// Dados gerados automaticamente - não editar
export const ZAMMAD_METRICS = {
  "filters": {
    "from_date": "2025-09-30"
  },
  "agents": {
    "Inês Martinho": {
      "overall": {
        "avg_time_hours": 133.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 620,
        "time_distribution": {
          "0-2h": 620,
          "2-4h": 211,
          "4-6h": 114,
          "6-8h": 65,
          "8-10h": 30,
          "10-12h": 44,
          "12-14h": 42,
          "14-16h": 48,
          "16-18h": 39,
          "18-20h": 45,
          "20-22h": 32,
          "22-24h": 37,
          "24-26h": 32,
          "26-28h": 18,
          "28-30h": 9,
          "30-32h": 5,
          "32-34h": 14,
          "34-36h": 10,
          "36-38h": 5,
          "38-40h": 8,
          "40-42h": 11,
          "42-44h": 11,
          "44-46h": 10,
          "46-48h": 13,
          "48-50h": 9,
          "50-52h": 13,
          "52-54h": 6,
          "54-56h": 7,
          "56-58h": 3,
          "58-60h": 3,
          "60-62h": 4,
          "62-64h": 7,
          "64-66h": 14,
          "66-68h": 8,
          "68-70h": 3,
          "70-72h": 9,
          "72-74h": 12,
          "74-76h": 7,
          "76-78h": 4,
          "78-80h": 2,
          "84-86h": 4,
          "86-88h": 4,
          "88-90h": 8,
          "90-92h": 3,
          "92-94h": 4,
          "94-96h": 4,
          "96-98h": 7,
          "98-100h": 3,
          "100-102h": 3,
          "102-104h": 2,
          "104-106h": 1,
          "106-108h": 1,
          "108-110h": 2,
          "110-112h": 1,
          "112-114h": 2,
          "114-116h": 5,
          "116-118h": 4,
          "118-120h": 5,
          "120-122h": 4,
          "122-124h": 4,
          "124-126h": 5,
          "128-130h": 4,
          "130-132h": 1,
          "132-134h": 8,
          "134-136h": 1,
          "136-138h": 2,
          "138-140h": 10,
          "140-142h": 10,
          "142-144h": 2,
          "144-146h": 6,
          "146-148h": 2,
          "148-150h": 4,
          "150-152h": 2,
          "152-154h": 2,
          "154-156h": 1,
          "156-158h": 2,
          "158-160h": 2,
          "160-162h": 6,
          "162-164h": 6,
          "164-166h": 4,
          "166-168h": 4,
          "168-170h": 3,
          "170-172h": 2,
          "172-174h": 2,
          "178-180h": 1,
          "180-182h": 1,
          "184-186h": 2,
          "186-188h": 2,
          "188-190h": 1,
          "190-192h": 7,
          "192-194h": 3,
          "194-196h": 2,
          "196-198h": 1,
          "198-200h": 2,
          "200-202h": 2,
          "202-204h": 1,
          "204-206h": 1,
          "210-212h": 3,
          "212-214h": 1,
          "214-216h": 1,
          "216-218h": 2,
          "218-220h": 3,
          "220-222h": 2,
          "222-224h": 2,
          "224-226h": 1,
          "230-232h": 2,
          "232-234h": 1,
          "234-236h": 4,
          "236-238h": 3,
          "238-240h": 4,
          "240-242h": 3,
          "242-244h": 1,
          "244-246h": 1,
          "246-248h": 1,
          "250-252h": 1,
          "252-254h": 1,
          "256-258h": 1,
          "258-260h": 1,
          "260-262h": 3,
          "262-264h": 2,
          "266-268h": 2,
          "268-270h": 3,
          "270-272h": 1,
          "272-274h": 1,
          "278-280h": 1,
          "280-282h": 3,
          "282-284h": 1,
          "284-286h": 1,
          "286-288h": 4,
          "288-290h": 1,
          "290-292h": 1,
          "292-294h": 3,
          "294-296h": 1,
          "296-298h": 1,
          "298-300h": 1,
          "302-304h": 1,
          "304-306h": 1,
          "306-308h": 4,
          "308-310h": 2,
          "310-312h": 3,
          "312-314h": 1,
          "314-316h": 1,
          "316-318h": 4,
          "320-322h": 2,
          "328-330h": 1,
          "330-332h": 3,
          "332-334h": 6,
          "334-336h": 1,
          "336-338h": 2,
          "338-340h": 2,
          "340-342h": 3,
          "342-344h": 1,
          "344-346h": 1,
          "356-358h": 2,
          "358-360h": 4,
          "360-362h": 3,
          "362-364h": 4,
          "364-366h": 1,
          "366-368h": 5,
          "368-370h": 4,
          "372-374h": 1,
          "376-378h": 2,
          "378-380h": 1,
          "380-382h": 3,
          "382-384h": 1,
          "386-388h": 1,
          "388-390h": 2,
          "398-400h": 1,
          "400-402h": 2,
          "402-404h": 1,
          "404-406h": 1,
          "406-408h": 3,
          "408-410h": 1,
          "410-412h": 1,
          "412-414h": 1,
          "414-416h": 2,
          "424-426h": 3,
          "426-428h": 1,
          "434-436h": 1,
          "436-438h": 2,
          "438-440h": 3,
          "442-444h": 1,
          "444-446h": 1,
          "446-448h": 1,
          "454-456h": 3,
          "456-458h": 1,
          "460-462h": 1,
          "468-470h": 1,
          "470-472h": 1,
          "472-474h": 1,
          "478-480h": 1,
          "480-482h": 1,
          "482-484h": 3,
          "494-496h": 1,
          "496-498h": 4,
          "498-500h": 1,
          "500-502h": 3,
          "506-508h": 1,
          "508-510h": 1,
          "512-514h": 1,
          "514-516h": 1,
          "518-520h": 2,
          "524-526h": 7,
          "526-528h": 3,
          "532-534h": 2,
          "534-536h": 1,
          "536-538h": 1,
          "548-550h": 4,
          "550-552h": 1,
          "554-556h": 1,
          "556-558h": 1,
          "560-562h": 1,
          "572-574h": 2,
          "574-576h": 1,
          "576-578h": 1,
          "592-594h": 1,
          "600-602h": 2,
          "614-616h": 1,
          "618-620h": 1,
          "624-626h": 1,
          "628-630h": 1,
          "642-644h": 1,
          "650-652h": 1,
          "656-658h": 1,
          "658-660h": 1,
          "660-662h": 1,
          "666-668h": 2,
          "668-670h": 2,
          "670-672h": 1,
          "672-674h": 1,
          "678-680h": 1,
          "680-682h": 2,
          "694-696h": 1,
          "700-702h": 2,
          "704-706h": 1,
          "720-722h": 1,
          "722-724h": 1,
          "724-726h": 1,
          "734-736h": 1,
          "736-738h": 1,
          "738-740h": 1,
          "742-744h": 1,
          "744-746h": 1,
          "746-748h": 1,
          "748-750h": 1,
          "758-760h": 1,
          "766-768h": 1,
          "772-774h": 1,
          "786-788h": 1,
          "792-794h": 1,
          "808-810h": 1,
          "810-812h": 1,
          "814-816h": 1,
          "820-822h": 4,
          "838-840h": 1,
          "840-842h": 2,
          "842-844h": 4,
          "860-862h": 2,
          "862-864h": 1,
          "866-868h": 1,
          "870-872h": 1,
          "890-892h": 2,
          "892-894h": 2,
          "902-904h": 2,
          "934-936h": 1,
          "984-986h": 2,
          "1000-1002h": 3,
          "1012-1014h": 1,
          "1024-1026h": 1,
          "1038-1040h": 1,
          "1050-1052h": 1,
          "1052-1054h": 1,
          "1054-1056h": 1,
          "1058-1060h": 1,
          "1060-1062h": 1,
          "1070-1072h": 1,
          "1076-1078h": 1,
          "1078-1080h": 1,
          "1100-1102h": 1,
          "1104-1106h": 1,
          "1122-1124h": 1,
          "1124-1126h": 1,
          "1142-1144h": 1,
          "1152-1154h": 1,
          "1166-1168h": 1,
          "1174-1176h": 1,
          "1176-1178h": 1,
          "1178-1180h": 2,
          "1196-1198h": 1,
          "1198-1200h": 1,
          "1200-1202h": 1,
          "1216-1218h": 1,
          "1238-1240h": 1,
          "1242-1244h": 2,
          "1244-1246h": 1,
          "1248-1250h": 2,
          "1250-1252h": 1,
          "1314-1316h": 1,
          "1316-1318h": 1,
          "1320-1322h": 1,
          "1338-1340h": 1,
          "1340-1342h": 1,
          "1360-1362h": 1,
          "1362-1364h": 2,
          "1390-1392h": 1,
          "1416-1418h": 1,
          "1454-1456h": 1,
          "1460-1462h": 1,
          "1482-1484h": 1,
          "1506-1508h": 2,
          "1514-1516h": 1,
          "1532-1534h": 2,
          "1546-1548h": 1,
          "1562-1564h": 1,
          "1584-1586h": 1,
          "1620-1622h": 1,
          "1622-1624h": 1,
          "1728-1730h": 1,
          "1752-1754h": 1,
          "1770-1772h": 1,
          "1778-1780h": 1,
          "1844-1846h": 1,
          "1872-1874h": 1,
          "2016-2018h": 1,
          "2032-2034h": 1,
          "2158-2160h": 1,
          "2212-2214h": 1,
          "3002-3004h": 3,
          "3554-3556h": 1
        },
        "tickets_count": 2192,
        "tickets_per_day": {
          "2025-09-30": 10,
          "2025-10-01": 3,
          "2025-10-02": 2,
          "2025-10-03": 1,
          "2025-10-06": 2,
          "2025-10-07": 8,
          "2025-10-08": 9,
          "2025-10-09": 7,
          "2025-10-10": 7,
          "2025-10-13": 1,
          "2025-10-14": 2,
          "2025-10-15": 6,
          "2025-10-16": 1,
          "2025-10-17": 3,
          "2025-10-20": 3,
          "2025-10-21": 7,
          "2025-10-22": 9,
          "2025-10-23": 6,
          "2025-10-24": 8,
          "2025-10-25": 1,
          "2025-10-27": 6,
          "2025-10-28": 17,
          "2025-10-29": 1,
          "2025-10-30": 6,
          "2025-10-31": 3,
          "2025-11-03": 14,
          "2025-11-04": 3,
          "2025-11-05": 9,
          "2025-11-06": 14,
          "2025-11-07": 5,
          "2025-11-08": 2,
          "2025-11-09": 1,
          "2025-11-10": 5,
          "2025-11-11": 3,
          "2025-11-12": 6,
          "2025-11-13": 10,
          "2025-11-14": 16,
          "2025-11-16": 1,
          "2025-11-18": 14,
          "2025-11-19": 20,
          "2025-11-20": 3,
          "2025-11-21": 12,
          "2025-11-24": 18,
          "2025-11-25": 14,
          "2025-11-26": 9,
          "2025-11-27": 10,
          "2025-11-28": 19,
          "2025-11-29": 3,
          "2025-12-02": 14,
          "2025-12-03": 10,
          "2025-12-04": 11,
          "2025-12-05": 12,
          "2025-12-09": 8,
          "2025-12-10": 10,
          "2025-12-11": 8,
          "2025-12-12": 18,
          "2025-12-13": 1,
          "2025-12-15": 16,
          "2025-12-16": 10,
          "2025-12-18": 2,
          "2025-12-22": 7,
          "2025-12-26": 3,
          "2025-12-29": 3,
          "2025-12-30": 2,
          "2025-12-31": 2,
          "2026-01-02": 10,
          "2026-01-05": 4,
          "2026-01-06": 2,
          "2026-01-07": 21,
          "2026-01-08": 7,
          "2026-01-09": 9,
          "2026-01-12": 3,
          "2026-01-13": 20,
          "2026-01-14": 7,
          "2026-01-15": 30,
          "2026-01-16": 18,
          "2026-01-17": 2,
          "2026-01-18": 8,
          "2026-01-19": 12,
          "2026-01-20": 8,
          "2026-01-21": 3,
          "2026-01-22": 1,
          "2026-01-23": 9,
          "2026-01-26": 8,
          "2026-01-27": 9,
          "2026-01-28": 4,
          "2026-01-29": 14,
          "2026-01-30": 24,
          "2026-02-02": 4,
          "2026-02-03": 40,
          "2026-02-04": 22,
          "2026-02-05": 4,
          "2026-02-06": 6,
          "2026-02-07": 2,
          "2026-02-09": 15,
          "2026-02-10": 35,
          "2026-02-11": 1,
          "2026-02-13": 1,
          "2026-02-16": 12,
          "2026-02-17": 23,
          "2026-02-18": 28,
          "2026-02-19": 17,
          "2026-02-20": 22,
          "2026-02-23": 22,
          "2026-02-24": 24,
          "2026-02-25": 23,
          "2026-02-26": 11,
          "2026-02-27": 14,
          "2026-02-28": 14,
          "2026-03-02": 19,
          "2026-03-03": 10,
          "2026-03-04": 31,
          "2026-03-05": 9,
          "2026-03-06": 19,
          "2026-03-07": 11,
          "2026-03-09": 10,
          "2026-03-10": 32,
          "2026-03-11": 7,
          "2026-03-12": 8,
          "2026-03-13": 9,
          "2026-03-15": 1,
          "2026-03-16": 19,
          "2026-03-17": 14,
          "2026-03-18": 34,
          "2026-03-19": 25,
          "2026-03-20": 39,
          "2026-03-23": 17,
          "2026-03-24": 17,
          "2026-03-25": 19,
          "2026-03-26": 11,
          "2026-03-27": 9,
          "2026-03-30": 13,
          "2026-03-31": 11,
          "2026-04-01": 16,
          "2026-04-02": 7,
          "2026-04-04": 1,
          "2026-04-06": 14,
          "2026-04-07": 20,
          "2026-04-08": 11,
          "2026-04-09": 10,
          "2026-04-10": 14,
          "2026-04-13": 30,
          "2026-04-14": 15,
          "2026-04-15": 24,
          "2026-04-16": 9,
          "2026-04-17": 17,
          "2026-04-20": 20,
          "2026-04-21": 8,
          "2026-04-22": 38,
          "2026-04-23": 36,
          "2026-04-24": 9,
          "2026-04-27": 26,
          "2026-04-28": 5,
          "2026-04-29": 17,
          "2026-04-30": 18,
          "2026-05-02": 2,
          "2026-05-04": 28,
          "2026-05-05": 11,
          "2026-05-06": 23,
          "2026-05-07": 10,
          "2026-05-08": 12,
          "2026-05-11": 8,
          "2026-05-12": 2,
          "2026-05-13": 21,
          "2026-05-14": 16,
          "2026-05-15": 14,
          "2026-05-16": 2,
          "2026-05-17": 1,
          "2026-05-18": 9,
          "2026-05-19": 10,
          "2026-05-20": 3,
          "2026-05-21": 13,
          "2026-05-22": 5,
          "2026-05-25": 5,
          "2026-05-26": 37,
          "2026-05-27": 25,
          "2026-05-28": 13,
          "2026-05-29": 2,
          "2026-06-01": 13,
          "2026-06-02": 21,
          "2026-06-03": 33,
          "2026-06-04": 1,
          "2026-06-05": 27,
          "2026-06-06": 3,
          "2026-06-08": 13
        },
        "time_per_day": {
          "2025-09-30": 14.75557861111111,
          "2025-10-01": 35.063807777777775,
          "2025-10-02": 20.05792861111111,
          "2025-10-03": 42.59790194444444,
          "2025-10-06": 94.90649833333332,
          "2025-10-07": 258.2252325,
          "2025-10-08": 50.83782111111112,
          "2025-10-09": 722.5472166666667,
          "2025-10-10": 432.6903519444444,
          "2025-10-13": 123.30291527777777,
          "2025-10-14": 470.5076261111111,
          "2025-10-15": 535.6696891666668,
          "2025-10-16": 20.367943333333336,
          "2025-10-17": 266.111235,
          "2025-10-20": 276.3484025,
          "2025-10-21": 731.0230075000001,
          "2025-10-22": 683.1636255555557,
          "2025-10-23": 543.7726233333333,
          "2025-10-24": 523.9427497222223,
          "2025-10-25": 256.24249305555554,
          "2025-10-27": 248.62698916666665,
          "2025-10-28": 1324.2816108333334,
          "2025-10-29": 1.4241794444444444,
          "2025-10-30": 202.7000863888889,
          "2025-10-31": 345.1623177777778,
          "2025-11-03": 826.3047222222223,
          "2025-11-04": 9.118137777777779,
          "2025-11-05": 900.6651666666667,
          "2025-11-06": 723.7876830555554,
          "2025-11-07": 506.6936205555556,
          "2025-11-08": 17.88305638888889,
          "2025-11-09": 41.51824638888889,
          "2025-11-10": 8.248972777777778,
          "2025-11-11": 25.237366111111115,
          "2025-11-12": 80.67927166666666,
          "2025-11-13": 1108.9715466666667,
          "2025-11-14": 1241.4247350000003,
          "2025-11-16": 253.38371305555555,
          "2025-11-18": 2488.658121666666,
          "2025-11-19": 2622.143905,
          "2025-11-20": 52.00544555555555,
          "2025-11-21": 643.4860455555554,
          "2025-11-24": 608.359658611111,
          "2025-11-25": 18.301033888888888,
          "2025-11-26": 2036.7790352777781,
          "2025-11-27": 1405.528240833333,
          "2025-11-28": 1057.3816080555555,
          "2025-11-29": 276.01111833333334,
          "2025-12-02": 864.5222005555556,
          "2025-12-03": 241.8261013888889,
          "2025-12-04": 487.83310083333345,
          "2025-12-05": 957.52056,
          "2025-12-09": 562.0933869444444,
          "2025-12-10": 1236.8228911111114,
          "2025-12-11": 1862.548443888889,
          "2025-12-12": 4385.003239166666,
          "2025-12-13": 27.688504444444444,
          "2025-12-15": 1744.937110277778,
          "2025-12-16": 2151.7340916666667,
          "2025-12-18": 10.837394166666666,
          "2025-12-22": 131.94296083333333,
          "2025-12-26": 10.105572222222222,
          "2025-12-29": 455.474,
          "2025-12-30": 1.3789041666666666,
          "2025-12-31": 1.5147458333333335,
          "2026-01-02": 3130.859666111111,
          "2026-01-05": 208.64132944444444,
          "2026-01-06": 31.783673055555553,
          "2026-01-07": 5638.298132500001,
          "2026-01-08": 937.6500144444444,
          "2026-01-09": 1614.506458888889,
          "2026-01-12": 228.41339722222224,
          "2026-01-13": 189.09393277777772,
          "2026-01-14": 42.22353833333333,
          "2026-01-15": 2285.4464883333335,
          "2026-01-16": 52.0658711111111,
          "2026-01-17": 189.38207444444444,
          "2026-01-18": 107.7343877777778,
          "2026-01-19": 479.12081444444453,
          "2026-01-20": 378.7890788888888,
          "2026-01-21": 309.3017127777778,
          "2026-01-22": 4.0281633333333335,
          "2026-01-23": 54.38232972222222,
          "2026-01-26": 192.12398222222222,
          "2026-01-27": 28.45615277777778,
          "2026-01-28": 20.657380277777776,
          "2026-01-29": 370.13796083333335,
          "2026-01-30": 855.340910277778,
          "2026-02-02": 148.38566111111115,
          "2026-02-03": 13709.93116444444,
          "2026-02-04": 1825.3787780555556,
          "2026-02-05": 698.5364166666667,
          "2026-02-06": 468.13839055555553,
          "2026-02-07": 122.51177861111111,
          "2026-02-09": 617.1009725000002,
          "2026-02-10": 15923.06294583334,
          "2026-02-11": 3.433265833333333,
          "2026-02-13": 758.5593352777778,
          "2026-02-16": 860.5135158333333,
          "2026-02-17": 9255.647648888887,
          "2026-02-18": 4247.09266722222,
          "2026-02-19": 3433.361839166667,
          "2026-02-20": 2208.953481111111,
          "2026-02-23": 1591.6274427777778,
          "2026-02-24": 84.18941666666663,
          "2026-02-25": 221.04098249999993,
          "2026-02-26": 74.26577666666668,
          "2026-02-27": 228.70575305555553,
          "2026-02-28": 88.52218527777778,
          "2026-03-02": 2042.5583180555554,
          "2026-03-03": 949.6753086111112,
          "2026-03-04": 482.5548694444445,
          "2026-03-05": 244.39238250000002,
          "2026-03-06": 495.28298222222213,
          "2026-03-07": 392.5282105555556,
          "2026-03-09": 32.66441722222222,
          "2026-03-10": 3786.065865,
          "2026-03-11": 109.64254388888888,
          "2026-03-12": 1453.130307222222,
          "2026-03-13": 94.22477083333337,
          "2026-03-15": 39.66556027777778,
          "2026-03-16": 899.9265066666668,
          "2026-03-17": 2152.0867377777777,
          "2026-03-18": 2258.673289444445,
          "2026-03-19": 916.4283263888888,
          "2026-03-20": 18265.526158888893,
          "2026-03-23": 829.8522761111111,
          "2026-03-24": 812.3060675,
          "2026-03-25": 2465.602445,
          "2026-03-26": 1817.320341388889,
          "2026-03-27": 73.76737333333334,
          "2026-03-30": 2352.9256530555554,
          "2026-03-31": 249.3140122222222,
          "2026-04-01": 770.7209130555555,
          "2026-04-02": 52.165303333333334,
          "2026-04-06": 416.7104766666667,
          "2026-04-07": 2342.2446241666667,
          "2026-04-08": 724.7797691666666,
          "2026-04-09": 705.3525777777777,
          "2026-04-10": 593.0516361111112,
          "2026-04-13": 3316.809195833332,
          "2026-04-14": 1403.9237727777777,
          "2026-04-15": 383.5829894444445,
          "2026-04-16": 206.7344427777778,
          "2026-04-17": 1258.4747916666665,
          "2026-04-20": 584.7715150000002,
          "2026-04-21": 128.34479305555556,
          "2026-04-22": 33229.475340277786,
          "2026-04-23": 30077.611573888888,
          "2026-04-24": 113.14097361111111,
          "2026-04-27": 836.9738355555556,
          "2026-04-28": 1607.3620036111108,
          "2026-04-29": 935.2631283333334,
          "2026-04-30": 3966.025183888889,
          "2026-05-02": 64.25406,
          "2026-05-04": 16414.42048472222,
          "2026-05-05": 33.7320225,
          "2026-05-06": 202.56242333333333,
          "2026-05-07": 51.269512500000005,
          "2026-05-08": 3442.991360555555,
          "2026-05-11": 144.0852372222222,
          "2026-05-12": 4.769479444444444,
          "2026-05-13": 357.8979591666667,
          "2026-05-14": 438.46230277777784,
          "2026-05-15": 300.18684722222224,
          "2026-05-16": 29.643955833333333,
          "2026-05-17": 192.58819499999998,
          "2026-05-18": 1704.6458044444444,
          "2026-05-19": 2244.0721127777774,
          "2026-05-20": 26.551808333333334,
          "2026-05-21": 198.1007383333333,
          "2026-05-22": 310.86982611111114,
          "2026-05-25": 190.19837166666665,
          "2026-05-26": 9017.187278055553,
          "2026-05-27": 240.18481972222224,
          "2026-05-28": 3490.2167358333336,
          "2026-05-29": 76.32945805555555,
          "2026-06-01": 523.6617536111111,
          "2026-06-02": 349.96520833333335,
          "2026-06-03": 2316.1009125,
          "2026-06-05": 103.11260055555556,
          "2026-06-08": 513.5392377777778
        },
        "time_count_per_day": {
          "2025-09-30": 10,
          "2025-10-01": 3,
          "2025-10-02": 2,
          "2025-10-03": 1,
          "2025-10-06": 2,
          "2025-10-07": 8,
          "2025-10-08": 9,
          "2025-10-09": 7,
          "2025-10-10": 7,
          "2025-10-13": 1,
          "2025-10-14": 2,
          "2025-10-15": 6,
          "2025-10-16": 1,
          "2025-10-17": 3,
          "2025-10-20": 3,
          "2025-10-21": 7,
          "2025-10-22": 9,
          "2025-10-23": 6,
          "2025-10-24": 8,
          "2025-10-25": 1,
          "2025-10-27": 6,
          "2025-10-28": 17,
          "2025-10-29": 1,
          "2025-10-30": 6,
          "2025-10-31": 3,
          "2025-11-03": 14,
          "2025-11-04": 3,
          "2025-11-05": 9,
          "2025-11-06": 14,
          "2025-11-07": 5,
          "2025-11-08": 2,
          "2025-11-09": 1,
          "2025-11-10": 5,
          "2025-11-11": 3,
          "2025-11-12": 6,
          "2025-11-13": 10,
          "2025-11-14": 16,
          "2025-11-16": 1,
          "2025-11-18": 14,
          "2025-11-19": 20,
          "2025-11-20": 3,
          "2025-11-21": 12,
          "2025-11-24": 18,
          "2025-11-25": 14,
          "2025-11-26": 9,
          "2025-11-27": 10,
          "2025-11-28": 18,
          "2025-11-29": 3,
          "2025-12-02": 14,
          "2025-12-03": 10,
          "2025-12-04": 11,
          "2025-12-05": 12,
          "2025-12-09": 8,
          "2025-12-10": 10,
          "2025-12-11": 8,
          "2025-12-12": 17,
          "2025-12-13": 1,
          "2025-12-15": 16,
          "2025-12-16": 10,
          "2025-12-18": 2,
          "2025-12-22": 6,
          "2025-12-26": 3,
          "2025-12-29": 2,
          "2025-12-30": 2,
          "2025-12-31": 2,
          "2026-01-02": 9,
          "2026-01-05": 4,
          "2026-01-06": 2,
          "2026-01-07": 21,
          "2026-01-08": 6,
          "2026-01-09": 9,
          "2026-01-12": 3,
          "2026-01-13": 20,
          "2026-01-14": 7,
          "2026-01-15": 30,
          "2026-01-16": 18,
          "2026-01-17": 2,
          "2026-01-18": 8,
          "2026-01-19": 12,
          "2026-01-20": 8,
          "2026-01-21": 3,
          "2026-01-22": 1,
          "2026-01-23": 9,
          "2026-01-26": 8,
          "2026-01-27": 9,
          "2026-01-28": 4,
          "2026-01-29": 14,
          "2026-01-30": 24,
          "2026-02-02": 4,
          "2026-02-03": 40,
          "2026-02-04": 22,
          "2026-02-05": 4,
          "2026-02-06": 6,
          "2026-02-07": 2,
          "2026-02-09": 15,
          "2026-02-10": 35,
          "2026-02-11": 1,
          "2026-02-13": 1,
          "2026-02-16": 12,
          "2026-02-17": 22,
          "2026-02-18": 28,
          "2026-02-19": 17,
          "2026-02-20": 22,
          "2026-02-23": 22,
          "2026-02-24": 23,
          "2026-02-25": 22,
          "2026-02-26": 11,
          "2026-02-27": 13,
          "2026-02-28": 14,
          "2026-03-02": 18,
          "2026-03-03": 10,
          "2026-03-04": 31,
          "2026-03-05": 9,
          "2026-03-06": 19,
          "2026-03-07": 11,
          "2026-03-09": 10,
          "2026-03-10": 32,
          "2026-03-11": 7,
          "2026-03-12": 8,
          "2026-03-13": 7,
          "2026-03-15": 1,
          "2026-03-16": 18,
          "2026-03-17": 14,
          "2026-03-18": 33,
          "2026-03-19": 25,
          "2026-03-20": 38,
          "2026-03-23": 17,
          "2026-03-24": 17,
          "2026-03-25": 19,
          "2026-03-26": 11,
          "2026-03-27": 9,
          "2026-03-30": 12,
          "2026-03-31": 11,
          "2026-04-01": 16,
          "2026-04-02": 7,
          "2026-04-06": 14,
          "2026-04-07": 20,
          "2026-04-08": 11,
          "2026-04-09": 10,
          "2026-04-10": 14,
          "2026-04-13": 30,
          "2026-04-14": 15,
          "2026-04-15": 23,
          "2026-04-16": 9,
          "2026-04-17": 16,
          "2026-04-20": 20,
          "2026-04-21": 8,
          "2026-04-22": 38,
          "2026-04-23": 36,
          "2026-04-24": 8,
          "2026-04-27": 26,
          "2026-04-28": 5,
          "2026-04-29": 17,
          "2026-04-30": 17,
          "2026-05-02": 1,
          "2026-05-04": 28,
          "2026-05-05": 11,
          "2026-05-06": 22,
          "2026-05-07": 10,
          "2026-05-08": 12,
          "2026-05-11": 8,
          "2026-05-12": 2,
          "2026-05-13": 20,
          "2026-05-14": 16,
          "2026-05-15": 14,
          "2026-05-16": 1,
          "2026-05-17": 1,
          "2026-05-18": 9,
          "2026-05-19": 10,
          "2026-05-20": 3,
          "2026-05-21": 10,
          "2026-05-22": 5,
          "2026-05-25": 5,
          "2026-05-26": 36,
          "2026-05-27": 23,
          "2026-05-28": 13,
          "2026-05-29": 1,
          "2026-06-01": 8,
          "2026-06-02": 18,
          "2026-06-03": 32,
          "2026-06-05": 20,
          "2026-06-08": 9
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 62.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 29,
          "time_distribution": {
            "0-2h": 29,
            "2-4h": 11,
            "4-6h": 7,
            "6-8h": 6,
            "10-12h": 6,
            "12-14h": 3,
            "14-16h": 9,
            "16-18h": 1,
            "18-20h": 2,
            "20-22h": 4,
            "22-24h": 2,
            "24-26h": 3,
            "26-28h": 2,
            "34-36h": 2,
            "36-38h": 2,
            "40-42h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "58-60h": 1,
            "62-64h": 1,
            "72-74h": 1,
            "92-94h": 1,
            "118-120h": 1,
            "122-124h": 1,
            "132-134h": 1,
            "148-150h": 1,
            "156-158h": 1,
            "162-164h": 2,
            "170-172h": 1,
            "234-236h": 1,
            "240-242h": 1,
            "306-308h": 1,
            "310-312h": 1,
            "344-346h": 1,
            "406-408h": 1,
            "434-436h": 1,
            "468-470h": 1,
            "650-652h": 1,
            "1242-1244h": 1
          },
          "tickets_count": 121,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-08": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-22": 3,
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-07": 1,
            "2025-11-08": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-03": 2,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-26": 1,
            "2026-01-08": 2,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-03-04": 3,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-26": 1,
            "2026-04-01": 2,
            "2026-04-06": 4,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-13": 2,
            "2026-04-14": 5,
            "2026-04-15": 5,
            "2026-04-16": 1,
            "2026-04-20": 3,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-04-30": 2,
            "2026-05-05": 3,
            "2026-05-06": 4,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-22": 2,
            "2026-05-25": 1,
            "2026-05-26": 6,
            "2026-05-27": 4,
            "2026-05-28": 1,
            "2026-06-01": 2,
            "2026-06-02": 2,
            "2026-06-03": 1,
            "2026-06-04": 1,
            "2026-06-05": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-09-30": 9.050675833333333,
            "2025-10-08": 14.909877222222221,
            "2025-10-10": 93.55738805555556,
            "2025-10-13": 123.30291527777777,
            "2025-10-22": 187.1280436111111,
            "2025-10-23": 59.432022499999995,
            "2025-10-27": 2.995404166666667,
            "2025-10-28": 20.40406861111111,
            "2025-11-04": 5.338383333333334,
            "2025-11-05": 25.560861111111112,
            "2025-11-07": 1.8481505555555555,
            "2025-11-08": 15.103649444444445,
            "2025-11-13": 469.4926302777778,
            "2025-11-14": 0.7499077777777778,
            "2025-11-24": 20.35652,
            "2025-11-27": 0.43700944444444445,
            "2025-12-03": 6.9707825,
            "2025-12-04": 1.669495,
            "2025-12-10": 23.88116861111111,
            "2025-12-12": 24.35603,
            "2025-12-26": 1.3623505555555557,
            "2026-01-08": 893.0433697222222,
            "2026-01-29": 23.1520225,
            "2026-02-03": 311.45288416666665,
            "2026-02-10": 119.56869527777778,
            "2026-02-20": 0.86444,
            "2026-02-27": 27.363500277777778,
            "2026-03-04": 21.693607500000002,
            "2026-03-06": 0.9276636111111111,
            "2026-03-09": 2.353734444444444,
            "2026-03-13": 37.823973888888894,
            "2026-03-16": 3.6321480555555556,
            "2026-03-17": 0.22554249999999998,
            "2026-03-18": 864.4903172222222,
            "2026-03-19": 19.21465611111111,
            "2026-03-20": 360.53000305555554,
            "2026-03-26": 7.627271111111111,
            "2026-04-01": 28.515480555555555,
            "2026-04-06": 94.90337222222222,
            "2026-04-07": 1.3544436111111111,
            "2026-04-08": 171.0420797222222,
            "2026-04-09": 2.7493611111111114,
            "2026-04-13": 2.2019641666666665,
            "2026-04-14": 190.98087055555555,
            "2026-04-15": 24.017150833333332,
            "2026-04-16": 0.6490197222222223,
            "2026-04-20": 44.220904166666664,
            "2026-04-23": 1243.0557030555556,
            "2026-04-24": 3.464617777777778,
            "2026-04-27": 66.44613194444446,
            "2026-04-29": 157.87616500000001,
            "2026-04-30": 3.4188672222222225,
            "2026-05-05": 22.083684166666664,
            "2026-05-06": 89.00785833333333,
            "2026-05-13": 2.7293938888888887,
            "2026-05-14": 4.965616111111111,
            "2026-05-18": 435.8702533333333,
            "2026-05-21": 35.05991527777778,
            "2026-05-22": 257.0750963888889,
            "2026-05-25": 73.19298916666666,
            "2026-05-26": 229.69563833333328,
            "2026-05-27": 76.33453944444446,
            "2026-05-28": 7.195656111111111,
            "2026-06-01": 12.3827125,
            "2026-06-02": 31.642096388888888,
            "2026-06-03": 24.57738666666667
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-08": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-22": 3,
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-07": 1,
            "2025-11-08": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-03": 2,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-26": 1,
            "2026-01-08": 2,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-03-04": 3,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-26": 1,
            "2026-04-01": 2,
            "2026-04-06": 4,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-13": 2,
            "2026-04-14": 5,
            "2026-04-15": 5,
            "2026-04-16": 1,
            "2026-04-20": 3,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-05": 3,
            "2026-05-06": 4,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-22": 2,
            "2026-05-25": 1,
            "2026-05-26": 6,
            "2026-05-27": 4,
            "2026-05-28": 1,
            "2026-06-01": 2,
            "2026-06-02": 2,
            "2026-06-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 121.23,
          "mode_time_hours": 1.0,
          "mode_frequency": 515,
          "time_distribution": {
            "0-2h": 515,
            "2-4h": 166,
            "4-6h": 78,
            "6-8h": 52,
            "8-10h": 20,
            "10-12h": 35,
            "12-14h": 28,
            "14-16h": 32,
            "16-18h": 35,
            "18-20h": 34,
            "20-22h": 21,
            "22-24h": 30,
            "24-26h": 20,
            "26-28h": 12,
            "28-30h": 8,
            "30-32h": 5,
            "32-34h": 13,
            "34-36h": 7,
            "36-38h": 3,
            "38-40h": 8,
            "40-42h": 8,
            "42-44h": 6,
            "44-46h": 10,
            "46-48h": 8,
            "48-50h": 7,
            "50-52h": 12,
            "52-54h": 4,
            "54-56h": 5,
            "56-58h": 3,
            "58-60h": 2,
            "60-62h": 2,
            "62-64h": 6,
            "64-66h": 11,
            "66-68h": 6,
            "68-70h": 3,
            "70-72h": 7,
            "72-74h": 9,
            "74-76h": 5,
            "76-78h": 2,
            "84-86h": 3,
            "86-88h": 4,
            "88-90h": 8,
            "90-92h": 2,
            "92-94h": 2,
            "94-96h": 2,
            "96-98h": 3,
            "98-100h": 2,
            "100-102h": 2,
            "102-104h": 1,
            "106-108h": 1,
            "108-110h": 1,
            "112-114h": 1,
            "114-116h": 4,
            "116-118h": 3,
            "118-120h": 1,
            "120-122h": 3,
            "122-124h": 1,
            "124-126h": 3,
            "128-130h": 1,
            "130-132h": 1,
            "134-136h": 1,
            "138-140h": 7,
            "140-142h": 2,
            "142-144h": 1,
            "144-146h": 3,
            "146-148h": 1,
            "148-150h": 1,
            "152-154h": 1,
            "154-156h": 1,
            "156-158h": 1,
            "158-160h": 1,
            "160-162h": 4,
            "162-164h": 4,
            "164-166h": 3,
            "166-168h": 1,
            "168-170h": 1,
            "180-182h": 1,
            "184-186h": 1,
            "188-190h": 1,
            "190-192h": 4,
            "192-194h": 3,
            "198-200h": 1,
            "200-202h": 2,
            "202-204h": 1,
            "204-206h": 1,
            "210-212h": 2,
            "212-214h": 1,
            "216-218h": 1,
            "220-222h": 1,
            "222-224h": 2,
            "234-236h": 2,
            "236-238h": 1,
            "238-240h": 3,
            "240-242h": 2,
            "246-248h": 1,
            "250-252h": 1,
            "258-260h": 1,
            "260-262h": 2,
            "266-268h": 1,
            "268-270h": 3,
            "278-280h": 1,
            "280-282h": 2,
            "284-286h": 1,
            "286-288h": 4,
            "290-292h": 1,
            "292-294h": 2,
            "294-296h": 1,
            "296-298h": 1,
            "298-300h": 1,
            "302-304h": 1,
            "306-308h": 3,
            "310-312h": 2,
            "312-314h": 1,
            "316-318h": 3,
            "320-322h": 1,
            "330-332h": 2,
            "332-334h": 6,
            "334-336h": 1,
            "336-338h": 1,
            "340-342h": 2,
            "342-344h": 1,
            "356-358h": 1,
            "358-360h": 2,
            "360-362h": 1,
            "362-364h": 2,
            "366-368h": 2,
            "368-370h": 2,
            "372-374h": 1,
            "376-378h": 1,
            "378-380h": 1,
            "380-382h": 1,
            "382-384h": 1,
            "388-390h": 1,
            "398-400h": 1,
            "400-402h": 2,
            "404-406h": 1,
            "406-408h": 2,
            "408-410h": 1,
            "414-416h": 1,
            "424-426h": 1,
            "426-428h": 1,
            "436-438h": 1,
            "444-446h": 1,
            "454-456h": 2,
            "456-458h": 1,
            "470-472h": 1,
            "482-484h": 2,
            "494-496h": 1,
            "496-498h": 4,
            "506-508h": 1,
            "508-510h": 1,
            "512-514h": 1,
            "518-520h": 2,
            "524-526h": 7,
            "526-528h": 2,
            "532-534h": 2,
            "548-550h": 1,
            "550-552h": 1,
            "554-556h": 1,
            "556-558h": 1,
            "560-562h": 1,
            "576-578h": 1,
            "592-594h": 1,
            "600-602h": 1,
            "624-626h": 1,
            "642-644h": 1,
            "656-658h": 1,
            "660-662h": 1,
            "666-668h": 2,
            "668-670h": 2,
            "672-674h": 1,
            "700-702h": 1,
            "704-706h": 1,
            "722-724h": 1,
            "724-726h": 1,
            "734-736h": 1,
            "738-740h": 1,
            "742-744h": 1,
            "744-746h": 1,
            "746-748h": 1,
            "748-750h": 1,
            "766-768h": 1,
            "772-774h": 1,
            "786-788h": 1,
            "792-794h": 1,
            "808-810h": 1,
            "810-812h": 1,
            "820-822h": 1,
            "838-840h": 1,
            "840-842h": 2,
            "842-844h": 3,
            "860-862h": 1,
            "862-864h": 1,
            "870-872h": 1,
            "890-892h": 2,
            "892-894h": 2,
            "934-936h": 1,
            "984-986h": 2,
            "1000-1002h": 3,
            "1012-1014h": 1,
            "1024-1026h": 1,
            "1038-1040h": 1,
            "1050-1052h": 1,
            "1052-1054h": 1,
            "1054-1056h": 1,
            "1058-1060h": 1,
            "1070-1072h": 1,
            "1076-1078h": 1,
            "1078-1080h": 1,
            "1100-1102h": 1,
            "1104-1106h": 1,
            "1122-1124h": 1,
            "1124-1126h": 1,
            "1142-1144h": 1,
            "1152-1154h": 1,
            "1166-1168h": 1,
            "1174-1176h": 1,
            "1176-1178h": 1,
            "1178-1180h": 1,
            "1196-1198h": 1,
            "1198-1200h": 1,
            "1200-1202h": 1,
            "1216-1218h": 1,
            "1242-1244h": 1,
            "1244-1246h": 1,
            "1248-1250h": 2,
            "1314-1316h": 1,
            "1316-1318h": 1,
            "1320-1322h": 1,
            "1338-1340h": 1,
            "1340-1342h": 1,
            "1360-1362h": 1,
            "1362-1364h": 1,
            "1416-1418h": 1,
            "1454-1456h": 1,
            "1460-1462h": 1,
            "1482-1484h": 1,
            "1506-1508h": 1,
            "1514-1516h": 1,
            "1532-1534h": 2,
            "1546-1548h": 1,
            "1562-1564h": 1,
            "1584-1586h": 1,
            "1620-1622h": 1,
            "1622-1624h": 1,
            "1728-1730h": 1,
            "1770-1772h": 1,
            "2158-2160h": 1,
            "3002-3004h": 3,
            "3554-3556h": 1
          },
          "tickets_count": 1610,
          "tickets_per_day": {
            "2025-09-30": 2,
            "2025-10-01": 3,
            "2025-10-02": 1,
            "2025-10-06": 1,
            "2025-10-07": 5,
            "2025-10-08": 1,
            "2025-10-09": 2,
            "2025-10-10": 3,
            "2025-10-15": 1,
            "2025-10-20": 3,
            "2025-10-21": 3,
            "2025-10-22": 6,
            "2025-10-23": 3,
            "2025-10-24": 3,
            "2025-10-27": 4,
            "2025-10-28": 13,
            "2025-10-29": 1,
            "2025-10-30": 5,
            "2025-10-31": 3,
            "2025-11-03": 4,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 4,
            "2025-11-08": 1,
            "2025-11-09": 1,
            "2025-11-10": 4,
            "2025-11-11": 1,
            "2025-11-12": 3,
            "2025-11-13": 5,
            "2025-11-14": 4,
            "2025-11-18": 4,
            "2025-11-19": 6,
            "2025-11-20": 1,
            "2025-11-21": 6,
            "2025-11-24": 12,
            "2025-11-25": 7,
            "2025-11-26": 6,
            "2025-11-27": 2,
            "2025-11-28": 13,
            "2025-12-02": 4,
            "2025-12-03": 4,
            "2025-12-04": 2,
            "2025-12-05": 1,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-12": 9,
            "2025-12-13": 1,
            "2025-12-15": 9,
            "2025-12-16": 5,
            "2025-12-22": 2,
            "2025-12-29": 2,
            "2025-12-30": 2,
            "2025-12-31": 2,
            "2026-01-02": 6,
            "2026-01-05": 3,
            "2026-01-06": 2,
            "2026-01-07": 16,
            "2026-01-08": 5,
            "2026-01-09": 7,
            "2026-01-12": 2,
            "2026-01-13": 5,
            "2026-01-14": 3,
            "2026-01-15": 23,
            "2026-01-16": 16,
            "2026-01-19": 9,
            "2026-01-20": 4,
            "2026-01-21": 3,
            "2026-01-23": 7,
            "2026-01-26": 3,
            "2026-01-27": 9,
            "2026-01-28": 1,
            "2026-01-29": 9,
            "2026-01-30": 22,
            "2026-02-02": 3,
            "2026-02-03": 13,
            "2026-02-04": 10,
            "2026-02-06": 4,
            "2026-02-09": 4,
            "2026-02-10": 20,
            "2026-02-11": 1,
            "2026-02-16": 10,
            "2026-02-17": 13,
            "2026-02-18": 24,
            "2026-02-19": 9,
            "2026-02-20": 18,
            "2026-02-23": 21,
            "2026-02-24": 19,
            "2026-02-25": 20,
            "2026-02-26": 11,
            "2026-02-27": 13,
            "2026-02-28": 13,
            "2026-03-02": 18,
            "2026-03-03": 10,
            "2026-03-04": 21,
            "2026-03-05": 9,
            "2026-03-06": 18,
            "2026-03-07": 10,
            "2026-03-09": 9,
            "2026-03-10": 31,
            "2026-03-11": 7,
            "2026-03-12": 7,
            "2026-03-13": 8,
            "2026-03-15": 1,
            "2026-03-16": 18,
            "2026-03-17": 12,
            "2026-03-18": 26,
            "2026-03-19": 24,
            "2026-03-20": 33,
            "2026-03-23": 17,
            "2026-03-24": 17,
            "2026-03-25": 19,
            "2026-03-26": 10,
            "2026-03-27": 9,
            "2026-03-30": 12,
            "2026-03-31": 11,
            "2026-04-01": 14,
            "2026-04-02": 7,
            "2026-04-04": 1,
            "2026-04-06": 10,
            "2026-04-07": 18,
            "2026-04-08": 10,
            "2026-04-09": 8,
            "2026-04-10": 13,
            "2026-04-13": 28,
            "2026-04-14": 10,
            "2026-04-15": 19,
            "2026-04-16": 8,
            "2026-04-17": 17,
            "2026-04-20": 16,
            "2026-04-21": 7,
            "2026-04-22": 37,
            "2026-04-23": 33,
            "2026-04-24": 8,
            "2026-04-27": 23,
            "2026-04-28": 5,
            "2026-04-29": 16,
            "2026-04-30": 16,
            "2026-05-02": 2,
            "2026-05-04": 26,
            "2026-05-05": 8,
            "2026-05-06": 19,
            "2026-05-07": 10,
            "2026-05-08": 12,
            "2026-05-11": 8,
            "2026-05-12": 2,
            "2026-05-13": 20,
            "2026-05-14": 15,
            "2026-05-15": 14,
            "2026-05-16": 2,
            "2026-05-17": 1,
            "2026-05-18": 8,
            "2026-05-19": 10,
            "2026-05-20": 3,
            "2026-05-21": 12,
            "2026-05-22": 3,
            "2026-05-25": 4,
            "2026-05-26": 31,
            "2026-05-27": 21,
            "2026-05-28": 12,
            "2026-05-29": 2,
            "2026-06-01": 11,
            "2026-06-02": 19,
            "2026-06-03": 32,
            "2026-06-05": 26,
            "2026-06-06": 3,
            "2026-06-08": 11
          },
          "time_per_day": {
            "2025-09-30": 0.21541500000000002,
            "2025-10-01": 35.063807777777775,
            "2025-10-02": 0.14305944444444443,
            "2025-10-06": 88.2338486111111,
            "2025-10-07": 15.106628333333335,
            "2025-10-08": 0.11517916666666667,
            "2025-10-09": 119.12701166666668,
            "2025-10-10": 70.20883472222222,
            "2025-10-15": 334.0021116666667,
            "2025-10-20": 276.3484025,
            "2025-10-21": 74.386865,
            "2025-10-22": 496.0355819444444,
            "2025-10-23": 172.71635666666666,
            "2025-10-24": 110.26280416666667,
            "2025-10-27": 80.6878386111111,
            "2025-10-28": 886.6988933333333,
            "2025-10-29": 1.4241794444444444,
            "2025-10-30": 156.03489916666666,
            "2025-10-31": 345.1623177777778,
            "2025-11-03": 117.39292861111112,
            "2025-11-04": 2.6465638888888887,
            "2025-11-05": 252.77630138888887,
            "2025-11-06": 320.3256944444445,
            "2025-11-08": 2.7794069444444442,
            "2025-11-09": 41.51824638888889,
            "2025-11-10": 5.1309636111111105,
            "2025-11-11": 3.316819722222222,
            "2025-11-12": 20.720672222222223,
            "2025-11-13": 314.88291861111117,
            "2025-11-14": 20.569830277777776,
            "2025-11-18": 646.9058022222222,
            "2025-11-19": 10.438888055555555,
            "2025-11-20": 10.361776388888888,
            "2025-11-21": 6.727173333333334,
            "2025-11-24": 228.71425416666668,
            "2025-11-25": 10.163039722222223,
            "2025-11-26": 23.011903888888888,
            "2025-11-27": 0.7876416666666666,
            "2025-11-28": 307.2674597222222,
            "2025-12-02": 182.98775750000001,
            "2025-12-03": 8.989055,
            "2025-12-04": 207.06527444444444,
            "2025-12-05": 592.3053,
            "2025-12-09": 291.71187722222226,
            "2025-12-10": 139.67406305555556,
            "2025-12-11": 17.814955,
            "2025-12-12": 1661.6262591666666,
            "2025-12-13": 27.688504444444444,
            "2025-12-15": 343.4534330555555,
            "2025-12-16": 985.7881386111111,
            "2025-12-22": 47.64007583333333,
            "2025-12-29": 455.474,
            "2025-12-30": 1.3789041666666666,
            "2025-12-31": 1.5147458333333335,
            "2026-01-02": 291.4872847222222,
            "2026-01-05": 202.18298,
            "2026-01-06": 31.783673055555553,
            "2026-01-07": 3943.2398355555556,
            "2026-01-08": 44.60664472222223,
            "2026-01-09": 888.7340208333333,
            "2026-01-12": 67.45101166666666,
            "2026-01-13": 129.78827222222222,
            "2026-01-14": 22.149330555555554,
            "2026-01-15": 2006.4108569444447,
            "2026-01-16": 48.24238472222221,
            "2026-01-19": 430.85222416666676,
            "2026-01-20": 314.32611944444443,
            "2026-01-21": 309.3017127777778,
            "2026-01-23": 47.79236861111111,
            "2026-01-26": 13.139311111111112,
            "2026-01-27": 28.45615277777778,
            "2026-01-28": 0.4589347222222222,
            "2026-01-29": 256.9772413888889,
            "2026-01-30": 431.60133361111104,
            "2026-02-02": 77.08788611111112,
            "2026-02-03": 6409.786090555556,
            "2026-02-04": 43.77285833333333,
            "2026-02-06": 79.73436472222222,
            "2026-02-09": 263.114645,
            "2026-02-10": 8669.576549722222,
            "2026-02-11": 3.433265833333333,
            "2026-02-16": 127.00441611111111,
            "2026-02-17": 2907.3842494444452,
            "2026-02-18": 198.80633166666664,
            "2026-02-19": 47.74764944444445,
            "2026-02-20": 298.4642847222222,
            "2026-02-23": 1283.4868869444447,
            "2026-02-24": 77.23807277777775,
            "2026-02-25": 163.2733041666666,
            "2026-02-26": 74.26577666666668,
            "2026-02-27": 201.34225277777776,
            "2026-02-28": 45.2848625,
            "2026-03-02": 536.0857811111109,
            "2026-03-03": 949.6753086111112,
            "2026-03-04": 451.4786247222222,
            "2026-03-05": 244.39238250000002,
            "2026-03-06": 494.35531861111104,
            "2026-03-07": 342.67716416666667,
            "2026-03-09": 30.310682777777778,
            "2026-03-10": 3127.550300833333,
            "2026-03-11": 109.64254388888888,
            "2026-03-12": 62.250895,
            "2026-03-13": 56.400796944444444,
            "2026-03-15": 39.66556027777778,
            "2026-03-16": 896.2943586111112,
            "2026-03-17": 119.14490416666666,
            "2026-03-18": 1112.4451713888893,
            "2026-03-19": 897.2136702777776,
            "2026-03-20": 14918.115485277778,
            "2026-03-23": 829.8522761111111,
            "2026-03-24": 812.3060675,
            "2026-03-25": 2465.602445,
            "2026-03-26": 1809.6930702777777,
            "2026-03-27": 73.76737333333334,
            "2026-03-30": 2012.3805155555551,
            "2026-03-31": 249.3140122222222,
            "2026-04-01": 742.2054324999999,
            "2026-04-02": 52.165303333333334,
            "2026-04-06": 321.80710444444446,
            "2026-04-07": 324.7814469444444,
            "2026-04-08": 553.7376894444443,
            "2026-04-09": 699.5547991666666,
            "2026-04-10": 545.7366366666666,
            "2026-04-13": 3314.6072316666655,
            "2026-04-14": 1212.942902222222,
            "2026-04-15": 359.56583861111113,
            "2026-04-16": 206.08542305555557,
            "2026-04-17": 1258.4747916666665,
            "2026-04-20": 158.73251722222219,
            "2026-04-21": 111.36156,
            "2026-04-22": 32868.52243638889,
            "2026-04-23": 25209.43742888889,
            "2026-04-24": 109.67635583333333,
            "2026-04-27": 770.5277036111112,
            "2026-04-28": 1607.3620036111108,
            "2026-04-29": 777.3869633333334,
            "2026-04-30": 3962.6063166666668,
            "2026-05-02": 64.25406,
            "2026-05-04": 14997.427743055552,
            "2026-05-05": 11.648338333333331,
            "2026-05-06": 113.55456500000001,
            "2026-05-07": 51.269512500000005,
            "2026-05-08": 3442.991360555555,
            "2026-05-11": 144.0852372222222,
            "2026-05-12": 4.769479444444444,
            "2026-05-13": 355.1685652777778,
            "2026-05-14": 433.49668666666673,
            "2026-05-15": 300.18684722222224,
            "2026-05-16": 29.643955833333333,
            "2026-05-17": 192.58819499999998,
            "2026-05-18": 1268.775551111111,
            "2026-05-19": 2244.0721127777774,
            "2026-05-20": 26.551808333333334,
            "2026-05-21": 163.04082305555553,
            "2026-05-22": 53.79472972222222,
            "2026-05-25": 117.00538250000001,
            "2026-05-26": 8787.49163972222,
            "2026-05-27": 163.8502802777778,
            "2026-05-28": 3483.0210797222226,
            "2026-05-29": 76.32945805555555,
            "2026-06-01": 511.2790411111111,
            "2026-06-02": 318.32311194444446,
            "2026-06-03": 2291.523525833333,
            "2026-06-05": 103.11260055555556,
            "2026-06-08": 513.5392377777778
          },
          "time_count_per_day": {
            "2025-09-30": 2,
            "2025-10-01": 3,
            "2025-10-02": 1,
            "2025-10-06": 1,
            "2025-10-07": 5,
            "2025-10-08": 1,
            "2025-10-09": 2,
            "2025-10-10": 3,
            "2025-10-15": 1,
            "2025-10-20": 3,
            "2025-10-21": 3,
            "2025-10-22": 6,
            "2025-10-23": 3,
            "2025-10-24": 3,
            "2025-10-27": 4,
            "2025-10-28": 13,
            "2025-10-29": 1,
            "2025-10-30": 5,
            "2025-10-31": 3,
            "2025-11-03": 4,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 4,
            "2025-11-08": 1,
            "2025-11-09": 1,
            "2025-11-10": 4,
            "2025-11-11": 1,
            "2025-11-12": 3,
            "2025-11-13": 5,
            "2025-11-14": 4,
            "2025-11-18": 4,
            "2025-11-19": 6,
            "2025-11-20": 1,
            "2025-11-21": 6,
            "2025-11-24": 12,
            "2025-11-25": 7,
            "2025-11-26": 6,
            "2025-11-27": 2,
            "2025-11-28": 13,
            "2025-12-02": 4,
            "2025-12-03": 4,
            "2025-12-04": 2,
            "2025-12-05": 1,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-12": 8,
            "2025-12-13": 1,
            "2025-12-15": 9,
            "2025-12-16": 5,
            "2025-12-22": 1,
            "2025-12-29": 2,
            "2025-12-30": 2,
            "2025-12-31": 2,
            "2026-01-02": 5,
            "2026-01-05": 3,
            "2026-01-06": 2,
            "2026-01-07": 16,
            "2026-01-08": 4,
            "2026-01-09": 7,
            "2026-01-12": 2,
            "2026-01-13": 5,
            "2026-01-14": 3,
            "2026-01-15": 23,
            "2026-01-16": 16,
            "2026-01-19": 9,
            "2026-01-20": 4,
            "2026-01-21": 3,
            "2026-01-23": 7,
            "2026-01-26": 3,
            "2026-01-27": 9,
            "2026-01-28": 1,
            "2026-01-29": 9,
            "2026-01-30": 22,
            "2026-02-02": 3,
            "2026-02-03": 13,
            "2026-02-04": 10,
            "2026-02-06": 4,
            "2026-02-09": 4,
            "2026-02-10": 20,
            "2026-02-11": 1,
            "2026-02-16": 10,
            "2026-02-17": 12,
            "2026-02-18": 24,
            "2026-02-19": 9,
            "2026-02-20": 18,
            "2026-02-23": 21,
            "2026-02-24": 18,
            "2026-02-25": 19,
            "2026-02-26": 11,
            "2026-02-27": 12,
            "2026-02-28": 13,
            "2026-03-02": 17,
            "2026-03-03": 10,
            "2026-03-04": 21,
            "2026-03-05": 9,
            "2026-03-06": 18,
            "2026-03-07": 10,
            "2026-03-09": 9,
            "2026-03-10": 31,
            "2026-03-11": 7,
            "2026-03-12": 7,
            "2026-03-13": 6,
            "2026-03-15": 1,
            "2026-03-16": 17,
            "2026-03-17": 12,
            "2026-03-18": 25,
            "2026-03-19": 24,
            "2026-03-20": 32,
            "2026-03-23": 17,
            "2026-03-24": 17,
            "2026-03-25": 19,
            "2026-03-26": 10,
            "2026-03-27": 9,
            "2026-03-30": 11,
            "2026-03-31": 11,
            "2026-04-01": 14,
            "2026-04-02": 7,
            "2026-04-06": 10,
            "2026-04-07": 18,
            "2026-04-08": 10,
            "2026-04-09": 8,
            "2026-04-10": 13,
            "2026-04-13": 28,
            "2026-04-14": 10,
            "2026-04-15": 18,
            "2026-04-16": 8,
            "2026-04-17": 16,
            "2026-04-20": 16,
            "2026-04-21": 7,
            "2026-04-22": 37,
            "2026-04-23": 33,
            "2026-04-24": 7,
            "2026-04-27": 23,
            "2026-04-28": 5,
            "2026-04-29": 16,
            "2026-04-30": 16,
            "2026-05-02": 1,
            "2026-05-04": 26,
            "2026-05-05": 8,
            "2026-05-06": 18,
            "2026-05-07": 10,
            "2026-05-08": 12,
            "2026-05-11": 8,
            "2026-05-12": 2,
            "2026-05-13": 19,
            "2026-05-14": 15,
            "2026-05-15": 14,
            "2026-05-16": 1,
            "2026-05-17": 1,
            "2026-05-18": 8,
            "2026-05-19": 10,
            "2026-05-20": 3,
            "2026-05-21": 9,
            "2026-05-22": 3,
            "2026-05-25": 4,
            "2026-05-26": 30,
            "2026-05-27": 19,
            "2026-05-28": 12,
            "2026-05-29": 1,
            "2026-06-01": 6,
            "2026-06-02": 16,
            "2026-06-03": 31,
            "2026-06-05": 20,
            "2026-06-08": 9
          }
        },
        "P3": {
          "avg_time_hours": 179.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 76,
          "time_distribution": {
            "0-2h": 76,
            "2-4h": 32,
            "4-6h": 27,
            "6-8h": 7,
            "8-10h": 9,
            "10-12h": 2,
            "12-14h": 11,
            "14-16h": 7,
            "16-18h": 3,
            "18-20h": 9,
            "20-22h": 5,
            "22-24h": 5,
            "24-26h": 9,
            "26-28h": 3,
            "28-30h": 1,
            "32-34h": 1,
            "34-36h": 1,
            "40-42h": 1,
            "42-44h": 4,
            "46-48h": 3,
            "48-50h": 1,
            "50-52h": 1,
            "52-54h": 2,
            "54-56h": 2,
            "60-62h": 2,
            "64-66h": 3,
            "70-72h": 1,
            "72-74h": 2,
            "74-76h": 2,
            "76-78h": 1,
            "78-80h": 2,
            "84-86h": 1,
            "92-94h": 1,
            "94-96h": 2,
            "96-98h": 4,
            "100-102h": 1,
            "102-104h": 1,
            "104-106h": 1,
            "108-110h": 1,
            "114-116h": 1,
            "118-120h": 3,
            "122-124h": 2,
            "124-126h": 1,
            "128-130h": 1,
            "136-138h": 2,
            "138-140h": 1,
            "140-142h": 3,
            "142-144h": 1,
            "144-146h": 3,
            "146-148h": 1,
            "150-152h": 1,
            "152-154h": 1,
            "158-160h": 1,
            "160-162h": 1,
            "164-166h": 1,
            "166-168h": 2,
            "168-170h": 2,
            "170-172h": 1,
            "172-174h": 2,
            "184-186h": 1,
            "186-188h": 1,
            "190-192h": 3,
            "194-196h": 1,
            "196-198h": 1,
            "198-200h": 1,
            "210-212h": 1,
            "214-216h": 1,
            "216-218h": 1,
            "218-220h": 1,
            "224-226h": 1,
            "230-232h": 1,
            "232-234h": 1,
            "236-238h": 2,
            "242-244h": 1,
            "244-246h": 1,
            "252-254h": 1,
            "260-262h": 1,
            "262-264h": 1,
            "270-272h": 1,
            "272-274h": 1,
            "280-282h": 1,
            "282-284h": 1,
            "304-306h": 1,
            "308-310h": 2,
            "314-316h": 1,
            "316-318h": 1,
            "320-322h": 1,
            "328-330h": 1,
            "336-338h": 1,
            "338-340h": 2,
            "356-358h": 1,
            "358-360h": 1,
            "360-362h": 1,
            "364-366h": 1,
            "368-370h": 1,
            "376-378h": 1,
            "380-382h": 1,
            "386-388h": 1,
            "388-390h": 1,
            "410-412h": 1,
            "414-416h": 1,
            "424-426h": 2,
            "436-438h": 1,
            "446-448h": 1,
            "454-456h": 1,
            "460-462h": 1,
            "482-484h": 1,
            "498-500h": 1,
            "500-502h": 2,
            "514-516h": 1,
            "526-528h": 1,
            "534-536h": 1,
            "536-538h": 1,
            "548-550h": 1,
            "572-574h": 1,
            "574-576h": 1,
            "600-602h": 1,
            "614-616h": 1,
            "618-620h": 1,
            "628-630h": 1,
            "658-660h": 1,
            "670-672h": 1,
            "678-680h": 1,
            "680-682h": 2,
            "694-696h": 1,
            "700-702h": 1,
            "720-722h": 1,
            "736-738h": 1,
            "758-760h": 1,
            "814-816h": 1,
            "820-822h": 3,
            "860-862h": 1,
            "866-868h": 1,
            "1060-1062h": 1,
            "1178-1180h": 1,
            "1238-1240h": 1,
            "1250-1252h": 1,
            "1362-1364h": 1,
            "1390-1392h": 1,
            "1506-1508h": 1,
            "1752-1754h": 1,
            "1778-1780h": 1,
            "1844-1846h": 1,
            "1872-1874h": 1,
            "2016-2018h": 1,
            "2032-2034h": 1,
            "2212-2214h": 1
          },
          "tickets_count": 377,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-02": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 3,
            "2025-10-08": 7,
            "2025-10-09": 5,
            "2025-10-10": 3,
            "2025-10-14": 2,
            "2025-10-15": 5,
            "2025-10-16": 1,
            "2025-10-17": 3,
            "2025-10-21": 3,
            "2025-10-23": 1,
            "2025-10-24": 5,
            "2025-10-27": 1,
            "2025-10-28": 3,
            "2025-10-30": 1,
            "2025-11-03": 10,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 9,
            "2025-11-07": 3,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-13": 4,
            "2025-11-14": 8,
            "2025-11-16": 1,
            "2025-11-18": 9,
            "2025-11-19": 10,
            "2025-11-20": 2,
            "2025-11-21": 6,
            "2025-11-24": 4,
            "2025-11-25": 7,
            "2025-11-26": 3,
            "2025-11-27": 7,
            "2025-11-28": 5,
            "2025-11-29": 1,
            "2025-12-02": 9,
            "2025-12-03": 4,
            "2025-12-04": 5,
            "2025-12-05": 7,
            "2025-12-09": 5,
            "2025-12-10": 7,
            "2025-12-11": 2,
            "2025-12-12": 6,
            "2025-12-15": 6,
            "2025-12-16": 3,
            "2025-12-18": 2,
            "2025-12-22": 5,
            "2025-12-26": 2,
            "2025-12-29": 1,
            "2026-01-02": 2,
            "2026-01-05": 1,
            "2026-01-07": 4,
            "2026-01-09": 2,
            "2026-01-12": 1,
            "2026-01-13": 14,
            "2026-01-14": 4,
            "2026-01-15": 6,
            "2026-01-16": 2,
            "2026-01-18": 8,
            "2026-01-19": 3,
            "2026-01-20": 4,
            "2026-01-22": 1,
            "2026-01-23": 2,
            "2026-01-26": 5,
            "2026-01-28": 3,
            "2026-01-29": 4,
            "2026-01-30": 1,
            "2026-02-03": 16,
            "2026-02-04": 3,
            "2026-02-05": 1,
            "2026-02-07": 2,
            "2026-02-09": 11,
            "2026-02-10": 11,
            "2026-02-13": 1,
            "2026-02-16": 2,
            "2026-02-17": 6,
            "2026-02-18": 4,
            "2026-02-19": 4,
            "2026-02-20": 3,
            "2026-02-23": 1,
            "2026-02-24": 5,
            "2026-02-25": 3,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-04": 7,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 4,
            "2026-04-07": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 2
          },
          "time_per_day": {
            "2025-09-30": 5.489487777777779,
            "2025-10-02": 19.914869166666666,
            "2025-10-03": 42.59790194444444,
            "2025-10-06": 6.672649722222222,
            "2025-10-07": 243.11860416666667,
            "2025-10-08": 35.812764722222234,
            "2025-10-09": 603.420205,
            "2025-10-10": 268.92412916666666,
            "2025-10-14": 470.5076261111111,
            "2025-10-15": 201.6675775,
            "2025-10-16": 20.367943333333336,
            "2025-10-17": 266.111235,
            "2025-10-21": 616.4316511111111,
            "2025-10-23": 233.7853338888889,
            "2025-10-24": 413.6799455555555,
            "2025-10-27": 164.94374638888888,
            "2025-10-28": 417.17864888888886,
            "2025-10-30": 46.66518722222222,
            "2025-11-03": 708.9117936111112,
            "2025-11-04": 1.1331905555555555,
            "2025-11-05": 383.5256216666667,
            "2025-11-06": 215.58570500000002,
            "2025-11-07": 274.33866222222224,
            "2025-11-11": 21.92054638888889,
            "2025-11-12": 59.958599444444445,
            "2025-11-13": 324.5959977777778,
            "2025-11-14": 117.86029583333332,
            "2025-11-16": 253.38371305555555,
            "2025-11-18": 1510.439731111111,
            "2025-11-19": 2203.3821408333333,
            "2025-11-20": 41.64366916666667,
            "2025-11-21": 636.7588722222222,
            "2025-11-24": 209.9088888888889,
            "2025-11-25": 8.137994166666667,
            "2025-11-26": 2013.7671313888889,
            "2025-11-27": 1404.3035897222221,
            "2025-11-28": 750.1141483333333,
            "2025-11-29": 123.85818388888889,
            "2025-12-02": 679.2828591666668,
            "2025-12-03": 225.86626388888885,
            "2025-12-04": 11.375973055555555,
            "2025-12-05": 6.894056944444445,
            "2025-12-09": 270.3815097222222,
            "2025-12-10": 1073.2676594444445,
            "2025-12-11": 19.43295777777778,
            "2025-12-12": 2225.8501133333334,
            "2025-12-15": 1390.7054316666668,
            "2025-12-16": 601.9666575,
            "2025-12-18": 10.837394166666666,
            "2025-12-22": 84.30288499999999,
            "2025-12-26": 8.743221666666667,
            "2026-01-02": 1033.0062691666667,
            "2026-01-05": 6.458349444444445,
            "2026-01-07": 1405.8122719444443,
            "2026-01-09": 725.7724380555555,
            "2026-01-12": 160.96238555555556,
            "2026-01-13": 54.99690666666667,
            "2026-01-14": 20.074207777777776,
            "2026-01-15": 270.3137530555556,
            "2026-01-16": 3.823486388888889,
            "2026-01-18": 107.7343877777778,
            "2026-01-19": 48.268590277777776,
            "2026-01-20": 64.46295944444444,
            "2026-01-22": 4.0281633333333335,
            "2026-01-23": 6.58996111111111,
            "2026-01-26": 178.98467111111108,
            "2026-01-28": 20.198445555555555,
            "2026-01-29": 90.00869694444445,
            "2026-01-30": 10.090999444444444,
            "2026-02-03": 4914.253681944444,
            "2026-02-04": 590.5203880555556,
            "2026-02-05": 173.83352694444446,
            "2026-02-07": 122.51177861111111,
            "2026-02-09": 353.9863275,
            "2026-02-10": 6309.947674722222,
            "2026-02-13": 758.5593352777778,
            "2026-02-16": 733.5090997222222,
            "2026-02-17": 4589.894079166667,
            "2026-02-18": 4048.2863355555555,
            "2026-02-19": 1452.800416666667,
            "2026-02-20": 1909.6247563888887,
            "2026-02-23": 308.14055583333334,
            "2026-02-24": 6.951343888888889,
            "2026-02-25": 57.76767833333333,
            "2026-02-28": 43.23732277777778,
            "2026-03-02": 1506.4725369444445,
            "2026-03-04": 9.382637222222222,
            "2026-03-07": 49.85104638888889,
            "2026-03-10": 658.5155641666666,
            "2026-03-12": 1390.879412222222,
            "2026-03-17": 2032.716291111111,
            "2026-03-18": 281.7378008333333,
            "2026-03-20": 2986.8806705555558,
            "2026-04-07": 2016.1087336111111,
            "2026-04-09": 3.0484175,
            "2026-04-10": 47.31499944444444,
            "2026-04-21": 16.983233055555555,
            "2026-04-22": 360.95290388888884,
            "2026-04-23": 3625.1184419444444
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-02": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 3,
            "2025-10-08": 7,
            "2025-10-09": 5,
            "2025-10-10": 3,
            "2025-10-14": 2,
            "2025-10-15": 5,
            "2025-10-16": 1,
            "2025-10-17": 3,
            "2025-10-21": 3,
            "2025-10-23": 1,
            "2025-10-24": 5,
            "2025-10-27": 1,
            "2025-10-28": 3,
            "2025-10-30": 1,
            "2025-11-03": 10,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 9,
            "2025-11-07": 3,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-13": 4,
            "2025-11-14": 8,
            "2025-11-16": 1,
            "2025-11-18": 9,
            "2025-11-19": 10,
            "2025-11-20": 2,
            "2025-11-21": 6,
            "2025-11-24": 4,
            "2025-11-25": 7,
            "2025-11-26": 3,
            "2025-11-27": 7,
            "2025-11-28": 5,
            "2025-11-29": 1,
            "2025-12-02": 9,
            "2025-12-03": 4,
            "2025-12-04": 5,
            "2025-12-05": 7,
            "2025-12-09": 5,
            "2025-12-10": 7,
            "2025-12-11": 2,
            "2025-12-12": 6,
            "2025-12-15": 6,
            "2025-12-16": 3,
            "2025-12-18": 2,
            "2025-12-22": 5,
            "2025-12-26": 2,
            "2026-01-02": 2,
            "2026-01-05": 1,
            "2026-01-07": 4,
            "2026-01-09": 2,
            "2026-01-12": 1,
            "2026-01-13": 14,
            "2026-01-14": 4,
            "2026-01-15": 6,
            "2026-01-16": 2,
            "2026-01-18": 8,
            "2026-01-19": 3,
            "2026-01-20": 4,
            "2026-01-22": 1,
            "2026-01-23": 2,
            "2026-01-26": 5,
            "2026-01-28": 3,
            "2026-01-29": 4,
            "2026-01-30": 1,
            "2026-02-03": 16,
            "2026-02-04": 3,
            "2026-02-05": 1,
            "2026-02-07": 2,
            "2026-02-09": 11,
            "2026-02-10": 11,
            "2026-02-13": 1,
            "2026-02-16": 2,
            "2026-02-17": 6,
            "2026-02-18": 4,
            "2026-02-19": 4,
            "2026-02-20": 3,
            "2026-02-23": 1,
            "2026-02-24": 5,
            "2026-02-25": 3,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-04": 7,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 4,
            "2026-04-07": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 201.25,
          "mode_time_hours": 133.0,
          "mode_frequency": 6,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "8-10h": 1,
            "20-22h": 2,
            "26-28h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "66-68h": 2,
            "70-72h": 1,
            "76-78h": 1,
            "90-92h": 1,
            "112-114h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "124-126h": 1,
            "128-130h": 2,
            "132-134h": 6,
            "138-140h": 2,
            "140-142h": 5,
            "148-150h": 2,
            "150-152h": 1,
            "166-168h": 1,
            "178-180h": 1,
            "186-188h": 1,
            "194-196h": 1,
            "218-220h": 1,
            "220-222h": 1,
            "230-232h": 1,
            "256-258h": 1,
            "262-264h": 1,
            "288-290h": 1,
            "292-294h": 1,
            "330-332h": 1,
            "340-342h": 1,
            "360-362h": 1,
            "362-364h": 1,
            "366-368h": 3,
            "380-382h": 1,
            "412-414h": 1,
            "438-440h": 2,
            "472-474h": 1,
            "572-574h": 1,
            "842-844h": 1
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-25": 1,
            "2025-11-05": 2,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-10": 1,
            "2025-11-14": 3,
            "2025-11-18": 1,
            "2025-11-19": 4,
            "2025-11-24": 1,
            "2025-11-29": 2,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-03": 9,
            "2026-02-04": 8,
            "2026-02-05": 3,
            "2026-02-06": 2,
            "2026-02-10": 2,
            "2026-02-17": 2,
            "2026-02-19": 1,
            "2026-03-30": 1,
            "2026-04-20": 1,
            "2026-05-04": 2
          },
          "time_per_day": {
            "2025-10-21": 40.20449138888889,
            "2025-10-23": 77.83891027777777,
            "2025-10-25": 256.24249305555554,
            "2025-11-05": 238.80238250000002,
            "2025-11-06": 187.87628361111112,
            "2025-11-07": 230.5068077777778,
            "2025-11-10": 3.118009166666667,
            "2025-11-14": 1102.2447011111112,
            "2025-11-18": 331.31258833333334,
            "2025-11-19": 408.3228761111111,
            "2025-11-24": 149.37999555555558,
            "2025-11-29": 152.15293444444444,
            "2025-12-04": 156.10407666666666,
            "2025-12-05": 133.8503372222222,
            "2026-01-07": 289.246025,
            "2026-01-13": 4.308753888888889,
            "2026-01-15": 8.721878333333333,
            "2026-01-17": 91.22941638888888,
            "2026-01-30": 413.64857722222223,
            "2026-02-02": 71.297775,
            "2026-02-03": 1711.5069522222223,
            "2026-02-04": 1057.9961658333334,
            "2026-02-05": 524.7028897222223,
            "2026-02-06": 388.4040258333333,
            "2026-02-10": 556.3568288888889,
            "2026-02-17": 877.9425422222222,
            "2026-02-19": 472.31816555555554,
            "2026-03-30": 340.5451375,
            "2026-04-20": 381.8180936111111,
            "2026-05-04": 1416.9927416666667
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-25": 1,
            "2025-11-05": 2,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-10": 1,
            "2025-11-14": 3,
            "2025-11-18": 1,
            "2025-11-19": 4,
            "2025-11-24": 1,
            "2025-11-29": 2,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-03": 9,
            "2026-02-04": 8,
            "2026-02-05": 3,
            "2026-02-06": 2,
            "2026-02-10": 2,
            "2026-02-17": 2,
            "2026-02-19": 1,
            "2026-03-30": 1,
            "2026-04-20": 1,
            "2026-05-04": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 342.53,
          "mode_time_hours": 549.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "10-12h": 1,
            "98-100h": 1,
            "110-112h": 1,
            "132-134h": 1,
            "160-162h": 1,
            "218-220h": 1,
            "234-236h": 1,
            "238-240h": 1,
            "266-268h": 1,
            "358-360h": 1,
            "362-364h": 1,
            "368-370h": 1,
            "402-404h": 1,
            "438-440h": 1,
            "442-444h": 1,
            "478-480h": 1,
            "480-482h": 1,
            "500-502h": 1,
            "548-550h": 2,
            "902-904h": 2
          },
          "tickets_count": 24,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-11": 4,
            "2025-12-12": 2,
            "2025-12-15": 1,
            "2025-12-16": 2,
            "2026-01-02": 2,
            "2026-01-17": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-17": 2,
            "2026-02-19": 3
          },
          "time_per_day": {
            "2025-12-02": 2.251583888888889,
            "2025-12-04": 111.61828166666668,
            "2025-12-05": 224.47086583333333,
            "2025-12-11": 1825.3005311111112,
            "2025-12-12": 473.1708366666667,
            "2025-12-15": 10.778245555555555,
            "2025-12-16": 563.9792955555556,
            "2026-01-02": 1806.366112222222,
            "2026-01-17": 98.15265805555556,
            "2026-02-03": 362.9315555555556,
            "2026-02-04": 133.08936583333335,
            "2026-02-10": 267.6131972222222,
            "2026-02-17": 880.4267780555555,
            "2026-02-19": 1460.4956075
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-11": 4,
            "2025-12-12": 2,
            "2025-12-15": 1,
            "2025-12-16": 2,
            "2026-01-02": 2,
            "2026-01-17": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-17": 2,
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 133.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 620,
            "time_distribution": {
              "0-2h": 620,
              "2-4h": 211,
              "4-6h": 114,
              "6-8h": 65,
              "8-10h": 30,
              "10-12h": 44,
              "12-14h": 42,
              "14-16h": 48,
              "16-18h": 39,
              "18-20h": 45,
              "20-22h": 32,
              "22-24h": 37,
              "24-26h": 32,
              "26-28h": 18,
              "28-30h": 9,
              "30-32h": 5,
              "32-34h": 14,
              "34-36h": 10,
              "36-38h": 5,
              "38-40h": 8,
              "40-42h": 11,
              "42-44h": 11,
              "44-46h": 10,
              "46-48h": 13,
              "48-50h": 9,
              "50-52h": 13,
              "52-54h": 6,
              "54-56h": 7,
              "56-58h": 3,
              "58-60h": 3,
              "60-62h": 4,
              "62-64h": 7,
              "64-66h": 14,
              "66-68h": 8,
              "68-70h": 3,
              "70-72h": 9,
              "72-74h": 12,
              "74-76h": 7,
              "76-78h": 4,
              "78-80h": 2,
              "84-86h": 4,
              "86-88h": 4,
              "88-90h": 8,
              "90-92h": 3,
              "92-94h": 4,
              "94-96h": 4,
              "96-98h": 7,
              "98-100h": 3,
              "100-102h": 3,
              "102-104h": 2,
              "104-106h": 1,
              "106-108h": 1,
              "108-110h": 2,
              "110-112h": 1,
              "112-114h": 2,
              "114-116h": 5,
              "116-118h": 4,
              "118-120h": 5,
              "120-122h": 4,
              "122-124h": 4,
              "124-126h": 5,
              "128-130h": 4,
              "130-132h": 1,
              "132-134h": 8,
              "134-136h": 1,
              "136-138h": 2,
              "138-140h": 10,
              "140-142h": 10,
              "142-144h": 2,
              "144-146h": 6,
              "146-148h": 2,
              "148-150h": 4,
              "150-152h": 2,
              "152-154h": 2,
              "154-156h": 1,
              "156-158h": 2,
              "158-160h": 2,
              "160-162h": 6,
              "162-164h": 6,
              "164-166h": 4,
              "166-168h": 4,
              "168-170h": 3,
              "170-172h": 2,
              "172-174h": 2,
              "178-180h": 1,
              "180-182h": 1,
              "184-186h": 2,
              "186-188h": 2,
              "188-190h": 1,
              "190-192h": 7,
              "192-194h": 3,
              "194-196h": 2,
              "196-198h": 1,
              "198-200h": 2,
              "200-202h": 2,
              "202-204h": 1,
              "204-206h": 1,
              "210-212h": 3,
              "212-214h": 1,
              "214-216h": 1,
              "216-218h": 2,
              "218-220h": 3,
              "220-222h": 2,
              "222-224h": 2,
              "224-226h": 1,
              "230-232h": 2,
              "232-234h": 1,
              "234-236h": 4,
              "236-238h": 3,
              "238-240h": 4,
              "240-242h": 3,
              "242-244h": 1,
              "244-246h": 1,
              "246-248h": 1,
              "250-252h": 1,
              "252-254h": 1,
              "256-258h": 1,
              "258-260h": 1,
              "260-262h": 3,
              "262-264h": 2,
              "266-268h": 2,
              "268-270h": 3,
              "270-272h": 1,
              "272-274h": 1,
              "278-280h": 1,
              "280-282h": 3,
              "282-284h": 1,
              "284-286h": 1,
              "286-288h": 4,
              "288-290h": 1,
              "290-292h": 1,
              "292-294h": 3,
              "294-296h": 1,
              "296-298h": 1,
              "298-300h": 1,
              "302-304h": 1,
              "304-306h": 1,
              "306-308h": 4,
              "308-310h": 2,
              "310-312h": 3,
              "312-314h": 1,
              "314-316h": 1,
              "316-318h": 4,
              "320-322h": 2,
              "328-330h": 1,
              "330-332h": 3,
              "332-334h": 6,
              "334-336h": 1,
              "336-338h": 2,
              "338-340h": 2,
              "340-342h": 3,
              "342-344h": 1,
              "344-346h": 1,
              "356-358h": 2,
              "358-360h": 4,
              "360-362h": 3,
              "362-364h": 4,
              "364-366h": 1,
              "366-368h": 5,
              "368-370h": 4,
              "372-374h": 1,
              "376-378h": 2,
              "378-380h": 1,
              "380-382h": 3,
              "382-384h": 1,
              "386-388h": 1,
              "388-390h": 2,
              "398-400h": 1,
              "400-402h": 2,
              "402-404h": 1,
              "404-406h": 1,
              "406-408h": 3,
              "408-410h": 1,
              "410-412h": 1,
              "412-414h": 1,
              "414-416h": 2,
              "424-426h": 3,
              "426-428h": 1,
              "434-436h": 1,
              "436-438h": 2,
              "438-440h": 3,
              "442-444h": 1,
              "444-446h": 1,
              "446-448h": 1,
              "454-456h": 3,
              "456-458h": 1,
              "460-462h": 1,
              "468-470h": 1,
              "470-472h": 1,
              "472-474h": 1,
              "478-480h": 1,
              "480-482h": 1,
              "482-484h": 3,
              "494-496h": 1,
              "496-498h": 4,
              "498-500h": 1,
              "500-502h": 3,
              "506-508h": 1,
              "508-510h": 1,
              "512-514h": 1,
              "514-516h": 1,
              "518-520h": 2,
              "524-526h": 7,
              "526-528h": 3,
              "532-534h": 2,
              "534-536h": 1,
              "536-538h": 1,
              "548-550h": 4,
              "550-552h": 1,
              "554-556h": 1,
              "556-558h": 1,
              "560-562h": 1,
              "572-574h": 2,
              "574-576h": 1,
              "576-578h": 1,
              "592-594h": 1,
              "600-602h": 2,
              "614-616h": 1,
              "618-620h": 1,
              "624-626h": 1,
              "628-630h": 1,
              "642-644h": 1,
              "650-652h": 1,
              "656-658h": 1,
              "658-660h": 1,
              "660-662h": 1,
              "666-668h": 2,
              "668-670h": 2,
              "670-672h": 1,
              "672-674h": 1,
              "678-680h": 1,
              "680-682h": 2,
              "694-696h": 1,
              "700-702h": 2,
              "704-706h": 1,
              "720-722h": 1,
              "722-724h": 1,
              "724-726h": 1,
              "734-736h": 1,
              "736-738h": 1,
              "738-740h": 1,
              "742-744h": 1,
              "744-746h": 1,
              "746-748h": 1,
              "748-750h": 1,
              "758-760h": 1,
              "766-768h": 1,
              "772-774h": 1,
              "786-788h": 1,
              "792-794h": 1,
              "808-810h": 1,
              "810-812h": 1,
              "814-816h": 1,
              "820-822h": 4,
              "838-840h": 1,
              "840-842h": 2,
              "842-844h": 4,
              "860-862h": 2,
              "862-864h": 1,
              "866-868h": 1,
              "870-872h": 1,
              "890-892h": 2,
              "892-894h": 2,
              "902-904h": 2,
              "934-936h": 1,
              "984-986h": 2,
              "1000-1002h": 3,
              "1012-1014h": 1,
              "1024-1026h": 1,
              "1038-1040h": 1,
              "1050-1052h": 1,
              "1052-1054h": 1,
              "1054-1056h": 1,
              "1058-1060h": 1,
              "1060-1062h": 1,
              "1070-1072h": 1,
              "1076-1078h": 1,
              "1078-1080h": 1,
              "1100-1102h": 1,
              "1104-1106h": 1,
              "1122-1124h": 1,
              "1124-1126h": 1,
              "1142-1144h": 1,
              "1152-1154h": 1,
              "1166-1168h": 1,
              "1174-1176h": 1,
              "1176-1178h": 1,
              "1178-1180h": 2,
              "1196-1198h": 1,
              "1198-1200h": 1,
              "1200-1202h": 1,
              "1216-1218h": 1,
              "1238-1240h": 1,
              "1242-1244h": 2,
              "1244-1246h": 1,
              "1248-1250h": 2,
              "1250-1252h": 1,
              "1314-1316h": 1,
              "1316-1318h": 1,
              "1320-1322h": 1,
              "1338-1340h": 1,
              "1340-1342h": 1,
              "1360-1362h": 1,
              "1362-1364h": 2,
              "1390-1392h": 1,
              "1416-1418h": 1,
              "1454-1456h": 1,
              "1460-1462h": 1,
              "1482-1484h": 1,
              "1506-1508h": 2,
              "1514-1516h": 1,
              "1532-1534h": 2,
              "1546-1548h": 1,
              "1562-1564h": 1,
              "1584-1586h": 1,
              "1620-1622h": 1,
              "1622-1624h": 1,
              "1728-1730h": 1,
              "1752-1754h": 1,
              "1770-1772h": 1,
              "1778-1780h": 1,
              "1844-1846h": 1,
              "1872-1874h": 1,
              "2016-2018h": 1,
              "2032-2034h": 1,
              "2158-2160h": 1,
              "2212-2214h": 1,
              "3002-3004h": 3,
              "3554-3556h": 1
            },
            "tickets_count": 2135,
            "tickets_per_day": {
              "2025-09-30": 10,
              "2025-10-01": 3,
              "2025-10-02": 2,
              "2025-10-03": 1,
              "2025-10-06": 2,
              "2025-10-07": 8,
              "2025-10-08": 9,
              "2025-10-09": 7,
              "2025-10-10": 7,
              "2025-10-13": 1,
              "2025-10-14": 2,
              "2025-10-15": 6,
              "2025-10-16": 1,
              "2025-10-17": 3,
              "2025-10-20": 3,
              "2025-10-21": 7,
              "2025-10-22": 9,
              "2025-10-23": 6,
              "2025-10-24": 8,
              "2025-10-25": 1,
              "2025-10-27": 6,
              "2025-10-28": 17,
              "2025-10-29": 1,
              "2025-10-30": 6,
              "2025-10-31": 3,
              "2025-11-03": 14,
              "2025-11-04": 3,
              "2025-11-05": 9,
              "2025-11-06": 14,
              "2025-11-07": 5,
              "2025-11-08": 2,
              "2025-11-09": 1,
              "2025-11-10": 5,
              "2025-11-11": 3,
              "2025-11-12": 6,
              "2025-11-13": 10,
              "2025-11-14": 16,
              "2025-11-16": 1,
              "2025-11-18": 14,
              "2025-11-19": 20,
              "2025-11-20": 3,
              "2025-11-21": 12,
              "2025-11-24": 18,
              "2025-11-25": 14,
              "2025-11-26": 9,
              "2025-11-27": 10,
              "2025-11-28": 18,
              "2025-11-29": 3,
              "2025-12-02": 14,
              "2025-12-03": 10,
              "2025-12-04": 11,
              "2025-12-05": 12,
              "2025-12-09": 8,
              "2025-12-10": 10,
              "2025-12-11": 8,
              "2025-12-12": 17,
              "2025-12-13": 1,
              "2025-12-15": 16,
              "2025-12-16": 10,
              "2025-12-18": 2,
              "2025-12-22": 6,
              "2025-12-26": 3,
              "2025-12-29": 2,
              "2025-12-30": 2,
              "2025-12-31": 2,
              "2026-01-02": 9,
              "2026-01-05": 4,
              "2026-01-06": 2,
              "2026-01-07": 21,
              "2026-01-08": 6,
              "2026-01-09": 9,
              "2026-01-12": 3,
              "2026-01-13": 20,
              "2026-01-14": 7,
              "2026-01-15": 30,
              "2026-01-16": 18,
              "2026-01-17": 2,
              "2026-01-18": 8,
              "2026-01-19": 12,
              "2026-01-20": 8,
              "2026-01-21": 3,
              "2026-01-22": 1,
              "2026-01-23": 9,
              "2026-01-26": 8,
              "2026-01-27": 9,
              "2026-01-28": 4,
              "2026-01-29": 14,
              "2026-01-30": 24,
              "2026-02-02": 4,
              "2026-02-03": 40,
              "2026-02-04": 22,
              "2026-02-05": 4,
              "2026-02-06": 6,
              "2026-02-07": 2,
              "2026-02-09": 15,
              "2026-02-10": 35,
              "2026-02-11": 1,
              "2026-02-13": 1,
              "2026-02-16": 12,
              "2026-02-17": 22,
              "2026-02-18": 28,
              "2026-02-19": 17,
              "2026-02-20": 22,
              "2026-02-23": 22,
              "2026-02-24": 23,
              "2026-02-25": 22,
              "2026-02-26": 11,
              "2026-02-27": 13,
              "2026-02-28": 14,
              "2026-03-02": 18,
              "2026-03-03": 10,
              "2026-03-04": 31,
              "2026-03-05": 9,
              "2026-03-06": 19,
              "2026-03-07": 11,
              "2026-03-09": 10,
              "2026-03-10": 32,
              "2026-03-11": 7,
              "2026-03-12": 8,
              "2026-03-13": 7,
              "2026-03-15": 1,
              "2026-03-16": 18,
              "2026-03-17": 14,
              "2026-03-18": 33,
              "2026-03-19": 25,
              "2026-03-20": 38,
              "2026-03-23": 17,
              "2026-03-24": 17,
              "2026-03-25": 19,
              "2026-03-26": 11,
              "2026-03-27": 9,
              "2026-03-30": 12,
              "2026-03-31": 11,
              "2026-04-01": 16,
              "2026-04-02": 7,
              "2026-04-06": 14,
              "2026-04-07": 20,
              "2026-04-08": 11,
              "2026-04-09": 10,
              "2026-04-10": 14,
              "2026-04-13": 30,
              "2026-04-14": 15,
              "2026-04-15": 23,
              "2026-04-16": 9,
              "2026-04-17": 16,
              "2026-04-20": 20,
              "2026-04-21": 8,
              "2026-04-22": 38,
              "2026-04-23": 36,
              "2026-04-24": 8,
              "2026-04-27": 26,
              "2026-04-28": 5,
              "2026-04-29": 17,
              "2026-04-30": 17,
              "2026-05-02": 1,
              "2026-05-04": 28,
              "2026-05-05": 11,
              "2026-05-06": 22,
              "2026-05-07": 10,
              "2026-05-08": 12,
              "2026-05-11": 8,
              "2026-05-12": 2,
              "2026-05-13": 20,
              "2026-05-14": 16,
              "2026-05-15": 14,
              "2026-05-16": 1,
              "2026-05-17": 1,
              "2026-05-18": 9,
              "2026-05-19": 10,
              "2026-05-20": 3,
              "2026-05-21": 10,
              "2026-05-22": 5,
              "2026-05-25": 5,
              "2026-05-26": 36,
              "2026-05-27": 23,
              "2026-05-28": 13,
              "2026-05-29": 1,
              "2026-06-01": 8,
              "2026-06-02": 18,
              "2026-06-03": 32,
              "2026-06-05": 20,
              "2026-06-08": 9
            },
            "time_per_day": {
              "2025-09-30": 14.75557861111111,
              "2025-10-01": 35.063807777777775,
              "2025-10-02": 20.05792861111111,
              "2025-10-03": 42.59790194444444,
              "2025-10-06": 94.90649833333332,
              "2025-10-07": 258.2252325,
              "2025-10-08": 50.83782111111112,
              "2025-10-09": 722.5472166666667,
              "2025-10-10": 432.6903519444444,
              "2025-10-13": 123.30291527777777,
              "2025-10-14": 470.5076261111111,
              "2025-10-15": 535.6696891666668,
              "2025-10-16": 20.367943333333336,
              "2025-10-17": 266.111235,
              "2025-10-20": 276.3484025,
              "2025-10-21": 731.0230075000001,
              "2025-10-22": 683.1636255555557,
              "2025-10-23": 543.7726233333333,
              "2025-10-24": 523.9427497222223,
              "2025-10-25": 256.24249305555554,
              "2025-10-27": 248.62698916666665,
              "2025-10-28": 1324.2816108333334,
              "2025-10-29": 1.4241794444444444,
              "2025-10-30": 202.7000863888889,
              "2025-10-31": 345.1623177777778,
              "2025-11-03": 826.3047222222223,
              "2025-11-04": 9.118137777777779,
              "2025-11-05": 900.6651666666667,
              "2025-11-06": 723.7876830555554,
              "2025-11-07": 506.6936205555556,
              "2025-11-08": 17.88305638888889,
              "2025-11-09": 41.51824638888889,
              "2025-11-10": 8.248972777777778,
              "2025-11-11": 25.237366111111115,
              "2025-11-12": 80.67927166666666,
              "2025-11-13": 1108.9715466666667,
              "2025-11-14": 1241.4247350000003,
              "2025-11-16": 253.38371305555555,
              "2025-11-18": 2488.658121666666,
              "2025-11-19": 2622.143905,
              "2025-11-20": 52.00544555555555,
              "2025-11-21": 643.4860455555554,
              "2025-11-24": 608.359658611111,
              "2025-11-25": 18.301033888888888,
              "2025-11-26": 2036.7790352777781,
              "2025-11-27": 1405.528240833333,
              "2025-11-28": 1057.3816080555555,
              "2025-11-29": 276.01111833333334,
              "2025-12-02": 864.5222005555556,
              "2025-12-03": 241.8261013888889,
              "2025-12-04": 487.83310083333345,
              "2025-12-05": 957.52056,
              "2025-12-09": 562.0933869444444,
              "2025-12-10": 1236.8228911111114,
              "2025-12-11": 1862.548443888889,
              "2025-12-12": 4385.003239166666,
              "2025-12-13": 27.688504444444444,
              "2025-12-15": 1744.937110277778,
              "2025-12-16": 2151.7340916666667,
              "2025-12-18": 10.837394166666666,
              "2025-12-22": 131.94296083333333,
              "2025-12-26": 10.105572222222222,
              "2025-12-29": 455.474,
              "2025-12-30": 1.3789041666666666,
              "2025-12-31": 1.5147458333333335,
              "2026-01-02": 3130.859666111111,
              "2026-01-05": 208.64132944444444,
              "2026-01-06": 31.783673055555553,
              "2026-01-07": 5638.298132500001,
              "2026-01-08": 937.6500144444444,
              "2026-01-09": 1614.506458888889,
              "2026-01-12": 228.41339722222224,
              "2026-01-13": 189.09393277777772,
              "2026-01-14": 42.22353833333333,
              "2026-01-15": 2285.4464883333335,
              "2026-01-16": 52.0658711111111,
              "2026-01-17": 189.38207444444444,
              "2026-01-18": 107.7343877777778,
              "2026-01-19": 479.12081444444453,
              "2026-01-20": 378.7890788888888,
              "2026-01-21": 309.3017127777778,
              "2026-01-22": 4.0281633333333335,
              "2026-01-23": 54.38232972222222,
              "2026-01-26": 192.12398222222222,
              "2026-01-27": 28.45615277777778,
              "2026-01-28": 20.657380277777776,
              "2026-01-29": 370.13796083333335,
              "2026-01-30": 855.340910277778,
              "2026-02-02": 148.38566111111115,
              "2026-02-03": 13709.93116444444,
              "2026-02-04": 1825.3787780555556,
              "2026-02-05": 698.5364166666667,
              "2026-02-06": 468.13839055555553,
              "2026-02-07": 122.51177861111111,
              "2026-02-09": 617.1009725000002,
              "2026-02-10": 15923.06294583334,
              "2026-02-11": 3.433265833333333,
              "2026-02-13": 758.5593352777778,
              "2026-02-16": 860.5135158333333,
              "2026-02-17": 9255.647648888887,
              "2026-02-18": 4247.09266722222,
              "2026-02-19": 3433.361839166667,
              "2026-02-20": 2208.953481111111,
              "2026-02-23": 1591.6274427777778,
              "2026-02-24": 84.18941666666663,
              "2026-02-25": 221.04098249999993,
              "2026-02-26": 74.26577666666668,
              "2026-02-27": 228.70575305555553,
              "2026-02-28": 88.52218527777778,
              "2026-03-02": 2042.5583180555554,
              "2026-03-03": 949.6753086111112,
              "2026-03-04": 482.5548694444445,
              "2026-03-05": 244.39238250000002,
              "2026-03-06": 495.28298222222213,
              "2026-03-07": 392.5282105555556,
              "2026-03-09": 32.66441722222222,
              "2026-03-10": 3786.065865,
              "2026-03-11": 109.64254388888888,
              "2026-03-12": 1453.130307222222,
              "2026-03-13": 94.22477083333337,
              "2026-03-15": 39.66556027777778,
              "2026-03-16": 899.9265066666668,
              "2026-03-17": 2152.0867377777777,
              "2026-03-18": 2258.673289444445,
              "2026-03-19": 916.4283263888888,
              "2026-03-20": 18265.526158888893,
              "2026-03-23": 829.8522761111111,
              "2026-03-24": 812.3060675,
              "2026-03-25": 2465.602445,
              "2026-03-26": 1817.320341388889,
              "2026-03-27": 73.76737333333334,
              "2026-03-30": 2352.9256530555554,
              "2026-03-31": 249.3140122222222,
              "2026-04-01": 770.7209130555555,
              "2026-04-02": 52.165303333333334,
              "2026-04-06": 416.7104766666667,
              "2026-04-07": 2342.2446241666667,
              "2026-04-08": 724.7797691666666,
              "2026-04-09": 705.3525777777777,
              "2026-04-10": 593.0516361111112,
              "2026-04-13": 3316.809195833332,
              "2026-04-14": 1403.9237727777777,
              "2026-04-15": 383.5829894444445,
              "2026-04-16": 206.7344427777778,
              "2026-04-17": 1258.4747916666665,
              "2026-04-20": 584.7715150000002,
              "2026-04-21": 128.34479305555556,
              "2026-04-22": 33229.475340277786,
              "2026-04-23": 30077.611573888888,
              "2026-04-24": 113.14097361111111,
              "2026-04-27": 836.9738355555556,
              "2026-04-28": 1607.3620036111108,
              "2026-04-29": 935.2631283333334,
              "2026-04-30": 3966.025183888889,
              "2026-05-02": 64.25406,
              "2026-05-04": 16414.42048472222,
              "2026-05-05": 33.7320225,
              "2026-05-06": 202.56242333333333,
              "2026-05-07": 51.269512500000005,
              "2026-05-08": 3442.991360555555,
              "2026-05-11": 144.0852372222222,
              "2026-05-12": 4.769479444444444,
              "2026-05-13": 357.8979591666667,
              "2026-05-14": 438.46230277777784,
              "2026-05-15": 300.18684722222224,
              "2026-05-16": 29.643955833333333,
              "2026-05-17": 192.58819499999998,
              "2026-05-18": 1704.6458044444444,
              "2026-05-19": 2244.0721127777774,
              "2026-05-20": 26.551808333333334,
              "2026-05-21": 198.1007383333333,
              "2026-05-22": 310.86982611111114,
              "2026-05-25": 190.19837166666665,
              "2026-05-26": 9017.187278055553,
              "2026-05-27": 240.18481972222224,
              "2026-05-28": 3490.2167358333336,
              "2026-05-29": 76.32945805555555,
              "2026-06-01": 523.6617536111111,
              "2026-06-02": 349.96520833333335,
              "2026-06-03": 2316.1009125,
              "2026-06-05": 103.11260055555556,
              "2026-06-08": 513.5392377777778
            },
            "time_count_per_day": {
              "2025-09-30": 10,
              "2025-10-01": 3,
              "2025-10-02": 2,
              "2025-10-03": 1,
              "2025-10-06": 2,
              "2025-10-07": 8,
              "2025-10-08": 9,
              "2025-10-09": 7,
              "2025-10-10": 7,
              "2025-10-13": 1,
              "2025-10-14": 2,
              "2025-10-15": 6,
              "2025-10-16": 1,
              "2025-10-17": 3,
              "2025-10-20": 3,
              "2025-10-21": 7,
              "2025-10-22": 9,
              "2025-10-23": 6,
              "2025-10-24": 8,
              "2025-10-25": 1,
              "2025-10-27": 6,
              "2025-10-28": 17,
              "2025-10-29": 1,
              "2025-10-30": 6,
              "2025-10-31": 3,
              "2025-11-03": 14,
              "2025-11-04": 3,
              "2025-11-05": 9,
              "2025-11-06": 14,
              "2025-11-07": 5,
              "2025-11-08": 2,
              "2025-11-09": 1,
              "2025-11-10": 5,
              "2025-11-11": 3,
              "2025-11-12": 6,
              "2025-11-13": 10,
              "2025-11-14": 16,
              "2025-11-16": 1,
              "2025-11-18": 14,
              "2025-11-19": 20,
              "2025-11-20": 3,
              "2025-11-21": 12,
              "2025-11-24": 18,
              "2025-11-25": 14,
              "2025-11-26": 9,
              "2025-11-27": 10,
              "2025-11-28": 18,
              "2025-11-29": 3,
              "2025-12-02": 14,
              "2025-12-03": 10,
              "2025-12-04": 11,
              "2025-12-05": 12,
              "2025-12-09": 8,
              "2025-12-10": 10,
              "2025-12-11": 8,
              "2025-12-12": 17,
              "2025-12-13": 1,
              "2025-12-15": 16,
              "2025-12-16": 10,
              "2025-12-18": 2,
              "2025-12-22": 6,
              "2025-12-26": 3,
              "2025-12-29": 2,
              "2025-12-30": 2,
              "2025-12-31": 2,
              "2026-01-02": 9,
              "2026-01-05": 4,
              "2026-01-06": 2,
              "2026-01-07": 21,
              "2026-01-08": 6,
              "2026-01-09": 9,
              "2026-01-12": 3,
              "2026-01-13": 20,
              "2026-01-14": 7,
              "2026-01-15": 30,
              "2026-01-16": 18,
              "2026-01-17": 2,
              "2026-01-18": 8,
              "2026-01-19": 12,
              "2026-01-20": 8,
              "2026-01-21": 3,
              "2026-01-22": 1,
              "2026-01-23": 9,
              "2026-01-26": 8,
              "2026-01-27": 9,
              "2026-01-28": 4,
              "2026-01-29": 14,
              "2026-01-30": 24,
              "2026-02-02": 4,
              "2026-02-03": 40,
              "2026-02-04": 22,
              "2026-02-05": 4,
              "2026-02-06": 6,
              "2026-02-07": 2,
              "2026-02-09": 15,
              "2026-02-10": 35,
              "2026-02-11": 1,
              "2026-02-13": 1,
              "2026-02-16": 12,
              "2026-02-17": 22,
              "2026-02-18": 28,
              "2026-02-19": 17,
              "2026-02-20": 22,
              "2026-02-23": 22,
              "2026-02-24": 23,
              "2026-02-25": 22,
              "2026-02-26": 11,
              "2026-02-27": 13,
              "2026-02-28": 14,
              "2026-03-02": 18,
              "2026-03-03": 10,
              "2026-03-04": 31,
              "2026-03-05": 9,
              "2026-03-06": 19,
              "2026-03-07": 11,
              "2026-03-09": 10,
              "2026-03-10": 32,
              "2026-03-11": 7,
              "2026-03-12": 8,
              "2026-03-13": 7,
              "2026-03-15": 1,
              "2026-03-16": 18,
              "2026-03-17": 14,
              "2026-03-18": 33,
              "2026-03-19": 25,
              "2026-03-20": 38,
              "2026-03-23": 17,
              "2026-03-24": 17,
              "2026-03-25": 19,
              "2026-03-26": 11,
              "2026-03-27": 9,
              "2026-03-30": 12,
              "2026-03-31": 11,
              "2026-04-01": 16,
              "2026-04-02": 7,
              "2026-04-06": 14,
              "2026-04-07": 20,
              "2026-04-08": 11,
              "2026-04-09": 10,
              "2026-04-10": 14,
              "2026-04-13": 30,
              "2026-04-14": 15,
              "2026-04-15": 23,
              "2026-04-16": 9,
              "2026-04-17": 16,
              "2026-04-20": 20,
              "2026-04-21": 8,
              "2026-04-22": 38,
              "2026-04-23": 36,
              "2026-04-24": 8,
              "2026-04-27": 26,
              "2026-04-28": 5,
              "2026-04-29": 17,
              "2026-04-30": 17,
              "2026-05-02": 1,
              "2026-05-04": 28,
              "2026-05-05": 11,
              "2026-05-06": 22,
              "2026-05-07": 10,
              "2026-05-08": 12,
              "2026-05-11": 8,
              "2026-05-12": 2,
              "2026-05-13": 20,
              "2026-05-14": 16,
              "2026-05-15": 14,
              "2026-05-16": 1,
              "2026-05-17": 1,
              "2026-05-18": 9,
              "2026-05-19": 10,
              "2026-05-20": 3,
              "2026-05-21": 10,
              "2026-05-22": 5,
              "2026-05-25": 5,
              "2026-05-26": 36,
              "2026-05-27": 23,
              "2026-05-28": 13,
              "2026-05-29": 1,
              "2026-06-01": 8,
              "2026-06-02": 18,
              "2026-06-03": 32,
              "2026-06-05": 20,
              "2026-06-08": 9
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 62.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 29,
              "time_distribution": {
                "0-2h": 29,
                "2-4h": 11,
                "4-6h": 7,
                "6-8h": 6,
                "10-12h": 6,
                "12-14h": 3,
                "14-16h": 9,
                "16-18h": 1,
                "18-20h": 2,
                "20-22h": 4,
                "22-24h": 2,
                "24-26h": 3,
                "26-28h": 2,
                "34-36h": 2,
                "36-38h": 2,
                "40-42h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "58-60h": 1,
                "62-64h": 1,
                "72-74h": 1,
                "92-94h": 1,
                "118-120h": 1,
                "122-124h": 1,
                "132-134h": 1,
                "148-150h": 1,
                "156-158h": 1,
                "162-164h": 2,
                "170-172h": 1,
                "234-236h": 1,
                "240-242h": 1,
                "306-308h": 1,
                "310-312h": 1,
                "344-346h": 1,
                "406-408h": 1,
                "434-436h": 1,
                "468-470h": 1,
                "650-652h": 1,
                "1242-1244h": 1
              },
              "tickets_count": 115,
              "tickets_per_day": {
                "2025-09-30": 4,
                "2025-10-08": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-22": 3,
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-07": 1,
                "2025-11-08": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-03": 2,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-26": 1,
                "2026-01-08": 2,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-03-04": 3,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-26": 1,
                "2026-04-01": 2,
                "2026-04-06": 4,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-13": 2,
                "2026-04-14": 5,
                "2026-04-15": 5,
                "2026-04-16": 1,
                "2026-04-20": 3,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-05": 3,
                "2026-05-06": 4,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-22": 2,
                "2026-05-25": 1,
                "2026-05-26": 6,
                "2026-05-27": 4,
                "2026-05-28": 1,
                "2026-06-01": 2,
                "2026-06-02": 2,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-09-30": 9.050675833333333,
                "2025-10-08": 14.909877222222221,
                "2025-10-10": 93.55738805555556,
                "2025-10-13": 123.30291527777777,
                "2025-10-22": 187.1280436111111,
                "2025-10-23": 59.432022499999995,
                "2025-10-27": 2.995404166666667,
                "2025-10-28": 20.40406861111111,
                "2025-11-04": 5.338383333333334,
                "2025-11-05": 25.560861111111112,
                "2025-11-07": 1.8481505555555555,
                "2025-11-08": 15.103649444444445,
                "2025-11-13": 469.4926302777778,
                "2025-11-14": 0.7499077777777778,
                "2025-11-24": 20.35652,
                "2025-11-27": 0.43700944444444445,
                "2025-12-03": 6.9707825,
                "2025-12-04": 1.669495,
                "2025-12-10": 23.88116861111111,
                "2025-12-12": 24.35603,
                "2025-12-26": 1.3623505555555557,
                "2026-01-08": 893.0433697222222,
                "2026-01-29": 23.1520225,
                "2026-02-03": 311.45288416666665,
                "2026-02-10": 119.56869527777778,
                "2026-02-20": 0.86444,
                "2026-02-27": 27.363500277777778,
                "2026-03-04": 21.693607500000002,
                "2026-03-06": 0.9276636111111111,
                "2026-03-09": 2.353734444444444,
                "2026-03-13": 37.823973888888894,
                "2026-03-16": 3.6321480555555556,
                "2026-03-17": 0.22554249999999998,
                "2026-03-18": 864.4903172222222,
                "2026-03-19": 19.21465611111111,
                "2026-03-20": 360.53000305555554,
                "2026-03-26": 7.627271111111111,
                "2026-04-01": 28.515480555555555,
                "2026-04-06": 94.90337222222222,
                "2026-04-07": 1.3544436111111111,
                "2026-04-08": 171.0420797222222,
                "2026-04-09": 2.7493611111111114,
                "2026-04-13": 2.2019641666666665,
                "2026-04-14": 190.98087055555555,
                "2026-04-15": 24.017150833333332,
                "2026-04-16": 0.6490197222222223,
                "2026-04-20": 44.220904166666664,
                "2026-04-23": 1243.0557030555556,
                "2026-04-24": 3.464617777777778,
                "2026-04-27": 66.44613194444446,
                "2026-04-29": 157.87616500000001,
                "2026-04-30": 3.4188672222222225,
                "2026-05-05": 22.083684166666664,
                "2026-05-06": 89.00785833333333,
                "2026-05-13": 2.7293938888888887,
                "2026-05-14": 4.965616111111111,
                "2026-05-18": 435.8702533333333,
                "2026-05-21": 35.05991527777778,
                "2026-05-22": 257.0750963888889,
                "2026-05-25": 73.19298916666666,
                "2026-05-26": 229.69563833333328,
                "2026-05-27": 76.33453944444446,
                "2026-05-28": 7.195656111111111,
                "2026-06-01": 12.3827125,
                "2026-06-02": 31.642096388888888,
                "2026-06-03": 24.57738666666667
              },
              "time_count_per_day": {
                "2025-09-30": 4,
                "2025-10-08": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-22": 3,
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-07": 1,
                "2025-11-08": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-03": 2,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-26": 1,
                "2026-01-08": 2,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-03-04": 3,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-26": 1,
                "2026-04-01": 2,
                "2026-04-06": 4,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-13": 2,
                "2026-04-14": 5,
                "2026-04-15": 5,
                "2026-04-16": 1,
                "2026-04-20": 3,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-05": 3,
                "2026-05-06": 4,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-22": 2,
                "2026-05-25": 1,
                "2026-05-26": 6,
                "2026-05-27": 4,
                "2026-05-28": 1,
                "2026-06-01": 2,
                "2026-06-02": 2,
                "2026-06-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 121.23,
              "mode_time_hours": 1.0,
              "mode_frequency": 515,
              "time_distribution": {
                "0-2h": 515,
                "2-4h": 166,
                "4-6h": 78,
                "6-8h": 52,
                "8-10h": 20,
                "10-12h": 35,
                "12-14h": 28,
                "14-16h": 32,
                "16-18h": 35,
                "18-20h": 34,
                "20-22h": 21,
                "22-24h": 30,
                "24-26h": 20,
                "26-28h": 12,
                "28-30h": 8,
                "30-32h": 5,
                "32-34h": 13,
                "34-36h": 7,
                "36-38h": 3,
                "38-40h": 8,
                "40-42h": 8,
                "42-44h": 6,
                "44-46h": 10,
                "46-48h": 8,
                "48-50h": 7,
                "50-52h": 12,
                "52-54h": 4,
                "54-56h": 5,
                "56-58h": 3,
                "58-60h": 2,
                "60-62h": 2,
                "62-64h": 6,
                "64-66h": 11,
                "66-68h": 6,
                "68-70h": 3,
                "70-72h": 7,
                "72-74h": 9,
                "74-76h": 5,
                "76-78h": 2,
                "84-86h": 3,
                "86-88h": 4,
                "88-90h": 8,
                "90-92h": 2,
                "92-94h": 2,
                "94-96h": 2,
                "96-98h": 3,
                "98-100h": 2,
                "100-102h": 2,
                "102-104h": 1,
                "106-108h": 1,
                "108-110h": 1,
                "112-114h": 1,
                "114-116h": 4,
                "116-118h": 3,
                "118-120h": 1,
                "120-122h": 3,
                "122-124h": 1,
                "124-126h": 3,
                "128-130h": 1,
                "130-132h": 1,
                "134-136h": 1,
                "138-140h": 7,
                "140-142h": 2,
                "142-144h": 1,
                "144-146h": 3,
                "146-148h": 1,
                "148-150h": 1,
                "152-154h": 1,
                "154-156h": 1,
                "156-158h": 1,
                "158-160h": 1,
                "160-162h": 4,
                "162-164h": 4,
                "164-166h": 3,
                "166-168h": 1,
                "168-170h": 1,
                "180-182h": 1,
                "184-186h": 1,
                "188-190h": 1,
                "190-192h": 4,
                "192-194h": 3,
                "198-200h": 1,
                "200-202h": 2,
                "202-204h": 1,
                "204-206h": 1,
                "210-212h": 2,
                "212-214h": 1,
                "216-218h": 1,
                "220-222h": 1,
                "222-224h": 2,
                "234-236h": 2,
                "236-238h": 1,
                "238-240h": 3,
                "240-242h": 2,
                "246-248h": 1,
                "250-252h": 1,
                "258-260h": 1,
                "260-262h": 2,
                "266-268h": 1,
                "268-270h": 3,
                "278-280h": 1,
                "280-282h": 2,
                "284-286h": 1,
                "286-288h": 4,
                "290-292h": 1,
                "292-294h": 2,
                "294-296h": 1,
                "296-298h": 1,
                "298-300h": 1,
                "302-304h": 1,
                "306-308h": 3,
                "310-312h": 2,
                "312-314h": 1,
                "316-318h": 3,
                "320-322h": 1,
                "330-332h": 2,
                "332-334h": 6,
                "334-336h": 1,
                "336-338h": 1,
                "340-342h": 2,
                "342-344h": 1,
                "356-358h": 1,
                "358-360h": 2,
                "360-362h": 1,
                "362-364h": 2,
                "366-368h": 2,
                "368-370h": 2,
                "372-374h": 1,
                "376-378h": 1,
                "378-380h": 1,
                "380-382h": 1,
                "382-384h": 1,
                "388-390h": 1,
                "398-400h": 1,
                "400-402h": 2,
                "404-406h": 1,
                "406-408h": 2,
                "408-410h": 1,
                "414-416h": 1,
                "424-426h": 1,
                "426-428h": 1,
                "436-438h": 1,
                "444-446h": 1,
                "454-456h": 2,
                "456-458h": 1,
                "470-472h": 1,
                "482-484h": 2,
                "494-496h": 1,
                "496-498h": 4,
                "506-508h": 1,
                "508-510h": 1,
                "512-514h": 1,
                "518-520h": 2,
                "524-526h": 7,
                "526-528h": 2,
                "532-534h": 2,
                "548-550h": 1,
                "550-552h": 1,
                "554-556h": 1,
                "556-558h": 1,
                "560-562h": 1,
                "576-578h": 1,
                "592-594h": 1,
                "600-602h": 1,
                "624-626h": 1,
                "642-644h": 1,
                "656-658h": 1,
                "660-662h": 1,
                "666-668h": 2,
                "668-670h": 2,
                "672-674h": 1,
                "700-702h": 1,
                "704-706h": 1,
                "722-724h": 1,
                "724-726h": 1,
                "734-736h": 1,
                "738-740h": 1,
                "742-744h": 1,
                "744-746h": 1,
                "746-748h": 1,
                "748-750h": 1,
                "766-768h": 1,
                "772-774h": 1,
                "786-788h": 1,
                "792-794h": 1,
                "808-810h": 1,
                "810-812h": 1,
                "820-822h": 1,
                "838-840h": 1,
                "840-842h": 2,
                "842-844h": 3,
                "860-862h": 1,
                "862-864h": 1,
                "870-872h": 1,
                "890-892h": 2,
                "892-894h": 2,
                "934-936h": 1,
                "984-986h": 2,
                "1000-1002h": 3,
                "1012-1014h": 1,
                "1024-1026h": 1,
                "1038-1040h": 1,
                "1050-1052h": 1,
                "1052-1054h": 1,
                "1054-1056h": 1,
                "1058-1060h": 1,
                "1070-1072h": 1,
                "1076-1078h": 1,
                "1078-1080h": 1,
                "1100-1102h": 1,
                "1104-1106h": 1,
                "1122-1124h": 1,
                "1124-1126h": 1,
                "1142-1144h": 1,
                "1152-1154h": 1,
                "1166-1168h": 1,
                "1174-1176h": 1,
                "1176-1178h": 1,
                "1178-1180h": 1,
                "1196-1198h": 1,
                "1198-1200h": 1,
                "1200-1202h": 1,
                "1216-1218h": 1,
                "1242-1244h": 1,
                "1244-1246h": 1,
                "1248-1250h": 2,
                "1314-1316h": 1,
                "1316-1318h": 1,
                "1320-1322h": 1,
                "1338-1340h": 1,
                "1340-1342h": 1,
                "1360-1362h": 1,
                "1362-1364h": 1,
                "1416-1418h": 1,
                "1454-1456h": 1,
                "1460-1462h": 1,
                "1482-1484h": 1,
                "1506-1508h": 1,
                "1514-1516h": 1,
                "1532-1534h": 2,
                "1546-1548h": 1,
                "1562-1564h": 1,
                "1584-1586h": 1,
                "1620-1622h": 1,
                "1622-1624h": 1,
                "1728-1730h": 1,
                "1770-1772h": 1,
                "2158-2160h": 1,
                "3002-3004h": 3,
                "3554-3556h": 1
              },
              "tickets_count": 1560,
              "tickets_per_day": {
                "2025-09-30": 2,
                "2025-10-01": 3,
                "2025-10-02": 1,
                "2025-10-06": 1,
                "2025-10-07": 5,
                "2025-10-08": 1,
                "2025-10-09": 2,
                "2025-10-10": 3,
                "2025-10-15": 1,
                "2025-10-20": 3,
                "2025-10-21": 3,
                "2025-10-22": 6,
                "2025-10-23": 3,
                "2025-10-24": 3,
                "2025-10-27": 4,
                "2025-10-28": 13,
                "2025-10-29": 1,
                "2025-10-30": 5,
                "2025-10-31": 3,
                "2025-11-03": 4,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 4,
                "2025-11-08": 1,
                "2025-11-09": 1,
                "2025-11-10": 4,
                "2025-11-11": 1,
                "2025-11-12": 3,
                "2025-11-13": 5,
                "2025-11-14": 4,
                "2025-11-18": 4,
                "2025-11-19": 6,
                "2025-11-20": 1,
                "2025-11-21": 6,
                "2025-11-24": 12,
                "2025-11-25": 7,
                "2025-11-26": 6,
                "2025-11-27": 2,
                "2025-11-28": 13,
                "2025-12-02": 4,
                "2025-12-03": 4,
                "2025-12-04": 2,
                "2025-12-05": 1,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-11": 2,
                "2025-12-12": 8,
                "2025-12-13": 1,
                "2025-12-15": 9,
                "2025-12-16": 5,
                "2025-12-22": 1,
                "2025-12-29": 2,
                "2025-12-30": 2,
                "2025-12-31": 2,
                "2026-01-02": 5,
                "2026-01-05": 3,
                "2026-01-06": 2,
                "2026-01-07": 16,
                "2026-01-08": 4,
                "2026-01-09": 7,
                "2026-01-12": 2,
                "2026-01-13": 5,
                "2026-01-14": 3,
                "2026-01-15": 23,
                "2026-01-16": 16,
                "2026-01-19": 9,
                "2026-01-20": 4,
                "2026-01-21": 3,
                "2026-01-23": 7,
                "2026-01-26": 3,
                "2026-01-27": 9,
                "2026-01-28": 1,
                "2026-01-29": 9,
                "2026-01-30": 22,
                "2026-02-02": 3,
                "2026-02-03": 13,
                "2026-02-04": 10,
                "2026-02-06": 4,
                "2026-02-09": 4,
                "2026-02-10": 20,
                "2026-02-11": 1,
                "2026-02-16": 10,
                "2026-02-17": 12,
                "2026-02-18": 24,
                "2026-02-19": 9,
                "2026-02-20": 18,
                "2026-02-23": 21,
                "2026-02-24": 18,
                "2026-02-25": 19,
                "2026-02-26": 11,
                "2026-02-27": 12,
                "2026-02-28": 13,
                "2026-03-02": 17,
                "2026-03-03": 10,
                "2026-03-04": 21,
                "2026-03-05": 9,
                "2026-03-06": 18,
                "2026-03-07": 10,
                "2026-03-09": 9,
                "2026-03-10": 31,
                "2026-03-11": 7,
                "2026-03-12": 7,
                "2026-03-13": 6,
                "2026-03-15": 1,
                "2026-03-16": 17,
                "2026-03-17": 12,
                "2026-03-18": 25,
                "2026-03-19": 24,
                "2026-03-20": 32,
                "2026-03-23": 17,
                "2026-03-24": 17,
                "2026-03-25": 19,
                "2026-03-26": 10,
                "2026-03-27": 9,
                "2026-03-30": 11,
                "2026-03-31": 11,
                "2026-04-01": 14,
                "2026-04-02": 7,
                "2026-04-06": 10,
                "2026-04-07": 18,
                "2026-04-08": 10,
                "2026-04-09": 8,
                "2026-04-10": 13,
                "2026-04-13": 28,
                "2026-04-14": 10,
                "2026-04-15": 18,
                "2026-04-16": 8,
                "2026-04-17": 16,
                "2026-04-20": 16,
                "2026-04-21": 7,
                "2026-04-22": 37,
                "2026-04-23": 33,
                "2026-04-24": 7,
                "2026-04-27": 23,
                "2026-04-28": 5,
                "2026-04-29": 16,
                "2026-04-30": 16,
                "2026-05-02": 1,
                "2026-05-04": 26,
                "2026-05-05": 8,
                "2026-05-06": 18,
                "2026-05-07": 10,
                "2026-05-08": 12,
                "2026-05-11": 8,
                "2026-05-12": 2,
                "2026-05-13": 19,
                "2026-05-14": 15,
                "2026-05-15": 14,
                "2026-05-16": 1,
                "2026-05-17": 1,
                "2026-05-18": 8,
                "2026-05-19": 10,
                "2026-05-20": 3,
                "2026-05-21": 9,
                "2026-05-22": 3,
                "2026-05-25": 4,
                "2026-05-26": 30,
                "2026-05-27": 19,
                "2026-05-28": 12,
                "2026-05-29": 1,
                "2026-06-01": 6,
                "2026-06-02": 16,
                "2026-06-03": 31,
                "2026-06-05": 20,
                "2026-06-08": 9
              },
              "time_per_day": {
                "2025-09-30": 0.21541500000000002,
                "2025-10-01": 35.063807777777775,
                "2025-10-02": 0.14305944444444443,
                "2025-10-06": 88.2338486111111,
                "2025-10-07": 15.106628333333335,
                "2025-10-08": 0.11517916666666667,
                "2025-10-09": 119.12701166666668,
                "2025-10-10": 70.20883472222222,
                "2025-10-15": 334.0021116666667,
                "2025-10-20": 276.3484025,
                "2025-10-21": 74.386865,
                "2025-10-22": 496.0355819444444,
                "2025-10-23": 172.71635666666666,
                "2025-10-24": 110.26280416666667,
                "2025-10-27": 80.6878386111111,
                "2025-10-28": 886.6988933333333,
                "2025-10-29": 1.4241794444444444,
                "2025-10-30": 156.03489916666666,
                "2025-10-31": 345.1623177777778,
                "2025-11-03": 117.39292861111112,
                "2025-11-04": 2.6465638888888887,
                "2025-11-05": 252.77630138888887,
                "2025-11-06": 320.3256944444445,
                "2025-11-08": 2.7794069444444442,
                "2025-11-09": 41.51824638888889,
                "2025-11-10": 5.1309636111111105,
                "2025-11-11": 3.316819722222222,
                "2025-11-12": 20.720672222222223,
                "2025-11-13": 314.88291861111117,
                "2025-11-14": 20.569830277777776,
                "2025-11-18": 646.9058022222222,
                "2025-11-19": 10.438888055555555,
                "2025-11-20": 10.361776388888888,
                "2025-11-21": 6.727173333333334,
                "2025-11-24": 228.71425416666668,
                "2025-11-25": 10.163039722222223,
                "2025-11-26": 23.011903888888888,
                "2025-11-27": 0.7876416666666666,
                "2025-11-28": 307.2674597222222,
                "2025-12-02": 182.98775750000001,
                "2025-12-03": 8.989055,
                "2025-12-04": 207.06527444444444,
                "2025-12-05": 592.3053,
                "2025-12-09": 291.71187722222226,
                "2025-12-10": 139.67406305555556,
                "2025-12-11": 17.814955,
                "2025-12-12": 1661.6262591666666,
                "2025-12-13": 27.688504444444444,
                "2025-12-15": 343.4534330555555,
                "2025-12-16": 985.7881386111111,
                "2025-12-22": 47.64007583333333,
                "2025-12-29": 455.474,
                "2025-12-30": 1.3789041666666666,
                "2025-12-31": 1.5147458333333335,
                "2026-01-02": 291.4872847222222,
                "2026-01-05": 202.18298,
                "2026-01-06": 31.783673055555553,
                "2026-01-07": 3943.2398355555556,
                "2026-01-08": 44.60664472222223,
                "2026-01-09": 888.7340208333333,
                "2026-01-12": 67.45101166666666,
                "2026-01-13": 129.78827222222222,
                "2026-01-14": 22.149330555555554,
                "2026-01-15": 2006.4108569444447,
                "2026-01-16": 48.24238472222221,
                "2026-01-19": 430.85222416666676,
                "2026-01-20": 314.32611944444443,
                "2026-01-21": 309.3017127777778,
                "2026-01-23": 47.79236861111111,
                "2026-01-26": 13.139311111111112,
                "2026-01-27": 28.45615277777778,
                "2026-01-28": 0.4589347222222222,
                "2026-01-29": 256.9772413888889,
                "2026-01-30": 431.60133361111104,
                "2026-02-02": 77.08788611111112,
                "2026-02-03": 6409.786090555556,
                "2026-02-04": 43.77285833333333,
                "2026-02-06": 79.73436472222222,
                "2026-02-09": 263.114645,
                "2026-02-10": 8669.576549722222,
                "2026-02-11": 3.433265833333333,
                "2026-02-16": 127.00441611111111,
                "2026-02-17": 2907.3842494444452,
                "2026-02-18": 198.80633166666664,
                "2026-02-19": 47.74764944444445,
                "2026-02-20": 298.4642847222222,
                "2026-02-23": 1283.4868869444447,
                "2026-02-24": 77.23807277777775,
                "2026-02-25": 163.2733041666666,
                "2026-02-26": 74.26577666666668,
                "2026-02-27": 201.34225277777776,
                "2026-02-28": 45.2848625,
                "2026-03-02": 536.0857811111109,
                "2026-03-03": 949.6753086111112,
                "2026-03-04": 451.4786247222222,
                "2026-03-05": 244.39238250000002,
                "2026-03-06": 494.35531861111104,
                "2026-03-07": 342.67716416666667,
                "2026-03-09": 30.310682777777778,
                "2026-03-10": 3127.550300833333,
                "2026-03-11": 109.64254388888888,
                "2026-03-12": 62.250895,
                "2026-03-13": 56.400796944444444,
                "2026-03-15": 39.66556027777778,
                "2026-03-16": 896.2943586111112,
                "2026-03-17": 119.14490416666666,
                "2026-03-18": 1112.4451713888893,
                "2026-03-19": 897.2136702777776,
                "2026-03-20": 14918.115485277778,
                "2026-03-23": 829.8522761111111,
                "2026-03-24": 812.3060675,
                "2026-03-25": 2465.602445,
                "2026-03-26": 1809.6930702777777,
                "2026-03-27": 73.76737333333334,
                "2026-03-30": 2012.3805155555551,
                "2026-03-31": 249.3140122222222,
                "2026-04-01": 742.2054324999999,
                "2026-04-02": 52.165303333333334,
                "2026-04-06": 321.80710444444446,
                "2026-04-07": 324.7814469444444,
                "2026-04-08": 553.7376894444443,
                "2026-04-09": 699.5547991666666,
                "2026-04-10": 545.7366366666666,
                "2026-04-13": 3314.6072316666655,
                "2026-04-14": 1212.942902222222,
                "2026-04-15": 359.56583861111113,
                "2026-04-16": 206.08542305555557,
                "2026-04-17": 1258.4747916666665,
                "2026-04-20": 158.73251722222219,
                "2026-04-21": 111.36156,
                "2026-04-22": 32868.52243638889,
                "2026-04-23": 25209.43742888889,
                "2026-04-24": 109.67635583333333,
                "2026-04-27": 770.5277036111112,
                "2026-04-28": 1607.3620036111108,
                "2026-04-29": 777.3869633333334,
                "2026-04-30": 3962.6063166666668,
                "2026-05-02": 64.25406,
                "2026-05-04": 14997.427743055552,
                "2026-05-05": 11.648338333333331,
                "2026-05-06": 113.55456500000001,
                "2026-05-07": 51.269512500000005,
                "2026-05-08": 3442.991360555555,
                "2026-05-11": 144.0852372222222,
                "2026-05-12": 4.769479444444444,
                "2026-05-13": 355.1685652777778,
                "2026-05-14": 433.49668666666673,
                "2026-05-15": 300.18684722222224,
                "2026-05-16": 29.643955833333333,
                "2026-05-17": 192.58819499999998,
                "2026-05-18": 1268.775551111111,
                "2026-05-19": 2244.0721127777774,
                "2026-05-20": 26.551808333333334,
                "2026-05-21": 163.04082305555553,
                "2026-05-22": 53.79472972222222,
                "2026-05-25": 117.00538250000001,
                "2026-05-26": 8787.49163972222,
                "2026-05-27": 163.8502802777778,
                "2026-05-28": 3483.0210797222226,
                "2026-05-29": 76.32945805555555,
                "2026-06-01": 511.2790411111111,
                "2026-06-02": 318.32311194444446,
                "2026-06-03": 2291.523525833333,
                "2026-06-05": 103.11260055555556,
                "2026-06-08": 513.5392377777778
              },
              "time_count_per_day": {
                "2025-09-30": 2,
                "2025-10-01": 3,
                "2025-10-02": 1,
                "2025-10-06": 1,
                "2025-10-07": 5,
                "2025-10-08": 1,
                "2025-10-09": 2,
                "2025-10-10": 3,
                "2025-10-15": 1,
                "2025-10-20": 3,
                "2025-10-21": 3,
                "2025-10-22": 6,
                "2025-10-23": 3,
                "2025-10-24": 3,
                "2025-10-27": 4,
                "2025-10-28": 13,
                "2025-10-29": 1,
                "2025-10-30": 5,
                "2025-10-31": 3,
                "2025-11-03": 4,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 4,
                "2025-11-08": 1,
                "2025-11-09": 1,
                "2025-11-10": 4,
                "2025-11-11": 1,
                "2025-11-12": 3,
                "2025-11-13": 5,
                "2025-11-14": 4,
                "2025-11-18": 4,
                "2025-11-19": 6,
                "2025-11-20": 1,
                "2025-11-21": 6,
                "2025-11-24": 12,
                "2025-11-25": 7,
                "2025-11-26": 6,
                "2025-11-27": 2,
                "2025-11-28": 13,
                "2025-12-02": 4,
                "2025-12-03": 4,
                "2025-12-04": 2,
                "2025-12-05": 1,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-11": 2,
                "2025-12-12": 8,
                "2025-12-13": 1,
                "2025-12-15": 9,
                "2025-12-16": 5,
                "2025-12-22": 1,
                "2025-12-29": 2,
                "2025-12-30": 2,
                "2025-12-31": 2,
                "2026-01-02": 5,
                "2026-01-05": 3,
                "2026-01-06": 2,
                "2026-01-07": 16,
                "2026-01-08": 4,
                "2026-01-09": 7,
                "2026-01-12": 2,
                "2026-01-13": 5,
                "2026-01-14": 3,
                "2026-01-15": 23,
                "2026-01-16": 16,
                "2026-01-19": 9,
                "2026-01-20": 4,
                "2026-01-21": 3,
                "2026-01-23": 7,
                "2026-01-26": 3,
                "2026-01-27": 9,
                "2026-01-28": 1,
                "2026-01-29": 9,
                "2026-01-30": 22,
                "2026-02-02": 3,
                "2026-02-03": 13,
                "2026-02-04": 10,
                "2026-02-06": 4,
                "2026-02-09": 4,
                "2026-02-10": 20,
                "2026-02-11": 1,
                "2026-02-16": 10,
                "2026-02-17": 12,
                "2026-02-18": 24,
                "2026-02-19": 9,
                "2026-02-20": 18,
                "2026-02-23": 21,
                "2026-02-24": 18,
                "2026-02-25": 19,
                "2026-02-26": 11,
                "2026-02-27": 12,
                "2026-02-28": 13,
                "2026-03-02": 17,
                "2026-03-03": 10,
                "2026-03-04": 21,
                "2026-03-05": 9,
                "2026-03-06": 18,
                "2026-03-07": 10,
                "2026-03-09": 9,
                "2026-03-10": 31,
                "2026-03-11": 7,
                "2026-03-12": 7,
                "2026-03-13": 6,
                "2026-03-15": 1,
                "2026-03-16": 17,
                "2026-03-17": 12,
                "2026-03-18": 25,
                "2026-03-19": 24,
                "2026-03-20": 32,
                "2026-03-23": 17,
                "2026-03-24": 17,
                "2026-03-25": 19,
                "2026-03-26": 10,
                "2026-03-27": 9,
                "2026-03-30": 11,
                "2026-03-31": 11,
                "2026-04-01": 14,
                "2026-04-02": 7,
                "2026-04-06": 10,
                "2026-04-07": 18,
                "2026-04-08": 10,
                "2026-04-09": 8,
                "2026-04-10": 13,
                "2026-04-13": 28,
                "2026-04-14": 10,
                "2026-04-15": 18,
                "2026-04-16": 8,
                "2026-04-17": 16,
                "2026-04-20": 16,
                "2026-04-21": 7,
                "2026-04-22": 37,
                "2026-04-23": 33,
                "2026-04-24": 7,
                "2026-04-27": 23,
                "2026-04-28": 5,
                "2026-04-29": 16,
                "2026-04-30": 16,
                "2026-05-02": 1,
                "2026-05-04": 26,
                "2026-05-05": 8,
                "2026-05-06": 18,
                "2026-05-07": 10,
                "2026-05-08": 12,
                "2026-05-11": 8,
                "2026-05-12": 2,
                "2026-05-13": 19,
                "2026-05-14": 15,
                "2026-05-15": 14,
                "2026-05-16": 1,
                "2026-05-17": 1,
                "2026-05-18": 8,
                "2026-05-19": 10,
                "2026-05-20": 3,
                "2026-05-21": 9,
                "2026-05-22": 3,
                "2026-05-25": 4,
                "2026-05-26": 30,
                "2026-05-27": 19,
                "2026-05-28": 12,
                "2026-05-29": 1,
                "2026-06-01": 6,
                "2026-06-02": 16,
                "2026-06-03": 31,
                "2026-06-05": 20,
                "2026-06-08": 9
              }
            },
            "P3": {
              "avg_time_hours": 179.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 76,
              "time_distribution": {
                "0-2h": 76,
                "2-4h": 32,
                "4-6h": 27,
                "6-8h": 7,
                "8-10h": 9,
                "10-12h": 2,
                "12-14h": 11,
                "14-16h": 7,
                "16-18h": 3,
                "18-20h": 9,
                "20-22h": 5,
                "22-24h": 5,
                "24-26h": 9,
                "26-28h": 3,
                "28-30h": 1,
                "32-34h": 1,
                "34-36h": 1,
                "40-42h": 1,
                "42-44h": 4,
                "46-48h": 3,
                "48-50h": 1,
                "50-52h": 1,
                "52-54h": 2,
                "54-56h": 2,
                "60-62h": 2,
                "64-66h": 3,
                "70-72h": 1,
                "72-74h": 2,
                "74-76h": 2,
                "76-78h": 1,
                "78-80h": 2,
                "84-86h": 1,
                "92-94h": 1,
                "94-96h": 2,
                "96-98h": 4,
                "100-102h": 1,
                "102-104h": 1,
                "104-106h": 1,
                "108-110h": 1,
                "114-116h": 1,
                "118-120h": 3,
                "122-124h": 2,
                "124-126h": 1,
                "128-130h": 1,
                "136-138h": 2,
                "138-140h": 1,
                "140-142h": 3,
                "142-144h": 1,
                "144-146h": 3,
                "146-148h": 1,
                "150-152h": 1,
                "152-154h": 1,
                "158-160h": 1,
                "160-162h": 1,
                "164-166h": 1,
                "166-168h": 2,
                "168-170h": 2,
                "170-172h": 1,
                "172-174h": 2,
                "184-186h": 1,
                "186-188h": 1,
                "190-192h": 3,
                "194-196h": 1,
                "196-198h": 1,
                "198-200h": 1,
                "210-212h": 1,
                "214-216h": 1,
                "216-218h": 1,
                "218-220h": 1,
                "224-226h": 1,
                "230-232h": 1,
                "232-234h": 1,
                "236-238h": 2,
                "242-244h": 1,
                "244-246h": 1,
                "252-254h": 1,
                "260-262h": 1,
                "262-264h": 1,
                "270-272h": 1,
                "272-274h": 1,
                "280-282h": 1,
                "282-284h": 1,
                "304-306h": 1,
                "308-310h": 2,
                "314-316h": 1,
                "316-318h": 1,
                "320-322h": 1,
                "328-330h": 1,
                "336-338h": 1,
                "338-340h": 2,
                "356-358h": 1,
                "358-360h": 1,
                "360-362h": 1,
                "364-366h": 1,
                "368-370h": 1,
                "376-378h": 1,
                "380-382h": 1,
                "386-388h": 1,
                "388-390h": 1,
                "410-412h": 1,
                "414-416h": 1,
                "424-426h": 2,
                "436-438h": 1,
                "446-448h": 1,
                "454-456h": 1,
                "460-462h": 1,
                "482-484h": 1,
                "498-500h": 1,
                "500-502h": 2,
                "514-516h": 1,
                "526-528h": 1,
                "534-536h": 1,
                "536-538h": 1,
                "548-550h": 1,
                "572-574h": 1,
                "574-576h": 1,
                "600-602h": 1,
                "614-616h": 1,
                "618-620h": 1,
                "628-630h": 1,
                "658-660h": 1,
                "670-672h": 1,
                "678-680h": 1,
                "680-682h": 2,
                "694-696h": 1,
                "700-702h": 1,
                "720-722h": 1,
                "736-738h": 1,
                "758-760h": 1,
                "814-816h": 1,
                "820-822h": 3,
                "860-862h": 1,
                "866-868h": 1,
                "1060-1062h": 1,
                "1178-1180h": 1,
                "1238-1240h": 1,
                "1250-1252h": 1,
                "1362-1364h": 1,
                "1390-1392h": 1,
                "1506-1508h": 1,
                "1752-1754h": 1,
                "1778-1780h": 1,
                "1844-1846h": 1,
                "1872-1874h": 1,
                "2016-2018h": 1,
                "2032-2034h": 1,
                "2212-2214h": 1
              },
              "tickets_count": 376,
              "tickets_per_day": {
                "2025-09-30": 4,
                "2025-10-02": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 3,
                "2025-10-08": 7,
                "2025-10-09": 5,
                "2025-10-10": 3,
                "2025-10-14": 2,
                "2025-10-15": 5,
                "2025-10-16": 1,
                "2025-10-17": 3,
                "2025-10-21": 3,
                "2025-10-23": 1,
                "2025-10-24": 5,
                "2025-10-27": 1,
                "2025-10-28": 3,
                "2025-10-30": 1,
                "2025-11-03": 10,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 9,
                "2025-11-07": 3,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-13": 4,
                "2025-11-14": 8,
                "2025-11-16": 1,
                "2025-11-18": 9,
                "2025-11-19": 10,
                "2025-11-20": 2,
                "2025-11-21": 6,
                "2025-11-24": 4,
                "2025-11-25": 7,
                "2025-11-26": 3,
                "2025-11-27": 7,
                "2025-11-28": 5,
                "2025-11-29": 1,
                "2025-12-02": 9,
                "2025-12-03": 4,
                "2025-12-04": 5,
                "2025-12-05": 7,
                "2025-12-09": 5,
                "2025-12-10": 7,
                "2025-12-11": 2,
                "2025-12-12": 6,
                "2025-12-15": 6,
                "2025-12-16": 3,
                "2025-12-18": 2,
                "2025-12-22": 5,
                "2025-12-26": 2,
                "2026-01-02": 2,
                "2026-01-05": 1,
                "2026-01-07": 4,
                "2026-01-09": 2,
                "2026-01-12": 1,
                "2026-01-13": 14,
                "2026-01-14": 4,
                "2026-01-15": 6,
                "2026-01-16": 2,
                "2026-01-18": 8,
                "2026-01-19": 3,
                "2026-01-20": 4,
                "2026-01-22": 1,
                "2026-01-23": 2,
                "2026-01-26": 5,
                "2026-01-28": 3,
                "2026-01-29": 4,
                "2026-01-30": 1,
                "2026-02-03": 16,
                "2026-02-04": 3,
                "2026-02-05": 1,
                "2026-02-07": 2,
                "2026-02-09": 11,
                "2026-02-10": 11,
                "2026-02-13": 1,
                "2026-02-16": 2,
                "2026-02-17": 6,
                "2026-02-18": 4,
                "2026-02-19": 4,
                "2026-02-20": 3,
                "2026-02-23": 1,
                "2026-02-24": 5,
                "2026-02-25": 3,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-04": 7,
                "2026-03-07": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 4,
                "2026-04-07": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 2
              },
              "time_per_day": {
                "2025-09-30": 5.489487777777779,
                "2025-10-02": 19.914869166666666,
                "2025-10-03": 42.59790194444444,
                "2025-10-06": 6.672649722222222,
                "2025-10-07": 243.11860416666667,
                "2025-10-08": 35.812764722222234,
                "2025-10-09": 603.420205,
                "2025-10-10": 268.92412916666666,
                "2025-10-14": 470.5076261111111,
                "2025-10-15": 201.6675775,
                "2025-10-16": 20.367943333333336,
                "2025-10-17": 266.111235,
                "2025-10-21": 616.4316511111111,
                "2025-10-23": 233.7853338888889,
                "2025-10-24": 413.6799455555555,
                "2025-10-27": 164.94374638888888,
                "2025-10-28": 417.17864888888886,
                "2025-10-30": 46.66518722222222,
                "2025-11-03": 708.9117936111112,
                "2025-11-04": 1.1331905555555555,
                "2025-11-05": 383.5256216666667,
                "2025-11-06": 215.58570500000002,
                "2025-11-07": 274.33866222222224,
                "2025-11-11": 21.92054638888889,
                "2025-11-12": 59.958599444444445,
                "2025-11-13": 324.5959977777778,
                "2025-11-14": 117.86029583333332,
                "2025-11-16": 253.38371305555555,
                "2025-11-18": 1510.439731111111,
                "2025-11-19": 2203.3821408333333,
                "2025-11-20": 41.64366916666667,
                "2025-11-21": 636.7588722222222,
                "2025-11-24": 209.9088888888889,
                "2025-11-25": 8.137994166666667,
                "2025-11-26": 2013.7671313888889,
                "2025-11-27": 1404.3035897222221,
                "2025-11-28": 750.1141483333333,
                "2025-11-29": 123.85818388888889,
                "2025-12-02": 679.2828591666668,
                "2025-12-03": 225.86626388888885,
                "2025-12-04": 11.375973055555555,
                "2025-12-05": 6.894056944444445,
                "2025-12-09": 270.3815097222222,
                "2025-12-10": 1073.2676594444445,
                "2025-12-11": 19.43295777777778,
                "2025-12-12": 2225.8501133333334,
                "2025-12-15": 1390.7054316666668,
                "2025-12-16": 601.9666575,
                "2025-12-18": 10.837394166666666,
                "2025-12-22": 84.30288499999999,
                "2025-12-26": 8.743221666666667,
                "2026-01-02": 1033.0062691666667,
                "2026-01-05": 6.458349444444445,
                "2026-01-07": 1405.8122719444443,
                "2026-01-09": 725.7724380555555,
                "2026-01-12": 160.96238555555556,
                "2026-01-13": 54.99690666666667,
                "2026-01-14": 20.074207777777776,
                "2026-01-15": 270.3137530555556,
                "2026-01-16": 3.823486388888889,
                "2026-01-18": 107.7343877777778,
                "2026-01-19": 48.268590277777776,
                "2026-01-20": 64.46295944444444,
                "2026-01-22": 4.0281633333333335,
                "2026-01-23": 6.58996111111111,
                "2026-01-26": 178.98467111111108,
                "2026-01-28": 20.198445555555555,
                "2026-01-29": 90.00869694444445,
                "2026-01-30": 10.090999444444444,
                "2026-02-03": 4914.253681944444,
                "2026-02-04": 590.5203880555556,
                "2026-02-05": 173.83352694444446,
                "2026-02-07": 122.51177861111111,
                "2026-02-09": 353.9863275,
                "2026-02-10": 6309.947674722222,
                "2026-02-13": 758.5593352777778,
                "2026-02-16": 733.5090997222222,
                "2026-02-17": 4589.894079166667,
                "2026-02-18": 4048.2863355555555,
                "2026-02-19": 1452.800416666667,
                "2026-02-20": 1909.6247563888887,
                "2026-02-23": 308.14055583333334,
                "2026-02-24": 6.951343888888889,
                "2026-02-25": 57.76767833333333,
                "2026-02-28": 43.23732277777778,
                "2026-03-02": 1506.4725369444445,
                "2026-03-04": 9.382637222222222,
                "2026-03-07": 49.85104638888889,
                "2026-03-10": 658.5155641666666,
                "2026-03-12": 1390.879412222222,
                "2026-03-17": 2032.716291111111,
                "2026-03-18": 281.7378008333333,
                "2026-03-20": 2986.8806705555558,
                "2026-04-07": 2016.1087336111111,
                "2026-04-09": 3.0484175,
                "2026-04-10": 47.31499944444444,
                "2026-04-21": 16.983233055555555,
                "2026-04-22": 360.95290388888884,
                "2026-04-23": 3625.1184419444444
              },
              "time_count_per_day": {
                "2025-09-30": 4,
                "2025-10-02": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 3,
                "2025-10-08": 7,
                "2025-10-09": 5,
                "2025-10-10": 3,
                "2025-10-14": 2,
                "2025-10-15": 5,
                "2025-10-16": 1,
                "2025-10-17": 3,
                "2025-10-21": 3,
                "2025-10-23": 1,
                "2025-10-24": 5,
                "2025-10-27": 1,
                "2025-10-28": 3,
                "2025-10-30": 1,
                "2025-11-03": 10,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 9,
                "2025-11-07": 3,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-13": 4,
                "2025-11-14": 8,
                "2025-11-16": 1,
                "2025-11-18": 9,
                "2025-11-19": 10,
                "2025-11-20": 2,
                "2025-11-21": 6,
                "2025-11-24": 4,
                "2025-11-25": 7,
                "2025-11-26": 3,
                "2025-11-27": 7,
                "2025-11-28": 5,
                "2025-11-29": 1,
                "2025-12-02": 9,
                "2025-12-03": 4,
                "2025-12-04": 5,
                "2025-12-05": 7,
                "2025-12-09": 5,
                "2025-12-10": 7,
                "2025-12-11": 2,
                "2025-12-12": 6,
                "2025-12-15": 6,
                "2025-12-16": 3,
                "2025-12-18": 2,
                "2025-12-22": 5,
                "2025-12-26": 2,
                "2026-01-02": 2,
                "2026-01-05": 1,
                "2026-01-07": 4,
                "2026-01-09": 2,
                "2026-01-12": 1,
                "2026-01-13": 14,
                "2026-01-14": 4,
                "2026-01-15": 6,
                "2026-01-16": 2,
                "2026-01-18": 8,
                "2026-01-19": 3,
                "2026-01-20": 4,
                "2026-01-22": 1,
                "2026-01-23": 2,
                "2026-01-26": 5,
                "2026-01-28": 3,
                "2026-01-29": 4,
                "2026-01-30": 1,
                "2026-02-03": 16,
                "2026-02-04": 3,
                "2026-02-05": 1,
                "2026-02-07": 2,
                "2026-02-09": 11,
                "2026-02-10": 11,
                "2026-02-13": 1,
                "2026-02-16": 2,
                "2026-02-17": 6,
                "2026-02-18": 4,
                "2026-02-19": 4,
                "2026-02-20": 3,
                "2026-02-23": 1,
                "2026-02-24": 5,
                "2026-02-25": 3,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-04": 7,
                "2026-03-07": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 4,
                "2026-04-07": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 201.25,
              "mode_time_hours": 133.0,
              "mode_frequency": 6,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "8-10h": 1,
                "20-22h": 2,
                "26-28h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "66-68h": 2,
                "70-72h": 1,
                "76-78h": 1,
                "90-92h": 1,
                "112-114h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "124-126h": 1,
                "128-130h": 2,
                "132-134h": 6,
                "138-140h": 2,
                "140-142h": 5,
                "148-150h": 2,
                "150-152h": 1,
                "166-168h": 1,
                "178-180h": 1,
                "186-188h": 1,
                "194-196h": 1,
                "218-220h": 1,
                "220-222h": 1,
                "230-232h": 1,
                "256-258h": 1,
                "262-264h": 1,
                "288-290h": 1,
                "292-294h": 1,
                "330-332h": 1,
                "340-342h": 1,
                "360-362h": 1,
                "362-364h": 1,
                "366-368h": 3,
                "380-382h": 1,
                "412-414h": 1,
                "438-440h": 2,
                "472-474h": 1,
                "572-574h": 1,
                "842-844h": 1
              },
              "tickets_count": 60,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-25": 1,
                "2025-11-05": 2,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-10": 1,
                "2025-11-14": 3,
                "2025-11-18": 1,
                "2025-11-19": 4,
                "2025-11-24": 1,
                "2025-11-29": 2,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-03": 9,
                "2026-02-04": 8,
                "2026-02-05": 3,
                "2026-02-06": 2,
                "2026-02-10": 2,
                "2026-02-17": 2,
                "2026-02-19": 1,
                "2026-03-30": 1,
                "2026-04-20": 1,
                "2026-05-04": 2
              },
              "time_per_day": {
                "2025-10-21": 40.20449138888889,
                "2025-10-23": 77.83891027777777,
                "2025-10-25": 256.24249305555554,
                "2025-11-05": 238.80238250000002,
                "2025-11-06": 187.87628361111112,
                "2025-11-07": 230.5068077777778,
                "2025-11-10": 3.118009166666667,
                "2025-11-14": 1102.2447011111112,
                "2025-11-18": 331.31258833333334,
                "2025-11-19": 408.3228761111111,
                "2025-11-24": 149.37999555555558,
                "2025-11-29": 152.15293444444444,
                "2025-12-04": 156.10407666666666,
                "2025-12-05": 133.8503372222222,
                "2026-01-07": 289.246025,
                "2026-01-13": 4.308753888888889,
                "2026-01-15": 8.721878333333333,
                "2026-01-17": 91.22941638888888,
                "2026-01-30": 413.64857722222223,
                "2026-02-02": 71.297775,
                "2026-02-03": 1711.5069522222223,
                "2026-02-04": 1057.9961658333334,
                "2026-02-05": 524.7028897222223,
                "2026-02-06": 388.4040258333333,
                "2026-02-10": 556.3568288888889,
                "2026-02-17": 877.9425422222222,
                "2026-02-19": 472.31816555555554,
                "2026-03-30": 340.5451375,
                "2026-04-20": 381.8180936111111,
                "2026-05-04": 1416.9927416666667
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-25": 1,
                "2025-11-05": 2,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-10": 1,
                "2025-11-14": 3,
                "2025-11-18": 1,
                "2025-11-19": 4,
                "2025-11-24": 1,
                "2025-11-29": 2,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-03": 9,
                "2026-02-04": 8,
                "2026-02-05": 3,
                "2026-02-06": 2,
                "2026-02-10": 2,
                "2026-02-17": 2,
                "2026-02-19": 1,
                "2026-03-30": 1,
                "2026-04-20": 1,
                "2026-05-04": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 342.53,
              "mode_time_hours": 549.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "10-12h": 1,
                "98-100h": 1,
                "110-112h": 1,
                "132-134h": 1,
                "160-162h": 1,
                "218-220h": 1,
                "234-236h": 1,
                "238-240h": 1,
                "266-268h": 1,
                "358-360h": 1,
                "362-364h": 1,
                "368-370h": 1,
                "402-404h": 1,
                "438-440h": 1,
                "442-444h": 1,
                "478-480h": 1,
                "480-482h": 1,
                "500-502h": 1,
                "548-550h": 2,
                "902-904h": 2
              },
              "tickets_count": 24,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-11": 4,
                "2025-12-12": 2,
                "2025-12-15": 1,
                "2025-12-16": 2,
                "2026-01-02": 2,
                "2026-01-17": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-17": 2,
                "2026-02-19": 3
              },
              "time_per_day": {
                "2025-12-02": 2.251583888888889,
                "2025-12-04": 111.61828166666668,
                "2025-12-05": 224.47086583333333,
                "2025-12-11": 1825.3005311111112,
                "2025-12-12": 473.1708366666667,
                "2025-12-15": 10.778245555555555,
                "2025-12-16": 563.9792955555556,
                "2026-01-02": 1806.366112222222,
                "2026-01-17": 98.15265805555556,
                "2026-02-03": 362.9315555555556,
                "2026-02-04": 133.08936583333335,
                "2026-02-10": 267.6131972222222,
                "2026-02-17": 880.4267780555555,
                "2026-02-19": 1460.4956075
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-11": 4,
                "2025-12-12": 2,
                "2025-12-15": 1,
                "2025-12-16": 2,
                "2026-01-02": 2,
                "2026-01-17": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-17": 2,
                "2026-02-19": 3
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2026-04-30": 1,
              "2026-06-04": 1,
              "2026-06-05": 1,
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-04-30": 1,
                "2026-06-04": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-05": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 15,
            "tickets_per_day": {
              "2025-12-29": 1,
              "2026-03-02": 1,
              "2026-04-17": 1,
              "2026-05-16": 1,
              "2026-05-21": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 4,
              "2026-06-06": 3,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-05": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-04-17": 1,
                "2026-05-16": 1,
                "2026-05-21": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 3,
                "2026-06-06": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-12-22": 1,
              "2026-01-08": 1,
              "2026-03-30": 1,
              "2026-05-13": 1,
              "2026-05-21": 1,
              "2026-05-27": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-12-22": 1,
                "2026-01-08": 1,
                "2026-03-30": 1,
                "2026-05-13": 1,
                "2026-05-21": 1,
                "2026-05-27": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 29,
            "tickets_per_day": {
              "2025-12-12": 1,
              "2026-01-02": 1,
              "2026-02-17": 1,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-02-27": 1,
              "2026-03-13": 2,
              "2026-03-16": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-04": 1,
              "2026-04-15": 1,
              "2026-04-24": 1,
              "2026-05-02": 1,
              "2026-05-06": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-01": 4,
              "2026-06-02": 2,
              "2026-06-03": 1,
              "2026-06-05": 2,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 29,
              "tickets_per_day": {
                "2025-12-12": 1,
                "2026-01-02": 1,
                "2026-02-17": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-02-27": 1,
                "2026-03-13": 2,
                "2026-03-16": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-04-04": 1,
                "2026-04-15": 1,
                "2026-04-24": 1,
                "2026-05-02": 1,
                "2026-05-06": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-29": 1,
                "2026-06-01": 4,
                "2026-06-02": 2,
                "2026-06-03": 1,
                "2026-06-05": 2,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Não Atribuído": {
      "overall": {
        "avg_time_hours": 125.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 2383,
        "time_distribution": {
          "0-2h": 2383,
          "2-4h": 482,
          "4-6h": 242,
          "6-8h": 139,
          "8-10h": 84,
          "10-12h": 55,
          "12-14h": 39,
          "14-16h": 32,
          "16-18h": 56,
          "18-20h": 59,
          "20-22h": 71,
          "22-24h": 65,
          "24-26h": 67,
          "26-28h": 50,
          "28-30h": 54,
          "30-32h": 56,
          "32-34h": 26,
          "34-36h": 22,
          "36-38h": 59,
          "38-40h": 27,
          "40-42h": 34,
          "42-44h": 20,
          "44-46h": 41,
          "46-48h": 30,
          "48-50h": 25,
          "50-52h": 46,
          "52-54h": 22,
          "54-56h": 5,
          "56-58h": 20,
          "58-60h": 14,
          "60-62h": 11,
          "62-64h": 5,
          "64-66h": 3,
          "66-68h": 12,
          "68-70h": 14,
          "70-72h": 21,
          "72-74h": 31,
          "74-76h": 26,
          "76-78h": 19,
          "78-80h": 30,
          "80-82h": 20,
          "82-84h": 20,
          "84-86h": 8,
          "86-88h": 2,
          "88-90h": 7,
          "90-92h": 9,
          "92-94h": 16,
          "94-96h": 30,
          "96-98h": 23,
          "98-100h": 18,
          "100-102h": 16,
          "102-104h": 19,
          "104-106h": 19,
          "106-108h": 2,
          "108-110h": 3,
          "110-112h": 4,
          "112-114h": 7,
          "114-116h": 12,
          "116-118h": 8,
          "118-120h": 16,
          "120-122h": 19,
          "122-124h": 25,
          "124-126h": 12,
          "126-128h": 13,
          "128-130h": 7,
          "130-132h": 7,
          "132-134h": 4,
          "134-136h": 9,
          "136-138h": 7,
          "138-140h": 7,
          "140-142h": 22,
          "142-144h": 12,
          "144-146h": 15,
          "146-148h": 9,
          "148-150h": 4,
          "150-152h": 20,
          "152-154h": 2,
          "154-156h": 7,
          "156-158h": 12,
          "158-160h": 10,
          "160-162h": 7,
          "162-164h": 19,
          "164-166h": 20,
          "166-168h": 9,
          "168-170h": 2,
          "170-172h": 2,
          "172-174h": 8,
          "174-176h": 7,
          "176-178h": 9,
          "178-180h": 9,
          "180-182h": 17,
          "182-184h": 7,
          "184-186h": 7,
          "186-188h": 6,
          "188-190h": 4,
          "190-192h": 2,
          "192-194h": 13,
          "194-196h": 11,
          "196-198h": 8,
          "198-200h": 6,
          "200-202h": 12,
          "202-204h": 6,
          "204-206h": 9,
          "206-208h": 11,
          "208-210h": 8,
          "210-212h": 5,
          "212-214h": 5,
          "214-216h": 5,
          "216-218h": 34,
          "218-220h": 3,
          "220-222h": 2,
          "222-224h": 1,
          "224-226h": 1,
          "228-230h": 9,
          "230-232h": 3,
          "232-234h": 3,
          "234-236h": 8,
          "236-238h": 3,
          "238-240h": 4,
          "240-242h": 14,
          "242-244h": 3,
          "244-246h": 1,
          "246-248h": 1,
          "252-254h": 1,
          "254-256h": 1,
          "256-258h": 4,
          "258-260h": 4,
          "260-262h": 3,
          "264-266h": 1,
          "266-268h": 8,
          "268-270h": 2,
          "270-272h": 1,
          "272-274h": 5,
          "274-276h": 6,
          "276-278h": 7,
          "278-280h": 4,
          "280-282h": 2,
          "282-284h": 5,
          "284-286h": 3,
          "286-288h": 6,
          "288-290h": 13,
          "290-292h": 1,
          "294-296h": 2,
          "298-300h": 2,
          "300-302h": 7,
          "302-304h": 9,
          "304-306h": 4,
          "306-308h": 7,
          "310-312h": 11,
          "312-314h": 10,
          "314-316h": 1,
          "316-318h": 2,
          "318-320h": 2,
          "322-324h": 3,
          "324-326h": 6,
          "326-328h": 1,
          "328-330h": 6,
          "330-332h": 7,
          "332-334h": 6,
          "334-336h": 17,
          "336-338h": 16,
          "338-340h": 3,
          "340-342h": 1,
          "342-344h": 1,
          "344-346h": 2,
          "346-348h": 2,
          "348-350h": 6,
          "350-352h": 4,
          "352-354h": 5,
          "354-356h": 4,
          "356-358h": 9,
          "358-360h": 9,
          "360-362h": 4,
          "362-364h": 2,
          "364-366h": 6,
          "366-368h": 1,
          "368-370h": 1,
          "370-372h": 8,
          "372-374h": 12,
          "374-376h": 3,
          "376-378h": 2,
          "378-380h": 2,
          "380-382h": 4,
          "382-384h": 14,
          "384-386h": 24,
          "386-388h": 1,
          "388-390h": 6,
          "390-392h": 1,
          "392-394h": 3,
          "394-396h": 1,
          "396-398h": 2,
          "398-400h": 13,
          "400-402h": 10,
          "402-404h": 3,
          "404-406h": 12,
          "406-408h": 4,
          "408-410h": 10,
          "412-414h": 1,
          "414-416h": 4,
          "416-418h": 3,
          "418-420h": 1,
          "420-422h": 9,
          "422-424h": 7,
          "424-426h": 6,
          "426-428h": 4,
          "428-430h": 6,
          "430-432h": 3,
          "432-434h": 3,
          "434-436h": 1,
          "442-444h": 2,
          "444-446h": 5,
          "446-448h": 4,
          "448-450h": 2,
          "450-452h": 4,
          "452-454h": 7,
          "454-456h": 9,
          "456-458h": 10,
          "458-460h": 2,
          "462-464h": 3,
          "466-468h": 7,
          "468-470h": 1,
          "470-472h": 1,
          "472-474h": 9,
          "474-476h": 3,
          "476-478h": 5,
          "478-480h": 9,
          "480-482h": 2,
          "482-484h": 2,
          "486-488h": 1,
          "490-492h": 1,
          "492-494h": 6,
          "494-496h": 2,
          "496-498h": 9,
          "498-500h": 6,
          "500-502h": 8,
          "502-504h": 13,
          "504-506h": 13,
          "506-508h": 2,
          "508-510h": 7,
          "510-512h": 3,
          "514-516h": 1,
          "520-522h": 1,
          "522-524h": 2,
          "524-526h": 3,
          "526-528h": 3,
          "528-530h": 7,
          "530-532h": 2,
          "532-534h": 3,
          "534-536h": 2,
          "538-540h": 1,
          "540-542h": 1,
          "542-544h": 2,
          "544-546h": 6,
          "546-548h": 4,
          "548-550h": 5,
          "550-552h": 3,
          "552-554h": 4,
          "554-556h": 1,
          "556-558h": 2,
          "558-560h": 1,
          "564-566h": 5,
          "566-568h": 2,
          "568-570h": 1,
          "570-572h": 2,
          "574-576h": 2,
          "576-578h": 11,
          "578-580h": 1,
          "580-582h": 2,
          "582-584h": 2,
          "584-586h": 2,
          "592-594h": 2,
          "594-596h": 1,
          "596-598h": 2,
          "598-600h": 3,
          "602-604h": 1,
          "604-606h": 1,
          "614-616h": 1,
          "616-618h": 4,
          "618-620h": 1,
          "620-622h": 2,
          "622-624h": 3,
          "624-626h": 6,
          "626-628h": 1,
          "628-630h": 3,
          "630-632h": 2,
          "634-636h": 4,
          "636-638h": 1,
          "638-640h": 4,
          "642-644h": 3,
          "644-646h": 1,
          "646-648h": 2,
          "648-650h": 1,
          "650-652h": 4,
          "652-654h": 4,
          "654-656h": 2,
          "656-658h": 1,
          "658-660h": 3,
          "662-664h": 1,
          "664-666h": 6,
          "666-668h": 2,
          "668-670h": 3,
          "670-672h": 4,
          "672-674h": 5,
          "674-676h": 2,
          "678-680h": 3,
          "682-684h": 6,
          "684-686h": 1,
          "688-690h": 1,
          "690-692h": 4,
          "692-694h": 5,
          "694-696h": 1,
          "700-702h": 2,
          "702-704h": 2,
          "708-710h": 1,
          "710-712h": 3,
          "714-716h": 1,
          "716-718h": 1,
          "718-720h": 1,
          "720-722h": 5,
          "722-724h": 2,
          "724-726h": 2,
          "726-728h": 2,
          "728-730h": 1,
          "732-734h": 1,
          "734-736h": 6,
          "736-738h": 3,
          "738-740h": 4,
          "740-742h": 1,
          "744-746h": 1,
          "746-748h": 3,
          "758-760h": 1,
          "762-764h": 1,
          "766-768h": 1,
          "768-770h": 5,
          "772-774h": 2,
          "782-784h": 1,
          "784-786h": 1,
          "786-788h": 1,
          "788-790h": 2,
          "790-792h": 3,
          "792-794h": 2,
          "804-806h": 5,
          "808-810h": 3,
          "814-816h": 2,
          "816-818h": 2,
          "822-824h": 1,
          "824-826h": 3,
          "826-828h": 4,
          "828-830h": 1,
          "830-832h": 1,
          "836-838h": 2,
          "838-840h": 1,
          "840-842h": 1,
          "842-844h": 2,
          "844-846h": 1,
          "846-848h": 1,
          "848-850h": 1,
          "852-854h": 3,
          "854-856h": 1,
          "858-860h": 1,
          "860-862h": 1,
          "876-878h": 3,
          "878-880h": 1,
          "886-888h": 1,
          "888-890h": 1,
          "900-902h": 1,
          "908-910h": 1,
          "912-914h": 3,
          "916-918h": 1,
          "940-942h": 1,
          "944-946h": 1,
          "960-962h": 1,
          "966-968h": 2,
          "972-974h": 2,
          "976-978h": 1,
          "978-980h": 2,
          "982-984h": 4,
          "988-990h": 1,
          "994-996h": 2,
          "1002-1004h": 1,
          "1008-1010h": 4,
          "1012-1014h": 1,
          "1018-1020h": 1,
          "1020-1022h": 3,
          "1026-1028h": 2,
          "1036-1038h": 1,
          "1038-1040h": 1,
          "1044-1046h": 1,
          "1046-1048h": 2,
          "1050-1052h": 2,
          "1054-1056h": 2,
          "1056-1058h": 3,
          "1060-1062h": 1,
          "1066-1068h": 1,
          "1068-1070h": 1,
          "1072-1074h": 2,
          "1078-1080h": 2,
          "1080-1082h": 3,
          "1084-1086h": 1,
          "1086-1088h": 1,
          "1100-1102h": 1,
          "1106-1108h": 1,
          "1124-1126h": 8,
          "1134-1136h": 1,
          "1138-1140h": 2,
          "1142-1144h": 1,
          "1150-1152h": 1,
          "1152-1154h": 2,
          "1176-1178h": 1,
          "1198-1200h": 2,
          "1214-1216h": 1,
          "1216-1218h": 1,
          "1222-1224h": 2,
          "1228-1230h": 1,
          "1236-1238h": 2,
          "1238-1240h": 1,
          "1240-1242h": 1,
          "1248-1250h": 1,
          "1252-1254h": 1,
          "1270-1272h": 3,
          "1282-1284h": 2,
          "1284-1286h": 1,
          "1298-1300h": 1,
          "1344-1346h": 1,
          "1348-1350h": 1,
          "1360-1362h": 1,
          "1368-1370h": 2,
          "1406-1408h": 1,
          "1408-1410h": 1,
          "1412-1414h": 1,
          "1416-1418h": 5,
          "1440-1442h": 1,
          "1460-1462h": 2,
          "1462-1464h": 2,
          "1488-1490h": 1,
          "1502-1504h": 1,
          "1506-1508h": 1,
          "1546-1548h": 1,
          "1634-1636h": 1,
          "1686-1688h": 1,
          "1698-1700h": 2,
          "1704-1706h": 2,
          "1718-1720h": 1,
          "1756-1758h": 1,
          "1838-1840h": 2,
          "1846-1848h": 1,
          "1856-1858h": 1,
          "1862-1864h": 1,
          "1916-1918h": 1,
          "1962-1964h": 1,
          "1964-1966h": 2,
          "2036-2038h": 1,
          "2048-2050h": 1,
          "2054-2056h": 1,
          "2132-2134h": 1,
          "2208-2210h": 1,
          "2272-2274h": 1,
          "2344-2346h": 1,
          "2510-2512h": 1,
          "2734-2736h": 1,
          "2886-2888h": 1,
          "3186-3188h": 1,
          "3262-3264h": 1
        },
        "tickets_count": 6977,
        "tickets_per_day": {
          "2025-09-30": 8,
          "2025-10-01": 2,
          "2025-10-03": 5,
          "2025-10-06": 4,
          "2025-10-07": 34,
          "2025-10-08": 9,
          "2025-10-09": 14,
          "2025-10-10": 8,
          "2025-10-13": 27,
          "2025-10-14": 27,
          "2025-10-15": 30,
          "2025-10-16": 2,
          "2025-10-17": 24,
          "2025-10-19": 1,
          "2025-10-20": 11,
          "2025-10-21": 12,
          "2025-10-22": 4,
          "2025-10-23": 25,
          "2025-10-24": 5,
          "2025-10-25": 10,
          "2025-10-26": 1,
          "2025-10-27": 23,
          "2025-10-28": 8,
          "2025-10-29": 29,
          "2025-10-30": 10,
          "2025-10-31": 16,
          "2025-11-02": 1,
          "2025-11-03": 10,
          "2025-11-04": 7,
          "2025-11-05": 22,
          "2025-11-06": 9,
          "2025-11-07": 4,
          "2025-11-10": 13,
          "2025-11-11": 12,
          "2025-11-12": 18,
          "2025-11-13": 11,
          "2025-11-14": 19,
          "2025-11-15": 1,
          "2025-11-16": 2,
          "2025-11-17": 11,
          "2025-11-18": 3,
          "2025-11-19": 22,
          "2025-11-20": 32,
          "2025-11-21": 35,
          "2025-11-22": 9,
          "2025-11-23": 3,
          "2025-11-24": 14,
          "2025-11-25": 11,
          "2025-11-26": 6,
          "2025-11-27": 6,
          "2025-11-28": 4,
          "2025-11-29": 15,
          "2025-11-30": 1,
          "2025-12-01": 2,
          "2025-12-02": 32,
          "2025-12-03": 43,
          "2025-12-04": 16,
          "2025-12-05": 16,
          "2025-12-06": 1,
          "2025-12-07": 1,
          "2025-12-09": 5,
          "2025-12-10": 18,
          "2025-12-11": 22,
          "2025-12-12": 8,
          "2025-12-14": 2,
          "2025-12-15": 64,
          "2025-12-16": 15,
          "2025-12-17": 17,
          "2025-12-18": 8,
          "2025-12-19": 18,
          "2025-12-21": 1,
          "2025-12-22": 31,
          "2025-12-23": 8,
          "2025-12-25": 1,
          "2025-12-26": 28,
          "2025-12-28": 1,
          "2025-12-29": 29,
          "2025-12-30": 10,
          "2025-12-31": 4,
          "2026-01-02": 26,
          "2026-01-03": 3,
          "2026-01-04": 2,
          "2026-01-05": 6,
          "2026-01-06": 7,
          "2026-01-07": 9,
          "2026-01-08": 38,
          "2026-01-09": 28,
          "2026-01-10": 2,
          "2026-01-12": 15,
          "2026-01-13": 47,
          "2026-01-14": 27,
          "2026-01-15": 59,
          "2026-01-16": 30,
          "2026-01-17": 29,
          "2026-01-18": 6,
          "2026-01-19": 14,
          "2026-01-20": 22,
          "2026-01-21": 40,
          "2026-01-22": 17,
          "2026-01-23": 47,
          "2026-01-24": 34,
          "2026-01-26": 36,
          "2026-01-27": 63,
          "2026-01-28": 8,
          "2026-01-29": 13,
          "2026-01-30": 40,
          "2026-01-31": 7,
          "2026-02-02": 17,
          "2026-02-03": 32,
          "2026-02-04": 14,
          "2026-02-05": 36,
          "2026-02-06": 107,
          "2026-02-07": 1,
          "2026-02-09": 47,
          "2026-02-10": 132,
          "2026-02-11": 32,
          "2026-02-12": 39,
          "2026-02-13": 89,
          "2026-02-14": 20,
          "2026-02-16": 25,
          "2026-02-17": 12,
          "2026-02-18": 63,
          "2026-02-19": 451,
          "2026-02-20": 32,
          "2026-02-21": 39,
          "2026-02-23": 88,
          "2026-02-24": 23,
          "2026-02-25": 18,
          "2026-02-26": 7,
          "2026-02-27": 11,
          "2026-02-28": 135,
          "2026-03-01": 1,
          "2026-03-02": 49,
          "2026-03-03": 36,
          "2026-03-04": 21,
          "2026-03-05": 39,
          "2026-03-06": 31,
          "2026-03-07": 15,
          "2026-03-09": 78,
          "2026-03-10": 31,
          "2026-03-11": 37,
          "2026-03-12": 17,
          "2026-03-13": 13,
          "2026-03-14": 43,
          "2026-03-16": 22,
          "2026-03-17": 115,
          "2026-03-18": 536,
          "2026-03-19": 26,
          "2026-03-20": 40,
          "2026-03-21": 2,
          "2026-03-23": 53,
          "2026-03-24": 75,
          "2026-03-25": 38,
          "2026-03-26": 69,
          "2026-03-27": 26,
          "2026-03-28": 9,
          "2026-03-30": 82,
          "2026-03-31": 30,
          "2026-04-01": 23,
          "2026-04-02": 22,
          "2026-04-04": 14,
          "2026-04-06": 69,
          "2026-04-07": 47,
          "2026-04-08": 42,
          "2026-04-09": 19,
          "2026-04-10": 42,
          "2026-04-11": 25,
          "2026-04-13": 41,
          "2026-04-14": 44,
          "2026-04-15": 19,
          "2026-04-16": 9,
          "2026-04-17": 20,
          "2026-04-18": 6,
          "2026-04-20": 23,
          "2026-04-21": 32,
          "2026-04-22": 92,
          "2026-04-23": 34,
          "2026-04-24": 40,
          "2026-04-27": 65,
          "2026-04-28": 28,
          "2026-04-29": 31,
          "2026-04-30": 36,
          "2026-05-01": 2,
          "2026-05-02": 64,
          "2026-05-04": 52,
          "2026-05-05": 19,
          "2026-05-06": 32,
          "2026-05-07": 16,
          "2026-05-08": 47,
          "2026-05-09": 34,
          "2026-05-11": 46,
          "2026-05-12": 24,
          "2026-05-13": 20,
          "2026-05-14": 24,
          "2026-05-15": 24,
          "2026-05-18": 59,
          "2026-05-19": 22,
          "2026-05-20": 38,
          "2026-05-21": 31,
          "2026-05-22": 19,
          "2026-05-23": 18,
          "2026-05-25": 86,
          "2026-05-26": 94,
          "2026-05-27": 70,
          "2026-05-28": 74,
          "2026-05-29": 99,
          "2026-05-30": 67,
          "2026-06-01": 86,
          "2026-06-02": 85,
          "2026-06-03": 33,
          "2026-06-05": 57,
          "2026-06-06": 5,
          "2026-06-07": 1,
          "2026-06-08": 76
        },
        "time_per_day": {
          "2025-09-30": 9.127841666666667,
          "2025-10-01": 26.06114138888889,
          "2025-10-03": 154.8331452777778,
          "2025-10-06": 0.9875205555555556,
          "2025-10-07": 1475.582726666667,
          "2025-10-08": 26.739000555555556,
          "2025-10-09": 294.5298491666666,
          "2025-10-10": 96.33314972222222,
          "2025-10-13": 1714.021978888889,
          "2025-10-14": 466.84292750000003,
          "2025-10-15": 497.33161083333346,
          "2025-10-16": 51.901759444444444,
          "2025-10-17": 604.2210780555555,
          "2025-10-20": 529.8430594444444,
          "2025-10-21": 365.31872694444445,
          "2025-10-22": 261.9568313888889,
          "2025-10-23": 807.3669249999998,
          "2025-10-24": 4.281496944444444,
          "2025-10-25": 557.7299408333333,
          "2025-10-26": 0.5912069444444444,
          "2025-10-27": 443.63950527777786,
          "2025-10-28": 114.28633305555557,
          "2025-10-29": 733.3488108333333,
          "2025-10-30": 620.6166327777779,
          "2025-10-31": 802.0761080555558,
          "2025-11-02": 6.409595277777778,
          "2025-11-03": 217.23275777777783,
          "2025-11-04": 3461.571971111111,
          "2025-11-05": 2060.2046066666667,
          "2025-11-06": 88.54049472222223,
          "2025-11-07": 11.220594722222224,
          "2025-11-10": 272.7147261111111,
          "2025-11-11": 136.03347444444444,
          "2025-11-12": 424.17754138888887,
          "2025-11-13": 347.99163555555555,
          "2025-11-14": 1184.051555,
          "2025-11-15": 0.20001194444444445,
          "2025-11-16": 1.5785355555555556,
          "2025-11-17": 237.39708972222223,
          "2025-11-18": 1041.1254194444446,
          "2025-11-19": 2130.5376741666673,
          "2025-11-20": 1554.0195413888891,
          "2025-11-21": 1195.0451911111113,
          "2025-11-22": 251.78188694444444,
          "2025-11-23": 172.13471583333333,
          "2025-11-24": 284.8341708333333,
          "2025-11-25": 209.1039725,
          "2025-11-26": 8.714044166666666,
          "2025-11-27": 3.5771949999999997,
          "2025-11-28": 103.04507500000001,
          "2025-11-29": 1256.4848872222226,
          "2025-11-30": 0.03324916666666667,
          "2025-12-01": 0.8959808333333333,
          "2025-12-02": 2678.997856944444,
          "2025-12-03": 3138.2686363888874,
          "2025-12-04": 553.5516025000001,
          "2025-12-05": 510.36735194444447,
          "2025-12-06": 3.4375983333333333,
          "2025-12-07": 0.18633083333333333,
          "2025-12-09": 464.3158397222221,
          "2025-12-10": 481.1334911111111,
          "2025-12-11": 1217.9861047222225,
          "2025-12-12": 2.112637777777778,
          "2025-12-14": 4.941235833333334,
          "2025-12-15": 4066.1005855555572,
          "2025-12-16": 1051.7887244444446,
          "2025-12-17": 1923.9397927777782,
          "2025-12-18": 543.3764277777777,
          "2025-12-19": 2078.872353611111,
          "2025-12-21": 89.8079611111111,
          "2025-12-22": 1689.4132386111112,
          "2025-12-23": 332.21707972222225,
          "2025-12-25": 56.22132055555555,
          "2025-12-26": 4176.6450561111105,
          "2025-12-29": 7610.488640277778,
          "2025-12-30": 446.78769333333344,
          "2025-12-31": 17.479653055555556,
          "2026-01-02": 2746.3424511111116,
          "2026-01-03": 0.9715977777777778,
          "2026-01-04": 0.23874944444444446,
          "2026-01-05": 1215.7688555555553,
          "2026-01-06": 121.38950722222222,
          "2026-01-07": 26.375528055555556,
          "2026-01-08": 3047.0554794444447,
          "2026-01-09": 933.4160502777778,
          "2026-01-10": 4.734784722222222,
          "2026-01-12": 901.1469772222223,
          "2026-01-13": 2413.834155277778,
          "2026-01-14": 177.35250361111108,
          "2026-01-15": 4774.817563888888,
          "2026-01-16": 677.5693083333332,
          "2026-01-17": 2886.5499641666665,
          "2026-01-18": 53.242089444444446,
          "2026-01-19": 85.26962166666665,
          "2026-01-20": 154.14520583333334,
          "2026-01-21": 1326.4593436111109,
          "2026-01-22": 169.82341722222228,
          "2026-01-23": 4318.421278888889,
          "2026-01-24": 5395.097718055556,
          "2026-01-26": 382.6337019444443,
          "2026-01-27": 3863.065136388889,
          "2026-01-28": 38.30271055555555,
          "2026-01-29": 54.121003333333334,
          "2026-01-30": 4161.651588055558,
          "2026-01-31": 734.4098319444445,
          "2026-02-02": 448.84911972222227,
          "2026-02-03": 2670.0772263888875,
          "2026-02-04": 969.9458644444443,
          "2026-02-05": 4054.0304705555554,
          "2026-02-06": 20583.37980777779,
          "2026-02-07": 532.1782808333334,
          "2026-02-09": 3131.4640480555554,
          "2026-02-10": 41571.18807611111,
          "2026-02-11": 3724.260151944445,
          "2026-02-12": 2986.808739166667,
          "2026-02-13": 14890.268112222226,
          "2026-02-14": 1629.8342494444441,
          "2026-02-16": 8963.890921944445,
          "2026-02-17": 1577.960201388889,
          "2026-02-18": 37079.736395277745,
          "2026-02-19": 245901.58612166674,
          "2026-02-20": 1336.3661916666663,
          "2026-02-21": 886.4260852777777,
          "2026-02-23": 4517.551563611108,
          "2026-02-24": 1171.0297166666662,
          "2026-02-25": 2367.6012313888887,
          "2026-02-26": 51.84813527777778,
          "2026-02-27": 23.493632777777776,
          "2026-02-28": 8822.087228611112,
          "2026-03-02": 794.3285966666667,
          "2026-03-03": 1171.6135350000004,
          "2026-03-04": 81.21685555555555,
          "2026-03-05": 118.37331250000001,
          "2026-03-06": 669.0325241666666,
          "2026-03-07": 23.669802222222224,
          "2026-03-09": 25754.188486111107,
          "2026-03-10": 1154.1383744444445,
          "2026-03-11": 9567.473549166667,
          "2026-03-12": 85.12184472222225,
          "2026-03-13": 1150.3077438888893,
          "2026-03-14": 2802.5688891666655,
          "2026-03-16": 68.73113249999997,
          "2026-03-17": 3978.155700555556,
          "2026-03-18": 163669.72289555575,
          "2026-03-19": 17.13997861111111,
          "2026-03-20": 1523.7399974999996,
          "2026-03-23": 50.92147166666666,
          "2026-03-24": 5468.567176111113,
          "2026-03-25": 158.6480972222223,
          "2026-03-26": 30053.443227500004,
          "2026-03-27": 11.6921575,
          "2026-03-28": 5.683826944444444,
          "2026-03-30": 5041.605215555553,
          "2026-03-31": 49.3596736111111,
          "2026-04-01": 38.22740222222223,
          "2026-04-02": 43.53574388888889,
          "2026-04-04": 23.56112388888889,
          "2026-04-06": 116.7791208333333,
          "2026-04-07": 129.74741222222227,
          "2026-04-08": 356.4146925,
          "2026-04-09": 13.570228055555555,
          "2026-04-10": 237.73439249999993,
          "2026-04-11": 644.4010447222222,
          "2026-04-13": 3486.897580277778,
          "2026-04-14": 197.0491361111111,
          "2026-04-15": 13.898377222222221,
          "2026-04-16": 5.540063888888889,
          "2026-04-17": 281.93704194444456,
          "2026-04-18": 9.854589166666667,
          "2026-04-20": 8.548414444444443,
          "2026-04-21": 16.52367388888889,
          "2026-04-22": 7996.157943611107,
          "2026-04-23": 11.611257777777778,
          "2026-04-24": 17.32518611111111,
          "2026-04-27": 174.98030250000008,
          "2026-04-28": 21.582048055555557,
          "2026-04-29": 9.415882222222224,
          "2026-04-30": 74.72355861111112,
          "2026-05-01": 392.60974166666665,
          "2026-05-02": 485.37755277777774,
          "2026-05-04": 109.69104555555556,
          "2026-05-05": 3.8272786111111112,
          "2026-05-06": 1871.9605497222224,
          "2026-05-07": 380.8554661111111,
          "2026-05-08": 105.95977055555555,
          "2026-05-09": 87.51052388888888,
          "2026-05-11": 63.2094736111111,
          "2026-05-12": 16.886509444444442,
          "2026-05-13": 26.51112805555556,
          "2026-05-14": 1479.1644561111107,
          "2026-05-15": 27.490176388888898,
          "2026-05-18": 49.658548888888895,
          "2026-05-19": 35.648480000000006,
          "2026-05-20": 25.66612027777778,
          "2026-05-21": 22.013790833333328,
          "2026-05-22": 15.802796666666666,
          "2026-05-23": 25.782598333333336,
          "2026-05-25": 416.62317138888875,
          "2026-05-26": 229.69407111111124,
          "2026-05-27": 134.39113777777777,
          "2026-05-28": 115.97938444444445,
          "2026-05-29": 2907.5056838888895,
          "2026-05-30": 62.9993325,
          "2026-06-01": 1591.3946899999996,
          "2026-06-02": 3477.543826944445,
          "2026-06-03": 244.46619083333337,
          "2026-06-05": 443.97138444444437,
          "2026-06-08": 35.62650527777777
        },
        "time_count_per_day": {
          "2025-09-30": 8,
          "2025-10-01": 2,
          "2025-10-03": 5,
          "2025-10-06": 3,
          "2025-10-07": 32,
          "2025-10-08": 8,
          "2025-10-09": 14,
          "2025-10-10": 8,
          "2025-10-13": 27,
          "2025-10-14": 27,
          "2025-10-15": 30,
          "2025-10-16": 2,
          "2025-10-17": 24,
          "2025-10-20": 10,
          "2025-10-21": 12,
          "2025-10-22": 4,
          "2025-10-23": 25,
          "2025-10-24": 5,
          "2025-10-25": 10,
          "2025-10-26": 1,
          "2025-10-27": 23,
          "2025-10-28": 8,
          "2025-10-29": 28,
          "2025-10-30": 10,
          "2025-10-31": 16,
          "2025-11-02": 1,
          "2025-11-03": 10,
          "2025-11-04": 6,
          "2025-11-05": 22,
          "2025-11-06": 9,
          "2025-11-07": 4,
          "2025-11-10": 13,
          "2025-11-11": 12,
          "2025-11-12": 18,
          "2025-11-13": 11,
          "2025-11-14": 19,
          "2025-11-15": 1,
          "2025-11-16": 2,
          "2025-11-17": 10,
          "2025-11-18": 3,
          "2025-11-19": 22,
          "2025-11-20": 32,
          "2025-11-21": 34,
          "2025-11-22": 9,
          "2025-11-23": 3,
          "2025-11-24": 14,
          "2025-11-25": 10,
          "2025-11-26": 5,
          "2025-11-27": 5,
          "2025-11-28": 4,
          "2025-11-29": 15,
          "2025-11-30": 1,
          "2025-12-01": 1,
          "2025-12-02": 32,
          "2025-12-03": 43,
          "2025-12-04": 16,
          "2025-12-05": 16,
          "2025-12-06": 1,
          "2025-12-07": 1,
          "2025-12-09": 5,
          "2025-12-10": 18,
          "2025-12-11": 22,
          "2025-12-12": 8,
          "2025-12-14": 2,
          "2025-12-15": 64,
          "2025-12-16": 15,
          "2025-12-17": 17,
          "2025-12-18": 8,
          "2025-12-19": 18,
          "2025-12-21": 1,
          "2025-12-22": 31,
          "2025-12-23": 8,
          "2025-12-25": 1,
          "2025-12-26": 28,
          "2025-12-29": 29,
          "2025-12-30": 10,
          "2025-12-31": 4,
          "2026-01-02": 25,
          "2026-01-03": 2,
          "2026-01-04": 2,
          "2026-01-05": 6,
          "2026-01-06": 7,
          "2026-01-07": 9,
          "2026-01-08": 38,
          "2026-01-09": 28,
          "2026-01-10": 2,
          "2026-01-12": 15,
          "2026-01-13": 47,
          "2026-01-14": 26,
          "2026-01-15": 59,
          "2026-01-16": 30,
          "2026-01-17": 29,
          "2026-01-18": 4,
          "2026-01-19": 14,
          "2026-01-20": 21,
          "2026-01-21": 39,
          "2026-01-22": 17,
          "2026-01-23": 47,
          "2026-01-24": 34,
          "2026-01-26": 36,
          "2026-01-27": 63,
          "2026-01-28": 8,
          "2026-01-29": 13,
          "2026-01-30": 40,
          "2026-01-31": 7,
          "2026-02-02": 17,
          "2026-02-03": 32,
          "2026-02-04": 13,
          "2026-02-05": 36,
          "2026-02-06": 107,
          "2026-02-07": 1,
          "2026-02-09": 47,
          "2026-02-10": 132,
          "2026-02-11": 30,
          "2026-02-12": 38,
          "2026-02-13": 89,
          "2026-02-14": 18,
          "2026-02-16": 15,
          "2026-02-17": 6,
          "2026-02-18": 57,
          "2026-02-19": 441,
          "2026-02-20": 23,
          "2026-02-21": 37,
          "2026-02-23": 71,
          "2026-02-24": 20,
          "2026-02-25": 14,
          "2026-02-26": 6,
          "2026-02-27": 11,
          "2026-02-28": 131,
          "2026-03-02": 42,
          "2026-03-03": 16,
          "2026-03-04": 13,
          "2026-03-05": 35,
          "2026-03-06": 25,
          "2026-03-07": 14,
          "2026-03-09": 69,
          "2026-03-10": 23,
          "2026-03-11": 26,
          "2026-03-12": 17,
          "2026-03-13": 13,
          "2026-03-14": 42,
          "2026-03-16": 20,
          "2026-03-17": 115,
          "2026-03-18": 532,
          "2026-03-19": 25,
          "2026-03-20": 38,
          "2026-03-23": 50,
          "2026-03-24": 74,
          "2026-03-25": 34,
          "2026-03-26": 68,
          "2026-03-27": 20,
          "2026-03-28": 6,
          "2026-03-30": 71,
          "2026-03-31": 21,
          "2026-04-01": 16,
          "2026-04-02": 16,
          "2026-04-04": 10,
          "2026-04-06": 63,
          "2026-04-07": 41,
          "2026-04-08": 37,
          "2026-04-09": 10,
          "2026-04-10": 37,
          "2026-04-11": 25,
          "2026-04-13": 40,
          "2026-04-14": 41,
          "2026-04-15": 12,
          "2026-04-16": 7,
          "2026-04-17": 19,
          "2026-04-18": 4,
          "2026-04-20": 20,
          "2026-04-21": 30,
          "2026-04-22": 83,
          "2026-04-23": 29,
          "2026-04-24": 25,
          "2026-04-27": 44,
          "2026-04-28": 20,
          "2026-04-29": 19,
          "2026-04-30": 26,
          "2026-05-01": 2,
          "2026-05-02": 50,
          "2026-05-04": 38,
          "2026-05-05": 10,
          "2026-05-06": 17,
          "2026-05-07": 9,
          "2026-05-08": 33,
          "2026-05-09": 24,
          "2026-05-11": 38,
          "2026-05-12": 14,
          "2026-05-13": 14,
          "2026-05-14": 19,
          "2026-05-15": 17,
          "2026-05-18": 46,
          "2026-05-19": 14,
          "2026-05-20": 23,
          "2026-05-21": 20,
          "2026-05-22": 13,
          "2026-05-23": 17,
          "2026-05-25": 75,
          "2026-05-26": 90,
          "2026-05-27": 61,
          "2026-05-28": 67,
          "2026-05-29": 91,
          "2026-05-30": 63,
          "2026-06-01": 84,
          "2026-06-02": 79,
          "2026-06-03": 28,
          "2026-06-05": 51,
          "2026-06-08": 58
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 7.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "26-28h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-10-29": 1,
            "2026-01-14": 1,
            "2026-03-17": 1,
            "2026-05-15": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-10-15": 1.828102222222222,
            "2026-01-14": 1.4789947222222224,
            "2026-03-17": 0.9878205555555556,
            "2026-05-26": 26.844470833333332
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2026-01-14": 1,
            "2026-03-17": 1,
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 29.96,
          "mode_time_hours": 1.0,
          "mode_frequency": 2301,
          "time_distribution": {
            "0-2h": 2301,
            "2-4h": 432,
            "4-6h": 185,
            "6-8h": 85,
            "8-10h": 46,
            "10-12h": 25,
            "12-14h": 24,
            "14-16h": 20,
            "16-18h": 22,
            "18-20h": 16,
            "20-22h": 17,
            "22-24h": 11,
            "24-26h": 7,
            "26-28h": 3,
            "28-30h": 5,
            "30-32h": 4,
            "32-34h": 1,
            "34-36h": 3,
            "36-38h": 6,
            "38-40h": 18,
            "40-42h": 5,
            "42-44h": 2,
            "44-46h": 6,
            "46-48h": 3,
            "48-50h": 2,
            "50-52h": 2,
            "58-60h": 1,
            "62-64h": 1,
            "68-70h": 5,
            "72-74h": 7,
            "74-76h": 6,
            "76-78h": 3,
            "78-80h": 1,
            "80-82h": 1,
            "88-90h": 1,
            "90-92h": 1,
            "92-94h": 3,
            "94-96h": 1,
            "96-98h": 2,
            "100-102h": 2,
            "102-104h": 1,
            "106-108h": 2,
            "120-122h": 1,
            "122-124h": 4,
            "124-126h": 1,
            "126-128h": 1,
            "128-130h": 1,
            "138-140h": 1,
            "142-144h": 2,
            "144-146h": 1,
            "150-152h": 1,
            "162-164h": 7,
            "164-166h": 1,
            "172-174h": 1,
            "176-178h": 2,
            "186-188h": 1,
            "188-190h": 1,
            "194-196h": 1,
            "198-200h": 1,
            "208-210h": 2,
            "234-236h": 1,
            "236-238h": 1,
            "238-240h": 1,
            "246-248h": 1,
            "254-256h": 1,
            "256-258h": 1,
            "260-262h": 1,
            "266-268h": 2,
            "268-270h": 1,
            "274-276h": 1,
            "280-282h": 1,
            "302-304h": 1,
            "312-314h": 2,
            "318-320h": 1,
            "324-326h": 1,
            "336-338h": 2,
            "338-340h": 1,
            "346-348h": 1,
            "348-350h": 2,
            "358-360h": 2,
            "392-394h": 1,
            "400-402h": 1,
            "418-420h": 1,
            "422-424h": 1,
            "424-426h": 2,
            "434-436h": 1,
            "450-452h": 1,
            "462-464h": 1,
            "486-488h": 1,
            "504-506h": 1,
            "506-508h": 2,
            "508-510h": 2,
            "526-528h": 2,
            "528-530h": 3,
            "532-534h": 1,
            "552-554h": 1,
            "584-586h": 1,
            "592-594h": 1,
            "598-600h": 1,
            "630-632h": 1,
            "634-636h": 1,
            "648-650h": 1,
            "650-652h": 1,
            "652-654h": 1,
            "654-656h": 1,
            "658-660h": 1,
            "664-666h": 1,
            "668-670h": 1,
            "670-672h": 1,
            "672-674h": 1,
            "674-676h": 1,
            "678-680h": 1,
            "702-704h": 1,
            "722-724h": 1,
            "726-728h": 1,
            "738-740h": 1,
            "746-748h": 3,
            "758-760h": 1,
            "772-774h": 2,
            "792-794h": 1,
            "808-810h": 1,
            "822-824h": 1,
            "826-828h": 2,
            "836-838h": 1,
            "842-844h": 2,
            "846-848h": 1,
            "886-888h": 1,
            "888-890h": 1,
            "940-942h": 1,
            "944-946h": 1,
            "972-974h": 1,
            "994-996h": 1,
            "1018-1020h": 1,
            "1036-1038h": 1,
            "1054-1056h": 1,
            "1056-1058h": 2,
            "1080-1082h": 1,
            "1084-1086h": 1,
            "1086-1088h": 1,
            "1134-1136h": 1,
            "1176-1178h": 1,
            "1228-1230h": 1,
            "1252-1254h": 1,
            "1298-1300h": 1,
            "1440-1442h": 1,
            "1460-1462h": 1,
            "1462-1464h": 1,
            "1502-1504h": 1,
            "1634-1636h": 1,
            "1686-1688h": 1,
            "1756-1758h": 1,
            "2510-2512h": 1,
            "2734-2736h": 1,
            "2886-2888h": 1,
            "3262-3264h": 1
          },
          "tickets_count": 3477,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-03": 1,
            "2025-10-06": 3,
            "2025-10-07": 5,
            "2025-10-08": 6,
            "2025-10-09": 3,
            "2025-10-10": 6,
            "2025-10-13": 3,
            "2025-10-14": 14,
            "2025-10-15": 11,
            "2025-10-17": 3,
            "2025-10-19": 1,
            "2025-10-20": 3,
            "2025-10-21": 6,
            "2025-10-23": 3,
            "2025-10-24": 5,
            "2025-10-25": 2,
            "2025-10-26": 1,
            "2025-10-27": 6,
            "2025-10-28": 7,
            "2025-10-29": 11,
            "2025-10-30": 2,
            "2025-10-31": 7,
            "2025-11-02": 1,
            "2025-11-03": 5,
            "2025-11-04": 2,
            "2025-11-05": 2,
            "2025-11-06": 4,
            "2025-11-07": 2,
            "2025-11-10": 5,
            "2025-11-11": 5,
            "2025-11-12": 4,
            "2025-11-13": 7,
            "2025-11-14": 3,
            "2025-11-15": 1,
            "2025-11-16": 2,
            "2025-11-17": 9,
            "2025-11-18": 1,
            "2025-11-19": 3,
            "2025-11-20": 6,
            "2025-11-21": 7,
            "2025-11-22": 1,
            "2025-11-23": 1,
            "2025-11-24": 8,
            "2025-11-25": 2,
            "2025-11-26": 6,
            "2025-11-27": 5,
            "2025-11-28": 3,
            "2025-11-29": 3,
            "2025-11-30": 1,
            "2025-12-01": 2,
            "2025-12-02": 5,
            "2025-12-03": 7,
            "2025-12-04": 7,
            "2025-12-05": 10,
            "2025-12-06": 1,
            "2025-12-07": 1,
            "2025-12-09": 2,
            "2025-12-10": 4,
            "2025-12-11": 4,
            "2025-12-12": 8,
            "2025-12-14": 2,
            "2025-12-15": 20,
            "2025-12-16": 5,
            "2025-12-17": 11,
            "2025-12-18": 4,
            "2025-12-19": 5,
            "2025-12-21": 1,
            "2025-12-22": 6,
            "2025-12-23": 6,
            "2025-12-26": 16,
            "2025-12-28": 1,
            "2025-12-29": 15,
            "2025-12-30": 6,
            "2025-12-31": 4,
            "2026-01-02": 17,
            "2026-01-03": 2,
            "2026-01-04": 2,
            "2026-01-05": 5,
            "2026-01-06": 7,
            "2026-01-07": 8,
            "2026-01-08": 3,
            "2026-01-09": 11,
            "2026-01-10": 2,
            "2026-01-12": 13,
            "2026-01-13": 13,
            "2026-01-14": 24,
            "2026-01-15": 26,
            "2026-01-16": 22,
            "2026-01-17": 10,
            "2026-01-18": 4,
            "2026-01-19": 14,
            "2026-01-20": 22,
            "2026-01-21": 21,
            "2026-01-22": 16,
            "2026-01-23": 22,
            "2026-01-24": 1,
            "2026-01-26": 34,
            "2026-01-27": 8,
            "2026-01-28": 8,
            "2026-01-29": 13,
            "2026-01-30": 30,
            "2026-01-31": 2,
            "2026-02-02": 13,
            "2026-02-03": 30,
            "2026-02-04": 6,
            "2026-02-05": 10,
            "2026-02-06": 18,
            "2026-02-07": 1,
            "2026-02-09": 28,
            "2026-02-10": 25,
            "2026-02-11": 11,
            "2026-02-12": 21,
            "2026-02-13": 41,
            "2026-02-14": 10,
            "2026-02-16": 16,
            "2026-02-17": 1,
            "2026-02-18": 7,
            "2026-02-19": 3,
            "2026-02-20": 21,
            "2026-02-21": 2,
            "2026-02-23": 32,
            "2026-02-24": 20,
            "2026-02-25": 13,
            "2026-02-26": 5,
            "2026-02-27": 10,
            "2026-02-28": 30,
            "2026-03-02": 37,
            "2026-03-03": 29,
            "2026-03-04": 13,
            "2026-03-05": 35,
            "2026-03-06": 24,
            "2026-03-07": 13,
            "2026-03-09": 64,
            "2026-03-10": 23,
            "2026-03-11": 24,
            "2026-03-12": 17,
            "2026-03-13": 13,
            "2026-03-14": 4,
            "2026-03-16": 20,
            "2026-03-17": 12,
            "2026-03-18": 32,
            "2026-03-19": 25,
            "2026-03-20": 9,
            "2026-03-23": 51,
            "2026-03-24": 23,
            "2026-03-25": 28,
            "2026-03-26": 8,
            "2026-03-27": 20,
            "2026-03-28": 6,
            "2026-03-30": 46,
            "2026-03-31": 21,
            "2026-04-01": 17,
            "2026-04-02": 16,
            "2026-04-04": 10,
            "2026-04-06": 63,
            "2026-04-07": 40,
            "2026-04-08": 36,
            "2026-04-09": 10,
            "2026-04-10": 38,
            "2026-04-11": 24,
            "2026-04-13": 40,
            "2026-04-14": 40,
            "2026-04-15": 12,
            "2026-04-16": 7,
            "2026-04-17": 19,
            "2026-04-18": 4,
            "2026-04-20": 20,
            "2026-04-21": 30,
            "2026-04-22": 29,
            "2026-04-23": 29,
            "2026-04-24": 26,
            "2026-04-27": 43,
            "2026-04-28": 20,
            "2026-04-29": 19,
            "2026-04-30": 26,
            "2026-05-02": 50,
            "2026-05-04": 38,
            "2026-05-05": 10,
            "2026-05-06": 16,
            "2026-05-07": 8,
            "2026-05-08": 33,
            "2026-05-09": 24,
            "2026-05-11": 38,
            "2026-05-12": 15,
            "2026-05-13": 14,
            "2026-05-14": 18,
            "2026-05-15": 17,
            "2026-05-18": 47,
            "2026-05-19": 14,
            "2026-05-20": 23,
            "2026-05-21": 20,
            "2026-05-22": 13,
            "2026-05-23": 17,
            "2026-05-25": 74,
            "2026-05-26": 89,
            "2026-05-27": 61,
            "2026-05-28": 67,
            "2026-05-29": 89,
            "2026-05-30": 63,
            "2026-06-01": 82,
            "2026-06-02": 80,
            "2026-06-03": 26,
            "2026-06-05": 52,
            "2026-06-07": 1,
            "2026-06-08": 64
          },
          "time_per_day": {
            "2025-09-30": 0.39751861111111114,
            "2025-10-03": 0.021263888888888888,
            "2025-10-06": 0.7613808333333334,
            "2025-10-07": 2.247374722222222,
            "2025-10-08": 2.5312477777777778,
            "2025-10-09": 1.2593172222222222,
            "2025-10-10": 13.018523333333333,
            "2025-10-13": 70.28719694444445,
            "2025-10-14": 134.54258527777776,
            "2025-10-15": 15.514913055555555,
            "2025-10-17": 3.7378861111111106,
            "2025-10-20": 5.207591944444444,
            "2025-10-21": 12.232139444444446,
            "2025-10-23": 3.947646666666667,
            "2025-10-24": 4.281496944444444,
            "2025-10-25": 1.2203088888888889,
            "2025-10-26": 0.5912069444444444,
            "2025-10-27": 2.5519249999999998,
            "2025-10-28": 1.5131844444444444,
            "2025-10-29": 86.24610194444445,
            "2025-10-30": 0.9753711111111111,
            "2025-10-31": 0.8029980555555556,
            "2025-11-02": 6.409595277777778,
            "2025-11-03": 2.3862502777777777,
            "2025-11-04": 878.9484986111111,
            "2025-11-05": 708.2831222222222,
            "2025-11-06": 2.1948025,
            "2025-11-07": 0.7197175,
            "2025-11-10": 2.341073333333333,
            "2025-11-11": 3.1950027777777774,
            "2025-11-12": 1.9303033333333335,
            "2025-11-13": 11.685139166666668,
            "2025-11-14": 748.5823819444445,
            "2025-11-15": 0.20001194444444445,
            "2025-11-16": 1.5785355555555556,
            "2025-11-17": 45.221200555555555,
            "2025-11-18": 0.9757916666666666,
            "2025-11-19": 1.0903713888888888,
            "2025-11-20": 2.7672572222222223,
            "2025-11-21": 5.813423611111111,
            "2025-11-22": 0.10855555555555556,
            "2025-11-23": 4.54905,
            "2025-11-24": 0.42017944444444444,
            "2025-11-25": 0.5955447222222222,
            "2025-11-26": 8.714044166666666,
            "2025-11-27": 3.5771949999999997,
            "2025-11-28": 2.3230555555555554,
            "2025-11-29": 6.347163055555556,
            "2025-11-30": 0.03324916666666667,
            "2025-12-01": 0.8959808333333333,
            "2025-12-02": 4.3632725,
            "2025-12-03": 9.004628611111114,
            "2025-12-04": 6.118444444444444,
            "2025-12-05": 5.062986944444445,
            "2025-12-06": 3.4375983333333333,
            "2025-12-07": 0.18633083333333333,
            "2025-12-09": 1.2998294444444445,
            "2025-12-10": 2.4602675000000005,
            "2025-12-11": 2.3460938888888885,
            "2025-12-12": 2.112637777777778,
            "2025-12-14": 4.941235833333334,
            "2025-12-15": 74.55829083333332,
            "2025-12-16": 49.95013333333333,
            "2025-12-17": 1139.072772777778,
            "2025-12-18": 3.5761244444444444,
            "2025-12-19": 664.5616516666668,
            "2025-12-21": 89.8079611111111,
            "2025-12-22": 110.52973694444444,
            "2025-12-23": 290.8313052777778,
            "2025-12-26": 1665.5290388888889,
            "2025-12-29": 2884.6093272222215,
            "2025-12-30": 4.208087777777778,
            "2025-12-31": 17.479653055555556,
            "2026-01-02": 755.9054822222224,
            "2026-01-03": 0.9715977777777778,
            "2026-01-04": 0.23874944444444446,
            "2026-01-05": 638.9597463888888,
            "2026-01-06": 121.38950722222222,
            "2026-01-07": 22.017985833333334,
            "2026-01-08": 3.537315,
            "2026-01-09": 35.281893888888895,
            "2026-01-10": 4.734784722222222,
            "2026-01-12": 317.7920477777778,
            "2026-01-13": 28.667740833333333,
            "2026-01-14": 173.94958388888887,
            "2026-01-15": 181.61561638888887,
            "2026-01-16": 485.333628611111,
            "2026-01-17": 770.4592133333333,
            "2026-01-18": 3.9855472222222224,
            "2026-01-19": 85.26962166666665,
            "2026-01-20": 154.14520583333334,
            "2026-01-21": 173.69945777777784,
            "2026-01-22": 165.66245111111115,
            "2026-01-23": 506.4030841666667,
            "2026-01-24": 0.09553694444444444,
            "2026-01-26": 238.53695083333338,
            "2026-01-27": 68.62901555555555,
            "2026-01-28": 38.30271055555555,
            "2026-01-29": 54.121003333333334,
            "2026-01-30": 257.8032055555556,
            "2026-01-31": 1.8519616666666665,
            "2026-02-02": 156.76013805555556,
            "2026-02-03": 1088.631670833334,
            "2026-02-04": 44.29557222222221,
            "2026-02-05": 25.06510666666667,
            "2026-02-06": 290.5879302777777,
            "2026-02-07": 532.1782808333334,
            "2026-02-09": 467.6151216666666,
            "2026-02-10": 7629.415310555555,
            "2026-02-11": 174.34704472222222,
            "2026-02-12": 802.0345016666666,
            "2026-02-13": 6301.245764166667,
            "2026-02-14": 876.5482505555555,
            "2026-02-16": 6441.6638022222205,
            "2026-02-17": 809.2356566666667,
            "2026-02-18": 8482.067904722222,
            "2026-02-19": 1.4525191666666666,
            "2026-02-20": 989.2936727777779,
            "2026-02-21": 5.9190875,
            "2026-02-23": 2252.317289444445,
            "2026-02-24": 1171.0297166666662,
            "2026-02-25": 2367.4331066666664,
            "2026-02-26": 31.38134138888889,
            "2026-02-27": 23.295595,
            "2026-02-28": 763.5067105555557,
            "2026-03-02": 466.92563805555557,
            "2026-03-03": 1171.6135350000004,
            "2026-03-04": 81.21685555555555,
            "2026-03-05": 118.37331250000001,
            "2026-03-06": 667.7490399999999,
            "2026-03-07": 23.657543333333333,
            "2026-03-09": 20362.415239444435,
            "2026-03-10": 1154.1383744444445,
            "2026-03-11": 7836.485220833334,
            "2026-03-12": 85.12184472222225,
            "2026-03-13": 1150.3077438888893,
            "2026-03-14": 1.8016294444444445,
            "2026-03-16": 68.73113249999997,
            "2026-03-17": 13.801639444444445,
            "2026-03-18": 40.53310055555555,
            "2026-03-19": 17.13997861111111,
            "2026-03-20": 15.86523611111111,
            "2026-03-23": 50.92147166666666,
            "2026-03-24": 67.11172583333335,
            "2026-03-25": 20.428344166666665,
            "2026-03-26": 2.8171013888888883,
            "2026-03-27": 11.6921575,
            "2026-03-28": 5.683826944444444,
            "2026-03-30": 200.4815383333333,
            "2026-03-31": 49.3596736111111,
            "2026-04-01": 38.22740222222223,
            "2026-04-02": 43.53574388888889,
            "2026-04-04": 23.56112388888889,
            "2026-04-06": 116.7791208333333,
            "2026-04-07": 128.95055111111114,
            "2026-04-08": 211.33719694444446,
            "2026-04-09": 13.570228055555555,
            "2026-04-10": 237.73439249999993,
            "2026-04-11": 431.0084183333332,
            "2026-04-13": 3486.897580277778,
            "2026-04-14": 46.383064722222244,
            "2026-04-15": 13.898377222222221,
            "2026-04-16": 5.540063888888889,
            "2026-04-17": 281.93704194444456,
            "2026-04-18": 9.854589166666667,
            "2026-04-20": 8.548414444444443,
            "2026-04-21": 16.52367388888889,
            "2026-04-22": 34.175648333333335,
            "2026-04-23": 11.611257777777778,
            "2026-04-24": 17.32518611111111,
            "2026-04-27": 79.82272694444444,
            "2026-04-28": 21.582048055555557,
            "2026-04-29": 9.415882222222224,
            "2026-04-30": 74.72355861111112,
            "2026-05-02": 485.37755277777774,
            "2026-05-04": 109.69104555555556,
            "2026-05-05": 3.8272786111111112,
            "2026-05-06": 24.955294999999996,
            "2026-05-07": 31.245059722222226,
            "2026-05-08": 105.95977055555555,
            "2026-05-09": 87.51052388888888,
            "2026-05-11": 63.2094736111111,
            "2026-05-12": 16.886509444444442,
            "2026-05-13": 26.51112805555556,
            "2026-05-14": 65.62822444444443,
            "2026-05-15": 27.490176388888898,
            "2026-05-18": 49.658548888888895,
            "2026-05-19": 35.648480000000006,
            "2026-05-20": 25.66612027777778,
            "2026-05-21": 22.013790833333328,
            "2026-05-22": 15.802796666666666,
            "2026-05-23": 25.782598333333336,
            "2026-05-25": 316.5972808333332,
            "2026-05-26": 202.84960027777785,
            "2026-05-27": 134.39113777777777,
            "2026-05-28": 115.97938444444445,
            "2026-05-29": 460.4737777777778,
            "2026-05-30": 62.9993325,
            "2026-06-01": 336.8447002777777,
            "2026-06-02": 3477.543826944445,
            "2026-06-03": 57.94644888888889,
            "2026-06-05": 443.97138444444437,
            "2026-06-08": 35.62650527777777
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-03": 1,
            "2025-10-06": 2,
            "2025-10-07": 4,
            "2025-10-08": 6,
            "2025-10-09": 3,
            "2025-10-10": 6,
            "2025-10-13": 3,
            "2025-10-14": 14,
            "2025-10-15": 11,
            "2025-10-17": 3,
            "2025-10-20": 2,
            "2025-10-21": 6,
            "2025-10-23": 3,
            "2025-10-24": 5,
            "2025-10-25": 2,
            "2025-10-26": 1,
            "2025-10-27": 6,
            "2025-10-28": 7,
            "2025-10-29": 11,
            "2025-10-30": 2,
            "2025-10-31": 7,
            "2025-11-02": 1,
            "2025-11-03": 5,
            "2025-11-04": 2,
            "2025-11-05": 2,
            "2025-11-06": 4,
            "2025-11-07": 2,
            "2025-11-10": 5,
            "2025-11-11": 5,
            "2025-11-12": 4,
            "2025-11-13": 7,
            "2025-11-14": 3,
            "2025-11-15": 1,
            "2025-11-16": 2,
            "2025-11-17": 8,
            "2025-11-18": 1,
            "2025-11-19": 3,
            "2025-11-20": 6,
            "2025-11-21": 7,
            "2025-11-22": 1,
            "2025-11-23": 1,
            "2025-11-24": 8,
            "2025-11-25": 2,
            "2025-11-26": 5,
            "2025-11-27": 5,
            "2025-11-28": 3,
            "2025-11-29": 3,
            "2025-11-30": 1,
            "2025-12-01": 1,
            "2025-12-02": 5,
            "2025-12-03": 7,
            "2025-12-04": 7,
            "2025-12-05": 10,
            "2025-12-06": 1,
            "2025-12-07": 1,
            "2025-12-09": 2,
            "2025-12-10": 4,
            "2025-12-11": 4,
            "2025-12-12": 8,
            "2025-12-14": 2,
            "2025-12-15": 20,
            "2025-12-16": 5,
            "2025-12-17": 11,
            "2025-12-18": 4,
            "2025-12-19": 5,
            "2025-12-21": 1,
            "2025-12-22": 6,
            "2025-12-23": 6,
            "2025-12-26": 16,
            "2025-12-29": 15,
            "2025-12-30": 6,
            "2025-12-31": 4,
            "2026-01-02": 16,
            "2026-01-03": 2,
            "2026-01-04": 2,
            "2026-01-05": 5,
            "2026-01-06": 7,
            "2026-01-07": 8,
            "2026-01-08": 3,
            "2026-01-09": 11,
            "2026-01-10": 2,
            "2026-01-12": 13,
            "2026-01-13": 13,
            "2026-01-14": 24,
            "2026-01-15": 26,
            "2026-01-16": 22,
            "2026-01-17": 10,
            "2026-01-18": 3,
            "2026-01-19": 14,
            "2026-01-20": 21,
            "2026-01-21": 21,
            "2026-01-22": 16,
            "2026-01-23": 22,
            "2026-01-24": 1,
            "2026-01-26": 34,
            "2026-01-27": 8,
            "2026-01-28": 8,
            "2026-01-29": 13,
            "2026-01-30": 30,
            "2026-01-31": 2,
            "2026-02-02": 13,
            "2026-02-03": 30,
            "2026-02-04": 6,
            "2026-02-05": 10,
            "2026-02-06": 18,
            "2026-02-07": 1,
            "2026-02-09": 28,
            "2026-02-10": 25,
            "2026-02-11": 11,
            "2026-02-12": 21,
            "2026-02-13": 41,
            "2026-02-14": 10,
            "2026-02-16": 11,
            "2026-02-17": 1,
            "2026-02-18": 7,
            "2026-02-19": 3,
            "2026-02-20": 21,
            "2026-02-21": 2,
            "2026-02-23": 32,
            "2026-02-24": 20,
            "2026-02-25": 13,
            "2026-02-26": 5,
            "2026-02-27": 10,
            "2026-02-28": 30,
            "2026-03-02": 37,
            "2026-03-03": 16,
            "2026-03-04": 13,
            "2026-03-05": 35,
            "2026-03-06": 24,
            "2026-03-07": 13,
            "2026-03-09": 64,
            "2026-03-10": 23,
            "2026-03-11": 24,
            "2026-03-12": 17,
            "2026-03-13": 13,
            "2026-03-14": 4,
            "2026-03-16": 20,
            "2026-03-17": 12,
            "2026-03-18": 32,
            "2026-03-19": 25,
            "2026-03-20": 9,
            "2026-03-23": 50,
            "2026-03-24": 23,
            "2026-03-25": 26,
            "2026-03-26": 8,
            "2026-03-27": 20,
            "2026-03-28": 6,
            "2026-03-30": 46,
            "2026-03-31": 21,
            "2026-04-01": 16,
            "2026-04-02": 16,
            "2026-04-04": 10,
            "2026-04-06": 63,
            "2026-04-07": 40,
            "2026-04-08": 36,
            "2026-04-09": 10,
            "2026-04-10": 37,
            "2026-04-11": 24,
            "2026-04-13": 40,
            "2026-04-14": 40,
            "2026-04-15": 12,
            "2026-04-16": 7,
            "2026-04-17": 19,
            "2026-04-18": 4,
            "2026-04-20": 20,
            "2026-04-21": 30,
            "2026-04-22": 29,
            "2026-04-23": 29,
            "2026-04-24": 25,
            "2026-04-27": 43,
            "2026-04-28": 20,
            "2026-04-29": 19,
            "2026-04-30": 26,
            "2026-05-02": 50,
            "2026-05-04": 38,
            "2026-05-05": 10,
            "2026-05-06": 16,
            "2026-05-07": 8,
            "2026-05-08": 33,
            "2026-05-09": 24,
            "2026-05-11": 38,
            "2026-05-12": 14,
            "2026-05-13": 14,
            "2026-05-14": 18,
            "2026-05-15": 17,
            "2026-05-18": 46,
            "2026-05-19": 14,
            "2026-05-20": 23,
            "2026-05-21": 20,
            "2026-05-22": 13,
            "2026-05-23": 17,
            "2026-05-25": 74,
            "2026-05-26": 89,
            "2026-05-27": 61,
            "2026-05-28": 67,
            "2026-05-29": 89,
            "2026-05-30": 63,
            "2026-06-01": 82,
            "2026-06-02": 79,
            "2026-06-03": 26,
            "2026-06-05": 51,
            "2026-06-08": 58
          }
        },
        "P3": {
          "avg_time_hours": 269.47,
          "mode_time_hours": 9.0,
          "mode_frequency": 12,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 2,
            "4-6h": 7,
            "6-8h": 11,
            "8-10h": 12,
            "12-14h": 1,
            "14-16h": 2,
            "16-18h": 4,
            "18-20h": 9,
            "20-22h": 6,
            "22-24h": 4,
            "24-26h": 4,
            "26-28h": 4,
            "28-30h": 5,
            "30-32h": 5,
            "32-34h": 4,
            "34-36h": 2,
            "38-40h": 4,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "56-58h": 1,
            "66-68h": 3,
            "70-72h": 2,
            "72-74h": 1,
            "78-80h": 2,
            "80-82h": 2,
            "90-92h": 1,
            "94-96h": 2,
            "98-100h": 1,
            "100-102h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "144-146h": 1,
            "150-152h": 7,
            "162-164h": 2,
            "164-166h": 2,
            "166-168h": 1,
            "174-176h": 1,
            "184-186h": 1,
            "188-190h": 2,
            "192-194h": 4,
            "194-196h": 1,
            "196-198h": 1,
            "200-202h": 5,
            "242-244h": 1,
            "332-334h": 1,
            "334-336h": 1,
            "336-338h": 3,
            "344-346h": 1,
            "448-450h": 1,
            "454-456h": 1,
            "462-464h": 1,
            "472-474h": 1,
            "478-480h": 3,
            "482-484h": 1,
            "492-494h": 2,
            "494-496h": 1,
            "498-500h": 2,
            "500-502h": 1,
            "504-506h": 4,
            "510-512h": 2,
            "524-526h": 1,
            "528-530h": 3,
            "534-536h": 2,
            "576-578h": 1,
            "578-580h": 1,
            "580-582h": 1,
            "584-586h": 1,
            "592-594h": 1,
            "596-598h": 2,
            "624-626h": 1,
            "628-630h": 1,
            "642-644h": 2,
            "670-672h": 1,
            "678-680h": 1,
            "722-724h": 1,
            "782-784h": 1,
            "876-878h": 1,
            "912-914h": 1,
            "988-990h": 1,
            "1012-1014h": 1,
            "1038-1040h": 1,
            "1046-1048h": 2,
            "1050-1052h": 1,
            "1054-1056h": 1,
            "1060-1062h": 1,
            "1106-1108h": 1,
            "1152-1154h": 1,
            "1198-1200h": 1,
            "1282-1284h": 2,
            "1284-1286h": 1,
            "1348-1350h": 1,
            "1360-1362h": 1,
            "1416-1418h": 1,
            "1856-1858h": 1,
            "2048-2050h": 1
          },
          "tickets_count": 223,
          "tickets_per_day": {
            "2025-10-03": 2,
            "2025-10-07": 1,
            "2025-10-08": 1,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-11-04": 5,
            "2025-11-18": 2,
            "2025-11-19": 1,
            "2025-11-21": 3,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 8,
            "2025-12-22": 2,
            "2025-12-25": 1,
            "2025-12-26": 2,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-12": 1,
            "2026-01-15": 15,
            "2026-01-16": 2,
            "2026-01-18": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-24": 2,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-06": 4,
            "2026-02-09": 2,
            "2026-02-10": 79,
            "2026-02-12": 1,
            "2026-02-13": 30,
            "2026-02-16": 3,
            "2026-02-18": 18,
            "2026-02-19": 11,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-03-09": 5,
            "2026-03-11": 2,
            "2026-04-14": 1
          },
          "time_per_day": {
            "2025-10-03": 77.80798222222222,
            "2025-10-09": 0.2294986111111111,
            "2025-10-13": 0.6280566666666666,
            "2025-10-15": 1.8115216666666667,
            "2025-11-04": 2582.6234725,
            "2025-11-18": 1040.1496277777778,
            "2025-11-19": 1.5284197222222222,
            "2025-11-21": 4.326126111111111,
            "2025-11-28": 100.72201944444446,
            "2025-12-15": 193.9302275,
            "2025-12-17": 117.45160083333333,
            "2025-12-19": 848.0159763888889,
            "2025-12-22": 98.96625472222222,
            "2025-12-25": 56.22132055555555,
            "2025-12-26": 600.2989366666667,
            "2025-12-29": 67.47783055555556,
            "2026-01-05": 576.8091091666666,
            "2026-01-07": 4.357542222222222,
            "2026-01-12": 6.016322499999999,
            "2026-01-15": 153.85098916666666,
            "2026-01-16": 29.506838055555555,
            "2026-01-22": 4.160966111111111,
            "2026-01-23": 1198.5635597222224,
            "2026-01-24": 656.7112477777778,
            "2026-01-27": 4.422586388888889,
            "2026-01-30": 98.05877500000001,
            "2026-02-02": 0.7296752777777779,
            "2026-02-06": 609.2657272222222,
            "2026-02-09": 957.8905666666667,
            "2026-02-10": 25657.193483333343,
            "2026-02-12": 49.17926555555555,
            "2026-02-13": 5926.423231111115,
            "2026-02-16": 2430.655862222222,
            "2026-02-18": 5651.5557847222235,
            "2026-02-19": 171.40392638888886,
            "2026-02-20": 344.7796316666667,
            "2026-02-23": 877.8514341666668,
            "2026-03-09": 5391.773246666667,
            "2026-03-11": 1730.9883283333334,
            "2026-04-14": 150.66607138888887
          },
          "time_count_per_day": {
            "2025-10-03": 2,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-11-04": 4,
            "2025-11-18": 2,
            "2025-11-19": 1,
            "2025-11-21": 2,
            "2025-11-28": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 8,
            "2025-12-22": 2,
            "2025-12-25": 1,
            "2025-12-26": 2,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-12": 1,
            "2026-01-15": 15,
            "2026-01-16": 2,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-24": 2,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-06": 4,
            "2026-02-09": 2,
            "2026-02-10": 79,
            "2026-02-12": 1,
            "2026-02-13": 30,
            "2026-02-16": 3,
            "2026-02-18": 18,
            "2026-02-19": 11,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-03-09": 5,
            "2026-03-11": 2,
            "2026-04-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 157.81,
          "mode_time_hours": 1.0,
          "mode_frequency": 65,
          "time_distribution": {
            "0-2h": 65,
            "2-4h": 46,
            "4-6h": 46,
            "6-8h": 41,
            "8-10h": 25,
            "10-12h": 29,
            "12-14h": 14,
            "14-16h": 8,
            "16-18h": 30,
            "18-20h": 33,
            "20-22h": 44,
            "22-24h": 48,
            "24-26h": 56,
            "26-28h": 42,
            "28-30h": 42,
            "30-32h": 46,
            "32-34h": 21,
            "34-36h": 17,
            "36-38h": 52,
            "38-40h": 5,
            "40-42h": 27,
            "42-44h": 17,
            "44-46h": 31,
            "46-48h": 22,
            "48-50h": 22,
            "50-52h": 43,
            "52-54h": 19,
            "54-56h": 5,
            "56-58h": 17,
            "58-60h": 13,
            "60-62h": 11,
            "62-64h": 3,
            "64-66h": 3,
            "66-68h": 9,
            "68-70h": 9,
            "70-72h": 19,
            "72-74h": 14,
            "74-76h": 19,
            "76-78h": 16,
            "78-80h": 26,
            "80-82h": 17,
            "82-84h": 20,
            "84-86h": 8,
            "86-88h": 2,
            "88-90h": 6,
            "90-92h": 6,
            "92-94h": 12,
            "94-96h": 26,
            "96-98h": 21,
            "98-100h": 17,
            "100-102h": 10,
            "102-104h": 18,
            "104-106h": 19,
            "108-110h": 3,
            "110-112h": 4,
            "112-114h": 7,
            "114-116h": 11,
            "116-118h": 6,
            "118-120h": 15,
            "120-122h": 16,
            "122-124h": 19,
            "124-126h": 11,
            "126-128h": 12,
            "128-130h": 6,
            "130-132h": 6,
            "132-134h": 2,
            "134-136h": 8,
            "136-138h": 2,
            "138-140h": 5,
            "140-142h": 22,
            "142-144h": 8,
            "144-146h": 13,
            "146-148h": 8,
            "148-150h": 4,
            "150-152h": 12,
            "152-154h": 2,
            "154-156h": 7,
            "156-158h": 12,
            "158-160h": 8,
            "160-162h": 5,
            "162-164h": 9,
            "164-166h": 16,
            "166-168h": 7,
            "168-170h": 2,
            "170-172h": 1,
            "172-174h": 7,
            "174-176h": 6,
            "176-178h": 7,
            "178-180h": 8,
            "180-182h": 14,
            "182-184h": 5,
            "184-186h": 4,
            "186-188h": 3,
            "188-190h": 1,
            "190-192h": 1,
            "192-194h": 6,
            "194-196h": 9,
            "196-198h": 5,
            "198-200h": 5,
            "200-202h": 7,
            "202-204h": 4,
            "204-206h": 3,
            "206-208h": 9,
            "208-210h": 3,
            "210-212h": 5,
            "212-214h": 5,
            "214-216h": 5,
            "216-218h": 27,
            "218-220h": 3,
            "220-222h": 2,
            "222-224h": 1,
            "224-226h": 1,
            "228-230h": 8,
            "234-236h": 3,
            "238-240h": 3,
            "240-242h": 5,
            "242-244h": 2,
            "244-246h": 1,
            "252-254h": 1,
            "256-258h": 3,
            "258-260h": 3,
            "260-262h": 2,
            "264-266h": 1,
            "266-268h": 6,
            "268-270h": 1,
            "270-272h": 1,
            "272-274h": 5,
            "274-276h": 5,
            "276-278h": 7,
            "278-280h": 4,
            "280-282h": 1,
            "282-284h": 5,
            "284-286h": 2,
            "286-288h": 6,
            "288-290h": 9,
            "294-296h": 1,
            "298-300h": 1,
            "302-304h": 1,
            "304-306h": 3,
            "306-308h": 3,
            "310-312h": 10,
            "312-314h": 6,
            "314-316h": 1,
            "316-318h": 2,
            "322-324h": 1,
            "324-326h": 4,
            "328-330h": 3,
            "330-332h": 4,
            "332-334h": 5,
            "334-336h": 14,
            "336-338h": 8,
            "338-340h": 2,
            "340-342h": 1,
            "342-344h": 1,
            "346-348h": 1,
            "348-350h": 4,
            "350-352h": 2,
            "352-354h": 5,
            "354-356h": 3,
            "356-358h": 9,
            "358-360h": 7,
            "360-362h": 3,
            "362-364h": 2,
            "364-366h": 3,
            "366-368h": 1,
            "368-370h": 1,
            "370-372h": 8,
            "372-374h": 10,
            "376-378h": 2,
            "378-380h": 2,
            "380-382h": 4,
            "382-384h": 13,
            "384-386h": 19,
            "386-388h": 1,
            "388-390h": 6,
            "390-392h": 1,
            "392-394h": 2,
            "396-398h": 1,
            "398-400h": 13,
            "400-402h": 8,
            "402-404h": 2,
            "404-406h": 10,
            "406-408h": 3,
            "408-410h": 4,
            "412-414h": 1,
            "414-416h": 4,
            "416-418h": 3,
            "420-422h": 9,
            "422-424h": 6,
            "424-426h": 4,
            "426-428h": 4,
            "428-430h": 6,
            "430-432h": 3,
            "432-434h": 3,
            "442-444h": 1,
            "444-446h": 5,
            "446-448h": 4,
            "448-450h": 1,
            "450-452h": 2,
            "452-454h": 7,
            "454-456h": 8,
            "456-458h": 10,
            "458-460h": 2,
            "462-464h": 1,
            "466-468h": 7,
            "472-474h": 1,
            "474-476h": 1,
            "476-478h": 1,
            "478-480h": 3,
            "480-482h": 1,
            "482-484h": 1,
            "490-492h": 1,
            "492-494h": 3,
            "494-496h": 1,
            "496-498h": 7,
            "498-500h": 3,
            "500-502h": 6,
            "502-504h": 12,
            "504-506h": 4,
            "508-510h": 5,
            "510-512h": 1,
            "514-516h": 1,
            "522-524h": 1,
            "524-526h": 2,
            "526-528h": 1,
            "530-532h": 2,
            "532-534h": 1,
            "538-540h": 1,
            "540-542h": 1,
            "546-548h": 3,
            "548-550h": 3,
            "552-554h": 1,
            "554-556h": 1,
            "556-558h": 2,
            "558-560h": 1,
            "570-572h": 1,
            "574-576h": 1,
            "576-578h": 1,
            "582-584h": 2,
            "594-596h": 1,
            "598-600h": 2,
            "602-604h": 1,
            "604-606h": 1,
            "614-616h": 1,
            "620-622h": 2,
            "622-624h": 1,
            "624-626h": 3,
            "626-628h": 1,
            "628-630h": 2,
            "630-632h": 1,
            "634-636h": 1,
            "644-646h": 1,
            "646-648h": 2,
            "650-652h": 2,
            "652-654h": 2,
            "654-656h": 1,
            "656-658h": 1,
            "664-666h": 2,
            "674-676h": 1,
            "678-680h": 1,
            "690-692h": 1,
            "700-702h": 2,
            "702-704h": 1,
            "724-726h": 2,
            "726-728h": 1,
            "816-818h": 1,
            "824-826h": 3,
            "836-838h": 1,
            "838-840h": 1,
            "848-850h": 1,
            "858-860h": 1,
            "916-918h": 1,
            "966-968h": 1,
            "982-984h": 2,
            "1152-1154h": 1,
            "1222-1224h": 2,
            "1412-1414h": 1,
            "1506-1508h": 1,
            "1846-1848h": 1,
            "2344-2346h": 1
          },
          "tickets_count": 2691,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 28,
            "2025-10-08": 2,
            "2025-10-09": 10,
            "2025-10-10": 2,
            "2025-10-13": 23,
            "2025-10-14": 13,
            "2025-10-15": 17,
            "2025-10-16": 2,
            "2025-10-17": 21,
            "2025-10-20": 8,
            "2025-10-21": 6,
            "2025-10-22": 4,
            "2025-10-23": 22,
            "2025-10-25": 8,
            "2025-10-27": 17,
            "2025-10-28": 1,
            "2025-10-29": 17,
            "2025-10-30": 8,
            "2025-10-31": 9,
            "2025-11-03": 5,
            "2025-11-05": 20,
            "2025-11-06": 5,
            "2025-11-07": 2,
            "2025-11-10": 8,
            "2025-11-11": 7,
            "2025-11-12": 14,
            "2025-11-13": 4,
            "2025-11-14": 16,
            "2025-11-17": 2,
            "2025-11-19": 18,
            "2025-11-20": 26,
            "2025-11-21": 25,
            "2025-11-22": 8,
            "2025-11-23": 2,
            "2025-11-24": 6,
            "2025-11-25": 9,
            "2025-11-29": 12,
            "2025-12-02": 26,
            "2025-12-03": 27,
            "2025-12-04": 8,
            "2025-12-05": 5,
            "2025-12-09": 3,
            "2025-12-10": 13,
            "2025-12-11": 6,
            "2025-12-15": 33,
            "2025-12-16": 5,
            "2025-12-18": 2,
            "2025-12-19": 4,
            "2025-12-22": 19,
            "2025-12-23": 2,
            "2025-12-26": 6,
            "2025-12-29": 8,
            "2025-12-30": 4,
            "2026-01-02": 2,
            "2026-01-03": 1,
            "2026-01-08": 35,
            "2026-01-09": 17,
            "2026-01-12": 1,
            "2026-01-13": 34,
            "2026-01-14": 1,
            "2026-01-15": 14,
            "2026-01-16": 5,
            "2026-01-17": 6,
            "2026-01-18": 1,
            "2026-01-21": 18,
            "2026-01-23": 23,
            "2026-01-24": 31,
            "2026-01-26": 1,
            "2026-01-27": 51,
            "2026-01-30": 9,
            "2026-01-31": 5,
            "2026-02-02": 3,
            "2026-02-04": 8,
            "2026-02-05": 25,
            "2026-02-06": 85,
            "2026-02-09": 17,
            "2026-02-10": 28,
            "2026-02-11": 20,
            "2026-02-12": 17,
            "2026-02-13": 16,
            "2026-02-14": 9,
            "2026-02-16": 1,
            "2026-02-17": 5,
            "2026-02-18": 23,
            "2026-02-19": 34,
            "2026-02-20": 2,
            "2026-02-21": 35,
            "2026-02-23": 38,
            "2026-02-24": 2,
            "2026-02-25": 4,
            "2026-02-26": 2,
            "2026-02-27": 1,
            "2026-02-28": 105,
            "2026-03-01": 1,
            "2026-03-02": 8,
            "2026-03-03": 5,
            "2026-03-04": 7,
            "2026-03-05": 3,
            "2026-03-06": 3,
            "2026-03-07": 2,
            "2026-03-09": 5,
            "2026-03-10": 8,
            "2026-03-11": 6,
            "2026-03-14": 39,
            "2026-03-16": 2,
            "2026-03-17": 102,
            "2026-03-18": 504,
            "2026-03-19": 1,
            "2026-03-20": 31,
            "2026-03-23": 2,
            "2026-03-24": 52,
            "2026-03-25": 10,
            "2026-03-26": 61,
            "2026-03-27": 6,
            "2026-03-28": 3,
            "2026-03-30": 36,
            "2026-03-31": 9,
            "2026-04-01": 6,
            "2026-04-02": 6,
            "2026-04-04": 4,
            "2026-04-06": 6,
            "2026-04-07": 7,
            "2026-04-08": 6,
            "2026-04-09": 9,
            "2026-04-10": 4,
            "2026-04-11": 1,
            "2026-04-13": 1,
            "2026-04-14": 3,
            "2026-04-15": 7,
            "2026-04-16": 2,
            "2026-04-17": 1,
            "2026-04-18": 2,
            "2026-04-20": 3,
            "2026-04-21": 2,
            "2026-04-22": 63,
            "2026-04-23": 5,
            "2026-04-24": 14,
            "2026-04-27": 22,
            "2026-04-28": 8,
            "2026-04-29": 12,
            "2026-04-30": 10,
            "2026-05-01": 2,
            "2026-05-02": 14,
            "2026-05-04": 14,
            "2026-05-05": 9,
            "2026-05-06": 16,
            "2026-05-07": 8,
            "2026-05-08": 14,
            "2026-05-09": 10,
            "2026-05-11": 8,
            "2026-05-12": 9,
            "2026-05-13": 6,
            "2026-05-14": 6,
            "2026-05-15": 6,
            "2026-05-18": 12,
            "2026-05-19": 8,
            "2026-05-20": 15,
            "2026-05-21": 11,
            "2026-05-22": 6,
            "2026-05-23": 1,
            "2026-05-25": 12,
            "2026-05-26": 4,
            "2026-05-27": 9,
            "2026-05-28": 7,
            "2026-05-29": 10,
            "2026-05-30": 4,
            "2026-06-01": 4,
            "2026-06-02": 5,
            "2026-06-03": 7,
            "2026-06-05": 5,
            "2026-06-06": 5,
            "2026-06-08": 12
          },
          "time_per_day": {
            "2025-09-30": 8.730323055555555,
            "2025-10-01": 26.06114138888889,
            "2025-10-03": 77.00389916666666,
            "2025-10-06": 0.2261397222222222,
            "2025-10-07": 1473.3353519444447,
            "2025-10-08": 24.207752777777777,
            "2025-10-09": 293.0410333333333,
            "2025-10-10": 83.31462638888888,
            "2025-10-13": 1643.106725277778,
            "2025-10-14": 332.30034222222224,
            "2025-10-15": 478.17707388888897,
            "2025-10-16": 51.901759444444444,
            "2025-10-17": 600.4831919444445,
            "2025-10-20": 524.6354675,
            "2025-10-21": 353.0865875,
            "2025-10-22": 261.9568313888889,
            "2025-10-23": 803.4192783333332,
            "2025-10-25": 556.5096319444444,
            "2025-10-27": 441.0875802777779,
            "2025-10-28": 112.77314861111111,
            "2025-10-29": 647.1027088888889,
            "2025-10-30": 619.6412616666668,
            "2025-10-31": 801.2731100000002,
            "2025-11-03": 214.84650750000006,
            "2025-11-05": 1351.9214844444443,
            "2025-11-06": 86.34569222222223,
            "2025-11-07": 10.500877222222222,
            "2025-11-10": 270.3736527777778,
            "2025-11-11": 132.83847166666666,
            "2025-11-12": 422.24723805555556,
            "2025-11-13": 336.3064963888889,
            "2025-11-14": 435.46917305555564,
            "2025-11-17": 192.17588916666665,
            "2025-11-19": 2127.918883055556,
            "2025-11-20": 1551.2522841666669,
            "2025-11-21": 1184.905641388889,
            "2025-11-22": 251.67333138888887,
            "2025-11-23": 167.58566583333334,
            "2025-11-24": 284.41399138888886,
            "2025-11-25": 208.5084277777778,
            "2025-11-29": 1250.137724166667,
            "2025-12-02": 2539.9803475,
            "2025-12-03": 2482.634415555555,
            "2025-12-04": 531.5756275,
            "2025-12-05": 342.50913027777784,
            "2025-12-09": 463.0160102777777,
            "2025-12-10": 472.8905525,
            "2025-12-11": 356.2948936111111,
            "2025-12-15": 2363.849196666667,
            "2025-12-16": 54.46674277777778,
            "2025-12-18": 101.54243861111112,
            "2025-12-19": 122.7490525,
            "2025-12-22": 383.99791027777775,
            "2025-12-23": 41.38577444444445,
            "2025-12-26": 615.3942780555556,
            "2025-12-29": 1528.0387966666665,
            "2025-12-30": 442.5796055555556,
            "2026-01-02": 83.53357944444444,
            "2026-01-08": 3043.5181644444447,
            "2026-01-09": 898.1341563888889,
            "2026-01-12": 577.3386069444445,
            "2026-01-13": 2385.1664144444444,
            "2026-01-15": 1217.8775291666668,
            "2026-01-16": 152.70728444444447,
            "2026-01-17": 159.38182194444443,
            "2026-01-18": 49.25654222222222,
            "2026-01-21": 1152.7598858333333,
            "2026-01-23": 2538.404043611112,
            "2026-01-24": 4738.290933333334,
            "2026-01-26": 141.78708805555556,
            "2026-01-27": 3724.0806002777786,
            "2026-01-30": 3805.7896075,
            "2026-01-31": 732.5578702777779,
            "2026-02-02": 291.3593063888889,
            "2026-02-04": 925.6502922222223,
            "2026-02-05": 3849.8910063888884,
            "2026-02-06": 19683.526150277787,
            "2026-02-09": 1705.9583597222222,
            "2026-02-10": 8284.579282222223,
            "2026-02-11": 3549.9131072222226,
            "2026-02-12": 2135.5949719444443,
            "2026-02-13": 1996.694378611111,
            "2026-02-14": 753.2859988888889,
            "2026-02-16": 91.5712575,
            "2026-02-17": 768.7245447222223,
            "2026-02-18": 2056.0249566666666,
            "2026-02-19": 1304.9263105555558,
            "2026-02-20": 2.2928872222222223,
            "2026-02-21": 880.5069977777778,
            "2026-02-23": 1387.3828400000004,
            "2026-02-25": 0.16812472222222222,
            "2026-02-26": 20.466793888888887,
            "2026-02-27": 0.19803777777777778,
            "2026-02-28": 8058.580518055558,
            "2026-03-02": 327.4029586111111,
            "2026-03-06": 1.2834841666666665,
            "2026-03-07": 0.012258888888888889,
            "2026-03-14": 2800.7672597222213,
            "2026-03-17": 3963.3662405555556,
            "2026-03-18": 163629.1897950002,
            "2026-03-20": 1507.8747613888886,
            "2026-03-24": 5401.455450277779,
            "2026-03-25": 138.21975305555557,
            "2026-03-26": 30050.62612611111,
            "2026-03-30": 4841.123677222222,
            "2026-04-07": 0.796861111111111,
            "2026-04-08": 145.07749555555554,
            "2026-04-11": 213.39262638888889,
            "2026-04-22": 7961.982295277776,
            "2026-04-27": 95.15757555555555,
            "2026-05-01": 392.60974166666665,
            "2026-05-06": 1847.0052547222224,
            "2026-05-07": 349.61040638888886,
            "2026-05-14": 1413.5362316666667,
            "2026-05-25": 100.02589055555556,
            "2026-05-29": 2447.031906111111,
            "2026-06-01": 1254.5499897222223,
            "2026-06-03": 186.51974194444446
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 28,
            "2025-10-08": 2,
            "2025-10-09": 10,
            "2025-10-10": 2,
            "2025-10-13": 23,
            "2025-10-14": 13,
            "2025-10-15": 17,
            "2025-10-16": 2,
            "2025-10-17": 21,
            "2025-10-20": 8,
            "2025-10-21": 6,
            "2025-10-22": 4,
            "2025-10-23": 22,
            "2025-10-25": 8,
            "2025-10-27": 17,
            "2025-10-28": 1,
            "2025-10-29": 17,
            "2025-10-30": 8,
            "2025-10-31": 9,
            "2025-11-03": 5,
            "2025-11-05": 20,
            "2025-11-06": 5,
            "2025-11-07": 2,
            "2025-11-10": 8,
            "2025-11-11": 7,
            "2025-11-12": 14,
            "2025-11-13": 4,
            "2025-11-14": 16,
            "2025-11-17": 2,
            "2025-11-19": 18,
            "2025-11-20": 26,
            "2025-11-21": 25,
            "2025-11-22": 8,
            "2025-11-23": 2,
            "2025-11-24": 6,
            "2025-11-25": 8,
            "2025-11-29": 12,
            "2025-12-02": 26,
            "2025-12-03": 27,
            "2025-12-04": 8,
            "2025-12-05": 5,
            "2025-12-09": 3,
            "2025-12-10": 13,
            "2025-12-11": 6,
            "2025-12-15": 33,
            "2025-12-16": 5,
            "2025-12-18": 2,
            "2025-12-19": 4,
            "2025-12-22": 19,
            "2025-12-23": 2,
            "2025-12-26": 6,
            "2025-12-29": 8,
            "2025-12-30": 4,
            "2026-01-02": 2,
            "2026-01-08": 35,
            "2026-01-09": 17,
            "2026-01-12": 1,
            "2026-01-13": 34,
            "2026-01-15": 14,
            "2026-01-16": 5,
            "2026-01-17": 6,
            "2026-01-18": 1,
            "2026-01-21": 18,
            "2026-01-23": 23,
            "2026-01-24": 31,
            "2026-01-26": 1,
            "2026-01-27": 51,
            "2026-01-30": 9,
            "2026-01-31": 5,
            "2026-02-02": 3,
            "2026-02-04": 7,
            "2026-02-05": 25,
            "2026-02-06": 85,
            "2026-02-09": 17,
            "2026-02-10": 28,
            "2026-02-11": 19,
            "2026-02-12": 16,
            "2026-02-13": 16,
            "2026-02-14": 8,
            "2026-02-16": 1,
            "2026-02-17": 5,
            "2026-02-18": 21,
            "2026-02-19": 33,
            "2026-02-20": 1,
            "2026-02-21": 35,
            "2026-02-23": 38,
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 101,
            "2026-03-02": 5,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-14": 38,
            "2026-03-17": 102,
            "2026-03-18": 500,
            "2026-03-20": 29,
            "2026-03-24": 51,
            "2026-03-25": 8,
            "2026-03-26": 60,
            "2026-03-30": 25,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-11": 1,
            "2026-04-22": 54,
            "2026-04-27": 1,
            "2026-05-01": 2,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-14": 1,
            "2026-05-25": 1,
            "2026-05-29": 2,
            "2026-06-01": 2,
            "2026-06-03": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 571.37,
          "mode_time_hours": 73.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 2,
            "4-6h": 4,
            "6-8h": 2,
            "8-10h": 1,
            "10-12h": 1,
            "14-16h": 2,
            "18-20h": 1,
            "20-22h": 4,
            "22-24h": 2,
            "28-30h": 2,
            "30-32h": 1,
            "36-38h": 1,
            "40-42h": 1,
            "44-46h": 3,
            "46-48h": 3,
            "50-52h": 1,
            "52-54h": 3,
            "56-58h": 2,
            "62-64h": 1,
            "72-74h": 9,
            "74-76h": 1,
            "78-80h": 1,
            "90-92h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "100-102h": 3,
            "114-116h": 1,
            "116-118h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 2,
            "130-132h": 1,
            "132-134h": 2,
            "134-136h": 1,
            "136-138h": 5,
            "138-140h": 1,
            "142-144h": 2,
            "146-148h": 1,
            "158-160h": 2,
            "160-162h": 2,
            "162-164h": 1,
            "164-166h": 1,
            "166-168h": 1,
            "170-172h": 1,
            "178-180h": 1,
            "180-182h": 3,
            "182-184h": 2,
            "184-186h": 2,
            "186-188h": 2,
            "190-192h": 1,
            "192-194h": 3,
            "196-198h": 2,
            "202-204h": 2,
            "204-206h": 6,
            "206-208h": 2,
            "208-210h": 3,
            "216-218h": 7,
            "228-230h": 1,
            "230-232h": 3,
            "232-234h": 3,
            "234-236h": 4,
            "236-238h": 2,
            "240-242h": 9,
            "258-260h": 1,
            "284-286h": 1,
            "288-290h": 4,
            "290-292h": 1,
            "294-296h": 1,
            "298-300h": 1,
            "300-302h": 7,
            "302-304h": 7,
            "304-306h": 1,
            "306-308h": 4,
            "310-312h": 1,
            "312-314h": 2,
            "318-320h": 1,
            "322-324h": 2,
            "324-326h": 1,
            "326-328h": 1,
            "328-330h": 3,
            "330-332h": 3,
            "334-336h": 2,
            "336-338h": 3,
            "344-346h": 1,
            "350-352h": 2,
            "354-356h": 1,
            "360-362h": 1,
            "364-366h": 3,
            "372-374h": 2,
            "374-376h": 3,
            "382-384h": 1,
            "384-386h": 5,
            "394-396h": 1,
            "396-398h": 1,
            "400-402h": 1,
            "402-404h": 1,
            "404-406h": 2,
            "406-408h": 1,
            "408-410h": 6,
            "442-444h": 1,
            "450-452h": 1,
            "468-470h": 1,
            "470-472h": 1,
            "472-474h": 7,
            "474-476h": 2,
            "476-478h": 4,
            "478-480h": 3,
            "480-482h": 1,
            "492-494h": 1,
            "496-498h": 2,
            "498-500h": 1,
            "500-502h": 1,
            "502-504h": 1,
            "504-506h": 4,
            "520-522h": 1,
            "522-524h": 1,
            "528-530h": 1,
            "532-534h": 1,
            "542-544h": 2,
            "544-546h": 6,
            "546-548h": 1,
            "548-550h": 2,
            "550-552h": 3,
            "552-554h": 2,
            "564-566h": 5,
            "566-568h": 2,
            "568-570h": 1,
            "570-572h": 1,
            "574-576h": 1,
            "576-578h": 9,
            "580-582h": 1,
            "616-618h": 4,
            "618-620h": 1,
            "622-624h": 2,
            "624-626h": 2,
            "634-636h": 2,
            "636-638h": 1,
            "638-640h": 4,
            "642-644h": 1,
            "650-652h": 1,
            "652-654h": 1,
            "658-660h": 2,
            "662-664h": 1,
            "664-666h": 3,
            "666-668h": 2,
            "668-670h": 2,
            "670-672h": 2,
            "672-674h": 4,
            "682-684h": 6,
            "684-686h": 1,
            "688-690h": 1,
            "690-692h": 3,
            "692-694h": 5,
            "694-696h": 1,
            "708-710h": 1,
            "710-712h": 3,
            "714-716h": 1,
            "716-718h": 1,
            "718-720h": 1,
            "720-722h": 5,
            "728-730h": 1,
            "732-734h": 1,
            "734-736h": 6,
            "736-738h": 3,
            "738-740h": 3,
            "740-742h": 1,
            "744-746h": 1,
            "762-764h": 1,
            "766-768h": 1,
            "768-770h": 5,
            "784-786h": 1,
            "786-788h": 1,
            "788-790h": 2,
            "790-792h": 3,
            "792-794h": 1,
            "804-806h": 5,
            "808-810h": 2,
            "814-816h": 2,
            "816-818h": 1,
            "826-828h": 2,
            "828-830h": 1,
            "830-832h": 1,
            "840-842h": 1,
            "844-846h": 1,
            "852-854h": 3,
            "854-856h": 1,
            "860-862h": 1,
            "876-878h": 2,
            "878-880h": 1,
            "900-902h": 1,
            "908-910h": 1,
            "912-914h": 2,
            "960-962h": 1,
            "966-968h": 1,
            "972-974h": 1,
            "976-978h": 1,
            "978-980h": 2,
            "982-984h": 2,
            "994-996h": 1,
            "1002-1004h": 1,
            "1008-1010h": 4,
            "1020-1022h": 3,
            "1026-1028h": 2,
            "1044-1046h": 1,
            "1050-1052h": 1,
            "1056-1058h": 1,
            "1066-1068h": 1,
            "1068-1070h": 1,
            "1072-1074h": 2,
            "1078-1080h": 2,
            "1080-1082h": 2,
            "1100-1102h": 1,
            "1124-1126h": 8,
            "1138-1140h": 2,
            "1142-1144h": 1,
            "1150-1152h": 1,
            "1198-1200h": 1,
            "1214-1216h": 1,
            "1216-1218h": 1,
            "1236-1238h": 2,
            "1238-1240h": 1,
            "1240-1242h": 1,
            "1248-1250h": 1,
            "1270-1272h": 3,
            "1344-1346h": 1,
            "1368-1370h": 2,
            "1406-1408h": 1,
            "1408-1410h": 1,
            "1416-1418h": 4,
            "1460-1462h": 1,
            "1462-1464h": 1,
            "1488-1490h": 1,
            "1546-1548h": 1,
            "1698-1700h": 2,
            "1704-1706h": 2,
            "1718-1720h": 1,
            "1838-1840h": 2,
            "1862-1864h": 1,
            "1916-1918h": 1,
            "1962-1964h": 1,
            "1964-1966h": 2,
            "2036-2038h": 1,
            "2054-2056h": 1,
            "2132-2134h": 1,
            "2208-2210h": 1,
            "2272-2274h": 1,
            "3186-3188h": 1
          },
          "tickets_count": 580,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 9,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-11": 12,
            "2025-12-15": 9,
            "2025-12-16": 5,
            "2025-12-17": 5,
            "2025-12-18": 2,
            "2025-12-19": 1,
            "2025-12-22": 4,
            "2025-12-26": 4,
            "2025-12-29": 5,
            "2026-01-02": 7,
            "2026-01-14": 1,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-17": 13,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-14": 1,
            "2026-02-16": 5,
            "2026-02-17": 6,
            "2026-02-18": 15,
            "2026-02-19": 403,
            "2026-02-20": 8,
            "2026-02-21": 2,
            "2026-02-23": 17,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 4,
            "2026-03-03": 2,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-06": 4,
            "2026-03-09": 4,
            "2026-03-11": 5,
            "2026-03-21": 2
          },
          "time_per_day": {
            "2025-12-02": 134.65423694444445,
            "2025-12-03": 646.6295922222222,
            "2025-12-04": 15.857530555555556,
            "2025-12-05": 162.7952347222222,
            "2025-12-10": 5.782671111111112,
            "2025-12-11": 859.345117222222,
            "2025-12-15": 1433.7628705555555,
            "2025-12-16": 947.3718483333333,
            "2025-12-17": 667.4154191666667,
            "2025-12-18": 438.25786472222217,
            "2025-12-19": 443.54567305555554,
            "2025-12-22": 1095.9193366666666,
            "2025-12-26": 1295.4228025,
            "2025-12-29": 3130.3626858333328,
            "2026-01-02": 1906.9033894444447,
            "2026-01-14": 1.923925,
            "2026-01-15": 3221.4734291666664,
            "2026-01-16": 10.021557222222222,
            "2026-01-17": 1956.708928888889,
            "2026-01-23": 75.05059138888889,
            "2026-01-26": 2.3096630555555557,
            "2026-01-27": 65.93293416666667,
            "2026-02-03": 1581.4455555555555,
            "2026-02-05": 179.07435750000002,
            "2026-02-13": 665.9047383333333,
            "2026-02-18": 20890.08774916666,
            "2026-02-19": 244423.80336555568
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 9,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-11": 12,
            "2025-12-15": 9,
            "2025-12-16": 5,
            "2025-12-17": 5,
            "2025-12-18": 2,
            "2025-12-19": 1,
            "2025-12-22": 4,
            "2025-12-26": 4,
            "2025-12-29": 5,
            "2026-01-02": 7,
            "2026-01-14": 1,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-17": 13,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-13": 2,
            "2026-02-18": 11,
            "2026-02-19": 394
          }
        }
      },
      "states": {
        "Aguarda Assinatura (rgpd Cvo)": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-18": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Closed": {
          "overall": {
            "avg_time_hours": 125.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 2383,
            "time_distribution": {
              "0-2h": 2383,
              "2-4h": 482,
              "4-6h": 242,
              "6-8h": 139,
              "8-10h": 84,
              "10-12h": 55,
              "12-14h": 39,
              "14-16h": 32,
              "16-18h": 56,
              "18-20h": 59,
              "20-22h": 71,
              "22-24h": 65,
              "24-26h": 67,
              "26-28h": 50,
              "28-30h": 54,
              "30-32h": 56,
              "32-34h": 26,
              "34-36h": 22,
              "36-38h": 59,
              "38-40h": 27,
              "40-42h": 34,
              "42-44h": 20,
              "44-46h": 41,
              "46-48h": 30,
              "48-50h": 25,
              "50-52h": 46,
              "52-54h": 22,
              "54-56h": 5,
              "56-58h": 20,
              "58-60h": 14,
              "60-62h": 11,
              "62-64h": 5,
              "64-66h": 3,
              "66-68h": 12,
              "68-70h": 14,
              "70-72h": 21,
              "72-74h": 31,
              "74-76h": 26,
              "76-78h": 19,
              "78-80h": 30,
              "80-82h": 20,
              "82-84h": 20,
              "84-86h": 8,
              "86-88h": 2,
              "88-90h": 7,
              "90-92h": 9,
              "92-94h": 16,
              "94-96h": 30,
              "96-98h": 23,
              "98-100h": 18,
              "100-102h": 16,
              "102-104h": 19,
              "104-106h": 19,
              "106-108h": 2,
              "108-110h": 3,
              "110-112h": 4,
              "112-114h": 7,
              "114-116h": 12,
              "116-118h": 8,
              "118-120h": 16,
              "120-122h": 19,
              "122-124h": 25,
              "124-126h": 12,
              "126-128h": 13,
              "128-130h": 7,
              "130-132h": 7,
              "132-134h": 4,
              "134-136h": 9,
              "136-138h": 7,
              "138-140h": 7,
              "140-142h": 22,
              "142-144h": 12,
              "144-146h": 15,
              "146-148h": 9,
              "148-150h": 4,
              "150-152h": 20,
              "152-154h": 2,
              "154-156h": 7,
              "156-158h": 12,
              "158-160h": 10,
              "160-162h": 7,
              "162-164h": 19,
              "164-166h": 20,
              "166-168h": 9,
              "168-170h": 2,
              "170-172h": 2,
              "172-174h": 8,
              "174-176h": 7,
              "176-178h": 9,
              "178-180h": 9,
              "180-182h": 17,
              "182-184h": 7,
              "184-186h": 7,
              "186-188h": 6,
              "188-190h": 4,
              "190-192h": 2,
              "192-194h": 13,
              "194-196h": 11,
              "196-198h": 8,
              "198-200h": 6,
              "200-202h": 12,
              "202-204h": 6,
              "204-206h": 9,
              "206-208h": 11,
              "208-210h": 8,
              "210-212h": 5,
              "212-214h": 5,
              "214-216h": 5,
              "216-218h": 34,
              "218-220h": 3,
              "220-222h": 2,
              "222-224h": 1,
              "224-226h": 1,
              "228-230h": 9,
              "230-232h": 3,
              "232-234h": 3,
              "234-236h": 8,
              "236-238h": 3,
              "238-240h": 4,
              "240-242h": 14,
              "242-244h": 3,
              "244-246h": 1,
              "246-248h": 1,
              "252-254h": 1,
              "254-256h": 1,
              "256-258h": 4,
              "258-260h": 4,
              "260-262h": 3,
              "264-266h": 1,
              "266-268h": 8,
              "268-270h": 2,
              "270-272h": 1,
              "272-274h": 5,
              "274-276h": 6,
              "276-278h": 7,
              "278-280h": 4,
              "280-282h": 2,
              "282-284h": 5,
              "284-286h": 3,
              "286-288h": 6,
              "288-290h": 13,
              "290-292h": 1,
              "294-296h": 2,
              "298-300h": 2,
              "300-302h": 7,
              "302-304h": 9,
              "304-306h": 4,
              "306-308h": 7,
              "310-312h": 11,
              "312-314h": 10,
              "314-316h": 1,
              "316-318h": 2,
              "318-320h": 2,
              "322-324h": 3,
              "324-326h": 6,
              "326-328h": 1,
              "328-330h": 6,
              "330-332h": 7,
              "332-334h": 6,
              "334-336h": 17,
              "336-338h": 16,
              "338-340h": 3,
              "340-342h": 1,
              "342-344h": 1,
              "344-346h": 2,
              "346-348h": 2,
              "348-350h": 6,
              "350-352h": 4,
              "352-354h": 5,
              "354-356h": 4,
              "356-358h": 9,
              "358-360h": 9,
              "360-362h": 4,
              "362-364h": 2,
              "364-366h": 6,
              "366-368h": 1,
              "368-370h": 1,
              "370-372h": 8,
              "372-374h": 12,
              "374-376h": 3,
              "376-378h": 2,
              "378-380h": 2,
              "380-382h": 4,
              "382-384h": 14,
              "384-386h": 24,
              "386-388h": 1,
              "388-390h": 6,
              "390-392h": 1,
              "392-394h": 3,
              "394-396h": 1,
              "396-398h": 2,
              "398-400h": 13,
              "400-402h": 10,
              "402-404h": 3,
              "404-406h": 12,
              "406-408h": 4,
              "408-410h": 10,
              "412-414h": 1,
              "414-416h": 4,
              "416-418h": 3,
              "418-420h": 1,
              "420-422h": 9,
              "422-424h": 7,
              "424-426h": 6,
              "426-428h": 4,
              "428-430h": 6,
              "430-432h": 3,
              "432-434h": 3,
              "434-436h": 1,
              "442-444h": 2,
              "444-446h": 5,
              "446-448h": 4,
              "448-450h": 2,
              "450-452h": 4,
              "452-454h": 7,
              "454-456h": 9,
              "456-458h": 10,
              "458-460h": 2,
              "462-464h": 3,
              "466-468h": 7,
              "468-470h": 1,
              "470-472h": 1,
              "472-474h": 9,
              "474-476h": 3,
              "476-478h": 5,
              "478-480h": 9,
              "480-482h": 2,
              "482-484h": 2,
              "486-488h": 1,
              "490-492h": 1,
              "492-494h": 6,
              "494-496h": 2,
              "496-498h": 9,
              "498-500h": 6,
              "500-502h": 8,
              "502-504h": 13,
              "504-506h": 13,
              "506-508h": 2,
              "508-510h": 7,
              "510-512h": 3,
              "514-516h": 1,
              "520-522h": 1,
              "522-524h": 2,
              "524-526h": 3,
              "526-528h": 3,
              "528-530h": 7,
              "530-532h": 2,
              "532-534h": 3,
              "534-536h": 2,
              "538-540h": 1,
              "540-542h": 1,
              "542-544h": 2,
              "544-546h": 6,
              "546-548h": 4,
              "548-550h": 5,
              "550-552h": 3,
              "552-554h": 4,
              "554-556h": 1,
              "556-558h": 2,
              "558-560h": 1,
              "564-566h": 5,
              "566-568h": 2,
              "568-570h": 1,
              "570-572h": 2,
              "574-576h": 2,
              "576-578h": 11,
              "578-580h": 1,
              "580-582h": 2,
              "582-584h": 2,
              "584-586h": 2,
              "592-594h": 2,
              "594-596h": 1,
              "596-598h": 2,
              "598-600h": 3,
              "602-604h": 1,
              "604-606h": 1,
              "614-616h": 1,
              "616-618h": 4,
              "618-620h": 1,
              "620-622h": 2,
              "622-624h": 3,
              "624-626h": 6,
              "626-628h": 1,
              "628-630h": 3,
              "630-632h": 2,
              "634-636h": 4,
              "636-638h": 1,
              "638-640h": 4,
              "642-644h": 3,
              "644-646h": 1,
              "646-648h": 2,
              "648-650h": 1,
              "650-652h": 4,
              "652-654h": 4,
              "654-656h": 2,
              "656-658h": 1,
              "658-660h": 3,
              "662-664h": 1,
              "664-666h": 6,
              "666-668h": 2,
              "668-670h": 3,
              "670-672h": 4,
              "672-674h": 5,
              "674-676h": 2,
              "678-680h": 3,
              "682-684h": 6,
              "684-686h": 1,
              "688-690h": 1,
              "690-692h": 4,
              "692-694h": 5,
              "694-696h": 1,
              "700-702h": 2,
              "702-704h": 2,
              "708-710h": 1,
              "710-712h": 3,
              "714-716h": 1,
              "716-718h": 1,
              "718-720h": 1,
              "720-722h": 5,
              "722-724h": 2,
              "724-726h": 2,
              "726-728h": 2,
              "728-730h": 1,
              "732-734h": 1,
              "734-736h": 6,
              "736-738h": 3,
              "738-740h": 4,
              "740-742h": 1,
              "744-746h": 1,
              "746-748h": 3,
              "758-760h": 1,
              "762-764h": 1,
              "766-768h": 1,
              "768-770h": 5,
              "772-774h": 2,
              "782-784h": 1,
              "784-786h": 1,
              "786-788h": 1,
              "788-790h": 2,
              "790-792h": 3,
              "792-794h": 2,
              "804-806h": 5,
              "808-810h": 3,
              "814-816h": 2,
              "816-818h": 2,
              "822-824h": 1,
              "824-826h": 3,
              "826-828h": 4,
              "828-830h": 1,
              "830-832h": 1,
              "836-838h": 2,
              "838-840h": 1,
              "840-842h": 1,
              "842-844h": 2,
              "844-846h": 1,
              "846-848h": 1,
              "848-850h": 1,
              "852-854h": 3,
              "854-856h": 1,
              "858-860h": 1,
              "860-862h": 1,
              "876-878h": 3,
              "878-880h": 1,
              "886-888h": 1,
              "888-890h": 1,
              "900-902h": 1,
              "908-910h": 1,
              "912-914h": 3,
              "916-918h": 1,
              "940-942h": 1,
              "944-946h": 1,
              "960-962h": 1,
              "966-968h": 2,
              "972-974h": 2,
              "976-978h": 1,
              "978-980h": 2,
              "982-984h": 4,
              "988-990h": 1,
              "994-996h": 2,
              "1002-1004h": 1,
              "1008-1010h": 4,
              "1012-1014h": 1,
              "1018-1020h": 1,
              "1020-1022h": 3,
              "1026-1028h": 2,
              "1036-1038h": 1,
              "1038-1040h": 1,
              "1044-1046h": 1,
              "1046-1048h": 2,
              "1050-1052h": 2,
              "1054-1056h": 2,
              "1056-1058h": 3,
              "1060-1062h": 1,
              "1066-1068h": 1,
              "1068-1070h": 1,
              "1072-1074h": 2,
              "1078-1080h": 2,
              "1080-1082h": 3,
              "1084-1086h": 1,
              "1086-1088h": 1,
              "1100-1102h": 1,
              "1106-1108h": 1,
              "1124-1126h": 8,
              "1134-1136h": 1,
              "1138-1140h": 2,
              "1142-1144h": 1,
              "1150-1152h": 1,
              "1152-1154h": 2,
              "1176-1178h": 1,
              "1198-1200h": 2,
              "1214-1216h": 1,
              "1216-1218h": 1,
              "1222-1224h": 2,
              "1228-1230h": 1,
              "1236-1238h": 2,
              "1238-1240h": 1,
              "1240-1242h": 1,
              "1248-1250h": 1,
              "1252-1254h": 1,
              "1270-1272h": 3,
              "1282-1284h": 2,
              "1284-1286h": 1,
              "1298-1300h": 1,
              "1344-1346h": 1,
              "1348-1350h": 1,
              "1360-1362h": 1,
              "1368-1370h": 2,
              "1406-1408h": 1,
              "1408-1410h": 1,
              "1412-1414h": 1,
              "1416-1418h": 5,
              "1440-1442h": 1,
              "1460-1462h": 2,
              "1462-1464h": 2,
              "1488-1490h": 1,
              "1502-1504h": 1,
              "1506-1508h": 1,
              "1546-1548h": 1,
              "1634-1636h": 1,
              "1686-1688h": 1,
              "1698-1700h": 2,
              "1704-1706h": 2,
              "1718-1720h": 1,
              "1756-1758h": 1,
              "1838-1840h": 2,
              "1846-1848h": 1,
              "1856-1858h": 1,
              "1862-1864h": 1,
              "1916-1918h": 1,
              "1962-1964h": 1,
              "1964-1966h": 2,
              "2036-2038h": 1,
              "2048-2050h": 1,
              "2054-2056h": 1,
              "2132-2134h": 1,
              "2208-2210h": 1,
              "2272-2274h": 1,
              "2344-2346h": 1,
              "2510-2512h": 1,
              "2734-2736h": 1,
              "2886-2888h": 1,
              "3186-3188h": 1,
              "3262-3264h": 1
            },
            "tickets_count": 6344,
            "tickets_per_day": {
              "2025-09-30": 8,
              "2025-10-01": 2,
              "2025-10-03": 5,
              "2025-10-06": 3,
              "2025-10-07": 32,
              "2025-10-08": 8,
              "2025-10-09": 14,
              "2025-10-10": 8,
              "2025-10-13": 27,
              "2025-10-14": 27,
              "2025-10-15": 30,
              "2025-10-16": 2,
              "2025-10-17": 24,
              "2025-10-20": 10,
              "2025-10-21": 12,
              "2025-10-22": 4,
              "2025-10-23": 25,
              "2025-10-24": 5,
              "2025-10-25": 10,
              "2025-10-26": 1,
              "2025-10-27": 23,
              "2025-10-28": 8,
              "2025-10-29": 28,
              "2025-10-30": 10,
              "2025-10-31": 16,
              "2025-11-02": 1,
              "2025-11-03": 10,
              "2025-11-04": 6,
              "2025-11-05": 22,
              "2025-11-06": 9,
              "2025-11-07": 4,
              "2025-11-10": 13,
              "2025-11-11": 12,
              "2025-11-12": 18,
              "2025-11-13": 11,
              "2025-11-14": 19,
              "2025-11-15": 1,
              "2025-11-16": 2,
              "2025-11-17": 10,
              "2025-11-18": 3,
              "2025-11-19": 22,
              "2025-11-20": 32,
              "2025-11-21": 34,
              "2025-11-22": 9,
              "2025-11-23": 3,
              "2025-11-24": 14,
              "2025-11-25": 10,
              "2025-11-26": 5,
              "2025-11-27": 5,
              "2025-11-28": 4,
              "2025-11-29": 15,
              "2025-11-30": 1,
              "2025-12-01": 1,
              "2025-12-02": 32,
              "2025-12-03": 43,
              "2025-12-04": 16,
              "2025-12-05": 16,
              "2025-12-06": 1,
              "2025-12-07": 1,
              "2025-12-09": 5,
              "2025-12-10": 18,
              "2025-12-11": 22,
              "2025-12-12": 8,
              "2025-12-14": 2,
              "2025-12-15": 64,
              "2025-12-16": 15,
              "2025-12-17": 17,
              "2025-12-18": 8,
              "2025-12-19": 18,
              "2025-12-21": 1,
              "2025-12-22": 31,
              "2025-12-23": 8,
              "2025-12-25": 1,
              "2025-12-26": 28,
              "2025-12-29": 29,
              "2025-12-30": 10,
              "2025-12-31": 4,
              "2026-01-02": 25,
              "2026-01-03": 2,
              "2026-01-04": 2,
              "2026-01-05": 6,
              "2026-01-06": 7,
              "2026-01-07": 9,
              "2026-01-08": 38,
              "2026-01-09": 28,
              "2026-01-10": 2,
              "2026-01-12": 15,
              "2026-01-13": 47,
              "2026-01-14": 26,
              "2026-01-15": 59,
              "2026-01-16": 30,
              "2026-01-17": 29,
              "2026-01-18": 4,
              "2026-01-19": 14,
              "2026-01-20": 21,
              "2026-01-21": 39,
              "2026-01-22": 17,
              "2026-01-23": 47,
              "2026-01-24": 34,
              "2026-01-26": 36,
              "2026-01-27": 63,
              "2026-01-28": 8,
              "2026-01-29": 13,
              "2026-01-30": 40,
              "2026-01-31": 7,
              "2026-02-02": 17,
              "2026-02-03": 32,
              "2026-02-04": 13,
              "2026-02-05": 36,
              "2026-02-06": 107,
              "2026-02-07": 1,
              "2026-02-09": 47,
              "2026-02-10": 132,
              "2026-02-11": 30,
              "2026-02-12": 38,
              "2026-02-13": 89,
              "2026-02-14": 18,
              "2026-02-16": 15,
              "2026-02-17": 6,
              "2026-02-18": 57,
              "2026-02-19": 441,
              "2026-02-20": 23,
              "2026-02-21": 37,
              "2026-02-23": 71,
              "2026-02-24": 20,
              "2026-02-25": 14,
              "2026-02-26": 6,
              "2026-02-27": 11,
              "2026-02-28": 131,
              "2026-03-02": 42,
              "2026-03-03": 16,
              "2026-03-04": 13,
              "2026-03-05": 35,
              "2026-03-06": 25,
              "2026-03-07": 14,
              "2026-03-09": 69,
              "2026-03-10": 23,
              "2026-03-11": 26,
              "2026-03-12": 17,
              "2026-03-13": 13,
              "2026-03-14": 42,
              "2026-03-16": 20,
              "2026-03-17": 115,
              "2026-03-18": 532,
              "2026-03-19": 25,
              "2026-03-20": 38,
              "2026-03-23": 50,
              "2026-03-24": 74,
              "2026-03-25": 34,
              "2026-03-26": 68,
              "2026-03-27": 20,
              "2026-03-28": 6,
              "2026-03-30": 71,
              "2026-03-31": 21,
              "2026-04-01": 16,
              "2026-04-02": 16,
              "2026-04-04": 10,
              "2026-04-06": 63,
              "2026-04-07": 41,
              "2026-04-08": 37,
              "2026-04-09": 10,
              "2026-04-10": 37,
              "2026-04-11": 25,
              "2026-04-13": 40,
              "2026-04-14": 41,
              "2026-04-15": 12,
              "2026-04-16": 7,
              "2026-04-17": 19,
              "2026-04-18": 4,
              "2026-04-20": 20,
              "2026-04-21": 30,
              "2026-04-22": 83,
              "2026-04-23": 29,
              "2026-04-24": 25,
              "2026-04-27": 44,
              "2026-04-28": 20,
              "2026-04-29": 19,
              "2026-04-30": 26,
              "2026-05-01": 2,
              "2026-05-02": 50,
              "2026-05-04": 38,
              "2026-05-05": 10,
              "2026-05-06": 17,
              "2026-05-07": 9,
              "2026-05-08": 33,
              "2026-05-09": 24,
              "2026-05-11": 38,
              "2026-05-12": 14,
              "2026-05-13": 14,
              "2026-05-14": 19,
              "2026-05-15": 17,
              "2026-05-18": 46,
              "2026-05-19": 14,
              "2026-05-20": 23,
              "2026-05-21": 20,
              "2026-05-22": 13,
              "2026-05-23": 17,
              "2026-05-25": 75,
              "2026-05-26": 90,
              "2026-05-27": 61,
              "2026-05-28": 67,
              "2026-05-29": 91,
              "2026-05-30": 63,
              "2026-06-01": 84,
              "2026-06-02": 79,
              "2026-06-03": 28,
              "2026-06-05": 51,
              "2026-06-08": 58
            },
            "time_per_day": {
              "2025-09-30": 9.127841666666667,
              "2025-10-01": 26.06114138888889,
              "2025-10-03": 154.8331452777778,
              "2025-10-06": 0.9875205555555556,
              "2025-10-07": 1475.582726666667,
              "2025-10-08": 26.739000555555556,
              "2025-10-09": 294.5298491666666,
              "2025-10-10": 96.33314972222222,
              "2025-10-13": 1714.021978888889,
              "2025-10-14": 466.84292750000003,
              "2025-10-15": 497.33161083333346,
              "2025-10-16": 51.901759444444444,
              "2025-10-17": 604.2210780555555,
              "2025-10-20": 529.8430594444444,
              "2025-10-21": 365.31872694444445,
              "2025-10-22": 261.9568313888889,
              "2025-10-23": 807.3669249999998,
              "2025-10-24": 4.281496944444444,
              "2025-10-25": 557.7299408333333,
              "2025-10-26": 0.5912069444444444,
              "2025-10-27": 443.63950527777786,
              "2025-10-28": 114.28633305555557,
              "2025-10-29": 733.3488108333333,
              "2025-10-30": 620.6166327777779,
              "2025-10-31": 802.0761080555558,
              "2025-11-02": 6.409595277777778,
              "2025-11-03": 217.23275777777783,
              "2025-11-04": 3461.571971111111,
              "2025-11-05": 2060.2046066666667,
              "2025-11-06": 88.54049472222223,
              "2025-11-07": 11.220594722222224,
              "2025-11-10": 272.7147261111111,
              "2025-11-11": 136.03347444444444,
              "2025-11-12": 424.17754138888887,
              "2025-11-13": 347.99163555555555,
              "2025-11-14": 1184.051555,
              "2025-11-15": 0.20001194444444445,
              "2025-11-16": 1.5785355555555556,
              "2025-11-17": 237.39708972222223,
              "2025-11-18": 1041.1254194444446,
              "2025-11-19": 2130.5376741666673,
              "2025-11-20": 1554.0195413888891,
              "2025-11-21": 1195.0451911111113,
              "2025-11-22": 251.78188694444444,
              "2025-11-23": 172.13471583333333,
              "2025-11-24": 284.8341708333333,
              "2025-11-25": 209.1039725,
              "2025-11-26": 8.714044166666666,
              "2025-11-27": 3.5771949999999997,
              "2025-11-28": 103.04507500000001,
              "2025-11-29": 1256.4848872222226,
              "2025-11-30": 0.03324916666666667,
              "2025-12-01": 0.8959808333333333,
              "2025-12-02": 2678.997856944444,
              "2025-12-03": 3138.2686363888874,
              "2025-12-04": 553.5516025000001,
              "2025-12-05": 510.36735194444447,
              "2025-12-06": 3.4375983333333333,
              "2025-12-07": 0.18633083333333333,
              "2025-12-09": 464.3158397222221,
              "2025-12-10": 481.1334911111111,
              "2025-12-11": 1217.9861047222225,
              "2025-12-12": 2.112637777777778,
              "2025-12-14": 4.941235833333334,
              "2025-12-15": 4066.1005855555572,
              "2025-12-16": 1051.7887244444446,
              "2025-12-17": 1923.9397927777782,
              "2025-12-18": 543.3764277777777,
              "2025-12-19": 2078.872353611111,
              "2025-12-21": 89.8079611111111,
              "2025-12-22": 1689.4132386111112,
              "2025-12-23": 332.21707972222225,
              "2025-12-25": 56.22132055555555,
              "2025-12-26": 4176.6450561111105,
              "2025-12-29": 7610.488640277778,
              "2025-12-30": 446.78769333333344,
              "2025-12-31": 17.479653055555556,
              "2026-01-02": 2746.3424511111116,
              "2026-01-03": 0.9715977777777778,
              "2026-01-04": 0.23874944444444446,
              "2026-01-05": 1215.7688555555553,
              "2026-01-06": 121.38950722222222,
              "2026-01-07": 26.375528055555556,
              "2026-01-08": 3047.0554794444447,
              "2026-01-09": 933.4160502777778,
              "2026-01-10": 4.734784722222222,
              "2026-01-12": 901.1469772222223,
              "2026-01-13": 2413.834155277778,
              "2026-01-14": 177.35250361111108,
              "2026-01-15": 4774.817563888888,
              "2026-01-16": 677.5693083333332,
              "2026-01-17": 2886.5499641666665,
              "2026-01-18": 53.242089444444446,
              "2026-01-19": 85.26962166666665,
              "2026-01-20": 154.14520583333334,
              "2026-01-21": 1326.4593436111109,
              "2026-01-22": 169.82341722222228,
              "2026-01-23": 4318.421278888889,
              "2026-01-24": 5395.097718055556,
              "2026-01-26": 382.6337019444443,
              "2026-01-27": 3863.065136388889,
              "2026-01-28": 38.30271055555555,
              "2026-01-29": 54.121003333333334,
              "2026-01-30": 4161.651588055558,
              "2026-01-31": 734.4098319444445,
              "2026-02-02": 448.84911972222227,
              "2026-02-03": 2670.0772263888875,
              "2026-02-04": 969.9458644444443,
              "2026-02-05": 4054.0304705555554,
              "2026-02-06": 20583.37980777779,
              "2026-02-07": 532.1782808333334,
              "2026-02-09": 3131.4640480555554,
              "2026-02-10": 41571.18807611111,
              "2026-02-11": 3724.260151944445,
              "2026-02-12": 2986.808739166667,
              "2026-02-13": 14890.268112222226,
              "2026-02-14": 1629.8342494444441,
              "2026-02-16": 8963.890921944445,
              "2026-02-17": 1577.960201388889,
              "2026-02-18": 37079.736395277745,
              "2026-02-19": 245901.58612166674,
              "2026-02-20": 1336.3661916666663,
              "2026-02-21": 886.4260852777777,
              "2026-02-23": 4517.551563611108,
              "2026-02-24": 1171.0297166666662,
              "2026-02-25": 2367.6012313888887,
              "2026-02-26": 51.84813527777778,
              "2026-02-27": 23.493632777777776,
              "2026-02-28": 8822.087228611112,
              "2026-03-02": 794.3285966666667,
              "2026-03-03": 1171.6135350000004,
              "2026-03-04": 81.21685555555555,
              "2026-03-05": 118.37331250000001,
              "2026-03-06": 669.0325241666666,
              "2026-03-07": 23.669802222222224,
              "2026-03-09": 25754.188486111107,
              "2026-03-10": 1154.1383744444445,
              "2026-03-11": 9567.473549166667,
              "2026-03-12": 85.12184472222225,
              "2026-03-13": 1150.3077438888893,
              "2026-03-14": 2802.5688891666655,
              "2026-03-16": 68.73113249999997,
              "2026-03-17": 3978.155700555556,
              "2026-03-18": 163669.72289555575,
              "2026-03-19": 17.13997861111111,
              "2026-03-20": 1523.7399974999996,
              "2026-03-23": 50.92147166666666,
              "2026-03-24": 5468.567176111113,
              "2026-03-25": 158.6480972222223,
              "2026-03-26": 30053.443227500004,
              "2026-03-27": 11.6921575,
              "2026-03-28": 5.683826944444444,
              "2026-03-30": 5041.605215555553,
              "2026-03-31": 49.3596736111111,
              "2026-04-01": 38.22740222222223,
              "2026-04-02": 43.53574388888889,
              "2026-04-04": 23.56112388888889,
              "2026-04-06": 116.7791208333333,
              "2026-04-07": 129.74741222222227,
              "2026-04-08": 356.4146925,
              "2026-04-09": 13.570228055555555,
              "2026-04-10": 237.73439249999993,
              "2026-04-11": 644.4010447222222,
              "2026-04-13": 3486.897580277778,
              "2026-04-14": 197.0491361111111,
              "2026-04-15": 13.898377222222221,
              "2026-04-16": 5.540063888888889,
              "2026-04-17": 281.93704194444456,
              "2026-04-18": 9.854589166666667,
              "2026-04-20": 8.548414444444443,
              "2026-04-21": 16.52367388888889,
              "2026-04-22": 7996.157943611107,
              "2026-04-23": 11.611257777777778,
              "2026-04-24": 17.32518611111111,
              "2026-04-27": 174.98030250000008,
              "2026-04-28": 21.582048055555557,
              "2026-04-29": 9.415882222222224,
              "2026-04-30": 74.72355861111112,
              "2026-05-01": 392.60974166666665,
              "2026-05-02": 485.37755277777774,
              "2026-05-04": 109.69104555555556,
              "2026-05-05": 3.8272786111111112,
              "2026-05-06": 1871.9605497222224,
              "2026-05-07": 380.8554661111111,
              "2026-05-08": 105.95977055555555,
              "2026-05-09": 87.51052388888888,
              "2026-05-11": 63.2094736111111,
              "2026-05-12": 16.886509444444442,
              "2026-05-13": 26.51112805555556,
              "2026-05-14": 1479.1644561111107,
              "2026-05-15": 27.490176388888898,
              "2026-05-18": 49.658548888888895,
              "2026-05-19": 35.648480000000006,
              "2026-05-20": 25.66612027777778,
              "2026-05-21": 22.013790833333328,
              "2026-05-22": 15.802796666666666,
              "2026-05-23": 25.782598333333336,
              "2026-05-25": 416.62317138888875,
              "2026-05-26": 229.69407111111124,
              "2026-05-27": 134.39113777777777,
              "2026-05-28": 115.97938444444445,
              "2026-05-29": 2907.5056838888895,
              "2026-05-30": 62.9993325,
              "2026-06-01": 1591.3946899999996,
              "2026-06-02": 3477.543826944445,
              "2026-06-03": 244.46619083333337,
              "2026-06-05": 443.97138444444437,
              "2026-06-08": 35.62650527777777
            },
            "time_count_per_day": {
              "2025-09-30": 8,
              "2025-10-01": 2,
              "2025-10-03": 5,
              "2025-10-06": 3,
              "2025-10-07": 32,
              "2025-10-08": 8,
              "2025-10-09": 14,
              "2025-10-10": 8,
              "2025-10-13": 27,
              "2025-10-14": 27,
              "2025-10-15": 30,
              "2025-10-16": 2,
              "2025-10-17": 24,
              "2025-10-20": 10,
              "2025-10-21": 12,
              "2025-10-22": 4,
              "2025-10-23": 25,
              "2025-10-24": 5,
              "2025-10-25": 10,
              "2025-10-26": 1,
              "2025-10-27": 23,
              "2025-10-28": 8,
              "2025-10-29": 28,
              "2025-10-30": 10,
              "2025-10-31": 16,
              "2025-11-02": 1,
              "2025-11-03": 10,
              "2025-11-04": 6,
              "2025-11-05": 22,
              "2025-11-06": 9,
              "2025-11-07": 4,
              "2025-11-10": 13,
              "2025-11-11": 12,
              "2025-11-12": 18,
              "2025-11-13": 11,
              "2025-11-14": 19,
              "2025-11-15": 1,
              "2025-11-16": 2,
              "2025-11-17": 10,
              "2025-11-18": 3,
              "2025-11-19": 22,
              "2025-11-20": 32,
              "2025-11-21": 34,
              "2025-11-22": 9,
              "2025-11-23": 3,
              "2025-11-24": 14,
              "2025-11-25": 10,
              "2025-11-26": 5,
              "2025-11-27": 5,
              "2025-11-28": 4,
              "2025-11-29": 15,
              "2025-11-30": 1,
              "2025-12-01": 1,
              "2025-12-02": 32,
              "2025-12-03": 43,
              "2025-12-04": 16,
              "2025-12-05": 16,
              "2025-12-06": 1,
              "2025-12-07": 1,
              "2025-12-09": 5,
              "2025-12-10": 18,
              "2025-12-11": 22,
              "2025-12-12": 8,
              "2025-12-14": 2,
              "2025-12-15": 64,
              "2025-12-16": 15,
              "2025-12-17": 17,
              "2025-12-18": 8,
              "2025-12-19": 18,
              "2025-12-21": 1,
              "2025-12-22": 31,
              "2025-12-23": 8,
              "2025-12-25": 1,
              "2025-12-26": 28,
              "2025-12-29": 29,
              "2025-12-30": 10,
              "2025-12-31": 4,
              "2026-01-02": 25,
              "2026-01-03": 2,
              "2026-01-04": 2,
              "2026-01-05": 6,
              "2026-01-06": 7,
              "2026-01-07": 9,
              "2026-01-08": 38,
              "2026-01-09": 28,
              "2026-01-10": 2,
              "2026-01-12": 15,
              "2026-01-13": 47,
              "2026-01-14": 26,
              "2026-01-15": 59,
              "2026-01-16": 30,
              "2026-01-17": 29,
              "2026-01-18": 4,
              "2026-01-19": 14,
              "2026-01-20": 21,
              "2026-01-21": 39,
              "2026-01-22": 17,
              "2026-01-23": 47,
              "2026-01-24": 34,
              "2026-01-26": 36,
              "2026-01-27": 63,
              "2026-01-28": 8,
              "2026-01-29": 13,
              "2026-01-30": 40,
              "2026-01-31": 7,
              "2026-02-02": 17,
              "2026-02-03": 32,
              "2026-02-04": 13,
              "2026-02-05": 36,
              "2026-02-06": 107,
              "2026-02-07": 1,
              "2026-02-09": 47,
              "2026-02-10": 132,
              "2026-02-11": 30,
              "2026-02-12": 38,
              "2026-02-13": 89,
              "2026-02-14": 18,
              "2026-02-16": 15,
              "2026-02-17": 6,
              "2026-02-18": 57,
              "2026-02-19": 441,
              "2026-02-20": 23,
              "2026-02-21": 37,
              "2026-02-23": 71,
              "2026-02-24": 20,
              "2026-02-25": 14,
              "2026-02-26": 6,
              "2026-02-27": 11,
              "2026-02-28": 131,
              "2026-03-02": 42,
              "2026-03-03": 16,
              "2026-03-04": 13,
              "2026-03-05": 35,
              "2026-03-06": 25,
              "2026-03-07": 14,
              "2026-03-09": 69,
              "2026-03-10": 23,
              "2026-03-11": 26,
              "2026-03-12": 17,
              "2026-03-13": 13,
              "2026-03-14": 42,
              "2026-03-16": 20,
              "2026-03-17": 115,
              "2026-03-18": 532,
              "2026-03-19": 25,
              "2026-03-20": 38,
              "2026-03-23": 50,
              "2026-03-24": 74,
              "2026-03-25": 34,
              "2026-03-26": 68,
              "2026-03-27": 20,
              "2026-03-28": 6,
              "2026-03-30": 71,
              "2026-03-31": 21,
              "2026-04-01": 16,
              "2026-04-02": 16,
              "2026-04-04": 10,
              "2026-04-06": 63,
              "2026-04-07": 41,
              "2026-04-08": 37,
              "2026-04-09": 10,
              "2026-04-10": 37,
              "2026-04-11": 25,
              "2026-04-13": 40,
              "2026-04-14": 41,
              "2026-04-15": 12,
              "2026-04-16": 7,
              "2026-04-17": 19,
              "2026-04-18": 4,
              "2026-04-20": 20,
              "2026-04-21": 30,
              "2026-04-22": 83,
              "2026-04-23": 29,
              "2026-04-24": 25,
              "2026-04-27": 44,
              "2026-04-28": 20,
              "2026-04-29": 19,
              "2026-04-30": 26,
              "2026-05-01": 2,
              "2026-05-02": 50,
              "2026-05-04": 38,
              "2026-05-05": 10,
              "2026-05-06": 17,
              "2026-05-07": 9,
              "2026-05-08": 33,
              "2026-05-09": 24,
              "2026-05-11": 38,
              "2026-05-12": 14,
              "2026-05-13": 14,
              "2026-05-14": 19,
              "2026-05-15": 17,
              "2026-05-18": 46,
              "2026-05-19": 14,
              "2026-05-20": 23,
              "2026-05-21": 20,
              "2026-05-22": 13,
              "2026-05-23": 17,
              "2026-05-25": 75,
              "2026-05-26": 90,
              "2026-05-27": 61,
              "2026-05-28": 67,
              "2026-05-29": 91,
              "2026-05-30": 63,
              "2026-06-01": 84,
              "2026-06-02": 79,
              "2026-06-03": 28,
              "2026-06-05": 51,
              "2026-06-08": 58
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 7.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "26-28h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2026-01-14": 1,
                "2026-03-17": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-10-15": 1.828102222222222,
                "2026-01-14": 1.4789947222222224,
                "2026-03-17": 0.9878205555555556,
                "2026-05-26": 26.844470833333332
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2026-01-14": 1,
                "2026-03-17": 1,
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 29.96,
              "mode_time_hours": 1.0,
              "mode_frequency": 2301,
              "time_distribution": {
                "0-2h": 2301,
                "2-4h": 432,
                "4-6h": 185,
                "6-8h": 85,
                "8-10h": 46,
                "10-12h": 25,
                "12-14h": 24,
                "14-16h": 20,
                "16-18h": 22,
                "18-20h": 16,
                "20-22h": 17,
                "22-24h": 11,
                "24-26h": 7,
                "26-28h": 3,
                "28-30h": 5,
                "30-32h": 4,
                "32-34h": 1,
                "34-36h": 3,
                "36-38h": 6,
                "38-40h": 18,
                "40-42h": 5,
                "42-44h": 2,
                "44-46h": 6,
                "46-48h": 3,
                "48-50h": 2,
                "50-52h": 2,
                "58-60h": 1,
                "62-64h": 1,
                "68-70h": 5,
                "72-74h": 7,
                "74-76h": 6,
                "76-78h": 3,
                "78-80h": 1,
                "80-82h": 1,
                "88-90h": 1,
                "90-92h": 1,
                "92-94h": 3,
                "94-96h": 1,
                "96-98h": 2,
                "100-102h": 2,
                "102-104h": 1,
                "106-108h": 2,
                "120-122h": 1,
                "122-124h": 4,
                "124-126h": 1,
                "126-128h": 1,
                "128-130h": 1,
                "138-140h": 1,
                "142-144h": 2,
                "144-146h": 1,
                "150-152h": 1,
                "162-164h": 7,
                "164-166h": 1,
                "172-174h": 1,
                "176-178h": 2,
                "186-188h": 1,
                "188-190h": 1,
                "194-196h": 1,
                "198-200h": 1,
                "208-210h": 2,
                "234-236h": 1,
                "236-238h": 1,
                "238-240h": 1,
                "246-248h": 1,
                "254-256h": 1,
                "256-258h": 1,
                "260-262h": 1,
                "266-268h": 2,
                "268-270h": 1,
                "274-276h": 1,
                "280-282h": 1,
                "302-304h": 1,
                "312-314h": 2,
                "318-320h": 1,
                "324-326h": 1,
                "336-338h": 2,
                "338-340h": 1,
                "346-348h": 1,
                "348-350h": 2,
                "358-360h": 2,
                "392-394h": 1,
                "400-402h": 1,
                "418-420h": 1,
                "422-424h": 1,
                "424-426h": 2,
                "434-436h": 1,
                "450-452h": 1,
                "462-464h": 1,
                "486-488h": 1,
                "504-506h": 1,
                "506-508h": 2,
                "508-510h": 2,
                "526-528h": 2,
                "528-530h": 3,
                "532-534h": 1,
                "552-554h": 1,
                "584-586h": 1,
                "592-594h": 1,
                "598-600h": 1,
                "630-632h": 1,
                "634-636h": 1,
                "648-650h": 1,
                "650-652h": 1,
                "652-654h": 1,
                "654-656h": 1,
                "658-660h": 1,
                "664-666h": 1,
                "668-670h": 1,
                "670-672h": 1,
                "672-674h": 1,
                "674-676h": 1,
                "678-680h": 1,
                "702-704h": 1,
                "722-724h": 1,
                "726-728h": 1,
                "738-740h": 1,
                "746-748h": 3,
                "758-760h": 1,
                "772-774h": 2,
                "792-794h": 1,
                "808-810h": 1,
                "822-824h": 1,
                "826-828h": 2,
                "836-838h": 1,
                "842-844h": 2,
                "846-848h": 1,
                "886-888h": 1,
                "888-890h": 1,
                "940-942h": 1,
                "944-946h": 1,
                "972-974h": 1,
                "994-996h": 1,
                "1018-1020h": 1,
                "1036-1038h": 1,
                "1054-1056h": 1,
                "1056-1058h": 2,
                "1080-1082h": 1,
                "1084-1086h": 1,
                "1086-1088h": 1,
                "1134-1136h": 1,
                "1176-1178h": 1,
                "1228-1230h": 1,
                "1252-1254h": 1,
                "1298-1300h": 1,
                "1440-1442h": 1,
                "1460-1462h": 1,
                "1462-1464h": 1,
                "1502-1504h": 1,
                "1634-1636h": 1,
                "1686-1688h": 1,
                "1756-1758h": 1,
                "2510-2512h": 1,
                "2734-2736h": 1,
                "2886-2888h": 1,
                "3262-3264h": 1
              },
              "tickets_count": 3431,
              "tickets_per_day": {
                "2025-09-30": 4,
                "2025-10-03": 1,
                "2025-10-06": 2,
                "2025-10-07": 4,
                "2025-10-08": 6,
                "2025-10-09": 3,
                "2025-10-10": 6,
                "2025-10-13": 3,
                "2025-10-14": 14,
                "2025-10-15": 11,
                "2025-10-17": 3,
                "2025-10-20": 2,
                "2025-10-21": 6,
                "2025-10-23": 3,
                "2025-10-24": 5,
                "2025-10-25": 2,
                "2025-10-26": 1,
                "2025-10-27": 6,
                "2025-10-28": 7,
                "2025-10-29": 11,
                "2025-10-30": 2,
                "2025-10-31": 7,
                "2025-11-02": 1,
                "2025-11-03": 5,
                "2025-11-04": 2,
                "2025-11-05": 2,
                "2025-11-06": 4,
                "2025-11-07": 2,
                "2025-11-10": 5,
                "2025-11-11": 5,
                "2025-11-12": 4,
                "2025-11-13": 7,
                "2025-11-14": 3,
                "2025-11-15": 1,
                "2025-11-16": 2,
                "2025-11-17": 8,
                "2025-11-18": 1,
                "2025-11-19": 3,
                "2025-11-20": 6,
                "2025-11-21": 7,
                "2025-11-22": 1,
                "2025-11-23": 1,
                "2025-11-24": 8,
                "2025-11-25": 2,
                "2025-11-26": 5,
                "2025-11-27": 5,
                "2025-11-28": 3,
                "2025-11-29": 3,
                "2025-11-30": 1,
                "2025-12-01": 1,
                "2025-12-02": 5,
                "2025-12-03": 7,
                "2025-12-04": 7,
                "2025-12-05": 10,
                "2025-12-06": 1,
                "2025-12-07": 1,
                "2025-12-09": 2,
                "2025-12-10": 4,
                "2025-12-11": 4,
                "2025-12-12": 8,
                "2025-12-14": 2,
                "2025-12-15": 20,
                "2025-12-16": 5,
                "2025-12-17": 11,
                "2025-12-18": 4,
                "2025-12-19": 5,
                "2025-12-21": 1,
                "2025-12-22": 6,
                "2025-12-23": 6,
                "2025-12-26": 16,
                "2025-12-29": 15,
                "2025-12-30": 6,
                "2025-12-31": 4,
                "2026-01-02": 16,
                "2026-01-03": 2,
                "2026-01-04": 2,
                "2026-01-05": 5,
                "2026-01-06": 7,
                "2026-01-07": 8,
                "2026-01-08": 3,
                "2026-01-09": 11,
                "2026-01-10": 2,
                "2026-01-12": 13,
                "2026-01-13": 13,
                "2026-01-14": 24,
                "2026-01-15": 26,
                "2026-01-16": 22,
                "2026-01-17": 10,
                "2026-01-18": 3,
                "2026-01-19": 14,
                "2026-01-20": 21,
                "2026-01-21": 21,
                "2026-01-22": 16,
                "2026-01-23": 22,
                "2026-01-24": 1,
                "2026-01-26": 34,
                "2026-01-27": 8,
                "2026-01-28": 8,
                "2026-01-29": 13,
                "2026-01-30": 30,
                "2026-01-31": 2,
                "2026-02-02": 13,
                "2026-02-03": 30,
                "2026-02-04": 6,
                "2026-02-05": 10,
                "2026-02-06": 18,
                "2026-02-07": 1,
                "2026-02-09": 28,
                "2026-02-10": 25,
                "2026-02-11": 11,
                "2026-02-12": 21,
                "2026-02-13": 41,
                "2026-02-14": 10,
                "2026-02-16": 11,
                "2026-02-17": 1,
                "2026-02-18": 7,
                "2026-02-19": 3,
                "2026-02-20": 21,
                "2026-02-21": 2,
                "2026-02-23": 32,
                "2026-02-24": 20,
                "2026-02-25": 13,
                "2026-02-26": 5,
                "2026-02-27": 10,
                "2026-02-28": 30,
                "2026-03-02": 37,
                "2026-03-03": 16,
                "2026-03-04": 13,
                "2026-03-05": 35,
                "2026-03-06": 24,
                "2026-03-07": 13,
                "2026-03-09": 64,
                "2026-03-10": 23,
                "2026-03-11": 24,
                "2026-03-12": 17,
                "2026-03-13": 13,
                "2026-03-14": 4,
                "2026-03-16": 20,
                "2026-03-17": 12,
                "2026-03-18": 32,
                "2026-03-19": 25,
                "2026-03-20": 9,
                "2026-03-23": 50,
                "2026-03-24": 23,
                "2026-03-25": 26,
                "2026-03-26": 8,
                "2026-03-27": 20,
                "2026-03-28": 6,
                "2026-03-30": 46,
                "2026-03-31": 21,
                "2026-04-01": 16,
                "2026-04-02": 16,
                "2026-04-04": 10,
                "2026-04-06": 63,
                "2026-04-07": 40,
                "2026-04-08": 36,
                "2026-04-09": 10,
                "2026-04-10": 37,
                "2026-04-11": 24,
                "2026-04-13": 40,
                "2026-04-14": 40,
                "2026-04-15": 12,
                "2026-04-16": 7,
                "2026-04-17": 19,
                "2026-04-18": 4,
                "2026-04-20": 20,
                "2026-04-21": 30,
                "2026-04-22": 29,
                "2026-04-23": 29,
                "2026-04-24": 25,
                "2026-04-27": 43,
                "2026-04-28": 20,
                "2026-04-29": 19,
                "2026-04-30": 26,
                "2026-05-02": 50,
                "2026-05-04": 38,
                "2026-05-05": 10,
                "2026-05-06": 16,
                "2026-05-07": 8,
                "2026-05-08": 33,
                "2026-05-09": 24,
                "2026-05-11": 38,
                "2026-05-12": 14,
                "2026-05-13": 14,
                "2026-05-14": 18,
                "2026-05-15": 17,
                "2026-05-18": 46,
                "2026-05-19": 14,
                "2026-05-20": 23,
                "2026-05-21": 20,
                "2026-05-22": 13,
                "2026-05-23": 17,
                "2026-05-25": 74,
                "2026-05-26": 89,
                "2026-05-27": 61,
                "2026-05-28": 67,
                "2026-05-29": 89,
                "2026-05-30": 63,
                "2026-06-01": 82,
                "2026-06-02": 79,
                "2026-06-03": 26,
                "2026-06-05": 51,
                "2026-06-08": 58
              },
              "time_per_day": {
                "2025-09-30": 0.39751861111111114,
                "2025-10-03": 0.021263888888888888,
                "2025-10-06": 0.7613808333333334,
                "2025-10-07": 2.247374722222222,
                "2025-10-08": 2.5312477777777778,
                "2025-10-09": 1.2593172222222222,
                "2025-10-10": 13.018523333333333,
                "2025-10-13": 70.28719694444445,
                "2025-10-14": 134.54258527777776,
                "2025-10-15": 15.514913055555555,
                "2025-10-17": 3.7378861111111106,
                "2025-10-20": 5.207591944444444,
                "2025-10-21": 12.232139444444446,
                "2025-10-23": 3.947646666666667,
                "2025-10-24": 4.281496944444444,
                "2025-10-25": 1.2203088888888889,
                "2025-10-26": 0.5912069444444444,
                "2025-10-27": 2.5519249999999998,
                "2025-10-28": 1.5131844444444444,
                "2025-10-29": 86.24610194444445,
                "2025-10-30": 0.9753711111111111,
                "2025-10-31": 0.8029980555555556,
                "2025-11-02": 6.409595277777778,
                "2025-11-03": 2.3862502777777777,
                "2025-11-04": 878.9484986111111,
                "2025-11-05": 708.2831222222222,
                "2025-11-06": 2.1948025,
                "2025-11-07": 0.7197175,
                "2025-11-10": 2.341073333333333,
                "2025-11-11": 3.1950027777777774,
                "2025-11-12": 1.9303033333333335,
                "2025-11-13": 11.685139166666668,
                "2025-11-14": 748.5823819444445,
                "2025-11-15": 0.20001194444444445,
                "2025-11-16": 1.5785355555555556,
                "2025-11-17": 45.221200555555555,
                "2025-11-18": 0.9757916666666666,
                "2025-11-19": 1.0903713888888888,
                "2025-11-20": 2.7672572222222223,
                "2025-11-21": 5.813423611111111,
                "2025-11-22": 0.10855555555555556,
                "2025-11-23": 4.54905,
                "2025-11-24": 0.42017944444444444,
                "2025-11-25": 0.5955447222222222,
                "2025-11-26": 8.714044166666666,
                "2025-11-27": 3.5771949999999997,
                "2025-11-28": 2.3230555555555554,
                "2025-11-29": 6.347163055555556,
                "2025-11-30": 0.03324916666666667,
                "2025-12-01": 0.8959808333333333,
                "2025-12-02": 4.3632725,
                "2025-12-03": 9.004628611111114,
                "2025-12-04": 6.118444444444444,
                "2025-12-05": 5.062986944444445,
                "2025-12-06": 3.4375983333333333,
                "2025-12-07": 0.18633083333333333,
                "2025-12-09": 1.2998294444444445,
                "2025-12-10": 2.4602675000000005,
                "2025-12-11": 2.3460938888888885,
                "2025-12-12": 2.112637777777778,
                "2025-12-14": 4.941235833333334,
                "2025-12-15": 74.55829083333332,
                "2025-12-16": 49.95013333333333,
                "2025-12-17": 1139.072772777778,
                "2025-12-18": 3.5761244444444444,
                "2025-12-19": 664.5616516666668,
                "2025-12-21": 89.8079611111111,
                "2025-12-22": 110.52973694444444,
                "2025-12-23": 290.8313052777778,
                "2025-12-26": 1665.5290388888889,
                "2025-12-29": 2884.6093272222215,
                "2025-12-30": 4.208087777777778,
                "2025-12-31": 17.479653055555556,
                "2026-01-02": 755.9054822222224,
                "2026-01-03": 0.9715977777777778,
                "2026-01-04": 0.23874944444444446,
                "2026-01-05": 638.9597463888888,
                "2026-01-06": 121.38950722222222,
                "2026-01-07": 22.017985833333334,
                "2026-01-08": 3.537315,
                "2026-01-09": 35.281893888888895,
                "2026-01-10": 4.734784722222222,
                "2026-01-12": 317.7920477777778,
                "2026-01-13": 28.667740833333333,
                "2026-01-14": 173.94958388888887,
                "2026-01-15": 181.61561638888887,
                "2026-01-16": 485.333628611111,
                "2026-01-17": 770.4592133333333,
                "2026-01-18": 3.9855472222222224,
                "2026-01-19": 85.26962166666665,
                "2026-01-20": 154.14520583333334,
                "2026-01-21": 173.69945777777784,
                "2026-01-22": 165.66245111111115,
                "2026-01-23": 506.4030841666667,
                "2026-01-24": 0.09553694444444444,
                "2026-01-26": 238.53695083333338,
                "2026-01-27": 68.62901555555555,
                "2026-01-28": 38.30271055555555,
                "2026-01-29": 54.121003333333334,
                "2026-01-30": 257.8032055555556,
                "2026-01-31": 1.8519616666666665,
                "2026-02-02": 156.76013805555556,
                "2026-02-03": 1088.631670833334,
                "2026-02-04": 44.29557222222221,
                "2026-02-05": 25.06510666666667,
                "2026-02-06": 290.5879302777777,
                "2026-02-07": 532.1782808333334,
                "2026-02-09": 467.6151216666666,
                "2026-02-10": 7629.415310555555,
                "2026-02-11": 174.34704472222222,
                "2026-02-12": 802.0345016666666,
                "2026-02-13": 6301.245764166667,
                "2026-02-14": 876.5482505555555,
                "2026-02-16": 6441.6638022222205,
                "2026-02-17": 809.2356566666667,
                "2026-02-18": 8482.067904722222,
                "2026-02-19": 1.4525191666666666,
                "2026-02-20": 989.2936727777779,
                "2026-02-21": 5.9190875,
                "2026-02-23": 2252.317289444445,
                "2026-02-24": 1171.0297166666662,
                "2026-02-25": 2367.4331066666664,
                "2026-02-26": 31.38134138888889,
                "2026-02-27": 23.295595,
                "2026-02-28": 763.5067105555557,
                "2026-03-02": 466.92563805555557,
                "2026-03-03": 1171.6135350000004,
                "2026-03-04": 81.21685555555555,
                "2026-03-05": 118.37331250000001,
                "2026-03-06": 667.7490399999999,
                "2026-03-07": 23.657543333333333,
                "2026-03-09": 20362.415239444435,
                "2026-03-10": 1154.1383744444445,
                "2026-03-11": 7836.485220833334,
                "2026-03-12": 85.12184472222225,
                "2026-03-13": 1150.3077438888893,
                "2026-03-14": 1.8016294444444445,
                "2026-03-16": 68.73113249999997,
                "2026-03-17": 13.801639444444445,
                "2026-03-18": 40.53310055555555,
                "2026-03-19": 17.13997861111111,
                "2026-03-20": 15.86523611111111,
                "2026-03-23": 50.92147166666666,
                "2026-03-24": 67.11172583333335,
                "2026-03-25": 20.428344166666665,
                "2026-03-26": 2.8171013888888883,
                "2026-03-27": 11.6921575,
                "2026-03-28": 5.683826944444444,
                "2026-03-30": 200.4815383333333,
                "2026-03-31": 49.3596736111111,
                "2026-04-01": 38.22740222222223,
                "2026-04-02": 43.53574388888889,
                "2026-04-04": 23.56112388888889,
                "2026-04-06": 116.7791208333333,
                "2026-04-07": 128.95055111111114,
                "2026-04-08": 211.33719694444446,
                "2026-04-09": 13.570228055555555,
                "2026-04-10": 237.73439249999993,
                "2026-04-11": 431.0084183333332,
                "2026-04-13": 3486.897580277778,
                "2026-04-14": 46.383064722222244,
                "2026-04-15": 13.898377222222221,
                "2026-04-16": 5.540063888888889,
                "2026-04-17": 281.93704194444456,
                "2026-04-18": 9.854589166666667,
                "2026-04-20": 8.548414444444443,
                "2026-04-21": 16.52367388888889,
                "2026-04-22": 34.175648333333335,
                "2026-04-23": 11.611257777777778,
                "2026-04-24": 17.32518611111111,
                "2026-04-27": 79.82272694444444,
                "2026-04-28": 21.582048055555557,
                "2026-04-29": 9.415882222222224,
                "2026-04-30": 74.72355861111112,
                "2026-05-02": 485.37755277777774,
                "2026-05-04": 109.69104555555556,
                "2026-05-05": 3.8272786111111112,
                "2026-05-06": 24.955294999999996,
                "2026-05-07": 31.245059722222226,
                "2026-05-08": 105.95977055555555,
                "2026-05-09": 87.51052388888888,
                "2026-05-11": 63.2094736111111,
                "2026-05-12": 16.886509444444442,
                "2026-05-13": 26.51112805555556,
                "2026-05-14": 65.62822444444443,
                "2026-05-15": 27.490176388888898,
                "2026-05-18": 49.658548888888895,
                "2026-05-19": 35.648480000000006,
                "2026-05-20": 25.66612027777778,
                "2026-05-21": 22.013790833333328,
                "2026-05-22": 15.802796666666666,
                "2026-05-23": 25.782598333333336,
                "2026-05-25": 316.5972808333332,
                "2026-05-26": 202.84960027777785,
                "2026-05-27": 134.39113777777777,
                "2026-05-28": 115.97938444444445,
                "2026-05-29": 460.4737777777778,
                "2026-05-30": 62.9993325,
                "2026-06-01": 336.8447002777777,
                "2026-06-02": 3477.543826944445,
                "2026-06-03": 57.94644888888889,
                "2026-06-05": 443.97138444444437,
                "2026-06-08": 35.62650527777777
              },
              "time_count_per_day": {
                "2025-09-30": 4,
                "2025-10-03": 1,
                "2025-10-06": 2,
                "2025-10-07": 4,
                "2025-10-08": 6,
                "2025-10-09": 3,
                "2025-10-10": 6,
                "2025-10-13": 3,
                "2025-10-14": 14,
                "2025-10-15": 11,
                "2025-10-17": 3,
                "2025-10-20": 2,
                "2025-10-21": 6,
                "2025-10-23": 3,
                "2025-10-24": 5,
                "2025-10-25": 2,
                "2025-10-26": 1,
                "2025-10-27": 6,
                "2025-10-28": 7,
                "2025-10-29": 11,
                "2025-10-30": 2,
                "2025-10-31": 7,
                "2025-11-02": 1,
                "2025-11-03": 5,
                "2025-11-04": 2,
                "2025-11-05": 2,
                "2025-11-06": 4,
                "2025-11-07": 2,
                "2025-11-10": 5,
                "2025-11-11": 5,
                "2025-11-12": 4,
                "2025-11-13": 7,
                "2025-11-14": 3,
                "2025-11-15": 1,
                "2025-11-16": 2,
                "2025-11-17": 8,
                "2025-11-18": 1,
                "2025-11-19": 3,
                "2025-11-20": 6,
                "2025-11-21": 7,
                "2025-11-22": 1,
                "2025-11-23": 1,
                "2025-11-24": 8,
                "2025-11-25": 2,
                "2025-11-26": 5,
                "2025-11-27": 5,
                "2025-11-28": 3,
                "2025-11-29": 3,
                "2025-11-30": 1,
                "2025-12-01": 1,
                "2025-12-02": 5,
                "2025-12-03": 7,
                "2025-12-04": 7,
                "2025-12-05": 10,
                "2025-12-06": 1,
                "2025-12-07": 1,
                "2025-12-09": 2,
                "2025-12-10": 4,
                "2025-12-11": 4,
                "2025-12-12": 8,
                "2025-12-14": 2,
                "2025-12-15": 20,
                "2025-12-16": 5,
                "2025-12-17": 11,
                "2025-12-18": 4,
                "2025-12-19": 5,
                "2025-12-21": 1,
                "2025-12-22": 6,
                "2025-12-23": 6,
                "2025-12-26": 16,
                "2025-12-29": 15,
                "2025-12-30": 6,
                "2025-12-31": 4,
                "2026-01-02": 16,
                "2026-01-03": 2,
                "2026-01-04": 2,
                "2026-01-05": 5,
                "2026-01-06": 7,
                "2026-01-07": 8,
                "2026-01-08": 3,
                "2026-01-09": 11,
                "2026-01-10": 2,
                "2026-01-12": 13,
                "2026-01-13": 13,
                "2026-01-14": 24,
                "2026-01-15": 26,
                "2026-01-16": 22,
                "2026-01-17": 10,
                "2026-01-18": 3,
                "2026-01-19": 14,
                "2026-01-20": 21,
                "2026-01-21": 21,
                "2026-01-22": 16,
                "2026-01-23": 22,
                "2026-01-24": 1,
                "2026-01-26": 34,
                "2026-01-27": 8,
                "2026-01-28": 8,
                "2026-01-29": 13,
                "2026-01-30": 30,
                "2026-01-31": 2,
                "2026-02-02": 13,
                "2026-02-03": 30,
                "2026-02-04": 6,
                "2026-02-05": 10,
                "2026-02-06": 18,
                "2026-02-07": 1,
                "2026-02-09": 28,
                "2026-02-10": 25,
                "2026-02-11": 11,
                "2026-02-12": 21,
                "2026-02-13": 41,
                "2026-02-14": 10,
                "2026-02-16": 11,
                "2026-02-17": 1,
                "2026-02-18": 7,
                "2026-02-19": 3,
                "2026-02-20": 21,
                "2026-02-21": 2,
                "2026-02-23": 32,
                "2026-02-24": 20,
                "2026-02-25": 13,
                "2026-02-26": 5,
                "2026-02-27": 10,
                "2026-02-28": 30,
                "2026-03-02": 37,
                "2026-03-03": 16,
                "2026-03-04": 13,
                "2026-03-05": 35,
                "2026-03-06": 24,
                "2026-03-07": 13,
                "2026-03-09": 64,
                "2026-03-10": 23,
                "2026-03-11": 24,
                "2026-03-12": 17,
                "2026-03-13": 13,
                "2026-03-14": 4,
                "2026-03-16": 20,
                "2026-03-17": 12,
                "2026-03-18": 32,
                "2026-03-19": 25,
                "2026-03-20": 9,
                "2026-03-23": 50,
                "2026-03-24": 23,
                "2026-03-25": 26,
                "2026-03-26": 8,
                "2026-03-27": 20,
                "2026-03-28": 6,
                "2026-03-30": 46,
                "2026-03-31": 21,
                "2026-04-01": 16,
                "2026-04-02": 16,
                "2026-04-04": 10,
                "2026-04-06": 63,
                "2026-04-07": 40,
                "2026-04-08": 36,
                "2026-04-09": 10,
                "2026-04-10": 37,
                "2026-04-11": 24,
                "2026-04-13": 40,
                "2026-04-14": 40,
                "2026-04-15": 12,
                "2026-04-16": 7,
                "2026-04-17": 19,
                "2026-04-18": 4,
                "2026-04-20": 20,
                "2026-04-21": 30,
                "2026-04-22": 29,
                "2026-04-23": 29,
                "2026-04-24": 25,
                "2026-04-27": 43,
                "2026-04-28": 20,
                "2026-04-29": 19,
                "2026-04-30": 26,
                "2026-05-02": 50,
                "2026-05-04": 38,
                "2026-05-05": 10,
                "2026-05-06": 16,
                "2026-05-07": 8,
                "2026-05-08": 33,
                "2026-05-09": 24,
                "2026-05-11": 38,
                "2026-05-12": 14,
                "2026-05-13": 14,
                "2026-05-14": 18,
                "2026-05-15": 17,
                "2026-05-18": 46,
                "2026-05-19": 14,
                "2026-05-20": 23,
                "2026-05-21": 20,
                "2026-05-22": 13,
                "2026-05-23": 17,
                "2026-05-25": 74,
                "2026-05-26": 89,
                "2026-05-27": 61,
                "2026-05-28": 67,
                "2026-05-29": 89,
                "2026-05-30": 63,
                "2026-06-01": 82,
                "2026-06-02": 79,
                "2026-06-03": 26,
                "2026-06-05": 51,
                "2026-06-08": 58
              }
            },
            "P3": {
              "avg_time_hours": 269.47,
              "mode_time_hours": 9.0,
              "mode_frequency": 12,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 2,
                "4-6h": 7,
                "6-8h": 11,
                "8-10h": 12,
                "12-14h": 1,
                "14-16h": 2,
                "16-18h": 4,
                "18-20h": 9,
                "20-22h": 6,
                "22-24h": 4,
                "24-26h": 4,
                "26-28h": 4,
                "28-30h": 5,
                "30-32h": 5,
                "32-34h": 4,
                "34-36h": 2,
                "38-40h": 4,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "56-58h": 1,
                "66-68h": 3,
                "70-72h": 2,
                "72-74h": 1,
                "78-80h": 2,
                "80-82h": 2,
                "90-92h": 1,
                "94-96h": 2,
                "98-100h": 1,
                "100-102h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "144-146h": 1,
                "150-152h": 7,
                "162-164h": 2,
                "164-166h": 2,
                "166-168h": 1,
                "174-176h": 1,
                "184-186h": 1,
                "188-190h": 2,
                "192-194h": 4,
                "194-196h": 1,
                "196-198h": 1,
                "200-202h": 5,
                "242-244h": 1,
                "332-334h": 1,
                "334-336h": 1,
                "336-338h": 3,
                "344-346h": 1,
                "448-450h": 1,
                "454-456h": 1,
                "462-464h": 1,
                "472-474h": 1,
                "478-480h": 3,
                "482-484h": 1,
                "492-494h": 2,
                "494-496h": 1,
                "498-500h": 2,
                "500-502h": 1,
                "504-506h": 4,
                "510-512h": 2,
                "524-526h": 1,
                "528-530h": 3,
                "534-536h": 2,
                "576-578h": 1,
                "578-580h": 1,
                "580-582h": 1,
                "584-586h": 1,
                "592-594h": 1,
                "596-598h": 2,
                "624-626h": 1,
                "628-630h": 1,
                "642-644h": 2,
                "670-672h": 1,
                "678-680h": 1,
                "722-724h": 1,
                "782-784h": 1,
                "876-878h": 1,
                "912-914h": 1,
                "988-990h": 1,
                "1012-1014h": 1,
                "1038-1040h": 1,
                "1046-1048h": 2,
                "1050-1052h": 1,
                "1054-1056h": 1,
                "1060-1062h": 1,
                "1106-1108h": 1,
                "1152-1154h": 1,
                "1198-1200h": 1,
                "1282-1284h": 2,
                "1284-1286h": 1,
                "1348-1350h": 1,
                "1360-1362h": 1,
                "1416-1418h": 1,
                "1856-1858h": 1,
                "2048-2050h": 1
              },
              "tickets_count": 217,
              "tickets_per_day": {
                "2025-10-03": 2,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-11-04": 4,
                "2025-11-18": 2,
                "2025-11-19": 1,
                "2025-11-21": 2,
                "2025-11-28": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 8,
                "2025-12-22": 2,
                "2025-12-25": 1,
                "2025-12-26": 2,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-07": 1,
                "2026-01-12": 1,
                "2026-01-15": 15,
                "2026-01-16": 2,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-24": 2,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-06": 4,
                "2026-02-09": 2,
                "2026-02-10": 79,
                "2026-02-12": 1,
                "2026-02-13": 30,
                "2026-02-16": 3,
                "2026-02-18": 18,
                "2026-02-19": 11,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-03-09": 5,
                "2026-03-11": 2,
                "2026-04-14": 1
              },
              "time_per_day": {
                "2025-10-03": 77.80798222222222,
                "2025-10-09": 0.2294986111111111,
                "2025-10-13": 0.6280566666666666,
                "2025-10-15": 1.8115216666666667,
                "2025-11-04": 2582.6234725,
                "2025-11-18": 1040.1496277777778,
                "2025-11-19": 1.5284197222222222,
                "2025-11-21": 4.326126111111111,
                "2025-11-28": 100.72201944444446,
                "2025-12-15": 193.9302275,
                "2025-12-17": 117.45160083333333,
                "2025-12-19": 848.0159763888889,
                "2025-12-22": 98.96625472222222,
                "2025-12-25": 56.22132055555555,
                "2025-12-26": 600.2989366666667,
                "2025-12-29": 67.47783055555556,
                "2026-01-05": 576.8091091666666,
                "2026-01-07": 4.357542222222222,
                "2026-01-12": 6.016322499999999,
                "2026-01-15": 153.85098916666666,
                "2026-01-16": 29.506838055555555,
                "2026-01-22": 4.160966111111111,
                "2026-01-23": 1198.5635597222224,
                "2026-01-24": 656.7112477777778,
                "2026-01-27": 4.422586388888889,
                "2026-01-30": 98.05877500000001,
                "2026-02-02": 0.7296752777777779,
                "2026-02-06": 609.2657272222222,
                "2026-02-09": 957.8905666666667,
                "2026-02-10": 25657.193483333343,
                "2026-02-12": 49.17926555555555,
                "2026-02-13": 5926.423231111115,
                "2026-02-16": 2430.655862222222,
                "2026-02-18": 5651.5557847222235,
                "2026-02-19": 171.40392638888886,
                "2026-02-20": 344.7796316666667,
                "2026-02-23": 877.8514341666668,
                "2026-03-09": 5391.773246666667,
                "2026-03-11": 1730.9883283333334,
                "2026-04-14": 150.66607138888887
              },
              "time_count_per_day": {
                "2025-10-03": 2,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-11-04": 4,
                "2025-11-18": 2,
                "2025-11-19": 1,
                "2025-11-21": 2,
                "2025-11-28": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 8,
                "2025-12-22": 2,
                "2025-12-25": 1,
                "2025-12-26": 2,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-07": 1,
                "2026-01-12": 1,
                "2026-01-15": 15,
                "2026-01-16": 2,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-24": 2,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-06": 4,
                "2026-02-09": 2,
                "2026-02-10": 79,
                "2026-02-12": 1,
                "2026-02-13": 30,
                "2026-02-16": 3,
                "2026-02-18": 18,
                "2026-02-19": 11,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-03-09": 5,
                "2026-03-11": 2,
                "2026-04-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 157.81,
              "mode_time_hours": 1.0,
              "mode_frequency": 65,
              "time_distribution": {
                "0-2h": 65,
                "2-4h": 46,
                "4-6h": 46,
                "6-8h": 41,
                "8-10h": 25,
                "10-12h": 29,
                "12-14h": 14,
                "14-16h": 8,
                "16-18h": 30,
                "18-20h": 33,
                "20-22h": 44,
                "22-24h": 48,
                "24-26h": 56,
                "26-28h": 42,
                "28-30h": 42,
                "30-32h": 46,
                "32-34h": 21,
                "34-36h": 17,
                "36-38h": 52,
                "38-40h": 5,
                "40-42h": 27,
                "42-44h": 17,
                "44-46h": 31,
                "46-48h": 22,
                "48-50h": 22,
                "50-52h": 43,
                "52-54h": 19,
                "54-56h": 5,
                "56-58h": 17,
                "58-60h": 13,
                "60-62h": 11,
                "62-64h": 3,
                "64-66h": 3,
                "66-68h": 9,
                "68-70h": 9,
                "70-72h": 19,
                "72-74h": 14,
                "74-76h": 19,
                "76-78h": 16,
                "78-80h": 26,
                "80-82h": 17,
                "82-84h": 20,
                "84-86h": 8,
                "86-88h": 2,
                "88-90h": 6,
                "90-92h": 6,
                "92-94h": 12,
                "94-96h": 26,
                "96-98h": 21,
                "98-100h": 17,
                "100-102h": 10,
                "102-104h": 18,
                "104-106h": 19,
                "108-110h": 3,
                "110-112h": 4,
                "112-114h": 7,
                "114-116h": 11,
                "116-118h": 6,
                "118-120h": 15,
                "120-122h": 16,
                "122-124h": 19,
                "124-126h": 11,
                "126-128h": 12,
                "128-130h": 6,
                "130-132h": 6,
                "132-134h": 2,
                "134-136h": 8,
                "136-138h": 2,
                "138-140h": 5,
                "140-142h": 22,
                "142-144h": 8,
                "144-146h": 13,
                "146-148h": 8,
                "148-150h": 4,
                "150-152h": 12,
                "152-154h": 2,
                "154-156h": 7,
                "156-158h": 12,
                "158-160h": 8,
                "160-162h": 5,
                "162-164h": 9,
                "164-166h": 16,
                "166-168h": 7,
                "168-170h": 2,
                "170-172h": 1,
                "172-174h": 7,
                "174-176h": 6,
                "176-178h": 7,
                "178-180h": 8,
                "180-182h": 14,
                "182-184h": 5,
                "184-186h": 4,
                "186-188h": 3,
                "188-190h": 1,
                "190-192h": 1,
                "192-194h": 6,
                "194-196h": 9,
                "196-198h": 5,
                "198-200h": 5,
                "200-202h": 7,
                "202-204h": 4,
                "204-206h": 3,
                "206-208h": 9,
                "208-210h": 3,
                "210-212h": 5,
                "212-214h": 5,
                "214-216h": 5,
                "216-218h": 27,
                "218-220h": 3,
                "220-222h": 2,
                "222-224h": 1,
                "224-226h": 1,
                "228-230h": 8,
                "234-236h": 3,
                "238-240h": 3,
                "240-242h": 5,
                "242-244h": 2,
                "244-246h": 1,
                "252-254h": 1,
                "256-258h": 3,
                "258-260h": 3,
                "260-262h": 2,
                "264-266h": 1,
                "266-268h": 6,
                "268-270h": 1,
                "270-272h": 1,
                "272-274h": 5,
                "274-276h": 5,
                "276-278h": 7,
                "278-280h": 4,
                "280-282h": 1,
                "282-284h": 5,
                "284-286h": 2,
                "286-288h": 6,
                "288-290h": 9,
                "294-296h": 1,
                "298-300h": 1,
                "302-304h": 1,
                "304-306h": 3,
                "306-308h": 3,
                "310-312h": 10,
                "312-314h": 6,
                "314-316h": 1,
                "316-318h": 2,
                "322-324h": 1,
                "324-326h": 4,
                "328-330h": 3,
                "330-332h": 4,
                "332-334h": 5,
                "334-336h": 14,
                "336-338h": 8,
                "338-340h": 2,
                "340-342h": 1,
                "342-344h": 1,
                "346-348h": 1,
                "348-350h": 4,
                "350-352h": 2,
                "352-354h": 5,
                "354-356h": 3,
                "356-358h": 9,
                "358-360h": 7,
                "360-362h": 3,
                "362-364h": 2,
                "364-366h": 3,
                "366-368h": 1,
                "368-370h": 1,
                "370-372h": 8,
                "372-374h": 10,
                "376-378h": 2,
                "378-380h": 2,
                "380-382h": 4,
                "382-384h": 13,
                "384-386h": 19,
                "386-388h": 1,
                "388-390h": 6,
                "390-392h": 1,
                "392-394h": 2,
                "396-398h": 1,
                "398-400h": 13,
                "400-402h": 8,
                "402-404h": 2,
                "404-406h": 10,
                "406-408h": 3,
                "408-410h": 4,
                "412-414h": 1,
                "414-416h": 4,
                "416-418h": 3,
                "420-422h": 9,
                "422-424h": 6,
                "424-426h": 4,
                "426-428h": 4,
                "428-430h": 6,
                "430-432h": 3,
                "432-434h": 3,
                "442-444h": 1,
                "444-446h": 5,
                "446-448h": 4,
                "448-450h": 1,
                "450-452h": 2,
                "452-454h": 7,
                "454-456h": 8,
                "456-458h": 10,
                "458-460h": 2,
                "462-464h": 1,
                "466-468h": 7,
                "472-474h": 1,
                "474-476h": 1,
                "476-478h": 1,
                "478-480h": 3,
                "480-482h": 1,
                "482-484h": 1,
                "490-492h": 1,
                "492-494h": 3,
                "494-496h": 1,
                "496-498h": 7,
                "498-500h": 3,
                "500-502h": 6,
                "502-504h": 12,
                "504-506h": 4,
                "508-510h": 5,
                "510-512h": 1,
                "514-516h": 1,
                "522-524h": 1,
                "524-526h": 2,
                "526-528h": 1,
                "530-532h": 2,
                "532-534h": 1,
                "538-540h": 1,
                "540-542h": 1,
                "546-548h": 3,
                "548-550h": 3,
                "552-554h": 1,
                "554-556h": 1,
                "556-558h": 2,
                "558-560h": 1,
                "570-572h": 1,
                "574-576h": 1,
                "576-578h": 1,
                "582-584h": 2,
                "594-596h": 1,
                "598-600h": 2,
                "602-604h": 1,
                "604-606h": 1,
                "614-616h": 1,
                "620-622h": 2,
                "622-624h": 1,
                "624-626h": 3,
                "626-628h": 1,
                "628-630h": 2,
                "630-632h": 1,
                "634-636h": 1,
                "644-646h": 1,
                "646-648h": 2,
                "650-652h": 2,
                "652-654h": 2,
                "654-656h": 1,
                "656-658h": 1,
                "664-666h": 2,
                "674-676h": 1,
                "678-680h": 1,
                "690-692h": 1,
                "700-702h": 2,
                "702-704h": 1,
                "724-726h": 2,
                "726-728h": 1,
                "816-818h": 1,
                "824-826h": 3,
                "836-838h": 1,
                "838-840h": 1,
                "848-850h": 1,
                "858-860h": 1,
                "916-918h": 1,
                "966-968h": 1,
                "982-984h": 2,
                "1152-1154h": 1,
                "1222-1224h": 2,
                "1412-1414h": 1,
                "1506-1508h": 1,
                "1846-1848h": 1,
                "2344-2346h": 1
              },
              "tickets_count": 2191,
              "tickets_per_day": {
                "2025-09-30": 4,
                "2025-10-01": 2,
                "2025-10-03": 2,
                "2025-10-06": 1,
                "2025-10-07": 28,
                "2025-10-08": 2,
                "2025-10-09": 10,
                "2025-10-10": 2,
                "2025-10-13": 23,
                "2025-10-14": 13,
                "2025-10-15": 17,
                "2025-10-16": 2,
                "2025-10-17": 21,
                "2025-10-20": 8,
                "2025-10-21": 6,
                "2025-10-22": 4,
                "2025-10-23": 22,
                "2025-10-25": 8,
                "2025-10-27": 17,
                "2025-10-28": 1,
                "2025-10-29": 17,
                "2025-10-30": 8,
                "2025-10-31": 9,
                "2025-11-03": 5,
                "2025-11-05": 20,
                "2025-11-06": 5,
                "2025-11-07": 2,
                "2025-11-10": 8,
                "2025-11-11": 7,
                "2025-11-12": 14,
                "2025-11-13": 4,
                "2025-11-14": 16,
                "2025-11-17": 2,
                "2025-11-19": 18,
                "2025-11-20": 26,
                "2025-11-21": 25,
                "2025-11-22": 8,
                "2025-11-23": 2,
                "2025-11-24": 6,
                "2025-11-25": 8,
                "2025-11-29": 12,
                "2025-12-02": 26,
                "2025-12-03": 27,
                "2025-12-04": 8,
                "2025-12-05": 5,
                "2025-12-09": 3,
                "2025-12-10": 13,
                "2025-12-11": 6,
                "2025-12-15": 33,
                "2025-12-16": 5,
                "2025-12-18": 2,
                "2025-12-19": 4,
                "2025-12-22": 19,
                "2025-12-23": 2,
                "2025-12-26": 6,
                "2025-12-29": 8,
                "2025-12-30": 4,
                "2026-01-02": 2,
                "2026-01-08": 35,
                "2026-01-09": 17,
                "2026-01-12": 1,
                "2026-01-13": 34,
                "2026-01-15": 14,
                "2026-01-16": 5,
                "2026-01-17": 6,
                "2026-01-18": 1,
                "2026-01-21": 18,
                "2026-01-23": 23,
                "2026-01-24": 31,
                "2026-01-26": 1,
                "2026-01-27": 51,
                "2026-01-30": 9,
                "2026-01-31": 5,
                "2026-02-02": 3,
                "2026-02-04": 7,
                "2026-02-05": 25,
                "2026-02-06": 85,
                "2026-02-09": 17,
                "2026-02-10": 28,
                "2026-02-11": 19,
                "2026-02-12": 16,
                "2026-02-13": 16,
                "2026-02-14": 8,
                "2026-02-16": 1,
                "2026-02-17": 5,
                "2026-02-18": 21,
                "2026-02-19": 33,
                "2026-02-20": 1,
                "2026-02-21": 35,
                "2026-02-23": 38,
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-02-28": 101,
                "2026-03-02": 5,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-14": 38,
                "2026-03-17": 102,
                "2026-03-18": 500,
                "2026-03-20": 29,
                "2026-03-24": 51,
                "2026-03-25": 8,
                "2026-03-26": 60,
                "2026-03-30": 25,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-11": 1,
                "2026-04-22": 54,
                "2026-04-27": 1,
                "2026-05-01": 2,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-14": 1,
                "2026-05-25": 1,
                "2026-05-29": 2,
                "2026-06-01": 2,
                "2026-06-03": 2
              },
              "time_per_day": {
                "2025-09-30": 8.730323055555555,
                "2025-10-01": 26.06114138888889,
                "2025-10-03": 77.00389916666666,
                "2025-10-06": 0.2261397222222222,
                "2025-10-07": 1473.3353519444447,
                "2025-10-08": 24.207752777777777,
                "2025-10-09": 293.0410333333333,
                "2025-10-10": 83.31462638888888,
                "2025-10-13": 1643.106725277778,
                "2025-10-14": 332.30034222222224,
                "2025-10-15": 478.17707388888897,
                "2025-10-16": 51.901759444444444,
                "2025-10-17": 600.4831919444445,
                "2025-10-20": 524.6354675,
                "2025-10-21": 353.0865875,
                "2025-10-22": 261.9568313888889,
                "2025-10-23": 803.4192783333332,
                "2025-10-25": 556.5096319444444,
                "2025-10-27": 441.0875802777779,
                "2025-10-28": 112.77314861111111,
                "2025-10-29": 647.1027088888889,
                "2025-10-30": 619.6412616666668,
                "2025-10-31": 801.2731100000002,
                "2025-11-03": 214.84650750000006,
                "2025-11-05": 1351.9214844444443,
                "2025-11-06": 86.34569222222223,
                "2025-11-07": 10.500877222222222,
                "2025-11-10": 270.3736527777778,
                "2025-11-11": 132.83847166666666,
                "2025-11-12": 422.24723805555556,
                "2025-11-13": 336.3064963888889,
                "2025-11-14": 435.46917305555564,
                "2025-11-17": 192.17588916666665,
                "2025-11-19": 2127.918883055556,
                "2025-11-20": 1551.2522841666669,
                "2025-11-21": 1184.905641388889,
                "2025-11-22": 251.67333138888887,
                "2025-11-23": 167.58566583333334,
                "2025-11-24": 284.41399138888886,
                "2025-11-25": 208.5084277777778,
                "2025-11-29": 1250.137724166667,
                "2025-12-02": 2539.9803475,
                "2025-12-03": 2482.634415555555,
                "2025-12-04": 531.5756275,
                "2025-12-05": 342.50913027777784,
                "2025-12-09": 463.0160102777777,
                "2025-12-10": 472.8905525,
                "2025-12-11": 356.2948936111111,
                "2025-12-15": 2363.849196666667,
                "2025-12-16": 54.46674277777778,
                "2025-12-18": 101.54243861111112,
                "2025-12-19": 122.7490525,
                "2025-12-22": 383.99791027777775,
                "2025-12-23": 41.38577444444445,
                "2025-12-26": 615.3942780555556,
                "2025-12-29": 1528.0387966666665,
                "2025-12-30": 442.5796055555556,
                "2026-01-02": 83.53357944444444,
                "2026-01-08": 3043.5181644444447,
                "2026-01-09": 898.1341563888889,
                "2026-01-12": 577.3386069444445,
                "2026-01-13": 2385.1664144444444,
                "2026-01-15": 1217.8775291666668,
                "2026-01-16": 152.70728444444447,
                "2026-01-17": 159.38182194444443,
                "2026-01-18": 49.25654222222222,
                "2026-01-21": 1152.7598858333333,
                "2026-01-23": 2538.404043611112,
                "2026-01-24": 4738.290933333334,
                "2026-01-26": 141.78708805555556,
                "2026-01-27": 3724.0806002777786,
                "2026-01-30": 3805.7896075,
                "2026-01-31": 732.5578702777779,
                "2026-02-02": 291.3593063888889,
                "2026-02-04": 925.6502922222223,
                "2026-02-05": 3849.8910063888884,
                "2026-02-06": 19683.526150277787,
                "2026-02-09": 1705.9583597222222,
                "2026-02-10": 8284.579282222223,
                "2026-02-11": 3549.9131072222226,
                "2026-02-12": 2135.5949719444443,
                "2026-02-13": 1996.694378611111,
                "2026-02-14": 753.2859988888889,
                "2026-02-16": 91.5712575,
                "2026-02-17": 768.7245447222223,
                "2026-02-18": 2056.0249566666666,
                "2026-02-19": 1304.9263105555558,
                "2026-02-20": 2.2928872222222223,
                "2026-02-21": 880.5069977777778,
                "2026-02-23": 1387.3828400000004,
                "2026-02-25": 0.16812472222222222,
                "2026-02-26": 20.466793888888887,
                "2026-02-27": 0.19803777777777778,
                "2026-02-28": 8058.580518055558,
                "2026-03-02": 327.4029586111111,
                "2026-03-06": 1.2834841666666665,
                "2026-03-07": 0.012258888888888889,
                "2026-03-14": 2800.7672597222213,
                "2026-03-17": 3963.3662405555556,
                "2026-03-18": 163629.1897950002,
                "2026-03-20": 1507.8747613888886,
                "2026-03-24": 5401.455450277779,
                "2026-03-25": 138.21975305555557,
                "2026-03-26": 30050.62612611111,
                "2026-03-30": 4841.123677222222,
                "2026-04-07": 0.796861111111111,
                "2026-04-08": 145.07749555555554,
                "2026-04-11": 213.39262638888889,
                "2026-04-22": 7961.982295277776,
                "2026-04-27": 95.15757555555555,
                "2026-05-01": 392.60974166666665,
                "2026-05-06": 1847.0052547222224,
                "2026-05-07": 349.61040638888886,
                "2026-05-14": 1413.5362316666667,
                "2026-05-25": 100.02589055555556,
                "2026-05-29": 2447.031906111111,
                "2026-06-01": 1254.5499897222223,
                "2026-06-03": 186.51974194444446
              },
              "time_count_per_day": {
                "2025-09-30": 4,
                "2025-10-01": 2,
                "2025-10-03": 2,
                "2025-10-06": 1,
                "2025-10-07": 28,
                "2025-10-08": 2,
                "2025-10-09": 10,
                "2025-10-10": 2,
                "2025-10-13": 23,
                "2025-10-14": 13,
                "2025-10-15": 17,
                "2025-10-16": 2,
                "2025-10-17": 21,
                "2025-10-20": 8,
                "2025-10-21": 6,
                "2025-10-22": 4,
                "2025-10-23": 22,
                "2025-10-25": 8,
                "2025-10-27": 17,
                "2025-10-28": 1,
                "2025-10-29": 17,
                "2025-10-30": 8,
                "2025-10-31": 9,
                "2025-11-03": 5,
                "2025-11-05": 20,
                "2025-11-06": 5,
                "2025-11-07": 2,
                "2025-11-10": 8,
                "2025-11-11": 7,
                "2025-11-12": 14,
                "2025-11-13": 4,
                "2025-11-14": 16,
                "2025-11-17": 2,
                "2025-11-19": 18,
                "2025-11-20": 26,
                "2025-11-21": 25,
                "2025-11-22": 8,
                "2025-11-23": 2,
                "2025-11-24": 6,
                "2025-11-25": 8,
                "2025-11-29": 12,
                "2025-12-02": 26,
                "2025-12-03": 27,
                "2025-12-04": 8,
                "2025-12-05": 5,
                "2025-12-09": 3,
                "2025-12-10": 13,
                "2025-12-11": 6,
                "2025-12-15": 33,
                "2025-12-16": 5,
                "2025-12-18": 2,
                "2025-12-19": 4,
                "2025-12-22": 19,
                "2025-12-23": 2,
                "2025-12-26": 6,
                "2025-12-29": 8,
                "2025-12-30": 4,
                "2026-01-02": 2,
                "2026-01-08": 35,
                "2026-01-09": 17,
                "2026-01-12": 1,
                "2026-01-13": 34,
                "2026-01-15": 14,
                "2026-01-16": 5,
                "2026-01-17": 6,
                "2026-01-18": 1,
                "2026-01-21": 18,
                "2026-01-23": 23,
                "2026-01-24": 31,
                "2026-01-26": 1,
                "2026-01-27": 51,
                "2026-01-30": 9,
                "2026-01-31": 5,
                "2026-02-02": 3,
                "2026-02-04": 7,
                "2026-02-05": 25,
                "2026-02-06": 85,
                "2026-02-09": 17,
                "2026-02-10": 28,
                "2026-02-11": 19,
                "2026-02-12": 16,
                "2026-02-13": 16,
                "2026-02-14": 8,
                "2026-02-16": 1,
                "2026-02-17": 5,
                "2026-02-18": 21,
                "2026-02-19": 33,
                "2026-02-20": 1,
                "2026-02-21": 35,
                "2026-02-23": 38,
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-02-28": 101,
                "2026-03-02": 5,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-14": 38,
                "2026-03-17": 102,
                "2026-03-18": 500,
                "2026-03-20": 29,
                "2026-03-24": 51,
                "2026-03-25": 8,
                "2026-03-26": 60,
                "2026-03-30": 25,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-11": 1,
                "2026-04-22": 54,
                "2026-04-27": 1,
                "2026-05-01": 2,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-14": 1,
                "2026-05-25": 1,
                "2026-05-29": 2,
                "2026-06-01": 2,
                "2026-06-03": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 571.37,
              "mode_time_hours": 73.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 2,
                "4-6h": 4,
                "6-8h": 2,
                "8-10h": 1,
                "10-12h": 1,
                "14-16h": 2,
                "18-20h": 1,
                "20-22h": 4,
                "22-24h": 2,
                "28-30h": 2,
                "30-32h": 1,
                "36-38h": 1,
                "40-42h": 1,
                "44-46h": 3,
                "46-48h": 3,
                "50-52h": 1,
                "52-54h": 3,
                "56-58h": 2,
                "62-64h": 1,
                "72-74h": 9,
                "74-76h": 1,
                "78-80h": 1,
                "90-92h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "100-102h": 3,
                "114-116h": 1,
                "116-118h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "122-124h": 2,
                "130-132h": 1,
                "132-134h": 2,
                "134-136h": 1,
                "136-138h": 5,
                "138-140h": 1,
                "142-144h": 2,
                "146-148h": 1,
                "158-160h": 2,
                "160-162h": 2,
                "162-164h": 1,
                "164-166h": 1,
                "166-168h": 1,
                "170-172h": 1,
                "178-180h": 1,
                "180-182h": 3,
                "182-184h": 2,
                "184-186h": 2,
                "186-188h": 2,
                "190-192h": 1,
                "192-194h": 3,
                "196-198h": 2,
                "202-204h": 2,
                "204-206h": 6,
                "206-208h": 2,
                "208-210h": 3,
                "216-218h": 7,
                "228-230h": 1,
                "230-232h": 3,
                "232-234h": 3,
                "234-236h": 4,
                "236-238h": 2,
                "240-242h": 9,
                "258-260h": 1,
                "284-286h": 1,
                "288-290h": 4,
                "290-292h": 1,
                "294-296h": 1,
                "298-300h": 1,
                "300-302h": 7,
                "302-304h": 7,
                "304-306h": 1,
                "306-308h": 4,
                "310-312h": 1,
                "312-314h": 2,
                "318-320h": 1,
                "322-324h": 2,
                "324-326h": 1,
                "326-328h": 1,
                "328-330h": 3,
                "330-332h": 3,
                "334-336h": 2,
                "336-338h": 3,
                "344-346h": 1,
                "350-352h": 2,
                "354-356h": 1,
                "360-362h": 1,
                "364-366h": 3,
                "372-374h": 2,
                "374-376h": 3,
                "382-384h": 1,
                "384-386h": 5,
                "394-396h": 1,
                "396-398h": 1,
                "400-402h": 1,
                "402-404h": 1,
                "404-406h": 2,
                "406-408h": 1,
                "408-410h": 6,
                "442-444h": 1,
                "450-452h": 1,
                "468-470h": 1,
                "470-472h": 1,
                "472-474h": 7,
                "474-476h": 2,
                "476-478h": 4,
                "478-480h": 3,
                "480-482h": 1,
                "492-494h": 1,
                "496-498h": 2,
                "498-500h": 1,
                "500-502h": 1,
                "502-504h": 1,
                "504-506h": 4,
                "520-522h": 1,
                "522-524h": 1,
                "528-530h": 1,
                "532-534h": 1,
                "542-544h": 2,
                "544-546h": 6,
                "546-548h": 1,
                "548-550h": 2,
                "550-552h": 3,
                "552-554h": 2,
                "564-566h": 5,
                "566-568h": 2,
                "568-570h": 1,
                "570-572h": 1,
                "574-576h": 1,
                "576-578h": 9,
                "580-582h": 1,
                "616-618h": 4,
                "618-620h": 1,
                "622-624h": 2,
                "624-626h": 2,
                "634-636h": 2,
                "636-638h": 1,
                "638-640h": 4,
                "642-644h": 1,
                "650-652h": 1,
                "652-654h": 1,
                "658-660h": 2,
                "662-664h": 1,
                "664-666h": 3,
                "666-668h": 2,
                "668-670h": 2,
                "670-672h": 2,
                "672-674h": 4,
                "682-684h": 6,
                "684-686h": 1,
                "688-690h": 1,
                "690-692h": 3,
                "692-694h": 5,
                "694-696h": 1,
                "708-710h": 1,
                "710-712h": 3,
                "714-716h": 1,
                "716-718h": 1,
                "718-720h": 1,
                "720-722h": 5,
                "728-730h": 1,
                "732-734h": 1,
                "734-736h": 6,
                "736-738h": 3,
                "738-740h": 3,
                "740-742h": 1,
                "744-746h": 1,
                "762-764h": 1,
                "766-768h": 1,
                "768-770h": 5,
                "784-786h": 1,
                "786-788h": 1,
                "788-790h": 2,
                "790-792h": 3,
                "792-794h": 1,
                "804-806h": 5,
                "808-810h": 2,
                "814-816h": 2,
                "816-818h": 1,
                "826-828h": 2,
                "828-830h": 1,
                "830-832h": 1,
                "840-842h": 1,
                "844-846h": 1,
                "852-854h": 3,
                "854-856h": 1,
                "860-862h": 1,
                "876-878h": 2,
                "878-880h": 1,
                "900-902h": 1,
                "908-910h": 1,
                "912-914h": 2,
                "960-962h": 1,
                "966-968h": 1,
                "972-974h": 1,
                "976-978h": 1,
                "978-980h": 2,
                "982-984h": 2,
                "994-996h": 1,
                "1002-1004h": 1,
                "1008-1010h": 4,
                "1020-1022h": 3,
                "1026-1028h": 2,
                "1044-1046h": 1,
                "1050-1052h": 1,
                "1056-1058h": 1,
                "1066-1068h": 1,
                "1068-1070h": 1,
                "1072-1074h": 2,
                "1078-1080h": 2,
                "1080-1082h": 2,
                "1100-1102h": 1,
                "1124-1126h": 8,
                "1138-1140h": 2,
                "1142-1144h": 1,
                "1150-1152h": 1,
                "1198-1200h": 1,
                "1214-1216h": 1,
                "1216-1218h": 1,
                "1236-1238h": 2,
                "1238-1240h": 1,
                "1240-1242h": 1,
                "1248-1250h": 1,
                "1270-1272h": 3,
                "1344-1346h": 1,
                "1368-1370h": 2,
                "1406-1408h": 1,
                "1408-1410h": 1,
                "1416-1418h": 4,
                "1460-1462h": 1,
                "1462-1464h": 1,
                "1488-1490h": 1,
                "1546-1548h": 1,
                "1698-1700h": 2,
                "1704-1706h": 2,
                "1718-1720h": 1,
                "1838-1840h": 2,
                "1862-1864h": 1,
                "1916-1918h": 1,
                "1962-1964h": 1,
                "1964-1966h": 2,
                "2036-2038h": 1,
                "2054-2056h": 1,
                "2132-2134h": 1,
                "2208-2210h": 1,
                "2272-2274h": 1,
                "3186-3188h": 1
              },
              "tickets_count": 501,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 9,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-11": 12,
                "2025-12-15": 9,
                "2025-12-16": 5,
                "2025-12-17": 5,
                "2025-12-18": 2,
                "2025-12-19": 1,
                "2025-12-22": 4,
                "2025-12-26": 4,
                "2025-12-29": 5,
                "2026-01-02": 7,
                "2026-01-14": 1,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-01-17": 13,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-13": 2,
                "2026-02-18": 11,
                "2026-02-19": 394
              },
              "time_per_day": {
                "2025-12-02": 134.65423694444445,
                "2025-12-03": 646.6295922222222,
                "2025-12-04": 15.857530555555556,
                "2025-12-05": 162.7952347222222,
                "2025-12-10": 5.782671111111112,
                "2025-12-11": 859.345117222222,
                "2025-12-15": 1433.7628705555555,
                "2025-12-16": 947.3718483333333,
                "2025-12-17": 667.4154191666667,
                "2025-12-18": 438.25786472222217,
                "2025-12-19": 443.54567305555554,
                "2025-12-22": 1095.9193366666666,
                "2025-12-26": 1295.4228025,
                "2025-12-29": 3130.3626858333328,
                "2026-01-02": 1906.9033894444447,
                "2026-01-14": 1.923925,
                "2026-01-15": 3221.4734291666664,
                "2026-01-16": 10.021557222222222,
                "2026-01-17": 1956.708928888889,
                "2026-01-23": 75.05059138888889,
                "2026-01-26": 2.3096630555555557,
                "2026-01-27": 65.93293416666667,
                "2026-02-03": 1581.4455555555555,
                "2026-02-05": 179.07435750000002,
                "2026-02-13": 665.9047383333333,
                "2026-02-18": 20890.08774916666,
                "2026-02-19": 244423.80336555568
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 9,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-11": 12,
                "2025-12-15": 9,
                "2025-12-16": 5,
                "2025-12-17": 5,
                "2025-12-18": 2,
                "2025-12-19": 1,
                "2025-12-22": 4,
                "2025-12-26": 4,
                "2025-12-29": 5,
                "2026-01-02": 7,
                "2026-01-14": 1,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-01-17": 13,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-13": 2,
                "2026-02-18": 11,
                "2026-02-19": 394
              }
            }
          }
        },
        "Cuba Cancelado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 13,
            "tickets_per_day": {
              "2026-03-03": 13
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-03-03": 13
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 550,
            "tickets_per_day": {
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-02-16": 5,
              "2026-02-17": 5,
              "2026-02-18": 4,
              "2026-02-19": 10,
              "2026-02-20": 9,
              "2026-02-21": 2,
              "2026-02-23": 4,
              "2026-02-24": 3,
              "2026-02-25": 3,
              "2026-02-26": 1,
              "2026-02-28": 4,
              "2026-03-01": 1,
              "2026-03-02": 7,
              "2026-03-03": 7,
              "2026-03-04": 8,
              "2026-03-05": 4,
              "2026-03-06": 6,
              "2026-03-07": 1,
              "2026-03-09": 9,
              "2026-03-10": 8,
              "2026-03-11": 11,
              "2026-03-14": 1,
              "2026-03-16": 2,
              "2026-03-18": 4,
              "2026-03-19": 1,
              "2026-03-20": 2,
              "2026-03-21": 2,
              "2026-03-23": 2,
              "2026-03-24": 1,
              "2026-03-25": 2,
              "2026-03-26": 1,
              "2026-03-27": 6,
              "2026-03-28": 3,
              "2026-03-30": 11,
              "2026-03-31": 9,
              "2026-04-01": 6,
              "2026-04-02": 6,
              "2026-04-04": 4,
              "2026-04-06": 5,
              "2026-04-07": 5,
              "2026-04-08": 5,
              "2026-04-09": 9,
              "2026-04-10": 4,
              "2026-04-13": 1,
              "2026-04-14": 3,
              "2026-04-15": 7,
              "2026-04-16": 2,
              "2026-04-17": 1,
              "2026-04-18": 2,
              "2026-04-20": 3,
              "2026-04-21": 1,
              "2026-04-22": 9,
              "2026-04-23": 5,
              "2026-04-24": 13,
              "2026-04-27": 21,
              "2026-04-28": 7,
              "2026-04-29": 12,
              "2026-04-30": 9,
              "2026-05-02": 14,
              "2026-05-04": 14,
              "2026-05-05": 9,
              "2026-05-06": 15,
              "2026-05-07": 7,
              "2026-05-08": 14,
              "2026-05-09": 10,
              "2026-05-11": 7,
              "2026-05-12": 9,
              "2026-05-13": 5,
              "2026-05-14": 4,
              "2026-05-15": 6,
              "2026-05-18": 12,
              "2026-05-19": 7,
              "2026-05-20": 15,
              "2026-05-21": 11,
              "2026-05-22": 6,
              "2026-05-23": 1,
              "2026-05-25": 10,
              "2026-05-26": 4,
              "2026-05-27": 9,
              "2026-05-28": 6,
              "2026-05-29": 8,
              "2026-05-30": 4,
              "2026-06-01": 2,
              "2026-06-02": 5,
              "2026-06-03": 5,
              "2026-06-05": 5,
              "2026-06-06": 5,
              "2026-06-07": 1,
              "2026-06-08": 18
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-06-07": 1,
                "2026-06-08": 6
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 482,
              "tickets_per_day": {
                "2026-02-11": 1,
                "2026-02-12": 1,
                "2026-02-14": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-25": 2,
                "2026-02-26": 1,
                "2026-02-28": 4,
                "2026-03-01": 1,
                "2026-03-02": 3,
                "2026-03-03": 5,
                "2026-03-04": 7,
                "2026-03-05": 3,
                "2026-03-06": 2,
                "2026-03-07": 1,
                "2026-03-09": 5,
                "2026-03-10": 8,
                "2026-03-11": 6,
                "2026-03-14": 1,
                "2026-03-16": 2,
                "2026-03-18": 4,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-23": 2,
                "2026-03-24": 1,
                "2026-03-25": 2,
                "2026-03-26": 1,
                "2026-03-27": 6,
                "2026-03-28": 3,
                "2026-03-30": 11,
                "2026-03-31": 9,
                "2026-04-01": 6,
                "2026-04-02": 6,
                "2026-04-04": 4,
                "2026-04-06": 5,
                "2026-04-07": 5,
                "2026-04-08": 5,
                "2026-04-09": 9,
                "2026-04-10": 4,
                "2026-04-13": 1,
                "2026-04-14": 3,
                "2026-04-15": 7,
                "2026-04-16": 2,
                "2026-04-17": 1,
                "2026-04-18": 2,
                "2026-04-20": 3,
                "2026-04-21": 1,
                "2026-04-22": 9,
                "2026-04-23": 5,
                "2026-04-24": 13,
                "2026-04-27": 21,
                "2026-04-28": 7,
                "2026-04-29": 12,
                "2026-04-30": 9,
                "2026-05-02": 14,
                "2026-05-04": 14,
                "2026-05-05": 9,
                "2026-05-06": 15,
                "2026-05-07": 7,
                "2026-05-08": 14,
                "2026-05-09": 10,
                "2026-05-11": 7,
                "2026-05-12": 9,
                "2026-05-13": 5,
                "2026-05-14": 4,
                "2026-05-15": 6,
                "2026-05-18": 12,
                "2026-05-19": 7,
                "2026-05-20": 15,
                "2026-05-21": 11,
                "2026-05-22": 6,
                "2026-05-23": 1,
                "2026-05-25": 10,
                "2026-05-26": 4,
                "2026-05-27": 9,
                "2026-05-28": 6,
                "2026-05-29": 8,
                "2026-05-30": 4,
                "2026-06-01": 2,
                "2026-06-02": 5,
                "2026-06-03": 5,
                "2026-06-05": 5,
                "2026-06-06": 5,
                "2026-06-08": 12
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 61,
              "tickets_per_day": {
                "2026-02-16": 5,
                "2026-02-17": 5,
                "2026-02-18": 3,
                "2026-02-19": 9,
                "2026-02-20": 8,
                "2026-02-21": 2,
                "2026-02-23": 4,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-02": 4,
                "2026-03-03": 2,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-06": 4,
                "2026-03-09": 4,
                "2026-03-11": 5,
                "2026-03-21": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 20,
            "tickets_per_day": {
              "2026-01-03": 1,
              "2026-01-21": 1,
              "2026-02-04": 1,
              "2026-02-11": 1,
              "2026-02-14": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-25": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-21": 1,
              "2026-04-24": 1,
              "2026-04-28": 1,
              "2026-04-30": 1,
              "2026-05-11": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-25": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 16,
              "tickets_per_day": {
                "2026-01-03": 1,
                "2026-02-04": 1,
                "2026-02-18": 1,
                "2026-02-25": 1,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-21": 1,
                "2026-04-24": 1,
                "2026-04-28": 1,
                "2026-04-30": 1,
                "2026-05-11": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-25": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-21": 1,
                "2026-02-11": 1,
                "2026-02-14": 1,
                "2026-02-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2025-12-28": 1,
              "2026-01-02": 1,
              "2026-01-14": 1,
              "2026-02-16": 4,
              "2026-02-18": 1,
              "2026-02-23": 13,
              "2026-03-23": 1,
              "2026-04-01": 1,
              "2026-04-10": 1,
              "2026-04-24": 1,
              "2026-05-18": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-12-28": 1,
                "2026-01-02": 1,
                "2026-02-16": 4,
                "2026-03-23": 1,
                "2026-04-01": 1,
                "2026-04-10": 1,
                "2026-04-24": 1,
                "2026-05-18": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2026-01-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-02-23": 13
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2025-12-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2025-10-07": 2,
              "2025-10-08": 1,
              "2025-10-19": 1,
              "2025-10-20": 1,
              "2025-10-29": 1,
              "2025-11-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-07": 1,
                "2025-10-19": 1,
                "2025-10-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-08": 1,
                "2025-11-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-01-20": 1,
              "2026-02-16": 1,
              "2026-03-25": 2,
              "2026-05-12": 1,
              "2026-05-15": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-20": 1,
                "2026-02-16": 1,
                "2026-03-25": 2,
                "2026-05-12": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-21": 1,
              "2025-11-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Sandra Reis": {
      "overall": {
        "avg_time_hours": 196.17,
        "mode_time_hours": 1.0,
        "mode_frequency": 240,
        "time_distribution": {
          "0-2h": 240,
          "2-4h": 107,
          "4-6h": 62,
          "6-8h": 22,
          "8-10h": 30,
          "10-12h": 2,
          "12-14h": 5,
          "14-16h": 7,
          "16-18h": 7,
          "18-20h": 8,
          "20-22h": 5,
          "22-24h": 12,
          "24-26h": 20,
          "26-28h": 10,
          "28-30h": 8,
          "30-32h": 11,
          "32-34h": 5,
          "36-38h": 2,
          "38-40h": 1,
          "42-44h": 1,
          "44-46h": 2,
          "46-48h": 5,
          "48-50h": 7,
          "50-52h": 8,
          "52-54h": 5,
          "54-56h": 11,
          "56-58h": 5,
          "64-66h": 1,
          "66-68h": 2,
          "68-70h": 2,
          "70-72h": 4,
          "72-74h": 7,
          "74-76h": 4,
          "76-78h": 4,
          "78-80h": 9,
          "80-82h": 2,
          "86-88h": 2,
          "88-90h": 1,
          "92-94h": 4,
          "94-96h": 1,
          "96-98h": 2,
          "98-100h": 4,
          "100-102h": 7,
          "102-104h": 1,
          "114-116h": 9,
          "116-118h": 3,
          "118-120h": 6,
          "120-122h": 3,
          "122-124h": 4,
          "124-126h": 2,
          "126-128h": 6,
          "128-130h": 3,
          "136-138h": 2,
          "138-140h": 1,
          "140-142h": 2,
          "142-144h": 3,
          "144-146h": 1,
          "146-148h": 6,
          "148-150h": 2,
          "150-152h": 5,
          "152-154h": 1,
          "154-156h": 1,
          "156-158h": 1,
          "158-160h": 2,
          "162-164h": 4,
          "164-166h": 3,
          "166-168h": 7,
          "168-170h": 6,
          "170-172h": 2,
          "172-174h": 3,
          "174-176h": 7,
          "176-178h": 1,
          "178-180h": 2,
          "180-182h": 1,
          "182-184h": 2,
          "184-186h": 3,
          "186-188h": 1,
          "190-192h": 1,
          "192-194h": 1,
          "194-196h": 1,
          "196-198h": 1,
          "198-200h": 3,
          "200-202h": 1,
          "204-206h": 4,
          "208-210h": 2,
          "212-214h": 3,
          "216-218h": 3,
          "218-220h": 3,
          "220-222h": 1,
          "222-224h": 2,
          "226-228h": 3,
          "228-230h": 1,
          "232-234h": 1,
          "238-240h": 1,
          "240-242h": 4,
          "242-244h": 8,
          "244-246h": 1,
          "248-250h": 1,
          "252-254h": 1,
          "254-256h": 1,
          "262-264h": 1,
          "264-266h": 2,
          "266-268h": 1,
          "268-270h": 6,
          "270-272h": 2,
          "272-274h": 1,
          "276-278h": 4,
          "282-284h": 1,
          "284-286h": 1,
          "288-290h": 1,
          "290-292h": 2,
          "292-294h": 2,
          "294-296h": 3,
          "298-300h": 3,
          "300-302h": 3,
          "306-308h": 3,
          "312-314h": 1,
          "314-316h": 1,
          "316-318h": 5,
          "318-320h": 5,
          "320-322h": 4,
          "322-324h": 2,
          "326-328h": 2,
          "330-332h": 1,
          "332-334h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "338-340h": 1,
          "340-342h": 3,
          "342-344h": 2,
          "344-346h": 2,
          "348-350h": 3,
          "350-352h": 6,
          "352-354h": 1,
          "358-360h": 1,
          "364-366h": 1,
          "366-368h": 1,
          "368-370h": 4,
          "370-372h": 2,
          "372-374h": 4,
          "376-378h": 1,
          "378-380h": 1,
          "386-388h": 3,
          "388-390h": 2,
          "390-392h": 4,
          "392-394h": 1,
          "400-402h": 1,
          "406-408h": 2,
          "408-410h": 2,
          "410-412h": 2,
          "414-416h": 4,
          "416-418h": 1,
          "418-420h": 1,
          "422-424h": 2,
          "424-426h": 1,
          "428-430h": 1,
          "430-432h": 1,
          "432-434h": 5,
          "434-436h": 2,
          "436-438h": 1,
          "448-450h": 1,
          "456-458h": 2,
          "460-462h": 1,
          "462-464h": 1,
          "464-466h": 1,
          "466-468h": 1,
          "468-470h": 1,
          "470-472h": 1,
          "478-480h": 5,
          "482-484h": 1,
          "488-490h": 3,
          "490-492h": 1,
          "492-494h": 2,
          "502-504h": 1,
          "506-508h": 1,
          "508-510h": 2,
          "512-514h": 2,
          "516-518h": 5,
          "518-520h": 1,
          "522-524h": 1,
          "526-528h": 1,
          "528-530h": 1,
          "530-532h": 2,
          "532-534h": 2,
          "534-536h": 1,
          "536-538h": 1,
          "538-540h": 4,
          "540-542h": 2,
          "548-550h": 1,
          "550-552h": 1,
          "552-554h": 4,
          "558-560h": 1,
          "560-562h": 1,
          "562-564h": 1,
          "566-568h": 1,
          "570-572h": 1,
          "574-576h": 2,
          "582-584h": 1,
          "586-588h": 1,
          "588-590h": 1,
          "590-592h": 1,
          "602-604h": 1,
          "606-608h": 1,
          "614-616h": 1,
          "626-628h": 2,
          "628-630h": 1,
          "654-656h": 1,
          "662-664h": 1,
          "664-666h": 1,
          "670-672h": 1,
          "672-674h": 1,
          "676-678h": 2,
          "678-680h": 2,
          "684-686h": 1,
          "690-692h": 1,
          "696-698h": 1,
          "704-706h": 1,
          "706-708h": 1,
          "724-726h": 2,
          "744-746h": 1,
          "748-750h": 1,
          "750-752h": 2,
          "754-756h": 1,
          "788-790h": 1,
          "790-792h": 1,
          "794-796h": 1,
          "796-798h": 1,
          "800-802h": 1,
          "812-814h": 1,
          "814-816h": 1,
          "816-818h": 1,
          "822-824h": 1,
          "838-840h": 1,
          "844-846h": 3,
          "866-868h": 2,
          "870-872h": 1,
          "872-874h": 2,
          "876-878h": 1,
          "882-884h": 1,
          "886-888h": 2,
          "890-892h": 1,
          "892-894h": 3,
          "894-896h": 2,
          "898-900h": 4,
          "910-912h": 1,
          "914-916h": 1,
          "916-918h": 1,
          "924-926h": 1,
          "984-986h": 1,
          "990-992h": 1,
          "1008-1010h": 1,
          "1068-1070h": 1,
          "1092-1094h": 1,
          "1114-1116h": 1,
          "1140-1142h": 1,
          "1162-1164h": 3,
          "1180-1182h": 1,
          "1188-1190h": 1,
          "1212-1214h": 1,
          "1228-1230h": 1,
          "1230-1232h": 1,
          "1234-1236h": 1,
          "1278-1280h": 1,
          "1284-1286h": 2,
          "1300-1302h": 1,
          "1376-1378h": 1,
          "1404-1406h": 1,
          "1422-1424h": 1,
          "1424-1426h": 1,
          "1426-1428h": 1,
          "1476-1478h": 1,
          "1498-1500h": 1,
          "1500-1502h": 1,
          "1518-1520h": 1,
          "1684-1686h": 2,
          "1732-1734h": 1,
          "1842-1844h": 1,
          "1896-1898h": 1,
          "2044-2046h": 1,
          "2696-2698h": 1,
          "3246-3248h": 1
        },
        "tickets_count": 1112,
        "tickets_per_day": {
          "2025-09-30": 7,
          "2025-10-01": 8,
          "2025-10-02": 2,
          "2025-10-03": 2,
          "2025-10-06": 8,
          "2025-10-07": 13,
          "2025-10-08": 7,
          "2025-10-09": 6,
          "2025-10-10": 14,
          "2025-10-13": 15,
          "2025-10-14": 13,
          "2025-10-15": 16,
          "2025-10-16": 4,
          "2025-10-20": 6,
          "2025-10-21": 14,
          "2025-10-22": 3,
          "2025-10-23": 27,
          "2025-10-24": 6,
          "2025-10-27": 7,
          "2025-10-28": 6,
          "2025-10-29": 15,
          "2025-10-30": 13,
          "2025-10-31": 6,
          "2025-11-03": 9,
          "2025-11-04": 5,
          "2025-11-05": 8,
          "2025-11-06": 10,
          "2025-11-07": 12,
          "2025-11-10": 11,
          "2025-11-11": 13,
          "2025-11-12": 12,
          "2025-11-13": 13,
          "2025-11-14": 13,
          "2025-11-17": 10,
          "2025-11-18": 6,
          "2025-11-19": 18,
          "2025-11-20": 11,
          "2025-11-21": 9,
          "2025-11-22": 1,
          "2025-11-24": 7,
          "2025-11-26": 11,
          "2025-11-27": 12,
          "2025-11-28": 7,
          "2025-12-02": 24,
          "2025-12-03": 3,
          "2025-12-04": 14,
          "2025-12-05": 12,
          "2025-12-09": 1,
          "2025-12-10": 7,
          "2025-12-11": 11,
          "2025-12-12": 8,
          "2025-12-15": 64,
          "2025-12-16": 3,
          "2025-12-17": 10,
          "2025-12-18": 8,
          "2025-12-19": 8,
          "2025-12-22": 5,
          "2025-12-23": 13,
          "2025-12-24": 4,
          "2025-12-26": 14,
          "2025-12-29": 5,
          "2026-01-02": 1,
          "2026-01-05": 14,
          "2026-01-06": 19,
          "2026-01-07": 13,
          "2026-01-08": 11,
          "2026-01-09": 11,
          "2026-01-12": 22,
          "2026-01-13": 20,
          "2026-01-14": 15,
          "2026-01-15": 7,
          "2026-01-16": 7,
          "2026-01-17": 4,
          "2026-01-19": 6,
          "2026-01-20": 5,
          "2026-01-21": 8,
          "2026-01-22": 4,
          "2026-01-23": 43,
          "2026-01-26": 20,
          "2026-01-27": 7,
          "2026-01-28": 4,
          "2026-01-29": 4,
          "2026-01-30": 2,
          "2026-02-02": 19,
          "2026-02-03": 59,
          "2026-02-04": 3,
          "2026-02-05": 9,
          "2026-02-06": 13,
          "2026-02-09": 9,
          "2026-02-10": 4,
          "2026-02-11": 7,
          "2026-02-12": 71,
          "2026-02-13": 39,
          "2026-02-16": 2
        },
        "time_per_day": {
          "2025-09-30": 17.67045222222222,
          "2025-10-01": 107.48918194444444,
          "2025-10-02": 46.32257861111111,
          "2025-10-03": 44.79330277777778,
          "2025-10-06": 710.2722913888889,
          "2025-10-07": 844.5038580555556,
          "2025-10-08": 386.9930425,
          "2025-10-09": 653.8329388888889,
          "2025-10-10": 1331.2771616666666,
          "2025-10-13": 1705.6818377777774,
          "2025-10-14": 660.8630849999998,
          "2025-10-15": 1224.0691111111112,
          "2025-10-16": 210.54633361111112,
          "2025-10-20": 461.47079333333335,
          "2025-10-21": 341.69153444444447,
          "2025-10-22": 86.83271305555556,
          "2025-10-23": 1771.8775205555557,
          "2025-10-24": 87.89853388888889,
          "2025-10-27": 520.6547202777776,
          "2025-10-28": 472.31891138888886,
          "2025-10-29": 1462.3758508333335,
          "2025-10-30": 294.2623075,
          "2025-10-31": 21.79866416666667,
          "2025-11-03": 795.4213952777775,
          "2025-11-04": 374.49555888888887,
          "2025-11-05": 417.5820247222222,
          "2025-11-06": 1769.8056397222222,
          "2025-11-07": 1278.1110638888888,
          "2025-11-10": 1086.3901805555558,
          "2025-11-11": 791.9551111111109,
          "2025-11-12": 225.2633555555556,
          "2025-11-13": 2430.019484166666,
          "2025-11-14": 3211.555087777778,
          "2025-11-17": 1187.922075833333,
          "2025-11-18": 204.16933111111112,
          "2025-11-19": 1966.3983391666666,
          "2025-11-20": 1615.0056269444444,
          "2025-11-21": 2344.499597777778,
          "2025-11-22": 52.83769583333333,
          "2025-11-24": 938.3912341666668,
          "2025-11-26": 466.66101611111105,
          "2025-11-27": 2938.4733680555555,
          "2025-11-28": 450.5068538888889,
          "2025-12-02": 4701.675381666668,
          "2025-12-03": 389.2933672222223,
          "2025-12-04": 1761.2988497222223,
          "2025-12-05": 753.9673108333333,
          "2025-12-09": 240.53105166666666,
          "2025-12-10": 323.80422916666674,
          "2025-12-11": 5007.294794166666,
          "2025-12-12": 686.3385558333333,
          "2025-12-15": 23154.692302222218,
          "2025-12-16": 7.9867197222222215,
          "2025-12-17": 71.41249194444443,
          "2025-12-18": 1238.5581591666669,
          "2025-12-19": 483.61316861111106,
          "2025-12-22": 918.8891386111111,
          "2025-12-23": 311.7282780555557,
          "2025-12-24": 170.9100358333333,
          "2025-12-26": 752.9101158333332,
          "2025-12-29": 151.0070769444445,
          "2026-01-02": 991.5368063888889,
          "2026-01-05": 3690.247452222221,
          "2026-01-06": 321.57498583333324,
          "2026-01-07": 1091.9909158333332,
          "2026-01-08": 803.9335730555555,
          "2026-01-09": 5054.462352500001,
          "2026-01-12": 73.99067777777778,
          "2026-01-13": 440.2180436111112,
          "2026-01-14": 189.82459527777783,
          "2026-01-15": 88.1514452777778,
          "2026-01-16": 780.7538058333334,
          "2026-01-17": 574.4905219444445,
          "2026-01-19": 334.38799527777775,
          "2026-01-20": 2914.2521613888894,
          "2026-01-21": 4113.233374166666,
          "2026-01-22": 738.2875072222222,
          "2026-01-23": 12891.270596666669,
          "2026-01-26": 69.94495722222221,
          "2026-01-27": 202.065405,
          "2026-01-28": 57.52680055555556,
          "2026-01-29": 240.72743388888892,
          "2026-01-30": 34.120216944444444,
          "2026-02-02": 400.5112019444444,
          "2026-02-03": 29743.128748055566,
          "2026-02-04": 1171.4400397222223,
          "2026-02-05": 86.13382444444443,
          "2026-02-06": 2393.940073055556,
          "2026-02-09": 318.3924316666667,
          "2026-02-10": 170.31826527777775,
          "2026-02-11": 406.9591447222223,
          "2026-02-12": 57877.1744108333,
          "2026-02-13": 10565.272643333337,
          "2026-02-16": 169.3617602777778
        },
        "time_count_per_day": {
          "2025-09-30": 7,
          "2025-10-01": 8,
          "2025-10-02": 2,
          "2025-10-03": 2,
          "2025-10-06": 8,
          "2025-10-07": 13,
          "2025-10-08": 7,
          "2025-10-09": 6,
          "2025-10-10": 14,
          "2025-10-13": 15,
          "2025-10-14": 13,
          "2025-10-15": 16,
          "2025-10-16": 4,
          "2025-10-20": 6,
          "2025-10-21": 14,
          "2025-10-22": 3,
          "2025-10-23": 27,
          "2025-10-24": 6,
          "2025-10-27": 7,
          "2025-10-28": 6,
          "2025-10-29": 15,
          "2025-10-30": 13,
          "2025-10-31": 6,
          "2025-11-03": 9,
          "2025-11-04": 5,
          "2025-11-05": 8,
          "2025-11-06": 10,
          "2025-11-07": 12,
          "2025-11-10": 11,
          "2025-11-11": 13,
          "2025-11-12": 12,
          "2025-11-13": 13,
          "2025-11-14": 13,
          "2025-11-17": 10,
          "2025-11-18": 6,
          "2025-11-19": 18,
          "2025-11-20": 11,
          "2025-11-21": 9,
          "2025-11-22": 1,
          "2025-11-24": 7,
          "2025-11-26": 11,
          "2025-11-27": 12,
          "2025-11-28": 7,
          "2025-12-02": 24,
          "2025-12-03": 3,
          "2025-12-04": 14,
          "2025-12-05": 12,
          "2025-12-09": 1,
          "2025-12-10": 7,
          "2025-12-11": 11,
          "2025-12-12": 8,
          "2025-12-15": 64,
          "2025-12-16": 3,
          "2025-12-17": 10,
          "2025-12-18": 8,
          "2025-12-19": 8,
          "2025-12-22": 5,
          "2025-12-23": 13,
          "2025-12-24": 4,
          "2025-12-26": 14,
          "2025-12-29": 5,
          "2026-01-02": 1,
          "2026-01-05": 14,
          "2026-01-06": 19,
          "2026-01-07": 13,
          "2026-01-08": 11,
          "2026-01-09": 11,
          "2026-01-12": 22,
          "2026-01-13": 20,
          "2026-01-14": 15,
          "2026-01-15": 7,
          "2026-01-16": 7,
          "2026-01-17": 4,
          "2026-01-19": 6,
          "2026-01-20": 5,
          "2026-01-21": 8,
          "2026-01-22": 4,
          "2026-01-23": 43,
          "2026-01-26": 20,
          "2026-01-27": 7,
          "2026-01-28": 4,
          "2026-01-29": 4,
          "2026-01-30": 2,
          "2026-02-02": 19,
          "2026-02-03": 59,
          "2026-02-04": 3,
          "2026-02-05": 9,
          "2026-02-06": 13,
          "2026-02-09": 9,
          "2026-02-10": 4,
          "2026-02-11": 7,
          "2026-02-12": 71,
          "2026-02-13": 39,
          "2026-02-16": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 99.92,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 2,
            "8-10h": 3,
            "22-24h": 1,
            "24-26h": 1,
            "30-32h": 1,
            "36-38h": 1,
            "44-46h": 1,
            "50-52h": 2,
            "52-54h": 1,
            "54-56h": 2,
            "56-58h": 1,
            "100-102h": 1,
            "122-124h": 1,
            "166-168h": 1,
            "192-194h": 1,
            "212-214h": 1,
            "330-332h": 1,
            "342-344h": 1,
            "350-352h": 2,
            "410-412h": 1
          },
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-15": 1,
            "2025-10-23": 2,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-24": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-23": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-14": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 1,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-10-06": 122.02680027777778,
            "2025-10-15": 54.32751694444444,
            "2025-10-23": 102.91623472222221,
            "2025-11-03": 0.10010416666666666,
            "2025-11-04": 54.64275361111111,
            "2025-11-24": 3.18576,
            "2025-11-28": 0.4007811111111111,
            "2025-12-04": 331.799555,
            "2025-12-23": 0.6058288888888889,
            "2026-01-06": 8.139582222222222,
            "2026-01-08": 51.827086111111115,
            "2026-01-14": 45.73746416666667,
            "2026-01-21": 56.02625,
            "2026-01-22": 30.24807,
            "2026-01-23": 790.0958941666667,
            "2026-01-26": 0.6639122222222221,
            "2026-01-29": 193.68715500000002,
            "2026-01-30": 24.44329611111111,
            "2026-02-03": 351.55231694444444,
            "2026-02-09": 2.292703888888889,
            "2026-02-10": 23.79750027777778,
            "2026-02-11": 8.16352111111111,
            "2026-02-12": 389.42757416666666,
            "2026-02-13": 350.6950444444444,
            "2026-02-16": 100.73119527777779
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-15": 1,
            "2025-10-23": 2,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-24": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-23": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-14": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 1,
            "2026-02-16": 1
          }
        },
        "P2": {
          "avg_time_hours": 164.16,
          "mode_time_hours": 1.0,
          "mode_frequency": 169,
          "time_distribution": {
            "0-2h": 169,
            "2-4h": 61,
            "4-6h": 37,
            "6-8h": 10,
            "8-10h": 16,
            "10-12h": 2,
            "12-14h": 5,
            "14-16h": 3,
            "16-18h": 6,
            "18-20h": 5,
            "20-22h": 2,
            "22-24h": 6,
            "24-26h": 12,
            "26-28h": 2,
            "28-30h": 3,
            "30-32h": 4,
            "32-34h": 2,
            "46-48h": 1,
            "48-50h": 5,
            "50-52h": 3,
            "52-54h": 3,
            "54-56h": 9,
            "56-58h": 3,
            "68-70h": 1,
            "70-72h": 3,
            "72-74h": 4,
            "74-76h": 1,
            "76-78h": 2,
            "80-82h": 1,
            "86-88h": 2,
            "88-90h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "96-98h": 1,
            "98-100h": 1,
            "100-102h": 3,
            "114-116h": 3,
            "116-118h": 1,
            "118-120h": 4,
            "120-122h": 1,
            "122-124h": 1,
            "126-128h": 3,
            "128-130h": 2,
            "144-146h": 1,
            "146-148h": 2,
            "150-152h": 2,
            "152-154h": 1,
            "154-156h": 1,
            "156-158h": 1,
            "158-160h": 1,
            "162-164h": 2,
            "164-166h": 2,
            "166-168h": 2,
            "168-170h": 1,
            "170-172h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "176-178h": 1,
            "178-180h": 2,
            "180-182h": 1,
            "184-186h": 1,
            "196-198h": 1,
            "198-200h": 1,
            "200-202h": 1,
            "204-206h": 3,
            "212-214h": 2,
            "216-218h": 1,
            "218-220h": 1,
            "226-228h": 1,
            "228-230h": 1,
            "238-240h": 1,
            "240-242h": 1,
            "242-244h": 1,
            "252-254h": 1,
            "254-256h": 1,
            "262-264h": 1,
            "264-266h": 1,
            "266-268h": 1,
            "268-270h": 2,
            "276-278h": 1,
            "282-284h": 1,
            "292-294h": 1,
            "294-296h": 1,
            "298-300h": 1,
            "300-302h": 2,
            "306-308h": 2,
            "314-316h": 1,
            "316-318h": 2,
            "318-320h": 2,
            "320-322h": 2,
            "326-328h": 1,
            "336-338h": 1,
            "340-342h": 2,
            "344-346h": 1,
            "350-352h": 2,
            "364-366h": 1,
            "366-368h": 1,
            "368-370h": 3,
            "370-372h": 1,
            "372-374h": 2,
            "386-388h": 2,
            "388-390h": 2,
            "390-392h": 3,
            "392-394h": 1,
            "400-402h": 1,
            "408-410h": 2,
            "410-412h": 1,
            "414-416h": 3,
            "416-418h": 1,
            "428-430h": 1,
            "432-434h": 1,
            "434-436h": 1,
            "436-438h": 1,
            "456-458h": 2,
            "460-462h": 1,
            "464-466h": 1,
            "478-480h": 1,
            "488-490h": 3,
            "492-494h": 2,
            "508-510h": 2,
            "512-514h": 2,
            "518-520h": 1,
            "528-530h": 1,
            "530-532h": 2,
            "532-534h": 2,
            "540-542h": 1,
            "548-550h": 1,
            "550-552h": 1,
            "558-560h": 1,
            "562-564h": 1,
            "566-568h": 1,
            "582-584h": 1,
            "602-604h": 1,
            "614-616h": 1,
            "628-630h": 1,
            "654-656h": 1,
            "662-664h": 1,
            "664-666h": 1,
            "672-674h": 1,
            "676-678h": 2,
            "678-680h": 2,
            "684-686h": 1,
            "706-708h": 1,
            "724-726h": 1,
            "744-746h": 1,
            "748-750h": 1,
            "750-752h": 2,
            "754-756h": 1,
            "796-798h": 1,
            "800-802h": 1,
            "812-814h": 1,
            "816-818h": 1,
            "822-824h": 1,
            "844-846h": 2,
            "866-868h": 1,
            "872-874h": 2,
            "876-878h": 1,
            "892-894h": 3,
            "894-896h": 1,
            "898-900h": 1,
            "914-916h": 1,
            "916-918h": 1,
            "984-986h": 1,
            "990-992h": 1,
            "1008-1010h": 1,
            "1068-1070h": 1,
            "1092-1094h": 1,
            "1114-1116h": 1,
            "1162-1164h": 1,
            "1180-1182h": 1,
            "1228-1230h": 1,
            "1234-1236h": 1,
            "1284-1286h": 1,
            "1300-1302h": 1,
            "1424-1426h": 1,
            "1842-1844h": 1,
            "1896-1898h": 1
          },
          "tickets_count": 582,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-01": 1,
            "2025-10-02": 1,
            "2025-10-03": 2,
            "2025-10-06": 3,
            "2025-10-07": 6,
            "2025-10-08": 4,
            "2025-10-09": 1,
            "2025-10-10": 6,
            "2025-10-13": 6,
            "2025-10-14": 11,
            "2025-10-15": 8,
            "2025-10-16": 3,
            "2025-10-20": 6,
            "2025-10-21": 11,
            "2025-10-22": 2,
            "2025-10-23": 18,
            "2025-10-24": 4,
            "2025-10-27": 5,
            "2025-10-28": 3,
            "2025-10-29": 14,
            "2025-10-30": 9,
            "2025-10-31": 6,
            "2025-11-03": 6,
            "2025-11-04": 3,
            "2025-11-05": 1,
            "2025-11-06": 4,
            "2025-11-07": 9,
            "2025-11-10": 6,
            "2025-11-11": 13,
            "2025-11-12": 3,
            "2025-11-13": 7,
            "2025-11-14": 4,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-19": 6,
            "2025-11-20": 1,
            "2025-11-21": 6,
            "2025-11-24": 1,
            "2025-11-26": 8,
            "2025-11-27": 6,
            "2025-11-28": 4,
            "2025-12-02": 3,
            "2025-12-04": 3,
            "2025-12-05": 7,
            "2025-12-10": 6,
            "2025-12-11": 9,
            "2025-12-12": 4,
            "2025-12-15": 26,
            "2025-12-17": 4,
            "2025-12-18": 3,
            "2025-12-19": 6,
            "2025-12-22": 2,
            "2025-12-23": 4,
            "2025-12-24": 3,
            "2025-12-26": 10,
            "2025-12-29": 3,
            "2026-01-02": 1,
            "2026-01-05": 3,
            "2026-01-06": 14,
            "2026-01-07": 9,
            "2026-01-08": 8,
            "2026-01-09": 6,
            "2026-01-12": 14,
            "2026-01-13": 16,
            "2026-01-14": 10,
            "2026-01-15": 4,
            "2026-01-16": 3,
            "2026-01-19": 3,
            "2026-01-20": 3,
            "2026-01-21": 4,
            "2026-01-22": 2,
            "2026-01-23": 23,
            "2026-01-26": 17,
            "2026-01-27": 5,
            "2026-01-28": 4,
            "2026-01-29": 2,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-03": 27,
            "2026-02-04": 1,
            "2026-02-05": 6,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-11": 3,
            "2026-02-12": 42,
            "2026-02-13": 25,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-09-30": 0.43303416666666666,
            "2025-10-01": 1.2259255555555557,
            "2025-10-02": 1.777478611111111,
            "2025-10-03": 44.79330277777778,
            "2025-10-06": 215.98573888888887,
            "2025-10-07": 442.9095361111111,
            "2025-10-08": 38.290801111111115,
            "2025-10-09": 25.853180555555554,
            "2025-10-10": 105.27102222222223,
            "2025-10-13": 577.4642477777778,
            "2025-10-14": 291.3477216666666,
            "2025-10-15": 220.1438975,
            "2025-10-16": 130.71368444444445,
            "2025-10-20": 461.47079333333335,
            "2025-10-21": 19.955766666666666,
            "2025-10-22": 36.905006388888886,
            "2025-10-23": 1229.133745,
            "2025-10-24": 83.6556,
            "2025-10-27": 284.36690833333336,
            "2025-10-28": 219.68845555555558,
            "2025-10-29": 1293.3646447222225,
            "2025-10-30": 239.48619499999995,
            "2025-10-31": 21.79866416666667,
            "2025-11-03": 3.6828938888888887,
            "2025-11-04": 311.2160947222222,
            "2025-11-05": 3.342628055555555,
            "2025-11-06": 84.09284472222221,
            "2025-11-07": 881.2284702777779,
            "2025-11-10": 5.549409166666666,
            "2025-11-11": 791.9551111111109,
            "2025-11-12": 1.6641930555555557,
            "2025-11-13": 1448.3387608333333,
            "2025-11-14": 830.2657355555556,
            "2025-11-17": 555.9628458333333,
            "2025-11-18": 0.5358844444444444,
            "2025-11-19": 563.0783711111111,
            "2025-11-20": 2.356298611111111,
            "2025-11-21": 2198.036521388889,
            "2025-11-24": 3.2222333333333335,
            "2025-11-26": 232.01889444444444,
            "2025-11-27": 1090.2011202777776,
            "2025-11-28": 418.7224522222223,
            "2025-12-02": 304.0986688888889,
            "2025-12-04": 332.71256166666666,
            "2025-12-05": 2.4941036111111115,
            "2025-12-10": 321.72088500000007,
            "2025-12-11": 4467.096739166666,
            "2025-12-12": 6.612499722222223,
            "2025-12-15": 9500.457635555555,
            "2025-12-17": 40.50358416666667,
            "2025-12-18": 1237.053218611111,
            "2025-12-19": 16.273385277777777,
            "2025-12-22": 219.39184555555556,
            "2025-12-23": 4.37403,
            "2025-12-24": 2.053116111111111,
            "2025-12-26": 11.285001944444447,
            "2025-12-29": 148.92714250000003,
            "2026-01-02": 991.5368063888889,
            "2026-01-05": 169.5097452777778,
            "2026-01-06": 101.04070416666667,
            "2026-01-07": 66.53821527777777,
            "2026-01-08": 631.6356669444444,
            "2026-01-09": 2717.5274375,
            "2026-01-12": 39.345231111111104,
            "2026-01-13": 62.477240555555554,
            "2026-01-14": 109.08312027777777,
            "2026-01-15": 35.255894166666664,
            "2026-01-16": 768.5521258333333,
            "2026-01-19": 304.1720630555555,
            "2026-01-20": 214.15606888888888,
            "2026-01-21": 1633.5123133333334,
            "2026-01-22": 2.8526483333333332,
            "2026-01-23": 6535.353262500001,
            "2026-01-26": 57.272137222222234,
            "2026-01-27": 43.05988972222222,
            "2026-01-28": 57.52680055555556,
            "2026-01-29": 16.793032222222223,
            "2026-01-30": 9.676920833333334,
            "2026-02-02": 3.9351541666666665,
            "2026-02-03": 11038.609178333334,
            "2026-02-04": 533.1324597222222,
            "2026-02-05": 82.91045888888888,
            "2026-02-06": 2084.34716,
            "2026-02-09": 0.3334608333333334,
            "2026-02-10": 122.48674083333333,
            "2026-02-11": 396.9694702777778,
            "2026-02-12": 28618.0943025,
            "2026-02-13": 5996.1037700000015,
            "2026-02-16": 68.630565
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-01": 1,
            "2025-10-02": 1,
            "2025-10-03": 2,
            "2025-10-06": 3,
            "2025-10-07": 6,
            "2025-10-08": 4,
            "2025-10-09": 1,
            "2025-10-10": 6,
            "2025-10-13": 6,
            "2025-10-14": 11,
            "2025-10-15": 8,
            "2025-10-16": 3,
            "2025-10-20": 6,
            "2025-10-21": 11,
            "2025-10-22": 2,
            "2025-10-23": 18,
            "2025-10-24": 4,
            "2025-10-27": 5,
            "2025-10-28": 3,
            "2025-10-29": 14,
            "2025-10-30": 9,
            "2025-10-31": 6,
            "2025-11-03": 6,
            "2025-11-04": 3,
            "2025-11-05": 1,
            "2025-11-06": 4,
            "2025-11-07": 9,
            "2025-11-10": 6,
            "2025-11-11": 13,
            "2025-11-12": 3,
            "2025-11-13": 7,
            "2025-11-14": 4,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-19": 6,
            "2025-11-20": 1,
            "2025-11-21": 6,
            "2025-11-24": 1,
            "2025-11-26": 8,
            "2025-11-27": 6,
            "2025-11-28": 4,
            "2025-12-02": 3,
            "2025-12-04": 3,
            "2025-12-05": 7,
            "2025-12-10": 6,
            "2025-12-11": 9,
            "2025-12-12": 4,
            "2025-12-15": 26,
            "2025-12-17": 4,
            "2025-12-18": 3,
            "2025-12-19": 6,
            "2025-12-22": 2,
            "2025-12-23": 4,
            "2025-12-24": 3,
            "2025-12-26": 10,
            "2025-12-29": 3,
            "2026-01-02": 1,
            "2026-01-05": 3,
            "2026-01-06": 14,
            "2026-01-07": 9,
            "2026-01-08": 8,
            "2026-01-09": 6,
            "2026-01-12": 14,
            "2026-01-13": 16,
            "2026-01-14": 10,
            "2026-01-15": 4,
            "2026-01-16": 3,
            "2026-01-19": 3,
            "2026-01-20": 3,
            "2026-01-21": 4,
            "2026-01-22": 2,
            "2026-01-23": 23,
            "2026-01-26": 17,
            "2026-01-27": 5,
            "2026-01-28": 4,
            "2026-01-29": 2,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-03": 27,
            "2026-02-04": 1,
            "2026-02-05": 6,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-11": 3,
            "2026-02-12": 42,
            "2026-02-13": 25,
            "2026-02-16": 1
          }
        },
        "P3": {
          "avg_time_hours": 249.74,
          "mode_time_hours": 1.0,
          "mode_frequency": 63,
          "time_distribution": {
            "0-2h": 63,
            "2-4h": 43,
            "4-6h": 24,
            "6-8h": 11,
            "8-10h": 8,
            "14-16h": 3,
            "16-18h": 1,
            "18-20h": 3,
            "20-22h": 2,
            "22-24h": 3,
            "24-26h": 7,
            "26-28h": 6,
            "28-30h": 5,
            "30-32h": 5,
            "32-34h": 2,
            "36-38h": 1,
            "38-40h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "50-52h": 3,
            "52-54h": 1,
            "56-58h": 1,
            "66-68h": 1,
            "68-70h": 1,
            "70-72h": 1,
            "72-74h": 2,
            "74-76h": 2,
            "78-80h": 6,
            "92-94h": 2,
            "98-100h": 1,
            "100-102h": 3,
            "102-104h": 1,
            "114-116h": 6,
            "116-118h": 2,
            "118-120h": 2,
            "120-122h": 1,
            "122-124h": 1,
            "124-126h": 2,
            "126-128h": 2,
            "136-138h": 1,
            "138-140h": 1,
            "140-142h": 1,
            "142-144h": 2,
            "146-148h": 1,
            "148-150h": 2,
            "150-152h": 1,
            "158-160h": 1,
            "164-166h": 1,
            "166-168h": 1,
            "168-170h": 2,
            "170-172h": 1,
            "174-176h": 5,
            "182-184h": 2,
            "184-186h": 1,
            "190-192h": 1,
            "198-200h": 1,
            "204-206h": 1,
            "208-210h": 1,
            "216-218h": 1,
            "218-220h": 2,
            "222-224h": 1,
            "226-228h": 2,
            "240-242h": 3,
            "242-244h": 7,
            "244-246h": 1,
            "268-270h": 3,
            "272-274h": 1,
            "276-278h": 1,
            "284-286h": 1,
            "288-290h": 1,
            "294-296h": 1,
            "298-300h": 1,
            "306-308h": 1,
            "312-314h": 1,
            "316-318h": 3,
            "318-320h": 1,
            "320-322h": 1,
            "322-324h": 1,
            "326-328h": 1,
            "338-340h": 1,
            "340-342h": 1,
            "342-344h": 1,
            "344-346h": 1,
            "348-350h": 2,
            "350-352h": 2,
            "358-360h": 1,
            "368-370h": 1,
            "370-372h": 1,
            "372-374h": 2,
            "376-378h": 1,
            "378-380h": 1,
            "386-388h": 1,
            "390-392h": 1,
            "406-408h": 2,
            "414-416h": 1,
            "418-420h": 1,
            "422-424h": 2,
            "424-426h": 1,
            "430-432h": 1,
            "432-434h": 3,
            "434-436h": 1,
            "448-450h": 1,
            "462-464h": 1,
            "470-472h": 1,
            "478-480h": 4,
            "482-484h": 1,
            "490-492h": 1,
            "502-504h": 1,
            "506-508h": 1,
            "516-518h": 5,
            "522-524h": 1,
            "526-528h": 1,
            "534-536h": 1,
            "538-540h": 4,
            "560-562h": 1,
            "570-572h": 1,
            "574-576h": 2,
            "586-588h": 1,
            "588-590h": 1,
            "590-592h": 1,
            "606-608h": 1,
            "626-628h": 2,
            "670-672h": 1,
            "690-692h": 1,
            "696-698h": 1,
            "704-706h": 1,
            "724-726h": 1,
            "788-790h": 1,
            "790-792h": 1,
            "794-796h": 1,
            "814-816h": 1,
            "838-840h": 1,
            "844-846h": 1,
            "866-868h": 1,
            "870-872h": 1,
            "882-884h": 1,
            "886-888h": 2,
            "890-892h": 1,
            "894-896h": 1,
            "898-900h": 3,
            "910-912h": 1,
            "924-926h": 1,
            "1140-1142h": 1,
            "1162-1164h": 2,
            "1188-1190h": 1,
            "1212-1214h": 1,
            "1278-1280h": 1,
            "1284-1286h": 1,
            "1376-1378h": 1,
            "1404-1406h": 1,
            "1422-1424h": 1,
            "1426-1428h": 1,
            "1476-1478h": 1,
            "1498-1500h": 1,
            "1500-1502h": 1,
            "1518-1520h": 1,
            "1684-1686h": 2,
            "1732-1734h": 1,
            "2044-2046h": 1,
            "2696-2698h": 1,
            "3246-3248h": 1
          },
          "tickets_count": 402,
          "tickets_per_day": {
            "2025-09-30": 6,
            "2025-10-01": 7,
            "2025-10-02": 1,
            "2025-10-06": 4,
            "2025-10-07": 4,
            "2025-10-08": 2,
            "2025-10-10": 3,
            "2025-10-13": 4,
            "2025-10-15": 4,
            "2025-10-16": 1,
            "2025-10-21": 1,
            "2025-10-23": 4,
            "2025-10-24": 2,
            "2025-10-27": 2,
            "2025-10-28": 2,
            "2025-10-30": 4,
            "2025-11-03": 2,
            "2025-11-04": 1,
            "2025-11-05": 6,
            "2025-11-06": 6,
            "2025-11-07": 3,
            "2025-11-10": 1,
            "2025-11-12": 8,
            "2025-11-13": 6,
            "2025-11-14": 6,
            "2025-11-17": 4,
            "2025-11-18": 5,
            "2025-11-19": 11,
            "2025-11-20": 9,
            "2025-11-21": 3,
            "2025-11-22": 1,
            "2025-11-24": 2,
            "2025-11-26": 3,
            "2025-11-27": 4,
            "2025-11-28": 2,
            "2025-12-02": 17,
            "2025-12-03": 2,
            "2025-12-04": 8,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-12": 2,
            "2025-12-15": 35,
            "2025-12-16": 3,
            "2025-12-17": 6,
            "2025-12-18": 5,
            "2025-12-19": 1,
            "2025-12-22": 3,
            "2025-12-23": 7,
            "2025-12-24": 1,
            "2025-12-26": 2,
            "2025-12-29": 1,
            "2026-01-05": 6,
            "2026-01-06": 4,
            "2026-01-07": 4,
            "2026-01-08": 2,
            "2026-01-09": 4,
            "2026-01-12": 7,
            "2026-01-13": 3,
            "2026-01-14": 2,
            "2026-01-15": 3,
            "2026-01-16": 4,
            "2026-01-19": 3,
            "2026-01-20": 2,
            "2026-01-21": 3,
            "2026-01-22": 1,
            "2026-01-23": 15,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-02": 16,
            "2026-02-03": 26,
            "2026-02-04": 2,
            "2026-02-05": 3,
            "2026-02-06": 9,
            "2026-02-09": 7,
            "2026-02-10": 1,
            "2026-02-11": 3,
            "2026-02-12": 26,
            "2026-02-13": 12
          },
          "time_per_day": {
            "2025-09-30": 17.23741805555555,
            "2025-10-01": 106.26325638888888,
            "2025-10-02": 44.5451,
            "2025-10-06": 372.25975222222223,
            "2025-10-07": 180.34373916666664,
            "2025-10-08": 186.23269722222224,
            "2025-10-10": 623.5979808333334,
            "2025-10-13": 566.2878283333333,
            "2025-10-15": 334.7119838888889,
            "2025-10-16": 79.83264916666667,
            "2025-10-21": 0.6583905555555556,
            "2025-10-23": 208.2698372222222,
            "2025-10-24": 4.242933888888889,
            "2025-10-27": 236.28781194444446,
            "2025-10-28": 155.65499666666668,
            "2025-10-30": 54.7761125,
            "2025-11-03": 791.6383972222221,
            "2025-11-04": 8.636710555555556,
            "2025-11-05": 240.4710638888889,
            "2025-11-06": 1685.7127950000001,
            "2025-11-07": 396.88259361111113,
            "2025-11-10": 0.8231030555555555,
            "2025-11-12": 93.79767305555553,
            "2025-11-13": 981.6807233333333,
            "2025-11-14": 1556.4082819444445,
            "2025-11-17": 580.3659719444445,
            "2025-11-18": 203.63344666666669,
            "2025-11-19": 1179.8035383333333,
            "2025-11-20": 1363.7242877777778,
            "2025-11-21": 146.46307638888888,
            "2025-11-22": 52.83769583333333,
            "2025-11-24": 1.8497394444444444,
            "2025-11-26": 234.6421216666667,
            "2025-11-27": 1181.8287383333334,
            "2025-11-28": 31.383620555555556,
            "2025-12-02": 3821.7620400000005,
            "2025-12-03": 374.0655672222223,
            "2025-12-04": 711.6800277777777,
            "2025-12-05": 447.1114430555555,
            "2025-12-09": 240.53105166666666,
            "2025-12-10": 2.0833441666666666,
            "2025-12-12": 12.06962,
            "2025-12-15": 12752.097025000003,
            "2025-12-16": 7.9867197222222215,
            "2025-12-17": 30.908907777777777,
            "2025-12-18": 1.5049405555555555,
            "2025-12-19": 1.0141541666666667,
            "2025-12-22": 699.4972930555556,
            "2025-12-23": 305.88669027777786,
            "2025-12-24": 168.85691972222222,
            "2025-12-26": 1.0026969444444445,
            "2025-12-29": 1.3257575,
            "2026-01-05": 1783.3270286111112,
            "2026-01-06": 212.39469944444443,
            "2026-01-07": 1025.4527005555556,
            "2026-01-08": 120.47082,
            "2026-01-09": 2254.9808063888886,
            "2026-01-12": 24.970901944444446,
            "2026-01-13": 351.09196222222226,
            "2026-01-14": 27.166048333333332,
            "2026-01-15": 52.895551111111104,
            "2026-01-16": 12.20168,
            "2026-01-19": 30.21593222222222,
            "2026-01-20": 2700.0960925,
            "2026-01-21": 2423.6948108333336,
            "2026-01-22": 705.1867888888888,
            "2026-01-23": 5017.090031666667,
            "2026-01-26": 3.8116808333333334,
            "2026-01-27": 36.109495,
            "2026-01-29": 30.24724666666667,
            "2026-02-02": 332.4812388888888,
            "2026-02-03": 15703.917646666665,
            "2026-02-04": 638.3075799999999,
            "2026-02-05": 3.2233655555555556,
            "2026-02-06": 40.117358333333335,
            "2026-02-09": 315.7662669444445,
            "2026-02-10": 24.034024166666665,
            "2026-02-11": 1.8261533333333335,
            "2026-02-12": 28869.652534166667,
            "2026-02-13": 4172.297464444446
          },
          "time_count_per_day": {
            "2025-09-30": 6,
            "2025-10-01": 7,
            "2025-10-02": 1,
            "2025-10-06": 4,
            "2025-10-07": 4,
            "2025-10-08": 2,
            "2025-10-10": 3,
            "2025-10-13": 4,
            "2025-10-15": 4,
            "2025-10-16": 1,
            "2025-10-21": 1,
            "2025-10-23": 4,
            "2025-10-24": 2,
            "2025-10-27": 2,
            "2025-10-28": 2,
            "2025-10-30": 4,
            "2025-11-03": 2,
            "2025-11-04": 1,
            "2025-11-05": 6,
            "2025-11-06": 6,
            "2025-11-07": 3,
            "2025-11-10": 1,
            "2025-11-12": 8,
            "2025-11-13": 6,
            "2025-11-14": 6,
            "2025-11-17": 4,
            "2025-11-18": 5,
            "2025-11-19": 11,
            "2025-11-20": 9,
            "2025-11-21": 3,
            "2025-11-22": 1,
            "2025-11-24": 2,
            "2025-11-26": 3,
            "2025-11-27": 4,
            "2025-11-28": 2,
            "2025-12-02": 17,
            "2025-12-03": 2,
            "2025-12-04": 8,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-12": 2,
            "2025-12-15": 35,
            "2025-12-16": 3,
            "2025-12-17": 6,
            "2025-12-18": 5,
            "2025-12-19": 1,
            "2025-12-22": 3,
            "2025-12-23": 7,
            "2025-12-24": 1,
            "2025-12-26": 2,
            "2025-12-29": 1,
            "2026-01-05": 6,
            "2026-01-06": 4,
            "2026-01-07": 4,
            "2026-01-08": 2,
            "2026-01-09": 4,
            "2026-01-12": 7,
            "2026-01-13": 3,
            "2026-01-14": 2,
            "2026-01-15": 3,
            "2026-01-16": 4,
            "2026-01-19": 3,
            "2026-01-20": 2,
            "2026-01-21": 3,
            "2026-01-22": 1,
            "2026-01-23": 15,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-02": 16,
            "2026-02-03": 26,
            "2026-02-04": 2,
            "2026-02-05": 3,
            "2026-02-06": 9,
            "2026-02-09": 7,
            "2026-02-10": 1,
            "2026-02-11": 3,
            "2026-02-12": 26,
            "2026-02-13": 12
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 160.35,
          "mode_time_hours": 169.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "20-22h": 1,
            "22-24h": 2,
            "30-32h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "64-66h": 1,
            "66-68h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "76-78h": 2,
            "78-80h": 2,
            "80-82h": 1,
            "92-94h": 1,
            "96-98h": 1,
            "98-100h": 1,
            "120-122h": 1,
            "122-124h": 1,
            "128-130h": 1,
            "140-142h": 1,
            "146-148h": 3,
            "150-152h": 2,
            "162-164h": 2,
            "166-168h": 3,
            "168-170h": 3,
            "172-174h": 2,
            "174-176h": 1,
            "184-186h": 1,
            "186-188h": 1,
            "194-196h": 1,
            "208-210h": 1,
            "216-218h": 1,
            "220-222h": 1,
            "222-224h": 1,
            "232-234h": 1,
            "248-250h": 1,
            "268-270h": 1,
            "270-272h": 1,
            "290-292h": 2,
            "292-294h": 1,
            "294-296h": 1,
            "300-302h": 1,
            "320-322h": 1,
            "348-350h": 1,
            "352-354h": 1,
            "432-434h": 1,
            "468-470h": 1,
            "536-538h": 1
          },
          "tickets_count": 67,
          "tickets_per_day": {
            "2025-10-07": 3,
            "2025-10-08": 1,
            "2025-10-09": 5,
            "2025-10-10": 5,
            "2025-10-13": 5,
            "2025-10-14": 2,
            "2025-10-15": 3,
            "2025-10-21": 2,
            "2025-10-22": 1,
            "2025-10-23": 3,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-05": 1,
            "2025-11-10": 4,
            "2025-11-12": 1,
            "2025-11-14": 3,
            "2025-11-17": 2,
            "2025-11-19": 1,
            "2025-11-20": 1,
            "2025-11-24": 3,
            "2025-11-27": 2,
            "2025-12-02": 2,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-11": 1,
            "2025-12-26": 1,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-09": 1,
            "2026-01-12": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-13": 1
          },
          "time_per_day": {
            "2025-10-07": 221.25058277777777,
            "2025-10-08": 162.46954416666668,
            "2025-10-09": 627.9797583333333,
            "2025-10-10": 602.4081586111112,
            "2025-10-13": 561.9297616666668,
            "2025-10-14": 369.51536333333337,
            "2025-10-15": 614.8857127777778,
            "2025-10-21": 321.0773772222222,
            "2025-10-22": 49.927706666666666,
            "2025-10-23": 231.55770361111112,
            "2025-10-28": 96.97545916666667,
            "2025-10-29": 169.0112061111111,
            "2025-11-05": 173.76833277777777,
            "2025-11-10": 1080.0176683333334,
            "2025-11-12": 129.80148944444446,
            "2025-11-14": 824.8810702777778,
            "2025-11-17": 51.59325805555555,
            "2025-11-19": 223.51642972222223,
            "2025-11-20": 248.92504055555554,
            "2025-11-24": 930.133501388889,
            "2025-11-27": 666.4435094444444,
            "2025-12-02": 295.5664591666666,
            "2025-12-03": 15.2278,
            "2025-12-04": 352.3138402777778,
            "2025-12-05": 78.38306277777778,
            "2025-12-11": 217.64557499999998,
            "2025-12-26": 186.72942222222224,
            "2025-12-29": 0.7541769444444444,
            "2026-01-05": 72.12259361111111,
            "2026-01-09": 81.95410861111112,
            "2026-01-12": 9.67454472222222,
            "2026-01-23": 271.10345944444447,
            "2026-01-27": 122.89602027777778,
            "2026-02-02": 64.09480888888889,
            "2026-02-03": 301.3532327777778,
            "2026-02-06": 269.4755547222222,
            "2026-02-13": 46.176364444444445
          },
          "time_count_per_day": {
            "2025-10-07": 3,
            "2025-10-08": 1,
            "2025-10-09": 5,
            "2025-10-10": 5,
            "2025-10-13": 5,
            "2025-10-14": 2,
            "2025-10-15": 3,
            "2025-10-21": 2,
            "2025-10-22": 1,
            "2025-10-23": 3,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-05": 1,
            "2025-11-10": 4,
            "2025-11-12": 1,
            "2025-11-14": 3,
            "2025-11-17": 2,
            "2025-11-19": 1,
            "2025-11-20": 1,
            "2025-11-24": 3,
            "2025-11-27": 2,
            "2025-12-02": 2,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-11": 1,
            "2025-12-26": 1,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-09": 1,
            "2026-01-12": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-13": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 278.67,
          "mode_time_hours": 553.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "8-10h": 2,
            "26-28h": 2,
            "32-34h": 1,
            "78-80h": 1,
            "98-100h": 1,
            "126-128h": 1,
            "136-138h": 1,
            "142-144h": 1,
            "198-200h": 1,
            "264-266h": 1,
            "270-272h": 1,
            "276-278h": 2,
            "298-300h": 1,
            "318-320h": 2,
            "322-324h": 1,
            "332-334h": 1,
            "334-336h": 1,
            "466-468h": 1,
            "540-542h": 1,
            "552-554h": 4,
            "1230-1232h": 1
          },
          "tickets_count": 30,
          "tickets_per_day": {
            "2025-12-02": 2,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-11": 1,
            "2025-12-12": 2,
            "2025-12-15": 3,
            "2025-12-19": 1,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2026-01-05": 4,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-17": 4,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 4
          },
          "time_per_day": {
            "2025-12-02": 280.2482136111111,
            "2025-12-04": 32.792865,
            "2025-12-05": 225.97870138888888,
            "2025-12-11": 322.55248,
            "2025-12-12": 667.6564361111111,
            "2025-12-15": 902.1376416666667,
            "2025-12-19": 466.32562916666666,
            "2025-12-23": 0.861728888888889,
            "2025-12-26": 553.8929947222222,
            "2026-01-05": 1665.2880847222223,
            "2026-01-13": 26.648840833333335,
            "2026-01-14": 7.837962500000001,
            "2026-01-17": 574.4905219444445,
            "2026-01-23": 277.6279488888889,
            "2026-01-26": 8.197226944444445,
            "2026-02-03": 2347.696373333333
          },
          "time_count_per_day": {
            "2025-12-02": 2,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-11": 1,
            "2025-12-12": 2,
            "2025-12-15": 3,
            "2025-12-19": 1,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2026-01-05": 4,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-17": 4,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 196.17,
            "mode_time_hours": 1.0,
            "mode_frequency": 240,
            "time_distribution": {
              "0-2h": 240,
              "2-4h": 107,
              "4-6h": 62,
              "6-8h": 22,
              "8-10h": 30,
              "10-12h": 2,
              "12-14h": 5,
              "14-16h": 7,
              "16-18h": 7,
              "18-20h": 8,
              "20-22h": 5,
              "22-24h": 12,
              "24-26h": 20,
              "26-28h": 10,
              "28-30h": 8,
              "30-32h": 11,
              "32-34h": 5,
              "36-38h": 2,
              "38-40h": 1,
              "42-44h": 1,
              "44-46h": 2,
              "46-48h": 5,
              "48-50h": 7,
              "50-52h": 8,
              "52-54h": 5,
              "54-56h": 11,
              "56-58h": 5,
              "64-66h": 1,
              "66-68h": 2,
              "68-70h": 2,
              "70-72h": 4,
              "72-74h": 7,
              "74-76h": 4,
              "76-78h": 4,
              "78-80h": 9,
              "80-82h": 2,
              "86-88h": 2,
              "88-90h": 1,
              "92-94h": 4,
              "94-96h": 1,
              "96-98h": 2,
              "98-100h": 4,
              "100-102h": 7,
              "102-104h": 1,
              "114-116h": 9,
              "116-118h": 3,
              "118-120h": 6,
              "120-122h": 3,
              "122-124h": 4,
              "124-126h": 2,
              "126-128h": 6,
              "128-130h": 3,
              "136-138h": 2,
              "138-140h": 1,
              "140-142h": 2,
              "142-144h": 3,
              "144-146h": 1,
              "146-148h": 6,
              "148-150h": 2,
              "150-152h": 5,
              "152-154h": 1,
              "154-156h": 1,
              "156-158h": 1,
              "158-160h": 2,
              "162-164h": 4,
              "164-166h": 3,
              "166-168h": 7,
              "168-170h": 6,
              "170-172h": 2,
              "172-174h": 3,
              "174-176h": 7,
              "176-178h": 1,
              "178-180h": 2,
              "180-182h": 1,
              "182-184h": 2,
              "184-186h": 3,
              "186-188h": 1,
              "190-192h": 1,
              "192-194h": 1,
              "194-196h": 1,
              "196-198h": 1,
              "198-200h": 3,
              "200-202h": 1,
              "204-206h": 4,
              "208-210h": 2,
              "212-214h": 3,
              "216-218h": 3,
              "218-220h": 3,
              "220-222h": 1,
              "222-224h": 2,
              "226-228h": 3,
              "228-230h": 1,
              "232-234h": 1,
              "238-240h": 1,
              "240-242h": 4,
              "242-244h": 8,
              "244-246h": 1,
              "248-250h": 1,
              "252-254h": 1,
              "254-256h": 1,
              "262-264h": 1,
              "264-266h": 2,
              "266-268h": 1,
              "268-270h": 6,
              "270-272h": 2,
              "272-274h": 1,
              "276-278h": 4,
              "282-284h": 1,
              "284-286h": 1,
              "288-290h": 1,
              "290-292h": 2,
              "292-294h": 2,
              "294-296h": 3,
              "298-300h": 3,
              "300-302h": 3,
              "306-308h": 3,
              "312-314h": 1,
              "314-316h": 1,
              "316-318h": 5,
              "318-320h": 5,
              "320-322h": 4,
              "322-324h": 2,
              "326-328h": 2,
              "330-332h": 1,
              "332-334h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "338-340h": 1,
              "340-342h": 3,
              "342-344h": 2,
              "344-346h": 2,
              "348-350h": 3,
              "350-352h": 6,
              "352-354h": 1,
              "358-360h": 1,
              "364-366h": 1,
              "366-368h": 1,
              "368-370h": 4,
              "370-372h": 2,
              "372-374h": 4,
              "376-378h": 1,
              "378-380h": 1,
              "386-388h": 3,
              "388-390h": 2,
              "390-392h": 4,
              "392-394h": 1,
              "400-402h": 1,
              "406-408h": 2,
              "408-410h": 2,
              "410-412h": 2,
              "414-416h": 4,
              "416-418h": 1,
              "418-420h": 1,
              "422-424h": 2,
              "424-426h": 1,
              "428-430h": 1,
              "430-432h": 1,
              "432-434h": 5,
              "434-436h": 2,
              "436-438h": 1,
              "448-450h": 1,
              "456-458h": 2,
              "460-462h": 1,
              "462-464h": 1,
              "464-466h": 1,
              "466-468h": 1,
              "468-470h": 1,
              "470-472h": 1,
              "478-480h": 5,
              "482-484h": 1,
              "488-490h": 3,
              "490-492h": 1,
              "492-494h": 2,
              "502-504h": 1,
              "506-508h": 1,
              "508-510h": 2,
              "512-514h": 2,
              "516-518h": 5,
              "518-520h": 1,
              "522-524h": 1,
              "526-528h": 1,
              "528-530h": 1,
              "530-532h": 2,
              "532-534h": 2,
              "534-536h": 1,
              "536-538h": 1,
              "538-540h": 4,
              "540-542h": 2,
              "548-550h": 1,
              "550-552h": 1,
              "552-554h": 4,
              "558-560h": 1,
              "560-562h": 1,
              "562-564h": 1,
              "566-568h": 1,
              "570-572h": 1,
              "574-576h": 2,
              "582-584h": 1,
              "586-588h": 1,
              "588-590h": 1,
              "590-592h": 1,
              "602-604h": 1,
              "606-608h": 1,
              "614-616h": 1,
              "626-628h": 2,
              "628-630h": 1,
              "654-656h": 1,
              "662-664h": 1,
              "664-666h": 1,
              "670-672h": 1,
              "672-674h": 1,
              "676-678h": 2,
              "678-680h": 2,
              "684-686h": 1,
              "690-692h": 1,
              "696-698h": 1,
              "704-706h": 1,
              "706-708h": 1,
              "724-726h": 2,
              "744-746h": 1,
              "748-750h": 1,
              "750-752h": 2,
              "754-756h": 1,
              "788-790h": 1,
              "790-792h": 1,
              "794-796h": 1,
              "796-798h": 1,
              "800-802h": 1,
              "812-814h": 1,
              "814-816h": 1,
              "816-818h": 1,
              "822-824h": 1,
              "838-840h": 1,
              "844-846h": 3,
              "866-868h": 2,
              "870-872h": 1,
              "872-874h": 2,
              "876-878h": 1,
              "882-884h": 1,
              "886-888h": 2,
              "890-892h": 1,
              "892-894h": 3,
              "894-896h": 2,
              "898-900h": 4,
              "910-912h": 1,
              "914-916h": 1,
              "916-918h": 1,
              "924-926h": 1,
              "984-986h": 1,
              "990-992h": 1,
              "1008-1010h": 1,
              "1068-1070h": 1,
              "1092-1094h": 1,
              "1114-1116h": 1,
              "1140-1142h": 1,
              "1162-1164h": 3,
              "1180-1182h": 1,
              "1188-1190h": 1,
              "1212-1214h": 1,
              "1228-1230h": 1,
              "1230-1232h": 1,
              "1234-1236h": 1,
              "1278-1280h": 1,
              "1284-1286h": 2,
              "1300-1302h": 1,
              "1376-1378h": 1,
              "1404-1406h": 1,
              "1422-1424h": 1,
              "1424-1426h": 1,
              "1426-1428h": 1,
              "1476-1478h": 1,
              "1498-1500h": 1,
              "1500-1502h": 1,
              "1518-1520h": 1,
              "1684-1686h": 2,
              "1732-1734h": 1,
              "1842-1844h": 1,
              "1896-1898h": 1,
              "2044-2046h": 1,
              "2696-2698h": 1,
              "3246-3248h": 1
            },
            "tickets_count": 1112,
            "tickets_per_day": {
              "2025-09-30": 7,
              "2025-10-01": 8,
              "2025-10-02": 2,
              "2025-10-03": 2,
              "2025-10-06": 8,
              "2025-10-07": 13,
              "2025-10-08": 7,
              "2025-10-09": 6,
              "2025-10-10": 14,
              "2025-10-13": 15,
              "2025-10-14": 13,
              "2025-10-15": 16,
              "2025-10-16": 4,
              "2025-10-20": 6,
              "2025-10-21": 14,
              "2025-10-22": 3,
              "2025-10-23": 27,
              "2025-10-24": 6,
              "2025-10-27": 7,
              "2025-10-28": 6,
              "2025-10-29": 15,
              "2025-10-30": 13,
              "2025-10-31": 6,
              "2025-11-03": 9,
              "2025-11-04": 5,
              "2025-11-05": 8,
              "2025-11-06": 10,
              "2025-11-07": 12,
              "2025-11-10": 11,
              "2025-11-11": 13,
              "2025-11-12": 12,
              "2025-11-13": 13,
              "2025-11-14": 13,
              "2025-11-17": 10,
              "2025-11-18": 6,
              "2025-11-19": 18,
              "2025-11-20": 11,
              "2025-11-21": 9,
              "2025-11-22": 1,
              "2025-11-24": 7,
              "2025-11-26": 11,
              "2025-11-27": 12,
              "2025-11-28": 7,
              "2025-12-02": 24,
              "2025-12-03": 3,
              "2025-12-04": 14,
              "2025-12-05": 12,
              "2025-12-09": 1,
              "2025-12-10": 7,
              "2025-12-11": 11,
              "2025-12-12": 8,
              "2025-12-15": 64,
              "2025-12-16": 3,
              "2025-12-17": 10,
              "2025-12-18": 8,
              "2025-12-19": 8,
              "2025-12-22": 5,
              "2025-12-23": 13,
              "2025-12-24": 4,
              "2025-12-26": 14,
              "2025-12-29": 5,
              "2026-01-02": 1,
              "2026-01-05": 14,
              "2026-01-06": 19,
              "2026-01-07": 13,
              "2026-01-08": 11,
              "2026-01-09": 11,
              "2026-01-12": 22,
              "2026-01-13": 20,
              "2026-01-14": 15,
              "2026-01-15": 7,
              "2026-01-16": 7,
              "2026-01-17": 4,
              "2026-01-19": 6,
              "2026-01-20": 5,
              "2026-01-21": 8,
              "2026-01-22": 4,
              "2026-01-23": 43,
              "2026-01-26": 20,
              "2026-01-27": 7,
              "2026-01-28": 4,
              "2026-01-29": 4,
              "2026-01-30": 2,
              "2026-02-02": 19,
              "2026-02-03": 59,
              "2026-02-04": 3,
              "2026-02-05": 9,
              "2026-02-06": 13,
              "2026-02-09": 9,
              "2026-02-10": 4,
              "2026-02-11": 7,
              "2026-02-12": 71,
              "2026-02-13": 39,
              "2026-02-16": 2
            },
            "time_per_day": {
              "2025-09-30": 17.67045222222222,
              "2025-10-01": 107.48918194444444,
              "2025-10-02": 46.32257861111111,
              "2025-10-03": 44.79330277777778,
              "2025-10-06": 710.2722913888889,
              "2025-10-07": 844.5038580555556,
              "2025-10-08": 386.9930425,
              "2025-10-09": 653.8329388888889,
              "2025-10-10": 1331.2771616666666,
              "2025-10-13": 1705.6818377777774,
              "2025-10-14": 660.8630849999998,
              "2025-10-15": 1224.0691111111112,
              "2025-10-16": 210.54633361111112,
              "2025-10-20": 461.47079333333335,
              "2025-10-21": 341.69153444444447,
              "2025-10-22": 86.83271305555556,
              "2025-10-23": 1771.8775205555557,
              "2025-10-24": 87.89853388888889,
              "2025-10-27": 520.6547202777776,
              "2025-10-28": 472.31891138888886,
              "2025-10-29": 1462.3758508333335,
              "2025-10-30": 294.2623075,
              "2025-10-31": 21.79866416666667,
              "2025-11-03": 795.4213952777775,
              "2025-11-04": 374.49555888888887,
              "2025-11-05": 417.5820247222222,
              "2025-11-06": 1769.8056397222222,
              "2025-11-07": 1278.1110638888888,
              "2025-11-10": 1086.3901805555558,
              "2025-11-11": 791.9551111111109,
              "2025-11-12": 225.2633555555556,
              "2025-11-13": 2430.019484166666,
              "2025-11-14": 3211.555087777778,
              "2025-11-17": 1187.922075833333,
              "2025-11-18": 204.16933111111112,
              "2025-11-19": 1966.3983391666666,
              "2025-11-20": 1615.0056269444444,
              "2025-11-21": 2344.499597777778,
              "2025-11-22": 52.83769583333333,
              "2025-11-24": 938.3912341666668,
              "2025-11-26": 466.66101611111105,
              "2025-11-27": 2938.4733680555555,
              "2025-11-28": 450.5068538888889,
              "2025-12-02": 4701.675381666668,
              "2025-12-03": 389.2933672222223,
              "2025-12-04": 1761.2988497222223,
              "2025-12-05": 753.9673108333333,
              "2025-12-09": 240.53105166666666,
              "2025-12-10": 323.80422916666674,
              "2025-12-11": 5007.294794166666,
              "2025-12-12": 686.3385558333333,
              "2025-12-15": 23154.692302222218,
              "2025-12-16": 7.9867197222222215,
              "2025-12-17": 71.41249194444443,
              "2025-12-18": 1238.5581591666669,
              "2025-12-19": 483.61316861111106,
              "2025-12-22": 918.8891386111111,
              "2025-12-23": 311.7282780555557,
              "2025-12-24": 170.9100358333333,
              "2025-12-26": 752.9101158333332,
              "2025-12-29": 151.0070769444445,
              "2026-01-02": 991.5368063888889,
              "2026-01-05": 3690.247452222221,
              "2026-01-06": 321.57498583333324,
              "2026-01-07": 1091.9909158333332,
              "2026-01-08": 803.9335730555555,
              "2026-01-09": 5054.462352500001,
              "2026-01-12": 73.99067777777778,
              "2026-01-13": 440.2180436111112,
              "2026-01-14": 189.82459527777783,
              "2026-01-15": 88.1514452777778,
              "2026-01-16": 780.7538058333334,
              "2026-01-17": 574.4905219444445,
              "2026-01-19": 334.38799527777775,
              "2026-01-20": 2914.2521613888894,
              "2026-01-21": 4113.233374166666,
              "2026-01-22": 738.2875072222222,
              "2026-01-23": 12891.270596666669,
              "2026-01-26": 69.94495722222221,
              "2026-01-27": 202.065405,
              "2026-01-28": 57.52680055555556,
              "2026-01-29": 240.72743388888892,
              "2026-01-30": 34.120216944444444,
              "2026-02-02": 400.5112019444444,
              "2026-02-03": 29743.128748055566,
              "2026-02-04": 1171.4400397222223,
              "2026-02-05": 86.13382444444443,
              "2026-02-06": 2393.940073055556,
              "2026-02-09": 318.3924316666667,
              "2026-02-10": 170.31826527777775,
              "2026-02-11": 406.9591447222223,
              "2026-02-12": 57877.1744108333,
              "2026-02-13": 10565.272643333337,
              "2026-02-16": 169.3617602777778
            },
            "time_count_per_day": {
              "2025-09-30": 7,
              "2025-10-01": 8,
              "2025-10-02": 2,
              "2025-10-03": 2,
              "2025-10-06": 8,
              "2025-10-07": 13,
              "2025-10-08": 7,
              "2025-10-09": 6,
              "2025-10-10": 14,
              "2025-10-13": 15,
              "2025-10-14": 13,
              "2025-10-15": 16,
              "2025-10-16": 4,
              "2025-10-20": 6,
              "2025-10-21": 14,
              "2025-10-22": 3,
              "2025-10-23": 27,
              "2025-10-24": 6,
              "2025-10-27": 7,
              "2025-10-28": 6,
              "2025-10-29": 15,
              "2025-10-30": 13,
              "2025-10-31": 6,
              "2025-11-03": 9,
              "2025-11-04": 5,
              "2025-11-05": 8,
              "2025-11-06": 10,
              "2025-11-07": 12,
              "2025-11-10": 11,
              "2025-11-11": 13,
              "2025-11-12": 12,
              "2025-11-13": 13,
              "2025-11-14": 13,
              "2025-11-17": 10,
              "2025-11-18": 6,
              "2025-11-19": 18,
              "2025-11-20": 11,
              "2025-11-21": 9,
              "2025-11-22": 1,
              "2025-11-24": 7,
              "2025-11-26": 11,
              "2025-11-27": 12,
              "2025-11-28": 7,
              "2025-12-02": 24,
              "2025-12-03": 3,
              "2025-12-04": 14,
              "2025-12-05": 12,
              "2025-12-09": 1,
              "2025-12-10": 7,
              "2025-12-11": 11,
              "2025-12-12": 8,
              "2025-12-15": 64,
              "2025-12-16": 3,
              "2025-12-17": 10,
              "2025-12-18": 8,
              "2025-12-19": 8,
              "2025-12-22": 5,
              "2025-12-23": 13,
              "2025-12-24": 4,
              "2025-12-26": 14,
              "2025-12-29": 5,
              "2026-01-02": 1,
              "2026-01-05": 14,
              "2026-01-06": 19,
              "2026-01-07": 13,
              "2026-01-08": 11,
              "2026-01-09": 11,
              "2026-01-12": 22,
              "2026-01-13": 20,
              "2026-01-14": 15,
              "2026-01-15": 7,
              "2026-01-16": 7,
              "2026-01-17": 4,
              "2026-01-19": 6,
              "2026-01-20": 5,
              "2026-01-21": 8,
              "2026-01-22": 4,
              "2026-01-23": 43,
              "2026-01-26": 20,
              "2026-01-27": 7,
              "2026-01-28": 4,
              "2026-01-29": 4,
              "2026-01-30": 2,
              "2026-02-02": 19,
              "2026-02-03": 59,
              "2026-02-04": 3,
              "2026-02-05": 9,
              "2026-02-06": 13,
              "2026-02-09": 9,
              "2026-02-10": 4,
              "2026-02-11": 7,
              "2026-02-12": 71,
              "2026-02-13": 39,
              "2026-02-16": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 99.92,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 2,
                "8-10h": 3,
                "22-24h": 1,
                "24-26h": 1,
                "30-32h": 1,
                "36-38h": 1,
                "44-46h": 1,
                "50-52h": 2,
                "52-54h": 1,
                "54-56h": 2,
                "56-58h": 1,
                "100-102h": 1,
                "122-124h": 1,
                "166-168h": 1,
                "192-194h": 1,
                "212-214h": 1,
                "330-332h": 1,
                "342-344h": 1,
                "350-352h": 2,
                "410-412h": 1
              },
              "tickets_count": 31,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-15": 1,
                "2025-10-23": 2,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-24": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-23": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-14": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 1,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-10-06": 122.02680027777778,
                "2025-10-15": 54.32751694444444,
                "2025-10-23": 102.91623472222221,
                "2025-11-03": 0.10010416666666666,
                "2025-11-04": 54.64275361111111,
                "2025-11-24": 3.18576,
                "2025-11-28": 0.4007811111111111,
                "2025-12-04": 331.799555,
                "2025-12-23": 0.6058288888888889,
                "2026-01-06": 8.139582222222222,
                "2026-01-08": 51.827086111111115,
                "2026-01-14": 45.73746416666667,
                "2026-01-21": 56.02625,
                "2026-01-22": 30.24807,
                "2026-01-23": 790.0958941666667,
                "2026-01-26": 0.6639122222222221,
                "2026-01-29": 193.68715500000002,
                "2026-01-30": 24.44329611111111,
                "2026-02-03": 351.55231694444444,
                "2026-02-09": 2.292703888888889,
                "2026-02-10": 23.79750027777778,
                "2026-02-11": 8.16352111111111,
                "2026-02-12": 389.42757416666666,
                "2026-02-13": 350.6950444444444,
                "2026-02-16": 100.73119527777779
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-15": 1,
                "2025-10-23": 2,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-24": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-23": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-14": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 1,
                "2026-02-16": 1
              }
            },
            "P2": {
              "avg_time_hours": 164.16,
              "mode_time_hours": 1.0,
              "mode_frequency": 169,
              "time_distribution": {
                "0-2h": 169,
                "2-4h": 61,
                "4-6h": 37,
                "6-8h": 10,
                "8-10h": 16,
                "10-12h": 2,
                "12-14h": 5,
                "14-16h": 3,
                "16-18h": 6,
                "18-20h": 5,
                "20-22h": 2,
                "22-24h": 6,
                "24-26h": 12,
                "26-28h": 2,
                "28-30h": 3,
                "30-32h": 4,
                "32-34h": 2,
                "46-48h": 1,
                "48-50h": 5,
                "50-52h": 3,
                "52-54h": 3,
                "54-56h": 9,
                "56-58h": 3,
                "68-70h": 1,
                "70-72h": 3,
                "72-74h": 4,
                "74-76h": 1,
                "76-78h": 2,
                "80-82h": 1,
                "86-88h": 2,
                "88-90h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "96-98h": 1,
                "98-100h": 1,
                "100-102h": 3,
                "114-116h": 3,
                "116-118h": 1,
                "118-120h": 4,
                "120-122h": 1,
                "122-124h": 1,
                "126-128h": 3,
                "128-130h": 2,
                "144-146h": 1,
                "146-148h": 2,
                "150-152h": 2,
                "152-154h": 1,
                "154-156h": 1,
                "156-158h": 1,
                "158-160h": 1,
                "162-164h": 2,
                "164-166h": 2,
                "166-168h": 2,
                "168-170h": 1,
                "170-172h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "176-178h": 1,
                "178-180h": 2,
                "180-182h": 1,
                "184-186h": 1,
                "196-198h": 1,
                "198-200h": 1,
                "200-202h": 1,
                "204-206h": 3,
                "212-214h": 2,
                "216-218h": 1,
                "218-220h": 1,
                "226-228h": 1,
                "228-230h": 1,
                "238-240h": 1,
                "240-242h": 1,
                "242-244h": 1,
                "252-254h": 1,
                "254-256h": 1,
                "262-264h": 1,
                "264-266h": 1,
                "266-268h": 1,
                "268-270h": 2,
                "276-278h": 1,
                "282-284h": 1,
                "292-294h": 1,
                "294-296h": 1,
                "298-300h": 1,
                "300-302h": 2,
                "306-308h": 2,
                "314-316h": 1,
                "316-318h": 2,
                "318-320h": 2,
                "320-322h": 2,
                "326-328h": 1,
                "336-338h": 1,
                "340-342h": 2,
                "344-346h": 1,
                "350-352h": 2,
                "364-366h": 1,
                "366-368h": 1,
                "368-370h": 3,
                "370-372h": 1,
                "372-374h": 2,
                "386-388h": 2,
                "388-390h": 2,
                "390-392h": 3,
                "392-394h": 1,
                "400-402h": 1,
                "408-410h": 2,
                "410-412h": 1,
                "414-416h": 3,
                "416-418h": 1,
                "428-430h": 1,
                "432-434h": 1,
                "434-436h": 1,
                "436-438h": 1,
                "456-458h": 2,
                "460-462h": 1,
                "464-466h": 1,
                "478-480h": 1,
                "488-490h": 3,
                "492-494h": 2,
                "508-510h": 2,
                "512-514h": 2,
                "518-520h": 1,
                "528-530h": 1,
                "530-532h": 2,
                "532-534h": 2,
                "540-542h": 1,
                "548-550h": 1,
                "550-552h": 1,
                "558-560h": 1,
                "562-564h": 1,
                "566-568h": 1,
                "582-584h": 1,
                "602-604h": 1,
                "614-616h": 1,
                "628-630h": 1,
                "654-656h": 1,
                "662-664h": 1,
                "664-666h": 1,
                "672-674h": 1,
                "676-678h": 2,
                "678-680h": 2,
                "684-686h": 1,
                "706-708h": 1,
                "724-726h": 1,
                "744-746h": 1,
                "748-750h": 1,
                "750-752h": 2,
                "754-756h": 1,
                "796-798h": 1,
                "800-802h": 1,
                "812-814h": 1,
                "816-818h": 1,
                "822-824h": 1,
                "844-846h": 2,
                "866-868h": 1,
                "872-874h": 2,
                "876-878h": 1,
                "892-894h": 3,
                "894-896h": 1,
                "898-900h": 1,
                "914-916h": 1,
                "916-918h": 1,
                "984-986h": 1,
                "990-992h": 1,
                "1008-1010h": 1,
                "1068-1070h": 1,
                "1092-1094h": 1,
                "1114-1116h": 1,
                "1162-1164h": 1,
                "1180-1182h": 1,
                "1228-1230h": 1,
                "1234-1236h": 1,
                "1284-1286h": 1,
                "1300-1302h": 1,
                "1424-1426h": 1,
                "1842-1844h": 1,
                "1896-1898h": 1
              },
              "tickets_count": 582,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-01": 1,
                "2025-10-02": 1,
                "2025-10-03": 2,
                "2025-10-06": 3,
                "2025-10-07": 6,
                "2025-10-08": 4,
                "2025-10-09": 1,
                "2025-10-10": 6,
                "2025-10-13": 6,
                "2025-10-14": 11,
                "2025-10-15": 8,
                "2025-10-16": 3,
                "2025-10-20": 6,
                "2025-10-21": 11,
                "2025-10-22": 2,
                "2025-10-23": 18,
                "2025-10-24": 4,
                "2025-10-27": 5,
                "2025-10-28": 3,
                "2025-10-29": 14,
                "2025-10-30": 9,
                "2025-10-31": 6,
                "2025-11-03": 6,
                "2025-11-04": 3,
                "2025-11-05": 1,
                "2025-11-06": 4,
                "2025-11-07": 9,
                "2025-11-10": 6,
                "2025-11-11": 13,
                "2025-11-12": 3,
                "2025-11-13": 7,
                "2025-11-14": 4,
                "2025-11-17": 4,
                "2025-11-18": 1,
                "2025-11-19": 6,
                "2025-11-20": 1,
                "2025-11-21": 6,
                "2025-11-24": 1,
                "2025-11-26": 8,
                "2025-11-27": 6,
                "2025-11-28": 4,
                "2025-12-02": 3,
                "2025-12-04": 3,
                "2025-12-05": 7,
                "2025-12-10": 6,
                "2025-12-11": 9,
                "2025-12-12": 4,
                "2025-12-15": 26,
                "2025-12-17": 4,
                "2025-12-18": 3,
                "2025-12-19": 6,
                "2025-12-22": 2,
                "2025-12-23": 4,
                "2025-12-24": 3,
                "2025-12-26": 10,
                "2025-12-29": 3,
                "2026-01-02": 1,
                "2026-01-05": 3,
                "2026-01-06": 14,
                "2026-01-07": 9,
                "2026-01-08": 8,
                "2026-01-09": 6,
                "2026-01-12": 14,
                "2026-01-13": 16,
                "2026-01-14": 10,
                "2026-01-15": 4,
                "2026-01-16": 3,
                "2026-01-19": 3,
                "2026-01-20": 3,
                "2026-01-21": 4,
                "2026-01-22": 2,
                "2026-01-23": 23,
                "2026-01-26": 17,
                "2026-01-27": 5,
                "2026-01-28": 4,
                "2026-01-29": 2,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-03": 27,
                "2026-02-04": 1,
                "2026-02-05": 6,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-11": 3,
                "2026-02-12": 42,
                "2026-02-13": 25,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-09-30": 0.43303416666666666,
                "2025-10-01": 1.2259255555555557,
                "2025-10-02": 1.777478611111111,
                "2025-10-03": 44.79330277777778,
                "2025-10-06": 215.98573888888887,
                "2025-10-07": 442.9095361111111,
                "2025-10-08": 38.290801111111115,
                "2025-10-09": 25.853180555555554,
                "2025-10-10": 105.27102222222223,
                "2025-10-13": 577.4642477777778,
                "2025-10-14": 291.3477216666666,
                "2025-10-15": 220.1438975,
                "2025-10-16": 130.71368444444445,
                "2025-10-20": 461.47079333333335,
                "2025-10-21": 19.955766666666666,
                "2025-10-22": 36.905006388888886,
                "2025-10-23": 1229.133745,
                "2025-10-24": 83.6556,
                "2025-10-27": 284.36690833333336,
                "2025-10-28": 219.68845555555558,
                "2025-10-29": 1293.3646447222225,
                "2025-10-30": 239.48619499999995,
                "2025-10-31": 21.79866416666667,
                "2025-11-03": 3.6828938888888887,
                "2025-11-04": 311.2160947222222,
                "2025-11-05": 3.342628055555555,
                "2025-11-06": 84.09284472222221,
                "2025-11-07": 881.2284702777779,
                "2025-11-10": 5.549409166666666,
                "2025-11-11": 791.9551111111109,
                "2025-11-12": 1.6641930555555557,
                "2025-11-13": 1448.3387608333333,
                "2025-11-14": 830.2657355555556,
                "2025-11-17": 555.9628458333333,
                "2025-11-18": 0.5358844444444444,
                "2025-11-19": 563.0783711111111,
                "2025-11-20": 2.356298611111111,
                "2025-11-21": 2198.036521388889,
                "2025-11-24": 3.2222333333333335,
                "2025-11-26": 232.01889444444444,
                "2025-11-27": 1090.2011202777776,
                "2025-11-28": 418.7224522222223,
                "2025-12-02": 304.0986688888889,
                "2025-12-04": 332.71256166666666,
                "2025-12-05": 2.4941036111111115,
                "2025-12-10": 321.72088500000007,
                "2025-12-11": 4467.096739166666,
                "2025-12-12": 6.612499722222223,
                "2025-12-15": 9500.457635555555,
                "2025-12-17": 40.50358416666667,
                "2025-12-18": 1237.053218611111,
                "2025-12-19": 16.273385277777777,
                "2025-12-22": 219.39184555555556,
                "2025-12-23": 4.37403,
                "2025-12-24": 2.053116111111111,
                "2025-12-26": 11.285001944444447,
                "2025-12-29": 148.92714250000003,
                "2026-01-02": 991.5368063888889,
                "2026-01-05": 169.5097452777778,
                "2026-01-06": 101.04070416666667,
                "2026-01-07": 66.53821527777777,
                "2026-01-08": 631.6356669444444,
                "2026-01-09": 2717.5274375,
                "2026-01-12": 39.345231111111104,
                "2026-01-13": 62.477240555555554,
                "2026-01-14": 109.08312027777777,
                "2026-01-15": 35.255894166666664,
                "2026-01-16": 768.5521258333333,
                "2026-01-19": 304.1720630555555,
                "2026-01-20": 214.15606888888888,
                "2026-01-21": 1633.5123133333334,
                "2026-01-22": 2.8526483333333332,
                "2026-01-23": 6535.353262500001,
                "2026-01-26": 57.272137222222234,
                "2026-01-27": 43.05988972222222,
                "2026-01-28": 57.52680055555556,
                "2026-01-29": 16.793032222222223,
                "2026-01-30": 9.676920833333334,
                "2026-02-02": 3.9351541666666665,
                "2026-02-03": 11038.609178333334,
                "2026-02-04": 533.1324597222222,
                "2026-02-05": 82.91045888888888,
                "2026-02-06": 2084.34716,
                "2026-02-09": 0.3334608333333334,
                "2026-02-10": 122.48674083333333,
                "2026-02-11": 396.9694702777778,
                "2026-02-12": 28618.0943025,
                "2026-02-13": 5996.1037700000015,
                "2026-02-16": 68.630565
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-01": 1,
                "2025-10-02": 1,
                "2025-10-03": 2,
                "2025-10-06": 3,
                "2025-10-07": 6,
                "2025-10-08": 4,
                "2025-10-09": 1,
                "2025-10-10": 6,
                "2025-10-13": 6,
                "2025-10-14": 11,
                "2025-10-15": 8,
                "2025-10-16": 3,
                "2025-10-20": 6,
                "2025-10-21": 11,
                "2025-10-22": 2,
                "2025-10-23": 18,
                "2025-10-24": 4,
                "2025-10-27": 5,
                "2025-10-28": 3,
                "2025-10-29": 14,
                "2025-10-30": 9,
                "2025-10-31": 6,
                "2025-11-03": 6,
                "2025-11-04": 3,
                "2025-11-05": 1,
                "2025-11-06": 4,
                "2025-11-07": 9,
                "2025-11-10": 6,
                "2025-11-11": 13,
                "2025-11-12": 3,
                "2025-11-13": 7,
                "2025-11-14": 4,
                "2025-11-17": 4,
                "2025-11-18": 1,
                "2025-11-19": 6,
                "2025-11-20": 1,
                "2025-11-21": 6,
                "2025-11-24": 1,
                "2025-11-26": 8,
                "2025-11-27": 6,
                "2025-11-28": 4,
                "2025-12-02": 3,
                "2025-12-04": 3,
                "2025-12-05": 7,
                "2025-12-10": 6,
                "2025-12-11": 9,
                "2025-12-12": 4,
                "2025-12-15": 26,
                "2025-12-17": 4,
                "2025-12-18": 3,
                "2025-12-19": 6,
                "2025-12-22": 2,
                "2025-12-23": 4,
                "2025-12-24": 3,
                "2025-12-26": 10,
                "2025-12-29": 3,
                "2026-01-02": 1,
                "2026-01-05": 3,
                "2026-01-06": 14,
                "2026-01-07": 9,
                "2026-01-08": 8,
                "2026-01-09": 6,
                "2026-01-12": 14,
                "2026-01-13": 16,
                "2026-01-14": 10,
                "2026-01-15": 4,
                "2026-01-16": 3,
                "2026-01-19": 3,
                "2026-01-20": 3,
                "2026-01-21": 4,
                "2026-01-22": 2,
                "2026-01-23": 23,
                "2026-01-26": 17,
                "2026-01-27": 5,
                "2026-01-28": 4,
                "2026-01-29": 2,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-03": 27,
                "2026-02-04": 1,
                "2026-02-05": 6,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-11": 3,
                "2026-02-12": 42,
                "2026-02-13": 25,
                "2026-02-16": 1
              }
            },
            "P3": {
              "avg_time_hours": 249.74,
              "mode_time_hours": 1.0,
              "mode_frequency": 63,
              "time_distribution": {
                "0-2h": 63,
                "2-4h": 43,
                "4-6h": 24,
                "6-8h": 11,
                "8-10h": 8,
                "14-16h": 3,
                "16-18h": 1,
                "18-20h": 3,
                "20-22h": 2,
                "22-24h": 3,
                "24-26h": 7,
                "26-28h": 6,
                "28-30h": 5,
                "30-32h": 5,
                "32-34h": 2,
                "36-38h": 1,
                "38-40h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "50-52h": 3,
                "52-54h": 1,
                "56-58h": 1,
                "66-68h": 1,
                "68-70h": 1,
                "70-72h": 1,
                "72-74h": 2,
                "74-76h": 2,
                "78-80h": 6,
                "92-94h": 2,
                "98-100h": 1,
                "100-102h": 3,
                "102-104h": 1,
                "114-116h": 6,
                "116-118h": 2,
                "118-120h": 2,
                "120-122h": 1,
                "122-124h": 1,
                "124-126h": 2,
                "126-128h": 2,
                "136-138h": 1,
                "138-140h": 1,
                "140-142h": 1,
                "142-144h": 2,
                "146-148h": 1,
                "148-150h": 2,
                "150-152h": 1,
                "158-160h": 1,
                "164-166h": 1,
                "166-168h": 1,
                "168-170h": 2,
                "170-172h": 1,
                "174-176h": 5,
                "182-184h": 2,
                "184-186h": 1,
                "190-192h": 1,
                "198-200h": 1,
                "204-206h": 1,
                "208-210h": 1,
                "216-218h": 1,
                "218-220h": 2,
                "222-224h": 1,
                "226-228h": 2,
                "240-242h": 3,
                "242-244h": 7,
                "244-246h": 1,
                "268-270h": 3,
                "272-274h": 1,
                "276-278h": 1,
                "284-286h": 1,
                "288-290h": 1,
                "294-296h": 1,
                "298-300h": 1,
                "306-308h": 1,
                "312-314h": 1,
                "316-318h": 3,
                "318-320h": 1,
                "320-322h": 1,
                "322-324h": 1,
                "326-328h": 1,
                "338-340h": 1,
                "340-342h": 1,
                "342-344h": 1,
                "344-346h": 1,
                "348-350h": 2,
                "350-352h": 2,
                "358-360h": 1,
                "368-370h": 1,
                "370-372h": 1,
                "372-374h": 2,
                "376-378h": 1,
                "378-380h": 1,
                "386-388h": 1,
                "390-392h": 1,
                "406-408h": 2,
                "414-416h": 1,
                "418-420h": 1,
                "422-424h": 2,
                "424-426h": 1,
                "430-432h": 1,
                "432-434h": 3,
                "434-436h": 1,
                "448-450h": 1,
                "462-464h": 1,
                "470-472h": 1,
                "478-480h": 4,
                "482-484h": 1,
                "490-492h": 1,
                "502-504h": 1,
                "506-508h": 1,
                "516-518h": 5,
                "522-524h": 1,
                "526-528h": 1,
                "534-536h": 1,
                "538-540h": 4,
                "560-562h": 1,
                "570-572h": 1,
                "574-576h": 2,
                "586-588h": 1,
                "588-590h": 1,
                "590-592h": 1,
                "606-608h": 1,
                "626-628h": 2,
                "670-672h": 1,
                "690-692h": 1,
                "696-698h": 1,
                "704-706h": 1,
                "724-726h": 1,
                "788-790h": 1,
                "790-792h": 1,
                "794-796h": 1,
                "814-816h": 1,
                "838-840h": 1,
                "844-846h": 1,
                "866-868h": 1,
                "870-872h": 1,
                "882-884h": 1,
                "886-888h": 2,
                "890-892h": 1,
                "894-896h": 1,
                "898-900h": 3,
                "910-912h": 1,
                "924-926h": 1,
                "1140-1142h": 1,
                "1162-1164h": 2,
                "1188-1190h": 1,
                "1212-1214h": 1,
                "1278-1280h": 1,
                "1284-1286h": 1,
                "1376-1378h": 1,
                "1404-1406h": 1,
                "1422-1424h": 1,
                "1426-1428h": 1,
                "1476-1478h": 1,
                "1498-1500h": 1,
                "1500-1502h": 1,
                "1518-1520h": 1,
                "1684-1686h": 2,
                "1732-1734h": 1,
                "2044-2046h": 1,
                "2696-2698h": 1,
                "3246-3248h": 1
              },
              "tickets_count": 402,
              "tickets_per_day": {
                "2025-09-30": 6,
                "2025-10-01": 7,
                "2025-10-02": 1,
                "2025-10-06": 4,
                "2025-10-07": 4,
                "2025-10-08": 2,
                "2025-10-10": 3,
                "2025-10-13": 4,
                "2025-10-15": 4,
                "2025-10-16": 1,
                "2025-10-21": 1,
                "2025-10-23": 4,
                "2025-10-24": 2,
                "2025-10-27": 2,
                "2025-10-28": 2,
                "2025-10-30": 4,
                "2025-11-03": 2,
                "2025-11-04": 1,
                "2025-11-05": 6,
                "2025-11-06": 6,
                "2025-11-07": 3,
                "2025-11-10": 1,
                "2025-11-12": 8,
                "2025-11-13": 6,
                "2025-11-14": 6,
                "2025-11-17": 4,
                "2025-11-18": 5,
                "2025-11-19": 11,
                "2025-11-20": 9,
                "2025-11-21": 3,
                "2025-11-22": 1,
                "2025-11-24": 2,
                "2025-11-26": 3,
                "2025-11-27": 4,
                "2025-11-28": 2,
                "2025-12-02": 17,
                "2025-12-03": 2,
                "2025-12-04": 8,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-12": 2,
                "2025-12-15": 35,
                "2025-12-16": 3,
                "2025-12-17": 6,
                "2025-12-18": 5,
                "2025-12-19": 1,
                "2025-12-22": 3,
                "2025-12-23": 7,
                "2025-12-24": 1,
                "2025-12-26": 2,
                "2025-12-29": 1,
                "2026-01-05": 6,
                "2026-01-06": 4,
                "2026-01-07": 4,
                "2026-01-08": 2,
                "2026-01-09": 4,
                "2026-01-12": 7,
                "2026-01-13": 3,
                "2026-01-14": 2,
                "2026-01-15": 3,
                "2026-01-16": 4,
                "2026-01-19": 3,
                "2026-01-20": 2,
                "2026-01-21": 3,
                "2026-01-22": 1,
                "2026-01-23": 15,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-02": 16,
                "2026-02-03": 26,
                "2026-02-04": 2,
                "2026-02-05": 3,
                "2026-02-06": 9,
                "2026-02-09": 7,
                "2026-02-10": 1,
                "2026-02-11": 3,
                "2026-02-12": 26,
                "2026-02-13": 12
              },
              "time_per_day": {
                "2025-09-30": 17.23741805555555,
                "2025-10-01": 106.26325638888888,
                "2025-10-02": 44.5451,
                "2025-10-06": 372.25975222222223,
                "2025-10-07": 180.34373916666664,
                "2025-10-08": 186.23269722222224,
                "2025-10-10": 623.5979808333334,
                "2025-10-13": 566.2878283333333,
                "2025-10-15": 334.7119838888889,
                "2025-10-16": 79.83264916666667,
                "2025-10-21": 0.6583905555555556,
                "2025-10-23": 208.2698372222222,
                "2025-10-24": 4.242933888888889,
                "2025-10-27": 236.28781194444446,
                "2025-10-28": 155.65499666666668,
                "2025-10-30": 54.7761125,
                "2025-11-03": 791.6383972222221,
                "2025-11-04": 8.636710555555556,
                "2025-11-05": 240.4710638888889,
                "2025-11-06": 1685.7127950000001,
                "2025-11-07": 396.88259361111113,
                "2025-11-10": 0.8231030555555555,
                "2025-11-12": 93.79767305555553,
                "2025-11-13": 981.6807233333333,
                "2025-11-14": 1556.4082819444445,
                "2025-11-17": 580.3659719444445,
                "2025-11-18": 203.63344666666669,
                "2025-11-19": 1179.8035383333333,
                "2025-11-20": 1363.7242877777778,
                "2025-11-21": 146.46307638888888,
                "2025-11-22": 52.83769583333333,
                "2025-11-24": 1.8497394444444444,
                "2025-11-26": 234.6421216666667,
                "2025-11-27": 1181.8287383333334,
                "2025-11-28": 31.383620555555556,
                "2025-12-02": 3821.7620400000005,
                "2025-12-03": 374.0655672222223,
                "2025-12-04": 711.6800277777777,
                "2025-12-05": 447.1114430555555,
                "2025-12-09": 240.53105166666666,
                "2025-12-10": 2.0833441666666666,
                "2025-12-12": 12.06962,
                "2025-12-15": 12752.097025000003,
                "2025-12-16": 7.9867197222222215,
                "2025-12-17": 30.908907777777777,
                "2025-12-18": 1.5049405555555555,
                "2025-12-19": 1.0141541666666667,
                "2025-12-22": 699.4972930555556,
                "2025-12-23": 305.88669027777786,
                "2025-12-24": 168.85691972222222,
                "2025-12-26": 1.0026969444444445,
                "2025-12-29": 1.3257575,
                "2026-01-05": 1783.3270286111112,
                "2026-01-06": 212.39469944444443,
                "2026-01-07": 1025.4527005555556,
                "2026-01-08": 120.47082,
                "2026-01-09": 2254.9808063888886,
                "2026-01-12": 24.970901944444446,
                "2026-01-13": 351.09196222222226,
                "2026-01-14": 27.166048333333332,
                "2026-01-15": 52.895551111111104,
                "2026-01-16": 12.20168,
                "2026-01-19": 30.21593222222222,
                "2026-01-20": 2700.0960925,
                "2026-01-21": 2423.6948108333336,
                "2026-01-22": 705.1867888888888,
                "2026-01-23": 5017.090031666667,
                "2026-01-26": 3.8116808333333334,
                "2026-01-27": 36.109495,
                "2026-01-29": 30.24724666666667,
                "2026-02-02": 332.4812388888888,
                "2026-02-03": 15703.917646666665,
                "2026-02-04": 638.3075799999999,
                "2026-02-05": 3.2233655555555556,
                "2026-02-06": 40.117358333333335,
                "2026-02-09": 315.7662669444445,
                "2026-02-10": 24.034024166666665,
                "2026-02-11": 1.8261533333333335,
                "2026-02-12": 28869.652534166667,
                "2026-02-13": 4172.297464444446
              },
              "time_count_per_day": {
                "2025-09-30": 6,
                "2025-10-01": 7,
                "2025-10-02": 1,
                "2025-10-06": 4,
                "2025-10-07": 4,
                "2025-10-08": 2,
                "2025-10-10": 3,
                "2025-10-13": 4,
                "2025-10-15": 4,
                "2025-10-16": 1,
                "2025-10-21": 1,
                "2025-10-23": 4,
                "2025-10-24": 2,
                "2025-10-27": 2,
                "2025-10-28": 2,
                "2025-10-30": 4,
                "2025-11-03": 2,
                "2025-11-04": 1,
                "2025-11-05": 6,
                "2025-11-06": 6,
                "2025-11-07": 3,
                "2025-11-10": 1,
                "2025-11-12": 8,
                "2025-11-13": 6,
                "2025-11-14": 6,
                "2025-11-17": 4,
                "2025-11-18": 5,
                "2025-11-19": 11,
                "2025-11-20": 9,
                "2025-11-21": 3,
                "2025-11-22": 1,
                "2025-11-24": 2,
                "2025-11-26": 3,
                "2025-11-27": 4,
                "2025-11-28": 2,
                "2025-12-02": 17,
                "2025-12-03": 2,
                "2025-12-04": 8,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-12": 2,
                "2025-12-15": 35,
                "2025-12-16": 3,
                "2025-12-17": 6,
                "2025-12-18": 5,
                "2025-12-19": 1,
                "2025-12-22": 3,
                "2025-12-23": 7,
                "2025-12-24": 1,
                "2025-12-26": 2,
                "2025-12-29": 1,
                "2026-01-05": 6,
                "2026-01-06": 4,
                "2026-01-07": 4,
                "2026-01-08": 2,
                "2026-01-09": 4,
                "2026-01-12": 7,
                "2026-01-13": 3,
                "2026-01-14": 2,
                "2026-01-15": 3,
                "2026-01-16": 4,
                "2026-01-19": 3,
                "2026-01-20": 2,
                "2026-01-21": 3,
                "2026-01-22": 1,
                "2026-01-23": 15,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-02": 16,
                "2026-02-03": 26,
                "2026-02-04": 2,
                "2026-02-05": 3,
                "2026-02-06": 9,
                "2026-02-09": 7,
                "2026-02-10": 1,
                "2026-02-11": 3,
                "2026-02-12": 26,
                "2026-02-13": 12
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 160.35,
              "mode_time_hours": 169.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "20-22h": 1,
                "22-24h": 2,
                "30-32h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "64-66h": 1,
                "66-68h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "76-78h": 2,
                "78-80h": 2,
                "80-82h": 1,
                "92-94h": 1,
                "96-98h": 1,
                "98-100h": 1,
                "120-122h": 1,
                "122-124h": 1,
                "128-130h": 1,
                "140-142h": 1,
                "146-148h": 3,
                "150-152h": 2,
                "162-164h": 2,
                "166-168h": 3,
                "168-170h": 3,
                "172-174h": 2,
                "174-176h": 1,
                "184-186h": 1,
                "186-188h": 1,
                "194-196h": 1,
                "208-210h": 1,
                "216-218h": 1,
                "220-222h": 1,
                "222-224h": 1,
                "232-234h": 1,
                "248-250h": 1,
                "268-270h": 1,
                "270-272h": 1,
                "290-292h": 2,
                "292-294h": 1,
                "294-296h": 1,
                "300-302h": 1,
                "320-322h": 1,
                "348-350h": 1,
                "352-354h": 1,
                "432-434h": 1,
                "468-470h": 1,
                "536-538h": 1
              },
              "tickets_count": 67,
              "tickets_per_day": {
                "2025-10-07": 3,
                "2025-10-08": 1,
                "2025-10-09": 5,
                "2025-10-10": 5,
                "2025-10-13": 5,
                "2025-10-14": 2,
                "2025-10-15": 3,
                "2025-10-21": 2,
                "2025-10-22": 1,
                "2025-10-23": 3,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-05": 1,
                "2025-11-10": 4,
                "2025-11-12": 1,
                "2025-11-14": 3,
                "2025-11-17": 2,
                "2025-11-19": 1,
                "2025-11-20": 1,
                "2025-11-24": 3,
                "2025-11-27": 2,
                "2025-12-02": 2,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-11": 1,
                "2025-12-26": 1,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-09": 1,
                "2026-01-12": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2025-10-07": 221.25058277777777,
                "2025-10-08": 162.46954416666668,
                "2025-10-09": 627.9797583333333,
                "2025-10-10": 602.4081586111112,
                "2025-10-13": 561.9297616666668,
                "2025-10-14": 369.51536333333337,
                "2025-10-15": 614.8857127777778,
                "2025-10-21": 321.0773772222222,
                "2025-10-22": 49.927706666666666,
                "2025-10-23": 231.55770361111112,
                "2025-10-28": 96.97545916666667,
                "2025-10-29": 169.0112061111111,
                "2025-11-05": 173.76833277777777,
                "2025-11-10": 1080.0176683333334,
                "2025-11-12": 129.80148944444446,
                "2025-11-14": 824.8810702777778,
                "2025-11-17": 51.59325805555555,
                "2025-11-19": 223.51642972222223,
                "2025-11-20": 248.92504055555554,
                "2025-11-24": 930.133501388889,
                "2025-11-27": 666.4435094444444,
                "2025-12-02": 295.5664591666666,
                "2025-12-03": 15.2278,
                "2025-12-04": 352.3138402777778,
                "2025-12-05": 78.38306277777778,
                "2025-12-11": 217.64557499999998,
                "2025-12-26": 186.72942222222224,
                "2025-12-29": 0.7541769444444444,
                "2026-01-05": 72.12259361111111,
                "2026-01-09": 81.95410861111112,
                "2026-01-12": 9.67454472222222,
                "2026-01-23": 271.10345944444447,
                "2026-01-27": 122.89602027777778,
                "2026-02-02": 64.09480888888889,
                "2026-02-03": 301.3532327777778,
                "2026-02-06": 269.4755547222222,
                "2026-02-13": 46.176364444444445
              },
              "time_count_per_day": {
                "2025-10-07": 3,
                "2025-10-08": 1,
                "2025-10-09": 5,
                "2025-10-10": 5,
                "2025-10-13": 5,
                "2025-10-14": 2,
                "2025-10-15": 3,
                "2025-10-21": 2,
                "2025-10-22": 1,
                "2025-10-23": 3,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-05": 1,
                "2025-11-10": 4,
                "2025-11-12": 1,
                "2025-11-14": 3,
                "2025-11-17": 2,
                "2025-11-19": 1,
                "2025-11-20": 1,
                "2025-11-24": 3,
                "2025-11-27": 2,
                "2025-12-02": 2,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-11": 1,
                "2025-12-26": 1,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-09": 1,
                "2026-01-12": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-13": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 278.67,
              "mode_time_hours": 553.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "8-10h": 2,
                "26-28h": 2,
                "32-34h": 1,
                "78-80h": 1,
                "98-100h": 1,
                "126-128h": 1,
                "136-138h": 1,
                "142-144h": 1,
                "198-200h": 1,
                "264-266h": 1,
                "270-272h": 1,
                "276-278h": 2,
                "298-300h": 1,
                "318-320h": 2,
                "322-324h": 1,
                "332-334h": 1,
                "334-336h": 1,
                "466-468h": 1,
                "540-542h": 1,
                "552-554h": 4,
                "1230-1232h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-12-02": 2,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-11": 1,
                "2025-12-12": 2,
                "2025-12-15": 3,
                "2025-12-19": 1,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2026-01-05": 4,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-17": 4,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 4
              },
              "time_per_day": {
                "2025-12-02": 280.2482136111111,
                "2025-12-04": 32.792865,
                "2025-12-05": 225.97870138888888,
                "2025-12-11": 322.55248,
                "2025-12-12": 667.6564361111111,
                "2025-12-15": 902.1376416666667,
                "2025-12-19": 466.32562916666666,
                "2025-12-23": 0.861728888888889,
                "2025-12-26": 553.8929947222222,
                "2026-01-05": 1665.2880847222223,
                "2026-01-13": 26.648840833333335,
                "2026-01-14": 7.837962500000001,
                "2026-01-17": 574.4905219444445,
                "2026-01-23": 277.6279488888889,
                "2026-01-26": 8.197226944444445,
                "2026-02-03": 2347.696373333333
              },
              "time_count_per_day": {
                "2025-12-02": 2,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-11": 1,
                "2025-12-12": 2,
                "2025-12-15": 3,
                "2025-12-19": 1,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2026-01-05": 4,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-17": 4,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 4
              }
            }
          }
        }
      }
    },
    "Catarina França": {
      "overall": {
        "avg_time_hours": 204.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 24,
        "time_distribution": {
          "0-2h": 24,
          "2-4h": 4,
          "4-6h": 10,
          "6-8h": 5,
          "8-10h": 1,
          "12-14h": 2,
          "18-20h": 6,
          "20-22h": 1,
          "22-24h": 3,
          "24-26h": 4,
          "26-28h": 6,
          "28-30h": 3,
          "30-32h": 3,
          "32-34h": 1,
          "34-36h": 2,
          "38-40h": 1,
          "42-44h": 2,
          "44-46h": 3,
          "46-48h": 1,
          "48-50h": 3,
          "50-52h": 2,
          "52-54h": 3,
          "54-56h": 5,
          "56-58h": 4,
          "58-60h": 1,
          "60-62h": 1,
          "70-72h": 1,
          "72-74h": 5,
          "74-76h": 1,
          "76-78h": 2,
          "78-80h": 1,
          "80-82h": 2,
          "82-84h": 1,
          "90-92h": 2,
          "92-94h": 1,
          "94-96h": 4,
          "96-98h": 2,
          "100-102h": 1,
          "102-104h": 1,
          "106-108h": 3,
          "114-116h": 3,
          "116-118h": 1,
          "118-120h": 2,
          "120-122h": 2,
          "122-124h": 2,
          "124-126h": 5,
          "126-128h": 3,
          "132-134h": 1,
          "134-136h": 1,
          "142-144h": 5,
          "144-146h": 5,
          "146-148h": 5,
          "148-150h": 2,
          "152-154h": 3,
          "160-162h": 2,
          "162-164h": 1,
          "166-168h": 4,
          "168-170h": 5,
          "174-176h": 2,
          "176-178h": 2,
          "178-180h": 3,
          "180-182h": 2,
          "182-184h": 1,
          "188-190h": 2,
          "190-192h": 2,
          "192-194h": 5,
          "196-198h": 3,
          "198-200h": 3,
          "202-204h": 1,
          "208-210h": 2,
          "210-212h": 1,
          "214-216h": 2,
          "216-218h": 2,
          "218-220h": 5,
          "220-222h": 1,
          "226-228h": 4,
          "228-230h": 1,
          "230-232h": 1,
          "234-236h": 1,
          "236-238h": 1,
          "240-242h": 1,
          "242-244h": 1,
          "244-246h": 1,
          "246-248h": 2,
          "248-250h": 3,
          "256-258h": 1,
          "262-264h": 1,
          "266-268h": 1,
          "268-270h": 1,
          "270-272h": 2,
          "272-274h": 1,
          "278-280h": 1,
          "284-286h": 1,
          "286-288h": 2,
          "288-290h": 2,
          "292-294h": 1,
          "308-310h": 5,
          "310-312h": 1,
          "314-316h": 1,
          "318-320h": 2,
          "320-322h": 2,
          "324-326h": 1,
          "332-334h": 1,
          "334-336h": 1,
          "336-338h": 2,
          "338-340h": 1,
          "344-346h": 1,
          "348-350h": 1,
          "354-356h": 1,
          "356-358h": 2,
          "360-362h": 1,
          "362-364h": 1,
          "366-368h": 1,
          "372-374h": 1,
          "374-376h": 1,
          "376-378h": 1,
          "380-382h": 2,
          "384-386h": 2,
          "386-388h": 1,
          "388-390h": 3,
          "392-394h": 1,
          "394-396h": 1,
          "396-398h": 1,
          "400-402h": 1,
          "404-406h": 2,
          "408-410h": 1,
          "410-412h": 2,
          "412-414h": 3,
          "414-416h": 2,
          "416-418h": 4,
          "418-420h": 1,
          "422-424h": 1,
          "428-430h": 1,
          "430-432h": 2,
          "432-434h": 1,
          "438-440h": 2,
          "440-442h": 1,
          "456-458h": 1,
          "458-460h": 1,
          "464-466h": 1,
          "472-474h": 1,
          "478-480h": 1,
          "482-484h": 1,
          "486-488h": 1,
          "488-490h": 1,
          "492-494h": 1,
          "494-496h": 1,
          "504-506h": 1,
          "506-508h": 1,
          "512-514h": 1,
          "514-516h": 2,
          "522-524h": 1,
          "526-528h": 1,
          "532-534h": 1,
          "536-538h": 1,
          "558-560h": 1,
          "574-576h": 2,
          "576-578h": 1,
          "578-580h": 1,
          "582-584h": 1,
          "614-616h": 2,
          "678-680h": 1,
          "824-826h": 1,
          "834-836h": 1,
          "846-848h": 1,
          "1028-1030h": 1,
          "1104-1106h": 1
        },
        "tickets_count": 345,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-01": 1,
          "2025-10-02": 1,
          "2025-10-03": 1,
          "2025-10-07": 4,
          "2025-10-10": 12,
          "2025-10-13": 2,
          "2025-10-14": 13,
          "2025-10-15": 7,
          "2025-10-16": 6,
          "2025-10-17": 1,
          "2025-10-22": 13,
          "2025-10-23": 8,
          "2025-10-24": 8,
          "2025-10-27": 13,
          "2025-10-28": 2,
          "2025-10-29": 2,
          "2025-10-30": 12,
          "2025-10-31": 6,
          "2025-11-03": 6,
          "2025-11-04": 4,
          "2025-11-05": 8,
          "2025-11-06": 16,
          "2025-11-07": 3,
          "2025-11-10": 6,
          "2025-11-11": 1,
          "2025-11-12": 9,
          "2025-11-13": 6,
          "2025-11-14": 4,
          "2025-11-17": 7,
          "2025-11-18": 1,
          "2025-11-19": 6,
          "2025-11-21": 12,
          "2025-11-22": 1,
          "2025-11-23": 10,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-27": 4,
          "2025-11-28": 4,
          "2025-11-29": 19,
          "2025-12-02": 17,
          "2025-12-03": 2,
          "2025-12-04": 7,
          "2025-12-05": 3,
          "2025-12-09": 4,
          "2025-12-10": 9,
          "2025-12-11": 8,
          "2025-12-12": 2,
          "2025-12-15": 3,
          "2025-12-16": 1,
          "2025-12-17": 5,
          "2025-12-19": 24
        },
        "time_per_day": {
          "2025-09-30": 5.250860555555556,
          "2025-10-01": 0.11571805555555555,
          "2025-10-02": 0.5968094444444445,
          "2025-10-03": 35.62733,
          "2025-10-07": 459.31242416666663,
          "2025-10-10": 754.2682230555556,
          "2025-10-13": 221.78032277777777,
          "2025-10-14": 2244.7919683333334,
          "2025-10-15": 399.70230972222225,
          "2025-10-16": 234.8553972222222,
          "2025-10-17": 48.729235277777775,
          "2025-10-22": 1005.4594863888889,
          "2025-10-23": 1198.5375488888888,
          "2025-10-24": 1639.0629544444446,
          "2025-10-27": 1863.9243969444444,
          "2025-10-28": 289.51996249999996,
          "2025-10-29": 651.2207227777778,
          "2025-10-30": 3252.322918888888,
          "2025-10-31": 449.7781061111112,
          "2025-11-03": 2396.8561200000004,
          "2025-11-04": 99.90165194444442,
          "2025-11-05": 2062.6726205555556,
          "2025-11-06": 3994.0069211111118,
          "2025-11-07": 14.921390277777778,
          "2025-11-10": 528.5042016666666,
          "2025-11-11": 147.5989952777778,
          "2025-11-12": 1559.0983091666667,
          "2025-11-13": 1943.7297225,
          "2025-11-14": 1694.0830422222225,
          "2025-11-17": 483.18692833333324,
          "2025-11-18": 287.6477113888889,
          "2025-11-19": 618.4016344444443,
          "2025-11-21": 1490.1549663888886,
          "2025-11-22": 94.43205333333333,
          "2025-11-23": 270.2120508333333,
          "2025-11-24": 3128.6994477777785,
          "2025-11-25": 717.0847005555554,
          "2025-11-27": 909.1785225,
          "2025-11-28": 792.9106933333334,
          "2025-11-29": 4640.729975833335,
          "2025-12-02": 4132.855905833333,
          "2025-12-03": 444.61606416666666,
          "2025-12-04": 1485.1995402777775,
          "2025-12-05": 1326.3139258333333,
          "2025-12-09": 994.1424816666666,
          "2025-12-10": 3010.6279936111114,
          "2025-12-11": 2446.514586944444,
          "2025-12-12": 1462.2775780555558,
          "2025-12-15": 950.4861247222223,
          "2025-12-16": 428.3155075,
          "2025-12-17": 2079.993994444444,
          "2025-12-19": 9213.498264166665
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-01": 1,
          "2025-10-02": 1,
          "2025-10-03": 1,
          "2025-10-07": 4,
          "2025-10-10": 12,
          "2025-10-13": 2,
          "2025-10-14": 13,
          "2025-10-15": 7,
          "2025-10-16": 6,
          "2025-10-17": 1,
          "2025-10-22": 13,
          "2025-10-23": 8,
          "2025-10-24": 8,
          "2025-10-27": 13,
          "2025-10-28": 2,
          "2025-10-29": 2,
          "2025-10-30": 12,
          "2025-10-31": 6,
          "2025-11-03": 6,
          "2025-11-04": 4,
          "2025-11-05": 8,
          "2025-11-06": 16,
          "2025-11-07": 3,
          "2025-11-10": 6,
          "2025-11-11": 1,
          "2025-11-12": 9,
          "2025-11-13": 6,
          "2025-11-14": 4,
          "2025-11-17": 7,
          "2025-11-18": 1,
          "2025-11-19": 6,
          "2025-11-21": 12,
          "2025-11-22": 1,
          "2025-11-23": 10,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-27": 4,
          "2025-11-28": 4,
          "2025-11-29": 19,
          "2025-12-02": 17,
          "2025-12-03": 2,
          "2025-12-04": 7,
          "2025-12-05": 3,
          "2025-12-09": 4,
          "2025-12-10": 9,
          "2025-12-11": 8,
          "2025-12-12": 2,
          "2025-12-15": 3,
          "2025-12-16": 1,
          "2025-12-17": 5,
          "2025-12-19": 24
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 78.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "22-24h": 1,
            "26-28h": 1,
            "132-134h": 1,
            "286-288h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-10": 1,
            "2025-10-16": 1,
            "2025-11-06": 1,
            "2025-11-18": 1,
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-10-01": 0.11571805555555555,
            "2025-10-10": 23.380275555555556,
            "2025-10-16": 0.7195861111111111,
            "2025-11-06": 27.529957777777778,
            "2025-11-18": 287.6477113888889,
            "2025-12-15": 133.2801411111111
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-10": 1,
            "2025-10-16": 1,
            "2025-11-06": 1,
            "2025-11-18": 1,
            "2025-12-15": 1
          }
        },
        "P2": {
          "avg_time_hours": 193.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 21,
          "time_distribution": {
            "0-2h": 21,
            "2-4h": 3,
            "4-6h": 7,
            "6-8h": 4,
            "12-14h": 1,
            "18-20h": 3,
            "22-24h": 2,
            "26-28h": 4,
            "28-30h": 2,
            "42-44h": 2,
            "44-46h": 1,
            "46-48h": 1,
            "48-50h": 2,
            "54-56h": 2,
            "70-72h": 1,
            "72-74h": 3,
            "74-76h": 1,
            "76-78h": 1,
            "78-80h": 1,
            "80-82h": 2,
            "94-96h": 2,
            "102-104h": 1,
            "114-116h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "124-126h": 1,
            "126-128h": 1,
            "142-144h": 2,
            "144-146h": 2,
            "146-148h": 4,
            "148-150h": 2,
            "160-162h": 1,
            "162-164h": 1,
            "166-168h": 4,
            "168-170h": 1,
            "180-182h": 2,
            "182-184h": 1,
            "188-190h": 2,
            "190-192h": 1,
            "198-200h": 1,
            "208-210h": 2,
            "214-216h": 2,
            "218-220h": 1,
            "226-228h": 3,
            "230-232h": 1,
            "236-238h": 1,
            "242-244h": 1,
            "246-248h": 1,
            "248-250h": 1,
            "268-270h": 1,
            "270-272h": 2,
            "278-280h": 1,
            "284-286h": 1,
            "288-290h": 2,
            "308-310h": 4,
            "318-320h": 1,
            "320-322h": 1,
            "324-326h": 1,
            "332-334h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "344-346h": 1,
            "356-358h": 1,
            "366-368h": 1,
            "374-376h": 1,
            "376-378h": 1,
            "380-382h": 2,
            "384-386h": 1,
            "388-390h": 2,
            "394-396h": 1,
            "396-398h": 1,
            "400-402h": 1,
            "404-406h": 1,
            "408-410h": 1,
            "412-414h": 3,
            "414-416h": 2,
            "416-418h": 1,
            "418-420h": 1,
            "422-424h": 1,
            "432-434h": 1,
            "438-440h": 2,
            "440-442h": 1,
            "472-474h": 1,
            "492-494h": 1,
            "506-508h": 1,
            "522-524h": 1,
            "526-528h": 1,
            "576-578h": 1,
            "578-580h": 1,
            "824-826h": 1,
            "834-836h": 1,
            "1028-1030h": 1
          },
          "tickets_count": 163,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2025-10-07": 3,
            "2025-10-10": 6,
            "2025-10-14": 7,
            "2025-10-15": 4,
            "2025-10-16": 5,
            "2025-10-22": 5,
            "2025-10-23": 6,
            "2025-10-24": 4,
            "2025-10-27": 8,
            "2025-10-28": 2,
            "2025-10-29": 1,
            "2025-10-30": 1,
            "2025-11-03": 4,
            "2025-11-04": 4,
            "2025-11-05": 4,
            "2025-11-06": 7,
            "2025-11-10": 4,
            "2025-11-12": 3,
            "2025-11-13": 1,
            "2025-11-14": 3,
            "2025-11-17": 7,
            "2025-11-19": 3,
            "2025-11-21": 3,
            "2025-11-23": 2,
            "2025-11-24": 7,
            "2025-11-25": 5,
            "2025-11-27": 2,
            "2025-11-28": 3,
            "2025-11-29": 1,
            "2025-12-02": 12,
            "2025-12-04": 2,
            "2025-12-09": 2,
            "2025-12-10": 4,
            "2025-12-11": 5,
            "2025-12-12": 2,
            "2025-12-15": 2,
            "2025-12-17": 5,
            "2025-12-19": 13
          },
          "time_per_day": {
            "2025-10-02": 0.5968094444444445,
            "2025-10-07": 315.99540138888887,
            "2025-10-10": 431.8993772222222,
            "2025-10-14": 1416.3919308333332,
            "2025-10-15": 191.889535,
            "2025-10-16": 234.13581111111108,
            "2025-10-22": 184.84544972222224,
            "2025-10-23": 997.5242397222222,
            "2025-10-24": 817.022993611111,
            "2025-10-27": 873.8582711111111,
            "2025-10-28": 289.51996249999996,
            "2025-10-29": 506.04429805555554,
            "2025-10-30": 144.65653555555556,
            "2025-11-03": 1825.0179791666667,
            "2025-11-04": 99.90165194444442,
            "2025-11-05": 1235.7838619444444,
            "2025-11-06": 1506.384471388889,
            "2025-11-10": 189.93571250000002,
            "2025-11-12": 109.4967063888889,
            "2025-11-13": 55.452886666666664,
            "2025-11-14": 847.233715,
            "2025-11-17": 483.18692833333324,
            "2025-11-19": 395.20618194444444,
            "2025-11-21": 277.0228716666667,
            "2025-11-23": 1.6453908333333334,
            "2025-11-24": 1112.148155,
            "2025-11-25": 423.43871888888884,
            "2025-11-27": 429.5985252777778,
            "2025-11-28": 444.1272988888889,
            "2025-11-29": 115.23021722222222,
            "2025-12-02": 2160.2984277777778,
            "2025-12-04": 878.3432222222222,
            "2025-12-09": 758.3590908333333,
            "2025-12-10": 1721.747153888889,
            "2025-12-11": 1071.1808472222222,
            "2025-12-12": 1462.2775780555558,
            "2025-12-15": 817.2059836111112,
            "2025-12-17": 2079.993994444444,
            "2025-12-19": 4680.805682222223
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2025-10-07": 3,
            "2025-10-10": 6,
            "2025-10-14": 7,
            "2025-10-15": 4,
            "2025-10-16": 5,
            "2025-10-22": 5,
            "2025-10-23": 6,
            "2025-10-24": 4,
            "2025-10-27": 8,
            "2025-10-28": 2,
            "2025-10-29": 1,
            "2025-10-30": 1,
            "2025-11-03": 4,
            "2025-11-04": 4,
            "2025-11-05": 4,
            "2025-11-06": 7,
            "2025-11-10": 4,
            "2025-11-12": 3,
            "2025-11-13": 1,
            "2025-11-14": 3,
            "2025-11-17": 7,
            "2025-11-19": 3,
            "2025-11-21": 3,
            "2025-11-23": 2,
            "2025-11-24": 7,
            "2025-11-25": 5,
            "2025-11-27": 2,
            "2025-11-28": 3,
            "2025-11-29": 1,
            "2025-12-02": 12,
            "2025-12-04": 2,
            "2025-12-09": 2,
            "2025-12-10": 4,
            "2025-12-11": 5,
            "2025-12-12": 2,
            "2025-12-15": 2,
            "2025-12-17": 5,
            "2025-12-19": 13
          }
        },
        "P3": {
          "avg_time_hours": 289.97,
          "mode_time_hours": 153.0,
          "mode_frequency": 3,
          "time_distribution": {
            "4-6h": 1,
            "18-20h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "34-36h": 1,
            "44-46h": 1,
            "58-60h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "116-118h": 1,
            "122-124h": 1,
            "124-126h": 3,
            "126-128h": 1,
            "142-144h": 1,
            "152-154h": 3,
            "174-176h": 1,
            "176-178h": 1,
            "178-180h": 1,
            "196-198h": 1,
            "216-218h": 1,
            "226-228h": 1,
            "234-236h": 1,
            "244-246h": 1,
            "256-258h": 1,
            "262-264h": 1,
            "266-268h": 1,
            "310-312h": 1,
            "314-316h": 1,
            "320-322h": 1,
            "336-338h": 1,
            "338-340h": 1,
            "348-350h": 1,
            "354-356h": 1,
            "356-358h": 1,
            "360-362h": 1,
            "386-388h": 1,
            "404-406h": 1,
            "410-412h": 1,
            "416-418h": 2,
            "430-432h": 1,
            "478-480h": 1,
            "488-490h": 1,
            "504-506h": 1,
            "512-514h": 1,
            "514-516h": 1,
            "532-534h": 1,
            "582-584h": 1,
            "678-680h": 1,
            "846-848h": 1,
            "1104-1106h": 1
          },
          "tickets_count": 55,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-03": 1,
            "2025-10-07": 1,
            "2025-10-13": 1,
            "2025-10-14": 5,
            "2025-10-15": 2,
            "2025-10-22": 1,
            "2025-10-24": 2,
            "2025-10-27": 1,
            "2025-10-30": 2,
            "2025-11-06": 2,
            "2025-11-14": 1,
            "2025-11-19": 3,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 3,
            "2025-11-27": 2,
            "2025-11-28": 1,
            "2025-11-29": 2,
            "2025-12-02": 5,
            "2025-12-03": 1,
            "2025-12-04": 3,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-19": 7
          },
          "time_per_day": {
            "2025-09-30": 5.250860555555556,
            "2025-10-03": 35.62733,
            "2025-10-07": 143.31702277777777,
            "2025-10-13": 125.40051416666667,
            "2025-10-14": 809.4708519444445,
            "2025-10-15": 162.16753472222223,
            "2025-10-22": 337.6833766666667,
            "2025-10-24": 606.6201288888889,
            "2025-10-27": 416.6074447222222,
            "2025-10-30": 1026.4851525,
            "2025-11-06": 738.6336227777778,
            "2025-11-14": 846.8493272222223,
            "2025-11-19": 223.19545250000002,
            "2025-11-21": 573.9154255555555,
            "2025-11-22": 94.43205333333333,
            "2025-11-24": 1354.4680480555555,
            "2025-11-27": 479.57999722222223,
            "2025-11-28": 348.7833944444444,
            "2025-11-29": 432.5672952777778,
            "2025-12-02": 1972.5574780555555,
            "2025-12-03": 310.17529388888886,
            "2025-12-04": 564.4077361111111,
            "2025-12-09": 92.30818805555556,
            "2025-12-10": 836.788506111111,
            "2025-12-11": 888.6611133333333,
            "2025-12-19": 2522.511980277777
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-03": 1,
            "2025-10-07": 1,
            "2025-10-13": 1,
            "2025-10-14": 5,
            "2025-10-15": 2,
            "2025-10-22": 1,
            "2025-10-24": 2,
            "2025-10-27": 1,
            "2025-10-30": 2,
            "2025-11-06": 2,
            "2025-11-14": 1,
            "2025-11-19": 3,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 3,
            "2025-11-27": 2,
            "2025-11-28": 1,
            "2025-11-29": 2,
            "2025-12-02": 5,
            "2025-12-03": 1,
            "2025-12-04": 3,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-19": 7
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 164.44,
          "mode_time_hours": 193.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 1,
            "8-10h": 1,
            "12-14h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "24-26h": 4,
            "30-32h": 3,
            "32-34h": 1,
            "34-36h": 1,
            "38-40h": 1,
            "44-46h": 1,
            "48-50h": 1,
            "50-52h": 2,
            "52-54h": 3,
            "54-56h": 3,
            "56-58h": 4,
            "60-62h": 1,
            "72-74h": 2,
            "76-78h": 1,
            "82-84h": 1,
            "90-92h": 2,
            "94-96h": 1,
            "96-98h": 2,
            "100-102h": 1,
            "106-108h": 3,
            "114-116h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 1,
            "124-126h": 1,
            "126-128h": 1,
            "142-144h": 2,
            "144-146h": 3,
            "146-148h": 1,
            "160-162h": 1,
            "168-170h": 2,
            "174-176h": 1,
            "176-178h": 1,
            "178-180h": 2,
            "190-192h": 1,
            "192-194h": 5,
            "196-198h": 2,
            "198-200h": 2,
            "202-204h": 1,
            "210-212h": 1,
            "216-218h": 1,
            "218-220h": 4,
            "220-222h": 1,
            "228-230h": 1,
            "240-242h": 1,
            "246-248h": 1,
            "248-250h": 2,
            "272-274h": 1,
            "286-288h": 1,
            "292-294h": 1,
            "308-310h": 1,
            "318-320h": 1,
            "372-374h": 1,
            "384-386h": 1,
            "388-390h": 1,
            "392-394h": 1,
            "416-418h": 1,
            "456-458h": 1,
            "458-460h": 1,
            "464-466h": 1,
            "494-496h": 1,
            "536-538h": 1,
            "574-576h": 1,
            "614-616h": 2
          },
          "tickets_count": 108,
          "tickets_per_day": {
            "2025-10-10": 5,
            "2025-10-13": 1,
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-22": 7,
            "2025-10-23": 2,
            "2025-10-24": 2,
            "2025-10-27": 4,
            "2025-10-29": 1,
            "2025-10-30": 9,
            "2025-10-31": 6,
            "2025-11-03": 2,
            "2025-11-05": 4,
            "2025-11-06": 6,
            "2025-11-07": 3,
            "2025-11-10": 2,
            "2025-11-11": 1,
            "2025-11-12": 6,
            "2025-11-13": 5,
            "2025-11-21": 7,
            "2025-11-23": 8,
            "2025-11-24": 4,
            "2025-11-25": 1,
            "2025-11-29": 16,
            "2025-12-04": 2,
            "2025-12-09": 1
          },
          "time_per_day": {
            "2025-10-10": 298.98857027777774,
            "2025-10-13": 96.3798086111111,
            "2025-10-14": 18.929185555555556,
            "2025-10-15": 45.64524,
            "2025-10-17": 48.729235277777775,
            "2025-10-22": 482.93066,
            "2025-10-23": 201.0133091666667,
            "2025-10-24": 215.41983194444444,
            "2025-10-27": 573.4586811111111,
            "2025-10-29": 145.17642472222224,
            "2025-10-30": 2081.1812308333333,
            "2025-10-31": 449.7781061111112,
            "2025-11-03": 571.8381408333333,
            "2025-11-05": 826.888758611111,
            "2025-11-06": 1721.4588691666668,
            "2025-11-07": 14.921390277777778,
            "2025-11-10": 338.56848916666667,
            "2025-11-11": 147.5989952777778,
            "2025-11-12": 1449.6016027777775,
            "2025-11-13": 1888.2768358333333,
            "2025-11-21": 639.2166691666667,
            "2025-11-23": 268.56666,
            "2025-11-24": 662.0832447222223,
            "2025-11-25": 293.64598166666667,
            "2025-11-29": 4092.932463333334,
            "2025-12-04": 42.44858194444444,
            "2025-12-09": 143.47520277777778
          },
          "time_count_per_day": {
            "2025-10-10": 5,
            "2025-10-13": 1,
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-22": 7,
            "2025-10-23": 2,
            "2025-10-24": 2,
            "2025-10-27": 4,
            "2025-10-29": 1,
            "2025-10-30": 9,
            "2025-10-31": 6,
            "2025-11-03": 2,
            "2025-11-05": 4,
            "2025-11-06": 6,
            "2025-11-07": 3,
            "2025-11-10": 2,
            "2025-11-11": 1,
            "2025-11-12": 6,
            "2025-11-13": 5,
            "2025-11-21": 7,
            "2025-11-23": 8,
            "2025-11-24": 4,
            "2025-11-25": 1,
            "2025-11-29": 16,
            "2025-12-04": 2,
            "2025-12-09": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 372.16,
          "mode_time_hours": 169.0,
          "mode_frequency": 2,
          "time_distribution": {
            "114-116h": 1,
            "134-136h": 1,
            "168-170h": 2,
            "362-364h": 1,
            "410-412h": 1,
            "428-430h": 1,
            "430-432h": 1,
            "482-484h": 1,
            "486-488h": 1,
            "514-516h": 1,
            "558-560h": 1,
            "574-576h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 3,
            "2025-12-10": 3,
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-19": 4
          },
          "time_per_day": {
            "2025-12-03": 134.44077027777777,
            "2025-12-05": 1326.3139258333333,
            "2025-12-10": 452.0923336111111,
            "2025-12-11": 486.6726263888889,
            "2025-12-16": 428.3155075,
            "2025-12-19": 2010.1806016666667
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 3,
            "2025-12-10": 3,
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-19": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 204.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 24,
            "time_distribution": {
              "0-2h": 24,
              "2-4h": 4,
              "4-6h": 10,
              "6-8h": 5,
              "8-10h": 1,
              "12-14h": 2,
              "18-20h": 6,
              "20-22h": 1,
              "22-24h": 3,
              "24-26h": 4,
              "26-28h": 6,
              "28-30h": 3,
              "30-32h": 3,
              "32-34h": 1,
              "34-36h": 2,
              "38-40h": 1,
              "42-44h": 2,
              "44-46h": 3,
              "46-48h": 1,
              "48-50h": 3,
              "50-52h": 2,
              "52-54h": 3,
              "54-56h": 5,
              "56-58h": 4,
              "58-60h": 1,
              "60-62h": 1,
              "70-72h": 1,
              "72-74h": 5,
              "74-76h": 1,
              "76-78h": 2,
              "78-80h": 1,
              "80-82h": 2,
              "82-84h": 1,
              "90-92h": 2,
              "92-94h": 1,
              "94-96h": 4,
              "96-98h": 2,
              "100-102h": 1,
              "102-104h": 1,
              "106-108h": 3,
              "114-116h": 3,
              "116-118h": 1,
              "118-120h": 2,
              "120-122h": 2,
              "122-124h": 2,
              "124-126h": 5,
              "126-128h": 3,
              "132-134h": 1,
              "134-136h": 1,
              "142-144h": 5,
              "144-146h": 5,
              "146-148h": 5,
              "148-150h": 2,
              "152-154h": 3,
              "160-162h": 2,
              "162-164h": 1,
              "166-168h": 4,
              "168-170h": 5,
              "174-176h": 2,
              "176-178h": 2,
              "178-180h": 3,
              "180-182h": 2,
              "182-184h": 1,
              "188-190h": 2,
              "190-192h": 2,
              "192-194h": 5,
              "196-198h": 3,
              "198-200h": 3,
              "202-204h": 1,
              "208-210h": 2,
              "210-212h": 1,
              "214-216h": 2,
              "216-218h": 2,
              "218-220h": 5,
              "220-222h": 1,
              "226-228h": 4,
              "228-230h": 1,
              "230-232h": 1,
              "234-236h": 1,
              "236-238h": 1,
              "240-242h": 1,
              "242-244h": 1,
              "244-246h": 1,
              "246-248h": 2,
              "248-250h": 3,
              "256-258h": 1,
              "262-264h": 1,
              "266-268h": 1,
              "268-270h": 1,
              "270-272h": 2,
              "272-274h": 1,
              "278-280h": 1,
              "284-286h": 1,
              "286-288h": 2,
              "288-290h": 2,
              "292-294h": 1,
              "308-310h": 5,
              "310-312h": 1,
              "314-316h": 1,
              "318-320h": 2,
              "320-322h": 2,
              "324-326h": 1,
              "332-334h": 1,
              "334-336h": 1,
              "336-338h": 2,
              "338-340h": 1,
              "344-346h": 1,
              "348-350h": 1,
              "354-356h": 1,
              "356-358h": 2,
              "360-362h": 1,
              "362-364h": 1,
              "366-368h": 1,
              "372-374h": 1,
              "374-376h": 1,
              "376-378h": 1,
              "380-382h": 2,
              "384-386h": 2,
              "386-388h": 1,
              "388-390h": 3,
              "392-394h": 1,
              "394-396h": 1,
              "396-398h": 1,
              "400-402h": 1,
              "404-406h": 2,
              "408-410h": 1,
              "410-412h": 2,
              "412-414h": 3,
              "414-416h": 2,
              "416-418h": 4,
              "418-420h": 1,
              "422-424h": 1,
              "428-430h": 1,
              "430-432h": 2,
              "432-434h": 1,
              "438-440h": 2,
              "440-442h": 1,
              "456-458h": 1,
              "458-460h": 1,
              "464-466h": 1,
              "472-474h": 1,
              "478-480h": 1,
              "482-484h": 1,
              "486-488h": 1,
              "488-490h": 1,
              "492-494h": 1,
              "494-496h": 1,
              "504-506h": 1,
              "506-508h": 1,
              "512-514h": 1,
              "514-516h": 2,
              "522-524h": 1,
              "526-528h": 1,
              "532-534h": 1,
              "536-538h": 1,
              "558-560h": 1,
              "574-576h": 2,
              "576-578h": 1,
              "578-580h": 1,
              "582-584h": 1,
              "614-616h": 2,
              "678-680h": 1,
              "824-826h": 1,
              "834-836h": 1,
              "846-848h": 1,
              "1028-1030h": 1,
              "1104-1106h": 1
            },
            "tickets_count": 345,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-01": 1,
              "2025-10-02": 1,
              "2025-10-03": 1,
              "2025-10-07": 4,
              "2025-10-10": 12,
              "2025-10-13": 2,
              "2025-10-14": 13,
              "2025-10-15": 7,
              "2025-10-16": 6,
              "2025-10-17": 1,
              "2025-10-22": 13,
              "2025-10-23": 8,
              "2025-10-24": 8,
              "2025-10-27": 13,
              "2025-10-28": 2,
              "2025-10-29": 2,
              "2025-10-30": 12,
              "2025-10-31": 6,
              "2025-11-03": 6,
              "2025-11-04": 4,
              "2025-11-05": 8,
              "2025-11-06": 16,
              "2025-11-07": 3,
              "2025-11-10": 6,
              "2025-11-11": 1,
              "2025-11-12": 9,
              "2025-11-13": 6,
              "2025-11-14": 4,
              "2025-11-17": 7,
              "2025-11-18": 1,
              "2025-11-19": 6,
              "2025-11-21": 12,
              "2025-11-22": 1,
              "2025-11-23": 10,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-27": 4,
              "2025-11-28": 4,
              "2025-11-29": 19,
              "2025-12-02": 17,
              "2025-12-03": 2,
              "2025-12-04": 7,
              "2025-12-05": 3,
              "2025-12-09": 4,
              "2025-12-10": 9,
              "2025-12-11": 8,
              "2025-12-12": 2,
              "2025-12-15": 3,
              "2025-12-16": 1,
              "2025-12-17": 5,
              "2025-12-19": 24
            },
            "time_per_day": {
              "2025-09-30": 5.250860555555556,
              "2025-10-01": 0.11571805555555555,
              "2025-10-02": 0.5968094444444445,
              "2025-10-03": 35.62733,
              "2025-10-07": 459.31242416666663,
              "2025-10-10": 754.2682230555556,
              "2025-10-13": 221.78032277777777,
              "2025-10-14": 2244.7919683333334,
              "2025-10-15": 399.70230972222225,
              "2025-10-16": 234.8553972222222,
              "2025-10-17": 48.729235277777775,
              "2025-10-22": 1005.4594863888889,
              "2025-10-23": 1198.5375488888888,
              "2025-10-24": 1639.0629544444446,
              "2025-10-27": 1863.9243969444444,
              "2025-10-28": 289.51996249999996,
              "2025-10-29": 651.2207227777778,
              "2025-10-30": 3252.322918888888,
              "2025-10-31": 449.7781061111112,
              "2025-11-03": 2396.8561200000004,
              "2025-11-04": 99.90165194444442,
              "2025-11-05": 2062.6726205555556,
              "2025-11-06": 3994.0069211111118,
              "2025-11-07": 14.921390277777778,
              "2025-11-10": 528.5042016666666,
              "2025-11-11": 147.5989952777778,
              "2025-11-12": 1559.0983091666667,
              "2025-11-13": 1943.7297225,
              "2025-11-14": 1694.0830422222225,
              "2025-11-17": 483.18692833333324,
              "2025-11-18": 287.6477113888889,
              "2025-11-19": 618.4016344444443,
              "2025-11-21": 1490.1549663888886,
              "2025-11-22": 94.43205333333333,
              "2025-11-23": 270.2120508333333,
              "2025-11-24": 3128.6994477777785,
              "2025-11-25": 717.0847005555554,
              "2025-11-27": 909.1785225,
              "2025-11-28": 792.9106933333334,
              "2025-11-29": 4640.729975833335,
              "2025-12-02": 4132.855905833333,
              "2025-12-03": 444.61606416666666,
              "2025-12-04": 1485.1995402777775,
              "2025-12-05": 1326.3139258333333,
              "2025-12-09": 994.1424816666666,
              "2025-12-10": 3010.6279936111114,
              "2025-12-11": 2446.514586944444,
              "2025-12-12": 1462.2775780555558,
              "2025-12-15": 950.4861247222223,
              "2025-12-16": 428.3155075,
              "2025-12-17": 2079.993994444444,
              "2025-12-19": 9213.498264166665
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-01": 1,
              "2025-10-02": 1,
              "2025-10-03": 1,
              "2025-10-07": 4,
              "2025-10-10": 12,
              "2025-10-13": 2,
              "2025-10-14": 13,
              "2025-10-15": 7,
              "2025-10-16": 6,
              "2025-10-17": 1,
              "2025-10-22": 13,
              "2025-10-23": 8,
              "2025-10-24": 8,
              "2025-10-27": 13,
              "2025-10-28": 2,
              "2025-10-29": 2,
              "2025-10-30": 12,
              "2025-10-31": 6,
              "2025-11-03": 6,
              "2025-11-04": 4,
              "2025-11-05": 8,
              "2025-11-06": 16,
              "2025-11-07": 3,
              "2025-11-10": 6,
              "2025-11-11": 1,
              "2025-11-12": 9,
              "2025-11-13": 6,
              "2025-11-14": 4,
              "2025-11-17": 7,
              "2025-11-18": 1,
              "2025-11-19": 6,
              "2025-11-21": 12,
              "2025-11-22": 1,
              "2025-11-23": 10,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-27": 4,
              "2025-11-28": 4,
              "2025-11-29": 19,
              "2025-12-02": 17,
              "2025-12-03": 2,
              "2025-12-04": 7,
              "2025-12-05": 3,
              "2025-12-09": 4,
              "2025-12-10": 9,
              "2025-12-11": 8,
              "2025-12-12": 2,
              "2025-12-15": 3,
              "2025-12-16": 1,
              "2025-12-17": 5,
              "2025-12-19": 24
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 78.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "22-24h": 1,
                "26-28h": 1,
                "132-134h": 1,
                "286-288h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-10": 1,
                "2025-10-16": 1,
                "2025-11-06": 1,
                "2025-11-18": 1,
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-10-01": 0.11571805555555555,
                "2025-10-10": 23.380275555555556,
                "2025-10-16": 0.7195861111111111,
                "2025-11-06": 27.529957777777778,
                "2025-11-18": 287.6477113888889,
                "2025-12-15": 133.2801411111111
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-10": 1,
                "2025-10-16": 1,
                "2025-11-06": 1,
                "2025-11-18": 1,
                "2025-12-15": 1
              }
            },
            "P2": {
              "avg_time_hours": 193.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 21,
              "time_distribution": {
                "0-2h": 21,
                "2-4h": 3,
                "4-6h": 7,
                "6-8h": 4,
                "12-14h": 1,
                "18-20h": 3,
                "22-24h": 2,
                "26-28h": 4,
                "28-30h": 2,
                "42-44h": 2,
                "44-46h": 1,
                "46-48h": 1,
                "48-50h": 2,
                "54-56h": 2,
                "70-72h": 1,
                "72-74h": 3,
                "74-76h": 1,
                "76-78h": 1,
                "78-80h": 1,
                "80-82h": 2,
                "94-96h": 2,
                "102-104h": 1,
                "114-116h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "124-126h": 1,
                "126-128h": 1,
                "142-144h": 2,
                "144-146h": 2,
                "146-148h": 4,
                "148-150h": 2,
                "160-162h": 1,
                "162-164h": 1,
                "166-168h": 4,
                "168-170h": 1,
                "180-182h": 2,
                "182-184h": 1,
                "188-190h": 2,
                "190-192h": 1,
                "198-200h": 1,
                "208-210h": 2,
                "214-216h": 2,
                "218-220h": 1,
                "226-228h": 3,
                "230-232h": 1,
                "236-238h": 1,
                "242-244h": 1,
                "246-248h": 1,
                "248-250h": 1,
                "268-270h": 1,
                "270-272h": 2,
                "278-280h": 1,
                "284-286h": 1,
                "288-290h": 2,
                "308-310h": 4,
                "318-320h": 1,
                "320-322h": 1,
                "324-326h": 1,
                "332-334h": 1,
                "334-336h": 1,
                "336-338h": 1,
                "344-346h": 1,
                "356-358h": 1,
                "366-368h": 1,
                "374-376h": 1,
                "376-378h": 1,
                "380-382h": 2,
                "384-386h": 1,
                "388-390h": 2,
                "394-396h": 1,
                "396-398h": 1,
                "400-402h": 1,
                "404-406h": 1,
                "408-410h": 1,
                "412-414h": 3,
                "414-416h": 2,
                "416-418h": 1,
                "418-420h": 1,
                "422-424h": 1,
                "432-434h": 1,
                "438-440h": 2,
                "440-442h": 1,
                "472-474h": 1,
                "492-494h": 1,
                "506-508h": 1,
                "522-524h": 1,
                "526-528h": 1,
                "576-578h": 1,
                "578-580h": 1,
                "824-826h": 1,
                "834-836h": 1,
                "1028-1030h": 1
              },
              "tickets_count": 163,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2025-10-07": 3,
                "2025-10-10": 6,
                "2025-10-14": 7,
                "2025-10-15": 4,
                "2025-10-16": 5,
                "2025-10-22": 5,
                "2025-10-23": 6,
                "2025-10-24": 4,
                "2025-10-27": 8,
                "2025-10-28": 2,
                "2025-10-29": 1,
                "2025-10-30": 1,
                "2025-11-03": 4,
                "2025-11-04": 4,
                "2025-11-05": 4,
                "2025-11-06": 7,
                "2025-11-10": 4,
                "2025-11-12": 3,
                "2025-11-13": 1,
                "2025-11-14": 3,
                "2025-11-17": 7,
                "2025-11-19": 3,
                "2025-11-21": 3,
                "2025-11-23": 2,
                "2025-11-24": 7,
                "2025-11-25": 5,
                "2025-11-27": 2,
                "2025-11-28": 3,
                "2025-11-29": 1,
                "2025-12-02": 12,
                "2025-12-04": 2,
                "2025-12-09": 2,
                "2025-12-10": 4,
                "2025-12-11": 5,
                "2025-12-12": 2,
                "2025-12-15": 2,
                "2025-12-17": 5,
                "2025-12-19": 13
              },
              "time_per_day": {
                "2025-10-02": 0.5968094444444445,
                "2025-10-07": 315.99540138888887,
                "2025-10-10": 431.8993772222222,
                "2025-10-14": 1416.3919308333332,
                "2025-10-15": 191.889535,
                "2025-10-16": 234.13581111111108,
                "2025-10-22": 184.84544972222224,
                "2025-10-23": 997.5242397222222,
                "2025-10-24": 817.022993611111,
                "2025-10-27": 873.8582711111111,
                "2025-10-28": 289.51996249999996,
                "2025-10-29": 506.04429805555554,
                "2025-10-30": 144.65653555555556,
                "2025-11-03": 1825.0179791666667,
                "2025-11-04": 99.90165194444442,
                "2025-11-05": 1235.7838619444444,
                "2025-11-06": 1506.384471388889,
                "2025-11-10": 189.93571250000002,
                "2025-11-12": 109.4967063888889,
                "2025-11-13": 55.452886666666664,
                "2025-11-14": 847.233715,
                "2025-11-17": 483.18692833333324,
                "2025-11-19": 395.20618194444444,
                "2025-11-21": 277.0228716666667,
                "2025-11-23": 1.6453908333333334,
                "2025-11-24": 1112.148155,
                "2025-11-25": 423.43871888888884,
                "2025-11-27": 429.5985252777778,
                "2025-11-28": 444.1272988888889,
                "2025-11-29": 115.23021722222222,
                "2025-12-02": 2160.2984277777778,
                "2025-12-04": 878.3432222222222,
                "2025-12-09": 758.3590908333333,
                "2025-12-10": 1721.747153888889,
                "2025-12-11": 1071.1808472222222,
                "2025-12-12": 1462.2775780555558,
                "2025-12-15": 817.2059836111112,
                "2025-12-17": 2079.993994444444,
                "2025-12-19": 4680.805682222223
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2025-10-07": 3,
                "2025-10-10": 6,
                "2025-10-14": 7,
                "2025-10-15": 4,
                "2025-10-16": 5,
                "2025-10-22": 5,
                "2025-10-23": 6,
                "2025-10-24": 4,
                "2025-10-27": 8,
                "2025-10-28": 2,
                "2025-10-29": 1,
                "2025-10-30": 1,
                "2025-11-03": 4,
                "2025-11-04": 4,
                "2025-11-05": 4,
                "2025-11-06": 7,
                "2025-11-10": 4,
                "2025-11-12": 3,
                "2025-11-13": 1,
                "2025-11-14": 3,
                "2025-11-17": 7,
                "2025-11-19": 3,
                "2025-11-21": 3,
                "2025-11-23": 2,
                "2025-11-24": 7,
                "2025-11-25": 5,
                "2025-11-27": 2,
                "2025-11-28": 3,
                "2025-11-29": 1,
                "2025-12-02": 12,
                "2025-12-04": 2,
                "2025-12-09": 2,
                "2025-12-10": 4,
                "2025-12-11": 5,
                "2025-12-12": 2,
                "2025-12-15": 2,
                "2025-12-17": 5,
                "2025-12-19": 13
              }
            },
            "P3": {
              "avg_time_hours": 289.97,
              "mode_time_hours": 153.0,
              "mode_frequency": 3,
              "time_distribution": {
                "4-6h": 1,
                "18-20h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "34-36h": 1,
                "44-46h": 1,
                "58-60h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "116-118h": 1,
                "122-124h": 1,
                "124-126h": 3,
                "126-128h": 1,
                "142-144h": 1,
                "152-154h": 3,
                "174-176h": 1,
                "176-178h": 1,
                "178-180h": 1,
                "196-198h": 1,
                "216-218h": 1,
                "226-228h": 1,
                "234-236h": 1,
                "244-246h": 1,
                "256-258h": 1,
                "262-264h": 1,
                "266-268h": 1,
                "310-312h": 1,
                "314-316h": 1,
                "320-322h": 1,
                "336-338h": 1,
                "338-340h": 1,
                "348-350h": 1,
                "354-356h": 1,
                "356-358h": 1,
                "360-362h": 1,
                "386-388h": 1,
                "404-406h": 1,
                "410-412h": 1,
                "416-418h": 2,
                "430-432h": 1,
                "478-480h": 1,
                "488-490h": 1,
                "504-506h": 1,
                "512-514h": 1,
                "514-516h": 1,
                "532-534h": 1,
                "582-584h": 1,
                "678-680h": 1,
                "846-848h": 1,
                "1104-1106h": 1
              },
              "tickets_count": 55,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-03": 1,
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-14": 5,
                "2025-10-15": 2,
                "2025-10-22": 1,
                "2025-10-24": 2,
                "2025-10-27": 1,
                "2025-10-30": 2,
                "2025-11-06": 2,
                "2025-11-14": 1,
                "2025-11-19": 3,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 3,
                "2025-11-27": 2,
                "2025-11-28": 1,
                "2025-11-29": 2,
                "2025-12-02": 5,
                "2025-12-03": 1,
                "2025-12-04": 3,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-11": 2,
                "2025-12-19": 7
              },
              "time_per_day": {
                "2025-09-30": 5.250860555555556,
                "2025-10-03": 35.62733,
                "2025-10-07": 143.31702277777777,
                "2025-10-13": 125.40051416666667,
                "2025-10-14": 809.4708519444445,
                "2025-10-15": 162.16753472222223,
                "2025-10-22": 337.6833766666667,
                "2025-10-24": 606.6201288888889,
                "2025-10-27": 416.6074447222222,
                "2025-10-30": 1026.4851525,
                "2025-11-06": 738.6336227777778,
                "2025-11-14": 846.8493272222223,
                "2025-11-19": 223.19545250000002,
                "2025-11-21": 573.9154255555555,
                "2025-11-22": 94.43205333333333,
                "2025-11-24": 1354.4680480555555,
                "2025-11-27": 479.57999722222223,
                "2025-11-28": 348.7833944444444,
                "2025-11-29": 432.5672952777778,
                "2025-12-02": 1972.5574780555555,
                "2025-12-03": 310.17529388888886,
                "2025-12-04": 564.4077361111111,
                "2025-12-09": 92.30818805555556,
                "2025-12-10": 836.788506111111,
                "2025-12-11": 888.6611133333333,
                "2025-12-19": 2522.511980277777
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-03": 1,
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-14": 5,
                "2025-10-15": 2,
                "2025-10-22": 1,
                "2025-10-24": 2,
                "2025-10-27": 1,
                "2025-10-30": 2,
                "2025-11-06": 2,
                "2025-11-14": 1,
                "2025-11-19": 3,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 3,
                "2025-11-27": 2,
                "2025-11-28": 1,
                "2025-11-29": 2,
                "2025-12-02": 5,
                "2025-12-03": 1,
                "2025-12-04": 3,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-11": 2,
                "2025-12-19": 7
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 164.44,
              "mode_time_hours": 193.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 1,
                "8-10h": 1,
                "12-14h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "24-26h": 4,
                "30-32h": 3,
                "32-34h": 1,
                "34-36h": 1,
                "38-40h": 1,
                "44-46h": 1,
                "48-50h": 1,
                "50-52h": 2,
                "52-54h": 3,
                "54-56h": 3,
                "56-58h": 4,
                "60-62h": 1,
                "72-74h": 2,
                "76-78h": 1,
                "82-84h": 1,
                "90-92h": 2,
                "94-96h": 1,
                "96-98h": 2,
                "100-102h": 1,
                "106-108h": 3,
                "114-116h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "122-124h": 1,
                "124-126h": 1,
                "126-128h": 1,
                "142-144h": 2,
                "144-146h": 3,
                "146-148h": 1,
                "160-162h": 1,
                "168-170h": 2,
                "174-176h": 1,
                "176-178h": 1,
                "178-180h": 2,
                "190-192h": 1,
                "192-194h": 5,
                "196-198h": 2,
                "198-200h": 2,
                "202-204h": 1,
                "210-212h": 1,
                "216-218h": 1,
                "218-220h": 4,
                "220-222h": 1,
                "228-230h": 1,
                "240-242h": 1,
                "246-248h": 1,
                "248-250h": 2,
                "272-274h": 1,
                "286-288h": 1,
                "292-294h": 1,
                "308-310h": 1,
                "318-320h": 1,
                "372-374h": 1,
                "384-386h": 1,
                "388-390h": 1,
                "392-394h": 1,
                "416-418h": 1,
                "456-458h": 1,
                "458-460h": 1,
                "464-466h": 1,
                "494-496h": 1,
                "536-538h": 1,
                "574-576h": 1,
                "614-616h": 2
              },
              "tickets_count": 108,
              "tickets_per_day": {
                "2025-10-10": 5,
                "2025-10-13": 1,
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-22": 7,
                "2025-10-23": 2,
                "2025-10-24": 2,
                "2025-10-27": 4,
                "2025-10-29": 1,
                "2025-10-30": 9,
                "2025-10-31": 6,
                "2025-11-03": 2,
                "2025-11-05": 4,
                "2025-11-06": 6,
                "2025-11-07": 3,
                "2025-11-10": 2,
                "2025-11-11": 1,
                "2025-11-12": 6,
                "2025-11-13": 5,
                "2025-11-21": 7,
                "2025-11-23": 8,
                "2025-11-24": 4,
                "2025-11-25": 1,
                "2025-11-29": 16,
                "2025-12-04": 2,
                "2025-12-09": 1
              },
              "time_per_day": {
                "2025-10-10": 298.98857027777774,
                "2025-10-13": 96.3798086111111,
                "2025-10-14": 18.929185555555556,
                "2025-10-15": 45.64524,
                "2025-10-17": 48.729235277777775,
                "2025-10-22": 482.93066,
                "2025-10-23": 201.0133091666667,
                "2025-10-24": 215.41983194444444,
                "2025-10-27": 573.4586811111111,
                "2025-10-29": 145.17642472222224,
                "2025-10-30": 2081.1812308333333,
                "2025-10-31": 449.7781061111112,
                "2025-11-03": 571.8381408333333,
                "2025-11-05": 826.888758611111,
                "2025-11-06": 1721.4588691666668,
                "2025-11-07": 14.921390277777778,
                "2025-11-10": 338.56848916666667,
                "2025-11-11": 147.5989952777778,
                "2025-11-12": 1449.6016027777775,
                "2025-11-13": 1888.2768358333333,
                "2025-11-21": 639.2166691666667,
                "2025-11-23": 268.56666,
                "2025-11-24": 662.0832447222223,
                "2025-11-25": 293.64598166666667,
                "2025-11-29": 4092.932463333334,
                "2025-12-04": 42.44858194444444,
                "2025-12-09": 143.47520277777778
              },
              "time_count_per_day": {
                "2025-10-10": 5,
                "2025-10-13": 1,
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-22": 7,
                "2025-10-23": 2,
                "2025-10-24": 2,
                "2025-10-27": 4,
                "2025-10-29": 1,
                "2025-10-30": 9,
                "2025-10-31": 6,
                "2025-11-03": 2,
                "2025-11-05": 4,
                "2025-11-06": 6,
                "2025-11-07": 3,
                "2025-11-10": 2,
                "2025-11-11": 1,
                "2025-11-12": 6,
                "2025-11-13": 5,
                "2025-11-21": 7,
                "2025-11-23": 8,
                "2025-11-24": 4,
                "2025-11-25": 1,
                "2025-11-29": 16,
                "2025-12-04": 2,
                "2025-12-09": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 372.16,
              "mode_time_hours": 169.0,
              "mode_frequency": 2,
              "time_distribution": {
                "114-116h": 1,
                "134-136h": 1,
                "168-170h": 2,
                "362-364h": 1,
                "410-412h": 1,
                "428-430h": 1,
                "430-432h": 1,
                "482-484h": 1,
                "486-488h": 1,
                "514-516h": 1,
                "558-560h": 1,
                "574-576h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 3,
                "2025-12-10": 3,
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-19": 4
              },
              "time_per_day": {
                "2025-12-03": 134.44077027777777,
                "2025-12-05": 1326.3139258333333,
                "2025-12-10": 452.0923336111111,
                "2025-12-11": 486.6726263888889,
                "2025-12-16": 428.3155075,
                "2025-12-19": 2010.1806016666667
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 3,
                "2025-12-10": 3,
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-19": 4
              }
            }
          }
        }
      }
    },
    "Paula Candeias": {
      "overall": {
        "avg_time_hours": 142.89,
        "mode_time_hours": 1.0,
        "mode_frequency": 29,
        "time_distribution": {
          "0-2h": 29,
          "2-4h": 16,
          "4-6h": 13,
          "6-8h": 8,
          "8-10h": 3,
          "10-12h": 1,
          "12-14h": 2,
          "14-16h": 1,
          "16-18h": 11,
          "18-20h": 4,
          "20-22h": 3,
          "22-24h": 7,
          "24-26h": 5,
          "26-28h": 3,
          "28-30h": 2,
          "30-32h": 2,
          "32-34h": 3,
          "34-36h": 2,
          "40-42h": 1,
          "42-44h": 1,
          "44-46h": 7,
          "46-48h": 1,
          "48-50h": 3,
          "52-54h": 4,
          "54-56h": 3,
          "64-66h": 3,
          "66-68h": 4,
          "68-70h": 7,
          "70-72h": 5,
          "72-74h": 4,
          "74-76h": 3,
          "76-78h": 4,
          "80-82h": 4,
          "82-84h": 2,
          "92-94h": 2,
          "94-96h": 2,
          "96-98h": 4,
          "98-100h": 3,
          "100-102h": 2,
          "104-106h": 1,
          "112-114h": 1,
          "116-118h": 3,
          "118-120h": 3,
          "120-122h": 1,
          "122-124h": 2,
          "124-126h": 2,
          "126-128h": 2,
          "130-132h": 1,
          "134-136h": 1,
          "136-138h": 2,
          "140-142h": 2,
          "142-144h": 2,
          "144-146h": 3,
          "146-148h": 2,
          "148-150h": 2,
          "152-154h": 3,
          "158-160h": 2,
          "160-162h": 5,
          "162-164h": 2,
          "164-166h": 4,
          "166-168h": 3,
          "168-170h": 1,
          "170-172h": 1,
          "172-174h": 1,
          "174-176h": 1,
          "186-188h": 2,
          "188-190h": 2,
          "190-192h": 1,
          "192-194h": 2,
          "198-200h": 1,
          "212-214h": 1,
          "216-218h": 1,
          "218-220h": 1,
          "220-222h": 1,
          "222-224h": 2,
          "224-226h": 1,
          "246-248h": 1,
          "248-250h": 1,
          "250-252h": 1,
          "264-266h": 5,
          "266-268h": 2,
          "268-270h": 2,
          "278-280h": 1,
          "288-290h": 1,
          "290-292h": 1,
          "292-294h": 1,
          "304-306h": 1,
          "310-312h": 1,
          "318-320h": 1,
          "322-324h": 1,
          "330-332h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "342-344h": 1,
          "354-356h": 3,
          "358-360h": 1,
          "360-362h": 1,
          "362-364h": 3,
          "366-368h": 1,
          "378-380h": 1,
          "384-386h": 1,
          "410-412h": 1,
          "414-416h": 1,
          "454-456h": 1,
          "464-466h": 1,
          "470-472h": 1,
          "476-478h": 1,
          "486-488h": 1,
          "494-496h": 1,
          "500-502h": 1,
          "522-524h": 1,
          "536-538h": 1,
          "556-558h": 1,
          "596-598h": 1,
          "626-628h": 1,
          "650-652h": 2,
          "722-724h": 1,
          "752-754h": 1,
          "808-810h": 1,
          "810-812h": 1,
          "814-816h": 1,
          "820-822h": 1,
          "824-826h": 1,
          "840-842h": 1,
          "910-912h": 1,
          "1338-1340h": 1
        },
        "tickets_count": 313,
        "tickets_per_day": {
          "2025-09-30": 6,
          "2025-10-02": 1,
          "2025-10-06": 1,
          "2025-10-07": 8,
          "2025-10-08": 1,
          "2025-10-09": 8,
          "2025-10-10": 3,
          "2025-10-13": 3,
          "2025-10-14": 9,
          "2025-10-15": 17,
          "2025-10-16": 3,
          "2025-10-17": 8,
          "2025-10-20": 3,
          "2025-10-21": 3,
          "2025-10-22": 4,
          "2025-10-23": 9,
          "2025-10-25": 3,
          "2025-10-27": 4,
          "2025-10-28": 4,
          "2025-10-29": 4,
          "2025-10-30": 15,
          "2025-10-31": 4,
          "2025-11-03": 7,
          "2025-11-04": 1,
          "2025-11-05": 3,
          "2025-11-06": 7,
          "2025-11-07": 2,
          "2025-11-10": 5,
          "2025-11-11": 8,
          "2025-11-12": 1,
          "2025-11-13": 8,
          "2025-11-14": 6,
          "2025-11-17": 9,
          "2025-11-19": 6,
          "2025-11-20": 12,
          "2025-11-21": 7,
          "2025-11-22": 1,
          "2025-11-23": 2,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-26": 3,
          "2025-11-27": 8,
          "2025-11-28": 5,
          "2025-11-29": 8,
          "2025-12-02": 6,
          "2025-12-03": 8,
          "2025-12-04": 8,
          "2025-12-05": 9,
          "2025-12-06": 2,
          "2025-12-09": 4,
          "2025-12-10": 10,
          "2025-12-11": 8,
          "2025-12-12": 8
        },
        "time_per_day": {
          "2025-09-30": 14.79189,
          "2025-10-02": 1.8476630555555558,
          "2025-10-06": 71.0621975,
          "2025-10-07": 138.4758125,
          "2025-10-08": 2.2778408333333338,
          "2025-10-09": 495.1713488888888,
          "2025-10-10": 314.4250486111111,
          "2025-10-13": 293.96572972222225,
          "2025-10-14": 908.7724619444444,
          "2025-10-15": 1112.6912944444446,
          "2025-10-16": 168.9174427777778,
          "2025-10-17": 68.16979250000001,
          "2025-10-20": 243.84312416666668,
          "2025-10-21": 293.4556777777778,
          "2025-10-22": 676.2863627777778,
          "2025-10-23": 761.1163799999998,
          "2025-10-25": 336.4876797222222,
          "2025-10-27": 712.621778611111,
          "2025-10-28": 786.5112949999999,
          "2025-10-29": 431.2255597222222,
          "2025-10-30": 1152.9927752777776,
          "2025-10-31": 451.3280294444445,
          "2025-11-03": 2484.6214369444447,
          "2025-11-04": 354.15818055555553,
          "2025-11-05": 679.3937994444444,
          "2025-11-06": 376.1577847222222,
          "2025-11-07": 488.75447722222225,
          "2025-11-10": 820.3913483333332,
          "2025-11-11": 770.54227,
          "2025-11-12": 76.30099361111111,
          "2025-11-13": 1259.5938161111112,
          "2025-11-14": 305.63630416666666,
          "2025-11-17": 1140.3326838888888,
          "2025-11-19": 1874.9190824999998,
          "2025-11-20": 2355.0293119444445,
          "2025-11-21": 1197.99113,
          "2025-11-22": 651.6799255555555,
          "2025-11-23": 172.3803611111111,
          "2025-11-24": 2698.137563055555,
          "2025-11-25": 1467.6411108333334,
          "2025-11-26": 18.009376944444444,
          "2025-11-27": 1136.2154691666667,
          "2025-11-28": 85.45247277777779,
          "2025-11-29": 2805.1505613888894,
          "2025-12-02": 1208.1346613888888,
          "2025-12-03": 1629.58807,
          "2025-12-04": 3850.744668888889,
          "2025-12-05": 681.6277244444444,
          "2025-12-06": 120.33500472222224,
          "2025-12-09": 287.5809338888889,
          "2025-12-10": 2036.6498694444444,
          "2025-12-11": 1510.7574908333336,
          "2025-12-12": 745.2489852777777
        },
        "time_count_per_day": {
          "2025-09-30": 6,
          "2025-10-02": 1,
          "2025-10-06": 1,
          "2025-10-07": 8,
          "2025-10-08": 1,
          "2025-10-09": 8,
          "2025-10-10": 3,
          "2025-10-13": 3,
          "2025-10-14": 9,
          "2025-10-15": 17,
          "2025-10-16": 3,
          "2025-10-17": 8,
          "2025-10-20": 3,
          "2025-10-21": 3,
          "2025-10-22": 4,
          "2025-10-23": 9,
          "2025-10-25": 3,
          "2025-10-27": 4,
          "2025-10-28": 4,
          "2025-10-29": 4,
          "2025-10-30": 15,
          "2025-10-31": 4,
          "2025-11-03": 7,
          "2025-11-04": 1,
          "2025-11-05": 3,
          "2025-11-06": 7,
          "2025-11-07": 2,
          "2025-11-10": 5,
          "2025-11-11": 8,
          "2025-11-12": 1,
          "2025-11-13": 8,
          "2025-11-14": 6,
          "2025-11-17": 9,
          "2025-11-19": 6,
          "2025-11-20": 12,
          "2025-11-21": 7,
          "2025-11-22": 1,
          "2025-11-23": 2,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-26": 3,
          "2025-11-27": 8,
          "2025-11-28": 5,
          "2025-11-29": 8,
          "2025-12-02": 6,
          "2025-12-03": 8,
          "2025-12-04": 8,
          "2025-12-05": 9,
          "2025-12-06": 2,
          "2025-12-09": 4,
          "2025-12-10": 10,
          "2025-12-11": 8,
          "2025-12-12": 8
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 17.31,
          "mode_time_hours": 17.0,
          "mode_frequency": 6,
          "time_distribution": {
            "16-18h": 6,
            "18-20h": 2
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-10-07": 8
          },
          "time_per_day": {
            "2025-10-07": 138.4758125
          },
          "time_count_per_day": {
            "2025-10-07": 8
          }
        },
        "P2": {
          "avg_time_hours": 126.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 25,
          "time_distribution": {
            "0-2h": 25,
            "2-4h": 15,
            "4-6h": 9,
            "6-8h": 3,
            "8-10h": 2,
            "12-14h": 2,
            "14-16h": 1,
            "16-18h": 4,
            "18-20h": 2,
            "20-22h": 2,
            "22-24h": 4,
            "24-26h": 4,
            "26-28h": 3,
            "28-30h": 2,
            "32-34h": 1,
            "44-46h": 6,
            "46-48h": 1,
            "48-50h": 2,
            "54-56h": 1,
            "64-66h": 3,
            "66-68h": 3,
            "68-70h": 3,
            "70-72h": 3,
            "72-74h": 1,
            "74-76h": 2,
            "76-78h": 1,
            "80-82h": 2,
            "92-94h": 1,
            "94-96h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "116-118h": 1,
            "118-120h": 1,
            "122-124h": 1,
            "124-126h": 1,
            "136-138h": 1,
            "140-142h": 1,
            "146-148h": 2,
            "162-164h": 1,
            "166-168h": 1,
            "170-172h": 1,
            "186-188h": 1,
            "190-192h": 1,
            "192-194h": 1,
            "218-220h": 1,
            "220-222h": 1,
            "264-266h": 1,
            "292-294h": 1,
            "310-312h": 1,
            "342-344h": 1,
            "354-356h": 1,
            "360-362h": 1,
            "414-416h": 1,
            "476-478h": 1,
            "500-502h": 1,
            "536-538h": 1,
            "596-598h": 1,
            "626-628h": 1,
            "650-652h": 2,
            "722-724h": 1,
            "808-810h": 1,
            "810-812h": 1,
            "814-816h": 1,
            "820-822h": 1,
            "824-826h": 1,
            "910-912h": 1,
            "1338-1340h": 1
          },
          "tickets_count": 149,
          "tickets_per_day": {
            "2025-09-30": 6,
            "2025-10-02": 1,
            "2025-10-06": 1,
            "2025-10-08": 1,
            "2025-10-09": 3,
            "2025-10-10": 3,
            "2025-10-13": 1,
            "2025-10-14": 6,
            "2025-10-15": 10,
            "2025-10-17": 8,
            "2025-10-20": 2,
            "2025-10-21": 1,
            "2025-10-22": 3,
            "2025-10-23": 5,
            "2025-10-25": 1,
            "2025-10-28": 1,
            "2025-10-29": 2,
            "2025-10-30": 4,
            "2025-10-31": 1,
            "2025-11-03": 3,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 6,
            "2025-11-11": 2,
            "2025-11-13": 6,
            "2025-11-14": 6,
            "2025-11-17": 6,
            "2025-11-19": 6,
            "2025-11-20": 3,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 6,
            "2025-11-26": 3,
            "2025-11-27": 5,
            "2025-11-28": 4,
            "2025-12-02": 2,
            "2025-12-03": 3,
            "2025-12-04": 4,
            "2025-12-05": 4,
            "2025-12-06": 1,
            "2025-12-09": 3,
            "2025-12-10": 5,
            "2025-12-11": 2,
            "2025-12-12": 2
          },
          "time_per_day": {
            "2025-09-30": 14.79189,
            "2025-10-02": 1.8476630555555558,
            "2025-10-06": 71.0621975,
            "2025-10-08": 2.2778408333333338,
            "2025-10-09": 225.53189055555555,
            "2025-10-10": 314.4250486111111,
            "2025-10-13": 0.2921977777777778,
            "2025-10-14": 581.6785747222222,
            "2025-10-15": 439.8721272222222,
            "2025-10-17": 68.16979250000001,
            "2025-10-20": 69.189075,
            "2025-10-21": 6.140098611111111,
            "2025-10-22": 508.5291322222222,
            "2025-10-23": 296.51819666666665,
            "2025-10-25": 0.29039722222222225,
            "2025-10-28": 186.64255444444444,
            "2025-10-29": 99.66484944444444,
            "2025-10-30": 115.21301972222223,
            "2025-10-31": 4.8573691666666665,
            "2025-11-03": 1693.8215044444446,
            "2025-11-04": 354.15818055555553,
            "2025-11-05": 679.3937994444444,
            "2025-11-06": 233.08618305555558,
            "2025-11-11": 105.81037027777778,
            "2025-11-13": 1115.0716205555557,
            "2025-11-14": 305.63630416666666,
            "2025-11-17": 1025.9828283333334,
            "2025-11-19": 1874.9190824999998,
            "2025-11-20": 1746.9750050000002,
            "2025-11-21": 124.84399083333332,
            "2025-11-22": 651.6799255555555,
            "2025-11-24": 1329.0305536111114,
            "2025-11-26": 18.009376944444444,
            "2025-11-27": 206.8340175,
            "2025-11-28": 74.31184833333333,
            "2025-12-02": 420.1464158333334,
            "2025-12-03": 9.48137638888889,
            "2025-12-04": 2392.106187777778,
            "2025-12-05": 77.80400805555556,
            "2025-12-06": 66.72490305555556,
            "2025-12-09": 150.63659361111112,
            "2025-12-10": 674.1066677777778,
            "2025-12-11": 317.1110741666667,
            "2025-12-12": 193.4162088888889
          },
          "time_count_per_day": {
            "2025-09-30": 6,
            "2025-10-02": 1,
            "2025-10-06": 1,
            "2025-10-08": 1,
            "2025-10-09": 3,
            "2025-10-10": 3,
            "2025-10-13": 1,
            "2025-10-14": 6,
            "2025-10-15": 10,
            "2025-10-17": 8,
            "2025-10-20": 2,
            "2025-10-21": 1,
            "2025-10-22": 3,
            "2025-10-23": 5,
            "2025-10-25": 1,
            "2025-10-28": 1,
            "2025-10-29": 2,
            "2025-10-30": 4,
            "2025-10-31": 1,
            "2025-11-03": 3,
            "2025-11-04": 1,
            "2025-11-05": 3,
            "2025-11-06": 6,
            "2025-11-11": 2,
            "2025-11-13": 6,
            "2025-11-14": 6,
            "2025-11-17": 6,
            "2025-11-19": 6,
            "2025-11-20": 3,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 6,
            "2025-11-26": 3,
            "2025-11-27": 5,
            "2025-11-28": 4,
            "2025-12-02": 2,
            "2025-12-03": 3,
            "2025-12-04": 4,
            "2025-12-05": 4,
            "2025-12-06": 1,
            "2025-12-09": 3,
            "2025-12-10": 5,
            "2025-12-11": 2,
            "2025-12-12": 2
          }
        },
        "P3": {
          "avg_time_hours": 92.62,
          "mode_time_hours": 7.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "4-6h": 4,
            "6-8h": 5,
            "16-18h": 1,
            "72-74h": 1,
            "100-102h": 1,
            "116-118h": 1,
            "160-162h": 1,
            "268-270h": 1,
            "304-306h": 1,
            "840-842h": 1
          },
          "tickets_count": 21,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-30": 2,
            "2025-11-17": 3,
            "2025-11-20": 4,
            "2025-11-21": 2,
            "2025-11-23": 1,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-12": 1
          },
          "time_per_day": {
            "2025-10-15": 117.2244911111111,
            "2025-10-16": 7.946609444444445,
            "2025-10-30": 3.465809722222222,
            "2025-11-17": 114.34985555555556,
            "2025-11-20": 23.591268055555553,
            "2025-11-21": 17.124760833333333,
            "2025-11-23": 72.40252111111111,
            "2025-11-27": 840.1644216666667,
            "2025-12-02": 160.34365833333334,
            "2025-12-03": 305.4125719444445,
            "2025-12-05": 269.9276883333333,
            "2025-12-10": 7.016358611111111,
            "2025-12-11": 5.659602222222222,
            "2025-12-12": 0.35086055555555556
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-30": 2,
            "2025-11-17": 3,
            "2025-11-20": 4,
            "2025-11-21": 2,
            "2025-11-23": 1,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 167.33,
          "mode_time_hours": 69.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1,
            "10-12h": 1,
            "20-22h": 1,
            "22-24h": 3,
            "24-26h": 1,
            "30-32h": 2,
            "32-34h": 2,
            "34-36h": 2,
            "40-42h": 1,
            "44-46h": 1,
            "48-50h": 1,
            "52-54h": 2,
            "54-56h": 2,
            "66-68h": 1,
            "68-70h": 4,
            "70-72h": 2,
            "72-74h": 2,
            "74-76h": 1,
            "76-78h": 1,
            "80-82h": 2,
            "82-84h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "96-98h": 4,
            "98-100h": 1,
            "104-106h": 1,
            "112-114h": 1,
            "116-118h": 1,
            "118-120h": 2,
            "120-122h": 1,
            "122-124h": 1,
            "124-126h": 1,
            "126-128h": 1,
            "130-132h": 1,
            "134-136h": 1,
            "140-142h": 1,
            "142-144h": 2,
            "144-146h": 2,
            "148-150h": 2,
            "152-154h": 3,
            "158-160h": 2,
            "160-162h": 4,
            "162-164h": 1,
            "164-166h": 4,
            "166-168h": 2,
            "168-170h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "186-188h": 1,
            "188-190h": 2,
            "192-194h": 1,
            "198-200h": 1,
            "222-224h": 2,
            "224-226h": 1,
            "246-248h": 1,
            "248-250h": 1,
            "264-266h": 3,
            "266-268h": 2,
            "268-270h": 1,
            "278-280h": 1,
            "288-290h": 1,
            "290-292h": 1,
            "330-332h": 1,
            "354-356h": 2,
            "358-360h": 1,
            "362-364h": 3,
            "384-386h": 1,
            "410-412h": 1,
            "454-456h": 1,
            "464-466h": 1,
            "470-472h": 1,
            "522-524h": 1,
            "556-558h": 1,
            "752-754h": 1
          },
          "tickets_count": 113,
          "tickets_per_day": {
            "2025-10-09": 5,
            "2025-10-13": 2,
            "2025-10-14": 3,
            "2025-10-15": 6,
            "2025-10-16": 2,
            "2025-10-20": 1,
            "2025-10-21": 2,
            "2025-10-22": 1,
            "2025-10-23": 4,
            "2025-10-25": 2,
            "2025-10-27": 4,
            "2025-10-28": 3,
            "2025-10-29": 2,
            "2025-10-30": 9,
            "2025-10-31": 3,
            "2025-11-03": 4,
            "2025-11-06": 1,
            "2025-11-07": 2,
            "2025-11-10": 5,
            "2025-11-11": 6,
            "2025-11-12": 1,
            "2025-11-13": 2,
            "2025-11-20": 5,
            "2025-11-21": 3,
            "2025-11-23": 1,
            "2025-11-24": 8,
            "2025-11-25": 6,
            "2025-11-27": 2,
            "2025-11-28": 1,
            "2025-11-29": 8,
            "2025-12-02": 3,
            "2025-12-04": 3,
            "2025-12-05": 2,
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-10-09": 269.6394583333333,
            "2025-10-13": 293.67353194444445,
            "2025-10-14": 327.0938872222222,
            "2025-10-15": 555.5946761111111,
            "2025-10-16": 160.97083333333336,
            "2025-10-20": 174.65404916666668,
            "2025-10-21": 287.3155791666667,
            "2025-10-22": 167.75723055555557,
            "2025-10-23": 464.59818333333334,
            "2025-10-25": 336.1972825,
            "2025-10-27": 712.621778611111,
            "2025-10-28": 599.8687405555555,
            "2025-10-29": 331.56071027777773,
            "2025-10-30": 1034.3139458333333,
            "2025-10-31": 446.4706602777778,
            "2025-11-03": 790.7999325,
            "2025-11-06": 143.07160166666668,
            "2025-11-07": 488.75447722222225,
            "2025-11-10": 820.3913483333332,
            "2025-11-11": 664.7318997222222,
            "2025-11-12": 76.30099361111111,
            "2025-11-13": 144.52219555555553,
            "2025-11-20": 584.4630388888888,
            "2025-11-21": 1056.0223783333333,
            "2025-11-23": 99.97784,
            "2025-11-24": 1369.1070094444444,
            "2025-11-25": 1467.6411108333334,
            "2025-11-27": 89.21703,
            "2025-11-28": 11.140624444444445,
            "2025-11-29": 2805.1505613888894,
            "2025-12-02": 627.6445872222222,
            "2025-12-04": 1091.0758658333334,
            "2025-12-05": 192.5981083333333,
            "2025-12-10": 223.8440322222222
          },
          "time_count_per_day": {
            "2025-10-09": 5,
            "2025-10-13": 2,
            "2025-10-14": 3,
            "2025-10-15": 6,
            "2025-10-16": 2,
            "2025-10-20": 1,
            "2025-10-21": 2,
            "2025-10-22": 1,
            "2025-10-23": 4,
            "2025-10-25": 2,
            "2025-10-27": 4,
            "2025-10-28": 3,
            "2025-10-29": 2,
            "2025-10-30": 9,
            "2025-10-31": 3,
            "2025-11-03": 4,
            "2025-11-06": 1,
            "2025-11-07": 2,
            "2025-11-10": 5,
            "2025-11-11": 6,
            "2025-11-12": 1,
            "2025-11-13": 2,
            "2025-11-20": 5,
            "2025-11-21": 3,
            "2025-11-23": 1,
            "2025-11-24": 8,
            "2025-11-25": 6,
            "2025-11-27": 2,
            "2025-11-28": 1,
            "2025-11-29": 8,
            "2025-12-02": 3,
            "2025-12-04": 3,
            "2025-12-05": 2,
            "2025-12-10": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 222.06,
          "mode_time_hours": 53.0,
          "mode_frequency": 2,
          "time_distribution": {
            "42-44h": 1,
            "52-54h": 2,
            "76-78h": 2,
            "82-84h": 1,
            "98-100h": 1,
            "126-128h": 1,
            "136-138h": 1,
            "144-146h": 1,
            "212-214h": 1,
            "216-218h": 1,
            "250-252h": 1,
            "264-266h": 1,
            "318-320h": 1,
            "322-324h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "366-368h": 1,
            "378-380h": 1,
            "486-488h": 1,
            "494-496h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-12-03": 4,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-06": 1,
            "2025-12-09": 1,
            "2025-12-10": 3,
            "2025-12-11": 5,
            "2025-12-12": 5
          },
          "time_per_day": {
            "2025-12-03": 1314.6941216666667,
            "2025-12-04": 367.5626152777778,
            "2025-12-05": 141.29791972222222,
            "2025-12-06": 53.61010166666667,
            "2025-12-09": 136.94434027777777,
            "2025-12-10": 1131.6828108333332,
            "2025-12-11": 1187.9868144444445,
            "2025-12-12": 551.4819158333333
          },
          "time_count_per_day": {
            "2025-12-03": 4,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-06": 1,
            "2025-12-09": 1,
            "2025-12-10": 3,
            "2025-12-11": 5,
            "2025-12-12": 5
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 142.89,
            "mode_time_hours": 1.0,
            "mode_frequency": 29,
            "time_distribution": {
              "0-2h": 29,
              "2-4h": 16,
              "4-6h": 13,
              "6-8h": 8,
              "8-10h": 3,
              "10-12h": 1,
              "12-14h": 2,
              "14-16h": 1,
              "16-18h": 11,
              "18-20h": 4,
              "20-22h": 3,
              "22-24h": 7,
              "24-26h": 5,
              "26-28h": 3,
              "28-30h": 2,
              "30-32h": 2,
              "32-34h": 3,
              "34-36h": 2,
              "40-42h": 1,
              "42-44h": 1,
              "44-46h": 7,
              "46-48h": 1,
              "48-50h": 3,
              "52-54h": 4,
              "54-56h": 3,
              "64-66h": 3,
              "66-68h": 4,
              "68-70h": 7,
              "70-72h": 5,
              "72-74h": 4,
              "74-76h": 3,
              "76-78h": 4,
              "80-82h": 4,
              "82-84h": 2,
              "92-94h": 2,
              "94-96h": 2,
              "96-98h": 4,
              "98-100h": 3,
              "100-102h": 2,
              "104-106h": 1,
              "112-114h": 1,
              "116-118h": 3,
              "118-120h": 3,
              "120-122h": 1,
              "122-124h": 2,
              "124-126h": 2,
              "126-128h": 2,
              "130-132h": 1,
              "134-136h": 1,
              "136-138h": 2,
              "140-142h": 2,
              "142-144h": 2,
              "144-146h": 3,
              "146-148h": 2,
              "148-150h": 2,
              "152-154h": 3,
              "158-160h": 2,
              "160-162h": 5,
              "162-164h": 2,
              "164-166h": 4,
              "166-168h": 3,
              "168-170h": 1,
              "170-172h": 1,
              "172-174h": 1,
              "174-176h": 1,
              "186-188h": 2,
              "188-190h": 2,
              "190-192h": 1,
              "192-194h": 2,
              "198-200h": 1,
              "212-214h": 1,
              "216-218h": 1,
              "218-220h": 1,
              "220-222h": 1,
              "222-224h": 2,
              "224-226h": 1,
              "246-248h": 1,
              "248-250h": 1,
              "250-252h": 1,
              "264-266h": 5,
              "266-268h": 2,
              "268-270h": 2,
              "278-280h": 1,
              "288-290h": 1,
              "290-292h": 1,
              "292-294h": 1,
              "304-306h": 1,
              "310-312h": 1,
              "318-320h": 1,
              "322-324h": 1,
              "330-332h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "342-344h": 1,
              "354-356h": 3,
              "358-360h": 1,
              "360-362h": 1,
              "362-364h": 3,
              "366-368h": 1,
              "378-380h": 1,
              "384-386h": 1,
              "410-412h": 1,
              "414-416h": 1,
              "454-456h": 1,
              "464-466h": 1,
              "470-472h": 1,
              "476-478h": 1,
              "486-488h": 1,
              "494-496h": 1,
              "500-502h": 1,
              "522-524h": 1,
              "536-538h": 1,
              "556-558h": 1,
              "596-598h": 1,
              "626-628h": 1,
              "650-652h": 2,
              "722-724h": 1,
              "752-754h": 1,
              "808-810h": 1,
              "810-812h": 1,
              "814-816h": 1,
              "820-822h": 1,
              "824-826h": 1,
              "840-842h": 1,
              "910-912h": 1,
              "1338-1340h": 1
            },
            "tickets_count": 313,
            "tickets_per_day": {
              "2025-09-30": 6,
              "2025-10-02": 1,
              "2025-10-06": 1,
              "2025-10-07": 8,
              "2025-10-08": 1,
              "2025-10-09": 8,
              "2025-10-10": 3,
              "2025-10-13": 3,
              "2025-10-14": 9,
              "2025-10-15": 17,
              "2025-10-16": 3,
              "2025-10-17": 8,
              "2025-10-20": 3,
              "2025-10-21": 3,
              "2025-10-22": 4,
              "2025-10-23": 9,
              "2025-10-25": 3,
              "2025-10-27": 4,
              "2025-10-28": 4,
              "2025-10-29": 4,
              "2025-10-30": 15,
              "2025-10-31": 4,
              "2025-11-03": 7,
              "2025-11-04": 1,
              "2025-11-05": 3,
              "2025-11-06": 7,
              "2025-11-07": 2,
              "2025-11-10": 5,
              "2025-11-11": 8,
              "2025-11-12": 1,
              "2025-11-13": 8,
              "2025-11-14": 6,
              "2025-11-17": 9,
              "2025-11-19": 6,
              "2025-11-20": 12,
              "2025-11-21": 7,
              "2025-11-22": 1,
              "2025-11-23": 2,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-26": 3,
              "2025-11-27": 8,
              "2025-11-28": 5,
              "2025-11-29": 8,
              "2025-12-02": 6,
              "2025-12-03": 8,
              "2025-12-04": 8,
              "2025-12-05": 9,
              "2025-12-06": 2,
              "2025-12-09": 4,
              "2025-12-10": 10,
              "2025-12-11": 8,
              "2025-12-12": 8
            },
            "time_per_day": {
              "2025-09-30": 14.79189,
              "2025-10-02": 1.8476630555555558,
              "2025-10-06": 71.0621975,
              "2025-10-07": 138.4758125,
              "2025-10-08": 2.2778408333333338,
              "2025-10-09": 495.1713488888888,
              "2025-10-10": 314.4250486111111,
              "2025-10-13": 293.96572972222225,
              "2025-10-14": 908.7724619444444,
              "2025-10-15": 1112.6912944444446,
              "2025-10-16": 168.9174427777778,
              "2025-10-17": 68.16979250000001,
              "2025-10-20": 243.84312416666668,
              "2025-10-21": 293.4556777777778,
              "2025-10-22": 676.2863627777778,
              "2025-10-23": 761.1163799999998,
              "2025-10-25": 336.4876797222222,
              "2025-10-27": 712.621778611111,
              "2025-10-28": 786.5112949999999,
              "2025-10-29": 431.2255597222222,
              "2025-10-30": 1152.9927752777776,
              "2025-10-31": 451.3280294444445,
              "2025-11-03": 2484.6214369444447,
              "2025-11-04": 354.15818055555553,
              "2025-11-05": 679.3937994444444,
              "2025-11-06": 376.1577847222222,
              "2025-11-07": 488.75447722222225,
              "2025-11-10": 820.3913483333332,
              "2025-11-11": 770.54227,
              "2025-11-12": 76.30099361111111,
              "2025-11-13": 1259.5938161111112,
              "2025-11-14": 305.63630416666666,
              "2025-11-17": 1140.3326838888888,
              "2025-11-19": 1874.9190824999998,
              "2025-11-20": 2355.0293119444445,
              "2025-11-21": 1197.99113,
              "2025-11-22": 651.6799255555555,
              "2025-11-23": 172.3803611111111,
              "2025-11-24": 2698.137563055555,
              "2025-11-25": 1467.6411108333334,
              "2025-11-26": 18.009376944444444,
              "2025-11-27": 1136.2154691666667,
              "2025-11-28": 85.45247277777779,
              "2025-11-29": 2805.1505613888894,
              "2025-12-02": 1208.1346613888888,
              "2025-12-03": 1629.58807,
              "2025-12-04": 3850.744668888889,
              "2025-12-05": 681.6277244444444,
              "2025-12-06": 120.33500472222224,
              "2025-12-09": 287.5809338888889,
              "2025-12-10": 2036.6498694444444,
              "2025-12-11": 1510.7574908333336,
              "2025-12-12": 745.2489852777777
            },
            "time_count_per_day": {
              "2025-09-30": 6,
              "2025-10-02": 1,
              "2025-10-06": 1,
              "2025-10-07": 8,
              "2025-10-08": 1,
              "2025-10-09": 8,
              "2025-10-10": 3,
              "2025-10-13": 3,
              "2025-10-14": 9,
              "2025-10-15": 17,
              "2025-10-16": 3,
              "2025-10-17": 8,
              "2025-10-20": 3,
              "2025-10-21": 3,
              "2025-10-22": 4,
              "2025-10-23": 9,
              "2025-10-25": 3,
              "2025-10-27": 4,
              "2025-10-28": 4,
              "2025-10-29": 4,
              "2025-10-30": 15,
              "2025-10-31": 4,
              "2025-11-03": 7,
              "2025-11-04": 1,
              "2025-11-05": 3,
              "2025-11-06": 7,
              "2025-11-07": 2,
              "2025-11-10": 5,
              "2025-11-11": 8,
              "2025-11-12": 1,
              "2025-11-13": 8,
              "2025-11-14": 6,
              "2025-11-17": 9,
              "2025-11-19": 6,
              "2025-11-20": 12,
              "2025-11-21": 7,
              "2025-11-22": 1,
              "2025-11-23": 2,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-26": 3,
              "2025-11-27": 8,
              "2025-11-28": 5,
              "2025-11-29": 8,
              "2025-12-02": 6,
              "2025-12-03": 8,
              "2025-12-04": 8,
              "2025-12-05": 9,
              "2025-12-06": 2,
              "2025-12-09": 4,
              "2025-12-10": 10,
              "2025-12-11": 8,
              "2025-12-12": 8
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 17.31,
              "mode_time_hours": 17.0,
              "mode_frequency": 6,
              "time_distribution": {
                "16-18h": 6,
                "18-20h": 2
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-10-07": 8
              },
              "time_per_day": {
                "2025-10-07": 138.4758125
              },
              "time_count_per_day": {
                "2025-10-07": 8
              }
            },
            "P2": {
              "avg_time_hours": 126.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 25,
              "time_distribution": {
                "0-2h": 25,
                "2-4h": 15,
                "4-6h": 9,
                "6-8h": 3,
                "8-10h": 2,
                "12-14h": 2,
                "14-16h": 1,
                "16-18h": 4,
                "18-20h": 2,
                "20-22h": 2,
                "22-24h": 4,
                "24-26h": 4,
                "26-28h": 3,
                "28-30h": 2,
                "32-34h": 1,
                "44-46h": 6,
                "46-48h": 1,
                "48-50h": 2,
                "54-56h": 1,
                "64-66h": 3,
                "66-68h": 3,
                "68-70h": 3,
                "70-72h": 3,
                "72-74h": 1,
                "74-76h": 2,
                "76-78h": 1,
                "80-82h": 2,
                "92-94h": 1,
                "94-96h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "116-118h": 1,
                "118-120h": 1,
                "122-124h": 1,
                "124-126h": 1,
                "136-138h": 1,
                "140-142h": 1,
                "146-148h": 2,
                "162-164h": 1,
                "166-168h": 1,
                "170-172h": 1,
                "186-188h": 1,
                "190-192h": 1,
                "192-194h": 1,
                "218-220h": 1,
                "220-222h": 1,
                "264-266h": 1,
                "292-294h": 1,
                "310-312h": 1,
                "342-344h": 1,
                "354-356h": 1,
                "360-362h": 1,
                "414-416h": 1,
                "476-478h": 1,
                "500-502h": 1,
                "536-538h": 1,
                "596-598h": 1,
                "626-628h": 1,
                "650-652h": 2,
                "722-724h": 1,
                "808-810h": 1,
                "810-812h": 1,
                "814-816h": 1,
                "820-822h": 1,
                "824-826h": 1,
                "910-912h": 1,
                "1338-1340h": 1
              },
              "tickets_count": 149,
              "tickets_per_day": {
                "2025-09-30": 6,
                "2025-10-02": 1,
                "2025-10-06": 1,
                "2025-10-08": 1,
                "2025-10-09": 3,
                "2025-10-10": 3,
                "2025-10-13": 1,
                "2025-10-14": 6,
                "2025-10-15": 10,
                "2025-10-17": 8,
                "2025-10-20": 2,
                "2025-10-21": 1,
                "2025-10-22": 3,
                "2025-10-23": 5,
                "2025-10-25": 1,
                "2025-10-28": 1,
                "2025-10-29": 2,
                "2025-10-30": 4,
                "2025-10-31": 1,
                "2025-11-03": 3,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 6,
                "2025-11-11": 2,
                "2025-11-13": 6,
                "2025-11-14": 6,
                "2025-11-17": 6,
                "2025-11-19": 6,
                "2025-11-20": 3,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 6,
                "2025-11-26": 3,
                "2025-11-27": 5,
                "2025-11-28": 4,
                "2025-12-02": 2,
                "2025-12-03": 3,
                "2025-12-04": 4,
                "2025-12-05": 4,
                "2025-12-06": 1,
                "2025-12-09": 3,
                "2025-12-10": 5,
                "2025-12-11": 2,
                "2025-12-12": 2
              },
              "time_per_day": {
                "2025-09-30": 14.79189,
                "2025-10-02": 1.8476630555555558,
                "2025-10-06": 71.0621975,
                "2025-10-08": 2.2778408333333338,
                "2025-10-09": 225.53189055555555,
                "2025-10-10": 314.4250486111111,
                "2025-10-13": 0.2921977777777778,
                "2025-10-14": 581.6785747222222,
                "2025-10-15": 439.8721272222222,
                "2025-10-17": 68.16979250000001,
                "2025-10-20": 69.189075,
                "2025-10-21": 6.140098611111111,
                "2025-10-22": 508.5291322222222,
                "2025-10-23": 296.51819666666665,
                "2025-10-25": 0.29039722222222225,
                "2025-10-28": 186.64255444444444,
                "2025-10-29": 99.66484944444444,
                "2025-10-30": 115.21301972222223,
                "2025-10-31": 4.8573691666666665,
                "2025-11-03": 1693.8215044444446,
                "2025-11-04": 354.15818055555553,
                "2025-11-05": 679.3937994444444,
                "2025-11-06": 233.08618305555558,
                "2025-11-11": 105.81037027777778,
                "2025-11-13": 1115.0716205555557,
                "2025-11-14": 305.63630416666666,
                "2025-11-17": 1025.9828283333334,
                "2025-11-19": 1874.9190824999998,
                "2025-11-20": 1746.9750050000002,
                "2025-11-21": 124.84399083333332,
                "2025-11-22": 651.6799255555555,
                "2025-11-24": 1329.0305536111114,
                "2025-11-26": 18.009376944444444,
                "2025-11-27": 206.8340175,
                "2025-11-28": 74.31184833333333,
                "2025-12-02": 420.1464158333334,
                "2025-12-03": 9.48137638888889,
                "2025-12-04": 2392.106187777778,
                "2025-12-05": 77.80400805555556,
                "2025-12-06": 66.72490305555556,
                "2025-12-09": 150.63659361111112,
                "2025-12-10": 674.1066677777778,
                "2025-12-11": 317.1110741666667,
                "2025-12-12": 193.4162088888889
              },
              "time_count_per_day": {
                "2025-09-30": 6,
                "2025-10-02": 1,
                "2025-10-06": 1,
                "2025-10-08": 1,
                "2025-10-09": 3,
                "2025-10-10": 3,
                "2025-10-13": 1,
                "2025-10-14": 6,
                "2025-10-15": 10,
                "2025-10-17": 8,
                "2025-10-20": 2,
                "2025-10-21": 1,
                "2025-10-22": 3,
                "2025-10-23": 5,
                "2025-10-25": 1,
                "2025-10-28": 1,
                "2025-10-29": 2,
                "2025-10-30": 4,
                "2025-10-31": 1,
                "2025-11-03": 3,
                "2025-11-04": 1,
                "2025-11-05": 3,
                "2025-11-06": 6,
                "2025-11-11": 2,
                "2025-11-13": 6,
                "2025-11-14": 6,
                "2025-11-17": 6,
                "2025-11-19": 6,
                "2025-11-20": 3,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 6,
                "2025-11-26": 3,
                "2025-11-27": 5,
                "2025-11-28": 4,
                "2025-12-02": 2,
                "2025-12-03": 3,
                "2025-12-04": 4,
                "2025-12-05": 4,
                "2025-12-06": 1,
                "2025-12-09": 3,
                "2025-12-10": 5,
                "2025-12-11": 2,
                "2025-12-12": 2
              }
            },
            "P3": {
              "avg_time_hours": 92.62,
              "mode_time_hours": 7.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "4-6h": 4,
                "6-8h": 5,
                "16-18h": 1,
                "72-74h": 1,
                "100-102h": 1,
                "116-118h": 1,
                "160-162h": 1,
                "268-270h": 1,
                "304-306h": 1,
                "840-842h": 1
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-30": 2,
                "2025-11-17": 3,
                "2025-11-20": 4,
                "2025-11-21": 2,
                "2025-11-23": 1,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-12": 1
              },
              "time_per_day": {
                "2025-10-15": 117.2244911111111,
                "2025-10-16": 7.946609444444445,
                "2025-10-30": 3.465809722222222,
                "2025-11-17": 114.34985555555556,
                "2025-11-20": 23.591268055555553,
                "2025-11-21": 17.124760833333333,
                "2025-11-23": 72.40252111111111,
                "2025-11-27": 840.1644216666667,
                "2025-12-02": 160.34365833333334,
                "2025-12-03": 305.4125719444445,
                "2025-12-05": 269.9276883333333,
                "2025-12-10": 7.016358611111111,
                "2025-12-11": 5.659602222222222,
                "2025-12-12": 0.35086055555555556
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-30": 2,
                "2025-11-17": 3,
                "2025-11-20": 4,
                "2025-11-21": 2,
                "2025-11-23": 1,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 167.33,
              "mode_time_hours": 69.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1,
                "10-12h": 1,
                "20-22h": 1,
                "22-24h": 3,
                "24-26h": 1,
                "30-32h": 2,
                "32-34h": 2,
                "34-36h": 2,
                "40-42h": 1,
                "44-46h": 1,
                "48-50h": 1,
                "52-54h": 2,
                "54-56h": 2,
                "66-68h": 1,
                "68-70h": 4,
                "70-72h": 2,
                "72-74h": 2,
                "74-76h": 1,
                "76-78h": 1,
                "80-82h": 2,
                "82-84h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "96-98h": 4,
                "98-100h": 1,
                "104-106h": 1,
                "112-114h": 1,
                "116-118h": 1,
                "118-120h": 2,
                "120-122h": 1,
                "122-124h": 1,
                "124-126h": 1,
                "126-128h": 1,
                "130-132h": 1,
                "134-136h": 1,
                "140-142h": 1,
                "142-144h": 2,
                "144-146h": 2,
                "148-150h": 2,
                "152-154h": 3,
                "158-160h": 2,
                "160-162h": 4,
                "162-164h": 1,
                "164-166h": 4,
                "166-168h": 2,
                "168-170h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "186-188h": 1,
                "188-190h": 2,
                "192-194h": 1,
                "198-200h": 1,
                "222-224h": 2,
                "224-226h": 1,
                "246-248h": 1,
                "248-250h": 1,
                "264-266h": 3,
                "266-268h": 2,
                "268-270h": 1,
                "278-280h": 1,
                "288-290h": 1,
                "290-292h": 1,
                "330-332h": 1,
                "354-356h": 2,
                "358-360h": 1,
                "362-364h": 3,
                "384-386h": 1,
                "410-412h": 1,
                "454-456h": 1,
                "464-466h": 1,
                "470-472h": 1,
                "522-524h": 1,
                "556-558h": 1,
                "752-754h": 1
              },
              "tickets_count": 113,
              "tickets_per_day": {
                "2025-10-09": 5,
                "2025-10-13": 2,
                "2025-10-14": 3,
                "2025-10-15": 6,
                "2025-10-16": 2,
                "2025-10-20": 1,
                "2025-10-21": 2,
                "2025-10-22": 1,
                "2025-10-23": 4,
                "2025-10-25": 2,
                "2025-10-27": 4,
                "2025-10-28": 3,
                "2025-10-29": 2,
                "2025-10-30": 9,
                "2025-10-31": 3,
                "2025-11-03": 4,
                "2025-11-06": 1,
                "2025-11-07": 2,
                "2025-11-10": 5,
                "2025-11-11": 6,
                "2025-11-12": 1,
                "2025-11-13": 2,
                "2025-11-20": 5,
                "2025-11-21": 3,
                "2025-11-23": 1,
                "2025-11-24": 8,
                "2025-11-25": 6,
                "2025-11-27": 2,
                "2025-11-28": 1,
                "2025-11-29": 8,
                "2025-12-02": 3,
                "2025-12-04": 3,
                "2025-12-05": 2,
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-10-09": 269.6394583333333,
                "2025-10-13": 293.67353194444445,
                "2025-10-14": 327.0938872222222,
                "2025-10-15": 555.5946761111111,
                "2025-10-16": 160.97083333333336,
                "2025-10-20": 174.65404916666668,
                "2025-10-21": 287.3155791666667,
                "2025-10-22": 167.75723055555557,
                "2025-10-23": 464.59818333333334,
                "2025-10-25": 336.1972825,
                "2025-10-27": 712.621778611111,
                "2025-10-28": 599.8687405555555,
                "2025-10-29": 331.56071027777773,
                "2025-10-30": 1034.3139458333333,
                "2025-10-31": 446.4706602777778,
                "2025-11-03": 790.7999325,
                "2025-11-06": 143.07160166666668,
                "2025-11-07": 488.75447722222225,
                "2025-11-10": 820.3913483333332,
                "2025-11-11": 664.7318997222222,
                "2025-11-12": 76.30099361111111,
                "2025-11-13": 144.52219555555553,
                "2025-11-20": 584.4630388888888,
                "2025-11-21": 1056.0223783333333,
                "2025-11-23": 99.97784,
                "2025-11-24": 1369.1070094444444,
                "2025-11-25": 1467.6411108333334,
                "2025-11-27": 89.21703,
                "2025-11-28": 11.140624444444445,
                "2025-11-29": 2805.1505613888894,
                "2025-12-02": 627.6445872222222,
                "2025-12-04": 1091.0758658333334,
                "2025-12-05": 192.5981083333333,
                "2025-12-10": 223.8440322222222
              },
              "time_count_per_day": {
                "2025-10-09": 5,
                "2025-10-13": 2,
                "2025-10-14": 3,
                "2025-10-15": 6,
                "2025-10-16": 2,
                "2025-10-20": 1,
                "2025-10-21": 2,
                "2025-10-22": 1,
                "2025-10-23": 4,
                "2025-10-25": 2,
                "2025-10-27": 4,
                "2025-10-28": 3,
                "2025-10-29": 2,
                "2025-10-30": 9,
                "2025-10-31": 3,
                "2025-11-03": 4,
                "2025-11-06": 1,
                "2025-11-07": 2,
                "2025-11-10": 5,
                "2025-11-11": 6,
                "2025-11-12": 1,
                "2025-11-13": 2,
                "2025-11-20": 5,
                "2025-11-21": 3,
                "2025-11-23": 1,
                "2025-11-24": 8,
                "2025-11-25": 6,
                "2025-11-27": 2,
                "2025-11-28": 1,
                "2025-11-29": 8,
                "2025-12-02": 3,
                "2025-12-04": 3,
                "2025-12-05": 2,
                "2025-12-10": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 222.06,
              "mode_time_hours": 53.0,
              "mode_frequency": 2,
              "time_distribution": {
                "42-44h": 1,
                "52-54h": 2,
                "76-78h": 2,
                "82-84h": 1,
                "98-100h": 1,
                "126-128h": 1,
                "136-138h": 1,
                "144-146h": 1,
                "212-214h": 1,
                "216-218h": 1,
                "250-252h": 1,
                "264-266h": 1,
                "318-320h": 1,
                "322-324h": 1,
                "334-336h": 1,
                "336-338h": 1,
                "366-368h": 1,
                "378-380h": 1,
                "486-488h": 1,
                "494-496h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-12-03": 4,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-06": 1,
                "2025-12-09": 1,
                "2025-12-10": 3,
                "2025-12-11": 5,
                "2025-12-12": 5
              },
              "time_per_day": {
                "2025-12-03": 1314.6941216666667,
                "2025-12-04": 367.5626152777778,
                "2025-12-05": 141.29791972222222,
                "2025-12-06": 53.61010166666667,
                "2025-12-09": 136.94434027777777,
                "2025-12-10": 1131.6828108333332,
                "2025-12-11": 1187.9868144444445,
                "2025-12-12": 551.4819158333333
              },
              "time_count_per_day": {
                "2025-12-03": 4,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-06": 1,
                "2025-12-09": 1,
                "2025-12-10": 3,
                "2025-12-11": 5,
                "2025-12-12": 5
              }
            }
          }
        }
      }
    },
    "Magali Morim": {
      "overall": {
        "avg_time_hours": 90.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 1030,
        "time_distribution": {
          "0-2h": 1030,
          "2-4h": 259,
          "4-6h": 70,
          "6-8h": 59,
          "8-10h": 17,
          "10-12h": 39,
          "12-14h": 31,
          "14-16h": 17,
          "16-18h": 29,
          "18-20h": 25,
          "20-22h": 13,
          "22-24h": 12,
          "24-26h": 28,
          "26-28h": 12,
          "28-30h": 12,
          "30-32h": 6,
          "32-34h": 3,
          "34-36h": 2,
          "36-38h": 4,
          "38-40h": 1,
          "40-42h": 13,
          "42-44h": 10,
          "44-46h": 6,
          "46-48h": 9,
          "48-50h": 10,
          "50-52h": 5,
          "52-54h": 12,
          "54-56h": 7,
          "58-60h": 1,
          "60-62h": 2,
          "62-64h": 1,
          "64-66h": 7,
          "66-68h": 9,
          "68-70h": 6,
          "70-72h": 7,
          "72-74h": 11,
          "74-76h": 8,
          "76-78h": 9,
          "78-80h": 5,
          "82-84h": 1,
          "84-86h": 1,
          "88-90h": 3,
          "90-92h": 1,
          "94-96h": 3,
          "96-98h": 3,
          "98-100h": 4,
          "100-102h": 2,
          "102-104h": 3,
          "104-106h": 1,
          "108-110h": 2,
          "110-112h": 1,
          "112-114h": 1,
          "114-116h": 1,
          "116-118h": 2,
          "120-122h": 1,
          "122-124h": 5,
          "124-126h": 5,
          "126-128h": 2,
          "134-136h": 1,
          "138-140h": 2,
          "140-142h": 3,
          "142-144h": 2,
          "144-146h": 1,
          "146-148h": 3,
          "148-150h": 5,
          "150-152h": 1,
          "158-160h": 1,
          "160-162h": 1,
          "162-164h": 2,
          "164-166h": 5,
          "166-168h": 1,
          "168-170h": 1,
          "170-172h": 1,
          "172-174h": 2,
          "174-176h": 2,
          "176-178h": 1,
          "178-180h": 1,
          "180-182h": 1,
          "186-188h": 1,
          "190-192h": 1,
          "192-194h": 1,
          "194-196h": 3,
          "196-198h": 2,
          "198-200h": 1,
          "200-202h": 3,
          "214-216h": 3,
          "220-222h": 1,
          "222-224h": 1,
          "226-228h": 1,
          "232-234h": 1,
          "236-238h": 1,
          "240-242h": 1,
          "242-244h": 2,
          "258-260h": 2,
          "262-264h": 2,
          "266-268h": 2,
          "268-270h": 1,
          "276-278h": 1,
          "282-284h": 1,
          "288-290h": 1,
          "294-296h": 1,
          "304-306h": 1,
          "308-310h": 2,
          "310-312h": 2,
          "312-314h": 3,
          "314-316h": 1,
          "318-320h": 1,
          "328-330h": 1,
          "330-332h": 1,
          "332-334h": 4,
          "336-338h": 3,
          "338-340h": 3,
          "340-342h": 3,
          "342-344h": 2,
          "348-350h": 1,
          "356-358h": 2,
          "358-360h": 1,
          "360-362h": 1,
          "362-364h": 1,
          "366-368h": 1,
          "380-382h": 2,
          "382-384h": 4,
          "384-386h": 3,
          "388-390h": 1,
          "408-410h": 3,
          "410-412h": 3,
          "412-414h": 1,
          "416-418h": 1,
          "418-420h": 1,
          "430-432h": 1,
          "432-434h": 1,
          "450-452h": 1,
          "452-454h": 1,
          "454-456h": 2,
          "456-458h": 2,
          "462-464h": 1,
          "480-482h": 2,
          "498-500h": 1,
          "500-502h": 1,
          "502-504h": 1,
          "520-522h": 1,
          "524-526h": 1,
          "526-528h": 1,
          "530-532h": 1,
          "536-538h": 1,
          "558-560h": 1,
          "560-562h": 1,
          "570-572h": 1,
          "572-574h": 1,
          "576-578h": 3,
          "578-580h": 3,
          "580-582h": 1,
          "582-584h": 2,
          "592-594h": 1,
          "594-596h": 2,
          "596-598h": 1,
          "604-606h": 1,
          "610-612h": 1,
          "612-614h": 1,
          "628-630h": 1,
          "642-644h": 1,
          "648-650h": 1,
          "652-654h": 1,
          "654-656h": 1,
          "658-660h": 1,
          "670-672h": 2,
          "672-674h": 1,
          "696-698h": 2,
          "698-700h": 2,
          "714-716h": 1,
          "724-726h": 2,
          "740-742h": 1,
          "742-744h": 1,
          "766-768h": 2,
          "772-774h": 1,
          "780-782h": 1,
          "788-790h": 1,
          "790-792h": 1,
          "792-794h": 1,
          "796-798h": 1,
          "816-818h": 1,
          "818-820h": 1,
          "840-842h": 1,
          "842-844h": 1,
          "846-848h": 2,
          "862-864h": 1,
          "864-866h": 1,
          "884-886h": 1,
          "892-894h": 1,
          "896-898h": 1,
          "904-906h": 1,
          "908-910h": 1,
          "910-912h": 1,
          "936-938h": 1,
          "942-944h": 1,
          "944-946h": 1,
          "954-956h": 1,
          "956-958h": 1,
          "984-986h": 1,
          "986-988h": 2,
          "990-992h": 1,
          "1008-1010h": 1,
          "1026-1028h": 1,
          "1034-1036h": 1,
          "1038-1040h": 1,
          "1054-1056h": 1,
          "1056-1058h": 1,
          "1058-1060h": 1,
          "1072-1074h": 1,
          "1074-1076h": 1,
          "1076-1078h": 1,
          "1078-1080h": 1,
          "1080-1082h": 1,
          "1086-1088h": 1,
          "1104-1106h": 1,
          "1112-1114h": 1,
          "1146-1148h": 1,
          "1156-1158h": 1,
          "1170-1172h": 1,
          "1194-1196h": 1,
          "1196-1198h": 1,
          "1198-1200h": 2,
          "1222-1224h": 2,
          "1248-1250h": 1,
          "1264-1266h": 1,
          "1266-1268h": 1,
          "1272-1274h": 1,
          "1294-1296h": 1,
          "1316-1318h": 1,
          "1322-1324h": 1,
          "1338-1340h": 1,
          "1342-1344h": 1,
          "1366-1368h": 1,
          "1404-1406h": 1,
          "1410-1412h": 1,
          "1468-1470h": 1,
          "1508-1510h": 1,
          "1578-1580h": 1,
          "1632-1634h": 1,
          "1634-1636h": 1,
          "1752-1754h": 1,
          "1830-1832h": 1,
          "1942-1944h": 1,
          "1944-1946h": 1,
          "1962-1964h": 1,
          "2044-2046h": 1,
          "2060-2062h": 1,
          "2108-2110h": 1,
          "2250-2252h": 1,
          "2372-2374h": 1,
          "3550-3552h": 1,
          "4036-4038h": 1
        },
        "tickets_count": 2299,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-06": 2,
          "2025-10-11": 2,
          "2025-10-14": 4,
          "2025-10-18": 4,
          "2025-11-04": 3,
          "2025-11-06": 2,
          "2025-11-07": 12,
          "2025-11-08": 2,
          "2025-11-11": 2,
          "2025-11-12": 9,
          "2025-11-13": 5,
          "2025-11-17": 4,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-24": 2,
          "2025-11-25": 5,
          "2025-11-26": 1,
          "2025-11-30": 1,
          "2025-12-02": 11,
          "2025-12-03": 6,
          "2025-12-05": 1,
          "2025-12-08": 2,
          "2025-12-09": 2,
          "2025-12-10": 3,
          "2025-12-11": 6,
          "2025-12-12": 1,
          "2025-12-13": 3,
          "2025-12-15": 1,
          "2025-12-16": 1,
          "2025-12-18": 7,
          "2025-12-19": 2,
          "2025-12-20": 2,
          "2025-12-22": 2,
          "2025-12-23": 2,
          "2025-12-24": 1,
          "2025-12-26": 1,
          "2025-12-28": 6,
          "2025-12-29": 2,
          "2025-12-30": 7,
          "2026-01-05": 8,
          "2026-01-07": 4,
          "2026-01-08": 8,
          "2026-01-10": 6,
          "2026-01-13": 22,
          "2026-01-14": 8,
          "2026-01-16": 9,
          "2026-01-19": 21,
          "2026-01-20": 13,
          "2026-01-21": 2,
          "2026-01-22": 7,
          "2026-01-23": 1,
          "2026-01-26": 14,
          "2026-01-27": 12,
          "2026-01-30": 5,
          "2026-01-31": 1,
          "2026-02-02": 5,
          "2026-02-03": 7,
          "2026-02-04": 11,
          "2026-02-05": 11,
          "2026-02-06": 5,
          "2026-02-07": 1,
          "2026-02-09": 7,
          "2026-02-10": 12,
          "2026-02-11": 6,
          "2026-02-12": 11,
          "2026-02-13": 9,
          "2026-02-14": 1,
          "2026-02-16": 32,
          "2026-02-17": 10,
          "2026-02-18": 34,
          "2026-02-19": 21,
          "2026-02-20": 18,
          "2026-02-23": 1,
          "2026-02-24": 12,
          "2026-02-25": 6,
          "2026-02-26": 14,
          "2026-02-27": 1,
          "2026-03-01": 21,
          "2026-03-02": 18,
          "2026-03-03": 25,
          "2026-03-04": 37,
          "2026-03-05": 2,
          "2026-03-06": 6,
          "2026-03-09": 8,
          "2026-03-10": 5,
          "2026-03-11": 29,
          "2026-03-12": 8,
          "2026-03-13": 18,
          "2026-03-15": 1,
          "2026-03-16": 26,
          "2026-03-17": 20,
          "2026-03-18": 13,
          "2026-03-19": 9,
          "2026-03-20": 40,
          "2026-03-21": 10,
          "2026-03-23": 16,
          "2026-03-24": 14,
          "2026-03-25": 9,
          "2026-03-26": 11,
          "2026-03-27": 17,
          "2026-03-30": 17,
          "2026-03-31": 14,
          "2026-04-01": 6,
          "2026-04-02": 34,
          "2026-04-06": 1,
          "2026-04-07": 2,
          "2026-04-08": 23,
          "2026-04-09": 29,
          "2026-04-10": 22,
          "2026-04-13": 35,
          "2026-04-14": 2,
          "2026-04-15": 13,
          "2026-04-16": 29,
          "2026-04-17": 23,
          "2026-04-18": 17,
          "2026-04-20": 45,
          "2026-04-21": 2,
          "2026-04-22": 25,
          "2026-04-23": 30,
          "2026-04-24": 18,
          "2026-04-27": 41,
          "2026-04-28": 14,
          "2026-04-29": 27,
          "2026-04-30": 34,
          "2026-05-04": 74,
          "2026-05-05": 24,
          "2026-05-06": 23,
          "2026-05-07": 49,
          "2026-05-08": 2,
          "2026-05-09": 8,
          "2026-05-11": 75,
          "2026-05-12": 54,
          "2026-05-13": 32,
          "2026-05-14": 82,
          "2026-05-15": 36,
          "2026-05-16": 22,
          "2026-05-17": 1,
          "2026-05-18": 48,
          "2026-05-19": 45,
          "2026-05-20": 64,
          "2026-05-21": 55,
          "2026-05-22": 39,
          "2026-05-25": 1,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-05-30": 3,
          "2026-05-31": 1,
          "2026-06-02": 6,
          "2026-06-03": 41,
          "2026-06-05": 89,
          "2026-06-06": 37,
          "2026-06-08": 7
        },
        "time_per_day": {
          "2025-10-01": 28.2095025,
          "2025-10-03": 0.2522908333333333,
          "2025-10-06": 100.90845999999999,
          "2025-10-11": 82.95310138888888,
          "2025-10-14": 70.68604500000001,
          "2025-10-18": 254.13021972222222,
          "2025-11-04": 1693.569995,
          "2025-11-06": 772.4831569444444,
          "2025-11-07": 52.41845138888888,
          "2025-11-08": 359.3445097222222,
          "2025-11-11": 33.308388888888885,
          "2025-11-12": 3130.3717827777778,
          "2025-11-13": 133.5197836111111,
          "2025-11-17": 209.3923472222222,
          "2025-11-18": 20.3284025,
          "2025-11-20": 431.11313416666667,
          "2025-11-21": 4.607036111111111,
          "2025-11-22": 3.430708888888889,
          "2025-11-24": 38.954905277777776,
          "2025-11-25": 479.4096191666667,
          "2025-11-26": 26.488642777777777,
          "2025-11-30": 3.9426472222222224,
          "2025-12-02": 790.5379177777778,
          "2025-12-03": 924.0464,
          "2025-12-05": 105.44115166666667,
          "2025-12-08": 302.6293366666667,
          "2025-12-09": 347.58443361111114,
          "2025-12-10": 61.14274638888888,
          "2025-12-11": 677.3744502777777,
          "2025-12-12": 3.2853466666666664,
          "2025-12-13": 616.365633888889,
          "2025-12-15": 48.33467805555555,
          "2025-12-16": 85.33078166666667,
          "2025-12-18": 393.77413722222224,
          "2025-12-19": 250.43696888888888,
          "2025-12-20": 423.2800086111111,
          "2025-12-22": 50.34117972222222,
          "2025-12-23": 64.29745166666666,
          "2025-12-24": 42.500729722222225,
          "2025-12-26": 3.097757777777778,
          "2025-12-28": 151.51704444444445,
          "2025-12-29": 1638.0612991666667,
          "2025-12-30": 774.0992722222221,
          "2026-01-05": 1024.3174291666667,
          "2026-01-07": 1089.4831083333331,
          "2026-01-08": 21.39674138888889,
          "2026-01-10": 74.0562225,
          "2026-01-13": 1293.3947761111112,
          "2026-01-14": 84.26943138888889,
          "2026-01-16": 504.15358611111117,
          "2026-01-19": 1841.4497772222219,
          "2026-01-20": 334.11286111111116,
          "2026-01-21": 31.33533055555555,
          "2026-01-22": 155.97769055555557,
          "2026-01-23": 7.443530833333333,
          "2026-01-26": 1498.322367222222,
          "2026-01-27": 1130.0593938888887,
          "2026-01-30": 361.1774069444445,
          "2026-01-31": 2.6259602777777777,
          "2026-02-02": 115.11340194444445,
          "2026-02-03": 127.95280416666667,
          "2026-02-04": 113.80689111111113,
          "2026-02-05": 290.73572666666666,
          "2026-02-06": 71.96606555555555,
          "2026-02-07": 2.790459166666667,
          "2026-02-09": 726.0434844444444,
          "2026-02-10": 1370.8267705555556,
          "2026-02-11": 1069.4877113888888,
          "2026-02-12": 1954.1255408333334,
          "2026-02-13": 306.96618944444435,
          "2026-02-14": 18.233544444444444,
          "2026-02-16": 2074.8153786111106,
          "2026-02-17": 46.81790916666667,
          "2026-02-18": 16534.162810277776,
          "2026-02-19": 661.6338088888889,
          "2026-02-20": 408.4524377777777,
          "2026-02-23": 70.41375277777777,
          "2026-02-24": 13.757394166666668,
          "2026-02-25": 4.2011263888888895,
          "2026-02-26": 47.05642611111112,
          "2026-02-27": 503.90358944444444,
          "2026-03-01": 500.97941805555564,
          "2026-03-02": 616.378101111111,
          "2026-03-03": 2317.721344722222,
          "2026-03-04": 581.2498219444448,
          "2026-03-05": 115.80278138888889,
          "2026-03-06": 149.67878055555553,
          "2026-03-09": 811.3535241666668,
          "2026-03-10": 1224.7594636111112,
          "2026-03-11": 5083.564697222221,
          "2026-03-12": 75.45444166666665,
          "2026-03-13": 237.85355055555556,
          "2026-03-15": 24.81566361111111,
          "2026-03-16": 371.6661688888889,
          "2026-03-17": 4889.832371666667,
          "2026-03-18": 24.50215472222222,
          "2026-03-19": 10.049879166666665,
          "2026-03-20": 17668.910679444452,
          "2026-03-21": 70.54546388888889,
          "2026-03-23": 303.5225911111111,
          "2026-03-24": 257.5039494444445,
          "2026-03-25": 139.49735138888892,
          "2026-03-26": 8.389298888888888,
          "2026-03-27": 6063.326778055556,
          "2026-03-30": 312.6296416666667,
          "2026-03-31": 410.4767074999999,
          "2026-04-01": 23.089324444444447,
          "2026-04-02": 12676.853988888886,
          "2026-04-08": 584.1872647222224,
          "2026-04-09": 704.2082036111112,
          "2026-04-10": 4335.806061666666,
          "2026-04-13": 3521.3054569444434,
          "2026-04-14": 295.96116027777776,
          "2026-04-15": 2311.5083227777786,
          "2026-04-16": 540.9071333333328,
          "2026-04-17": 2047.8296919444444,
          "2026-04-18": 6951.719850277779,
          "2026-04-20": 1072.2402988888887,
          "2026-04-21": 0.40624805555555554,
          "2026-04-22": 48.799794444444444,
          "2026-04-23": 15298.078595555558,
          "2026-04-24": 163.73625333333337,
          "2026-04-27": 1801.494629166666,
          "2026-04-28": 470.45262388888887,
          "2026-04-29": 35.83221694444444,
          "2026-04-30": 209.36740027777782,
          "2026-05-04": 812.2141269444444,
          "2026-05-05": 438.4196941666667,
          "2026-05-06": 236.65377277777782,
          "2026-05-07": 7016.756178333333,
          "2026-05-08": 143.40255888888888,
          "2026-05-09": 214.3889363888889,
          "2026-05-11": 254.63180944444449,
          "2026-05-12": 2559.0889905555555,
          "2026-05-13": 2950.017783888888,
          "2026-05-14": 19772.84391166668,
          "2026-05-15": 103.5975536111111,
          "2026-05-16": 150.9955297222222,
          "2026-05-17": 0.01920222222222222,
          "2026-05-18": 59.73469138888889,
          "2026-05-19": 62.55724861111112,
          "2026-05-20": 550.7758802777777,
          "2026-05-21": 556.1303508333332,
          "2026-05-22": 98.28122944444442,
          "2026-05-25": 76.09619500000001,
          "2026-05-30": 222.98155527777777,
          "2026-06-02": 200.86864694444444,
          "2026-06-03": 914.4228186111111,
          "2026-06-05": 983.9036169444445,
          "2026-06-06": 5075.259952222224,
          "2026-06-08": 14.812650833333334
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-06": 2,
          "2025-10-11": 2,
          "2025-10-14": 4,
          "2025-10-18": 4,
          "2025-11-04": 3,
          "2025-11-06": 2,
          "2025-11-07": 12,
          "2025-11-08": 2,
          "2025-11-11": 2,
          "2025-11-12": 9,
          "2025-11-13": 5,
          "2025-11-17": 4,
          "2025-11-18": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-24": 2,
          "2025-11-25": 5,
          "2025-11-26": 1,
          "2025-11-30": 1,
          "2025-12-02": 11,
          "2025-12-03": 6,
          "2025-12-05": 1,
          "2025-12-08": 2,
          "2025-12-09": 2,
          "2025-12-10": 3,
          "2025-12-11": 6,
          "2025-12-12": 1,
          "2025-12-13": 3,
          "2025-12-15": 1,
          "2025-12-16": 1,
          "2025-12-18": 7,
          "2025-12-19": 2,
          "2025-12-20": 2,
          "2025-12-22": 2,
          "2025-12-23": 2,
          "2025-12-24": 1,
          "2025-12-26": 1,
          "2025-12-28": 6,
          "2025-12-29": 2,
          "2025-12-30": 7,
          "2026-01-05": 8,
          "2026-01-07": 4,
          "2026-01-08": 8,
          "2026-01-10": 6,
          "2026-01-13": 22,
          "2026-01-14": 8,
          "2026-01-16": 9,
          "2026-01-19": 21,
          "2026-01-20": 13,
          "2026-01-21": 2,
          "2026-01-22": 7,
          "2026-01-23": 1,
          "2026-01-26": 14,
          "2026-01-27": 12,
          "2026-01-30": 5,
          "2026-01-31": 1,
          "2026-02-02": 5,
          "2026-02-03": 6,
          "2026-02-04": 11,
          "2026-02-05": 11,
          "2026-02-06": 5,
          "2026-02-07": 1,
          "2026-02-09": 7,
          "2026-02-10": 12,
          "2026-02-11": 6,
          "2026-02-12": 9,
          "2026-02-13": 9,
          "2026-02-14": 1,
          "2026-02-16": 14,
          "2026-02-17": 4,
          "2026-02-18": 34,
          "2026-02-19": 21,
          "2026-02-20": 18,
          "2026-02-23": 1,
          "2026-02-24": 12,
          "2026-02-25": 6,
          "2026-02-26": 14,
          "2026-02-27": 1,
          "2026-03-01": 21,
          "2026-03-02": 17,
          "2026-03-03": 23,
          "2026-03-04": 37,
          "2026-03-05": 2,
          "2026-03-06": 5,
          "2026-03-09": 8,
          "2026-03-10": 5,
          "2026-03-11": 27,
          "2026-03-12": 8,
          "2026-03-13": 17,
          "2026-03-15": 1,
          "2026-03-16": 24,
          "2026-03-17": 19,
          "2026-03-18": 12,
          "2026-03-19": 8,
          "2026-03-20": 39,
          "2026-03-21": 10,
          "2026-03-23": 15,
          "2026-03-24": 14,
          "2026-03-25": 9,
          "2026-03-26": 9,
          "2026-03-27": 17,
          "2026-03-30": 15,
          "2026-03-31": 13,
          "2026-04-01": 6,
          "2026-04-02": 34,
          "2026-04-08": 20,
          "2026-04-09": 29,
          "2026-04-10": 21,
          "2026-04-13": 35,
          "2026-04-14": 1,
          "2026-04-15": 12,
          "2026-04-16": 29,
          "2026-04-17": 21,
          "2026-04-18": 17,
          "2026-04-20": 42,
          "2026-04-21": 2,
          "2026-04-22": 23,
          "2026-04-23": 30,
          "2026-04-24": 18,
          "2026-04-27": 39,
          "2026-04-28": 11,
          "2026-04-29": 20,
          "2026-04-30": 31,
          "2026-05-04": 68,
          "2026-05-05": 20,
          "2026-05-06": 21,
          "2026-05-07": 44,
          "2026-05-08": 1,
          "2026-05-09": 6,
          "2026-05-11": 71,
          "2026-05-12": 43,
          "2026-05-13": 32,
          "2026-05-14": 77,
          "2026-05-15": 32,
          "2026-05-16": 22,
          "2026-05-17": 1,
          "2026-05-18": 44,
          "2026-05-19": 41,
          "2026-05-20": 57,
          "2026-05-21": 47,
          "2026-05-22": 34,
          "2026-05-25": 1,
          "2026-05-30": 3,
          "2026-06-02": 1,
          "2026-06-03": 39,
          "2026-06-05": 75,
          "2026-06-06": 29,
          "2026-06-08": 5
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 121.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 6,
            "4-6h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "28-30h": 2,
            "48-50h": 1,
            "54-56h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "126-128h": 1,
            "144-146h": 1,
            "304-306h": 1,
            "670-672h": 1,
            "780-782h": 1,
            "1086-1088h": 1
          },
          "tickets_count": 45,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2026-01-20": 1,
            "2026-03-03": 2,
            "2026-03-06": 2,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-21": 1,
            "2026-03-23": 1,
            "2026-04-02": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-04-29": 1,
            "2026-05-04": 3,
            "2026-05-05": 1,
            "2026-05-07": 1,
            "2026-05-12": 2,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-26": 1,
            "2026-05-31": 1,
            "2026-06-02": 1,
            "2026-06-03": 1,
            "2026-06-05": 6,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-01": 28.2095025,
            "2025-10-03": 0.2522908333333333,
            "2025-10-06": 2.599463611111111,
            "2025-11-24": 2.0779130555555554,
            "2025-12-02": 0.2569183333333333,
            "2025-12-12": 3.2853466666666664,
            "2026-01-20": 8.536498611111112,
            "2026-03-03": 0.5228838888888888,
            "2026-03-06": 126.96194277777778,
            "2026-03-10": 780.9277716666667,
            "2026-03-17": 72.59561555555555,
            "2026-03-20": 2.031414166666667,
            "2026-03-21": 28.306140833333334,
            "2026-03-23": 77.29467666666667,
            "2026-04-02": 1086.5316547222221,
            "2026-04-09": 24.582395,
            "2026-04-10": 29.045561944444447,
            "2026-04-17": 2.5466955555555555,
            "2026-04-18": 2.6868855555555555,
            "2026-05-04": 103.27584555555555,
            "2026-05-07": 304.9134616666667,
            "2026-05-12": 15.295642222222222,
            "2026-05-14": 145.47382416666667,
            "2026-05-19": 4.274418333333333,
            "2026-05-20": 1.1007677777777778,
            "2026-06-05": 671.2827441666667
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2026-01-20": 1,
            "2026-03-03": 2,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-21": 1,
            "2026-03-23": 1,
            "2026-04-02": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-05-04": 2,
            "2026-05-07": 1,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 75.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 1018,
          "time_distribution": {
            "0-2h": 1018,
            "2-4h": 239,
            "4-6h": 61,
            "6-8h": 45,
            "8-10h": 12,
            "10-12h": 36,
            "12-14h": 29,
            "14-16h": 15,
            "16-18h": 26,
            "18-20h": 17,
            "20-22h": 10,
            "22-24h": 10,
            "24-26h": 16,
            "26-28h": 8,
            "28-30h": 8,
            "30-32h": 5,
            "32-34h": 2,
            "34-36h": 2,
            "36-38h": 4,
            "38-40h": 1,
            "40-42h": 13,
            "42-44h": 9,
            "44-46h": 6,
            "46-48h": 6,
            "48-50h": 9,
            "50-52h": 4,
            "52-54h": 11,
            "54-56h": 5,
            "58-60h": 1,
            "60-62h": 2,
            "64-66h": 7,
            "66-68h": 7,
            "68-70h": 4,
            "70-72h": 4,
            "72-74h": 8,
            "74-76h": 6,
            "76-78h": 7,
            "78-80h": 5,
            "84-86h": 1,
            "88-90h": 2,
            "90-92h": 1,
            "94-96h": 3,
            "96-98h": 3,
            "98-100h": 2,
            "102-104h": 2,
            "108-110h": 2,
            "110-112h": 1,
            "112-114h": 1,
            "114-116h": 1,
            "116-118h": 2,
            "122-124h": 4,
            "124-126h": 3,
            "126-128h": 1,
            "134-136h": 1,
            "138-140h": 2,
            "140-142h": 3,
            "142-144h": 2,
            "146-148h": 3,
            "148-150h": 5,
            "150-152h": 1,
            "158-160h": 1,
            "160-162h": 1,
            "162-164h": 2,
            "164-166h": 5,
            "166-168h": 1,
            "168-170h": 1,
            "170-172h": 1,
            "172-174h": 1,
            "174-176h": 2,
            "176-178h": 1,
            "178-180h": 1,
            "180-182h": 1,
            "186-188h": 1,
            "190-192h": 1,
            "194-196h": 1,
            "200-202h": 3,
            "214-216h": 3,
            "220-222h": 1,
            "222-224h": 1,
            "226-228h": 1,
            "232-234h": 1,
            "236-238h": 1,
            "240-242h": 1,
            "242-244h": 1,
            "262-264h": 2,
            "266-268h": 2,
            "268-270h": 1,
            "276-278h": 1,
            "288-290h": 1,
            "294-296h": 1,
            "308-310h": 2,
            "310-312h": 2,
            "312-314h": 3,
            "314-316h": 1,
            "328-330h": 1,
            "330-332h": 1,
            "332-334h": 4,
            "336-338h": 3,
            "338-340h": 2,
            "340-342h": 3,
            "342-344h": 1,
            "348-350h": 1,
            "356-358h": 2,
            "360-362h": 1,
            "366-368h": 1,
            "380-382h": 2,
            "382-384h": 3,
            "384-386h": 2,
            "388-390h": 1,
            "408-410h": 3,
            "410-412h": 2,
            "412-414h": 1,
            "418-420h": 1,
            "430-432h": 1,
            "432-434h": 1,
            "450-452h": 1,
            "452-454h": 1,
            "454-456h": 2,
            "456-458h": 2,
            "462-464h": 1,
            "480-482h": 2,
            "498-500h": 1,
            "520-522h": 1,
            "524-526h": 1,
            "526-528h": 1,
            "530-532h": 1,
            "536-538h": 1,
            "558-560h": 1,
            "560-562h": 1,
            "570-572h": 1,
            "572-574h": 1,
            "576-578h": 3,
            "578-580h": 2,
            "580-582h": 1,
            "582-584h": 2,
            "594-596h": 1,
            "596-598h": 1,
            "604-606h": 1,
            "610-612h": 1,
            "612-614h": 1,
            "628-630h": 1,
            "642-644h": 1,
            "652-654h": 1,
            "654-656h": 1,
            "658-660h": 1,
            "670-672h": 1,
            "672-674h": 1,
            "696-698h": 1,
            "698-700h": 1,
            "714-716h": 1,
            "724-726h": 2,
            "766-768h": 2,
            "772-774h": 1,
            "788-790h": 1,
            "790-792h": 1,
            "792-794h": 1,
            "796-798h": 1,
            "816-818h": 1,
            "818-820h": 1,
            "846-848h": 1,
            "862-864h": 1,
            "864-866h": 1,
            "884-886h": 1,
            "892-894h": 1,
            "904-906h": 1,
            "908-910h": 1,
            "910-912h": 1,
            "936-938h": 1,
            "942-944h": 1,
            "954-956h": 1,
            "956-958h": 1,
            "984-986h": 1,
            "986-988h": 1,
            "990-992h": 1,
            "1008-1010h": 1,
            "1026-1028h": 1,
            "1034-1036h": 1,
            "1038-1040h": 1,
            "1054-1056h": 1,
            "1056-1058h": 1,
            "1058-1060h": 1,
            "1072-1074h": 1,
            "1074-1076h": 1,
            "1076-1078h": 1,
            "1078-1080h": 1,
            "1080-1082h": 1,
            "1104-1106h": 1,
            "1112-1114h": 1,
            "1146-1148h": 1,
            "1156-1158h": 1,
            "1170-1172h": 1,
            "1194-1196h": 1,
            "1196-1198h": 1,
            "1198-1200h": 1,
            "1222-1224h": 2,
            "1248-1250h": 1,
            "1264-1266h": 1,
            "1266-1268h": 1,
            "1272-1274h": 1,
            "1294-1296h": 1,
            "1316-1318h": 1,
            "1322-1324h": 1,
            "1338-1340h": 1,
            "1342-1344h": 1,
            "1366-1368h": 1,
            "1404-1406h": 1,
            "1410-1412h": 1,
            "1578-1580h": 1,
            "1632-1634h": 1,
            "1634-1636h": 1,
            "1942-1944h": 1,
            "2044-2046h": 1,
            "2060-2062h": 1,
            "2108-2110h": 1,
            "2250-2252h": 1
          },
          "tickets_count": 2085,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-11": 2,
            "2025-10-14": 4,
            "2025-10-18": 3,
            "2025-11-04": 2,
            "2025-11-06": 1,
            "2025-11-08": 1,
            "2025-11-12": 6,
            "2025-11-13": 1,
            "2025-11-20": 1,
            "2025-11-21": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-30": 1,
            "2025-12-02": 3,
            "2025-12-03": 2,
            "2025-12-08": 1,
            "2025-12-09": 2,
            "2025-12-11": 3,
            "2025-12-13": 2,
            "2025-12-15": 1,
            "2025-12-16": 1,
            "2025-12-18": 2,
            "2025-12-19": 1,
            "2025-12-20": 1,
            "2025-12-22": 2,
            "2025-12-24": 1,
            "2025-12-26": 1,
            "2025-12-28": 5,
            "2025-12-29": 2,
            "2025-12-30": 5,
            "2026-01-05": 6,
            "2026-01-07": 1,
            "2026-01-08": 6,
            "2026-01-10": 6,
            "2026-01-13": 14,
            "2026-01-14": 3,
            "2026-01-16": 6,
            "2026-01-19": 15,
            "2026-01-20": 12,
            "2026-01-21": 2,
            "2026-01-22": 6,
            "2026-01-23": 1,
            "2026-01-26": 8,
            "2026-01-27": 10,
            "2026-01-30": 5,
            "2026-01-31": 1,
            "2026-02-02": 3,
            "2026-02-03": 6,
            "2026-02-04": 9,
            "2026-02-05": 11,
            "2026-02-06": 5,
            "2026-02-09": 6,
            "2026-02-10": 11,
            "2026-02-11": 5,
            "2026-02-12": 8,
            "2026-02-13": 3,
            "2026-02-14": 1,
            "2026-02-16": 31,
            "2026-02-17": 10,
            "2026-02-18": 29,
            "2026-02-19": 20,
            "2026-02-20": 18,
            "2026-02-23": 1,
            "2026-02-24": 12,
            "2026-02-25": 6,
            "2026-02-26": 13,
            "2026-03-01": 21,
            "2026-03-02": 18,
            "2026-03-03": 23,
            "2026-03-04": 36,
            "2026-03-05": 2,
            "2026-03-06": 4,
            "2026-03-09": 7,
            "2026-03-10": 4,
            "2026-03-11": 28,
            "2026-03-12": 8,
            "2026-03-13": 18,
            "2026-03-15": 1,
            "2026-03-16": 25,
            "2026-03-17": 19,
            "2026-03-18": 13,
            "2026-03-19": 9,
            "2026-03-20": 37,
            "2026-03-21": 9,
            "2026-03-23": 15,
            "2026-03-24": 14,
            "2026-03-25": 9,
            "2026-03-26": 11,
            "2026-03-27": 15,
            "2026-03-30": 17,
            "2026-03-31": 12,
            "2026-04-01": 6,
            "2026-04-02": 33,
            "2026-04-08": 21,
            "2026-04-09": 28,
            "2026-04-10": 20,
            "2026-04-13": 34,
            "2026-04-14": 2,
            "2026-04-15": 13,
            "2026-04-16": 28,
            "2026-04-17": 21,
            "2026-04-18": 16,
            "2026-04-20": 45,
            "2026-04-21": 2,
            "2026-04-22": 25,
            "2026-04-23": 29,
            "2026-04-24": 18,
            "2026-04-27": 41,
            "2026-04-28": 14,
            "2026-04-29": 26,
            "2026-04-30": 34,
            "2026-05-04": 71,
            "2026-05-05": 22,
            "2026-05-06": 23,
            "2026-05-07": 48,
            "2026-05-08": 2,
            "2026-05-09": 8,
            "2026-05-11": 75,
            "2026-05-12": 52,
            "2026-05-13": 31,
            "2026-05-14": 77,
            "2026-05-15": 36,
            "2026-05-16": 22,
            "2026-05-17": 1,
            "2026-05-18": 48,
            "2026-05-19": 44,
            "2026-05-20": 63,
            "2026-05-21": 55,
            "2026-05-22": 39,
            "2026-05-25": 1,
            "2026-05-28": 1,
            "2026-05-29": 1,
            "2026-05-30": 3,
            "2026-06-02": 5,
            "2026-06-03": 40,
            "2026-06-05": 83,
            "2026-06-06": 25,
            "2026-06-08": 7
          },
          "time_per_day": {
            "2025-10-06": 98.30899638888889,
            "2025-10-11": 82.95310138888888,
            "2025-10-14": 70.68604500000001,
            "2025-10-18": 165.31194305555556,
            "2025-11-04": 1043.6828805555556,
            "2025-11-06": 28.519268055555557,
            "2025-11-08": 0.5027602777777778,
            "2025-11-12": 1394.7102141666664,
            "2025-11-13": 7.715464444444444,
            "2025-11-20": 431.11313416666667,
            "2025-11-21": 4.607036111111111,
            "2025-11-24": 36.87699222222222,
            "2025-11-25": 113.66069527777779,
            "2025-11-30": 3.9426472222222224,
            "2025-12-02": 265.59195222222223,
            "2025-12-03": 72.06623888888889,
            "2025-12-08": 178.52628416666667,
            "2025-12-09": 347.58443361111114,
            "2025-12-11": 354.83350722222224,
            "2025-12-13": 22.585570555555556,
            "2025-12-15": 48.33467805555555,
            "2025-12-16": 85.33078166666667,
            "2025-12-18": 177.44043583333334,
            "2025-12-19": 226.8685688888889,
            "2025-12-20": 164.55994805555554,
            "2025-12-22": 50.34117972222222,
            "2025-12-24": 42.500729722222225,
            "2025-12-26": 3.097757777777778,
            "2025-12-28": 52.471337500000004,
            "2025-12-29": 1638.0612991666667,
            "2025-12-30": 393.04578333333336,
            "2026-01-05": 749.0600022222222,
            "2026-01-07": 172.67616333333334,
            "2026-01-08": 6.631965000000001,
            "2026-01-10": 74.0562225,
            "2026-01-13": 1053.978360277778,
            "2026-01-14": 40.990641388888896,
            "2026-01-16": 400.93805611111117,
            "2026-01-19": 1624.7149638888889,
            "2026-01-20": 325.5763625000001,
            "2026-01-21": 31.33533055555555,
            "2026-01-22": 132.4544647222222,
            "2026-01-23": 7.443530833333333,
            "2026-01-26": 1042.2138455555555,
            "2026-01-27": 1089.169176111111,
            "2026-01-30": 361.1774069444445,
            "2026-01-31": 2.6259602777777777,
            "2026-02-02": 102.26513000000001,
            "2026-02-03": 125.50274583333334,
            "2026-02-04": 49.15538416666666,
            "2026-02-05": 290.73572666666666,
            "2026-02-06": 71.96606555555555,
            "2026-02-09": 650.1478766666667,
            "2026-02-10": 1111.6242933333335,
            "2026-02-11": 1044.0843538888887,
            "2026-02-12": 1343.6791133333334,
            "2026-02-13": 194.37763083333334,
            "2026-02-14": 18.233544444444444,
            "2026-02-16": 242.93500611111105,
            "2026-02-17": 46.81790916666667,
            "2026-02-18": 10099.773053055558,
            "2026-02-19": 609.1640058333334,
            "2026-02-20": 408.4524377777777,
            "2026-02-23": 70.41375277777777,
            "2026-02-24": 13.757394166666668,
            "2026-02-25": 4.2011263888888895,
            "2026-02-26": 43.41168250000001,
            "2026-03-01": 500.97941805555564,
            "2026-03-02": 616.378101111111,
            "2026-03-03": 2317.1984608333332,
            "2026-03-04": 572.431281666667,
            "2026-03-05": 115.80278138888889,
            "2026-03-06": 22.71683777777778,
            "2026-03-09": 736.352243888889,
            "2026-03-10": 443.8316919444444,
            "2026-03-11": 4186.590230555555,
            "2026-03-12": 75.45444166666665,
            "2026-03-13": 237.85355055555556,
            "2026-03-15": 24.81566361111111,
            "2026-03-16": 250.4329880555555,
            "2026-03-17": 4817.236756111111,
            "2026-03-18": 24.50215472222222,
            "2026-03-19": 10.049879166666665,
            "2026-03-20": 15832.557142500003,
            "2026-03-21": 42.23932305555555,
            "2026-03-23": 226.22791444444442,
            "2026-03-24": 257.5039494444445,
            "2026-03-25": 139.49735138888892,
            "2026-03-26": 8.389298888888888,
            "2026-03-27": 3364.783826944444,
            "2026-03-30": 312.6296416666667,
            "2026-03-31": 408.84785583333326,
            "2026-04-01": 23.089324444444447,
            "2026-04-02": 11590.322334166665,
            "2026-04-08": 584.1872647222224,
            "2026-04-09": 679.6258086111112,
            "2026-04-10": 4306.7604997222215,
            "2026-04-13": 3514.1967633333325,
            "2026-04-14": 295.96116027777776,
            "2026-04-15": 2311.5083227777786,
            "2026-04-16": 39.876256388888905,
            "2026-04-17": 2044.2661383333334,
            "2026-04-18": 6949.032964722223,
            "2026-04-20": 1072.2402988888887,
            "2026-04-21": 0.40624805555555554,
            "2026-04-22": 48.799794444444444,
            "2026-04-23": 14098.193785000001,
            "2026-04-24": 163.73625333333337,
            "2026-04-27": 1801.494629166666,
            "2026-04-28": 470.45262388888887,
            "2026-04-29": 35.83221694444444,
            "2026-04-30": 209.36740027777782,
            "2026-05-04": 708.9382813888889,
            "2026-05-05": 21.000017777777778,
            "2026-05-06": 236.65377277777782,
            "2026-05-07": 6711.842716666666,
            "2026-05-08": 143.40255888888888,
            "2026-05-09": 214.3889363888889,
            "2026-05-11": 254.63180944444449,
            "2026-05-12": 2543.793348333333,
            "2026-05-13": 2949.965561388888,
            "2026-05-14": 8195.16643333333,
            "2026-05-15": 103.5975536111111,
            "2026-05-16": 150.9955297222222,
            "2026-05-17": 0.01920222222222222,
            "2026-05-18": 59.73469138888889,
            "2026-05-19": 58.28283027777778,
            "2026-05-20": 549.6751124999998,
            "2026-05-21": 556.1303508333332,
            "2026-05-22": 98.28122944444442,
            "2026-05-25": 76.09619500000001,
            "2026-05-30": 222.98155527777777,
            "2026-06-02": 200.86864694444444,
            "2026-06-03": 914.4228186111111,
            "2026-06-05": 312.62087277777795,
            "2026-06-06": 1999.5024544444448,
            "2026-06-08": 14.812650833333334
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-11": 2,
            "2025-10-14": 4,
            "2025-10-18": 3,
            "2025-11-04": 2,
            "2025-11-06": 1,
            "2025-11-08": 1,
            "2025-11-12": 6,
            "2025-11-13": 1,
            "2025-11-20": 1,
            "2025-11-21": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-30": 1,
            "2025-12-02": 3,
            "2025-12-03": 2,
            "2025-12-08": 1,
            "2025-12-09": 2,
            "2025-12-11": 3,
            "2025-12-13": 2,
            "2025-12-15": 1,
            "2025-12-16": 1,
            "2025-12-18": 2,
            "2025-12-19": 1,
            "2025-12-20": 1,
            "2025-12-22": 2,
            "2025-12-24": 1,
            "2025-12-26": 1,
            "2025-12-28": 5,
            "2025-12-29": 2,
            "2025-12-30": 5,
            "2026-01-05": 6,
            "2026-01-07": 1,
            "2026-01-08": 6,
            "2026-01-10": 6,
            "2026-01-13": 14,
            "2026-01-14": 3,
            "2026-01-16": 6,
            "2026-01-19": 15,
            "2026-01-20": 12,
            "2026-01-21": 2,
            "2026-01-22": 6,
            "2026-01-23": 1,
            "2026-01-26": 8,
            "2026-01-27": 10,
            "2026-01-30": 5,
            "2026-01-31": 1,
            "2026-02-02": 3,
            "2026-02-03": 5,
            "2026-02-04": 9,
            "2026-02-05": 11,
            "2026-02-06": 5,
            "2026-02-09": 6,
            "2026-02-10": 11,
            "2026-02-11": 5,
            "2026-02-12": 6,
            "2026-02-13": 3,
            "2026-02-14": 1,
            "2026-02-16": 13,
            "2026-02-17": 4,
            "2026-02-18": 29,
            "2026-02-19": 20,
            "2026-02-20": 18,
            "2026-02-23": 1,
            "2026-02-24": 12,
            "2026-02-25": 6,
            "2026-02-26": 13,
            "2026-03-01": 21,
            "2026-03-02": 17,
            "2026-03-03": 21,
            "2026-03-04": 36,
            "2026-03-05": 2,
            "2026-03-06": 4,
            "2026-03-09": 7,
            "2026-03-10": 4,
            "2026-03-11": 26,
            "2026-03-12": 8,
            "2026-03-13": 17,
            "2026-03-15": 1,
            "2026-03-16": 23,
            "2026-03-17": 18,
            "2026-03-18": 12,
            "2026-03-19": 8,
            "2026-03-20": 36,
            "2026-03-21": 9,
            "2026-03-23": 14,
            "2026-03-24": 14,
            "2026-03-25": 9,
            "2026-03-26": 9,
            "2026-03-27": 15,
            "2026-03-30": 15,
            "2026-03-31": 11,
            "2026-04-01": 6,
            "2026-04-02": 33,
            "2026-04-08": 20,
            "2026-04-09": 28,
            "2026-04-10": 19,
            "2026-04-13": 34,
            "2026-04-14": 1,
            "2026-04-15": 12,
            "2026-04-16": 28,
            "2026-04-17": 19,
            "2026-04-18": 16,
            "2026-04-20": 42,
            "2026-04-21": 2,
            "2026-04-22": 23,
            "2026-04-23": 29,
            "2026-04-24": 18,
            "2026-04-27": 39,
            "2026-04-28": 11,
            "2026-04-29": 20,
            "2026-04-30": 31,
            "2026-05-04": 66,
            "2026-05-05": 19,
            "2026-05-06": 21,
            "2026-05-07": 43,
            "2026-05-08": 1,
            "2026-05-09": 6,
            "2026-05-11": 71,
            "2026-05-12": 42,
            "2026-05-13": 31,
            "2026-05-14": 72,
            "2026-05-15": 32,
            "2026-05-16": 22,
            "2026-05-17": 1,
            "2026-05-18": 44,
            "2026-05-19": 40,
            "2026-05-20": 56,
            "2026-05-21": 47,
            "2026-05-22": 34,
            "2026-05-25": 1,
            "2026-05-30": 3,
            "2026-06-02": 1,
            "2026-06-03": 39,
            "2026-06-05": 74,
            "2026-06-06": 18,
            "2026-06-08": 5
          }
        },
        "P3": {
          "avg_time_hours": 283.41,
          "mode_time_hours": 3.0,
          "mode_frequency": 14,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 14,
            "4-6h": 8,
            "6-8h": 11,
            "8-10h": 3,
            "10-12h": 1,
            "12-14h": 2,
            "14-16h": 1,
            "16-18h": 3,
            "18-20h": 8,
            "20-22h": 3,
            "22-24h": 2,
            "24-26h": 8,
            "26-28h": 3,
            "28-30h": 2,
            "30-32h": 1,
            "32-34h": 1,
            "42-44h": 1,
            "46-48h": 3,
            "50-52h": 1,
            "52-54h": 1,
            "62-64h": 1,
            "66-68h": 2,
            "68-70h": 2,
            "70-72h": 3,
            "72-74h": 1,
            "74-76h": 2,
            "88-90h": 1,
            "98-100h": 2,
            "100-102h": 2,
            "120-122h": 1,
            "124-126h": 1,
            "172-174h": 1,
            "194-196h": 1,
            "242-244h": 1,
            "258-260h": 1,
            "282-284h": 1,
            "318-320h": 1,
            "338-340h": 1,
            "342-344h": 1,
            "358-360h": 1,
            "362-364h": 1,
            "382-384h": 1,
            "410-412h": 1,
            "416-418h": 1,
            "500-502h": 1,
            "502-504h": 1,
            "578-580h": 1,
            "592-594h": 1,
            "594-596h": 1,
            "648-650h": 1,
            "696-698h": 1,
            "698-700h": 1,
            "742-744h": 1,
            "840-842h": 1,
            "842-844h": 1,
            "846-848h": 1,
            "896-898h": 1,
            "944-946h": 1,
            "986-988h": 1,
            "1198-1200h": 1,
            "1468-1470h": 1,
            "1508-1510h": 1,
            "1752-1754h": 1,
            "1830-1832h": 1,
            "1944-1946h": 1,
            "1962-1964h": 1,
            "2372-2374h": 1,
            "3550-3552h": 1,
            "4036-4038h": 1
          },
          "tickets_count": 144,
          "tickets_per_day": {
            "2025-10-18": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-11-07": 12,
            "2025-11-08": 1,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-13": 4,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-22": 1,
            "2025-11-25": 4,
            "2025-11-26": 1,
            "2025-12-02": 6,
            "2025-12-03": 3,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-13": 1,
            "2025-12-18": 5,
            "2025-12-19": 1,
            "2025-12-23": 2,
            "2025-12-28": 1,
            "2025-12-30": 2,
            "2026-01-05": 2,
            "2026-01-07": 3,
            "2026-01-08": 2,
            "2026-01-13": 7,
            "2026-01-16": 2,
            "2026-01-19": 5,
            "2026-01-22": 1,
            "2026-01-26": 5,
            "2026-01-27": 2,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-04": 2,
            "2026-02-07": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 6,
            "2026-02-16": 1,
            "2026-02-18": 5,
            "2026-02-19": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-20": 2,
            "2026-03-27": 2,
            "2026-03-31": 2,
            "2026-04-06": 1,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-13": 1,
            "2026-05-14": 4,
            "2026-06-06": 3
          },
          "time_per_day": {
            "2025-10-18": 88.81827666666666,
            "2025-11-04": 649.8871144444445,
            "2025-11-06": 743.9638888888888,
            "2025-11-07": 52.41845138888888,
            "2025-11-08": 358.8417494444444,
            "2025-11-11": 33.308388888888885,
            "2025-11-12": 1735.661568611111,
            "2025-11-13": 125.80431916666666,
            "2025-11-17": 209.3923472222222,
            "2025-11-18": 20.3284025,
            "2025-11-22": 3.430708888888889,
            "2025-11-25": 365.7489238888889,
            "2025-11-26": 26.488642777777777,
            "2025-12-02": 421.1237969444444,
            "2025-12-03": 110.68159583333333,
            "2025-12-10": 9.213739444444444,
            "2025-12-11": 200.5044111111111,
            "2025-12-13": 593.7800633333334,
            "2025-12-18": 216.3337013888889,
            "2025-12-19": 23.5684,
            "2025-12-23": 64.29745166666666,
            "2025-12-28": 99.04570694444443,
            "2025-12-30": 381.05348888888886,
            "2026-01-05": 275.25742694444443,
            "2026-01-07": 916.806945,
            "2026-01-08": 14.76477638888889,
            "2026-01-13": 213.9673166666667,
            "2026-01-16": 19.49048611111111,
            "2026-01-19": 162.29513666666668,
            "2026-01-22": 23.52322583333333,
            "2026-01-26": 449.3969505555556,
            "2026-01-27": 40.89021777777778,
            "2026-02-02": 12.848271944444445,
            "2026-02-03": 2.4500583333333332,
            "2026-02-04": 64.65150694444445,
            "2026-02-07": 2.790459166666667,
            "2026-02-09": 75.89560777777778,
            "2026-02-10": 259.2024772222222,
            "2026-02-11": 25.4033575,
            "2026-02-12": 610.4464275,
            "2026-02-13": 112.58855861111113,
            "2026-02-16": 1831.8803725,
            "2026-02-18": 6434.389757222222,
            "2026-02-19": 52.46980305555555,
            "2026-02-26": 3.644743611111111,
            "2026-02-27": 503.90358944444444,
            "2026-03-04": 8.818540277777778,
            "2026-03-09": 75.00128027777778,
            "2026-03-11": 896.9744666666667,
            "2026-03-16": 121.23318083333334,
            "2026-03-20": 1834.3221227777776,
            "2026-03-27": 2698.5429511111115,
            "2026-03-31": 1.6288516666666668,
            "2026-04-13": 7.108693611111111,
            "2026-04-16": 501.0308769444444,
            "2026-04-17": 1.0168580555555555,
            "2026-04-23": 1199.8848105555555,
            "2026-05-05": 417.4196763888889,
            "2026-05-13": 0.0522225,
            "2026-05-14": 11432.203654166666,
            "2026-06-06": 1556.4501066666667
          },
          "time_count_per_day": {
            "2025-10-18": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-11-07": 12,
            "2025-11-08": 1,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-13": 4,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-22": 1,
            "2025-11-25": 4,
            "2025-11-26": 1,
            "2025-12-02": 6,
            "2025-12-03": 3,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-13": 1,
            "2025-12-18": 5,
            "2025-12-19": 1,
            "2025-12-23": 2,
            "2025-12-28": 1,
            "2025-12-30": 2,
            "2026-01-05": 2,
            "2026-01-07": 3,
            "2026-01-08": 2,
            "2026-01-13": 7,
            "2026-01-16": 2,
            "2026-01-19": 5,
            "2026-01-22": 1,
            "2026-01-26": 5,
            "2026-01-27": 2,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-04": 2,
            "2026-02-07": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 6,
            "2026-02-16": 1,
            "2026-02-18": 5,
            "2026-02-19": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-20": 2,
            "2026-03-27": 2,
            "2026-03-31": 2,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-13": 1,
            "2026-05-14": 4,
            "2026-06-06": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 131.62,
          "mode_time_hours": 7.0,
          "mode_frequency": 3,
          "time_distribution": {
            "6-8h": 3,
            "8-10h": 1,
            "10-12h": 2,
            "24-26h": 2,
            "54-56h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "82-84h": 1,
            "192-194h": 1,
            "194-196h": 1,
            "196-198h": 2,
            "198-200h": 1,
            "384-386h": 1,
            "740-742h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-10": 2,
            "2026-01-14": 5,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-06-06": 8
          },
          "time_per_day": {
            "2025-12-03": 741.2985652777778,
            "2025-12-10": 51.92900694444444,
            "2026-01-14": 43.27879,
            "2026-01-16": 83.72504388888889,
            "2026-01-19": 54.43967666666667,
            "2026-01-26": 6.711571111111111,
            "2026-06-06": 1519.3073911111112
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-10": 2,
            "2026-01-14": 5,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-06-06": 8
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 123.22,
          "mode_time_hours": 103.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "102-104h": 1,
            "104-106h": 1,
            "122-124h": 1,
            "124-126h": 1,
            "258-260h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-08": 1,
            "2025-12-11": 1,
            "2025-12-20": 1,
            "2026-01-13": 1
          },
          "time_per_day": {
            "2025-12-02": 103.56525027777778,
            "2025-12-05": 105.44115166666667,
            "2025-12-08": 124.1030525,
            "2025-12-11": 122.03653194444445,
            "2025-12-20": 258.72006055555556,
            "2026-01-13": 25.449099166666667
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-08": 1,
            "2025-12-11": 1,
            "2025-12-20": 1,
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 90.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 1030,
            "time_distribution": {
              "0-2h": 1030,
              "2-4h": 259,
              "4-6h": 70,
              "6-8h": 59,
              "8-10h": 17,
              "10-12h": 39,
              "12-14h": 31,
              "14-16h": 17,
              "16-18h": 29,
              "18-20h": 25,
              "20-22h": 13,
              "22-24h": 12,
              "24-26h": 28,
              "26-28h": 12,
              "28-30h": 12,
              "30-32h": 6,
              "32-34h": 3,
              "34-36h": 2,
              "36-38h": 4,
              "38-40h": 1,
              "40-42h": 13,
              "42-44h": 10,
              "44-46h": 6,
              "46-48h": 9,
              "48-50h": 10,
              "50-52h": 5,
              "52-54h": 12,
              "54-56h": 7,
              "58-60h": 1,
              "60-62h": 2,
              "62-64h": 1,
              "64-66h": 7,
              "66-68h": 9,
              "68-70h": 6,
              "70-72h": 7,
              "72-74h": 11,
              "74-76h": 8,
              "76-78h": 9,
              "78-80h": 5,
              "82-84h": 1,
              "84-86h": 1,
              "88-90h": 3,
              "90-92h": 1,
              "94-96h": 3,
              "96-98h": 3,
              "98-100h": 4,
              "100-102h": 2,
              "102-104h": 3,
              "104-106h": 1,
              "108-110h": 2,
              "110-112h": 1,
              "112-114h": 1,
              "114-116h": 1,
              "116-118h": 2,
              "120-122h": 1,
              "122-124h": 5,
              "124-126h": 5,
              "126-128h": 2,
              "134-136h": 1,
              "138-140h": 2,
              "140-142h": 3,
              "142-144h": 2,
              "144-146h": 1,
              "146-148h": 3,
              "148-150h": 5,
              "150-152h": 1,
              "158-160h": 1,
              "160-162h": 1,
              "162-164h": 2,
              "164-166h": 5,
              "166-168h": 1,
              "168-170h": 1,
              "170-172h": 1,
              "172-174h": 2,
              "174-176h": 2,
              "176-178h": 1,
              "178-180h": 1,
              "180-182h": 1,
              "186-188h": 1,
              "190-192h": 1,
              "192-194h": 1,
              "194-196h": 3,
              "196-198h": 2,
              "198-200h": 1,
              "200-202h": 3,
              "214-216h": 3,
              "220-222h": 1,
              "222-224h": 1,
              "226-228h": 1,
              "232-234h": 1,
              "236-238h": 1,
              "240-242h": 1,
              "242-244h": 2,
              "258-260h": 2,
              "262-264h": 2,
              "266-268h": 2,
              "268-270h": 1,
              "276-278h": 1,
              "282-284h": 1,
              "288-290h": 1,
              "294-296h": 1,
              "304-306h": 1,
              "308-310h": 2,
              "310-312h": 2,
              "312-314h": 3,
              "314-316h": 1,
              "318-320h": 1,
              "328-330h": 1,
              "330-332h": 1,
              "332-334h": 4,
              "336-338h": 3,
              "338-340h": 3,
              "340-342h": 3,
              "342-344h": 2,
              "348-350h": 1,
              "356-358h": 2,
              "358-360h": 1,
              "360-362h": 1,
              "362-364h": 1,
              "366-368h": 1,
              "380-382h": 2,
              "382-384h": 4,
              "384-386h": 3,
              "388-390h": 1,
              "408-410h": 3,
              "410-412h": 3,
              "412-414h": 1,
              "416-418h": 1,
              "418-420h": 1,
              "430-432h": 1,
              "432-434h": 1,
              "450-452h": 1,
              "452-454h": 1,
              "454-456h": 2,
              "456-458h": 2,
              "462-464h": 1,
              "480-482h": 2,
              "498-500h": 1,
              "500-502h": 1,
              "502-504h": 1,
              "520-522h": 1,
              "524-526h": 1,
              "526-528h": 1,
              "530-532h": 1,
              "536-538h": 1,
              "558-560h": 1,
              "560-562h": 1,
              "570-572h": 1,
              "572-574h": 1,
              "576-578h": 3,
              "578-580h": 3,
              "580-582h": 1,
              "582-584h": 2,
              "592-594h": 1,
              "594-596h": 2,
              "596-598h": 1,
              "604-606h": 1,
              "610-612h": 1,
              "612-614h": 1,
              "628-630h": 1,
              "642-644h": 1,
              "648-650h": 1,
              "652-654h": 1,
              "654-656h": 1,
              "658-660h": 1,
              "670-672h": 2,
              "672-674h": 1,
              "696-698h": 2,
              "698-700h": 2,
              "714-716h": 1,
              "724-726h": 2,
              "740-742h": 1,
              "742-744h": 1,
              "766-768h": 2,
              "772-774h": 1,
              "780-782h": 1,
              "788-790h": 1,
              "790-792h": 1,
              "792-794h": 1,
              "796-798h": 1,
              "816-818h": 1,
              "818-820h": 1,
              "840-842h": 1,
              "842-844h": 1,
              "846-848h": 2,
              "862-864h": 1,
              "864-866h": 1,
              "884-886h": 1,
              "892-894h": 1,
              "896-898h": 1,
              "904-906h": 1,
              "908-910h": 1,
              "910-912h": 1,
              "936-938h": 1,
              "942-944h": 1,
              "944-946h": 1,
              "954-956h": 1,
              "956-958h": 1,
              "984-986h": 1,
              "986-988h": 2,
              "990-992h": 1,
              "1008-1010h": 1,
              "1026-1028h": 1,
              "1034-1036h": 1,
              "1038-1040h": 1,
              "1054-1056h": 1,
              "1056-1058h": 1,
              "1058-1060h": 1,
              "1072-1074h": 1,
              "1074-1076h": 1,
              "1076-1078h": 1,
              "1078-1080h": 1,
              "1080-1082h": 1,
              "1086-1088h": 1,
              "1104-1106h": 1,
              "1112-1114h": 1,
              "1146-1148h": 1,
              "1156-1158h": 1,
              "1170-1172h": 1,
              "1194-1196h": 1,
              "1196-1198h": 1,
              "1198-1200h": 2,
              "1222-1224h": 2,
              "1248-1250h": 1,
              "1264-1266h": 1,
              "1266-1268h": 1,
              "1272-1274h": 1,
              "1294-1296h": 1,
              "1316-1318h": 1,
              "1322-1324h": 1,
              "1338-1340h": 1,
              "1342-1344h": 1,
              "1366-1368h": 1,
              "1404-1406h": 1,
              "1410-1412h": 1,
              "1468-1470h": 1,
              "1508-1510h": 1,
              "1578-1580h": 1,
              "1632-1634h": 1,
              "1634-1636h": 1,
              "1752-1754h": 1,
              "1830-1832h": 1,
              "1942-1944h": 1,
              "1944-1946h": 1,
              "1962-1964h": 1,
              "2044-2046h": 1,
              "2060-2062h": 1,
              "2108-2110h": 1,
              "2250-2252h": 1,
              "2372-2374h": 1,
              "3550-3552h": 1,
              "4036-4038h": 1
            },
            "tickets_count": 2114,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-06": 2,
              "2025-10-11": 2,
              "2025-10-14": 4,
              "2025-10-18": 4,
              "2025-11-04": 3,
              "2025-11-06": 2,
              "2025-11-07": 12,
              "2025-11-08": 2,
              "2025-11-11": 2,
              "2025-11-12": 9,
              "2025-11-13": 5,
              "2025-11-17": 4,
              "2025-11-18": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-24": 2,
              "2025-11-25": 5,
              "2025-11-26": 1,
              "2025-11-30": 1,
              "2025-12-02": 11,
              "2025-12-03": 6,
              "2025-12-05": 1,
              "2025-12-08": 2,
              "2025-12-09": 2,
              "2025-12-10": 3,
              "2025-12-11": 6,
              "2025-12-12": 1,
              "2025-12-13": 3,
              "2025-12-15": 1,
              "2025-12-16": 1,
              "2025-12-18": 7,
              "2025-12-19": 2,
              "2025-12-20": 2,
              "2025-12-22": 2,
              "2025-12-23": 2,
              "2025-12-24": 1,
              "2025-12-26": 1,
              "2025-12-28": 6,
              "2025-12-29": 2,
              "2025-12-30": 7,
              "2026-01-05": 8,
              "2026-01-07": 4,
              "2026-01-08": 8,
              "2026-01-10": 6,
              "2026-01-13": 22,
              "2026-01-14": 8,
              "2026-01-16": 9,
              "2026-01-19": 21,
              "2026-01-20": 13,
              "2026-01-21": 2,
              "2026-01-22": 7,
              "2026-01-23": 1,
              "2026-01-26": 14,
              "2026-01-27": 12,
              "2026-01-30": 5,
              "2026-01-31": 1,
              "2026-02-02": 5,
              "2026-02-03": 6,
              "2026-02-04": 11,
              "2026-02-05": 11,
              "2026-02-06": 5,
              "2026-02-07": 1,
              "2026-02-09": 7,
              "2026-02-10": 12,
              "2026-02-11": 6,
              "2026-02-12": 9,
              "2026-02-13": 9,
              "2026-02-14": 1,
              "2026-02-16": 14,
              "2026-02-17": 4,
              "2026-02-18": 34,
              "2026-02-19": 21,
              "2026-02-20": 18,
              "2026-02-23": 1,
              "2026-02-24": 12,
              "2026-02-25": 6,
              "2026-02-26": 14,
              "2026-02-27": 1,
              "2026-03-01": 21,
              "2026-03-02": 17,
              "2026-03-03": 23,
              "2026-03-04": 37,
              "2026-03-05": 2,
              "2026-03-06": 5,
              "2026-03-09": 8,
              "2026-03-10": 5,
              "2026-03-11": 27,
              "2026-03-12": 8,
              "2026-03-13": 17,
              "2026-03-15": 1,
              "2026-03-16": 24,
              "2026-03-17": 19,
              "2026-03-18": 12,
              "2026-03-19": 8,
              "2026-03-20": 39,
              "2026-03-21": 10,
              "2026-03-23": 15,
              "2026-03-24": 14,
              "2026-03-25": 9,
              "2026-03-26": 9,
              "2026-03-27": 17,
              "2026-03-30": 15,
              "2026-03-31": 13,
              "2026-04-01": 6,
              "2026-04-02": 34,
              "2026-04-08": 20,
              "2026-04-09": 29,
              "2026-04-10": 21,
              "2026-04-13": 35,
              "2026-04-14": 1,
              "2026-04-15": 12,
              "2026-04-16": 29,
              "2026-04-17": 21,
              "2026-04-18": 17,
              "2026-04-20": 42,
              "2026-04-21": 2,
              "2026-04-22": 23,
              "2026-04-23": 30,
              "2026-04-24": 18,
              "2026-04-27": 39,
              "2026-04-28": 11,
              "2026-04-29": 20,
              "2026-04-30": 31,
              "2026-05-04": 68,
              "2026-05-05": 20,
              "2026-05-06": 21,
              "2026-05-07": 44,
              "2026-05-08": 1,
              "2026-05-09": 6,
              "2026-05-11": 71,
              "2026-05-12": 43,
              "2026-05-13": 32,
              "2026-05-14": 77,
              "2026-05-15": 32,
              "2026-05-16": 22,
              "2026-05-17": 1,
              "2026-05-18": 44,
              "2026-05-19": 41,
              "2026-05-20": 57,
              "2026-05-21": 47,
              "2026-05-22": 34,
              "2026-05-25": 1,
              "2026-05-30": 3,
              "2026-06-02": 1,
              "2026-06-03": 39,
              "2026-06-05": 75,
              "2026-06-06": 29,
              "2026-06-08": 5
            },
            "time_per_day": {
              "2025-10-01": 28.2095025,
              "2025-10-03": 0.2522908333333333,
              "2025-10-06": 100.90845999999999,
              "2025-10-11": 82.95310138888888,
              "2025-10-14": 70.68604500000001,
              "2025-10-18": 254.13021972222222,
              "2025-11-04": 1693.569995,
              "2025-11-06": 772.4831569444444,
              "2025-11-07": 52.41845138888888,
              "2025-11-08": 359.3445097222222,
              "2025-11-11": 33.308388888888885,
              "2025-11-12": 3130.3717827777778,
              "2025-11-13": 133.5197836111111,
              "2025-11-17": 209.3923472222222,
              "2025-11-18": 20.3284025,
              "2025-11-20": 431.11313416666667,
              "2025-11-21": 4.607036111111111,
              "2025-11-22": 3.430708888888889,
              "2025-11-24": 38.954905277777776,
              "2025-11-25": 479.4096191666667,
              "2025-11-26": 26.488642777777777,
              "2025-11-30": 3.9426472222222224,
              "2025-12-02": 790.5379177777778,
              "2025-12-03": 924.0464,
              "2025-12-05": 105.44115166666667,
              "2025-12-08": 302.6293366666667,
              "2025-12-09": 347.58443361111114,
              "2025-12-10": 61.14274638888888,
              "2025-12-11": 677.3744502777777,
              "2025-12-12": 3.2853466666666664,
              "2025-12-13": 616.365633888889,
              "2025-12-15": 48.33467805555555,
              "2025-12-16": 85.33078166666667,
              "2025-12-18": 393.77413722222224,
              "2025-12-19": 250.43696888888888,
              "2025-12-20": 423.2800086111111,
              "2025-12-22": 50.34117972222222,
              "2025-12-23": 64.29745166666666,
              "2025-12-24": 42.500729722222225,
              "2025-12-26": 3.097757777777778,
              "2025-12-28": 151.51704444444445,
              "2025-12-29": 1638.0612991666667,
              "2025-12-30": 774.0992722222221,
              "2026-01-05": 1024.3174291666667,
              "2026-01-07": 1089.4831083333331,
              "2026-01-08": 21.39674138888889,
              "2026-01-10": 74.0562225,
              "2026-01-13": 1293.3947761111112,
              "2026-01-14": 84.26943138888889,
              "2026-01-16": 504.15358611111117,
              "2026-01-19": 1841.4497772222219,
              "2026-01-20": 334.11286111111116,
              "2026-01-21": 31.33533055555555,
              "2026-01-22": 155.97769055555557,
              "2026-01-23": 7.443530833333333,
              "2026-01-26": 1498.322367222222,
              "2026-01-27": 1130.0593938888887,
              "2026-01-30": 361.1774069444445,
              "2026-01-31": 2.6259602777777777,
              "2026-02-02": 115.11340194444445,
              "2026-02-03": 127.95280416666667,
              "2026-02-04": 113.80689111111113,
              "2026-02-05": 290.73572666666666,
              "2026-02-06": 71.96606555555555,
              "2026-02-07": 2.790459166666667,
              "2026-02-09": 726.0434844444444,
              "2026-02-10": 1370.8267705555556,
              "2026-02-11": 1069.4877113888888,
              "2026-02-12": 1954.1255408333334,
              "2026-02-13": 306.96618944444435,
              "2026-02-14": 18.233544444444444,
              "2026-02-16": 2074.8153786111106,
              "2026-02-17": 46.81790916666667,
              "2026-02-18": 16534.162810277776,
              "2026-02-19": 661.6338088888889,
              "2026-02-20": 408.4524377777777,
              "2026-02-23": 70.41375277777777,
              "2026-02-24": 13.757394166666668,
              "2026-02-25": 4.2011263888888895,
              "2026-02-26": 47.05642611111112,
              "2026-02-27": 503.90358944444444,
              "2026-03-01": 500.97941805555564,
              "2026-03-02": 616.378101111111,
              "2026-03-03": 2317.721344722222,
              "2026-03-04": 581.2498219444448,
              "2026-03-05": 115.80278138888889,
              "2026-03-06": 149.67878055555553,
              "2026-03-09": 811.3535241666668,
              "2026-03-10": 1224.7594636111112,
              "2026-03-11": 5083.564697222221,
              "2026-03-12": 75.45444166666665,
              "2026-03-13": 237.85355055555556,
              "2026-03-15": 24.81566361111111,
              "2026-03-16": 371.6661688888889,
              "2026-03-17": 4889.832371666667,
              "2026-03-18": 24.50215472222222,
              "2026-03-19": 10.049879166666665,
              "2026-03-20": 17668.910679444452,
              "2026-03-21": 70.54546388888889,
              "2026-03-23": 303.5225911111111,
              "2026-03-24": 257.5039494444445,
              "2026-03-25": 139.49735138888892,
              "2026-03-26": 8.389298888888888,
              "2026-03-27": 6063.326778055556,
              "2026-03-30": 312.6296416666667,
              "2026-03-31": 410.4767074999999,
              "2026-04-01": 23.089324444444447,
              "2026-04-02": 12676.853988888886,
              "2026-04-08": 584.1872647222224,
              "2026-04-09": 704.2082036111112,
              "2026-04-10": 4335.806061666666,
              "2026-04-13": 3521.3054569444434,
              "2026-04-14": 295.96116027777776,
              "2026-04-15": 2311.5083227777786,
              "2026-04-16": 540.9071333333328,
              "2026-04-17": 2047.8296919444444,
              "2026-04-18": 6951.719850277779,
              "2026-04-20": 1072.2402988888887,
              "2026-04-21": 0.40624805555555554,
              "2026-04-22": 48.799794444444444,
              "2026-04-23": 15298.078595555558,
              "2026-04-24": 163.73625333333337,
              "2026-04-27": 1801.494629166666,
              "2026-04-28": 470.45262388888887,
              "2026-04-29": 35.83221694444444,
              "2026-04-30": 209.36740027777782,
              "2026-05-04": 812.2141269444444,
              "2026-05-05": 438.4196941666667,
              "2026-05-06": 236.65377277777782,
              "2026-05-07": 7016.756178333333,
              "2026-05-08": 143.40255888888888,
              "2026-05-09": 214.3889363888889,
              "2026-05-11": 254.63180944444449,
              "2026-05-12": 2559.0889905555555,
              "2026-05-13": 2950.017783888888,
              "2026-05-14": 19772.84391166668,
              "2026-05-15": 103.5975536111111,
              "2026-05-16": 150.9955297222222,
              "2026-05-17": 0.01920222222222222,
              "2026-05-18": 59.73469138888889,
              "2026-05-19": 62.55724861111112,
              "2026-05-20": 550.7758802777777,
              "2026-05-21": 556.1303508333332,
              "2026-05-22": 98.28122944444442,
              "2026-05-25": 76.09619500000001,
              "2026-05-30": 222.98155527777777,
              "2026-06-02": 200.86864694444444,
              "2026-06-03": 914.4228186111111,
              "2026-06-05": 983.9036169444445,
              "2026-06-06": 5075.259952222224,
              "2026-06-08": 14.812650833333334
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-06": 2,
              "2025-10-11": 2,
              "2025-10-14": 4,
              "2025-10-18": 4,
              "2025-11-04": 3,
              "2025-11-06": 2,
              "2025-11-07": 12,
              "2025-11-08": 2,
              "2025-11-11": 2,
              "2025-11-12": 9,
              "2025-11-13": 5,
              "2025-11-17": 4,
              "2025-11-18": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-24": 2,
              "2025-11-25": 5,
              "2025-11-26": 1,
              "2025-11-30": 1,
              "2025-12-02": 11,
              "2025-12-03": 6,
              "2025-12-05": 1,
              "2025-12-08": 2,
              "2025-12-09": 2,
              "2025-12-10": 3,
              "2025-12-11": 6,
              "2025-12-12": 1,
              "2025-12-13": 3,
              "2025-12-15": 1,
              "2025-12-16": 1,
              "2025-12-18": 7,
              "2025-12-19": 2,
              "2025-12-20": 2,
              "2025-12-22": 2,
              "2025-12-23": 2,
              "2025-12-24": 1,
              "2025-12-26": 1,
              "2025-12-28": 6,
              "2025-12-29": 2,
              "2025-12-30": 7,
              "2026-01-05": 8,
              "2026-01-07": 4,
              "2026-01-08": 8,
              "2026-01-10": 6,
              "2026-01-13": 22,
              "2026-01-14": 8,
              "2026-01-16": 9,
              "2026-01-19": 21,
              "2026-01-20": 13,
              "2026-01-21": 2,
              "2026-01-22": 7,
              "2026-01-23": 1,
              "2026-01-26": 14,
              "2026-01-27": 12,
              "2026-01-30": 5,
              "2026-01-31": 1,
              "2026-02-02": 5,
              "2026-02-03": 6,
              "2026-02-04": 11,
              "2026-02-05": 11,
              "2026-02-06": 5,
              "2026-02-07": 1,
              "2026-02-09": 7,
              "2026-02-10": 12,
              "2026-02-11": 6,
              "2026-02-12": 9,
              "2026-02-13": 9,
              "2026-02-14": 1,
              "2026-02-16": 14,
              "2026-02-17": 4,
              "2026-02-18": 34,
              "2026-02-19": 21,
              "2026-02-20": 18,
              "2026-02-23": 1,
              "2026-02-24": 12,
              "2026-02-25": 6,
              "2026-02-26": 14,
              "2026-02-27": 1,
              "2026-03-01": 21,
              "2026-03-02": 17,
              "2026-03-03": 23,
              "2026-03-04": 37,
              "2026-03-05": 2,
              "2026-03-06": 5,
              "2026-03-09": 8,
              "2026-03-10": 5,
              "2026-03-11": 27,
              "2026-03-12": 8,
              "2026-03-13": 17,
              "2026-03-15": 1,
              "2026-03-16": 24,
              "2026-03-17": 19,
              "2026-03-18": 12,
              "2026-03-19": 8,
              "2026-03-20": 39,
              "2026-03-21": 10,
              "2026-03-23": 15,
              "2026-03-24": 14,
              "2026-03-25": 9,
              "2026-03-26": 9,
              "2026-03-27": 17,
              "2026-03-30": 15,
              "2026-03-31": 13,
              "2026-04-01": 6,
              "2026-04-02": 34,
              "2026-04-08": 20,
              "2026-04-09": 29,
              "2026-04-10": 21,
              "2026-04-13": 35,
              "2026-04-14": 1,
              "2026-04-15": 12,
              "2026-04-16": 29,
              "2026-04-17": 21,
              "2026-04-18": 17,
              "2026-04-20": 42,
              "2026-04-21": 2,
              "2026-04-22": 23,
              "2026-04-23": 30,
              "2026-04-24": 18,
              "2026-04-27": 39,
              "2026-04-28": 11,
              "2026-04-29": 20,
              "2026-04-30": 31,
              "2026-05-04": 68,
              "2026-05-05": 20,
              "2026-05-06": 21,
              "2026-05-07": 44,
              "2026-05-08": 1,
              "2026-05-09": 6,
              "2026-05-11": 71,
              "2026-05-12": 43,
              "2026-05-13": 32,
              "2026-05-14": 77,
              "2026-05-15": 32,
              "2026-05-16": 22,
              "2026-05-17": 1,
              "2026-05-18": 44,
              "2026-05-19": 41,
              "2026-05-20": 57,
              "2026-05-21": 47,
              "2026-05-22": 34,
              "2026-05-25": 1,
              "2026-05-30": 3,
              "2026-06-02": 1,
              "2026-06-03": 39,
              "2026-06-05": 75,
              "2026-06-06": 29,
              "2026-06-08": 5
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 121.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 6,
                "4-6h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "28-30h": 2,
                "48-50h": 1,
                "54-56h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "126-128h": 1,
                "144-146h": 1,
                "304-306h": 1,
                "670-672h": 1,
                "780-782h": 1,
                "1086-1088h": 1
              },
              "tickets_count": 29,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2026-01-20": 1,
                "2026-03-03": 2,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-21": 1,
                "2026-03-23": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-04": 2,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-01": 28.2095025,
                "2025-10-03": 0.2522908333333333,
                "2025-10-06": 2.599463611111111,
                "2025-11-24": 2.0779130555555554,
                "2025-12-02": 0.2569183333333333,
                "2025-12-12": 3.2853466666666664,
                "2026-01-20": 8.536498611111112,
                "2026-03-03": 0.5228838888888888,
                "2026-03-06": 126.96194277777778,
                "2026-03-10": 780.9277716666667,
                "2026-03-17": 72.59561555555555,
                "2026-03-20": 2.031414166666667,
                "2026-03-21": 28.306140833333334,
                "2026-03-23": 77.29467666666667,
                "2026-04-02": 1086.5316547222221,
                "2026-04-09": 24.582395,
                "2026-04-10": 29.045561944444447,
                "2026-04-17": 2.5466955555555555,
                "2026-04-18": 2.6868855555555555,
                "2026-05-04": 103.27584555555555,
                "2026-05-07": 304.9134616666667,
                "2026-05-12": 15.295642222222222,
                "2026-05-14": 145.47382416666667,
                "2026-05-19": 4.274418333333333,
                "2026-05-20": 1.1007677777777778,
                "2026-06-05": 671.2827441666667
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2026-01-20": 1,
                "2026-03-03": 2,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-21": 1,
                "2026-03-23": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-04": 2,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 75.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 1018,
              "time_distribution": {
                "0-2h": 1018,
                "2-4h": 239,
                "4-6h": 61,
                "6-8h": 45,
                "8-10h": 12,
                "10-12h": 36,
                "12-14h": 29,
                "14-16h": 15,
                "16-18h": 26,
                "18-20h": 17,
                "20-22h": 10,
                "22-24h": 10,
                "24-26h": 16,
                "26-28h": 8,
                "28-30h": 8,
                "30-32h": 5,
                "32-34h": 2,
                "34-36h": 2,
                "36-38h": 4,
                "38-40h": 1,
                "40-42h": 13,
                "42-44h": 9,
                "44-46h": 6,
                "46-48h": 6,
                "48-50h": 9,
                "50-52h": 4,
                "52-54h": 11,
                "54-56h": 5,
                "58-60h": 1,
                "60-62h": 2,
                "64-66h": 7,
                "66-68h": 7,
                "68-70h": 4,
                "70-72h": 4,
                "72-74h": 8,
                "74-76h": 6,
                "76-78h": 7,
                "78-80h": 5,
                "84-86h": 1,
                "88-90h": 2,
                "90-92h": 1,
                "94-96h": 3,
                "96-98h": 3,
                "98-100h": 2,
                "102-104h": 2,
                "108-110h": 2,
                "110-112h": 1,
                "112-114h": 1,
                "114-116h": 1,
                "116-118h": 2,
                "122-124h": 4,
                "124-126h": 3,
                "126-128h": 1,
                "134-136h": 1,
                "138-140h": 2,
                "140-142h": 3,
                "142-144h": 2,
                "146-148h": 3,
                "148-150h": 5,
                "150-152h": 1,
                "158-160h": 1,
                "160-162h": 1,
                "162-164h": 2,
                "164-166h": 5,
                "166-168h": 1,
                "168-170h": 1,
                "170-172h": 1,
                "172-174h": 1,
                "174-176h": 2,
                "176-178h": 1,
                "178-180h": 1,
                "180-182h": 1,
                "186-188h": 1,
                "190-192h": 1,
                "194-196h": 1,
                "200-202h": 3,
                "214-216h": 3,
                "220-222h": 1,
                "222-224h": 1,
                "226-228h": 1,
                "232-234h": 1,
                "236-238h": 1,
                "240-242h": 1,
                "242-244h": 1,
                "262-264h": 2,
                "266-268h": 2,
                "268-270h": 1,
                "276-278h": 1,
                "288-290h": 1,
                "294-296h": 1,
                "308-310h": 2,
                "310-312h": 2,
                "312-314h": 3,
                "314-316h": 1,
                "328-330h": 1,
                "330-332h": 1,
                "332-334h": 4,
                "336-338h": 3,
                "338-340h": 2,
                "340-342h": 3,
                "342-344h": 1,
                "348-350h": 1,
                "356-358h": 2,
                "360-362h": 1,
                "366-368h": 1,
                "380-382h": 2,
                "382-384h": 3,
                "384-386h": 2,
                "388-390h": 1,
                "408-410h": 3,
                "410-412h": 2,
                "412-414h": 1,
                "418-420h": 1,
                "430-432h": 1,
                "432-434h": 1,
                "450-452h": 1,
                "452-454h": 1,
                "454-456h": 2,
                "456-458h": 2,
                "462-464h": 1,
                "480-482h": 2,
                "498-500h": 1,
                "520-522h": 1,
                "524-526h": 1,
                "526-528h": 1,
                "530-532h": 1,
                "536-538h": 1,
                "558-560h": 1,
                "560-562h": 1,
                "570-572h": 1,
                "572-574h": 1,
                "576-578h": 3,
                "578-580h": 2,
                "580-582h": 1,
                "582-584h": 2,
                "594-596h": 1,
                "596-598h": 1,
                "604-606h": 1,
                "610-612h": 1,
                "612-614h": 1,
                "628-630h": 1,
                "642-644h": 1,
                "652-654h": 1,
                "654-656h": 1,
                "658-660h": 1,
                "670-672h": 1,
                "672-674h": 1,
                "696-698h": 1,
                "698-700h": 1,
                "714-716h": 1,
                "724-726h": 2,
                "766-768h": 2,
                "772-774h": 1,
                "788-790h": 1,
                "790-792h": 1,
                "792-794h": 1,
                "796-798h": 1,
                "816-818h": 1,
                "818-820h": 1,
                "846-848h": 1,
                "862-864h": 1,
                "864-866h": 1,
                "884-886h": 1,
                "892-894h": 1,
                "904-906h": 1,
                "908-910h": 1,
                "910-912h": 1,
                "936-938h": 1,
                "942-944h": 1,
                "954-956h": 1,
                "956-958h": 1,
                "984-986h": 1,
                "986-988h": 1,
                "990-992h": 1,
                "1008-1010h": 1,
                "1026-1028h": 1,
                "1034-1036h": 1,
                "1038-1040h": 1,
                "1054-1056h": 1,
                "1056-1058h": 1,
                "1058-1060h": 1,
                "1072-1074h": 1,
                "1074-1076h": 1,
                "1076-1078h": 1,
                "1078-1080h": 1,
                "1080-1082h": 1,
                "1104-1106h": 1,
                "1112-1114h": 1,
                "1146-1148h": 1,
                "1156-1158h": 1,
                "1170-1172h": 1,
                "1194-1196h": 1,
                "1196-1198h": 1,
                "1198-1200h": 1,
                "1222-1224h": 2,
                "1248-1250h": 1,
                "1264-1266h": 1,
                "1266-1268h": 1,
                "1272-1274h": 1,
                "1294-1296h": 1,
                "1316-1318h": 1,
                "1322-1324h": 1,
                "1338-1340h": 1,
                "1342-1344h": 1,
                "1366-1368h": 1,
                "1404-1406h": 1,
                "1410-1412h": 1,
                "1578-1580h": 1,
                "1632-1634h": 1,
                "1634-1636h": 1,
                "1942-1944h": 1,
                "2044-2046h": 1,
                "2060-2062h": 1,
                "2108-2110h": 1,
                "2250-2252h": 1
              },
              "tickets_count": 1921,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-11": 2,
                "2025-10-14": 4,
                "2025-10-18": 3,
                "2025-11-04": 2,
                "2025-11-06": 1,
                "2025-11-08": 1,
                "2025-11-12": 6,
                "2025-11-13": 1,
                "2025-11-20": 1,
                "2025-11-21": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-30": 1,
                "2025-12-02": 3,
                "2025-12-03": 2,
                "2025-12-08": 1,
                "2025-12-09": 2,
                "2025-12-11": 3,
                "2025-12-13": 2,
                "2025-12-15": 1,
                "2025-12-16": 1,
                "2025-12-18": 2,
                "2025-12-19": 1,
                "2025-12-20": 1,
                "2025-12-22": 2,
                "2025-12-24": 1,
                "2025-12-26": 1,
                "2025-12-28": 5,
                "2025-12-29": 2,
                "2025-12-30": 5,
                "2026-01-05": 6,
                "2026-01-07": 1,
                "2026-01-08": 6,
                "2026-01-10": 6,
                "2026-01-13": 14,
                "2026-01-14": 3,
                "2026-01-16": 6,
                "2026-01-19": 15,
                "2026-01-20": 12,
                "2026-01-21": 2,
                "2026-01-22": 6,
                "2026-01-23": 1,
                "2026-01-26": 8,
                "2026-01-27": 10,
                "2026-01-30": 5,
                "2026-01-31": 1,
                "2026-02-02": 3,
                "2026-02-03": 5,
                "2026-02-04": 9,
                "2026-02-05": 11,
                "2026-02-06": 5,
                "2026-02-09": 6,
                "2026-02-10": 11,
                "2026-02-11": 5,
                "2026-02-12": 6,
                "2026-02-13": 3,
                "2026-02-14": 1,
                "2026-02-16": 13,
                "2026-02-17": 4,
                "2026-02-18": 29,
                "2026-02-19": 20,
                "2026-02-20": 18,
                "2026-02-23": 1,
                "2026-02-24": 12,
                "2026-02-25": 6,
                "2026-02-26": 13,
                "2026-03-01": 21,
                "2026-03-02": 17,
                "2026-03-03": 21,
                "2026-03-04": 36,
                "2026-03-05": 2,
                "2026-03-06": 4,
                "2026-03-09": 7,
                "2026-03-10": 4,
                "2026-03-11": 26,
                "2026-03-12": 8,
                "2026-03-13": 17,
                "2026-03-15": 1,
                "2026-03-16": 23,
                "2026-03-17": 18,
                "2026-03-18": 12,
                "2026-03-19": 8,
                "2026-03-20": 36,
                "2026-03-21": 9,
                "2026-03-23": 14,
                "2026-03-24": 14,
                "2026-03-25": 9,
                "2026-03-26": 9,
                "2026-03-27": 15,
                "2026-03-30": 15,
                "2026-03-31": 11,
                "2026-04-01": 6,
                "2026-04-02": 33,
                "2026-04-08": 20,
                "2026-04-09": 28,
                "2026-04-10": 19,
                "2026-04-13": 34,
                "2026-04-14": 1,
                "2026-04-15": 12,
                "2026-04-16": 28,
                "2026-04-17": 19,
                "2026-04-18": 16,
                "2026-04-20": 42,
                "2026-04-21": 2,
                "2026-04-22": 23,
                "2026-04-23": 29,
                "2026-04-24": 18,
                "2026-04-27": 39,
                "2026-04-28": 11,
                "2026-04-29": 20,
                "2026-04-30": 31,
                "2026-05-04": 66,
                "2026-05-05": 19,
                "2026-05-06": 21,
                "2026-05-07": 43,
                "2026-05-08": 1,
                "2026-05-09": 6,
                "2026-05-11": 71,
                "2026-05-12": 42,
                "2026-05-13": 31,
                "2026-05-14": 72,
                "2026-05-15": 32,
                "2026-05-16": 22,
                "2026-05-17": 1,
                "2026-05-18": 44,
                "2026-05-19": 40,
                "2026-05-20": 56,
                "2026-05-21": 47,
                "2026-05-22": 34,
                "2026-05-25": 1,
                "2026-05-30": 3,
                "2026-06-02": 1,
                "2026-06-03": 39,
                "2026-06-05": 74,
                "2026-06-06": 18,
                "2026-06-08": 5
              },
              "time_per_day": {
                "2025-10-06": 98.30899638888889,
                "2025-10-11": 82.95310138888888,
                "2025-10-14": 70.68604500000001,
                "2025-10-18": 165.31194305555556,
                "2025-11-04": 1043.6828805555556,
                "2025-11-06": 28.519268055555557,
                "2025-11-08": 0.5027602777777778,
                "2025-11-12": 1394.7102141666664,
                "2025-11-13": 7.715464444444444,
                "2025-11-20": 431.11313416666667,
                "2025-11-21": 4.607036111111111,
                "2025-11-24": 36.87699222222222,
                "2025-11-25": 113.66069527777779,
                "2025-11-30": 3.9426472222222224,
                "2025-12-02": 265.59195222222223,
                "2025-12-03": 72.06623888888889,
                "2025-12-08": 178.52628416666667,
                "2025-12-09": 347.58443361111114,
                "2025-12-11": 354.83350722222224,
                "2025-12-13": 22.585570555555556,
                "2025-12-15": 48.33467805555555,
                "2025-12-16": 85.33078166666667,
                "2025-12-18": 177.44043583333334,
                "2025-12-19": 226.8685688888889,
                "2025-12-20": 164.55994805555554,
                "2025-12-22": 50.34117972222222,
                "2025-12-24": 42.500729722222225,
                "2025-12-26": 3.097757777777778,
                "2025-12-28": 52.471337500000004,
                "2025-12-29": 1638.0612991666667,
                "2025-12-30": 393.04578333333336,
                "2026-01-05": 749.0600022222222,
                "2026-01-07": 172.67616333333334,
                "2026-01-08": 6.631965000000001,
                "2026-01-10": 74.0562225,
                "2026-01-13": 1053.978360277778,
                "2026-01-14": 40.990641388888896,
                "2026-01-16": 400.93805611111117,
                "2026-01-19": 1624.7149638888889,
                "2026-01-20": 325.5763625000001,
                "2026-01-21": 31.33533055555555,
                "2026-01-22": 132.4544647222222,
                "2026-01-23": 7.443530833333333,
                "2026-01-26": 1042.2138455555555,
                "2026-01-27": 1089.169176111111,
                "2026-01-30": 361.1774069444445,
                "2026-01-31": 2.6259602777777777,
                "2026-02-02": 102.26513000000001,
                "2026-02-03": 125.50274583333334,
                "2026-02-04": 49.15538416666666,
                "2026-02-05": 290.73572666666666,
                "2026-02-06": 71.96606555555555,
                "2026-02-09": 650.1478766666667,
                "2026-02-10": 1111.6242933333335,
                "2026-02-11": 1044.0843538888887,
                "2026-02-12": 1343.6791133333334,
                "2026-02-13": 194.37763083333334,
                "2026-02-14": 18.233544444444444,
                "2026-02-16": 242.93500611111105,
                "2026-02-17": 46.81790916666667,
                "2026-02-18": 10099.773053055558,
                "2026-02-19": 609.1640058333334,
                "2026-02-20": 408.4524377777777,
                "2026-02-23": 70.41375277777777,
                "2026-02-24": 13.757394166666668,
                "2026-02-25": 4.2011263888888895,
                "2026-02-26": 43.41168250000001,
                "2026-03-01": 500.97941805555564,
                "2026-03-02": 616.378101111111,
                "2026-03-03": 2317.1984608333332,
                "2026-03-04": 572.431281666667,
                "2026-03-05": 115.80278138888889,
                "2026-03-06": 22.71683777777778,
                "2026-03-09": 736.352243888889,
                "2026-03-10": 443.8316919444444,
                "2026-03-11": 4186.590230555555,
                "2026-03-12": 75.45444166666665,
                "2026-03-13": 237.85355055555556,
                "2026-03-15": 24.81566361111111,
                "2026-03-16": 250.4329880555555,
                "2026-03-17": 4817.236756111111,
                "2026-03-18": 24.50215472222222,
                "2026-03-19": 10.049879166666665,
                "2026-03-20": 15832.557142500003,
                "2026-03-21": 42.23932305555555,
                "2026-03-23": 226.22791444444442,
                "2026-03-24": 257.5039494444445,
                "2026-03-25": 139.49735138888892,
                "2026-03-26": 8.389298888888888,
                "2026-03-27": 3364.783826944444,
                "2026-03-30": 312.6296416666667,
                "2026-03-31": 408.84785583333326,
                "2026-04-01": 23.089324444444447,
                "2026-04-02": 11590.322334166665,
                "2026-04-08": 584.1872647222224,
                "2026-04-09": 679.6258086111112,
                "2026-04-10": 4306.7604997222215,
                "2026-04-13": 3514.1967633333325,
                "2026-04-14": 295.96116027777776,
                "2026-04-15": 2311.5083227777786,
                "2026-04-16": 39.876256388888905,
                "2026-04-17": 2044.2661383333334,
                "2026-04-18": 6949.032964722223,
                "2026-04-20": 1072.2402988888887,
                "2026-04-21": 0.40624805555555554,
                "2026-04-22": 48.799794444444444,
                "2026-04-23": 14098.193785000001,
                "2026-04-24": 163.73625333333337,
                "2026-04-27": 1801.494629166666,
                "2026-04-28": 470.45262388888887,
                "2026-04-29": 35.83221694444444,
                "2026-04-30": 209.36740027777782,
                "2026-05-04": 708.9382813888889,
                "2026-05-05": 21.000017777777778,
                "2026-05-06": 236.65377277777782,
                "2026-05-07": 6711.842716666666,
                "2026-05-08": 143.40255888888888,
                "2026-05-09": 214.3889363888889,
                "2026-05-11": 254.63180944444449,
                "2026-05-12": 2543.793348333333,
                "2026-05-13": 2949.965561388888,
                "2026-05-14": 8195.16643333333,
                "2026-05-15": 103.5975536111111,
                "2026-05-16": 150.9955297222222,
                "2026-05-17": 0.01920222222222222,
                "2026-05-18": 59.73469138888889,
                "2026-05-19": 58.28283027777778,
                "2026-05-20": 549.6751124999998,
                "2026-05-21": 556.1303508333332,
                "2026-05-22": 98.28122944444442,
                "2026-05-25": 76.09619500000001,
                "2026-05-30": 222.98155527777777,
                "2026-06-02": 200.86864694444444,
                "2026-06-03": 914.4228186111111,
                "2026-06-05": 312.62087277777795,
                "2026-06-06": 1999.5024544444448,
                "2026-06-08": 14.812650833333334
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-11": 2,
                "2025-10-14": 4,
                "2025-10-18": 3,
                "2025-11-04": 2,
                "2025-11-06": 1,
                "2025-11-08": 1,
                "2025-11-12": 6,
                "2025-11-13": 1,
                "2025-11-20": 1,
                "2025-11-21": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-30": 1,
                "2025-12-02": 3,
                "2025-12-03": 2,
                "2025-12-08": 1,
                "2025-12-09": 2,
                "2025-12-11": 3,
                "2025-12-13": 2,
                "2025-12-15": 1,
                "2025-12-16": 1,
                "2025-12-18": 2,
                "2025-12-19": 1,
                "2025-12-20": 1,
                "2025-12-22": 2,
                "2025-12-24": 1,
                "2025-12-26": 1,
                "2025-12-28": 5,
                "2025-12-29": 2,
                "2025-12-30": 5,
                "2026-01-05": 6,
                "2026-01-07": 1,
                "2026-01-08": 6,
                "2026-01-10": 6,
                "2026-01-13": 14,
                "2026-01-14": 3,
                "2026-01-16": 6,
                "2026-01-19": 15,
                "2026-01-20": 12,
                "2026-01-21": 2,
                "2026-01-22": 6,
                "2026-01-23": 1,
                "2026-01-26": 8,
                "2026-01-27": 10,
                "2026-01-30": 5,
                "2026-01-31": 1,
                "2026-02-02": 3,
                "2026-02-03": 5,
                "2026-02-04": 9,
                "2026-02-05": 11,
                "2026-02-06": 5,
                "2026-02-09": 6,
                "2026-02-10": 11,
                "2026-02-11": 5,
                "2026-02-12": 6,
                "2026-02-13": 3,
                "2026-02-14": 1,
                "2026-02-16": 13,
                "2026-02-17": 4,
                "2026-02-18": 29,
                "2026-02-19": 20,
                "2026-02-20": 18,
                "2026-02-23": 1,
                "2026-02-24": 12,
                "2026-02-25": 6,
                "2026-02-26": 13,
                "2026-03-01": 21,
                "2026-03-02": 17,
                "2026-03-03": 21,
                "2026-03-04": 36,
                "2026-03-05": 2,
                "2026-03-06": 4,
                "2026-03-09": 7,
                "2026-03-10": 4,
                "2026-03-11": 26,
                "2026-03-12": 8,
                "2026-03-13": 17,
                "2026-03-15": 1,
                "2026-03-16": 23,
                "2026-03-17": 18,
                "2026-03-18": 12,
                "2026-03-19": 8,
                "2026-03-20": 36,
                "2026-03-21": 9,
                "2026-03-23": 14,
                "2026-03-24": 14,
                "2026-03-25": 9,
                "2026-03-26": 9,
                "2026-03-27": 15,
                "2026-03-30": 15,
                "2026-03-31": 11,
                "2026-04-01": 6,
                "2026-04-02": 33,
                "2026-04-08": 20,
                "2026-04-09": 28,
                "2026-04-10": 19,
                "2026-04-13": 34,
                "2026-04-14": 1,
                "2026-04-15": 12,
                "2026-04-16": 28,
                "2026-04-17": 19,
                "2026-04-18": 16,
                "2026-04-20": 42,
                "2026-04-21": 2,
                "2026-04-22": 23,
                "2026-04-23": 29,
                "2026-04-24": 18,
                "2026-04-27": 39,
                "2026-04-28": 11,
                "2026-04-29": 20,
                "2026-04-30": 31,
                "2026-05-04": 66,
                "2026-05-05": 19,
                "2026-05-06": 21,
                "2026-05-07": 43,
                "2026-05-08": 1,
                "2026-05-09": 6,
                "2026-05-11": 71,
                "2026-05-12": 42,
                "2026-05-13": 31,
                "2026-05-14": 72,
                "2026-05-15": 32,
                "2026-05-16": 22,
                "2026-05-17": 1,
                "2026-05-18": 44,
                "2026-05-19": 40,
                "2026-05-20": 56,
                "2026-05-21": 47,
                "2026-05-22": 34,
                "2026-05-25": 1,
                "2026-05-30": 3,
                "2026-06-02": 1,
                "2026-06-03": 39,
                "2026-06-05": 74,
                "2026-06-06": 18,
                "2026-06-08": 5
              }
            },
            "P3": {
              "avg_time_hours": 283.41,
              "mode_time_hours": 3.0,
              "mode_frequency": 14,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 14,
                "4-6h": 8,
                "6-8h": 11,
                "8-10h": 3,
                "10-12h": 1,
                "12-14h": 2,
                "14-16h": 1,
                "16-18h": 3,
                "18-20h": 8,
                "20-22h": 3,
                "22-24h": 2,
                "24-26h": 8,
                "26-28h": 3,
                "28-30h": 2,
                "30-32h": 1,
                "32-34h": 1,
                "42-44h": 1,
                "46-48h": 3,
                "50-52h": 1,
                "52-54h": 1,
                "62-64h": 1,
                "66-68h": 2,
                "68-70h": 2,
                "70-72h": 3,
                "72-74h": 1,
                "74-76h": 2,
                "88-90h": 1,
                "98-100h": 2,
                "100-102h": 2,
                "120-122h": 1,
                "124-126h": 1,
                "172-174h": 1,
                "194-196h": 1,
                "242-244h": 1,
                "258-260h": 1,
                "282-284h": 1,
                "318-320h": 1,
                "338-340h": 1,
                "342-344h": 1,
                "358-360h": 1,
                "362-364h": 1,
                "382-384h": 1,
                "410-412h": 1,
                "416-418h": 1,
                "500-502h": 1,
                "502-504h": 1,
                "578-580h": 1,
                "592-594h": 1,
                "594-596h": 1,
                "648-650h": 1,
                "696-698h": 1,
                "698-700h": 1,
                "742-744h": 1,
                "840-842h": 1,
                "842-844h": 1,
                "846-848h": 1,
                "896-898h": 1,
                "944-946h": 1,
                "986-988h": 1,
                "1198-1200h": 1,
                "1468-1470h": 1,
                "1508-1510h": 1,
                "1752-1754h": 1,
                "1830-1832h": 1,
                "1944-1946h": 1,
                "1962-1964h": 1,
                "2372-2374h": 1,
                "3550-3552h": 1,
                "4036-4038h": 1
              },
              "tickets_count": 139,
              "tickets_per_day": {
                "2025-10-18": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-11-07": 12,
                "2025-11-08": 1,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-13": 4,
                "2025-11-17": 4,
                "2025-11-18": 1,
                "2025-11-22": 1,
                "2025-11-25": 4,
                "2025-11-26": 1,
                "2025-12-02": 6,
                "2025-12-03": 3,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-13": 1,
                "2025-12-18": 5,
                "2025-12-19": 1,
                "2025-12-23": 2,
                "2025-12-28": 1,
                "2025-12-30": 2,
                "2026-01-05": 2,
                "2026-01-07": 3,
                "2026-01-08": 2,
                "2026-01-13": 7,
                "2026-01-16": 2,
                "2026-01-19": 5,
                "2026-01-22": 1,
                "2026-01-26": 5,
                "2026-01-27": 2,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-04": 2,
                "2026-02-07": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 6,
                "2026-02-16": 1,
                "2026-02-18": 5,
                "2026-02-19": 1,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-20": 2,
                "2026-03-27": 2,
                "2026-03-31": 2,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-13": 1,
                "2026-05-14": 4,
                "2026-06-06": 3
              },
              "time_per_day": {
                "2025-10-18": 88.81827666666666,
                "2025-11-04": 649.8871144444445,
                "2025-11-06": 743.9638888888888,
                "2025-11-07": 52.41845138888888,
                "2025-11-08": 358.8417494444444,
                "2025-11-11": 33.308388888888885,
                "2025-11-12": 1735.661568611111,
                "2025-11-13": 125.80431916666666,
                "2025-11-17": 209.3923472222222,
                "2025-11-18": 20.3284025,
                "2025-11-22": 3.430708888888889,
                "2025-11-25": 365.7489238888889,
                "2025-11-26": 26.488642777777777,
                "2025-12-02": 421.1237969444444,
                "2025-12-03": 110.68159583333333,
                "2025-12-10": 9.213739444444444,
                "2025-12-11": 200.5044111111111,
                "2025-12-13": 593.7800633333334,
                "2025-12-18": 216.3337013888889,
                "2025-12-19": 23.5684,
                "2025-12-23": 64.29745166666666,
                "2025-12-28": 99.04570694444443,
                "2025-12-30": 381.05348888888886,
                "2026-01-05": 275.25742694444443,
                "2026-01-07": 916.806945,
                "2026-01-08": 14.76477638888889,
                "2026-01-13": 213.9673166666667,
                "2026-01-16": 19.49048611111111,
                "2026-01-19": 162.29513666666668,
                "2026-01-22": 23.52322583333333,
                "2026-01-26": 449.3969505555556,
                "2026-01-27": 40.89021777777778,
                "2026-02-02": 12.848271944444445,
                "2026-02-03": 2.4500583333333332,
                "2026-02-04": 64.65150694444445,
                "2026-02-07": 2.790459166666667,
                "2026-02-09": 75.89560777777778,
                "2026-02-10": 259.2024772222222,
                "2026-02-11": 25.4033575,
                "2026-02-12": 610.4464275,
                "2026-02-13": 112.58855861111113,
                "2026-02-16": 1831.8803725,
                "2026-02-18": 6434.389757222222,
                "2026-02-19": 52.46980305555555,
                "2026-02-26": 3.644743611111111,
                "2026-02-27": 503.90358944444444,
                "2026-03-04": 8.818540277777778,
                "2026-03-09": 75.00128027777778,
                "2026-03-11": 896.9744666666667,
                "2026-03-16": 121.23318083333334,
                "2026-03-20": 1834.3221227777776,
                "2026-03-27": 2698.5429511111115,
                "2026-03-31": 1.6288516666666668,
                "2026-04-13": 7.108693611111111,
                "2026-04-16": 501.0308769444444,
                "2026-04-17": 1.0168580555555555,
                "2026-04-23": 1199.8848105555555,
                "2026-05-05": 417.4196763888889,
                "2026-05-13": 0.0522225,
                "2026-05-14": 11432.203654166666,
                "2026-06-06": 1556.4501066666667
              },
              "time_count_per_day": {
                "2025-10-18": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-11-07": 12,
                "2025-11-08": 1,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-13": 4,
                "2025-11-17": 4,
                "2025-11-18": 1,
                "2025-11-22": 1,
                "2025-11-25": 4,
                "2025-11-26": 1,
                "2025-12-02": 6,
                "2025-12-03": 3,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-13": 1,
                "2025-12-18": 5,
                "2025-12-19": 1,
                "2025-12-23": 2,
                "2025-12-28": 1,
                "2025-12-30": 2,
                "2026-01-05": 2,
                "2026-01-07": 3,
                "2026-01-08": 2,
                "2026-01-13": 7,
                "2026-01-16": 2,
                "2026-01-19": 5,
                "2026-01-22": 1,
                "2026-01-26": 5,
                "2026-01-27": 2,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-04": 2,
                "2026-02-07": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 6,
                "2026-02-16": 1,
                "2026-02-18": 5,
                "2026-02-19": 1,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-20": 2,
                "2026-03-27": 2,
                "2026-03-31": 2,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-13": 1,
                "2026-05-14": 4,
                "2026-06-06": 3
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 131.62,
              "mode_time_hours": 7.0,
              "mode_frequency": 3,
              "time_distribution": {
                "6-8h": 3,
                "8-10h": 1,
                "10-12h": 2,
                "24-26h": 2,
                "54-56h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "82-84h": 1,
                "192-194h": 1,
                "194-196h": 1,
                "196-198h": 2,
                "198-200h": 1,
                "384-386h": 1,
                "740-742h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-10": 2,
                "2026-01-14": 5,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-06-06": 8
              },
              "time_per_day": {
                "2025-12-03": 741.2985652777778,
                "2025-12-10": 51.92900694444444,
                "2026-01-14": 43.27879,
                "2026-01-16": 83.72504388888889,
                "2026-01-19": 54.43967666666667,
                "2026-01-26": 6.711571111111111,
                "2026-06-06": 1519.3073911111112
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-10": 2,
                "2026-01-14": 5,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-06-06": 8
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 123.22,
              "mode_time_hours": 103.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "102-104h": 1,
                "104-106h": 1,
                "122-124h": 1,
                "124-126h": 1,
                "258-260h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-05": 1,
                "2025-12-08": 1,
                "2025-12-11": 1,
                "2025-12-20": 1,
                "2026-01-13": 1
              },
              "time_per_day": {
                "2025-12-02": 103.56525027777778,
                "2025-12-05": 105.44115166666667,
                "2025-12-08": 124.1030525,
                "2025-12-11": 122.03653194444445,
                "2025-12-20": 258.72006055555556,
                "2026-01-13": 25.449099166666667
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-05": 1,
                "2025-12-08": 1,
                "2025-12-11": 1,
                "2025-12-20": 1,
                "2026-01-13": 1
              }
            }
          }
        },
        "Cuba Cancelado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-02-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Cuba Remarcado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-16": 1,
              "2026-03-31": 1,
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-16": 1,
                "2026-03-31": 1,
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 14,
            "tickets_per_day": {
              "2026-05-14": 1,
              "2026-05-22": 1,
              "2026-05-28": 1,
              "2026-05-31": 1,
              "2026-06-02": 1,
              "2026-06-05": 3,
              "2026-06-06": 4,
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-31": 1,
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-05-14": 1,
                "2026-05-22": 1,
                "2026-05-28": 1,
                "2026-06-02": 1,
                "2026-06-05": 3,
                "2026-06-06": 3,
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 89,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-02-16": 2,
              "2026-02-17": 1,
              "2026-03-02": 1,
              "2026-03-03": 1,
              "2026-03-11": 1,
              "2026-03-16": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 3,
              "2026-04-10": 1,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-04-17": 2,
              "2026-04-20": 2,
              "2026-04-22": 1,
              "2026-04-28": 3,
              "2026-04-29": 6,
              "2026-04-30": 2,
              "2026-05-04": 4,
              "2026-05-05": 3,
              "2026-05-06": 1,
              "2026-05-07": 3,
              "2026-05-08": 1,
              "2026-05-09": 2,
              "2026-05-11": 2,
              "2026-05-12": 9,
              "2026-05-14": 4,
              "2026-05-15": 2,
              "2026-05-18": 3,
              "2026-05-19": 3,
              "2026-05-20": 6,
              "2026-05-21": 4,
              "2026-05-22": 2,
              "2026-06-02": 1,
              "2026-06-05": 1,
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-08": 1,
                "2026-05-04": 1,
                "2026-05-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 83,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-16": 2,
                "2026-02-17": 1,
                "2026-03-02": 1,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-14": 1,
                "2026-04-15": 1,
                "2026-04-17": 2,
                "2026-04-20": 2,
                "2026-04-22": 1,
                "2026-04-28": 3,
                "2026-04-29": 6,
                "2026-04-30": 2,
                "2026-05-04": 3,
                "2026-05-05": 2,
                "2026-05-06": 1,
                "2026-05-07": 3,
                "2026-05-08": 1,
                "2026-05-09": 2,
                "2026-05-11": 2,
                "2026-05-12": 9,
                "2026-05-14": 4,
                "2026-05-15": 2,
                "2026-05-18": 3,
                "2026-05-19": 3,
                "2026-05-20": 6,
                "2026-05-21": 4,
                "2026-05-22": 2,
                "2026-06-02": 1,
                "2026-06-05": 1,
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-06-02": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-06": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 69,
            "tickets_per_day": {
              "2025-11-19": 1,
              "2026-02-03": 1,
              "2026-02-16": 14,
              "2026-02-17": 5,
              "2026-03-19": 1,
              "2026-03-26": 1,
              "2026-03-30": 2,
              "2026-04-07": 1,
              "2026-04-20": 1,
              "2026-04-27": 2,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 2,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-15": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-21": 4,
              "2026-05-22": 2,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-02": 2,
              "2026-06-03": 2,
              "2026-06-05": 9,
              "2026-06-06": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-04-29": 1,
                "2026-05-12": 1,
                "2026-05-26": 1,
                "2026-06-03": 1,
                "2026-06-05": 5
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 58,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-16": 14,
                "2026-02-17": 5,
                "2026-03-19": 1,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-20": 1,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-15": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-21": 4,
                "2026-05-22": 2,
                "2026-05-29": 1,
                "2026-06-02": 2,
                "2026-06-03": 1,
                "2026-06-05": 4,
                "2026-06-06": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-19": 1,
                "2026-04-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Cátia Leal": {
      "overall": {
        "avg_time_hours": 123.53,
        "mode_time_hours": 7.0,
        "mode_frequency": 207,
        "time_distribution": {
          "0-2h": 185,
          "2-4h": 196,
          "4-6h": 164,
          "6-8h": 207,
          "8-10h": 115,
          "10-12h": 13,
          "12-14h": 9,
          "14-16h": 17,
          "16-18h": 26,
          "18-20h": 41,
          "20-22h": 58,
          "22-24h": 41,
          "24-26h": 47,
          "26-28h": 38,
          "28-30h": 54,
          "30-32h": 51,
          "32-34h": 46,
          "34-36h": 12,
          "36-38h": 5,
          "38-40h": 7,
          "40-42h": 21,
          "42-44h": 26,
          "44-46h": 21,
          "46-48h": 18,
          "48-50h": 25,
          "50-52h": 25,
          "52-54h": 28,
          "54-56h": 39,
          "56-58h": 13,
          "58-60h": 4,
          "60-62h": 2,
          "62-64h": 5,
          "64-66h": 11,
          "66-68h": 28,
          "68-70h": 15,
          "70-72h": 20,
          "72-74h": 20,
          "74-76h": 9,
          "76-78h": 12,
          "78-80h": 21,
          "80-82h": 10,
          "82-84h": 4,
          "84-86h": 5,
          "86-88h": 4,
          "88-90h": 4,
          "90-92h": 5,
          "92-94h": 6,
          "94-96h": 13,
          "96-98h": 20,
          "98-100h": 12,
          "100-102h": 19,
          "102-104h": 11,
          "104-106h": 8,
          "106-108h": 4,
          "108-110h": 1,
          "110-112h": 1,
          "112-114h": 1,
          "114-116h": 3,
          "116-118h": 9,
          "118-120h": 8,
          "120-122h": 7,
          "122-124h": 4,
          "124-126h": 2,
          "126-128h": 7,
          "128-130h": 7,
          "130-132h": 2,
          "132-134h": 3,
          "134-136h": 6,
          "136-138h": 5,
          "138-140h": 7,
          "140-142h": 5,
          "142-144h": 7,
          "144-146h": 11,
          "146-148h": 3,
          "148-150h": 14,
          "150-152h": 3,
          "152-154h": 1,
          "154-156h": 1,
          "156-158h": 2,
          "158-160h": 3,
          "160-162h": 5,
          "162-164h": 3,
          "164-166h": 8,
          "166-168h": 8,
          "168-170h": 5,
          "170-172h": 5,
          "172-174h": 8,
          "176-178h": 3,
          "178-180h": 1,
          "180-182h": 2,
          "182-184h": 1,
          "184-186h": 3,
          "186-188h": 3,
          "188-190h": 6,
          "190-192h": 5,
          "192-194h": 6,
          "194-196h": 10,
          "196-198h": 2,
          "198-200h": 2,
          "200-202h": 1,
          "202-204h": 3,
          "204-206h": 4,
          "206-208h": 1,
          "208-210h": 1,
          "210-212h": 2,
          "214-216h": 3,
          "216-218h": 3,
          "218-220h": 11,
          "222-224h": 1,
          "226-228h": 3,
          "228-230h": 1,
          "234-236h": 1,
          "238-240h": 1,
          "240-242h": 2,
          "242-244h": 1,
          "244-246h": 1,
          "246-248h": 1,
          "248-250h": 2,
          "250-252h": 1,
          "254-256h": 2,
          "256-258h": 2,
          "260-262h": 2,
          "262-264h": 5,
          "268-270h": 4,
          "270-272h": 3,
          "272-274h": 3,
          "276-278h": 1,
          "278-280h": 1,
          "280-282h": 1,
          "282-284h": 2,
          "286-288h": 2,
          "288-290h": 2,
          "290-292h": 3,
          "292-294h": 4,
          "298-300h": 1,
          "300-302h": 1,
          "304-306h": 2,
          "306-308h": 3,
          "308-310h": 1,
          "312-314h": 4,
          "314-316h": 1,
          "316-318h": 2,
          "318-320h": 4,
          "324-326h": 4,
          "326-328h": 2,
          "328-330h": 1,
          "330-332h": 1,
          "332-334h": 1,
          "334-336h": 3,
          "336-338h": 2,
          "338-340h": 1,
          "340-342h": 4,
          "342-344h": 2,
          "344-346h": 2,
          "348-350h": 3,
          "352-354h": 2,
          "354-356h": 2,
          "356-358h": 1,
          "360-362h": 4,
          "362-364h": 1,
          "364-366h": 2,
          "366-368h": 4,
          "372-374h": 1,
          "376-378h": 1,
          "380-382h": 2,
          "384-386h": 1,
          "386-388h": 2,
          "388-390h": 1,
          "390-392h": 2,
          "398-400h": 1,
          "402-404h": 1,
          "406-408h": 2,
          "408-410h": 2,
          "410-412h": 1,
          "414-416h": 2,
          "416-418h": 1,
          "424-426h": 2,
          "426-428h": 1,
          "428-430h": 2,
          "430-432h": 3,
          "438-440h": 1,
          "444-446h": 1,
          "448-450h": 1,
          "450-452h": 1,
          "452-454h": 2,
          "460-462h": 1,
          "468-470h": 1,
          "472-474h": 1,
          "474-476h": 1,
          "488-490h": 1,
          "490-492h": 5,
          "492-494h": 1,
          "498-500h": 1,
          "502-504h": 2,
          "504-506h": 4,
          "506-508h": 2,
          "508-510h": 1,
          "512-514h": 2,
          "514-516h": 1,
          "520-522h": 1,
          "526-528h": 2,
          "528-530h": 3,
          "532-534h": 2,
          "534-536h": 1,
          "536-538h": 1,
          "538-540h": 1,
          "540-542h": 3,
          "542-544h": 1,
          "544-546h": 1,
          "548-550h": 1,
          "554-556h": 1,
          "564-566h": 1,
          "568-570h": 1,
          "570-572h": 1,
          "572-574h": 3,
          "574-576h": 1,
          "576-578h": 6,
          "580-582h": 2,
          "582-584h": 4,
          "596-598h": 1,
          "598-600h": 1,
          "616-618h": 2,
          "622-624h": 1,
          "628-630h": 1,
          "642-644h": 3,
          "644-646h": 1,
          "660-662h": 1,
          "662-664h": 1,
          "670-672h": 1,
          "672-674h": 1,
          "674-676h": 1,
          "682-684h": 1,
          "698-700h": 1,
          "704-706h": 1,
          "714-716h": 1,
          "718-720h": 1,
          "722-724h": 1,
          "724-726h": 1,
          "744-746h": 1,
          "746-748h": 1,
          "758-760h": 1,
          "760-762h": 1,
          "764-766h": 2,
          "768-770h": 1,
          "780-782h": 1,
          "794-796h": 1,
          "798-800h": 1,
          "816-818h": 1,
          "818-820h": 2,
          "824-826h": 1,
          "834-836h": 1,
          "836-838h": 1,
          "840-842h": 2,
          "842-844h": 1,
          "848-850h": 1,
          "866-868h": 1,
          "872-874h": 3,
          "882-884h": 1,
          "896-898h": 1,
          "902-904h": 1,
          "906-908h": 1,
          "916-918h": 1,
          "918-920h": 1,
          "924-926h": 1,
          "936-938h": 1,
          "938-940h": 1,
          "940-942h": 1,
          "952-954h": 1,
          "960-962h": 2,
          "976-978h": 1,
          "980-982h": 1,
          "984-986h": 3,
          "986-988h": 1,
          "992-994h": 1,
          "1002-1004h": 2,
          "1006-1008h": 1,
          "1010-1012h": 1,
          "1012-1014h": 1,
          "1028-1030h": 2,
          "1076-1078h": 1,
          "1086-1088h": 1,
          "1096-1098h": 2,
          "1098-1100h": 1,
          "1102-1104h": 2,
          "1104-1106h": 1,
          "1152-1154h": 1,
          "1176-1178h": 1,
          "1178-1180h": 1,
          "1190-1192h": 1,
          "1200-1202h": 1,
          "1202-1204h": 1,
          "1208-1210h": 1,
          "1236-1238h": 2,
          "1244-1246h": 1,
          "1256-1258h": 1,
          "1258-1260h": 1,
          "1268-1270h": 1,
          "1276-1278h": 1,
          "1326-1328h": 1,
          "1336-1338h": 1,
          "1338-1340h": 1,
          "1340-1342h": 1,
          "1376-1378h": 2,
          "1380-1382h": 1,
          "1390-1392h": 1,
          "1462-1464h": 1,
          "1486-1488h": 1,
          "1514-1516h": 1,
          "1548-1550h": 1,
          "1570-1572h": 1,
          "1636-1638h": 1,
          "1658-1660h": 1,
          "1660-1662h": 1,
          "1712-1714h": 1,
          "1718-1720h": 1,
          "1728-1730h": 1,
          "1762-1764h": 1,
          "1896-1898h": 1,
          "1906-1908h": 1,
          "2040-2042h": 1,
          "2152-2154h": 1,
          "2902-2904h": 1
        },
        "tickets_count": 2472,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-09": 2,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-22": 1,
          "2025-10-23": 8,
          "2025-10-24": 4,
          "2025-10-27": 14,
          "2025-10-28": 9,
          "2025-10-29": 5,
          "2025-10-30": 8,
          "2025-10-31": 29,
          "2025-11-03": 18,
          "2025-11-04": 26,
          "2025-11-05": 9,
          "2025-11-06": 14,
          "2025-11-07": 7,
          "2025-11-10": 22,
          "2025-11-11": 15,
          "2025-11-12": 8,
          "2025-11-13": 27,
          "2025-11-14": 12,
          "2025-11-17": 46,
          "2025-11-18": 11,
          "2025-11-19": 13,
          "2025-11-20": 8,
          "2025-11-21": 10,
          "2025-11-22": 18,
          "2025-11-24": 34,
          "2025-11-25": 8,
          "2025-11-26": 18,
          "2025-11-27": 26,
          "2025-11-28": 15,
          "2025-11-30": 5,
          "2025-12-02": 27,
          "2025-12-03": 12,
          "2025-12-04": 29,
          "2025-12-05": 18,
          "2025-12-09": 18,
          "2025-12-10": 12,
          "2025-12-11": 31,
          "2025-12-12": 16,
          "2025-12-13": 11,
          "2025-12-14": 13,
          "2025-12-15": 12,
          "2025-12-16": 1,
          "2025-12-17": 17,
          "2025-12-18": 23,
          "2025-12-19": 6,
          "2025-12-22": 14,
          "2025-12-23": 13,
          "2025-12-24": 2,
          "2025-12-26": 10,
          "2025-12-29": 15,
          "2025-12-30": 8,
          "2025-12-31": 1,
          "2026-01-05": 14,
          "2026-01-06": 16,
          "2026-01-07": 4,
          "2026-01-08": 12,
          "2026-01-09": 4,
          "2026-01-10": 1,
          "2026-01-12": 8,
          "2026-01-13": 18,
          "2026-01-14": 36,
          "2026-01-15": 9,
          "2026-01-16": 16,
          "2026-01-19": 3,
          "2026-01-20": 29,
          "2026-01-21": 21,
          "2026-01-22": 8,
          "2026-01-23": 6,
          "2026-01-26": 9,
          "2026-01-27": 47,
          "2026-01-28": 2,
          "2026-01-29": 6,
          "2026-01-30": 14,
          "2026-02-02": 12,
          "2026-02-03": 16,
          "2026-02-04": 34,
          "2026-02-05": 7,
          "2026-02-06": 5,
          "2026-02-09": 14,
          "2026-02-10": 25,
          "2026-02-11": 3,
          "2026-02-12": 4,
          "2026-02-13": 8,
          "2026-02-16": 6,
          "2026-02-17": 6,
          "2026-02-18": 14,
          "2026-02-19": 9,
          "2026-02-20": 6,
          "2026-02-22": 2,
          "2026-02-23": 19,
          "2026-02-24": 9,
          "2026-02-25": 11,
          "2026-02-26": 4,
          "2026-02-27": 11,
          "2026-02-28": 3,
          "2026-03-02": 53,
          "2026-03-03": 11,
          "2026-03-04": 15,
          "2026-03-05": 21,
          "2026-03-06": 19,
          "2026-03-07": 3,
          "2026-03-09": 35,
          "2026-03-10": 12,
          "2026-03-11": 13,
          "2026-03-12": 18,
          "2026-03-13": 18,
          "2026-03-16": 31,
          "2026-03-17": 65,
          "2026-03-18": 14,
          "2026-03-19": 13,
          "2026-03-20": 34,
          "2026-03-23": 18,
          "2026-03-24": 18,
          "2026-03-25": 24,
          "2026-03-26": 6,
          "2026-03-27": 4,
          "2026-03-30": 12,
          "2026-03-31": 19,
          "2026-04-01": 11,
          "2026-04-02": 9,
          "2026-04-06": 21,
          "2026-04-07": 20,
          "2026-04-08": 10,
          "2026-04-09": 35,
          "2026-04-10": 35,
          "2026-04-13": 5,
          "2026-04-14": 7,
          "2026-04-15": 10,
          "2026-04-16": 12,
          "2026-04-17": 6,
          "2026-04-20": 12,
          "2026-04-21": 2,
          "2026-04-22": 15,
          "2026-04-23": 11,
          "2026-04-24": 5,
          "2026-04-26": 1,
          "2026-04-27": 20,
          "2026-04-28": 15,
          "2026-04-29": 4,
          "2026-04-30": 4,
          "2026-05-02": 3,
          "2026-05-04": 20,
          "2026-05-05": 44,
          "2026-05-06": 28,
          "2026-05-07": 1,
          "2026-05-08": 20,
          "2026-05-09": 1,
          "2026-05-10": 4,
          "2026-05-11": 10,
          "2026-05-12": 17,
          "2026-05-13": 17,
          "2026-05-14": 5,
          "2026-05-15": 7,
          "2026-05-18": 21,
          "2026-05-19": 18,
          "2026-05-20": 5,
          "2026-05-21": 27,
          "2026-05-22": 31,
          "2026-05-23": 1,
          "2026-05-25": 25,
          "2026-05-26": 18,
          "2026-05-27": 17,
          "2026-05-28": 9,
          "2026-05-29": 11,
          "2026-06-01": 21,
          "2026-06-02": 21,
          "2026-06-03": 18,
          "2026-06-05": 22,
          "2026-06-06": 3,
          "2026-06-08": 7
        },
        "time_per_day": {
          "2025-10-08": 53.6505225,
          "2025-10-09": 188.15949916666665,
          "2025-10-10": 40.36689472222222,
          "2025-10-13": 0.18714916666666664,
          "2025-10-14": 16.192532777777778,
          "2025-10-22": 0.08416194444444444,
          "2025-10-23": 1610.0926680555556,
          "2025-10-24": 14.662827499999999,
          "2025-10-27": 231.21287694444442,
          "2025-10-28": 540.9404644444445,
          "2025-10-29": 237.2767986111111,
          "2025-10-30": 215.47600361111114,
          "2025-10-31": 1918.9509924999995,
          "2025-11-03": 599.6555869444445,
          "2025-11-04": 1060.3222830555555,
          "2025-11-05": 332.19690583333335,
          "2025-11-06": 108.28947722222222,
          "2025-11-07": 121.45288388888889,
          "2025-11-10": 1627.3704755555555,
          "2025-11-11": 644.76857,
          "2025-11-12": 212.7945961111111,
          "2025-11-13": 889.3066358333334,
          "2025-11-14": 519.8885150000001,
          "2025-11-17": 3469.3928933333345,
          "2025-11-18": 515.1217733333333,
          "2025-11-19": 869.1700105555552,
          "2025-11-20": 585.0044227777779,
          "2025-11-21": 453.03002888888886,
          "2025-11-22": 1065.552337777778,
          "2025-11-24": 2766.542715277778,
          "2025-11-25": 797.4113311111113,
          "2025-11-26": 627.3927902777779,
          "2025-11-27": 493.1483258333332,
          "2025-11-28": 526.310815,
          "2025-11-30": 177.758895,
          "2025-12-02": 2242.576708611111,
          "2025-12-03": 88.29168194444443,
          "2025-12-04": 3394.2816341666676,
          "2025-12-05": 1211.0166341666666,
          "2025-12-09": 1018.5692899999998,
          "2025-12-10": 851.6378802777779,
          "2025-12-11": 3654.1125733333333,
          "2025-12-12": 1090.0607241666664,
          "2025-12-13": 2059.2225283333332,
          "2025-12-14": 680.2957594444445,
          "2025-12-15": 480.5557391666667,
          "2025-12-16": 54.9179925,
          "2025-12-17": 1260.6805427777779,
          "2025-12-18": 1488.1471722222223,
          "2025-12-19": 350.1024455555556,
          "2025-12-22": 448.4895747222222,
          "2025-12-23": 875.0064263888889,
          "2025-12-24": 699.1475755555556,
          "2025-12-26": 2001.6654786111114,
          "2025-12-29": 1310.5877105555555,
          "2025-12-30": 209.16750083333332,
          "2025-12-31": 52.349401944444445,
          "2026-01-05": 2597.772352777778,
          "2026-01-06": 2047.3653372222223,
          "2026-01-07": 120.73829805555557,
          "2026-01-08": 220.45242,
          "2026-01-09": 15.293095833333332,
          "2026-01-12": 220.0630886111111,
          "2026-01-13": 1963.091298888889,
          "2026-01-14": 2981.439555833333,
          "2026-01-15": 200.86274444444444,
          "2026-01-16": 2683.4993363888884,
          "2026-01-19": 44.83396166666667,
          "2026-01-20": 1218.0684827777777,
          "2026-01-21": 1398.4368580555551,
          "2026-01-22": 97.66266555555556,
          "2026-01-23": 169.1470841666667,
          "2026-01-26": 238.44543583333333,
          "2026-01-27": 3852.541328333333,
          "2026-01-28": 10.294375833333334,
          "2026-01-29": 642.9321083333333,
          "2026-01-30": 1418.543996388889,
          "2026-02-02": 308.3652822222222,
          "2026-02-03": 1057.0650491666665,
          "2026-02-04": 4530.639370833333,
          "2026-02-05": 60.01619416666666,
          "2026-02-06": 253.90716833333335,
          "2026-02-09": 377.53208777777775,
          "2026-02-10": 2748.70631361111,
          "2026-02-11": 10.634999444444444,
          "2026-02-12": 1914.9164047222218,
          "2026-02-13": 149.70655916666664,
          "2026-02-16": 476.84734194444445,
          "2026-02-17": 83.41856861111111,
          "2026-02-18": 828.7219394444445,
          "2026-02-19": 558.0402441666666,
          "2026-02-20": 769.8565116666667,
          "2026-02-22": 67.21825555555554,
          "2026-02-23": 292.27670972222217,
          "2026-02-24": 122.62486777777778,
          "2026-02-25": 1644.180453888889,
          "2026-02-26": 20.433703333333334,
          "2026-02-27": 213.65988444444437,
          "2026-02-28": 5.815738333333334,
          "2026-03-02": 2580.2105455555547,
          "2026-03-03": 465.24912638888895,
          "2026-03-04": 92.7259275,
          "2026-03-05": 3999.5181488888898,
          "2026-03-06": 7182.343670833333,
          "2026-03-07": 6.08331388888889,
          "2026-03-09": 639.2989583333334,
          "2026-03-10": 212.85803472222227,
          "2026-03-11": 2606.5405408333336,
          "2026-03-12": 1948.0417066666666,
          "2026-03-13": 1350.5440644444443,
          "2026-03-16": 1045.157576111111,
          "2026-03-17": 25147.036882777767,
          "2026-03-18": 2697.1507769444456,
          "2026-03-19": 1443.9747138888886,
          "2026-03-20": 14683.563386944445,
          "2026-03-23": 2008.694167777778,
          "2026-03-24": 10862.25883416667,
          "2026-03-25": 9452.48876666667,
          "2026-03-26": 420.61598833333335,
          "2026-03-27": 72.76069361111111,
          "2026-03-30": 954.0015655555559,
          "2026-03-31": 5154.069229444444,
          "2026-04-01": 2430.4885338888894,
          "2026-04-02": 262.2300997222222,
          "2026-04-06": 932.693468611111,
          "2026-04-07": 10370.807704722223,
          "2026-04-08": 344.1760736111111,
          "2026-04-09": 9534.828087777772,
          "2026-04-10": 28833.809921666663,
          "2026-04-13": 23.010235555555553,
          "2026-04-14": 177.55500777777775,
          "2026-04-15": 148.66482083333335,
          "2026-04-16": 2141.350355555556,
          "2026-04-17": 23.172380833333335,
          "2026-04-20": 481.06589111111106,
          "2026-04-21": 37.696800277777776,
          "2026-04-22": 437.121096111111,
          "2026-04-23": 3014.7638933333333,
          "2026-04-24": 189.56530722222223,
          "2026-04-26": 386.9462188888889,
          "2026-04-27": 370.0466219444443,
          "2026-04-28": 1550.016698888889,
          "2026-04-29": 146.20076333333333,
          "2026-04-30": 81.95733222222222,
          "2026-05-02": 348.5236488888889,
          "2026-05-04": 671.2849630555556,
          "2026-05-05": 12975.851252499999,
          "2026-05-06": 12753.942924166666,
          "2026-05-07": 2.6027802777777778,
          "2026-05-08": 7318.760912222222,
          "2026-05-10": 245.4068125,
          "2026-05-11": 62.70415944444444,
          "2026-05-12": 677.5803552777778,
          "2026-05-13": 351.7984105555557,
          "2026-05-14": 1237.5576455555556,
          "2026-05-15": 117.62110361111114,
          "2026-05-18": 1171.4110208333339,
          "2026-05-19": 450.28824194444445,
          "2026-05-20": 39.08823361111111,
          "2026-05-21": 2952.221484722223,
          "2026-05-22": 4426.018546388887,
          "2026-05-25": 979.5148155555556,
          "2026-05-26": 783.2881830555556,
          "2026-05-27": 250.78605055555553,
          "2026-05-28": 427.2425305555555,
          "2026-05-29": 114.11494972222224,
          "2026-06-01": 328.11429166666676,
          "2026-06-02": 498.65953666666667,
          "2026-06-03": 668.6195655555554,
          "2026-06-05": 262.2419883333333,
          "2026-06-08": 0.9049816666666667
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-09": 2,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-22": 1,
          "2025-10-23": 8,
          "2025-10-24": 4,
          "2025-10-27": 14,
          "2025-10-28": 9,
          "2025-10-29": 5,
          "2025-10-30": 8,
          "2025-10-31": 29,
          "2025-11-03": 18,
          "2025-11-04": 26,
          "2025-11-05": 9,
          "2025-11-06": 14,
          "2025-11-07": 7,
          "2025-11-10": 22,
          "2025-11-11": 15,
          "2025-11-12": 8,
          "2025-11-13": 27,
          "2025-11-14": 11,
          "2025-11-17": 46,
          "2025-11-18": 11,
          "2025-11-19": 13,
          "2025-11-20": 8,
          "2025-11-21": 10,
          "2025-11-22": 18,
          "2025-11-24": 33,
          "2025-11-25": 8,
          "2025-11-26": 18,
          "2025-11-27": 26,
          "2025-11-28": 15,
          "2025-11-30": 5,
          "2025-12-02": 27,
          "2025-12-03": 12,
          "2025-12-04": 29,
          "2025-12-05": 18,
          "2025-12-09": 18,
          "2025-12-10": 11,
          "2025-12-11": 31,
          "2025-12-12": 16,
          "2025-12-13": 11,
          "2025-12-14": 13,
          "2025-12-15": 12,
          "2025-12-16": 1,
          "2025-12-17": 17,
          "2025-12-18": 23,
          "2025-12-19": 6,
          "2025-12-22": 14,
          "2025-12-23": 13,
          "2025-12-24": 2,
          "2025-12-26": 10,
          "2025-12-29": 14,
          "2025-12-30": 8,
          "2025-12-31": 1,
          "2026-01-05": 14,
          "2026-01-06": 16,
          "2026-01-07": 4,
          "2026-01-08": 12,
          "2026-01-09": 4,
          "2026-01-12": 8,
          "2026-01-13": 18,
          "2026-01-14": 36,
          "2026-01-15": 9,
          "2026-01-16": 14,
          "2026-01-19": 2,
          "2026-01-20": 29,
          "2026-01-21": 20,
          "2026-01-22": 8,
          "2026-01-23": 6,
          "2026-01-26": 9,
          "2026-01-27": 47,
          "2026-01-28": 2,
          "2026-01-29": 6,
          "2026-01-30": 13,
          "2026-02-02": 11,
          "2026-02-03": 16,
          "2026-02-04": 34,
          "2026-02-05": 7,
          "2026-02-06": 5,
          "2026-02-09": 14,
          "2026-02-10": 25,
          "2026-02-11": 3,
          "2026-02-12": 4,
          "2026-02-13": 8,
          "2026-02-16": 6,
          "2026-02-17": 6,
          "2026-02-18": 14,
          "2026-02-19": 9,
          "2026-02-20": 5,
          "2026-02-22": 2,
          "2026-02-23": 19,
          "2026-02-24": 9,
          "2026-02-25": 11,
          "2026-02-26": 4,
          "2026-02-27": 11,
          "2026-02-28": 3,
          "2026-03-02": 53,
          "2026-03-03": 11,
          "2026-03-04": 14,
          "2026-03-05": 21,
          "2026-03-06": 19,
          "2026-03-07": 3,
          "2026-03-09": 35,
          "2026-03-10": 11,
          "2026-03-11": 13,
          "2026-03-12": 18,
          "2026-03-13": 18,
          "2026-03-16": 31,
          "2026-03-17": 65,
          "2026-03-18": 13,
          "2026-03-19": 13,
          "2026-03-20": 34,
          "2026-03-23": 17,
          "2026-03-24": 17,
          "2026-03-25": 23,
          "2026-03-26": 6,
          "2026-03-27": 4,
          "2026-03-30": 11,
          "2026-03-31": 19,
          "2026-04-01": 11,
          "2026-04-02": 9,
          "2026-04-06": 21,
          "2026-04-07": 20,
          "2026-04-08": 9,
          "2026-04-09": 33,
          "2026-04-10": 35,
          "2026-04-13": 5,
          "2026-04-14": 6,
          "2026-04-15": 10,
          "2026-04-16": 12,
          "2026-04-17": 5,
          "2026-04-20": 12,
          "2026-04-21": 2,
          "2026-04-22": 15,
          "2026-04-23": 11,
          "2026-04-24": 5,
          "2026-04-26": 1,
          "2026-04-27": 19,
          "2026-04-28": 15,
          "2026-04-29": 4,
          "2026-04-30": 4,
          "2026-05-02": 2,
          "2026-05-04": 18,
          "2026-05-05": 44,
          "2026-05-06": 24,
          "2026-05-07": 1,
          "2026-05-08": 20,
          "2026-05-10": 4,
          "2026-05-11": 3,
          "2026-05-12": 17,
          "2026-05-13": 17,
          "2026-05-14": 5,
          "2026-05-15": 7,
          "2026-05-18": 20,
          "2026-05-19": 18,
          "2026-05-20": 4,
          "2026-05-21": 27,
          "2026-05-22": 30,
          "2026-05-25": 24,
          "2026-05-26": 11,
          "2026-05-27": 13,
          "2026-05-28": 6,
          "2026-05-29": 7,
          "2026-06-01": 17,
          "2026-06-02": 20,
          "2026-06-03": 15,
          "2026-06-05": 15,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 48.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 92,
          "time_distribution": {
            "0-2h": 81,
            "2-4h": 92,
            "4-6h": 40,
            "6-8h": 65,
            "8-10h": 25,
            "10-12h": 4,
            "12-14h": 4,
            "14-16h": 1,
            "16-18h": 4,
            "18-20h": 5,
            "20-22h": 6,
            "22-24h": 8,
            "24-26h": 14,
            "26-28h": 4,
            "28-30h": 5,
            "30-32h": 6,
            "32-34h": 6,
            "38-40h": 2,
            "40-42h": 2,
            "42-44h": 2,
            "44-46h": 1,
            "46-48h": 1,
            "48-50h": 4,
            "52-54h": 6,
            "54-56h": 16,
            "56-58h": 2,
            "58-60h": 2,
            "62-64h": 1,
            "64-66h": 2,
            "66-68h": 5,
            "70-72h": 3,
            "72-74h": 3,
            "74-76h": 1,
            "78-80h": 4,
            "80-82h": 2,
            "82-84h": 1,
            "84-86h": 1,
            "86-88h": 2,
            "88-90h": 1,
            "94-96h": 3,
            "96-98h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "116-118h": 2,
            "122-124h": 2,
            "138-140h": 1,
            "140-142h": 1,
            "144-146h": 1,
            "146-148h": 1,
            "192-194h": 2,
            "194-196h": 3,
            "262-264h": 1,
            "280-282h": 1,
            "290-292h": 1,
            "312-314h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "380-382h": 1,
            "402-404h": 1,
            "468-470h": 1,
            "580-582h": 1,
            "662-664h": 1,
            "670-672h": 1,
            "682-684h": 1,
            "760-762h": 1,
            "840-842h": 1,
            "896-898h": 1,
            "940-942h": 1,
            "1190-1192h": 1,
            "1200-1202h": 1,
            "2040-2042h": 1
          },
          "tickets_count": 480,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2025-10-29": 1,
            "2025-10-30": 3,
            "2025-10-31": 2,
            "2025-11-03": 4,
            "2025-11-04": 2,
            "2025-11-07": 1,
            "2025-11-10": 2,
            "2025-11-11": 6,
            "2025-11-13": 2,
            "2025-11-14": 2,
            "2025-11-18": 1,
            "2025-11-19": 2,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-11-26": 4,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-30": 2,
            "2025-12-02": 2,
            "2025-12-03": 7,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-15": 1,
            "2025-12-22": 4,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 4,
            "2026-01-15": 1,
            "2026-01-16": 5,
            "2026-01-20": 3,
            "2026-01-22": 3,
            "2026-01-23": 3,
            "2026-01-26": 3,
            "2026-01-27": 7,
            "2026-01-28": 2,
            "2026-01-29": 3,
            "2026-01-30": 11,
            "2026-02-02": 5,
            "2026-02-03": 2,
            "2026-02-04": 3,
            "2026-02-05": 5,
            "2026-02-06": 2,
            "2026-02-09": 6,
            "2026-02-10": 5,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-17": 3,
            "2026-02-18": 3,
            "2026-02-19": 2,
            "2026-02-20": 3,
            "2026-02-23": 3,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-02-26": 4,
            "2026-02-27": 5,
            "2026-02-28": 3,
            "2026-03-02": 19,
            "2026-03-03": 3,
            "2026-03-04": 9,
            "2026-03-05": 3,
            "2026-03-06": 2,
            "2026-03-07": 3,
            "2026-03-09": 23,
            "2026-03-10": 7,
            "2026-03-11": 3,
            "2026-03-12": 2,
            "2026-03-13": 10,
            "2026-03-16": 20,
            "2026-03-17": 3,
            "2026-03-18": 6,
            "2026-03-19": 4,
            "2026-03-20": 8,
            "2026-03-23": 6,
            "2026-03-24": 4,
            "2026-03-25": 3,
            "2026-03-26": 2,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 6,
            "2026-04-01": 3,
            "2026-04-06": 9,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-09": 2,
            "2026-04-10": 1,
            "2026-04-14": 4,
            "2026-04-15": 4,
            "2026-04-16": 1,
            "2026-04-17": 5,
            "2026-04-20": 4,
            "2026-04-22": 4,
            "2026-04-27": 2,
            "2026-04-28": 6,
            "2026-04-29": 3,
            "2026-04-30": 2,
            "2026-05-04": 10,
            "2026-05-05": 4,
            "2026-05-06": 4,
            "2026-05-08": 1,
            "2026-05-10": 2,
            "2026-05-11": 3,
            "2026-05-12": 3,
            "2026-05-13": 6,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 3,
            "2026-05-19": 2,
            "2026-05-21": 4,
            "2026-05-22": 3,
            "2026-05-25": 10,
            "2026-05-26": 2,
            "2026-05-27": 2,
            "2026-05-28": 3,
            "2026-05-29": 2,
            "2026-06-01": 8,
            "2026-06-02": 10,
            "2026-06-03": 4,
            "2026-06-05": 6,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-27": 4.266186388888889,
            "2025-10-29": 1.4751697222222222,
            "2025-10-30": 45.37463916666667,
            "2025-10-31": 64.40059277777777,
            "2025-11-03": 21.390671666666666,
            "2025-11-04": 174.11333416666668,
            "2025-11-07": 7.910745277777778,
            "2025-11-10": 86.79111083333333,
            "2025-11-11": 227.35522000000003,
            "2025-11-13": 39.16493444444444,
            "2025-11-14": 3.901648611111111,
            "2025-11-18": 7.580475833333333,
            "2025-11-19": 6.509518333333333,
            "2025-11-20": 3.1897516666666665,
            "2025-11-21": 9.812267222222221,
            "2025-11-24": 7.606755555555556,
            "2025-11-26": 24.804433055555556,
            "2025-11-27": 37.838055277777784,
            "2025-11-28": 15.678542499999999,
            "2025-11-30": 4.148313611111111,
            "2025-12-02": 63.55810666666667,
            "2025-12-03": 22.446189999999998,
            "2025-12-04": 29.204210555555555,
            "2025-12-05": 23.87092722222222,
            "2025-12-09": 6.758991944444444,
            "2025-12-10": 1.3825533333333333,
            "2025-12-11": 42.29987,
            "2025-12-15": 65.72100472222222,
            "2025-12-22": 61.553256111111104,
            "2026-01-05": 44.82703305555555,
            "2026-01-07": 8.134878055555555,
            "2026-01-09": 10.136113333333332,
            "2026-01-12": 14.080266666666667,
            "2026-01-13": 33.00572416666667,
            "2026-01-14": 10.342204166666667,
            "2026-01-15": 9.21332,
            "2026-01-16": 24.544510555555554,
            "2026-01-20": 164.14758333333336,
            "2026-01-22": 10.2237525,
            "2026-01-23": 69.00714444444445,
            "2026-01-26": 91.47231444444444,
            "2026-01-27": 147.77962694444446,
            "2026-01-28": 10.294375833333334,
            "2026-01-29": 15.740139722222223,
            "2026-01-30": 1138.9646586111112,
            "2026-02-02": 234.83004972222224,
            "2026-02-03": 55.10911694444444,
            "2026-02-04": 72.61455277777777,
            "2026-02-05": 44.42697166666666,
            "2026-02-06": 16.81598972222222,
            "2026-02-09": 39.868235,
            "2026-02-10": 70.60843555555554,
            "2026-02-11": 1.2553952777777777,
            "2026-02-13": 8.310764166666667,
            "2026-02-17": 40.58201277777778,
            "2026-02-18": 56.3083525,
            "2026-02-19": 79.21968166666667,
            "2026-02-20": 695.4694036111111,
            "2026-02-23": 20.873534166666666,
            "2026-02-24": 20.912975000000003,
            "2026-02-25": 10.08637388888889,
            "2026-02-26": 20.433703333333334,
            "2026-02-27": 15.729041944444443,
            "2026-02-28": 5.815738333333334,
            "2026-03-02": 703.2436302777777,
            "2026-03-03": 105.5301888888889,
            "2026-03-04": 16.490043888888888,
            "2026-03-05": 29.155119166666665,
            "2026-03-06": 1.985176388888889,
            "2026-03-07": 6.08331388888889,
            "2026-03-09": 426.04346333333325,
            "2026-03-10": 56.223332222222226,
            "2026-03-11": 43.14777055555555,
            "2026-03-12": 23.174715277777782,
            "2026-03-13": 776.7137436111111,
            "2026-03-16": 989.9124913888888,
            "2026-03-17": 531.1706244444445,
            "2026-03-18": 882.6121138888888,
            "2026-03-19": 11.934978611111113,
            "2026-03-20": 1204.1814280555557,
            "2026-03-23": 118.68450750000001,
            "2026-03-24": 1239.3183952777777,
            "2026-03-25": 17.621339166666665,
            "2026-03-26": 17.94080138888889,
            "2026-03-27": 5.423542777777778,
            "2026-03-30": 4.803260833333333,
            "2026-03-31": 1277.7555691666669,
            "2026-04-01": 25.216595555555553,
            "2026-04-06": 181.8084536111111,
            "2026-04-07": 6.786682777777777,
            "2026-04-08": 7.549686111111111,
            "2026-04-09": 469.5782858333333,
            "2026-04-10": 1.4720302777777778,
            "2026-04-14": 27.456881111111112,
            "2026-04-15": 69.01355166666666,
            "2026-04-16": 897.6813783333333,
            "2026-04-17": 23.172380833333335,
            "2026-04-20": 165.05004416666668,
            "2026-04-22": 62.16802722222223,
            "2026-04-27": 17.505486666666666,
            "2026-04-28": 812.0874377777777,
            "2026-04-29": 126.85795388888887,
            "2026-04-30": 29.858301944444445,
            "2026-05-04": 466.70921583333336,
            "2026-05-05": 1042.8142372222221,
            "2026-05-06": 2086.8024352777775,
            "2026-05-08": 581.8848891666667,
            "2026-05-10": 99.32111305555556,
            "2026-05-11": 55.94242361111111,
            "2026-05-12": 123.56129527777777,
            "2026-05-13": 97.7608202777778,
            "2026-05-14": 662.2088486111111,
            "2026-05-15": 0.5954644444444445,
            "2026-05-18": 77.57906222222223,
            "2026-05-19": 304.5535447222222,
            "2026-05-21": 71.05450416666666,
            "2026-05-22": 19.474238333333332,
            "2026-05-25": 776.5722158333333,
            "2026-05-26": 94.35630194444444,
            "2026-05-27": 7.520459166666666,
            "2026-05-28": 8.2220225,
            "2026-05-29": 6.249756111111111,
            "2026-06-01": 85.97413722222223,
            "2026-06-02": 290.47956555555555,
            "2026-06-03": 66.74636444444445,
            "2026-06-05": 56.663225,
            "2026-06-08": 0.9049816666666667
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2025-10-29": 1,
            "2025-10-30": 3,
            "2025-10-31": 2,
            "2025-11-03": 4,
            "2025-11-04": 2,
            "2025-11-07": 1,
            "2025-11-10": 2,
            "2025-11-11": 6,
            "2025-11-13": 2,
            "2025-11-14": 2,
            "2025-11-18": 1,
            "2025-11-19": 2,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-11-26": 4,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-30": 2,
            "2025-12-02": 2,
            "2025-12-03": 7,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-15": 1,
            "2025-12-22": 4,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 4,
            "2026-01-15": 1,
            "2026-01-16": 5,
            "2026-01-20": 3,
            "2026-01-22": 3,
            "2026-01-23": 3,
            "2026-01-26": 3,
            "2026-01-27": 7,
            "2026-01-28": 2,
            "2026-01-29": 3,
            "2026-01-30": 11,
            "2026-02-02": 5,
            "2026-02-03": 2,
            "2026-02-04": 3,
            "2026-02-05": 5,
            "2026-02-06": 2,
            "2026-02-09": 6,
            "2026-02-10": 5,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-17": 3,
            "2026-02-18": 3,
            "2026-02-19": 2,
            "2026-02-20": 3,
            "2026-02-23": 3,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-02-26": 4,
            "2026-02-27": 5,
            "2026-02-28": 3,
            "2026-03-02": 19,
            "2026-03-03": 3,
            "2026-03-04": 9,
            "2026-03-05": 3,
            "2026-03-06": 2,
            "2026-03-07": 3,
            "2026-03-09": 23,
            "2026-03-10": 7,
            "2026-03-11": 3,
            "2026-03-12": 2,
            "2026-03-13": 10,
            "2026-03-16": 20,
            "2026-03-17": 3,
            "2026-03-18": 6,
            "2026-03-19": 4,
            "2026-03-20": 8,
            "2026-03-23": 6,
            "2026-03-24": 4,
            "2026-03-25": 3,
            "2026-03-26": 2,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 6,
            "2026-04-01": 3,
            "2026-04-06": 9,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-14": 4,
            "2026-04-15": 4,
            "2026-04-16": 1,
            "2026-04-17": 5,
            "2026-04-20": 4,
            "2026-04-22": 4,
            "2026-04-27": 2,
            "2026-04-28": 6,
            "2026-04-29": 3,
            "2026-04-30": 2,
            "2026-05-04": 10,
            "2026-05-05": 4,
            "2026-05-06": 3,
            "2026-05-08": 1,
            "2026-05-10": 2,
            "2026-05-11": 2,
            "2026-05-12": 3,
            "2026-05-13": 6,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 2,
            "2026-05-19": 2,
            "2026-05-21": 4,
            "2026-05-22": 3,
            "2026-05-25": 10,
            "2026-05-26": 2,
            "2026-05-27": 1,
            "2026-05-28": 2,
            "2026-05-29": 2,
            "2026-06-01": 8,
            "2026-06-02": 10,
            "2026-06-03": 4,
            "2026-06-05": 6,
            "2026-06-08": 2
          }
        },
        "P2": {
          "avg_time_hours": 132.3,
          "mode_time_hours": 7.0,
          "mode_frequency": 119,
          "time_distribution": {
            "0-2h": 80,
            "2-4h": 74,
            "4-6h": 104,
            "6-8h": 119,
            "8-10h": 60,
            "10-12h": 8,
            "12-14h": 5,
            "14-16h": 13,
            "16-18h": 17,
            "18-20h": 35,
            "20-22h": 42,
            "22-24h": 27,
            "24-26h": 26,
            "26-28h": 20,
            "28-30h": 43,
            "30-32h": 37,
            "32-34h": 23,
            "34-36h": 11,
            "36-38h": 5,
            "38-40h": 4,
            "40-42h": 18,
            "42-44h": 18,
            "44-46h": 14,
            "46-48h": 12,
            "48-50h": 11,
            "50-52h": 17,
            "52-54h": 18,
            "54-56h": 15,
            "56-58h": 10,
            "58-60h": 2,
            "60-62h": 2,
            "62-64h": 3,
            "64-66h": 8,
            "66-68h": 21,
            "68-70h": 13,
            "70-72h": 10,
            "72-74h": 14,
            "74-76h": 5,
            "76-78h": 10,
            "78-80h": 15,
            "80-82h": 4,
            "82-84h": 3,
            "84-86h": 3,
            "86-88h": 1,
            "88-90h": 2,
            "90-92h": 4,
            "92-94h": 6,
            "94-96h": 7,
            "96-98h": 11,
            "98-100h": 3,
            "100-102h": 4,
            "102-104h": 5,
            "104-106h": 7,
            "106-108h": 3,
            "112-114h": 1,
            "114-116h": 3,
            "116-118h": 7,
            "118-120h": 4,
            "120-122h": 5,
            "122-124h": 1,
            "126-128h": 4,
            "128-130h": 1,
            "130-132h": 2,
            "132-134h": 3,
            "134-136h": 5,
            "136-138h": 3,
            "138-140h": 6,
            "140-142h": 3,
            "142-144h": 6,
            "144-146h": 7,
            "146-148h": 2,
            "148-150h": 1,
            "150-152h": 1,
            "154-156h": 1,
            "156-158h": 2,
            "158-160h": 2,
            "160-162h": 4,
            "162-164h": 3,
            "164-166h": 4,
            "166-168h": 7,
            "168-170h": 4,
            "170-172h": 3,
            "172-174h": 6,
            "176-178h": 1,
            "178-180h": 1,
            "180-182h": 2,
            "184-186h": 2,
            "186-188h": 2,
            "188-190h": 4,
            "190-192h": 2,
            "192-194h": 2,
            "194-196h": 5,
            "196-198h": 1,
            "198-200h": 1,
            "202-204h": 3,
            "204-206h": 4,
            "206-208h": 1,
            "208-210h": 1,
            "210-212h": 2,
            "214-216h": 3,
            "216-218h": 3,
            "218-220h": 11,
            "226-228h": 3,
            "234-236h": 1,
            "238-240h": 1,
            "240-242h": 2,
            "242-244h": 1,
            "246-248h": 1,
            "248-250h": 1,
            "254-256h": 2,
            "256-258h": 2,
            "260-262h": 1,
            "262-264h": 2,
            "268-270h": 1,
            "270-272h": 2,
            "278-280h": 1,
            "282-284h": 2,
            "286-288h": 2,
            "288-290h": 2,
            "290-292h": 2,
            "292-294h": 4,
            "298-300h": 1,
            "300-302h": 1,
            "304-306h": 2,
            "306-308h": 3,
            "308-310h": 1,
            "312-314h": 1,
            "314-316h": 1,
            "316-318h": 2,
            "318-320h": 3,
            "324-326h": 4,
            "326-328h": 2,
            "328-330h": 1,
            "330-332h": 1,
            "332-334h": 1,
            "334-336h": 2,
            "336-338h": 1,
            "340-342h": 4,
            "342-344h": 2,
            "344-346h": 1,
            "348-350h": 3,
            "352-354h": 2,
            "354-356h": 2,
            "360-362h": 3,
            "362-364h": 1,
            "364-366h": 2,
            "366-368h": 4,
            "376-378h": 1,
            "380-382h": 1,
            "384-386h": 1,
            "386-388h": 2,
            "388-390h": 1,
            "390-392h": 2,
            "398-400h": 1,
            "406-408h": 1,
            "408-410h": 2,
            "410-412h": 1,
            "414-416h": 2,
            "416-418h": 1,
            "424-426h": 2,
            "426-428h": 1,
            "428-430h": 2,
            "430-432h": 3,
            "438-440h": 1,
            "444-446h": 1,
            "448-450h": 1,
            "460-462h": 1,
            "472-474h": 1,
            "474-476h": 1,
            "488-490h": 1,
            "490-492h": 5,
            "492-494h": 1,
            "498-500h": 1,
            "502-504h": 2,
            "504-506h": 2,
            "506-508h": 2,
            "508-510h": 1,
            "512-514h": 2,
            "514-516h": 1,
            "520-522h": 1,
            "526-528h": 2,
            "528-530h": 1,
            "532-534h": 2,
            "534-536h": 1,
            "536-538h": 1,
            "538-540h": 1,
            "540-542h": 3,
            "542-544h": 1,
            "544-546h": 1,
            "548-550h": 1,
            "554-556h": 1,
            "564-566h": 1,
            "568-570h": 1,
            "570-572h": 1,
            "572-574h": 2,
            "574-576h": 1,
            "576-578h": 1,
            "580-582h": 1,
            "582-584h": 4,
            "596-598h": 1,
            "616-618h": 2,
            "622-624h": 1,
            "628-630h": 1,
            "642-644h": 3,
            "644-646h": 1,
            "660-662h": 1,
            "672-674h": 1,
            "674-676h": 1,
            "698-700h": 1,
            "704-706h": 1,
            "718-720h": 1,
            "724-726h": 1,
            "744-746h": 1,
            "746-748h": 1,
            "758-760h": 1,
            "764-766h": 2,
            "780-782h": 1,
            "794-796h": 1,
            "798-800h": 1,
            "818-820h": 2,
            "836-838h": 1,
            "840-842h": 1,
            "842-844h": 1,
            "848-850h": 1,
            "866-868h": 1,
            "872-874h": 1,
            "902-904h": 1,
            "916-918h": 1,
            "918-920h": 1,
            "924-926h": 1,
            "936-938h": 1,
            "938-940h": 1,
            "980-982h": 1,
            "984-986h": 1,
            "986-988h": 1,
            "992-994h": 1,
            "1002-1004h": 2,
            "1010-1012h": 1,
            "1028-1030h": 2,
            "1076-1078h": 1,
            "1086-1088h": 1,
            "1096-1098h": 1,
            "1098-1100h": 1,
            "1102-1104h": 1,
            "1152-1154h": 1,
            "1208-1210h": 1,
            "1236-1238h": 2,
            "1244-1246h": 1,
            "1256-1258h": 1,
            "1258-1260h": 1,
            "1268-1270h": 1,
            "1276-1278h": 1,
            "1336-1338h": 1,
            "1340-1342h": 1,
            "1462-1464h": 1,
            "1486-1488h": 1,
            "1548-1550h": 1,
            "1636-1638h": 1,
            "1660-1662h": 1,
            "1712-1714h": 1,
            "1762-1764h": 1,
            "1896-1898h": 1,
            "1906-1908h": 1
          },
          "tickets_count": 1505,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-09": 2,
            "2025-10-10": 1,
            "2025-10-14": 1,
            "2025-10-22": 1,
            "2025-10-23": 6,
            "2025-10-24": 4,
            "2025-10-27": 13,
            "2025-10-28": 9,
            "2025-10-29": 4,
            "2025-10-30": 5,
            "2025-10-31": 27,
            "2025-11-03": 14,
            "2025-11-04": 22,
            "2025-11-05": 8,
            "2025-11-06": 14,
            "2025-11-07": 6,
            "2025-11-10": 16,
            "2025-11-11": 9,
            "2025-11-12": 5,
            "2025-11-13": 11,
            "2025-11-14": 7,
            "2025-11-17": 25,
            "2025-11-18": 5,
            "2025-11-19": 6,
            "2025-11-20": 4,
            "2025-11-21": 6,
            "2025-11-22": 5,
            "2025-11-24": 12,
            "2025-11-25": 3,
            "2025-11-26": 7,
            "2025-11-27": 16,
            "2025-11-28": 6,
            "2025-11-30": 1,
            "2025-12-02": 13,
            "2025-12-03": 4,
            "2025-12-04": 16,
            "2025-12-05": 9,
            "2025-12-09": 12,
            "2025-12-10": 3,
            "2025-12-11": 14,
            "2025-12-12": 7,
            "2025-12-13": 6,
            "2025-12-14": 5,
            "2025-12-15": 6,
            "2025-12-16": 1,
            "2025-12-17": 12,
            "2025-12-18": 14,
            "2025-12-19": 1,
            "2025-12-22": 8,
            "2025-12-23": 9,
            "2025-12-26": 3,
            "2025-12-29": 10,
            "2025-12-30": 5,
            "2026-01-05": 12,
            "2026-01-06": 14,
            "2026-01-07": 1,
            "2026-01-08": 9,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 7,
            "2026-01-14": 12,
            "2026-01-15": 6,
            "2026-01-16": 6,
            "2026-01-19": 2,
            "2026-01-20": 25,
            "2026-01-21": 12,
            "2026-01-22": 5,
            "2026-01-23": 3,
            "2026-01-26": 5,
            "2026-01-27": 12,
            "2026-01-29": 2,
            "2026-02-03": 7,
            "2026-02-04": 8,
            "2026-02-06": 1,
            "2026-02-09": 2,
            "2026-02-10": 14,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-16": 2,
            "2026-02-17": 3,
            "2026-02-18": 9,
            "2026-02-19": 7,
            "2026-02-20": 2,
            "2026-02-22": 2,
            "2026-02-23": 16,
            "2026-02-24": 8,
            "2026-02-25": 9,
            "2026-02-27": 6,
            "2026-03-02": 33,
            "2026-03-03": 8,
            "2026-03-04": 6,
            "2026-03-05": 13,
            "2026-03-06": 10,
            "2026-03-09": 12,
            "2026-03-10": 5,
            "2026-03-11": 9,
            "2026-03-12": 16,
            "2026-03-13": 8,
            "2026-03-16": 10,
            "2026-03-17": 46,
            "2026-03-18": 5,
            "2026-03-19": 9,
            "2026-03-20": 22,
            "2026-03-23": 12,
            "2026-03-24": 11,
            "2026-03-25": 15,
            "2026-03-26": 4,
            "2026-03-27": 1,
            "2026-03-30": 10,
            "2026-03-31": 11,
            "2026-04-01": 6,
            "2026-04-02": 9,
            "2026-04-06": 10,
            "2026-04-07": 18,
            "2026-04-08": 8,
            "2026-04-09": 31,
            "2026-04-10": 30,
            "2026-04-13": 4,
            "2026-04-14": 3,
            "2026-04-15": 6,
            "2026-04-16": 10,
            "2026-04-17": 1,
            "2026-04-20": 8,
            "2026-04-21": 2,
            "2026-04-22": 11,
            "2026-04-23": 11,
            "2026-04-24": 5,
            "2026-04-26": 1,
            "2026-04-27": 18,
            "2026-04-28": 9,
            "2026-04-29": 1,
            "2026-04-30": 2,
            "2026-05-02": 3,
            "2026-05-04": 10,
            "2026-05-05": 40,
            "2026-05-06": 22,
            "2026-05-08": 19,
            "2026-05-09": 1,
            "2026-05-10": 1,
            "2026-05-11": 7,
            "2026-05-12": 14,
            "2026-05-13": 10,
            "2026-05-14": 4,
            "2026-05-15": 6,
            "2026-05-18": 17,
            "2026-05-19": 16,
            "2026-05-20": 5,
            "2026-05-21": 23,
            "2026-05-22": 28,
            "2026-05-23": 1,
            "2026-05-25": 14,
            "2026-05-26": 16,
            "2026-05-27": 15,
            "2026-05-28": 6,
            "2026-05-29": 9,
            "2026-06-01": 12,
            "2026-06-02": 11,
            "2026-06-03": 14,
            "2026-06-05": 16,
            "2026-06-06": 3,
            "2026-06-08": 5
          },
          "time_per_day": {
            "2025-10-08": 53.6505225,
            "2025-10-09": 188.15949916666665,
            "2025-10-10": 40.36689472222222,
            "2025-10-14": 16.192532777777778,
            "2025-10-22": 0.08416194444444444,
            "2025-10-23": 1045.1798805555554,
            "2025-10-24": 14.662827499999999,
            "2025-10-27": 226.94669055555553,
            "2025-10-28": 540.9404644444445,
            "2025-10-29": 235.80162888888887,
            "2025-10-30": 170.10136444444444,
            "2025-10-31": 1854.5503997222218,
            "2025-11-03": 578.2649152777777,
            "2025-11-04": 875.943601111111,
            "2025-11-05": 323.69166944444447,
            "2025-11-06": 108.28947722222222,
            "2025-11-07": 113.54213861111111,
            "2025-11-10": 922.6149780555556,
            "2025-11-11": 417.41335000000004,
            "2025-11-12": 182.8506036111111,
            "2025-11-13": 582.0089855555556,
            "2025-11-14": 245.0140366666667,
            "2025-11-17": 1496.247501111111,
            "2025-11-18": 378.76126166666666,
            "2025-11-19": 820.5727922222221,
            "2025-11-20": 407.72470166666665,
            "2025-11-21": 320.3204161111111,
            "2025-11-22": 127.91303833333333,
            "2025-11-24": 1115.1203013888887,
            "2025-11-25": 381.78816111111115,
            "2025-11-26": 272.7637838888889,
            "2025-11-27": 374.7098313888888,
            "2025-11-28": 363.69742583333334,
            "2025-11-30": 85.22440611111112,
            "2025-12-02": 1317.7487683333334,
            "2025-12-03": 65.69918472222221,
            "2025-12-04": 1223.629413611111,
            "2025-12-05": 807.7307172222222,
            "2025-12-09": 696.9724883333332,
            "2025-12-10": 212.7347216666667,
            "2025-12-11": 1082.2327138888888,
            "2025-12-12": 923.2113405555555,
            "2025-12-13": 709.632901111111,
            "2025-12-14": 281.1087452777778,
            "2025-12-15": 228.19703527777781,
            "2025-12-16": 54.9179925,
            "2025-12-17": 1051.1956091666666,
            "2025-12-18": 812.4414897222222,
            "2025-12-19": 2.3543997222222224,
            "2025-12-22": 132.51905916666666,
            "2025-12-23": 546.3407566666668,
            "2025-12-26": 306.74757305555556,
            "2025-12-29": 961.4728138888889,
            "2025-12-30": 65.0279075,
            "2026-01-05": 2146.2941636111113,
            "2026-01-06": 2019.5292205555556,
            "2026-01-07": 48.47889916666667,
            "2026-01-08": 163.47828861111114,
            "2026-01-09": 5.1569825,
            "2026-01-12": 189.99320999999998,
            "2026-01-13": 1627.0131205555556,
            "2026-01-14": 457.4604258333334,
            "2026-01-15": 78.39655749999999,
            "2026-01-16": 868.9925344444443,
            "2026-01-19": 35.78324111111111,
            "2026-01-20": 998.2762674999999,
            "2026-01-21": 822.7086736111114,
            "2026-01-22": 87.43891305555556,
            "2026-01-23": 100.13993972222222,
            "2026-01-26": 139.67612194444447,
            "2026-01-27": 361.6590080555556,
            "2026-01-29": 577.3166808333333,
            "2026-02-03": 508.9731833333334,
            "2026-02-04": 2144.3680397222224,
            "2026-02-06": 4.203928055555555,
            "2026-02-09": 125.24296833333332,
            "2026-02-10": 2522.90641361111,
            "2026-02-12": 1763.7845513888888,
            "2026-02-13": 41.839655,
            "2026-02-16": 70.24742083333334,
            "2026-02-17": 42.836555833333335,
            "2026-02-18": 283.2835872222223,
            "2026-02-19": 478.8205625,
            "2026-02-20": 74.38710805555556,
            "2026-02-22": 67.21825555555554,
            "2026-02-23": 271.4031755555555,
            "2026-02-24": 101.71189277777778,
            "2026-02-25": 1322.0919747222224,
            "2026-02-27": 197.93084249999995,
            "2026-03-02": 1876.206384166666,
            "2026-03-03": 359.71893750000004,
            "2026-03-04": 76.23588361111112,
            "2026-03-05": 1082.366075,
            "2026-03-06": 2677.9491216666665,
            "2026-03-09": 213.255495,
            "2026-03-10": 156.6347025,
            "2026-03-11": 1602.2422097222222,
            "2026-03-12": 1924.866991388889,
            "2026-03-13": 573.8303208333334,
            "2026-03-16": 51.88583916666666,
            "2026-03-17": 17804.92433777778,
            "2026-03-18": 1742.348747222222,
            "2026-03-19": 1432.0397352777775,
            "2026-03-20": 11210.810481944443,
            "2026-03-23": 1890.009660277778,
            "2026-03-24": 5986.971108888889,
            "2026-03-25": 3566.8754841666673,
            "2026-03-26": 402.6751869444445,
            "2026-03-27": 67.33715083333333,
            "2026-03-30": 949.1983047222225,
            "2026-03-31": 1441.0339513888891,
            "2026-04-01": 1195.8835561111111,
            "2026-04-02": 262.2300997222222,
            "2026-04-06": 451.2522230555555,
            "2026-04-07": 10364.021021944447,
            "2026-04-08": 136.9819097222222,
            "2026-04-09": 6311.977522777775,
            "2026-04-10": 22503.238151111105,
            "2026-04-13": 18.580959722222218,
            "2026-04-14": 150.09812666666664,
            "2026-04-15": 79.65126916666668,
            "2026-04-16": 1239.6362505555555,
            "2026-04-20": 316.0158469444444,
            "2026-04-21": 37.696800277777776,
            "2026-04-22": 374.9530688888888,
            "2026-04-23": 3014.7638933333333,
            "2026-04-24": 189.56530722222223,
            "2026-04-26": 386.9462188888889,
            "2026-04-27": 352.5411352777777,
            "2026-04-28": 737.929261111111,
            "2026-04-29": 19.342809444444445,
            "2026-04-30": 52.09903027777778,
            "2026-05-02": 348.5236488888889,
            "2026-05-04": 204.57574722222225,
            "2026-05-05": 11933.037015277776,
            "2026-05-06": 5611.508093055557,
            "2026-05-08": 6736.876023055556,
            "2026-05-10": 72.01353027777778,
            "2026-05-11": 6.761735833333333,
            "2026-05-12": 554.0190600000001,
            "2026-05-13": 207.65320499999999,
            "2026-05-14": 575.3487969444444,
            "2026-05-15": 117.02563916666669,
            "2026-05-18": 831.5761902777776,
            "2026-05-19": 145.73469722222222,
            "2026-05-20": 39.08823361111111,
            "2026-05-21": 2881.1669805555566,
            "2026-05-22": 4406.544308055555,
            "2026-05-25": 197.6318963888889,
            "2026-05-26": 688.9318811111111,
            "2026-05-27": 243.26559138888888,
            "2026-05-28": 419.0205080555555,
            "2026-05-29": 107.86519361111112,
            "2026-06-01": 242.14015444444448,
            "2026-06-02": 208.17997111111112,
            "2026-06-03": 601.873201111111,
            "2026-06-05": 205.57876333333328
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-09": 2,
            "2025-10-10": 1,
            "2025-10-14": 1,
            "2025-10-22": 1,
            "2025-10-23": 6,
            "2025-10-24": 4,
            "2025-10-27": 13,
            "2025-10-28": 9,
            "2025-10-29": 4,
            "2025-10-30": 5,
            "2025-10-31": 27,
            "2025-11-03": 14,
            "2025-11-04": 22,
            "2025-11-05": 8,
            "2025-11-06": 14,
            "2025-11-07": 6,
            "2025-11-10": 16,
            "2025-11-11": 9,
            "2025-11-12": 5,
            "2025-11-13": 11,
            "2025-11-14": 7,
            "2025-11-17": 25,
            "2025-11-18": 5,
            "2025-11-19": 6,
            "2025-11-20": 4,
            "2025-11-21": 6,
            "2025-11-22": 5,
            "2025-11-24": 12,
            "2025-11-25": 3,
            "2025-11-26": 7,
            "2025-11-27": 16,
            "2025-11-28": 6,
            "2025-11-30": 1,
            "2025-12-02": 13,
            "2025-12-03": 4,
            "2025-12-04": 16,
            "2025-12-05": 9,
            "2025-12-09": 12,
            "2025-12-10": 3,
            "2025-12-11": 14,
            "2025-12-12": 7,
            "2025-12-13": 6,
            "2025-12-14": 5,
            "2025-12-15": 6,
            "2025-12-16": 1,
            "2025-12-17": 12,
            "2025-12-18": 14,
            "2025-12-19": 1,
            "2025-12-22": 8,
            "2025-12-23": 9,
            "2025-12-26": 3,
            "2025-12-29": 10,
            "2025-12-30": 5,
            "2026-01-05": 12,
            "2026-01-06": 14,
            "2026-01-07": 1,
            "2026-01-08": 9,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 7,
            "2026-01-14": 12,
            "2026-01-15": 6,
            "2026-01-16": 5,
            "2026-01-19": 1,
            "2026-01-20": 25,
            "2026-01-21": 12,
            "2026-01-22": 5,
            "2026-01-23": 3,
            "2026-01-26": 5,
            "2026-01-27": 12,
            "2026-01-29": 2,
            "2026-02-03": 7,
            "2026-02-04": 8,
            "2026-02-06": 1,
            "2026-02-09": 2,
            "2026-02-10": 14,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-16": 2,
            "2026-02-17": 3,
            "2026-02-18": 9,
            "2026-02-19": 7,
            "2026-02-20": 2,
            "2026-02-22": 2,
            "2026-02-23": 16,
            "2026-02-24": 8,
            "2026-02-25": 9,
            "2026-02-27": 6,
            "2026-03-02": 33,
            "2026-03-03": 8,
            "2026-03-04": 5,
            "2026-03-05": 13,
            "2026-03-06": 10,
            "2026-03-09": 12,
            "2026-03-10": 4,
            "2026-03-11": 9,
            "2026-03-12": 16,
            "2026-03-13": 8,
            "2026-03-16": 10,
            "2026-03-17": 46,
            "2026-03-18": 4,
            "2026-03-19": 9,
            "2026-03-20": 22,
            "2026-03-23": 11,
            "2026-03-24": 10,
            "2026-03-25": 14,
            "2026-03-26": 4,
            "2026-03-27": 1,
            "2026-03-30": 9,
            "2026-03-31": 11,
            "2026-04-01": 6,
            "2026-04-02": 9,
            "2026-04-06": 10,
            "2026-04-07": 18,
            "2026-04-08": 7,
            "2026-04-09": 30,
            "2026-04-10": 30,
            "2026-04-13": 4,
            "2026-04-14": 2,
            "2026-04-15": 6,
            "2026-04-16": 10,
            "2026-04-20": 8,
            "2026-04-21": 2,
            "2026-04-22": 11,
            "2026-04-23": 11,
            "2026-04-24": 5,
            "2026-04-26": 1,
            "2026-04-27": 17,
            "2026-04-28": 9,
            "2026-04-29": 1,
            "2026-04-30": 2,
            "2026-05-02": 2,
            "2026-05-04": 8,
            "2026-05-05": 40,
            "2026-05-06": 19,
            "2026-05-08": 19,
            "2026-05-10": 1,
            "2026-05-11": 1,
            "2026-05-12": 14,
            "2026-05-13": 10,
            "2026-05-14": 4,
            "2026-05-15": 6,
            "2026-05-18": 17,
            "2026-05-19": 16,
            "2026-05-20": 4,
            "2026-05-21": 23,
            "2026-05-22": 27,
            "2026-05-25": 13,
            "2026-05-26": 9,
            "2026-05-27": 12,
            "2026-05-28": 4,
            "2026-05-29": 5,
            "2026-06-01": 9,
            "2026-06-02": 10,
            "2026-06-03": 11,
            "2026-06-05": 9
          }
        },
        "P3": {
          "avg_time_hours": 173.46,
          "mode_time_hours": 9.0,
          "mode_frequency": 29,
          "time_distribution": {
            "0-2h": 23,
            "2-4h": 29,
            "4-6h": 20,
            "6-8h": 23,
            "8-10h": 29,
            "10-12h": 1,
            "14-16h": 3,
            "16-18h": 5,
            "18-20h": 1,
            "20-22h": 10,
            "22-24h": 6,
            "24-26h": 7,
            "26-28h": 14,
            "28-30h": 6,
            "30-32h": 8,
            "32-34h": 17,
            "34-36h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "42-44h": 6,
            "44-46h": 5,
            "46-48h": 5,
            "48-50h": 10,
            "50-52h": 8,
            "52-54h": 4,
            "54-56h": 8,
            "56-58h": 1,
            "62-64h": 1,
            "64-66h": 1,
            "66-68h": 2,
            "68-70h": 2,
            "70-72h": 7,
            "72-74h": 3,
            "74-76h": 3,
            "76-78h": 2,
            "78-80h": 2,
            "80-82h": 4,
            "84-86h": 1,
            "88-90h": 1,
            "90-92h": 1,
            "94-96h": 3,
            "96-98h": 8,
            "98-100h": 8,
            "100-102h": 14,
            "102-104h": 5,
            "104-106h": 1,
            "106-108h": 1,
            "108-110h": 1,
            "110-112h": 1,
            "118-120h": 4,
            "120-122h": 2,
            "122-124h": 1,
            "124-126h": 2,
            "126-128h": 3,
            "128-130h": 6,
            "134-136h": 1,
            "136-138h": 2,
            "140-142h": 1,
            "142-144h": 1,
            "144-146h": 3,
            "148-150h": 13,
            "150-152h": 2,
            "152-154h": 1,
            "158-160h": 1,
            "160-162h": 1,
            "164-166h": 4,
            "166-168h": 1,
            "168-170h": 1,
            "170-172h": 2,
            "172-174h": 2,
            "176-178h": 2,
            "182-184h": 1,
            "184-186h": 1,
            "186-188h": 1,
            "188-190h": 2,
            "190-192h": 3,
            "192-194h": 2,
            "194-196h": 2,
            "196-198h": 1,
            "198-200h": 1,
            "200-202h": 1,
            "222-224h": 1,
            "228-230h": 1,
            "244-246h": 1,
            "248-250h": 1,
            "250-252h": 1,
            "260-262h": 1,
            "262-264h": 2,
            "268-270h": 3,
            "270-272h": 1,
            "272-274h": 3,
            "276-278h": 1,
            "312-314h": 2,
            "318-320h": 1,
            "338-340h": 1,
            "344-346h": 1,
            "356-358h": 1,
            "360-362h": 1,
            "372-374h": 1,
            "406-408h": 1,
            "450-452h": 1,
            "452-454h": 2,
            "504-506h": 2,
            "528-530h": 2,
            "572-574h": 1,
            "576-578h": 5,
            "598-600h": 1,
            "714-716h": 1,
            "722-724h": 1,
            "768-770h": 1,
            "816-818h": 1,
            "824-826h": 1,
            "834-836h": 1,
            "872-874h": 2,
            "882-884h": 1,
            "906-908h": 1,
            "952-954h": 1,
            "960-962h": 2,
            "976-978h": 1,
            "984-986h": 2,
            "1006-1008h": 1,
            "1012-1014h": 1,
            "1096-1098h": 1,
            "1102-1104h": 1,
            "1104-1106h": 1,
            "1176-1178h": 1,
            "1178-1180h": 1,
            "1202-1204h": 1,
            "1326-1328h": 1,
            "1338-1340h": 1,
            "1376-1378h": 2,
            "1380-1382h": 1,
            "1390-1392h": 1,
            "1514-1516h": 1,
            "1570-1572h": 1,
            "1658-1660h": 1,
            "1718-1720h": 1,
            "1728-1730h": 1,
            "2152-2154h": 1,
            "2902-2904h": 1
          },
          "tickets_count": 482,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-10-23": 2,
            "2025-11-04": 2,
            "2025-11-05": 1,
            "2025-11-10": 2,
            "2025-11-12": 3,
            "2025-11-13": 14,
            "2025-11-14": 3,
            "2025-11-17": 21,
            "2025-11-18": 5,
            "2025-11-19": 5,
            "2025-11-20": 2,
            "2025-11-21": 2,
            "2025-11-22": 13,
            "2025-11-24": 20,
            "2025-11-25": 5,
            "2025-11-26": 7,
            "2025-11-27": 8,
            "2025-11-28": 7,
            "2025-11-30": 1,
            "2025-12-02": 12,
            "2025-12-03": 1,
            "2025-12-04": 11,
            "2025-12-05": 7,
            "2025-12-09": 5,
            "2025-12-10": 8,
            "2025-12-11": 15,
            "2025-12-12": 9,
            "2025-12-13": 5,
            "2025-12-14": 8,
            "2025-12-15": 5,
            "2025-12-17": 5,
            "2025-12-18": 9,
            "2025-12-19": 5,
            "2025-12-22": 2,
            "2025-12-23": 4,
            "2025-12-24": 2,
            "2025-12-26": 7,
            "2025-12-29": 5,
            "2025-12-30": 3,
            "2025-12-31": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-07": 2,
            "2026-01-08": 3,
            "2026-01-10": 1,
            "2026-01-12": 2,
            "2026-01-13": 8,
            "2026-01-14": 20,
            "2026-01-15": 2,
            "2026-01-16": 5,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-21": 9,
            "2026-01-26": 1,
            "2026-01-27": 27,
            "2026-01-29": 1,
            "2026-01-30": 3,
            "2026-02-02": 7,
            "2026-02-03": 7,
            "2026-02-04": 23,
            "2026-02-05": 2,
            "2026-02-06": 2,
            "2026-02-09": 6,
            "2026-02-10": 6,
            "2026-02-11": 2,
            "2026-02-12": 3,
            "2026-02-13": 4,
            "2026-02-16": 4,
            "2026-02-18": 2,
            "2026-02-20": 1,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-05": 5,
            "2026-03-06": 7,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-17": 16,
            "2026-03-18": 3,
            "2026-03-20": 4,
            "2026-03-24": 3,
            "2026-03-25": 6,
            "2026-03-31": 2,
            "2026-04-01": 2,
            "2026-04-06": 2,
            "2026-04-08": 1,
            "2026-04-09": 2,
            "2026-04-10": 4,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-13": 1,
            "2026-05-18": 1,
            "2026-05-25": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-13": 0.18714916666666664,
            "2025-10-23": 564.9127875,
            "2025-11-04": 10.265347777777778,
            "2025-11-05": 8.505236388888889,
            "2025-11-10": 614.9529177777778,
            "2025-11-12": 29.9439925,
            "2025-11-13": 268.13271583333346,
            "2025-11-14": 270.97282972222223,
            "2025-11-17": 1973.1453922222222,
            "2025-11-18": 128.78003583333336,
            "2025-11-19": 42.0877,
            "2025-11-20": 174.08996944444442,
            "2025-11-21": 113.0926125,
            "2025-11-22": 937.6392994444445,
            "2025-11-24": 1643.8156583333337,
            "2025-11-25": 415.62317,
            "2025-11-26": 329.8245733333333,
            "2025-11-27": 80.60043916666667,
            "2025-11-28": 146.93484666666666,
            "2025-11-30": 43.668389166666664,
            "2025-12-02": 861.2698336111112,
            "2025-12-03": 0.14630722222222223,
            "2025-12-04": 2141.4480100000005,
            "2025-12-05": 379.4149897222222,
            "2025-12-09": 314.83780972222223,
            "2025-12-10": 637.5206052777777,
            "2025-12-11": 2529.5799894444444,
            "2025-12-12": 166.84938361111114,
            "2025-12-13": 1349.5896272222221,
            "2025-12-14": 399.1870141666667,
            "2025-12-15": 186.63769916666666,
            "2025-12-17": 209.4849336111111,
            "2025-12-18": 675.7056825000001,
            "2025-12-19": 347.7480458333334,
            "2025-12-22": 254.41725944444445,
            "2025-12-23": 328.6656697222222,
            "2025-12-24": 699.1475755555556,
            "2025-12-26": 1694.9179055555558,
            "2025-12-29": 349.1148966666666,
            "2025-12-30": 144.13959333333332,
            "2025-12-31": 52.349401944444445,
            "2026-01-05": 406.6511561111111,
            "2026-01-06": 27.836116666666666,
            "2026-01-07": 64.12452083333334,
            "2026-01-08": 56.97413138888889,
            "2026-01-12": 15.989611944444444,
            "2026-01-13": 303.07245416666666,
            "2026-01-14": 2513.636925833333,
            "2026-01-15": 113.25286694444443,
            "2026-01-16": 1789.9622913888886,
            "2026-01-19": 9.050720555555555,
            "2026-01-20": 55.64463194444444,
            "2026-01-21": 575.7281844444444,
            "2026-01-26": 7.296999444444444,
            "2026-01-27": 3255.50560611111,
            "2026-01-29": 49.87528777777778,
            "2026-01-30": 279.57933777777777,
            "2026-02-02": 73.5352325,
            "2026-02-03": 492.98274888888886,
            "2026-02-04": 2313.6567783333326,
            "2026-02-05": 15.589222499999998,
            "2026-02-06": 232.88725055555557,
            "2026-02-09": 212.42088444444445,
            "2026-02-10": 155.19146444444445,
            "2026-02-11": 9.379604166666667,
            "2026-02-12": 151.13185333333334,
            "2026-02-13": 99.55614,
            "2026-02-16": 406.5999211111111,
            "2026-02-18": 489.12999972222224,
            "2026-02-25": 312.00210527777773,
            "2026-03-02": 0.760531111111111,
            "2026-03-05": 2887.9969547222227,
            "2026-03-06": 4502.409372777777,
            "2026-03-11": 961.1505605555556,
            "2026-03-16": 3.3592455555555554,
            "2026-03-17": 6810.941920555557,
            "2026-03-18": 72.18991583333334,
            "2026-03-20": 2268.5714769444444,
            "2026-03-24": 3635.96933,
            "2026-03-25": 5867.991943333333,
            "2026-03-31": 2435.2797088888888,
            "2026-04-01": 1209.3883822222222,
            "2026-04-06": 299.6327919444444,
            "2026-04-08": 199.64447777777778,
            "2026-04-09": 2753.2722791666665,
            "2026-04-10": 6329.0997402777775,
            "2026-04-13": 4.4292758333333335,
            "2026-04-16": 4.032726666666667,
            "2026-05-06": 5055.632395833333,
            "2026-05-07": 2.6027802777777778,
            "2026-05-10": 74.07216916666667,
            "2026-05-13": 46.38438527777778,
            "2026-05-18": 262.2557683333333,
            "2026-05-25": 5.3107033333333336
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-10-23": 2,
            "2025-11-04": 2,
            "2025-11-05": 1,
            "2025-11-10": 2,
            "2025-11-12": 3,
            "2025-11-13": 14,
            "2025-11-14": 2,
            "2025-11-17": 21,
            "2025-11-18": 5,
            "2025-11-19": 5,
            "2025-11-20": 2,
            "2025-11-21": 2,
            "2025-11-22": 13,
            "2025-11-24": 19,
            "2025-11-25": 5,
            "2025-11-26": 7,
            "2025-11-27": 8,
            "2025-11-28": 7,
            "2025-11-30": 1,
            "2025-12-02": 12,
            "2025-12-03": 1,
            "2025-12-04": 11,
            "2025-12-05": 7,
            "2025-12-09": 5,
            "2025-12-10": 7,
            "2025-12-11": 15,
            "2025-12-12": 9,
            "2025-12-13": 5,
            "2025-12-14": 8,
            "2025-12-15": 5,
            "2025-12-17": 5,
            "2025-12-18": 9,
            "2025-12-19": 5,
            "2025-12-22": 2,
            "2025-12-23": 4,
            "2025-12-24": 2,
            "2025-12-26": 7,
            "2025-12-29": 4,
            "2025-12-30": 3,
            "2025-12-31": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-07": 2,
            "2026-01-08": 3,
            "2026-01-12": 2,
            "2026-01-13": 8,
            "2026-01-14": 20,
            "2026-01-15": 2,
            "2026-01-16": 4,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-21": 8,
            "2026-01-26": 1,
            "2026-01-27": 27,
            "2026-01-29": 1,
            "2026-01-30": 2,
            "2026-02-02": 6,
            "2026-02-03": 7,
            "2026-02-04": 23,
            "2026-02-05": 2,
            "2026-02-06": 2,
            "2026-02-09": 6,
            "2026-02-10": 6,
            "2026-02-11": 2,
            "2026-02-12": 3,
            "2026-02-13": 4,
            "2026-02-16": 4,
            "2026-02-18": 2,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-05": 5,
            "2026-03-06": 7,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-17": 16,
            "2026-03-18": 3,
            "2026-03-20": 4,
            "2026-03-24": 3,
            "2026-03-25": 6,
            "2026-03-31": 2,
            "2026-04-01": 2,
            "2026-04-06": 2,
            "2026-04-08": 1,
            "2026-04-09": 2,
            "2026-04-10": 4,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-13": 1,
            "2026-05-18": 1,
            "2026-05-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 29.03,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "8-10h": 1,
            "44-46h": 1,
            "86-88h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-10": 2,
            "2025-11-21": 1,
            "2025-11-30": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-11-10": 3.011468888888889,
            "2025-11-21": 9.804733055555555,
            "2025-11-30": 44.71778611111111,
            "2026-01-27": 87.59708722222223
          },
          "time_count_per_day": {
            "2025-11-10": 2,
            "2025-11-21": 1,
            "2025-11-30": 1,
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Aguarda Assinatura (rgpd Cvo)": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Closed": {
          "overall": {
            "avg_time_hours": 123.53,
            "mode_time_hours": 7.0,
            "mode_frequency": 207,
            "time_distribution": {
              "0-2h": 185,
              "2-4h": 196,
              "4-6h": 164,
              "6-8h": 207,
              "8-10h": 115,
              "10-12h": 13,
              "12-14h": 9,
              "14-16h": 17,
              "16-18h": 26,
              "18-20h": 41,
              "20-22h": 58,
              "22-24h": 41,
              "24-26h": 47,
              "26-28h": 38,
              "28-30h": 54,
              "30-32h": 51,
              "32-34h": 46,
              "34-36h": 12,
              "36-38h": 5,
              "38-40h": 7,
              "40-42h": 21,
              "42-44h": 26,
              "44-46h": 21,
              "46-48h": 18,
              "48-50h": 25,
              "50-52h": 25,
              "52-54h": 28,
              "54-56h": 39,
              "56-58h": 13,
              "58-60h": 4,
              "60-62h": 2,
              "62-64h": 5,
              "64-66h": 11,
              "66-68h": 28,
              "68-70h": 15,
              "70-72h": 20,
              "72-74h": 20,
              "74-76h": 9,
              "76-78h": 12,
              "78-80h": 21,
              "80-82h": 10,
              "82-84h": 4,
              "84-86h": 5,
              "86-88h": 4,
              "88-90h": 4,
              "90-92h": 5,
              "92-94h": 6,
              "94-96h": 13,
              "96-98h": 20,
              "98-100h": 12,
              "100-102h": 19,
              "102-104h": 11,
              "104-106h": 8,
              "106-108h": 4,
              "108-110h": 1,
              "110-112h": 1,
              "112-114h": 1,
              "114-116h": 3,
              "116-118h": 9,
              "118-120h": 8,
              "120-122h": 7,
              "122-124h": 4,
              "124-126h": 2,
              "126-128h": 7,
              "128-130h": 7,
              "130-132h": 2,
              "132-134h": 3,
              "134-136h": 6,
              "136-138h": 5,
              "138-140h": 7,
              "140-142h": 5,
              "142-144h": 7,
              "144-146h": 11,
              "146-148h": 3,
              "148-150h": 14,
              "150-152h": 3,
              "152-154h": 1,
              "154-156h": 1,
              "156-158h": 2,
              "158-160h": 3,
              "160-162h": 5,
              "162-164h": 3,
              "164-166h": 8,
              "166-168h": 8,
              "168-170h": 5,
              "170-172h": 5,
              "172-174h": 8,
              "176-178h": 3,
              "178-180h": 1,
              "180-182h": 2,
              "182-184h": 1,
              "184-186h": 3,
              "186-188h": 3,
              "188-190h": 6,
              "190-192h": 5,
              "192-194h": 6,
              "194-196h": 10,
              "196-198h": 2,
              "198-200h": 2,
              "200-202h": 1,
              "202-204h": 3,
              "204-206h": 4,
              "206-208h": 1,
              "208-210h": 1,
              "210-212h": 2,
              "214-216h": 3,
              "216-218h": 3,
              "218-220h": 11,
              "222-224h": 1,
              "226-228h": 3,
              "228-230h": 1,
              "234-236h": 1,
              "238-240h": 1,
              "240-242h": 2,
              "242-244h": 1,
              "244-246h": 1,
              "246-248h": 1,
              "248-250h": 2,
              "250-252h": 1,
              "254-256h": 2,
              "256-258h": 2,
              "260-262h": 2,
              "262-264h": 5,
              "268-270h": 4,
              "270-272h": 3,
              "272-274h": 3,
              "276-278h": 1,
              "278-280h": 1,
              "280-282h": 1,
              "282-284h": 2,
              "286-288h": 2,
              "288-290h": 2,
              "290-292h": 3,
              "292-294h": 4,
              "298-300h": 1,
              "300-302h": 1,
              "304-306h": 2,
              "306-308h": 3,
              "308-310h": 1,
              "312-314h": 4,
              "314-316h": 1,
              "316-318h": 2,
              "318-320h": 4,
              "324-326h": 4,
              "326-328h": 2,
              "328-330h": 1,
              "330-332h": 1,
              "332-334h": 1,
              "334-336h": 3,
              "336-338h": 2,
              "338-340h": 1,
              "340-342h": 4,
              "342-344h": 2,
              "344-346h": 2,
              "348-350h": 3,
              "352-354h": 2,
              "354-356h": 2,
              "356-358h": 1,
              "360-362h": 4,
              "362-364h": 1,
              "364-366h": 2,
              "366-368h": 4,
              "372-374h": 1,
              "376-378h": 1,
              "380-382h": 2,
              "384-386h": 1,
              "386-388h": 2,
              "388-390h": 1,
              "390-392h": 2,
              "398-400h": 1,
              "402-404h": 1,
              "406-408h": 2,
              "408-410h": 2,
              "410-412h": 1,
              "414-416h": 2,
              "416-418h": 1,
              "424-426h": 2,
              "426-428h": 1,
              "428-430h": 2,
              "430-432h": 3,
              "438-440h": 1,
              "444-446h": 1,
              "448-450h": 1,
              "450-452h": 1,
              "452-454h": 2,
              "460-462h": 1,
              "468-470h": 1,
              "472-474h": 1,
              "474-476h": 1,
              "488-490h": 1,
              "490-492h": 5,
              "492-494h": 1,
              "498-500h": 1,
              "502-504h": 2,
              "504-506h": 4,
              "506-508h": 2,
              "508-510h": 1,
              "512-514h": 2,
              "514-516h": 1,
              "520-522h": 1,
              "526-528h": 2,
              "528-530h": 3,
              "532-534h": 2,
              "534-536h": 1,
              "536-538h": 1,
              "538-540h": 1,
              "540-542h": 3,
              "542-544h": 1,
              "544-546h": 1,
              "548-550h": 1,
              "554-556h": 1,
              "564-566h": 1,
              "568-570h": 1,
              "570-572h": 1,
              "572-574h": 3,
              "574-576h": 1,
              "576-578h": 6,
              "580-582h": 2,
              "582-584h": 4,
              "596-598h": 1,
              "598-600h": 1,
              "616-618h": 2,
              "622-624h": 1,
              "628-630h": 1,
              "642-644h": 3,
              "644-646h": 1,
              "660-662h": 1,
              "662-664h": 1,
              "670-672h": 1,
              "672-674h": 1,
              "674-676h": 1,
              "682-684h": 1,
              "698-700h": 1,
              "704-706h": 1,
              "714-716h": 1,
              "718-720h": 1,
              "722-724h": 1,
              "724-726h": 1,
              "744-746h": 1,
              "746-748h": 1,
              "758-760h": 1,
              "760-762h": 1,
              "764-766h": 2,
              "768-770h": 1,
              "780-782h": 1,
              "794-796h": 1,
              "798-800h": 1,
              "816-818h": 1,
              "818-820h": 2,
              "824-826h": 1,
              "834-836h": 1,
              "836-838h": 1,
              "840-842h": 2,
              "842-844h": 1,
              "848-850h": 1,
              "866-868h": 1,
              "872-874h": 3,
              "882-884h": 1,
              "896-898h": 1,
              "902-904h": 1,
              "906-908h": 1,
              "916-918h": 1,
              "918-920h": 1,
              "924-926h": 1,
              "936-938h": 1,
              "938-940h": 1,
              "940-942h": 1,
              "952-954h": 1,
              "960-962h": 2,
              "976-978h": 1,
              "980-982h": 1,
              "984-986h": 3,
              "986-988h": 1,
              "992-994h": 1,
              "1002-1004h": 2,
              "1006-1008h": 1,
              "1010-1012h": 1,
              "1012-1014h": 1,
              "1028-1030h": 2,
              "1076-1078h": 1,
              "1086-1088h": 1,
              "1096-1098h": 2,
              "1098-1100h": 1,
              "1102-1104h": 2,
              "1104-1106h": 1,
              "1152-1154h": 1,
              "1176-1178h": 1,
              "1178-1180h": 1,
              "1190-1192h": 1,
              "1200-1202h": 1,
              "1202-1204h": 1,
              "1208-1210h": 1,
              "1236-1238h": 2,
              "1244-1246h": 1,
              "1256-1258h": 1,
              "1258-1260h": 1,
              "1268-1270h": 1,
              "1276-1278h": 1,
              "1326-1328h": 1,
              "1336-1338h": 1,
              "1338-1340h": 1,
              "1340-1342h": 1,
              "1376-1378h": 2,
              "1380-1382h": 1,
              "1390-1392h": 1,
              "1462-1464h": 1,
              "1486-1488h": 1,
              "1514-1516h": 1,
              "1548-1550h": 1,
              "1570-1572h": 1,
              "1636-1638h": 1,
              "1658-1660h": 1,
              "1660-1662h": 1,
              "1712-1714h": 1,
              "1718-1720h": 1,
              "1728-1730h": 1,
              "1762-1764h": 1,
              "1896-1898h": 1,
              "1906-1908h": 1,
              "2040-2042h": 1,
              "2152-2154h": 1,
              "2902-2904h": 1
            },
            "tickets_count": 2386,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-09": 2,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-22": 1,
              "2025-10-23": 8,
              "2025-10-24": 4,
              "2025-10-27": 14,
              "2025-10-28": 9,
              "2025-10-29": 5,
              "2025-10-30": 8,
              "2025-10-31": 29,
              "2025-11-03": 18,
              "2025-11-04": 26,
              "2025-11-05": 9,
              "2025-11-06": 14,
              "2025-11-07": 7,
              "2025-11-10": 22,
              "2025-11-11": 15,
              "2025-11-12": 8,
              "2025-11-13": 27,
              "2025-11-14": 11,
              "2025-11-17": 46,
              "2025-11-18": 11,
              "2025-11-19": 13,
              "2025-11-20": 8,
              "2025-11-21": 10,
              "2025-11-22": 18,
              "2025-11-24": 33,
              "2025-11-25": 8,
              "2025-11-26": 18,
              "2025-11-27": 26,
              "2025-11-28": 15,
              "2025-11-30": 5,
              "2025-12-02": 27,
              "2025-12-03": 12,
              "2025-12-04": 29,
              "2025-12-05": 18,
              "2025-12-09": 18,
              "2025-12-10": 11,
              "2025-12-11": 31,
              "2025-12-12": 16,
              "2025-12-13": 11,
              "2025-12-14": 13,
              "2025-12-15": 12,
              "2025-12-16": 1,
              "2025-12-17": 17,
              "2025-12-18": 23,
              "2025-12-19": 6,
              "2025-12-22": 14,
              "2025-12-23": 13,
              "2025-12-24": 2,
              "2025-12-26": 10,
              "2025-12-29": 14,
              "2025-12-30": 8,
              "2025-12-31": 1,
              "2026-01-05": 14,
              "2026-01-06": 16,
              "2026-01-07": 4,
              "2026-01-08": 12,
              "2026-01-09": 4,
              "2026-01-12": 8,
              "2026-01-13": 18,
              "2026-01-14": 36,
              "2026-01-15": 9,
              "2026-01-16": 14,
              "2026-01-19": 2,
              "2026-01-20": 29,
              "2026-01-21": 20,
              "2026-01-22": 8,
              "2026-01-23": 6,
              "2026-01-26": 9,
              "2026-01-27": 47,
              "2026-01-28": 2,
              "2026-01-29": 6,
              "2026-01-30": 13,
              "2026-02-02": 11,
              "2026-02-03": 16,
              "2026-02-04": 34,
              "2026-02-05": 7,
              "2026-02-06": 5,
              "2026-02-09": 14,
              "2026-02-10": 25,
              "2026-02-11": 3,
              "2026-02-12": 4,
              "2026-02-13": 8,
              "2026-02-16": 6,
              "2026-02-17": 6,
              "2026-02-18": 14,
              "2026-02-19": 9,
              "2026-02-20": 5,
              "2026-02-22": 2,
              "2026-02-23": 19,
              "2026-02-24": 9,
              "2026-02-25": 11,
              "2026-02-26": 4,
              "2026-02-27": 11,
              "2026-02-28": 3,
              "2026-03-02": 53,
              "2026-03-03": 11,
              "2026-03-04": 14,
              "2026-03-05": 21,
              "2026-03-06": 19,
              "2026-03-07": 3,
              "2026-03-09": 35,
              "2026-03-10": 11,
              "2026-03-11": 13,
              "2026-03-12": 18,
              "2026-03-13": 18,
              "2026-03-16": 31,
              "2026-03-17": 65,
              "2026-03-18": 13,
              "2026-03-19": 13,
              "2026-03-20": 34,
              "2026-03-23": 17,
              "2026-03-24": 17,
              "2026-03-25": 23,
              "2026-03-26": 6,
              "2026-03-27": 4,
              "2026-03-30": 11,
              "2026-03-31": 19,
              "2026-04-01": 11,
              "2026-04-02": 9,
              "2026-04-06": 21,
              "2026-04-07": 20,
              "2026-04-08": 9,
              "2026-04-09": 33,
              "2026-04-10": 35,
              "2026-04-13": 5,
              "2026-04-14": 6,
              "2026-04-15": 10,
              "2026-04-16": 12,
              "2026-04-17": 5,
              "2026-04-20": 12,
              "2026-04-21": 2,
              "2026-04-22": 15,
              "2026-04-23": 11,
              "2026-04-24": 5,
              "2026-04-26": 1,
              "2026-04-27": 19,
              "2026-04-28": 15,
              "2026-04-29": 4,
              "2026-04-30": 4,
              "2026-05-02": 2,
              "2026-05-04": 18,
              "2026-05-05": 44,
              "2026-05-06": 24,
              "2026-05-07": 1,
              "2026-05-08": 20,
              "2026-05-10": 4,
              "2026-05-11": 3,
              "2026-05-12": 17,
              "2026-05-13": 17,
              "2026-05-14": 5,
              "2026-05-15": 7,
              "2026-05-18": 20,
              "2026-05-19": 18,
              "2026-05-20": 4,
              "2026-05-21": 27,
              "2026-05-22": 30,
              "2026-05-25": 24,
              "2026-05-26": 11,
              "2026-05-27": 13,
              "2026-05-28": 6,
              "2026-05-29": 7,
              "2026-06-01": 17,
              "2026-06-02": 20,
              "2026-06-03": 15,
              "2026-06-05": 15,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-08": 53.6505225,
              "2025-10-09": 188.15949916666665,
              "2025-10-10": 40.36689472222222,
              "2025-10-13": 0.18714916666666664,
              "2025-10-14": 16.192532777777778,
              "2025-10-22": 0.08416194444444444,
              "2025-10-23": 1610.0926680555556,
              "2025-10-24": 14.662827499999999,
              "2025-10-27": 231.21287694444442,
              "2025-10-28": 540.9404644444445,
              "2025-10-29": 237.2767986111111,
              "2025-10-30": 215.47600361111114,
              "2025-10-31": 1918.9509924999995,
              "2025-11-03": 599.6555869444445,
              "2025-11-04": 1060.3222830555555,
              "2025-11-05": 332.19690583333335,
              "2025-11-06": 108.28947722222222,
              "2025-11-07": 121.45288388888889,
              "2025-11-10": 1627.3704755555555,
              "2025-11-11": 644.76857,
              "2025-11-12": 212.7945961111111,
              "2025-11-13": 889.3066358333334,
              "2025-11-14": 519.8885150000001,
              "2025-11-17": 3469.3928933333345,
              "2025-11-18": 515.1217733333333,
              "2025-11-19": 869.1700105555552,
              "2025-11-20": 585.0044227777779,
              "2025-11-21": 453.03002888888886,
              "2025-11-22": 1065.552337777778,
              "2025-11-24": 2766.542715277778,
              "2025-11-25": 797.4113311111113,
              "2025-11-26": 627.3927902777779,
              "2025-11-27": 493.1483258333332,
              "2025-11-28": 526.310815,
              "2025-11-30": 177.758895,
              "2025-12-02": 2242.576708611111,
              "2025-12-03": 88.29168194444443,
              "2025-12-04": 3394.2816341666676,
              "2025-12-05": 1211.0166341666666,
              "2025-12-09": 1018.5692899999998,
              "2025-12-10": 851.6378802777779,
              "2025-12-11": 3654.1125733333333,
              "2025-12-12": 1090.0607241666664,
              "2025-12-13": 2059.2225283333332,
              "2025-12-14": 680.2957594444445,
              "2025-12-15": 480.5557391666667,
              "2025-12-16": 54.9179925,
              "2025-12-17": 1260.6805427777779,
              "2025-12-18": 1488.1471722222223,
              "2025-12-19": 350.1024455555556,
              "2025-12-22": 448.4895747222222,
              "2025-12-23": 875.0064263888889,
              "2025-12-24": 699.1475755555556,
              "2025-12-26": 2001.6654786111114,
              "2025-12-29": 1310.5877105555555,
              "2025-12-30": 209.16750083333332,
              "2025-12-31": 52.349401944444445,
              "2026-01-05": 2597.772352777778,
              "2026-01-06": 2047.3653372222223,
              "2026-01-07": 120.73829805555557,
              "2026-01-08": 220.45242,
              "2026-01-09": 15.293095833333332,
              "2026-01-12": 220.0630886111111,
              "2026-01-13": 1963.091298888889,
              "2026-01-14": 2981.439555833333,
              "2026-01-15": 200.86274444444444,
              "2026-01-16": 2683.4993363888884,
              "2026-01-19": 44.83396166666667,
              "2026-01-20": 1218.0684827777777,
              "2026-01-21": 1398.4368580555551,
              "2026-01-22": 97.66266555555556,
              "2026-01-23": 169.1470841666667,
              "2026-01-26": 238.44543583333333,
              "2026-01-27": 3852.541328333333,
              "2026-01-28": 10.294375833333334,
              "2026-01-29": 642.9321083333333,
              "2026-01-30": 1418.543996388889,
              "2026-02-02": 308.3652822222222,
              "2026-02-03": 1057.0650491666665,
              "2026-02-04": 4530.639370833333,
              "2026-02-05": 60.01619416666666,
              "2026-02-06": 253.90716833333335,
              "2026-02-09": 377.53208777777775,
              "2026-02-10": 2748.70631361111,
              "2026-02-11": 10.634999444444444,
              "2026-02-12": 1914.9164047222218,
              "2026-02-13": 149.70655916666664,
              "2026-02-16": 476.84734194444445,
              "2026-02-17": 83.41856861111111,
              "2026-02-18": 828.7219394444445,
              "2026-02-19": 558.0402441666666,
              "2026-02-20": 769.8565116666667,
              "2026-02-22": 67.21825555555554,
              "2026-02-23": 292.27670972222217,
              "2026-02-24": 122.62486777777778,
              "2026-02-25": 1644.180453888889,
              "2026-02-26": 20.433703333333334,
              "2026-02-27": 213.65988444444437,
              "2026-02-28": 5.815738333333334,
              "2026-03-02": 2580.2105455555547,
              "2026-03-03": 465.24912638888895,
              "2026-03-04": 92.7259275,
              "2026-03-05": 3999.5181488888898,
              "2026-03-06": 7182.343670833333,
              "2026-03-07": 6.08331388888889,
              "2026-03-09": 639.2989583333334,
              "2026-03-10": 212.85803472222227,
              "2026-03-11": 2606.5405408333336,
              "2026-03-12": 1948.0417066666666,
              "2026-03-13": 1350.5440644444443,
              "2026-03-16": 1045.157576111111,
              "2026-03-17": 25147.036882777767,
              "2026-03-18": 2697.1507769444456,
              "2026-03-19": 1443.9747138888886,
              "2026-03-20": 14683.563386944445,
              "2026-03-23": 2008.694167777778,
              "2026-03-24": 10862.25883416667,
              "2026-03-25": 9452.48876666667,
              "2026-03-26": 420.61598833333335,
              "2026-03-27": 72.76069361111111,
              "2026-03-30": 954.0015655555559,
              "2026-03-31": 5154.069229444444,
              "2026-04-01": 2430.4885338888894,
              "2026-04-02": 262.2300997222222,
              "2026-04-06": 932.693468611111,
              "2026-04-07": 10370.807704722223,
              "2026-04-08": 344.1760736111111,
              "2026-04-09": 9534.828087777772,
              "2026-04-10": 28833.809921666663,
              "2026-04-13": 23.010235555555553,
              "2026-04-14": 177.55500777777775,
              "2026-04-15": 148.66482083333335,
              "2026-04-16": 2141.350355555556,
              "2026-04-17": 23.172380833333335,
              "2026-04-20": 481.06589111111106,
              "2026-04-21": 37.696800277777776,
              "2026-04-22": 437.121096111111,
              "2026-04-23": 3014.7638933333333,
              "2026-04-24": 189.56530722222223,
              "2026-04-26": 386.9462188888889,
              "2026-04-27": 370.0466219444443,
              "2026-04-28": 1550.016698888889,
              "2026-04-29": 146.20076333333333,
              "2026-04-30": 81.95733222222222,
              "2026-05-02": 348.5236488888889,
              "2026-05-04": 671.2849630555556,
              "2026-05-05": 12975.851252499999,
              "2026-05-06": 12753.942924166666,
              "2026-05-07": 2.6027802777777778,
              "2026-05-08": 7318.760912222222,
              "2026-05-10": 245.4068125,
              "2026-05-11": 62.70415944444444,
              "2026-05-12": 677.5803552777778,
              "2026-05-13": 351.7984105555557,
              "2026-05-14": 1237.5576455555556,
              "2026-05-15": 117.62110361111114,
              "2026-05-18": 1171.4110208333339,
              "2026-05-19": 450.28824194444445,
              "2026-05-20": 39.08823361111111,
              "2026-05-21": 2952.221484722223,
              "2026-05-22": 4426.018546388887,
              "2026-05-25": 979.5148155555556,
              "2026-05-26": 783.2881830555556,
              "2026-05-27": 250.78605055555553,
              "2026-05-28": 427.2425305555555,
              "2026-05-29": 114.11494972222224,
              "2026-06-01": 328.11429166666676,
              "2026-06-02": 498.65953666666667,
              "2026-06-03": 668.6195655555554,
              "2026-06-05": 262.2419883333333,
              "2026-06-08": 0.9049816666666667
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-09": 2,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-22": 1,
              "2025-10-23": 8,
              "2025-10-24": 4,
              "2025-10-27": 14,
              "2025-10-28": 9,
              "2025-10-29": 5,
              "2025-10-30": 8,
              "2025-10-31": 29,
              "2025-11-03": 18,
              "2025-11-04": 26,
              "2025-11-05": 9,
              "2025-11-06": 14,
              "2025-11-07": 7,
              "2025-11-10": 22,
              "2025-11-11": 15,
              "2025-11-12": 8,
              "2025-11-13": 27,
              "2025-11-14": 11,
              "2025-11-17": 46,
              "2025-11-18": 11,
              "2025-11-19": 13,
              "2025-11-20": 8,
              "2025-11-21": 10,
              "2025-11-22": 18,
              "2025-11-24": 33,
              "2025-11-25": 8,
              "2025-11-26": 18,
              "2025-11-27": 26,
              "2025-11-28": 15,
              "2025-11-30": 5,
              "2025-12-02": 27,
              "2025-12-03": 12,
              "2025-12-04": 29,
              "2025-12-05": 18,
              "2025-12-09": 18,
              "2025-12-10": 11,
              "2025-12-11": 31,
              "2025-12-12": 16,
              "2025-12-13": 11,
              "2025-12-14": 13,
              "2025-12-15": 12,
              "2025-12-16": 1,
              "2025-12-17": 17,
              "2025-12-18": 23,
              "2025-12-19": 6,
              "2025-12-22": 14,
              "2025-12-23": 13,
              "2025-12-24": 2,
              "2025-12-26": 10,
              "2025-12-29": 14,
              "2025-12-30": 8,
              "2025-12-31": 1,
              "2026-01-05": 14,
              "2026-01-06": 16,
              "2026-01-07": 4,
              "2026-01-08": 12,
              "2026-01-09": 4,
              "2026-01-12": 8,
              "2026-01-13": 18,
              "2026-01-14": 36,
              "2026-01-15": 9,
              "2026-01-16": 14,
              "2026-01-19": 2,
              "2026-01-20": 29,
              "2026-01-21": 20,
              "2026-01-22": 8,
              "2026-01-23": 6,
              "2026-01-26": 9,
              "2026-01-27": 47,
              "2026-01-28": 2,
              "2026-01-29": 6,
              "2026-01-30": 13,
              "2026-02-02": 11,
              "2026-02-03": 16,
              "2026-02-04": 34,
              "2026-02-05": 7,
              "2026-02-06": 5,
              "2026-02-09": 14,
              "2026-02-10": 25,
              "2026-02-11": 3,
              "2026-02-12": 4,
              "2026-02-13": 8,
              "2026-02-16": 6,
              "2026-02-17": 6,
              "2026-02-18": 14,
              "2026-02-19": 9,
              "2026-02-20": 5,
              "2026-02-22": 2,
              "2026-02-23": 19,
              "2026-02-24": 9,
              "2026-02-25": 11,
              "2026-02-26": 4,
              "2026-02-27": 11,
              "2026-02-28": 3,
              "2026-03-02": 53,
              "2026-03-03": 11,
              "2026-03-04": 14,
              "2026-03-05": 21,
              "2026-03-06": 19,
              "2026-03-07": 3,
              "2026-03-09": 35,
              "2026-03-10": 11,
              "2026-03-11": 13,
              "2026-03-12": 18,
              "2026-03-13": 18,
              "2026-03-16": 31,
              "2026-03-17": 65,
              "2026-03-18": 13,
              "2026-03-19": 13,
              "2026-03-20": 34,
              "2026-03-23": 17,
              "2026-03-24": 17,
              "2026-03-25": 23,
              "2026-03-26": 6,
              "2026-03-27": 4,
              "2026-03-30": 11,
              "2026-03-31": 19,
              "2026-04-01": 11,
              "2026-04-02": 9,
              "2026-04-06": 21,
              "2026-04-07": 20,
              "2026-04-08": 9,
              "2026-04-09": 33,
              "2026-04-10": 35,
              "2026-04-13": 5,
              "2026-04-14": 6,
              "2026-04-15": 10,
              "2026-04-16": 12,
              "2026-04-17": 5,
              "2026-04-20": 12,
              "2026-04-21": 2,
              "2026-04-22": 15,
              "2026-04-23": 11,
              "2026-04-24": 5,
              "2026-04-26": 1,
              "2026-04-27": 19,
              "2026-04-28": 15,
              "2026-04-29": 4,
              "2026-04-30": 4,
              "2026-05-02": 2,
              "2026-05-04": 18,
              "2026-05-05": 44,
              "2026-05-06": 24,
              "2026-05-07": 1,
              "2026-05-08": 20,
              "2026-05-10": 4,
              "2026-05-11": 3,
              "2026-05-12": 17,
              "2026-05-13": 17,
              "2026-05-14": 5,
              "2026-05-15": 7,
              "2026-05-18": 20,
              "2026-05-19": 18,
              "2026-05-20": 4,
              "2026-05-21": 27,
              "2026-05-22": 30,
              "2026-05-25": 24,
              "2026-05-26": 11,
              "2026-05-27": 13,
              "2026-05-28": 6,
              "2026-05-29": 7,
              "2026-06-01": 17,
              "2026-06-02": 20,
              "2026-06-03": 15,
              "2026-06-05": 15,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 48.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 92,
              "time_distribution": {
                "0-2h": 81,
                "2-4h": 92,
                "4-6h": 40,
                "6-8h": 65,
                "8-10h": 25,
                "10-12h": 4,
                "12-14h": 4,
                "14-16h": 1,
                "16-18h": 4,
                "18-20h": 5,
                "20-22h": 6,
                "22-24h": 8,
                "24-26h": 14,
                "26-28h": 4,
                "28-30h": 5,
                "30-32h": 6,
                "32-34h": 6,
                "38-40h": 2,
                "40-42h": 2,
                "42-44h": 2,
                "44-46h": 1,
                "46-48h": 1,
                "48-50h": 4,
                "52-54h": 6,
                "54-56h": 16,
                "56-58h": 2,
                "58-60h": 2,
                "62-64h": 1,
                "64-66h": 2,
                "66-68h": 5,
                "70-72h": 3,
                "72-74h": 3,
                "74-76h": 1,
                "78-80h": 4,
                "80-82h": 2,
                "82-84h": 1,
                "84-86h": 1,
                "86-88h": 2,
                "88-90h": 1,
                "94-96h": 3,
                "96-98h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "116-118h": 2,
                "122-124h": 2,
                "138-140h": 1,
                "140-142h": 1,
                "144-146h": 1,
                "146-148h": 1,
                "192-194h": 2,
                "194-196h": 3,
                "262-264h": 1,
                "280-282h": 1,
                "290-292h": 1,
                "312-314h": 1,
                "334-336h": 1,
                "336-338h": 1,
                "380-382h": 1,
                "402-404h": 1,
                "468-470h": 1,
                "580-582h": 1,
                "662-664h": 1,
                "670-672h": 1,
                "682-684h": 1,
                "760-762h": 1,
                "840-842h": 1,
                "896-898h": 1,
                "940-942h": 1,
                "1190-1192h": 1,
                "1200-1202h": 1,
                "2040-2042h": 1
              },
              "tickets_count": 474,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2025-10-29": 1,
                "2025-10-30": 3,
                "2025-10-31": 2,
                "2025-11-03": 4,
                "2025-11-04": 2,
                "2025-11-07": 1,
                "2025-11-10": 2,
                "2025-11-11": 6,
                "2025-11-13": 2,
                "2025-11-14": 2,
                "2025-11-18": 1,
                "2025-11-19": 2,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-11-26": 4,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-30": 2,
                "2025-12-02": 2,
                "2025-12-03": 7,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-15": 1,
                "2025-12-22": 4,
                "2026-01-05": 1,
                "2026-01-07": 1,
                "2026-01-09": 2,
                "2026-01-12": 3,
                "2026-01-13": 3,
                "2026-01-14": 4,
                "2026-01-15": 1,
                "2026-01-16": 5,
                "2026-01-20": 3,
                "2026-01-22": 3,
                "2026-01-23": 3,
                "2026-01-26": 3,
                "2026-01-27": 7,
                "2026-01-28": 2,
                "2026-01-29": 3,
                "2026-01-30": 11,
                "2026-02-02": 5,
                "2026-02-03": 2,
                "2026-02-04": 3,
                "2026-02-05": 5,
                "2026-02-06": 2,
                "2026-02-09": 6,
                "2026-02-10": 5,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-17": 3,
                "2026-02-18": 3,
                "2026-02-19": 2,
                "2026-02-20": 3,
                "2026-02-23": 3,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-02-26": 4,
                "2026-02-27": 5,
                "2026-02-28": 3,
                "2026-03-02": 19,
                "2026-03-03": 3,
                "2026-03-04": 9,
                "2026-03-05": 3,
                "2026-03-06": 2,
                "2026-03-07": 3,
                "2026-03-09": 23,
                "2026-03-10": 7,
                "2026-03-11": 3,
                "2026-03-12": 2,
                "2026-03-13": 10,
                "2026-03-16": 20,
                "2026-03-17": 3,
                "2026-03-18": 6,
                "2026-03-19": 4,
                "2026-03-20": 8,
                "2026-03-23": 6,
                "2026-03-24": 4,
                "2026-03-25": 3,
                "2026-03-26": 2,
                "2026-03-27": 3,
                "2026-03-30": 2,
                "2026-03-31": 6,
                "2026-04-01": 3,
                "2026-04-06": 9,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-14": 4,
                "2026-04-15": 4,
                "2026-04-16": 1,
                "2026-04-17": 5,
                "2026-04-20": 4,
                "2026-04-22": 4,
                "2026-04-27": 2,
                "2026-04-28": 6,
                "2026-04-29": 3,
                "2026-04-30": 2,
                "2026-05-04": 10,
                "2026-05-05": 4,
                "2026-05-06": 3,
                "2026-05-08": 1,
                "2026-05-10": 2,
                "2026-05-11": 2,
                "2026-05-12": 3,
                "2026-05-13": 6,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-19": 2,
                "2026-05-21": 4,
                "2026-05-22": 3,
                "2026-05-25": 10,
                "2026-05-26": 2,
                "2026-05-27": 1,
                "2026-05-28": 2,
                "2026-05-29": 2,
                "2026-06-01": 8,
                "2026-06-02": 10,
                "2026-06-03": 4,
                "2026-06-05": 6,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-10-27": 4.266186388888889,
                "2025-10-29": 1.4751697222222222,
                "2025-10-30": 45.37463916666667,
                "2025-10-31": 64.40059277777777,
                "2025-11-03": 21.390671666666666,
                "2025-11-04": 174.11333416666668,
                "2025-11-07": 7.910745277777778,
                "2025-11-10": 86.79111083333333,
                "2025-11-11": 227.35522000000003,
                "2025-11-13": 39.16493444444444,
                "2025-11-14": 3.901648611111111,
                "2025-11-18": 7.580475833333333,
                "2025-11-19": 6.509518333333333,
                "2025-11-20": 3.1897516666666665,
                "2025-11-21": 9.812267222222221,
                "2025-11-24": 7.606755555555556,
                "2025-11-26": 24.804433055555556,
                "2025-11-27": 37.838055277777784,
                "2025-11-28": 15.678542499999999,
                "2025-11-30": 4.148313611111111,
                "2025-12-02": 63.55810666666667,
                "2025-12-03": 22.446189999999998,
                "2025-12-04": 29.204210555555555,
                "2025-12-05": 23.87092722222222,
                "2025-12-09": 6.758991944444444,
                "2025-12-10": 1.3825533333333333,
                "2025-12-11": 42.29987,
                "2025-12-15": 65.72100472222222,
                "2025-12-22": 61.553256111111104,
                "2026-01-05": 44.82703305555555,
                "2026-01-07": 8.134878055555555,
                "2026-01-09": 10.136113333333332,
                "2026-01-12": 14.080266666666667,
                "2026-01-13": 33.00572416666667,
                "2026-01-14": 10.342204166666667,
                "2026-01-15": 9.21332,
                "2026-01-16": 24.544510555555554,
                "2026-01-20": 164.14758333333336,
                "2026-01-22": 10.2237525,
                "2026-01-23": 69.00714444444445,
                "2026-01-26": 91.47231444444444,
                "2026-01-27": 147.77962694444446,
                "2026-01-28": 10.294375833333334,
                "2026-01-29": 15.740139722222223,
                "2026-01-30": 1138.9646586111112,
                "2026-02-02": 234.83004972222224,
                "2026-02-03": 55.10911694444444,
                "2026-02-04": 72.61455277777777,
                "2026-02-05": 44.42697166666666,
                "2026-02-06": 16.81598972222222,
                "2026-02-09": 39.868235,
                "2026-02-10": 70.60843555555554,
                "2026-02-11": 1.2553952777777777,
                "2026-02-13": 8.310764166666667,
                "2026-02-17": 40.58201277777778,
                "2026-02-18": 56.3083525,
                "2026-02-19": 79.21968166666667,
                "2026-02-20": 695.4694036111111,
                "2026-02-23": 20.873534166666666,
                "2026-02-24": 20.912975000000003,
                "2026-02-25": 10.08637388888889,
                "2026-02-26": 20.433703333333334,
                "2026-02-27": 15.729041944444443,
                "2026-02-28": 5.815738333333334,
                "2026-03-02": 703.2436302777777,
                "2026-03-03": 105.5301888888889,
                "2026-03-04": 16.490043888888888,
                "2026-03-05": 29.155119166666665,
                "2026-03-06": 1.985176388888889,
                "2026-03-07": 6.08331388888889,
                "2026-03-09": 426.04346333333325,
                "2026-03-10": 56.223332222222226,
                "2026-03-11": 43.14777055555555,
                "2026-03-12": 23.174715277777782,
                "2026-03-13": 776.7137436111111,
                "2026-03-16": 989.9124913888888,
                "2026-03-17": 531.1706244444445,
                "2026-03-18": 882.6121138888888,
                "2026-03-19": 11.934978611111113,
                "2026-03-20": 1204.1814280555557,
                "2026-03-23": 118.68450750000001,
                "2026-03-24": 1239.3183952777777,
                "2026-03-25": 17.621339166666665,
                "2026-03-26": 17.94080138888889,
                "2026-03-27": 5.423542777777778,
                "2026-03-30": 4.803260833333333,
                "2026-03-31": 1277.7555691666669,
                "2026-04-01": 25.216595555555553,
                "2026-04-06": 181.8084536111111,
                "2026-04-07": 6.786682777777777,
                "2026-04-08": 7.549686111111111,
                "2026-04-09": 469.5782858333333,
                "2026-04-10": 1.4720302777777778,
                "2026-04-14": 27.456881111111112,
                "2026-04-15": 69.01355166666666,
                "2026-04-16": 897.6813783333333,
                "2026-04-17": 23.172380833333335,
                "2026-04-20": 165.05004416666668,
                "2026-04-22": 62.16802722222223,
                "2026-04-27": 17.505486666666666,
                "2026-04-28": 812.0874377777777,
                "2026-04-29": 126.85795388888887,
                "2026-04-30": 29.858301944444445,
                "2026-05-04": 466.70921583333336,
                "2026-05-05": 1042.8142372222221,
                "2026-05-06": 2086.8024352777775,
                "2026-05-08": 581.8848891666667,
                "2026-05-10": 99.32111305555556,
                "2026-05-11": 55.94242361111111,
                "2026-05-12": 123.56129527777777,
                "2026-05-13": 97.7608202777778,
                "2026-05-14": 662.2088486111111,
                "2026-05-15": 0.5954644444444445,
                "2026-05-18": 77.57906222222223,
                "2026-05-19": 304.5535447222222,
                "2026-05-21": 71.05450416666666,
                "2026-05-22": 19.474238333333332,
                "2026-05-25": 776.5722158333333,
                "2026-05-26": 94.35630194444444,
                "2026-05-27": 7.520459166666666,
                "2026-05-28": 8.2220225,
                "2026-05-29": 6.249756111111111,
                "2026-06-01": 85.97413722222223,
                "2026-06-02": 290.47956555555555,
                "2026-06-03": 66.74636444444445,
                "2026-06-05": 56.663225,
                "2026-06-08": 0.9049816666666667
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2025-10-29": 1,
                "2025-10-30": 3,
                "2025-10-31": 2,
                "2025-11-03": 4,
                "2025-11-04": 2,
                "2025-11-07": 1,
                "2025-11-10": 2,
                "2025-11-11": 6,
                "2025-11-13": 2,
                "2025-11-14": 2,
                "2025-11-18": 1,
                "2025-11-19": 2,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-11-26": 4,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-30": 2,
                "2025-12-02": 2,
                "2025-12-03": 7,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-15": 1,
                "2025-12-22": 4,
                "2026-01-05": 1,
                "2026-01-07": 1,
                "2026-01-09": 2,
                "2026-01-12": 3,
                "2026-01-13": 3,
                "2026-01-14": 4,
                "2026-01-15": 1,
                "2026-01-16": 5,
                "2026-01-20": 3,
                "2026-01-22": 3,
                "2026-01-23": 3,
                "2026-01-26": 3,
                "2026-01-27": 7,
                "2026-01-28": 2,
                "2026-01-29": 3,
                "2026-01-30": 11,
                "2026-02-02": 5,
                "2026-02-03": 2,
                "2026-02-04": 3,
                "2026-02-05": 5,
                "2026-02-06": 2,
                "2026-02-09": 6,
                "2026-02-10": 5,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-17": 3,
                "2026-02-18": 3,
                "2026-02-19": 2,
                "2026-02-20": 3,
                "2026-02-23": 3,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-02-26": 4,
                "2026-02-27": 5,
                "2026-02-28": 3,
                "2026-03-02": 19,
                "2026-03-03": 3,
                "2026-03-04": 9,
                "2026-03-05": 3,
                "2026-03-06": 2,
                "2026-03-07": 3,
                "2026-03-09": 23,
                "2026-03-10": 7,
                "2026-03-11": 3,
                "2026-03-12": 2,
                "2026-03-13": 10,
                "2026-03-16": 20,
                "2026-03-17": 3,
                "2026-03-18": 6,
                "2026-03-19": 4,
                "2026-03-20": 8,
                "2026-03-23": 6,
                "2026-03-24": 4,
                "2026-03-25": 3,
                "2026-03-26": 2,
                "2026-03-27": 3,
                "2026-03-30": 2,
                "2026-03-31": 6,
                "2026-04-01": 3,
                "2026-04-06": 9,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-14": 4,
                "2026-04-15": 4,
                "2026-04-16": 1,
                "2026-04-17": 5,
                "2026-04-20": 4,
                "2026-04-22": 4,
                "2026-04-27": 2,
                "2026-04-28": 6,
                "2026-04-29": 3,
                "2026-04-30": 2,
                "2026-05-04": 10,
                "2026-05-05": 4,
                "2026-05-06": 3,
                "2026-05-08": 1,
                "2026-05-10": 2,
                "2026-05-11": 2,
                "2026-05-12": 3,
                "2026-05-13": 6,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-19": 2,
                "2026-05-21": 4,
                "2026-05-22": 3,
                "2026-05-25": 10,
                "2026-05-26": 2,
                "2026-05-27": 1,
                "2026-05-28": 2,
                "2026-05-29": 2,
                "2026-06-01": 8,
                "2026-06-02": 10,
                "2026-06-03": 4,
                "2026-06-05": 6,
                "2026-06-08": 2
              }
            },
            "P2": {
              "avg_time_hours": 132.3,
              "mode_time_hours": 7.0,
              "mode_frequency": 119,
              "time_distribution": {
                "0-2h": 80,
                "2-4h": 74,
                "4-6h": 104,
                "6-8h": 119,
                "8-10h": 60,
                "10-12h": 8,
                "12-14h": 5,
                "14-16h": 13,
                "16-18h": 17,
                "18-20h": 35,
                "20-22h": 42,
                "22-24h": 27,
                "24-26h": 26,
                "26-28h": 20,
                "28-30h": 43,
                "30-32h": 37,
                "32-34h": 23,
                "34-36h": 11,
                "36-38h": 5,
                "38-40h": 4,
                "40-42h": 18,
                "42-44h": 18,
                "44-46h": 14,
                "46-48h": 12,
                "48-50h": 11,
                "50-52h": 17,
                "52-54h": 18,
                "54-56h": 15,
                "56-58h": 10,
                "58-60h": 2,
                "60-62h": 2,
                "62-64h": 3,
                "64-66h": 8,
                "66-68h": 21,
                "68-70h": 13,
                "70-72h": 10,
                "72-74h": 14,
                "74-76h": 5,
                "76-78h": 10,
                "78-80h": 15,
                "80-82h": 4,
                "82-84h": 3,
                "84-86h": 3,
                "86-88h": 1,
                "88-90h": 2,
                "90-92h": 4,
                "92-94h": 6,
                "94-96h": 7,
                "96-98h": 11,
                "98-100h": 3,
                "100-102h": 4,
                "102-104h": 5,
                "104-106h": 7,
                "106-108h": 3,
                "112-114h": 1,
                "114-116h": 3,
                "116-118h": 7,
                "118-120h": 4,
                "120-122h": 5,
                "122-124h": 1,
                "126-128h": 4,
                "128-130h": 1,
                "130-132h": 2,
                "132-134h": 3,
                "134-136h": 5,
                "136-138h": 3,
                "138-140h": 6,
                "140-142h": 3,
                "142-144h": 6,
                "144-146h": 7,
                "146-148h": 2,
                "148-150h": 1,
                "150-152h": 1,
                "154-156h": 1,
                "156-158h": 2,
                "158-160h": 2,
                "160-162h": 4,
                "162-164h": 3,
                "164-166h": 4,
                "166-168h": 7,
                "168-170h": 4,
                "170-172h": 3,
                "172-174h": 6,
                "176-178h": 1,
                "178-180h": 1,
                "180-182h": 2,
                "184-186h": 2,
                "186-188h": 2,
                "188-190h": 4,
                "190-192h": 2,
                "192-194h": 2,
                "194-196h": 5,
                "196-198h": 1,
                "198-200h": 1,
                "202-204h": 3,
                "204-206h": 4,
                "206-208h": 1,
                "208-210h": 1,
                "210-212h": 2,
                "214-216h": 3,
                "216-218h": 3,
                "218-220h": 11,
                "226-228h": 3,
                "234-236h": 1,
                "238-240h": 1,
                "240-242h": 2,
                "242-244h": 1,
                "246-248h": 1,
                "248-250h": 1,
                "254-256h": 2,
                "256-258h": 2,
                "260-262h": 1,
                "262-264h": 2,
                "268-270h": 1,
                "270-272h": 2,
                "278-280h": 1,
                "282-284h": 2,
                "286-288h": 2,
                "288-290h": 2,
                "290-292h": 2,
                "292-294h": 4,
                "298-300h": 1,
                "300-302h": 1,
                "304-306h": 2,
                "306-308h": 3,
                "308-310h": 1,
                "312-314h": 1,
                "314-316h": 1,
                "316-318h": 2,
                "318-320h": 3,
                "324-326h": 4,
                "326-328h": 2,
                "328-330h": 1,
                "330-332h": 1,
                "332-334h": 1,
                "334-336h": 2,
                "336-338h": 1,
                "340-342h": 4,
                "342-344h": 2,
                "344-346h": 1,
                "348-350h": 3,
                "352-354h": 2,
                "354-356h": 2,
                "360-362h": 3,
                "362-364h": 1,
                "364-366h": 2,
                "366-368h": 4,
                "376-378h": 1,
                "380-382h": 1,
                "384-386h": 1,
                "386-388h": 2,
                "388-390h": 1,
                "390-392h": 2,
                "398-400h": 1,
                "406-408h": 1,
                "408-410h": 2,
                "410-412h": 1,
                "414-416h": 2,
                "416-418h": 1,
                "424-426h": 2,
                "426-428h": 1,
                "428-430h": 2,
                "430-432h": 3,
                "438-440h": 1,
                "444-446h": 1,
                "448-450h": 1,
                "460-462h": 1,
                "472-474h": 1,
                "474-476h": 1,
                "488-490h": 1,
                "490-492h": 5,
                "492-494h": 1,
                "498-500h": 1,
                "502-504h": 2,
                "504-506h": 2,
                "506-508h": 2,
                "508-510h": 1,
                "512-514h": 2,
                "514-516h": 1,
                "520-522h": 1,
                "526-528h": 2,
                "528-530h": 1,
                "532-534h": 2,
                "534-536h": 1,
                "536-538h": 1,
                "538-540h": 1,
                "540-542h": 3,
                "542-544h": 1,
                "544-546h": 1,
                "548-550h": 1,
                "554-556h": 1,
                "564-566h": 1,
                "568-570h": 1,
                "570-572h": 1,
                "572-574h": 2,
                "574-576h": 1,
                "576-578h": 1,
                "580-582h": 1,
                "582-584h": 4,
                "596-598h": 1,
                "616-618h": 2,
                "622-624h": 1,
                "628-630h": 1,
                "642-644h": 3,
                "644-646h": 1,
                "660-662h": 1,
                "672-674h": 1,
                "674-676h": 1,
                "698-700h": 1,
                "704-706h": 1,
                "718-720h": 1,
                "724-726h": 1,
                "744-746h": 1,
                "746-748h": 1,
                "758-760h": 1,
                "764-766h": 2,
                "780-782h": 1,
                "794-796h": 1,
                "798-800h": 1,
                "818-820h": 2,
                "836-838h": 1,
                "840-842h": 1,
                "842-844h": 1,
                "848-850h": 1,
                "866-868h": 1,
                "872-874h": 1,
                "902-904h": 1,
                "916-918h": 1,
                "918-920h": 1,
                "924-926h": 1,
                "936-938h": 1,
                "938-940h": 1,
                "980-982h": 1,
                "984-986h": 1,
                "986-988h": 1,
                "992-994h": 1,
                "1002-1004h": 2,
                "1010-1012h": 1,
                "1028-1030h": 2,
                "1076-1078h": 1,
                "1086-1088h": 1,
                "1096-1098h": 1,
                "1098-1100h": 1,
                "1102-1104h": 1,
                "1152-1154h": 1,
                "1208-1210h": 1,
                "1236-1238h": 2,
                "1244-1246h": 1,
                "1256-1258h": 1,
                "1258-1260h": 1,
                "1268-1270h": 1,
                "1276-1278h": 1,
                "1336-1338h": 1,
                "1340-1342h": 1,
                "1462-1464h": 1,
                "1486-1488h": 1,
                "1548-1550h": 1,
                "1636-1638h": 1,
                "1660-1662h": 1,
                "1712-1714h": 1,
                "1762-1764h": 1,
                "1896-1898h": 1,
                "1906-1908h": 1
              },
              "tickets_count": 1436,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-09": 2,
                "2025-10-10": 1,
                "2025-10-14": 1,
                "2025-10-22": 1,
                "2025-10-23": 6,
                "2025-10-24": 4,
                "2025-10-27": 13,
                "2025-10-28": 9,
                "2025-10-29": 4,
                "2025-10-30": 5,
                "2025-10-31": 27,
                "2025-11-03": 14,
                "2025-11-04": 22,
                "2025-11-05": 8,
                "2025-11-06": 14,
                "2025-11-07": 6,
                "2025-11-10": 16,
                "2025-11-11": 9,
                "2025-11-12": 5,
                "2025-11-13": 11,
                "2025-11-14": 7,
                "2025-11-17": 25,
                "2025-11-18": 5,
                "2025-11-19": 6,
                "2025-11-20": 4,
                "2025-11-21": 6,
                "2025-11-22": 5,
                "2025-11-24": 12,
                "2025-11-25": 3,
                "2025-11-26": 7,
                "2025-11-27": 16,
                "2025-11-28": 6,
                "2025-11-30": 1,
                "2025-12-02": 13,
                "2025-12-03": 4,
                "2025-12-04": 16,
                "2025-12-05": 9,
                "2025-12-09": 12,
                "2025-12-10": 3,
                "2025-12-11": 14,
                "2025-12-12": 7,
                "2025-12-13": 6,
                "2025-12-14": 5,
                "2025-12-15": 6,
                "2025-12-16": 1,
                "2025-12-17": 12,
                "2025-12-18": 14,
                "2025-12-19": 1,
                "2025-12-22": 8,
                "2025-12-23": 9,
                "2025-12-26": 3,
                "2025-12-29": 10,
                "2025-12-30": 5,
                "2026-01-05": 12,
                "2026-01-06": 14,
                "2026-01-07": 1,
                "2026-01-08": 9,
                "2026-01-09": 2,
                "2026-01-12": 3,
                "2026-01-13": 7,
                "2026-01-14": 12,
                "2026-01-15": 6,
                "2026-01-16": 5,
                "2026-01-19": 1,
                "2026-01-20": 25,
                "2026-01-21": 12,
                "2026-01-22": 5,
                "2026-01-23": 3,
                "2026-01-26": 5,
                "2026-01-27": 12,
                "2026-01-29": 2,
                "2026-02-03": 7,
                "2026-02-04": 8,
                "2026-02-06": 1,
                "2026-02-09": 2,
                "2026-02-10": 14,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-16": 2,
                "2026-02-17": 3,
                "2026-02-18": 9,
                "2026-02-19": 7,
                "2026-02-20": 2,
                "2026-02-22": 2,
                "2026-02-23": 16,
                "2026-02-24": 8,
                "2026-02-25": 9,
                "2026-02-27": 6,
                "2026-03-02": 33,
                "2026-03-03": 8,
                "2026-03-04": 5,
                "2026-03-05": 13,
                "2026-03-06": 10,
                "2026-03-09": 12,
                "2026-03-10": 4,
                "2026-03-11": 9,
                "2026-03-12": 16,
                "2026-03-13": 8,
                "2026-03-16": 10,
                "2026-03-17": 46,
                "2026-03-18": 4,
                "2026-03-19": 9,
                "2026-03-20": 22,
                "2026-03-23": 11,
                "2026-03-24": 10,
                "2026-03-25": 14,
                "2026-03-26": 4,
                "2026-03-27": 1,
                "2026-03-30": 9,
                "2026-03-31": 11,
                "2026-04-01": 6,
                "2026-04-02": 9,
                "2026-04-06": 10,
                "2026-04-07": 18,
                "2026-04-08": 7,
                "2026-04-09": 30,
                "2026-04-10": 30,
                "2026-04-13": 4,
                "2026-04-14": 2,
                "2026-04-15": 6,
                "2026-04-16": 10,
                "2026-04-20": 8,
                "2026-04-21": 2,
                "2026-04-22": 11,
                "2026-04-23": 11,
                "2026-04-24": 5,
                "2026-04-26": 1,
                "2026-04-27": 17,
                "2026-04-28": 9,
                "2026-04-29": 1,
                "2026-04-30": 2,
                "2026-05-02": 2,
                "2026-05-04": 8,
                "2026-05-05": 40,
                "2026-05-06": 19,
                "2026-05-08": 19,
                "2026-05-10": 1,
                "2026-05-11": 1,
                "2026-05-12": 14,
                "2026-05-13": 10,
                "2026-05-14": 4,
                "2026-05-15": 6,
                "2026-05-18": 17,
                "2026-05-19": 16,
                "2026-05-20": 4,
                "2026-05-21": 23,
                "2026-05-22": 27,
                "2026-05-25": 13,
                "2026-05-26": 9,
                "2026-05-27": 12,
                "2026-05-28": 4,
                "2026-05-29": 5,
                "2026-06-01": 9,
                "2026-06-02": 10,
                "2026-06-03": 11,
                "2026-06-05": 9
              },
              "time_per_day": {
                "2025-10-08": 53.6505225,
                "2025-10-09": 188.15949916666665,
                "2025-10-10": 40.36689472222222,
                "2025-10-14": 16.192532777777778,
                "2025-10-22": 0.08416194444444444,
                "2025-10-23": 1045.1798805555554,
                "2025-10-24": 14.662827499999999,
                "2025-10-27": 226.94669055555553,
                "2025-10-28": 540.9404644444445,
                "2025-10-29": 235.80162888888887,
                "2025-10-30": 170.10136444444444,
                "2025-10-31": 1854.5503997222218,
                "2025-11-03": 578.2649152777777,
                "2025-11-04": 875.943601111111,
                "2025-11-05": 323.69166944444447,
                "2025-11-06": 108.28947722222222,
                "2025-11-07": 113.54213861111111,
                "2025-11-10": 922.6149780555556,
                "2025-11-11": 417.41335000000004,
                "2025-11-12": 182.8506036111111,
                "2025-11-13": 582.0089855555556,
                "2025-11-14": 245.0140366666667,
                "2025-11-17": 1496.247501111111,
                "2025-11-18": 378.76126166666666,
                "2025-11-19": 820.5727922222221,
                "2025-11-20": 407.72470166666665,
                "2025-11-21": 320.3204161111111,
                "2025-11-22": 127.91303833333333,
                "2025-11-24": 1115.1203013888887,
                "2025-11-25": 381.78816111111115,
                "2025-11-26": 272.7637838888889,
                "2025-11-27": 374.7098313888888,
                "2025-11-28": 363.69742583333334,
                "2025-11-30": 85.22440611111112,
                "2025-12-02": 1317.7487683333334,
                "2025-12-03": 65.69918472222221,
                "2025-12-04": 1223.629413611111,
                "2025-12-05": 807.7307172222222,
                "2025-12-09": 696.9724883333332,
                "2025-12-10": 212.7347216666667,
                "2025-12-11": 1082.2327138888888,
                "2025-12-12": 923.2113405555555,
                "2025-12-13": 709.632901111111,
                "2025-12-14": 281.1087452777778,
                "2025-12-15": 228.19703527777781,
                "2025-12-16": 54.9179925,
                "2025-12-17": 1051.1956091666666,
                "2025-12-18": 812.4414897222222,
                "2025-12-19": 2.3543997222222224,
                "2025-12-22": 132.51905916666666,
                "2025-12-23": 546.3407566666668,
                "2025-12-26": 306.74757305555556,
                "2025-12-29": 961.4728138888889,
                "2025-12-30": 65.0279075,
                "2026-01-05": 2146.2941636111113,
                "2026-01-06": 2019.5292205555556,
                "2026-01-07": 48.47889916666667,
                "2026-01-08": 163.47828861111114,
                "2026-01-09": 5.1569825,
                "2026-01-12": 189.99320999999998,
                "2026-01-13": 1627.0131205555556,
                "2026-01-14": 457.4604258333334,
                "2026-01-15": 78.39655749999999,
                "2026-01-16": 868.9925344444443,
                "2026-01-19": 35.78324111111111,
                "2026-01-20": 998.2762674999999,
                "2026-01-21": 822.7086736111114,
                "2026-01-22": 87.43891305555556,
                "2026-01-23": 100.13993972222222,
                "2026-01-26": 139.67612194444447,
                "2026-01-27": 361.6590080555556,
                "2026-01-29": 577.3166808333333,
                "2026-02-03": 508.9731833333334,
                "2026-02-04": 2144.3680397222224,
                "2026-02-06": 4.203928055555555,
                "2026-02-09": 125.24296833333332,
                "2026-02-10": 2522.90641361111,
                "2026-02-12": 1763.7845513888888,
                "2026-02-13": 41.839655,
                "2026-02-16": 70.24742083333334,
                "2026-02-17": 42.836555833333335,
                "2026-02-18": 283.2835872222223,
                "2026-02-19": 478.8205625,
                "2026-02-20": 74.38710805555556,
                "2026-02-22": 67.21825555555554,
                "2026-02-23": 271.4031755555555,
                "2026-02-24": 101.71189277777778,
                "2026-02-25": 1322.0919747222224,
                "2026-02-27": 197.93084249999995,
                "2026-03-02": 1876.206384166666,
                "2026-03-03": 359.71893750000004,
                "2026-03-04": 76.23588361111112,
                "2026-03-05": 1082.366075,
                "2026-03-06": 2677.9491216666665,
                "2026-03-09": 213.255495,
                "2026-03-10": 156.6347025,
                "2026-03-11": 1602.2422097222222,
                "2026-03-12": 1924.866991388889,
                "2026-03-13": 573.8303208333334,
                "2026-03-16": 51.88583916666666,
                "2026-03-17": 17804.92433777778,
                "2026-03-18": 1742.348747222222,
                "2026-03-19": 1432.0397352777775,
                "2026-03-20": 11210.810481944443,
                "2026-03-23": 1890.009660277778,
                "2026-03-24": 5986.971108888889,
                "2026-03-25": 3566.8754841666673,
                "2026-03-26": 402.6751869444445,
                "2026-03-27": 67.33715083333333,
                "2026-03-30": 949.1983047222225,
                "2026-03-31": 1441.0339513888891,
                "2026-04-01": 1195.8835561111111,
                "2026-04-02": 262.2300997222222,
                "2026-04-06": 451.2522230555555,
                "2026-04-07": 10364.021021944447,
                "2026-04-08": 136.9819097222222,
                "2026-04-09": 6311.977522777775,
                "2026-04-10": 22503.238151111105,
                "2026-04-13": 18.580959722222218,
                "2026-04-14": 150.09812666666664,
                "2026-04-15": 79.65126916666668,
                "2026-04-16": 1239.6362505555555,
                "2026-04-20": 316.0158469444444,
                "2026-04-21": 37.696800277777776,
                "2026-04-22": 374.9530688888888,
                "2026-04-23": 3014.7638933333333,
                "2026-04-24": 189.56530722222223,
                "2026-04-26": 386.9462188888889,
                "2026-04-27": 352.5411352777777,
                "2026-04-28": 737.929261111111,
                "2026-04-29": 19.342809444444445,
                "2026-04-30": 52.09903027777778,
                "2026-05-02": 348.5236488888889,
                "2026-05-04": 204.57574722222225,
                "2026-05-05": 11933.037015277776,
                "2026-05-06": 5611.508093055557,
                "2026-05-08": 6736.876023055556,
                "2026-05-10": 72.01353027777778,
                "2026-05-11": 6.761735833333333,
                "2026-05-12": 554.0190600000001,
                "2026-05-13": 207.65320499999999,
                "2026-05-14": 575.3487969444444,
                "2026-05-15": 117.02563916666669,
                "2026-05-18": 831.5761902777776,
                "2026-05-19": 145.73469722222222,
                "2026-05-20": 39.08823361111111,
                "2026-05-21": 2881.1669805555566,
                "2026-05-22": 4406.544308055555,
                "2026-05-25": 197.6318963888889,
                "2026-05-26": 688.9318811111111,
                "2026-05-27": 243.26559138888888,
                "2026-05-28": 419.0205080555555,
                "2026-05-29": 107.86519361111112,
                "2026-06-01": 242.14015444444448,
                "2026-06-02": 208.17997111111112,
                "2026-06-03": 601.873201111111,
                "2026-06-05": 205.57876333333328
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-09": 2,
                "2025-10-10": 1,
                "2025-10-14": 1,
                "2025-10-22": 1,
                "2025-10-23": 6,
                "2025-10-24": 4,
                "2025-10-27": 13,
                "2025-10-28": 9,
                "2025-10-29": 4,
                "2025-10-30": 5,
                "2025-10-31": 27,
                "2025-11-03": 14,
                "2025-11-04": 22,
                "2025-11-05": 8,
                "2025-11-06": 14,
                "2025-11-07": 6,
                "2025-11-10": 16,
                "2025-11-11": 9,
                "2025-11-12": 5,
                "2025-11-13": 11,
                "2025-11-14": 7,
                "2025-11-17": 25,
                "2025-11-18": 5,
                "2025-11-19": 6,
                "2025-11-20": 4,
                "2025-11-21": 6,
                "2025-11-22": 5,
                "2025-11-24": 12,
                "2025-11-25": 3,
                "2025-11-26": 7,
                "2025-11-27": 16,
                "2025-11-28": 6,
                "2025-11-30": 1,
                "2025-12-02": 13,
                "2025-12-03": 4,
                "2025-12-04": 16,
                "2025-12-05": 9,
                "2025-12-09": 12,
                "2025-12-10": 3,
                "2025-12-11": 14,
                "2025-12-12": 7,
                "2025-12-13": 6,
                "2025-12-14": 5,
                "2025-12-15": 6,
                "2025-12-16": 1,
                "2025-12-17": 12,
                "2025-12-18": 14,
                "2025-12-19": 1,
                "2025-12-22": 8,
                "2025-12-23": 9,
                "2025-12-26": 3,
                "2025-12-29": 10,
                "2025-12-30": 5,
                "2026-01-05": 12,
                "2026-01-06": 14,
                "2026-01-07": 1,
                "2026-01-08": 9,
                "2026-01-09": 2,
                "2026-01-12": 3,
                "2026-01-13": 7,
                "2026-01-14": 12,
                "2026-01-15": 6,
                "2026-01-16": 5,
                "2026-01-19": 1,
                "2026-01-20": 25,
                "2026-01-21": 12,
                "2026-01-22": 5,
                "2026-01-23": 3,
                "2026-01-26": 5,
                "2026-01-27": 12,
                "2026-01-29": 2,
                "2026-02-03": 7,
                "2026-02-04": 8,
                "2026-02-06": 1,
                "2026-02-09": 2,
                "2026-02-10": 14,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-16": 2,
                "2026-02-17": 3,
                "2026-02-18": 9,
                "2026-02-19": 7,
                "2026-02-20": 2,
                "2026-02-22": 2,
                "2026-02-23": 16,
                "2026-02-24": 8,
                "2026-02-25": 9,
                "2026-02-27": 6,
                "2026-03-02": 33,
                "2026-03-03": 8,
                "2026-03-04": 5,
                "2026-03-05": 13,
                "2026-03-06": 10,
                "2026-03-09": 12,
                "2026-03-10": 4,
                "2026-03-11": 9,
                "2026-03-12": 16,
                "2026-03-13": 8,
                "2026-03-16": 10,
                "2026-03-17": 46,
                "2026-03-18": 4,
                "2026-03-19": 9,
                "2026-03-20": 22,
                "2026-03-23": 11,
                "2026-03-24": 10,
                "2026-03-25": 14,
                "2026-03-26": 4,
                "2026-03-27": 1,
                "2026-03-30": 9,
                "2026-03-31": 11,
                "2026-04-01": 6,
                "2026-04-02": 9,
                "2026-04-06": 10,
                "2026-04-07": 18,
                "2026-04-08": 7,
                "2026-04-09": 30,
                "2026-04-10": 30,
                "2026-04-13": 4,
                "2026-04-14": 2,
                "2026-04-15": 6,
                "2026-04-16": 10,
                "2026-04-20": 8,
                "2026-04-21": 2,
                "2026-04-22": 11,
                "2026-04-23": 11,
                "2026-04-24": 5,
                "2026-04-26": 1,
                "2026-04-27": 17,
                "2026-04-28": 9,
                "2026-04-29": 1,
                "2026-04-30": 2,
                "2026-05-02": 2,
                "2026-05-04": 8,
                "2026-05-05": 40,
                "2026-05-06": 19,
                "2026-05-08": 19,
                "2026-05-10": 1,
                "2026-05-11": 1,
                "2026-05-12": 14,
                "2026-05-13": 10,
                "2026-05-14": 4,
                "2026-05-15": 6,
                "2026-05-18": 17,
                "2026-05-19": 16,
                "2026-05-20": 4,
                "2026-05-21": 23,
                "2026-05-22": 27,
                "2026-05-25": 13,
                "2026-05-26": 9,
                "2026-05-27": 12,
                "2026-05-28": 4,
                "2026-05-29": 5,
                "2026-06-01": 9,
                "2026-06-02": 10,
                "2026-06-03": 11,
                "2026-06-05": 9
              }
            },
            "P3": {
              "avg_time_hours": 173.46,
              "mode_time_hours": 9.0,
              "mode_frequency": 29,
              "time_distribution": {
                "0-2h": 23,
                "2-4h": 29,
                "4-6h": 20,
                "6-8h": 23,
                "8-10h": 29,
                "10-12h": 1,
                "14-16h": 3,
                "16-18h": 5,
                "18-20h": 1,
                "20-22h": 10,
                "22-24h": 6,
                "24-26h": 7,
                "26-28h": 14,
                "28-30h": 6,
                "30-32h": 8,
                "32-34h": 17,
                "34-36h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "42-44h": 6,
                "44-46h": 5,
                "46-48h": 5,
                "48-50h": 10,
                "50-52h": 8,
                "52-54h": 4,
                "54-56h": 8,
                "56-58h": 1,
                "62-64h": 1,
                "64-66h": 1,
                "66-68h": 2,
                "68-70h": 2,
                "70-72h": 7,
                "72-74h": 3,
                "74-76h": 3,
                "76-78h": 2,
                "78-80h": 2,
                "80-82h": 4,
                "84-86h": 1,
                "88-90h": 1,
                "90-92h": 1,
                "94-96h": 3,
                "96-98h": 8,
                "98-100h": 8,
                "100-102h": 14,
                "102-104h": 5,
                "104-106h": 1,
                "106-108h": 1,
                "108-110h": 1,
                "110-112h": 1,
                "118-120h": 4,
                "120-122h": 2,
                "122-124h": 1,
                "124-126h": 2,
                "126-128h": 3,
                "128-130h": 6,
                "134-136h": 1,
                "136-138h": 2,
                "140-142h": 1,
                "142-144h": 1,
                "144-146h": 3,
                "148-150h": 13,
                "150-152h": 2,
                "152-154h": 1,
                "158-160h": 1,
                "160-162h": 1,
                "164-166h": 4,
                "166-168h": 1,
                "168-170h": 1,
                "170-172h": 2,
                "172-174h": 2,
                "176-178h": 2,
                "182-184h": 1,
                "184-186h": 1,
                "186-188h": 1,
                "188-190h": 2,
                "190-192h": 3,
                "192-194h": 2,
                "194-196h": 2,
                "196-198h": 1,
                "198-200h": 1,
                "200-202h": 1,
                "222-224h": 1,
                "228-230h": 1,
                "244-246h": 1,
                "248-250h": 1,
                "250-252h": 1,
                "260-262h": 1,
                "262-264h": 2,
                "268-270h": 3,
                "270-272h": 1,
                "272-274h": 3,
                "276-278h": 1,
                "312-314h": 2,
                "318-320h": 1,
                "338-340h": 1,
                "344-346h": 1,
                "356-358h": 1,
                "360-362h": 1,
                "372-374h": 1,
                "406-408h": 1,
                "450-452h": 1,
                "452-454h": 2,
                "504-506h": 2,
                "528-530h": 2,
                "572-574h": 1,
                "576-578h": 5,
                "598-600h": 1,
                "714-716h": 1,
                "722-724h": 1,
                "768-770h": 1,
                "816-818h": 1,
                "824-826h": 1,
                "834-836h": 1,
                "872-874h": 2,
                "882-884h": 1,
                "906-908h": 1,
                "952-954h": 1,
                "960-962h": 2,
                "976-978h": 1,
                "984-986h": 2,
                "1006-1008h": 1,
                "1012-1014h": 1,
                "1096-1098h": 1,
                "1102-1104h": 1,
                "1104-1106h": 1,
                "1176-1178h": 1,
                "1178-1180h": 1,
                "1202-1204h": 1,
                "1326-1328h": 1,
                "1338-1340h": 1,
                "1376-1378h": 2,
                "1380-1382h": 1,
                "1390-1392h": 1,
                "1514-1516h": 1,
                "1570-1572h": 1,
                "1658-1660h": 1,
                "1718-1720h": 1,
                "1728-1730h": 1,
                "2152-2154h": 1,
                "2902-2904h": 1
              },
              "tickets_count": 471,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-10-23": 2,
                "2025-11-04": 2,
                "2025-11-05": 1,
                "2025-11-10": 2,
                "2025-11-12": 3,
                "2025-11-13": 14,
                "2025-11-14": 2,
                "2025-11-17": 21,
                "2025-11-18": 5,
                "2025-11-19": 5,
                "2025-11-20": 2,
                "2025-11-21": 2,
                "2025-11-22": 13,
                "2025-11-24": 19,
                "2025-11-25": 5,
                "2025-11-26": 7,
                "2025-11-27": 8,
                "2025-11-28": 7,
                "2025-11-30": 1,
                "2025-12-02": 12,
                "2025-12-03": 1,
                "2025-12-04": 11,
                "2025-12-05": 7,
                "2025-12-09": 5,
                "2025-12-10": 7,
                "2025-12-11": 15,
                "2025-12-12": 9,
                "2025-12-13": 5,
                "2025-12-14": 8,
                "2025-12-15": 5,
                "2025-12-17": 5,
                "2025-12-18": 9,
                "2025-12-19": 5,
                "2025-12-22": 2,
                "2025-12-23": 4,
                "2025-12-24": 2,
                "2025-12-26": 7,
                "2025-12-29": 4,
                "2025-12-30": 3,
                "2025-12-31": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-07": 2,
                "2026-01-08": 3,
                "2026-01-12": 2,
                "2026-01-13": 8,
                "2026-01-14": 20,
                "2026-01-15": 2,
                "2026-01-16": 4,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-21": 8,
                "2026-01-26": 1,
                "2026-01-27": 27,
                "2026-01-29": 1,
                "2026-01-30": 2,
                "2026-02-02": 6,
                "2026-02-03": 7,
                "2026-02-04": 23,
                "2026-02-05": 2,
                "2026-02-06": 2,
                "2026-02-09": 6,
                "2026-02-10": 6,
                "2026-02-11": 2,
                "2026-02-12": 3,
                "2026-02-13": 4,
                "2026-02-16": 4,
                "2026-02-18": 2,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-05": 5,
                "2026-03-06": 7,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-17": 16,
                "2026-03-18": 3,
                "2026-03-20": 4,
                "2026-03-24": 3,
                "2026-03-25": 6,
                "2026-03-31": 2,
                "2026-04-01": 2,
                "2026-04-06": 2,
                "2026-04-08": 1,
                "2026-04-09": 2,
                "2026-04-10": 4,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-10": 1,
                "2026-05-13": 1,
                "2026-05-18": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-10-13": 0.18714916666666664,
                "2025-10-23": 564.9127875,
                "2025-11-04": 10.265347777777778,
                "2025-11-05": 8.505236388888889,
                "2025-11-10": 614.9529177777778,
                "2025-11-12": 29.9439925,
                "2025-11-13": 268.13271583333346,
                "2025-11-14": 270.97282972222223,
                "2025-11-17": 1973.1453922222222,
                "2025-11-18": 128.78003583333336,
                "2025-11-19": 42.0877,
                "2025-11-20": 174.08996944444442,
                "2025-11-21": 113.0926125,
                "2025-11-22": 937.6392994444445,
                "2025-11-24": 1643.8156583333337,
                "2025-11-25": 415.62317,
                "2025-11-26": 329.8245733333333,
                "2025-11-27": 80.60043916666667,
                "2025-11-28": 146.93484666666666,
                "2025-11-30": 43.668389166666664,
                "2025-12-02": 861.2698336111112,
                "2025-12-03": 0.14630722222222223,
                "2025-12-04": 2141.4480100000005,
                "2025-12-05": 379.4149897222222,
                "2025-12-09": 314.83780972222223,
                "2025-12-10": 637.5206052777777,
                "2025-12-11": 2529.5799894444444,
                "2025-12-12": 166.84938361111114,
                "2025-12-13": 1349.5896272222221,
                "2025-12-14": 399.1870141666667,
                "2025-12-15": 186.63769916666666,
                "2025-12-17": 209.4849336111111,
                "2025-12-18": 675.7056825000001,
                "2025-12-19": 347.7480458333334,
                "2025-12-22": 254.41725944444445,
                "2025-12-23": 328.6656697222222,
                "2025-12-24": 699.1475755555556,
                "2025-12-26": 1694.9179055555558,
                "2025-12-29": 349.1148966666666,
                "2025-12-30": 144.13959333333332,
                "2025-12-31": 52.349401944444445,
                "2026-01-05": 406.6511561111111,
                "2026-01-06": 27.836116666666666,
                "2026-01-07": 64.12452083333334,
                "2026-01-08": 56.97413138888889,
                "2026-01-12": 15.989611944444444,
                "2026-01-13": 303.07245416666666,
                "2026-01-14": 2513.636925833333,
                "2026-01-15": 113.25286694444443,
                "2026-01-16": 1789.9622913888886,
                "2026-01-19": 9.050720555555555,
                "2026-01-20": 55.64463194444444,
                "2026-01-21": 575.7281844444444,
                "2026-01-26": 7.296999444444444,
                "2026-01-27": 3255.50560611111,
                "2026-01-29": 49.87528777777778,
                "2026-01-30": 279.57933777777777,
                "2026-02-02": 73.5352325,
                "2026-02-03": 492.98274888888886,
                "2026-02-04": 2313.6567783333326,
                "2026-02-05": 15.589222499999998,
                "2026-02-06": 232.88725055555557,
                "2026-02-09": 212.42088444444445,
                "2026-02-10": 155.19146444444445,
                "2026-02-11": 9.379604166666667,
                "2026-02-12": 151.13185333333334,
                "2026-02-13": 99.55614,
                "2026-02-16": 406.5999211111111,
                "2026-02-18": 489.12999972222224,
                "2026-02-25": 312.00210527777773,
                "2026-03-02": 0.760531111111111,
                "2026-03-05": 2887.9969547222227,
                "2026-03-06": 4502.409372777777,
                "2026-03-11": 961.1505605555556,
                "2026-03-16": 3.3592455555555554,
                "2026-03-17": 6810.941920555557,
                "2026-03-18": 72.18991583333334,
                "2026-03-20": 2268.5714769444444,
                "2026-03-24": 3635.96933,
                "2026-03-25": 5867.991943333333,
                "2026-03-31": 2435.2797088888888,
                "2026-04-01": 1209.3883822222222,
                "2026-04-06": 299.6327919444444,
                "2026-04-08": 199.64447777777778,
                "2026-04-09": 2753.2722791666665,
                "2026-04-10": 6329.0997402777775,
                "2026-04-13": 4.4292758333333335,
                "2026-04-16": 4.032726666666667,
                "2026-05-06": 5055.632395833333,
                "2026-05-07": 2.6027802777777778,
                "2026-05-10": 74.07216916666667,
                "2026-05-13": 46.38438527777778,
                "2026-05-18": 262.2557683333333,
                "2026-05-25": 5.3107033333333336
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-10-23": 2,
                "2025-11-04": 2,
                "2025-11-05": 1,
                "2025-11-10": 2,
                "2025-11-12": 3,
                "2025-11-13": 14,
                "2025-11-14": 2,
                "2025-11-17": 21,
                "2025-11-18": 5,
                "2025-11-19": 5,
                "2025-11-20": 2,
                "2025-11-21": 2,
                "2025-11-22": 13,
                "2025-11-24": 19,
                "2025-11-25": 5,
                "2025-11-26": 7,
                "2025-11-27": 8,
                "2025-11-28": 7,
                "2025-11-30": 1,
                "2025-12-02": 12,
                "2025-12-03": 1,
                "2025-12-04": 11,
                "2025-12-05": 7,
                "2025-12-09": 5,
                "2025-12-10": 7,
                "2025-12-11": 15,
                "2025-12-12": 9,
                "2025-12-13": 5,
                "2025-12-14": 8,
                "2025-12-15": 5,
                "2025-12-17": 5,
                "2025-12-18": 9,
                "2025-12-19": 5,
                "2025-12-22": 2,
                "2025-12-23": 4,
                "2025-12-24": 2,
                "2025-12-26": 7,
                "2025-12-29": 4,
                "2025-12-30": 3,
                "2025-12-31": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-07": 2,
                "2026-01-08": 3,
                "2026-01-12": 2,
                "2026-01-13": 8,
                "2026-01-14": 20,
                "2026-01-15": 2,
                "2026-01-16": 4,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-21": 8,
                "2026-01-26": 1,
                "2026-01-27": 27,
                "2026-01-29": 1,
                "2026-01-30": 2,
                "2026-02-02": 6,
                "2026-02-03": 7,
                "2026-02-04": 23,
                "2026-02-05": 2,
                "2026-02-06": 2,
                "2026-02-09": 6,
                "2026-02-10": 6,
                "2026-02-11": 2,
                "2026-02-12": 3,
                "2026-02-13": 4,
                "2026-02-16": 4,
                "2026-02-18": 2,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-05": 5,
                "2026-03-06": 7,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-17": 16,
                "2026-03-18": 3,
                "2026-03-20": 4,
                "2026-03-24": 3,
                "2026-03-25": 6,
                "2026-03-31": 2,
                "2026-04-01": 2,
                "2026-04-06": 2,
                "2026-04-08": 1,
                "2026-04-09": 2,
                "2026-04-10": 4,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-10": 1,
                "2026-05-13": 1,
                "2026-05-18": 1,
                "2026-05-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 29.03,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "8-10h": 1,
                "44-46h": 1,
                "86-88h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-10": 2,
                "2025-11-21": 1,
                "2025-11-30": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-11-10": 3.011468888888889,
                "2025-11-21": 9.804733055555555,
                "2025-11-30": 44.71778611111111,
                "2026-01-27": 87.59708722222223
              },
              "time_count_per_day": {
                "2025-11-10": 2,
                "2025-11-21": 1,
                "2025-11-30": 1,
                "2026-01-27": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 70,
            "tickets_per_day": {
              "2025-11-14": 1,
              "2025-11-24": 1,
              "2026-01-16": 2,
              "2026-01-21": 1,
              "2026-02-02": 1,
              "2026-02-20": 1,
              "2026-03-10": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-09": 1,
              "2026-04-27": 1,
              "2026-05-02": 1,
              "2026-05-04": 2,
              "2026-05-06": 4,
              "2026-05-09": 1,
              "2026-05-11": 7,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-23": 1,
              "2026-05-25": 1,
              "2026-05-26": 7,
              "2026-05-27": 3,
              "2026-05-28": 2,
              "2026-05-29": 3,
              "2026-06-01": 4,
              "2026-06-02": 1,
              "2026-06-03": 3,
              "2026-06-05": 7,
              "2026-06-06": 3,
              "2026-06-08": 5
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-04-09": 1,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-18": 1,
                "2026-05-27": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 57,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-03-10": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-04-27": 1,
                "2026-05-02": 1,
                "2026-05-04": 2,
                "2026-05-06": 3,
                "2026-05-09": 1,
                "2026-05-11": 6,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-26": 7,
                "2026-05-27": 2,
                "2026-05-28": 1,
                "2026-05-29": 3,
                "2026-06-01": 3,
                "2026-06-02": 1,
                "2026-06-03": 3,
                "2026-06-05": 7,
                "2026-06-06": 3,
                "2026-06-08": 5
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-11-24": 1,
                "2026-01-16": 1,
                "2026-01-21": 1,
                "2026-02-02": 1,
                "2026-02-20": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-23": 1,
              "2026-03-30": 1,
              "2026-05-27": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-23": 1,
                "2026-03-30": 1,
                "2026-05-27": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-19": 1,
              "2026-03-18": 1,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-04-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-03-18": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-04-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-12-10": 1,
              "2025-12-29": 1,
              "2026-03-04": 1,
              "2026-04-09": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-04-09": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-10": 1,
                "2025-12-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Reminder": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Carolina Ferreirinha": {
      "overall": {
        "avg_time_hours": 112.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 46,
        "time_distribution": {
          "0-2h": 46,
          "2-4h": 16,
          "4-6h": 19,
          "6-8h": 18,
          "8-10h": 18,
          "10-12h": 7,
          "12-14h": 23,
          "14-16h": 34,
          "16-18h": 18,
          "18-20h": 26,
          "20-22h": 21,
          "22-24h": 39,
          "24-26h": 33,
          "26-28h": 18,
          "28-30h": 11,
          "30-32h": 33,
          "32-34h": 15,
          "34-36h": 12,
          "36-38h": 11,
          "38-40h": 7,
          "40-42h": 5,
          "42-44h": 12,
          "44-46h": 15,
          "46-48h": 10,
          "48-50h": 13,
          "50-52h": 8,
          "52-54h": 2,
          "54-56h": 6,
          "56-58h": 15,
          "58-60h": 5,
          "60-62h": 13,
          "62-64h": 16,
          "64-66h": 4,
          "66-68h": 8,
          "68-70h": 8,
          "70-72h": 3,
          "72-74h": 14,
          "74-76h": 15,
          "76-78h": 11,
          "78-80h": 10,
          "80-82h": 6,
          "82-84h": 7,
          "84-86h": 9,
          "86-88h": 9,
          "88-90h": 2,
          "90-92h": 2,
          "92-94h": 6,
          "94-96h": 4,
          "96-98h": 2,
          "98-100h": 2,
          "100-102h": 3,
          "104-106h": 4,
          "110-112h": 1,
          "112-114h": 1,
          "114-116h": 1,
          "116-118h": 3,
          "118-120h": 4,
          "120-122h": 3,
          "122-124h": 5,
          "124-126h": 4,
          "126-128h": 6,
          "128-130h": 3,
          "132-134h": 2,
          "134-136h": 1,
          "136-138h": 2,
          "138-140h": 2,
          "140-142h": 4,
          "142-144h": 3,
          "144-146h": 5,
          "146-148h": 2,
          "148-150h": 3,
          "154-156h": 2,
          "160-162h": 1,
          "162-164h": 2,
          "164-166h": 1,
          "168-170h": 2,
          "170-172h": 7,
          "172-174h": 1,
          "174-176h": 1,
          "176-178h": 1,
          "180-182h": 1,
          "182-184h": 3,
          "186-188h": 1,
          "190-192h": 2,
          "198-200h": 1,
          "202-204h": 1,
          "208-210h": 1,
          "210-212h": 1,
          "214-216h": 1,
          "218-220h": 1,
          "220-222h": 3,
          "222-224h": 1,
          "228-230h": 2,
          "232-234h": 2,
          "234-236h": 1,
          "236-238h": 1,
          "238-240h": 3,
          "240-242h": 2,
          "244-246h": 3,
          "254-256h": 1,
          "256-258h": 3,
          "260-262h": 1,
          "268-270h": 3,
          "276-278h": 1,
          "282-284h": 2,
          "284-286h": 4,
          "288-290h": 1,
          "290-292h": 1,
          "292-294h": 1,
          "304-306h": 1,
          "308-310h": 1,
          "310-312h": 1,
          "312-314h": 1,
          "314-316h": 1,
          "316-318h": 3,
          "334-336h": 1,
          "338-340h": 1,
          "340-342h": 1,
          "342-344h": 1,
          "344-346h": 1,
          "348-350h": 1,
          "354-356h": 2,
          "366-368h": 2,
          "368-370h": 1,
          "372-374h": 1,
          "374-376h": 1,
          "378-380h": 1,
          "386-388h": 3,
          "388-390h": 2,
          "392-394h": 1,
          "402-404h": 1,
          "406-408h": 1,
          "416-418h": 2,
          "426-428h": 1,
          "428-430h": 1,
          "434-436h": 1,
          "454-456h": 2,
          "458-460h": 1,
          "472-474h": 1,
          "478-480h": 3,
          "496-498h": 1,
          "506-508h": 1,
          "510-512h": 1,
          "514-516h": 1,
          "526-528h": 2,
          "546-548h": 1,
          "548-550h": 2,
          "552-554h": 1,
          "560-562h": 1,
          "576-578h": 1,
          "578-580h": 1,
          "594-596h": 1,
          "612-614h": 1,
          "644-646h": 1,
          "648-650h": 1,
          "654-656h": 1,
          "682-684h": 1,
          "714-716h": 1,
          "742-744h": 1,
          "762-764h": 1,
          "794-796h": 1,
          "806-808h": 1,
          "844-846h": 1,
          "848-850h": 1,
          "850-852h": 1,
          "864-866h": 1,
          "1030-1032h": 1,
          "1032-1034h": 1,
          "1034-1036h": 1,
          "1036-1038h": 1,
          "1080-1082h": 1,
          "1128-1130h": 1,
          "1252-1254h": 1,
          "1306-1308h": 1,
          "1310-1312h": 1,
          "1392-1394h": 1,
          "2124-2126h": 1,
          "2160-2162h": 1,
          "2392-2394h": 1
        },
        "tickets_count": 910,
        "tickets_per_day": {
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-12-02": 1,
          "2025-12-03": 2,
          "2025-12-10": 3,
          "2026-01-07": 9,
          "2026-01-08": 24,
          "2026-01-09": 1,
          "2026-01-11": 4,
          "2026-01-12": 1,
          "2026-01-13": 22,
          "2026-01-14": 8,
          "2026-01-15": 46,
          "2026-01-16": 20,
          "2026-01-17": 11,
          "2026-01-19": 33,
          "2026-01-20": 10,
          "2026-01-22": 32,
          "2026-01-23": 18,
          "2026-01-26": 9,
          "2026-01-27": 46,
          "2026-01-28": 43,
          "2026-01-29": 13,
          "2026-01-30": 1,
          "2026-01-31": 18,
          "2026-02-02": 2,
          "2026-02-03": 74,
          "2026-02-04": 1,
          "2026-02-05": 13,
          "2026-02-06": 7,
          "2026-02-07": 33,
          "2026-02-09": 33,
          "2026-02-10": 36,
          "2026-02-12": 12,
          "2026-02-14": 60,
          "2026-02-16": 12,
          "2026-02-17": 3,
          "2026-02-18": 37,
          "2026-02-19": 5,
          "2026-02-20": 18,
          "2026-02-21": 3,
          "2026-02-22": 2,
          "2026-02-23": 2,
          "2026-02-24": 5,
          "2026-02-25": 4,
          "2026-03-03": 1,
          "2026-03-05": 17,
          "2026-03-06": 15,
          "2026-03-07": 1,
          "2026-03-09": 4,
          "2026-03-10": 9,
          "2026-03-11": 16,
          "2026-03-17": 1,
          "2026-03-20": 3,
          "2026-03-23": 14,
          "2026-03-24": 2,
          "2026-03-25": 4,
          "2026-03-26": 1,
          "2026-03-30": 3,
          "2026-03-31": 10,
          "2026-04-01": 1,
          "2026-04-04": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 2,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-16": 6,
          "2026-04-20": 3,
          "2026-04-22": 3,
          "2026-04-23": 3,
          "2026-04-27": 3,
          "2026-04-28": 2,
          "2026-04-29": 10,
          "2026-05-03": 1,
          "2026-05-04": 7,
          "2026-05-07": 3,
          "2026-05-09": 1,
          "2026-05-11": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 2,
          "2026-05-22": 3,
          "2026-05-28": 2,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-11-04": 91.49926194444444,
          "2025-11-06": 0.4233675,
          "2025-11-11": 126.80880111111111,
          "2025-11-14": 1036.9217947222223,
          "2025-11-18": 139.55627805555557,
          "2025-11-19": 4.184505277777777,
          "2025-12-02": 162.58090083333335,
          "2025-12-03": 397.88330222222226,
          "2025-12-10": 625.9387091666667,
          "2026-01-07": 4483.928124166667,
          "2026-01-08": 7.116061666666665,
          "2026-01-09": 1392.7871625,
          "2026-01-11": 3729.0510155555553,
          "2026-01-12": 12.020579444444445,
          "2026-01-13": 258.09911999999997,
          "2026-01-14": 232.14148166666666,
          "2026-01-15": 3132.5359427777776,
          "2026-01-16": 517.8380083333334,
          "2026-01-17": 245.48245416666666,
          "2026-01-19": 1463.885282777778,
          "2026-01-20": 297.61162888888884,
          "2026-01-22": 1763.0323855555555,
          "2026-01-23": 641.4578166666666,
          "2026-01-26": 674.4880605555556,
          "2026-01-27": 2196.7036344444446,
          "2026-01-28": 966.0112230555558,
          "2026-01-29": 166.87786055555557,
          "2026-01-30": 36.14561944444444,
          "2026-01-31": 471.92562416666675,
          "2026-02-02": 203.8731422222222,
          "2026-02-03": 3809.4592597222213,
          "2026-02-04": 37.59851888888889,
          "2026-02-05": 872.9177308333334,
          "2026-02-06": 356.4887563888889,
          "2026-02-07": 2267.013641666667,
          "2026-02-09": 4712.125949166667,
          "2026-02-10": 3076.9096841666665,
          "2026-02-12": 938.189919722222,
          "2026-02-14": 2514.268824166667,
          "2026-02-16": 2158.8738511111114,
          "2026-02-17": 296.11070666666666,
          "2026-02-18": 4753.580001111113,
          "2026-02-19": 2275.018355,
          "2026-02-20": 1663.5718816666665,
          "2026-02-21": 72.10717555555556,
          "2026-02-22": 43.53679416666667,
          "2026-02-23": 136.33911750000001,
          "2026-02-24": 67.6964111111111,
          "2026-02-25": 29.4374575,
          "2026-03-05": 6347.7484397222215,
          "2026-03-06": 3036.9144208333337,
          "2026-03-07": 62.877425555555554,
          "2026-03-09": 9.962905833333334,
          "2026-03-10": 1122.7556566666665,
          "2026-03-11": 4134.729181111111,
          "2026-03-17": 22.76893472222222,
          "2026-03-20": 1686.1726122222224,
          "2026-03-23": 5077.336802777777,
          "2026-03-24": 535.8004411111111,
          "2026-03-25": 395.0920044444444,
          "2026-03-30": 1057.1013711111111,
          "2026-03-31": 2583.9707422222223,
          "2026-04-01": 340.28477194444446,
          "2026-04-07": 84.61776333333333,
          "2026-04-09": 876.0699622222223,
          "2026-04-16": 237.19031055555558,
          "2026-04-20": 3054.5751566666663,
          "2026-04-22": 2575.7682141666664,
          "2026-04-27": 547.2606027777778,
          "2026-04-29": 6107.833321666667,
          "2026-05-04": 1663.4550658333333,
          "2026-05-07": 4.809958611111111,
          "2026-05-14": 0.5579908333333333,
          "2026-05-20": 20.308903055555557,
          "2026-05-22": 854.2103013888889,
          "2026-05-28": 743.8173119444444
        },
        "time_count_per_day": {
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-12-02": 1,
          "2025-12-03": 2,
          "2025-12-10": 3,
          "2026-01-07": 9,
          "2026-01-08": 24,
          "2026-01-09": 1,
          "2026-01-11": 4,
          "2026-01-12": 1,
          "2026-01-13": 22,
          "2026-01-14": 8,
          "2026-01-15": 46,
          "2026-01-16": 19,
          "2026-01-17": 11,
          "2026-01-19": 33,
          "2026-01-20": 10,
          "2026-01-22": 32,
          "2026-01-23": 18,
          "2026-01-26": 9,
          "2026-01-27": 46,
          "2026-01-28": 43,
          "2026-01-29": 13,
          "2026-01-30": 1,
          "2026-01-31": 18,
          "2026-02-02": 2,
          "2026-02-03": 74,
          "2026-02-04": 1,
          "2026-02-05": 13,
          "2026-02-06": 7,
          "2026-02-07": 33,
          "2026-02-09": 33,
          "2026-02-10": 36,
          "2026-02-12": 12,
          "2026-02-14": 60,
          "2026-02-16": 12,
          "2026-02-17": 3,
          "2026-02-18": 37,
          "2026-02-19": 5,
          "2026-02-20": 17,
          "2026-02-21": 3,
          "2026-02-22": 2,
          "2026-02-23": 2,
          "2026-02-24": 5,
          "2026-02-25": 4,
          "2026-03-05": 17,
          "2026-03-06": 15,
          "2026-03-07": 1,
          "2026-03-09": 4,
          "2026-03-10": 9,
          "2026-03-11": 16,
          "2026-03-17": 1,
          "2026-03-20": 3,
          "2026-03-23": 14,
          "2026-03-24": 2,
          "2026-03-25": 4,
          "2026-03-30": 3,
          "2026-03-31": 10,
          "2026-04-01": 1,
          "2026-04-07": 1,
          "2026-04-09": 2,
          "2026-04-16": 6,
          "2026-04-20": 3,
          "2026-04-22": 2,
          "2026-04-27": 2,
          "2026-04-29": 10,
          "2026-05-04": 5,
          "2026-05-07": 1,
          "2026-05-14": 1,
          "2026-05-20": 1,
          "2026-05-22": 3,
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 221.89,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "46-48h": 1,
            "78-80h": 1,
            "84-86h": 1,
            "112-114h": 1,
            "120-122h": 1,
            "160-162h": 1,
            "170-172h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "222-224h": 1,
            "1310-1312h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2026-02-07": 1,
            "2026-02-10": 1,
            "2026-02-18": 2,
            "2026-03-03": 1,
            "2026-03-23": 1,
            "2026-03-25": 2,
            "2026-03-31": 1,
            "2026-04-07": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-04": 2,
            "2026-05-07": 1,
            "2026-05-09": 1
          },
          "time_per_day": {
            "2026-02-07": 3.7770802777777774,
            "2026-02-10": 79.70536527777777,
            "2026-02-18": 397.51375083333335,
            "2026-03-23": 113.72397638888889,
            "2026-03-25": 207.84017749999998,
            "2026-03-31": 121.01029222222223,
            "2026-04-07": 84.61776333333333,
            "2026-04-29": 172.6751986111111,
            "2026-05-04": 1481.8547769444444
          },
          "time_count_per_day": {
            "2026-02-07": 1,
            "2026-02-10": 1,
            "2026-02-18": 2,
            "2026-03-23": 1,
            "2026-03-25": 2,
            "2026-03-31": 1,
            "2026-04-07": 1,
            "2026-04-29": 1,
            "2026-05-04": 2
          }
        },
        "P2": {
          "avg_time_hours": 149.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 38,
          "time_distribution": {
            "0-2h": 38,
            "2-4h": 7,
            "4-6h": 7,
            "6-8h": 3,
            "8-10h": 3,
            "10-12h": 2,
            "12-14h": 2,
            "14-16h": 10,
            "16-18h": 3,
            "20-22h": 2,
            "22-24h": 5,
            "24-26h": 10,
            "26-28h": 3,
            "28-30h": 5,
            "30-32h": 1,
            "32-34h": 1,
            "34-36h": 7,
            "36-38h": 5,
            "38-40h": 3,
            "40-42h": 2,
            "42-44h": 2,
            "44-46h": 4,
            "46-48h": 1,
            "48-50h": 3,
            "54-56h": 1,
            "62-64h": 3,
            "66-68h": 1,
            "68-70h": 4,
            "72-74h": 5,
            "74-76h": 8,
            "76-78h": 2,
            "78-80h": 1,
            "80-82h": 1,
            "86-88h": 2,
            "90-92h": 2,
            "92-94h": 1,
            "94-96h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 3,
            "124-126h": 1,
            "126-128h": 1,
            "132-134h": 1,
            "134-136h": 1,
            "136-138h": 1,
            "140-142h": 3,
            "144-146h": 3,
            "146-148h": 1,
            "148-150h": 1,
            "154-156h": 1,
            "162-164h": 1,
            "170-172h": 3,
            "180-182h": 1,
            "182-184h": 3,
            "186-188h": 1,
            "190-192h": 1,
            "198-200h": 1,
            "202-204h": 1,
            "214-216h": 1,
            "228-230h": 2,
            "232-234h": 2,
            "236-238h": 1,
            "238-240h": 3,
            "240-242h": 2,
            "244-246h": 3,
            "256-258h": 2,
            "260-262h": 1,
            "268-270h": 2,
            "276-278h": 1,
            "282-284h": 2,
            "284-286h": 4,
            "312-314h": 1,
            "314-316h": 1,
            "316-318h": 1,
            "338-340h": 1,
            "340-342h": 1,
            "342-344h": 1,
            "344-346h": 1,
            "348-350h": 1,
            "354-356h": 1,
            "366-368h": 1,
            "372-374h": 1,
            "374-376h": 1,
            "386-388h": 2,
            "388-390h": 2,
            "392-394h": 1,
            "402-404h": 1,
            "406-408h": 1,
            "416-418h": 2,
            "426-428h": 1,
            "428-430h": 1,
            "434-436h": 1,
            "454-456h": 1,
            "478-480h": 2,
            "514-516h": 1,
            "548-550h": 1,
            "552-554h": 1,
            "644-646h": 1,
            "648-650h": 1,
            "654-656h": 1,
            "742-744h": 1,
            "762-764h": 1,
            "806-808h": 1,
            "864-866h": 1,
            "1036-1038h": 1,
            "1080-1082h": 1,
            "1128-1130h": 1,
            "1252-1254h": 1,
            "1392-1394h": 1
          },
          "tickets_count": 284,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-19": 1,
            "2025-12-03": 2,
            "2025-12-10": 1,
            "2026-01-07": 1,
            "2026-01-08": 23,
            "2026-01-09": 1,
            "2026-01-11": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-16": 9,
            "2026-01-19": 20,
            "2026-01-20": 5,
            "2026-01-22": 8,
            "2026-01-23": 3,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-01-31": 6,
            "2026-02-02": 2,
            "2026-02-03": 13,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-09": 12,
            "2026-02-10": 6,
            "2026-02-12": 1,
            "2026-02-14": 8,
            "2026-02-16": 3,
            "2026-02-17": 1,
            "2026-02-18": 11,
            "2026-02-20": 2,
            "2026-02-21": 3,
            "2026-02-22": 1,
            "2026-02-23": 1,
            "2026-02-24": 5,
            "2026-02-25": 4,
            "2026-03-05": 7,
            "2026-03-06": 13,
            "2026-03-07": 1,
            "2026-03-09": 4,
            "2026-03-10": 9,
            "2026-03-11": 15,
            "2026-03-17": 1,
            "2026-03-20": 2,
            "2026-03-23": 11,
            "2026-03-24": 2,
            "2026-03-25": 2,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-03-31": 4,
            "2026-04-01": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-09": 2,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-20": 2,
            "2026-04-22": 2,
            "2026-04-23": 2,
            "2026-04-27": 3,
            "2026-04-29": 6,
            "2026-05-03": 1,
            "2026-05-04": 5,
            "2026-05-07": 2,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-21": 2,
            "2026-05-22": 2,
            "2026-05-28": 2,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-11-04": 91.49926194444444,
            "2025-11-11": 126.80880111111111,
            "2025-11-14": 1036.9217947222223,
            "2025-11-19": 4.184505277777777,
            "2025-12-03": 397.88330222222226,
            "2025-12-10": 171.3362075,
            "2026-01-07": 54.095234999999995,
            "2026-01-08": 5.2793288888888865,
            "2026-01-09": 1392.7871625,
            "2026-01-11": 1570.273516111111,
            "2026-01-13": 23.39232972222222,
            "2026-01-14": 133.76325972222222,
            "2026-01-16": 206.0520977777778,
            "2026-01-19": 602.7021519444445,
            "2026-01-20": 151.44975388888886,
            "2026-01-22": 778.1317127777779,
            "2026-01-23": 124.3044188888889,
            "2026-01-26": 7.597497777777777,
            "2026-01-28": 5.890578611111111,
            "2026-01-29": 5.556644444444444,
            "2026-01-30": 36.14561944444444,
            "2026-01-31": 130.32139083333334,
            "2026-02-02": 203.8731422222222,
            "2026-02-03": 1015.4411325,
            "2026-02-04": 37.59851888888889,
            "2026-02-05": 178.8529661111111,
            "2026-02-09": 2737.1166224999997,
            "2026-02-10": 1291.8310613888889,
            "2026-02-12": 314.3810136111111,
            "2026-02-14": 85.63634555555556,
            "2026-02-16": 671.2339219444444,
            "2026-02-17": 1.3278127777777777,
            "2026-02-18": 1035.880431388889,
            "2026-02-20": 88.34821944444444,
            "2026-02-21": 72.10717555555556,
            "2026-02-22": 13.70508888888889,
            "2026-02-23": 62.66969111111111,
            "2026-02-24": 67.6964111111111,
            "2026-02-25": 29.4374575,
            "2026-03-05": 2198.474203888889,
            "2026-03-06": 2616.4075530555556,
            "2026-03-07": 62.877425555555554,
            "2026-03-09": 9.962905833333334,
            "2026-03-10": 1122.7556566666665,
            "2026-03-11": 3420.695398055556,
            "2026-03-17": 22.76893472222222,
            "2026-03-20": 1073.1063175,
            "2026-03-23": 3617.7516088888897,
            "2026-03-24": 535.8004411111111,
            "2026-03-25": 187.25182694444447,
            "2026-03-30": 4.865214166666667,
            "2026-03-31": 1142.8218011111112,
            "2026-04-01": 340.28477194444446,
            "2026-04-09": 876.0699622222223,
            "2026-04-16": 48.84182861111111,
            "2026-04-20": 2209.8961827777775,
            "2026-04-22": 183.265175,
            "2026-04-27": 547.2606027777778,
            "2026-04-29": 2726.304171111111,
            "2026-05-04": 181.60028888888888,
            "2026-05-07": 4.809958611111111,
            "2026-05-14": 0.5579908333333333,
            "2026-05-20": 20.308903055555557,
            "2026-05-22": 327.8274616666667,
            "2026-05-28": 743.8173119444444
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-19": 1,
            "2025-12-03": 2,
            "2025-12-10": 1,
            "2026-01-07": 1,
            "2026-01-08": 23,
            "2026-01-09": 1,
            "2026-01-11": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-16": 8,
            "2026-01-19": 20,
            "2026-01-20": 5,
            "2026-01-22": 8,
            "2026-01-23": 3,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-01-31": 6,
            "2026-02-02": 2,
            "2026-02-03": 13,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-09": 12,
            "2026-02-10": 6,
            "2026-02-12": 1,
            "2026-02-14": 8,
            "2026-02-16": 3,
            "2026-02-17": 1,
            "2026-02-18": 11,
            "2026-02-20": 2,
            "2026-02-21": 3,
            "2026-02-22": 1,
            "2026-02-23": 1,
            "2026-02-24": 5,
            "2026-02-25": 4,
            "2026-03-05": 7,
            "2026-03-06": 13,
            "2026-03-07": 1,
            "2026-03-09": 4,
            "2026-03-10": 9,
            "2026-03-11": 15,
            "2026-03-17": 1,
            "2026-03-20": 2,
            "2026-03-23": 11,
            "2026-03-24": 2,
            "2026-03-25": 2,
            "2026-03-30": 1,
            "2026-03-31": 4,
            "2026-04-01": 1,
            "2026-04-09": 2,
            "2026-04-16": 1,
            "2026-04-20": 2,
            "2026-04-22": 1,
            "2026-04-27": 2,
            "2026-04-29": 6,
            "2026-05-04": 3,
            "2026-05-07": 1,
            "2026-05-14": 1,
            "2026-05-20": 1,
            "2026-05-22": 2,
            "2026-05-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 91.13,
          "mode_time_hours": 23.0,
          "mode_frequency": 34,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 7,
            "4-6h": 12,
            "6-8h": 15,
            "8-10h": 15,
            "10-12h": 5,
            "12-14h": 21,
            "14-16h": 24,
            "16-18h": 15,
            "18-20h": 26,
            "20-22h": 19,
            "22-24h": 34,
            "24-26h": 22,
            "26-28h": 15,
            "28-30h": 5,
            "30-32h": 31,
            "32-34h": 14,
            "34-36h": 5,
            "36-38h": 6,
            "38-40h": 4,
            "40-42h": 3,
            "42-44h": 10,
            "44-46h": 11,
            "46-48h": 8,
            "48-50h": 10,
            "50-52h": 8,
            "52-54h": 2,
            "54-56h": 5,
            "56-58h": 15,
            "58-60h": 5,
            "60-62h": 13,
            "62-64h": 13,
            "64-66h": 4,
            "66-68h": 7,
            "68-70h": 4,
            "70-72h": 3,
            "72-74h": 9,
            "74-76h": 7,
            "76-78h": 9,
            "78-80h": 8,
            "80-82h": 5,
            "82-84h": 7,
            "84-86h": 8,
            "86-88h": 7,
            "88-90h": 2,
            "92-94h": 5,
            "94-96h": 3,
            "96-98h": 2,
            "98-100h": 1,
            "100-102h": 2,
            "104-106h": 4,
            "110-112h": 1,
            "114-116h": 1,
            "116-118h": 3,
            "118-120h": 3,
            "120-122h": 1,
            "122-124h": 2,
            "124-126h": 3,
            "126-128h": 5,
            "128-130h": 3,
            "132-134h": 1,
            "136-138h": 1,
            "138-140h": 2,
            "140-142h": 1,
            "142-144h": 3,
            "144-146h": 2,
            "146-148h": 1,
            "148-150h": 2,
            "154-156h": 1,
            "162-164h": 1,
            "164-166h": 1,
            "168-170h": 2,
            "170-172h": 3,
            "176-178h": 1,
            "190-192h": 1,
            "208-210h": 1,
            "210-212h": 1,
            "218-220h": 1,
            "220-222h": 3,
            "234-236h": 1,
            "254-256h": 1,
            "256-258h": 1,
            "268-270h": 1,
            "288-290h": 1,
            "290-292h": 1,
            "292-294h": 1,
            "304-306h": 1,
            "308-310h": 1,
            "310-312h": 1,
            "316-318h": 2,
            "334-336h": 1,
            "354-356h": 1,
            "366-368h": 1,
            "368-370h": 1,
            "378-380h": 1,
            "386-388h": 1,
            "454-456h": 1,
            "458-460h": 1,
            "472-474h": 1,
            "478-480h": 1,
            "496-498h": 1,
            "506-508h": 1,
            "510-512h": 1,
            "526-528h": 2,
            "546-548h": 1,
            "548-550h": 1,
            "560-562h": 1,
            "576-578h": 1,
            "578-580h": 1,
            "594-596h": 1,
            "612-614h": 1,
            "682-684h": 1,
            "714-716h": 1,
            "794-796h": 1,
            "844-846h": 1,
            "848-850h": 1,
            "850-852h": 1,
            "1030-1032h": 1,
            "1032-1034h": 1,
            "1034-1036h": 1,
            "1306-1308h": 1,
            "2160-2162h": 1,
            "2392-2394h": 1
          },
          "tickets_count": 604,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-18": 1,
            "2025-12-02": 1,
            "2025-12-10": 2,
            "2026-01-07": 8,
            "2026-01-08": 1,
            "2026-01-11": 2,
            "2026-01-12": 1,
            "2026-01-13": 21,
            "2026-01-14": 7,
            "2026-01-15": 46,
            "2026-01-16": 11,
            "2026-01-17": 11,
            "2026-01-19": 13,
            "2026-01-20": 5,
            "2026-01-22": 23,
            "2026-01-23": 15,
            "2026-01-26": 8,
            "2026-01-27": 46,
            "2026-01-28": 42,
            "2026-01-29": 12,
            "2026-01-31": 12,
            "2026-02-03": 58,
            "2026-02-05": 11,
            "2026-02-06": 7,
            "2026-02-07": 32,
            "2026-02-09": 21,
            "2026-02-10": 29,
            "2026-02-12": 11,
            "2026-02-14": 52,
            "2026-02-16": 9,
            "2026-02-17": 2,
            "2026-02-18": 24,
            "2026-02-19": 4,
            "2026-02-20": 16,
            "2026-02-22": 1,
            "2026-02-23": 1,
            "2026-03-05": 10,
            "2026-03-06": 2,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-03-30": 2,
            "2026-03-31": 5,
            "2026-04-13": 1,
            "2026-04-16": 5,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-04-29": 3,
            "2026-05-11": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2025-11-06": 0.4233675,
            "2025-11-18": 139.55627805555557,
            "2025-12-02": 162.58090083333335,
            "2025-12-10": 454.60250166666674,
            "2026-01-07": 4429.832889166667,
            "2026-01-08": 1.8367327777777778,
            "2026-01-11": 2158.7774994444444,
            "2026-01-12": 12.020579444444445,
            "2026-01-13": 234.70679027777777,
            "2026-01-14": 98.37822194444446,
            "2026-01-15": 3132.5359427777776,
            "2026-01-16": 311.7859105555556,
            "2026-01-17": 245.48245416666666,
            "2026-01-19": 861.1831308333334,
            "2026-01-20": 146.161875,
            "2026-01-22": 960.577355,
            "2026-01-23": 517.1533977777777,
            "2026-01-26": 666.8905627777779,
            "2026-01-27": 2196.7036344444446,
            "2026-01-28": 960.1206444444447,
            "2026-01-29": 161.3212161111111,
            "2026-01-31": 341.60423333333335,
            "2026-02-03": 2732.025938055556,
            "2026-02-05": 694.0647647222223,
            "2026-02-06": 356.4887563888889,
            "2026-02-07": 2263.236561388889,
            "2026-02-09": 1975.0093266666668,
            "2026-02-10": 1705.3732574999997,
            "2026-02-12": 623.808906111111,
            "2026-02-14": 2428.6324786111118,
            "2026-02-16": 1487.6399291666664,
            "2026-02-17": 294.7828938888889,
            "2026-02-18": 3320.185818888889,
            "2026-02-19": 149.6290072222222,
            "2026-02-20": 1575.2236622222222,
            "2026-02-22": 29.831705277777775,
            "2026-02-23": 73.6694263888889,
            "2026-03-05": 4149.2742358333335,
            "2026-03-06": 420.50686777777776,
            "2026-03-11": 714.0337830555555,
            "2026-03-20": 613.0662947222222,
            "2026-03-23": 1345.8612175,
            "2026-03-30": 1052.2361569444445,
            "2026-03-31": 1320.1386488888893,
            "2026-04-16": 188.34848194444447,
            "2026-04-20": 844.6789738888889,
            "2026-04-22": 2392.5030391666664,
            "2026-04-29": 3208.853951944445,
            "2026-05-22": 526.3828397222222
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-18": 1,
            "2025-12-02": 1,
            "2025-12-10": 2,
            "2026-01-07": 8,
            "2026-01-08": 1,
            "2026-01-11": 2,
            "2026-01-12": 1,
            "2026-01-13": 21,
            "2026-01-14": 7,
            "2026-01-15": 46,
            "2026-01-16": 11,
            "2026-01-17": 11,
            "2026-01-19": 13,
            "2026-01-20": 5,
            "2026-01-22": 23,
            "2026-01-23": 15,
            "2026-01-26": 8,
            "2026-01-27": 46,
            "2026-01-28": 42,
            "2026-01-29": 12,
            "2026-01-31": 12,
            "2026-02-03": 58,
            "2026-02-05": 11,
            "2026-02-06": 7,
            "2026-02-07": 32,
            "2026-02-09": 21,
            "2026-02-10": 29,
            "2026-02-12": 11,
            "2026-02-14": 52,
            "2026-02-16": 9,
            "2026-02-17": 2,
            "2026-02-18": 24,
            "2026-02-19": 4,
            "2026-02-20": 15,
            "2026-02-22": 1,
            "2026-02-23": 1,
            "2026-03-05": 10,
            "2026-03-06": 2,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-03-30": 2,
            "2026-03-31": 5,
            "2026-04-16": 5,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-29": 3,
            "2026-05-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 21.58,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "24-26h": 1,
            "28-30h": 1,
            "30-32h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-22": 1,
            "2026-02-03": 3
          },
          "time_per_day": {
            "2026-01-22": 24.323317777777778,
            "2026-02-03": 61.99218916666666
          },
          "time_count_per_day": {
            "2026-01-22": 1,
            "2026-02-03": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 2125.39,
          "mode_time_hours": 2125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2124-2126h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 2125.389347777778
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 112.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 46,
            "time_distribution": {
              "0-2h": 46,
              "2-4h": 16,
              "4-6h": 19,
              "6-8h": 18,
              "8-10h": 18,
              "10-12h": 7,
              "12-14h": 23,
              "14-16h": 34,
              "16-18h": 18,
              "18-20h": 26,
              "20-22h": 21,
              "22-24h": 39,
              "24-26h": 33,
              "26-28h": 18,
              "28-30h": 11,
              "30-32h": 33,
              "32-34h": 15,
              "34-36h": 12,
              "36-38h": 11,
              "38-40h": 7,
              "40-42h": 5,
              "42-44h": 12,
              "44-46h": 15,
              "46-48h": 10,
              "48-50h": 13,
              "50-52h": 8,
              "52-54h": 2,
              "54-56h": 6,
              "56-58h": 15,
              "58-60h": 5,
              "60-62h": 13,
              "62-64h": 16,
              "64-66h": 4,
              "66-68h": 8,
              "68-70h": 8,
              "70-72h": 3,
              "72-74h": 14,
              "74-76h": 15,
              "76-78h": 11,
              "78-80h": 10,
              "80-82h": 6,
              "82-84h": 7,
              "84-86h": 9,
              "86-88h": 9,
              "88-90h": 2,
              "90-92h": 2,
              "92-94h": 6,
              "94-96h": 4,
              "96-98h": 2,
              "98-100h": 2,
              "100-102h": 3,
              "104-106h": 4,
              "110-112h": 1,
              "112-114h": 1,
              "114-116h": 1,
              "116-118h": 3,
              "118-120h": 4,
              "120-122h": 3,
              "122-124h": 5,
              "124-126h": 4,
              "126-128h": 6,
              "128-130h": 3,
              "132-134h": 2,
              "134-136h": 1,
              "136-138h": 2,
              "138-140h": 2,
              "140-142h": 4,
              "142-144h": 3,
              "144-146h": 5,
              "146-148h": 2,
              "148-150h": 3,
              "154-156h": 2,
              "160-162h": 1,
              "162-164h": 2,
              "164-166h": 1,
              "168-170h": 2,
              "170-172h": 7,
              "172-174h": 1,
              "174-176h": 1,
              "176-178h": 1,
              "180-182h": 1,
              "182-184h": 3,
              "186-188h": 1,
              "190-192h": 2,
              "198-200h": 1,
              "202-204h": 1,
              "208-210h": 1,
              "210-212h": 1,
              "214-216h": 1,
              "218-220h": 1,
              "220-222h": 3,
              "222-224h": 1,
              "228-230h": 2,
              "232-234h": 2,
              "234-236h": 1,
              "236-238h": 1,
              "238-240h": 3,
              "240-242h": 2,
              "244-246h": 3,
              "254-256h": 1,
              "256-258h": 3,
              "260-262h": 1,
              "268-270h": 3,
              "276-278h": 1,
              "282-284h": 2,
              "284-286h": 4,
              "288-290h": 1,
              "290-292h": 1,
              "292-294h": 1,
              "304-306h": 1,
              "308-310h": 1,
              "310-312h": 1,
              "312-314h": 1,
              "314-316h": 1,
              "316-318h": 3,
              "334-336h": 1,
              "338-340h": 1,
              "340-342h": 1,
              "342-344h": 1,
              "344-346h": 1,
              "348-350h": 1,
              "354-356h": 2,
              "366-368h": 2,
              "368-370h": 1,
              "372-374h": 1,
              "374-376h": 1,
              "378-380h": 1,
              "386-388h": 3,
              "388-390h": 2,
              "392-394h": 1,
              "402-404h": 1,
              "406-408h": 1,
              "416-418h": 2,
              "426-428h": 1,
              "428-430h": 1,
              "434-436h": 1,
              "454-456h": 2,
              "458-460h": 1,
              "472-474h": 1,
              "478-480h": 3,
              "496-498h": 1,
              "506-508h": 1,
              "510-512h": 1,
              "514-516h": 1,
              "526-528h": 2,
              "546-548h": 1,
              "548-550h": 2,
              "552-554h": 1,
              "560-562h": 1,
              "576-578h": 1,
              "578-580h": 1,
              "594-596h": 1,
              "612-614h": 1,
              "644-646h": 1,
              "648-650h": 1,
              "654-656h": 1,
              "682-684h": 1,
              "714-716h": 1,
              "742-744h": 1,
              "762-764h": 1,
              "794-796h": 1,
              "806-808h": 1,
              "844-846h": 1,
              "848-850h": 1,
              "850-852h": 1,
              "864-866h": 1,
              "1030-1032h": 1,
              "1032-1034h": 1,
              "1034-1036h": 1,
              "1036-1038h": 1,
              "1080-1082h": 1,
              "1128-1130h": 1,
              "1252-1254h": 1,
              "1306-1308h": 1,
              "1310-1312h": 1,
              "1392-1394h": 1,
              "2124-2126h": 1,
              "2160-2162h": 1,
              "2392-2394h": 1
            },
            "tickets_count": 879,
            "tickets_per_day": {
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-12-02": 1,
              "2025-12-03": 2,
              "2025-12-10": 3,
              "2026-01-07": 9,
              "2026-01-08": 24,
              "2026-01-09": 1,
              "2026-01-11": 4,
              "2026-01-12": 1,
              "2026-01-13": 22,
              "2026-01-14": 8,
              "2026-01-15": 46,
              "2026-01-16": 19,
              "2026-01-17": 11,
              "2026-01-19": 33,
              "2026-01-20": 10,
              "2026-01-22": 32,
              "2026-01-23": 18,
              "2026-01-26": 9,
              "2026-01-27": 46,
              "2026-01-28": 43,
              "2026-01-29": 13,
              "2026-01-30": 1,
              "2026-01-31": 18,
              "2026-02-02": 2,
              "2026-02-03": 74,
              "2026-02-04": 1,
              "2026-02-05": 13,
              "2026-02-06": 7,
              "2026-02-07": 33,
              "2026-02-09": 33,
              "2026-02-10": 36,
              "2026-02-12": 12,
              "2026-02-14": 60,
              "2026-02-16": 12,
              "2026-02-17": 3,
              "2026-02-18": 37,
              "2026-02-19": 5,
              "2026-02-20": 17,
              "2026-02-21": 3,
              "2026-02-22": 2,
              "2026-02-23": 2,
              "2026-02-24": 5,
              "2026-02-25": 4,
              "2026-03-05": 17,
              "2026-03-06": 15,
              "2026-03-07": 1,
              "2026-03-09": 4,
              "2026-03-10": 9,
              "2026-03-11": 16,
              "2026-03-17": 1,
              "2026-03-20": 3,
              "2026-03-23": 14,
              "2026-03-24": 2,
              "2026-03-25": 4,
              "2026-03-30": 3,
              "2026-03-31": 10,
              "2026-04-01": 1,
              "2026-04-07": 1,
              "2026-04-09": 2,
              "2026-04-16": 6,
              "2026-04-20": 3,
              "2026-04-22": 2,
              "2026-04-27": 2,
              "2026-04-29": 10,
              "2026-05-04": 5,
              "2026-05-07": 1,
              "2026-05-14": 1,
              "2026-05-20": 1,
              "2026-05-22": 3,
              "2026-05-28": 1
            },
            "time_per_day": {
              "2025-11-04": 91.49926194444444,
              "2025-11-06": 0.4233675,
              "2025-11-11": 126.80880111111111,
              "2025-11-14": 1036.9217947222223,
              "2025-11-18": 139.55627805555557,
              "2025-11-19": 4.184505277777777,
              "2025-12-02": 162.58090083333335,
              "2025-12-03": 397.88330222222226,
              "2025-12-10": 625.9387091666667,
              "2026-01-07": 4483.928124166667,
              "2026-01-08": 7.116061666666665,
              "2026-01-09": 1392.7871625,
              "2026-01-11": 3729.0510155555553,
              "2026-01-12": 12.020579444444445,
              "2026-01-13": 258.09911999999997,
              "2026-01-14": 232.14148166666666,
              "2026-01-15": 3132.5359427777776,
              "2026-01-16": 517.8380083333334,
              "2026-01-17": 245.48245416666666,
              "2026-01-19": 1463.885282777778,
              "2026-01-20": 297.61162888888884,
              "2026-01-22": 1763.0323855555555,
              "2026-01-23": 641.4578166666666,
              "2026-01-26": 674.4880605555556,
              "2026-01-27": 2196.7036344444446,
              "2026-01-28": 966.0112230555558,
              "2026-01-29": 166.87786055555557,
              "2026-01-30": 36.14561944444444,
              "2026-01-31": 471.92562416666675,
              "2026-02-02": 203.8731422222222,
              "2026-02-03": 3809.4592597222213,
              "2026-02-04": 37.59851888888889,
              "2026-02-05": 872.9177308333334,
              "2026-02-06": 356.4887563888889,
              "2026-02-07": 2267.013641666667,
              "2026-02-09": 4712.125949166667,
              "2026-02-10": 3076.9096841666665,
              "2026-02-12": 938.189919722222,
              "2026-02-14": 2514.268824166667,
              "2026-02-16": 2158.8738511111114,
              "2026-02-17": 296.11070666666666,
              "2026-02-18": 4753.580001111113,
              "2026-02-19": 2275.018355,
              "2026-02-20": 1663.5718816666665,
              "2026-02-21": 72.10717555555556,
              "2026-02-22": 43.53679416666667,
              "2026-02-23": 136.33911750000001,
              "2026-02-24": 67.6964111111111,
              "2026-02-25": 29.4374575,
              "2026-03-05": 6347.7484397222215,
              "2026-03-06": 3036.9144208333337,
              "2026-03-07": 62.877425555555554,
              "2026-03-09": 9.962905833333334,
              "2026-03-10": 1122.7556566666665,
              "2026-03-11": 4134.729181111111,
              "2026-03-17": 22.76893472222222,
              "2026-03-20": 1686.1726122222224,
              "2026-03-23": 5077.336802777777,
              "2026-03-24": 535.8004411111111,
              "2026-03-25": 395.0920044444444,
              "2026-03-30": 1057.1013711111111,
              "2026-03-31": 2583.9707422222223,
              "2026-04-01": 340.28477194444446,
              "2026-04-07": 84.61776333333333,
              "2026-04-09": 876.0699622222223,
              "2026-04-16": 237.19031055555558,
              "2026-04-20": 3054.5751566666663,
              "2026-04-22": 2575.7682141666664,
              "2026-04-27": 547.2606027777778,
              "2026-04-29": 6107.833321666667,
              "2026-05-04": 1663.4550658333333,
              "2026-05-07": 4.809958611111111,
              "2026-05-14": 0.5579908333333333,
              "2026-05-20": 20.308903055555557,
              "2026-05-22": 854.2103013888889,
              "2026-05-28": 743.8173119444444
            },
            "time_count_per_day": {
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-12-02": 1,
              "2025-12-03": 2,
              "2025-12-10": 3,
              "2026-01-07": 9,
              "2026-01-08": 24,
              "2026-01-09": 1,
              "2026-01-11": 4,
              "2026-01-12": 1,
              "2026-01-13": 22,
              "2026-01-14": 8,
              "2026-01-15": 46,
              "2026-01-16": 19,
              "2026-01-17": 11,
              "2026-01-19": 33,
              "2026-01-20": 10,
              "2026-01-22": 32,
              "2026-01-23": 18,
              "2026-01-26": 9,
              "2026-01-27": 46,
              "2026-01-28": 43,
              "2026-01-29": 13,
              "2026-01-30": 1,
              "2026-01-31": 18,
              "2026-02-02": 2,
              "2026-02-03": 74,
              "2026-02-04": 1,
              "2026-02-05": 13,
              "2026-02-06": 7,
              "2026-02-07": 33,
              "2026-02-09": 33,
              "2026-02-10": 36,
              "2026-02-12": 12,
              "2026-02-14": 60,
              "2026-02-16": 12,
              "2026-02-17": 3,
              "2026-02-18": 37,
              "2026-02-19": 5,
              "2026-02-20": 17,
              "2026-02-21": 3,
              "2026-02-22": 2,
              "2026-02-23": 2,
              "2026-02-24": 5,
              "2026-02-25": 4,
              "2026-03-05": 17,
              "2026-03-06": 15,
              "2026-03-07": 1,
              "2026-03-09": 4,
              "2026-03-10": 9,
              "2026-03-11": 16,
              "2026-03-17": 1,
              "2026-03-20": 3,
              "2026-03-23": 14,
              "2026-03-24": 2,
              "2026-03-25": 4,
              "2026-03-30": 3,
              "2026-03-31": 10,
              "2026-04-01": 1,
              "2026-04-07": 1,
              "2026-04-09": 2,
              "2026-04-16": 6,
              "2026-04-20": 3,
              "2026-04-22": 2,
              "2026-04-27": 2,
              "2026-04-29": 10,
              "2026-05-04": 5,
              "2026-05-07": 1,
              "2026-05-14": 1,
              "2026-05-20": 1,
              "2026-05-22": 3,
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 221.89,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "46-48h": 1,
                "78-80h": 1,
                "84-86h": 1,
                "112-114h": 1,
                "120-122h": 1,
                "160-162h": 1,
                "170-172h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "222-224h": 1,
                "1310-1312h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-02-07": 1,
                "2026-02-10": 1,
                "2026-02-18": 2,
                "2026-03-23": 1,
                "2026-03-25": 2,
                "2026-03-31": 1,
                "2026-04-07": 1,
                "2026-04-29": 1,
                "2026-05-04": 2
              },
              "time_per_day": {
                "2026-02-07": 3.7770802777777774,
                "2026-02-10": 79.70536527777777,
                "2026-02-18": 397.51375083333335,
                "2026-03-23": 113.72397638888889,
                "2026-03-25": 207.84017749999998,
                "2026-03-31": 121.01029222222223,
                "2026-04-07": 84.61776333333333,
                "2026-04-29": 172.6751986111111,
                "2026-05-04": 1481.8547769444444
              },
              "time_count_per_day": {
                "2026-02-07": 1,
                "2026-02-10": 1,
                "2026-02-18": 2,
                "2026-03-23": 1,
                "2026-03-25": 2,
                "2026-03-31": 1,
                "2026-04-07": 1,
                "2026-04-29": 1,
                "2026-05-04": 2
              }
            },
            "P2": {
              "avg_time_hours": 149.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 38,
              "time_distribution": {
                "0-2h": 38,
                "2-4h": 7,
                "4-6h": 7,
                "6-8h": 3,
                "8-10h": 3,
                "10-12h": 2,
                "12-14h": 2,
                "14-16h": 10,
                "16-18h": 3,
                "20-22h": 2,
                "22-24h": 5,
                "24-26h": 10,
                "26-28h": 3,
                "28-30h": 5,
                "30-32h": 1,
                "32-34h": 1,
                "34-36h": 7,
                "36-38h": 5,
                "38-40h": 3,
                "40-42h": 2,
                "42-44h": 2,
                "44-46h": 4,
                "46-48h": 1,
                "48-50h": 3,
                "54-56h": 1,
                "62-64h": 3,
                "66-68h": 1,
                "68-70h": 4,
                "72-74h": 5,
                "74-76h": 8,
                "76-78h": 2,
                "78-80h": 1,
                "80-82h": 1,
                "86-88h": 2,
                "90-92h": 2,
                "92-94h": 1,
                "94-96h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "122-124h": 3,
                "124-126h": 1,
                "126-128h": 1,
                "132-134h": 1,
                "134-136h": 1,
                "136-138h": 1,
                "140-142h": 3,
                "144-146h": 3,
                "146-148h": 1,
                "148-150h": 1,
                "154-156h": 1,
                "162-164h": 1,
                "170-172h": 3,
                "180-182h": 1,
                "182-184h": 3,
                "186-188h": 1,
                "190-192h": 1,
                "198-200h": 1,
                "202-204h": 1,
                "214-216h": 1,
                "228-230h": 2,
                "232-234h": 2,
                "236-238h": 1,
                "238-240h": 3,
                "240-242h": 2,
                "244-246h": 3,
                "256-258h": 2,
                "260-262h": 1,
                "268-270h": 2,
                "276-278h": 1,
                "282-284h": 2,
                "284-286h": 4,
                "312-314h": 1,
                "314-316h": 1,
                "316-318h": 1,
                "338-340h": 1,
                "340-342h": 1,
                "342-344h": 1,
                "344-346h": 1,
                "348-350h": 1,
                "354-356h": 1,
                "366-368h": 1,
                "372-374h": 1,
                "374-376h": 1,
                "386-388h": 2,
                "388-390h": 2,
                "392-394h": 1,
                "402-404h": 1,
                "406-408h": 1,
                "416-418h": 2,
                "426-428h": 1,
                "428-430h": 1,
                "434-436h": 1,
                "454-456h": 1,
                "478-480h": 2,
                "514-516h": 1,
                "548-550h": 1,
                "552-554h": 1,
                "644-646h": 1,
                "648-650h": 1,
                "654-656h": 1,
                "742-744h": 1,
                "762-764h": 1,
                "806-808h": 1,
                "864-866h": 1,
                "1036-1038h": 1,
                "1080-1082h": 1,
                "1128-1130h": 1,
                "1252-1254h": 1,
                "1392-1394h": 1
              },
              "tickets_count": 262,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-19": 1,
                "2025-12-03": 2,
                "2025-12-10": 1,
                "2026-01-07": 1,
                "2026-01-08": 23,
                "2026-01-09": 1,
                "2026-01-11": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-16": 8,
                "2026-01-19": 20,
                "2026-01-20": 5,
                "2026-01-22": 8,
                "2026-01-23": 3,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-01-31": 6,
                "2026-02-02": 2,
                "2026-02-03": 13,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-09": 12,
                "2026-02-10": 6,
                "2026-02-12": 1,
                "2026-02-14": 8,
                "2026-02-16": 3,
                "2026-02-17": 1,
                "2026-02-18": 11,
                "2026-02-20": 2,
                "2026-02-21": 3,
                "2026-02-22": 1,
                "2026-02-23": 1,
                "2026-02-24": 5,
                "2026-02-25": 4,
                "2026-03-05": 7,
                "2026-03-06": 13,
                "2026-03-07": 1,
                "2026-03-09": 4,
                "2026-03-10": 9,
                "2026-03-11": 15,
                "2026-03-17": 1,
                "2026-03-20": 2,
                "2026-03-23": 11,
                "2026-03-24": 2,
                "2026-03-25": 2,
                "2026-03-30": 1,
                "2026-03-31": 4,
                "2026-04-01": 1,
                "2026-04-09": 2,
                "2026-04-16": 1,
                "2026-04-20": 2,
                "2026-04-22": 1,
                "2026-04-27": 2,
                "2026-04-29": 6,
                "2026-05-04": 3,
                "2026-05-07": 1,
                "2026-05-14": 1,
                "2026-05-20": 1,
                "2026-05-22": 2,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2025-11-04": 91.49926194444444,
                "2025-11-11": 126.80880111111111,
                "2025-11-14": 1036.9217947222223,
                "2025-11-19": 4.184505277777777,
                "2025-12-03": 397.88330222222226,
                "2025-12-10": 171.3362075,
                "2026-01-07": 54.095234999999995,
                "2026-01-08": 5.2793288888888865,
                "2026-01-09": 1392.7871625,
                "2026-01-11": 1570.273516111111,
                "2026-01-13": 23.39232972222222,
                "2026-01-14": 133.76325972222222,
                "2026-01-16": 206.0520977777778,
                "2026-01-19": 602.7021519444445,
                "2026-01-20": 151.44975388888886,
                "2026-01-22": 778.1317127777779,
                "2026-01-23": 124.3044188888889,
                "2026-01-26": 7.597497777777777,
                "2026-01-28": 5.890578611111111,
                "2026-01-29": 5.556644444444444,
                "2026-01-30": 36.14561944444444,
                "2026-01-31": 130.32139083333334,
                "2026-02-02": 203.8731422222222,
                "2026-02-03": 1015.4411325,
                "2026-02-04": 37.59851888888889,
                "2026-02-05": 178.8529661111111,
                "2026-02-09": 2737.1166224999997,
                "2026-02-10": 1291.8310613888889,
                "2026-02-12": 314.3810136111111,
                "2026-02-14": 85.63634555555556,
                "2026-02-16": 671.2339219444444,
                "2026-02-17": 1.3278127777777777,
                "2026-02-18": 1035.880431388889,
                "2026-02-20": 88.34821944444444,
                "2026-02-21": 72.10717555555556,
                "2026-02-22": 13.70508888888889,
                "2026-02-23": 62.66969111111111,
                "2026-02-24": 67.6964111111111,
                "2026-02-25": 29.4374575,
                "2026-03-05": 2198.474203888889,
                "2026-03-06": 2616.4075530555556,
                "2026-03-07": 62.877425555555554,
                "2026-03-09": 9.962905833333334,
                "2026-03-10": 1122.7556566666665,
                "2026-03-11": 3420.695398055556,
                "2026-03-17": 22.76893472222222,
                "2026-03-20": 1073.1063175,
                "2026-03-23": 3617.7516088888897,
                "2026-03-24": 535.8004411111111,
                "2026-03-25": 187.25182694444447,
                "2026-03-30": 4.865214166666667,
                "2026-03-31": 1142.8218011111112,
                "2026-04-01": 340.28477194444446,
                "2026-04-09": 876.0699622222223,
                "2026-04-16": 48.84182861111111,
                "2026-04-20": 2209.8961827777775,
                "2026-04-22": 183.265175,
                "2026-04-27": 547.2606027777778,
                "2026-04-29": 2726.304171111111,
                "2026-05-04": 181.60028888888888,
                "2026-05-07": 4.809958611111111,
                "2026-05-14": 0.5579908333333333,
                "2026-05-20": 20.308903055555557,
                "2026-05-22": 327.8274616666667,
                "2026-05-28": 743.8173119444444
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-19": 1,
                "2025-12-03": 2,
                "2025-12-10": 1,
                "2026-01-07": 1,
                "2026-01-08": 23,
                "2026-01-09": 1,
                "2026-01-11": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-16": 8,
                "2026-01-19": 20,
                "2026-01-20": 5,
                "2026-01-22": 8,
                "2026-01-23": 3,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-01-31": 6,
                "2026-02-02": 2,
                "2026-02-03": 13,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-09": 12,
                "2026-02-10": 6,
                "2026-02-12": 1,
                "2026-02-14": 8,
                "2026-02-16": 3,
                "2026-02-17": 1,
                "2026-02-18": 11,
                "2026-02-20": 2,
                "2026-02-21": 3,
                "2026-02-22": 1,
                "2026-02-23": 1,
                "2026-02-24": 5,
                "2026-02-25": 4,
                "2026-03-05": 7,
                "2026-03-06": 13,
                "2026-03-07": 1,
                "2026-03-09": 4,
                "2026-03-10": 9,
                "2026-03-11": 15,
                "2026-03-17": 1,
                "2026-03-20": 2,
                "2026-03-23": 11,
                "2026-03-24": 2,
                "2026-03-25": 2,
                "2026-03-30": 1,
                "2026-03-31": 4,
                "2026-04-01": 1,
                "2026-04-09": 2,
                "2026-04-16": 1,
                "2026-04-20": 2,
                "2026-04-22": 1,
                "2026-04-27": 2,
                "2026-04-29": 6,
                "2026-05-04": 3,
                "2026-05-07": 1,
                "2026-05-14": 1,
                "2026-05-20": 1,
                "2026-05-22": 2,
                "2026-05-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 91.13,
              "mode_time_hours": 23.0,
              "mode_frequency": 34,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 7,
                "4-6h": 12,
                "6-8h": 15,
                "8-10h": 15,
                "10-12h": 5,
                "12-14h": 21,
                "14-16h": 24,
                "16-18h": 15,
                "18-20h": 26,
                "20-22h": 19,
                "22-24h": 34,
                "24-26h": 22,
                "26-28h": 15,
                "28-30h": 5,
                "30-32h": 31,
                "32-34h": 14,
                "34-36h": 5,
                "36-38h": 6,
                "38-40h": 4,
                "40-42h": 3,
                "42-44h": 10,
                "44-46h": 11,
                "46-48h": 8,
                "48-50h": 10,
                "50-52h": 8,
                "52-54h": 2,
                "54-56h": 5,
                "56-58h": 15,
                "58-60h": 5,
                "60-62h": 13,
                "62-64h": 13,
                "64-66h": 4,
                "66-68h": 7,
                "68-70h": 4,
                "70-72h": 3,
                "72-74h": 9,
                "74-76h": 7,
                "76-78h": 9,
                "78-80h": 8,
                "80-82h": 5,
                "82-84h": 7,
                "84-86h": 8,
                "86-88h": 7,
                "88-90h": 2,
                "92-94h": 5,
                "94-96h": 3,
                "96-98h": 2,
                "98-100h": 1,
                "100-102h": 2,
                "104-106h": 4,
                "110-112h": 1,
                "114-116h": 1,
                "116-118h": 3,
                "118-120h": 3,
                "120-122h": 1,
                "122-124h": 2,
                "124-126h": 3,
                "126-128h": 5,
                "128-130h": 3,
                "132-134h": 1,
                "136-138h": 1,
                "138-140h": 2,
                "140-142h": 1,
                "142-144h": 3,
                "144-146h": 2,
                "146-148h": 1,
                "148-150h": 2,
                "154-156h": 1,
                "162-164h": 1,
                "164-166h": 1,
                "168-170h": 2,
                "170-172h": 3,
                "176-178h": 1,
                "190-192h": 1,
                "208-210h": 1,
                "210-212h": 1,
                "218-220h": 1,
                "220-222h": 3,
                "234-236h": 1,
                "254-256h": 1,
                "256-258h": 1,
                "268-270h": 1,
                "288-290h": 1,
                "290-292h": 1,
                "292-294h": 1,
                "304-306h": 1,
                "308-310h": 1,
                "310-312h": 1,
                "316-318h": 2,
                "334-336h": 1,
                "354-356h": 1,
                "366-368h": 1,
                "368-370h": 1,
                "378-380h": 1,
                "386-388h": 1,
                "454-456h": 1,
                "458-460h": 1,
                "472-474h": 1,
                "478-480h": 1,
                "496-498h": 1,
                "506-508h": 1,
                "510-512h": 1,
                "526-528h": 2,
                "546-548h": 1,
                "548-550h": 1,
                "560-562h": 1,
                "576-578h": 1,
                "578-580h": 1,
                "594-596h": 1,
                "612-614h": 1,
                "682-684h": 1,
                "714-716h": 1,
                "794-796h": 1,
                "844-846h": 1,
                "848-850h": 1,
                "850-852h": 1,
                "1030-1032h": 1,
                "1032-1034h": 1,
                "1034-1036h": 1,
                "1306-1308h": 1,
                "2160-2162h": 1,
                "2392-2394h": 1
              },
              "tickets_count": 600,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-18": 1,
                "2025-12-02": 1,
                "2025-12-10": 2,
                "2026-01-07": 8,
                "2026-01-08": 1,
                "2026-01-11": 2,
                "2026-01-12": 1,
                "2026-01-13": 21,
                "2026-01-14": 7,
                "2026-01-15": 46,
                "2026-01-16": 11,
                "2026-01-17": 11,
                "2026-01-19": 13,
                "2026-01-20": 5,
                "2026-01-22": 23,
                "2026-01-23": 15,
                "2026-01-26": 8,
                "2026-01-27": 46,
                "2026-01-28": 42,
                "2026-01-29": 12,
                "2026-01-31": 12,
                "2026-02-03": 58,
                "2026-02-05": 11,
                "2026-02-06": 7,
                "2026-02-07": 32,
                "2026-02-09": 21,
                "2026-02-10": 29,
                "2026-02-12": 11,
                "2026-02-14": 52,
                "2026-02-16": 9,
                "2026-02-17": 2,
                "2026-02-18": 24,
                "2026-02-19": 4,
                "2026-02-20": 15,
                "2026-02-22": 1,
                "2026-02-23": 1,
                "2026-03-05": 10,
                "2026-03-06": 2,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-03-30": 2,
                "2026-03-31": 5,
                "2026-04-16": 5,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-29": 3,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2025-11-06": 0.4233675,
                "2025-11-18": 139.55627805555557,
                "2025-12-02": 162.58090083333335,
                "2025-12-10": 454.60250166666674,
                "2026-01-07": 4429.832889166667,
                "2026-01-08": 1.8367327777777778,
                "2026-01-11": 2158.7774994444444,
                "2026-01-12": 12.020579444444445,
                "2026-01-13": 234.70679027777777,
                "2026-01-14": 98.37822194444446,
                "2026-01-15": 3132.5359427777776,
                "2026-01-16": 311.7859105555556,
                "2026-01-17": 245.48245416666666,
                "2026-01-19": 861.1831308333334,
                "2026-01-20": 146.161875,
                "2026-01-22": 960.577355,
                "2026-01-23": 517.1533977777777,
                "2026-01-26": 666.8905627777779,
                "2026-01-27": 2196.7036344444446,
                "2026-01-28": 960.1206444444447,
                "2026-01-29": 161.3212161111111,
                "2026-01-31": 341.60423333333335,
                "2026-02-03": 2732.025938055556,
                "2026-02-05": 694.0647647222223,
                "2026-02-06": 356.4887563888889,
                "2026-02-07": 2263.236561388889,
                "2026-02-09": 1975.0093266666668,
                "2026-02-10": 1705.3732574999997,
                "2026-02-12": 623.808906111111,
                "2026-02-14": 2428.6324786111118,
                "2026-02-16": 1487.6399291666664,
                "2026-02-17": 294.7828938888889,
                "2026-02-18": 3320.185818888889,
                "2026-02-19": 149.6290072222222,
                "2026-02-20": 1575.2236622222222,
                "2026-02-22": 29.831705277777775,
                "2026-02-23": 73.6694263888889,
                "2026-03-05": 4149.2742358333335,
                "2026-03-06": 420.50686777777776,
                "2026-03-11": 714.0337830555555,
                "2026-03-20": 613.0662947222222,
                "2026-03-23": 1345.8612175,
                "2026-03-30": 1052.2361569444445,
                "2026-03-31": 1320.1386488888893,
                "2026-04-16": 188.34848194444447,
                "2026-04-20": 844.6789738888889,
                "2026-04-22": 2392.5030391666664,
                "2026-04-29": 3208.853951944445,
                "2026-05-22": 526.3828397222222
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-18": 1,
                "2025-12-02": 1,
                "2025-12-10": 2,
                "2026-01-07": 8,
                "2026-01-08": 1,
                "2026-01-11": 2,
                "2026-01-12": 1,
                "2026-01-13": 21,
                "2026-01-14": 7,
                "2026-01-15": 46,
                "2026-01-16": 11,
                "2026-01-17": 11,
                "2026-01-19": 13,
                "2026-01-20": 5,
                "2026-01-22": 23,
                "2026-01-23": 15,
                "2026-01-26": 8,
                "2026-01-27": 46,
                "2026-01-28": 42,
                "2026-01-29": 12,
                "2026-01-31": 12,
                "2026-02-03": 58,
                "2026-02-05": 11,
                "2026-02-06": 7,
                "2026-02-07": 32,
                "2026-02-09": 21,
                "2026-02-10": 29,
                "2026-02-12": 11,
                "2026-02-14": 52,
                "2026-02-16": 9,
                "2026-02-17": 2,
                "2026-02-18": 24,
                "2026-02-19": 4,
                "2026-02-20": 15,
                "2026-02-22": 1,
                "2026-02-23": 1,
                "2026-03-05": 10,
                "2026-03-06": 2,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-03-30": 2,
                "2026-03-31": 5,
                "2026-04-16": 5,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-29": 3,
                "2026-05-22": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 21.58,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "24-26h": 1,
                "28-30h": 1,
                "30-32h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-22": 1,
                "2026-02-03": 3
              },
              "time_per_day": {
                "2026-01-22": 24.323317777777778,
                "2026-02-03": 61.99218916666666
              },
              "time_count_per_day": {
                "2026-01-22": 1,
                "2026-02-03": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 2125.39,
              "mode_time_hours": 2125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2124-2126h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 2125.389347777778
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 30,
            "tickets_per_day": {
              "2026-01-16": 1,
              "2026-02-20": 1,
              "2026-03-03": 1,
              "2026-03-26": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-22": 1,
              "2026-04-23": 3,
              "2026-04-27": 1,
              "2026-04-28": 2,
              "2026-05-03": 1,
              "2026-05-04": 2,
              "2026-05-07": 2,
              "2026-05-11": 1,
              "2026-05-13": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-21": 2,
              "2026-05-28": 1,
              "2026-05-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 22,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-03-26": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-27": 1,
                "2026-05-03": 1,
                "2026-05-04": 2,
                "2026-05-07": 1,
                "2026-05-13": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-21": 2,
                "2026-05-28": 1,
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-20": 1,
                "2026-04-13": 1,
                "2026-04-28": 1,
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Rafaela Lapa": {
      "overall": {
        "avg_time_hours": 29.74,
        "mode_time_hours": 1.0,
        "mode_frequency": 31,
        "time_distribution": {
          "0-2h": 31,
          "2-4h": 7,
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 2,
          "10-12h": 2,
          "20-22h": 1,
          "24-26h": 2,
          "26-28h": 2,
          "30-32h": 1,
          "34-36h": 1,
          "40-42h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "56-58h": 1,
          "94-96h": 1,
          "112-114h": 1,
          "134-136h": 1,
          "138-140h": 1,
          "144-146h": 1,
          "162-164h": 1,
          "184-186h": 1,
          "208-210h": 1,
          "218-220h": 1
        },
        "tickets_count": 65,
        "tickets_per_day": {
          "2025-10-06": 3,
          "2025-10-12": 1,
          "2025-10-13": 3,
          "2025-10-20": 4,
          "2025-10-21": 1,
          "2025-10-22": 2,
          "2025-10-24": 1,
          "2025-10-27": 3,
          "2025-10-28": 5,
          "2025-11-03": 2,
          "2025-11-10": 3,
          "2025-11-12": 7,
          "2025-11-13": 1,
          "2025-11-17": 7,
          "2025-11-23": 4,
          "2025-11-24": 1,
          "2025-12-01": 2,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2025-12-08": 2,
          "2025-12-09": 3,
          "2025-12-10": 2,
          "2025-12-12": 3,
          "2025-12-15": 2
        },
        "time_per_day": {
          "2025-10-06": 2.773993055555555,
          "2025-10-12": 209.2571233333333,
          "2025-10-13": 11.972901666666665,
          "2025-10-20": 10.622575833333334,
          "2025-10-21": 46.64482583333333,
          "2025-10-22": 49.920585833333334,
          "2025-10-24": 2.178645,
          "2025-10-27": 11.430916944444443,
          "2025-10-28": 1.5647405555555554,
          "2025-11-03": 57.62543527777778,
          "2025-11-10": 42.286285,
          "2025-11-12": 14.866360833333333,
          "2025-11-13": 48.98876277777778,
          "2025-11-17": 94.18220972222221,
          "2025-11-23": 622.4367611111111,
          "2025-11-24": 95.49299944444445,
          "2025-12-01": 13.044408055555555,
          "2025-12-02": 30.79812805555556,
          "2025-12-03": 21.43753138888889,
          "2025-12-08": 12.451605,
          "2025-12-09": 172.1256663888889,
          "2025-12-10": 28.720841666666665,
          "2025-12-12": 331.66118361111114,
          "2025-12-15": 0.5181977777777778
        },
        "time_count_per_day": {
          "2025-10-06": 3,
          "2025-10-12": 1,
          "2025-10-13": 3,
          "2025-10-20": 4,
          "2025-10-21": 1,
          "2025-10-22": 2,
          "2025-10-24": 1,
          "2025-10-27": 3,
          "2025-10-28": 5,
          "2025-11-03": 2,
          "2025-11-10": 3,
          "2025-11-12": 7,
          "2025-11-13": 1,
          "2025-11-17": 7,
          "2025-11-23": 4,
          "2025-11-24": 1,
          "2025-12-01": 2,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2025-12-08": 2,
          "2025-12-09": 3,
          "2025-12-10": 2,
          "2025-12-12": 3,
          "2025-12-15": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-13": 1.3364169444444443,
            "2025-10-28": 0.7114563888888888
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-10-28": 1
          }
        },
        "P2": {
          "avg_time_hours": 23.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 26,
          "time_distribution": {
            "0-2h": 26,
            "2-4h": 5,
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 2,
            "10-12h": 2,
            "24-26h": 2,
            "26-28h": 2,
            "40-42h": 1,
            "46-48h": 1,
            "48-50h": 2,
            "56-58h": 1,
            "134-136h": 1,
            "138-140h": 1,
            "144-146h": 1,
            "162-164h": 1,
            "184-186h": 1
          },
          "tickets_count": 51,
          "tickets_per_day": {
            "2025-10-06": 3,
            "2025-10-13": 2,
            "2025-10-20": 4,
            "2025-10-21": 1,
            "2025-10-22": 2,
            "2025-10-24": 1,
            "2025-10-27": 3,
            "2025-10-28": 4,
            "2025-11-03": 1,
            "2025-11-10": 3,
            "2025-11-12": 6,
            "2025-11-13": 1,
            "2025-11-17": 5,
            "2025-11-23": 4,
            "2025-12-01": 1,
            "2025-12-02": 1,
            "2025-12-08": 2,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-15": 2
          },
          "time_per_day": {
            "2025-10-06": 2.773993055555555,
            "2025-10-13": 10.636484722222221,
            "2025-10-20": 10.622575833333334,
            "2025-10-21": 46.64482583333333,
            "2025-10-22": 49.920585833333334,
            "2025-10-24": 2.178645,
            "2025-10-27": 11.430916944444443,
            "2025-10-28": 0.8532841666666666,
            "2025-11-03": 25.982532222222222,
            "2025-11-10": 42.286285,
            "2025-11-12": 11.246934166666666,
            "2025-11-13": 48.98876277777778,
            "2025-11-17": 58.06987000000001,
            "2025-11-23": 622.4367611111111,
            "2025-12-01": 11.609512222222222,
            "2025-12-02": 27.692730833333336,
            "2025-12-08": 12.451605,
            "2025-12-09": 172.1256663888889,
            "2025-12-10": 28.720841666666665,
            "2025-12-15": 0.5181977777777778
          },
          "time_count_per_day": {
            "2025-10-06": 3,
            "2025-10-13": 2,
            "2025-10-20": 4,
            "2025-10-21": 1,
            "2025-10-22": 2,
            "2025-10-24": 1,
            "2025-10-27": 3,
            "2025-10-28": 4,
            "2025-11-03": 1,
            "2025-11-10": 3,
            "2025-11-12": 6,
            "2025-11-13": 1,
            "2025-11-17": 5,
            "2025-11-23": 4,
            "2025-12-01": 1,
            "2025-12-02": 1,
            "2025-12-08": 2,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-15": 2
          }
        },
        "P3": {
          "avg_time_hours": 61.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "20-22h": 1,
            "30-32h": 1,
            "34-36h": 1,
            "94-96h": 1,
            "112-114h": 1,
            "208-210h": 1,
            "218-220h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-10-12": 1,
            "2025-11-03": 1,
            "2025-11-12": 1,
            "2025-11-17": 2,
            "2025-11-24": 1,
            "2025-12-01": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-12": 3
          },
          "time_per_day": {
            "2025-10-12": 209.2571233333333,
            "2025-11-03": 31.642903055555557,
            "2025-11-12": 3.6194266666666666,
            "2025-11-17": 36.112339722222224,
            "2025-11-24": 95.49299944444445,
            "2025-12-01": 1.4348958333333333,
            "2025-12-02": 3.1053972222222224,
            "2025-12-03": 21.43753138888889,
            "2025-12-12": 331.66118361111114
          },
          "time_count_per_day": {
            "2025-10-12": 1,
            "2025-11-03": 1,
            "2025-11-12": 1,
            "2025-11-17": 2,
            "2025-11-24": 1,
            "2025-12-01": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-12": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.74,
            "mode_time_hours": 1.0,
            "mode_frequency": 31,
            "time_distribution": {
              "0-2h": 31,
              "2-4h": 7,
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 2,
              "10-12h": 2,
              "20-22h": 1,
              "24-26h": 2,
              "26-28h": 2,
              "30-32h": 1,
              "34-36h": 1,
              "40-42h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "56-58h": 1,
              "94-96h": 1,
              "112-114h": 1,
              "134-136h": 1,
              "138-140h": 1,
              "144-146h": 1,
              "162-164h": 1,
              "184-186h": 1,
              "208-210h": 1,
              "218-220h": 1
            },
            "tickets_count": 65,
            "tickets_per_day": {
              "2025-10-06": 3,
              "2025-10-12": 1,
              "2025-10-13": 3,
              "2025-10-20": 4,
              "2025-10-21": 1,
              "2025-10-22": 2,
              "2025-10-24": 1,
              "2025-10-27": 3,
              "2025-10-28": 5,
              "2025-11-03": 2,
              "2025-11-10": 3,
              "2025-11-12": 7,
              "2025-11-13": 1,
              "2025-11-17": 7,
              "2025-11-23": 4,
              "2025-11-24": 1,
              "2025-12-01": 2,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2025-12-08": 2,
              "2025-12-09": 3,
              "2025-12-10": 2,
              "2025-12-12": 3,
              "2025-12-15": 2
            },
            "time_per_day": {
              "2025-10-06": 2.773993055555555,
              "2025-10-12": 209.2571233333333,
              "2025-10-13": 11.972901666666665,
              "2025-10-20": 10.622575833333334,
              "2025-10-21": 46.64482583333333,
              "2025-10-22": 49.920585833333334,
              "2025-10-24": 2.178645,
              "2025-10-27": 11.430916944444443,
              "2025-10-28": 1.5647405555555554,
              "2025-11-03": 57.62543527777778,
              "2025-11-10": 42.286285,
              "2025-11-12": 14.866360833333333,
              "2025-11-13": 48.98876277777778,
              "2025-11-17": 94.18220972222221,
              "2025-11-23": 622.4367611111111,
              "2025-11-24": 95.49299944444445,
              "2025-12-01": 13.044408055555555,
              "2025-12-02": 30.79812805555556,
              "2025-12-03": 21.43753138888889,
              "2025-12-08": 12.451605,
              "2025-12-09": 172.1256663888889,
              "2025-12-10": 28.720841666666665,
              "2025-12-12": 331.66118361111114,
              "2025-12-15": 0.5181977777777778
            },
            "time_count_per_day": {
              "2025-10-06": 3,
              "2025-10-12": 1,
              "2025-10-13": 3,
              "2025-10-20": 4,
              "2025-10-21": 1,
              "2025-10-22": 2,
              "2025-10-24": 1,
              "2025-10-27": 3,
              "2025-10-28": 5,
              "2025-11-03": 2,
              "2025-11-10": 3,
              "2025-11-12": 7,
              "2025-11-13": 1,
              "2025-11-17": 7,
              "2025-11-23": 4,
              "2025-11-24": 1,
              "2025-12-01": 2,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2025-12-08": 2,
              "2025-12-09": 3,
              "2025-12-10": 2,
              "2025-12-12": 3,
              "2025-12-15": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-13": 1.3364169444444443,
                "2025-10-28": 0.7114563888888888
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-10-28": 1
              }
            },
            "P2": {
              "avg_time_hours": 23.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 26,
              "time_distribution": {
                "0-2h": 26,
                "2-4h": 5,
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 2,
                "10-12h": 2,
                "24-26h": 2,
                "26-28h": 2,
                "40-42h": 1,
                "46-48h": 1,
                "48-50h": 2,
                "56-58h": 1,
                "134-136h": 1,
                "138-140h": 1,
                "144-146h": 1,
                "162-164h": 1,
                "184-186h": 1
              },
              "tickets_count": 51,
              "tickets_per_day": {
                "2025-10-06": 3,
                "2025-10-13": 2,
                "2025-10-20": 4,
                "2025-10-21": 1,
                "2025-10-22": 2,
                "2025-10-24": 1,
                "2025-10-27": 3,
                "2025-10-28": 4,
                "2025-11-03": 1,
                "2025-11-10": 3,
                "2025-11-12": 6,
                "2025-11-13": 1,
                "2025-11-17": 5,
                "2025-11-23": 4,
                "2025-12-01": 1,
                "2025-12-02": 1,
                "2025-12-08": 2,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-15": 2
              },
              "time_per_day": {
                "2025-10-06": 2.773993055555555,
                "2025-10-13": 10.636484722222221,
                "2025-10-20": 10.622575833333334,
                "2025-10-21": 46.64482583333333,
                "2025-10-22": 49.920585833333334,
                "2025-10-24": 2.178645,
                "2025-10-27": 11.430916944444443,
                "2025-10-28": 0.8532841666666666,
                "2025-11-03": 25.982532222222222,
                "2025-11-10": 42.286285,
                "2025-11-12": 11.246934166666666,
                "2025-11-13": 48.98876277777778,
                "2025-11-17": 58.06987000000001,
                "2025-11-23": 622.4367611111111,
                "2025-12-01": 11.609512222222222,
                "2025-12-02": 27.692730833333336,
                "2025-12-08": 12.451605,
                "2025-12-09": 172.1256663888889,
                "2025-12-10": 28.720841666666665,
                "2025-12-15": 0.5181977777777778
              },
              "time_count_per_day": {
                "2025-10-06": 3,
                "2025-10-13": 2,
                "2025-10-20": 4,
                "2025-10-21": 1,
                "2025-10-22": 2,
                "2025-10-24": 1,
                "2025-10-27": 3,
                "2025-10-28": 4,
                "2025-11-03": 1,
                "2025-11-10": 3,
                "2025-11-12": 6,
                "2025-11-13": 1,
                "2025-11-17": 5,
                "2025-11-23": 4,
                "2025-12-01": 1,
                "2025-12-02": 1,
                "2025-12-08": 2,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-15": 2
              }
            },
            "P3": {
              "avg_time_hours": 61.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "20-22h": 1,
                "30-32h": 1,
                "34-36h": 1,
                "94-96h": 1,
                "112-114h": 1,
                "208-210h": 1,
                "218-220h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-12": 1,
                "2025-11-03": 1,
                "2025-11-12": 1,
                "2025-11-17": 2,
                "2025-11-24": 1,
                "2025-12-01": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-12": 3
              },
              "time_per_day": {
                "2025-10-12": 209.2571233333333,
                "2025-11-03": 31.642903055555557,
                "2025-11-12": 3.6194266666666666,
                "2025-11-17": 36.112339722222224,
                "2025-11-24": 95.49299944444445,
                "2025-12-01": 1.4348958333333333,
                "2025-12-02": 3.1053972222222224,
                "2025-12-03": 21.43753138888889,
                "2025-12-12": 331.66118361111114
              },
              "time_count_per_day": {
                "2025-10-12": 1,
                "2025-11-03": 1,
                "2025-11-12": 1,
                "2025-11-17": 2,
                "2025-11-24": 1,
                "2025-12-01": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-12": 3
              }
            }
          }
        }
      }
    },
    "Débora Pinto": {
      "overall": {
        "avg_time_hours": 160.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 286,
        "time_distribution": {
          "0-2h": 286,
          "2-4h": 67,
          "4-6h": 23,
          "6-8h": 24,
          "8-10h": 9,
          "10-12h": 9,
          "12-14h": 9,
          "14-16h": 6,
          "16-18h": 16,
          "18-20h": 17,
          "20-22h": 15,
          "22-24h": 18,
          "24-26h": 10,
          "26-28h": 7,
          "28-30h": 15,
          "30-32h": 2,
          "32-34h": 2,
          "34-36h": 1,
          "38-40h": 2,
          "40-42h": 2,
          "42-44h": 7,
          "44-46h": 3,
          "48-50h": 7,
          "50-52h": 3,
          "52-54h": 1,
          "58-60h": 2,
          "64-66h": 1,
          "66-68h": 2,
          "68-70h": 4,
          "70-72h": 6,
          "72-74h": 9,
          "74-76h": 6,
          "76-78h": 1,
          "84-86h": 4,
          "86-88h": 1,
          "88-90h": 1,
          "90-92h": 1,
          "92-94h": 1,
          "94-96h": 3,
          "96-98h": 1,
          "98-100h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "104-106h": 2,
          "112-114h": 3,
          "114-116h": 1,
          "116-118h": 1,
          "118-120h": 1,
          "120-122h": 3,
          "122-124h": 1,
          "124-126h": 1,
          "126-128h": 1,
          "128-130h": 1,
          "136-138h": 1,
          "138-140h": 2,
          "140-142h": 1,
          "142-144h": 1,
          "144-146h": 1,
          "146-148h": 1,
          "148-150h": 1,
          "160-162h": 1,
          "162-164h": 1,
          "168-170h": 3,
          "170-172h": 2,
          "172-174h": 1,
          "190-192h": 3,
          "192-194h": 2,
          "194-196h": 2,
          "196-198h": 2,
          "198-200h": 1,
          "210-212h": 1,
          "212-214h": 2,
          "216-218h": 1,
          "218-220h": 1,
          "222-224h": 2,
          "226-228h": 2,
          "240-242h": 1,
          "246-248h": 2,
          "248-250h": 1,
          "252-254h": 1,
          "256-258h": 1,
          "260-262h": 1,
          "262-264h": 1,
          "264-266h": 1,
          "270-272h": 2,
          "272-274h": 1,
          "280-282h": 1,
          "282-284h": 1,
          "306-308h": 1,
          "308-310h": 1,
          "332-334h": 1,
          "334-336h": 2,
          "336-338h": 3,
          "338-340h": 4,
          "340-342h": 2,
          "348-350h": 1,
          "350-352h": 1,
          "352-354h": 1,
          "354-356h": 1,
          "356-358h": 1,
          "362-364h": 1,
          "364-366h": 1,
          "366-368h": 1,
          "372-374h": 2,
          "382-384h": 1,
          "388-390h": 2,
          "398-400h": 1,
          "402-404h": 1,
          "404-406h": 4,
          "406-408h": 1,
          "408-410h": 2,
          "410-412h": 1,
          "412-414h": 2,
          "430-432h": 1,
          "446-448h": 1,
          "456-458h": 1,
          "460-462h": 1,
          "478-480h": 2,
          "480-482h": 1,
          "482-484h": 1,
          "492-494h": 1,
          "496-498h": 2,
          "502-504h": 1,
          "504-506h": 1,
          "508-510h": 1,
          "510-512h": 1,
          "512-514h": 1,
          "514-516h": 1,
          "522-524h": 1,
          "526-528h": 1,
          "528-530h": 1,
          "532-534h": 2,
          "546-548h": 1,
          "560-562h": 1,
          "566-568h": 1,
          "576-578h": 1,
          "582-584h": 2,
          "592-594h": 1,
          "612-614h": 1,
          "622-624h": 1,
          "634-636h": 1,
          "638-640h": 1,
          "648-650h": 2,
          "650-652h": 1,
          "652-654h": 1,
          "672-674h": 1,
          "682-684h": 1,
          "696-698h": 1,
          "698-700h": 1,
          "702-704h": 1,
          "730-732h": 2,
          "766-768h": 1,
          "800-802h": 3,
          "810-812h": 1,
          "818-820h": 2,
          "822-824h": 1,
          "844-846h": 1,
          "850-852h": 1,
          "854-856h": 1,
          "860-862h": 1,
          "864-866h": 1,
          "866-868h": 1,
          "896-898h": 1,
          "922-924h": 1,
          "938-940h": 1,
          "968-970h": 1,
          "970-972h": 1,
          "986-988h": 2,
          "1000-1002h": 1,
          "1002-1004h": 1,
          "1012-1014h": 1,
          "1032-1034h": 1,
          "1052-1054h": 1,
          "1086-1088h": 1,
          "1144-1146h": 1,
          "1200-1202h": 2,
          "1224-1226h": 1,
          "1336-1338h": 1,
          "1476-1478h": 1,
          "1480-1482h": 1,
          "1514-1516h": 1,
          "1556-1558h": 1,
          "1582-1584h": 1,
          "1732-1734h": 1,
          "1786-1788h": 1,
          "1852-1854h": 1,
          "2008-2010h": 1,
          "2182-2184h": 1,
          "2280-2282h": 1,
          "2304-2306h": 1,
          "2350-2352h": 1,
          "2374-2376h": 1,
          "2390-2392h": 1,
          "2524-2526h": 2,
          "2534-2536h": 1,
          "2560-2562h": 1
        },
        "tickets_count": 972,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-14": 1,
          "2025-12-04": 1,
          "2025-12-15": 1,
          "2026-01-05": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-13": 5,
          "2026-02-14": 5,
          "2026-02-16": 7,
          "2026-02-17": 3,
          "2026-02-18": 18,
          "2026-02-19": 10,
          "2026-02-20": 4,
          "2026-02-21": 29,
          "2026-02-24": 4,
          "2026-02-25": 10,
          "2026-02-26": 3,
          "2026-02-27": 1,
          "2026-02-28": 6,
          "2026-03-02": 3,
          "2026-03-03": 9,
          "2026-03-04": 6,
          "2026-03-05": 13,
          "2026-03-06": 7,
          "2026-03-07": 16,
          "2026-03-08": 2,
          "2026-03-09": 2,
          "2026-03-10": 13,
          "2026-03-11": 5,
          "2026-03-12": 20,
          "2026-03-13": 5,
          "2026-03-14": 8,
          "2026-03-16": 4,
          "2026-03-17": 7,
          "2026-03-18": 7,
          "2026-03-19": 9,
          "2026-03-20": 41,
          "2026-03-22": 1,
          "2026-03-23": 1,
          "2026-03-24": 9,
          "2026-03-25": 5,
          "2026-03-26": 13,
          "2026-03-27": 5,
          "2026-03-28": 9,
          "2026-03-29": 1,
          "2026-03-30": 1,
          "2026-03-31": 16,
          "2026-04-01": 8,
          "2026-04-02": 9,
          "2026-04-04": 8,
          "2026-04-06": 13,
          "2026-04-07": 6,
          "2026-04-08": 6,
          "2026-04-10": 21,
          "2026-04-11": 9,
          "2026-04-13": 1,
          "2026-04-14": 17,
          "2026-04-15": 9,
          "2026-04-16": 48,
          "2026-04-17": 40,
          "2026-04-18": 1,
          "2026-04-20": 14,
          "2026-04-21": 15,
          "2026-04-22": 11,
          "2026-04-23": 8,
          "2026-04-24": 10,
          "2026-04-26": 1,
          "2026-04-27": 3,
          "2026-04-28": 12,
          "2026-04-29": 21,
          "2026-04-30": 9,
          "2026-05-04": 11,
          "2026-05-05": 8,
          "2026-05-06": 19,
          "2026-05-07": 22,
          "2026-05-08": 3,
          "2026-05-09": 10,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-18": 10,
          "2026-05-19": 13,
          "2026-05-20": 13,
          "2026-05-21": 16,
          "2026-05-22": 23,
          "2026-05-23": 13,
          "2026-05-25": 20,
          "2026-05-26": 32,
          "2026-05-27": 9,
          "2026-05-28": 23,
          "2026-05-29": 23,
          "2026-06-01": 8,
          "2026-06-02": 14,
          "2026-06-03": 15,
          "2026-06-05": 2,
          "2026-06-06": 1,
          "2026-06-08": 5
        },
        "time_per_day": {
          "2025-12-04": 1224.5898944444446,
          "2025-12-15": 479.98042166666664,
          "2026-01-14": 42.92236694444445,
          "2026-02-03": 1476.9555258333335,
          "2026-02-11": 5.3686847222222225,
          "2026-02-12": 75.16169416666666,
          "2026-02-13": 1287.5534830555557,
          "2026-02-14": 2783.9741319444447,
          "2026-02-16": 2031.6483583333334,
          "2026-02-17": 4.999691111111111,
          "2026-02-18": 14170.950523055555,
          "2026-02-19": 5095.4785458333345,
          "2026-02-20": 227.7058144444444,
          "2026-02-21": 1008.8304463888891,
          "2026-02-24": 745.9152122222222,
          "2026-02-25": 217.71209444444443,
          "2026-02-26": 12.96091388888889,
          "2026-02-27": 28.417183611111113,
          "2026-02-28": 457.0938536111111,
          "2026-03-02": 0.6003283333333332,
          "2026-03-03": 39.984950000000005,
          "2026-03-04": 414.4525430555555,
          "2026-03-05": 359.3319955555555,
          "2026-03-06": 33.65053944444444,
          "2026-03-07": 374.6373825,
          "2026-03-08": 0.020296944444444444,
          "2026-03-09": 687.1093488888889,
          "2026-03-10": 2919.6150097222217,
          "2026-03-11": 82.05425305555555,
          "2026-03-12": 3837.114968333333,
          "2026-03-13": 389.0923891666667,
          "2026-03-14": 53.3002438888889,
          "2026-03-16": 535.0469802777778,
          "2026-03-17": 673.0699958333333,
          "2026-03-18": 47.41389916666667,
          "2026-03-19": 338.1378311111111,
          "2026-03-20": 15552.488163888884,
          "2026-03-22": 196.89580444444442,
          "2026-03-24": 1104.1625513888891,
          "2026-03-25": 9.0508725,
          "2026-03-26": 1682.9482991666664,
          "2026-03-27": 63.761807777777776,
          "2026-03-28": 65.8983575,
          "2026-03-29": 17.501973055555556,
          "2026-03-31": 1157.8508652777778,
          "2026-04-01": 320.55235972222226,
          "2026-04-02": 83.06752861111109,
          "2026-04-04": 87.07294638888888,
          "2026-04-06": 634.0519472222222,
          "2026-04-07": 287.3435213888889,
          "2026-04-08": 538.5730663888887,
          "2026-04-10": 4644.408684166668,
          "2026-04-11": 66.36803583333334,
          "2026-04-14": 4238.620706111112,
          "2026-04-15": 517.3059663888889,
          "2026-04-16": 27638.286584444442,
          "2026-04-17": 7043.936267222221,
          "2026-04-20": 1108.8984669444444,
          "2026-04-21": 841.0857513888892,
          "2026-04-22": 2848.719221944444,
          "2026-04-23": 149.9428405555556,
          "2026-04-24": 30.51744611111111,
          "2026-04-26": 766.8327555555555,
          "2026-04-27": 150.0131225,
          "2026-04-28": 2909.42143,
          "2026-04-29": 1239.5130508333332,
          "2026-04-30": 461.0119027777777,
          "2026-05-04": 993.2139824999998,
          "2026-05-05": 1089.4499669444444,
          "2026-05-06": 3042.5427402777773,
          "2026-05-07": 781.5411113888889,
          "2026-05-08": 17.72205194444444,
          "2026-05-09": 518.0400675,
          "2026-05-14": 6.616233888888889,
          "2026-05-18": 465.06282472222216,
          "2026-05-19": 88.38509694444444,
          "2026-05-20": 233.76011944444446,
          "2026-05-21": 226.44245083333328,
          "2026-05-22": 159.09073749999996,
          "2026-05-23": 231.94806611111113,
          "2026-05-25": 941.9781050000001,
          "2026-05-26": 312.84538222222244,
          "2026-05-27": 79.39878027777776,
          "2026-05-28": 9.907505555555556,
          "2026-05-29": 226.82706944444445,
          "2026-06-01": 14.207236666666667,
          "2026-06-02": 335.20296611111115,
          "2026-06-03": 84.77990861111113,
          "2026-06-05": 68.87973111111111,
          "2026-06-08": 280.95521055555554
        },
        "time_count_per_day": {
          "2025-12-04": 1,
          "2025-12-15": 1,
          "2026-01-14": 1,
          "2026-02-03": 1,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 5,
          "2026-02-14": 5,
          "2026-02-16": 6,
          "2026-02-17": 3,
          "2026-02-18": 18,
          "2026-02-19": 10,
          "2026-02-20": 4,
          "2026-02-21": 29,
          "2026-02-24": 3,
          "2026-02-25": 9,
          "2026-02-26": 3,
          "2026-02-27": 1,
          "2026-02-28": 6,
          "2026-03-02": 1,
          "2026-03-03": 7,
          "2026-03-04": 5,
          "2026-03-05": 12,
          "2026-03-06": 6,
          "2026-03-07": 14,
          "2026-03-08": 2,
          "2026-03-09": 2,
          "2026-03-10": 12,
          "2026-03-11": 5,
          "2026-03-12": 19,
          "2026-03-13": 5,
          "2026-03-14": 8,
          "2026-03-16": 3,
          "2026-03-17": 6,
          "2026-03-18": 7,
          "2026-03-19": 6,
          "2026-03-20": 41,
          "2026-03-22": 1,
          "2026-03-24": 8,
          "2026-03-25": 4,
          "2026-03-26": 12,
          "2026-03-27": 4,
          "2026-03-28": 8,
          "2026-03-29": 1,
          "2026-03-31": 15,
          "2026-04-01": 7,
          "2026-04-02": 7,
          "2026-04-04": 8,
          "2026-04-06": 12,
          "2026-04-07": 6,
          "2026-04-08": 6,
          "2026-04-10": 20,
          "2026-04-11": 8,
          "2026-04-14": 15,
          "2026-04-15": 8,
          "2026-04-16": 46,
          "2026-04-17": 35,
          "2026-04-20": 5,
          "2026-04-21": 11,
          "2026-04-22": 11,
          "2026-04-23": 6,
          "2026-04-24": 8,
          "2026-04-26": 1,
          "2026-04-27": 2,
          "2026-04-28": 10,
          "2026-04-29": 18,
          "2026-04-30": 7,
          "2026-05-04": 9,
          "2026-05-05": 7,
          "2026-05-06": 14,
          "2026-05-07": 12,
          "2026-05-08": 2,
          "2026-05-09": 7,
          "2026-05-14": 1,
          "2026-05-18": 8,
          "2026-05-19": 10,
          "2026-05-20": 6,
          "2026-05-21": 13,
          "2026-05-22": 20,
          "2026-05-23": 9,
          "2026-05-25": 16,
          "2026-05-26": 28,
          "2026-05-27": 7,
          "2026-05-28": 19,
          "2026-05-29": 14,
          "2026-06-01": 2,
          "2026-06-02": 10,
          "2026-06-03": 9,
          "2026-06-05": 1,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 141.5,
          "mode_time_hours": 3.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 7,
            "4-6h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "22-24h": 4,
            "24-26h": 1,
            "26-28h": 1,
            "42-44h": 1,
            "68-70h": 1,
            "84-86h": 1,
            "86-88h": 1,
            "96-98h": 1,
            "112-114h": 1,
            "114-116h": 1,
            "138-140h": 1,
            "172-174h": 1,
            "372-374h": 1,
            "410-412h": 1,
            "566-568h": 1,
            "638-640h": 1,
            "844-846h": 1,
            "854-856h": 1
          },
          "tickets_count": 52,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-01-14": 1,
            "2026-02-13": 1,
            "2026-02-19": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-03": 1,
            "2026-03-14": 1,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-04-07": 1,
            "2026-04-10": 2,
            "2026-04-11": 2,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 10,
            "2026-04-20": 2,
            "2026-04-21": 1,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-07": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-23": 2,
            "2026-05-25": 2,
            "2026-05-26": 3,
            "2026-05-29": 1,
            "2026-06-03": 3,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-01-14": 42.92236694444445,
            "2026-02-13": 410.5228652777778,
            "2026-02-19": 25.82521138888889,
            "2026-02-26": 1.668902222222222,
            "2026-02-28": 22.598300833333333,
            "2026-03-03": 23.74983138888889,
            "2026-03-14": 1.4962497222222222,
            "2026-03-20": 207.51351944444443,
            "2026-03-24": 638.4945047222222,
            "2026-04-07": 86.15805777777777,
            "2026-04-10": 1226.3868052777777,
            "2026-04-11": 27.189146666666666,
            "2026-04-15": 96.54103500000001,
            "2026-04-17": 59.32034166666667,
            "2026-04-21": 566.1962222222222,
            "2026-05-04": 112.17740722222223,
            "2026-05-20": 23.04843222222222,
            "2026-05-21": 84.29436861111111,
            "2026-05-23": 172.49276055555555,
            "2026-05-25": 844.4759944444445,
            "2026-05-26": 137.81449694444444
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-02-13": 1,
            "2026-02-19": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-03": 1,
            "2026-03-14": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-04-07": 1,
            "2026-04-10": 2,
            "2026-04-11": 2,
            "2026-04-15": 1,
            "2026-04-17": 10,
            "2026-04-21": 1,
            "2026-05-04": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-26": 2
          }
        },
        "P2": {
          "avg_time_hours": 127.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 283,
          "time_distribution": {
            "0-2h": 283,
            "2-4h": 60,
            "4-6h": 22,
            "6-8h": 24,
            "8-10h": 8,
            "10-12h": 9,
            "12-14h": 9,
            "14-16h": 6,
            "16-18h": 15,
            "18-20h": 16,
            "20-22h": 15,
            "22-24h": 14,
            "24-26h": 9,
            "26-28h": 6,
            "28-30h": 15,
            "30-32h": 2,
            "32-34h": 1,
            "34-36h": 1,
            "38-40h": 2,
            "40-42h": 2,
            "42-44h": 6,
            "44-46h": 2,
            "48-50h": 7,
            "50-52h": 3,
            "52-54h": 1,
            "58-60h": 2,
            "64-66h": 1,
            "66-68h": 2,
            "68-70h": 3,
            "70-72h": 6,
            "72-74h": 9,
            "74-76h": 5,
            "76-78h": 1,
            "84-86h": 3,
            "88-90h": 1,
            "90-92h": 1,
            "92-94h": 1,
            "94-96h": 3,
            "98-100h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "104-106h": 2,
            "112-114h": 2,
            "116-118h": 1,
            "118-120h": 1,
            "120-122h": 3,
            "122-124h": 1,
            "124-126h": 1,
            "126-128h": 1,
            "128-130h": 1,
            "136-138h": 1,
            "138-140h": 1,
            "140-142h": 1,
            "142-144h": 1,
            "144-146h": 1,
            "146-148h": 1,
            "148-150h": 1,
            "160-162h": 1,
            "168-170h": 3,
            "170-172h": 2,
            "190-192h": 3,
            "192-194h": 2,
            "194-196h": 2,
            "196-198h": 2,
            "210-212h": 1,
            "212-214h": 2,
            "216-218h": 1,
            "218-220h": 1,
            "222-224h": 2,
            "226-228h": 2,
            "246-248h": 2,
            "248-250h": 1,
            "252-254h": 1,
            "256-258h": 1,
            "260-262h": 1,
            "262-264h": 1,
            "264-266h": 1,
            "270-272h": 2,
            "272-274h": 1,
            "280-282h": 1,
            "282-284h": 1,
            "306-308h": 1,
            "308-310h": 1,
            "332-334h": 1,
            "334-336h": 2,
            "336-338h": 3,
            "338-340h": 4,
            "340-342h": 2,
            "348-350h": 1,
            "350-352h": 1,
            "352-354h": 1,
            "354-356h": 1,
            "356-358h": 1,
            "362-364h": 1,
            "364-366h": 1,
            "366-368h": 1,
            "372-374h": 1,
            "382-384h": 1,
            "388-390h": 2,
            "398-400h": 1,
            "402-404h": 1,
            "404-406h": 4,
            "406-408h": 1,
            "408-410h": 2,
            "412-414h": 2,
            "430-432h": 1,
            "446-448h": 1,
            "456-458h": 1,
            "460-462h": 1,
            "478-480h": 1,
            "480-482h": 1,
            "482-484h": 1,
            "496-498h": 1,
            "502-504h": 1,
            "504-506h": 1,
            "508-510h": 1,
            "510-512h": 1,
            "512-514h": 1,
            "514-516h": 1,
            "522-524h": 1,
            "526-528h": 1,
            "528-530h": 1,
            "532-534h": 2,
            "546-548h": 1,
            "560-562h": 1,
            "576-578h": 1,
            "582-584h": 2,
            "592-594h": 1,
            "612-614h": 1,
            "622-624h": 1,
            "634-636h": 1,
            "648-650h": 2,
            "650-652h": 1,
            "652-654h": 1,
            "672-674h": 1,
            "682-684h": 1,
            "696-698h": 1,
            "698-700h": 1,
            "702-704h": 1,
            "730-732h": 2,
            "766-768h": 1,
            "800-802h": 3,
            "810-812h": 1,
            "818-820h": 2,
            "822-824h": 1,
            "850-852h": 1,
            "860-862h": 1,
            "864-866h": 1,
            "866-868h": 1,
            "896-898h": 1,
            "922-924h": 1,
            "938-940h": 1,
            "968-970h": 1,
            "970-972h": 1,
            "986-988h": 2,
            "1000-1002h": 1,
            "1002-1004h": 1,
            "1012-1014h": 1,
            "1032-1034h": 1,
            "1052-1054h": 1,
            "1086-1088h": 1,
            "1144-1146h": 1,
            "1200-1202h": 2,
            "1224-1226h": 1,
            "1336-1338h": 1,
            "1480-1482h": 1,
            "1514-1516h": 1,
            "1556-1558h": 1,
            "1582-1584h": 1,
            "1852-1854h": 1,
            "2280-2282h": 1,
            "2560-2562h": 1
          },
          "tickets_count": 895,
          "tickets_per_day": {
            "2025-12-04": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-02-11": 2,
            "2026-02-13": 2,
            "2026-02-14": 4,
            "2026-02-16": 6,
            "2026-02-17": 3,
            "2026-02-18": 13,
            "2026-02-19": 7,
            "2026-02-20": 4,
            "2026-02-21": 29,
            "2026-02-24": 4,
            "2026-02-25": 10,
            "2026-02-26": 2,
            "2026-02-27": 1,
            "2026-02-28": 5,
            "2026-03-02": 2,
            "2026-03-03": 8,
            "2026-03-04": 6,
            "2026-03-05": 13,
            "2026-03-06": 7,
            "2026-03-07": 16,
            "2026-03-08": 2,
            "2026-03-09": 2,
            "2026-03-10": 12,
            "2026-03-11": 5,
            "2026-03-12": 20,
            "2026-03-13": 5,
            "2026-03-14": 7,
            "2026-03-16": 3,
            "2026-03-17": 7,
            "2026-03-18": 7,
            "2026-03-19": 8,
            "2026-03-20": 37,
            "2026-03-22": 1,
            "2026-03-23": 1,
            "2026-03-24": 8,
            "2026-03-25": 5,
            "2026-03-26": 13,
            "2026-03-27": 4,
            "2026-03-28": 9,
            "2026-03-29": 1,
            "2026-03-30": 1,
            "2026-03-31": 16,
            "2026-04-01": 8,
            "2026-04-02": 9,
            "2026-04-04": 8,
            "2026-04-06": 13,
            "2026-04-07": 5,
            "2026-04-08": 6,
            "2026-04-10": 18,
            "2026-04-11": 6,
            "2026-04-13": 1,
            "2026-04-14": 16,
            "2026-04-15": 8,
            "2026-04-16": 47,
            "2026-04-17": 30,
            "2026-04-18": 1,
            "2026-04-20": 11,
            "2026-04-21": 14,
            "2026-04-22": 11,
            "2026-04-23": 8,
            "2026-04-24": 10,
            "2026-04-26": 1,
            "2026-04-27": 3,
            "2026-04-28": 12,
            "2026-04-29": 20,
            "2026-04-30": 8,
            "2026-05-04": 9,
            "2026-05-05": 8,
            "2026-05-06": 19,
            "2026-05-07": 21,
            "2026-05-08": 3,
            "2026-05-09": 10,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-14": 2,
            "2026-05-18": 10,
            "2026-05-19": 13,
            "2026-05-20": 12,
            "2026-05-21": 15,
            "2026-05-22": 23,
            "2026-05-23": 11,
            "2026-05-25": 18,
            "2026-05-26": 29,
            "2026-05-27": 9,
            "2026-05-28": 23,
            "2026-05-29": 22,
            "2026-06-01": 8,
            "2026-06-02": 14,
            "2026-06-03": 12,
            "2026-06-05": 2,
            "2026-06-06": 1,
            "2026-06-08": 4
          },
          "time_per_day": {
            "2025-12-04": 1224.5898944444446,
            "2026-02-11": 5.3686847222222225,
            "2026-02-13": 351.9221302777778,
            "2026-02-14": 1050.5295158333333,
            "2026-02-16": 244.35082083333333,
            "2026-02-17": 4.999691111111111,
            "2026-02-18": 2787.8724841666663,
            "2026-02-19": 153.15618166666667,
            "2026-02-20": 227.7058144444444,
            "2026-02-21": 1008.8304463888891,
            "2026-02-24": 745.9152122222222,
            "2026-02-25": 217.71209444444443,
            "2026-02-26": 11.292011666666667,
            "2026-02-27": 28.417183611111113,
            "2026-02-28": 434.4955527777778,
            "2026-03-02": 0.6003283333333332,
            "2026-03-03": 16.23511861111111,
            "2026-03-04": 414.4525430555555,
            "2026-03-05": 359.3319955555555,
            "2026-03-06": 33.65053944444444,
            "2026-03-07": 374.6373825,
            "2026-03-08": 0.020296944444444444,
            "2026-03-09": 687.1093488888889,
            "2026-03-10": 394.6552794444445,
            "2026-03-11": 82.05425305555555,
            "2026-03-12": 3837.114968333333,
            "2026-03-13": 389.0923891666667,
            "2026-03-14": 51.803994166666676,
            "2026-03-16": 293.3387475,
            "2026-03-17": 673.0699958333333,
            "2026-03-18": 47.41389916666667,
            "2026-03-19": 338.1378311111111,
            "2026-03-20": 12807.098482499998,
            "2026-03-22": 196.89580444444442,
            "2026-03-24": 465.66804666666667,
            "2026-03-25": 9.0508725,
            "2026-03-26": 1682.9482991666664,
            "2026-03-27": 47.004350277777775,
            "2026-03-28": 65.8983575,
            "2026-03-29": 17.501973055555556,
            "2026-03-31": 1157.8508652777778,
            "2026-04-01": 320.55235972222226,
            "2026-04-02": 83.06752861111109,
            "2026-04-04": 87.07294638888888,
            "2026-04-06": 634.0519472222222,
            "2026-04-07": 201.18546361111112,
            "2026-04-08": 538.5730663888887,
            "2026-04-10": 3373.660941944444,
            "2026-04-11": 39.178889166666664,
            "2026-04-14": 4238.620706111112,
            "2026-04-15": 420.76493138888884,
            "2026-04-16": 27638.286584444442,
            "2026-04-17": 6984.615925555555,
            "2026-04-20": 910.1225552777777,
            "2026-04-21": 274.88952916666665,
            "2026-04-22": 2848.719221944444,
            "2026-04-23": 149.9428405555556,
            "2026-04-24": 30.51744611111111,
            "2026-04-26": 766.8327555555555,
            "2026-04-27": 150.0131225,
            "2026-04-28": 2909.42143,
            "2026-04-29": 1239.5130508333332,
            "2026-04-30": 461.0119027777777,
            "2026-05-04": 383.1886805555556,
            "2026-05-05": 1089.4499669444444,
            "2026-05-06": 3042.5427402777773,
            "2026-05-07": 781.5411113888889,
            "2026-05-08": 17.72205194444444,
            "2026-05-09": 518.0400675,
            "2026-05-14": 6.616233888888889,
            "2026-05-18": 465.06282472222216,
            "2026-05-19": 88.38509694444444,
            "2026-05-20": 210.71168722222222,
            "2026-05-21": 142.1480822222222,
            "2026-05-22": 159.09073749999996,
            "2026-05-23": 59.455305555555555,
            "2026-05-25": 97.50211055555556,
            "2026-05-26": 175.0308852777777,
            "2026-05-27": 79.39878027777776,
            "2026-05-28": 9.907505555555556,
            "2026-05-29": 226.82706944444445,
            "2026-06-01": 14.207236666666667,
            "2026-06-02": 335.20296611111115,
            "2026-06-03": 84.77990861111113,
            "2026-06-05": 68.87973111111111,
            "2026-06-08": 280.95521055555554
          },
          "time_count_per_day": {
            "2025-12-04": 1,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-14": 4,
            "2026-02-16": 5,
            "2026-02-17": 3,
            "2026-02-18": 13,
            "2026-02-19": 7,
            "2026-02-20": 4,
            "2026-02-21": 29,
            "2026-02-24": 3,
            "2026-02-25": 9,
            "2026-02-26": 2,
            "2026-02-27": 1,
            "2026-02-28": 5,
            "2026-03-02": 1,
            "2026-03-03": 6,
            "2026-03-04": 5,
            "2026-03-05": 12,
            "2026-03-06": 6,
            "2026-03-07": 14,
            "2026-03-08": 2,
            "2026-03-09": 2,
            "2026-03-10": 11,
            "2026-03-11": 5,
            "2026-03-12": 19,
            "2026-03-13": 5,
            "2026-03-14": 7,
            "2026-03-16": 2,
            "2026-03-17": 6,
            "2026-03-18": 7,
            "2026-03-19": 6,
            "2026-03-20": 37,
            "2026-03-22": 1,
            "2026-03-24": 7,
            "2026-03-25": 4,
            "2026-03-26": 12,
            "2026-03-27": 3,
            "2026-03-28": 8,
            "2026-03-29": 1,
            "2026-03-31": 15,
            "2026-04-01": 7,
            "2026-04-02": 7,
            "2026-04-04": 8,
            "2026-04-06": 12,
            "2026-04-07": 5,
            "2026-04-08": 6,
            "2026-04-10": 17,
            "2026-04-11": 6,
            "2026-04-14": 15,
            "2026-04-15": 7,
            "2026-04-16": 46,
            "2026-04-17": 25,
            "2026-04-20": 4,
            "2026-04-21": 10,
            "2026-04-22": 11,
            "2026-04-23": 6,
            "2026-04-24": 8,
            "2026-04-26": 1,
            "2026-04-27": 2,
            "2026-04-28": 10,
            "2026-04-29": 18,
            "2026-04-30": 7,
            "2026-05-04": 7,
            "2026-05-05": 7,
            "2026-05-06": 14,
            "2026-05-07": 12,
            "2026-05-08": 2,
            "2026-05-09": 7,
            "2026-05-14": 1,
            "2026-05-18": 8,
            "2026-05-19": 10,
            "2026-05-20": 5,
            "2026-05-21": 12,
            "2026-05-22": 20,
            "2026-05-23": 8,
            "2026-05-25": 15,
            "2026-05-26": 26,
            "2026-05-27": 7,
            "2026-05-28": 19,
            "2026-05-29": 14,
            "2026-06-01": 2,
            "2026-06-02": 10,
            "2026-06-03": 9,
            "2026-06-05": 1,
            "2026-06-08": 2
          }
        },
        "P3": {
          "avg_time_hours": 1183.62,
          "mode_time_hours": 2525.0,
          "mode_frequency": 2,
          "time_distribution": {
            "16-18h": 1,
            "32-34h": 1,
            "44-46h": 1,
            "74-76h": 1,
            "162-164h": 1,
            "198-200h": 1,
            "240-242h": 1,
            "478-480h": 1,
            "492-494h": 1,
            "496-498h": 1,
            "1476-1478h": 1,
            "1732-1734h": 1,
            "1786-1788h": 1,
            "2008-2010h": 1,
            "2182-2184h": 1,
            "2304-2306h": 1,
            "2350-2352h": 1,
            "2524-2526h": 2,
            "2534-2536h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-14": 1,
            "2025-12-15": 1,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-14": 1,
            "2026-02-16": 1,
            "2026-02-18": 5,
            "2026-02-19": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-20": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2025-12-15": 479.98042166666664,
            "2026-02-03": 1476.9555258333335,
            "2026-02-12": 75.16169416666666,
            "2026-02-13": 525.1084875,
            "2026-02-14": 1733.4446161111111,
            "2026-02-16": 1787.2975374999999,
            "2026-02-18": 11383.078038888887,
            "2026-02-19": 2524.689726944445,
            "2026-03-10": 2524.9597302777775,
            "2026-03-16": 241.7082327777778,
            "2026-03-20": 162.18627777777778,
            "2026-03-27": 16.7574575,
            "2026-04-10": 44.36093694444444,
            "2026-04-20": 198.77591166666667,
            "2026-05-04": 497.84789472222224
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-14": 1,
            "2026-02-16": 1,
            "2026-02-18": 5,
            "2026-02-19": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-10": 1,
            "2026-04-20": 1,
            "2026-05-04": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 2375.69,
          "mode_time_hours": 2375.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2374-2376h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 2375.6898841666666
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 2391.81,
          "mode_time_hours": 2391.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2390-2392h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 2391.807425833333
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 160.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 286,
            "time_distribution": {
              "0-2h": 286,
              "2-4h": 67,
              "4-6h": 23,
              "6-8h": 24,
              "8-10h": 9,
              "10-12h": 9,
              "12-14h": 9,
              "14-16h": 6,
              "16-18h": 16,
              "18-20h": 17,
              "20-22h": 15,
              "22-24h": 18,
              "24-26h": 10,
              "26-28h": 7,
              "28-30h": 15,
              "30-32h": 2,
              "32-34h": 2,
              "34-36h": 1,
              "38-40h": 2,
              "40-42h": 2,
              "42-44h": 7,
              "44-46h": 3,
              "48-50h": 7,
              "50-52h": 3,
              "52-54h": 1,
              "58-60h": 2,
              "64-66h": 1,
              "66-68h": 2,
              "68-70h": 4,
              "70-72h": 6,
              "72-74h": 9,
              "74-76h": 6,
              "76-78h": 1,
              "84-86h": 4,
              "86-88h": 1,
              "88-90h": 1,
              "90-92h": 1,
              "92-94h": 1,
              "94-96h": 3,
              "96-98h": 1,
              "98-100h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "104-106h": 2,
              "112-114h": 3,
              "114-116h": 1,
              "116-118h": 1,
              "118-120h": 1,
              "120-122h": 3,
              "122-124h": 1,
              "124-126h": 1,
              "126-128h": 1,
              "128-130h": 1,
              "136-138h": 1,
              "138-140h": 2,
              "140-142h": 1,
              "142-144h": 1,
              "144-146h": 1,
              "146-148h": 1,
              "148-150h": 1,
              "160-162h": 1,
              "162-164h": 1,
              "168-170h": 3,
              "170-172h": 2,
              "172-174h": 1,
              "190-192h": 3,
              "192-194h": 2,
              "194-196h": 2,
              "196-198h": 2,
              "198-200h": 1,
              "210-212h": 1,
              "212-214h": 2,
              "216-218h": 1,
              "218-220h": 1,
              "222-224h": 2,
              "226-228h": 2,
              "240-242h": 1,
              "246-248h": 2,
              "248-250h": 1,
              "252-254h": 1,
              "256-258h": 1,
              "260-262h": 1,
              "262-264h": 1,
              "264-266h": 1,
              "270-272h": 2,
              "272-274h": 1,
              "280-282h": 1,
              "282-284h": 1,
              "306-308h": 1,
              "308-310h": 1,
              "332-334h": 1,
              "334-336h": 2,
              "336-338h": 3,
              "338-340h": 4,
              "340-342h": 2,
              "348-350h": 1,
              "350-352h": 1,
              "352-354h": 1,
              "354-356h": 1,
              "356-358h": 1,
              "362-364h": 1,
              "364-366h": 1,
              "366-368h": 1,
              "372-374h": 2,
              "382-384h": 1,
              "388-390h": 2,
              "398-400h": 1,
              "402-404h": 1,
              "404-406h": 4,
              "406-408h": 1,
              "408-410h": 2,
              "410-412h": 1,
              "412-414h": 2,
              "430-432h": 1,
              "446-448h": 1,
              "456-458h": 1,
              "460-462h": 1,
              "478-480h": 2,
              "480-482h": 1,
              "482-484h": 1,
              "492-494h": 1,
              "496-498h": 2,
              "502-504h": 1,
              "504-506h": 1,
              "508-510h": 1,
              "510-512h": 1,
              "512-514h": 1,
              "514-516h": 1,
              "522-524h": 1,
              "526-528h": 1,
              "528-530h": 1,
              "532-534h": 2,
              "546-548h": 1,
              "560-562h": 1,
              "566-568h": 1,
              "576-578h": 1,
              "582-584h": 2,
              "592-594h": 1,
              "612-614h": 1,
              "622-624h": 1,
              "634-636h": 1,
              "638-640h": 1,
              "648-650h": 2,
              "650-652h": 1,
              "652-654h": 1,
              "672-674h": 1,
              "682-684h": 1,
              "696-698h": 1,
              "698-700h": 1,
              "702-704h": 1,
              "730-732h": 2,
              "766-768h": 1,
              "800-802h": 3,
              "810-812h": 1,
              "818-820h": 2,
              "822-824h": 1,
              "844-846h": 1,
              "850-852h": 1,
              "854-856h": 1,
              "860-862h": 1,
              "864-866h": 1,
              "866-868h": 1,
              "896-898h": 1,
              "922-924h": 1,
              "938-940h": 1,
              "968-970h": 1,
              "970-972h": 1,
              "986-988h": 2,
              "1000-1002h": 1,
              "1002-1004h": 1,
              "1012-1014h": 1,
              "1032-1034h": 1,
              "1052-1054h": 1,
              "1086-1088h": 1,
              "1144-1146h": 1,
              "1200-1202h": 2,
              "1224-1226h": 1,
              "1336-1338h": 1,
              "1476-1478h": 1,
              "1480-1482h": 1,
              "1514-1516h": 1,
              "1556-1558h": 1,
              "1582-1584h": 1,
              "1732-1734h": 1,
              "1786-1788h": 1,
              "1852-1854h": 1,
              "2008-2010h": 1,
              "2182-2184h": 1,
              "2280-2282h": 1,
              "2304-2306h": 1,
              "2350-2352h": 1,
              "2374-2376h": 1,
              "2390-2392h": 1,
              "2524-2526h": 2,
              "2534-2536h": 1,
              "2560-2562h": 1
            },
            "tickets_count": 805,
            "tickets_per_day": {
              "2025-12-04": 1,
              "2025-12-15": 1,
              "2026-01-14": 1,
              "2026-02-03": 1,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 5,
              "2026-02-14": 5,
              "2026-02-16": 6,
              "2026-02-17": 3,
              "2026-02-18": 18,
              "2026-02-19": 10,
              "2026-02-20": 4,
              "2026-02-21": 29,
              "2026-02-24": 3,
              "2026-02-25": 9,
              "2026-02-26": 3,
              "2026-02-27": 1,
              "2026-02-28": 6,
              "2026-03-02": 1,
              "2026-03-03": 7,
              "2026-03-04": 5,
              "2026-03-05": 12,
              "2026-03-06": 6,
              "2026-03-07": 14,
              "2026-03-08": 2,
              "2026-03-09": 2,
              "2026-03-10": 12,
              "2026-03-11": 5,
              "2026-03-12": 19,
              "2026-03-13": 5,
              "2026-03-14": 8,
              "2026-03-16": 3,
              "2026-03-17": 6,
              "2026-03-18": 7,
              "2026-03-19": 6,
              "2026-03-20": 41,
              "2026-03-22": 1,
              "2026-03-24": 8,
              "2026-03-25": 4,
              "2026-03-26": 12,
              "2026-03-27": 4,
              "2026-03-28": 8,
              "2026-03-29": 1,
              "2026-03-31": 15,
              "2026-04-01": 7,
              "2026-04-02": 7,
              "2026-04-04": 8,
              "2026-04-06": 12,
              "2026-04-07": 6,
              "2026-04-08": 6,
              "2026-04-10": 20,
              "2026-04-11": 8,
              "2026-04-14": 15,
              "2026-04-15": 8,
              "2026-04-16": 46,
              "2026-04-17": 35,
              "2026-04-20": 5,
              "2026-04-21": 11,
              "2026-04-22": 11,
              "2026-04-23": 6,
              "2026-04-24": 8,
              "2026-04-26": 1,
              "2026-04-27": 2,
              "2026-04-28": 10,
              "2026-04-29": 18,
              "2026-04-30": 7,
              "2026-05-04": 9,
              "2026-05-05": 7,
              "2026-05-06": 14,
              "2026-05-07": 12,
              "2026-05-08": 2,
              "2026-05-09": 7,
              "2026-05-14": 1,
              "2026-05-18": 8,
              "2026-05-19": 10,
              "2026-05-20": 6,
              "2026-05-21": 13,
              "2026-05-22": 20,
              "2026-05-23": 9,
              "2026-05-25": 16,
              "2026-05-26": 28,
              "2026-05-27": 7,
              "2026-05-28": 19,
              "2026-05-29": 14,
              "2026-06-01": 2,
              "2026-06-02": 10,
              "2026-06-03": 9,
              "2026-06-05": 1,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-12-04": 1224.5898944444446,
              "2025-12-15": 479.98042166666664,
              "2026-01-14": 42.92236694444445,
              "2026-02-03": 1476.9555258333335,
              "2026-02-11": 5.3686847222222225,
              "2026-02-12": 75.16169416666666,
              "2026-02-13": 1287.5534830555557,
              "2026-02-14": 2783.9741319444447,
              "2026-02-16": 2031.6483583333334,
              "2026-02-17": 4.999691111111111,
              "2026-02-18": 14170.950523055555,
              "2026-02-19": 5095.4785458333345,
              "2026-02-20": 227.7058144444444,
              "2026-02-21": 1008.8304463888891,
              "2026-02-24": 745.9152122222222,
              "2026-02-25": 217.71209444444443,
              "2026-02-26": 12.96091388888889,
              "2026-02-27": 28.417183611111113,
              "2026-02-28": 457.0938536111111,
              "2026-03-02": 0.6003283333333332,
              "2026-03-03": 39.984950000000005,
              "2026-03-04": 414.4525430555555,
              "2026-03-05": 359.3319955555555,
              "2026-03-06": 33.65053944444444,
              "2026-03-07": 374.6373825,
              "2026-03-08": 0.020296944444444444,
              "2026-03-09": 687.1093488888889,
              "2026-03-10": 2919.6150097222217,
              "2026-03-11": 82.05425305555555,
              "2026-03-12": 3837.114968333333,
              "2026-03-13": 389.0923891666667,
              "2026-03-14": 53.3002438888889,
              "2026-03-16": 535.0469802777778,
              "2026-03-17": 673.0699958333333,
              "2026-03-18": 47.41389916666667,
              "2026-03-19": 338.1378311111111,
              "2026-03-20": 15552.488163888884,
              "2026-03-22": 196.89580444444442,
              "2026-03-24": 1104.1625513888891,
              "2026-03-25": 9.0508725,
              "2026-03-26": 1682.9482991666664,
              "2026-03-27": 63.761807777777776,
              "2026-03-28": 65.8983575,
              "2026-03-29": 17.501973055555556,
              "2026-03-31": 1157.8508652777778,
              "2026-04-01": 320.55235972222226,
              "2026-04-02": 83.06752861111109,
              "2026-04-04": 87.07294638888888,
              "2026-04-06": 634.0519472222222,
              "2026-04-07": 287.3435213888889,
              "2026-04-08": 538.5730663888887,
              "2026-04-10": 4644.408684166668,
              "2026-04-11": 66.36803583333334,
              "2026-04-14": 4238.620706111112,
              "2026-04-15": 517.3059663888889,
              "2026-04-16": 27638.286584444442,
              "2026-04-17": 7043.936267222221,
              "2026-04-20": 1108.8984669444444,
              "2026-04-21": 841.0857513888892,
              "2026-04-22": 2848.719221944444,
              "2026-04-23": 149.9428405555556,
              "2026-04-24": 30.51744611111111,
              "2026-04-26": 766.8327555555555,
              "2026-04-27": 150.0131225,
              "2026-04-28": 2909.42143,
              "2026-04-29": 1239.5130508333332,
              "2026-04-30": 461.0119027777777,
              "2026-05-04": 993.2139824999998,
              "2026-05-05": 1089.4499669444444,
              "2026-05-06": 3042.5427402777773,
              "2026-05-07": 781.5411113888889,
              "2026-05-08": 17.72205194444444,
              "2026-05-09": 518.0400675,
              "2026-05-14": 6.616233888888889,
              "2026-05-18": 465.06282472222216,
              "2026-05-19": 88.38509694444444,
              "2026-05-20": 233.76011944444446,
              "2026-05-21": 226.44245083333328,
              "2026-05-22": 159.09073749999996,
              "2026-05-23": 231.94806611111113,
              "2026-05-25": 941.9781050000001,
              "2026-05-26": 312.84538222222244,
              "2026-05-27": 79.39878027777776,
              "2026-05-28": 9.907505555555556,
              "2026-05-29": 226.82706944444445,
              "2026-06-01": 14.207236666666667,
              "2026-06-02": 335.20296611111115,
              "2026-06-03": 84.77990861111113,
              "2026-06-05": 68.87973111111111,
              "2026-06-08": 280.95521055555554
            },
            "time_count_per_day": {
              "2025-12-04": 1,
              "2025-12-15": 1,
              "2026-01-14": 1,
              "2026-02-03": 1,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 5,
              "2026-02-14": 5,
              "2026-02-16": 6,
              "2026-02-17": 3,
              "2026-02-18": 18,
              "2026-02-19": 10,
              "2026-02-20": 4,
              "2026-02-21": 29,
              "2026-02-24": 3,
              "2026-02-25": 9,
              "2026-02-26": 3,
              "2026-02-27": 1,
              "2026-02-28": 6,
              "2026-03-02": 1,
              "2026-03-03": 7,
              "2026-03-04": 5,
              "2026-03-05": 12,
              "2026-03-06": 6,
              "2026-03-07": 14,
              "2026-03-08": 2,
              "2026-03-09": 2,
              "2026-03-10": 12,
              "2026-03-11": 5,
              "2026-03-12": 19,
              "2026-03-13": 5,
              "2026-03-14": 8,
              "2026-03-16": 3,
              "2026-03-17": 6,
              "2026-03-18": 7,
              "2026-03-19": 6,
              "2026-03-20": 41,
              "2026-03-22": 1,
              "2026-03-24": 8,
              "2026-03-25": 4,
              "2026-03-26": 12,
              "2026-03-27": 4,
              "2026-03-28": 8,
              "2026-03-29": 1,
              "2026-03-31": 15,
              "2026-04-01": 7,
              "2026-04-02": 7,
              "2026-04-04": 8,
              "2026-04-06": 12,
              "2026-04-07": 6,
              "2026-04-08": 6,
              "2026-04-10": 20,
              "2026-04-11": 8,
              "2026-04-14": 15,
              "2026-04-15": 8,
              "2026-04-16": 46,
              "2026-04-17": 35,
              "2026-04-20": 5,
              "2026-04-21": 11,
              "2026-04-22": 11,
              "2026-04-23": 6,
              "2026-04-24": 8,
              "2026-04-26": 1,
              "2026-04-27": 2,
              "2026-04-28": 10,
              "2026-04-29": 18,
              "2026-04-30": 7,
              "2026-05-04": 9,
              "2026-05-05": 7,
              "2026-05-06": 14,
              "2026-05-07": 12,
              "2026-05-08": 2,
              "2026-05-09": 7,
              "2026-05-14": 1,
              "2026-05-18": 8,
              "2026-05-19": 10,
              "2026-05-20": 6,
              "2026-05-21": 13,
              "2026-05-22": 20,
              "2026-05-23": 9,
              "2026-05-25": 16,
              "2026-05-26": 28,
              "2026-05-27": 7,
              "2026-05-28": 19,
              "2026-05-29": 14,
              "2026-06-01": 2,
              "2026-06-02": 10,
              "2026-06-03": 9,
              "2026-06-05": 1,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 141.5,
              "mode_time_hours": 3.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 7,
                "4-6h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "22-24h": 4,
                "24-26h": 1,
                "26-28h": 1,
                "42-44h": 1,
                "68-70h": 1,
                "84-86h": 1,
                "86-88h": 1,
                "96-98h": 1,
                "112-114h": 1,
                "114-116h": 1,
                "138-140h": 1,
                "172-174h": 1,
                "372-374h": 1,
                "410-412h": 1,
                "566-568h": 1,
                "638-640h": 1,
                "844-846h": 1,
                "854-856h": 1
              },
              "tickets_count": 34,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-02-13": 1,
                "2026-02-19": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-03": 1,
                "2026-03-14": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-04-07": 1,
                "2026-04-10": 2,
                "2026-04-11": 2,
                "2026-04-15": 1,
                "2026-04-17": 10,
                "2026-04-21": 1,
                "2026-05-04": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-26": 2
              },
              "time_per_day": {
                "2026-01-14": 42.92236694444445,
                "2026-02-13": 410.5228652777778,
                "2026-02-19": 25.82521138888889,
                "2026-02-26": 1.668902222222222,
                "2026-02-28": 22.598300833333333,
                "2026-03-03": 23.74983138888889,
                "2026-03-14": 1.4962497222222222,
                "2026-03-20": 207.51351944444443,
                "2026-03-24": 638.4945047222222,
                "2026-04-07": 86.15805777777777,
                "2026-04-10": 1226.3868052777777,
                "2026-04-11": 27.189146666666666,
                "2026-04-15": 96.54103500000001,
                "2026-04-17": 59.32034166666667,
                "2026-04-21": 566.1962222222222,
                "2026-05-04": 112.17740722222223,
                "2026-05-20": 23.04843222222222,
                "2026-05-21": 84.29436861111111,
                "2026-05-23": 172.49276055555555,
                "2026-05-25": 844.4759944444445,
                "2026-05-26": 137.81449694444444
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-02-13": 1,
                "2026-02-19": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-03": 1,
                "2026-03-14": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-04-07": 1,
                "2026-04-10": 2,
                "2026-04-11": 2,
                "2026-04-15": 1,
                "2026-04-17": 10,
                "2026-04-21": 1,
                "2026-05-04": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-26": 2
              }
            },
            "P2": {
              "avg_time_hours": 127.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 283,
              "time_distribution": {
                "0-2h": 283,
                "2-4h": 60,
                "4-6h": 22,
                "6-8h": 24,
                "8-10h": 8,
                "10-12h": 9,
                "12-14h": 9,
                "14-16h": 6,
                "16-18h": 15,
                "18-20h": 16,
                "20-22h": 15,
                "22-24h": 14,
                "24-26h": 9,
                "26-28h": 6,
                "28-30h": 15,
                "30-32h": 2,
                "32-34h": 1,
                "34-36h": 1,
                "38-40h": 2,
                "40-42h": 2,
                "42-44h": 6,
                "44-46h": 2,
                "48-50h": 7,
                "50-52h": 3,
                "52-54h": 1,
                "58-60h": 2,
                "64-66h": 1,
                "66-68h": 2,
                "68-70h": 3,
                "70-72h": 6,
                "72-74h": 9,
                "74-76h": 5,
                "76-78h": 1,
                "84-86h": 3,
                "88-90h": 1,
                "90-92h": 1,
                "92-94h": 1,
                "94-96h": 3,
                "98-100h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "104-106h": 2,
                "112-114h": 2,
                "116-118h": 1,
                "118-120h": 1,
                "120-122h": 3,
                "122-124h": 1,
                "124-126h": 1,
                "126-128h": 1,
                "128-130h": 1,
                "136-138h": 1,
                "138-140h": 1,
                "140-142h": 1,
                "142-144h": 1,
                "144-146h": 1,
                "146-148h": 1,
                "148-150h": 1,
                "160-162h": 1,
                "168-170h": 3,
                "170-172h": 2,
                "190-192h": 3,
                "192-194h": 2,
                "194-196h": 2,
                "196-198h": 2,
                "210-212h": 1,
                "212-214h": 2,
                "216-218h": 1,
                "218-220h": 1,
                "222-224h": 2,
                "226-228h": 2,
                "246-248h": 2,
                "248-250h": 1,
                "252-254h": 1,
                "256-258h": 1,
                "260-262h": 1,
                "262-264h": 1,
                "264-266h": 1,
                "270-272h": 2,
                "272-274h": 1,
                "280-282h": 1,
                "282-284h": 1,
                "306-308h": 1,
                "308-310h": 1,
                "332-334h": 1,
                "334-336h": 2,
                "336-338h": 3,
                "338-340h": 4,
                "340-342h": 2,
                "348-350h": 1,
                "350-352h": 1,
                "352-354h": 1,
                "354-356h": 1,
                "356-358h": 1,
                "362-364h": 1,
                "364-366h": 1,
                "366-368h": 1,
                "372-374h": 1,
                "382-384h": 1,
                "388-390h": 2,
                "398-400h": 1,
                "402-404h": 1,
                "404-406h": 4,
                "406-408h": 1,
                "408-410h": 2,
                "412-414h": 2,
                "430-432h": 1,
                "446-448h": 1,
                "456-458h": 1,
                "460-462h": 1,
                "478-480h": 1,
                "480-482h": 1,
                "482-484h": 1,
                "496-498h": 1,
                "502-504h": 1,
                "504-506h": 1,
                "508-510h": 1,
                "510-512h": 1,
                "512-514h": 1,
                "514-516h": 1,
                "522-524h": 1,
                "526-528h": 1,
                "528-530h": 1,
                "532-534h": 2,
                "546-548h": 1,
                "560-562h": 1,
                "576-578h": 1,
                "582-584h": 2,
                "592-594h": 1,
                "612-614h": 1,
                "622-624h": 1,
                "634-636h": 1,
                "648-650h": 2,
                "650-652h": 1,
                "652-654h": 1,
                "672-674h": 1,
                "682-684h": 1,
                "696-698h": 1,
                "698-700h": 1,
                "702-704h": 1,
                "730-732h": 2,
                "766-768h": 1,
                "800-802h": 3,
                "810-812h": 1,
                "818-820h": 2,
                "822-824h": 1,
                "850-852h": 1,
                "860-862h": 1,
                "864-866h": 1,
                "866-868h": 1,
                "896-898h": 1,
                "922-924h": 1,
                "938-940h": 1,
                "968-970h": 1,
                "970-972h": 1,
                "986-988h": 2,
                "1000-1002h": 1,
                "1002-1004h": 1,
                "1012-1014h": 1,
                "1032-1034h": 1,
                "1052-1054h": 1,
                "1086-1088h": 1,
                "1144-1146h": 1,
                "1200-1202h": 2,
                "1224-1226h": 1,
                "1336-1338h": 1,
                "1480-1482h": 1,
                "1514-1516h": 1,
                "1556-1558h": 1,
                "1582-1584h": 1,
                "1852-1854h": 1,
                "2280-2282h": 1,
                "2560-2562h": 1
              },
              "tickets_count": 749,
              "tickets_per_day": {
                "2025-12-04": 1,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-14": 4,
                "2026-02-16": 5,
                "2026-02-17": 3,
                "2026-02-18": 13,
                "2026-02-19": 7,
                "2026-02-20": 4,
                "2026-02-21": 29,
                "2026-02-24": 3,
                "2026-02-25": 9,
                "2026-02-26": 2,
                "2026-02-27": 1,
                "2026-02-28": 5,
                "2026-03-02": 1,
                "2026-03-03": 6,
                "2026-03-04": 5,
                "2026-03-05": 12,
                "2026-03-06": 6,
                "2026-03-07": 14,
                "2026-03-08": 2,
                "2026-03-09": 2,
                "2026-03-10": 11,
                "2026-03-11": 5,
                "2026-03-12": 19,
                "2026-03-13": 5,
                "2026-03-14": 7,
                "2026-03-16": 2,
                "2026-03-17": 6,
                "2026-03-18": 7,
                "2026-03-19": 6,
                "2026-03-20": 37,
                "2026-03-22": 1,
                "2026-03-24": 7,
                "2026-03-25": 4,
                "2026-03-26": 12,
                "2026-03-27": 3,
                "2026-03-28": 8,
                "2026-03-29": 1,
                "2026-03-31": 15,
                "2026-04-01": 7,
                "2026-04-02": 7,
                "2026-04-04": 8,
                "2026-04-06": 12,
                "2026-04-07": 5,
                "2026-04-08": 6,
                "2026-04-10": 17,
                "2026-04-11": 6,
                "2026-04-14": 15,
                "2026-04-15": 7,
                "2026-04-16": 46,
                "2026-04-17": 25,
                "2026-04-20": 4,
                "2026-04-21": 10,
                "2026-04-22": 11,
                "2026-04-23": 6,
                "2026-04-24": 8,
                "2026-04-26": 1,
                "2026-04-27": 2,
                "2026-04-28": 10,
                "2026-04-29": 18,
                "2026-04-30": 7,
                "2026-05-04": 7,
                "2026-05-05": 7,
                "2026-05-06": 14,
                "2026-05-07": 12,
                "2026-05-08": 2,
                "2026-05-09": 7,
                "2026-05-14": 1,
                "2026-05-18": 8,
                "2026-05-19": 10,
                "2026-05-20": 5,
                "2026-05-21": 12,
                "2026-05-22": 20,
                "2026-05-23": 8,
                "2026-05-25": 15,
                "2026-05-26": 26,
                "2026-05-27": 7,
                "2026-05-28": 19,
                "2026-05-29": 14,
                "2026-06-01": 2,
                "2026-06-02": 10,
                "2026-06-03": 9,
                "2026-06-05": 1,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-12-04": 1224.5898944444446,
                "2026-02-11": 5.3686847222222225,
                "2026-02-13": 351.9221302777778,
                "2026-02-14": 1050.5295158333333,
                "2026-02-16": 244.35082083333333,
                "2026-02-17": 4.999691111111111,
                "2026-02-18": 2787.8724841666663,
                "2026-02-19": 153.15618166666667,
                "2026-02-20": 227.7058144444444,
                "2026-02-21": 1008.8304463888891,
                "2026-02-24": 745.9152122222222,
                "2026-02-25": 217.71209444444443,
                "2026-02-26": 11.292011666666667,
                "2026-02-27": 28.417183611111113,
                "2026-02-28": 434.4955527777778,
                "2026-03-02": 0.6003283333333332,
                "2026-03-03": 16.23511861111111,
                "2026-03-04": 414.4525430555555,
                "2026-03-05": 359.3319955555555,
                "2026-03-06": 33.65053944444444,
                "2026-03-07": 374.6373825,
                "2026-03-08": 0.020296944444444444,
                "2026-03-09": 687.1093488888889,
                "2026-03-10": 394.6552794444445,
                "2026-03-11": 82.05425305555555,
                "2026-03-12": 3837.114968333333,
                "2026-03-13": 389.0923891666667,
                "2026-03-14": 51.803994166666676,
                "2026-03-16": 293.3387475,
                "2026-03-17": 673.0699958333333,
                "2026-03-18": 47.41389916666667,
                "2026-03-19": 338.1378311111111,
                "2026-03-20": 12807.098482499998,
                "2026-03-22": 196.89580444444442,
                "2026-03-24": 465.66804666666667,
                "2026-03-25": 9.0508725,
                "2026-03-26": 1682.9482991666664,
                "2026-03-27": 47.004350277777775,
                "2026-03-28": 65.8983575,
                "2026-03-29": 17.501973055555556,
                "2026-03-31": 1157.8508652777778,
                "2026-04-01": 320.55235972222226,
                "2026-04-02": 83.06752861111109,
                "2026-04-04": 87.07294638888888,
                "2026-04-06": 634.0519472222222,
                "2026-04-07": 201.18546361111112,
                "2026-04-08": 538.5730663888887,
                "2026-04-10": 3373.660941944444,
                "2026-04-11": 39.178889166666664,
                "2026-04-14": 4238.620706111112,
                "2026-04-15": 420.76493138888884,
                "2026-04-16": 27638.286584444442,
                "2026-04-17": 6984.615925555555,
                "2026-04-20": 910.1225552777777,
                "2026-04-21": 274.88952916666665,
                "2026-04-22": 2848.719221944444,
                "2026-04-23": 149.9428405555556,
                "2026-04-24": 30.51744611111111,
                "2026-04-26": 766.8327555555555,
                "2026-04-27": 150.0131225,
                "2026-04-28": 2909.42143,
                "2026-04-29": 1239.5130508333332,
                "2026-04-30": 461.0119027777777,
                "2026-05-04": 383.1886805555556,
                "2026-05-05": 1089.4499669444444,
                "2026-05-06": 3042.5427402777773,
                "2026-05-07": 781.5411113888889,
                "2026-05-08": 17.72205194444444,
                "2026-05-09": 518.0400675,
                "2026-05-14": 6.616233888888889,
                "2026-05-18": 465.06282472222216,
                "2026-05-19": 88.38509694444444,
                "2026-05-20": 210.71168722222222,
                "2026-05-21": 142.1480822222222,
                "2026-05-22": 159.09073749999996,
                "2026-05-23": 59.455305555555555,
                "2026-05-25": 97.50211055555556,
                "2026-05-26": 175.0308852777777,
                "2026-05-27": 79.39878027777776,
                "2026-05-28": 9.907505555555556,
                "2026-05-29": 226.82706944444445,
                "2026-06-01": 14.207236666666667,
                "2026-06-02": 335.20296611111115,
                "2026-06-03": 84.77990861111113,
                "2026-06-05": 68.87973111111111,
                "2026-06-08": 280.95521055555554
              },
              "time_count_per_day": {
                "2025-12-04": 1,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-14": 4,
                "2026-02-16": 5,
                "2026-02-17": 3,
                "2026-02-18": 13,
                "2026-02-19": 7,
                "2026-02-20": 4,
                "2026-02-21": 29,
                "2026-02-24": 3,
                "2026-02-25": 9,
                "2026-02-26": 2,
                "2026-02-27": 1,
                "2026-02-28": 5,
                "2026-03-02": 1,
                "2026-03-03": 6,
                "2026-03-04": 5,
                "2026-03-05": 12,
                "2026-03-06": 6,
                "2026-03-07": 14,
                "2026-03-08": 2,
                "2026-03-09": 2,
                "2026-03-10": 11,
                "2026-03-11": 5,
                "2026-03-12": 19,
                "2026-03-13": 5,
                "2026-03-14": 7,
                "2026-03-16": 2,
                "2026-03-17": 6,
                "2026-03-18": 7,
                "2026-03-19": 6,
                "2026-03-20": 37,
                "2026-03-22": 1,
                "2026-03-24": 7,
                "2026-03-25": 4,
                "2026-03-26": 12,
                "2026-03-27": 3,
                "2026-03-28": 8,
                "2026-03-29": 1,
                "2026-03-31": 15,
                "2026-04-01": 7,
                "2026-04-02": 7,
                "2026-04-04": 8,
                "2026-04-06": 12,
                "2026-04-07": 5,
                "2026-04-08": 6,
                "2026-04-10": 17,
                "2026-04-11": 6,
                "2026-04-14": 15,
                "2026-04-15": 7,
                "2026-04-16": 46,
                "2026-04-17": 25,
                "2026-04-20": 4,
                "2026-04-21": 10,
                "2026-04-22": 11,
                "2026-04-23": 6,
                "2026-04-24": 8,
                "2026-04-26": 1,
                "2026-04-27": 2,
                "2026-04-28": 10,
                "2026-04-29": 18,
                "2026-04-30": 7,
                "2026-05-04": 7,
                "2026-05-05": 7,
                "2026-05-06": 14,
                "2026-05-07": 12,
                "2026-05-08": 2,
                "2026-05-09": 7,
                "2026-05-14": 1,
                "2026-05-18": 8,
                "2026-05-19": 10,
                "2026-05-20": 5,
                "2026-05-21": 12,
                "2026-05-22": 20,
                "2026-05-23": 8,
                "2026-05-25": 15,
                "2026-05-26": 26,
                "2026-05-27": 7,
                "2026-05-28": 19,
                "2026-05-29": 14,
                "2026-06-01": 2,
                "2026-06-02": 10,
                "2026-06-03": 9,
                "2026-06-05": 1,
                "2026-06-08": 2
              }
            },
            "P3": {
              "avg_time_hours": 1183.62,
              "mode_time_hours": 2525.0,
              "mode_frequency": 2,
              "time_distribution": {
                "16-18h": 1,
                "32-34h": 1,
                "44-46h": 1,
                "74-76h": 1,
                "162-164h": 1,
                "198-200h": 1,
                "240-242h": 1,
                "478-480h": 1,
                "492-494h": 1,
                "496-498h": 1,
                "1476-1478h": 1,
                "1732-1734h": 1,
                "1786-1788h": 1,
                "2008-2010h": 1,
                "2182-2184h": 1,
                "2304-2306h": 1,
                "2350-2352h": 1,
                "2524-2526h": 2,
                "2534-2536h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-14": 1,
                "2026-02-16": 1,
                "2026-02-18": 5,
                "2026-02-19": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2025-12-15": 479.98042166666664,
                "2026-02-03": 1476.9555258333335,
                "2026-02-12": 75.16169416666666,
                "2026-02-13": 525.1084875,
                "2026-02-14": 1733.4446161111111,
                "2026-02-16": 1787.2975374999999,
                "2026-02-18": 11383.078038888887,
                "2026-02-19": 2524.689726944445,
                "2026-03-10": 2524.9597302777775,
                "2026-03-16": 241.7082327777778,
                "2026-03-20": 162.18627777777778,
                "2026-03-27": 16.7574575,
                "2026-04-10": 44.36093694444444,
                "2026-04-20": 198.77591166666667,
                "2026-05-04": 497.84789472222224
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-14": 1,
                "2026-02-16": 1,
                "2026-02-18": 5,
                "2026-02-19": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-05-04": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 2375.69,
              "mode_time_hours": 2375.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2374-2376h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 2375.6898841666666
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 2391.81,
              "mode_time_hours": 2391.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2390-2392h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 2391.807425833333
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-03-06": 1,
              "2026-05-04": 1,
              "2026-05-22": 1,
              "2026-06-03": 1,
              "2026-06-06": 1,
              "2026-06-08": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-03": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-03-06": 1,
                "2026-05-04": 1,
                "2026-05-22": 1,
                "2026-06-06": 1,
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 73,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-11-14": 1,
              "2026-03-02": 2,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-10": 1,
              "2026-03-17": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-03-28": 1,
              "2026-03-31": 1,
              "2026-04-13": 1,
              "2026-04-14": 2,
              "2026-04-16": 2,
              "2026-04-20": 5,
              "2026-04-21": 3,
              "2026-04-23": 2,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-04-28": 1,
              "2026-04-29": 2,
              "2026-05-04": 1,
              "2026-05-06": 2,
              "2026-05-07": 5,
              "2026-05-09": 2,
              "2026-05-12": 1,
              "2026-05-18": 2,
              "2026-05-19": 2,
              "2026-05-20": 4,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-23": 1,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-28": 2,
              "2026-05-29": 5,
              "2026-06-01": 2,
              "2026-06-02": 1,
              "2026-06-03": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-05-26": 1,
                "2026-05-29": 1,
                "2026-06-03": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 64,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-07": 1,
                "2026-03-10": 1,
                "2026-03-17": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-28": 1,
                "2026-03-31": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-04-20": 5,
                "2026-04-21": 3,
                "2026-04-23": 2,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-04-28": 1,
                "2026-04-29": 2,
                "2026-05-04": 1,
                "2026-05-06": 2,
                "2026-05-07": 5,
                "2026-05-09": 2,
                "2026-05-12": 1,
                "2026-05-18": 2,
                "2026-05-19": 2,
                "2026-05-20": 4,
                "2026-05-21": 2,
                "2026-05-22": 1,
                "2026-05-23": 1,
                "2026-05-25": 2,
                "2026-05-27": 1,
                "2026-05-28": 2,
                "2026-05-29": 4,
                "2026-06-01": 2,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 84,
            "tickets_per_day": {
              "2026-01-05": 1,
              "2026-01-16": 1,
              "2026-01-29": 1,
              "2026-02-11": 1,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-03-03": 2,
              "2026-03-04": 1,
              "2026-03-07": 1,
              "2026-03-12": 1,
              "2026-03-19": 3,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-01": 1,
              "2026-04-02": 2,
              "2026-04-06": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-15": 1,
              "2026-04-17": 4,
              "2026-04-18": 1,
              "2026-04-20": 4,
              "2026-04-21": 1,
              "2026-04-24": 1,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-04-30": 2,
              "2026-05-05": 1,
              "2026-05-06": 3,
              "2026-05-07": 5,
              "2026-05-08": 1,
              "2026-05-09": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-20": 3,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-23": 3,
              "2026-05-25": 2,
              "2026-05-26": 3,
              "2026-05-27": 1,
              "2026-05-28": 2,
              "2026-05-29": 4,
              "2026-06-01": 4,
              "2026-06-02": 3,
              "2026-06-03": 3,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-03-19": 1,
                "2026-04-20": 2,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-07": 1,
                "2026-05-23": 1,
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 74,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-02-11": 1,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-03": 2,
                "2026-03-04": 1,
                "2026-03-07": 1,
                "2026-03-12": 1,
                "2026-03-19": 2,
                "2026-03-27": 1,
                "2026-03-30": 1,
                "2026-04-01": 1,
                "2026-04-02": 2,
                "2026-04-06": 1,
                "2026-04-10": 1,
                "2026-04-15": 1,
                "2026-04-17": 4,
                "2026-04-18": 1,
                "2026-04-20": 2,
                "2026-04-21": 1,
                "2026-04-24": 1,
                "2026-04-28": 1,
                "2026-04-30": 1,
                "2026-05-05": 1,
                "2026-05-06": 3,
                "2026-05-07": 4,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 3,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-23": 2,
                "2026-05-25": 1,
                "2026-05-26": 3,
                "2026-05-27": 1,
                "2026-05-28": 2,
                "2026-05-29": 4,
                "2026-06-01": 4,
                "2026-06-02": 3,
                "2026-06-03": 3,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Marta Oliveira": {
      "overall": {
        "avg_time_hours": 888.3,
        "mode_time_hours": 1797.0,
        "mode_frequency": 1,
        "time_distribution": {
          "192-194h": 1,
          "700-702h": 1,
          "722-724h": 1,
          "742-744h": 1,
          "744-746h": 1,
          "814-816h": 1,
          "888-890h": 1,
          "974-976h": 1,
          "1018-1020h": 1,
          "1170-1172h": 1,
          "1796-1798h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2025-12-22": 4,
          "2025-12-26": 3,
          "2025-12-31": 3,
          "2026-01-09": 1
        },
        "time_per_day": {
          "2025-12-22": 2910.960103888889,
          "2025-12-26": 1896.0970627777776,
          "2025-12-31": 3792.2956022222224,
          "2026-01-09": 1171.9090594444444
        },
        "time_count_per_day": {
          "2025-12-22": 4,
          "2025-12-26": 3,
          "2025-12-31": 3,
          "2026-01-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 871.0,
          "mode_time_hours": 1019.0,
          "mode_frequency": 1,
          "time_distribution": {
            "742-744h": 1,
            "744-746h": 1,
            "974-976h": 1,
            "1018-1020h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-22": 2,
            "2025-12-31": 2
          },
          "time_per_day": {
            "2025-12-22": 1488.6758930555557,
            "2025-12-31": 1995.3122569444445
          },
          "time_count_per_day": {
            "2025-12-22": 2,
            "2025-12-31": 2
          }
        },
        "P3": {
          "avg_time_hours": 711.14,
          "mode_time_hours": 723.0,
          "mode_frequency": 1,
          "time_distribution": {
            "700-702h": 1,
            "722-724h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-22": 2
          },
          "time_per_day": {
            "2025-12-22": 1422.2842108333334
          },
          "time_count_per_day": {
            "2025-12-22": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 193.23,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "192-194h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-12-26": 193.23345
          },
          "time_count_per_day": {
            "2025-12-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1167.94,
          "mode_time_hours": 1797.0,
          "mode_frequency": 1,
          "time_distribution": {
            "814-816h": 1,
            "888-890h": 1,
            "1170-1172h": 1,
            "1796-1798h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-26": 2,
            "2025-12-31": 1,
            "2026-01-09": 1
          },
          "time_per_day": {
            "2025-12-26": 1702.8636127777777,
            "2025-12-31": 1796.9833452777777,
            "2026-01-09": 1171.9090594444444
          },
          "time_count_per_day": {
            "2025-12-26": 2,
            "2025-12-31": 1,
            "2026-01-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 888.3,
            "mode_time_hours": 1797.0,
            "mode_frequency": 1,
            "time_distribution": {
              "192-194h": 1,
              "700-702h": 1,
              "722-724h": 1,
              "742-744h": 1,
              "744-746h": 1,
              "814-816h": 1,
              "888-890h": 1,
              "974-976h": 1,
              "1018-1020h": 1,
              "1170-1172h": 1,
              "1796-1798h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2025-12-22": 4,
              "2025-12-26": 3,
              "2025-12-31": 3,
              "2026-01-09": 1
            },
            "time_per_day": {
              "2025-12-22": 2910.960103888889,
              "2025-12-26": 1896.0970627777776,
              "2025-12-31": 3792.2956022222224,
              "2026-01-09": 1171.9090594444444
            },
            "time_count_per_day": {
              "2025-12-22": 4,
              "2025-12-26": 3,
              "2025-12-31": 3,
              "2026-01-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 871.0,
              "mode_time_hours": 1019.0,
              "mode_frequency": 1,
              "time_distribution": {
                "742-744h": 1,
                "744-746h": 1,
                "974-976h": 1,
                "1018-1020h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-22": 2,
                "2025-12-31": 2
              },
              "time_per_day": {
                "2025-12-22": 1488.6758930555557,
                "2025-12-31": 1995.3122569444445
              },
              "time_count_per_day": {
                "2025-12-22": 2,
                "2025-12-31": 2
              }
            },
            "P3": {
              "avg_time_hours": 711.14,
              "mode_time_hours": 723.0,
              "mode_frequency": 1,
              "time_distribution": {
                "700-702h": 1,
                "722-724h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-22": 2
              },
              "time_per_day": {
                "2025-12-22": 1422.2842108333334
              },
              "time_count_per_day": {
                "2025-12-22": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 193.23,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "192-194h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-12-26": 193.23345
              },
              "time_count_per_day": {
                "2025-12-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1167.94,
              "mode_time_hours": 1797.0,
              "mode_frequency": 1,
              "time_distribution": {
                "814-816h": 1,
                "888-890h": 1,
                "1170-1172h": 1,
                "1796-1798h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-26": 2,
                "2025-12-31": 1,
                "2026-01-09": 1
              },
              "time_per_day": {
                "2025-12-26": 1702.8636127777777,
                "2025-12-31": 1796.9833452777777,
                "2026-01-09": 1171.9090594444444
              },
              "time_count_per_day": {
                "2025-12-26": 2,
                "2025-12-31": 1,
                "2026-01-09": 1
              }
            }
          }
        }
      }
    },
    "Margarida Janeiro": {
      "overall": {
        "avg_time_hours": 251.5,
        "mode_time_hours": 1.0,
        "mode_frequency": 58,
        "time_distribution": {
          "0-2h": 58,
          "2-4h": 40,
          "4-6h": 16,
          "6-8h": 8,
          "8-10h": 7,
          "10-12h": 7,
          "12-14h": 11,
          "14-16h": 3,
          "16-18h": 9,
          "18-20h": 8,
          "20-22h": 7,
          "22-24h": 8,
          "24-26h": 10,
          "26-28h": 7,
          "28-30h": 3,
          "30-32h": 2,
          "32-34h": 5,
          "34-36h": 1,
          "36-38h": 3,
          "38-40h": 3,
          "40-42h": 9,
          "42-44h": 2,
          "44-46h": 4,
          "46-48h": 3,
          "48-50h": 7,
          "50-52h": 5,
          "52-54h": 3,
          "54-56h": 2,
          "56-58h": 1,
          "58-60h": 2,
          "60-62h": 1,
          "62-64h": 1,
          "64-66h": 3,
          "66-68h": 1,
          "68-70h": 1,
          "72-74h": 4,
          "76-78h": 2,
          "80-82h": 3,
          "84-86h": 2,
          "86-88h": 1,
          "92-94h": 2,
          "96-98h": 2,
          "98-100h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "106-108h": 1,
          "110-112h": 1,
          "114-116h": 2,
          "118-120h": 2,
          "120-122h": 2,
          "122-124h": 1,
          "124-126h": 1,
          "140-142h": 1,
          "142-144h": 3,
          "144-146h": 2,
          "146-148h": 2,
          "148-150h": 1,
          "156-158h": 1,
          "160-162h": 2,
          "164-166h": 3,
          "166-168h": 1,
          "170-172h": 1,
          "172-174h": 1,
          "174-176h": 1,
          "176-178h": 1,
          "186-188h": 1,
          "192-194h": 1,
          "206-208h": 1,
          "210-212h": 1,
          "212-214h": 1,
          "216-218h": 1,
          "218-220h": 5,
          "230-232h": 1,
          "236-238h": 1,
          "240-242h": 1,
          "246-248h": 3,
          "248-250h": 1,
          "250-252h": 1,
          "252-254h": 1,
          "256-258h": 1,
          "260-262h": 1,
          "262-264h": 1,
          "264-266h": 1,
          "274-276h": 1,
          "276-278h": 1,
          "278-280h": 2,
          "300-302h": 1,
          "304-306h": 2,
          "306-308h": 1,
          "308-310h": 1,
          "310-312h": 1,
          "312-314h": 1,
          "314-316h": 1,
          "320-322h": 1,
          "326-328h": 1,
          "328-330h": 1,
          "330-332h": 1,
          "334-336h": 1,
          "336-338h": 4,
          "338-340h": 3,
          "342-344h": 2,
          "344-346h": 1,
          "348-350h": 3,
          "358-360h": 1,
          "360-362h": 1,
          "362-364h": 3,
          "368-370h": 1,
          "372-374h": 2,
          "376-378h": 1,
          "386-388h": 3,
          "396-398h": 1,
          "408-410h": 2,
          "410-412h": 1,
          "412-414h": 1,
          "414-416h": 3,
          "420-422h": 1,
          "424-426h": 1,
          "428-430h": 1,
          "432-434h": 1,
          "452-454h": 1,
          "492-494h": 1,
          "508-510h": 1,
          "516-518h": 1,
          "522-524h": 1,
          "524-526h": 4,
          "528-530h": 2,
          "530-532h": 4,
          "538-540h": 1,
          "540-542h": 2,
          "542-544h": 2,
          "544-546h": 2,
          "556-558h": 1,
          "558-560h": 2,
          "562-564h": 1,
          "572-574h": 1,
          "576-578h": 2,
          "578-580h": 2,
          "582-584h": 1,
          "584-586h": 1,
          "594-596h": 1,
          "604-606h": 1,
          "614-616h": 1,
          "616-618h": 5,
          "618-620h": 1,
          "622-624h": 1,
          "640-642h": 1,
          "646-648h": 2,
          "652-654h": 2,
          "654-656h": 2,
          "668-670h": 1,
          "670-672h": 1,
          "672-674h": 1,
          "674-676h": 1,
          "678-680h": 1,
          "684-686h": 1,
          "692-694h": 1,
          "696-698h": 3,
          "698-700h": 1,
          "700-702h": 2,
          "702-704h": 1,
          "718-720h": 1,
          "722-724h": 1,
          "744-746h": 2,
          "746-748h": 1,
          "748-750h": 1,
          "750-752h": 1,
          "756-758h": 3,
          "768-770h": 1,
          "786-788h": 1,
          "794-796h": 1,
          "798-800h": 1,
          "814-816h": 1,
          "816-818h": 2,
          "834-836h": 1,
          "844-846h": 1,
          "886-888h": 1,
          "888-890h": 1,
          "890-892h": 2,
          "896-898h": 1,
          "902-904h": 1,
          "906-908h": 1,
          "916-918h": 1,
          "922-924h": 1,
          "964-966h": 1,
          "988-990h": 2,
          "1018-1020h": 1,
          "1030-1032h": 2,
          "1054-1056h": 2,
          "1080-1082h": 1,
          "1142-1144h": 1,
          "1152-1154h": 1,
          "1158-1160h": 1,
          "1180-1182h": 1,
          "1218-1220h": 1,
          "1222-1224h": 1,
          "1324-1326h": 1,
          "1388-1390h": 1,
          "1390-1392h": 1,
          "1414-1416h": 1,
          "1560-1562h": 1,
          "1634-1636h": 1,
          "1670-1672h": 1,
          "1732-1734h": 1,
          "2138-2140h": 1
        },
        "tickets_count": 706,
        "tickets_per_day": {
          "2025-12-09": 2,
          "2025-12-26": 1,
          "2026-01-23": 1,
          "2026-02-18": 1,
          "2026-03-03": 1,
          "2026-03-06": 1,
          "2026-03-09": 3,
          "2026-03-10": 3,
          "2026-03-11": 3,
          "2026-03-12": 7,
          "2026-03-13": 3,
          "2026-03-16": 10,
          "2026-03-17": 3,
          "2026-03-18": 8,
          "2026-03-19": 12,
          "2026-03-20": 3,
          "2026-03-23": 5,
          "2026-03-24": 3,
          "2026-03-25": 3,
          "2026-03-26": 7,
          "2026-03-27": 5,
          "2026-03-30": 5,
          "2026-03-31": 10,
          "2026-04-01": 3,
          "2026-04-02": 4,
          "2026-04-06": 4,
          "2026-04-07": 2,
          "2026-04-08": 2,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 4,
          "2026-04-14": 9,
          "2026-04-15": 2,
          "2026-04-17": 1,
          "2026-04-18": 8,
          "2026-04-20": 3,
          "2026-04-21": 4,
          "2026-04-22": 7,
          "2026-04-23": 67,
          "2026-04-24": 6,
          "2026-04-27": 9,
          "2026-04-28": 5,
          "2026-04-29": 9,
          "2026-04-30": 10,
          "2026-05-02": 12,
          "2026-05-04": 15,
          "2026-05-05": 12,
          "2026-05-06": 70,
          "2026-05-07": 14,
          "2026-05-08": 11,
          "2026-05-11": 16,
          "2026-05-12": 39,
          "2026-05-13": 25,
          "2026-05-14": 23,
          "2026-05-15": 6,
          "2026-05-16": 1,
          "2026-05-18": 20,
          "2026-05-19": 5,
          "2026-05-20": 4,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-25": 16,
          "2026-05-26": 16,
          "2026-05-27": 24,
          "2026-05-28": 13,
          "2026-05-29": 15,
          "2026-05-30": 17,
          "2026-06-01": 17,
          "2026-06-02": 8,
          "2026-06-03": 19,
          "2026-06-04": 1,
          "2026-06-05": 12,
          "2026-06-06": 2,
          "2026-06-07": 1,
          "2026-06-08": 9
        },
        "time_per_day": {
          "2026-01-23": 176.91004972222223,
          "2026-02-18": 1560.4081719444443,
          "2026-03-03": 2.4879641666666665,
          "2026-03-09": 86.13693944444444,
          "2026-03-10": 169.800335,
          "2026-03-11": 129.4392188888889,
          "2026-03-12": 924.9127616666667,
          "2026-03-13": 1646.3838430555556,
          "2026-03-16": 430.91426777777775,
          "2026-03-17": 119.95666472222223,
          "2026-03-18": 28.793728333333334,
          "2026-03-19": 3879.268671111111,
          "2026-03-20": 1053.1728586111112,
          "2026-03-23": 57.86280416666666,
          "2026-03-24": 195.17969972222224,
          "2026-03-25": 68.16204694444444,
          "2026-03-26": 1276.041449166667,
          "2026-03-27": 11.809873888888887,
          "2026-03-30": 674.9224977777778,
          "2026-03-31": 579.5402841666667,
          "2026-04-01": 178.66154833333334,
          "2026-04-02": 608.6231416666667,
          "2026-04-06": 442.7936005555556,
          "2026-04-07": 32.383045,
          "2026-04-08": 215.45070972222223,
          "2026-04-10": 26.939643611111112,
          "2026-04-11": 14.23579,
          "2026-04-13": 142.41543361111113,
          "2026-04-14": 608.8405113888888,
          "2026-04-15": 64.93091166666667,
          "2026-04-17": 902.2539983333332,
          "2026-04-18": 6792.923353055555,
          "2026-04-20": 13.634943333333334,
          "2026-04-21": 2.898441666666667,
          "2026-04-22": 4121.383150555555,
          "2026-04-23": 43274.50974166669,
          "2026-04-24": 576.2725880555556,
          "2026-04-27": 223.0165538888889,
          "2026-04-28": 155.27042805555553,
          "2026-04-29": 460.241965,
          "2026-04-30": 467.4924402777777,
          "2026-05-02": 827.9228861111111,
          "2026-05-04": 506.37765,
          "2026-05-05": 973.1613288888888,
          "2026-05-06": 22158.891635000007,
          "2026-05-07": 131.3409725,
          "2026-05-08": 324.0911369444445,
          "2026-05-11": 205.11060083333336,
          "2026-05-12": 86.69435388888888,
          "2026-05-13": 413.95643416666667,
          "2026-05-14": 4658.037812777778,
          "2026-05-15": 13.08796972222222,
          "2026-05-18": 818.7390113888889,
          "2026-05-19": 817.8153705555555,
          "2026-05-20": 77.29019222222223,
          "2026-05-21": 216.27364333333335,
          "2026-05-22": 250.13939944444445,
          "2026-05-25": 650.206371111111,
          "2026-05-26": 414.6874252777778,
          "2026-05-27": 7645.0390730555555,
          "2026-05-28": 214.58746833333333,
          "2026-05-29": 229.18435805555552,
          "2026-05-30": 8677.350413333335,
          "2026-06-01": 2024.9286844444446,
          "2026-06-02": 202.3621525,
          "2026-06-03": 376.51808250000005,
          "2026-06-04": 888.8700166666666,
          "2026-06-05": 162.39462305555554,
          "2026-06-08": 395.33272805555555
        },
        "time_count_per_day": {
          "2026-01-23": 1,
          "2026-02-18": 1,
          "2026-03-03": 1,
          "2026-03-09": 3,
          "2026-03-10": 2,
          "2026-03-11": 3,
          "2026-03-12": 6,
          "2026-03-13": 3,
          "2026-03-16": 10,
          "2026-03-17": 3,
          "2026-03-18": 8,
          "2026-03-19": 12,
          "2026-03-20": 3,
          "2026-03-23": 5,
          "2026-03-24": 3,
          "2026-03-25": 2,
          "2026-03-26": 7,
          "2026-03-27": 5,
          "2026-03-30": 5,
          "2026-03-31": 9,
          "2026-04-01": 3,
          "2026-04-02": 4,
          "2026-04-06": 3,
          "2026-04-07": 2,
          "2026-04-08": 2,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 4,
          "2026-04-14": 8,
          "2026-04-15": 2,
          "2026-04-17": 1,
          "2026-04-18": 8,
          "2026-04-20": 1,
          "2026-04-21": 2,
          "2026-04-22": 6,
          "2026-04-23": 66,
          "2026-04-24": 2,
          "2026-04-27": 7,
          "2026-04-28": 5,
          "2026-04-29": 6,
          "2026-04-30": 7,
          "2026-05-02": 11,
          "2026-05-04": 10,
          "2026-05-05": 9,
          "2026-05-06": 60,
          "2026-05-07": 9,
          "2026-05-08": 7,
          "2026-05-11": 11,
          "2026-05-12": 9,
          "2026-05-13": 10,
          "2026-05-14": 17,
          "2026-05-15": 2,
          "2026-05-18": 13,
          "2026-05-19": 5,
          "2026-05-20": 2,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-25": 9,
          "2026-05-26": 10,
          "2026-05-27": 18,
          "2026-05-28": 4,
          "2026-05-29": 6,
          "2026-05-30": 13,
          "2026-06-01": 9,
          "2026-06-02": 6,
          "2026-06-03": 9,
          "2026-06-04": 1,
          "2026-06-05": 4,
          "2026-06-08": 5
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 229.37,
          "mode_time_hours": 33.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2,
            "4-6h": 1,
            "6-8h": 2,
            "12-14h": 1,
            "16-18h": 1,
            "18-20h": 2,
            "22-24h": 1,
            "32-34h": 2,
            "50-52h": 1,
            "92-94h": 1,
            "186-188h": 1,
            "250-252h": 1,
            "306-308h": 1,
            "308-310h": 1,
            "348-350h": 1,
            "386-388h": 1,
            "424-426h": 1,
            "604-606h": 1,
            "744-746h": 1,
            "890-892h": 1,
            "1180-1182h": 1
          },
          "tickets_count": 54,
          "tickets_per_day": {
            "2026-04-20": 2,
            "2026-04-23": 2,
            "2026-04-29": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-11": 3,
            "2026-05-12": 2,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-19": 2,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-25": 3,
            "2026-05-26": 2,
            "2026-05-27": 2,
            "2026-05-28": 3,
            "2026-05-29": 4,
            "2026-05-30": 5,
            "2026-06-01": 3,
            "2026-06-02": 2,
            "2026-06-03": 7,
            "2026-06-05": 1,
            "2026-06-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-04-23": 1636.906943888889,
            "2026-05-05": 32.2339425,
            "2026-05-06": 656.4510872222222,
            "2026-05-12": 41.747601111111116,
            "2026-05-19": 811.6213688888889,
            "2026-05-20": 18.01931,
            "2026-05-22": 250.13939944444445,
            "2026-05-26": 23.722966111111113,
            "2026-05-27": 308.6965025,
            "2026-05-28": 186.57898666666665,
            "2026-05-29": 50.160133055555555,
            "2026-05-30": 1816.6736647222224,
            "2026-06-01": 13.839698333333335,
            "2026-06-02": 110.54424138888889,
            "2026-06-03": 6.1547777777777775
          },
          "time_count_per_day": {
            "2026-04-23": 2,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-12": 2,
            "2026-05-19": 2,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-29": 1,
            "2026-05-30": 4,
            "2026-06-01": 3,
            "2026-06-02": 2,
            "2026-06-03": 2
          }
        },
        "P2": {
          "avg_time_hours": 232.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 57,
          "time_distribution": {
            "0-2h": 57,
            "2-4h": 38,
            "4-6h": 15,
            "6-8h": 5,
            "8-10h": 7,
            "10-12h": 7,
            "12-14h": 10,
            "14-16h": 3,
            "16-18h": 8,
            "18-20h": 6,
            "20-22h": 7,
            "22-24h": 7,
            "24-26h": 10,
            "26-28h": 7,
            "28-30h": 3,
            "30-32h": 2,
            "32-34h": 3,
            "34-36h": 1,
            "36-38h": 3,
            "38-40h": 3,
            "40-42h": 9,
            "42-44h": 2,
            "44-46h": 4,
            "46-48h": 3,
            "48-50h": 7,
            "50-52h": 4,
            "52-54h": 3,
            "54-56h": 2,
            "56-58h": 1,
            "58-60h": 2,
            "60-62h": 1,
            "62-64h": 1,
            "64-66h": 3,
            "66-68h": 1,
            "68-70h": 1,
            "72-74h": 4,
            "76-78h": 2,
            "80-82h": 3,
            "84-86h": 2,
            "86-88h": 1,
            "92-94h": 1,
            "96-98h": 2,
            "98-100h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "106-108h": 1,
            "114-116h": 2,
            "118-120h": 2,
            "120-122h": 2,
            "122-124h": 1,
            "140-142h": 1,
            "142-144h": 3,
            "144-146h": 2,
            "146-148h": 2,
            "148-150h": 1,
            "156-158h": 1,
            "160-162h": 2,
            "164-166h": 2,
            "166-168h": 1,
            "170-172h": 1,
            "172-174h": 1,
            "176-178h": 1,
            "192-194h": 1,
            "212-214h": 1,
            "216-218h": 1,
            "218-220h": 5,
            "230-232h": 1,
            "240-242h": 1,
            "246-248h": 2,
            "248-250h": 1,
            "252-254h": 1,
            "256-258h": 1,
            "260-262h": 1,
            "262-264h": 1,
            "264-266h": 1,
            "274-276h": 1,
            "276-278h": 1,
            "278-280h": 2,
            "300-302h": 1,
            "304-306h": 2,
            "310-312h": 1,
            "312-314h": 1,
            "314-316h": 1,
            "320-322h": 1,
            "326-328h": 1,
            "328-330h": 1,
            "330-332h": 1,
            "334-336h": 1,
            "336-338h": 4,
            "338-340h": 3,
            "342-344h": 2,
            "344-346h": 1,
            "348-350h": 2,
            "360-362h": 1,
            "362-364h": 3,
            "368-370h": 1,
            "372-374h": 2,
            "376-378h": 1,
            "386-388h": 2,
            "396-398h": 1,
            "408-410h": 2,
            "410-412h": 1,
            "412-414h": 1,
            "414-416h": 3,
            "420-422h": 1,
            "432-434h": 1,
            "452-454h": 1,
            "492-494h": 1,
            "508-510h": 1,
            "516-518h": 1,
            "522-524h": 1,
            "524-526h": 4,
            "528-530h": 2,
            "530-532h": 3,
            "538-540h": 1,
            "540-542h": 2,
            "542-544h": 2,
            "544-546h": 2,
            "556-558h": 1,
            "558-560h": 1,
            "562-564h": 1,
            "572-574h": 1,
            "576-578h": 2,
            "578-580h": 2,
            "582-584h": 1,
            "584-586h": 1,
            "594-596h": 1,
            "614-616h": 1,
            "616-618h": 3,
            "618-620h": 1,
            "622-624h": 1,
            "640-642h": 1,
            "646-648h": 1,
            "652-654h": 2,
            "654-656h": 2,
            "668-670h": 1,
            "670-672h": 1,
            "672-674h": 1,
            "674-676h": 1,
            "678-680h": 1,
            "684-686h": 1,
            "692-694h": 1,
            "696-698h": 3,
            "698-700h": 1,
            "700-702h": 2,
            "702-704h": 1,
            "718-720h": 1,
            "722-724h": 1,
            "746-748h": 1,
            "748-750h": 1,
            "750-752h": 1,
            "756-758h": 3,
            "768-770h": 1,
            "786-788h": 1,
            "794-796h": 1,
            "798-800h": 1,
            "814-816h": 1,
            "816-818h": 2,
            "834-836h": 1,
            "844-846h": 1,
            "886-888h": 1,
            "888-890h": 1,
            "890-892h": 1,
            "896-898h": 1,
            "902-904h": 1,
            "906-908h": 1,
            "922-924h": 1,
            "988-990h": 1,
            "1030-1032h": 2,
            "1054-1056h": 2,
            "1142-1144h": 1,
            "1152-1154h": 1,
            "1158-1160h": 1,
            "1218-1220h": 1,
            "1222-1224h": 1,
            "1390-1392h": 1,
            "1414-1416h": 1,
            "1560-1562h": 1,
            "1634-1636h": 1,
            "1670-1672h": 1,
            "2138-2140h": 1
          },
          "tickets_count": 625,
          "tickets_per_day": {
            "2025-12-09": 2,
            "2025-12-26": 1,
            "2026-01-23": 1,
            "2026-02-18": 1,
            "2026-03-03": 1,
            "2026-03-06": 1,
            "2026-03-09": 2,
            "2026-03-10": 2,
            "2026-03-11": 2,
            "2026-03-12": 6,
            "2026-03-13": 1,
            "2026-03-16": 10,
            "2026-03-17": 3,
            "2026-03-18": 8,
            "2026-03-19": 9,
            "2026-03-20": 3,
            "2026-03-23": 5,
            "2026-03-24": 3,
            "2026-03-25": 3,
            "2026-03-26": 7,
            "2026-03-27": 5,
            "2026-03-30": 5,
            "2026-03-31": 10,
            "2026-04-01": 2,
            "2026-04-02": 4,
            "2026-04-06": 3,
            "2026-04-07": 2,
            "2026-04-08": 2,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 9,
            "2026-04-15": 2,
            "2026-04-17": 1,
            "2026-04-18": 7,
            "2026-04-20": 1,
            "2026-04-21": 4,
            "2026-04-22": 6,
            "2026-04-23": 58,
            "2026-04-24": 6,
            "2026-04-27": 9,
            "2026-04-28": 5,
            "2026-04-29": 8,
            "2026-04-30": 10,
            "2026-05-02": 12,
            "2026-05-04": 15,
            "2026-05-05": 10,
            "2026-05-06": 65,
            "2026-05-07": 14,
            "2026-05-08": 11,
            "2026-05-11": 13,
            "2026-05-12": 37,
            "2026-05-13": 23,
            "2026-05-14": 22,
            "2026-05-15": 5,
            "2026-05-16": 1,
            "2026-05-18": 20,
            "2026-05-19": 3,
            "2026-05-20": 3,
            "2026-05-21": 1,
            "2026-05-25": 13,
            "2026-05-26": 14,
            "2026-05-27": 22,
            "2026-05-28": 10,
            "2026-05-29": 11,
            "2026-05-30": 12,
            "2026-06-01": 12,
            "2026-06-02": 6,
            "2026-06-03": 12,
            "2026-06-04": 1,
            "2026-06-05": 11,
            "2026-06-06": 1,
            "2026-06-07": 1,
            "2026-06-08": 8
          },
          "time_per_day": {
            "2026-01-23": 176.91004972222223,
            "2026-02-18": 1560.4081719444443,
            "2026-03-03": 2.4879641666666665,
            "2026-03-09": 78.206195,
            "2026-03-10": 4.5083786111111115,
            "2026-03-11": 18.11370638888889,
            "2026-03-12": 179.92828777777777,
            "2026-03-13": 44.54058888888889,
            "2026-03-16": 430.91426777777775,
            "2026-03-17": 119.95666472222223,
            "2026-03-18": 28.793728333333334,
            "2026-03-19": 2746.0016983333335,
            "2026-03-20": 1053.1728586111112,
            "2026-03-23": 57.86280416666666,
            "2026-03-24": 195.17969972222224,
            "2026-03-25": 68.16204694444444,
            "2026-03-26": 1276.041449166667,
            "2026-03-27": 11.809873888888887,
            "2026-03-30": 674.9224977777778,
            "2026-03-31": 579.5402841666667,
            "2026-04-01": 4.044201388888889,
            "2026-04-02": 608.6231416666667,
            "2026-04-06": 14.234016666666667,
            "2026-04-07": 32.383045,
            "2026-04-08": 215.45070972222223,
            "2026-04-10": 26.939643611111112,
            "2026-04-11": 14.23579,
            "2026-04-13": 142.41543361111113,
            "2026-04-14": 608.8405113888888,
            "2026-04-15": 64.93091166666667,
            "2026-04-17": 902.2539983333332,
            "2026-04-18": 5828.422834444445,
            "2026-04-20": 13.634943333333334,
            "2026-04-21": 2.898441666666667,
            "2026-04-22": 2795.8914086111104,
            "2026-04-23": 36182.42497111112,
            "2026-04-24": 576.2725880555556,
            "2026-04-27": 223.0165538888889,
            "2026-04-28": 155.27042805555553,
            "2026-04-29": 460.241965,
            "2026-04-30": 467.4924402777777,
            "2026-05-02": 827.9228861111111,
            "2026-05-04": 506.37765,
            "2026-05-05": 940.9273863888887,
            "2026-05-06": 20061.57901722223,
            "2026-05-07": 131.3409725,
            "2026-05-08": 324.0911369444445,
            "2026-05-11": 205.11060083333336,
            "2026-05-12": 44.946752777777775,
            "2026-05-13": 288.9755941666667,
            "2026-05-14": 4658.037812777778,
            "2026-05-15": 13.08796972222222,
            "2026-05-18": 818.7390113888889,
            "2026-05-19": 6.194001666666667,
            "2026-05-20": 59.27088222222223,
            "2026-05-21": 216.27364333333335,
            "2026-05-25": 650.206371111111,
            "2026-05-26": 390.96445916666664,
            "2026-05-27": 7336.3425705555555,
            "2026-05-28": 28.00848166666667,
            "2026-05-29": 179.02422499999997,
            "2026-05-30": 6860.676748611111,
            "2026-06-01": 278.39966277777773,
            "2026-06-02": 91.8179111111111,
            "2026-06-03": 370.36330472222227,
            "2026-06-04": 888.8700166666666,
            "2026-06-05": 162.39462305555554,
            "2026-06-08": 395.33272805555555
          },
          "time_count_per_day": {
            "2026-01-23": 1,
            "2026-02-18": 1,
            "2026-03-03": 1,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-12": 5,
            "2026-03-13": 1,
            "2026-03-16": 10,
            "2026-03-17": 3,
            "2026-03-18": 8,
            "2026-03-19": 9,
            "2026-03-20": 3,
            "2026-03-23": 5,
            "2026-03-24": 3,
            "2026-03-25": 2,
            "2026-03-26": 7,
            "2026-03-27": 5,
            "2026-03-30": 5,
            "2026-03-31": 9,
            "2026-04-01": 2,
            "2026-04-02": 4,
            "2026-04-06": 2,
            "2026-04-07": 2,
            "2026-04-08": 2,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 8,
            "2026-04-15": 2,
            "2026-04-17": 1,
            "2026-04-18": 7,
            "2026-04-20": 1,
            "2026-04-21": 2,
            "2026-04-22": 5,
            "2026-04-23": 57,
            "2026-04-24": 2,
            "2026-04-27": 7,
            "2026-04-28": 5,
            "2026-04-29": 6,
            "2026-04-30": 7,
            "2026-05-02": 11,
            "2026-05-04": 10,
            "2026-05-05": 8,
            "2026-05-06": 55,
            "2026-05-07": 9,
            "2026-05-08": 7,
            "2026-05-11": 11,
            "2026-05-12": 7,
            "2026-05-13": 9,
            "2026-05-14": 17,
            "2026-05-15": 2,
            "2026-05-18": 13,
            "2026-05-19": 3,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-25": 9,
            "2026-05-26": 9,
            "2026-05-27": 17,
            "2026-05-28": 3,
            "2026-05-29": 5,
            "2026-05-30": 9,
            "2026-06-01": 5,
            "2026-06-02": 4,
            "2026-06-03": 7,
            "2026-06-04": 1,
            "2026-06-05": 4,
            "2026-06-08": 5
          }
        },
        "P3": {
          "avg_time_hours": 616.46,
          "mode_time_hours": 617.0,
          "mode_frequency": 2,
          "time_distribution": {
            "6-8h": 1,
            "110-112h": 1,
            "124-126h": 1,
            "164-166h": 1,
            "174-176h": 1,
            "206-208h": 1,
            "210-212h": 1,
            "236-238h": 1,
            "246-248h": 1,
            "358-360h": 1,
            "428-430h": 1,
            "530-532h": 1,
            "558-560h": 1,
            "616-618h": 2,
            "646-648h": 1,
            "744-746h": 1,
            "916-918h": 1,
            "964-966h": 1,
            "988-990h": 1,
            "1018-1020h": 1,
            "1080-1082h": 1,
            "1324-1326h": 1,
            "1388-1390h": 1,
            "1732-1734h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-19": 3,
            "2026-04-01": 1,
            "2026-04-06": 1,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 7,
            "2026-05-05": 1,
            "2026-05-06": 3,
            "2026-05-13": 1,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2026-03-09": 7.930744444444445,
            "2026-03-10": 165.29195638888888,
            "2026-03-11": 111.32551249999999,
            "2026-03-12": 744.9844738888889,
            "2026-03-13": 1601.8432541666668,
            "2026-03-19": 1133.2669727777777,
            "2026-04-01": 174.61734694444445,
            "2026-04-06": 428.55958388888894,
            "2026-04-18": 964.5005186111111,
            "2026-04-22": 1325.4917419444444,
            "2026-04-23": 5455.177826666666,
            "2026-05-06": 1440.8615305555554,
            "2026-05-13": 124.98083999999999,
            "2026-06-01": 1732.6893233333335
          },
          "time_count_per_day": {
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-19": 3,
            "2026-04-01": 1,
            "2026-04-06": 1,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 7,
            "2026-05-06": 3,
            "2026-05-13": 1,
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 251.5,
            "mode_time_hours": 1.0,
            "mode_frequency": 58,
            "time_distribution": {
              "0-2h": 58,
              "2-4h": 40,
              "4-6h": 16,
              "6-8h": 8,
              "8-10h": 7,
              "10-12h": 7,
              "12-14h": 11,
              "14-16h": 3,
              "16-18h": 9,
              "18-20h": 8,
              "20-22h": 7,
              "22-24h": 8,
              "24-26h": 10,
              "26-28h": 7,
              "28-30h": 3,
              "30-32h": 2,
              "32-34h": 5,
              "34-36h": 1,
              "36-38h": 3,
              "38-40h": 3,
              "40-42h": 9,
              "42-44h": 2,
              "44-46h": 4,
              "46-48h": 3,
              "48-50h": 7,
              "50-52h": 5,
              "52-54h": 3,
              "54-56h": 2,
              "56-58h": 1,
              "58-60h": 2,
              "60-62h": 1,
              "62-64h": 1,
              "64-66h": 3,
              "66-68h": 1,
              "68-70h": 1,
              "72-74h": 4,
              "76-78h": 2,
              "80-82h": 3,
              "84-86h": 2,
              "86-88h": 1,
              "92-94h": 2,
              "96-98h": 2,
              "98-100h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "106-108h": 1,
              "110-112h": 1,
              "114-116h": 2,
              "118-120h": 2,
              "120-122h": 2,
              "122-124h": 1,
              "124-126h": 1,
              "140-142h": 1,
              "142-144h": 3,
              "144-146h": 2,
              "146-148h": 2,
              "148-150h": 1,
              "156-158h": 1,
              "160-162h": 2,
              "164-166h": 3,
              "166-168h": 1,
              "170-172h": 1,
              "172-174h": 1,
              "174-176h": 1,
              "176-178h": 1,
              "186-188h": 1,
              "192-194h": 1,
              "206-208h": 1,
              "210-212h": 1,
              "212-214h": 1,
              "216-218h": 1,
              "218-220h": 5,
              "230-232h": 1,
              "236-238h": 1,
              "240-242h": 1,
              "246-248h": 3,
              "248-250h": 1,
              "250-252h": 1,
              "252-254h": 1,
              "256-258h": 1,
              "260-262h": 1,
              "262-264h": 1,
              "264-266h": 1,
              "274-276h": 1,
              "276-278h": 1,
              "278-280h": 2,
              "300-302h": 1,
              "304-306h": 2,
              "306-308h": 1,
              "308-310h": 1,
              "310-312h": 1,
              "312-314h": 1,
              "314-316h": 1,
              "320-322h": 1,
              "326-328h": 1,
              "328-330h": 1,
              "330-332h": 1,
              "334-336h": 1,
              "336-338h": 4,
              "338-340h": 3,
              "342-344h": 2,
              "344-346h": 1,
              "348-350h": 3,
              "358-360h": 1,
              "360-362h": 1,
              "362-364h": 3,
              "368-370h": 1,
              "372-374h": 2,
              "376-378h": 1,
              "386-388h": 3,
              "396-398h": 1,
              "408-410h": 2,
              "410-412h": 1,
              "412-414h": 1,
              "414-416h": 3,
              "420-422h": 1,
              "424-426h": 1,
              "428-430h": 1,
              "432-434h": 1,
              "452-454h": 1,
              "492-494h": 1,
              "508-510h": 1,
              "516-518h": 1,
              "522-524h": 1,
              "524-526h": 4,
              "528-530h": 2,
              "530-532h": 4,
              "538-540h": 1,
              "540-542h": 2,
              "542-544h": 2,
              "544-546h": 2,
              "556-558h": 1,
              "558-560h": 2,
              "562-564h": 1,
              "572-574h": 1,
              "576-578h": 2,
              "578-580h": 2,
              "582-584h": 1,
              "584-586h": 1,
              "594-596h": 1,
              "604-606h": 1,
              "614-616h": 1,
              "616-618h": 5,
              "618-620h": 1,
              "622-624h": 1,
              "640-642h": 1,
              "646-648h": 2,
              "652-654h": 2,
              "654-656h": 2,
              "668-670h": 1,
              "670-672h": 1,
              "672-674h": 1,
              "674-676h": 1,
              "678-680h": 1,
              "684-686h": 1,
              "692-694h": 1,
              "696-698h": 3,
              "698-700h": 1,
              "700-702h": 2,
              "702-704h": 1,
              "718-720h": 1,
              "722-724h": 1,
              "744-746h": 2,
              "746-748h": 1,
              "748-750h": 1,
              "750-752h": 1,
              "756-758h": 3,
              "768-770h": 1,
              "786-788h": 1,
              "794-796h": 1,
              "798-800h": 1,
              "814-816h": 1,
              "816-818h": 2,
              "834-836h": 1,
              "844-846h": 1,
              "886-888h": 1,
              "888-890h": 1,
              "890-892h": 2,
              "896-898h": 1,
              "902-904h": 1,
              "906-908h": 1,
              "916-918h": 1,
              "922-924h": 1,
              "964-966h": 1,
              "988-990h": 2,
              "1018-1020h": 1,
              "1030-1032h": 2,
              "1054-1056h": 2,
              "1080-1082h": 1,
              "1142-1144h": 1,
              "1152-1154h": 1,
              "1158-1160h": 1,
              "1180-1182h": 1,
              "1218-1220h": 1,
              "1222-1224h": 1,
              "1324-1326h": 1,
              "1388-1390h": 1,
              "1390-1392h": 1,
              "1414-1416h": 1,
              "1560-1562h": 1,
              "1634-1636h": 1,
              "1670-1672h": 1,
              "1732-1734h": 1,
              "2138-2140h": 1
            },
            "tickets_count": 504,
            "tickets_per_day": {
              "2026-01-23": 1,
              "2026-02-18": 1,
              "2026-03-03": 1,
              "2026-03-09": 3,
              "2026-03-10": 2,
              "2026-03-11": 3,
              "2026-03-12": 6,
              "2026-03-13": 3,
              "2026-03-16": 10,
              "2026-03-17": 3,
              "2026-03-18": 8,
              "2026-03-19": 12,
              "2026-03-20": 3,
              "2026-03-23": 5,
              "2026-03-24": 3,
              "2026-03-25": 2,
              "2026-03-26": 7,
              "2026-03-27": 5,
              "2026-03-30": 5,
              "2026-03-31": 9,
              "2026-04-01": 3,
              "2026-04-02": 4,
              "2026-04-06": 3,
              "2026-04-07": 2,
              "2026-04-08": 2,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 8,
              "2026-04-15": 2,
              "2026-04-17": 1,
              "2026-04-18": 8,
              "2026-04-20": 1,
              "2026-04-21": 2,
              "2026-04-22": 6,
              "2026-04-23": 66,
              "2026-04-24": 2,
              "2026-04-27": 7,
              "2026-04-28": 5,
              "2026-04-29": 6,
              "2026-04-30": 7,
              "2026-05-02": 11,
              "2026-05-04": 10,
              "2026-05-05": 9,
              "2026-05-06": 60,
              "2026-05-07": 9,
              "2026-05-08": 7,
              "2026-05-11": 11,
              "2026-05-12": 9,
              "2026-05-13": 10,
              "2026-05-14": 17,
              "2026-05-15": 2,
              "2026-05-18": 13,
              "2026-05-19": 5,
              "2026-05-20": 2,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 9,
              "2026-05-26": 10,
              "2026-05-27": 18,
              "2026-05-28": 4,
              "2026-05-29": 6,
              "2026-05-30": 13,
              "2026-06-01": 9,
              "2026-06-02": 6,
              "2026-06-03": 9,
              "2026-06-04": 1,
              "2026-06-05": 4,
              "2026-06-08": 5
            },
            "time_per_day": {
              "2026-01-23": 176.91004972222223,
              "2026-02-18": 1560.4081719444443,
              "2026-03-03": 2.4879641666666665,
              "2026-03-09": 86.13693944444444,
              "2026-03-10": 169.800335,
              "2026-03-11": 129.4392188888889,
              "2026-03-12": 924.9127616666667,
              "2026-03-13": 1646.3838430555556,
              "2026-03-16": 430.91426777777775,
              "2026-03-17": 119.95666472222223,
              "2026-03-18": 28.793728333333334,
              "2026-03-19": 3879.268671111111,
              "2026-03-20": 1053.1728586111112,
              "2026-03-23": 57.86280416666666,
              "2026-03-24": 195.17969972222224,
              "2026-03-25": 68.16204694444444,
              "2026-03-26": 1276.041449166667,
              "2026-03-27": 11.809873888888887,
              "2026-03-30": 674.9224977777778,
              "2026-03-31": 579.5402841666667,
              "2026-04-01": 178.66154833333334,
              "2026-04-02": 608.6231416666667,
              "2026-04-06": 442.7936005555556,
              "2026-04-07": 32.383045,
              "2026-04-08": 215.45070972222223,
              "2026-04-10": 26.939643611111112,
              "2026-04-11": 14.23579,
              "2026-04-13": 142.41543361111113,
              "2026-04-14": 608.8405113888888,
              "2026-04-15": 64.93091166666667,
              "2026-04-17": 902.2539983333332,
              "2026-04-18": 6792.923353055555,
              "2026-04-20": 13.634943333333334,
              "2026-04-21": 2.898441666666667,
              "2026-04-22": 4121.383150555555,
              "2026-04-23": 43274.50974166669,
              "2026-04-24": 576.2725880555556,
              "2026-04-27": 223.0165538888889,
              "2026-04-28": 155.27042805555553,
              "2026-04-29": 460.241965,
              "2026-04-30": 467.4924402777777,
              "2026-05-02": 827.9228861111111,
              "2026-05-04": 506.37765,
              "2026-05-05": 973.1613288888888,
              "2026-05-06": 22158.891635000007,
              "2026-05-07": 131.3409725,
              "2026-05-08": 324.0911369444445,
              "2026-05-11": 205.11060083333336,
              "2026-05-12": 86.69435388888888,
              "2026-05-13": 413.95643416666667,
              "2026-05-14": 4658.037812777778,
              "2026-05-15": 13.08796972222222,
              "2026-05-18": 818.7390113888889,
              "2026-05-19": 817.8153705555555,
              "2026-05-20": 77.29019222222223,
              "2026-05-21": 216.27364333333335,
              "2026-05-22": 250.13939944444445,
              "2026-05-25": 650.206371111111,
              "2026-05-26": 414.6874252777778,
              "2026-05-27": 7645.0390730555555,
              "2026-05-28": 214.58746833333333,
              "2026-05-29": 229.18435805555552,
              "2026-05-30": 8677.350413333335,
              "2026-06-01": 2024.9286844444446,
              "2026-06-02": 202.3621525,
              "2026-06-03": 376.51808250000005,
              "2026-06-04": 888.8700166666666,
              "2026-06-05": 162.39462305555554,
              "2026-06-08": 395.33272805555555
            },
            "time_count_per_day": {
              "2026-01-23": 1,
              "2026-02-18": 1,
              "2026-03-03": 1,
              "2026-03-09": 3,
              "2026-03-10": 2,
              "2026-03-11": 3,
              "2026-03-12": 6,
              "2026-03-13": 3,
              "2026-03-16": 10,
              "2026-03-17": 3,
              "2026-03-18": 8,
              "2026-03-19": 12,
              "2026-03-20": 3,
              "2026-03-23": 5,
              "2026-03-24": 3,
              "2026-03-25": 2,
              "2026-03-26": 7,
              "2026-03-27": 5,
              "2026-03-30": 5,
              "2026-03-31": 9,
              "2026-04-01": 3,
              "2026-04-02": 4,
              "2026-04-06": 3,
              "2026-04-07": 2,
              "2026-04-08": 2,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 8,
              "2026-04-15": 2,
              "2026-04-17": 1,
              "2026-04-18": 8,
              "2026-04-20": 1,
              "2026-04-21": 2,
              "2026-04-22": 6,
              "2026-04-23": 66,
              "2026-04-24": 2,
              "2026-04-27": 7,
              "2026-04-28": 5,
              "2026-04-29": 6,
              "2026-04-30": 7,
              "2026-05-02": 11,
              "2026-05-04": 10,
              "2026-05-05": 9,
              "2026-05-06": 60,
              "2026-05-07": 9,
              "2026-05-08": 7,
              "2026-05-11": 11,
              "2026-05-12": 9,
              "2026-05-13": 10,
              "2026-05-14": 17,
              "2026-05-15": 2,
              "2026-05-18": 13,
              "2026-05-19": 5,
              "2026-05-20": 2,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 9,
              "2026-05-26": 10,
              "2026-05-27": 18,
              "2026-05-28": 4,
              "2026-05-29": 6,
              "2026-05-30": 13,
              "2026-06-01": 9,
              "2026-06-02": 6,
              "2026-06-03": 9,
              "2026-06-04": 1,
              "2026-06-05": 4,
              "2026-06-08": 5
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 229.37,
              "mode_time_hours": 33.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2,
                "4-6h": 1,
                "6-8h": 2,
                "12-14h": 1,
                "16-18h": 1,
                "18-20h": 2,
                "22-24h": 1,
                "32-34h": 2,
                "50-52h": 1,
                "92-94h": 1,
                "186-188h": 1,
                "250-252h": 1,
                "306-308h": 1,
                "308-310h": 1,
                "348-350h": 1,
                "386-388h": 1,
                "424-426h": 1,
                "604-606h": 1,
                "744-746h": 1,
                "890-892h": 1,
                "1180-1182h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2026-04-23": 2,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-12": 2,
                "2026-05-19": 2,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-05-30": 4,
                "2026-06-01": 3,
                "2026-06-02": 2,
                "2026-06-03": 2
              },
              "time_per_day": {
                "2026-04-23": 1636.906943888889,
                "2026-05-05": 32.2339425,
                "2026-05-06": 656.4510872222222,
                "2026-05-12": 41.747601111111116,
                "2026-05-19": 811.6213688888889,
                "2026-05-20": 18.01931,
                "2026-05-22": 250.13939944444445,
                "2026-05-26": 23.722966111111113,
                "2026-05-27": 308.6965025,
                "2026-05-28": 186.57898666666665,
                "2026-05-29": 50.160133055555555,
                "2026-05-30": 1816.6736647222224,
                "2026-06-01": 13.839698333333335,
                "2026-06-02": 110.54424138888889,
                "2026-06-03": 6.1547777777777775
              },
              "time_count_per_day": {
                "2026-04-23": 2,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-12": 2,
                "2026-05-19": 2,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-05-30": 4,
                "2026-06-01": 3,
                "2026-06-02": 2,
                "2026-06-03": 2
              }
            },
            "P2": {
              "avg_time_hours": 232.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 57,
              "time_distribution": {
                "0-2h": 57,
                "2-4h": 38,
                "4-6h": 15,
                "6-8h": 5,
                "8-10h": 7,
                "10-12h": 7,
                "12-14h": 10,
                "14-16h": 3,
                "16-18h": 8,
                "18-20h": 6,
                "20-22h": 7,
                "22-24h": 7,
                "24-26h": 10,
                "26-28h": 7,
                "28-30h": 3,
                "30-32h": 2,
                "32-34h": 3,
                "34-36h": 1,
                "36-38h": 3,
                "38-40h": 3,
                "40-42h": 9,
                "42-44h": 2,
                "44-46h": 4,
                "46-48h": 3,
                "48-50h": 7,
                "50-52h": 4,
                "52-54h": 3,
                "54-56h": 2,
                "56-58h": 1,
                "58-60h": 2,
                "60-62h": 1,
                "62-64h": 1,
                "64-66h": 3,
                "66-68h": 1,
                "68-70h": 1,
                "72-74h": 4,
                "76-78h": 2,
                "80-82h": 3,
                "84-86h": 2,
                "86-88h": 1,
                "92-94h": 1,
                "96-98h": 2,
                "98-100h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "106-108h": 1,
                "114-116h": 2,
                "118-120h": 2,
                "120-122h": 2,
                "122-124h": 1,
                "140-142h": 1,
                "142-144h": 3,
                "144-146h": 2,
                "146-148h": 2,
                "148-150h": 1,
                "156-158h": 1,
                "160-162h": 2,
                "164-166h": 2,
                "166-168h": 1,
                "170-172h": 1,
                "172-174h": 1,
                "176-178h": 1,
                "192-194h": 1,
                "212-214h": 1,
                "216-218h": 1,
                "218-220h": 5,
                "230-232h": 1,
                "240-242h": 1,
                "246-248h": 2,
                "248-250h": 1,
                "252-254h": 1,
                "256-258h": 1,
                "260-262h": 1,
                "262-264h": 1,
                "264-266h": 1,
                "274-276h": 1,
                "276-278h": 1,
                "278-280h": 2,
                "300-302h": 1,
                "304-306h": 2,
                "310-312h": 1,
                "312-314h": 1,
                "314-316h": 1,
                "320-322h": 1,
                "326-328h": 1,
                "328-330h": 1,
                "330-332h": 1,
                "334-336h": 1,
                "336-338h": 4,
                "338-340h": 3,
                "342-344h": 2,
                "344-346h": 1,
                "348-350h": 2,
                "360-362h": 1,
                "362-364h": 3,
                "368-370h": 1,
                "372-374h": 2,
                "376-378h": 1,
                "386-388h": 2,
                "396-398h": 1,
                "408-410h": 2,
                "410-412h": 1,
                "412-414h": 1,
                "414-416h": 3,
                "420-422h": 1,
                "432-434h": 1,
                "452-454h": 1,
                "492-494h": 1,
                "508-510h": 1,
                "516-518h": 1,
                "522-524h": 1,
                "524-526h": 4,
                "528-530h": 2,
                "530-532h": 3,
                "538-540h": 1,
                "540-542h": 2,
                "542-544h": 2,
                "544-546h": 2,
                "556-558h": 1,
                "558-560h": 1,
                "562-564h": 1,
                "572-574h": 1,
                "576-578h": 2,
                "578-580h": 2,
                "582-584h": 1,
                "584-586h": 1,
                "594-596h": 1,
                "614-616h": 1,
                "616-618h": 3,
                "618-620h": 1,
                "622-624h": 1,
                "640-642h": 1,
                "646-648h": 1,
                "652-654h": 2,
                "654-656h": 2,
                "668-670h": 1,
                "670-672h": 1,
                "672-674h": 1,
                "674-676h": 1,
                "678-680h": 1,
                "684-686h": 1,
                "692-694h": 1,
                "696-698h": 3,
                "698-700h": 1,
                "700-702h": 2,
                "702-704h": 1,
                "718-720h": 1,
                "722-724h": 1,
                "746-748h": 1,
                "748-750h": 1,
                "750-752h": 1,
                "756-758h": 3,
                "768-770h": 1,
                "786-788h": 1,
                "794-796h": 1,
                "798-800h": 1,
                "814-816h": 1,
                "816-818h": 2,
                "834-836h": 1,
                "844-846h": 1,
                "886-888h": 1,
                "888-890h": 1,
                "890-892h": 1,
                "896-898h": 1,
                "902-904h": 1,
                "906-908h": 1,
                "922-924h": 1,
                "988-990h": 1,
                "1030-1032h": 2,
                "1054-1056h": 2,
                "1142-1144h": 1,
                "1152-1154h": 1,
                "1158-1160h": 1,
                "1218-1220h": 1,
                "1222-1224h": 1,
                "1390-1392h": 1,
                "1414-1416h": 1,
                "1560-1562h": 1,
                "1634-1636h": 1,
                "1670-1672h": 1,
                "2138-2140h": 1
              },
              "tickets_count": 453,
              "tickets_per_day": {
                "2026-01-23": 1,
                "2026-02-18": 1,
                "2026-03-03": 1,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 5,
                "2026-03-13": 1,
                "2026-03-16": 10,
                "2026-03-17": 3,
                "2026-03-18": 8,
                "2026-03-19": 9,
                "2026-03-20": 3,
                "2026-03-23": 5,
                "2026-03-24": 3,
                "2026-03-25": 2,
                "2026-03-26": 7,
                "2026-03-27": 5,
                "2026-03-30": 5,
                "2026-03-31": 9,
                "2026-04-01": 2,
                "2026-04-02": 4,
                "2026-04-06": 2,
                "2026-04-07": 2,
                "2026-04-08": 2,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 8,
                "2026-04-15": 2,
                "2026-04-17": 1,
                "2026-04-18": 7,
                "2026-04-20": 1,
                "2026-04-21": 2,
                "2026-04-22": 5,
                "2026-04-23": 57,
                "2026-04-24": 2,
                "2026-04-27": 7,
                "2026-04-28": 5,
                "2026-04-29": 6,
                "2026-04-30": 7,
                "2026-05-02": 11,
                "2026-05-04": 10,
                "2026-05-05": 8,
                "2026-05-06": 55,
                "2026-05-07": 9,
                "2026-05-08": 7,
                "2026-05-11": 11,
                "2026-05-12": 7,
                "2026-05-13": 9,
                "2026-05-14": 17,
                "2026-05-15": 2,
                "2026-05-18": 13,
                "2026-05-19": 3,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-25": 9,
                "2026-05-26": 9,
                "2026-05-27": 17,
                "2026-05-28": 3,
                "2026-05-29": 5,
                "2026-05-30": 9,
                "2026-06-01": 5,
                "2026-06-02": 4,
                "2026-06-03": 7,
                "2026-06-04": 1,
                "2026-06-05": 4,
                "2026-06-08": 5
              },
              "time_per_day": {
                "2026-01-23": 176.91004972222223,
                "2026-02-18": 1560.4081719444443,
                "2026-03-03": 2.4879641666666665,
                "2026-03-09": 78.206195,
                "2026-03-10": 4.5083786111111115,
                "2026-03-11": 18.11370638888889,
                "2026-03-12": 179.92828777777777,
                "2026-03-13": 44.54058888888889,
                "2026-03-16": 430.91426777777775,
                "2026-03-17": 119.95666472222223,
                "2026-03-18": 28.793728333333334,
                "2026-03-19": 2746.0016983333335,
                "2026-03-20": 1053.1728586111112,
                "2026-03-23": 57.86280416666666,
                "2026-03-24": 195.17969972222224,
                "2026-03-25": 68.16204694444444,
                "2026-03-26": 1276.041449166667,
                "2026-03-27": 11.809873888888887,
                "2026-03-30": 674.9224977777778,
                "2026-03-31": 579.5402841666667,
                "2026-04-01": 4.044201388888889,
                "2026-04-02": 608.6231416666667,
                "2026-04-06": 14.234016666666667,
                "2026-04-07": 32.383045,
                "2026-04-08": 215.45070972222223,
                "2026-04-10": 26.939643611111112,
                "2026-04-11": 14.23579,
                "2026-04-13": 142.41543361111113,
                "2026-04-14": 608.8405113888888,
                "2026-04-15": 64.93091166666667,
                "2026-04-17": 902.2539983333332,
                "2026-04-18": 5828.422834444445,
                "2026-04-20": 13.634943333333334,
                "2026-04-21": 2.898441666666667,
                "2026-04-22": 2795.8914086111104,
                "2026-04-23": 36182.42497111112,
                "2026-04-24": 576.2725880555556,
                "2026-04-27": 223.0165538888889,
                "2026-04-28": 155.27042805555553,
                "2026-04-29": 460.241965,
                "2026-04-30": 467.4924402777777,
                "2026-05-02": 827.9228861111111,
                "2026-05-04": 506.37765,
                "2026-05-05": 940.9273863888887,
                "2026-05-06": 20061.57901722223,
                "2026-05-07": 131.3409725,
                "2026-05-08": 324.0911369444445,
                "2026-05-11": 205.11060083333336,
                "2026-05-12": 44.946752777777775,
                "2026-05-13": 288.9755941666667,
                "2026-05-14": 4658.037812777778,
                "2026-05-15": 13.08796972222222,
                "2026-05-18": 818.7390113888889,
                "2026-05-19": 6.194001666666667,
                "2026-05-20": 59.27088222222223,
                "2026-05-21": 216.27364333333335,
                "2026-05-25": 650.206371111111,
                "2026-05-26": 390.96445916666664,
                "2026-05-27": 7336.3425705555555,
                "2026-05-28": 28.00848166666667,
                "2026-05-29": 179.02422499999997,
                "2026-05-30": 6860.676748611111,
                "2026-06-01": 278.39966277777773,
                "2026-06-02": 91.8179111111111,
                "2026-06-03": 370.36330472222227,
                "2026-06-04": 888.8700166666666,
                "2026-06-05": 162.39462305555554,
                "2026-06-08": 395.33272805555555
              },
              "time_count_per_day": {
                "2026-01-23": 1,
                "2026-02-18": 1,
                "2026-03-03": 1,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 5,
                "2026-03-13": 1,
                "2026-03-16": 10,
                "2026-03-17": 3,
                "2026-03-18": 8,
                "2026-03-19": 9,
                "2026-03-20": 3,
                "2026-03-23": 5,
                "2026-03-24": 3,
                "2026-03-25": 2,
                "2026-03-26": 7,
                "2026-03-27": 5,
                "2026-03-30": 5,
                "2026-03-31": 9,
                "2026-04-01": 2,
                "2026-04-02": 4,
                "2026-04-06": 2,
                "2026-04-07": 2,
                "2026-04-08": 2,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 8,
                "2026-04-15": 2,
                "2026-04-17": 1,
                "2026-04-18": 7,
                "2026-04-20": 1,
                "2026-04-21": 2,
                "2026-04-22": 5,
                "2026-04-23": 57,
                "2026-04-24": 2,
                "2026-04-27": 7,
                "2026-04-28": 5,
                "2026-04-29": 6,
                "2026-04-30": 7,
                "2026-05-02": 11,
                "2026-05-04": 10,
                "2026-05-05": 8,
                "2026-05-06": 55,
                "2026-05-07": 9,
                "2026-05-08": 7,
                "2026-05-11": 11,
                "2026-05-12": 7,
                "2026-05-13": 9,
                "2026-05-14": 17,
                "2026-05-15": 2,
                "2026-05-18": 13,
                "2026-05-19": 3,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-25": 9,
                "2026-05-26": 9,
                "2026-05-27": 17,
                "2026-05-28": 3,
                "2026-05-29": 5,
                "2026-05-30": 9,
                "2026-06-01": 5,
                "2026-06-02": 4,
                "2026-06-03": 7,
                "2026-06-04": 1,
                "2026-06-05": 4,
                "2026-06-08": 5
              }
            },
            "P3": {
              "avg_time_hours": 616.46,
              "mode_time_hours": 617.0,
              "mode_frequency": 2,
              "time_distribution": {
                "6-8h": 1,
                "110-112h": 1,
                "124-126h": 1,
                "164-166h": 1,
                "174-176h": 1,
                "206-208h": 1,
                "210-212h": 1,
                "236-238h": 1,
                "246-248h": 1,
                "358-360h": 1,
                "428-430h": 1,
                "530-532h": 1,
                "558-560h": 1,
                "616-618h": 2,
                "646-648h": 1,
                "744-746h": 1,
                "916-918h": 1,
                "964-966h": 1,
                "988-990h": 1,
                "1018-1020h": 1,
                "1080-1082h": 1,
                "1324-1326h": 1,
                "1388-1390h": 1,
                "1732-1734h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-19": 3,
                "2026-04-01": 1,
                "2026-04-06": 1,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 7,
                "2026-05-06": 3,
                "2026-05-13": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-03-09": 7.930744444444445,
                "2026-03-10": 165.29195638888888,
                "2026-03-11": 111.32551249999999,
                "2026-03-12": 744.9844738888889,
                "2026-03-13": 1601.8432541666668,
                "2026-03-19": 1133.2669727777777,
                "2026-04-01": 174.61734694444445,
                "2026-04-06": 428.55958388888894,
                "2026-04-18": 964.5005186111111,
                "2026-04-22": 1325.4917419444444,
                "2026-04-23": 5455.177826666666,
                "2026-05-06": 1440.8615305555554,
                "2026-05-13": 124.98083999999999,
                "2026-06-01": 1732.6893233333335
              },
              "time_count_per_day": {
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-19": 3,
                "2026-04-01": 1,
                "2026-04-06": 1,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 7,
                "2026-05-06": 3,
                "2026-05-13": 1,
                "2026-06-01": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-05-28": 1,
              "2026-06-01": 1,
              "2026-06-06": 1,
              "2026-06-07": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-05-28": 1,
                "2026-06-01": 1,
                "2026-06-07": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 128,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2025-12-26": 1,
              "2026-03-06": 1,
              "2026-03-31": 1,
              "2026-04-20": 2,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-04-30": 3,
              "2026-05-04": 4,
              "2026-05-05": 1,
              "2026-05-06": 9,
              "2026-05-07": 2,
              "2026-05-08": 4,
              "2026-05-11": 2,
              "2026-05-12": 28,
              "2026-05-13": 10,
              "2026-05-14": 5,
              "2026-05-15": 4,
              "2026-05-16": 1,
              "2026-05-18": 4,
              "2026-05-20": 2,
              "2026-05-25": 4,
              "2026-05-26": 6,
              "2026-05-27": 2,
              "2026-05-28": 3,
              "2026-05-29": 4,
              "2026-05-30": 1,
              "2026-06-01": 4,
              "2026-06-02": 2,
              "2026-06-03": 8,
              "2026-06-05": 4,
              "2026-06-06": 1,
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-04-20": 2,
                "2026-05-11": 1,
                "2026-05-15": 1,
                "2026-05-25": 1,
                "2026-05-26": 1,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-06-03": 5,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 113,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2025-12-26": 1,
                "2026-03-06": 1,
                "2026-03-31": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-04-30": 3,
                "2026-05-04": 4,
                "2026-05-05": 1,
                "2026-05-06": 9,
                "2026-05-07": 2,
                "2026-05-08": 4,
                "2026-05-11": 1,
                "2026-05-12": 28,
                "2026-05-13": 10,
                "2026-05-14": 5,
                "2026-05-15": 3,
                "2026-05-16": 1,
                "2026-05-18": 4,
                "2026-05-20": 2,
                "2026-05-25": 3,
                "2026-05-26": 5,
                "2026-05-27": 2,
                "2026-05-28": 2,
                "2026-05-29": 3,
                "2026-05-30": 1,
                "2026-06-01": 3,
                "2026-06-02": 2,
                "2026-06-03": 3,
                "2026-06-05": 3,
                "2026-06-06": 1,
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 65,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2026-03-25": 1,
              "2026-04-06": 1,
              "2026-04-14": 1,
              "2026-04-21": 2,
              "2026-04-22": 1,
              "2026-04-24": 4,
              "2026-04-29": 3,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-07": 2,
              "2026-05-11": 3,
              "2026-05-12": 2,
              "2026-05-13": 5,
              "2026-05-14": 1,
              "2026-05-18": 3,
              "2026-05-25": 3,
              "2026-05-27": 4,
              "2026-05-28": 5,
              "2026-05-29": 5,
              "2026-05-30": 3,
              "2026-06-01": 3,
              "2026-06-03": 2,
              "2026-06-05": 4,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-04-29": 1,
                "2026-05-11": 2,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-25": 2,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-05-29": 2,
                "2026-05-30": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 51,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2026-03-25": 1,
                "2026-04-06": 1,
                "2026-04-14": 1,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-24": 4,
                "2026-04-29": 2,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-11": 1,
                "2026-05-12": 2,
                "2026-05-13": 4,
                "2026-05-18": 3,
                "2026-05-25": 1,
                "2026-05-27": 3,
                "2026-05-28": 4,
                "2026-05-29": 3,
                "2026-05-30": 2,
                "2026-06-01": 3,
                "2026-06-03": 2,
                "2026-06-05": 4
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-05-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    }
  },
  "customers": {
    "cliente_23": {
      "overall": {
        "avg_time_hours": 80.89,
        "mode_time_hours": 1.0,
        "mode_frequency": 14,
        "time_distribution": {
          "0-2h": 14,
          "4-6h": 1,
          "14-16h": 1,
          "246-248h": 1,
          "276-278h": 1,
          "972-974h": 1
        },
        "tickets_count": 20,
        "tickets_per_day": {
          "2025-09-30": 2,
          "2026-01-27": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-05-18": 1,
          "2026-05-22": 4,
          "2026-05-26": 4
        },
        "time_per_day": {
          "2025-09-30": 2.4448716666666668,
          "2026-01-27": 1.6880758333333334,
          "2026-01-31": 1.3933588888888888,
          "2026-02-03": 277.6776038888889,
          "2026-02-13": 15.550350833333333,
          "2026-02-26": 0.5560836111111112,
          "2026-03-02": 5.952630555555556,
          "2026-03-04": 1.8958608333333333,
          "2026-03-09": 973.4645041666666,
          "2026-03-19": 247.8656536111111,
          "2026-05-22": 5.618426666666667,
          "2026-05-26": 2.764438888888889
        },
        "time_count_per_day": {
          "2025-09-30": 2,
          "2026-01-27": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-05-22": 4,
          "2026-05-26": 4
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-09-30": 2
          },
          "time_per_day": {
            "2025-09-30": 2.4448716666666668
          },
          "time_count_per_day": {
            "2025-09-30": 2
          }
        },
        "P2": {
          "avg_time_hours": 78.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 12,
          "time_distribution": {
            "0-2h": 12,
            "4-6h": 1,
            "14-16h": 1,
            "246-248h": 1,
            "972-974h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-01-31": 1,
            "2026-02-13": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-05-18": 1,
            "2026-05-22": 4,
            "2026-05-26": 4
          },
          "time_per_day": {
            "2026-01-27": 1.6880758333333334,
            "2026-01-31": 1.3933588888888888,
            "2026-02-13": 15.550350833333333,
            "2026-02-26": 0.5560836111111112,
            "2026-03-02": 5.952630555555556,
            "2026-03-04": 1.8958608333333333,
            "2026-03-09": 973.4645041666666,
            "2026-03-19": 247.8656536111111,
            "2026-05-22": 5.618426666666667,
            "2026-05-26": 2.764438888888889
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-01-31": 1,
            "2026-02-13": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-05-22": 4,
            "2026-05-26": 4
          }
        },
        "P3": {
          "avg_time_hours": 277.68,
          "mode_time_hours": 277.0,
          "mode_frequency": 1,
          "time_distribution": {
            "276-278h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 277.6776038888889
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 80.89,
            "mode_time_hours": 1.0,
            "mode_frequency": 14,
            "time_distribution": {
              "0-2h": 14,
              "4-6h": 1,
              "14-16h": 1,
              "246-248h": 1,
              "276-278h": 1,
              "972-974h": 1
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-09-30": 2,
              "2026-01-27": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-05-22": 4,
              "2026-05-26": 4
            },
            "time_per_day": {
              "2025-09-30": 2.4448716666666668,
              "2026-01-27": 1.6880758333333334,
              "2026-01-31": 1.3933588888888888,
              "2026-02-03": 277.6776038888889,
              "2026-02-13": 15.550350833333333,
              "2026-02-26": 0.5560836111111112,
              "2026-03-02": 5.952630555555556,
              "2026-03-04": 1.8958608333333333,
              "2026-03-09": 973.4645041666666,
              "2026-03-19": 247.8656536111111,
              "2026-05-22": 5.618426666666667,
              "2026-05-26": 2.764438888888889
            },
            "time_count_per_day": {
              "2025-09-30": 2,
              "2026-01-27": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-05-22": 4,
              "2026-05-26": 4
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-09-30": 2
              },
              "time_per_day": {
                "2025-09-30": 2.4448716666666668
              },
              "time_count_per_day": {
                "2025-09-30": 2
              }
            },
            "P2": {
              "avg_time_hours": 78.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 12,
              "time_distribution": {
                "0-2h": 12,
                "4-6h": 1,
                "14-16h": 1,
                "246-248h": 1,
                "972-974h": 1
              },
              "tickets_count": 16,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-01-31": 1,
                "2026-02-13": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-05-22": 4,
                "2026-05-26": 4
              },
              "time_per_day": {
                "2026-01-27": 1.6880758333333334,
                "2026-01-31": 1.3933588888888888,
                "2026-02-13": 15.550350833333333,
                "2026-02-26": 0.5560836111111112,
                "2026-03-02": 5.952630555555556,
                "2026-03-04": 1.8958608333333333,
                "2026-03-09": 973.4645041666666,
                "2026-03-19": 247.8656536111111,
                "2026-05-22": 5.618426666666667,
                "2026-05-26": 2.764438888888889
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-01-31": 1,
                "2026-02-13": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-05-22": 4,
                "2026-05-26": 4
              }
            },
            "P3": {
              "avg_time_hours": 277.68,
              "mode_time_hours": 277.0,
              "mode_frequency": 1,
              "time_distribution": {
                "276-278h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 277.6776038888889
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_24": {
      "overall": {
        "avg_time_hours": 2.35,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-09-30": 1
        },
        "time_per_day": {
          "2025-09-30": 2.3502780555555556
        },
        "time_count_per_day": {
          "2025-09-30": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 2.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-09-30": 1
          },
          "time_per_day": {
            "2025-09-30": 2.3502780555555556
          },
          "time_count_per_day": {
            "2025-09-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.35,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-09-30": 1
            },
            "time_per_day": {
              "2025-09-30": 2.3502780555555556
            },
            "time_count_per_day": {
              "2025-09-30": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 2.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-09-30": 1
              },
              "time_per_day": {
                "2025-09-30": 2.3502780555555556
              },
              "time_count_per_day": {
                "2025-09-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_22": {
      "overall": {
        "avg_time_hours": 107.29,
        "mode_time_hours": 1.0,
        "mode_frequency": 452,
        "time_distribution": {
          "0-2h": 452,
          "2-4h": 89,
          "4-6h": 17,
          "6-8h": 19,
          "8-10h": 6,
          "10-12h": 7,
          "12-14h": 3,
          "14-16h": 6,
          "16-18h": 6,
          "18-20h": 18,
          "20-22h": 24,
          "22-24h": 21,
          "24-26h": 11,
          "26-28h": 5,
          "28-30h": 12,
          "30-32h": 12,
          "32-34h": 8,
          "34-36h": 7,
          "36-38h": 8,
          "38-40h": 2,
          "40-42h": 12,
          "42-44h": 3,
          "44-46h": 9,
          "46-48h": 7,
          "48-50h": 4,
          "50-52h": 5,
          "52-54h": 8,
          "54-56h": 2,
          "56-58h": 1,
          "58-60h": 2,
          "60-62h": 1,
          "66-68h": 2,
          "68-70h": 6,
          "70-72h": 6,
          "72-74h": 9,
          "74-76h": 6,
          "76-78h": 5,
          "78-80h": 3,
          "80-82h": 1,
          "82-84h": 1,
          "84-86h": 1,
          "88-90h": 1,
          "90-92h": 1,
          "92-94h": 6,
          "94-96h": 11,
          "96-98h": 7,
          "98-100h": 5,
          "100-102h": 1,
          "102-104h": 3,
          "104-106h": 2,
          "108-110h": 1,
          "110-112h": 3,
          "112-114h": 3,
          "114-116h": 5,
          "116-118h": 8,
          "118-120h": 4,
          "120-122h": 3,
          "122-124h": 3,
          "124-126h": 3,
          "126-128h": 3,
          "128-130h": 1,
          "136-138h": 4,
          "140-142h": 2,
          "142-144h": 7,
          "144-146h": 5,
          "146-148h": 1,
          "148-150h": 2,
          "150-152h": 1,
          "152-154h": 2,
          "156-158h": 1,
          "158-160h": 4,
          "160-162h": 1,
          "162-164h": 3,
          "164-166h": 4,
          "166-168h": 3,
          "168-170h": 7,
          "172-174h": 2,
          "174-176h": 2,
          "176-178h": 1,
          "178-180h": 5,
          "180-182h": 4,
          "184-186h": 2,
          "186-188h": 2,
          "188-190h": 2,
          "192-194h": 1,
          "194-196h": 2,
          "196-198h": 2,
          "198-200h": 2,
          "200-202h": 3,
          "202-204h": 1,
          "204-206h": 2,
          "208-210h": 1,
          "210-212h": 5,
          "214-216h": 1,
          "216-218h": 3,
          "218-220h": 3,
          "220-222h": 1,
          "222-224h": 2,
          "228-230h": 2,
          "230-232h": 1,
          "232-234h": 2,
          "234-236h": 1,
          "236-238h": 1,
          "238-240h": 1,
          "246-248h": 1,
          "248-250h": 1,
          "252-254h": 1,
          "256-258h": 2,
          "258-260h": 1,
          "260-262h": 1,
          "262-264h": 1,
          "266-268h": 3,
          "268-270h": 1,
          "278-280h": 3,
          "282-284h": 1,
          "284-286h": 1,
          "286-288h": 2,
          "288-290h": 2,
          "294-296h": 1,
          "300-302h": 1,
          "302-304h": 3,
          "304-306h": 1,
          "308-310h": 1,
          "310-312h": 1,
          "312-314h": 1,
          "316-318h": 1,
          "318-320h": 3,
          "320-322h": 1,
          "324-326h": 1,
          "328-330h": 1,
          "332-334h": 1,
          "334-336h": 6,
          "340-342h": 1,
          "344-346h": 1,
          "346-348h": 1,
          "354-356h": 1,
          "356-358h": 2,
          "358-360h": 2,
          "366-368h": 4,
          "370-372h": 1,
          "372-374h": 1,
          "378-380h": 1,
          "382-384h": 4,
          "384-386h": 2,
          "388-390h": 1,
          "400-402h": 1,
          "404-406h": 2,
          "410-412h": 1,
          "416-418h": 2,
          "418-420h": 1,
          "424-426h": 1,
          "426-428h": 1,
          "428-430h": 1,
          "432-434h": 1,
          "452-454h": 1,
          "454-456h": 4,
          "456-458h": 2,
          "466-468h": 1,
          "468-470h": 1,
          "470-472h": 1,
          "472-474h": 5,
          "478-480h": 1,
          "482-484h": 1,
          "492-494h": 1,
          "496-498h": 2,
          "500-502h": 2,
          "508-510h": 1,
          "512-514h": 1,
          "522-524h": 2,
          "532-534h": 1,
          "540-542h": 1,
          "542-544h": 1,
          "544-546h": 1,
          "552-554h": 1,
          "562-564h": 1,
          "572-574h": 1,
          "574-576h": 1,
          "578-580h": 1,
          "638-640h": 2,
          "646-648h": 1,
          "650-652h": 1,
          "652-654h": 1,
          "664-666h": 2,
          "678-680h": 3,
          "700-702h": 1,
          "710-712h": 1,
          "734-736h": 1,
          "736-738h": 2,
          "740-742h": 1,
          "742-744h": 1,
          "808-810h": 1,
          "814-816h": 1,
          "824-826h": 2,
          "830-832h": 1,
          "844-846h": 1,
          "846-848h": 1,
          "888-890h": 1,
          "1036-1038h": 1,
          "1056-1058h": 1,
          "1150-1152h": 1,
          "1198-1200h": 1,
          "1214-1216h": 1,
          "1278-1280h": 1,
          "1704-1706h": 1,
          "1916-1918h": 1,
          "1962-1964h": 1,
          "2124-2126h": 1,
          "2132-2134h": 1,
          "2152-2154h": 1,
          "2272-2274h": 1,
          "2344-2346h": 1,
          "2374-2376h": 1
        },
        "tickets_count": 1202,
        "tickets_per_day": {
          "2025-09-30": 3,
          "2025-10-01": 1,
          "2025-10-03": 4,
          "2025-10-06": 3,
          "2025-10-07": 21,
          "2025-10-08": 1,
          "2025-10-09": 10,
          "2025-10-10": 5,
          "2025-10-13": 11,
          "2025-10-14": 16,
          "2025-10-15": 18,
          "2025-10-17": 10,
          "2025-10-20": 3,
          "2025-10-21": 11,
          "2025-10-22": 2,
          "2025-10-23": 13,
          "2025-10-24": 3,
          "2025-10-25": 10,
          "2025-10-27": 16,
          "2025-10-28": 3,
          "2025-10-29": 8,
          "2025-10-30": 11,
          "2025-10-31": 6,
          "2025-11-03": 6,
          "2025-11-04": 2,
          "2025-11-05": 13,
          "2025-11-06": 12,
          "2025-11-07": 8,
          "2025-11-10": 15,
          "2025-11-11": 5,
          "2025-11-12": 10,
          "2025-11-13": 8,
          "2025-11-14": 16,
          "2025-11-19": 14,
          "2025-11-20": 7,
          "2025-11-21": 17,
          "2025-11-23": 6,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-27": 2,
          "2025-11-29": 18,
          "2025-12-02": 28,
          "2025-12-03": 14,
          "2025-12-04": 5,
          "2025-12-05": 8,
          "2025-12-08": 1,
          "2025-12-09": 3,
          "2025-12-10": 9,
          "2025-12-11": 12,
          "2025-12-12": 9,
          "2025-12-15": 11,
          "2025-12-16": 1,
          "2025-12-17": 3,
          "2025-12-18": 1,
          "2025-12-19": 2,
          "2025-12-22": 9,
          "2025-12-23": 1,
          "2025-12-26": 6,
          "2025-12-29": 2,
          "2025-12-30": 2,
          "2026-01-02": 3,
          "2026-01-05": 2,
          "2026-01-07": 5,
          "2026-01-08": 5,
          "2026-01-09": 1,
          "2026-01-12": 4,
          "2026-01-13": 7,
          "2026-01-14": 1,
          "2026-01-15": 5,
          "2026-01-16": 3,
          "2026-01-18": 1,
          "2026-01-20": 3,
          "2026-01-21": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-01-29": 1,
          "2026-01-30": 5,
          "2026-02-02": 4,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-06": 8,
          "2026-02-09": 3,
          "2026-02-10": 8,
          "2026-02-11": 2,
          "2026-02-12": 8,
          "2026-02-13": 12,
          "2026-02-17": 1,
          "2026-02-18": 8,
          "2026-02-19": 34,
          "2026-02-20": 9,
          "2026-02-21": 1,
          "2026-02-23": 5,
          "2026-02-28": 7,
          "2026-03-01": 1,
          "2026-03-02": 2,
          "2026-03-04": 8,
          "2026-03-05": 4,
          "2026-03-06": 4,
          "2026-03-07": 2,
          "2026-03-09": 1,
          "2026-03-14": 10,
          "2026-03-16": 7,
          "2026-03-17": 7,
          "2026-03-18": 64,
          "2026-03-19": 5,
          "2026-03-20": 6,
          "2026-03-21": 3,
          "2026-03-23": 3,
          "2026-03-24": 13,
          "2026-03-25": 4,
          "2026-03-26": 4,
          "2026-03-27": 5,
          "2026-03-28": 1,
          "2026-03-30": 5,
          "2026-03-31": 10,
          "2026-04-01": 1,
          "2026-04-02": 8,
          "2026-04-06": 6,
          "2026-04-07": 3,
          "2026-04-08": 1,
          "2026-04-09": 12,
          "2026-04-10": 1,
          "2026-04-13": 10,
          "2026-04-14": 3,
          "2026-04-15": 1,
          "2026-04-16": 8,
          "2026-04-17": 4,
          "2026-04-18": 1,
          "2026-04-20": 11,
          "2026-04-21": 4,
          "2026-04-22": 7,
          "2026-04-23": 7,
          "2026-04-24": 4,
          "2026-04-27": 12,
          "2026-04-28": 3,
          "2026-04-29": 3,
          "2026-04-30": 7,
          "2026-05-02": 4,
          "2026-05-04": 8,
          "2026-05-05": 5,
          "2026-05-06": 7,
          "2026-05-07": 6,
          "2026-05-08": 6,
          "2026-05-09": 1,
          "2026-05-11": 6,
          "2026-05-12": 7,
          "2026-05-13": 10,
          "2026-05-14": 11,
          "2026-05-15": 12,
          "2026-05-18": 13,
          "2026-05-19": 9,
          "2026-05-20": 10,
          "2026-05-21": 6,
          "2026-05-22": 14,
          "2026-05-23": 4,
          "2026-05-25": 10,
          "2026-05-26": 10,
          "2026-05-27": 6,
          "2026-05-28": 4,
          "2026-05-29": 10,
          "2026-06-01": 10,
          "2026-06-02": 13,
          "2026-06-03": 8,
          "2026-06-05": 28,
          "2026-06-06": 5,
          "2026-06-08": 14
        },
        "time_per_day": {
          "2025-09-30": 3.413374722222222,
          "2025-10-01": 24.06752388888889,
          "2025-10-03": 137.96832666666666,
          "2025-10-06": 7.296663888888889,
          "2025-10-07": 1100.6900950000002,
          "2025-10-08": 0.5847205555555556,
          "2025-10-09": 682.3173444444444,
          "2025-10-10": 438.3128313888889,
          "2025-10-13": 838.2040825,
          "2025-10-14": 1006.5966394444443,
          "2025-10-15": 1241.529676111111,
          "2025-10-17": 301.2312430555555,
          "2025-10-20": 384.33581944444444,
          "2025-10-21": 684.8643141666665,
          "2025-10-22": 407.3903788888889,
          "2025-10-23": 451.18869527777775,
          "2025-10-24": 392.1889463888889,
          "2025-10-25": 1070.0072452777779,
          "2025-10-27": 1935.3804522222222,
          "2025-10-28": 27.77580888888889,
          "2025-10-29": 415.2642858333333,
          "2025-10-30": 2280.0865955555555,
          "2025-10-31": 66.43046527777778,
          "2025-11-03": 436.1560247222222,
          "2025-11-04": 0.016178333333333333,
          "2025-11-05": 1642.6222019444444,
          "2025-11-06": 2300.049122777778,
          "2025-11-07": 386.23072833333333,
          "2025-11-10": 1414.5868077777777,
          "2025-11-11": 391.11480416666666,
          "2025-11-12": 617.1057438888889,
          "2025-11-13": 605.7670488888889,
          "2025-11-14": 3805.1868905555557,
          "2025-11-19": 1319.2439744444448,
          "2025-11-20": 397.49395888888887,
          "2025-11-21": 1645.9268116666665,
          "2025-11-23": 198.23639416666666,
          "2025-11-24": 1431.215703888889,
          "2025-11-25": 230.31930416666665,
          "2025-11-27": 89.21703,
          "2025-11-29": 3682.4317838888887,
          "2025-12-02": 3775.639446388889,
          "2025-12-03": 1781.2693519444445,
          "2025-12-04": 597.9171511111111,
          "2025-12-05": 1242.0123802777778,
          "2025-12-08": 178.52628416666667,
          "2025-12-09": 228.1621186111111,
          "2025-12-10": 847.9348266666666,
          "2025-12-11": 1122.7219786111114,
          "2025-12-12": 1274.0440449999999,
          "2025-12-15": 1306.1727013888892,
          "2025-12-16": 142.81966555555556,
          "2025-12-17": 1222.0160091666667,
          "2025-12-18": 664.2215874999999,
          "2025-12-19": 704.1715975,
          "2025-12-22": 1465.4473466666668,
          "2025-12-23": 20.733946666666668,
          "2025-12-26": 2995.2936797222224,
          "2025-12-29": 1271.2469722222222,
          "2025-12-30": 6.173720555555556,
          "2026-01-02": 1303.2341483333335,
          "2026-01-05": 0.7188022222222222,
          "2026-01-07": 5.444769166666667,
          "2026-01-08": 200.56989444444443,
          "2026-01-09": 2.843283611111111,
          "2026-01-12": 1.1786366666666668,
          "2026-01-13": 10.968097777777777,
          "2026-01-14": 0.47969500000000004,
          "2026-01-15": 1179.57372,
          "2026-01-16": 0.6163058333333333,
          "2026-01-18": 1.2740480555555556,
          "2026-01-20": 0.23338916666666668,
          "2026-01-21": 412.9642302777778,
          "2026-01-23": 1198.5635597222224,
          "2026-01-27": 315.86450055555554,
          "2026-01-29": 16.547351111111112,
          "2026-01-30": 115.97010722222223,
          "2026-02-02": 1.9360813888888888,
          "2026-02-03": 5.900456944444445,
          "2026-02-05": 80.9097425,
          "2026-02-06": 313.70778694444436,
          "2026-02-09": 156.23611027777775,
          "2026-02-10": 1312.5788552777778,
          "2026-02-11": 215.76989055555555,
          "2026-02-12": 3086.915321388889,
          "2026-02-13": 616.2494455555556,
          "2026-02-17": 142.59776444444444,
          "2026-02-18": 8172.753432222222,
          "2026-02-19": 16988.460003333337,
          "2026-02-20": 355.52572027777785,
          "2026-02-21": 52.60538444444444,
          "2026-02-23": 291.54892611111114,
          "2026-02-28": 637.4640677777777,
          "2026-03-01": 1.4713325,
          "2026-03-02": 4.074475277777778,
          "2026-03-04": 5.058054722222222,
          "2026-03-05": 1.690439722222222,
          "2026-03-06": 5.153587777777778,
          "2026-03-07": 0.34648666666666667,
          "2026-03-14": 710.8099730555555,
          "2026-03-16": 2.7827047222222223,
          "2026-03-17": 357.94331111111114,
          "2026-03-18": 19872.856035277782,
          "2026-03-19": 0.6124633333333334,
          "2026-03-20": 2602.873223888889,
          "2026-03-21": 8.283401944444444,
          "2026-03-23": 1.5455088888888888,
          "2026-03-24": 720.7530119444446,
          "2026-03-25": 4.287197222222223,
          "2026-03-26": 1663.4273102777777,
          "2026-03-27": 4.206545,
          "2026-03-28": 1.2578880555555556,
          "2026-03-30": 111.25769361111112,
          "2026-03-31": 23.956553333333336,
          "2026-04-02": 0.8939725000000001,
          "2026-04-06": 10.495324722222223,
          "2026-04-07": 1.3245247222222223,
          "2026-04-08": 145.07749555555554,
          "2026-04-09": 311.7132652777777,
          "2026-04-10": 0.5312247222222223,
          "2026-04-13": 9.018739444444444,
          "2026-04-14": 1.958396388888889,
          "2026-04-15": 1.0337097222222222,
          "2026-04-16": 2.4645941666666666,
          "2026-04-17": 3.9189563888888888,
          "2026-04-18": 3.0794444444444444,
          "2026-04-20": 6.269298611111112,
          "2026-04-21": 2.2994822222222226,
          "2026-04-22": 430.38678472222216,
          "2026-04-23": 687.0942877777778,
          "2026-04-24": 18.682498055555556,
          "2026-04-27": 1.6681730555555554,
          "2026-04-28": 8.406531388888888,
          "2026-04-29": 4.043160555555556,
          "2026-04-30": 32.721746111111116,
          "2026-05-02": 2.949578333333333,
          "2026-05-04": 6.74355861111111,
          "2026-05-05": 2.7183555555555556,
          "2026-05-06": 2158.860638611111,
          "2026-05-07": 5.942641666666667,
          "2026-05-08": 7.461678611111111,
          "2026-05-09": 13.23972388888889,
          "2026-05-11": 4.473174722222222,
          "2026-05-12": 9.207008888888888,
          "2026-05-13": 3.619744444444444,
          "2026-05-14": 3.454493888888889,
          "2026-05-15": 11.070950833333333,
          "2026-05-18": 2.9719244444444444,
          "2026-05-19": 13.642463333333332,
          "2026-05-20": 7.259925000000001,
          "2026-05-21": 8.291316111111112,
          "2026-05-22": 9.976853055555555,
          "2026-05-23": 10.071846666666668,
          "2026-05-25": 4.0109216666666665,
          "2026-05-26": 10.026299166666664,
          "2026-05-27": 9.730844444444445,
          "2026-05-28": 0.34180750000000004,
          "2026-05-29": 6.195584722222222,
          "2026-06-01": 422.2042811111112,
          "2026-06-02": 5.602555000000001,
          "2026-06-03": 11.313926388888888,
          "2026-06-05": 210.2429597222223,
          "2026-06-06": 848.033231111111,
          "2026-06-08": 4.374390555555555
        },
        "time_count_per_day": {
          "2025-09-30": 3,
          "2025-10-01": 1,
          "2025-10-03": 4,
          "2025-10-06": 3,
          "2025-10-07": 20,
          "2025-10-08": 1,
          "2025-10-09": 10,
          "2025-10-10": 5,
          "2025-10-13": 11,
          "2025-10-14": 16,
          "2025-10-15": 18,
          "2025-10-17": 10,
          "2025-10-20": 3,
          "2025-10-21": 11,
          "2025-10-22": 2,
          "2025-10-23": 13,
          "2025-10-24": 3,
          "2025-10-25": 10,
          "2025-10-27": 16,
          "2025-10-28": 3,
          "2025-10-29": 8,
          "2025-10-30": 11,
          "2025-10-31": 6,
          "2025-11-03": 6,
          "2025-11-04": 1,
          "2025-11-05": 13,
          "2025-11-06": 12,
          "2025-11-07": 8,
          "2025-11-10": 15,
          "2025-11-11": 5,
          "2025-11-12": 10,
          "2025-11-13": 8,
          "2025-11-14": 16,
          "2025-11-19": 14,
          "2025-11-20": 7,
          "2025-11-21": 17,
          "2025-11-23": 6,
          "2025-11-24": 14,
          "2025-11-25": 6,
          "2025-11-27": 2,
          "2025-11-29": 18,
          "2025-12-02": 28,
          "2025-12-03": 14,
          "2025-12-04": 5,
          "2025-12-05": 8,
          "2025-12-08": 1,
          "2025-12-09": 3,
          "2025-12-10": 9,
          "2025-12-11": 12,
          "2025-12-12": 9,
          "2025-12-15": 11,
          "2025-12-16": 1,
          "2025-12-17": 3,
          "2025-12-18": 1,
          "2025-12-19": 2,
          "2025-12-22": 9,
          "2025-12-23": 1,
          "2025-12-26": 6,
          "2025-12-29": 2,
          "2025-12-30": 2,
          "2026-01-02": 3,
          "2026-01-05": 1,
          "2026-01-07": 5,
          "2026-01-08": 5,
          "2026-01-09": 1,
          "2026-01-12": 4,
          "2026-01-13": 7,
          "2026-01-14": 1,
          "2026-01-15": 5,
          "2026-01-16": 3,
          "2026-01-18": 1,
          "2026-01-20": 3,
          "2026-01-21": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-01-29": 1,
          "2026-01-30": 5,
          "2026-02-02": 4,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-06": 8,
          "2026-02-09": 3,
          "2026-02-10": 8,
          "2026-02-11": 2,
          "2026-02-12": 8,
          "2026-02-13": 12,
          "2026-02-17": 1,
          "2026-02-18": 8,
          "2026-02-19": 34,
          "2026-02-20": 7,
          "2026-02-21": 1,
          "2026-02-23": 5,
          "2026-02-28": 7,
          "2026-03-01": 1,
          "2026-03-02": 1,
          "2026-03-04": 7,
          "2026-03-05": 4,
          "2026-03-06": 4,
          "2026-03-07": 2,
          "2026-03-14": 10,
          "2026-03-16": 7,
          "2026-03-17": 7,
          "2026-03-18": 64,
          "2026-03-19": 5,
          "2026-03-20": 6,
          "2026-03-21": 3,
          "2026-03-23": 2,
          "2026-03-24": 13,
          "2026-03-25": 4,
          "2026-03-26": 4,
          "2026-03-27": 5,
          "2026-03-28": 1,
          "2026-03-30": 3,
          "2026-03-31": 9,
          "2026-04-02": 7,
          "2026-04-06": 6,
          "2026-04-07": 3,
          "2026-04-08": 1,
          "2026-04-09": 12,
          "2026-04-10": 1,
          "2026-04-13": 9,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-16": 8,
          "2026-04-17": 3,
          "2026-04-18": 1,
          "2026-04-20": 10,
          "2026-04-21": 4,
          "2026-04-22": 7,
          "2026-04-23": 7,
          "2026-04-24": 3,
          "2026-04-27": 11,
          "2026-04-28": 3,
          "2026-04-29": 3,
          "2026-04-30": 7,
          "2026-05-02": 3,
          "2026-05-04": 7,
          "2026-05-05": 4,
          "2026-05-06": 6,
          "2026-05-07": 6,
          "2026-05-08": 6,
          "2026-05-09": 1,
          "2026-05-11": 4,
          "2026-05-12": 5,
          "2026-05-13": 9,
          "2026-05-14": 10,
          "2026-05-15": 11,
          "2026-05-18": 11,
          "2026-05-19": 9,
          "2026-05-20": 9,
          "2026-05-21": 5,
          "2026-05-22": 14,
          "2026-05-23": 4,
          "2026-05-25": 8,
          "2026-05-26": 10,
          "2026-05-27": 6,
          "2026-05-28": 1,
          "2026-05-29": 9,
          "2026-06-01": 10,
          "2026-06-02": 13,
          "2026-06-03": 8,
          "2026-06-05": 28,
          "2026-06-06": 4,
          "2026-06-08": 11
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 37.28,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 37.28416638888889
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        },
        "P2": {
          "avg_time_hours": 22.06,
          "mode_time_hours": 1.0,
          "mode_frequency": 424,
          "time_distribution": {
            "0-2h": 424,
            "2-4h": 70,
            "4-6h": 9,
            "6-8h": 6,
            "8-10h": 1,
            "10-12h": 6,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "22-24h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "34-36h": 1,
            "36-38h": 3,
            "40-42h": 2,
            "44-46h": 3,
            "68-70h": 1,
            "96-98h": 2,
            "98-100h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 1,
            "156-158h": 1,
            "178-180h": 1,
            "198-200h": 1,
            "210-212h": 1,
            "236-238h": 1,
            "258-260h": 1,
            "262-264h": 1,
            "310-312h": 1,
            "312-314h": 1,
            "316-318h": 1,
            "340-342h": 1,
            "356-358h": 1,
            "410-412h": 1,
            "472-474h": 1,
            "508-510h": 1,
            "562-564h": 1,
            "646-648h": 1,
            "664-666h": 1,
            "678-680h": 2,
            "742-744h": 1,
            "1036-1038h": 1,
            "1056-1058h": 1
          },
          "tickets_count": 562,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-14": 3,
            "2025-10-15": 2,
            "2025-10-21": 4,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-10-25": 1,
            "2025-10-27": 1,
            "2025-10-28": 3,
            "2025-10-29": 1,
            "2025-10-30": 2,
            "2025-10-31": 2,
            "2025-11-03": 2,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 2,
            "2025-11-07": 3,
            "2025-11-10": 5,
            "2025-11-13": 5,
            "2025-11-14": 2,
            "2025-11-19": 3,
            "2025-11-20": 1,
            "2025-11-23": 1,
            "2025-11-24": 6,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-08": 1,
            "2025-12-09": 1,
            "2025-12-11": 3,
            "2025-12-12": 4,
            "2025-12-15": 6,
            "2025-12-17": 2,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-26": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-07": 5,
            "2026-01-08": 2,
            "2026-01-09": 1,
            "2026-01-12": 4,
            "2026-01-13": 5,
            "2026-01-14": 1,
            "2026-01-15": 3,
            "2026-01-16": 3,
            "2026-01-18": 1,
            "2026-01-20": 3,
            "2026-01-21": 2,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-01-30": 5,
            "2026-02-02": 4,
            "2026-02-03": 2,
            "2026-02-06": 5,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 5,
            "2026-02-13": 5,
            "2026-02-20": 5,
            "2026-02-28": 2,
            "2026-03-01": 1,
            "2026-03-02": 1,
            "2026-03-04": 7,
            "2026-03-05": 4,
            "2026-03-06": 3,
            "2026-03-07": 1,
            "2026-03-16": 7,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-19": 5,
            "2026-03-21": 3,
            "2026-03-23": 2,
            "2026-03-24": 8,
            "2026-03-25": 4,
            "2026-03-26": 1,
            "2026-03-27": 5,
            "2026-03-28": 1,
            "2026-03-30": 3,
            "2026-03-31": 9,
            "2026-04-02": 7,
            "2026-04-06": 6,
            "2026-04-07": 3,
            "2026-04-09": 12,
            "2026-04-10": 1,
            "2026-04-13": 8,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 8,
            "2026-04-17": 3,
            "2026-04-18": 1,
            "2026-04-20": 10,
            "2026-04-21": 4,
            "2026-04-22": 4,
            "2026-04-23": 7,
            "2026-04-24": 3,
            "2026-04-27": 11,
            "2026-04-28": 3,
            "2026-04-29": 3,
            "2026-04-30": 7,
            "2026-05-02": 3,
            "2026-05-04": 7,
            "2026-05-05": 4,
            "2026-05-06": 5,
            "2026-05-07": 6,
            "2026-05-08": 6,
            "2026-05-09": 1,
            "2026-05-11": 4,
            "2026-05-12": 5,
            "2026-05-13": 9,
            "2026-05-14": 10,
            "2026-05-15": 11,
            "2026-05-18": 11,
            "2026-05-19": 9,
            "2026-05-20": 9,
            "2026-05-21": 5,
            "2026-05-22": 14,
            "2026-05-23": 4,
            "2026-05-25": 8,
            "2026-05-26": 10,
            "2026-05-27": 6,
            "2026-05-28": 1,
            "2026-05-29": 9,
            "2026-06-01": 9,
            "2026-06-02": 13,
            "2026-06-03": 8,
            "2026-06-05": 28,
            "2026-06-06": 1,
            "2026-06-08": 11
          },
          "time_per_day": {
            "2025-09-30": 0.2738661111111111,
            "2025-10-03": 25.337097500000002,
            "2025-10-06": 0.3978744444444444,
            "2025-10-07": 124.97357833333334,
            "2025-10-09": 0.2323413888888889,
            "2025-10-10": 10.058805833333334,
            "2025-10-14": 3.0587625,
            "2025-10-15": 163.99700305555555,
            "2025-10-21": 3.556356388888889,
            "2025-10-22": 211.27871666666667,
            "2025-10-23": 199.83179222222225,
            "2025-10-24": 0.8987066666666667,
            "2025-10-25": 0.6397405555555555,
            "2025-10-27": 0.8519711111111111,
            "2025-10-28": 27.77580888888889,
            "2025-10-29": 11.730011388888888,
            "2025-10-30": 226.54228805555556,
            "2025-10-31": 0.28388888888888886,
            "2025-11-03": 0.8393297222222222,
            "2025-11-04": 0.016178333333333333,
            "2025-11-05": 97.12117527777778,
            "2025-11-06": 2.6799858333333333,
            "2025-11-07": 342.6969716666667,
            "2025-11-10": 2.1453569444444445,
            "2025-11-13": 102.73550944444445,
            "2025-11-14": 1394.300573888889,
            "2025-11-19": 3.100338333333333,
            "2025-11-20": 0.3957102777777778,
            "2025-11-23": 0.591426388888889,
            "2025-11-24": 122.20086972222224,
            "2025-12-03": 0.10423972222222222,
            "2025-12-05": 0.1277825,
            "2025-12-08": 178.52628416666667,
            "2025-12-09": 1.1079255555555556,
            "2025-12-11": 515.3570891666667,
            "2025-12-12": 1.1793875000000003,
            "2025-12-15": 1.6717972222222222,
            "2025-12-17": 1056.9871422222222,
            "2025-12-18": 664.2215874999999,
            "2025-12-19": 237.84596833333333,
            "2025-12-22": 743.1364861111111,
            "2025-12-26": 3.072745277777778,
            "2025-12-30": 0.8887186111111112,
            "2026-01-02": 0.08942888888888889,
            "2026-01-05": 0.7188022222222222,
            "2026-01-07": 5.444769166666667,
            "2026-01-08": 2.2338061111111114,
            "2026-01-09": 2.843283611111111,
            "2026-01-12": 1.1786366666666668,
            "2026-01-13": 6.935640555555556,
            "2026-01-14": 0.47969500000000004,
            "2026-01-15": 6.9156152777777775,
            "2026-01-16": 0.6163058333333333,
            "2026-01-18": 1.2740480555555556,
            "2026-01-20": 0.23338916666666668,
            "2026-01-21": 412.9642302777778,
            "2026-01-27": 313.3106702777778,
            "2026-01-29": 16.547351111111112,
            "2026-01-30": 115.97010722222223,
            "2026-02-02": 1.9360813888888888,
            "2026-02-03": 5.900456944444445,
            "2026-02-06": 0.28036833333333333,
            "2026-02-09": 8.078096944444445,
            "2026-02-10": 523.9460002777779,
            "2026-02-11": 1.1373833333333334,
            "2026-02-12": 2746.1860058333336,
            "2026-02-13": 3.995711388888889,
            "2026-02-20": 8.453201388888889,
            "2026-02-28": 17.766421666666666,
            "2026-03-01": 1.4713325,
            "2026-03-02": 4.074475277777778,
            "2026-03-04": 5.058054722222222,
            "2026-03-05": 1.690439722222222,
            "2026-03-06": 3.8701036111111113,
            "2026-03-07": 0.3342277777777778,
            "2026-03-16": 2.7827047222222223,
            "2026-03-17": 0.22752361111111113,
            "2026-03-18": 6.984445277777778,
            "2026-03-19": 0.6124633333333334,
            "2026-03-21": 8.283401944444444,
            "2026-03-23": 1.5455088888888888,
            "2026-03-24": 7.2154516666666675,
            "2026-03-25": 4.287197222222223,
            "2026-03-26": 0.4299894444444444,
            "2026-03-27": 4.206545,
            "2026-03-28": 1.2578880555555556,
            "2026-03-30": 111.25769361111112,
            "2026-03-31": 23.956553333333336,
            "2026-04-02": 0.8939725000000001,
            "2026-04-06": 10.495324722222223,
            "2026-04-07": 1.3245247222222223,
            "2026-04-09": 311.7132652777777,
            "2026-04-10": 0.5312247222222223,
            "2026-04-13": 1.9100458333333334,
            "2026-04-14": 1.958396388888889,
            "2026-04-15": 1.0337097222222222,
            "2026-04-16": 2.4645941666666666,
            "2026-04-17": 3.9189563888888888,
            "2026-04-18": 3.0794444444444444,
            "2026-04-20": 6.269298611111112,
            "2026-04-21": 2.2994822222222226,
            "2026-04-22": 11.308571944444445,
            "2026-04-23": 687.0942877777778,
            "2026-04-24": 18.682498055555556,
            "2026-04-27": 1.6681730555555554,
            "2026-04-28": 8.406531388888888,
            "2026-04-29": 4.043160555555556,
            "2026-04-30": 32.721746111111116,
            "2026-05-02": 2.949578333333333,
            "2026-05-04": 6.74355861111111,
            "2026-05-05": 2.7183555555555556,
            "2026-05-06": 5.9857394444444445,
            "2026-05-07": 5.942641666666667,
            "2026-05-08": 7.461678611111111,
            "2026-05-09": 13.23972388888889,
            "2026-05-11": 4.473174722222222,
            "2026-05-12": 9.207008888888888,
            "2026-05-13": 3.619744444444444,
            "2026-05-14": 3.454493888888889,
            "2026-05-15": 11.070950833333333,
            "2026-05-18": 2.9719244444444444,
            "2026-05-19": 13.642463333333332,
            "2026-05-20": 7.259925000000001,
            "2026-05-21": 8.291316111111112,
            "2026-05-22": 9.976853055555555,
            "2026-05-23": 10.071846666666668,
            "2026-05-25": 4.0109216666666665,
            "2026-05-26": 10.026299166666664,
            "2026-05-27": 9.730844444444445,
            "2026-05-28": 0.34180750000000004,
            "2026-05-29": 6.195584722222222,
            "2026-06-01": 16.306101666666667,
            "2026-06-02": 5.602555000000001,
            "2026-06-03": 11.313926388888888,
            "2026-06-05": 210.2429597222223,
            "2026-06-06": 0.07125333333333334,
            "2026-06-08": 4.374390555555555
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-14": 3,
            "2025-10-15": 2,
            "2025-10-21": 4,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-10-25": 1,
            "2025-10-27": 1,
            "2025-10-28": 3,
            "2025-10-29": 1,
            "2025-10-30": 2,
            "2025-10-31": 2,
            "2025-11-03": 2,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 2,
            "2025-11-07": 3,
            "2025-11-10": 5,
            "2025-11-13": 5,
            "2025-11-14": 2,
            "2025-11-19": 3,
            "2025-11-20": 1,
            "2025-11-23": 1,
            "2025-11-24": 6,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-08": 1,
            "2025-12-09": 1,
            "2025-12-11": 3,
            "2025-12-12": 4,
            "2025-12-15": 6,
            "2025-12-17": 2,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-26": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-07": 5,
            "2026-01-08": 2,
            "2026-01-09": 1,
            "2026-01-12": 4,
            "2026-01-13": 5,
            "2026-01-14": 1,
            "2026-01-15": 3,
            "2026-01-16": 3,
            "2026-01-18": 1,
            "2026-01-20": 3,
            "2026-01-21": 2,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-01-30": 5,
            "2026-02-02": 4,
            "2026-02-03": 2,
            "2026-02-06": 5,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 5,
            "2026-02-13": 5,
            "2026-02-20": 5,
            "2026-02-28": 2,
            "2026-03-01": 1,
            "2026-03-02": 1,
            "2026-03-04": 7,
            "2026-03-05": 4,
            "2026-03-06": 3,
            "2026-03-07": 1,
            "2026-03-16": 7,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-19": 5,
            "2026-03-21": 3,
            "2026-03-23": 2,
            "2026-03-24": 8,
            "2026-03-25": 4,
            "2026-03-26": 1,
            "2026-03-27": 5,
            "2026-03-28": 1,
            "2026-03-30": 3,
            "2026-03-31": 9,
            "2026-04-02": 7,
            "2026-04-06": 6,
            "2026-04-07": 3,
            "2026-04-09": 12,
            "2026-04-10": 1,
            "2026-04-13": 8,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 8,
            "2026-04-17": 3,
            "2026-04-18": 1,
            "2026-04-20": 10,
            "2026-04-21": 4,
            "2026-04-22": 4,
            "2026-04-23": 7,
            "2026-04-24": 3,
            "2026-04-27": 11,
            "2026-04-28": 3,
            "2026-04-29": 3,
            "2026-04-30": 7,
            "2026-05-02": 3,
            "2026-05-04": 7,
            "2026-05-05": 4,
            "2026-05-06": 5,
            "2026-05-07": 6,
            "2026-05-08": 6,
            "2026-05-09": 1,
            "2026-05-11": 4,
            "2026-05-12": 5,
            "2026-05-13": 9,
            "2026-05-14": 10,
            "2026-05-15": 11,
            "2026-05-18": 11,
            "2026-05-19": 9,
            "2026-05-20": 9,
            "2026-05-21": 5,
            "2026-05-22": 14,
            "2026-05-23": 4,
            "2026-05-25": 8,
            "2026-05-26": 10,
            "2026-05-27": 6,
            "2026-05-28": 1,
            "2026-05-29": 9,
            "2026-06-01": 9,
            "2026-06-02": 13,
            "2026-06-03": 8,
            "2026-06-05": 28,
            "2026-06-06": 1,
            "2026-06-08": 11
          }
        },
        "P3": {
          "avg_time_hours": 275.87,
          "mode_time_hours": 7.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 2,
            "6-8h": 4,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "34-36h": 1,
            "40-42h": 1,
            "44-46h": 1,
            "74-76h": 1,
            "92-94h": 1,
            "114-116h": 2,
            "116-118h": 3,
            "124-126h": 2,
            "140-142h": 1,
            "142-144h": 3,
            "146-148h": 1,
            "152-154h": 2,
            "174-176h": 1,
            "200-202h": 2,
            "260-262h": 1,
            "266-268h": 1,
            "318-320h": 1,
            "334-336h": 1,
            "344-346h": 1,
            "356-358h": 1,
            "416-418h": 1,
            "418-420h": 1,
            "478-480h": 1,
            "512-514h": 1,
            "572-574h": 1,
            "578-580h": 1,
            "678-680h": 1,
            "700-702h": 1,
            "844-846h": 1,
            "846-848h": 1,
            "1198-1200h": 1,
            "1278-1280h": 1,
            "2152-2154h": 1
          },
          "tickets_count": 58,
          "tickets_per_day": {
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 2,
            "2025-10-13": 1,
            "2025-10-14": 3,
            "2025-10-15": 2,
            "2025-10-24": 1,
            "2025-10-27": 1,
            "2025-10-30": 1,
            "2025-11-04": 1,
            "2025-11-06": 7,
            "2025-11-14": 1,
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-11-29": 1,
            "2025-12-02": 12,
            "2025-12-12": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-15": 1,
            "2026-01-23": 1,
            "2026-02-10": 3,
            "2026-02-13": 5,
            "2026-02-18": 2,
            "2026-02-20": 1,
            "2026-04-13": 1,
            "2026-05-06": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-03": 35.62733,
            "2025-10-06": 6.672649722222222,
            "2025-10-07": 143.31702277777777,
            "2025-10-13": 125.40051416666667,
            "2025-10-14": 335.1925175,
            "2025-10-15": 233.65214666666668,
            "2025-10-24": 267.5145438888889,
            "2025-10-27": 416.6074447222222,
            "2025-10-30": 512.1784144444445,
            "2025-11-06": 1543.1800275,
            "2025-11-14": 846.8493272222223,
            "2025-11-21": 356.91744277777775,
            "2025-11-24": 335.3742741666667,
            "2025-11-29": 174.75754111111112,
            "2025-12-02": 2427.1643736111114,
            "2025-12-12": 573.6265625,
            "2025-12-15": 479.2125833333333,
            "2025-12-22": 700.1640958333334,
            "2026-01-15": 21.65919472222222,
            "2026-01-23": 1198.5635597222224,
            "2026-02-10": 736.215918888889,
            "2026-02-13": 529.7473433333333,
            "2026-02-18": 365.4628822222222,
            "2026-02-20": 344.7796316666667,
            "2026-04-13": 7.108693611111111,
            "2026-05-06": 2152.8748991666666,
            "2026-06-06": 578.9116552777778
          },
          "time_count_per_day": {
            "2025-10-03": 1,
            "2025-10-06": 1,
            "2025-10-07": 1,
            "2025-10-13": 1,
            "2025-10-14": 3,
            "2025-10-15": 2,
            "2025-10-24": 1,
            "2025-10-27": 1,
            "2025-10-30": 1,
            "2025-11-06": 7,
            "2025-11-14": 1,
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-11-29": 1,
            "2025-12-02": 12,
            "2025-12-12": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-15": 1,
            "2026-01-23": 1,
            "2026-02-10": 3,
            "2026-02-13": 5,
            "2026-02-18": 2,
            "2026-02-20": 1,
            "2026-04-13": 1,
            "2026-05-06": 1,
            "2026-06-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 128.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 24,
          "time_distribution": {
            "0-2h": 24,
            "2-4h": 16,
            "4-6h": 7,
            "6-8h": 9,
            "8-10h": 5,
            "10-12h": 1,
            "12-14h": 2,
            "14-16h": 3,
            "16-18h": 4,
            "18-20h": 17,
            "20-22h": 23,
            "22-24h": 19,
            "24-26h": 10,
            "26-28h": 3,
            "28-30h": 11,
            "30-32h": 12,
            "32-34h": 8,
            "34-36h": 5,
            "36-38h": 4,
            "38-40h": 2,
            "40-42h": 9,
            "42-44h": 3,
            "44-46h": 5,
            "46-48h": 7,
            "48-50h": 4,
            "50-52h": 5,
            "52-54h": 5,
            "54-56h": 2,
            "56-58h": 1,
            "58-60h": 2,
            "60-62h": 1,
            "66-68h": 2,
            "68-70h": 5,
            "70-72h": 6,
            "72-74h": 6,
            "74-76h": 5,
            "76-78h": 5,
            "78-80h": 3,
            "80-82h": 1,
            "82-84h": 1,
            "84-86h": 1,
            "88-90h": 1,
            "90-92h": 1,
            "92-94h": 5,
            "94-96h": 11,
            "96-98h": 5,
            "98-100h": 3,
            "102-104h": 3,
            "104-106h": 2,
            "108-110h": 1,
            "110-112h": 2,
            "112-114h": 3,
            "114-116h": 3,
            "116-118h": 5,
            "118-120h": 3,
            "120-122h": 2,
            "122-124h": 2,
            "124-126h": 1,
            "126-128h": 2,
            "128-130h": 1,
            "136-138h": 1,
            "140-142h": 1,
            "142-144h": 3,
            "144-146h": 4,
            "148-150h": 2,
            "150-152h": 1,
            "158-160h": 4,
            "160-162h": 1,
            "162-164h": 2,
            "164-166h": 3,
            "166-168h": 3,
            "168-170h": 6,
            "172-174h": 2,
            "174-176h": 1,
            "176-178h": 1,
            "178-180h": 4,
            "180-182h": 3,
            "184-186h": 1,
            "186-188h": 2,
            "188-190h": 2,
            "192-194h": 1,
            "194-196h": 2,
            "196-198h": 2,
            "200-202h": 1,
            "208-210h": 1,
            "210-212h": 4,
            "214-216h": 1,
            "216-218h": 3,
            "218-220h": 2,
            "220-222h": 1,
            "222-224h": 2,
            "228-230h": 1,
            "234-236h": 1,
            "246-248h": 1,
            "248-250h": 1,
            "252-254h": 1,
            "256-258h": 2,
            "266-268h": 2,
            "268-270h": 1,
            "278-280h": 3,
            "282-284h": 1,
            "284-286h": 1,
            "286-288h": 2,
            "288-290h": 2,
            "304-306h": 1,
            "308-310h": 1,
            "318-320h": 1,
            "320-322h": 1,
            "324-326h": 1,
            "328-330h": 1,
            "332-334h": 1,
            "334-336h": 4,
            "346-348h": 1,
            "354-356h": 1,
            "358-360h": 2,
            "366-368h": 3,
            "370-372h": 1,
            "372-374h": 1,
            "382-384h": 4,
            "384-386h": 2,
            "388-390h": 1,
            "400-402h": 1,
            "404-406h": 2,
            "416-418h": 1,
            "424-426h": 1,
            "426-428h": 1,
            "428-430h": 1,
            "432-434h": 1,
            "452-454h": 1,
            "454-456h": 4,
            "456-458h": 2,
            "468-470h": 1,
            "470-472h": 1,
            "492-494h": 1,
            "496-498h": 2,
            "500-502h": 2,
            "522-524h": 2,
            "540-542h": 1,
            "574-576h": 1,
            "740-742h": 1,
            "824-826h": 2,
            "2344-2346h": 1,
            "2374-2376h": 1
          },
          "tickets_count": 502,
          "tickets_per_day": {
            "2025-09-30": 2,
            "2025-10-01": 1,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 17,
            "2025-10-08": 1,
            "2025-10-09": 9,
            "2025-10-10": 4,
            "2025-10-13": 10,
            "2025-10-14": 10,
            "2025-10-15": 14,
            "2025-10-17": 10,
            "2025-10-20": 3,
            "2025-10-21": 7,
            "2025-10-22": 1,
            "2025-10-23": 12,
            "2025-10-24": 1,
            "2025-10-25": 9,
            "2025-10-27": 14,
            "2025-10-29": 7,
            "2025-10-30": 8,
            "2025-10-31": 4,
            "2025-11-03": 4,
            "2025-11-05": 12,
            "2025-11-06": 3,
            "2025-11-07": 5,
            "2025-11-10": 10,
            "2025-11-11": 5,
            "2025-11-12": 10,
            "2025-11-13": 3,
            "2025-11-14": 13,
            "2025-11-19": 11,
            "2025-11-20": 6,
            "2025-11-21": 16,
            "2025-11-23": 5,
            "2025-11-24": 6,
            "2025-11-25": 6,
            "2025-11-27": 2,
            "2025-11-29": 17,
            "2025-12-02": 15,
            "2025-12-03": 7,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 7,
            "2025-12-11": 5,
            "2025-12-15": 2,
            "2025-12-22": 7,
            "2025-12-23": 1,
            "2025-12-30": 1,
            "2026-01-08": 3,
            "2026-01-13": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-06": 3,
            "2026-02-09": 2,
            "2026-02-10": 2,
            "2026-02-11": 1,
            "2026-02-12": 2,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-02-18": 2,
            "2026-02-19": 3,
            "2026-02-20": 1,
            "2026-02-21": 1,
            "2026-02-23": 5,
            "2026-02-28": 5,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-14": 10,
            "2026-03-17": 6,
            "2026-03-18": 57,
            "2026-03-20": 6,
            "2026-03-23": 1,
            "2026-03-24": 5,
            "2026-03-26": 3,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 3,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 2,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-25": 2,
            "2026-05-28": 3,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-06": 3,
            "2026-06-08": 3
          },
          "time_per_day": {
            "2025-09-30": 3.1395086111111112,
            "2025-10-01": 24.06752388888889,
            "2025-10-03": 77.00389916666666,
            "2025-10-06": 0.2261397222222222,
            "2025-10-07": 832.3994938888889,
            "2025-10-08": 0.5847205555555556,
            "2025-10-09": 682.0850030555555,
            "2025-10-10": 428.2540255555556,
            "2025-10-13": 712.8035683333334,
            "2025-10-14": 668.3453594444445,
            "2025-10-15": 843.8805263888887,
            "2025-10-17": 301.2312430555555,
            "2025-10-20": 384.33581944444444,
            "2025-10-21": 681.3079577777777,
            "2025-10-22": 196.11166222222224,
            "2025-10-23": 251.35690305555553,
            "2025-10-24": 123.77569583333333,
            "2025-10-25": 1069.3675047222223,
            "2025-10-27": 1517.9210363888892,
            "2025-10-29": 403.5342744444444,
            "2025-10-30": 1541.3658930555553,
            "2025-10-31": 66.1465763888889,
            "2025-11-03": 435.316695,
            "2025-11-05": 1545.5010266666666,
            "2025-11-06": 754.1891094444445,
            "2025-11-07": 43.53375666666667,
            "2025-11-10": 1412.4414508333334,
            "2025-11-11": 391.11480416666666,
            "2025-11-12": 617.1057438888889,
            "2025-11-13": 503.0315394444445,
            "2025-11-14": 1564.0369894444445,
            "2025-11-19": 1316.1436361111114,
            "2025-11-20": 397.0982486111111,
            "2025-11-21": 1289.0093688888887,
            "2025-11-23": 197.64496777777777,
            "2025-11-24": 973.6405599999998,
            "2025-11-25": 230.31930416666665,
            "2025-11-27": 89.21703,
            "2025-11-29": 3507.6742427777776,
            "2025-12-02": 1346.2234888888888,
            "2025-12-03": 1271.5407941666665,
            "2025-12-04": 102.87872361111111,
            "2025-12-05": 79.37016055555556,
            "2025-12-09": 90.10985277777777,
            "2025-12-10": 299.8725161111111,
            "2025-12-11": 301.02210999999994,
            "2025-12-15": 212.90035083333333,
            "2025-12-22": 22.14676472222222,
            "2025-12-23": 20.733946666666668,
            "2025-12-30": 5.285001944444445,
            "2026-01-08": 198.33608833333332,
            "2026-01-13": 4.032457222222222,
            "2026-01-27": 2.553830277777778,
            "2026-02-05": 80.9097425,
            "2026-02-06": 313.4274186111111,
            "2026-02-09": 148.15801333333332,
            "2026-02-10": 52.41693611111111,
            "2026-02-11": 214.63250722222222,
            "2026-02-12": 303.4451491666667,
            "2026-02-13": 82.50639083333333,
            "2026-02-17": 142.59776444444444,
            "2026-02-18": 89.1460075,
            "2026-02-19": 148.18540944444447,
            "2026-02-20": 2.2928872222222223,
            "2026-02-21": 52.60538444444444,
            "2026-02-23": 291.54892611111114,
            "2026-02-28": 619.6976461111111,
            "2026-03-06": 1.2834841666666665,
            "2026-03-07": 0.012258888888888889,
            "2026-03-14": 710.8099730555555,
            "2026-03-17": 357.71578750000003,
            "2026-03-18": 19865.871590000002,
            "2026-03-20": 2602.873223888889,
            "2026-03-24": 713.5375602777777,
            "2026-03-26": 1662.9973208333333,
            "2026-04-08": 145.07749555555554,
            "2026-04-22": 419.07821277777776,
            "2026-06-01": 405.89817944444445,
            "2026-06-06": 269.0503225
          },
          "time_count_per_day": {
            "2025-09-30": 2,
            "2025-10-01": 1,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 17,
            "2025-10-08": 1,
            "2025-10-09": 9,
            "2025-10-10": 4,
            "2025-10-13": 10,
            "2025-10-14": 10,
            "2025-10-15": 14,
            "2025-10-17": 10,
            "2025-10-20": 3,
            "2025-10-21": 7,
            "2025-10-22": 1,
            "2025-10-23": 12,
            "2025-10-24": 1,
            "2025-10-25": 9,
            "2025-10-27": 14,
            "2025-10-29": 7,
            "2025-10-30": 8,
            "2025-10-31": 4,
            "2025-11-03": 4,
            "2025-11-05": 12,
            "2025-11-06": 3,
            "2025-11-07": 5,
            "2025-11-10": 10,
            "2025-11-11": 5,
            "2025-11-12": 10,
            "2025-11-13": 3,
            "2025-11-14": 13,
            "2025-11-19": 11,
            "2025-11-20": 6,
            "2025-11-21": 16,
            "2025-11-23": 5,
            "2025-11-24": 6,
            "2025-11-25": 6,
            "2025-11-27": 2,
            "2025-11-29": 17,
            "2025-12-02": 15,
            "2025-12-03": 7,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 7,
            "2025-12-11": 5,
            "2025-12-15": 2,
            "2025-12-22": 7,
            "2025-12-23": 1,
            "2025-12-30": 1,
            "2026-01-08": 3,
            "2026-01-13": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-06": 3,
            "2026-02-09": 2,
            "2026-02-10": 2,
            "2026-02-11": 1,
            "2026-02-12": 2,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-02-18": 2,
            "2026-02-19": 3,
            "2026-02-20": 1,
            "2026-02-21": 1,
            "2026-02-23": 5,
            "2026-02-28": 5,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-14": 10,
            "2026-03-17": 6,
            "2026-03-18": 57,
            "2026-03-20": 6,
            "2026-03-24": 5,
            "2026-03-26": 3,
            "2026-04-08": 1,
            "2026-04-22": 3,
            "2026-06-01": 1,
            "2026-06-06": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 493.55,
          "mode_time_hours": 473.0,
          "mode_frequency": 4,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "14-16h": 2,
            "52-54h": 3,
            "72-74h": 3,
            "98-100h": 1,
            "100-102h": 1,
            "110-112h": 1,
            "126-128h": 1,
            "136-138h": 3,
            "142-144h": 1,
            "144-146h": 1,
            "162-164h": 1,
            "164-166h": 1,
            "168-170h": 1,
            "180-182h": 1,
            "184-186h": 1,
            "198-200h": 1,
            "202-204h": 1,
            "204-206h": 2,
            "218-220h": 1,
            "228-230h": 1,
            "230-232h": 1,
            "232-234h": 2,
            "238-240h": 1,
            "294-296h": 1,
            "300-302h": 1,
            "302-304h": 3,
            "318-320h": 1,
            "334-336h": 1,
            "366-368h": 1,
            "378-380h": 1,
            "466-468h": 1,
            "472-474h": 4,
            "482-484h": 1,
            "532-534h": 1,
            "542-544h": 1,
            "544-546h": 1,
            "552-554h": 1,
            "638-640h": 2,
            "650-652h": 1,
            "652-654h": 1,
            "664-666h": 1,
            "710-712h": 1,
            "734-736h": 1,
            "736-738h": 2,
            "808-810h": 1,
            "814-816h": 1,
            "830-832h": 1,
            "888-890h": 1,
            "1150-1152h": 1,
            "1214-1216h": 1,
            "1704-1706h": 1,
            "1916-1918h": 1,
            "1962-1964h": 1,
            "2124-2126h": 1,
            "2132-2134h": 1,
            "2272-2274h": 1
          },
          "tickets_count": 78,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 6,
            "2025-12-04": 3,
            "2025-12-05": 5,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 4,
            "2025-12-12": 3,
            "2025-12-15": 2,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-26": 4,
            "2025-12-29": 2,
            "2026-01-02": 2,
            "2026-01-15": 1,
            "2026-02-18": 4,
            "2026-02-19": 31,
            "2026-02-20": 2,
            "2026-03-02": 1,
            "2026-03-04": 1
          },
          "time_per_day": {
            "2025-12-02": 2.251583888888889,
            "2025-12-03": 509.6243180555555,
            "2025-12-04": 495.03842750000007,
            "2025-12-05": 1162.514437222222,
            "2025-12-09": 136.94434027777777,
            "2025-12-10": 548.0623105555555,
            "2025-12-11": 306.34277944444443,
            "2025-12-12": 699.2380949999999,
            "2025-12-15": 612.38797,
            "2025-12-16": 142.81966555555556,
            "2025-12-17": 165.02886694444445,
            "2025-12-19": 466.32562916666666,
            "2025-12-26": 2992.2209344444445,
            "2025-12-29": 1271.2469722222222,
            "2026-01-02": 1303.1447194444445,
            "2026-01-15": 1150.99891,
            "2026-02-18": 7718.1445425,
            "2026-02-19": 16840.27459388889
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 6,
            "2025-12-04": 3,
            "2025-12-05": 5,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 4,
            "2025-12-12": 3,
            "2025-12-15": 2,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-26": 4,
            "2025-12-29": 2,
            "2026-01-02": 2,
            "2026-01-15": 1,
            "2026-02-18": 4,
            "2026-02-19": 31
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 107.29,
            "mode_time_hours": 1.0,
            "mode_frequency": 452,
            "time_distribution": {
              "0-2h": 452,
              "2-4h": 89,
              "4-6h": 17,
              "6-8h": 19,
              "8-10h": 6,
              "10-12h": 7,
              "12-14h": 3,
              "14-16h": 6,
              "16-18h": 6,
              "18-20h": 18,
              "20-22h": 24,
              "22-24h": 21,
              "24-26h": 11,
              "26-28h": 5,
              "28-30h": 12,
              "30-32h": 12,
              "32-34h": 8,
              "34-36h": 7,
              "36-38h": 8,
              "38-40h": 2,
              "40-42h": 12,
              "42-44h": 3,
              "44-46h": 9,
              "46-48h": 7,
              "48-50h": 4,
              "50-52h": 5,
              "52-54h": 8,
              "54-56h": 2,
              "56-58h": 1,
              "58-60h": 2,
              "60-62h": 1,
              "66-68h": 2,
              "68-70h": 6,
              "70-72h": 6,
              "72-74h": 9,
              "74-76h": 6,
              "76-78h": 5,
              "78-80h": 3,
              "80-82h": 1,
              "82-84h": 1,
              "84-86h": 1,
              "88-90h": 1,
              "90-92h": 1,
              "92-94h": 6,
              "94-96h": 11,
              "96-98h": 7,
              "98-100h": 5,
              "100-102h": 1,
              "102-104h": 3,
              "104-106h": 2,
              "108-110h": 1,
              "110-112h": 3,
              "112-114h": 3,
              "114-116h": 5,
              "116-118h": 8,
              "118-120h": 4,
              "120-122h": 3,
              "122-124h": 3,
              "124-126h": 3,
              "126-128h": 3,
              "128-130h": 1,
              "136-138h": 4,
              "140-142h": 2,
              "142-144h": 7,
              "144-146h": 5,
              "146-148h": 1,
              "148-150h": 2,
              "150-152h": 1,
              "152-154h": 2,
              "156-158h": 1,
              "158-160h": 4,
              "160-162h": 1,
              "162-164h": 3,
              "164-166h": 4,
              "166-168h": 3,
              "168-170h": 7,
              "172-174h": 2,
              "174-176h": 2,
              "176-178h": 1,
              "178-180h": 5,
              "180-182h": 4,
              "184-186h": 2,
              "186-188h": 2,
              "188-190h": 2,
              "192-194h": 1,
              "194-196h": 2,
              "196-198h": 2,
              "198-200h": 2,
              "200-202h": 3,
              "202-204h": 1,
              "204-206h": 2,
              "208-210h": 1,
              "210-212h": 5,
              "214-216h": 1,
              "216-218h": 3,
              "218-220h": 3,
              "220-222h": 1,
              "222-224h": 2,
              "228-230h": 2,
              "230-232h": 1,
              "232-234h": 2,
              "234-236h": 1,
              "236-238h": 1,
              "238-240h": 1,
              "246-248h": 1,
              "248-250h": 1,
              "252-254h": 1,
              "256-258h": 2,
              "258-260h": 1,
              "260-262h": 1,
              "262-264h": 1,
              "266-268h": 3,
              "268-270h": 1,
              "278-280h": 3,
              "282-284h": 1,
              "284-286h": 1,
              "286-288h": 2,
              "288-290h": 2,
              "294-296h": 1,
              "300-302h": 1,
              "302-304h": 3,
              "304-306h": 1,
              "308-310h": 1,
              "310-312h": 1,
              "312-314h": 1,
              "316-318h": 1,
              "318-320h": 3,
              "320-322h": 1,
              "324-326h": 1,
              "328-330h": 1,
              "332-334h": 1,
              "334-336h": 6,
              "340-342h": 1,
              "344-346h": 1,
              "346-348h": 1,
              "354-356h": 1,
              "356-358h": 2,
              "358-360h": 2,
              "366-368h": 4,
              "370-372h": 1,
              "372-374h": 1,
              "378-380h": 1,
              "382-384h": 4,
              "384-386h": 2,
              "388-390h": 1,
              "400-402h": 1,
              "404-406h": 2,
              "410-412h": 1,
              "416-418h": 2,
              "418-420h": 1,
              "424-426h": 1,
              "426-428h": 1,
              "428-430h": 1,
              "432-434h": 1,
              "452-454h": 1,
              "454-456h": 4,
              "456-458h": 2,
              "466-468h": 1,
              "468-470h": 1,
              "470-472h": 1,
              "472-474h": 5,
              "478-480h": 1,
              "482-484h": 1,
              "492-494h": 1,
              "496-498h": 2,
              "500-502h": 2,
              "508-510h": 1,
              "512-514h": 1,
              "522-524h": 2,
              "532-534h": 1,
              "540-542h": 1,
              "542-544h": 1,
              "544-546h": 1,
              "552-554h": 1,
              "562-564h": 1,
              "572-574h": 1,
              "574-576h": 1,
              "578-580h": 1,
              "638-640h": 2,
              "646-648h": 1,
              "650-652h": 1,
              "652-654h": 1,
              "664-666h": 2,
              "678-680h": 3,
              "700-702h": 1,
              "710-712h": 1,
              "734-736h": 1,
              "736-738h": 2,
              "740-742h": 1,
              "742-744h": 1,
              "808-810h": 1,
              "814-816h": 1,
              "824-826h": 2,
              "830-832h": 1,
              "844-846h": 1,
              "846-848h": 1,
              "888-890h": 1,
              "1036-1038h": 1,
              "1056-1058h": 1,
              "1150-1152h": 1,
              "1198-1200h": 1,
              "1214-1216h": 1,
              "1278-1280h": 1,
              "1704-1706h": 1,
              "1916-1918h": 1,
              "1962-1964h": 1,
              "2124-2126h": 1,
              "2132-2134h": 1,
              "2152-2154h": 1,
              "2272-2274h": 1,
              "2344-2346h": 1,
              "2374-2376h": 1
            },
            "tickets_count": 1157,
            "tickets_per_day": {
              "2025-09-30": 3,
              "2025-10-01": 1,
              "2025-10-03": 4,
              "2025-10-06": 3,
              "2025-10-07": 20,
              "2025-10-08": 1,
              "2025-10-09": 10,
              "2025-10-10": 5,
              "2025-10-13": 11,
              "2025-10-14": 16,
              "2025-10-15": 18,
              "2025-10-17": 10,
              "2025-10-20": 3,
              "2025-10-21": 11,
              "2025-10-22": 2,
              "2025-10-23": 13,
              "2025-10-24": 3,
              "2025-10-25": 10,
              "2025-10-27": 16,
              "2025-10-28": 3,
              "2025-10-29": 8,
              "2025-10-30": 11,
              "2025-10-31": 6,
              "2025-11-03": 6,
              "2025-11-04": 1,
              "2025-11-05": 13,
              "2025-11-06": 12,
              "2025-11-07": 8,
              "2025-11-10": 15,
              "2025-11-11": 5,
              "2025-11-12": 10,
              "2025-11-13": 8,
              "2025-11-14": 16,
              "2025-11-19": 14,
              "2025-11-20": 7,
              "2025-11-21": 17,
              "2025-11-23": 6,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-27": 2,
              "2025-11-29": 18,
              "2025-12-02": 28,
              "2025-12-03": 14,
              "2025-12-04": 5,
              "2025-12-05": 8,
              "2025-12-08": 1,
              "2025-12-09": 3,
              "2025-12-10": 9,
              "2025-12-11": 12,
              "2025-12-12": 9,
              "2025-12-15": 11,
              "2025-12-16": 1,
              "2025-12-17": 3,
              "2025-12-18": 1,
              "2025-12-19": 2,
              "2025-12-22": 9,
              "2025-12-23": 1,
              "2025-12-26": 6,
              "2025-12-29": 2,
              "2025-12-30": 2,
              "2026-01-02": 3,
              "2026-01-05": 1,
              "2026-01-07": 5,
              "2026-01-08": 5,
              "2026-01-09": 1,
              "2026-01-12": 4,
              "2026-01-13": 7,
              "2026-01-14": 1,
              "2026-01-15": 5,
              "2026-01-16": 3,
              "2026-01-18": 1,
              "2026-01-20": 3,
              "2026-01-21": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-01-29": 1,
              "2026-01-30": 5,
              "2026-02-02": 4,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-06": 8,
              "2026-02-09": 3,
              "2026-02-10": 8,
              "2026-02-11": 2,
              "2026-02-12": 8,
              "2026-02-13": 12,
              "2026-02-17": 1,
              "2026-02-18": 8,
              "2026-02-19": 34,
              "2026-02-20": 7,
              "2026-02-21": 1,
              "2026-02-23": 5,
              "2026-02-28": 7,
              "2026-03-01": 1,
              "2026-03-02": 1,
              "2026-03-04": 7,
              "2026-03-05": 4,
              "2026-03-06": 4,
              "2026-03-07": 2,
              "2026-03-14": 10,
              "2026-03-16": 7,
              "2026-03-17": 7,
              "2026-03-18": 64,
              "2026-03-19": 5,
              "2026-03-20": 6,
              "2026-03-21": 3,
              "2026-03-23": 2,
              "2026-03-24": 13,
              "2026-03-25": 4,
              "2026-03-26": 4,
              "2026-03-27": 5,
              "2026-03-28": 1,
              "2026-03-30": 3,
              "2026-03-31": 9,
              "2026-04-02": 7,
              "2026-04-06": 6,
              "2026-04-07": 3,
              "2026-04-08": 1,
              "2026-04-09": 12,
              "2026-04-10": 1,
              "2026-04-13": 9,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-16": 8,
              "2026-04-17": 3,
              "2026-04-18": 1,
              "2026-04-20": 10,
              "2026-04-21": 4,
              "2026-04-22": 7,
              "2026-04-23": 7,
              "2026-04-24": 3,
              "2026-04-27": 11,
              "2026-04-28": 3,
              "2026-04-29": 3,
              "2026-04-30": 7,
              "2026-05-02": 3,
              "2026-05-04": 7,
              "2026-05-05": 4,
              "2026-05-06": 6,
              "2026-05-07": 6,
              "2026-05-08": 6,
              "2026-05-09": 1,
              "2026-05-11": 4,
              "2026-05-12": 5,
              "2026-05-13": 9,
              "2026-05-14": 10,
              "2026-05-15": 11,
              "2026-05-18": 11,
              "2026-05-19": 9,
              "2026-05-20": 9,
              "2026-05-21": 5,
              "2026-05-22": 14,
              "2026-05-23": 4,
              "2026-05-25": 8,
              "2026-05-26": 10,
              "2026-05-27": 6,
              "2026-05-28": 1,
              "2026-05-29": 9,
              "2026-06-01": 10,
              "2026-06-02": 13,
              "2026-06-03": 8,
              "2026-06-05": 28,
              "2026-06-06": 4,
              "2026-06-08": 11
            },
            "time_per_day": {
              "2025-09-30": 3.413374722222222,
              "2025-10-01": 24.06752388888889,
              "2025-10-03": 137.96832666666666,
              "2025-10-06": 7.296663888888889,
              "2025-10-07": 1100.6900950000002,
              "2025-10-08": 0.5847205555555556,
              "2025-10-09": 682.3173444444444,
              "2025-10-10": 438.3128313888889,
              "2025-10-13": 838.2040825,
              "2025-10-14": 1006.5966394444443,
              "2025-10-15": 1241.529676111111,
              "2025-10-17": 301.2312430555555,
              "2025-10-20": 384.33581944444444,
              "2025-10-21": 684.8643141666665,
              "2025-10-22": 407.3903788888889,
              "2025-10-23": 451.18869527777775,
              "2025-10-24": 392.1889463888889,
              "2025-10-25": 1070.0072452777779,
              "2025-10-27": 1935.3804522222222,
              "2025-10-28": 27.77580888888889,
              "2025-10-29": 415.2642858333333,
              "2025-10-30": 2280.0865955555555,
              "2025-10-31": 66.43046527777778,
              "2025-11-03": 436.1560247222222,
              "2025-11-04": 0.016178333333333333,
              "2025-11-05": 1642.6222019444444,
              "2025-11-06": 2300.049122777778,
              "2025-11-07": 386.23072833333333,
              "2025-11-10": 1414.5868077777777,
              "2025-11-11": 391.11480416666666,
              "2025-11-12": 617.1057438888889,
              "2025-11-13": 605.7670488888889,
              "2025-11-14": 3805.1868905555557,
              "2025-11-19": 1319.2439744444448,
              "2025-11-20": 397.49395888888887,
              "2025-11-21": 1645.9268116666665,
              "2025-11-23": 198.23639416666666,
              "2025-11-24": 1431.215703888889,
              "2025-11-25": 230.31930416666665,
              "2025-11-27": 89.21703,
              "2025-11-29": 3682.4317838888887,
              "2025-12-02": 3775.639446388889,
              "2025-12-03": 1781.2693519444445,
              "2025-12-04": 597.9171511111111,
              "2025-12-05": 1242.0123802777778,
              "2025-12-08": 178.52628416666667,
              "2025-12-09": 228.1621186111111,
              "2025-12-10": 847.9348266666666,
              "2025-12-11": 1122.7219786111114,
              "2025-12-12": 1274.0440449999999,
              "2025-12-15": 1306.1727013888892,
              "2025-12-16": 142.81966555555556,
              "2025-12-17": 1222.0160091666667,
              "2025-12-18": 664.2215874999999,
              "2025-12-19": 704.1715975,
              "2025-12-22": 1465.4473466666668,
              "2025-12-23": 20.733946666666668,
              "2025-12-26": 2995.2936797222224,
              "2025-12-29": 1271.2469722222222,
              "2025-12-30": 6.173720555555556,
              "2026-01-02": 1303.2341483333335,
              "2026-01-05": 0.7188022222222222,
              "2026-01-07": 5.444769166666667,
              "2026-01-08": 200.56989444444443,
              "2026-01-09": 2.843283611111111,
              "2026-01-12": 1.1786366666666668,
              "2026-01-13": 10.968097777777777,
              "2026-01-14": 0.47969500000000004,
              "2026-01-15": 1179.57372,
              "2026-01-16": 0.6163058333333333,
              "2026-01-18": 1.2740480555555556,
              "2026-01-20": 0.23338916666666668,
              "2026-01-21": 412.9642302777778,
              "2026-01-23": 1198.5635597222224,
              "2026-01-27": 315.86450055555554,
              "2026-01-29": 16.547351111111112,
              "2026-01-30": 115.97010722222223,
              "2026-02-02": 1.9360813888888888,
              "2026-02-03": 5.900456944444445,
              "2026-02-05": 80.9097425,
              "2026-02-06": 313.70778694444436,
              "2026-02-09": 156.23611027777775,
              "2026-02-10": 1312.5788552777778,
              "2026-02-11": 215.76989055555555,
              "2026-02-12": 3086.915321388889,
              "2026-02-13": 616.2494455555556,
              "2026-02-17": 142.59776444444444,
              "2026-02-18": 8172.753432222222,
              "2026-02-19": 16988.460003333337,
              "2026-02-20": 355.52572027777785,
              "2026-02-21": 52.60538444444444,
              "2026-02-23": 291.54892611111114,
              "2026-02-28": 637.4640677777777,
              "2026-03-01": 1.4713325,
              "2026-03-02": 4.074475277777778,
              "2026-03-04": 5.058054722222222,
              "2026-03-05": 1.690439722222222,
              "2026-03-06": 5.153587777777778,
              "2026-03-07": 0.34648666666666667,
              "2026-03-14": 710.8099730555555,
              "2026-03-16": 2.7827047222222223,
              "2026-03-17": 357.94331111111114,
              "2026-03-18": 19872.856035277782,
              "2026-03-19": 0.6124633333333334,
              "2026-03-20": 2602.873223888889,
              "2026-03-21": 8.283401944444444,
              "2026-03-23": 1.5455088888888888,
              "2026-03-24": 720.7530119444446,
              "2026-03-25": 4.287197222222223,
              "2026-03-26": 1663.4273102777777,
              "2026-03-27": 4.206545,
              "2026-03-28": 1.2578880555555556,
              "2026-03-30": 111.25769361111112,
              "2026-03-31": 23.956553333333336,
              "2026-04-02": 0.8939725000000001,
              "2026-04-06": 10.495324722222223,
              "2026-04-07": 1.3245247222222223,
              "2026-04-08": 145.07749555555554,
              "2026-04-09": 311.7132652777777,
              "2026-04-10": 0.5312247222222223,
              "2026-04-13": 9.018739444444444,
              "2026-04-14": 1.958396388888889,
              "2026-04-15": 1.0337097222222222,
              "2026-04-16": 2.4645941666666666,
              "2026-04-17": 3.9189563888888888,
              "2026-04-18": 3.0794444444444444,
              "2026-04-20": 6.269298611111112,
              "2026-04-21": 2.2994822222222226,
              "2026-04-22": 430.38678472222216,
              "2026-04-23": 687.0942877777778,
              "2026-04-24": 18.682498055555556,
              "2026-04-27": 1.6681730555555554,
              "2026-04-28": 8.406531388888888,
              "2026-04-29": 4.043160555555556,
              "2026-04-30": 32.721746111111116,
              "2026-05-02": 2.949578333333333,
              "2026-05-04": 6.74355861111111,
              "2026-05-05": 2.7183555555555556,
              "2026-05-06": 2158.860638611111,
              "2026-05-07": 5.942641666666667,
              "2026-05-08": 7.461678611111111,
              "2026-05-09": 13.23972388888889,
              "2026-05-11": 4.473174722222222,
              "2026-05-12": 9.207008888888888,
              "2026-05-13": 3.619744444444444,
              "2026-05-14": 3.454493888888889,
              "2026-05-15": 11.070950833333333,
              "2026-05-18": 2.9719244444444444,
              "2026-05-19": 13.642463333333332,
              "2026-05-20": 7.259925000000001,
              "2026-05-21": 8.291316111111112,
              "2026-05-22": 9.976853055555555,
              "2026-05-23": 10.071846666666668,
              "2026-05-25": 4.0109216666666665,
              "2026-05-26": 10.026299166666664,
              "2026-05-27": 9.730844444444445,
              "2026-05-28": 0.34180750000000004,
              "2026-05-29": 6.195584722222222,
              "2026-06-01": 422.2042811111112,
              "2026-06-02": 5.602555000000001,
              "2026-06-03": 11.313926388888888,
              "2026-06-05": 210.2429597222223,
              "2026-06-06": 848.033231111111,
              "2026-06-08": 4.374390555555555
            },
            "time_count_per_day": {
              "2025-09-30": 3,
              "2025-10-01": 1,
              "2025-10-03": 4,
              "2025-10-06": 3,
              "2025-10-07": 20,
              "2025-10-08": 1,
              "2025-10-09": 10,
              "2025-10-10": 5,
              "2025-10-13": 11,
              "2025-10-14": 16,
              "2025-10-15": 18,
              "2025-10-17": 10,
              "2025-10-20": 3,
              "2025-10-21": 11,
              "2025-10-22": 2,
              "2025-10-23": 13,
              "2025-10-24": 3,
              "2025-10-25": 10,
              "2025-10-27": 16,
              "2025-10-28": 3,
              "2025-10-29": 8,
              "2025-10-30": 11,
              "2025-10-31": 6,
              "2025-11-03": 6,
              "2025-11-04": 1,
              "2025-11-05": 13,
              "2025-11-06": 12,
              "2025-11-07": 8,
              "2025-11-10": 15,
              "2025-11-11": 5,
              "2025-11-12": 10,
              "2025-11-13": 8,
              "2025-11-14": 16,
              "2025-11-19": 14,
              "2025-11-20": 7,
              "2025-11-21": 17,
              "2025-11-23": 6,
              "2025-11-24": 14,
              "2025-11-25": 6,
              "2025-11-27": 2,
              "2025-11-29": 18,
              "2025-12-02": 28,
              "2025-12-03": 14,
              "2025-12-04": 5,
              "2025-12-05": 8,
              "2025-12-08": 1,
              "2025-12-09": 3,
              "2025-12-10": 9,
              "2025-12-11": 12,
              "2025-12-12": 9,
              "2025-12-15": 11,
              "2025-12-16": 1,
              "2025-12-17": 3,
              "2025-12-18": 1,
              "2025-12-19": 2,
              "2025-12-22": 9,
              "2025-12-23": 1,
              "2025-12-26": 6,
              "2025-12-29": 2,
              "2025-12-30": 2,
              "2026-01-02": 3,
              "2026-01-05": 1,
              "2026-01-07": 5,
              "2026-01-08": 5,
              "2026-01-09": 1,
              "2026-01-12": 4,
              "2026-01-13": 7,
              "2026-01-14": 1,
              "2026-01-15": 5,
              "2026-01-16": 3,
              "2026-01-18": 1,
              "2026-01-20": 3,
              "2026-01-21": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-01-29": 1,
              "2026-01-30": 5,
              "2026-02-02": 4,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-06": 8,
              "2026-02-09": 3,
              "2026-02-10": 8,
              "2026-02-11": 2,
              "2026-02-12": 8,
              "2026-02-13": 12,
              "2026-02-17": 1,
              "2026-02-18": 8,
              "2026-02-19": 34,
              "2026-02-20": 7,
              "2026-02-21": 1,
              "2026-02-23": 5,
              "2026-02-28": 7,
              "2026-03-01": 1,
              "2026-03-02": 1,
              "2026-03-04": 7,
              "2026-03-05": 4,
              "2026-03-06": 4,
              "2026-03-07": 2,
              "2026-03-14": 10,
              "2026-03-16": 7,
              "2026-03-17": 7,
              "2026-03-18": 64,
              "2026-03-19": 5,
              "2026-03-20": 6,
              "2026-03-21": 3,
              "2026-03-23": 2,
              "2026-03-24": 13,
              "2026-03-25": 4,
              "2026-03-26": 4,
              "2026-03-27": 5,
              "2026-03-28": 1,
              "2026-03-30": 3,
              "2026-03-31": 9,
              "2026-04-02": 7,
              "2026-04-06": 6,
              "2026-04-07": 3,
              "2026-04-08": 1,
              "2026-04-09": 12,
              "2026-04-10": 1,
              "2026-04-13": 9,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-16": 8,
              "2026-04-17": 3,
              "2026-04-18": 1,
              "2026-04-20": 10,
              "2026-04-21": 4,
              "2026-04-22": 7,
              "2026-04-23": 7,
              "2026-04-24": 3,
              "2026-04-27": 11,
              "2026-04-28": 3,
              "2026-04-29": 3,
              "2026-04-30": 7,
              "2026-05-02": 3,
              "2026-05-04": 7,
              "2026-05-05": 4,
              "2026-05-06": 6,
              "2026-05-07": 6,
              "2026-05-08": 6,
              "2026-05-09": 1,
              "2026-05-11": 4,
              "2026-05-12": 5,
              "2026-05-13": 9,
              "2026-05-14": 10,
              "2026-05-15": 11,
              "2026-05-18": 11,
              "2026-05-19": 9,
              "2026-05-20": 9,
              "2026-05-21": 5,
              "2026-05-22": 14,
              "2026-05-23": 4,
              "2026-05-25": 8,
              "2026-05-26": 10,
              "2026-05-27": 6,
              "2026-05-28": 1,
              "2026-05-29": 9,
              "2026-06-01": 10,
              "2026-06-02": 13,
              "2026-06-03": 8,
              "2026-06-05": 28,
              "2026-06-06": 4,
              "2026-06-08": 11
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 37.28,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 37.28416638888889
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            },
            "P2": {
              "avg_time_hours": 22.06,
              "mode_time_hours": 1.0,
              "mode_frequency": 424,
              "time_distribution": {
                "0-2h": 424,
                "2-4h": 70,
                "4-6h": 9,
                "6-8h": 6,
                "8-10h": 1,
                "10-12h": 6,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "22-24h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "34-36h": 1,
                "36-38h": 3,
                "40-42h": 2,
                "44-46h": 3,
                "68-70h": 1,
                "96-98h": 2,
                "98-100h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "122-124h": 1,
                "156-158h": 1,
                "178-180h": 1,
                "198-200h": 1,
                "210-212h": 1,
                "236-238h": 1,
                "258-260h": 1,
                "262-264h": 1,
                "310-312h": 1,
                "312-314h": 1,
                "316-318h": 1,
                "340-342h": 1,
                "356-358h": 1,
                "410-412h": 1,
                "472-474h": 1,
                "508-510h": 1,
                "562-564h": 1,
                "646-648h": 1,
                "664-666h": 1,
                "678-680h": 2,
                "742-744h": 1,
                "1036-1038h": 1,
                "1056-1058h": 1
              },
              "tickets_count": 562,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-14": 3,
                "2025-10-15": 2,
                "2025-10-21": 4,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-10-25": 1,
                "2025-10-27": 1,
                "2025-10-28": 3,
                "2025-10-29": 1,
                "2025-10-30": 2,
                "2025-10-31": 2,
                "2025-11-03": 2,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 2,
                "2025-11-07": 3,
                "2025-11-10": 5,
                "2025-11-13": 5,
                "2025-11-14": 2,
                "2025-11-19": 3,
                "2025-11-20": 1,
                "2025-11-23": 1,
                "2025-11-24": 6,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-08": 1,
                "2025-12-09": 1,
                "2025-12-11": 3,
                "2025-12-12": 4,
                "2025-12-15": 6,
                "2025-12-17": 2,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-26": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-07": 5,
                "2026-01-08": 2,
                "2026-01-09": 1,
                "2026-01-12": 4,
                "2026-01-13": 5,
                "2026-01-14": 1,
                "2026-01-15": 3,
                "2026-01-16": 3,
                "2026-01-18": 1,
                "2026-01-20": 3,
                "2026-01-21": 2,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-01-30": 5,
                "2026-02-02": 4,
                "2026-02-03": 2,
                "2026-02-06": 5,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 5,
                "2026-02-13": 5,
                "2026-02-20": 5,
                "2026-02-28": 2,
                "2026-03-01": 1,
                "2026-03-02": 1,
                "2026-03-04": 7,
                "2026-03-05": 4,
                "2026-03-06": 3,
                "2026-03-07": 1,
                "2026-03-16": 7,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-19": 5,
                "2026-03-21": 3,
                "2026-03-23": 2,
                "2026-03-24": 8,
                "2026-03-25": 4,
                "2026-03-26": 1,
                "2026-03-27": 5,
                "2026-03-28": 1,
                "2026-03-30": 3,
                "2026-03-31": 9,
                "2026-04-02": 7,
                "2026-04-06": 6,
                "2026-04-07": 3,
                "2026-04-09": 12,
                "2026-04-10": 1,
                "2026-04-13": 8,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-16": 8,
                "2026-04-17": 3,
                "2026-04-18": 1,
                "2026-04-20": 10,
                "2026-04-21": 4,
                "2026-04-22": 4,
                "2026-04-23": 7,
                "2026-04-24": 3,
                "2026-04-27": 11,
                "2026-04-28": 3,
                "2026-04-29": 3,
                "2026-04-30": 7,
                "2026-05-02": 3,
                "2026-05-04": 7,
                "2026-05-05": 4,
                "2026-05-06": 5,
                "2026-05-07": 6,
                "2026-05-08": 6,
                "2026-05-09": 1,
                "2026-05-11": 4,
                "2026-05-12": 5,
                "2026-05-13": 9,
                "2026-05-14": 10,
                "2026-05-15": 11,
                "2026-05-18": 11,
                "2026-05-19": 9,
                "2026-05-20": 9,
                "2026-05-21": 5,
                "2026-05-22": 14,
                "2026-05-23": 4,
                "2026-05-25": 8,
                "2026-05-26": 10,
                "2026-05-27": 6,
                "2026-05-28": 1,
                "2026-05-29": 9,
                "2026-06-01": 9,
                "2026-06-02": 13,
                "2026-06-03": 8,
                "2026-06-05": 28,
                "2026-06-06": 1,
                "2026-06-08": 11
              },
              "time_per_day": {
                "2025-09-30": 0.2738661111111111,
                "2025-10-03": 25.337097500000002,
                "2025-10-06": 0.3978744444444444,
                "2025-10-07": 124.97357833333334,
                "2025-10-09": 0.2323413888888889,
                "2025-10-10": 10.058805833333334,
                "2025-10-14": 3.0587625,
                "2025-10-15": 163.99700305555555,
                "2025-10-21": 3.556356388888889,
                "2025-10-22": 211.27871666666667,
                "2025-10-23": 199.83179222222225,
                "2025-10-24": 0.8987066666666667,
                "2025-10-25": 0.6397405555555555,
                "2025-10-27": 0.8519711111111111,
                "2025-10-28": 27.77580888888889,
                "2025-10-29": 11.730011388888888,
                "2025-10-30": 226.54228805555556,
                "2025-10-31": 0.28388888888888886,
                "2025-11-03": 0.8393297222222222,
                "2025-11-04": 0.016178333333333333,
                "2025-11-05": 97.12117527777778,
                "2025-11-06": 2.6799858333333333,
                "2025-11-07": 342.6969716666667,
                "2025-11-10": 2.1453569444444445,
                "2025-11-13": 102.73550944444445,
                "2025-11-14": 1394.300573888889,
                "2025-11-19": 3.100338333333333,
                "2025-11-20": 0.3957102777777778,
                "2025-11-23": 0.591426388888889,
                "2025-11-24": 122.20086972222224,
                "2025-12-03": 0.10423972222222222,
                "2025-12-05": 0.1277825,
                "2025-12-08": 178.52628416666667,
                "2025-12-09": 1.1079255555555556,
                "2025-12-11": 515.3570891666667,
                "2025-12-12": 1.1793875000000003,
                "2025-12-15": 1.6717972222222222,
                "2025-12-17": 1056.9871422222222,
                "2025-12-18": 664.2215874999999,
                "2025-12-19": 237.84596833333333,
                "2025-12-22": 743.1364861111111,
                "2025-12-26": 3.072745277777778,
                "2025-12-30": 0.8887186111111112,
                "2026-01-02": 0.08942888888888889,
                "2026-01-05": 0.7188022222222222,
                "2026-01-07": 5.444769166666667,
                "2026-01-08": 2.2338061111111114,
                "2026-01-09": 2.843283611111111,
                "2026-01-12": 1.1786366666666668,
                "2026-01-13": 6.935640555555556,
                "2026-01-14": 0.47969500000000004,
                "2026-01-15": 6.9156152777777775,
                "2026-01-16": 0.6163058333333333,
                "2026-01-18": 1.2740480555555556,
                "2026-01-20": 0.23338916666666668,
                "2026-01-21": 412.9642302777778,
                "2026-01-27": 313.3106702777778,
                "2026-01-29": 16.547351111111112,
                "2026-01-30": 115.97010722222223,
                "2026-02-02": 1.9360813888888888,
                "2026-02-03": 5.900456944444445,
                "2026-02-06": 0.28036833333333333,
                "2026-02-09": 8.078096944444445,
                "2026-02-10": 523.9460002777779,
                "2026-02-11": 1.1373833333333334,
                "2026-02-12": 2746.1860058333336,
                "2026-02-13": 3.995711388888889,
                "2026-02-20": 8.453201388888889,
                "2026-02-28": 17.766421666666666,
                "2026-03-01": 1.4713325,
                "2026-03-02": 4.074475277777778,
                "2026-03-04": 5.058054722222222,
                "2026-03-05": 1.690439722222222,
                "2026-03-06": 3.8701036111111113,
                "2026-03-07": 0.3342277777777778,
                "2026-03-16": 2.7827047222222223,
                "2026-03-17": 0.22752361111111113,
                "2026-03-18": 6.984445277777778,
                "2026-03-19": 0.6124633333333334,
                "2026-03-21": 8.283401944444444,
                "2026-03-23": 1.5455088888888888,
                "2026-03-24": 7.2154516666666675,
                "2026-03-25": 4.287197222222223,
                "2026-03-26": 0.4299894444444444,
                "2026-03-27": 4.206545,
                "2026-03-28": 1.2578880555555556,
                "2026-03-30": 111.25769361111112,
                "2026-03-31": 23.956553333333336,
                "2026-04-02": 0.8939725000000001,
                "2026-04-06": 10.495324722222223,
                "2026-04-07": 1.3245247222222223,
                "2026-04-09": 311.7132652777777,
                "2026-04-10": 0.5312247222222223,
                "2026-04-13": 1.9100458333333334,
                "2026-04-14": 1.958396388888889,
                "2026-04-15": 1.0337097222222222,
                "2026-04-16": 2.4645941666666666,
                "2026-04-17": 3.9189563888888888,
                "2026-04-18": 3.0794444444444444,
                "2026-04-20": 6.269298611111112,
                "2026-04-21": 2.2994822222222226,
                "2026-04-22": 11.308571944444445,
                "2026-04-23": 687.0942877777778,
                "2026-04-24": 18.682498055555556,
                "2026-04-27": 1.6681730555555554,
                "2026-04-28": 8.406531388888888,
                "2026-04-29": 4.043160555555556,
                "2026-04-30": 32.721746111111116,
                "2026-05-02": 2.949578333333333,
                "2026-05-04": 6.74355861111111,
                "2026-05-05": 2.7183555555555556,
                "2026-05-06": 5.9857394444444445,
                "2026-05-07": 5.942641666666667,
                "2026-05-08": 7.461678611111111,
                "2026-05-09": 13.23972388888889,
                "2026-05-11": 4.473174722222222,
                "2026-05-12": 9.207008888888888,
                "2026-05-13": 3.619744444444444,
                "2026-05-14": 3.454493888888889,
                "2026-05-15": 11.070950833333333,
                "2026-05-18": 2.9719244444444444,
                "2026-05-19": 13.642463333333332,
                "2026-05-20": 7.259925000000001,
                "2026-05-21": 8.291316111111112,
                "2026-05-22": 9.976853055555555,
                "2026-05-23": 10.071846666666668,
                "2026-05-25": 4.0109216666666665,
                "2026-05-26": 10.026299166666664,
                "2026-05-27": 9.730844444444445,
                "2026-05-28": 0.34180750000000004,
                "2026-05-29": 6.195584722222222,
                "2026-06-01": 16.306101666666667,
                "2026-06-02": 5.602555000000001,
                "2026-06-03": 11.313926388888888,
                "2026-06-05": 210.2429597222223,
                "2026-06-06": 0.07125333333333334,
                "2026-06-08": 4.374390555555555
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-14": 3,
                "2025-10-15": 2,
                "2025-10-21": 4,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-10-25": 1,
                "2025-10-27": 1,
                "2025-10-28": 3,
                "2025-10-29": 1,
                "2025-10-30": 2,
                "2025-10-31": 2,
                "2025-11-03": 2,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 2,
                "2025-11-07": 3,
                "2025-11-10": 5,
                "2025-11-13": 5,
                "2025-11-14": 2,
                "2025-11-19": 3,
                "2025-11-20": 1,
                "2025-11-23": 1,
                "2025-11-24": 6,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-08": 1,
                "2025-12-09": 1,
                "2025-12-11": 3,
                "2025-12-12": 4,
                "2025-12-15": 6,
                "2025-12-17": 2,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-26": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-07": 5,
                "2026-01-08": 2,
                "2026-01-09": 1,
                "2026-01-12": 4,
                "2026-01-13": 5,
                "2026-01-14": 1,
                "2026-01-15": 3,
                "2026-01-16": 3,
                "2026-01-18": 1,
                "2026-01-20": 3,
                "2026-01-21": 2,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-01-30": 5,
                "2026-02-02": 4,
                "2026-02-03": 2,
                "2026-02-06": 5,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 5,
                "2026-02-13": 5,
                "2026-02-20": 5,
                "2026-02-28": 2,
                "2026-03-01": 1,
                "2026-03-02": 1,
                "2026-03-04": 7,
                "2026-03-05": 4,
                "2026-03-06": 3,
                "2026-03-07": 1,
                "2026-03-16": 7,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-19": 5,
                "2026-03-21": 3,
                "2026-03-23": 2,
                "2026-03-24": 8,
                "2026-03-25": 4,
                "2026-03-26": 1,
                "2026-03-27": 5,
                "2026-03-28": 1,
                "2026-03-30": 3,
                "2026-03-31": 9,
                "2026-04-02": 7,
                "2026-04-06": 6,
                "2026-04-07": 3,
                "2026-04-09": 12,
                "2026-04-10": 1,
                "2026-04-13": 8,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-16": 8,
                "2026-04-17": 3,
                "2026-04-18": 1,
                "2026-04-20": 10,
                "2026-04-21": 4,
                "2026-04-22": 4,
                "2026-04-23": 7,
                "2026-04-24": 3,
                "2026-04-27": 11,
                "2026-04-28": 3,
                "2026-04-29": 3,
                "2026-04-30": 7,
                "2026-05-02": 3,
                "2026-05-04": 7,
                "2026-05-05": 4,
                "2026-05-06": 5,
                "2026-05-07": 6,
                "2026-05-08": 6,
                "2026-05-09": 1,
                "2026-05-11": 4,
                "2026-05-12": 5,
                "2026-05-13": 9,
                "2026-05-14": 10,
                "2026-05-15": 11,
                "2026-05-18": 11,
                "2026-05-19": 9,
                "2026-05-20": 9,
                "2026-05-21": 5,
                "2026-05-22": 14,
                "2026-05-23": 4,
                "2026-05-25": 8,
                "2026-05-26": 10,
                "2026-05-27": 6,
                "2026-05-28": 1,
                "2026-05-29": 9,
                "2026-06-01": 9,
                "2026-06-02": 13,
                "2026-06-03": 8,
                "2026-06-05": 28,
                "2026-06-06": 1,
                "2026-06-08": 11
              }
            },
            "P3": {
              "avg_time_hours": 275.87,
              "mode_time_hours": 7.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 2,
                "6-8h": 4,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "34-36h": 1,
                "40-42h": 1,
                "44-46h": 1,
                "74-76h": 1,
                "92-94h": 1,
                "114-116h": 2,
                "116-118h": 3,
                "124-126h": 2,
                "140-142h": 1,
                "142-144h": 3,
                "146-148h": 1,
                "152-154h": 2,
                "174-176h": 1,
                "200-202h": 2,
                "260-262h": 1,
                "266-268h": 1,
                "318-320h": 1,
                "334-336h": 1,
                "344-346h": 1,
                "356-358h": 1,
                "416-418h": 1,
                "418-420h": 1,
                "478-480h": 1,
                "512-514h": 1,
                "572-574h": 1,
                "578-580h": 1,
                "678-680h": 1,
                "700-702h": 1,
                "844-846h": 1,
                "846-848h": 1,
                "1198-1200h": 1,
                "1278-1280h": 1,
                "2152-2154h": 1
              },
              "tickets_count": 56,
              "tickets_per_day": {
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-14": 3,
                "2025-10-15": 2,
                "2025-10-24": 1,
                "2025-10-27": 1,
                "2025-10-30": 1,
                "2025-11-06": 7,
                "2025-11-14": 1,
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-11-29": 1,
                "2025-12-02": 12,
                "2025-12-12": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-15": 1,
                "2026-01-23": 1,
                "2026-02-10": 3,
                "2026-02-13": 5,
                "2026-02-18": 2,
                "2026-02-20": 1,
                "2026-04-13": 1,
                "2026-05-06": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-03": 35.62733,
                "2025-10-06": 6.672649722222222,
                "2025-10-07": 143.31702277777777,
                "2025-10-13": 125.40051416666667,
                "2025-10-14": 335.1925175,
                "2025-10-15": 233.65214666666668,
                "2025-10-24": 267.5145438888889,
                "2025-10-27": 416.6074447222222,
                "2025-10-30": 512.1784144444445,
                "2025-11-06": 1543.1800275,
                "2025-11-14": 846.8493272222223,
                "2025-11-21": 356.91744277777775,
                "2025-11-24": 335.3742741666667,
                "2025-11-29": 174.75754111111112,
                "2025-12-02": 2427.1643736111114,
                "2025-12-12": 573.6265625,
                "2025-12-15": 479.2125833333333,
                "2025-12-22": 700.1640958333334,
                "2026-01-15": 21.65919472222222,
                "2026-01-23": 1198.5635597222224,
                "2026-02-10": 736.215918888889,
                "2026-02-13": 529.7473433333333,
                "2026-02-18": 365.4628822222222,
                "2026-02-20": 344.7796316666667,
                "2026-04-13": 7.108693611111111,
                "2026-05-06": 2152.8748991666666,
                "2026-06-06": 578.9116552777778
              },
              "time_count_per_day": {
                "2025-10-03": 1,
                "2025-10-06": 1,
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-14": 3,
                "2025-10-15": 2,
                "2025-10-24": 1,
                "2025-10-27": 1,
                "2025-10-30": 1,
                "2025-11-06": 7,
                "2025-11-14": 1,
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-11-29": 1,
                "2025-12-02": 12,
                "2025-12-12": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-15": 1,
                "2026-01-23": 1,
                "2026-02-10": 3,
                "2026-02-13": 5,
                "2026-02-18": 2,
                "2026-02-20": 1,
                "2026-04-13": 1,
                "2026-05-06": 1,
                "2026-06-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 128.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 24,
              "time_distribution": {
                "0-2h": 24,
                "2-4h": 16,
                "4-6h": 7,
                "6-8h": 9,
                "8-10h": 5,
                "10-12h": 1,
                "12-14h": 2,
                "14-16h": 3,
                "16-18h": 4,
                "18-20h": 17,
                "20-22h": 23,
                "22-24h": 19,
                "24-26h": 10,
                "26-28h": 3,
                "28-30h": 11,
                "30-32h": 12,
                "32-34h": 8,
                "34-36h": 5,
                "36-38h": 4,
                "38-40h": 2,
                "40-42h": 9,
                "42-44h": 3,
                "44-46h": 5,
                "46-48h": 7,
                "48-50h": 4,
                "50-52h": 5,
                "52-54h": 5,
                "54-56h": 2,
                "56-58h": 1,
                "58-60h": 2,
                "60-62h": 1,
                "66-68h": 2,
                "68-70h": 5,
                "70-72h": 6,
                "72-74h": 6,
                "74-76h": 5,
                "76-78h": 5,
                "78-80h": 3,
                "80-82h": 1,
                "82-84h": 1,
                "84-86h": 1,
                "88-90h": 1,
                "90-92h": 1,
                "92-94h": 5,
                "94-96h": 11,
                "96-98h": 5,
                "98-100h": 3,
                "102-104h": 3,
                "104-106h": 2,
                "108-110h": 1,
                "110-112h": 2,
                "112-114h": 3,
                "114-116h": 3,
                "116-118h": 5,
                "118-120h": 3,
                "120-122h": 2,
                "122-124h": 2,
                "124-126h": 1,
                "126-128h": 2,
                "128-130h": 1,
                "136-138h": 1,
                "140-142h": 1,
                "142-144h": 3,
                "144-146h": 4,
                "148-150h": 2,
                "150-152h": 1,
                "158-160h": 4,
                "160-162h": 1,
                "162-164h": 2,
                "164-166h": 3,
                "166-168h": 3,
                "168-170h": 6,
                "172-174h": 2,
                "174-176h": 1,
                "176-178h": 1,
                "178-180h": 4,
                "180-182h": 3,
                "184-186h": 1,
                "186-188h": 2,
                "188-190h": 2,
                "192-194h": 1,
                "194-196h": 2,
                "196-198h": 2,
                "200-202h": 1,
                "208-210h": 1,
                "210-212h": 4,
                "214-216h": 1,
                "216-218h": 3,
                "218-220h": 2,
                "220-222h": 1,
                "222-224h": 2,
                "228-230h": 1,
                "234-236h": 1,
                "246-248h": 1,
                "248-250h": 1,
                "252-254h": 1,
                "256-258h": 2,
                "266-268h": 2,
                "268-270h": 1,
                "278-280h": 3,
                "282-284h": 1,
                "284-286h": 1,
                "286-288h": 2,
                "288-290h": 2,
                "304-306h": 1,
                "308-310h": 1,
                "318-320h": 1,
                "320-322h": 1,
                "324-326h": 1,
                "328-330h": 1,
                "332-334h": 1,
                "334-336h": 4,
                "346-348h": 1,
                "354-356h": 1,
                "358-360h": 2,
                "366-368h": 3,
                "370-372h": 1,
                "372-374h": 1,
                "382-384h": 4,
                "384-386h": 2,
                "388-390h": 1,
                "400-402h": 1,
                "404-406h": 2,
                "416-418h": 1,
                "424-426h": 1,
                "426-428h": 1,
                "428-430h": 1,
                "432-434h": 1,
                "452-454h": 1,
                "454-456h": 4,
                "456-458h": 2,
                "468-470h": 1,
                "470-472h": 1,
                "492-494h": 1,
                "496-498h": 2,
                "500-502h": 2,
                "522-524h": 2,
                "540-542h": 1,
                "574-576h": 1,
                "740-742h": 1,
                "824-826h": 2,
                "2344-2346h": 1,
                "2374-2376h": 1
              },
              "tickets_count": 464,
              "tickets_per_day": {
                "2025-09-30": 2,
                "2025-10-01": 1,
                "2025-10-03": 2,
                "2025-10-06": 1,
                "2025-10-07": 17,
                "2025-10-08": 1,
                "2025-10-09": 9,
                "2025-10-10": 4,
                "2025-10-13": 10,
                "2025-10-14": 10,
                "2025-10-15": 14,
                "2025-10-17": 10,
                "2025-10-20": 3,
                "2025-10-21": 7,
                "2025-10-22": 1,
                "2025-10-23": 12,
                "2025-10-24": 1,
                "2025-10-25": 9,
                "2025-10-27": 14,
                "2025-10-29": 7,
                "2025-10-30": 8,
                "2025-10-31": 4,
                "2025-11-03": 4,
                "2025-11-05": 12,
                "2025-11-06": 3,
                "2025-11-07": 5,
                "2025-11-10": 10,
                "2025-11-11": 5,
                "2025-11-12": 10,
                "2025-11-13": 3,
                "2025-11-14": 13,
                "2025-11-19": 11,
                "2025-11-20": 6,
                "2025-11-21": 16,
                "2025-11-23": 5,
                "2025-11-24": 6,
                "2025-11-25": 6,
                "2025-11-27": 2,
                "2025-11-29": 17,
                "2025-12-02": 15,
                "2025-12-03": 7,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 7,
                "2025-12-11": 5,
                "2025-12-15": 2,
                "2025-12-22": 7,
                "2025-12-23": 1,
                "2025-12-30": 1,
                "2026-01-08": 3,
                "2026-01-13": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-06": 3,
                "2026-02-09": 2,
                "2026-02-10": 2,
                "2026-02-11": 1,
                "2026-02-12": 2,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-02-18": 2,
                "2026-02-19": 3,
                "2026-02-20": 1,
                "2026-02-21": 1,
                "2026-02-23": 5,
                "2026-02-28": 5,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-14": 10,
                "2026-03-17": 6,
                "2026-03-18": 57,
                "2026-03-20": 6,
                "2026-03-24": 5,
                "2026-03-26": 3,
                "2026-04-08": 1,
                "2026-04-22": 3,
                "2026-06-01": 1,
                "2026-06-06": 2
              },
              "time_per_day": {
                "2025-09-30": 3.1395086111111112,
                "2025-10-01": 24.06752388888889,
                "2025-10-03": 77.00389916666666,
                "2025-10-06": 0.2261397222222222,
                "2025-10-07": 832.3994938888889,
                "2025-10-08": 0.5847205555555556,
                "2025-10-09": 682.0850030555555,
                "2025-10-10": 428.2540255555556,
                "2025-10-13": 712.8035683333334,
                "2025-10-14": 668.3453594444445,
                "2025-10-15": 843.8805263888887,
                "2025-10-17": 301.2312430555555,
                "2025-10-20": 384.33581944444444,
                "2025-10-21": 681.3079577777777,
                "2025-10-22": 196.11166222222224,
                "2025-10-23": 251.35690305555553,
                "2025-10-24": 123.77569583333333,
                "2025-10-25": 1069.3675047222223,
                "2025-10-27": 1517.9210363888892,
                "2025-10-29": 403.5342744444444,
                "2025-10-30": 1541.3658930555553,
                "2025-10-31": 66.1465763888889,
                "2025-11-03": 435.316695,
                "2025-11-05": 1545.5010266666666,
                "2025-11-06": 754.1891094444445,
                "2025-11-07": 43.53375666666667,
                "2025-11-10": 1412.4414508333334,
                "2025-11-11": 391.11480416666666,
                "2025-11-12": 617.1057438888889,
                "2025-11-13": 503.0315394444445,
                "2025-11-14": 1564.0369894444445,
                "2025-11-19": 1316.1436361111114,
                "2025-11-20": 397.0982486111111,
                "2025-11-21": 1289.0093688888887,
                "2025-11-23": 197.64496777777777,
                "2025-11-24": 973.6405599999998,
                "2025-11-25": 230.31930416666665,
                "2025-11-27": 89.21703,
                "2025-11-29": 3507.6742427777776,
                "2025-12-02": 1346.2234888888888,
                "2025-12-03": 1271.5407941666665,
                "2025-12-04": 102.87872361111111,
                "2025-12-05": 79.37016055555556,
                "2025-12-09": 90.10985277777777,
                "2025-12-10": 299.8725161111111,
                "2025-12-11": 301.02210999999994,
                "2025-12-15": 212.90035083333333,
                "2025-12-22": 22.14676472222222,
                "2025-12-23": 20.733946666666668,
                "2025-12-30": 5.285001944444445,
                "2026-01-08": 198.33608833333332,
                "2026-01-13": 4.032457222222222,
                "2026-01-27": 2.553830277777778,
                "2026-02-05": 80.9097425,
                "2026-02-06": 313.4274186111111,
                "2026-02-09": 148.15801333333332,
                "2026-02-10": 52.41693611111111,
                "2026-02-11": 214.63250722222222,
                "2026-02-12": 303.4451491666667,
                "2026-02-13": 82.50639083333333,
                "2026-02-17": 142.59776444444444,
                "2026-02-18": 89.1460075,
                "2026-02-19": 148.18540944444447,
                "2026-02-20": 2.2928872222222223,
                "2026-02-21": 52.60538444444444,
                "2026-02-23": 291.54892611111114,
                "2026-02-28": 619.6976461111111,
                "2026-03-06": 1.2834841666666665,
                "2026-03-07": 0.012258888888888889,
                "2026-03-14": 710.8099730555555,
                "2026-03-17": 357.71578750000003,
                "2026-03-18": 19865.871590000002,
                "2026-03-20": 2602.873223888889,
                "2026-03-24": 713.5375602777777,
                "2026-03-26": 1662.9973208333333,
                "2026-04-08": 145.07749555555554,
                "2026-04-22": 419.07821277777776,
                "2026-06-01": 405.89817944444445,
                "2026-06-06": 269.0503225
              },
              "time_count_per_day": {
                "2025-09-30": 2,
                "2025-10-01": 1,
                "2025-10-03": 2,
                "2025-10-06": 1,
                "2025-10-07": 17,
                "2025-10-08": 1,
                "2025-10-09": 9,
                "2025-10-10": 4,
                "2025-10-13": 10,
                "2025-10-14": 10,
                "2025-10-15": 14,
                "2025-10-17": 10,
                "2025-10-20": 3,
                "2025-10-21": 7,
                "2025-10-22": 1,
                "2025-10-23": 12,
                "2025-10-24": 1,
                "2025-10-25": 9,
                "2025-10-27": 14,
                "2025-10-29": 7,
                "2025-10-30": 8,
                "2025-10-31": 4,
                "2025-11-03": 4,
                "2025-11-05": 12,
                "2025-11-06": 3,
                "2025-11-07": 5,
                "2025-11-10": 10,
                "2025-11-11": 5,
                "2025-11-12": 10,
                "2025-11-13": 3,
                "2025-11-14": 13,
                "2025-11-19": 11,
                "2025-11-20": 6,
                "2025-11-21": 16,
                "2025-11-23": 5,
                "2025-11-24": 6,
                "2025-11-25": 6,
                "2025-11-27": 2,
                "2025-11-29": 17,
                "2025-12-02": 15,
                "2025-12-03": 7,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 7,
                "2025-12-11": 5,
                "2025-12-15": 2,
                "2025-12-22": 7,
                "2025-12-23": 1,
                "2025-12-30": 1,
                "2026-01-08": 3,
                "2026-01-13": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-06": 3,
                "2026-02-09": 2,
                "2026-02-10": 2,
                "2026-02-11": 1,
                "2026-02-12": 2,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-02-18": 2,
                "2026-02-19": 3,
                "2026-02-20": 1,
                "2026-02-21": 1,
                "2026-02-23": 5,
                "2026-02-28": 5,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-14": 10,
                "2026-03-17": 6,
                "2026-03-18": 57,
                "2026-03-20": 6,
                "2026-03-24": 5,
                "2026-03-26": 3,
                "2026-04-08": 1,
                "2026-04-22": 3,
                "2026-06-01": 1,
                "2026-06-06": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 493.55,
              "mode_time_hours": 473.0,
              "mode_frequency": 4,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "14-16h": 2,
                "52-54h": 3,
                "72-74h": 3,
                "98-100h": 1,
                "100-102h": 1,
                "110-112h": 1,
                "126-128h": 1,
                "136-138h": 3,
                "142-144h": 1,
                "144-146h": 1,
                "162-164h": 1,
                "164-166h": 1,
                "168-170h": 1,
                "180-182h": 1,
                "184-186h": 1,
                "198-200h": 1,
                "202-204h": 1,
                "204-206h": 2,
                "218-220h": 1,
                "228-230h": 1,
                "230-232h": 1,
                "232-234h": 2,
                "238-240h": 1,
                "294-296h": 1,
                "300-302h": 1,
                "302-304h": 3,
                "318-320h": 1,
                "334-336h": 1,
                "366-368h": 1,
                "378-380h": 1,
                "466-468h": 1,
                "472-474h": 4,
                "482-484h": 1,
                "532-534h": 1,
                "542-544h": 1,
                "544-546h": 1,
                "552-554h": 1,
                "638-640h": 2,
                "650-652h": 1,
                "652-654h": 1,
                "664-666h": 1,
                "710-712h": 1,
                "734-736h": 1,
                "736-738h": 2,
                "808-810h": 1,
                "814-816h": 1,
                "830-832h": 1,
                "888-890h": 1,
                "1150-1152h": 1,
                "1214-1216h": 1,
                "1704-1706h": 1,
                "1916-1918h": 1,
                "1962-1964h": 1,
                "2124-2126h": 1,
                "2132-2134h": 1,
                "2272-2274h": 1
              },
              "tickets_count": 74,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 6,
                "2025-12-04": 3,
                "2025-12-05": 5,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-11": 4,
                "2025-12-12": 3,
                "2025-12-15": 2,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-26": 4,
                "2025-12-29": 2,
                "2026-01-02": 2,
                "2026-01-15": 1,
                "2026-02-18": 4,
                "2026-02-19": 31
              },
              "time_per_day": {
                "2025-12-02": 2.251583888888889,
                "2025-12-03": 509.6243180555555,
                "2025-12-04": 495.03842750000007,
                "2025-12-05": 1162.514437222222,
                "2025-12-09": 136.94434027777777,
                "2025-12-10": 548.0623105555555,
                "2025-12-11": 306.34277944444443,
                "2025-12-12": 699.2380949999999,
                "2025-12-15": 612.38797,
                "2025-12-16": 142.81966555555556,
                "2025-12-17": 165.02886694444445,
                "2025-12-19": 466.32562916666666,
                "2025-12-26": 2992.2209344444445,
                "2025-12-29": 1271.2469722222222,
                "2026-01-02": 1303.1447194444445,
                "2026-01-15": 1150.99891,
                "2026-02-18": 7718.1445425,
                "2026-02-19": 16840.27459388889
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 6,
                "2025-12-04": 3,
                "2025-12-05": 5,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-11": 4,
                "2025-12-12": 3,
                "2025-12-15": 2,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-26": 4,
                "2025-12-29": 2,
                "2026-01-02": 2,
                "2026-01-15": 1,
                "2026-02-18": 4,
                "2026-02-19": 31
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 41,
            "tickets_per_day": {
              "2026-02-20": 2,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-09": 1,
              "2026-03-23": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-28": 3,
              "2026-05-29": 1,
              "2026-06-06": 1,
              "2026-06-08": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 37,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-03-23": 1,
                "2026-03-30": 2,
                "2026-03-31": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-28": 3,
                "2026-05-29": 1,
                "2026-06-06": 1,
                "2026-06-08": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-20": 2,
                "2026-03-02": 1,
                "2026-03-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-11-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-11-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_26": {
      "overall": {
        "avg_time_hours": 164.45,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "2-4h": 3,
          "4-6h": 2,
          "6-8h": 1,
          "20-22h": 1,
          "26-28h": 2,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "54-56h": 1,
          "70-72h": 1,
          "74-76h": 1,
          "88-90h": 1,
          "180-182h": 1,
          "240-242h": 1,
          "318-320h": 1,
          "414-416h": 1,
          "986-988h": 1,
          "1080-1082h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-10-13": 1,
          "2025-10-30": 3,
          "2025-10-31": 1,
          "2025-11-20": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-03-16": 4,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-04-16": 1,
          "2026-04-20": 1
        },
        "time_per_day": {
          "2025-10-01": 26.99164361111111,
          "2025-10-13": 318.43777305555557,
          "2025-10-30": 82.97137333333335,
          "2025-10-31": 20.438085833333332,
          "2025-11-20": 70.25457138888889,
          "2025-11-27": 40.53803277777778,
          "2025-12-04": 43.85436333333334,
          "2025-12-14": 4.729810555555555,
          "2025-12-15": 88.64958277777778,
          "2025-12-17": 55.520449166666666,
          "2026-02-09": 7.370340555555555,
          "2026-02-10": 181.80459166666668,
          "2026-03-16": 686.4690658333334,
          "2026-03-17": 42.73128916666667,
          "2026-03-18": 42.36642027777778,
          "2026-04-16": 987.7958363888889,
          "2026-04-20": 1081.4806902777777
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-10-13": 1,
          "2025-10-30": 3,
          "2025-10-31": 1,
          "2025-11-20": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-03-16": 4,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-04-16": 1,
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 183.29,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 3,
            "6-8h": 1,
            "20-22h": 1,
            "26-28h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "42-44h": 2,
            "54-56h": 1,
            "74-76h": 1,
            "88-90h": 1,
            "180-182h": 1,
            "414-416h": 1,
            "986-988h": 1,
            "1080-1082h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-10-30": 2,
            "2025-10-31": 1,
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-03-16": 3,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-04-16": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2025-10-30": 78.68029166666668,
            "2025-10-31": 20.438085833333332,
            "2025-11-27": 40.53803277777778,
            "2025-12-04": 43.85436333333334,
            "2025-12-15": 88.64958277777778,
            "2025-12-17": 55.520449166666666,
            "2026-02-09": 7.370340555555555,
            "2026-02-10": 181.80459166666668,
            "2026-03-16": 444.76083305555557,
            "2026-03-17": 42.73128916666667,
            "2026-03-18": 42.36642027777778,
            "2026-04-16": 987.7958363888889,
            "2026-04-20": 1081.4806902777777
          },
          "time_count_per_day": {
            "2025-10-30": 2,
            "2025-10-31": 1,
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-03-16": 3,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-04-16": 1,
            "2026-04-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 132.42,
          "mode_time_hours": 319.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "26-28h": 1,
            "70-72h": 1,
            "240-242h": 1,
            "318-320h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-13": 1,
            "2025-11-20": 1,
            "2025-12-14": 1,
            "2026-03-16": 1
          },
          "time_per_day": {
            "2025-10-01": 26.99164361111111,
            "2025-10-13": 318.43777305555557,
            "2025-11-20": 70.25457138888889,
            "2025-12-14": 4.729810555555555,
            "2026-03-16": 241.7082327777778
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-13": 1,
            "2025-11-20": 1,
            "2025-12-14": 1,
            "2026-03-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 4.29,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-30": 1
          },
          "time_per_day": {
            "2025-10-30": 4.291081666666667
          },
          "time_count_per_day": {
            "2025-10-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 164.45,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "2-4h": 3,
              "4-6h": 2,
              "6-8h": 1,
              "20-22h": 1,
              "26-28h": 2,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "54-56h": 1,
              "70-72h": 1,
              "74-76h": 1,
              "88-90h": 1,
              "180-182h": 1,
              "240-242h": 1,
              "318-320h": 1,
              "414-416h": 1,
              "986-988h": 1,
              "1080-1082h": 1
            },
            "tickets_count": 23,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-10-13": 1,
              "2025-10-30": 3,
              "2025-10-31": 1,
              "2025-11-20": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-03-16": 4,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-04-16": 1,
              "2026-04-20": 1
            },
            "time_per_day": {
              "2025-10-01": 26.99164361111111,
              "2025-10-13": 318.43777305555557,
              "2025-10-30": 82.97137333333335,
              "2025-10-31": 20.438085833333332,
              "2025-11-20": 70.25457138888889,
              "2025-11-27": 40.53803277777778,
              "2025-12-04": 43.85436333333334,
              "2025-12-14": 4.729810555555555,
              "2025-12-15": 88.64958277777778,
              "2025-12-17": 55.520449166666666,
              "2026-02-09": 7.370340555555555,
              "2026-02-10": 181.80459166666668,
              "2026-03-16": 686.4690658333334,
              "2026-03-17": 42.73128916666667,
              "2026-03-18": 42.36642027777778,
              "2026-04-16": 987.7958363888889,
              "2026-04-20": 1081.4806902777777
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-10-13": 1,
              "2025-10-30": 3,
              "2025-10-31": 1,
              "2025-11-20": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-03-16": 4,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-04-16": 1,
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 183.29,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 3,
                "6-8h": 1,
                "20-22h": 1,
                "26-28h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "42-44h": 2,
                "54-56h": 1,
                "74-76h": 1,
                "88-90h": 1,
                "180-182h": 1,
                "414-416h": 1,
                "986-988h": 1,
                "1080-1082h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-10-30": 2,
                "2025-10-31": 1,
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-03-16": 3,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-04-16": 1,
                "2026-04-20": 1
              },
              "time_per_day": {
                "2025-10-30": 78.68029166666668,
                "2025-10-31": 20.438085833333332,
                "2025-11-27": 40.53803277777778,
                "2025-12-04": 43.85436333333334,
                "2025-12-15": 88.64958277777778,
                "2025-12-17": 55.520449166666666,
                "2026-02-09": 7.370340555555555,
                "2026-02-10": 181.80459166666668,
                "2026-03-16": 444.76083305555557,
                "2026-03-17": 42.73128916666667,
                "2026-03-18": 42.36642027777778,
                "2026-04-16": 987.7958363888889,
                "2026-04-20": 1081.4806902777777
              },
              "time_count_per_day": {
                "2025-10-30": 2,
                "2025-10-31": 1,
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-03-16": 3,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-04-16": 1,
                "2026-04-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 132.42,
              "mode_time_hours": 319.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "26-28h": 1,
                "70-72h": 1,
                "240-242h": 1,
                "318-320h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-13": 1,
                "2025-11-20": 1,
                "2025-12-14": 1,
                "2026-03-16": 1
              },
              "time_per_day": {
                "2025-10-01": 26.99164361111111,
                "2025-10-13": 318.43777305555557,
                "2025-11-20": 70.25457138888889,
                "2025-12-14": 4.729810555555555,
                "2026-03-16": 241.7082327777778
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-13": 1,
                "2025-11-20": 1,
                "2025-12-14": 1,
                "2026-03-16": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 4.29,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-30": 1
              },
              "time_per_day": {
                "2025-10-30": 4.291081666666667
              },
              "time_count_per_day": {
                "2025-10-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_27": {
      "overall": {
        "avg_time_hours": 214.46,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 4,
          "4-6h": 3,
          "6-8h": 1,
          "8-10h": 3,
          "10-12h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "24-26h": 1,
          "30-32h": 1,
          "34-36h": 1,
          "40-42h": 2,
          "44-46h": 2,
          "48-50h": 1,
          "50-52h": 2,
          "54-56h": 1,
          "112-114h": 1,
          "162-164h": 1,
          "174-176h": 1,
          "192-194h": 1,
          "272-274h": 1,
          "340-342h": 1,
          "406-408h": 1,
          "504-506h": 1,
          "530-532h": 1,
          "548-550h": 1,
          "806-808h": 1,
          "980-982h": 1,
          "1096-1098h": 1,
          "1140-1142h": 1,
          "2212-2214h": 1
        },
        "tickets_count": 50,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-08": 1,
          "2025-10-28": 1,
          "2025-11-20": 1,
          "2025-11-24": 1,
          "2025-11-26": 1,
          "2025-12-12": 1,
          "2026-01-05": 1,
          "2026-01-17": 1,
          "2026-01-23": 2,
          "2026-02-03": 2,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-02-25": 1,
          "2026-03-06": 1,
          "2026-03-17": 1,
          "2026-03-23": 1,
          "2026-03-30": 1,
          "2026-03-31": 2,
          "2026-04-01": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-27": 2,
          "2026-04-29": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-11": 3,
          "2026-05-12": 2,
          "2026-05-28": 2,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-09-30": 1.089161111111111,
          "2025-10-08": 2.6841119444444446,
          "2025-10-28": 193.68003444444443,
          "2025-11-20": 54.3764975,
          "2025-11-24": 17.16838472222222,
          "2025-11-26": 41.95143083333334,
          "2025-12-12": 6.653163055555555,
          "2026-01-05": 51.540099444444444,
          "2026-01-17": 9.027061388888889,
          "2026-01-23": 198.42062444444446,
          "2026-02-03": 1414.1720002777777,
          "2026-02-06": 49.09291527777778,
          "2026-02-09": 8.906834166666666,
          "2026-02-10": 2212.9151497222224,
          "2026-02-13": 531.2195644444445,
          "2026-02-16": 1.6647713888888889,
          "2026-02-18": 9.225034722222222,
          "2026-02-25": 0.028148055555555555,
          "2026-03-06": 504.6639427777778,
          "2026-03-17": 981.4248816666667,
          "2026-03-23": 406.63314722222225,
          "2026-03-30": 4.865214166666667,
          "2026-03-31": 1127.5741161111112,
          "2026-04-01": 174.61734694444445,
          "2026-04-07": 0.6133466666666666,
          "2026-04-08": 90.76678055555556,
          "2026-04-09": 806.9441722222223,
          "2026-04-10": 340.3991302777778,
          "2026-04-11": 14.23579,
          "2026-04-13": 25.963821944444447,
          "2026-04-27": 2.631733888888889,
          "2026-04-29": 548.6097238888889,
          "2026-05-04": 5.31373138888889,
          "2026-05-05": 112.94777027777778,
          "2026-05-11": 95.00600027777777,
          "2026-05-12": 8.60936361111111,
          "2026-05-28": 23.765047222222222
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-08": 1,
          "2025-10-28": 1,
          "2025-11-20": 1,
          "2025-11-24": 1,
          "2025-11-26": 1,
          "2025-12-12": 1,
          "2026-01-05": 1,
          "2026-01-17": 1,
          "2026-01-23": 2,
          "2026-02-03": 2,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-02-25": 1,
          "2026-03-06": 1,
          "2026-03-17": 1,
          "2026-03-23": 1,
          "2026-03-30": 1,
          "2026-03-31": 2,
          "2026-04-01": 1,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-27": 2,
          "2026-04-29": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-11": 3,
          "2026-05-12": 2,
          "2026-05-28": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.09,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-09-30": 1
          },
          "time_per_day": {
            "2025-09-30": 1.089161111111111
          },
          "time_count_per_day": {
            "2025-09-30": 1
          }
        },
        "P2": {
          "avg_time_hours": 139.4,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 3,
            "4-6h": 3,
            "8-10h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "14-16h": 1,
            "24-26h": 1,
            "40-42h": 2,
            "44-46h": 2,
            "50-52h": 2,
            "54-56h": 1,
            "112-114h": 1,
            "162-164h": 1,
            "340-342h": 1,
            "406-408h": 1,
            "530-532h": 1,
            "548-550h": 1,
            "806-808h": 1,
            "980-982h": 1
          },
          "tickets_count": 34,
          "tickets_per_day": {
            "2025-11-20": 1,
            "2025-11-26": 1,
            "2026-01-05": 1,
            "2026-01-23": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-02-25": 1,
            "2026-03-17": 1,
            "2026-03-23": 1,
            "2026-03-30": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 1,
            "2026-04-27": 2,
            "2026-04-29": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-11": 3,
            "2026-05-12": 2,
            "2026-05-28": 2,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-11-20": 54.3764975,
            "2025-11-26": 41.95143083333334,
            "2026-01-05": 51.540099444444444,
            "2026-01-23": 162.81026833333334,
            "2026-02-13": 531.2195644444445,
            "2026-02-16": 1.6647713888888889,
            "2026-02-18": 9.225034722222222,
            "2026-02-25": 0.028148055555555555,
            "2026-03-17": 981.4248816666667,
            "2026-03-23": 406.63314722222225,
            "2026-03-30": 4.865214166666667,
            "2026-04-07": 0.6133466666666666,
            "2026-04-08": 90.76678055555556,
            "2026-04-09": 806.9441722222223,
            "2026-04-10": 340.3991302777778,
            "2026-04-11": 14.23579,
            "2026-04-13": 25.963821944444447,
            "2026-04-27": 2.631733888888889,
            "2026-04-29": 548.6097238888889,
            "2026-05-04": 5.31373138888889,
            "2026-05-05": 112.94777027777778,
            "2026-05-11": 95.00600027777777,
            "2026-05-12": 8.60936361111111,
            "2026-05-28": 23.765047222222222
          },
          "time_count_per_day": {
            "2025-11-20": 1,
            "2025-11-26": 1,
            "2026-01-05": 1,
            "2026-01-23": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-02-25": 1,
            "2026-03-17": 1,
            "2026-03-23": 1,
            "2026-03-30": 1,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 1,
            "2026-04-27": 2,
            "2026-04-29": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-11": 3,
            "2026-05-12": 2,
            "2026-05-28": 2
          }
        },
        "P3": {
          "avg_time_hours": 397.36,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1,
            "8-10h": 2,
            "16-18h": 1,
            "30-32h": 1,
            "34-36h": 1,
            "48-50h": 1,
            "174-176h": 1,
            "272-274h": 1,
            "504-506h": 1,
            "1096-1098h": 1,
            "1140-1142h": 1,
            "2212-2214h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-11-24": 1,
            "2025-12-12": 1,
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-03-06": 1,
            "2026-03-31": 2,
            "2026-04-01": 1
          },
          "time_per_day": {
            "2025-10-08": 2.6841119444444446,
            "2025-11-24": 17.16838472222222,
            "2025-12-12": 6.653163055555555,
            "2026-01-17": 9.027061388888889,
            "2026-01-23": 35.610356111111116,
            "2026-02-03": 1414.1720002777777,
            "2026-02-06": 49.09291527777778,
            "2026-02-09": 8.906834166666666,
            "2026-02-10": 2212.9151497222224,
            "2026-03-06": 504.6639427777778,
            "2026-03-31": 1127.5741161111112,
            "2026-04-01": 174.61734694444445
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-11-24": 1,
            "2025-12-12": 1,
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-03-06": 1,
            "2026-03-31": 2,
            "2026-04-01": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 193.68,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "192-194h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 193.68003444444443
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 214.46,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 4,
              "4-6h": 3,
              "6-8h": 1,
              "8-10h": 3,
              "10-12h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "24-26h": 1,
              "30-32h": 1,
              "34-36h": 1,
              "40-42h": 2,
              "44-46h": 2,
              "48-50h": 1,
              "50-52h": 2,
              "54-56h": 1,
              "112-114h": 1,
              "162-164h": 1,
              "174-176h": 1,
              "192-194h": 1,
              "272-274h": 1,
              "340-342h": 1,
              "406-408h": 1,
              "504-506h": 1,
              "530-532h": 1,
              "548-550h": 1,
              "806-808h": 1,
              "980-982h": 1,
              "1096-1098h": 1,
              "1140-1142h": 1,
              "2212-2214h": 1
            },
            "tickets_count": 47,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-08": 1,
              "2025-10-28": 1,
              "2025-11-20": 1,
              "2025-11-24": 1,
              "2025-11-26": 1,
              "2025-12-12": 1,
              "2026-01-05": 1,
              "2026-01-17": 1,
              "2026-01-23": 2,
              "2026-02-03": 2,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-02-25": 1,
              "2026-03-06": 1,
              "2026-03-17": 1,
              "2026-03-23": 1,
              "2026-03-30": 1,
              "2026-03-31": 2,
              "2026-04-01": 1,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-27": 2,
              "2026-04-29": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-11": 3,
              "2026-05-12": 2,
              "2026-05-28": 2
            },
            "time_per_day": {
              "2025-09-30": 1.089161111111111,
              "2025-10-08": 2.6841119444444446,
              "2025-10-28": 193.68003444444443,
              "2025-11-20": 54.3764975,
              "2025-11-24": 17.16838472222222,
              "2025-11-26": 41.95143083333334,
              "2025-12-12": 6.653163055555555,
              "2026-01-05": 51.540099444444444,
              "2026-01-17": 9.027061388888889,
              "2026-01-23": 198.42062444444446,
              "2026-02-03": 1414.1720002777777,
              "2026-02-06": 49.09291527777778,
              "2026-02-09": 8.906834166666666,
              "2026-02-10": 2212.9151497222224,
              "2026-02-13": 531.2195644444445,
              "2026-02-16": 1.6647713888888889,
              "2026-02-18": 9.225034722222222,
              "2026-02-25": 0.028148055555555555,
              "2026-03-06": 504.6639427777778,
              "2026-03-17": 981.4248816666667,
              "2026-03-23": 406.63314722222225,
              "2026-03-30": 4.865214166666667,
              "2026-03-31": 1127.5741161111112,
              "2026-04-01": 174.61734694444445,
              "2026-04-07": 0.6133466666666666,
              "2026-04-08": 90.76678055555556,
              "2026-04-09": 806.9441722222223,
              "2026-04-10": 340.3991302777778,
              "2026-04-11": 14.23579,
              "2026-04-13": 25.963821944444447,
              "2026-04-27": 2.631733888888889,
              "2026-04-29": 548.6097238888889,
              "2026-05-04": 5.31373138888889,
              "2026-05-05": 112.94777027777778,
              "2026-05-11": 95.00600027777777,
              "2026-05-12": 8.60936361111111,
              "2026-05-28": 23.765047222222222
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-08": 1,
              "2025-10-28": 1,
              "2025-11-20": 1,
              "2025-11-24": 1,
              "2025-11-26": 1,
              "2025-12-12": 1,
              "2026-01-05": 1,
              "2026-01-17": 1,
              "2026-01-23": 2,
              "2026-02-03": 2,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-02-25": 1,
              "2026-03-06": 1,
              "2026-03-17": 1,
              "2026-03-23": 1,
              "2026-03-30": 1,
              "2026-03-31": 2,
              "2026-04-01": 1,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-27": 2,
              "2026-04-29": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-11": 3,
              "2026-05-12": 2,
              "2026-05-28": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.09,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-09-30": 1
              },
              "time_per_day": {
                "2025-09-30": 1.089161111111111
              },
              "time_count_per_day": {
                "2025-09-30": 1
              }
            },
            "P2": {
              "avg_time_hours": 139.4,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 3,
                "4-6h": 3,
                "8-10h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "14-16h": 1,
                "24-26h": 1,
                "40-42h": 2,
                "44-46h": 2,
                "50-52h": 2,
                "54-56h": 1,
                "112-114h": 1,
                "162-164h": 1,
                "340-342h": 1,
                "406-408h": 1,
                "530-532h": 1,
                "548-550h": 1,
                "806-808h": 1,
                "980-982h": 1
              },
              "tickets_count": 31,
              "tickets_per_day": {
                "2025-11-20": 1,
                "2025-11-26": 1,
                "2026-01-05": 1,
                "2026-01-23": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-02-25": 1,
                "2026-03-17": 1,
                "2026-03-23": 1,
                "2026-03-30": 1,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 1,
                "2026-04-27": 2,
                "2026-04-29": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-11": 3,
                "2026-05-12": 2,
                "2026-05-28": 2
              },
              "time_per_day": {
                "2025-11-20": 54.3764975,
                "2025-11-26": 41.95143083333334,
                "2026-01-05": 51.540099444444444,
                "2026-01-23": 162.81026833333334,
                "2026-02-13": 531.2195644444445,
                "2026-02-16": 1.6647713888888889,
                "2026-02-18": 9.225034722222222,
                "2026-02-25": 0.028148055555555555,
                "2026-03-17": 981.4248816666667,
                "2026-03-23": 406.63314722222225,
                "2026-03-30": 4.865214166666667,
                "2026-04-07": 0.6133466666666666,
                "2026-04-08": 90.76678055555556,
                "2026-04-09": 806.9441722222223,
                "2026-04-10": 340.3991302777778,
                "2026-04-11": 14.23579,
                "2026-04-13": 25.963821944444447,
                "2026-04-27": 2.631733888888889,
                "2026-04-29": 548.6097238888889,
                "2026-05-04": 5.31373138888889,
                "2026-05-05": 112.94777027777778,
                "2026-05-11": 95.00600027777777,
                "2026-05-12": 8.60936361111111,
                "2026-05-28": 23.765047222222222
              },
              "time_count_per_day": {
                "2025-11-20": 1,
                "2025-11-26": 1,
                "2026-01-05": 1,
                "2026-01-23": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-02-25": 1,
                "2026-03-17": 1,
                "2026-03-23": 1,
                "2026-03-30": 1,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 1,
                "2026-04-27": 2,
                "2026-04-29": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-11": 3,
                "2026-05-12": 2,
                "2026-05-28": 2
              }
            },
            "P3": {
              "avg_time_hours": 397.36,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1,
                "8-10h": 2,
                "16-18h": 1,
                "30-32h": 1,
                "34-36h": 1,
                "48-50h": 1,
                "174-176h": 1,
                "272-274h": 1,
                "504-506h": 1,
                "1096-1098h": 1,
                "1140-1142h": 1,
                "2212-2214h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-11-24": 1,
                "2025-12-12": 1,
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-03-06": 1,
                "2026-03-31": 2,
                "2026-04-01": 1
              },
              "time_per_day": {
                "2025-10-08": 2.6841119444444446,
                "2025-11-24": 17.16838472222222,
                "2025-12-12": 6.653163055555555,
                "2026-01-17": 9.027061388888889,
                "2026-01-23": 35.610356111111116,
                "2026-02-03": 1414.1720002777777,
                "2026-02-06": 49.09291527777778,
                "2026-02-09": 8.906834166666666,
                "2026-02-10": 2212.9151497222224,
                "2026-03-06": 504.6639427777778,
                "2026-03-31": 1127.5741161111112,
                "2026-04-01": 174.61734694444445
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-11-24": 1,
                "2025-12-12": 1,
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-03-06": 1,
                "2026-03-31": 2,
                "2026-04-01": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 193.68,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "192-194h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 193.68003444444443
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-06": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-06": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_28": {
      "overall": {
        "avg_time_hours": 19.19,
        "mode_time_hours": 1.0,
        "mode_frequency": 94,
        "time_distribution": {
          "0-2h": 94,
          "2-4h": 11,
          "4-6h": 7,
          "6-8h": 4,
          "8-10h": 12,
          "12-14h": 3,
          "16-18h": 6,
          "18-20h": 8,
          "24-26h": 2,
          "30-32h": 1,
          "38-40h": 3,
          "126-128h": 1,
          "148-150h": 1,
          "180-182h": 2,
          "266-268h": 3,
          "886-888h": 1
        },
        "tickets_count": 159,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-24": 1,
          "2025-11-17": 2,
          "2025-11-24": 1,
          "2025-11-29": 1,
          "2025-12-02": 3,
          "2025-12-22": 2,
          "2026-01-07": 2,
          "2026-01-08": 1,
          "2026-01-15": 17,
          "2026-01-16": 3,
          "2026-01-23": 3,
          "2026-01-26": 5,
          "2026-02-02": 1,
          "2026-02-06": 1,
          "2026-02-13": 6,
          "2026-02-19": 1,
          "2026-03-01": 6,
          "2026-03-17": 3,
          "2026-03-18": 1,
          "2026-03-26": 1,
          "2026-03-28": 2,
          "2026-04-06": 6,
          "2026-04-13": 5,
          "2026-04-20": 11,
          "2026-04-23": 1,
          "2026-04-24": 3,
          "2026-04-27": 6,
          "2026-04-29": 3,
          "2026-05-04": 1,
          "2026-05-06": 3,
          "2026-05-07": 1,
          "2026-05-08": 2,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-18": 21,
          "2026-05-22": 1,
          "2026-05-23": 1,
          "2026-05-25": 6,
          "2026-05-26": 4,
          "2026-05-27": 3,
          "2026-05-29": 2,
          "2026-05-30": 8,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-09-30": 5.250860555555556,
          "2025-10-24": 0.04939444444444444,
          "2025-11-17": 0.10390694444444445,
          "2025-11-24": 180.6593836111111,
          "2025-11-29": 3.0347605555555557,
          "2025-12-02": 179.6057313888889,
          "2025-12-22": 2.112131111111111,
          "2026-01-07": 38.19050083333333,
          "2026-01-08": 0.9928575,
          "2026-01-15": 907.3783191666666,
          "2026-01-16": 3.124043888888889,
          "2026-01-23": 1016.9097677777778,
          "2026-01-26": 28.658293055555554,
          "2026-02-02": 0.06979722222222222,
          "2026-02-06": 0.007018333333333333,
          "2026-02-13": 112.58855861111113,
          "2026-02-19": 0.13686722222222222,
          "2026-03-01": 100.4451263888889,
          "2026-03-17": 53.597965,
          "2026-03-18": 181.0355947222222,
          "2026-03-26": 1.4845505555555554,
          "2026-03-28": 1.0038200000000002,
          "2026-04-06": 29.041932777777777,
          "2026-04-13": 119.70086972222222,
          "2026-04-20": 6.232804444444445,
          "2026-04-23": 0.4075152777777778,
          "2026-04-24": 6.070608333333333,
          "2026-04-27": 3.498041666666667,
          "2026-04-29": 3.218256111111111,
          "2026-05-04": 0.15995055555555557,
          "2026-05-06": 1.4144372222222221,
          "2026-05-07": 1.2706941666666667,
          "2026-05-08": 1.0573605555555554,
          "2026-05-11": 1.0991177777777779,
          "2026-05-12": 0.4835702777777778,
          "2026-05-14": 0.13277805555555555,
          "2026-05-15": 0.09129777777777778,
          "2026-05-18": 5.909018333333334,
          "2026-05-22": 0.0190525,
          "2026-05-23": 0.10059694444444445,
          "2026-05-25": 1.9377691666666665,
          "2026-05-26": 40.67117722222222,
          "2026-05-27": 3.848129444444444,
          "2026-05-29": 7.060016388888888,
          "2026-05-30": 0.14603083333333333,
          "2026-06-05": 1.2536969444444446,
          "2026-06-08": 0.31698472222222224
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-24": 1,
          "2025-11-17": 2,
          "2025-11-24": 1,
          "2025-11-29": 1,
          "2025-12-02": 3,
          "2025-12-22": 2,
          "2026-01-07": 2,
          "2026-01-08": 1,
          "2026-01-15": 17,
          "2026-01-16": 3,
          "2026-01-23": 3,
          "2026-01-26": 5,
          "2026-02-02": 1,
          "2026-02-06": 1,
          "2026-02-13": 6,
          "2026-02-19": 1,
          "2026-03-01": 6,
          "2026-03-17": 3,
          "2026-03-18": 1,
          "2026-03-26": 1,
          "2026-03-28": 2,
          "2026-04-06": 6,
          "2026-04-13": 5,
          "2026-04-20": 11,
          "2026-04-23": 1,
          "2026-04-24": 3,
          "2026-04-27": 6,
          "2026-04-29": 3,
          "2026-05-04": 1,
          "2026-05-06": 3,
          "2026-05-07": 1,
          "2026-05-08": 2,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-18": 21,
          "2026-05-22": 1,
          "2026-05-23": 1,
          "2026-05-25": 6,
          "2026-05-26": 4,
          "2026-05-27": 3,
          "2026-05-29": 2,
          "2026-05-30": 8,
          "2026-06-05": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 91,
          "time_distribution": {
            "0-2h": 91,
            "2-4h": 11,
            "4-6h": 6,
            "6-8h": 4,
            "12-14h": 3,
            "16-18h": 6,
            "18-20h": 2,
            "38-40h": 3,
            "180-182h": 1
          },
          "tickets_count": 127,
          "tickets_per_day": {
            "2025-10-24": 1,
            "2025-11-17": 2,
            "2025-11-24": 1,
            "2025-11-29": 1,
            "2025-12-02": 1,
            "2025-12-22": 2,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-15": 2,
            "2026-01-23": 1,
            "2026-01-26": 5,
            "2026-02-02": 1,
            "2026-02-06": 1,
            "2026-02-19": 1,
            "2026-03-01": 6,
            "2026-03-17": 1,
            "2026-03-26": 1,
            "2026-03-28": 2,
            "2026-04-06": 6,
            "2026-04-13": 5,
            "2026-04-20": 11,
            "2026-04-23": 1,
            "2026-04-24": 3,
            "2026-04-27": 6,
            "2026-04-29": 3,
            "2026-05-04": 1,
            "2026-05-06": 3,
            "2026-05-07": 1,
            "2026-05-08": 2,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 21,
            "2026-05-22": 1,
            "2026-05-23": 1,
            "2026-05-25": 6,
            "2026-05-26": 4,
            "2026-05-27": 3,
            "2026-05-29": 2,
            "2026-05-30": 8,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-24": 0.04939444444444444,
            "2025-11-17": 0.10390694444444445,
            "2025-11-24": 180.6593836111111,
            "2025-11-29": 3.0347605555555557,
            "2025-12-02": 0.39815666666666666,
            "2025-12-22": 2.112131111111111,
            "2026-01-07": 38.19050083333333,
            "2026-01-08": 0.9928575,
            "2026-01-15": 3.2231466666666666,
            "2026-01-23": 3.211641388888889,
            "2026-01-26": 28.658293055555554,
            "2026-02-02": 0.06979722222222222,
            "2026-02-06": 0.007018333333333333,
            "2026-02-19": 0.13686722222222222,
            "2026-03-01": 100.4451263888889,
            "2026-03-17": 2.165168888888889,
            "2026-03-26": 1.4845505555555554,
            "2026-03-28": 1.0038200000000002,
            "2026-04-06": 29.041932777777777,
            "2026-04-13": 119.70086972222222,
            "2026-04-20": 6.232804444444445,
            "2026-04-23": 0.4075152777777778,
            "2026-04-24": 6.070608333333333,
            "2026-04-27": 3.498041666666667,
            "2026-04-29": 3.218256111111111,
            "2026-05-04": 0.15995055555555557,
            "2026-05-06": 1.4144372222222221,
            "2026-05-07": 1.2706941666666667,
            "2026-05-08": 1.0573605555555554,
            "2026-05-11": 1.0991177777777779,
            "2026-05-12": 0.4835702777777778,
            "2026-05-14": 0.13277805555555555,
            "2026-05-15": 0.09129777777777778,
            "2026-05-18": 5.909018333333334,
            "2026-05-22": 0.0190525,
            "2026-05-23": 0.10059694444444445,
            "2026-05-25": 1.9377691666666665,
            "2026-05-26": 40.67117722222222,
            "2026-05-27": 3.848129444444444,
            "2026-05-29": 7.060016388888888,
            "2026-05-30": 0.14603083333333333,
            "2026-06-05": 1.2536969444444446,
            "2026-06-08": 0.31698472222222224
          },
          "time_count_per_day": {
            "2025-10-24": 1,
            "2025-11-17": 2,
            "2025-11-24": 1,
            "2025-11-29": 1,
            "2025-12-02": 1,
            "2025-12-22": 2,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-15": 2,
            "2026-01-23": 1,
            "2026-01-26": 5,
            "2026-02-02": 1,
            "2026-02-06": 1,
            "2026-02-19": 1,
            "2026-03-01": 6,
            "2026-03-17": 1,
            "2026-03-26": 1,
            "2026-03-28": 2,
            "2026-04-06": 6,
            "2026-04-13": 5,
            "2026-04-20": 11,
            "2026-04-23": 1,
            "2026-04-24": 3,
            "2026-04-27": 6,
            "2026-04-29": 3,
            "2026-05-04": 1,
            "2026-05-06": 3,
            "2026-05-07": 1,
            "2026-05-08": 2,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 21,
            "2026-05-22": 1,
            "2026-05-23": 1,
            "2026-05-25": 6,
            "2026-05-26": 4,
            "2026-05-27": 3,
            "2026-05-29": 2,
            "2026-05-30": 8,
            "2026-06-05": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 51.62,
          "mode_time_hours": 9.0,
          "mode_frequency": 12,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 1,
            "8-10h": 12,
            "18-20h": 6,
            "30-32h": 1,
            "148-150h": 1,
            "886-888h": 1
          },
          "tickets_count": 25,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-12-02": 2,
            "2026-01-15": 12,
            "2026-01-16": 3,
            "2026-01-23": 1,
            "2026-02-13": 6
          },
          "time_per_day": {
            "2025-09-30": 5.250860555555556,
            "2025-12-02": 179.20757472222223,
            "2026-01-15": 104.01750000000001,
            "2026-01-16": 3.124043888888889,
            "2026-01-23": 886.4293977777778,
            "2026-02-13": 112.58855861111113
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-12-02": 2,
            "2026-01-15": 12,
            "2026-01-16": 3,
            "2026-01-23": 1,
            "2026-02-13": 6
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 165.7,
          "mode_time_hours": 267.0,
          "mode_frequency": 3,
          "time_distribution": {
            "24-26h": 2,
            "126-128h": 1,
            "180-182h": 1,
            "266-268h": 3
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-01-15": 3,
            "2026-01-23": 1,
            "2026-03-17": 2,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-01-15": 800.1376725,
            "2026-01-23": 127.26872861111111,
            "2026-03-17": 51.43279611111112,
            "2026-03-18": 181.0355947222222
          },
          "time_count_per_day": {
            "2026-01-15": 3,
            "2026-01-23": 1,
            "2026-03-17": 2,
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.19,
            "mode_time_hours": 1.0,
            "mode_frequency": 94,
            "time_distribution": {
              "0-2h": 94,
              "2-4h": 11,
              "4-6h": 7,
              "6-8h": 4,
              "8-10h": 12,
              "12-14h": 3,
              "16-18h": 6,
              "18-20h": 8,
              "24-26h": 2,
              "30-32h": 1,
              "38-40h": 3,
              "126-128h": 1,
              "148-150h": 1,
              "180-182h": 2,
              "266-268h": 3,
              "886-888h": 1
            },
            "tickets_count": 159,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-24": 1,
              "2025-11-17": 2,
              "2025-11-24": 1,
              "2025-11-29": 1,
              "2025-12-02": 3,
              "2025-12-22": 2,
              "2026-01-07": 2,
              "2026-01-08": 1,
              "2026-01-15": 17,
              "2026-01-16": 3,
              "2026-01-23": 3,
              "2026-01-26": 5,
              "2026-02-02": 1,
              "2026-02-06": 1,
              "2026-02-13": 6,
              "2026-02-19": 1,
              "2026-03-01": 6,
              "2026-03-17": 3,
              "2026-03-18": 1,
              "2026-03-26": 1,
              "2026-03-28": 2,
              "2026-04-06": 6,
              "2026-04-13": 5,
              "2026-04-20": 11,
              "2026-04-23": 1,
              "2026-04-24": 3,
              "2026-04-27": 6,
              "2026-04-29": 3,
              "2026-05-04": 1,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-08": 2,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-18": 21,
              "2026-05-22": 1,
              "2026-05-23": 1,
              "2026-05-25": 6,
              "2026-05-26": 4,
              "2026-05-27": 3,
              "2026-05-29": 2,
              "2026-05-30": 8,
              "2026-06-05": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-09-30": 5.250860555555556,
              "2025-10-24": 0.04939444444444444,
              "2025-11-17": 0.10390694444444445,
              "2025-11-24": 180.6593836111111,
              "2025-11-29": 3.0347605555555557,
              "2025-12-02": 179.6057313888889,
              "2025-12-22": 2.112131111111111,
              "2026-01-07": 38.19050083333333,
              "2026-01-08": 0.9928575,
              "2026-01-15": 907.3783191666666,
              "2026-01-16": 3.124043888888889,
              "2026-01-23": 1016.9097677777778,
              "2026-01-26": 28.658293055555554,
              "2026-02-02": 0.06979722222222222,
              "2026-02-06": 0.007018333333333333,
              "2026-02-13": 112.58855861111113,
              "2026-02-19": 0.13686722222222222,
              "2026-03-01": 100.4451263888889,
              "2026-03-17": 53.597965,
              "2026-03-18": 181.0355947222222,
              "2026-03-26": 1.4845505555555554,
              "2026-03-28": 1.0038200000000002,
              "2026-04-06": 29.041932777777777,
              "2026-04-13": 119.70086972222222,
              "2026-04-20": 6.232804444444445,
              "2026-04-23": 0.4075152777777778,
              "2026-04-24": 6.070608333333333,
              "2026-04-27": 3.498041666666667,
              "2026-04-29": 3.218256111111111,
              "2026-05-04": 0.15995055555555557,
              "2026-05-06": 1.4144372222222221,
              "2026-05-07": 1.2706941666666667,
              "2026-05-08": 1.0573605555555554,
              "2026-05-11": 1.0991177777777779,
              "2026-05-12": 0.4835702777777778,
              "2026-05-14": 0.13277805555555555,
              "2026-05-15": 0.09129777777777778,
              "2026-05-18": 5.909018333333334,
              "2026-05-22": 0.0190525,
              "2026-05-23": 0.10059694444444445,
              "2026-05-25": 1.9377691666666665,
              "2026-05-26": 40.67117722222222,
              "2026-05-27": 3.848129444444444,
              "2026-05-29": 7.060016388888888,
              "2026-05-30": 0.14603083333333333,
              "2026-06-05": 1.2536969444444446,
              "2026-06-08": 0.31698472222222224
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-24": 1,
              "2025-11-17": 2,
              "2025-11-24": 1,
              "2025-11-29": 1,
              "2025-12-02": 3,
              "2025-12-22": 2,
              "2026-01-07": 2,
              "2026-01-08": 1,
              "2026-01-15": 17,
              "2026-01-16": 3,
              "2026-01-23": 3,
              "2026-01-26": 5,
              "2026-02-02": 1,
              "2026-02-06": 1,
              "2026-02-13": 6,
              "2026-02-19": 1,
              "2026-03-01": 6,
              "2026-03-17": 3,
              "2026-03-18": 1,
              "2026-03-26": 1,
              "2026-03-28": 2,
              "2026-04-06": 6,
              "2026-04-13": 5,
              "2026-04-20": 11,
              "2026-04-23": 1,
              "2026-04-24": 3,
              "2026-04-27": 6,
              "2026-04-29": 3,
              "2026-05-04": 1,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-08": 2,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-18": 21,
              "2026-05-22": 1,
              "2026-05-23": 1,
              "2026-05-25": 6,
              "2026-05-26": 4,
              "2026-05-27": 3,
              "2026-05-29": 2,
              "2026-05-30": 8,
              "2026-06-05": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 91,
              "time_distribution": {
                "0-2h": 91,
                "2-4h": 11,
                "4-6h": 6,
                "6-8h": 4,
                "12-14h": 3,
                "16-18h": 6,
                "18-20h": 2,
                "38-40h": 3,
                "180-182h": 1
              },
              "tickets_count": 127,
              "tickets_per_day": {
                "2025-10-24": 1,
                "2025-11-17": 2,
                "2025-11-24": 1,
                "2025-11-29": 1,
                "2025-12-02": 1,
                "2025-12-22": 2,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-15": 2,
                "2026-01-23": 1,
                "2026-01-26": 5,
                "2026-02-02": 1,
                "2026-02-06": 1,
                "2026-02-19": 1,
                "2026-03-01": 6,
                "2026-03-17": 1,
                "2026-03-26": 1,
                "2026-03-28": 2,
                "2026-04-06": 6,
                "2026-04-13": 5,
                "2026-04-20": 11,
                "2026-04-23": 1,
                "2026-04-24": 3,
                "2026-04-27": 6,
                "2026-04-29": 3,
                "2026-05-04": 1,
                "2026-05-06": 3,
                "2026-05-07": 1,
                "2026-05-08": 2,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 21,
                "2026-05-22": 1,
                "2026-05-23": 1,
                "2026-05-25": 6,
                "2026-05-26": 4,
                "2026-05-27": 3,
                "2026-05-29": 2,
                "2026-05-30": 8,
                "2026-06-05": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-24": 0.04939444444444444,
                "2025-11-17": 0.10390694444444445,
                "2025-11-24": 180.6593836111111,
                "2025-11-29": 3.0347605555555557,
                "2025-12-02": 0.39815666666666666,
                "2025-12-22": 2.112131111111111,
                "2026-01-07": 38.19050083333333,
                "2026-01-08": 0.9928575,
                "2026-01-15": 3.2231466666666666,
                "2026-01-23": 3.211641388888889,
                "2026-01-26": 28.658293055555554,
                "2026-02-02": 0.06979722222222222,
                "2026-02-06": 0.007018333333333333,
                "2026-02-19": 0.13686722222222222,
                "2026-03-01": 100.4451263888889,
                "2026-03-17": 2.165168888888889,
                "2026-03-26": 1.4845505555555554,
                "2026-03-28": 1.0038200000000002,
                "2026-04-06": 29.041932777777777,
                "2026-04-13": 119.70086972222222,
                "2026-04-20": 6.232804444444445,
                "2026-04-23": 0.4075152777777778,
                "2026-04-24": 6.070608333333333,
                "2026-04-27": 3.498041666666667,
                "2026-04-29": 3.218256111111111,
                "2026-05-04": 0.15995055555555557,
                "2026-05-06": 1.4144372222222221,
                "2026-05-07": 1.2706941666666667,
                "2026-05-08": 1.0573605555555554,
                "2026-05-11": 1.0991177777777779,
                "2026-05-12": 0.4835702777777778,
                "2026-05-14": 0.13277805555555555,
                "2026-05-15": 0.09129777777777778,
                "2026-05-18": 5.909018333333334,
                "2026-05-22": 0.0190525,
                "2026-05-23": 0.10059694444444445,
                "2026-05-25": 1.9377691666666665,
                "2026-05-26": 40.67117722222222,
                "2026-05-27": 3.848129444444444,
                "2026-05-29": 7.060016388888888,
                "2026-05-30": 0.14603083333333333,
                "2026-06-05": 1.2536969444444446,
                "2026-06-08": 0.31698472222222224
              },
              "time_count_per_day": {
                "2025-10-24": 1,
                "2025-11-17": 2,
                "2025-11-24": 1,
                "2025-11-29": 1,
                "2025-12-02": 1,
                "2025-12-22": 2,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-15": 2,
                "2026-01-23": 1,
                "2026-01-26": 5,
                "2026-02-02": 1,
                "2026-02-06": 1,
                "2026-02-19": 1,
                "2026-03-01": 6,
                "2026-03-17": 1,
                "2026-03-26": 1,
                "2026-03-28": 2,
                "2026-04-06": 6,
                "2026-04-13": 5,
                "2026-04-20": 11,
                "2026-04-23": 1,
                "2026-04-24": 3,
                "2026-04-27": 6,
                "2026-04-29": 3,
                "2026-05-04": 1,
                "2026-05-06": 3,
                "2026-05-07": 1,
                "2026-05-08": 2,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 21,
                "2026-05-22": 1,
                "2026-05-23": 1,
                "2026-05-25": 6,
                "2026-05-26": 4,
                "2026-05-27": 3,
                "2026-05-29": 2,
                "2026-05-30": 8,
                "2026-06-05": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 51.62,
              "mode_time_hours": 9.0,
              "mode_frequency": 12,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 1,
                "8-10h": 12,
                "18-20h": 6,
                "30-32h": 1,
                "148-150h": 1,
                "886-888h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-12-02": 2,
                "2026-01-15": 12,
                "2026-01-16": 3,
                "2026-01-23": 1,
                "2026-02-13": 6
              },
              "time_per_day": {
                "2025-09-30": 5.250860555555556,
                "2025-12-02": 179.20757472222223,
                "2026-01-15": 104.01750000000001,
                "2026-01-16": 3.124043888888889,
                "2026-01-23": 886.4293977777778,
                "2026-02-13": 112.58855861111113
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-12-02": 2,
                "2026-01-15": 12,
                "2026-01-16": 3,
                "2026-01-23": 1,
                "2026-02-13": 6
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 165.7,
              "mode_time_hours": 267.0,
              "mode_frequency": 3,
              "time_distribution": {
                "24-26h": 2,
                "126-128h": 1,
                "180-182h": 1,
                "266-268h": 3
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-01-15": 3,
                "2026-01-23": 1,
                "2026-03-17": 2,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-01-15": 800.1376725,
                "2026-01-23": 127.26872861111111,
                "2026-03-17": 51.43279611111112,
                "2026-03-18": 181.0355947222222
              },
              "time_count_per_day": {
                "2026-01-15": 3,
                "2026-01-23": 1,
                "2026-03-17": 2,
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_30": {
      "overall": {
        "avg_time_hours": 567.21,
        "mode_time_hours": 825.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "154-156h": 1,
          "226-228h": 1,
          "288-290h": 1,
          "576-578h": 1,
          "824-826h": 1,
          "1896-1898h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-11-03": 1,
          "2025-11-06": 1,
          "2026-01-05": 1,
          "2026-02-06": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-14": 288.0740055555556,
          "2025-11-03": 825.0359152777778,
          "2025-11-06": 226.75254083333334,
          "2026-01-05": 576.8091091666666,
          "2026-02-06": 2.8028325,
          "2026-02-12": 1896.6417766666666,
          "2026-02-13": 154.37704555555553
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-11-03": 1,
          "2025-11-06": 1,
          "2026-01-05": 1,
          "2026-02-06": 1,
          "2026-02-12": 1,
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 678.18,
          "mode_time_hours": 825.0,
          "mode_frequency": 1,
          "time_distribution": {
            "154-156h": 1,
            "226-228h": 1,
            "288-290h": 1,
            "824-826h": 1,
            "1896-1898h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-11-03": 1,
            "2025-11-06": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-14": 288.0740055555556,
            "2025-11-03": 825.0359152777778,
            "2025-11-06": 226.75254083333334,
            "2026-02-12": 1896.6417766666666,
            "2026-02-13": 154.37704555555553
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-11-03": 1,
            "2025-11-06": 1,
            "2026-02-12": 1,
            "2026-02-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 289.81,
          "mode_time_hours": 577.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "576-578h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-01-05": 576.8091091666666,
            "2026-02-06": 2.8028325
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 567.21,
            "mode_time_hours": 825.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "154-156h": 1,
              "226-228h": 1,
              "288-290h": 1,
              "576-578h": 1,
              "824-826h": 1,
              "1896-1898h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-11-03": 1,
              "2025-11-06": 1,
              "2026-01-05": 1,
              "2026-02-06": 1,
              "2026-02-12": 1,
              "2026-02-13": 1
            },
            "time_per_day": {
              "2025-10-14": 288.0740055555556,
              "2025-11-03": 825.0359152777778,
              "2025-11-06": 226.75254083333334,
              "2026-01-05": 576.8091091666666,
              "2026-02-06": 2.8028325,
              "2026-02-12": 1896.6417766666666,
              "2026-02-13": 154.37704555555553
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-11-03": 1,
              "2025-11-06": 1,
              "2026-01-05": 1,
              "2026-02-06": 1,
              "2026-02-12": 1,
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 678.18,
              "mode_time_hours": 825.0,
              "mode_frequency": 1,
              "time_distribution": {
                "154-156h": 1,
                "226-228h": 1,
                "288-290h": 1,
                "824-826h": 1,
                "1896-1898h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-11-03": 1,
                "2025-11-06": 1,
                "2026-02-12": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2025-10-14": 288.0740055555556,
                "2025-11-03": 825.0359152777778,
                "2025-11-06": 226.75254083333334,
                "2026-02-12": 1896.6417766666666,
                "2026-02-13": 154.37704555555553
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-11-03": 1,
                "2025-11-06": 1,
                "2026-02-12": 1,
                "2026-02-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 289.81,
              "mode_time_hours": 577.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "576-578h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-01-05": 576.8091091666666,
                "2026-02-06": 2.8028325
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-02-06": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_33": {
      "overall": {
        "avg_time_hours": 95.92,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "8-10h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "40-42h": 1,
          "70-72h": 1,
          "102-104h": 1,
          "326-328h": 1,
          "360-362h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2025-09-30": 2,
          "2025-11-04": 1,
          "2025-11-18": 1,
          "2025-12-05": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-04-29": 1,
          "2026-04-30": 1
        },
        "time_per_day": {
          "2025-09-30": 13.78001,
          "2025-11-04": 21.15580472222222,
          "2025-11-18": 1.7832352777777778,
          "2025-12-05": 71.65836083333333,
          "2026-01-21": 17.531193055555555,
          "2026-01-22": 41.81885138888889,
          "2026-02-03": 102.96672722222222,
          "2026-02-13": 327.47594805555553,
          "2026-04-29": 361.0402794444445
        },
        "time_count_per_day": {
          "2025-09-30": 2,
          "2025-11-04": 1,
          "2025-11-18": 1,
          "2025-12-05": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 123.5,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "8-10h": 1,
            "16-18h": 1,
            "20-22h": 1,
            "326-328h": 1,
            "360-362h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-09-30": 2,
            "2025-11-04": 1,
            "2026-01-21": 1,
            "2026-02-13": 1,
            "2026-04-29": 1,
            "2026-04-30": 1
          },
          "time_per_day": {
            "2025-09-30": 13.78001,
            "2025-11-04": 21.15580472222222,
            "2026-01-21": 17.531193055555555,
            "2026-02-13": 327.47594805555553,
            "2026-04-29": 361.0402794444445
          },
          "time_count_per_day": {
            "2025-09-30": 2,
            "2025-11-04": 1,
            "2026-01-21": 1,
            "2026-02-13": 1,
            "2026-04-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 54.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "40-42h": 1,
            "70-72h": 1,
            "102-104h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-12-05": 1,
            "2026-01-22": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-11-18": 1.7832352777777778,
            "2025-12-05": 71.65836083333333,
            "2026-01-22": 41.81885138888889,
            "2026-02-03": 102.96672722222222
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-12-05": 1,
            "2026-01-22": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 95.92,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "8-10h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "40-42h": 1,
              "70-72h": 1,
              "102-104h": 1,
              "326-328h": 1,
              "360-362h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-09-30": 2,
              "2025-11-04": 1,
              "2025-11-18": 1,
              "2025-12-05": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-04-29": 1
            },
            "time_per_day": {
              "2025-09-30": 13.78001,
              "2025-11-04": 21.15580472222222,
              "2025-11-18": 1.7832352777777778,
              "2025-12-05": 71.65836083333333,
              "2026-01-21": 17.531193055555555,
              "2026-01-22": 41.81885138888889,
              "2026-02-03": 102.96672722222222,
              "2026-02-13": 327.47594805555553,
              "2026-04-29": 361.0402794444445
            },
            "time_count_per_day": {
              "2025-09-30": 2,
              "2025-11-04": 1,
              "2025-11-18": 1,
              "2025-12-05": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 123.5,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "8-10h": 1,
                "16-18h": 1,
                "20-22h": 1,
                "326-328h": 1,
                "360-362h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-09-30": 2,
                "2025-11-04": 1,
                "2026-01-21": 1,
                "2026-02-13": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2025-09-30": 13.78001,
                "2025-11-04": 21.15580472222222,
                "2026-01-21": 17.531193055555555,
                "2026-02-13": 327.47594805555553,
                "2026-04-29": 361.0402794444445
              },
              "time_count_per_day": {
                "2025-09-30": 2,
                "2025-11-04": 1,
                "2026-01-21": 1,
                "2026-02-13": 1,
                "2026-04-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 54.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "40-42h": 1,
                "70-72h": 1,
                "102-104h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-12-05": 1,
                "2026-01-22": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-11-18": 1.7832352777777778,
                "2025-12-05": 71.65836083333333,
                "2026-01-22": 41.81885138888889,
                "2026-02-03": 102.96672722222222
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-12-05": 1,
                "2026-01-22": 1,
                "2026-02-03": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_34": {
      "overall": {
        "avg_time_hours": 28.21,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-01": 1
        },
        "time_per_day": {
          "2025-10-01": 28.2095025
        },
        "time_count_per_day": {
          "2025-10-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 28.21,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-01": 1
          },
          "time_per_day": {
            "2025-10-01": 28.2095025
          },
          "time_count_per_day": {
            "2025-10-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.21,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-01": 1
            },
            "time_per_day": {
              "2025-10-01": 28.2095025
            },
            "time_count_per_day": {
              "2025-10-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 28.21,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-01": 1
              },
              "time_per_day": {
                "2025-10-01": 28.2095025
              },
              "time_count_per_day": {
                "2025-10-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_35": {
      "overall": {
        "avg_time_hours": 128.88,
        "mode_time_hours": 1.0,
        "mode_frequency": 109,
        "time_distribution": {
          "0-2h": 109,
          "2-4h": 20,
          "4-6h": 9,
          "6-8h": 6,
          "8-10h": 5,
          "10-12h": 4,
          "12-14h": 1,
          "16-18h": 2,
          "18-20h": 3,
          "20-22h": 1,
          "22-24h": 6,
          "24-26h": 5,
          "26-28h": 3,
          "30-32h": 3,
          "36-38h": 2,
          "40-42h": 1,
          "42-44h": 3,
          "44-46h": 3,
          "48-50h": 2,
          "50-52h": 9,
          "52-54h": 2,
          "54-56h": 2,
          "56-58h": 1,
          "60-62h": 2,
          "62-64h": 1,
          "70-72h": 1,
          "76-78h": 2,
          "78-80h": 4,
          "94-96h": 1,
          "96-98h": 4,
          "100-102h": 1,
          "102-104h": 1,
          "104-106h": 2,
          "106-108h": 2,
          "108-110h": 1,
          "120-122h": 3,
          "122-124h": 2,
          "124-126h": 1,
          "134-136h": 2,
          "140-142h": 2,
          "142-144h": 2,
          "144-146h": 2,
          "148-150h": 1,
          "150-152h": 2,
          "152-154h": 1,
          "166-168h": 1,
          "184-186h": 1,
          "192-194h": 2,
          "200-202h": 1,
          "206-208h": 1,
          "230-232h": 1,
          "258-260h": 1,
          "288-290h": 1,
          "314-316h": 1,
          "332-334h": 1,
          "336-338h": 2,
          "342-344h": 1,
          "354-356h": 1,
          "360-362h": 1,
          "366-368h": 1,
          "372-374h": 1,
          "392-394h": 1,
          "408-410h": 1,
          "416-418h": 1,
          "442-444h": 1,
          "448-450h": 1,
          "462-464h": 1,
          "476-478h": 1,
          "502-504h": 2,
          "504-506h": 2,
          "508-510h": 1,
          "538-540h": 2,
          "582-584h": 1,
          "598-600h": 1,
          "666-668h": 1,
          "672-674h": 1,
          "678-680h": 1,
          "682-684h": 2,
          "690-692h": 1,
          "692-694h": 2,
          "700-702h": 1,
          "912-914h": 1,
          "1080-1082h": 1,
          "1100-1102h": 1,
          "1124-1126h": 1,
          "1230-1232h": 1,
          "1344-1346h": 1,
          "1838-1840h": 2,
          "1862-1864h": 1
        },
        "tickets_count": 320,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-07": 3,
          "2025-10-09": 1,
          "2025-10-13": 7,
          "2025-10-14": 1,
          "2025-10-15": 7,
          "2025-10-17": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-25": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-31": 2,
          "2025-11-03": 2,
          "2025-11-05": 3,
          "2025-11-11": 2,
          "2025-11-12": 3,
          "2025-11-19": 5,
          "2025-11-20": 2,
          "2025-11-21": 3,
          "2025-11-22": 2,
          "2025-11-23": 1,
          "2025-11-25": 1,
          "2025-12-02": 1,
          "2025-12-03": 6,
          "2025-12-05": 1,
          "2025-12-08": 1,
          "2025-12-09": 1,
          "2025-12-10": 5,
          "2025-12-12": 1,
          "2025-12-15": 11,
          "2025-12-18": 2,
          "2025-12-20": 1,
          "2025-12-22": 3,
          "2025-12-23": 1,
          "2025-12-26": 1,
          "2025-12-29": 2,
          "2026-01-03": 1,
          "2026-01-08": 2,
          "2026-01-09": 2,
          "2026-01-15": 1,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 3,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 6,
          "2026-02-10": 10,
          "2026-02-12": 5,
          "2026-02-13": 5,
          "2026-02-14": 2,
          "2026-02-17": 1,
          "2026-02-18": 4,
          "2026-02-19": 17,
          "2026-02-20": 2,
          "2026-02-21": 8,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-02-28": 2,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-07": 1,
          "2026-03-10": 7,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-17": 4,
          "2026-03-18": 6,
          "2026-03-19": 2,
          "2026-03-26": 9,
          "2026-03-27": 1,
          "2026-03-31": 3,
          "2026-04-01": 7,
          "2026-04-02": 6,
          "2026-04-04": 1,
          "2026-04-06": 6,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-13": 2,
          "2026-04-14": 1,
          "2026-04-15": 3,
          "2026-04-20": 4,
          "2026-04-21": 2,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-04-27": 5,
          "2026-04-30": 1,
          "2026-05-04": 5,
          "2026-05-05": 8,
          "2026-05-06": 6,
          "2026-05-07": 4,
          "2026-05-08": 3,
          "2026-05-09": 1,
          "2026-05-11": 7,
          "2026-05-12": 2,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-16": 2,
          "2026-05-20": 2,
          "2026-05-21": 1,
          "2026-05-23": 1,
          "2026-05-25": 7,
          "2026-05-26": 1,
          "2026-05-27": 2,
          "2026-05-28": 3,
          "2026-05-29": 2,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-02": 2,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-09-30": 0.699281111111111,
          "2025-10-07": 212.07944361111112,
          "2025-10-09": 41.029045833333335,
          "2025-10-13": 722.74511,
          "2025-10-14": 25.396378333333335,
          "2025-10-15": 159.38956583333336,
          "2025-10-17": 1.4272766666666667,
          "2025-10-22": 121.48236305555555,
          "2025-10-23": 18.021049444444444,
          "2025-10-25": 62.87988805555556,
          "2025-10-27": 5.515646944444445,
          "2025-10-28": 354.0095219444445,
          "2025-10-31": 215.06064583333335,
          "2025-11-03": 10.490560833333333,
          "2025-11-05": 120.48810194444445,
          "2025-11-11": 193.67877611111112,
          "2025-11-12": 79.89401388888889,
          "2025-11-19": 241.76419277777777,
          "2025-11-20": 79.86287694444445,
          "2025-11-21": 74.93561861111111,
          "2025-11-22": 87.93168861111113,
          "2025-11-23": 25.912654166666666,
          "2025-11-25": 149.89087194444443,
          "2025-12-02": 315.18753194444446,
          "2025-12-03": 882.3425197222222,
          "2025-12-05": 78.31860833333333,
          "2025-12-08": 4.968939722222222,
          "2025-12-09": 143.47520277777778,
          "2025-12-10": 38.27426916666667,
          "2025-12-12": 5.872123055555556,
          "2025-12-15": 294.1989613888889,
          "2025-12-18": 0.5797427777777777,
          "2025-12-20": 258.72006055555556,
          "2025-12-22": 218.93360194444443,
          "2025-12-23": 1.5074008333333333,
          "2025-12-26": 61.554855555555555,
          "2025-12-29": 10.986420277777778,
          "2026-01-03": 0.7922186111111111,
          "2026-01-08": 26.567760555555555,
          "2026-01-09": 563.0768513888888,
          "2026-01-15": 8.333137222222224,
          "2026-01-20": 87.60785138888889,
          "2026-01-21": 22.750493055555555,
          "2026-01-23": 0.06407861111111111,
          "2026-01-26": 1.4117863888888889,
          "2026-01-27": 212.77755611111112,
          "2026-02-03": 1230.685456111111,
          "2026-02-06": 1263.9140194444444,
          "2026-02-10": 3742.819351666666,
          "2026-02-12": 1228.942422777778,
          "2026-02-13": 230.79345472222224,
          "2026-02-14": 0.4978694444444444,
          "2026-02-17": 442.07610861111107,
          "2026-02-18": 5702.7389775,
          "2026-02-19": 11462.060175,
          "2026-02-20": 0.042763333333333334,
          "2026-02-21": 12.844868611111112,
          "2026-02-23": 8.04192138888889,
          "2026-02-24": 11.812933888888889,
          "2026-02-28": 104.81895694444444,
          "2026-03-03": 1.0329944444444445,
          "2026-03-07": 1.4992966666666667,
          "2026-03-10": 8.607306388888889,
          "2026-03-12": 1.7546247222222222,
          "2026-03-13": 0.5632325,
          "2026-03-16": 0.40735944444444444,
          "2026-03-17": 83.8383861111111,
          "2026-03-18": 1752.3517469444446,
          "2026-03-19": 1.348843888888889,
          "2026-03-26": 3644.057130833334,
          "2026-03-27": 0.5333927777777777,
          "2026-03-31": 1.7602280555555556,
          "2026-04-01": 46.80364,
          "2026-04-02": 28.70897527777778,
          "2026-04-04": 42.067433888888885,
          "2026-04-06": 13.590801111111112,
          "2026-04-07": 0.7159202777777778,
          "2026-04-08": 1.0198283333333333,
          "2026-04-10": 1.3259986111111113,
          "2026-04-13": 0.6201230555555556,
          "2026-04-14": 1.7177469444444444,
          "2026-04-20": 1.293745,
          "2026-04-21": 1.2518755555555556,
          "2026-04-22": 0.12097722222222221,
          "2026-04-23": 1.339748611111111,
          "2026-04-27": 80.94238055555554,
          "2026-04-30": 1.016265,
          "2026-05-04": 2.7440475,
          "2026-05-05": 6.478658888888888,
          "2026-05-06": 3.3188016666666664,
          "2026-05-07": 30.598537777777782,
          "2026-05-08": 31.96392833333333,
          "2026-05-11": 16.6627325,
          "2026-05-12": 108.58553888888889,
          "2026-05-14": 1.3116555555555556,
          "2026-05-15": 0.3178352777777778,
          "2026-05-16": 0.23889472222222222,
          "2026-05-20": 1.1473638888888888,
          "2026-05-21": 0.3150530555555556,
          "2026-05-25": 60.41142833333333,
          "2026-05-26": 0.1972386111111111,
          "2026-05-27": 3.5619294444444445,
          "2026-05-28": 4.7967611111111115,
          "2026-05-29": 2.8115449999999997,
          "2026-05-30": 0.35210027777777775,
          "2026-06-01": 4.0270447222222225,
          "2026-06-02": 202.7389538888889,
          "2026-06-08": 1.6237697222222223
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-07": 3,
          "2025-10-09": 1,
          "2025-10-13": 7,
          "2025-10-14": 1,
          "2025-10-15": 7,
          "2025-10-17": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-25": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-31": 2,
          "2025-11-03": 2,
          "2025-11-05": 3,
          "2025-11-11": 2,
          "2025-11-12": 3,
          "2025-11-19": 5,
          "2025-11-20": 2,
          "2025-11-21": 3,
          "2025-11-22": 2,
          "2025-11-23": 1,
          "2025-11-25": 1,
          "2025-12-02": 1,
          "2025-12-03": 6,
          "2025-12-05": 1,
          "2025-12-08": 1,
          "2025-12-09": 1,
          "2025-12-10": 5,
          "2025-12-12": 1,
          "2025-12-15": 11,
          "2025-12-18": 2,
          "2025-12-20": 1,
          "2025-12-22": 3,
          "2025-12-23": 1,
          "2025-12-26": 1,
          "2025-12-29": 2,
          "2026-01-03": 1,
          "2026-01-08": 2,
          "2026-01-09": 2,
          "2026-01-15": 1,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 3,
          "2026-02-03": 1,
          "2026-02-06": 6,
          "2026-02-10": 10,
          "2026-02-12": 5,
          "2026-02-13": 5,
          "2026-02-14": 2,
          "2026-02-17": 1,
          "2026-02-18": 4,
          "2026-02-19": 17,
          "2026-02-20": 1,
          "2026-02-21": 8,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-02-28": 2,
          "2026-03-03": 1,
          "2026-03-07": 1,
          "2026-03-10": 5,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-17": 4,
          "2026-03-18": 6,
          "2026-03-19": 2,
          "2026-03-26": 9,
          "2026-03-27": 1,
          "2026-03-31": 2,
          "2026-04-01": 7,
          "2026-04-02": 6,
          "2026-04-04": 1,
          "2026-04-06": 6,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-13": 2,
          "2026-04-14": 1,
          "2026-04-20": 4,
          "2026-04-21": 2,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-04-27": 3,
          "2026-04-30": 1,
          "2026-05-04": 4,
          "2026-05-05": 5,
          "2026-05-06": 5,
          "2026-05-07": 4,
          "2026-05-08": 2,
          "2026-05-11": 7,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-16": 2,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-25": 5,
          "2026-05-26": 1,
          "2026-05-27": 2,
          "2026-05-28": 3,
          "2026-05-29": 2,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-02": 2,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 31.17,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "54-56h": 1,
            "56-58h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2026-01-20": 1,
            "2026-04-06": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2025-11-19": 5.7333694444444445,
            "2026-01-20": 55.654672777777776,
            "2026-04-06": 6.578388611111111,
            "2026-05-25": 56.71292527777778
          },
          "time_count_per_day": {
            "2025-11-19": 1,
            "2026-01-20": 1,
            "2026-04-06": 1,
            "2026-05-25": 1
          }
        },
        "P2": {
          "avg_time_hours": 12.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 104,
          "time_distribution": {
            "0-2h": 104,
            "2-4h": 16,
            "4-6h": 4,
            "6-8h": 4,
            "8-10h": 2,
            "10-12h": 4,
            "12-14h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "30-32h": 2,
            "42-44h": 1,
            "52-54h": 1,
            "76-78h": 2,
            "78-80h": 1,
            "108-110h": 1,
            "122-124h": 1,
            "200-202h": 1,
            "354-356h": 1,
            "408-410h": 1
          },
          "tickets_count": 151,
          "tickets_per_day": {
            "2025-10-15": 2,
            "2025-10-17": 1,
            "2025-10-28": 1,
            "2025-11-19": 2,
            "2025-11-21": 1,
            "2025-12-03": 1,
            "2025-12-08": 1,
            "2025-12-10": 3,
            "2025-12-15": 3,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-29": 2,
            "2026-01-03": 1,
            "2026-01-09": 1,
            "2026-01-15": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-02-13": 2,
            "2026-02-14": 2,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-21": 5,
            "2026-02-24": 1,
            "2026-03-03": 1,
            "2026-03-07": 1,
            "2026-03-10": 5,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-19": 2,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-31": 2,
            "2026-04-01": 7,
            "2026-04-02": 6,
            "2026-04-04": 1,
            "2026-04-06": 5,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-13": 2,
            "2026-04-14": 1,
            "2026-04-20": 4,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-27": 3,
            "2026-04-30": 1,
            "2026-05-04": 4,
            "2026-05-05": 6,
            "2026-05-06": 5,
            "2026-05-07": 4,
            "2026-05-08": 2,
            "2026-05-11": 7,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-16": 2,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-23": 1,
            "2026-05-25": 4,
            "2026-05-26": 1,
            "2026-05-27": 2,
            "2026-05-28": 3,
            "2026-05-29": 2,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-02": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-15": 1.2022905555555556,
            "2025-10-17": 1.4272766666666667,
            "2025-10-28": 354.0095219444445,
            "2025-11-19": 130.49367833333332,
            "2025-11-21": 1.1167194444444444,
            "2025-12-03": 3.540503888888889,
            "2025-12-08": 4.968939722222222,
            "2025-12-10": 3.0973683333333337,
            "2025-12-15": 0.25015,
            "2025-12-22": 1.7217277777777777,
            "2025-12-23": 1.5074008333333333,
            "2025-12-29": 10.986420277777778,
            "2026-01-03": 0.7922186111111111,
            "2026-01-09": 409.9502572222222,
            "2026-01-15": 8.333137222222224,
            "2026-01-20": 31.953178611111113,
            "2026-01-21": 22.750493055555555,
            "2026-01-23": 0.06407861111111111,
            "2026-01-26": 1.4117863888888889,
            "2026-01-27": 79.94882944444446,
            "2026-02-13": 3.444682777777778,
            "2026-02-14": 0.4978694444444444,
            "2026-02-19": 122.09595138888889,
            "2026-02-20": 0.042763333333333334,
            "2026-02-21": 2.4466108333333336,
            "2026-02-24": 11.812933888888889,
            "2026-03-03": 1.0329944444444445,
            "2026-03-07": 1.4992966666666667,
            "2026-03-10": 8.607306388888889,
            "2026-03-12": 1.7546247222222222,
            "2026-03-13": 0.5632325,
            "2026-03-16": 0.40735944444444444,
            "2026-03-17": 8.988806666666667,
            "2026-03-18": 0.9748955555555555,
            "2026-03-19": 1.348843888888889,
            "2026-03-26": 6.048633888888888,
            "2026-03-27": 0.5333927777777777,
            "2026-03-31": 1.7602280555555556,
            "2026-04-01": 46.80364,
            "2026-04-02": 28.70897527777778,
            "2026-04-04": 42.067433888888885,
            "2026-04-06": 7.0124125,
            "2026-04-07": 0.7159202777777778,
            "2026-04-08": 1.0198283333333333,
            "2026-04-10": 1.3259986111111113,
            "2026-04-13": 0.6201230555555556,
            "2026-04-14": 1.7177469444444444,
            "2026-04-20": 1.293745,
            "2026-04-21": 1.2518755555555556,
            "2026-04-22": 0.12097722222222221,
            "2026-04-23": 1.339748611111111,
            "2026-04-27": 80.94238055555554,
            "2026-04-30": 1.016265,
            "2026-05-04": 2.7440475,
            "2026-05-05": 6.478658888888888,
            "2026-05-06": 3.3188016666666664,
            "2026-05-07": 30.598537777777782,
            "2026-05-08": 31.96392833333333,
            "2026-05-11": 16.6627325,
            "2026-05-12": 108.58553888888889,
            "2026-05-14": 1.3116555555555556,
            "2026-05-15": 0.3178352777777778,
            "2026-05-16": 0.23889472222222222,
            "2026-05-20": 1.1473638888888888,
            "2026-05-21": 0.3150530555555556,
            "2026-05-25": 3.6985030555555554,
            "2026-05-26": 0.1972386111111111,
            "2026-05-27": 3.5619294444444445,
            "2026-05-28": 4.7967611111111115,
            "2026-05-29": 2.8115449999999997,
            "2026-05-30": 0.35210027777777775,
            "2026-06-01": 4.0270447222222225,
            "2026-06-02": 202.7389538888889,
            "2026-06-08": 1.6237697222222223
          },
          "time_count_per_day": {
            "2025-10-15": 2,
            "2025-10-17": 1,
            "2025-10-28": 1,
            "2025-11-19": 2,
            "2025-11-21": 1,
            "2025-12-03": 1,
            "2025-12-08": 1,
            "2025-12-10": 3,
            "2025-12-15": 3,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-29": 2,
            "2026-01-03": 1,
            "2026-01-09": 1,
            "2026-01-15": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-02-13": 2,
            "2026-02-14": 2,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-21": 5,
            "2026-02-24": 1,
            "2026-03-03": 1,
            "2026-03-07": 1,
            "2026-03-10": 5,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-19": 2,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-31": 2,
            "2026-04-01": 7,
            "2026-04-02": 6,
            "2026-04-04": 1,
            "2026-04-06": 5,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-13": 2,
            "2026-04-14": 1,
            "2026-04-20": 4,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-27": 3,
            "2026-04-30": 1,
            "2026-05-04": 4,
            "2026-05-05": 5,
            "2026-05-06": 5,
            "2026-05-07": 4,
            "2026-05-08": 2,
            "2026-05-11": 7,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-16": 2,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-25": 4,
            "2026-05-26": 1,
            "2026-05-27": 2,
            "2026-05-28": 3,
            "2026-05-29": 2,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-02": 2,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 202.74,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "4-6h": 1,
            "8-10h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "44-46h": 1,
            "100-102h": 1,
            "150-152h": 2,
            "166-168h": 1,
            "184-186h": 1,
            "192-194h": 2,
            "332-334h": 1,
            "336-338h": 2,
            "448-450h": 1,
            "462-464h": 1,
            "504-506h": 2,
            "538-540h": 2
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-11-19": 1,
            "2025-11-21": 1,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-18": 2,
            "2025-12-22": 1,
            "2026-02-06": 2,
            "2026-02-10": 9,
            "2026-02-12": 2,
            "2026-02-13": 3
          },
          "time_per_day": {
            "2025-09-30": 0.699281111111111,
            "2025-10-07": 100.66653,
            "2025-10-15": 45.73987916666667,
            "2025-11-19": 0.9157702777777779,
            "2025-11-21": 18.580653055555555,
            "2025-12-10": 9.213739444444444,
            "2025-12-12": 5.872123055555556,
            "2025-12-18": 0.5797427777777777,
            "2025-12-22": 166.72237055555556,
            "2026-02-06": 384.64594805555555,
            "2026-02-10": 3233.524673888888,
            "2026-02-12": 1076.7851833333334,
            "2026-02-13": 227.34877194444445
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-11-19": 1,
            "2025-11-21": 1,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-18": 2,
            "2025-12-22": 1,
            "2026-02-06": 2,
            "2026-02-10": 9,
            "2026-02-12": 2,
            "2026-02-13": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 136.72,
          "mode_time_hours": 51.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 4,
            "4-6h": 3,
            "6-8h": 1,
            "8-10h": 1,
            "16-18h": 1,
            "18-20h": 2,
            "22-24h": 3,
            "24-26h": 3,
            "26-28h": 3,
            "30-32h": 1,
            "36-38h": 2,
            "40-42h": 1,
            "42-44h": 2,
            "44-46h": 2,
            "48-50h": 2,
            "50-52h": 9,
            "52-54h": 1,
            "54-56h": 1,
            "60-62h": 2,
            "62-64h": 1,
            "70-72h": 1,
            "78-80h": 3,
            "94-96h": 1,
            "96-98h": 4,
            "102-104h": 1,
            "104-106h": 2,
            "106-108h": 2,
            "120-122h": 3,
            "122-124h": 1,
            "124-126h": 1,
            "134-136h": 2,
            "140-142h": 2,
            "142-144h": 2,
            "144-146h": 2,
            "148-150h": 1,
            "152-154h": 1,
            "314-316h": 1,
            "342-344h": 1,
            "366-368h": 1,
            "372-374h": 1,
            "392-394h": 1,
            "416-418h": 1,
            "476-478h": 1,
            "502-504h": 2,
            "508-510h": 1,
            "582-584h": 1,
            "598-600h": 1,
            "678-680h": 1,
            "690-692h": 1,
            "700-702h": 1
          },
          "tickets_count": 112,
          "tickets_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-13": 7,
            "2025-10-14": 1,
            "2025-10-15": 4,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-25": 1,
            "2025-10-27": 1,
            "2025-10-31": 2,
            "2025-11-03": 2,
            "2025-11-05": 3,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-19": 1,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-22": 2,
            "2025-11-23": 1,
            "2025-11-25": 1,
            "2025-12-02": 1,
            "2025-12-03": 5,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-15": 5,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-08": 2,
            "2026-01-09": 1,
            "2026-01-27": 1,
            "2026-02-04": 1,
            "2026-02-06": 4,
            "2026-02-10": 1,
            "2026-02-12": 3,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 3,
            "2026-02-23": 1,
            "2026-02-28": 2,
            "2026-03-04": 1,
            "2026-03-10": 2,
            "2026-03-17": 2,
            "2026-03-18": 5,
            "2026-03-26": 8,
            "2026-03-31": 1,
            "2026-04-15": 3,
            "2026-04-27": 2,
            "2026-05-04": 1,
            "2026-05-05": 2,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-20": 1,
            "2026-05-25": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-07": 111.41291361111111,
            "2025-10-09": 41.029045833333335,
            "2025-10-13": 722.74511,
            "2025-10-14": 25.396378333333335,
            "2025-10-15": 112.44739611111112,
            "2025-10-22": 121.48236305555555,
            "2025-10-23": 18.021049444444444,
            "2025-10-25": 62.87988805555556,
            "2025-10-27": 5.515646944444445,
            "2025-10-31": 215.06064583333335,
            "2025-11-03": 10.490560833333333,
            "2025-11-05": 120.48810194444445,
            "2025-11-11": 193.67877611111112,
            "2025-11-12": 79.89401388888889,
            "2025-11-19": 104.62137472222223,
            "2025-11-20": 79.86287694444445,
            "2025-11-21": 55.23824611111111,
            "2025-11-22": 87.93168861111113,
            "2025-11-23": 25.912654166666666,
            "2025-11-25": 149.89087194444443,
            "2025-12-02": 315.18753194444446,
            "2025-12-03": 878.8020158333333,
            "2025-12-05": 78.31860833333333,
            "2025-12-09": 143.47520277777778,
            "2025-12-10": 25.96316138888889,
            "2025-12-15": 226.08665666666667,
            "2025-12-22": 50.48950361111111,
            "2025-12-26": 61.554855555555555,
            "2026-01-08": 26.567760555555555,
            "2026-01-09": 153.12659416666665,
            "2026-01-27": 122.83056722222223,
            "2026-02-06": 879.268071388889,
            "2026-02-10": 509.2946777777778,
            "2026-02-12": 152.15723944444443,
            "2026-02-18": 678.8836433333333,
            "2026-02-19": 71.00617777777778,
            "2026-02-21": 10.398257777777777,
            "2026-02-23": 8.04192138888889,
            "2026-02-28": 104.81895694444444,
            "2026-03-17": 74.84957944444444,
            "2026-03-18": 1751.376851388889,
            "2026-03-26": 3638.008496944445
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-13": 7,
            "2025-10-14": 1,
            "2025-10-15": 4,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-25": 1,
            "2025-10-27": 1,
            "2025-10-31": 2,
            "2025-11-03": 2,
            "2025-11-05": 3,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-19": 1,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-22": 2,
            "2025-11-23": 1,
            "2025-11-25": 1,
            "2025-12-02": 1,
            "2025-12-03": 5,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-15": 5,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-08": 2,
            "2026-01-09": 1,
            "2026-01-27": 1,
            "2026-02-06": 4,
            "2026-02-10": 1,
            "2026-02-12": 3,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 3,
            "2026-02-23": 1,
            "2026-02-28": 2,
            "2026-03-17": 2,
            "2026-03-18": 5,
            "2026-03-26": 8
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 732.09,
          "mode_time_hours": 1839.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 1,
            "20-22h": 1,
            "22-24h": 2,
            "206-208h": 1,
            "230-232h": 1,
            "258-260h": 1,
            "288-290h": 1,
            "360-362h": 1,
            "442-444h": 1,
            "666-668h": 1,
            "672-674h": 1,
            "682-684h": 2,
            "692-694h": 2,
            "912-914h": 1,
            "1080-1082h": 1,
            "1100-1102h": 1,
            "1124-1126h": 1,
            "1230-1232h": 1,
            "1344-1346h": 1,
            "1838-1840h": 2,
            "1862-1864h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2025-12-15": 3,
            "2025-12-20": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-17": 1,
            "2026-02-18": 3,
            "2026-02-19": 15,
            "2026-02-20": 1,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-12-15": 67.86215472222221,
            "2025-12-20": 258.72006055555556,
            "2026-01-27": 9.998159444444445,
            "2026-02-03": 1230.685456111111,
            "2026-02-17": 442.07610861111107,
            "2026-02-18": 5023.855334166667,
            "2026-02-19": 11268.958045833335
          },
          "time_count_per_day": {
            "2025-12-15": 3,
            "2025-12-20": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-17": 1,
            "2026-02-18": 3,
            "2026-02-19": 15
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 128.88,
            "mode_time_hours": 1.0,
            "mode_frequency": 109,
            "time_distribution": {
              "0-2h": 109,
              "2-4h": 20,
              "4-6h": 9,
              "6-8h": 6,
              "8-10h": 5,
              "10-12h": 4,
              "12-14h": 1,
              "16-18h": 2,
              "18-20h": 3,
              "20-22h": 1,
              "22-24h": 6,
              "24-26h": 5,
              "26-28h": 3,
              "30-32h": 3,
              "36-38h": 2,
              "40-42h": 1,
              "42-44h": 3,
              "44-46h": 3,
              "48-50h": 2,
              "50-52h": 9,
              "52-54h": 2,
              "54-56h": 2,
              "56-58h": 1,
              "60-62h": 2,
              "62-64h": 1,
              "70-72h": 1,
              "76-78h": 2,
              "78-80h": 4,
              "94-96h": 1,
              "96-98h": 4,
              "100-102h": 1,
              "102-104h": 1,
              "104-106h": 2,
              "106-108h": 2,
              "108-110h": 1,
              "120-122h": 3,
              "122-124h": 2,
              "124-126h": 1,
              "134-136h": 2,
              "140-142h": 2,
              "142-144h": 2,
              "144-146h": 2,
              "148-150h": 1,
              "150-152h": 2,
              "152-154h": 1,
              "166-168h": 1,
              "184-186h": 1,
              "192-194h": 2,
              "200-202h": 1,
              "206-208h": 1,
              "230-232h": 1,
              "258-260h": 1,
              "288-290h": 1,
              "314-316h": 1,
              "332-334h": 1,
              "336-338h": 2,
              "342-344h": 1,
              "354-356h": 1,
              "360-362h": 1,
              "366-368h": 1,
              "372-374h": 1,
              "392-394h": 1,
              "408-410h": 1,
              "416-418h": 1,
              "442-444h": 1,
              "448-450h": 1,
              "462-464h": 1,
              "476-478h": 1,
              "502-504h": 2,
              "504-506h": 2,
              "508-510h": 1,
              "538-540h": 2,
              "582-584h": 1,
              "598-600h": 1,
              "666-668h": 1,
              "672-674h": 1,
              "678-680h": 1,
              "682-684h": 2,
              "690-692h": 1,
              "692-694h": 2,
              "700-702h": 1,
              "912-914h": 1,
              "1080-1082h": 1,
              "1100-1102h": 1,
              "1124-1126h": 1,
              "1230-1232h": 1,
              "1344-1346h": 1,
              "1838-1840h": 2,
              "1862-1864h": 1
            },
            "tickets_count": 294,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-07": 3,
              "2025-10-09": 1,
              "2025-10-13": 7,
              "2025-10-14": 1,
              "2025-10-15": 7,
              "2025-10-17": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-25": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-31": 2,
              "2025-11-03": 2,
              "2025-11-05": 3,
              "2025-11-11": 2,
              "2025-11-12": 3,
              "2025-11-19": 5,
              "2025-11-20": 2,
              "2025-11-21": 3,
              "2025-11-22": 2,
              "2025-11-23": 1,
              "2025-11-25": 1,
              "2025-12-02": 1,
              "2025-12-03": 6,
              "2025-12-05": 1,
              "2025-12-08": 1,
              "2025-12-09": 1,
              "2025-12-10": 5,
              "2025-12-12": 1,
              "2025-12-15": 11,
              "2025-12-18": 2,
              "2025-12-20": 1,
              "2025-12-22": 3,
              "2025-12-23": 1,
              "2025-12-26": 1,
              "2025-12-29": 2,
              "2026-01-03": 1,
              "2026-01-08": 2,
              "2026-01-09": 2,
              "2026-01-15": 1,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 3,
              "2026-02-03": 1,
              "2026-02-06": 6,
              "2026-02-10": 10,
              "2026-02-12": 5,
              "2026-02-13": 5,
              "2026-02-14": 2,
              "2026-02-17": 1,
              "2026-02-18": 4,
              "2026-02-19": 17,
              "2026-02-20": 1,
              "2026-02-21": 8,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-02-28": 2,
              "2026-03-03": 1,
              "2026-03-07": 1,
              "2026-03-10": 5,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-17": 4,
              "2026-03-18": 6,
              "2026-03-19": 2,
              "2026-03-26": 9,
              "2026-03-27": 1,
              "2026-03-31": 2,
              "2026-04-01": 7,
              "2026-04-02": 6,
              "2026-04-04": 1,
              "2026-04-06": 6,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-13": 2,
              "2026-04-14": 1,
              "2026-04-20": 4,
              "2026-04-21": 2,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-27": 3,
              "2026-04-30": 1,
              "2026-05-04": 4,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 4,
              "2026-05-08": 2,
              "2026-05-11": 7,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-16": 2,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-25": 5,
              "2026-05-26": 1,
              "2026-05-27": 2,
              "2026-05-28": 3,
              "2026-05-29": 2,
              "2026-05-30": 1,
              "2026-06-01": 1,
              "2026-06-02": 2,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-09-30": 0.699281111111111,
              "2025-10-07": 212.07944361111112,
              "2025-10-09": 41.029045833333335,
              "2025-10-13": 722.74511,
              "2025-10-14": 25.396378333333335,
              "2025-10-15": 159.38956583333336,
              "2025-10-17": 1.4272766666666667,
              "2025-10-22": 121.48236305555555,
              "2025-10-23": 18.021049444444444,
              "2025-10-25": 62.87988805555556,
              "2025-10-27": 5.515646944444445,
              "2025-10-28": 354.0095219444445,
              "2025-10-31": 215.06064583333335,
              "2025-11-03": 10.490560833333333,
              "2025-11-05": 120.48810194444445,
              "2025-11-11": 193.67877611111112,
              "2025-11-12": 79.89401388888889,
              "2025-11-19": 241.76419277777777,
              "2025-11-20": 79.86287694444445,
              "2025-11-21": 74.93561861111111,
              "2025-11-22": 87.93168861111113,
              "2025-11-23": 25.912654166666666,
              "2025-11-25": 149.89087194444443,
              "2025-12-02": 315.18753194444446,
              "2025-12-03": 882.3425197222222,
              "2025-12-05": 78.31860833333333,
              "2025-12-08": 4.968939722222222,
              "2025-12-09": 143.47520277777778,
              "2025-12-10": 38.27426916666667,
              "2025-12-12": 5.872123055555556,
              "2025-12-15": 294.1989613888889,
              "2025-12-18": 0.5797427777777777,
              "2025-12-20": 258.72006055555556,
              "2025-12-22": 218.93360194444443,
              "2025-12-23": 1.5074008333333333,
              "2025-12-26": 61.554855555555555,
              "2025-12-29": 10.986420277777778,
              "2026-01-03": 0.7922186111111111,
              "2026-01-08": 26.567760555555555,
              "2026-01-09": 563.0768513888888,
              "2026-01-15": 8.333137222222224,
              "2026-01-20": 87.60785138888889,
              "2026-01-21": 22.750493055555555,
              "2026-01-23": 0.06407861111111111,
              "2026-01-26": 1.4117863888888889,
              "2026-01-27": 212.77755611111112,
              "2026-02-03": 1230.685456111111,
              "2026-02-06": 1263.9140194444444,
              "2026-02-10": 3742.819351666666,
              "2026-02-12": 1228.942422777778,
              "2026-02-13": 230.79345472222224,
              "2026-02-14": 0.4978694444444444,
              "2026-02-17": 442.07610861111107,
              "2026-02-18": 5702.7389775,
              "2026-02-19": 11462.060175,
              "2026-02-20": 0.042763333333333334,
              "2026-02-21": 12.844868611111112,
              "2026-02-23": 8.04192138888889,
              "2026-02-24": 11.812933888888889,
              "2026-02-28": 104.81895694444444,
              "2026-03-03": 1.0329944444444445,
              "2026-03-07": 1.4992966666666667,
              "2026-03-10": 8.607306388888889,
              "2026-03-12": 1.7546247222222222,
              "2026-03-13": 0.5632325,
              "2026-03-16": 0.40735944444444444,
              "2026-03-17": 83.8383861111111,
              "2026-03-18": 1752.3517469444446,
              "2026-03-19": 1.348843888888889,
              "2026-03-26": 3644.057130833334,
              "2026-03-27": 0.5333927777777777,
              "2026-03-31": 1.7602280555555556,
              "2026-04-01": 46.80364,
              "2026-04-02": 28.70897527777778,
              "2026-04-04": 42.067433888888885,
              "2026-04-06": 13.590801111111112,
              "2026-04-07": 0.7159202777777778,
              "2026-04-08": 1.0198283333333333,
              "2026-04-10": 1.3259986111111113,
              "2026-04-13": 0.6201230555555556,
              "2026-04-14": 1.7177469444444444,
              "2026-04-20": 1.293745,
              "2026-04-21": 1.2518755555555556,
              "2026-04-22": 0.12097722222222221,
              "2026-04-23": 1.339748611111111,
              "2026-04-27": 80.94238055555554,
              "2026-04-30": 1.016265,
              "2026-05-04": 2.7440475,
              "2026-05-05": 6.478658888888888,
              "2026-05-06": 3.3188016666666664,
              "2026-05-07": 30.598537777777782,
              "2026-05-08": 31.96392833333333,
              "2026-05-11": 16.6627325,
              "2026-05-12": 108.58553888888889,
              "2026-05-14": 1.3116555555555556,
              "2026-05-15": 0.3178352777777778,
              "2026-05-16": 0.23889472222222222,
              "2026-05-20": 1.1473638888888888,
              "2026-05-21": 0.3150530555555556,
              "2026-05-25": 60.41142833333333,
              "2026-05-26": 0.1972386111111111,
              "2026-05-27": 3.5619294444444445,
              "2026-05-28": 4.7967611111111115,
              "2026-05-29": 2.8115449999999997,
              "2026-05-30": 0.35210027777777775,
              "2026-06-01": 4.0270447222222225,
              "2026-06-02": 202.7389538888889,
              "2026-06-08": 1.6237697222222223
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-07": 3,
              "2025-10-09": 1,
              "2025-10-13": 7,
              "2025-10-14": 1,
              "2025-10-15": 7,
              "2025-10-17": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-25": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-31": 2,
              "2025-11-03": 2,
              "2025-11-05": 3,
              "2025-11-11": 2,
              "2025-11-12": 3,
              "2025-11-19": 5,
              "2025-11-20": 2,
              "2025-11-21": 3,
              "2025-11-22": 2,
              "2025-11-23": 1,
              "2025-11-25": 1,
              "2025-12-02": 1,
              "2025-12-03": 6,
              "2025-12-05": 1,
              "2025-12-08": 1,
              "2025-12-09": 1,
              "2025-12-10": 5,
              "2025-12-12": 1,
              "2025-12-15": 11,
              "2025-12-18": 2,
              "2025-12-20": 1,
              "2025-12-22": 3,
              "2025-12-23": 1,
              "2025-12-26": 1,
              "2025-12-29": 2,
              "2026-01-03": 1,
              "2026-01-08": 2,
              "2026-01-09": 2,
              "2026-01-15": 1,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 3,
              "2026-02-03": 1,
              "2026-02-06": 6,
              "2026-02-10": 10,
              "2026-02-12": 5,
              "2026-02-13": 5,
              "2026-02-14": 2,
              "2026-02-17": 1,
              "2026-02-18": 4,
              "2026-02-19": 17,
              "2026-02-20": 1,
              "2026-02-21": 8,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-02-28": 2,
              "2026-03-03": 1,
              "2026-03-07": 1,
              "2026-03-10": 5,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-17": 4,
              "2026-03-18": 6,
              "2026-03-19": 2,
              "2026-03-26": 9,
              "2026-03-27": 1,
              "2026-03-31": 2,
              "2026-04-01": 7,
              "2026-04-02": 6,
              "2026-04-04": 1,
              "2026-04-06": 6,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-13": 2,
              "2026-04-14": 1,
              "2026-04-20": 4,
              "2026-04-21": 2,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-27": 3,
              "2026-04-30": 1,
              "2026-05-04": 4,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 4,
              "2026-05-08": 2,
              "2026-05-11": 7,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-16": 2,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-25": 5,
              "2026-05-26": 1,
              "2026-05-27": 2,
              "2026-05-28": 3,
              "2026-05-29": 2,
              "2026-05-30": 1,
              "2026-06-01": 1,
              "2026-06-02": 2,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 31.17,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "54-56h": 1,
                "56-58h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-19": 1,
                "2026-01-20": 1,
                "2026-04-06": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-11-19": 5.7333694444444445,
                "2026-01-20": 55.654672777777776,
                "2026-04-06": 6.578388611111111,
                "2026-05-25": 56.71292527777778
              },
              "time_count_per_day": {
                "2025-11-19": 1,
                "2026-01-20": 1,
                "2026-04-06": 1,
                "2026-05-25": 1
              }
            },
            "P2": {
              "avg_time_hours": 12.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 104,
              "time_distribution": {
                "0-2h": 104,
                "2-4h": 16,
                "4-6h": 4,
                "6-8h": 4,
                "8-10h": 2,
                "10-12h": 4,
                "12-14h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "30-32h": 2,
                "42-44h": 1,
                "52-54h": 1,
                "76-78h": 2,
                "78-80h": 1,
                "108-110h": 1,
                "122-124h": 1,
                "200-202h": 1,
                "354-356h": 1,
                "408-410h": 1
              },
              "tickets_count": 149,
              "tickets_per_day": {
                "2025-10-15": 2,
                "2025-10-17": 1,
                "2025-10-28": 1,
                "2025-11-19": 2,
                "2025-11-21": 1,
                "2025-12-03": 1,
                "2025-12-08": 1,
                "2025-12-10": 3,
                "2025-12-15": 3,
                "2025-12-22": 1,
                "2025-12-23": 1,
                "2025-12-29": 2,
                "2026-01-03": 1,
                "2026-01-09": 1,
                "2026-01-15": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-02-13": 2,
                "2026-02-14": 2,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-21": 5,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-07": 1,
                "2026-03-10": 5,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-19": 2,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-31": 2,
                "2026-04-01": 7,
                "2026-04-02": 6,
                "2026-04-04": 1,
                "2026-04-06": 5,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-13": 2,
                "2026-04-14": 1,
                "2026-04-20": 4,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-27": 3,
                "2026-04-30": 1,
                "2026-05-04": 4,
                "2026-05-05": 5,
                "2026-05-06": 5,
                "2026-05-07": 4,
                "2026-05-08": 2,
                "2026-05-11": 7,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-16": 2,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-25": 4,
                "2026-05-26": 1,
                "2026-05-27": 2,
                "2026-05-28": 3,
                "2026-05-29": 2,
                "2026-05-30": 1,
                "2026-06-01": 1,
                "2026-06-02": 2,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-15": 1.2022905555555556,
                "2025-10-17": 1.4272766666666667,
                "2025-10-28": 354.0095219444445,
                "2025-11-19": 130.49367833333332,
                "2025-11-21": 1.1167194444444444,
                "2025-12-03": 3.540503888888889,
                "2025-12-08": 4.968939722222222,
                "2025-12-10": 3.0973683333333337,
                "2025-12-15": 0.25015,
                "2025-12-22": 1.7217277777777777,
                "2025-12-23": 1.5074008333333333,
                "2025-12-29": 10.986420277777778,
                "2026-01-03": 0.7922186111111111,
                "2026-01-09": 409.9502572222222,
                "2026-01-15": 8.333137222222224,
                "2026-01-20": 31.953178611111113,
                "2026-01-21": 22.750493055555555,
                "2026-01-23": 0.06407861111111111,
                "2026-01-26": 1.4117863888888889,
                "2026-01-27": 79.94882944444446,
                "2026-02-13": 3.444682777777778,
                "2026-02-14": 0.4978694444444444,
                "2026-02-19": 122.09595138888889,
                "2026-02-20": 0.042763333333333334,
                "2026-02-21": 2.4466108333333336,
                "2026-02-24": 11.812933888888889,
                "2026-03-03": 1.0329944444444445,
                "2026-03-07": 1.4992966666666667,
                "2026-03-10": 8.607306388888889,
                "2026-03-12": 1.7546247222222222,
                "2026-03-13": 0.5632325,
                "2026-03-16": 0.40735944444444444,
                "2026-03-17": 8.988806666666667,
                "2026-03-18": 0.9748955555555555,
                "2026-03-19": 1.348843888888889,
                "2026-03-26": 6.048633888888888,
                "2026-03-27": 0.5333927777777777,
                "2026-03-31": 1.7602280555555556,
                "2026-04-01": 46.80364,
                "2026-04-02": 28.70897527777778,
                "2026-04-04": 42.067433888888885,
                "2026-04-06": 7.0124125,
                "2026-04-07": 0.7159202777777778,
                "2026-04-08": 1.0198283333333333,
                "2026-04-10": 1.3259986111111113,
                "2026-04-13": 0.6201230555555556,
                "2026-04-14": 1.7177469444444444,
                "2026-04-20": 1.293745,
                "2026-04-21": 1.2518755555555556,
                "2026-04-22": 0.12097722222222221,
                "2026-04-23": 1.339748611111111,
                "2026-04-27": 80.94238055555554,
                "2026-04-30": 1.016265,
                "2026-05-04": 2.7440475,
                "2026-05-05": 6.478658888888888,
                "2026-05-06": 3.3188016666666664,
                "2026-05-07": 30.598537777777782,
                "2026-05-08": 31.96392833333333,
                "2026-05-11": 16.6627325,
                "2026-05-12": 108.58553888888889,
                "2026-05-14": 1.3116555555555556,
                "2026-05-15": 0.3178352777777778,
                "2026-05-16": 0.23889472222222222,
                "2026-05-20": 1.1473638888888888,
                "2026-05-21": 0.3150530555555556,
                "2026-05-25": 3.6985030555555554,
                "2026-05-26": 0.1972386111111111,
                "2026-05-27": 3.5619294444444445,
                "2026-05-28": 4.7967611111111115,
                "2026-05-29": 2.8115449999999997,
                "2026-05-30": 0.35210027777777775,
                "2026-06-01": 4.0270447222222225,
                "2026-06-02": 202.7389538888889,
                "2026-06-08": 1.6237697222222223
              },
              "time_count_per_day": {
                "2025-10-15": 2,
                "2025-10-17": 1,
                "2025-10-28": 1,
                "2025-11-19": 2,
                "2025-11-21": 1,
                "2025-12-03": 1,
                "2025-12-08": 1,
                "2025-12-10": 3,
                "2025-12-15": 3,
                "2025-12-22": 1,
                "2025-12-23": 1,
                "2025-12-29": 2,
                "2026-01-03": 1,
                "2026-01-09": 1,
                "2026-01-15": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-02-13": 2,
                "2026-02-14": 2,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-21": 5,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-07": 1,
                "2026-03-10": 5,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-19": 2,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-31": 2,
                "2026-04-01": 7,
                "2026-04-02": 6,
                "2026-04-04": 1,
                "2026-04-06": 5,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-13": 2,
                "2026-04-14": 1,
                "2026-04-20": 4,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-27": 3,
                "2026-04-30": 1,
                "2026-05-04": 4,
                "2026-05-05": 5,
                "2026-05-06": 5,
                "2026-05-07": 4,
                "2026-05-08": 2,
                "2026-05-11": 7,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-16": 2,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-25": 4,
                "2026-05-26": 1,
                "2026-05-27": 2,
                "2026-05-28": 3,
                "2026-05-29": 2,
                "2026-05-30": 1,
                "2026-06-01": 1,
                "2026-06-02": 2,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 202.74,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "4-6h": 1,
                "8-10h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "44-46h": 1,
                "100-102h": 1,
                "150-152h": 2,
                "166-168h": 1,
                "184-186h": 1,
                "192-194h": 2,
                "332-334h": 1,
                "336-338h": 2,
                "448-450h": 1,
                "462-464h": 1,
                "504-506h": 2,
                "538-540h": 2
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-11-19": 1,
                "2025-11-21": 1,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-18": 2,
                "2025-12-22": 1,
                "2026-02-06": 2,
                "2026-02-10": 9,
                "2026-02-12": 2,
                "2026-02-13": 3
              },
              "time_per_day": {
                "2025-09-30": 0.699281111111111,
                "2025-10-07": 100.66653,
                "2025-10-15": 45.73987916666667,
                "2025-11-19": 0.9157702777777779,
                "2025-11-21": 18.580653055555555,
                "2025-12-10": 9.213739444444444,
                "2025-12-12": 5.872123055555556,
                "2025-12-18": 0.5797427777777777,
                "2025-12-22": 166.72237055555556,
                "2026-02-06": 384.64594805555555,
                "2026-02-10": 3233.524673888888,
                "2026-02-12": 1076.7851833333334,
                "2026-02-13": 227.34877194444445
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-11-19": 1,
                "2025-11-21": 1,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-18": 2,
                "2025-12-22": 1,
                "2026-02-06": 2,
                "2026-02-10": 9,
                "2026-02-12": 2,
                "2026-02-13": 3
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 136.72,
              "mode_time_hours": 51.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 4,
                "4-6h": 3,
                "6-8h": 1,
                "8-10h": 1,
                "16-18h": 1,
                "18-20h": 2,
                "22-24h": 3,
                "24-26h": 3,
                "26-28h": 3,
                "30-32h": 1,
                "36-38h": 2,
                "40-42h": 1,
                "42-44h": 2,
                "44-46h": 2,
                "48-50h": 2,
                "50-52h": 9,
                "52-54h": 1,
                "54-56h": 1,
                "60-62h": 2,
                "62-64h": 1,
                "70-72h": 1,
                "78-80h": 3,
                "94-96h": 1,
                "96-98h": 4,
                "102-104h": 1,
                "104-106h": 2,
                "106-108h": 2,
                "120-122h": 3,
                "122-124h": 1,
                "124-126h": 1,
                "134-136h": 2,
                "140-142h": 2,
                "142-144h": 2,
                "144-146h": 2,
                "148-150h": 1,
                "152-154h": 1,
                "314-316h": 1,
                "342-344h": 1,
                "366-368h": 1,
                "372-374h": 1,
                "392-394h": 1,
                "416-418h": 1,
                "476-478h": 1,
                "502-504h": 2,
                "508-510h": 1,
                "582-584h": 1,
                "598-600h": 1,
                "678-680h": 1,
                "690-692h": 1,
                "700-702h": 1
              },
              "tickets_count": 90,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-13": 7,
                "2025-10-14": 1,
                "2025-10-15": 4,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-25": 1,
                "2025-10-27": 1,
                "2025-10-31": 2,
                "2025-11-03": 2,
                "2025-11-05": 3,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-19": 1,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-22": 2,
                "2025-11-23": 1,
                "2025-11-25": 1,
                "2025-12-02": 1,
                "2025-12-03": 5,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-15": 5,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-08": 2,
                "2026-01-09": 1,
                "2026-01-27": 1,
                "2026-02-06": 4,
                "2026-02-10": 1,
                "2026-02-12": 3,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 3,
                "2026-02-23": 1,
                "2026-02-28": 2,
                "2026-03-17": 2,
                "2026-03-18": 5,
                "2026-03-26": 8
              },
              "time_per_day": {
                "2025-10-07": 111.41291361111111,
                "2025-10-09": 41.029045833333335,
                "2025-10-13": 722.74511,
                "2025-10-14": 25.396378333333335,
                "2025-10-15": 112.44739611111112,
                "2025-10-22": 121.48236305555555,
                "2025-10-23": 18.021049444444444,
                "2025-10-25": 62.87988805555556,
                "2025-10-27": 5.515646944444445,
                "2025-10-31": 215.06064583333335,
                "2025-11-03": 10.490560833333333,
                "2025-11-05": 120.48810194444445,
                "2025-11-11": 193.67877611111112,
                "2025-11-12": 79.89401388888889,
                "2025-11-19": 104.62137472222223,
                "2025-11-20": 79.86287694444445,
                "2025-11-21": 55.23824611111111,
                "2025-11-22": 87.93168861111113,
                "2025-11-23": 25.912654166666666,
                "2025-11-25": 149.89087194444443,
                "2025-12-02": 315.18753194444446,
                "2025-12-03": 878.8020158333333,
                "2025-12-05": 78.31860833333333,
                "2025-12-09": 143.47520277777778,
                "2025-12-10": 25.96316138888889,
                "2025-12-15": 226.08665666666667,
                "2025-12-22": 50.48950361111111,
                "2025-12-26": 61.554855555555555,
                "2026-01-08": 26.567760555555555,
                "2026-01-09": 153.12659416666665,
                "2026-01-27": 122.83056722222223,
                "2026-02-06": 879.268071388889,
                "2026-02-10": 509.2946777777778,
                "2026-02-12": 152.15723944444443,
                "2026-02-18": 678.8836433333333,
                "2026-02-19": 71.00617777777778,
                "2026-02-21": 10.398257777777777,
                "2026-02-23": 8.04192138888889,
                "2026-02-28": 104.81895694444444,
                "2026-03-17": 74.84957944444444,
                "2026-03-18": 1751.376851388889,
                "2026-03-26": 3638.008496944445
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-13": 7,
                "2025-10-14": 1,
                "2025-10-15": 4,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-25": 1,
                "2025-10-27": 1,
                "2025-10-31": 2,
                "2025-11-03": 2,
                "2025-11-05": 3,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-19": 1,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-22": 2,
                "2025-11-23": 1,
                "2025-11-25": 1,
                "2025-12-02": 1,
                "2025-12-03": 5,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-15": 5,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-08": 2,
                "2026-01-09": 1,
                "2026-01-27": 1,
                "2026-02-06": 4,
                "2026-02-10": 1,
                "2026-02-12": 3,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 3,
                "2026-02-23": 1,
                "2026-02-28": 2,
                "2026-03-17": 2,
                "2026-03-18": 5,
                "2026-03-26": 8
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 732.09,
              "mode_time_hours": 1839.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 1,
                "20-22h": 1,
                "22-24h": 2,
                "206-208h": 1,
                "230-232h": 1,
                "258-260h": 1,
                "288-290h": 1,
                "360-362h": 1,
                "442-444h": 1,
                "666-668h": 1,
                "672-674h": 1,
                "682-684h": 2,
                "692-694h": 2,
                "912-914h": 1,
                "1080-1082h": 1,
                "1100-1102h": 1,
                "1124-1126h": 1,
                "1230-1232h": 1,
                "1344-1346h": 1,
                "1838-1840h": 2,
                "1862-1864h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-12-15": 3,
                "2025-12-20": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-17": 1,
                "2026-02-18": 3,
                "2026-02-19": 15
              },
              "time_per_day": {
                "2025-12-15": 67.86215472222221,
                "2025-12-20": 258.72006055555556,
                "2026-01-27": 9.998159444444445,
                "2026-02-03": 1230.685456111111,
                "2026-02-17": 442.07610861111107,
                "2026-02-18": 5023.855334166667,
                "2026-02-19": 11268.958045833335
              },
              "time_count_per_day": {
                "2025-12-15": 3,
                "2025-12-20": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-17": 1,
                "2026-02-18": 3,
                "2026-02-19": 15
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 23,
            "tickets_per_day": {
              "2026-02-20": 1,
              "2026-03-04": 1,
              "2026-03-10": 2,
              "2026-03-11": 1,
              "2026-03-31": 1,
              "2026-04-15": 3,
              "2026-04-27": 2,
              "2026-05-04": 1,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-09": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 21,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-03-10": 2,
                "2026-03-31": 1,
                "2026-04-15": 3,
                "2026-04-27": 2,
                "2026-05-04": 1,
                "2026-05-05": 2,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-20": 1,
                "2026-05-25": 2,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-20": 1,
                "2026-03-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_36": {
      "overall": {
        "avg_time_hours": 59.96,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "6-8h": 1,
          "52-54h": 1,
          "174-176h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-14": 1,
          "2025-11-11": 1,
          "2026-01-19": 1
        },
        "time_per_day": {
          "2025-09-30": 7.951079722222222,
          "2025-10-14": 174.40907361111113,
          "2025-11-11": 53.35391694444444,
          "2026-01-19": 4.123653055555556
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-14": 1,
          "2025-11-11": 1,
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 53.35,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "52-54h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-11": 1
          },
          "time_per_day": {
            "2025-11-11": 53.35391694444444
          },
          "time_count_per_day": {
            "2025-11-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.04,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2026-01-19": 1
          },
          "time_per_day": {
            "2025-09-30": 7.951079722222222,
            "2026-01-19": 4.123653055555556
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2026-01-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 174.41,
          "mode_time_hours": 175.0,
          "mode_frequency": 1,
          "time_distribution": {
            "174-176h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-14": 1
          },
          "time_per_day": {
            "2025-10-14": 174.40907361111113
          },
          "time_count_per_day": {
            "2025-10-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 59.96,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "6-8h": 1,
              "52-54h": 1,
              "174-176h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-14": 1,
              "2025-11-11": 1,
              "2026-01-19": 1
            },
            "time_per_day": {
              "2025-09-30": 7.951079722222222,
              "2025-10-14": 174.40907361111113,
              "2025-11-11": 53.35391694444444,
              "2026-01-19": 4.123653055555556
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-14": 1,
              "2025-11-11": 1,
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 53.35,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "52-54h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-11": 1
              },
              "time_per_day": {
                "2025-11-11": 53.35391694444444
              },
              "time_count_per_day": {
                "2025-11-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.04,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2026-01-19": 1
              },
              "time_per_day": {
                "2025-09-30": 7.951079722222222,
                "2026-01-19": 4.123653055555556
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2026-01-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 174.41,
              "mode_time_hours": 175.0,
              "mode_frequency": 1,
              "time_distribution": {
                "174-176h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-14": 1
              },
              "time_per_day": {
                "2025-10-14": 174.40907361111113
              },
              "time_count_per_day": {
                "2025-10-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_37": {
      "overall": {
        "avg_time_hours": 58.77,
        "mode_time_hours": 3.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 4,
          "8-10h": 1,
          "56-58h": 1,
          "390-392h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-12-03": 1,
          "2026-01-12": 2,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-03-02": 1,
          "2026-04-17": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-09-30": 1.9131069444444446,
          "2025-12-03": 57.15152277777778,
          "2026-01-12": 6.708801111111111,
          "2026-01-14": 2.8249480555555557,
          "2026-01-23": 391.0116752777778,
          "2026-04-17": 2.110351388888889,
          "2026-06-01": 8.469465
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-12-03": 1,
          "2026-01-12": 2,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-04-17": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 101.1,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "8-10h": 1,
            "390-392h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-04-17": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-01-14": 2.8249480555555557,
            "2026-01-23": 391.0116752777778,
            "2026-04-17": 2.110351388888889,
            "2026-06-01": 8.469465
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-04-17": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 2.87,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2026-01-12": 2
          },
          "time_per_day": {
            "2025-09-30": 1.9131069444444446,
            "2026-01-12": 6.708801111111111
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2026-01-12": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 57.15,
          "mode_time_hours": 57.0,
          "mode_frequency": 1,
          "time_distribution": {
            "56-58h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2026-03-02": 1
          },
          "time_per_day": {
            "2025-12-03": 57.15152277777778
          },
          "time_count_per_day": {
            "2025-12-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 58.77,
            "mode_time_hours": 3.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 4,
              "8-10h": 1,
              "56-58h": 1,
              "390-392h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-12-03": 1,
              "2026-01-12": 2,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-04-17": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-09-30": 1.9131069444444446,
              "2025-12-03": 57.15152277777778,
              "2026-01-12": 6.708801111111111,
              "2026-01-14": 2.8249480555555557,
              "2026-01-23": 391.0116752777778,
              "2026-04-17": 2.110351388888889,
              "2026-06-01": 8.469465
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-12-03": 1,
              "2026-01-12": 2,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-04-17": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 101.1,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "8-10h": 1,
                "390-392h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-04-17": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-01-14": 2.8249480555555557,
                "2026-01-23": 391.0116752777778,
                "2026-04-17": 2.110351388888889,
                "2026-06-01": 8.469465
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-04-17": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 2.87,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2026-01-12": 2
              },
              "time_per_day": {
                "2025-09-30": 1.9131069444444446,
                "2026-01-12": 6.708801111111111
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2026-01-12": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 57.15,
              "mode_time_hours": 57.0,
              "mode_frequency": 1,
              "time_distribution": {
                "56-58h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-12-03": 57.15152277777778
              },
              "time_count_per_day": {
                "2025-12-03": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_39": {
      "overall": {
        "avg_time_hours": 242.43,
        "mode_time_hours": 243.0,
        "mode_frequency": 1,
        "time_distribution": {
          "242-244h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-10": 1
        },
        "time_per_day": {
          "2025-10-10": 242.43415444444446
        },
        "time_count_per_day": {
          "2025-10-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 242.43,
          "mode_time_hours": 243.0,
          "mode_frequency": 1,
          "time_distribution": {
            "242-244h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-10": 1
          },
          "time_per_day": {
            "2025-10-10": 242.43415444444446
          },
          "time_count_per_day": {
            "2025-10-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 242.43,
            "mode_time_hours": 243.0,
            "mode_frequency": 1,
            "time_distribution": {
              "242-244h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-10": 1
            },
            "time_per_day": {
              "2025-10-10": 242.43415444444446
            },
            "time_count_per_day": {
              "2025-10-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 242.43,
              "mode_time_hours": 243.0,
              "mode_frequency": 1,
              "time_distribution": {
                "242-244h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-10": 1
              },
              "time_per_day": {
                "2025-10-10": 242.43415444444446
              },
              "time_count_per_day": {
                "2025-10-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_41": {
      "overall": {
        "avg_time_hours": 128.9,
        "mode_time_hours": 1.0,
        "mode_frequency": 75,
        "time_distribution": {
          "0-2h": 75,
          "2-4h": 24,
          "4-6h": 10,
          "6-8h": 6,
          "8-10h": 3,
          "10-12h": 2,
          "12-14h": 4,
          "14-16h": 1,
          "18-20h": 7,
          "20-22h": 3,
          "22-24h": 5,
          "24-26h": 3,
          "26-28h": 4,
          "28-30h": 4,
          "30-32h": 12,
          "32-34h": 4,
          "34-36h": 2,
          "36-38h": 3,
          "38-40h": 1,
          "40-42h": 3,
          "42-44h": 1,
          "44-46h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "54-56h": 1,
          "60-62h": 2,
          "64-66h": 1,
          "70-72h": 1,
          "76-78h": 1,
          "78-80h": 1,
          "80-82h": 1,
          "84-86h": 1,
          "92-94h": 1,
          "94-96h": 2,
          "96-98h": 1,
          "110-112h": 1,
          "114-116h": 1,
          "124-126h": 1,
          "126-128h": 1,
          "128-130h": 1,
          "134-136h": 1,
          "144-146h": 1,
          "160-162h": 2,
          "166-168h": 3,
          "180-182h": 1,
          "184-186h": 1,
          "196-198h": 2,
          "210-212h": 1,
          "216-218h": 3,
          "218-220h": 1,
          "234-236h": 1,
          "264-266h": 1,
          "276-278h": 1,
          "304-306h": 1,
          "328-330h": 1,
          "330-332h": 1,
          "332-334h": 1,
          "334-336h": 1,
          "352-354h": 1,
          "362-364h": 1,
          "370-372h": 3,
          "382-384h": 2,
          "398-400h": 2,
          "400-402h": 1,
          "402-404h": 1,
          "404-406h": 3,
          "414-416h": 1,
          "430-432h": 1,
          "438-440h": 1,
          "442-444h": 1,
          "450-452h": 1,
          "478-480h": 4,
          "480-482h": 1,
          "496-498h": 2,
          "498-500h": 1,
          "502-504h": 1,
          "546-548h": 1,
          "552-554h": 1,
          "564-566h": 1,
          "602-604h": 1,
          "650-652h": 1,
          "656-658h": 1,
          "666-668h": 1,
          "668-670h": 1,
          "690-692h": 1,
          "710-712h": 1,
          "734-736h": 3,
          "842-844h": 1,
          "966-968h": 1,
          "982-984h": 2,
          "1412-1414h": 1
        },
        "tickets_count": 289,
        "tickets_per_day": {
          "2025-09-30": 2,
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-22": 3,
          "2025-10-29": 2,
          "2025-10-30": 1,
          "2025-11-05": 1,
          "2025-11-10": 1,
          "2025-11-14": 1,
          "2025-11-21": 1,
          "2025-11-22": 4,
          "2025-12-04": 1,
          "2025-12-05": 1,
          "2025-12-11": 1,
          "2025-12-15": 2,
          "2025-12-18": 1,
          "2025-12-19": 1,
          "2026-01-09": 2,
          "2026-01-13": 2,
          "2026-01-15": 2,
          "2026-01-30": 3,
          "2026-02-02": 2,
          "2026-02-03": 1,
          "2026-02-04": 3,
          "2026-02-06": 3,
          "2026-02-09": 3,
          "2026-02-10": 6,
          "2026-02-17": 2,
          "2026-02-18": 2,
          "2026-02-19": 15,
          "2026-02-26": 1,
          "2026-02-28": 5,
          "2026-03-02": 4,
          "2026-03-03": 2,
          "2026-03-05": 2,
          "2026-03-09": 2,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-16": 1,
          "2026-03-17": 24,
          "2026-03-18": 40,
          "2026-03-20": 2,
          "2026-03-21": 1,
          "2026-03-23": 5,
          "2026-03-24": 5,
          "2026-03-26": 4,
          "2026-03-28": 1,
          "2026-03-30": 2,
          "2026-03-31": 2,
          "2026-04-01": 2,
          "2026-04-07": 1,
          "2026-04-08": 3,
          "2026-04-09": 7,
          "2026-04-10": 8,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-04-20": 3,
          "2026-04-21": 2,
          "2026-04-22": 4,
          "2026-04-27": 1,
          "2026-04-28": 3,
          "2026-05-02": 2,
          "2026-05-04": 5,
          "2026-05-05": 1,
          "2026-05-06": 3,
          "2026-05-07": 4,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 6,
          "2026-05-12": 2,
          "2026-05-13": 6,
          "2026-05-14": 9,
          "2026-05-19": 2,
          "2026-05-21": 4,
          "2026-05-22": 3,
          "2026-05-25": 3,
          "2026-05-26": 2,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-06-02": 1,
          "2026-06-05": 4,
          "2026-06-06": 7
        },
        "time_per_day": {
          "2025-09-30": 6.0122816666666665,
          "2025-10-07": 20.21378861111111,
          "2025-10-09": 49.80916833333333,
          "2025-10-10": 3.9933858333333334,
          "2025-10-13": 166.3261425,
          "2025-10-22": 192.72703,
          "2025-10-29": 148.37568722222224,
          "2025-10-30": 1.8186933333333335,
          "2025-11-05": 42.840990833333336,
          "2025-11-10": 3.118009166666667,
          "2025-11-14": 219.60796222222223,
          "2025-11-21": 5.218376111111111,
          "2025-11-22": 96.9876036111111,
          "2025-12-04": 0.42080805555555556,
          "2025-12-05": 0.5482897222222223,
          "2025-12-11": 305.67023805555556,
          "2025-12-15": 668.8802225,
          "2025-12-18": 5.112048888888889,
          "2025-12-19": 363.0000025,
          "2026-01-09": 13.325439166666666,
          "2026-01-13": 25.688715000000002,
          "2026-01-15": 75.6127238888889,
          "2026-01-30": 8.818456944444444,
          "2026-02-02": 124.18986916666667,
          "2026-02-03": 276.9323430555556,
          "2026-02-04": 371.69344083333334,
          "2026-02-06": 470.41752722222225,
          "2026-02-09": 92.10517583333333,
          "2026-02-10": 955.6482111111112,
          "2026-02-17": 1095.391215,
          "2026-02-18": 5.42693,
          "2026-02-19": 8322.376858611111,
          "2026-02-26": 0.3073458333333333,
          "2026-02-28": 263.5375080555556,
          "2026-03-02": 85.44579083333333,
          "2026-03-03": 13.491353888888888,
          "2026-03-05": 4.122792222222222,
          "2026-03-09": 3.5902966666666667,
          "2026-03-11": 0.5999638888888889,
          "2026-03-12": 0.1728438888888889,
          "2026-03-16": 0.12464805555555555,
          "2026-03-17": 733.7416658333335,
          "2026-03-18": 11074.352964166672,
          "2026-03-20": 56.12177055555556,
          "2026-03-21": 0.5897047222222221,
          "2026-03-23": 4.073246666666666,
          "2026-03-24": 920.4861047222221,
          "2026-03-26": 3535.054629444444,
          "2026-03-30": 70.0080375,
          "2026-03-31": 1.9476155555555557,
          "2026-04-01": 3.4465233333333334,
          "2026-04-07": 0.211855,
          "2026-04-08": 19.64697888888889,
          "2026-04-09": 31.247343333333333,
          "2026-04-10": 116.32229944444445,
          "2026-04-11": 0.9075822222222222,
          "2026-04-13": 1.6771825,
          "2026-04-15": 0.007180833333333333,
          "2026-04-16": 0.08210333333333333,
          "2026-04-17": 0.008290277777777777,
          "2026-04-18": 12.609203055555556,
          "2026-04-20": 2.235083611111111,
          "2026-04-21": 0.10118694444444444,
          "2026-04-22": 426.80049444444444,
          "2026-04-27": 0.11136833333333333,
          "2026-04-28": 4.191473888888889,
          "2026-05-02": 44.482755833333336,
          "2026-05-04": 884.0034966666666,
          "2026-05-06": 3.189002222222222,
          "2026-05-07": 4.8303569444444445,
          "2026-05-08": 4.288792222222223,
          "2026-05-09": 124.67282777777777,
          "2026-05-11": 8.36736638888889,
          "2026-05-12": 0.11981222222222222,
          "2026-05-13": 21.583765,
          "2026-05-14": 1449.721297777778,
          "2026-05-19": 0.12022694444444444,
          "2026-05-21": 89.9539136111111,
          "2026-05-22": 32.24729555555555,
          "2026-05-25": 2.6497175,
          "2026-05-26": 5.056611111111112,
          "2026-05-27": 0.9304702777777778,
          "2026-05-29": 55.18523722222222,
          "2026-06-02": 0.4168741666666667,
          "2026-06-05": 8.327665555555555,
          "2026-06-06": 409.4212694444445
        },
        "time_count_per_day": {
          "2025-09-30": 2,
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-22": 3,
          "2025-10-29": 2,
          "2025-10-30": 1,
          "2025-11-05": 1,
          "2025-11-10": 1,
          "2025-11-14": 1,
          "2025-11-21": 1,
          "2025-11-22": 4,
          "2025-12-04": 1,
          "2025-12-05": 1,
          "2025-12-11": 1,
          "2025-12-15": 2,
          "2025-12-18": 1,
          "2025-12-19": 1,
          "2026-01-09": 2,
          "2026-01-13": 2,
          "2026-01-15": 2,
          "2026-01-30": 3,
          "2026-02-02": 2,
          "2026-02-03": 1,
          "2026-02-04": 3,
          "2026-02-06": 3,
          "2026-02-09": 3,
          "2026-02-10": 6,
          "2026-02-17": 2,
          "2026-02-18": 2,
          "2026-02-19": 15,
          "2026-02-26": 1,
          "2026-02-28": 5,
          "2026-03-02": 4,
          "2026-03-03": 2,
          "2026-03-05": 2,
          "2026-03-09": 2,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-16": 1,
          "2026-03-17": 24,
          "2026-03-18": 40,
          "2026-03-20": 2,
          "2026-03-21": 1,
          "2026-03-23": 5,
          "2026-03-24": 5,
          "2026-03-26": 4,
          "2026-03-30": 1,
          "2026-03-31": 2,
          "2026-04-01": 2,
          "2026-04-07": 1,
          "2026-04-08": 3,
          "2026-04-09": 7,
          "2026-04-10": 8,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-04-20": 3,
          "2026-04-21": 2,
          "2026-04-22": 4,
          "2026-04-27": 1,
          "2026-04-28": 2,
          "2026-05-02": 2,
          "2026-05-04": 5,
          "2026-05-06": 1,
          "2026-05-07": 4,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 6,
          "2026-05-12": 1,
          "2026-05-13": 3,
          "2026-05-14": 8,
          "2026-05-19": 1,
          "2026-05-21": 3,
          "2026-05-22": 3,
          "2026-05-25": 3,
          "2026-05-26": 2,
          "2026-05-27": 1,
          "2026-05-29": 2,
          "2026-06-02": 1,
          "2026-06-05": 2,
          "2026-06-06": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 53.01,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "50-52h": 1,
            "84-86h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-04-09": 1,
            "2026-05-12": 1,
            "2026-05-21": 1,
            "2026-05-28": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-04-09": 24.582395,
            "2026-05-21": 84.29436861111111,
            "2026-05-29": 50.160133055555555
          },
          "time_count_per_day": {
            "2026-04-09": 1,
            "2026-05-21": 1,
            "2026-05-29": 1
          }
        },
        "P2": {
          "avg_time_hours": 19.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 71,
          "time_distribution": {
            "0-2h": 71,
            "2-4h": 22,
            "4-6h": 6,
            "6-8h": 5,
            "8-10h": 1,
            "12-14h": 4,
            "14-16h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 5,
            "24-26h": 1,
            "26-28h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "48-50h": 1,
            "124-126h": 1,
            "218-220h": 1,
            "656-658h": 1,
            "842-844h": 1
          },
          "tickets_count": 130,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-11-14": 1,
            "2025-12-05": 1,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-30": 2,
            "2026-02-09": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-03": 2,
            "2026-03-05": 2,
            "2026-03-09": 2,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-21": 1,
            "2026-03-23": 5,
            "2026-03-24": 1,
            "2026-03-31": 2,
            "2026-04-01": 2,
            "2026-04-07": 1,
            "2026-04-08": 3,
            "2026-04-09": 6,
            "2026-04-10": 8,
            "2026-04-11": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-04-20": 3,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-27": 1,
            "2026-04-28": 2,
            "2026-05-02": 2,
            "2026-05-04": 5,
            "2026-05-06": 1,
            "2026-05-07": 4,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 6,
            "2026-05-12": 1,
            "2026-05-13": 5,
            "2026-05-14": 8,
            "2026-05-19": 1,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-25": 3,
            "2026-05-26": 2,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-06": 2
          },
          "time_per_day": {
            "2025-10-10": 3.9933858333333334,
            "2025-11-14": 219.60796222222223,
            "2025-12-05": 0.5482897222222223,
            "2025-12-18": 5.112048888888889,
            "2026-01-13": 0.8329033333333334,
            "2026-01-15": 48.4858675,
            "2026-01-30": 8.772814722222222,
            "2026-02-09": 3.1970375,
            "2026-02-17": 657.0405455555556,
            "2026-02-18": 0.19496194444444445,
            "2026-02-26": 0.3073458333333333,
            "2026-02-28": 19.57252777777778,
            "2026-03-02": 44.64039444444444,
            "2026-03-03": 13.491353888888888,
            "2026-03-05": 4.122792222222222,
            "2026-03-09": 3.5902966666666667,
            "2026-03-11": 0.5999638888888889,
            "2026-03-12": 0.1728438888888889,
            "2026-03-16": 0.12464805555555555,
            "2026-03-17": 12.390272222222222,
            "2026-03-18": 7.510345,
            "2026-03-21": 0.5897047222222221,
            "2026-03-23": 4.073246666666666,
            "2026-03-24": 1.1690680555555557,
            "2026-03-31": 1.9476155555555557,
            "2026-04-01": 3.4465233333333334,
            "2026-04-07": 0.211855,
            "2026-04-08": 19.64697888888889,
            "2026-04-09": 6.664948333333333,
            "2026-04-10": 116.32229944444445,
            "2026-04-11": 0.9075822222222222,
            "2026-04-13": 1.6771825,
            "2026-04-15": 0.007180833333333333,
            "2026-04-16": 0.08210333333333333,
            "2026-04-17": 0.008290277777777777,
            "2026-04-18": 12.609203055555556,
            "2026-04-20": 2.235083611111111,
            "2026-04-21": 0.10118694444444444,
            "2026-04-22": 0.6000919444444445,
            "2026-04-27": 0.11136833333333333,
            "2026-04-28": 4.191473888888889,
            "2026-05-02": 44.482755833333336,
            "2026-05-04": 884.0034966666666,
            "2026-05-06": 3.189002222222222,
            "2026-05-07": 4.8303569444444445,
            "2026-05-08": 4.288792222222223,
            "2026-05-09": 124.67282777777777,
            "2026-05-11": 8.36736638888889,
            "2026-05-12": 0.11981222222222222,
            "2026-05-13": 21.583765,
            "2026-05-14": 36.18506611111111,
            "2026-05-19": 0.12022694444444444,
            "2026-05-21": 5.659545,
            "2026-05-22": 32.24729555555555,
            "2026-05-25": 2.6497175,
            "2026-05-26": 5.056611111111112,
            "2026-05-27": 0.9304702777777778,
            "2026-05-29": 5.025104166666667,
            "2026-06-02": 0.4168741666666667,
            "2026-06-05": 8.327665555555555,
            "2026-06-06": 27.30772361111111
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-11-14": 1,
            "2025-12-05": 1,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-30": 2,
            "2026-02-09": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-03": 2,
            "2026-03-05": 2,
            "2026-03-09": 2,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-18": 7,
            "2026-03-21": 1,
            "2026-03-23": 5,
            "2026-03-24": 1,
            "2026-03-31": 2,
            "2026-04-01": 2,
            "2026-04-07": 1,
            "2026-04-08": 3,
            "2026-04-09": 6,
            "2026-04-10": 8,
            "2026-04-11": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-04-20": 3,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-27": 1,
            "2026-04-28": 2,
            "2026-05-02": 2,
            "2026-05-04": 5,
            "2026-05-06": 1,
            "2026-05-07": 4,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 6,
            "2026-05-12": 1,
            "2026-05-13": 3,
            "2026-05-14": 7,
            "2026-05-19": 1,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-25": 3,
            "2026-05-26": 2,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-06": 2
          }
        },
        "P3": {
          "avg_time_hours": 70.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "6-8h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "30-32h": 1,
            "114-116h": 1,
            "382-384h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-12-04": 1,
            "2026-02-04": 1,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-09-30": 1.5781363888888889,
            "2025-12-04": 0.42080805555555556,
            "2026-02-04": 114.70182694444445,
            "2026-02-09": 8.013397222222222,
            "2026-02-10": 56.75903805555556,
            "2026-06-06": 382.1135458333333
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-12-04": 1,
            "2026-02-04": 1,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-06-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 192.06,
          "mode_time_hours": 31.0,
          "mode_frequency": 11,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "4-6h": 4,
            "8-10h": 1,
            "10-12h": 2,
            "18-20h": 5,
            "20-22h": 1,
            "24-26h": 1,
            "26-28h": 3,
            "28-30h": 4,
            "30-32h": 11,
            "32-34h": 4,
            "34-36h": 2,
            "36-38h": 3,
            "40-42h": 2,
            "42-44h": 1,
            "44-46h": 1,
            "48-50h": 1,
            "54-56h": 1,
            "60-62h": 2,
            "64-66h": 1,
            "70-72h": 1,
            "76-78h": 1,
            "78-80h": 1,
            "80-82h": 1,
            "92-94h": 1,
            "94-96h": 2,
            "96-98h": 1,
            "110-112h": 1,
            "126-128h": 1,
            "128-130h": 1,
            "134-136h": 1,
            "144-146h": 1,
            "160-162h": 2,
            "166-168h": 3,
            "180-182h": 1,
            "184-186h": 1,
            "196-198h": 2,
            "210-212h": 1,
            "216-218h": 3,
            "328-330h": 1,
            "332-334h": 1,
            "334-336h": 1,
            "352-354h": 1,
            "370-372h": 3,
            "382-384h": 1,
            "398-400h": 2,
            "400-402h": 1,
            "404-406h": 1,
            "414-416h": 1,
            "430-432h": 1,
            "442-444h": 1,
            "450-452h": 1,
            "478-480h": 2,
            "496-498h": 2,
            "498-500h": 1,
            "502-504h": 1,
            "546-548h": 1,
            "552-554h": 1,
            "602-604h": 1,
            "650-652h": 1,
            "966-968h": 1,
            "982-984h": 2,
            "1412-1414h": 1
          },
          "tickets_count": 125,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-22": 3,
            "2025-10-29": 2,
            "2025-10-30": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-21": 1,
            "2025-11-22": 4,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-04": 2,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-02-18": 1,
            "2026-02-28": 4,
            "2026-03-02": 1,
            "2026-03-17": 23,
            "2026-03-18": 33,
            "2026-03-20": 2,
            "2026-03-24": 4,
            "2026-03-26": 4,
            "2026-03-28": 1,
            "2026-03-30": 2,
            "2026-04-22": 3,
            "2026-04-28": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-06-05": 2,
            "2026-06-06": 4
          },
          "time_per_day": {
            "2025-09-30": 4.434145277777778,
            "2025-10-07": 20.21378861111111,
            "2025-10-09": 49.80916833333333,
            "2025-10-13": 166.3261425,
            "2025-10-22": 192.72703,
            "2025-10-29": 148.37568722222224,
            "2025-10-30": 1.8186933333333335,
            "2025-11-05": 42.840990833333336,
            "2025-11-10": 3.118009166666667,
            "2025-11-21": 5.218376111111111,
            "2025-11-22": 96.9876036111111,
            "2026-01-09": 13.325439166666666,
            "2026-01-13": 24.855811666666668,
            "2026-01-15": 27.12685638888889,
            "2026-01-30": 0.04564222222222222,
            "2026-02-02": 124.18986916666667,
            "2026-02-04": 256.9916138888889,
            "2026-02-06": 470.41752722222225,
            "2026-02-09": 80.89474111111112,
            "2026-02-10": 898.8891730555556,
            "2026-02-18": 5.231968055555555,
            "2026-02-28": 243.96498027777778,
            "2026-03-02": 40.80539638888889,
            "2026-03-17": 721.3513936111112,
            "2026-03-18": 11066.84261916667,
            "2026-03-20": 56.12177055555556,
            "2026-03-24": 919.3170366666666,
            "2026-03-26": 3535.054629444444,
            "2026-03-30": 70.0080375,
            "2026-04-22": 426.2004025,
            "2026-05-14": 1413.5362316666667
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-22": 3,
            "2025-10-29": 2,
            "2025-10-30": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-21": 1,
            "2025-11-22": 4,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-04": 2,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-10": 3,
            "2026-02-18": 1,
            "2026-02-28": 4,
            "2026-03-02": 1,
            "2026-03-17": 23,
            "2026-03-18": 33,
            "2026-03-20": 2,
            "2026-03-24": 4,
            "2026-03-26": 4,
            "2026-03-30": 1,
            "2026-04-22": 3,
            "2026-05-14": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 494.06,
          "mode_time_hours": 735.0,
          "mode_frequency": 3,
          "time_distribution": {
            "234-236h": 1,
            "264-266h": 1,
            "276-278h": 1,
            "304-306h": 1,
            "330-332h": 1,
            "362-364h": 1,
            "402-404h": 1,
            "404-406h": 2,
            "438-440h": 1,
            "478-480h": 2,
            "480-482h": 1,
            "564-566h": 1,
            "666-668h": 1,
            "668-670h": 1,
            "690-692h": 1,
            "710-712h": 1,
            "734-736h": 3
          },
          "tickets_count": 21,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2026-02-03": 1,
            "2026-02-17": 1,
            "2026-02-19": 15
          },
          "time_per_day": {
            "2025-12-11": 305.67023805555556,
            "2025-12-15": 668.8802225,
            "2025-12-19": 363.0000025,
            "2026-02-03": 276.9323430555556,
            "2026-02-17": 438.3506694444444,
            "2026-02-19": 8322.376858611111
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2026-02-03": 1,
            "2026-02-17": 1,
            "2026-02-19": 15
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 128.9,
            "mode_time_hours": 1.0,
            "mode_frequency": 75,
            "time_distribution": {
              "0-2h": 75,
              "2-4h": 24,
              "4-6h": 10,
              "6-8h": 6,
              "8-10h": 3,
              "10-12h": 2,
              "12-14h": 4,
              "14-16h": 1,
              "18-20h": 7,
              "20-22h": 3,
              "22-24h": 5,
              "24-26h": 3,
              "26-28h": 4,
              "28-30h": 4,
              "30-32h": 12,
              "32-34h": 4,
              "34-36h": 2,
              "36-38h": 3,
              "38-40h": 1,
              "40-42h": 3,
              "42-44h": 1,
              "44-46h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "54-56h": 1,
              "60-62h": 2,
              "64-66h": 1,
              "70-72h": 1,
              "76-78h": 1,
              "78-80h": 1,
              "80-82h": 1,
              "84-86h": 1,
              "92-94h": 1,
              "94-96h": 2,
              "96-98h": 1,
              "110-112h": 1,
              "114-116h": 1,
              "124-126h": 1,
              "126-128h": 1,
              "128-130h": 1,
              "134-136h": 1,
              "144-146h": 1,
              "160-162h": 2,
              "166-168h": 3,
              "180-182h": 1,
              "184-186h": 1,
              "196-198h": 2,
              "210-212h": 1,
              "216-218h": 3,
              "218-220h": 1,
              "234-236h": 1,
              "264-266h": 1,
              "276-278h": 1,
              "304-306h": 1,
              "328-330h": 1,
              "330-332h": 1,
              "332-334h": 1,
              "334-336h": 1,
              "352-354h": 1,
              "362-364h": 1,
              "370-372h": 3,
              "382-384h": 2,
              "398-400h": 2,
              "400-402h": 1,
              "402-404h": 1,
              "404-406h": 3,
              "414-416h": 1,
              "430-432h": 1,
              "438-440h": 1,
              "442-444h": 1,
              "450-452h": 1,
              "478-480h": 4,
              "480-482h": 1,
              "496-498h": 2,
              "498-500h": 1,
              "502-504h": 1,
              "546-548h": 1,
              "552-554h": 1,
              "564-566h": 1,
              "602-604h": 1,
              "650-652h": 1,
              "656-658h": 1,
              "666-668h": 1,
              "668-670h": 1,
              "690-692h": 1,
              "710-712h": 1,
              "734-736h": 3,
              "842-844h": 1,
              "966-968h": 1,
              "982-984h": 2,
              "1412-1414h": 1
            },
            "tickets_count": 269,
            "tickets_per_day": {
              "2025-09-30": 2,
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-22": 3,
              "2025-10-29": 2,
              "2025-10-30": 1,
              "2025-11-05": 1,
              "2025-11-10": 1,
              "2025-11-14": 1,
              "2025-11-21": 1,
              "2025-11-22": 4,
              "2025-12-04": 1,
              "2025-12-05": 1,
              "2025-12-11": 1,
              "2025-12-15": 2,
              "2025-12-18": 1,
              "2025-12-19": 1,
              "2026-01-09": 2,
              "2026-01-13": 2,
              "2026-01-15": 2,
              "2026-01-30": 3,
              "2026-02-02": 2,
              "2026-02-03": 1,
              "2026-02-04": 3,
              "2026-02-06": 3,
              "2026-02-09": 3,
              "2026-02-10": 6,
              "2026-02-17": 2,
              "2026-02-18": 2,
              "2026-02-19": 15,
              "2026-02-26": 1,
              "2026-02-28": 5,
              "2026-03-02": 4,
              "2026-03-03": 2,
              "2026-03-05": 2,
              "2026-03-09": 2,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-17": 24,
              "2026-03-18": 40,
              "2026-03-20": 2,
              "2026-03-21": 1,
              "2026-03-23": 5,
              "2026-03-24": 5,
              "2026-03-26": 4,
              "2026-03-30": 1,
              "2026-03-31": 2,
              "2026-04-01": 2,
              "2026-04-07": 1,
              "2026-04-08": 3,
              "2026-04-09": 7,
              "2026-04-10": 8,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-04-20": 3,
              "2026-04-21": 2,
              "2026-04-22": 4,
              "2026-04-27": 1,
              "2026-04-28": 2,
              "2026-05-02": 2,
              "2026-05-04": 5,
              "2026-05-06": 1,
              "2026-05-07": 4,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 6,
              "2026-05-12": 1,
              "2026-05-13": 3,
              "2026-05-14": 8,
              "2026-05-19": 1,
              "2026-05-21": 3,
              "2026-05-22": 3,
              "2026-05-25": 3,
              "2026-05-26": 2,
              "2026-05-27": 1,
              "2026-05-29": 2,
              "2026-06-02": 1,
              "2026-06-05": 2,
              "2026-06-06": 3
            },
            "time_per_day": {
              "2025-09-30": 6.0122816666666665,
              "2025-10-07": 20.21378861111111,
              "2025-10-09": 49.80916833333333,
              "2025-10-10": 3.9933858333333334,
              "2025-10-13": 166.3261425,
              "2025-10-22": 192.72703,
              "2025-10-29": 148.37568722222224,
              "2025-10-30": 1.8186933333333335,
              "2025-11-05": 42.840990833333336,
              "2025-11-10": 3.118009166666667,
              "2025-11-14": 219.60796222222223,
              "2025-11-21": 5.218376111111111,
              "2025-11-22": 96.9876036111111,
              "2025-12-04": 0.42080805555555556,
              "2025-12-05": 0.5482897222222223,
              "2025-12-11": 305.67023805555556,
              "2025-12-15": 668.8802225,
              "2025-12-18": 5.112048888888889,
              "2025-12-19": 363.0000025,
              "2026-01-09": 13.325439166666666,
              "2026-01-13": 25.688715000000002,
              "2026-01-15": 75.6127238888889,
              "2026-01-30": 8.818456944444444,
              "2026-02-02": 124.18986916666667,
              "2026-02-03": 276.9323430555556,
              "2026-02-04": 371.69344083333334,
              "2026-02-06": 470.41752722222225,
              "2026-02-09": 92.10517583333333,
              "2026-02-10": 955.6482111111112,
              "2026-02-17": 1095.391215,
              "2026-02-18": 5.42693,
              "2026-02-19": 8322.376858611111,
              "2026-02-26": 0.3073458333333333,
              "2026-02-28": 263.5375080555556,
              "2026-03-02": 85.44579083333333,
              "2026-03-03": 13.491353888888888,
              "2026-03-05": 4.122792222222222,
              "2026-03-09": 3.5902966666666667,
              "2026-03-11": 0.5999638888888889,
              "2026-03-12": 0.1728438888888889,
              "2026-03-16": 0.12464805555555555,
              "2026-03-17": 733.7416658333335,
              "2026-03-18": 11074.352964166672,
              "2026-03-20": 56.12177055555556,
              "2026-03-21": 0.5897047222222221,
              "2026-03-23": 4.073246666666666,
              "2026-03-24": 920.4861047222221,
              "2026-03-26": 3535.054629444444,
              "2026-03-30": 70.0080375,
              "2026-03-31": 1.9476155555555557,
              "2026-04-01": 3.4465233333333334,
              "2026-04-07": 0.211855,
              "2026-04-08": 19.64697888888889,
              "2026-04-09": 31.247343333333333,
              "2026-04-10": 116.32229944444445,
              "2026-04-11": 0.9075822222222222,
              "2026-04-13": 1.6771825,
              "2026-04-15": 0.007180833333333333,
              "2026-04-16": 0.08210333333333333,
              "2026-04-17": 0.008290277777777777,
              "2026-04-18": 12.609203055555556,
              "2026-04-20": 2.235083611111111,
              "2026-04-21": 0.10118694444444444,
              "2026-04-22": 426.80049444444444,
              "2026-04-27": 0.11136833333333333,
              "2026-04-28": 4.191473888888889,
              "2026-05-02": 44.482755833333336,
              "2026-05-04": 884.0034966666666,
              "2026-05-06": 3.189002222222222,
              "2026-05-07": 4.8303569444444445,
              "2026-05-08": 4.288792222222223,
              "2026-05-09": 124.67282777777777,
              "2026-05-11": 8.36736638888889,
              "2026-05-12": 0.11981222222222222,
              "2026-05-13": 21.583765,
              "2026-05-14": 1449.721297777778,
              "2026-05-19": 0.12022694444444444,
              "2026-05-21": 89.9539136111111,
              "2026-05-22": 32.24729555555555,
              "2026-05-25": 2.6497175,
              "2026-05-26": 5.056611111111112,
              "2026-05-27": 0.9304702777777778,
              "2026-05-29": 55.18523722222222,
              "2026-06-02": 0.4168741666666667,
              "2026-06-05": 8.327665555555555,
              "2026-06-06": 409.4212694444445
            },
            "time_count_per_day": {
              "2025-09-30": 2,
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-22": 3,
              "2025-10-29": 2,
              "2025-10-30": 1,
              "2025-11-05": 1,
              "2025-11-10": 1,
              "2025-11-14": 1,
              "2025-11-21": 1,
              "2025-11-22": 4,
              "2025-12-04": 1,
              "2025-12-05": 1,
              "2025-12-11": 1,
              "2025-12-15": 2,
              "2025-12-18": 1,
              "2025-12-19": 1,
              "2026-01-09": 2,
              "2026-01-13": 2,
              "2026-01-15": 2,
              "2026-01-30": 3,
              "2026-02-02": 2,
              "2026-02-03": 1,
              "2026-02-04": 3,
              "2026-02-06": 3,
              "2026-02-09": 3,
              "2026-02-10": 6,
              "2026-02-17": 2,
              "2026-02-18": 2,
              "2026-02-19": 15,
              "2026-02-26": 1,
              "2026-02-28": 5,
              "2026-03-02": 4,
              "2026-03-03": 2,
              "2026-03-05": 2,
              "2026-03-09": 2,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-17": 24,
              "2026-03-18": 40,
              "2026-03-20": 2,
              "2026-03-21": 1,
              "2026-03-23": 5,
              "2026-03-24": 5,
              "2026-03-26": 4,
              "2026-03-30": 1,
              "2026-03-31": 2,
              "2026-04-01": 2,
              "2026-04-07": 1,
              "2026-04-08": 3,
              "2026-04-09": 7,
              "2026-04-10": 8,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-04-20": 3,
              "2026-04-21": 2,
              "2026-04-22": 4,
              "2026-04-27": 1,
              "2026-04-28": 2,
              "2026-05-02": 2,
              "2026-05-04": 5,
              "2026-05-06": 1,
              "2026-05-07": 4,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 6,
              "2026-05-12": 1,
              "2026-05-13": 3,
              "2026-05-14": 8,
              "2026-05-19": 1,
              "2026-05-21": 3,
              "2026-05-22": 3,
              "2026-05-25": 3,
              "2026-05-26": 2,
              "2026-05-27": 1,
              "2026-05-29": 2,
              "2026-06-02": 1,
              "2026-06-05": 2,
              "2026-06-06": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 53.01,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "50-52h": 1,
                "84-86h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-09": 1,
                "2026-05-21": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-04-09": 24.582395,
                "2026-05-21": 84.29436861111111,
                "2026-05-29": 50.160133055555555
              },
              "time_count_per_day": {
                "2026-04-09": 1,
                "2026-05-21": 1,
                "2026-05-29": 1
              }
            },
            "P2": {
              "avg_time_hours": 19.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 71,
              "time_distribution": {
                "0-2h": 71,
                "2-4h": 22,
                "4-6h": 6,
                "6-8h": 5,
                "8-10h": 1,
                "12-14h": 4,
                "14-16h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 5,
                "24-26h": 1,
                "26-28h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "48-50h": 1,
                "124-126h": 1,
                "218-220h": 1,
                "656-658h": 1,
                "842-844h": 1
              },
              "tickets_count": 127,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-11-14": 1,
                "2025-12-05": 1,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-30": 2,
                "2026-02-09": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-03": 2,
                "2026-03-05": 2,
                "2026-03-09": 2,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-21": 1,
                "2026-03-23": 5,
                "2026-03-24": 1,
                "2026-03-31": 2,
                "2026-04-01": 2,
                "2026-04-07": 1,
                "2026-04-08": 3,
                "2026-04-09": 6,
                "2026-04-10": 8,
                "2026-04-11": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-04-20": 3,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-27": 1,
                "2026-04-28": 2,
                "2026-05-02": 2,
                "2026-05-04": 5,
                "2026-05-06": 1,
                "2026-05-07": 4,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 6,
                "2026-05-12": 1,
                "2026-05-13": 3,
                "2026-05-14": 7,
                "2026-05-19": 1,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-25": 3,
                "2026-05-26": 2,
                "2026-05-27": 1,
                "2026-05-29": 1,
                "2026-06-02": 1,
                "2026-06-05": 2,
                "2026-06-06": 2
              },
              "time_per_day": {
                "2025-10-10": 3.9933858333333334,
                "2025-11-14": 219.60796222222223,
                "2025-12-05": 0.5482897222222223,
                "2025-12-18": 5.112048888888889,
                "2026-01-13": 0.8329033333333334,
                "2026-01-15": 48.4858675,
                "2026-01-30": 8.772814722222222,
                "2026-02-09": 3.1970375,
                "2026-02-17": 657.0405455555556,
                "2026-02-18": 0.19496194444444445,
                "2026-02-26": 0.3073458333333333,
                "2026-02-28": 19.57252777777778,
                "2026-03-02": 44.64039444444444,
                "2026-03-03": 13.491353888888888,
                "2026-03-05": 4.122792222222222,
                "2026-03-09": 3.5902966666666667,
                "2026-03-11": 0.5999638888888889,
                "2026-03-12": 0.1728438888888889,
                "2026-03-16": 0.12464805555555555,
                "2026-03-17": 12.390272222222222,
                "2026-03-18": 7.510345,
                "2026-03-21": 0.5897047222222221,
                "2026-03-23": 4.073246666666666,
                "2026-03-24": 1.1690680555555557,
                "2026-03-31": 1.9476155555555557,
                "2026-04-01": 3.4465233333333334,
                "2026-04-07": 0.211855,
                "2026-04-08": 19.64697888888889,
                "2026-04-09": 6.664948333333333,
                "2026-04-10": 116.32229944444445,
                "2026-04-11": 0.9075822222222222,
                "2026-04-13": 1.6771825,
                "2026-04-15": 0.007180833333333333,
                "2026-04-16": 0.08210333333333333,
                "2026-04-17": 0.008290277777777777,
                "2026-04-18": 12.609203055555556,
                "2026-04-20": 2.235083611111111,
                "2026-04-21": 0.10118694444444444,
                "2026-04-22": 0.6000919444444445,
                "2026-04-27": 0.11136833333333333,
                "2026-04-28": 4.191473888888889,
                "2026-05-02": 44.482755833333336,
                "2026-05-04": 884.0034966666666,
                "2026-05-06": 3.189002222222222,
                "2026-05-07": 4.8303569444444445,
                "2026-05-08": 4.288792222222223,
                "2026-05-09": 124.67282777777777,
                "2026-05-11": 8.36736638888889,
                "2026-05-12": 0.11981222222222222,
                "2026-05-13": 21.583765,
                "2026-05-14": 36.18506611111111,
                "2026-05-19": 0.12022694444444444,
                "2026-05-21": 5.659545,
                "2026-05-22": 32.24729555555555,
                "2026-05-25": 2.6497175,
                "2026-05-26": 5.056611111111112,
                "2026-05-27": 0.9304702777777778,
                "2026-05-29": 5.025104166666667,
                "2026-06-02": 0.4168741666666667,
                "2026-06-05": 8.327665555555555,
                "2026-06-06": 27.30772361111111
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-11-14": 1,
                "2025-12-05": 1,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-30": 2,
                "2026-02-09": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-03": 2,
                "2026-03-05": 2,
                "2026-03-09": 2,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-18": 7,
                "2026-03-21": 1,
                "2026-03-23": 5,
                "2026-03-24": 1,
                "2026-03-31": 2,
                "2026-04-01": 2,
                "2026-04-07": 1,
                "2026-04-08": 3,
                "2026-04-09": 6,
                "2026-04-10": 8,
                "2026-04-11": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-04-20": 3,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-27": 1,
                "2026-04-28": 2,
                "2026-05-02": 2,
                "2026-05-04": 5,
                "2026-05-06": 1,
                "2026-05-07": 4,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 6,
                "2026-05-12": 1,
                "2026-05-13": 3,
                "2026-05-14": 7,
                "2026-05-19": 1,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-25": 3,
                "2026-05-26": 2,
                "2026-05-27": 1,
                "2026-05-29": 1,
                "2026-06-02": 1,
                "2026-06-05": 2,
                "2026-06-06": 2
              }
            },
            "P3": {
              "avg_time_hours": 70.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "6-8h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "30-32h": 1,
                "114-116h": 1,
                "382-384h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-12-04": 1,
                "2026-02-04": 1,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-09-30": 1.5781363888888889,
                "2025-12-04": 0.42080805555555556,
                "2026-02-04": 114.70182694444445,
                "2026-02-09": 8.013397222222222,
                "2026-02-10": 56.75903805555556,
                "2026-06-06": 382.1135458333333
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-12-04": 1,
                "2026-02-04": 1,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-06-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 192.06,
              "mode_time_hours": 31.0,
              "mode_frequency": 11,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "4-6h": 4,
                "8-10h": 1,
                "10-12h": 2,
                "18-20h": 5,
                "20-22h": 1,
                "24-26h": 1,
                "26-28h": 3,
                "28-30h": 4,
                "30-32h": 11,
                "32-34h": 4,
                "34-36h": 2,
                "36-38h": 3,
                "40-42h": 2,
                "42-44h": 1,
                "44-46h": 1,
                "48-50h": 1,
                "54-56h": 1,
                "60-62h": 2,
                "64-66h": 1,
                "70-72h": 1,
                "76-78h": 1,
                "78-80h": 1,
                "80-82h": 1,
                "92-94h": 1,
                "94-96h": 2,
                "96-98h": 1,
                "110-112h": 1,
                "126-128h": 1,
                "128-130h": 1,
                "134-136h": 1,
                "144-146h": 1,
                "160-162h": 2,
                "166-168h": 3,
                "180-182h": 1,
                "184-186h": 1,
                "196-198h": 2,
                "210-212h": 1,
                "216-218h": 3,
                "328-330h": 1,
                "332-334h": 1,
                "334-336h": 1,
                "352-354h": 1,
                "370-372h": 3,
                "382-384h": 1,
                "398-400h": 2,
                "400-402h": 1,
                "404-406h": 1,
                "414-416h": 1,
                "430-432h": 1,
                "442-444h": 1,
                "450-452h": 1,
                "478-480h": 2,
                "496-498h": 2,
                "498-500h": 1,
                "502-504h": 1,
                "546-548h": 1,
                "552-554h": 1,
                "602-604h": 1,
                "650-652h": 1,
                "966-968h": 1,
                "982-984h": 2,
                "1412-1414h": 1
              },
              "tickets_count": 110,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-22": 3,
                "2025-10-29": 2,
                "2025-10-30": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-21": 1,
                "2025-11-22": 4,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-04": 2,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-02-18": 1,
                "2026-02-28": 4,
                "2026-03-02": 1,
                "2026-03-17": 23,
                "2026-03-18": 33,
                "2026-03-20": 2,
                "2026-03-24": 4,
                "2026-03-26": 4,
                "2026-03-30": 1,
                "2026-04-22": 3,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-09-30": 4.434145277777778,
                "2025-10-07": 20.21378861111111,
                "2025-10-09": 49.80916833333333,
                "2025-10-13": 166.3261425,
                "2025-10-22": 192.72703,
                "2025-10-29": 148.37568722222224,
                "2025-10-30": 1.8186933333333335,
                "2025-11-05": 42.840990833333336,
                "2025-11-10": 3.118009166666667,
                "2025-11-21": 5.218376111111111,
                "2025-11-22": 96.9876036111111,
                "2026-01-09": 13.325439166666666,
                "2026-01-13": 24.855811666666668,
                "2026-01-15": 27.12685638888889,
                "2026-01-30": 0.04564222222222222,
                "2026-02-02": 124.18986916666667,
                "2026-02-04": 256.9916138888889,
                "2026-02-06": 470.41752722222225,
                "2026-02-09": 80.89474111111112,
                "2026-02-10": 898.8891730555556,
                "2026-02-18": 5.231968055555555,
                "2026-02-28": 243.96498027777778,
                "2026-03-02": 40.80539638888889,
                "2026-03-17": 721.3513936111112,
                "2026-03-18": 11066.84261916667,
                "2026-03-20": 56.12177055555556,
                "2026-03-24": 919.3170366666666,
                "2026-03-26": 3535.054629444444,
                "2026-03-30": 70.0080375,
                "2026-04-22": 426.2004025,
                "2026-05-14": 1413.5362316666667
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-22": 3,
                "2025-10-29": 2,
                "2025-10-30": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-21": 1,
                "2025-11-22": 4,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-04": 2,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-10": 3,
                "2026-02-18": 1,
                "2026-02-28": 4,
                "2026-03-02": 1,
                "2026-03-17": 23,
                "2026-03-18": 33,
                "2026-03-20": 2,
                "2026-03-24": 4,
                "2026-03-26": 4,
                "2026-03-30": 1,
                "2026-04-22": 3,
                "2026-05-14": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 494.06,
              "mode_time_hours": 735.0,
              "mode_frequency": 3,
              "time_distribution": {
                "234-236h": 1,
                "264-266h": 1,
                "276-278h": 1,
                "304-306h": 1,
                "330-332h": 1,
                "362-364h": 1,
                "402-404h": 1,
                "404-406h": 2,
                "438-440h": 1,
                "478-480h": 2,
                "480-482h": 1,
                "564-566h": 1,
                "666-668h": 1,
                "668-670h": 1,
                "690-692h": 1,
                "710-712h": 1,
                "734-736h": 3
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2026-02-03": 1,
                "2026-02-17": 1,
                "2026-02-19": 15
              },
              "time_per_day": {
                "2025-12-11": 305.67023805555556,
                "2025-12-15": 668.8802225,
                "2025-12-19": 363.0000025,
                "2026-02-03": 276.9323430555556,
                "2026-02-17": 438.3506694444444,
                "2026-02-19": 8322.376858611111
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2026-02-03": 1,
                "2026-02-17": 1,
                "2026-02-19": 15
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-03-28": 1,
              "2026-03-30": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-21": 1,
              "2026-06-05": 2,
              "2026-06-06": 4
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-03-28": 1,
                "2026-03-30": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-21": 1,
                "2026-06-05": 2,
                "2026-06-06": 4
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-28": 1,
              "2026-05-13": 1,
              "2026-05-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-28": 1,
                "2026-05-13": 1,
                "2026-05-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-14": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-12": 1,
              "2026-05-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_42": {
      "overall": {
        "avg_time_hours": 267.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 4,
          "4-6h": 4,
          "14-16h": 1,
          "18-20h": 3,
          "22-24h": 1,
          "24-26h": 3,
          "26-28h": 1,
          "28-30h": 1,
          "42-44h": 1,
          "48-50h": 1,
          "64-66h": 1,
          "116-118h": 1,
          "170-172h": 1,
          "194-196h": 1,
          "212-214h": 1,
          "234-236h": 1,
          "268-270h": 1,
          "294-296h": 1,
          "318-320h": 2,
          "506-508h": 1,
          "580-582h": 1,
          "640-642h": 1,
          "670-672h": 1,
          "826-828h": 1,
          "974-976h": 1,
          "1050-1052h": 1,
          "1196-1198h": 1,
          "3554-3556h": 1
        },
        "tickets_count": 52,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-11-06": 1,
          "2025-11-13": 1,
          "2025-11-21": 1,
          "2025-12-03": 1,
          "2025-12-05": 2,
          "2025-12-10": 1,
          "2025-12-31": 1,
          "2026-01-02": 1,
          "2026-01-06": 1,
          "2026-01-16": 1,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-02-26": 2,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-09": 1,
          "2026-03-10": 3,
          "2026-03-11": 2,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-04-22": 2,
          "2026-04-23": 1,
          "2026-04-30": 2,
          "2026-05-04": 1,
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-20": 1,
          "2026-05-27": 2,
          "2026-05-29": 2,
          "2026-06-01": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-09-30": 0.43303416666666666,
          "2025-10-15": 19.074982777777777,
          "2025-10-17": 25.230057777777777,
          "2025-11-06": 5.4155783333333325,
          "2025-11-13": 26.159139722222225,
          "2025-11-21": 19.380625833333333,
          "2025-12-03": 5.600823888888889,
          "2025-12-05": 2.4944594444444443,
          "2025-12-10": 171.3362075,
          "2025-12-31": 975.9564755555556,
          "2026-01-06": 3.9930066666666666,
          "2026-01-16": 4.193883611111111,
          "2026-01-29": 25.326855277777778,
          "2026-01-30": 24.44329611111111,
          "2026-02-03": 318.70486305555556,
          "2026-02-09": 2.1350366666666667,
          "2026-02-13": 428.9816172222222,
          "2026-02-18": 49.17653583333333,
          "2026-02-23": 1.0287888888888888,
          "2026-02-26": 8.421405277777778,
          "2026-02-28": 19.494841666666666,
          "2026-03-02": 65.22834611111111,
          "2026-03-05": 506.7838161111111,
          "2026-03-09": 827.8779566666666,
          "2026-03-10": 682.1570533333334,
          "2026-03-11": 1371.472798888889,
          "2026-04-01": 0.01468138888888889,
          "2026-04-02": 14.112179166666667,
          "2026-04-15": 0.06774944444444445,
          "2026-04-20": 670.3201372222222,
          "2026-04-22": 241.9852327777778,
          "2026-04-23": 1196.0942061111111,
          "2026-04-30": 3555.0599475000004,
          "2026-05-04": 0.10292583333333334,
          "2026-05-14": 580.980085,
          "2026-05-20": 1.1007677777777778,
          "2026-05-27": 663.8721369444444,
          "2026-05-29": 43.04656722222222,
          "2026-06-03": 0.2346513888888889
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-11-06": 1,
          "2025-11-13": 1,
          "2025-11-21": 1,
          "2025-12-03": 1,
          "2025-12-05": 2,
          "2025-12-10": 1,
          "2025-12-31": 1,
          "2026-01-06": 1,
          "2026-01-16": 1,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-02-26": 2,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-09": 1,
          "2026-03-10": 3,
          "2026-03-11": 2,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-04-22": 2,
          "2026-04-23": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-20": 1,
          "2026-05-27": 2,
          "2026-05-29": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 12.77,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "24-26h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-04-30": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2026-01-30": 24.44329611111111,
            "2026-05-20": 1.1007677777777778
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-05-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 261.19,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 3,
            "4-6h": 4,
            "14-16h": 1,
            "18-20h": 3,
            "22-24h": 1,
            "24-26h": 2,
            "26-28h": 1,
            "28-30h": 1,
            "42-44h": 1,
            "48-50h": 1,
            "64-66h": 1,
            "116-118h": 1,
            "170-172h": 1,
            "194-196h": 1,
            "212-214h": 1,
            "234-236h": 1,
            "268-270h": 1,
            "294-296h": 1,
            "318-320h": 2,
            "580-582h": 1,
            "640-642h": 1,
            "670-672h": 1,
            "826-828h": 1,
            "974-976h": 1,
            "1196-1198h": 1,
            "3554-3556h": 1
          },
          "tickets_count": 46,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-11-06": 1,
            "2025-11-13": 1,
            "2025-11-21": 1,
            "2025-12-03": 1,
            "2025-12-05": 2,
            "2025-12-10": 1,
            "2025-12-31": 1,
            "2026-01-02": 1,
            "2026-01-06": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-02-23": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-09": 1,
            "2026-03-10": 3,
            "2026-03-11": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-04-22": 2,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-27": 2,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-09-30": 0.43303416666666666,
            "2025-10-15": 19.074982777777777,
            "2025-10-17": 25.230057777777777,
            "2025-11-06": 5.4155783333333325,
            "2025-11-13": 26.159139722222225,
            "2025-11-21": 19.380625833333333,
            "2025-12-03": 5.600823888888889,
            "2025-12-05": 2.4944594444444443,
            "2025-12-10": 171.3362075,
            "2025-12-31": 975.9564755555556,
            "2026-01-06": 3.9930066666666666,
            "2026-01-16": 4.193883611111111,
            "2026-01-29": 25.326855277777778,
            "2026-02-03": 318.70486305555556,
            "2026-02-09": 2.1350366666666667,
            "2026-02-13": 428.9816172222222,
            "2026-02-18": 49.17653583333333,
            "2026-02-23": 1.0287888888888888,
            "2026-02-26": 4.776661666666667,
            "2026-02-28": 19.494841666666666,
            "2026-03-02": 65.22834611111111,
            "2026-03-09": 827.8779566666666,
            "2026-03-10": 682.1570533333334,
            "2026-03-11": 319.7553286111111,
            "2026-04-01": 0.01468138888888889,
            "2026-04-02": 14.112179166666667,
            "2026-04-15": 0.06774944444444445,
            "2026-04-20": 670.3201372222222,
            "2026-04-22": 241.9852327777778,
            "2026-04-23": 1196.0942061111111,
            "2026-04-30": 3555.0599475000004,
            "2026-05-04": 0.10292583333333334,
            "2026-05-14": 580.980085,
            "2026-05-27": 663.8721369444444,
            "2026-05-29": 43.04656722222222,
            "2026-06-03": 0.2346513888888889
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-11-06": 1,
            "2025-11-13": 1,
            "2025-11-21": 1,
            "2025-12-03": 1,
            "2025-12-05": 2,
            "2025-12-10": 1,
            "2025-12-31": 1,
            "2026-01-06": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-02-23": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-09": 1,
            "2026-03-10": 3,
            "2026-03-11": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-04-22": 2,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-14": 1,
            "2026-05-27": 2,
            "2026-05-29": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 520.72,
          "mode_time_hours": 1051.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "506-508h": 1,
            "1050-1052h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-26": 1,
            "2026-03-05": 1,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-02-26": 3.644743611111111,
            "2026-03-05": 506.7838161111111,
            "2026-03-11": 1051.717470277778
          },
          "time_count_per_day": {
            "2026-02-26": 1,
            "2026-03-05": 1,
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 267.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 4,
              "4-6h": 4,
              "14-16h": 1,
              "18-20h": 3,
              "22-24h": 1,
              "24-26h": 3,
              "26-28h": 1,
              "28-30h": 1,
              "42-44h": 1,
              "48-50h": 1,
              "64-66h": 1,
              "116-118h": 1,
              "170-172h": 1,
              "194-196h": 1,
              "212-214h": 1,
              "234-236h": 1,
              "268-270h": 1,
              "294-296h": 1,
              "318-320h": 2,
              "506-508h": 1,
              "580-582h": 1,
              "640-642h": 1,
              "670-672h": 1,
              "826-828h": 1,
              "974-976h": 1,
              "1050-1052h": 1,
              "1196-1198h": 1,
              "3554-3556h": 1
            },
            "tickets_count": 47,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-11-06": 1,
              "2025-11-13": 1,
              "2025-11-21": 1,
              "2025-12-03": 1,
              "2025-12-05": 2,
              "2025-12-10": 1,
              "2025-12-31": 1,
              "2026-01-06": 1,
              "2026-01-16": 1,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-02-26": 2,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-09": 1,
              "2026-03-10": 3,
              "2026-03-11": 2,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-04-22": 2,
              "2026-04-23": 1,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-20": 1,
              "2026-05-27": 2,
              "2026-05-29": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-09-30": 0.43303416666666666,
              "2025-10-15": 19.074982777777777,
              "2025-10-17": 25.230057777777777,
              "2025-11-06": 5.4155783333333325,
              "2025-11-13": 26.159139722222225,
              "2025-11-21": 19.380625833333333,
              "2025-12-03": 5.600823888888889,
              "2025-12-05": 2.4944594444444443,
              "2025-12-10": 171.3362075,
              "2025-12-31": 975.9564755555556,
              "2026-01-06": 3.9930066666666666,
              "2026-01-16": 4.193883611111111,
              "2026-01-29": 25.326855277777778,
              "2026-01-30": 24.44329611111111,
              "2026-02-03": 318.70486305555556,
              "2026-02-09": 2.1350366666666667,
              "2026-02-13": 428.9816172222222,
              "2026-02-18": 49.17653583333333,
              "2026-02-23": 1.0287888888888888,
              "2026-02-26": 8.421405277777778,
              "2026-02-28": 19.494841666666666,
              "2026-03-02": 65.22834611111111,
              "2026-03-05": 506.7838161111111,
              "2026-03-09": 827.8779566666666,
              "2026-03-10": 682.1570533333334,
              "2026-03-11": 1371.472798888889,
              "2026-04-01": 0.01468138888888889,
              "2026-04-02": 14.112179166666667,
              "2026-04-15": 0.06774944444444445,
              "2026-04-20": 670.3201372222222,
              "2026-04-22": 241.9852327777778,
              "2026-04-23": 1196.0942061111111,
              "2026-04-30": 3555.0599475000004,
              "2026-05-04": 0.10292583333333334,
              "2026-05-14": 580.980085,
              "2026-05-20": 1.1007677777777778,
              "2026-05-27": 663.8721369444444,
              "2026-05-29": 43.04656722222222,
              "2026-06-03": 0.2346513888888889
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-11-06": 1,
              "2025-11-13": 1,
              "2025-11-21": 1,
              "2025-12-03": 1,
              "2025-12-05": 2,
              "2025-12-10": 1,
              "2025-12-31": 1,
              "2026-01-06": 1,
              "2026-01-16": 1,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-02-26": 2,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-09": 1,
              "2026-03-10": 3,
              "2026-03-11": 2,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-04-22": 2,
              "2026-04-23": 1,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-20": 1,
              "2026-05-27": 2,
              "2026-05-29": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 12.77,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "24-26h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2026-01-30": 24.44329611111111,
                "2026-05-20": 1.1007677777777778
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-05-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 261.19,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 3,
                "4-6h": 4,
                "14-16h": 1,
                "18-20h": 3,
                "22-24h": 1,
                "24-26h": 2,
                "26-28h": 1,
                "28-30h": 1,
                "42-44h": 1,
                "48-50h": 1,
                "64-66h": 1,
                "116-118h": 1,
                "170-172h": 1,
                "194-196h": 1,
                "212-214h": 1,
                "234-236h": 1,
                "268-270h": 1,
                "294-296h": 1,
                "318-320h": 2,
                "580-582h": 1,
                "640-642h": 1,
                "670-672h": 1,
                "826-828h": 1,
                "974-976h": 1,
                "1196-1198h": 1,
                "3554-3556h": 1
              },
              "tickets_count": 42,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-11-06": 1,
                "2025-11-13": 1,
                "2025-11-21": 1,
                "2025-12-03": 1,
                "2025-12-05": 2,
                "2025-12-10": 1,
                "2025-12-31": 1,
                "2026-01-06": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-02-23": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-09": 1,
                "2026-03-10": 3,
                "2026-03-11": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-04-22": 2,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-14": 1,
                "2026-05-27": 2,
                "2026-05-29": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-09-30": 0.43303416666666666,
                "2025-10-15": 19.074982777777777,
                "2025-10-17": 25.230057777777777,
                "2025-11-06": 5.4155783333333325,
                "2025-11-13": 26.159139722222225,
                "2025-11-21": 19.380625833333333,
                "2025-12-03": 5.600823888888889,
                "2025-12-05": 2.4944594444444443,
                "2025-12-10": 171.3362075,
                "2025-12-31": 975.9564755555556,
                "2026-01-06": 3.9930066666666666,
                "2026-01-16": 4.193883611111111,
                "2026-01-29": 25.326855277777778,
                "2026-02-03": 318.70486305555556,
                "2026-02-09": 2.1350366666666667,
                "2026-02-13": 428.9816172222222,
                "2026-02-18": 49.17653583333333,
                "2026-02-23": 1.0287888888888888,
                "2026-02-26": 4.776661666666667,
                "2026-02-28": 19.494841666666666,
                "2026-03-02": 65.22834611111111,
                "2026-03-09": 827.8779566666666,
                "2026-03-10": 682.1570533333334,
                "2026-03-11": 319.7553286111111,
                "2026-04-01": 0.01468138888888889,
                "2026-04-02": 14.112179166666667,
                "2026-04-15": 0.06774944444444445,
                "2026-04-20": 670.3201372222222,
                "2026-04-22": 241.9852327777778,
                "2026-04-23": 1196.0942061111111,
                "2026-04-30": 3555.0599475000004,
                "2026-05-04": 0.10292583333333334,
                "2026-05-14": 580.980085,
                "2026-05-27": 663.8721369444444,
                "2026-05-29": 43.04656722222222,
                "2026-06-03": 0.2346513888888889
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-11-06": 1,
                "2025-11-13": 1,
                "2025-11-21": 1,
                "2025-12-03": 1,
                "2025-12-05": 2,
                "2025-12-10": 1,
                "2025-12-31": 1,
                "2026-01-06": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-02-23": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-09": 1,
                "2026-03-10": 3,
                "2026-03-11": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-04-22": 2,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-14": 1,
                "2026-05-27": 2,
                "2026-05-29": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 520.72,
              "mode_time_hours": 1051.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "506-508h": 1,
                "1050-1052h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-26": 1,
                "2026-03-05": 1,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-02-26": 3.644743611111111,
                "2026-03-05": 506.7838161111111,
                "2026-03-11": 1051.717470277778
              },
              "time_count_per_day": {
                "2026-02-26": 1,
                "2026-03-05": 1,
                "2026-03-11": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-02": 1,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-29": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-02": 1,
                "2026-05-06": 1,
                "2026-05-29": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_43": {
      "overall": {
        "avg_time_hours": 85.14,
        "mode_time_hours": 31.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "6-8h": 2,
          "8-10h": 1,
          "14-16h": 1,
          "24-26h": 1,
          "28-30h": 1,
          "30-32h": 2,
          "44-46h": 1,
          "50-52h": 1,
          "62-64h": 1,
          "74-76h": 2,
          "112-114h": 1,
          "132-134h": 1,
          "372-374h": 1,
          "530-532h": 1
        },
        "tickets_count": 21,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-23": 1,
          "2025-12-11": 1,
          "2026-01-15": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-04": 2,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-22": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-06-07": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-09-30": 4.0469725,
          "2025-10-23": 62.25618333333333,
          "2025-12-11": 15.473765833333333,
          "2026-01-15": 25.609080555555558,
          "2026-01-21": 28.45309194444444,
          "2026-01-27": 31.22179277777778,
          "2026-02-03": 74.53659777777777,
          "2026-02-04": 184.48183555555556,
          "2026-02-09": 9.603505277777778,
          "2026-02-10": 74.63770583333333,
          "2026-02-13": 372.6534127777778,
          "2026-02-18": 6.864153333333333,
          "2026-02-20": 44.64252888888889,
          "2026-02-22": 31.19750972222222,
          "2026-03-23": 113.72397638888889,
          "2026-03-31": 0.04289861111111111,
          "2026-04-23": 530.5056111111111,
          "2026-05-05": 7.756599722222222
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-23": 1,
          "2025-12-11": 1,
          "2026-01-15": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-04": 2,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-22": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-23": 1,
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 113.72,
          "mode_time_hours": 113.0,
          "mode_frequency": 1,
          "time_distribution": {
            "112-114h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 113.72397638888889
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        },
        "P2": {
          "avg_time_hours": 66.89,
          "mode_time_hours": 63.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "28-30h": 1,
            "30-32h": 1,
            "62-64h": 1,
            "74-76h": 1,
            "372-374h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-12-11": 1,
            "2026-01-21": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-13": 1,
            "2026-02-22": 1,
            "2026-03-31": 1,
            "2026-05-05": 1,
            "2026-06-07": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-23": 62.25618333333333,
            "2025-12-11": 15.473765833333333,
            "2026-01-21": 28.45309194444444,
            "2026-02-03": 74.53659777777777,
            "2026-02-09": 9.603505277777778,
            "2026-02-13": 372.6534127777778,
            "2026-02-22": 31.19750972222222,
            "2026-03-31": 0.04289861111111111,
            "2026-05-05": 7.756599722222222
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-12-11": 1,
            "2026-01-21": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-13": 1,
            "2026-02-22": 1,
            "2026-03-31": 1,
            "2026-05-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 96.12,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "24-26h": 1,
            "30-32h": 1,
            "44-46h": 1,
            "50-52h": 1,
            "74-76h": 1,
            "530-532h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-09-30": 4.0469725,
            "2026-01-15": 25.609080555555558,
            "2026-01-27": 31.22179277777778,
            "2026-02-04": 51.41178055555556,
            "2026-02-10": 74.63770583333333,
            "2026-02-18": 6.864153333333333,
            "2026-02-20": 44.64252888888889,
            "2026-04-23": 530.5056111111111
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 133.07,
          "mode_time_hours": 133.0,
          "mode_frequency": 1,
          "time_distribution": {
            "132-134h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 133.070055
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 85.14,
            "mode_time_hours": 31.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "6-8h": 2,
              "8-10h": 1,
              "14-16h": 1,
              "24-26h": 1,
              "28-30h": 1,
              "30-32h": 2,
              "44-46h": 1,
              "50-52h": 1,
              "62-64h": 1,
              "74-76h": 2,
              "112-114h": 1,
              "132-134h": 1,
              "372-374h": 1,
              "530-532h": 1
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-23": 1,
              "2025-12-11": 1,
              "2026-01-15": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-04": 2,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-22": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-23": 1,
              "2026-05-05": 1
            },
            "time_per_day": {
              "2025-09-30": 4.0469725,
              "2025-10-23": 62.25618333333333,
              "2025-12-11": 15.473765833333333,
              "2026-01-15": 25.609080555555558,
              "2026-01-21": 28.45309194444444,
              "2026-01-27": 31.22179277777778,
              "2026-02-03": 74.53659777777777,
              "2026-02-04": 184.48183555555556,
              "2026-02-09": 9.603505277777778,
              "2026-02-10": 74.63770583333333,
              "2026-02-13": 372.6534127777778,
              "2026-02-18": 6.864153333333333,
              "2026-02-20": 44.64252888888889,
              "2026-02-22": 31.19750972222222,
              "2026-03-23": 113.72397638888889,
              "2026-03-31": 0.04289861111111111,
              "2026-04-23": 530.5056111111111,
              "2026-05-05": 7.756599722222222
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-23": 1,
              "2025-12-11": 1,
              "2026-01-15": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-04": 2,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-22": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-23": 1,
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 113.72,
              "mode_time_hours": 113.0,
              "mode_frequency": 1,
              "time_distribution": {
                "112-114h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 113.72397638888889
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            },
            "P2": {
              "avg_time_hours": 66.89,
              "mode_time_hours": 63.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "28-30h": 1,
                "30-32h": 1,
                "62-64h": 1,
                "74-76h": 1,
                "372-374h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-12-11": 1,
                "2026-01-21": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-13": 1,
                "2026-02-22": 1,
                "2026-03-31": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2025-10-23": 62.25618333333333,
                "2025-12-11": 15.473765833333333,
                "2026-01-21": 28.45309194444444,
                "2026-02-03": 74.53659777777777,
                "2026-02-09": 9.603505277777778,
                "2026-02-13": 372.6534127777778,
                "2026-02-22": 31.19750972222222,
                "2026-03-31": 0.04289861111111111,
                "2026-05-05": 7.756599722222222
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-12-11": 1,
                "2026-01-21": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-13": 1,
                "2026-02-22": 1,
                "2026-03-31": 1,
                "2026-05-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 96.12,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "24-26h": 1,
                "30-32h": 1,
                "44-46h": 1,
                "50-52h": 1,
                "74-76h": 1,
                "530-532h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-09-30": 4.0469725,
                "2026-01-15": 25.609080555555558,
                "2026-01-27": 31.22179277777778,
                "2026-02-04": 51.41178055555556,
                "2026-02-10": 74.63770583333333,
                "2026-02-18": 6.864153333333333,
                "2026-02-20": 44.64252888888889,
                "2026-04-23": 530.5056111111111
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 133.07,
              "mode_time_hours": 133.0,
              "mode_frequency": 1,
              "time_distribution": {
                "132-134h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 133.070055
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_44": {
      "overall": {
        "avg_time_hours": 135.58,
        "mode_time_hours": 1.0,
        "mode_frequency": 442,
        "time_distribution": {
          "0-2h": 442,
          "2-4h": 168,
          "4-6h": 83,
          "6-8h": 49,
          "8-10h": 24,
          "10-12h": 13,
          "12-14h": 18,
          "14-16h": 11,
          "16-18h": 15,
          "18-20h": 18,
          "20-22h": 12,
          "22-24h": 16,
          "24-26h": 18,
          "26-28h": 15,
          "28-30h": 10,
          "30-32h": 10,
          "32-34h": 3,
          "34-36h": 4,
          "36-38h": 5,
          "40-42h": 4,
          "42-44h": 6,
          "44-46h": 8,
          "46-48h": 6,
          "48-50h": 2,
          "50-52h": 7,
          "52-54h": 4,
          "54-56h": 3,
          "56-58h": 10,
          "58-60h": 1,
          "60-62h": 2,
          "64-66h": 1,
          "66-68h": 7,
          "68-70h": 1,
          "70-72h": 4,
          "72-74h": 2,
          "74-76h": 6,
          "76-78h": 3,
          "78-80h": 6,
          "80-82h": 6,
          "82-84h": 3,
          "84-86h": 1,
          "86-88h": 1,
          "88-90h": 3,
          "90-92h": 4,
          "92-94h": 5,
          "94-96h": 3,
          "96-98h": 5,
          "98-100h": 3,
          "100-102h": 4,
          "102-104h": 1,
          "104-106h": 1,
          "112-114h": 1,
          "114-116h": 3,
          "118-120h": 5,
          "120-122h": 2,
          "122-124h": 9,
          "124-126h": 1,
          "126-128h": 3,
          "128-130h": 1,
          "132-134h": 1,
          "134-136h": 1,
          "136-138h": 2,
          "138-140h": 1,
          "140-142h": 4,
          "142-144h": 5,
          "144-146h": 6,
          "146-148h": 8,
          "148-150h": 2,
          "150-152h": 3,
          "152-154h": 1,
          "154-156h": 1,
          "156-158h": 3,
          "160-162h": 2,
          "162-164h": 5,
          "164-166h": 9,
          "166-168h": 3,
          "168-170h": 1,
          "172-174h": 2,
          "174-176h": 2,
          "176-178h": 2,
          "178-180h": 1,
          "184-186h": 1,
          "186-188h": 1,
          "192-194h": 4,
          "194-196h": 4,
          "198-200h": 2,
          "200-202h": 2,
          "204-206h": 2,
          "208-210h": 1,
          "212-214h": 2,
          "216-218h": 2,
          "218-220h": 5,
          "222-224h": 1,
          "228-230h": 3,
          "232-234h": 1,
          "234-236h": 4,
          "240-242h": 1,
          "248-250h": 2,
          "256-258h": 1,
          "260-262h": 1,
          "262-264h": 2,
          "264-266h": 1,
          "268-270h": 1,
          "276-278h": 2,
          "286-288h": 3,
          "288-290h": 4,
          "290-292h": 2,
          "292-294h": 2,
          "294-296h": 1,
          "298-300h": 1,
          "300-302h": 3,
          "302-304h": 1,
          "310-312h": 3,
          "312-314h": 2,
          "314-316h": 1,
          "316-318h": 3,
          "322-324h": 2,
          "330-332h": 3,
          "332-334h": 2,
          "334-336h": 1,
          "336-338h": 9,
          "340-342h": 3,
          "342-344h": 1,
          "348-350h": 3,
          "354-356h": 2,
          "356-358h": 2,
          "360-362h": 1,
          "362-364h": 2,
          "364-366h": 1,
          "368-370h": 1,
          "374-376h": 1,
          "378-380h": 1,
          "382-384h": 3,
          "384-386h": 7,
          "388-390h": 4,
          "390-392h": 2,
          "392-394h": 1,
          "396-398h": 1,
          "402-404h": 1,
          "406-408h": 2,
          "408-410h": 4,
          "410-412h": 3,
          "412-414h": 1,
          "428-430h": 2,
          "432-434h": 2,
          "436-438h": 1,
          "454-456h": 4,
          "456-458h": 2,
          "464-466h": 1,
          "466-468h": 3,
          "472-474h": 1,
          "476-478h": 1,
          "478-480h": 1,
          "482-484h": 1,
          "486-488h": 2,
          "488-490h": 1,
          "492-494h": 2,
          "494-496h": 1,
          "496-498h": 1,
          "498-500h": 1,
          "500-502h": 1,
          "502-504h": 2,
          "504-506h": 2,
          "508-510h": 2,
          "514-516h": 1,
          "528-530h": 2,
          "532-534h": 1,
          "534-536h": 1,
          "536-538h": 2,
          "544-546h": 2,
          "546-548h": 1,
          "550-552h": 1,
          "556-558h": 1,
          "560-562h": 1,
          "572-574h": 1,
          "576-578h": 1,
          "578-580h": 1,
          "604-606h": 1,
          "610-612h": 1,
          "614-616h": 1,
          "624-626h": 1,
          "630-632h": 1,
          "634-636h": 1,
          "648-650h": 1,
          "650-652h": 2,
          "654-656h": 1,
          "664-666h": 1,
          "672-674h": 1,
          "680-682h": 2,
          "684-686h": 1,
          "688-690h": 1,
          "694-696h": 1,
          "714-716h": 1,
          "720-722h": 2,
          "738-740h": 3,
          "740-742h": 1,
          "746-748h": 2,
          "766-768h": 1,
          "780-782h": 1,
          "784-786h": 1,
          "796-798h": 1,
          "798-800h": 1,
          "816-818h": 1,
          "820-822h": 1,
          "826-828h": 1,
          "834-836h": 1,
          "842-844h": 1,
          "846-848h": 1,
          "862-864h": 1,
          "866-868h": 1,
          "888-890h": 1,
          "914-916h": 1,
          "1012-1014h": 1,
          "1028-1030h": 1,
          "1052-1054h": 1,
          "1056-1058h": 1,
          "1058-1060h": 1,
          "1068-1070h": 1,
          "1072-1074h": 2,
          "1080-1082h": 1,
          "1092-1094h": 1,
          "1102-1104h": 1,
          "1124-1126h": 2,
          "1134-1136h": 1,
          "1166-1168h": 1,
          "1170-1172h": 1,
          "1200-1202h": 1,
          "1208-1210h": 1,
          "1222-1224h": 2,
          "1228-1230h": 1,
          "1238-1240h": 1,
          "1248-1250h": 3,
          "1250-1252h": 1,
          "1272-1274h": 1,
          "1314-1316h": 1,
          "1360-1362h": 1,
          "1408-1410h": 1,
          "1416-1418h": 2,
          "1506-1508h": 1,
          "1514-1516h": 1,
          "1532-1534h": 1,
          "1684-1686h": 1,
          "1698-1700h": 1,
          "1704-1706h": 1,
          "1718-1720h": 1,
          "1728-1730h": 1,
          "1796-1798h": 1,
          "1842-1844h": 1,
          "1846-1848h": 1,
          "1856-1858h": 1,
          "2158-2160h": 1,
          "2208-2210h": 1,
          "2304-2306h": 1,
          "4036-4038h": 1
        },
        "tickets_count": 1474,
        "tickets_per_day": {
          "2025-09-30": 4,
          "2025-10-08": 5,
          "2025-10-09": 5,
          "2025-10-10": 6,
          "2025-10-13": 2,
          "2025-10-14": 10,
          "2025-10-15": 5,
          "2025-10-16": 5,
          "2025-10-17": 3,
          "2025-10-20": 4,
          "2025-10-21": 1,
          "2025-10-22": 6,
          "2025-10-23": 14,
          "2025-10-24": 4,
          "2025-10-27": 8,
          "2025-10-28": 12,
          "2025-10-29": 8,
          "2025-10-30": 13,
          "2025-10-31": 10,
          "2025-11-02": 1,
          "2025-11-03": 6,
          "2025-11-04": 2,
          "2025-11-05": 6,
          "2025-11-06": 8,
          "2025-11-07": 3,
          "2025-11-10": 10,
          "2025-11-11": 8,
          "2025-11-12": 6,
          "2025-11-13": 5,
          "2025-11-14": 8,
          "2025-11-16": 1,
          "2025-11-17": 5,
          "2025-11-18": 7,
          "2025-11-19": 6,
          "2025-11-20": 14,
          "2025-11-21": 12,
          "2025-11-22": 1,
          "2025-11-23": 2,
          "2025-11-24": 15,
          "2025-11-25": 4,
          "2025-11-26": 10,
          "2025-11-27": 4,
          "2025-11-28": 5,
          "2025-11-29": 10,
          "2025-11-30": 1,
          "2025-12-02": 17,
          "2025-12-03": 17,
          "2025-12-04": 10,
          "2025-12-05": 9,
          "2025-12-06": 1,
          "2025-12-09": 4,
          "2025-12-10": 7,
          "2025-12-11": 8,
          "2025-12-12": 9,
          "2025-12-13": 1,
          "2025-12-14": 2,
          "2025-12-15": 18,
          "2025-12-16": 11,
          "2025-12-17": 2,
          "2025-12-18": 1,
          "2025-12-19": 7,
          "2025-12-22": 5,
          "2025-12-23": 10,
          "2025-12-24": 1,
          "2025-12-26": 8,
          "2025-12-29": 10,
          "2025-12-31": 3,
          "2026-01-02": 4,
          "2026-01-03": 1,
          "2026-01-05": 5,
          "2026-01-06": 14,
          "2026-01-07": 14,
          "2026-01-08": 16,
          "2026-01-09": 10,
          "2026-01-10": 4,
          "2026-01-11": 1,
          "2026-01-12": 9,
          "2026-01-13": 15,
          "2026-01-14": 4,
          "2026-01-15": 10,
          "2026-01-16": 4,
          "2026-01-17": 3,
          "2026-01-18": 3,
          "2026-01-19": 7,
          "2026-01-20": 7,
          "2026-01-21": 3,
          "2026-01-22": 1,
          "2026-01-23": 15,
          "2026-01-24": 9,
          "2026-01-26": 16,
          "2026-01-27": 5,
          "2026-01-28": 4,
          "2026-01-29": 3,
          "2026-01-30": 2,
          "2026-01-31": 1,
          "2026-02-02": 12,
          "2026-02-03": 24,
          "2026-02-04": 4,
          "2026-02-05": 8,
          "2026-02-06": 9,
          "2026-02-07": 1,
          "2026-02-09": 13,
          "2026-02-10": 18,
          "2026-02-11": 5,
          "2026-02-12": 7,
          "2026-02-13": 18,
          "2026-02-14": 8,
          "2026-02-16": 7,
          "2026-02-17": 4,
          "2026-02-18": 19,
          "2026-02-19": 67,
          "2026-02-20": 4,
          "2026-02-21": 3,
          "2026-02-23": 13,
          "2026-02-24": 9,
          "2026-02-25": 5,
          "2026-02-26": 3,
          "2026-02-27": 2,
          "2026-02-28": 10,
          "2026-03-02": 16,
          "2026-03-03": 4,
          "2026-03-04": 10,
          "2026-03-06": 10,
          "2026-03-09": 16,
          "2026-03-10": 7,
          "2026-03-11": 16,
          "2026-03-12": 12,
          "2026-03-13": 11,
          "2026-03-14": 5,
          "2026-03-16": 8,
          "2026-03-17": 10,
          "2026-03-18": 59,
          "2026-03-19": 8,
          "2026-03-20": 12,
          "2026-03-21": 1,
          "2026-03-23": 3,
          "2026-03-24": 5,
          "2026-03-25": 3,
          "2026-03-26": 11,
          "2026-03-27": 5,
          "2026-03-30": 20,
          "2026-03-31": 4,
          "2026-04-01": 8,
          "2026-04-02": 2,
          "2026-04-06": 14,
          "2026-04-07": 14,
          "2026-04-08": 12,
          "2026-04-09": 3,
          "2026-04-10": 21,
          "2026-04-11": 2,
          "2026-04-13": 12,
          "2026-04-14": 10,
          "2026-04-15": 7,
          "2026-04-16": 6,
          "2026-04-17": 7,
          "2026-04-18": 5,
          "2026-04-20": 9,
          "2026-04-21": 4,
          "2026-04-22": 18,
          "2026-04-23": 14,
          "2026-04-24": 7,
          "2026-04-27": 16,
          "2026-04-28": 13,
          "2026-04-29": 11,
          "2026-04-30": 6,
          "2026-05-02": 3,
          "2026-05-04": 10,
          "2026-05-05": 5,
          "2026-05-06": 5,
          "2026-05-07": 6,
          "2026-05-08": 1,
          "2026-05-11": 3,
          "2026-05-12": 2,
          "2026-05-13": 1,
          "2026-05-14": 10,
          "2026-05-16": 1,
          "2026-05-18": 2,
          "2026-05-19": 4,
          "2026-05-20": 9,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-23": 1,
          "2026-05-25": 2,
          "2026-05-26": 6,
          "2026-05-28": 1,
          "2026-05-29": 3,
          "2026-06-01": 5,
          "2026-06-02": 2,
          "2026-06-03": 2,
          "2026-06-04": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-09-30": 0.576358888888889,
          "2025-10-08": 1.9572552777777776,
          "2025-10-09": 246.67860222222222,
          "2025-10-10": 140.59894638888886,
          "2025-10-13": 12.94264138888889,
          "2025-10-14": 429.95017916666666,
          "2025-10-15": 150.88691138888888,
          "2025-10-16": 198.45461000000003,
          "2025-10-17": 111.8887025,
          "2025-10-20": 34.65188222222223,
          "2025-10-21": 40.20449138888889,
          "2025-10-22": 232.56774083333332,
          "2025-10-23": 999.5927541666666,
          "2025-10-24": 111.170225,
          "2025-10-27": 443.92410361111115,
          "2025-10-28": 623.6641997222223,
          "2025-10-29": 92.46663833333331,
          "2025-10-30": 351.6774422222221,
          "2025-10-31": 257.2903758333333,
          "2025-11-02": 6.409595277777778,
          "2025-11-03": 713.882495,
          "2025-11-04": 741.386376388889,
          "2025-11-05": 524.8881144444445,
          "2025-11-06": 731.0627066666666,
          "2025-11-07": 36.66560194444444,
          "2025-11-10": 659.8165105555556,
          "2025-11-11": 96.33133250000002,
          "2025-11-12": 1136.1566458333334,
          "2025-11-13": 150.1151461111111,
          "2025-11-14": 965.0590733333333,
          "2025-11-16": 1.4783980555555556,
          "2025-11-17": 267.9176944444444,
          "2025-11-18": 1007.7596824999999,
          "2025-11-19": 209.43338111111115,
          "2025-11-20": 527.8912783333333,
          "2025-11-21": 991.5900869444445,
          "2025-11-22": 48.57978222222222,
          "2025-11-23": 5.603014444444445,
          "2025-11-24": 686.5224791666666,
          "2025-11-25": 588.2081252777778,
          "2025-11-26": 619.4595397222222,
          "2025-11-27": 913.5078474999999,
          "2025-11-28": 426.34451722222224,
          "2025-11-29": 2122.365774722222,
          "2025-11-30": 43.668389166666664,
          "2025-12-02": 2133.5600322222217,
          "2025-12-03": 1261.8031533333337,
          "2025-12-04": 1044.3076105555556,
          "2025-12-05": 634.1759652777778,
          "2025-12-06": 53.61010166666667,
          "2025-12-09": 208.70741083333337,
          "2025-12-10": 985.8019524999999,
          "2025-12-11": 1231.3638577777776,
          "2025-12-12": 1806.7238383333333,
          "2025-12-13": 22.036010277777777,
          "2025-12-14": 4.941235833333334,
          "2025-12-15": 3263.1213347222224,
          "2025-12-16": 916.4167808333333,
          "2025-12-17": 22.995979999999996,
          "2025-12-18": 50.02964111111112,
          "2025-12-19": 1079.8213972222225,
          "2025-12-22": 136.67121694444447,
          "2025-12-23": 55.47709333333333,
          "2025-12-24": 528.5530186111112,
          "2025-12-26": 499.67036277777777,
          "2025-12-29": 1803.6595038888888,
          "2025-12-31": 1798.498091111111,
          "2026-01-02": 173.11062444444445,
          "2026-01-03": 0.17937916666666667,
          "2026-01-05": 14.399536944444446,
          "2026-01-06": 180.1106327777778,
          "2026-01-07": 2708.654718611111,
          "2026-01-08": 1818.6551472222222,
          "2026-01-09": 1457.8180711111108,
          "2026-01-10": 35.056598888888885,
          "2026-01-11": 317.47465611111113,
          "2026-01-12": 43.40318361111112,
          "2026-01-13": 561.1487083333333,
          "2026-01-14": 13.799904722222221,
          "2026-01-15": 44.47461416666667,
          "2026-01-16": 19.838945555555554,
          "2026-01-17": 331.0085661111111,
          "2026-01-18": 36.801215,
          "2026-01-19": 61.61098166666666,
          "2026-01-20": 61.26920777777777,
          "2026-01-21": 13.356034166666667,
          "2026-01-22": 4.0281633333333335,
          "2026-01-23": 2667.344846388889,
          "2026-01-24": 1668.9001052777778,
          "2026-01-26": 193.37172305555558,
          "2026-01-27": 656.2210575,
          "2026-01-28": 18.88968527777778,
          "2026-01-29": 5.004430277777778,
          "2026-01-30": 605.2924308333334,
          "2026-01-31": 94.91649527777777,
          "2026-02-02": 355.23847833333326,
          "2026-02-03": 5901.14019777778,
          "2026-02-04": 646.947288611111,
          "2026-02-05": 860.9628672222223,
          "2026-02-06": 4107.893561666667,
          "2026-02-07": 61.669156111111114,
          "2026-02-09": 232.98623638888893,
          "2026-02-10": 5329.5985386111115,
          "2026-02-11": 229.20677194444445,
          "2026-02-12": 4070.207493888889,
          "2026-02-13": 4995.862341944444,
          "2026-02-14": 67.48531055555557,
          "2026-02-16": 678.9704405555556,
          "2026-02-17": 536.9066458333334,
          "2026-02-18": 3842.7056941666665,
          "2026-02-19": 38601.76643166667,
          "2026-02-20": 1584.9742455555554,
          "2026-02-21": 23.005583055555558,
          "2026-02-23": 587.8648902777777,
          "2026-02-24": 14.090424722222222,
          "2026-02-25": 18.993416388888892,
          "2026-02-26": 2.2268499999999998,
          "2026-02-27": 30.469789722222224,
          "2026-02-28": 696.4292952777778,
          "2026-03-02": 1685.773158888889,
          "2026-03-03": 14.629023333333333,
          "2026-03-04": 82.88029277777778,
          "2026-03-06": 9.841352777777775,
          "2026-03-09": 5766.40939638889,
          "2026-03-10": 997.8927819444446,
          "2026-03-11": 828.3813258333336,
          "2026-03-12": 51.470911388888894,
          "2026-03-13": 24.883514722222223,
          "2026-03-14": 77.61068222222222,
          "2026-03-16": 162.89780972222223,
          "2026-03-17": 3035.773606944445,
          "2026-03-18": 14887.780328611116,
          "2026-03-19": 7.090382499999999,
          "2026-03-20": 7584.365625,
          "2026-03-23": 1.3219516666666666,
          "2026-03-24": 58.54782055555556,
          "2026-03-25": 1.7215894444444446,
          "2026-03-26": 22.187801388888886,
          "2026-03-27": 1.574491111111111,
          "2026-03-30": 1429.7034247222223,
          "2026-03-31": 42.3624175,
          "2026-04-01": 40.434483333333326,
          "2026-04-02": 0.9695430555555555,
          "2026-04-06": 109.13554083333331,
          "2026-04-07": 1146.1199252777778,
          "2026-04-08": 54.42757027777778,
          "2026-04-09": 4.3895719444444445,
          "2026-04-10": 1462.916945277778,
          "2026-04-11": 4.518258888888889,
          "2026-04-13": 2231.981999166667,
          "2026-04-14": 24.88372638888889,
          "2026-04-15": 23.08744861111111,
          "2026-04-16": 7.5042447222222215,
          "2026-04-17": 14.558940555555555,
          "2026-04-18": 74.51195166666668,
          "2026-04-20": 173.78219055555556,
          "2026-04-21": 263.8170744444445,
          "2026-04-22": 1159.1678791666668,
          "2026-04-23": 6472.359143888889,
          "2026-04-24": 22.27381722222222,
          "2026-04-27": 11.158858333333335,
          "2026-04-28": 154.75705916666664,
          "2026-04-29": 26.216341944444444,
          "2026-04-30": 132.81982583333334,
          "2026-05-02": 11.237937777777777,
          "2026-05-04": 2951.766945,
          "2026-05-05": 9.649476388888889,
          "2026-05-06": 2338.9541622222227,
          "2026-05-07": 357.0003305555556,
          "2026-05-08": 1361.2413838888888,
          "2026-05-11": 5.4162791666666665,
          "2026-05-12": 3.441718888888889,
          "2026-05-13": 28.50823805555556,
          "2026-05-14": 4054.583642777777,
          "2026-05-16": 1.6307119444444445,
          "2026-05-18": 4.347391944444444,
          "2026-05-19": 8.075175833333333,
          "2026-05-20": 2.5878547222222226,
          "2026-05-21": 16.911079166666667,
          "2026-05-22": 2.6794813888888886,
          "2026-05-25": 88.23298416666667,
          "2026-05-26": 2172.4818986111113,
          "2026-05-29": 2450.5144863888886,
          "2026-06-01": 111.95712194444444,
          "2026-06-02": 0.5801372222222222,
          "2026-06-03": 0.20785555555555554,
          "2026-06-04": 888.8700166666666,
          "2026-06-08": 0.3223972222222223
        },
        "time_count_per_day": {
          "2025-09-30": 4,
          "2025-10-08": 5,
          "2025-10-09": 5,
          "2025-10-10": 6,
          "2025-10-13": 2,
          "2025-10-14": 10,
          "2025-10-15": 5,
          "2025-10-16": 5,
          "2025-10-17": 3,
          "2025-10-20": 4,
          "2025-10-21": 1,
          "2025-10-22": 6,
          "2025-10-23": 14,
          "2025-10-24": 4,
          "2025-10-27": 8,
          "2025-10-28": 12,
          "2025-10-29": 8,
          "2025-10-30": 13,
          "2025-10-31": 10,
          "2025-11-02": 1,
          "2025-11-03": 6,
          "2025-11-04": 2,
          "2025-11-05": 6,
          "2025-11-06": 8,
          "2025-11-07": 3,
          "2025-11-10": 10,
          "2025-11-11": 8,
          "2025-11-12": 6,
          "2025-11-13": 5,
          "2025-11-14": 8,
          "2025-11-16": 1,
          "2025-11-17": 5,
          "2025-11-18": 7,
          "2025-11-19": 6,
          "2025-11-20": 14,
          "2025-11-21": 12,
          "2025-11-22": 1,
          "2025-11-23": 2,
          "2025-11-24": 15,
          "2025-11-25": 4,
          "2025-11-26": 9,
          "2025-11-27": 4,
          "2025-11-28": 5,
          "2025-11-29": 10,
          "2025-11-30": 1,
          "2025-12-02": 17,
          "2025-12-03": 17,
          "2025-12-04": 10,
          "2025-12-05": 9,
          "2025-12-06": 1,
          "2025-12-09": 4,
          "2025-12-10": 7,
          "2025-12-11": 8,
          "2025-12-12": 9,
          "2025-12-13": 1,
          "2025-12-14": 2,
          "2025-12-15": 18,
          "2025-12-16": 11,
          "2025-12-17": 2,
          "2025-12-18": 1,
          "2025-12-19": 7,
          "2025-12-22": 4,
          "2025-12-23": 10,
          "2025-12-24": 1,
          "2025-12-26": 8,
          "2025-12-29": 10,
          "2025-12-31": 3,
          "2026-01-02": 4,
          "2026-01-03": 1,
          "2026-01-05": 5,
          "2026-01-06": 14,
          "2026-01-07": 14,
          "2026-01-08": 15,
          "2026-01-09": 10,
          "2026-01-10": 4,
          "2026-01-11": 1,
          "2026-01-12": 9,
          "2026-01-13": 15,
          "2026-01-14": 4,
          "2026-01-15": 10,
          "2026-01-16": 4,
          "2026-01-17": 3,
          "2026-01-18": 3,
          "2026-01-19": 7,
          "2026-01-20": 7,
          "2026-01-21": 3,
          "2026-01-22": 1,
          "2026-01-23": 15,
          "2026-01-24": 9,
          "2026-01-26": 16,
          "2026-01-27": 5,
          "2026-01-28": 4,
          "2026-01-29": 3,
          "2026-01-30": 2,
          "2026-01-31": 1,
          "2026-02-02": 12,
          "2026-02-03": 24,
          "2026-02-04": 4,
          "2026-02-05": 8,
          "2026-02-06": 9,
          "2026-02-07": 1,
          "2026-02-09": 13,
          "2026-02-10": 18,
          "2026-02-11": 5,
          "2026-02-12": 7,
          "2026-02-13": 18,
          "2026-02-14": 8,
          "2026-02-16": 7,
          "2026-02-17": 2,
          "2026-02-18": 17,
          "2026-02-19": 67,
          "2026-02-20": 4,
          "2026-02-21": 3,
          "2026-02-23": 12,
          "2026-02-24": 9,
          "2026-02-25": 5,
          "2026-02-26": 3,
          "2026-02-27": 2,
          "2026-02-28": 10,
          "2026-03-02": 15,
          "2026-03-03": 4,
          "2026-03-04": 9,
          "2026-03-06": 10,
          "2026-03-09": 14,
          "2026-03-10": 5,
          "2026-03-11": 13,
          "2026-03-12": 12,
          "2026-03-13": 11,
          "2026-03-14": 5,
          "2026-03-16": 8,
          "2026-03-17": 10,
          "2026-03-18": 59,
          "2026-03-19": 8,
          "2026-03-20": 11,
          "2026-03-23": 2,
          "2026-03-24": 5,
          "2026-03-25": 3,
          "2026-03-26": 10,
          "2026-03-27": 4,
          "2026-03-30": 19,
          "2026-03-31": 4,
          "2026-04-01": 6,
          "2026-04-02": 1,
          "2026-04-06": 14,
          "2026-04-07": 12,
          "2026-04-08": 12,
          "2026-04-09": 3,
          "2026-04-10": 20,
          "2026-04-11": 2,
          "2026-04-13": 12,
          "2026-04-14": 10,
          "2026-04-15": 5,
          "2026-04-16": 6,
          "2026-04-17": 7,
          "2026-04-18": 4,
          "2026-04-20": 9,
          "2026-04-21": 4,
          "2026-04-22": 16,
          "2026-04-23": 12,
          "2026-04-24": 6,
          "2026-04-27": 14,
          "2026-04-28": 12,
          "2026-04-29": 5,
          "2026-04-30": 5,
          "2026-05-02": 3,
          "2026-05-04": 9,
          "2026-05-05": 5,
          "2026-05-06": 5,
          "2026-05-07": 6,
          "2026-05-08": 1,
          "2026-05-11": 2,
          "2026-05-12": 2,
          "2026-05-13": 1,
          "2026-05-14": 10,
          "2026-05-16": 1,
          "2026-05-18": 2,
          "2026-05-19": 4,
          "2026-05-20": 9,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-25": 2,
          "2026-05-26": 6,
          "2026-05-29": 3,
          "2026-06-01": 5,
          "2026-06-02": 2,
          "2026-06-03": 1,
          "2026-06-04": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 141.9,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 1,
            "4-6h": 1,
            "20-22h": 1,
            "50-52h": 1,
            "166-168h": 1,
            "310-312h": 1,
            "410-412h": 1,
            "650-652h": 1,
            "780-782h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-10-16": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-12-03": 2,
            "2025-12-04": 1,
            "2025-12-23": 1,
            "2026-01-08": 2,
            "2026-01-23": 2,
            "2026-02-03": 1,
            "2026-02-26": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-14": 1,
            "2026-04-10": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-16": 0.7195861111111111,
            "2025-10-27": 2.995404166666667,
            "2025-10-28": 20.40406861111111,
            "2025-12-03": 6.9707825,
            "2025-12-04": 1.669495,
            "2025-12-23": 0.6058288888888889,
            "2026-01-08": 703.2076830555557,
            "2026-01-23": 577.8482425,
            "2026-02-03": 311.45288416666665,
            "2026-02-26": 1.668902222222222,
            "2026-03-06": 0.9276636111111111,
            "2026-03-10": 780.9277716666667,
            "2026-03-14": 1.4962497222222222,
            "2026-04-10": 1.3674869444444446
          },
          "time_count_per_day": {
            "2025-10-16": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-12-03": 2,
            "2025-12-04": 1,
            "2025-12-23": 1,
            "2026-01-08": 2,
            "2026-01-23": 2,
            "2026-02-03": 1,
            "2026-02-26": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-14": 1,
            "2026-04-10": 1
          }
        },
        "P2": {
          "avg_time_hours": 74.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 405,
          "time_distribution": {
            "0-2h": 405,
            "2-4h": 136,
            "4-6h": 59,
            "6-8h": 38,
            "8-10h": 17,
            "10-12h": 9,
            "12-14h": 11,
            "14-16h": 9,
            "16-18h": 11,
            "18-20h": 14,
            "20-22h": 6,
            "22-24h": 5,
            "24-26h": 6,
            "26-28h": 3,
            "28-30h": 4,
            "30-32h": 2,
            "32-34h": 1,
            "36-38h": 1,
            "40-42h": 2,
            "44-46h": 5,
            "46-48h": 2,
            "50-52h": 1,
            "54-56h": 2,
            "56-58h": 1,
            "58-60h": 1,
            "64-66h": 1,
            "66-68h": 1,
            "72-74h": 1,
            "74-76h": 3,
            "76-78h": 1,
            "78-80h": 1,
            "86-88h": 1,
            "88-90h": 1,
            "90-92h": 1,
            "92-94h": 1,
            "96-98h": 2,
            "98-100h": 1,
            "100-102h": 2,
            "102-104h": 1,
            "122-124h": 2,
            "126-128h": 2,
            "138-140h": 1,
            "146-148h": 4,
            "160-162h": 1,
            "162-164h": 1,
            "164-166h": 2,
            "166-168h": 1,
            "168-170h": 1,
            "198-200h": 1,
            "200-202h": 2,
            "212-214h": 1,
            "216-218h": 1,
            "218-220h": 2,
            "222-224h": 1,
            "228-230h": 1,
            "234-236h": 2,
            "262-264h": 1,
            "268-270h": 1,
            "286-288h": 3,
            "312-314h": 1,
            "316-318h": 1,
            "330-332h": 1,
            "332-334h": 2,
            "336-338h": 1,
            "340-342h": 3,
            "342-344h": 1,
            "348-350h": 2,
            "368-370h": 1,
            "378-380h": 1,
            "390-392h": 1,
            "408-410h": 1,
            "412-414h": 1,
            "436-438h": 1,
            "454-456h": 2,
            "486-488h": 1,
            "488-490h": 1,
            "508-510h": 1,
            "550-552h": 1,
            "610-612h": 1,
            "624-626h": 1,
            "630-632h": 1,
            "650-652h": 1,
            "654-656h": 1,
            "672-674h": 1,
            "684-686h": 1,
            "738-740h": 1,
            "746-748h": 2,
            "796-798h": 1,
            "798-800h": 1,
            "826-828h": 1,
            "834-836h": 1,
            "842-844h": 1,
            "846-848h": 1,
            "862-864h": 1,
            "866-868h": 1,
            "888-890h": 1,
            "914-916h": 1,
            "1028-1030h": 1,
            "1052-1054h": 1,
            "1058-1060h": 1,
            "1068-1070h": 1,
            "1092-1094h": 1,
            "1102-1104h": 1,
            "1134-1136h": 1,
            "1166-1168h": 1,
            "1170-1172h": 1,
            "1200-1202h": 1,
            "1208-1210h": 1,
            "1228-1230h": 1,
            "1248-1250h": 2,
            "1272-1274h": 1,
            "1314-1316h": 1,
            "1360-1362h": 1,
            "1514-1516h": 1,
            "1532-1534h": 1,
            "1728-1730h": 1,
            "1842-1844h": 1,
            "2158-2160h": 1
          },
          "tickets_count": 880,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-08": 5,
            "2025-10-09": 1,
            "2025-10-10": 4,
            "2025-10-14": 7,
            "2025-10-15": 2,
            "2025-10-20": 2,
            "2025-10-22": 3,
            "2025-10-23": 3,
            "2025-10-24": 4,
            "2025-10-27": 4,
            "2025-10-28": 10,
            "2025-10-29": 6,
            "2025-10-30": 3,
            "2025-10-31": 5,
            "2025-11-02": 1,
            "2025-11-03": 3,
            "2025-11-04": 1,
            "2025-11-05": 2,
            "2025-11-06": 5,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 6,
            "2025-11-12": 3,
            "2025-11-13": 5,
            "2025-11-14": 2,
            "2025-11-16": 1,
            "2025-11-17": 2,
            "2025-11-18": 2,
            "2025-11-19": 3,
            "2025-11-20": 3,
            "2025-11-21": 4,
            "2025-11-23": 2,
            "2025-11-24": 10,
            "2025-11-25": 2,
            "2025-11-26": 9,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-12-02": 9,
            "2025-12-03": 8,
            "2025-12-04": 3,
            "2025-12-05": 3,
            "2025-12-09": 1,
            "2025-12-11": 3,
            "2025-12-12": 5,
            "2025-12-13": 1,
            "2025-12-14": 2,
            "2025-12-15": 9,
            "2025-12-16": 2,
            "2025-12-17": 1,
            "2025-12-19": 3,
            "2025-12-22": 1,
            "2025-12-23": 3,
            "2025-12-26": 5,
            "2025-12-29": 6,
            "2025-12-31": 2,
            "2026-01-02": 4,
            "2026-01-03": 1,
            "2026-01-05": 2,
            "2026-01-06": 13,
            "2026-01-07": 10,
            "2026-01-08": 7,
            "2026-01-09": 5,
            "2026-01-10": 4,
            "2026-01-11": 1,
            "2026-01-12": 7,
            "2026-01-13": 6,
            "2026-01-14": 3,
            "2026-01-15": 9,
            "2026-01-16": 4,
            "2026-01-17": 1,
            "2026-01-19": 4,
            "2026-01-20": 5,
            "2026-01-21": 3,
            "2026-01-23": 6,
            "2026-01-26": 11,
            "2026-01-27": 2,
            "2026-01-28": 3,
            "2026-01-29": 2,
            "2026-01-30": 1,
            "2026-02-02": 3,
            "2026-02-03": 10,
            "2026-02-04": 2,
            "2026-02-05": 3,
            "2026-02-06": 2,
            "2026-02-09": 7,
            "2026-02-10": 6,
            "2026-02-11": 4,
            "2026-02-12": 5,
            "2026-02-13": 17,
            "2026-02-14": 5,
            "2026-02-16": 7,
            "2026-02-17": 1,
            "2026-02-18": 11,
            "2026-02-19": 8,
            "2026-02-20": 2,
            "2026-02-21": 2,
            "2026-02-23": 9,
            "2026-02-24": 4,
            "2026-02-25": 5,
            "2026-02-26": 2,
            "2026-02-27": 2,
            "2026-02-28": 1,
            "2026-03-02": 14,
            "2026-03-03": 4,
            "2026-03-04": 9,
            "2026-03-06": 9,
            "2026-03-09": 14,
            "2026-03-10": 5,
            "2026-03-11": 13,
            "2026-03-12": 12,
            "2026-03-13": 11,
            "2026-03-14": 2,
            "2026-03-16": 8,
            "2026-03-17": 4,
            "2026-03-18": 6,
            "2026-03-19": 8,
            "2026-03-20": 8,
            "2026-03-23": 3,
            "2026-03-24": 3,
            "2026-03-25": 3,
            "2026-03-26": 10,
            "2026-03-27": 4,
            "2026-03-30": 17,
            "2026-03-31": 4,
            "2026-04-01": 6,
            "2026-04-02": 2,
            "2026-04-06": 14,
            "2026-04-07": 11,
            "2026-04-08": 12,
            "2026-04-09": 3,
            "2026-04-10": 20,
            "2026-04-11": 2,
            "2026-04-13": 12,
            "2026-04-14": 10,
            "2026-04-15": 7,
            "2026-04-16": 6,
            "2026-04-17": 7,
            "2026-04-18": 4,
            "2026-04-20": 9,
            "2026-04-21": 4,
            "2026-04-22": 9,
            "2026-04-23": 13,
            "2026-04-24": 6,
            "2026-04-27": 14,
            "2026-04-28": 12,
            "2026-04-29": 5,
            "2026-04-30": 5,
            "2026-05-02": 3,
            "2026-05-04": 9,
            "2026-05-05": 5,
            "2026-05-06": 4,
            "2026-05-07": 5,
            "2026-05-08": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 1,
            "2026-05-14": 9,
            "2026-05-16": 1,
            "2026-05-18": 2,
            "2026-05-19": 4,
            "2026-05-20": 9,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 2,
            "2026-05-26": 6,
            "2026-05-29": 1,
            "2026-06-01": 5,
            "2026-06-02": 2,
            "2026-06-03": 1,
            "2026-06-04": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-09-30": 0.576358888888889,
            "2025-10-08": 1.9572552777777776,
            "2025-10-09": 0.5231627777777778,
            "2025-10-10": 24.381331666666668,
            "2025-10-14": 186.49039305555556,
            "2025-10-15": 26.781140555555556,
            "2025-10-20": 5.253918055555555,
            "2025-10-22": 91.45513944444446,
            "2025-10-23": 22.869139722222222,
            "2025-10-24": 111.170225,
            "2025-10-27": 277.2945041666667,
            "2025-10-28": 490.48698250000007,
            "2025-10-29": 21.04014638888889,
            "2025-10-30": 74.9897938888889,
            "2025-10-31": 18.477401111111114,
            "2025-11-02": 6.409595277777778,
            "2025-11-03": 94.28831805555555,
            "2025-11-04": 91.49926194444444,
            "2025-11-05": 207.86891666666665,
            "2025-11-06": 256.6397880555555,
            "2025-11-07": 0.15936722222222222,
            "2025-11-10": 4.726127777777778,
            "2025-11-11": 24.498576666666665,
            "2025-11-12": 4.288109722222222,
            "2025-11-13": 150.1151461111111,
            "2025-11-14": 560.8657166666667,
            "2025-11-16": 1.4783980555555556,
            "2025-11-17": 28.10147444444444,
            "2025-11-18": 160.94368555555556,
            "2025-11-19": 1.8305375000000002,
            "2025-11-20": 2.1219913888888886,
            "2025-11-21": 552.8373797222222,
            "2025-11-23": 5.603014444444445,
            "2025-11-24": 12.508761111111111,
            "2025-11-25": 3.2632455555555557,
            "2025-11-26": 230.3195188888889,
            "2025-11-27": 1.0805713888888888,
            "2025-11-28": 2.469957222222222,
            "2025-11-29": 2.029996111111111,
            "2025-12-02": 704.2144563888888,
            "2025-12-03": 15.371003333333336,
            "2025-12-04": 857.9545108333333,
            "2025-12-05": 1.4239986111111111,
            "2025-12-09": 3.1795427777777774,
            "2025-12-11": 869.6431069444445,
            "2025-12-12": 1416.4382313888889,
            "2025-12-13": 22.036010277777777,
            "2025-12-14": 4.941235833333334,
            "2025-12-15": 1424.1066244444446,
            "2025-12-16": 1.0964702777777777,
            "2025-12-17": 4.8725572222222215,
            "2025-12-19": 2.2754119444444445,
            "2025-12-23": 22.961467222222222,
            "2025-12-26": 82.99106777777776,
            "2025-12-29": 458.0886625,
            "2025-12-31": 1.5147458333333335,
            "2026-01-02": 173.11062444444445,
            "2026-01-03": 0.17937916666666667,
            "2026-01-05": 2.703323055555556,
            "2026-01-06": 175.3423088888889,
            "2026-01-07": 1208.5136463888887,
            "2026-01-08": 157.49024583333335,
            "2026-01-09": 9.329468888888888,
            "2026-01-10": 35.056598888888885,
            "2026-01-11": 317.47465611111113,
            "2026-01-12": 32.2236575,
            "2026-01-13": 26.280669722222225,
            "2026-01-14": 12.485874444444445,
            "2026-01-15": 43.850433611111114,
            "2026-01-16": 19.838945555555554,
            "2026-01-17": 0.12519111111111111,
            "2026-01-19": 13.342391388888888,
            "2026-01-20": 37.25074333333333,
            "2026-01-21": 13.356034166666667,
            "2026-01-23": 1348.0419227777777,
            "2026-01-26": 29.257969999999997,
            "2026-01-27": 5.218471111111111,
            "2026-01-28": 15.470024166666667,
            "2026-01-29": 4.5240422222222225,
            "2026-01-30": 0.8958030555555556,
            "2026-02-02": 38.85133194444445,
            "2026-02-03": 3186.9013486111107,
            "2026-02-04": 7.928804722222222,
            "2026-02-05": 11.267988055555556,
            "2026-02-06": 1843.4406733333333,
            "2026-02-09": 35.85369083333334,
            "2026-02-10": 1113.1750994444446,
            "2026-02-11": 1.1472858333333333,
            "2026-02-12": 2192.3711280555563,
            "2026-02-13": 3139.361541111111,
            "2026-02-14": 19.9124325,
            "2026-02-16": 678.9704405555556,
            "2026-02-17": 0.07940416666666668,
            "2026-02-18": 1276.5188744444447,
            "2026-02-19": 23.489661666666667,
            "2026-02-20": 224.10161722222225,
            "2026-02-21": 1.1873066666666667,
            "2026-02-23": 441.72652277777775,
            "2026-02-24": 7.139080833333332,
            "2026-02-25": 18.993416388888892,
            "2026-02-26": 0.5579477777777777,
            "2026-02-27": 30.469789722222224,
            "2026-02-28": 40.25651138888889,
            "2026-03-02": 96.15876444444443,
            "2026-03-03": 14.629023333333333,
            "2026-03-04": 82.88029277777778,
            "2026-03-06": 8.913689166666666,
            "2026-03-09": 5766.40939638889,
            "2026-03-10": 216.9650102777778,
            "2026-03-11": 828.3813258333336,
            "2026-03-12": 51.470911388888894,
            "2026-03-13": 24.883514722222223,
            "2026-03-14": 13.849366944444446,
            "2026-03-16": 162.89780972222223,
            "2026-03-17": 1972.3397155555556,
            "2026-03-18": 11.658672777777777,
            "2026-03-19": 7.090382499999999,
            "2026-03-20": 6221.1217680555565,
            "2026-03-23": 1.3219516666666666,
            "2026-03-24": 5.794600833333334,
            "2026-03-25": 1.7215894444444446,
            "2026-03-26": 15.5313925,
            "2026-03-27": 1.574491111111111,
            "2026-03-30": 1231.2657358333333,
            "2026-03-31": 42.3624175,
            "2026-04-01": 40.434483333333326,
            "2026-04-02": 0.9695430555555555,
            "2026-04-06": 109.13554083333331,
            "2026-04-07": 1145.3230641666667,
            "2026-04-08": 54.42757027777778,
            "2026-04-09": 4.3895719444444445,
            "2026-04-10": 1461.5494583333336,
            "2026-04-11": 4.518258888888889,
            "2026-04-13": 2231.981999166667,
            "2026-04-14": 24.88372638888889,
            "2026-04-15": 23.08744861111111,
            "2026-04-16": 7.5042447222222215,
            "2026-04-17": 14.558940555555555,
            "2026-04-18": 74.51195166666668,
            "2026-04-20": 173.78219055555556,
            "2026-04-21": 263.8170744444445,
            "2026-04-22": 4.608050555555556,
            "2026-04-23": 6472.359143888889,
            "2026-04-24": 22.27381722222222,
            "2026-04-27": 11.158858333333335,
            "2026-04-28": 154.75705916666664,
            "2026-04-29": 26.216341944444444,
            "2026-04-30": 132.81982583333334,
            "2026-05-02": 11.237937777777777,
            "2026-05-04": 2378.217475833333,
            "2026-05-05": 9.649476388888889,
            "2026-05-06": 491.9489075,
            "2026-05-07": 7.389924166666667,
            "2026-05-08": 1361.2413838888888,
            "2026-05-11": 5.4162791666666665,
            "2026-05-12": 3.441718888888889,
            "2026-05-13": 28.50823805555556,
            "2026-05-14": 17.280848888888887,
            "2026-05-16": 1.6307119444444445,
            "2026-05-18": 4.347391944444444,
            "2026-05-19": 8.075175833333333,
            "2026-05-20": 2.5878547222222226,
            "2026-05-21": 16.911079166666667,
            "2026-05-22": 2.6794813888888886,
            "2026-05-25": 88.23298416666667,
            "2026-05-26": 2172.4818986111113,
            "2026-05-29": 3.482580277777778,
            "2026-06-01": 111.95712194444444,
            "2026-06-02": 0.5801372222222222,
            "2026-06-03": 0.20785555555555554,
            "2026-06-04": 888.8700166666666,
            "2026-06-08": 0.3223972222222223
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-08": 5,
            "2025-10-09": 1,
            "2025-10-10": 4,
            "2025-10-14": 7,
            "2025-10-15": 2,
            "2025-10-20": 2,
            "2025-10-22": 3,
            "2025-10-23": 3,
            "2025-10-24": 4,
            "2025-10-27": 4,
            "2025-10-28": 10,
            "2025-10-29": 6,
            "2025-10-30": 3,
            "2025-10-31": 5,
            "2025-11-02": 1,
            "2025-11-03": 3,
            "2025-11-04": 1,
            "2025-11-05": 2,
            "2025-11-06": 5,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 6,
            "2025-11-12": 3,
            "2025-11-13": 5,
            "2025-11-14": 2,
            "2025-11-16": 1,
            "2025-11-17": 2,
            "2025-11-18": 2,
            "2025-11-19": 3,
            "2025-11-20": 3,
            "2025-11-21": 4,
            "2025-11-23": 2,
            "2025-11-24": 10,
            "2025-11-25": 2,
            "2025-11-26": 8,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-12-02": 9,
            "2025-12-03": 8,
            "2025-12-04": 3,
            "2025-12-05": 3,
            "2025-12-09": 1,
            "2025-12-11": 3,
            "2025-12-12": 5,
            "2025-12-13": 1,
            "2025-12-14": 2,
            "2025-12-15": 9,
            "2025-12-16": 2,
            "2025-12-17": 1,
            "2025-12-19": 3,
            "2025-12-23": 3,
            "2025-12-26": 5,
            "2025-12-29": 6,
            "2025-12-31": 2,
            "2026-01-02": 4,
            "2026-01-03": 1,
            "2026-01-05": 2,
            "2026-01-06": 13,
            "2026-01-07": 10,
            "2026-01-08": 6,
            "2026-01-09": 5,
            "2026-01-10": 4,
            "2026-01-11": 1,
            "2026-01-12": 7,
            "2026-01-13": 6,
            "2026-01-14": 3,
            "2026-01-15": 9,
            "2026-01-16": 4,
            "2026-01-17": 1,
            "2026-01-19": 4,
            "2026-01-20": 5,
            "2026-01-21": 3,
            "2026-01-23": 6,
            "2026-01-26": 11,
            "2026-01-27": 2,
            "2026-01-28": 3,
            "2026-01-29": 2,
            "2026-01-30": 1,
            "2026-02-02": 3,
            "2026-02-03": 10,
            "2026-02-04": 2,
            "2026-02-05": 3,
            "2026-02-06": 2,
            "2026-02-09": 7,
            "2026-02-10": 6,
            "2026-02-11": 4,
            "2026-02-12": 5,
            "2026-02-13": 17,
            "2026-02-14": 5,
            "2026-02-16": 7,
            "2026-02-17": 1,
            "2026-02-18": 11,
            "2026-02-19": 8,
            "2026-02-20": 2,
            "2026-02-21": 2,
            "2026-02-23": 9,
            "2026-02-24": 4,
            "2026-02-25": 5,
            "2026-02-26": 2,
            "2026-02-27": 2,
            "2026-02-28": 1,
            "2026-03-02": 13,
            "2026-03-03": 4,
            "2026-03-04": 9,
            "2026-03-06": 9,
            "2026-03-09": 14,
            "2026-03-10": 4,
            "2026-03-11": 13,
            "2026-03-12": 12,
            "2026-03-13": 11,
            "2026-03-14": 2,
            "2026-03-16": 8,
            "2026-03-17": 4,
            "2026-03-18": 6,
            "2026-03-19": 8,
            "2026-03-20": 7,
            "2026-03-23": 2,
            "2026-03-24": 3,
            "2026-03-25": 3,
            "2026-03-26": 9,
            "2026-03-27": 4,
            "2026-03-30": 17,
            "2026-03-31": 4,
            "2026-04-01": 6,
            "2026-04-02": 1,
            "2026-04-06": 14,
            "2026-04-07": 11,
            "2026-04-08": 12,
            "2026-04-09": 3,
            "2026-04-10": 19,
            "2026-04-11": 2,
            "2026-04-13": 12,
            "2026-04-14": 10,
            "2026-04-15": 5,
            "2026-04-16": 6,
            "2026-04-17": 7,
            "2026-04-18": 4,
            "2026-04-20": 9,
            "2026-04-21": 4,
            "2026-04-22": 9,
            "2026-04-23": 12,
            "2026-04-24": 6,
            "2026-04-27": 14,
            "2026-04-28": 12,
            "2026-04-29": 5,
            "2026-04-30": 5,
            "2026-05-02": 3,
            "2026-05-04": 8,
            "2026-05-05": 5,
            "2026-05-06": 4,
            "2026-05-07": 5,
            "2026-05-08": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 1,
            "2026-05-14": 9,
            "2026-05-16": 1,
            "2026-05-18": 2,
            "2026-05-19": 4,
            "2026-05-20": 9,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 2,
            "2026-05-26": 6,
            "2026-05-29": 1,
            "2026-06-01": 5,
            "2026-06-02": 2,
            "2026-06-03": 1,
            "2026-06-04": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 210.84,
          "mode_time_hours": 3.0,
          "mode_frequency": 25,
          "time_distribution": {
            "0-2h": 21,
            "2-4h": 25,
            "4-6h": 11,
            "6-8h": 3,
            "8-10h": 4,
            "12-14h": 5,
            "14-16h": 2,
            "18-20h": 4,
            "22-24h": 3,
            "24-26h": 8,
            "26-28h": 2,
            "30-32h": 1,
            "34-36h": 1,
            "42-44h": 1,
            "46-48h": 1,
            "60-62h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "78-80h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "118-120h": 1,
            "122-124h": 1,
            "126-128h": 1,
            "136-138h": 1,
            "150-152h": 1,
            "164-166h": 1,
            "172-174h": 1,
            "186-188h": 1,
            "194-196h": 1,
            "198-200h": 1,
            "208-210h": 1,
            "218-220h": 2,
            "232-234h": 1,
            "260-262h": 1,
            "262-264h": 1,
            "314-316h": 1,
            "364-366h": 1,
            "388-390h": 1,
            "406-408h": 1,
            "410-412h": 1,
            "432-434h": 1,
            "454-456h": 1,
            "478-480h": 1,
            "482-484h": 1,
            "492-494h": 1,
            "498-500h": 1,
            "504-506h": 1,
            "528-530h": 1,
            "532-534h": 1,
            "534-536h": 1,
            "536-538h": 1,
            "560-562h": 1,
            "578-580h": 1,
            "648-650h": 1,
            "680-682h": 2,
            "694-696h": 1,
            "720-722h": 1,
            "820-822h": 1,
            "1012-1014h": 1,
            "1250-1252h": 1,
            "1506-1508h": 1,
            "1684-1686h": 1,
            "1856-1858h": 1,
            "2304-2306h": 1,
            "4036-4038h": 1
          },
          "tickets_count": 146,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-23": 1,
            "2025-10-30": 4,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 2,
            "2025-11-07": 1,
            "2025-11-14": 4,
            "2025-11-18": 4,
            "2025-11-19": 3,
            "2025-11-20": 6,
            "2025-11-24": 2,
            "2025-11-26": 1,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-02": 2,
            "2025-12-03": 2,
            "2025-12-04": 3,
            "2025-12-09": 2,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2025-12-15": 3,
            "2025-12-16": 3,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-23": 4,
            "2025-12-24": 1,
            "2025-12-26": 2,
            "2026-01-05": 3,
            "2026-01-06": 1,
            "2026-01-07": 3,
            "2026-01-08": 2,
            "2026-01-09": 2,
            "2026-01-12": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-18": 3,
            "2026-01-19": 3,
            "2026-01-20": 2,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-02-02": 7,
            "2026-02-03": 9,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-09": 4,
            "2026-02-10": 8,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 3,
            "2026-02-20": 2,
            "2026-02-24": 5,
            "2026-03-02": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-10-14": 198.05785694444447,
            "2025-10-15": 118.00792583333333,
            "2025-10-16": 7.946609444444445,
            "2025-10-23": 233.7853338888889,
            "2025-10-30": 18.98919777777778,
            "2025-11-04": 649.8871144444445,
            "2025-11-05": 208.11751805555554,
            "2025-11-06": 82.18301555555556,
            "2025-11-07": 30.361932499999998,
            "2025-11-14": 258.91013305555555,
            "2025-11-18": 515.503408611111,
            "2025-11-19": 207.60284361111113,
            "2025-11-20": 41.25763277777778,
            "2025-11-24": 129.2334061111111,
            "2025-11-26": 389.1400208333333,
            "2025-11-27": 479.3214219444444,
            "2025-11-28": 412.73393555555555,
            "2025-11-29": 123.85818388888889,
            "2025-11-30": 43.668389166666664,
            "2025-12-02": 578.6513561111111,
            "2025-12-03": 7.999434166666666,
            "2025-12-04": 3.7277027777777776,
            "2025-12-09": 115.84634805555557,
            "2025-12-10": 136.74804944444443,
            "2025-12-11": 18.481043055555556,
            "2025-12-12": 1.2671477777777778,
            "2025-12-15": 1103.1992402777778,
            "2025-12-16": 7.9867197222222215,
            "2025-12-17": 18.123422777777776,
            "2025-12-19": 533.2183305555556,
            "2025-12-22": 70.88767138888889,
            "2025-12-23": 10.396240555555554,
            "2025-12-24": 528.5530186111112,
            "2025-12-26": 8.743221666666667,
            "2026-01-05": 11.696213888888888,
            "2026-01-06": 4.768323888888889,
            "2026-01-07": 1210.895047222222,
            "2026-01-08": 120.47082,
            "2026-01-09": 1256.0155825,
            "2026-01-12": 11.179526111111112,
            "2026-01-13": 25.51585722222222,
            "2026-01-14": 1.3140302777777777,
            "2026-01-15": 0.6241805555555556,
            "2026-01-18": 36.801215,
            "2026-01-19": 48.268590277777776,
            "2026-01-20": 24.018464444444447,
            "2026-01-22": 4.0281633333333335,
            "2026-01-23": 1.7805825,
            "2026-01-26": 11.819775,
            "2026-01-28": 3.4196611111111115,
            "2026-01-29": 0.4803880555555555,
            "2026-02-02": 16.583048333333334,
            "2026-02-03": 1173.5204983333335,
            "2026-02-04": 483.0221975,
            "2026-02-05": 173.83352694444446,
            "2026-02-07": 61.669156111111114,
            "2026-02-09": 35.695210555555555,
            "2026-02-10": 3154.4992375,
            "2026-02-12": 1685.1854513888889,
            "2026-02-13": 1856.5008008333334,
            "2026-02-17": 536.8272416666667,
            "2026-02-18": 2364.813901111111,
            "2026-02-20": 1360.8726283333333,
            "2026-02-24": 6.951343888888889,
            "2026-03-02": 1506.4725369444445,
            "2026-03-17": 1012.6697977777777,
            "2026-03-20": 1250.268898888889,
            "2026-05-14": 4037.302793888889
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-23": 1,
            "2025-10-30": 4,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 2,
            "2025-11-07": 1,
            "2025-11-14": 4,
            "2025-11-18": 4,
            "2025-11-19": 3,
            "2025-11-20": 6,
            "2025-11-24": 2,
            "2025-11-26": 1,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-02": 2,
            "2025-12-03": 2,
            "2025-12-04": 3,
            "2025-12-09": 2,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2025-12-15": 3,
            "2025-12-16": 3,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-23": 4,
            "2025-12-24": 1,
            "2025-12-26": 2,
            "2026-01-05": 3,
            "2026-01-06": 1,
            "2026-01-07": 3,
            "2026-01-08": 2,
            "2026-01-09": 2,
            "2026-01-12": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-18": 3,
            "2026-01-19": 3,
            "2026-01-20": 2,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-02-02": 7,
            "2026-02-03": 9,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-09": 4,
            "2026-02-10": 8,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 3,
            "2026-02-20": 2,
            "2026-02-24": 5,
            "2026-03-02": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-05-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 161.08,
          "mode_time_hours": 5.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 5,
            "4-6h": 10,
            "6-8h": 7,
            "8-10h": 2,
            "10-12h": 3,
            "12-14h": 2,
            "16-18h": 4,
            "20-22h": 5,
            "22-24h": 8,
            "24-26h": 4,
            "26-28h": 9,
            "28-30h": 5,
            "30-32h": 7,
            "32-34h": 1,
            "34-36h": 3,
            "36-38h": 4,
            "40-42h": 2,
            "42-44h": 4,
            "44-46h": 3,
            "46-48h": 2,
            "48-50h": 2,
            "50-52h": 5,
            "52-54h": 3,
            "54-56h": 1,
            "56-58h": 9,
            "60-62h": 1,
            "66-68h": 6,
            "68-70h": 1,
            "70-72h": 3,
            "74-76h": 2,
            "78-80h": 4,
            "80-82h": 6,
            "82-84h": 3,
            "84-86h": 1,
            "88-90h": 2,
            "90-92h": 2,
            "92-94h": 3,
            "94-96h": 2,
            "96-98h": 3,
            "98-100h": 2,
            "100-102h": 1,
            "104-106h": 1,
            "112-114h": 1,
            "114-116h": 3,
            "118-120h": 3,
            "120-122h": 2,
            "122-124h": 4,
            "124-126h": 1,
            "128-130h": 1,
            "132-134h": 1,
            "140-142h": 4,
            "142-144h": 5,
            "144-146h": 6,
            "146-148h": 4,
            "148-150h": 2,
            "150-152h": 2,
            "152-154h": 1,
            "154-156h": 1,
            "156-158h": 3,
            "160-162h": 1,
            "162-164h": 4,
            "164-166h": 6,
            "172-174h": 1,
            "174-176h": 2,
            "176-178h": 2,
            "178-180h": 1,
            "184-186h": 1,
            "192-194h": 4,
            "194-196h": 3,
            "212-214h": 1,
            "218-220h": 1,
            "228-230h": 2,
            "234-236h": 1,
            "248-250h": 2,
            "256-258h": 1,
            "276-278h": 1,
            "288-290h": 4,
            "290-292h": 2,
            "292-294h": 2,
            "294-296h": 1,
            "298-300h": 1,
            "310-312h": 2,
            "312-314h": 1,
            "316-318h": 2,
            "322-324h": 1,
            "330-332h": 2,
            "336-338h": 6,
            "348-350h": 1,
            "354-356h": 2,
            "356-358h": 2,
            "360-362h": 1,
            "362-364h": 1,
            "382-384h": 2,
            "384-386h": 3,
            "388-390h": 3,
            "390-392h": 1,
            "392-394h": 1,
            "396-398h": 1,
            "428-430h": 1,
            "432-434h": 1,
            "454-456h": 1,
            "456-458h": 2,
            "464-466h": 1,
            "466-468h": 3,
            "472-474h": 1,
            "492-494h": 1,
            "494-496h": 1,
            "496-498h": 1,
            "500-502h": 1,
            "502-504h": 2,
            "504-506h": 1,
            "508-510h": 1,
            "536-538h": 1,
            "556-558h": 1,
            "572-574h": 1,
            "604-606h": 1,
            "614-616h": 1,
            "1222-1224h": 2,
            "1846-1848h": 1
          },
          "tickets_count": 337,
          "tickets_per_day": {
            "2025-10-09": 4,
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-14": 2,
            "2025-10-15": 2,
            "2025-10-16": 3,
            "2025-10-17": 3,
            "2025-10-20": 2,
            "2025-10-21": 1,
            "2025-10-22": 3,
            "2025-10-23": 10,
            "2025-10-27": 3,
            "2025-10-28": 1,
            "2025-10-29": 2,
            "2025-10-30": 6,
            "2025-10-31": 5,
            "2025-11-03": 3,
            "2025-11-05": 3,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-14": 2,
            "2025-11-17": 3,
            "2025-11-18": 1,
            "2025-11-20": 5,
            "2025-11-21": 8,
            "2025-11-22": 1,
            "2025-11-24": 3,
            "2025-11-25": 2,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-11-29": 8,
            "2025-12-02": 6,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 3,
            "2025-12-11": 1,
            "2025-12-15": 5,
            "2025-12-16": 3,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 2,
            "2025-12-23": 1,
            "2025-12-29": 4,
            "2026-01-07": 1,
            "2026-01-08": 5,
            "2026-01-09": 3,
            "2026-01-13": 8,
            "2026-01-23": 5,
            "2026-01-24": 9,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-02": 2,
            "2026-02-03": 3,
            "2026-02-04": 1,
            "2026-02-05": 4,
            "2026-02-06": 7,
            "2026-02-09": 2,
            "2026-02-10": 4,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-14": 3,
            "2026-02-18": 4,
            "2026-02-19": 7,
            "2026-02-21": 1,
            "2026-02-23": 3,
            "2026-02-28": 9,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-14": 2,
            "2026-03-17": 5,
            "2026-03-18": 53,
            "2026-03-20": 3,
            "2026-03-24": 2,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-30": 3,
            "2026-04-01": 2,
            "2026-04-07": 3,
            "2026-04-18": 1,
            "2026-04-22": 9,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-27": 2,
            "2026-04-28": 1,
            "2026-04-29": 6,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-11": 1,
            "2026-05-23": 1,
            "2026-05-28": 1,
            "2026-05-29": 2
          },
          "time_per_day": {
            "2025-10-09": 246.15543944444445,
            "2025-10-10": 116.21761472222222,
            "2025-10-13": 12.94264138888889,
            "2025-10-14": 45.40192916666667,
            "2025-10-15": 6.097845,
            "2025-10-16": 189.78841444444447,
            "2025-10-17": 111.8887025,
            "2025-10-20": 29.397964166666668,
            "2025-10-21": 40.20449138888889,
            "2025-10-22": 141.1126013888889,
            "2025-10-23": 742.9382805555555,
            "2025-10-27": 163.63419527777776,
            "2025-10-28": 112.77314861111111,
            "2025-10-29": 71.42649194444444,
            "2025-10-30": 257.69845055555555,
            "2025-10-31": 238.81297472222226,
            "2025-11-03": 619.5941769444445,
            "2025-11-05": 108.90167972222223,
            "2025-11-06": 392.2399030555556,
            "2025-11-07": 6.1443022222222226,
            "2025-11-10": 655.0903827777778,
            "2025-11-11": 71.83275583333334,
            "2025-11-12": 1131.868536111111,
            "2025-11-14": 145.2832236111111,
            "2025-11-17": 239.81622,
            "2025-11-18": 331.31258833333334,
            "2025-11-20": 484.51165416666663,
            "2025-11-21": 438.7527072222223,
            "2025-11-22": 48.57978222222222,
            "2025-11-24": 544.7803119444445,
            "2025-11-25": 584.9448797222223,
            "2025-11-27": 433.10585416666663,
            "2025-11-28": 11.140624444444445,
            "2025-11-29": 1996.4775947222224,
            "2025-12-02": 850.6942197222222,
            "2025-12-04": 148.16303694444446,
            "2025-12-05": 145.40101916666669,
            "2025-12-09": 89.68152,
            "2025-12-10": 90.76960861111111,
            "2025-12-11": 51.37015722222222,
            "2025-12-15": 725.0372244444444,
            "2025-12-16": 46.05539333333333,
            "2025-12-18": 50.02964111111112,
            "2025-12-19": 30.144908333333333,
            "2025-12-22": 58.68871444444444,
            "2025-12-23": 20.65182777777778,
            "2025-12-29": 1345.5708413888888,
            "2026-01-07": 289.246025,
            "2026-01-08": 837.4863983333333,
            "2026-01-09": 192.4730197222222,
            "2026-01-13": 509.35218138888894,
            "2026-01-23": 462.04614972222225,
            "2026-01-24": 1668.9001052777778,
            "2026-01-26": 141.78708805555556,
            "2026-01-27": 651.0025863888889,
            "2026-01-30": 604.3966277777778,
            "2026-01-31": 94.91649527777777,
            "2026-02-02": 299.8040980555555,
            "2026-02-03": 866.3339111111111,
            "2026-02-04": 155.9962863888889,
            "2026-02-05": 675.8613522222223,
            "2026-02-06": 2264.4528883333332,
            "2026-02-09": 161.43733500000002,
            "2026-02-10": 1061.9242016666667,
            "2026-02-11": 228.0594861111111,
            "2026-02-12": 192.65091444444445,
            "2026-02-14": 47.572878055555556,
            "2026-02-18": 201.37291861111112,
            "2026-02-19": 620.0981461111111,
            "2026-02-21": 21.81827638888889,
            "2026-02-23": 146.1383675,
            "2026-02-28": 656.172783888889,
            "2026-03-02": 83.1418575,
            "2026-03-14": 62.26506555555556,
            "2026-03-17": 50.764093611111115,
            "2026-03-18": 14876.121655833336,
            "2026-03-20": 112.97495805555556,
            "2026-03-24": 52.75321972222223,
            "2026-03-26": 6.656408888888889,
            "2026-03-30": 198.43768888888889,
            "2026-04-07": 0.796861111111111,
            "2026-04-22": 1154.559828611111,
            "2026-05-04": 573.5494691666667,
            "2026-05-06": 1847.0052547222224,
            "2026-05-07": 349.61040638888886,
            "2026-05-29": 2447.031906111111
          },
          "time_count_per_day": {
            "2025-10-09": 4,
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-14": 2,
            "2025-10-15": 2,
            "2025-10-16": 3,
            "2025-10-17": 3,
            "2025-10-20": 2,
            "2025-10-21": 1,
            "2025-10-22": 3,
            "2025-10-23": 10,
            "2025-10-27": 3,
            "2025-10-28": 1,
            "2025-10-29": 2,
            "2025-10-30": 6,
            "2025-10-31": 5,
            "2025-11-03": 3,
            "2025-11-05": 3,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 2,
            "2025-11-12": 3,
            "2025-11-14": 2,
            "2025-11-17": 3,
            "2025-11-18": 1,
            "2025-11-20": 5,
            "2025-11-21": 8,
            "2025-11-22": 1,
            "2025-11-24": 3,
            "2025-11-25": 2,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-11-29": 8,
            "2025-12-02": 6,
            "2025-12-04": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 3,
            "2025-12-11": 1,
            "2025-12-15": 5,
            "2025-12-16": 3,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 2,
            "2025-12-23": 1,
            "2025-12-29": 4,
            "2026-01-07": 1,
            "2026-01-08": 5,
            "2026-01-09": 3,
            "2026-01-13": 8,
            "2026-01-23": 5,
            "2026-01-24": 9,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-02": 2,
            "2026-02-03": 3,
            "2026-02-04": 1,
            "2026-02-05": 4,
            "2026-02-06": 7,
            "2026-02-09": 2,
            "2026-02-10": 4,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-14": 3,
            "2026-02-18": 3,
            "2026-02-19": 7,
            "2026-02-21": 1,
            "2026-02-23": 3,
            "2026-02-28": 9,
            "2026-03-02": 1,
            "2026-03-14": 2,
            "2026-03-17": 5,
            "2026-03-18": 53,
            "2026-03-20": 3,
            "2026-03-24": 2,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-07": 1,
            "2026-04-22": 7,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-29": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 526.25,
          "mode_time_hours": 385.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 1,
            "8-10h": 1,
            "10-12h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "32-34h": 1,
            "42-44h": 1,
            "46-48h": 1,
            "52-54h": 1,
            "76-78h": 2,
            "90-92h": 1,
            "100-102h": 1,
            "118-120h": 1,
            "122-124h": 2,
            "134-136h": 1,
            "136-138h": 1,
            "166-168h": 1,
            "204-206h": 2,
            "216-218h": 1,
            "234-236h": 1,
            "240-242h": 1,
            "264-266h": 1,
            "276-278h": 1,
            "300-302h": 3,
            "302-304h": 1,
            "322-324h": 1,
            "334-336h": 1,
            "336-338h": 2,
            "362-364h": 1,
            "374-376h": 1,
            "382-384h": 1,
            "384-386h": 4,
            "402-404h": 1,
            "406-408h": 1,
            "408-410h": 3,
            "410-412h": 1,
            "428-430h": 1,
            "476-478h": 1,
            "486-488h": 1,
            "514-516h": 1,
            "528-530h": 1,
            "544-546h": 2,
            "546-548h": 1,
            "576-578h": 1,
            "634-636h": 1,
            "664-666h": 1,
            "688-690h": 1,
            "714-716h": 1,
            "720-722h": 1,
            "738-740h": 2,
            "740-742h": 1,
            "766-768h": 1,
            "784-786h": 1,
            "816-818h": 1,
            "1056-1058h": 1,
            "1072-1074h": 2,
            "1080-1082h": 1,
            "1124-1126h": 2,
            "1238-1240h": 1,
            "1248-1250h": 1,
            "1408-1410h": 1,
            "1416-1418h": 2,
            "1698-1700h": 1,
            "1704-1706h": 1,
            "1718-1720h": 1,
            "1796-1798h": 1,
            "2208-2210h": 1
          },
          "tickets_count": 93,
          "tickets_per_day": {
            "2025-12-03": 5,
            "2025-12-04": 1,
            "2025-12-05": 4,
            "2025-12-06": 1,
            "2025-12-10": 3,
            "2025-12-11": 3,
            "2025-12-12": 3,
            "2025-12-15": 1,
            "2025-12-16": 3,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2025-12-31": 1,
            "2026-01-17": 2,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-02-03": 1,
            "2026-02-17": 2,
            "2026-02-18": 1,
            "2026-02-19": 52,
            "2026-02-23": 1,
            "2026-03-11": 1,
            "2026-03-21": 1
          },
          "time_per_day": {
            "2025-12-03": 1231.4619333333335,
            "2025-12-04": 32.792865,
            "2025-12-05": 487.35094749999996,
            "2025-12-06": 53.61010166666667,
            "2025-12-10": 758.2842944444444,
            "2025-12-11": 291.8695505555556,
            "2025-12-12": 389.0184591666666,
            "2025-12-15": 10.778245555555555,
            "2025-12-16": 861.2781975,
            "2025-12-19": 514.182746388889,
            "2025-12-22": 7.094831111111111,
            "2025-12-23": 0.861728888888889,
            "2025-12-26": 407.93607333333335,
            "2025-12-31": 1796.9833452777777,
            "2026-01-17": 330.883375,
            "2026-01-23": 277.6279488888889,
            "2026-01-26": 10.50689,
            "2026-02-03": 362.9315555555556,
            "2026-02-19": 37958.17862388888
          },
          "time_count_per_day": {
            "2025-12-03": 5,
            "2025-12-04": 1,
            "2025-12-05": 4,
            "2025-12-06": 1,
            "2025-12-10": 3,
            "2025-12-11": 3,
            "2025-12-12": 3,
            "2025-12-15": 1,
            "2025-12-16": 3,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2025-12-31": 1,
            "2026-01-17": 2,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-02-03": 1,
            "2026-02-19": 52
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 135.58,
            "mode_time_hours": 1.0,
            "mode_frequency": 442,
            "time_distribution": {
              "0-2h": 442,
              "2-4h": 168,
              "4-6h": 83,
              "6-8h": 49,
              "8-10h": 24,
              "10-12h": 13,
              "12-14h": 18,
              "14-16h": 11,
              "16-18h": 15,
              "18-20h": 18,
              "20-22h": 12,
              "22-24h": 16,
              "24-26h": 18,
              "26-28h": 15,
              "28-30h": 10,
              "30-32h": 10,
              "32-34h": 3,
              "34-36h": 4,
              "36-38h": 5,
              "40-42h": 4,
              "42-44h": 6,
              "44-46h": 8,
              "46-48h": 6,
              "48-50h": 2,
              "50-52h": 7,
              "52-54h": 4,
              "54-56h": 3,
              "56-58h": 10,
              "58-60h": 1,
              "60-62h": 2,
              "64-66h": 1,
              "66-68h": 7,
              "68-70h": 1,
              "70-72h": 4,
              "72-74h": 2,
              "74-76h": 6,
              "76-78h": 3,
              "78-80h": 6,
              "80-82h": 6,
              "82-84h": 3,
              "84-86h": 1,
              "86-88h": 1,
              "88-90h": 3,
              "90-92h": 4,
              "92-94h": 5,
              "94-96h": 3,
              "96-98h": 5,
              "98-100h": 3,
              "100-102h": 4,
              "102-104h": 1,
              "104-106h": 1,
              "112-114h": 1,
              "114-116h": 3,
              "118-120h": 5,
              "120-122h": 2,
              "122-124h": 9,
              "124-126h": 1,
              "126-128h": 3,
              "128-130h": 1,
              "132-134h": 1,
              "134-136h": 1,
              "136-138h": 2,
              "138-140h": 1,
              "140-142h": 4,
              "142-144h": 5,
              "144-146h": 6,
              "146-148h": 8,
              "148-150h": 2,
              "150-152h": 3,
              "152-154h": 1,
              "154-156h": 1,
              "156-158h": 3,
              "160-162h": 2,
              "162-164h": 5,
              "164-166h": 9,
              "166-168h": 3,
              "168-170h": 1,
              "172-174h": 2,
              "174-176h": 2,
              "176-178h": 2,
              "178-180h": 1,
              "184-186h": 1,
              "186-188h": 1,
              "192-194h": 4,
              "194-196h": 4,
              "198-200h": 2,
              "200-202h": 2,
              "204-206h": 2,
              "208-210h": 1,
              "212-214h": 2,
              "216-218h": 2,
              "218-220h": 5,
              "222-224h": 1,
              "228-230h": 3,
              "232-234h": 1,
              "234-236h": 4,
              "240-242h": 1,
              "248-250h": 2,
              "256-258h": 1,
              "260-262h": 1,
              "262-264h": 2,
              "264-266h": 1,
              "268-270h": 1,
              "276-278h": 2,
              "286-288h": 3,
              "288-290h": 4,
              "290-292h": 2,
              "292-294h": 2,
              "294-296h": 1,
              "298-300h": 1,
              "300-302h": 3,
              "302-304h": 1,
              "310-312h": 3,
              "312-314h": 2,
              "314-316h": 1,
              "316-318h": 3,
              "322-324h": 2,
              "330-332h": 3,
              "332-334h": 2,
              "334-336h": 1,
              "336-338h": 9,
              "340-342h": 3,
              "342-344h": 1,
              "348-350h": 3,
              "354-356h": 2,
              "356-358h": 2,
              "360-362h": 1,
              "362-364h": 2,
              "364-366h": 1,
              "368-370h": 1,
              "374-376h": 1,
              "378-380h": 1,
              "382-384h": 3,
              "384-386h": 7,
              "388-390h": 4,
              "390-392h": 2,
              "392-394h": 1,
              "396-398h": 1,
              "402-404h": 1,
              "406-408h": 2,
              "408-410h": 4,
              "410-412h": 3,
              "412-414h": 1,
              "428-430h": 2,
              "432-434h": 2,
              "436-438h": 1,
              "454-456h": 4,
              "456-458h": 2,
              "464-466h": 1,
              "466-468h": 3,
              "472-474h": 1,
              "476-478h": 1,
              "478-480h": 1,
              "482-484h": 1,
              "486-488h": 2,
              "488-490h": 1,
              "492-494h": 2,
              "494-496h": 1,
              "496-498h": 1,
              "498-500h": 1,
              "500-502h": 1,
              "502-504h": 2,
              "504-506h": 2,
              "508-510h": 2,
              "514-516h": 1,
              "528-530h": 2,
              "532-534h": 1,
              "534-536h": 1,
              "536-538h": 2,
              "544-546h": 2,
              "546-548h": 1,
              "550-552h": 1,
              "556-558h": 1,
              "560-562h": 1,
              "572-574h": 1,
              "576-578h": 1,
              "578-580h": 1,
              "604-606h": 1,
              "610-612h": 1,
              "614-616h": 1,
              "624-626h": 1,
              "630-632h": 1,
              "634-636h": 1,
              "648-650h": 1,
              "650-652h": 2,
              "654-656h": 1,
              "664-666h": 1,
              "672-674h": 1,
              "680-682h": 2,
              "684-686h": 1,
              "688-690h": 1,
              "694-696h": 1,
              "714-716h": 1,
              "720-722h": 2,
              "738-740h": 3,
              "740-742h": 1,
              "746-748h": 2,
              "766-768h": 1,
              "780-782h": 1,
              "784-786h": 1,
              "796-798h": 1,
              "798-800h": 1,
              "816-818h": 1,
              "820-822h": 1,
              "826-828h": 1,
              "834-836h": 1,
              "842-844h": 1,
              "846-848h": 1,
              "862-864h": 1,
              "866-868h": 1,
              "888-890h": 1,
              "914-916h": 1,
              "1012-1014h": 1,
              "1028-1030h": 1,
              "1052-1054h": 1,
              "1056-1058h": 1,
              "1058-1060h": 1,
              "1068-1070h": 1,
              "1072-1074h": 2,
              "1080-1082h": 1,
              "1092-1094h": 1,
              "1102-1104h": 1,
              "1124-1126h": 2,
              "1134-1136h": 1,
              "1166-1168h": 1,
              "1170-1172h": 1,
              "1200-1202h": 1,
              "1208-1210h": 1,
              "1222-1224h": 2,
              "1228-1230h": 1,
              "1238-1240h": 1,
              "1248-1250h": 3,
              "1250-1252h": 1,
              "1272-1274h": 1,
              "1314-1316h": 1,
              "1360-1362h": 1,
              "1408-1410h": 1,
              "1416-1418h": 2,
              "1506-1508h": 1,
              "1514-1516h": 1,
              "1532-1534h": 1,
              "1684-1686h": 1,
              "1698-1700h": 1,
              "1704-1706h": 1,
              "1718-1720h": 1,
              "1728-1730h": 1,
              "1796-1798h": 1,
              "1842-1844h": 1,
              "1846-1848h": 1,
              "1856-1858h": 1,
              "2158-2160h": 1,
              "2208-2210h": 1,
              "2304-2306h": 1,
              "4036-4038h": 1
            },
            "tickets_count": 1422,
            "tickets_per_day": {
              "2025-09-30": 4,
              "2025-10-08": 5,
              "2025-10-09": 5,
              "2025-10-10": 6,
              "2025-10-13": 2,
              "2025-10-14": 10,
              "2025-10-15": 5,
              "2025-10-16": 5,
              "2025-10-17": 3,
              "2025-10-20": 4,
              "2025-10-21": 1,
              "2025-10-22": 6,
              "2025-10-23": 14,
              "2025-10-24": 4,
              "2025-10-27": 8,
              "2025-10-28": 12,
              "2025-10-29": 8,
              "2025-10-30": 13,
              "2025-10-31": 10,
              "2025-11-02": 1,
              "2025-11-03": 6,
              "2025-11-04": 2,
              "2025-11-05": 6,
              "2025-11-06": 8,
              "2025-11-07": 3,
              "2025-11-10": 10,
              "2025-11-11": 8,
              "2025-11-12": 6,
              "2025-11-13": 5,
              "2025-11-14": 8,
              "2025-11-16": 1,
              "2025-11-17": 5,
              "2025-11-18": 7,
              "2025-11-19": 6,
              "2025-11-20": 14,
              "2025-11-21": 12,
              "2025-11-22": 1,
              "2025-11-23": 2,
              "2025-11-24": 15,
              "2025-11-25": 4,
              "2025-11-26": 9,
              "2025-11-27": 4,
              "2025-11-28": 5,
              "2025-11-29": 10,
              "2025-11-30": 1,
              "2025-12-02": 17,
              "2025-12-03": 17,
              "2025-12-04": 10,
              "2025-12-05": 9,
              "2025-12-06": 1,
              "2025-12-09": 4,
              "2025-12-10": 7,
              "2025-12-11": 8,
              "2025-12-12": 9,
              "2025-12-13": 1,
              "2025-12-14": 2,
              "2025-12-15": 18,
              "2025-12-16": 11,
              "2025-12-17": 2,
              "2025-12-18": 1,
              "2025-12-19": 7,
              "2025-12-22": 4,
              "2025-12-23": 10,
              "2025-12-24": 1,
              "2025-12-26": 8,
              "2025-12-29": 10,
              "2025-12-31": 3,
              "2026-01-02": 4,
              "2026-01-03": 1,
              "2026-01-05": 5,
              "2026-01-06": 14,
              "2026-01-07": 14,
              "2026-01-08": 15,
              "2026-01-09": 10,
              "2026-01-10": 4,
              "2026-01-11": 1,
              "2026-01-12": 9,
              "2026-01-13": 15,
              "2026-01-14": 4,
              "2026-01-15": 10,
              "2026-01-16": 4,
              "2026-01-17": 3,
              "2026-01-18": 3,
              "2026-01-19": 7,
              "2026-01-20": 7,
              "2026-01-21": 3,
              "2026-01-22": 1,
              "2026-01-23": 15,
              "2026-01-24": 9,
              "2026-01-26": 16,
              "2026-01-27": 5,
              "2026-01-28": 4,
              "2026-01-29": 3,
              "2026-01-30": 2,
              "2026-01-31": 1,
              "2026-02-02": 12,
              "2026-02-03": 24,
              "2026-02-04": 4,
              "2026-02-05": 8,
              "2026-02-06": 9,
              "2026-02-07": 1,
              "2026-02-09": 13,
              "2026-02-10": 18,
              "2026-02-11": 5,
              "2026-02-12": 7,
              "2026-02-13": 18,
              "2026-02-14": 8,
              "2026-02-16": 7,
              "2026-02-17": 2,
              "2026-02-18": 17,
              "2026-02-19": 67,
              "2026-02-20": 4,
              "2026-02-21": 3,
              "2026-02-23": 12,
              "2026-02-24": 9,
              "2026-02-25": 5,
              "2026-02-26": 3,
              "2026-02-27": 2,
              "2026-02-28": 10,
              "2026-03-02": 15,
              "2026-03-03": 4,
              "2026-03-04": 9,
              "2026-03-06": 10,
              "2026-03-09": 14,
              "2026-03-10": 5,
              "2026-03-11": 13,
              "2026-03-12": 12,
              "2026-03-13": 11,
              "2026-03-14": 5,
              "2026-03-16": 8,
              "2026-03-17": 10,
              "2026-03-18": 59,
              "2026-03-19": 8,
              "2026-03-20": 11,
              "2026-03-23": 2,
              "2026-03-24": 5,
              "2026-03-25": 3,
              "2026-03-26": 10,
              "2026-03-27": 4,
              "2026-03-30": 19,
              "2026-03-31": 4,
              "2026-04-01": 6,
              "2026-04-02": 1,
              "2026-04-06": 14,
              "2026-04-07": 12,
              "2026-04-08": 12,
              "2026-04-09": 3,
              "2026-04-10": 20,
              "2026-04-11": 2,
              "2026-04-13": 12,
              "2026-04-14": 10,
              "2026-04-15": 5,
              "2026-04-16": 6,
              "2026-04-17": 7,
              "2026-04-18": 4,
              "2026-04-20": 9,
              "2026-04-21": 4,
              "2026-04-22": 16,
              "2026-04-23": 12,
              "2026-04-24": 6,
              "2026-04-27": 14,
              "2026-04-28": 12,
              "2026-04-29": 5,
              "2026-04-30": 5,
              "2026-05-02": 3,
              "2026-05-04": 9,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 6,
              "2026-05-08": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 1,
              "2026-05-14": 10,
              "2026-05-16": 1,
              "2026-05-18": 2,
              "2026-05-19": 4,
              "2026-05-20": 9,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 2,
              "2026-05-26": 6,
              "2026-05-29": 3,
              "2026-06-01": 5,
              "2026-06-02": 2,
              "2026-06-03": 1,
              "2026-06-04": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-09-30": 0.576358888888889,
              "2025-10-08": 1.9572552777777776,
              "2025-10-09": 246.67860222222222,
              "2025-10-10": 140.59894638888886,
              "2025-10-13": 12.94264138888889,
              "2025-10-14": 429.95017916666666,
              "2025-10-15": 150.88691138888888,
              "2025-10-16": 198.45461000000003,
              "2025-10-17": 111.8887025,
              "2025-10-20": 34.65188222222223,
              "2025-10-21": 40.20449138888889,
              "2025-10-22": 232.56774083333332,
              "2025-10-23": 999.5927541666666,
              "2025-10-24": 111.170225,
              "2025-10-27": 443.92410361111115,
              "2025-10-28": 623.6641997222223,
              "2025-10-29": 92.46663833333331,
              "2025-10-30": 351.6774422222221,
              "2025-10-31": 257.2903758333333,
              "2025-11-02": 6.409595277777778,
              "2025-11-03": 713.882495,
              "2025-11-04": 741.386376388889,
              "2025-11-05": 524.8881144444445,
              "2025-11-06": 731.0627066666666,
              "2025-11-07": 36.66560194444444,
              "2025-11-10": 659.8165105555556,
              "2025-11-11": 96.33133250000002,
              "2025-11-12": 1136.1566458333334,
              "2025-11-13": 150.1151461111111,
              "2025-11-14": 965.0590733333333,
              "2025-11-16": 1.4783980555555556,
              "2025-11-17": 267.9176944444444,
              "2025-11-18": 1007.7596824999999,
              "2025-11-19": 209.43338111111115,
              "2025-11-20": 527.8912783333333,
              "2025-11-21": 991.5900869444445,
              "2025-11-22": 48.57978222222222,
              "2025-11-23": 5.603014444444445,
              "2025-11-24": 686.5224791666666,
              "2025-11-25": 588.2081252777778,
              "2025-11-26": 619.4595397222222,
              "2025-11-27": 913.5078474999999,
              "2025-11-28": 426.34451722222224,
              "2025-11-29": 2122.365774722222,
              "2025-11-30": 43.668389166666664,
              "2025-12-02": 2133.5600322222217,
              "2025-12-03": 1261.8031533333337,
              "2025-12-04": 1044.3076105555556,
              "2025-12-05": 634.1759652777778,
              "2025-12-06": 53.61010166666667,
              "2025-12-09": 208.70741083333337,
              "2025-12-10": 985.8019524999999,
              "2025-12-11": 1231.3638577777776,
              "2025-12-12": 1806.7238383333333,
              "2025-12-13": 22.036010277777777,
              "2025-12-14": 4.941235833333334,
              "2025-12-15": 3263.1213347222224,
              "2025-12-16": 916.4167808333333,
              "2025-12-17": 22.995979999999996,
              "2025-12-18": 50.02964111111112,
              "2025-12-19": 1079.8213972222225,
              "2025-12-22": 136.67121694444447,
              "2025-12-23": 55.47709333333333,
              "2025-12-24": 528.5530186111112,
              "2025-12-26": 499.67036277777777,
              "2025-12-29": 1803.6595038888888,
              "2025-12-31": 1798.498091111111,
              "2026-01-02": 173.11062444444445,
              "2026-01-03": 0.17937916666666667,
              "2026-01-05": 14.399536944444446,
              "2026-01-06": 180.1106327777778,
              "2026-01-07": 2708.654718611111,
              "2026-01-08": 1818.6551472222222,
              "2026-01-09": 1457.8180711111108,
              "2026-01-10": 35.056598888888885,
              "2026-01-11": 317.47465611111113,
              "2026-01-12": 43.40318361111112,
              "2026-01-13": 561.1487083333333,
              "2026-01-14": 13.799904722222221,
              "2026-01-15": 44.47461416666667,
              "2026-01-16": 19.838945555555554,
              "2026-01-17": 331.0085661111111,
              "2026-01-18": 36.801215,
              "2026-01-19": 61.61098166666666,
              "2026-01-20": 61.26920777777777,
              "2026-01-21": 13.356034166666667,
              "2026-01-22": 4.0281633333333335,
              "2026-01-23": 2667.344846388889,
              "2026-01-24": 1668.9001052777778,
              "2026-01-26": 193.37172305555558,
              "2026-01-27": 656.2210575,
              "2026-01-28": 18.88968527777778,
              "2026-01-29": 5.004430277777778,
              "2026-01-30": 605.2924308333334,
              "2026-01-31": 94.91649527777777,
              "2026-02-02": 355.23847833333326,
              "2026-02-03": 5901.14019777778,
              "2026-02-04": 646.947288611111,
              "2026-02-05": 860.9628672222223,
              "2026-02-06": 4107.893561666667,
              "2026-02-07": 61.669156111111114,
              "2026-02-09": 232.98623638888893,
              "2026-02-10": 5329.5985386111115,
              "2026-02-11": 229.20677194444445,
              "2026-02-12": 4070.207493888889,
              "2026-02-13": 4995.862341944444,
              "2026-02-14": 67.48531055555557,
              "2026-02-16": 678.9704405555556,
              "2026-02-17": 536.9066458333334,
              "2026-02-18": 3842.7056941666665,
              "2026-02-19": 38601.76643166667,
              "2026-02-20": 1584.9742455555554,
              "2026-02-21": 23.005583055555558,
              "2026-02-23": 587.8648902777777,
              "2026-02-24": 14.090424722222222,
              "2026-02-25": 18.993416388888892,
              "2026-02-26": 2.2268499999999998,
              "2026-02-27": 30.469789722222224,
              "2026-02-28": 696.4292952777778,
              "2026-03-02": 1685.773158888889,
              "2026-03-03": 14.629023333333333,
              "2026-03-04": 82.88029277777778,
              "2026-03-06": 9.841352777777775,
              "2026-03-09": 5766.40939638889,
              "2026-03-10": 997.8927819444446,
              "2026-03-11": 828.3813258333336,
              "2026-03-12": 51.470911388888894,
              "2026-03-13": 24.883514722222223,
              "2026-03-14": 77.61068222222222,
              "2026-03-16": 162.89780972222223,
              "2026-03-17": 3035.773606944445,
              "2026-03-18": 14887.780328611116,
              "2026-03-19": 7.090382499999999,
              "2026-03-20": 7584.365625,
              "2026-03-23": 1.3219516666666666,
              "2026-03-24": 58.54782055555556,
              "2026-03-25": 1.7215894444444446,
              "2026-03-26": 22.187801388888886,
              "2026-03-27": 1.574491111111111,
              "2026-03-30": 1429.7034247222223,
              "2026-03-31": 42.3624175,
              "2026-04-01": 40.434483333333326,
              "2026-04-02": 0.9695430555555555,
              "2026-04-06": 109.13554083333331,
              "2026-04-07": 1146.1199252777778,
              "2026-04-08": 54.42757027777778,
              "2026-04-09": 4.3895719444444445,
              "2026-04-10": 1462.916945277778,
              "2026-04-11": 4.518258888888889,
              "2026-04-13": 2231.981999166667,
              "2026-04-14": 24.88372638888889,
              "2026-04-15": 23.08744861111111,
              "2026-04-16": 7.5042447222222215,
              "2026-04-17": 14.558940555555555,
              "2026-04-18": 74.51195166666668,
              "2026-04-20": 173.78219055555556,
              "2026-04-21": 263.8170744444445,
              "2026-04-22": 1159.1678791666668,
              "2026-04-23": 6472.359143888889,
              "2026-04-24": 22.27381722222222,
              "2026-04-27": 11.158858333333335,
              "2026-04-28": 154.75705916666664,
              "2026-04-29": 26.216341944444444,
              "2026-04-30": 132.81982583333334,
              "2026-05-02": 11.237937777777777,
              "2026-05-04": 2951.766945,
              "2026-05-05": 9.649476388888889,
              "2026-05-06": 2338.9541622222227,
              "2026-05-07": 357.0003305555556,
              "2026-05-08": 1361.2413838888888,
              "2026-05-11": 5.4162791666666665,
              "2026-05-12": 3.441718888888889,
              "2026-05-13": 28.50823805555556,
              "2026-05-14": 4054.583642777777,
              "2026-05-16": 1.6307119444444445,
              "2026-05-18": 4.347391944444444,
              "2026-05-19": 8.075175833333333,
              "2026-05-20": 2.5878547222222226,
              "2026-05-21": 16.911079166666667,
              "2026-05-22": 2.6794813888888886,
              "2026-05-25": 88.23298416666667,
              "2026-05-26": 2172.4818986111113,
              "2026-05-29": 2450.5144863888886,
              "2026-06-01": 111.95712194444444,
              "2026-06-02": 0.5801372222222222,
              "2026-06-03": 0.20785555555555554,
              "2026-06-04": 888.8700166666666,
              "2026-06-08": 0.3223972222222223
            },
            "time_count_per_day": {
              "2025-09-30": 4,
              "2025-10-08": 5,
              "2025-10-09": 5,
              "2025-10-10": 6,
              "2025-10-13": 2,
              "2025-10-14": 10,
              "2025-10-15": 5,
              "2025-10-16": 5,
              "2025-10-17": 3,
              "2025-10-20": 4,
              "2025-10-21": 1,
              "2025-10-22": 6,
              "2025-10-23": 14,
              "2025-10-24": 4,
              "2025-10-27": 8,
              "2025-10-28": 12,
              "2025-10-29": 8,
              "2025-10-30": 13,
              "2025-10-31": 10,
              "2025-11-02": 1,
              "2025-11-03": 6,
              "2025-11-04": 2,
              "2025-11-05": 6,
              "2025-11-06": 8,
              "2025-11-07": 3,
              "2025-11-10": 10,
              "2025-11-11": 8,
              "2025-11-12": 6,
              "2025-11-13": 5,
              "2025-11-14": 8,
              "2025-11-16": 1,
              "2025-11-17": 5,
              "2025-11-18": 7,
              "2025-11-19": 6,
              "2025-11-20": 14,
              "2025-11-21": 12,
              "2025-11-22": 1,
              "2025-11-23": 2,
              "2025-11-24": 15,
              "2025-11-25": 4,
              "2025-11-26": 9,
              "2025-11-27": 4,
              "2025-11-28": 5,
              "2025-11-29": 10,
              "2025-11-30": 1,
              "2025-12-02": 17,
              "2025-12-03": 17,
              "2025-12-04": 10,
              "2025-12-05": 9,
              "2025-12-06": 1,
              "2025-12-09": 4,
              "2025-12-10": 7,
              "2025-12-11": 8,
              "2025-12-12": 9,
              "2025-12-13": 1,
              "2025-12-14": 2,
              "2025-12-15": 18,
              "2025-12-16": 11,
              "2025-12-17": 2,
              "2025-12-18": 1,
              "2025-12-19": 7,
              "2025-12-22": 4,
              "2025-12-23": 10,
              "2025-12-24": 1,
              "2025-12-26": 8,
              "2025-12-29": 10,
              "2025-12-31": 3,
              "2026-01-02": 4,
              "2026-01-03": 1,
              "2026-01-05": 5,
              "2026-01-06": 14,
              "2026-01-07": 14,
              "2026-01-08": 15,
              "2026-01-09": 10,
              "2026-01-10": 4,
              "2026-01-11": 1,
              "2026-01-12": 9,
              "2026-01-13": 15,
              "2026-01-14": 4,
              "2026-01-15": 10,
              "2026-01-16": 4,
              "2026-01-17": 3,
              "2026-01-18": 3,
              "2026-01-19": 7,
              "2026-01-20": 7,
              "2026-01-21": 3,
              "2026-01-22": 1,
              "2026-01-23": 15,
              "2026-01-24": 9,
              "2026-01-26": 16,
              "2026-01-27": 5,
              "2026-01-28": 4,
              "2026-01-29": 3,
              "2026-01-30": 2,
              "2026-01-31": 1,
              "2026-02-02": 12,
              "2026-02-03": 24,
              "2026-02-04": 4,
              "2026-02-05": 8,
              "2026-02-06": 9,
              "2026-02-07": 1,
              "2026-02-09": 13,
              "2026-02-10": 18,
              "2026-02-11": 5,
              "2026-02-12": 7,
              "2026-02-13": 18,
              "2026-02-14": 8,
              "2026-02-16": 7,
              "2026-02-17": 2,
              "2026-02-18": 17,
              "2026-02-19": 67,
              "2026-02-20": 4,
              "2026-02-21": 3,
              "2026-02-23": 12,
              "2026-02-24": 9,
              "2026-02-25": 5,
              "2026-02-26": 3,
              "2026-02-27": 2,
              "2026-02-28": 10,
              "2026-03-02": 15,
              "2026-03-03": 4,
              "2026-03-04": 9,
              "2026-03-06": 10,
              "2026-03-09": 14,
              "2026-03-10": 5,
              "2026-03-11": 13,
              "2026-03-12": 12,
              "2026-03-13": 11,
              "2026-03-14": 5,
              "2026-03-16": 8,
              "2026-03-17": 10,
              "2026-03-18": 59,
              "2026-03-19": 8,
              "2026-03-20": 11,
              "2026-03-23": 2,
              "2026-03-24": 5,
              "2026-03-25": 3,
              "2026-03-26": 10,
              "2026-03-27": 4,
              "2026-03-30": 19,
              "2026-03-31": 4,
              "2026-04-01": 6,
              "2026-04-02": 1,
              "2026-04-06": 14,
              "2026-04-07": 12,
              "2026-04-08": 12,
              "2026-04-09": 3,
              "2026-04-10": 20,
              "2026-04-11": 2,
              "2026-04-13": 12,
              "2026-04-14": 10,
              "2026-04-15": 5,
              "2026-04-16": 6,
              "2026-04-17": 7,
              "2026-04-18": 4,
              "2026-04-20": 9,
              "2026-04-21": 4,
              "2026-04-22": 16,
              "2026-04-23": 12,
              "2026-04-24": 6,
              "2026-04-27": 14,
              "2026-04-28": 12,
              "2026-04-29": 5,
              "2026-04-30": 5,
              "2026-05-02": 3,
              "2026-05-04": 9,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 6,
              "2026-05-08": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 1,
              "2026-05-14": 10,
              "2026-05-16": 1,
              "2026-05-18": 2,
              "2026-05-19": 4,
              "2026-05-20": 9,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 2,
              "2026-05-26": 6,
              "2026-05-29": 3,
              "2026-06-01": 5,
              "2026-06-02": 2,
              "2026-06-03": 1,
              "2026-06-04": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 141.9,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 1,
                "4-6h": 1,
                "20-22h": 1,
                "50-52h": 1,
                "166-168h": 1,
                "310-312h": 1,
                "410-412h": 1,
                "650-652h": 1,
                "780-782h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-10-16": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-12-03": 2,
                "2025-12-04": 1,
                "2025-12-23": 1,
                "2026-01-08": 2,
                "2026-01-23": 2,
                "2026-02-03": 1,
                "2026-02-26": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-14": 1,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2025-10-16": 0.7195861111111111,
                "2025-10-27": 2.995404166666667,
                "2025-10-28": 20.40406861111111,
                "2025-12-03": 6.9707825,
                "2025-12-04": 1.669495,
                "2025-12-23": 0.6058288888888889,
                "2026-01-08": 703.2076830555557,
                "2026-01-23": 577.8482425,
                "2026-02-03": 311.45288416666665,
                "2026-02-26": 1.668902222222222,
                "2026-03-06": 0.9276636111111111,
                "2026-03-10": 780.9277716666667,
                "2026-03-14": 1.4962497222222222,
                "2026-04-10": 1.3674869444444446
              },
              "time_count_per_day": {
                "2025-10-16": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-12-03": 2,
                "2025-12-04": 1,
                "2025-12-23": 1,
                "2026-01-08": 2,
                "2026-01-23": 2,
                "2026-02-03": 1,
                "2026-02-26": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-14": 1,
                "2026-04-10": 1
              }
            },
            "P2": {
              "avg_time_hours": 74.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 405,
              "time_distribution": {
                "0-2h": 405,
                "2-4h": 136,
                "4-6h": 59,
                "6-8h": 38,
                "8-10h": 17,
                "10-12h": 9,
                "12-14h": 11,
                "14-16h": 9,
                "16-18h": 11,
                "18-20h": 14,
                "20-22h": 6,
                "22-24h": 5,
                "24-26h": 6,
                "26-28h": 3,
                "28-30h": 4,
                "30-32h": 2,
                "32-34h": 1,
                "36-38h": 1,
                "40-42h": 2,
                "44-46h": 5,
                "46-48h": 2,
                "50-52h": 1,
                "54-56h": 2,
                "56-58h": 1,
                "58-60h": 1,
                "64-66h": 1,
                "66-68h": 1,
                "72-74h": 1,
                "74-76h": 3,
                "76-78h": 1,
                "78-80h": 1,
                "86-88h": 1,
                "88-90h": 1,
                "90-92h": 1,
                "92-94h": 1,
                "96-98h": 2,
                "98-100h": 1,
                "100-102h": 2,
                "102-104h": 1,
                "122-124h": 2,
                "126-128h": 2,
                "138-140h": 1,
                "146-148h": 4,
                "160-162h": 1,
                "162-164h": 1,
                "164-166h": 2,
                "166-168h": 1,
                "168-170h": 1,
                "198-200h": 1,
                "200-202h": 2,
                "212-214h": 1,
                "216-218h": 1,
                "218-220h": 2,
                "222-224h": 1,
                "228-230h": 1,
                "234-236h": 2,
                "262-264h": 1,
                "268-270h": 1,
                "286-288h": 3,
                "312-314h": 1,
                "316-318h": 1,
                "330-332h": 1,
                "332-334h": 2,
                "336-338h": 1,
                "340-342h": 3,
                "342-344h": 1,
                "348-350h": 2,
                "368-370h": 1,
                "378-380h": 1,
                "390-392h": 1,
                "408-410h": 1,
                "412-414h": 1,
                "436-438h": 1,
                "454-456h": 2,
                "486-488h": 1,
                "488-490h": 1,
                "508-510h": 1,
                "550-552h": 1,
                "610-612h": 1,
                "624-626h": 1,
                "630-632h": 1,
                "650-652h": 1,
                "654-656h": 1,
                "672-674h": 1,
                "684-686h": 1,
                "738-740h": 1,
                "746-748h": 2,
                "796-798h": 1,
                "798-800h": 1,
                "826-828h": 1,
                "834-836h": 1,
                "842-844h": 1,
                "846-848h": 1,
                "862-864h": 1,
                "866-868h": 1,
                "888-890h": 1,
                "914-916h": 1,
                "1028-1030h": 1,
                "1052-1054h": 1,
                "1058-1060h": 1,
                "1068-1070h": 1,
                "1092-1094h": 1,
                "1102-1104h": 1,
                "1134-1136h": 1,
                "1166-1168h": 1,
                "1170-1172h": 1,
                "1200-1202h": 1,
                "1208-1210h": 1,
                "1228-1230h": 1,
                "1248-1250h": 2,
                "1272-1274h": 1,
                "1314-1316h": 1,
                "1360-1362h": 1,
                "1514-1516h": 1,
                "1532-1534h": 1,
                "1728-1730h": 1,
                "1842-1844h": 1,
                "2158-2160h": 1
              },
              "tickets_count": 866,
              "tickets_per_day": {
                "2025-09-30": 4,
                "2025-10-08": 5,
                "2025-10-09": 1,
                "2025-10-10": 4,
                "2025-10-14": 7,
                "2025-10-15": 2,
                "2025-10-20": 2,
                "2025-10-22": 3,
                "2025-10-23": 3,
                "2025-10-24": 4,
                "2025-10-27": 4,
                "2025-10-28": 10,
                "2025-10-29": 6,
                "2025-10-30": 3,
                "2025-10-31": 5,
                "2025-11-02": 1,
                "2025-11-03": 3,
                "2025-11-04": 1,
                "2025-11-05": 2,
                "2025-11-06": 5,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 6,
                "2025-11-12": 3,
                "2025-11-13": 5,
                "2025-11-14": 2,
                "2025-11-16": 1,
                "2025-11-17": 2,
                "2025-11-18": 2,
                "2025-11-19": 3,
                "2025-11-20": 3,
                "2025-11-21": 4,
                "2025-11-23": 2,
                "2025-11-24": 10,
                "2025-11-25": 2,
                "2025-11-26": 8,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-12-02": 9,
                "2025-12-03": 8,
                "2025-12-04": 3,
                "2025-12-05": 3,
                "2025-12-09": 1,
                "2025-12-11": 3,
                "2025-12-12": 5,
                "2025-12-13": 1,
                "2025-12-14": 2,
                "2025-12-15": 9,
                "2025-12-16": 2,
                "2025-12-17": 1,
                "2025-12-19": 3,
                "2025-12-23": 3,
                "2025-12-26": 5,
                "2025-12-29": 6,
                "2025-12-31": 2,
                "2026-01-02": 4,
                "2026-01-03": 1,
                "2026-01-05": 2,
                "2026-01-06": 13,
                "2026-01-07": 10,
                "2026-01-08": 6,
                "2026-01-09": 5,
                "2026-01-10": 4,
                "2026-01-11": 1,
                "2026-01-12": 7,
                "2026-01-13": 6,
                "2026-01-14": 3,
                "2026-01-15": 9,
                "2026-01-16": 4,
                "2026-01-17": 1,
                "2026-01-19": 4,
                "2026-01-20": 5,
                "2026-01-21": 3,
                "2026-01-23": 6,
                "2026-01-26": 11,
                "2026-01-27": 2,
                "2026-01-28": 3,
                "2026-01-29": 2,
                "2026-01-30": 1,
                "2026-02-02": 3,
                "2026-02-03": 10,
                "2026-02-04": 2,
                "2026-02-05": 3,
                "2026-02-06": 2,
                "2026-02-09": 7,
                "2026-02-10": 6,
                "2026-02-11": 4,
                "2026-02-12": 5,
                "2026-02-13": 17,
                "2026-02-14": 5,
                "2026-02-16": 7,
                "2026-02-17": 1,
                "2026-02-18": 11,
                "2026-02-19": 8,
                "2026-02-20": 2,
                "2026-02-21": 2,
                "2026-02-23": 9,
                "2026-02-24": 4,
                "2026-02-25": 5,
                "2026-02-26": 2,
                "2026-02-27": 2,
                "2026-02-28": 1,
                "2026-03-02": 13,
                "2026-03-03": 4,
                "2026-03-04": 9,
                "2026-03-06": 9,
                "2026-03-09": 14,
                "2026-03-10": 4,
                "2026-03-11": 13,
                "2026-03-12": 12,
                "2026-03-13": 11,
                "2026-03-14": 2,
                "2026-03-16": 8,
                "2026-03-17": 4,
                "2026-03-18": 6,
                "2026-03-19": 8,
                "2026-03-20": 7,
                "2026-03-23": 2,
                "2026-03-24": 3,
                "2026-03-25": 3,
                "2026-03-26": 9,
                "2026-03-27": 4,
                "2026-03-30": 17,
                "2026-03-31": 4,
                "2026-04-01": 6,
                "2026-04-02": 1,
                "2026-04-06": 14,
                "2026-04-07": 11,
                "2026-04-08": 12,
                "2026-04-09": 3,
                "2026-04-10": 19,
                "2026-04-11": 2,
                "2026-04-13": 12,
                "2026-04-14": 10,
                "2026-04-15": 5,
                "2026-04-16": 6,
                "2026-04-17": 7,
                "2026-04-18": 4,
                "2026-04-20": 9,
                "2026-04-21": 4,
                "2026-04-22": 9,
                "2026-04-23": 12,
                "2026-04-24": 6,
                "2026-04-27": 14,
                "2026-04-28": 12,
                "2026-04-29": 5,
                "2026-04-30": 5,
                "2026-05-02": 3,
                "2026-05-04": 8,
                "2026-05-05": 5,
                "2026-05-06": 4,
                "2026-05-07": 5,
                "2026-05-08": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 1,
                "2026-05-14": 9,
                "2026-05-16": 1,
                "2026-05-18": 2,
                "2026-05-19": 4,
                "2026-05-20": 9,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 2,
                "2026-05-26": 6,
                "2026-05-29": 1,
                "2026-06-01": 5,
                "2026-06-02": 2,
                "2026-06-03": 1,
                "2026-06-04": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-09-30": 0.576358888888889,
                "2025-10-08": 1.9572552777777776,
                "2025-10-09": 0.5231627777777778,
                "2025-10-10": 24.381331666666668,
                "2025-10-14": 186.49039305555556,
                "2025-10-15": 26.781140555555556,
                "2025-10-20": 5.253918055555555,
                "2025-10-22": 91.45513944444446,
                "2025-10-23": 22.869139722222222,
                "2025-10-24": 111.170225,
                "2025-10-27": 277.2945041666667,
                "2025-10-28": 490.48698250000007,
                "2025-10-29": 21.04014638888889,
                "2025-10-30": 74.9897938888889,
                "2025-10-31": 18.477401111111114,
                "2025-11-02": 6.409595277777778,
                "2025-11-03": 94.28831805555555,
                "2025-11-04": 91.49926194444444,
                "2025-11-05": 207.86891666666665,
                "2025-11-06": 256.6397880555555,
                "2025-11-07": 0.15936722222222222,
                "2025-11-10": 4.726127777777778,
                "2025-11-11": 24.498576666666665,
                "2025-11-12": 4.288109722222222,
                "2025-11-13": 150.1151461111111,
                "2025-11-14": 560.8657166666667,
                "2025-11-16": 1.4783980555555556,
                "2025-11-17": 28.10147444444444,
                "2025-11-18": 160.94368555555556,
                "2025-11-19": 1.8305375000000002,
                "2025-11-20": 2.1219913888888886,
                "2025-11-21": 552.8373797222222,
                "2025-11-23": 5.603014444444445,
                "2025-11-24": 12.508761111111111,
                "2025-11-25": 3.2632455555555557,
                "2025-11-26": 230.3195188888889,
                "2025-11-27": 1.0805713888888888,
                "2025-11-28": 2.469957222222222,
                "2025-11-29": 2.029996111111111,
                "2025-12-02": 704.2144563888888,
                "2025-12-03": 15.371003333333336,
                "2025-12-04": 857.9545108333333,
                "2025-12-05": 1.4239986111111111,
                "2025-12-09": 3.1795427777777774,
                "2025-12-11": 869.6431069444445,
                "2025-12-12": 1416.4382313888889,
                "2025-12-13": 22.036010277777777,
                "2025-12-14": 4.941235833333334,
                "2025-12-15": 1424.1066244444446,
                "2025-12-16": 1.0964702777777777,
                "2025-12-17": 4.8725572222222215,
                "2025-12-19": 2.2754119444444445,
                "2025-12-23": 22.961467222222222,
                "2025-12-26": 82.99106777777776,
                "2025-12-29": 458.0886625,
                "2025-12-31": 1.5147458333333335,
                "2026-01-02": 173.11062444444445,
                "2026-01-03": 0.17937916666666667,
                "2026-01-05": 2.703323055555556,
                "2026-01-06": 175.3423088888889,
                "2026-01-07": 1208.5136463888887,
                "2026-01-08": 157.49024583333335,
                "2026-01-09": 9.329468888888888,
                "2026-01-10": 35.056598888888885,
                "2026-01-11": 317.47465611111113,
                "2026-01-12": 32.2236575,
                "2026-01-13": 26.280669722222225,
                "2026-01-14": 12.485874444444445,
                "2026-01-15": 43.850433611111114,
                "2026-01-16": 19.838945555555554,
                "2026-01-17": 0.12519111111111111,
                "2026-01-19": 13.342391388888888,
                "2026-01-20": 37.25074333333333,
                "2026-01-21": 13.356034166666667,
                "2026-01-23": 1348.0419227777777,
                "2026-01-26": 29.257969999999997,
                "2026-01-27": 5.218471111111111,
                "2026-01-28": 15.470024166666667,
                "2026-01-29": 4.5240422222222225,
                "2026-01-30": 0.8958030555555556,
                "2026-02-02": 38.85133194444445,
                "2026-02-03": 3186.9013486111107,
                "2026-02-04": 7.928804722222222,
                "2026-02-05": 11.267988055555556,
                "2026-02-06": 1843.4406733333333,
                "2026-02-09": 35.85369083333334,
                "2026-02-10": 1113.1750994444446,
                "2026-02-11": 1.1472858333333333,
                "2026-02-12": 2192.3711280555563,
                "2026-02-13": 3139.361541111111,
                "2026-02-14": 19.9124325,
                "2026-02-16": 678.9704405555556,
                "2026-02-17": 0.07940416666666668,
                "2026-02-18": 1276.5188744444447,
                "2026-02-19": 23.489661666666667,
                "2026-02-20": 224.10161722222225,
                "2026-02-21": 1.1873066666666667,
                "2026-02-23": 441.72652277777775,
                "2026-02-24": 7.139080833333332,
                "2026-02-25": 18.993416388888892,
                "2026-02-26": 0.5579477777777777,
                "2026-02-27": 30.469789722222224,
                "2026-02-28": 40.25651138888889,
                "2026-03-02": 96.15876444444443,
                "2026-03-03": 14.629023333333333,
                "2026-03-04": 82.88029277777778,
                "2026-03-06": 8.913689166666666,
                "2026-03-09": 5766.40939638889,
                "2026-03-10": 216.9650102777778,
                "2026-03-11": 828.3813258333336,
                "2026-03-12": 51.470911388888894,
                "2026-03-13": 24.883514722222223,
                "2026-03-14": 13.849366944444446,
                "2026-03-16": 162.89780972222223,
                "2026-03-17": 1972.3397155555556,
                "2026-03-18": 11.658672777777777,
                "2026-03-19": 7.090382499999999,
                "2026-03-20": 6221.1217680555565,
                "2026-03-23": 1.3219516666666666,
                "2026-03-24": 5.794600833333334,
                "2026-03-25": 1.7215894444444446,
                "2026-03-26": 15.5313925,
                "2026-03-27": 1.574491111111111,
                "2026-03-30": 1231.2657358333333,
                "2026-03-31": 42.3624175,
                "2026-04-01": 40.434483333333326,
                "2026-04-02": 0.9695430555555555,
                "2026-04-06": 109.13554083333331,
                "2026-04-07": 1145.3230641666667,
                "2026-04-08": 54.42757027777778,
                "2026-04-09": 4.3895719444444445,
                "2026-04-10": 1461.5494583333336,
                "2026-04-11": 4.518258888888889,
                "2026-04-13": 2231.981999166667,
                "2026-04-14": 24.88372638888889,
                "2026-04-15": 23.08744861111111,
                "2026-04-16": 7.5042447222222215,
                "2026-04-17": 14.558940555555555,
                "2026-04-18": 74.51195166666668,
                "2026-04-20": 173.78219055555556,
                "2026-04-21": 263.8170744444445,
                "2026-04-22": 4.608050555555556,
                "2026-04-23": 6472.359143888889,
                "2026-04-24": 22.27381722222222,
                "2026-04-27": 11.158858333333335,
                "2026-04-28": 154.75705916666664,
                "2026-04-29": 26.216341944444444,
                "2026-04-30": 132.81982583333334,
                "2026-05-02": 11.237937777777777,
                "2026-05-04": 2378.217475833333,
                "2026-05-05": 9.649476388888889,
                "2026-05-06": 491.9489075,
                "2026-05-07": 7.389924166666667,
                "2026-05-08": 1361.2413838888888,
                "2026-05-11": 5.4162791666666665,
                "2026-05-12": 3.441718888888889,
                "2026-05-13": 28.50823805555556,
                "2026-05-14": 17.280848888888887,
                "2026-05-16": 1.6307119444444445,
                "2026-05-18": 4.347391944444444,
                "2026-05-19": 8.075175833333333,
                "2026-05-20": 2.5878547222222226,
                "2026-05-21": 16.911079166666667,
                "2026-05-22": 2.6794813888888886,
                "2026-05-25": 88.23298416666667,
                "2026-05-26": 2172.4818986111113,
                "2026-05-29": 3.482580277777778,
                "2026-06-01": 111.95712194444444,
                "2026-06-02": 0.5801372222222222,
                "2026-06-03": 0.20785555555555554,
                "2026-06-04": 888.8700166666666,
                "2026-06-08": 0.3223972222222223
              },
              "time_count_per_day": {
                "2025-09-30": 4,
                "2025-10-08": 5,
                "2025-10-09": 1,
                "2025-10-10": 4,
                "2025-10-14": 7,
                "2025-10-15": 2,
                "2025-10-20": 2,
                "2025-10-22": 3,
                "2025-10-23": 3,
                "2025-10-24": 4,
                "2025-10-27": 4,
                "2025-10-28": 10,
                "2025-10-29": 6,
                "2025-10-30": 3,
                "2025-10-31": 5,
                "2025-11-02": 1,
                "2025-11-03": 3,
                "2025-11-04": 1,
                "2025-11-05": 2,
                "2025-11-06": 5,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 6,
                "2025-11-12": 3,
                "2025-11-13": 5,
                "2025-11-14": 2,
                "2025-11-16": 1,
                "2025-11-17": 2,
                "2025-11-18": 2,
                "2025-11-19": 3,
                "2025-11-20": 3,
                "2025-11-21": 4,
                "2025-11-23": 2,
                "2025-11-24": 10,
                "2025-11-25": 2,
                "2025-11-26": 8,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-12-02": 9,
                "2025-12-03": 8,
                "2025-12-04": 3,
                "2025-12-05": 3,
                "2025-12-09": 1,
                "2025-12-11": 3,
                "2025-12-12": 5,
                "2025-12-13": 1,
                "2025-12-14": 2,
                "2025-12-15": 9,
                "2025-12-16": 2,
                "2025-12-17": 1,
                "2025-12-19": 3,
                "2025-12-23": 3,
                "2025-12-26": 5,
                "2025-12-29": 6,
                "2025-12-31": 2,
                "2026-01-02": 4,
                "2026-01-03": 1,
                "2026-01-05": 2,
                "2026-01-06": 13,
                "2026-01-07": 10,
                "2026-01-08": 6,
                "2026-01-09": 5,
                "2026-01-10": 4,
                "2026-01-11": 1,
                "2026-01-12": 7,
                "2026-01-13": 6,
                "2026-01-14": 3,
                "2026-01-15": 9,
                "2026-01-16": 4,
                "2026-01-17": 1,
                "2026-01-19": 4,
                "2026-01-20": 5,
                "2026-01-21": 3,
                "2026-01-23": 6,
                "2026-01-26": 11,
                "2026-01-27": 2,
                "2026-01-28": 3,
                "2026-01-29": 2,
                "2026-01-30": 1,
                "2026-02-02": 3,
                "2026-02-03": 10,
                "2026-02-04": 2,
                "2026-02-05": 3,
                "2026-02-06": 2,
                "2026-02-09": 7,
                "2026-02-10": 6,
                "2026-02-11": 4,
                "2026-02-12": 5,
                "2026-02-13": 17,
                "2026-02-14": 5,
                "2026-02-16": 7,
                "2026-02-17": 1,
                "2026-02-18": 11,
                "2026-02-19": 8,
                "2026-02-20": 2,
                "2026-02-21": 2,
                "2026-02-23": 9,
                "2026-02-24": 4,
                "2026-02-25": 5,
                "2026-02-26": 2,
                "2026-02-27": 2,
                "2026-02-28": 1,
                "2026-03-02": 13,
                "2026-03-03": 4,
                "2026-03-04": 9,
                "2026-03-06": 9,
                "2026-03-09": 14,
                "2026-03-10": 4,
                "2026-03-11": 13,
                "2026-03-12": 12,
                "2026-03-13": 11,
                "2026-03-14": 2,
                "2026-03-16": 8,
                "2026-03-17": 4,
                "2026-03-18": 6,
                "2026-03-19": 8,
                "2026-03-20": 7,
                "2026-03-23": 2,
                "2026-03-24": 3,
                "2026-03-25": 3,
                "2026-03-26": 9,
                "2026-03-27": 4,
                "2026-03-30": 17,
                "2026-03-31": 4,
                "2026-04-01": 6,
                "2026-04-02": 1,
                "2026-04-06": 14,
                "2026-04-07": 11,
                "2026-04-08": 12,
                "2026-04-09": 3,
                "2026-04-10": 19,
                "2026-04-11": 2,
                "2026-04-13": 12,
                "2026-04-14": 10,
                "2026-04-15": 5,
                "2026-04-16": 6,
                "2026-04-17": 7,
                "2026-04-18": 4,
                "2026-04-20": 9,
                "2026-04-21": 4,
                "2026-04-22": 9,
                "2026-04-23": 12,
                "2026-04-24": 6,
                "2026-04-27": 14,
                "2026-04-28": 12,
                "2026-04-29": 5,
                "2026-04-30": 5,
                "2026-05-02": 3,
                "2026-05-04": 8,
                "2026-05-05": 5,
                "2026-05-06": 4,
                "2026-05-07": 5,
                "2026-05-08": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 1,
                "2026-05-14": 9,
                "2026-05-16": 1,
                "2026-05-18": 2,
                "2026-05-19": 4,
                "2026-05-20": 9,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 2,
                "2026-05-26": 6,
                "2026-05-29": 1,
                "2026-06-01": 5,
                "2026-06-02": 2,
                "2026-06-03": 1,
                "2026-06-04": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 210.84,
              "mode_time_hours": 3.0,
              "mode_frequency": 25,
              "time_distribution": {
                "0-2h": 21,
                "2-4h": 25,
                "4-6h": 11,
                "6-8h": 3,
                "8-10h": 4,
                "12-14h": 5,
                "14-16h": 2,
                "18-20h": 4,
                "22-24h": 3,
                "24-26h": 8,
                "26-28h": 2,
                "30-32h": 1,
                "34-36h": 1,
                "42-44h": 1,
                "46-48h": 1,
                "60-62h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "78-80h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "118-120h": 1,
                "122-124h": 1,
                "126-128h": 1,
                "136-138h": 1,
                "150-152h": 1,
                "164-166h": 1,
                "172-174h": 1,
                "186-188h": 1,
                "194-196h": 1,
                "198-200h": 1,
                "208-210h": 1,
                "218-220h": 2,
                "232-234h": 1,
                "260-262h": 1,
                "262-264h": 1,
                "314-316h": 1,
                "364-366h": 1,
                "388-390h": 1,
                "406-408h": 1,
                "410-412h": 1,
                "432-434h": 1,
                "454-456h": 1,
                "478-480h": 1,
                "482-484h": 1,
                "492-494h": 1,
                "498-500h": 1,
                "504-506h": 1,
                "528-530h": 1,
                "532-534h": 1,
                "534-536h": 1,
                "536-538h": 1,
                "560-562h": 1,
                "578-580h": 1,
                "648-650h": 1,
                "680-682h": 2,
                "694-696h": 1,
                "720-722h": 1,
                "820-822h": 1,
                "1012-1014h": 1,
                "1250-1252h": 1,
                "1506-1508h": 1,
                "1684-1686h": 1,
                "1856-1858h": 1,
                "2304-2306h": 1,
                "4036-4038h": 1
              },
              "tickets_count": 146,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-23": 1,
                "2025-10-30": 4,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 2,
                "2025-11-07": 1,
                "2025-11-14": 4,
                "2025-11-18": 4,
                "2025-11-19": 3,
                "2025-11-20": 6,
                "2025-11-24": 2,
                "2025-11-26": 1,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-02": 2,
                "2025-12-03": 2,
                "2025-12-04": 3,
                "2025-12-09": 2,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-16": 3,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-23": 4,
                "2025-12-24": 1,
                "2025-12-26": 2,
                "2026-01-05": 3,
                "2026-01-06": 1,
                "2026-01-07": 3,
                "2026-01-08": 2,
                "2026-01-09": 2,
                "2026-01-12": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-18": 3,
                "2026-01-19": 3,
                "2026-01-20": 2,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-02-02": 7,
                "2026-02-03": 9,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-09": 4,
                "2026-02-10": 8,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 3,
                "2026-02-20": 2,
                "2026-02-24": 5,
                "2026-03-02": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-10-14": 198.05785694444447,
                "2025-10-15": 118.00792583333333,
                "2025-10-16": 7.946609444444445,
                "2025-10-23": 233.7853338888889,
                "2025-10-30": 18.98919777777778,
                "2025-11-04": 649.8871144444445,
                "2025-11-05": 208.11751805555554,
                "2025-11-06": 82.18301555555556,
                "2025-11-07": 30.361932499999998,
                "2025-11-14": 258.91013305555555,
                "2025-11-18": 515.503408611111,
                "2025-11-19": 207.60284361111113,
                "2025-11-20": 41.25763277777778,
                "2025-11-24": 129.2334061111111,
                "2025-11-26": 389.1400208333333,
                "2025-11-27": 479.3214219444444,
                "2025-11-28": 412.73393555555555,
                "2025-11-29": 123.85818388888889,
                "2025-11-30": 43.668389166666664,
                "2025-12-02": 578.6513561111111,
                "2025-12-03": 7.999434166666666,
                "2025-12-04": 3.7277027777777776,
                "2025-12-09": 115.84634805555557,
                "2025-12-10": 136.74804944444443,
                "2025-12-11": 18.481043055555556,
                "2025-12-12": 1.2671477777777778,
                "2025-12-15": 1103.1992402777778,
                "2025-12-16": 7.9867197222222215,
                "2025-12-17": 18.123422777777776,
                "2025-12-19": 533.2183305555556,
                "2025-12-22": 70.88767138888889,
                "2025-12-23": 10.396240555555554,
                "2025-12-24": 528.5530186111112,
                "2025-12-26": 8.743221666666667,
                "2026-01-05": 11.696213888888888,
                "2026-01-06": 4.768323888888889,
                "2026-01-07": 1210.895047222222,
                "2026-01-08": 120.47082,
                "2026-01-09": 1256.0155825,
                "2026-01-12": 11.179526111111112,
                "2026-01-13": 25.51585722222222,
                "2026-01-14": 1.3140302777777777,
                "2026-01-15": 0.6241805555555556,
                "2026-01-18": 36.801215,
                "2026-01-19": 48.268590277777776,
                "2026-01-20": 24.018464444444447,
                "2026-01-22": 4.0281633333333335,
                "2026-01-23": 1.7805825,
                "2026-01-26": 11.819775,
                "2026-01-28": 3.4196611111111115,
                "2026-01-29": 0.4803880555555555,
                "2026-02-02": 16.583048333333334,
                "2026-02-03": 1173.5204983333335,
                "2026-02-04": 483.0221975,
                "2026-02-05": 173.83352694444446,
                "2026-02-07": 61.669156111111114,
                "2026-02-09": 35.695210555555555,
                "2026-02-10": 3154.4992375,
                "2026-02-12": 1685.1854513888889,
                "2026-02-13": 1856.5008008333334,
                "2026-02-17": 536.8272416666667,
                "2026-02-18": 2364.813901111111,
                "2026-02-20": 1360.8726283333333,
                "2026-02-24": 6.951343888888889,
                "2026-03-02": 1506.4725369444445,
                "2026-03-17": 1012.6697977777777,
                "2026-03-20": 1250.268898888889,
                "2026-05-14": 4037.302793888889
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-23": 1,
                "2025-10-30": 4,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 2,
                "2025-11-07": 1,
                "2025-11-14": 4,
                "2025-11-18": 4,
                "2025-11-19": 3,
                "2025-11-20": 6,
                "2025-11-24": 2,
                "2025-11-26": 1,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-02": 2,
                "2025-12-03": 2,
                "2025-12-04": 3,
                "2025-12-09": 2,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-16": 3,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-23": 4,
                "2025-12-24": 1,
                "2025-12-26": 2,
                "2026-01-05": 3,
                "2026-01-06": 1,
                "2026-01-07": 3,
                "2026-01-08": 2,
                "2026-01-09": 2,
                "2026-01-12": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-18": 3,
                "2026-01-19": 3,
                "2026-01-20": 2,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-02-02": 7,
                "2026-02-03": 9,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-09": 4,
                "2026-02-10": 8,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 3,
                "2026-02-20": 2,
                "2026-02-24": 5,
                "2026-03-02": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 161.08,
              "mode_time_hours": 5.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 5,
                "4-6h": 10,
                "6-8h": 7,
                "8-10h": 2,
                "10-12h": 3,
                "12-14h": 2,
                "16-18h": 4,
                "20-22h": 5,
                "22-24h": 8,
                "24-26h": 4,
                "26-28h": 9,
                "28-30h": 5,
                "30-32h": 7,
                "32-34h": 1,
                "34-36h": 3,
                "36-38h": 4,
                "40-42h": 2,
                "42-44h": 4,
                "44-46h": 3,
                "46-48h": 2,
                "48-50h": 2,
                "50-52h": 5,
                "52-54h": 3,
                "54-56h": 1,
                "56-58h": 9,
                "60-62h": 1,
                "66-68h": 6,
                "68-70h": 1,
                "70-72h": 3,
                "74-76h": 2,
                "78-80h": 4,
                "80-82h": 6,
                "82-84h": 3,
                "84-86h": 1,
                "88-90h": 2,
                "90-92h": 2,
                "92-94h": 3,
                "94-96h": 2,
                "96-98h": 3,
                "98-100h": 2,
                "100-102h": 1,
                "104-106h": 1,
                "112-114h": 1,
                "114-116h": 3,
                "118-120h": 3,
                "120-122h": 2,
                "122-124h": 4,
                "124-126h": 1,
                "128-130h": 1,
                "132-134h": 1,
                "140-142h": 4,
                "142-144h": 5,
                "144-146h": 6,
                "146-148h": 4,
                "148-150h": 2,
                "150-152h": 2,
                "152-154h": 1,
                "154-156h": 1,
                "156-158h": 3,
                "160-162h": 1,
                "162-164h": 4,
                "164-166h": 6,
                "172-174h": 1,
                "174-176h": 2,
                "176-178h": 2,
                "178-180h": 1,
                "184-186h": 1,
                "192-194h": 4,
                "194-196h": 3,
                "212-214h": 1,
                "218-220h": 1,
                "228-230h": 2,
                "234-236h": 1,
                "248-250h": 2,
                "256-258h": 1,
                "276-278h": 1,
                "288-290h": 4,
                "290-292h": 2,
                "292-294h": 2,
                "294-296h": 1,
                "298-300h": 1,
                "310-312h": 2,
                "312-314h": 1,
                "316-318h": 2,
                "322-324h": 1,
                "330-332h": 2,
                "336-338h": 6,
                "348-350h": 1,
                "354-356h": 2,
                "356-358h": 2,
                "360-362h": 1,
                "362-364h": 1,
                "382-384h": 2,
                "384-386h": 3,
                "388-390h": 3,
                "390-392h": 1,
                "392-394h": 1,
                "396-398h": 1,
                "428-430h": 1,
                "432-434h": 1,
                "454-456h": 1,
                "456-458h": 2,
                "464-466h": 1,
                "466-468h": 3,
                "472-474h": 1,
                "492-494h": 1,
                "494-496h": 1,
                "496-498h": 1,
                "500-502h": 1,
                "502-504h": 2,
                "504-506h": 1,
                "508-510h": 1,
                "536-538h": 1,
                "556-558h": 1,
                "572-574h": 1,
                "604-606h": 1,
                "614-616h": 1,
                "1222-1224h": 2,
                "1846-1848h": 1
              },
              "tickets_count": 306,
              "tickets_per_day": {
                "2025-10-09": 4,
                "2025-10-10": 2,
                "2025-10-13": 2,
                "2025-10-14": 2,
                "2025-10-15": 2,
                "2025-10-16": 3,
                "2025-10-17": 3,
                "2025-10-20": 2,
                "2025-10-21": 1,
                "2025-10-22": 3,
                "2025-10-23": 10,
                "2025-10-27": 3,
                "2025-10-28": 1,
                "2025-10-29": 2,
                "2025-10-30": 6,
                "2025-10-31": 5,
                "2025-11-03": 3,
                "2025-11-05": 3,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-14": 2,
                "2025-11-17": 3,
                "2025-11-18": 1,
                "2025-11-20": 5,
                "2025-11-21": 8,
                "2025-11-22": 1,
                "2025-11-24": 3,
                "2025-11-25": 2,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-11-29": 8,
                "2025-12-02": 6,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 3,
                "2025-12-11": 1,
                "2025-12-15": 5,
                "2025-12-16": 3,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 2,
                "2025-12-23": 1,
                "2025-12-29": 4,
                "2026-01-07": 1,
                "2026-01-08": 5,
                "2026-01-09": 3,
                "2026-01-13": 8,
                "2026-01-23": 5,
                "2026-01-24": 9,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-02": 2,
                "2026-02-03": 3,
                "2026-02-04": 1,
                "2026-02-05": 4,
                "2026-02-06": 7,
                "2026-02-09": 2,
                "2026-02-10": 4,
                "2026-02-11": 1,
                "2026-02-12": 1,
                "2026-02-14": 3,
                "2026-02-18": 3,
                "2026-02-19": 7,
                "2026-02-21": 1,
                "2026-02-23": 3,
                "2026-02-28": 9,
                "2026-03-02": 1,
                "2026-03-14": 2,
                "2026-03-17": 5,
                "2026-03-18": 53,
                "2026-03-20": 3,
                "2026-03-24": 2,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-07": 1,
                "2026-04-22": 7,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-29": 2
              },
              "time_per_day": {
                "2025-10-09": 246.15543944444445,
                "2025-10-10": 116.21761472222222,
                "2025-10-13": 12.94264138888889,
                "2025-10-14": 45.40192916666667,
                "2025-10-15": 6.097845,
                "2025-10-16": 189.78841444444447,
                "2025-10-17": 111.8887025,
                "2025-10-20": 29.397964166666668,
                "2025-10-21": 40.20449138888889,
                "2025-10-22": 141.1126013888889,
                "2025-10-23": 742.9382805555555,
                "2025-10-27": 163.63419527777776,
                "2025-10-28": 112.77314861111111,
                "2025-10-29": 71.42649194444444,
                "2025-10-30": 257.69845055555555,
                "2025-10-31": 238.81297472222226,
                "2025-11-03": 619.5941769444445,
                "2025-11-05": 108.90167972222223,
                "2025-11-06": 392.2399030555556,
                "2025-11-07": 6.1443022222222226,
                "2025-11-10": 655.0903827777778,
                "2025-11-11": 71.83275583333334,
                "2025-11-12": 1131.868536111111,
                "2025-11-14": 145.2832236111111,
                "2025-11-17": 239.81622,
                "2025-11-18": 331.31258833333334,
                "2025-11-20": 484.51165416666663,
                "2025-11-21": 438.7527072222223,
                "2025-11-22": 48.57978222222222,
                "2025-11-24": 544.7803119444445,
                "2025-11-25": 584.9448797222223,
                "2025-11-27": 433.10585416666663,
                "2025-11-28": 11.140624444444445,
                "2025-11-29": 1996.4775947222224,
                "2025-12-02": 850.6942197222222,
                "2025-12-04": 148.16303694444446,
                "2025-12-05": 145.40101916666669,
                "2025-12-09": 89.68152,
                "2025-12-10": 90.76960861111111,
                "2025-12-11": 51.37015722222222,
                "2025-12-15": 725.0372244444444,
                "2025-12-16": 46.05539333333333,
                "2025-12-18": 50.02964111111112,
                "2025-12-19": 30.144908333333333,
                "2025-12-22": 58.68871444444444,
                "2025-12-23": 20.65182777777778,
                "2025-12-29": 1345.5708413888888,
                "2026-01-07": 289.246025,
                "2026-01-08": 837.4863983333333,
                "2026-01-09": 192.4730197222222,
                "2026-01-13": 509.35218138888894,
                "2026-01-23": 462.04614972222225,
                "2026-01-24": 1668.9001052777778,
                "2026-01-26": 141.78708805555556,
                "2026-01-27": 651.0025863888889,
                "2026-01-30": 604.3966277777778,
                "2026-01-31": 94.91649527777777,
                "2026-02-02": 299.8040980555555,
                "2026-02-03": 866.3339111111111,
                "2026-02-04": 155.9962863888889,
                "2026-02-05": 675.8613522222223,
                "2026-02-06": 2264.4528883333332,
                "2026-02-09": 161.43733500000002,
                "2026-02-10": 1061.9242016666667,
                "2026-02-11": 228.0594861111111,
                "2026-02-12": 192.65091444444445,
                "2026-02-14": 47.572878055555556,
                "2026-02-18": 201.37291861111112,
                "2026-02-19": 620.0981461111111,
                "2026-02-21": 21.81827638888889,
                "2026-02-23": 146.1383675,
                "2026-02-28": 656.172783888889,
                "2026-03-02": 83.1418575,
                "2026-03-14": 62.26506555555556,
                "2026-03-17": 50.764093611111115,
                "2026-03-18": 14876.121655833336,
                "2026-03-20": 112.97495805555556,
                "2026-03-24": 52.75321972222223,
                "2026-03-26": 6.656408888888889,
                "2026-03-30": 198.43768888888889,
                "2026-04-07": 0.796861111111111,
                "2026-04-22": 1154.559828611111,
                "2026-05-04": 573.5494691666667,
                "2026-05-06": 1847.0052547222224,
                "2026-05-07": 349.61040638888886,
                "2026-05-29": 2447.031906111111
              },
              "time_count_per_day": {
                "2025-10-09": 4,
                "2025-10-10": 2,
                "2025-10-13": 2,
                "2025-10-14": 2,
                "2025-10-15": 2,
                "2025-10-16": 3,
                "2025-10-17": 3,
                "2025-10-20": 2,
                "2025-10-21": 1,
                "2025-10-22": 3,
                "2025-10-23": 10,
                "2025-10-27": 3,
                "2025-10-28": 1,
                "2025-10-29": 2,
                "2025-10-30": 6,
                "2025-10-31": 5,
                "2025-11-03": 3,
                "2025-11-05": 3,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 2,
                "2025-11-12": 3,
                "2025-11-14": 2,
                "2025-11-17": 3,
                "2025-11-18": 1,
                "2025-11-20": 5,
                "2025-11-21": 8,
                "2025-11-22": 1,
                "2025-11-24": 3,
                "2025-11-25": 2,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-11-29": 8,
                "2025-12-02": 6,
                "2025-12-04": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 3,
                "2025-12-11": 1,
                "2025-12-15": 5,
                "2025-12-16": 3,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 2,
                "2025-12-23": 1,
                "2025-12-29": 4,
                "2026-01-07": 1,
                "2026-01-08": 5,
                "2026-01-09": 3,
                "2026-01-13": 8,
                "2026-01-23": 5,
                "2026-01-24": 9,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-02": 2,
                "2026-02-03": 3,
                "2026-02-04": 1,
                "2026-02-05": 4,
                "2026-02-06": 7,
                "2026-02-09": 2,
                "2026-02-10": 4,
                "2026-02-11": 1,
                "2026-02-12": 1,
                "2026-02-14": 3,
                "2026-02-18": 3,
                "2026-02-19": 7,
                "2026-02-21": 1,
                "2026-02-23": 3,
                "2026-02-28": 9,
                "2026-03-02": 1,
                "2026-03-14": 2,
                "2026-03-17": 5,
                "2026-03-18": 53,
                "2026-03-20": 3,
                "2026-03-24": 2,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-07": 1,
                "2026-04-22": 7,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-29": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 526.25,
              "mode_time_hours": 385.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 1,
                "8-10h": 1,
                "10-12h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "32-34h": 1,
                "42-44h": 1,
                "46-48h": 1,
                "52-54h": 1,
                "76-78h": 2,
                "90-92h": 1,
                "100-102h": 1,
                "118-120h": 1,
                "122-124h": 2,
                "134-136h": 1,
                "136-138h": 1,
                "166-168h": 1,
                "204-206h": 2,
                "216-218h": 1,
                "234-236h": 1,
                "240-242h": 1,
                "264-266h": 1,
                "276-278h": 1,
                "300-302h": 3,
                "302-304h": 1,
                "322-324h": 1,
                "334-336h": 1,
                "336-338h": 2,
                "362-364h": 1,
                "374-376h": 1,
                "382-384h": 1,
                "384-386h": 4,
                "402-404h": 1,
                "406-408h": 1,
                "408-410h": 3,
                "410-412h": 1,
                "428-430h": 1,
                "476-478h": 1,
                "486-488h": 1,
                "514-516h": 1,
                "528-530h": 1,
                "544-546h": 2,
                "546-548h": 1,
                "576-578h": 1,
                "634-636h": 1,
                "664-666h": 1,
                "688-690h": 1,
                "714-716h": 1,
                "720-722h": 1,
                "738-740h": 2,
                "740-742h": 1,
                "766-768h": 1,
                "784-786h": 1,
                "816-818h": 1,
                "1056-1058h": 1,
                "1072-1074h": 2,
                "1080-1082h": 1,
                "1124-1126h": 2,
                "1238-1240h": 1,
                "1248-1250h": 1,
                "1408-1410h": 1,
                "1416-1418h": 2,
                "1698-1700h": 1,
                "1704-1706h": 1,
                "1718-1720h": 1,
                "1796-1798h": 1,
                "2208-2210h": 1
              },
              "tickets_count": 87,
              "tickets_per_day": {
                "2025-12-03": 5,
                "2025-12-04": 1,
                "2025-12-05": 4,
                "2025-12-06": 1,
                "2025-12-10": 3,
                "2025-12-11": 3,
                "2025-12-12": 3,
                "2025-12-15": 1,
                "2025-12-16": 3,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2025-12-31": 1,
                "2026-01-17": 2,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-02-03": 1,
                "2026-02-19": 52
              },
              "time_per_day": {
                "2025-12-03": 1231.4619333333335,
                "2025-12-04": 32.792865,
                "2025-12-05": 487.35094749999996,
                "2025-12-06": 53.61010166666667,
                "2025-12-10": 758.2842944444444,
                "2025-12-11": 291.8695505555556,
                "2025-12-12": 389.0184591666666,
                "2025-12-15": 10.778245555555555,
                "2025-12-16": 861.2781975,
                "2025-12-19": 514.182746388889,
                "2025-12-22": 7.094831111111111,
                "2025-12-23": 0.861728888888889,
                "2025-12-26": 407.93607333333335,
                "2025-12-31": 1796.9833452777777,
                "2026-01-17": 330.883375,
                "2026-01-23": 277.6279488888889,
                "2026-01-26": 10.50689,
                "2026-02-03": 362.9315555555556,
                "2026-02-19": 37958.17862388888
              },
              "time_count_per_day": {
                "2025-12-03": 5,
                "2025-12-04": 1,
                "2025-12-05": 4,
                "2025-12-06": 1,
                "2025-12-10": 3,
                "2025-12-11": 3,
                "2025-12-12": 3,
                "2025-12-15": 1,
                "2025-12-16": 3,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2025-12-31": 1,
                "2026-01-17": 2,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-02-03": 1,
                "2026-02-19": 52
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 32,
            "tickets_per_day": {
              "2026-02-17": 2,
              "2026-02-18": 1,
              "2026-03-04": 1,
              "2026-03-09": 2,
              "2026-03-10": 1,
              "2026-03-11": 3,
              "2026-03-21": 1,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-01": 2,
              "2026-04-07": 1,
              "2026-04-18": 1,
              "2026-04-22": 2,
              "2026-04-23": 1,
              "2026-04-24": 1,
              "2026-04-27": 2,
              "2026-04-28": 1,
              "2026-04-29": 6,
              "2026-04-30": 1,
              "2026-05-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 28,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-27": 1,
                "2026-03-30": 1,
                "2026-04-01": 2,
                "2026-04-07": 1,
                "2026-04-18": 1,
                "2026-04-22": 2,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-27": 2,
                "2026-04-28": 1,
                "2026-04-29": 6,
                "2026-04-30": 1,
                "2026-05-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-17": 2,
                "2026-03-11": 1,
                "2026-03-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-05-11": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-05-11": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-10": 1,
              "2026-04-23": 1,
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-10": 1,
                "2026-04-23": 1,
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-02-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-22": 1,
              "2026-01-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-22": 1,
                "2026-01-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-02": 1,
              "2026-04-15": 2,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-02": 1,
                "2026-04-15": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-26": 1,
              "2026-03-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-26": 1,
                "2026-03-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_48": {
      "overall": {
        "avg_time_hours": 15.36,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "28-30h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-01": 2
        },
        "time_per_day": {
          "2025-10-01": 30.712296111111108
        },
        "time_count_per_day": {
          "2025-10-01": 2
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 15.36,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "28-30h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-01": 2
          },
          "time_per_day": {
            "2025-10-01": 30.712296111111108
          },
          "time_count_per_day": {
            "2025-10-01": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.36,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "28-30h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-01": 2
            },
            "time_per_day": {
              "2025-10-01": 30.712296111111108
            },
            "time_count_per_day": {
              "2025-10-01": 2
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 15.36,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "28-30h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-01": 2
              },
              "time_per_day": {
                "2025-10-01": 30.712296111111108
              },
              "time_count_per_day": {
                "2025-10-01": 2
              }
            }
          }
        }
      }
    },
    "cliente_49": {
      "overall": {
        "avg_time_hours": 28.31,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-01": 1
        },
        "time_per_day": {
          "2025-10-01": 28.307408055555555
        },
        "time_count_per_day": {
          "2025-10-01": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 28.31,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-01": 1
          },
          "time_per_day": {
            "2025-10-01": 28.307408055555555
          },
          "time_count_per_day": {
            "2025-10-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.31,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-01": 1
            },
            "time_per_day": {
              "2025-10-01": 28.307408055555555
            },
            "time_count_per_day": {
              "2025-10-01": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 28.31,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-01": 1
              },
              "time_per_day": {
                "2025-10-01": 28.307408055555555
              },
              "time_count_per_day": {
                "2025-10-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_50": {
      "overall": {
        "avg_time_hours": 243.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 22,
        "time_distribution": {
          "0-2h": 22,
          "2-4h": 8,
          "4-6h": 3,
          "6-8h": 3,
          "8-10h": 3,
          "12-14h": 3,
          "16-18h": 2,
          "18-20h": 1,
          "20-22h": 3,
          "22-24h": 3,
          "26-28h": 2,
          "28-30h": 2,
          "30-32h": 2,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "64-66h": 1,
          "66-68h": 2,
          "72-74h": 3,
          "86-88h": 1,
          "94-96h": 1,
          "100-102h": 1,
          "118-120h": 1,
          "122-124h": 1,
          "124-126h": 1,
          "136-138h": 1,
          "138-140h": 1,
          "148-150h": 1,
          "160-162h": 2,
          "164-166h": 1,
          "166-168h": 1,
          "172-174h": 2,
          "190-192h": 1,
          "230-232h": 1,
          "238-240h": 1,
          "240-242h": 2,
          "266-268h": 1,
          "270-272h": 1,
          "276-278h": 1,
          "278-280h": 1,
          "280-282h": 1,
          "282-284h": 3,
          "310-312h": 1,
          "312-314h": 1,
          "326-328h": 1,
          "338-340h": 1,
          "348-350h": 1,
          "356-358h": 1,
          "358-360h": 1,
          "362-364h": 1,
          "374-376h": 1,
          "380-382h": 1,
          "386-388h": 1,
          "388-390h": 1,
          "398-400h": 1,
          "404-406h": 1,
          "412-414h": 1,
          "414-416h": 1,
          "436-438h": 1,
          "456-458h": 1,
          "468-470h": 1,
          "482-484h": 1,
          "526-528h": 1,
          "528-530h": 1,
          "530-532h": 1,
          "540-542h": 1,
          "554-556h": 1,
          "564-566h": 1,
          "572-574h": 1,
          "576-578h": 1,
          "676-678h": 1,
          "744-746h": 1,
          "758-760h": 2,
          "768-770h": 1,
          "772-774h": 1,
          "808-810h": 2,
          "810-812h": 1,
          "860-862h": 1,
          "1038-1040h": 1,
          "1224-1226h": 1,
          "1388-1390h": 1,
          "1404-1406h": 1,
          "1454-1456h": 1,
          "1634-1636h": 1
        },
        "tickets_count": 157,
        "tickets_per_day": {
          "2025-10-01": 3,
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-10-20": 2,
          "2025-10-23": 3,
          "2025-10-27": 1,
          "2025-10-29": 1,
          "2025-10-30": 3,
          "2025-11-03": 3,
          "2025-11-13": 1,
          "2025-11-14": 2,
          "2025-11-17": 4,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-25": 3,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-11-30": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-09": 1,
          "2025-12-13": 2,
          "2025-12-15": 2,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2025-12-29": 3,
          "2026-01-05": 2,
          "2026-01-07": 2,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-22": 1,
          "2026-02-25": 1,
          "2026-02-28": 1,
          "2026-03-05": 2,
          "2026-03-09": 2,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-18": 7,
          "2026-03-20": 6,
          "2026-03-25": 1,
          "2026-03-28": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-17": 1,
          "2026-04-18": 2,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 3,
          "2026-04-23": 2,
          "2026-04-27": 3,
          "2026-04-29": 1,
          "2026-05-02": 2,
          "2026-05-03": 1,
          "2026-05-04": 6,
          "2026-05-05": 1,
          "2026-05-06": 7,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-13": 2,
          "2026-05-14": 3,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 2,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-29": 3,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-01": 37.20561472222222,
          "2025-10-08": 16.555659444444444,
          "2025-10-10": 40.36689472222222,
          "2025-10-14": 118.76289083333333,
          "2025-10-20": 9.347512777777778,
          "2025-10-23": 365.8179272222222,
          "2025-10-27": 164.94374638888888,
          "2025-10-29": 457.05725027777777,
          "2025-10-30": 103.981745,
          "2025-11-03": 850.7755630555555,
          "2025-11-13": 469.4926302777778,
          "2025-11-14": 21.517423888888885,
          "2025-11-17": 1741.2855819444442,
          "2025-11-18": 482.220105,
          "2025-11-19": 1.1815391666666668,
          "2025-11-21": 539.0012711111111,
          "2025-11-24": 167.48074972222224,
          "2025-11-25": 137.733085,
          "2025-11-26": 2.497576111111111,
          "2025-11-27": 64.36538305555555,
          "2025-11-30": 3.9426472222222224,
          "2025-12-02": 27.692730833333336,
          "2025-12-04": 1224.5898944444446,
          "2025-12-09": 2.4651513888888887,
          "2025-12-13": 66.89977777777777,
          "2025-12-15": 197.71581055555555,
          "2025-12-17": 137.8797197222222,
          "2025-12-23": 267.9717152777778,
          "2025-12-29": 164.86195805555556,
          "2026-01-05": 347.2297388888889,
          "2026-01-07": 529.273765,
          "2026-01-09": 860.6106008333334,
          "2026-01-13": 21.867345,
          "2026-01-16": 0.6926694444444444,
          "2026-01-19": 122.94315666666667,
          "2026-01-22": 375.4068075,
          "2026-01-23": 22.336023333333333,
          "2026-01-26": 73.199895,
          "2026-02-03": 1804.8261722222223,
          "2026-02-04": 283.33237194444445,
          "2026-02-12": 677.8507477777778,
          "2026-02-13": 1503.7726908333334,
          "2026-02-18": 30.320452222222222,
          "2026-02-19": 577.6351647222223,
          "2026-02-21": 1.0789369444444443,
          "2026-02-22": 13.70508888888889,
          "2026-02-25": 48.44438916666667,
          "2026-02-28": 270.32559,
          "2026-03-05": 240.05608555555554,
          "2026-03-09": 315.7268388888889,
          "2026-03-10": 28.236327777777777,
          "2026-03-12": 1.0895355555555555,
          "2026-03-13": 1389.87631,
          "2026-03-18": 1533.0537702777779,
          "2026-03-20": 2713.5408386111117,
          "2026-03-25": 1.3516447222222223,
          "2026-03-30": 156.14892083333334,
          "2026-03-31": 67.4354625,
          "2026-04-02": 0.8328622222222223,
          "2026-04-07": 759.3510594444443,
          "2026-04-08": 4.124169444444444,
          "2026-04-13": 12.003203333333332,
          "2026-04-14": 0.25644805555555555,
          "2026-04-15": 1.012031388888889,
          "2026-04-17": 1.473281111111111,
          "2026-04-18": 2173.041656944444,
          "2026-04-20": 0.12358972222222223,
          "2026-04-21": 0.3257816666666667,
          "2026-04-22": 3055.3470725,
          "2026-04-23": 26.738362777777777,
          "2026-04-27": 7.428304166666667,
          "2026-04-29": 388.4468047222222,
          "2026-05-02": 121.72729,
          "2026-05-04": 1058.0572066666668,
          "2026-05-05": 540.2273280555555,
          "2026-05-06": 2101.217628888889,
          "2026-05-07": 18.234625277777777,
          "2026-05-08": 399.71883833333334,
          "2026-05-13": 241.2239025,
          "2026-05-14": 931.6076255555556,
          "2026-05-18": 9.894770833333334,
          "2026-05-19": 386.6921113888889,
          "2026-05-20": 23.04843222222222,
          "2026-05-21": 28.64557361111111,
          "2026-05-30": 572.8312088888889,
          "2026-06-01": 7.541388055555555
        },
        "time_count_per_day": {
          "2025-10-01": 3,
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-10-20": 2,
          "2025-10-23": 3,
          "2025-10-27": 1,
          "2025-10-29": 1,
          "2025-10-30": 3,
          "2025-11-03": 3,
          "2025-11-13": 1,
          "2025-11-14": 2,
          "2025-11-17": 4,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-25": 3,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-11-30": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-09": 1,
          "2025-12-13": 2,
          "2025-12-15": 2,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2025-12-29": 3,
          "2026-01-05": 2,
          "2026-01-07": 2,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-22": 1,
          "2026-02-25": 1,
          "2026-02-28": 1,
          "2026-03-05": 2,
          "2026-03-09": 2,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-18": 6,
          "2026-03-20": 6,
          "2026-03-25": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-17": 1,
          "2026-04-18": 2,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 3,
          "2026-04-23": 1,
          "2026-04-27": 3,
          "2026-04-29": 1,
          "2026-05-02": 2,
          "2026-05-04": 5,
          "2026-05-05": 1,
          "2026-05-06": 6,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-13": 1,
          "2026-05-14": 3,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-30": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 293.08,
          "mode_time_hours": 469.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "386-388h": 1,
            "468-470h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2026-05-13": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2025-11-13": 469.4926302777778,
            "2026-05-19": 386.6921113888889,
            "2026-05-20": 23.04843222222222
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2026-05-19": 1,
            "2026-05-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 239.49,
          "mode_time_hours": 1.0,
          "mode_frequency": 19,
          "time_distribution": {
            "0-2h": 19,
            "2-4h": 7,
            "4-6h": 3,
            "6-8h": 3,
            "8-10h": 3,
            "12-14h": 3,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 3,
            "22-24h": 2,
            "26-28h": 2,
            "28-30h": 2,
            "30-32h": 1,
            "40-42h": 1,
            "42-44h": 2,
            "46-48h": 1,
            "48-50h": 2,
            "64-66h": 1,
            "66-68h": 2,
            "72-74h": 2,
            "86-88h": 1,
            "94-96h": 1,
            "118-120h": 1,
            "122-124h": 1,
            "138-140h": 1,
            "148-150h": 1,
            "160-162h": 2,
            "166-168h": 1,
            "172-174h": 2,
            "190-192h": 1,
            "230-232h": 1,
            "238-240h": 1,
            "240-242h": 2,
            "266-268h": 1,
            "270-272h": 1,
            "276-278h": 1,
            "278-280h": 1,
            "282-284h": 1,
            "310-312h": 1,
            "312-314h": 1,
            "326-328h": 1,
            "338-340h": 1,
            "356-358h": 1,
            "362-364h": 1,
            "374-376h": 1,
            "380-382h": 1,
            "388-390h": 1,
            "398-400h": 1,
            "412-414h": 1,
            "414-416h": 1,
            "456-458h": 1,
            "482-484h": 1,
            "526-528h": 1,
            "528-530h": 1,
            "530-532h": 1,
            "540-542h": 1,
            "554-556h": 1,
            "564-566h": 1,
            "572-574h": 1,
            "676-678h": 1,
            "744-746h": 1,
            "758-760h": 1,
            "768-770h": 1,
            "772-774h": 1,
            "808-810h": 2,
            "810-812h": 1,
            "860-862h": 1,
            "1038-1040h": 1,
            "1224-1226h": 1,
            "1404-1406h": 1,
            "1454-1456h": 1,
            "1634-1636h": 1
          },
          "tickets_count": 128,
          "tickets_per_day": {
            "2025-10-01": 2,
            "2025-10-10": 1,
            "2025-10-14": 1,
            "2025-10-20": 2,
            "2025-10-23": 3,
            "2025-10-29": 1,
            "2025-10-30": 2,
            "2025-11-03": 2,
            "2025-11-14": 2,
            "2025-11-17": 3,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-24": 1,
            "2025-11-25": 2,
            "2025-11-26": 1,
            "2025-11-27": 1,
            "2025-11-30": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-13": 2,
            "2025-12-23": 1,
            "2025-12-29": 3,
            "2026-01-05": 2,
            "2026-01-07": 2,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-22": 1,
            "2026-02-25": 1,
            "2026-02-28": 1,
            "2026-03-05": 2,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-18": 3,
            "2026-03-20": 5,
            "2026-03-25": 1,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-13": 2,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-17": 1,
            "2026-04-18": 2,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 3,
            "2026-04-23": 2,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-05-02": 2,
            "2026-05-03": 1,
            "2026-05-04": 6,
            "2026-05-05": 1,
            "2026-05-06": 7,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-13": 1,
            "2026-05-14": 3,
            "2026-05-18": 1,
            "2026-05-21": 2,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-29": 2,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-01": 34.848573888888886,
            "2025-10-10": 40.36689472222222,
            "2025-10-14": 118.76289083333333,
            "2025-10-20": 9.347512777777778,
            "2025-10-23": 365.8179272222222,
            "2025-10-29": 457.05725027777777,
            "2025-10-30": 65.28883166666667,
            "2025-11-03": 819.13266,
            "2025-11-14": 21.517423888888885,
            "2025-11-17": 1382.0723763888886,
            "2025-11-18": 482.220105,
            "2025-11-19": 1.1815391666666668,
            "2025-11-24": 167.48074972222224,
            "2025-11-25": 137.58222999999998,
            "2025-11-26": 2.497576111111111,
            "2025-11-27": 64.36538305555555,
            "2025-11-30": 3.9426472222222224,
            "2025-12-02": 27.692730833333336,
            "2025-12-04": 1224.5898944444446,
            "2025-12-09": 2.4651513888888887,
            "2025-12-13": 66.89977777777777,
            "2025-12-23": 267.9717152777778,
            "2025-12-29": 164.86195805555556,
            "2026-01-05": 347.2297388888889,
            "2026-01-07": 529.273765,
            "2026-01-09": 860.6106008333334,
            "2026-01-13": 21.867345,
            "2026-01-19": 122.00438638888889,
            "2026-01-22": 375.4068075,
            "2026-01-23": 22.336023333333333,
            "2026-01-26": 73.199895,
            "2026-02-03": 1455.0755877777779,
            "2026-02-04": 283.33237194444445,
            "2026-02-12": 677.8507477777778,
            "2026-02-13": 745.2133555555556,
            "2026-02-18": 30.320452222222222,
            "2026-02-21": 1.0789369444444443,
            "2026-02-22": 13.70508888888889,
            "2026-02-25": 48.44438916666667,
            "2026-02-28": 270.32559,
            "2026-03-05": 240.05608555555554,
            "2026-03-09": 315.7268388888889,
            "2026-03-10": 28.236327777777777,
            "2026-03-12": 1.0895355555555555,
            "2026-03-18": 281.48275805555556,
            "2026-03-20": 2662.4354677777783,
            "2026-03-25": 1.3516447222222223,
            "2026-03-30": 156.14892083333334,
            "2026-03-31": 67.4354625,
            "2026-04-02": 0.8328622222222223,
            "2026-04-07": 759.3510594444443,
            "2026-04-08": 4.124169444444444,
            "2026-04-13": 12.003203333333332,
            "2026-04-14": 0.25644805555555555,
            "2026-04-15": 1.012031388888889,
            "2026-04-17": 1.473281111111111,
            "2026-04-18": 2173.041656944444,
            "2026-04-20": 0.12358972222222223,
            "2026-04-21": 0.3257816666666667,
            "2026-04-22": 3055.3470725,
            "2026-04-23": 26.738362777777777,
            "2026-04-27": 7.428304166666667,
            "2026-04-29": 388.4468047222222,
            "2026-05-02": 121.72729,
            "2026-05-04": 1058.0572066666668,
            "2026-05-05": 540.2273280555555,
            "2026-05-06": 2101.217628888889,
            "2026-05-07": 18.234625277777777,
            "2026-05-08": 399.71883833333334,
            "2026-05-13": 241.2239025,
            "2026-05-14": 931.6076255555556,
            "2026-05-18": 9.894770833333334,
            "2026-05-21": 28.64557361111111,
            "2026-05-30": 572.8312088888889,
            "2026-06-01": 7.541388055555555
          },
          "time_count_per_day": {
            "2025-10-01": 2,
            "2025-10-10": 1,
            "2025-10-14": 1,
            "2025-10-20": 2,
            "2025-10-23": 3,
            "2025-10-29": 1,
            "2025-10-30": 2,
            "2025-11-03": 2,
            "2025-11-14": 2,
            "2025-11-17": 3,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-24": 1,
            "2025-11-25": 2,
            "2025-11-26": 1,
            "2025-11-27": 1,
            "2025-11-30": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-13": 2,
            "2025-12-23": 1,
            "2025-12-29": 3,
            "2026-01-05": 2,
            "2026-01-07": 2,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-22": 1,
            "2026-02-25": 1,
            "2026-02-28": 1,
            "2026-03-05": 2,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-18": 2,
            "2026-03-20": 5,
            "2026-03-25": 1,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-13": 2,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-17": 1,
            "2026-04-18": 2,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 3,
            "2026-04-23": 1,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-05-02": 2,
            "2026-05-04": 5,
            "2026-05-05": 1,
            "2026-05-06": 6,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-13": 1,
            "2026-05-14": 3,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-30": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 237.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "16-18h": 1,
            "30-32h": 1,
            "38-40h": 1,
            "72-74h": 1,
            "100-102h": 1,
            "124-126h": 1,
            "136-138h": 1,
            "164-166h": 1,
            "280-282h": 1,
            "348-350h": 1,
            "358-360h": 1,
            "436-438h": 1,
            "758-760h": 1,
            "1388-1390h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-08": 1,
            "2025-10-27": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-17": 1,
            "2025-11-21": 2,
            "2025-11-25": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-13": 1,
            "2026-03-13": 1,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2025-10-01": 2.3570408333333335,
            "2025-10-08": 16.555659444444444,
            "2025-10-27": 164.94374638888888,
            "2025-10-30": 38.69291333333334,
            "2025-11-03": 31.642903055555557,
            "2025-11-17": 359.2132055555556,
            "2025-11-21": 539.0012711111111,
            "2025-11-25": 0.150855,
            "2025-12-15": 197.71581055555555,
            "2025-12-17": 137.8797197222222,
            "2026-01-16": 0.6926694444444444,
            "2026-01-19": 0.9387702777777778,
            "2026-02-03": 349.7505844444445,
            "2026-02-13": 758.5593352777778,
            "2026-03-13": 1389.87631,
            "2026-03-18": 281.7378008333333
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-08": 1,
            "2025-10-27": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-17": 1,
            "2025-11-21": 2,
            "2025-11-25": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-13": 1,
            "2026-03-13": 1,
            "2026-03-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 255.23,
          "mode_time_hours": 283.0,
          "mode_frequency": 2,
          "time_distribution": {
            "50-52h": 1,
            "282-284h": 2,
            "404-406h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-03-18": 3,
            "2026-03-20": 1,
            "2026-03-28": 1
          },
          "time_per_day": {
            "2026-03-18": 969.8332113888888,
            "2026-03-20": 51.10537083333333
          },
          "time_count_per_day": {
            "2026-03-18": 3,
            "2026-03-20": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 577.64,
          "mode_time_hours": 577.0,
          "mode_frequency": 1,
          "time_distribution": {
            "576-578h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 577.6351647222223
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 243.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 22,
            "time_distribution": {
              "0-2h": 22,
              "2-4h": 8,
              "4-6h": 3,
              "6-8h": 3,
              "8-10h": 3,
              "12-14h": 3,
              "16-18h": 2,
              "18-20h": 1,
              "20-22h": 3,
              "22-24h": 3,
              "26-28h": 2,
              "28-30h": 2,
              "30-32h": 2,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "64-66h": 1,
              "66-68h": 2,
              "72-74h": 3,
              "86-88h": 1,
              "94-96h": 1,
              "100-102h": 1,
              "118-120h": 1,
              "122-124h": 1,
              "124-126h": 1,
              "136-138h": 1,
              "138-140h": 1,
              "148-150h": 1,
              "160-162h": 2,
              "164-166h": 1,
              "166-168h": 1,
              "172-174h": 2,
              "190-192h": 1,
              "230-232h": 1,
              "238-240h": 1,
              "240-242h": 2,
              "266-268h": 1,
              "270-272h": 1,
              "276-278h": 1,
              "278-280h": 1,
              "280-282h": 1,
              "282-284h": 3,
              "310-312h": 1,
              "312-314h": 1,
              "326-328h": 1,
              "338-340h": 1,
              "348-350h": 1,
              "356-358h": 1,
              "358-360h": 1,
              "362-364h": 1,
              "374-376h": 1,
              "380-382h": 1,
              "386-388h": 1,
              "388-390h": 1,
              "398-400h": 1,
              "404-406h": 1,
              "412-414h": 1,
              "414-416h": 1,
              "436-438h": 1,
              "456-458h": 1,
              "468-470h": 1,
              "482-484h": 1,
              "526-528h": 1,
              "528-530h": 1,
              "530-532h": 1,
              "540-542h": 1,
              "554-556h": 1,
              "564-566h": 1,
              "572-574h": 1,
              "576-578h": 1,
              "676-678h": 1,
              "744-746h": 1,
              "758-760h": 2,
              "768-770h": 1,
              "772-774h": 1,
              "808-810h": 2,
              "810-812h": 1,
              "860-862h": 1,
              "1038-1040h": 1,
              "1224-1226h": 1,
              "1388-1390h": 1,
              "1404-1406h": 1,
              "1454-1456h": 1,
              "1634-1636h": 1
            },
            "tickets_count": 143,
            "tickets_per_day": {
              "2025-10-01": 3,
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-10-20": 2,
              "2025-10-23": 3,
              "2025-10-27": 1,
              "2025-10-29": 1,
              "2025-10-30": 3,
              "2025-11-03": 3,
              "2025-11-13": 1,
              "2025-11-14": 2,
              "2025-11-17": 4,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-25": 3,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-11-30": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-09": 1,
              "2025-12-13": 2,
              "2025-12-15": 2,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2025-12-29": 3,
              "2026-01-05": 2,
              "2026-01-07": 2,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-22": 1,
              "2026-02-25": 1,
              "2026-02-28": 1,
              "2026-03-05": 2,
              "2026-03-09": 2,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-18": 6,
              "2026-03-20": 6,
              "2026-03-25": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-17": 1,
              "2026-04-18": 2,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 3,
              "2026-04-23": 1,
              "2026-04-27": 3,
              "2026-04-29": 1,
              "2026-05-02": 2,
              "2026-05-04": 5,
              "2026-05-05": 1,
              "2026-05-06": 6,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-13": 1,
              "2026-05-14": 3,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-30": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-01": 37.20561472222222,
              "2025-10-08": 16.555659444444444,
              "2025-10-10": 40.36689472222222,
              "2025-10-14": 118.76289083333333,
              "2025-10-20": 9.347512777777778,
              "2025-10-23": 365.8179272222222,
              "2025-10-27": 164.94374638888888,
              "2025-10-29": 457.05725027777777,
              "2025-10-30": 103.981745,
              "2025-11-03": 850.7755630555555,
              "2025-11-13": 469.4926302777778,
              "2025-11-14": 21.517423888888885,
              "2025-11-17": 1741.2855819444442,
              "2025-11-18": 482.220105,
              "2025-11-19": 1.1815391666666668,
              "2025-11-21": 539.0012711111111,
              "2025-11-24": 167.48074972222224,
              "2025-11-25": 137.733085,
              "2025-11-26": 2.497576111111111,
              "2025-11-27": 64.36538305555555,
              "2025-11-30": 3.9426472222222224,
              "2025-12-02": 27.692730833333336,
              "2025-12-04": 1224.5898944444446,
              "2025-12-09": 2.4651513888888887,
              "2025-12-13": 66.89977777777777,
              "2025-12-15": 197.71581055555555,
              "2025-12-17": 137.8797197222222,
              "2025-12-23": 267.9717152777778,
              "2025-12-29": 164.86195805555556,
              "2026-01-05": 347.2297388888889,
              "2026-01-07": 529.273765,
              "2026-01-09": 860.6106008333334,
              "2026-01-13": 21.867345,
              "2026-01-16": 0.6926694444444444,
              "2026-01-19": 122.94315666666667,
              "2026-01-22": 375.4068075,
              "2026-01-23": 22.336023333333333,
              "2026-01-26": 73.199895,
              "2026-02-03": 1804.8261722222223,
              "2026-02-04": 283.33237194444445,
              "2026-02-12": 677.8507477777778,
              "2026-02-13": 1503.7726908333334,
              "2026-02-18": 30.320452222222222,
              "2026-02-19": 577.6351647222223,
              "2026-02-21": 1.0789369444444443,
              "2026-02-22": 13.70508888888889,
              "2026-02-25": 48.44438916666667,
              "2026-02-28": 270.32559,
              "2026-03-05": 240.05608555555554,
              "2026-03-09": 315.7268388888889,
              "2026-03-10": 28.236327777777777,
              "2026-03-12": 1.0895355555555555,
              "2026-03-13": 1389.87631,
              "2026-03-18": 1533.0537702777779,
              "2026-03-20": 2713.5408386111117,
              "2026-03-25": 1.3516447222222223,
              "2026-03-30": 156.14892083333334,
              "2026-03-31": 67.4354625,
              "2026-04-02": 0.8328622222222223,
              "2026-04-07": 759.3510594444443,
              "2026-04-08": 4.124169444444444,
              "2026-04-13": 12.003203333333332,
              "2026-04-14": 0.25644805555555555,
              "2026-04-15": 1.012031388888889,
              "2026-04-17": 1.473281111111111,
              "2026-04-18": 2173.041656944444,
              "2026-04-20": 0.12358972222222223,
              "2026-04-21": 0.3257816666666667,
              "2026-04-22": 3055.3470725,
              "2026-04-23": 26.738362777777777,
              "2026-04-27": 7.428304166666667,
              "2026-04-29": 388.4468047222222,
              "2026-05-02": 121.72729,
              "2026-05-04": 1058.0572066666668,
              "2026-05-05": 540.2273280555555,
              "2026-05-06": 2101.217628888889,
              "2026-05-07": 18.234625277777777,
              "2026-05-08": 399.71883833333334,
              "2026-05-13": 241.2239025,
              "2026-05-14": 931.6076255555556,
              "2026-05-18": 9.894770833333334,
              "2026-05-19": 386.6921113888889,
              "2026-05-20": 23.04843222222222,
              "2026-05-21": 28.64557361111111,
              "2026-05-30": 572.8312088888889,
              "2026-06-01": 7.541388055555555
            },
            "time_count_per_day": {
              "2025-10-01": 3,
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-10-20": 2,
              "2025-10-23": 3,
              "2025-10-27": 1,
              "2025-10-29": 1,
              "2025-10-30": 3,
              "2025-11-03": 3,
              "2025-11-13": 1,
              "2025-11-14": 2,
              "2025-11-17": 4,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-25": 3,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-11-30": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-09": 1,
              "2025-12-13": 2,
              "2025-12-15": 2,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2025-12-29": 3,
              "2026-01-05": 2,
              "2026-01-07": 2,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-22": 1,
              "2026-02-25": 1,
              "2026-02-28": 1,
              "2026-03-05": 2,
              "2026-03-09": 2,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-18": 6,
              "2026-03-20": 6,
              "2026-03-25": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-17": 1,
              "2026-04-18": 2,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 3,
              "2026-04-23": 1,
              "2026-04-27": 3,
              "2026-04-29": 1,
              "2026-05-02": 2,
              "2026-05-04": 5,
              "2026-05-05": 1,
              "2026-05-06": 6,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-13": 1,
              "2026-05-14": 3,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-30": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 293.08,
              "mode_time_hours": 469.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "386-388h": 1,
                "468-470h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2026-05-19": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2025-11-13": 469.4926302777778,
                "2026-05-19": 386.6921113888889,
                "2026-05-20": 23.04843222222222
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2026-05-19": 1,
                "2026-05-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 239.49,
              "mode_time_hours": 1.0,
              "mode_frequency": 19,
              "time_distribution": {
                "0-2h": 19,
                "2-4h": 7,
                "4-6h": 3,
                "6-8h": 3,
                "8-10h": 3,
                "12-14h": 3,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 3,
                "22-24h": 2,
                "26-28h": 2,
                "28-30h": 2,
                "30-32h": 1,
                "40-42h": 1,
                "42-44h": 2,
                "46-48h": 1,
                "48-50h": 2,
                "64-66h": 1,
                "66-68h": 2,
                "72-74h": 2,
                "86-88h": 1,
                "94-96h": 1,
                "118-120h": 1,
                "122-124h": 1,
                "138-140h": 1,
                "148-150h": 1,
                "160-162h": 2,
                "166-168h": 1,
                "172-174h": 2,
                "190-192h": 1,
                "230-232h": 1,
                "238-240h": 1,
                "240-242h": 2,
                "266-268h": 1,
                "270-272h": 1,
                "276-278h": 1,
                "278-280h": 1,
                "282-284h": 1,
                "310-312h": 1,
                "312-314h": 1,
                "326-328h": 1,
                "338-340h": 1,
                "356-358h": 1,
                "362-364h": 1,
                "374-376h": 1,
                "380-382h": 1,
                "388-390h": 1,
                "398-400h": 1,
                "412-414h": 1,
                "414-416h": 1,
                "456-458h": 1,
                "482-484h": 1,
                "526-528h": 1,
                "528-530h": 1,
                "530-532h": 1,
                "540-542h": 1,
                "554-556h": 1,
                "564-566h": 1,
                "572-574h": 1,
                "676-678h": 1,
                "744-746h": 1,
                "758-760h": 1,
                "768-770h": 1,
                "772-774h": 1,
                "808-810h": 2,
                "810-812h": 1,
                "860-862h": 1,
                "1038-1040h": 1,
                "1224-1226h": 1,
                "1404-1406h": 1,
                "1454-1456h": 1,
                "1634-1636h": 1
              },
              "tickets_count": 117,
              "tickets_per_day": {
                "2025-10-01": 2,
                "2025-10-10": 1,
                "2025-10-14": 1,
                "2025-10-20": 2,
                "2025-10-23": 3,
                "2025-10-29": 1,
                "2025-10-30": 2,
                "2025-11-03": 2,
                "2025-11-14": 2,
                "2025-11-17": 3,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-11-24": 1,
                "2025-11-25": 2,
                "2025-11-26": 1,
                "2025-11-27": 1,
                "2025-11-30": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-13": 2,
                "2025-12-23": 1,
                "2025-12-29": 3,
                "2026-01-05": 2,
                "2026-01-07": 2,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-22": 1,
                "2026-02-25": 1,
                "2026-02-28": 1,
                "2026-03-05": 2,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-18": 2,
                "2026-03-20": 5,
                "2026-03-25": 1,
                "2026-03-30": 2,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-13": 2,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-17": 1,
                "2026-04-18": 2,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 3,
                "2026-04-23": 1,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-05-02": 2,
                "2026-05-04": 5,
                "2026-05-05": 1,
                "2026-05-06": 6,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-13": 1,
                "2026-05-14": 3,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-30": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-01": 34.848573888888886,
                "2025-10-10": 40.36689472222222,
                "2025-10-14": 118.76289083333333,
                "2025-10-20": 9.347512777777778,
                "2025-10-23": 365.8179272222222,
                "2025-10-29": 457.05725027777777,
                "2025-10-30": 65.28883166666667,
                "2025-11-03": 819.13266,
                "2025-11-14": 21.517423888888885,
                "2025-11-17": 1382.0723763888886,
                "2025-11-18": 482.220105,
                "2025-11-19": 1.1815391666666668,
                "2025-11-24": 167.48074972222224,
                "2025-11-25": 137.58222999999998,
                "2025-11-26": 2.497576111111111,
                "2025-11-27": 64.36538305555555,
                "2025-11-30": 3.9426472222222224,
                "2025-12-02": 27.692730833333336,
                "2025-12-04": 1224.5898944444446,
                "2025-12-09": 2.4651513888888887,
                "2025-12-13": 66.89977777777777,
                "2025-12-23": 267.9717152777778,
                "2025-12-29": 164.86195805555556,
                "2026-01-05": 347.2297388888889,
                "2026-01-07": 529.273765,
                "2026-01-09": 860.6106008333334,
                "2026-01-13": 21.867345,
                "2026-01-19": 122.00438638888889,
                "2026-01-22": 375.4068075,
                "2026-01-23": 22.336023333333333,
                "2026-01-26": 73.199895,
                "2026-02-03": 1455.0755877777779,
                "2026-02-04": 283.33237194444445,
                "2026-02-12": 677.8507477777778,
                "2026-02-13": 745.2133555555556,
                "2026-02-18": 30.320452222222222,
                "2026-02-21": 1.0789369444444443,
                "2026-02-22": 13.70508888888889,
                "2026-02-25": 48.44438916666667,
                "2026-02-28": 270.32559,
                "2026-03-05": 240.05608555555554,
                "2026-03-09": 315.7268388888889,
                "2026-03-10": 28.236327777777777,
                "2026-03-12": 1.0895355555555555,
                "2026-03-18": 281.48275805555556,
                "2026-03-20": 2662.4354677777783,
                "2026-03-25": 1.3516447222222223,
                "2026-03-30": 156.14892083333334,
                "2026-03-31": 67.4354625,
                "2026-04-02": 0.8328622222222223,
                "2026-04-07": 759.3510594444443,
                "2026-04-08": 4.124169444444444,
                "2026-04-13": 12.003203333333332,
                "2026-04-14": 0.25644805555555555,
                "2026-04-15": 1.012031388888889,
                "2026-04-17": 1.473281111111111,
                "2026-04-18": 2173.041656944444,
                "2026-04-20": 0.12358972222222223,
                "2026-04-21": 0.3257816666666667,
                "2026-04-22": 3055.3470725,
                "2026-04-23": 26.738362777777777,
                "2026-04-27": 7.428304166666667,
                "2026-04-29": 388.4468047222222,
                "2026-05-02": 121.72729,
                "2026-05-04": 1058.0572066666668,
                "2026-05-05": 540.2273280555555,
                "2026-05-06": 2101.217628888889,
                "2026-05-07": 18.234625277777777,
                "2026-05-08": 399.71883833333334,
                "2026-05-13": 241.2239025,
                "2026-05-14": 931.6076255555556,
                "2026-05-18": 9.894770833333334,
                "2026-05-21": 28.64557361111111,
                "2026-05-30": 572.8312088888889,
                "2026-06-01": 7.541388055555555
              },
              "time_count_per_day": {
                "2025-10-01": 2,
                "2025-10-10": 1,
                "2025-10-14": 1,
                "2025-10-20": 2,
                "2025-10-23": 3,
                "2025-10-29": 1,
                "2025-10-30": 2,
                "2025-11-03": 2,
                "2025-11-14": 2,
                "2025-11-17": 3,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-11-24": 1,
                "2025-11-25": 2,
                "2025-11-26": 1,
                "2025-11-27": 1,
                "2025-11-30": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-13": 2,
                "2025-12-23": 1,
                "2025-12-29": 3,
                "2026-01-05": 2,
                "2026-01-07": 2,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-22": 1,
                "2026-02-25": 1,
                "2026-02-28": 1,
                "2026-03-05": 2,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-18": 2,
                "2026-03-20": 5,
                "2026-03-25": 1,
                "2026-03-30": 2,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-13": 2,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-17": 1,
                "2026-04-18": 2,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 3,
                "2026-04-23": 1,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-05-02": 2,
                "2026-05-04": 5,
                "2026-05-05": 1,
                "2026-05-06": 6,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-13": 1,
                "2026-05-14": 3,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-30": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 237.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "16-18h": 1,
                "30-32h": 1,
                "38-40h": 1,
                "72-74h": 1,
                "100-102h": 1,
                "124-126h": 1,
                "136-138h": 1,
                "164-166h": 1,
                "280-282h": 1,
                "348-350h": 1,
                "358-360h": 1,
                "436-438h": 1,
                "758-760h": 1,
                "1388-1390h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-08": 1,
                "2025-10-27": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-17": 1,
                "2025-11-21": 2,
                "2025-11-25": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-13": 1,
                "2026-03-13": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2025-10-01": 2.3570408333333335,
                "2025-10-08": 16.555659444444444,
                "2025-10-27": 164.94374638888888,
                "2025-10-30": 38.69291333333334,
                "2025-11-03": 31.642903055555557,
                "2025-11-17": 359.2132055555556,
                "2025-11-21": 539.0012711111111,
                "2025-11-25": 0.150855,
                "2025-12-15": 197.71581055555555,
                "2025-12-17": 137.8797197222222,
                "2026-01-16": 0.6926694444444444,
                "2026-01-19": 0.9387702777777778,
                "2026-02-03": 349.7505844444445,
                "2026-02-13": 758.5593352777778,
                "2026-03-13": 1389.87631,
                "2026-03-18": 281.7378008333333
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-08": 1,
                "2025-10-27": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-17": 1,
                "2025-11-21": 2,
                "2025-11-25": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-13": 1,
                "2026-03-13": 1,
                "2026-03-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 255.23,
              "mode_time_hours": 283.0,
              "mode_frequency": 2,
              "time_distribution": {
                "50-52h": 1,
                "282-284h": 2,
                "404-406h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-18": 3,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-18": 969.8332113888888,
                "2026-03-20": 51.10537083333333
              },
              "time_count_per_day": {
                "2026-03-18": 3,
                "2026-03-20": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 577.64,
              "mode_time_hours": 577.0,
              "mode_frequency": 1,
              "time_distribution": {
                "576-578h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 577.6351647222223
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-04-23": 1,
              "2026-05-03": 1,
              "2026-05-04": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-05-03": 1,
                "2026-05-04": 1,
                "2026-05-26": 1,
                "2026-05-29": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-18": 1,
              "2026-05-06": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-18": 1,
                "2026-05-06": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-13": 1,
              "2026-05-27": 1,
              "2026-05-29": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-13": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-27": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_54": {
      "overall": {
        "avg_time_hours": 46.4,
        "mode_time_hours": 1.0,
        "mode_frequency": 346,
        "time_distribution": {
          "0-2h": 346,
          "2-4h": 98,
          "4-6h": 38,
          "6-8h": 21,
          "8-10h": 5,
          "10-12h": 15,
          "12-14h": 10,
          "14-16h": 12,
          "16-18h": 11,
          "18-20h": 12,
          "20-22h": 3,
          "22-24h": 12,
          "24-26h": 5,
          "26-28h": 3,
          "28-30h": 2,
          "30-32h": 1,
          "32-34h": 3,
          "34-36h": 5,
          "36-38h": 3,
          "40-42h": 4,
          "42-44h": 2,
          "44-46h": 4,
          "46-48h": 3,
          "48-50h": 1,
          "50-52h": 1,
          "52-54h": 2,
          "54-56h": 1,
          "62-64h": 1,
          "64-66h": 2,
          "72-74h": 4,
          "76-78h": 1,
          "84-86h": 1,
          "88-90h": 2,
          "90-92h": 1,
          "94-96h": 1,
          "96-98h": 4,
          "98-100h": 1,
          "100-102h": 1,
          "108-110h": 1,
          "114-116h": 1,
          "116-118h": 1,
          "118-120h": 2,
          "120-122h": 1,
          "136-138h": 1,
          "138-140h": 2,
          "140-142h": 1,
          "150-152h": 2,
          "152-154h": 1,
          "156-158h": 1,
          "158-160h": 1,
          "160-162h": 1,
          "162-164h": 2,
          "164-166h": 1,
          "166-168h": 2,
          "170-172h": 1,
          "180-182h": 1,
          "200-202h": 1,
          "202-204h": 1,
          "214-216h": 1,
          "226-228h": 1,
          "236-238h": 1,
          "242-244h": 1,
          "268-270h": 1,
          "270-272h": 1,
          "302-304h": 1,
          "306-308h": 3,
          "316-318h": 3,
          "320-322h": 1,
          "332-334h": 4,
          "348-350h": 1,
          "366-368h": 1,
          "376-378h": 1,
          "390-392h": 1,
          "434-436h": 1,
          "446-448h": 1,
          "460-462h": 1,
          "494-496h": 1,
          "496-498h": 1,
          "506-508h": 1,
          "512-514h": 1,
          "524-526h": 7,
          "666-668h": 1,
          "700-702h": 1,
          "724-726h": 2,
          "726-728h": 1,
          "792-794h": 1,
          "794-796h": 1,
          "852-854h": 1,
          "934-936h": 1,
          "1058-1060h": 1,
          "1196-1198h": 1,
          "1198-1200h": 1
        },
        "tickets_count": 720,
        "tickets_per_day": {
          "2025-09-30": 4,
          "2025-10-06": 1,
          "2025-10-07": 6,
          "2025-10-13": 3,
          "2025-10-14": 2,
          "2025-10-15": 4,
          "2025-10-16": 2,
          "2025-10-17": 5,
          "2025-10-23": 3,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-11-03": 10,
          "2025-11-04": 1,
          "2025-11-07": 3,
          "2025-11-08": 2,
          "2025-11-09": 1,
          "2025-11-12": 2,
          "2025-11-13": 2,
          "2025-11-14": 1,
          "2025-11-18": 2,
          "2025-11-19": 5,
          "2025-11-26": 2,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-04": 2,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-16": 2,
          "2025-12-22": 3,
          "2025-12-30": 1,
          "2026-01-07": 1,
          "2026-01-09": 2,
          "2026-01-13": 2,
          "2026-01-14": 3,
          "2026-01-15": 9,
          "2026-01-16": 15,
          "2026-01-20": 7,
          "2026-01-21": 1,
          "2026-01-23": 4,
          "2026-01-26": 1,
          "2026-01-27": 8,
          "2026-01-30": 9,
          "2026-02-03": 3,
          "2026-02-04": 9,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-09": 3,
          "2026-02-10": 6,
          "2026-02-11": 3,
          "2026-02-12": 3,
          "2026-02-13": 1,
          "2026-02-16": 3,
          "2026-02-17": 10,
          "2026-02-18": 11,
          "2026-02-19": 4,
          "2026-02-20": 1,
          "2026-02-23": 4,
          "2026-02-24": 14,
          "2026-02-25": 7,
          "2026-02-26": 3,
          "2026-02-27": 8,
          "2026-02-28": 14,
          "2026-03-02": 1,
          "2026-03-04": 22,
          "2026-03-05": 5,
          "2026-03-06": 7,
          "2026-03-07": 13,
          "2026-03-09": 8,
          "2026-03-10": 7,
          "2026-03-13": 2,
          "2026-03-16": 3,
          "2026-03-17": 7,
          "2026-03-18": 14,
          "2026-03-19": 16,
          "2026-03-20": 15,
          "2026-03-23": 2,
          "2026-03-24": 8,
          "2026-03-25": 8,
          "2026-03-26": 6,
          "2026-03-27": 9,
          "2026-03-30": 1,
          "2026-03-31": 6,
          "2026-04-01": 8,
          "2026-04-02": 2,
          "2026-04-04": 5,
          "2026-04-06": 6,
          "2026-04-07": 5,
          "2026-04-10": 2,
          "2026-04-11": 17,
          "2026-04-13": 12,
          "2026-04-14": 10,
          "2026-04-15": 9,
          "2026-04-16": 5,
          "2026-04-17": 18,
          "2026-04-20": 14,
          "2026-04-21": 6,
          "2026-04-22": 3,
          "2026-04-23": 5,
          "2026-04-24": 3,
          "2026-04-27": 9,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-04-30": 8,
          "2026-05-02": 1,
          "2026-05-04": 3,
          "2026-05-05": 3,
          "2026-05-06": 14,
          "2026-05-11": 5,
          "2026-05-13": 16,
          "2026-05-14": 9,
          "2026-05-15": 12,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-20": 2,
          "2026-05-21": 6,
          "2026-05-22": 1,
          "2026-05-25": 4,
          "2026-05-26": 11,
          "2026-05-27": 16,
          "2026-05-28": 9,
          "2026-05-30": 4,
          "2026-06-01": 4,
          "2026-06-02": 5,
          "2026-06-03": 16,
          "2026-06-05": 13,
          "2026-06-08": 4
        },
        "time_per_day": {
          "2025-09-30": 5.813929166666667,
          "2025-10-06": 88.2338486111111,
          "2025-10-07": 105.11058305555557,
          "2025-10-13": 14.863778055555555,
          "2025-10-14": 2.8192616666666668,
          "2025-10-15": 4.9016383333333335,
          "2025-10-16": 107.71357888888889,
          "2025-10-17": 98.634535,
          "2025-10-23": 491.46426444444444,
          "2025-10-24": 215.21984166666667,
          "2025-10-27": 158.2608275,
          "2025-11-03": 17.14510527777778,
          "2025-11-04": 1.1331905555555555,
          "2025-11-07": 642.7997044444444,
          "2025-11-08": 17.88305638888889,
          "2025-11-09": 41.51824638888889,
          "2025-11-12": 29.94479583333333,
          "2025-11-13": 862.127363888889,
          "2025-11-14": 16.632265277777776,
          "2025-11-18": 356.8504222222222,
          "2025-11-19": 686.9345602777778,
          "2025-11-26": 13.938205,
          "2025-11-27": 725.5615683333334,
          "2025-11-28": 40.8020525,
          "2025-12-04": 7.289094722222222,
          "2025-12-10": 189.8497952777778,
          "2025-12-11": 46.58428527777778,
          "2025-12-16": 431.1287186111111,
          "2025-12-22": 52.328917499999996,
          "2025-12-30": 0.1906186111111111,
          "2026-01-07": 377.6065341666667,
          "2026-01-09": 0.6517594444444444,
          "2026-01-13": 3.1049286111111107,
          "2026-01-14": 30.869110833333334,
          "2026-01-15": 817.354786388889,
          "2026-01-16": 42.16198777777777,
          "2026-01-20": 17.644410277777776,
          "2026-01-21": 795.1561586111111,
          "2026-01-23": 19.228603333333332,
          "2026-01-26": 10.922991944444444,
          "2026-01-27": 26.008133333333337,
          "2026-01-30": 33.25808472222222,
          "2026-02-03": 1325.6364080555554,
          "2026-02-04": 75.49758194444446,
          "2026-02-05": 3.0470458333333332,
          "2026-02-06": 3.508694444444444,
          "2026-02-09": 291.0624911111111,
          "2026-02-10": 2490.214246666667,
          "2026-02-11": 155.53297305555557,
          "2026-02-12": 14.585331666666665,
          "2026-02-13": 390.87425361111116,
          "2026-02-16": 824.8220775,
          "2026-02-17": 844.1042038888888,
          "2026-02-18": 13.159938055555555,
          "2026-02-19": 613.0574569444445,
          "2026-02-20": 0.35042611111111116,
          "2026-02-23": 157.39482361111115,
          "2026-02-24": 83.0660572222222,
          "2026-02-25": 37.11399527777778,
          "2026-02-26": 1.6786291666666666,
          "2026-02-27": 112.17344333333332,
          "2026-02-28": 116.6839475,
          "2026-03-02": 3.998465,
          "2026-03-04": 173.1626855555555,
          "2026-03-05": 241.78153222222224,
          "2026-03-06": 61.22751444444444,
          "2026-03-07": 144.4832486111111,
          "2026-03-09": 521.914816111111,
          "2026-03-10": 702.7983208333334,
          "2026-03-13": 1.600055277777778,
          "2026-03-16": 6.496965833333333,
          "2026-03-17": 53.572706388888896,
          "2026-03-18": 903.5784927777778,
          "2026-03-19": 34.419187777777765,
          "2026-03-20": 3291.5993561111104,
          "2026-03-23": 3.3926433333333335,
          "2026-03-24": 27.603335833333336,
          "2026-03-25": 73.48409694444445,
          "2026-03-26": 347.5459391666667,
          "2026-03-27": 73.76737333333334,
          "2026-03-30": 0.9534027777777778,
          "2026-03-31": 27.283340555555554,
          "2026-04-01": 77.79578527777778,
          "2026-04-02": 3.866191111111111,
          "2026-04-04": 14.172971666666665,
          "2026-04-06": 105.8420961111111,
          "2026-04-07": 78.93978861111111,
          "2026-04-10": 3.7986102777777777,
          "2026-04-11": 11.001355833333333,
          "2026-04-13": 83.83548194444444,
          "2026-04-14": 86.78415055555557,
          "2026-04-15": 29.271865833333333,
          "2026-04-16": 24.129258333333336,
          "2026-04-17": 70.40017638888888,
          "2026-04-20": 51.09867833333334,
          "2026-04-21": 50.590755833333326,
          "2026-04-22": 1777.7686169444444,
          "2026-04-23": 1244.742353333333,
          "2026-04-24": 37.55845138888889,
          "2026-04-27": 71.1644513888889,
          "2026-04-28": 935.5843691666666,
          "2026-04-29": 157.87616500000001,
          "2026-04-30": 70.20734111111112,
          "2026-05-02": 64.25406,
          "2026-05-04": 175.66457111111112,
          "2026-05-05": 22.083684166666664,
          "2026-05-06": 148.01111250000002,
          "2026-05-11": 131.41725416666665,
          "2026-05-13": 106.14941666666667,
          "2026-05-14": 35.07843666666666,
          "2026-05-15": 248.2289325,
          "2026-05-16": 29.643955833333333,
          "2026-05-18": 435.8702533333333,
          "2026-05-20": 25.01508527777778,
          "2026-05-21": 45.478008888888894,
          "2026-05-22": 21.416099166666665,
          "2026-05-25": 174.9130152777778,
          "2026-05-26": 2257.064501388889,
          "2026-05-27": 101.57496722222223,
          "2026-05-28": 548.933041111111,
          "2026-05-30": 34.38226777777778,
          "2026-06-01": 128.2659725,
          "2026-06-02": 236.26948916666663,
          "2026-06-03": 1244.6921311111114,
          "2026-06-05": 7.435764444444444,
          "2026-06-08": 74.73644083333335
        },
        "time_count_per_day": {
          "2025-09-30": 4,
          "2025-10-06": 1,
          "2025-10-07": 6,
          "2025-10-13": 3,
          "2025-10-14": 2,
          "2025-10-15": 4,
          "2025-10-16": 2,
          "2025-10-17": 5,
          "2025-10-23": 3,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-11-03": 10,
          "2025-11-04": 1,
          "2025-11-07": 3,
          "2025-11-08": 2,
          "2025-11-09": 1,
          "2025-11-12": 2,
          "2025-11-13": 2,
          "2025-11-14": 1,
          "2025-11-18": 2,
          "2025-11-19": 5,
          "2025-11-26": 2,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-04": 2,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-16": 2,
          "2025-12-22": 3,
          "2025-12-30": 1,
          "2026-01-07": 1,
          "2026-01-09": 2,
          "2026-01-13": 2,
          "2026-01-14": 3,
          "2026-01-15": 9,
          "2026-01-16": 15,
          "2026-01-20": 7,
          "2026-01-21": 1,
          "2026-01-23": 4,
          "2026-01-26": 1,
          "2026-01-27": 8,
          "2026-01-30": 9,
          "2026-02-03": 3,
          "2026-02-04": 9,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-09": 3,
          "2026-02-10": 6,
          "2026-02-11": 3,
          "2026-02-12": 3,
          "2026-02-13": 1,
          "2026-02-16": 3,
          "2026-02-17": 10,
          "2026-02-18": 11,
          "2026-02-19": 4,
          "2026-02-20": 1,
          "2026-02-23": 4,
          "2026-02-24": 13,
          "2026-02-25": 7,
          "2026-02-26": 3,
          "2026-02-27": 8,
          "2026-02-28": 14,
          "2026-03-02": 1,
          "2026-03-04": 22,
          "2026-03-05": 5,
          "2026-03-06": 7,
          "2026-03-07": 13,
          "2026-03-09": 7,
          "2026-03-10": 7,
          "2026-03-13": 2,
          "2026-03-16": 3,
          "2026-03-17": 7,
          "2026-03-18": 14,
          "2026-03-19": 16,
          "2026-03-20": 15,
          "2026-03-23": 2,
          "2026-03-24": 8,
          "2026-03-25": 8,
          "2026-03-26": 6,
          "2026-03-27": 9,
          "2026-03-30": 1,
          "2026-03-31": 6,
          "2026-04-01": 8,
          "2026-04-02": 2,
          "2026-04-04": 5,
          "2026-04-06": 6,
          "2026-04-07": 5,
          "2026-04-10": 2,
          "2026-04-11": 17,
          "2026-04-13": 12,
          "2026-04-14": 10,
          "2026-04-15": 9,
          "2026-04-16": 5,
          "2026-04-17": 18,
          "2026-04-20": 14,
          "2026-04-21": 6,
          "2026-04-22": 3,
          "2026-04-23": 5,
          "2026-04-24": 3,
          "2026-04-27": 9,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-04-30": 8,
          "2026-05-02": 1,
          "2026-05-04": 3,
          "2026-05-05": 3,
          "2026-05-06": 14,
          "2026-05-11": 5,
          "2026-05-13": 16,
          "2026-05-14": 9,
          "2026-05-15": 12,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-20": 2,
          "2026-05-21": 6,
          "2026-05-22": 1,
          "2026-05-25": 3,
          "2026-05-26": 11,
          "2026-05-27": 16,
          "2026-05-28": 9,
          "2026-05-30": 4,
          "2026-06-01": 3,
          "2026-06-02": 5,
          "2026-06-03": 16,
          "2026-06-05": 13,
          "2026-06-08": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 19.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 20,
          "time_distribution": {
            "0-2h": 20,
            "2-4h": 12,
            "4-6h": 5,
            "6-8h": 7,
            "8-10h": 2,
            "10-12h": 5,
            "12-14h": 3,
            "14-16h": 7,
            "16-18h": 5,
            "18-20h": 4,
            "20-22h": 2,
            "22-24h": 1,
            "26-28h": 1,
            "34-36h": 2,
            "36-38h": 1,
            "40-42h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "62-64h": 1,
            "72-74h": 1,
            "156-158h": 1,
            "434-436h": 1
          },
          "tickets_count": 87,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 6,
            "2025-10-13": 1,
            "2025-11-03": 1,
            "2025-11-08": 1,
            "2025-12-10": 1,
            "2026-02-12": 1,
            "2026-03-04": 3,
            "2026-03-17": 2,
            "2026-03-18": 4,
            "2026-03-19": 1,
            "2026-03-26": 1,
            "2026-04-01": 2,
            "2026-04-06": 4,
            "2026-04-07": 1,
            "2026-04-11": 1,
            "2026-04-13": 2,
            "2026-04-14": 4,
            "2026-04-15": 5,
            "2026-04-16": 1,
            "2026-04-17": 10,
            "2026-04-20": 2,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-05": 3,
            "2026-05-06": 4,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 2,
            "2026-05-26": 4,
            "2026-05-27": 4,
            "2026-05-28": 1,
            "2026-05-30": 2,
            "2026-06-01": 2,
            "2026-06-02": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-09-30": 5.516643055555556,
            "2025-10-07": 105.11058305555557,
            "2025-10-13": 1.3364169444444443,
            "2025-11-03": 7.510579444444445,
            "2025-11-08": 15.103649444444445,
            "2025-12-10": 23.88116861111111,
            "2026-02-12": 9.544401666666666,
            "2026-03-04": 21.693607500000002,
            "2026-03-17": 1.2133630555555555,
            "2026-03-18": 18.462410277777778,
            "2026-03-19": 19.21465611111111,
            "2026-03-26": 7.627271111111111,
            "2026-04-01": 28.515480555555555,
            "2026-04-06": 94.90337222222222,
            "2026-04-07": 1.3544436111111111,
            "2026-04-11": 8.266464166666667,
            "2026-04-13": 2.2019641666666665,
            "2026-04-14": 42.751111111111115,
            "2026-04-15": 24.017150833333332,
            "2026-04-16": 0.6490197222222223,
            "2026-04-17": 59.32034166666667,
            "2026-04-20": 42.692545555555554,
            "2026-04-27": 66.44613194444446,
            "2026-04-29": 157.87616500000001,
            "2026-04-30": 3.4188672222222225,
            "2026-05-05": 22.083684166666664,
            "2026-05-06": 89.00785833333333,
            "2026-05-18": 435.8702533333333,
            "2026-05-21": 35.05991527777778,
            "2026-05-22": 21.416099166666665,
            "2026-05-25": 73.19298916666666,
            "2026-05-26": 40.26002916666666,
            "2026-05-27": 76.33453944444446,
            "2026-05-28": 7.195656111111111,
            "2026-05-30": 31.36430916666667,
            "2026-06-01": 12.3827125,
            "2026-06-02": 14.600267777777777
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-07": 6,
            "2025-10-13": 1,
            "2025-11-03": 1,
            "2025-11-08": 1,
            "2025-12-10": 1,
            "2026-02-12": 1,
            "2026-03-04": 3,
            "2026-03-17": 2,
            "2026-03-18": 4,
            "2026-03-19": 1,
            "2026-03-26": 1,
            "2026-04-01": 2,
            "2026-04-06": 4,
            "2026-04-07": 1,
            "2026-04-11": 1,
            "2026-04-13": 2,
            "2026-04-14": 4,
            "2026-04-15": 5,
            "2026-04-16": 1,
            "2026-04-17": 10,
            "2026-04-20": 2,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-05": 3,
            "2026-05-06": 4,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-26": 4,
            "2026-05-27": 4,
            "2026-05-28": 1,
            "2026-05-30": 2,
            "2026-06-01": 2,
            "2026-06-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 40.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 305,
          "time_distribution": {
            "0-2h": 305,
            "2-4h": 80,
            "4-6h": 28,
            "6-8h": 13,
            "8-10h": 3,
            "10-12h": 9,
            "12-14h": 7,
            "14-16h": 5,
            "16-18h": 6,
            "18-20h": 8,
            "20-22h": 1,
            "22-24h": 7,
            "24-26h": 4,
            "28-30h": 2,
            "30-32h": 1,
            "32-34h": 3,
            "34-36h": 3,
            "36-38h": 1,
            "40-42h": 1,
            "42-44h": 2,
            "44-46h": 2,
            "46-48h": 1,
            "50-52h": 1,
            "52-54h": 2,
            "64-66h": 2,
            "72-74h": 3,
            "76-78h": 1,
            "84-86h": 1,
            "88-90h": 2,
            "94-96h": 1,
            "114-116h": 1,
            "118-120h": 1,
            "138-140h": 1,
            "152-154h": 1,
            "166-168h": 1,
            "180-182h": 1,
            "200-202h": 1,
            "202-204h": 1,
            "214-216h": 1,
            "226-228h": 1,
            "268-270h": 1,
            "302-304h": 1,
            "306-308h": 3,
            "316-318h": 2,
            "320-322h": 1,
            "332-334h": 4,
            "366-368h": 1,
            "376-378h": 1,
            "494-496h": 1,
            "496-498h": 1,
            "506-508h": 1,
            "512-514h": 1,
            "524-526h": 6,
            "666-668h": 1,
            "700-702h": 1,
            "724-726h": 1,
            "726-728h": 1,
            "792-794h": 1,
            "934-936h": 1,
            "1058-1060h": 1,
            "1196-1198h": 1,
            "1198-1200h": 1
          },
          "tickets_count": 549,
          "tickets_per_day": {
            "2025-09-30": 2,
            "2025-10-06": 1,
            "2025-10-13": 1,
            "2025-10-14": 2,
            "2025-10-15": 3,
            "2025-10-16": 2,
            "2025-10-24": 1,
            "2025-11-03": 1,
            "2025-11-07": 1,
            "2025-11-08": 1,
            "2025-11-09": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-26": 2,
            "2025-12-10": 1,
            "2025-12-22": 1,
            "2025-12-30": 1,
            "2026-01-07": 1,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 9,
            "2026-01-16": 15,
            "2026-01-20": 7,
            "2026-01-23": 3,
            "2026-01-27": 8,
            "2026-01-30": 9,
            "2026-02-04": 8,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 2,
            "2026-02-16": 2,
            "2026-02-17": 7,
            "2026-02-18": 11,
            "2026-02-19": 2,
            "2026-02-20": 1,
            "2026-02-23": 4,
            "2026-02-24": 13,
            "2026-02-25": 7,
            "2026-02-26": 3,
            "2026-02-27": 8,
            "2026-02-28": 13,
            "2026-03-02": 1,
            "2026-03-04": 13,
            "2026-03-05": 5,
            "2026-03-06": 7,
            "2026-03-07": 13,
            "2026-03-09": 7,
            "2026-03-10": 7,
            "2026-03-13": 2,
            "2026-03-16": 3,
            "2026-03-17": 5,
            "2026-03-18": 8,
            "2026-03-19": 15,
            "2026-03-20": 13,
            "2026-03-23": 2,
            "2026-03-24": 8,
            "2026-03-25": 7,
            "2026-03-26": 5,
            "2026-03-27": 9,
            "2026-03-30": 1,
            "2026-03-31": 6,
            "2026-04-01": 6,
            "2026-04-02": 2,
            "2026-04-04": 5,
            "2026-04-06": 2,
            "2026-04-07": 4,
            "2026-04-10": 2,
            "2026-04-11": 16,
            "2026-04-13": 10,
            "2026-04-14": 6,
            "2026-04-15": 4,
            "2026-04-16": 4,
            "2026-04-17": 8,
            "2026-04-20": 12,
            "2026-04-21": 6,
            "2026-04-22": 3,
            "2026-04-23": 5,
            "2026-04-24": 3,
            "2026-04-27": 6,
            "2026-04-28": 1,
            "2026-04-30": 7,
            "2026-05-02": 1,
            "2026-05-04": 3,
            "2026-05-06": 10,
            "2026-05-11": 5,
            "2026-05-13": 16,
            "2026-05-14": 9,
            "2026-05-15": 12,
            "2026-05-16": 1,
            "2026-05-20": 2,
            "2026-05-21": 5,
            "2026-05-25": 1,
            "2026-05-26": 7,
            "2026-05-27": 12,
            "2026-05-28": 8,
            "2026-05-30": 2,
            "2026-06-01": 2,
            "2026-06-02": 4,
            "2026-06-03": 16,
            "2026-06-05": 13,
            "2026-06-08": 3
          },
          "time_per_day": {
            "2025-09-30": 0.21541500000000002,
            "2025-10-06": 88.2338486111111,
            "2025-10-13": 8.75986611111111,
            "2025-10-14": 2.8192616666666668,
            "2025-10-15": 3.67656,
            "2025-10-16": 107.71357888888889,
            "2025-10-24": 215.21984166666667,
            "2025-11-03": 0.2363236111111111,
            "2025-11-07": 227.837975,
            "2025-11-08": 2.7794069444444442,
            "2025-11-09": 41.51824638888889,
            "2025-11-12": 2.013837777777778,
            "2025-11-13": 725.9614247222223,
            "2025-11-14": 16.632265277777776,
            "2025-11-26": 13.938205,
            "2025-12-10": 139.28275472222222,
            "2025-12-22": 47.64007583333333,
            "2025-12-30": 0.1906186111111111,
            "2026-01-07": 377.6065341666667,
            "2026-01-09": 0.6517594444444444,
            "2026-01-13": 0.4364375,
            "2026-01-14": 20.82775138888889,
            "2026-01-15": 817.354786388889,
            "2026-01-16": 42.16198777777777,
            "2026-01-20": 17.644410277777776,
            "2026-01-23": 14.419224722222221,
            "2026-01-27": 26.008133333333337,
            "2026-01-30": 33.25808472222222,
            "2026-02-04": 20.96688222222222,
            "2026-02-05": 3.0470458333333332,
            "2026-02-06": 2.168863611111111,
            "2026-02-10": 2485.9924319444444,
            "2026-02-11": 3.433265833333333,
            "2026-02-12": 5.0409299999999995,
            "2026-02-16": 733.25082,
            "2026-02-17": 320.23019638888894,
            "2026-02-18": 13.159938055555555,
            "2026-02-19": 0.5054038888888889,
            "2026-02-20": 0.35042611111111116,
            "2026-02-23": 157.39482361111115,
            "2026-02-24": 83.0660572222222,
            "2026-02-25": 37.11399527777778,
            "2026-02-26": 1.6786291666666666,
            "2026-02-27": 112.17344333333332,
            "2026-02-28": 19.422687499999995,
            "2026-03-02": 3.998465,
            "2026-03-04": 142.6134066666666,
            "2026-03-05": 241.78153222222224,
            "2026-03-06": 61.22751444444444,
            "2026-03-07": 144.4832486111111,
            "2026-03-09": 521.914816111111,
            "2026-03-10": 702.7983208333334,
            "2026-03-13": 1.600055277777778,
            "2026-03-16": 6.496965833333333,
            "2026-03-17": 52.359343333333335,
            "2026-03-18": 11.603616111111112,
            "2026-03-19": 15.204531666666664,
            "2026-03-20": 3206.310660277777,
            "2026-03-23": 3.3926433333333335,
            "2026-03-24": 27.603335833333336,
            "2026-03-25": 36.80092166666667,
            "2026-03-26": 339.9186680555556,
            "2026-03-27": 73.76737333333334,
            "2026-03-30": 0.9534027777777778,
            "2026-03-31": 27.283340555555554,
            "2026-04-01": 49.280304722222226,
            "2026-04-02": 3.866191111111111,
            "2026-04-04": 14.172971666666665,
            "2026-04-06": 10.938723888888891,
            "2026-04-07": 77.585345,
            "2026-04-10": 3.7986102777777777,
            "2026-04-11": 2.734891666666667,
            "2026-04-13": 81.63351777777777,
            "2026-04-14": 44.03303944444444,
            "2026-04-15": 5.254715,
            "2026-04-16": 23.480238611111115,
            "2026-04-17": 11.079834722222222,
            "2026-04-20": 8.406132777777778,
            "2026-04-21": 50.590755833333326,
            "2026-04-22": 1777.7686169444444,
            "2026-04-23": 1244.742353333333,
            "2026-04-24": 37.55845138888889,
            "2026-04-27": 4.718319444444445,
            "2026-04-28": 935.5843691666666,
            "2026-04-30": 66.7884738888889,
            "2026-05-02": 64.25406,
            "2026-05-04": 175.66457111111112,
            "2026-05-06": 59.003254166666665,
            "2026-05-11": 131.41725416666665,
            "2026-05-13": 106.14941666666667,
            "2026-05-14": 35.07843666666666,
            "2026-05-15": 248.2289325,
            "2026-05-16": 29.643955833333333,
            "2026-05-20": 25.01508527777778,
            "2026-05-21": 10.418093611111109,
            "2026-05-25": 1.6941355555555555,
            "2026-05-26": 2216.804472222222,
            "2026-05-27": 25.24042777777778,
            "2026-05-28": 541.7373849999999,
            "2026-05-30": 3.017958611111111,
            "2026-06-01": 115.88325999999999,
            "2026-06-02": 221.66922138888884,
            "2026-06-03": 1244.6921311111114,
            "2026-06-05": 7.435764444444444,
            "2026-06-08": 74.73644083333335
          },
          "time_count_per_day": {
            "2025-09-30": 2,
            "2025-10-06": 1,
            "2025-10-13": 1,
            "2025-10-14": 2,
            "2025-10-15": 3,
            "2025-10-16": 2,
            "2025-10-24": 1,
            "2025-11-03": 1,
            "2025-11-07": 1,
            "2025-11-08": 1,
            "2025-11-09": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-26": 2,
            "2025-12-10": 1,
            "2025-12-22": 1,
            "2025-12-30": 1,
            "2026-01-07": 1,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 9,
            "2026-01-16": 15,
            "2026-01-20": 7,
            "2026-01-23": 3,
            "2026-01-27": 8,
            "2026-01-30": 9,
            "2026-02-04": 8,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 2,
            "2026-02-16": 2,
            "2026-02-17": 7,
            "2026-02-18": 11,
            "2026-02-19": 2,
            "2026-02-20": 1,
            "2026-02-23": 4,
            "2026-02-24": 13,
            "2026-02-25": 7,
            "2026-02-26": 3,
            "2026-02-27": 8,
            "2026-02-28": 13,
            "2026-03-02": 1,
            "2026-03-04": 13,
            "2026-03-05": 5,
            "2026-03-06": 7,
            "2026-03-07": 13,
            "2026-03-09": 7,
            "2026-03-10": 7,
            "2026-03-13": 2,
            "2026-03-16": 3,
            "2026-03-17": 5,
            "2026-03-18": 8,
            "2026-03-19": 15,
            "2026-03-20": 13,
            "2026-03-23": 2,
            "2026-03-24": 8,
            "2026-03-25": 7,
            "2026-03-26": 5,
            "2026-03-27": 9,
            "2026-03-30": 1,
            "2026-03-31": 6,
            "2026-04-01": 6,
            "2026-04-02": 2,
            "2026-04-04": 5,
            "2026-04-06": 2,
            "2026-04-07": 4,
            "2026-04-10": 2,
            "2026-04-11": 16,
            "2026-04-13": 10,
            "2026-04-14": 6,
            "2026-04-15": 4,
            "2026-04-16": 4,
            "2026-04-17": 8,
            "2026-04-20": 12,
            "2026-04-21": 6,
            "2026-04-22": 3,
            "2026-04-23": 5,
            "2026-04-24": 3,
            "2026-04-27": 6,
            "2026-04-28": 1,
            "2026-04-30": 7,
            "2026-05-02": 1,
            "2026-05-04": 3,
            "2026-05-06": 10,
            "2026-05-11": 5,
            "2026-05-13": 16,
            "2026-05-14": 9,
            "2026-05-15": 12,
            "2026-05-16": 1,
            "2026-05-20": 2,
            "2026-05-21": 5,
            "2026-05-25": 1,
            "2026-05-26": 7,
            "2026-05-27": 12,
            "2026-05-28": 8,
            "2026-05-30": 2,
            "2026-06-01": 1,
            "2026-06-02": 4,
            "2026-06-03": 16,
            "2026-06-05": 13,
            "2026-06-08": 3
          }
        },
        "P3": {
          "avg_time_hours": 97.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 21,
          "time_distribution": {
            "0-2h": 21,
            "2-4h": 6,
            "4-6h": 5,
            "6-8h": 1,
            "10-12h": 1,
            "24-26h": 1,
            "40-42h": 1,
            "54-56h": 1,
            "96-98h": 3,
            "118-120h": 1,
            "136-138h": 1,
            "138-140h": 1,
            "140-142h": 1,
            "150-152h": 1,
            "158-160h": 1,
            "166-168h": 1,
            "170-172h": 1,
            "236-238h": 1,
            "242-244h": 1,
            "270-272h": 1,
            "316-318h": 1,
            "390-392h": 1,
            "446-448h": 1,
            "460-462h": 1,
            "724-726h": 1,
            "794-796h": 1
          },
          "tickets_count": 57,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-27": 1,
            "2025-11-03": 8,
            "2025-11-04": 1,
            "2025-11-07": 2,
            "2025-11-13": 1,
            "2025-11-18": 2,
            "2025-11-19": 3,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-22": 2,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-09": 3,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-19": 2,
            "2026-03-04": 6
          },
          "time_per_day": {
            "2025-09-30": 0.0818711111111111,
            "2025-10-13": 4.767495,
            "2025-10-15": 1.2250783333333333,
            "2025-10-17": 5.775149166666667,
            "2025-10-27": 158.2608275,
            "2025-11-03": 9.398202222222222,
            "2025-11-04": 1.1331905555555555,
            "2025-11-07": 414.9617294444445,
            "2025-11-13": 136.16593916666667,
            "2025-11-18": 356.8504222222222,
            "2025-11-19": 448.24334027777775,
            "2025-11-27": 725.5615683333334,
            "2025-11-28": 40.8020525,
            "2025-12-04": 7.289094722222222,
            "2025-12-11": 0.9519147222222222,
            "2025-12-16": 270.8696444444444,
            "2025-12-22": 4.688841666666667,
            "2026-01-13": 2.668491111111111,
            "2026-01-14": 10.041359444444446,
            "2026-01-21": 795.1561586111111,
            "2026-01-23": 4.809378611111111,
            "2026-01-26": 10.922991944444444,
            "2026-02-03": 472.4015486111111,
            "2026-02-04": 54.530699722222224,
            "2026-02-06": 1.3398308333333333,
            "2026-02-09": 291.0624911111111,
            "2026-02-10": 4.221814722222222,
            "2026-02-11": 0.6867611111111112,
            "2026-02-13": 390.87425361111116,
            "2026-02-17": 316.5820391666667,
            "2026-02-19": 612.5520530555556,
            "2026-03-04": 8.855671388888888
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-27": 1,
            "2025-11-03": 8,
            "2025-11-04": 1,
            "2025-11-07": 2,
            "2025-11-13": 1,
            "2025-11-18": 2,
            "2025-11-19": 3,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-22": 2,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-09": 3,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-19": 2,
            "2026-03-04": 6
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 114.58,
          "mode_time_hours": 23.0,
          "mode_frequency": 4,
          "time_distribution": {
            "22-24h": 4,
            "26-28h": 2,
            "36-38h": 1,
            "40-42h": 1,
            "44-46h": 1,
            "90-92h": 1,
            "96-98h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "108-110h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "150-152h": 1,
            "162-164h": 2,
            "164-166h": 1,
            "348-350h": 1,
            "524-526h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-10-17": 4,
            "2025-10-23": 3,
            "2025-11-12": 1,
            "2025-11-19": 2,
            "2025-12-10": 1,
            "2026-02-11": 1,
            "2026-02-16": 1,
            "2026-02-17": 2,
            "2026-02-24": 1,
            "2026-02-28": 1,
            "2026-03-18": 2,
            "2026-03-20": 2,
            "2026-03-25": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2025-10-17": 92.85938583333333,
            "2025-10-23": 491.46426444444444,
            "2025-11-12": 27.930958055555553,
            "2025-11-19": 238.69122,
            "2025-12-10": 26.685871944444443,
            "2026-02-11": 151.41294611111113,
            "2026-02-16": 91.5712575,
            "2026-02-17": 207.29196833333333,
            "2026-02-28": 97.26126000000001,
            "2026-03-18": 873.5124663888889,
            "2026-03-20": 85.28869583333335,
            "2026-03-25": 36.68317527777778,
            "2026-05-25": 100.02589055555556
          },
          "time_count_per_day": {
            "2025-10-17": 4,
            "2025-10-23": 3,
            "2025-11-12": 1,
            "2025-11-19": 2,
            "2025-12-10": 1,
            "2026-02-11": 1,
            "2026-02-16": 1,
            "2026-02-17": 2,
            "2026-02-28": 1,
            "2026-03-18": 2,
            "2026-03-20": 2,
            "2026-03-25": 1,
            "2026-05-25": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 353.04,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1,
            "160-162h": 1,
            "852-854h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2026-02-03": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2025-12-11": 45.63237055555556,
            "2025-12-16": 160.25907416666666,
            "2026-02-03": 853.2348594444444
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 46.4,
            "mode_time_hours": 1.0,
            "mode_frequency": 346,
            "time_distribution": {
              "0-2h": 346,
              "2-4h": 98,
              "4-6h": 38,
              "6-8h": 21,
              "8-10h": 5,
              "10-12h": 15,
              "12-14h": 10,
              "14-16h": 12,
              "16-18h": 11,
              "18-20h": 12,
              "20-22h": 3,
              "22-24h": 12,
              "24-26h": 5,
              "26-28h": 3,
              "28-30h": 2,
              "30-32h": 1,
              "32-34h": 3,
              "34-36h": 5,
              "36-38h": 3,
              "40-42h": 4,
              "42-44h": 2,
              "44-46h": 4,
              "46-48h": 3,
              "48-50h": 1,
              "50-52h": 1,
              "52-54h": 2,
              "54-56h": 1,
              "62-64h": 1,
              "64-66h": 2,
              "72-74h": 4,
              "76-78h": 1,
              "84-86h": 1,
              "88-90h": 2,
              "90-92h": 1,
              "94-96h": 1,
              "96-98h": 4,
              "98-100h": 1,
              "100-102h": 1,
              "108-110h": 1,
              "114-116h": 1,
              "116-118h": 1,
              "118-120h": 2,
              "120-122h": 1,
              "136-138h": 1,
              "138-140h": 2,
              "140-142h": 1,
              "150-152h": 2,
              "152-154h": 1,
              "156-158h": 1,
              "158-160h": 1,
              "160-162h": 1,
              "162-164h": 2,
              "164-166h": 1,
              "166-168h": 2,
              "170-172h": 1,
              "180-182h": 1,
              "200-202h": 1,
              "202-204h": 1,
              "214-216h": 1,
              "226-228h": 1,
              "236-238h": 1,
              "242-244h": 1,
              "268-270h": 1,
              "270-272h": 1,
              "302-304h": 1,
              "306-308h": 3,
              "316-318h": 3,
              "320-322h": 1,
              "332-334h": 4,
              "348-350h": 1,
              "366-368h": 1,
              "376-378h": 1,
              "390-392h": 1,
              "434-436h": 1,
              "446-448h": 1,
              "460-462h": 1,
              "494-496h": 1,
              "496-498h": 1,
              "506-508h": 1,
              "512-514h": 1,
              "524-526h": 7,
              "666-668h": 1,
              "700-702h": 1,
              "724-726h": 2,
              "726-728h": 1,
              "792-794h": 1,
              "794-796h": 1,
              "852-854h": 1,
              "934-936h": 1,
              "1058-1060h": 1,
              "1196-1198h": 1,
              "1198-1200h": 1
            },
            "tickets_count": 715,
            "tickets_per_day": {
              "2025-09-30": 4,
              "2025-10-06": 1,
              "2025-10-07": 6,
              "2025-10-13": 3,
              "2025-10-14": 2,
              "2025-10-15": 4,
              "2025-10-16": 2,
              "2025-10-17": 5,
              "2025-10-23": 3,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-11-03": 10,
              "2025-11-04": 1,
              "2025-11-07": 3,
              "2025-11-08": 2,
              "2025-11-09": 1,
              "2025-11-12": 2,
              "2025-11-13": 2,
              "2025-11-14": 1,
              "2025-11-18": 2,
              "2025-11-19": 5,
              "2025-11-26": 2,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-04": 2,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-16": 2,
              "2025-12-22": 3,
              "2025-12-30": 1,
              "2026-01-07": 1,
              "2026-01-09": 2,
              "2026-01-13": 2,
              "2026-01-14": 3,
              "2026-01-15": 9,
              "2026-01-16": 15,
              "2026-01-20": 7,
              "2026-01-21": 1,
              "2026-01-23": 4,
              "2026-01-26": 1,
              "2026-01-27": 8,
              "2026-01-30": 9,
              "2026-02-03": 3,
              "2026-02-04": 9,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-09": 3,
              "2026-02-10": 6,
              "2026-02-11": 3,
              "2026-02-12": 3,
              "2026-02-13": 1,
              "2026-02-16": 3,
              "2026-02-17": 10,
              "2026-02-18": 11,
              "2026-02-19": 4,
              "2026-02-20": 1,
              "2026-02-23": 4,
              "2026-02-24": 13,
              "2026-02-25": 7,
              "2026-02-26": 3,
              "2026-02-27": 8,
              "2026-02-28": 14,
              "2026-03-02": 1,
              "2026-03-04": 22,
              "2026-03-05": 5,
              "2026-03-06": 7,
              "2026-03-07": 13,
              "2026-03-09": 7,
              "2026-03-10": 7,
              "2026-03-13": 2,
              "2026-03-16": 3,
              "2026-03-17": 7,
              "2026-03-18": 14,
              "2026-03-19": 16,
              "2026-03-20": 15,
              "2026-03-23": 2,
              "2026-03-24": 8,
              "2026-03-25": 8,
              "2026-03-26": 6,
              "2026-03-27": 9,
              "2026-03-30": 1,
              "2026-03-31": 6,
              "2026-04-01": 8,
              "2026-04-02": 2,
              "2026-04-04": 5,
              "2026-04-06": 6,
              "2026-04-07": 5,
              "2026-04-10": 2,
              "2026-04-11": 17,
              "2026-04-13": 12,
              "2026-04-14": 10,
              "2026-04-15": 9,
              "2026-04-16": 5,
              "2026-04-17": 18,
              "2026-04-20": 14,
              "2026-04-21": 6,
              "2026-04-22": 3,
              "2026-04-23": 5,
              "2026-04-24": 3,
              "2026-04-27": 9,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-04-30": 8,
              "2026-05-02": 1,
              "2026-05-04": 3,
              "2026-05-05": 3,
              "2026-05-06": 14,
              "2026-05-11": 5,
              "2026-05-13": 16,
              "2026-05-14": 9,
              "2026-05-15": 12,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-20": 2,
              "2026-05-21": 6,
              "2026-05-22": 1,
              "2026-05-25": 3,
              "2026-05-26": 11,
              "2026-05-27": 16,
              "2026-05-28": 9,
              "2026-05-30": 4,
              "2026-06-01": 3,
              "2026-06-02": 5,
              "2026-06-03": 16,
              "2026-06-05": 13,
              "2026-06-08": 3
            },
            "time_per_day": {
              "2025-09-30": 5.813929166666667,
              "2025-10-06": 88.2338486111111,
              "2025-10-07": 105.11058305555557,
              "2025-10-13": 14.863778055555555,
              "2025-10-14": 2.8192616666666668,
              "2025-10-15": 4.9016383333333335,
              "2025-10-16": 107.71357888888889,
              "2025-10-17": 98.634535,
              "2025-10-23": 491.46426444444444,
              "2025-10-24": 215.21984166666667,
              "2025-10-27": 158.2608275,
              "2025-11-03": 17.14510527777778,
              "2025-11-04": 1.1331905555555555,
              "2025-11-07": 642.7997044444444,
              "2025-11-08": 17.88305638888889,
              "2025-11-09": 41.51824638888889,
              "2025-11-12": 29.94479583333333,
              "2025-11-13": 862.127363888889,
              "2025-11-14": 16.632265277777776,
              "2025-11-18": 356.8504222222222,
              "2025-11-19": 686.9345602777778,
              "2025-11-26": 13.938205,
              "2025-11-27": 725.5615683333334,
              "2025-11-28": 40.8020525,
              "2025-12-04": 7.289094722222222,
              "2025-12-10": 189.8497952777778,
              "2025-12-11": 46.58428527777778,
              "2025-12-16": 431.1287186111111,
              "2025-12-22": 52.328917499999996,
              "2025-12-30": 0.1906186111111111,
              "2026-01-07": 377.6065341666667,
              "2026-01-09": 0.6517594444444444,
              "2026-01-13": 3.1049286111111107,
              "2026-01-14": 30.869110833333334,
              "2026-01-15": 817.354786388889,
              "2026-01-16": 42.16198777777777,
              "2026-01-20": 17.644410277777776,
              "2026-01-21": 795.1561586111111,
              "2026-01-23": 19.228603333333332,
              "2026-01-26": 10.922991944444444,
              "2026-01-27": 26.008133333333337,
              "2026-01-30": 33.25808472222222,
              "2026-02-03": 1325.6364080555554,
              "2026-02-04": 75.49758194444446,
              "2026-02-05": 3.0470458333333332,
              "2026-02-06": 3.508694444444444,
              "2026-02-09": 291.0624911111111,
              "2026-02-10": 2490.214246666667,
              "2026-02-11": 155.53297305555557,
              "2026-02-12": 14.585331666666665,
              "2026-02-13": 390.87425361111116,
              "2026-02-16": 824.8220775,
              "2026-02-17": 844.1042038888888,
              "2026-02-18": 13.159938055555555,
              "2026-02-19": 613.0574569444445,
              "2026-02-20": 0.35042611111111116,
              "2026-02-23": 157.39482361111115,
              "2026-02-24": 83.0660572222222,
              "2026-02-25": 37.11399527777778,
              "2026-02-26": 1.6786291666666666,
              "2026-02-27": 112.17344333333332,
              "2026-02-28": 116.6839475,
              "2026-03-02": 3.998465,
              "2026-03-04": 173.1626855555555,
              "2026-03-05": 241.78153222222224,
              "2026-03-06": 61.22751444444444,
              "2026-03-07": 144.4832486111111,
              "2026-03-09": 521.914816111111,
              "2026-03-10": 702.7983208333334,
              "2026-03-13": 1.600055277777778,
              "2026-03-16": 6.496965833333333,
              "2026-03-17": 53.572706388888896,
              "2026-03-18": 903.5784927777778,
              "2026-03-19": 34.419187777777765,
              "2026-03-20": 3291.5993561111104,
              "2026-03-23": 3.3926433333333335,
              "2026-03-24": 27.603335833333336,
              "2026-03-25": 73.48409694444445,
              "2026-03-26": 347.5459391666667,
              "2026-03-27": 73.76737333333334,
              "2026-03-30": 0.9534027777777778,
              "2026-03-31": 27.283340555555554,
              "2026-04-01": 77.79578527777778,
              "2026-04-02": 3.866191111111111,
              "2026-04-04": 14.172971666666665,
              "2026-04-06": 105.8420961111111,
              "2026-04-07": 78.93978861111111,
              "2026-04-10": 3.7986102777777777,
              "2026-04-11": 11.001355833333333,
              "2026-04-13": 83.83548194444444,
              "2026-04-14": 86.78415055555557,
              "2026-04-15": 29.271865833333333,
              "2026-04-16": 24.129258333333336,
              "2026-04-17": 70.40017638888888,
              "2026-04-20": 51.09867833333334,
              "2026-04-21": 50.590755833333326,
              "2026-04-22": 1777.7686169444444,
              "2026-04-23": 1244.742353333333,
              "2026-04-24": 37.55845138888889,
              "2026-04-27": 71.1644513888889,
              "2026-04-28": 935.5843691666666,
              "2026-04-29": 157.87616500000001,
              "2026-04-30": 70.20734111111112,
              "2026-05-02": 64.25406,
              "2026-05-04": 175.66457111111112,
              "2026-05-05": 22.083684166666664,
              "2026-05-06": 148.01111250000002,
              "2026-05-11": 131.41725416666665,
              "2026-05-13": 106.14941666666667,
              "2026-05-14": 35.07843666666666,
              "2026-05-15": 248.2289325,
              "2026-05-16": 29.643955833333333,
              "2026-05-18": 435.8702533333333,
              "2026-05-20": 25.01508527777778,
              "2026-05-21": 45.478008888888894,
              "2026-05-22": 21.416099166666665,
              "2026-05-25": 174.9130152777778,
              "2026-05-26": 2257.064501388889,
              "2026-05-27": 101.57496722222223,
              "2026-05-28": 548.933041111111,
              "2026-05-30": 34.38226777777778,
              "2026-06-01": 128.2659725,
              "2026-06-02": 236.26948916666663,
              "2026-06-03": 1244.6921311111114,
              "2026-06-05": 7.435764444444444,
              "2026-06-08": 74.73644083333335
            },
            "time_count_per_day": {
              "2025-09-30": 4,
              "2025-10-06": 1,
              "2025-10-07": 6,
              "2025-10-13": 3,
              "2025-10-14": 2,
              "2025-10-15": 4,
              "2025-10-16": 2,
              "2025-10-17": 5,
              "2025-10-23": 3,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-11-03": 10,
              "2025-11-04": 1,
              "2025-11-07": 3,
              "2025-11-08": 2,
              "2025-11-09": 1,
              "2025-11-12": 2,
              "2025-11-13": 2,
              "2025-11-14": 1,
              "2025-11-18": 2,
              "2025-11-19": 5,
              "2025-11-26": 2,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-04": 2,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-16": 2,
              "2025-12-22": 3,
              "2025-12-30": 1,
              "2026-01-07": 1,
              "2026-01-09": 2,
              "2026-01-13": 2,
              "2026-01-14": 3,
              "2026-01-15": 9,
              "2026-01-16": 15,
              "2026-01-20": 7,
              "2026-01-21": 1,
              "2026-01-23": 4,
              "2026-01-26": 1,
              "2026-01-27": 8,
              "2026-01-30": 9,
              "2026-02-03": 3,
              "2026-02-04": 9,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-09": 3,
              "2026-02-10": 6,
              "2026-02-11": 3,
              "2026-02-12": 3,
              "2026-02-13": 1,
              "2026-02-16": 3,
              "2026-02-17": 10,
              "2026-02-18": 11,
              "2026-02-19": 4,
              "2026-02-20": 1,
              "2026-02-23": 4,
              "2026-02-24": 13,
              "2026-02-25": 7,
              "2026-02-26": 3,
              "2026-02-27": 8,
              "2026-02-28": 14,
              "2026-03-02": 1,
              "2026-03-04": 22,
              "2026-03-05": 5,
              "2026-03-06": 7,
              "2026-03-07": 13,
              "2026-03-09": 7,
              "2026-03-10": 7,
              "2026-03-13": 2,
              "2026-03-16": 3,
              "2026-03-17": 7,
              "2026-03-18": 14,
              "2026-03-19": 16,
              "2026-03-20": 15,
              "2026-03-23": 2,
              "2026-03-24": 8,
              "2026-03-25": 8,
              "2026-03-26": 6,
              "2026-03-27": 9,
              "2026-03-30": 1,
              "2026-03-31": 6,
              "2026-04-01": 8,
              "2026-04-02": 2,
              "2026-04-04": 5,
              "2026-04-06": 6,
              "2026-04-07": 5,
              "2026-04-10": 2,
              "2026-04-11": 17,
              "2026-04-13": 12,
              "2026-04-14": 10,
              "2026-04-15": 9,
              "2026-04-16": 5,
              "2026-04-17": 18,
              "2026-04-20": 14,
              "2026-04-21": 6,
              "2026-04-22": 3,
              "2026-04-23": 5,
              "2026-04-24": 3,
              "2026-04-27": 9,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-04-30": 8,
              "2026-05-02": 1,
              "2026-05-04": 3,
              "2026-05-05": 3,
              "2026-05-06": 14,
              "2026-05-11": 5,
              "2026-05-13": 16,
              "2026-05-14": 9,
              "2026-05-15": 12,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-20": 2,
              "2026-05-21": 6,
              "2026-05-22": 1,
              "2026-05-25": 3,
              "2026-05-26": 11,
              "2026-05-27": 16,
              "2026-05-28": 9,
              "2026-05-30": 4,
              "2026-06-01": 3,
              "2026-06-02": 5,
              "2026-06-03": 16,
              "2026-06-05": 13,
              "2026-06-08": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 19.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 20,
              "time_distribution": {
                "0-2h": 20,
                "2-4h": 12,
                "4-6h": 5,
                "6-8h": 7,
                "8-10h": 2,
                "10-12h": 5,
                "12-14h": 3,
                "14-16h": 7,
                "16-18h": 5,
                "18-20h": 4,
                "20-22h": 2,
                "22-24h": 1,
                "26-28h": 1,
                "34-36h": 2,
                "36-38h": 1,
                "40-42h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "62-64h": 1,
                "72-74h": 1,
                "156-158h": 1,
                "434-436h": 1
              },
              "tickets_count": 85,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 6,
                "2025-10-13": 1,
                "2025-11-03": 1,
                "2025-11-08": 1,
                "2025-12-10": 1,
                "2026-02-12": 1,
                "2026-03-04": 3,
                "2026-03-17": 2,
                "2026-03-18": 4,
                "2026-03-19": 1,
                "2026-03-26": 1,
                "2026-04-01": 2,
                "2026-04-06": 4,
                "2026-04-07": 1,
                "2026-04-11": 1,
                "2026-04-13": 2,
                "2026-04-14": 4,
                "2026-04-15": 5,
                "2026-04-16": 1,
                "2026-04-17": 10,
                "2026-04-20": 2,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-05": 3,
                "2026-05-06": 4,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 4,
                "2026-05-27": 4,
                "2026-05-28": 1,
                "2026-05-30": 2,
                "2026-06-01": 2,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-09-30": 5.516643055555556,
                "2025-10-07": 105.11058305555557,
                "2025-10-13": 1.3364169444444443,
                "2025-11-03": 7.510579444444445,
                "2025-11-08": 15.103649444444445,
                "2025-12-10": 23.88116861111111,
                "2026-02-12": 9.544401666666666,
                "2026-03-04": 21.693607500000002,
                "2026-03-17": 1.2133630555555555,
                "2026-03-18": 18.462410277777778,
                "2026-03-19": 19.21465611111111,
                "2026-03-26": 7.627271111111111,
                "2026-04-01": 28.515480555555555,
                "2026-04-06": 94.90337222222222,
                "2026-04-07": 1.3544436111111111,
                "2026-04-11": 8.266464166666667,
                "2026-04-13": 2.2019641666666665,
                "2026-04-14": 42.751111111111115,
                "2026-04-15": 24.017150833333332,
                "2026-04-16": 0.6490197222222223,
                "2026-04-17": 59.32034166666667,
                "2026-04-20": 42.692545555555554,
                "2026-04-27": 66.44613194444446,
                "2026-04-29": 157.87616500000001,
                "2026-04-30": 3.4188672222222225,
                "2026-05-05": 22.083684166666664,
                "2026-05-06": 89.00785833333333,
                "2026-05-18": 435.8702533333333,
                "2026-05-21": 35.05991527777778,
                "2026-05-22": 21.416099166666665,
                "2026-05-25": 73.19298916666666,
                "2026-05-26": 40.26002916666666,
                "2026-05-27": 76.33453944444446,
                "2026-05-28": 7.195656111111111,
                "2026-05-30": 31.36430916666667,
                "2026-06-01": 12.3827125,
                "2026-06-02": 14.600267777777777
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-07": 6,
                "2025-10-13": 1,
                "2025-11-03": 1,
                "2025-11-08": 1,
                "2025-12-10": 1,
                "2026-02-12": 1,
                "2026-03-04": 3,
                "2026-03-17": 2,
                "2026-03-18": 4,
                "2026-03-19": 1,
                "2026-03-26": 1,
                "2026-04-01": 2,
                "2026-04-06": 4,
                "2026-04-07": 1,
                "2026-04-11": 1,
                "2026-04-13": 2,
                "2026-04-14": 4,
                "2026-04-15": 5,
                "2026-04-16": 1,
                "2026-04-17": 10,
                "2026-04-20": 2,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-05": 3,
                "2026-05-06": 4,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 4,
                "2026-05-27": 4,
                "2026-05-28": 1,
                "2026-05-30": 2,
                "2026-06-01": 2,
                "2026-06-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 40.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 305,
              "time_distribution": {
                "0-2h": 305,
                "2-4h": 80,
                "4-6h": 28,
                "6-8h": 13,
                "8-10h": 3,
                "10-12h": 9,
                "12-14h": 7,
                "14-16h": 5,
                "16-18h": 6,
                "18-20h": 8,
                "20-22h": 1,
                "22-24h": 7,
                "24-26h": 4,
                "28-30h": 2,
                "30-32h": 1,
                "32-34h": 3,
                "34-36h": 3,
                "36-38h": 1,
                "40-42h": 1,
                "42-44h": 2,
                "44-46h": 2,
                "46-48h": 1,
                "50-52h": 1,
                "52-54h": 2,
                "64-66h": 2,
                "72-74h": 3,
                "76-78h": 1,
                "84-86h": 1,
                "88-90h": 2,
                "94-96h": 1,
                "114-116h": 1,
                "118-120h": 1,
                "138-140h": 1,
                "152-154h": 1,
                "166-168h": 1,
                "180-182h": 1,
                "200-202h": 1,
                "202-204h": 1,
                "214-216h": 1,
                "226-228h": 1,
                "268-270h": 1,
                "302-304h": 1,
                "306-308h": 3,
                "316-318h": 2,
                "320-322h": 1,
                "332-334h": 4,
                "366-368h": 1,
                "376-378h": 1,
                "494-496h": 1,
                "496-498h": 1,
                "506-508h": 1,
                "512-514h": 1,
                "524-526h": 6,
                "666-668h": 1,
                "700-702h": 1,
                "724-726h": 1,
                "726-728h": 1,
                "792-794h": 1,
                "934-936h": 1,
                "1058-1060h": 1,
                "1196-1198h": 1,
                "1198-1200h": 1
              },
              "tickets_count": 548,
              "tickets_per_day": {
                "2025-09-30": 2,
                "2025-10-06": 1,
                "2025-10-13": 1,
                "2025-10-14": 2,
                "2025-10-15": 3,
                "2025-10-16": 2,
                "2025-10-24": 1,
                "2025-11-03": 1,
                "2025-11-07": 1,
                "2025-11-08": 1,
                "2025-11-09": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-26": 2,
                "2025-12-10": 1,
                "2025-12-22": 1,
                "2025-12-30": 1,
                "2026-01-07": 1,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 9,
                "2026-01-16": 15,
                "2026-01-20": 7,
                "2026-01-23": 3,
                "2026-01-27": 8,
                "2026-01-30": 9,
                "2026-02-04": 8,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 2,
                "2026-02-16": 2,
                "2026-02-17": 7,
                "2026-02-18": 11,
                "2026-02-19": 2,
                "2026-02-20": 1,
                "2026-02-23": 4,
                "2026-02-24": 13,
                "2026-02-25": 7,
                "2026-02-26": 3,
                "2026-02-27": 8,
                "2026-02-28": 13,
                "2026-03-02": 1,
                "2026-03-04": 13,
                "2026-03-05": 5,
                "2026-03-06": 7,
                "2026-03-07": 13,
                "2026-03-09": 7,
                "2026-03-10": 7,
                "2026-03-13": 2,
                "2026-03-16": 3,
                "2026-03-17": 5,
                "2026-03-18": 8,
                "2026-03-19": 15,
                "2026-03-20": 13,
                "2026-03-23": 2,
                "2026-03-24": 8,
                "2026-03-25": 7,
                "2026-03-26": 5,
                "2026-03-27": 9,
                "2026-03-30": 1,
                "2026-03-31": 6,
                "2026-04-01": 6,
                "2026-04-02": 2,
                "2026-04-04": 5,
                "2026-04-06": 2,
                "2026-04-07": 4,
                "2026-04-10": 2,
                "2026-04-11": 16,
                "2026-04-13": 10,
                "2026-04-14": 6,
                "2026-04-15": 4,
                "2026-04-16": 4,
                "2026-04-17": 8,
                "2026-04-20": 12,
                "2026-04-21": 6,
                "2026-04-22": 3,
                "2026-04-23": 5,
                "2026-04-24": 3,
                "2026-04-27": 6,
                "2026-04-28": 1,
                "2026-04-30": 7,
                "2026-05-02": 1,
                "2026-05-04": 3,
                "2026-05-06": 10,
                "2026-05-11": 5,
                "2026-05-13": 16,
                "2026-05-14": 9,
                "2026-05-15": 12,
                "2026-05-16": 1,
                "2026-05-20": 2,
                "2026-05-21": 5,
                "2026-05-25": 1,
                "2026-05-26": 7,
                "2026-05-27": 12,
                "2026-05-28": 8,
                "2026-05-30": 2,
                "2026-06-01": 1,
                "2026-06-02": 4,
                "2026-06-03": 16,
                "2026-06-05": 13,
                "2026-06-08": 3
              },
              "time_per_day": {
                "2025-09-30": 0.21541500000000002,
                "2025-10-06": 88.2338486111111,
                "2025-10-13": 8.75986611111111,
                "2025-10-14": 2.8192616666666668,
                "2025-10-15": 3.67656,
                "2025-10-16": 107.71357888888889,
                "2025-10-24": 215.21984166666667,
                "2025-11-03": 0.2363236111111111,
                "2025-11-07": 227.837975,
                "2025-11-08": 2.7794069444444442,
                "2025-11-09": 41.51824638888889,
                "2025-11-12": 2.013837777777778,
                "2025-11-13": 725.9614247222223,
                "2025-11-14": 16.632265277777776,
                "2025-11-26": 13.938205,
                "2025-12-10": 139.28275472222222,
                "2025-12-22": 47.64007583333333,
                "2025-12-30": 0.1906186111111111,
                "2026-01-07": 377.6065341666667,
                "2026-01-09": 0.6517594444444444,
                "2026-01-13": 0.4364375,
                "2026-01-14": 20.82775138888889,
                "2026-01-15": 817.354786388889,
                "2026-01-16": 42.16198777777777,
                "2026-01-20": 17.644410277777776,
                "2026-01-23": 14.419224722222221,
                "2026-01-27": 26.008133333333337,
                "2026-01-30": 33.25808472222222,
                "2026-02-04": 20.96688222222222,
                "2026-02-05": 3.0470458333333332,
                "2026-02-06": 2.168863611111111,
                "2026-02-10": 2485.9924319444444,
                "2026-02-11": 3.433265833333333,
                "2026-02-12": 5.0409299999999995,
                "2026-02-16": 733.25082,
                "2026-02-17": 320.23019638888894,
                "2026-02-18": 13.159938055555555,
                "2026-02-19": 0.5054038888888889,
                "2026-02-20": 0.35042611111111116,
                "2026-02-23": 157.39482361111115,
                "2026-02-24": 83.0660572222222,
                "2026-02-25": 37.11399527777778,
                "2026-02-26": 1.6786291666666666,
                "2026-02-27": 112.17344333333332,
                "2026-02-28": 19.422687499999995,
                "2026-03-02": 3.998465,
                "2026-03-04": 142.6134066666666,
                "2026-03-05": 241.78153222222224,
                "2026-03-06": 61.22751444444444,
                "2026-03-07": 144.4832486111111,
                "2026-03-09": 521.914816111111,
                "2026-03-10": 702.7983208333334,
                "2026-03-13": 1.600055277777778,
                "2026-03-16": 6.496965833333333,
                "2026-03-17": 52.359343333333335,
                "2026-03-18": 11.603616111111112,
                "2026-03-19": 15.204531666666664,
                "2026-03-20": 3206.310660277777,
                "2026-03-23": 3.3926433333333335,
                "2026-03-24": 27.603335833333336,
                "2026-03-25": 36.80092166666667,
                "2026-03-26": 339.9186680555556,
                "2026-03-27": 73.76737333333334,
                "2026-03-30": 0.9534027777777778,
                "2026-03-31": 27.283340555555554,
                "2026-04-01": 49.280304722222226,
                "2026-04-02": 3.866191111111111,
                "2026-04-04": 14.172971666666665,
                "2026-04-06": 10.938723888888891,
                "2026-04-07": 77.585345,
                "2026-04-10": 3.7986102777777777,
                "2026-04-11": 2.734891666666667,
                "2026-04-13": 81.63351777777777,
                "2026-04-14": 44.03303944444444,
                "2026-04-15": 5.254715,
                "2026-04-16": 23.480238611111115,
                "2026-04-17": 11.079834722222222,
                "2026-04-20": 8.406132777777778,
                "2026-04-21": 50.590755833333326,
                "2026-04-22": 1777.7686169444444,
                "2026-04-23": 1244.742353333333,
                "2026-04-24": 37.55845138888889,
                "2026-04-27": 4.718319444444445,
                "2026-04-28": 935.5843691666666,
                "2026-04-30": 66.7884738888889,
                "2026-05-02": 64.25406,
                "2026-05-04": 175.66457111111112,
                "2026-05-06": 59.003254166666665,
                "2026-05-11": 131.41725416666665,
                "2026-05-13": 106.14941666666667,
                "2026-05-14": 35.07843666666666,
                "2026-05-15": 248.2289325,
                "2026-05-16": 29.643955833333333,
                "2026-05-20": 25.01508527777778,
                "2026-05-21": 10.418093611111109,
                "2026-05-25": 1.6941355555555555,
                "2026-05-26": 2216.804472222222,
                "2026-05-27": 25.24042777777778,
                "2026-05-28": 541.7373849999999,
                "2026-05-30": 3.017958611111111,
                "2026-06-01": 115.88325999999999,
                "2026-06-02": 221.66922138888884,
                "2026-06-03": 1244.6921311111114,
                "2026-06-05": 7.435764444444444,
                "2026-06-08": 74.73644083333335
              },
              "time_count_per_day": {
                "2025-09-30": 2,
                "2025-10-06": 1,
                "2025-10-13": 1,
                "2025-10-14": 2,
                "2025-10-15": 3,
                "2025-10-16": 2,
                "2025-10-24": 1,
                "2025-11-03": 1,
                "2025-11-07": 1,
                "2025-11-08": 1,
                "2025-11-09": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-26": 2,
                "2025-12-10": 1,
                "2025-12-22": 1,
                "2025-12-30": 1,
                "2026-01-07": 1,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 9,
                "2026-01-16": 15,
                "2026-01-20": 7,
                "2026-01-23": 3,
                "2026-01-27": 8,
                "2026-01-30": 9,
                "2026-02-04": 8,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 2,
                "2026-02-16": 2,
                "2026-02-17": 7,
                "2026-02-18": 11,
                "2026-02-19": 2,
                "2026-02-20": 1,
                "2026-02-23": 4,
                "2026-02-24": 13,
                "2026-02-25": 7,
                "2026-02-26": 3,
                "2026-02-27": 8,
                "2026-02-28": 13,
                "2026-03-02": 1,
                "2026-03-04": 13,
                "2026-03-05": 5,
                "2026-03-06": 7,
                "2026-03-07": 13,
                "2026-03-09": 7,
                "2026-03-10": 7,
                "2026-03-13": 2,
                "2026-03-16": 3,
                "2026-03-17": 5,
                "2026-03-18": 8,
                "2026-03-19": 15,
                "2026-03-20": 13,
                "2026-03-23": 2,
                "2026-03-24": 8,
                "2026-03-25": 7,
                "2026-03-26": 5,
                "2026-03-27": 9,
                "2026-03-30": 1,
                "2026-03-31": 6,
                "2026-04-01": 6,
                "2026-04-02": 2,
                "2026-04-04": 5,
                "2026-04-06": 2,
                "2026-04-07": 4,
                "2026-04-10": 2,
                "2026-04-11": 16,
                "2026-04-13": 10,
                "2026-04-14": 6,
                "2026-04-15": 4,
                "2026-04-16": 4,
                "2026-04-17": 8,
                "2026-04-20": 12,
                "2026-04-21": 6,
                "2026-04-22": 3,
                "2026-04-23": 5,
                "2026-04-24": 3,
                "2026-04-27": 6,
                "2026-04-28": 1,
                "2026-04-30": 7,
                "2026-05-02": 1,
                "2026-05-04": 3,
                "2026-05-06": 10,
                "2026-05-11": 5,
                "2026-05-13": 16,
                "2026-05-14": 9,
                "2026-05-15": 12,
                "2026-05-16": 1,
                "2026-05-20": 2,
                "2026-05-21": 5,
                "2026-05-25": 1,
                "2026-05-26": 7,
                "2026-05-27": 12,
                "2026-05-28": 8,
                "2026-05-30": 2,
                "2026-06-01": 1,
                "2026-06-02": 4,
                "2026-06-03": 16,
                "2026-06-05": 13,
                "2026-06-08": 3
              }
            },
            "P3": {
              "avg_time_hours": 97.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 21,
              "time_distribution": {
                "0-2h": 21,
                "2-4h": 6,
                "4-6h": 5,
                "6-8h": 1,
                "10-12h": 1,
                "24-26h": 1,
                "40-42h": 1,
                "54-56h": 1,
                "96-98h": 3,
                "118-120h": 1,
                "136-138h": 1,
                "138-140h": 1,
                "140-142h": 1,
                "150-152h": 1,
                "158-160h": 1,
                "166-168h": 1,
                "170-172h": 1,
                "236-238h": 1,
                "242-244h": 1,
                "270-272h": 1,
                "316-318h": 1,
                "390-392h": 1,
                "446-448h": 1,
                "460-462h": 1,
                "724-726h": 1,
                "794-796h": 1
              },
              "tickets_count": 57,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-27": 1,
                "2025-11-03": 8,
                "2025-11-04": 1,
                "2025-11-07": 2,
                "2025-11-13": 1,
                "2025-11-18": 2,
                "2025-11-19": 3,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-22": 2,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-09": 3,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-19": 2,
                "2026-03-04": 6
              },
              "time_per_day": {
                "2025-09-30": 0.0818711111111111,
                "2025-10-13": 4.767495,
                "2025-10-15": 1.2250783333333333,
                "2025-10-17": 5.775149166666667,
                "2025-10-27": 158.2608275,
                "2025-11-03": 9.398202222222222,
                "2025-11-04": 1.1331905555555555,
                "2025-11-07": 414.9617294444445,
                "2025-11-13": 136.16593916666667,
                "2025-11-18": 356.8504222222222,
                "2025-11-19": 448.24334027777775,
                "2025-11-27": 725.5615683333334,
                "2025-11-28": 40.8020525,
                "2025-12-04": 7.289094722222222,
                "2025-12-11": 0.9519147222222222,
                "2025-12-16": 270.8696444444444,
                "2025-12-22": 4.688841666666667,
                "2026-01-13": 2.668491111111111,
                "2026-01-14": 10.041359444444446,
                "2026-01-21": 795.1561586111111,
                "2026-01-23": 4.809378611111111,
                "2026-01-26": 10.922991944444444,
                "2026-02-03": 472.4015486111111,
                "2026-02-04": 54.530699722222224,
                "2026-02-06": 1.3398308333333333,
                "2026-02-09": 291.0624911111111,
                "2026-02-10": 4.221814722222222,
                "2026-02-11": 0.6867611111111112,
                "2026-02-13": 390.87425361111116,
                "2026-02-17": 316.5820391666667,
                "2026-02-19": 612.5520530555556,
                "2026-03-04": 8.855671388888888
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-27": 1,
                "2025-11-03": 8,
                "2025-11-04": 1,
                "2025-11-07": 2,
                "2025-11-13": 1,
                "2025-11-18": 2,
                "2025-11-19": 3,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-22": 2,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-09": 3,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-19": 2,
                "2026-03-04": 6
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 114.58,
              "mode_time_hours": 23.0,
              "mode_frequency": 4,
              "time_distribution": {
                "22-24h": 4,
                "26-28h": 2,
                "36-38h": 1,
                "40-42h": 1,
                "44-46h": 1,
                "90-92h": 1,
                "96-98h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "108-110h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "150-152h": 1,
                "162-164h": 2,
                "164-166h": 1,
                "348-350h": 1,
                "524-526h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-10-17": 4,
                "2025-10-23": 3,
                "2025-11-12": 1,
                "2025-11-19": 2,
                "2025-12-10": 1,
                "2026-02-11": 1,
                "2026-02-16": 1,
                "2026-02-17": 2,
                "2026-02-28": 1,
                "2026-03-18": 2,
                "2026-03-20": 2,
                "2026-03-25": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-10-17": 92.85938583333333,
                "2025-10-23": 491.46426444444444,
                "2025-11-12": 27.930958055555553,
                "2025-11-19": 238.69122,
                "2025-12-10": 26.685871944444443,
                "2026-02-11": 151.41294611111113,
                "2026-02-16": 91.5712575,
                "2026-02-17": 207.29196833333333,
                "2026-02-28": 97.26126000000001,
                "2026-03-18": 873.5124663888889,
                "2026-03-20": 85.28869583333335,
                "2026-03-25": 36.68317527777778,
                "2026-05-25": 100.02589055555556
              },
              "time_count_per_day": {
                "2025-10-17": 4,
                "2025-10-23": 3,
                "2025-11-12": 1,
                "2025-11-19": 2,
                "2025-12-10": 1,
                "2026-02-11": 1,
                "2026-02-16": 1,
                "2026-02-17": 2,
                "2026-02-28": 1,
                "2026-03-18": 2,
                "2026-03-20": 2,
                "2026-03-25": 1,
                "2026-05-25": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 353.04,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1,
                "160-162h": 1,
                "852-854h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-12-11": 45.63237055555556,
                "2025-12-16": 160.25907416666666,
                "2026-02-03": 853.2348594444444
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2026-02-03": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-03-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-01": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_57": {
      "overall": {
        "avg_time_hours": 211.59,
        "mode_time_hours": 1.0,
        "mode_frequency": 81,
        "time_distribution": {
          "0-2h": 81,
          "2-4h": 36,
          "4-6h": 18,
          "6-8h": 8,
          "8-10h": 6,
          "12-14h": 2,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 5,
          "20-22h": 2,
          "22-24h": 3,
          "24-26h": 8,
          "26-28h": 3,
          "28-30h": 3,
          "30-32h": 1,
          "32-34h": 1,
          "34-36h": 1,
          "38-40h": 2,
          "40-42h": 1,
          "42-44h": 2,
          "44-46h": 2,
          "46-48h": 2,
          "48-50h": 2,
          "50-52h": 1,
          "54-56h": 2,
          "64-66h": 1,
          "66-68h": 2,
          "68-70h": 3,
          "70-72h": 2,
          "72-74h": 3,
          "78-80h": 1,
          "92-94h": 2,
          "98-100h": 1,
          "106-108h": 1,
          "114-116h": 3,
          "120-122h": 1,
          "140-142h": 2,
          "144-146h": 2,
          "146-148h": 1,
          "162-164h": 3,
          "172-174h": 1,
          "174-176h": 1,
          "178-180h": 1,
          "182-184h": 1,
          "190-192h": 1,
          "192-194h": 1,
          "214-216h": 1,
          "218-220h": 1,
          "220-222h": 1,
          "226-228h": 2,
          "238-240h": 1,
          "244-246h": 1,
          "246-248h": 1,
          "262-264h": 1,
          "270-272h": 1,
          "306-308h": 1,
          "316-318h": 1,
          "366-368h": 2,
          "382-384h": 1,
          "384-386h": 1,
          "386-388h": 1,
          "388-390h": 1,
          "404-406h": 1,
          "416-418h": 1,
          "438-440h": 1,
          "478-480h": 1,
          "500-502h": 1,
          "506-508h": 1,
          "520-522h": 1,
          "534-536h": 1,
          "570-572h": 1,
          "602-604h": 1,
          "614-616h": 1,
          "650-652h": 1,
          "652-654h": 1,
          "654-656h": 1,
          "744-746h": 1,
          "746-748h": 1,
          "790-792h": 1,
          "794-796h": 1,
          "840-842h": 1,
          "864-866h": 1,
          "882-884h": 1,
          "892-894h": 1,
          "910-912h": 1,
          "922-924h": 1,
          "924-926h": 1,
          "1056-1058h": 1,
          "1086-1088h": 1,
          "1142-1144h": 1,
          "1198-1200h": 1,
          "1282-1284h": 1,
          "1320-1322h": 1,
          "1338-1340h": 1,
          "1514-1516h": 1,
          "1532-1534h": 1,
          "1570-1572h": 1,
          "1658-1660h": 1,
          "1670-1672h": 1,
          "1728-1730h": 1,
          "1752-1754h": 1,
          "2008-2010h": 1,
          "2250-2252h": 1,
          "2280-2282h": 1,
          "2350-2352h": 1,
          "2392-2394h": 1,
          "2560-2562h": 1
        },
        "tickets_count": 330,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-10-02": 1,
          "2025-10-06": 1,
          "2025-10-07": 4,
          "2025-10-09": 1,
          "2025-10-13": 2,
          "2025-10-14": 1,
          "2025-10-15": 4,
          "2025-10-16": 1,
          "2025-10-21": 5,
          "2025-10-22": 2,
          "2025-10-23": 3,
          "2025-10-27": 2,
          "2025-10-30": 2,
          "2025-10-31": 3,
          "2025-11-03": 3,
          "2025-11-04": 2,
          "2025-11-05": 2,
          "2025-11-06": 2,
          "2025-11-07": 3,
          "2025-11-10": 4,
          "2025-11-11": 3,
          "2025-11-12": 2,
          "2025-11-13": 4,
          "2025-11-14": 1,
          "2025-11-17": 5,
          "2025-11-21": 2,
          "2025-11-24": 2,
          "2025-11-25": 2,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-02": 5,
          "2025-12-04": 2,
          "2025-12-09": 2,
          "2025-12-10": 2,
          "2025-12-11": 3,
          "2025-12-12": 3,
          "2025-12-15": 6,
          "2025-12-17": 2,
          "2025-12-18": 1,
          "2025-12-19": 6,
          "2025-12-22": 1,
          "2025-12-26": 2,
          "2025-12-28": 2,
          "2025-12-29": 2,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-07": 3,
          "2026-01-08": 2,
          "2026-01-09": 1,
          "2026-01-10": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-14": 5,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 3,
          "2026-01-22": 1,
          "2026-01-23": 3,
          "2026-01-26": 2,
          "2026-01-27": 2,
          "2026-01-28": 1,
          "2026-01-29": 3,
          "2026-02-02": 1,
          "2026-02-03": 4,
          "2026-02-06": 3,
          "2026-02-10": 7,
          "2026-02-11": 2,
          "2026-02-12": 4,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-16": 7,
          "2026-02-17": 1,
          "2026-02-18": 6,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-25": 3,
          "2026-03-02": 2,
          "2026-03-03": 3,
          "2026-03-05": 6,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-09": 3,
          "2026-03-11": 2,
          "2026-03-20": 6,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-01": 2,
          "2026-04-02": 2,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 4,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-16": 6,
          "2026-04-17": 3,
          "2026-04-18": 1,
          "2026-04-22": 2,
          "2026-04-23": 6,
          "2026-04-24": 3,
          "2026-04-27": 1,
          "2026-04-30": 5,
          "2026-05-02": 4,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-06": 4,
          "2026-05-07": 8,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 4,
          "2026-05-12": 3,
          "2026-05-13": 5,
          "2026-05-14": 4,
          "2026-05-15": 3,
          "2026-05-16": 1,
          "2026-05-18": 6,
          "2026-05-19": 1,
          "2026-05-20": 2,
          "2026-05-21": 2,
          "2026-05-23": 1,
          "2026-05-25": 1,
          "2026-05-27": 5,
          "2026-05-29": 3,
          "2026-06-01": 1,
          "2026-06-02": 3,
          "2026-06-03": 3
        },
        "time_per_day": {
          "2025-10-01": 0.11571805555555555,
          "2025-10-02": 44.5451,
          "2025-10-06": 70.83189805555556,
          "2025-10-07": 402.41420416666665,
          "2025-10-09": 45.84464805555556,
          "2025-10-13": 71.56748944444445,
          "2025-10-14": 0.34103583333333337,
          "2025-10-15": 120.28503027777779,
          "2025-10-16": 23.000105555555557,
          "2025-10-21": 75.3463236111111,
          "2025-10-22": 0.8643288888888889,
          "2025-10-23": 104.8948625,
          "2025-10-27": 73.62724777777778,
          "2025-10-30": 145.21634666666668,
          "2025-10-31": 148.67816666666667,
          "2025-11-03": 868.45512,
          "2025-11-04": 11.06639638888889,
          "2025-11-05": 28.940222777777777,
          "2025-11-06": 94.00019722222221,
          "2025-11-07": 206.26370416666668,
          "2025-11-10": 479.47420472222217,
          "2025-11-11": 31.330934722222224,
          "2025-11-12": 3.970601111111111,
          "2025-11-13": 91.12542277777779,
          "2025-11-14": 0.40476305555555553,
          "2025-11-17": 0.8120263888888888,
          "2025-11-21": 0.7284091666666667,
          "2025-11-24": 1.45416,
          "2025-11-25": 5.866547222222223,
          "2025-11-26": 174.77648166666668,
          "2025-11-27": 840.1644216666667,
          "2025-11-28": 1.0159425,
          "2025-12-02": 30.261243055555553,
          "2025-12-04": 310.5535188888889,
          "2025-12-09": 146.41939972222224,
          "2025-12-10": 2.1433472222222223,
          "2025-12-11": 893.5236558333334,
          "2025-12-12": 4.490802777777778,
          "2025-12-15": 1566.6611075,
          "2025-12-17": 190.8909547222222,
          "2025-12-18": 0.6828458333333333,
          "2025-12-19": 1759.4374180555556,
          "2025-12-22": 4.7264936111111115,
          "2025-12-26": 178.90927222222223,
          "2025-12-28": 4.5615425,
          "2025-12-29": 2.498867222222222,
          "2026-01-05": 570.7576738888889,
          "2026-01-06": 25.54874111111111,
          "2026-01-07": 393.09614,
          "2026-01-08": 14.76477638888889,
          "2026-01-09": 262.2818877777778,
          "2026-01-10": 20.37309611111111,
          "2026-01-12": 1.8264941666666665,
          "2026-01-13": 120.59017361111111,
          "2026-01-14": 273.5433744444444,
          "2026-01-15": 3.841716111111111,
          "2026-01-16": 1729.4702991666666,
          "2026-01-17": 43.91567916666667,
          "2026-01-19": 4.248590277777778,
          "2026-01-20": 6.784655555555556,
          "2026-01-22": 27.786169166666667,
          "2026-01-23": 999.0861152777778,
          "2026-01-26": 143.51527833333333,
          "2026-01-27": 6.479324166666667,
          "2026-01-28": 2.619482777777778,
          "2026-01-29": 726.3629633333333,
          "2026-02-02": 64.25478888888888,
          "2026-02-03": 852.7928630555556,
          "2026-02-06": 34.1779,
          "2026-02-10": 616.7122761111114,
          "2026-02-11": 5.5450163888888895,
          "2026-02-12": 1038.9565888888892,
          "2026-02-13": 226.29466055555557,
          "2026-02-14": 18.233544444444444,
          "2026-02-16": 75.32140750000002,
          "2026-02-17": 28.794724444444444,
          "2026-02-18": 7451.035639166666,
          "2026-02-19": 21.93923277777778,
          "2026-02-20": 1.756875,
          "2026-02-25": 123.20912194444446,
          "2026-03-02": 2.6513958333333334,
          "2026-03-03": 17.718085833333333,
          "2026-03-05": 141.7230313888889,
          "2026-03-06": 883.6413005555555,
          "2026-03-07": 0.7976375,
          "2026-03-09": 2376.6721013888887,
          "2026-03-11": 1058.1489969444444,
          "2026-03-20": 4050.9741786111113,
          "2026-03-23": 8.5267125,
          "2026-03-27": 1753.8385850000002,
          "2026-03-31": 27.415861944444444,
          "2026-04-01": 4.0437416666666675,
          "2026-04-02": 1266.9781263888888,
          "2026-04-06": 479.37460694444445,
          "2026-04-07": 794.6149263888889,
          "2026-04-08": 1.0121405555555556,
          "2026-04-09": 0.10152666666666667,
          "2026-04-10": 5434.363653055556,
          "2026-04-14": 3.395893888888889,
          "2026-04-16": 3121.511768888889,
          "2026-04-17": 11.878485277777777,
          "2026-04-18": 1.2609613888888889,
          "2026-04-22": 3714.0220874999995,
          "2026-04-23": 4332.806551944445,
          "2026-04-24": 0.04357833333333334,
          "2026-04-27": 405.8394527777778,
          "2026-04-30": 91.40771111111111,
          "2026-05-02": 1.479202222222222,
          "2026-05-04": 507.3518438888889,
          "2026-05-05": 0.9428222222222222,
          "2026-05-06": 8.418647222222223,
          "2026-05-07": 2260.6443850000005,
          "2026-05-08": 57.00662527777778,
          "2026-05-09": 17.119254722222223,
          "2026-05-11": 10.643018333333334,
          "2026-05-12": 15.295642222222222,
          "2026-05-13": 16.758458055555554,
          "2026-05-14": 250.66884166666668,
          "2026-05-18": 15.549960277777778,
          "2026-05-20": 18.316105,
          "2026-05-21": 2.951569166666667,
          "2026-05-23": 23.92593833333333,
          "2026-05-25": 0.11237222222222223,
          "2026-05-27": 2839.8183988888886,
          "2026-05-29": 28.467966944444445,
          "2026-06-01": 0.05463861111111112,
          "2026-06-02": 92.42940138888889,
          "2026-06-03": 221.9904738888889
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-10-02": 1,
          "2025-10-06": 1,
          "2025-10-07": 4,
          "2025-10-09": 1,
          "2025-10-13": 2,
          "2025-10-14": 1,
          "2025-10-15": 4,
          "2025-10-16": 1,
          "2025-10-21": 5,
          "2025-10-22": 2,
          "2025-10-23": 3,
          "2025-10-27": 2,
          "2025-10-30": 2,
          "2025-10-31": 3,
          "2025-11-03": 3,
          "2025-11-04": 2,
          "2025-11-05": 2,
          "2025-11-06": 2,
          "2025-11-07": 3,
          "2025-11-10": 4,
          "2025-11-11": 3,
          "2025-11-12": 2,
          "2025-11-13": 4,
          "2025-11-14": 1,
          "2025-11-17": 5,
          "2025-11-21": 1,
          "2025-11-24": 2,
          "2025-11-25": 2,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-02": 5,
          "2025-12-04": 2,
          "2025-12-09": 2,
          "2025-12-10": 2,
          "2025-12-11": 3,
          "2025-12-12": 2,
          "2025-12-15": 6,
          "2025-12-17": 2,
          "2025-12-18": 1,
          "2025-12-19": 6,
          "2025-12-22": 1,
          "2025-12-26": 2,
          "2025-12-28": 2,
          "2025-12-29": 2,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-07": 3,
          "2026-01-08": 2,
          "2026-01-09": 1,
          "2026-01-10": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-14": 5,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 3,
          "2026-01-22": 1,
          "2026-01-23": 3,
          "2026-01-26": 2,
          "2026-01-27": 2,
          "2026-01-28": 1,
          "2026-01-29": 2,
          "2026-02-02": 1,
          "2026-02-03": 4,
          "2026-02-06": 3,
          "2026-02-10": 7,
          "2026-02-11": 2,
          "2026-02-12": 4,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-16": 7,
          "2026-02-17": 1,
          "2026-02-18": 6,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-25": 2,
          "2026-03-02": 2,
          "2026-03-03": 3,
          "2026-03-05": 5,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-09": 3,
          "2026-03-11": 2,
          "2026-03-20": 5,
          "2026-03-23": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-01": 2,
          "2026-04-02": 2,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 4,
          "2026-04-14": 1,
          "2026-04-16": 6,
          "2026-04-17": 2,
          "2026-04-18": 1,
          "2026-04-22": 2,
          "2026-04-23": 5,
          "2026-04-24": 1,
          "2026-04-27": 1,
          "2026-04-30": 4,
          "2026-05-02": 4,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-07": 6,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 4,
          "2026-05-14": 3,
          "2026-05-18": 4,
          "2026-05-20": 1,
          "2026-05-21": 2,
          "2026-05-23": 1,
          "2026-05-25": 1,
          "2026-05-27": 3,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 2,
          "2026-06-03": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 142.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "14-16h": 1,
            "92-94h": 1,
            "744-746h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-15": 1,
            "2025-11-03": 1,
            "2026-04-23": 1,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-01": 0.11571805555555555,
            "2025-10-15": 1.828102222222222,
            "2025-11-03": 0.10010416666666666,
            "2026-04-23": 745.3244961111112,
            "2026-05-12": 15.295642222222222,
            "2026-06-02": 92.39122305555556
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-15": 1,
            "2025-11-03": 1,
            "2026-04-23": 1,
            "2026-05-12": 1,
            "2026-06-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 164.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 70,
          "time_distribution": {
            "0-2h": 70,
            "2-4h": 33,
            "4-6h": 16,
            "6-8h": 4,
            "8-10h": 5,
            "12-14h": 2,
            "16-18h": 1,
            "18-20h": 4,
            "20-22h": 2,
            "22-24h": 3,
            "24-26h": 7,
            "26-28h": 3,
            "28-30h": 3,
            "30-32h": 1,
            "34-36h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "46-48h": 2,
            "48-50h": 2,
            "50-52h": 1,
            "54-56h": 2,
            "64-66h": 1,
            "66-68h": 2,
            "68-70h": 3,
            "70-72h": 2,
            "72-74h": 3,
            "78-80h": 1,
            "92-94h": 1,
            "98-100h": 1,
            "106-108h": 1,
            "114-116h": 3,
            "120-122h": 1,
            "140-142h": 1,
            "144-146h": 2,
            "146-148h": 1,
            "162-164h": 3,
            "172-174h": 1,
            "190-192h": 1,
            "192-194h": 1,
            "214-216h": 1,
            "220-222h": 1,
            "226-228h": 1,
            "238-240h": 1,
            "246-248h": 1,
            "262-264h": 1,
            "316-318h": 1,
            "366-368h": 2,
            "382-384h": 1,
            "384-386h": 1,
            "388-390h": 1,
            "404-406h": 1,
            "416-418h": 1,
            "438-440h": 1,
            "478-480h": 1,
            "506-508h": 1,
            "520-522h": 1,
            "534-536h": 1,
            "602-604h": 1,
            "614-616h": 1,
            "650-652h": 1,
            "652-654h": 1,
            "654-656h": 1,
            "746-748h": 1,
            "794-796h": 1,
            "864-866h": 1,
            "892-894h": 1,
            "922-924h": 1,
            "924-926h": 1,
            "1056-1058h": 1,
            "1086-1088h": 1,
            "1142-1144h": 1,
            "1198-1200h": 1,
            "1320-1322h": 1,
            "1338-1340h": 1,
            "1514-1516h": 1,
            "1532-1534h": 1,
            "1670-1672h": 1,
            "2250-2252h": 1,
            "2280-2282h": 1,
            "2560-2562h": 1
          },
          "tickets_count": 270,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-07": 3,
            "2025-10-09": 1,
            "2025-10-13": 2,
            "2025-10-14": 1,
            "2025-10-15": 2,
            "2025-10-16": 1,
            "2025-10-21": 5,
            "2025-10-22": 2,
            "2025-10-23": 3,
            "2025-10-27": 2,
            "2025-10-30": 1,
            "2025-10-31": 3,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-05": 2,
            "2025-11-06": 2,
            "2025-11-07": 3,
            "2025-11-10": 3,
            "2025-11-11": 3,
            "2025-11-12": 2,
            "2025-11-13": 3,
            "2025-11-17": 5,
            "2025-11-24": 2,
            "2025-11-25": 2,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-09": 2,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-12": 2,
            "2025-12-15": 3,
            "2025-12-17": 2,
            "2025-12-19": 4,
            "2025-12-26": 2,
            "2025-12-28": 2,
            "2025-12-29": 2,
            "2026-01-07": 2,
            "2026-01-09": 1,
            "2026-01-10": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-20": 3,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 2,
            "2026-01-27": 2,
            "2026-01-28": 1,
            "2026-01-29": 3,
            "2026-02-02": 1,
            "2026-02-03": 3,
            "2026-02-06": 1,
            "2026-02-10": 7,
            "2026-02-11": 2,
            "2026-02-12": 4,
            "2026-02-14": 1,
            "2026-02-16": 7,
            "2026-02-17": 1,
            "2026-02-18": 4,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-25": 3,
            "2026-03-02": 2,
            "2026-03-03": 3,
            "2026-03-05": 5,
            "2026-03-07": 1,
            "2026-03-09": 2,
            "2026-03-11": 2,
            "2026-03-20": 6,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-26": 1,
            "2026-03-31": 1,
            "2026-04-01": 2,
            "2026-04-02": 2,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-16": 6,
            "2026-04-17": 3,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 5,
            "2026-04-24": 3,
            "2026-04-27": 1,
            "2026-04-30": 5,
            "2026-05-02": 4,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-07": 8,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 5,
            "2026-05-14": 4,
            "2026-05-15": 3,
            "2026-05-16": 1,
            "2026-05-18": 6,
            "2026-05-19": 1,
            "2026-05-20": 2,
            "2026-05-21": 2,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-27": 5,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-02": 2,
            "2026-06-03": 2
          },
          "time_per_day": {
            "2025-10-06": 70.83189805555556,
            "2025-10-07": 262.16691222222227,
            "2025-10-09": 45.84464805555556,
            "2025-10-13": 71.56748944444445,
            "2025-10-14": 0.34103583333333337,
            "2025-10-15": 116.6454063888889,
            "2025-10-16": 23.000105555555557,
            "2025-10-21": 75.3463236111111,
            "2025-10-22": 0.8643288888888889,
            "2025-10-23": 104.8948625,
            "2025-10-27": 73.62724777777778,
            "2025-10-30": 144.65653555555556,
            "2025-10-31": 148.67816666666667,
            "2025-11-03": 78.30582027777777,
            "2025-11-04": 4.809675833333333,
            "2025-11-05": 28.940222777777777,
            "2025-11-06": 94.00019722222221,
            "2025-11-07": 206.26370416666668,
            "2025-11-10": 209.3747977777778,
            "2025-11-11": 31.330934722222224,
            "2025-11-12": 3.970601111111111,
            "2025-11-13": 72.614135,
            "2025-11-17": 0.8120263888888888,
            "2025-11-24": 1.45416,
            "2025-11-25": 5.866547222222223,
            "2025-11-28": 1.0159425,
            "2025-12-02": 9.055391111111112,
            "2025-12-09": 146.41939972222224,
            "2025-12-10": 0.06000305555555555,
            "2025-12-11": 893.5236558333334,
            "2025-12-12": 4.017132777777777,
            "2025-12-15": 408.6185394444445,
            "2025-12-17": 190.8909547222222,
            "2025-12-19": 1193.4810083333332,
            "2025-12-26": 178.90927222222223,
            "2025-12-28": 4.5615425,
            "2025-12-29": 2.498867222222222,
            "2026-01-07": 174.75432916666668,
            "2026-01-09": 262.2818877777778,
            "2026-01-10": 20.37309611111111,
            "2026-01-12": 1.8264941666666665,
            "2026-01-13": 120.59017361111111,
            "2026-01-14": 7.9870430555555565,
            "2026-01-15": 3.841716111111111,
            "2026-01-17": 43.91567916666667,
            "2026-01-19": 4.248590277777778,
            "2026-01-20": 6.784655555555556,
            "2026-01-22": 27.786169166666667,
            "2026-01-23": 999.0861152777778,
            "2026-01-26": 143.51527833333333,
            "2026-01-27": 6.479324166666667,
            "2026-01-28": 2.619482777777778,
            "2026-01-29": 726.3629633333333,
            "2026-02-02": 64.25478888888888,
            "2026-02-03": 352.41113583333333,
            "2026-02-06": 0.12150611111111112,
            "2026-02-10": 616.7122761111114,
            "2026-02-11": 5.5450163888888895,
            "2026-02-12": 1038.9565888888892,
            "2026-02-14": 18.233544444444444,
            "2026-02-16": 75.32140750000002,
            "2026-02-17": 28.794724444444444,
            "2026-02-18": 3090.743473611111,
            "2026-02-19": 21.93923277777778,
            "2026-02-20": 1.756875,
            "2026-02-25": 123.20912194444446,
            "2026-03-02": 2.6513958333333334,
            "2026-03-03": 17.718085833333333,
            "2026-03-05": 141.7230313888889,
            "2026-03-07": 0.7976375,
            "2026-03-09": 1094.0913308333331,
            "2026-03-11": 1058.1489969444444,
            "2026-03-20": 4050.9741786111113,
            "2026-03-23": 8.5267125,
            "2026-03-31": 27.415861944444444,
            "2026-04-01": 4.0437416666666675,
            "2026-04-02": 1266.9781263888888,
            "2026-04-06": 479.37460694444445,
            "2026-04-07": 794.6149263888889,
            "2026-04-08": 1.0121405555555556,
            "2026-04-09": 0.10152666666666667,
            "2026-04-10": 2205.253993611111,
            "2026-04-14": 3.395893888888889,
            "2026-04-16": 3121.511768888889,
            "2026-04-17": 11.878485277777777,
            "2026-04-18": 1.2609613888888889,
            "2026-04-22": 1321.5190483333333,
            "2026-04-23": 3587.482055833334,
            "2026-04-24": 0.04357833333333334,
            "2026-04-27": 405.8394527777778,
            "2026-04-30": 91.40771111111111,
            "2026-05-02": 1.479202222222222,
            "2026-05-04": 507.3518438888889,
            "2026-05-05": 0.9428222222222222,
            "2026-05-06": 8.418647222222223,
            "2026-05-07": 2260.6443850000005,
            "2026-05-08": 57.00662527777778,
            "2026-05-09": 17.119254722222223,
            "2026-05-11": 10.643018333333334,
            "2026-05-13": 16.758458055555554,
            "2026-05-14": 250.66884166666668,
            "2026-05-18": 15.549960277777778,
            "2026-05-20": 18.316105,
            "2026-05-21": 2.951569166666667,
            "2026-05-23": 23.92593833333333,
            "2026-05-25": 0.11237222222222223,
            "2026-05-27": 2839.8183988888886,
            "2026-05-29": 28.467966944444445,
            "2026-06-01": 0.05463861111111112,
            "2026-06-02": 0.038178333333333335,
            "2026-06-03": 221.9904738888889
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-07": 3,
            "2025-10-09": 1,
            "2025-10-13": 2,
            "2025-10-14": 1,
            "2025-10-15": 2,
            "2025-10-16": 1,
            "2025-10-21": 5,
            "2025-10-22": 2,
            "2025-10-23": 3,
            "2025-10-27": 2,
            "2025-10-30": 1,
            "2025-10-31": 3,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-05": 2,
            "2025-11-06": 2,
            "2025-11-07": 3,
            "2025-11-10": 3,
            "2025-11-11": 3,
            "2025-11-12": 2,
            "2025-11-13": 3,
            "2025-11-17": 5,
            "2025-11-24": 2,
            "2025-11-25": 2,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-09": 2,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-12": 1,
            "2025-12-15": 3,
            "2025-12-17": 2,
            "2025-12-19": 4,
            "2025-12-26": 2,
            "2025-12-28": 2,
            "2025-12-29": 2,
            "2026-01-07": 2,
            "2026-01-09": 1,
            "2026-01-10": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-20": 3,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 2,
            "2026-01-27": 2,
            "2026-01-28": 1,
            "2026-01-29": 2,
            "2026-02-02": 1,
            "2026-02-03": 3,
            "2026-02-06": 1,
            "2026-02-10": 7,
            "2026-02-11": 2,
            "2026-02-12": 4,
            "2026-02-14": 1,
            "2026-02-16": 7,
            "2026-02-17": 1,
            "2026-02-18": 4,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-25": 2,
            "2026-03-02": 2,
            "2026-03-03": 3,
            "2026-03-05": 5,
            "2026-03-07": 1,
            "2026-03-09": 2,
            "2026-03-11": 2,
            "2026-03-20": 5,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-01": 2,
            "2026-04-02": 2,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-14": 1,
            "2026-04-16": 6,
            "2026-04-17": 2,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 4,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-04-30": 4,
            "2026-05-02": 4,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 6,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-13": 4,
            "2026-05-14": 3,
            "2026-05-18": 4,
            "2026-05-20": 1,
            "2026-05-21": 2,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-27": 3,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-03": 2
          }
        },
        "P3": {
          "avg_time_hours": 464.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 4,
            "8-10h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "32-34h": 1,
            "38-40h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "140-142h": 1,
            "174-176h": 1,
            "178-180h": 1,
            "182-184h": 1,
            "218-220h": 1,
            "226-228h": 1,
            "244-246h": 1,
            "270-272h": 1,
            "306-308h": 1,
            "386-388h": 1,
            "500-502h": 1,
            "570-572h": 1,
            "790-792h": 1,
            "840-842h": 1,
            "882-884h": 1,
            "910-912h": 1,
            "1282-1284h": 1,
            "1570-1572h": 1,
            "1658-1660h": 1,
            "1728-1730h": 1,
            "1752-1754h": 1,
            "2008-2010h": 1,
            "2350-2352h": 1,
            "2392-2394h": 1
          },
          "tickets_count": 48,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-10": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-21": 2,
            "2025-11-26": 1,
            "2025-11-27": 1,
            "2025-12-02": 4,
            "2025-12-04": 2,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-15": 3,
            "2025-12-18": 1,
            "2025-12-19": 2,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-08": 2,
            "2026-01-14": 3,
            "2026-01-16": 1,
            "2026-02-03": 1,
            "2026-02-06": 2,
            "2026-02-13": 1,
            "2026-02-18": 2,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-27": 1,
            "2026-04-10": 2,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2025-10-02": 44.5451,
            "2025-10-07": 140.24729194444444,
            "2025-10-15": 1.8115216666666667,
            "2025-10-30": 0.5598111111111111,
            "2025-11-03": 790.0491955555555,
            "2025-11-04": 6.256720555555556,
            "2025-11-10": 270.09940694444447,
            "2025-11-13": 18.511287777777778,
            "2025-11-14": 0.40476305555555553,
            "2025-11-21": 0.7284091666666667,
            "2025-11-26": 174.77648166666668,
            "2025-11-27": 840.1644216666667,
            "2025-12-02": 21.205851944444444,
            "2025-12-04": 310.5535188888889,
            "2025-12-10": 2.0833441666666666,
            "2025-12-12": 0.47367,
            "2025-12-15": 1158.0425680555556,
            "2025-12-18": 0.6828458333333333,
            "2025-12-19": 565.9564097222221,
            "2026-01-05": 570.7576738888889,
            "2026-01-06": 25.54874111111111,
            "2026-01-07": 218.3418108333333,
            "2026-01-08": 14.76477638888889,
            "2026-01-14": 265.55633138888885,
            "2026-01-16": 1729.4702991666666,
            "2026-02-03": 500.38172722222225,
            "2026-02-06": 34.05639388888889,
            "2026-02-13": 226.29466055555557,
            "2026-02-18": 4360.292165555556,
            "2026-03-06": 883.6413005555555,
            "2026-03-09": 1282.5807705555555,
            "2026-03-27": 1753.8385850000002,
            "2026-04-10": 3229.1096594444443,
            "2026-04-22": 2392.5030391666664
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2025-11-10": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-21": 1,
            "2025-11-26": 1,
            "2025-11-27": 1,
            "2025-12-02": 4,
            "2025-12-04": 2,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-15": 3,
            "2025-12-18": 1,
            "2025-12-19": 2,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-08": 2,
            "2026-01-14": 3,
            "2026-01-16": 1,
            "2026-02-03": 1,
            "2026-02-06": 2,
            "2026-02-13": 1,
            "2026-02-18": 2,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-27": 1,
            "2026-04-10": 2,
            "2026-04-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 4.73,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-22": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2025-12-22": 4.7264936111111115
          },
          "time_count_per_day": {
            "2025-12-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 211.59,
            "mode_time_hours": 1.0,
            "mode_frequency": 81,
            "time_distribution": {
              "0-2h": 81,
              "2-4h": 36,
              "4-6h": 18,
              "6-8h": 8,
              "8-10h": 6,
              "12-14h": 2,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 5,
              "20-22h": 2,
              "22-24h": 3,
              "24-26h": 8,
              "26-28h": 3,
              "28-30h": 3,
              "30-32h": 1,
              "32-34h": 1,
              "34-36h": 1,
              "38-40h": 2,
              "40-42h": 1,
              "42-44h": 2,
              "44-46h": 2,
              "46-48h": 2,
              "48-50h": 2,
              "50-52h": 1,
              "54-56h": 2,
              "64-66h": 1,
              "66-68h": 2,
              "68-70h": 3,
              "70-72h": 2,
              "72-74h": 3,
              "78-80h": 1,
              "92-94h": 2,
              "98-100h": 1,
              "106-108h": 1,
              "114-116h": 3,
              "120-122h": 1,
              "140-142h": 2,
              "144-146h": 2,
              "146-148h": 1,
              "162-164h": 3,
              "172-174h": 1,
              "174-176h": 1,
              "178-180h": 1,
              "182-184h": 1,
              "190-192h": 1,
              "192-194h": 1,
              "214-216h": 1,
              "218-220h": 1,
              "220-222h": 1,
              "226-228h": 2,
              "238-240h": 1,
              "244-246h": 1,
              "246-248h": 1,
              "262-264h": 1,
              "270-272h": 1,
              "306-308h": 1,
              "316-318h": 1,
              "366-368h": 2,
              "382-384h": 1,
              "384-386h": 1,
              "386-388h": 1,
              "388-390h": 1,
              "404-406h": 1,
              "416-418h": 1,
              "438-440h": 1,
              "478-480h": 1,
              "500-502h": 1,
              "506-508h": 1,
              "520-522h": 1,
              "534-536h": 1,
              "570-572h": 1,
              "602-604h": 1,
              "614-616h": 1,
              "650-652h": 1,
              "652-654h": 1,
              "654-656h": 1,
              "744-746h": 1,
              "746-748h": 1,
              "790-792h": 1,
              "794-796h": 1,
              "840-842h": 1,
              "864-866h": 1,
              "882-884h": 1,
              "892-894h": 1,
              "910-912h": 1,
              "922-924h": 1,
              "924-926h": 1,
              "1056-1058h": 1,
              "1086-1088h": 1,
              "1142-1144h": 1,
              "1198-1200h": 1,
              "1282-1284h": 1,
              "1320-1322h": 1,
              "1338-1340h": 1,
              "1514-1516h": 1,
              "1532-1534h": 1,
              "1570-1572h": 1,
              "1658-1660h": 1,
              "1670-1672h": 1,
              "1728-1730h": 1,
              "1752-1754h": 1,
              "2008-2010h": 1,
              "2250-2252h": 1,
              "2280-2282h": 1,
              "2350-2352h": 1,
              "2392-2394h": 1,
              "2560-2562h": 1
            },
            "tickets_count": 291,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-10-02": 1,
              "2025-10-06": 1,
              "2025-10-07": 4,
              "2025-10-09": 1,
              "2025-10-13": 2,
              "2025-10-14": 1,
              "2025-10-15": 4,
              "2025-10-16": 1,
              "2025-10-21": 5,
              "2025-10-22": 2,
              "2025-10-23": 3,
              "2025-10-27": 2,
              "2025-10-30": 2,
              "2025-10-31": 3,
              "2025-11-03": 3,
              "2025-11-04": 2,
              "2025-11-05": 2,
              "2025-11-06": 2,
              "2025-11-07": 3,
              "2025-11-10": 4,
              "2025-11-11": 3,
              "2025-11-12": 2,
              "2025-11-13": 4,
              "2025-11-14": 1,
              "2025-11-17": 5,
              "2025-11-21": 1,
              "2025-11-24": 2,
              "2025-11-25": 2,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-02": 5,
              "2025-12-04": 2,
              "2025-12-09": 2,
              "2025-12-10": 2,
              "2025-12-11": 3,
              "2025-12-12": 2,
              "2025-12-15": 6,
              "2025-12-17": 2,
              "2025-12-18": 1,
              "2025-12-19": 6,
              "2025-12-22": 1,
              "2025-12-26": 2,
              "2025-12-28": 2,
              "2025-12-29": 2,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-07": 3,
              "2026-01-08": 2,
              "2026-01-09": 1,
              "2026-01-10": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-14": 5,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 3,
              "2026-01-22": 1,
              "2026-01-23": 3,
              "2026-01-26": 2,
              "2026-01-27": 2,
              "2026-01-28": 1,
              "2026-01-29": 2,
              "2026-02-02": 1,
              "2026-02-03": 4,
              "2026-02-06": 3,
              "2026-02-10": 7,
              "2026-02-11": 2,
              "2026-02-12": 4,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-16": 7,
              "2026-02-17": 1,
              "2026-02-18": 6,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-25": 2,
              "2026-03-02": 2,
              "2026-03-03": 3,
              "2026-03-05": 5,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-09": 3,
              "2026-03-11": 2,
              "2026-03-20": 5,
              "2026-03-23": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-01": 2,
              "2026-04-02": 2,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 4,
              "2026-04-14": 1,
              "2026-04-16": 6,
              "2026-04-17": 2,
              "2026-04-18": 1,
              "2026-04-22": 2,
              "2026-04-23": 5,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-04-30": 4,
              "2026-05-02": 4,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 6,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 4,
              "2026-05-14": 3,
              "2026-05-18": 4,
              "2026-05-20": 1,
              "2026-05-21": 2,
              "2026-05-23": 1,
              "2026-05-25": 1,
              "2026-05-27": 3,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 2,
              "2026-06-03": 2
            },
            "time_per_day": {
              "2025-10-01": 0.11571805555555555,
              "2025-10-02": 44.5451,
              "2025-10-06": 70.83189805555556,
              "2025-10-07": 402.41420416666665,
              "2025-10-09": 45.84464805555556,
              "2025-10-13": 71.56748944444445,
              "2025-10-14": 0.34103583333333337,
              "2025-10-15": 120.28503027777779,
              "2025-10-16": 23.000105555555557,
              "2025-10-21": 75.3463236111111,
              "2025-10-22": 0.8643288888888889,
              "2025-10-23": 104.8948625,
              "2025-10-27": 73.62724777777778,
              "2025-10-30": 145.21634666666668,
              "2025-10-31": 148.67816666666667,
              "2025-11-03": 868.45512,
              "2025-11-04": 11.06639638888889,
              "2025-11-05": 28.940222777777777,
              "2025-11-06": 94.00019722222221,
              "2025-11-07": 206.26370416666668,
              "2025-11-10": 479.47420472222217,
              "2025-11-11": 31.330934722222224,
              "2025-11-12": 3.970601111111111,
              "2025-11-13": 91.12542277777779,
              "2025-11-14": 0.40476305555555553,
              "2025-11-17": 0.8120263888888888,
              "2025-11-21": 0.7284091666666667,
              "2025-11-24": 1.45416,
              "2025-11-25": 5.866547222222223,
              "2025-11-26": 174.77648166666668,
              "2025-11-27": 840.1644216666667,
              "2025-11-28": 1.0159425,
              "2025-12-02": 30.261243055555553,
              "2025-12-04": 310.5535188888889,
              "2025-12-09": 146.41939972222224,
              "2025-12-10": 2.1433472222222223,
              "2025-12-11": 893.5236558333334,
              "2025-12-12": 4.490802777777778,
              "2025-12-15": 1566.6611075,
              "2025-12-17": 190.8909547222222,
              "2025-12-18": 0.6828458333333333,
              "2025-12-19": 1759.4374180555556,
              "2025-12-22": 4.7264936111111115,
              "2025-12-26": 178.90927222222223,
              "2025-12-28": 4.5615425,
              "2025-12-29": 2.498867222222222,
              "2026-01-05": 570.7576738888889,
              "2026-01-06": 25.54874111111111,
              "2026-01-07": 393.09614,
              "2026-01-08": 14.76477638888889,
              "2026-01-09": 262.2818877777778,
              "2026-01-10": 20.37309611111111,
              "2026-01-12": 1.8264941666666665,
              "2026-01-13": 120.59017361111111,
              "2026-01-14": 273.5433744444444,
              "2026-01-15": 3.841716111111111,
              "2026-01-16": 1729.4702991666666,
              "2026-01-17": 43.91567916666667,
              "2026-01-19": 4.248590277777778,
              "2026-01-20": 6.784655555555556,
              "2026-01-22": 27.786169166666667,
              "2026-01-23": 999.0861152777778,
              "2026-01-26": 143.51527833333333,
              "2026-01-27": 6.479324166666667,
              "2026-01-28": 2.619482777777778,
              "2026-01-29": 726.3629633333333,
              "2026-02-02": 64.25478888888888,
              "2026-02-03": 852.7928630555556,
              "2026-02-06": 34.1779,
              "2026-02-10": 616.7122761111114,
              "2026-02-11": 5.5450163888888895,
              "2026-02-12": 1038.9565888888892,
              "2026-02-13": 226.29466055555557,
              "2026-02-14": 18.233544444444444,
              "2026-02-16": 75.32140750000002,
              "2026-02-17": 28.794724444444444,
              "2026-02-18": 7451.035639166666,
              "2026-02-19": 21.93923277777778,
              "2026-02-20": 1.756875,
              "2026-02-25": 123.20912194444446,
              "2026-03-02": 2.6513958333333334,
              "2026-03-03": 17.718085833333333,
              "2026-03-05": 141.7230313888889,
              "2026-03-06": 883.6413005555555,
              "2026-03-07": 0.7976375,
              "2026-03-09": 2376.6721013888887,
              "2026-03-11": 1058.1489969444444,
              "2026-03-20": 4050.9741786111113,
              "2026-03-23": 8.5267125,
              "2026-03-27": 1753.8385850000002,
              "2026-03-31": 27.415861944444444,
              "2026-04-01": 4.0437416666666675,
              "2026-04-02": 1266.9781263888888,
              "2026-04-06": 479.37460694444445,
              "2026-04-07": 794.6149263888889,
              "2026-04-08": 1.0121405555555556,
              "2026-04-09": 0.10152666666666667,
              "2026-04-10": 5434.363653055556,
              "2026-04-14": 3.395893888888889,
              "2026-04-16": 3121.511768888889,
              "2026-04-17": 11.878485277777777,
              "2026-04-18": 1.2609613888888889,
              "2026-04-22": 3714.0220874999995,
              "2026-04-23": 4332.806551944445,
              "2026-04-24": 0.04357833333333334,
              "2026-04-27": 405.8394527777778,
              "2026-04-30": 91.40771111111111,
              "2026-05-02": 1.479202222222222,
              "2026-05-04": 507.3518438888889,
              "2026-05-05": 0.9428222222222222,
              "2026-05-06": 8.418647222222223,
              "2026-05-07": 2260.6443850000005,
              "2026-05-08": 57.00662527777778,
              "2026-05-09": 17.119254722222223,
              "2026-05-11": 10.643018333333334,
              "2026-05-12": 15.295642222222222,
              "2026-05-13": 16.758458055555554,
              "2026-05-14": 250.66884166666668,
              "2026-05-18": 15.549960277777778,
              "2026-05-20": 18.316105,
              "2026-05-21": 2.951569166666667,
              "2026-05-23": 23.92593833333333,
              "2026-05-25": 0.11237222222222223,
              "2026-05-27": 2839.8183988888886,
              "2026-05-29": 28.467966944444445,
              "2026-06-01": 0.05463861111111112,
              "2026-06-02": 92.42940138888889,
              "2026-06-03": 221.9904738888889
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-10-02": 1,
              "2025-10-06": 1,
              "2025-10-07": 4,
              "2025-10-09": 1,
              "2025-10-13": 2,
              "2025-10-14": 1,
              "2025-10-15": 4,
              "2025-10-16": 1,
              "2025-10-21": 5,
              "2025-10-22": 2,
              "2025-10-23": 3,
              "2025-10-27": 2,
              "2025-10-30": 2,
              "2025-10-31": 3,
              "2025-11-03": 3,
              "2025-11-04": 2,
              "2025-11-05": 2,
              "2025-11-06": 2,
              "2025-11-07": 3,
              "2025-11-10": 4,
              "2025-11-11": 3,
              "2025-11-12": 2,
              "2025-11-13": 4,
              "2025-11-14": 1,
              "2025-11-17": 5,
              "2025-11-21": 1,
              "2025-11-24": 2,
              "2025-11-25": 2,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-02": 5,
              "2025-12-04": 2,
              "2025-12-09": 2,
              "2025-12-10": 2,
              "2025-12-11": 3,
              "2025-12-12": 2,
              "2025-12-15": 6,
              "2025-12-17": 2,
              "2025-12-18": 1,
              "2025-12-19": 6,
              "2025-12-22": 1,
              "2025-12-26": 2,
              "2025-12-28": 2,
              "2025-12-29": 2,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-07": 3,
              "2026-01-08": 2,
              "2026-01-09": 1,
              "2026-01-10": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-14": 5,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 3,
              "2026-01-22": 1,
              "2026-01-23": 3,
              "2026-01-26": 2,
              "2026-01-27": 2,
              "2026-01-28": 1,
              "2026-01-29": 2,
              "2026-02-02": 1,
              "2026-02-03": 4,
              "2026-02-06": 3,
              "2026-02-10": 7,
              "2026-02-11": 2,
              "2026-02-12": 4,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-16": 7,
              "2026-02-17": 1,
              "2026-02-18": 6,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-25": 2,
              "2026-03-02": 2,
              "2026-03-03": 3,
              "2026-03-05": 5,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-09": 3,
              "2026-03-11": 2,
              "2026-03-20": 5,
              "2026-03-23": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-01": 2,
              "2026-04-02": 2,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 4,
              "2026-04-14": 1,
              "2026-04-16": 6,
              "2026-04-17": 2,
              "2026-04-18": 1,
              "2026-04-22": 2,
              "2026-04-23": 5,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-04-30": 4,
              "2026-05-02": 4,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 6,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 4,
              "2026-05-14": 3,
              "2026-05-18": 4,
              "2026-05-20": 1,
              "2026-05-21": 2,
              "2026-05-23": 1,
              "2026-05-25": 1,
              "2026-05-27": 3,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 2,
              "2026-06-03": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 142.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "14-16h": 1,
                "92-94h": 1,
                "744-746h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-15": 1,
                "2025-11-03": 1,
                "2026-04-23": 1,
                "2026-05-12": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-01": 0.11571805555555555,
                "2025-10-15": 1.828102222222222,
                "2025-11-03": 0.10010416666666666,
                "2026-04-23": 745.3244961111112,
                "2026-05-12": 15.295642222222222,
                "2026-06-02": 92.39122305555556
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-15": 1,
                "2025-11-03": 1,
                "2026-04-23": 1,
                "2026-05-12": 1,
                "2026-06-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 164.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 70,
              "time_distribution": {
                "0-2h": 70,
                "2-4h": 33,
                "4-6h": 16,
                "6-8h": 4,
                "8-10h": 5,
                "12-14h": 2,
                "16-18h": 1,
                "18-20h": 4,
                "20-22h": 2,
                "22-24h": 3,
                "24-26h": 7,
                "26-28h": 3,
                "28-30h": 3,
                "30-32h": 1,
                "34-36h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "46-48h": 2,
                "48-50h": 2,
                "50-52h": 1,
                "54-56h": 2,
                "64-66h": 1,
                "66-68h": 2,
                "68-70h": 3,
                "70-72h": 2,
                "72-74h": 3,
                "78-80h": 1,
                "92-94h": 1,
                "98-100h": 1,
                "106-108h": 1,
                "114-116h": 3,
                "120-122h": 1,
                "140-142h": 1,
                "144-146h": 2,
                "146-148h": 1,
                "162-164h": 3,
                "172-174h": 1,
                "190-192h": 1,
                "192-194h": 1,
                "214-216h": 1,
                "220-222h": 1,
                "226-228h": 1,
                "238-240h": 1,
                "246-248h": 1,
                "262-264h": 1,
                "316-318h": 1,
                "366-368h": 2,
                "382-384h": 1,
                "384-386h": 1,
                "388-390h": 1,
                "404-406h": 1,
                "416-418h": 1,
                "438-440h": 1,
                "478-480h": 1,
                "506-508h": 1,
                "520-522h": 1,
                "534-536h": 1,
                "602-604h": 1,
                "614-616h": 1,
                "650-652h": 1,
                "652-654h": 1,
                "654-656h": 1,
                "746-748h": 1,
                "794-796h": 1,
                "864-866h": 1,
                "892-894h": 1,
                "922-924h": 1,
                "924-926h": 1,
                "1056-1058h": 1,
                "1086-1088h": 1,
                "1142-1144h": 1,
                "1198-1200h": 1,
                "1320-1322h": 1,
                "1338-1340h": 1,
                "1514-1516h": 1,
                "1532-1534h": 1,
                "1670-1672h": 1,
                "2250-2252h": 1,
                "2280-2282h": 1,
                "2560-2562h": 1
              },
              "tickets_count": 237,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-07": 3,
                "2025-10-09": 1,
                "2025-10-13": 2,
                "2025-10-14": 1,
                "2025-10-15": 2,
                "2025-10-16": 1,
                "2025-10-21": 5,
                "2025-10-22": 2,
                "2025-10-23": 3,
                "2025-10-27": 2,
                "2025-10-30": 1,
                "2025-10-31": 3,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-05": 2,
                "2025-11-06": 2,
                "2025-11-07": 3,
                "2025-11-10": 3,
                "2025-11-11": 3,
                "2025-11-12": 2,
                "2025-11-13": 3,
                "2025-11-17": 5,
                "2025-11-24": 2,
                "2025-11-25": 2,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-09": 2,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-17": 2,
                "2025-12-19": 4,
                "2025-12-26": 2,
                "2025-12-28": 2,
                "2025-12-29": 2,
                "2026-01-07": 2,
                "2026-01-09": 1,
                "2026-01-10": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-20": 3,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 2,
                "2026-01-27": 2,
                "2026-01-28": 1,
                "2026-01-29": 2,
                "2026-02-02": 1,
                "2026-02-03": 3,
                "2026-02-06": 1,
                "2026-02-10": 7,
                "2026-02-11": 2,
                "2026-02-12": 4,
                "2026-02-14": 1,
                "2026-02-16": 7,
                "2026-02-17": 1,
                "2026-02-18": 4,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-25": 2,
                "2026-03-02": 2,
                "2026-03-03": 3,
                "2026-03-05": 5,
                "2026-03-07": 1,
                "2026-03-09": 2,
                "2026-03-11": 2,
                "2026-03-20": 5,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-01": 2,
                "2026-04-02": 2,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-14": 1,
                "2026-04-16": 6,
                "2026-04-17": 2,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 4,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-04-30": 4,
                "2026-05-02": 4,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 6,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-13": 4,
                "2026-05-14": 3,
                "2026-05-18": 4,
                "2026-05-20": 1,
                "2026-05-21": 2,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-27": 3,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-03": 2
              },
              "time_per_day": {
                "2025-10-06": 70.83189805555556,
                "2025-10-07": 262.16691222222227,
                "2025-10-09": 45.84464805555556,
                "2025-10-13": 71.56748944444445,
                "2025-10-14": 0.34103583333333337,
                "2025-10-15": 116.6454063888889,
                "2025-10-16": 23.000105555555557,
                "2025-10-21": 75.3463236111111,
                "2025-10-22": 0.8643288888888889,
                "2025-10-23": 104.8948625,
                "2025-10-27": 73.62724777777778,
                "2025-10-30": 144.65653555555556,
                "2025-10-31": 148.67816666666667,
                "2025-11-03": 78.30582027777777,
                "2025-11-04": 4.809675833333333,
                "2025-11-05": 28.940222777777777,
                "2025-11-06": 94.00019722222221,
                "2025-11-07": 206.26370416666668,
                "2025-11-10": 209.3747977777778,
                "2025-11-11": 31.330934722222224,
                "2025-11-12": 3.970601111111111,
                "2025-11-13": 72.614135,
                "2025-11-17": 0.8120263888888888,
                "2025-11-24": 1.45416,
                "2025-11-25": 5.866547222222223,
                "2025-11-28": 1.0159425,
                "2025-12-02": 9.055391111111112,
                "2025-12-09": 146.41939972222224,
                "2025-12-10": 0.06000305555555555,
                "2025-12-11": 893.5236558333334,
                "2025-12-12": 4.017132777777777,
                "2025-12-15": 408.6185394444445,
                "2025-12-17": 190.8909547222222,
                "2025-12-19": 1193.4810083333332,
                "2025-12-26": 178.90927222222223,
                "2025-12-28": 4.5615425,
                "2025-12-29": 2.498867222222222,
                "2026-01-07": 174.75432916666668,
                "2026-01-09": 262.2818877777778,
                "2026-01-10": 20.37309611111111,
                "2026-01-12": 1.8264941666666665,
                "2026-01-13": 120.59017361111111,
                "2026-01-14": 7.9870430555555565,
                "2026-01-15": 3.841716111111111,
                "2026-01-17": 43.91567916666667,
                "2026-01-19": 4.248590277777778,
                "2026-01-20": 6.784655555555556,
                "2026-01-22": 27.786169166666667,
                "2026-01-23": 999.0861152777778,
                "2026-01-26": 143.51527833333333,
                "2026-01-27": 6.479324166666667,
                "2026-01-28": 2.619482777777778,
                "2026-01-29": 726.3629633333333,
                "2026-02-02": 64.25478888888888,
                "2026-02-03": 352.41113583333333,
                "2026-02-06": 0.12150611111111112,
                "2026-02-10": 616.7122761111114,
                "2026-02-11": 5.5450163888888895,
                "2026-02-12": 1038.9565888888892,
                "2026-02-14": 18.233544444444444,
                "2026-02-16": 75.32140750000002,
                "2026-02-17": 28.794724444444444,
                "2026-02-18": 3090.743473611111,
                "2026-02-19": 21.93923277777778,
                "2026-02-20": 1.756875,
                "2026-02-25": 123.20912194444446,
                "2026-03-02": 2.6513958333333334,
                "2026-03-03": 17.718085833333333,
                "2026-03-05": 141.7230313888889,
                "2026-03-07": 0.7976375,
                "2026-03-09": 1094.0913308333331,
                "2026-03-11": 1058.1489969444444,
                "2026-03-20": 4050.9741786111113,
                "2026-03-23": 8.5267125,
                "2026-03-31": 27.415861944444444,
                "2026-04-01": 4.0437416666666675,
                "2026-04-02": 1266.9781263888888,
                "2026-04-06": 479.37460694444445,
                "2026-04-07": 794.6149263888889,
                "2026-04-08": 1.0121405555555556,
                "2026-04-09": 0.10152666666666667,
                "2026-04-10": 2205.253993611111,
                "2026-04-14": 3.395893888888889,
                "2026-04-16": 3121.511768888889,
                "2026-04-17": 11.878485277777777,
                "2026-04-18": 1.2609613888888889,
                "2026-04-22": 1321.5190483333333,
                "2026-04-23": 3587.482055833334,
                "2026-04-24": 0.04357833333333334,
                "2026-04-27": 405.8394527777778,
                "2026-04-30": 91.40771111111111,
                "2026-05-02": 1.479202222222222,
                "2026-05-04": 507.3518438888889,
                "2026-05-05": 0.9428222222222222,
                "2026-05-06": 8.418647222222223,
                "2026-05-07": 2260.6443850000005,
                "2026-05-08": 57.00662527777778,
                "2026-05-09": 17.119254722222223,
                "2026-05-11": 10.643018333333334,
                "2026-05-13": 16.758458055555554,
                "2026-05-14": 250.66884166666668,
                "2026-05-18": 15.549960277777778,
                "2026-05-20": 18.316105,
                "2026-05-21": 2.951569166666667,
                "2026-05-23": 23.92593833333333,
                "2026-05-25": 0.11237222222222223,
                "2026-05-27": 2839.8183988888886,
                "2026-05-29": 28.467966944444445,
                "2026-06-01": 0.05463861111111112,
                "2026-06-02": 0.038178333333333335,
                "2026-06-03": 221.9904738888889
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-07": 3,
                "2025-10-09": 1,
                "2025-10-13": 2,
                "2025-10-14": 1,
                "2025-10-15": 2,
                "2025-10-16": 1,
                "2025-10-21": 5,
                "2025-10-22": 2,
                "2025-10-23": 3,
                "2025-10-27": 2,
                "2025-10-30": 1,
                "2025-10-31": 3,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-05": 2,
                "2025-11-06": 2,
                "2025-11-07": 3,
                "2025-11-10": 3,
                "2025-11-11": 3,
                "2025-11-12": 2,
                "2025-11-13": 3,
                "2025-11-17": 5,
                "2025-11-24": 2,
                "2025-11-25": 2,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-09": 2,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-17": 2,
                "2025-12-19": 4,
                "2025-12-26": 2,
                "2025-12-28": 2,
                "2025-12-29": 2,
                "2026-01-07": 2,
                "2026-01-09": 1,
                "2026-01-10": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-20": 3,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 2,
                "2026-01-27": 2,
                "2026-01-28": 1,
                "2026-01-29": 2,
                "2026-02-02": 1,
                "2026-02-03": 3,
                "2026-02-06": 1,
                "2026-02-10": 7,
                "2026-02-11": 2,
                "2026-02-12": 4,
                "2026-02-14": 1,
                "2026-02-16": 7,
                "2026-02-17": 1,
                "2026-02-18": 4,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-25": 2,
                "2026-03-02": 2,
                "2026-03-03": 3,
                "2026-03-05": 5,
                "2026-03-07": 1,
                "2026-03-09": 2,
                "2026-03-11": 2,
                "2026-03-20": 5,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-01": 2,
                "2026-04-02": 2,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-14": 1,
                "2026-04-16": 6,
                "2026-04-17": 2,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 4,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-04-30": 4,
                "2026-05-02": 4,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 6,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-13": 4,
                "2026-05-14": 3,
                "2026-05-18": 4,
                "2026-05-20": 1,
                "2026-05-21": 2,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-27": 3,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-03": 2
              }
            },
            "P3": {
              "avg_time_hours": 464.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 4,
                "8-10h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "32-34h": 1,
                "38-40h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "140-142h": 1,
                "174-176h": 1,
                "178-180h": 1,
                "182-184h": 1,
                "218-220h": 1,
                "226-228h": 1,
                "244-246h": 1,
                "270-272h": 1,
                "306-308h": 1,
                "386-388h": 1,
                "500-502h": 1,
                "570-572h": 1,
                "790-792h": 1,
                "840-842h": 1,
                "882-884h": 1,
                "910-912h": 1,
                "1282-1284h": 1,
                "1570-1572h": 1,
                "1658-1660h": 1,
                "1728-1730h": 1,
                "1752-1754h": 1,
                "2008-2010h": 1,
                "2350-2352h": 1,
                "2392-2394h": 1
              },
              "tickets_count": 47,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-10": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-21": 1,
                "2025-11-26": 1,
                "2025-11-27": 1,
                "2025-12-02": 4,
                "2025-12-04": 2,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-18": 1,
                "2025-12-19": 2,
                "2026-01-05": 1,
                "2026-01-06": 1,
                "2026-01-07": 1,
                "2026-01-08": 2,
                "2026-01-14": 3,
                "2026-01-16": 1,
                "2026-02-03": 1,
                "2026-02-06": 2,
                "2026-02-13": 1,
                "2026-02-18": 2,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-27": 1,
                "2026-04-10": 2,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2025-10-02": 44.5451,
                "2025-10-07": 140.24729194444444,
                "2025-10-15": 1.8115216666666667,
                "2025-10-30": 0.5598111111111111,
                "2025-11-03": 790.0491955555555,
                "2025-11-04": 6.256720555555556,
                "2025-11-10": 270.09940694444447,
                "2025-11-13": 18.511287777777778,
                "2025-11-14": 0.40476305555555553,
                "2025-11-21": 0.7284091666666667,
                "2025-11-26": 174.77648166666668,
                "2025-11-27": 840.1644216666667,
                "2025-12-02": 21.205851944444444,
                "2025-12-04": 310.5535188888889,
                "2025-12-10": 2.0833441666666666,
                "2025-12-12": 0.47367,
                "2025-12-15": 1158.0425680555556,
                "2025-12-18": 0.6828458333333333,
                "2025-12-19": 565.9564097222221,
                "2026-01-05": 570.7576738888889,
                "2026-01-06": 25.54874111111111,
                "2026-01-07": 218.3418108333333,
                "2026-01-08": 14.76477638888889,
                "2026-01-14": 265.55633138888885,
                "2026-01-16": 1729.4702991666666,
                "2026-02-03": 500.38172722222225,
                "2026-02-06": 34.05639388888889,
                "2026-02-13": 226.29466055555557,
                "2026-02-18": 4360.292165555556,
                "2026-03-06": 883.6413005555555,
                "2026-03-09": 1282.5807705555555,
                "2026-03-27": 1753.8385850000002,
                "2026-04-10": 3229.1096594444443,
                "2026-04-22": 2392.5030391666664
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2025-11-10": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-21": 1,
                "2025-11-26": 1,
                "2025-11-27": 1,
                "2025-12-02": 4,
                "2025-12-04": 2,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-15": 3,
                "2025-12-18": 1,
                "2025-12-19": 2,
                "2026-01-05": 1,
                "2026-01-06": 1,
                "2026-01-07": 1,
                "2026-01-08": 2,
                "2026-01-14": 3,
                "2026-01-16": 1,
                "2026-02-03": 1,
                "2026-02-06": 2,
                "2026-02-13": 1,
                "2026-02-18": 2,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-27": 1,
                "2026-04-10": 2,
                "2026-04-22": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 4.73,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-22": 1
              },
              "time_per_day": {
                "2025-12-22": 4.7264936111111115
              },
              "time_count_per_day": {
                "2025-12-22": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 17,
            "tickets_per_day": {
              "2026-03-24": 1,
              "2026-03-26": 1,
              "2026-04-13": 1,
              "2026-04-23": 1,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-07": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-27": 2,
              "2026-05-29": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 15,
              "tickets_per_day": {
                "2026-03-24": 1,
                "2026-03-26": 1,
                "2026-04-13": 1,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-07": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-16": 1,
                "2026-05-18": 1,
                "2026-05-20": 1,
                "2026-05-27": 2,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-12-12": 1,
              "2026-01-29": 1,
              "2026-02-25": 1,
              "2026-03-20": 1,
              "2026-04-24": 2,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-11": 1,
              "2026-05-12": 2,
              "2026-05-13": 1,
              "2026-05-15": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-29": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-12-12": 1,
                "2026-01-29": 1,
                "2026-02-25": 1,
                "2026-03-20": 1,
                "2026-04-24": 2,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-12": 2,
                "2026-05-13": 1,
                "2026-05-15": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2026-04-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_58": {
      "overall": {
        "avg_time_hours": 147.82,
        "mode_time_hours": 217.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1,
          "216-218h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-09": 1,
          "2025-10-27": 1
        },
        "time_per_day": {
          "2025-10-09": 217.61307666666667,
          "2025-10-27": 78.02698444444444
        },
        "time_count_per_day": {
          "2025-10-09": 1,
          "2025-10-27": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 147.82,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1,
            "216-218h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-10-27": 1
          },
          "time_per_day": {
            "2025-10-09": 217.61307666666667,
            "2025-10-27": 78.02698444444444
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-10-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 147.82,
            "mode_time_hours": 217.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1,
              "216-218h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-09": 1,
              "2025-10-27": 1
            },
            "time_per_day": {
              "2025-10-09": 217.61307666666667,
              "2025-10-27": 78.02698444444444
            },
            "time_count_per_day": {
              "2025-10-09": 1,
              "2025-10-27": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 147.82,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1,
                "216-218h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-10-27": 1
              },
              "time_per_day": {
                "2025-10-09": 217.61307666666667,
                "2025-10-27": 78.02698444444444
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-10-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_63": {
      "overall": {
        "avg_time_hours": 97.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "286-288h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-11-18": 1,
          "2025-12-03": 1
        },
        "time_per_day": {
          "2025-09-30": 1.1442316666666668,
          "2025-11-18": 287.6477113888889,
          "2025-12-03": 2.867046666666667
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-11-18": 1,
          "2025-12-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 287.65,
          "mode_time_hours": 287.0,
          "mode_frequency": 1,
          "time_distribution": {
            "286-288h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-18": 1
          },
          "time_per_day": {
            "2025-11-18": 287.6477113888889
          },
          "time_count_per_day": {
            "2025-11-18": 1
          }
        },
        "P2": {
          "avg_time_hours": 2.87,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-03": 1
          },
          "time_per_day": {
            "2025-12-03": 2.867046666666667
          },
          "time_count_per_day": {
            "2025-12-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 1.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-09-30": 1
          },
          "time_per_day": {
            "2025-09-30": 1.1442316666666668
          },
          "time_count_per_day": {
            "2025-09-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 97.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "286-288h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-11-18": 1,
              "2025-12-03": 1
            },
            "time_per_day": {
              "2025-09-30": 1.1442316666666668,
              "2025-11-18": 287.6477113888889,
              "2025-12-03": 2.867046666666667
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-11-18": 1,
              "2025-12-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 287.65,
              "mode_time_hours": 287.0,
              "mode_frequency": 1,
              "time_distribution": {
                "286-288h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-18": 1
              },
              "time_per_day": {
                "2025-11-18": 287.6477113888889
              },
              "time_count_per_day": {
                "2025-11-18": 1
              }
            },
            "P2": {
              "avg_time_hours": 2.87,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-12-03": 2.867046666666667
              },
              "time_count_per_day": {
                "2025-12-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 1.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-09-30": 1
              },
              "time_per_day": {
                "2025-09-30": 1.1442316666666668
              },
              "time_count_per_day": {
                "2025-09-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_64": {
      "overall": {
        "avg_time_hours": 453.48,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "424-426h": 1,
          "844-846h": 1,
          "988-990h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-12-05": 1,
          "2025-12-11": 1,
          "2026-03-04": 1,
          "2026-04-23": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2025-09-30": 1.635491388888889,
          "2025-12-05": 424.44921,
          "2025-12-11": 845.8041133333334,
          "2026-04-23": 988.1891402777777,
          "2026-05-20": 7.313762777777777
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-12-05": 1,
          "2025-12-11": 1,
          "2026-04-23": 1,
          "2026-05-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 426.56,
          "mode_time_hours": 845.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "844-846h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2026-03-04": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2025-12-11": 845.8041133333334,
            "2026-05-20": 7.313762777777777
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2026-05-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 471.42,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "424-426h": 1,
            "988-990h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-12-05": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-09-30": 1.635491388888889,
            "2025-12-05": 424.44921,
            "2026-04-23": 988.1891402777777
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-12-05": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 453.48,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "424-426h": 1,
              "844-846h": 1,
              "988-990h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-12-05": 1,
              "2025-12-11": 1,
              "2026-04-23": 1,
              "2026-05-20": 1
            },
            "time_per_day": {
              "2025-09-30": 1.635491388888889,
              "2025-12-05": 424.44921,
              "2025-12-11": 845.8041133333334,
              "2026-04-23": 988.1891402777777,
              "2026-05-20": 7.313762777777777
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-12-05": 1,
              "2025-12-11": 1,
              "2026-04-23": 1,
              "2026-05-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 426.56,
              "mode_time_hours": 845.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "844-846h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2025-12-11": 845.8041133333334,
                "2026-05-20": 7.313762777777777
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2026-05-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 471.42,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "424-426h": 1,
                "988-990h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-12-05": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-09-30": 1.635491388888889,
                "2025-12-05": 424.44921,
                "2026-04-23": 988.1891402777777
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-12-05": 1,
                "2026-04-23": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_65": {
      "overall": {
        "avg_time_hours": 219.34,
        "mode_time_hours": 219.0,
        "mode_frequency": 1,
        "time_distribution": {
          "218-220h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-09": 1
        },
        "time_per_day": {
          "2025-10-09": 219.338965
        },
        "time_count_per_day": {
          "2025-10-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 219.34,
          "mode_time_hours": 219.0,
          "mode_frequency": 1,
          "time_distribution": {
            "218-220h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-09": 1
          },
          "time_per_day": {
            "2025-10-09": 219.338965
          },
          "time_count_per_day": {
            "2025-10-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 219.34,
            "mode_time_hours": 219.0,
            "mode_frequency": 1,
            "time_distribution": {
              "218-220h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-09": 1
            },
            "time_per_day": {
              "2025-10-09": 219.338965
            },
            "time_count_per_day": {
              "2025-10-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 219.34,
              "mode_time_hours": 219.0,
              "mode_frequency": 1,
              "time_distribution": {
                "218-220h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-09": 1
              },
              "time_per_day": {
                "2025-10-09": 219.338965
              },
              "time_count_per_day": {
                "2025-10-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_66": {
      "overall": {
        "avg_time_hours": 1.33,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-09-30": 1
        },
        "time_per_day": {
          "2025-09-30": 1.3264569444444445
        },
        "time_count_per_day": {
          "2025-09-30": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-09-30": 1
          },
          "time_per_day": {
            "2025-09-30": 1.3264569444444445
          },
          "time_count_per_day": {
            "2025-09-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.33,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-09-30": 1
            },
            "time_per_day": {
              "2025-09-30": 1.3264569444444445
            },
            "time_count_per_day": {
              "2025-09-30": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-09-30": 1
              },
              "time_per_day": {
                "2025-09-30": 1.3264569444444445
              },
              "time_count_per_day": {
                "2025-09-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_67": {
      "overall": {
        "avg_time_hours": 198.62,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "2-4h": 1,
          "6-8h": 1,
          "8-10h": 1,
          "12-14h": 1,
          "14-16h": 5,
          "16-18h": 3,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 3,
          "26-28h": 1,
          "28-30h": 1,
          "44-46h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "52-54h": 1,
          "54-56h": 1,
          "64-66h": 1,
          "68-70h": 1,
          "96-98h": 1,
          "102-104h": 1,
          "104-106h": 1,
          "134-136h": 1,
          "136-138h": 1,
          "160-162h": 1,
          "166-168h": 1,
          "196-198h": 1,
          "242-244h": 1,
          "262-264h": 2,
          "344-346h": 1,
          "372-374h": 1,
          "416-418h": 1,
          "460-462h": 1,
          "478-480h": 1,
          "498-500h": 1,
          "528-530h": 1,
          "634-636h": 1,
          "736-738h": 1,
          "1050-1052h": 1,
          "1498-1500h": 1,
          "2016-2018h": 1
        },
        "tickets_count": 61,
        "tickets_per_day": {
          "2025-10-10": 1,
          "2025-10-23": 1,
          "2025-10-31": 1,
          "2025-11-07": 1,
          "2025-11-13": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2025-12-29": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-16": 4,
          "2026-02-12": 1,
          "2026-02-19": 2,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-02-28": 1,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-22": 1,
          "2026-03-25": 1,
          "2026-04-07": 1,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-15": 8,
          "2026-05-05": 3,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-12": 1,
          "2026-05-14": 2,
          "2026-05-18": 2,
          "2026-05-27": 1,
          "2026-06-03": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-10": 243.5199477777778,
          "2025-10-23": 29.015289722222224,
          "2025-10-31": 44.046657222222215,
          "2025-11-07": 102.05548777777777,
          "2025-11-13": 49.13822666666667,
          "2025-11-14": 262.60846972222225,
          "2025-11-17": 96.50489611111111,
          "2025-11-18": 137.34109833333335,
          "2025-11-21": 0.8737283333333333,
          "2025-11-24": 262.1874447222222,
          "2025-11-27": 68.50639222222222,
          "2025-12-11": 48.56690583333334,
          "2025-12-15": 479.98042166666664,
          "2025-12-19": 167.30266500000002,
          "2025-12-22": 53.13162861111111,
          "2025-12-29": 64.7730375,
          "2026-01-14": 2.639026388888889,
          "2026-01-15": 22.1035525,
          "2026-01-16": 89.91865333333334,
          "2026-02-12": 1499.6859749999999,
          "2026-02-19": 1685.8956238888888,
          "2026-02-24": 14.77894,
          "2026-02-25": 134.8368702777778,
          "2026-02-28": 9.507157222222222,
          "2026-03-03": 0.7194719444444445,
          "2026-03-04": 26.210594444444443,
          "2026-03-05": 47.89969194444445,
          "2026-03-07": 0.24971972222222222,
          "2026-03-11": 345.70350638888885,
          "2026-03-20": 736.0691894444444,
          "2026-03-22": 196.89580444444442,
          "2026-03-25": 498.30753888888887,
          "2026-04-07": 2016.1087336111111,
          "2026-04-13": 0.4232594444444444,
          "2026-04-14": 0.015753055555555555,
          "2026-04-15": 132.6176911111111,
          "2026-05-05": 1251.8261938888888,
          "2026-05-07": 529.0669594444445,
          "2026-05-12": 23.005328333333335,
          "2026-05-14": 9.771229166666666,
          "2026-05-18": 118.89273388888887,
          "2026-06-03": 54.31258583333334,
          "2026-06-08": 161.49304999999998
        },
        "time_count_per_day": {
          "2025-10-10": 1,
          "2025-10-23": 1,
          "2025-10-31": 1,
          "2025-11-07": 1,
          "2025-11-13": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2025-12-29": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-16": 4,
          "2026-02-12": 1,
          "2026-02-19": 2,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-02-28": 1,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-22": 1,
          "2026-03-25": 1,
          "2026-04-07": 1,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-15": 8,
          "2026-05-05": 3,
          "2026-05-07": 1,
          "2026-05-12": 1,
          "2026-05-14": 2,
          "2026-05-18": 2,
          "2026-06-03": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 92.84,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "14-16h": 5,
            "16-18h": 3,
            "18-20h": 2,
            "22-24h": 1,
            "24-26h": 3,
            "26-28h": 1,
            "28-30h": 1,
            "44-46h": 1,
            "46-48h": 1,
            "52-54h": 1,
            "54-56h": 1,
            "64-66h": 1,
            "68-70h": 1,
            "96-98h": 1,
            "104-106h": 1,
            "134-136h": 1,
            "160-162h": 1,
            "196-198h": 1,
            "242-244h": 1,
            "262-264h": 1,
            "344-346h": 1,
            "372-374h": 1,
            "460-462h": 1,
            "498-500h": 1,
            "528-530h": 1
          },
          "tickets_count": 46,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-10-23": 1,
            "2025-10-31": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 4,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-07": 1,
            "2026-03-11": 1,
            "2026-03-22": 1,
            "2026-03-25": 1,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-15": 8,
            "2026-05-05": 2,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-12": 1,
            "2026-05-14": 2,
            "2026-05-18": 2,
            "2026-05-27": 1,
            "2026-06-03": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-10": 243.5199477777778,
            "2025-10-23": 29.015289722222224,
            "2025-10-31": 44.046657222222215,
            "2025-11-17": 96.50489611111111,
            "2025-11-21": 0.8737283333333333,
            "2025-11-24": 262.1874447222222,
            "2025-11-27": 68.50639222222222,
            "2025-12-22": 53.13162861111111,
            "2025-12-29": 64.7730375,
            "2026-01-14": 2.639026388888889,
            "2026-01-15": 0.42879805555555556,
            "2026-01-16": 89.91865333333334,
            "2026-02-24": 14.77894,
            "2026-02-25": 134.8368702777778,
            "2026-03-03": 0.7194719444444445,
            "2026-03-04": 26.210594444444443,
            "2026-03-05": 47.89969194444445,
            "2026-03-07": 0.24971972222222222,
            "2026-03-11": 345.70350638888885,
            "2026-03-22": 196.89580444444442,
            "2026-03-25": 498.30753888888887,
            "2026-04-13": 0.4232594444444444,
            "2026-04-14": 0.015753055555555555,
            "2026-04-15": 132.6176911111111,
            "2026-05-05": 834.4065175000001,
            "2026-05-07": 529.0669594444445,
            "2026-05-12": 23.005328333333335,
            "2026-05-14": 9.771229166666666,
            "2026-05-18": 118.89273388888887,
            "2026-06-03": 54.31258583333334,
            "2026-06-08": 161.49304999999998
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-10-23": 1,
            "2025-10-31": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 4,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-07": 1,
            "2026-03-11": 1,
            "2026-03-22": 1,
            "2026-03-25": 1,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-15": 8,
            "2026-05-05": 2,
            "2026-05-07": 1,
            "2026-05-12": 1,
            "2026-05-14": 2,
            "2026-05-18": 2,
            "2026-06-03": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 494.83,
          "mode_time_hours": 49.0,
          "mode_frequency": 2,
          "time_distribution": {
            "20-22h": 1,
            "48-50h": 2,
            "102-104h": 1,
            "136-138h": 1,
            "166-168h": 1,
            "262-264h": 1,
            "416-418h": 1,
            "478-480h": 1,
            "736-738h": 1,
            "1498-1500h": 1,
            "2016-2018h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-11-07": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-18": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-02-12": 1,
            "2026-03-20": 1,
            "2026-04-07": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2025-11-07": 102.05548777777777,
            "2025-11-13": 49.13822666666667,
            "2025-11-14": 262.60846972222225,
            "2025-11-18": 137.34109833333335,
            "2025-12-11": 48.56690583333334,
            "2025-12-15": 479.98042166666664,
            "2025-12-19": 167.30266500000002,
            "2026-01-15": 21.674754444444442,
            "2026-02-12": 1499.6859749999999,
            "2026-03-20": 736.0691894444444,
            "2026-04-07": 2016.1087336111111,
            "2026-05-05": 417.4196763888889
          },
          "time_count_per_day": {
            "2025-11-07": 1,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-18": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-02-12": 1,
            "2026-03-20": 1,
            "2026-04-07": 1,
            "2026-05-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 9.51,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 9.507157222222222
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 842.95,
          "mode_time_hours": 1051.0,
          "mode_frequency": 1,
          "time_distribution": {
            "634-636h": 1,
            "1050-1052h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 1685.8956238888888
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 198.62,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "2-4h": 1,
              "6-8h": 1,
              "8-10h": 1,
              "12-14h": 1,
              "14-16h": 5,
              "16-18h": 3,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 3,
              "26-28h": 1,
              "28-30h": 1,
              "44-46h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "52-54h": 1,
              "54-56h": 1,
              "64-66h": 1,
              "68-70h": 1,
              "96-98h": 1,
              "102-104h": 1,
              "104-106h": 1,
              "134-136h": 1,
              "136-138h": 1,
              "160-162h": 1,
              "166-168h": 1,
              "196-198h": 1,
              "242-244h": 1,
              "262-264h": 2,
              "344-346h": 1,
              "372-374h": 1,
              "416-418h": 1,
              "460-462h": 1,
              "478-480h": 1,
              "498-500h": 1,
              "528-530h": 1,
              "634-636h": 1,
              "736-738h": 1,
              "1050-1052h": 1,
              "1498-1500h": 1,
              "2016-2018h": 1
            },
            "tickets_count": 59,
            "tickets_per_day": {
              "2025-10-10": 1,
              "2025-10-23": 1,
              "2025-10-31": 1,
              "2025-11-07": 1,
              "2025-11-13": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2025-12-29": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-16": 4,
              "2026-02-12": 1,
              "2026-02-19": 2,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-02-28": 1,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-22": 1,
              "2026-03-25": 1,
              "2026-04-07": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-15": 8,
              "2026-05-05": 3,
              "2026-05-07": 1,
              "2026-05-12": 1,
              "2026-05-14": 2,
              "2026-05-18": 2,
              "2026-06-03": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-10": 243.5199477777778,
              "2025-10-23": 29.015289722222224,
              "2025-10-31": 44.046657222222215,
              "2025-11-07": 102.05548777777777,
              "2025-11-13": 49.13822666666667,
              "2025-11-14": 262.60846972222225,
              "2025-11-17": 96.50489611111111,
              "2025-11-18": 137.34109833333335,
              "2025-11-21": 0.8737283333333333,
              "2025-11-24": 262.1874447222222,
              "2025-11-27": 68.50639222222222,
              "2025-12-11": 48.56690583333334,
              "2025-12-15": 479.98042166666664,
              "2025-12-19": 167.30266500000002,
              "2025-12-22": 53.13162861111111,
              "2025-12-29": 64.7730375,
              "2026-01-14": 2.639026388888889,
              "2026-01-15": 22.1035525,
              "2026-01-16": 89.91865333333334,
              "2026-02-12": 1499.6859749999999,
              "2026-02-19": 1685.8956238888888,
              "2026-02-24": 14.77894,
              "2026-02-25": 134.8368702777778,
              "2026-02-28": 9.507157222222222,
              "2026-03-03": 0.7194719444444445,
              "2026-03-04": 26.210594444444443,
              "2026-03-05": 47.89969194444445,
              "2026-03-07": 0.24971972222222222,
              "2026-03-11": 345.70350638888885,
              "2026-03-20": 736.0691894444444,
              "2026-03-22": 196.89580444444442,
              "2026-03-25": 498.30753888888887,
              "2026-04-07": 2016.1087336111111,
              "2026-04-13": 0.4232594444444444,
              "2026-04-14": 0.015753055555555555,
              "2026-04-15": 132.6176911111111,
              "2026-05-05": 1251.8261938888888,
              "2026-05-07": 529.0669594444445,
              "2026-05-12": 23.005328333333335,
              "2026-05-14": 9.771229166666666,
              "2026-05-18": 118.89273388888887,
              "2026-06-03": 54.31258583333334,
              "2026-06-08": 161.49304999999998
            },
            "time_count_per_day": {
              "2025-10-10": 1,
              "2025-10-23": 1,
              "2025-10-31": 1,
              "2025-11-07": 1,
              "2025-11-13": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2025-12-29": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-16": 4,
              "2026-02-12": 1,
              "2026-02-19": 2,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-02-28": 1,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-22": 1,
              "2026-03-25": 1,
              "2026-04-07": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-15": 8,
              "2026-05-05": 3,
              "2026-05-07": 1,
              "2026-05-12": 1,
              "2026-05-14": 2,
              "2026-05-18": 2,
              "2026-06-03": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 92.84,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "14-16h": 5,
                "16-18h": 3,
                "18-20h": 2,
                "22-24h": 1,
                "24-26h": 3,
                "26-28h": 1,
                "28-30h": 1,
                "44-46h": 1,
                "46-48h": 1,
                "52-54h": 1,
                "54-56h": 1,
                "64-66h": 1,
                "68-70h": 1,
                "96-98h": 1,
                "104-106h": 1,
                "134-136h": 1,
                "160-162h": 1,
                "196-198h": 1,
                "242-244h": 1,
                "262-264h": 1,
                "344-346h": 1,
                "372-374h": 1,
                "460-462h": 1,
                "498-500h": 1,
                "528-530h": 1
              },
              "tickets_count": 44,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-10-31": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 4,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-07": 1,
                "2026-03-11": 1,
                "2026-03-22": 1,
                "2026-03-25": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-15": 8,
                "2026-05-05": 2,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-14": 2,
                "2026-05-18": 2,
                "2026-06-03": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-10": 243.5199477777778,
                "2025-10-23": 29.015289722222224,
                "2025-10-31": 44.046657222222215,
                "2025-11-17": 96.50489611111111,
                "2025-11-21": 0.8737283333333333,
                "2025-11-24": 262.1874447222222,
                "2025-11-27": 68.50639222222222,
                "2025-12-22": 53.13162861111111,
                "2025-12-29": 64.7730375,
                "2026-01-14": 2.639026388888889,
                "2026-01-15": 0.42879805555555556,
                "2026-01-16": 89.91865333333334,
                "2026-02-24": 14.77894,
                "2026-02-25": 134.8368702777778,
                "2026-03-03": 0.7194719444444445,
                "2026-03-04": 26.210594444444443,
                "2026-03-05": 47.89969194444445,
                "2026-03-07": 0.24971972222222222,
                "2026-03-11": 345.70350638888885,
                "2026-03-22": 196.89580444444442,
                "2026-03-25": 498.30753888888887,
                "2026-04-13": 0.4232594444444444,
                "2026-04-14": 0.015753055555555555,
                "2026-04-15": 132.6176911111111,
                "2026-05-05": 834.4065175000001,
                "2026-05-07": 529.0669594444445,
                "2026-05-12": 23.005328333333335,
                "2026-05-14": 9.771229166666666,
                "2026-05-18": 118.89273388888887,
                "2026-06-03": 54.31258583333334,
                "2026-06-08": 161.49304999999998
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-10-31": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 4,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-07": 1,
                "2026-03-11": 1,
                "2026-03-22": 1,
                "2026-03-25": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-15": 8,
                "2026-05-05": 2,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-14": 2,
                "2026-05-18": 2,
                "2026-06-03": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 494.83,
              "mode_time_hours": 49.0,
              "mode_frequency": 2,
              "time_distribution": {
                "20-22h": 1,
                "48-50h": 2,
                "102-104h": 1,
                "136-138h": 1,
                "166-168h": 1,
                "262-264h": 1,
                "416-418h": 1,
                "478-480h": 1,
                "736-738h": 1,
                "1498-1500h": 1,
                "2016-2018h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-11-07": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-18": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-02-12": 1,
                "2026-03-20": 1,
                "2026-04-07": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2025-11-07": 102.05548777777777,
                "2025-11-13": 49.13822666666667,
                "2025-11-14": 262.60846972222225,
                "2025-11-18": 137.34109833333335,
                "2025-12-11": 48.56690583333334,
                "2025-12-15": 479.98042166666664,
                "2025-12-19": 167.30266500000002,
                "2026-01-15": 21.674754444444442,
                "2026-02-12": 1499.6859749999999,
                "2026-03-20": 736.0691894444444,
                "2026-04-07": 2016.1087336111111,
                "2026-05-05": 417.4196763888889
              },
              "time_count_per_day": {
                "2025-11-07": 1,
                "2025-11-13": 1,
                "2025-11-14": 1,
                "2025-11-18": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-02-12": 1,
                "2026-03-20": 1,
                "2026-04-07": 1,
                "2026-05-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 9.51,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 9.507157222222222
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 842.95,
              "mode_time_hours": 1051.0,
              "mode_frequency": 1,
              "time_distribution": {
                "634-636h": 1,
                "1050-1052h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 1685.8956238888888
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-06": 1,
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-06": 1,
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_62": {
      "overall": {
        "avg_time_hours": 147.57,
        "mode_time_hours": 1.0,
        "mode_frequency": 14,
        "time_distribution": {
          "0-2h": 14,
          "2-4h": 3,
          "4-6h": 4,
          "6-8h": 8,
          "8-10h": 5,
          "10-12h": 2,
          "14-16h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 3,
          "28-30h": 1,
          "32-34h": 1,
          "46-48h": 2,
          "48-50h": 1,
          "50-52h": 1,
          "52-54h": 2,
          "54-56h": 1,
          "62-64h": 2,
          "64-66h": 1,
          "68-70h": 1,
          "70-72h": 2,
          "72-74h": 1,
          "74-76h": 1,
          "80-82h": 1,
          "82-84h": 1,
          "84-86h": 1,
          "98-100h": 1,
          "100-102h": 3,
          "102-104h": 1,
          "104-106h": 1,
          "116-118h": 1,
          "126-128h": 1,
          "142-144h": 1,
          "164-166h": 1,
          "166-168h": 3,
          "168-170h": 1,
          "194-196h": 1,
          "210-212h": 1,
          "218-220h": 1,
          "222-224h": 1,
          "230-232h": 1,
          "236-238h": 1,
          "242-244h": 1,
          "260-262h": 1,
          "268-270h": 1,
          "272-274h": 1,
          "292-294h": 1,
          "318-320h": 1,
          "338-340h": 1,
          "432-434h": 1,
          "502-504h": 1,
          "544-546h": 1,
          "650-652h": 1,
          "658-660h": 1,
          "764-766h": 1,
          "838-840h": 1,
          "968-970h": 1,
          "1086-1088h": 1,
          "1762-1764h": 1
        },
        "tickets_count": 107,
        "tickets_per_day": {
          "2025-09-30": 2,
          "2025-10-09": 1,
          "2025-10-14": 1,
          "2025-10-15": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-28": 1,
          "2025-10-30": 1,
          "2025-11-03": 2,
          "2025-11-04": 3,
          "2025-11-06": 2,
          "2025-11-07": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-17": 4,
          "2025-11-22": 1,
          "2025-12-01": 1,
          "2025-12-02": 1,
          "2025-12-05": 1,
          "2025-12-12": 2,
          "2025-12-24": 1,
          "2026-01-05": 1,
          "2026-01-08": 3,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-06": 1,
          "2026-02-07": 2,
          "2026-02-12": 1,
          "2026-02-14": 2,
          "2026-02-16": 3,
          "2026-02-18": 3,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-02": 2,
          "2026-03-03": 1,
          "2026-03-04": 2,
          "2026-03-07": 1,
          "2026-03-10": 3,
          "2026-03-11": 2,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-20": 2,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-04-02": 2,
          "2026-04-09": 2,
          "2026-04-13": 1,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-16": 3,
          "2026-04-24": 1,
          "2026-04-27": 2,
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-15": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-28": 1
        },
        "time_per_day": {
          "2025-09-30": 0.5455091666666667,
          "2025-10-09": 210.85269416666668,
          "2025-10-14": 272.44976916666667,
          "2025-10-15": 293.80307055555556,
          "2025-10-20": 5.537886666666666,
          "2025-10-22": 49.655495,
          "2025-10-28": 164.24522416666667,
          "2025-10-30": 22.481259722222223,
          "2025-11-03": 10.139015277777778,
          "2025-11-04": 22.239098055555555,
          "2025-11-06": 235.66958166666666,
          "2025-11-07": 1.8481505555555555,
          "2025-11-10": 47.3464575,
          "2025-11-11": 126.80880111111111,
          "2025-11-12": 54.78884722222222,
          "2025-11-13": 219.3726047222222,
          "2025-11-17": 371.67363222222224,
          "2025-11-22": 651.6799255555555,
          "2025-12-02": 102.25535944444444,
          "2025-12-05": 0.29595666666666665,
          "2025-12-12": 772.1154494444445,
          "2025-12-24": 0.05460527777777778,
          "2026-01-05": 52.061346111111106,
          "2026-01-08": 11.784155833333333,
          "2026-01-09": 2.9478863888888887,
          "2026-01-14": 19.137159999999998,
          "2026-01-15": 226.9019961111111,
          "2026-01-17": 236.71868638888887,
          "2026-01-19": 326.1704991666667,
          "2026-01-23": 268.63819333333333,
          "2026-01-27": 34.941559999999996,
          "2026-02-03": 109.57332777777779,
          "2026-02-04": 6.104761944444444,
          "2026-02-05": 62.77694527777778,
          "2026-02-06": 2.0799527777777778,
          "2026-02-07": 67.86198138888889,
          "2026-02-12": 1763.7845513888888,
          "2026-02-14": 135.5570713888889,
          "2026-02-16": 185.22498638888888,
          "2026-02-18": 330.0831847222222,
          "2026-02-21": 194.2587313888889,
          "2026-02-23": 73.4800388888889,
          "2026-02-25": 10.08637388888889,
          "2026-03-02": 11.885685833333334,
          "2026-03-03": 32.71425527777778,
          "2026-03-04": 16.0058875,
          "2026-03-07": 62.877425555555554,
          "2026-03-10": 801.8552405555555,
          "2026-03-11": 219.0429861111111,
          "2026-03-17": 764.1287994444444,
          "2026-03-18": 1.9061102777777779,
          "2026-03-20": 1100.0175944444445,
          "2026-03-24": 0.9662138888888889,
          "2026-03-25": 505.62327361111113,
          "2026-04-02": 26.19088888888889,
          "2026-04-09": 333.6743813888889,
          "2026-04-13": 1.8456511111111111,
          "2026-04-14": 193.68424694444442,
          "2026-04-16": 2120.5085436111112,
          "2026-04-24": 1.8369030555555554,
          "2026-04-27": 2.665758888888889,
          "2026-05-02": 52.05325194444444,
          "2026-05-04": 8.377608333333333,
          "2026-05-05": 319.67713249999997,
          "2026-05-08": 545.9520041666667,
          "2026-05-20": 25.107761111111113
        },
        "time_count_per_day": {
          "2025-09-30": 2,
          "2025-10-09": 1,
          "2025-10-14": 1,
          "2025-10-15": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-28": 1,
          "2025-10-30": 1,
          "2025-11-03": 2,
          "2025-11-04": 3,
          "2025-11-06": 2,
          "2025-11-07": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-17": 4,
          "2025-11-22": 1,
          "2025-12-02": 1,
          "2025-12-05": 1,
          "2025-12-12": 2,
          "2025-12-24": 1,
          "2026-01-05": 1,
          "2026-01-08": 3,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-06": 1,
          "2026-02-07": 2,
          "2026-02-12": 1,
          "2026-02-14": 2,
          "2026-02-16": 3,
          "2026-02-18": 3,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-02": 2,
          "2026-03-03": 1,
          "2026-03-04": 2,
          "2026-03-07": 1,
          "2026-03-10": 3,
          "2026-03-11": 2,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-20": 2,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-04-02": 2,
          "2026-04-09": 2,
          "2026-04-13": 1,
          "2026-04-14": 2,
          "2026-04-16": 3,
          "2026-04-24": 1,
          "2026-04-27": 2,
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 78.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "10-12h": 1,
            "222-224h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-07": 1,
            "2026-02-18": 1,
            "2026-02-25": 1
          },
          "time_per_day": {
            "2025-11-07": 1.8481505555555555,
            "2026-02-18": 222.44924722222223,
            "2026-02-25": 10.08637388888889
          },
          "time_count_per_day": {
            "2025-11-07": 1,
            "2026-02-18": 1,
            "2026-02-25": 1
          }
        },
        "P2": {
          "avg_time_hours": 159.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 3,
            "4-6h": 4,
            "6-8h": 8,
            "8-10h": 4,
            "10-12h": 1,
            "14-16h": 1,
            "18-20h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "32-34h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "52-54h": 2,
            "54-56h": 1,
            "62-64h": 1,
            "64-66h": 1,
            "68-70h": 1,
            "70-72h": 2,
            "72-74h": 1,
            "74-76h": 1,
            "80-82h": 1,
            "126-128h": 1,
            "164-166h": 1,
            "166-168h": 3,
            "168-170h": 1,
            "194-196h": 1,
            "218-220h": 1,
            "230-232h": 1,
            "236-238h": 1,
            "242-244h": 1,
            "260-262h": 1,
            "292-294h": 1,
            "318-320h": 1,
            "432-434h": 1,
            "502-504h": 1,
            "544-546h": 1,
            "650-652h": 1,
            "764-766h": 1,
            "838-840h": 1,
            "968-970h": 1,
            "1086-1088h": 1,
            "1762-1764h": 1
          },
          "tickets_count": 79,
          "tickets_per_day": {
            "2025-09-30": 2,
            "2025-10-15": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-10-28": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-04": 3,
            "2025-11-06": 2,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-12-01": 1,
            "2025-12-05": 1,
            "2025-12-12": 1,
            "2025-12-24": 1,
            "2026-01-05": 1,
            "2026-01-08": 3,
            "2026-01-09": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-02-16": 2,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 2,
            "2026-03-07": 1,
            "2026-03-10": 2,
            "2026-03-11": 2,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 2,
            "2026-03-25": 2,
            "2026-04-02": 2,
            "2026-04-09": 2,
            "2026-04-13": 1,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 3,
            "2026-04-24": 1,
            "2026-04-27": 2,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2025-09-30": 0.5455091666666667,
            "2025-10-15": 293.80307055555556,
            "2025-10-20": 5.537886666666666,
            "2025-10-22": 49.655495,
            "2025-10-28": 164.24522416666667,
            "2025-10-30": 22.481259722222223,
            "2025-11-03": 8.549813611111112,
            "2025-11-04": 22.239098055555555,
            "2025-11-06": 235.66958166666666,
            "2025-11-10": 47.3464575,
            "2025-11-11": 126.80880111111111,
            "2025-11-12": 54.78884722222222,
            "2025-11-13": 219.3726047222222,
            "2025-11-17": 69.97478722222222,
            "2025-11-22": 651.6799255555555,
            "2025-12-05": 0.29595666666666665,
            "2025-12-12": 432.8933527777778,
            "2025-12-24": 0.05460527777777778,
            "2026-01-05": 52.061346111111106,
            "2026-01-08": 11.784155833333333,
            "2026-01-09": 2.9478863888888887,
            "2026-01-14": 19.137159999999998,
            "2026-01-17": 236.71868638888887,
            "2026-01-19": 243.61434277777778,
            "2026-02-03": 80.5726763888889,
            "2026-02-04": 6.104761944444444,
            "2026-02-06": 2.0799527777777778,
            "2026-02-12": 1763.7845513888888,
            "2026-02-16": 81.16106027777778,
            "2026-02-18": 9.21238638888889,
            "2026-02-21": 194.2587313888889,
            "2026-02-23": 73.4800388888889,
            "2026-03-02": 11.885685833333334,
            "2026-03-03": 32.71425527777778,
            "2026-03-04": 16.0058875,
            "2026-03-07": 62.877425555555554,
            "2026-03-10": 143.3396763888889,
            "2026-03-11": 219.0429861111111,
            "2026-03-17": 764.1287994444444,
            "2026-03-18": 1.9061102777777779,
            "2026-03-20": 1100.0175944444445,
            "2026-03-25": 505.62327361111113,
            "2026-04-02": 26.19088888888889,
            "2026-04-09": 333.6743813888889,
            "2026-04-13": 1.8456511111111111,
            "2026-04-14": 193.68424694444442,
            "2026-04-16": 2120.5085436111112,
            "2026-04-24": 1.8369030555555554,
            "2026-04-27": 2.665758888888889,
            "2026-05-02": 52.05325194444444,
            "2026-05-04": 8.377608333333333,
            "2026-05-05": 319.67713249999997,
            "2026-05-08": 545.9520041666667,
            "2026-05-20": 25.107761111111113
          },
          "time_count_per_day": {
            "2025-09-30": 2,
            "2025-10-15": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-10-28": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-04": 3,
            "2025-11-06": 2,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-12-05": 1,
            "2025-12-12": 1,
            "2025-12-24": 1,
            "2026-01-05": 1,
            "2026-01-08": 3,
            "2026-01-09": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-02-16": 2,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 2,
            "2026-03-07": 1,
            "2026-03-10": 2,
            "2026-03-11": 2,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 2,
            "2026-03-25": 2,
            "2026-04-02": 2,
            "2026-04-09": 2,
            "2026-04-13": 1,
            "2026-04-14": 2,
            "2026-04-16": 3,
            "2026-04-24": 1,
            "2026-04-27": 2,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 134.92,
          "mode_time_hours": 101.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "46-48h": 1,
            "62-64h": 1,
            "82-84h": 1,
            "84-86h": 1,
            "98-100h": 1,
            "100-102h": 3,
            "102-104h": 1,
            "104-106h": 1,
            "116-118h": 1,
            "142-144h": 1,
            "210-212h": 1,
            "268-270h": 1,
            "272-274h": 1,
            "338-340h": 1,
            "658-660h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-10-14": 1,
            "2025-11-03": 1,
            "2025-11-17": 3,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2026-01-15": 2,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-27": 2,
            "2026-02-05": 1,
            "2026-02-07": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-03-10": 1
          },
          "time_per_day": {
            "2025-10-09": 210.85269416666668,
            "2025-10-14": 272.44976916666667,
            "2025-11-03": 1.5892016666666666,
            "2025-11-17": 301.698845,
            "2025-12-02": 102.25535944444444,
            "2025-12-12": 339.22209666666663,
            "2026-01-15": 226.9019961111111,
            "2026-01-19": 82.5561563888889,
            "2026-01-23": 268.63819333333333,
            "2026-01-27": 34.941559999999996,
            "2026-02-05": 62.77694527777778,
            "2026-02-07": 67.86198138888889,
            "2026-02-14": 135.5570713888889,
            "2026-02-16": 104.06392611111112,
            "2026-02-18": 98.4215511111111,
            "2026-03-10": 658.5155641666666
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-10-14": 1,
            "2025-11-03": 1,
            "2025-11-17": 3,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2026-01-15": 2,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-27": 2,
            "2026-02-05": 1,
            "2026-02-07": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-03-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 9.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "28-30h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-03-24": 2
          },
          "time_per_day": {
            "2026-02-03": 29.00065138888889,
            "2026-03-24": 0.9662138888888889
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-03-24": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 147.57,
            "mode_time_hours": 1.0,
            "mode_frequency": 14,
            "time_distribution": {
              "0-2h": 14,
              "2-4h": 3,
              "4-6h": 4,
              "6-8h": 8,
              "8-10h": 5,
              "10-12h": 2,
              "14-16h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 3,
              "28-30h": 1,
              "32-34h": 1,
              "46-48h": 2,
              "48-50h": 1,
              "50-52h": 1,
              "52-54h": 2,
              "54-56h": 1,
              "62-64h": 2,
              "64-66h": 1,
              "68-70h": 1,
              "70-72h": 2,
              "72-74h": 1,
              "74-76h": 1,
              "80-82h": 1,
              "82-84h": 1,
              "84-86h": 1,
              "98-100h": 1,
              "100-102h": 3,
              "102-104h": 1,
              "104-106h": 1,
              "116-118h": 1,
              "126-128h": 1,
              "142-144h": 1,
              "164-166h": 1,
              "166-168h": 3,
              "168-170h": 1,
              "194-196h": 1,
              "210-212h": 1,
              "218-220h": 1,
              "222-224h": 1,
              "230-232h": 1,
              "236-238h": 1,
              "242-244h": 1,
              "260-262h": 1,
              "268-270h": 1,
              "272-274h": 1,
              "292-294h": 1,
              "318-320h": 1,
              "338-340h": 1,
              "432-434h": 1,
              "502-504h": 1,
              "544-546h": 1,
              "650-652h": 1,
              "658-660h": 1,
              "764-766h": 1,
              "838-840h": 1,
              "968-970h": 1,
              "1086-1088h": 1,
              "1762-1764h": 1
            },
            "tickets_count": 101,
            "tickets_per_day": {
              "2025-09-30": 2,
              "2025-10-09": 1,
              "2025-10-14": 1,
              "2025-10-15": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-28": 1,
              "2025-10-30": 1,
              "2025-11-03": 2,
              "2025-11-04": 3,
              "2025-11-06": 2,
              "2025-11-07": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-17": 4,
              "2025-11-22": 1,
              "2025-12-02": 1,
              "2025-12-05": 1,
              "2025-12-12": 2,
              "2025-12-24": 1,
              "2026-01-05": 1,
              "2026-01-08": 3,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-06": 1,
              "2026-02-07": 2,
              "2026-02-12": 1,
              "2026-02-14": 2,
              "2026-02-16": 3,
              "2026-02-18": 3,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-02": 2,
              "2026-03-03": 1,
              "2026-03-04": 2,
              "2026-03-07": 1,
              "2026-03-10": 3,
              "2026-03-11": 2,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-20": 2,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-04-02": 2,
              "2026-04-09": 2,
              "2026-04-13": 1,
              "2026-04-14": 2,
              "2026-04-16": 3,
              "2026-04-24": 1,
              "2026-04-27": 2,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-20": 1
            },
            "time_per_day": {
              "2025-09-30": 0.5455091666666667,
              "2025-10-09": 210.85269416666668,
              "2025-10-14": 272.44976916666667,
              "2025-10-15": 293.80307055555556,
              "2025-10-20": 5.537886666666666,
              "2025-10-22": 49.655495,
              "2025-10-28": 164.24522416666667,
              "2025-10-30": 22.481259722222223,
              "2025-11-03": 10.139015277777778,
              "2025-11-04": 22.239098055555555,
              "2025-11-06": 235.66958166666666,
              "2025-11-07": 1.8481505555555555,
              "2025-11-10": 47.3464575,
              "2025-11-11": 126.80880111111111,
              "2025-11-12": 54.78884722222222,
              "2025-11-13": 219.3726047222222,
              "2025-11-17": 371.67363222222224,
              "2025-11-22": 651.6799255555555,
              "2025-12-02": 102.25535944444444,
              "2025-12-05": 0.29595666666666665,
              "2025-12-12": 772.1154494444445,
              "2025-12-24": 0.05460527777777778,
              "2026-01-05": 52.061346111111106,
              "2026-01-08": 11.784155833333333,
              "2026-01-09": 2.9478863888888887,
              "2026-01-14": 19.137159999999998,
              "2026-01-15": 226.9019961111111,
              "2026-01-17": 236.71868638888887,
              "2026-01-19": 326.1704991666667,
              "2026-01-23": 268.63819333333333,
              "2026-01-27": 34.941559999999996,
              "2026-02-03": 109.57332777777779,
              "2026-02-04": 6.104761944444444,
              "2026-02-05": 62.77694527777778,
              "2026-02-06": 2.0799527777777778,
              "2026-02-07": 67.86198138888889,
              "2026-02-12": 1763.7845513888888,
              "2026-02-14": 135.5570713888889,
              "2026-02-16": 185.22498638888888,
              "2026-02-18": 330.0831847222222,
              "2026-02-21": 194.2587313888889,
              "2026-02-23": 73.4800388888889,
              "2026-02-25": 10.08637388888889,
              "2026-03-02": 11.885685833333334,
              "2026-03-03": 32.71425527777778,
              "2026-03-04": 16.0058875,
              "2026-03-07": 62.877425555555554,
              "2026-03-10": 801.8552405555555,
              "2026-03-11": 219.0429861111111,
              "2026-03-17": 764.1287994444444,
              "2026-03-18": 1.9061102777777779,
              "2026-03-20": 1100.0175944444445,
              "2026-03-24": 0.9662138888888889,
              "2026-03-25": 505.62327361111113,
              "2026-04-02": 26.19088888888889,
              "2026-04-09": 333.6743813888889,
              "2026-04-13": 1.8456511111111111,
              "2026-04-14": 193.68424694444442,
              "2026-04-16": 2120.5085436111112,
              "2026-04-24": 1.8369030555555554,
              "2026-04-27": 2.665758888888889,
              "2026-05-02": 52.05325194444444,
              "2026-05-04": 8.377608333333333,
              "2026-05-05": 319.67713249999997,
              "2026-05-08": 545.9520041666667,
              "2026-05-20": 25.107761111111113
            },
            "time_count_per_day": {
              "2025-09-30": 2,
              "2025-10-09": 1,
              "2025-10-14": 1,
              "2025-10-15": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-28": 1,
              "2025-10-30": 1,
              "2025-11-03": 2,
              "2025-11-04": 3,
              "2025-11-06": 2,
              "2025-11-07": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-17": 4,
              "2025-11-22": 1,
              "2025-12-02": 1,
              "2025-12-05": 1,
              "2025-12-12": 2,
              "2025-12-24": 1,
              "2026-01-05": 1,
              "2026-01-08": 3,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-06": 1,
              "2026-02-07": 2,
              "2026-02-12": 1,
              "2026-02-14": 2,
              "2026-02-16": 3,
              "2026-02-18": 3,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-02": 2,
              "2026-03-03": 1,
              "2026-03-04": 2,
              "2026-03-07": 1,
              "2026-03-10": 3,
              "2026-03-11": 2,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-20": 2,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-04-02": 2,
              "2026-04-09": 2,
              "2026-04-13": 1,
              "2026-04-14": 2,
              "2026-04-16": 3,
              "2026-04-24": 1,
              "2026-04-27": 2,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-20": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 78.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "10-12h": 1,
                "222-224h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-07": 1,
                "2026-02-18": 1,
                "2026-02-25": 1
              },
              "time_per_day": {
                "2025-11-07": 1.8481505555555555,
                "2026-02-18": 222.44924722222223,
                "2026-02-25": 10.08637388888889
              },
              "time_count_per_day": {
                "2025-11-07": 1,
                "2026-02-18": 1,
                "2026-02-25": 1
              }
            },
            "P2": {
              "avg_time_hours": 159.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 3,
                "4-6h": 4,
                "6-8h": 8,
                "8-10h": 4,
                "10-12h": 1,
                "14-16h": 1,
                "18-20h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "32-34h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "52-54h": 2,
                "54-56h": 1,
                "62-64h": 1,
                "64-66h": 1,
                "68-70h": 1,
                "70-72h": 2,
                "72-74h": 1,
                "74-76h": 1,
                "80-82h": 1,
                "126-128h": 1,
                "164-166h": 1,
                "166-168h": 3,
                "168-170h": 1,
                "194-196h": 1,
                "218-220h": 1,
                "230-232h": 1,
                "236-238h": 1,
                "242-244h": 1,
                "260-262h": 1,
                "292-294h": 1,
                "318-320h": 1,
                "432-434h": 1,
                "502-504h": 1,
                "544-546h": 1,
                "650-652h": 1,
                "764-766h": 1,
                "838-840h": 1,
                "968-970h": 1,
                "1086-1088h": 1,
                "1762-1764h": 1
              },
              "tickets_count": 73,
              "tickets_per_day": {
                "2025-09-30": 2,
                "2025-10-15": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-10-28": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-04": 3,
                "2025-11-06": 2,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-12-05": 1,
                "2025-12-12": 1,
                "2025-12-24": 1,
                "2026-01-05": 1,
                "2026-01-08": 3,
                "2026-01-09": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-02-16": 2,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 2,
                "2026-03-07": 1,
                "2026-03-10": 2,
                "2026-03-11": 2,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 2,
                "2026-03-25": 2,
                "2026-04-02": 2,
                "2026-04-09": 2,
                "2026-04-13": 1,
                "2026-04-14": 2,
                "2026-04-16": 3,
                "2026-04-24": 1,
                "2026-04-27": 2,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2025-09-30": 0.5455091666666667,
                "2025-10-15": 293.80307055555556,
                "2025-10-20": 5.537886666666666,
                "2025-10-22": 49.655495,
                "2025-10-28": 164.24522416666667,
                "2025-10-30": 22.481259722222223,
                "2025-11-03": 8.549813611111112,
                "2025-11-04": 22.239098055555555,
                "2025-11-06": 235.66958166666666,
                "2025-11-10": 47.3464575,
                "2025-11-11": 126.80880111111111,
                "2025-11-12": 54.78884722222222,
                "2025-11-13": 219.3726047222222,
                "2025-11-17": 69.97478722222222,
                "2025-11-22": 651.6799255555555,
                "2025-12-05": 0.29595666666666665,
                "2025-12-12": 432.8933527777778,
                "2025-12-24": 0.05460527777777778,
                "2026-01-05": 52.061346111111106,
                "2026-01-08": 11.784155833333333,
                "2026-01-09": 2.9478863888888887,
                "2026-01-14": 19.137159999999998,
                "2026-01-17": 236.71868638888887,
                "2026-01-19": 243.61434277777778,
                "2026-02-03": 80.5726763888889,
                "2026-02-04": 6.104761944444444,
                "2026-02-06": 2.0799527777777778,
                "2026-02-12": 1763.7845513888888,
                "2026-02-16": 81.16106027777778,
                "2026-02-18": 9.21238638888889,
                "2026-02-21": 194.2587313888889,
                "2026-02-23": 73.4800388888889,
                "2026-03-02": 11.885685833333334,
                "2026-03-03": 32.71425527777778,
                "2026-03-04": 16.0058875,
                "2026-03-07": 62.877425555555554,
                "2026-03-10": 143.3396763888889,
                "2026-03-11": 219.0429861111111,
                "2026-03-17": 764.1287994444444,
                "2026-03-18": 1.9061102777777779,
                "2026-03-20": 1100.0175944444445,
                "2026-03-25": 505.62327361111113,
                "2026-04-02": 26.19088888888889,
                "2026-04-09": 333.6743813888889,
                "2026-04-13": 1.8456511111111111,
                "2026-04-14": 193.68424694444442,
                "2026-04-16": 2120.5085436111112,
                "2026-04-24": 1.8369030555555554,
                "2026-04-27": 2.665758888888889,
                "2026-05-02": 52.05325194444444,
                "2026-05-04": 8.377608333333333,
                "2026-05-05": 319.67713249999997,
                "2026-05-08": 545.9520041666667,
                "2026-05-20": 25.107761111111113
              },
              "time_count_per_day": {
                "2025-09-30": 2,
                "2025-10-15": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-10-28": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-04": 3,
                "2025-11-06": 2,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-12-05": 1,
                "2025-12-12": 1,
                "2025-12-24": 1,
                "2026-01-05": 1,
                "2026-01-08": 3,
                "2026-01-09": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-02-16": 2,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 2,
                "2026-03-07": 1,
                "2026-03-10": 2,
                "2026-03-11": 2,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 2,
                "2026-03-25": 2,
                "2026-04-02": 2,
                "2026-04-09": 2,
                "2026-04-13": 1,
                "2026-04-14": 2,
                "2026-04-16": 3,
                "2026-04-24": 1,
                "2026-04-27": 2,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 134.92,
              "mode_time_hours": 101.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "46-48h": 1,
                "62-64h": 1,
                "82-84h": 1,
                "84-86h": 1,
                "98-100h": 1,
                "100-102h": 3,
                "102-104h": 1,
                "104-106h": 1,
                "116-118h": 1,
                "142-144h": 1,
                "210-212h": 1,
                "268-270h": 1,
                "272-274h": 1,
                "338-340h": 1,
                "658-660h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-10-14": 1,
                "2025-11-03": 1,
                "2025-11-17": 3,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2026-01-15": 2,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-27": 2,
                "2026-02-05": 1,
                "2026-02-07": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-03-10": 1
              },
              "time_per_day": {
                "2025-10-09": 210.85269416666668,
                "2025-10-14": 272.44976916666667,
                "2025-11-03": 1.5892016666666666,
                "2025-11-17": 301.698845,
                "2025-12-02": 102.25535944444444,
                "2025-12-12": 339.22209666666663,
                "2026-01-15": 226.9019961111111,
                "2026-01-19": 82.5561563888889,
                "2026-01-23": 268.63819333333333,
                "2026-01-27": 34.941559999999996,
                "2026-02-05": 62.77694527777778,
                "2026-02-07": 67.86198138888889,
                "2026-02-14": 135.5570713888889,
                "2026-02-16": 104.06392611111112,
                "2026-02-18": 98.4215511111111,
                "2026-03-10": 658.5155641666666
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-10-14": 1,
                "2025-11-03": 1,
                "2025-11-17": 3,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2026-01-15": 2,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-27": 2,
                "2026-02-05": 1,
                "2026-02-07": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-03-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 9.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "28-30h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-03-24": 2
              },
              "time_per_day": {
                "2026-02-03": 29.00065138888889,
                "2026-03-24": 0.9662138888888889
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-03-24": 2
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-15": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-15": 1,
              "2026-05-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-15": 1,
                "2026-05-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_70": {
      "overall": {
        "avg_time_hours": 451.26,
        "mode_time_hours": 337.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "28-30h": 1,
          "196-198h": 1,
          "248-250h": 1,
          "268-270h": 1,
          "336-338h": 1,
          "576-578h": 1,
          "698-700h": 1,
          "706-708h": 1,
          "722-724h": 1,
          "792-794h": 1,
          "824-826h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-10-30": 1,
          "2025-11-03": 1,
          "2025-11-06": 1,
          "2025-11-12": 2,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2026-01-20": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-10-14": 336.5701716666667,
          "2025-10-30": 28.537358055555558,
          "2025-11-03": 577.6734183333334,
          "2025-11-06": 248.9583011111111,
          "2025-11-12": 1492.7311502777777,
          "2025-11-13": 824.1808294444445,
          "2025-11-19": 723.176596111111,
          "2026-01-20": 9.942506944444444,
          "2026-02-04": 197.68830388888887,
          "2026-02-10": 269.54452833333335,
          "2026-02-12": 706.1698025
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-10-30": 1,
          "2025-11-03": 1,
          "2025-11-06": 1,
          "2025-11-12": 2,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2026-01-20": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 451.79,
          "mode_time_hours": 337.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "28-30h": 1,
            "248-250h": 1,
            "268-270h": 1,
            "336-338h": 1,
            "576-578h": 1,
            "706-708h": 1,
            "722-724h": 1,
            "792-794h": 1,
            "824-826h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-06": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-19": 1,
            "2026-01-20": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-14": 336.5701716666667,
            "2025-10-30": 28.537358055555558,
            "2025-11-03": 577.6734183333334,
            "2025-11-06": 248.9583011111111,
            "2025-11-12": 793.1485297222222,
            "2025-11-13": 824.1808294444445,
            "2025-11-19": 723.176596111111,
            "2026-01-20": 9.942506944444444,
            "2026-02-10": 269.54452833333335,
            "2026-02-12": 706.1698025
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-06": 1,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-19": 1,
            "2026-01-20": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 448.64,
          "mode_time_hours": 699.0,
          "mode_frequency": 1,
          "time_distribution": {
            "196-198h": 1,
            "698-700h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2026-02-04": 1
          },
          "time_per_day": {
            "2025-11-12": 699.5826205555555,
            "2026-02-04": 197.68830388888887
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 451.26,
            "mode_time_hours": 337.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "28-30h": 1,
              "196-198h": 1,
              "248-250h": 1,
              "268-270h": 1,
              "336-338h": 1,
              "576-578h": 1,
              "698-700h": 1,
              "706-708h": 1,
              "722-724h": 1,
              "792-794h": 1,
              "824-826h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-10-30": 1,
              "2025-11-03": 1,
              "2025-11-06": 1,
              "2025-11-12": 2,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2026-01-20": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-10-14": 336.5701716666667,
              "2025-10-30": 28.537358055555558,
              "2025-11-03": 577.6734183333334,
              "2025-11-06": 248.9583011111111,
              "2025-11-12": 1492.7311502777777,
              "2025-11-13": 824.1808294444445,
              "2025-11-19": 723.176596111111,
              "2026-01-20": 9.942506944444444,
              "2026-02-04": 197.68830388888887,
              "2026-02-10": 269.54452833333335,
              "2026-02-12": 706.1698025
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-10-30": 1,
              "2025-11-03": 1,
              "2025-11-06": 1,
              "2025-11-12": 2,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2026-01-20": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 451.79,
              "mode_time_hours": 337.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "28-30h": 1,
                "248-250h": 1,
                "268-270h": 1,
                "336-338h": 1,
                "576-578h": 1,
                "706-708h": 1,
                "722-724h": 1,
                "792-794h": 1,
                "824-826h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-06": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-19": 1,
                "2026-01-20": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-14": 336.5701716666667,
                "2025-10-30": 28.537358055555558,
                "2025-11-03": 577.6734183333334,
                "2025-11-06": 248.9583011111111,
                "2025-11-12": 793.1485297222222,
                "2025-11-13": 824.1808294444445,
                "2025-11-19": 723.176596111111,
                "2026-01-20": 9.942506944444444,
                "2026-02-10": 269.54452833333335,
                "2026-02-12": 706.1698025
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-06": 1,
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-19": 1,
                "2026-01-20": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 448.64,
              "mode_time_hours": 699.0,
              "mode_frequency": 1,
              "time_distribution": {
                "196-198h": 1,
                "698-700h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2026-02-04": 1
              },
              "time_per_day": {
                "2025-11-12": 699.5826205555555,
                "2026-02-04": 197.68830388888887
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_72": {
      "overall": {
        "avg_time_hours": 167.66,
        "mode_time_hours": 167.0,
        "mode_frequency": 1,
        "time_distribution": {
          "166-168h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-07": 1
        },
        "time_per_day": {
          "2025-10-07": 167.65555083333334
        },
        "time_count_per_day": {
          "2025-10-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 167.66,
          "mode_time_hours": 167.0,
          "mode_frequency": 1,
          "time_distribution": {
            "166-168h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-07": 1
          },
          "time_per_day": {
            "2025-10-07": 167.65555083333334
          },
          "time_count_per_day": {
            "2025-10-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 167.66,
            "mode_time_hours": 167.0,
            "mode_frequency": 1,
            "time_distribution": {
              "166-168h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-07": 1
            },
            "time_per_day": {
              "2025-10-07": 167.65555083333334
            },
            "time_count_per_day": {
              "2025-10-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 167.66,
              "mode_time_hours": 167.0,
              "mode_frequency": 1,
              "time_distribution": {
                "166-168h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-07": 1
              },
              "time_per_day": {
                "2025-10-07": 167.65555083333334
              },
              "time_count_per_day": {
                "2025-10-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_73": {
      "overall": {
        "avg_time_hours": 1270.68,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1,
          "2524-2526h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2026-02-19": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2025-10-01": 16.673143333333332,
          "2026-02-19": 2524.689726944445
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": 1270.68,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "2524-2526h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-10-01": 16.673143333333332,
            "2026-02-19": 2524.689726944445
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1270.68,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1,
              "2524-2526h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2025-10-01": 16.673143333333332,
              "2026-02-19": 2524.689726944445
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1270.68,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "2524-2526h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-10-01": 16.673143333333332,
                "2026-02-19": 2524.689726944445
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_74": {
      "overall": {
        "avg_time_hours": 553.47,
        "mode_time_hours": 815.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "306-308h": 1,
          "388-390h": 1,
          "498-500h": 1,
          "670-672h": 1,
          "814-816h": 1,
          "1162-1164h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-03": 1,
          "2025-12-04": 1,
          "2026-01-13": 1,
          "2026-02-05": 1,
          "2026-02-12": 1,
          "2026-03-13": 1,
          "2026-03-20": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-11-03": 815.4608338888888,
          "2025-12-04": 307.1368988888889,
          "2026-01-13": 498.09940944444446,
          "2026-02-05": 28.588201944444446,
          "2026-02-12": 1163.5112366666667,
          "2026-03-13": 671.9127438888889,
          "2026-03-20": 389.58063583333336
        },
        "time_count_per_day": {
          "2025-11-03": 1,
          "2025-12-04": 1,
          "2026-01-13": 1,
          "2026-02-05": 1,
          "2026-02-12": 1,
          "2026-03-13": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 671.91,
          "mode_time_hours": 671.0,
          "mode_frequency": 1,
          "time_distribution": {
            "670-672h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-13": 1
          },
          "time_per_day": {
            "2026-03-13": 671.9127438888889
          },
          "time_count_per_day": {
            "2026-03-13": 1
          }
        },
        "P2": {
          "avg_time_hours": 407.77,
          "mode_time_hours": 815.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1,
            "306-308h": 1,
            "388-390h": 1,
            "498-500h": 1,
            "814-816h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2025-12-04": 1,
            "2026-01-13": 1,
            "2026-02-05": 1,
            "2026-03-20": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-11-03": 815.4608338888888,
            "2025-12-04": 307.1368988888889,
            "2026-01-13": 498.09940944444446,
            "2026-02-05": 28.588201944444446,
            "2026-03-20": 389.58063583333336
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2025-12-04": 1,
            "2026-01-13": 1,
            "2026-02-05": 1,
            "2026-03-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 1163.51,
          "mode_time_hours": 1163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1162-1164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 1163.5112366666667
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 553.47,
            "mode_time_hours": 815.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "306-308h": 1,
              "388-390h": 1,
              "498-500h": 1,
              "670-672h": 1,
              "814-816h": 1,
              "1162-1164h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-03": 1,
              "2025-12-04": 1,
              "2026-01-13": 1,
              "2026-02-05": 1,
              "2026-02-12": 1,
              "2026-03-13": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2025-11-03": 815.4608338888888,
              "2025-12-04": 307.1368988888889,
              "2026-01-13": 498.09940944444446,
              "2026-02-05": 28.588201944444446,
              "2026-02-12": 1163.5112366666667,
              "2026-03-13": 671.9127438888889,
              "2026-03-20": 389.58063583333336
            },
            "time_count_per_day": {
              "2025-11-03": 1,
              "2025-12-04": 1,
              "2026-01-13": 1,
              "2026-02-05": 1,
              "2026-02-12": 1,
              "2026-03-13": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 671.91,
              "mode_time_hours": 671.0,
              "mode_frequency": 1,
              "time_distribution": {
                "670-672h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-13": 1
              },
              "time_per_day": {
                "2026-03-13": 671.9127438888889
              },
              "time_count_per_day": {
                "2026-03-13": 1
              }
            },
            "P2": {
              "avg_time_hours": 407.77,
              "mode_time_hours": 815.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1,
                "306-308h": 1,
                "388-390h": 1,
                "498-500h": 1,
                "814-816h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2025-12-04": 1,
                "2026-01-13": 1,
                "2026-02-05": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2025-11-03": 815.4608338888888,
                "2025-12-04": 307.1368988888889,
                "2026-01-13": 498.09940944444446,
                "2026-02-05": 28.588201944444446,
                "2026-03-20": 389.58063583333336
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2025-12-04": 1,
                "2026-01-13": 1,
                "2026-02-05": 1,
                "2026-03-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 1163.51,
              "mode_time_hours": 1163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1162-1164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 1163.5112366666667
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_59": {
      "overall": {
        "avg_time_hours": 62.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "2-4h": 1,
          "10-12h": 1,
          "30-32h": 1,
          "66-68h": 1,
          "104-106h": 1,
          "110-112h": 1,
          "116-118h": 1,
          "124-126h": 1,
          "146-148h": 1,
          "168-170h": 1,
          "174-176h": 1,
          "304-306h": 1,
          "376-378h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-09": 1,
          "2025-10-22": 1,
          "2025-10-24": 1,
          "2025-11-04": 1,
          "2025-11-14": 2,
          "2025-11-17": 1,
          "2026-02-16": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-05-06": 1,
          "2026-05-07": 3,
          "2026-05-11": 1,
          "2026-05-12": 2,
          "2026-05-17": 1,
          "2026-05-20": 1,
          "2026-05-22": 1,
          "2026-05-26": 5,
          "2026-06-01": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-09-30": 0.013664444444444444,
          "2025-10-09": 0.2644111111111111,
          "2025-10-22": 0.08416194444444444,
          "2025-10-24": 1.2182897222222222,
          "2025-11-04": 146.03480694444445,
          "2025-11-14": 107.29036944444445,
          "2025-11-17": 0.6696325000000001,
          "2026-02-16": 235.83171888888887,
          "2026-03-09": 66.39208888888889,
          "2026-03-10": 169.0349475,
          "2026-04-13": 116.58446944444445,
          "2026-04-15": 174.6344527777778,
          "2026-05-06": 377.86333138888887,
          "2026-05-07": 305.2398413888889,
          "2026-05-11": 1.252471111111111,
          "2026-05-12": 11.303565,
          "2026-05-17": 0.01920222222222222,
          "2026-05-20": 0.017478055555555556,
          "2026-05-22": 31.21249027777778,
          "2026-05-26": 2.6471625,
          "2026-06-02": 1.0518277777777778
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-09": 1,
          "2025-10-22": 1,
          "2025-10-24": 1,
          "2025-11-04": 1,
          "2025-11-14": 2,
          "2025-11-17": 1,
          "2026-02-16": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-05-06": 1,
          "2026-05-07": 3,
          "2026-05-11": 1,
          "2026-05-12": 2,
          "2026-05-17": 1,
          "2026-05-20": 1,
          "2026-05-22": 1,
          "2026-05-26": 3,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 225.47,
          "mode_time_hours": 147.0,
          "mode_frequency": 1,
          "time_distribution": {
            "146-148h": 1,
            "304-306h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2026-05-07": 1
          },
          "time_per_day": {
            "2025-11-04": 146.03480694444445,
            "2026-05-07": 304.9134616666667
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2026-05-07": 1
          }
        },
        "P2": {
          "avg_time_hours": 51.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 14,
          "time_distribution": {
            "0-2h": 14,
            "2-4h": 1,
            "10-12h": 1,
            "30-32h": 1,
            "66-68h": 1,
            "104-106h": 1,
            "110-112h": 1,
            "116-118h": 1,
            "124-126h": 1,
            "168-170h": 1,
            "174-176h": 1,
            "376-378h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-09": 1,
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-11-14": 1,
            "2025-11-17": 1,
            "2026-02-16": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-05-06": 1,
            "2026-05-07": 2,
            "2026-05-11": 1,
            "2026-05-12": 2,
            "2026-05-17": 1,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-26": 5,
            "2026-06-01": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-09-30": 0.013664444444444444,
            "2025-10-09": 0.2644111111111111,
            "2025-10-22": 0.08416194444444444,
            "2025-10-24": 1.2182897222222222,
            "2025-11-14": 105.80550083333334,
            "2025-11-17": 0.6696325000000001,
            "2026-02-16": 235.83171888888887,
            "2026-03-09": 66.39208888888889,
            "2026-03-10": 169.0349475,
            "2026-04-13": 116.58446944444445,
            "2026-04-15": 174.6344527777778,
            "2026-05-06": 377.86333138888887,
            "2026-05-07": 0.3263797222222222,
            "2026-05-11": 1.252471111111111,
            "2026-05-12": 11.303565,
            "2026-05-17": 0.01920222222222222,
            "2026-05-20": 0.017478055555555556,
            "2026-05-22": 31.21249027777778,
            "2026-05-26": 2.6471625,
            "2026-06-02": 1.0518277777777778
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2025-10-09": 1,
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-11-14": 1,
            "2025-11-17": 1,
            "2026-02-16": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-05-06": 1,
            "2026-05-07": 2,
            "2026-05-11": 1,
            "2026-05-12": 2,
            "2026-05-17": 1,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-26": 3,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 1.48,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 1.4848686111111111
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 62.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "2-4h": 1,
              "10-12h": 1,
              "30-32h": 1,
              "66-68h": 1,
              "104-106h": 1,
              "110-112h": 1,
              "116-118h": 1,
              "124-126h": 1,
              "146-148h": 1,
              "168-170h": 1,
              "174-176h": 1,
              "304-306h": 1,
              "376-378h": 1
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-09": 1,
              "2025-10-22": 1,
              "2025-10-24": 1,
              "2025-11-04": 1,
              "2025-11-14": 2,
              "2025-11-17": 1,
              "2026-02-16": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-05-06": 1,
              "2026-05-07": 3,
              "2026-05-11": 1,
              "2026-05-12": 2,
              "2026-05-17": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-26": 3,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-09-30": 0.013664444444444444,
              "2025-10-09": 0.2644111111111111,
              "2025-10-22": 0.08416194444444444,
              "2025-10-24": 1.2182897222222222,
              "2025-11-04": 146.03480694444445,
              "2025-11-14": 107.29036944444445,
              "2025-11-17": 0.6696325000000001,
              "2026-02-16": 235.83171888888887,
              "2026-03-09": 66.39208888888889,
              "2026-03-10": 169.0349475,
              "2026-04-13": 116.58446944444445,
              "2026-04-15": 174.6344527777778,
              "2026-05-06": 377.86333138888887,
              "2026-05-07": 305.2398413888889,
              "2026-05-11": 1.252471111111111,
              "2026-05-12": 11.303565,
              "2026-05-17": 0.01920222222222222,
              "2026-05-20": 0.017478055555555556,
              "2026-05-22": 31.21249027777778,
              "2026-05-26": 2.6471625,
              "2026-06-02": 1.0518277777777778
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-09": 1,
              "2025-10-22": 1,
              "2025-10-24": 1,
              "2025-11-04": 1,
              "2025-11-14": 2,
              "2025-11-17": 1,
              "2026-02-16": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-05-06": 1,
              "2026-05-07": 3,
              "2026-05-11": 1,
              "2026-05-12": 2,
              "2026-05-17": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-26": 3,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 225.47,
              "mode_time_hours": 147.0,
              "mode_frequency": 1,
              "time_distribution": {
                "146-148h": 1,
                "304-306h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2025-11-04": 146.03480694444445,
                "2026-05-07": 304.9134616666667
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2026-05-07": 1
              }
            },
            "P2": {
              "avg_time_hours": 51.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 14,
              "time_distribution": {
                "0-2h": 14,
                "2-4h": 1,
                "10-12h": 1,
                "30-32h": 1,
                "66-68h": 1,
                "104-106h": 1,
                "110-112h": 1,
                "116-118h": 1,
                "124-126h": 1,
                "168-170h": 1,
                "174-176h": 1,
                "376-378h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2025-10-09": 1,
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-11-14": 1,
                "2025-11-17": 1,
                "2026-02-16": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-11": 1,
                "2026-05-12": 2,
                "2026-05-17": 1,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-26": 3,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-09-30": 0.013664444444444444,
                "2025-10-09": 0.2644111111111111,
                "2025-10-22": 0.08416194444444444,
                "2025-10-24": 1.2182897222222222,
                "2025-11-14": 105.80550083333334,
                "2025-11-17": 0.6696325000000001,
                "2026-02-16": 235.83171888888887,
                "2026-03-09": 66.39208888888889,
                "2026-03-10": 169.0349475,
                "2026-04-13": 116.58446944444445,
                "2026-04-15": 174.6344527777778,
                "2026-05-06": 377.86333138888887,
                "2026-05-07": 0.3263797222222222,
                "2026-05-11": 1.252471111111111,
                "2026-05-12": 11.303565,
                "2026-05-17": 0.01920222222222222,
                "2026-05-20": 0.017478055555555556,
                "2026-05-22": 31.21249027777778,
                "2026-05-26": 2.6471625,
                "2026-06-02": 1.0518277777777778
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2025-10-09": 1,
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-11-14": 1,
                "2025-11-17": 1,
                "2026-02-16": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-11": 1,
                "2026-05-12": 2,
                "2026-05-17": 1,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-26": 3,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 1.48,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 1.4848686111111111
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-26": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-26": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_75": {
      "overall": {
        "avg_time_hours": 239.89,
        "mode_time_hours": 25.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "6-8h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 2,
          "22-24h": 1,
          "24-26h": 3,
          "30-32h": 2,
          "36-38h": 1,
          "48-50h": 2,
          "56-58h": 1,
          "66-68h": 1,
          "70-72h": 1,
          "90-92h": 1,
          "96-98h": 1,
          "100-102h": 1,
          "122-124h": 1,
          "134-136h": 1,
          "144-146h": 2,
          "162-164h": 1,
          "166-168h": 1,
          "170-172h": 1,
          "174-176h": 1,
          "184-186h": 1,
          "214-216h": 1,
          "240-242h": 1,
          "246-248h": 1,
          "350-352h": 1,
          "368-370h": 1,
          "598-600h": 1,
          "714-716h": 1,
          "840-842h": 1,
          "860-862h": 1,
          "866-868h": 1,
          "1124-1126h": 2,
          "1424-1426h": 1
        },
        "tickets_count": 51,
        "tickets_per_day": {
          "2025-10-08": 2,
          "2025-10-14": 2,
          "2025-10-24": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-22": 2,
          "2025-11-28": 1,
          "2025-12-04": 2,
          "2025-12-11": 2,
          "2026-01-02": 1,
          "2026-01-06": 2,
          "2026-01-07": 1,
          "2026-01-10": 1,
          "2026-01-12": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-16": 2,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-23": 2,
          "2026-01-27": 2,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-02-25": 2,
          "2026-03-11": 1,
          "2026-03-25": 1,
          "2026-04-14": 1,
          "2026-04-28": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-21": 2
        },
        "time_per_day": {
          "2025-10-08": 196.70522111111114,
          "2025-10-14": 41.21693833333333,
          "2025-10-24": 246.84411861111113,
          "2025-11-11": 20.20807027777778,
          "2025-11-14": 175.66110722222223,
          "2025-11-17": 0.37337944444444443,
          "2025-11-19": 170.92009972222223,
          "2025-11-21": 1.1175175,
          "2025-11-22": 125.54137944444443,
          "2025-11-28": 48.16856805555555,
          "2025-12-04": 146.6464638888889,
          "2025-12-11": 191.55503055555556,
          "2026-01-02": 166.7096427777778,
          "2026-01-06": 96.72529750000001,
          "2026-01-07": 14.14756361111111,
          "2026-01-10": 19.884472222222225,
          "2026-01-12": 7.004823055555556,
          "2026-01-13": 71.78566305555555,
          "2026-01-14": 20.109136944444444,
          "2026-01-15": 290.7919591666667,
          "2026-01-16": 79.92504277777778,
          "2026-01-17": 240.84356916666667,
          "2026-01-19": 215.63997833333335,
          "2026-01-23": 902.7588186111111,
          "2026-01-27": 466.60798222222223,
          "2026-02-12": 1424.3679394444446,
          "2026-02-13": 598.1871086111112,
          "2026-02-18": 860.9208577777778,
          "2026-02-19": 3092.4841980555557,
          "2026-02-25": 185.44363833333333,
          "2026-03-11": 714.0337830555555,
          "2026-03-25": 0.33084138888888887,
          "2026-04-14": 350.87625499999996,
          "2026-05-04": 90.27032361111111
        },
        "time_count_per_day": {
          "2025-10-08": 2,
          "2025-10-14": 2,
          "2025-10-24": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-22": 2,
          "2025-11-28": 1,
          "2025-12-04": 2,
          "2025-12-11": 2,
          "2026-01-02": 1,
          "2026-01-06": 2,
          "2026-01-07": 1,
          "2026-01-10": 1,
          "2026-01-12": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-16": 2,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-23": 2,
          "2026-01-27": 2,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-02-25": 2,
          "2026-03-11": 1,
          "2026-03-25": 1,
          "2026-04-14": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 142.45,
          "mode_time_hours": 25.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "6-8h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 3,
            "30-32h": 2,
            "48-50h": 1,
            "56-58h": 1,
            "66-68h": 1,
            "70-72h": 1,
            "90-92h": 1,
            "134-136h": 1,
            "162-164h": 1,
            "214-216h": 1,
            "246-248h": 1,
            "350-352h": 1,
            "598-600h": 1,
            "1424-1426h": 1
          },
          "tickets_count": 29,
          "tickets_per_day": {
            "2025-10-14": 2,
            "2025-10-24": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-11": 2,
            "2026-01-06": 2,
            "2026-01-07": 1,
            "2026-01-10": 1,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-25": 2,
            "2026-03-25": 1,
            "2026-04-14": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-21": 2
          },
          "time_per_day": {
            "2025-10-14": 41.21693833333333,
            "2025-10-24": 246.84411861111113,
            "2025-11-17": 0.37337944444444443,
            "2025-11-21": 1.1175175,
            "2025-11-22": 25.363525833333334,
            "2025-11-28": 48.16856805555555,
            "2025-12-04": 24.20346333333333,
            "2025-12-11": 191.55503055555556,
            "2026-01-06": 96.72529750000001,
            "2026-01-07": 14.14756361111111,
            "2026-01-10": 19.884472222222225,
            "2026-01-12": 7.004823055555556,
            "2026-01-13": 71.78566305555555,
            "2026-01-14": 20.109136944444444,
            "2026-01-16": 30.151005833333333,
            "2026-01-19": 215.63997833333335,
            "2026-02-12": 1424.3679394444446,
            "2026-02-13": 598.1871086111112,
            "2026-02-25": 185.44363833333333,
            "2026-03-25": 0.33084138888888887,
            "2026-04-14": 350.87625499999996,
            "2026-05-04": 90.27032361111111
          },
          "time_count_per_day": {
            "2025-10-14": 2,
            "2025-10-24": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-11": 2,
            "2026-01-06": 2,
            "2026-01-07": 1,
            "2026-01-10": 1,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-25": 2,
            "2026-03-25": 1,
            "2026-04-14": 1,
            "2026-05-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 249.28,
          "mode_time_hours": 145.0,
          "mode_frequency": 2,
          "time_distribution": {
            "12-14h": 1,
            "20-22h": 1,
            "36-38h": 1,
            "48-50h": 1,
            "96-98h": 1,
            "100-102h": 1,
            "122-124h": 1,
            "144-146h": 2,
            "166-168h": 1,
            "170-172h": 1,
            "174-176h": 1,
            "184-186h": 1,
            "368-370h": 1,
            "714-716h": 1,
            "860-862h": 1,
            "866-868h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-10-08": 2,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-19": 1,
            "2025-11-22": 1,
            "2025-12-04": 1,
            "2026-01-02": 1,
            "2026-01-15": 2,
            "2026-01-16": 1,
            "2026-01-23": 2,
            "2026-01-27": 2,
            "2026-02-18": 1,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-10-08": 196.70522111111114,
            "2025-11-11": 20.20807027777778,
            "2025-11-14": 175.66110722222223,
            "2025-11-19": 170.92009972222223,
            "2025-11-22": 100.1778536111111,
            "2025-12-04": 122.44300055555556,
            "2026-01-02": 166.7096427777778,
            "2026-01-15": 290.7919591666667,
            "2026-01-16": 49.77403694444445,
            "2026-01-23": 902.7588186111111,
            "2026-01-27": 466.60798222222223,
            "2026-02-18": 860.9208577777778,
            "2026-03-11": 714.0337830555555
          },
          "time_count_per_day": {
            "2025-10-08": 2,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-19": 1,
            "2025-11-22": 1,
            "2025-12-04": 1,
            "2026-01-02": 1,
            "2026-01-15": 2,
            "2026-01-16": 1,
            "2026-01-23": 2,
            "2026-01-27": 2,
            "2026-02-18": 1,
            "2026-03-11": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 833.33,
          "mode_time_hours": 1125.0,
          "mode_frequency": 2,
          "time_distribution": {
            "240-242h": 1,
            "840-842h": 1,
            "1124-1126h": 2
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-17": 1,
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-01-17": 240.84356916666667,
            "2026-02-19": 3092.4841980555557
          },
          "time_count_per_day": {
            "2026-01-17": 1,
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 239.89,
            "mode_time_hours": 25.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "6-8h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 2,
              "22-24h": 1,
              "24-26h": 3,
              "30-32h": 2,
              "36-38h": 1,
              "48-50h": 2,
              "56-58h": 1,
              "66-68h": 1,
              "70-72h": 1,
              "90-92h": 1,
              "96-98h": 1,
              "100-102h": 1,
              "122-124h": 1,
              "134-136h": 1,
              "144-146h": 2,
              "162-164h": 1,
              "166-168h": 1,
              "170-172h": 1,
              "174-176h": 1,
              "184-186h": 1,
              "214-216h": 1,
              "240-242h": 1,
              "246-248h": 1,
              "350-352h": 1,
              "368-370h": 1,
              "598-600h": 1,
              "714-716h": 1,
              "840-842h": 1,
              "860-862h": 1,
              "866-868h": 1,
              "1124-1126h": 2,
              "1424-1426h": 1
            },
            "tickets_count": 47,
            "tickets_per_day": {
              "2025-10-08": 2,
              "2025-10-14": 2,
              "2025-10-24": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-22": 2,
              "2025-11-28": 1,
              "2025-12-04": 2,
              "2025-12-11": 2,
              "2026-01-02": 1,
              "2026-01-06": 2,
              "2026-01-07": 1,
              "2026-01-10": 1,
              "2026-01-12": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-16": 2,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-23": 2,
              "2026-01-27": 2,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-02-25": 2,
              "2026-03-11": 1,
              "2026-03-25": 1,
              "2026-04-14": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2025-10-08": 196.70522111111114,
              "2025-10-14": 41.21693833333333,
              "2025-10-24": 246.84411861111113,
              "2025-11-11": 20.20807027777778,
              "2025-11-14": 175.66110722222223,
              "2025-11-17": 0.37337944444444443,
              "2025-11-19": 170.92009972222223,
              "2025-11-21": 1.1175175,
              "2025-11-22": 125.54137944444443,
              "2025-11-28": 48.16856805555555,
              "2025-12-04": 146.6464638888889,
              "2025-12-11": 191.55503055555556,
              "2026-01-02": 166.7096427777778,
              "2026-01-06": 96.72529750000001,
              "2026-01-07": 14.14756361111111,
              "2026-01-10": 19.884472222222225,
              "2026-01-12": 7.004823055555556,
              "2026-01-13": 71.78566305555555,
              "2026-01-14": 20.109136944444444,
              "2026-01-15": 290.7919591666667,
              "2026-01-16": 79.92504277777778,
              "2026-01-17": 240.84356916666667,
              "2026-01-19": 215.63997833333335,
              "2026-01-23": 902.7588186111111,
              "2026-01-27": 466.60798222222223,
              "2026-02-12": 1424.3679394444446,
              "2026-02-13": 598.1871086111112,
              "2026-02-18": 860.9208577777778,
              "2026-02-19": 3092.4841980555557,
              "2026-02-25": 185.44363833333333,
              "2026-03-11": 714.0337830555555,
              "2026-03-25": 0.33084138888888887,
              "2026-04-14": 350.87625499999996,
              "2026-05-04": 90.27032361111111
            },
            "time_count_per_day": {
              "2025-10-08": 2,
              "2025-10-14": 2,
              "2025-10-24": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-22": 2,
              "2025-11-28": 1,
              "2025-12-04": 2,
              "2025-12-11": 2,
              "2026-01-02": 1,
              "2026-01-06": 2,
              "2026-01-07": 1,
              "2026-01-10": 1,
              "2026-01-12": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-16": 2,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-23": 2,
              "2026-01-27": 2,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-02-25": 2,
              "2026-03-11": 1,
              "2026-03-25": 1,
              "2026-04-14": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 142.45,
              "mode_time_hours": 25.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "6-8h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 3,
                "30-32h": 2,
                "48-50h": 1,
                "56-58h": 1,
                "66-68h": 1,
                "70-72h": 1,
                "90-92h": 1,
                "134-136h": 1,
                "162-164h": 1,
                "214-216h": 1,
                "246-248h": 1,
                "350-352h": 1,
                "598-600h": 1,
                "1424-1426h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2025-10-14": 2,
                "2025-10-24": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-11": 2,
                "2026-01-06": 2,
                "2026-01-07": 1,
                "2026-01-10": 1,
                "2026-01-12": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-25": 2,
                "2026-03-25": 1,
                "2026-04-14": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2025-10-14": 41.21693833333333,
                "2025-10-24": 246.84411861111113,
                "2025-11-17": 0.37337944444444443,
                "2025-11-21": 1.1175175,
                "2025-11-22": 25.363525833333334,
                "2025-11-28": 48.16856805555555,
                "2025-12-04": 24.20346333333333,
                "2025-12-11": 191.55503055555556,
                "2026-01-06": 96.72529750000001,
                "2026-01-07": 14.14756361111111,
                "2026-01-10": 19.884472222222225,
                "2026-01-12": 7.004823055555556,
                "2026-01-13": 71.78566305555555,
                "2026-01-14": 20.109136944444444,
                "2026-01-16": 30.151005833333333,
                "2026-01-19": 215.63997833333335,
                "2026-02-12": 1424.3679394444446,
                "2026-02-13": 598.1871086111112,
                "2026-02-25": 185.44363833333333,
                "2026-03-25": 0.33084138888888887,
                "2026-04-14": 350.87625499999996,
                "2026-05-04": 90.27032361111111
              },
              "time_count_per_day": {
                "2025-10-14": 2,
                "2025-10-24": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-11": 2,
                "2026-01-06": 2,
                "2026-01-07": 1,
                "2026-01-10": 1,
                "2026-01-12": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-25": 2,
                "2026-03-25": 1,
                "2026-04-14": 1,
                "2026-05-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 249.28,
              "mode_time_hours": 145.0,
              "mode_frequency": 2,
              "time_distribution": {
                "12-14h": 1,
                "20-22h": 1,
                "36-38h": 1,
                "48-50h": 1,
                "96-98h": 1,
                "100-102h": 1,
                "122-124h": 1,
                "144-146h": 2,
                "166-168h": 1,
                "170-172h": 1,
                "174-176h": 1,
                "184-186h": 1,
                "368-370h": 1,
                "714-716h": 1,
                "860-862h": 1,
                "866-868h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-10-08": 2,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-19": 1,
                "2025-11-22": 1,
                "2025-12-04": 1,
                "2026-01-02": 1,
                "2026-01-15": 2,
                "2026-01-16": 1,
                "2026-01-23": 2,
                "2026-01-27": 2,
                "2026-02-18": 1,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2025-10-08": 196.70522111111114,
                "2025-11-11": 20.20807027777778,
                "2025-11-14": 175.66110722222223,
                "2025-11-19": 170.92009972222223,
                "2025-11-22": 100.1778536111111,
                "2025-12-04": 122.44300055555556,
                "2026-01-02": 166.7096427777778,
                "2026-01-15": 290.7919591666667,
                "2026-01-16": 49.77403694444445,
                "2026-01-23": 902.7588186111111,
                "2026-01-27": 466.60798222222223,
                "2026-02-18": 860.9208577777778,
                "2026-03-11": 714.0337830555555
              },
              "time_count_per_day": {
                "2025-10-08": 2,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-19": 1,
                "2025-11-22": 1,
                "2025-12-04": 1,
                "2026-01-02": 1,
                "2026-01-15": 2,
                "2026-01-16": 1,
                "2026-01-23": 2,
                "2026-01-27": 2,
                "2026-02-18": 1,
                "2026-03-11": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 833.33,
              "mode_time_hours": 1125.0,
              "mode_frequency": 2,
              "time_distribution": {
                "240-242h": 1,
                "840-842h": 1,
                "1124-1126h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-01-17": 240.84356916666667,
                "2026-02-19": 3092.4841980555557
              },
              "time_count_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 3
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-28": 1,
              "2026-05-21": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-21": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_47": {
      "overall": {
        "avg_time_hours": 311.56,
        "mode_time_hours": 139.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1,
          "138-140h": 1,
          "164-166h": 1,
          "898-900h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-10": 1,
          "2025-12-05": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-10-06": 138.75568388888888,
          "2025-10-10": 164.14912,
          "2025-12-05": 44.64255777777778,
          "2026-02-12": 898.6729427777777
        },
        "time_count_per_day": {
          "2025-10-06": 1,
          "2025-10-10": 1,
          "2025-12-05": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 44.64,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 44.64255777777778
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 400.53,
          "mode_time_hours": 139.0,
          "mode_frequency": 1,
          "time_distribution": {
            "138-140h": 1,
            "164-166h": 1,
            "898-900h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-06": 138.75568388888888,
            "2025-10-10": 164.14912,
            "2026-02-12": 898.6729427777777
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-10": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 311.56,
            "mode_time_hours": 139.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1,
              "138-140h": 1,
              "164-166h": 1,
              "898-900h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2025-10-10": 1,
              "2025-12-05": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-10-06": 138.75568388888888,
              "2025-10-10": 164.14912,
              "2025-12-05": 44.64255777777778,
              "2026-02-12": 898.6729427777777
            },
            "time_count_per_day": {
              "2025-10-06": 1,
              "2025-10-10": 1,
              "2025-12-05": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 44.64,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 44.64255777777778
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 400.53,
              "mode_time_hours": 139.0,
              "mode_frequency": 1,
              "time_distribution": {
                "138-140h": 1,
                "164-166h": 1,
                "898-900h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-06": 138.75568388888888,
                "2025-10-10": 164.14912,
                "2026-02-12": 898.6729427777777
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-10": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_76": {
      "overall": {
        "avg_time_hours": 93.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 24,
        "time_distribution": {
          "0-2h": 24,
          "2-4h": 4,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 2,
          "10-12h": 3,
          "12-14h": 1,
          "18-20h": 1,
          "24-26h": 2,
          "30-32h": 3,
          "54-56h": 1,
          "58-60h": 1,
          "78-80h": 1,
          "102-104h": 1,
          "126-128h": 1,
          "414-416h": 2,
          "456-458h": 1,
          "516-518h": 1,
          "1178-1180h": 1,
          "1348-1350h": 1
        },
        "tickets_count": 56,
        "tickets_per_day": {
          "2025-09-30": 1,
          "2025-10-14": 2,
          "2025-11-03": 1,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-01": 1,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2025-12-19": 1,
          "2025-12-23": 2,
          "2026-01-06": 1,
          "2026-01-08": 2,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-20": 1,
          "2026-01-21": 1,
          "2026-01-23": 3,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-16": 1,
          "2026-02-19": 3,
          "2026-02-21": 2,
          "2026-03-04": 1,
          "2026-04-09": 1,
          "2026-04-13": 1,
          "2026-04-17": 1,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-29": 1,
          "2026-06-02": 1,
          "2026-06-05": 7
        },
        "time_per_day": {
          "2025-09-30": 1.1566691666666666,
          "2025-10-14": 2.181928333333333,
          "2025-11-03": 19.54996611111111,
          "2025-11-19": 1.6374863888888889,
          "2025-11-26": 30.96975361111111,
          "2025-11-28": 0.4007811111111111,
          "2025-12-01": 0.8959808333333333,
          "2025-12-02": 158.48268666666667,
          "2025-12-03": 0.14630722222222223,
          "2025-12-19": 31.737644166666666,
          "2025-12-23": 11.431311666666666,
          "2026-01-06": 25.274853611111112,
          "2026-01-08": 129.43051944444446,
          "2026-01-09": 415.17642083333334,
          "2026-01-12": 3.5309452777777777,
          "2026-01-13": 11.277789444444444,
          "2026-01-14": 21.560818333333337,
          "2026-01-15": 6.545133333333333,
          "2026-01-20": 79.41655638888889,
          "2026-01-21": 1.4192933333333333,
          "2026-01-23": 416.370635,
          "2026-02-03": 1695.6143755555554,
          "2026-02-05": 0.8716558333333333,
          "2026-02-16": 1349.4999094444443,
          "2026-02-19": 75.95849055555556,
          "2026-02-21": 34.97681472222222,
          "2026-04-13": 456.4272036111111,
          "2026-04-17": 13.178501944444445,
          "2026-05-12": 1.672613611111111,
          "2026-05-14": 0.7677891666666667,
          "2026-05-19": 0.24984472222222223,
          "2026-05-21": 1.2238269444444445,
          "2026-05-26": 0.6981561111111111,
          "2026-05-29": 24.924460555555555,
          "2026-06-02": 2.2156744444444443,
          "2026-06-05": 8.37492638888889
        },
        "time_count_per_day": {
          "2025-09-30": 1,
          "2025-10-14": 2,
          "2025-11-03": 1,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-01": 1,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2025-12-19": 1,
          "2025-12-23": 2,
          "2026-01-06": 1,
          "2026-01-08": 2,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-20": 1,
          "2026-01-21": 1,
          "2026-01-23": 3,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-16": 1,
          "2026-02-19": 3,
          "2026-02-21": 2,
          "2026-04-13": 1,
          "2026-04-17": 1,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-29": 1,
          "2026-06-02": 1,
          "2026-06-05": 7
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 27.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "54-56h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-11-28": 0.4007811111111111,
            "2025-12-02": 54.91743638888889
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2025-12-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 37.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 20,
          "time_distribution": {
            "0-2h": 20,
            "2-4h": 1,
            "4-6h": 1,
            "12-14h": 1,
            "24-26h": 2,
            "78-80h": 1,
            "414-416h": 1,
            "456-458h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-10-14": 2,
            "2025-11-19": 1,
            "2025-12-01": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-20": 1,
            "2026-01-23": 3,
            "2026-02-05": 1,
            "2026-02-21": 1,
            "2026-04-13": 1,
            "2026-04-17": 1,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-05": 7
          },
          "time_per_day": {
            "2025-10-14": 2.181928333333333,
            "2025-11-19": 1.6374863888888889,
            "2025-12-01": 0.8959808333333333,
            "2026-01-06": 25.274853611111112,
            "2026-01-08": 1.7827563888888889,
            "2026-01-20": 79.41655638888889,
            "2026-01-23": 416.370635,
            "2026-02-05": 0.8716558333333333,
            "2026-02-21": 4.8692866666666665,
            "2026-04-13": 456.4272036111111,
            "2026-04-17": 13.178501944444445,
            "2026-05-12": 1.672613611111111,
            "2026-05-14": 0.7677891666666667,
            "2026-05-19": 0.24984472222222223,
            "2026-05-21": 1.2238269444444445,
            "2026-05-26": 0.6981561111111111,
            "2026-05-29": 24.924460555555555,
            "2026-06-02": 2.2156744444444443,
            "2026-06-05": 8.37492638888889
          },
          "time_count_per_day": {
            "2025-10-14": 2,
            "2025-11-19": 1,
            "2025-12-01": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-20": 1,
            "2026-01-23": 3,
            "2026-02-05": 1,
            "2026-02-21": 1,
            "2026-04-13": 1,
            "2026-04-17": 1,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-05": 7
          }
        },
        "P3": {
          "avg_time_hours": 238.46,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "6-8h": 1,
            "8-10h": 2,
            "18-20h": 1,
            "30-32h": 2,
            "414-416h": 1,
            "516-518h": 1,
            "1178-1180h": 1,
            "1348-1350h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2025-11-26": 1,
            "2025-12-03": 1,
            "2025-12-19": 1,
            "2025-12-23": 2,
            "2026-01-09": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-15": 1,
            "2026-01-21": 1,
            "2026-02-03": 2,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-11-03": 19.54996611111111,
            "2025-11-26": 30.96975361111111,
            "2025-12-03": 0.14630722222222223,
            "2025-12-19": 31.737644166666666,
            "2025-12-23": 11.431311666666666,
            "2026-01-09": 415.17642083333334,
            "2026-01-12": 3.5309452777777777,
            "2026-01-13": 11.277789444444444,
            "2026-01-15": 6.545133333333333,
            "2026-01-21": 1.4192933333333333,
            "2026-02-03": 1695.6143755555554,
            "2026-02-16": 1349.4999094444443
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2025-11-26": 1,
            "2025-12-03": 1,
            "2025-12-19": 1,
            "2025-12-23": 2,
            "2026-01-09": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-15": 1,
            "2026-01-21": 1,
            "2026-02-03": 2,
            "2026-02-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 32.05,
          "mode_time_hours": 11.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "10-12h": 3,
            "30-32h": 1,
            "58-60h": 1,
            "126-128h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2026-01-08": 1,
            "2026-01-14": 2,
            "2026-02-19": 3,
            "2026-02-21": 1,
            "2026-03-04": 1,
            "2026-04-09": 1
          },
          "time_per_day": {
            "2025-09-30": 1.1566691666666666,
            "2026-01-08": 127.64776305555556,
            "2026-01-14": 21.560818333333337,
            "2026-02-19": 75.95849055555556,
            "2026-02-21": 30.107528055555555
          },
          "time_count_per_day": {
            "2025-09-30": 1,
            "2026-01-08": 1,
            "2026-01-14": 2,
            "2026-02-19": 3,
            "2026-02-21": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 103.57,
          "mode_time_hours": 103.0,
          "mode_frequency": 1,
          "time_distribution": {
            "102-104h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-12-02": 103.56525027777778
          },
          "time_count_per_day": {
            "2025-12-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 93.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 24,
            "time_distribution": {
              "0-2h": 24,
              "2-4h": 4,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 2,
              "10-12h": 3,
              "12-14h": 1,
              "18-20h": 1,
              "24-26h": 2,
              "30-32h": 3,
              "54-56h": 1,
              "58-60h": 1,
              "78-80h": 1,
              "102-104h": 1,
              "126-128h": 1,
              "414-416h": 2,
              "456-458h": 1,
              "516-518h": 1,
              "1178-1180h": 1,
              "1348-1350h": 1
            },
            "tickets_count": 54,
            "tickets_per_day": {
              "2025-09-30": 1,
              "2025-10-14": 2,
              "2025-11-03": 1,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-01": 1,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2025-12-19": 1,
              "2025-12-23": 2,
              "2026-01-06": 1,
              "2026-01-08": 2,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-20": 1,
              "2026-01-21": 1,
              "2026-01-23": 3,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-16": 1,
              "2026-02-19": 3,
              "2026-02-21": 2,
              "2026-04-13": 1,
              "2026-04-17": 1,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-02": 1,
              "2026-06-05": 7
            },
            "time_per_day": {
              "2025-09-30": 1.1566691666666666,
              "2025-10-14": 2.181928333333333,
              "2025-11-03": 19.54996611111111,
              "2025-11-19": 1.6374863888888889,
              "2025-11-26": 30.96975361111111,
              "2025-11-28": 0.4007811111111111,
              "2025-12-01": 0.8959808333333333,
              "2025-12-02": 158.48268666666667,
              "2025-12-03": 0.14630722222222223,
              "2025-12-19": 31.737644166666666,
              "2025-12-23": 11.431311666666666,
              "2026-01-06": 25.274853611111112,
              "2026-01-08": 129.43051944444446,
              "2026-01-09": 415.17642083333334,
              "2026-01-12": 3.5309452777777777,
              "2026-01-13": 11.277789444444444,
              "2026-01-14": 21.560818333333337,
              "2026-01-15": 6.545133333333333,
              "2026-01-20": 79.41655638888889,
              "2026-01-21": 1.4192933333333333,
              "2026-01-23": 416.370635,
              "2026-02-03": 1695.6143755555554,
              "2026-02-05": 0.8716558333333333,
              "2026-02-16": 1349.4999094444443,
              "2026-02-19": 75.95849055555556,
              "2026-02-21": 34.97681472222222,
              "2026-04-13": 456.4272036111111,
              "2026-04-17": 13.178501944444445,
              "2026-05-12": 1.672613611111111,
              "2026-05-14": 0.7677891666666667,
              "2026-05-19": 0.24984472222222223,
              "2026-05-21": 1.2238269444444445,
              "2026-05-26": 0.6981561111111111,
              "2026-05-29": 24.924460555555555,
              "2026-06-02": 2.2156744444444443,
              "2026-06-05": 8.37492638888889
            },
            "time_count_per_day": {
              "2025-09-30": 1,
              "2025-10-14": 2,
              "2025-11-03": 1,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-01": 1,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2025-12-19": 1,
              "2025-12-23": 2,
              "2026-01-06": 1,
              "2026-01-08": 2,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-20": 1,
              "2026-01-21": 1,
              "2026-01-23": 3,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-16": 1,
              "2026-02-19": 3,
              "2026-02-21": 2,
              "2026-04-13": 1,
              "2026-04-17": 1,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-02": 1,
              "2026-06-05": 7
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 27.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "54-56h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-11-28": 0.4007811111111111,
                "2025-12-02": 54.91743638888889
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2025-12-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 37.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 20,
              "time_distribution": {
                "0-2h": 20,
                "2-4h": 1,
                "4-6h": 1,
                "12-14h": 1,
                "24-26h": 2,
                "78-80h": 1,
                "414-416h": 1,
                "456-458h": 1
              },
              "tickets_count": 28,
              "tickets_per_day": {
                "2025-10-14": 2,
                "2025-11-19": 1,
                "2025-12-01": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-20": 1,
                "2026-01-23": 3,
                "2026-02-05": 1,
                "2026-02-21": 1,
                "2026-04-13": 1,
                "2026-04-17": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-29": 1,
                "2026-06-02": 1,
                "2026-06-05": 7
              },
              "time_per_day": {
                "2025-10-14": 2.181928333333333,
                "2025-11-19": 1.6374863888888889,
                "2025-12-01": 0.8959808333333333,
                "2026-01-06": 25.274853611111112,
                "2026-01-08": 1.7827563888888889,
                "2026-01-20": 79.41655638888889,
                "2026-01-23": 416.370635,
                "2026-02-05": 0.8716558333333333,
                "2026-02-21": 4.8692866666666665,
                "2026-04-13": 456.4272036111111,
                "2026-04-17": 13.178501944444445,
                "2026-05-12": 1.672613611111111,
                "2026-05-14": 0.7677891666666667,
                "2026-05-19": 0.24984472222222223,
                "2026-05-21": 1.2238269444444445,
                "2026-05-26": 0.6981561111111111,
                "2026-05-29": 24.924460555555555,
                "2026-06-02": 2.2156744444444443,
                "2026-06-05": 8.37492638888889
              },
              "time_count_per_day": {
                "2025-10-14": 2,
                "2025-11-19": 1,
                "2025-12-01": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-20": 1,
                "2026-01-23": 3,
                "2026-02-05": 1,
                "2026-02-21": 1,
                "2026-04-13": 1,
                "2026-04-17": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-29": 1,
                "2026-06-02": 1,
                "2026-06-05": 7
              }
            },
            "P3": {
              "avg_time_hours": 238.46,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "6-8h": 1,
                "8-10h": 2,
                "18-20h": 1,
                "30-32h": 2,
                "414-416h": 1,
                "516-518h": 1,
                "1178-1180h": 1,
                "1348-1350h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2025-11-26": 1,
                "2025-12-03": 1,
                "2025-12-19": 1,
                "2025-12-23": 2,
                "2026-01-09": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-15": 1,
                "2026-01-21": 1,
                "2026-02-03": 2,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-11-03": 19.54996611111111,
                "2025-11-26": 30.96975361111111,
                "2025-12-03": 0.14630722222222223,
                "2025-12-19": 31.737644166666666,
                "2025-12-23": 11.431311666666666,
                "2026-01-09": 415.17642083333334,
                "2026-01-12": 3.5309452777777777,
                "2026-01-13": 11.277789444444444,
                "2026-01-15": 6.545133333333333,
                "2026-01-21": 1.4192933333333333,
                "2026-02-03": 1695.6143755555554,
                "2026-02-16": 1349.4999094444443
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2025-11-26": 1,
                "2025-12-03": 1,
                "2025-12-19": 1,
                "2025-12-23": 2,
                "2026-01-09": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-15": 1,
                "2026-01-21": 1,
                "2026-02-03": 2,
                "2026-02-16": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 32.05,
              "mode_time_hours": 11.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "10-12h": 3,
                "30-32h": 1,
                "58-60h": 1,
                "126-128h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-09-30": 1,
                "2026-01-08": 1,
                "2026-01-14": 2,
                "2026-02-19": 3,
                "2026-02-21": 1
              },
              "time_per_day": {
                "2025-09-30": 1.1566691666666666,
                "2026-01-08": 127.64776305555556,
                "2026-01-14": 21.560818333333337,
                "2026-02-19": 75.95849055555556,
                "2026-02-21": 30.107528055555555
              },
              "time_count_per_day": {
                "2025-09-30": 1,
                "2026-01-08": 1,
                "2026-01-14": 2,
                "2026-02-19": 3,
                "2026-02-21": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 103.57,
              "mode_time_hours": 103.0,
              "mode_frequency": 1,
              "time_distribution": {
                "102-104h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-12-02": 103.56525027777778
              },
              "time_count_per_day": {
                "2025-12-02": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-04": 1,
              "2026-04-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-04-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_80": {
      "overall": {
        "avg_time_hours": 177.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 12,
        "time_distribution": {
          "0-2h": 12,
          "2-4h": 2,
          "6-8h": 3,
          "8-10h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "14-16h": 6,
          "16-18h": 1,
          "18-20h": 3,
          "22-24h": 5,
          "24-26h": 1,
          "38-40h": 1,
          "42-44h": 1,
          "46-48h": 1,
          "48-50h": 3,
          "68-70h": 2,
          "70-72h": 1,
          "72-74h": 1,
          "76-78h": 1,
          "82-84h": 2,
          "88-90h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "114-116h": 1,
          "120-122h": 1,
          "128-130h": 1,
          "134-136h": 1,
          "136-138h": 1,
          "178-180h": 1,
          "196-198h": 1,
          "204-206h": 1,
          "210-212h": 2,
          "238-240h": 1,
          "242-244h": 1,
          "276-278h": 1,
          "302-304h": 1,
          "320-322h": 2,
          "326-328h": 1,
          "340-342h": 1,
          "344-346h": 1,
          "350-352h": 1,
          "424-426h": 2,
          "446-448h": 1,
          "496-498h": 1,
          "612-614h": 1,
          "628-630h": 1,
          "790-792h": 1,
          "808-810h": 1,
          "892-894h": 1,
          "922-924h": 1,
          "924-926h": 1,
          "1316-1318h": 1
        },
        "tickets_count": 94,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-10-31": 2,
          "2025-11-04": 2,
          "2025-11-06": 2,
          "2025-11-12": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-12-04": 1,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-22": 1,
          "2025-12-26": 1,
          "2026-01-07": 2,
          "2026-01-13": 6,
          "2026-01-15": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-01-28": 2,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-12": 2,
          "2026-02-13": 1,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 2,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-26": 2,
          "2026-02-28": 1,
          "2026-03-09": 1,
          "2026-03-10": 2,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 2,
          "2026-03-17": 1,
          "2026-03-20": 2,
          "2026-03-23": 1,
          "2026-04-06": 1,
          "2026-04-08": 2,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-16": 3,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-28": 2,
          "2026-06-01": 3,
          "2026-06-02": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-14": 320.7767325,
          "2025-10-31": 9.60173111111111,
          "2025-11-04": 46.31885666666667,
          "2025-11-06": 3.0692819444444446,
          "2025-11-12": 103.4016311111111,
          "2025-11-18": 115.69277305555556,
          "2025-11-19": 463.4328194444445,
          "2025-12-04": 43.80128222222223,
          "2025-12-09": 345.37040388888886,
          "2025-12-15": 892.6673499999999,
          "2025-12-18": 47.15912888888889,
          "2025-12-22": 243.31445916666667,
          "2025-12-26": 178.73076972222222,
          "2026-01-07": 317.46676583333334,
          "2026-01-13": 1000.0955947222221,
          "2026-01-15": 128.26545638888888,
          "2026-01-19": 29.307628055555554,
          "2026-01-27": 73.1783425,
          "2026-01-28": 26.22442972222222,
          "2026-01-31": 23.238895,
          "2026-02-03": 624.6223375,
          "2026-02-06": 49.07414333333333,
          "2026-02-07": 69.69147666666666,
          "2026-02-09": 328.3015086111111,
          "2026-02-10": 95.64786027777777,
          "2026-02-12": 947.9978183333334,
          "2026-02-13": 350.9139838888889,
          "2026-02-14": 167.26530555555559,
          "2026-02-16": 100.73119527777779,
          "2026-02-17": 809.2356566666667,
          "2026-02-18": 24.305006666666667,
          "2026-02-19": 99.02926916666667,
          "2026-02-21": 210.93477222222225,
          "2026-02-23": 69.26833166666667,
          "2026-02-26": 28.185335555555554,
          "2026-02-28": 8.50805861111111,
          "2026-03-10": 174.29671638888888,
          "2026-03-11": 205.7358072222222,
          "2026-03-12": 6.0504613888888885,
          "2026-03-13": 3.8418205555555556,
          "2026-03-17": 210.90922527777778,
          "2026-03-20": 700.9101566666668,
          "2026-03-23": 497.2082061111111,
          "2026-04-06": 0.03084638888888889,
          "2026-04-08": 23.874280555555554,
          "2026-04-13": 1.9877280555555554,
          "2026-04-14": 446.71510111111115,
          "2026-04-16": 19.618925277777777,
          "2026-04-22": 612.6252647222223,
          "2026-04-23": 923.8380997222222,
          "2026-04-29": 17.71986111111111,
          "2026-05-05": 71.90940083333334,
          "2026-05-06": 12.460999166666667,
          "2026-05-07": 1317.2068175,
          "2026-05-08": 425.25459027777777,
          "2026-05-14": 791.673411111111,
          "2026-05-15": 12.481137777777777,
          "2026-05-28": 0.22365833333333332,
          "2026-06-01": 1.790748611111111
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-10-31": 2,
          "2025-11-04": 2,
          "2025-11-06": 2,
          "2025-11-12": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-12-04": 1,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-22": 1,
          "2025-12-26": 1,
          "2026-01-07": 2,
          "2026-01-13": 6,
          "2026-01-15": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-01-28": 2,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-12": 2,
          "2026-02-13": 1,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 2,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-26": 2,
          "2026-02-28": 1,
          "2026-03-10": 2,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 2,
          "2026-03-17": 1,
          "2026-03-20": 2,
          "2026-03-23": 1,
          "2026-04-06": 1,
          "2026-04-08": 2,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-16": 2,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-29": 1,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-28": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 100.73,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "100-102h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-16": 1
          },
          "time_per_day": {
            "2026-02-16": 100.73119527777779
          },
          "time_count_per_day": {
            "2026-02-16": 1
          }
        },
        "P2": {
          "avg_time_hours": 189.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 2,
            "6-8h": 2,
            "8-10h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "14-16h": 4,
            "16-18h": 1,
            "18-20h": 1,
            "22-24h": 4,
            "24-26h": 1,
            "38-40h": 1,
            "42-44h": 1,
            "46-48h": 1,
            "68-70h": 1,
            "70-72h": 1,
            "76-78h": 1,
            "102-104h": 1,
            "114-116h": 1,
            "120-122h": 1,
            "134-136h": 1,
            "136-138h": 1,
            "178-180h": 1,
            "204-206h": 1,
            "210-212h": 2,
            "238-240h": 1,
            "302-304h": 1,
            "320-322h": 1,
            "340-342h": 1,
            "344-346h": 1,
            "424-426h": 1,
            "446-448h": 1,
            "612-614h": 1,
            "628-630h": 1,
            "790-792h": 1,
            "808-810h": 1,
            "892-894h": 1,
            "922-924h": 1,
            "1316-1318h": 1
          },
          "tickets_count": 64,
          "tickets_per_day": {
            "2025-10-31": 2,
            "2025-11-04": 2,
            "2025-11-12": 1,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-13": 2,
            "2026-01-19": 2,
            "2026-02-03": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-02-26": 2,
            "2026-02-28": 1,
            "2026-03-10": 2,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-17": 1,
            "2026-04-06": 1,
            "2026-04-08": 2,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-16": 3,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-28": 2,
            "2026-06-01": 3,
            "2026-06-02": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-31": 9.60173111111111,
            "2025-11-04": 46.31885666666667,
            "2025-11-12": 103.4016311111111,
            "2025-11-18": 115.69277305555556,
            "2025-11-19": 136.81354777777779,
            "2025-12-04": 43.80128222222223,
            "2025-12-09": 345.37040388888886,
            "2025-12-15": 892.6673499999999,
            "2025-12-18": 47.15912888888889,
            "2025-12-26": 178.73076972222222,
            "2026-01-07": 121.01157833333332,
            "2026-01-13": 970.1632058333332,
            "2026-01-19": 29.307628055555554,
            "2026-02-03": 624.6223375,
            "2026-02-09": 239.4842063888889,
            "2026-02-10": 76.21574472222221,
            "2026-02-12": 22.246232222222222,
            "2026-02-17": 809.2356566666667,
            "2026-02-18": 24.305006666666667,
            "2026-02-21": 210.93477222222225,
            "2026-02-23": 69.26833166666667,
            "2026-02-26": 28.185335555555554,
            "2026-02-28": 8.50805861111111,
            "2026-03-10": 174.29671638888888,
            "2026-03-11": 205.7358072222222,
            "2026-03-12": 6.0504613888888885,
            "2026-03-13": 3.8418205555555556,
            "2026-03-17": 210.90922527777778,
            "2026-04-06": 0.03084638888888889,
            "2026-04-08": 23.874280555555554,
            "2026-04-13": 1.9877280555555554,
            "2026-04-14": 446.71510111111115,
            "2026-04-16": 19.618925277777777,
            "2026-04-22": 612.6252647222223,
            "2026-04-23": 923.8380997222222,
            "2026-04-29": 17.71986111111111,
            "2026-05-05": 71.90940083333334,
            "2026-05-06": 12.460999166666667,
            "2026-05-07": 1317.2068175,
            "2026-05-08": 425.25459027777777,
            "2026-05-14": 791.673411111111,
            "2026-05-15": 12.481137777777777,
            "2026-05-28": 0.22365833333333332,
            "2026-06-01": 1.790748611111111
          },
          "time_count_per_day": {
            "2025-10-31": 2,
            "2025-11-04": 2,
            "2025-11-12": 1,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-13": 2,
            "2026-01-19": 2,
            "2026-02-03": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-02-26": 2,
            "2026-02-28": 1,
            "2026-03-10": 2,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-17": 1,
            "2026-04-06": 1,
            "2026-04-08": 2,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-16": 2,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-29": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-28": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 154.97,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "6-8h": 1,
            "14-16h": 2,
            "18-20h": 2,
            "22-24h": 1,
            "48-50h": 3,
            "68-70h": 1,
            "72-74h": 1,
            "82-84h": 2,
            "88-90h": 1,
            "128-130h": 1,
            "196-198h": 1,
            "242-244h": 1,
            "276-278h": 1,
            "320-322h": 1,
            "326-328h": 1,
            "350-352h": 1,
            "424-426h": 1,
            "496-498h": 1,
            "924-926h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-11-06": 2,
            "2025-11-19": 1,
            "2025-12-22": 1,
            "2026-01-07": 1,
            "2026-01-13": 4,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-06": 1,
            "2026-02-07": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 2,
            "2026-02-19": 2,
            "2026-03-20": 2,
            "2026-03-23": 1
          },
          "time_per_day": {
            "2025-10-14": 320.7767325,
            "2025-11-06": 3.0692819444444446,
            "2025-11-19": 326.6192716666667,
            "2025-12-22": 243.31445916666667,
            "2026-01-07": 196.45518750000002,
            "2026-01-13": 29.932388888888887,
            "2026-01-15": 128.26545638888888,
            "2026-01-27": 73.1783425,
            "2026-01-28": 26.22442972222222,
            "2026-01-31": 23.238895,
            "2026-02-06": 49.07414333333333,
            "2026-02-07": 69.69147666666666,
            "2026-02-09": 88.81730222222222,
            "2026-02-10": 19.432115555555555,
            "2026-02-12": 925.7515861111111,
            "2026-02-13": 350.9139838888889,
            "2026-02-14": 167.26530555555559,
            "2026-02-19": 99.02926916666667,
            "2026-03-20": 700.9101566666668,
            "2026-03-23": 497.2082061111111
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-11-06": 2,
            "2025-11-19": 1,
            "2025-12-22": 1,
            "2026-01-07": 1,
            "2026-01-13": 4,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-06": 1,
            "2026-02-07": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 2,
            "2026-02-19": 2,
            "2026-03-20": 2,
            "2026-03-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 177.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 12,
            "time_distribution": {
              "0-2h": 12,
              "2-4h": 2,
              "6-8h": 3,
              "8-10h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "14-16h": 6,
              "16-18h": 1,
              "18-20h": 3,
              "22-24h": 5,
              "24-26h": 1,
              "38-40h": 1,
              "42-44h": 1,
              "46-48h": 1,
              "48-50h": 3,
              "68-70h": 2,
              "70-72h": 1,
              "72-74h": 1,
              "76-78h": 1,
              "82-84h": 2,
              "88-90h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "114-116h": 1,
              "120-122h": 1,
              "128-130h": 1,
              "134-136h": 1,
              "136-138h": 1,
              "178-180h": 1,
              "196-198h": 1,
              "204-206h": 1,
              "210-212h": 2,
              "238-240h": 1,
              "242-244h": 1,
              "276-278h": 1,
              "302-304h": 1,
              "320-322h": 2,
              "326-328h": 1,
              "340-342h": 1,
              "344-346h": 1,
              "350-352h": 1,
              "424-426h": 2,
              "446-448h": 1,
              "496-498h": 1,
              "612-614h": 1,
              "628-630h": 1,
              "790-792h": 1,
              "808-810h": 1,
              "892-894h": 1,
              "922-924h": 1,
              "924-926h": 1,
              "1316-1318h": 1
            },
            "tickets_count": 84,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-10-31": 2,
              "2025-11-04": 2,
              "2025-11-06": 2,
              "2025-11-12": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-12-04": 1,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-22": 1,
              "2025-12-26": 1,
              "2026-01-07": 2,
              "2026-01-13": 6,
              "2026-01-15": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-01-28": 2,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-12": 2,
              "2026-02-13": 1,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 2,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-26": 2,
              "2026-02-28": 1,
              "2026-03-10": 2,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 2,
              "2026-03-17": 1,
              "2026-03-20": 2,
              "2026-03-23": 1,
              "2026-04-06": 1,
              "2026-04-08": 2,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-16": 2,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-29": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-28": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-14": 320.7767325,
              "2025-10-31": 9.60173111111111,
              "2025-11-04": 46.31885666666667,
              "2025-11-06": 3.0692819444444446,
              "2025-11-12": 103.4016311111111,
              "2025-11-18": 115.69277305555556,
              "2025-11-19": 463.4328194444445,
              "2025-12-04": 43.80128222222223,
              "2025-12-09": 345.37040388888886,
              "2025-12-15": 892.6673499999999,
              "2025-12-18": 47.15912888888889,
              "2025-12-22": 243.31445916666667,
              "2025-12-26": 178.73076972222222,
              "2026-01-07": 317.46676583333334,
              "2026-01-13": 1000.0955947222221,
              "2026-01-15": 128.26545638888888,
              "2026-01-19": 29.307628055555554,
              "2026-01-27": 73.1783425,
              "2026-01-28": 26.22442972222222,
              "2026-01-31": 23.238895,
              "2026-02-03": 624.6223375,
              "2026-02-06": 49.07414333333333,
              "2026-02-07": 69.69147666666666,
              "2026-02-09": 328.3015086111111,
              "2026-02-10": 95.64786027777777,
              "2026-02-12": 947.9978183333334,
              "2026-02-13": 350.9139838888889,
              "2026-02-14": 167.26530555555559,
              "2026-02-16": 100.73119527777779,
              "2026-02-17": 809.2356566666667,
              "2026-02-18": 24.305006666666667,
              "2026-02-19": 99.02926916666667,
              "2026-02-21": 210.93477222222225,
              "2026-02-23": 69.26833166666667,
              "2026-02-26": 28.185335555555554,
              "2026-02-28": 8.50805861111111,
              "2026-03-10": 174.29671638888888,
              "2026-03-11": 205.7358072222222,
              "2026-03-12": 6.0504613888888885,
              "2026-03-13": 3.8418205555555556,
              "2026-03-17": 210.90922527777778,
              "2026-03-20": 700.9101566666668,
              "2026-03-23": 497.2082061111111,
              "2026-04-06": 0.03084638888888889,
              "2026-04-08": 23.874280555555554,
              "2026-04-13": 1.9877280555555554,
              "2026-04-14": 446.71510111111115,
              "2026-04-16": 19.618925277777777,
              "2026-04-22": 612.6252647222223,
              "2026-04-23": 923.8380997222222,
              "2026-04-29": 17.71986111111111,
              "2026-05-05": 71.90940083333334,
              "2026-05-06": 12.460999166666667,
              "2026-05-07": 1317.2068175,
              "2026-05-08": 425.25459027777777,
              "2026-05-14": 791.673411111111,
              "2026-05-15": 12.481137777777777,
              "2026-05-28": 0.22365833333333332,
              "2026-06-01": 1.790748611111111
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-10-31": 2,
              "2025-11-04": 2,
              "2025-11-06": 2,
              "2025-11-12": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-12-04": 1,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-22": 1,
              "2025-12-26": 1,
              "2026-01-07": 2,
              "2026-01-13": 6,
              "2026-01-15": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-01-28": 2,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-12": 2,
              "2026-02-13": 1,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 2,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-26": 2,
              "2026-02-28": 1,
              "2026-03-10": 2,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 2,
              "2026-03-17": 1,
              "2026-03-20": 2,
              "2026-03-23": 1,
              "2026-04-06": 1,
              "2026-04-08": 2,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-16": 2,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-29": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-28": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 100.73,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "100-102h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {
                "2026-02-16": 100.73119527777779
              },
              "time_count_per_day": {
                "2026-02-16": 1
              }
            },
            "P2": {
              "avg_time_hours": 189.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 2,
                "6-8h": 2,
                "8-10h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "14-16h": 4,
                "16-18h": 1,
                "18-20h": 1,
                "22-24h": 4,
                "24-26h": 1,
                "38-40h": 1,
                "42-44h": 1,
                "46-48h": 1,
                "68-70h": 1,
                "70-72h": 1,
                "76-78h": 1,
                "102-104h": 1,
                "114-116h": 1,
                "120-122h": 1,
                "134-136h": 1,
                "136-138h": 1,
                "178-180h": 1,
                "204-206h": 1,
                "210-212h": 2,
                "238-240h": 1,
                "302-304h": 1,
                "320-322h": 1,
                "340-342h": 1,
                "344-346h": 1,
                "424-426h": 1,
                "446-448h": 1,
                "612-614h": 1,
                "628-630h": 1,
                "790-792h": 1,
                "808-810h": 1,
                "892-894h": 1,
                "922-924h": 1,
                "1316-1318h": 1
              },
              "tickets_count": 55,
              "tickets_per_day": {
                "2025-10-31": 2,
                "2025-11-04": 2,
                "2025-11-12": 1,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-13": 2,
                "2026-01-19": 2,
                "2026-02-03": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-02-26": 2,
                "2026-02-28": 1,
                "2026-03-10": 2,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-17": 1,
                "2026-04-06": 1,
                "2026-04-08": 2,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-16": 2,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-29": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-28": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-31": 9.60173111111111,
                "2025-11-04": 46.31885666666667,
                "2025-11-12": 103.4016311111111,
                "2025-11-18": 115.69277305555556,
                "2025-11-19": 136.81354777777779,
                "2025-12-04": 43.80128222222223,
                "2025-12-09": 345.37040388888886,
                "2025-12-15": 892.6673499999999,
                "2025-12-18": 47.15912888888889,
                "2025-12-26": 178.73076972222222,
                "2026-01-07": 121.01157833333332,
                "2026-01-13": 970.1632058333332,
                "2026-01-19": 29.307628055555554,
                "2026-02-03": 624.6223375,
                "2026-02-09": 239.4842063888889,
                "2026-02-10": 76.21574472222221,
                "2026-02-12": 22.246232222222222,
                "2026-02-17": 809.2356566666667,
                "2026-02-18": 24.305006666666667,
                "2026-02-21": 210.93477222222225,
                "2026-02-23": 69.26833166666667,
                "2026-02-26": 28.185335555555554,
                "2026-02-28": 8.50805861111111,
                "2026-03-10": 174.29671638888888,
                "2026-03-11": 205.7358072222222,
                "2026-03-12": 6.0504613888888885,
                "2026-03-13": 3.8418205555555556,
                "2026-03-17": 210.90922527777778,
                "2026-04-06": 0.03084638888888889,
                "2026-04-08": 23.874280555555554,
                "2026-04-13": 1.9877280555555554,
                "2026-04-14": 446.71510111111115,
                "2026-04-16": 19.618925277777777,
                "2026-04-22": 612.6252647222223,
                "2026-04-23": 923.8380997222222,
                "2026-04-29": 17.71986111111111,
                "2026-05-05": 71.90940083333334,
                "2026-05-06": 12.460999166666667,
                "2026-05-07": 1317.2068175,
                "2026-05-08": 425.25459027777777,
                "2026-05-14": 791.673411111111,
                "2026-05-15": 12.481137777777777,
                "2026-05-28": 0.22365833333333332,
                "2026-06-01": 1.790748611111111
              },
              "time_count_per_day": {
                "2025-10-31": 2,
                "2025-11-04": 2,
                "2025-11-12": 1,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-13": 2,
                "2026-01-19": 2,
                "2026-02-03": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-02-26": 2,
                "2026-02-28": 1,
                "2026-03-10": 2,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-17": 1,
                "2026-04-06": 1,
                "2026-04-08": 2,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-16": 2,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-29": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-28": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 154.97,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "6-8h": 1,
                "14-16h": 2,
                "18-20h": 2,
                "22-24h": 1,
                "48-50h": 3,
                "68-70h": 1,
                "72-74h": 1,
                "82-84h": 2,
                "88-90h": 1,
                "128-130h": 1,
                "196-198h": 1,
                "242-244h": 1,
                "276-278h": 1,
                "320-322h": 1,
                "326-328h": 1,
                "350-352h": 1,
                "424-426h": 1,
                "496-498h": 1,
                "924-926h": 1
              },
              "tickets_count": 28,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-11-06": 2,
                "2025-11-19": 1,
                "2025-12-22": 1,
                "2026-01-07": 1,
                "2026-01-13": 4,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-06": 1,
                "2026-02-07": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 2,
                "2026-02-19": 2,
                "2026-03-20": 2,
                "2026-03-23": 1
              },
              "time_per_day": {
                "2025-10-14": 320.7767325,
                "2025-11-06": 3.0692819444444446,
                "2025-11-19": 326.6192716666667,
                "2025-12-22": 243.31445916666667,
                "2026-01-07": 196.45518750000002,
                "2026-01-13": 29.932388888888887,
                "2026-01-15": 128.26545638888888,
                "2026-01-27": 73.1783425,
                "2026-01-28": 26.22442972222222,
                "2026-01-31": 23.238895,
                "2026-02-06": 49.07414333333333,
                "2026-02-07": 69.69147666666666,
                "2026-02-09": 88.81730222222222,
                "2026-02-10": 19.432115555555555,
                "2026-02-12": 925.7515861111111,
                "2026-02-13": 350.9139838888889,
                "2026-02-14": 167.26530555555559,
                "2026-02-19": 99.02926916666667,
                "2026-03-20": 700.9101566666668,
                "2026-03-23": 497.2082061111111
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-11-06": 2,
                "2025-11-19": 1,
                "2025-12-22": 1,
                "2026-01-07": 1,
                "2026-01-13": 4,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-06": 1,
                "2026-02-07": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 2,
                "2026-02-19": 2,
                "2026-03-20": 2,
                "2026-03-23": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-05-28": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-05-28": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-16": 1,
              "2026-05-13": 1,
              "2026-06-01": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-16": 1,
                "2026-05-13": 1,
                "2026-06-01": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-11": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-11": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_81": {
      "overall": {
        "avg_time_hours": 174.78,
        "mode_time_hours": 1.0,
        "mode_frequency": 142,
        "time_distribution": {
          "0-2h": 142,
          "2-4h": 18,
          "4-6h": 7,
          "6-8h": 6,
          "8-10h": 4,
          "10-12h": 6,
          "12-14h": 5,
          "14-16h": 5,
          "16-18h": 1,
          "18-20h": 3,
          "20-22h": 2,
          "24-26h": 6,
          "26-28h": 1,
          "28-30h": 2,
          "30-32h": 4,
          "32-34h": 3,
          "34-36h": 4,
          "36-38h": 16,
          "38-40h": 7,
          "40-42h": 3,
          "42-44h": 1,
          "44-46h": 2,
          "46-48h": 5,
          "48-50h": 3,
          "50-52h": 2,
          "52-54h": 14,
          "54-56h": 1,
          "56-58h": 1,
          "58-60h": 2,
          "66-68h": 1,
          "68-70h": 2,
          "72-74h": 1,
          "74-76h": 2,
          "76-78h": 1,
          "78-80h": 3,
          "80-82h": 3,
          "82-84h": 8,
          "84-86h": 1,
          "88-90h": 2,
          "92-94h": 2,
          "94-96h": 4,
          "96-98h": 4,
          "98-100h": 1,
          "102-104h": 5,
          "104-106h": 6,
          "108-110h": 1,
          "112-114h": 3,
          "118-120h": 3,
          "120-122h": 2,
          "122-124h": 1,
          "124-126h": 5,
          "126-128h": 1,
          "128-130h": 3,
          "136-138h": 2,
          "140-142h": 2,
          "144-146h": 3,
          "150-152h": 5,
          "154-156h": 2,
          "160-162h": 4,
          "162-164h": 1,
          "166-168h": 1,
          "172-174h": 2,
          "176-178h": 1,
          "178-180h": 2,
          "184-186h": 1,
          "192-194h": 2,
          "198-200h": 1,
          "200-202h": 4,
          "204-206h": 1,
          "206-208h": 1,
          "212-214h": 1,
          "216-218h": 3,
          "222-224h": 1,
          "234-236h": 1,
          "250-252h": 1,
          "268-270h": 2,
          "276-278h": 3,
          "280-282h": 1,
          "306-308h": 2,
          "312-314h": 2,
          "320-322h": 1,
          "330-332h": 1,
          "332-334h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "340-342h": 2,
          "344-346h": 1,
          "348-350h": 1,
          "354-356h": 1,
          "358-360h": 1,
          "360-362h": 2,
          "362-364h": 1,
          "364-366h": 2,
          "372-374h": 1,
          "374-376h": 1,
          "382-384h": 1,
          "384-386h": 4,
          "398-400h": 5,
          "400-402h": 1,
          "402-404h": 1,
          "406-408h": 1,
          "408-410h": 2,
          "412-414h": 1,
          "420-422h": 2,
          "422-424h": 1,
          "426-428h": 1,
          "430-432h": 1,
          "434-436h": 1,
          "438-440h": 2,
          "442-444h": 1,
          "444-446h": 1,
          "464-466h": 1,
          "466-468h": 1,
          "472-474h": 1,
          "476-478h": 2,
          "478-480h": 2,
          "482-484h": 2,
          "486-488h": 1,
          "498-500h": 1,
          "500-502h": 2,
          "502-504h": 2,
          "504-506h": 1,
          "508-510h": 1,
          "510-512h": 3,
          "514-516h": 1,
          "528-530h": 1,
          "530-532h": 1,
          "532-534h": 1,
          "548-550h": 2,
          "552-554h": 1,
          "556-558h": 1,
          "564-566h": 2,
          "574-576h": 1,
          "576-578h": 1,
          "596-598h": 1,
          "614-616h": 2,
          "618-620h": 1,
          "620-622h": 1,
          "624-626h": 1,
          "638-640h": 2,
          "644-646h": 1,
          "646-648h": 1,
          "664-666h": 1,
          "694-696h": 1,
          "702-704h": 1,
          "720-722h": 1,
          "722-724h": 1,
          "726-728h": 1,
          "734-736h": 2,
          "738-740h": 1,
          "768-770h": 3,
          "814-816h": 1,
          "826-828h": 1,
          "836-838h": 1,
          "838-840h": 1,
          "844-846h": 1,
          "852-854h": 1,
          "900-902h": 1,
          "902-904h": 2,
          "1406-1408h": 1,
          "1416-1418h": 1,
          "1506-1508h": 1,
          "1556-1558h": 1,
          "1944-1946h": 1,
          "2036-2038h": 1,
          "2054-2056h": 1
        },
        "tickets_count": 590,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-07": 2,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-22": 1,
          "2025-10-29": 3,
          "2025-11-07": 1,
          "2025-11-11": 1,
          "2025-11-13": 3,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-11-20": 4,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-23": 3,
          "2025-11-24": 5,
          "2025-11-25": 5,
          "2025-11-28": 1,
          "2025-11-29": 4,
          "2025-12-02": 6,
          "2025-12-03": 5,
          "2025-12-04": 1,
          "2025-12-05": 3,
          "2025-12-11": 5,
          "2025-12-15": 1,
          "2025-12-16": 2,
          "2025-12-19": 2,
          "2025-12-22": 3,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2026-01-02": 2,
          "2026-01-08": 4,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-21": 2,
          "2026-01-23": 8,
          "2026-01-24": 3,
          "2026-01-26": 1,
          "2026-01-27": 16,
          "2026-01-30": 3,
          "2026-02-02": 2,
          "2026-02-03": 5,
          "2026-02-04": 2,
          "2026-02-05": 7,
          "2026-02-06": 17,
          "2026-02-10": 15,
          "2026-02-11": 1,
          "2026-02-13": 10,
          "2026-02-14": 2,
          "2026-02-16": 16,
          "2026-02-17": 9,
          "2026-02-18": 4,
          "2026-02-19": 49,
          "2026-02-20": 4,
          "2026-02-21": 2,
          "2026-02-23": 16,
          "2026-02-24": 2,
          "2026-02-25": 1,
          "2026-02-26": 3,
          "2026-02-28": 16,
          "2026-03-02": 6,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-07": 2,
          "2026-03-09": 5,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-14": 1,
          "2026-03-16": 1,
          "2026-03-17": 16,
          "2026-03-18": 41,
          "2026-03-19": 2,
          "2026-03-20": 5,
          "2026-03-23": 6,
          "2026-03-24": 3,
          "2026-03-26": 13,
          "2026-03-27": 2,
          "2026-03-28": 1,
          "2026-03-30": 6,
          "2026-03-31": 1,
          "2026-04-01": 1,
          "2026-04-04": 2,
          "2026-04-06": 4,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-10": 2,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-21": 4,
          "2026-04-22": 14,
          "2026-04-24": 3,
          "2026-04-27": 3,
          "2026-04-28": 1,
          "2026-04-29": 15,
          "2026-04-30": 6,
          "2026-05-02": 2,
          "2026-05-04": 3,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 8,
          "2026-05-09": 1,
          "2026-05-11": 3,
          "2026-05-12": 3,
          "2026-05-13": 4,
          "2026-05-14": 2,
          "2026-05-18": 3,
          "2026-05-19": 4,
          "2026-05-20": 3,
          "2026-05-21": 1,
          "2026-05-22": 2,
          "2026-05-23": 2,
          "2026-05-25": 6,
          "2026-05-26": 1,
          "2026-05-28": 46,
          "2026-05-29": 2,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-05": 4,
          "2026-06-08": 4
        },
        "time_per_day": {
          "2025-10-01": 1.2217244444444444,
          "2025-10-03": 38.010268611111115,
          "2025-10-07": 208.79162972222224,
          "2025-10-08": 15.025056388888888,
          "2025-10-09": 10.736087777777778,
          "2025-10-22": 2.1759941666666665,
          "2025-10-29": 115.82729027777776,
          "2025-11-07": 464.49868583333335,
          "2025-11-11": 24.03040138888889,
          "2025-11-13": 1231.243376111111,
          "2025-11-17": 3.9529272222222223,
          "2025-11-18": 0.9757916666666666,
          "2025-11-19": 141.0050425,
          "2025-11-20": 204.96544555555556,
          "2025-11-21": 47.38346138888889,
          "2025-11-22": 0.10855555555555556,
          "2025-11-23": 251.5295225,
          "2025-11-24": 881.2529172222223,
          "2025-11-25": 320.15957805555564,
          "2025-11-29": 522.0137552777778,
          "2025-12-02": 314.49498222222223,
          "2025-12-03": 317.6949266666667,
          "2025-12-04": 112.77025027777778,
          "2025-12-05": 873.0826402777777,
          "2025-12-11": 1227.6395297222223,
          "2025-12-15": 344.41333194444445,
          "2025-12-16": 730.2928372222223,
          "2025-12-19": 443.90922166666667,
          "2025-12-22": 1614.8942358333334,
          "2025-12-26": 66.03713833333333,
          "2025-12-29": 694.3345916666666,
          "2026-01-02": 1806.366112222222,
          "2026-01-08": 139.7559125,
          "2026-01-09": 11.475235,
          "2026-01-13": 25.47695277777778,
          "2026-01-14": 0.6495791666666667,
          "2026-01-15": 46.90678944444444,
          "2026-01-17": 59.23298138888889,
          "2026-01-19": 54.78139444444445,
          "2026-01-21": 189.99884805555556,
          "2026-01-23": 459.07848944444453,
          "2026-01-24": 401.39720833333337,
          "2026-01-26": 5.198082222222222,
          "2026-01-27": 1035.4981947222223,
          "2026-01-30": 414.63324972222216,
          "2026-02-02": 9.437793888888887,
          "2026-02-03": 1239.3969975,
          "2026-02-04": 258.49636361111106,
          "2026-02-05": 967.0616538888889,
          "2026-02-06": 3725.319206111112,
          "2026-02-10": 5797.734476944444,
          "2026-02-13": 290.97115138888887,
          "2026-02-14": 64.19461861111111,
          "2026-02-17": 879.1817355555555,
          "2026-02-18": 4108.645753888889,
          "2026-02-19": 24837.990108333335,
          "2026-02-20": 374.9425391666667,
          "2026-02-21": 25.762951666666666,
          "2026-02-23": 222.98295472222225,
          "2026-02-24": 0.13264916666666665,
          "2026-02-26": 0.20352,
          "2026-02-28": 1139.9071419444447,
          "2026-03-02": 42.34380833333333,
          "2026-03-04": 6.884471666666666,
          "2026-03-07": 3.8608075,
          "2026-03-09": 326.21142138888894,
          "2026-03-11": 0.7279411111111111,
          "2026-03-12": 0.8275083333333334,
          "2026-03-16": 0.5085447222222222,
          "2026-03-17": 657.18613,
          "2026-03-18": 14650.721553888896,
          "2026-03-19": 2.1131416666666665,
          "2026-03-20": 226.05234194444444,
          "2026-03-23": 3.732812777777778,
          "2026-03-24": 601.2162425,
          "2026-03-26": 6401.038848333333,
          "2026-03-27": 0.07198916666666667,
          "2026-03-28": 1.3941166666666667,
          "2026-03-30": 2037.5313861111113,
          "2026-04-01": 0.9902227777777778,
          "2026-04-04": 2.776515,
          "2026-04-06": 1.6641269444444444,
          "2026-04-07": 7.601612222222222,
          "2026-04-08": 0.4575311111111111,
          "2026-04-10": 26.601209166666667,
          "2026-04-13": 0.18762055555555554,
          "2026-04-16": 1.1373188888888888,
          "2026-04-21": 1.794559722222222,
          "2026-04-22": 2436.8386400000004,
          "2026-04-24": 1.1106883333333333,
          "2026-04-27": 0.30150305555555557,
          "2026-04-29": 14.400718611111113,
          "2026-04-30": 59.52813805555556,
          "2026-05-02": 36.59716027777778,
          "2026-05-04": 2.3025136111111113,
          "2026-05-05": 1.1517636111111111,
          "2026-05-06": 163.8901213888889,
          "2026-05-08": 8.583115000000001,
          "2026-05-09": 17.466869166666665,
          "2026-05-11": 8.467306666666666,
          "2026-05-12": 313.3490069444445,
          "2026-05-13": 346.68439916666665,
          "2026-05-14": 148.264485,
          "2026-05-18": 1.7103130555555555,
          "2026-05-19": 1.727167222222222,
          "2026-05-20": 0.31303583333333335,
          "2026-05-23": 15.8137225,
          "2026-05-25": 79.48832944444445,
          "2026-05-26": 10.620747777777778,
          "2026-05-28": 27.445049444444443,
          "2026-06-01": 8.821342777777778,
          "2026-06-02": 1.2200719444444446,
          "2026-06-05": 79.23354027777778,
          "2026-06-08": 3.2511905555555556
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-07": 2,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-22": 1,
          "2025-10-29": 3,
          "2025-11-07": 1,
          "2025-11-11": 1,
          "2025-11-13": 3,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-11-20": 4,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-23": 3,
          "2025-11-24": 5,
          "2025-11-25": 5,
          "2025-11-29": 4,
          "2025-12-02": 6,
          "2025-12-03": 5,
          "2025-12-04": 1,
          "2025-12-05": 3,
          "2025-12-11": 5,
          "2025-12-15": 1,
          "2025-12-16": 2,
          "2025-12-19": 2,
          "2025-12-22": 3,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2026-01-02": 2,
          "2026-01-08": 4,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-21": 2,
          "2026-01-23": 8,
          "2026-01-24": 3,
          "2026-01-26": 1,
          "2026-01-27": 16,
          "2026-01-30": 3,
          "2026-02-02": 2,
          "2026-02-03": 5,
          "2026-02-04": 2,
          "2026-02-05": 7,
          "2026-02-06": 17,
          "2026-02-10": 15,
          "2026-02-13": 10,
          "2026-02-14": 2,
          "2026-02-17": 3,
          "2026-02-18": 4,
          "2026-02-19": 49,
          "2026-02-20": 4,
          "2026-02-21": 2,
          "2026-02-23": 6,
          "2026-02-24": 2,
          "2026-02-26": 3,
          "2026-02-28": 16,
          "2026-03-02": 3,
          "2026-03-04": 2,
          "2026-03-07": 2,
          "2026-03-09": 4,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-16": 1,
          "2026-03-17": 16,
          "2026-03-18": 41,
          "2026-03-19": 2,
          "2026-03-20": 4,
          "2026-03-23": 5,
          "2026-03-24": 3,
          "2026-03-26": 13,
          "2026-03-27": 1,
          "2026-03-28": 1,
          "2026-03-30": 6,
          "2026-04-01": 1,
          "2026-04-04": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-10": 2,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-21": 3,
          "2026-04-22": 12,
          "2026-04-24": 1,
          "2026-04-27": 1,
          "2026-04-29": 9,
          "2026-04-30": 4,
          "2026-05-02": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 6,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-12": 2,
          "2026-05-13": 4,
          "2026-05-14": 2,
          "2026-05-18": 3,
          "2026-05-19": 4,
          "2026-05-20": 1,
          "2026-05-23": 2,
          "2026-05-25": 5,
          "2026-05-26": 1,
          "2026-05-28": 46,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-05": 3,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 70.12,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "24-26h": 1,
            "94-96h": 1,
            "144-146h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-11-28": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-10-08": 14.909877222222221,
            "2026-02-19": 25.82521138888889,
            "2026-02-20": 94.25224972222222,
            "2026-05-14": 145.47382416666667
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-05-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 25.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 138,
          "time_distribution": {
            "0-2h": 138,
            "2-4h": 13,
            "4-6h": 3,
            "6-8h": 4,
            "8-10h": 2,
            "10-12h": 2,
            "12-14h": 2,
            "14-16h": 2,
            "16-18h": 1,
            "18-20h": 3,
            "24-26h": 1,
            "36-38h": 1,
            "38-40h": 4,
            "40-42h": 1,
            "52-54h": 8,
            "76-78h": 1,
            "92-94h": 1,
            "94-96h": 2,
            "126-128h": 1,
            "162-164h": 1,
            "176-178h": 1,
            "192-194h": 1,
            "198-200h": 1,
            "276-278h": 1,
            "312-314h": 1,
            "320-322h": 1,
            "332-334h": 1,
            "1556-1558h": 1
          },
          "tickets_count": 233,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-29": 1,
            "2025-11-11": 1,
            "2025-11-18": 1,
            "2025-11-22": 1,
            "2025-11-25": 3,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-19": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-30": 2,
            "2026-02-03": 3,
            "2026-02-13": 2,
            "2026-02-16": 16,
            "2026-02-17": 7,
            "2026-02-19": 9,
            "2026-02-20": 3,
            "2026-02-21": 1,
            "2026-02-24": 2,
            "2026-02-26": 3,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-04": 2,
            "2026-03-07": 2,
            "2026-03-09": 4,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-19": 2,
            "2026-03-20": 1,
            "2026-03-23": 5,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-28": 1,
            "2026-03-30": 2,
            "2026-04-01": 1,
            "2026-04-04": 1,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-10": 2,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-21": 4,
            "2026-04-22": 9,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-04-29": 15,
            "2026-04-30": 4,
            "2026-05-02": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 8,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 4,
            "2026-05-14": 1,
            "2026-05-18": 3,
            "2026-05-19": 4,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-23": 2,
            "2026-05-25": 5,
            "2026-05-26": 1,
            "2026-05-28": 46,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 3,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-08": 0.11517916666666667,
            "2025-10-29": 13.68336472222222,
            "2025-11-11": 24.03040138888889,
            "2025-11-18": 0.9757916666666666,
            "2025-11-22": 0.10855555555555556,
            "2025-11-25": 2.761754444444444,
            "2025-12-02": 0.8970416666666666,
            "2025-12-11": 193.75837361111113,
            "2025-12-19": 0.36354861111111114,
            "2026-01-14": 0.6495791666666667,
            "2026-01-19": 0.3417177777777778,
            "2026-01-23": 3.3112319444444442,
            "2026-01-26": 5.198082222222222,
            "2026-01-27": 7.164789444444444,
            "2026-01-30": 6.950875555555555,
            "2026-02-03": 776.3405338888888,
            "2026-02-13": 9.199802777777778,
            "2026-02-17": 1.2391933333333331,
            "2026-02-19": 502.23780361111113,
            "2026-02-20": 280.69028944444443,
            "2026-02-21": 1.0498447222222222,
            "2026-02-24": 0.13264916666666665,
            "2026-02-26": 0.20352,
            "2026-02-28": 2.2058958333333334,
            "2026-03-02": 42.34380833333333,
            "2026-03-04": 6.884471666666666,
            "2026-03-07": 3.8608075,
            "2026-03-09": 326.21142138888894,
            "2026-03-11": 0.7279411111111111,
            "2026-03-12": 0.8275083333333334,
            "2026-03-16": 0.5085447222222222,
            "2026-03-18": 0.2841547222222222,
            "2026-03-19": 2.1131416666666665,
            "2026-03-20": 2.4295066666666667,
            "2026-03-23": 3.732812777777778,
            "2026-03-26": 0.13065805555555557,
            "2026-03-27": 0.07198916666666667,
            "2026-03-28": 1.3941166666666667,
            "2026-03-30": 12.24611611111111,
            "2026-04-01": 0.9902227777777778,
            "2026-04-04": 2.776515,
            "2026-04-06": 1.6641269444444444,
            "2026-04-07": 7.601612222222222,
            "2026-04-08": 0.4575311111111111,
            "2026-04-10": 26.601209166666667,
            "2026-04-13": 0.18762055555555554,
            "2026-04-16": 1.1373188888888888,
            "2026-04-21": 1.794559722222222,
            "2026-04-22": 1560.1667608333335,
            "2026-04-24": 1.1106883333333333,
            "2026-04-27": 0.30150305555555557,
            "2026-04-29": 14.400718611111113,
            "2026-04-30": 59.52813805555556,
            "2026-05-02": 36.59716027777778,
            "2026-05-04": 2.3025136111111113,
            "2026-05-05": 1.1517636111111111,
            "2026-05-06": 163.8901213888889,
            "2026-05-08": 8.583115000000001,
            "2026-05-09": 17.466869166666665,
            "2026-05-11": 8.467306666666666,
            "2026-05-12": 313.3490069444445,
            "2026-05-13": 346.68439916666665,
            "2026-05-14": 2.7906608333333334,
            "2026-05-18": 1.7103130555555555,
            "2026-05-19": 1.727167222222222,
            "2026-05-20": 0.31303583333333335,
            "2026-05-23": 15.8137225,
            "2026-05-25": 79.48832944444445,
            "2026-05-26": 10.620747777777778,
            "2026-05-28": 27.445049444444443,
            "2026-06-01": 8.821342777777778,
            "2026-06-02": 1.2200719444444446,
            "2026-06-05": 79.23354027777778,
            "2026-06-08": 3.2511905555555556
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-29": 1,
            "2025-11-11": 1,
            "2025-11-18": 1,
            "2025-11-22": 1,
            "2025-11-25": 3,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-19": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-30": 2,
            "2026-02-03": 3,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-02-19": 9,
            "2026-02-20": 3,
            "2026-02-21": 1,
            "2026-02-24": 2,
            "2026-02-26": 3,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-04": 2,
            "2026-03-07": 2,
            "2026-03-09": 4,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-19": 2,
            "2026-03-20": 1,
            "2026-03-23": 5,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-28": 1,
            "2026-03-30": 2,
            "2026-04-01": 1,
            "2026-04-04": 1,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-10": 2,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-21": 3,
            "2026-04-22": 9,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-04-29": 9,
            "2026-04-30": 4,
            "2026-05-02": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 6,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 4,
            "2026-05-14": 1,
            "2026-05-18": 3,
            "2026-05-19": 4,
            "2026-05-20": 1,
            "2026-05-23": 2,
            "2026-05-25": 5,
            "2026-05-26": 1,
            "2026-05-28": 46,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 3,
            "2026-06-08": 2
          }
        },
        "P3": {
          "avg_time_hours": 221.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "4-6h": 2,
            "8-10h": 1,
            "26-28h": 1,
            "28-30h": 2,
            "30-32h": 2,
            "32-34h": 3,
            "38-40h": 1,
            "46-48h": 1,
            "52-54h": 1,
            "66-68h": 1,
            "92-94h": 1,
            "200-202h": 1,
            "268-270h": 1,
            "312-314h": 1,
            "434-436h": 1,
            "482-484h": 1,
            "510-512h": 2,
            "528-530h": 1,
            "596-598h": 1,
            "722-724h": 1,
            "1944-1946h": 1
          },
          "tickets_count": 32,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-03": 1,
            "2025-11-13": 1,
            "2025-11-25": 1,
            "2025-12-02": 2,
            "2025-12-05": 1,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-23": 4,
            "2026-02-02": 2,
            "2026-02-03": 2,
            "2026-02-10": 8,
            "2026-02-13": 5,
            "2026-02-18": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-10-01": 1.2217244444444444,
            "2025-10-03": 38.010268611111115,
            "2025-11-13": 1.8089766666666667,
            "2025-11-25": 312.9755983333334,
            "2025-12-02": 102.43351972222221,
            "2025-12-05": 269.9276883333333,
            "2025-12-22": 722.1201149999999,
            "2025-12-26": 66.03713833333333,
            "2026-01-23": 55.313469722222216,
            "2026-02-02": 9.437793888888887,
            "2026-02-03": 463.05646361111116,
            "2026-02-10": 2892.4106083333327,
            "2026-02-13": 154.20927555555556,
            "2026-02-18": 1944.837333888889,
            "2026-02-19": 52.46980305555555
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-03": 1,
            "2025-11-13": 1,
            "2025-11-25": 1,
            "2025-12-02": 2,
            "2025-12-05": 1,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-23": 4,
            "2026-02-02": 2,
            "2026-02-03": 2,
            "2026-02-10": 8,
            "2026-02-13": 5,
            "2026-02-18": 1,
            "2026-02-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 199.13,
          "mode_time_hours": 37.0,
          "mode_frequency": 14,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 3,
            "4-6h": 2,
            "6-8h": 2,
            "8-10h": 1,
            "10-12h": 4,
            "12-14h": 3,
            "14-16h": 2,
            "20-22h": 2,
            "24-26h": 4,
            "30-32h": 1,
            "34-36h": 4,
            "36-38h": 14,
            "38-40h": 2,
            "40-42h": 2,
            "42-44h": 1,
            "44-46h": 2,
            "46-48h": 4,
            "48-50h": 3,
            "50-52h": 2,
            "52-54h": 5,
            "54-56h": 1,
            "56-58h": 1,
            "58-60h": 2,
            "68-70h": 2,
            "72-74h": 1,
            "74-76h": 2,
            "78-80h": 3,
            "80-82h": 3,
            "82-84h": 7,
            "84-86h": 1,
            "88-90h": 2,
            "94-96h": 1,
            "96-98h": 4,
            "98-100h": 1,
            "102-104h": 5,
            "104-106h": 6,
            "108-110h": 1,
            "112-114h": 3,
            "118-120h": 3,
            "120-122h": 2,
            "122-124h": 1,
            "124-126h": 5,
            "128-130h": 3,
            "140-142h": 2,
            "144-146h": 2,
            "150-152h": 5,
            "154-156h": 2,
            "160-162h": 4,
            "166-168h": 1,
            "172-174h": 2,
            "178-180h": 1,
            "200-202h": 3,
            "204-206h": 1,
            "206-208h": 1,
            "216-218h": 3,
            "222-224h": 1,
            "234-236h": 1,
            "268-270h": 1,
            "276-278h": 2,
            "280-282h": 1,
            "306-308h": 2,
            "330-332h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "340-342h": 2,
            "348-350h": 1,
            "354-356h": 1,
            "358-360h": 1,
            "360-362h": 2,
            "362-364h": 1,
            "372-374h": 1,
            "382-384h": 1,
            "384-386h": 4,
            "398-400h": 5,
            "400-402h": 1,
            "402-404h": 1,
            "406-408h": 1,
            "412-414h": 1,
            "420-422h": 2,
            "422-424h": 1,
            "426-428h": 1,
            "438-440h": 2,
            "444-446h": 1,
            "464-466h": 1,
            "466-468h": 1,
            "472-474h": 1,
            "482-484h": 1,
            "498-500h": 1,
            "502-504h": 2,
            "508-510h": 1,
            "510-512h": 1,
            "514-516h": 1,
            "530-532h": 1,
            "532-534h": 1,
            "548-550h": 2,
            "556-558h": 1,
            "614-616h": 2,
            "620-622h": 1,
            "624-626h": 1,
            "644-646h": 1,
            "646-648h": 1,
            "702-704h": 1,
            "726-728h": 1,
            "836-838h": 1,
            "838-840h": 1,
            "1506-1508h": 1
          },
          "tickets_count": 254,
          "tickets_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-22": 1,
            "2025-10-29": 2,
            "2025-11-07": 1,
            "2025-11-13": 2,
            "2025-11-17": 1,
            "2025-11-19": 2,
            "2025-11-20": 4,
            "2025-11-21": 1,
            "2025-11-23": 3,
            "2025-11-24": 5,
            "2025-11-25": 1,
            "2025-11-29": 4,
            "2025-12-02": 3,
            "2025-12-03": 4,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-22": 1,
            "2026-01-08": 4,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-15": 2,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-21": 2,
            "2026-01-23": 3,
            "2026-01-24": 3,
            "2026-01-27": 14,
            "2026-01-30": 1,
            "2026-02-04": 2,
            "2026-02-05": 6,
            "2026-02-06": 17,
            "2026-02-10": 7,
            "2026-02-11": 1,
            "2026-02-13": 3,
            "2026-02-14": 2,
            "2026-02-17": 2,
            "2026-02-18": 2,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 6,
            "2026-02-25": 1,
            "2026-02-28": 15,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-09": 1,
            "2026-03-14": 1,
            "2026-03-17": 16,
            "2026-03-18": 40,
            "2026-03-20": 4,
            "2026-03-23": 1,
            "2026-03-24": 3,
            "2026-03-26": 12,
            "2026-03-27": 1,
            "2026-03-30": 4,
            "2026-03-31": 1,
            "2026-04-04": 1,
            "2026-04-06": 2,
            "2026-04-22": 5,
            "2026-04-24": 2,
            "2026-04-27": 2,
            "2026-04-28": 1,
            "2026-04-30": 2,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-11": 1,
            "2026-05-12": 1,
            "2026-05-20": 2,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-29": 1,
            "2026-06-05": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-07": 208.79162972222224,
            "2025-10-09": 10.736087777777778,
            "2025-10-22": 2.1759941666666665,
            "2025-10-29": 102.14392555555554,
            "2025-11-07": 464.49868583333335,
            "2025-11-13": 1229.4343994444444,
            "2025-11-17": 3.9529272222222223,
            "2025-11-19": 141.0050425,
            "2025-11-20": 204.96544555555556,
            "2025-11-21": 47.38346138888889,
            "2025-11-23": 251.5295225,
            "2025-11-24": 881.2529172222223,
            "2025-11-25": 4.422225277777778,
            "2025-11-29": 522.0137552777778,
            "2025-12-02": 211.16442083333334,
            "2025-12-03": 286.7578488888889,
            "2025-12-04": 112.77025027777778,
            "2025-12-05": 172.16368916666664,
            "2025-12-22": 47.37878916666667,
            "2026-01-08": 139.7559125,
            "2026-01-09": 11.475235,
            "2026-01-13": 25.47695277777778,
            "2026-01-15": 46.90678944444444,
            "2026-01-17": 59.23298138888889,
            "2026-01-19": 54.43967666666667,
            "2026-01-21": 189.99884805555556,
            "2026-01-23": 400.45378777777785,
            "2026-01-24": 401.39720833333337,
            "2026-01-27": 991.5268263888888,
            "2026-01-30": 407.68237416666665,
            "2026-02-04": 258.49636361111106,
            "2026-02-05": 787.9872963888889,
            "2026-02-06": 3725.319206111112,
            "2026-02-10": 2905.3238686111113,
            "2026-02-13": 127.56207305555554,
            "2026-02-14": 64.19461861111111,
            "2026-02-17": 877.9425422222222,
            "2026-02-18": 127.61551583333332,
            "2026-02-19": 82.85659333333332,
            "2026-02-21": 24.713106944444444,
            "2026-02-23": 222.98295472222225,
            "2026-02-28": 1137.7012461111112,
            "2026-03-17": 657.18613,
            "2026-03-18": 14650.437399166674,
            "2026-03-20": 223.62283527777777,
            "2026-03-24": 601.2162425,
            "2026-03-26": 6400.908190277777,
            "2026-03-30": 2025.28527,
            "2026-04-22": 876.6718791666667
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-22": 1,
            "2025-10-29": 2,
            "2025-11-07": 1,
            "2025-11-13": 2,
            "2025-11-17": 1,
            "2025-11-19": 2,
            "2025-11-20": 4,
            "2025-11-21": 1,
            "2025-11-23": 3,
            "2025-11-24": 5,
            "2025-11-25": 1,
            "2025-11-29": 4,
            "2025-12-02": 3,
            "2025-12-03": 4,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-22": 1,
            "2026-01-08": 4,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-15": 2,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-21": 2,
            "2026-01-23": 3,
            "2026-01-24": 3,
            "2026-01-27": 14,
            "2026-01-30": 1,
            "2026-02-04": 2,
            "2026-02-05": 6,
            "2026-02-06": 17,
            "2026-02-10": 7,
            "2026-02-13": 3,
            "2026-02-14": 2,
            "2026-02-17": 2,
            "2026-02-18": 2,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 6,
            "2026-02-28": 15,
            "2026-03-17": 16,
            "2026-03-18": 40,
            "2026-03-20": 3,
            "2026-03-24": 3,
            "2026-03-26": 12,
            "2026-03-30": 4,
            "2026-04-22": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 607.16,
          "mode_time_hours": 769.0,
          "mode_frequency": 3,
          "time_distribution": {
            "30-32h": 1,
            "36-38h": 1,
            "82-84h": 1,
            "136-138h": 2,
            "178-180h": 1,
            "184-186h": 1,
            "192-194h": 1,
            "212-214h": 1,
            "250-252h": 1,
            "344-346h": 1,
            "364-366h": 2,
            "374-376h": 1,
            "408-410h": 2,
            "430-432h": 1,
            "442-444h": 1,
            "476-478h": 2,
            "478-480h": 2,
            "486-488h": 1,
            "500-502h": 2,
            "504-506h": 1,
            "552-554h": 1,
            "564-566h": 2,
            "574-576h": 1,
            "576-578h": 1,
            "618-620h": 1,
            "638-640h": 2,
            "664-666h": 1,
            "694-696h": 1,
            "720-722h": 1,
            "734-736h": 2,
            "738-740h": 1,
            "768-770h": 3,
            "814-816h": 1,
            "826-828h": 1,
            "844-846h": 1,
            "852-854h": 1,
            "900-902h": 1,
            "902-904h": 2,
            "1406-1408h": 1,
            "1416-1418h": 1,
            "2036-2038h": 1,
            "2054-2056h": 1
          },
          "tickets_count": 66,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-11": 4,
            "2025-12-15": 1,
            "2025-12-16": 2,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-02": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-18": 1,
            "2026-02-19": 37,
            "2026-02-23": 10,
            "2026-03-02": 1,
            "2026-03-03": 1
          },
          "time_per_day": {
            "2025-12-03": 30.937077777777777,
            "2025-12-05": 430.9912627777778,
            "2025-12-11": 1033.881156111111,
            "2025-12-15": 344.41333194444445,
            "2025-12-16": 730.2928372222223,
            "2025-12-19": 443.54567305555554,
            "2025-12-22": 845.3953316666667,
            "2025-12-29": 694.3345916666666,
            "2026-01-02": 1806.366112222222,
            "2026-01-27": 36.80657888888889,
            "2026-02-05": 179.07435750000002,
            "2026-02-18": 2036.1929041666667,
            "2026-02-19": 24174.600696944446
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-11": 4,
            "2025-12-15": 1,
            "2025-12-16": 2,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-02": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-18": 1,
            "2026-02-19": 37
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 174.78,
            "mode_time_hours": 1.0,
            "mode_frequency": 142,
            "time_distribution": {
              "0-2h": 142,
              "2-4h": 18,
              "4-6h": 7,
              "6-8h": 6,
              "8-10h": 4,
              "10-12h": 6,
              "12-14h": 5,
              "14-16h": 5,
              "16-18h": 1,
              "18-20h": 3,
              "20-22h": 2,
              "24-26h": 6,
              "26-28h": 1,
              "28-30h": 2,
              "30-32h": 4,
              "32-34h": 3,
              "34-36h": 4,
              "36-38h": 16,
              "38-40h": 7,
              "40-42h": 3,
              "42-44h": 1,
              "44-46h": 2,
              "46-48h": 5,
              "48-50h": 3,
              "50-52h": 2,
              "52-54h": 14,
              "54-56h": 1,
              "56-58h": 1,
              "58-60h": 2,
              "66-68h": 1,
              "68-70h": 2,
              "72-74h": 1,
              "74-76h": 2,
              "76-78h": 1,
              "78-80h": 3,
              "80-82h": 3,
              "82-84h": 8,
              "84-86h": 1,
              "88-90h": 2,
              "92-94h": 2,
              "94-96h": 4,
              "96-98h": 4,
              "98-100h": 1,
              "102-104h": 5,
              "104-106h": 6,
              "108-110h": 1,
              "112-114h": 3,
              "118-120h": 3,
              "120-122h": 2,
              "122-124h": 1,
              "124-126h": 5,
              "126-128h": 1,
              "128-130h": 3,
              "136-138h": 2,
              "140-142h": 2,
              "144-146h": 3,
              "150-152h": 5,
              "154-156h": 2,
              "160-162h": 4,
              "162-164h": 1,
              "166-168h": 1,
              "172-174h": 2,
              "176-178h": 1,
              "178-180h": 2,
              "184-186h": 1,
              "192-194h": 2,
              "198-200h": 1,
              "200-202h": 4,
              "204-206h": 1,
              "206-208h": 1,
              "212-214h": 1,
              "216-218h": 3,
              "222-224h": 1,
              "234-236h": 1,
              "250-252h": 1,
              "268-270h": 2,
              "276-278h": 3,
              "280-282h": 1,
              "306-308h": 2,
              "312-314h": 2,
              "320-322h": 1,
              "330-332h": 1,
              "332-334h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "340-342h": 2,
              "344-346h": 1,
              "348-350h": 1,
              "354-356h": 1,
              "358-360h": 1,
              "360-362h": 2,
              "362-364h": 1,
              "364-366h": 2,
              "372-374h": 1,
              "374-376h": 1,
              "382-384h": 1,
              "384-386h": 4,
              "398-400h": 5,
              "400-402h": 1,
              "402-404h": 1,
              "406-408h": 1,
              "408-410h": 2,
              "412-414h": 1,
              "420-422h": 2,
              "422-424h": 1,
              "426-428h": 1,
              "430-432h": 1,
              "434-436h": 1,
              "438-440h": 2,
              "442-444h": 1,
              "444-446h": 1,
              "464-466h": 1,
              "466-468h": 1,
              "472-474h": 1,
              "476-478h": 2,
              "478-480h": 2,
              "482-484h": 2,
              "486-488h": 1,
              "498-500h": 1,
              "500-502h": 2,
              "502-504h": 2,
              "504-506h": 1,
              "508-510h": 1,
              "510-512h": 3,
              "514-516h": 1,
              "528-530h": 1,
              "530-532h": 1,
              "532-534h": 1,
              "548-550h": 2,
              "552-554h": 1,
              "556-558h": 1,
              "564-566h": 2,
              "574-576h": 1,
              "576-578h": 1,
              "596-598h": 1,
              "614-616h": 2,
              "618-620h": 1,
              "620-622h": 1,
              "624-626h": 1,
              "638-640h": 2,
              "644-646h": 1,
              "646-648h": 1,
              "664-666h": 1,
              "694-696h": 1,
              "702-704h": 1,
              "720-722h": 1,
              "722-724h": 1,
              "726-728h": 1,
              "734-736h": 2,
              "738-740h": 1,
              "768-770h": 3,
              "814-816h": 1,
              "826-828h": 1,
              "836-838h": 1,
              "838-840h": 1,
              "844-846h": 1,
              "852-854h": 1,
              "900-902h": 1,
              "902-904h": 2,
              "1406-1408h": 1,
              "1416-1418h": 1,
              "1506-1508h": 1,
              "1556-1558h": 1,
              "1944-1946h": 1,
              "2036-2038h": 1,
              "2054-2056h": 1
            },
            "tickets_count": 507,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-07": 2,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-22": 1,
              "2025-10-29": 3,
              "2025-11-07": 1,
              "2025-11-11": 1,
              "2025-11-13": 3,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-11-20": 4,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-23": 3,
              "2025-11-24": 5,
              "2025-11-25": 5,
              "2025-11-29": 4,
              "2025-12-02": 6,
              "2025-12-03": 5,
              "2025-12-04": 1,
              "2025-12-05": 3,
              "2025-12-11": 5,
              "2025-12-15": 1,
              "2025-12-16": 2,
              "2025-12-19": 2,
              "2025-12-22": 3,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2026-01-02": 2,
              "2026-01-08": 4,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-21": 2,
              "2026-01-23": 8,
              "2026-01-24": 3,
              "2026-01-26": 1,
              "2026-01-27": 16,
              "2026-01-30": 3,
              "2026-02-02": 2,
              "2026-02-03": 5,
              "2026-02-04": 2,
              "2026-02-05": 7,
              "2026-02-06": 17,
              "2026-02-10": 15,
              "2026-02-13": 10,
              "2026-02-14": 2,
              "2026-02-17": 3,
              "2026-02-18": 4,
              "2026-02-19": 49,
              "2026-02-20": 4,
              "2026-02-21": 2,
              "2026-02-23": 6,
              "2026-02-24": 2,
              "2026-02-26": 3,
              "2026-02-28": 16,
              "2026-03-02": 3,
              "2026-03-04": 2,
              "2026-03-07": 2,
              "2026-03-09": 4,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-17": 16,
              "2026-03-18": 41,
              "2026-03-19": 2,
              "2026-03-20": 4,
              "2026-03-23": 5,
              "2026-03-24": 3,
              "2026-03-26": 13,
              "2026-03-27": 1,
              "2026-03-28": 1,
              "2026-03-30": 6,
              "2026-04-01": 1,
              "2026-04-04": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-10": 2,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-21": 3,
              "2026-04-22": 12,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-04-29": 9,
              "2026-04-30": 4,
              "2026-05-02": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 6,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 4,
              "2026-05-14": 2,
              "2026-05-18": 3,
              "2026-05-19": 4,
              "2026-05-20": 1,
              "2026-05-23": 2,
              "2026-05-25": 5,
              "2026-05-26": 1,
              "2026-05-28": 46,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 3,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-01": 1.2217244444444444,
              "2025-10-03": 38.010268611111115,
              "2025-10-07": 208.79162972222224,
              "2025-10-08": 15.025056388888888,
              "2025-10-09": 10.736087777777778,
              "2025-10-22": 2.1759941666666665,
              "2025-10-29": 115.82729027777776,
              "2025-11-07": 464.49868583333335,
              "2025-11-11": 24.03040138888889,
              "2025-11-13": 1231.243376111111,
              "2025-11-17": 3.9529272222222223,
              "2025-11-18": 0.9757916666666666,
              "2025-11-19": 141.0050425,
              "2025-11-20": 204.96544555555556,
              "2025-11-21": 47.38346138888889,
              "2025-11-22": 0.10855555555555556,
              "2025-11-23": 251.5295225,
              "2025-11-24": 881.2529172222223,
              "2025-11-25": 320.15957805555564,
              "2025-11-29": 522.0137552777778,
              "2025-12-02": 314.49498222222223,
              "2025-12-03": 317.6949266666667,
              "2025-12-04": 112.77025027777778,
              "2025-12-05": 873.0826402777777,
              "2025-12-11": 1227.6395297222223,
              "2025-12-15": 344.41333194444445,
              "2025-12-16": 730.2928372222223,
              "2025-12-19": 443.90922166666667,
              "2025-12-22": 1614.8942358333334,
              "2025-12-26": 66.03713833333333,
              "2025-12-29": 694.3345916666666,
              "2026-01-02": 1806.366112222222,
              "2026-01-08": 139.7559125,
              "2026-01-09": 11.475235,
              "2026-01-13": 25.47695277777778,
              "2026-01-14": 0.6495791666666667,
              "2026-01-15": 46.90678944444444,
              "2026-01-17": 59.23298138888889,
              "2026-01-19": 54.78139444444445,
              "2026-01-21": 189.99884805555556,
              "2026-01-23": 459.07848944444453,
              "2026-01-24": 401.39720833333337,
              "2026-01-26": 5.198082222222222,
              "2026-01-27": 1035.4981947222223,
              "2026-01-30": 414.63324972222216,
              "2026-02-02": 9.437793888888887,
              "2026-02-03": 1239.3969975,
              "2026-02-04": 258.49636361111106,
              "2026-02-05": 967.0616538888889,
              "2026-02-06": 3725.319206111112,
              "2026-02-10": 5797.734476944444,
              "2026-02-13": 290.97115138888887,
              "2026-02-14": 64.19461861111111,
              "2026-02-17": 879.1817355555555,
              "2026-02-18": 4108.645753888889,
              "2026-02-19": 24837.990108333335,
              "2026-02-20": 374.9425391666667,
              "2026-02-21": 25.762951666666666,
              "2026-02-23": 222.98295472222225,
              "2026-02-24": 0.13264916666666665,
              "2026-02-26": 0.20352,
              "2026-02-28": 1139.9071419444447,
              "2026-03-02": 42.34380833333333,
              "2026-03-04": 6.884471666666666,
              "2026-03-07": 3.8608075,
              "2026-03-09": 326.21142138888894,
              "2026-03-11": 0.7279411111111111,
              "2026-03-12": 0.8275083333333334,
              "2026-03-16": 0.5085447222222222,
              "2026-03-17": 657.18613,
              "2026-03-18": 14650.721553888896,
              "2026-03-19": 2.1131416666666665,
              "2026-03-20": 226.05234194444444,
              "2026-03-23": 3.732812777777778,
              "2026-03-24": 601.2162425,
              "2026-03-26": 6401.038848333333,
              "2026-03-27": 0.07198916666666667,
              "2026-03-28": 1.3941166666666667,
              "2026-03-30": 2037.5313861111113,
              "2026-04-01": 0.9902227777777778,
              "2026-04-04": 2.776515,
              "2026-04-06": 1.6641269444444444,
              "2026-04-07": 7.601612222222222,
              "2026-04-08": 0.4575311111111111,
              "2026-04-10": 26.601209166666667,
              "2026-04-13": 0.18762055555555554,
              "2026-04-16": 1.1373188888888888,
              "2026-04-21": 1.794559722222222,
              "2026-04-22": 2436.8386400000004,
              "2026-04-24": 1.1106883333333333,
              "2026-04-27": 0.30150305555555557,
              "2026-04-29": 14.400718611111113,
              "2026-04-30": 59.52813805555556,
              "2026-05-02": 36.59716027777778,
              "2026-05-04": 2.3025136111111113,
              "2026-05-05": 1.1517636111111111,
              "2026-05-06": 163.8901213888889,
              "2026-05-08": 8.583115000000001,
              "2026-05-09": 17.466869166666665,
              "2026-05-11": 8.467306666666666,
              "2026-05-12": 313.3490069444445,
              "2026-05-13": 346.68439916666665,
              "2026-05-14": 148.264485,
              "2026-05-18": 1.7103130555555555,
              "2026-05-19": 1.727167222222222,
              "2026-05-20": 0.31303583333333335,
              "2026-05-23": 15.8137225,
              "2026-05-25": 79.48832944444445,
              "2026-05-26": 10.620747777777778,
              "2026-05-28": 27.445049444444443,
              "2026-06-01": 8.821342777777778,
              "2026-06-02": 1.2200719444444446,
              "2026-06-05": 79.23354027777778,
              "2026-06-08": 3.2511905555555556
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-07": 2,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-22": 1,
              "2025-10-29": 3,
              "2025-11-07": 1,
              "2025-11-11": 1,
              "2025-11-13": 3,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-11-20": 4,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-23": 3,
              "2025-11-24": 5,
              "2025-11-25": 5,
              "2025-11-29": 4,
              "2025-12-02": 6,
              "2025-12-03": 5,
              "2025-12-04": 1,
              "2025-12-05": 3,
              "2025-12-11": 5,
              "2025-12-15": 1,
              "2025-12-16": 2,
              "2025-12-19": 2,
              "2025-12-22": 3,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2026-01-02": 2,
              "2026-01-08": 4,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-21": 2,
              "2026-01-23": 8,
              "2026-01-24": 3,
              "2026-01-26": 1,
              "2026-01-27": 16,
              "2026-01-30": 3,
              "2026-02-02": 2,
              "2026-02-03": 5,
              "2026-02-04": 2,
              "2026-02-05": 7,
              "2026-02-06": 17,
              "2026-02-10": 15,
              "2026-02-13": 10,
              "2026-02-14": 2,
              "2026-02-17": 3,
              "2026-02-18": 4,
              "2026-02-19": 49,
              "2026-02-20": 4,
              "2026-02-21": 2,
              "2026-02-23": 6,
              "2026-02-24": 2,
              "2026-02-26": 3,
              "2026-02-28": 16,
              "2026-03-02": 3,
              "2026-03-04": 2,
              "2026-03-07": 2,
              "2026-03-09": 4,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-17": 16,
              "2026-03-18": 41,
              "2026-03-19": 2,
              "2026-03-20": 4,
              "2026-03-23": 5,
              "2026-03-24": 3,
              "2026-03-26": 13,
              "2026-03-27": 1,
              "2026-03-28": 1,
              "2026-03-30": 6,
              "2026-04-01": 1,
              "2026-04-04": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-10": 2,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-21": 3,
              "2026-04-22": 12,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-04-29": 9,
              "2026-04-30": 4,
              "2026-05-02": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 6,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 4,
              "2026-05-14": 2,
              "2026-05-18": 3,
              "2026-05-19": 4,
              "2026-05-20": 1,
              "2026-05-23": 2,
              "2026-05-25": 5,
              "2026-05-26": 1,
              "2026-05-28": 46,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 3,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 70.12,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "24-26h": 1,
                "94-96h": 1,
                "144-146h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-10-08": 14.909877222222221,
                "2026-02-19": 25.82521138888889,
                "2026-02-20": 94.25224972222222,
                "2026-05-14": 145.47382416666667
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-05-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 25.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 138,
              "time_distribution": {
                "0-2h": 138,
                "2-4h": 13,
                "4-6h": 3,
                "6-8h": 4,
                "8-10h": 2,
                "10-12h": 2,
                "12-14h": 2,
                "14-16h": 2,
                "16-18h": 1,
                "18-20h": 3,
                "24-26h": 1,
                "36-38h": 1,
                "38-40h": 4,
                "40-42h": 1,
                "52-54h": 8,
                "76-78h": 1,
                "92-94h": 1,
                "94-96h": 2,
                "126-128h": 1,
                "162-164h": 1,
                "176-178h": 1,
                "192-194h": 1,
                "198-200h": 1,
                "276-278h": 1,
                "312-314h": 1,
                "320-322h": 1,
                "332-334h": 1,
                "1556-1558h": 1
              },
              "tickets_count": 199,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-29": 1,
                "2025-11-11": 1,
                "2025-11-18": 1,
                "2025-11-22": 1,
                "2025-11-25": 3,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-19": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-30": 2,
                "2026-02-03": 3,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-02-19": 9,
                "2026-02-20": 3,
                "2026-02-21": 1,
                "2026-02-24": 2,
                "2026-02-26": 3,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-04": 2,
                "2026-03-07": 2,
                "2026-03-09": 4,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-18": 1,
                "2026-03-19": 2,
                "2026-03-20": 1,
                "2026-03-23": 5,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-28": 1,
                "2026-03-30": 2,
                "2026-04-01": 1,
                "2026-04-04": 1,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-10": 2,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-21": 3,
                "2026-04-22": 9,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-04-29": 9,
                "2026-04-30": 4,
                "2026-05-02": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 6,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 4,
                "2026-05-14": 1,
                "2026-05-18": 3,
                "2026-05-19": 4,
                "2026-05-20": 1,
                "2026-05-23": 2,
                "2026-05-25": 5,
                "2026-05-26": 1,
                "2026-05-28": 46,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 3,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-10-08": 0.11517916666666667,
                "2025-10-29": 13.68336472222222,
                "2025-11-11": 24.03040138888889,
                "2025-11-18": 0.9757916666666666,
                "2025-11-22": 0.10855555555555556,
                "2025-11-25": 2.761754444444444,
                "2025-12-02": 0.8970416666666666,
                "2025-12-11": 193.75837361111113,
                "2025-12-19": 0.36354861111111114,
                "2026-01-14": 0.6495791666666667,
                "2026-01-19": 0.3417177777777778,
                "2026-01-23": 3.3112319444444442,
                "2026-01-26": 5.198082222222222,
                "2026-01-27": 7.164789444444444,
                "2026-01-30": 6.950875555555555,
                "2026-02-03": 776.3405338888888,
                "2026-02-13": 9.199802777777778,
                "2026-02-17": 1.2391933333333331,
                "2026-02-19": 502.23780361111113,
                "2026-02-20": 280.69028944444443,
                "2026-02-21": 1.0498447222222222,
                "2026-02-24": 0.13264916666666665,
                "2026-02-26": 0.20352,
                "2026-02-28": 2.2058958333333334,
                "2026-03-02": 42.34380833333333,
                "2026-03-04": 6.884471666666666,
                "2026-03-07": 3.8608075,
                "2026-03-09": 326.21142138888894,
                "2026-03-11": 0.7279411111111111,
                "2026-03-12": 0.8275083333333334,
                "2026-03-16": 0.5085447222222222,
                "2026-03-18": 0.2841547222222222,
                "2026-03-19": 2.1131416666666665,
                "2026-03-20": 2.4295066666666667,
                "2026-03-23": 3.732812777777778,
                "2026-03-26": 0.13065805555555557,
                "2026-03-27": 0.07198916666666667,
                "2026-03-28": 1.3941166666666667,
                "2026-03-30": 12.24611611111111,
                "2026-04-01": 0.9902227777777778,
                "2026-04-04": 2.776515,
                "2026-04-06": 1.6641269444444444,
                "2026-04-07": 7.601612222222222,
                "2026-04-08": 0.4575311111111111,
                "2026-04-10": 26.601209166666667,
                "2026-04-13": 0.18762055555555554,
                "2026-04-16": 1.1373188888888888,
                "2026-04-21": 1.794559722222222,
                "2026-04-22": 1560.1667608333335,
                "2026-04-24": 1.1106883333333333,
                "2026-04-27": 0.30150305555555557,
                "2026-04-29": 14.400718611111113,
                "2026-04-30": 59.52813805555556,
                "2026-05-02": 36.59716027777778,
                "2026-05-04": 2.3025136111111113,
                "2026-05-05": 1.1517636111111111,
                "2026-05-06": 163.8901213888889,
                "2026-05-08": 8.583115000000001,
                "2026-05-09": 17.466869166666665,
                "2026-05-11": 8.467306666666666,
                "2026-05-12": 313.3490069444445,
                "2026-05-13": 346.68439916666665,
                "2026-05-14": 2.7906608333333334,
                "2026-05-18": 1.7103130555555555,
                "2026-05-19": 1.727167222222222,
                "2026-05-20": 0.31303583333333335,
                "2026-05-23": 15.8137225,
                "2026-05-25": 79.48832944444445,
                "2026-05-26": 10.620747777777778,
                "2026-05-28": 27.445049444444443,
                "2026-06-01": 8.821342777777778,
                "2026-06-02": 1.2200719444444446,
                "2026-06-05": 79.23354027777778,
                "2026-06-08": 3.2511905555555556
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-29": 1,
                "2025-11-11": 1,
                "2025-11-18": 1,
                "2025-11-22": 1,
                "2025-11-25": 3,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-19": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-30": 2,
                "2026-02-03": 3,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-02-19": 9,
                "2026-02-20": 3,
                "2026-02-21": 1,
                "2026-02-24": 2,
                "2026-02-26": 3,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-04": 2,
                "2026-03-07": 2,
                "2026-03-09": 4,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-18": 1,
                "2026-03-19": 2,
                "2026-03-20": 1,
                "2026-03-23": 5,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-28": 1,
                "2026-03-30": 2,
                "2026-04-01": 1,
                "2026-04-04": 1,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-10": 2,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-21": 3,
                "2026-04-22": 9,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-04-29": 9,
                "2026-04-30": 4,
                "2026-05-02": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 6,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 4,
                "2026-05-14": 1,
                "2026-05-18": 3,
                "2026-05-19": 4,
                "2026-05-20": 1,
                "2026-05-23": 2,
                "2026-05-25": 5,
                "2026-05-26": 1,
                "2026-05-28": 46,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 3,
                "2026-06-08": 2
              }
            },
            "P3": {
              "avg_time_hours": 221.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "4-6h": 2,
                "8-10h": 1,
                "26-28h": 1,
                "28-30h": 2,
                "30-32h": 2,
                "32-34h": 3,
                "38-40h": 1,
                "46-48h": 1,
                "52-54h": 1,
                "66-68h": 1,
                "92-94h": 1,
                "200-202h": 1,
                "268-270h": 1,
                "312-314h": 1,
                "434-436h": 1,
                "482-484h": 1,
                "510-512h": 2,
                "528-530h": 1,
                "596-598h": 1,
                "722-724h": 1,
                "1944-1946h": 1
              },
              "tickets_count": 32,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-03": 1,
                "2025-11-13": 1,
                "2025-11-25": 1,
                "2025-12-02": 2,
                "2025-12-05": 1,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-23": 4,
                "2026-02-02": 2,
                "2026-02-03": 2,
                "2026-02-10": 8,
                "2026-02-13": 5,
                "2026-02-18": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-10-01": 1.2217244444444444,
                "2025-10-03": 38.010268611111115,
                "2025-11-13": 1.8089766666666667,
                "2025-11-25": 312.9755983333334,
                "2025-12-02": 102.43351972222221,
                "2025-12-05": 269.9276883333333,
                "2025-12-22": 722.1201149999999,
                "2025-12-26": 66.03713833333333,
                "2026-01-23": 55.313469722222216,
                "2026-02-02": 9.437793888888887,
                "2026-02-03": 463.05646361111116,
                "2026-02-10": 2892.4106083333327,
                "2026-02-13": 154.20927555555556,
                "2026-02-18": 1944.837333888889,
                "2026-02-19": 52.46980305555555
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-03": 1,
                "2025-11-13": 1,
                "2025-11-25": 1,
                "2025-12-02": 2,
                "2025-12-05": 1,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-23": 4,
                "2026-02-02": 2,
                "2026-02-03": 2,
                "2026-02-10": 8,
                "2026-02-13": 5,
                "2026-02-18": 1,
                "2026-02-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 199.13,
              "mode_time_hours": 37.0,
              "mode_frequency": 14,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 3,
                "4-6h": 2,
                "6-8h": 2,
                "8-10h": 1,
                "10-12h": 4,
                "12-14h": 3,
                "14-16h": 2,
                "20-22h": 2,
                "24-26h": 4,
                "30-32h": 1,
                "34-36h": 4,
                "36-38h": 14,
                "38-40h": 2,
                "40-42h": 2,
                "42-44h": 1,
                "44-46h": 2,
                "46-48h": 4,
                "48-50h": 3,
                "50-52h": 2,
                "52-54h": 5,
                "54-56h": 1,
                "56-58h": 1,
                "58-60h": 2,
                "68-70h": 2,
                "72-74h": 1,
                "74-76h": 2,
                "78-80h": 3,
                "80-82h": 3,
                "82-84h": 7,
                "84-86h": 1,
                "88-90h": 2,
                "94-96h": 1,
                "96-98h": 4,
                "98-100h": 1,
                "102-104h": 5,
                "104-106h": 6,
                "108-110h": 1,
                "112-114h": 3,
                "118-120h": 3,
                "120-122h": 2,
                "122-124h": 1,
                "124-126h": 5,
                "128-130h": 3,
                "140-142h": 2,
                "144-146h": 2,
                "150-152h": 5,
                "154-156h": 2,
                "160-162h": 4,
                "166-168h": 1,
                "172-174h": 2,
                "178-180h": 1,
                "200-202h": 3,
                "204-206h": 1,
                "206-208h": 1,
                "216-218h": 3,
                "222-224h": 1,
                "234-236h": 1,
                "268-270h": 1,
                "276-278h": 2,
                "280-282h": 1,
                "306-308h": 2,
                "330-332h": 1,
                "334-336h": 1,
                "336-338h": 1,
                "340-342h": 2,
                "348-350h": 1,
                "354-356h": 1,
                "358-360h": 1,
                "360-362h": 2,
                "362-364h": 1,
                "372-374h": 1,
                "382-384h": 1,
                "384-386h": 4,
                "398-400h": 5,
                "400-402h": 1,
                "402-404h": 1,
                "406-408h": 1,
                "412-414h": 1,
                "420-422h": 2,
                "422-424h": 1,
                "426-428h": 1,
                "438-440h": 2,
                "444-446h": 1,
                "464-466h": 1,
                "466-468h": 1,
                "472-474h": 1,
                "482-484h": 1,
                "498-500h": 1,
                "502-504h": 2,
                "508-510h": 1,
                "510-512h": 1,
                "514-516h": 1,
                "530-532h": 1,
                "532-534h": 1,
                "548-550h": 2,
                "556-558h": 1,
                "614-616h": 2,
                "620-622h": 1,
                "624-626h": 1,
                "644-646h": 1,
                "646-648h": 1,
                "702-704h": 1,
                "726-728h": 1,
                "836-838h": 1,
                "838-840h": 1,
                "1506-1508h": 1
              },
              "tickets_count": 218,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-22": 1,
                "2025-10-29": 2,
                "2025-11-07": 1,
                "2025-11-13": 2,
                "2025-11-17": 1,
                "2025-11-19": 2,
                "2025-11-20": 4,
                "2025-11-21": 1,
                "2025-11-23": 3,
                "2025-11-24": 5,
                "2025-11-25": 1,
                "2025-11-29": 4,
                "2025-12-02": 3,
                "2025-12-03": 4,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-22": 1,
                "2026-01-08": 4,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-15": 2,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-21": 2,
                "2026-01-23": 3,
                "2026-01-24": 3,
                "2026-01-27": 14,
                "2026-01-30": 1,
                "2026-02-04": 2,
                "2026-02-05": 6,
                "2026-02-06": 17,
                "2026-02-10": 7,
                "2026-02-13": 3,
                "2026-02-14": 2,
                "2026-02-17": 2,
                "2026-02-18": 2,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 6,
                "2026-02-28": 15,
                "2026-03-17": 16,
                "2026-03-18": 40,
                "2026-03-20": 3,
                "2026-03-24": 3,
                "2026-03-26": 12,
                "2026-03-30": 4,
                "2026-04-22": 3
              },
              "time_per_day": {
                "2025-10-07": 208.79162972222224,
                "2025-10-09": 10.736087777777778,
                "2025-10-22": 2.1759941666666665,
                "2025-10-29": 102.14392555555554,
                "2025-11-07": 464.49868583333335,
                "2025-11-13": 1229.4343994444444,
                "2025-11-17": 3.9529272222222223,
                "2025-11-19": 141.0050425,
                "2025-11-20": 204.96544555555556,
                "2025-11-21": 47.38346138888889,
                "2025-11-23": 251.5295225,
                "2025-11-24": 881.2529172222223,
                "2025-11-25": 4.422225277777778,
                "2025-11-29": 522.0137552777778,
                "2025-12-02": 211.16442083333334,
                "2025-12-03": 286.7578488888889,
                "2025-12-04": 112.77025027777778,
                "2025-12-05": 172.16368916666664,
                "2025-12-22": 47.37878916666667,
                "2026-01-08": 139.7559125,
                "2026-01-09": 11.475235,
                "2026-01-13": 25.47695277777778,
                "2026-01-15": 46.90678944444444,
                "2026-01-17": 59.23298138888889,
                "2026-01-19": 54.43967666666667,
                "2026-01-21": 189.99884805555556,
                "2026-01-23": 400.45378777777785,
                "2026-01-24": 401.39720833333337,
                "2026-01-27": 991.5268263888888,
                "2026-01-30": 407.68237416666665,
                "2026-02-04": 258.49636361111106,
                "2026-02-05": 787.9872963888889,
                "2026-02-06": 3725.319206111112,
                "2026-02-10": 2905.3238686111113,
                "2026-02-13": 127.56207305555554,
                "2026-02-14": 64.19461861111111,
                "2026-02-17": 877.9425422222222,
                "2026-02-18": 127.61551583333332,
                "2026-02-19": 82.85659333333332,
                "2026-02-21": 24.713106944444444,
                "2026-02-23": 222.98295472222225,
                "2026-02-28": 1137.7012461111112,
                "2026-03-17": 657.18613,
                "2026-03-18": 14650.437399166674,
                "2026-03-20": 223.62283527777777,
                "2026-03-24": 601.2162425,
                "2026-03-26": 6400.908190277777,
                "2026-03-30": 2025.28527,
                "2026-04-22": 876.6718791666667
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-22": 1,
                "2025-10-29": 2,
                "2025-11-07": 1,
                "2025-11-13": 2,
                "2025-11-17": 1,
                "2025-11-19": 2,
                "2025-11-20": 4,
                "2025-11-21": 1,
                "2025-11-23": 3,
                "2025-11-24": 5,
                "2025-11-25": 1,
                "2025-11-29": 4,
                "2025-12-02": 3,
                "2025-12-03": 4,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-22": 1,
                "2026-01-08": 4,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-15": 2,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-21": 2,
                "2026-01-23": 3,
                "2026-01-24": 3,
                "2026-01-27": 14,
                "2026-01-30": 1,
                "2026-02-04": 2,
                "2026-02-05": 6,
                "2026-02-06": 17,
                "2026-02-10": 7,
                "2026-02-13": 3,
                "2026-02-14": 2,
                "2026-02-17": 2,
                "2026-02-18": 2,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 6,
                "2026-02-28": 15,
                "2026-03-17": 16,
                "2026-03-18": 40,
                "2026-03-20": 3,
                "2026-03-24": 3,
                "2026-03-26": 12,
                "2026-03-30": 4,
                "2026-04-22": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 607.16,
              "mode_time_hours": 769.0,
              "mode_frequency": 3,
              "time_distribution": {
                "30-32h": 1,
                "36-38h": 1,
                "82-84h": 1,
                "136-138h": 2,
                "178-180h": 1,
                "184-186h": 1,
                "192-194h": 1,
                "212-214h": 1,
                "250-252h": 1,
                "344-346h": 1,
                "364-366h": 2,
                "374-376h": 1,
                "408-410h": 2,
                "430-432h": 1,
                "442-444h": 1,
                "476-478h": 2,
                "478-480h": 2,
                "486-488h": 1,
                "500-502h": 2,
                "504-506h": 1,
                "552-554h": 1,
                "564-566h": 2,
                "574-576h": 1,
                "576-578h": 1,
                "618-620h": 1,
                "638-640h": 2,
                "664-666h": 1,
                "694-696h": 1,
                "720-722h": 1,
                "734-736h": 2,
                "738-740h": 1,
                "768-770h": 3,
                "814-816h": 1,
                "826-828h": 1,
                "844-846h": 1,
                "852-854h": 1,
                "900-902h": 1,
                "902-904h": 2,
                "1406-1408h": 1,
                "1416-1418h": 1,
                "2036-2038h": 1,
                "2054-2056h": 1
              },
              "tickets_count": 54,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-11": 4,
                "2025-12-15": 1,
                "2025-12-16": 2,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-02": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-18": 1,
                "2026-02-19": 37
              },
              "time_per_day": {
                "2025-12-03": 30.937077777777777,
                "2025-12-05": 430.9912627777778,
                "2025-12-11": 1033.881156111111,
                "2025-12-15": 344.41333194444445,
                "2025-12-16": 730.2928372222223,
                "2025-12-19": 443.54567305555554,
                "2025-12-22": 845.3953316666667,
                "2025-12-29": 694.3345916666666,
                "2026-01-02": 1806.366112222222,
                "2026-01-27": 36.80657888888889,
                "2026-02-05": 179.07435750000002,
                "2026-02-18": 2036.1929041666667,
                "2026-02-19": 24174.600696944446
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-11": 4,
                "2025-12-15": 1,
                "2025-12-16": 2,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-02": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-18": 1,
                "2026-02-19": 37
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 39,
            "tickets_per_day": {
              "2026-02-11": 1,
              "2026-02-23": 2,
              "2026-02-25": 1,
              "2026-03-02": 3,
              "2026-03-03": 2,
              "2026-03-05": 1,
              "2026-03-09": 1,
              "2026-03-14": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-22": 2,
              "2026-04-24": 2,
              "2026-04-27": 2,
              "2026-04-28": 1,
              "2026-04-30": 2,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-11": 1,
              "2026-05-12": 1,
              "2026-05-20": 2,
              "2026-05-22": 1,
              "2026-05-25": 1,
              "2026-05-29": 1,
              "2026-06-05": 1,
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 35,
              "tickets_per_day": {
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-05": 1,
                "2026-03-09": 1,
                "2026-03-14": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-22": 2,
                "2026-04-24": 2,
                "2026-04-27": 2,
                "2026-04-28": 1,
                "2026-04-30": 2,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-11": 1,
                "2026-05-12": 1,
                "2026-05-20": 2,
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-29": 1,
                "2026-06-05": 1,
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-23": 2,
                "2026-03-02": 1,
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2026-04-06": 1,
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 20,
            "tickets_per_day": {
              "2026-02-16": 2,
              "2026-02-17": 1,
              "2026-02-23": 8,
              "2026-04-21": 1,
              "2026-04-29": 6,
              "2026-05-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-02-16": 2,
                "2026-02-17": 1,
                "2026-04-21": 1,
                "2026-04-29": 6,
                "2026-05-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-02-23": 8
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 21,
            "tickets_per_day": {
              "2026-02-16": 14,
              "2026-02-17": 5,
              "2026-05-21": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 21,
              "tickets_per_day": {
                "2026-02-16": 14,
                "2026-02-17": 5,
                "2026-05-21": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_83": {
      "overall": {
        "avg_time_hours": 188.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 4,
          "16-18h": 1,
          "18-20h": 4,
          "20-22h": 4,
          "24-26h": 1,
          "30-32h": 1,
          "34-36h": 1,
          "46-48h": 1,
          "48-50h": 1,
          "56-58h": 2,
          "62-64h": 1,
          "70-72h": 1,
          "72-74h": 2,
          "74-76h": 3,
          "88-90h": 1,
          "96-98h": 1,
          "158-160h": 1,
          "186-188h": 1,
          "192-194h": 1,
          "216-218h": 2,
          "222-224h": 1,
          "264-266h": 1,
          "298-300h": 1,
          "336-338h": 1,
          "348-350h": 1,
          "426-428h": 1,
          "492-494h": 1,
          "532-534h": 1,
          "554-556h": 1,
          "592-594h": 1,
          "672-674h": 1,
          "772-774h": 1,
          "902-904h": 1,
          "1392-1394h": 1
        },
        "tickets_count": 53,
        "tickets_per_day": {
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-11-17": 7,
          "2025-11-18": 1,
          "2025-11-22": 2,
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-09": 2,
          "2026-01-27": 1,
          "2026-01-28": 2,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-14": 3,
          "2026-02-19": 2,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-03": 2,
          "2026-03-04": 1,
          "2026-03-16": 2,
          "2026-03-18": 1,
          "2026-03-20": 2,
          "2026-03-27": 1,
          "2026-03-28": 1,
          "2026-03-31": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-05-05": 1,
          "2026-05-21": 1,
          "2026-05-26": 2
        },
        "time_per_day": {
          "2025-10-10": 217.01470638888887,
          "2025-10-14": 97.17121694444444,
          "2025-11-11": 1.712476111111111,
          "2025-11-13": 20.191544166666667,
          "2025-11-17": 446.3174344444444,
          "2025-11-18": 2.7394013888888886,
          "2025-11-22": 136.19279944444443,
          "2026-01-06": 159.9366852777778,
          "2026-01-08": 18.364418611111113,
          "2026-01-09": 1658.1549416666667,
          "2026-01-27": 2.727292777777778,
          "2026-01-28": 41.32530722222222,
          "2026-01-29": 49.87528777777778,
          "2026-01-30": 63.666804166666665,
          "2026-02-03": 349.3183108333333,
          "2026-02-04": 193.33018027777777,
          "2026-02-07": 532.1782808333334,
          "2026-02-10": 104.97228638888889,
          "2026-02-13": 492.9349794444444,
          "2026-02-14": 55.26920055555556,
          "2026-02-19": 205.0215127777778,
          "2026-02-23": 337.55271527777774,
          "2026-03-02": 2.9111511111111112,
          "2026-03-03": 1445.0190961111111,
          "2026-03-04": 25.204518888888888,
          "2026-03-16": 293.3387475,
          "2026-03-18": 299.83422972222223,
          "2026-03-20": 554.4587752777778,
          "2026-03-27": 2.0480727777777776,
          "2026-03-28": 20.119777777777777,
          "2026-03-31": 592.9497327777779,
          "2026-04-17": 902.2539983333332,
          "2026-04-18": 1.4754425,
          "2026-05-05": 426.1046969444444,
          "2026-05-21": 216.27364333333335,
          "2026-05-26": 1.8820036111111111
        },
        "time_count_per_day": {
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-11-17": 7,
          "2025-11-18": 1,
          "2025-11-22": 2,
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-09": 2,
          "2026-01-27": 1,
          "2026-01-28": 2,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-14": 3,
          "2026-02-19": 2,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-03": 2,
          "2026-03-04": 1,
          "2026-03-16": 2,
          "2026-03-18": 1,
          "2026-03-20": 2,
          "2026-03-27": 1,
          "2026-03-28": 1,
          "2026-03-31": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-05-05": 1,
          "2026-05-21": 1,
          "2026-05-26": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 249.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 2,
            "18-20h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "56-58h": 2,
            "62-64h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "74-76h": 3,
            "96-98h": 1,
            "158-160h": 1,
            "186-188h": 1,
            "216-218h": 1,
            "222-224h": 1,
            "264-266h": 1,
            "298-300h": 1,
            "336-338h": 1,
            "426-428h": 1,
            "532-534h": 1,
            "554-556h": 1,
            "592-594h": 1,
            "672-674h": 1,
            "772-774h": 1,
            "902-904h": 1,
            "1392-1394h": 1
          },
          "tickets_count": 33,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-11-17": 6,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-30": 1,
            "2026-02-07": 1,
            "2026-02-19": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-03": 2,
            "2026-03-04": 1,
            "2026-03-16": 2,
            "2026-03-18": 1,
            "2026-03-20": 2,
            "2026-03-27": 1,
            "2026-03-28": 1,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-05-05": 1,
            "2026-05-21": 1,
            "2026-05-26": 2
          },
          "time_per_day": {
            "2025-10-14": 97.17121694444444,
            "2025-11-17": 411.2262833333333,
            "2026-01-06": 159.9366852777778,
            "2026-01-08": 18.364418611111113,
            "2026-01-09": 1658.1549416666667,
            "2026-01-30": 63.666804166666665,
            "2026-02-07": 532.1782808333334,
            "2026-02-19": 187.28868111111112,
            "2026-02-23": 337.55271527777774,
            "2026-03-02": 2.9111511111111112,
            "2026-03-03": 1445.0190961111111,
            "2026-03-04": 25.204518888888888,
            "2026-03-16": 293.3387475,
            "2026-03-18": 299.83422972222223,
            "2026-03-20": 554.4587752777778,
            "2026-03-27": 2.0480727777777776,
            "2026-03-28": 20.119777777777777,
            "2026-03-31": 592.9497327777779,
            "2026-04-17": 902.2539983333332,
            "2026-04-18": 1.4754425,
            "2026-05-05": 426.1046969444444,
            "2026-05-21": 216.27364333333335,
            "2026-05-26": 1.8820036111111111
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-11-17": 6,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-30": 1,
            "2026-02-07": 1,
            "2026-02-19": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-03": 2,
            "2026-03-04": 1,
            "2026-03-16": 2,
            "2026-03-18": 1,
            "2026-03-20": 2,
            "2026-03-27": 1,
            "2026-03-28": 1,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-05-05": 1,
            "2026-05-21": 1,
            "2026-05-26": 2
          }
        },
        "P3": {
          "avg_time_hours": 86.02,
          "mode_time_hours": 21.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2,
            "16-18h": 1,
            "18-20h": 3,
            "20-22h": 3,
            "30-32h": 1,
            "34-36h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "72-74h": 1,
            "88-90h": 1,
            "192-194h": 1,
            "216-218h": 1,
            "348-350h": 1,
            "492-494h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-18": 1,
            "2025-11-22": 2,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-02-14": 3,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-10-10": 217.01470638888887,
            "2025-11-11": 1.712476111111111,
            "2025-11-13": 20.191544166666667,
            "2025-11-17": 35.09115111111111,
            "2025-11-18": 2.7394013888888886,
            "2025-11-22": 136.19279944444443,
            "2026-01-27": 2.727292777777778,
            "2026-01-28": 41.32530722222222,
            "2026-01-29": 49.87528777777778,
            "2026-02-03": 349.3183108333333,
            "2026-02-04": 193.33018027777777,
            "2026-02-10": 104.97228638888889,
            "2026-02-13": 492.9349794444444,
            "2026-02-14": 55.26920055555556,
            "2026-02-19": 17.732831666666666
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-18": 1,
            "2025-11-22": 2,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-02-14": 3,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 188.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 4,
              "16-18h": 1,
              "18-20h": 4,
              "20-22h": 4,
              "24-26h": 1,
              "30-32h": 1,
              "34-36h": 1,
              "46-48h": 1,
              "48-50h": 1,
              "56-58h": 2,
              "62-64h": 1,
              "70-72h": 1,
              "72-74h": 2,
              "74-76h": 3,
              "88-90h": 1,
              "96-98h": 1,
              "158-160h": 1,
              "186-188h": 1,
              "192-194h": 1,
              "216-218h": 2,
              "222-224h": 1,
              "264-266h": 1,
              "298-300h": 1,
              "336-338h": 1,
              "348-350h": 1,
              "426-428h": 1,
              "492-494h": 1,
              "532-534h": 1,
              "554-556h": 1,
              "592-594h": 1,
              "672-674h": 1,
              "772-774h": 1,
              "902-904h": 1,
              "1392-1394h": 1
            },
            "tickets_count": 53,
            "tickets_per_day": {
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-11-17": 7,
              "2025-11-18": 1,
              "2025-11-22": 2,
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-09": 2,
              "2026-01-27": 1,
              "2026-01-28": 2,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-14": 3,
              "2026-02-19": 2,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-03": 2,
              "2026-03-04": 1,
              "2026-03-16": 2,
              "2026-03-18": 1,
              "2026-03-20": 2,
              "2026-03-27": 1,
              "2026-03-28": 1,
              "2026-03-31": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-05-05": 1,
              "2026-05-21": 1,
              "2026-05-26": 2
            },
            "time_per_day": {
              "2025-10-10": 217.01470638888887,
              "2025-10-14": 97.17121694444444,
              "2025-11-11": 1.712476111111111,
              "2025-11-13": 20.191544166666667,
              "2025-11-17": 446.3174344444444,
              "2025-11-18": 2.7394013888888886,
              "2025-11-22": 136.19279944444443,
              "2026-01-06": 159.9366852777778,
              "2026-01-08": 18.364418611111113,
              "2026-01-09": 1658.1549416666667,
              "2026-01-27": 2.727292777777778,
              "2026-01-28": 41.32530722222222,
              "2026-01-29": 49.87528777777778,
              "2026-01-30": 63.666804166666665,
              "2026-02-03": 349.3183108333333,
              "2026-02-04": 193.33018027777777,
              "2026-02-07": 532.1782808333334,
              "2026-02-10": 104.97228638888889,
              "2026-02-13": 492.9349794444444,
              "2026-02-14": 55.26920055555556,
              "2026-02-19": 205.0215127777778,
              "2026-02-23": 337.55271527777774,
              "2026-03-02": 2.9111511111111112,
              "2026-03-03": 1445.0190961111111,
              "2026-03-04": 25.204518888888888,
              "2026-03-16": 293.3387475,
              "2026-03-18": 299.83422972222223,
              "2026-03-20": 554.4587752777778,
              "2026-03-27": 2.0480727777777776,
              "2026-03-28": 20.119777777777777,
              "2026-03-31": 592.9497327777779,
              "2026-04-17": 902.2539983333332,
              "2026-04-18": 1.4754425,
              "2026-05-05": 426.1046969444444,
              "2026-05-21": 216.27364333333335,
              "2026-05-26": 1.8820036111111111
            },
            "time_count_per_day": {
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-11-17": 7,
              "2025-11-18": 1,
              "2025-11-22": 2,
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-09": 2,
              "2026-01-27": 1,
              "2026-01-28": 2,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-14": 3,
              "2026-02-19": 2,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-03": 2,
              "2026-03-04": 1,
              "2026-03-16": 2,
              "2026-03-18": 1,
              "2026-03-20": 2,
              "2026-03-27": 1,
              "2026-03-28": 1,
              "2026-03-31": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-05-05": 1,
              "2026-05-21": 1,
              "2026-05-26": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 249.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 2,
                "18-20h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "56-58h": 2,
                "62-64h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "74-76h": 3,
                "96-98h": 1,
                "158-160h": 1,
                "186-188h": 1,
                "216-218h": 1,
                "222-224h": 1,
                "264-266h": 1,
                "298-300h": 1,
                "336-338h": 1,
                "426-428h": 1,
                "532-534h": 1,
                "554-556h": 1,
                "592-594h": 1,
                "672-674h": 1,
                "772-774h": 1,
                "902-904h": 1,
                "1392-1394h": 1
              },
              "tickets_count": 33,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-11-17": 6,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-30": 1,
                "2026-02-07": 1,
                "2026-02-19": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-03": 2,
                "2026-03-04": 1,
                "2026-03-16": 2,
                "2026-03-18": 1,
                "2026-03-20": 2,
                "2026-03-27": 1,
                "2026-03-28": 1,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-05": 1,
                "2026-05-21": 1,
                "2026-05-26": 2
              },
              "time_per_day": {
                "2025-10-14": 97.17121694444444,
                "2025-11-17": 411.2262833333333,
                "2026-01-06": 159.9366852777778,
                "2026-01-08": 18.364418611111113,
                "2026-01-09": 1658.1549416666667,
                "2026-01-30": 63.666804166666665,
                "2026-02-07": 532.1782808333334,
                "2026-02-19": 187.28868111111112,
                "2026-02-23": 337.55271527777774,
                "2026-03-02": 2.9111511111111112,
                "2026-03-03": 1445.0190961111111,
                "2026-03-04": 25.204518888888888,
                "2026-03-16": 293.3387475,
                "2026-03-18": 299.83422972222223,
                "2026-03-20": 554.4587752777778,
                "2026-03-27": 2.0480727777777776,
                "2026-03-28": 20.119777777777777,
                "2026-03-31": 592.9497327777779,
                "2026-04-17": 902.2539983333332,
                "2026-04-18": 1.4754425,
                "2026-05-05": 426.1046969444444,
                "2026-05-21": 216.27364333333335,
                "2026-05-26": 1.8820036111111111
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-11-17": 6,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-30": 1,
                "2026-02-07": 1,
                "2026-02-19": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-03": 2,
                "2026-03-04": 1,
                "2026-03-16": 2,
                "2026-03-18": 1,
                "2026-03-20": 2,
                "2026-03-27": 1,
                "2026-03-28": 1,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-05": 1,
                "2026-05-21": 1,
                "2026-05-26": 2
              }
            },
            "P3": {
              "avg_time_hours": 86.02,
              "mode_time_hours": 21.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2,
                "16-18h": 1,
                "18-20h": 3,
                "20-22h": 3,
                "30-32h": 1,
                "34-36h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "72-74h": 1,
                "88-90h": 1,
                "192-194h": 1,
                "216-218h": 1,
                "348-350h": 1,
                "492-494h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-18": 1,
                "2025-11-22": 2,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-02-14": 3,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-10-10": 217.01470638888887,
                "2025-11-11": 1.712476111111111,
                "2025-11-13": 20.191544166666667,
                "2025-11-17": 35.09115111111111,
                "2025-11-18": 2.7394013888888886,
                "2025-11-22": 136.19279944444443,
                "2026-01-27": 2.727292777777778,
                "2026-01-28": 41.32530722222222,
                "2026-01-29": 49.87528777777778,
                "2026-02-03": 349.3183108333333,
                "2026-02-04": 193.33018027777777,
                "2026-02-10": 104.97228638888889,
                "2026-02-13": 492.9349794444444,
                "2026-02-14": 55.26920055555556,
                "2026-02-19": 17.732831666666666
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-18": 1,
                "2025-11-22": 2,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-02-14": 3,
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_40": {
      "overall": {
        "avg_time_hours": 134.31,
        "mode_time_hours": 1.0,
        "mode_frequency": 256,
        "time_distribution": {
          "0-2h": 256,
          "2-4h": 62,
          "4-6h": 58,
          "6-8h": 79,
          "8-10h": 43,
          "10-12h": 12,
          "12-14h": 9,
          "14-16h": 3,
          "16-18h": 14,
          "18-20h": 2,
          "20-22h": 5,
          "22-24h": 11,
          "24-26h": 7,
          "26-28h": 13,
          "28-30h": 10,
          "30-32h": 24,
          "32-34h": 16,
          "34-36h": 5,
          "36-38h": 2,
          "38-40h": 3,
          "40-42h": 2,
          "42-44h": 1,
          "44-46h": 2,
          "46-48h": 5,
          "48-50h": 3,
          "50-52h": 5,
          "52-54h": 5,
          "54-56h": 14,
          "56-58h": 5,
          "58-60h": 3,
          "70-72h": 3,
          "72-74h": 2,
          "74-76h": 5,
          "76-78h": 5,
          "78-80h": 6,
          "84-86h": 1,
          "86-88h": 1,
          "88-90h": 1,
          "90-92h": 1,
          "92-94h": 2,
          "94-96h": 4,
          "96-98h": 1,
          "98-100h": 2,
          "100-102h": 3,
          "104-106h": 1,
          "112-114h": 1,
          "116-118h": 2,
          "118-120h": 1,
          "120-122h": 4,
          "122-124h": 2,
          "124-126h": 3,
          "126-128h": 2,
          "134-136h": 1,
          "138-140h": 2,
          "140-142h": 4,
          "142-144h": 2,
          "144-146h": 1,
          "146-148h": 4,
          "148-150h": 2,
          "158-160h": 1,
          "160-162h": 2,
          "162-164h": 2,
          "164-166h": 1,
          "166-168h": 1,
          "170-172h": 1,
          "172-174h": 1,
          "174-176h": 2,
          "176-178h": 1,
          "178-180h": 1,
          "180-182h": 1,
          "184-186h": 1,
          "186-188h": 1,
          "188-190h": 1,
          "190-192h": 1,
          "192-194h": 2,
          "196-198h": 1,
          "198-200h": 2,
          "200-202h": 2,
          "202-204h": 1,
          "206-208h": 1,
          "208-210h": 1,
          "212-214h": 1,
          "214-216h": 1,
          "216-218h": 2,
          "218-220h": 1,
          "226-228h": 1,
          "232-234h": 1,
          "236-238h": 1,
          "240-242h": 2,
          "242-244h": 2,
          "246-248h": 1,
          "250-252h": 1,
          "260-262h": 1,
          "264-266h": 1,
          "266-268h": 2,
          "272-274h": 1,
          "276-278h": 1,
          "282-284h": 1,
          "284-286h": 1,
          "288-290h": 1,
          "302-304h": 1,
          "308-310h": 2,
          "314-316h": 1,
          "318-320h": 1,
          "332-334h": 4,
          "334-336h": 1,
          "338-340h": 2,
          "340-342h": 1,
          "344-346h": 1,
          "352-354h": 2,
          "354-356h": 1,
          "356-358h": 1,
          "358-360h": 2,
          "366-368h": 1,
          "368-370h": 1,
          "372-374h": 1,
          "380-382h": 1,
          "382-384h": 1,
          "384-386h": 2,
          "386-388h": 1,
          "398-400h": 1,
          "400-402h": 1,
          "404-406h": 2,
          "406-408h": 1,
          "408-410h": 2,
          "410-412h": 2,
          "414-416h": 1,
          "416-418h": 1,
          "418-420h": 1,
          "420-422h": 2,
          "424-426h": 1,
          "430-432h": 1,
          "434-436h": 1,
          "440-442h": 1,
          "446-448h": 2,
          "462-464h": 1,
          "472-474h": 1,
          "494-496h": 1,
          "496-498h": 1,
          "498-500h": 1,
          "504-506h": 2,
          "516-518h": 1,
          "518-520h": 1,
          "526-528h": 1,
          "532-534h": 1,
          "540-542h": 2,
          "542-544h": 1,
          "556-558h": 1,
          "560-562h": 1,
          "576-578h": 1,
          "582-584h": 1,
          "604-606h": 1,
          "620-622h": 1,
          "622-624h": 1,
          "624-626h": 1,
          "628-630h": 3,
          "642-644h": 1,
          "648-650h": 3,
          "652-654h": 1,
          "662-664h": 1,
          "666-668h": 1,
          "668-670h": 1,
          "670-672h": 1,
          "672-674h": 1,
          "678-680h": 3,
          "692-694h": 1,
          "700-702h": 1,
          "704-706h": 1,
          "720-722h": 1,
          "724-726h": 2,
          "742-744h": 1,
          "748-750h": 1,
          "750-752h": 1,
          "772-774h": 1,
          "800-802h": 1,
          "814-816h": 1,
          "846-848h": 1,
          "860-862h": 1,
          "866-868h": 1,
          "884-886h": 1,
          "886-888h": 1,
          "890-892h": 2,
          "892-894h": 1,
          "896-898h": 1,
          "916-918h": 1,
          "954-956h": 1,
          "956-958h": 1,
          "970-972h": 1,
          "986-988h": 2,
          "1000-1002h": 1,
          "1002-1004h": 1,
          "1008-1010h": 1,
          "1034-1036h": 1,
          "1038-1040h": 1,
          "1054-1056h": 1,
          "1056-1058h": 1,
          "1076-1078h": 1,
          "1078-1080h": 1,
          "1114-1116h": 1,
          "1174-1176h": 1,
          "1200-1202h": 1,
          "1342-1344h": 1,
          "1462-1464h": 1,
          "1480-1482h": 1,
          "1482-1484h": 1,
          "1506-1508h": 1,
          "1546-1548h": 1,
          "1562-1564h": 1,
          "1582-1584h": 1,
          "1684-1686h": 1,
          "1712-1714h": 1,
          "1732-1734h": 1,
          "1778-1780h": 1,
          "2138-2140h": 1,
          "3550-3552h": 1
        },
        "tickets_count": 1017,
        "tickets_per_day": {
          "2025-10-06": 3,
          "2025-10-07": 2,
          "2025-10-09": 2,
          "2025-10-10": 9,
          "2025-10-12": 1,
          "2025-10-13": 5,
          "2025-10-14": 6,
          "2025-10-15": 2,
          "2025-10-17": 2,
          "2025-10-20": 5,
          "2025-10-21": 4,
          "2025-10-22": 6,
          "2025-10-23": 5,
          "2025-10-24": 3,
          "2025-10-27": 2,
          "2025-10-28": 6,
          "2025-10-29": 1,
          "2025-10-31": 4,
          "2025-11-03": 5,
          "2025-11-04": 3,
          "2025-11-05": 4,
          "2025-11-06": 2,
          "2025-11-07": 2,
          "2025-11-10": 8,
          "2025-11-11": 4,
          "2025-11-12": 4,
          "2025-11-13": 5,
          "2025-11-14": 3,
          "2025-11-15": 1,
          "2025-11-17": 1,
          "2025-11-18": 5,
          "2025-11-19": 7,
          "2025-11-20": 2,
          "2025-11-21": 4,
          "2025-11-23": 4,
          "2025-11-24": 5,
          "2025-11-25": 2,
          "2025-11-26": 3,
          "2025-11-27": 8,
          "2025-11-28": 2,
          "2025-12-01": 1,
          "2025-12-02": 8,
          "2025-12-03": 2,
          "2025-12-05": 1,
          "2025-12-09": 2,
          "2025-12-10": 5,
          "2025-12-11": 4,
          "2025-12-12": 6,
          "2025-12-15": 12,
          "2025-12-16": 3,
          "2025-12-17": 2,
          "2025-12-19": 3,
          "2025-12-21": 1,
          "2025-12-22": 7,
          "2025-12-23": 1,
          "2025-12-25": 1,
          "2025-12-26": 1,
          "2025-12-28": 3,
          "2025-12-29": 4,
          "2025-12-30": 2,
          "2025-12-31": 1,
          "2026-01-02": 3,
          "2026-01-05": 2,
          "2026-01-06": 1,
          "2026-01-07": 6,
          "2026-01-08": 5,
          "2026-01-09": 1,
          "2026-01-12": 6,
          "2026-01-13": 6,
          "2026-01-14": 10,
          "2026-01-15": 8,
          "2026-01-16": 4,
          "2026-01-17": 4,
          "2026-01-19": 1,
          "2026-01-20": 3,
          "2026-01-21": 3,
          "2026-01-22": 3,
          "2026-01-23": 6,
          "2026-01-24": 2,
          "2026-01-26": 3,
          "2026-01-27": 10,
          "2026-01-29": 3,
          "2026-01-30": 1,
          "2026-02-02": 3,
          "2026-02-03": 4,
          "2026-02-04": 3,
          "2026-02-05": 5,
          "2026-02-06": 9,
          "2026-02-09": 9,
          "2026-02-10": 10,
          "2026-02-12": 8,
          "2026-02-13": 7,
          "2026-02-16": 1,
          "2026-02-17": 4,
          "2026-02-18": 8,
          "2026-02-19": 13,
          "2026-02-21": 10,
          "2026-02-23": 6,
          "2026-02-24": 3,
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-02-28": 8,
          "2026-03-02": 17,
          "2026-03-03": 4,
          "2026-03-04": 6,
          "2026-03-05": 10,
          "2026-03-06": 2,
          "2026-03-07": 1,
          "2026-03-09": 8,
          "2026-03-10": 3,
          "2026-03-11": 8,
          "2026-03-12": 3,
          "2026-03-13": 4,
          "2026-03-14": 2,
          "2026-03-16": 24,
          "2026-03-17": 11,
          "2026-03-18": 26,
          "2026-03-19": 1,
          "2026-03-20": 16,
          "2026-03-23": 13,
          "2026-03-24": 4,
          "2026-03-25": 6,
          "2026-03-26": 4,
          "2026-03-27": 4,
          "2026-03-28": 1,
          "2026-03-30": 5,
          "2026-03-31": 8,
          "2026-04-01": 2,
          "2026-04-02": 3,
          "2026-04-06": 11,
          "2026-04-07": 3,
          "2026-04-08": 7,
          "2026-04-09": 5,
          "2026-04-10": 5,
          "2026-04-11": 2,
          "2026-04-13": 4,
          "2026-04-14": 4,
          "2026-04-15": 7,
          "2026-04-16": 15,
          "2026-04-17": 4,
          "2026-04-18": 4,
          "2026-04-20": 10,
          "2026-04-21": 4,
          "2026-04-22": 7,
          "2026-04-23": 9,
          "2026-04-24": 7,
          "2026-04-28": 10,
          "2026-04-29": 9,
          "2026-04-30": 6,
          "2026-05-02": 4,
          "2026-05-04": 23,
          "2026-05-05": 8,
          "2026-05-06": 11,
          "2026-05-07": 6,
          "2026-05-09": 11,
          "2026-05-11": 19,
          "2026-05-12": 7,
          "2026-05-13": 3,
          "2026-05-14": 7,
          "2026-05-15": 6,
          "2026-05-16": 1,
          "2026-05-18": 14,
          "2026-05-19": 6,
          "2026-05-20": 10,
          "2026-05-21": 5,
          "2026-05-22": 7,
          "2026-05-23": 3,
          "2026-05-25": 17,
          "2026-05-26": 6,
          "2026-05-27": 4,
          "2026-05-28": 7,
          "2026-05-29": 24,
          "2026-05-30": 5,
          "2026-06-01": 21,
          "2026-06-02": 6,
          "2026-06-03": 7,
          "2026-06-05": 8,
          "2026-06-06": 3,
          "2026-06-08": 3
        },
        "time_per_day": {
          "2025-10-06": 193.9069061111111,
          "2025-10-07": 27.322882777777778,
          "2025-10-09": 5.7604275000000005,
          "2025-10-10": 319.75782722222215,
          "2025-10-12": 209.2571233333333,
          "2025-10-13": 309.5293644444444,
          "2025-10-14": 376.9396938888888,
          "2025-10-15": 16.8710125,
          "2025-10-17": 260.33608583333336,
          "2025-10-20": 518.8552722222223,
          "2025-10-21": 123.58970166666668,
          "2025-10-22": 60.94554,
          "2025-10-23": 637.6104916666666,
          "2025-10-24": 510.4742883333333,
          "2025-10-27": 57.40872638888889,
          "2025-10-28": 416.8655969444444,
          "2025-10-29": 47.48235861111112,
          "2025-10-31": 75.86215388888888,
          "2025-11-03": 207.15595027777775,
          "2025-11-04": 9.001379722222222,
          "2025-11-05": 356.3813033333334,
          "2025-11-06": 153.686895,
          "2025-11-07": 9.430285833333333,
          "2025-11-10": 618.7697580555554,
          "2025-11-11": 581.565865,
          "2025-11-12": 112.63452055555555,
          "2025-11-13": 348.5568030555556,
          "2025-11-14": 170.15104333333332,
          "2025-11-15": 0.20001194444444445,
          "2025-11-17": 0.07475361111111112,
          "2025-11-18": 60.770063611111105,
          "2025-11-19": 37.81681722222223,
          "2025-11-20": 80.78824888888889,
          "2025-11-21": 173.16540222222224,
          "2025-11-23": 622.4367611111111,
          "2025-11-24": 338.34369333333336,
          "2025-11-25": 101.00707416666665,
          "2025-11-26": 8.413736111111113,
          "2025-11-27": 739.0166583333332,
          "2025-11-28": 4.079934722222222,
          "2025-12-01": 11.609512222222222,
          "2025-12-02": 1085.2419033333333,
          "2025-12-03": 99.25172166666667,
          "2025-12-05": 0.27298666666666666,
          "2025-12-09": 37.57654611111111,
          "2025-12-10": 278.8189375,
          "2025-12-11": 618.4792983333332,
          "2025-12-12": 831.6508177777778,
          "2025-12-15": 2257.6400283333332,
          "2025-12-16": 102.6038711111111,
          "2025-12-17": 449.7064408333333,
          "2025-12-19": 3.444729166666667,
          "2025-12-21": 89.8079611111111,
          "2025-12-22": 149.58132972222222,
          "2025-12-23": 77.81090555555556,
          "2025-12-25": 56.22132055555555,
          "2025-12-26": 76.171835,
          "2025-12-28": 27.939852499999997,
          "2025-12-29": 215.26909111111112,
          "2025-12-30": 41.038515000000004,
          "2025-12-31": 0.014488333333333334,
          "2026-01-02": 917.3816741666667,
          "2026-01-05": 139.33688722222223,
          "2026-01-06": 32.79596527777778,
          "2026-01-07": 728.9424297222222,
          "2026-01-08": 886.4510222222222,
          "2026-01-09": 26.628954444444446,
          "2026-01-12": 41.27174472222222,
          "2026-01-13": 226.45801666666665,
          "2026-01-14": 125.20340999999999,
          "2026-01-15": 87.93867388888889,
          "2026-01-16": 60.762274166666664,
          "2026-01-17": 357.8757308333333,
          "2026-01-19": 146.16052027777778,
          "2026-01-20": 139.14151944444444,
          "2026-01-21": 69.95103944444445,
          "2026-01-22": 709.3206475,
          "2026-01-23": 1402.9894858333332,
          "2026-01-24": 307.93734861111113,
          "2026-01-26": 348.9046163888888,
          "2026-01-27": 172.97148305555558,
          "2026-01-29": 36.94245277777778,
          "2026-01-30": 9.677766666666667,
          "2026-02-02": 63.62296805555556,
          "2026-02-03": 751.0113361111111,
          "2026-02-04": 144.89914194444444,
          "2026-02-05": 398.0232719444444,
          "2026-02-06": 1593.5759511111112,
          "2026-02-09": 385.8263197222222,
          "2026-02-10": 2260.671730555555,
          "2026-02-12": 5601.766519999999,
          "2026-02-13": 241.68637055555556,
          "2026-02-16": 6.388031111111111,
          "2026-02-17": 1789.3543836111112,
          "2026-02-18": 1118.689406111111,
          "2026-02-19": 3927.032482222222,
          "2026-02-21": 428.0334205555556,
          "2026-02-23": 959.1483575000002,
          "2026-02-24": 74.89359166666667,
          "2026-02-25": 34.94009361111111,
          "2026-02-26": 20.466793888888887,
          "2026-02-28": 366.9267447222222,
          "2026-03-02": 643.0483141666666,
          "2026-03-03": 8.692031111111111,
          "2026-03-04": 352.9782783333333,
          "2026-03-05": 101.76125500000002,
          "2026-03-06": 128.64355472222223,
          "2026-03-07": 4.014266388888889,
          "2026-03-09": 458.2128213888888,
          "2026-03-10": 450.0281675,
          "2026-03-11": 3992.2525433333335,
          "2026-03-12": 13.715893888888889,
          "2026-03-13": 4.007083611111111,
          "2026-03-14": 148.80616583333335,
          "2026-03-16": 365.8602802777777,
          "2026-03-17": 2971.1273116666666,
          "2026-03-18": 8527.449511666671,
          "2026-03-19": 7.699686666666667,
          "2026-03-20": 9390.775983888887,
          "2026-03-23": 285.3385427777777,
          "2026-03-24": 844.1763819444444,
          "2026-03-25": 3.5798472222222224,
          "2026-03-26": 1262.001047222222,
          "2026-03-27": 1700.458145,
          "2026-03-28": 38.522799722222224,
          "2026-03-30": 30.359245833333333,
          "2026-03-31": 16.85687777777778,
          "2026-04-01": 141.08804138888888,
          "2026-04-02": 1078.6394894444445,
          "2026-04-06": 191.3452475,
          "2026-04-07": 19.1516875,
          "2026-04-08": 416.5033469444444,
          "2026-04-09": 39.188669999999995,
          "2026-04-10": 1774.613133888889,
          "2026-04-11": 0.042020277777777774,
          "2026-04-13": 1077.607700277778,
          "2026-04-14": 285.1569311111111,
          "2026-04-15": 1896.1542705555555,
          "2026-04-16": 5887.63123722222,
          "2026-04-17": 2010.1342061111113,
          "2026-04-18": 2922.276483888889,
          "2026-04-20": 726.8239269444445,
          "2026-04-21": 32.81673416666667,
          "2026-04-22": 1062.645471388889,
          "2026-04-23": 7315.651700555557,
          "2026-04-24": 1.2995802777777778,
          "2026-04-28": 1891.5033341666665,
          "2026-04-29": 1215.4960852777779,
          "2026-04-30": 22.954015833333333,
          "2026-05-02": 7.495664166666667,
          "2026-05-04": 4590.278073333334,
          "2026-05-05": 35.5129075,
          "2026-05-06": 2993.501327222222,
          "2026-05-07": 657.0098105555556,
          "2026-05-09": 400.9431152777778,
          "2026-05-11": 71.08669527777776,
          "2026-05-12": 10.443576111111112,
          "2026-05-13": 64.52806166666667,
          "2026-05-14": 4282.683363888889,
          "2026-05-15": 10.805037222222222,
          "2026-05-16": 13.163388333333332,
          "2026-05-18": 846.5174988888888,
          "2026-05-19": 3.0689236111111113,
          "2026-05-20": 6.670005,
          "2026-05-21": 0.7425355555555555,
          "2026-05-22": 5.615225,
          "2026-05-23": 0.09236333333333334,
          "2026-05-25": 94.21852138888889,
          "2026-05-26": 23.057102500000003,
          "2026-05-27": 2449.8958641666663,
          "2026-05-28": 1630.3515219444444,
          "2026-05-29": 170.6907327777778,
          "2026-05-30": 681.3131033333333,
          "2026-06-01": 1839.6562613888887,
          "2026-06-02": 127.4606911111111,
          "2026-06-03": 24.42372138888889,
          "2026-06-05": 46.83106166666666,
          "2026-06-06": 579.278475,
          "2026-06-08": 0.8446169444444445
        },
        "time_count_per_day": {
          "2025-10-06": 3,
          "2025-10-07": 2,
          "2025-10-09": 2,
          "2025-10-10": 9,
          "2025-10-12": 1,
          "2025-10-13": 5,
          "2025-10-14": 6,
          "2025-10-15": 2,
          "2025-10-17": 2,
          "2025-10-20": 5,
          "2025-10-21": 4,
          "2025-10-22": 6,
          "2025-10-23": 5,
          "2025-10-24": 3,
          "2025-10-27": 2,
          "2025-10-28": 6,
          "2025-10-29": 1,
          "2025-10-31": 4,
          "2025-11-03": 5,
          "2025-11-04": 3,
          "2025-11-05": 4,
          "2025-11-06": 2,
          "2025-11-07": 2,
          "2025-11-10": 8,
          "2025-11-11": 4,
          "2025-11-12": 4,
          "2025-11-13": 5,
          "2025-11-14": 3,
          "2025-11-15": 1,
          "2025-11-17": 1,
          "2025-11-18": 5,
          "2025-11-19": 7,
          "2025-11-20": 2,
          "2025-11-21": 4,
          "2025-11-23": 4,
          "2025-11-24": 5,
          "2025-11-25": 2,
          "2025-11-26": 3,
          "2025-11-27": 8,
          "2025-11-28": 2,
          "2025-12-01": 1,
          "2025-12-02": 8,
          "2025-12-03": 2,
          "2025-12-05": 1,
          "2025-12-09": 2,
          "2025-12-10": 5,
          "2025-12-11": 4,
          "2025-12-12": 6,
          "2025-12-15": 12,
          "2025-12-16": 3,
          "2025-12-17": 2,
          "2025-12-19": 3,
          "2025-12-21": 1,
          "2025-12-22": 7,
          "2025-12-23": 1,
          "2025-12-25": 1,
          "2025-12-26": 1,
          "2025-12-28": 2,
          "2025-12-29": 4,
          "2025-12-30": 2,
          "2025-12-31": 1,
          "2026-01-02": 3,
          "2026-01-05": 2,
          "2026-01-06": 1,
          "2026-01-07": 6,
          "2026-01-08": 5,
          "2026-01-09": 1,
          "2026-01-12": 6,
          "2026-01-13": 6,
          "2026-01-14": 10,
          "2026-01-15": 8,
          "2026-01-16": 4,
          "2026-01-17": 4,
          "2026-01-19": 1,
          "2026-01-20": 3,
          "2026-01-21": 3,
          "2026-01-22": 3,
          "2026-01-23": 6,
          "2026-01-24": 2,
          "2026-01-26": 3,
          "2026-01-27": 10,
          "2026-01-29": 3,
          "2026-01-30": 1,
          "2026-02-02": 3,
          "2026-02-03": 4,
          "2026-02-04": 3,
          "2026-02-05": 5,
          "2026-02-06": 9,
          "2026-02-09": 9,
          "2026-02-10": 10,
          "2026-02-12": 8,
          "2026-02-13": 7,
          "2026-02-16": 1,
          "2026-02-17": 3,
          "2026-02-18": 8,
          "2026-02-19": 13,
          "2026-02-21": 10,
          "2026-02-23": 6,
          "2026-02-24": 3,
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-02-28": 8,
          "2026-03-02": 17,
          "2026-03-03": 3,
          "2026-03-04": 6,
          "2026-03-05": 10,
          "2026-03-06": 2,
          "2026-03-07": 1,
          "2026-03-09": 8,
          "2026-03-10": 2,
          "2026-03-11": 8,
          "2026-03-12": 3,
          "2026-03-13": 4,
          "2026-03-14": 2,
          "2026-03-16": 23,
          "2026-03-17": 11,
          "2026-03-18": 26,
          "2026-03-19": 1,
          "2026-03-20": 16,
          "2026-03-23": 12,
          "2026-03-24": 4,
          "2026-03-25": 4,
          "2026-03-26": 3,
          "2026-03-27": 3,
          "2026-03-28": 1,
          "2026-03-30": 4,
          "2026-03-31": 8,
          "2026-04-01": 1,
          "2026-04-02": 2,
          "2026-04-06": 10,
          "2026-04-07": 3,
          "2026-04-08": 7,
          "2026-04-09": 4,
          "2026-04-10": 4,
          "2026-04-11": 1,
          "2026-04-13": 4,
          "2026-04-14": 3,
          "2026-04-15": 6,
          "2026-04-16": 15,
          "2026-04-17": 3,
          "2026-04-18": 4,
          "2026-04-20": 9,
          "2026-04-21": 4,
          "2026-04-22": 7,
          "2026-04-23": 9,
          "2026-04-24": 6,
          "2026-04-28": 9,
          "2026-04-29": 7,
          "2026-04-30": 4,
          "2026-05-02": 4,
          "2026-05-04": 23,
          "2026-05-05": 5,
          "2026-05-06": 6,
          "2026-05-07": 6,
          "2026-05-09": 7,
          "2026-05-11": 15,
          "2026-05-12": 6,
          "2026-05-13": 3,
          "2026-05-14": 4,
          "2026-05-15": 4,
          "2026-05-16": 1,
          "2026-05-18": 14,
          "2026-05-19": 5,
          "2026-05-20": 8,
          "2026-05-21": 2,
          "2026-05-22": 5,
          "2026-05-23": 2,
          "2026-05-25": 17,
          "2026-05-26": 6,
          "2026-05-27": 4,
          "2026-05-28": 5,
          "2026-05-29": 20,
          "2026-05-30": 4,
          "2026-06-01": 15,
          "2026-06-02": 5,
          "2026-06-03": 5,
          "2026-06-05": 5,
          "2026-06-06": 2,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 29.27,
          "mode_time_hours": 7.0,
          "mode_frequency": 16,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 7,
            "4-6h": 3,
            "6-8h": 16,
            "8-10h": 9,
            "10-12h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "20-22h": 1,
            "22-24h": 4,
            "24-26h": 1,
            "26-28h": 1,
            "32-34h": 1,
            "52-54h": 2,
            "54-56h": 11,
            "78-80h": 1,
            "86-88h": 1,
            "92-94h": 1,
            "100-102h": 1,
            "122-124h": 2,
            "126-128h": 1,
            "212-214h": 1
          },
          "tickets_count": 76,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-10": 2,
            "2025-10-13": 1,
            "2025-10-22": 2,
            "2025-10-28": 1,
            "2025-11-07": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2026-01-14": 1,
            "2026-01-16": 2,
            "2026-01-23": 2,
            "2026-01-27": 2,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-06": 1,
            "2026-02-09": 4,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-03-02": 4,
            "2026-03-04": 3,
            "2026-03-06": 1,
            "2026-03-09": 2,
            "2026-03-11": 2,
            "2026-03-13": 2,
            "2026-03-16": 13,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-04-06": 2,
            "2026-04-09": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-29": 1,
            "2026-05-04": 6,
            "2026-05-11": 2,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-22": 2,
            "2026-05-29": 1,
            "2026-06-03": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-06": 122.02680027777778,
            "2025-10-10": 116.93766361111112,
            "2025-10-13": 123.30291527777777,
            "2025-10-22": 24.436643888888888,
            "2025-10-28": 0.7114563888888888,
            "2025-11-07": 7.910745277777778,
            "2025-11-24": 20.35652,
            "2025-11-27": 27.443496666666668,
            "2026-01-14": 1.4789947222222224,
            "2026-01-16": 14.586745,
            "2026-01-23": 220.46421666666666,
            "2026-01-27": 13.124075277777777,
            "2026-01-30": 9.677766666666667,
            "2026-02-02": 8.47519861111111,
            "2026-02-06": 8.4881275,
            "2026-02-09": 32.716680555555556,
            "2026-02-10": 32.032264999999995,
            "2026-02-13": 8.181568055555555,
            "2026-03-02": 152.35966249999998,
            "2026-03-04": 9.86106527777778,
            "2026-03-06": 126.96194277777778,
            "2026-03-09": 178.81334638888887,
            "2026-03-11": 41.51652333333333,
            "2026-03-13": 2.0930927777777777,
            "2026-03-16": 321.32747722222217,
            "2026-03-20": 7.408984444444445,
            "2026-03-23": 6.230805555555556,
            "2026-04-06": 107.30915027777777,
            "2026-04-09": 2.7493611111111114,
            "2026-04-17": 6.2821711111111105,
            "2026-04-20": 3.804172777777778,
            "2026-05-04": 277.53008555555556,
            "2026-05-11": 55.86313416666667,
            "2026-05-18": 4.286660277777778,
            "2026-05-22": 5.5615741666666665,
            "2026-05-29": 4.479723888888889,
            "2026-06-08": 0.46472305555555554
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-10": 2,
            "2025-10-13": 1,
            "2025-10-22": 2,
            "2025-10-28": 1,
            "2025-11-07": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2026-01-14": 1,
            "2026-01-16": 2,
            "2026-01-23": 2,
            "2026-01-27": 2,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-06": 1,
            "2026-02-09": 4,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-03-02": 4,
            "2026-03-04": 3,
            "2026-03-06": 1,
            "2026-03-09": 2,
            "2026-03-11": 2,
            "2026-03-13": 2,
            "2026-03-16": 13,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-04-06": 2,
            "2026-04-09": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-05-04": 6,
            "2026-05-11": 1,
            "2026-05-18": 1,
            "2026-05-22": 2,
            "2026-05-29": 1,
            "2026-06-08": 1
          }
        },
        "P2": {
          "avg_time_hours": 128.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 241,
          "time_distribution": {
            "0-2h": 241,
            "2-4h": 45,
            "4-6h": 50,
            "6-8h": 48,
            "8-10h": 26,
            "10-12h": 5,
            "12-14h": 5,
            "14-16h": 1,
            "16-18h": 9,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 4,
            "24-26h": 4,
            "26-28h": 7,
            "28-30h": 8,
            "30-32h": 16,
            "32-34h": 5,
            "34-36h": 1,
            "36-38h": 1,
            "38-40h": 2,
            "42-44h": 1,
            "44-46h": 1,
            "46-48h": 4,
            "48-50h": 2,
            "50-52h": 3,
            "52-54h": 1,
            "54-56h": 3,
            "56-58h": 2,
            "70-72h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "76-78h": 2,
            "78-80h": 3,
            "88-90h": 1,
            "90-92h": 1,
            "94-96h": 1,
            "100-102h": 1,
            "116-118h": 2,
            "118-120h": 1,
            "120-122h": 4,
            "124-126h": 3,
            "134-136h": 1,
            "138-140h": 2,
            "140-142h": 1,
            "142-144h": 1,
            "144-146h": 1,
            "146-148h": 2,
            "148-150h": 1,
            "160-162h": 1,
            "162-164h": 2,
            "164-166h": 1,
            "166-168h": 1,
            "174-176h": 1,
            "178-180h": 1,
            "180-182h": 1,
            "184-186h": 1,
            "186-188h": 1,
            "188-190h": 1,
            "196-198h": 1,
            "200-202h": 1,
            "214-216h": 1,
            "226-228h": 1,
            "246-248h": 1,
            "250-252h": 1,
            "260-262h": 1,
            "264-266h": 1,
            "266-268h": 2,
            "282-284h": 1,
            "284-286h": 1,
            "288-290h": 1,
            "308-310h": 2,
            "314-316h": 1,
            "318-320h": 1,
            "332-334h": 3,
            "340-342h": 1,
            "356-358h": 1,
            "358-360h": 1,
            "366-368h": 1,
            "386-388h": 1,
            "398-400h": 1,
            "400-402h": 1,
            "404-406h": 1,
            "408-410h": 2,
            "410-412h": 2,
            "418-420h": 1,
            "424-426h": 1,
            "430-432h": 1,
            "434-436h": 1,
            "440-442h": 1,
            "462-464h": 1,
            "504-506h": 1,
            "516-518h": 1,
            "518-520h": 1,
            "526-528h": 1,
            "532-534h": 1,
            "540-542h": 2,
            "542-544h": 1,
            "576-578h": 1,
            "582-584h": 1,
            "604-606h": 1,
            "622-624h": 1,
            "628-630h": 1,
            "642-644h": 1,
            "648-650h": 3,
            "652-654h": 1,
            "666-668h": 1,
            "668-670h": 1,
            "672-674h": 1,
            "678-680h": 2,
            "692-694h": 1,
            "700-702h": 1,
            "724-726h": 2,
            "742-744h": 1,
            "748-750h": 1,
            "750-752h": 1,
            "772-774h": 1,
            "800-802h": 1,
            "846-848h": 1,
            "860-862h": 1,
            "884-886h": 1,
            "886-888h": 1,
            "890-892h": 2,
            "892-894h": 1,
            "896-898h": 1,
            "916-918h": 1,
            "954-956h": 1,
            "956-958h": 1,
            "970-972h": 1,
            "986-988h": 1,
            "1000-1002h": 1,
            "1002-1004h": 1,
            "1008-1010h": 1,
            "1034-1036h": 1,
            "1038-1040h": 1,
            "1054-1056h": 1,
            "1056-1058h": 1,
            "1076-1078h": 1,
            "1078-1080h": 1,
            "1114-1116h": 1,
            "1174-1176h": 1,
            "1200-1202h": 1,
            "1342-1344h": 1,
            "1462-1464h": 1,
            "1480-1482h": 1,
            "1482-1484h": 1,
            "1506-1508h": 1,
            "1546-1548h": 1,
            "1562-1564h": 1,
            "1582-1584h": 1,
            "1712-1714h": 1,
            "2138-2140h": 1
          },
          "tickets_count": 705,
          "tickets_per_day": {
            "2025-10-06": 2,
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-10": 6,
            "2025-10-14": 6,
            "2025-10-15": 2,
            "2025-10-20": 3,
            "2025-10-21": 3,
            "2025-10-22": 4,
            "2025-10-23": 3,
            "2025-10-24": 2,
            "2025-10-27": 2,
            "2025-10-28": 4,
            "2025-10-31": 4,
            "2025-11-03": 5,
            "2025-11-04": 3,
            "2025-11-05": 3,
            "2025-11-06": 2,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 3,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-14": 1,
            "2025-11-15": 1,
            "2025-11-17": 1,
            "2025-11-18": 3,
            "2025-11-19": 2,
            "2025-11-21": 2,
            "2025-11-23": 4,
            "2025-11-24": 3,
            "2025-11-26": 3,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-12-01": 1,
            "2025-12-02": 3,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-12": 1,
            "2025-12-15": 6,
            "2025-12-16": 3,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-21": 1,
            "2025-12-22": 6,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2025-12-28": 3,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2025-12-31": 1,
            "2026-01-02": 2,
            "2026-01-05": 2,
            "2026-01-07": 4,
            "2026-01-08": 1,
            "2026-01-12": 3,
            "2026-01-13": 2,
            "2026-01-14": 6,
            "2026-01-15": 6,
            "2026-01-16": 2,
            "2026-01-19": 1,
            "2026-01-20": 2,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 2,
            "2026-01-27": 5,
            "2026-01-29": 2,
            "2026-02-03": 3,
            "2026-02-04": 2,
            "2026-02-05": 2,
            "2026-02-09": 1,
            "2026-02-10": 5,
            "2026-02-12": 5,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-17": 3,
            "2026-02-18": 6,
            "2026-02-21": 4,
            "2026-02-23": 2,
            "2026-02-24": 3,
            "2026-02-25": 1,
            "2026-02-28": 5,
            "2026-03-02": 13,
            "2026-03-03": 3,
            "2026-03-04": 2,
            "2026-03-05": 10,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-09": 6,
            "2026-03-10": 3,
            "2026-03-11": 5,
            "2026-03-12": 3,
            "2026-03-13": 2,
            "2026-03-16": 11,
            "2026-03-17": 10,
            "2026-03-18": 5,
            "2026-03-19": 1,
            "2026-03-20": 12,
            "2026-03-23": 12,
            "2026-03-24": 2,
            "2026-03-25": 6,
            "2026-03-26": 1,
            "2026-03-27": 4,
            "2026-03-28": 1,
            "2026-03-30": 5,
            "2026-03-31": 8,
            "2026-04-01": 1,
            "2026-04-02": 3,
            "2026-04-06": 9,
            "2026-04-07": 3,
            "2026-04-08": 7,
            "2026-04-09": 3,
            "2026-04-10": 5,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 4,
            "2026-04-15": 6,
            "2026-04-16": 15,
            "2026-04-17": 3,
            "2026-04-18": 4,
            "2026-04-20": 9,
            "2026-04-21": 4,
            "2026-04-22": 6,
            "2026-04-23": 9,
            "2026-04-24": 7,
            "2026-04-28": 10,
            "2026-04-29": 8,
            "2026-04-30": 6,
            "2026-05-02": 4,
            "2026-05-04": 17,
            "2026-05-05": 7,
            "2026-05-06": 9,
            "2026-05-07": 6,
            "2026-05-09": 9,
            "2026-05-11": 17,
            "2026-05-12": 7,
            "2026-05-13": 3,
            "2026-05-14": 4,
            "2026-05-15": 5,
            "2026-05-16": 1,
            "2026-05-18": 13,
            "2026-05-19": 6,
            "2026-05-20": 10,
            "2026-05-21": 4,
            "2026-05-22": 5,
            "2026-05-23": 3,
            "2026-05-25": 17,
            "2026-05-26": 6,
            "2026-05-27": 4,
            "2026-05-28": 7,
            "2026-05-29": 22,
            "2026-05-30": 5,
            "2026-06-01": 19,
            "2026-06-02": 6,
            "2026-06-03": 6,
            "2026-06-05": 8,
            "2026-06-06": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-06": 71.88010583333333,
            "2025-10-07": 2.484757777777778,
            "2025-10-09": 0.5038130555555556,
            "2025-10-10": 123.27296999999999,
            "2025-10-14": 376.9396938888888,
            "2025-10-15": 16.8710125,
            "2025-10-20": 367.2668972222222,
            "2025-10-21": 28.646811388888892,
            "2025-10-22": 36.50889611111111,
            "2025-10-23": 417.9238638888889,
            "2025-10-24": 337.74180138888886,
            "2025-10-27": 57.40872638888889,
            "2025-10-28": 319.17868138888883,
            "2025-10-31": 75.86215388888888,
            "2025-11-03": 207.15595027777775,
            "2025-11-04": 9.001379722222222,
            "2025-11-05": 16.900185833333335,
            "2025-11-06": 153.686895,
            "2025-11-07": 1.5195405555555554,
            "2025-11-10": 239.35057166666667,
            "2025-11-11": 433.96686972222227,
            "2025-11-12": 79.85328861111111,
            "2025-11-13": 316.2961,
            "2025-11-14": 163.05060833333332,
            "2025-11-15": 0.20001194444444445,
            "2025-11-17": 0.07475361111111112,
            "2025-11-18": 45.459515277777776,
            "2025-11-19": 4.0421547222222225,
            "2025-11-21": 135.2869125,
            "2025-11-23": 622.4367611111111,
            "2025-11-24": 222.4941738888889,
            "2025-11-26": 8.413736111111113,
            "2025-11-27": 27.452398055555555,
            "2025-11-28": 4.079934722222222,
            "2025-12-01": 11.609512222222222,
            "2025-12-02": 510.8509622222222,
            "2025-12-03": 0.09544333333333334,
            "2025-12-05": 0.27298666666666666,
            "2025-12-09": 30.966324444444442,
            "2025-12-10": 26.079805,
            "2025-12-11": 611.2394452777777,
            "2025-12-12": 12.155380555555556,
            "2025-12-15": 977.1834383333334,
            "2025-12-16": 102.6038711111111,
            "2025-12-17": 441.5827875,
            "2025-12-19": 0.30123777777777777,
            "2025-12-21": 89.8079611111111,
            "2025-12-22": 121.50274638888888,
            "2025-12-23": 77.81090555555556,
            "2025-12-26": 76.171835,
            "2025-12-28": 27.939852499999997,
            "2025-12-29": 30.487995833333333,
            "2025-12-30": 8.524286944444444,
            "2025-12-31": 0.014488333333333334,
            "2026-01-02": 51.08504777777778,
            "2026-01-05": 139.33688722222223,
            "2026-01-07": 664.8179088888888,
            "2026-01-08": 401.4129358333333,
            "2026-01-12": 13.261553333333334,
            "2026-01-13": 12.353398333333335,
            "2026-01-14": 48.10133694444444,
            "2026-01-15": 36.41210194444444,
            "2026-01-16": 46.175529166666664,
            "2026-01-19": 146.16052027777778,
            "2026-01-20": 135.08440027777777,
            "2026-01-22": 4.133858611111111,
            "2026-01-23": 917.1860613888888,
            "2026-01-26": 9.072400555555555,
            "2026-01-27": 40.084412777777786,
            "2026-01-29": 19.40204111111111,
            "2026-02-03": 720.5226905555555,
            "2026-02-04": 17.802160555555556,
            "2026-02-05": 204.5333766666667,
            "2026-02-09": 56.53581694444444,
            "2026-02-10": 1469.19991,
            "2026-02-12": 3298.773456666667,
            "2026-02-13": 51.004605833333336,
            "2026-02-16": 6.388031111111111,
            "2026-02-17": 11.17194361111111,
            "2026-02-18": 1024.6227458333335,
            "2026-02-21": 245.0215586111111,
            "2026-02-23": 773.3773436111112,
            "2026-02-24": 74.89359166666667,
            "2026-02-25": 34.94009361111111,
            "2026-02-28": 50.99637416666666,
            "2026-03-02": 490.68865166666666,
            "2026-03-03": 8.692031111111111,
            "2026-03-04": 334.29867277777777,
            "2026-03-05": 101.76125500000002,
            "2026-03-06": 1.6816119444444444,
            "2026-03-07": 4.014266388888889,
            "2026-03-09": 279.399475,
            "2026-03-10": 450.0281675,
            "2026-03-11": 3271.4651619444444,
            "2026-03-12": 13.715893888888889,
            "2026-03-13": 1.9139908333333333,
            "2026-03-16": 44.53280305555556,
            "2026-03-17": 2964.234208888889,
            "2026-03-18": 0.8379202777777778,
            "2026-03-19": 7.699686666666667,
            "2026-03-20": 8310.035975833332,
            "2026-03-23": 279.10773722222217,
            "2026-03-24": 431.3202855555556,
            "2026-03-25": 3.5798472222222224,
            "2026-03-27": 1700.458145,
            "2026-03-28": 38.522799722222224,
            "2026-03-30": 30.359245833333333,
            "2026-03-31": 16.85687777777778,
            "2026-04-01": 141.08804138888888,
            "2026-04-02": 1078.6394894444445,
            "2026-04-06": 84.03609722222222,
            "2026-04-07": 19.1516875,
            "2026-04-08": 416.5033469444444,
            "2026-04-09": 36.43930888888888,
            "2026-04-10": 1774.613133888889,
            "2026-04-11": 0.042020277777777774,
            "2026-04-13": 1077.607700277778,
            "2026-04-14": 285.1569311111111,
            "2026-04-15": 1896.1542705555555,
            "2026-04-16": 5887.63123722222,
            "2026-04-17": 2003.8520350000001,
            "2026-04-18": 2922.276483888889,
            "2026-04-20": 723.0197541666666,
            "2026-04-21": 32.81673416666667,
            "2026-04-22": 1045.8939330555556,
            "2026-04-23": 7315.651700555557,
            "2026-04-24": 1.2995802777777778,
            "2026-04-28": 1891.5033341666665,
            "2026-04-29": 1215.4960852777779,
            "2026-04-30": 22.954015833333333,
            "2026-05-02": 7.495664166666667,
            "2026-05-04": 4312.747987777779,
            "2026-05-05": 35.5129075,
            "2026-05-06": 2993.501327222222,
            "2026-05-07": 657.0098105555556,
            "2026-05-09": 400.9431152777778,
            "2026-05-11": 15.223561111111112,
            "2026-05-12": 10.443576111111112,
            "2026-05-13": 64.52806166666667,
            "2026-05-14": 730.9324825,
            "2026-05-15": 10.805037222222222,
            "2026-05-16": 13.163388333333332,
            "2026-05-18": 842.230838611111,
            "2026-05-19": 3.0689236111111113,
            "2026-05-20": 6.670005,
            "2026-05-21": 0.7425355555555555,
            "2026-05-22": 0.05365083333333333,
            "2026-05-23": 0.09236333333333334,
            "2026-05-25": 94.21852138888889,
            "2026-05-26": 23.057102500000003,
            "2026-05-27": 2449.8958641666663,
            "2026-05-28": 1630.3515219444444,
            "2026-05-29": 166.21100888888893,
            "2026-05-30": 681.3131033333333,
            "2026-06-01": 106.96693805555556,
            "2026-06-02": 127.4606911111111,
            "2026-06-03": 24.42372138888889,
            "2026-06-05": 46.83106166666666,
            "2026-06-08": 0.37989388888888886
          },
          "time_count_per_day": {
            "2025-10-06": 2,
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-10": 6,
            "2025-10-14": 6,
            "2025-10-15": 2,
            "2025-10-20": 3,
            "2025-10-21": 3,
            "2025-10-22": 4,
            "2025-10-23": 3,
            "2025-10-24": 2,
            "2025-10-27": 2,
            "2025-10-28": 4,
            "2025-10-31": 4,
            "2025-11-03": 5,
            "2025-11-04": 3,
            "2025-11-05": 3,
            "2025-11-06": 2,
            "2025-11-07": 1,
            "2025-11-10": 5,
            "2025-11-11": 3,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-14": 1,
            "2025-11-15": 1,
            "2025-11-17": 1,
            "2025-11-18": 3,
            "2025-11-19": 2,
            "2025-11-21": 2,
            "2025-11-23": 4,
            "2025-11-24": 3,
            "2025-11-26": 3,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-12-01": 1,
            "2025-12-02": 3,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-12": 1,
            "2025-12-15": 6,
            "2025-12-16": 3,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-21": 1,
            "2025-12-22": 6,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2025-12-28": 2,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2025-12-31": 1,
            "2026-01-02": 2,
            "2026-01-05": 2,
            "2026-01-07": 4,
            "2026-01-08": 1,
            "2026-01-12": 3,
            "2026-01-13": 2,
            "2026-01-14": 6,
            "2026-01-15": 6,
            "2026-01-16": 2,
            "2026-01-19": 1,
            "2026-01-20": 2,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 2,
            "2026-01-27": 5,
            "2026-01-29": 2,
            "2026-02-03": 3,
            "2026-02-04": 2,
            "2026-02-05": 2,
            "2026-02-09": 1,
            "2026-02-10": 5,
            "2026-02-12": 5,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-17": 2,
            "2026-02-18": 6,
            "2026-02-21": 4,
            "2026-02-23": 2,
            "2026-02-24": 3,
            "2026-02-25": 1,
            "2026-02-28": 5,
            "2026-03-02": 13,
            "2026-03-03": 3,
            "2026-03-04": 2,
            "2026-03-05": 10,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-09": 6,
            "2026-03-10": 2,
            "2026-03-11": 5,
            "2026-03-12": 3,
            "2026-03-13": 2,
            "2026-03-16": 10,
            "2026-03-17": 10,
            "2026-03-18": 5,
            "2026-03-19": 1,
            "2026-03-20": 12,
            "2026-03-23": 11,
            "2026-03-24": 2,
            "2026-03-25": 4,
            "2026-03-27": 3,
            "2026-03-28": 1,
            "2026-03-30": 4,
            "2026-03-31": 8,
            "2026-04-01": 1,
            "2026-04-02": 2,
            "2026-04-06": 8,
            "2026-04-07": 3,
            "2026-04-08": 7,
            "2026-04-09": 3,
            "2026-04-10": 4,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 3,
            "2026-04-15": 6,
            "2026-04-16": 15,
            "2026-04-17": 2,
            "2026-04-18": 4,
            "2026-04-20": 8,
            "2026-04-21": 4,
            "2026-04-22": 6,
            "2026-04-23": 9,
            "2026-04-24": 6,
            "2026-04-28": 9,
            "2026-04-29": 7,
            "2026-04-30": 4,
            "2026-05-02": 4,
            "2026-05-04": 17,
            "2026-05-05": 5,
            "2026-05-06": 6,
            "2026-05-07": 6,
            "2026-05-09": 7,
            "2026-05-11": 14,
            "2026-05-12": 6,
            "2026-05-13": 3,
            "2026-05-14": 3,
            "2026-05-15": 4,
            "2026-05-16": 1,
            "2026-05-18": 13,
            "2026-05-19": 5,
            "2026-05-20": 8,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-23": 2,
            "2026-05-25": 17,
            "2026-05-26": 6,
            "2026-05-27": 4,
            "2026-05-28": 5,
            "2026-05-29": 19,
            "2026-05-30": 4,
            "2026-06-01": 14,
            "2026-06-02": 5,
            "2026-06-03": 5,
            "2026-06-05": 5,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 192.8,
          "mode_time_hours": 7.0,
          "mode_frequency": 11,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 7,
            "4-6h": 4,
            "6-8h": 11,
            "8-10h": 7,
            "10-12h": 1,
            "12-14h": 1,
            "14-16h": 2,
            "16-18h": 3,
            "18-20h": 1,
            "22-24h": 3,
            "24-26h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "30-32h": 2,
            "32-34h": 10,
            "34-36h": 2,
            "38-40h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "56-58h": 2,
            "72-74h": 1,
            "76-78h": 1,
            "94-96h": 2,
            "104-106h": 1,
            "148-150h": 1,
            "172-174h": 1,
            "190-192h": 1,
            "198-200h": 1,
            "208-210h": 1,
            "218-220h": 1,
            "236-238h": 1,
            "242-244h": 1,
            "338-340h": 2,
            "344-346h": 1,
            "380-382h": 1,
            "414-416h": 1,
            "560-562h": 1,
            "670-672h": 1,
            "678-680h": 1,
            "704-706h": 1,
            "814-816h": 1,
            "866-868h": 1,
            "986-988h": 1,
            "1684-1686h": 1,
            "1732-1734h": 1,
            "1778-1780h": 1,
            "3550-3552h": 1
          },
          "tickets_count": 101,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-10-12": 1,
            "2025-10-13": 1,
            "2025-10-17": 2,
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-12": 2,
            "2025-11-13": 3,
            "2025-11-14": 1,
            "2025-11-18": 2,
            "2025-11-19": 5,
            "2025-11-20": 1,
            "2025-11-21": 2,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-27": 5,
            "2025-12-02": 1,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-12": 4,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-25": 1,
            "2025-12-29": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-06": 1,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 3,
            "2026-01-15": 2,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-05": 2,
            "2026-02-06": 2,
            "2026-02-09": 3,
            "2026-02-10": 4,
            "2026-02-12": 2,
            "2026-02-13": 3,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-04-11": 1,
            "2026-05-14": 1,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2025-10-09": 5.256614444444445,
            "2025-10-12": 209.2571233333333,
            "2025-10-13": 0.6280566666666666,
            "2025-10-17": 260.33608583333336,
            "2025-10-21": 94.94289027777779,
            "2025-10-23": 199.19804833333333,
            "2025-10-24": 172.73248694444445,
            "2025-11-05": 339.48111750000004,
            "2025-11-10": 344.8535108333333,
            "2025-11-12": 32.78123194444444,
            "2025-11-13": 32.26070305555555,
            "2025-11-14": 0.40792249999999997,
            "2025-11-18": 15.310548333333333,
            "2025-11-19": 33.7746625,
            "2025-11-20": 5.780520277777778,
            "2025-11-21": 37.87848972222222,
            "2025-11-24": 95.49299944444445,
            "2025-11-25": 1.7478783333333334,
            "2025-11-27": 450.78310833333336,
            "2025-12-02": 1.3747397222222222,
            "2025-12-09": 6.610221666666666,
            "2025-12-10": 197.17657666666668,
            "2025-12-12": 486.32033027777777,
            "2025-12-15": 1196.5460338888888,
            "2025-12-17": 8.123653333333333,
            "2025-12-19": 3.143491388888889,
            "2025-12-22": 28.07858333333333,
            "2025-12-25": 56.22132055555555,
            "2025-12-29": 150.3722138888889,
            "2025-12-30": 32.514228055555556,
            "2026-01-02": 866.2966263888889,
            "2026-01-06": 32.79596527777778,
            "2026-01-07": 64.12452083333334,
            "2026-01-08": 32.35326583333333,
            "2026-01-12": 28.01019138888889,
            "2026-01-13": 211.6495363888889,
            "2026-01-14": 75.62307833333334,
            "2026-01-15": 51.52657194444444,
            "2026-01-20": 4.057119166666667,
            "2026-01-22": 705.1867888888888,
            "2026-01-26": 339.8322158333333,
            "2026-01-27": 4.422586388888889,
            "2026-01-29": 17.540411666666667,
            "2026-02-02": 55.14776944444445,
            "2026-02-03": 30.488645555555554,
            "2026-02-05": 15.589222499999998,
            "2026-02-06": 58.376803055555555,
            "2026-02-09": 121.85689833333333,
            "2026-02-10": 759.4395555555557,
            "2026-02-12": 2244.8394013888887,
            "2026-02-13": 89.35990805555556,
            "2026-02-17": 1778.18244,
            "2026-02-18": 34.86182194444444,
            "2026-03-04": 8.818540277777778,
            "2026-03-11": 679.2708580555555,
            "2026-03-17": 6.893102777777777,
            "2026-03-20": 987.0688627777778,
            "2026-05-14": 3551.750881388889,
            "2026-06-01": 1732.6893233333335
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-10-12": 1,
            "2025-10-13": 1,
            "2025-10-17": 2,
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-12": 2,
            "2025-11-13": 3,
            "2025-11-14": 1,
            "2025-11-18": 2,
            "2025-11-19": 5,
            "2025-11-20": 1,
            "2025-11-21": 2,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-27": 5,
            "2025-12-02": 1,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-12": 4,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-25": 1,
            "2025-12-29": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-06": 1,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 3,
            "2026-01-15": 2,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-05": 2,
            "2026-02-06": 2,
            "2026-02-09": 3,
            "2026-02-10": 4,
            "2026-02-12": 2,
            "2026-02-13": 3,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-05-14": 1,
            "2026-06-01": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 159.37,
          "mode_time_hours": 31.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 3,
            "8-10h": 1,
            "10-12h": 5,
            "12-14h": 2,
            "16-18h": 1,
            "20-22h": 2,
            "24-26h": 1,
            "26-28h": 4,
            "28-30h": 1,
            "30-32h": 6,
            "34-36h": 2,
            "36-38h": 1,
            "40-42h": 2,
            "44-46h": 1,
            "46-48h": 1,
            "50-52h": 1,
            "52-54h": 2,
            "56-58h": 1,
            "58-60h": 3,
            "70-72h": 2,
            "74-76h": 4,
            "76-78h": 2,
            "78-80h": 2,
            "84-86h": 1,
            "94-96h": 1,
            "96-98h": 1,
            "98-100h": 2,
            "100-102h": 1,
            "112-114h": 1,
            "126-128h": 1,
            "140-142h": 3,
            "146-148h": 2,
            "160-162h": 1,
            "170-172h": 1,
            "174-176h": 1,
            "176-178h": 1,
            "192-194h": 1,
            "198-200h": 1,
            "200-202h": 1,
            "206-208h": 1,
            "216-218h": 2,
            "232-234h": 1,
            "240-242h": 1,
            "242-244h": 1,
            "272-274h": 1,
            "276-278h": 1,
            "334-336h": 1,
            "352-354h": 2,
            "354-356h": 1,
            "358-360h": 1,
            "368-370h": 1,
            "372-374h": 1,
            "382-384h": 1,
            "384-386h": 2,
            "404-406h": 1,
            "406-408h": 1,
            "416-418h": 1,
            "420-422h": 2,
            "446-448h": 2,
            "494-496h": 1,
            "496-498h": 1,
            "504-506h": 1,
            "556-558h": 1,
            "620-622h": 1,
            "628-630h": 2
          },
          "tickets_count": 120,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-10": 1,
            "2025-10-13": 3,
            "2025-10-20": 2,
            "2025-10-23": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-10": 2,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-20": 1,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-12-02": 3,
            "2025-12-03": 1,
            "2025-12-10": 2,
            "2025-12-15": 4,
            "2025-12-29": 1,
            "2026-01-08": 3,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-17": 2,
            "2026-01-21": 3,
            "2026-01-23": 2,
            "2026-01-24": 2,
            "2026-01-27": 2,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-06": 6,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-02-19": 4,
            "2026-02-21": 6,
            "2026-02-23": 4,
            "2026-02-26": 1,
            "2026-02-28": 3,
            "2026-03-14": 2,
            "2026-03-18": 21,
            "2026-03-20": 2,
            "2026-03-24": 2,
            "2026-03-26": 3,
            "2026-04-01": 1,
            "2026-04-09": 1,
            "2026-04-15": 1,
            "2026-04-22": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-09": 2,
            "2026-05-14": 2,
            "2026-05-21": 1,
            "2026-05-29": 1,
            "2026-06-06": 2
          },
          "time_per_day": {
            "2025-10-07": 24.838125,
            "2025-10-10": 79.54719361111111,
            "2025-10-13": 185.5983925,
            "2025-10-20": 151.588375,
            "2025-10-23": 20.488579444444444,
            "2025-10-28": 96.97545916666667,
            "2025-10-29": 47.48235861111112,
            "2025-11-10": 34.56567555555555,
            "2025-11-11": 147.5989952777778,
            "2025-11-14": 6.692512499999999,
            "2025-11-20": 75.0077286111111,
            "2025-11-25": 99.25919583333332,
            "2025-11-27": 233.33765527777777,
            "2025-12-02": 429.30632694444444,
            "2025-12-03": 99.15627833333333,
            "2025-12-10": 55.562555833333334,
            "2025-12-15": 83.91055611111112,
            "2025-12-29": 34.40888138888889,
            "2026-01-08": 452.6848205555556,
            "2026-01-09": 26.628954444444446,
            "2026-01-13": 2.4550819444444443,
            "2026-01-17": 72.90092138888889,
            "2026-01-21": 69.95103944444445,
            "2026-01-23": 265.33920777777774,
            "2026-01-24": 307.93734861111113,
            "2026-01-27": 115.34040861111112,
            "2026-02-04": 127.09698138888888,
            "2026-02-05": 177.90067277777777,
            "2026-02-06": 1526.7110205555555,
            "2026-02-09": 174.71692388888889,
            "2026-02-12": 58.153661944444444,
            "2026-02-13": 93.14028861111112,
            "2026-02-18": 59.204838333333335,
            "2026-02-19": 38.64368888888889,
            "2026-02-21": 183.01186194444446,
            "2026-02-23": 185.7710138888889,
            "2026-02-26": 20.466793888888887,
            "2026-02-28": 315.93037055555556,
            "2026-03-14": 148.80616583333335,
            "2026-03-18": 8526.61159138889,
            "2026-03-20": 86.26216083333334,
            "2026-03-24": 412.8560963888889,
            "2026-03-26": 1262.001047222222,
            "2026-04-22": 16.751538333333333,
            "2026-06-06": 579.278475
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-10": 1,
            "2025-10-13": 3,
            "2025-10-20": 2,
            "2025-10-23": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-10": 2,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-20": 1,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-12-02": 3,
            "2025-12-03": 1,
            "2025-12-10": 2,
            "2025-12-15": 4,
            "2025-12-29": 1,
            "2026-01-08": 3,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-01-17": 2,
            "2026-01-21": 3,
            "2026-01-23": 2,
            "2026-01-24": 2,
            "2026-01-27": 2,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-06": 6,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-02-19": 4,
            "2026-02-21": 6,
            "2026-02-23": 4,
            "2026-02-26": 1,
            "2026-02-28": 3,
            "2026-03-14": 2,
            "2026-03-18": 21,
            "2026-03-20": 2,
            "2026-03-24": 2,
            "2026-03-26": 3,
            "2026-04-22": 1,
            "2026-06-06": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 332.68,
          "mode_time_hours": 143.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "92-94h": 1,
            "142-144h": 1,
            "158-160h": 1,
            "192-194h": 1,
            "202-204h": 1,
            "240-242h": 1,
            "302-304h": 1,
            "332-334h": 1,
            "472-474h": 1,
            "498-500h": 1,
            "624-626h": 1,
            "662-664h": 1,
            "720-722h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2026-01-17": 2,
            "2026-02-19": 9,
            "2026-03-03": 1
          },
          "time_per_day": {
            "2025-12-02": 143.70987444444444,
            "2025-12-11": 7.239853055555556,
            "2025-12-12": 333.17510694444445,
            "2026-01-17": 284.9748094444444,
            "2026-02-19": 3888.388793333333
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2026-01-17": 2,
            "2026-02-19": 9
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 134.31,
            "mode_time_hours": 1.0,
            "mode_frequency": 256,
            "time_distribution": {
              "0-2h": 256,
              "2-4h": 62,
              "4-6h": 58,
              "6-8h": 79,
              "8-10h": 43,
              "10-12h": 12,
              "12-14h": 9,
              "14-16h": 3,
              "16-18h": 14,
              "18-20h": 2,
              "20-22h": 5,
              "22-24h": 11,
              "24-26h": 7,
              "26-28h": 13,
              "28-30h": 10,
              "30-32h": 24,
              "32-34h": 16,
              "34-36h": 5,
              "36-38h": 2,
              "38-40h": 3,
              "40-42h": 2,
              "42-44h": 1,
              "44-46h": 2,
              "46-48h": 5,
              "48-50h": 3,
              "50-52h": 5,
              "52-54h": 5,
              "54-56h": 14,
              "56-58h": 5,
              "58-60h": 3,
              "70-72h": 3,
              "72-74h": 2,
              "74-76h": 5,
              "76-78h": 5,
              "78-80h": 6,
              "84-86h": 1,
              "86-88h": 1,
              "88-90h": 1,
              "90-92h": 1,
              "92-94h": 2,
              "94-96h": 4,
              "96-98h": 1,
              "98-100h": 2,
              "100-102h": 3,
              "104-106h": 1,
              "112-114h": 1,
              "116-118h": 2,
              "118-120h": 1,
              "120-122h": 4,
              "122-124h": 2,
              "124-126h": 3,
              "126-128h": 2,
              "134-136h": 1,
              "138-140h": 2,
              "140-142h": 4,
              "142-144h": 2,
              "144-146h": 1,
              "146-148h": 4,
              "148-150h": 2,
              "158-160h": 1,
              "160-162h": 2,
              "162-164h": 2,
              "164-166h": 1,
              "166-168h": 1,
              "170-172h": 1,
              "172-174h": 1,
              "174-176h": 2,
              "176-178h": 1,
              "178-180h": 1,
              "180-182h": 1,
              "184-186h": 1,
              "186-188h": 1,
              "188-190h": 1,
              "190-192h": 1,
              "192-194h": 2,
              "196-198h": 1,
              "198-200h": 2,
              "200-202h": 2,
              "202-204h": 1,
              "206-208h": 1,
              "208-210h": 1,
              "212-214h": 1,
              "214-216h": 1,
              "216-218h": 2,
              "218-220h": 1,
              "226-228h": 1,
              "232-234h": 1,
              "236-238h": 1,
              "240-242h": 2,
              "242-244h": 2,
              "246-248h": 1,
              "250-252h": 1,
              "260-262h": 1,
              "264-266h": 1,
              "266-268h": 2,
              "272-274h": 1,
              "276-278h": 1,
              "282-284h": 1,
              "284-286h": 1,
              "288-290h": 1,
              "302-304h": 1,
              "308-310h": 2,
              "314-316h": 1,
              "318-320h": 1,
              "332-334h": 4,
              "334-336h": 1,
              "338-340h": 2,
              "340-342h": 1,
              "344-346h": 1,
              "352-354h": 2,
              "354-356h": 1,
              "356-358h": 1,
              "358-360h": 2,
              "366-368h": 1,
              "368-370h": 1,
              "372-374h": 1,
              "380-382h": 1,
              "382-384h": 1,
              "384-386h": 2,
              "386-388h": 1,
              "398-400h": 1,
              "400-402h": 1,
              "404-406h": 2,
              "406-408h": 1,
              "408-410h": 2,
              "410-412h": 2,
              "414-416h": 1,
              "416-418h": 1,
              "418-420h": 1,
              "420-422h": 2,
              "424-426h": 1,
              "430-432h": 1,
              "434-436h": 1,
              "440-442h": 1,
              "446-448h": 2,
              "462-464h": 1,
              "472-474h": 1,
              "494-496h": 1,
              "496-498h": 1,
              "498-500h": 1,
              "504-506h": 2,
              "516-518h": 1,
              "518-520h": 1,
              "526-528h": 1,
              "532-534h": 1,
              "540-542h": 2,
              "542-544h": 1,
              "556-558h": 1,
              "560-562h": 1,
              "576-578h": 1,
              "582-584h": 1,
              "604-606h": 1,
              "620-622h": 1,
              "622-624h": 1,
              "624-626h": 1,
              "628-630h": 3,
              "642-644h": 1,
              "648-650h": 3,
              "652-654h": 1,
              "662-664h": 1,
              "666-668h": 1,
              "668-670h": 1,
              "670-672h": 1,
              "672-674h": 1,
              "678-680h": 3,
              "692-694h": 1,
              "700-702h": 1,
              "704-706h": 1,
              "720-722h": 1,
              "724-726h": 2,
              "742-744h": 1,
              "748-750h": 1,
              "750-752h": 1,
              "772-774h": 1,
              "800-802h": 1,
              "814-816h": 1,
              "846-848h": 1,
              "860-862h": 1,
              "866-868h": 1,
              "884-886h": 1,
              "886-888h": 1,
              "890-892h": 2,
              "892-894h": 1,
              "896-898h": 1,
              "916-918h": 1,
              "954-956h": 1,
              "956-958h": 1,
              "970-972h": 1,
              "986-988h": 2,
              "1000-1002h": 1,
              "1002-1004h": 1,
              "1008-1010h": 1,
              "1034-1036h": 1,
              "1038-1040h": 1,
              "1054-1056h": 1,
              "1056-1058h": 1,
              "1076-1078h": 1,
              "1078-1080h": 1,
              "1114-1116h": 1,
              "1174-1176h": 1,
              "1200-1202h": 1,
              "1342-1344h": 1,
              "1462-1464h": 1,
              "1480-1482h": 1,
              "1482-1484h": 1,
              "1506-1508h": 1,
              "1546-1548h": 1,
              "1562-1564h": 1,
              "1582-1584h": 1,
              "1684-1686h": 1,
              "1712-1714h": 1,
              "1732-1734h": 1,
              "1778-1780h": 1,
              "2138-2140h": 1,
              "3550-3552h": 1
            },
            "tickets_count": 938,
            "tickets_per_day": {
              "2025-10-06": 3,
              "2025-10-07": 2,
              "2025-10-09": 2,
              "2025-10-10": 9,
              "2025-10-12": 1,
              "2025-10-13": 5,
              "2025-10-14": 6,
              "2025-10-15": 2,
              "2025-10-17": 2,
              "2025-10-20": 5,
              "2025-10-21": 4,
              "2025-10-22": 6,
              "2025-10-23": 5,
              "2025-10-24": 3,
              "2025-10-27": 2,
              "2025-10-28": 6,
              "2025-10-29": 1,
              "2025-10-31": 4,
              "2025-11-03": 5,
              "2025-11-04": 3,
              "2025-11-05": 4,
              "2025-11-06": 2,
              "2025-11-07": 2,
              "2025-11-10": 8,
              "2025-11-11": 4,
              "2025-11-12": 4,
              "2025-11-13": 5,
              "2025-11-14": 3,
              "2025-11-15": 1,
              "2025-11-17": 1,
              "2025-11-18": 5,
              "2025-11-19": 7,
              "2025-11-20": 2,
              "2025-11-21": 4,
              "2025-11-23": 4,
              "2025-11-24": 5,
              "2025-11-25": 2,
              "2025-11-26": 3,
              "2025-11-27": 8,
              "2025-11-28": 2,
              "2025-12-01": 1,
              "2025-12-02": 8,
              "2025-12-03": 2,
              "2025-12-05": 1,
              "2025-12-09": 2,
              "2025-12-10": 5,
              "2025-12-11": 4,
              "2025-12-12": 6,
              "2025-12-15": 12,
              "2025-12-16": 3,
              "2025-12-17": 2,
              "2025-12-19": 3,
              "2025-12-21": 1,
              "2025-12-22": 7,
              "2025-12-23": 1,
              "2025-12-25": 1,
              "2025-12-26": 1,
              "2025-12-28": 2,
              "2025-12-29": 4,
              "2025-12-30": 2,
              "2025-12-31": 1,
              "2026-01-02": 3,
              "2026-01-05": 2,
              "2026-01-06": 1,
              "2026-01-07": 6,
              "2026-01-08": 5,
              "2026-01-09": 1,
              "2026-01-12": 6,
              "2026-01-13": 6,
              "2026-01-14": 10,
              "2026-01-15": 8,
              "2026-01-16": 4,
              "2026-01-17": 4,
              "2026-01-19": 1,
              "2026-01-20": 3,
              "2026-01-21": 3,
              "2026-01-22": 3,
              "2026-01-23": 6,
              "2026-01-24": 2,
              "2026-01-26": 3,
              "2026-01-27": 10,
              "2026-01-29": 3,
              "2026-01-30": 1,
              "2026-02-02": 3,
              "2026-02-03": 4,
              "2026-02-04": 3,
              "2026-02-05": 5,
              "2026-02-06": 9,
              "2026-02-09": 9,
              "2026-02-10": 10,
              "2026-02-12": 8,
              "2026-02-13": 7,
              "2026-02-16": 1,
              "2026-02-17": 3,
              "2026-02-18": 8,
              "2026-02-19": 13,
              "2026-02-21": 10,
              "2026-02-23": 6,
              "2026-02-24": 3,
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-02-28": 8,
              "2026-03-02": 17,
              "2026-03-03": 3,
              "2026-03-04": 6,
              "2026-03-05": 10,
              "2026-03-06": 2,
              "2026-03-07": 1,
              "2026-03-09": 8,
              "2026-03-10": 2,
              "2026-03-11": 8,
              "2026-03-12": 3,
              "2026-03-13": 4,
              "2026-03-14": 2,
              "2026-03-16": 23,
              "2026-03-17": 11,
              "2026-03-18": 26,
              "2026-03-19": 1,
              "2026-03-20": 16,
              "2026-03-23": 12,
              "2026-03-24": 4,
              "2026-03-25": 4,
              "2026-03-26": 3,
              "2026-03-27": 3,
              "2026-03-28": 1,
              "2026-03-30": 4,
              "2026-03-31": 8,
              "2026-04-01": 1,
              "2026-04-02": 2,
              "2026-04-06": 10,
              "2026-04-07": 3,
              "2026-04-08": 7,
              "2026-04-09": 4,
              "2026-04-10": 4,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 3,
              "2026-04-15": 6,
              "2026-04-16": 15,
              "2026-04-17": 3,
              "2026-04-18": 4,
              "2026-04-20": 9,
              "2026-04-21": 4,
              "2026-04-22": 7,
              "2026-04-23": 9,
              "2026-04-24": 6,
              "2026-04-28": 9,
              "2026-04-29": 7,
              "2026-04-30": 4,
              "2026-05-02": 4,
              "2026-05-04": 23,
              "2026-05-05": 5,
              "2026-05-06": 6,
              "2026-05-07": 6,
              "2026-05-09": 7,
              "2026-05-11": 15,
              "2026-05-12": 6,
              "2026-05-13": 3,
              "2026-05-14": 4,
              "2026-05-15": 4,
              "2026-05-16": 1,
              "2026-05-18": 14,
              "2026-05-19": 5,
              "2026-05-20": 8,
              "2026-05-21": 2,
              "2026-05-22": 5,
              "2026-05-23": 2,
              "2026-05-25": 17,
              "2026-05-26": 6,
              "2026-05-27": 4,
              "2026-05-28": 5,
              "2026-05-29": 20,
              "2026-05-30": 4,
              "2026-06-01": 15,
              "2026-06-02": 5,
              "2026-06-03": 5,
              "2026-06-05": 5,
              "2026-06-06": 2,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-06": 193.9069061111111,
              "2025-10-07": 27.322882777777778,
              "2025-10-09": 5.7604275000000005,
              "2025-10-10": 319.75782722222215,
              "2025-10-12": 209.2571233333333,
              "2025-10-13": 309.5293644444444,
              "2025-10-14": 376.9396938888888,
              "2025-10-15": 16.8710125,
              "2025-10-17": 260.33608583333336,
              "2025-10-20": 518.8552722222223,
              "2025-10-21": 123.58970166666668,
              "2025-10-22": 60.94554,
              "2025-10-23": 637.6104916666666,
              "2025-10-24": 510.4742883333333,
              "2025-10-27": 57.40872638888889,
              "2025-10-28": 416.8655969444444,
              "2025-10-29": 47.48235861111112,
              "2025-10-31": 75.86215388888888,
              "2025-11-03": 207.15595027777775,
              "2025-11-04": 9.001379722222222,
              "2025-11-05": 356.3813033333334,
              "2025-11-06": 153.686895,
              "2025-11-07": 9.430285833333333,
              "2025-11-10": 618.7697580555554,
              "2025-11-11": 581.565865,
              "2025-11-12": 112.63452055555555,
              "2025-11-13": 348.5568030555556,
              "2025-11-14": 170.15104333333332,
              "2025-11-15": 0.20001194444444445,
              "2025-11-17": 0.07475361111111112,
              "2025-11-18": 60.770063611111105,
              "2025-11-19": 37.81681722222223,
              "2025-11-20": 80.78824888888889,
              "2025-11-21": 173.16540222222224,
              "2025-11-23": 622.4367611111111,
              "2025-11-24": 338.34369333333336,
              "2025-11-25": 101.00707416666665,
              "2025-11-26": 8.413736111111113,
              "2025-11-27": 739.0166583333332,
              "2025-11-28": 4.079934722222222,
              "2025-12-01": 11.609512222222222,
              "2025-12-02": 1085.2419033333333,
              "2025-12-03": 99.25172166666667,
              "2025-12-05": 0.27298666666666666,
              "2025-12-09": 37.57654611111111,
              "2025-12-10": 278.8189375,
              "2025-12-11": 618.4792983333332,
              "2025-12-12": 831.6508177777778,
              "2025-12-15": 2257.6400283333332,
              "2025-12-16": 102.6038711111111,
              "2025-12-17": 449.7064408333333,
              "2025-12-19": 3.444729166666667,
              "2025-12-21": 89.8079611111111,
              "2025-12-22": 149.58132972222222,
              "2025-12-23": 77.81090555555556,
              "2025-12-25": 56.22132055555555,
              "2025-12-26": 76.171835,
              "2025-12-28": 27.939852499999997,
              "2025-12-29": 215.26909111111112,
              "2025-12-30": 41.038515000000004,
              "2025-12-31": 0.014488333333333334,
              "2026-01-02": 917.3816741666667,
              "2026-01-05": 139.33688722222223,
              "2026-01-06": 32.79596527777778,
              "2026-01-07": 728.9424297222222,
              "2026-01-08": 886.4510222222222,
              "2026-01-09": 26.628954444444446,
              "2026-01-12": 41.27174472222222,
              "2026-01-13": 226.45801666666665,
              "2026-01-14": 125.20340999999999,
              "2026-01-15": 87.93867388888889,
              "2026-01-16": 60.762274166666664,
              "2026-01-17": 357.8757308333333,
              "2026-01-19": 146.16052027777778,
              "2026-01-20": 139.14151944444444,
              "2026-01-21": 69.95103944444445,
              "2026-01-22": 709.3206475,
              "2026-01-23": 1402.9894858333332,
              "2026-01-24": 307.93734861111113,
              "2026-01-26": 348.9046163888888,
              "2026-01-27": 172.97148305555558,
              "2026-01-29": 36.94245277777778,
              "2026-01-30": 9.677766666666667,
              "2026-02-02": 63.62296805555556,
              "2026-02-03": 751.0113361111111,
              "2026-02-04": 144.89914194444444,
              "2026-02-05": 398.0232719444444,
              "2026-02-06": 1593.5759511111112,
              "2026-02-09": 385.8263197222222,
              "2026-02-10": 2260.671730555555,
              "2026-02-12": 5601.766519999999,
              "2026-02-13": 241.68637055555556,
              "2026-02-16": 6.388031111111111,
              "2026-02-17": 1789.3543836111112,
              "2026-02-18": 1118.689406111111,
              "2026-02-19": 3927.032482222222,
              "2026-02-21": 428.0334205555556,
              "2026-02-23": 959.1483575000002,
              "2026-02-24": 74.89359166666667,
              "2026-02-25": 34.94009361111111,
              "2026-02-26": 20.466793888888887,
              "2026-02-28": 366.9267447222222,
              "2026-03-02": 643.0483141666666,
              "2026-03-03": 8.692031111111111,
              "2026-03-04": 352.9782783333333,
              "2026-03-05": 101.76125500000002,
              "2026-03-06": 128.64355472222223,
              "2026-03-07": 4.014266388888889,
              "2026-03-09": 458.2128213888888,
              "2026-03-10": 450.0281675,
              "2026-03-11": 3992.2525433333335,
              "2026-03-12": 13.715893888888889,
              "2026-03-13": 4.007083611111111,
              "2026-03-14": 148.80616583333335,
              "2026-03-16": 365.8602802777777,
              "2026-03-17": 2971.1273116666666,
              "2026-03-18": 8527.449511666671,
              "2026-03-19": 7.699686666666667,
              "2026-03-20": 9390.775983888887,
              "2026-03-23": 285.3385427777777,
              "2026-03-24": 844.1763819444444,
              "2026-03-25": 3.5798472222222224,
              "2026-03-26": 1262.001047222222,
              "2026-03-27": 1700.458145,
              "2026-03-28": 38.522799722222224,
              "2026-03-30": 30.359245833333333,
              "2026-03-31": 16.85687777777778,
              "2026-04-01": 141.08804138888888,
              "2026-04-02": 1078.6394894444445,
              "2026-04-06": 191.3452475,
              "2026-04-07": 19.1516875,
              "2026-04-08": 416.5033469444444,
              "2026-04-09": 39.188669999999995,
              "2026-04-10": 1774.613133888889,
              "2026-04-11": 0.042020277777777774,
              "2026-04-13": 1077.607700277778,
              "2026-04-14": 285.1569311111111,
              "2026-04-15": 1896.1542705555555,
              "2026-04-16": 5887.63123722222,
              "2026-04-17": 2010.1342061111113,
              "2026-04-18": 2922.276483888889,
              "2026-04-20": 726.8239269444445,
              "2026-04-21": 32.81673416666667,
              "2026-04-22": 1062.645471388889,
              "2026-04-23": 7315.651700555557,
              "2026-04-24": 1.2995802777777778,
              "2026-04-28": 1891.5033341666665,
              "2026-04-29": 1215.4960852777779,
              "2026-04-30": 22.954015833333333,
              "2026-05-02": 7.495664166666667,
              "2026-05-04": 4590.278073333334,
              "2026-05-05": 35.5129075,
              "2026-05-06": 2993.501327222222,
              "2026-05-07": 657.0098105555556,
              "2026-05-09": 400.9431152777778,
              "2026-05-11": 71.08669527777776,
              "2026-05-12": 10.443576111111112,
              "2026-05-13": 64.52806166666667,
              "2026-05-14": 4282.683363888889,
              "2026-05-15": 10.805037222222222,
              "2026-05-16": 13.163388333333332,
              "2026-05-18": 846.5174988888888,
              "2026-05-19": 3.0689236111111113,
              "2026-05-20": 6.670005,
              "2026-05-21": 0.7425355555555555,
              "2026-05-22": 5.615225,
              "2026-05-23": 0.09236333333333334,
              "2026-05-25": 94.21852138888889,
              "2026-05-26": 23.057102500000003,
              "2026-05-27": 2449.8958641666663,
              "2026-05-28": 1630.3515219444444,
              "2026-05-29": 170.6907327777778,
              "2026-05-30": 681.3131033333333,
              "2026-06-01": 1839.6562613888887,
              "2026-06-02": 127.4606911111111,
              "2026-06-03": 24.42372138888889,
              "2026-06-05": 46.83106166666666,
              "2026-06-06": 579.278475,
              "2026-06-08": 0.8446169444444445
            },
            "time_count_per_day": {
              "2025-10-06": 3,
              "2025-10-07": 2,
              "2025-10-09": 2,
              "2025-10-10": 9,
              "2025-10-12": 1,
              "2025-10-13": 5,
              "2025-10-14": 6,
              "2025-10-15": 2,
              "2025-10-17": 2,
              "2025-10-20": 5,
              "2025-10-21": 4,
              "2025-10-22": 6,
              "2025-10-23": 5,
              "2025-10-24": 3,
              "2025-10-27": 2,
              "2025-10-28": 6,
              "2025-10-29": 1,
              "2025-10-31": 4,
              "2025-11-03": 5,
              "2025-11-04": 3,
              "2025-11-05": 4,
              "2025-11-06": 2,
              "2025-11-07": 2,
              "2025-11-10": 8,
              "2025-11-11": 4,
              "2025-11-12": 4,
              "2025-11-13": 5,
              "2025-11-14": 3,
              "2025-11-15": 1,
              "2025-11-17": 1,
              "2025-11-18": 5,
              "2025-11-19": 7,
              "2025-11-20": 2,
              "2025-11-21": 4,
              "2025-11-23": 4,
              "2025-11-24": 5,
              "2025-11-25": 2,
              "2025-11-26": 3,
              "2025-11-27": 8,
              "2025-11-28": 2,
              "2025-12-01": 1,
              "2025-12-02": 8,
              "2025-12-03": 2,
              "2025-12-05": 1,
              "2025-12-09": 2,
              "2025-12-10": 5,
              "2025-12-11": 4,
              "2025-12-12": 6,
              "2025-12-15": 12,
              "2025-12-16": 3,
              "2025-12-17": 2,
              "2025-12-19": 3,
              "2025-12-21": 1,
              "2025-12-22": 7,
              "2025-12-23": 1,
              "2025-12-25": 1,
              "2025-12-26": 1,
              "2025-12-28": 2,
              "2025-12-29": 4,
              "2025-12-30": 2,
              "2025-12-31": 1,
              "2026-01-02": 3,
              "2026-01-05": 2,
              "2026-01-06": 1,
              "2026-01-07": 6,
              "2026-01-08": 5,
              "2026-01-09": 1,
              "2026-01-12": 6,
              "2026-01-13": 6,
              "2026-01-14": 10,
              "2026-01-15": 8,
              "2026-01-16": 4,
              "2026-01-17": 4,
              "2026-01-19": 1,
              "2026-01-20": 3,
              "2026-01-21": 3,
              "2026-01-22": 3,
              "2026-01-23": 6,
              "2026-01-24": 2,
              "2026-01-26": 3,
              "2026-01-27": 10,
              "2026-01-29": 3,
              "2026-01-30": 1,
              "2026-02-02": 3,
              "2026-02-03": 4,
              "2026-02-04": 3,
              "2026-02-05": 5,
              "2026-02-06": 9,
              "2026-02-09": 9,
              "2026-02-10": 10,
              "2026-02-12": 8,
              "2026-02-13": 7,
              "2026-02-16": 1,
              "2026-02-17": 3,
              "2026-02-18": 8,
              "2026-02-19": 13,
              "2026-02-21": 10,
              "2026-02-23": 6,
              "2026-02-24": 3,
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-02-28": 8,
              "2026-03-02": 17,
              "2026-03-03": 3,
              "2026-03-04": 6,
              "2026-03-05": 10,
              "2026-03-06": 2,
              "2026-03-07": 1,
              "2026-03-09": 8,
              "2026-03-10": 2,
              "2026-03-11": 8,
              "2026-03-12": 3,
              "2026-03-13": 4,
              "2026-03-14": 2,
              "2026-03-16": 23,
              "2026-03-17": 11,
              "2026-03-18": 26,
              "2026-03-19": 1,
              "2026-03-20": 16,
              "2026-03-23": 12,
              "2026-03-24": 4,
              "2026-03-25": 4,
              "2026-03-26": 3,
              "2026-03-27": 3,
              "2026-03-28": 1,
              "2026-03-30": 4,
              "2026-03-31": 8,
              "2026-04-01": 1,
              "2026-04-02": 2,
              "2026-04-06": 10,
              "2026-04-07": 3,
              "2026-04-08": 7,
              "2026-04-09": 4,
              "2026-04-10": 4,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 3,
              "2026-04-15": 6,
              "2026-04-16": 15,
              "2026-04-17": 3,
              "2026-04-18": 4,
              "2026-04-20": 9,
              "2026-04-21": 4,
              "2026-04-22": 7,
              "2026-04-23": 9,
              "2026-04-24": 6,
              "2026-04-28": 9,
              "2026-04-29": 7,
              "2026-04-30": 4,
              "2026-05-02": 4,
              "2026-05-04": 23,
              "2026-05-05": 5,
              "2026-05-06": 6,
              "2026-05-07": 6,
              "2026-05-09": 7,
              "2026-05-11": 15,
              "2026-05-12": 6,
              "2026-05-13": 3,
              "2026-05-14": 4,
              "2026-05-15": 4,
              "2026-05-16": 1,
              "2026-05-18": 14,
              "2026-05-19": 5,
              "2026-05-20": 8,
              "2026-05-21": 2,
              "2026-05-22": 5,
              "2026-05-23": 2,
              "2026-05-25": 17,
              "2026-05-26": 6,
              "2026-05-27": 4,
              "2026-05-28": 5,
              "2026-05-29": 20,
              "2026-05-30": 4,
              "2026-06-01": 15,
              "2026-06-02": 5,
              "2026-06-03": 5,
              "2026-06-05": 5,
              "2026-06-06": 2,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 29.27,
              "mode_time_hours": 7.0,
              "mode_frequency": 16,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 7,
                "4-6h": 3,
                "6-8h": 16,
                "8-10h": 9,
                "10-12h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "20-22h": 1,
                "22-24h": 4,
                "24-26h": 1,
                "26-28h": 1,
                "32-34h": 1,
                "52-54h": 2,
                "54-56h": 11,
                "78-80h": 1,
                "86-88h": 1,
                "92-94h": 1,
                "100-102h": 1,
                "122-124h": 2,
                "126-128h": 1,
                "212-214h": 1
              },
              "tickets_count": 72,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-10": 2,
                "2025-10-13": 1,
                "2025-10-22": 2,
                "2025-10-28": 1,
                "2025-11-07": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2026-01-14": 1,
                "2026-01-16": 2,
                "2026-01-23": 2,
                "2026-01-27": 2,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-06": 1,
                "2026-02-09": 4,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-03-02": 4,
                "2026-03-04": 3,
                "2026-03-06": 1,
                "2026-03-09": 2,
                "2026-03-11": 2,
                "2026-03-13": 2,
                "2026-03-16": 13,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-04-06": 2,
                "2026-04-09": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-05-04": 6,
                "2026-05-11": 1,
                "2026-05-18": 1,
                "2026-05-22": 2,
                "2026-05-29": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-06": 122.02680027777778,
                "2025-10-10": 116.93766361111112,
                "2025-10-13": 123.30291527777777,
                "2025-10-22": 24.436643888888888,
                "2025-10-28": 0.7114563888888888,
                "2025-11-07": 7.910745277777778,
                "2025-11-24": 20.35652,
                "2025-11-27": 27.443496666666668,
                "2026-01-14": 1.4789947222222224,
                "2026-01-16": 14.586745,
                "2026-01-23": 220.46421666666666,
                "2026-01-27": 13.124075277777777,
                "2026-01-30": 9.677766666666667,
                "2026-02-02": 8.47519861111111,
                "2026-02-06": 8.4881275,
                "2026-02-09": 32.716680555555556,
                "2026-02-10": 32.032264999999995,
                "2026-02-13": 8.181568055555555,
                "2026-03-02": 152.35966249999998,
                "2026-03-04": 9.86106527777778,
                "2026-03-06": 126.96194277777778,
                "2026-03-09": 178.81334638888887,
                "2026-03-11": 41.51652333333333,
                "2026-03-13": 2.0930927777777777,
                "2026-03-16": 321.32747722222217,
                "2026-03-20": 7.408984444444445,
                "2026-03-23": 6.230805555555556,
                "2026-04-06": 107.30915027777777,
                "2026-04-09": 2.7493611111111114,
                "2026-04-17": 6.2821711111111105,
                "2026-04-20": 3.804172777777778,
                "2026-05-04": 277.53008555555556,
                "2026-05-11": 55.86313416666667,
                "2026-05-18": 4.286660277777778,
                "2026-05-22": 5.5615741666666665,
                "2026-05-29": 4.479723888888889,
                "2026-06-08": 0.46472305555555554
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-10": 2,
                "2025-10-13": 1,
                "2025-10-22": 2,
                "2025-10-28": 1,
                "2025-11-07": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2026-01-14": 1,
                "2026-01-16": 2,
                "2026-01-23": 2,
                "2026-01-27": 2,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-06": 1,
                "2026-02-09": 4,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-03-02": 4,
                "2026-03-04": 3,
                "2026-03-06": 1,
                "2026-03-09": 2,
                "2026-03-11": 2,
                "2026-03-13": 2,
                "2026-03-16": 13,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-04-06": 2,
                "2026-04-09": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-05-04": 6,
                "2026-05-11": 1,
                "2026-05-18": 1,
                "2026-05-22": 2,
                "2026-05-29": 1,
                "2026-06-08": 1
              }
            },
            "P2": {
              "avg_time_hours": 128.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 241,
              "time_distribution": {
                "0-2h": 241,
                "2-4h": 45,
                "4-6h": 50,
                "6-8h": 48,
                "8-10h": 26,
                "10-12h": 5,
                "12-14h": 5,
                "14-16h": 1,
                "16-18h": 9,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 4,
                "24-26h": 4,
                "26-28h": 7,
                "28-30h": 8,
                "30-32h": 16,
                "32-34h": 5,
                "34-36h": 1,
                "36-38h": 1,
                "38-40h": 2,
                "42-44h": 1,
                "44-46h": 1,
                "46-48h": 4,
                "48-50h": 2,
                "50-52h": 3,
                "52-54h": 1,
                "54-56h": 3,
                "56-58h": 2,
                "70-72h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "76-78h": 2,
                "78-80h": 3,
                "88-90h": 1,
                "90-92h": 1,
                "94-96h": 1,
                "100-102h": 1,
                "116-118h": 2,
                "118-120h": 1,
                "120-122h": 4,
                "124-126h": 3,
                "134-136h": 1,
                "138-140h": 2,
                "140-142h": 1,
                "142-144h": 1,
                "144-146h": 1,
                "146-148h": 2,
                "148-150h": 1,
                "160-162h": 1,
                "162-164h": 2,
                "164-166h": 1,
                "166-168h": 1,
                "174-176h": 1,
                "178-180h": 1,
                "180-182h": 1,
                "184-186h": 1,
                "186-188h": 1,
                "188-190h": 1,
                "196-198h": 1,
                "200-202h": 1,
                "214-216h": 1,
                "226-228h": 1,
                "246-248h": 1,
                "250-252h": 1,
                "260-262h": 1,
                "264-266h": 1,
                "266-268h": 2,
                "282-284h": 1,
                "284-286h": 1,
                "288-290h": 1,
                "308-310h": 2,
                "314-316h": 1,
                "318-320h": 1,
                "332-334h": 3,
                "340-342h": 1,
                "356-358h": 1,
                "358-360h": 1,
                "366-368h": 1,
                "386-388h": 1,
                "398-400h": 1,
                "400-402h": 1,
                "404-406h": 1,
                "408-410h": 2,
                "410-412h": 2,
                "418-420h": 1,
                "424-426h": 1,
                "430-432h": 1,
                "434-436h": 1,
                "440-442h": 1,
                "462-464h": 1,
                "504-506h": 1,
                "516-518h": 1,
                "518-520h": 1,
                "526-528h": 1,
                "532-534h": 1,
                "540-542h": 2,
                "542-544h": 1,
                "576-578h": 1,
                "582-584h": 1,
                "604-606h": 1,
                "622-624h": 1,
                "628-630h": 1,
                "642-644h": 1,
                "648-650h": 3,
                "652-654h": 1,
                "666-668h": 1,
                "668-670h": 1,
                "672-674h": 1,
                "678-680h": 2,
                "692-694h": 1,
                "700-702h": 1,
                "724-726h": 2,
                "742-744h": 1,
                "748-750h": 1,
                "750-752h": 1,
                "772-774h": 1,
                "800-802h": 1,
                "846-848h": 1,
                "860-862h": 1,
                "884-886h": 1,
                "886-888h": 1,
                "890-892h": 2,
                "892-894h": 1,
                "896-898h": 1,
                "916-918h": 1,
                "954-956h": 1,
                "956-958h": 1,
                "970-972h": 1,
                "986-988h": 1,
                "1000-1002h": 1,
                "1002-1004h": 1,
                "1008-1010h": 1,
                "1034-1036h": 1,
                "1038-1040h": 1,
                "1054-1056h": 1,
                "1056-1058h": 1,
                "1076-1078h": 1,
                "1078-1080h": 1,
                "1114-1116h": 1,
                "1174-1176h": 1,
                "1200-1202h": 1,
                "1342-1344h": 1,
                "1462-1464h": 1,
                "1480-1482h": 1,
                "1482-1484h": 1,
                "1506-1508h": 1,
                "1546-1548h": 1,
                "1562-1564h": 1,
                "1582-1584h": 1,
                "1712-1714h": 1,
                "2138-2140h": 1
              },
              "tickets_count": 645,
              "tickets_per_day": {
                "2025-10-06": 2,
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-10": 6,
                "2025-10-14": 6,
                "2025-10-15": 2,
                "2025-10-20": 3,
                "2025-10-21": 3,
                "2025-10-22": 4,
                "2025-10-23": 3,
                "2025-10-24": 2,
                "2025-10-27": 2,
                "2025-10-28": 4,
                "2025-10-31": 4,
                "2025-11-03": 5,
                "2025-11-04": 3,
                "2025-11-05": 3,
                "2025-11-06": 2,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 3,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-14": 1,
                "2025-11-15": 1,
                "2025-11-17": 1,
                "2025-11-18": 3,
                "2025-11-19": 2,
                "2025-11-21": 2,
                "2025-11-23": 4,
                "2025-11-24": 3,
                "2025-11-26": 3,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-12-01": 1,
                "2025-12-02": 3,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 6,
                "2025-12-16": 3,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-21": 1,
                "2025-12-22": 6,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2025-12-28": 2,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2025-12-31": 1,
                "2026-01-02": 2,
                "2026-01-05": 2,
                "2026-01-07": 4,
                "2026-01-08": 1,
                "2026-01-12": 3,
                "2026-01-13": 2,
                "2026-01-14": 6,
                "2026-01-15": 6,
                "2026-01-16": 2,
                "2026-01-19": 1,
                "2026-01-20": 2,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 2,
                "2026-01-27": 5,
                "2026-01-29": 2,
                "2026-02-03": 3,
                "2026-02-04": 2,
                "2026-02-05": 2,
                "2026-02-09": 1,
                "2026-02-10": 5,
                "2026-02-12": 5,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-17": 2,
                "2026-02-18": 6,
                "2026-02-21": 4,
                "2026-02-23": 2,
                "2026-02-24": 3,
                "2026-02-25": 1,
                "2026-02-28": 5,
                "2026-03-02": 13,
                "2026-03-03": 3,
                "2026-03-04": 2,
                "2026-03-05": 10,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-09": 6,
                "2026-03-10": 2,
                "2026-03-11": 5,
                "2026-03-12": 3,
                "2026-03-13": 2,
                "2026-03-16": 10,
                "2026-03-17": 10,
                "2026-03-18": 5,
                "2026-03-19": 1,
                "2026-03-20": 12,
                "2026-03-23": 11,
                "2026-03-24": 2,
                "2026-03-25": 4,
                "2026-03-27": 3,
                "2026-03-28": 1,
                "2026-03-30": 4,
                "2026-03-31": 8,
                "2026-04-01": 1,
                "2026-04-02": 2,
                "2026-04-06": 8,
                "2026-04-07": 3,
                "2026-04-08": 7,
                "2026-04-09": 3,
                "2026-04-10": 4,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 3,
                "2026-04-15": 6,
                "2026-04-16": 15,
                "2026-04-17": 2,
                "2026-04-18": 4,
                "2026-04-20": 8,
                "2026-04-21": 4,
                "2026-04-22": 6,
                "2026-04-23": 9,
                "2026-04-24": 6,
                "2026-04-28": 9,
                "2026-04-29": 7,
                "2026-04-30": 4,
                "2026-05-02": 4,
                "2026-05-04": 17,
                "2026-05-05": 5,
                "2026-05-06": 6,
                "2026-05-07": 6,
                "2026-05-09": 7,
                "2026-05-11": 14,
                "2026-05-12": 6,
                "2026-05-13": 3,
                "2026-05-14": 3,
                "2026-05-15": 4,
                "2026-05-16": 1,
                "2026-05-18": 13,
                "2026-05-19": 5,
                "2026-05-20": 8,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-23": 2,
                "2026-05-25": 17,
                "2026-05-26": 6,
                "2026-05-27": 4,
                "2026-05-28": 5,
                "2026-05-29": 19,
                "2026-05-30": 4,
                "2026-06-01": 14,
                "2026-06-02": 5,
                "2026-06-03": 5,
                "2026-06-05": 5,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-06": 71.88010583333333,
                "2025-10-07": 2.484757777777778,
                "2025-10-09": 0.5038130555555556,
                "2025-10-10": 123.27296999999999,
                "2025-10-14": 376.9396938888888,
                "2025-10-15": 16.8710125,
                "2025-10-20": 367.2668972222222,
                "2025-10-21": 28.646811388888892,
                "2025-10-22": 36.50889611111111,
                "2025-10-23": 417.9238638888889,
                "2025-10-24": 337.74180138888886,
                "2025-10-27": 57.40872638888889,
                "2025-10-28": 319.17868138888883,
                "2025-10-31": 75.86215388888888,
                "2025-11-03": 207.15595027777775,
                "2025-11-04": 9.001379722222222,
                "2025-11-05": 16.900185833333335,
                "2025-11-06": 153.686895,
                "2025-11-07": 1.5195405555555554,
                "2025-11-10": 239.35057166666667,
                "2025-11-11": 433.96686972222227,
                "2025-11-12": 79.85328861111111,
                "2025-11-13": 316.2961,
                "2025-11-14": 163.05060833333332,
                "2025-11-15": 0.20001194444444445,
                "2025-11-17": 0.07475361111111112,
                "2025-11-18": 45.459515277777776,
                "2025-11-19": 4.0421547222222225,
                "2025-11-21": 135.2869125,
                "2025-11-23": 622.4367611111111,
                "2025-11-24": 222.4941738888889,
                "2025-11-26": 8.413736111111113,
                "2025-11-27": 27.452398055555555,
                "2025-11-28": 4.079934722222222,
                "2025-12-01": 11.609512222222222,
                "2025-12-02": 510.8509622222222,
                "2025-12-03": 0.09544333333333334,
                "2025-12-05": 0.27298666666666666,
                "2025-12-09": 30.966324444444442,
                "2025-12-10": 26.079805,
                "2025-12-11": 611.2394452777777,
                "2025-12-12": 12.155380555555556,
                "2025-12-15": 977.1834383333334,
                "2025-12-16": 102.6038711111111,
                "2025-12-17": 441.5827875,
                "2025-12-19": 0.30123777777777777,
                "2025-12-21": 89.8079611111111,
                "2025-12-22": 121.50274638888888,
                "2025-12-23": 77.81090555555556,
                "2025-12-26": 76.171835,
                "2025-12-28": 27.939852499999997,
                "2025-12-29": 30.487995833333333,
                "2025-12-30": 8.524286944444444,
                "2025-12-31": 0.014488333333333334,
                "2026-01-02": 51.08504777777778,
                "2026-01-05": 139.33688722222223,
                "2026-01-07": 664.8179088888888,
                "2026-01-08": 401.4129358333333,
                "2026-01-12": 13.261553333333334,
                "2026-01-13": 12.353398333333335,
                "2026-01-14": 48.10133694444444,
                "2026-01-15": 36.41210194444444,
                "2026-01-16": 46.175529166666664,
                "2026-01-19": 146.16052027777778,
                "2026-01-20": 135.08440027777777,
                "2026-01-22": 4.133858611111111,
                "2026-01-23": 917.1860613888888,
                "2026-01-26": 9.072400555555555,
                "2026-01-27": 40.084412777777786,
                "2026-01-29": 19.40204111111111,
                "2026-02-03": 720.5226905555555,
                "2026-02-04": 17.802160555555556,
                "2026-02-05": 204.5333766666667,
                "2026-02-09": 56.53581694444444,
                "2026-02-10": 1469.19991,
                "2026-02-12": 3298.773456666667,
                "2026-02-13": 51.004605833333336,
                "2026-02-16": 6.388031111111111,
                "2026-02-17": 11.17194361111111,
                "2026-02-18": 1024.6227458333335,
                "2026-02-21": 245.0215586111111,
                "2026-02-23": 773.3773436111112,
                "2026-02-24": 74.89359166666667,
                "2026-02-25": 34.94009361111111,
                "2026-02-28": 50.99637416666666,
                "2026-03-02": 490.68865166666666,
                "2026-03-03": 8.692031111111111,
                "2026-03-04": 334.29867277777777,
                "2026-03-05": 101.76125500000002,
                "2026-03-06": 1.6816119444444444,
                "2026-03-07": 4.014266388888889,
                "2026-03-09": 279.399475,
                "2026-03-10": 450.0281675,
                "2026-03-11": 3271.4651619444444,
                "2026-03-12": 13.715893888888889,
                "2026-03-13": 1.9139908333333333,
                "2026-03-16": 44.53280305555556,
                "2026-03-17": 2964.234208888889,
                "2026-03-18": 0.8379202777777778,
                "2026-03-19": 7.699686666666667,
                "2026-03-20": 8310.035975833332,
                "2026-03-23": 279.10773722222217,
                "2026-03-24": 431.3202855555556,
                "2026-03-25": 3.5798472222222224,
                "2026-03-27": 1700.458145,
                "2026-03-28": 38.522799722222224,
                "2026-03-30": 30.359245833333333,
                "2026-03-31": 16.85687777777778,
                "2026-04-01": 141.08804138888888,
                "2026-04-02": 1078.6394894444445,
                "2026-04-06": 84.03609722222222,
                "2026-04-07": 19.1516875,
                "2026-04-08": 416.5033469444444,
                "2026-04-09": 36.43930888888888,
                "2026-04-10": 1774.613133888889,
                "2026-04-11": 0.042020277777777774,
                "2026-04-13": 1077.607700277778,
                "2026-04-14": 285.1569311111111,
                "2026-04-15": 1896.1542705555555,
                "2026-04-16": 5887.63123722222,
                "2026-04-17": 2003.8520350000001,
                "2026-04-18": 2922.276483888889,
                "2026-04-20": 723.0197541666666,
                "2026-04-21": 32.81673416666667,
                "2026-04-22": 1045.8939330555556,
                "2026-04-23": 7315.651700555557,
                "2026-04-24": 1.2995802777777778,
                "2026-04-28": 1891.5033341666665,
                "2026-04-29": 1215.4960852777779,
                "2026-04-30": 22.954015833333333,
                "2026-05-02": 7.495664166666667,
                "2026-05-04": 4312.747987777779,
                "2026-05-05": 35.5129075,
                "2026-05-06": 2993.501327222222,
                "2026-05-07": 657.0098105555556,
                "2026-05-09": 400.9431152777778,
                "2026-05-11": 15.223561111111112,
                "2026-05-12": 10.443576111111112,
                "2026-05-13": 64.52806166666667,
                "2026-05-14": 730.9324825,
                "2026-05-15": 10.805037222222222,
                "2026-05-16": 13.163388333333332,
                "2026-05-18": 842.230838611111,
                "2026-05-19": 3.0689236111111113,
                "2026-05-20": 6.670005,
                "2026-05-21": 0.7425355555555555,
                "2026-05-22": 0.05365083333333333,
                "2026-05-23": 0.09236333333333334,
                "2026-05-25": 94.21852138888889,
                "2026-05-26": 23.057102500000003,
                "2026-05-27": 2449.8958641666663,
                "2026-05-28": 1630.3515219444444,
                "2026-05-29": 166.21100888888893,
                "2026-05-30": 681.3131033333333,
                "2026-06-01": 106.96693805555556,
                "2026-06-02": 127.4606911111111,
                "2026-06-03": 24.42372138888889,
                "2026-06-05": 46.83106166666666,
                "2026-06-08": 0.37989388888888886
              },
              "time_count_per_day": {
                "2025-10-06": 2,
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-10": 6,
                "2025-10-14": 6,
                "2025-10-15": 2,
                "2025-10-20": 3,
                "2025-10-21": 3,
                "2025-10-22": 4,
                "2025-10-23": 3,
                "2025-10-24": 2,
                "2025-10-27": 2,
                "2025-10-28": 4,
                "2025-10-31": 4,
                "2025-11-03": 5,
                "2025-11-04": 3,
                "2025-11-05": 3,
                "2025-11-06": 2,
                "2025-11-07": 1,
                "2025-11-10": 5,
                "2025-11-11": 3,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-14": 1,
                "2025-11-15": 1,
                "2025-11-17": 1,
                "2025-11-18": 3,
                "2025-11-19": 2,
                "2025-11-21": 2,
                "2025-11-23": 4,
                "2025-11-24": 3,
                "2025-11-26": 3,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-12-01": 1,
                "2025-12-02": 3,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 6,
                "2025-12-16": 3,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-21": 1,
                "2025-12-22": 6,
                "2025-12-23": 1,
                "2025-12-26": 1,
                "2025-12-28": 2,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2025-12-31": 1,
                "2026-01-02": 2,
                "2026-01-05": 2,
                "2026-01-07": 4,
                "2026-01-08": 1,
                "2026-01-12": 3,
                "2026-01-13": 2,
                "2026-01-14": 6,
                "2026-01-15": 6,
                "2026-01-16": 2,
                "2026-01-19": 1,
                "2026-01-20": 2,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 2,
                "2026-01-27": 5,
                "2026-01-29": 2,
                "2026-02-03": 3,
                "2026-02-04": 2,
                "2026-02-05": 2,
                "2026-02-09": 1,
                "2026-02-10": 5,
                "2026-02-12": 5,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-17": 2,
                "2026-02-18": 6,
                "2026-02-21": 4,
                "2026-02-23": 2,
                "2026-02-24": 3,
                "2026-02-25": 1,
                "2026-02-28": 5,
                "2026-03-02": 13,
                "2026-03-03": 3,
                "2026-03-04": 2,
                "2026-03-05": 10,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-09": 6,
                "2026-03-10": 2,
                "2026-03-11": 5,
                "2026-03-12": 3,
                "2026-03-13": 2,
                "2026-03-16": 10,
                "2026-03-17": 10,
                "2026-03-18": 5,
                "2026-03-19": 1,
                "2026-03-20": 12,
                "2026-03-23": 11,
                "2026-03-24": 2,
                "2026-03-25": 4,
                "2026-03-27": 3,
                "2026-03-28": 1,
                "2026-03-30": 4,
                "2026-03-31": 8,
                "2026-04-01": 1,
                "2026-04-02": 2,
                "2026-04-06": 8,
                "2026-04-07": 3,
                "2026-04-08": 7,
                "2026-04-09": 3,
                "2026-04-10": 4,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 3,
                "2026-04-15": 6,
                "2026-04-16": 15,
                "2026-04-17": 2,
                "2026-04-18": 4,
                "2026-04-20": 8,
                "2026-04-21": 4,
                "2026-04-22": 6,
                "2026-04-23": 9,
                "2026-04-24": 6,
                "2026-04-28": 9,
                "2026-04-29": 7,
                "2026-04-30": 4,
                "2026-05-02": 4,
                "2026-05-04": 17,
                "2026-05-05": 5,
                "2026-05-06": 6,
                "2026-05-07": 6,
                "2026-05-09": 7,
                "2026-05-11": 14,
                "2026-05-12": 6,
                "2026-05-13": 3,
                "2026-05-14": 3,
                "2026-05-15": 4,
                "2026-05-16": 1,
                "2026-05-18": 13,
                "2026-05-19": 5,
                "2026-05-20": 8,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-23": 2,
                "2026-05-25": 17,
                "2026-05-26": 6,
                "2026-05-27": 4,
                "2026-05-28": 5,
                "2026-05-29": 19,
                "2026-05-30": 4,
                "2026-06-01": 14,
                "2026-06-02": 5,
                "2026-06-03": 5,
                "2026-06-05": 5,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 192.8,
              "mode_time_hours": 7.0,
              "mode_frequency": 11,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 7,
                "4-6h": 4,
                "6-8h": 11,
                "8-10h": 7,
                "10-12h": 1,
                "12-14h": 1,
                "14-16h": 2,
                "16-18h": 3,
                "18-20h": 1,
                "22-24h": 3,
                "24-26h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "30-32h": 2,
                "32-34h": 10,
                "34-36h": 2,
                "38-40h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "56-58h": 2,
                "72-74h": 1,
                "76-78h": 1,
                "94-96h": 2,
                "104-106h": 1,
                "148-150h": 1,
                "172-174h": 1,
                "190-192h": 1,
                "198-200h": 1,
                "208-210h": 1,
                "218-220h": 1,
                "236-238h": 1,
                "242-244h": 1,
                "338-340h": 2,
                "344-346h": 1,
                "380-382h": 1,
                "414-416h": 1,
                "560-562h": 1,
                "670-672h": 1,
                "678-680h": 1,
                "704-706h": 1,
                "814-816h": 1,
                "866-868h": 1,
                "986-988h": 1,
                "1684-1686h": 1,
                "1732-1734h": 1,
                "1778-1780h": 1,
                "3550-3552h": 1
              },
              "tickets_count": 99,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-10-12": 1,
                "2025-10-13": 1,
                "2025-10-17": 2,
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-12": 2,
                "2025-11-13": 3,
                "2025-11-14": 1,
                "2025-11-18": 2,
                "2025-11-19": 5,
                "2025-11-20": 1,
                "2025-11-21": 2,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-27": 5,
                "2025-12-02": 1,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-12": 4,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-25": 1,
                "2025-12-29": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-06": 1,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-12": 3,
                "2026-01-13": 3,
                "2026-01-14": 3,
                "2026-01-15": 2,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-05": 2,
                "2026-02-06": 2,
                "2026-02-09": 3,
                "2026-02-10": 4,
                "2026-02-12": 2,
                "2026-02-13": 3,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-14": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-09": 5.256614444444445,
                "2025-10-12": 209.2571233333333,
                "2025-10-13": 0.6280566666666666,
                "2025-10-17": 260.33608583333336,
                "2025-10-21": 94.94289027777779,
                "2025-10-23": 199.19804833333333,
                "2025-10-24": 172.73248694444445,
                "2025-11-05": 339.48111750000004,
                "2025-11-10": 344.8535108333333,
                "2025-11-12": 32.78123194444444,
                "2025-11-13": 32.26070305555555,
                "2025-11-14": 0.40792249999999997,
                "2025-11-18": 15.310548333333333,
                "2025-11-19": 33.7746625,
                "2025-11-20": 5.780520277777778,
                "2025-11-21": 37.87848972222222,
                "2025-11-24": 95.49299944444445,
                "2025-11-25": 1.7478783333333334,
                "2025-11-27": 450.78310833333336,
                "2025-12-02": 1.3747397222222222,
                "2025-12-09": 6.610221666666666,
                "2025-12-10": 197.17657666666668,
                "2025-12-12": 486.32033027777777,
                "2025-12-15": 1196.5460338888888,
                "2025-12-17": 8.123653333333333,
                "2025-12-19": 3.143491388888889,
                "2025-12-22": 28.07858333333333,
                "2025-12-25": 56.22132055555555,
                "2025-12-29": 150.3722138888889,
                "2025-12-30": 32.514228055555556,
                "2026-01-02": 866.2966263888889,
                "2026-01-06": 32.79596527777778,
                "2026-01-07": 64.12452083333334,
                "2026-01-08": 32.35326583333333,
                "2026-01-12": 28.01019138888889,
                "2026-01-13": 211.6495363888889,
                "2026-01-14": 75.62307833333334,
                "2026-01-15": 51.52657194444444,
                "2026-01-20": 4.057119166666667,
                "2026-01-22": 705.1867888888888,
                "2026-01-26": 339.8322158333333,
                "2026-01-27": 4.422586388888889,
                "2026-01-29": 17.540411666666667,
                "2026-02-02": 55.14776944444445,
                "2026-02-03": 30.488645555555554,
                "2026-02-05": 15.589222499999998,
                "2026-02-06": 58.376803055555555,
                "2026-02-09": 121.85689833333333,
                "2026-02-10": 759.4395555555557,
                "2026-02-12": 2244.8394013888887,
                "2026-02-13": 89.35990805555556,
                "2026-02-17": 1778.18244,
                "2026-02-18": 34.86182194444444,
                "2026-03-04": 8.818540277777778,
                "2026-03-11": 679.2708580555555,
                "2026-03-17": 6.893102777777777,
                "2026-03-20": 987.0688627777778,
                "2026-05-14": 3551.750881388889,
                "2026-06-01": 1732.6893233333335
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-10-12": 1,
                "2025-10-13": 1,
                "2025-10-17": 2,
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-12": 2,
                "2025-11-13": 3,
                "2025-11-14": 1,
                "2025-11-18": 2,
                "2025-11-19": 5,
                "2025-11-20": 1,
                "2025-11-21": 2,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-27": 5,
                "2025-12-02": 1,
                "2025-12-09": 1,
                "2025-12-10": 2,
                "2025-12-12": 4,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-25": 1,
                "2025-12-29": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-06": 1,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-12": 3,
                "2026-01-13": 3,
                "2026-01-14": 3,
                "2026-01-15": 2,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-05": 2,
                "2026-02-06": 2,
                "2026-02-09": 3,
                "2026-02-10": 4,
                "2026-02-12": 2,
                "2026-02-13": 3,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-14": 1,
                "2026-06-01": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 159.37,
              "mode_time_hours": 31.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 3,
                "8-10h": 1,
                "10-12h": 5,
                "12-14h": 2,
                "16-18h": 1,
                "20-22h": 2,
                "24-26h": 1,
                "26-28h": 4,
                "28-30h": 1,
                "30-32h": 6,
                "34-36h": 2,
                "36-38h": 1,
                "40-42h": 2,
                "44-46h": 1,
                "46-48h": 1,
                "50-52h": 1,
                "52-54h": 2,
                "56-58h": 1,
                "58-60h": 3,
                "70-72h": 2,
                "74-76h": 4,
                "76-78h": 2,
                "78-80h": 2,
                "84-86h": 1,
                "94-96h": 1,
                "96-98h": 1,
                "98-100h": 2,
                "100-102h": 1,
                "112-114h": 1,
                "126-128h": 1,
                "140-142h": 3,
                "146-148h": 2,
                "160-162h": 1,
                "170-172h": 1,
                "174-176h": 1,
                "176-178h": 1,
                "192-194h": 1,
                "198-200h": 1,
                "200-202h": 1,
                "206-208h": 1,
                "216-218h": 2,
                "232-234h": 1,
                "240-242h": 1,
                "242-244h": 1,
                "272-274h": 1,
                "276-278h": 1,
                "334-336h": 1,
                "352-354h": 2,
                "354-356h": 1,
                "358-360h": 1,
                "368-370h": 1,
                "372-374h": 1,
                "382-384h": 1,
                "384-386h": 2,
                "404-406h": 1,
                "406-408h": 1,
                "416-418h": 1,
                "420-422h": 2,
                "446-448h": 2,
                "494-496h": 1,
                "496-498h": 1,
                "504-506h": 1,
                "556-558h": 1,
                "620-622h": 1,
                "628-630h": 2
              },
              "tickets_count": 108,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-10": 1,
                "2025-10-13": 3,
                "2025-10-20": 2,
                "2025-10-23": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-10": 2,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-20": 1,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-12-02": 3,
                "2025-12-03": 1,
                "2025-12-10": 2,
                "2025-12-15": 4,
                "2025-12-29": 1,
                "2026-01-08": 3,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-17": 2,
                "2026-01-21": 3,
                "2026-01-23": 2,
                "2026-01-24": 2,
                "2026-01-27": 2,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-06": 6,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-02-19": 4,
                "2026-02-21": 6,
                "2026-02-23": 4,
                "2026-02-26": 1,
                "2026-02-28": 3,
                "2026-03-14": 2,
                "2026-03-18": 21,
                "2026-03-20": 2,
                "2026-03-24": 2,
                "2026-03-26": 3,
                "2026-04-22": 1,
                "2026-06-06": 2
              },
              "time_per_day": {
                "2025-10-07": 24.838125,
                "2025-10-10": 79.54719361111111,
                "2025-10-13": 185.5983925,
                "2025-10-20": 151.588375,
                "2025-10-23": 20.488579444444444,
                "2025-10-28": 96.97545916666667,
                "2025-10-29": 47.48235861111112,
                "2025-11-10": 34.56567555555555,
                "2025-11-11": 147.5989952777778,
                "2025-11-14": 6.692512499999999,
                "2025-11-20": 75.0077286111111,
                "2025-11-25": 99.25919583333332,
                "2025-11-27": 233.33765527777777,
                "2025-12-02": 429.30632694444444,
                "2025-12-03": 99.15627833333333,
                "2025-12-10": 55.562555833333334,
                "2025-12-15": 83.91055611111112,
                "2025-12-29": 34.40888138888889,
                "2026-01-08": 452.6848205555556,
                "2026-01-09": 26.628954444444446,
                "2026-01-13": 2.4550819444444443,
                "2026-01-17": 72.90092138888889,
                "2026-01-21": 69.95103944444445,
                "2026-01-23": 265.33920777777774,
                "2026-01-24": 307.93734861111113,
                "2026-01-27": 115.34040861111112,
                "2026-02-04": 127.09698138888888,
                "2026-02-05": 177.90067277777777,
                "2026-02-06": 1526.7110205555555,
                "2026-02-09": 174.71692388888889,
                "2026-02-12": 58.153661944444444,
                "2026-02-13": 93.14028861111112,
                "2026-02-18": 59.204838333333335,
                "2026-02-19": 38.64368888888889,
                "2026-02-21": 183.01186194444446,
                "2026-02-23": 185.7710138888889,
                "2026-02-26": 20.466793888888887,
                "2026-02-28": 315.93037055555556,
                "2026-03-14": 148.80616583333335,
                "2026-03-18": 8526.61159138889,
                "2026-03-20": 86.26216083333334,
                "2026-03-24": 412.8560963888889,
                "2026-03-26": 1262.001047222222,
                "2026-04-22": 16.751538333333333,
                "2026-06-06": 579.278475
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-10": 1,
                "2025-10-13": 3,
                "2025-10-20": 2,
                "2025-10-23": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-10": 2,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-20": 1,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-12-02": 3,
                "2025-12-03": 1,
                "2025-12-10": 2,
                "2025-12-15": 4,
                "2025-12-29": 1,
                "2026-01-08": 3,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-01-17": 2,
                "2026-01-21": 3,
                "2026-01-23": 2,
                "2026-01-24": 2,
                "2026-01-27": 2,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-06": 6,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-02-19": 4,
                "2026-02-21": 6,
                "2026-02-23": 4,
                "2026-02-26": 1,
                "2026-02-28": 3,
                "2026-03-14": 2,
                "2026-03-18": 21,
                "2026-03-20": 2,
                "2026-03-24": 2,
                "2026-03-26": 3,
                "2026-04-22": 1,
                "2026-06-06": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 332.68,
              "mode_time_hours": 143.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "92-94h": 1,
                "142-144h": 1,
                "158-160h": 1,
                "192-194h": 1,
                "202-204h": 1,
                "240-242h": 1,
                "302-304h": 1,
                "332-334h": 1,
                "472-474h": 1,
                "498-500h": 1,
                "624-626h": 1,
                "662-664h": 1,
                "720-722h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2026-01-17": 2,
                "2026-02-19": 9
              },
              "time_per_day": {
                "2025-12-02": 143.70987444444444,
                "2025-12-11": 7.239853055555556,
                "2025-12-12": 333.17510694444445,
                "2026-01-17": 284.9748094444444,
                "2026-02-19": 3888.388793333333
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2026-01-17": 2,
                "2026-02-19": 9
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-04-01": 1,
              "2026-04-09": 1,
              "2026-04-15": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-09": 2,
              "2026-05-14": 1,
              "2026-05-21": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-04-01": 1,
                "2026-04-09": 1,
                "2026-04-15": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-09": 2,
                "2026-05-14": 1,
                "2026-05-21": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-14": 1,
              "2026-06-01": 1,
              "2026-06-06": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-06": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 16,
            "tickets_per_day": {
              "2025-12-28": 1,
              "2026-03-10": 1,
              "2026-03-23": 1,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-09": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-29": 1,
              "2026-05-30": 1,
              "2026-06-01": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-12-28": 1,
                "2026-03-10": 1,
                "2026-03-23": 1,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-09": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 46,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-03-16": 1,
              "2026-03-25": 2,
              "2026-03-26": 1,
              "2026-03-27": 1,
              "2026-04-02": 1,
              "2026-04-06": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-14": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-24": 1,
              "2026-04-28": 1,
              "2026-04-29": 2,
              "2026-04-30": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-09": 1,
              "2026-05-11": 3,
              "2026-05-12": 1,
              "2026-05-15": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-23": 1,
              "2026-05-28": 2,
              "2026-05-29": 2,
              "2026-06-01": 4,
              "2026-06-02": 1,
              "2026-06-03": 1,
              "2026-06-05": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-29": 1,
                "2026-05-11": 1,
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 42,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-03-16": 1,
                "2026-03-25": 2,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-04-02": 1,
                "2026-04-06": 1,
                "2026-04-10": 1,
                "2026-04-14": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-24": 1,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-04-30": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-21": 2,
                "2026-05-22": 1,
                "2026-05-23": 1,
                "2026-05-28": 2,
                "2026-05-29": 2,
                "2026-06-01": 4,
                "2026-06-02": 1,
                "2026-06-03": 1,
                "2026-06-05": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_86": {
      "overall": {
        "avg_time_hours": 16.78,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "44-46h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-12-02": 1,
          "2025-12-04": 1
        },
        "time_per_day": {
          "2025-10-01": 0.2152338888888889,
          "2025-12-02": 5.214960555555556,
          "2025-12-04": 44.917857500000004
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-12-02": 1,
          "2025-12-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 22.57,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "44-46h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-10-01": 0.2152338888888889,
            "2025-12-04": 44.917857500000004
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-12-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 5.21,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-12-02": 5.214960555555556
          },
          "time_count_per_day": {
            "2025-12-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.78,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "44-46h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-12-02": 1,
              "2025-12-04": 1
            },
            "time_per_day": {
              "2025-10-01": 0.2152338888888889,
              "2025-12-02": 5.214960555555556,
              "2025-12-04": 44.917857500000004
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-12-02": 1,
              "2025-12-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 22.57,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "44-46h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-10-01": 0.2152338888888889,
                "2025-12-04": 44.917857500000004
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-12-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 5.21,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-12-02": 5.214960555555556
              },
              "time_count_per_day": {
                "2025-12-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_88": {
      "overall": {
        "avg_time_hours": 139.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 83,
        "time_distribution": {
          "0-2h": 83,
          "2-4h": 23,
          "4-6h": 20,
          "6-8h": 7,
          "8-10h": 5,
          "10-12h": 3,
          "12-14h": 3,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 3,
          "22-24h": 2,
          "24-26h": 3,
          "26-28h": 1,
          "28-30h": 3,
          "30-32h": 1,
          "32-34h": 3,
          "36-38h": 4,
          "38-40h": 3,
          "40-42h": 6,
          "42-44h": 2,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 2,
          "54-56h": 3,
          "62-64h": 2,
          "70-72h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "76-78h": 1,
          "78-80h": 2,
          "82-84h": 1,
          "96-98h": 2,
          "98-100h": 2,
          "100-102h": 1,
          "104-106h": 2,
          "114-116h": 1,
          "118-120h": 2,
          "122-124h": 2,
          "124-126h": 1,
          "130-132h": 3,
          "132-134h": 1,
          "136-138h": 1,
          "148-150h": 1,
          "160-162h": 1,
          "162-164h": 1,
          "166-168h": 1,
          "168-170h": 2,
          "172-174h": 1,
          "174-176h": 1,
          "180-182h": 2,
          "182-184h": 1,
          "186-188h": 1,
          "192-194h": 1,
          "194-196h": 1,
          "216-218h": 5,
          "218-220h": 1,
          "228-230h": 1,
          "238-240h": 1,
          "240-242h": 1,
          "248-250h": 1,
          "258-260h": 1,
          "260-262h": 1,
          "264-266h": 1,
          "288-290h": 1,
          "298-300h": 1,
          "300-302h": 1,
          "310-312h": 1,
          "324-326h": 1,
          "328-330h": 1,
          "332-334h": 1,
          "334-336h": 2,
          "342-344h": 1,
          "348-350h": 1,
          "356-358h": 1,
          "358-360h": 1,
          "364-366h": 1,
          "368-370h": 1,
          "372-374h": 1,
          "384-386h": 2,
          "398-400h": 1,
          "400-402h": 1,
          "410-412h": 1,
          "426-428h": 2,
          "428-430h": 1,
          "430-432h": 1,
          "466-468h": 1,
          "470-472h": 1,
          "478-480h": 1,
          "480-482h": 2,
          "498-500h": 2,
          "552-554h": 1,
          "596-598h": 1,
          "634-636h": 1,
          "658-660h": 1,
          "664-666h": 1,
          "674-676h": 1,
          "720-722h": 1,
          "768-770h": 2,
          "878-880h": 1,
          "938-940h": 1,
          "960-962h": 1,
          "994-996h": 1,
          "1020-1022h": 1,
          "1124-1126h": 1,
          "1368-1370h": 1,
          "1896-1898h": 1,
          "2390-2392h": 1
        },
        "tickets_count": 319,
        "tickets_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 3,
          "2025-10-17": 1,
          "2025-10-22": 1,
          "2025-10-30": 1,
          "2025-11-03": 1,
          "2025-11-06": 3,
          "2025-11-20": 4,
          "2025-11-21": 2,
          "2025-11-24": 2,
          "2025-11-25": 2,
          "2025-11-29": 1,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-04": 4,
          "2025-12-05": 1,
          "2025-12-11": 3,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2025-12-22": 2,
          "2025-12-24": 2,
          "2026-01-02": 1,
          "2026-01-08": 3,
          "2026-01-13": 3,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-21": 1,
          "2026-01-26": 2,
          "2026-01-30": 2,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 4,
          "2026-02-09": 4,
          "2026-02-10": 5,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-13": 5,
          "2026-02-14": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 20,
          "2026-02-23": 3,
          "2026-02-24": 1,
          "2026-02-27": 1,
          "2026-02-28": 2,
          "2026-03-03": 1,
          "2026-03-04": 2,
          "2026-03-05": 2,
          "2026-03-06": 1,
          "2026-03-10": 2,
          "2026-03-11": 2,
          "2026-03-14": 1,
          "2026-03-17": 10,
          "2026-03-18": 31,
          "2026-03-19": 2,
          "2026-03-20": 7,
          "2026-03-23": 1,
          "2026-03-24": 7,
          "2026-03-25": 4,
          "2026-03-26": 1,
          "2026-03-27": 2,
          "2026-03-30": 7,
          "2026-03-31": 1,
          "2026-04-01": 1,
          "2026-04-04": 3,
          "2026-04-07": 1,
          "2026-04-08": 7,
          "2026-04-09": 2,
          "2026-04-10": 1,
          "2026-04-13": 4,
          "2026-04-14": 3,
          "2026-04-15": 3,
          "2026-04-16": 3,
          "2026-04-17": 2,
          "2026-04-21": 3,
          "2026-04-22": 9,
          "2026-04-23": 3,
          "2026-04-27": 2,
          "2026-04-29": 2,
          "2026-04-30": 1,
          "2026-05-02": 2,
          "2026-05-04": 6,
          "2026-05-06": 2,
          "2026-05-07": 1,
          "2026-05-08": 2,
          "2026-05-11": 6,
          "2026-05-12": 3,
          "2026-05-13": 2,
          "2026-05-14": 1,
          "2026-05-18": 5,
          "2026-05-19": 1,
          "2026-05-20": 7,
          "2026-05-22": 3,
          "2026-05-23": 3,
          "2026-05-25": 2,
          "2026-05-26": 5,
          "2026-05-27": 3,
          "2026-05-30": 2,
          "2026-06-01": 1,
          "2026-06-02": 4,
          "2026-06-03": 2,
          "2026-06-05": 3,
          "2026-06-06": 1,
          "2026-06-08": 3
        },
        "time_per_day": {
          "2025-10-01": 1.9936175,
          "2025-10-03": 42.59790194444444,
          "2025-10-08": 186.09257638888892,
          "2025-10-09": 54.84737361111112,
          "2025-10-10": 82.87740944444444,
          "2025-10-13": 109.69585916666668,
          "2025-10-17": 24.687799166666668,
          "2025-10-22": 6.639176111111111,
          "2025-10-30": 249.97340888888888,
          "2025-11-03": 265.9227525,
          "2025-11-06": 408.71828805555555,
          "2025-11-20": 270.05823444444445,
          "2025-11-21": 454.0513086111111,
          "2025-11-24": 124.86353944444444,
          "2025-11-25": 20.172942222222222,
          "2025-11-29": 71.21058611111111,
          "2025-12-02": 149.55092861111112,
          "2025-12-03": 5.204712777777778,
          "2025-12-04": 66.72515027777777,
          "2025-12-05": 1.2718855555555555,
          "2025-12-11": 776.0358738888889,
          "2025-12-12": 217.71522527777776,
          "2025-12-15": 1.1697969444444445,
          "2025-12-17": 365.40546,
          "2025-12-19": 173.33231194444443,
          "2025-12-22": 16.018676666666668,
          "2025-12-24": 170.24469166666665,
          "2026-01-02": 0.8217122222222223,
          "2026-01-08": 21.169596666666667,
          "2026-01-13": 394.56335749999994,
          "2026-01-15": 995.7977094444445,
          "2026-01-16": 5.728996944444444,
          "2026-01-17": 78.56695083333332,
          "2026-01-21": 77.54844055555556,
          "2026-01-26": 10.233933888888888,
          "2026-01-30": 1308.9209999999998,
          "2026-02-02": 0.7296752777777779,
          "2026-02-03": 5.118578611111111,
          "2026-02-04": 133.0584736111111,
          "2026-02-06": 208.9072488888889,
          "2026-02-09": 485.8744886111111,
          "2026-02-10": 832.7511875000001,
          "2026-02-11": 395.03101944444444,
          "2026-02-12": 175.3994827777778,
          "2026-02-13": 246.87281944444442,
          "2026-02-14": 23.35452777777778,
          "2026-02-18": 21.916291666666666,
          "2026-02-19": 13781.633425555552,
          "2026-02-23": 85.21072972222223,
          "2026-02-24": 0.34394611111111106,
          "2026-02-28": 55.63298027777778,
          "2026-03-03": 1.4437605555555555,
          "2026-03-04": 4.650855555555556,
          "2026-03-05": 0.7748208333333333,
          "2026-03-06": 10.510086388888888,
          "2026-03-10": 10.770251666666665,
          "2026-03-11": 13.061363888888888,
          "2026-03-14": 26.781325833333334,
          "2026-03-17": 165.4634927777778,
          "2026-03-18": 10244.49428194444,
          "2026-03-19": 3.464633611111111,
          "2026-03-20": 1017.4476983333333,
          "2026-03-23": 0.7693255555555556,
          "2026-03-24": 444.4852972222223,
          "2026-03-25": 60.87502277777778,
          "2026-03-26": 194.87155916666666,
          "2026-03-27": 4.043255833333333,
          "2026-03-30": 96.22492833333335,
          "2026-04-01": 0.5499461111111111,
          "2026-04-04": 2.5494369444444445,
          "2026-04-07": 5.746321388888889,
          "2026-04-08": 15.42652027777778,
          "2026-04-09": 2.559088611111111,
          "2026-04-10": 4.481355,
          "2026-04-13": 1.0219008333333333,
          "2026-04-14": 3.394772222222222,
          "2026-04-15": 34.4505975,
          "2026-04-16": 28.780241666666665,
          "2026-04-17": 3.058755555555556,
          "2026-04-21": 1.4712852777777778,
          "2026-04-22": 927.450146111111,
          "2026-04-23": 343.0389533333334,
          "2026-04-27": 0.3276894444444444,
          "2026-04-30": 1.9550694444444445,
          "2026-05-02": 38.63679777777779,
          "2026-05-04": 5.875669166666667,
          "2026-05-06": 1896.6734847222222,
          "2026-05-07": 2.603385277777778,
          "2026-05-11": 10.451883333333333,
          "2026-05-12": 28.38133777777778,
          "2026-05-13": 0.03328472222222222,
          "2026-05-14": 0.21503666666666665,
          "2026-05-18": 161.17656305555553,
          "2026-05-19": 1.0565463888888889,
          "2026-05-20": 9.88547611111111,
          "2026-05-22": 2.0684194444444444,
          "2026-05-23": 4.312508055555556,
          "2026-05-25": 9.256776666666665,
          "2026-05-26": 2.4749855555555555,
          "2026-05-27": 43.72586277777778,
          "2026-06-01": 5.719321944444445,
          "2026-06-02": 12.491269166666667,
          "2026-06-03": 17.51601,
          "2026-06-05": 9.727704444444445,
          "2026-06-06": 597.7866297222223,
          "2026-06-08": 1.006018888888889
        },
        "time_count_per_day": {
          "2025-10-01": 1,
          "2025-10-03": 1,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 3,
          "2025-10-17": 1,
          "2025-10-22": 1,
          "2025-10-30": 1,
          "2025-11-03": 1,
          "2025-11-06": 3,
          "2025-11-20": 4,
          "2025-11-21": 2,
          "2025-11-24": 2,
          "2025-11-25": 1,
          "2025-11-29": 1,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-04": 4,
          "2025-12-05": 1,
          "2025-12-11": 3,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2025-12-22": 2,
          "2025-12-24": 2,
          "2026-01-02": 1,
          "2026-01-08": 3,
          "2026-01-13": 3,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-21": 1,
          "2026-01-26": 2,
          "2026-01-30": 2,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 4,
          "2026-02-09": 4,
          "2026-02-10": 5,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-13": 5,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-02-19": 20,
          "2026-02-23": 2,
          "2026-02-24": 1,
          "2026-02-28": 2,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-10": 2,
          "2026-03-11": 2,
          "2026-03-14": 1,
          "2026-03-17": 10,
          "2026-03-18": 31,
          "2026-03-19": 1,
          "2026-03-20": 6,
          "2026-03-23": 1,
          "2026-03-24": 7,
          "2026-03-25": 4,
          "2026-03-26": 1,
          "2026-03-27": 2,
          "2026-03-30": 6,
          "2026-04-01": 1,
          "2026-04-04": 2,
          "2026-04-07": 1,
          "2026-04-08": 5,
          "2026-04-09": 2,
          "2026-04-10": 1,
          "2026-04-13": 4,
          "2026-04-14": 3,
          "2026-04-15": 3,
          "2026-04-16": 3,
          "2026-04-17": 2,
          "2026-04-21": 1,
          "2026-04-22": 9,
          "2026-04-23": 1,
          "2026-04-27": 2,
          "2026-04-30": 1,
          "2026-05-02": 2,
          "2026-05-04": 6,
          "2026-05-06": 2,
          "2026-05-07": 1,
          "2026-05-11": 6,
          "2026-05-12": 3,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-18": 2,
          "2026-05-19": 1,
          "2026-05-20": 4,
          "2026-05-22": 3,
          "2026-05-23": 3,
          "2026-05-25": 2,
          "2026-05-26": 5,
          "2026-05-27": 3,
          "2026-06-01": 1,
          "2026-06-02": 4,
          "2026-06-03": 2,
          "2026-06-05": 3,
          "2026-06-06": 1,
          "2026-06-08": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 24.43,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 1,
            "118-120h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-22": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-03-27": 2,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-12-22": 7.906338333333333,
            "2026-02-10": 119.56869527777778,
            "2026-03-10": 9.520774722222221,
            "2026-03-27": 4.043255833333333,
            "2026-06-03": 5.559647777777778
          },
          "time_count_per_day": {
            "2025-12-22": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-03-27": 2,
            "2026-06-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 34.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 76,
          "time_distribution": {
            "0-2h": 76,
            "2-4h": 20,
            "4-6h": 15,
            "6-8h": 6,
            "8-10h": 4,
            "10-12h": 3,
            "12-14h": 2,
            "24-26h": 2,
            "30-32h": 1,
            "32-34h": 1,
            "38-40h": 2,
            "148-150h": 1,
            "160-162h": 1,
            "168-170h": 1,
            "342-344h": 1,
            "596-598h": 1,
            "938-940h": 1,
            "1896-1898h": 1
          },
          "tickets_count": 143,
          "tickets_per_day": {
            "2025-10-22": 1,
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2025-12-04": 2,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-24": 1,
            "2026-01-08": 3,
            "2026-01-16": 1,
            "2026-01-26": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-24": 1,
            "2026-02-27": 1,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-17": 5,
            "2026-03-18": 1,
            "2026-03-19": 2,
            "2026-03-20": 5,
            "2026-03-23": 1,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-30": 5,
            "2026-04-01": 1,
            "2026-04-04": 2,
            "2026-04-07": 1,
            "2026-04-08": 5,
            "2026-04-09": 2,
            "2026-04-10": 1,
            "2026-04-13": 4,
            "2026-04-14": 3,
            "2026-04-15": 3,
            "2026-04-16": 3,
            "2026-04-17": 2,
            "2026-04-21": 2,
            "2026-04-22": 3,
            "2026-04-23": 1,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-02": 2,
            "2026-05-04": 6,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-11": 6,
            "2026-05-12": 3,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-18": 2,
            "2026-05-19": 1,
            "2026-05-20": 5,
            "2026-05-22": 3,
            "2026-05-23": 3,
            "2026-05-25": 2,
            "2026-05-26": 5,
            "2026-05-27": 3,
            "2026-06-01": 1,
            "2026-06-02": 4,
            "2026-06-03": 1,
            "2026-06-05": 3,
            "2026-06-06": 1,
            "2026-06-08": 3
          },
          "time_per_day": {
            "2025-10-22": 6.639176111111111,
            "2025-11-24": 4.952985833333333,
            "2025-12-02": 149.55092861111112,
            "2025-12-04": 5.817374166666667,
            "2025-12-19": 173.33231194444443,
            "2025-12-22": 8.112338333333334,
            "2025-12-24": 1.3877719444444445,
            "2026-01-08": 21.169596666666667,
            "2026-01-16": 5.728996944444444,
            "2026-01-26": 10.233933888888888,
            "2026-02-09": 1.4262691666666667,
            "2026-02-10": 8.5255875,
            "2026-02-24": 0.34394611111111106,
            "2026-03-03": 1.4437605555555555,
            "2026-03-04": 4.650855555555556,
            "2026-03-05": 0.7748208333333333,
            "2026-03-06": 10.510086388888888,
            "2026-03-10": 1.2494769444444445,
            "2026-03-11": 13.061363888888888,
            "2026-03-17": 11.365965555555558,
            "2026-03-18": 0.8289036111111111,
            "2026-03-19": 3.464633611111111,
            "2026-03-20": 988.3901283333332,
            "2026-03-23": 0.7693255555555556,
            "2026-03-24": 12.592222222222222,
            "2026-03-25": 0.42784527777777775,
            "2026-03-30": 20.92114416666667,
            "2026-04-01": 0.5499461111111111,
            "2026-04-04": 2.5494369444444445,
            "2026-04-07": 5.746321388888889,
            "2026-04-08": 15.42652027777778,
            "2026-04-09": 2.559088611111111,
            "2026-04-10": 4.481355,
            "2026-04-13": 1.0219008333333333,
            "2026-04-14": 3.394772222222222,
            "2026-04-15": 34.4505975,
            "2026-04-16": 28.780241666666665,
            "2026-04-17": 3.058755555555556,
            "2026-04-21": 1.4712852777777778,
            "2026-04-22": 1.8974933333333333,
            "2026-04-23": 343.0389533333334,
            "2026-04-27": 0.3276894444444444,
            "2026-04-30": 1.9550694444444445,
            "2026-05-02": 38.63679777777779,
            "2026-05-04": 5.875669166666667,
            "2026-05-06": 1896.6734847222222,
            "2026-05-07": 2.603385277777778,
            "2026-05-11": 10.451883333333333,
            "2026-05-12": 28.38133777777778,
            "2026-05-13": 0.03328472222222222,
            "2026-05-14": 0.21503666666666665,
            "2026-05-18": 161.17656305555553,
            "2026-05-19": 1.0565463888888889,
            "2026-05-20": 9.88547611111111,
            "2026-05-22": 2.0684194444444444,
            "2026-05-23": 4.312508055555556,
            "2026-05-25": 9.256776666666665,
            "2026-05-26": 2.4749855555555555,
            "2026-05-27": 43.72586277777778,
            "2026-06-01": 5.719321944444445,
            "2026-06-02": 12.491269166666667,
            "2026-06-03": 11.956362222222223,
            "2026-06-05": 9.727704444444445,
            "2026-06-06": 597.7866297222223,
            "2026-06-08": 1.006018888888889
          },
          "time_count_per_day": {
            "2025-10-22": 1,
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2025-12-04": 2,
            "2025-12-19": 2,
            "2025-12-22": 1,
            "2025-12-24": 1,
            "2026-01-08": 3,
            "2026-01-16": 1,
            "2026-01-26": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-24": 1,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-17": 5,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-20": 5,
            "2026-03-23": 1,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-30": 5,
            "2026-04-01": 1,
            "2026-04-04": 2,
            "2026-04-07": 1,
            "2026-04-08": 5,
            "2026-04-09": 2,
            "2026-04-10": 1,
            "2026-04-13": 4,
            "2026-04-14": 3,
            "2026-04-15": 3,
            "2026-04-16": 3,
            "2026-04-17": 2,
            "2026-04-21": 1,
            "2026-04-22": 3,
            "2026-04-23": 1,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-02": 2,
            "2026-05-04": 6,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-11": 6,
            "2026-05-12": 3,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-18": 2,
            "2026-05-19": 1,
            "2026-05-20": 4,
            "2026-05-22": 3,
            "2026-05-23": 3,
            "2026-05-25": 2,
            "2026-05-26": 5,
            "2026-05-27": 3,
            "2026-06-01": 1,
            "2026-06-02": 4,
            "2026-06-03": 1,
            "2026-06-05": 3,
            "2026-06-06": 1,
            "2026-06-08": 3
          }
        },
        "P3": {
          "avg_time_hours": 97.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 1,
            "20-22h": 1,
            "32-34h": 1,
            "42-44h": 1,
            "78-80h": 1,
            "118-120h": 1,
            "168-170h": 1,
            "498-500h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-10-03": 1,
            "2025-10-13": 1,
            "2025-11-24": 1,
            "2025-12-24": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-10-03": 42.59790194444444,
            "2025-10-13": 0.18714916666666664,
            "2025-11-24": 119.91055361111111,
            "2025-12-24": 168.85691972222222,
            "2026-02-02": 0.7296752777777779,
            "2026-02-03": 5.118578611111111,
            "2026-02-10": 531.6398713888889,
            "2026-02-13": 79.86706055555555,
            "2026-02-18": 21.916291666666666
          },
          "time_count_per_day": {
            "2025-10-03": 1,
            "2025-10-13": 1,
            "2025-11-24": 1,
            "2025-12-24": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 173.55,
          "mode_time_hours": 41.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "4-6h": 3,
            "12-14h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 2,
            "24-26h": 1,
            "26-28h": 1,
            "28-30h": 3,
            "32-34h": 1,
            "36-38h": 4,
            "38-40h": 1,
            "40-42h": 5,
            "42-44h": 1,
            "48-50h": 2,
            "50-52h": 2,
            "54-56h": 3,
            "62-64h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "82-84h": 1,
            "96-98h": 2,
            "98-100h": 2,
            "100-102h": 1,
            "104-106h": 2,
            "114-116h": 1,
            "122-124h": 2,
            "124-126h": 1,
            "130-132h": 3,
            "132-134h": 1,
            "136-138h": 1,
            "162-164h": 1,
            "166-168h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "180-182h": 2,
            "192-194h": 1,
            "194-196h": 1,
            "216-218h": 4,
            "218-220h": 1,
            "228-230h": 1,
            "238-240h": 1,
            "248-250h": 1,
            "258-260h": 1,
            "260-262h": 1,
            "264-266h": 1,
            "288-290h": 1,
            "310-312h": 1,
            "324-326h": 1,
            "328-330h": 1,
            "332-334h": 1,
            "334-336h": 1,
            "348-350h": 1,
            "356-358h": 1,
            "372-374h": 1,
            "384-386h": 2,
            "398-400h": 1,
            "400-402h": 1,
            "410-412h": 1,
            "426-428h": 2,
            "428-430h": 1,
            "430-432h": 1,
            "466-468h": 1,
            "478-480h": 1,
            "480-482h": 1,
            "498-500h": 1,
            "634-636h": 1,
            "664-666h": 1,
            "674-676h": 1
          },
          "tickets_count": 127,
          "tickets_per_day": {
            "2025-10-01": 1,
            "2025-10-08": 2,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-13": 2,
            "2025-10-17": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-06": 3,
            "2025-11-20": 4,
            "2025-11-21": 2,
            "2025-11-25": 2,
            "2025-11-29": 1,
            "2025-12-03": 1,
            "2025-12-04": 2,
            "2025-12-05": 1,
            "2026-01-13": 3,
            "2026-01-21": 1,
            "2026-01-30": 2,
            "2026-02-04": 1,
            "2026-02-06": 4,
            "2026-02-09": 3,
            "2026-02-10": 1,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-13": 3,
            "2026-02-14": 1,
            "2026-02-23": 2,
            "2026-02-28": 2,
            "2026-03-04": 1,
            "2026-03-14": 1,
            "2026-03-17": 5,
            "2026-03-18": 30,
            "2026-03-20": 2,
            "2026-03-24": 5,
            "2026-03-25": 3,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-04": 1,
            "2026-04-08": 2,
            "2026-04-21": 1,
            "2026-04-22": 6,
            "2026-04-23": 2,
            "2026-04-29": 2,
            "2026-05-08": 2,
            "2026-05-13": 1,
            "2026-05-18": 3,
            "2026-05-20": 2,
            "2026-05-30": 2
          },
          "time_per_day": {
            "2025-10-01": 1.9936175,
            "2025-10-08": 186.09257638888892,
            "2025-10-09": 54.84737361111112,
            "2025-10-10": 82.87740944444444,
            "2025-10-13": 109.50871000000001,
            "2025-10-17": 24.687799166666668,
            "2025-10-30": 249.97340888888888,
            "2025-11-03": 265.9227525,
            "2025-11-06": 408.71828805555555,
            "2025-11-20": 270.05823444444445,
            "2025-11-21": 454.0513086111111,
            "2025-11-25": 20.172942222222222,
            "2025-11-29": 71.21058611111111,
            "2025-12-03": 5.204712777777778,
            "2025-12-04": 60.907776111111104,
            "2025-12-05": 1.2718855555555555,
            "2026-01-13": 394.56335749999994,
            "2026-01-21": 77.54844055555556,
            "2026-01-30": 1308.9209999999998,
            "2026-02-04": 133.0584736111111,
            "2026-02-06": 208.9072488888889,
            "2026-02-09": 484.4482194444444,
            "2026-02-10": 173.01703333333333,
            "2026-02-11": 395.03101944444444,
            "2026-02-12": 175.3994827777778,
            "2026-02-13": 125.03175777777778,
            "2026-02-14": 23.35452777777778,
            "2026-02-23": 85.21072972222223,
            "2026-02-28": 55.63298027777778,
            "2026-03-14": 26.781325833333334,
            "2026-03-17": 154.09752722222223,
            "2026-03-18": 10243.66537833333,
            "2026-03-20": 29.05757,
            "2026-03-24": 431.89307500000007,
            "2026-03-25": 60.4471775,
            "2026-03-26": 194.87155916666666,
            "2026-03-30": 75.30378416666667,
            "2026-04-22": 925.5526527777777
          },
          "time_count_per_day": {
            "2025-10-01": 1,
            "2025-10-08": 2,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-13": 2,
            "2025-10-17": 1,
            "2025-10-30": 1,
            "2025-11-03": 1,
            "2025-11-06": 3,
            "2025-11-20": 4,
            "2025-11-21": 2,
            "2025-11-25": 1,
            "2025-11-29": 1,
            "2025-12-03": 1,
            "2025-12-04": 2,
            "2025-12-05": 1,
            "2026-01-13": 3,
            "2026-01-21": 1,
            "2026-01-30": 2,
            "2026-02-04": 1,
            "2026-02-06": 4,
            "2026-02-09": 3,
            "2026-02-10": 1,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-13": 3,
            "2026-02-14": 1,
            "2026-02-23": 2,
            "2026-02-28": 2,
            "2026-03-14": 1,
            "2026-03-17": 5,
            "2026-03-18": 30,
            "2026-03-20": 1,
            "2026-03-24": 5,
            "2026-03-25": 3,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-22": 6
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 541.97,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "40-42h": 1,
            "46-48h": 1,
            "62-64h": 1,
            "78-80h": 1,
            "182-184h": 1,
            "186-188h": 1,
            "216-218h": 1,
            "240-242h": 1,
            "298-300h": 1,
            "300-302h": 1,
            "334-336h": 1,
            "358-360h": 1,
            "364-366h": 1,
            "368-370h": 1,
            "470-472h": 1,
            "480-482h": 1,
            "552-554h": 1,
            "658-660h": 1,
            "720-722h": 1,
            "768-770h": 2,
            "878-880h": 1,
            "960-962h": 1,
            "994-996h": 1,
            "1020-1022h": 1,
            "1124-1126h": 1,
            "1368-1370h": 1,
            "2390-2392h": 1
          },
          "tickets_count": 33,
          "tickets_per_day": {
            "2025-12-11": 3,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-02": 1,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-19": 20,
            "2026-02-23": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2025-12-11": 776.0358738888889,
            "2025-12-12": 217.71522527777776,
            "2025-12-15": 1.1697969444444445,
            "2025-12-17": 365.40546,
            "2026-01-02": 0.8217122222222223,
            "2026-01-15": 995.7977094444445,
            "2026-01-17": 78.56695083333332,
            "2026-02-13": 41.974001111111114,
            "2026-02-19": 13781.633425555552
          },
          "time_count_per_day": {
            "2025-12-11": 3,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-02": 1,
            "2026-01-15": 1,
            "2026-01-17": 1,
            "2026-02-13": 1,
            "2026-02-19": 20
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 139.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 83,
            "time_distribution": {
              "0-2h": 83,
              "2-4h": 23,
              "4-6h": 20,
              "6-8h": 7,
              "8-10h": 5,
              "10-12h": 3,
              "12-14h": 3,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 3,
              "22-24h": 2,
              "24-26h": 3,
              "26-28h": 1,
              "28-30h": 3,
              "30-32h": 1,
              "32-34h": 3,
              "36-38h": 4,
              "38-40h": 3,
              "40-42h": 6,
              "42-44h": 2,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 2,
              "54-56h": 3,
              "62-64h": 2,
              "70-72h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "76-78h": 1,
              "78-80h": 2,
              "82-84h": 1,
              "96-98h": 2,
              "98-100h": 2,
              "100-102h": 1,
              "104-106h": 2,
              "114-116h": 1,
              "118-120h": 2,
              "122-124h": 2,
              "124-126h": 1,
              "130-132h": 3,
              "132-134h": 1,
              "136-138h": 1,
              "148-150h": 1,
              "160-162h": 1,
              "162-164h": 1,
              "166-168h": 1,
              "168-170h": 2,
              "172-174h": 1,
              "174-176h": 1,
              "180-182h": 2,
              "182-184h": 1,
              "186-188h": 1,
              "192-194h": 1,
              "194-196h": 1,
              "216-218h": 5,
              "218-220h": 1,
              "228-230h": 1,
              "238-240h": 1,
              "240-242h": 1,
              "248-250h": 1,
              "258-260h": 1,
              "260-262h": 1,
              "264-266h": 1,
              "288-290h": 1,
              "298-300h": 1,
              "300-302h": 1,
              "310-312h": 1,
              "324-326h": 1,
              "328-330h": 1,
              "332-334h": 1,
              "334-336h": 2,
              "342-344h": 1,
              "348-350h": 1,
              "356-358h": 1,
              "358-360h": 1,
              "364-366h": 1,
              "368-370h": 1,
              "372-374h": 1,
              "384-386h": 2,
              "398-400h": 1,
              "400-402h": 1,
              "410-412h": 1,
              "426-428h": 2,
              "428-430h": 1,
              "430-432h": 1,
              "466-468h": 1,
              "470-472h": 1,
              "478-480h": 1,
              "480-482h": 2,
              "498-500h": 2,
              "552-554h": 1,
              "596-598h": 1,
              "634-636h": 1,
              "658-660h": 1,
              "664-666h": 1,
              "674-676h": 1,
              "720-722h": 1,
              "768-770h": 2,
              "878-880h": 1,
              "938-940h": 1,
              "960-962h": 1,
              "994-996h": 1,
              "1020-1022h": 1,
              "1124-1126h": 1,
              "1368-1370h": 1,
              "1896-1898h": 1,
              "2390-2392h": 1
            },
            "tickets_count": 289,
            "tickets_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 3,
              "2025-10-17": 1,
              "2025-10-22": 1,
              "2025-10-30": 1,
              "2025-11-03": 1,
              "2025-11-06": 3,
              "2025-11-20": 4,
              "2025-11-21": 2,
              "2025-11-24": 2,
              "2025-11-25": 1,
              "2025-11-29": 1,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-04": 4,
              "2025-12-05": 1,
              "2025-12-11": 3,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2025-12-22": 2,
              "2025-12-24": 2,
              "2026-01-02": 1,
              "2026-01-08": 3,
              "2026-01-13": 3,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-21": 1,
              "2026-01-26": 2,
              "2026-01-30": 2,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 4,
              "2026-02-09": 4,
              "2026-02-10": 5,
              "2026-02-11": 2,
              "2026-02-12": 1,
              "2026-02-13": 5,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-02-19": 20,
              "2026-02-23": 2,
              "2026-02-24": 1,
              "2026-02-28": 2,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-14": 1,
              "2026-03-17": 10,
              "2026-03-18": 31,
              "2026-03-19": 1,
              "2026-03-20": 6,
              "2026-03-23": 1,
              "2026-03-24": 7,
              "2026-03-25": 4,
              "2026-03-26": 1,
              "2026-03-27": 2,
              "2026-03-30": 6,
              "2026-04-01": 1,
              "2026-04-04": 2,
              "2026-04-07": 1,
              "2026-04-08": 5,
              "2026-04-09": 2,
              "2026-04-10": 1,
              "2026-04-13": 4,
              "2026-04-14": 3,
              "2026-04-15": 3,
              "2026-04-16": 3,
              "2026-04-17": 2,
              "2026-04-21": 1,
              "2026-04-22": 9,
              "2026-04-23": 1,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-02": 2,
              "2026-05-04": 6,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-11": 6,
              "2026-05-12": 3,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-18": 2,
              "2026-05-19": 1,
              "2026-05-20": 4,
              "2026-05-22": 3,
              "2026-05-23": 3,
              "2026-05-25": 2,
              "2026-05-26": 5,
              "2026-05-27": 3,
              "2026-06-01": 1,
              "2026-06-02": 4,
              "2026-06-03": 2,
              "2026-06-05": 3,
              "2026-06-06": 1,
              "2026-06-08": 3
            },
            "time_per_day": {
              "2025-10-01": 1.9936175,
              "2025-10-03": 42.59790194444444,
              "2025-10-08": 186.09257638888892,
              "2025-10-09": 54.84737361111112,
              "2025-10-10": 82.87740944444444,
              "2025-10-13": 109.69585916666668,
              "2025-10-17": 24.687799166666668,
              "2025-10-22": 6.639176111111111,
              "2025-10-30": 249.97340888888888,
              "2025-11-03": 265.9227525,
              "2025-11-06": 408.71828805555555,
              "2025-11-20": 270.05823444444445,
              "2025-11-21": 454.0513086111111,
              "2025-11-24": 124.86353944444444,
              "2025-11-25": 20.172942222222222,
              "2025-11-29": 71.21058611111111,
              "2025-12-02": 149.55092861111112,
              "2025-12-03": 5.204712777777778,
              "2025-12-04": 66.72515027777777,
              "2025-12-05": 1.2718855555555555,
              "2025-12-11": 776.0358738888889,
              "2025-12-12": 217.71522527777776,
              "2025-12-15": 1.1697969444444445,
              "2025-12-17": 365.40546,
              "2025-12-19": 173.33231194444443,
              "2025-12-22": 16.018676666666668,
              "2025-12-24": 170.24469166666665,
              "2026-01-02": 0.8217122222222223,
              "2026-01-08": 21.169596666666667,
              "2026-01-13": 394.56335749999994,
              "2026-01-15": 995.7977094444445,
              "2026-01-16": 5.728996944444444,
              "2026-01-17": 78.56695083333332,
              "2026-01-21": 77.54844055555556,
              "2026-01-26": 10.233933888888888,
              "2026-01-30": 1308.9209999999998,
              "2026-02-02": 0.7296752777777779,
              "2026-02-03": 5.118578611111111,
              "2026-02-04": 133.0584736111111,
              "2026-02-06": 208.9072488888889,
              "2026-02-09": 485.8744886111111,
              "2026-02-10": 832.7511875000001,
              "2026-02-11": 395.03101944444444,
              "2026-02-12": 175.3994827777778,
              "2026-02-13": 246.87281944444442,
              "2026-02-14": 23.35452777777778,
              "2026-02-18": 21.916291666666666,
              "2026-02-19": 13781.633425555552,
              "2026-02-23": 85.21072972222223,
              "2026-02-24": 0.34394611111111106,
              "2026-02-28": 55.63298027777778,
              "2026-03-03": 1.4437605555555555,
              "2026-03-04": 4.650855555555556,
              "2026-03-05": 0.7748208333333333,
              "2026-03-06": 10.510086388888888,
              "2026-03-10": 10.770251666666665,
              "2026-03-11": 13.061363888888888,
              "2026-03-14": 26.781325833333334,
              "2026-03-17": 165.4634927777778,
              "2026-03-18": 10244.49428194444,
              "2026-03-19": 3.464633611111111,
              "2026-03-20": 1017.4476983333333,
              "2026-03-23": 0.7693255555555556,
              "2026-03-24": 444.4852972222223,
              "2026-03-25": 60.87502277777778,
              "2026-03-26": 194.87155916666666,
              "2026-03-27": 4.043255833333333,
              "2026-03-30": 96.22492833333335,
              "2026-04-01": 0.5499461111111111,
              "2026-04-04": 2.5494369444444445,
              "2026-04-07": 5.746321388888889,
              "2026-04-08": 15.42652027777778,
              "2026-04-09": 2.559088611111111,
              "2026-04-10": 4.481355,
              "2026-04-13": 1.0219008333333333,
              "2026-04-14": 3.394772222222222,
              "2026-04-15": 34.4505975,
              "2026-04-16": 28.780241666666665,
              "2026-04-17": 3.058755555555556,
              "2026-04-21": 1.4712852777777778,
              "2026-04-22": 927.450146111111,
              "2026-04-23": 343.0389533333334,
              "2026-04-27": 0.3276894444444444,
              "2026-04-30": 1.9550694444444445,
              "2026-05-02": 38.63679777777779,
              "2026-05-04": 5.875669166666667,
              "2026-05-06": 1896.6734847222222,
              "2026-05-07": 2.603385277777778,
              "2026-05-11": 10.451883333333333,
              "2026-05-12": 28.38133777777778,
              "2026-05-13": 0.03328472222222222,
              "2026-05-14": 0.21503666666666665,
              "2026-05-18": 161.17656305555553,
              "2026-05-19": 1.0565463888888889,
              "2026-05-20": 9.88547611111111,
              "2026-05-22": 2.0684194444444444,
              "2026-05-23": 4.312508055555556,
              "2026-05-25": 9.256776666666665,
              "2026-05-26": 2.4749855555555555,
              "2026-05-27": 43.72586277777778,
              "2026-06-01": 5.719321944444445,
              "2026-06-02": 12.491269166666667,
              "2026-06-03": 17.51601,
              "2026-06-05": 9.727704444444445,
              "2026-06-06": 597.7866297222223,
              "2026-06-08": 1.006018888888889
            },
            "time_count_per_day": {
              "2025-10-01": 1,
              "2025-10-03": 1,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 3,
              "2025-10-17": 1,
              "2025-10-22": 1,
              "2025-10-30": 1,
              "2025-11-03": 1,
              "2025-11-06": 3,
              "2025-11-20": 4,
              "2025-11-21": 2,
              "2025-11-24": 2,
              "2025-11-25": 1,
              "2025-11-29": 1,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-04": 4,
              "2025-12-05": 1,
              "2025-12-11": 3,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2025-12-22": 2,
              "2025-12-24": 2,
              "2026-01-02": 1,
              "2026-01-08": 3,
              "2026-01-13": 3,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-21": 1,
              "2026-01-26": 2,
              "2026-01-30": 2,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 4,
              "2026-02-09": 4,
              "2026-02-10": 5,
              "2026-02-11": 2,
              "2026-02-12": 1,
              "2026-02-13": 5,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-02-19": 20,
              "2026-02-23": 2,
              "2026-02-24": 1,
              "2026-02-28": 2,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-14": 1,
              "2026-03-17": 10,
              "2026-03-18": 31,
              "2026-03-19": 1,
              "2026-03-20": 6,
              "2026-03-23": 1,
              "2026-03-24": 7,
              "2026-03-25": 4,
              "2026-03-26": 1,
              "2026-03-27": 2,
              "2026-03-30": 6,
              "2026-04-01": 1,
              "2026-04-04": 2,
              "2026-04-07": 1,
              "2026-04-08": 5,
              "2026-04-09": 2,
              "2026-04-10": 1,
              "2026-04-13": 4,
              "2026-04-14": 3,
              "2026-04-15": 3,
              "2026-04-16": 3,
              "2026-04-17": 2,
              "2026-04-21": 1,
              "2026-04-22": 9,
              "2026-04-23": 1,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-02": 2,
              "2026-05-04": 6,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-11": 6,
              "2026-05-12": 3,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-18": 2,
              "2026-05-19": 1,
              "2026-05-20": 4,
              "2026-05-22": 3,
              "2026-05-23": 3,
              "2026-05-25": 2,
              "2026-05-26": 5,
              "2026-05-27": 3,
              "2026-06-01": 1,
              "2026-06-02": 4,
              "2026-06-03": 2,
              "2026-06-05": 3,
              "2026-06-06": 1,
              "2026-06-08": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 24.43,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 1,
                "118-120h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-22": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-03-27": 2,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-12-22": 7.906338333333333,
                "2026-02-10": 119.56869527777778,
                "2026-03-10": 9.520774722222221,
                "2026-03-27": 4.043255833333333,
                "2026-06-03": 5.559647777777778
              },
              "time_count_per_day": {
                "2025-12-22": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-03-27": 2,
                "2026-06-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 34.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 76,
              "time_distribution": {
                "0-2h": 76,
                "2-4h": 20,
                "4-6h": 15,
                "6-8h": 6,
                "8-10h": 4,
                "10-12h": 3,
                "12-14h": 2,
                "24-26h": 2,
                "30-32h": 1,
                "32-34h": 1,
                "38-40h": 2,
                "148-150h": 1,
                "160-162h": 1,
                "168-170h": 1,
                "342-344h": 1,
                "596-598h": 1,
                "938-940h": 1,
                "1896-1898h": 1
              },
              "tickets_count": 139,
              "tickets_per_day": {
                "2025-10-22": 1,
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2025-12-04": 2,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-24": 1,
                "2026-01-08": 3,
                "2026-01-16": 1,
                "2026-01-26": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-17": 5,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-20": 5,
                "2026-03-23": 1,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-30": 5,
                "2026-04-01": 1,
                "2026-04-04": 2,
                "2026-04-07": 1,
                "2026-04-08": 5,
                "2026-04-09": 2,
                "2026-04-10": 1,
                "2026-04-13": 4,
                "2026-04-14": 3,
                "2026-04-15": 3,
                "2026-04-16": 3,
                "2026-04-17": 2,
                "2026-04-21": 1,
                "2026-04-22": 3,
                "2026-04-23": 1,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-02": 2,
                "2026-05-04": 6,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-11": 6,
                "2026-05-12": 3,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-18": 2,
                "2026-05-19": 1,
                "2026-05-20": 4,
                "2026-05-22": 3,
                "2026-05-23": 3,
                "2026-05-25": 2,
                "2026-05-26": 5,
                "2026-05-27": 3,
                "2026-06-01": 1,
                "2026-06-02": 4,
                "2026-06-03": 1,
                "2026-06-05": 3,
                "2026-06-06": 1,
                "2026-06-08": 3
              },
              "time_per_day": {
                "2025-10-22": 6.639176111111111,
                "2025-11-24": 4.952985833333333,
                "2025-12-02": 149.55092861111112,
                "2025-12-04": 5.817374166666667,
                "2025-12-19": 173.33231194444443,
                "2025-12-22": 8.112338333333334,
                "2025-12-24": 1.3877719444444445,
                "2026-01-08": 21.169596666666667,
                "2026-01-16": 5.728996944444444,
                "2026-01-26": 10.233933888888888,
                "2026-02-09": 1.4262691666666667,
                "2026-02-10": 8.5255875,
                "2026-02-24": 0.34394611111111106,
                "2026-03-03": 1.4437605555555555,
                "2026-03-04": 4.650855555555556,
                "2026-03-05": 0.7748208333333333,
                "2026-03-06": 10.510086388888888,
                "2026-03-10": 1.2494769444444445,
                "2026-03-11": 13.061363888888888,
                "2026-03-17": 11.365965555555558,
                "2026-03-18": 0.8289036111111111,
                "2026-03-19": 3.464633611111111,
                "2026-03-20": 988.3901283333332,
                "2026-03-23": 0.7693255555555556,
                "2026-03-24": 12.592222222222222,
                "2026-03-25": 0.42784527777777775,
                "2026-03-30": 20.92114416666667,
                "2026-04-01": 0.5499461111111111,
                "2026-04-04": 2.5494369444444445,
                "2026-04-07": 5.746321388888889,
                "2026-04-08": 15.42652027777778,
                "2026-04-09": 2.559088611111111,
                "2026-04-10": 4.481355,
                "2026-04-13": 1.0219008333333333,
                "2026-04-14": 3.394772222222222,
                "2026-04-15": 34.4505975,
                "2026-04-16": 28.780241666666665,
                "2026-04-17": 3.058755555555556,
                "2026-04-21": 1.4712852777777778,
                "2026-04-22": 1.8974933333333333,
                "2026-04-23": 343.0389533333334,
                "2026-04-27": 0.3276894444444444,
                "2026-04-30": 1.9550694444444445,
                "2026-05-02": 38.63679777777779,
                "2026-05-04": 5.875669166666667,
                "2026-05-06": 1896.6734847222222,
                "2026-05-07": 2.603385277777778,
                "2026-05-11": 10.451883333333333,
                "2026-05-12": 28.38133777777778,
                "2026-05-13": 0.03328472222222222,
                "2026-05-14": 0.21503666666666665,
                "2026-05-18": 161.17656305555553,
                "2026-05-19": 1.0565463888888889,
                "2026-05-20": 9.88547611111111,
                "2026-05-22": 2.0684194444444444,
                "2026-05-23": 4.312508055555556,
                "2026-05-25": 9.256776666666665,
                "2026-05-26": 2.4749855555555555,
                "2026-05-27": 43.72586277777778,
                "2026-06-01": 5.719321944444445,
                "2026-06-02": 12.491269166666667,
                "2026-06-03": 11.956362222222223,
                "2026-06-05": 9.727704444444445,
                "2026-06-06": 597.7866297222223,
                "2026-06-08": 1.006018888888889
              },
              "time_count_per_day": {
                "2025-10-22": 1,
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2025-12-04": 2,
                "2025-12-19": 2,
                "2025-12-22": 1,
                "2025-12-24": 1,
                "2026-01-08": 3,
                "2026-01-16": 1,
                "2026-01-26": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-17": 5,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-20": 5,
                "2026-03-23": 1,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-30": 5,
                "2026-04-01": 1,
                "2026-04-04": 2,
                "2026-04-07": 1,
                "2026-04-08": 5,
                "2026-04-09": 2,
                "2026-04-10": 1,
                "2026-04-13": 4,
                "2026-04-14": 3,
                "2026-04-15": 3,
                "2026-04-16": 3,
                "2026-04-17": 2,
                "2026-04-21": 1,
                "2026-04-22": 3,
                "2026-04-23": 1,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-02": 2,
                "2026-05-04": 6,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-11": 6,
                "2026-05-12": 3,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-18": 2,
                "2026-05-19": 1,
                "2026-05-20": 4,
                "2026-05-22": 3,
                "2026-05-23": 3,
                "2026-05-25": 2,
                "2026-05-26": 5,
                "2026-05-27": 3,
                "2026-06-01": 1,
                "2026-06-02": 4,
                "2026-06-03": 1,
                "2026-06-05": 3,
                "2026-06-06": 1,
                "2026-06-08": 3
              }
            },
            "P3": {
              "avg_time_hours": 97.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 1,
                "20-22h": 1,
                "32-34h": 1,
                "42-44h": 1,
                "78-80h": 1,
                "118-120h": 1,
                "168-170h": 1,
                "498-500h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-10-03": 1,
                "2025-10-13": 1,
                "2025-11-24": 1,
                "2025-12-24": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-10-03": 42.59790194444444,
                "2025-10-13": 0.18714916666666664,
                "2025-11-24": 119.91055361111111,
                "2025-12-24": 168.85691972222222,
                "2026-02-02": 0.7296752777777779,
                "2026-02-03": 5.118578611111111,
                "2026-02-10": 531.6398713888889,
                "2026-02-13": 79.86706055555555,
                "2026-02-18": 21.916291666666666
              },
              "time_count_per_day": {
                "2025-10-03": 1,
                "2025-10-13": 1,
                "2025-11-24": 1,
                "2025-12-24": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 173.55,
              "mode_time_hours": 41.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "4-6h": 3,
                "12-14h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 2,
                "24-26h": 1,
                "26-28h": 1,
                "28-30h": 3,
                "32-34h": 1,
                "36-38h": 4,
                "38-40h": 1,
                "40-42h": 5,
                "42-44h": 1,
                "48-50h": 2,
                "50-52h": 2,
                "54-56h": 3,
                "62-64h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "82-84h": 1,
                "96-98h": 2,
                "98-100h": 2,
                "100-102h": 1,
                "104-106h": 2,
                "114-116h": 1,
                "122-124h": 2,
                "124-126h": 1,
                "130-132h": 3,
                "132-134h": 1,
                "136-138h": 1,
                "162-164h": 1,
                "166-168h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "180-182h": 2,
                "192-194h": 1,
                "194-196h": 1,
                "216-218h": 4,
                "218-220h": 1,
                "228-230h": 1,
                "238-240h": 1,
                "248-250h": 1,
                "258-260h": 1,
                "260-262h": 1,
                "264-266h": 1,
                "288-290h": 1,
                "310-312h": 1,
                "324-326h": 1,
                "328-330h": 1,
                "332-334h": 1,
                "334-336h": 1,
                "348-350h": 1,
                "356-358h": 1,
                "372-374h": 1,
                "384-386h": 2,
                "398-400h": 1,
                "400-402h": 1,
                "410-412h": 1,
                "426-428h": 2,
                "428-430h": 1,
                "430-432h": 1,
                "466-468h": 1,
                "478-480h": 1,
                "480-482h": 1,
                "498-500h": 1,
                "634-636h": 1,
                "664-666h": 1,
                "674-676h": 1
              },
              "tickets_count": 104,
              "tickets_per_day": {
                "2025-10-01": 1,
                "2025-10-08": 2,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-13": 2,
                "2025-10-17": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-06": 3,
                "2025-11-20": 4,
                "2025-11-21": 2,
                "2025-11-25": 1,
                "2025-11-29": 1,
                "2025-12-03": 1,
                "2025-12-04": 2,
                "2025-12-05": 1,
                "2026-01-13": 3,
                "2026-01-21": 1,
                "2026-01-30": 2,
                "2026-02-04": 1,
                "2026-02-06": 4,
                "2026-02-09": 3,
                "2026-02-10": 1,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-13": 3,
                "2026-02-14": 1,
                "2026-02-23": 2,
                "2026-02-28": 2,
                "2026-03-14": 1,
                "2026-03-17": 5,
                "2026-03-18": 30,
                "2026-03-20": 1,
                "2026-03-24": 5,
                "2026-03-25": 3,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-22": 6
              },
              "time_per_day": {
                "2025-10-01": 1.9936175,
                "2025-10-08": 186.09257638888892,
                "2025-10-09": 54.84737361111112,
                "2025-10-10": 82.87740944444444,
                "2025-10-13": 109.50871000000001,
                "2025-10-17": 24.687799166666668,
                "2025-10-30": 249.97340888888888,
                "2025-11-03": 265.9227525,
                "2025-11-06": 408.71828805555555,
                "2025-11-20": 270.05823444444445,
                "2025-11-21": 454.0513086111111,
                "2025-11-25": 20.172942222222222,
                "2025-11-29": 71.21058611111111,
                "2025-12-03": 5.204712777777778,
                "2025-12-04": 60.907776111111104,
                "2025-12-05": 1.2718855555555555,
                "2026-01-13": 394.56335749999994,
                "2026-01-21": 77.54844055555556,
                "2026-01-30": 1308.9209999999998,
                "2026-02-04": 133.0584736111111,
                "2026-02-06": 208.9072488888889,
                "2026-02-09": 484.4482194444444,
                "2026-02-10": 173.01703333333333,
                "2026-02-11": 395.03101944444444,
                "2026-02-12": 175.3994827777778,
                "2026-02-13": 125.03175777777778,
                "2026-02-14": 23.35452777777778,
                "2026-02-23": 85.21072972222223,
                "2026-02-28": 55.63298027777778,
                "2026-03-14": 26.781325833333334,
                "2026-03-17": 154.09752722222223,
                "2026-03-18": 10243.66537833333,
                "2026-03-20": 29.05757,
                "2026-03-24": 431.89307500000007,
                "2026-03-25": 60.4471775,
                "2026-03-26": 194.87155916666666,
                "2026-03-30": 75.30378416666667,
                "2026-04-22": 925.5526527777777
              },
              "time_count_per_day": {
                "2025-10-01": 1,
                "2025-10-08": 2,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-13": 2,
                "2025-10-17": 1,
                "2025-10-30": 1,
                "2025-11-03": 1,
                "2025-11-06": 3,
                "2025-11-20": 4,
                "2025-11-21": 2,
                "2025-11-25": 1,
                "2025-11-29": 1,
                "2025-12-03": 1,
                "2025-12-04": 2,
                "2025-12-05": 1,
                "2026-01-13": 3,
                "2026-01-21": 1,
                "2026-01-30": 2,
                "2026-02-04": 1,
                "2026-02-06": 4,
                "2026-02-09": 3,
                "2026-02-10": 1,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-13": 3,
                "2026-02-14": 1,
                "2026-02-23": 2,
                "2026-02-28": 2,
                "2026-03-14": 1,
                "2026-03-17": 5,
                "2026-03-18": 30,
                "2026-03-20": 1,
                "2026-03-24": 5,
                "2026-03-25": 3,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-22": 6
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 541.97,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "40-42h": 1,
                "46-48h": 1,
                "62-64h": 1,
                "78-80h": 1,
                "182-184h": 1,
                "186-188h": 1,
                "216-218h": 1,
                "240-242h": 1,
                "298-300h": 1,
                "300-302h": 1,
                "334-336h": 1,
                "358-360h": 1,
                "364-366h": 1,
                "368-370h": 1,
                "470-472h": 1,
                "480-482h": 1,
                "552-554h": 1,
                "658-660h": 1,
                "720-722h": 1,
                "768-770h": 2,
                "878-880h": 1,
                "960-962h": 1,
                "994-996h": 1,
                "1020-1022h": 1,
                "1124-1126h": 1,
                "1368-1370h": 1,
                "2390-2392h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-02": 1,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-02-13": 1,
                "2026-02-19": 20
              },
              "time_per_day": {
                "2025-12-11": 776.0358738888889,
                "2025-12-12": 217.71522527777776,
                "2025-12-15": 1.1697969444444445,
                "2025-12-17": 365.40546,
                "2026-01-02": 0.8217122222222223,
                "2026-01-15": 995.7977094444445,
                "2026-01-17": 78.56695083333332,
                "2026-02-13": 41.974001111111114,
                "2026-02-19": 13781.633425555552
              },
              "time_count_per_day": {
                "2025-12-11": 3,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-02": 1,
                "2026-01-15": 1,
                "2026-01-17": 1,
                "2026-02-13": 1,
                "2026-02-19": 20
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 25,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-02-23": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-20": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-04": 1,
              "2026-04-08": 2,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-04-29": 2,
              "2026-05-08": 2,
              "2026-05-13": 1,
              "2026-05-18": 3,
              "2026-05-20": 2,
              "2026-05-30": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 22,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-03-20": 1,
                "2026-03-30": 1,
                "2026-03-31": 1,
                "2026-04-04": 1,
                "2026-04-08": 2,
                "2026-04-21": 1,
                "2026-04-23": 2,
                "2026-04-29": 2,
                "2026-05-08": 2,
                "2026-05-13": 1,
                "2026-05-18": 3,
                "2026-05-20": 2,
                "2026-05-30": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-02-23": 1,
                "2026-03-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-27": 1,
              "2026-03-19": 1,
              "2026-04-21": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-27": 1,
                "2026-03-19": 1,
                "2026-04-21": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_90": {
      "overall": {
        "avg_time_hours": 218.02,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "4-6h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "42-44h": 1,
          "68-70h": 1,
          "76-78h": 1,
          "96-98h": 1,
          "334-336h": 1,
          "366-368h": 1,
          "984-986h": 1,
          "1012-1014h": 1
        },
        "tickets_count": 16,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-11-24": 1,
          "2025-12-24": 1,
          "2026-02-09": 1,
          "2026-03-07": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-04-08": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-05-29": 2,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-10-15": 334.0021116666667,
          "2025-11-24": 96.89977333333333,
          "2025-12-24": 42.500729722222225,
          "2026-02-09": 2.477857777777778,
          "2026-03-07": 32.194872777777775,
          "2026-03-11": 366.3769986111111,
          "2026-03-13": 0.08066333333333332,
          "2026-04-22": 985.7507372222223,
          "2026-04-23": 1012.6033455555556,
          "2026-05-22": 29.244723611111112,
          "2026-05-26": 0.3428272222222222,
          "2026-05-29": 81.63705555555555,
          "2026-06-01": 68.14458444444445
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-11-24": 1,
          "2025-12-24": 1,
          "2026-02-09": 1,
          "2026-03-07": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-05-29": 2,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 246.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 1,
            "28-30h": 1,
            "32-34h": 1,
            "42-44h": 1,
            "68-70h": 1,
            "76-78h": 1,
            "334-336h": 1,
            "366-368h": 1,
            "984-986h": 1,
            "1012-1014h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-12-24": 1,
            "2026-03-07": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-04-08": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-29": 2,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-15": 334.0021116666667,
            "2025-12-24": 42.500729722222225,
            "2026-03-07": 32.194872777777775,
            "2026-03-11": 366.3769986111111,
            "2026-03-13": 0.08066333333333332,
            "2026-04-22": 985.7507372222223,
            "2026-04-23": 1012.6033455555556,
            "2026-05-22": 29.244723611111112,
            "2026-05-26": 0.3428272222222222,
            "2026-05-29": 81.63705555555555,
            "2026-06-01": 68.14458444444445
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-12-24": 1,
            "2026-03-07": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-29": 2,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 49.69,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "96-98h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2026-02-09": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2025-11-24": 96.89977333333333,
            "2026-02-09": 2.477857777777778
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 218.02,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "4-6h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "42-44h": 1,
              "68-70h": 1,
              "76-78h": 1,
              "96-98h": 1,
              "334-336h": 1,
              "366-368h": 1,
              "984-986h": 1,
              "1012-1014h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-11-24": 1,
              "2025-12-24": 1,
              "2026-02-09": 1,
              "2026-03-07": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-15": 334.0021116666667,
              "2025-11-24": 96.89977333333333,
              "2025-12-24": 42.500729722222225,
              "2026-02-09": 2.477857777777778,
              "2026-03-07": 32.194872777777775,
              "2026-03-11": 366.3769986111111,
              "2026-03-13": 0.08066333333333332,
              "2026-04-22": 985.7507372222223,
              "2026-04-23": 1012.6033455555556,
              "2026-05-22": 29.244723611111112,
              "2026-05-26": 0.3428272222222222,
              "2026-05-29": 81.63705555555555,
              "2026-06-01": 68.14458444444445
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-11-24": 1,
              "2025-12-24": 1,
              "2026-02-09": 1,
              "2026-03-07": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 246.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 1,
                "28-30h": 1,
                "32-34h": 1,
                "42-44h": 1,
                "68-70h": 1,
                "76-78h": 1,
                "334-336h": 1,
                "366-368h": 1,
                "984-986h": 1,
                "1012-1014h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-12-24": 1,
                "2026-03-07": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-29": 2,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-15": 334.0021116666667,
                "2025-12-24": 42.500729722222225,
                "2026-03-07": 32.194872777777775,
                "2026-03-11": 366.3769986111111,
                "2026-03-13": 0.08066333333333332,
                "2026-04-22": 985.7507372222223,
                "2026-04-23": 1012.6033455555556,
                "2026-05-22": 29.244723611111112,
                "2026-05-26": 0.3428272222222222,
                "2026-05-29": 81.63705555555555,
                "2026-06-01": 68.14458444444445
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-12-24": 1,
                "2026-03-07": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-29": 2,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 49.69,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "96-98h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2025-11-24": 96.89977333333333,
                "2026-02-09": 2.477857777777778
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2026-02-09": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_92": {
      "overall": {
        "avg_time_hours": 171.39,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "2-4h": 2,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 2,
          "16-18h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 2,
          "24-26h": 1,
          "26-28h": 1,
          "48-50h": 1,
          "50-52h": 1,
          "52-54h": 1,
          "56-58h": 2,
          "68-70h": 1,
          "76-78h": 1,
          "80-82h": 1,
          "98-100h": 1,
          "102-104h": 1,
          "112-114h": 1,
          "118-120h": 1,
          "128-130h": 1,
          "134-136h": 1,
          "146-148h": 1,
          "162-164h": 1,
          "170-172h": 1,
          "194-196h": 1,
          "200-202h": 1,
          "204-206h": 1,
          "212-214h": 1,
          "240-242h": 1,
          "478-480h": 1,
          "480-482h": 1,
          "528-530h": 1,
          "626-628h": 1,
          "628-630h": 1,
          "704-706h": 1,
          "1194-1196h": 1,
          "1316-1318h": 1
        },
        "tickets_count": 58,
        "tickets_per_day": {
          "2025-10-02": 1,
          "2025-10-07": 3,
          "2025-10-10": 1,
          "2025-10-20": 1,
          "2025-10-23": 1,
          "2025-10-31": 1,
          "2025-11-04": 1,
          "2025-11-07": 1,
          "2025-11-12": 2,
          "2025-11-22": 1,
          "2025-11-28": 1,
          "2025-12-14": 1,
          "2025-12-15": 2,
          "2026-01-17": 1,
          "2026-01-26": 2,
          "2026-01-28": 1,
          "2026-02-03": 3,
          "2026-02-06": 2,
          "2026-02-07": 1,
          "2026-02-09": 1,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-04-01": 1,
          "2026-04-10": 1,
          "2026-04-15": 1,
          "2026-04-18": 1,
          "2026-04-23": 3,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-22": 1,
          "2026-05-29": 4,
          "2026-06-02": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-02": 19.914869166666666,
          "2025-10-07": 172.37680861111113,
          "2025-10-10": 80.08851111111112,
          "2025-10-23": 49.580240277777776,
          "2025-10-31": 3.2199230555555554,
          "2025-11-04": 529.0714475,
          "2025-11-07": 0.099555,
          "2025-11-12": 293.1635102777778,
          "2025-11-22": 52.83769583333333,
          "2025-11-28": 213.62274250000002,
          "2025-12-14": 50.74408666666667,
          "2025-12-15": 1254.168186388889,
          "2026-01-17": 9.858850555555556,
          "2026-01-26": 81.96731833333332,
          "2026-01-28": 7.488798611111111,
          "2026-02-03": 358.6502888888889,
          "2026-02-06": 267.10810333333336,
          "2026-02-07": 3.7770802777777774,
          "2026-02-09": 119.41169277777777,
          "2026-02-14": 68.14672777777778,
          "2026-02-18": 134.35946027777777,
          "2026-03-06": 162.048795,
          "2026-03-16": 113.22090388888888,
          "2026-03-17": 201.07729722222223,
          "2026-03-20": 705.6525508333334,
          "2026-03-27": 0.6350011111111111,
          "2026-04-01": 113.80977472222223,
          "2026-04-10": 480.3397525,
          "2026-04-15": 16.790120833333333,
          "2026-04-18": 22.861921944444443,
          "2026-04-23": 2512.029682777778,
          "2026-04-28": 1.7552908333333332,
          "2026-04-29": 479.9495716666667,
          "2026-05-11": 5.909871944444444,
          "2026-05-14": 19.80460972222222,
          "2026-05-19": 1.3700677777777777,
          "2026-05-20": 170.8871086111111,
          "2026-05-22": 20.392615555555555,
          "2026-05-29": 112.77017277777777,
          "2026-06-02": 1.4592691666666666
        },
        "time_count_per_day": {
          "2025-10-02": 1,
          "2025-10-07": 2,
          "2025-10-10": 1,
          "2025-10-23": 1,
          "2025-10-31": 1,
          "2025-11-04": 1,
          "2025-11-07": 1,
          "2025-11-12": 2,
          "2025-11-22": 1,
          "2025-11-28": 1,
          "2025-12-14": 1,
          "2025-12-15": 2,
          "2026-01-17": 1,
          "2026-01-26": 2,
          "2026-01-28": 1,
          "2026-02-03": 3,
          "2026-02-06": 2,
          "2026-02-07": 1,
          "2026-02-09": 1,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-04-01": 1,
          "2026-04-10": 1,
          "2026-04-15": 1,
          "2026-04-18": 1,
          "2026-04-23": 3,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-22": 1,
          "2026-05-29": 3,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.78,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-07": 1
          },
          "time_per_day": {
            "2026-02-07": 3.7770802777777774
          },
          "time_count_per_day": {
            "2026-02-07": 1
          }
        },
        "P2": {
          "avg_time_hours": 195.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 1,
            "4-6h": 2,
            "8-10h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "48-50h": 1,
            "56-58h": 2,
            "80-82h": 1,
            "98-100h": 1,
            "102-104h": 1,
            "112-114h": 1,
            "118-120h": 1,
            "134-136h": 1,
            "146-148h": 1,
            "162-164h": 1,
            "170-172h": 1,
            "204-206h": 1,
            "212-214h": 1,
            "240-242h": 1,
            "478-480h": 1,
            "480-482h": 1,
            "528-530h": 1,
            "628-630h": 1,
            "704-706h": 1,
            "1194-1196h": 1,
            "1316-1318h": 1
          },
          "tickets_count": 44,
          "tickets_per_day": {
            "2025-10-07": 3,
            "2025-10-10": 1,
            "2025-10-20": 1,
            "2025-10-23": 1,
            "2025-10-31": 1,
            "2025-11-04": 1,
            "2025-11-07": 1,
            "2025-11-12": 1,
            "2025-11-28": 1,
            "2025-12-15": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-18": 1,
            "2026-03-06": 1,
            "2026-03-16": 2,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-01": 1,
            "2026-04-10": 1,
            "2026-04-15": 1,
            "2026-04-18": 1,
            "2026-04-23": 3,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-29": 4,
            "2026-06-02": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-07": 172.37680861111113,
            "2025-10-10": 80.08851111111112,
            "2025-10-23": 49.580240277777776,
            "2025-10-31": 3.2199230555555554,
            "2025-11-04": 529.0714475,
            "2025-11-07": 0.099555,
            "2025-11-12": 98.54932444444445,
            "2025-11-28": 213.62274250000002,
            "2025-12-15": 628.0993116666666,
            "2026-01-26": 4.218675277777778,
            "2026-02-03": 205.5472111111111,
            "2026-02-06": 240.90648666666667,
            "2026-02-09": 119.41169277777777,
            "2026-02-18": 134.35946027777777,
            "2026-03-06": 162.048795,
            "2026-03-16": 113.22090388888888,
            "2026-03-20": 705.6525508333334,
            "2026-03-27": 0.6350011111111111,
            "2026-04-01": 113.80977472222223,
            "2026-04-10": 480.3397525,
            "2026-04-15": 16.790120833333333,
            "2026-04-18": 22.861921944444443,
            "2026-04-23": 2512.029682777778,
            "2026-04-28": 1.7552908333333332,
            "2026-04-29": 479.9495716666667,
            "2026-05-11": 5.909871944444444,
            "2026-05-14": 19.80460972222222,
            "2026-05-19": 1.3700677777777777,
            "2026-05-20": 170.8871086111111,
            "2026-05-22": 20.392615555555555,
            "2026-05-29": 112.77017277777777,
            "2026-06-02": 1.4592691666666666
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-10-10": 1,
            "2025-10-23": 1,
            "2025-10-31": 1,
            "2025-11-04": 1,
            "2025-11-07": 1,
            "2025-11-12": 1,
            "2025-11-28": 1,
            "2025-12-15": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-18": 1,
            "2026-03-06": 1,
            "2026-03-16": 2,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-01": 1,
            "2026-04-10": 1,
            "2026-04-15": 1,
            "2026-04-18": 1,
            "2026-04-23": 3,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-22": 1,
            "2026-05-29": 3,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 114.45,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "50-52h": 1,
            "52-54h": 1,
            "68-70h": 1,
            "76-78h": 1,
            "128-130h": 1,
            "194-196h": 1,
            "200-202h": 1,
            "626-628h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2025-11-12": 1,
            "2025-11-22": 1,
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2026-01-17": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-14": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2025-10-02": 19.914869166666666,
            "2025-11-12": 194.61418583333335,
            "2025-11-22": 52.83769583333333,
            "2025-12-14": 50.74408666666667,
            "2025-12-15": 626.0688747222222,
            "2026-01-17": 9.858850555555556,
            "2026-01-26": 77.74864305555555,
            "2026-01-28": 7.488798611111111,
            "2026-02-03": 153.1030777777778,
            "2026-02-06": 26.20161666666667,
            "2026-02-14": 68.14672777777778,
            "2026-03-17": 201.07729722222223
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2025-11-12": 1,
            "2025-11-22": 1,
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2026-01-17": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-14": 1,
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 171.39,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "2-4h": 2,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 2,
              "16-18h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 2,
              "24-26h": 1,
              "26-28h": 1,
              "48-50h": 1,
              "50-52h": 1,
              "52-54h": 1,
              "56-58h": 2,
              "68-70h": 1,
              "76-78h": 1,
              "80-82h": 1,
              "98-100h": 1,
              "102-104h": 1,
              "112-114h": 1,
              "118-120h": 1,
              "128-130h": 1,
              "134-136h": 1,
              "146-148h": 1,
              "162-164h": 1,
              "170-172h": 1,
              "194-196h": 1,
              "200-202h": 1,
              "204-206h": 1,
              "212-214h": 1,
              "240-242h": 1,
              "478-480h": 1,
              "480-482h": 1,
              "528-530h": 1,
              "626-628h": 1,
              "628-630h": 1,
              "704-706h": 1,
              "1194-1196h": 1,
              "1316-1318h": 1
            },
            "tickets_count": 52,
            "tickets_per_day": {
              "2025-10-02": 1,
              "2025-10-07": 2,
              "2025-10-10": 1,
              "2025-10-23": 1,
              "2025-10-31": 1,
              "2025-11-04": 1,
              "2025-11-07": 1,
              "2025-11-12": 2,
              "2025-11-22": 1,
              "2025-11-28": 1,
              "2025-12-14": 1,
              "2025-12-15": 2,
              "2026-01-17": 1,
              "2026-01-26": 2,
              "2026-01-28": 1,
              "2026-02-03": 3,
              "2026-02-06": 2,
              "2026-02-07": 1,
              "2026-02-09": 1,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-01": 1,
              "2026-04-10": 1,
              "2026-04-15": 1,
              "2026-04-18": 1,
              "2026-04-23": 3,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-29": 3,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-10-02": 19.914869166666666,
              "2025-10-07": 172.37680861111113,
              "2025-10-10": 80.08851111111112,
              "2025-10-23": 49.580240277777776,
              "2025-10-31": 3.2199230555555554,
              "2025-11-04": 529.0714475,
              "2025-11-07": 0.099555,
              "2025-11-12": 293.1635102777778,
              "2025-11-22": 52.83769583333333,
              "2025-11-28": 213.62274250000002,
              "2025-12-14": 50.74408666666667,
              "2025-12-15": 1254.168186388889,
              "2026-01-17": 9.858850555555556,
              "2026-01-26": 81.96731833333332,
              "2026-01-28": 7.488798611111111,
              "2026-02-03": 358.6502888888889,
              "2026-02-06": 267.10810333333336,
              "2026-02-07": 3.7770802777777774,
              "2026-02-09": 119.41169277777777,
              "2026-02-14": 68.14672777777778,
              "2026-02-18": 134.35946027777777,
              "2026-03-06": 162.048795,
              "2026-03-16": 113.22090388888888,
              "2026-03-17": 201.07729722222223,
              "2026-03-20": 705.6525508333334,
              "2026-03-27": 0.6350011111111111,
              "2026-04-01": 113.80977472222223,
              "2026-04-10": 480.3397525,
              "2026-04-15": 16.790120833333333,
              "2026-04-18": 22.861921944444443,
              "2026-04-23": 2512.029682777778,
              "2026-04-28": 1.7552908333333332,
              "2026-04-29": 479.9495716666667,
              "2026-05-11": 5.909871944444444,
              "2026-05-14": 19.80460972222222,
              "2026-05-19": 1.3700677777777777,
              "2026-05-20": 170.8871086111111,
              "2026-05-22": 20.392615555555555,
              "2026-05-29": 112.77017277777777,
              "2026-06-02": 1.4592691666666666
            },
            "time_count_per_day": {
              "2025-10-02": 1,
              "2025-10-07": 2,
              "2025-10-10": 1,
              "2025-10-23": 1,
              "2025-10-31": 1,
              "2025-11-04": 1,
              "2025-11-07": 1,
              "2025-11-12": 2,
              "2025-11-22": 1,
              "2025-11-28": 1,
              "2025-12-14": 1,
              "2025-12-15": 2,
              "2026-01-17": 1,
              "2026-01-26": 2,
              "2026-01-28": 1,
              "2026-02-03": 3,
              "2026-02-06": 2,
              "2026-02-07": 1,
              "2026-02-09": 1,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-01": 1,
              "2026-04-10": 1,
              "2026-04-15": 1,
              "2026-04-18": 1,
              "2026-04-23": 3,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-22": 1,
              "2026-05-29": 3,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.78,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-07": 1
              },
              "time_per_day": {
                "2026-02-07": 3.7770802777777774
              },
              "time_count_per_day": {
                "2026-02-07": 1
              }
            },
            "P2": {
              "avg_time_hours": 195.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 1,
                "4-6h": 2,
                "8-10h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "48-50h": 1,
                "56-58h": 2,
                "80-82h": 1,
                "98-100h": 1,
                "102-104h": 1,
                "112-114h": 1,
                "118-120h": 1,
                "134-136h": 1,
                "146-148h": 1,
                "162-164h": 1,
                "170-172h": 1,
                "204-206h": 1,
                "212-214h": 1,
                "240-242h": 1,
                "478-480h": 1,
                "480-482h": 1,
                "528-530h": 1,
                "628-630h": 1,
                "704-706h": 1,
                "1194-1196h": 1,
                "1316-1318h": 1
              },
              "tickets_count": 38,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-10-31": 1,
                "2025-11-04": 1,
                "2025-11-07": 1,
                "2025-11-12": 1,
                "2025-11-28": 1,
                "2025-12-15": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-16": 2,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-01": 1,
                "2026-04-10": 1,
                "2026-04-15": 1,
                "2026-04-18": 1,
                "2026-04-23": 3,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-29": 3,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-07": 172.37680861111113,
                "2025-10-10": 80.08851111111112,
                "2025-10-23": 49.580240277777776,
                "2025-10-31": 3.2199230555555554,
                "2025-11-04": 529.0714475,
                "2025-11-07": 0.099555,
                "2025-11-12": 98.54932444444445,
                "2025-11-28": 213.62274250000002,
                "2025-12-15": 628.0993116666666,
                "2026-01-26": 4.218675277777778,
                "2026-02-03": 205.5472111111111,
                "2026-02-06": 240.90648666666667,
                "2026-02-09": 119.41169277777777,
                "2026-02-18": 134.35946027777777,
                "2026-03-06": 162.048795,
                "2026-03-16": 113.22090388888888,
                "2026-03-20": 705.6525508333334,
                "2026-03-27": 0.6350011111111111,
                "2026-04-01": 113.80977472222223,
                "2026-04-10": 480.3397525,
                "2026-04-15": 16.790120833333333,
                "2026-04-18": 22.861921944444443,
                "2026-04-23": 2512.029682777778,
                "2026-04-28": 1.7552908333333332,
                "2026-04-29": 479.9495716666667,
                "2026-05-11": 5.909871944444444,
                "2026-05-14": 19.80460972222222,
                "2026-05-19": 1.3700677777777777,
                "2026-05-20": 170.8871086111111,
                "2026-05-22": 20.392615555555555,
                "2026-05-29": 112.77017277777777,
                "2026-06-02": 1.4592691666666666
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-10-31": 1,
                "2025-11-04": 1,
                "2025-11-07": 1,
                "2025-11-12": 1,
                "2025-11-28": 1,
                "2025-12-15": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-16": 2,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-01": 1,
                "2026-04-10": 1,
                "2026-04-15": 1,
                "2026-04-18": 1,
                "2026-04-23": 3,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-22": 1,
                "2026-05-29": 3,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 114.45,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "50-52h": 1,
                "52-54h": 1,
                "68-70h": 1,
                "76-78h": 1,
                "128-130h": 1,
                "194-196h": 1,
                "200-202h": 1,
                "626-628h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2025-11-12": 1,
                "2025-11-22": 1,
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2026-01-17": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-14": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2025-10-02": 19.914869166666666,
                "2025-11-12": 194.61418583333335,
                "2025-11-22": 52.83769583333333,
                "2025-12-14": 50.74408666666667,
                "2025-12-15": 626.0688747222222,
                "2026-01-17": 9.858850555555556,
                "2026-01-26": 77.74864305555555,
                "2026-01-28": 7.488798611111111,
                "2026-02-03": 153.1030777777778,
                "2026-02-06": 26.20161666666667,
                "2026-02-14": 68.14672777777778,
                "2026-03-17": 201.07729722222223
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2025-11-12": 1,
                "2025-11-22": 1,
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2026-01-17": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-14": 1,
                "2026-03-17": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-29": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-29": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_93": {
      "overall": {
        "avg_time_hours": 1.23,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-01": 1
        },
        "time_per_day": {
          "2025-10-01": 1.2259255555555557
        },
        "time_count_per_day": {
          "2025-10-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.23,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-01": 1
          },
          "time_per_day": {
            "2025-10-01": 1.2259255555555557
          },
          "time_count_per_day": {
            "2025-10-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.23,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-01": 1
            },
            "time_per_day": {
              "2025-10-01": 1.2259255555555557
            },
            "time_count_per_day": {
              "2025-10-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.23,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-01": 1
              },
              "time_per_day": {
                "2025-10-01": 1.2259255555555557
              },
              "time_count_per_day": {
                "2025-10-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_29": {
      "overall": {
        "avg_time_hours": 232.85,
        "mode_time_hours": 1.0,
        "mode_frequency": 12,
        "time_distribution": {
          "0-2h": 12,
          "2-4h": 5,
          "4-6h": 5,
          "6-8h": 2,
          "8-10h": 3,
          "10-12h": 2,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 2,
          "24-26h": 1,
          "26-28h": 2,
          "30-32h": 2,
          "32-34h": 2,
          "44-46h": 1,
          "46-48h": 2,
          "48-50h": 1,
          "50-52h": 1,
          "62-64h": 1,
          "68-70h": 1,
          "72-74h": 2,
          "74-76h": 1,
          "80-82h": 1,
          "94-96h": 8,
          "112-114h": 1,
          "114-116h": 1,
          "116-118h": 1,
          "120-122h": 1,
          "130-132h": 1,
          "142-144h": 1,
          "146-148h": 1,
          "170-172h": 1,
          "186-188h": 1,
          "196-198h": 1,
          "208-210h": 1,
          "244-246h": 1,
          "270-272h": 1,
          "294-296h": 1,
          "312-314h": 1,
          "316-318h": 1,
          "334-336h": 1,
          "354-356h": 1,
          "406-408h": 1,
          "408-410h": 1,
          "428-430h": 2,
          "444-446h": 1,
          "522-524h": 1,
          "526-528h": 1,
          "572-574h": 1,
          "596-598h": 1,
          "696-698h": 1,
          "872-874h": 1,
          "898-900h": 1,
          "1028-1030h": 1,
          "1242-1244h": 1,
          "1962-1964h": 1,
          "2534-2536h": 1,
          "2696-2698h": 1
        },
        "tickets_count": 102,
        "tickets_per_day": {
          "2025-10-06": 2,
          "2025-10-08": 1,
          "2025-10-22": 2,
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-30": 1,
          "2025-10-31": 2,
          "2025-11-04": 4,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-25": 1,
          "2025-12-02": 1,
          "2025-12-05": 1,
          "2025-12-10": 1,
          "2025-12-15": 2,
          "2025-12-18": 2,
          "2025-12-19": 1,
          "2026-01-14": 1,
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 3,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-18": 2,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-25": 2,
          "2026-02-28": 5,
          "2026-03-02": 1,
          "2026-03-03": 3,
          "2026-03-06": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-13": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-27": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 3,
          "2026-04-13": 1,
          "2026-04-28": 1,
          "2026-04-29": 2,
          "2026-05-04": 2,
          "2026-05-05": 5,
          "2026-05-06": 3,
          "2026-05-07": 2,
          "2026-05-08": 1,
          "2026-05-12": 1,
          "2026-05-14": 2,
          "2026-05-21": 1,
          "2026-05-22": 3,
          "2026-05-26": 1,
          "2026-05-27": 2,
          "2026-05-30": 1,
          "2026-06-01": 2,
          "2026-06-04": 1
        },
        "time_per_day": {
          "2025-10-06": 232.56886055555555,
          "2025-10-22": 149.62582527777778,
          "2025-10-23": 50.676446388888884,
          "2025-10-27": 80.0469075,
          "2025-10-28": 186.64255444444444,
          "2025-10-30": 4.096041666666666,
          "2025-10-31": 43.601792222222215,
          "2025-11-04": 381.7255552777778,
          "2025-11-05": 10.38404861111111,
          "2025-11-06": 696.3419258333333,
          "2025-11-10": 7.421793611111111,
          "2025-11-11": 170.26513,
          "2025-11-14": 244.19154916666668,
          "2025-11-25": 2.860138611111111,
          "2025-12-02": 354.15654472222224,
          "2025-12-05": 69.73713305555556,
          "2025-12-10": 121.35672583333333,
          "2025-12-15": 720.6487691666666,
          "2025-12-18": 145.8158338888889,
          "2025-12-19": 197.97872083333334,
          "2026-01-14": 46.72071944444444,
          "2026-01-20": 2696.038973333333,
          "2026-01-22": 2.3157091666666667,
          "2026-01-23": 428.36573027777774,
          "2026-02-03": 1202.5575244444444,
          "2026-02-04": 523.6057530555555,
          "2026-02-05": 62.753282500000005,
          "2026-02-12": 873.1119813888889,
          "2026-02-13": 46.53264583333333,
          "2026-02-18": 4498.4488458333335,
          "2026-02-19": 209.4822411111111,
          "2026-02-21": 27.11656138888889,
          "2026-02-25": 52.028060833333335,
          "2026-02-28": 407.03668277777774,
          "2026-03-02": 0.0349975,
          "2026-03-03": 40.012008888888886,
          "2026-03-06": 576.3652575,
          "2026-03-10": 445.80834027777775,
          "2026-03-11": 1.022285,
          "2026-03-13": 94.09008444444444,
          "2026-03-17": 270.7717138888889,
          "2026-03-20": 409.4483941666667,
          "2026-03-24": 1028.2715316666668,
          "2026-03-25": 5.446444166666667,
          "2026-03-27": 3.659043611111111,
          "2026-04-08": 0.9989797222222223,
          "2026-04-09": 30.556513333333335,
          "2026-04-10": 353.0044502777778,
          "2026-04-13": 74.84164361111111,
          "2026-04-29": 3.1177519444444446,
          "2026-05-04": 1355.9531480555556,
          "2026-05-05": 755.992845,
          "2026-05-06": 2.3491122222222223,
          "2026-05-07": 6.409149722222222,
          "2026-05-08": 429.469635,
          "2026-05-14": 58.02885611111111,
          "2026-05-21": 316.23515083333336,
          "2026-05-22": 526.5147394444444,
          "2026-05-27": 1.5519577777777778,
          "2026-06-01": 151.22730666666666
        },
        "time_count_per_day": {
          "2025-10-06": 2,
          "2025-10-22": 2,
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-30": 1,
          "2025-10-31": 2,
          "2025-11-04": 4,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-11-25": 1,
          "2025-12-02": 1,
          "2025-12-05": 1,
          "2025-12-10": 1,
          "2025-12-15": 2,
          "2025-12-18": 2,
          "2025-12-19": 1,
          "2026-01-14": 1,
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 3,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-18": 2,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-25": 2,
          "2026-02-28": 5,
          "2026-03-02": 1,
          "2026-03-03": 3,
          "2026-03-06": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-13": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-27": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 3,
          "2026-04-13": 1,
          "2026-04-29": 2,
          "2026-05-04": 2,
          "2026-05-05": 5,
          "2026-05-06": 3,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-14": 2,
          "2026-05-21": 1,
          "2026-05-22": 2,
          "2026-05-27": 2,
          "2026-06-01": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 112.18,
          "mode_time_hours": 113.0,
          "mode_frequency": 1,
          "time_distribution": {
            "112-114h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-04": 1,
            "2026-05-26": 1,
            "2026-06-04": 1
          },
          "time_per_day": {
            "2026-05-04": 112.17740722222223
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        },
        "P2": {
          "avg_time_hours": 133.17,
          "mode_time_hours": 1.0,
          "mode_frequency": 12,
          "time_distribution": {
            "0-2h": 12,
            "2-4h": 4,
            "4-6h": 5,
            "6-8h": 2,
            "8-10h": 2,
            "10-12h": 2,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "26-28h": 1,
            "30-32h": 2,
            "32-34h": 2,
            "44-46h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "72-74h": 2,
            "74-76h": 1,
            "80-82h": 1,
            "94-96h": 4,
            "130-132h": 1,
            "142-144h": 1,
            "146-148h": 1,
            "170-172h": 1,
            "186-188h": 1,
            "270-272h": 1,
            "294-296h": 1,
            "316-318h": 1,
            "334-336h": 1,
            "408-410h": 1,
            "428-430h": 2,
            "444-446h": 1,
            "596-598h": 1,
            "872-874h": 1,
            "1028-1030h": 1,
            "1242-1244h": 1
          },
          "tickets_count": 67,
          "tickets_per_day": {
            "2025-10-22": 2,
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-10-30": 1,
            "2025-10-31": 2,
            "2025-11-04": 4,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-12-18": 2,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-02-25": 2,
            "2026-03-02": 1,
            "2026-03-03": 3,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-13": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-27": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 3,
            "2026-04-13": 1,
            "2026-04-29": 2,
            "2026-05-04": 1,
            "2026-05-05": 5,
            "2026-05-06": 3,
            "2026-05-07": 2,
            "2026-05-08": 1,
            "2026-05-12": 1,
            "2026-05-14": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-27": 2,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2025-10-22": 149.62582527777778,
            "2025-10-23": 50.676446388888884,
            "2025-10-27": 80.0469075,
            "2025-10-28": 186.64255444444444,
            "2025-10-30": 4.096041666666666,
            "2025-10-31": 43.601792222222215,
            "2025-11-04": 381.7255552777778,
            "2025-11-05": 10.38404861111111,
            "2025-11-10": 7.421793611111111,
            "2025-11-11": 170.26513,
            "2025-12-18": 145.8158338888889,
            "2026-01-14": 46.72071944444444,
            "2026-01-22": 2.3157091666666667,
            "2026-01-23": 428.36573027777774,
            "2026-02-03": 294.1671288888889,
            "2026-02-12": 873.1119813888889,
            "2026-02-25": 52.028060833333335,
            "2026-03-02": 0.0349975,
            "2026-03-03": 40.012008888888886,
            "2026-03-06": 2.469580833333333,
            "2026-03-10": 445.80834027777775,
            "2026-03-11": 1.022285,
            "2026-03-13": 94.09008444444444,
            "2026-03-17": 270.7717138888889,
            "2026-03-20": 409.4483941666667,
            "2026-03-24": 1028.2715316666668,
            "2026-03-25": 5.446444166666667,
            "2026-03-27": 3.659043611111111,
            "2026-04-08": 0.9989797222222223,
            "2026-04-09": 30.556513333333335,
            "2026-04-10": 353.0044502777778,
            "2026-04-13": 74.84164361111111,
            "2026-04-29": 3.1177519444444446,
            "2026-05-04": 1243.7757408333334,
            "2026-05-05": 755.992845,
            "2026-05-06": 2.3491122222222223,
            "2026-05-07": 6.409149722222222,
            "2026-05-08": 429.469635,
            "2026-05-14": 58.02885611111111,
            "2026-05-21": 316.23515083333336,
            "2026-05-22": 0.1318997222222222,
            "2026-05-27": 1.5519577777777778,
            "2026-06-01": 151.22730666666666
          },
          "time_count_per_day": {
            "2025-10-22": 2,
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-10-30": 1,
            "2025-10-31": 2,
            "2025-11-04": 4,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-12-18": 2,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-02-25": 2,
            "2026-03-02": 1,
            "2026-03-03": 3,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-13": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-27": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 3,
            "2026-04-13": 1,
            "2026-04-29": 2,
            "2026-05-04": 1,
            "2026-05-05": 5,
            "2026-05-06": 3,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-14": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-27": 2,
            "2026-06-01": 2
          }
        },
        "P3": {
          "avg_time_hours": 621.47,
          "mode_time_hours": 115.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "8-10h": 1,
            "62-64h": 1,
            "68-70h": 1,
            "114-116h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "196-198h": 1,
            "244-246h": 1,
            "312-314h": 1,
            "354-356h": 1,
            "406-408h": 1,
            "522-524h": 1,
            "526-528h": 1,
            "572-574h": 1,
            "696-698h": 1,
            "898-900h": 1,
            "1962-1964h": 1,
            "2534-2536h": 1,
            "2696-2698h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-10-06": 2,
            "2025-10-08": 1,
            "2025-11-06": 1,
            "2025-11-14": 1,
            "2025-11-25": 1,
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2026-01-20": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-18": 2,
            "2026-03-06": 1,
            "2026-04-28": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2025-10-06": 232.56886055555555,
            "2025-11-06": 696.3419258333333,
            "2025-11-14": 244.19154916666668,
            "2025-11-25": 2.860138611111111,
            "2025-12-02": 354.15654472222224,
            "2025-12-05": 69.73713305555556,
            "2025-12-10": 121.35672583333333,
            "2025-12-15": 720.6487691666666,
            "2025-12-19": 197.97872083333334,
            "2026-01-20": 2696.038973333333,
            "2026-02-03": 908.3903955555555,
            "2026-02-04": 523.6057530555555,
            "2026-02-05": 62.753282500000005,
            "2026-02-18": 4498.4488458333335,
            "2026-03-06": 573.8956766666666,
            "2026-05-22": 526.3828397222222
          },
          "time_count_per_day": {
            "2025-10-06": 2,
            "2025-11-06": 1,
            "2025-11-14": 1,
            "2025-11-25": 1,
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2026-01-20": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-18": 2,
            "2026-03-06": 1,
            "2026-05-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 68.67,
          "mode_time_hours": 95.0,
          "mode_frequency": 4,
          "time_distribution": {
            "24-26h": 1,
            "26-28h": 1,
            "46-48h": 1,
            "94-96h": 4
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2026-02-13": 1,
            "2026-02-21": 1,
            "2026-02-28": 5,
            "2026-05-22": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-02-13": 46.53264583333333,
            "2026-02-21": 27.11656138888889,
            "2026-02-28": 407.03668277777774
          },
          "time_count_per_day": {
            "2026-02-13": 1,
            "2026-02-21": 1,
            "2026-02-28": 5
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 209.48,
          "mode_time_hours": 209.0,
          "mode_frequency": 1,
          "time_distribution": {
            "208-210h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 209.4822411111111
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 232.85,
            "mode_time_hours": 1.0,
            "mode_frequency": 12,
            "time_distribution": {
              "0-2h": 12,
              "2-4h": 5,
              "4-6h": 5,
              "6-8h": 2,
              "8-10h": 3,
              "10-12h": 2,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 2,
              "24-26h": 1,
              "26-28h": 2,
              "30-32h": 2,
              "32-34h": 2,
              "44-46h": 1,
              "46-48h": 2,
              "48-50h": 1,
              "50-52h": 1,
              "62-64h": 1,
              "68-70h": 1,
              "72-74h": 2,
              "74-76h": 1,
              "80-82h": 1,
              "94-96h": 8,
              "112-114h": 1,
              "114-116h": 1,
              "116-118h": 1,
              "120-122h": 1,
              "130-132h": 1,
              "142-144h": 1,
              "146-148h": 1,
              "170-172h": 1,
              "186-188h": 1,
              "196-198h": 1,
              "208-210h": 1,
              "244-246h": 1,
              "270-272h": 1,
              "294-296h": 1,
              "312-314h": 1,
              "316-318h": 1,
              "334-336h": 1,
              "354-356h": 1,
              "406-408h": 1,
              "408-410h": 1,
              "428-430h": 2,
              "444-446h": 1,
              "522-524h": 1,
              "526-528h": 1,
              "572-574h": 1,
              "596-598h": 1,
              "696-698h": 1,
              "872-874h": 1,
              "898-900h": 1,
              "1028-1030h": 1,
              "1242-1244h": 1,
              "1962-1964h": 1,
              "2534-2536h": 1,
              "2696-2698h": 1
            },
            "tickets_count": 94,
            "tickets_per_day": {
              "2025-10-06": 2,
              "2025-10-22": 2,
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-30": 1,
              "2025-10-31": 2,
              "2025-11-04": 4,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-25": 1,
              "2025-12-02": 1,
              "2025-12-05": 1,
              "2025-12-10": 1,
              "2025-12-15": 2,
              "2025-12-18": 2,
              "2025-12-19": 1,
              "2026-01-14": 1,
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 3,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-18": 2,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-25": 2,
              "2026-02-28": 5,
              "2026-03-02": 1,
              "2026-03-03": 3,
              "2026-03-06": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-13": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-27": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 3,
              "2026-04-13": 1,
              "2026-04-29": 2,
              "2026-05-04": 2,
              "2026-05-05": 5,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-14": 2,
              "2026-05-21": 1,
              "2026-05-22": 2,
              "2026-05-27": 2,
              "2026-06-01": 2
            },
            "time_per_day": {
              "2025-10-06": 232.56886055555555,
              "2025-10-22": 149.62582527777778,
              "2025-10-23": 50.676446388888884,
              "2025-10-27": 80.0469075,
              "2025-10-28": 186.64255444444444,
              "2025-10-30": 4.096041666666666,
              "2025-10-31": 43.601792222222215,
              "2025-11-04": 381.7255552777778,
              "2025-11-05": 10.38404861111111,
              "2025-11-06": 696.3419258333333,
              "2025-11-10": 7.421793611111111,
              "2025-11-11": 170.26513,
              "2025-11-14": 244.19154916666668,
              "2025-11-25": 2.860138611111111,
              "2025-12-02": 354.15654472222224,
              "2025-12-05": 69.73713305555556,
              "2025-12-10": 121.35672583333333,
              "2025-12-15": 720.6487691666666,
              "2025-12-18": 145.8158338888889,
              "2025-12-19": 197.97872083333334,
              "2026-01-14": 46.72071944444444,
              "2026-01-20": 2696.038973333333,
              "2026-01-22": 2.3157091666666667,
              "2026-01-23": 428.36573027777774,
              "2026-02-03": 1202.5575244444444,
              "2026-02-04": 523.6057530555555,
              "2026-02-05": 62.753282500000005,
              "2026-02-12": 873.1119813888889,
              "2026-02-13": 46.53264583333333,
              "2026-02-18": 4498.4488458333335,
              "2026-02-19": 209.4822411111111,
              "2026-02-21": 27.11656138888889,
              "2026-02-25": 52.028060833333335,
              "2026-02-28": 407.03668277777774,
              "2026-03-02": 0.0349975,
              "2026-03-03": 40.012008888888886,
              "2026-03-06": 576.3652575,
              "2026-03-10": 445.80834027777775,
              "2026-03-11": 1.022285,
              "2026-03-13": 94.09008444444444,
              "2026-03-17": 270.7717138888889,
              "2026-03-20": 409.4483941666667,
              "2026-03-24": 1028.2715316666668,
              "2026-03-25": 5.446444166666667,
              "2026-03-27": 3.659043611111111,
              "2026-04-08": 0.9989797222222223,
              "2026-04-09": 30.556513333333335,
              "2026-04-10": 353.0044502777778,
              "2026-04-13": 74.84164361111111,
              "2026-04-29": 3.1177519444444446,
              "2026-05-04": 1355.9531480555556,
              "2026-05-05": 755.992845,
              "2026-05-06": 2.3491122222222223,
              "2026-05-07": 6.409149722222222,
              "2026-05-08": 429.469635,
              "2026-05-14": 58.02885611111111,
              "2026-05-21": 316.23515083333336,
              "2026-05-22": 526.5147394444444,
              "2026-05-27": 1.5519577777777778,
              "2026-06-01": 151.22730666666666
            },
            "time_count_per_day": {
              "2025-10-06": 2,
              "2025-10-22": 2,
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-30": 1,
              "2025-10-31": 2,
              "2025-11-04": 4,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-11-25": 1,
              "2025-12-02": 1,
              "2025-12-05": 1,
              "2025-12-10": 1,
              "2025-12-15": 2,
              "2025-12-18": 2,
              "2025-12-19": 1,
              "2026-01-14": 1,
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 3,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-18": 2,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-25": 2,
              "2026-02-28": 5,
              "2026-03-02": 1,
              "2026-03-03": 3,
              "2026-03-06": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-13": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-27": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 3,
              "2026-04-13": 1,
              "2026-04-29": 2,
              "2026-05-04": 2,
              "2026-05-05": 5,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-14": 2,
              "2026-05-21": 1,
              "2026-05-22": 2,
              "2026-05-27": 2,
              "2026-06-01": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 112.18,
              "mode_time_hours": 113.0,
              "mode_frequency": 1,
              "time_distribution": {
                "112-114h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 112.17740722222223
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            },
            "P2": {
              "avg_time_hours": 133.17,
              "mode_time_hours": 1.0,
              "mode_frequency": 12,
              "time_distribution": {
                "0-2h": 12,
                "2-4h": 4,
                "4-6h": 5,
                "6-8h": 2,
                "8-10h": 2,
                "10-12h": 2,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "26-28h": 1,
                "30-32h": 2,
                "32-34h": 2,
                "44-46h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "72-74h": 2,
                "74-76h": 1,
                "80-82h": 1,
                "94-96h": 4,
                "130-132h": 1,
                "142-144h": 1,
                "146-148h": 1,
                "170-172h": 1,
                "186-188h": 1,
                "270-272h": 1,
                "294-296h": 1,
                "316-318h": 1,
                "334-336h": 1,
                "408-410h": 1,
                "428-430h": 2,
                "444-446h": 1,
                "596-598h": 1,
                "872-874h": 1,
                "1028-1030h": 1,
                "1242-1244h": 1
              },
              "tickets_count": 65,
              "tickets_per_day": {
                "2025-10-22": 2,
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-10-30": 1,
                "2025-10-31": 2,
                "2025-11-04": 4,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-12-18": 2,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-02-25": 2,
                "2026-03-02": 1,
                "2026-03-03": 3,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-13": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-27": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 3,
                "2026-04-13": 1,
                "2026-04-29": 2,
                "2026-05-04": 1,
                "2026-05-05": 5,
                "2026-05-06": 3,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-14": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-27": 2,
                "2026-06-01": 2
              },
              "time_per_day": {
                "2025-10-22": 149.62582527777778,
                "2025-10-23": 50.676446388888884,
                "2025-10-27": 80.0469075,
                "2025-10-28": 186.64255444444444,
                "2025-10-30": 4.096041666666666,
                "2025-10-31": 43.601792222222215,
                "2025-11-04": 381.7255552777778,
                "2025-11-05": 10.38404861111111,
                "2025-11-10": 7.421793611111111,
                "2025-11-11": 170.26513,
                "2025-12-18": 145.8158338888889,
                "2026-01-14": 46.72071944444444,
                "2026-01-22": 2.3157091666666667,
                "2026-01-23": 428.36573027777774,
                "2026-02-03": 294.1671288888889,
                "2026-02-12": 873.1119813888889,
                "2026-02-25": 52.028060833333335,
                "2026-03-02": 0.0349975,
                "2026-03-03": 40.012008888888886,
                "2026-03-06": 2.469580833333333,
                "2026-03-10": 445.80834027777775,
                "2026-03-11": 1.022285,
                "2026-03-13": 94.09008444444444,
                "2026-03-17": 270.7717138888889,
                "2026-03-20": 409.4483941666667,
                "2026-03-24": 1028.2715316666668,
                "2026-03-25": 5.446444166666667,
                "2026-03-27": 3.659043611111111,
                "2026-04-08": 0.9989797222222223,
                "2026-04-09": 30.556513333333335,
                "2026-04-10": 353.0044502777778,
                "2026-04-13": 74.84164361111111,
                "2026-04-29": 3.1177519444444446,
                "2026-05-04": 1243.7757408333334,
                "2026-05-05": 755.992845,
                "2026-05-06": 2.3491122222222223,
                "2026-05-07": 6.409149722222222,
                "2026-05-08": 429.469635,
                "2026-05-14": 58.02885611111111,
                "2026-05-21": 316.23515083333336,
                "2026-05-22": 0.1318997222222222,
                "2026-05-27": 1.5519577777777778,
                "2026-06-01": 151.22730666666666
              },
              "time_count_per_day": {
                "2025-10-22": 2,
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-10-30": 1,
                "2025-10-31": 2,
                "2025-11-04": 4,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-12-18": 2,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-02-25": 2,
                "2026-03-02": 1,
                "2026-03-03": 3,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-13": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-27": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 3,
                "2026-04-13": 1,
                "2026-04-29": 2,
                "2026-05-04": 1,
                "2026-05-05": 5,
                "2026-05-06": 3,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-14": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-27": 2,
                "2026-06-01": 2
              }
            },
            "P3": {
              "avg_time_hours": 621.47,
              "mode_time_hours": 115.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "8-10h": 1,
                "62-64h": 1,
                "68-70h": 1,
                "114-116h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "196-198h": 1,
                "244-246h": 1,
                "312-314h": 1,
                "354-356h": 1,
                "406-408h": 1,
                "522-524h": 1,
                "526-528h": 1,
                "572-574h": 1,
                "696-698h": 1,
                "898-900h": 1,
                "1962-1964h": 1,
                "2534-2536h": 1,
                "2696-2698h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-10-06": 2,
                "2025-11-06": 1,
                "2025-11-14": 1,
                "2025-11-25": 1,
                "2025-12-02": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2026-01-20": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-18": 2,
                "2026-03-06": 1,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2025-10-06": 232.56886055555555,
                "2025-11-06": 696.3419258333333,
                "2025-11-14": 244.19154916666668,
                "2025-11-25": 2.860138611111111,
                "2025-12-02": 354.15654472222224,
                "2025-12-05": 69.73713305555556,
                "2025-12-10": 121.35672583333333,
                "2025-12-15": 720.6487691666666,
                "2025-12-19": 197.97872083333334,
                "2026-01-20": 2696.038973333333,
                "2026-02-03": 908.3903955555555,
                "2026-02-04": 523.6057530555555,
                "2026-02-05": 62.753282500000005,
                "2026-02-18": 4498.4488458333335,
                "2026-03-06": 573.8956766666666,
                "2026-05-22": 526.3828397222222
              },
              "time_count_per_day": {
                "2025-10-06": 2,
                "2025-11-06": 1,
                "2025-11-14": 1,
                "2025-11-25": 1,
                "2025-12-02": 1,
                "2025-12-05": 1,
                "2025-12-10": 1,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2026-01-20": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-18": 2,
                "2026-03-06": 1,
                "2026-05-22": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 68.67,
              "mode_time_hours": 95.0,
              "mode_frequency": 4,
              "time_distribution": {
                "24-26h": 1,
                "26-28h": 1,
                "46-48h": 1,
                "94-96h": 4
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-02-13": 1,
                "2026-02-21": 1,
                "2026-02-28": 5
              },
              "time_per_day": {
                "2026-02-13": 46.53264583333333,
                "2026-02-21": 27.11656138888889,
                "2026-02-28": 407.03668277777774
              },
              "time_count_per_day": {
                "2026-02-13": 1,
                "2026-02-21": 1,
                "2026-02-28": 5
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 209.48,
              "mode_time_hours": 209.0,
              "mode_frequency": 1,
              "time_distribution": {
                "208-210h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 209.4822411111111
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-22": 1,
              "2026-05-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-22": 1,
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-28": 1,
              "2026-06-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-07": 1,
              "2026-05-12": 1,
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-07": 1,
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_99": {
      "overall": {
        "avg_time_hours": 183.85,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 3,
          "4-6h": 1,
          "14-16h": 1,
          "18-20h": 2,
          "22-24h": 1,
          "24-26h": 1,
          "28-30h": 1,
          "30-32h": 1,
          "36-38h": 1,
          "52-54h": 1,
          "68-70h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "108-110h": 1,
          "116-118h": 1,
          "120-122h": 1,
          "136-138h": 1,
          "142-144h": 1,
          "160-162h": 1,
          "190-192h": 1,
          "208-210h": 1,
          "218-220h": 1,
          "220-222h": 1,
          "272-274h": 1,
          "276-278h": 1,
          "282-284h": 1,
          "336-338h": 1,
          "404-406h": 1,
          "456-458h": 1,
          "548-550h": 1,
          "642-644h": 1,
          "758-760h": 1,
          "1218-1220h": 1
        },
        "tickets_count": 41,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-27": 1,
          "2025-11-04": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-23": 1,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2026-01-07": 1,
          "2026-01-13": 1,
          "2026-01-19": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-18": 2,
          "2026-02-20": 3,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-02": 3,
          "2026-04-15": 1,
          "2026-04-22": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-08": 1.6745555555555554,
          "2025-10-10": 221.9434838888889,
          "2025-10-27": 143.08204777777777,
          "2025-11-04": 643.0608380555556,
          "2025-11-13": 3.1570719444444446,
          "2025-11-17": 96.84702305555555,
          "2025-11-24": 273.15931861111113,
          "2025-11-27": 218.4858238888889,
          "2025-11-28": 28.527908888888888,
          "2025-12-04": 121.23233361111112,
          "2025-12-10": 405.5960097222222,
          "2025-12-23": 190.88749777777778,
          "2025-12-26": 2.2778241666666665,
          "2025-12-29": 161.50156416666667,
          "2026-01-07": 24.106773055555557,
          "2026-01-13": 1.5504302777777779,
          "2026-01-19": 36.06181,
          "2026-01-28": 5.890578611111111,
          "2026-02-03": 15.904156666666667,
          "2026-02-18": 575.0809313888889,
          "2026-02-20": 1516.1850488888888,
          "2026-03-02": 92.65176444444445,
          "2026-03-06": 276.39403111111113,
          "2026-03-09": 337.0846163888889,
          "2026-03-24": 22.543755833333332,
          "2026-03-25": 108.7269125,
          "2026-03-26": 53.03874583333333,
          "2026-04-02": 49.83889444444444,
          "2026-04-15": 18.802811666666667,
          "2026-05-04": 136.45327277777778,
          "2026-05-05": 282.12312833333334,
          "2026-05-26": 2.42098,
          "2026-05-27": 0.3647777777777778,
          "2026-05-30": 1218.6250669444446,
          "2026-06-05": 68.87973111111111
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-27": 1,
          "2025-11-04": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-23": 1,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2026-01-07": 1,
          "2026-01-13": 1,
          "2026-01-19": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-18": 2,
          "2026-02-20": 3,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-02": 3,
          "2026-04-15": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 180.95,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "4-6h": 1,
            "18-20h": 2,
            "22-24h": 1,
            "30-32h": 1,
            "36-38h": 1,
            "52-54h": 1,
            "68-70h": 1,
            "92-94h": 1,
            "108-110h": 1,
            "136-138h": 1,
            "142-144h": 1,
            "160-162h": 1,
            "208-210h": 1,
            "218-220h": 1,
            "220-222h": 1,
            "276-278h": 1,
            "282-284h": 1,
            "336-338h": 1,
            "456-458h": 1,
            "758-760h": 1,
            "1218-1220h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-10-27": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-12-26": 1,
            "2025-12-29": 1,
            "2026-01-19": 1,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-04-02": 3,
            "2026-04-15": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-30": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-10": 221.9434838888889,
            "2025-10-27": 143.08204777777777,
            "2025-11-13": 3.1570719444444446,
            "2025-11-27": 218.4858238888889,
            "2025-12-26": 2.2778241666666665,
            "2025-12-29": 161.50156416666667,
            "2026-01-19": 36.06181,
            "2026-01-28": 5.890578611111111,
            "2026-02-18": 457.9697802777778,
            "2026-02-20": 967.4329208333334,
            "2026-03-02": 92.65176444444445,
            "2026-03-06": 276.39403111111113,
            "2026-03-09": 337.0846163888889,
            "2026-03-24": 22.543755833333332,
            "2026-03-25": 108.7269125,
            "2026-03-26": 53.03874583333333,
            "2026-04-02": 49.83889444444444,
            "2026-04-15": 18.802811666666667,
            "2026-05-04": 136.45327277777778,
            "2026-05-05": 282.12312833333334,
            "2026-05-26": 2.42098,
            "2026-05-27": 0.3647777777777778,
            "2026-05-30": 1218.6250669444446,
            "2026-06-05": 68.87973111111111
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-10-27": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-12-26": 1,
            "2025-12-29": 1,
            "2026-01-19": 1,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-04-02": 3,
            "2026-04-15": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-30": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 182.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "14-16h": 1,
            "24-26h": 1,
            "28-30h": 1,
            "96-98h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "190-192h": 1,
            "404-406h": 1,
            "548-550h": 1,
            "642-644h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-11-04": 1,
            "2025-11-17": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-23": 1,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-18": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-10-08": 1.6745555555555554,
            "2025-11-04": 643.0608380555556,
            "2025-11-17": 96.84702305555555,
            "2025-11-28": 28.527908888888888,
            "2025-12-04": 121.23233361111112,
            "2025-12-10": 405.5960097222222,
            "2025-12-23": 190.88749777777778,
            "2026-01-07": 24.106773055555557,
            "2026-01-13": 1.5504302777777779,
            "2026-02-03": 15.904156666666667,
            "2026-02-18": 117.1111511111111,
            "2026-02-20": 548.7521280555555
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-11-04": 1,
            "2025-11-17": 1,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-23": 1,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-18": 1,
            "2026-02-20": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 273.16,
          "mode_time_hours": 273.0,
          "mode_frequency": 1,
          "time_distribution": {
            "272-274h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-11-24": 273.15931861111113
          },
          "time_count_per_day": {
            "2025-11-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 183.85,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 3,
              "4-6h": 1,
              "14-16h": 1,
              "18-20h": 2,
              "22-24h": 1,
              "24-26h": 1,
              "28-30h": 1,
              "30-32h": 1,
              "36-38h": 1,
              "52-54h": 1,
              "68-70h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "108-110h": 1,
              "116-118h": 1,
              "120-122h": 1,
              "136-138h": 1,
              "142-144h": 1,
              "160-162h": 1,
              "190-192h": 1,
              "208-210h": 1,
              "218-220h": 1,
              "220-222h": 1,
              "272-274h": 1,
              "276-278h": 1,
              "282-284h": 1,
              "336-338h": 1,
              "404-406h": 1,
              "456-458h": 1,
              "548-550h": 1,
              "642-644h": 1,
              "758-760h": 1,
              "1218-1220h": 1
            },
            "tickets_count": 40,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-27": 1,
              "2025-11-04": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-23": 1,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2026-01-07": 1,
              "2026-01-13": 1,
              "2026-01-19": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-18": 2,
              "2026-02-20": 3,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-02": 3,
              "2026-04-15": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-08": 1.6745555555555554,
              "2025-10-10": 221.9434838888889,
              "2025-10-27": 143.08204777777777,
              "2025-11-04": 643.0608380555556,
              "2025-11-13": 3.1570719444444446,
              "2025-11-17": 96.84702305555555,
              "2025-11-24": 273.15931861111113,
              "2025-11-27": 218.4858238888889,
              "2025-11-28": 28.527908888888888,
              "2025-12-04": 121.23233361111112,
              "2025-12-10": 405.5960097222222,
              "2025-12-23": 190.88749777777778,
              "2025-12-26": 2.2778241666666665,
              "2025-12-29": 161.50156416666667,
              "2026-01-07": 24.106773055555557,
              "2026-01-13": 1.5504302777777779,
              "2026-01-19": 36.06181,
              "2026-01-28": 5.890578611111111,
              "2026-02-03": 15.904156666666667,
              "2026-02-18": 575.0809313888889,
              "2026-02-20": 1516.1850488888888,
              "2026-03-02": 92.65176444444445,
              "2026-03-06": 276.39403111111113,
              "2026-03-09": 337.0846163888889,
              "2026-03-24": 22.543755833333332,
              "2026-03-25": 108.7269125,
              "2026-03-26": 53.03874583333333,
              "2026-04-02": 49.83889444444444,
              "2026-04-15": 18.802811666666667,
              "2026-05-04": 136.45327277777778,
              "2026-05-05": 282.12312833333334,
              "2026-05-26": 2.42098,
              "2026-05-27": 0.3647777777777778,
              "2026-05-30": 1218.6250669444446,
              "2026-06-05": 68.87973111111111
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-27": 1,
              "2025-11-04": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-23": 1,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2026-01-07": 1,
              "2026-01-13": 1,
              "2026-01-19": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-18": 2,
              "2026-02-20": 3,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-02": 3,
              "2026-04-15": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 180.95,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "4-6h": 1,
                "18-20h": 2,
                "22-24h": 1,
                "30-32h": 1,
                "36-38h": 1,
                "52-54h": 1,
                "68-70h": 1,
                "92-94h": 1,
                "108-110h": 1,
                "136-138h": 1,
                "142-144h": 1,
                "160-162h": 1,
                "208-210h": 1,
                "218-220h": 1,
                "220-222h": 1,
                "276-278h": 1,
                "282-284h": 1,
                "336-338h": 1,
                "456-458h": 1,
                "758-760h": 1,
                "1218-1220h": 1
              },
              "tickets_count": 27,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-10-27": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-12-26": 1,
                "2025-12-29": 1,
                "2026-01-19": 1,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-04-02": 3,
                "2026-04-15": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-10": 221.9434838888889,
                "2025-10-27": 143.08204777777777,
                "2025-11-13": 3.1570719444444446,
                "2025-11-27": 218.4858238888889,
                "2025-12-26": 2.2778241666666665,
                "2025-12-29": 161.50156416666667,
                "2026-01-19": 36.06181,
                "2026-01-28": 5.890578611111111,
                "2026-02-18": 457.9697802777778,
                "2026-02-20": 967.4329208333334,
                "2026-03-02": 92.65176444444445,
                "2026-03-06": 276.39403111111113,
                "2026-03-09": 337.0846163888889,
                "2026-03-24": 22.543755833333332,
                "2026-03-25": 108.7269125,
                "2026-03-26": 53.03874583333333,
                "2026-04-02": 49.83889444444444,
                "2026-04-15": 18.802811666666667,
                "2026-05-04": 136.45327277777778,
                "2026-05-05": 282.12312833333334,
                "2026-05-26": 2.42098,
                "2026-05-27": 0.3647777777777778,
                "2026-05-30": 1218.6250669444446,
                "2026-06-05": 68.87973111111111
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-10-27": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-12-26": 1,
                "2025-12-29": 1,
                "2026-01-19": 1,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-04-02": 3,
                "2026-04-15": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 182.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "14-16h": 1,
                "24-26h": 1,
                "28-30h": 1,
                "96-98h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "190-192h": 1,
                "404-406h": 1,
                "548-550h": 1,
                "642-644h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-11-04": 1,
                "2025-11-17": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-23": 1,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-18": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2025-10-08": 1.6745555555555554,
                "2025-11-04": 643.0608380555556,
                "2025-11-17": 96.84702305555555,
                "2025-11-28": 28.527908888888888,
                "2025-12-04": 121.23233361111112,
                "2025-12-10": 405.5960097222222,
                "2025-12-23": 190.88749777777778,
                "2026-01-07": 24.106773055555557,
                "2026-01-13": 1.5504302777777779,
                "2026-02-03": 15.904156666666667,
                "2026-02-18": 117.1111511111111,
                "2026-02-20": 548.7521280555555
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-11-04": 1,
                "2025-11-17": 1,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-23": 1,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-18": 1,
                "2026-02-20": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 273.16,
              "mode_time_hours": 273.0,
              "mode_frequency": 1,
              "time_distribution": {
                "272-274h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-11-24": 273.15931861111113
              },
              "time_count_per_day": {
                "2025-11-24": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_100": {
      "overall": {
        "avg_time_hours": 298.74,
        "mode_time_hours": 283.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "8-10h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "18-20h": 1,
          "78-80h": 1,
          "86-88h": 1,
          "282-284h": 1,
          "1142-1144h": 1,
          "1622-1624h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-10-13": 1,
          "2026-03-06": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 2,
          "2026-04-04": 1,
          "2026-04-07": 1,
          "2026-04-14": 1,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-21": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-10-13": 282.9804447222222,
          "2026-03-06": 11.607413611111111,
          "2026-03-24": 79.21435027777778,
          "2026-03-26": 31.710029166666665,
          "2026-04-04": 14.220505555555555,
          "2026-04-07": 86.15805777777777,
          "2026-04-14": 9.373364166666667,
          "2026-05-04": 1143.0159777777778,
          "2026-05-14": 4.965616111111111,
          "2026-05-26": 1622.879303888889
        },
        "time_count_per_day": {
          "2025-10-13": 1,
          "2026-03-06": 1,
          "2026-03-24": 1,
          "2026-03-26": 2,
          "2026-04-04": 1,
          "2026-04-07": 1,
          "2026-04-14": 1,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 45.56,
          "mode_time_hours": 87.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "86-88h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-07": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-04-07": 86.15805777777777,
            "2026-05-14": 4.965616111111111
          },
          "time_count_per_day": {
            "2026-04-07": 1,
            "2026-05-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 355.0,
          "mode_time_hours": 283.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "14-16h": 1,
            "18-20h": 1,
            "78-80h": 1,
            "282-284h": 1,
            "1142-1144h": 1,
            "1622-1624h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2026-03-06": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 2,
            "2026-04-04": 1,
            "2026-04-14": 1,
            "2026-05-04": 1,
            "2026-05-21": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-10-13": 282.9804447222222,
            "2026-03-06": 11.607413611111111,
            "2026-03-24": 79.21435027777778,
            "2026-03-26": 31.710029166666665,
            "2026-04-04": 14.220505555555555,
            "2026-04-14": 9.373364166666667,
            "2026-05-04": 1143.0159777777778,
            "2026-05-26": 1622.879303888889
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2026-03-06": 1,
            "2026-03-24": 1,
            "2026-03-26": 2,
            "2026-04-04": 1,
            "2026-04-14": 1,
            "2026-05-04": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 298.74,
            "mode_time_hours": 283.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "8-10h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "18-20h": 1,
              "78-80h": 1,
              "86-88h": 1,
              "282-284h": 1,
              "1142-1144h": 1,
              "1622-1624h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2025-10-13": 1,
              "2026-03-06": 1,
              "2026-03-24": 1,
              "2026-03-26": 2,
              "2026-04-04": 1,
              "2026-04-07": 1,
              "2026-04-14": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-10-13": 282.9804447222222,
              "2026-03-06": 11.607413611111111,
              "2026-03-24": 79.21435027777778,
              "2026-03-26": 31.710029166666665,
              "2026-04-04": 14.220505555555555,
              "2026-04-07": 86.15805777777777,
              "2026-04-14": 9.373364166666667,
              "2026-05-04": 1143.0159777777778,
              "2026-05-14": 4.965616111111111,
              "2026-05-26": 1622.879303888889
            },
            "time_count_per_day": {
              "2025-10-13": 1,
              "2026-03-06": 1,
              "2026-03-24": 1,
              "2026-03-26": 2,
              "2026-04-04": 1,
              "2026-04-07": 1,
              "2026-04-14": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 45.56,
              "mode_time_hours": 87.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "86-88h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-04-07": 86.15805777777777,
                "2026-05-14": 4.965616111111111
              },
              "time_count_per_day": {
                "2026-04-07": 1,
                "2026-05-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 355.0,
              "mode_time_hours": 283.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "14-16h": 1,
                "18-20h": 1,
                "78-80h": 1,
                "282-284h": 1,
                "1142-1144h": 1,
                "1622-1624h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2026-03-06": 1,
                "2026-03-24": 1,
                "2026-03-26": 2,
                "2026-04-04": 1,
                "2026-04-14": 1,
                "2026-05-04": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-10-13": 282.9804447222222,
                "2026-03-06": 11.607413611111111,
                "2026-03-24": 79.21435027777778,
                "2026-03-26": 31.710029166666665,
                "2026-04-04": 14.220505555555555,
                "2026-04-14": 9.373364166666667,
                "2026-05-04": 1143.0159777777778,
                "2026-05-26": 1622.879303888889
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2026-03-06": 1,
                "2026-03-24": 1,
                "2026-03-26": 2,
                "2026-04-04": 1,
                "2026-04-14": 1,
                "2026-05-04": 1,
                "2026-05-26": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_102": {
      "overall": {
        "avg_time_hours": 133.96,
        "mode_time_hours": 1.0,
        "mode_frequency": 36,
        "time_distribution": {
          "0-2h": 36,
          "2-4h": 13,
          "4-6h": 6,
          "6-8h": 2,
          "8-10h": 1,
          "10-12h": 1,
          "14-16h": 1,
          "16-18h": 3,
          "20-22h": 2,
          "22-24h": 1,
          "24-26h": 2,
          "26-28h": 4,
          "28-30h": 2,
          "30-32h": 3,
          "32-34h": 1,
          "34-36h": 1,
          "38-40h": 1,
          "46-48h": 2,
          "48-50h": 2,
          "50-52h": 1,
          "58-60h": 1,
          "60-62h": 1,
          "70-72h": 1,
          "74-76h": 1,
          "76-78h": 1,
          "78-80h": 1,
          "80-82h": 1,
          "84-86h": 1,
          "94-96h": 1,
          "96-98h": 1,
          "114-116h": 2,
          "118-120h": 3,
          "122-124h": 1,
          "144-146h": 1,
          "148-150h": 1,
          "150-152h": 1,
          "152-154h": 1,
          "166-168h": 1,
          "178-180h": 1,
          "180-182h": 1,
          "186-188h": 1,
          "188-190h": 1,
          "190-192h": 1,
          "192-194h": 3,
          "200-202h": 1,
          "216-218h": 1,
          "246-248h": 1,
          "270-272h": 1,
          "310-312h": 1,
          "318-320h": 2,
          "324-326h": 1,
          "336-338h": 1,
          "352-354h": 1,
          "356-358h": 1,
          "370-372h": 1,
          "372-374h": 1,
          "384-386h": 2,
          "420-422h": 1,
          "424-426h": 1,
          "538-540h": 1,
          "718-720h": 1,
          "804-806h": 1,
          "850-852h": 1,
          "972-974h": 1,
          "982-984h": 1,
          "1170-1172h": 1,
          "1198-1200h": 1,
          "1228-1230h": 1
        },
        "tickets_count": 145,
        "tickets_per_day": {
          "2025-10-03": 1,
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-17": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-11-03": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-14": 2,
          "2025-11-19": 3,
          "2025-11-20": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-11-29": 1,
          "2025-12-02": 2,
          "2025-12-03": 2,
          "2025-12-04": 1,
          "2025-12-12": 2,
          "2025-12-13": 1,
          "2025-12-15": 4,
          "2025-12-22": 1,
          "2025-12-26": 5,
          "2026-01-08": 2,
          "2026-01-09": 5,
          "2026-01-12": 1,
          "2026-01-14": 2,
          "2026-01-15": 4,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-24": 1,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-12": 4,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-02-19": 8,
          "2026-03-02": 3,
          "2026-03-04": 1,
          "2026-03-16": 2,
          "2026-03-17": 4,
          "2026-03-18": 10,
          "2026-03-20": 2,
          "2026-03-23": 6,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-18": 1,
          "2026-04-20": 2,
          "2026-04-23": 1,
          "2026-04-24": 1,
          "2026-04-27": 1,
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-26": 5,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-10-03": 39.797713611111114,
          "2025-10-07": 96.30709833333333,
          "2025-10-09": 32.37637361111111,
          "2025-10-10": 167.3534363888889,
          "2025-10-13": 74.8253011111111,
          "2025-10-14": 153.50160194444445,
          "2025-10-15": 3.4134591666666667,
          "2025-10-17": 17.809995555555556,
          "2025-10-21": 2.8801444444444444,
          "2025-10-23": 30.04208277777778,
          "2025-11-03": 246.16039555555557,
          "2025-11-10": 0.3338525,
          "2025-11-11": 6.894833888888888,
          "2025-11-12": 3.6194266666666666,
          "2025-11-13": 192.48940694444445,
          "2025-11-14": 53.121335277777774,
          "2025-11-19": 415.5059219444445,
          "2025-11-20": 76.32900000000001,
          "2025-11-21": 4.326126111111111,
          "2025-11-24": 5.575109444444444,
          "2025-11-28": 0.2492036111111111,
          "2025-11-29": 385.4071108333333,
          "2025-12-02": 31.77342055555556,
          "2025-12-03": 322.93276944444443,
          "2025-12-04": 352.3138402777778,
          "2025-12-12": 7.096753611111112,
          "2025-12-13": 27.688504444444444,
          "2025-12-15": 562.8006899999999,
          "2025-12-22": 0.26151861111111113,
          "2025-12-26": 822.4323194444445,
          "2026-01-08": 61.56930166666666,
          "2026-01-09": 1279.8550230555556,
          "2026-01-12": 8.31147,
          "2026-01-14": 3.0136519444444443,
          "2026-01-15": 49.71531027777778,
          "2026-01-16": 16.82023166666667,
          "2026-01-17": 270.0243936111111,
          "2026-01-21": 78.20138361111113,
          "2026-01-23": 151.33085777777777,
          "2026-01-24": 71.84922444444445,
          "2026-02-03": 0.29258055555555557,
          "2026-02-09": 240.54062472222222,
          "2026-02-10": 388.5544083333333,
          "2026-02-12": 1686.70525,
          "2026-02-13": 26.54112138888889,
          "2026-02-19": 5071.141003333333,
          "2026-03-02": 23.579017222222223,
          "2026-03-04": 5.960014444444444,
          "2026-03-16": 0.1442122222222222,
          "2026-03-17": 191.62966611111108,
          "2026-03-18": 2895.6583975,
          "2026-03-20": 53.29559388888889,
          "2026-03-23": 11.107807222222222,
          "2026-03-24": 28.60913083333333,
          "2026-03-25": 1.7600761111111112,
          "2026-03-26": 118.4215825,
          "2026-03-27": 0.7299330555555555,
          "2026-03-30": 47.700833333333335,
          "2026-04-07": 16.980181666666667,
          "2026-04-08": 15.575396666666666,
          "2026-04-13": 2.9913569444444446,
          "2026-04-16": 850.4010958333333,
          "2026-04-18": 25.81769861111111,
          "2026-04-20": 0.3542655555555555,
          "2026-04-23": 0.2537622222222222,
          "2026-05-04": 1.192658888888889,
          "2026-05-06": 337.51714277777774,
          "2026-05-07": 0.2884419444444445,
          "2026-05-08": 2.7470422222222224,
          "2026-05-11": 0.3332938888888889,
          "2026-05-14": 538.4371297222222,
          "2026-05-18": 1.165581111111111,
          "2026-05-21": 0.07534944444444444,
          "2026-05-25": 4.779363333333333,
          "2026-05-26": 34.108138333333336,
          "2026-05-28": 1.1313452777777777,
          "2026-05-29": 1.9852202777777777,
          "2026-05-30": 0.2266488888888889
        },
        "time_count_per_day": {
          "2025-10-03": 1,
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-17": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-11-03": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-14": 2,
          "2025-11-19": 3,
          "2025-11-20": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-11-29": 1,
          "2025-12-02": 2,
          "2025-12-03": 2,
          "2025-12-04": 1,
          "2025-12-12": 2,
          "2025-12-13": 1,
          "2025-12-15": 4,
          "2025-12-22": 1,
          "2025-12-26": 5,
          "2026-01-08": 2,
          "2026-01-09": 5,
          "2026-01-12": 1,
          "2026-01-14": 2,
          "2026-01-15": 4,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-24": 1,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-12": 4,
          "2026-02-13": 1,
          "2026-02-19": 8,
          "2026-03-02": 2,
          "2026-03-04": 1,
          "2026-03-16": 2,
          "2026-03-17": 4,
          "2026-03-18": 10,
          "2026-03-20": 2,
          "2026-03-23": 6,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-18": 1,
          "2026-04-20": 2,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-26": 5,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 56.84,
          "mode_time_hours": 1.0,
          "mode_frequency": 32,
          "time_distribution": {
            "0-2h": 32,
            "2-4h": 8,
            "4-6h": 4,
            "6-8h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "20-22h": 1,
            "24-26h": 2,
            "26-28h": 1,
            "48-50h": 1,
            "118-120h": 1,
            "336-338h": 1,
            "538-540h": 1,
            "850-852h": 1,
            "1228-1230h": 1
          },
          "tickets_count": 59,
          "tickets_per_day": {
            "2025-10-15": 2,
            "2025-10-17": 1,
            "2025-10-21": 1,
            "2025-11-10": 1,
            "2025-11-28": 1,
            "2025-12-12": 2,
            "2025-12-13": 1,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-12": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-02-03": 1,
            "2026-02-12": 2,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-16": 2,
            "2026-03-20": 1,
            "2026-03-23": 6,
            "2026-03-27": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-18": 1,
            "2026-04-20": 2,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-26": 5,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-10-15": 3.4134591666666667,
            "2025-10-17": 17.809995555555556,
            "2025-10-21": 2.8801444444444444,
            "2025-11-10": 0.3338525,
            "2025-11-28": 0.2492036111111111,
            "2025-12-12": 7.096753611111112,
            "2025-12-13": 27.688504444444444,
            "2025-12-15": 119.25105333333333,
            "2025-12-22": 0.26151861111111113,
            "2026-01-08": 49.89738,
            "2026-01-09": 25.045609166666665,
            "2026-01-12": 8.31147,
            "2026-01-14": 3.0136519444444443,
            "2026-01-15": 1.8291111111111111,
            "2026-02-03": 0.29258055555555557,
            "2026-02-12": 1229.6549602777777,
            "2026-03-02": 0.6217555555555556,
            "2026-03-04": 5.960014444444444,
            "2026-03-16": 0.1442122222222222,
            "2026-03-20": 1.3464175,
            "2026-03-23": 11.107807222222222,
            "2026-03-27": 0.7299330555555555,
            "2026-04-07": 16.980181666666667,
            "2026-04-08": 15.575396666666666,
            "2026-04-13": 2.9913569444444446,
            "2026-04-16": 850.4010958333333,
            "2026-04-18": 25.81769861111111,
            "2026-04-20": 0.3542655555555555,
            "2026-04-23": 0.2537622222222222,
            "2026-05-04": 1.192658888888889,
            "2026-05-06": 337.51714277777774,
            "2026-05-07": 0.2884419444444445,
            "2026-05-08": 2.7470422222222224,
            "2026-05-11": 0.3332938888888889,
            "2026-05-14": 538.4371297222222,
            "2026-05-18": 1.165581111111111,
            "2026-05-21": 0.07534944444444444,
            "2026-05-25": 4.779363333333333,
            "2026-05-26": 34.108138333333336,
            "2026-05-28": 1.1313452777777777,
            "2026-05-29": 1.9852202777777777,
            "2026-05-30": 0.2266488888888889
          },
          "time_count_per_day": {
            "2025-10-15": 2,
            "2025-10-17": 1,
            "2025-10-21": 1,
            "2025-11-10": 1,
            "2025-11-28": 1,
            "2025-12-12": 2,
            "2025-12-13": 1,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-12": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-02-03": 1,
            "2026-02-12": 2,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-16": 2,
            "2026-03-20": 1,
            "2026-03-23": 6,
            "2026-03-27": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-04-16": 1,
            "2026-04-18": 1,
            "2026-04-20": 2,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-26": 5,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 80.94,
          "mode_time_hours": 3.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 4,
            "20-22h": 1,
            "26-28h": 1,
            "38-40h": 1,
            "118-120h": 1,
            "152-154h": 1,
            "188-190h": 1,
            "200-202h": 1,
            "372-374h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-10-03": 1,
            "2025-10-14": 1,
            "2025-11-12": 1,
            "2025-11-21": 2,
            "2025-12-02": 1,
            "2025-12-15": 1,
            "2026-01-15": 2,
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-10-03": 39.797713611111114,
            "2025-10-14": 153.50160194444445,
            "2025-11-12": 3.6194266666666666,
            "2025-11-21": 4.326126111111111,
            "2025-12-02": 3.569055555555556,
            "2025-12-15": 119.24264222222222,
            "2026-01-15": 1.0929966666666666,
            "2026-02-10": 388.5544083333333,
            "2026-02-12": 372.7022827777778,
            "2026-02-13": 26.54112138888889,
            "2026-02-19": 20.159840833333334
          },
          "time_count_per_day": {
            "2025-10-03": 1,
            "2025-10-14": 1,
            "2025-11-12": 1,
            "2025-11-21": 2,
            "2025-12-02": 1,
            "2025-12-15": 1,
            "2026-01-15": 2,
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 126.07,
          "mode_time_hours": 31.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 1,
            "10-12h": 1,
            "16-18h": 1,
            "22-24h": 1,
            "26-28h": 2,
            "28-30h": 2,
            "30-32h": 3,
            "32-34h": 1,
            "34-36h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "50-52h": 1,
            "58-60h": 1,
            "60-62h": 1,
            "70-72h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "78-80h": 1,
            "80-82h": 1,
            "84-86h": 1,
            "94-96h": 1,
            "96-98h": 1,
            "114-116h": 2,
            "118-120h": 1,
            "122-124h": 1,
            "144-146h": 1,
            "148-150h": 1,
            "150-152h": 1,
            "166-168h": 1,
            "178-180h": 1,
            "180-182h": 1,
            "186-188h": 1,
            "190-192h": 1,
            "192-194h": 3,
            "216-218h": 1,
            "246-248h": 1,
            "310-312h": 1,
            "352-354h": 1,
            "356-358h": 1,
            "370-372h": 1,
            "384-386h": 2,
            "420-422h": 1,
            "424-426h": 1
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-23": 1,
            "2025-11-03": 1,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-14": 2,
            "2025-11-19": 3,
            "2025-11-20": 1,
            "2025-11-24": 1,
            "2025-11-29": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-26": 5,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-24": 1,
            "2026-02-09": 2,
            "2026-02-12": 1,
            "2026-02-19": 1,
            "2026-03-02": 1,
            "2026-03-17": 4,
            "2026-03-18": 10,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-05-02": 1
          },
          "time_per_day": {
            "2025-10-07": 96.30709833333333,
            "2025-10-09": 32.37637361111111,
            "2025-10-10": 167.3534363888889,
            "2025-10-13": 74.8253011111111,
            "2025-10-23": 30.04208277777778,
            "2025-11-03": 246.16039555555557,
            "2025-11-11": 6.894833888888888,
            "2025-11-13": 192.48940694444445,
            "2025-11-14": 53.121335277777774,
            "2025-11-19": 415.5059219444445,
            "2025-11-20": 76.32900000000001,
            "2025-11-24": 5.575109444444444,
            "2025-11-29": 385.4071108333333,
            "2025-12-02": 28.204365000000003,
            "2025-12-03": 3.8099202777777776,
            "2025-12-04": 352.3138402777778,
            "2025-12-15": 5.4739144444444445,
            "2025-12-26": 822.4323194444445,
            "2026-01-08": 11.671921666666666,
            "2026-01-09": 82.90035444444446,
            "2026-01-15": 46.7932025,
            "2026-01-16": 16.82023166666667,
            "2026-01-21": 78.20138361111113,
            "2026-01-23": 151.33085777777777,
            "2026-01-24": 71.84922444444445,
            "2026-02-09": 240.54062472222222,
            "2026-02-12": 84.34800694444445,
            "2026-02-19": 48.12871638888888,
            "2026-03-02": 22.957261666666668,
            "2026-03-17": 191.62966611111108,
            "2026-03-18": 2895.6583975,
            "2026-03-20": 51.94917638888889,
            "2026-03-24": 28.60913083333333,
            "2026-03-25": 1.7600761111111112,
            "2026-03-26": 118.4215825,
            "2026-03-30": 47.700833333333335
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-23": 1,
            "2025-11-03": 1,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-14": 2,
            "2025-11-19": 3,
            "2025-11-20": 1,
            "2025-11-24": 1,
            "2025-11-29": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-26": 5,
            "2026-01-08": 1,
            "2026-01-09": 2,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-01-24": 1,
            "2026-02-09": 2,
            "2026-02-12": 1,
            "2026-02-19": 1,
            "2026-03-02": 1,
            "2026-03-17": 4,
            "2026-03-18": 10,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-30": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 708.27,
          "mode_time_hours": 319.0,
          "mode_frequency": 2,
          "time_distribution": {
            "270-272h": 1,
            "318-320h": 2,
            "324-326h": 1,
            "718-720h": 1,
            "804-806h": 1,
            "972-974h": 1,
            "982-984h": 1,
            "1170-1172h": 1,
            "1198-1200h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2026-01-09": 1,
            "2026-01-17": 1,
            "2026-02-17": 1,
            "2026-02-19": 6,
            "2026-03-02": 1
          },
          "time_per_day": {
            "2025-12-03": 319.12284916666664,
            "2025-12-15": 318.83308,
            "2026-01-09": 1171.9090594444444,
            "2026-01-17": 270.0243936111111,
            "2026-02-19": 5002.852446111111
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2026-01-09": 1,
            "2026-01-17": 1,
            "2026-02-19": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 133.96,
            "mode_time_hours": 1.0,
            "mode_frequency": 36,
            "time_distribution": {
              "0-2h": 36,
              "2-4h": 13,
              "4-6h": 6,
              "6-8h": 2,
              "8-10h": 1,
              "10-12h": 1,
              "14-16h": 1,
              "16-18h": 3,
              "20-22h": 2,
              "22-24h": 1,
              "24-26h": 2,
              "26-28h": 4,
              "28-30h": 2,
              "30-32h": 3,
              "32-34h": 1,
              "34-36h": 1,
              "38-40h": 1,
              "46-48h": 2,
              "48-50h": 2,
              "50-52h": 1,
              "58-60h": 1,
              "60-62h": 1,
              "70-72h": 1,
              "74-76h": 1,
              "76-78h": 1,
              "78-80h": 1,
              "80-82h": 1,
              "84-86h": 1,
              "94-96h": 1,
              "96-98h": 1,
              "114-116h": 2,
              "118-120h": 3,
              "122-124h": 1,
              "144-146h": 1,
              "148-150h": 1,
              "150-152h": 1,
              "152-154h": 1,
              "166-168h": 1,
              "178-180h": 1,
              "180-182h": 1,
              "186-188h": 1,
              "188-190h": 1,
              "190-192h": 1,
              "192-194h": 3,
              "200-202h": 1,
              "216-218h": 1,
              "246-248h": 1,
              "270-272h": 1,
              "310-312h": 1,
              "318-320h": 2,
              "324-326h": 1,
              "336-338h": 1,
              "352-354h": 1,
              "356-358h": 1,
              "370-372h": 1,
              "372-374h": 1,
              "384-386h": 2,
              "420-422h": 1,
              "424-426h": 1,
              "538-540h": 1,
              "718-720h": 1,
              "804-806h": 1,
              "850-852h": 1,
              "972-974h": 1,
              "982-984h": 1,
              "1170-1172h": 1,
              "1198-1200h": 1,
              "1228-1230h": 1
            },
            "tickets_count": 140,
            "tickets_per_day": {
              "2025-10-03": 1,
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-17": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-11-03": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-14": 2,
              "2025-11-19": 3,
              "2025-11-20": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-11-29": 1,
              "2025-12-02": 2,
              "2025-12-03": 2,
              "2025-12-04": 1,
              "2025-12-12": 2,
              "2025-12-13": 1,
              "2025-12-15": 4,
              "2025-12-22": 1,
              "2025-12-26": 5,
              "2026-01-08": 2,
              "2026-01-09": 5,
              "2026-01-12": 1,
              "2026-01-14": 2,
              "2026-01-15": 4,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-24": 1,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-12": 4,
              "2026-02-13": 1,
              "2026-02-19": 8,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-03-16": 2,
              "2026-03-17": 4,
              "2026-03-18": 10,
              "2026-03-20": 2,
              "2026-03-23": 6,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-18": 1,
              "2026-04-20": 2,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-26": 5,
              "2026-05-28": 1,
              "2026-05-29": 2,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-10-03": 39.797713611111114,
              "2025-10-07": 96.30709833333333,
              "2025-10-09": 32.37637361111111,
              "2025-10-10": 167.3534363888889,
              "2025-10-13": 74.8253011111111,
              "2025-10-14": 153.50160194444445,
              "2025-10-15": 3.4134591666666667,
              "2025-10-17": 17.809995555555556,
              "2025-10-21": 2.8801444444444444,
              "2025-10-23": 30.04208277777778,
              "2025-11-03": 246.16039555555557,
              "2025-11-10": 0.3338525,
              "2025-11-11": 6.894833888888888,
              "2025-11-12": 3.6194266666666666,
              "2025-11-13": 192.48940694444445,
              "2025-11-14": 53.121335277777774,
              "2025-11-19": 415.5059219444445,
              "2025-11-20": 76.32900000000001,
              "2025-11-21": 4.326126111111111,
              "2025-11-24": 5.575109444444444,
              "2025-11-28": 0.2492036111111111,
              "2025-11-29": 385.4071108333333,
              "2025-12-02": 31.77342055555556,
              "2025-12-03": 322.93276944444443,
              "2025-12-04": 352.3138402777778,
              "2025-12-12": 7.096753611111112,
              "2025-12-13": 27.688504444444444,
              "2025-12-15": 562.8006899999999,
              "2025-12-22": 0.26151861111111113,
              "2025-12-26": 822.4323194444445,
              "2026-01-08": 61.56930166666666,
              "2026-01-09": 1279.8550230555556,
              "2026-01-12": 8.31147,
              "2026-01-14": 3.0136519444444443,
              "2026-01-15": 49.71531027777778,
              "2026-01-16": 16.82023166666667,
              "2026-01-17": 270.0243936111111,
              "2026-01-21": 78.20138361111113,
              "2026-01-23": 151.33085777777777,
              "2026-01-24": 71.84922444444445,
              "2026-02-03": 0.29258055555555557,
              "2026-02-09": 240.54062472222222,
              "2026-02-10": 388.5544083333333,
              "2026-02-12": 1686.70525,
              "2026-02-13": 26.54112138888889,
              "2026-02-19": 5071.141003333333,
              "2026-03-02": 23.579017222222223,
              "2026-03-04": 5.960014444444444,
              "2026-03-16": 0.1442122222222222,
              "2026-03-17": 191.62966611111108,
              "2026-03-18": 2895.6583975,
              "2026-03-20": 53.29559388888889,
              "2026-03-23": 11.107807222222222,
              "2026-03-24": 28.60913083333333,
              "2026-03-25": 1.7600761111111112,
              "2026-03-26": 118.4215825,
              "2026-03-27": 0.7299330555555555,
              "2026-03-30": 47.700833333333335,
              "2026-04-07": 16.980181666666667,
              "2026-04-08": 15.575396666666666,
              "2026-04-13": 2.9913569444444446,
              "2026-04-16": 850.4010958333333,
              "2026-04-18": 25.81769861111111,
              "2026-04-20": 0.3542655555555555,
              "2026-04-23": 0.2537622222222222,
              "2026-05-04": 1.192658888888889,
              "2026-05-06": 337.51714277777774,
              "2026-05-07": 0.2884419444444445,
              "2026-05-08": 2.7470422222222224,
              "2026-05-11": 0.3332938888888889,
              "2026-05-14": 538.4371297222222,
              "2026-05-18": 1.165581111111111,
              "2026-05-21": 0.07534944444444444,
              "2026-05-25": 4.779363333333333,
              "2026-05-26": 34.108138333333336,
              "2026-05-28": 1.1313452777777777,
              "2026-05-29": 1.9852202777777777,
              "2026-05-30": 0.2266488888888889
            },
            "time_count_per_day": {
              "2025-10-03": 1,
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-17": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-11-03": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-14": 2,
              "2025-11-19": 3,
              "2025-11-20": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-11-29": 1,
              "2025-12-02": 2,
              "2025-12-03": 2,
              "2025-12-04": 1,
              "2025-12-12": 2,
              "2025-12-13": 1,
              "2025-12-15": 4,
              "2025-12-22": 1,
              "2025-12-26": 5,
              "2026-01-08": 2,
              "2026-01-09": 5,
              "2026-01-12": 1,
              "2026-01-14": 2,
              "2026-01-15": 4,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-24": 1,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-12": 4,
              "2026-02-13": 1,
              "2026-02-19": 8,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-03-16": 2,
              "2026-03-17": 4,
              "2026-03-18": 10,
              "2026-03-20": 2,
              "2026-03-23": 6,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-18": 1,
              "2026-04-20": 2,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-26": 5,
              "2026-05-28": 1,
              "2026-05-29": 2,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 56.84,
              "mode_time_hours": 1.0,
              "mode_frequency": 32,
              "time_distribution": {
                "0-2h": 32,
                "2-4h": 8,
                "4-6h": 4,
                "6-8h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "20-22h": 1,
                "24-26h": 2,
                "26-28h": 1,
                "48-50h": 1,
                "118-120h": 1,
                "336-338h": 1,
                "538-540h": 1,
                "850-852h": 1,
                "1228-1230h": 1
              },
              "tickets_count": 59,
              "tickets_per_day": {
                "2025-10-15": 2,
                "2025-10-17": 1,
                "2025-10-21": 1,
                "2025-11-10": 1,
                "2025-11-28": 1,
                "2025-12-12": 2,
                "2025-12-13": 1,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-12": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-02-03": 1,
                "2026-02-12": 2,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-16": 2,
                "2026-03-20": 1,
                "2026-03-23": 6,
                "2026-03-27": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-18": 1,
                "2026-04-20": 2,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-26": 5,
                "2026-05-28": 1,
                "2026-05-29": 2,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-10-15": 3.4134591666666667,
                "2025-10-17": 17.809995555555556,
                "2025-10-21": 2.8801444444444444,
                "2025-11-10": 0.3338525,
                "2025-11-28": 0.2492036111111111,
                "2025-12-12": 7.096753611111112,
                "2025-12-13": 27.688504444444444,
                "2025-12-15": 119.25105333333333,
                "2025-12-22": 0.26151861111111113,
                "2026-01-08": 49.89738,
                "2026-01-09": 25.045609166666665,
                "2026-01-12": 8.31147,
                "2026-01-14": 3.0136519444444443,
                "2026-01-15": 1.8291111111111111,
                "2026-02-03": 0.29258055555555557,
                "2026-02-12": 1229.6549602777777,
                "2026-03-02": 0.6217555555555556,
                "2026-03-04": 5.960014444444444,
                "2026-03-16": 0.1442122222222222,
                "2026-03-20": 1.3464175,
                "2026-03-23": 11.107807222222222,
                "2026-03-27": 0.7299330555555555,
                "2026-04-07": 16.980181666666667,
                "2026-04-08": 15.575396666666666,
                "2026-04-13": 2.9913569444444446,
                "2026-04-16": 850.4010958333333,
                "2026-04-18": 25.81769861111111,
                "2026-04-20": 0.3542655555555555,
                "2026-04-23": 0.2537622222222222,
                "2026-05-04": 1.192658888888889,
                "2026-05-06": 337.51714277777774,
                "2026-05-07": 0.2884419444444445,
                "2026-05-08": 2.7470422222222224,
                "2026-05-11": 0.3332938888888889,
                "2026-05-14": 538.4371297222222,
                "2026-05-18": 1.165581111111111,
                "2026-05-21": 0.07534944444444444,
                "2026-05-25": 4.779363333333333,
                "2026-05-26": 34.108138333333336,
                "2026-05-28": 1.1313452777777777,
                "2026-05-29": 1.9852202777777777,
                "2026-05-30": 0.2266488888888889
              },
              "time_count_per_day": {
                "2025-10-15": 2,
                "2025-10-17": 1,
                "2025-10-21": 1,
                "2025-11-10": 1,
                "2025-11-28": 1,
                "2025-12-12": 2,
                "2025-12-13": 1,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-12": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-02-03": 1,
                "2026-02-12": 2,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-16": 2,
                "2026-03-20": 1,
                "2026-03-23": 6,
                "2026-03-27": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-13": 1,
                "2026-04-16": 1,
                "2026-04-18": 1,
                "2026-04-20": 2,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-26": 5,
                "2026-05-28": 1,
                "2026-05-29": 2,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 80.94,
              "mode_time_hours": 3.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 4,
                "20-22h": 1,
                "26-28h": 1,
                "38-40h": 1,
                "118-120h": 1,
                "152-154h": 1,
                "188-190h": 1,
                "200-202h": 1,
                "372-374h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-10-03": 1,
                "2025-10-14": 1,
                "2025-11-12": 1,
                "2025-11-21": 2,
                "2025-12-02": 1,
                "2025-12-15": 1,
                "2026-01-15": 2,
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-10-03": 39.797713611111114,
                "2025-10-14": 153.50160194444445,
                "2025-11-12": 3.6194266666666666,
                "2025-11-21": 4.326126111111111,
                "2025-12-02": 3.569055555555556,
                "2025-12-15": 119.24264222222222,
                "2026-01-15": 1.0929966666666666,
                "2026-02-10": 388.5544083333333,
                "2026-02-12": 372.7022827777778,
                "2026-02-13": 26.54112138888889,
                "2026-02-19": 20.159840833333334
              },
              "time_count_per_day": {
                "2025-10-03": 1,
                "2025-10-14": 1,
                "2025-11-12": 1,
                "2025-11-21": 2,
                "2025-12-02": 1,
                "2025-12-15": 1,
                "2026-01-15": 2,
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 126.07,
              "mode_time_hours": 31.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 1,
                "10-12h": 1,
                "16-18h": 1,
                "22-24h": 1,
                "26-28h": 2,
                "28-30h": 2,
                "30-32h": 3,
                "32-34h": 1,
                "34-36h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "50-52h": 1,
                "58-60h": 1,
                "60-62h": 1,
                "70-72h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "78-80h": 1,
                "80-82h": 1,
                "84-86h": 1,
                "94-96h": 1,
                "96-98h": 1,
                "114-116h": 2,
                "118-120h": 1,
                "122-124h": 1,
                "144-146h": 1,
                "148-150h": 1,
                "150-152h": 1,
                "166-168h": 1,
                "178-180h": 1,
                "180-182h": 1,
                "186-188h": 1,
                "190-192h": 1,
                "192-194h": 3,
                "216-218h": 1,
                "246-248h": 1,
                "310-312h": 1,
                "352-354h": 1,
                "356-358h": 1,
                "370-372h": 1,
                "384-386h": 2,
                "420-422h": 1,
                "424-426h": 1
              },
              "tickets_count": 57,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-23": 1,
                "2025-11-03": 1,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-14": 2,
                "2025-11-19": 3,
                "2025-11-20": 1,
                "2025-11-24": 1,
                "2025-11-29": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-26": 5,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-24": 1,
                "2026-02-09": 2,
                "2026-02-12": 1,
                "2026-02-19": 1,
                "2026-03-02": 1,
                "2026-03-17": 4,
                "2026-03-18": 10,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2025-10-07": 96.30709833333333,
                "2025-10-09": 32.37637361111111,
                "2025-10-10": 167.3534363888889,
                "2025-10-13": 74.8253011111111,
                "2025-10-23": 30.04208277777778,
                "2025-11-03": 246.16039555555557,
                "2025-11-11": 6.894833888888888,
                "2025-11-13": 192.48940694444445,
                "2025-11-14": 53.121335277777774,
                "2025-11-19": 415.5059219444445,
                "2025-11-20": 76.32900000000001,
                "2025-11-24": 5.575109444444444,
                "2025-11-29": 385.4071108333333,
                "2025-12-02": 28.204365000000003,
                "2025-12-03": 3.8099202777777776,
                "2025-12-04": 352.3138402777778,
                "2025-12-15": 5.4739144444444445,
                "2025-12-26": 822.4323194444445,
                "2026-01-08": 11.671921666666666,
                "2026-01-09": 82.90035444444446,
                "2026-01-15": 46.7932025,
                "2026-01-16": 16.82023166666667,
                "2026-01-21": 78.20138361111113,
                "2026-01-23": 151.33085777777777,
                "2026-01-24": 71.84922444444445,
                "2026-02-09": 240.54062472222222,
                "2026-02-12": 84.34800694444445,
                "2026-02-19": 48.12871638888888,
                "2026-03-02": 22.957261666666668,
                "2026-03-17": 191.62966611111108,
                "2026-03-18": 2895.6583975,
                "2026-03-20": 51.94917638888889,
                "2026-03-24": 28.60913083333333,
                "2026-03-25": 1.7600761111111112,
                "2026-03-26": 118.4215825,
                "2026-03-30": 47.700833333333335
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-23": 1,
                "2025-11-03": 1,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-14": 2,
                "2025-11-19": 3,
                "2025-11-20": 1,
                "2025-11-24": 1,
                "2025-11-29": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-26": 5,
                "2026-01-08": 1,
                "2026-01-09": 2,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-01-24": 1,
                "2026-02-09": 2,
                "2026-02-12": 1,
                "2026-02-19": 1,
                "2026-03-02": 1,
                "2026-03-17": 4,
                "2026-03-18": 10,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-30": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 708.27,
              "mode_time_hours": 319.0,
              "mode_frequency": 2,
              "time_distribution": {
                "270-272h": 1,
                "318-320h": 2,
                "324-326h": 1,
                "718-720h": 1,
                "804-806h": 1,
                "972-974h": 1,
                "982-984h": 1,
                "1170-1172h": 1,
                "1198-1200h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2026-01-09": 1,
                "2026-01-17": 1,
                "2026-02-19": 6
              },
              "time_per_day": {
                "2025-12-03": 319.12284916666664,
                "2025-12-15": 318.83308,
                "2026-01-09": 1171.9090594444444,
                "2026-01-17": 270.0243936111111,
                "2026-02-19": 5002.852446111111
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2026-01-09": 1,
                "2026-01-17": 1,
                "2026-02-19": 6
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-03-02": 1,
              "2026-04-24": 1,
              "2026-04-27": 1,
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-03-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_105": {
      "overall": {
        "avg_time_hours": 179.2,
        "mode_time_hours": 31.0,
        "mode_frequency": 2,
        "time_distribution": {
          "10-12h": 1,
          "16-18h": 1,
          "24-26h": 1,
          "30-32h": 2,
          "62-64h": 1,
          "66-68h": 1,
          "68-70h": 1,
          "94-96h": 1,
          "100-102h": 1,
          "176-178h": 1,
          "526-528h": 1,
          "622-624h": 1,
          "672-674h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-24": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-16": 1,
          "2026-01-27": 1,
          "2026-02-09": 1,
          "2026-02-16": 2,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-04-10": 1,
          "2026-05-06": 1,
          "2026-05-07": 1
        },
        "time_per_day": {
          "2025-10-23": 526.544955,
          "2025-11-24": 16.751143333333335,
          "2025-12-15": 67.78416944444444,
          "2025-12-19": 94.55984972222221,
          "2026-01-16": 30.518178055555556,
          "2026-01-27": 31.208723055555556,
          "2026-02-09": 62.77974777777778,
          "2026-02-16": 170.2526697222222,
          "2026-02-20": 176.30508777777777,
          "2026-02-21": 24.686686666666667,
          "2026-04-10": 11.846008888888889,
          "2026-05-06": 622.3098830555555,
          "2026-05-07": 673.1920475
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-24": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-16": 1,
          "2026-01-27": 1,
          "2026-02-09": 1,
          "2026-02-16": 2,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-04-10": 1,
          "2026-05-06": 1,
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 371.72,
          "mode_time_hours": 527.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1,
            "24-26h": 1,
            "526-528h": 1,
            "622-624h": 1,
            "672-674h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2026-02-21": 1,
            "2026-04-10": 1,
            "2026-05-06": 1,
            "2026-05-07": 1
          },
          "time_per_day": {
            "2025-10-23": 526.544955,
            "2026-02-21": 24.686686666666667,
            "2026-04-10": 11.846008888888889,
            "2026-05-06": 622.3098830555555,
            "2026-05-07": 673.1920475
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2026-02-21": 1,
            "2026-04-10": 1,
            "2026-05-06": 1,
            "2026-05-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 72.24,
          "mode_time_hours": 31.0,
          "mode_frequency": 2,
          "time_distribution": {
            "16-18h": 1,
            "30-32h": 2,
            "62-64h": 1,
            "66-68h": 1,
            "68-70h": 1,
            "94-96h": 1,
            "100-102h": 1,
            "176-178h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-16": 1,
            "2026-01-27": 1,
            "2026-02-09": 1,
            "2026-02-16": 2,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-11-24": 16.751143333333335,
            "2025-12-15": 67.78416944444444,
            "2025-12-19": 94.55984972222221,
            "2026-01-16": 30.518178055555556,
            "2026-01-27": 31.208723055555556,
            "2026-02-09": 62.77974777777778,
            "2026-02-16": 170.2526697222222,
            "2026-02-20": 176.30508777777777
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-16": 1,
            "2026-01-27": 1,
            "2026-02-09": 1,
            "2026-02-16": 2,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 179.2,
            "mode_time_hours": 31.0,
            "mode_frequency": 2,
            "time_distribution": {
              "10-12h": 1,
              "16-18h": 1,
              "24-26h": 1,
              "30-32h": 2,
              "62-64h": 1,
              "66-68h": 1,
              "68-70h": 1,
              "94-96h": 1,
              "100-102h": 1,
              "176-178h": 1,
              "526-528h": 1,
              "622-624h": 1,
              "672-674h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-24": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-16": 1,
              "2026-01-27": 1,
              "2026-02-09": 1,
              "2026-02-16": 2,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-04-10": 1,
              "2026-05-06": 1,
              "2026-05-07": 1
            },
            "time_per_day": {
              "2025-10-23": 526.544955,
              "2025-11-24": 16.751143333333335,
              "2025-12-15": 67.78416944444444,
              "2025-12-19": 94.55984972222221,
              "2026-01-16": 30.518178055555556,
              "2026-01-27": 31.208723055555556,
              "2026-02-09": 62.77974777777778,
              "2026-02-16": 170.2526697222222,
              "2026-02-20": 176.30508777777777,
              "2026-02-21": 24.686686666666667,
              "2026-04-10": 11.846008888888889,
              "2026-05-06": 622.3098830555555,
              "2026-05-07": 673.1920475
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-24": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-16": 1,
              "2026-01-27": 1,
              "2026-02-09": 1,
              "2026-02-16": 2,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-04-10": 1,
              "2026-05-06": 1,
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 371.72,
              "mode_time_hours": 527.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1,
                "24-26h": 1,
                "526-528h": 1,
                "622-624h": 1,
                "672-674h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2026-02-21": 1,
                "2026-04-10": 1,
                "2026-05-06": 1,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2025-10-23": 526.544955,
                "2026-02-21": 24.686686666666667,
                "2026-04-10": 11.846008888888889,
                "2026-05-06": 622.3098830555555,
                "2026-05-07": 673.1920475
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2026-02-21": 1,
                "2026-04-10": 1,
                "2026-05-06": 1,
                "2026-05-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 72.24,
              "mode_time_hours": 31.0,
              "mode_frequency": 2,
              "time_distribution": {
                "16-18h": 1,
                "30-32h": 2,
                "62-64h": 1,
                "66-68h": 1,
                "68-70h": 1,
                "94-96h": 1,
                "100-102h": 1,
                "176-178h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-16": 1,
                "2026-01-27": 1,
                "2026-02-09": 1,
                "2026-02-16": 2,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2025-11-24": 16.751143333333335,
                "2025-12-15": 67.78416944444444,
                "2025-12-19": 94.55984972222221,
                "2026-01-16": 30.518178055555556,
                "2026-01-27": 31.208723055555556,
                "2026-02-09": 62.77974777777778,
                "2026-02-16": 170.2526697222222,
                "2026-02-20": 176.30508777777777
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-16": 1,
                "2026-01-27": 1,
                "2026-02-09": 1,
                "2026-02-16": 2,
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_106": {
      "overall": {
        "avg_time_hours": 68.84,
        "mode_time_hours": 189.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "14-16h": 1,
          "188-190h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-09": 1,
          "2025-10-27": 1
        },
        "time_per_day": {
          "2025-10-08": 15.829409444444446,
          "2025-10-09": 188.02736027777777,
          "2025-10-27": 2.649462222222222
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-09": 1,
          "2025-10-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 68.84,
          "mode_time_hours": 189.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "14-16h": 1,
            "188-190h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-09": 1,
            "2025-10-27": 1
          },
          "time_per_day": {
            "2025-10-08": 15.829409444444446,
            "2025-10-09": 188.02736027777777,
            "2025-10-27": 2.649462222222222
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-09": 1,
            "2025-10-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 68.84,
            "mode_time_hours": 189.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "14-16h": 1,
              "188-190h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-09": 1,
              "2025-10-27": 1
            },
            "time_per_day": {
              "2025-10-08": 15.829409444444446,
              "2025-10-09": 188.02736027777777,
              "2025-10-27": 2.649462222222222
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-09": 1,
              "2025-10-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 68.84,
              "mode_time_hours": 189.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "14-16h": 1,
                "188-190h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-09": 1,
                "2025-10-27": 1
              },
              "time_per_day": {
                "2025-10-08": 15.829409444444446,
                "2025-10-09": 188.02736027777777,
                "2025-10-27": 2.649462222222222
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-09": 1,
                "2025-10-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_78": {
      "overall": {
        "avg_time_hours": 192.44,
        "mode_time_hours": 19.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 2,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 1,
          "16-18h": 2,
          "18-20h": 7,
          "20-22h": 3,
          "22-24h": 3,
          "24-26h": 2,
          "26-28h": 1,
          "38-40h": 1,
          "40-42h": 1,
          "72-74h": 1,
          "74-76h": 2,
          "76-78h": 1,
          "92-94h": 1,
          "98-100h": 1,
          "136-138h": 1,
          "144-146h": 1,
          "148-150h": 1,
          "158-160h": 1,
          "164-166h": 1,
          "190-192h": 1,
          "210-212h": 1,
          "360-362h": 1,
          "372-374h": 1,
          "378-380h": 1,
          "422-424h": 1,
          "500-502h": 1,
          "646-648h": 1,
          "820-822h": 1,
          "994-996h": 1,
          "1076-1078h": 1,
          "1198-1200h": 1,
          "1284-1286h": 1
        },
        "tickets_count": 54,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-13": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-24": 1,
          "2025-11-06": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-20": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-11": 1,
          "2025-12-18": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-23": 2,
          "2026-01-27": 2,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-20": 3,
          "2026-02-25": 3,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-10": 1,
          "2026-03-11": 2,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-19": 2,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-10": 2,
          "2026-04-23": 2,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-10-08": 20.345914722222222,
          "2025-10-13": 2.9830308333333333,
          "2025-10-22": 500.0452363888889,
          "2025-10-23": 136.84703916666666,
          "2025-10-24": 76.06710777777778,
          "2025-11-06": 18.746964722222224,
          "2025-11-07": 7.718718888888889,
          "2025-11-17": 99.7991611111111,
          "2025-11-20": 821.0604505555556,
          "2025-11-24": 25.417965833333334,
          "2025-11-27": 23.626026944444444,
          "2025-12-04": 149.28886722222222,
          "2025-12-11": 159.67451305555554,
          "2025-12-18": 190.60741416666667,
          "2026-01-14": 0.7997797222222222,
          "2026-01-15": 48.55766138888889,
          "2026-01-17": 423.3760758333333,
          "2026-01-19": 75.27453861111111,
          "2026-01-20": 2.811101388888889,
          "2026-01-23": 63.06516527777778,
          "2026-01-27": 238.75273305555555,
          "2026-02-07": 379.3488702777778,
          "2026-02-10": 1019.0767783333333,
          "2026-02-11": 8.16352111111111,
          "2026-02-12": 1284.9380608333333,
          "2026-02-13": 74.46310361111111,
          "2026-02-14": 17.35722722222222,
          "2026-02-19": 18.328780833333333,
          "2026-02-20": 93.1257063888889,
          "2026-02-25": 57.76767833333333,
          "2026-03-06": 18.712922222222222,
          "2026-03-07": 4.068217777777778,
          "2026-03-10": 145.040635,
          "2026-03-11": 20.117456666666666,
          "2026-03-13": 18.694550833333334,
          "2026-03-17": 360.3869022222222,
          "2026-03-19": 858.313106111111,
          "2026-03-24": 17.396209444444445,
          "2026-03-25": 39.91911888888889,
          "2026-04-10": 376.1687872222222,
          "2026-04-23": 2276.2343205555553,
          "2026-05-26": 26.673771666666664
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-13": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-24": 1,
          "2025-11-06": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-20": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-11": 1,
          "2025-12-18": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-23": 2,
          "2026-01-27": 2,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-20": 3,
          "2026-02-25": 3,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-19": 2,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-10": 2,
          "2026-04-23": 2,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 107.68,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "372-374h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-04-10": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-10": 23.79750027777778,
            "2026-02-11": 8.16352111111111,
            "2026-04-10": 372.0833383333333,
            "2026-05-26": 26.673771666666664
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-04-10": 1,
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 217.09,
          "mode_time_hours": 19.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "4-6h": 2,
            "6-8h": 1,
            "16-18h": 1,
            "18-20h": 3,
            "20-22h": 2,
            "22-24h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "136-138h": 1,
            "144-146h": 1,
            "164-166h": 1,
            "210-212h": 1,
            "360-362h": 1,
            "422-424h": 1,
            "500-502h": 1,
            "820-822h": 1,
            "994-996h": 1,
            "1076-1078h": 1,
            "1284-1286h": 1
          },
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-13": 1,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-20": 1,
            "2025-11-27": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-20": 2,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-13": 1,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-04-10": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-10-08": 20.345914722222222,
            "2025-10-13": 2.9830308333333333,
            "2025-10-22": 500.0452363888889,
            "2025-10-23": 136.84703916666666,
            "2025-10-24": 76.06710777777778,
            "2025-11-06": 18.746964722222224,
            "2025-11-07": 7.718718888888889,
            "2025-11-20": 821.0604505555556,
            "2025-11-27": 23.626026944444444,
            "2026-01-14": 0.7997797222222222,
            "2026-01-17": 423.3760758333333,
            "2026-01-20": 2.811101388888889,
            "2026-01-23": 41.52176027777778,
            "2026-01-27": 165.62362083333335,
            "2026-02-10": 995.2792780555556,
            "2026-02-12": 1284.9380608333333,
            "2026-02-13": 74.46310361111111,
            "2026-02-20": 0.9980302777777778,
            "2026-03-06": 18.712922222222222,
            "2026-03-07": 4.068217777777778,
            "2026-03-10": 145.040635,
            "2026-03-11": 20.117456666666666,
            "2026-03-13": 18.694550833333334,
            "2026-03-17": 360.3869022222222,
            "2026-03-19": 210.5616938888889,
            "2026-03-24": 17.396209444444445,
            "2026-03-25": 39.91911888888889,
            "2026-04-10": 4.085448888888889,
            "2026-04-23": 1076.34951
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-13": 1,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-20": 1,
            "2025-11-27": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-20": 2,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-04-10": 1,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 171.36,
          "mode_time_hours": 19.0,
          "mode_frequency": 4,
          "time_distribution": {
            "16-18h": 1,
            "18-20h": 4,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "72-74h": 1,
            "74-76h": 1,
            "92-94h": 1,
            "98-100h": 1,
            "148-150h": 1,
            "158-160h": 1,
            "190-192h": 1,
            "378-380h": 1,
            "646-648h": 1,
            "1198-1200h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-04": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2026-01-15": 2,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-07": 1,
            "2026-02-14": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-25": 3,
            "2026-03-19": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-11-17": 99.7991611111111,
            "2025-11-24": 25.417965833333334,
            "2025-12-04": 149.28886722222222,
            "2025-12-11": 159.67451305555554,
            "2025-12-18": 190.60741416666667,
            "2026-01-15": 48.55766138888889,
            "2026-01-19": 75.27453861111111,
            "2026-01-23": 21.543405,
            "2026-01-27": 73.12911222222222,
            "2026-02-07": 379.3488702777778,
            "2026-02-14": 17.35722722222222,
            "2026-02-19": 18.328780833333333,
            "2026-02-20": 92.12767611111111,
            "2026-02-25": 57.76767833333333,
            "2026-03-19": 647.7514122222221,
            "2026-04-23": 1199.8848105555555
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-04": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2026-01-15": 2,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-07": 1,
            "2026-02-14": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-25": 3,
            "2026-03-19": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 192.44,
            "mode_time_hours": 19.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 2,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 1,
              "16-18h": 2,
              "18-20h": 7,
              "20-22h": 3,
              "22-24h": 3,
              "24-26h": 2,
              "26-28h": 1,
              "38-40h": 1,
              "40-42h": 1,
              "72-74h": 1,
              "74-76h": 2,
              "76-78h": 1,
              "92-94h": 1,
              "98-100h": 1,
              "136-138h": 1,
              "144-146h": 1,
              "148-150h": 1,
              "158-160h": 1,
              "164-166h": 1,
              "190-192h": 1,
              "210-212h": 1,
              "360-362h": 1,
              "372-374h": 1,
              "378-380h": 1,
              "422-424h": 1,
              "500-502h": 1,
              "646-648h": 1,
              "820-822h": 1,
              "994-996h": 1,
              "1076-1078h": 1,
              "1198-1200h": 1,
              "1284-1286h": 1
            },
            "tickets_count": 53,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-13": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-24": 1,
              "2025-11-06": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-20": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-11": 1,
              "2025-12-18": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-23": 2,
              "2026-01-27": 2,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-20": 3,
              "2026-02-25": 3,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-19": 2,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-10": 2,
              "2026-04-23": 2,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-10-08": 20.345914722222222,
              "2025-10-13": 2.9830308333333333,
              "2025-10-22": 500.0452363888889,
              "2025-10-23": 136.84703916666666,
              "2025-10-24": 76.06710777777778,
              "2025-11-06": 18.746964722222224,
              "2025-11-07": 7.718718888888889,
              "2025-11-17": 99.7991611111111,
              "2025-11-20": 821.0604505555556,
              "2025-11-24": 25.417965833333334,
              "2025-11-27": 23.626026944444444,
              "2025-12-04": 149.28886722222222,
              "2025-12-11": 159.67451305555554,
              "2025-12-18": 190.60741416666667,
              "2026-01-14": 0.7997797222222222,
              "2026-01-15": 48.55766138888889,
              "2026-01-17": 423.3760758333333,
              "2026-01-19": 75.27453861111111,
              "2026-01-20": 2.811101388888889,
              "2026-01-23": 63.06516527777778,
              "2026-01-27": 238.75273305555555,
              "2026-02-07": 379.3488702777778,
              "2026-02-10": 1019.0767783333333,
              "2026-02-11": 8.16352111111111,
              "2026-02-12": 1284.9380608333333,
              "2026-02-13": 74.46310361111111,
              "2026-02-14": 17.35722722222222,
              "2026-02-19": 18.328780833333333,
              "2026-02-20": 93.1257063888889,
              "2026-02-25": 57.76767833333333,
              "2026-03-06": 18.712922222222222,
              "2026-03-07": 4.068217777777778,
              "2026-03-10": 145.040635,
              "2026-03-11": 20.117456666666666,
              "2026-03-13": 18.694550833333334,
              "2026-03-17": 360.3869022222222,
              "2026-03-19": 858.313106111111,
              "2026-03-24": 17.396209444444445,
              "2026-03-25": 39.91911888888889,
              "2026-04-10": 376.1687872222222,
              "2026-04-23": 2276.2343205555553,
              "2026-05-26": 26.673771666666664
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-13": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-24": 1,
              "2025-11-06": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-20": 1,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-11": 1,
              "2025-12-18": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-23": 2,
              "2026-01-27": 2,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-20": 3,
              "2026-02-25": 3,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-19": 2,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-10": 2,
              "2026-04-23": 2,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 107.68,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "372-374h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-04-10": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-02-10": 23.79750027777778,
                "2026-02-11": 8.16352111111111,
                "2026-04-10": 372.0833383333333,
                "2026-05-26": 26.673771666666664
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-04-10": 1,
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 217.09,
              "mode_time_hours": 19.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "4-6h": 2,
                "6-8h": 1,
                "16-18h": 1,
                "18-20h": 3,
                "20-22h": 2,
                "22-24h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "136-138h": 1,
                "144-146h": 1,
                "164-166h": 1,
                "210-212h": 1,
                "360-362h": 1,
                "422-424h": 1,
                "500-502h": 1,
                "820-822h": 1,
                "994-996h": 1,
                "1076-1078h": 1,
                "1284-1286h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-13": 1,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-20": 1,
                "2025-11-27": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-20": 2,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-04-10": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-10-08": 20.345914722222222,
                "2025-10-13": 2.9830308333333333,
                "2025-10-22": 500.0452363888889,
                "2025-10-23": 136.84703916666666,
                "2025-10-24": 76.06710777777778,
                "2025-11-06": 18.746964722222224,
                "2025-11-07": 7.718718888888889,
                "2025-11-20": 821.0604505555556,
                "2025-11-27": 23.626026944444444,
                "2026-01-14": 0.7997797222222222,
                "2026-01-17": 423.3760758333333,
                "2026-01-20": 2.811101388888889,
                "2026-01-23": 41.52176027777778,
                "2026-01-27": 165.62362083333335,
                "2026-02-10": 995.2792780555556,
                "2026-02-12": 1284.9380608333333,
                "2026-02-13": 74.46310361111111,
                "2026-02-20": 0.9980302777777778,
                "2026-03-06": 18.712922222222222,
                "2026-03-07": 4.068217777777778,
                "2026-03-10": 145.040635,
                "2026-03-11": 20.117456666666666,
                "2026-03-13": 18.694550833333334,
                "2026-03-17": 360.3869022222222,
                "2026-03-19": 210.5616938888889,
                "2026-03-24": 17.396209444444445,
                "2026-03-25": 39.91911888888889,
                "2026-04-10": 4.085448888888889,
                "2026-04-23": 1076.34951
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-13": 1,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-20": 1,
                "2025-11-27": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-20": 2,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-04-10": 1,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 171.36,
              "mode_time_hours": 19.0,
              "mode_frequency": 4,
              "time_distribution": {
                "16-18h": 1,
                "18-20h": 4,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "72-74h": 1,
                "74-76h": 1,
                "92-94h": 1,
                "98-100h": 1,
                "148-150h": 1,
                "158-160h": 1,
                "190-192h": 1,
                "378-380h": 1,
                "646-648h": 1,
                "1198-1200h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-04": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2026-01-15": 2,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-07": 1,
                "2026-02-14": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-25": 3,
                "2026-03-19": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-11-17": 99.7991611111111,
                "2025-11-24": 25.417965833333334,
                "2025-12-04": 149.28886722222222,
                "2025-12-11": 159.67451305555554,
                "2025-12-18": 190.60741416666667,
                "2026-01-15": 48.55766138888889,
                "2026-01-19": 75.27453861111111,
                "2026-01-23": 21.543405,
                "2026-01-27": 73.12911222222222,
                "2026-02-07": 379.3488702777778,
                "2026-02-14": 17.35722722222222,
                "2026-02-19": 18.328780833333333,
                "2026-02-20": 92.12767611111111,
                "2026-02-25": 57.76767833333333,
                "2026-03-19": 647.7514122222221,
                "2026-04-23": 1199.8848105555555
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-04": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2026-01-15": 2,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-07": 1,
                "2026-02-14": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-25": 3,
                "2026-03-19": 1,
                "2026-04-23": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_109": {
      "overall": {
        "avg_time_hours": 437.9,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "128-130h": 1,
          "338-340h": 1,
          "1188-1190h": 1,
          "1404-1406h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-02": 1,
          "2026-01-13": 1,
          "2026-02-03": 2,
          "2026-02-12": 1,
          "2026-02-25": 1,
          "2026-04-17": 1
        },
        "time_per_day": {
          "2025-10-02": 0.14305944444444443,
          "2026-01-13": 339.3446141666667,
          "2026-02-03": 1316.8989952777777,
          "2026-02-12": 1405.273635,
          "2026-02-25": 0.7311388888888889,
          "2026-04-17": 2.8774641666666665
        },
        "time_count_per_day": {
          "2025-10-02": 1,
          "2026-01-13": 1,
          "2026-02-03": 2,
          "2026-02-12": 1,
          "2026-02-25": 1,
          "2026-04-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 32.95,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "128-130h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2026-02-03": 1,
            "2026-02-25": 1,
            "2026-04-17": 1
          },
          "time_per_day": {
            "2025-10-02": 0.14305944444444443,
            "2026-02-03": 128.06136944444444,
            "2026-02-25": 0.7311388888888889,
            "2026-04-17": 2.8774641666666665
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2026-02-03": 1,
            "2026-02-25": 1,
            "2026-04-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 977.82,
          "mode_time_hours": 1189.0,
          "mode_frequency": 1,
          "time_distribution": {
            "338-340h": 1,
            "1188-1190h": 1,
            "1404-1406h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-01-13": 339.3446141666667,
            "2026-02-03": 1188.8376258333333,
            "2026-02-12": 1405.273635
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 437.9,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "128-130h": 1,
              "338-340h": 1,
              "1188-1190h": 1,
              "1404-1406h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-02": 1,
              "2026-01-13": 1,
              "2026-02-03": 2,
              "2026-02-12": 1,
              "2026-02-25": 1,
              "2026-04-17": 1
            },
            "time_per_day": {
              "2025-10-02": 0.14305944444444443,
              "2026-01-13": 339.3446141666667,
              "2026-02-03": 1316.8989952777777,
              "2026-02-12": 1405.273635,
              "2026-02-25": 0.7311388888888889,
              "2026-04-17": 2.8774641666666665
            },
            "time_count_per_day": {
              "2025-10-02": 1,
              "2026-01-13": 1,
              "2026-02-03": 2,
              "2026-02-12": 1,
              "2026-02-25": 1,
              "2026-04-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 32.95,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "128-130h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2026-02-03": 1,
                "2026-02-25": 1,
                "2026-04-17": 1
              },
              "time_per_day": {
                "2025-10-02": 0.14305944444444443,
                "2026-02-03": 128.06136944444444,
                "2026-02-25": 0.7311388888888889,
                "2026-04-17": 2.8774641666666665
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2026-02-03": 1,
                "2026-02-25": 1,
                "2026-04-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 977.82,
              "mode_time_hours": 1189.0,
              "mode_frequency": 1,
              "time_distribution": {
                "338-340h": 1,
                "1188-1190h": 1,
                "1404-1406h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-01-13": 339.3446141666667,
                "2026-02-03": 1188.8376258333333,
                "2026-02-12": 1405.273635
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_103": {
      "overall": {
        "avg_time_hours": 198.19,
        "mode_time_hours": 23.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "4-6h": 1,
          "6-8h": 3,
          "8-10h": 5,
          "10-12h": 2,
          "12-14h": 3,
          "14-16h": 3,
          "16-18h": 2,
          "18-20h": 4,
          "20-22h": 2,
          "22-24h": 7,
          "24-26h": 1,
          "28-30h": 2,
          "44-46h": 2,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "56-58h": 1,
          "70-72h": 1,
          "72-74h": 3,
          "80-82h": 1,
          "82-84h": 1,
          "84-86h": 3,
          "94-96h": 1,
          "96-98h": 2,
          "98-100h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "114-116h": 1,
          "176-178h": 1,
          "184-186h": 2,
          "194-196h": 1,
          "216-218h": 1,
          "264-266h": 1,
          "290-292h": 1,
          "370-372h": 1,
          "448-450h": 1,
          "532-534h": 1,
          "588-590h": 1,
          "662-664h": 1,
          "702-704h": 1,
          "730-732h": 1,
          "870-872h": 1,
          "960-962h": 1,
          "1032-1034h": 1,
          "1476-1478h": 2,
          "1732-1734h": 1,
          "1786-1788h": 1
        },
        "tickets_count": 88,
        "tickets_per_day": {
          "2025-10-02": 1,
          "2025-10-15": 1,
          "2025-10-29": 1,
          "2025-11-03": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-22": 2,
          "2025-12-04": 3,
          "2025-12-11": 1,
          "2025-12-13": 2,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2025-12-29": 1,
          "2026-01-06": 1,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-01-28": 4,
          "2026-02-03": 5,
          "2026-02-06": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-14": 17,
          "2026-02-16": 5,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-26": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-03-20": 1,
          "2026-03-31": 2,
          "2026-04-02": 1,
          "2026-04-07": 1,
          "2026-04-16": 1,
          "2026-04-17": 3,
          "2026-04-20": 3,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2025-10-02": 1.8476630555555558,
          "2025-10-15": 115.5420625,
          "2025-10-29": 29.04371138888889,
          "2025-11-03": 97.52906861111111,
          "2025-11-07": 3.560718611111111,
          "2025-11-17": 56.108891388888885,
          "2025-11-18": 103.13566972222223,
          "2025-11-19": 45.70034805555555,
          "2025-11-22": 199.8973827777778,
          "2025-12-04": 34.6643925,
          "2025-12-11": 216.94057944444444,
          "2025-12-13": 380.1316830555555,
          "2025-12-15": 448.53088083333336,
          "2025-12-19": 50.152631944444444,
          "2025-12-22": 8.563291666666666,
          "2025-12-29": 185.88526972222223,
          "2026-01-06": 9.386803888888888,
          "2026-01-09": 871.84771,
          "2026-01-14": 12.46186138888889,
          "2026-01-15": 71.89509194444445,
          "2026-01-19": 14.731364166666667,
          "2026-01-22": 10.96907,
          "2026-01-27": 73.15632694444444,
          "2026-01-28": 27.7024625,
          "2026-02-03": 3343.4761511111114,
          "2026-02-06": 2.4349208333333334,
          "2026-02-09": 95.79476944444444,
          "2026-02-10": 709.5586530555556,
          "2026-02-13": 589.9425161111112,
          "2026-02-14": 3156.143658888889,
          "2026-02-16": 2028.0290955555556,
          "2026-02-20": 80.45718944444444,
          "2026-02-24": 23.055354444444447,
          "2026-02-26": 6.5064166666666665,
          "2026-03-06": 22.172710277777778,
          "2026-03-11": 961.1505605555556,
          "2026-03-17": 96.02526638888888,
          "2026-03-18": 40.540793055555554,
          "2026-03-20": 264.1378286111111,
          "2026-03-31": 48.630340277777776,
          "2026-04-02": 2.323860555555555,
          "2026-04-07": 291.13869805555555,
          "2026-04-16": 703.2276822222223,
          "2026-04-17": 740.510991111111,
          "2026-04-20": 256.3425027777778,
          "2026-05-14": 662.2088486111111,
          "2026-05-15": 49.39096444444445
        },
        "time_count_per_day": {
          "2025-10-02": 1,
          "2025-10-15": 1,
          "2025-10-29": 1,
          "2025-11-03": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-22": 2,
          "2025-12-04": 3,
          "2025-12-11": 1,
          "2025-12-13": 2,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2025-12-29": 1,
          "2026-01-06": 1,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-01-28": 4,
          "2026-02-03": 5,
          "2026-02-06": 1,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-14": 17,
          "2026-02-16": 5,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-26": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-03-20": 1,
          "2026-03-31": 2,
          "2026-04-02": 1,
          "2026-04-07": 1,
          "2026-04-16": 1,
          "2026-04-17": 3,
          "2026-04-20": 3,
          "2026-05-14": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 379.12,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "96-98h": 1,
            "662-664h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-03-17": 96.02526638888888,
            "2026-05-14": 662.2088486111111
          },
          "time_count_per_day": {
            "2026-03-17": 1,
            "2026-05-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 119.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 2,
            "6-8h": 1,
            "8-10h": 3,
            "10-12h": 1,
            "12-14h": 2,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "28-30h": 2,
            "44-46h": 2,
            "48-50h": 2,
            "56-58h": 1,
            "72-74h": 2,
            "80-82h": 1,
            "84-86h": 3,
            "96-98h": 1,
            "176-178h": 1,
            "184-186h": 1,
            "216-218h": 1,
            "264-266h": 1,
            "290-292h": 1,
            "532-534h": 1,
            "702-704h": 1,
            "730-732h": 1,
            "1032-1034h": 1
          },
          "tickets_count": 45,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2025-10-29": 1,
            "2025-11-03": 1,
            "2025-11-07": 1,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-06": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-14": 2,
            "2026-02-16": 4,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-26": 1,
            "2026-03-06": 1,
            "2026-03-18": 2,
            "2026-03-20": 1,
            "2026-03-31": 2,
            "2026-04-02": 1,
            "2026-04-07": 1,
            "2026-04-16": 1,
            "2026-04-17": 3,
            "2026-04-20": 3,
            "2026-05-12": 1,
            "2026-05-15": 1
          },
          "time_per_day": {
            "2025-10-02": 1.8476630555555558,
            "2025-10-29": 29.04371138888889,
            "2025-11-03": 97.52906861111111,
            "2025-11-07": 3.560718611111111,
            "2025-11-17": 56.108891388888885,
            "2025-11-19": 45.70034805555555,
            "2025-12-04": 25.5904,
            "2025-12-11": 216.94057944444444,
            "2025-12-22": 8.563291666666666,
            "2025-12-29": 185.88526972222223,
            "2026-01-06": 9.386803888888888,
            "2026-01-14": 12.46186138888889,
            "2026-01-19": 14.731364166666667,
            "2026-02-03": 1.5804258333333334,
            "2026-02-09": 0.3334608333333334,
            "2026-02-10": 709.5586530555556,
            "2026-02-14": 1050.031646388889,
            "2026-02-16": 240.73155805555555,
            "2026-02-20": 80.45718944444444,
            "2026-02-24": 23.055354444444447,
            "2026-02-26": 6.5064166666666665,
            "2026-03-06": 22.172710277777778,
            "2026-03-18": 40.540793055555554,
            "2026-03-20": 264.1378286111111,
            "2026-03-31": 48.630340277777776,
            "2026-04-02": 2.323860555555555,
            "2026-04-07": 291.13869805555555,
            "2026-04-16": 703.2276822222223,
            "2026-04-17": 740.510991111111,
            "2026-04-20": 256.3425027777778,
            "2026-05-15": 49.39096444444445
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2025-10-29": 1,
            "2025-11-03": 1,
            "2025-11-07": 1,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-22": 1,
            "2025-12-29": 1,
            "2026-01-06": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-14": 2,
            "2026-02-16": 4,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-26": 1,
            "2026-03-06": 1,
            "2026-03-18": 2,
            "2026-03-20": 1,
            "2026-03-31": 2,
            "2026-04-02": 1,
            "2026-04-07": 1,
            "2026-04-16": 1,
            "2026-04-17": 3,
            "2026-04-20": 3,
            "2026-05-15": 1
          }
        },
        "P3": {
          "avg_time_hours": 274.3,
          "mode_time_hours": 23.0,
          "mode_frequency": 6,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 2,
            "8-10h": 2,
            "10-12h": 1,
            "12-14h": 1,
            "14-16h": 2,
            "16-18h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "22-24h": 6,
            "46-48h": 1,
            "50-52h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "82-84h": 1,
            "94-96h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "114-116h": 1,
            "184-186h": 1,
            "194-196h": 1,
            "370-372h": 1,
            "448-450h": 1,
            "588-590h": 1,
            "870-872h": 1,
            "960-962h": 1,
            "1476-1478h": 2,
            "1732-1734h": 1,
            "1786-1788h": 1
          },
          "tickets_count": 41,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-18": 1,
            "2025-11-22": 2,
            "2025-12-04": 1,
            "2025-12-13": 2,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-09": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-01-28": 4,
            "2026-02-03": 4,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-13": 1,
            "2026-02-14": 15,
            "2026-02-16": 1,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-10-15": 115.5420625,
            "2025-11-18": 103.13566972222223,
            "2025-11-22": 199.8973827777778,
            "2025-12-04": 9.0739925,
            "2025-12-13": 380.1316830555555,
            "2025-12-15": 448.53088083333336,
            "2025-12-19": 50.152631944444444,
            "2026-01-09": 871.84771,
            "2026-01-15": 71.89509194444445,
            "2026-01-22": 10.96907,
            "2026-01-27": 73.15632694444444,
            "2026-01-28": 27.7024625,
            "2026-02-03": 3341.895725277778,
            "2026-02-06": 2.4349208333333334,
            "2026-02-09": 95.46130861111111,
            "2026-02-13": 589.9425161111112,
            "2026-02-14": 2106.1120124999998,
            "2026-02-16": 1787.2975374999999,
            "2026-03-11": 961.1505605555556
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-18": 1,
            "2025-11-22": 2,
            "2025-12-04": 1,
            "2025-12-13": 2,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-09": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-01-28": 4,
            "2026-02-03": 4,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-13": 1,
            "2026-02-14": 15,
            "2026-02-16": 1,
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 198.19,
            "mode_time_hours": 23.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "4-6h": 1,
              "6-8h": 3,
              "8-10h": 5,
              "10-12h": 2,
              "12-14h": 3,
              "14-16h": 3,
              "16-18h": 2,
              "18-20h": 4,
              "20-22h": 2,
              "22-24h": 7,
              "24-26h": 1,
              "28-30h": 2,
              "44-46h": 2,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "56-58h": 1,
              "70-72h": 1,
              "72-74h": 3,
              "80-82h": 1,
              "82-84h": 1,
              "84-86h": 3,
              "94-96h": 1,
              "96-98h": 2,
              "98-100h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "114-116h": 1,
              "176-178h": 1,
              "184-186h": 2,
              "194-196h": 1,
              "216-218h": 1,
              "264-266h": 1,
              "290-292h": 1,
              "370-372h": 1,
              "448-450h": 1,
              "532-534h": 1,
              "588-590h": 1,
              "662-664h": 1,
              "702-704h": 1,
              "730-732h": 1,
              "870-872h": 1,
              "960-962h": 1,
              "1032-1034h": 1,
              "1476-1478h": 2,
              "1732-1734h": 1,
              "1786-1788h": 1
            },
            "tickets_count": 87,
            "tickets_per_day": {
              "2025-10-02": 1,
              "2025-10-15": 1,
              "2025-10-29": 1,
              "2025-11-03": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-22": 2,
              "2025-12-04": 3,
              "2025-12-11": 1,
              "2025-12-13": 2,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2025-12-29": 1,
              "2026-01-06": 1,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-01-28": 4,
              "2026-02-03": 5,
              "2026-02-06": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-14": 17,
              "2026-02-16": 5,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-26": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-03-20": 1,
              "2026-03-31": 2,
              "2026-04-02": 1,
              "2026-04-07": 1,
              "2026-04-16": 1,
              "2026-04-17": 3,
              "2026-04-20": 3,
              "2026-05-14": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2025-10-02": 1.8476630555555558,
              "2025-10-15": 115.5420625,
              "2025-10-29": 29.04371138888889,
              "2025-11-03": 97.52906861111111,
              "2025-11-07": 3.560718611111111,
              "2025-11-17": 56.108891388888885,
              "2025-11-18": 103.13566972222223,
              "2025-11-19": 45.70034805555555,
              "2025-11-22": 199.8973827777778,
              "2025-12-04": 34.6643925,
              "2025-12-11": 216.94057944444444,
              "2025-12-13": 380.1316830555555,
              "2025-12-15": 448.53088083333336,
              "2025-12-19": 50.152631944444444,
              "2025-12-22": 8.563291666666666,
              "2025-12-29": 185.88526972222223,
              "2026-01-06": 9.386803888888888,
              "2026-01-09": 871.84771,
              "2026-01-14": 12.46186138888889,
              "2026-01-15": 71.89509194444445,
              "2026-01-19": 14.731364166666667,
              "2026-01-22": 10.96907,
              "2026-01-27": 73.15632694444444,
              "2026-01-28": 27.7024625,
              "2026-02-03": 3343.4761511111114,
              "2026-02-06": 2.4349208333333334,
              "2026-02-09": 95.79476944444444,
              "2026-02-10": 709.5586530555556,
              "2026-02-13": 589.9425161111112,
              "2026-02-14": 3156.143658888889,
              "2026-02-16": 2028.0290955555556,
              "2026-02-20": 80.45718944444444,
              "2026-02-24": 23.055354444444447,
              "2026-02-26": 6.5064166666666665,
              "2026-03-06": 22.172710277777778,
              "2026-03-11": 961.1505605555556,
              "2026-03-17": 96.02526638888888,
              "2026-03-18": 40.540793055555554,
              "2026-03-20": 264.1378286111111,
              "2026-03-31": 48.630340277777776,
              "2026-04-02": 2.323860555555555,
              "2026-04-07": 291.13869805555555,
              "2026-04-16": 703.2276822222223,
              "2026-04-17": 740.510991111111,
              "2026-04-20": 256.3425027777778,
              "2026-05-14": 662.2088486111111,
              "2026-05-15": 49.39096444444445
            },
            "time_count_per_day": {
              "2025-10-02": 1,
              "2025-10-15": 1,
              "2025-10-29": 1,
              "2025-11-03": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-22": 2,
              "2025-12-04": 3,
              "2025-12-11": 1,
              "2025-12-13": 2,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2025-12-29": 1,
              "2026-01-06": 1,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-01-28": 4,
              "2026-02-03": 5,
              "2026-02-06": 1,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-14": 17,
              "2026-02-16": 5,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-26": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-03-20": 1,
              "2026-03-31": 2,
              "2026-04-02": 1,
              "2026-04-07": 1,
              "2026-04-16": 1,
              "2026-04-17": 3,
              "2026-04-20": 3,
              "2026-05-14": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 379.12,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "96-98h": 1,
                "662-664h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-17": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-03-17": 96.02526638888888,
                "2026-05-14": 662.2088486111111
              },
              "time_count_per_day": {
                "2026-03-17": 1,
                "2026-05-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 119.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 2,
                "6-8h": 1,
                "8-10h": 3,
                "10-12h": 1,
                "12-14h": 2,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "28-30h": 2,
                "44-46h": 2,
                "48-50h": 2,
                "56-58h": 1,
                "72-74h": 2,
                "80-82h": 1,
                "84-86h": 3,
                "96-98h": 1,
                "176-178h": 1,
                "184-186h": 1,
                "216-218h": 1,
                "264-266h": 1,
                "290-292h": 1,
                "532-534h": 1,
                "702-704h": 1,
                "730-732h": 1,
                "1032-1034h": 1
              },
              "tickets_count": 44,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2025-10-29": 1,
                "2025-11-03": 1,
                "2025-11-07": 1,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-06": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-14": 2,
                "2026-02-16": 4,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-26": 1,
                "2026-03-06": 1,
                "2026-03-18": 2,
                "2026-03-20": 1,
                "2026-03-31": 2,
                "2026-04-02": 1,
                "2026-04-07": 1,
                "2026-04-16": 1,
                "2026-04-17": 3,
                "2026-04-20": 3,
                "2026-05-15": 1
              },
              "time_per_day": {
                "2025-10-02": 1.8476630555555558,
                "2025-10-29": 29.04371138888889,
                "2025-11-03": 97.52906861111111,
                "2025-11-07": 3.560718611111111,
                "2025-11-17": 56.108891388888885,
                "2025-11-19": 45.70034805555555,
                "2025-12-04": 25.5904,
                "2025-12-11": 216.94057944444444,
                "2025-12-22": 8.563291666666666,
                "2025-12-29": 185.88526972222223,
                "2026-01-06": 9.386803888888888,
                "2026-01-14": 12.46186138888889,
                "2026-01-19": 14.731364166666667,
                "2026-02-03": 1.5804258333333334,
                "2026-02-09": 0.3334608333333334,
                "2026-02-10": 709.5586530555556,
                "2026-02-14": 1050.031646388889,
                "2026-02-16": 240.73155805555555,
                "2026-02-20": 80.45718944444444,
                "2026-02-24": 23.055354444444447,
                "2026-02-26": 6.5064166666666665,
                "2026-03-06": 22.172710277777778,
                "2026-03-18": 40.540793055555554,
                "2026-03-20": 264.1378286111111,
                "2026-03-31": 48.630340277777776,
                "2026-04-02": 2.323860555555555,
                "2026-04-07": 291.13869805555555,
                "2026-04-16": 703.2276822222223,
                "2026-04-17": 740.510991111111,
                "2026-04-20": 256.3425027777778,
                "2026-05-15": 49.39096444444445
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2025-10-29": 1,
                "2025-11-03": 1,
                "2025-11-07": 1,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-22": 1,
                "2025-12-29": 1,
                "2026-01-06": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-14": 2,
                "2026-02-16": 4,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-26": 1,
                "2026-03-06": 1,
                "2026-03-18": 2,
                "2026-03-20": 1,
                "2026-03-31": 2,
                "2026-04-02": 1,
                "2026-04-07": 1,
                "2026-04-16": 1,
                "2026-04-17": 3,
                "2026-04-20": 3,
                "2026-05-15": 1
              }
            },
            "P3": {
              "avg_time_hours": 274.3,
              "mode_time_hours": 23.0,
              "mode_frequency": 6,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 2,
                "8-10h": 2,
                "10-12h": 1,
                "12-14h": 1,
                "14-16h": 2,
                "16-18h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "22-24h": 6,
                "46-48h": 1,
                "50-52h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "82-84h": 1,
                "94-96h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "114-116h": 1,
                "184-186h": 1,
                "194-196h": 1,
                "370-372h": 1,
                "448-450h": 1,
                "588-590h": 1,
                "870-872h": 1,
                "960-962h": 1,
                "1476-1478h": 2,
                "1732-1734h": 1,
                "1786-1788h": 1
              },
              "tickets_count": 41,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-18": 1,
                "2025-11-22": 2,
                "2025-12-04": 1,
                "2025-12-13": 2,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-09": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-01-28": 4,
                "2026-02-03": 4,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-13": 1,
                "2026-02-14": 15,
                "2026-02-16": 1,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2025-10-15": 115.5420625,
                "2025-11-18": 103.13566972222223,
                "2025-11-22": 199.8973827777778,
                "2025-12-04": 9.0739925,
                "2025-12-13": 380.1316830555555,
                "2025-12-15": 448.53088083333336,
                "2025-12-19": 50.152631944444444,
                "2026-01-09": 871.84771,
                "2026-01-15": 71.89509194444445,
                "2026-01-22": 10.96907,
                "2026-01-27": 73.15632694444444,
                "2026-01-28": 27.7024625,
                "2026-02-03": 3341.895725277778,
                "2026-02-06": 2.4349208333333334,
                "2026-02-09": 95.46130861111111,
                "2026-02-13": 589.9425161111112,
                "2026-02-14": 2106.1120124999998,
                "2026-02-16": 1787.2975374999999,
                "2026-03-11": 961.1505605555556
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-18": 1,
                "2025-11-22": 2,
                "2025-12-04": 1,
                "2025-12-13": 2,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-09": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-01-28": 4,
                "2026-02-03": 4,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-13": 1,
                "2026-02-14": 15,
                "2026-02-16": 1,
                "2026-03-11": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_112": {
      "overall": {
        "avg_time_hours": 49.28,
        "mode_time_hours": 99.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "98-100h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-03": 1,
          "2025-10-06": 1
        },
        "time_per_day": {
          "2025-10-03": 0.2522908333333333,
          "2025-10-06": 98.30899638888889
        },
        "time_count_per_day": {
          "2025-10-03": 1,
          "2025-10-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-03": 1
          },
          "time_per_day": {
            "2025-10-03": 0.2522908333333333
          },
          "time_count_per_day": {
            "2025-10-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 98.31,
          "mode_time_hours": 99.0,
          "mode_frequency": 1,
          "time_distribution": {
            "98-100h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-06": 1
          },
          "time_per_day": {
            "2025-10-06": 98.30899638888889
          },
          "time_count_per_day": {
            "2025-10-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 49.28,
            "mode_time_hours": 99.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "98-100h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-03": 1,
              "2025-10-06": 1
            },
            "time_per_day": {
              "2025-10-03": 0.2522908333333333,
              "2025-10-06": 98.30899638888889
            },
            "time_count_per_day": {
              "2025-10-03": 1,
              "2025-10-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-03": 1
              },
              "time_per_day": {
                "2025-10-03": 0.2522908333333333
              },
              "time_count_per_day": {
                "2025-10-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 98.31,
              "mode_time_hours": 99.0,
              "mode_frequency": 1,
              "time_distribution": {
                "98-100h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-06": 1
              },
              "time_per_day": {
                "2025-10-06": 98.30899638888889
              },
              "time_count_per_day": {
                "2025-10-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_116": {
      "overall": {
        "avg_time_hours": 463.43,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "226-228h": 1,
          "1162-1164h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-10-02": 1,
          "2026-02-12": 1,
          "2026-02-13": 1
        },
        "time_per_day": {
          "2025-10-02": 0.5968094444444445,
          "2026-02-12": 1163.5494844444445,
          "2026-02-13": 226.1583038888889
        },
        "time_count_per_day": {
          "2025-10-02": 1,
          "2026-02-12": 1,
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 582.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "1162-1164h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-02": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-02": 0.5968094444444445,
            "2026-02-12": 1163.5494844444445
          },
          "time_count_per_day": {
            "2025-10-02": 1,
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 226.16,
          "mode_time_hours": 227.0,
          "mode_frequency": 1,
          "time_distribution": {
            "226-228h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 226.1583038888889
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 463.43,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "226-228h": 1,
              "1162-1164h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-02": 1,
              "2026-02-12": 1,
              "2026-02-13": 1
            },
            "time_per_day": {
              "2025-10-02": 0.5968094444444445,
              "2026-02-12": 1163.5494844444445,
              "2026-02-13": 226.1583038888889
            },
            "time_count_per_day": {
              "2025-10-02": 1,
              "2026-02-12": 1,
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 582.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "1162-1164h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-02": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-02": 0.5968094444444445,
                "2026-02-12": 1163.5494844444445
              },
              "time_count_per_day": {
                "2025-10-02": 1,
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 226.16,
              "mode_time_hours": 227.0,
              "mode_frequency": 1,
              "time_distribution": {
                "226-228h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 226.1583038888889
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_117": {
      "overall": {
        "avg_time_hours": 58.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 68,
        "time_distribution": {
          "0-2h": 68,
          "2-4h": 31,
          "4-6h": 15,
          "8-10h": 3,
          "10-12h": 1,
          "12-14h": 3,
          "24-26h": 8,
          "26-28h": 4,
          "28-30h": 5,
          "30-32h": 2,
          "36-38h": 2,
          "42-44h": 1,
          "44-46h": 2,
          "46-48h": 1,
          "48-50h": 3,
          "50-52h": 5,
          "56-58h": 1,
          "66-68h": 2,
          "72-74h": 1,
          "76-78h": 1,
          "92-94h": 2,
          "94-96h": 3,
          "116-118h": 1,
          "120-122h": 2,
          "128-130h": 1,
          "134-136h": 1,
          "136-138h": 1,
          "140-142h": 1,
          "142-144h": 1,
          "150-152h": 2,
          "158-160h": 1,
          "160-162h": 1,
          "164-166h": 1,
          "192-194h": 1,
          "200-202h": 1,
          "208-210h": 1,
          "220-222h": 1,
          "222-224h": 1,
          "260-262h": 1,
          "312-314h": 1,
          "336-338h": 1,
          "362-364h": 1,
          "368-370h": 1,
          "388-390h": 1,
          "444-446h": 1,
          "450-452h": 1,
          "496-498h": 1,
          "548-550h": 1,
          "652-654h": 1,
          "656-658h": 1,
          "912-914h": 1
        },
        "tickets_count": 224,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 3,
          "2025-11-13": 1,
          "2025-11-14": 1,
          "2025-11-17": 4,
          "2025-11-19": 2,
          "2025-11-20": 1,
          "2025-11-27": 1,
          "2025-12-02": 4,
          "2025-12-04": 1,
          "2025-12-09": 4,
          "2025-12-10": 2,
          "2025-12-11": 4,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-19": 1,
          "2025-12-22": 5,
          "2026-01-05": 1,
          "2026-01-12": 1,
          "2026-01-13": 7,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-01-30": 1,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-14": 2,
          "2026-02-18": 2,
          "2026-02-19": 4,
          "2026-02-28": 1,
          "2026-03-01": 1,
          "2026-03-05": 1,
          "2026-03-11": 2,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-14": 1,
          "2026-03-18": 9,
          "2026-03-23": 1,
          "2026-03-24": 3,
          "2026-03-25": 1,
          "2026-03-26": 2,
          "2026-03-28": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-01": 1,
          "2026-04-04": 1,
          "2026-04-07": 4,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 4,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-17": 4,
          "2026-04-20": 1,
          "2026-04-22": 2,
          "2026-04-23": 2,
          "2026-04-27": 4,
          "2026-04-29": 2,
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-06": 4,
          "2026-05-07": 2,
          "2026-05-08": 5,
          "2026-05-09": 6,
          "2026-05-11": 2,
          "2026-05-15": 2,
          "2026-05-16": 2,
          "2026-05-18": 3,
          "2026-05-19": 1,
          "2026-05-20": 2,
          "2026-05-21": 2,
          "2026-05-22": 1,
          "2026-05-25": 5,
          "2026-05-26": 7,
          "2026-05-27": 6,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-05-30": 2,
          "2026-06-01": 11,
          "2026-06-02": 9,
          "2026-06-03": 5,
          "2026-06-05": 3,
          "2026-06-06": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-07": 117.05434111111111,
          "2025-10-15": 29.090123333333334,
          "2025-10-17": 48.729235277777775,
          "2025-10-21": 368.5097222222222,
          "2025-10-23": 192.76719555555556,
          "2025-11-05": 30.382739444444443,
          "2025-11-06": 2.8625775,
          "2025-11-10": 49.97641,
          "2025-11-11": 127.65472166666667,
          "2025-11-13": 4.656809166666666,
          "2025-11-14": 1.841378888888889,
          "2025-11-17": 135.49174166666666,
          "2025-11-19": 250.2607991666667,
          "2025-11-20": 67.88950666666666,
          "2025-11-27": 3.2158075,
          "2025-12-02": 218.60733972222224,
          "2025-12-04": 25.054204444444444,
          "2025-12-09": 84.12895833333333,
          "2025-12-10": 227.63509138888887,
          "2025-12-11": 346.9055855555556,
          "2025-12-15": 66.55703555555556,
          "2025-12-17": 0.2468886111111111,
          "2025-12-19": 2.3543997222222224,
          "2025-12-22": 156.22476305555554,
          "2026-01-05": 44.82703305555555,
          "2026-01-12": 2.9141708333333334,
          "2026-01-13": 128.2257363888889,
          "2026-01-14": 3.1774002777777777,
          "2026-01-15": 45.9954925,
          "2026-01-16": 4.658713888888888,
          "2026-01-26": 3.8535291666666667,
          "2026-01-27": 8.074316388888889,
          "2026-01-28": 2.5420194444444446,
          "2026-01-30": 444.35754833333334,
          "2026-02-05": 140.8899522222222,
          "2026-02-06": 722.4018424999999,
          "2026-02-10": 201.5649575,
          "2026-02-11": 302.80676222222223,
          "2026-02-14": 0.803051111111111,
          "2026-02-18": 178.39356444444445,
          "2026-02-19": 2410.472746388889,
          "2026-02-28": 26.003776388888888,
          "2026-03-05": 3.4222375,
          "2026-03-11": 2.662255,
          "2026-03-12": 0.28140055555555554,
          "2026-03-13": 143.73321611111112,
          "2026-03-14": 26.133686666666666,
          "2026-03-18": 1633.5265036111111,
          "2026-03-23": 0.7809975,
          "2026-03-24": 58.570265,
          "2026-03-25": 2.6648644444444445,
          "2026-03-26": 1309.910195,
          "2026-03-28": 2.6290761111111114,
          "2026-03-30": 74.77018833333334,
          "2026-04-01": 3.5765391666666666,
          "2026-04-07": 0.803255,
          "2026-04-08": 0.1476522222222222,
          "2026-04-09": 1.828343611111111,
          "2026-04-10": 0.3663780555555556,
          "2026-04-11": 2.040625,
          "2026-04-13": 3.7196338888888887,
          "2026-04-14": 2.7830030555555556,
          "2026-04-15": 0.7089669444444444,
          "2026-04-16": 1.2112991666666666,
          "2026-04-17": 7.353265277777778,
          "2026-04-20": 2.452759166666667,
          "2026-04-22": 302.0548136111111,
          "2026-04-23": 0.17628916666666666,
          "2026-04-27": 0.3854263888888889,
          "2026-04-29": 0.050818055555555554,
          "2026-05-02": 0.4267402777777778,
          "2026-05-04": 94.6248511111111,
          "2026-05-06": 40.11575527777778,
          "2026-05-09": 1.6872075,
          "2026-05-11": 0.33871666666666667,
          "2026-05-15": 3.62213,
          "2026-05-16": 0.3269683333333333,
          "2026-05-18": 1.6194969444444443,
          "2026-05-20": 5.75847,
          "2026-05-21": 4.931001111111112,
          "2026-05-22": 1.0211622222222223,
          "2026-05-25": 48.69397777777778,
          "2026-05-26": 16.92021888888889,
          "2026-05-27": 2.9788480555555554,
          "2026-05-28": 0.16477472222222223,
          "2026-05-29": 4.311796944444445,
          "2026-05-30": 0.3416419444444444,
          "2026-06-01": 86.90312694444444,
          "2026-06-02": 117.39660083333334,
          "2026-06-03": 4.264551944444444,
          "2026-06-05": 2.655946111111111,
          "2026-06-06": 77.01747694444445,
          "2026-06-08": 0.44025861111111114
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 3,
          "2025-11-13": 1,
          "2025-11-14": 1,
          "2025-11-17": 4,
          "2025-11-19": 2,
          "2025-11-20": 1,
          "2025-11-27": 1,
          "2025-12-02": 4,
          "2025-12-04": 1,
          "2025-12-09": 4,
          "2025-12-10": 2,
          "2025-12-11": 4,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-19": 1,
          "2025-12-22": 5,
          "2026-01-05": 1,
          "2026-01-12": 1,
          "2026-01-13": 7,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-01-30": 1,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-14": 2,
          "2026-02-18": 2,
          "2026-02-19": 4,
          "2026-02-28": 1,
          "2026-03-05": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-14": 1,
          "2026-03-18": 9,
          "2026-03-23": 1,
          "2026-03-24": 3,
          "2026-03-25": 1,
          "2026-03-26": 2,
          "2026-03-28": 1,
          "2026-03-30": 2,
          "2026-04-01": 1,
          "2026-04-07": 3,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-13": 4,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-17": 4,
          "2026-04-20": 1,
          "2026-04-22": 2,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-06": 3,
          "2026-05-09": 3,
          "2026-05-11": 2,
          "2026-05-15": 2,
          "2026-05-16": 2,
          "2026-05-18": 2,
          "2026-05-20": 2,
          "2026-05-21": 2,
          "2026-05-22": 1,
          "2026-05-25": 4,
          "2026-05-26": 6,
          "2026-05-27": 2,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-05-30": 2,
          "2026-06-01": 11,
          "2026-06-02": 9,
          "2026-06-03": 5,
          "2026-06-05": 3,
          "2026-06-06": 2,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 15.99,
          "mode_time_hours": 5.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 5,
            "4-6h": 7,
            "8-10h": 2,
            "24-26h": 6,
            "42-44h": 1,
            "44-46h": 1,
            "48-50h": 1,
            "94-96h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-11-11": 1,
            "2025-12-04": 1,
            "2025-12-22": 2,
            "2026-01-05": 1,
            "2026-01-13": 1,
            "2026-01-28": 1,
            "2026-03-25": 1,
            "2026-05-21": 1,
            "2026-05-25": 3,
            "2026-06-01": 7,
            "2026-06-02": 8,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-11": 94.77474166666667,
            "2025-12-04": 25.054204444444444,
            "2025-12-22": 51.321886388888885,
            "2026-01-05": 44.82703305555555,
            "2026-01-13": 1.0077475,
            "2026-01-28": 2.5420194444444446,
            "2026-03-25": 2.6648644444444445,
            "2026-05-21": 1.3561422222222221,
            "2026-05-25": 46.49232888888889,
            "2026-06-01": 84.158315,
            "2026-06-02": 93.21623416666667,
            "2026-06-08": 0.44025861111111114
          },
          "time_count_per_day": {
            "2025-11-11": 1,
            "2025-12-04": 1,
            "2025-12-22": 2,
            "2026-01-05": 1,
            "2026-01-13": 1,
            "2026-01-28": 1,
            "2026-03-25": 1,
            "2026-05-21": 1,
            "2026-05-25": 3,
            "2026-06-01": 7,
            "2026-06-02": 8,
            "2026-06-08": 1
          }
        },
        "P2": {
          "avg_time_hours": 6.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 64,
          "time_distribution": {
            "0-2h": 64,
            "2-4h": 23,
            "4-6h": 6,
            "10-12h": 1,
            "12-14h": 3,
            "24-26h": 1,
            "26-28h": 2,
            "28-30h": 1,
            "50-52h": 3,
            "94-96h": 1,
            "142-144h": 1
          },
          "tickets_count": 108,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-17": 4,
            "2025-12-02": 2,
            "2025-12-09": 4,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-14": 2,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-18": 3,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-28": 1,
            "2026-03-30": 1,
            "2026-04-01": 1,
            "2026-04-07": 3,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 4,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-06": 3,
            "2026-05-09": 3,
            "2026-05-11": 2,
            "2026-05-15": 2,
            "2026-05-16": 2,
            "2026-05-18": 2,
            "2026-05-20": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-26": 6,
            "2026-05-27": 4,
            "2026-05-28": 1,
            "2026-05-29": 1,
            "2026-05-30": 2,
            "2026-06-01": 4,
            "2026-06-02": 1,
            "2026-06-03": 5,
            "2026-06-05": 3,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-11-06": 2.8625775,
            "2025-11-11": 2.5689819444444444,
            "2025-11-14": 1.841378888888889,
            "2025-11-17": 135.49174166666666,
            "2025-12-02": 30.472877500000003,
            "2025-12-09": 84.12895833333333,
            "2025-12-11": 1.5956888888888887,
            "2025-12-17": 0.2468886111111111,
            "2025-12-19": 2.3543997222222224,
            "2026-01-12": 2.9141708333333334,
            "2026-01-13": 0.5578188888888889,
            "2026-01-16": 4.658713888888888,
            "2026-01-26": 3.8535291666666667,
            "2026-02-14": 0.803051111111111,
            "2026-03-05": 3.4222375,
            "2026-03-11": 2.662255,
            "2026-03-12": 0.28140055555555554,
            "2026-03-13": 143.73321611111112,
            "2026-03-18": 11.209267222222223,
            "2026-03-23": 0.7809975,
            "2026-03-24": 1.3608066666666667,
            "2026-03-28": 2.6290761111111114,
            "2026-03-30": 1.1583447222222223,
            "2026-04-01": 3.5765391666666666,
            "2026-04-07": 0.803255,
            "2026-04-08": 0.1476522222222222,
            "2026-04-09": 1.828343611111111,
            "2026-04-10": 0.3663780555555556,
            "2026-04-11": 2.040625,
            "2026-04-13": 3.7196338888888887,
            "2026-04-14": 2.7830030555555556,
            "2026-04-15": 0.7089669444444444,
            "2026-04-16": 1.2112991666666666,
            "2026-04-17": 7.353265277777778,
            "2026-04-20": 2.452759166666667,
            "2026-04-23": 0.17628916666666666,
            "2026-04-27": 0.3854263888888889,
            "2026-04-29": 0.050818055555555554,
            "2026-05-02": 0.4267402777777778,
            "2026-05-04": 94.6248511111111,
            "2026-05-06": 40.11575527777778,
            "2026-05-09": 1.6872075,
            "2026-05-11": 0.33871666666666667,
            "2026-05-15": 3.62213,
            "2026-05-16": 0.3269683333333333,
            "2026-05-18": 1.6194969444444443,
            "2026-05-20": 5.75847,
            "2026-05-21": 3.574858888888889,
            "2026-05-22": 1.0211622222222223,
            "2026-05-25": 2.2016488888888888,
            "2026-05-26": 16.92021888888889,
            "2026-05-27": 2.9788480555555554,
            "2026-05-28": 0.16477472222222223,
            "2026-05-29": 4.311796944444445,
            "2026-05-30": 0.3416419444444444,
            "2026-06-01": 2.7448119444444448,
            "2026-06-02": 24.180366666666668,
            "2026-06-03": 4.264551944444444,
            "2026-06-05": 2.655946111111111,
            "2026-06-06": 0.04217611111111111
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2025-11-17": 4,
            "2025-12-02": 2,
            "2025-12-09": 4,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2026-01-12": 1,
            "2026-01-13": 2,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-14": 2,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-18": 3,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-28": 1,
            "2026-03-30": 1,
            "2026-04-01": 1,
            "2026-04-07": 3,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-11": 1,
            "2026-04-13": 4,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 4,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-06": 3,
            "2026-05-09": 3,
            "2026-05-11": 2,
            "2026-05-15": 2,
            "2026-05-16": 2,
            "2026-05-18": 2,
            "2026-05-20": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-26": 6,
            "2026-05-27": 2,
            "2026-05-28": 1,
            "2026-05-29": 1,
            "2026-05-30": 2,
            "2026-06-01": 4,
            "2026-06-02": 1,
            "2026-06-03": 5,
            "2026-06-05": 3,
            "2026-06-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 89.11,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 3,
            "4-6h": 2,
            "24-26h": 1,
            "66-68h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "136-138h": 1,
            "160-162h": 1,
            "192-194h": 1,
            "368-370h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-12-02": 2,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-13": 1,
            "2026-01-14": 1
          },
          "time_per_day": {
            "2025-10-21": 368.5097222222222,
            "2025-10-23": 192.76719555555556,
            "2025-11-13": 4.656809166666666,
            "2025-11-27": 3.2158075,
            "2025-12-02": 188.13446222222223,
            "2025-12-10": 3.791059166666667,
            "2025-12-11": 298.57208,
            "2025-12-15": 66.55703555555556,
            "2025-12-22": 4.181547777777777,
            "2026-01-13": 24.92988722222222,
            "2026-01-14": 3.1774002777777777
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-12-02": 2,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-13": 1,
            "2026-01-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 153.23,
          "mode_time_hours": 29.0,
          "mode_frequency": 4,
          "time_distribution": {
            "8-10h": 1,
            "26-28h": 2,
            "28-30h": 4,
            "30-32h": 2,
            "36-38h": 2,
            "44-46h": 1,
            "48-50h": 2,
            "50-52h": 2,
            "56-58h": 1,
            "66-68h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "92-94h": 1,
            "116-118h": 1,
            "120-122h": 2,
            "128-130h": 1,
            "134-136h": 1,
            "140-142h": 1,
            "150-152h": 2,
            "158-160h": 1,
            "164-166h": 1,
            "200-202h": 1,
            "208-210h": 1,
            "220-222h": 1,
            "222-224h": 1,
            "260-262h": 1,
            "312-314h": 1,
            "336-338h": 1,
            "362-364h": 1,
            "388-390h": 1,
            "444-446h": 1,
            "652-654h": 1,
            "656-658h": 1
          },
          "tickets_count": 70,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-19": 2,
            "2025-11-20": 1,
            "2025-12-10": 1,
            "2025-12-22": 2,
            "2026-01-13": 3,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-05": 1,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-11": 2,
            "2026-02-18": 2,
            "2026-02-28": 1,
            "2026-03-01": 1,
            "2026-03-11": 1,
            "2026-03-14": 1,
            "2026-03-18": 6,
            "2026-03-24": 2,
            "2026-03-26": 2,
            "2026-03-30": 1,
            "2026-03-31": 1,
            "2026-04-04": 1,
            "2026-04-07": 1,
            "2026-04-22": 2,
            "2026-04-23": 1,
            "2026-04-27": 3,
            "2026-04-29": 1,
            "2026-05-06": 1,
            "2026-05-07": 2,
            "2026-05-08": 5,
            "2026-05-09": 3,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-25": 1,
            "2026-05-26": 1,
            "2026-05-27": 2,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-07": 117.05434111111111,
            "2025-10-15": 29.090123333333334,
            "2025-10-17": 48.729235277777775,
            "2025-11-05": 30.382739444444443,
            "2025-11-10": 49.97641,
            "2025-11-11": 30.310998055555554,
            "2025-11-19": 250.2607991666667,
            "2025-11-20": 67.88950666666666,
            "2025-12-10": 223.8440322222222,
            "2025-12-22": 100.72132888888888,
            "2026-01-13": 101.73028277777779,
            "2026-01-15": 45.9954925,
            "2026-01-27": 8.074316388888889,
            "2026-01-30": 444.35754833333334,
            "2026-02-05": 140.8899522222222,
            "2026-02-06": 722.4018424999999,
            "2026-02-10": 201.5649575,
            "2026-02-11": 302.80676222222223,
            "2026-02-18": 178.39356444444445,
            "2026-02-28": 26.003776388888888,
            "2026-03-14": 26.133686666666666,
            "2026-03-18": 1622.317236388889,
            "2026-03-24": 57.20945833333333,
            "2026-03-26": 1309.910195,
            "2026-03-30": 73.61184361111111,
            "2026-04-22": 302.0548136111111,
            "2026-06-06": 76.97530083333334
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-19": 2,
            "2025-11-20": 1,
            "2025-12-10": 1,
            "2025-12-22": 2,
            "2026-01-13": 3,
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-05": 1,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-11": 2,
            "2026-02-18": 2,
            "2026-02-28": 1,
            "2026-03-14": 1,
            "2026-03-18": 6,
            "2026-03-24": 2,
            "2026-03-26": 2,
            "2026-03-30": 1,
            "2026-04-22": 2,
            "2026-06-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 491.44,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1,
            "450-452h": 1,
            "496-498h": 1,
            "548-550h": 1,
            "912-914h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2026-02-19": 4
          },
          "time_per_day": {
            "2025-12-11": 46.73781666666667,
            "2026-02-19": 2410.472746388889
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2026-02-19": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 58.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 68,
            "time_distribution": {
              "0-2h": 68,
              "2-4h": 31,
              "4-6h": 15,
              "8-10h": 3,
              "10-12h": 1,
              "12-14h": 3,
              "24-26h": 8,
              "26-28h": 4,
              "28-30h": 5,
              "30-32h": 2,
              "36-38h": 2,
              "42-44h": 1,
              "44-46h": 2,
              "46-48h": 1,
              "48-50h": 3,
              "50-52h": 5,
              "56-58h": 1,
              "66-68h": 2,
              "72-74h": 1,
              "76-78h": 1,
              "92-94h": 2,
              "94-96h": 3,
              "116-118h": 1,
              "120-122h": 2,
              "128-130h": 1,
              "134-136h": 1,
              "136-138h": 1,
              "140-142h": 1,
              "142-144h": 1,
              "150-152h": 2,
              "158-160h": 1,
              "160-162h": 1,
              "164-166h": 1,
              "192-194h": 1,
              "200-202h": 1,
              "208-210h": 1,
              "220-222h": 1,
              "222-224h": 1,
              "260-262h": 1,
              "312-314h": 1,
              "336-338h": 1,
              "362-364h": 1,
              "368-370h": 1,
              "388-390h": 1,
              "444-446h": 1,
              "450-452h": 1,
              "496-498h": 1,
              "548-550h": 1,
              "652-654h": 1,
              "656-658h": 1,
              "912-914h": 1
            },
            "tickets_count": 195,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 3,
              "2025-11-13": 1,
              "2025-11-14": 1,
              "2025-11-17": 4,
              "2025-11-19": 2,
              "2025-11-20": 1,
              "2025-11-27": 1,
              "2025-12-02": 4,
              "2025-12-04": 1,
              "2025-12-09": 4,
              "2025-12-10": 2,
              "2025-12-11": 4,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-19": 1,
              "2025-12-22": 5,
              "2026-01-05": 1,
              "2026-01-12": 1,
              "2026-01-13": 7,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-01-30": 1,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-02-14": 2,
              "2026-02-18": 2,
              "2026-02-19": 4,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-14": 1,
              "2026-03-18": 9,
              "2026-03-23": 1,
              "2026-03-24": 3,
              "2026-03-25": 1,
              "2026-03-26": 2,
              "2026-03-28": 1,
              "2026-03-30": 2,
              "2026-04-01": 1,
              "2026-04-07": 3,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-17": 4,
              "2026-04-20": 1,
              "2026-04-22": 2,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-06": 3,
              "2026-05-09": 3,
              "2026-05-11": 2,
              "2026-05-15": 2,
              "2026-05-16": 2,
              "2026-05-18": 2,
              "2026-05-20": 2,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-25": 4,
              "2026-05-26": 6,
              "2026-05-27": 2,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-05-30": 2,
              "2026-06-01": 11,
              "2026-06-02": 9,
              "2026-06-03": 5,
              "2026-06-05": 3,
              "2026-06-06": 2,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-07": 117.05434111111111,
              "2025-10-15": 29.090123333333334,
              "2025-10-17": 48.729235277777775,
              "2025-10-21": 368.5097222222222,
              "2025-10-23": 192.76719555555556,
              "2025-11-05": 30.382739444444443,
              "2025-11-06": 2.8625775,
              "2025-11-10": 49.97641,
              "2025-11-11": 127.65472166666667,
              "2025-11-13": 4.656809166666666,
              "2025-11-14": 1.841378888888889,
              "2025-11-17": 135.49174166666666,
              "2025-11-19": 250.2607991666667,
              "2025-11-20": 67.88950666666666,
              "2025-11-27": 3.2158075,
              "2025-12-02": 218.60733972222224,
              "2025-12-04": 25.054204444444444,
              "2025-12-09": 84.12895833333333,
              "2025-12-10": 227.63509138888887,
              "2025-12-11": 346.9055855555556,
              "2025-12-15": 66.55703555555556,
              "2025-12-17": 0.2468886111111111,
              "2025-12-19": 2.3543997222222224,
              "2025-12-22": 156.22476305555554,
              "2026-01-05": 44.82703305555555,
              "2026-01-12": 2.9141708333333334,
              "2026-01-13": 128.2257363888889,
              "2026-01-14": 3.1774002777777777,
              "2026-01-15": 45.9954925,
              "2026-01-16": 4.658713888888888,
              "2026-01-26": 3.8535291666666667,
              "2026-01-27": 8.074316388888889,
              "2026-01-28": 2.5420194444444446,
              "2026-01-30": 444.35754833333334,
              "2026-02-05": 140.8899522222222,
              "2026-02-06": 722.4018424999999,
              "2026-02-10": 201.5649575,
              "2026-02-11": 302.80676222222223,
              "2026-02-14": 0.803051111111111,
              "2026-02-18": 178.39356444444445,
              "2026-02-19": 2410.472746388889,
              "2026-02-28": 26.003776388888888,
              "2026-03-05": 3.4222375,
              "2026-03-11": 2.662255,
              "2026-03-12": 0.28140055555555554,
              "2026-03-13": 143.73321611111112,
              "2026-03-14": 26.133686666666666,
              "2026-03-18": 1633.5265036111111,
              "2026-03-23": 0.7809975,
              "2026-03-24": 58.570265,
              "2026-03-25": 2.6648644444444445,
              "2026-03-26": 1309.910195,
              "2026-03-28": 2.6290761111111114,
              "2026-03-30": 74.77018833333334,
              "2026-04-01": 3.5765391666666666,
              "2026-04-07": 0.803255,
              "2026-04-08": 0.1476522222222222,
              "2026-04-09": 1.828343611111111,
              "2026-04-10": 0.3663780555555556,
              "2026-04-11": 2.040625,
              "2026-04-13": 3.7196338888888887,
              "2026-04-14": 2.7830030555555556,
              "2026-04-15": 0.7089669444444444,
              "2026-04-16": 1.2112991666666666,
              "2026-04-17": 7.353265277777778,
              "2026-04-20": 2.452759166666667,
              "2026-04-22": 302.0548136111111,
              "2026-04-23": 0.17628916666666666,
              "2026-04-27": 0.3854263888888889,
              "2026-04-29": 0.050818055555555554,
              "2026-05-02": 0.4267402777777778,
              "2026-05-04": 94.6248511111111,
              "2026-05-06": 40.11575527777778,
              "2026-05-09": 1.6872075,
              "2026-05-11": 0.33871666666666667,
              "2026-05-15": 3.62213,
              "2026-05-16": 0.3269683333333333,
              "2026-05-18": 1.6194969444444443,
              "2026-05-20": 5.75847,
              "2026-05-21": 4.931001111111112,
              "2026-05-22": 1.0211622222222223,
              "2026-05-25": 48.69397777777778,
              "2026-05-26": 16.92021888888889,
              "2026-05-27": 2.9788480555555554,
              "2026-05-28": 0.16477472222222223,
              "2026-05-29": 4.311796944444445,
              "2026-05-30": 0.3416419444444444,
              "2026-06-01": 86.90312694444444,
              "2026-06-02": 117.39660083333334,
              "2026-06-03": 4.264551944444444,
              "2026-06-05": 2.655946111111111,
              "2026-06-06": 77.01747694444445,
              "2026-06-08": 0.44025861111111114
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 3,
              "2025-11-13": 1,
              "2025-11-14": 1,
              "2025-11-17": 4,
              "2025-11-19": 2,
              "2025-11-20": 1,
              "2025-11-27": 1,
              "2025-12-02": 4,
              "2025-12-04": 1,
              "2025-12-09": 4,
              "2025-12-10": 2,
              "2025-12-11": 4,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-19": 1,
              "2025-12-22": 5,
              "2026-01-05": 1,
              "2026-01-12": 1,
              "2026-01-13": 7,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-01-30": 1,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-02-14": 2,
              "2026-02-18": 2,
              "2026-02-19": 4,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-14": 1,
              "2026-03-18": 9,
              "2026-03-23": 1,
              "2026-03-24": 3,
              "2026-03-25": 1,
              "2026-03-26": 2,
              "2026-03-28": 1,
              "2026-03-30": 2,
              "2026-04-01": 1,
              "2026-04-07": 3,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-13": 4,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-17": 4,
              "2026-04-20": 1,
              "2026-04-22": 2,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-06": 3,
              "2026-05-09": 3,
              "2026-05-11": 2,
              "2026-05-15": 2,
              "2026-05-16": 2,
              "2026-05-18": 2,
              "2026-05-20": 2,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-25": 4,
              "2026-05-26": 6,
              "2026-05-27": 2,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-05-30": 2,
              "2026-06-01": 11,
              "2026-06-02": 9,
              "2026-06-03": 5,
              "2026-06-05": 3,
              "2026-06-06": 2,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 15.99,
              "mode_time_hours": 5.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 5,
                "4-6h": 7,
                "8-10h": 2,
                "24-26h": 6,
                "42-44h": 1,
                "44-46h": 1,
                "48-50h": 1,
                "94-96h": 1
              },
              "tickets_count": 28,
              "tickets_per_day": {
                "2025-11-11": 1,
                "2025-12-04": 1,
                "2025-12-22": 2,
                "2026-01-05": 1,
                "2026-01-13": 1,
                "2026-01-28": 1,
                "2026-03-25": 1,
                "2026-05-21": 1,
                "2026-05-25": 3,
                "2026-06-01": 7,
                "2026-06-02": 8,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-11-11": 94.77474166666667,
                "2025-12-04": 25.054204444444444,
                "2025-12-22": 51.321886388888885,
                "2026-01-05": 44.82703305555555,
                "2026-01-13": 1.0077475,
                "2026-01-28": 2.5420194444444446,
                "2026-03-25": 2.6648644444444445,
                "2026-05-21": 1.3561422222222221,
                "2026-05-25": 46.49232888888889,
                "2026-06-01": 84.158315,
                "2026-06-02": 93.21623416666667,
                "2026-06-08": 0.44025861111111114
              },
              "time_count_per_day": {
                "2025-11-11": 1,
                "2025-12-04": 1,
                "2025-12-22": 2,
                "2026-01-05": 1,
                "2026-01-13": 1,
                "2026-01-28": 1,
                "2026-03-25": 1,
                "2026-05-21": 1,
                "2026-05-25": 3,
                "2026-06-01": 7,
                "2026-06-02": 8,
                "2026-06-08": 1
              }
            },
            "P2": {
              "avg_time_hours": 6.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 64,
              "time_distribution": {
                "0-2h": 64,
                "2-4h": 23,
                "4-6h": 6,
                "10-12h": 1,
                "12-14h": 3,
                "24-26h": 1,
                "26-28h": 2,
                "28-30h": 1,
                "50-52h": 3,
                "94-96h": 1,
                "142-144h": 1
              },
              "tickets_count": 106,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-17": 4,
                "2025-12-02": 2,
                "2025-12-09": 4,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-14": 2,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-18": 3,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-28": 1,
                "2026-03-30": 1,
                "2026-04-01": 1,
                "2026-04-07": 3,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-17": 4,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-06": 3,
                "2026-05-09": 3,
                "2026-05-11": 2,
                "2026-05-15": 2,
                "2026-05-16": 2,
                "2026-05-18": 2,
                "2026-05-20": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 6,
                "2026-05-27": 2,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-05-30": 2,
                "2026-06-01": 4,
                "2026-06-02": 1,
                "2026-06-03": 5,
                "2026-06-05": 3,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-11-06": 2.8625775,
                "2025-11-11": 2.5689819444444444,
                "2025-11-14": 1.841378888888889,
                "2025-11-17": 135.49174166666666,
                "2025-12-02": 30.472877500000003,
                "2025-12-09": 84.12895833333333,
                "2025-12-11": 1.5956888888888887,
                "2025-12-17": 0.2468886111111111,
                "2025-12-19": 2.3543997222222224,
                "2026-01-12": 2.9141708333333334,
                "2026-01-13": 0.5578188888888889,
                "2026-01-16": 4.658713888888888,
                "2026-01-26": 3.8535291666666667,
                "2026-02-14": 0.803051111111111,
                "2026-03-05": 3.4222375,
                "2026-03-11": 2.662255,
                "2026-03-12": 0.28140055555555554,
                "2026-03-13": 143.73321611111112,
                "2026-03-18": 11.209267222222223,
                "2026-03-23": 0.7809975,
                "2026-03-24": 1.3608066666666667,
                "2026-03-28": 2.6290761111111114,
                "2026-03-30": 1.1583447222222223,
                "2026-04-01": 3.5765391666666666,
                "2026-04-07": 0.803255,
                "2026-04-08": 0.1476522222222222,
                "2026-04-09": 1.828343611111111,
                "2026-04-10": 0.3663780555555556,
                "2026-04-11": 2.040625,
                "2026-04-13": 3.7196338888888887,
                "2026-04-14": 2.7830030555555556,
                "2026-04-15": 0.7089669444444444,
                "2026-04-16": 1.2112991666666666,
                "2026-04-17": 7.353265277777778,
                "2026-04-20": 2.452759166666667,
                "2026-04-23": 0.17628916666666666,
                "2026-04-27": 0.3854263888888889,
                "2026-04-29": 0.050818055555555554,
                "2026-05-02": 0.4267402777777778,
                "2026-05-04": 94.6248511111111,
                "2026-05-06": 40.11575527777778,
                "2026-05-09": 1.6872075,
                "2026-05-11": 0.33871666666666667,
                "2026-05-15": 3.62213,
                "2026-05-16": 0.3269683333333333,
                "2026-05-18": 1.6194969444444443,
                "2026-05-20": 5.75847,
                "2026-05-21": 3.574858888888889,
                "2026-05-22": 1.0211622222222223,
                "2026-05-25": 2.2016488888888888,
                "2026-05-26": 16.92021888888889,
                "2026-05-27": 2.9788480555555554,
                "2026-05-28": 0.16477472222222223,
                "2026-05-29": 4.311796944444445,
                "2026-05-30": 0.3416419444444444,
                "2026-06-01": 2.7448119444444448,
                "2026-06-02": 24.180366666666668,
                "2026-06-03": 4.264551944444444,
                "2026-06-05": 2.655946111111111,
                "2026-06-06": 0.04217611111111111
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2025-11-17": 4,
                "2025-12-02": 2,
                "2025-12-09": 4,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2026-01-12": 1,
                "2026-01-13": 2,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-14": 2,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-18": 3,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-28": 1,
                "2026-03-30": 1,
                "2026-04-01": 1,
                "2026-04-07": 3,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-11": 1,
                "2026-04-13": 4,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-17": 4,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-06": 3,
                "2026-05-09": 3,
                "2026-05-11": 2,
                "2026-05-15": 2,
                "2026-05-16": 2,
                "2026-05-18": 2,
                "2026-05-20": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 6,
                "2026-05-27": 2,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-05-30": 2,
                "2026-06-01": 4,
                "2026-06-02": 1,
                "2026-06-03": 5,
                "2026-06-05": 3,
                "2026-06-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 89.11,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 3,
                "4-6h": 2,
                "24-26h": 1,
                "66-68h": 1,
                "92-94h": 1,
                "94-96h": 1,
                "136-138h": 1,
                "160-162h": 1,
                "192-194h": 1,
                "368-370h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-12-02": 2,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-13": 1,
                "2026-01-14": 1
              },
              "time_per_day": {
                "2025-10-21": 368.5097222222222,
                "2025-10-23": 192.76719555555556,
                "2025-11-13": 4.656809166666666,
                "2025-11-27": 3.2158075,
                "2025-12-02": 188.13446222222223,
                "2025-12-10": 3.791059166666667,
                "2025-12-11": 298.57208,
                "2025-12-15": 66.55703555555556,
                "2025-12-22": 4.181547777777777,
                "2026-01-13": 24.92988722222222,
                "2026-01-14": 3.1774002777777777
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-12-02": 2,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-13": 1,
                "2026-01-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 153.23,
              "mode_time_hours": 29.0,
              "mode_frequency": 4,
              "time_distribution": {
                "8-10h": 1,
                "26-28h": 2,
                "28-30h": 4,
                "30-32h": 2,
                "36-38h": 2,
                "44-46h": 1,
                "48-50h": 2,
                "50-52h": 2,
                "56-58h": 1,
                "66-68h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "92-94h": 1,
                "116-118h": 1,
                "120-122h": 2,
                "128-130h": 1,
                "134-136h": 1,
                "140-142h": 1,
                "150-152h": 2,
                "158-160h": 1,
                "164-166h": 1,
                "200-202h": 1,
                "208-210h": 1,
                "220-222h": 1,
                "222-224h": 1,
                "260-262h": 1,
                "312-314h": 1,
                "336-338h": 1,
                "362-364h": 1,
                "388-390h": 1,
                "444-446h": 1,
                "652-654h": 1,
                "656-658h": 1
              },
              "tickets_count": 43,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-19": 2,
                "2025-11-20": 1,
                "2025-12-10": 1,
                "2025-12-22": 2,
                "2026-01-13": 3,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-05": 1,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-11": 2,
                "2026-02-18": 2,
                "2026-02-28": 1,
                "2026-03-14": 1,
                "2026-03-18": 6,
                "2026-03-24": 2,
                "2026-03-26": 2,
                "2026-03-30": 1,
                "2026-04-22": 2,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-07": 117.05434111111111,
                "2025-10-15": 29.090123333333334,
                "2025-10-17": 48.729235277777775,
                "2025-11-05": 30.382739444444443,
                "2025-11-10": 49.97641,
                "2025-11-11": 30.310998055555554,
                "2025-11-19": 250.2607991666667,
                "2025-11-20": 67.88950666666666,
                "2025-12-10": 223.8440322222222,
                "2025-12-22": 100.72132888888888,
                "2026-01-13": 101.73028277777779,
                "2026-01-15": 45.9954925,
                "2026-01-27": 8.074316388888889,
                "2026-01-30": 444.35754833333334,
                "2026-02-05": 140.8899522222222,
                "2026-02-06": 722.4018424999999,
                "2026-02-10": 201.5649575,
                "2026-02-11": 302.80676222222223,
                "2026-02-18": 178.39356444444445,
                "2026-02-28": 26.003776388888888,
                "2026-03-14": 26.133686666666666,
                "2026-03-18": 1622.317236388889,
                "2026-03-24": 57.20945833333333,
                "2026-03-26": 1309.910195,
                "2026-03-30": 73.61184361111111,
                "2026-04-22": 302.0548136111111,
                "2026-06-06": 76.97530083333334
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-19": 2,
                "2025-11-20": 1,
                "2025-12-10": 1,
                "2025-12-22": 2,
                "2026-01-13": 3,
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-05": 1,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-11": 2,
                "2026-02-18": 2,
                "2026-02-28": 1,
                "2026-03-14": 1,
                "2026-03-18": 6,
                "2026-03-24": 2,
                "2026-03-26": 2,
                "2026-03-30": 1,
                "2026-04-22": 2,
                "2026-06-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 491.44,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1,
                "450-452h": 1,
                "496-498h": 1,
                "548-550h": 1,
                "912-914h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2026-02-19": 4
              },
              "time_per_day": {
                "2025-12-11": 46.73781666666667,
                "2026-02-19": 2410.472746388889
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2026-02-19": 4
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 27,
            "tickets_per_day": {
              "2026-03-01": 1,
              "2026-03-11": 1,
              "2026-03-31": 1,
              "2026-04-04": 1,
              "2026-04-07": 1,
              "2026-04-23": 1,
              "2026-04-27": 3,
              "2026-04-29": 1,
              "2026-05-06": 1,
              "2026-05-07": 2,
              "2026-05-08": 5,
              "2026-05-09": 3,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-25": 1,
              "2026-05-26": 1,
              "2026-05-27": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 27,
              "tickets_per_day": {
                "2026-03-01": 1,
                "2026-03-11": 1,
                "2026-03-31": 1,
                "2026-04-04": 1,
                "2026-04-07": 1,
                "2026-04-23": 1,
                "2026-04-27": 3,
                "2026-04-29": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-08": 5,
                "2026-05-09": 3,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-25": 1,
                "2026-05-26": 1,
                "2026-05-27": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_118": {
      "overall": {
        "avg_time_hours": 1.78,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-02": 1
        },
        "time_per_day": {
          "2025-10-02": 1.777478611111111
        },
        "time_count_per_day": {
          "2025-10-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-02": 1
          },
          "time_per_day": {
            "2025-10-02": 1.777478611111111
          },
          "time_count_per_day": {
            "2025-10-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.78,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-02": 1
            },
            "time_per_day": {
              "2025-10-02": 1.777478611111111
            },
            "time_count_per_day": {
              "2025-10-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-02": 1
              },
              "time_per_day": {
                "2025-10-02": 1.777478611111111
              },
              "time_count_per_day": {
                "2025-10-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_120": {
      "overall": {
        "avg_time_hours": 67.03,
        "mode_time_hours": 191.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "20-22h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "32-34h": 1,
          "164-166h": 1,
          "190-192h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-10": 1,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-10-10": 191.2426161111111,
          "2025-11-04": 26.07754,
          "2025-11-06": 26.87677111111111,
          "2025-12-04": 25.51791805555556,
          "2025-12-10": 165.6753277777778,
          "2025-12-18": 33.836013888888886
        },
        "time_count_per_day": {
          "2025-10-10": 1,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 17.65,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "20-22h": 1,
            "26-28h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-11-06": 2
          },
          "time_per_day": {
            "2025-11-04": 26.07754,
            "2025-11-06": 26.87677111111111
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-11-06": 2
          }
        },
        "P3": {
          "avg_time_hours": 104.07,
          "mode_time_hours": 191.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "32-34h": 1,
            "164-166h": 1,
            "190-192h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-10-10": 191.2426161111111,
            "2025-12-04": 25.51791805555556,
            "2025-12-10": 165.6753277777778,
            "2025-12-18": 33.836013888888886
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 67.03,
            "mode_time_hours": 191.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "20-22h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "32-34h": 1,
              "164-166h": 1,
              "190-192h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-10": 1,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-10-10": 191.2426161111111,
              "2025-11-04": 26.07754,
              "2025-11-06": 26.87677111111111,
              "2025-12-04": 25.51791805555556,
              "2025-12-10": 165.6753277777778,
              "2025-12-18": 33.836013888888886
            },
            "time_count_per_day": {
              "2025-10-10": 1,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 17.65,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "20-22h": 1,
                "26-28h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-11-06": 2
              },
              "time_per_day": {
                "2025-11-04": 26.07754,
                "2025-11-06": 26.87677111111111
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-11-06": 2
              }
            },
            "P3": {
              "avg_time_hours": 104.07,
              "mode_time_hours": 191.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "32-34h": 1,
                "164-166h": 1,
                "190-192h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-10-10": 191.2426161111111,
                "2025-12-04": 25.51791805555556,
                "2025-12-10": 165.6753277777778,
                "2025-12-18": 33.836013888888886
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_121": {
      "overall": {
        "avg_time_hours": 198.83,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 1,
          "574-576h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-10-03": 1,
          "2025-11-14": 1,
          "2026-03-26": 1
        },
        "time_per_day": {
          "2025-10-03": 19.45620527777778,
          "2025-11-14": 575.3488108333333,
          "2026-03-26": 1.689051111111111
        },
        "time_count_per_day": {
          "2025-10-03": 1,
          "2025-11-14": 1,
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.57,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "18-20h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-03": 1,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2025-10-03": 19.45620527777778,
            "2026-03-26": 1.689051111111111
          },
          "time_count_per_day": {
            "2025-10-03": 1,
            "2026-03-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 575.35,
          "mode_time_hours": 575.0,
          "mode_frequency": 1,
          "time_distribution": {
            "574-576h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 575.3488108333333
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 198.83,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 1,
              "574-576h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-03": 1,
              "2025-11-14": 1,
              "2026-03-26": 1
            },
            "time_per_day": {
              "2025-10-03": 19.45620527777778,
              "2025-11-14": 575.3488108333333,
              "2026-03-26": 1.689051111111111
            },
            "time_count_per_day": {
              "2025-10-03": 1,
              "2025-11-14": 1,
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.57,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "18-20h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-03": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2025-10-03": 19.45620527777778,
                "2026-03-26": 1.689051111111111
              },
              "time_count_per_day": {
                "2025-10-03": 1,
                "2026-03-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 575.35,
              "mode_time_hours": 575.0,
              "mode_frequency": 1,
              "time_distribution": {
                "574-576h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 575.3488108333333
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_123": {
      "overall": {
        "avg_time_hours": 23.35,
        "mode_time_hours": 1.0,
        "mode_frequency": 10,
        "time_distribution": {
          "0-2h": 10,
          "2-4h": 3,
          "4-6h": 1,
          "8-10h": 4,
          "96-98h": 1,
          "118-120h": 2,
          "124-126h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-13": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-10-21": 2,
          "2025-10-24": 1,
          "2025-11-19": 2,
          "2025-12-15": 2,
          "2026-01-12": 1,
          "2026-01-16": 2,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-03-04": 1,
          "2026-03-16": 1,
          "2026-03-25": 1,
          "2026-03-30": 4
        },
        "time_per_day": {
          "2025-10-07": 96.02676583333334,
          "2025-10-13": 0.38234861111111107,
          "2025-10-15": 1.5162127777777779,
          "2025-10-17": 2.636629722222222,
          "2025-10-21": 126.39936277777778,
          "2025-10-24": 1.2522455555555556,
          "2025-11-19": 0.34494694444444446,
          "2025-12-15": 238.57776194444443,
          "2026-01-12": 8.068690833333333,
          "2026-01-16": 13.805300555555556,
          "2026-02-03": 2.482996111111111,
          "2026-02-09": 8.311637777777777,
          "2026-03-04": 9.407644999999999,
          "2026-03-25": 0.013667222222222221,
          "2026-03-30": 4.513143055555555
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-13": 1,
          "2025-10-15": 1,
          "2025-10-17": 1,
          "2025-10-21": 2,
          "2025-10-24": 1,
          "2025-11-19": 2,
          "2025-12-15": 2,
          "2026-01-12": 1,
          "2026-01-16": 2,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-03-04": 1,
          "2026-03-25": 1,
          "2026-03-30": 4
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 14.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 3,
            "4-6h": 1,
            "8-10h": 3,
            "118-120h": 2
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-21": 1,
            "2025-10-24": 1,
            "2025-11-19": 2,
            "2025-12-15": 2,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-03-04": 1,
            "2026-03-25": 1,
            "2026-03-30": 4
          },
          "time_per_day": {
            "2025-10-13": 0.38234861111111107,
            "2025-10-15": 1.5162127777777779,
            "2025-10-17": 2.636629722222222,
            "2025-10-21": 2.3715972222222224,
            "2025-10-24": 1.2522455555555556,
            "2025-11-19": 0.34494694444444446,
            "2025-12-15": 238.57776194444443,
            "2026-01-12": 8.068690833333333,
            "2026-01-16": 4.727664444444445,
            "2026-02-03": 2.482996111111111,
            "2026-02-09": 8.311637777777777,
            "2026-03-04": 9.407644999999999,
            "2026-03-25": 0.013667222222222221,
            "2026-03-30": 4.513143055555555
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-21": 1,
            "2025-10-24": 1,
            "2025-11-19": 2,
            "2025-12-15": 2,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-03-04": 1,
            "2026-03-25": 1,
            "2026-03-30": 4
          }
        },
        "P3": {
          "avg_time_hours": 9.08,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 9.077636111111111
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 110.03,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "96-98h": 1,
            "124-126h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-21": 1,
            "2026-03-16": 1
          },
          "time_per_day": {
            "2025-10-07": 96.02676583333334,
            "2025-10-21": 124.02776555555556
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 23.35,
            "mode_time_hours": 1.0,
            "mode_frequency": 10,
            "time_distribution": {
              "0-2h": 10,
              "2-4h": 3,
              "4-6h": 1,
              "8-10h": 4,
              "96-98h": 1,
              "118-120h": 2,
              "124-126h": 1
            },
            "tickets_count": 22,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-13": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-10-21": 2,
              "2025-10-24": 1,
              "2025-11-19": 2,
              "2025-12-15": 2,
              "2026-01-12": 1,
              "2026-01-16": 2,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-03-04": 1,
              "2026-03-25": 1,
              "2026-03-30": 4
            },
            "time_per_day": {
              "2025-10-07": 96.02676583333334,
              "2025-10-13": 0.38234861111111107,
              "2025-10-15": 1.5162127777777779,
              "2025-10-17": 2.636629722222222,
              "2025-10-21": 126.39936277777778,
              "2025-10-24": 1.2522455555555556,
              "2025-11-19": 0.34494694444444446,
              "2025-12-15": 238.57776194444443,
              "2026-01-12": 8.068690833333333,
              "2026-01-16": 13.805300555555556,
              "2026-02-03": 2.482996111111111,
              "2026-02-09": 8.311637777777777,
              "2026-03-04": 9.407644999999999,
              "2026-03-25": 0.013667222222222221,
              "2026-03-30": 4.513143055555555
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-13": 1,
              "2025-10-15": 1,
              "2025-10-17": 1,
              "2025-10-21": 2,
              "2025-10-24": 1,
              "2025-11-19": 2,
              "2025-12-15": 2,
              "2026-01-12": 1,
              "2026-01-16": 2,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-03-04": 1,
              "2026-03-25": 1,
              "2026-03-30": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 14.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 3,
                "4-6h": 1,
                "8-10h": 3,
                "118-120h": 2
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-21": 1,
                "2025-10-24": 1,
                "2025-11-19": 2,
                "2025-12-15": 2,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-03-04": 1,
                "2026-03-25": 1,
                "2026-03-30": 4
              },
              "time_per_day": {
                "2025-10-13": 0.38234861111111107,
                "2025-10-15": 1.5162127777777779,
                "2025-10-17": 2.636629722222222,
                "2025-10-21": 2.3715972222222224,
                "2025-10-24": 1.2522455555555556,
                "2025-11-19": 0.34494694444444446,
                "2025-12-15": 238.57776194444443,
                "2026-01-12": 8.068690833333333,
                "2026-01-16": 4.727664444444445,
                "2026-02-03": 2.482996111111111,
                "2026-02-09": 8.311637777777777,
                "2026-03-04": 9.407644999999999,
                "2026-03-25": 0.013667222222222221,
                "2026-03-30": 4.513143055555555
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-17": 1,
                "2025-10-21": 1,
                "2025-10-24": 1,
                "2025-11-19": 2,
                "2025-12-15": 2,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-03-04": 1,
                "2026-03-25": 1,
                "2026-03-30": 4
              }
            },
            "P3": {
              "avg_time_hours": 9.08,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 9.077636111111111
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 110.03,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "96-98h": 1,
                "124-126h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-21": 1
              },
              "time_per_day": {
                "2025-10-07": 96.02676583333334,
                "2025-10-21": 124.02776555555556
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-21": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_124": {
      "overall": {
        "avg_time_hours": 157.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 1,
          "6-8h": 1,
          "28-30h": 1,
          "30-32h": 1,
          "32-34h": 1,
          "54-56h": 1,
          "102-104h": 2,
          "202-204h": 1,
          "218-220h": 1,
          "230-232h": 1,
          "334-336h": 1,
          "502-504h": 1,
          "536-538h": 1,
          "908-910h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-08": 1,
          "2025-10-15": 1,
          "2025-10-23": 1,
          "2025-10-30": 1,
          "2025-11-05": 1,
          "2025-11-07": 1,
          "2025-11-14": 1,
          "2026-02-19": 2,
          "2026-03-13": 1,
          "2026-03-16": 2,
          "2026-03-17": 2,
          "2026-03-18": 1,
          "2026-03-24": 2,
          "2026-04-27": 2,
          "2026-05-11": 1,
          "2026-05-26": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-10-07": 103.4232386111111,
          "2025-10-08": 1.9286677777777776,
          "2025-10-15": 0.40360250000000003,
          "2025-10-23": 28.72063861111111,
          "2025-10-30": 202.30614666666668,
          "2025-11-05": 218.63484222222223,
          "2025-11-07": 230.5068077777778,
          "2025-11-14": 536.4754038888889,
          "2026-02-19": 1411.1072947222224,
          "2026-03-16": 60.95232166666666,
          "2026-03-17": 135.33240944444447,
          "2026-03-18": 334.34172722222223,
          "2026-03-24": 3.138782777777778,
          "2026-04-27": 0.4435113888888889,
          "2026-05-11": 1.4173194444444446,
          "2026-05-27": 30.134935833333333
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-08": 1,
          "2025-10-15": 1,
          "2025-10-23": 1,
          "2025-10-30": 1,
          "2025-11-05": 1,
          "2025-11-07": 1,
          "2025-11-14": 1,
          "2026-02-19": 2,
          "2026-03-16": 2,
          "2026-03-17": 2,
          "2026-03-18": 1,
          "2026-03-24": 2,
          "2026-04-27": 2,
          "2026-05-11": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 31.06,
          "mode_time_hours": 55.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "32-34h": 1,
            "54-56h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-16": 2,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-16": 60.95232166666666,
            "2026-03-17": 32.221940277777776
          },
          "time_count_per_day": {
            "2026-03-16": 2,
            "2026-03-17": 1
          }
        },
        "P2": {
          "avg_time_hours": 6.48,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "30-32h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2026-03-13": 1,
            "2026-04-27": 2,
            "2026-05-11": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2025-10-15": 0.40360250000000003,
            "2026-04-27": 0.4435113888888889,
            "2026-05-11": 1.4173194444444446,
            "2026-05-27": 30.134935833333333
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2026-04-27": 2,
            "2026-05-11": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 52.68,
          "mode_time_hours": 103.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "102-104h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-08": 1
          },
          "time_per_day": {
            "2025-10-07": 103.4232386111111,
            "2025-10-08": 1.9286677777777776
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-08": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 184.14,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "28-30h": 1,
            "102-104h": 1,
            "202-204h": 1,
            "218-220h": 1,
            "230-232h": 1,
            "334-336h": 1,
            "536-538h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-10-30": 1,
            "2025-11-05": 1,
            "2025-11-07": 1,
            "2025-11-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-24": 2,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-10-23": 28.72063861111111,
            "2025-10-30": 202.30614666666668,
            "2025-11-05": 218.63484222222223,
            "2025-11-07": 230.5068077777778,
            "2025-11-14": 536.4754038888889,
            "2026-03-17": 103.11046916666668,
            "2026-03-18": 334.34172722222223,
            "2026-03-24": 3.138782777777778
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-10-30": 1,
            "2025-11-05": 1,
            "2025-11-07": 1,
            "2025-11-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-24": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 705.55,
          "mode_time_hours": 909.0,
          "mode_frequency": 1,
          "time_distribution": {
            "502-504h": 1,
            "908-910h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 1411.1072947222224
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 1,
              "6-8h": 1,
              "28-30h": 1,
              "30-32h": 1,
              "32-34h": 1,
              "54-56h": 1,
              "102-104h": 2,
              "202-204h": 1,
              "218-220h": 1,
              "230-232h": 1,
              "334-336h": 1,
              "502-504h": 1,
              "536-538h": 1,
              "908-910h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-08": 1,
              "2025-10-15": 1,
              "2025-10-23": 1,
              "2025-10-30": 1,
              "2025-11-05": 1,
              "2025-11-07": 1,
              "2025-11-14": 1,
              "2026-02-19": 2,
              "2026-03-16": 2,
              "2026-03-17": 2,
              "2026-03-18": 1,
              "2026-03-24": 2,
              "2026-04-27": 2,
              "2026-05-11": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-10-07": 103.4232386111111,
              "2025-10-08": 1.9286677777777776,
              "2025-10-15": 0.40360250000000003,
              "2025-10-23": 28.72063861111111,
              "2025-10-30": 202.30614666666668,
              "2025-11-05": 218.63484222222223,
              "2025-11-07": 230.5068077777778,
              "2025-11-14": 536.4754038888889,
              "2026-02-19": 1411.1072947222224,
              "2026-03-16": 60.95232166666666,
              "2026-03-17": 135.33240944444447,
              "2026-03-18": 334.34172722222223,
              "2026-03-24": 3.138782777777778,
              "2026-04-27": 0.4435113888888889,
              "2026-05-11": 1.4173194444444446,
              "2026-05-27": 30.134935833333333
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-08": 1,
              "2025-10-15": 1,
              "2025-10-23": 1,
              "2025-10-30": 1,
              "2025-11-05": 1,
              "2025-11-07": 1,
              "2025-11-14": 1,
              "2026-02-19": 2,
              "2026-03-16": 2,
              "2026-03-17": 2,
              "2026-03-18": 1,
              "2026-03-24": 2,
              "2026-04-27": 2,
              "2026-05-11": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 31.06,
              "mode_time_hours": 55.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "32-34h": 1,
                "54-56h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-16": 2,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-16": 60.95232166666666,
                "2026-03-17": 32.221940277777776
              },
              "time_count_per_day": {
                "2026-03-16": 2,
                "2026-03-17": 1
              }
            },
            "P2": {
              "avg_time_hours": 6.48,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "30-32h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2026-04-27": 2,
                "2026-05-11": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2025-10-15": 0.40360250000000003,
                "2026-04-27": 0.4435113888888889,
                "2026-05-11": 1.4173194444444446,
                "2026-05-27": 30.134935833333333
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2026-04-27": 2,
                "2026-05-11": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 52.68,
              "mode_time_hours": 103.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "102-104h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-08": 1
              },
              "time_per_day": {
                "2025-10-07": 103.4232386111111,
                "2025-10-08": 1.9286677777777776
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-08": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 184.14,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "28-30h": 1,
                "102-104h": 1,
                "202-204h": 1,
                "218-220h": 1,
                "230-232h": 1,
                "334-336h": 1,
                "536-538h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-10-30": 1,
                "2025-11-05": 1,
                "2025-11-07": 1,
                "2025-11-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-24": 2
              },
              "time_per_day": {
                "2025-10-23": 28.72063861111111,
                "2025-10-30": 202.30614666666668,
                "2025-11-05": 218.63484222222223,
                "2025-11-07": 230.5068077777778,
                "2025-11-14": 536.4754038888889,
                "2026-03-17": 103.11046916666668,
                "2026-03-18": 334.34172722222223,
                "2026-03-24": 3.138782777777778
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-10-30": 1,
                "2025-11-05": 1,
                "2025-11-07": 1,
                "2025-11-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-24": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 705.55,
              "mode_time_hours": 909.0,
              "mode_frequency": 1,
              "time_distribution": {
                "502-504h": 1,
                "908-910h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 1411.1072947222224
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_126": {
      "overall": {
        "avg_time_hours": 142.73,
        "mode_time_hours": 1.0,
        "mode_frequency": 66,
        "time_distribution": {
          "0-2h": 66,
          "2-4h": 27,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 3,
          "10-12h": 2,
          "12-14h": 1,
          "16-18h": 3,
          "20-22h": 5,
          "22-24h": 1,
          "24-26h": 4,
          "26-28h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "36-38h": 1,
          "44-46h": 4,
          "48-50h": 1,
          "50-52h": 6,
          "60-62h": 2,
          "70-72h": 1,
          "94-96h": 1,
          "96-98h": 1,
          "104-106h": 2,
          "106-108h": 1,
          "118-120h": 3,
          "122-124h": 2,
          "126-128h": 1,
          "134-136h": 3,
          "140-142h": 3,
          "150-152h": 2,
          "164-166h": 2,
          "166-168h": 1,
          "182-184h": 1,
          "192-194h": 2,
          "206-208h": 1,
          "218-220h": 1,
          "220-222h": 1,
          "282-284h": 1,
          "330-332h": 1,
          "336-338h": 2,
          "338-340h": 1,
          "354-356h": 1,
          "362-364h": 3,
          "364-366h": 1,
          "372-374h": 2,
          "374-376h": 1,
          "380-382h": 2,
          "392-394h": 1,
          "414-416h": 1,
          "478-480h": 2,
          "502-504h": 1,
          "504-506h": 2,
          "508-510h": 1,
          "514-516h": 1,
          "524-526h": 1,
          "550-552h": 1,
          "552-554h": 3,
          "582-584h": 1,
          "598-600h": 1,
          "622-624h": 1,
          "630-632h": 1,
          "672-674h": 1,
          "682-684h": 1,
          "692-694h": 1,
          "700-702h": 1,
          "752-754h": 1,
          "966-968h": 1,
          "1020-1022h": 1,
          "1124-1126h": 2,
          "1152-1154h": 1
        },
        "tickets_count": 229,
        "tickets_per_day": {
          "2025-10-07": 2,
          "2025-10-09": 1,
          "2025-10-13": 1,
          "2025-10-14": 3,
          "2025-10-15": 5,
          "2025-10-17": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-29": 1,
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-11-03": 1,
          "2025-11-05": 3,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-11-20": 2,
          "2025-11-21": 1,
          "2025-11-23": 1,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-12-03": 3,
          "2025-12-04": 3,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-11": 2,
          "2025-12-15": 3,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-22": 1,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-05": 3,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-23": 3,
          "2026-01-27": 3,
          "2026-02-06": 6,
          "2026-02-09": 1,
          "2026-02-10": 10,
          "2026-02-11": 1,
          "2026-02-13": 5,
          "2026-02-17": 1,
          "2026-02-18": 3,
          "2026-02-19": 10,
          "2026-02-20": 1,
          "2026-02-21": 12,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-10": 6,
          "2026-03-11": 1,
          "2026-03-17": 3,
          "2026-03-18": 5,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-26": 10,
          "2026-03-27": 1,
          "2026-03-31": 3,
          "2026-04-01": 4,
          "2026-04-02": 6,
          "2026-04-06": 1,
          "2026-04-07": 5,
          "2026-04-10": 3,
          "2026-04-13": 2,
          "2026-04-14": 5,
          "2026-04-15": 2,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-27": 3,
          "2026-04-30": 1,
          "2026-05-04": 8,
          "2026-05-05": 3,
          "2026-05-06": 6,
          "2026-05-07": 3,
          "2026-05-08": 1,
          "2026-05-11": 7,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-15": 1,
          "2026-05-20": 2,
          "2026-05-21": 1,
          "2026-05-25": 3,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-06-01": 1,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-07": 111.38935944444444,
          "2025-10-09": 32.56438611111111,
          "2025-10-13": 134.651725,
          "2025-10-14": 74.17587472222223,
          "2025-10-15": 501.4084316666667,
          "2025-10-17": 2.412789722222222,
          "2025-10-20": 105.33570527777778,
          "2025-10-22": 337.6833766666667,
          "2025-10-24": 339.10558499999996,
          "2025-10-27": 8.042834444444445,
          "2025-10-28": 141.32116444444443,
          "2025-10-29": 330.80124388888885,
          "2025-10-30": 514.3067380555556,
          "2025-10-31": 107.55078833333333,
          "2025-11-03": 0.5973827777777778,
          "2025-11-05": 153.21618666666666,
          "2025-11-11": 96.83750972222221,
          "2025-11-13": 218.1298088888889,
          "2025-11-20": 171.57087527777776,
          "2025-11-21": 1.096176111111111,
          "2025-11-23": 25.916546666666665,
          "2025-11-25": 752.8860755555555,
          "2025-11-27": 1.0339502777777778,
          "2025-12-03": 111.15808833333334,
          "2025-12-04": 1091.0758658333334,
          "2025-12-05": 183.54847583333336,
          "2025-12-09": 283.2246375,
          "2025-12-10": 25.965845555555553,
          "2025-12-11": 266.7176538888889,
          "2025-12-15": 51.17185611111111,
          "2025-12-16": 45.01687694444445,
          "2025-12-17": 45.44326861111111,
          "2025-12-22": 50.482947777777774,
          "2025-12-26": 51.998439999999995,
          "2025-12-29": 967.7605972222221,
          "2025-12-30": 17.349172777777778,
          "2026-01-05": 1656.4645858333333,
          "2026-01-09": 26.049014444444445,
          "2026-01-12": 8.286105555555556,
          "2026-01-23": 358.67445833333335,
          "2026-01-27": 130.7534677777778,
          "2026-02-06": 1583.4092191666668,
          "2026-02-09": 61.66920388888889,
          "2026-02-10": 4293.263790277779,
          "2026-02-11": 167.0150825,
          "2026-02-13": 635.2593591666667,
          "2026-02-18": 65.75032611111111,
          "2026-02-19": 6811.063728888889,
          "2026-02-20": 2.180337777777778,
          "2026-02-21": 16.466997222222226,
          "2026-02-23": 8.038527222222223,
          "2026-02-28": 70.0758975,
          "2026-03-10": 8.926432777777778,
          "2026-03-17": 69.39460055555556,
          "2026-03-18": 1296.918020277778,
          "2026-03-19": 0.8520063888888889,
          "2026-03-20": 17.907520555555557,
          "2026-03-26": 4337.062097222221,
          "2026-03-27": 0.49905444444444447,
          "2026-03-31": 1.7623358333333332,
          "2026-04-01": 9.407725,
          "2026-04-02": 17.542678055555555,
          "2026-04-06": 2.788527222222222,
          "2026-04-07": 12.169107777777777,
          "2026-04-10": 3.948923888888889,
          "2026-04-13": 0.5661844444444445,
          "2026-04-14": 2.574705,
          "2026-04-20": 0.14621222222222224,
          "2026-04-21": 1.0706463888888889,
          "2026-04-22": 0.08684416666666667,
          "2026-04-23": 1.7335997222222221,
          "2026-04-27": 1.010178611111111,
          "2026-04-30": 1.0222505555555554,
          "2026-05-04": 4.5570305555555555,
          "2026-05-05": 0.1179363888888889,
          "2026-05-06": 2.579900277777778,
          "2026-05-07": 45.40945472222222,
          "2026-05-11": 13.302378055555556,
          "2026-05-15": 0.32165222222222223,
          "2026-05-21": 1.05566,
          "2026-05-25": 1.50434,
          "2026-05-26": 0.17968277777777777,
          "2026-05-28": 4.1281083333333335,
          "2026-05-29": 2.7160741666666666,
          "2026-06-01": 4.028912222222222,
          "2026-06-08": 1.6222916666666667
        },
        "time_count_per_day": {
          "2025-10-07": 2,
          "2025-10-09": 1,
          "2025-10-13": 1,
          "2025-10-14": 3,
          "2025-10-15": 5,
          "2025-10-17": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-29": 1,
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-11-03": 1,
          "2025-11-05": 3,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-11-20": 2,
          "2025-11-21": 1,
          "2025-11-23": 1,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-12-03": 3,
          "2025-12-04": 3,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-11": 2,
          "2025-12-15": 3,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-22": 1,
          "2025-12-26": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-05": 3,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-23": 3,
          "2026-01-27": 3,
          "2026-02-06": 6,
          "2026-02-09": 1,
          "2026-02-10": 10,
          "2026-02-11": 1,
          "2026-02-13": 5,
          "2026-02-18": 3,
          "2026-02-19": 10,
          "2026-02-20": 1,
          "2026-02-21": 12,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-10": 5,
          "2026-03-17": 3,
          "2026-03-18": 5,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-26": 10,
          "2026-03-27": 1,
          "2026-03-31": 2,
          "2026-04-01": 4,
          "2026-04-02": 6,
          "2026-04-06": 1,
          "2026-04-07": 5,
          "2026-04-10": 3,
          "2026-04-13": 2,
          "2026-04-14": 4,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-27": 1,
          "2026-04-30": 1,
          "2026-05-04": 4,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-07": 3,
          "2026-05-11": 7,
          "2026-05-15": 1,
          "2026-05-21": 1,
          "2026-05-25": 3,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-06-01": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 65,
          "time_distribution": {
            "0-2h": 65,
            "2-4h": 22,
            "4-6h": 2,
            "8-10h": 1,
            "10-12h": 2,
            "12-14h": 1,
            "20-22h": 1,
            "28-30h": 1,
            "44-46h": 2
          },
          "tickets_count": 97,
          "tickets_per_day": {
            "2025-10-15": 2,
            "2025-11-03": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-03": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-12": 1,
            "2026-02-13": 4,
            "2026-02-20": 1,
            "2026-02-21": 9,
            "2026-03-10": 5,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-27": 1,
            "2026-03-31": 2,
            "2026-04-01": 4,
            "2026-04-02": 6,
            "2026-04-06": 1,
            "2026-04-07": 5,
            "2026-04-10": 3,
            "2026-04-13": 2,
            "2026-04-14": 4,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 3,
            "2026-04-27": 1,
            "2026-04-30": 1,
            "2026-05-04": 4,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 3,
            "2026-05-11": 7,
            "2026-05-15": 1,
            "2026-05-21": 1,
            "2026-05-25": 3,
            "2026-05-26": 1,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-15": 44.629129444444445,
            "2025-11-03": 0.5973827777777778,
            "2025-11-21": 1.096176111111111,
            "2025-11-27": 1.0339502777777778,
            "2025-12-03": 3.5444155555555557,
            "2025-12-15": 0.230055,
            "2025-12-17": 45.44326861111111,
            "2026-01-12": 8.286105555555556,
            "2026-02-13": 11.328621944444444,
            "2026-02-20": 2.180337777777778,
            "2026-02-21": 6.077696944444446,
            "2026-03-10": 8.926432777777778,
            "2026-03-17": 31.968325555555555,
            "2026-03-18": 0.6422277777777777,
            "2026-03-19": 0.8520063888888889,
            "2026-03-27": 0.49905444444444447,
            "2026-03-31": 1.7623358333333332,
            "2026-04-01": 9.407725,
            "2026-04-02": 17.542678055555555,
            "2026-04-06": 2.788527222222222,
            "2026-04-07": 12.169107777777777,
            "2026-04-10": 3.948923888888889,
            "2026-04-13": 0.5661844444444445,
            "2026-04-14": 2.574705,
            "2026-04-20": 0.14621222222222224,
            "2026-04-21": 1.0706463888888889,
            "2026-04-22": 0.08684416666666667,
            "2026-04-23": 1.7335997222222221,
            "2026-04-27": 1.010178611111111,
            "2026-04-30": 1.0222505555555554,
            "2026-05-04": 4.5570305555555555,
            "2026-05-05": 0.1179363888888889,
            "2026-05-06": 2.579900277777778,
            "2026-05-07": 45.40945472222222,
            "2026-05-11": 13.302378055555556,
            "2026-05-15": 0.32165222222222223,
            "2026-05-21": 1.05566,
            "2026-05-25": 1.50434,
            "2026-05-26": 0.17968277777777777,
            "2026-05-28": 4.1281083333333335,
            "2026-05-29": 2.7160741666666666,
            "2026-06-01": 4.028912222222222,
            "2026-06-08": 1.6222916666666667
          },
          "time_count_per_day": {
            "2025-10-15": 2,
            "2025-11-03": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-03": 1,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-12": 1,
            "2026-02-13": 4,
            "2026-02-20": 1,
            "2026-02-21": 9,
            "2026-03-10": 5,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-27": 1,
            "2026-03-31": 2,
            "2026-04-01": 4,
            "2026-04-02": 6,
            "2026-04-06": 1,
            "2026-04-07": 5,
            "2026-04-10": 3,
            "2026-04-13": 2,
            "2026-04-14": 4,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 3,
            "2026-04-27": 1,
            "2026-04-30": 1,
            "2026-05-04": 4,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 3,
            "2026-05-11": 7,
            "2026-05-15": 1,
            "2026-05-21": 1,
            "2026-05-25": 3,
            "2026-05-26": 1,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 314.87,
          "mode_time_hours": 21.0,
          "mode_frequency": 3,
          "time_distribution": {
            "16-18h": 1,
            "20-22h": 3,
            "150-152h": 2,
            "192-194h": 1,
            "336-338h": 2,
            "338-340h": 1,
            "478-480h": 2,
            "504-506h": 1,
            "514-516h": 1,
            "1152-1154h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-10-30": 1,
            "2025-12-30": 1,
            "2026-02-06": 1,
            "2026-02-10": 8,
            "2026-02-18": 2
          },
          "time_per_day": {
            "2025-10-22": 337.6833766666667,
            "2025-10-24": 339.10558499999996,
            "2025-10-30": 514.3067380555556,
            "2025-12-30": 17.349172777777778,
            "2026-02-06": 192.3283072222222,
            "2026-02-10": 3278.3625258333336,
            "2026-02-18": 43.85021305555556
          },
          "time_count_per_day": {
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-10-30": 1,
            "2025-12-30": 1,
            "2026-02-06": 1,
            "2026-02-10": 8,
            "2026-02-18": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 185.86,
          "mode_time_hours": 51.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 5,
            "6-8h": 1,
            "8-10h": 2,
            "16-18h": 2,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 4,
            "26-28h": 1,
            "32-34h": 1,
            "36-38h": 1,
            "48-50h": 1,
            "50-52h": 6,
            "60-62h": 2,
            "70-72h": 1,
            "94-96h": 1,
            "96-98h": 1,
            "104-106h": 2,
            "106-108h": 1,
            "118-120h": 3,
            "122-124h": 2,
            "126-128h": 1,
            "134-136h": 3,
            "140-142h": 3,
            "164-166h": 2,
            "166-168h": 1,
            "182-184h": 1,
            "192-194h": 1,
            "218-220h": 1,
            "220-222h": 1,
            "282-284h": 1,
            "330-332h": 1,
            "362-364h": 3,
            "364-366h": 1,
            "372-374h": 2,
            "380-382h": 2,
            "392-394h": 1,
            "414-416h": 1,
            "502-504h": 1,
            "504-506h": 1,
            "508-510h": 1,
            "524-526h": 1,
            "582-584h": 1,
            "598-600h": 1,
            "630-632h": 1,
            "700-702h": 1,
            "752-754h": 1
          },
          "tickets_count": 98,
          "tickets_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-14": 3,
            "2025-10-15": 3,
            "2025-10-17": 1,
            "2025-10-20": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2025-11-05": 3,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-20": 2,
            "2025-11-23": 1,
            "2025-11-25": 1,
            "2025-12-03": 2,
            "2025-12-04": 3,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-09": 1,
            "2026-01-23": 3,
            "2026-01-27": 3,
            "2026-02-06": 5,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-11": 1,
            "2026-02-18": 1,
            "2026-02-21": 3,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-20": 1,
            "2026-03-26": 10,
            "2026-03-31": 1,
            "2026-04-14": 1,
            "2026-04-15": 2,
            "2026-04-27": 2,
            "2026-05-04": 4,
            "2026-05-05": 2,
            "2026-05-06": 4,
            "2026-05-08": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-20": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-07": 111.38935944444444,
            "2025-10-09": 32.56438611111111,
            "2025-10-13": 134.651725,
            "2025-10-14": 74.17587472222223,
            "2025-10-15": 456.7793022222222,
            "2025-10-17": 2.412789722222222,
            "2025-10-20": 105.33570527777778,
            "2025-10-27": 8.042834444444445,
            "2025-10-28": 141.32116444444443,
            "2025-10-29": 330.80124388888885,
            "2025-10-31": 107.55078833333333,
            "2025-11-05": 153.21618666666666,
            "2025-11-11": 96.83750972222221,
            "2025-11-13": 218.1298088888889,
            "2025-11-20": 171.57087527777776,
            "2025-11-23": 25.916546666666665,
            "2025-11-25": 752.8860755555555,
            "2025-12-03": 107.61367277777778,
            "2025-12-04": 1091.0758658333334,
            "2025-12-05": 183.54847583333336,
            "2025-12-09": 283.2246375,
            "2025-12-10": 25.965845555555553,
            "2025-12-11": 221.54820138888888,
            "2025-12-15": 50.94180111111111,
            "2025-12-22": 50.482947777777774,
            "2025-12-26": 51.998439999999995,
            "2026-01-09": 26.049014444444445,
            "2026-01-23": 358.67445833333335,
            "2026-01-27": 130.7534677777778,
            "2026-02-06": 1391.0809119444446,
            "2026-02-09": 61.66920388888889,
            "2026-02-10": 1014.9012644444445,
            "2026-02-11": 167.0150825,
            "2026-02-18": 21.900113055555558,
            "2026-02-21": 10.389300277777778,
            "2026-02-23": 8.038527222222223,
            "2026-02-28": 70.0758975,
            "2026-03-17": 37.426275,
            "2026-03-18": 1296.2757925,
            "2026-03-20": 17.907520555555557,
            "2026-03-26": 4337.062097222221
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-14": 3,
            "2025-10-15": 3,
            "2025-10-17": 1,
            "2025-10-20": 1,
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2025-11-05": 3,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-20": 2,
            "2025-11-23": 1,
            "2025-11-25": 1,
            "2025-12-03": 2,
            "2025-12-04": 3,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2025-12-26": 1,
            "2026-01-09": 1,
            "2026-01-23": 3,
            "2026-01-27": 3,
            "2026-02-06": 5,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-11": 1,
            "2026-02-18": 1,
            "2026-02-21": 3,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-20": 1,
            "2026-03-26": 10
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 597.02,
          "mode_time_hours": 553.0,
          "mode_frequency": 3,
          "time_distribution": {
            "44-46h": 2,
            "206-208h": 1,
            "354-356h": 1,
            "374-376h": 1,
            "550-552h": 1,
            "552-554h": 3,
            "622-624h": 1,
            "672-674h": 1,
            "682-684h": 1,
            "692-694h": 1,
            "966-968h": 1,
            "1020-1022h": 1,
            "1124-1126h": 2
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-29": 1,
            "2026-01-05": 3,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-19": 10,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-12-11": 45.169452500000006,
            "2025-12-16": 45.01687694444445,
            "2025-12-29": 967.7605972222221,
            "2026-01-05": 1656.4645858333333,
            "2026-02-13": 623.9307372222222,
            "2026-02-19": 6811.063728888889
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2025-12-16": 1,
            "2025-12-29": 1,
            "2026-01-05": 3,
            "2026-02-13": 1,
            "2026-02-19": 10
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 142.73,
            "mode_time_hours": 1.0,
            "mode_frequency": 66,
            "time_distribution": {
              "0-2h": 66,
              "2-4h": 27,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 3,
              "10-12h": 2,
              "12-14h": 1,
              "16-18h": 3,
              "20-22h": 5,
              "22-24h": 1,
              "24-26h": 4,
              "26-28h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "36-38h": 1,
              "44-46h": 4,
              "48-50h": 1,
              "50-52h": 6,
              "60-62h": 2,
              "70-72h": 1,
              "94-96h": 1,
              "96-98h": 1,
              "104-106h": 2,
              "106-108h": 1,
              "118-120h": 3,
              "122-124h": 2,
              "126-128h": 1,
              "134-136h": 3,
              "140-142h": 3,
              "150-152h": 2,
              "164-166h": 2,
              "166-168h": 1,
              "182-184h": 1,
              "192-194h": 2,
              "206-208h": 1,
              "218-220h": 1,
              "220-222h": 1,
              "282-284h": 1,
              "330-332h": 1,
              "336-338h": 2,
              "338-340h": 1,
              "354-356h": 1,
              "362-364h": 3,
              "364-366h": 1,
              "372-374h": 2,
              "374-376h": 1,
              "380-382h": 2,
              "392-394h": 1,
              "414-416h": 1,
              "478-480h": 2,
              "502-504h": 1,
              "504-506h": 2,
              "508-510h": 1,
              "514-516h": 1,
              "524-526h": 1,
              "550-552h": 1,
              "552-554h": 3,
              "582-584h": 1,
              "598-600h": 1,
              "622-624h": 1,
              "630-632h": 1,
              "672-674h": 1,
              "682-684h": 1,
              "692-694h": 1,
              "700-702h": 1,
              "752-754h": 1,
              "966-968h": 1,
              "1020-1022h": 1,
              "1124-1126h": 2,
              "1152-1154h": 1
            },
            "tickets_count": 204,
            "tickets_per_day": {
              "2025-10-07": 2,
              "2025-10-09": 1,
              "2025-10-13": 1,
              "2025-10-14": 3,
              "2025-10-15": 5,
              "2025-10-17": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-29": 1,
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-11-03": 1,
              "2025-11-05": 3,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-11-20": 2,
              "2025-11-21": 1,
              "2025-11-23": 1,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-12-03": 3,
              "2025-12-04": 3,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-11": 2,
              "2025-12-15": 3,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-22": 1,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-05": 3,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-23": 3,
              "2026-01-27": 3,
              "2026-02-06": 6,
              "2026-02-09": 1,
              "2026-02-10": 10,
              "2026-02-11": 1,
              "2026-02-13": 5,
              "2026-02-18": 3,
              "2026-02-19": 10,
              "2026-02-20": 1,
              "2026-02-21": 12,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-10": 5,
              "2026-03-17": 3,
              "2026-03-18": 5,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-26": 10,
              "2026-03-27": 1,
              "2026-03-31": 2,
              "2026-04-01": 4,
              "2026-04-02": 6,
              "2026-04-06": 1,
              "2026-04-07": 5,
              "2026-04-10": 3,
              "2026-04-13": 2,
              "2026-04-14": 4,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 3,
              "2026-04-27": 1,
              "2026-04-30": 1,
              "2026-05-04": 4,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 3,
              "2026-05-11": 7,
              "2026-05-15": 1,
              "2026-05-21": 1,
              "2026-05-25": 3,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-05-29": 2,
              "2026-06-01": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-07": 111.38935944444444,
              "2025-10-09": 32.56438611111111,
              "2025-10-13": 134.651725,
              "2025-10-14": 74.17587472222223,
              "2025-10-15": 501.4084316666667,
              "2025-10-17": 2.412789722222222,
              "2025-10-20": 105.33570527777778,
              "2025-10-22": 337.6833766666667,
              "2025-10-24": 339.10558499999996,
              "2025-10-27": 8.042834444444445,
              "2025-10-28": 141.32116444444443,
              "2025-10-29": 330.80124388888885,
              "2025-10-30": 514.3067380555556,
              "2025-10-31": 107.55078833333333,
              "2025-11-03": 0.5973827777777778,
              "2025-11-05": 153.21618666666666,
              "2025-11-11": 96.83750972222221,
              "2025-11-13": 218.1298088888889,
              "2025-11-20": 171.57087527777776,
              "2025-11-21": 1.096176111111111,
              "2025-11-23": 25.916546666666665,
              "2025-11-25": 752.8860755555555,
              "2025-11-27": 1.0339502777777778,
              "2025-12-03": 111.15808833333334,
              "2025-12-04": 1091.0758658333334,
              "2025-12-05": 183.54847583333336,
              "2025-12-09": 283.2246375,
              "2025-12-10": 25.965845555555553,
              "2025-12-11": 266.7176538888889,
              "2025-12-15": 51.17185611111111,
              "2025-12-16": 45.01687694444445,
              "2025-12-17": 45.44326861111111,
              "2025-12-22": 50.482947777777774,
              "2025-12-26": 51.998439999999995,
              "2025-12-29": 967.7605972222221,
              "2025-12-30": 17.349172777777778,
              "2026-01-05": 1656.4645858333333,
              "2026-01-09": 26.049014444444445,
              "2026-01-12": 8.286105555555556,
              "2026-01-23": 358.67445833333335,
              "2026-01-27": 130.7534677777778,
              "2026-02-06": 1583.4092191666668,
              "2026-02-09": 61.66920388888889,
              "2026-02-10": 4293.263790277779,
              "2026-02-11": 167.0150825,
              "2026-02-13": 635.2593591666667,
              "2026-02-18": 65.75032611111111,
              "2026-02-19": 6811.063728888889,
              "2026-02-20": 2.180337777777778,
              "2026-02-21": 16.466997222222226,
              "2026-02-23": 8.038527222222223,
              "2026-02-28": 70.0758975,
              "2026-03-10": 8.926432777777778,
              "2026-03-17": 69.39460055555556,
              "2026-03-18": 1296.918020277778,
              "2026-03-19": 0.8520063888888889,
              "2026-03-20": 17.907520555555557,
              "2026-03-26": 4337.062097222221,
              "2026-03-27": 0.49905444444444447,
              "2026-03-31": 1.7623358333333332,
              "2026-04-01": 9.407725,
              "2026-04-02": 17.542678055555555,
              "2026-04-06": 2.788527222222222,
              "2026-04-07": 12.169107777777777,
              "2026-04-10": 3.948923888888889,
              "2026-04-13": 0.5661844444444445,
              "2026-04-14": 2.574705,
              "2026-04-20": 0.14621222222222224,
              "2026-04-21": 1.0706463888888889,
              "2026-04-22": 0.08684416666666667,
              "2026-04-23": 1.7335997222222221,
              "2026-04-27": 1.010178611111111,
              "2026-04-30": 1.0222505555555554,
              "2026-05-04": 4.5570305555555555,
              "2026-05-05": 0.1179363888888889,
              "2026-05-06": 2.579900277777778,
              "2026-05-07": 45.40945472222222,
              "2026-05-11": 13.302378055555556,
              "2026-05-15": 0.32165222222222223,
              "2026-05-21": 1.05566,
              "2026-05-25": 1.50434,
              "2026-05-26": 0.17968277777777777,
              "2026-05-28": 4.1281083333333335,
              "2026-05-29": 2.7160741666666666,
              "2026-06-01": 4.028912222222222,
              "2026-06-08": 1.6222916666666667
            },
            "time_count_per_day": {
              "2025-10-07": 2,
              "2025-10-09": 1,
              "2025-10-13": 1,
              "2025-10-14": 3,
              "2025-10-15": 5,
              "2025-10-17": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-29": 1,
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-11-03": 1,
              "2025-11-05": 3,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-11-20": 2,
              "2025-11-21": 1,
              "2025-11-23": 1,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-12-03": 3,
              "2025-12-04": 3,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-11": 2,
              "2025-12-15": 3,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-22": 1,
              "2025-12-26": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-05": 3,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-23": 3,
              "2026-01-27": 3,
              "2026-02-06": 6,
              "2026-02-09": 1,
              "2026-02-10": 10,
              "2026-02-11": 1,
              "2026-02-13": 5,
              "2026-02-18": 3,
              "2026-02-19": 10,
              "2026-02-20": 1,
              "2026-02-21": 12,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-10": 5,
              "2026-03-17": 3,
              "2026-03-18": 5,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-26": 10,
              "2026-03-27": 1,
              "2026-03-31": 2,
              "2026-04-01": 4,
              "2026-04-02": 6,
              "2026-04-06": 1,
              "2026-04-07": 5,
              "2026-04-10": 3,
              "2026-04-13": 2,
              "2026-04-14": 4,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 3,
              "2026-04-27": 1,
              "2026-04-30": 1,
              "2026-05-04": 4,
              "2026-05-05": 1,
              "2026-05-06": 2,
              "2026-05-07": 3,
              "2026-05-11": 7,
              "2026-05-15": 1,
              "2026-05-21": 1,
              "2026-05-25": 3,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-05-29": 2,
              "2026-06-01": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 65,
              "time_distribution": {
                "0-2h": 65,
                "2-4h": 22,
                "4-6h": 2,
                "8-10h": 1,
                "10-12h": 2,
                "12-14h": 1,
                "20-22h": 1,
                "28-30h": 1,
                "44-46h": 2
              },
              "tickets_count": 97,
              "tickets_per_day": {
                "2025-10-15": 2,
                "2025-11-03": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-03": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-12": 1,
                "2026-02-13": 4,
                "2026-02-20": 1,
                "2026-02-21": 9,
                "2026-03-10": 5,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-27": 1,
                "2026-03-31": 2,
                "2026-04-01": 4,
                "2026-04-02": 6,
                "2026-04-06": 1,
                "2026-04-07": 5,
                "2026-04-10": 3,
                "2026-04-13": 2,
                "2026-04-14": 4,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 3,
                "2026-04-27": 1,
                "2026-04-30": 1,
                "2026-05-04": 4,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 3,
                "2026-05-11": 7,
                "2026-05-15": 1,
                "2026-05-21": 1,
                "2026-05-25": 3,
                "2026-05-26": 1,
                "2026-05-28": 1,
                "2026-05-29": 2,
                "2026-06-01": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-15": 44.629129444444445,
                "2025-11-03": 0.5973827777777778,
                "2025-11-21": 1.096176111111111,
                "2025-11-27": 1.0339502777777778,
                "2025-12-03": 3.5444155555555557,
                "2025-12-15": 0.230055,
                "2025-12-17": 45.44326861111111,
                "2026-01-12": 8.286105555555556,
                "2026-02-13": 11.328621944444444,
                "2026-02-20": 2.180337777777778,
                "2026-02-21": 6.077696944444446,
                "2026-03-10": 8.926432777777778,
                "2026-03-17": 31.968325555555555,
                "2026-03-18": 0.6422277777777777,
                "2026-03-19": 0.8520063888888889,
                "2026-03-27": 0.49905444444444447,
                "2026-03-31": 1.7623358333333332,
                "2026-04-01": 9.407725,
                "2026-04-02": 17.542678055555555,
                "2026-04-06": 2.788527222222222,
                "2026-04-07": 12.169107777777777,
                "2026-04-10": 3.948923888888889,
                "2026-04-13": 0.5661844444444445,
                "2026-04-14": 2.574705,
                "2026-04-20": 0.14621222222222224,
                "2026-04-21": 1.0706463888888889,
                "2026-04-22": 0.08684416666666667,
                "2026-04-23": 1.7335997222222221,
                "2026-04-27": 1.010178611111111,
                "2026-04-30": 1.0222505555555554,
                "2026-05-04": 4.5570305555555555,
                "2026-05-05": 0.1179363888888889,
                "2026-05-06": 2.579900277777778,
                "2026-05-07": 45.40945472222222,
                "2026-05-11": 13.302378055555556,
                "2026-05-15": 0.32165222222222223,
                "2026-05-21": 1.05566,
                "2026-05-25": 1.50434,
                "2026-05-26": 0.17968277777777777,
                "2026-05-28": 4.1281083333333335,
                "2026-05-29": 2.7160741666666666,
                "2026-06-01": 4.028912222222222,
                "2026-06-08": 1.6222916666666667
              },
              "time_count_per_day": {
                "2025-10-15": 2,
                "2025-11-03": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-03": 1,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-12": 1,
                "2026-02-13": 4,
                "2026-02-20": 1,
                "2026-02-21": 9,
                "2026-03-10": 5,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-27": 1,
                "2026-03-31": 2,
                "2026-04-01": 4,
                "2026-04-02": 6,
                "2026-04-06": 1,
                "2026-04-07": 5,
                "2026-04-10": 3,
                "2026-04-13": 2,
                "2026-04-14": 4,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 3,
                "2026-04-27": 1,
                "2026-04-30": 1,
                "2026-05-04": 4,
                "2026-05-05": 1,
                "2026-05-06": 2,
                "2026-05-07": 3,
                "2026-05-11": 7,
                "2026-05-15": 1,
                "2026-05-21": 1,
                "2026-05-25": 3,
                "2026-05-26": 1,
                "2026-05-28": 1,
                "2026-05-29": 2,
                "2026-06-01": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 314.87,
              "mode_time_hours": 21.0,
              "mode_frequency": 3,
              "time_distribution": {
                "16-18h": 1,
                "20-22h": 3,
                "150-152h": 2,
                "192-194h": 1,
                "336-338h": 2,
                "338-340h": 1,
                "478-480h": 2,
                "504-506h": 1,
                "514-516h": 1,
                "1152-1154h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-10-30": 1,
                "2025-12-30": 1,
                "2026-02-06": 1,
                "2026-02-10": 8,
                "2026-02-18": 2
              },
              "time_per_day": {
                "2025-10-22": 337.6833766666667,
                "2025-10-24": 339.10558499999996,
                "2025-10-30": 514.3067380555556,
                "2025-12-30": 17.349172777777778,
                "2026-02-06": 192.3283072222222,
                "2026-02-10": 3278.3625258333336,
                "2026-02-18": 43.85021305555556
              },
              "time_count_per_day": {
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-10-30": 1,
                "2025-12-30": 1,
                "2026-02-06": 1,
                "2026-02-10": 8,
                "2026-02-18": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 185.86,
              "mode_time_hours": 51.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 5,
                "6-8h": 1,
                "8-10h": 2,
                "16-18h": 2,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 4,
                "26-28h": 1,
                "32-34h": 1,
                "36-38h": 1,
                "48-50h": 1,
                "50-52h": 6,
                "60-62h": 2,
                "70-72h": 1,
                "94-96h": 1,
                "96-98h": 1,
                "104-106h": 2,
                "106-108h": 1,
                "118-120h": 3,
                "122-124h": 2,
                "126-128h": 1,
                "134-136h": 3,
                "140-142h": 3,
                "164-166h": 2,
                "166-168h": 1,
                "182-184h": 1,
                "192-194h": 1,
                "218-220h": 1,
                "220-222h": 1,
                "282-284h": 1,
                "330-332h": 1,
                "362-364h": 3,
                "364-366h": 1,
                "372-374h": 2,
                "380-382h": 2,
                "392-394h": 1,
                "414-416h": 1,
                "502-504h": 1,
                "504-506h": 1,
                "508-510h": 1,
                "524-526h": 1,
                "582-584h": 1,
                "598-600h": 1,
                "630-632h": 1,
                "700-702h": 1,
                "752-754h": 1
              },
              "tickets_count": 75,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-14": 3,
                "2025-10-15": 3,
                "2025-10-17": 1,
                "2025-10-20": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2025-11-05": 3,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-20": 2,
                "2025-11-23": 1,
                "2025-11-25": 1,
                "2025-12-03": 2,
                "2025-12-04": 3,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-09": 1,
                "2026-01-23": 3,
                "2026-01-27": 3,
                "2026-02-06": 5,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-11": 1,
                "2026-02-18": 1,
                "2026-02-21": 3,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-20": 1,
                "2026-03-26": 10
              },
              "time_per_day": {
                "2025-10-07": 111.38935944444444,
                "2025-10-09": 32.56438611111111,
                "2025-10-13": 134.651725,
                "2025-10-14": 74.17587472222223,
                "2025-10-15": 456.7793022222222,
                "2025-10-17": 2.412789722222222,
                "2025-10-20": 105.33570527777778,
                "2025-10-27": 8.042834444444445,
                "2025-10-28": 141.32116444444443,
                "2025-10-29": 330.80124388888885,
                "2025-10-31": 107.55078833333333,
                "2025-11-05": 153.21618666666666,
                "2025-11-11": 96.83750972222221,
                "2025-11-13": 218.1298088888889,
                "2025-11-20": 171.57087527777776,
                "2025-11-23": 25.916546666666665,
                "2025-11-25": 752.8860755555555,
                "2025-12-03": 107.61367277777778,
                "2025-12-04": 1091.0758658333334,
                "2025-12-05": 183.54847583333336,
                "2025-12-09": 283.2246375,
                "2025-12-10": 25.965845555555553,
                "2025-12-11": 221.54820138888888,
                "2025-12-15": 50.94180111111111,
                "2025-12-22": 50.482947777777774,
                "2025-12-26": 51.998439999999995,
                "2026-01-09": 26.049014444444445,
                "2026-01-23": 358.67445833333335,
                "2026-01-27": 130.7534677777778,
                "2026-02-06": 1391.0809119444446,
                "2026-02-09": 61.66920388888889,
                "2026-02-10": 1014.9012644444445,
                "2026-02-11": 167.0150825,
                "2026-02-18": 21.900113055555558,
                "2026-02-21": 10.389300277777778,
                "2026-02-23": 8.038527222222223,
                "2026-02-28": 70.0758975,
                "2026-03-17": 37.426275,
                "2026-03-18": 1296.2757925,
                "2026-03-20": 17.907520555555557,
                "2026-03-26": 4337.062097222221
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-10-09": 1,
                "2025-10-13": 1,
                "2025-10-14": 3,
                "2025-10-15": 3,
                "2025-10-17": 1,
                "2025-10-20": 1,
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2025-11-05": 3,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-11-20": 2,
                "2025-11-23": 1,
                "2025-11-25": 1,
                "2025-12-03": 2,
                "2025-12-04": 3,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2025-12-26": 1,
                "2026-01-09": 1,
                "2026-01-23": 3,
                "2026-01-27": 3,
                "2026-02-06": 5,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-11": 1,
                "2026-02-18": 1,
                "2026-02-21": 3,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-20": 1,
                "2026-03-26": 10
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 597.02,
              "mode_time_hours": 553.0,
              "mode_frequency": 3,
              "time_distribution": {
                "44-46h": 2,
                "206-208h": 1,
                "354-356h": 1,
                "374-376h": 1,
                "550-552h": 1,
                "552-554h": 3,
                "622-624h": 1,
                "672-674h": 1,
                "682-684h": 1,
                "692-694h": 1,
                "966-968h": 1,
                "1020-1022h": 1,
                "1124-1126h": 2
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-29": 1,
                "2026-01-05": 3,
                "2026-02-13": 1,
                "2026-02-19": 10
              },
              "time_per_day": {
                "2025-12-11": 45.169452500000006,
                "2025-12-16": 45.01687694444445,
                "2025-12-29": 967.7605972222221,
                "2026-01-05": 1656.4645858333333,
                "2026-02-13": 623.9307372222222,
                "2026-02-19": 6811.063728888889
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2025-12-16": 1,
                "2025-12-29": 1,
                "2026-01-05": 3,
                "2026-02-13": 1,
                "2026-02-19": 10
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 25,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-31": 1,
              "2026-04-14": 1,
              "2026-04-15": 2,
              "2026-04-27": 2,
              "2026-05-04": 4,
              "2026-05-05": 2,
              "2026-05-06": 4,
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-20": 2,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 23,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-31": 1,
                "2026-04-14": 1,
                "2026-04-15": 2,
                "2026-04-27": 2,
                "2026-05-04": 4,
                "2026-05-05": 2,
                "2026-05-06": 4,
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-20": 2,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-03-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_127": {
      "overall": {
        "avg_time_hours": 271.1,
        "mode_time_hours": 271.0,
        "mode_frequency": 1,
        "time_distribution": {
          "270-272h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-14": 271.0990491666667
        },
        "time_count_per_day": {
          "2025-10-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 271.1,
          "mode_time_hours": 271.0,
          "mode_frequency": 1,
          "time_distribution": {
            "270-272h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-14": 271.0990491666667
          },
          "time_count_per_day": {
            "2025-10-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 271.1,
            "mode_time_hours": 271.0,
            "mode_frequency": 1,
            "time_distribution": {
              "270-272h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-14": 1
            },
            "time_per_day": {
              "2025-10-14": 271.0990491666667
            },
            "time_count_per_day": {
              "2025-10-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 271.1,
              "mode_time_hours": 271.0,
              "mode_frequency": 1,
              "time_distribution": {
                "270-272h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-14": 1
              },
              "time_per_day": {
                "2025-10-14": 271.0990491666667
              },
              "time_count_per_day": {
                "2025-10-14": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_130": {
      "overall": {
        "avg_time_hours": 0.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-03": 1,
          "2025-11-25": 1
        },
        "time_per_day": {
          "2025-10-03": 0.021263888888888888,
          "2025-11-25": 0.1776575
        },
        "time_count_per_day": {
          "2025-10-03": 1,
          "2025-11-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.1,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-03": 1,
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-10-03": 0.021263888888888888,
            "2025-11-25": 0.1776575
          },
          "time_count_per_day": {
            "2025-10-03": 1,
            "2025-11-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-03": 1,
              "2025-11-25": 1
            },
            "time_per_day": {
              "2025-10-03": 0.021263888888888888,
              "2025-11-25": 0.1776575
            },
            "time_count_per_day": {
              "2025-10-03": 1,
              "2025-11-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.1,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-03": 1,
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-10-03": 0.021263888888888888,
                "2025-11-25": 0.1776575
              },
              "time_count_per_day": {
                "2025-10-03": 1,
                "2025-11-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_131": {
      "overall": {
        "avg_time_hours": 208.89,
        "mode_time_hours": 7.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 1,
          "6-8h": 4,
          "8-10h": 1,
          "12-14h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "40-42h": 2,
          "72-74h": 1,
          "76-78h": 1,
          "94-96h": 1,
          "120-122h": 1,
          "142-144h": 1,
          "160-162h": 1,
          "206-208h": 1,
          "324-326h": 1,
          "372-374h": 1,
          "434-436h": 1,
          "818-820h": 1,
          "822-824h": 1,
          "1002-1004h": 2
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-10-09": 1,
          "2025-10-29": 1,
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-13": 2,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-26": 1,
          "2026-01-06": 1,
          "2026-01-13": 1,
          "2026-01-28": 1,
          "2026-02-10": 2,
          "2026-02-24": 1,
          "2026-03-10": 1,
          "2026-03-11": 2,
          "2026-03-24": 1,
          "2026-03-30": 6,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-05-06": 1,
          "2026-05-18": 2
        },
        "time_per_day": {
          "2025-10-09": 142.99027583333333,
          "2025-10-29": 76.81895083333333,
          "2025-11-04": 94.47081694444444,
          "2025-11-06": 325.7048338888889,
          "2025-11-10": 0.8231030555555555,
          "2025-11-13": 28.457285277777775,
          "2025-12-11": 21.58586361111111,
          "2025-12-15": 823.1625672222223,
          "2025-12-26": 5.077845,
          "2026-01-06": 160.38667833333335,
          "2026-01-13": 13.935234444444443,
          "2026-01-28": 7.514184166666666,
          "2026-02-10": 2005.6145472222224,
          "2026-03-10": 72.07772250000001,
          "2026-03-11": 1191.7326008333334,
          "2026-03-24": 435.9730880555556,
          "2026-03-30": 31.668554722222225,
          "2026-04-16": 0.5926488888888889,
          "2026-04-22": 121.31004027777779,
          "2026-05-06": 206.80916722222221,
          "2026-05-18": 82.34101527777779
        },
        "time_count_per_day": {
          "2025-10-09": 1,
          "2025-10-29": 1,
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-13": 2,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-26": 1,
          "2026-01-06": 1,
          "2026-01-13": 1,
          "2026-01-28": 1,
          "2026-02-10": 2,
          "2026-03-10": 1,
          "2026-03-11": 2,
          "2026-03-24": 1,
          "2026-03-30": 4,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-05-06": 1,
          "2026-05-18": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 259.45,
          "mode_time_hours": 7.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "6-8h": 3,
            "8-10h": 1,
            "20-22h": 1,
            "40-42h": 2,
            "72-74h": 1,
            "76-78h": 1,
            "94-96h": 1,
            "120-122h": 1,
            "160-162h": 1,
            "324-326h": 1,
            "372-374h": 1,
            "434-436h": 1,
            "818-820h": 1,
            "822-824h": 1,
            "1002-1004h": 2
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-06": 1,
            "2026-02-10": 2,
            "2026-02-24": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-24": 1,
            "2026-03-30": 4,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-05-18": 2
          },
          "time_per_day": {
            "2025-10-29": 76.81895083333333,
            "2025-11-04": 94.47081694444444,
            "2025-11-06": 325.7048338888889,
            "2025-12-11": 21.58586361111111,
            "2025-12-15": 823.1625672222223,
            "2025-12-26": 5.077845,
            "2026-01-06": 160.38667833333335,
            "2026-02-10": 2005.6145472222224,
            "2026-03-10": 72.07772250000001,
            "2026-03-11": 1191.7326008333334,
            "2026-03-24": 435.9730880555556,
            "2026-03-30": 31.668554722222225,
            "2026-04-16": 0.5926488888888889,
            "2026-04-22": 121.31004027777779,
            "2026-05-18": 82.34101527777779
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-06": 1,
            "2026-02-10": 2,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-24": 1,
            "2026-03-30": 4,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-05-18": 2
          }
        },
        "P3": {
          "avg_time_hours": 57.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "6-8h": 1,
            "12-14h": 1,
            "26-28h": 1,
            "142-144h": 1,
            "206-208h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-11-10": 1,
            "2025-11-13": 2,
            "2026-01-13": 1,
            "2026-01-28": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2025-10-09": 142.99027583333333,
            "2025-11-10": 0.8231030555555555,
            "2025-11-13": 28.457285277777775,
            "2026-01-13": 13.935234444444443,
            "2026-01-28": 7.514184166666666,
            "2026-05-06": 206.80916722222221
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-11-10": 1,
            "2025-11-13": 2,
            "2026-01-13": 1,
            "2026-01-28": 1,
            "2026-05-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-30": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 208.89,
            "mode_time_hours": 7.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 1,
              "6-8h": 4,
              "8-10h": 1,
              "12-14h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "40-42h": 2,
              "72-74h": 1,
              "76-78h": 1,
              "94-96h": 1,
              "120-122h": 1,
              "142-144h": 1,
              "160-162h": 1,
              "206-208h": 1,
              "324-326h": 1,
              "372-374h": 1,
              "434-436h": 1,
              "818-820h": 1,
              "822-824h": 1,
              "1002-1004h": 2
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-10-09": 1,
              "2025-10-29": 1,
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-13": 2,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-26": 1,
              "2026-01-06": 1,
              "2026-01-13": 1,
              "2026-01-28": 1,
              "2026-02-10": 2,
              "2026-03-10": 1,
              "2026-03-11": 2,
              "2026-03-24": 1,
              "2026-03-30": 4,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-05-06": 1,
              "2026-05-18": 2
            },
            "time_per_day": {
              "2025-10-09": 142.99027583333333,
              "2025-10-29": 76.81895083333333,
              "2025-11-04": 94.47081694444444,
              "2025-11-06": 325.7048338888889,
              "2025-11-10": 0.8231030555555555,
              "2025-11-13": 28.457285277777775,
              "2025-12-11": 21.58586361111111,
              "2025-12-15": 823.1625672222223,
              "2025-12-26": 5.077845,
              "2026-01-06": 160.38667833333335,
              "2026-01-13": 13.935234444444443,
              "2026-01-28": 7.514184166666666,
              "2026-02-10": 2005.6145472222224,
              "2026-03-10": 72.07772250000001,
              "2026-03-11": 1191.7326008333334,
              "2026-03-24": 435.9730880555556,
              "2026-03-30": 31.668554722222225,
              "2026-04-16": 0.5926488888888889,
              "2026-04-22": 121.31004027777779,
              "2026-05-06": 206.80916722222221,
              "2026-05-18": 82.34101527777779
            },
            "time_count_per_day": {
              "2025-10-09": 1,
              "2025-10-29": 1,
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-13": 2,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-26": 1,
              "2026-01-06": 1,
              "2026-01-13": 1,
              "2026-01-28": 1,
              "2026-02-10": 2,
              "2026-03-10": 1,
              "2026-03-11": 2,
              "2026-03-24": 1,
              "2026-03-30": 4,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-05-06": 1,
              "2026-05-18": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 259.45,
              "mode_time_hours": 7.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "6-8h": 3,
                "8-10h": 1,
                "20-22h": 1,
                "40-42h": 2,
                "72-74h": 1,
                "76-78h": 1,
                "94-96h": 1,
                "120-122h": 1,
                "160-162h": 1,
                "324-326h": 1,
                "372-374h": 1,
                "434-436h": 1,
                "818-820h": 1,
                "822-824h": 1,
                "1002-1004h": 2
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-06": 1,
                "2026-02-10": 2,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-24": 1,
                "2026-03-30": 4,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-05-18": 2
              },
              "time_per_day": {
                "2025-10-29": 76.81895083333333,
                "2025-11-04": 94.47081694444444,
                "2025-11-06": 325.7048338888889,
                "2025-12-11": 21.58586361111111,
                "2025-12-15": 823.1625672222223,
                "2025-12-26": 5.077845,
                "2026-01-06": 160.38667833333335,
                "2026-02-10": 2005.6145472222224,
                "2026-03-10": 72.07772250000001,
                "2026-03-11": 1191.7326008333334,
                "2026-03-24": 435.9730880555556,
                "2026-03-30": 31.668554722222225,
                "2026-04-16": 0.5926488888888889,
                "2026-04-22": 121.31004027777779,
                "2026-05-18": 82.34101527777779
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-06": 1,
                "2026-02-10": 2,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-24": 1,
                "2026-03-30": 4,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-05-18": 2
              }
            },
            "P3": {
              "avg_time_hours": 57.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "6-8h": 1,
                "12-14h": 1,
                "26-28h": 1,
                "142-144h": 1,
                "206-208h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-11-10": 1,
                "2025-11-13": 2,
                "2026-01-13": 1,
                "2026-01-28": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2025-10-09": 142.99027583333333,
                "2025-11-10": 0.8231030555555555,
                "2025-11-13": 28.457285277777775,
                "2026-01-13": 13.935234444444443,
                "2026-01-28": 7.514184166666666,
                "2026-05-06": 206.80916722222221
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-11-10": 1,
                "2025-11-13": 2,
                "2026-01-13": 1,
                "2026-01-28": 1,
                "2026-05-06": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-30": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-30": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_134": {
      "overall": {
        "avg_time_hours": 48.62,
        "mode_time_hours": 75.0,
        "mode_frequency": 1,
        "time_distribution": {
          "22-24h": 1,
          "74-76h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-28": 1
        },
        "time_per_day": {
          "2025-10-06": 74.0905563888889,
          "2025-10-28": 23.157408333333333
        },
        "time_count_per_day": {
          "2025-10-06": 1,
          "2025-10-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.62,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "74-76h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-06": 74.0905563888889,
            "2025-10-28": 23.157408333333333
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.62,
            "mode_time_hours": 75.0,
            "mode_frequency": 1,
            "time_distribution": {
              "22-24h": 1,
              "74-76h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2025-10-28": 1
            },
            "time_per_day": {
              "2025-10-06": 74.0905563888889,
              "2025-10-28": 23.157408333333333
            },
            "time_count_per_day": {
              "2025-10-06": 1,
              "2025-10-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.62,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "74-76h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-06": 74.0905563888889,
                "2025-10-28": 23.157408333333333
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_135": {
      "overall": {
        "avg_time_hours": 212.55,
        "mode_time_hours": 55.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 2,
          "4-6h": 2,
          "16-18h": 1,
          "30-32h": 3,
          "34-36h": 1,
          "36-38h": 1,
          "54-56h": 5,
          "66-68h": 1,
          "72-74h": 1,
          "116-118h": 1,
          "120-122h": 1,
          "126-128h": 1,
          "240-242h": 1,
          "380-382h": 1,
          "560-562h": 1,
          "960-962h": 1,
          "984-986h": 1,
          "1844-1846h": 1
        },
        "tickets_count": 29,
        "tickets_per_day": {
          "2025-10-13": 2,
          "2025-12-04": 2,
          "2025-12-11": 1,
          "2025-12-13": 1,
          "2026-02-10": 2,
          "2026-02-16": 1,
          "2026-02-18": 6,
          "2026-02-19": 1,
          "2026-02-22": 1,
          "2026-02-25": 1,
          "2026-03-07": 1,
          "2026-03-25": 1,
          "2026-03-30": 5,
          "2026-03-31": 1,
          "2026-04-10": 1,
          "2026-04-22": 1,
          "2026-05-19": 1
        },
        "time_per_day": {
          "2025-10-13": 363.47334805555556,
          "2025-12-04": 103.64662999999999,
          "2025-12-11": 66.0010188888889,
          "2025-12-13": 116.13525083333333,
          "2026-02-10": 8.840045277777778,
          "2026-02-18": 3372.123252222222,
          "2026-02-19": 2.7640547222222223,
          "2026-02-22": 36.02074583333333,
          "2026-02-25": 0.24095333333333332,
          "2026-03-07": 34.34508916666667,
          "2026-03-25": 961.3310805555556,
          "2026-03-30": 273.21200361111113,
          "2026-03-31": 30.302936666666668,
          "2026-04-10": 17.96774138888889,
          "2026-04-22": 561.3829797222222,
          "2026-05-19": 3.719911111111111
        },
        "time_count_per_day": {
          "2025-10-13": 2,
          "2025-12-04": 2,
          "2025-12-11": 1,
          "2025-12-13": 1,
          "2026-02-10": 2,
          "2026-02-18": 6,
          "2026-02-19": 1,
          "2026-02-22": 1,
          "2026-02-25": 1,
          "2026-03-07": 1,
          "2026-03-25": 1,
          "2026-03-30": 5,
          "2026-03-31": 1,
          "2026-04-10": 1,
          "2026-04-22": 1,
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 130.28,
          "mode_time_hours": 55.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "16-18h": 1,
            "30-32h": 2,
            "34-36h": 1,
            "36-38h": 1,
            "54-56h": 5,
            "66-68h": 1,
            "72-74h": 1,
            "116-118h": 1,
            "120-122h": 1,
            "380-382h": 1,
            "560-562h": 1,
            "984-986h": 1
          },
          "tickets_count": 21,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-13": 1,
            "2026-02-18": 3,
            "2026-02-19": 1,
            "2026-02-22": 1,
            "2026-02-25": 1,
            "2026-03-07": 1,
            "2026-03-30": 5,
            "2026-03-31": 1,
            "2026-04-10": 1,
            "2026-04-22": 1,
            "2026-05-19": 1
          },
          "time_per_day": {
            "2025-10-13": 121.71255222222223,
            "2025-12-04": 103.64662999999999,
            "2025-12-11": 66.0010188888889,
            "2025-12-13": 116.13525083333333,
            "2026-02-18": 1368.380181388889,
            "2026-02-19": 2.7640547222222223,
            "2026-02-22": 36.02074583333333,
            "2026-02-25": 0.24095333333333332,
            "2026-03-07": 34.34508916666667,
            "2026-03-30": 273.21200361111113,
            "2026-03-31": 30.302936666666668,
            "2026-04-10": 17.96774138888889,
            "2026-04-22": 561.3829797222222,
            "2026-05-19": 3.719911111111111
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-12-04": 2,
            "2025-12-11": 1,
            "2025-12-13": 1,
            "2026-02-18": 3,
            "2026-02-19": 1,
            "2026-02-22": 1,
            "2026-02-25": 1,
            "2026-03-07": 1,
            "2026-03-30": 5,
            "2026-03-31": 1,
            "2026-04-10": 1,
            "2026-04-22": 1,
            "2026-05-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 459.38,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "30-32h": 1,
            "126-128h": 1,
            "240-242h": 1,
            "960-962h": 1,
            "1844-1846h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2026-02-10": 2,
            "2026-02-18": 3,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-10-13": 241.76079583333333,
            "2026-02-10": 8.840045277777778,
            "2026-02-18": 2003.7430708333334,
            "2026-03-25": 961.3310805555556
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2026-02-10": 2,
            "2026-02-18": 3,
            "2026-03-25": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-16": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 212.55,
            "mode_time_hours": 55.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 2,
              "4-6h": 2,
              "16-18h": 1,
              "30-32h": 3,
              "34-36h": 1,
              "36-38h": 1,
              "54-56h": 5,
              "66-68h": 1,
              "72-74h": 1,
              "116-118h": 1,
              "120-122h": 1,
              "126-128h": 1,
              "240-242h": 1,
              "380-382h": 1,
              "560-562h": 1,
              "960-962h": 1,
              "984-986h": 1,
              "1844-1846h": 1
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-10-13": 2,
              "2025-12-04": 2,
              "2025-12-11": 1,
              "2025-12-13": 1,
              "2026-02-10": 2,
              "2026-02-18": 6,
              "2026-02-19": 1,
              "2026-02-22": 1,
              "2026-02-25": 1,
              "2026-03-07": 1,
              "2026-03-25": 1,
              "2026-03-30": 5,
              "2026-03-31": 1,
              "2026-04-10": 1,
              "2026-04-22": 1,
              "2026-05-19": 1
            },
            "time_per_day": {
              "2025-10-13": 363.47334805555556,
              "2025-12-04": 103.64662999999999,
              "2025-12-11": 66.0010188888889,
              "2025-12-13": 116.13525083333333,
              "2026-02-10": 8.840045277777778,
              "2026-02-18": 3372.123252222222,
              "2026-02-19": 2.7640547222222223,
              "2026-02-22": 36.02074583333333,
              "2026-02-25": 0.24095333333333332,
              "2026-03-07": 34.34508916666667,
              "2026-03-25": 961.3310805555556,
              "2026-03-30": 273.21200361111113,
              "2026-03-31": 30.302936666666668,
              "2026-04-10": 17.96774138888889,
              "2026-04-22": 561.3829797222222,
              "2026-05-19": 3.719911111111111
            },
            "time_count_per_day": {
              "2025-10-13": 2,
              "2025-12-04": 2,
              "2025-12-11": 1,
              "2025-12-13": 1,
              "2026-02-10": 2,
              "2026-02-18": 6,
              "2026-02-19": 1,
              "2026-02-22": 1,
              "2026-02-25": 1,
              "2026-03-07": 1,
              "2026-03-25": 1,
              "2026-03-30": 5,
              "2026-03-31": 1,
              "2026-04-10": 1,
              "2026-04-22": 1,
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 130.28,
              "mode_time_hours": 55.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "16-18h": 1,
                "30-32h": 2,
                "34-36h": 1,
                "36-38h": 1,
                "54-56h": 5,
                "66-68h": 1,
                "72-74h": 1,
                "116-118h": 1,
                "120-122h": 1,
                "380-382h": 1,
                "560-562h": 1,
                "984-986h": 1
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-13": 1,
                "2026-02-18": 3,
                "2026-02-19": 1,
                "2026-02-22": 1,
                "2026-02-25": 1,
                "2026-03-07": 1,
                "2026-03-30": 5,
                "2026-03-31": 1,
                "2026-04-10": 1,
                "2026-04-22": 1,
                "2026-05-19": 1
              },
              "time_per_day": {
                "2025-10-13": 121.71255222222223,
                "2025-12-04": 103.64662999999999,
                "2025-12-11": 66.0010188888889,
                "2025-12-13": 116.13525083333333,
                "2026-02-18": 1368.380181388889,
                "2026-02-19": 2.7640547222222223,
                "2026-02-22": 36.02074583333333,
                "2026-02-25": 0.24095333333333332,
                "2026-03-07": 34.34508916666667,
                "2026-03-30": 273.21200361111113,
                "2026-03-31": 30.302936666666668,
                "2026-04-10": 17.96774138888889,
                "2026-04-22": 561.3829797222222,
                "2026-05-19": 3.719911111111111
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-12-04": 2,
                "2025-12-11": 1,
                "2025-12-13": 1,
                "2026-02-18": 3,
                "2026-02-19": 1,
                "2026-02-22": 1,
                "2026-02-25": 1,
                "2026-03-07": 1,
                "2026-03-30": 5,
                "2026-03-31": 1,
                "2026-04-10": 1,
                "2026-04-22": 1,
                "2026-05-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 459.38,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "30-32h": 1,
                "126-128h": 1,
                "240-242h": 1,
                "960-962h": 1,
                "1844-1846h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2026-02-10": 2,
                "2026-02-18": 3,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-10-13": 241.76079583333333,
                "2026-02-10": 8.840045277777778,
                "2026-02-18": 2003.7430708333334,
                "2026-03-25": 961.3310805555556
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2026-02-10": 2,
                "2026-02-18": 3,
                "2026-03-25": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_136": {
      "overall": {
        "avg_time_hours": 95.51,
        "mode_time_hours": 1.0,
        "mode_frequency": 11,
        "time_distribution": {
          "0-2h": 11,
          "2-4h": 1,
          "8-10h": 1,
          "10-12h": 1,
          "28-30h": 1,
          "36-38h": 1,
          "60-62h": 1,
          "70-72h": 1,
          "240-242h": 2,
          "294-296h": 1,
          "384-386h": 1,
          "450-452h": 1,
          "452-454h": 1
        },
        "tickets_count": 28,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-07": 1,
          "2025-11-03": 2,
          "2026-01-08": 4,
          "2026-01-21": 1,
          "2026-02-10": 1,
          "2026-02-16": 1,
          "2026-02-19": 2,
          "2026-02-28": 1,
          "2026-03-17": 1,
          "2026-03-18": 3,
          "2026-04-16": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-06-02": 1,
          "2026-06-03": 4,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-06": 71.0621975,
          "2025-10-07": 0.3042241666666667,
          "2025-11-03": 0.5558477777777778,
          "2026-01-08": 1.8442594444444445,
          "2026-01-21": 61.837312222222224,
          "2026-02-10": 8.174899722222221,
          "2026-02-16": 0.07145694444444445,
          "2026-02-19": 481.85112055555555,
          "2026-02-28": 294.5652122222222,
          "2026-03-17": 37.43601472222222,
          "2026-03-18": 1288.9835205555555,
          "2026-04-16": 0.8171844444444445,
          "2026-05-11": 2.520935,
          "2026-06-02": 0.6400841666666667,
          "2026-06-03": 40.58432722222222,
          "2026-06-05": 0.9856024999999999
        },
        "time_count_per_day": {
          "2025-10-06": 1,
          "2025-10-07": 1,
          "2025-11-03": 2,
          "2026-01-08": 4,
          "2026-01-21": 1,
          "2026-02-10": 1,
          "2026-02-16": 1,
          "2026-02-19": 2,
          "2026-02-28": 1,
          "2026-03-17": 1,
          "2026-03-18": 3,
          "2026-04-16": 1,
          "2026-05-11": 1,
          "2026-06-02": 1,
          "2026-06-03": 2,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.97,
          "mode_time_hours": 1.0,
          "mode_frequency": 11,
          "time_distribution": {
            "0-2h": 11,
            "2-4h": 1,
            "8-10h": 1,
            "10-12h": 1,
            "28-30h": 1,
            "70-72h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-07": 1,
            "2025-11-03": 2,
            "2026-01-08": 4,
            "2026-02-10": 1,
            "2026-02-16": 1,
            "2026-04-16": 1,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-06-02": 1,
            "2026-06-03": 4,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-06": 71.0621975,
            "2025-10-07": 0.3042241666666667,
            "2025-11-03": 0.5558477777777778,
            "2026-01-08": 1.8442594444444445,
            "2026-02-10": 8.174899722222221,
            "2026-02-16": 0.07145694444444445,
            "2026-04-16": 0.8171844444444445,
            "2026-05-11": 2.520935,
            "2026-06-02": 0.6400841666666667,
            "2026-06-03": 40.58432722222222,
            "2026-06-05": 0.9856024999999999
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-07": 1,
            "2025-11-03": 2,
            "2026-01-08": 4,
            "2026-02-10": 1,
            "2026-02-16": 1,
            "2026-04-16": 1,
            "2026-05-11": 1,
            "2026-06-02": 1,
            "2026-06-03": 2,
            "2026-06-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 280.47,
          "mode_time_hours": 61.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1,
            "60-62h": 1,
            "294-296h": 1,
            "384-386h": 1,
            "450-452h": 1,
            "452-454h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-21": 1,
            "2026-02-28": 1,
            "2026-03-17": 1,
            "2026-03-18": 3
          },
          "time_per_day": {
            "2026-01-21": 61.837312222222224,
            "2026-02-28": 294.5652122222222,
            "2026-03-17": 37.43601472222222,
            "2026-03-18": 1288.9835205555555
          },
          "time_count_per_day": {
            "2026-01-21": 1,
            "2026-02-28": 1,
            "2026-03-17": 1,
            "2026-03-18": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 240.93,
          "mode_time_hours": 241.0,
          "mode_frequency": 2,
          "time_distribution": {
            "240-242h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 481.85112055555555
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 95.51,
            "mode_time_hours": 1.0,
            "mode_frequency": 11,
            "time_distribution": {
              "0-2h": 11,
              "2-4h": 1,
              "8-10h": 1,
              "10-12h": 1,
              "28-30h": 1,
              "36-38h": 1,
              "60-62h": 1,
              "70-72h": 1,
              "240-242h": 2,
              "294-296h": 1,
              "384-386h": 1,
              "450-452h": 1,
              "452-454h": 1
            },
            "tickets_count": 24,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2025-10-07": 1,
              "2025-11-03": 2,
              "2026-01-08": 4,
              "2026-01-21": 1,
              "2026-02-10": 1,
              "2026-02-16": 1,
              "2026-02-19": 2,
              "2026-02-28": 1,
              "2026-03-17": 1,
              "2026-03-18": 3,
              "2026-04-16": 1,
              "2026-05-11": 1,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-06": 71.0621975,
              "2025-10-07": 0.3042241666666667,
              "2025-11-03": 0.5558477777777778,
              "2026-01-08": 1.8442594444444445,
              "2026-01-21": 61.837312222222224,
              "2026-02-10": 8.174899722222221,
              "2026-02-16": 0.07145694444444445,
              "2026-02-19": 481.85112055555555,
              "2026-02-28": 294.5652122222222,
              "2026-03-17": 37.43601472222222,
              "2026-03-18": 1288.9835205555555,
              "2026-04-16": 0.8171844444444445,
              "2026-05-11": 2.520935,
              "2026-06-02": 0.6400841666666667,
              "2026-06-03": 40.58432722222222,
              "2026-06-05": 0.9856024999999999
            },
            "time_count_per_day": {
              "2025-10-06": 1,
              "2025-10-07": 1,
              "2025-11-03": 2,
              "2026-01-08": 4,
              "2026-01-21": 1,
              "2026-02-10": 1,
              "2026-02-16": 1,
              "2026-02-19": 2,
              "2026-02-28": 1,
              "2026-03-17": 1,
              "2026-03-18": 3,
              "2026-04-16": 1,
              "2026-05-11": 1,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.97,
              "mode_time_hours": 1.0,
              "mode_frequency": 11,
              "time_distribution": {
                "0-2h": 11,
                "2-4h": 1,
                "8-10h": 1,
                "10-12h": 1,
                "28-30h": 1,
                "70-72h": 1
              },
              "tickets_count": 16,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-07": 1,
                "2025-11-03": 2,
                "2026-01-08": 4,
                "2026-02-10": 1,
                "2026-02-16": 1,
                "2026-04-16": 1,
                "2026-05-11": 1,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-06": 71.0621975,
                "2025-10-07": 0.3042241666666667,
                "2025-11-03": 0.5558477777777778,
                "2026-01-08": 1.8442594444444445,
                "2026-02-10": 8.174899722222221,
                "2026-02-16": 0.07145694444444445,
                "2026-04-16": 0.8171844444444445,
                "2026-05-11": 2.520935,
                "2026-06-02": 0.6400841666666667,
                "2026-06-03": 40.58432722222222,
                "2026-06-05": 0.9856024999999999
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-07": 1,
                "2025-11-03": 2,
                "2026-01-08": 4,
                "2026-02-10": 1,
                "2026-02-16": 1,
                "2026-04-16": 1,
                "2026-05-11": 1,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 280.47,
              "mode_time_hours": 61.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1,
                "60-62h": 1,
                "294-296h": 1,
                "384-386h": 1,
                "450-452h": 1,
                "452-454h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-21": 1,
                "2026-02-28": 1,
                "2026-03-17": 1,
                "2026-03-18": 3
              },
              "time_per_day": {
                "2026-01-21": 61.837312222222224,
                "2026-02-28": 294.5652122222222,
                "2026-03-17": 37.43601472222222,
                "2026-03-18": 1288.9835205555555
              },
              "time_count_per_day": {
                "2026-01-21": 1,
                "2026-02-28": 1,
                "2026-03-17": 1,
                "2026-03-18": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 240.93,
              "mode_time_hours": 241.0,
              "mode_frequency": 2,
              "time_distribution": {
                "240-242h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 481.85112055555555
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-03": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-03": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_141": {
      "overall": {
        "avg_time_hours": 153.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 35,
        "time_distribution": {
          "0-2h": 35,
          "2-4h": 5,
          "4-6h": 5,
          "6-8h": 10,
          "8-10h": 6,
          "18-20h": 2,
          "22-24h": 3,
          "24-26h": 6,
          "26-28h": 2,
          "28-30h": 1,
          "48-50h": 1,
          "52-54h": 1,
          "54-56h": 1,
          "62-64h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "80-82h": 2,
          "82-84h": 1,
          "86-88h": 1,
          "96-98h": 1,
          "98-100h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "122-124h": 1,
          "126-128h": 1,
          "130-132h": 2,
          "134-136h": 2,
          "144-146h": 1,
          "150-152h": 2,
          "164-166h": 1,
          "172-174h": 1,
          "190-192h": 1,
          "240-242h": 1,
          "248-250h": 1,
          "264-266h": 1,
          "272-274h": 1,
          "274-276h": 1,
          "288-290h": 2,
          "312-314h": 1,
          "330-332h": 2,
          "334-336h": 4,
          "356-358h": 2,
          "382-384h": 1,
          "396-398h": 1,
          "500-502h": 1,
          "502-504h": 1,
          "528-530h": 1,
          "530-532h": 1,
          "534-536h": 1,
          "546-548h": 2,
          "704-706h": 1,
          "716-718h": 1,
          "814-816h": 1,
          "1008-1010h": 2,
          "3186-3188h": 1
        },
        "tickets_count": 145,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-10-30": 2,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-12": 1,
          "2025-11-14": 5,
          "2025-11-20": 2,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-24": 1,
          "2026-01-26": 1,
          "2026-01-27": 7,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-05": 3,
          "2026-02-06": 3,
          "2026-02-10": 5,
          "2026-02-11": 1,
          "2026-02-13": 3,
          "2026-02-18": 2,
          "2026-02-19": 9,
          "2026-02-23": 3,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-03-02": 3,
          "2026-03-04": 3,
          "2026-03-05": 1,
          "2026-03-14": 5,
          "2026-03-17": 2,
          "2026-03-18": 13,
          "2026-03-19": 3,
          "2026-03-20": 1,
          "2026-03-23": 3,
          "2026-03-24": 1,
          "2026-03-25": 5,
          "2026-03-26": 1,
          "2026-03-30": 7,
          "2026-03-31": 1,
          "2026-04-06": 4,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-24": 2,
          "2026-05-02": 2,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-07": 4,
          "2026-05-09": 2,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-21": 7,
          "2026-05-25": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-10-07": 24.991370555555555,
          "2025-10-21": 99.88760138888888,
          "2025-10-23": 145.31284416666668,
          "2025-10-30": 661.7699936111111,
          "2025-11-05": 25.560861111111112,
          "2025-11-06": 191.08936027777779,
          "2025-11-10": 264.0810055555556,
          "2025-11-12": 19.474531388888888,
          "2025-11-14": 60.75149305555556,
          "2025-11-20": 262.5986097222222,
          "2025-12-02": 269.26414083333333,
          "2025-12-03": 2.4229972222222225,
          "2026-01-16": 4.449356944444444,
          "2026-01-24": 71.85979305555556,
          "2026-01-26": 4.429835277777777,
          "2026-01-27": 392.5955319444444,
          "2026-01-30": 502.9954975,
          "2026-01-31": 172.45157138888888,
          "2026-02-05": 3.590132777777778,
          "2026-02-06": 578.8522383333334,
          "2026-02-10": 1725.92002,
          "2026-02-11": 272.0731455555556,
          "2026-02-13": 134.3921875,
          "2026-02-18": 3187.2028225,
          "2026-02-19": 4615.914458055556,
          "2026-02-23": 19.969808611111112,
          "2026-02-24": 9.108730277777777,
          "2026-02-25": 0.16204694444444445,
          "2026-03-02": 184.72094194444443,
          "2026-03-04": 8.833776944444445,
          "2026-03-05": 8.009800833333333,
          "2026-03-14": 104.28295611111109,
          "2026-03-17": 350.8942675,
          "2026-03-18": 3857.1407772222224,
          "2026-03-19": 6.707669444444444,
          "2026-03-20": 0.4841461111111111,
          "2026-03-23": 64.67529222222223,
          "2026-03-24": 127.65104111111111,
          "2026-03-25": 1.5394138888888889,
          "2026-03-26": 704.0679955555555,
          "2026-03-30": 123.80624805555554,
          "2026-04-06": 6.161546388888889,
          "2026-04-20": 2.0367144444444443,
          "2026-04-21": 6.874808611111112,
          "2026-04-22": 6.704937222222223,
          "2026-04-23": 815.2972847222222,
          "2026-05-02": 1.01511,
          "2026-05-04": 60.83894722222223,
          "2026-05-05": 23.48013,
          "2026-05-07": 3.7626947222222222,
          "2026-05-09": 1.0561141666666667,
          "2026-05-12": 0.01119111111111111,
          "2026-05-18": 0.16269611111111112,
          "2026-05-21": 4.163656944444444,
          "2026-05-25": 2.639676944444444,
          "2026-06-05": 1.803790277777778
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-21": 1,
          "2025-10-23": 1,
          "2025-10-30": 2,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-12": 1,
          "2025-11-14": 5,
          "2025-11-20": 2,
          "2025-12-02": 2,
          "2025-12-03": 1,
          "2026-01-16": 1,
          "2026-01-24": 1,
          "2026-01-26": 1,
          "2026-01-27": 7,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-05": 3,
          "2026-02-06": 3,
          "2026-02-10": 5,
          "2026-02-11": 1,
          "2026-02-13": 3,
          "2026-02-18": 1,
          "2026-02-19": 9,
          "2026-02-23": 3,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-03-02": 3,
          "2026-03-04": 3,
          "2026-03-05": 1,
          "2026-03-14": 5,
          "2026-03-17": 2,
          "2026-03-18": 13,
          "2026-03-19": 3,
          "2026-03-20": 1,
          "2026-03-23": 3,
          "2026-03-24": 1,
          "2026-03-25": 5,
          "2026-03-26": 1,
          "2026-03-30": 4,
          "2026-04-06": 4,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-05-02": 2,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-07": 3,
          "2026-05-09": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-21": 4,
          "2026-05-25": 1,
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 14.06,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "22-24h": 1,
            "24-26h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2026-03-20": 1,
            "2026-05-04": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2025-11-05": 25.560861111111112,
            "2026-03-20": 0.4841461111111111,
            "2026-05-04": 6.727408333333333,
            "2026-05-05": 23.48013
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2026-03-20": 1,
            "2026-05-04": 1,
            "2026-05-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 37.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 33,
          "time_distribution": {
            "0-2h": 33,
            "2-4h": 4,
            "4-6h": 3,
            "6-8h": 6,
            "8-10h": 5,
            "48-50h": 1,
            "52-54h": 1,
            "54-56h": 1,
            "62-64h": 1,
            "72-74h": 1,
            "86-88h": 1,
            "248-250h": 1,
            "704-706h": 1,
            "814-816h": 1
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-12-03": 1,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-05": 2,
            "2026-02-13": 1,
            "2026-02-23": 1,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 3,
            "2026-03-04": 3,
            "2026-03-05": 1,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-19": 3,
            "2026-03-23": 3,
            "2026-03-25": 5,
            "2026-03-26": 1,
            "2026-03-30": 3,
            "2026-04-06": 4,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-02": 2,
            "2026-05-04": 1,
            "2026-05-07": 3,
            "2026-05-09": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-21": 4,
            "2026-05-25": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-11-14": 1.3801527777777778,
            "2025-12-03": 2.4229972222222225,
            "2026-01-16": 4.449356944444444,
            "2026-01-26": 4.429835277777777,
            "2026-02-05": 2.437295555555555,
            "2026-02-13": 86.75136611111111,
            "2026-02-23": 6.929021666666666,
            "2026-02-24": 9.108730277777777,
            "2026-02-25": 0.16204694444444445,
            "2026-03-02": 184.72094194444443,
            "2026-03-04": 8.833776944444445,
            "2026-03-05": 8.009800833333333,
            "2026-03-14": 0.3052727777777778,
            "2026-03-17": 248.17718444444444,
            "2026-03-18": 3.1660958333333333,
            "2026-03-19": 6.707669444444444,
            "2026-03-23": 64.67529222222223,
            "2026-03-25": 1.5394138888888889,
            "2026-03-26": 704.0679955555555,
            "2026-03-30": 22.129985277777777,
            "2026-04-06": 6.161546388888889,
            "2026-04-20": 2.0367144444444443,
            "2026-04-21": 6.874808611111112,
            "2026-04-22": 6.704937222222223,
            "2026-04-23": 815.2972847222222,
            "2026-05-02": 1.01511,
            "2026-05-04": 54.111538888888894,
            "2026-05-07": 3.7626947222222222,
            "2026-05-09": 1.0561141666666667,
            "2026-05-12": 0.01119111111111111,
            "2026-05-18": 0.16269611111111112,
            "2026-05-21": 4.163656944444444,
            "2026-05-25": 2.639676944444444,
            "2026-06-05": 1.803790277777778
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2025-12-03": 1,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-05": 2,
            "2026-02-13": 1,
            "2026-02-23": 1,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 3,
            "2026-03-04": 3,
            "2026-03-05": 1,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-19": 3,
            "2026-03-23": 3,
            "2026-03-25": 5,
            "2026-03-26": 1,
            "2026-03-30": 3,
            "2026-04-06": 4,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-02": 2,
            "2026-05-04": 1,
            "2026-05-07": 3,
            "2026-05-09": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-21": 4,
            "2026-05-25": 1,
            "2026-06-05": 2
          }
        },
        "P3": {
          "avg_time_hours": 156.37,
          "mode_time_hours": 81.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "22-24h": 2,
            "70-72h": 1,
            "80-82h": 2,
            "500-502h": 1,
            "528-530h": 1,
            "534-536h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-14": 1,
            "2026-01-24": 1,
            "2026-02-05": 1,
            "2026-02-10": 5,
            "2026-02-13": 2,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2025-11-12": 19.474531388888888,
            "2025-11-14": 2.3858605555555554,
            "2026-01-24": 71.85979305555556,
            "2026-02-05": 1.1528372222222223,
            "2026-02-10": 1725.92002,
            "2026-02-13": 47.640821388888895,
            "2026-03-18": 8.038671666666668
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-14": 1,
            "2026-01-24": 1,
            "2026-02-05": 1,
            "2026-02-10": 5,
            "2026-02-13": 2,
            "2026-03-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 182.64,
          "mode_time_hours": 25.0,
          "mode_frequency": 5,
          "time_distribution": {
            "4-6h": 2,
            "6-8h": 3,
            "24-26h": 5,
            "26-28h": 2,
            "28-30h": 1,
            "82-84h": 1,
            "96-98h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "122-124h": 1,
            "126-128h": 1,
            "130-132h": 2,
            "134-136h": 1,
            "144-146h": 1,
            "150-152h": 2,
            "164-166h": 1,
            "172-174h": 1,
            "190-192h": 1,
            "264-266h": 1,
            "272-274h": 1,
            "274-276h": 1,
            "312-314h": 1,
            "334-336h": 4,
            "356-358h": 2,
            "382-384h": 1,
            "502-504h": 1,
            "530-532h": 1,
            "546-548h": 2
          },
          "tickets_count": 56,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-30": 2,
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-14": 3,
            "2025-11-20": 2,
            "2025-12-02": 1,
            "2026-01-14": 1,
            "2026-01-27": 6,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-06": 3,
            "2026-02-11": 1,
            "2026-02-23": 2,
            "2026-03-14": 4,
            "2026-03-17": 1,
            "2026-03-18": 10,
            "2026-03-24": 1,
            "2026-03-30": 4,
            "2026-03-31": 1,
            "2026-04-24": 2,
            "2026-05-07": 1,
            "2026-05-09": 1,
            "2026-05-21": 3
          },
          "time_per_day": {
            "2025-10-07": 24.991370555555555,
            "2025-10-21": 99.88760138888888,
            "2025-10-23": 145.31284416666668,
            "2025-10-30": 661.7699936111111,
            "2025-11-06": 191.08936027777779,
            "2025-11-10": 264.0810055555556,
            "2025-11-14": 56.98547972222222,
            "2025-11-20": 262.5986097222222,
            "2025-12-02": 134.60990388888888,
            "2026-01-27": 373.4673361111111,
            "2026-01-30": 502.9954975,
            "2026-01-31": 172.45157138888888,
            "2026-02-06": 578.8522383333334,
            "2026-02-11": 272.0731455555556,
            "2026-02-23": 13.040786944444445,
            "2026-03-14": 103.97768333333332,
            "2026-03-17": 102.71708305555556,
            "2026-03-18": 3845.9360097222225,
            "2026-03-24": 127.65104111111111,
            "2026-03-30": 101.67626277777777
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-21": 1,
            "2025-10-23": 1,
            "2025-10-30": 2,
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-14": 3,
            "2025-11-20": 2,
            "2025-12-02": 1,
            "2026-01-27": 6,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-06": 3,
            "2026-02-11": 1,
            "2026-02-23": 2,
            "2026-03-14": 4,
            "2026-03-17": 1,
            "2026-03-18": 10,
            "2026-03-24": 1,
            "2026-03-30": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 663.07,
          "mode_time_hours": 1009.0,
          "mode_frequency": 2,
          "time_distribution": {
            "18-20h": 1,
            "134-136h": 1,
            "240-242h": 1,
            "288-290h": 2,
            "330-332h": 2,
            "396-398h": 1,
            "716-718h": 1,
            "1008-1010h": 2,
            "3186-3188h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-01-27": 1,
            "2026-02-18": 2,
            "2026-02-19": 9
          },
          "time_per_day": {
            "2025-12-02": 134.65423694444445,
            "2026-01-27": 19.128195833333336,
            "2026-02-18": 3187.2028225,
            "2026-02-19": 4615.914458055556
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-01-27": 1,
            "2026-02-18": 1,
            "2026-02-19": 9
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 153.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 35,
            "time_distribution": {
              "0-2h": 35,
              "2-4h": 5,
              "4-6h": 5,
              "6-8h": 10,
              "8-10h": 6,
              "18-20h": 2,
              "22-24h": 3,
              "24-26h": 6,
              "26-28h": 2,
              "28-30h": 1,
              "48-50h": 1,
              "52-54h": 1,
              "54-56h": 1,
              "62-64h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "80-82h": 2,
              "82-84h": 1,
              "86-88h": 1,
              "96-98h": 1,
              "98-100h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "122-124h": 1,
              "126-128h": 1,
              "130-132h": 2,
              "134-136h": 2,
              "144-146h": 1,
              "150-152h": 2,
              "164-166h": 1,
              "172-174h": 1,
              "190-192h": 1,
              "240-242h": 1,
              "248-250h": 1,
              "264-266h": 1,
              "272-274h": 1,
              "274-276h": 1,
              "288-290h": 2,
              "312-314h": 1,
              "330-332h": 2,
              "334-336h": 4,
              "356-358h": 2,
              "382-384h": 1,
              "396-398h": 1,
              "500-502h": 1,
              "502-504h": 1,
              "528-530h": 1,
              "530-532h": 1,
              "534-536h": 1,
              "546-548h": 2,
              "704-706h": 1,
              "716-718h": 1,
              "814-816h": 1,
              "1008-1010h": 2,
              "3186-3188h": 1
            },
            "tickets_count": 132,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-10-30": 2,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-12": 1,
              "2025-11-14": 5,
              "2025-11-20": 2,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2026-01-16": 1,
              "2026-01-24": 1,
              "2026-01-26": 1,
              "2026-01-27": 7,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-05": 3,
              "2026-02-06": 3,
              "2026-02-10": 5,
              "2026-02-11": 1,
              "2026-02-13": 3,
              "2026-02-18": 1,
              "2026-02-19": 9,
              "2026-02-23": 3,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-03-02": 3,
              "2026-03-04": 3,
              "2026-03-05": 1,
              "2026-03-14": 5,
              "2026-03-17": 2,
              "2026-03-18": 13,
              "2026-03-19": 3,
              "2026-03-20": 1,
              "2026-03-23": 3,
              "2026-03-24": 1,
              "2026-03-25": 5,
              "2026-03-26": 1,
              "2026-03-30": 4,
              "2026-04-06": 4,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-02": 2,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-07": 3,
              "2026-05-09": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-21": 4,
              "2026-05-25": 1,
              "2026-06-05": 2
            },
            "time_per_day": {
              "2025-10-07": 24.991370555555555,
              "2025-10-21": 99.88760138888888,
              "2025-10-23": 145.31284416666668,
              "2025-10-30": 661.7699936111111,
              "2025-11-05": 25.560861111111112,
              "2025-11-06": 191.08936027777779,
              "2025-11-10": 264.0810055555556,
              "2025-11-12": 19.474531388888888,
              "2025-11-14": 60.75149305555556,
              "2025-11-20": 262.5986097222222,
              "2025-12-02": 269.26414083333333,
              "2025-12-03": 2.4229972222222225,
              "2026-01-16": 4.449356944444444,
              "2026-01-24": 71.85979305555556,
              "2026-01-26": 4.429835277777777,
              "2026-01-27": 392.5955319444444,
              "2026-01-30": 502.9954975,
              "2026-01-31": 172.45157138888888,
              "2026-02-05": 3.590132777777778,
              "2026-02-06": 578.8522383333334,
              "2026-02-10": 1725.92002,
              "2026-02-11": 272.0731455555556,
              "2026-02-13": 134.3921875,
              "2026-02-18": 3187.2028225,
              "2026-02-19": 4615.914458055556,
              "2026-02-23": 19.969808611111112,
              "2026-02-24": 9.108730277777777,
              "2026-02-25": 0.16204694444444445,
              "2026-03-02": 184.72094194444443,
              "2026-03-04": 8.833776944444445,
              "2026-03-05": 8.009800833333333,
              "2026-03-14": 104.28295611111109,
              "2026-03-17": 350.8942675,
              "2026-03-18": 3857.1407772222224,
              "2026-03-19": 6.707669444444444,
              "2026-03-20": 0.4841461111111111,
              "2026-03-23": 64.67529222222223,
              "2026-03-24": 127.65104111111111,
              "2026-03-25": 1.5394138888888889,
              "2026-03-26": 704.0679955555555,
              "2026-03-30": 123.80624805555554,
              "2026-04-06": 6.161546388888889,
              "2026-04-20": 2.0367144444444443,
              "2026-04-21": 6.874808611111112,
              "2026-04-22": 6.704937222222223,
              "2026-04-23": 815.2972847222222,
              "2026-05-02": 1.01511,
              "2026-05-04": 60.83894722222223,
              "2026-05-05": 23.48013,
              "2026-05-07": 3.7626947222222222,
              "2026-05-09": 1.0561141666666667,
              "2026-05-12": 0.01119111111111111,
              "2026-05-18": 0.16269611111111112,
              "2026-05-21": 4.163656944444444,
              "2026-05-25": 2.639676944444444,
              "2026-06-05": 1.803790277777778
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-21": 1,
              "2025-10-23": 1,
              "2025-10-30": 2,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-12": 1,
              "2025-11-14": 5,
              "2025-11-20": 2,
              "2025-12-02": 2,
              "2025-12-03": 1,
              "2026-01-16": 1,
              "2026-01-24": 1,
              "2026-01-26": 1,
              "2026-01-27": 7,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-05": 3,
              "2026-02-06": 3,
              "2026-02-10": 5,
              "2026-02-11": 1,
              "2026-02-13": 3,
              "2026-02-18": 1,
              "2026-02-19": 9,
              "2026-02-23": 3,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-03-02": 3,
              "2026-03-04": 3,
              "2026-03-05": 1,
              "2026-03-14": 5,
              "2026-03-17": 2,
              "2026-03-18": 13,
              "2026-03-19": 3,
              "2026-03-20": 1,
              "2026-03-23": 3,
              "2026-03-24": 1,
              "2026-03-25": 5,
              "2026-03-26": 1,
              "2026-03-30": 4,
              "2026-04-06": 4,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-02": 2,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-07": 3,
              "2026-05-09": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-21": 4,
              "2026-05-25": 1,
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 14.06,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "22-24h": 1,
                "24-26h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2026-03-20": 1,
                "2026-05-04": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2025-11-05": 25.560861111111112,
                "2026-03-20": 0.4841461111111111,
                "2026-05-04": 6.727408333333333,
                "2026-05-05": 23.48013
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2026-03-20": 1,
                "2026-05-04": 1,
                "2026-05-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 37.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 33,
              "time_distribution": {
                "0-2h": 33,
                "2-4h": 4,
                "4-6h": 3,
                "6-8h": 6,
                "8-10h": 5,
                "48-50h": 1,
                "52-54h": 1,
                "54-56h": 1,
                "62-64h": 1,
                "72-74h": 1,
                "86-88h": 1,
                "248-250h": 1,
                "704-706h": 1,
                "814-816h": 1
              },
              "tickets_count": 60,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-12-03": 1,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-05": 2,
                "2026-02-13": 1,
                "2026-02-23": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-02": 3,
                "2026-03-04": 3,
                "2026-03-05": 1,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-19": 3,
                "2026-03-23": 3,
                "2026-03-25": 5,
                "2026-03-26": 1,
                "2026-03-30": 3,
                "2026-04-06": 4,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-02": 2,
                "2026-05-04": 1,
                "2026-05-07": 3,
                "2026-05-09": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-21": 4,
                "2026-05-25": 1,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-11-14": 1.3801527777777778,
                "2025-12-03": 2.4229972222222225,
                "2026-01-16": 4.449356944444444,
                "2026-01-26": 4.429835277777777,
                "2026-02-05": 2.437295555555555,
                "2026-02-13": 86.75136611111111,
                "2026-02-23": 6.929021666666666,
                "2026-02-24": 9.108730277777777,
                "2026-02-25": 0.16204694444444445,
                "2026-03-02": 184.72094194444443,
                "2026-03-04": 8.833776944444445,
                "2026-03-05": 8.009800833333333,
                "2026-03-14": 0.3052727777777778,
                "2026-03-17": 248.17718444444444,
                "2026-03-18": 3.1660958333333333,
                "2026-03-19": 6.707669444444444,
                "2026-03-23": 64.67529222222223,
                "2026-03-25": 1.5394138888888889,
                "2026-03-26": 704.0679955555555,
                "2026-03-30": 22.129985277777777,
                "2026-04-06": 6.161546388888889,
                "2026-04-20": 2.0367144444444443,
                "2026-04-21": 6.874808611111112,
                "2026-04-22": 6.704937222222223,
                "2026-04-23": 815.2972847222222,
                "2026-05-02": 1.01511,
                "2026-05-04": 54.111538888888894,
                "2026-05-07": 3.7626947222222222,
                "2026-05-09": 1.0561141666666667,
                "2026-05-12": 0.01119111111111111,
                "2026-05-18": 0.16269611111111112,
                "2026-05-21": 4.163656944444444,
                "2026-05-25": 2.639676944444444,
                "2026-06-05": 1.803790277777778
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2025-12-03": 1,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-05": 2,
                "2026-02-13": 1,
                "2026-02-23": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-02": 3,
                "2026-03-04": 3,
                "2026-03-05": 1,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-19": 3,
                "2026-03-23": 3,
                "2026-03-25": 5,
                "2026-03-26": 1,
                "2026-03-30": 3,
                "2026-04-06": 4,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-02": 2,
                "2026-05-04": 1,
                "2026-05-07": 3,
                "2026-05-09": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-21": 4,
                "2026-05-25": 1,
                "2026-06-05": 2
              }
            },
            "P3": {
              "avg_time_hours": 156.37,
              "mode_time_hours": 81.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "22-24h": 2,
                "70-72h": 1,
                "80-82h": 2,
                "500-502h": 1,
                "528-530h": 1,
                "534-536h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-14": 1,
                "2026-01-24": 1,
                "2026-02-05": 1,
                "2026-02-10": 5,
                "2026-02-13": 2,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2025-11-12": 19.474531388888888,
                "2025-11-14": 2.3858605555555554,
                "2026-01-24": 71.85979305555556,
                "2026-02-05": 1.1528372222222223,
                "2026-02-10": 1725.92002,
                "2026-02-13": 47.640821388888895,
                "2026-03-18": 8.038671666666668
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-14": 1,
                "2026-01-24": 1,
                "2026-02-05": 1,
                "2026-02-10": 5,
                "2026-02-13": 2,
                "2026-03-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 182.64,
              "mode_time_hours": 25.0,
              "mode_frequency": 5,
              "time_distribution": {
                "4-6h": 2,
                "6-8h": 3,
                "24-26h": 5,
                "26-28h": 2,
                "28-30h": 1,
                "82-84h": 1,
                "96-98h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "122-124h": 1,
                "126-128h": 1,
                "130-132h": 2,
                "134-136h": 1,
                "144-146h": 1,
                "150-152h": 2,
                "164-166h": 1,
                "172-174h": 1,
                "190-192h": 1,
                "264-266h": 1,
                "272-274h": 1,
                "274-276h": 1,
                "312-314h": 1,
                "334-336h": 4,
                "356-358h": 2,
                "382-384h": 1,
                "502-504h": 1,
                "530-532h": 1,
                "546-548h": 2
              },
              "tickets_count": 44,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-30": 2,
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-14": 3,
                "2025-11-20": 2,
                "2025-12-02": 1,
                "2026-01-27": 6,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-06": 3,
                "2026-02-11": 1,
                "2026-02-23": 2,
                "2026-03-14": 4,
                "2026-03-17": 1,
                "2026-03-18": 10,
                "2026-03-24": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2025-10-07": 24.991370555555555,
                "2025-10-21": 99.88760138888888,
                "2025-10-23": 145.31284416666668,
                "2025-10-30": 661.7699936111111,
                "2025-11-06": 191.08936027777779,
                "2025-11-10": 264.0810055555556,
                "2025-11-14": 56.98547972222222,
                "2025-11-20": 262.5986097222222,
                "2025-12-02": 134.60990388888888,
                "2026-01-27": 373.4673361111111,
                "2026-01-30": 502.9954975,
                "2026-01-31": 172.45157138888888,
                "2026-02-06": 578.8522383333334,
                "2026-02-11": 272.0731455555556,
                "2026-02-23": 13.040786944444445,
                "2026-03-14": 103.97768333333332,
                "2026-03-17": 102.71708305555556,
                "2026-03-18": 3845.9360097222225,
                "2026-03-24": 127.65104111111111,
                "2026-03-30": 101.67626277777777
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-21": 1,
                "2025-10-23": 1,
                "2025-10-30": 2,
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-14": 3,
                "2025-11-20": 2,
                "2025-12-02": 1,
                "2026-01-27": 6,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-06": 3,
                "2026-02-11": 1,
                "2026-02-23": 2,
                "2026-03-14": 4,
                "2026-03-17": 1,
                "2026-03-18": 10,
                "2026-03-24": 1,
                "2026-03-30": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 663.07,
              "mode_time_hours": 1009.0,
              "mode_frequency": 2,
              "time_distribution": {
                "18-20h": 1,
                "134-136h": 1,
                "240-242h": 1,
                "288-290h": 2,
                "330-332h": 2,
                "396-398h": 1,
                "716-718h": 1,
                "1008-1010h": 2,
                "3186-3188h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-01-27": 1,
                "2026-02-18": 1,
                "2026-02-19": 9
              },
              "time_per_day": {
                "2025-12-02": 134.65423694444445,
                "2026-01-27": 19.128195833333336,
                "2026-02-18": 3187.2028225,
                "2026-02-19": 4615.914458055556
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-01-27": 1,
                "2026-02-18": 1,
                "2026-02-19": 9
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-03-30": 3,
              "2026-03-31": 1,
              "2026-04-24": 2,
              "2026-05-07": 1,
              "2026-05-09": 1,
              "2026-05-21": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-03-30": 3,
                "2026-03-31": 1,
                "2026-04-24": 2,
                "2026-05-07": 1,
                "2026-05-09": 1,
                "2026-05-21": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_143": {
      "overall": {
        "avg_time_hours": 1.74,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2026-01-12": 1
        },
        "time_per_day": {
          "2025-10-06": 0.3635063888888889,
          "2026-01-12": 3.119861111111111
        },
        "time_count_per_day": {
          "2025-10-06": 1,
          "2026-01-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-06": 1
          },
          "time_per_day": {
            "2025-10-06": 0.3635063888888889
          },
          "time_count_per_day": {
            "2025-10-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 3.12,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-12": 1
          },
          "time_per_day": {
            "2026-01-12": 3.119861111111111
          },
          "time_count_per_day": {
            "2026-01-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.74,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2026-01-12": 1
            },
            "time_per_day": {
              "2025-10-06": 0.3635063888888889,
              "2026-01-12": 3.119861111111111
            },
            "time_count_per_day": {
              "2025-10-06": 1,
              "2026-01-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-06": 1
              },
              "time_per_day": {
                "2025-10-06": 0.3635063888888889
              },
              "time_count_per_day": {
                "2025-10-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 3.12,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-12": 1
              },
              "time_per_day": {
                "2026-01-12": 3.119861111111111
              },
              "time_count_per_day": {
                "2026-01-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_145": {
      "overall": {
        "avg_time_hours": 61.95,
        "mode_time_hours": 1.0,
        "mode_frequency": 87,
        "time_distribution": {
          "0-2h": 87,
          "2-4h": 26,
          "4-6h": 18,
          "6-8h": 5,
          "8-10h": 3,
          "10-12h": 5,
          "12-14h": 1,
          "14-16h": 3,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "24-26h": 3,
          "26-28h": 1,
          "28-30h": 2,
          "32-34h": 1,
          "36-38h": 2,
          "38-40h": 1,
          "44-46h": 4,
          "48-50h": 1,
          "68-70h": 1,
          "70-72h": 1,
          "72-74h": 5,
          "80-82h": 1,
          "82-84h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "120-122h": 1,
          "126-128h": 1,
          "140-142h": 2,
          "142-144h": 1,
          "146-148h": 1,
          "152-154h": 3,
          "160-162h": 1,
          "168-170h": 1,
          "206-208h": 1,
          "212-214h": 2,
          "216-218h": 2,
          "220-222h": 1,
          "234-236h": 1,
          "236-238h": 2,
          "286-288h": 2,
          "308-310h": 4,
          "310-312h": 3,
          "330-332h": 1,
          "332-334h": 2,
          "432-434h": 2,
          "456-458h": 1,
          "500-502h": 1,
          "558-560h": 1,
          "616-618h": 3
        },
        "tickets_count": 230,
        "tickets_per_day": {
          "2025-10-07": 2,
          "2025-10-13": 1,
          "2025-10-15": 2,
          "2025-10-16": 2,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-24": 3,
          "2025-10-27": 11,
          "2025-10-28": 1,
          "2025-10-29": 4,
          "2025-10-30": 4,
          "2025-11-05": 4,
          "2025-11-12": 9,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2026-01-05": 1,
          "2026-01-08": 1,
          "2026-01-09": 4,
          "2026-01-13": 1,
          "2026-01-16": 3,
          "2026-01-19": 3,
          "2026-01-23": 1,
          "2026-02-03": 1,
          "2026-02-12": 1,
          "2026-02-19": 18,
          "2026-02-21": 1,
          "2026-03-02": 1,
          "2026-03-03": 2,
          "2026-03-04": 1,
          "2026-03-06": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-03-11": 2,
          "2026-03-12": 2,
          "2026-03-14": 2,
          "2026-03-17": 3,
          "2026-03-18": 24,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-03-30": 1,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-14": 2,
          "2026-04-18": 1,
          "2026-04-20": 1,
          "2026-04-21": 2,
          "2026-04-22": 5,
          "2026-04-27": 9,
          "2026-04-28": 1,
          "2026-04-29": 3,
          "2026-04-30": 1,
          "2026-05-02": 6,
          "2026-05-04": 5,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-12": 2,
          "2026-05-13": 2,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 2,
          "2026-05-21": 8,
          "2026-05-25": 3,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-05-29": 10,
          "2026-06-01": 5,
          "2026-06-03": 7,
          "2026-06-05": 4,
          "2026-06-08": 3
        },
        "time_per_day": {
          "2025-10-07": 51.16104861111111,
          "2025-10-13": 147.16133861111112,
          "2025-10-15": 222.1752316666667,
          "2025-10-16": 0.21945055555555557,
          "2025-10-20": 28.631652777777777,
          "2025-10-22": 38.23141944444444,
          "2025-10-23": 26.31403638888889,
          "2025-10-24": 12.229323611111113,
          "2025-10-27": 187.09194138888887,
          "2025-10-28": 0.6739344444444445,
          "2025-10-29": 179.50917083333334,
          "2025-10-30": 525.4561322222222,
          "2025-11-05": 1235.7838619444444,
          "2025-11-12": 23.318417222222223,
          "2025-11-13": 0.09486527777777777,
          "2025-11-19": 558.6868397222222,
          "2025-11-21": 101.69455805555555,
          "2025-11-26": 0.010081111111111112,
          "2025-11-28": 0.26214472222222224,
          "2026-01-05": 143.9655686111111,
          "2026-01-08": 82.63133861111112,
          "2026-01-09": 969.3609661111111,
          "2026-01-13": 19.113959444444443,
          "2026-01-16": 31.375615555555555,
          "2026-01-19": 11.813978333333333,
          "2026-01-23": 127.63344444444445,
          "2026-02-03": 7.810426111111111,
          "2026-02-12": 21.786188888888887,
          "2026-02-19": 3096.1272138888894,
          "2026-02-21": 49.656299999999995,
          "2026-03-03": 1.4330269444444443,
          "2026-03-04": 8.7886025,
          "2026-03-10": 3.094773333333333,
          "2026-03-11": 1.8277119444444445,
          "2026-03-12": 6.159761944444444,
          "2026-03-14": 24.910403333333335,
          "2026-03-17": 70.19302722222223,
          "2026-03-18": 4906.645756388889,
          "2026-03-20": 213.57120833333332,
          "2026-03-24": 8.090398333333333,
          "2026-03-26": 0.4190555555555555,
          "2026-03-30": 7.1636291666666665,
          "2026-04-07": 12.936884166666665,
          "2026-04-08": 15.143540833333335,
          "2026-04-10": 6.3208525,
          "2026-04-14": 2.1191061111111114,
          "2026-04-20": 0.03251305555555555,
          "2026-04-21": 3.5028452777777774,
          "2026-04-22": 2.0827258333333334,
          "2026-04-27": 6.363102222222222,
          "2026-04-29": 7.477266944444445,
          "2026-04-30": 6.107094166666667,
          "2026-05-02": 3.9686194444444443,
          "2026-05-04": 4.158711388888889,
          "2026-05-06": 0.5390733333333333,
          "2026-05-07": 0.6894372222222223,
          "2026-05-08": 4.2267447222222225,
          "2026-05-09": 4.185468055555555,
          "2026-05-11": 4.939500277777778,
          "2026-05-12": 2.8853199999999997,
          "2026-05-13": 1.5991672222222222,
          "2026-05-18": 0.08280111111111112,
          "2026-05-19": 1.4379069444444446,
          "2026-05-20": 0.44346555555555556,
          "2026-05-21": 16.472967222222223,
          "2026-05-25": 1.5219694444444443,
          "2026-05-27": 10.303836944444445,
          "2026-05-28": 1.1327322222222223,
          "2026-05-29": 74.32605583333333,
          "2026-06-01": 13.655758055555555,
          "2026-06-03": 37.65376222222222,
          "2026-06-05": 42.38279277777777,
          "2026-06-08": 1.4523919444444444
        },
        "time_count_per_day": {
          "2025-10-07": 2,
          "2025-10-13": 1,
          "2025-10-15": 2,
          "2025-10-16": 2,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-23": 1,
          "2025-10-24": 3,
          "2025-10-27": 11,
          "2025-10-28": 1,
          "2025-10-29": 4,
          "2025-10-30": 4,
          "2025-11-05": 4,
          "2025-11-12": 9,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2026-01-05": 1,
          "2026-01-08": 1,
          "2026-01-09": 4,
          "2026-01-13": 1,
          "2026-01-16": 3,
          "2026-01-19": 3,
          "2026-01-23": 1,
          "2026-02-03": 1,
          "2026-02-12": 1,
          "2026-02-19": 13,
          "2026-02-21": 1,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-10": 1,
          "2026-03-11": 2,
          "2026-03-12": 2,
          "2026-03-14": 2,
          "2026-03-17": 3,
          "2026-03-18": 24,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-03-30": 1,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-14": 2,
          "2026-04-20": 1,
          "2026-04-21": 2,
          "2026-04-22": 5,
          "2026-04-27": 9,
          "2026-04-29": 3,
          "2026-04-30": 1,
          "2026-05-02": 6,
          "2026-05-04": 5,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-12": 2,
          "2026-05-13": 2,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 2,
          "2026-05-21": 8,
          "2026-05-25": 3,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-05-29": 10,
          "2026-06-01": 5,
          "2026-06-03": 7,
          "2026-06-05": 4,
          "2026-06-08": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 21.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 81,
          "time_distribution": {
            "0-2h": 81,
            "2-4h": 26,
            "4-6h": 11,
            "6-8h": 5,
            "8-10h": 1,
            "10-12h": 5,
            "12-14h": 1,
            "14-16h": 3,
            "16-18h": 1,
            "36-38h": 1,
            "72-74h": 1,
            "80-82h": 1,
            "142-144h": 1,
            "212-214h": 1,
            "308-310h": 4,
            "432-434h": 1,
            "558-560h": 1
          },
          "tickets_count": 146,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-10-16": 2,
            "2025-10-24": 1,
            "2025-10-27": 5,
            "2025-10-28": 1,
            "2025-11-05": 4,
            "2025-11-12": 4,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2026-01-05": 1,
            "2026-01-09": 2,
            "2026-01-16": 3,
            "2026-01-19": 3,
            "2026-02-03": 1,
            "2026-03-03": 2,
            "2026-03-04": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-12": 2,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 6,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-14": 2,
            "2026-04-20": 1,
            "2026-04-21": 2,
            "2026-04-22": 5,
            "2026-04-27": 9,
            "2026-04-29": 3,
            "2026-04-30": 1,
            "2026-05-02": 6,
            "2026-05-04": 5,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 2,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 2,
            "2026-05-21": 8,
            "2026-05-25": 3,
            "2026-05-27": 3,
            "2026-05-28": 1,
            "2026-05-29": 10,
            "2026-06-01": 5,
            "2026-06-03": 7,
            "2026-06-05": 4,
            "2026-06-08": 3
          },
          "time_per_day": {
            "2025-10-15": 0.4251769444444444,
            "2025-10-16": 0.21945055555555557,
            "2025-10-24": 2.178645,
            "2025-10-27": 155.03761444444442,
            "2025-10-28": 0.6739344444444445,
            "2025-11-05": 1235.7838619444444,
            "2025-11-12": 0.36337194444444443,
            "2025-11-19": 558.6868397222222,
            "2025-11-26": 0.010081111111111112,
            "2025-11-28": 0.26214472222222224,
            "2026-01-05": 143.9655686111111,
            "2026-01-09": 433.28923055555555,
            "2026-01-16": 31.375615555555555,
            "2026-01-19": 11.813978333333333,
            "2026-02-03": 7.810426111111111,
            "2026-03-03": 1.4330269444444443,
            "2026-03-04": 8.7886025,
            "2026-03-10": 3.094773333333333,
            "2026-03-11": 1.8277119444444445,
            "2026-03-12": 6.159761944444444,
            "2026-03-14": 0.30655861111111116,
            "2026-03-17": 0.33684055555555553,
            "2026-03-18": 21.49526861111111,
            "2026-03-20": 213.57120833333332,
            "2026-03-26": 0.4190555555555555,
            "2026-03-30": 7.1636291666666665,
            "2026-04-07": 12.936884166666665,
            "2026-04-08": 15.143540833333335,
            "2026-04-10": 6.3208525,
            "2026-04-14": 2.1191061111111114,
            "2026-04-20": 0.03251305555555555,
            "2026-04-21": 3.5028452777777774,
            "2026-04-22": 2.0827258333333334,
            "2026-04-27": 6.363102222222222,
            "2026-04-29": 7.477266944444445,
            "2026-04-30": 6.107094166666667,
            "2026-05-02": 3.9686194444444443,
            "2026-05-04": 4.158711388888889,
            "2026-05-06": 0.5390733333333333,
            "2026-05-07": 0.6894372222222223,
            "2026-05-08": 4.2267447222222225,
            "2026-05-09": 4.185468055555555,
            "2026-05-11": 4.939500277777778,
            "2026-05-12": 2.8853199999999997,
            "2026-05-13": 1.5991672222222222,
            "2026-05-18": 0.08280111111111112,
            "2026-05-19": 1.4379069444444446,
            "2026-05-20": 0.44346555555555556,
            "2026-05-21": 16.472967222222223,
            "2026-05-25": 1.5219694444444443,
            "2026-05-27": 10.303836944444445,
            "2026-05-28": 1.1327322222222223,
            "2026-05-29": 74.32605583333333,
            "2026-06-01": 13.655758055555555,
            "2026-06-03": 37.65376222222222,
            "2026-06-05": 42.38279277777777,
            "2026-06-08": 1.4523919444444444
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-10-16": 2,
            "2025-10-24": 1,
            "2025-10-27": 5,
            "2025-10-28": 1,
            "2025-11-05": 4,
            "2025-11-12": 4,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2026-01-05": 1,
            "2026-01-09": 2,
            "2026-01-16": 3,
            "2026-01-19": 3,
            "2026-02-03": 1,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-12": 2,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 6,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-14": 2,
            "2026-04-20": 1,
            "2026-04-21": 2,
            "2026-04-22": 5,
            "2026-04-27": 9,
            "2026-04-29": 3,
            "2026-04-30": 1,
            "2026-05-02": 6,
            "2026-05-04": 5,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-12": 2,
            "2026-05-13": 2,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 2,
            "2026-05-21": 8,
            "2026-05-25": 3,
            "2026-05-27": 3,
            "2026-05-28": 1,
            "2026-05-29": 10,
            "2026-06-01": 5,
            "2026-06-03": 7,
            "2026-06-05": 4,
            "2026-06-08": 3
          }
        },
        "P3": {
          "avg_time_hours": 46.03,
          "mode_time_hours": 5.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 7,
            "18-20h": 1,
            "20-22h": 1,
            "432-434h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-24": 2,
            "2025-11-12": 5,
            "2025-11-13": 1,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-24": 10.050678611111111,
            "2025-11-12": 22.955045277777778,
            "2025-11-13": 0.09486527777777777,
            "2026-01-09": 432.37241,
            "2026-01-13": 19.113959444444443,
            "2026-02-12": 21.786188888888887
          },
          "time_count_per_day": {
            "2025-10-24": 2,
            "2025-11-12": 5,
            "2025-11-13": 1,
            "2026-01-09": 1,
            "2026-01-13": 1,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 135.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "8-10h": 2,
            "24-26h": 3,
            "26-28h": 1,
            "28-30h": 2,
            "32-34h": 1,
            "36-38h": 1,
            "38-40h": 1,
            "44-46h": 4,
            "48-50h": 1,
            "68-70h": 1,
            "70-72h": 1,
            "82-84h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "120-122h": 1,
            "126-128h": 1,
            "140-142h": 2,
            "146-148h": 1,
            "152-154h": 3,
            "168-170h": 1,
            "206-208h": 1,
            "212-214h": 1,
            "216-218h": 2,
            "220-222h": 1,
            "286-288h": 2,
            "310-312h": 3,
            "330-332h": 1,
            "332-334h": 2,
            "456-458h": 1,
            "500-502h": 1
          },
          "tickets_count": 53,
          "tickets_per_day": {
            "2025-10-07": 2,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-27": 6,
            "2025-10-29": 4,
            "2025-10-30": 4,
            "2025-11-21": 1,
            "2026-01-08": 1,
            "2026-01-09": 1,
            "2026-01-23": 1,
            "2026-02-19": 2,
            "2026-02-21": 1,
            "2026-03-14": 1,
            "2026-03-17": 2,
            "2026-03-18": 18,
            "2026-03-24": 1,
            "2026-04-18": 1,
            "2026-04-28": 1,
            "2026-05-08": 1
          },
          "time_per_day": {
            "2025-10-07": 51.16104861111111,
            "2025-10-13": 147.16133861111112,
            "2025-10-15": 221.75005472222225,
            "2025-10-20": 28.631652777777777,
            "2025-10-22": 38.23141944444444,
            "2025-10-23": 26.31403638888889,
            "2025-10-27": 32.05432694444444,
            "2025-10-29": 179.50917083333334,
            "2025-10-30": 525.4561322222222,
            "2025-11-21": 101.69455805555555,
            "2026-01-08": 82.63133861111112,
            "2026-01-09": 103.69932555555555,
            "2026-01-23": 127.63344444444445,
            "2026-02-19": 79.38826166666666,
            "2026-02-21": 49.656299999999995,
            "2026-03-14": 24.603844722222224,
            "2026-03-17": 69.85618666666667,
            "2026-03-18": 4885.150487777779,
            "2026-03-24": 8.090398333333333
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-10-23": 1,
            "2025-10-27": 6,
            "2025-10-29": 4,
            "2025-10-30": 4,
            "2025-11-21": 1,
            "2026-01-08": 1,
            "2026-01-09": 1,
            "2026-01-23": 1,
            "2026-02-19": 2,
            "2026-02-21": 1,
            "2026-03-14": 1,
            "2026-03-17": 2,
            "2026-03-18": 18,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 274.25,
          "mode_time_hours": 73.0,
          "mode_frequency": 4,
          "time_distribution": {
            "72-74h": 4,
            "160-162h": 1,
            "234-236h": 1,
            "236-238h": 2,
            "616-618h": 3
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2026-02-19": 16,
            "2026-03-02": 1,
            "2026-03-06": 2,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-02-19": 3016.7389522222225
          },
          "time_count_per_day": {
            "2026-02-19": 11
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 61.95,
            "mode_time_hours": 1.0,
            "mode_frequency": 87,
            "time_distribution": {
              "0-2h": 87,
              "2-4h": 26,
              "4-6h": 18,
              "6-8h": 5,
              "8-10h": 3,
              "10-12h": 5,
              "12-14h": 1,
              "14-16h": 3,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "24-26h": 3,
              "26-28h": 1,
              "28-30h": 2,
              "32-34h": 1,
              "36-38h": 2,
              "38-40h": 1,
              "44-46h": 4,
              "48-50h": 1,
              "68-70h": 1,
              "70-72h": 1,
              "72-74h": 5,
              "80-82h": 1,
              "82-84h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "120-122h": 1,
              "126-128h": 1,
              "140-142h": 2,
              "142-144h": 1,
              "146-148h": 1,
              "152-154h": 3,
              "160-162h": 1,
              "168-170h": 1,
              "206-208h": 1,
              "212-214h": 2,
              "216-218h": 2,
              "220-222h": 1,
              "234-236h": 1,
              "236-238h": 2,
              "286-288h": 2,
              "308-310h": 4,
              "310-312h": 3,
              "330-332h": 1,
              "332-334h": 2,
              "432-434h": 2,
              "456-458h": 1,
              "500-502h": 1,
              "558-560h": 1,
              "616-618h": 3
            },
            "tickets_count": 217,
            "tickets_per_day": {
              "2025-10-07": 2,
              "2025-10-13": 1,
              "2025-10-15": 2,
              "2025-10-16": 2,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-24": 3,
              "2025-10-27": 11,
              "2025-10-28": 1,
              "2025-10-29": 4,
              "2025-10-30": 4,
              "2025-11-05": 4,
              "2025-11-12": 9,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2026-01-05": 1,
              "2026-01-08": 1,
              "2026-01-09": 4,
              "2026-01-13": 1,
              "2026-01-16": 3,
              "2026-01-19": 3,
              "2026-01-23": 1,
              "2026-02-03": 1,
              "2026-02-12": 1,
              "2026-02-19": 13,
              "2026-02-21": 1,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-10": 1,
              "2026-03-11": 2,
              "2026-03-12": 2,
              "2026-03-14": 2,
              "2026-03-17": 3,
              "2026-03-18": 24,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-26": 1,
              "2026-03-30": 1,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-14": 2,
              "2026-04-20": 1,
              "2026-04-21": 2,
              "2026-04-22": 5,
              "2026-04-27": 9,
              "2026-04-29": 3,
              "2026-04-30": 1,
              "2026-05-02": 6,
              "2026-05-04": 5,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 2,
              "2026-05-21": 8,
              "2026-05-25": 3,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-29": 10,
              "2026-06-01": 5,
              "2026-06-03": 7,
              "2026-06-05": 4,
              "2026-06-08": 3
            },
            "time_per_day": {
              "2025-10-07": 51.16104861111111,
              "2025-10-13": 147.16133861111112,
              "2025-10-15": 222.1752316666667,
              "2025-10-16": 0.21945055555555557,
              "2025-10-20": 28.631652777777777,
              "2025-10-22": 38.23141944444444,
              "2025-10-23": 26.31403638888889,
              "2025-10-24": 12.229323611111113,
              "2025-10-27": 187.09194138888887,
              "2025-10-28": 0.6739344444444445,
              "2025-10-29": 179.50917083333334,
              "2025-10-30": 525.4561322222222,
              "2025-11-05": 1235.7838619444444,
              "2025-11-12": 23.318417222222223,
              "2025-11-13": 0.09486527777777777,
              "2025-11-19": 558.6868397222222,
              "2025-11-21": 101.69455805555555,
              "2025-11-26": 0.010081111111111112,
              "2025-11-28": 0.26214472222222224,
              "2026-01-05": 143.9655686111111,
              "2026-01-08": 82.63133861111112,
              "2026-01-09": 969.3609661111111,
              "2026-01-13": 19.113959444444443,
              "2026-01-16": 31.375615555555555,
              "2026-01-19": 11.813978333333333,
              "2026-01-23": 127.63344444444445,
              "2026-02-03": 7.810426111111111,
              "2026-02-12": 21.786188888888887,
              "2026-02-19": 3096.1272138888894,
              "2026-02-21": 49.656299999999995,
              "2026-03-03": 1.4330269444444443,
              "2026-03-04": 8.7886025,
              "2026-03-10": 3.094773333333333,
              "2026-03-11": 1.8277119444444445,
              "2026-03-12": 6.159761944444444,
              "2026-03-14": 24.910403333333335,
              "2026-03-17": 70.19302722222223,
              "2026-03-18": 4906.645756388889,
              "2026-03-20": 213.57120833333332,
              "2026-03-24": 8.090398333333333,
              "2026-03-26": 0.4190555555555555,
              "2026-03-30": 7.1636291666666665,
              "2026-04-07": 12.936884166666665,
              "2026-04-08": 15.143540833333335,
              "2026-04-10": 6.3208525,
              "2026-04-14": 2.1191061111111114,
              "2026-04-20": 0.03251305555555555,
              "2026-04-21": 3.5028452777777774,
              "2026-04-22": 2.0827258333333334,
              "2026-04-27": 6.363102222222222,
              "2026-04-29": 7.477266944444445,
              "2026-04-30": 6.107094166666667,
              "2026-05-02": 3.9686194444444443,
              "2026-05-04": 4.158711388888889,
              "2026-05-06": 0.5390733333333333,
              "2026-05-07": 0.6894372222222223,
              "2026-05-08": 4.2267447222222225,
              "2026-05-09": 4.185468055555555,
              "2026-05-11": 4.939500277777778,
              "2026-05-12": 2.8853199999999997,
              "2026-05-13": 1.5991672222222222,
              "2026-05-18": 0.08280111111111112,
              "2026-05-19": 1.4379069444444446,
              "2026-05-20": 0.44346555555555556,
              "2026-05-21": 16.472967222222223,
              "2026-05-25": 1.5219694444444443,
              "2026-05-27": 10.303836944444445,
              "2026-05-28": 1.1327322222222223,
              "2026-05-29": 74.32605583333333,
              "2026-06-01": 13.655758055555555,
              "2026-06-03": 37.65376222222222,
              "2026-06-05": 42.38279277777777,
              "2026-06-08": 1.4523919444444444
            },
            "time_count_per_day": {
              "2025-10-07": 2,
              "2025-10-13": 1,
              "2025-10-15": 2,
              "2025-10-16": 2,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-10-23": 1,
              "2025-10-24": 3,
              "2025-10-27": 11,
              "2025-10-28": 1,
              "2025-10-29": 4,
              "2025-10-30": 4,
              "2025-11-05": 4,
              "2025-11-12": 9,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2026-01-05": 1,
              "2026-01-08": 1,
              "2026-01-09": 4,
              "2026-01-13": 1,
              "2026-01-16": 3,
              "2026-01-19": 3,
              "2026-01-23": 1,
              "2026-02-03": 1,
              "2026-02-12": 1,
              "2026-02-19": 13,
              "2026-02-21": 1,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-10": 1,
              "2026-03-11": 2,
              "2026-03-12": 2,
              "2026-03-14": 2,
              "2026-03-17": 3,
              "2026-03-18": 24,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-26": 1,
              "2026-03-30": 1,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-14": 2,
              "2026-04-20": 1,
              "2026-04-21": 2,
              "2026-04-22": 5,
              "2026-04-27": 9,
              "2026-04-29": 3,
              "2026-04-30": 1,
              "2026-05-02": 6,
              "2026-05-04": 5,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-12": 2,
              "2026-05-13": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 2,
              "2026-05-21": 8,
              "2026-05-25": 3,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-29": 10,
              "2026-06-01": 5,
              "2026-06-03": 7,
              "2026-06-05": 4,
              "2026-06-08": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 21.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 81,
              "time_distribution": {
                "0-2h": 81,
                "2-4h": 26,
                "4-6h": 11,
                "6-8h": 5,
                "8-10h": 1,
                "10-12h": 5,
                "12-14h": 1,
                "14-16h": 3,
                "16-18h": 1,
                "36-38h": 1,
                "72-74h": 1,
                "80-82h": 1,
                "142-144h": 1,
                "212-214h": 1,
                "308-310h": 4,
                "432-434h": 1,
                "558-560h": 1
              },
              "tickets_count": 145,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-10-16": 2,
                "2025-10-24": 1,
                "2025-10-27": 5,
                "2025-10-28": 1,
                "2025-11-05": 4,
                "2025-11-12": 4,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2026-01-05": 1,
                "2026-01-09": 2,
                "2026-01-16": 3,
                "2026-01-19": 3,
                "2026-02-03": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 2,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 6,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-14": 2,
                "2026-04-20": 1,
                "2026-04-21": 2,
                "2026-04-22": 5,
                "2026-04-27": 9,
                "2026-04-29": 3,
                "2026-04-30": 1,
                "2026-05-02": 6,
                "2026-05-04": 5,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-20": 2,
                "2026-05-21": 8,
                "2026-05-25": 3,
                "2026-05-27": 3,
                "2026-05-28": 1,
                "2026-05-29": 10,
                "2026-06-01": 5,
                "2026-06-03": 7,
                "2026-06-05": 4,
                "2026-06-08": 3
              },
              "time_per_day": {
                "2025-10-15": 0.4251769444444444,
                "2025-10-16": 0.21945055555555557,
                "2025-10-24": 2.178645,
                "2025-10-27": 155.03761444444442,
                "2025-10-28": 0.6739344444444445,
                "2025-11-05": 1235.7838619444444,
                "2025-11-12": 0.36337194444444443,
                "2025-11-19": 558.6868397222222,
                "2025-11-26": 0.010081111111111112,
                "2025-11-28": 0.26214472222222224,
                "2026-01-05": 143.9655686111111,
                "2026-01-09": 433.28923055555555,
                "2026-01-16": 31.375615555555555,
                "2026-01-19": 11.813978333333333,
                "2026-02-03": 7.810426111111111,
                "2026-03-03": 1.4330269444444443,
                "2026-03-04": 8.7886025,
                "2026-03-10": 3.094773333333333,
                "2026-03-11": 1.8277119444444445,
                "2026-03-12": 6.159761944444444,
                "2026-03-14": 0.30655861111111116,
                "2026-03-17": 0.33684055555555553,
                "2026-03-18": 21.49526861111111,
                "2026-03-20": 213.57120833333332,
                "2026-03-26": 0.4190555555555555,
                "2026-03-30": 7.1636291666666665,
                "2026-04-07": 12.936884166666665,
                "2026-04-08": 15.143540833333335,
                "2026-04-10": 6.3208525,
                "2026-04-14": 2.1191061111111114,
                "2026-04-20": 0.03251305555555555,
                "2026-04-21": 3.5028452777777774,
                "2026-04-22": 2.0827258333333334,
                "2026-04-27": 6.363102222222222,
                "2026-04-29": 7.477266944444445,
                "2026-04-30": 6.107094166666667,
                "2026-05-02": 3.9686194444444443,
                "2026-05-04": 4.158711388888889,
                "2026-05-06": 0.5390733333333333,
                "2026-05-07": 0.6894372222222223,
                "2026-05-08": 4.2267447222222225,
                "2026-05-09": 4.185468055555555,
                "2026-05-11": 4.939500277777778,
                "2026-05-12": 2.8853199999999997,
                "2026-05-13": 1.5991672222222222,
                "2026-05-18": 0.08280111111111112,
                "2026-05-19": 1.4379069444444446,
                "2026-05-20": 0.44346555555555556,
                "2026-05-21": 16.472967222222223,
                "2026-05-25": 1.5219694444444443,
                "2026-05-27": 10.303836944444445,
                "2026-05-28": 1.1327322222222223,
                "2026-05-29": 74.32605583333333,
                "2026-06-01": 13.655758055555555,
                "2026-06-03": 37.65376222222222,
                "2026-06-05": 42.38279277777777,
                "2026-06-08": 1.4523919444444444
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-10-16": 2,
                "2025-10-24": 1,
                "2025-10-27": 5,
                "2025-10-28": 1,
                "2025-11-05": 4,
                "2025-11-12": 4,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2026-01-05": 1,
                "2026-01-09": 2,
                "2026-01-16": 3,
                "2026-01-19": 3,
                "2026-02-03": 1,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 2,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-18": 6,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-14": 2,
                "2026-04-20": 1,
                "2026-04-21": 2,
                "2026-04-22": 5,
                "2026-04-27": 9,
                "2026-04-29": 3,
                "2026-04-30": 1,
                "2026-05-02": 6,
                "2026-05-04": 5,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-12": 2,
                "2026-05-13": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-20": 2,
                "2026-05-21": 8,
                "2026-05-25": 3,
                "2026-05-27": 3,
                "2026-05-28": 1,
                "2026-05-29": 10,
                "2026-06-01": 5,
                "2026-06-03": 7,
                "2026-06-05": 4,
                "2026-06-08": 3
              }
            },
            "P3": {
              "avg_time_hours": 46.03,
              "mode_time_hours": 5.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 7,
                "18-20h": 1,
                "20-22h": 1,
                "432-434h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-24": 2,
                "2025-11-12": 5,
                "2025-11-13": 1,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-24": 10.050678611111111,
                "2025-11-12": 22.955045277777778,
                "2025-11-13": 0.09486527777777777,
                "2026-01-09": 432.37241,
                "2026-01-13": 19.113959444444443,
                "2026-02-12": 21.786188888888887
              },
              "time_count_per_day": {
                "2025-10-24": 2,
                "2025-11-12": 5,
                "2025-11-13": 1,
                "2026-01-09": 1,
                "2026-01-13": 1,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 135.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "8-10h": 2,
                "24-26h": 3,
                "26-28h": 1,
                "28-30h": 2,
                "32-34h": 1,
                "36-38h": 1,
                "38-40h": 1,
                "44-46h": 4,
                "48-50h": 1,
                "68-70h": 1,
                "70-72h": 1,
                "82-84h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "120-122h": 1,
                "126-128h": 1,
                "140-142h": 2,
                "146-148h": 1,
                "152-154h": 3,
                "168-170h": 1,
                "206-208h": 1,
                "212-214h": 1,
                "216-218h": 2,
                "220-222h": 1,
                "286-288h": 2,
                "310-312h": 3,
                "330-332h": 1,
                "332-334h": 2,
                "456-458h": 1,
                "500-502h": 1
              },
              "tickets_count": 50,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-27": 6,
                "2025-10-29": 4,
                "2025-10-30": 4,
                "2025-11-21": 1,
                "2026-01-08": 1,
                "2026-01-09": 1,
                "2026-01-23": 1,
                "2026-02-19": 2,
                "2026-02-21": 1,
                "2026-03-14": 1,
                "2026-03-17": 2,
                "2026-03-18": 18,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-10-07": 51.16104861111111,
                "2025-10-13": 147.16133861111112,
                "2025-10-15": 221.75005472222225,
                "2025-10-20": 28.631652777777777,
                "2025-10-22": 38.23141944444444,
                "2025-10-23": 26.31403638888889,
                "2025-10-27": 32.05432694444444,
                "2025-10-29": 179.50917083333334,
                "2025-10-30": 525.4561322222222,
                "2025-11-21": 101.69455805555555,
                "2026-01-08": 82.63133861111112,
                "2026-01-09": 103.69932555555555,
                "2026-01-23": 127.63344444444445,
                "2026-02-19": 79.38826166666666,
                "2026-02-21": 49.656299999999995,
                "2026-03-14": 24.603844722222224,
                "2026-03-17": 69.85618666666667,
                "2026-03-18": 4885.150487777779,
                "2026-03-24": 8.090398333333333
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-10-13": 1,
                "2025-10-15": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-10-23": 1,
                "2025-10-27": 6,
                "2025-10-29": 4,
                "2025-10-30": 4,
                "2025-11-21": 1,
                "2026-01-08": 1,
                "2026-01-09": 1,
                "2026-01-23": 1,
                "2026-02-19": 2,
                "2026-02-21": 1,
                "2026-03-14": 1,
                "2026-03-17": 2,
                "2026-03-18": 18,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 274.25,
              "mode_time_hours": 73.0,
              "mode_frequency": 4,
              "time_distribution": {
                "72-74h": 4,
                "160-162h": 1,
                "234-236h": 1,
                "236-238h": 2,
                "616-618h": 3
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-02-19": 11
              },
              "time_per_day": {
                "2026-02-19": 3016.7389522222225
              },
              "time_count_per_day": {
                "2026-02-19": 11
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-02-19": 5,
              "2026-03-02": 1,
              "2026-03-06": 2,
              "2026-03-09": 1,
              "2026-04-18": 1,
              "2026-04-28": 1,
              "2026-05-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-18": 1,
                "2026-04-28": 1,
                "2026-05-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-02-19": 5,
                "2026-03-02": 1,
                "2026-03-06": 2,
                "2026-03-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_146": {
      "overall": {
        "avg_time_hours": 199.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 17,
        "time_distribution": {
          "0-2h": 17,
          "2-4h": 9,
          "4-6h": 3,
          "6-8h": 2,
          "10-12h": 2,
          "14-16h": 1,
          "16-18h": 5,
          "18-20h": 2,
          "20-22h": 8,
          "22-24h": 7,
          "24-26h": 2,
          "26-28h": 1,
          "28-30h": 2,
          "30-32h": 5,
          "32-34h": 2,
          "34-36h": 1,
          "36-38h": 1,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "46-48h": 2,
          "54-56h": 1,
          "62-64h": 1,
          "64-66h": 1,
          "66-68h": 3,
          "68-70h": 2,
          "78-80h": 1,
          "82-84h": 1,
          "86-88h": 1,
          "88-90h": 1,
          "96-98h": 1,
          "100-102h": 2,
          "118-120h": 1,
          "134-136h": 1,
          "142-144h": 1,
          "144-146h": 1,
          "146-148h": 1,
          "168-170h": 1,
          "180-182h": 1,
          "182-184h": 1,
          "192-194h": 1,
          "212-214h": 1,
          "226-228h": 2,
          "274-276h": 1,
          "330-332h": 1,
          "332-334h": 1,
          "336-338h": 1,
          "338-340h": 1,
          "340-342h": 1,
          "358-360h": 1,
          "376-378h": 2,
          "386-388h": 1,
          "388-390h": 1,
          "392-394h": 1,
          "414-416h": 1,
          "416-418h": 1,
          "468-470h": 1,
          "502-504h": 1,
          "528-530h": 2,
          "598-600h": 1,
          "644-646h": 1,
          "664-666h": 1,
          "682-684h": 1,
          "698-700h": 1,
          "744-746h": 1,
          "818-820h": 1,
          "848-850h": 1,
          "916-918h": 1,
          "1178-1180h": 1,
          "1222-1224h": 1,
          "1376-1378h": 2,
          "1752-1754h": 1,
          "1942-1944h": 1
        },
        "tickets_count": 147,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-14": 1,
          "2025-10-23": 1,
          "2025-10-30": 1,
          "2025-11-04": 3,
          "2025-11-05": 1,
          "2025-11-06": 2,
          "2025-11-13": 2,
          "2025-11-17": 3,
          "2025-11-19": 1,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-26": 1,
          "2026-01-06": 1,
          "2026-01-07": 1,
          "2026-01-13": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-27": 5,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-05": 2,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-09": 2,
          "2026-02-10": 4,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-14": 2,
          "2026-02-16": 3,
          "2026-02-18": 1,
          "2026-02-19": 2,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-26": 1,
          "2026-02-28": 1,
          "2026-03-02": 3,
          "2026-03-03": 1,
          "2026-03-06": 2,
          "2026-03-10": 3,
          "2026-03-11": 2,
          "2026-03-17": 3,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-03-31": 6,
          "2026-04-01": 2,
          "2026-04-02": 1,
          "2026-04-08": 4,
          "2026-04-09": 6,
          "2026-04-10": 4,
          "2026-04-11": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-29": 3,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-04": 4,
          "2026-05-05": 2,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-23": 1,
          "2026-05-25": 3,
          "2026-05-26": 8,
          "2026-05-27": 2,
          "2026-05-30": 1,
          "2026-06-01": 2,
          "2026-06-02": 3,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-06": 0.9759191666666667,
          "2025-10-14": 2.485466666666667,
          "2025-10-23": 415.3416108333334,
          "2025-10-30": 27.01849222222222,
          "2025-11-04": 81.01974138888889,
          "2025-11-05": 43.18830083333334,
          "2025-11-06": 74.47344277777778,
          "2025-11-13": 127.02549138888888,
          "2025-11-17": 298.9758425,
          "2025-11-19": 377.3133897222222,
          "2025-12-09": 377.9919113888889,
          "2025-12-10": 147.0694436111111,
          "2025-12-12": 4.620699444444444,
          "2025-12-15": 119.98074083333334,
          "2025-12-17": 389.5099161111111,
          "2025-12-26": 1.3623505555555557,
          "2026-01-06": 7.795201388888889,
          "2026-01-07": 387.09173694444445,
          "2026-01-13": 30.582750555555556,
          "2026-01-19": 330.78853361111106,
          "2026-01-20": 22.4482375,
          "2026-01-27": 151.25738027777777,
          "2026-01-31": 23.14280472222222,
          "2026-02-03": 17.29978861111111,
          "2026-02-05": 3.60283,
          "2026-02-06": 22.82869638888889,
          "2026-02-07": 43.370150555555554,
          "2026-02-09": 166.9961675,
          "2026-02-10": 1103.764975,
          "2026-02-11": 536.3913777777777,
          "2026-02-12": 181.82719194444442,
          "2026-02-14": 134.5682613888889,
          "2026-02-16": 172.31808694444445,
          "2026-02-18": 28.517516388888886,
          "2026-02-19": 469.3319336111111,
          "2026-02-20": 337.4722947222222,
          "2026-02-21": 32.41282,
          "2026-02-26": 23.516940555555557,
          "2026-02-28": 21.345871111111112,
          "2026-03-02": 337.9838422222222,
          "2026-03-03": 40.08169722222222,
          "2026-03-06": 86.74204222222222,
          "2026-03-10": 755.5515119444444,
          "2026-03-11": 339.14156750000006,
          "2026-03-17": 1134.5802408333334,
          "2026-03-18": 358.1038941666667,
          "2026-03-20": 417.31557972222225,
          "2026-03-24": 11.3734375,
          "2026-03-27": 2.034214722222222,
          "2026-03-31": 708.1645111111111,
          "2026-04-01": 1878.8089994444445,
          "2026-04-02": 68.43143416666666,
          "2026-04-08": 233.90776277777778,
          "2026-04-09": 3309.465255,
          "2026-04-10": 3710.215033333333,
          "2026-04-11": 19.829509444444444,
          "2026-04-16": 1.421408611111111,
          "2026-04-17": 0.8591180555555555,
          "2026-04-22": 183.265175,
          "2026-04-23": 3719.975344722222,
          "2026-04-29": 1603.6185747222223,
          "2026-04-30": 46.41129222222222,
          "2026-05-02": 37.48311138888889,
          "2026-05-05": 819.9686313888889,
          "2026-05-06": 85.36269722222224,
          "2026-05-08": 144.90003027777777,
          "2026-05-20": 22.40508472222222,
          "2026-05-21": 35.24847027777778,
          "2026-05-22": 20.76068111111111,
          "2026-05-25": 2.627677222222222,
          "2026-05-26": 159.5029741666667,
          "2026-05-27": 6.264268611111111,
          "2026-05-30": 0.27215805555555556,
          "2026-06-01": 0.3175947222222222,
          "2026-06-02": 32.31187027777778
        },
        "time_count_per_day": {
          "2025-10-06": 1,
          "2025-10-14": 1,
          "2025-10-23": 1,
          "2025-10-30": 1,
          "2025-11-04": 3,
          "2025-11-05": 1,
          "2025-11-06": 2,
          "2025-11-13": 2,
          "2025-11-17": 3,
          "2025-11-19": 1,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-26": 1,
          "2026-01-06": 1,
          "2026-01-07": 1,
          "2026-01-13": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-27": 5,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-05": 2,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-09": 2,
          "2026-02-10": 4,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-14": 2,
          "2026-02-16": 3,
          "2026-02-18": 1,
          "2026-02-19": 2,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-26": 1,
          "2026-02-28": 1,
          "2026-03-02": 3,
          "2026-03-03": 1,
          "2026-03-06": 2,
          "2026-03-10": 2,
          "2026-03-11": 2,
          "2026-03-17": 3,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-03-31": 6,
          "2026-04-01": 2,
          "2026-04-02": 1,
          "2026-04-08": 4,
          "2026-04-09": 6,
          "2026-04-10": 4,
          "2026-04-11": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-29": 3,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 2,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-25": 2,
          "2026-05-26": 7,
          "2026-05-27": 2,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-02": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 70.69,
          "mode_time_hours": 55.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 1,
            "22-24h": 1,
            "54-56h": 1,
            "336-338h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-04": 2,
            "2025-12-26": 1,
            "2026-02-05": 1,
            "2026-02-20": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-11-04": 59.981136944444444,
            "2025-12-26": 1.3623505555555557,
            "2026-02-05": 2.1594544444444446,
            "2026-02-20": 337.4722947222222,
            "2026-05-26": 23.142966944444442
          },
          "time_count_per_day": {
            "2025-11-04": 2,
            "2025-12-26": 1,
            "2026-02-05": 1,
            "2026-02-20": 1,
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 177.57,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 8,
            "4-6h": 1,
            "10-12h": 2,
            "16-18h": 5,
            "18-20h": 2,
            "20-22h": 8,
            "22-24h": 5,
            "24-26h": 1,
            "26-28h": 1,
            "28-30h": 2,
            "32-34h": 2,
            "34-36h": 1,
            "36-38h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "46-48h": 2,
            "62-64h": 1,
            "64-66h": 1,
            "66-68h": 1,
            "68-70h": 2,
            "82-84h": 1,
            "88-90h": 1,
            "118-120h": 1,
            "134-136h": 1,
            "142-144h": 1,
            "144-146h": 1,
            "180-182h": 1,
            "182-184h": 1,
            "192-194h": 1,
            "212-214h": 1,
            "226-228h": 2,
            "274-276h": 1,
            "330-332h": 1,
            "332-334h": 1,
            "338-340h": 1,
            "340-342h": 1,
            "358-360h": 1,
            "376-378h": 2,
            "388-390h": 1,
            "392-394h": 1,
            "414-416h": 1,
            "416-418h": 1,
            "502-504h": 1,
            "528-530h": 2,
            "644-646h": 1,
            "664-666h": 1,
            "698-700h": 1,
            "744-746h": 1,
            "818-820h": 1,
            "848-850h": 1,
            "916-918h": 1,
            "1222-1224h": 1,
            "1942-1944h": 1
          },
          "tickets_count": 109,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-14": 1,
            "2025-10-23": 1,
            "2025-10-30": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-11-13": 2,
            "2025-11-19": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-02-05": 1,
            "2026-02-06": 1,
            "2026-02-10": 4,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-16": 2,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-03": 1,
            "2026-03-06": 2,
            "2026-03-10": 3,
            "2026-03-11": 2,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-03-31": 6,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-08": 4,
            "2026-04-09": 4,
            "2026-04-10": 4,
            "2026-04-11": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-29": 2,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-04": 4,
            "2026-05-05": 2,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-23": 1,
            "2026-05-25": 3,
            "2026-05-26": 7,
            "2026-05-27": 2,
            "2026-05-30": 1,
            "2026-06-01": 2,
            "2026-06-02": 3,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-06": 0.9759191666666667,
            "2025-10-14": 2.485466666666667,
            "2025-10-23": 415.3416108333334,
            "2025-10-30": 27.01849222222222,
            "2025-11-04": 21.03860444444444,
            "2025-11-06": 66.67919555555555,
            "2025-11-13": 127.02549138888888,
            "2025-11-19": 377.3133897222222,
            "2025-12-09": 377.9919113888889,
            "2025-12-15": 119.98074083333334,
            "2025-12-17": 389.5099161111111,
            "2026-01-19": 330.78853361111106,
            "2026-01-20": 22.4482375,
            "2026-02-05": 1.4433755555555556,
            "2026-02-06": 22.82869638888889,
            "2026-02-10": 1103.764975,
            "2026-02-11": 536.3913777777777,
            "2026-02-12": 181.82719194444442,
            "2026-02-16": 4.007662777777777,
            "2026-02-18": 28.517516388888886,
            "2026-02-19": 0.8088516666666666,
            "2026-02-21": 32.41282,
            "2026-02-26": 23.516940555555557,
            "2026-02-28": 21.345871111111112,
            "2026-03-02": 337.9838422222222,
            "2026-03-03": 40.08169722222222,
            "2026-03-06": 86.74204222222222,
            "2026-03-10": 755.5515119444444,
            "2026-03-11": 339.14156750000006,
            "2026-03-17": 534.8444411111111,
            "2026-03-18": 358.1038941666667,
            "2026-03-20": 417.31557972222225,
            "2026-03-24": 11.3734375,
            "2026-03-27": 2.034214722222222,
            "2026-03-31": 708.1645111111111,
            "2026-04-01": 699.4432083333332,
            "2026-04-02": 68.43143416666666,
            "2026-04-08": 233.90776277777778,
            "2026-04-09": 556.1929758333333,
            "2026-04-10": 3710.215033333333,
            "2026-04-11": 19.829509444444444,
            "2026-04-16": 1.421408611111111,
            "2026-04-17": 0.8591180555555555,
            "2026-04-22": 183.265175,
            "2026-04-23": 1967.5999252777779,
            "2026-04-29": 921.0155950000001,
            "2026-04-30": 46.41129222222222,
            "2026-05-02": 37.48311138888889,
            "2026-05-05": 819.9686313888889,
            "2026-05-06": 85.36269722222224,
            "2026-05-08": 144.90003027777777,
            "2026-05-20": 22.40508472222222,
            "2026-05-21": 35.24847027777778,
            "2026-05-22": 20.76068111111111,
            "2026-05-25": 2.627677222222222,
            "2026-05-26": 136.36000722222224,
            "2026-05-27": 6.264268611111111,
            "2026-05-30": 0.27215805555555556,
            "2026-06-01": 0.3175947222222222,
            "2026-06-02": 32.31187027777778
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2025-10-14": 1,
            "2025-10-23": 1,
            "2025-10-30": 1,
            "2025-11-04": 1,
            "2025-11-06": 1,
            "2025-11-13": 2,
            "2025-11-19": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-02-05": 1,
            "2026-02-06": 1,
            "2026-02-10": 4,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-16": 2,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-26": 1,
            "2026-02-28": 1,
            "2026-03-02": 3,
            "2026-03-03": 1,
            "2026-03-06": 2,
            "2026-03-10": 2,
            "2026-03-11": 2,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-03-31": 6,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-08": 4,
            "2026-04-09": 4,
            "2026-04-10": 4,
            "2026-04-11": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-29": 2,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 2,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 2,
            "2026-05-26": 6,
            "2026-05-27": 2,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-02": 3
          }
        },
        "P3": {
          "avg_time_hours": 286.65,
          "mode_time_hours": 31.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "6-8h": 2,
            "14-16h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "30-32h": 5,
            "42-44h": 2,
            "66-68h": 2,
            "78-80h": 1,
            "86-88h": 1,
            "96-98h": 1,
            "100-102h": 2,
            "146-148h": 1,
            "168-170h": 1,
            "386-388h": 1,
            "598-600h": 1,
            "682-684h": 1,
            "1178-1180h": 1,
            "1376-1378h": 2,
            "1752-1754h": 1
          },
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-17": 3,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-01-27": 5,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-03": 2,
            "2026-02-07": 1,
            "2026-02-09": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-03-17": 1,
            "2026-04-01": 1,
            "2026-04-09": 2,
            "2026-04-23": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2025-11-05": 43.18830083333334,
            "2025-11-06": 7.794247222222222,
            "2025-11-17": 298.9758425,
            "2025-12-10": 147.0694436111111,
            "2025-12-12": 4.620699444444444,
            "2026-01-06": 7.795201388888889,
            "2026-01-07": 387.09173694444445,
            "2026-01-13": 30.582750555555556,
            "2026-01-27": 151.25738027777777,
            "2026-01-31": 23.14280472222222,
            "2026-02-03": 17.29978861111111,
            "2026-02-07": 43.370150555555554,
            "2026-02-09": 166.9961675,
            "2026-02-14": 134.5682613888889,
            "2026-02-16": 168.31042416666668,
            "2026-03-17": 599.7357997222223,
            "2026-04-01": 1179.365791111111,
            "2026-04-09": 2753.2722791666665,
            "2026-04-23": 1752.3754194444443,
            "2026-04-29": 682.6029797222222
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-17": 3,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-13": 1,
            "2026-01-27": 5,
            "2026-01-31": 1,
            "2026-02-03": 2,
            "2026-02-07": 1,
            "2026-02-09": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-03-17": 1,
            "2026-04-01": 1,
            "2026-04-09": 2,
            "2026-04-23": 1,
            "2026-04-29": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 468.52,
          "mode_time_hours": 469.0,
          "mode_frequency": 1,
          "time_distribution": {
            "468-470h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 468.5230819444444
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 199.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 17,
            "time_distribution": {
              "0-2h": 17,
              "2-4h": 9,
              "4-6h": 3,
              "6-8h": 2,
              "10-12h": 2,
              "14-16h": 1,
              "16-18h": 5,
              "18-20h": 2,
              "20-22h": 8,
              "22-24h": 7,
              "24-26h": 2,
              "26-28h": 1,
              "28-30h": 2,
              "30-32h": 5,
              "32-34h": 2,
              "34-36h": 1,
              "36-38h": 1,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "46-48h": 2,
              "54-56h": 1,
              "62-64h": 1,
              "64-66h": 1,
              "66-68h": 3,
              "68-70h": 2,
              "78-80h": 1,
              "82-84h": 1,
              "86-88h": 1,
              "88-90h": 1,
              "96-98h": 1,
              "100-102h": 2,
              "118-120h": 1,
              "134-136h": 1,
              "142-144h": 1,
              "144-146h": 1,
              "146-148h": 1,
              "168-170h": 1,
              "180-182h": 1,
              "182-184h": 1,
              "192-194h": 1,
              "212-214h": 1,
              "226-228h": 2,
              "274-276h": 1,
              "330-332h": 1,
              "332-334h": 1,
              "336-338h": 1,
              "338-340h": 1,
              "340-342h": 1,
              "358-360h": 1,
              "376-378h": 2,
              "386-388h": 1,
              "388-390h": 1,
              "392-394h": 1,
              "414-416h": 1,
              "416-418h": 1,
              "468-470h": 1,
              "502-504h": 1,
              "528-530h": 2,
              "598-600h": 1,
              "644-646h": 1,
              "664-666h": 1,
              "682-684h": 1,
              "698-700h": 1,
              "744-746h": 1,
              "818-820h": 1,
              "848-850h": 1,
              "916-918h": 1,
              "1178-1180h": 1,
              "1222-1224h": 1,
              "1376-1378h": 2,
              "1752-1754h": 1,
              "1942-1944h": 1
            },
            "tickets_count": 136,
            "tickets_per_day": {
              "2025-10-06": 1,
              "2025-10-14": 1,
              "2025-10-23": 1,
              "2025-10-30": 1,
              "2025-11-04": 3,
              "2025-11-05": 1,
              "2025-11-06": 2,
              "2025-11-13": 2,
              "2025-11-17": 3,
              "2025-11-19": 1,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-26": 1,
              "2026-01-06": 1,
              "2026-01-07": 1,
              "2026-01-13": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-27": 5,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-05": 2,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-09": 2,
              "2026-02-10": 4,
              "2026-02-11": 2,
              "2026-02-12": 1,
              "2026-02-14": 2,
              "2026-02-16": 3,
              "2026-02-18": 1,
              "2026-02-19": 2,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-26": 1,
              "2026-02-28": 1,
              "2026-03-02": 3,
              "2026-03-03": 1,
              "2026-03-06": 2,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-17": 3,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-03-31": 6,
              "2026-04-01": 2,
              "2026-04-02": 1,
              "2026-04-08": 4,
              "2026-04-09": 6,
              "2026-04-10": 4,
              "2026-04-11": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-23": 3,
              "2026-04-29": 3,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 2,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 2,
              "2026-05-26": 7,
              "2026-05-27": 2,
              "2026-05-30": 1,
              "2026-06-01": 1,
              "2026-06-02": 3
            },
            "time_per_day": {
              "2025-10-06": 0.9759191666666667,
              "2025-10-14": 2.485466666666667,
              "2025-10-23": 415.3416108333334,
              "2025-10-30": 27.01849222222222,
              "2025-11-04": 81.01974138888889,
              "2025-11-05": 43.18830083333334,
              "2025-11-06": 74.47344277777778,
              "2025-11-13": 127.02549138888888,
              "2025-11-17": 298.9758425,
              "2025-11-19": 377.3133897222222,
              "2025-12-09": 377.9919113888889,
              "2025-12-10": 147.0694436111111,
              "2025-12-12": 4.620699444444444,
              "2025-12-15": 119.98074083333334,
              "2025-12-17": 389.5099161111111,
              "2025-12-26": 1.3623505555555557,
              "2026-01-06": 7.795201388888889,
              "2026-01-07": 387.09173694444445,
              "2026-01-13": 30.582750555555556,
              "2026-01-19": 330.78853361111106,
              "2026-01-20": 22.4482375,
              "2026-01-27": 151.25738027777777,
              "2026-01-31": 23.14280472222222,
              "2026-02-03": 17.29978861111111,
              "2026-02-05": 3.60283,
              "2026-02-06": 22.82869638888889,
              "2026-02-07": 43.370150555555554,
              "2026-02-09": 166.9961675,
              "2026-02-10": 1103.764975,
              "2026-02-11": 536.3913777777777,
              "2026-02-12": 181.82719194444442,
              "2026-02-14": 134.5682613888889,
              "2026-02-16": 172.31808694444445,
              "2026-02-18": 28.517516388888886,
              "2026-02-19": 469.3319336111111,
              "2026-02-20": 337.4722947222222,
              "2026-02-21": 32.41282,
              "2026-02-26": 23.516940555555557,
              "2026-02-28": 21.345871111111112,
              "2026-03-02": 337.9838422222222,
              "2026-03-03": 40.08169722222222,
              "2026-03-06": 86.74204222222222,
              "2026-03-10": 755.5515119444444,
              "2026-03-11": 339.14156750000006,
              "2026-03-17": 1134.5802408333334,
              "2026-03-18": 358.1038941666667,
              "2026-03-20": 417.31557972222225,
              "2026-03-24": 11.3734375,
              "2026-03-27": 2.034214722222222,
              "2026-03-31": 708.1645111111111,
              "2026-04-01": 1878.8089994444445,
              "2026-04-02": 68.43143416666666,
              "2026-04-08": 233.90776277777778,
              "2026-04-09": 3309.465255,
              "2026-04-10": 3710.215033333333,
              "2026-04-11": 19.829509444444444,
              "2026-04-16": 1.421408611111111,
              "2026-04-17": 0.8591180555555555,
              "2026-04-22": 183.265175,
              "2026-04-23": 3719.975344722222,
              "2026-04-29": 1603.6185747222223,
              "2026-04-30": 46.41129222222222,
              "2026-05-02": 37.48311138888889,
              "2026-05-05": 819.9686313888889,
              "2026-05-06": 85.36269722222224,
              "2026-05-08": 144.90003027777777,
              "2026-05-20": 22.40508472222222,
              "2026-05-21": 35.24847027777778,
              "2026-05-22": 20.76068111111111,
              "2026-05-25": 2.627677222222222,
              "2026-05-26": 159.5029741666667,
              "2026-05-27": 6.264268611111111,
              "2026-05-30": 0.27215805555555556,
              "2026-06-01": 0.3175947222222222,
              "2026-06-02": 32.31187027777778
            },
            "time_count_per_day": {
              "2025-10-06": 1,
              "2025-10-14": 1,
              "2025-10-23": 1,
              "2025-10-30": 1,
              "2025-11-04": 3,
              "2025-11-05": 1,
              "2025-11-06": 2,
              "2025-11-13": 2,
              "2025-11-17": 3,
              "2025-11-19": 1,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-26": 1,
              "2026-01-06": 1,
              "2026-01-07": 1,
              "2026-01-13": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-27": 5,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-05": 2,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-09": 2,
              "2026-02-10": 4,
              "2026-02-11": 2,
              "2026-02-12": 1,
              "2026-02-14": 2,
              "2026-02-16": 3,
              "2026-02-18": 1,
              "2026-02-19": 2,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-26": 1,
              "2026-02-28": 1,
              "2026-03-02": 3,
              "2026-03-03": 1,
              "2026-03-06": 2,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-17": 3,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-03-31": 6,
              "2026-04-01": 2,
              "2026-04-02": 1,
              "2026-04-08": 4,
              "2026-04-09": 6,
              "2026-04-10": 4,
              "2026-04-11": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-23": 3,
              "2026-04-29": 3,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 2,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-25": 2,
              "2026-05-26": 7,
              "2026-05-27": 2,
              "2026-05-30": 1,
              "2026-06-01": 1,
              "2026-06-02": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 70.69,
              "mode_time_hours": 55.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 1,
                "22-24h": 1,
                "54-56h": 1,
                "336-338h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-04": 2,
                "2025-12-26": 1,
                "2026-02-05": 1,
                "2026-02-20": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-11-04": 59.981136944444444,
                "2025-12-26": 1.3623505555555557,
                "2026-02-05": 2.1594544444444446,
                "2026-02-20": 337.4722947222222,
                "2026-05-26": 23.142966944444442
              },
              "time_count_per_day": {
                "2025-11-04": 2,
                "2025-12-26": 1,
                "2026-02-05": 1,
                "2026-02-20": 1,
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 177.57,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 8,
                "4-6h": 1,
                "10-12h": 2,
                "16-18h": 5,
                "18-20h": 2,
                "20-22h": 8,
                "22-24h": 5,
                "24-26h": 1,
                "26-28h": 1,
                "28-30h": 2,
                "32-34h": 2,
                "34-36h": 1,
                "36-38h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "46-48h": 2,
                "62-64h": 1,
                "64-66h": 1,
                "66-68h": 1,
                "68-70h": 2,
                "82-84h": 1,
                "88-90h": 1,
                "118-120h": 1,
                "134-136h": 1,
                "142-144h": 1,
                "144-146h": 1,
                "180-182h": 1,
                "182-184h": 1,
                "192-194h": 1,
                "212-214h": 1,
                "226-228h": 2,
                "274-276h": 1,
                "330-332h": 1,
                "332-334h": 1,
                "338-340h": 1,
                "340-342h": 1,
                "358-360h": 1,
                "376-378h": 2,
                "388-390h": 1,
                "392-394h": 1,
                "414-416h": 1,
                "416-418h": 1,
                "502-504h": 1,
                "528-530h": 2,
                "644-646h": 1,
                "664-666h": 1,
                "698-700h": 1,
                "744-746h": 1,
                "818-820h": 1,
                "848-850h": 1,
                "916-918h": 1,
                "1222-1224h": 1,
                "1942-1944h": 1
              },
              "tickets_count": 99,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2025-10-14": 1,
                "2025-10-23": 1,
                "2025-10-30": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-11-13": 2,
                "2025-11-19": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-02-05": 1,
                "2026-02-06": 1,
                "2026-02-10": 4,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-16": 2,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-03": 1,
                "2026-03-06": 2,
                "2026-03-10": 2,
                "2026-03-11": 2,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-03-31": 6,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-08": 4,
                "2026-04-09": 4,
                "2026-04-10": 4,
                "2026-04-11": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-29": 2,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 2,
                "2026-05-06": 2,
                "2026-05-08": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 2,
                "2026-05-26": 6,
                "2026-05-27": 2,
                "2026-05-30": 1,
                "2026-06-01": 1,
                "2026-06-02": 3
              },
              "time_per_day": {
                "2025-10-06": 0.9759191666666667,
                "2025-10-14": 2.485466666666667,
                "2025-10-23": 415.3416108333334,
                "2025-10-30": 27.01849222222222,
                "2025-11-04": 21.03860444444444,
                "2025-11-06": 66.67919555555555,
                "2025-11-13": 127.02549138888888,
                "2025-11-19": 377.3133897222222,
                "2025-12-09": 377.9919113888889,
                "2025-12-15": 119.98074083333334,
                "2025-12-17": 389.5099161111111,
                "2026-01-19": 330.78853361111106,
                "2026-01-20": 22.4482375,
                "2026-02-05": 1.4433755555555556,
                "2026-02-06": 22.82869638888889,
                "2026-02-10": 1103.764975,
                "2026-02-11": 536.3913777777777,
                "2026-02-12": 181.82719194444442,
                "2026-02-16": 4.007662777777777,
                "2026-02-18": 28.517516388888886,
                "2026-02-19": 0.8088516666666666,
                "2026-02-21": 32.41282,
                "2026-02-26": 23.516940555555557,
                "2026-02-28": 21.345871111111112,
                "2026-03-02": 337.9838422222222,
                "2026-03-03": 40.08169722222222,
                "2026-03-06": 86.74204222222222,
                "2026-03-10": 755.5515119444444,
                "2026-03-11": 339.14156750000006,
                "2026-03-17": 534.8444411111111,
                "2026-03-18": 358.1038941666667,
                "2026-03-20": 417.31557972222225,
                "2026-03-24": 11.3734375,
                "2026-03-27": 2.034214722222222,
                "2026-03-31": 708.1645111111111,
                "2026-04-01": 699.4432083333332,
                "2026-04-02": 68.43143416666666,
                "2026-04-08": 233.90776277777778,
                "2026-04-09": 556.1929758333333,
                "2026-04-10": 3710.215033333333,
                "2026-04-11": 19.829509444444444,
                "2026-04-16": 1.421408611111111,
                "2026-04-17": 0.8591180555555555,
                "2026-04-22": 183.265175,
                "2026-04-23": 1967.5999252777779,
                "2026-04-29": 921.0155950000001,
                "2026-04-30": 46.41129222222222,
                "2026-05-02": 37.48311138888889,
                "2026-05-05": 819.9686313888889,
                "2026-05-06": 85.36269722222224,
                "2026-05-08": 144.90003027777777,
                "2026-05-20": 22.40508472222222,
                "2026-05-21": 35.24847027777778,
                "2026-05-22": 20.76068111111111,
                "2026-05-25": 2.627677222222222,
                "2026-05-26": 136.36000722222224,
                "2026-05-27": 6.264268611111111,
                "2026-05-30": 0.27215805555555556,
                "2026-06-01": 0.3175947222222222,
                "2026-06-02": 32.31187027777778
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2025-10-14": 1,
                "2025-10-23": 1,
                "2025-10-30": 1,
                "2025-11-04": 1,
                "2025-11-06": 1,
                "2025-11-13": 2,
                "2025-11-19": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-02-05": 1,
                "2026-02-06": 1,
                "2026-02-10": 4,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-16": 2,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-26": 1,
                "2026-02-28": 1,
                "2026-03-02": 3,
                "2026-03-03": 1,
                "2026-03-06": 2,
                "2026-03-10": 2,
                "2026-03-11": 2,
                "2026-03-17": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-03-31": 6,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-08": 4,
                "2026-04-09": 4,
                "2026-04-10": 4,
                "2026-04-11": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-29": 2,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 2,
                "2026-05-06": 2,
                "2026-05-08": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 2,
                "2026-05-26": 6,
                "2026-05-27": 2,
                "2026-05-30": 1,
                "2026-06-01": 1,
                "2026-06-02": 3
              }
            },
            "P3": {
              "avg_time_hours": 286.65,
              "mode_time_hours": 31.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "6-8h": 2,
                "14-16h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "30-32h": 5,
                "42-44h": 2,
                "66-68h": 2,
                "78-80h": 1,
                "86-88h": 1,
                "96-98h": 1,
                "100-102h": 2,
                "146-148h": 1,
                "168-170h": 1,
                "386-388h": 1,
                "598-600h": 1,
                "682-684h": 1,
                "1178-1180h": 1,
                "1376-1378h": 2,
                "1752-1754h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-17": 3,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2026-01-06": 1,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-01-27": 5,
                "2026-01-31": 1,
                "2026-02-03": 2,
                "2026-02-07": 1,
                "2026-02-09": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-03-17": 1,
                "2026-04-01": 1,
                "2026-04-09": 2,
                "2026-04-23": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2025-11-05": 43.18830083333334,
                "2025-11-06": 7.794247222222222,
                "2025-11-17": 298.9758425,
                "2025-12-10": 147.0694436111111,
                "2025-12-12": 4.620699444444444,
                "2026-01-06": 7.795201388888889,
                "2026-01-07": 387.09173694444445,
                "2026-01-13": 30.582750555555556,
                "2026-01-27": 151.25738027777777,
                "2026-01-31": 23.14280472222222,
                "2026-02-03": 17.29978861111111,
                "2026-02-07": 43.370150555555554,
                "2026-02-09": 166.9961675,
                "2026-02-14": 134.5682613888889,
                "2026-02-16": 168.31042416666668,
                "2026-03-17": 599.7357997222223,
                "2026-04-01": 1179.365791111111,
                "2026-04-09": 2753.2722791666665,
                "2026-04-23": 1752.3754194444443,
                "2026-04-29": 682.6029797222222
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-17": 3,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2026-01-06": 1,
                "2026-01-07": 1,
                "2026-01-13": 1,
                "2026-01-27": 5,
                "2026-01-31": 1,
                "2026-02-03": 2,
                "2026-02-07": 1,
                "2026-02-09": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-03-17": 1,
                "2026-04-01": 1,
                "2026-04-09": 2,
                "2026-04-23": 1,
                "2026-04-29": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 468.52,
              "mode_time_hours": 469.0,
              "mode_frequency": 1,
              "time_distribution": {
                "468-470h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 468.5230819444444
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-05-04": 2,
              "2026-05-23": 1,
              "2026-05-25": 1,
              "2026-05-26": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-05-04": 2,
                "2026-05-23": 1,
                "2026-05-25": 1,
                "2026-05-26": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-04": 2,
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-04": 2,
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Reminder": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_147": {
      "overall": {
        "avg_time_hours": 8.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 57,
        "time_distribution": {
          "0-2h": 57,
          "2-4h": 47,
          "4-6h": 12,
          "6-8h": 8,
          "8-10h": 6,
          "10-12h": 2,
          "14-16h": 1,
          "16-18h": 3,
          "20-22h": 3,
          "22-24h": 1,
          "26-28h": 3,
          "32-34h": 1,
          "50-52h": 3,
          "52-54h": 1,
          "58-60h": 1,
          "66-68h": 1,
          "78-80h": 1,
          "86-88h": 1,
          "132-134h": 1
        },
        "tickets_count": 157,
        "tickets_per_day": {
          "2025-10-07": 3,
          "2025-11-03": 4,
          "2025-11-13": 1,
          "2025-11-14": 3,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2025-12-22": 1,
          "2025-12-23": 3,
          "2025-12-30": 1,
          "2026-01-05": 1,
          "2026-01-09": 5,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-15": 2,
          "2026-01-16": 4,
          "2026-01-20": 2,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 2,
          "2026-01-30": 2,
          "2026-02-05": 2,
          "2026-02-06": 2,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-24": 5,
          "2026-02-26": 1,
          "2026-02-27": 4,
          "2026-02-28": 3,
          "2026-03-02": 4,
          "2026-03-04": 3,
          "2026-03-07": 4,
          "2026-03-09": 2,
          "2026-03-10": 5,
          "2026-03-18": 3,
          "2026-03-19": 3,
          "2026-03-20": 1,
          "2026-03-21": 1,
          "2026-03-23": 1,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-01": 4,
          "2026-04-06": 2,
          "2026-04-07": 2,
          "2026-04-11": 2,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 2,
          "2026-04-16": 1,
          "2026-04-17": 3,
          "2026-04-20": 1,
          "2026-04-22": 4,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-04": 2,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-13": 5,
          "2026-05-15": 4,
          "2026-05-26": 1,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-05-30": 2,
          "2026-06-02": 1,
          "2026-06-03": 2,
          "2026-06-05": 7,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-07": 65.54655777777778,
          "2025-11-03": 20.292850833333333,
          "2025-11-13": 0.21041027777777777,
          "2025-11-14": 24.710502499999997,
          "2025-11-17": 67.69819111111111,
          "2025-12-11": 1.2360983333333333,
          "2025-12-22": 2.9039744444444446,
          "2025-12-23": 22.281386111111114,
          "2025-12-30": 1.1534608333333334,
          "2026-01-05": 0.9842747222222222,
          "2026-01-09": 18.002256944444444,
          "2026-01-13": 1.624206388888889,
          "2026-01-14": 6.4595713888888895,
          "2026-01-15": 9.507886388888888,
          "2026-01-16": 13.864643888888889,
          "2026-01-20": 4.880712222222222,
          "2026-01-23": 3.1495727777777778,
          "2026-01-26": 78.34979388888888,
          "2026-01-27": 5.817144722222222,
          "2026-01-30": 5.340994444444444,
          "2026-02-05": 17.25394777777778,
          "2026-02-06": 12.531790277777777,
          "2026-02-10": 1.7528355555555555,
          "2026-02-13": 0.12919611111111112,
          "2026-02-17": 3.087729166666667,
          "2026-02-18": 3.627032222222222,
          "2026-02-24": 38.622545833333334,
          "2026-02-26": 1.1834647222222223,
          "2026-02-27": 36.44901888888889,
          "2026-02-28": 5.815738333333334,
          "2026-03-02": 283.2482983333333,
          "2026-03-04": 3.5799725000000002,
          "2026-03-07": 6.534774166666668,
          "2026-03-09": 3.0894130555555552,
          "2026-03-10": 13.06464861111111,
          "2026-03-18": 38.598010555555554,
          "2026-03-19": 7.276661111111111,
          "2026-03-20": 0.3363041666666666,
          "2026-03-21": 1.000944722222222,
          "2026-03-23": 52.25689611111111,
          "2026-03-24": 5.817843333333333,
          "2026-03-25": 1.7772686111111113,
          "2026-03-27": 1.3802869444444446,
          "2026-03-30": 58.622865000000004,
          "2026-03-31": 2.278225833333333,
          "2026-04-01": 28.825283333333335,
          "2026-04-06": 2.2074794444444445,
          "2026-04-07": 6.786682777777777,
          "2026-04-11": 0.49276472222222223,
          "2026-04-13": 8.957980555555555,
          "2026-04-14": 6.492314444444444,
          "2026-04-15": 12.041764166666667,
          "2026-04-16": 6.578950833333334,
          "2026-04-17": 10.653747777777777,
          "2026-04-20": 0.4264413888888889,
          "2026-04-22": 55.15054416666667,
          "2026-04-27": 6.159803611111111,
          "2026-04-29": 0.4581388888888889,
          "2026-04-30": 5.016957499999999,
          "2026-05-04": 89.65489388888889,
          "2026-05-05": 2.2329866666666667,
          "2026-05-06": 6.288303055555556,
          "2026-05-13": 19.510711944444445,
          "2026-05-15": 6.539066666666667,
          "2026-05-26": 0.11411805555555556,
          "2026-05-27": 16.304256944444443,
          "2026-05-28": 2.771505,
          "2026-05-30": 1.5548647222222223,
          "2026-06-02": 0.1942688888888889,
          "2026-06-03": 10.826877777777778,
          "2026-06-05": 1.6295080555555552,
          "2026-06-08": 1.6706805555555555
        },
        "time_count_per_day": {
          "2025-10-07": 3,
          "2025-11-03": 4,
          "2025-11-13": 1,
          "2025-11-14": 3,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2025-12-22": 1,
          "2025-12-23": 3,
          "2025-12-30": 1,
          "2026-01-05": 1,
          "2026-01-09": 5,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-15": 2,
          "2026-01-16": 4,
          "2026-01-20": 2,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 2,
          "2026-01-30": 2,
          "2026-02-05": 2,
          "2026-02-06": 2,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-24": 5,
          "2026-02-26": 1,
          "2026-02-27": 4,
          "2026-02-28": 3,
          "2026-03-02": 4,
          "2026-03-04": 3,
          "2026-03-07": 4,
          "2026-03-09": 2,
          "2026-03-10": 4,
          "2026-03-18": 3,
          "2026-03-19": 3,
          "2026-03-20": 1,
          "2026-03-21": 1,
          "2026-03-23": 1,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-01": 4,
          "2026-04-06": 2,
          "2026-04-07": 2,
          "2026-04-11": 2,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 2,
          "2026-04-16": 1,
          "2026-04-17": 3,
          "2026-04-20": 1,
          "2026-04-22": 4,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-04": 2,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-13": 5,
          "2026-05-15": 4,
          "2026-05-26": 1,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-05-30": 2,
          "2026-06-02": 1,
          "2026-06-03": 2,
          "2026-06-05": 4,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 6.17,
          "mode_time_hours": 3.0,
          "mode_frequency": 34,
          "time_distribution": {
            "0-2h": 27,
            "2-4h": 34,
            "4-6h": 10,
            "6-8h": 4,
            "8-10h": 3,
            "10-12h": 1,
            "16-18h": 3,
            "20-22h": 1,
            "22-24h": 1,
            "26-28h": 3,
            "52-54h": 1,
            "78-80h": 1
          },
          "tickets_count": 89,
          "tickets_per_day": {
            "2025-10-07": 2,
            "2025-11-03": 3,
            "2025-11-14": 1,
            "2025-12-11": 1,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-16": 3,
            "2026-01-26": 1,
            "2026-01-27": 2,
            "2026-01-30": 2,
            "2026-02-05": 2,
            "2026-02-06": 1,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 2,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-02-27": 4,
            "2026-02-28": 3,
            "2026-03-04": 2,
            "2026-03-07": 3,
            "2026-03-09": 2,
            "2026-03-10": 4,
            "2026-03-18": 3,
            "2026-03-19": 3,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-24": 2,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-04-07": 2,
            "2026-04-14": 2,
            "2026-04-15": 2,
            "2026-04-17": 3,
            "2026-04-22": 2,
            "2026-04-30": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-13": 5,
            "2026-05-15": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-10-07": 33.365229444444445,
            "2025-11-03": 13.880092222222222,
            "2025-11-14": 1.8822536111111112,
            "2025-12-11": 1.2360983333333333,
            "2026-01-09": 10.136113333333332,
            "2026-01-13": 1.624206388888889,
            "2026-01-14": 6.4595713888888895,
            "2026-01-15": 9.21332,
            "2026-01-16": 9.957765555555556,
            "2026-01-26": 78.34979388888888,
            "2026-01-27": 5.817144722222222,
            "2026-01-30": 5.340994444444444,
            "2026-02-05": 17.25394777777778,
            "2026-02-06": 8.327862222222222,
            "2026-02-10": 1.7528355555555555,
            "2026-02-13": 0.12919611111111112,
            "2026-02-17": 3.087729166666667,
            "2026-02-18": 3.627032222222222,
            "2026-02-24": 20.912975000000003,
            "2026-02-26": 1.1834647222222223,
            "2026-02-27": 36.44901888888889,
            "2026-02-28": 5.815738333333334,
            "2026-03-04": 1.685161111111111,
            "2026-03-07": 6.08331388888889,
            "2026-03-09": 3.0894130555555552,
            "2026-03-10": 13.06464861111111,
            "2026-03-18": 38.598010555555554,
            "2026-03-19": 7.276661111111111,
            "2026-03-20": 0.3363041666666666,
            "2026-03-23": 52.25689611111111,
            "2026-03-24": 5.817843333333333,
            "2026-03-27": 1.3802869444444446,
            "2026-03-31": 2.278225833333333,
            "2026-04-01": 2.394913888888889,
            "2026-04-06": 2.2074794444444445,
            "2026-04-07": 6.786682777777777,
            "2026-04-14": 6.492314444444444,
            "2026-04-15": 12.041764166666667,
            "2026-04-17": 10.653747777777777,
            "2026-04-22": 54.931830833333336,
            "2026-04-30": 5.016957499999999,
            "2026-05-05": 2.2211966666666667,
            "2026-05-06": 6.288303055555556,
            "2026-05-13": 19.510711944444445,
            "2026-05-15": 0.5954644444444445,
            "2026-05-26": 0.11411805555555556,
            "2026-05-27": 7.520459166666666,
            "2026-05-28": 2.771505,
            "2026-06-05": 1.5251916666666665
          },
          "time_count_per_day": {
            "2025-10-07": 2,
            "2025-11-03": 3,
            "2025-11-14": 1,
            "2025-12-11": 1,
            "2026-01-09": 2,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-16": 3,
            "2026-01-26": 1,
            "2026-01-27": 2,
            "2026-01-30": 2,
            "2026-02-05": 2,
            "2026-02-06": 1,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 2,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-02-27": 4,
            "2026-02-28": 3,
            "2026-03-04": 2,
            "2026-03-07": 3,
            "2026-03-09": 2,
            "2026-03-10": 4,
            "2026-03-18": 3,
            "2026-03-19": 3,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-24": 2,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-04-07": 2,
            "2026-04-14": 2,
            "2026-04-15": 2,
            "2026-04-17": 3,
            "2026-04-22": 2,
            "2026-04-30": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-13": 5,
            "2026-05-15": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-06-05": 2
          }
        },
        "P2": {
          "avg_time_hours": 10.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 30,
          "time_distribution": {
            "0-2h": 30,
            "2-4h": 12,
            "4-6h": 2,
            "6-8h": 4,
            "8-10h": 3,
            "10-12h": 1,
            "14-16h": 1,
            "20-22h": 2,
            "50-52h": 3,
            "58-60h": 1,
            "66-68h": 1,
            "86-88h": 1,
            "132-134h": 1
          },
          "tickets_count": 65,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2025-11-13": 1,
            "2025-11-14": 2,
            "2025-11-17": 1,
            "2025-12-22": 1,
            "2025-12-23": 3,
            "2025-12-30": 1,
            "2026-01-05": 1,
            "2026-01-09": 3,
            "2026-01-15": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-02-06": 1,
            "2026-02-24": 4,
            "2026-03-02": 4,
            "2026-03-04": 1,
            "2026-03-07": 1,
            "2026-03-21": 1,
            "2026-03-25": 2,
            "2026-03-30": 1,
            "2026-04-01": 3,
            "2026-04-11": 2,
            "2026-04-13": 2,
            "2026-04-16": 1,
            "2026-04-20": 1,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-15": 3,
            "2026-05-27": 2,
            "2026-05-30": 2,
            "2026-06-02": 1,
            "2026-06-03": 2,
            "2026-06-05": 5,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-03": 6.412758611111111,
            "2025-11-13": 0.21041027777777777,
            "2025-11-14": 22.828248888888886,
            "2025-11-17": 67.69819111111111,
            "2025-12-22": 2.9039744444444446,
            "2025-12-23": 22.281386111111114,
            "2025-12-30": 1.1534608333333334,
            "2026-01-05": 0.9842747222222222,
            "2026-01-09": 7.866143611111111,
            "2026-01-15": 0.2945663888888889,
            "2026-01-20": 4.880712222222222,
            "2026-01-23": 3.1495727777777778,
            "2026-02-06": 4.203928055555555,
            "2026-02-24": 17.709570833333334,
            "2026-03-02": 283.2482983333333,
            "2026-03-04": 1.894811388888889,
            "2026-03-07": 0.4514602777777778,
            "2026-03-21": 1.000944722222222,
            "2026-03-25": 1.7772686111111113,
            "2026-03-30": 58.622865000000004,
            "2026-04-01": 26.430369444444445,
            "2026-04-11": 0.49276472222222223,
            "2026-04-13": 8.957980555555555,
            "2026-04-16": 6.578950833333334,
            "2026-04-20": 0.4264413888888889,
            "2026-04-22": 0.21871333333333332,
            "2026-04-27": 6.159803611111111,
            "2026-04-29": 0.4581388888888889,
            "2026-05-04": 89.65489388888889,
            "2026-05-05": 0.01179,
            "2026-05-15": 5.943602222222222,
            "2026-05-27": 8.783797777777778,
            "2026-05-30": 1.5548647222222223,
            "2026-06-02": 0.1942688888888889,
            "2026-06-03": 10.826877777777778,
            "2026-06-05": 0.10431638888888889,
            "2026-06-08": 1.6706805555555555
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2025-11-13": 1,
            "2025-11-14": 2,
            "2025-11-17": 1,
            "2025-12-22": 1,
            "2025-12-23": 3,
            "2025-12-30": 1,
            "2026-01-05": 1,
            "2026-01-09": 3,
            "2026-01-15": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-02-06": 1,
            "2026-02-24": 4,
            "2026-03-02": 4,
            "2026-03-04": 1,
            "2026-03-07": 1,
            "2026-03-21": 1,
            "2026-03-25": 2,
            "2026-03-30": 1,
            "2026-04-01": 3,
            "2026-04-11": 2,
            "2026-04-13": 2,
            "2026-04-16": 1,
            "2026-04-20": 1,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-15": 3,
            "2026-05-27": 2,
            "2026-05-30": 2,
            "2026-06-02": 1,
            "2026-06-03": 2,
            "2026-06-05": 2,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 18.04,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "32-34h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2026-01-16": 1
          },
          "time_per_day": {
            "2025-10-07": 32.18132833333333,
            "2026-01-16": 3.9068783333333337
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2026-01-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-10": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 57,
            "time_distribution": {
              "0-2h": 57,
              "2-4h": 47,
              "4-6h": 12,
              "6-8h": 8,
              "8-10h": 6,
              "10-12h": 2,
              "14-16h": 1,
              "16-18h": 3,
              "20-22h": 3,
              "22-24h": 1,
              "26-28h": 3,
              "32-34h": 1,
              "50-52h": 3,
              "52-54h": 1,
              "58-60h": 1,
              "66-68h": 1,
              "78-80h": 1,
              "86-88h": 1,
              "132-134h": 1
            },
            "tickets_count": 153,
            "tickets_per_day": {
              "2025-10-07": 3,
              "2025-11-03": 4,
              "2025-11-13": 1,
              "2025-11-14": 3,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2025-12-22": 1,
              "2025-12-23": 3,
              "2025-12-30": 1,
              "2026-01-05": 1,
              "2026-01-09": 5,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-15": 2,
              "2026-01-16": 4,
              "2026-01-20": 2,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 2,
              "2026-01-30": 2,
              "2026-02-05": 2,
              "2026-02-06": 2,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-24": 5,
              "2026-02-26": 1,
              "2026-02-27": 4,
              "2026-02-28": 3,
              "2026-03-02": 4,
              "2026-03-04": 3,
              "2026-03-07": 4,
              "2026-03-09": 2,
              "2026-03-10": 4,
              "2026-03-18": 3,
              "2026-03-19": 3,
              "2026-03-20": 1,
              "2026-03-21": 1,
              "2026-03-23": 1,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-01": 4,
              "2026-04-06": 2,
              "2026-04-07": 2,
              "2026-04-11": 2,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 2,
              "2026-04-16": 1,
              "2026-04-17": 3,
              "2026-04-20": 1,
              "2026-04-22": 4,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-04": 2,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-13": 5,
              "2026-05-15": 4,
              "2026-05-26": 1,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-30": 2,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 4,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-07": 65.54655777777778,
              "2025-11-03": 20.292850833333333,
              "2025-11-13": 0.21041027777777777,
              "2025-11-14": 24.710502499999997,
              "2025-11-17": 67.69819111111111,
              "2025-12-11": 1.2360983333333333,
              "2025-12-22": 2.9039744444444446,
              "2025-12-23": 22.281386111111114,
              "2025-12-30": 1.1534608333333334,
              "2026-01-05": 0.9842747222222222,
              "2026-01-09": 18.002256944444444,
              "2026-01-13": 1.624206388888889,
              "2026-01-14": 6.4595713888888895,
              "2026-01-15": 9.507886388888888,
              "2026-01-16": 13.864643888888889,
              "2026-01-20": 4.880712222222222,
              "2026-01-23": 3.1495727777777778,
              "2026-01-26": 78.34979388888888,
              "2026-01-27": 5.817144722222222,
              "2026-01-30": 5.340994444444444,
              "2026-02-05": 17.25394777777778,
              "2026-02-06": 12.531790277777777,
              "2026-02-10": 1.7528355555555555,
              "2026-02-13": 0.12919611111111112,
              "2026-02-17": 3.087729166666667,
              "2026-02-18": 3.627032222222222,
              "2026-02-24": 38.622545833333334,
              "2026-02-26": 1.1834647222222223,
              "2026-02-27": 36.44901888888889,
              "2026-02-28": 5.815738333333334,
              "2026-03-02": 283.2482983333333,
              "2026-03-04": 3.5799725000000002,
              "2026-03-07": 6.534774166666668,
              "2026-03-09": 3.0894130555555552,
              "2026-03-10": 13.06464861111111,
              "2026-03-18": 38.598010555555554,
              "2026-03-19": 7.276661111111111,
              "2026-03-20": 0.3363041666666666,
              "2026-03-21": 1.000944722222222,
              "2026-03-23": 52.25689611111111,
              "2026-03-24": 5.817843333333333,
              "2026-03-25": 1.7772686111111113,
              "2026-03-27": 1.3802869444444446,
              "2026-03-30": 58.622865000000004,
              "2026-03-31": 2.278225833333333,
              "2026-04-01": 28.825283333333335,
              "2026-04-06": 2.2074794444444445,
              "2026-04-07": 6.786682777777777,
              "2026-04-11": 0.49276472222222223,
              "2026-04-13": 8.957980555555555,
              "2026-04-14": 6.492314444444444,
              "2026-04-15": 12.041764166666667,
              "2026-04-16": 6.578950833333334,
              "2026-04-17": 10.653747777777777,
              "2026-04-20": 0.4264413888888889,
              "2026-04-22": 55.15054416666667,
              "2026-04-27": 6.159803611111111,
              "2026-04-29": 0.4581388888888889,
              "2026-04-30": 5.016957499999999,
              "2026-05-04": 89.65489388888889,
              "2026-05-05": 2.2329866666666667,
              "2026-05-06": 6.288303055555556,
              "2026-05-13": 19.510711944444445,
              "2026-05-15": 6.539066666666667,
              "2026-05-26": 0.11411805555555556,
              "2026-05-27": 16.304256944444443,
              "2026-05-28": 2.771505,
              "2026-05-30": 1.5548647222222223,
              "2026-06-02": 0.1942688888888889,
              "2026-06-03": 10.826877777777778,
              "2026-06-05": 1.6295080555555552,
              "2026-06-08": 1.6706805555555555
            },
            "time_count_per_day": {
              "2025-10-07": 3,
              "2025-11-03": 4,
              "2025-11-13": 1,
              "2025-11-14": 3,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2025-12-22": 1,
              "2025-12-23": 3,
              "2025-12-30": 1,
              "2026-01-05": 1,
              "2026-01-09": 5,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-15": 2,
              "2026-01-16": 4,
              "2026-01-20": 2,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 2,
              "2026-01-30": 2,
              "2026-02-05": 2,
              "2026-02-06": 2,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-24": 5,
              "2026-02-26": 1,
              "2026-02-27": 4,
              "2026-02-28": 3,
              "2026-03-02": 4,
              "2026-03-04": 3,
              "2026-03-07": 4,
              "2026-03-09": 2,
              "2026-03-10": 4,
              "2026-03-18": 3,
              "2026-03-19": 3,
              "2026-03-20": 1,
              "2026-03-21": 1,
              "2026-03-23": 1,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-01": 4,
              "2026-04-06": 2,
              "2026-04-07": 2,
              "2026-04-11": 2,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 2,
              "2026-04-16": 1,
              "2026-04-17": 3,
              "2026-04-20": 1,
              "2026-04-22": 4,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-04": 2,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-13": 5,
              "2026-05-15": 4,
              "2026-05-26": 1,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-30": 2,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 4,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 6.17,
              "mode_time_hours": 3.0,
              "mode_frequency": 34,
              "time_distribution": {
                "0-2h": 27,
                "2-4h": 34,
                "4-6h": 10,
                "6-8h": 4,
                "8-10h": 3,
                "10-12h": 1,
                "16-18h": 3,
                "20-22h": 1,
                "22-24h": 1,
                "26-28h": 3,
                "52-54h": 1,
                "78-80h": 1
              },
              "tickets_count": 89,
              "tickets_per_day": {
                "2025-10-07": 2,
                "2025-11-03": 3,
                "2025-11-14": 1,
                "2025-12-11": 1,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-16": 3,
                "2026-01-26": 1,
                "2026-01-27": 2,
                "2026-01-30": 2,
                "2026-02-05": 2,
                "2026-02-06": 1,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 2,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-02-27": 4,
                "2026-02-28": 3,
                "2026-03-04": 2,
                "2026-03-07": 3,
                "2026-03-09": 2,
                "2026-03-10": 4,
                "2026-03-18": 3,
                "2026-03-19": 3,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-24": 2,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-04-07": 2,
                "2026-04-14": 2,
                "2026-04-15": 2,
                "2026-04-17": 3,
                "2026-04-22": 2,
                "2026-04-30": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-13": 5,
                "2026-05-15": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-10-07": 33.365229444444445,
                "2025-11-03": 13.880092222222222,
                "2025-11-14": 1.8822536111111112,
                "2025-12-11": 1.2360983333333333,
                "2026-01-09": 10.136113333333332,
                "2026-01-13": 1.624206388888889,
                "2026-01-14": 6.4595713888888895,
                "2026-01-15": 9.21332,
                "2026-01-16": 9.957765555555556,
                "2026-01-26": 78.34979388888888,
                "2026-01-27": 5.817144722222222,
                "2026-01-30": 5.340994444444444,
                "2026-02-05": 17.25394777777778,
                "2026-02-06": 8.327862222222222,
                "2026-02-10": 1.7528355555555555,
                "2026-02-13": 0.12919611111111112,
                "2026-02-17": 3.087729166666667,
                "2026-02-18": 3.627032222222222,
                "2026-02-24": 20.912975000000003,
                "2026-02-26": 1.1834647222222223,
                "2026-02-27": 36.44901888888889,
                "2026-02-28": 5.815738333333334,
                "2026-03-04": 1.685161111111111,
                "2026-03-07": 6.08331388888889,
                "2026-03-09": 3.0894130555555552,
                "2026-03-10": 13.06464861111111,
                "2026-03-18": 38.598010555555554,
                "2026-03-19": 7.276661111111111,
                "2026-03-20": 0.3363041666666666,
                "2026-03-23": 52.25689611111111,
                "2026-03-24": 5.817843333333333,
                "2026-03-27": 1.3802869444444446,
                "2026-03-31": 2.278225833333333,
                "2026-04-01": 2.394913888888889,
                "2026-04-06": 2.2074794444444445,
                "2026-04-07": 6.786682777777777,
                "2026-04-14": 6.492314444444444,
                "2026-04-15": 12.041764166666667,
                "2026-04-17": 10.653747777777777,
                "2026-04-22": 54.931830833333336,
                "2026-04-30": 5.016957499999999,
                "2026-05-05": 2.2211966666666667,
                "2026-05-06": 6.288303055555556,
                "2026-05-13": 19.510711944444445,
                "2026-05-15": 0.5954644444444445,
                "2026-05-26": 0.11411805555555556,
                "2026-05-27": 7.520459166666666,
                "2026-05-28": 2.771505,
                "2026-06-05": 1.5251916666666665
              },
              "time_count_per_day": {
                "2025-10-07": 2,
                "2025-11-03": 3,
                "2025-11-14": 1,
                "2025-12-11": 1,
                "2026-01-09": 2,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-16": 3,
                "2026-01-26": 1,
                "2026-01-27": 2,
                "2026-01-30": 2,
                "2026-02-05": 2,
                "2026-02-06": 1,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 2,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-02-27": 4,
                "2026-02-28": 3,
                "2026-03-04": 2,
                "2026-03-07": 3,
                "2026-03-09": 2,
                "2026-03-10": 4,
                "2026-03-18": 3,
                "2026-03-19": 3,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-24": 2,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-04-07": 2,
                "2026-04-14": 2,
                "2026-04-15": 2,
                "2026-04-17": 3,
                "2026-04-22": 2,
                "2026-04-30": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-13": 5,
                "2026-05-15": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-06-05": 2
              }
            },
            "P2": {
              "avg_time_hours": 10.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 30,
              "time_distribution": {
                "0-2h": 30,
                "2-4h": 12,
                "4-6h": 2,
                "6-8h": 4,
                "8-10h": 3,
                "10-12h": 1,
                "14-16h": 1,
                "20-22h": 2,
                "50-52h": 3,
                "58-60h": 1,
                "66-68h": 1,
                "86-88h": 1,
                "132-134h": 1
              },
              "tickets_count": 62,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2025-11-13": 1,
                "2025-11-14": 2,
                "2025-11-17": 1,
                "2025-12-22": 1,
                "2025-12-23": 3,
                "2025-12-30": 1,
                "2026-01-05": 1,
                "2026-01-09": 3,
                "2026-01-15": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-02-06": 1,
                "2026-02-24": 4,
                "2026-03-02": 4,
                "2026-03-04": 1,
                "2026-03-07": 1,
                "2026-03-21": 1,
                "2026-03-25": 2,
                "2026-03-30": 1,
                "2026-04-01": 3,
                "2026-04-11": 2,
                "2026-04-13": 2,
                "2026-04-16": 1,
                "2026-04-20": 1,
                "2026-04-22": 2,
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-15": 3,
                "2026-05-27": 2,
                "2026-05-30": 2,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 2,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-11-03": 6.412758611111111,
                "2025-11-13": 0.21041027777777777,
                "2025-11-14": 22.828248888888886,
                "2025-11-17": 67.69819111111111,
                "2025-12-22": 2.9039744444444446,
                "2025-12-23": 22.281386111111114,
                "2025-12-30": 1.1534608333333334,
                "2026-01-05": 0.9842747222222222,
                "2026-01-09": 7.866143611111111,
                "2026-01-15": 0.2945663888888889,
                "2026-01-20": 4.880712222222222,
                "2026-01-23": 3.1495727777777778,
                "2026-02-06": 4.203928055555555,
                "2026-02-24": 17.709570833333334,
                "2026-03-02": 283.2482983333333,
                "2026-03-04": 1.894811388888889,
                "2026-03-07": 0.4514602777777778,
                "2026-03-21": 1.000944722222222,
                "2026-03-25": 1.7772686111111113,
                "2026-03-30": 58.622865000000004,
                "2026-04-01": 26.430369444444445,
                "2026-04-11": 0.49276472222222223,
                "2026-04-13": 8.957980555555555,
                "2026-04-16": 6.578950833333334,
                "2026-04-20": 0.4264413888888889,
                "2026-04-22": 0.21871333333333332,
                "2026-04-27": 6.159803611111111,
                "2026-04-29": 0.4581388888888889,
                "2026-05-04": 89.65489388888889,
                "2026-05-05": 0.01179,
                "2026-05-15": 5.943602222222222,
                "2026-05-27": 8.783797777777778,
                "2026-05-30": 1.5548647222222223,
                "2026-06-02": 0.1942688888888889,
                "2026-06-03": 10.826877777777778,
                "2026-06-05": 0.10431638888888889,
                "2026-06-08": 1.6706805555555555
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2025-11-13": 1,
                "2025-11-14": 2,
                "2025-11-17": 1,
                "2025-12-22": 1,
                "2025-12-23": 3,
                "2025-12-30": 1,
                "2026-01-05": 1,
                "2026-01-09": 3,
                "2026-01-15": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-02-06": 1,
                "2026-02-24": 4,
                "2026-03-02": 4,
                "2026-03-04": 1,
                "2026-03-07": 1,
                "2026-03-21": 1,
                "2026-03-25": 2,
                "2026-03-30": 1,
                "2026-04-01": 3,
                "2026-04-11": 2,
                "2026-04-13": 2,
                "2026-04-16": 1,
                "2026-04-20": 1,
                "2026-04-22": 2,
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-15": 3,
                "2026-05-27": 2,
                "2026-05-30": 2,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 2,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 18.04,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "32-34h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2026-01-16": 1
              },
              "time_per_day": {
                "2025-10-07": 32.18132833333333,
                "2026-01-16": 3.9068783333333337
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2026-01-16": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-06-05": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-06-05": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_149": {
      "overall": {
        "avg_time_hours": 69.26,
        "mode_time_hours": 31.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "8-10h": 1,
          "30-32h": 1,
          "60-62h": 1,
          "244-246h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-11-14": 1,
          "2025-11-24": 1,
          "2026-01-16": 1,
          "2026-02-07": 1
        },
        "time_per_day": {
          "2025-10-07": 31.6909725,
          "2025-11-14": 8.36436,
          "2025-11-24": 244.57251805555555,
          "2026-01-16": 0.8463838888888889,
          "2026-02-07": 60.8426225
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-11-14": 1,
          "2025-11-24": 1,
          "2026-01-16": 1,
          "2026-02-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.27,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "30-32h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2026-01-16": 1
          },
          "time_per_day": {
            "2025-10-07": 31.6909725,
            "2026-01-16": 0.8463838888888889
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2026-01-16": 1
          }
        },
        "P3": {
          "avg_time_hours": 104.59,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "60-62h": 1,
            "244-246h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-11-24": 1,
            "2026-02-07": 1
          },
          "time_per_day": {
            "2025-11-14": 8.36436,
            "2025-11-24": 244.57251805555555,
            "2026-02-07": 60.8426225
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2025-11-24": 1,
            "2026-02-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 69.26,
            "mode_time_hours": 31.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "8-10h": 1,
              "30-32h": 1,
              "60-62h": 1,
              "244-246h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-11-14": 1,
              "2025-11-24": 1,
              "2026-01-16": 1,
              "2026-02-07": 1
            },
            "time_per_day": {
              "2025-10-07": 31.6909725,
              "2025-11-14": 8.36436,
              "2025-11-24": 244.57251805555555,
              "2026-01-16": 0.8463838888888889,
              "2026-02-07": 60.8426225
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-11-14": 1,
              "2025-11-24": 1,
              "2026-01-16": 1,
              "2026-02-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.27,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "30-32h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2026-01-16": 1
              },
              "time_per_day": {
                "2025-10-07": 31.6909725,
                "2026-01-16": 0.8463838888888889
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2026-01-16": 1
              }
            },
            "P3": {
              "avg_time_hours": 104.59,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "60-62h": 1,
                "244-246h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-11-24": 1,
                "2026-02-07": 1
              },
              "time_per_day": {
                "2025-11-14": 8.36436,
                "2025-11-24": 244.57251805555555,
                "2026-02-07": 60.8426225
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2025-11-24": 1,
                "2026-02-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_151": {
      "overall": {
        "avg_time_hours": 146.55,
        "mode_time_hours": 679.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1,
          "16-18h": 1,
          "24-26h": 1,
          "42-44h": 1,
          "62-64h": 1,
          "182-184h": 1,
          "678-680h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-11-03": 1,
          "2025-11-04": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-27": 1,
          "2026-01-07": 1,
          "2026-04-07": 1
        },
        "time_per_day": {
          "2025-11-03": 679.9636252777777,
          "2025-11-04": 16.9992325,
          "2025-11-07": 43.01398638888889,
          "2025-11-17": 182.4813725,
          "2025-11-27": 13.615293888888887,
          "2026-01-07": 25.995112777777777,
          "2026-04-07": 63.77263
        },
        "time_count_per_day": {
          "2025-11-03": 1,
          "2025-11-04": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-11-27": 1,
          "2026-01-07": 1,
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 63.98,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "16-18h": 1,
            "42-44h": 1,
            "62-64h": 1,
            "182-184h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-11-07": 1,
            "2025-11-17": 1,
            "2025-11-27": 1,
            "2026-04-07": 1
          },
          "time_per_day": {
            "2025-11-04": 16.9992325,
            "2025-11-07": 43.01398638888889,
            "2025-11-17": 182.4813725,
            "2025-11-27": 13.615293888888887,
            "2026-04-07": 63.77263
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-11-07": 1,
            "2025-11-17": 1,
            "2025-11-27": 1,
            "2026-04-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 352.98,
          "mode_time_hours": 679.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "678-680h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2026-01-07": 1
          },
          "time_per_day": {
            "2025-11-03": 679.9636252777777,
            "2026-01-07": 25.995112777777777
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 146.55,
            "mode_time_hours": 679.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1,
              "16-18h": 1,
              "24-26h": 1,
              "42-44h": 1,
              "62-64h": 1,
              "182-184h": 1,
              "678-680h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-03": 1,
              "2025-11-04": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-27": 1,
              "2026-01-07": 1,
              "2026-04-07": 1
            },
            "time_per_day": {
              "2025-11-03": 679.9636252777777,
              "2025-11-04": 16.9992325,
              "2025-11-07": 43.01398638888889,
              "2025-11-17": 182.4813725,
              "2025-11-27": 13.615293888888887,
              "2026-01-07": 25.995112777777777,
              "2026-04-07": 63.77263
            },
            "time_count_per_day": {
              "2025-11-03": 1,
              "2025-11-04": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-11-27": 1,
              "2026-01-07": 1,
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 63.98,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "16-18h": 1,
                "42-44h": 1,
                "62-64h": 1,
                "182-184h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-11-07": 1,
                "2025-11-17": 1,
                "2025-11-27": 1,
                "2026-04-07": 1
              },
              "time_per_day": {
                "2025-11-04": 16.9992325,
                "2025-11-07": 43.01398638888889,
                "2025-11-17": 182.4813725,
                "2025-11-27": 13.615293888888887,
                "2026-04-07": 63.77263
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-11-07": 1,
                "2025-11-17": 1,
                "2025-11-27": 1,
                "2026-04-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 352.98,
              "mode_time_hours": 679.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "678-680h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2026-01-07": 1
              },
              "time_per_day": {
                "2025-11-03": 679.9636252777777,
                "2026-01-07": 25.995112777777777
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_152": {
      "overall": {
        "avg_time_hours": 77.36,
        "mode_time_hours": 97.0,
        "mode_frequency": 3,
        "time_distribution": {
          "2-4h": 1,
          "72-74h": 1,
          "96-98h": 3,
          "98-100h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-10-09": 1,
          "2025-11-21": 3,
          "2025-11-22": 1,
          "2025-11-24": 1
        },
        "time_per_day": {
          "2025-10-09": 73.28236361111112,
          "2025-11-21": 289.4660430555556,
          "2025-11-22": 3.430708888888889,
          "2025-11-24": 98.0036638888889
        },
        "time_count_per_day": {
          "2025-10-09": 1,
          "2025-11-21": 3,
          "2025-11-22": 1,
          "2025-11-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 92.15,
          "mode_time_hours": 97.0,
          "mode_frequency": 3,
          "time_distribution": {
            "72-74h": 1,
            "96-98h": 3,
            "98-100h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-11-21": 3,
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-10-09": 73.28236361111112,
            "2025-11-21": 289.4660430555556,
            "2025-11-24": 98.0036638888889
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-11-21": 3,
            "2025-11-24": 1
          }
        },
        "P3": {
          "avg_time_hours": 3.43,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-22": 1
          },
          "time_per_day": {
            "2025-11-22": 3.430708888888889
          },
          "time_count_per_day": {
            "2025-11-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 77.36,
            "mode_time_hours": 97.0,
            "mode_frequency": 3,
            "time_distribution": {
              "2-4h": 1,
              "72-74h": 1,
              "96-98h": 3,
              "98-100h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-09": 1,
              "2025-11-21": 3,
              "2025-11-22": 1,
              "2025-11-24": 1
            },
            "time_per_day": {
              "2025-10-09": 73.28236361111112,
              "2025-11-21": 289.4660430555556,
              "2025-11-22": 3.430708888888889,
              "2025-11-24": 98.0036638888889
            },
            "time_count_per_day": {
              "2025-10-09": 1,
              "2025-11-21": 3,
              "2025-11-22": 1,
              "2025-11-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 92.15,
              "mode_time_hours": 97.0,
              "mode_frequency": 3,
              "time_distribution": {
                "72-74h": 1,
                "96-98h": 3,
                "98-100h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-11-21": 3,
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-10-09": 73.28236361111112,
                "2025-11-21": 289.4660430555556,
                "2025-11-24": 98.0036638888889
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-11-21": 3,
                "2025-11-24": 1
              }
            },
            "P3": {
              "avg_time_hours": 3.43,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-22": 1
              },
              "time_per_day": {
                "2025-11-22": 3.430708888888889
              },
              "time_count_per_day": {
                "2025-11-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_46": {
      "overall": {
        "avg_time_hours": 413.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "1238-1240h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-26": 1,
          "2026-05-19": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2025-11-26": 1238.4102363888887,
          "2026-05-19": 0.03550861111111111,
          "2026-05-20": 1.8878122222222222
        },
        "time_count_per_day": {
          "2025-11-26": 1,
          "2026-05-19": 1,
          "2026-05-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.96,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-19": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2026-05-19": 0.03550861111111111,
            "2026-05-20": 1.8878122222222222
          },
          "time_count_per_day": {
            "2026-05-19": 1,
            "2026-05-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 1238.41,
          "mode_time_hours": 1239.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1238-1240h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-26": 1
          },
          "time_per_day": {
            "2025-11-26": 1238.4102363888887
          },
          "time_count_per_day": {
            "2025-11-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 413.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "1238-1240h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-26": 1,
              "2026-05-19": 1,
              "2026-05-20": 1
            },
            "time_per_day": {
              "2025-11-26": 1238.4102363888887,
              "2026-05-19": 0.03550861111111111,
              "2026-05-20": 1.8878122222222222
            },
            "time_count_per_day": {
              "2025-11-26": 1,
              "2026-05-19": 1,
              "2026-05-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.96,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-19": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2026-05-19": 0.03550861111111111,
                "2026-05-20": 1.8878122222222222
              },
              "time_count_per_day": {
                "2026-05-19": 1,
                "2026-05-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 1238.41,
              "mode_time_hours": 1239.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1238-1240h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-26": 1
              },
              "time_per_day": {
                "2025-11-26": 1238.4102363888887
              },
              "time_count_per_day": {
                "2025-11-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_154": {
      "overall": {
        "avg_time_hours": 736.9,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "42-44h": 1,
          "2902-2904h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-06": 2,
          "2026-01-14": 1,
          "2026-03-17": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2025-10-06": 1.9164602777777777,
          "2026-01-14": 42.92236694444445,
          "2026-05-06": 2902.7574966666666
        },
        "time_count_per_day": {
          "2025-10-06": 2,
          "2026-01-14": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 42.92,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 42.92236694444445
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 0.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2025-10-06": 0.9812525
          },
          "time_count_per_day": {
            "2025-10-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 1451.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2902-2904h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2025-10-06": 0.9352077777777777,
            "2026-05-06": 2902.7574966666666
          },
          "time_count_per_day": {
            "2025-10-06": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 736.9,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "42-44h": 1,
              "2902-2904h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-06": 2,
              "2026-01-14": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2025-10-06": 1.9164602777777777,
              "2026-01-14": 42.92236694444445,
              "2026-05-06": 2902.7574966666666
            },
            "time_count_per_day": {
              "2025-10-06": 2,
              "2026-01-14": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 42.92,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 42.92236694444445
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 0.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-06": 1
              },
              "time_per_day": {
                "2025-10-06": 0.9812525
              },
              "time_count_per_day": {
                "2025-10-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 1451.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2902-2904h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-06": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2025-10-06": 0.9352077777777777,
                "2026-05-06": 2902.7574966666666
              },
              "time_count_per_day": {
                "2025-10-06": 1,
                "2026-05-06": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_155": {
      "overall": {
        "avg_time_hours": 2.6,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-06": 1
        },
        "time_per_day": {
          "2025-10-06": 2.599463611111111
        },
        "time_count_per_day": {
          "2025-10-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 2.6,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-06": 1
          },
          "time_per_day": {
            "2025-10-06": 2.599463611111111
          },
          "time_count_per_day": {
            "2025-10-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.6,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-06": 1
            },
            "time_per_day": {
              "2025-10-06": 2.599463611111111
            },
            "time_count_per_day": {
              "2025-10-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 2.6,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-06": 1
              },
              "time_per_day": {
                "2025-10-06": 2.599463611111111
              },
              "time_count_per_day": {
                "2025-10-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_32": {
      "overall": {
        "avg_time_hours": 273.19,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "6-8h": 1,
          "10-12h": 1,
          "16-18h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "40-42h": 1,
          "42-44h": 1,
          "44-46h": 1,
          "48-50h": 1,
          "90-92h": 1,
          "92-94h": 1,
          "100-102h": 1,
          "118-120h": 1,
          "164-166h": 1,
          "170-172h": 1,
          "208-210h": 1,
          "222-224h": 1,
          "270-272h": 1,
          "312-314h": 1,
          "342-344h": 1,
          "350-352h": 2,
          "362-364h": 1,
          "430-432h": 1,
          "508-510h": 1,
          "526-528h": 1,
          "612-614h": 1,
          "628-630h": 1,
          "722-724h": 2,
          "800-802h": 1,
          "844-846h": 1,
          "942-944h": 1,
          "1038-1040h": 1,
          "1284-1286h": 1
        },
        "tickets_count": 51,
        "tickets_per_day": {
          "2025-10-13": 1,
          "2025-10-21": 1,
          "2025-10-31": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-24": 2,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-02": 1,
          "2025-12-11": 1,
          "2025-12-13": 1,
          "2025-12-14": 1,
          "2025-12-24": 1,
          "2026-01-27": 5,
          "2026-02-03": 1,
          "2026-02-04": 2,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-03-06": 2,
          "2026-03-09": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-31": 2,
          "2026-04-17": 1,
          "2026-04-22": 2,
          "2026-04-23": 2,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-21": 1,
          "2026-05-26": 2,
          "2026-05-28": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-13": 165.92957305555555,
          "2025-10-21": 24.18856527777778,
          "2025-10-31": 20.805091666666666,
          "2025-11-18": 1038.1988544444446,
          "2025-11-19": 209.8194497222222,
          "2025-11-24": 132.90473222222224,
          "2025-11-26": 2.902953333333333,
          "2025-11-28": 100.72201944444446,
          "2025-12-02": 343.22092944444444,
          "2025-12-11": 26.807891666666666,
          "2025-12-13": 723.7227094444445,
          "2025-12-14": 49.814701944444444,
          "2025-12-24": 170.59455694444446,
          "2026-01-27": 132.47264777777778,
          "2026-02-03": 11.811334166666667,
          "2026-02-04": 45.54291722222222,
          "2026-02-12": 2086.807980833333,
          "2026-02-13": 701.4008791666665,
          "2026-02-16": 3.6192627777777777,
          "2026-02-17": 17.690678055555555,
          "2026-02-18": 612.036431111111,
          "2026-03-06": 431.5190733333334,
          "2026-03-09": 628.7509808333333,
          "2026-03-17": 270.83455805555553,
          "2026-03-20": 942.8671769444444,
          "2026-03-23": 7.843434166666667,
          "2026-03-31": 529.6389891666666,
          "2026-04-17": 40.56012166666667,
          "2026-04-22": 722.8892583333334,
          "2026-04-23": 1352.8398516666666,
          "2026-04-30": 222.6879761111111,
          "2026-05-06": 312.51828333333333,
          "2026-05-14": 362.7454133333333,
          "2026-05-18": 119.77859972222221,
          "2026-05-26": 0.3280225
        },
        "time_count_per_day": {
          "2025-10-13": 1,
          "2025-10-21": 1,
          "2025-10-31": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-24": 2,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-02": 1,
          "2025-12-11": 1,
          "2025-12-13": 1,
          "2025-12-14": 1,
          "2025-12-24": 1,
          "2026-01-27": 5,
          "2026-02-03": 1,
          "2026-02-04": 2,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-31": 2,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-26": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 175.4,
          "mode_time_hours": 351.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "350-352h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-04": 1,
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-04": 0.11294499999999999,
            "2026-02-13": 350.6950444444444
          },
          "time_count_per_day": {
            "2026-02-04": 1,
            "2026-02-13": 1
          }
        },
        "P2": {
          "avg_time_hours": 265.71,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "6-8h": 1,
            "16-18h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "90-92h": 1,
            "118-120h": 1,
            "164-166h": 1,
            "208-210h": 1,
            "222-224h": 1,
            "270-272h": 1,
            "312-314h": 1,
            "350-352h": 1,
            "362-364h": 1,
            "430-432h": 1,
            "508-510h": 1,
            "526-528h": 1,
            "612-614h": 1,
            "722-724h": 1,
            "800-802h": 1,
            "844-846h": 1,
            "942-944h": 1
          },
          "tickets_count": 34,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-10-21": 1,
            "2025-10-31": 1,
            "2025-11-19": 1,
            "2025-11-24": 2,
            "2025-11-26": 1,
            "2026-01-27": 1,
            "2026-02-04": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-06": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-22": 2,
            "2026-04-23": 2,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-26": 2,
            "2026-05-28": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-13": 165.92957305555555,
            "2025-10-21": 24.18856527777778,
            "2025-10-31": 20.805091666666666,
            "2025-11-19": 209.8194497222222,
            "2025-11-24": 132.90473222222224,
            "2025-11-26": 2.902953333333333,
            "2026-01-27": 2.4480194444444447,
            "2026-02-04": 45.42997222222222,
            "2026-02-12": 801.9345480555556,
            "2026-02-13": 350.70583472222216,
            "2026-02-16": 3.6192627777777777,
            "2026-02-17": 17.690678055555555,
            "2026-02-18": 612.036431111111,
            "2026-03-06": 431.5190733333334,
            "2026-03-17": 270.83455805555553,
            "2026-03-20": 942.8671769444444,
            "2026-03-23": 7.843434166666667,
            "2026-03-31": 527.8205691666667,
            "2026-04-17": 40.56012166666667,
            "2026-04-22": 722.8892583333334,
            "2026-04-23": 1352.8398516666666,
            "2026-04-30": 222.6879761111111,
            "2026-05-06": 312.51828333333333,
            "2026-05-14": 362.7454133333333,
            "2026-05-18": 119.77859972222221,
            "2026-05-26": 0.3280225
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-10-21": 1,
            "2025-10-31": 1,
            "2025-11-19": 1,
            "2025-11-24": 2,
            "2025-11-26": 1,
            "2026-01-27": 1,
            "2026-02-04": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-06": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-26": 2
          }
        },
        "P3": {
          "avg_time_hours": 300.69,
          "mode_time_hours": 19.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "10-12h": 1,
            "18-20h": 2,
            "26-28h": 1,
            "48-50h": 1,
            "92-94h": 1,
            "100-102h": 1,
            "170-172h": 1,
            "342-344h": 1,
            "628-630h": 1,
            "722-724h": 1,
            "1038-1040h": 1,
            "1284-1286h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-13": 1,
            "2025-12-14": 1,
            "2025-12-24": 1,
            "2026-01-27": 4,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-03-09": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-11-18": 1038.1988544444446,
            "2025-11-28": 100.72201944444446,
            "2025-12-02": 343.22092944444444,
            "2025-12-11": 26.807891666666666,
            "2025-12-13": 723.7227094444445,
            "2025-12-14": 49.814701944444444,
            "2025-12-24": 170.59455694444446,
            "2026-01-27": 130.02462833333334,
            "2026-02-03": 11.811334166666667,
            "2026-02-12": 1284.8734327777777,
            "2026-03-09": 628.7509808333333,
            "2026-03-31": 1.81842
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-13": 1,
            "2025-12-14": 1,
            "2025-12-24": 1,
            "2026-01-27": 4,
            "2026-02-03": 1,
            "2026-02-12": 1,
            "2026-03-09": 1,
            "2026-03-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 273.19,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "6-8h": 1,
              "10-12h": 1,
              "16-18h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "40-42h": 1,
              "42-44h": 1,
              "44-46h": 1,
              "48-50h": 1,
              "90-92h": 1,
              "92-94h": 1,
              "100-102h": 1,
              "118-120h": 1,
              "164-166h": 1,
              "170-172h": 1,
              "208-210h": 1,
              "222-224h": 1,
              "270-272h": 1,
              "312-314h": 1,
              "342-344h": 1,
              "350-352h": 2,
              "362-364h": 1,
              "430-432h": 1,
              "508-510h": 1,
              "526-528h": 1,
              "612-614h": 1,
              "628-630h": 1,
              "722-724h": 2,
              "800-802h": 1,
              "844-846h": 1,
              "942-944h": 1,
              "1038-1040h": 1,
              "1284-1286h": 1
            },
            "tickets_count": 46,
            "tickets_per_day": {
              "2025-10-13": 1,
              "2025-10-21": 1,
              "2025-10-31": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-24": 2,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-02": 1,
              "2025-12-11": 1,
              "2025-12-13": 1,
              "2025-12-14": 1,
              "2025-12-24": 1,
              "2026-01-27": 5,
              "2026-02-03": 1,
              "2026-02-04": 2,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-31": 2,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-26": 2
            },
            "time_per_day": {
              "2025-10-13": 165.92957305555555,
              "2025-10-21": 24.18856527777778,
              "2025-10-31": 20.805091666666666,
              "2025-11-18": 1038.1988544444446,
              "2025-11-19": 209.8194497222222,
              "2025-11-24": 132.90473222222224,
              "2025-11-26": 2.902953333333333,
              "2025-11-28": 100.72201944444446,
              "2025-12-02": 343.22092944444444,
              "2025-12-11": 26.807891666666666,
              "2025-12-13": 723.7227094444445,
              "2025-12-14": 49.814701944444444,
              "2025-12-24": 170.59455694444446,
              "2026-01-27": 132.47264777777778,
              "2026-02-03": 11.811334166666667,
              "2026-02-04": 45.54291722222222,
              "2026-02-12": 2086.807980833333,
              "2026-02-13": 701.4008791666665,
              "2026-02-16": 3.6192627777777777,
              "2026-02-17": 17.690678055555555,
              "2026-02-18": 612.036431111111,
              "2026-03-06": 431.5190733333334,
              "2026-03-09": 628.7509808333333,
              "2026-03-17": 270.83455805555553,
              "2026-03-20": 942.8671769444444,
              "2026-03-23": 7.843434166666667,
              "2026-03-31": 529.6389891666666,
              "2026-04-17": 40.56012166666667,
              "2026-04-22": 722.8892583333334,
              "2026-04-23": 1352.8398516666666,
              "2026-04-30": 222.6879761111111,
              "2026-05-06": 312.51828333333333,
              "2026-05-14": 362.7454133333333,
              "2026-05-18": 119.77859972222221,
              "2026-05-26": 0.3280225
            },
            "time_count_per_day": {
              "2025-10-13": 1,
              "2025-10-21": 1,
              "2025-10-31": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-24": 2,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-02": 1,
              "2025-12-11": 1,
              "2025-12-13": 1,
              "2025-12-14": 1,
              "2025-12-24": 1,
              "2026-01-27": 5,
              "2026-02-03": 1,
              "2026-02-04": 2,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-31": 2,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-26": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 175.4,
              "mode_time_hours": 351.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "350-352h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-04": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-04": 0.11294499999999999,
                "2026-02-13": 350.6950444444444
              },
              "time_count_per_day": {
                "2026-02-04": 1,
                "2026-02-13": 1
              }
            },
            "P2": {
              "avg_time_hours": 265.71,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "6-8h": 1,
                "16-18h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "90-92h": 1,
                "118-120h": 1,
                "164-166h": 1,
                "208-210h": 1,
                "222-224h": 1,
                "270-272h": 1,
                "312-314h": 1,
                "350-352h": 1,
                "362-364h": 1,
                "430-432h": 1,
                "508-510h": 1,
                "526-528h": 1,
                "612-614h": 1,
                "722-724h": 1,
                "800-802h": 1,
                "844-846h": 1,
                "942-944h": 1
              },
              "tickets_count": 29,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-10-21": 1,
                "2025-10-31": 1,
                "2025-11-19": 1,
                "2025-11-24": 2,
                "2025-11-26": 1,
                "2026-01-27": 1,
                "2026-02-04": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-26": 2
              },
              "time_per_day": {
                "2025-10-13": 165.92957305555555,
                "2025-10-21": 24.18856527777778,
                "2025-10-31": 20.805091666666666,
                "2025-11-19": 209.8194497222222,
                "2025-11-24": 132.90473222222224,
                "2025-11-26": 2.902953333333333,
                "2026-01-27": 2.4480194444444447,
                "2026-02-04": 45.42997222222222,
                "2026-02-12": 801.9345480555556,
                "2026-02-13": 350.70583472222216,
                "2026-02-16": 3.6192627777777777,
                "2026-02-17": 17.690678055555555,
                "2026-02-18": 612.036431111111,
                "2026-03-06": 431.5190733333334,
                "2026-03-17": 270.83455805555553,
                "2026-03-20": 942.8671769444444,
                "2026-03-23": 7.843434166666667,
                "2026-03-31": 527.8205691666667,
                "2026-04-17": 40.56012166666667,
                "2026-04-22": 722.8892583333334,
                "2026-04-23": 1352.8398516666666,
                "2026-04-30": 222.6879761111111,
                "2026-05-06": 312.51828333333333,
                "2026-05-14": 362.7454133333333,
                "2026-05-18": 119.77859972222221,
                "2026-05-26": 0.3280225
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-10-21": 1,
                "2025-10-31": 1,
                "2025-11-19": 1,
                "2025-11-24": 2,
                "2025-11-26": 1,
                "2026-01-27": 1,
                "2026-02-04": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-26": 2
              }
            },
            "P3": {
              "avg_time_hours": 300.69,
              "mode_time_hours": 19.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "10-12h": 1,
                "18-20h": 2,
                "26-28h": 1,
                "48-50h": 1,
                "92-94h": 1,
                "100-102h": 1,
                "170-172h": 1,
                "342-344h": 1,
                "628-630h": 1,
                "722-724h": 1,
                "1038-1040h": 1,
                "1284-1286h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-13": 1,
                "2025-12-14": 1,
                "2025-12-24": 1,
                "2026-01-27": 4,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-03-09": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-11-18": 1038.1988544444446,
                "2025-11-28": 100.72201944444446,
                "2025-12-02": 343.22092944444444,
                "2025-12-11": 26.807891666666666,
                "2025-12-13": 723.7227094444445,
                "2025-12-14": 49.814701944444444,
                "2025-12-24": 170.59455694444446,
                "2026-01-27": 130.02462833333334,
                "2026-02-03": 11.811334166666667,
                "2026-02-12": 1284.8734327777777,
                "2026-03-09": 628.7509808333333,
                "2026-03-31": 1.81842
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-13": 1,
                "2025-12-14": 1,
                "2025-12-24": 1,
                "2026-01-27": 4,
                "2026-02-03": 1,
                "2026-02-12": 1,
                "2026-03-09": 1,
                "2026-03-31": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-06": 1,
              "2026-04-22": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-06": 1,
                "2026-04-22": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_101": {
      "overall": {
        "avg_time_hours": 189.91,
        "mode_time_hours": 1.0,
        "mode_frequency": 18,
        "time_distribution": {
          "0-2h": 18,
          "2-4h": 6,
          "4-6h": 2,
          "6-8h": 4,
          "8-10h": 2,
          "10-12h": 2,
          "12-14h": 2,
          "16-18h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 4,
          "26-28h": 5,
          "28-30h": 7,
          "30-32h": 4,
          "32-34h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "44-46h": 4,
          "46-48h": 1,
          "48-50h": 1,
          "52-54h": 2,
          "56-58h": 1,
          "62-64h": 1,
          "66-68h": 1,
          "70-72h": 1,
          "72-74h": 2,
          "74-76h": 1,
          "76-78h": 3,
          "78-80h": 2,
          "80-82h": 2,
          "82-84h": 1,
          "84-86h": 4,
          "94-96h": 3,
          "100-102h": 3,
          "104-106h": 1,
          "106-108h": 1,
          "120-122h": 2,
          "124-126h": 1,
          "132-134h": 1,
          "138-140h": 2,
          "150-152h": 1,
          "176-178h": 1,
          "214-216h": 1,
          "254-256h": 1,
          "266-268h": 1,
          "268-270h": 2,
          "274-276h": 2,
          "278-280h": 1,
          "288-290h": 1,
          "316-318h": 1,
          "338-340h": 1,
          "368-370h": 1,
          "408-410h": 1,
          "418-420h": 1,
          "502-504h": 1,
          "512-514h": 1,
          "530-532h": 1,
          "540-542h": 1,
          "564-566h": 1,
          "570-572h": 1,
          "594-596h": 2,
          "624-626h": 1,
          "682-684h": 2,
          "796-798h": 1,
          "800-802h": 1,
          "804-806h": 1,
          "984-986h": 2,
          "1066-1068h": 1,
          "1338-1340h": 1,
          "1410-1412h": 1,
          "1416-1418h": 1,
          "2032-2034h": 1
        },
        "tickets_count": 153,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 2,
          "2025-10-17": 2,
          "2025-10-20": 1,
          "2025-10-26": 1,
          "2025-11-05": 1,
          "2025-11-11": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-25": 1,
          "2025-11-26": 2,
          "2025-11-27": 5,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-15": 2,
          "2025-12-23": 2,
          "2026-01-02": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-08": 2,
          "2026-01-12": 1,
          "2026-01-15": 4,
          "2026-01-16": 2,
          "2026-01-17": 2,
          "2026-01-21": 1,
          "2026-01-22": 4,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-28": 4,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-06": 3,
          "2026-02-07": 3,
          "2026-02-10": 5,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-14": 5,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-19": 9,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-02-28": 4,
          "2026-03-05": 1,
          "2026-03-07": 2,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-17": 3,
          "2026-03-18": 5,
          "2026-03-19": 1,
          "2026-03-21": 1,
          "2026-03-23": 2,
          "2026-03-25": 3,
          "2026-03-26": 1,
          "2026-03-29": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-14": 1,
          "2026-04-16": 3,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-24": 1,
          "2026-05-04": 1,
          "2026-05-05": 2,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-14": 2,
          "2026-05-23": 1,
          "2026-05-28": 2,
          "2026-05-29": 1,
          "2026-05-30": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-08": 53.6505225,
          "2025-10-10": 95.2703525,
          "2025-10-17": 15.158353333333332,
          "2025-10-20": 66.327935,
          "2025-10-26": 0.5912069444444444,
          "2025-11-05": 29.45224222222222,
          "2025-11-11": 0.04942694444444445,
          "2025-11-17": 279.3717213888889,
          "2025-11-19": 26.841418611111113,
          "2025-11-20": 106.82546277777779,
          "2025-11-21": 0.3380025,
          "2025-11-25": 7.7025500000000005,
          "2025-11-26": 54.62519944444445,
          "2025-11-27": 71.08782555555555,
          "2025-12-02": 339.5041997222222,
          "2025-12-03": 215.88901527777776,
          "2025-12-15": 391.44309555555554,
          "2025-12-23": 197.46011388888888,
          "2026-01-02": 7.371209722222222,
          "2026-01-05": 72.12259361111111,
          "2026-01-06": 7.211203888888889,
          "2026-01-08": 84.33879361111111,
          "2026-01-12": 9.67454472222222,
          "2026-01-15": 272.3427741666667,
          "2026-01-16": 114.39079222222222,
          "2026-01-17": 22.81818277777778,
          "2026-01-21": 796.1296127777778,
          "2026-01-22": 140.57496361111112,
          "2026-01-23": 13.892103055555557,
          "2026-01-24": 203.84236388888888,
          "2026-01-26": 2.572754166666667,
          "2026-01-27": 152.2311288888889,
          "2026-01-28": 112.27655805555555,
          "2026-01-31": 43.06622416666667,
          "2026-02-03": 151.27752194444446,
          "2026-02-04": 26.789045555555557,
          "2026-02-05": 180.39807305555556,
          "2026-02-06": 557.9135974999999,
          "2026-02-07": 322.67323861111106,
          "2026-02-10": 851.4373266666666,
          "2026-02-12": 133.8676575,
          "2026-02-13": 614.7945969444445,
          "2026-02-14": 1181.8068066666667,
          "2026-02-17": 0.2531025,
          "2026-02-18": 153.02589305555557,
          "2026-02-19": 6275.454104166666,
          "2026-02-21": 41.359647777777774,
          "2026-02-23": 76.19186416666668,
          "2026-02-25": 0.7857269444444445,
          "2026-02-28": 324.3522938888889,
          "2026-03-05": 49.28913333333333,
          "2026-03-07": 94.05266277777778,
          "2026-03-11": 1.7575269444444444,
          "2026-03-14": 1.4782216666666665,
          "2026-03-17": 2213.8186355555554,
          "2026-03-18": 1194.0778705555554,
          "2026-03-19": 4.6583175,
          "2026-03-21": 3.076986111111111,
          "2026-03-23": 56.447356666666664,
          "2026-03-25": 1970.3984705555554,
          "2026-03-26": 0.030692499999999998,
          "2026-03-29": 17.501973055555556,
          "2026-03-30": 75.96359916666667,
          "2026-03-31": 1339.067541111111,
          "2026-04-06": 6.550781944444444,
          "2026-04-07": 84.61776333333333,
          "2026-04-08": 44.24923861111111,
          "2026-04-10": 72.2353611111111,
          "2026-04-16": 1316.3654091666667,
          "2026-04-17": 0.13057249999999998,
          "2026-04-21": 0.7907011111111111,
          "2026-04-23": 0.5008541666666667,
          "2026-05-05": 573.3279997222222,
          "2026-05-06": 531.2696202777778,
          "2026-05-08": 409.2546613888889,
          "2026-05-14": 1411.7449255555557,
          "2026-05-30": 595.4478563888888
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 2,
          "2025-10-17": 2,
          "2025-10-20": 1,
          "2025-10-26": 1,
          "2025-11-05": 1,
          "2025-11-11": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-25": 1,
          "2025-11-26": 2,
          "2025-11-27": 5,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-15": 2,
          "2025-12-23": 2,
          "2026-01-02": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-08": 2,
          "2026-01-12": 1,
          "2026-01-15": 4,
          "2026-01-16": 2,
          "2026-01-17": 2,
          "2026-01-21": 1,
          "2026-01-22": 4,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-28": 4,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-06": 3,
          "2026-02-07": 3,
          "2026-02-10": 5,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-14": 5,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-19": 9,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-02-28": 4,
          "2026-03-05": 1,
          "2026-03-07": 2,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-17": 3,
          "2026-03-18": 4,
          "2026-03-19": 1,
          "2026-03-21": 1,
          "2026-03-23": 2,
          "2026-03-25": 3,
          "2026-03-26": 1,
          "2026-03-29": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-10": 1,
          "2026-04-16": 3,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-14": 2,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 30.49,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "32-34h": 1,
            "84-86h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-03-19": 1,
            "2026-04-07": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2025-11-27": 0.43700944444444445,
            "2026-03-19": 4.6583175,
            "2026-04-07": 84.61776333333333,
            "2026-05-05": 32.2339425
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-03-19": 1,
            "2026-04-07": 1,
            "2026-05-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 136.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 17,
          "time_distribution": {
            "0-2h": 17,
            "2-4h": 6,
            "6-8h": 3,
            "8-10h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "28-30h": 3,
            "42-44h": 1,
            "44-46h": 2,
            "46-48h": 1,
            "48-50h": 1,
            "52-54h": 2,
            "66-68h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "94-96h": 1,
            "104-106h": 1,
            "106-108h": 1,
            "268-270h": 1,
            "278-280h": 1,
            "316-318h": 1,
            "368-370h": 1,
            "408-410h": 1,
            "418-420h": 1,
            "512-514h": 1,
            "530-532h": 1,
            "540-542h": 1,
            "594-596h": 1,
            "796-798h": 1,
            "800-802h": 1,
            "1410-1412h": 1
          },
          "tickets_count": 69,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-10": 2,
            "2025-10-17": 2,
            "2025-10-20": 1,
            "2025-10-26": 1,
            "2025-11-11": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-11-21": 1,
            "2025-11-27": 3,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-06": 2,
            "2026-01-08": 1,
            "2026-01-21": 1,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-31": 1,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-06": 1,
            "2026-02-10": 2,
            "2026-02-14": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-25": 1,
            "2026-03-05": 1,
            "2026-03-07": 2,
            "2026-03-11": 1,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-21": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-29": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-14": 1,
            "2026-04-16": 3,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-14": 2,
            "2026-05-23": 1,
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-08": 53.6505225,
            "2025-10-10": 95.2703525,
            "2025-10-17": 15.158353333333332,
            "2025-10-20": 66.327935,
            "2025-10-26": 0.5912069444444444,
            "2025-11-11": 0.04942694444444445,
            "2025-11-17": 279.3717213888889,
            "2025-11-20": 106.82546277777779,
            "2025-11-21": 0.3380025,
            "2025-11-27": 57.45039611111111,
            "2025-12-15": 269.6287125,
            "2026-01-02": 7.371209722222222,
            "2026-01-06": 7.211203888888889,
            "2026-01-08": 0.1833136111111111,
            "2026-01-21": 796.1296127777778,
            "2026-01-22": 92.11445444444445,
            "2026-01-23": 13.892103055555557,
            "2026-01-26": 2.572754166666667,
            "2026-01-31": 43.06622416666667,
            "2026-02-04": 26.789045555555557,
            "2026-02-05": 3.8721336111111113,
            "2026-02-06": 21.348655833333332,
            "2026-02-10": 685.3221086111112,
            "2026-02-14": 418.6305125,
            "2026-02-17": 0.2531025,
            "2026-02-18": 28.279763333333335,
            "2026-02-25": 0.7857269444444445,
            "2026-03-05": 49.28913333333333,
            "2026-03-07": 94.05266277777778,
            "2026-03-11": 1.7575269444444444,
            "2026-03-14": 1.4782216666666665,
            "2026-03-17": 104.30368055555556,
            "2026-03-21": 3.076986111111111,
            "2026-03-23": 56.447356666666664,
            "2026-03-25": 0.08772805555555556,
            "2026-03-26": 0.030692499999999998,
            "2026-03-29": 17.501973055555556,
            "2026-04-06": 6.550781944444444,
            "2026-04-08": 44.24923861111111,
            "2026-04-10": 72.2353611111111,
            "2026-04-16": 1316.3654091666667,
            "2026-04-17": 0.13057249999999998,
            "2026-04-21": 0.7907011111111111,
            "2026-04-23": 0.5008541666666667,
            "2026-05-05": 541.0940572222222,
            "2026-05-06": 531.2696202777778,
            "2026-05-08": 409.2546613888889,
            "2026-05-14": 1411.7449255555557,
            "2026-05-30": 595.4478563888888
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-10": 2,
            "2025-10-17": 2,
            "2025-10-20": 1,
            "2025-10-26": 1,
            "2025-11-11": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-11-21": 1,
            "2025-11-27": 3,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-06": 2,
            "2026-01-08": 1,
            "2026-01-21": 1,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-01-31": 1,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-06": 1,
            "2026-02-10": 2,
            "2026-02-14": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-25": 1,
            "2026-03-05": 1,
            "2026-03-07": 2,
            "2026-03-11": 1,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-03-21": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-29": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-16": 3,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-14": 2,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 197.37,
          "mode_time_hours": 29.0,
          "mode_frequency": 4,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "26-28h": 4,
            "28-30h": 4,
            "30-32h": 3,
            "42-44h": 1,
            "44-46h": 1,
            "56-58h": 1,
            "62-64h": 1,
            "76-78h": 1,
            "78-80h": 1,
            "80-82h": 1,
            "84-86h": 2,
            "94-96h": 2,
            "100-102h": 1,
            "120-122h": 1,
            "132-134h": 1,
            "150-152h": 1,
            "214-216h": 1,
            "254-256h": 1,
            "338-340h": 1,
            "984-986h": 2,
            "1338-1340h": 1,
            "2032-2034h": 1
          },
          "tickets_count": 40,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2025-11-19": 1,
            "2025-11-25": 1,
            "2025-11-26": 2,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2025-12-23": 2,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-22": 1,
            "2026-01-27": 3,
            "2026-01-28": 4,
            "2026-02-03": 1,
            "2026-02-07": 3,
            "2026-02-10": 3,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 3,
            "2026-03-17": 1,
            "2026-03-25": 2,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-11-05": 29.45224222222222,
            "2025-11-19": 26.841418611111113,
            "2025-11-25": 7.7025500000000005,
            "2025-11-26": 54.62519944444445,
            "2025-11-27": 13.200420000000001,
            "2025-12-02": 339.5041997222222,
            "2025-12-03": 215.88901527777776,
            "2025-12-15": 121.81438305555555,
            "2025-12-23": 197.46011388888888,
            "2026-01-15": 272.3427741666667,
            "2026-01-16": 30.665748333333333,
            "2026-01-22": 24.137191388888887,
            "2026-01-27": 121.65607472222221,
            "2026-01-28": 112.27655805555555,
            "2026-02-03": 151.27752194444446,
            "2026-02-07": 322.67323861111106,
            "2026-02-10": 166.11521805555557,
            "2026-02-12": 133.8676575,
            "2026-02-13": 42.9662575,
            "2026-02-14": 168.39151972222223,
            "2026-03-17": 2032.716291111111,
            "2026-03-25": 1970.3107424999998,
            "2026-03-31": 1339.067541111111
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2025-11-19": 1,
            "2025-11-25": 1,
            "2025-11-26": 2,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2025-12-23": 2,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-22": 1,
            "2026-01-27": 3,
            "2026-01-28": 4,
            "2026-02-03": 1,
            "2026-02-07": 3,
            "2026-02-10": 3,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 3,
            "2026-03-17": 1,
            "2026-03-25": 2,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 153.93,
          "mode_time_hours": 11.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 1,
            "10-12h": 2,
            "24-26h": 1,
            "30-32h": 1,
            "40-42h": 1,
            "44-46h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "76-78h": 2,
            "78-80h": 1,
            "80-82h": 1,
            "82-84h": 1,
            "84-86h": 1,
            "100-102h": 2,
            "120-122h": 1,
            "124-126h": 1,
            "138-140h": 2,
            "176-178h": 1,
            "266-268h": 1,
            "268-270h": 1,
            "274-276h": 2,
            "502-504h": 1,
            "570-572h": 1,
            "594-596h": 1
          },
          "tickets_count": 32,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-01-08": 1,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-01-17": 2,
            "2026-01-22": 1,
            "2026-01-24": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-13": 1,
            "2026-02-14": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-02-28": 4,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-30": 1,
            "2026-04-22": 1,
            "2026-05-28": 2
          },
          "time_per_day": {
            "2026-01-05": 72.12259361111111,
            "2026-01-08": 84.15548,
            "2026-01-12": 9.67454472222222,
            "2026-01-16": 83.72504388888889,
            "2026-01-17": 22.81818277777778,
            "2026-01-22": 24.323317777777778,
            "2026-01-24": 203.84236388888888,
            "2026-01-27": 30.575054166666668,
            "2026-02-05": 176.52593944444445,
            "2026-02-06": 536.5649416666666,
            "2026-02-13": 571.8283394444445,
            "2026-02-14": 594.7847744444445,
            "2026-02-18": 124.74612972222222,
            "2026-02-19": 139.46499916666667,
            "2026-02-21": 41.359647777777774,
            "2026-02-23": 76.19186416666668,
            "2026-02-28": 324.3522938888889,
            "2026-03-17": 76.7986638888889,
            "2026-03-18": 1194.0778705555554,
            "2026-03-30": 75.96359916666667
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-01-08": 1,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-01-17": 2,
            "2026-01-22": 1,
            "2026-01-24": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-13": 1,
            "2026-02-14": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-02-28": 4,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-30": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 767.0,
          "mode_time_hours": 683.0,
          "mode_frequency": 2,
          "time_distribution": {
            "288-290h": 1,
            "564-566h": 1,
            "624-626h": 1,
            "682-684h": 2,
            "804-806h": 1,
            "1066-1068h": 1,
            "1416-1418h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-02-19": 8
          },
          "time_per_day": {
            "2026-02-19": 6135.989105
          },
          "time_count_per_day": {
            "2026-02-19": 8
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 189.91,
            "mode_time_hours": 1.0,
            "mode_frequency": 18,
            "time_distribution": {
              "0-2h": 18,
              "2-4h": 6,
              "4-6h": 2,
              "6-8h": 4,
              "8-10h": 2,
              "10-12h": 2,
              "12-14h": 2,
              "16-18h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 4,
              "26-28h": 5,
              "28-30h": 7,
              "30-32h": 4,
              "32-34h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "44-46h": 4,
              "46-48h": 1,
              "48-50h": 1,
              "52-54h": 2,
              "56-58h": 1,
              "62-64h": 1,
              "66-68h": 1,
              "70-72h": 1,
              "72-74h": 2,
              "74-76h": 1,
              "76-78h": 3,
              "78-80h": 2,
              "80-82h": 2,
              "82-84h": 1,
              "84-86h": 4,
              "94-96h": 3,
              "100-102h": 3,
              "104-106h": 1,
              "106-108h": 1,
              "120-122h": 2,
              "124-126h": 1,
              "132-134h": 1,
              "138-140h": 2,
              "150-152h": 1,
              "176-178h": 1,
              "214-216h": 1,
              "254-256h": 1,
              "266-268h": 1,
              "268-270h": 2,
              "274-276h": 2,
              "278-280h": 1,
              "288-290h": 1,
              "316-318h": 1,
              "338-340h": 1,
              "368-370h": 1,
              "408-410h": 1,
              "418-420h": 1,
              "502-504h": 1,
              "512-514h": 1,
              "530-532h": 1,
              "540-542h": 1,
              "564-566h": 1,
              "570-572h": 1,
              "594-596h": 2,
              "624-626h": 1,
              "682-684h": 2,
              "796-798h": 1,
              "800-802h": 1,
              "804-806h": 1,
              "984-986h": 2,
              "1066-1068h": 1,
              "1338-1340h": 1,
              "1410-1412h": 1,
              "1416-1418h": 1,
              "2032-2034h": 1
            },
            "tickets_count": 142,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 2,
              "2025-10-17": 2,
              "2025-10-20": 1,
              "2025-10-26": 1,
              "2025-11-05": 1,
              "2025-11-11": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-25": 1,
              "2025-11-26": 2,
              "2025-11-27": 5,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-15": 2,
              "2025-12-23": 2,
              "2026-01-02": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-08": 2,
              "2026-01-12": 1,
              "2026-01-15": 4,
              "2026-01-16": 2,
              "2026-01-17": 2,
              "2026-01-21": 1,
              "2026-01-22": 4,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-28": 4,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-06": 3,
              "2026-02-07": 3,
              "2026-02-10": 5,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-14": 5,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-19": 9,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-02-28": 4,
              "2026-03-05": 1,
              "2026-03-07": 2,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-17": 3,
              "2026-03-18": 4,
              "2026-03-19": 1,
              "2026-03-21": 1,
              "2026-03-23": 2,
              "2026-03-25": 3,
              "2026-03-26": 1,
              "2026-03-29": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-16": 3,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-14": 2,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-10-08": 53.6505225,
              "2025-10-10": 95.2703525,
              "2025-10-17": 15.158353333333332,
              "2025-10-20": 66.327935,
              "2025-10-26": 0.5912069444444444,
              "2025-11-05": 29.45224222222222,
              "2025-11-11": 0.04942694444444445,
              "2025-11-17": 279.3717213888889,
              "2025-11-19": 26.841418611111113,
              "2025-11-20": 106.82546277777779,
              "2025-11-21": 0.3380025,
              "2025-11-25": 7.7025500000000005,
              "2025-11-26": 54.62519944444445,
              "2025-11-27": 71.08782555555555,
              "2025-12-02": 339.5041997222222,
              "2025-12-03": 215.88901527777776,
              "2025-12-15": 391.44309555555554,
              "2025-12-23": 197.46011388888888,
              "2026-01-02": 7.371209722222222,
              "2026-01-05": 72.12259361111111,
              "2026-01-06": 7.211203888888889,
              "2026-01-08": 84.33879361111111,
              "2026-01-12": 9.67454472222222,
              "2026-01-15": 272.3427741666667,
              "2026-01-16": 114.39079222222222,
              "2026-01-17": 22.81818277777778,
              "2026-01-21": 796.1296127777778,
              "2026-01-22": 140.57496361111112,
              "2026-01-23": 13.892103055555557,
              "2026-01-24": 203.84236388888888,
              "2026-01-26": 2.572754166666667,
              "2026-01-27": 152.2311288888889,
              "2026-01-28": 112.27655805555555,
              "2026-01-31": 43.06622416666667,
              "2026-02-03": 151.27752194444446,
              "2026-02-04": 26.789045555555557,
              "2026-02-05": 180.39807305555556,
              "2026-02-06": 557.9135974999999,
              "2026-02-07": 322.67323861111106,
              "2026-02-10": 851.4373266666666,
              "2026-02-12": 133.8676575,
              "2026-02-13": 614.7945969444445,
              "2026-02-14": 1181.8068066666667,
              "2026-02-17": 0.2531025,
              "2026-02-18": 153.02589305555557,
              "2026-02-19": 6275.454104166666,
              "2026-02-21": 41.359647777777774,
              "2026-02-23": 76.19186416666668,
              "2026-02-25": 0.7857269444444445,
              "2026-02-28": 324.3522938888889,
              "2026-03-05": 49.28913333333333,
              "2026-03-07": 94.05266277777778,
              "2026-03-11": 1.7575269444444444,
              "2026-03-14": 1.4782216666666665,
              "2026-03-17": 2213.8186355555554,
              "2026-03-18": 1194.0778705555554,
              "2026-03-19": 4.6583175,
              "2026-03-21": 3.076986111111111,
              "2026-03-23": 56.447356666666664,
              "2026-03-25": 1970.3984705555554,
              "2026-03-26": 0.030692499999999998,
              "2026-03-29": 17.501973055555556,
              "2026-03-30": 75.96359916666667,
              "2026-03-31": 1339.067541111111,
              "2026-04-06": 6.550781944444444,
              "2026-04-07": 84.61776333333333,
              "2026-04-08": 44.24923861111111,
              "2026-04-10": 72.2353611111111,
              "2026-04-16": 1316.3654091666667,
              "2026-04-17": 0.13057249999999998,
              "2026-04-21": 0.7907011111111111,
              "2026-04-23": 0.5008541666666667,
              "2026-05-05": 573.3279997222222,
              "2026-05-06": 531.2696202777778,
              "2026-05-08": 409.2546613888889,
              "2026-05-14": 1411.7449255555557,
              "2026-05-30": 595.4478563888888
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 2,
              "2025-10-17": 2,
              "2025-10-20": 1,
              "2025-10-26": 1,
              "2025-11-05": 1,
              "2025-11-11": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-25": 1,
              "2025-11-26": 2,
              "2025-11-27": 5,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-15": 2,
              "2025-12-23": 2,
              "2026-01-02": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-08": 2,
              "2026-01-12": 1,
              "2026-01-15": 4,
              "2026-01-16": 2,
              "2026-01-17": 2,
              "2026-01-21": 1,
              "2026-01-22": 4,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-28": 4,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-06": 3,
              "2026-02-07": 3,
              "2026-02-10": 5,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-14": 5,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-19": 9,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-02-28": 4,
              "2026-03-05": 1,
              "2026-03-07": 2,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-17": 3,
              "2026-03-18": 4,
              "2026-03-19": 1,
              "2026-03-21": 1,
              "2026-03-23": 2,
              "2026-03-25": 3,
              "2026-03-26": 1,
              "2026-03-29": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-10": 1,
              "2026-04-16": 3,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-14": 2,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 30.49,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "32-34h": 1,
                "84-86h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-03-19": 1,
                "2026-04-07": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2025-11-27": 0.43700944444444445,
                "2026-03-19": 4.6583175,
                "2026-04-07": 84.61776333333333,
                "2026-05-05": 32.2339425
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-03-19": 1,
                "2026-04-07": 1,
                "2026-05-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 136.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 17,
              "time_distribution": {
                "0-2h": 17,
                "2-4h": 6,
                "6-8h": 3,
                "8-10h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "28-30h": 3,
                "42-44h": 1,
                "44-46h": 2,
                "46-48h": 1,
                "48-50h": 1,
                "52-54h": 2,
                "66-68h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "94-96h": 1,
                "104-106h": 1,
                "106-108h": 1,
                "268-270h": 1,
                "278-280h": 1,
                "316-318h": 1,
                "368-370h": 1,
                "408-410h": 1,
                "418-420h": 1,
                "512-514h": 1,
                "530-532h": 1,
                "540-542h": 1,
                "594-596h": 1,
                "796-798h": 1,
                "800-802h": 1,
                "1410-1412h": 1
              },
              "tickets_count": 61,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-10": 2,
                "2025-10-17": 2,
                "2025-10-20": 1,
                "2025-10-26": 1,
                "2025-11-11": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-11-21": 1,
                "2025-11-27": 3,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-06": 2,
                "2026-01-08": 1,
                "2026-01-21": 1,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-31": 1,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-06": 1,
                "2026-02-10": 2,
                "2026-02-14": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-25": 1,
                "2026-03-05": 1,
                "2026-03-07": 2,
                "2026-03-11": 1,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-21": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-29": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-16": 3,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-14": 2,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-10-08": 53.6505225,
                "2025-10-10": 95.2703525,
                "2025-10-17": 15.158353333333332,
                "2025-10-20": 66.327935,
                "2025-10-26": 0.5912069444444444,
                "2025-11-11": 0.04942694444444445,
                "2025-11-17": 279.3717213888889,
                "2025-11-20": 106.82546277777779,
                "2025-11-21": 0.3380025,
                "2025-11-27": 57.45039611111111,
                "2025-12-15": 269.6287125,
                "2026-01-02": 7.371209722222222,
                "2026-01-06": 7.211203888888889,
                "2026-01-08": 0.1833136111111111,
                "2026-01-21": 796.1296127777778,
                "2026-01-22": 92.11445444444445,
                "2026-01-23": 13.892103055555557,
                "2026-01-26": 2.572754166666667,
                "2026-01-31": 43.06622416666667,
                "2026-02-04": 26.789045555555557,
                "2026-02-05": 3.8721336111111113,
                "2026-02-06": 21.348655833333332,
                "2026-02-10": 685.3221086111112,
                "2026-02-14": 418.6305125,
                "2026-02-17": 0.2531025,
                "2026-02-18": 28.279763333333335,
                "2026-02-25": 0.7857269444444445,
                "2026-03-05": 49.28913333333333,
                "2026-03-07": 94.05266277777778,
                "2026-03-11": 1.7575269444444444,
                "2026-03-14": 1.4782216666666665,
                "2026-03-17": 104.30368055555556,
                "2026-03-21": 3.076986111111111,
                "2026-03-23": 56.447356666666664,
                "2026-03-25": 0.08772805555555556,
                "2026-03-26": 0.030692499999999998,
                "2026-03-29": 17.501973055555556,
                "2026-04-06": 6.550781944444444,
                "2026-04-08": 44.24923861111111,
                "2026-04-10": 72.2353611111111,
                "2026-04-16": 1316.3654091666667,
                "2026-04-17": 0.13057249999999998,
                "2026-04-21": 0.7907011111111111,
                "2026-04-23": 0.5008541666666667,
                "2026-05-05": 541.0940572222222,
                "2026-05-06": 531.2696202777778,
                "2026-05-08": 409.2546613888889,
                "2026-05-14": 1411.7449255555557,
                "2026-05-30": 595.4478563888888
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-10": 2,
                "2025-10-17": 2,
                "2025-10-20": 1,
                "2025-10-26": 1,
                "2025-11-11": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-11-21": 1,
                "2025-11-27": 3,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-06": 2,
                "2026-01-08": 1,
                "2026-01-21": 1,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-01-31": 1,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-06": 1,
                "2026-02-10": 2,
                "2026-02-14": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-25": 1,
                "2026-03-05": 1,
                "2026-03-07": 2,
                "2026-03-11": 1,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-03-21": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-29": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-16": 3,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-14": 2,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 197.37,
              "mode_time_hours": 29.0,
              "mode_frequency": 4,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "26-28h": 4,
                "28-30h": 4,
                "30-32h": 3,
                "42-44h": 1,
                "44-46h": 1,
                "56-58h": 1,
                "62-64h": 1,
                "76-78h": 1,
                "78-80h": 1,
                "80-82h": 1,
                "84-86h": 2,
                "94-96h": 2,
                "100-102h": 1,
                "120-122h": 1,
                "132-134h": 1,
                "150-152h": 1,
                "214-216h": 1,
                "254-256h": 1,
                "338-340h": 1,
                "984-986h": 2,
                "1338-1340h": 1,
                "2032-2034h": 1
              },
              "tickets_count": 40,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2025-11-19": 1,
                "2025-11-25": 1,
                "2025-11-26": 2,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2025-12-23": 2,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-01-22": 1,
                "2026-01-27": 3,
                "2026-01-28": 4,
                "2026-02-03": 1,
                "2026-02-07": 3,
                "2026-02-10": 3,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 3,
                "2026-03-17": 1,
                "2026-03-25": 2,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-11-05": 29.45224222222222,
                "2025-11-19": 26.841418611111113,
                "2025-11-25": 7.7025500000000005,
                "2025-11-26": 54.62519944444445,
                "2025-11-27": 13.200420000000001,
                "2025-12-02": 339.5041997222222,
                "2025-12-03": 215.88901527777776,
                "2025-12-15": 121.81438305555555,
                "2025-12-23": 197.46011388888888,
                "2026-01-15": 272.3427741666667,
                "2026-01-16": 30.665748333333333,
                "2026-01-22": 24.137191388888887,
                "2026-01-27": 121.65607472222221,
                "2026-01-28": 112.27655805555555,
                "2026-02-03": 151.27752194444446,
                "2026-02-07": 322.67323861111106,
                "2026-02-10": 166.11521805555557,
                "2026-02-12": 133.8676575,
                "2026-02-13": 42.9662575,
                "2026-02-14": 168.39151972222223,
                "2026-03-17": 2032.716291111111,
                "2026-03-25": 1970.3107424999998,
                "2026-03-31": 1339.067541111111
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2025-11-19": 1,
                "2025-11-25": 1,
                "2025-11-26": 2,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2025-12-23": 2,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-01-22": 1,
                "2026-01-27": 3,
                "2026-01-28": 4,
                "2026-02-03": 1,
                "2026-02-07": 3,
                "2026-02-10": 3,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 3,
                "2026-03-17": 1,
                "2026-03-25": 2,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 153.93,
              "mode_time_hours": 11.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 1,
                "10-12h": 2,
                "24-26h": 1,
                "30-32h": 1,
                "40-42h": 1,
                "44-46h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "76-78h": 2,
                "78-80h": 1,
                "80-82h": 1,
                "82-84h": 1,
                "84-86h": 1,
                "100-102h": 2,
                "120-122h": 1,
                "124-126h": 1,
                "138-140h": 2,
                "176-178h": 1,
                "266-268h": 1,
                "268-270h": 1,
                "274-276h": 2,
                "502-504h": 1,
                "570-572h": 1,
                "594-596h": 1
              },
              "tickets_count": 29,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-01-08": 1,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-01-17": 2,
                "2026-01-22": 1,
                "2026-01-24": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-13": 1,
                "2026-02-14": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-02-28": 4,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-01-05": 72.12259361111111,
                "2026-01-08": 84.15548,
                "2026-01-12": 9.67454472222222,
                "2026-01-16": 83.72504388888889,
                "2026-01-17": 22.81818277777778,
                "2026-01-22": 24.323317777777778,
                "2026-01-24": 203.84236388888888,
                "2026-01-27": 30.575054166666668,
                "2026-02-05": 176.52593944444445,
                "2026-02-06": 536.5649416666666,
                "2026-02-13": 571.8283394444445,
                "2026-02-14": 594.7847744444445,
                "2026-02-18": 124.74612972222222,
                "2026-02-19": 139.46499916666667,
                "2026-02-21": 41.359647777777774,
                "2026-02-23": 76.19186416666668,
                "2026-02-28": 324.3522938888889,
                "2026-03-17": 76.7986638888889,
                "2026-03-18": 1194.0778705555554,
                "2026-03-30": 75.96359916666667
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-01-08": 1,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-01-17": 2,
                "2026-01-22": 1,
                "2026-01-24": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-13": 1,
                "2026-02-14": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-02-28": 4,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-30": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 767.0,
              "mode_time_hours": 683.0,
              "mode_frequency": 2,
              "time_distribution": {
                "288-290h": 1,
                "564-566h": 1,
                "624-626h": 1,
                "682-684h": 2,
                "804-806h": 1,
                "1066-1068h": 1,
                "1416-1418h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-02-19": 8
              },
              "time_per_day": {
                "2026-02-19": 6135.989105
              },
              "time_count_per_day": {
                "2026-02-19": 8
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-22": 1,
              "2026-05-28": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-22": 1,
                "2026-05-28": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-03-18": 1,
              "2026-04-24": 1,
              "2026-05-04": 1,
              "2026-05-06": 1,
              "2026-05-23": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-03-18": 1,
                "2026-04-24": 1,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-23": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_157": {
      "overall": {
        "avg_time_hours": 108.7,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 2,
          "4-6h": 2,
          "24-26h": 1,
          "28-30h": 1,
          "30-32h": 2,
          "46-48h": 1,
          "50-52h": 1,
          "62-64h": 1,
          "92-94h": 1,
          "118-120h": 1,
          "142-144h": 1,
          "144-146h": 1,
          "146-148h": 1,
          "226-228h": 1,
          "240-242h": 1,
          "298-300h": 1,
          "300-302h": 1,
          "386-388h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-11-17": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-07": 1,
          "2026-01-14": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 3,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-03-17": 2,
          "2026-03-23": 1,
          "2026-05-06": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-22": 2,
          "2026-05-28": 1
        },
        "time_per_day": {
          "2025-10-07": 24.895565277777777,
          "2025-11-17": 28.376435277777777,
          "2025-12-15": 0.6057575,
          "2025-12-19": 227.09042555555556,
          "2026-01-07": 4.357542222222222,
          "2026-01-14": 50.32179166666667,
          "2026-01-22": 62.063469166666664,
          "2026-01-23": 46.79157583333333,
          "2026-02-03": 359.629815,
          "2026-02-09": 93.72161916666667,
          "2026-02-16": 147.08757222222224,
          "2026-02-18": 118.091425,
          "2026-03-17": 6.244595555555556,
          "2026-03-23": 145.66326055555555,
          "2026-05-06": 387.3115133333334,
          "2026-05-14": 300.6973066666667,
          "2026-05-22": 245.59187666666668,
          "2026-05-28": 142.86037777777779
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-11-17": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-07": 1,
          "2026-01-14": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 3,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-03-17": 2,
          "2026-03-23": 1,
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-22": 2,
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 140.2,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "28-30h": 1,
            "50-52h": 1,
            "92-94h": 1,
            "142-144h": 1,
            "144-146h": 1,
            "146-148h": 1,
            "240-242h": 1,
            "300-302h": 1,
            "386-388h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-12-15": 1,
            "2026-01-14": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-03-23": 1,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-22": 2,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2025-11-17": 28.376435277777777,
            "2025-12-15": 0.6057575,
            "2026-01-14": 50.32179166666667,
            "2026-02-09": 93.72161916666667,
            "2026-02-16": 147.08757222222224,
            "2026-03-23": 145.66326055555555,
            "2026-05-06": 387.3115133333334,
            "2026-05-14": 300.6973066666667,
            "2026-05-22": 245.59187666666668,
            "2026-05-28": 142.86037777777779
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-12-15": 1,
            "2026-01-14": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-03-23": 1,
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-22": 2,
            "2026-05-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 77.2,
          "mode_time_hours": 31.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "4-6h": 1,
            "24-26h": 1,
            "30-32h": 2,
            "46-48h": 1,
            "62-64h": 1,
            "118-120h": 1,
            "226-228h": 1,
            "298-300h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-12-19": 1,
            "2026-01-07": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 3,
            "2026-02-18": 1,
            "2026-03-17": 2
          },
          "time_per_day": {
            "2025-10-07": 24.895565277777777,
            "2025-12-19": 227.09042555555556,
            "2026-01-07": 4.357542222222222,
            "2026-01-22": 62.063469166666664,
            "2026-01-23": 46.79157583333333,
            "2026-02-03": 359.629815,
            "2026-02-18": 118.091425,
            "2026-03-17": 6.244595555555556
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-12-19": 1,
            "2026-01-07": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 3,
            "2026-02-18": 1,
            "2026-03-17": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 108.7,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 2,
              "4-6h": 2,
              "24-26h": 1,
              "28-30h": 1,
              "30-32h": 2,
              "46-48h": 1,
              "50-52h": 1,
              "62-64h": 1,
              "92-94h": 1,
              "118-120h": 1,
              "142-144h": 1,
              "144-146h": 1,
              "146-148h": 1,
              "226-228h": 1,
              "240-242h": 1,
              "298-300h": 1,
              "300-302h": 1,
              "386-388h": 1
            },
            "tickets_count": 22,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-11-17": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-07": 1,
              "2026-01-14": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 3,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-03-17": 2,
              "2026-03-23": 1,
              "2026-05-06": 1,
              "2026-05-14": 1,
              "2026-05-22": 2,
              "2026-05-28": 1
            },
            "time_per_day": {
              "2025-10-07": 24.895565277777777,
              "2025-11-17": 28.376435277777777,
              "2025-12-15": 0.6057575,
              "2025-12-19": 227.09042555555556,
              "2026-01-07": 4.357542222222222,
              "2026-01-14": 50.32179166666667,
              "2026-01-22": 62.063469166666664,
              "2026-01-23": 46.79157583333333,
              "2026-02-03": 359.629815,
              "2026-02-09": 93.72161916666667,
              "2026-02-16": 147.08757222222224,
              "2026-02-18": 118.091425,
              "2026-03-17": 6.244595555555556,
              "2026-03-23": 145.66326055555555,
              "2026-05-06": 387.3115133333334,
              "2026-05-14": 300.6973066666667,
              "2026-05-22": 245.59187666666668,
              "2026-05-28": 142.86037777777779
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-11-17": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-07": 1,
              "2026-01-14": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 3,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-03-17": 2,
              "2026-03-23": 1,
              "2026-05-06": 1,
              "2026-05-14": 1,
              "2026-05-22": 2,
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 140.2,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "28-30h": 1,
                "50-52h": 1,
                "92-94h": 1,
                "142-144h": 1,
                "144-146h": 1,
                "146-148h": 1,
                "240-242h": 1,
                "300-302h": 1,
                "386-388h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-12-15": 1,
                "2026-01-14": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-03-23": 1,
                "2026-05-06": 1,
                "2026-05-14": 1,
                "2026-05-22": 2,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2025-11-17": 28.376435277777777,
                "2025-12-15": 0.6057575,
                "2026-01-14": 50.32179166666667,
                "2026-02-09": 93.72161916666667,
                "2026-02-16": 147.08757222222224,
                "2026-03-23": 145.66326055555555,
                "2026-05-06": 387.3115133333334,
                "2026-05-14": 300.6973066666667,
                "2026-05-22": 245.59187666666668,
                "2026-05-28": 142.86037777777779
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-12-15": 1,
                "2026-01-14": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-03-23": 1,
                "2026-05-06": 1,
                "2026-05-14": 1,
                "2026-05-22": 2,
                "2026-05-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 77.2,
              "mode_time_hours": 31.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "4-6h": 1,
                "24-26h": 1,
                "30-32h": 2,
                "46-48h": 1,
                "62-64h": 1,
                "118-120h": 1,
                "226-228h": 1,
                "298-300h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-12-19": 1,
                "2026-01-07": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 3,
                "2026-02-18": 1,
                "2026-03-17": 2
              },
              "time_per_day": {
                "2025-10-07": 24.895565277777777,
                "2025-12-19": 227.09042555555556,
                "2026-01-07": 4.357542222222222,
                "2026-01-22": 62.063469166666664,
                "2026-01-23": 46.79157583333333,
                "2026-02-03": 359.629815,
                "2026-02-18": 118.091425,
                "2026-03-17": 6.244595555555556
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-12-19": 1,
                "2026-01-07": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 3,
                "2026-02-18": 1,
                "2026-03-17": 2
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_158": {
      "overall": {
        "avg_time_hours": 237.14,
        "mode_time_hours": 1.0,
        "mode_frequency": 13,
        "time_distribution": {
          "0-2h": 13,
          "2-4h": 1,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 4,
          "24-26h": 2,
          "26-28h": 1,
          "34-36h": 1,
          "36-38h": 3,
          "40-42h": 2,
          "48-50h": 3,
          "52-54h": 2,
          "56-58h": 1,
          "68-70h": 1,
          "72-74h": 2,
          "76-78h": 1,
          "100-102h": 1,
          "106-108h": 1,
          "116-118h": 2,
          "126-128h": 2,
          "136-138h": 1,
          "144-146h": 1,
          "162-164h": 2,
          "164-166h": 1,
          "186-188h": 1,
          "188-190h": 1,
          "190-192h": 1,
          "216-218h": 1,
          "234-236h": 1,
          "260-262h": 1,
          "268-270h": 1,
          "288-290h": 2,
          "338-340h": 1,
          "340-342h": 1,
          "354-356h": 1,
          "366-368h": 1,
          "400-402h": 1,
          "502-504h": 1,
          "526-528h": 1,
          "576-578h": 1,
          "720-722h": 1,
          "858-860h": 1,
          "904-906h": 1,
          "986-988h": 1,
          "1078-1080h": 1,
          "1112-1114h": 1,
          "1142-1144h": 1,
          "1368-1370h": 1,
          "1636-1638h": 1,
          "1756-1758h": 1
        },
        "tickets_count": 94,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-11-04": 1,
          "2025-11-05": 1,
          "2025-11-12": 2,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-12-02": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-24": 1,
          "2026-01-07": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-18": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-24": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-19": 5,
          "2026-02-20": 1,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-02-28": 1,
          "2026-03-05": 1,
          "2026-03-06": 6,
          "2026-03-07": 1,
          "2026-03-11": 3,
          "2026-03-12": 1,
          "2026-03-17": 2,
          "2026-03-18": 4,
          "2026-03-24": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-04-16": 3,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-04-24": 3,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-12": 3,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-20": 1,
          "2026-05-25": 1,
          "2026-05-26": 2,
          "2026-05-27": 1,
          "2026-06-01": 1,
          "2026-06-03": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-14": 191.70376444444446,
          "2025-11-04": 354.15818055555553,
          "2025-11-05": 0.8562033333333333,
          "2025-11-12": 63.694253333333336,
          "2025-11-24": 40.77539722222222,
          "2025-11-28": 19.093685,
          "2025-12-02": 162.58090083333335,
          "2025-12-11": 48.57991388888889,
          "2025-12-17": 26.07036388888889,
          "2025-12-24": 0.6107388888888888,
          "2026-01-07": 502.8444983333333,
          "2026-01-08": 4.332289722222223,
          "2026-01-13": 137.35640916666665,
          "2026-01-14": 272.85435805555556,
          "2026-01-15": 289.7434127777778,
          "2026-01-17": 235.12547555555557,
          "2026-01-18": 1.3253358333333334,
          "2026-01-19": 60.7612225,
          "2026-01-22": 76.93990194444444,
          "2026-01-24": 526.7352125,
          "2026-01-26": 100.50626916666667,
          "2026-01-27": 144.45820750000001,
          "2026-02-03": 23.65676888888889,
          "2026-02-04": 116.20435111111111,
          "2026-02-05": 72.87978222222223,
          "2026-02-10": 338.3130075,
          "2026-02-16": 576.5972380555555,
          "2026-02-18": 290.7196138888889,
          "2026-02-19": 4349.673922222222,
          "2026-02-20": 0.39842916666666667,
          "2026-02-23": 0.6560391666666666,
          "2026-02-24": 0.3888697222222222,
          "2026-02-28": 57.14757,
          "2026-03-05": 73.0323425,
          "2026-03-06": 756.9304625,
          "2026-03-07": 49.85104638888889,
          "2026-03-11": 418.2682688888889,
          "2026-03-12": 68.8460325,
          "2026-03-17": 74.88755416666666,
          "2026-03-18": 2431.778886111111,
          "2026-03-24": 859.1650980555556,
          "2026-04-13": 1756.5566922222222,
          "2026-04-15": 16.947225833333334,
          "2026-04-16": 986.4862238888888,
          "2026-04-17": 1113.101057777778,
          "2026-04-21": 1.8381133333333333,
          "2026-04-23": 905.3171116666666,
          "2026-04-27": 0.24165527777777776,
          "2026-04-29": 366.14706805555556,
          "2026-04-30": 23.48261972222222,
          "2026-05-02": 52.18286833333333,
          "2026-05-05": 126.48723027777777,
          "2026-05-06": 260.85103833333335,
          "2026-05-12": 6.5299525,
          "2026-05-13": 53.05152666666667,
          "2026-05-14": 23.681681666666666,
          "2026-05-25": 116.931235,
          "2026-05-26": 48.26108138888889,
          "2026-05-27": 0.4674158333333333,
          "2026-06-03": 2.603283333333333,
          "2026-06-08": 1.0398577777777778
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-11-04": 1,
          "2025-11-05": 1,
          "2025-11-12": 2,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-12-02": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-24": 1,
          "2026-01-07": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-18": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-24": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-16": 1,
          "2026-02-18": 2,
          "2026-02-19": 5,
          "2026-02-20": 1,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-02-28": 1,
          "2026-03-05": 1,
          "2026-03-06": 5,
          "2026-03-07": 1,
          "2026-03-11": 3,
          "2026-03-12": 1,
          "2026-03-17": 2,
          "2026-03-18": 4,
          "2026-03-24": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-04-16": 3,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-25": 1,
          "2026-05-26": 2,
          "2026-05-27": 1,
          "2026-06-03": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 23.72,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 23.722966111111113
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 198.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 12,
          "time_distribution": {
            "0-2h": 12,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 1,
            "8-10h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "22-24h": 2,
            "24-26h": 1,
            "34-36h": 1,
            "36-38h": 1,
            "40-42h": 2,
            "48-50h": 1,
            "52-54h": 2,
            "68-70h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "116-118h": 2,
            "126-128h": 1,
            "136-138h": 1,
            "162-164h": 1,
            "186-188h": 1,
            "188-190h": 1,
            "190-192h": 1,
            "260-262h": 1,
            "268-270h": 1,
            "340-342h": 1,
            "354-356h": 1,
            "400-402h": 1,
            "904-906h": 1,
            "986-988h": 1,
            "1112-1114h": 1,
            "1636-1638h": 1,
            "1756-1758h": 1
          },
          "tickets_count": 55,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-11-04": 1,
            "2025-11-12": 1,
            "2025-11-24": 1,
            "2025-11-28": 1,
            "2025-12-24": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-18": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-02-04": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-02-24": 1,
            "2026-03-05": 1,
            "2026-03-06": 5,
            "2026-03-11": 3,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-04-16": 3,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-12": 2,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-20": 1,
            "2026-05-25": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-01": 1,
            "2026-06-03": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-14": 191.70376444444446,
            "2025-11-04": 354.15818055555553,
            "2025-11-12": 48.46675472222223,
            "2025-11-24": 40.77539722222222,
            "2025-11-28": 19.093685,
            "2025-12-24": 0.6107388888888888,
            "2026-01-08": 4.332289722222223,
            "2026-01-13": 137.35640916666665,
            "2026-01-15": 162.68732888888889,
            "2026-01-18": 1.3253358333333334,
            "2026-01-19": 36.291756666666664,
            "2026-01-22": 76.93990194444444,
            "2026-02-04": 116.20435111111111,
            "2026-02-18": 268.8867325,
            "2026-02-19": 35.32155111111111,
            "2026-02-20": 0.39842916666666667,
            "2026-02-23": 0.6560391666666666,
            "2026-02-24": 0.3888697222222222,
            "2026-03-05": 73.0323425,
            "2026-03-06": 756.9304625,
            "2026-03-11": 418.2682688888889,
            "2026-03-12": 68.8460325,
            "2026-03-18": 1637.4323055555556,
            "2026-04-13": 1756.5566922222222,
            "2026-04-15": 16.947225833333334,
            "2026-04-16": 986.4862238888888,
            "2026-04-17": 1113.101057777778,
            "2026-04-21": 1.8381133333333333,
            "2026-04-23": 905.3171116666666,
            "2026-04-27": 0.24165527777777776,
            "2026-04-30": 23.48261972222222,
            "2026-05-02": 52.18286833333333,
            "2026-05-05": 126.48723027777777,
            "2026-05-06": 260.85103833333335,
            "2026-05-12": 6.5299525,
            "2026-05-13": 53.05152666666667,
            "2026-05-14": 23.681681666666666,
            "2026-05-25": 116.931235,
            "2026-05-26": 24.538115277777777,
            "2026-05-27": 0.4674158333333333,
            "2026-06-03": 2.603283333333333,
            "2026-06-08": 1.0398577777777778
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-11-04": 1,
            "2025-11-12": 1,
            "2025-11-24": 1,
            "2025-11-28": 1,
            "2025-12-24": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-18": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-02-04": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-02-24": 1,
            "2026-03-05": 1,
            "2026-03-06": 5,
            "2026-03-11": 3,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-04-16": 3,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-25": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-03": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 147.92,
          "mode_time_hours": 49.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "14-16h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "48-50h": 2,
            "72-74h": 1,
            "100-102h": 1,
            "106-108h": 1,
            "126-128h": 1,
            "144-146h": 1,
            "162-164h": 1,
            "164-166h": 1,
            "366-368h": 1,
            "502-504h": 1,
            "576-578h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2025-11-12": 1,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2026-01-07": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-16": 1,
            "2026-03-07": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2025-11-05": 0.8562033333333333,
            "2025-11-12": 15.227498611111113,
            "2025-12-02": 162.58090083333335,
            "2025-12-11": 48.57991388888889,
            "2025-12-17": 26.07036388888889,
            "2026-01-07": 502.8444983333333,
            "2026-01-14": 272.85435805555556,
            "2026-01-15": 127.05608388888889,
            "2026-01-19": 24.469465833333334,
            "2026-01-26": 100.50626916666667,
            "2026-01-27": 144.45820750000001,
            "2026-02-03": 23.65676888888889,
            "2026-02-05": 72.87978222222223,
            "2026-02-16": 576.5972380555555,
            "2026-03-07": 49.85104638888889,
            "2026-04-29": 366.14706805555556
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2025-11-12": 1,
            "2025-12-02": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2026-01-07": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-16": 1,
            "2026-03-07": 1,
            "2026-04-29": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 267.24,
          "mode_time_hours": 289.0,
          "mode_frequency": 2,
          "time_distribution": {
            "20-22h": 1,
            "36-38h": 2,
            "56-58h": 1,
            "216-218h": 1,
            "288-290h": 2,
            "338-340h": 1,
            "526-528h": 1,
            "858-860h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2026-01-24": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-28": 1,
            "2026-03-17": 2,
            "2026-03-18": 3,
            "2026-03-24": 1,
            "2026-04-24": 3,
            "2026-05-12": 1
          },
          "time_per_day": {
            "2026-01-24": 526.7352125,
            "2026-02-10": 338.3130075,
            "2026-02-18": 21.83288138888889,
            "2026-02-28": 57.14757,
            "2026-03-17": 74.88755416666666,
            "2026-03-18": 794.3465805555556,
            "2026-03-24": 859.1650980555556
          },
          "time_count_per_day": {
            "2026-01-24": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-28": 1,
            "2026-03-17": 2,
            "2026-03-18": 3,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 909.9,
          "mode_time_hours": 1369.0,
          "mode_frequency": 1,
          "time_distribution": {
            "234-236h": 1,
            "720-722h": 1,
            "1078-1080h": 1,
            "1142-1144h": 1,
            "1368-1370h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-01-17": 1,
            "2026-02-17": 1,
            "2026-02-19": 4,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-01-17": 235.12547555555557,
            "2026-02-19": 4314.352371111111
          },
          "time_count_per_day": {
            "2026-01-17": 1,
            "2026-02-19": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 237.14,
            "mode_time_hours": 1.0,
            "mode_frequency": 13,
            "time_distribution": {
              "0-2h": 13,
              "2-4h": 1,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 4,
              "24-26h": 2,
              "26-28h": 1,
              "34-36h": 1,
              "36-38h": 3,
              "40-42h": 2,
              "48-50h": 3,
              "52-54h": 2,
              "56-58h": 1,
              "68-70h": 1,
              "72-74h": 2,
              "76-78h": 1,
              "100-102h": 1,
              "106-108h": 1,
              "116-118h": 2,
              "126-128h": 2,
              "136-138h": 1,
              "144-146h": 1,
              "162-164h": 2,
              "164-166h": 1,
              "186-188h": 1,
              "188-190h": 1,
              "190-192h": 1,
              "216-218h": 1,
              "234-236h": 1,
              "260-262h": 1,
              "268-270h": 1,
              "288-290h": 2,
              "338-340h": 1,
              "340-342h": 1,
              "354-356h": 1,
              "366-368h": 1,
              "400-402h": 1,
              "502-504h": 1,
              "526-528h": 1,
              "576-578h": 1,
              "720-722h": 1,
              "858-860h": 1,
              "904-906h": 1,
              "986-988h": 1,
              "1078-1080h": 1,
              "1112-1114h": 1,
              "1142-1144h": 1,
              "1368-1370h": 1,
              "1636-1638h": 1,
              "1756-1758h": 1
            },
            "tickets_count": 83,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-11-04": 1,
              "2025-11-05": 1,
              "2025-11-12": 2,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-12-02": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-24": 1,
              "2026-01-07": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-18": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-24": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-16": 1,
              "2026-02-18": 2,
              "2026-02-19": 5,
              "2026-02-20": 1,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-06": 5,
              "2026-03-07": 1,
              "2026-03-11": 3,
              "2026-03-12": 1,
              "2026-03-17": 2,
              "2026-03-18": 4,
              "2026-03-24": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-04-16": 3,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-25": 1,
              "2026-05-26": 2,
              "2026-05-27": 1,
              "2026-06-03": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-14": 191.70376444444446,
              "2025-11-04": 354.15818055555553,
              "2025-11-05": 0.8562033333333333,
              "2025-11-12": 63.694253333333336,
              "2025-11-24": 40.77539722222222,
              "2025-11-28": 19.093685,
              "2025-12-02": 162.58090083333335,
              "2025-12-11": 48.57991388888889,
              "2025-12-17": 26.07036388888889,
              "2025-12-24": 0.6107388888888888,
              "2026-01-07": 502.8444983333333,
              "2026-01-08": 4.332289722222223,
              "2026-01-13": 137.35640916666665,
              "2026-01-14": 272.85435805555556,
              "2026-01-15": 289.7434127777778,
              "2026-01-17": 235.12547555555557,
              "2026-01-18": 1.3253358333333334,
              "2026-01-19": 60.7612225,
              "2026-01-22": 76.93990194444444,
              "2026-01-24": 526.7352125,
              "2026-01-26": 100.50626916666667,
              "2026-01-27": 144.45820750000001,
              "2026-02-03": 23.65676888888889,
              "2026-02-04": 116.20435111111111,
              "2026-02-05": 72.87978222222223,
              "2026-02-10": 338.3130075,
              "2026-02-16": 576.5972380555555,
              "2026-02-18": 290.7196138888889,
              "2026-02-19": 4349.673922222222,
              "2026-02-20": 0.39842916666666667,
              "2026-02-23": 0.6560391666666666,
              "2026-02-24": 0.3888697222222222,
              "2026-02-28": 57.14757,
              "2026-03-05": 73.0323425,
              "2026-03-06": 756.9304625,
              "2026-03-07": 49.85104638888889,
              "2026-03-11": 418.2682688888889,
              "2026-03-12": 68.8460325,
              "2026-03-17": 74.88755416666666,
              "2026-03-18": 2431.778886111111,
              "2026-03-24": 859.1650980555556,
              "2026-04-13": 1756.5566922222222,
              "2026-04-15": 16.947225833333334,
              "2026-04-16": 986.4862238888888,
              "2026-04-17": 1113.101057777778,
              "2026-04-21": 1.8381133333333333,
              "2026-04-23": 905.3171116666666,
              "2026-04-27": 0.24165527777777776,
              "2026-04-29": 366.14706805555556,
              "2026-04-30": 23.48261972222222,
              "2026-05-02": 52.18286833333333,
              "2026-05-05": 126.48723027777777,
              "2026-05-06": 260.85103833333335,
              "2026-05-12": 6.5299525,
              "2026-05-13": 53.05152666666667,
              "2026-05-14": 23.681681666666666,
              "2026-05-25": 116.931235,
              "2026-05-26": 48.26108138888889,
              "2026-05-27": 0.4674158333333333,
              "2026-06-03": 2.603283333333333,
              "2026-06-08": 1.0398577777777778
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-11-04": 1,
              "2025-11-05": 1,
              "2025-11-12": 2,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-12-02": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-24": 1,
              "2026-01-07": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-18": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-24": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-16": 1,
              "2026-02-18": 2,
              "2026-02-19": 5,
              "2026-02-20": 1,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-06": 5,
              "2026-03-07": 1,
              "2026-03-11": 3,
              "2026-03-12": 1,
              "2026-03-17": 2,
              "2026-03-18": 4,
              "2026-03-24": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-04-16": 3,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-25": 1,
              "2026-05-26": 2,
              "2026-05-27": 1,
              "2026-06-03": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 23.72,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 23.722966111111113
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 198.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 12,
              "time_distribution": {
                "0-2h": 12,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 1,
                "8-10h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "22-24h": 2,
                "24-26h": 1,
                "34-36h": 1,
                "36-38h": 1,
                "40-42h": 2,
                "48-50h": 1,
                "52-54h": 2,
                "68-70h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "116-118h": 2,
                "126-128h": 1,
                "136-138h": 1,
                "162-164h": 1,
                "186-188h": 1,
                "188-190h": 1,
                "190-192h": 1,
                "260-262h": 1,
                "268-270h": 1,
                "340-342h": 1,
                "354-356h": 1,
                "400-402h": 1,
                "904-906h": 1,
                "986-988h": 1,
                "1112-1114h": 1,
                "1636-1638h": 1,
                "1756-1758h": 1
              },
              "tickets_count": 50,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-11-04": 1,
                "2025-11-12": 1,
                "2025-11-24": 1,
                "2025-11-28": 1,
                "2025-12-24": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-18": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-02-04": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-02-24": 1,
                "2026-03-05": 1,
                "2026-03-06": 5,
                "2026-03-11": 3,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-04-16": 3,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-25": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-03": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-14": 191.70376444444446,
                "2025-11-04": 354.15818055555553,
                "2025-11-12": 48.46675472222223,
                "2025-11-24": 40.77539722222222,
                "2025-11-28": 19.093685,
                "2025-12-24": 0.6107388888888888,
                "2026-01-08": 4.332289722222223,
                "2026-01-13": 137.35640916666665,
                "2026-01-15": 162.68732888888889,
                "2026-01-18": 1.3253358333333334,
                "2026-01-19": 36.291756666666664,
                "2026-01-22": 76.93990194444444,
                "2026-02-04": 116.20435111111111,
                "2026-02-18": 268.8867325,
                "2026-02-19": 35.32155111111111,
                "2026-02-20": 0.39842916666666667,
                "2026-02-23": 0.6560391666666666,
                "2026-02-24": 0.3888697222222222,
                "2026-03-05": 73.0323425,
                "2026-03-06": 756.9304625,
                "2026-03-11": 418.2682688888889,
                "2026-03-12": 68.8460325,
                "2026-03-18": 1637.4323055555556,
                "2026-04-13": 1756.5566922222222,
                "2026-04-15": 16.947225833333334,
                "2026-04-16": 986.4862238888888,
                "2026-04-17": 1113.101057777778,
                "2026-04-21": 1.8381133333333333,
                "2026-04-23": 905.3171116666666,
                "2026-04-27": 0.24165527777777776,
                "2026-04-30": 23.48261972222222,
                "2026-05-02": 52.18286833333333,
                "2026-05-05": 126.48723027777777,
                "2026-05-06": 260.85103833333335,
                "2026-05-12": 6.5299525,
                "2026-05-13": 53.05152666666667,
                "2026-05-14": 23.681681666666666,
                "2026-05-25": 116.931235,
                "2026-05-26": 24.538115277777777,
                "2026-05-27": 0.4674158333333333,
                "2026-06-03": 2.603283333333333,
                "2026-06-08": 1.0398577777777778
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-11-04": 1,
                "2025-11-12": 1,
                "2025-11-24": 1,
                "2025-11-28": 1,
                "2025-12-24": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-18": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-02-04": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-02-24": 1,
                "2026-03-05": 1,
                "2026-03-06": 5,
                "2026-03-11": 3,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-04-16": 3,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-25": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-03": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 147.92,
              "mode_time_hours": 49.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "14-16h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "48-50h": 2,
                "72-74h": 1,
                "100-102h": 1,
                "106-108h": 1,
                "126-128h": 1,
                "144-146h": 1,
                "162-164h": 1,
                "164-166h": 1,
                "366-368h": 1,
                "502-504h": 1,
                "576-578h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2025-11-12": 1,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2026-01-07": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-16": 1,
                "2026-03-07": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2025-11-05": 0.8562033333333333,
                "2025-11-12": 15.227498611111113,
                "2025-12-02": 162.58090083333335,
                "2025-12-11": 48.57991388888889,
                "2025-12-17": 26.07036388888889,
                "2026-01-07": 502.8444983333333,
                "2026-01-14": 272.85435805555556,
                "2026-01-15": 127.05608388888889,
                "2026-01-19": 24.469465833333334,
                "2026-01-26": 100.50626916666667,
                "2026-01-27": 144.45820750000001,
                "2026-02-03": 23.65676888888889,
                "2026-02-05": 72.87978222222223,
                "2026-02-16": 576.5972380555555,
                "2026-03-07": 49.85104638888889,
                "2026-04-29": 366.14706805555556
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2025-11-12": 1,
                "2025-12-02": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2026-01-07": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-16": 1,
                "2026-03-07": 1,
                "2026-04-29": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 267.24,
              "mode_time_hours": 289.0,
              "mode_frequency": 2,
              "time_distribution": {
                "20-22h": 1,
                "36-38h": 2,
                "56-58h": 1,
                "216-218h": 1,
                "288-290h": 2,
                "338-340h": 1,
                "526-528h": 1,
                "858-860h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-24": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-28": 1,
                "2026-03-17": 2,
                "2026-03-18": 3,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-01-24": 526.7352125,
                "2026-02-10": 338.3130075,
                "2026-02-18": 21.83288138888889,
                "2026-02-28": 57.14757,
                "2026-03-17": 74.88755416666666,
                "2026-03-18": 794.3465805555556,
                "2026-03-24": 859.1650980555556
              },
              "time_count_per_day": {
                "2026-01-24": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-28": 1,
                "2026-03-17": 2,
                "2026-03-18": 3,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 909.9,
              "mode_time_hours": 1369.0,
              "mode_frequency": 1,
              "time_distribution": {
                "234-236h": 1,
                "720-722h": 1,
                "1078-1080h": 1,
                "1142-1144h": 1,
                "1368-1370h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 4
              },
              "time_per_day": {
                "2026-01-17": 235.12547555555557,
                "2026-02-19": 4314.352371111111
              },
              "time_count_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 4
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-06": 1,
              "2026-04-24": 3,
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-24": 3,
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-06-01": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-01": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_160": {
      "overall": {
        "avg_time_hours": 281.69,
        "mode_time_hours": 191.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "52-54h": 1,
          "58-60h": 1,
          "190-192h": 1,
          "296-298h": 1,
          "700-702h": 1,
          "944-946h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-10-23": 1,
          "2025-12-11": 1,
          "2025-12-18": 1,
          "2026-01-05": 1,
          "2026-01-20": 1,
          "2026-02-10": 1,
          "2026-03-27": 1
        },
        "time_per_day": {
          "2025-10-14": 190.62699388888888,
          "2025-10-23": 59.432022499999995,
          "2025-12-11": 0.24879500000000002,
          "2025-12-18": 53.61882361111112,
          "2026-01-05": 6.525760277777778,
          "2026-01-20": 297.8713325,
          "2026-02-10": 700.4918138888888,
          "2026-03-27": 944.7043661111111
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-10-23": 1,
          "2025-12-11": 1,
          "2025-12-18": 1,
          "2026-01-05": 1,
          "2026-01-20": 1,
          "2026-02-10": 1,
          "2026-03-27": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 59.43,
          "mode_time_hours": 59.0,
          "mode_frequency": 1,
          "time_distribution": {
            "58-60h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-23": 1
          },
          "time_per_day": {
            "2025-10-23": 59.432022499999995
          },
          "time_count_per_day": {
            "2025-10-23": 1
          }
        },
        "P2": {
          "avg_time_hours": 135.59,
          "mode_time_hours": 191.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "52-54h": 1,
            "190-192h": 1,
            "296-298h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2026-01-20": 1
          },
          "time_per_day": {
            "2025-10-14": 190.62699388888888,
            "2025-12-11": 0.24879500000000002,
            "2025-12-18": 53.61882361111112,
            "2026-01-20": 297.8713325
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2026-01-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 550.57,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "700-702h": 1,
            "944-946h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-02-10": 1,
            "2026-03-27": 1
          },
          "time_per_day": {
            "2026-01-05": 6.525760277777778,
            "2026-02-10": 700.4918138888888,
            "2026-03-27": 944.7043661111111
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-02-10": 1,
            "2026-03-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 281.69,
            "mode_time_hours": 191.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "52-54h": 1,
              "58-60h": 1,
              "190-192h": 1,
              "296-298h": 1,
              "700-702h": 1,
              "944-946h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-10-23": 1,
              "2025-12-11": 1,
              "2025-12-18": 1,
              "2026-01-05": 1,
              "2026-01-20": 1,
              "2026-02-10": 1,
              "2026-03-27": 1
            },
            "time_per_day": {
              "2025-10-14": 190.62699388888888,
              "2025-10-23": 59.432022499999995,
              "2025-12-11": 0.24879500000000002,
              "2025-12-18": 53.61882361111112,
              "2026-01-05": 6.525760277777778,
              "2026-01-20": 297.8713325,
              "2026-02-10": 700.4918138888888,
              "2026-03-27": 944.7043661111111
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-10-23": 1,
              "2025-12-11": 1,
              "2025-12-18": 1,
              "2026-01-05": 1,
              "2026-01-20": 1,
              "2026-02-10": 1,
              "2026-03-27": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 59.43,
              "mode_time_hours": 59.0,
              "mode_frequency": 1,
              "time_distribution": {
                "58-60h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-23": 1
              },
              "time_per_day": {
                "2025-10-23": 59.432022499999995
              },
              "time_count_per_day": {
                "2025-10-23": 1
              }
            },
            "P2": {
              "avg_time_hours": 135.59,
              "mode_time_hours": 191.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "52-54h": 1,
                "190-192h": 1,
                "296-298h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2026-01-20": 1
              },
              "time_per_day": {
                "2025-10-14": 190.62699388888888,
                "2025-12-11": 0.24879500000000002,
                "2025-12-18": 53.61882361111112,
                "2026-01-20": 297.8713325
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2026-01-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 550.57,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "700-702h": 1,
                "944-946h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-02-10": 1,
                "2026-03-27": 1
              },
              "time_per_day": {
                "2026-01-05": 6.525760277777778,
                "2026-02-10": 700.4918138888888,
                "2026-03-27": 944.7043661111111
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-02-10": 1,
                "2026-03-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_161": {
      "overall": {
        "avg_time_hours": 287.72,
        "mode_time_hours": 743.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "40-42h": 1,
          "72-74h": 1,
          "84-86h": 1,
          "230-232h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "522-524h": 1,
          "742-744h": 1,
          "1018-1020h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-28": 1,
          "2025-12-02": 2,
          "2025-12-10": 1,
          "2025-12-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-23": 1,
          "2026-03-30": 1,
          "2026-04-23": 1,
          "2026-05-28": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-11-04": 25.869543611111112,
          "2025-11-06": 743.9638888888888,
          "2025-11-28": 231.251585,
          "2025-12-02": 670.5617116666667,
          "2025-12-10": 522.1561019444445,
          "2025-12-31": 1019.3557813888889,
          "2026-02-03": 15.935826111111112,
          "2026-02-05": 23.813142499999998,
          "2026-02-23": 73.6694263888889,
          "2026-03-30": 85.92831944444445,
          "2026-04-23": 40.154588333333336
        },
        "time_count_per_day": {
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-28": 1,
          "2025-12-02": 2,
          "2025-12-10": 1,
          "2025-12-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-23": 1,
          "2026-03-30": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 293.11,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "24-26h": 1,
            "40-42h": 1,
            "84-86h": 1,
            "334-336h": 1,
            "522-524h": 1,
            "1018-1020h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-12-02": 1,
            "2025-12-10": 1,
            "2025-12-31": 1,
            "2026-02-05": 1,
            "2026-03-30": 1,
            "2026-04-23": 1,
            "2026-05-28": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-11-04": 25.869543611111112,
            "2025-12-02": 334.46518083333336,
            "2025-12-10": 522.1561019444445,
            "2025-12-31": 1019.3557813888889,
            "2026-02-05": 23.813142499999998,
            "2026-03-30": 85.92831944444445,
            "2026-04-23": 40.154588333333336
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-12-02": 1,
            "2025-12-10": 1,
            "2025-12-31": 1,
            "2026-02-05": 1,
            "2026-03-30": 1,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 280.18,
          "mode_time_hours": 743.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "72-74h": 1,
            "230-232h": 1,
            "336-338h": 1,
            "742-744h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2026-02-03": 1,
            "2026-02-23": 1
          },
          "time_per_day": {
            "2025-11-06": 743.9638888888888,
            "2025-11-28": 231.251585,
            "2025-12-02": 336.0965308333333,
            "2026-02-03": 15.935826111111112,
            "2026-02-23": 73.6694263888889
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2026-02-03": 1,
            "2026-02-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 287.72,
            "mode_time_hours": 743.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "40-42h": 1,
              "72-74h": 1,
              "84-86h": 1,
              "230-232h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "522-524h": 1,
              "742-744h": 1,
              "1018-1020h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-28": 1,
              "2025-12-02": 2,
              "2025-12-10": 1,
              "2025-12-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-23": 1,
              "2026-03-30": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-11-04": 25.869543611111112,
              "2025-11-06": 743.9638888888888,
              "2025-11-28": 231.251585,
              "2025-12-02": 670.5617116666667,
              "2025-12-10": 522.1561019444445,
              "2025-12-31": 1019.3557813888889,
              "2026-02-03": 15.935826111111112,
              "2026-02-05": 23.813142499999998,
              "2026-02-23": 73.6694263888889,
              "2026-03-30": 85.92831944444445,
              "2026-04-23": 40.154588333333336
            },
            "time_count_per_day": {
              "2025-11-04": 1,
              "2025-11-06": 1,
              "2025-11-28": 1,
              "2025-12-02": 2,
              "2025-12-10": 1,
              "2025-12-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-23": 1,
              "2026-03-30": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 293.11,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "24-26h": 1,
                "40-42h": 1,
                "84-86h": 1,
                "334-336h": 1,
                "522-524h": 1,
                "1018-1020h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-12-02": 1,
                "2025-12-10": 1,
                "2025-12-31": 1,
                "2026-02-05": 1,
                "2026-03-30": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-11-04": 25.869543611111112,
                "2025-12-02": 334.46518083333336,
                "2025-12-10": 522.1561019444445,
                "2025-12-31": 1019.3557813888889,
                "2026-02-05": 23.813142499999998,
                "2026-03-30": 85.92831944444445,
                "2026-04-23": 40.154588333333336
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-12-02": 1,
                "2025-12-10": 1,
                "2025-12-31": 1,
                "2026-02-05": 1,
                "2026-03-30": 1,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 280.18,
              "mode_time_hours": 743.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "72-74h": 1,
                "230-232h": 1,
                "336-338h": 1,
                "742-744h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2026-02-03": 1,
                "2026-02-23": 1
              },
              "time_per_day": {
                "2025-11-06": 743.9638888888888,
                "2025-11-28": 231.251585,
                "2025-12-02": 336.0965308333333,
                "2026-02-03": 15.935826111111112,
                "2026-02-23": 73.6694263888889
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2026-02-03": 1,
                "2026-02-23": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_168": {
      "overall": {
        "avg_time_hours": 79.29,
        "mode_time_hours": 1.0,
        "mode_frequency": 65,
        "time_distribution": {
          "0-2h": 65,
          "2-4h": 7,
          "4-6h": 5,
          "6-8h": 10,
          "8-10h": 4,
          "10-12h": 2,
          "12-14h": 1,
          "14-16h": 1,
          "16-18h": 2,
          "18-20h": 4,
          "20-22h": 1,
          "22-24h": 5,
          "24-26h": 2,
          "28-30h": 1,
          "30-32h": 1,
          "32-34h": 2,
          "40-42h": 1,
          "52-54h": 1,
          "58-60h": 2,
          "68-70h": 2,
          "70-72h": 1,
          "72-74h": 1,
          "78-80h": 1,
          "90-92h": 1,
          "98-100h": 1,
          "120-122h": 1,
          "124-126h": 1,
          "138-140h": 1,
          "140-142h": 1,
          "142-144h": 1,
          "146-148h": 1,
          "154-156h": 1,
          "156-158h": 1,
          "158-160h": 2,
          "160-162h": 1,
          "164-166h": 1,
          "184-186h": 1,
          "196-198h": 1,
          "202-204h": 1,
          "204-206h": 1,
          "206-208h": 1,
          "212-214h": 1,
          "218-220h": 1,
          "240-242h": 1,
          "256-258h": 1,
          "266-268h": 1,
          "328-330h": 1,
          "370-372h": 2,
          "384-386h": 1,
          "404-406h": 2,
          "472-474h": 2,
          "500-502h": 1,
          "532-534h": 1,
          "554-556h": 1,
          "576-578h": 1,
          "672-674h": 1,
          "1240-1242h": 1
        },
        "tickets_count": 170,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-30": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-12-22": 1,
          "2026-01-16": 1,
          "2026-01-17": 2,
          "2026-01-22": 3,
          "2026-01-23": 2,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-01-30": 3,
          "2026-02-02": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-10": 3,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-02-19": 8,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-02": 2,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-17": 2,
          "2026-03-18": 18,
          "2026-03-20": 5,
          "2026-03-24": 3,
          "2026-03-25": 2,
          "2026-03-26": 2,
          "2026-03-30": 1,
          "2026-04-08": 1,
          "2026-04-10": 2,
          "2026-04-14": 1,
          "2026-04-15": 2,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-22": 3,
          "2026-04-23": 1,
          "2026-04-24": 5,
          "2026-04-27": 11,
          "2026-04-29": 2,
          "2026-05-02": 2,
          "2026-05-04": 1,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-08": 4,
          "2026-05-10": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 4,
          "2026-05-14": 2,
          "2026-05-15": 2,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-19": 3,
          "2026-05-20": 2,
          "2026-05-21": 2,
          "2026-05-22": 3,
          "2026-05-25": 2,
          "2026-05-26": 2,
          "2026-05-27": 5,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-06": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-07": 19.843606944444446,
          "2025-10-08": 1.0376438888888888,
          "2025-10-09": 41.05737222222223,
          "2025-10-10": 0.4372169444444444,
          "2025-10-14": 1.0513072222222222,
          "2025-10-15": 40.06601055555555,
          "2025-10-30": 218.19422305555554,
          "2025-11-06": 143.07160166666668,
          "2025-11-10": 6.189331944444445,
          "2025-11-13": 71.77213583333334,
          "2025-11-24": 0.07166194444444444,
          "2025-12-22": 121.19869555555556,
          "2026-01-16": 6.063266111111112,
          "2026-01-17": 177.55728361111113,
          "2026-01-22": 41.1360125,
          "2026-01-23": 52.62152861111112,
          "2026-01-27": 125.60812388888888,
          "2026-01-29": 2.8908122222222223,
          "2026-01-30": 19.371919722222223,
          "2026-02-02": 0.46797805555555555,
          "2026-02-03": 2.3845983333333334,
          "2026-02-04": 533.1324597222222,
          "2026-02-05": 416.98758194444446,
          "2026-02-10": 810.5943611111112,
          "2026-02-11": 204.44126333333332,
          "2026-02-13": 32.85229388888889,
          "2026-02-14": 23.379199999999997,
          "2026-02-18": 154.53828027777777,
          "2026-02-19": 3572.479719722222,
          "2026-02-27": 0.6757016666666666,
          "2026-02-28": 69.10925833333333,
          "2026-03-02": 1.431163611111111,
          "2026-03-05": 0.7516522222222222,
          "2026-03-06": 1.0152908333333333,
          "2026-03-17": 51.43313333333333,
          "2026-03-18": 3616.3456661111113,
          "2026-03-20": 55.505019999999995,
          "2026-03-24": 18.2867,
          "2026-03-25": 7.3519227777777765,
          "2026-03-26": 24.20422666666667,
          "2026-03-30": 3.3882630555555555,
          "2026-04-08": 13.418674444444445,
          "2026-04-10": 2.6062683333333334,
          "2026-04-14": 0.4682091666666667,
          "2026-04-15": 5.414940555555556,
          "2026-04-16": 19.238574166666666,
          "2026-04-17": 0.4898927777777778,
          "2026-04-20": 0.6086086111111111,
          "2026-04-22": 474.7719002777778,
          "2026-04-23": 14.634069444444444,
          "2026-04-24": 583.5121302777778,
          "2026-04-27": 231.55328222222224,
          "2026-04-29": 3.5376466666666673,
          "2026-05-05": 0.4672322222222222,
          "2026-05-06": 0.5495944444444444,
          "2026-05-08": 17.679449444444444,
          "2026-05-10": 32.178176944444445,
          "2026-05-11": 1.7790455555555555,
          "2026-05-12": 0.7896702777777778,
          "2026-05-13": 81.79297055555556,
          "2026-05-14": 207.81093638888888,
          "2026-05-15": 0.862975,
          "2026-05-16": 0.1335463888888889,
          "2026-05-18": 1.2251713888888889,
          "2026-05-19": 2.330404166666667,
          "2026-05-20": 9.438134166666668,
          "2026-05-21": 3.5190175000000004,
          "2026-05-22": 37.106119722222225,
          "2026-05-25": 13.543367222222223,
          "2026-05-26": 7.7881,
          "2026-05-27": 0.6094333333333334,
          "2026-05-28": 5.4505175,
          "2026-05-29": 22.886394444444445,
          "2026-06-01": 2.3665541666666665,
          "2026-06-02": 0.03248333333333333,
          "2026-06-06": 196.55488944444443
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-08": 2,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-30": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-12-22": 1,
          "2026-01-16": 1,
          "2026-01-17": 2,
          "2026-01-22": 3,
          "2026-01-23": 2,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-01-30": 3,
          "2026-02-02": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-10": 3,
          "2026-02-11": 1,
          "2026-02-13": 2,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-02-19": 8,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-02": 2,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-17": 2,
          "2026-03-18": 18,
          "2026-03-20": 5,
          "2026-03-24": 3,
          "2026-03-25": 2,
          "2026-03-26": 2,
          "2026-03-30": 1,
          "2026-04-08": 1,
          "2026-04-10": 2,
          "2026-04-14": 1,
          "2026-04-15": 2,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-22": 3,
          "2026-04-23": 1,
          "2026-04-24": 5,
          "2026-04-27": 10,
          "2026-04-29": 2,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-08": 3,
          "2026-05-10": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 4,
          "2026-05-14": 2,
          "2026-05-15": 2,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-19": 3,
          "2026-05-20": 2,
          "2026-05-21": 2,
          "2026-05-22": 3,
          "2026-05-25": 2,
          "2026-05-26": 2,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 21.26,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 2,
            "8-10h": 1,
            "20-22h": 1,
            "30-32h": 1,
            "32-34h": 1,
            "52-54h": 1,
            "58-60h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-05-10": 1,
            "2026-05-13": 2,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-01-22": 36.141846666666666,
            "2026-01-23": 52.597503611111115,
            "2026-03-20": 7.403949722222222,
            "2026-03-25": 6.970573055555555,
            "2026-04-24": 3.464617777777778,
            "2026-04-27": 8.718010277777777,
            "2026-05-10": 32.178176944444445,
            "2026-05-13": 80.97950222222222,
            "2026-05-28": 5.4505175
          },
          "time_count_per_day": {
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-05-10": 1,
            "2026-05-13": 2,
            "2026-05-28": 1
          }
        },
        "P2": {
          "avg_time_hours": 19.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 59,
          "time_distribution": {
            "0-2h": 59,
            "2-4h": 6,
            "4-6h": 2,
            "6-8h": 7,
            "8-10h": 2,
            "10-12h": 2,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 3,
            "22-24h": 4,
            "58-60h": 1,
            "146-148h": 1,
            "184-186h": 1,
            "532-534h": 1,
            "576-578h": 1
          },
          "tickets_count": 94,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-11-10": 1,
            "2025-11-24": 1,
            "2026-01-16": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 2,
            "2026-02-02": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-13": 1,
            "2026-02-27": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-18": 3,
            "2026-03-20": 3,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-26": 2,
            "2026-03-30": 1,
            "2026-04-08": 1,
            "2026-04-10": 2,
            "2026-04-14": 1,
            "2026-04-15": 2,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-24": 4,
            "2026-04-27": 9,
            "2026-04-29": 2,
            "2026-05-05": 2,
            "2026-05-06": 1,
            "2026-05-08": 3,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 2,
            "2026-05-14": 2,
            "2026-05-15": 2,
            "2026-05-16": 1,
            "2026-05-18": 1,
            "2026-05-19": 3,
            "2026-05-20": 2,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-27": 4,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-10-14": 1.0513072222222222,
            "2025-10-15": 23.104452777777777,
            "2025-11-10": 6.189331944444445,
            "2025-11-24": 0.07166194444444444,
            "2026-01-16": 6.063266111111112,
            "2026-01-22": 4.994165833333333,
            "2026-01-23": 0.024024999999999998,
            "2026-01-29": 2.8908122222222223,
            "2026-01-30": 9.7023525,
            "2026-02-02": 0.46797805555555555,
            "2026-02-03": 2.3845983333333334,
            "2026-02-04": 533.1324597222222,
            "2026-02-13": 0.22316472222222222,
            "2026-02-27": 0.6757016666666666,
            "2026-03-02": 0.6706325,
            "2026-03-05": 0.7516522222222222,
            "2026-03-06": 1.0152908333333333,
            "2026-03-18": 1.1132772222222223,
            "2026-03-20": 20.03646361111111,
            "2026-03-24": 11.031095277777776,
            "2026-03-25": 0.3813497222222222,
            "2026-03-26": 24.20422666666667,
            "2026-03-30": 3.3882630555555555,
            "2026-04-08": 13.418674444444445,
            "2026-04-10": 2.6062683333333334,
            "2026-04-14": 0.4682091666666667,
            "2026-04-15": 5.414940555555556,
            "2026-04-16": 19.238574166666666,
            "2026-04-17": 0.4898927777777778,
            "2026-04-20": 0.6086086111111111,
            "2026-04-22": 0.6042852777777779,
            "2026-04-23": 14.634069444444444,
            "2026-04-24": 580.0475125,
            "2026-04-27": 222.83527194444446,
            "2026-04-29": 3.5376466666666673,
            "2026-05-05": 0.4672322222222222,
            "2026-05-06": 0.5495944444444444,
            "2026-05-08": 17.679449444444444,
            "2026-05-11": 1.7790455555555555,
            "2026-05-12": 0.7896702777777778,
            "2026-05-13": 0.8134683333333332,
            "2026-05-14": 207.81093638888888,
            "2026-05-15": 0.862975,
            "2026-05-16": 0.1335463888888889,
            "2026-05-18": 1.2251713888888889,
            "2026-05-19": 2.330404166666667,
            "2026-05-20": 9.438134166666668,
            "2026-05-21": 3.5190175000000004,
            "2026-05-22": 37.106119722222225,
            "2026-05-25": 8.232663888888888,
            "2026-05-26": 7.7881,
            "2026-05-27": 0.6094333333333334,
            "2026-05-29": 22.886394444444445,
            "2026-06-01": 2.3665541666666665,
            "2026-06-02": 0.03248333333333333
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-11-10": 1,
            "2025-11-24": 1,
            "2026-01-16": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 2,
            "2026-02-02": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-13": 1,
            "2026-02-27": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-18": 3,
            "2026-03-20": 3,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-26": 2,
            "2026-03-30": 1,
            "2026-04-08": 1,
            "2026-04-10": 2,
            "2026-04-14": 1,
            "2026-04-15": 2,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-24": 4,
            "2026-04-27": 9,
            "2026-04-29": 2,
            "2026-05-05": 2,
            "2026-05-06": 1,
            "2026-05-08": 3,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 2,
            "2026-05-14": 2,
            "2026-05-15": 2,
            "2026-05-16": 1,
            "2026-05-18": 1,
            "2026-05-19": 3,
            "2026-05-20": 2,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-27": 3,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 47.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "32-34h": 1,
            "70-72h": 1,
            "90-92h": 1,
            "124-126h": 1,
            "164-166h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-08": 2,
            "2025-11-13": 1,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-03-02": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2025-10-07": 19.843606944444446,
            "2025-10-08": 1.0376438888888888,
            "2025-11-13": 71.77213583333334,
            "2026-01-27": 125.60812388888888,
            "2026-01-30": 9.669567222222224,
            "2026-02-10": 256.5769016666667,
            "2026-02-13": 32.629129166666665,
            "2026-03-02": 0.760531111111111,
            "2026-05-25": 5.3107033333333336
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-08": 2,
            "2025-11-13": 1,
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-10": 2,
            "2026-02-13": 1,
            "2026-03-02": 1,
            "2026-05-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 176.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "6-8h": 1,
            "16-18h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "28-30h": 1,
            "40-42h": 1,
            "68-70h": 2,
            "72-74h": 1,
            "138-140h": 1,
            "140-142h": 1,
            "142-144h": 1,
            "154-156h": 1,
            "156-158h": 1,
            "158-160h": 2,
            "160-162h": 1,
            "196-198h": 1,
            "202-204h": 1,
            "204-206h": 1,
            "206-208h": 1,
            "212-214h": 1,
            "218-220h": 1,
            "256-258h": 1,
            "266-268h": 1,
            "370-372h": 2,
            "384-386h": 1,
            "404-406h": 2,
            "500-502h": 1,
            "554-556h": 1
          },
          "tickets_count": 44,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-15": 1,
            "2025-10-30": 1,
            "2025-11-06": 1,
            "2026-02-05": 2,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-02-18": 1,
            "2026-02-19": 2,
            "2026-02-28": 1,
            "2026-03-17": 2,
            "2026-03-18": 15,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-05-02": 2,
            "2026-05-04": 1,
            "2026-05-08": 1,
            "2026-05-27": 1,
            "2026-06-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-09": 41.05737222222223,
            "2025-10-10": 0.4372169444444444,
            "2025-10-15": 16.961557777777777,
            "2025-10-30": 218.19422305555554,
            "2025-11-06": 143.07160166666668,
            "2026-02-05": 416.98758194444446,
            "2026-02-10": 554.0174594444445,
            "2026-02-11": 204.44126333333332,
            "2026-02-14": 23.379199999999997,
            "2026-02-18": 154.53828027777777,
            "2026-02-19": 143.1488361111111,
            "2026-02-28": 69.10925833333333,
            "2026-03-17": 51.43313333333333,
            "2026-03-18": 3615.232388888889,
            "2026-03-20": 28.064606666666666,
            "2026-03-24": 7.255604722222222,
            "2026-04-22": 474.167615,
            "2026-06-06": 196.55488944444443
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-10-10": 1,
            "2025-10-15": 1,
            "2025-10-30": 1,
            "2025-11-06": 1,
            "2026-02-05": 2,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-14": 1,
            "2026-02-18": 1,
            "2026-02-19": 2,
            "2026-02-28": 1,
            "2026-03-17": 2,
            "2026-03-18": 15,
            "2026-03-20": 1,
            "2026-03-24": 1,
            "2026-04-22": 2,
            "2026-06-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 414.23,
          "mode_time_hours": 473.0,
          "mode_frequency": 2,
          "time_distribution": {
            "78-80h": 1,
            "98-100h": 1,
            "120-122h": 1,
            "240-242h": 1,
            "328-330h": 1,
            "472-474h": 2,
            "672-674h": 1,
            "1240-1242h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-12-22": 1,
            "2026-01-17": 2,
            "2026-02-19": 6,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2025-12-22": 121.19869555555556,
            "2026-01-17": 177.55728361111113,
            "2026-02-19": 3429.330883611111
          },
          "time_count_per_day": {
            "2025-12-22": 1,
            "2026-01-17": 2,
            "2026-02-19": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 79.29,
            "mode_time_hours": 1.0,
            "mode_frequency": 65,
            "time_distribution": {
              "0-2h": 65,
              "2-4h": 7,
              "4-6h": 5,
              "6-8h": 10,
              "8-10h": 4,
              "10-12h": 2,
              "12-14h": 1,
              "14-16h": 1,
              "16-18h": 2,
              "18-20h": 4,
              "20-22h": 1,
              "22-24h": 5,
              "24-26h": 2,
              "28-30h": 1,
              "30-32h": 1,
              "32-34h": 2,
              "40-42h": 1,
              "52-54h": 1,
              "58-60h": 2,
              "68-70h": 2,
              "70-72h": 1,
              "72-74h": 1,
              "78-80h": 1,
              "90-92h": 1,
              "98-100h": 1,
              "120-122h": 1,
              "124-126h": 1,
              "138-140h": 1,
              "140-142h": 1,
              "142-144h": 1,
              "146-148h": 1,
              "154-156h": 1,
              "156-158h": 1,
              "158-160h": 2,
              "160-162h": 1,
              "164-166h": 1,
              "184-186h": 1,
              "196-198h": 1,
              "202-204h": 1,
              "204-206h": 1,
              "206-208h": 1,
              "212-214h": 1,
              "218-220h": 1,
              "240-242h": 1,
              "256-258h": 1,
              "266-268h": 1,
              "328-330h": 1,
              "370-372h": 2,
              "384-386h": 1,
              "404-406h": 2,
              "472-474h": 2,
              "500-502h": 1,
              "532-534h": 1,
              "554-556h": 1,
              "576-578h": 1,
              "672-674h": 1,
              "1240-1242h": 1
            },
            "tickets_count": 160,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-30": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-12-22": 1,
              "2026-01-16": 1,
              "2026-01-17": 2,
              "2026-01-22": 3,
              "2026-01-23": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-01-30": 3,
              "2026-02-02": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-10": 3,
              "2026-02-11": 1,
              "2026-02-13": 2,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-02-19": 8,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-02": 2,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-17": 2,
              "2026-03-18": 18,
              "2026-03-20": 5,
              "2026-03-24": 3,
              "2026-03-25": 2,
              "2026-03-26": 2,
              "2026-03-30": 1,
              "2026-04-08": 1,
              "2026-04-10": 2,
              "2026-04-14": 1,
              "2026-04-15": 2,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-22": 3,
              "2026-04-23": 1,
              "2026-04-24": 5,
              "2026-04-27": 10,
              "2026-04-29": 2,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-08": 3,
              "2026-05-10": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 4,
              "2026-05-14": 2,
              "2026-05-15": 2,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-19": 3,
              "2026-05-20": 2,
              "2026-05-21": 2,
              "2026-05-22": 3,
              "2026-05-25": 2,
              "2026-05-26": 2,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2025-10-07": 19.843606944444446,
              "2025-10-08": 1.0376438888888888,
              "2025-10-09": 41.05737222222223,
              "2025-10-10": 0.4372169444444444,
              "2025-10-14": 1.0513072222222222,
              "2025-10-15": 40.06601055555555,
              "2025-10-30": 218.19422305555554,
              "2025-11-06": 143.07160166666668,
              "2025-11-10": 6.189331944444445,
              "2025-11-13": 71.77213583333334,
              "2025-11-24": 0.07166194444444444,
              "2025-12-22": 121.19869555555556,
              "2026-01-16": 6.063266111111112,
              "2026-01-17": 177.55728361111113,
              "2026-01-22": 41.1360125,
              "2026-01-23": 52.62152861111112,
              "2026-01-27": 125.60812388888888,
              "2026-01-29": 2.8908122222222223,
              "2026-01-30": 19.371919722222223,
              "2026-02-02": 0.46797805555555555,
              "2026-02-03": 2.3845983333333334,
              "2026-02-04": 533.1324597222222,
              "2026-02-05": 416.98758194444446,
              "2026-02-10": 810.5943611111112,
              "2026-02-11": 204.44126333333332,
              "2026-02-13": 32.85229388888889,
              "2026-02-14": 23.379199999999997,
              "2026-02-18": 154.53828027777777,
              "2026-02-19": 3572.479719722222,
              "2026-02-27": 0.6757016666666666,
              "2026-02-28": 69.10925833333333,
              "2026-03-02": 1.431163611111111,
              "2026-03-05": 0.7516522222222222,
              "2026-03-06": 1.0152908333333333,
              "2026-03-17": 51.43313333333333,
              "2026-03-18": 3616.3456661111113,
              "2026-03-20": 55.505019999999995,
              "2026-03-24": 18.2867,
              "2026-03-25": 7.3519227777777765,
              "2026-03-26": 24.20422666666667,
              "2026-03-30": 3.3882630555555555,
              "2026-04-08": 13.418674444444445,
              "2026-04-10": 2.6062683333333334,
              "2026-04-14": 0.4682091666666667,
              "2026-04-15": 5.414940555555556,
              "2026-04-16": 19.238574166666666,
              "2026-04-17": 0.4898927777777778,
              "2026-04-20": 0.6086086111111111,
              "2026-04-22": 474.7719002777778,
              "2026-04-23": 14.634069444444444,
              "2026-04-24": 583.5121302777778,
              "2026-04-27": 231.55328222222224,
              "2026-04-29": 3.5376466666666673,
              "2026-05-05": 0.4672322222222222,
              "2026-05-06": 0.5495944444444444,
              "2026-05-08": 17.679449444444444,
              "2026-05-10": 32.178176944444445,
              "2026-05-11": 1.7790455555555555,
              "2026-05-12": 0.7896702777777778,
              "2026-05-13": 81.79297055555556,
              "2026-05-14": 207.81093638888888,
              "2026-05-15": 0.862975,
              "2026-05-16": 0.1335463888888889,
              "2026-05-18": 1.2251713888888889,
              "2026-05-19": 2.330404166666667,
              "2026-05-20": 9.438134166666668,
              "2026-05-21": 3.5190175000000004,
              "2026-05-22": 37.106119722222225,
              "2026-05-25": 13.543367222222223,
              "2026-05-26": 7.7881,
              "2026-05-27": 0.6094333333333334,
              "2026-05-28": 5.4505175,
              "2026-05-29": 22.886394444444445,
              "2026-06-01": 2.3665541666666665,
              "2026-06-02": 0.03248333333333333,
              "2026-06-06": 196.55488944444443
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-08": 2,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-30": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-12-22": 1,
              "2026-01-16": 1,
              "2026-01-17": 2,
              "2026-01-22": 3,
              "2026-01-23": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-01-30": 3,
              "2026-02-02": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-10": 3,
              "2026-02-11": 1,
              "2026-02-13": 2,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-02-19": 8,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-02": 2,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-17": 2,
              "2026-03-18": 18,
              "2026-03-20": 5,
              "2026-03-24": 3,
              "2026-03-25": 2,
              "2026-03-26": 2,
              "2026-03-30": 1,
              "2026-04-08": 1,
              "2026-04-10": 2,
              "2026-04-14": 1,
              "2026-04-15": 2,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-22": 3,
              "2026-04-23": 1,
              "2026-04-24": 5,
              "2026-04-27": 10,
              "2026-04-29": 2,
              "2026-05-05": 2,
              "2026-05-06": 1,
              "2026-05-08": 3,
              "2026-05-10": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 4,
              "2026-05-14": 2,
              "2026-05-15": 2,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-19": 3,
              "2026-05-20": 2,
              "2026-05-21": 2,
              "2026-05-22": 3,
              "2026-05-25": 2,
              "2026-05-26": 2,
              "2026-05-27": 3,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 21.26,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 2,
                "8-10h": 1,
                "20-22h": 1,
                "30-32h": 1,
                "32-34h": 1,
                "52-54h": 1,
                "58-60h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-05-10": 1,
                "2026-05-13": 2,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-01-22": 36.141846666666666,
                "2026-01-23": 52.597503611111115,
                "2026-03-20": 7.403949722222222,
                "2026-03-25": 6.970573055555555,
                "2026-04-24": 3.464617777777778,
                "2026-04-27": 8.718010277777777,
                "2026-05-10": 32.178176944444445,
                "2026-05-13": 80.97950222222222,
                "2026-05-28": 5.4505175
              },
              "time_count_per_day": {
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-24": 1,
                "2026-04-27": 1,
                "2026-05-10": 1,
                "2026-05-13": 2,
                "2026-05-28": 1
              }
            },
            "P2": {
              "avg_time_hours": 19.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 59,
              "time_distribution": {
                "0-2h": 59,
                "2-4h": 6,
                "4-6h": 2,
                "6-8h": 7,
                "8-10h": 2,
                "10-12h": 2,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 3,
                "22-24h": 4,
                "58-60h": 1,
                "146-148h": 1,
                "184-186h": 1,
                "532-534h": 1,
                "576-578h": 1
              },
              "tickets_count": 93,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-11-10": 1,
                "2025-11-24": 1,
                "2026-01-16": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 2,
                "2026-02-02": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-13": 1,
                "2026-02-27": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-18": 3,
                "2026-03-20": 3,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-26": 2,
                "2026-03-30": 1,
                "2026-04-08": 1,
                "2026-04-10": 2,
                "2026-04-14": 1,
                "2026-04-15": 2,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-24": 4,
                "2026-04-27": 9,
                "2026-04-29": 2,
                "2026-05-05": 2,
                "2026-05-06": 1,
                "2026-05-08": 3,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-13": 2,
                "2026-05-14": 2,
                "2026-05-15": 2,
                "2026-05-16": 1,
                "2026-05-18": 1,
                "2026-05-19": 3,
                "2026-05-20": 2,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-25": 1,
                "2026-05-26": 2,
                "2026-05-27": 3,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-14": 1.0513072222222222,
                "2025-10-15": 23.104452777777777,
                "2025-11-10": 6.189331944444445,
                "2025-11-24": 0.07166194444444444,
                "2026-01-16": 6.063266111111112,
                "2026-01-22": 4.994165833333333,
                "2026-01-23": 0.024024999999999998,
                "2026-01-29": 2.8908122222222223,
                "2026-01-30": 9.7023525,
                "2026-02-02": 0.46797805555555555,
                "2026-02-03": 2.3845983333333334,
                "2026-02-04": 533.1324597222222,
                "2026-02-13": 0.22316472222222222,
                "2026-02-27": 0.6757016666666666,
                "2026-03-02": 0.6706325,
                "2026-03-05": 0.7516522222222222,
                "2026-03-06": 1.0152908333333333,
                "2026-03-18": 1.1132772222222223,
                "2026-03-20": 20.03646361111111,
                "2026-03-24": 11.031095277777776,
                "2026-03-25": 0.3813497222222222,
                "2026-03-26": 24.20422666666667,
                "2026-03-30": 3.3882630555555555,
                "2026-04-08": 13.418674444444445,
                "2026-04-10": 2.6062683333333334,
                "2026-04-14": 0.4682091666666667,
                "2026-04-15": 5.414940555555556,
                "2026-04-16": 19.238574166666666,
                "2026-04-17": 0.4898927777777778,
                "2026-04-20": 0.6086086111111111,
                "2026-04-22": 0.6042852777777779,
                "2026-04-23": 14.634069444444444,
                "2026-04-24": 580.0475125,
                "2026-04-27": 222.83527194444446,
                "2026-04-29": 3.5376466666666673,
                "2026-05-05": 0.4672322222222222,
                "2026-05-06": 0.5495944444444444,
                "2026-05-08": 17.679449444444444,
                "2026-05-11": 1.7790455555555555,
                "2026-05-12": 0.7896702777777778,
                "2026-05-13": 0.8134683333333332,
                "2026-05-14": 207.81093638888888,
                "2026-05-15": 0.862975,
                "2026-05-16": 0.1335463888888889,
                "2026-05-18": 1.2251713888888889,
                "2026-05-19": 2.330404166666667,
                "2026-05-20": 9.438134166666668,
                "2026-05-21": 3.5190175000000004,
                "2026-05-22": 37.106119722222225,
                "2026-05-25": 8.232663888888888,
                "2026-05-26": 7.7881,
                "2026-05-27": 0.6094333333333334,
                "2026-05-29": 22.886394444444445,
                "2026-06-01": 2.3665541666666665,
                "2026-06-02": 0.03248333333333333
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-11-10": 1,
                "2025-11-24": 1,
                "2026-01-16": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 2,
                "2026-02-02": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-13": 1,
                "2026-02-27": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-18": 3,
                "2026-03-20": 3,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-26": 2,
                "2026-03-30": 1,
                "2026-04-08": 1,
                "2026-04-10": 2,
                "2026-04-14": 1,
                "2026-04-15": 2,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-24": 4,
                "2026-04-27": 9,
                "2026-04-29": 2,
                "2026-05-05": 2,
                "2026-05-06": 1,
                "2026-05-08": 3,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-13": 2,
                "2026-05-14": 2,
                "2026-05-15": 2,
                "2026-05-16": 1,
                "2026-05-18": 1,
                "2026-05-19": 3,
                "2026-05-20": 2,
                "2026-05-21": 2,
                "2026-05-22": 3,
                "2026-05-25": 1,
                "2026-05-26": 2,
                "2026-05-27": 3,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 47.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "32-34h": 1,
                "70-72h": 1,
                "90-92h": 1,
                "124-126h": 1,
                "164-166h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-08": 2,
                "2025-11-13": 1,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-03-02": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-10-07": 19.843606944444446,
                "2025-10-08": 1.0376438888888888,
                "2025-11-13": 71.77213583333334,
                "2026-01-27": 125.60812388888888,
                "2026-01-30": 9.669567222222224,
                "2026-02-10": 256.5769016666667,
                "2026-02-13": 32.629129166666665,
                "2026-03-02": 0.760531111111111,
                "2026-05-25": 5.3107033333333336
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-08": 2,
                "2025-11-13": 1,
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-10": 2,
                "2026-02-13": 1,
                "2026-03-02": 1,
                "2026-05-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 176.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "6-8h": 1,
                "16-18h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "28-30h": 1,
                "40-42h": 1,
                "68-70h": 2,
                "72-74h": 1,
                "138-140h": 1,
                "140-142h": 1,
                "142-144h": 1,
                "154-156h": 1,
                "156-158h": 1,
                "158-160h": 2,
                "160-162h": 1,
                "196-198h": 1,
                "202-204h": 1,
                "204-206h": 1,
                "206-208h": 1,
                "212-214h": 1,
                "218-220h": 1,
                "256-258h": 1,
                "266-268h": 1,
                "370-372h": 2,
                "384-386h": 1,
                "404-406h": 2,
                "500-502h": 1,
                "554-556h": 1
              },
              "tickets_count": 36,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-15": 1,
                "2025-10-30": 1,
                "2025-11-06": 1,
                "2026-02-05": 2,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-14": 1,
                "2026-02-18": 1,
                "2026-02-19": 2,
                "2026-02-28": 1,
                "2026-03-17": 2,
                "2026-03-18": 15,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-04-22": 2,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-09": 41.05737222222223,
                "2025-10-10": 0.4372169444444444,
                "2025-10-15": 16.961557777777777,
                "2025-10-30": 218.19422305555554,
                "2025-11-06": 143.07160166666668,
                "2026-02-05": 416.98758194444446,
                "2026-02-10": 554.0174594444445,
                "2026-02-11": 204.44126333333332,
                "2026-02-14": 23.379199999999997,
                "2026-02-18": 154.53828027777777,
                "2026-02-19": 143.1488361111111,
                "2026-02-28": 69.10925833333333,
                "2026-03-17": 51.43313333333333,
                "2026-03-18": 3615.232388888889,
                "2026-03-20": 28.064606666666666,
                "2026-03-24": 7.255604722222222,
                "2026-04-22": 474.167615,
                "2026-06-06": 196.55488944444443
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-10-10": 1,
                "2025-10-15": 1,
                "2025-10-30": 1,
                "2025-11-06": 1,
                "2026-02-05": 2,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-14": 1,
                "2026-02-18": 1,
                "2026-02-19": 2,
                "2026-02-28": 1,
                "2026-03-17": 2,
                "2026-03-18": 15,
                "2026-03-20": 1,
                "2026-03-24": 1,
                "2026-04-22": 2,
                "2026-06-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 414.23,
              "mode_time_hours": 473.0,
              "mode_frequency": 2,
              "time_distribution": {
                "78-80h": 1,
                "98-100h": 1,
                "120-122h": 1,
                "240-242h": 1,
                "328-330h": 1,
                "472-474h": 2,
                "672-674h": 1,
                "1240-1242h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-12-22": 1,
                "2026-01-17": 2,
                "2026-02-19": 6
              },
              "time_per_day": {
                "2025-12-22": 121.19869555555556,
                "2026-01-17": 177.55728361111113,
                "2026-02-19": 3429.330883611111
              },
              "time_count_per_day": {
                "2025-12-22": 1,
                "2026-01-17": 2,
                "2026-02-19": 6
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-03-09": 1,
              "2026-04-27": 1,
              "2026-05-02": 2,
              "2026-05-04": 1,
              "2026-05-08": 1,
              "2026-05-27": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-04-27": 1,
                "2026-05-02": 2,
                "2026-05-04": 1,
                "2026-05-08": 1,
                "2026-05-27": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_170": {
      "overall": {
        "avg_time_hours": 45.86,
        "mode_time_hours": 1.0,
        "mode_frequency": 73,
        "time_distribution": {
          "0-2h": 73,
          "2-4h": 19,
          "4-6h": 9,
          "6-8h": 10,
          "10-12h": 1,
          "20-22h": 2,
          "22-24h": 1,
          "24-26h": 1,
          "26-28h": 3,
          "28-30h": 1,
          "52-54h": 1,
          "78-80h": 1,
          "80-82h": 1,
          "122-124h": 1,
          "194-196h": 1,
          "272-274h": 1,
          "320-322h": 1,
          "336-338h": 1,
          "410-412h": 1,
          "412-414h": 1,
          "456-458h": 1,
          "458-460h": 1,
          "482-484h": 1,
          "528-530h": 1,
          "532-534h": 1,
          "544-546h": 1,
          "558-560h": 1
        },
        "tickets_count": 139,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-23": 2,
          "2025-10-30": 2,
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-11-11": 6,
          "2025-11-12": 2,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-24": 2,
          "2025-11-26": 2,
          "2025-11-27": 1,
          "2025-11-29": 2,
          "2025-12-02": 2,
          "2025-12-03": 3,
          "2025-12-05": 2,
          "2025-12-09": 1,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-15": 4,
          "2025-12-17": 1,
          "2025-12-19": 1,
          "2025-12-23": 1,
          "2025-12-26": 2,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-13": 3,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-20": 4,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-26": 2,
          "2026-01-27": 2,
          "2026-01-28": 1,
          "2026-01-29": 3,
          "2026-01-30": 1,
          "2026-02-03": 4,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-16": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-26": 1,
          "2026-02-27": 2,
          "2026-03-02": 2,
          "2026-03-03": 4,
          "2026-03-04": 2,
          "2026-03-13": 3,
          "2026-03-16": 1,
          "2026-03-23": 3,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-03-28": 1,
          "2026-04-13": 1,
          "2026-04-23": 1,
          "2026-04-24": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-06": 3,
          "2026-05-07": 2,
          "2026-05-18": 6,
          "2026-05-20": 1,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-29": 1,
          "2026-06-01": 2,
          "2026-06-02": 1,
          "2026-06-05": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-07": 11.313169444444446,
          "2025-10-09": 0.2294986111111111,
          "2025-10-10": 0.15278555555555556,
          "2025-10-23": 30.27611027777778,
          "2025-10-30": 15.268503055555556,
          "2025-10-31": 0.03053222222222222,
          "2025-11-10": 2.1673608333333334,
          "2025-11-11": 17.547169444444442,
          "2025-11-12": 26.29326388888889,
          "2025-11-13": 23.8429125,
          "2025-11-19": 3.5744297222222223,
          "2025-11-24": 8.037226944444445,
          "2025-11-26": 2.9735702777777773,
          "2025-11-27": 27.569133333333333,
          "2025-11-29": 915.278146111111,
          "2025-12-02": 0.26306861111111113,
          "2025-12-03": 22.329212777777776,
          "2025-12-05": 1.1965816666666667,
          "2025-12-09": 1.1274111111111111,
          "2025-12-10": 4.090787777777777,
          "2025-12-11": 415.67632138888894,
          "2025-12-15": 484.59753916666665,
          "2025-12-17": 4.365002777777778,
          "2025-12-19": 413.60750083333335,
          "2025-12-23": 0.4351075,
          "2025-12-26": 0.421295,
          "2026-01-09": 337.97612444444445,
          "2026-01-12": 0.4317683333333333,
          "2026-01-13": 40.612724722222225,
          "2026-01-14": 3.882632777777778,
          "2026-01-15": 1.4682177777777776,
          "2026-01-20": 12.292313055555557,
          "2026-01-22": 4.5882775,
          "2026-01-23": 0.5955002777777778,
          "2026-01-26": 9.228560277777778,
          "2026-01-27": 125.54781666666666,
          "2026-01-28": 6.5109602777777775,
          "2026-01-29": 10.135090555555555,
          "2026-01-30": 6.647329999999999,
          "2026-02-03": 344.0671275,
          "2026-02-06": 273.4243158333333,
          "2026-02-10": 4.944014722222223,
          "2026-02-12": 1.9000505555555556,
          "2026-02-13": 199.30687416666666,
          "2026-02-16": 0.17862194444444443,
          "2026-02-19": 545.3312847222222,
          "2026-02-20": 1.2597525,
          "2026-02-24": 0.4711722222222222,
          "2026-02-26": 6.66357,
          "2026-02-27": 3.9109000000000003,
          "2026-03-02": 161.17745916666667,
          "2026-03-03": 11.096290555555557,
          "2026-03-04": 2.293969722222222,
          "2026-03-13": 1.9610880555555554,
          "2026-03-16": 1.5462075,
          "2026-03-23": 1.7128333333333334,
          "2026-03-24": 1.2754733333333332,
          "2026-03-25": 532.979713611111,
          "2026-03-28": 0.06711611111111111,
          "2026-04-13": 0.8018969444444445,
          "2026-04-23": 558.3781802777778,
          "2026-04-24": 0.05080111111111111,
          "2026-04-29": 0.10283138888888889,
          "2026-04-30": 2.4379483333333334,
          "2026-05-06": 530.6383266666668,
          "2026-05-07": 27.45062611111111,
          "2026-05-18": 11.255858055555557,
          "2026-05-20": 1.1599827777777778,
          "2026-05-25": 2.4082558333333335,
          "2026-05-26": 0.31214972222222226,
          "2026-05-27": 0.12151138888888888,
          "2026-06-01": 4.223919444444444,
          "2026-06-02": 0.9382919444444445,
          "2026-06-05": 53.855404444444446,
          "2026-06-08": 0.35714944444444446
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-10": 1,
          "2025-10-23": 2,
          "2025-10-30": 2,
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-11-11": 6,
          "2025-11-12": 2,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-24": 2,
          "2025-11-26": 2,
          "2025-11-27": 1,
          "2025-11-29": 2,
          "2025-12-02": 2,
          "2025-12-03": 3,
          "2025-12-05": 2,
          "2025-12-09": 1,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-15": 4,
          "2025-12-17": 1,
          "2025-12-19": 1,
          "2025-12-23": 1,
          "2025-12-26": 2,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-01-13": 3,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-20": 4,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-26": 2,
          "2026-01-27": 2,
          "2026-01-28": 1,
          "2026-01-29": 3,
          "2026-01-30": 1,
          "2026-02-03": 4,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-16": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-26": 1,
          "2026-02-27": 2,
          "2026-03-02": 2,
          "2026-03-03": 4,
          "2026-03-04": 2,
          "2026-03-13": 3,
          "2026-03-16": 1,
          "2026-03-23": 3,
          "2026-03-24": 2,
          "2026-03-25": 2,
          "2026-03-28": 1,
          "2026-04-13": 1,
          "2026-04-23": 1,
          "2026-04-24": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-06": 3,
          "2026-05-07": 2,
          "2026-05-18": 5,
          "2026-05-20": 1,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-01": 2,
          "2026-06-02": 1,
          "2026-06-05": 2,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 13.41,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 7,
            "4-6h": 2,
            "6-8h": 5,
            "78-80h": 1,
            "80-82h": 1,
            "122-124h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2025-10-30": 2,
            "2025-11-11": 4,
            "2025-11-24": 1,
            "2025-11-26": 1,
            "2025-12-03": 2,
            "2025-12-10": 1,
            "2026-01-14": 2,
            "2026-01-20": 1,
            "2026-01-27": 1,
            "2026-01-29": 2,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 2,
            "2026-03-13": 2,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-30": 15.268503055555556,
            "2025-11-11": 10.138170555555556,
            "2025-11-24": 4.409907222222222,
            "2025-11-26": 2.256071111111111,
            "2025-12-03": 0.8916813888888888,
            "2025-12-10": 1.3825533333333333,
            "2026-01-14": 3.882632777777778,
            "2026-01-20": 6.294151944444445,
            "2026-01-27": 123.93923333333333,
            "2026-01-29": 9.334405555555556,
            "2026-02-26": 6.66357,
            "2026-02-27": 3.7128622222222223,
            "2026-03-02": 161.17745916666667,
            "2026-03-03": 7.538062222222223,
            "2026-03-04": 2.293969722222222,
            "2026-03-13": 0.9514119444444444,
            "2026-06-01": 1.8158222222222222
          },
          "time_count_per_day": {
            "2025-10-30": 2,
            "2025-11-11": 4,
            "2025-11-24": 1,
            "2025-11-26": 1,
            "2025-12-03": 2,
            "2025-12-10": 1,
            "2026-01-14": 2,
            "2026-01-20": 1,
            "2026-01-27": 1,
            "2026-01-29": 2,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 2,
            "2026-03-13": 2,
            "2026-06-01": 1
          }
        },
        "P2": {
          "avg_time_hours": 32.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 57,
          "time_distribution": {
            "0-2h": 57,
            "2-4h": 11,
            "4-6h": 4,
            "6-8h": 4,
            "10-12h": 1,
            "20-22h": 1,
            "26-28h": 2,
            "28-30h": 1,
            "52-54h": 1,
            "194-196h": 1,
            "336-338h": 1,
            "412-414h": 1,
            "528-530h": 1,
            "532-534h": 1,
            "558-560h": 1
          },
          "tickets_count": 90,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-10": 1,
            "2025-10-23": 2,
            "2025-10-31": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2025-12-02": 2,
            "2025-12-05": 2,
            "2025-12-10": 2,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2025-12-23": 1,
            "2025-12-26": 2,
            "2026-01-09": 1,
            "2026-01-13": 3,
            "2026-01-15": 1,
            "2026-01-20": 3,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-27": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 3,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-16": 2,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-03-03": 3,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-23": 3,
            "2026-03-24": 2,
            "2026-03-25": 2,
            "2026-03-28": 1,
            "2026-04-13": 1,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-06": 3,
            "2026-05-07": 2,
            "2026-05-18": 6,
            "2026-05-20": 1,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-07": 11.313169444444446,
            "2025-10-10": 0.15278555555555556,
            "2025-10-23": 30.27611027777778,
            "2025-10-31": 0.03053222222222222,
            "2025-11-10": 2.1673608333333334,
            "2025-11-11": 0.5083052777777778,
            "2025-11-12": 0.39291305555555556,
            "2025-11-19": 3.5744297222222223,
            "2025-11-26": 0.7174991666666666,
            "2025-12-02": 0.26306861111111113,
            "2025-12-05": 1.1965816666666667,
            "2025-12-10": 2.7082344444444444,
            "2025-12-15": 0.8886016666666667,
            "2025-12-19": 413.60750083333335,
            "2025-12-23": 0.4351075,
            "2025-12-26": 0.421295,
            "2026-01-09": 337.97612444444445,
            "2026-01-13": 40.612724722222225,
            "2026-01-15": 1.4682177777777776,
            "2026-01-20": 5.998161111111111,
            "2026-01-22": 4.5882775,
            "2026-01-23": 0.5955002777777778,
            "2026-01-26": 9.228560277777778,
            "2026-01-27": 1.6085833333333333,
            "2026-01-28": 6.5109602777777775,
            "2026-01-29": 0.800685,
            "2026-01-30": 6.647329999999999,
            "2026-02-03": 22.361329166666664,
            "2026-02-12": 0.7627441666666667,
            "2026-02-13": 199.30687416666666,
            "2026-02-16": 0.17862194444444443,
            "2026-02-20": 1.2597525,
            "2026-02-24": 0.4711722222222222,
            "2026-03-03": 3.558228333333334,
            "2026-03-13": 1.009676111111111,
            "2026-03-16": 1.5462075,
            "2026-03-23": 1.7128333333333334,
            "2026-03-24": 1.2754733333333332,
            "2026-03-25": 532.979713611111,
            "2026-03-28": 0.06711611111111111,
            "2026-04-13": 0.8018969444444445,
            "2026-04-23": 558.3781802777778,
            "2026-04-24": 0.05080111111111111,
            "2026-04-29": 0.10283138888888889,
            "2026-04-30": 2.4379483333333334,
            "2026-05-06": 530.6383266666668,
            "2026-05-07": 27.45062611111111,
            "2026-05-18": 11.255858055555557,
            "2026-05-20": 1.1599827777777778,
            "2026-05-25": 2.4082558333333335,
            "2026-05-26": 0.31214972222222226,
            "2026-05-27": 0.12151138888888888,
            "2026-06-01": 2.408097222222222,
            "2026-06-02": 0.9382919444444445,
            "2026-06-05": 53.855404444444446,
            "2026-06-08": 0.35714944444444446
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-10": 1,
            "2025-10-23": 2,
            "2025-10-31": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2025-12-02": 2,
            "2025-12-05": 2,
            "2025-12-10": 2,
            "2025-12-15": 2,
            "2025-12-19": 1,
            "2025-12-23": 1,
            "2025-12-26": 2,
            "2026-01-09": 1,
            "2026-01-13": 3,
            "2026-01-15": 1,
            "2026-01-20": 3,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-27": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 3,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-16": 2,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-03-03": 3,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-23": 3,
            "2026-03-24": 2,
            "2026-03-25": 2,
            "2026-03-28": 1,
            "2026-04-13": 1,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-06": 3,
            "2026-05-07": 2,
            "2026-05-18": 5,
            "2026-05-20": 1,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 87.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1,
            "4-6h": 3,
            "20-22h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "320-322h": 1,
            "410-412h": 1,
            "482-484h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-03": 1,
            "2025-12-09": 1,
            "2025-12-11": 2,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-12": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-09": 0.2294986111111111,
            "2025-11-13": 23.8429125,
            "2025-11-24": 3.6273197222222224,
            "2025-11-27": 27.569133333333333,
            "2025-12-03": 21.43753138888889,
            "2025-12-09": 1.1274111111111111,
            "2025-12-11": 415.67632138888894,
            "2025-12-15": 483.7089375,
            "2025-12-17": 4.365002777777778,
            "2026-01-12": 0.4317683333333333,
            "2026-02-03": 321.70579833333335,
            "2026-02-10": 4.944014722222223,
            "2026-02-12": 1.1373063888888888
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-03": 1,
            "2025-12-09": 1,
            "2025-12-11": 2,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2026-01-12": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 203.62,
          "mode_time_hours": 459.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "24-26h": 1,
            "272-274h": 1,
            "456-458h": 1,
            "458-460h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-29": 2,
            "2026-02-06": 1,
            "2026-02-27": 1
          },
          "time_per_day": {
            "2025-11-11": 6.900693611111111,
            "2025-11-12": 25.900350833333334,
            "2025-11-29": 915.278146111111,
            "2026-02-06": 273.4243158333333,
            "2026-02-27": 0.19803777777777778
          },
          "time_count_per_day": {
            "2025-11-11": 1,
            "2025-11-12": 1,
            "2025-11-29": 2,
            "2026-02-06": 1,
            "2026-02-27": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 545.33,
          "mode_time_hours": 545.0,
          "mode_frequency": 1,
          "time_distribution": {
            "544-546h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 545.3312847222222
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 45.86,
            "mode_time_hours": 1.0,
            "mode_frequency": 73,
            "time_distribution": {
              "0-2h": 73,
              "2-4h": 19,
              "4-6h": 9,
              "6-8h": 10,
              "10-12h": 1,
              "20-22h": 2,
              "22-24h": 1,
              "24-26h": 1,
              "26-28h": 3,
              "28-30h": 1,
              "52-54h": 1,
              "78-80h": 1,
              "80-82h": 1,
              "122-124h": 1,
              "194-196h": 1,
              "272-274h": 1,
              "320-322h": 1,
              "336-338h": 1,
              "410-412h": 1,
              "412-414h": 1,
              "456-458h": 1,
              "458-460h": 1,
              "482-484h": 1,
              "528-530h": 1,
              "532-534h": 1,
              "544-546h": 1,
              "558-560h": 1
            },
            "tickets_count": 137,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-23": 2,
              "2025-10-30": 2,
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-11-11": 6,
              "2025-11-12": 2,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-24": 2,
              "2025-11-26": 2,
              "2025-11-27": 1,
              "2025-11-29": 2,
              "2025-12-02": 2,
              "2025-12-03": 3,
              "2025-12-05": 2,
              "2025-12-09": 1,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-15": 4,
              "2025-12-17": 1,
              "2025-12-19": 1,
              "2025-12-23": 1,
              "2025-12-26": 2,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-13": 3,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-20": 4,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-26": 2,
              "2026-01-27": 2,
              "2026-01-28": 1,
              "2026-01-29": 3,
              "2026-01-30": 1,
              "2026-02-03": 4,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-16": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-26": 1,
              "2026-02-27": 2,
              "2026-03-02": 2,
              "2026-03-03": 4,
              "2026-03-04": 2,
              "2026-03-13": 3,
              "2026-03-16": 1,
              "2026-03-23": 3,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-03-28": 1,
              "2026-04-13": 1,
              "2026-04-23": 1,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-06": 3,
              "2026-05-07": 2,
              "2026-05-18": 5,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 2,
              "2026-06-02": 1,
              "2026-06-05": 2,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-07": 11.313169444444446,
              "2025-10-09": 0.2294986111111111,
              "2025-10-10": 0.15278555555555556,
              "2025-10-23": 30.27611027777778,
              "2025-10-30": 15.268503055555556,
              "2025-10-31": 0.03053222222222222,
              "2025-11-10": 2.1673608333333334,
              "2025-11-11": 17.547169444444442,
              "2025-11-12": 26.29326388888889,
              "2025-11-13": 23.8429125,
              "2025-11-19": 3.5744297222222223,
              "2025-11-24": 8.037226944444445,
              "2025-11-26": 2.9735702777777773,
              "2025-11-27": 27.569133333333333,
              "2025-11-29": 915.278146111111,
              "2025-12-02": 0.26306861111111113,
              "2025-12-03": 22.329212777777776,
              "2025-12-05": 1.1965816666666667,
              "2025-12-09": 1.1274111111111111,
              "2025-12-10": 4.090787777777777,
              "2025-12-11": 415.67632138888894,
              "2025-12-15": 484.59753916666665,
              "2025-12-17": 4.365002777777778,
              "2025-12-19": 413.60750083333335,
              "2025-12-23": 0.4351075,
              "2025-12-26": 0.421295,
              "2026-01-09": 337.97612444444445,
              "2026-01-12": 0.4317683333333333,
              "2026-01-13": 40.612724722222225,
              "2026-01-14": 3.882632777777778,
              "2026-01-15": 1.4682177777777776,
              "2026-01-20": 12.292313055555557,
              "2026-01-22": 4.5882775,
              "2026-01-23": 0.5955002777777778,
              "2026-01-26": 9.228560277777778,
              "2026-01-27": 125.54781666666666,
              "2026-01-28": 6.5109602777777775,
              "2026-01-29": 10.135090555555555,
              "2026-01-30": 6.647329999999999,
              "2026-02-03": 344.0671275,
              "2026-02-06": 273.4243158333333,
              "2026-02-10": 4.944014722222223,
              "2026-02-12": 1.9000505555555556,
              "2026-02-13": 199.30687416666666,
              "2026-02-16": 0.17862194444444443,
              "2026-02-19": 545.3312847222222,
              "2026-02-20": 1.2597525,
              "2026-02-24": 0.4711722222222222,
              "2026-02-26": 6.66357,
              "2026-02-27": 3.9109000000000003,
              "2026-03-02": 161.17745916666667,
              "2026-03-03": 11.096290555555557,
              "2026-03-04": 2.293969722222222,
              "2026-03-13": 1.9610880555555554,
              "2026-03-16": 1.5462075,
              "2026-03-23": 1.7128333333333334,
              "2026-03-24": 1.2754733333333332,
              "2026-03-25": 532.979713611111,
              "2026-03-28": 0.06711611111111111,
              "2026-04-13": 0.8018969444444445,
              "2026-04-23": 558.3781802777778,
              "2026-04-24": 0.05080111111111111,
              "2026-04-29": 0.10283138888888889,
              "2026-04-30": 2.4379483333333334,
              "2026-05-06": 530.6383266666668,
              "2026-05-07": 27.45062611111111,
              "2026-05-18": 11.255858055555557,
              "2026-05-20": 1.1599827777777778,
              "2026-05-25": 2.4082558333333335,
              "2026-05-26": 0.31214972222222226,
              "2026-05-27": 0.12151138888888888,
              "2026-06-01": 4.223919444444444,
              "2026-06-02": 0.9382919444444445,
              "2026-06-05": 53.855404444444446,
              "2026-06-08": 0.35714944444444446
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-10": 1,
              "2025-10-23": 2,
              "2025-10-30": 2,
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-11-11": 6,
              "2025-11-12": 2,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-24": 2,
              "2025-11-26": 2,
              "2025-11-27": 1,
              "2025-11-29": 2,
              "2025-12-02": 2,
              "2025-12-03": 3,
              "2025-12-05": 2,
              "2025-12-09": 1,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-15": 4,
              "2025-12-17": 1,
              "2025-12-19": 1,
              "2025-12-23": 1,
              "2025-12-26": 2,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-01-13": 3,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-20": 4,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-26": 2,
              "2026-01-27": 2,
              "2026-01-28": 1,
              "2026-01-29": 3,
              "2026-01-30": 1,
              "2026-02-03": 4,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-16": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-26": 1,
              "2026-02-27": 2,
              "2026-03-02": 2,
              "2026-03-03": 4,
              "2026-03-04": 2,
              "2026-03-13": 3,
              "2026-03-16": 1,
              "2026-03-23": 3,
              "2026-03-24": 2,
              "2026-03-25": 2,
              "2026-03-28": 1,
              "2026-04-13": 1,
              "2026-04-23": 1,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-06": 3,
              "2026-05-07": 2,
              "2026-05-18": 5,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 2,
              "2026-06-02": 1,
              "2026-06-05": 2,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 13.41,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 7,
                "4-6h": 2,
                "6-8h": 5,
                "78-80h": 1,
                "80-82h": 1,
                "122-124h": 1
              },
              "tickets_count": 27,
              "tickets_per_day": {
                "2025-10-30": 2,
                "2025-11-11": 4,
                "2025-11-24": 1,
                "2025-11-26": 1,
                "2025-12-03": 2,
                "2025-12-10": 1,
                "2026-01-14": 2,
                "2026-01-20": 1,
                "2026-01-27": 1,
                "2026-01-29": 2,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 2,
                "2026-03-13": 2,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-30": 15.268503055555556,
                "2025-11-11": 10.138170555555556,
                "2025-11-24": 4.409907222222222,
                "2025-11-26": 2.256071111111111,
                "2025-12-03": 0.8916813888888888,
                "2025-12-10": 1.3825533333333333,
                "2026-01-14": 3.882632777777778,
                "2026-01-20": 6.294151944444445,
                "2026-01-27": 123.93923333333333,
                "2026-01-29": 9.334405555555556,
                "2026-02-26": 6.66357,
                "2026-02-27": 3.7128622222222223,
                "2026-03-02": 161.17745916666667,
                "2026-03-03": 7.538062222222223,
                "2026-03-04": 2.293969722222222,
                "2026-03-13": 0.9514119444444444,
                "2026-06-01": 1.8158222222222222
              },
              "time_count_per_day": {
                "2025-10-30": 2,
                "2025-11-11": 4,
                "2025-11-24": 1,
                "2025-11-26": 1,
                "2025-12-03": 2,
                "2025-12-10": 1,
                "2026-01-14": 2,
                "2026-01-20": 1,
                "2026-01-27": 1,
                "2026-01-29": 2,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 2,
                "2026-03-13": 2,
                "2026-06-01": 1
              }
            },
            "P2": {
              "avg_time_hours": 32.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 57,
              "time_distribution": {
                "0-2h": 57,
                "2-4h": 11,
                "4-6h": 4,
                "6-8h": 4,
                "10-12h": 1,
                "20-22h": 1,
                "26-28h": 2,
                "28-30h": 1,
                "52-54h": 1,
                "194-196h": 1,
                "336-338h": 1,
                "412-414h": 1,
                "528-530h": 1,
                "532-534h": 1,
                "558-560h": 1
              },
              "tickets_count": 88,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-10": 1,
                "2025-10-23": 2,
                "2025-10-31": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2025-12-02": 2,
                "2025-12-05": 2,
                "2025-12-10": 2,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2025-12-23": 1,
                "2025-12-26": 2,
                "2026-01-09": 1,
                "2026-01-13": 3,
                "2026-01-15": 1,
                "2026-01-20": 3,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-27": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 3,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-16": 2,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-03-03": 3,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-23": 3,
                "2026-03-24": 2,
                "2026-03-25": 2,
                "2026-03-28": 1,
                "2026-04-13": 1,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-06": 3,
                "2026-05-07": 2,
                "2026-05-18": 5,
                "2026-05-20": 1,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 2,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-07": 11.313169444444446,
                "2025-10-10": 0.15278555555555556,
                "2025-10-23": 30.27611027777778,
                "2025-10-31": 0.03053222222222222,
                "2025-11-10": 2.1673608333333334,
                "2025-11-11": 0.5083052777777778,
                "2025-11-12": 0.39291305555555556,
                "2025-11-19": 3.5744297222222223,
                "2025-11-26": 0.7174991666666666,
                "2025-12-02": 0.26306861111111113,
                "2025-12-05": 1.1965816666666667,
                "2025-12-10": 2.7082344444444444,
                "2025-12-15": 0.8886016666666667,
                "2025-12-19": 413.60750083333335,
                "2025-12-23": 0.4351075,
                "2025-12-26": 0.421295,
                "2026-01-09": 337.97612444444445,
                "2026-01-13": 40.612724722222225,
                "2026-01-15": 1.4682177777777776,
                "2026-01-20": 5.998161111111111,
                "2026-01-22": 4.5882775,
                "2026-01-23": 0.5955002777777778,
                "2026-01-26": 9.228560277777778,
                "2026-01-27": 1.6085833333333333,
                "2026-01-28": 6.5109602777777775,
                "2026-01-29": 0.800685,
                "2026-01-30": 6.647329999999999,
                "2026-02-03": 22.361329166666664,
                "2026-02-12": 0.7627441666666667,
                "2026-02-13": 199.30687416666666,
                "2026-02-16": 0.17862194444444443,
                "2026-02-20": 1.2597525,
                "2026-02-24": 0.4711722222222222,
                "2026-03-03": 3.558228333333334,
                "2026-03-13": 1.009676111111111,
                "2026-03-16": 1.5462075,
                "2026-03-23": 1.7128333333333334,
                "2026-03-24": 1.2754733333333332,
                "2026-03-25": 532.979713611111,
                "2026-03-28": 0.06711611111111111,
                "2026-04-13": 0.8018969444444445,
                "2026-04-23": 558.3781802777778,
                "2026-04-24": 0.05080111111111111,
                "2026-04-29": 0.10283138888888889,
                "2026-04-30": 2.4379483333333334,
                "2026-05-06": 530.6383266666668,
                "2026-05-07": 27.45062611111111,
                "2026-05-18": 11.255858055555557,
                "2026-05-20": 1.1599827777777778,
                "2026-05-25": 2.4082558333333335,
                "2026-05-26": 0.31214972222222226,
                "2026-05-27": 0.12151138888888888,
                "2026-06-01": 2.408097222222222,
                "2026-06-02": 0.9382919444444445,
                "2026-06-05": 53.855404444444446,
                "2026-06-08": 0.35714944444444446
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-10": 1,
                "2025-10-23": 2,
                "2025-10-31": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2025-12-02": 2,
                "2025-12-05": 2,
                "2025-12-10": 2,
                "2025-12-15": 2,
                "2025-12-19": 1,
                "2025-12-23": 1,
                "2025-12-26": 2,
                "2026-01-09": 1,
                "2026-01-13": 3,
                "2026-01-15": 1,
                "2026-01-20": 3,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-27": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 3,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-16": 2,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-03-03": 3,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-23": 3,
                "2026-03-24": 2,
                "2026-03-25": 2,
                "2026-03-28": 1,
                "2026-04-13": 1,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-06": 3,
                "2026-05-07": 2,
                "2026-05-18": 5,
                "2026-05-20": 1,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 2,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 87.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1,
                "4-6h": 3,
                "20-22h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "320-322h": 1,
                "410-412h": 1,
                "482-484h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-03": 1,
                "2025-12-09": 1,
                "2025-12-11": 2,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-12": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-09": 0.2294986111111111,
                "2025-11-13": 23.8429125,
                "2025-11-24": 3.6273197222222224,
                "2025-11-27": 27.569133333333333,
                "2025-12-03": 21.43753138888889,
                "2025-12-09": 1.1274111111111111,
                "2025-12-11": 415.67632138888894,
                "2025-12-15": 483.7089375,
                "2025-12-17": 4.365002777777778,
                "2026-01-12": 0.4317683333333333,
                "2026-02-03": 321.70579833333335,
                "2026-02-10": 4.944014722222223,
                "2026-02-12": 1.1373063888888888
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-03": 1,
                "2025-12-09": 1,
                "2025-12-11": 2,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2026-01-12": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 203.62,
              "mode_time_hours": 459.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "24-26h": 1,
                "272-274h": 1,
                "456-458h": 1,
                "458-460h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-29": 2,
                "2026-02-06": 1,
                "2026-02-27": 1
              },
              "time_per_day": {
                "2025-11-11": 6.900693611111111,
                "2025-11-12": 25.900350833333334,
                "2025-11-29": 915.278146111111,
                "2026-02-06": 273.4243158333333,
                "2026-02-27": 0.19803777777777778
              },
              "time_count_per_day": {
                "2025-11-11": 1,
                "2025-11-12": 1,
                "2025-11-29": 2,
                "2026-02-06": 1,
                "2026-02-27": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 545.33,
              "mode_time_hours": 545.0,
              "mode_frequency": 1,
              "time_distribution": {
                "544-546h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 545.3312847222222
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_171": {
      "overall": {
        "avg_time_hours": 166.89,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "12-14h": 2,
          "16-18h": 2,
          "22-24h": 1,
          "46-48h": 1,
          "48-50h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "96-98h": 2,
          "132-134h": 1,
          "154-156h": 1,
          "164-166h": 1,
          "190-192h": 1,
          "200-202h": 1,
          "254-256h": 1,
          "290-292h": 1,
          "400-402h": 1,
          "818-820h": 1,
          "872-874h": 1
        },
        "tickets_count": 25,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-10": 1,
          "2025-11-27": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-04-16": 1,
          "2026-04-27": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-05-30": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-07": 0.15520555555555557,
          "2025-10-10": 73.19887305555557,
          "2025-11-27": 400.6979072222222,
          "2026-01-22": 74.40497777777777,
          "2026-01-26": 96.41299388888889,
          "2026-01-27": 164.65061277777778,
          "2026-01-29": 12.720934444444445,
          "2026-02-03": 16.00796888888889,
          "2026-02-10": 200.57323277777778,
          "2026-02-18": 290.5136272222222,
          "2026-02-23": 49.31063861111111,
          "2026-03-02": 254.1527825,
          "2026-03-09": 46.38033444444444,
          "2026-03-10": 23.49174888888889,
          "2026-03-11": 154.98043333333334,
          "2026-03-12": 17.93446388888889,
          "2026-03-17": 872.6234686111112,
          "2026-03-18": 133.48976583333334,
          "2026-04-16": 819.6210827777778,
          "2026-04-27": 0.25051055555555557,
          "2026-05-08": 13.934069444444445,
          "2026-05-14": 191.85134416666668,
          "2026-05-30": 0.22372861111111111,
          "2026-06-03": 97.8312238888889
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-10": 1,
          "2025-11-27": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-04-16": 1,
          "2026-04-27": 1,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-05-30": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 133.49,
          "mode_time_hours": 133.0,
          "mode_frequency": 1,
          "time_distribution": {
            "132-134h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 133.48976583333334
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        },
        "P2": {
          "avg_time_hours": 187.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "12-14h": 1,
            "16-18h": 1,
            "22-24h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "74-76h": 1,
            "96-98h": 1,
            "154-156h": 1,
            "164-166h": 1,
            "190-192h": 1,
            "254-256h": 1,
            "400-402h": 1,
            "818-820h": 1,
            "872-874h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-11-27": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-17": 1,
            "2026-04-16": 1,
            "2026-04-27": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-05-30": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-07": 0.15520555555555557,
            "2025-11-27": 400.6979072222222,
            "2026-01-22": 74.40497777777777,
            "2026-01-27": 164.65061277777778,
            "2026-02-23": 49.31063861111111,
            "2026-03-02": 254.1527825,
            "2026-03-09": 46.38033444444444,
            "2026-03-10": 23.49174888888889,
            "2026-03-11": 154.98043333333334,
            "2026-03-12": 17.93446388888889,
            "2026-03-17": 872.6234686111112,
            "2026-04-16": 819.6210827777778,
            "2026-04-27": 0.25051055555555557,
            "2026-05-08": 13.934069444444445,
            "2026-05-14": 191.85134416666668,
            "2026-05-30": 0.22372861111111111,
            "2026-06-03": 97.8312238888889
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-11-27": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-17": 1,
            "2026-04-16": 1,
            "2026-04-27": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-05-30": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 114.9,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "16-18h": 1,
            "72-74h": 1,
            "96-98h": 1,
            "200-202h": 1,
            "290-292h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-10-10": 73.19887305555557,
            "2026-01-26": 96.41299388888889,
            "2026-01-29": 12.720934444444445,
            "2026-02-03": 16.00796888888889,
            "2026-02-10": 200.57323277777778,
            "2026-02-18": 290.5136272222222
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 166.89,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "12-14h": 2,
              "16-18h": 2,
              "22-24h": 1,
              "46-48h": 1,
              "48-50h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "96-98h": 2,
              "132-134h": 1,
              "154-156h": 1,
              "164-166h": 1,
              "190-192h": 1,
              "200-202h": 1,
              "254-256h": 1,
              "290-292h": 1,
              "400-402h": 1,
              "818-820h": 1,
              "872-874h": 1
            },
            "tickets_count": 24,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-10": 1,
              "2025-11-27": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-04-16": 1,
              "2026-04-27": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-30": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-10-07": 0.15520555555555557,
              "2025-10-10": 73.19887305555557,
              "2025-11-27": 400.6979072222222,
              "2026-01-22": 74.40497777777777,
              "2026-01-26": 96.41299388888889,
              "2026-01-27": 164.65061277777778,
              "2026-01-29": 12.720934444444445,
              "2026-02-03": 16.00796888888889,
              "2026-02-10": 200.57323277777778,
              "2026-02-18": 290.5136272222222,
              "2026-02-23": 49.31063861111111,
              "2026-03-02": 254.1527825,
              "2026-03-09": 46.38033444444444,
              "2026-03-10": 23.49174888888889,
              "2026-03-11": 154.98043333333334,
              "2026-03-12": 17.93446388888889,
              "2026-03-17": 872.6234686111112,
              "2026-03-18": 133.48976583333334,
              "2026-04-16": 819.6210827777778,
              "2026-04-27": 0.25051055555555557,
              "2026-05-08": 13.934069444444445,
              "2026-05-14": 191.85134416666668,
              "2026-05-30": 0.22372861111111111,
              "2026-06-03": 97.8312238888889
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-10": 1,
              "2025-11-27": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-04-16": 1,
              "2026-04-27": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-30": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 133.49,
              "mode_time_hours": 133.0,
              "mode_frequency": 1,
              "time_distribution": {
                "132-134h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 133.48976583333334
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            },
            "P2": {
              "avg_time_hours": 187.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "12-14h": 1,
                "16-18h": 1,
                "22-24h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "74-76h": 1,
                "96-98h": 1,
                "154-156h": 1,
                "164-166h": 1,
                "190-192h": 1,
                "254-256h": 1,
                "400-402h": 1,
                "818-820h": 1,
                "872-874h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-11-27": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-17": 1,
                "2026-04-16": 1,
                "2026-04-27": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-30": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-10-07": 0.15520555555555557,
                "2025-11-27": 400.6979072222222,
                "2026-01-22": 74.40497777777777,
                "2026-01-27": 164.65061277777778,
                "2026-02-23": 49.31063861111111,
                "2026-03-02": 254.1527825,
                "2026-03-09": 46.38033444444444,
                "2026-03-10": 23.49174888888889,
                "2026-03-11": 154.98043333333334,
                "2026-03-12": 17.93446388888889,
                "2026-03-17": 872.6234686111112,
                "2026-04-16": 819.6210827777778,
                "2026-04-27": 0.25051055555555557,
                "2026-05-08": 13.934069444444445,
                "2026-05-14": 191.85134416666668,
                "2026-05-30": 0.22372861111111111,
                "2026-06-03": 97.8312238888889
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-11-27": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-17": 1,
                "2026-04-16": 1,
                "2026-04-27": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-30": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 114.9,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "16-18h": 1,
                "72-74h": 1,
                "96-98h": 1,
                "200-202h": 1,
                "290-292h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-10-10": 73.19887305555557,
                "2026-01-26": 96.41299388888889,
                "2026-01-29": 12.720934444444445,
                "2026-02-03": 16.00796888888889,
                "2026-02-10": 200.57323277777778,
                "2026-02-18": 290.5136272222222
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_172": {
      "overall": {
        "avg_time_hours": 50.37,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "6-8h": 1,
          "18-20h": 1,
          "22-24h": 1,
          "24-26h": 3,
          "46-48h": 1,
          "52-54h": 1,
          "88-90h": 1,
          "116-118h": 1,
          "118-120h": 1,
          "304-306h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-27": 1,
          "2025-11-14": 1,
          "2026-01-08": 1,
          "2026-02-10": 1,
          "2026-02-26": 1,
          "2026-03-05": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-20": 1,
          "2026-04-24": 1,
          "2026-05-04": 1,
          "2026-05-08": 1,
          "2026-05-22": 1,
          "2026-05-29": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-07": 0.1315975,
          "2025-10-27": 0.34208972222222217,
          "2025-11-14": 19.777790833333334,
          "2026-01-08": 23.79849861111111,
          "2026-02-10": 1.6269974999999999,
          "2026-02-26": 7.6359055555555555,
          "2026-03-05": 24.769713055555556,
          "2026-04-06": 118.85246777777779,
          "2026-04-07": 304.3020080555556,
          "2026-04-20": 88.15126555555555,
          "2026-04-24": 24.086256388888888,
          "2026-05-04": 117.46305138888889,
          "2026-05-08": 24.375069722222225,
          "2026-05-22": 52.86899722222223,
          "2026-05-29": 1.7700322222222222,
          "2026-06-05": 46.33106472222222
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-27": 1,
          "2025-11-14": 1,
          "2026-01-08": 1,
          "2026-02-10": 1,
          "2026-02-26": 1,
          "2026-03-05": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-20": 1,
          "2026-04-24": 1,
          "2026-05-04": 1,
          "2026-05-08": 1,
          "2026-05-22": 1,
          "2026-05-29": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 34.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "6-8h": 1,
            "24-26h": 1,
            "88-90h": 1,
            "116-118h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-26": 1,
            "2026-03-05": 1,
            "2026-04-06": 1,
            "2026-04-20": 1,
            "2026-05-04": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-02-10": 1.6269974999999999,
            "2026-02-26": 7.6359055555555555,
            "2026-03-05": 24.769713055555556,
            "2026-04-06": 0.1431625,
            "2026-04-20": 88.15126555555555,
            "2026-05-04": 117.46305138888889,
            "2026-05-29": 1.7700322222222222
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-02-26": 1,
            "2026-03-05": 1,
            "2026-04-06": 1,
            "2026-04-20": 1,
            "2026-05-04": 1,
            "2026-05-29": 1
          }
        },
        "P2": {
          "avg_time_hours": 61.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "18-20h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "46-48h": 1,
            "52-54h": 1,
            "118-120h": 1,
            "304-306h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-27": 1,
            "2025-11-14": 1,
            "2026-01-08": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-24": 1,
            "2026-05-08": 1,
            "2026-05-22": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-07": 0.1315975,
            "2025-10-27": 0.34208972222222217,
            "2025-11-14": 19.777790833333334,
            "2026-01-08": 23.79849861111111,
            "2026-04-06": 118.70930527777779,
            "2026-04-07": 304.3020080555556,
            "2026-04-24": 24.086256388888888,
            "2026-05-08": 24.375069722222225,
            "2026-05-22": 52.86899722222223,
            "2026-06-05": 46.33106472222222
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-27": 1,
            "2025-11-14": 1,
            "2026-01-08": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-24": 1,
            "2026-05-08": 1,
            "2026-05-22": 1,
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 50.37,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "6-8h": 1,
              "18-20h": 1,
              "22-24h": 1,
              "24-26h": 3,
              "46-48h": 1,
              "52-54h": 1,
              "88-90h": 1,
              "116-118h": 1,
              "118-120h": 1,
              "304-306h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-27": 1,
              "2025-11-14": 1,
              "2026-01-08": 1,
              "2026-02-10": 1,
              "2026-02-26": 1,
              "2026-03-05": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-20": 1,
              "2026-04-24": 1,
              "2026-05-04": 1,
              "2026-05-08": 1,
              "2026-05-22": 1,
              "2026-05-29": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-07": 0.1315975,
              "2025-10-27": 0.34208972222222217,
              "2025-11-14": 19.777790833333334,
              "2026-01-08": 23.79849861111111,
              "2026-02-10": 1.6269974999999999,
              "2026-02-26": 7.6359055555555555,
              "2026-03-05": 24.769713055555556,
              "2026-04-06": 118.85246777777779,
              "2026-04-07": 304.3020080555556,
              "2026-04-20": 88.15126555555555,
              "2026-04-24": 24.086256388888888,
              "2026-05-04": 117.46305138888889,
              "2026-05-08": 24.375069722222225,
              "2026-05-22": 52.86899722222223,
              "2026-05-29": 1.7700322222222222,
              "2026-06-05": 46.33106472222222
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-27": 1,
              "2025-11-14": 1,
              "2026-01-08": 1,
              "2026-02-10": 1,
              "2026-02-26": 1,
              "2026-03-05": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-20": 1,
              "2026-04-24": 1,
              "2026-05-04": 1,
              "2026-05-08": 1,
              "2026-05-22": 1,
              "2026-05-29": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 34.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "6-8h": 1,
                "24-26h": 1,
                "88-90h": 1,
                "116-118h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-02-26": 1,
                "2026-03-05": 1,
                "2026-04-06": 1,
                "2026-04-20": 1,
                "2026-05-04": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-02-10": 1.6269974999999999,
                "2026-02-26": 7.6359055555555555,
                "2026-03-05": 24.769713055555556,
                "2026-04-06": 0.1431625,
                "2026-04-20": 88.15126555555555,
                "2026-05-04": 117.46305138888889,
                "2026-05-29": 1.7700322222222222
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-02-26": 1,
                "2026-03-05": 1,
                "2026-04-06": 1,
                "2026-04-20": 1,
                "2026-05-04": 1,
                "2026-05-29": 1
              }
            },
            "P2": {
              "avg_time_hours": 61.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "18-20h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "46-48h": 1,
                "52-54h": 1,
                "118-120h": 1,
                "304-306h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-27": 1,
                "2025-11-14": 1,
                "2026-01-08": 1,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-24": 1,
                "2026-05-08": 1,
                "2026-05-22": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-07": 0.1315975,
                "2025-10-27": 0.34208972222222217,
                "2025-11-14": 19.777790833333334,
                "2026-01-08": 23.79849861111111,
                "2026-04-06": 118.70930527777779,
                "2026-04-07": 304.3020080555556,
                "2026-04-24": 24.086256388888888,
                "2026-05-08": 24.375069722222225,
                "2026-05-22": 52.86899722222223,
                "2026-06-05": 46.33106472222222
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-27": 1,
                "2025-11-14": 1,
                "2026-01-08": 1,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-24": 1,
                "2026-05-08": 1,
                "2026-05-22": 1,
                "2026-06-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_162": {
      "overall": {
        "avg_time_hours": 5.5,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "8-10h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2026-04-27": 1
        },
        "time_per_day": {
          "2025-10-07": 2.204782222222222,
          "2026-04-27": 8.787476388888889
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2026-04-27": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 8.79,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {
            "2026-04-27": 8.787476388888889
          },
          "time_count_per_day": {
            "2026-04-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 2.2,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-07": 1
          },
          "time_per_day": {
            "2025-10-07": 2.204782222222222
          },
          "time_count_per_day": {
            "2025-10-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.5,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "8-10h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2026-04-27": 1
            },
            "time_per_day": {
              "2025-10-07": 2.204782222222222,
              "2026-04-27": 8.787476388888889
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2026-04-27": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 8.79,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {
                "2026-04-27": 8.787476388888889
              },
              "time_count_per_day": {
                "2026-04-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 2.2,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-07": 1
              },
              "time_per_day": {
                "2025-10-07": 2.204782222222222
              },
              "time_count_per_day": {
                "2025-10-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_174": {
      "overall": {
        "avg_time_hours": 90.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 29,
        "time_distribution": {
          "0-2h": 29,
          "2-4h": 8,
          "4-6h": 5,
          "6-8h": 4,
          "16-18h": 1,
          "20-22h": 1,
          "22-24h": 3,
          "24-26h": 2,
          "26-28h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "40-42h": 2,
          "46-48h": 2,
          "48-50h": 2,
          "52-54h": 1,
          "56-58h": 1,
          "58-60h": 1,
          "66-68h": 1,
          "72-74h": 3,
          "92-94h": 1,
          "94-96h": 1,
          "102-104h": 1,
          "286-288h": 1,
          "336-338h": 1,
          "342-344h": 1,
          "352-354h": 1,
          "356-358h": 1,
          "364-366h": 1,
          "376-378h": 2,
          "456-458h": 1,
          "584-586h": 1,
          "734-736h": 1,
          "834-836h": 1,
          "892-894h": 1
        },
        "tickets_count": 88,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-11-24": 1,
          "2025-11-27": 2,
          "2025-12-03": 1,
          "2025-12-04": 2,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 2,
          "2026-01-26": 1,
          "2026-02-12": 1,
          "2026-02-18": 2,
          "2026-02-20": 2,
          "2026-02-27": 3,
          "2026-03-02": 2,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-05": 2,
          "2026-03-06": 1,
          "2026-03-12": 1,
          "2026-03-13": 4,
          "2026-03-16": 1,
          "2026-03-17": 5,
          "2026-03-18": 7,
          "2026-03-19": 1,
          "2026-03-20": 2,
          "2026-03-23": 2,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-17": 2,
          "2026-04-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-04-24": 1,
          "2026-04-27": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-10": 1,
          "2026-05-11": 2,
          "2026-05-18": 1,
          "2026-05-20": 1,
          "2026-05-22": 2,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-06-05": 3
        },
        "time_per_day": {
          "2025-10-07": 0.9447805555555555,
          "2025-11-24": 0.13937388888888888,
          "2025-11-27": 29.627437222222223,
          "2025-12-03": 1.450718888888889,
          "2025-12-04": 1.6354783333333334,
          "2025-12-15": 456.6942608333333,
          "2025-12-19": 585.5069680555555,
          "2026-01-13": 26.357166666666668,
          "2026-01-15": 23.82149027777778,
          "2026-01-16": 5.779034444444445,
          "2026-01-20": 131.28140333333334,
          "2026-01-21": 25.862680555555553,
          "2026-01-22": 47.333464166666666,
          "2026-01-23": 73.10433,
          "2026-01-26": 0.3570375,
          "2026-02-12": 342.5990061111111,
          "2026-02-18": 52.69510694444445,
          "2026-02-20": 25.656109722222222,
          "2026-02-27": 115.84193805555554,
          "2026-03-02": 68.25776444444445,
          "2026-03-03": 22.873828055555556,
          "2026-03-04": 17.959489722222223,
          "2026-03-05": 50.2738175,
          "2026-03-06": 835.2149938888889,
          "2026-03-12": 21.520122500000003,
          "2026-03-13": 49.96619222222222,
          "2026-03-16": 4.698488611111111,
          "2026-03-17": 42.68598888888888,
          "2026-03-18": 1754.0548036111115,
          "2026-03-19": 0.1256825,
          "2026-03-20": 8.719096666666667,
          "2026-03-23": 0.15948777777777778,
          "2026-03-24": 1.2431844444444444,
          "2026-03-26": 364.16787,
          "2026-04-06": 3.991895277777778,
          "2026-04-08": 0.2549430555555555,
          "2026-04-09": 0.6606855555555555,
          "2026-04-13": 7.635251111111111,
          "2026-04-16": 4.032726666666667,
          "2026-04-17": 1.0945011111111111,
          "2026-04-20": 1.000043888888889,
          "2026-04-22": 892.0847891666666,
          "2026-04-23": 1070.842186111111,
          "2026-04-30": 48.54285083333333,
          "2026-05-04": 0.04620666666666667,
          "2026-05-10": 72.01353027777778,
          "2026-05-11": 5.513431944444444,
          "2026-05-18": 73.29240194444445,
          "2026-05-20": 2.5053875000000003,
          "2026-05-22": 42.55184027777778,
          "2026-05-25": 93.78307333333333,
          "2026-05-26": 94.24218388888889,
          "2026-06-05": 52.21389944444445
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-11-24": 1,
          "2025-11-27": 2,
          "2025-12-03": 1,
          "2025-12-04": 2,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 2,
          "2026-01-26": 1,
          "2026-02-12": 1,
          "2026-02-18": 2,
          "2026-02-20": 1,
          "2026-02-27": 3,
          "2026-03-02": 2,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-05": 2,
          "2026-03-06": 1,
          "2026-03-12": 1,
          "2026-03-13": 4,
          "2026-03-16": 1,
          "2026-03-17": 5,
          "2026-03-18": 7,
          "2026-03-19": 1,
          "2026-03-20": 2,
          "2026-03-23": 2,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-17": 2,
          "2026-04-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-10": 1,
          "2026-05-11": 2,
          "2026-05-18": 1,
          "2026-05-20": 1,
          "2026-05-22": 2,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-06-05": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 53.65,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 1,
            "20-22h": 1,
            "40-42h": 1,
            "52-54h": 1,
            "72-74h": 1,
            "94-96h": 1,
            "102-104h": 1,
            "342-344h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2026-01-20": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-05": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-16": 1,
            "2026-03-18": 2,
            "2026-04-06": 1,
            "2026-05-18": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-12-03": 1.450718888888889,
            "2026-01-20": 102.19875861111112,
            "2026-02-12": 342.5990061111111,
            "2026-02-18": 52.68132027777778,
            "2026-03-05": 3.313541111111111,
            "2026-03-12": 21.520122500000003,
            "2026-03-13": 47.49873083333333,
            "2026-03-16": 4.698488611111111,
            "2026-03-18": 3.6208016666666665,
            "2026-04-06": 3.991895277777778,
            "2026-05-18": 73.29240194444445,
            "2026-05-26": 94.24218388888889
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2026-01-20": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-05": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-16": 1,
            "2026-03-18": 2,
            "2026-04-06": 1,
            "2026-05-18": 1,
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 65.41,
          "mode_time_hours": 1.0,
          "mode_frequency": 26,
          "time_distribution": {
            "0-2h": 26,
            "2-4h": 5,
            "4-6h": 3,
            "6-8h": 3,
            "16-18h": 1,
            "22-24h": 2,
            "24-26h": 2,
            "28-30h": 1,
            "40-42h": 1,
            "46-48h": 2,
            "48-50h": 2,
            "56-58h": 1,
            "58-60h": 1,
            "66-68h": 1,
            "72-74h": 1,
            "92-94h": 1,
            "336-338h": 1,
            "456-458h": 1,
            "584-586h": 1,
            "734-736h": 1,
            "892-894h": 1
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-04": 2,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-02-27": 3,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-13": 2,
            "2026-03-17": 4,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-13": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-24": 1,
            "2026-04-27": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-10": 1,
            "2026-05-11": 2,
            "2026-05-20": 1,
            "2026-05-22": 2,
            "2026-05-25": 2,
            "2026-06-05": 3
          },
          "time_per_day": {
            "2025-10-07": 0.9447805555555555,
            "2025-11-24": 0.13937388888888888,
            "2025-11-27": 7.46854,
            "2025-12-04": 1.6354783333333334,
            "2025-12-15": 456.6942608333333,
            "2025-12-19": 585.5069680555555,
            "2026-01-15": 23.82149027777778,
            "2026-01-16": 5.779034444444445,
            "2026-01-20": 29.082644722222224,
            "2026-01-21": 25.862680555555553,
            "2026-01-22": 47.333464166666666,
            "2026-01-23": 0.1770511111111111,
            "2026-01-26": 0.3570375,
            "2026-02-18": 0.013786666666666666,
            "2026-02-20": 25.656109722222222,
            "2026-02-27": 115.84193805555554,
            "2026-03-02": 68.25776444444445,
            "2026-03-03": 22.873828055555556,
            "2026-03-04": 17.959489722222223,
            "2026-03-05": 46.960276388888886,
            "2026-03-13": 2.467461388888889,
            "2026-03-17": 9.231499722222221,
            "2026-03-19": 0.1256825,
            "2026-03-20": 8.719096666666667,
            "2026-03-23": 0.15948777777777778,
            "2026-03-24": 1.2431844444444444,
            "2026-04-08": 0.2549430555555555,
            "2026-04-09": 0.6606855555555555,
            "2026-04-13": 7.635251111111111,
            "2026-04-17": 0.07764305555555555,
            "2026-04-20": 1.000043888888889,
            "2026-04-22": 892.0847891666666,
            "2026-04-23": 1070.842186111111,
            "2026-04-30": 48.54285083333333,
            "2026-05-04": 0.04620666666666667,
            "2026-05-10": 72.01353027777778,
            "2026-05-11": 5.513431944444444,
            "2026-05-20": 2.5053875000000003,
            "2026-05-22": 42.55184027777778,
            "2026-05-25": 93.78307333333333,
            "2026-06-05": 52.21389944444445
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-04": 2,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-02-27": 3,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-13": 2,
            "2026-03-17": 4,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-13": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-10": 1,
            "2026-05-11": 2,
            "2026-05-20": 1,
            "2026-05-22": 2,
            "2026-05-25": 2,
            "2026-06-05": 3
          }
        },
        "P3": {
          "avg_time_hours": 177.76,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "834-836h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-01-13": 1,
            "2026-03-06": 1,
            "2026-04-16": 1,
            "2026-04-17": 1
          },
          "time_per_day": {
            "2025-11-27": 22.158897222222222,
            "2026-01-13": 26.357166666666668,
            "2026-03-06": 835.2149938888889,
            "2026-04-16": 4.032726666666667,
            "2026-04-17": 1.0168580555555555
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-01-13": 1,
            "2026-03-06": 1,
            "2026-04-16": 1,
            "2026-04-17": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 277.62,
          "mode_time_hours": 377.0,
          "mode_frequency": 2,
          "time_distribution": {
            "32-34h": 1,
            "72-74h": 1,
            "286-288h": 1,
            "352-354h": 1,
            "356-358h": 1,
            "364-366h": 1,
            "376-378h": 2
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-01-23": 1,
            "2026-03-17": 1,
            "2026-03-18": 5,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-01-23": 72.92727888888889,
            "2026-03-17": 33.45448916666666,
            "2026-03-18": 1750.4340019444448,
            "2026-03-26": 364.16787
          },
          "time_count_per_day": {
            "2026-01-23": 1,
            "2026-03-17": 1,
            "2026-03-18": 5,
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 90.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 29,
            "time_distribution": {
              "0-2h": 29,
              "2-4h": 8,
              "4-6h": 5,
              "6-8h": 4,
              "16-18h": 1,
              "20-22h": 1,
              "22-24h": 3,
              "24-26h": 2,
              "26-28h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "40-42h": 2,
              "46-48h": 2,
              "48-50h": 2,
              "52-54h": 1,
              "56-58h": 1,
              "58-60h": 1,
              "66-68h": 1,
              "72-74h": 3,
              "92-94h": 1,
              "94-96h": 1,
              "102-104h": 1,
              "286-288h": 1,
              "336-338h": 1,
              "342-344h": 1,
              "352-354h": 1,
              "356-358h": 1,
              "364-366h": 1,
              "376-378h": 2,
              "456-458h": 1,
              "584-586h": 1,
              "734-736h": 1,
              "834-836h": 1,
              "892-894h": 1
            },
            "tickets_count": 85,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-11-24": 1,
              "2025-11-27": 2,
              "2025-12-03": 1,
              "2025-12-04": 2,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 2,
              "2026-01-26": 1,
              "2026-02-12": 1,
              "2026-02-18": 2,
              "2026-02-20": 1,
              "2026-02-27": 3,
              "2026-03-02": 2,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 2,
              "2026-03-06": 1,
              "2026-03-12": 1,
              "2026-03-13": 4,
              "2026-03-16": 1,
              "2026-03-17": 5,
              "2026-03-18": 7,
              "2026-03-19": 1,
              "2026-03-20": 2,
              "2026-03-23": 2,
              "2026-03-24": 1,
              "2026-03-26": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-17": 2,
              "2026-04-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-10": 1,
              "2026-05-11": 2,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-22": 2,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-06-05": 3
            },
            "time_per_day": {
              "2025-10-07": 0.9447805555555555,
              "2025-11-24": 0.13937388888888888,
              "2025-11-27": 29.627437222222223,
              "2025-12-03": 1.450718888888889,
              "2025-12-04": 1.6354783333333334,
              "2025-12-15": 456.6942608333333,
              "2025-12-19": 585.5069680555555,
              "2026-01-13": 26.357166666666668,
              "2026-01-15": 23.82149027777778,
              "2026-01-16": 5.779034444444445,
              "2026-01-20": 131.28140333333334,
              "2026-01-21": 25.862680555555553,
              "2026-01-22": 47.333464166666666,
              "2026-01-23": 73.10433,
              "2026-01-26": 0.3570375,
              "2026-02-12": 342.5990061111111,
              "2026-02-18": 52.69510694444445,
              "2026-02-20": 25.656109722222222,
              "2026-02-27": 115.84193805555554,
              "2026-03-02": 68.25776444444445,
              "2026-03-03": 22.873828055555556,
              "2026-03-04": 17.959489722222223,
              "2026-03-05": 50.2738175,
              "2026-03-06": 835.2149938888889,
              "2026-03-12": 21.520122500000003,
              "2026-03-13": 49.96619222222222,
              "2026-03-16": 4.698488611111111,
              "2026-03-17": 42.68598888888888,
              "2026-03-18": 1754.0548036111115,
              "2026-03-19": 0.1256825,
              "2026-03-20": 8.719096666666667,
              "2026-03-23": 0.15948777777777778,
              "2026-03-24": 1.2431844444444444,
              "2026-03-26": 364.16787,
              "2026-04-06": 3.991895277777778,
              "2026-04-08": 0.2549430555555555,
              "2026-04-09": 0.6606855555555555,
              "2026-04-13": 7.635251111111111,
              "2026-04-16": 4.032726666666667,
              "2026-04-17": 1.0945011111111111,
              "2026-04-20": 1.000043888888889,
              "2026-04-22": 892.0847891666666,
              "2026-04-23": 1070.842186111111,
              "2026-04-30": 48.54285083333333,
              "2026-05-04": 0.04620666666666667,
              "2026-05-10": 72.01353027777778,
              "2026-05-11": 5.513431944444444,
              "2026-05-18": 73.29240194444445,
              "2026-05-20": 2.5053875000000003,
              "2026-05-22": 42.55184027777778,
              "2026-05-25": 93.78307333333333,
              "2026-05-26": 94.24218388888889,
              "2026-06-05": 52.21389944444445
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-11-24": 1,
              "2025-11-27": 2,
              "2025-12-03": 1,
              "2025-12-04": 2,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 2,
              "2026-01-26": 1,
              "2026-02-12": 1,
              "2026-02-18": 2,
              "2026-02-20": 1,
              "2026-02-27": 3,
              "2026-03-02": 2,
              "2026-03-03": 1,
              "2026-03-04": 1,
              "2026-03-05": 2,
              "2026-03-06": 1,
              "2026-03-12": 1,
              "2026-03-13": 4,
              "2026-03-16": 1,
              "2026-03-17": 5,
              "2026-03-18": 7,
              "2026-03-19": 1,
              "2026-03-20": 2,
              "2026-03-23": 2,
              "2026-03-24": 1,
              "2026-03-26": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-13": 1,
              "2026-04-16": 1,
              "2026-04-17": 2,
              "2026-04-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-10": 1,
              "2026-05-11": 2,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-22": 2,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-06-05": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 53.65,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 1,
                "20-22h": 1,
                "40-42h": 1,
                "52-54h": 1,
                "72-74h": 1,
                "94-96h": 1,
                "102-104h": 1,
                "342-344h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2026-01-20": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-05": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-16": 1,
                "2026-03-18": 2,
                "2026-04-06": 1,
                "2026-05-18": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-12-03": 1.450718888888889,
                "2026-01-20": 102.19875861111112,
                "2026-02-12": 342.5990061111111,
                "2026-02-18": 52.68132027777778,
                "2026-03-05": 3.313541111111111,
                "2026-03-12": 21.520122500000003,
                "2026-03-13": 47.49873083333333,
                "2026-03-16": 4.698488611111111,
                "2026-03-18": 3.6208016666666665,
                "2026-04-06": 3.991895277777778,
                "2026-05-18": 73.29240194444445,
                "2026-05-26": 94.24218388888889
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2026-01-20": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-05": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-16": 1,
                "2026-03-18": 2,
                "2026-04-06": 1,
                "2026-05-18": 1,
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 65.41,
              "mode_time_hours": 1.0,
              "mode_frequency": 26,
              "time_distribution": {
                "0-2h": 26,
                "2-4h": 5,
                "4-6h": 3,
                "6-8h": 3,
                "16-18h": 1,
                "22-24h": 2,
                "24-26h": 2,
                "28-30h": 1,
                "40-42h": 1,
                "46-48h": 2,
                "48-50h": 2,
                "56-58h": 1,
                "58-60h": 1,
                "66-68h": 1,
                "72-74h": 1,
                "92-94h": 1,
                "336-338h": 1,
                "456-458h": 1,
                "584-586h": 1,
                "734-736h": 1,
                "892-894h": 1
              },
              "tickets_count": 58,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-04": 2,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-02-27": 3,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-13": 2,
                "2026-03-17": 4,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-23": 2,
                "2026-03-24": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-13": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-10": 1,
                "2026-05-11": 2,
                "2026-05-20": 1,
                "2026-05-22": 2,
                "2026-05-25": 2,
                "2026-06-05": 3
              },
              "time_per_day": {
                "2025-10-07": 0.9447805555555555,
                "2025-11-24": 0.13937388888888888,
                "2025-11-27": 7.46854,
                "2025-12-04": 1.6354783333333334,
                "2025-12-15": 456.6942608333333,
                "2025-12-19": 585.5069680555555,
                "2026-01-15": 23.82149027777778,
                "2026-01-16": 5.779034444444445,
                "2026-01-20": 29.082644722222224,
                "2026-01-21": 25.862680555555553,
                "2026-01-22": 47.333464166666666,
                "2026-01-23": 0.1770511111111111,
                "2026-01-26": 0.3570375,
                "2026-02-18": 0.013786666666666666,
                "2026-02-20": 25.656109722222222,
                "2026-02-27": 115.84193805555554,
                "2026-03-02": 68.25776444444445,
                "2026-03-03": 22.873828055555556,
                "2026-03-04": 17.959489722222223,
                "2026-03-05": 46.960276388888886,
                "2026-03-13": 2.467461388888889,
                "2026-03-17": 9.231499722222221,
                "2026-03-19": 0.1256825,
                "2026-03-20": 8.719096666666667,
                "2026-03-23": 0.15948777777777778,
                "2026-03-24": 1.2431844444444444,
                "2026-04-08": 0.2549430555555555,
                "2026-04-09": 0.6606855555555555,
                "2026-04-13": 7.635251111111111,
                "2026-04-17": 0.07764305555555555,
                "2026-04-20": 1.000043888888889,
                "2026-04-22": 892.0847891666666,
                "2026-04-23": 1070.842186111111,
                "2026-04-30": 48.54285083333333,
                "2026-05-04": 0.04620666666666667,
                "2026-05-10": 72.01353027777778,
                "2026-05-11": 5.513431944444444,
                "2026-05-20": 2.5053875000000003,
                "2026-05-22": 42.55184027777778,
                "2026-05-25": 93.78307333333333,
                "2026-06-05": 52.21389944444445
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-04": 2,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-02-27": 3,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-13": 2,
                "2026-03-17": 4,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-23": 2,
                "2026-03-24": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-13": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-10": 1,
                "2026-05-11": 2,
                "2026-05-20": 1,
                "2026-05-22": 2,
                "2026-05-25": 2,
                "2026-06-05": 3
              }
            },
            "P3": {
              "avg_time_hours": 177.76,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "834-836h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-01-13": 1,
                "2026-03-06": 1,
                "2026-04-16": 1,
                "2026-04-17": 1
              },
              "time_per_day": {
                "2025-11-27": 22.158897222222222,
                "2026-01-13": 26.357166666666668,
                "2026-03-06": 835.2149938888889,
                "2026-04-16": 4.032726666666667,
                "2026-04-17": 1.0168580555555555
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-01-13": 1,
                "2026-03-06": 1,
                "2026-04-16": 1,
                "2026-04-17": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 277.62,
              "mode_time_hours": 377.0,
              "mode_frequency": 2,
              "time_distribution": {
                "32-34h": 1,
                "72-74h": 1,
                "286-288h": 1,
                "352-354h": 1,
                "356-358h": 1,
                "364-366h": 1,
                "376-378h": 2
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-01-23": 1,
                "2026-03-17": 1,
                "2026-03-18": 5,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-01-23": 72.92727888888889,
                "2026-03-17": 33.45448916666666,
                "2026-03-18": 1750.4340019444448,
                "2026-03-26": 364.16787
              },
              "time_count_per_day": {
                "2026-01-23": 1,
                "2026-03-17": 1,
                "2026-03-18": 5,
                "2026-03-26": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-24": 1,
              "2026-04-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-24": 1,
                "2026-04-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_87": {
      "overall": {
        "avg_time_hours": 183.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 2,
          "4-6h": 1,
          "8-10h": 1,
          "12-14h": 2,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "32-34h": 1,
          "42-44h": 1,
          "44-46h": 2,
          "54-56h": 1,
          "70-72h": 1,
          "86-88h": 1,
          "102-104h": 1,
          "112-114h": 1,
          "144-146h": 1,
          "222-224h": 1,
          "226-228h": 1,
          "238-240h": 1,
          "246-248h": 1,
          "318-320h": 1,
          "344-346h": 1,
          "408-410h": 1,
          "454-456h": 1,
          "500-502h": 1,
          "746-748h": 1,
          "840-842h": 1,
          "1176-1178h": 1
        },
        "tickets_count": 38,
        "tickets_per_day": {
          "2025-10-16": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-10-29": 1,
          "2025-11-03": 1,
          "2025-11-12": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-12-15": 1,
          "2025-12-30": 1,
          "2026-01-07": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-29": 4,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-16": 1,
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-19": 1,
          "2026-03-23": 2,
          "2026-03-31": 1,
          "2026-04-09": 1,
          "2026-04-27": 2,
          "2026-04-30": 1,
          "2026-05-08": 2,
          "2026-05-28": 1
        },
        "time_per_day": {
          "2025-10-16": 226.80372,
          "2025-10-20": 0.5890605555555556,
          "2025-10-22": 222.8283386111111,
          "2025-11-03": 344.0028252777778,
          "2025-11-12": 841.4647622222221,
          "2025-11-14": 746.1764947222223,
          "2025-11-17": 112.70143,
          "2025-11-24": 1.7658924999999999,
          "2025-12-15": 319.4756552777778,
          "2025-12-30": 103.12485527777777,
          "2026-01-07": 54.095234999999995,
          "2026-01-19": 0.09435472222222223,
          "2026-01-20": 23.003074444444444,
          "2026-01-22": 86.98315333333333,
          "2026-01-23": 19.615389722222226,
          "2026-01-29": 33.69459888888889,
          "2026-02-03": 500.2017130555555,
          "2026-02-09": 10.852923333333335,
          "2026-02-16": 1176.5055580555554,
          "2026-03-10": 32.42216444444445,
          "2026-03-16": 70.58402972222223,
          "2026-03-19": 247.89461111111112,
          "2026-03-23": 18.111476666666665,
          "2026-03-31": 20.668334444444444,
          "2026-04-09": 87.357465,
          "2026-04-27": 599.9927386111111,
          "2026-04-30": 45.41898333333333,
          "2026-05-08": 647.7645561111111,
          "2026-05-28": 0.24102166666666666
        },
        "time_count_per_day": {
          "2025-10-16": 1,
          "2025-10-20": 1,
          "2025-10-22": 1,
          "2025-11-03": 1,
          "2025-11-12": 1,
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-12-15": 1,
          "2025-12-30": 1,
          "2026-01-07": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-29": 4,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-16": 1,
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-19": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-09": 1,
          "2026-04-27": 2,
          "2026-04-30": 1,
          "2026-05-08": 2,
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-29": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 184.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "32-34h": 1,
            "44-46h": 2,
            "54-56h": 1,
            "70-72h": 1,
            "86-88h": 1,
            "112-114h": 1,
            "144-146h": 1,
            "222-224h": 1,
            "226-228h": 1,
            "238-240h": 1,
            "318-320h": 1,
            "344-346h": 1,
            "408-410h": 1,
            "454-456h": 1,
            "746-748h": 1,
            "1176-1178h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2025-10-16": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-11-03": 1,
            "2025-11-14": 1,
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-15": 1,
            "2026-01-07": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-01-29": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-23": 2,
            "2026-03-31": 1,
            "2026-04-09": 1,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-08": 2,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2025-10-16": 226.80372,
            "2025-10-20": 0.5890605555555556,
            "2025-10-22": 222.8283386111111,
            "2025-11-03": 344.0028252777778,
            "2025-11-14": 746.1764947222223,
            "2025-11-17": 112.70143,
            "2025-11-24": 1.7658924999999999,
            "2025-12-15": 319.4756552777778,
            "2026-01-07": 54.095234999999995,
            "2026-01-19": 0.09435472222222223,
            "2026-01-20": 23.003074444444444,
            "2026-01-22": 44.396770555555555,
            "2026-01-29": 2.7364247222222224,
            "2026-02-09": 8.294188611111112,
            "2026-02-16": 1176.5055580555554,
            "2026-03-10": 32.42216444444445,
            "2026-03-16": 70.58402972222223,
            "2026-03-23": 18.111476666666665,
            "2026-03-31": 20.668334444444444,
            "2026-04-09": 87.357465,
            "2026-04-27": 599.9927386111111,
            "2026-04-30": 45.41898333333333,
            "2026-05-08": 647.7645561111111,
            "2026-05-28": 0.24102166666666666
          },
          "time_count_per_day": {
            "2025-10-16": 1,
            "2025-10-20": 1,
            "2025-10-22": 1,
            "2025-11-03": 1,
            "2025-11-14": 1,
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-15": 1,
            "2026-01-07": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-01-29": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-09": 1,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-08": 2,
            "2026-05-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 178.84,
          "mode_time_hours": 13.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "12-14h": 2,
            "18-20h": 1,
            "42-44h": 1,
            "102-104h": 1,
            "246-248h": 1,
            "500-502h": 1,
            "840-842h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-12-30": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 3,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2025-11-12": 841.4647622222221,
            "2025-12-30": 103.12485527777777,
            "2026-01-22": 42.58638277777778,
            "2026-01-23": 19.615389722222226,
            "2026-01-29": 30.958174166666666,
            "2026-02-03": 500.2017130555555,
            "2026-02-09": 2.5587347222222223,
            "2026-03-19": 247.89461111111112
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-12-30": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 3,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-03-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 183.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 2,
              "4-6h": 1,
              "8-10h": 1,
              "12-14h": 2,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "32-34h": 1,
              "42-44h": 1,
              "44-46h": 2,
              "54-56h": 1,
              "70-72h": 1,
              "86-88h": 1,
              "102-104h": 1,
              "112-114h": 1,
              "144-146h": 1,
              "222-224h": 1,
              "226-228h": 1,
              "238-240h": 1,
              "246-248h": 1,
              "318-320h": 1,
              "344-346h": 1,
              "408-410h": 1,
              "454-456h": 1,
              "500-502h": 1,
              "746-748h": 1,
              "840-842h": 1,
              "1176-1178h": 1
            },
            "tickets_count": 36,
            "tickets_per_day": {
              "2025-10-16": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-11-03": 1,
              "2025-11-12": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-12-15": 1,
              "2025-12-30": 1,
              "2026-01-07": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-29": 4,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-16": 1,
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-19": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-09": 1,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-08": 2,
              "2026-05-28": 1
            },
            "time_per_day": {
              "2025-10-16": 226.80372,
              "2025-10-20": 0.5890605555555556,
              "2025-10-22": 222.8283386111111,
              "2025-11-03": 344.0028252777778,
              "2025-11-12": 841.4647622222221,
              "2025-11-14": 746.1764947222223,
              "2025-11-17": 112.70143,
              "2025-11-24": 1.7658924999999999,
              "2025-12-15": 319.4756552777778,
              "2025-12-30": 103.12485527777777,
              "2026-01-07": 54.095234999999995,
              "2026-01-19": 0.09435472222222223,
              "2026-01-20": 23.003074444444444,
              "2026-01-22": 86.98315333333333,
              "2026-01-23": 19.615389722222226,
              "2026-01-29": 33.69459888888889,
              "2026-02-03": 500.2017130555555,
              "2026-02-09": 10.852923333333335,
              "2026-02-16": 1176.5055580555554,
              "2026-03-10": 32.42216444444445,
              "2026-03-16": 70.58402972222223,
              "2026-03-19": 247.89461111111112,
              "2026-03-23": 18.111476666666665,
              "2026-03-31": 20.668334444444444,
              "2026-04-09": 87.357465,
              "2026-04-27": 599.9927386111111,
              "2026-04-30": 45.41898333333333,
              "2026-05-08": 647.7645561111111,
              "2026-05-28": 0.24102166666666666
            },
            "time_count_per_day": {
              "2025-10-16": 1,
              "2025-10-20": 1,
              "2025-10-22": 1,
              "2025-11-03": 1,
              "2025-11-12": 1,
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-12-15": 1,
              "2025-12-30": 1,
              "2026-01-07": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-29": 4,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-16": 1,
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-19": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-09": 1,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-08": 2,
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 184.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "32-34h": 1,
                "44-46h": 2,
                "54-56h": 1,
                "70-72h": 1,
                "86-88h": 1,
                "112-114h": 1,
                "144-146h": 1,
                "222-224h": 1,
                "226-228h": 1,
                "238-240h": 1,
                "318-320h": 1,
                "344-346h": 1,
                "408-410h": 1,
                "454-456h": 1,
                "746-748h": 1,
                "1176-1178h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2025-10-16": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-11-03": 1,
                "2025-11-14": 1,
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-15": 1,
                "2026-01-07": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-01-29": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-09": 1,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-08": 2,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2025-10-16": 226.80372,
                "2025-10-20": 0.5890605555555556,
                "2025-10-22": 222.8283386111111,
                "2025-11-03": 344.0028252777778,
                "2025-11-14": 746.1764947222223,
                "2025-11-17": 112.70143,
                "2025-11-24": 1.7658924999999999,
                "2025-12-15": 319.4756552777778,
                "2026-01-07": 54.095234999999995,
                "2026-01-19": 0.09435472222222223,
                "2026-01-20": 23.003074444444444,
                "2026-01-22": 44.396770555555555,
                "2026-01-29": 2.7364247222222224,
                "2026-02-09": 8.294188611111112,
                "2026-02-16": 1176.5055580555554,
                "2026-03-10": 32.42216444444445,
                "2026-03-16": 70.58402972222223,
                "2026-03-23": 18.111476666666665,
                "2026-03-31": 20.668334444444444,
                "2026-04-09": 87.357465,
                "2026-04-27": 599.9927386111111,
                "2026-04-30": 45.41898333333333,
                "2026-05-08": 647.7645561111111,
                "2026-05-28": 0.24102166666666666
              },
              "time_count_per_day": {
                "2025-10-16": 1,
                "2025-10-20": 1,
                "2025-10-22": 1,
                "2025-11-03": 1,
                "2025-11-14": 1,
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-15": 1,
                "2026-01-07": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-01-29": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-09": 1,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-08": 2,
                "2026-05-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 178.84,
              "mode_time_hours": 13.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "12-14h": 2,
                "18-20h": 1,
                "42-44h": 1,
                "102-104h": 1,
                "246-248h": 1,
                "500-502h": 1,
                "840-842h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-12-30": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 3,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-03-19": 1
              },
              "time_per_day": {
                "2025-11-12": 841.4647622222221,
                "2025-12-30": 103.12485527777777,
                "2026-01-22": 42.58638277777778,
                "2026-01-23": 19.615389722222226,
                "2026-01-29": 30.958174166666666,
                "2026-02-03": 500.2017130555555,
                "2026-02-09": 2.5587347222222223,
                "2026-03-19": 247.89461111111112
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-12-30": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 3,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-03-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_180": {
      "overall": {
        "avg_time_hours": 515.89,
        "mode_time_hours": 891.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "654-656h": 1,
          "890-892h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-10": 1,
          "2025-11-13": 1,
          "2025-11-27": 1,
          "2026-04-18": 1
        },
        "time_per_day": {
          "2025-11-10": 3.242144444444444,
          "2025-11-13": 890.26861,
          "2025-11-27": 654.1531983333333
        },
        "time_count_per_day": {
          "2025-11-10": 1,
          "2025-11-13": 1,
          "2025-11-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 328.7,
          "mode_time_hours": 655.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "654-656h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-10": 1,
            "2025-11-27": 1,
            "2026-04-18": 1
          },
          "time_per_day": {
            "2025-11-10": 3.242144444444444,
            "2025-11-27": 654.1531983333333
          },
          "time_count_per_day": {
            "2025-11-10": 1,
            "2025-11-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 890.27,
          "mode_time_hours": 891.0,
          "mode_frequency": 1,
          "time_distribution": {
            "890-892h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 890.26861
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 515.89,
            "mode_time_hours": 891.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "654-656h": 1,
              "890-892h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-10": 1,
              "2025-11-13": 1,
              "2025-11-27": 1
            },
            "time_per_day": {
              "2025-11-10": 3.242144444444444,
              "2025-11-13": 890.26861,
              "2025-11-27": 654.1531983333333
            },
            "time_count_per_day": {
              "2025-11-10": 1,
              "2025-11-13": 1,
              "2025-11-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 328.7,
              "mode_time_hours": 655.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "654-656h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-10": 1,
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-10": 3.242144444444444,
                "2025-11-27": 654.1531983333333
              },
              "time_count_per_day": {
                "2025-11-10": 1,
                "2025-11-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 890.27,
              "mode_time_hours": 891.0,
              "mode_frequency": 1,
              "time_distribution": {
                "890-892h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 890.26861
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_181": {
      "overall": {
        "avg_time_hours": 135.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "670-672h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-20": 1,
          "2025-11-04": 1,
          "2026-02-23": 1,
          "2026-03-18": 1,
          "2026-03-23": 1
        },
        "time_per_day": {
          "2025-10-20": 1.1096055555555555,
          "2025-11-04": 671.3297786111111,
          "2026-02-23": 0.032608333333333336,
          "2026-03-18": 3.2297775,
          "2026-03-23": 1.9002838888888889
        },
        "time_count_per_day": {
          "2025-10-20": 1,
          "2025-11-04": 1,
          "2026-02-23": 1,
          "2026-03-18": 1,
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.57,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-20": 1,
            "2026-02-23": 1,
            "2026-03-18": 1,
            "2026-03-23": 1
          },
          "time_per_day": {
            "2025-10-20": 1.1096055555555555,
            "2026-02-23": 0.032608333333333336,
            "2026-03-18": 3.2297775,
            "2026-03-23": 1.9002838888888889
          },
          "time_count_per_day": {
            "2025-10-20": 1,
            "2026-02-23": 1,
            "2026-03-18": 1,
            "2026-03-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 671.33,
          "mode_time_hours": 671.0,
          "mode_frequency": 1,
          "time_distribution": {
            "670-672h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-11-04": 671.3297786111111
          },
          "time_count_per_day": {
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 135.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "670-672h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-10-20": 1,
              "2025-11-04": 1,
              "2026-02-23": 1,
              "2026-03-18": 1,
              "2026-03-23": 1
            },
            "time_per_day": {
              "2025-10-20": 1.1096055555555555,
              "2025-11-04": 671.3297786111111,
              "2026-02-23": 0.032608333333333336,
              "2026-03-18": 3.2297775,
              "2026-03-23": 1.9002838888888889
            },
            "time_count_per_day": {
              "2025-10-20": 1,
              "2025-11-04": 1,
              "2026-02-23": 1,
              "2026-03-18": 1,
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.57,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-20": 1,
                "2026-02-23": 1,
                "2026-03-18": 1,
                "2026-03-23": 1
              },
              "time_per_day": {
                "2025-10-20": 1.1096055555555555,
                "2026-02-23": 0.032608333333333336,
                "2026-03-18": 3.2297775,
                "2026-03-23": 1.9002838888888889
              },
              "time_count_per_day": {
                "2025-10-20": 1,
                "2026-02-23": 1,
                "2026-03-18": 1,
                "2026-03-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 671.33,
              "mode_time_hours": 671.0,
              "mode_frequency": 1,
              "time_distribution": {
                "670-672h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-11-04": 671.3297786111111
              },
              "time_count_per_day": {
                "2025-11-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_182": {
      "overall": {
        "avg_time_hours": 0.36,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-07": 1
        },
        "time_per_day": {
          "2025-10-07": 0.35542111111111113
        },
        "time_count_per_day": {
          "2025-10-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-07": 1
          },
          "time_per_day": {
            "2025-10-07": 0.35542111111111113
          },
          "time_count_per_day": {
            "2025-10-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.36,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-07": 1
            },
            "time_per_day": {
              "2025-10-07": 0.35542111111111113
            },
            "time_count_per_day": {
              "2025-10-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-07": 1
              },
              "time_per_day": {
                "2025-10-07": 0.35542111111111113
              },
              "time_count_per_day": {
                "2025-10-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_185": {
      "overall": {
        "avg_time_hours": 229.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 2,
          "12-14h": 1,
          "16-18h": 2,
          "22-24h": 2,
          "24-26h": 1,
          "88-90h": 1,
          "154-156h": 1,
          "192-194h": 1,
          "204-206h": 1,
          "352-354h": 1,
          "606-608h": 1,
          "652-654h": 1,
          "820-822h": 1,
          "1390-1392h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-15": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-19": 2,
          "2026-02-21": 2,
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-22": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-11-28": 22.26383777777778,
          "2025-12-04": 1391.1419977777778,
          "2025-12-15": 607.2518830555556,
          "2026-01-31": 23.330719444444444,
          "2026-02-03": 13.244217222222222,
          "2026-02-10": 155.8190563888889,
          "2026-02-13": 24.848130277777777,
          "2026-02-19": 197.81957944444443,
          "2026-02-21": 34.36415083333333,
          "2026-03-10": 205.20562305555555,
          "2026-03-16": 4.490625555555556,
          "2026-03-31": 89.1721675,
          "2026-04-14": 1.0672302777777778,
          "2026-04-22": 0.3627683333333333,
          "2026-05-08": 353.3985436111111,
          "2026-05-14": 653.4124172222222,
          "2026-06-03": 821.723026111111,
          "2026-06-05": 0.4486102777777778
        },
        "time_count_per_day": {
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-15": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-19": 2,
          "2026-02-21": 2,
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-31": 1,
          "2026-04-14": 1,
          "2026-04-22": 1,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-14": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 195.17,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 2,
            "12-14h": 1,
            "88-90h": 1,
            "204-206h": 1,
            "352-354h": 1,
            "652-654h": 1,
            "820-822h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-31": 1,
            "2026-04-14": 1,
            "2026-04-22": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-06-03": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-02-03": 13.244217222222222,
            "2026-02-19": 4.357614722222222,
            "2026-03-10": 205.20562305555555,
            "2026-03-16": 4.490625555555556,
            "2026-03-31": 89.1721675,
            "2026-04-14": 1.0672302777777778,
            "2026-04-22": 0.3627683333333333,
            "2026-05-08": 353.3985436111111,
            "2026-05-14": 653.4124172222222,
            "2026-06-03": 821.723026111111,
            "2026-06-05": 0.4486102777777778
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-03-10": 1,
            "2026-03-16": 1,
            "2026-03-31": 1,
            "2026-04-14": 1,
            "2026-04-22": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-06-03": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 370.78,
          "mode_time_hours": 23.0,
          "mode_frequency": 2,
          "time_distribution": {
            "22-24h": 2,
            "24-26h": 1,
            "154-156h": 1,
            "606-608h": 1,
            "1390-1392h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2026-01-31": 1,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-04-08": 1
          },
          "time_per_day": {
            "2025-11-28": 22.26383777777778,
            "2025-12-04": 1391.1419977777778,
            "2025-12-15": 607.2518830555556,
            "2026-01-31": 23.330719444444444,
            "2026-02-10": 155.8190563888889,
            "2026-02-13": 24.848130277777777
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2026-01-31": 1,
            "2026-02-10": 1,
            "2026-02-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 17.18,
          "mode_time_hours": 17.0,
          "mode_frequency": 2,
          "time_distribution": {
            "16-18h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-21": 2
          },
          "time_per_day": {
            "2026-02-21": 34.36415083333333
          },
          "time_count_per_day": {
            "2026-02-21": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 193.46,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "192-194h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 193.4619647222222
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 229.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 2,
              "12-14h": 1,
              "16-18h": 2,
              "22-24h": 2,
              "24-26h": 1,
              "88-90h": 1,
              "154-156h": 1,
              "192-194h": 1,
              "204-206h": 1,
              "352-354h": 1,
              "606-608h": 1,
              "652-654h": 1,
              "820-822h": 1,
              "1390-1392h": 1
            },
            "tickets_count": 20,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-15": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-19": 2,
              "2026-02-21": 2,
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-31": 1,
              "2026-04-14": 1,
              "2026-04-22": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-11-28": 22.26383777777778,
              "2025-12-04": 1391.1419977777778,
              "2025-12-15": 607.2518830555556,
              "2026-01-31": 23.330719444444444,
              "2026-02-03": 13.244217222222222,
              "2026-02-10": 155.8190563888889,
              "2026-02-13": 24.848130277777777,
              "2026-02-19": 197.81957944444443,
              "2026-02-21": 34.36415083333333,
              "2026-03-10": 205.20562305555555,
              "2026-03-16": 4.490625555555556,
              "2026-03-31": 89.1721675,
              "2026-04-14": 1.0672302777777778,
              "2026-04-22": 0.3627683333333333,
              "2026-05-08": 353.3985436111111,
              "2026-05-14": 653.4124172222222,
              "2026-06-03": 821.723026111111,
              "2026-06-05": 0.4486102777777778
            },
            "time_count_per_day": {
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-15": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-19": 2,
              "2026-02-21": 2,
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-31": 1,
              "2026-04-14": 1,
              "2026-04-22": 1,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 195.17,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 2,
                "12-14h": 1,
                "88-90h": 1,
                "204-206h": 1,
                "352-354h": 1,
                "652-654h": 1,
                "820-822h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-31": 1,
                "2026-04-14": 1,
                "2026-04-22": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-06-03": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-02-03": 13.244217222222222,
                "2026-02-19": 4.357614722222222,
                "2026-03-10": 205.20562305555555,
                "2026-03-16": 4.490625555555556,
                "2026-03-31": 89.1721675,
                "2026-04-14": 1.0672302777777778,
                "2026-04-22": 0.3627683333333333,
                "2026-05-08": 353.3985436111111,
                "2026-05-14": 653.4124172222222,
                "2026-06-03": 821.723026111111,
                "2026-06-05": 0.4486102777777778
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-03-10": 1,
                "2026-03-16": 1,
                "2026-03-31": 1,
                "2026-04-14": 1,
                "2026-04-22": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-06-03": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 370.78,
              "mode_time_hours": 23.0,
              "mode_frequency": 2,
              "time_distribution": {
                "22-24h": 2,
                "24-26h": 1,
                "154-156h": 1,
                "606-608h": 1,
                "1390-1392h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2026-01-31": 1,
                "2026-02-10": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2025-11-28": 22.26383777777778,
                "2025-12-04": 1391.1419977777778,
                "2025-12-15": 607.2518830555556,
                "2026-01-31": 23.330719444444444,
                "2026-02-10": 155.8190563888889,
                "2026-02-13": 24.848130277777777
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2026-01-31": 1,
                "2026-02-10": 1,
                "2026-02-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 17.18,
              "mode_time_hours": 17.0,
              "mode_frequency": 2,
              "time_distribution": {
                "16-18h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-21": 2
              },
              "time_per_day": {
                "2026-02-21": 34.36415083333333
              },
              "time_count_per_day": {
                "2026-02-21": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 193.46,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "192-194h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 193.4619647222222
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-08": 1,
              "2026-04-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_178": {
      "overall": {
        "avg_time_hours": 165.74,
        "mode_time_hours": 3.0,
        "mode_frequency": 12,
        "time_distribution": {
          "0-2h": 7,
          "2-4h": 12,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 2,
          "12-14h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 2,
          "24-26h": 2,
          "26-28h": 1,
          "30-32h": 1,
          "32-34h": 1,
          "36-38h": 1,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "44-46h": 1,
          "46-48h": 1,
          "50-52h": 1,
          "54-56h": 1,
          "64-66h": 1,
          "68-70h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "76-78h": 2,
          "78-80h": 1,
          "92-94h": 1,
          "142-144h": 1,
          "144-146h": 1,
          "190-192h": 1,
          "198-200h": 1,
          "266-268h": 1,
          "330-332h": 1,
          "362-364h": 1,
          "388-390h": 2,
          "396-398h": 1,
          "412-414h": 1,
          "414-416h": 2,
          "452-454h": 1,
          "478-480h": 1,
          "578-580h": 1,
          "652-654h": 1,
          "696-698h": 1,
          "910-912h": 1,
          "976-978h": 1,
          "990-992h": 1,
          "1128-1130h": 1
        },
        "tickets_count": 79,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-31": 1,
          "2025-11-17": 2,
          "2025-11-20": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2026-01-02": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-17": 1,
          "2026-01-20": 2,
          "2026-01-22": 2,
          "2026-01-23": 3,
          "2026-01-26": 2,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 3,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 2,
          "2026-03-09": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-20": 4,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-02": 1,
          "2026-04-13": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-27": 1,
          "2026-06-02": 3,
          "2026-06-03": 2,
          "2026-06-05": 1,
          "2026-06-06": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-08": 2.2778408333333338,
          "2025-10-10": 76.55157444444444,
          "2025-10-13": 3.4762983333333337,
          "2025-10-14": 4.859609166666667,
          "2025-10-15": 58.03118194444444,
          "2025-10-31": 92.69544555555555,
          "2025-11-17": 151.3941586111111,
          "2025-11-20": 910.4646516666667,
          "2025-12-02": 414.6846902777778,
          "2025-12-04": 144.06847249999998,
          "2025-12-11": 478.64439416666664,
          "2025-12-17": 415.0800058333333,
          "2025-12-19": 802.0139741666667,
          "2026-01-02": 991.5368063888889,
          "2026-01-13": 7.351136388888889,
          "2026-01-14": 455.8459877777778,
          "2026-01-17": 32.244463333333336,
          "2026-01-20": 465.5332441666667,
          "2026-01-22": 89.50418777777779,
          "2026-01-23": 125.21315194444446,
          "2026-01-26": 4.9400691666666665,
          "2026-01-27": 64.9159088888889,
          "2026-01-29": 12.799901944444443,
          "2026-02-03": 679.7855475,
          "2026-02-04": 191.82268638888888,
          "2026-02-05": 47.966259722222226,
          "2026-02-09": 44.68745722222222,
          "2026-02-10": 53.89702916666666,
          "2026-02-19": 8.263624722222222,
          "2026-02-20": 23.538175833333334,
          "2026-02-24": 26.213710833333334,
          "2026-03-02": 1.7306980555555556,
          "2026-03-04": 3.7114530555555554,
          "2026-03-06": 0.9913236111111111,
          "2026-03-09": 76.12187305555555,
          "2026-03-11": 696.2096327777778,
          "2026-03-12": 18.22682388888889,
          "2026-03-13": 37.823973888888894,
          "2026-03-16": 1.4127155555555555,
          "2026-03-20": 1156.6953991666664,
          "2026-03-25": 977.0795708333334,
          "2026-03-26": 143.54668527777778,
          "2026-04-02": 578.0457516666667,
          "2026-04-13": 68.8902075,
          "2026-04-20": 1128.4154925,
          "2026-04-21": 2.0726630555555556,
          "2026-04-23": 400.4115977777778,
          "2026-05-14": 8.31645,
          "2026-05-19": 22.48693472222222,
          "2026-05-21": 18.05381,
          "2026-05-27": 25.882471388888888,
          "2026-06-02": 12.156926388888888,
          "2026-06-03": 5.949463055555556,
          "2026-06-05": 0.05304805555555556
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-10": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-15": 2,
          "2025-10-31": 1,
          "2025-11-17": 2,
          "2025-11-20": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2026-01-02": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-17": 1,
          "2026-01-20": 2,
          "2026-01-22": 2,
          "2026-01-23": 3,
          "2026-01-26": 2,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 3,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 2,
          "2026-03-09": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-20": 4,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-02": 1,
          "2026-04-13": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-27": 1,
          "2026-06-02": 3,
          "2026-06-03": 2,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 39.17,
          "mode_time_hours": 55.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "36-38h": 1,
            "54-56h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2026-02-03": 1,
            "2026-03-13": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-15": 54.32751694444444,
            "2026-02-03": 25.346445277777775,
            "2026-03-13": 37.823973888888894
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2026-02-03": 1,
            "2026-03-13": 1
          }
        },
        "P2": {
          "avg_time_hours": 187.06,
          "mode_time_hours": 3.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 10,
            "4-6h": 2,
            "8-10h": 1,
            "18-20h": 2,
            "22-24h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "42-44h": 1,
            "46-48h": 1,
            "68-70h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "76-78h": 2,
            "92-94h": 1,
            "142-144h": 1,
            "144-146h": 1,
            "198-200h": 1,
            "266-268h": 1,
            "330-332h": 1,
            "362-364h": 1,
            "388-390h": 2,
            "396-398h": 1,
            "412-414h": 1,
            "414-416h": 2,
            "578-580h": 1,
            "652-654h": 1,
            "696-698h": 1,
            "910-912h": 1,
            "990-992h": 1,
            "1128-1130h": 1
          },
          "tickets_count": 55,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-31": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2026-01-02": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-24": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 2,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-20": 4,
            "2026-03-26": 1,
            "2026-04-02": 1,
            "2026-04-13": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-23": 2,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-27": 1,
            "2026-06-02": 3,
            "2026-06-03": 2,
            "2026-06-05": 1,
            "2026-06-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-08": 2.2778408333333338,
            "2025-10-10": 76.55157444444444,
            "2025-10-13": 3.4762983333333337,
            "2025-10-14": 4.859609166666667,
            "2025-10-15": 3.703665,
            "2025-10-31": 92.69544555555555,
            "2025-11-17": 71.89653638888889,
            "2025-11-20": 910.4646516666667,
            "2025-12-02": 414.6846902777778,
            "2025-12-04": 144.06847249999998,
            "2025-12-17": 415.0800058333333,
            "2025-12-19": 802.0139741666667,
            "2026-01-02": 991.5368063888889,
            "2026-01-20": 465.5332441666667,
            "2026-01-23": 42.04386388888889,
            "2026-01-26": 1.1283883333333333,
            "2026-02-03": 654.4391022222222,
            "2026-02-05": 47.966259722222226,
            "2026-02-24": 26.213710833333334,
            "2026-03-02": 1.7306980555555556,
            "2026-03-04": 3.7114530555555554,
            "2026-03-06": 0.9913236111111111,
            "2026-03-09": 76.12187305555555,
            "2026-03-11": 696.2096327777778,
            "2026-03-12": 18.22682388888889,
            "2026-03-16": 1.4127155555555555,
            "2026-03-20": 1156.6953991666664,
            "2026-03-26": 143.54668527777778,
            "2026-04-02": 578.0457516666667,
            "2026-04-13": 68.8902075,
            "2026-04-20": 1128.4154925,
            "2026-04-21": 2.0726630555555556,
            "2026-04-23": 400.4115977777778,
            "2026-05-14": 8.31645,
            "2026-05-19": 22.48693472222222,
            "2026-05-21": 18.05381,
            "2026-05-27": 25.882471388888888,
            "2026-06-02": 12.156926388888888,
            "2026-06-03": 5.949463055555556,
            "2026-06-05": 0.05304805555555556
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-10": 1,
            "2025-10-13": 1,
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-31": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-17": 1,
            "2025-12-19": 2,
            "2026-01-02": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-24": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 2,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-16": 1,
            "2026-03-20": 4,
            "2026-03-26": 1,
            "2026-04-02": 1,
            "2026-04-13": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-23": 2,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-27": 1,
            "2026-06-02": 3,
            "2026-06-03": 2,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 136.78,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "6-8h": 1,
            "12-14h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "30-32h": 1,
            "32-34h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "50-52h": 1,
            "64-66h": 1,
            "78-80h": 1,
            "190-192h": 1,
            "452-454h": 1,
            "478-480h": 1,
            "976-978h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-12-11": 1,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-17": 1,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-04": 1,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-20": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-11-17": 79.49762222222222,
            "2025-12-11": 478.64439416666664,
            "2026-01-13": 7.351136388888889,
            "2026-01-14": 455.8459877777778,
            "2026-01-17": 32.244463333333336,
            "2026-01-22": 89.50418777777779,
            "2026-01-23": 83.16928805555555,
            "2026-01-26": 3.8116808333333334,
            "2026-01-27": 64.9159088888889,
            "2026-01-29": 12.799901944444443,
            "2026-02-04": 191.82268638888888,
            "2026-02-09": 44.68745722222222,
            "2026-02-10": 53.89702916666666,
            "2026-02-20": 23.538175833333334,
            "2026-03-25": 977.0795708333334
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-12-11": 1,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-17": 1,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-29": 1,
            "2026-02-04": 1,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-20": 1,
            "2026-03-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 8.26,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 8.263624722222222
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.74,
            "mode_time_hours": 3.0,
            "mode_frequency": 12,
            "time_distribution": {
              "0-2h": 7,
              "2-4h": 12,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 2,
              "12-14h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 2,
              "24-26h": 2,
              "26-28h": 1,
              "30-32h": 1,
              "32-34h": 1,
              "36-38h": 1,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "44-46h": 1,
              "46-48h": 1,
              "50-52h": 1,
              "54-56h": 1,
              "64-66h": 1,
              "68-70h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "76-78h": 2,
              "78-80h": 1,
              "92-94h": 1,
              "142-144h": 1,
              "144-146h": 1,
              "190-192h": 1,
              "198-200h": 1,
              "266-268h": 1,
              "330-332h": 1,
              "362-364h": 1,
              "388-390h": 2,
              "396-398h": 1,
              "412-414h": 1,
              "414-416h": 2,
              "452-454h": 1,
              "478-480h": 1,
              "578-580h": 1,
              "652-654h": 1,
              "696-698h": 1,
              "910-912h": 1,
              "976-978h": 1,
              "990-992h": 1,
              "1128-1130h": 1
            },
            "tickets_count": 74,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-31": 1,
              "2025-11-17": 2,
              "2025-11-20": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2026-01-02": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-17": 1,
              "2026-01-20": 2,
              "2026-01-22": 2,
              "2026-01-23": 3,
              "2026-01-26": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 3,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 2,
              "2026-03-09": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-20": 4,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-27": 1,
              "2026-06-02": 3,
              "2026-06-03": 2,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-08": 2.2778408333333338,
              "2025-10-10": 76.55157444444444,
              "2025-10-13": 3.4762983333333337,
              "2025-10-14": 4.859609166666667,
              "2025-10-15": 58.03118194444444,
              "2025-10-31": 92.69544555555555,
              "2025-11-17": 151.3941586111111,
              "2025-11-20": 910.4646516666667,
              "2025-12-02": 414.6846902777778,
              "2025-12-04": 144.06847249999998,
              "2025-12-11": 478.64439416666664,
              "2025-12-17": 415.0800058333333,
              "2025-12-19": 802.0139741666667,
              "2026-01-02": 991.5368063888889,
              "2026-01-13": 7.351136388888889,
              "2026-01-14": 455.8459877777778,
              "2026-01-17": 32.244463333333336,
              "2026-01-20": 465.5332441666667,
              "2026-01-22": 89.50418777777779,
              "2026-01-23": 125.21315194444446,
              "2026-01-26": 4.9400691666666665,
              "2026-01-27": 64.9159088888889,
              "2026-01-29": 12.799901944444443,
              "2026-02-03": 679.7855475,
              "2026-02-04": 191.82268638888888,
              "2026-02-05": 47.966259722222226,
              "2026-02-09": 44.68745722222222,
              "2026-02-10": 53.89702916666666,
              "2026-02-19": 8.263624722222222,
              "2026-02-20": 23.538175833333334,
              "2026-02-24": 26.213710833333334,
              "2026-03-02": 1.7306980555555556,
              "2026-03-04": 3.7114530555555554,
              "2026-03-06": 0.9913236111111111,
              "2026-03-09": 76.12187305555555,
              "2026-03-11": 696.2096327777778,
              "2026-03-12": 18.22682388888889,
              "2026-03-13": 37.823973888888894,
              "2026-03-16": 1.4127155555555555,
              "2026-03-20": 1156.6953991666664,
              "2026-03-25": 977.0795708333334,
              "2026-03-26": 143.54668527777778,
              "2026-04-02": 578.0457516666667,
              "2026-04-13": 68.8902075,
              "2026-04-20": 1128.4154925,
              "2026-04-21": 2.0726630555555556,
              "2026-04-23": 400.4115977777778,
              "2026-05-14": 8.31645,
              "2026-05-19": 22.48693472222222,
              "2026-05-21": 18.05381,
              "2026-05-27": 25.882471388888888,
              "2026-06-02": 12.156926388888888,
              "2026-06-03": 5.949463055555556,
              "2026-06-05": 0.05304805555555556
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-10": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-15": 2,
              "2025-10-31": 1,
              "2025-11-17": 2,
              "2025-11-20": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2026-01-02": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-17": 1,
              "2026-01-20": 2,
              "2026-01-22": 2,
              "2026-01-23": 3,
              "2026-01-26": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 3,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 2,
              "2026-03-09": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-20": 4,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-27": 1,
              "2026-06-02": 3,
              "2026-06-03": 2,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 39.17,
              "mode_time_hours": 55.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "36-38h": 1,
                "54-56h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2026-02-03": 1,
                "2026-03-13": 1
              },
              "time_per_day": {
                "2025-10-15": 54.32751694444444,
                "2026-02-03": 25.346445277777775,
                "2026-03-13": 37.823973888888894
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2026-02-03": 1,
                "2026-03-13": 1
              }
            },
            "P2": {
              "avg_time_hours": 187.06,
              "mode_time_hours": 3.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 10,
                "4-6h": 2,
                "8-10h": 1,
                "18-20h": 2,
                "22-24h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "42-44h": 1,
                "46-48h": 1,
                "68-70h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "76-78h": 2,
                "92-94h": 1,
                "142-144h": 1,
                "144-146h": 1,
                "198-200h": 1,
                "266-268h": 1,
                "330-332h": 1,
                "362-364h": 1,
                "388-390h": 2,
                "396-398h": 1,
                "412-414h": 1,
                "414-416h": 2,
                "578-580h": 1,
                "652-654h": 1,
                "696-698h": 1,
                "910-912h": 1,
                "990-992h": 1,
                "1128-1130h": 1
              },
              "tickets_count": 51,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-31": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2026-01-02": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-24": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 2,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-20": 4,
                "2026-03-26": 1,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-23": 2,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-27": 1,
                "2026-06-02": 3,
                "2026-06-03": 2,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-08": 2.2778408333333338,
                "2025-10-10": 76.55157444444444,
                "2025-10-13": 3.4762983333333337,
                "2025-10-14": 4.859609166666667,
                "2025-10-15": 3.703665,
                "2025-10-31": 92.69544555555555,
                "2025-11-17": 71.89653638888889,
                "2025-11-20": 910.4646516666667,
                "2025-12-02": 414.6846902777778,
                "2025-12-04": 144.06847249999998,
                "2025-12-17": 415.0800058333333,
                "2025-12-19": 802.0139741666667,
                "2026-01-02": 991.5368063888889,
                "2026-01-20": 465.5332441666667,
                "2026-01-23": 42.04386388888889,
                "2026-01-26": 1.1283883333333333,
                "2026-02-03": 654.4391022222222,
                "2026-02-05": 47.966259722222226,
                "2026-02-24": 26.213710833333334,
                "2026-03-02": 1.7306980555555556,
                "2026-03-04": 3.7114530555555554,
                "2026-03-06": 0.9913236111111111,
                "2026-03-09": 76.12187305555555,
                "2026-03-11": 696.2096327777778,
                "2026-03-12": 18.22682388888889,
                "2026-03-16": 1.4127155555555555,
                "2026-03-20": 1156.6953991666664,
                "2026-03-26": 143.54668527777778,
                "2026-04-02": 578.0457516666667,
                "2026-04-13": 68.8902075,
                "2026-04-20": 1128.4154925,
                "2026-04-21": 2.0726630555555556,
                "2026-04-23": 400.4115977777778,
                "2026-05-14": 8.31645,
                "2026-05-19": 22.48693472222222,
                "2026-05-21": 18.05381,
                "2026-05-27": 25.882471388888888,
                "2026-06-02": 12.156926388888888,
                "2026-06-03": 5.949463055555556,
                "2026-06-05": 0.05304805555555556
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-10": 1,
                "2025-10-13": 1,
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-31": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-17": 1,
                "2025-12-19": 2,
                "2026-01-02": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-24": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 2,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-16": 1,
                "2026-03-20": 4,
                "2026-03-26": 1,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-23": 2,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-27": 1,
                "2026-06-02": 3,
                "2026-06-03": 2,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 136.78,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "6-8h": 1,
                "12-14h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "30-32h": 1,
                "32-34h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "50-52h": 1,
                "64-66h": 1,
                "78-80h": 1,
                "190-192h": 1,
                "452-454h": 1,
                "478-480h": 1,
                "976-978h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-12-11": 1,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-17": 1,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-04": 1,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-20": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-11-17": 79.49762222222222,
                "2025-12-11": 478.64439416666664,
                "2026-01-13": 7.351136388888889,
                "2026-01-14": 455.8459877777778,
                "2026-01-17": 32.244463333333336,
                "2026-01-22": 89.50418777777779,
                "2026-01-23": 83.16928805555555,
                "2026-01-26": 3.8116808333333334,
                "2026-01-27": 64.9159088888889,
                "2026-01-29": 12.799901944444443,
                "2026-02-04": 191.82268638888888,
                "2026-02-09": 44.68745722222222,
                "2026-02-10": 53.89702916666666,
                "2026-02-20": 23.538175833333334,
                "2026-03-25": 977.0795708333334
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-12-11": 1,
                "2026-01-13": 1,
                "2026-01-14": 2,
                "2026-01-17": 1,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-29": 1,
                "2026-02-04": 1,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-20": 1,
                "2026-03-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 8.26,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 8.263624722222222
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-06": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_187": {
      "overall": {
        "avg_time_hours": 8.42,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "2-4h": 2,
          "12-14h": 1,
          "72-74h": 2
        },
        "tickets_count": 20,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-27": 1,
          "2025-10-29": 1,
          "2025-11-11": 2,
          "2026-01-06": 2,
          "2026-01-13": 1,
          "2026-01-21": 3,
          "2026-01-23": 1,
          "2026-01-30": 6,
          "2026-02-03": 1
        },
        "time_per_day": {
          "2025-10-07": 1.588885833333333,
          "2025-10-09": 0.1321388888888889,
          "2025-10-27": 0.5770861111111112,
          "2025-10-29": 12.140692777777778,
          "2025-11-11": 145.7007377777778,
          "2026-01-06": 5.959388055555555,
          "2026-01-13": 0.6160277777777777,
          "2026-01-21": 0.588726388888889,
          "2026-01-23": 0.030443055555555557,
          "2026-01-30": 0.3696391666666667,
          "2026-02-03": 0.6778066666666667
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-09": 1,
          "2025-10-27": 1,
          "2025-10-29": 1,
          "2025-11-11": 2,
          "2026-01-06": 2,
          "2026-01-13": 1,
          "2026-01-21": 3,
          "2026-01-23": 1,
          "2026-01-30": 6,
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.42,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 2,
            "12-14h": 1,
            "72-74h": 2
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-27": 1,
            "2025-10-29": 1,
            "2025-11-11": 2,
            "2026-01-06": 2,
            "2026-01-13": 1,
            "2026-01-21": 3,
            "2026-01-23": 1,
            "2026-01-30": 6,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-10-07": 1.588885833333333,
            "2025-10-09": 0.1321388888888889,
            "2025-10-27": 0.5770861111111112,
            "2025-10-29": 12.140692777777778,
            "2025-11-11": 145.7007377777778,
            "2026-01-06": 5.959388055555555,
            "2026-01-13": 0.6160277777777777,
            "2026-01-21": 0.588726388888889,
            "2026-01-23": 0.030443055555555557,
            "2026-01-30": 0.3696391666666667,
            "2026-02-03": 0.6778066666666667
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-09": 1,
            "2025-10-27": 1,
            "2025-10-29": 1,
            "2025-11-11": 2,
            "2026-01-06": 2,
            "2026-01-13": 1,
            "2026-01-21": 3,
            "2026-01-23": 1,
            "2026-01-30": 6,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.42,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "2-4h": 2,
              "12-14h": 1,
              "72-74h": 2
            },
            "tickets_count": 20,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-27": 1,
              "2025-10-29": 1,
              "2025-11-11": 2,
              "2026-01-06": 2,
              "2026-01-13": 1,
              "2026-01-21": 3,
              "2026-01-23": 1,
              "2026-01-30": 6,
              "2026-02-03": 1
            },
            "time_per_day": {
              "2025-10-07": 1.588885833333333,
              "2025-10-09": 0.1321388888888889,
              "2025-10-27": 0.5770861111111112,
              "2025-10-29": 12.140692777777778,
              "2025-11-11": 145.7007377777778,
              "2026-01-06": 5.959388055555555,
              "2026-01-13": 0.6160277777777777,
              "2026-01-21": 0.588726388888889,
              "2026-01-23": 0.030443055555555557,
              "2026-01-30": 0.3696391666666667,
              "2026-02-03": 0.6778066666666667
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-09": 1,
              "2025-10-27": 1,
              "2025-10-29": 1,
              "2025-11-11": 2,
              "2026-01-06": 2,
              "2026-01-13": 1,
              "2026-01-21": 3,
              "2026-01-23": 1,
              "2026-01-30": 6,
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.42,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 2,
                "12-14h": 1,
                "72-74h": 2
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-27": 1,
                "2025-10-29": 1,
                "2025-11-11": 2,
                "2026-01-06": 2,
                "2026-01-13": 1,
                "2026-01-21": 3,
                "2026-01-23": 1,
                "2026-01-30": 6,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-10-07": 1.588885833333333,
                "2025-10-09": 0.1321388888888889,
                "2025-10-27": 0.5770861111111112,
                "2025-10-29": 12.140692777777778,
                "2025-11-11": 145.7007377777778,
                "2026-01-06": 5.959388055555555,
                "2026-01-13": 0.6160277777777777,
                "2026-01-21": 0.588726388888889,
                "2026-01-23": 0.030443055555555557,
                "2026-01-30": 0.3696391666666667,
                "2026-02-03": 0.6778066666666667
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-09": 1,
                "2025-10-27": 1,
                "2025-10-29": 1,
                "2025-11-11": 2,
                "2026-01-06": 2,
                "2026-01-13": 1,
                "2026-01-21": 3,
                "2026-01-23": 1,
                "2026-01-30": 6,
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_189": {
      "overall": {
        "avg_time_hours": 4.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 23,
        "time_distribution": {
          "0-2h": 23,
          "2-4h": 3,
          "4-6h": 1,
          "6-8h": 2,
          "12-14h": 1,
          "90-92h": 1
        },
        "tickets_count": 32,
        "tickets_per_day": {
          "2025-10-07": 1,
          "2025-10-13": 1,
          "2025-10-29": 1,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-06": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-25": 1,
          "2026-02-28": 2,
          "2026-03-05": 1,
          "2026-03-09": 2,
          "2026-03-12": 1,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-04": 1,
          "2026-05-11": 1,
          "2026-05-25": 1,
          "2026-06-01": 3
        },
        "time_per_day": {
          "2025-10-07": 0.1170761111111111,
          "2025-10-13": 0.2720311111111111,
          "2025-10-29": 12.439925833333334,
          "2026-01-17": 91.22941638888888,
          "2026-01-19": 6.811304722222222,
          "2026-01-22": 1.5361933333333333,
          "2026-01-26": 1.4442397222222223,
          "2026-01-28": 6.494385,
          "2026-02-06": 0.2887091666666667,
          "2026-02-18": 2.0257444444444443,
          "2026-02-20": 0.5212755555555556,
          "2026-02-24": 0.5284091666666667,
          "2026-02-25": 0.028404722222222224,
          "2026-02-28": 0.7972441666666668,
          "2026-03-09": 7.665682222222221,
          "2026-03-12": 0.010476111111111111,
          "2026-03-23": 4.408528333333333,
          "2026-03-26": 0.12277972222222222,
          "2026-04-16": 0.5363516666666667,
          "2026-04-22": 0.10024111111111111,
          "2026-04-28": 0.3196936111111111,
          "2026-05-04": 0.9355330555555555,
          "2026-05-11": 0.37211111111111106,
          "2026-05-25": 0.24555666666666667,
          "2026-06-01": 4.845343333333333
        },
        "time_count_per_day": {
          "2025-10-07": 1,
          "2025-10-13": 1,
          "2025-10-29": 1,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-06": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-25": 1,
          "2026-02-28": 2,
          "2026-03-09": 2,
          "2026-03-12": 1,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-04": 1,
          "2026-05-11": 1,
          "2026-05-25": 1,
          "2026-06-01": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.76,
          "mode_time_hours": 1.0,
          "mode_frequency": 23,
          "time_distribution": {
            "0-2h": 23,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 2,
            "12-14h": 1
          },
          "tickets_count": 30,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-13": 1,
            "2025-10-29": 1,
            "2026-01-19": 2,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-06": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-25": 1,
            "2026-02-28": 2,
            "2026-03-09": 2,
            "2026-03-12": 1,
            "2026-03-23": 1,
            "2026-03-26": 1,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-04": 1,
            "2026-05-11": 1,
            "2026-05-25": 1,
            "2026-06-01": 3
          },
          "time_per_day": {
            "2025-10-07": 0.1170761111111111,
            "2025-10-13": 0.2720311111111111,
            "2025-10-29": 12.439925833333334,
            "2026-01-19": 6.811304722222222,
            "2026-01-22": 1.5361933333333333,
            "2026-01-26": 1.4442397222222223,
            "2026-01-28": 6.494385,
            "2026-02-06": 0.2887091666666667,
            "2026-02-18": 2.0257444444444443,
            "2026-02-20": 0.5212755555555556,
            "2026-02-24": 0.5284091666666667,
            "2026-02-25": 0.028404722222222224,
            "2026-02-28": 0.7972441666666668,
            "2026-03-09": 7.665682222222221,
            "2026-03-12": 0.010476111111111111,
            "2026-03-23": 4.408528333333333,
            "2026-03-26": 0.12277972222222222,
            "2026-04-16": 0.5363516666666667,
            "2026-04-22": 0.10024111111111111,
            "2026-04-28": 0.3196936111111111,
            "2026-05-04": 0.9355330555555555,
            "2026-05-11": 0.37211111111111106,
            "2026-05-25": 0.24555666666666667,
            "2026-06-01": 4.845343333333333
          },
          "time_count_per_day": {
            "2025-10-07": 1,
            "2025-10-13": 1,
            "2025-10-29": 1,
            "2026-01-19": 2,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-06": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-25": 1,
            "2026-02-28": 2,
            "2026-03-09": 2,
            "2026-03-12": 1,
            "2026-03-23": 1,
            "2026-03-26": 1,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-04": 1,
            "2026-05-11": 1,
            "2026-05-25": 1,
            "2026-06-01": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 91.23,
          "mode_time_hours": 91.0,
          "mode_frequency": 1,
          "time_distribution": {
            "90-92h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-17": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-01-17": 91.22941638888888
          },
          "time_count_per_day": {
            "2026-01-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 23,
            "time_distribution": {
              "0-2h": 23,
              "2-4h": 3,
              "4-6h": 1,
              "6-8h": 2,
              "12-14h": 1,
              "90-92h": 1
            },
            "tickets_count": 31,
            "tickets_per_day": {
              "2025-10-07": 1,
              "2025-10-13": 1,
              "2025-10-29": 1,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-06": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-25": 1,
              "2026-02-28": 2,
              "2026-03-09": 2,
              "2026-03-12": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-04": 1,
              "2026-05-11": 1,
              "2026-05-25": 1,
              "2026-06-01": 3
            },
            "time_per_day": {
              "2025-10-07": 0.1170761111111111,
              "2025-10-13": 0.2720311111111111,
              "2025-10-29": 12.439925833333334,
              "2026-01-17": 91.22941638888888,
              "2026-01-19": 6.811304722222222,
              "2026-01-22": 1.5361933333333333,
              "2026-01-26": 1.4442397222222223,
              "2026-01-28": 6.494385,
              "2026-02-06": 0.2887091666666667,
              "2026-02-18": 2.0257444444444443,
              "2026-02-20": 0.5212755555555556,
              "2026-02-24": 0.5284091666666667,
              "2026-02-25": 0.028404722222222224,
              "2026-02-28": 0.7972441666666668,
              "2026-03-09": 7.665682222222221,
              "2026-03-12": 0.010476111111111111,
              "2026-03-23": 4.408528333333333,
              "2026-03-26": 0.12277972222222222,
              "2026-04-16": 0.5363516666666667,
              "2026-04-22": 0.10024111111111111,
              "2026-04-28": 0.3196936111111111,
              "2026-05-04": 0.9355330555555555,
              "2026-05-11": 0.37211111111111106,
              "2026-05-25": 0.24555666666666667,
              "2026-06-01": 4.845343333333333
            },
            "time_count_per_day": {
              "2025-10-07": 1,
              "2025-10-13": 1,
              "2025-10-29": 1,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-06": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-25": 1,
              "2026-02-28": 2,
              "2026-03-09": 2,
              "2026-03-12": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-04": 1,
              "2026-05-11": 1,
              "2026-05-25": 1,
              "2026-06-01": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.76,
              "mode_time_hours": 1.0,
              "mode_frequency": 23,
              "time_distribution": {
                "0-2h": 23,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 2,
                "12-14h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-29": 1,
                "2026-01-19": 2,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-06": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-25": 1,
                "2026-02-28": 2,
                "2026-03-09": 2,
                "2026-03-12": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-04": 1,
                "2026-05-11": 1,
                "2026-05-25": 1,
                "2026-06-01": 3
              },
              "time_per_day": {
                "2025-10-07": 0.1170761111111111,
                "2025-10-13": 0.2720311111111111,
                "2025-10-29": 12.439925833333334,
                "2026-01-19": 6.811304722222222,
                "2026-01-22": 1.5361933333333333,
                "2026-01-26": 1.4442397222222223,
                "2026-01-28": 6.494385,
                "2026-02-06": 0.2887091666666667,
                "2026-02-18": 2.0257444444444443,
                "2026-02-20": 0.5212755555555556,
                "2026-02-24": 0.5284091666666667,
                "2026-02-25": 0.028404722222222224,
                "2026-02-28": 0.7972441666666668,
                "2026-03-09": 7.665682222222221,
                "2026-03-12": 0.010476111111111111,
                "2026-03-23": 4.408528333333333,
                "2026-03-26": 0.12277972222222222,
                "2026-04-16": 0.5363516666666667,
                "2026-04-22": 0.10024111111111111,
                "2026-04-28": 0.3196936111111111,
                "2026-05-04": 0.9355330555555555,
                "2026-05-11": 0.37211111111111106,
                "2026-05-25": 0.24555666666666667,
                "2026-06-01": 4.845343333333333
              },
              "time_count_per_day": {
                "2025-10-07": 1,
                "2025-10-13": 1,
                "2025-10-29": 1,
                "2026-01-19": 2,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-06": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-25": 1,
                "2026-02-28": 2,
                "2026-03-09": 2,
                "2026-03-12": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-04": 1,
                "2026-05-11": 1,
                "2026-05-25": 1,
                "2026-06-01": 3
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 91.23,
              "mode_time_hours": 91.0,
              "mode_frequency": 1,
              "time_distribution": {
                "90-92h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-17": 1
              },
              "time_per_day": {
                "2026-01-17": 91.22941638888888
              },
              "time_count_per_day": {
                "2026-01-17": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_190": {
      "overall": {
        "avg_time_hours": 179.62,
        "mode_time_hours": 3.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 5,
          "4-6h": 2,
          "8-10h": 3,
          "10-12h": 1,
          "14-16h": 1,
          "16-18h": 3,
          "24-26h": 1,
          "26-28h": 2,
          "32-34h": 2,
          "46-48h": 1,
          "48-50h": 1,
          "50-52h": 2,
          "60-62h": 1,
          "66-68h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "96-98h": 1,
          "106-108h": 1,
          "138-140h": 1,
          "184-186h": 1,
          "268-270h": 1,
          "284-286h": 1,
          "294-296h": 1,
          "304-306h": 1,
          "372-374h": 1,
          "390-392h": 1,
          "458-460h": 1,
          "506-508h": 1,
          "526-528h": 1,
          "576-578h": 2,
          "672-674h": 1,
          "1306-1308h": 1,
          "1336-1338h": 1
        },
        "tickets_count": 57,
        "tickets_per_day": {
          "2025-10-10": 1,
          "2025-10-20": 1,
          "2025-10-23": 3,
          "2025-10-27": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-07": 1,
          "2026-01-08": 1,
          "2026-01-11": 1,
          "2026-01-12": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-23": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-04-07": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-13": 1,
          "2026-04-16": 1,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-27": 1,
          "2026-05-28": 2,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-10-10": 4.48264,
          "2025-10-20": 2.86114,
          "2025-10-23": 574.9821155555555,
          "2025-10-27": 1.1264825,
          "2025-11-07": 32.073321666666665,
          "2025-11-17": 97.39243111111111,
          "2025-12-02": 284.25434805555557,
          "2025-12-09": 50.576703611111114,
          "2025-12-15": 294.2384761111111,
          "2025-12-18": 61.12748805555555,
          "2025-12-26": 3.503107222222222,
          "2026-01-07": 459.33691666666664,
          "2026-01-08": 0.31710166666666667,
          "2026-01-11": 1307.4589775,
          "2026-01-12": 139.66401555555555,
          "2026-01-14": 0.2526658333333333,
          "2026-01-17": 4.41467,
          "2026-01-19": 14.777507222222221,
          "2026-01-21": 106.8501025,
          "2026-01-22": 33.45699527777778,
          "2026-01-30": 269.90977055555555,
          "2026-02-09": 66.04926527777778,
          "2026-02-12": 506.0255413888889,
          "2026-02-13": 575.0450363888889,
          "2026-02-19": 17.644305,
          "2026-02-20": 51.787951944444444,
          "2026-02-23": 70.41375277777777,
          "2026-02-26": 9.455543333333333,
          "2026-03-02": 0.6003283333333332,
          "2026-03-06": 24.022974722222223,
          "2026-03-10": 3.5410066666666666,
          "2026-03-12": 17.43446888888889,
          "2026-03-20": 577.3126813888889,
          "2026-03-25": 673.4264044444444,
          "2026-04-07": 3.671943888888889,
          "2026-04-09": 1.9129694444444443,
          "2026-04-10": 419.18536666666665,
          "2026-04-16": 1337.0554869444443,
          "2026-04-29": 3.002336111111111,
          "2026-05-05": 576.4904683333333,
          "2026-05-06": 304.8362511111111,
          "2026-05-08": 73.19345777777777,
          "2026-05-19": 26.589961666666664,
          "2026-05-20": 11.011890555555555,
          "2026-05-27": 49.24266194444445,
          "2026-05-28": 9.4332,
          "2026-06-01": 9.052391111111111
        },
        "time_count_per_day": {
          "2025-10-10": 1,
          "2025-10-20": 1,
          "2025-10-23": 3,
          "2025-10-27": 1,
          "2025-11-07": 1,
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-07": 1,
          "2026-01-08": 1,
          "2026-01-11": 1,
          "2026-01-12": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-23": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-04-07": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-16": 1,
          "2026-04-29": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 27.68,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 27.678075000000003
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        },
        "P2": {
          "avg_time_hours": 162.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 4,
            "4-6h": 1,
            "8-10h": 3,
            "10-12h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "24-26h": 1,
            "26-28h": 1,
            "32-34h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "60-62h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "106-108h": 1,
            "138-140h": 1,
            "184-186h": 1,
            "284-286h": 1,
            "304-306h": 1,
            "390-392h": 1,
            "506-508h": 1,
            "526-528h": 1,
            "576-578h": 2,
            "672-674h": 1,
            "1336-1338h": 1
          },
          "tickets_count": 43,
          "tickets_per_day": {
            "2025-10-20": 1,
            "2025-10-23": 2,
            "2025-10-27": 1,
            "2025-11-07": 1,
            "2025-12-02": 1,
            "2025-12-18": 1,
            "2026-01-08": 1,
            "2026-01-12": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-21": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-07": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-27": 1,
            "2026-05-28": 2,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-10-20": 2.86114,
            "2025-10-23": 202.83652361111112,
            "2025-10-27": 1.1264825,
            "2025-11-07": 32.073321666666665,
            "2025-12-02": 284.25434805555557,
            "2025-12-18": 61.12748805555555,
            "2026-01-08": 0.31710166666666667,
            "2026-01-12": 139.66401555555555,
            "2026-01-14": 0.2526658333333333,
            "2026-01-17": 4.41467,
            "2026-01-19": 14.777507222222221,
            "2026-01-21": 106.8501025,
            "2026-02-12": 506.0255413888889,
            "2026-02-13": 575.0450363888889,
            "2026-02-20": 51.787951944444444,
            "2026-02-23": 70.41375277777777,
            "2026-02-26": 9.455543333333333,
            "2026-03-02": 0.6003283333333332,
            "2026-03-06": 24.022974722222223,
            "2026-03-10": 3.5410066666666666,
            "2026-03-12": 17.43446888888889,
            "2026-03-20": 577.3126813888889,
            "2026-03-25": 673.4264044444444,
            "2026-04-07": 3.671943888888889,
            "2026-04-09": 1.9129694444444443,
            "2026-04-10": 391.5072916666667,
            "2026-04-16": 1337.0554869444443,
            "2026-04-29": 3.002336111111111,
            "2026-05-05": 576.4904683333333,
            "2026-05-06": 304.8362511111111,
            "2026-05-08": 73.19345777777777,
            "2026-05-19": 26.589961666666664,
            "2026-05-20": 11.011890555555555,
            "2026-05-27": 49.24266194444445,
            "2026-05-28": 9.4332,
            "2026-06-01": 9.052391111111111
          },
          "time_count_per_day": {
            "2025-10-20": 1,
            "2025-10-23": 2,
            "2025-10-27": 1,
            "2025-11-07": 1,
            "2025-12-02": 1,
            "2025-12-18": 1,
            "2026-01-08": 1,
            "2026-01-12": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-21": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-07": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-29": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 248.02,
          "mode_time_hours": 373.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "16-18h": 1,
            "32-34h": 1,
            "50-52h": 1,
            "66-68h": 1,
            "96-98h": 1,
            "268-270h": 1,
            "294-296h": 1,
            "372-374h": 1,
            "458-460h": 1,
            "1306-1308h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-10-10": 1,
            "2025-10-23": 1,
            "2025-11-17": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-11": 1,
            "2026-01-22": 1,
            "2026-01-30": 1,
            "2026-02-09": 1,
            "2026-02-19": 1,
            "2026-04-13": 1
          },
          "time_per_day": {
            "2025-10-10": 4.48264,
            "2025-10-23": 372.14559194444445,
            "2025-11-17": 97.39243111111111,
            "2025-12-09": 50.576703611111114,
            "2025-12-15": 294.2384761111111,
            "2025-12-26": 3.503107222222222,
            "2026-01-07": 459.33691666666664,
            "2026-01-11": 1307.4589775,
            "2026-01-22": 33.45699527777778,
            "2026-01-30": 269.90977055555555,
            "2026-02-09": 66.04926527777778,
            "2026-02-19": 17.644305
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-10-23": 1,
            "2025-11-17": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-11": 1,
            "2026-01-22": 1,
            "2026-01-30": 1,
            "2026-02-09": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 179.62,
            "mode_time_hours": 3.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 5,
              "4-6h": 2,
              "8-10h": 3,
              "10-12h": 1,
              "14-16h": 1,
              "16-18h": 3,
              "24-26h": 1,
              "26-28h": 2,
              "32-34h": 2,
              "46-48h": 1,
              "48-50h": 1,
              "50-52h": 2,
              "60-62h": 1,
              "66-68h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "96-98h": 1,
              "106-108h": 1,
              "138-140h": 1,
              "184-186h": 1,
              "268-270h": 1,
              "284-286h": 1,
              "294-296h": 1,
              "304-306h": 1,
              "372-374h": 1,
              "390-392h": 1,
              "458-460h": 1,
              "506-508h": 1,
              "526-528h": 1,
              "576-578h": 2,
              "672-674h": 1,
              "1306-1308h": 1,
              "1336-1338h": 1
            },
            "tickets_count": 51,
            "tickets_per_day": {
              "2025-10-10": 1,
              "2025-10-20": 1,
              "2025-10-23": 3,
              "2025-10-27": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-07": 1,
              "2026-01-08": 1,
              "2026-01-11": 1,
              "2026-01-12": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-23": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-04-07": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-16": 1,
              "2026-04-29": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-27": 1,
              "2026-05-28": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-10": 4.48264,
              "2025-10-20": 2.86114,
              "2025-10-23": 574.9821155555555,
              "2025-10-27": 1.1264825,
              "2025-11-07": 32.073321666666665,
              "2025-11-17": 97.39243111111111,
              "2025-12-02": 284.25434805555557,
              "2025-12-09": 50.576703611111114,
              "2025-12-15": 294.2384761111111,
              "2025-12-18": 61.12748805555555,
              "2025-12-26": 3.503107222222222,
              "2026-01-07": 459.33691666666664,
              "2026-01-08": 0.31710166666666667,
              "2026-01-11": 1307.4589775,
              "2026-01-12": 139.66401555555555,
              "2026-01-14": 0.2526658333333333,
              "2026-01-17": 4.41467,
              "2026-01-19": 14.777507222222221,
              "2026-01-21": 106.8501025,
              "2026-01-22": 33.45699527777778,
              "2026-01-30": 269.90977055555555,
              "2026-02-09": 66.04926527777778,
              "2026-02-12": 506.0255413888889,
              "2026-02-13": 575.0450363888889,
              "2026-02-19": 17.644305,
              "2026-02-20": 51.787951944444444,
              "2026-02-23": 70.41375277777777,
              "2026-02-26": 9.455543333333333,
              "2026-03-02": 0.6003283333333332,
              "2026-03-06": 24.022974722222223,
              "2026-03-10": 3.5410066666666666,
              "2026-03-12": 17.43446888888889,
              "2026-03-20": 577.3126813888889,
              "2026-03-25": 673.4264044444444,
              "2026-04-07": 3.671943888888889,
              "2026-04-09": 1.9129694444444443,
              "2026-04-10": 419.18536666666665,
              "2026-04-16": 1337.0554869444443,
              "2026-04-29": 3.002336111111111,
              "2026-05-05": 576.4904683333333,
              "2026-05-06": 304.8362511111111,
              "2026-05-08": 73.19345777777777,
              "2026-05-19": 26.589961666666664,
              "2026-05-20": 11.011890555555555,
              "2026-05-27": 49.24266194444445,
              "2026-05-28": 9.4332,
              "2026-06-01": 9.052391111111111
            },
            "time_count_per_day": {
              "2025-10-10": 1,
              "2025-10-20": 1,
              "2025-10-23": 3,
              "2025-10-27": 1,
              "2025-11-07": 1,
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-07": 1,
              "2026-01-08": 1,
              "2026-01-11": 1,
              "2026-01-12": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-23": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-04-07": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-16": 1,
              "2026-04-29": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-27": 1,
              "2026-05-28": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 27.68,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 27.678075000000003
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            },
            "P2": {
              "avg_time_hours": 162.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 4,
                "4-6h": 1,
                "8-10h": 3,
                "10-12h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "24-26h": 1,
                "26-28h": 1,
                "32-34h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "60-62h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "106-108h": 1,
                "138-140h": 1,
                "184-186h": 1,
                "284-286h": 1,
                "304-306h": 1,
                "390-392h": 1,
                "506-508h": 1,
                "526-528h": 1,
                "576-578h": 2,
                "672-674h": 1,
                "1336-1338h": 1
              },
              "tickets_count": 38,
              "tickets_per_day": {
                "2025-10-20": 1,
                "2025-10-23": 2,
                "2025-10-27": 1,
                "2025-11-07": 1,
                "2025-12-02": 1,
                "2025-12-18": 1,
                "2026-01-08": 1,
                "2026-01-12": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-21": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-07": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-29": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-20": 2.86114,
                "2025-10-23": 202.83652361111112,
                "2025-10-27": 1.1264825,
                "2025-11-07": 32.073321666666665,
                "2025-12-02": 284.25434805555557,
                "2025-12-18": 61.12748805555555,
                "2026-01-08": 0.31710166666666667,
                "2026-01-12": 139.66401555555555,
                "2026-01-14": 0.2526658333333333,
                "2026-01-17": 4.41467,
                "2026-01-19": 14.777507222222221,
                "2026-01-21": 106.8501025,
                "2026-02-12": 506.0255413888889,
                "2026-02-13": 575.0450363888889,
                "2026-02-20": 51.787951944444444,
                "2026-02-23": 70.41375277777777,
                "2026-02-26": 9.455543333333333,
                "2026-03-02": 0.6003283333333332,
                "2026-03-06": 24.022974722222223,
                "2026-03-10": 3.5410066666666666,
                "2026-03-12": 17.43446888888889,
                "2026-03-20": 577.3126813888889,
                "2026-03-25": 673.4264044444444,
                "2026-04-07": 3.671943888888889,
                "2026-04-09": 1.9129694444444443,
                "2026-04-10": 391.5072916666667,
                "2026-04-16": 1337.0554869444443,
                "2026-04-29": 3.002336111111111,
                "2026-05-05": 576.4904683333333,
                "2026-05-06": 304.8362511111111,
                "2026-05-08": 73.19345777777777,
                "2026-05-19": 26.589961666666664,
                "2026-05-20": 11.011890555555555,
                "2026-05-27": 49.24266194444445,
                "2026-05-28": 9.4332,
                "2026-06-01": 9.052391111111111
              },
              "time_count_per_day": {
                "2025-10-20": 1,
                "2025-10-23": 2,
                "2025-10-27": 1,
                "2025-11-07": 1,
                "2025-12-02": 1,
                "2025-12-18": 1,
                "2026-01-08": 1,
                "2026-01-12": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-21": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-20": 1,
                "2026-02-23": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-07": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-29": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 248.02,
              "mode_time_hours": 373.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "16-18h": 1,
                "32-34h": 1,
                "50-52h": 1,
                "66-68h": 1,
                "96-98h": 1,
                "268-270h": 1,
                "294-296h": 1,
                "372-374h": 1,
                "458-460h": 1,
                "1306-1308h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-11-17": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-11": 1,
                "2026-01-22": 1,
                "2026-01-30": 1,
                "2026-02-09": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-10-10": 4.48264,
                "2025-10-23": 372.14559194444445,
                "2025-11-17": 97.39243111111111,
                "2025-12-09": 50.576703611111114,
                "2025-12-15": 294.2384761111111,
                "2025-12-26": 3.503107222222222,
                "2026-01-07": 459.33691666666664,
                "2026-01-11": 1307.4589775,
                "2026-01-22": 33.45699527777778,
                "2026-01-30": 269.90977055555555,
                "2026-02-09": 66.04926527777778,
                "2026-02-19": 17.644305
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-10-23": 1,
                "2025-11-17": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-11": 1,
                "2026-01-22": 1,
                "2026-01-30": 1,
                "2026-02-09": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-04": 1,
              "2026-06-05": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-04": 1,
                "2026-06-05": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-28": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-28": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_191": {
      "overall": {
        "avg_time_hours": 96.93,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 2,
          "20-22h": 1,
          "30-32h": 1,
          "66-68h": 1,
          "68-70h": 1,
          "76-78h": 1,
          "96-98h": 1,
          "114-116h": 1,
          "162-164h": 1,
          "286-288h": 1,
          "422-424h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-10-15": 1,
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-12-09": 1,
          "2026-01-26": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-20": 2,
          "2026-04-08": 1,
          "2026-05-06": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-14": 163.1685986111111,
          "2025-10-15": 97.66009611111112,
          "2025-10-30": 20.766779999999997,
          "2025-10-31": 68.33117555555555,
          "2025-12-09": 286.42915444444446,
          "2026-01-26": 3.951330555555556,
          "2026-02-09": 66.04477944444444,
          "2026-02-10": 31.994656944444444,
          "2026-02-12": 499.0625436111111,
          "2026-02-20": 3.165283888888889,
          "2026-05-06": 1.6670066666666667,
          "2026-06-06": 114.74612583333334
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-10-15": 1,
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-12-09": 1,
          "2026-01-26": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-20": 2,
          "2026-05-06": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 73.58,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "20-22h": 1,
            "68-70h": 1,
            "114-116h": 1,
            "162-164h": 1,
            "286-288h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-30": 1,
            "2025-10-31": 1,
            "2025-12-09": 1,
            "2026-01-26": 1,
            "2026-02-20": 2,
            "2026-05-06": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-14": 163.1685986111111,
            "2025-10-30": 20.766779999999997,
            "2025-10-31": 68.33117555555555,
            "2025-12-09": 286.42915444444446,
            "2026-01-26": 3.951330555555556,
            "2026-02-20": 3.165283888888889,
            "2026-05-06": 1.6670066666666667,
            "2026-06-06": 114.74612583333334
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-30": 1,
            "2025-10-31": 1,
            "2025-12-09": 1,
            "2026-01-26": 1,
            "2026-02-20": 2,
            "2026-05-06": 1,
            "2026-06-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 138.95,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1,
            "66-68h": 1,
            "76-78h": 1,
            "96-98h": 1,
            "422-424h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-12": 2
          },
          "time_per_day": {
            "2025-10-15": 97.66009611111112,
            "2026-02-09": 66.04477944444444,
            "2026-02-10": 31.994656944444444,
            "2026-02-12": 499.0625436111111
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-12": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 96.93,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 2,
              "20-22h": 1,
              "30-32h": 1,
              "66-68h": 1,
              "68-70h": 1,
              "76-78h": 1,
              "96-98h": 1,
              "114-116h": 1,
              "162-164h": 1,
              "286-288h": 1,
              "422-424h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-10-15": 1,
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-12-09": 1,
              "2026-01-26": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-20": 2,
              "2026-05-06": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2025-10-14": 163.1685986111111,
              "2025-10-15": 97.66009611111112,
              "2025-10-30": 20.766779999999997,
              "2025-10-31": 68.33117555555555,
              "2025-12-09": 286.42915444444446,
              "2026-01-26": 3.951330555555556,
              "2026-02-09": 66.04477944444444,
              "2026-02-10": 31.994656944444444,
              "2026-02-12": 499.0625436111111,
              "2026-02-20": 3.165283888888889,
              "2026-05-06": 1.6670066666666667,
              "2026-06-06": 114.74612583333334
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-10-15": 1,
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-12-09": 1,
              "2026-01-26": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-20": 2,
              "2026-05-06": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 73.58,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "20-22h": 1,
                "68-70h": 1,
                "114-116h": 1,
                "162-164h": 1,
                "286-288h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-30": 1,
                "2025-10-31": 1,
                "2025-12-09": 1,
                "2026-01-26": 1,
                "2026-02-20": 2,
                "2026-05-06": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-14": 163.1685986111111,
                "2025-10-30": 20.766779999999997,
                "2025-10-31": 68.33117555555555,
                "2025-12-09": 286.42915444444446,
                "2026-01-26": 3.951330555555556,
                "2026-02-20": 3.165283888888889,
                "2026-05-06": 1.6670066666666667,
                "2026-06-06": 114.74612583333334
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-30": 1,
                "2025-10-31": 1,
                "2025-12-09": 1,
                "2026-01-26": 1,
                "2026-02-20": 2,
                "2026-05-06": 1,
                "2026-06-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 138.95,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1,
                "66-68h": 1,
                "76-78h": 1,
                "96-98h": 1,
                "422-424h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 2
              },
              "time_per_day": {
                "2025-10-15": 97.66009611111112,
                "2026-02-09": 66.04477944444444,
                "2026-02-10": 31.994656944444444,
                "2026-02-12": 499.0625436111111
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-12": 2
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_193": {
      "overall": {
        "avg_time_hours": 49.26,
        "mode_time_hours": 49.0,
        "mode_frequency": 1,
        "time_distribution": {
          "48-50h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-10": 1
        },
        "time_per_day": {
          "2025-10-10": 49.26151833333333
        },
        "time_count_per_day": {
          "2025-10-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 49.26,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-10": 1
          },
          "time_per_day": {
            "2025-10-10": 49.26151833333333
          },
          "time_count_per_day": {
            "2025-10-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 49.26,
            "mode_time_hours": 49.0,
            "mode_frequency": 1,
            "time_distribution": {
              "48-50h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-10": 1
            },
            "time_per_day": {
              "2025-10-10": 49.26151833333333
            },
            "time_count_per_day": {
              "2025-10-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 49.26,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-10": 1
              },
              "time_per_day": {
                "2025-10-10": 49.26151833333333
              },
              "time_count_per_day": {
                "2025-10-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_177": {
      "overall": {
        "avg_time_hours": 151.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 2,
          "4-6h": 2,
          "8-10h": 2,
          "10-12h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 3,
          "22-24h": 3,
          "24-26h": 2,
          "28-30h": 1,
          "34-36h": 1,
          "36-38h": 1,
          "40-42h": 1,
          "42-44h": 1,
          "48-50h": 1,
          "64-66h": 2,
          "70-72h": 1,
          "72-74h": 1,
          "82-84h": 1,
          "96-98h": 1,
          "102-104h": 1,
          "110-112h": 1,
          "150-152h": 1,
          "168-170h": 1,
          "186-188h": 1,
          "222-224h": 1,
          "314-316h": 1,
          "380-382h": 1,
          "382-384h": 1,
          "424-426h": 1,
          "452-454h": 1,
          "456-458h": 1,
          "548-550h": 1,
          "612-614h": 1,
          "792-794h": 1,
          "822-824h": 1,
          "1104-1106h": 1
        },
        "tickets_count": 61,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-16": 1,
          "2025-11-10": 1,
          "2025-11-13": 2,
          "2025-11-17": 2,
          "2025-11-20": 1,
          "2025-12-05": 2,
          "2025-12-13": 1,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2026-01-08": 1,
          "2026-01-10": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-21": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-02-14": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 3,
          "2026-03-23": 1,
          "2026-03-25": 1,
          "2026-03-31": 2,
          "2026-04-01": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-17": 2,
          "2026-04-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-05-04": 1,
          "2026-05-09": 1,
          "2026-05-18": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-27": 1,
          "2026-05-30": 2,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-08": 0.5448366666666666,
          "2025-10-16": 20.367943333333336,
          "2025-11-10": 0.8647333333333334,
          "2025-11-13": 20.155689444444448,
          "2025-11-17": 185.06338916666667,
          "2025-11-20": 168.1377075,
          "2025-12-05": 450.0756222222222,
          "2025-12-13": 96.20639138888889,
          "2025-12-16": 103.64789944444445,
          "2025-12-17": 37.69197805555556,
          "2025-12-18": 64.75449333333333,
          "2026-01-08": 0.2785755555555555,
          "2026-01-17": 22.196289444444446,
          "2026-01-19": 35.72121555555556,
          "2026-01-20": 4.324585277777778,
          "2026-01-21": 28.272659722222222,
          "2026-01-22": 46.86158944444445,
          "2026-01-23": 187.29651361111112,
          "2026-01-27": 288.7059194444445,
          "2026-02-14": 82.5764638888889,
          "2026-02-24": 8.464300277777777,
          "2026-02-25": 1615.4972383333334,
          "2026-03-03": 10.034376111111111,
          "2026-03-05": 549.1284011111111,
          "2026-03-12": 457.40093611111115,
          "2026-03-18": 5.059675277777777,
          "2026-03-20": 995.5704838888888,
          "2026-03-23": 21.916701944444444,
          "2026-03-25": 1.2737055555555556,
          "2026-03-31": 766.658528611111,
          "2026-04-01": 42.506989999999995,
          "2026-04-08": 2.9115488888888885,
          "2026-04-14": 174.67647333333332,
          "2026-04-17": 48.10153611111111,
          "2026-04-20": 41.26748166666667,
          "2026-04-22": 20.870995277777777,
          "2026-04-23": 382.12407722222224,
          "2026-04-28": 3.5662205555555557,
          "2026-05-04": 1104.4102933333334,
          "2026-05-20": 17.06794638888889,
          "2026-05-25": 70.89335388888888,
          "2026-05-30": 9.65088888888889,
          "2026-06-05": 0.21133027777777777
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-16": 1,
          "2025-11-10": 1,
          "2025-11-13": 2,
          "2025-11-17": 2,
          "2025-11-20": 1,
          "2025-12-05": 2,
          "2025-12-13": 1,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2026-01-08": 1,
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-21": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-02-14": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 3,
          "2026-03-23": 1,
          "2026-03-25": 1,
          "2026-03-31": 2,
          "2026-04-01": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-05-04": 1,
          "2026-05-20": 1,
          "2026-05-25": 1,
          "2026-05-30": 2,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 381.56,
          "mode_time_hours": 381.0,
          "mode_frequency": 1,
          "time_distribution": {
            "380-382h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-05-18": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2026-03-20": 381.5631197222222
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 144.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 2,
            "4-6h": 1,
            "8-10h": 2,
            "10-12h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "24-26h": 2,
            "28-30h": 1,
            "34-36h": 1,
            "36-38h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "48-50h": 1,
            "64-66h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "96-98h": 1,
            "102-104h": 1,
            "168-170h": 1,
            "186-188h": 1,
            "314-316h": 1,
            "382-384h": 1,
            "424-426h": 1,
            "452-454h": 1,
            "456-458h": 1,
            "792-794h": 1,
            "822-824h": 1,
            "1104-1106h": 1
          },
          "tickets_count": 44,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-11-10": 1,
            "2025-11-13": 2,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-12-05": 2,
            "2025-12-13": 1,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-08": 1,
            "2026-01-19": 1,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-03": 1,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-25": 1,
            "2026-03-31": 2,
            "2026-04-01": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-17": 2,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-05-04": 1,
            "2026-05-09": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-30": 2,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-08": 0.5448366666666666,
            "2025-11-10": 0.8647333333333334,
            "2025-11-13": 20.155689444444448,
            "2025-11-17": 73.49696444444444,
            "2025-11-20": 168.1377075,
            "2025-12-05": 450.0756222222222,
            "2025-12-13": 96.20639138888889,
            "2025-12-16": 103.64789944444445,
            "2025-12-17": 37.69197805555556,
            "2025-12-18": 64.75449333333333,
            "2026-01-08": 0.2785755555555555,
            "2026-01-19": 35.72121555555556,
            "2026-01-21": 28.272659722222222,
            "2026-01-23": 187.29651361111112,
            "2026-02-24": 8.464300277777777,
            "2026-02-25": 1615.4972383333334,
            "2026-03-03": 10.034376111111111,
            "2026-03-12": 457.40093611111115,
            "2026-03-18": 5.059675277777777,
            "2026-03-20": 0.9410694444444444,
            "2026-03-23": 21.916701944444444,
            "2026-03-25": 1.2737055555555556,
            "2026-03-31": 766.658528611111,
            "2026-04-01": 42.506989999999995,
            "2026-04-08": 2.9115488888888885,
            "2026-04-14": 24.010401944444446,
            "2026-04-17": 48.10153611111111,
            "2026-04-20": 41.26748166666667,
            "2026-04-22": 20.870995277777777,
            "2026-04-23": 382.12407722222224,
            "2026-04-28": 3.5662205555555557,
            "2026-05-04": 1104.4102933333334,
            "2026-05-20": 17.06794638888889,
            "2026-05-25": 70.89335388888888,
            "2026-05-30": 9.65088888888889,
            "2026-06-05": 0.21133027777777777
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-11-10": 1,
            "2025-11-13": 2,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-12-05": 2,
            "2025-12-13": 1,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-08": 1,
            "2026-01-19": 1,
            "2026-01-21": 1,
            "2026-01-23": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-03": 1,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-25": 1,
            "2026-03-31": 2,
            "2026-04-01": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-05-04": 1,
            "2026-05-20": 1,
            "2026-05-25": 1,
            "2026-05-30": 2,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 157.45,
          "mode_time_hours": 23.0,
          "mode_frequency": 3,
          "time_distribution": {
            "4-6h": 1,
            "20-22h": 1,
            "22-24h": 3,
            "64-66h": 1,
            "82-84h": 1,
            "110-112h": 1,
            "150-152h": 1,
            "222-224h": 1,
            "548-550h": 1,
            "612-614h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-10-16": 1,
            "2025-11-17": 1,
            "2026-01-10": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-01-22": 2,
            "2026-01-27": 2,
            "2026-02-14": 1,
            "2026-03-05": 1,
            "2026-03-20": 1,
            "2026-04-06": 1,
            "2026-04-14": 1
          },
          "time_per_day": {
            "2025-10-16": 20.367943333333336,
            "2025-11-17": 111.56642472222222,
            "2026-01-17": 22.196289444444446,
            "2026-01-20": 4.324585277777778,
            "2026-01-22": 46.86158944444445,
            "2026-01-27": 288.7059194444445,
            "2026-02-14": 82.5764638888889,
            "2026-03-05": 549.1284011111111,
            "2026-03-20": 613.0662947222222,
            "2026-04-14": 150.66607138888887
          },
          "time_count_per_day": {
            "2025-10-16": 1,
            "2025-11-17": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-01-22": 2,
            "2026-01-27": 2,
            "2026-02-14": 1,
            "2026-03-05": 1,
            "2026-03-20": 1,
            "2026-04-14": 1
          }
        }
      },
      "states": {
        "Aguarda Assinatura (rgpd Cvo)": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Closed": {
          "overall": {
            "avg_time_hours": 151.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 2,
              "4-6h": 2,
              "8-10h": 2,
              "10-12h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 3,
              "22-24h": 3,
              "24-26h": 2,
              "28-30h": 1,
              "34-36h": 1,
              "36-38h": 1,
              "40-42h": 1,
              "42-44h": 1,
              "48-50h": 1,
              "64-66h": 2,
              "70-72h": 1,
              "72-74h": 1,
              "82-84h": 1,
              "96-98h": 1,
              "102-104h": 1,
              "110-112h": 1,
              "150-152h": 1,
              "168-170h": 1,
              "186-188h": 1,
              "222-224h": 1,
              "314-316h": 1,
              "380-382h": 1,
              "382-384h": 1,
              "424-426h": 1,
              "452-454h": 1,
              "456-458h": 1,
              "548-550h": 1,
              "612-614h": 1,
              "792-794h": 1,
              "822-824h": 1,
              "1104-1106h": 1
            },
            "tickets_count": 54,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-16": 1,
              "2025-11-10": 1,
              "2025-11-13": 2,
              "2025-11-17": 2,
              "2025-11-20": 1,
              "2025-12-05": 2,
              "2025-12-13": 1,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-08": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-21": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-02-14": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 3,
              "2026-03-23": 1,
              "2026-03-25": 1,
              "2026-03-31": 2,
              "2026-04-01": 1,
              "2026-04-08": 1,
              "2026-04-14": 2,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-05-04": 1,
              "2026-05-20": 1,
              "2026-05-25": 1,
              "2026-05-30": 2,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-08": 0.5448366666666666,
              "2025-10-16": 20.367943333333336,
              "2025-11-10": 0.8647333333333334,
              "2025-11-13": 20.155689444444448,
              "2025-11-17": 185.06338916666667,
              "2025-11-20": 168.1377075,
              "2025-12-05": 450.0756222222222,
              "2025-12-13": 96.20639138888889,
              "2025-12-16": 103.64789944444445,
              "2025-12-17": 37.69197805555556,
              "2025-12-18": 64.75449333333333,
              "2026-01-08": 0.2785755555555555,
              "2026-01-17": 22.196289444444446,
              "2026-01-19": 35.72121555555556,
              "2026-01-20": 4.324585277777778,
              "2026-01-21": 28.272659722222222,
              "2026-01-22": 46.86158944444445,
              "2026-01-23": 187.29651361111112,
              "2026-01-27": 288.7059194444445,
              "2026-02-14": 82.5764638888889,
              "2026-02-24": 8.464300277777777,
              "2026-02-25": 1615.4972383333334,
              "2026-03-03": 10.034376111111111,
              "2026-03-05": 549.1284011111111,
              "2026-03-12": 457.40093611111115,
              "2026-03-18": 5.059675277777777,
              "2026-03-20": 995.5704838888888,
              "2026-03-23": 21.916701944444444,
              "2026-03-25": 1.2737055555555556,
              "2026-03-31": 766.658528611111,
              "2026-04-01": 42.506989999999995,
              "2026-04-08": 2.9115488888888885,
              "2026-04-14": 174.67647333333332,
              "2026-04-17": 48.10153611111111,
              "2026-04-20": 41.26748166666667,
              "2026-04-22": 20.870995277777777,
              "2026-04-23": 382.12407722222224,
              "2026-04-28": 3.5662205555555557,
              "2026-05-04": 1104.4102933333334,
              "2026-05-20": 17.06794638888889,
              "2026-05-25": 70.89335388888888,
              "2026-05-30": 9.65088888888889,
              "2026-06-05": 0.21133027777777777
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-16": 1,
              "2025-11-10": 1,
              "2025-11-13": 2,
              "2025-11-17": 2,
              "2025-11-20": 1,
              "2025-12-05": 2,
              "2025-12-13": 1,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-08": 1,
              "2026-01-17": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-21": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-02-14": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 3,
              "2026-03-23": 1,
              "2026-03-25": 1,
              "2026-03-31": 2,
              "2026-04-01": 1,
              "2026-04-08": 1,
              "2026-04-14": 2,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-05-04": 1,
              "2026-05-20": 1,
              "2026-05-25": 1,
              "2026-05-30": 2,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 381.56,
              "mode_time_hours": 381.0,
              "mode_frequency": 1,
              "time_distribution": {
                "380-382h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 381.5631197222222
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 144.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 2,
                "4-6h": 1,
                "8-10h": 2,
                "10-12h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "24-26h": 2,
                "28-30h": 1,
                "34-36h": 1,
                "36-38h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "48-50h": 1,
                "64-66h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "96-98h": 1,
                "102-104h": 1,
                "168-170h": 1,
                "186-188h": 1,
                "314-316h": 1,
                "382-384h": 1,
                "424-426h": 1,
                "452-454h": 1,
                "456-458h": 1,
                "792-794h": 1,
                "822-824h": 1,
                "1104-1106h": 1
              },
              "tickets_count": 41,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-11-10": 1,
                "2025-11-13": 2,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-12-05": 2,
                "2025-12-13": 1,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-08": 1,
                "2026-01-19": 1,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-03": 1,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-25": 1,
                "2026-03-31": 2,
                "2026-04-01": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-05-04": 1,
                "2026-05-20": 1,
                "2026-05-25": 1,
                "2026-05-30": 2,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-08": 0.5448366666666666,
                "2025-11-10": 0.8647333333333334,
                "2025-11-13": 20.155689444444448,
                "2025-11-17": 73.49696444444444,
                "2025-11-20": 168.1377075,
                "2025-12-05": 450.0756222222222,
                "2025-12-13": 96.20639138888889,
                "2025-12-16": 103.64789944444445,
                "2025-12-17": 37.69197805555556,
                "2025-12-18": 64.75449333333333,
                "2026-01-08": 0.2785755555555555,
                "2026-01-19": 35.72121555555556,
                "2026-01-21": 28.272659722222222,
                "2026-01-23": 187.29651361111112,
                "2026-02-24": 8.464300277777777,
                "2026-02-25": 1615.4972383333334,
                "2026-03-03": 10.034376111111111,
                "2026-03-12": 457.40093611111115,
                "2026-03-18": 5.059675277777777,
                "2026-03-20": 0.9410694444444444,
                "2026-03-23": 21.916701944444444,
                "2026-03-25": 1.2737055555555556,
                "2026-03-31": 766.658528611111,
                "2026-04-01": 42.506989999999995,
                "2026-04-08": 2.9115488888888885,
                "2026-04-14": 24.010401944444446,
                "2026-04-17": 48.10153611111111,
                "2026-04-20": 41.26748166666667,
                "2026-04-22": 20.870995277777777,
                "2026-04-23": 382.12407722222224,
                "2026-04-28": 3.5662205555555557,
                "2026-05-04": 1104.4102933333334,
                "2026-05-20": 17.06794638888889,
                "2026-05-25": 70.89335388888888,
                "2026-05-30": 9.65088888888889,
                "2026-06-05": 0.21133027777777777
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-11-10": 1,
                "2025-11-13": 2,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-12-05": 2,
                "2025-12-13": 1,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-08": 1,
                "2026-01-19": 1,
                "2026-01-21": 1,
                "2026-01-23": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-03": 1,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-25": 1,
                "2026-03-31": 2,
                "2026-04-01": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-05-04": 1,
                "2026-05-20": 1,
                "2026-05-25": 1,
                "2026-05-30": 2,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 157.45,
              "mode_time_hours": 23.0,
              "mode_frequency": 3,
              "time_distribution": {
                "4-6h": 1,
                "20-22h": 1,
                "22-24h": 3,
                "64-66h": 1,
                "82-84h": 1,
                "110-112h": 1,
                "150-152h": 1,
                "222-224h": 1,
                "548-550h": 1,
                "612-614h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-16": 1,
                "2025-11-17": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-01-22": 2,
                "2026-01-27": 2,
                "2026-02-14": 1,
                "2026-03-05": 1,
                "2026-03-20": 1,
                "2026-04-14": 1
              },
              "time_per_day": {
                "2025-10-16": 20.367943333333336,
                "2025-11-17": 111.56642472222222,
                "2026-01-17": 22.196289444444446,
                "2026-01-20": 4.324585277777778,
                "2026-01-22": 46.86158944444445,
                "2026-01-27": 288.7059194444445,
                "2026-02-14": 82.5764638888889,
                "2026-03-05": 549.1284011111111,
                "2026-03-20": 613.0662947222222,
                "2026-04-14": 150.66607138888887
              },
              "time_count_per_day": {
                "2025-10-16": 1,
                "2025-11-17": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-01-22": 2,
                "2026-01-27": 2,
                "2026-02-14": 1,
                "2026-03-05": 1,
                "2026-03-20": 1,
                "2026-04-14": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-18": 1,
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-18": 1,
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-06": 1,
              "2026-04-17": 1,
              "2026-05-09": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-05-09": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_194": {
      "overall": {
        "avg_time_hours": 64.61,
        "mode_time_hours": 27.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 1,
          "20-22h": 1,
          "26-28h": 2,
          "142-144h": 1,
          "164-166h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-10-09": 1,
          "2025-12-02": 1,
          "2026-01-15": 1,
          "2026-02-10": 1,
          "2026-04-07": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-10-09": 26.70754388888889,
          "2025-12-02": 164.0226002777778,
          "2026-01-15": 26.4542825,
          "2026-02-10": 143.11292194444442,
          "2026-04-07": 5.869374722222222,
          "2026-05-27": 21.48834638888889
        },
        "time_count_per_day": {
          "2025-10-09": 1,
          "2025-12-02": 1,
          "2026-01-15": 1,
          "2026-02-10": 1,
          "2026-04-07": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 83.62,
          "mode_time_hours": 165.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "20-22h": 1,
            "142-144h": 1,
            "164-166h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-10": 1,
            "2026-04-07": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2025-12-02": 164.0226002777778,
            "2026-02-10": 143.11292194444442,
            "2026-04-07": 5.869374722222222,
            "2026-05-27": 21.48834638888889
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-10": 1,
            "2026-04-07": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 26.58,
          "mode_time_hours": 27.0,
          "mode_frequency": 2,
          "time_distribution": {
            "26-28h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2026-01-15": 1
          },
          "time_per_day": {
            "2025-10-09": 26.70754388888889,
            "2026-01-15": 26.4542825
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 64.61,
            "mode_time_hours": 27.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 1,
              "20-22h": 1,
              "26-28h": 2,
              "142-144h": 1,
              "164-166h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-09": 1,
              "2025-12-02": 1,
              "2026-01-15": 1,
              "2026-02-10": 1,
              "2026-04-07": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-10-09": 26.70754388888889,
              "2025-12-02": 164.0226002777778,
              "2026-01-15": 26.4542825,
              "2026-02-10": 143.11292194444442,
              "2026-04-07": 5.869374722222222,
              "2026-05-27": 21.48834638888889
            },
            "time_count_per_day": {
              "2025-10-09": 1,
              "2025-12-02": 1,
              "2026-01-15": 1,
              "2026-02-10": 1,
              "2026-04-07": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 83.62,
              "mode_time_hours": 165.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "20-22h": 1,
                "142-144h": 1,
                "164-166h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-10": 1,
                "2026-04-07": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2025-12-02": 164.0226002777778,
                "2026-02-10": 143.11292194444442,
                "2026-04-07": 5.869374722222222,
                "2026-05-27": 21.48834638888889
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-10": 1,
                "2026-04-07": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 26.58,
              "mode_time_hours": 27.0,
              "mode_frequency": 2,
              "time_distribution": {
                "26-28h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2026-01-15": 1
              },
              "time_per_day": {
                "2025-10-09": 26.70754388888889,
                "2026-01-15": 26.4542825
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_195": {
      "overall": {
        "avg_time_hours": 1.51,
        "mode_time_hours": 1.0,
        "mode_frequency": 48,
        "time_distribution": {
          "0-2h": 48,
          "2-4h": 10,
          "4-6h": 2,
          "6-8h": 4
        },
        "tickets_count": 64,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-11-28": 1,
          "2025-12-31": 1,
          "2026-01-04": 2,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-18": 1,
          "2026-02-25": 2,
          "2026-03-03": 1,
          "2026-03-16": 1,
          "2026-03-17": 4,
          "2026-03-18": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-14": 2,
          "2026-04-20": 4,
          "2026-04-21": 2,
          "2026-04-22": 1,
          "2026-04-28": 2,
          "2026-05-04": 7,
          "2026-05-06": 1,
          "2026-05-11": 4,
          "2026-05-12": 3,
          "2026-05-18": 2,
          "2026-05-25": 3,
          "2026-05-26": 1,
          "2026-05-30": 2,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-08": 3
        },
        "time_per_day": {
          "2025-10-08": 1.4596022222222222,
          "2025-11-28": 2.8557116666666666,
          "2025-12-31": 0.38752777777777775,
          "2026-01-04": 0.23874944444444446,
          "2026-01-19": 3.4674333333333336,
          "2026-01-20": 1.2014874999999998,
          "2026-01-26": 0.3887333333333334,
          "2026-01-28": 6.468841944444444,
          "2026-02-18": 1.916851111111111,
          "2026-02-25": 9.137766944444444,
          "2026-03-03": 4.383358055555555,
          "2026-03-16": 2.2782805555555554,
          "2026-03-17": 1.4325636111111113,
          "2026-03-18": 0.6928316666666666,
          "2026-03-30": 2.269997222222222,
          "2026-03-31": 0.3931219444444444,
          "2026-04-06": 5.271523333333333,
          "2026-04-07": 6.71611,
          "2026-04-14": 11.38933777777778,
          "2026-04-20": 4.256204166666667,
          "2026-04-21": 0.0657275,
          "2026-04-22": 0.009058055555555555,
          "2026-04-28": 2.485764722222222,
          "2026-05-04": 9.449581666666667,
          "2026-05-06": 0.2547225,
          "2026-05-11": 4.344014166666667,
          "2026-05-12": 7.717327777777777,
          "2026-05-18": 0.4109405555555556,
          "2026-05-25": 2.1102672222222223,
          "2026-05-26": 0.3159038888888889,
          "2026-05-30": 0.2634447222222222,
          "2026-06-01": 0.11434666666666668,
          "2026-06-02": 0.3819591666666667,
          "2026-06-08": 2.2410791666666667
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-11-28": 1,
          "2025-12-31": 1,
          "2026-01-04": 2,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-18": 1,
          "2026-02-25": 2,
          "2026-03-03": 1,
          "2026-03-16": 1,
          "2026-03-17": 4,
          "2026-03-18": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-14": 2,
          "2026-04-20": 4,
          "2026-04-21": 2,
          "2026-04-22": 1,
          "2026-04-28": 2,
          "2026-05-04": 7,
          "2026-05-06": 1,
          "2026-05-11": 4,
          "2026-05-12": 3,
          "2026-05-18": 2,
          "2026-05-25": 3,
          "2026-05-26": 1,
          "2026-05-30": 2,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-08": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 46,
          "time_distribution": {
            "0-2h": 46,
            "2-4h": 8,
            "4-6h": 2,
            "6-8h": 4
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-12-31": 1,
            "2026-01-04": 2,
            "2026-01-20": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-25": 2,
            "2026-03-03": 1,
            "2026-03-16": 1,
            "2026-03-17": 4,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-14": 2,
            "2026-04-20": 4,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-28": 2,
            "2026-05-04": 7,
            "2026-05-06": 1,
            "2026-05-11": 4,
            "2026-05-12": 3,
            "2026-05-18": 2,
            "2026-05-25": 3,
            "2026-05-26": 1,
            "2026-05-30": 2,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-08": 3
          },
          "time_per_day": {
            "2025-12-31": 0.38752777777777775,
            "2026-01-04": 0.23874944444444446,
            "2026-01-20": 1.2014874999999998,
            "2026-01-26": 0.3887333333333334,
            "2026-01-28": 6.468841944444444,
            "2026-02-18": 1.916851111111111,
            "2026-02-25": 9.137766944444444,
            "2026-03-03": 4.383358055555555,
            "2026-03-16": 2.2782805555555554,
            "2026-03-17": 1.4325636111111113,
            "2026-03-30": 2.269997222222222,
            "2026-03-31": 0.3931219444444444,
            "2026-04-06": 5.271523333333333,
            "2026-04-07": 6.71611,
            "2026-04-14": 11.38933777777778,
            "2026-04-20": 4.256204166666667,
            "2026-04-21": 0.0657275,
            "2026-04-22": 0.009058055555555555,
            "2026-04-28": 2.485764722222222,
            "2026-05-04": 9.449581666666667,
            "2026-05-06": 0.2547225,
            "2026-05-11": 4.344014166666667,
            "2026-05-12": 7.717327777777777,
            "2026-05-18": 0.4109405555555556,
            "2026-05-25": 2.1102672222222223,
            "2026-05-26": 0.3159038888888889,
            "2026-05-30": 0.2634447222222222,
            "2026-06-01": 0.11434666666666668,
            "2026-06-02": 0.3819591666666667,
            "2026-06-08": 2.2410791666666667
          },
          "time_count_per_day": {
            "2025-12-31": 1,
            "2026-01-04": 2,
            "2026-01-20": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-25": 2,
            "2026-03-03": 1,
            "2026-03-16": 1,
            "2026-03-17": 4,
            "2026-03-30": 2,
            "2026-03-31": 1,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-14": 2,
            "2026-04-20": 4,
            "2026-04-21": 2,
            "2026-04-22": 1,
            "2026-04-28": 2,
            "2026-05-04": 7,
            "2026-05-06": 1,
            "2026-05-11": 4,
            "2026-05-12": 3,
            "2026-05-18": 2,
            "2026-05-25": 3,
            "2026-05-26": 1,
            "2026-05-30": 2,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-08": 3
          }
        },
        "P3": {
          "avg_time_hours": 2.59,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-11-28": 1,
            "2026-01-19": 1
          },
          "time_per_day": {
            "2025-10-08": 1.4596022222222222,
            "2025-11-28": 2.8557116666666666,
            "2026-01-19": 3.4674333333333336
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-11-28": 1,
            "2026-01-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 0.69,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 0.6928316666666666
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.51,
            "mode_time_hours": 1.0,
            "mode_frequency": 48,
            "time_distribution": {
              "0-2h": 48,
              "2-4h": 10,
              "4-6h": 2,
              "6-8h": 4
            },
            "tickets_count": 64,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-11-28": 1,
              "2025-12-31": 1,
              "2026-01-04": 2,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-18": 1,
              "2026-02-25": 2,
              "2026-03-03": 1,
              "2026-03-16": 1,
              "2026-03-17": 4,
              "2026-03-18": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-14": 2,
              "2026-04-20": 4,
              "2026-04-21": 2,
              "2026-04-22": 1,
              "2026-04-28": 2,
              "2026-05-04": 7,
              "2026-05-06": 1,
              "2026-05-11": 4,
              "2026-05-12": 3,
              "2026-05-18": 2,
              "2026-05-25": 3,
              "2026-05-26": 1,
              "2026-05-30": 2,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-08": 3
            },
            "time_per_day": {
              "2025-10-08": 1.4596022222222222,
              "2025-11-28": 2.8557116666666666,
              "2025-12-31": 0.38752777777777775,
              "2026-01-04": 0.23874944444444446,
              "2026-01-19": 3.4674333333333336,
              "2026-01-20": 1.2014874999999998,
              "2026-01-26": 0.3887333333333334,
              "2026-01-28": 6.468841944444444,
              "2026-02-18": 1.916851111111111,
              "2026-02-25": 9.137766944444444,
              "2026-03-03": 4.383358055555555,
              "2026-03-16": 2.2782805555555554,
              "2026-03-17": 1.4325636111111113,
              "2026-03-18": 0.6928316666666666,
              "2026-03-30": 2.269997222222222,
              "2026-03-31": 0.3931219444444444,
              "2026-04-06": 5.271523333333333,
              "2026-04-07": 6.71611,
              "2026-04-14": 11.38933777777778,
              "2026-04-20": 4.256204166666667,
              "2026-04-21": 0.0657275,
              "2026-04-22": 0.009058055555555555,
              "2026-04-28": 2.485764722222222,
              "2026-05-04": 9.449581666666667,
              "2026-05-06": 0.2547225,
              "2026-05-11": 4.344014166666667,
              "2026-05-12": 7.717327777777777,
              "2026-05-18": 0.4109405555555556,
              "2026-05-25": 2.1102672222222223,
              "2026-05-26": 0.3159038888888889,
              "2026-05-30": 0.2634447222222222,
              "2026-06-01": 0.11434666666666668,
              "2026-06-02": 0.3819591666666667,
              "2026-06-08": 2.2410791666666667
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-11-28": 1,
              "2025-12-31": 1,
              "2026-01-04": 2,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-18": 1,
              "2026-02-25": 2,
              "2026-03-03": 1,
              "2026-03-16": 1,
              "2026-03-17": 4,
              "2026-03-18": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-14": 2,
              "2026-04-20": 4,
              "2026-04-21": 2,
              "2026-04-22": 1,
              "2026-04-28": 2,
              "2026-05-04": 7,
              "2026-05-06": 1,
              "2026-05-11": 4,
              "2026-05-12": 3,
              "2026-05-18": 2,
              "2026-05-25": 3,
              "2026-05-26": 1,
              "2026-05-30": 2,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-08": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 46,
              "time_distribution": {
                "0-2h": 46,
                "2-4h": 8,
                "4-6h": 2,
                "6-8h": 4
              },
              "tickets_count": 60,
              "tickets_per_day": {
                "2025-12-31": 1,
                "2026-01-04": 2,
                "2026-01-20": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-25": 2,
                "2026-03-03": 1,
                "2026-03-16": 1,
                "2026-03-17": 4,
                "2026-03-30": 2,
                "2026-03-31": 1,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-14": 2,
                "2026-04-20": 4,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-28": 2,
                "2026-05-04": 7,
                "2026-05-06": 1,
                "2026-05-11": 4,
                "2026-05-12": 3,
                "2026-05-18": 2,
                "2026-05-25": 3,
                "2026-05-26": 1,
                "2026-05-30": 2,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-08": 3
              },
              "time_per_day": {
                "2025-12-31": 0.38752777777777775,
                "2026-01-04": 0.23874944444444446,
                "2026-01-20": 1.2014874999999998,
                "2026-01-26": 0.3887333333333334,
                "2026-01-28": 6.468841944444444,
                "2026-02-18": 1.916851111111111,
                "2026-02-25": 9.137766944444444,
                "2026-03-03": 4.383358055555555,
                "2026-03-16": 2.2782805555555554,
                "2026-03-17": 1.4325636111111113,
                "2026-03-30": 2.269997222222222,
                "2026-03-31": 0.3931219444444444,
                "2026-04-06": 5.271523333333333,
                "2026-04-07": 6.71611,
                "2026-04-14": 11.38933777777778,
                "2026-04-20": 4.256204166666667,
                "2026-04-21": 0.0657275,
                "2026-04-22": 0.009058055555555555,
                "2026-04-28": 2.485764722222222,
                "2026-05-04": 9.449581666666667,
                "2026-05-06": 0.2547225,
                "2026-05-11": 4.344014166666667,
                "2026-05-12": 7.717327777777777,
                "2026-05-18": 0.4109405555555556,
                "2026-05-25": 2.1102672222222223,
                "2026-05-26": 0.3159038888888889,
                "2026-05-30": 0.2634447222222222,
                "2026-06-01": 0.11434666666666668,
                "2026-06-02": 0.3819591666666667,
                "2026-06-08": 2.2410791666666667
              },
              "time_count_per_day": {
                "2025-12-31": 1,
                "2026-01-04": 2,
                "2026-01-20": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-25": 2,
                "2026-03-03": 1,
                "2026-03-16": 1,
                "2026-03-17": 4,
                "2026-03-30": 2,
                "2026-03-31": 1,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-14": 2,
                "2026-04-20": 4,
                "2026-04-21": 2,
                "2026-04-22": 1,
                "2026-04-28": 2,
                "2026-05-04": 7,
                "2026-05-06": 1,
                "2026-05-11": 4,
                "2026-05-12": 3,
                "2026-05-18": 2,
                "2026-05-25": 3,
                "2026-05-26": 1,
                "2026-05-30": 2,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-08": 3
              }
            },
            "P3": {
              "avg_time_hours": 2.59,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-11-28": 1,
                "2026-01-19": 1
              },
              "time_per_day": {
                "2025-10-08": 1.4596022222222222,
                "2025-11-28": 2.8557116666666666,
                "2026-01-19": 3.4674333333333336
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-11-28": 1,
                "2026-01-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 0.69,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 0.6928316666666666
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_196": {
      "overall": {
        "avg_time_hours": 415.64,
        "mode_time_hours": 659.0,
        "mode_frequency": 1,
        "time_distribution": {
          "172-174h": 1,
          "658-660h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-04": 1
        },
        "time_per_day": {
          "2025-10-29": 172.11074916666666,
          "2025-11-04": 659.1748155555556
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-11-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 415.64,
          "mode_time_hours": 659.0,
          "mode_frequency": 1,
          "time_distribution": {
            "172-174h": 1,
            "658-660h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-10-29": 172.11074916666666,
            "2025-11-04": 659.1748155555556
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 415.64,
            "mode_time_hours": 659.0,
            "mode_frequency": 1,
            "time_distribution": {
              "172-174h": 1,
              "658-660h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-11-04": 1
            },
            "time_per_day": {
              "2025-10-29": 172.11074916666666,
              "2025-11-04": 659.1748155555556
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-11-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 415.64,
              "mode_time_hours": 659.0,
              "mode_frequency": 1,
              "time_distribution": {
                "172-174h": 1,
                "658-660h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-10-29": 172.11074916666666,
                "2025-11-04": 659.1748155555556
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-11-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_197": {
      "overall": {
        "avg_time_hours": 177.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 1,
          "6-8h": 3,
          "8-10h": 3,
          "10-12h": 1,
          "14-16h": 1,
          "16-18h": 2,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 4,
          "26-28h": 2,
          "30-32h": 2,
          "36-38h": 2,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 2,
          "44-46h": 1,
          "50-52h": 2,
          "52-54h": 1,
          "54-56h": 1,
          "60-62h": 4,
          "64-66h": 1,
          "78-80h": 2,
          "86-88h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "102-104h": 1,
          "122-124h": 2,
          "132-134h": 1,
          "134-136h": 1,
          "148-150h": 1,
          "192-194h": 1,
          "194-196h": 1,
          "196-198h": 1,
          "206-208h": 1,
          "208-210h": 3,
          "210-212h": 1,
          "220-222h": 1,
          "242-244h": 1,
          "262-264h": 1,
          "350-352h": 1,
          "362-364h": 1,
          "380-382h": 1,
          "388-390h": 1,
          "406-408h": 1,
          "454-456h": 2,
          "520-522h": 1,
          "526-528h": 2,
          "626-628h": 1,
          "1008-1010h": 1,
          "1906-1908h": 1,
          "2044-2046h": 1
        },
        "tickets_count": 92,
        "tickets_per_day": {
          "2025-10-11": 1,
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-07": 1,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-12-02": 1,
          "2025-12-12": 2,
          "2025-12-15": 5,
          "2025-12-22": 1,
          "2026-01-05": 1,
          "2026-01-08": 3,
          "2026-01-09": 1,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-27": 4,
          "2026-01-28": 2,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-03": 5,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-07": 2,
          "2026-02-10": 1,
          "2026-02-11": 1,
          "2026-02-12": 3,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-06": 2,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-03-25": 1,
          "2026-03-30": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-13": 1,
          "2026-04-14": 2,
          "2026-04-15": 2,
          "2026-04-22": 5,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-05-02": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-14": 1,
          "2026-05-20": 3,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-10-11": 78.01724444444444,
          "2025-10-23": 52.851726944444444,
          "2025-10-27": 149.67193166666667,
          "2025-11-05": 8.439625555555555,
          "2025-11-06": 55.167673055555554,
          "2025-11-07": 123.20894444444444,
          "2025-11-13": 42.273335555555555,
          "2025-11-19": 78.5312786111111,
          "2025-12-02": 263.55440416666664,
          "2025-12-12": 0.43177194444444444,
          "2025-12-15": 147.68661194444445,
          "2025-12-22": 45.8481175,
          "2026-01-05": 626.6618880555556,
          "2026-01-08": 159.72170222222223,
          "2026-01-09": 1009.0348347222222,
          "2026-01-14": 31.003383055555556,
          "2026-01-15": 26.307479444444446,
          "2026-01-16": 42.94725888888889,
          "2026-01-19": 122.96122027777778,
          "2026-01-22": 51.261249444444445,
          "2026-01-23": 40.738794722222224,
          "2026-01-24": 105.81798583333332,
          "2026-01-27": 147.8156377777778,
          "2026-01-28": 12.680081666666666,
          "2026-01-30": 7.86182361111111,
          "2026-01-31": 23.26577138888889,
          "2026-02-03": 221.75839222222223,
          "2026-02-04": 132.95393194444446,
          "2026-02-06": 243.53805027777778,
          "2026-02-07": 82.7911986111111,
          "2026-02-10": 135.06654666666668,
          "2026-02-12": 2615.5042763888887,
          "2026-02-16": 0.9786758333333334,
          "2026-02-24": 526.612885,
          "2026-02-25": 208.56393472222223,
          "2026-03-02": 210.25413027777776,
          "2026-03-05": 527.1423580555555,
          "2026-03-06": 0.6528555555555555,
          "2026-03-17": 11.590754722222222,
          "2026-03-18": 908.1002611111112,
          "2026-03-25": 388.84665611111114,
          "2026-03-30": 92.74866138888888,
          "2026-04-09": 38.03785638888889,
          "2026-04-10": 1907.3156655555554,
          "2026-04-13": 1.8807783333333332,
          "2026-04-14": 363.9359575,
          "2026-04-15": 96.54103500000001,
          "2026-04-22": 1018.0273958333333,
          "2026-04-23": 0.4126152777777778,
          "2026-05-04": 407.57371666666666,
          "2026-05-05": 520.3195675,
          "2026-05-14": 381.45066194444445,
          "2026-05-20": 38.32821305555556,
          "2026-06-02": 192.95005916666668
        },
        "time_count_per_day": {
          "2025-10-11": 1,
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-07": 1,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-12-02": 1,
          "2025-12-12": 2,
          "2025-12-15": 5,
          "2025-12-22": 1,
          "2026-01-05": 1,
          "2026-01-08": 3,
          "2026-01-09": 1,
          "2026-01-14": 2,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-27": 4,
          "2026-01-28": 2,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-03": 5,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-07": 2,
          "2026-02-10": 1,
          "2026-02-12": 3,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-06": 2,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-03-25": 1,
          "2026-03-30": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-13": 1,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-22": 5,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-14": 1,
          "2026-05-20": 2,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 90.09,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "52-54h": 1,
            "96-98h": 1,
            "192-194h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2026-04-15": 1,
            "2026-05-20": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-10-23": 52.851726944444444,
            "2026-04-15": 96.54103500000001,
            "2026-05-20": 18.01931,
            "2026-06-02": 192.95005916666668
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2026-04-15": 1,
            "2026-05-20": 1,
            "2026-06-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 225.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "6-8h": 1,
            "8-10h": 1,
            "20-22h": 1,
            "38-40h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "54-56h": 1,
            "78-80h": 2,
            "134-136h": 1,
            "148-150h": 1,
            "208-210h": 1,
            "210-212h": 1,
            "350-352h": 1,
            "362-364h": 1,
            "380-382h": 1,
            "388-390h": 1,
            "406-408h": 1,
            "520-522h": 1,
            "526-528h": 1,
            "1008-1010h": 1,
            "1906-1908h": 1
          },
          "tickets_count": 34,
          "tickets_per_day": {
            "2025-10-11": 1,
            "2025-10-27": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-19": 1,
            "2025-12-12": 2,
            "2025-12-22": 1,
            "2026-01-09": 1,
            "2026-01-16": 2,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-06": 2,
            "2026-03-25": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-13": 1,
            "2026-04-14": 2,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-14": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2025-10-11": 78.01724444444444,
            "2025-10-27": 149.67193166666667,
            "2025-11-05": 8.439625555555555,
            "2025-11-06": 55.167673055555554,
            "2025-11-19": 78.5312786111111,
            "2025-12-12": 0.43177194444444444,
            "2025-12-22": 45.8481175,
            "2026-01-09": 1009.0348347222222,
            "2026-01-16": 42.94725888888889,
            "2026-01-23": 40.738794722222224,
            "2026-01-30": 7.86182361111111,
            "2026-02-10": 135.06654666666668,
            "2026-02-12": 350.1037711111111,
            "2026-02-16": 0.9786758333333334,
            "2026-02-24": 526.612885,
            "2026-02-25": 208.56393472222223,
            "2026-03-02": 210.25413027777776,
            "2026-03-06": 0.6528555555555555,
            "2026-03-25": 388.84665611111114,
            "2026-04-09": 38.03785638888889,
            "2026-04-10": 1907.3156655555554,
            "2026-04-13": 1.8807783333333332,
            "2026-04-14": 363.9359575,
            "2026-04-23": 0.4126152777777778,
            "2026-05-04": 407.57371666666666,
            "2026-05-05": 520.3195675,
            "2026-05-14": 381.45066194444445,
            "2026-05-20": 20.308903055555557
          },
          "time_count_per_day": {
            "2025-10-11": 1,
            "2025-10-27": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-19": 1,
            "2025-12-12": 2,
            "2025-12-22": 1,
            "2026-01-09": 1,
            "2026-01-16": 1,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-06": 2,
            "2026-03-25": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-13": 1,
            "2026-04-14": 2,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-14": 1,
            "2026-05-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 167.22,
          "mode_time_hours": 61.0,
          "mode_frequency": 4,
          "time_distribution": {
            "6-8h": 2,
            "8-10h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "18-20h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "30-32h": 2,
            "36-38h": 2,
            "42-44h": 1,
            "50-52h": 1,
            "60-62h": 4,
            "64-66h": 1,
            "86-88h": 1,
            "122-124h": 1,
            "262-264h": 1,
            "526-528h": 1,
            "626-628h": 1,
            "2044-2046h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2025-11-07": 1,
            "2025-11-13": 1,
            "2025-12-02": 1,
            "2026-01-05": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-19": 2,
            "2026-01-22": 1,
            "2026-01-27": 4,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-03": 5,
            "2026-02-07": 2,
            "2026-02-12": 1,
            "2026-03-05": 1,
            "2026-04-07": 1
          },
          "time_per_day": {
            "2025-11-07": 123.20894444444444,
            "2025-11-13": 42.273335555555555,
            "2025-12-02": 263.55440416666664,
            "2026-01-05": 626.6618880555556,
            "2026-01-14": 31.003383055555556,
            "2026-01-15": 26.307479444444446,
            "2026-01-19": 122.96122027777778,
            "2026-01-22": 51.261249444444445,
            "2026-01-27": 147.8156377777778,
            "2026-01-28": 12.680081666666666,
            "2026-01-31": 23.26577138888889,
            "2026-02-03": 221.75839222222223,
            "2026-02-07": 82.7911986111111,
            "2026-02-12": 2045.154964722222,
            "2026-03-05": 527.1423580555555
          },
          "time_count_per_day": {
            "2025-11-07": 1,
            "2025-11-13": 1,
            "2025-12-02": 1,
            "2026-01-05": 1,
            "2026-01-14": 2,
            "2026-01-15": 1,
            "2026-01-19": 2,
            "2026-01-22": 1,
            "2026-01-27": 4,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-03": 5,
            "2026-02-07": 2,
            "2026-02-12": 1,
            "2026-03-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 138.2,
          "mode_time_hours": 25.0,
          "mode_frequency": 4,
          "time_distribution": {
            "2-4h": 1,
            "8-10h": 1,
            "10-12h": 1,
            "24-26h": 4,
            "26-28h": 1,
            "50-52h": 1,
            "92-94h": 1,
            "102-104h": 1,
            "122-124h": 1,
            "132-134h": 1,
            "194-196h": 1,
            "196-198h": 1,
            "206-208h": 1,
            "208-210h": 2,
            "220-222h": 1,
            "242-244h": 1,
            "454-456h": 2
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-12-15": 5,
            "2026-01-08": 3,
            "2026-01-24": 2,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-30": 1,
            "2026-04-15": 1,
            "2026-04-22": 5,
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2025-12-15": 147.68661194444445,
            "2026-01-08": 159.72170222222223,
            "2026-01-24": 105.81798583333332,
            "2026-02-04": 132.95393194444446,
            "2026-02-06": 243.53805027777778,
            "2026-02-12": 220.24554055555555,
            "2026-03-17": 11.590754722222222,
            "2026-03-18": 908.1002611111112,
            "2026-03-30": 92.74866138888888,
            "2026-04-22": 1018.0273958333333
          },
          "time_count_per_day": {
            "2025-12-15": 5,
            "2026-01-08": 3,
            "2026-01-24": 2,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-30": 1,
            "2026-04-22": 5
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-11": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 177.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 1,
              "6-8h": 3,
              "8-10h": 3,
              "10-12h": 1,
              "14-16h": 1,
              "16-18h": 2,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 4,
              "26-28h": 2,
              "30-32h": 2,
              "36-38h": 2,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 2,
              "44-46h": 1,
              "50-52h": 2,
              "52-54h": 1,
              "54-56h": 1,
              "60-62h": 4,
              "64-66h": 1,
              "78-80h": 2,
              "86-88h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "102-104h": 1,
              "122-124h": 2,
              "132-134h": 1,
              "134-136h": 1,
              "148-150h": 1,
              "192-194h": 1,
              "194-196h": 1,
              "196-198h": 1,
              "206-208h": 1,
              "208-210h": 3,
              "210-212h": 1,
              "220-222h": 1,
              "242-244h": 1,
              "262-264h": 1,
              "350-352h": 1,
              "362-364h": 1,
              "380-382h": 1,
              "388-390h": 1,
              "406-408h": 1,
              "454-456h": 2,
              "520-522h": 1,
              "526-528h": 2,
              "626-628h": 1,
              "1008-1010h": 1,
              "1906-1908h": 1,
              "2044-2046h": 1
            },
            "tickets_count": 83,
            "tickets_per_day": {
              "2025-10-11": 1,
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-07": 1,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-12-02": 1,
              "2025-12-12": 2,
              "2025-12-15": 5,
              "2025-12-22": 1,
              "2026-01-05": 1,
              "2026-01-08": 3,
              "2026-01-09": 1,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-27": 4,
              "2026-01-28": 2,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-03": 5,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-07": 2,
              "2026-02-10": 1,
              "2026-02-12": 3,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-06": 2,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-03-25": 1,
              "2026-03-30": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-13": 1,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-22": 5,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-14": 1,
              "2026-05-20": 2,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-10-11": 78.01724444444444,
              "2025-10-23": 52.851726944444444,
              "2025-10-27": 149.67193166666667,
              "2025-11-05": 8.439625555555555,
              "2025-11-06": 55.167673055555554,
              "2025-11-07": 123.20894444444444,
              "2025-11-13": 42.273335555555555,
              "2025-11-19": 78.5312786111111,
              "2025-12-02": 263.55440416666664,
              "2025-12-12": 0.43177194444444444,
              "2025-12-15": 147.68661194444445,
              "2025-12-22": 45.8481175,
              "2026-01-05": 626.6618880555556,
              "2026-01-08": 159.72170222222223,
              "2026-01-09": 1009.0348347222222,
              "2026-01-14": 31.003383055555556,
              "2026-01-15": 26.307479444444446,
              "2026-01-16": 42.94725888888889,
              "2026-01-19": 122.96122027777778,
              "2026-01-22": 51.261249444444445,
              "2026-01-23": 40.738794722222224,
              "2026-01-24": 105.81798583333332,
              "2026-01-27": 147.8156377777778,
              "2026-01-28": 12.680081666666666,
              "2026-01-30": 7.86182361111111,
              "2026-01-31": 23.26577138888889,
              "2026-02-03": 221.75839222222223,
              "2026-02-04": 132.95393194444446,
              "2026-02-06": 243.53805027777778,
              "2026-02-07": 82.7911986111111,
              "2026-02-10": 135.06654666666668,
              "2026-02-12": 2615.5042763888887,
              "2026-02-16": 0.9786758333333334,
              "2026-02-24": 526.612885,
              "2026-02-25": 208.56393472222223,
              "2026-03-02": 210.25413027777776,
              "2026-03-05": 527.1423580555555,
              "2026-03-06": 0.6528555555555555,
              "2026-03-17": 11.590754722222222,
              "2026-03-18": 908.1002611111112,
              "2026-03-25": 388.84665611111114,
              "2026-03-30": 92.74866138888888,
              "2026-04-09": 38.03785638888889,
              "2026-04-10": 1907.3156655555554,
              "2026-04-13": 1.8807783333333332,
              "2026-04-14": 363.9359575,
              "2026-04-15": 96.54103500000001,
              "2026-04-22": 1018.0273958333333,
              "2026-04-23": 0.4126152777777778,
              "2026-05-04": 407.57371666666666,
              "2026-05-05": 520.3195675,
              "2026-05-14": 381.45066194444445,
              "2026-05-20": 38.32821305555556,
              "2026-06-02": 192.95005916666668
            },
            "time_count_per_day": {
              "2025-10-11": 1,
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-07": 1,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-12-02": 1,
              "2025-12-12": 2,
              "2025-12-15": 5,
              "2025-12-22": 1,
              "2026-01-05": 1,
              "2026-01-08": 3,
              "2026-01-09": 1,
              "2026-01-14": 2,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-27": 4,
              "2026-01-28": 2,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-03": 5,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-07": 2,
              "2026-02-10": 1,
              "2026-02-12": 3,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-02-25": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-06": 2,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-03-25": 1,
              "2026-03-30": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-13": 1,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-22": 5,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-14": 1,
              "2026-05-20": 2,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 90.09,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "52-54h": 1,
                "96-98h": 1,
                "192-194h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2026-04-15": 1,
                "2026-05-20": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-23": 52.851726944444444,
                "2026-04-15": 96.54103500000001,
                "2026-05-20": 18.01931,
                "2026-06-02": 192.95005916666668
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2026-04-15": 1,
                "2026-05-20": 1,
                "2026-06-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 225.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "6-8h": 1,
                "8-10h": 1,
                "20-22h": 1,
                "38-40h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "54-56h": 1,
                "78-80h": 2,
                "134-136h": 1,
                "148-150h": 1,
                "208-210h": 1,
                "210-212h": 1,
                "350-352h": 1,
                "362-364h": 1,
                "380-382h": 1,
                "388-390h": 1,
                "406-408h": 1,
                "520-522h": 1,
                "526-528h": 1,
                "1008-1010h": 1,
                "1906-1908h": 1
              },
              "tickets_count": 31,
              "tickets_per_day": {
                "2025-10-11": 1,
                "2025-10-27": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-19": 1,
                "2025-12-12": 2,
                "2025-12-22": 1,
                "2026-01-09": 1,
                "2026-01-16": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-06": 2,
                "2026-03-25": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-13": 1,
                "2026-04-14": 2,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-14": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2025-10-11": 78.01724444444444,
                "2025-10-27": 149.67193166666667,
                "2025-11-05": 8.439625555555555,
                "2025-11-06": 55.167673055555554,
                "2025-11-19": 78.5312786111111,
                "2025-12-12": 0.43177194444444444,
                "2025-12-22": 45.8481175,
                "2026-01-09": 1009.0348347222222,
                "2026-01-16": 42.94725888888889,
                "2026-01-23": 40.738794722222224,
                "2026-01-30": 7.86182361111111,
                "2026-02-10": 135.06654666666668,
                "2026-02-12": 350.1037711111111,
                "2026-02-16": 0.9786758333333334,
                "2026-02-24": 526.612885,
                "2026-02-25": 208.56393472222223,
                "2026-03-02": 210.25413027777776,
                "2026-03-06": 0.6528555555555555,
                "2026-03-25": 388.84665611111114,
                "2026-04-09": 38.03785638888889,
                "2026-04-10": 1907.3156655555554,
                "2026-04-13": 1.8807783333333332,
                "2026-04-14": 363.9359575,
                "2026-04-23": 0.4126152777777778,
                "2026-05-04": 407.57371666666666,
                "2026-05-05": 520.3195675,
                "2026-05-14": 381.45066194444445,
                "2026-05-20": 20.308903055555557
              },
              "time_count_per_day": {
                "2025-10-11": 1,
                "2025-10-27": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-19": 1,
                "2025-12-12": 2,
                "2025-12-22": 1,
                "2026-01-09": 1,
                "2026-01-16": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-06": 2,
                "2026-03-25": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-13": 1,
                "2026-04-14": 2,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-14": 1,
                "2026-05-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 167.22,
              "mode_time_hours": 61.0,
              "mode_frequency": 4,
              "time_distribution": {
                "6-8h": 2,
                "8-10h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "18-20h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "30-32h": 2,
                "36-38h": 2,
                "42-44h": 1,
                "50-52h": 1,
                "60-62h": 4,
                "64-66h": 1,
                "86-88h": 1,
                "122-124h": 1,
                "262-264h": 1,
                "526-528h": 1,
                "626-628h": 1,
                "2044-2046h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2025-11-07": 1,
                "2025-11-13": 1,
                "2025-12-02": 1,
                "2026-01-05": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-19": 2,
                "2026-01-22": 1,
                "2026-01-27": 4,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-03": 5,
                "2026-02-07": 2,
                "2026-02-12": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2025-11-07": 123.20894444444444,
                "2025-11-13": 42.273335555555555,
                "2025-12-02": 263.55440416666664,
                "2026-01-05": 626.6618880555556,
                "2026-01-14": 31.003383055555556,
                "2026-01-15": 26.307479444444446,
                "2026-01-19": 122.96122027777778,
                "2026-01-22": 51.261249444444445,
                "2026-01-27": 147.8156377777778,
                "2026-01-28": 12.680081666666666,
                "2026-01-31": 23.26577138888889,
                "2026-02-03": 221.75839222222223,
                "2026-02-07": 82.7911986111111,
                "2026-02-12": 2045.154964722222,
                "2026-03-05": 527.1423580555555
              },
              "time_count_per_day": {
                "2025-11-07": 1,
                "2025-11-13": 1,
                "2025-12-02": 1,
                "2026-01-05": 1,
                "2026-01-14": 2,
                "2026-01-15": 1,
                "2026-01-19": 2,
                "2026-01-22": 1,
                "2026-01-27": 4,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-03": 5,
                "2026-02-07": 2,
                "2026-02-12": 1,
                "2026-03-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 138.2,
              "mode_time_hours": 25.0,
              "mode_frequency": 4,
              "time_distribution": {
                "2-4h": 1,
                "8-10h": 1,
                "10-12h": 1,
                "24-26h": 4,
                "26-28h": 1,
                "50-52h": 1,
                "92-94h": 1,
                "102-104h": 1,
                "122-124h": 1,
                "132-134h": 1,
                "194-196h": 1,
                "196-198h": 1,
                "206-208h": 1,
                "208-210h": 2,
                "220-222h": 1,
                "242-244h": 1,
                "454-456h": 2
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-12-15": 5,
                "2026-01-08": 3,
                "2026-01-24": 2,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-30": 1,
                "2026-04-22": 5
              },
              "time_per_day": {
                "2025-12-15": 147.68661194444445,
                "2026-01-08": 159.72170222222223,
                "2026-01-24": 105.81798583333332,
                "2026-02-04": 132.95393194444446,
                "2026-02-06": 243.53805027777778,
                "2026-02-12": 220.24554055555555,
                "2026-03-17": 11.590754722222222,
                "2026-03-18": 908.1002611111112,
                "2026-03-30": 92.74866138888888,
                "2026-04-22": 1018.0273958333333
              },
              "time_count_per_day": {
                "2025-12-15": 5,
                "2026-01-08": 3,
                "2026-01-24": 2,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-30": 1,
                "2026-04-22": 5
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-15": 1,
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-15": 1,
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-04-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_202": {
      "overall": {
        "avg_time_hours": 102.21,
        "mode_time_hours": 1.0,
        "mode_frequency": 78,
        "time_distribution": {
          "0-2h": 78,
          "2-4h": 36,
          "4-6h": 18,
          "6-8h": 19,
          "8-10h": 15,
          "10-12h": 9,
          "12-14h": 8,
          "14-16h": 4,
          "16-18h": 10,
          "18-20h": 16,
          "20-22h": 22,
          "22-24h": 1,
          "24-26h": 8,
          "26-28h": 3,
          "28-30h": 11,
          "30-32h": 7,
          "32-34h": 12,
          "34-36h": 2,
          "36-38h": 1,
          "40-42h": 7,
          "42-44h": 16,
          "44-46h": 10,
          "46-48h": 1,
          "48-50h": 3,
          "50-52h": 4,
          "52-54h": 3,
          "54-56h": 7,
          "56-58h": 5,
          "58-60h": 2,
          "60-62h": 1,
          "64-66h": 1,
          "66-68h": 15,
          "68-70h": 5,
          "70-72h": 2,
          "72-74h": 1,
          "74-76h": 2,
          "76-78h": 1,
          "78-80h": 2,
          "80-82h": 3,
          "82-84h": 1,
          "84-86h": 3,
          "86-88h": 2,
          "88-90h": 1,
          "90-92h": 4,
          "92-94h": 2,
          "94-96h": 2,
          "96-98h": 1,
          "98-100h": 2,
          "102-104h": 1,
          "104-106h": 2,
          "106-108h": 1,
          "112-114h": 1,
          "114-116h": 2,
          "116-118h": 2,
          "120-122h": 3,
          "122-124h": 1,
          "132-134h": 2,
          "134-136h": 1,
          "136-138h": 1,
          "138-140h": 6,
          "140-142h": 2,
          "142-144h": 2,
          "144-146h": 2,
          "146-148h": 1,
          "148-150h": 1,
          "152-154h": 1,
          "158-160h": 1,
          "160-162h": 1,
          "162-164h": 1,
          "166-168h": 1,
          "168-170h": 1,
          "170-172h": 1,
          "172-174h": 2,
          "174-176h": 1,
          "176-178h": 1,
          "180-182h": 1,
          "186-188h": 1,
          "198-200h": 1,
          "200-202h": 1,
          "208-210h": 1,
          "212-214h": 1,
          "228-230h": 1,
          "240-242h": 2,
          "252-254h": 1,
          "260-262h": 1,
          "300-302h": 1,
          "306-308h": 3,
          "308-310h": 1,
          "314-316h": 1,
          "316-318h": 1,
          "318-320h": 1,
          "324-326h": 1,
          "336-338h": 2,
          "338-340h": 3,
          "362-364h": 1,
          "384-386h": 1,
          "386-388h": 2,
          "388-390h": 1,
          "390-392h": 1,
          "398-400h": 1,
          "402-404h": 1,
          "404-406h": 4,
          "406-408h": 1,
          "408-410h": 2,
          "414-416h": 1,
          "422-424h": 1,
          "424-426h": 1,
          "432-434h": 1,
          "448-450h": 2,
          "454-456h": 1,
          "456-458h": 1,
          "462-464h": 1,
          "474-476h": 1,
          "478-480h": 1,
          "490-492h": 1,
          "492-494h": 1,
          "494-496h": 1,
          "504-506h": 1,
          "522-524h": 1,
          "524-526h": 1,
          "560-562h": 1,
          "622-624h": 1,
          "652-654h": 1,
          "654-656h": 1,
          "692-694h": 1,
          "714-716h": 1,
          "736-738h": 1,
          "794-796h": 1,
          "804-806h": 1,
          "816-818h": 1,
          "834-836h": 1,
          "896-898h": 1,
          "990-992h": 1,
          "1018-1020h": 1,
          "1216-1218h": 1,
          "1414-1416h": 1,
          "1732-1734h": 1
        },
        "tickets_count": 545,
        "tickets_per_day": {
          "2025-10-10": 2,
          "2025-10-13": 2,
          "2025-10-17": 1,
          "2025-10-22": 2,
          "2025-10-27": 1,
          "2025-10-28": 2,
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-03": 8,
          "2025-11-04": 2,
          "2025-11-05": 4,
          "2025-11-06": 5,
          "2025-11-10": 7,
          "2025-11-12": 4,
          "2025-11-13": 5,
          "2025-11-14": 2,
          "2025-11-16": 1,
          "2025-11-17": 5,
          "2025-11-19": 3,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-25": 2,
          "2025-11-26": 3,
          "2025-11-27": 3,
          "2025-11-28": 3,
          "2025-11-29": 2,
          "2025-11-30": 2,
          "2025-12-02": 2,
          "2025-12-03": 8,
          "2025-12-04": 2,
          "2025-12-05": 2,
          "2025-12-09": 5,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-12": 1,
          "2025-12-15": 9,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-02": 2,
          "2026-01-05": 1,
          "2026-01-07": 1,
          "2026-01-08": 2,
          "2026-01-12": 1,
          "2026-01-13": 3,
          "2026-01-14": 1,
          "2026-01-15": 3,
          "2026-01-16": 2,
          "2026-01-17": 2,
          "2026-01-20": 5,
          "2026-01-21": 7,
          "2026-01-22": 3,
          "2026-01-23": 6,
          "2026-01-24": 3,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-29": 4,
          "2026-01-30": 1,
          "2026-02-02": 5,
          "2026-02-03": 2,
          "2026-02-04": 3,
          "2026-02-05": 1,
          "2026-02-06": 2,
          "2026-02-09": 3,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-12": 3,
          "2026-02-13": 7,
          "2026-02-16": 3,
          "2026-02-18": 4,
          "2026-02-19": 10,
          "2026-02-20": 1,
          "2026-02-21": 2,
          "2026-02-23": 9,
          "2026-02-25": 1,
          "2026-02-27": 4,
          "2026-02-28": 6,
          "2026-03-01": 9,
          "2026-03-02": 14,
          "2026-03-03": 11,
          "2026-03-04": 3,
          "2026-03-05": 2,
          "2026-03-06": 3,
          "2026-03-08": 2,
          "2026-03-09": 5,
          "2026-03-11": 4,
          "2026-03-12": 5,
          "2026-03-13": 3,
          "2026-03-16": 4,
          "2026-03-17": 9,
          "2026-03-18": 24,
          "2026-03-19": 4,
          "2026-03-20": 2,
          "2026-03-21": 1,
          "2026-03-23": 3,
          "2026-03-24": 4,
          "2026-03-25": 1,
          "2026-03-26": 4,
          "2026-03-27": 2,
          "2026-03-28": 1,
          "2026-03-30": 9,
          "2026-03-31": 9,
          "2026-04-01": 3,
          "2026-04-02": 1,
          "2026-04-04": 2,
          "2026-04-06": 4,
          "2026-04-07": 3,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-14": 6,
          "2026-04-16": 2,
          "2026-04-17": 9,
          "2026-04-18": 1,
          "2026-04-20": 2,
          "2026-04-22": 3,
          "2026-04-23": 2,
          "2026-04-24": 3,
          "2026-04-27": 8,
          "2026-04-28": 3,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-04": 6,
          "2026-05-05": 5,
          "2026-05-06": 10,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 3,
          "2026-05-10": 1,
          "2026-05-11": 2,
          "2026-05-12": 8,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-15": 2,
          "2026-05-16": 2,
          "2026-05-18": 2,
          "2026-05-19": 4,
          "2026-05-20": 2,
          "2026-05-21": 7,
          "2026-05-22": 2,
          "2026-05-23": 2,
          "2026-05-25": 4,
          "2026-05-26": 3,
          "2026-05-27": 5,
          "2026-05-28": 6,
          "2026-05-29": 4,
          "2026-05-30": 1,
          "2026-06-01": 6,
          "2026-06-02": 7,
          "2026-06-03": 9,
          "2026-06-05": 5,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-10": 110.0244586111111,
          "2025-10-13": 226.76580166666668,
          "2025-10-17": 24.595296111111114,
          "2025-10-22": 169.61350805555557,
          "2025-10-27": 0.3379758333333333,
          "2025-10-28": 87.47993277777778,
          "2025-10-31": 47.19441833333333,
          "2025-11-03": 215.72651416666668,
          "2025-11-04": 59.406085833333336,
          "2025-11-05": 416.32277555555555,
          "2025-11-06": 273.13589888888896,
          "2025-11-10": 225.66614194444446,
          "2025-11-12": 111.26079305555557,
          "2025-11-13": 286.2641144444445,
          "2025-11-14": 45.1022225,
          "2025-11-16": 0.1001375,
          "2025-11-17": 68.08685,
          "2025-11-19": 303.37165166666665,
          "2025-11-21": 450.2005322222222,
          "2025-11-24": 64.44629277777778,
          "2025-11-25": 100.83881277777778,
          "2025-11-26": 412.27397222222226,
          "2025-11-27": 212.08139305555557,
          "2025-11-28": 75.26212305555556,
          "2025-11-29": 578.5283044444445,
          "2025-11-30": 129.94219222222222,
          "2025-12-02": 436.74849,
          "2025-12-03": 52.91439527777777,
          "2025-12-04": 147.24221555555556,
          "2025-12-05": 78.71027444444445,
          "2025-12-09": 272.7638483333334,
          "2025-12-10": 503.9093661111112,
          "2025-12-11": 537.0377288888889,
          "2025-12-12": 74.52195166666667,
          "2025-12-15": 2148.7910222222226,
          "2025-12-17": 0.06531527777777778,
          "2025-12-18": 0.3389519444444445,
          "2025-12-26": 715.1154475,
          "2026-01-02": 14.86838,
          "2026-01-05": 132.77725388888888,
          "2026-01-07": 795.735585,
          "2026-01-08": 99.76179916666668,
          "2026-01-12": 8.473508055555556,
          "2026-01-13": 104.99412694444445,
          "2026-01-14": 20.660363888888888,
          "2026-01-15": 104.03432027777777,
          "2026-01-16": 11.936634999999999,
          "2026-01-17": 23.743889999999997,
          "2026-01-20": 252.42847333333333,
          "2026-01-21": 257.1723213888889,
          "2026-01-22": 23.0153225,
          "2026-01-23": 836.389176111111,
          "2026-01-24": 294.5730658333333,
          "2026-01-26": 116.35523416666666,
          "2026-01-27": 141.1425127777778,
          "2026-01-29": 52.588408055555554,
          "2026-01-30": 26.27584722222222,
          "2026-02-02": 86.18857249999999,
          "2026-02-03": 59.507508055555554,
          "2026-02-04": 101.83301666666667,
          "2026-02-05": 147.9869963888889,
          "2026-02-06": 442.67577000000006,
          "2026-02-09": 86.30399444444444,
          "2026-02-10": 525.3461619444445,
          "2026-02-11": 237.22518805555555,
          "2026-02-12": 2646.7278377777775,
          "2026-02-13": 531.2284736111111,
          "2026-02-16": 69.98440861111112,
          "2026-02-18": 1035.6333213888888,
          "2026-02-19": 4983.427045277776,
          "2026-02-21": 34.822161111111114,
          "2026-02-23": 264.31467638888887,
          "2026-02-25": 0.16812472222222222,
          "2026-02-27": 97.94562583333334,
          "2026-02-28": 83.22441694444444,
          "2026-03-01": 380.9603463888889,
          "2026-03-02": 555.6983758333333,
          "2026-03-03": 415.65389805555554,
          "2026-03-04": 52.5657688888889,
          "2026-03-05": 51.90006138888889,
          "2026-03-06": 50.40215333333333,
          "2026-03-08": 0.020296944444444444,
          "2026-03-09": 1771.4054927777777,
          "2026-03-11": 1042.8122516666667,
          "2026-03-12": 63.89656777777778,
          "2026-03-13": 54.25776416666666,
          "2026-03-16": 17.35059972222222,
          "2026-03-17": 670.6764133333332,
          "2026-03-18": 6834.9739802777785,
          "2026-03-19": 212.91002055555555,
          "2026-03-20": 998.1417583333333,
          "2026-03-23": 113.63565861111111,
          "2026-03-24": 129.3362277777778,
          "2026-03-25": 19.957144722222225,
          "2026-03-26": 2010.1129008333332,
          "2026-03-27": 84.09460833333333,
          "2026-03-30": 631.2030419444446,
          "2026-03-31": 138.80231611111114,
          "2026-04-01": 467.56694055555556,
          "2026-04-04": 6.223869722222222,
          "2026-04-06": 213.3823363888889,
          "2026-04-07": 130.33135305555555,
          "2026-04-08": 171.02021194444444,
          "2026-04-09": 42.646448888888884,
          "2026-04-10": 20.88860222222222,
          "2026-04-14": 1373.4276855555554,
          "2026-04-17": 2361.252085555556,
          "2026-04-18": 2.185453611111111,
          "2026-04-20": 73.09460583333333,
          "2026-04-22": 162.42378472222222,
          "2026-04-23": 10.72691888888889,
          "2026-04-24": 2.2204052777777776,
          "2026-04-27": 160.00315583333332,
          "2026-04-28": 44.389922500000004,
          "2026-04-29": 19.342809444444445,
          "2026-05-02": 0.27299444444444443,
          "2026-05-04": 219.0021102777778,
          "2026-05-05": 650.7460336111111,
          "2026-05-06": 1513.5424669444442,
          "2026-05-07": 2.3821930555555557,
          "2026-05-08": 35.61870555555556,
          "2026-05-09": 20.906869444444443,
          "2026-05-10": 67.14293611111111,
          "2026-05-11": 0.46896222222222217,
          "2026-05-12": 334.18457611111114,
          "2026-05-13": 143.1730636111111,
          "2026-05-14": 2.1729072222222223,
          "2026-05-15": 11.125628888888889,
          "2026-05-16": 3.3792980555555556,
          "2026-05-18": 3.462464444444444,
          "2026-05-19": 50.86221666666667,
          "2026-05-20": 2.2973886111111113,
          "2026-05-21": 314.82150888888884,
          "2026-05-22": 2.5376255555555556,
          "2026-05-23": 2.543711388888889,
          "2026-05-25": 174.0750497222222,
          "2026-05-26": 31.322801388888887,
          "2026-05-27": 170.0999238888889,
          "2026-05-28": 26.74279861111111,
          "2026-05-29": 45.57301638888889,
          "2026-05-30": 1414.279821111111,
          "2026-06-01": 100.8101875,
          "2026-06-02": 139.92116083333332,
          "2026-06-03": 65.80446972222222,
          "2026-06-05": 90.01720583333334,
          "2026-06-08": 0.3132997222222222
        },
        "time_count_per_day": {
          "2025-10-10": 2,
          "2025-10-13": 2,
          "2025-10-17": 1,
          "2025-10-22": 2,
          "2025-10-27": 1,
          "2025-10-28": 2,
          "2025-10-31": 1,
          "2025-11-03": 8,
          "2025-11-04": 2,
          "2025-11-05": 4,
          "2025-11-06": 5,
          "2025-11-10": 7,
          "2025-11-12": 4,
          "2025-11-13": 5,
          "2025-11-14": 2,
          "2025-11-16": 1,
          "2025-11-17": 5,
          "2025-11-19": 3,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-11-25": 2,
          "2025-11-26": 3,
          "2025-11-27": 3,
          "2025-11-28": 3,
          "2025-11-29": 2,
          "2025-11-30": 2,
          "2025-12-02": 2,
          "2025-12-03": 8,
          "2025-12-04": 2,
          "2025-12-05": 2,
          "2025-12-09": 5,
          "2025-12-10": 3,
          "2025-12-11": 2,
          "2025-12-12": 1,
          "2025-12-15": 9,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-02": 2,
          "2026-01-05": 1,
          "2026-01-07": 1,
          "2026-01-08": 2,
          "2026-01-12": 1,
          "2026-01-13": 3,
          "2026-01-14": 1,
          "2026-01-15": 3,
          "2026-01-16": 2,
          "2026-01-17": 2,
          "2026-01-20": 5,
          "2026-01-21": 7,
          "2026-01-22": 3,
          "2026-01-23": 6,
          "2026-01-24": 3,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-29": 4,
          "2026-01-30": 1,
          "2026-02-02": 5,
          "2026-02-03": 2,
          "2026-02-04": 3,
          "2026-02-05": 1,
          "2026-02-06": 2,
          "2026-02-09": 3,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-12": 3,
          "2026-02-13": 7,
          "2026-02-16": 2,
          "2026-02-18": 4,
          "2026-02-19": 10,
          "2026-02-21": 2,
          "2026-02-23": 8,
          "2026-02-25": 1,
          "2026-02-27": 4,
          "2026-02-28": 5,
          "2026-03-01": 9,
          "2026-03-02": 12,
          "2026-03-03": 10,
          "2026-03-04": 3,
          "2026-03-05": 2,
          "2026-03-06": 3,
          "2026-03-08": 2,
          "2026-03-09": 5,
          "2026-03-11": 3,
          "2026-03-12": 5,
          "2026-03-13": 3,
          "2026-03-16": 4,
          "2026-03-17": 9,
          "2026-03-18": 24,
          "2026-03-19": 4,
          "2026-03-20": 2,
          "2026-03-23": 3,
          "2026-03-24": 4,
          "2026-03-25": 1,
          "2026-03-26": 4,
          "2026-03-27": 2,
          "2026-03-30": 9,
          "2026-03-31": 7,
          "2026-04-01": 2,
          "2026-04-04": 2,
          "2026-04-06": 4,
          "2026-04-07": 3,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-14": 6,
          "2026-04-17": 9,
          "2026-04-18": 1,
          "2026-04-20": 2,
          "2026-04-22": 3,
          "2026-04-23": 2,
          "2026-04-24": 2,
          "2026-04-27": 8,
          "2026-04-28": 3,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-04": 6,
          "2026-05-05": 5,
          "2026-05-06": 5,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 3,
          "2026-05-10": 1,
          "2026-05-11": 1,
          "2026-05-12": 7,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-15": 2,
          "2026-05-16": 2,
          "2026-05-18": 1,
          "2026-05-19": 4,
          "2026-05-20": 1,
          "2026-05-21": 5,
          "2026-05-22": 2,
          "2026-05-23": 1,
          "2026-05-25": 4,
          "2026-05-26": 3,
          "2026-05-27": 5,
          "2026-05-28": 3,
          "2026-05-29": 4,
          "2026-05-30": 1,
          "2026-06-01": 6,
          "2026-06-02": 6,
          "2026-06-03": 5,
          "2026-06-05": 5,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 39.61,
          "mode_time_hours": 7.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 4,
            "6-8h": 8,
            "8-10h": 3,
            "10-12h": 2,
            "12-14h": 2,
            "14-16h": 1,
            "18-20h": 2,
            "20-22h": 3,
            "24-26h": 1,
            "26-28h": 2,
            "28-30h": 1,
            "30-32h": 3,
            "32-34h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "48-50h": 2,
            "52-54h": 1,
            "54-56h": 3,
            "56-58h": 1,
            "58-60h": 1,
            "66-68h": 3,
            "74-76h": 1,
            "82-84h": 1,
            "84-86h": 1,
            "132-134h": 1,
            "306-308h": 1,
            "402-404h": 1
          },
          "tickets_count": 65,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-03": 3,
            "2025-12-09": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-09": 2,
            "2026-02-23": 3,
            "2026-03-02": 3,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 3,
            "2026-03-17": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-31": 3,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-04-14": 2,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-20": 2,
            "2026-05-04": 4,
            "2026-05-06": 1,
            "2026-05-10": 1,
            "2026-05-12": 1,
            "2026-05-23": 1,
            "2026-05-25": 2,
            "2026-06-03": 4,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-11-06": 27.529957777777778,
            "2025-11-10": 6.358011944444445,
            "2025-11-13": 14.662340833333333,
            "2025-11-27": 10.394558611111112,
            "2025-11-28": 12.524309722222222,
            "2025-12-03": 13.04123111111111,
            "2025-12-09": 6.758991944444444,
            "2025-12-11": 41.06377166666667,
            "2025-12-15": 133.2801411111111,
            "2026-01-12": 8.473508055555556,
            "2026-01-13": 30.37377027777778,
            "2026-01-22": 0.3549558333333333,
            "2026-01-23": 8.193075833333333,
            "2026-01-29": 6.405734166666667,
            "2026-01-30": 26.27584722222222,
            "2026-02-02": 79.56966555555556,
            "2026-02-03": 29.762671666666666,
            "2026-02-04": 54.2752175,
            "2026-02-09": 4.529368333333334,
            "2026-02-23": 20.873534166666666,
            "2026-03-02": 109.2712363888889,
            "2026-03-03": 67.82572,
            "2026-03-11": 1.631247222222222,
            "2026-03-12": 1.6545927777777776,
            "2026-03-13": 54.25776416666666,
            "2026-03-17": 402.9234177777778,
            "2026-03-23": 53.183791666666664,
            "2026-03-24": 32.702583611111116,
            "2026-03-31": 82.55449527777778,
            "2026-04-01": 18.798235,
            "2026-04-06": 61.578377499999995,
            "2026-04-14": 20.964566666666666,
            "2026-04-17": 2.5466955555555555,
            "2026-04-20": 73.09460583333333,
            "2026-05-04": 168.2645161111111,
            "2026-05-06": 306.94763277777776,
            "2026-05-10": 67.14293611111111,
            "2026-05-12": 25.412093055555555,
            "2026-05-25": 168.9372897222222,
            "2026-06-05": 42.998759444444445
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-03": 3,
            "2025-12-09": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-02": 2,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-09": 2,
            "2026-02-23": 3,
            "2026-03-02": 2,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 3,
            "2026-03-17": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-31": 3,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-04-14": 2,
            "2026-04-17": 1,
            "2026-04-20": 2,
            "2026-05-04": 4,
            "2026-05-06": 1,
            "2026-05-10": 1,
            "2026-05-12": 1,
            "2026-05-25": 2,
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 70.31,
          "mode_time_hours": 1.0,
          "mode_frequency": 68,
          "time_distribution": {
            "0-2h": 68,
            "2-4h": 28,
            "4-6h": 14,
            "6-8h": 10,
            "8-10h": 6,
            "10-12h": 3,
            "12-14h": 5,
            "14-16h": 2,
            "16-18h": 5,
            "18-20h": 14,
            "20-22h": 17,
            "22-24h": 1,
            "24-26h": 5,
            "26-28h": 1,
            "28-30h": 7,
            "30-32h": 4,
            "32-34h": 11,
            "34-36h": 2,
            "40-42h": 6,
            "42-44h": 14,
            "44-46h": 6,
            "48-50h": 1,
            "50-52h": 1,
            "52-54h": 1,
            "54-56h": 3,
            "56-58h": 2,
            "58-60h": 1,
            "60-62h": 1,
            "66-68h": 10,
            "68-70h": 5,
            "70-72h": 1,
            "72-74h": 1,
            "78-80h": 2,
            "80-82h": 1,
            "84-86h": 2,
            "86-88h": 1,
            "88-90h": 1,
            "90-92h": 3,
            "92-94h": 2,
            "96-98h": 1,
            "106-108h": 1,
            "114-116h": 1,
            "116-118h": 2,
            "132-134h": 1,
            "134-136h": 1,
            "138-140h": 5,
            "142-144h": 1,
            "144-146h": 1,
            "168-170h": 1,
            "170-172h": 1,
            "172-174h": 1,
            "180-182h": 1,
            "200-202h": 1,
            "208-210h": 1,
            "252-254h": 1,
            "260-262h": 1,
            "300-302h": 1,
            "306-308h": 1,
            "308-310h": 1,
            "314-316h": 1,
            "336-338h": 2,
            "338-340h": 2,
            "362-364h": 1,
            "384-386h": 1,
            "390-392h": 1,
            "404-406h": 4,
            "408-410h": 1,
            "414-416h": 1,
            "448-450h": 1,
            "504-506h": 1,
            "560-562h": 1,
            "816-818h": 1,
            "834-836h": 1,
            "990-992h": 1,
            "1018-1020h": 1,
            "1414-1416h": 1
          },
          "tickets_count": 336,
          "tickets_per_day": {
            "2025-10-22": 1,
            "2025-10-27": 1,
            "2025-10-28": 2,
            "2025-11-03": 8,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-10": 4,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-14": 2,
            "2025-11-16": 1,
            "2025-11-17": 4,
            "2025-11-21": 1,
            "2025-11-26": 2,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-02": 1,
            "2025-12-03": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-15": 4,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 2,
            "2026-01-16": 1,
            "2026-01-17": 1,
            "2026-01-20": 4,
            "2026-01-21": 5,
            "2026-01-22": 2,
            "2026-01-23": 4,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-29": 3,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-13": 4,
            "2026-02-16": 2,
            "2026-02-18": 4,
            "2026-02-23": 3,
            "2026-02-27": 4,
            "2026-02-28": 3,
            "2026-03-01": 9,
            "2026-03-02": 11,
            "2026-03-03": 10,
            "2026-03-04": 3,
            "2026-03-05": 2,
            "2026-03-06": 3,
            "2026-03-08": 2,
            "2026-03-09": 5,
            "2026-03-11": 1,
            "2026-03-12": 4,
            "2026-03-16": 4,
            "2026-03-17": 4,
            "2026-03-18": 3,
            "2026-03-19": 4,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-28": 1,
            "2026-03-30": 8,
            "2026-03-31": 4,
            "2026-04-01": 2,
            "2026-04-04": 2,
            "2026-04-06": 2,
            "2026-04-07": 3,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-14": 4,
            "2026-04-17": 8,
            "2026-04-18": 1,
            "2026-04-22": 2,
            "2026-04-23": 2,
            "2026-04-24": 3,
            "2026-04-27": 8,
            "2026-04-28": 3,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-04": 2,
            "2026-05-05": 5,
            "2026-05-06": 9,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 3,
            "2026-05-11": 1,
            "2026-05-12": 7,
            "2026-05-13": 1,
            "2026-05-14": 2,
            "2026-05-15": 2,
            "2026-05-16": 2,
            "2026-05-18": 2,
            "2026-05-19": 4,
            "2026-05-20": 2,
            "2026-05-21": 6,
            "2026-05-22": 2,
            "2026-05-23": 1,
            "2026-05-25": 2,
            "2026-05-26": 3,
            "2026-05-27": 5,
            "2026-05-28": 6,
            "2026-05-29": 4,
            "2026-05-30": 1,
            "2026-06-01": 6,
            "2026-06-02": 7,
            "2026-06-03": 4,
            "2026-06-05": 4,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-22": 1.8562775,
            "2025-10-27": 0.3379758333333333,
            "2025-10-28": 87.47993277777778,
            "2025-11-03": 215.72651416666668,
            "2025-11-04": 55.39745861111111,
            "2025-11-05": 44.90738472222222,
            "2025-11-06": 12.695453888888888,
            "2025-11-10": 123.10042722222222,
            "2025-11-12": 22.101481944444444,
            "2025-11-13": 149.24600277777776,
            "2025-11-14": 45.1022225,
            "2025-11-16": 0.1001375,
            "2025-11-17": 67.06566138888888,
            "2025-11-21": 208.86265027777776,
            "2025-11-26": 26.057098055555556,
            "2025-11-27": 201.68683444444446,
            "2025-11-28": 62.737813333333335,
            "2025-11-29": 115.23021722222222,
            "2025-11-30": 85.22440611111112,
            "2025-12-02": 300.21015083333333,
            "2025-12-03": 14.814977500000001,
            "2025-12-05": 78.71027444444445,
            "2025-12-09": 93.66823666666667,
            "2025-12-10": 306.46787500000005,
            "2025-12-15": 851.0701366666668,
            "2025-12-17": 0.06531527777777778,
            "2025-12-18": 0.3389519444444445,
            "2026-01-02": 3.8647069444444444,
            "2026-01-05": 132.77725388888888,
            "2026-01-08": 97.9250663888889,
            "2026-01-13": 72.55373861111111,
            "2026-01-14": 20.660363888888888,
            "2026-01-15": 23.473886388888886,
            "2026-01-16": 5.125558055555555,
            "2026-01-17": 19.31415361111111,
            "2026-01-20": 196.7838413888889,
            "2026-01-21": 123.01705166666666,
            "2026-01-22": 22.66036666666667,
            "2026-01-23": 824.5126305555556,
            "2026-01-26": 116.35523416666666,
            "2026-01-27": 53.54542555555556,
            "2026-01-29": 46.182673888888885,
            "2026-02-02": 0.25120305555555555,
            "2026-02-03": 29.74483638888889,
            "2026-02-04": 27.421869166666667,
            "2026-02-13": 297.75387750000004,
            "2026-02-16": 69.98440861111112,
            "2026-02-18": 1035.6333213888888,
            "2026-02-23": 137.3179336111111,
            "2026-02-27": 97.94562583333334,
            "2026-02-28": 27.681361111111112,
            "2026-03-01": 380.9603463888889,
            "2026-03-02": 446.42713944444444,
            "2026-03-03": 347.82817805555555,
            "2026-03-04": 52.5657688888889,
            "2026-03-05": 51.90006138888889,
            "2026-03-06": 50.40215333333333,
            "2026-03-08": 0.020296944444444444,
            "2026-03-09": 1771.4054927777777,
            "2026-03-11": 144.20653777777778,
            "2026-03-12": 62.241975000000004,
            "2026-03-16": 17.35059972222222,
            "2026-03-17": 182.44545305555553,
            "2026-03-18": 103.21167694444445,
            "2026-03-19": 212.91002055555555,
            "2026-03-20": 998.1417583333333,
            "2026-03-23": 60.45186694444445,
            "2026-03-24": 1.3135041666666667,
            "2026-03-25": 19.957144722222225,
            "2026-03-26": 78.90550055555556,
            "2026-03-27": 67.33715083333333,
            "2026-03-30": 580.5914994444446,
            "2026-03-31": 54.68829666666666,
            "2026-04-01": 448.7687055555556,
            "2026-04-04": 6.223869722222222,
            "2026-04-06": 151.80395888888887,
            "2026-04-07": 130.33135305555555,
            "2026-04-08": 171.02021194444444,
            "2026-04-09": 42.646448888888884,
            "2026-04-10": 20.88860222222222,
            "2026-04-14": 1352.4631188888889,
            "2026-04-17": 2358.70539,
            "2026-04-18": 2.185453611111111,
            "2026-04-22": 40.398757222222216,
            "2026-04-23": 10.72691888888889,
            "2026-04-24": 2.2204052777777776,
            "2026-04-27": 160.00315583333332,
            "2026-04-28": 44.389922500000004,
            "2026-04-29": 19.342809444444445,
            "2026-05-02": 0.27299444444444443,
            "2026-05-04": 50.73759416666666,
            "2026-05-05": 650.7460336111111,
            "2026-05-06": 1206.5948341666665,
            "2026-05-07": 2.3821930555555557,
            "2026-05-08": 35.61870555555556,
            "2026-05-09": 20.906869444444443,
            "2026-05-11": 0.46896222222222217,
            "2026-05-12": 308.77248305555554,
            "2026-05-13": 143.1730636111111,
            "2026-05-14": 2.1729072222222223,
            "2026-05-15": 11.125628888888889,
            "2026-05-16": 3.3792980555555556,
            "2026-05-18": 3.462464444444444,
            "2026-05-19": 50.86221666666667,
            "2026-05-20": 2.2973886111111113,
            "2026-05-21": 314.82150888888884,
            "2026-05-22": 2.5376255555555556,
            "2026-05-23": 2.543711388888889,
            "2026-05-25": 5.13776,
            "2026-05-26": 31.322801388888887,
            "2026-05-27": 170.0999238888889,
            "2026-05-28": 26.74279861111111,
            "2026-05-29": 45.57301638888889,
            "2026-05-30": 1414.279821111111,
            "2026-06-01": 100.8101875,
            "2026-06-02": 139.92116083333332,
            "2026-06-03": 54.22771333333333,
            "2026-06-05": 47.01844638888889,
            "2026-06-08": 0.3132997222222222
          },
          "time_count_per_day": {
            "2025-10-22": 1,
            "2025-10-27": 1,
            "2025-10-28": 2,
            "2025-11-03": 8,
            "2025-11-04": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-10": 4,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-14": 2,
            "2025-11-16": 1,
            "2025-11-17": 4,
            "2025-11-21": 1,
            "2025-11-26": 2,
            "2025-11-27": 2,
            "2025-11-28": 2,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-02": 1,
            "2025-12-03": 2,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-15": 4,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 2,
            "2026-01-16": 1,
            "2026-01-17": 1,
            "2026-01-20": 4,
            "2026-01-21": 5,
            "2026-01-22": 2,
            "2026-01-23": 4,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-29": 3,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-13": 4,
            "2026-02-16": 2,
            "2026-02-18": 4,
            "2026-02-23": 3,
            "2026-02-27": 4,
            "2026-02-28": 3,
            "2026-03-01": 9,
            "2026-03-02": 10,
            "2026-03-03": 9,
            "2026-03-04": 3,
            "2026-03-05": 2,
            "2026-03-06": 3,
            "2026-03-08": 2,
            "2026-03-09": 5,
            "2026-03-11": 1,
            "2026-03-12": 4,
            "2026-03-16": 4,
            "2026-03-17": 4,
            "2026-03-18": 3,
            "2026-03-19": 4,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-30": 8,
            "2026-03-31": 3,
            "2026-04-01": 1,
            "2026-04-04": 2,
            "2026-04-06": 2,
            "2026-04-07": 3,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-14": 4,
            "2026-04-17": 8,
            "2026-04-18": 1,
            "2026-04-22": 2,
            "2026-04-23": 2,
            "2026-04-24": 2,
            "2026-04-27": 8,
            "2026-04-28": 3,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-04": 2,
            "2026-05-05": 5,
            "2026-05-06": 4,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 3,
            "2026-05-11": 1,
            "2026-05-12": 6,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 2,
            "2026-05-16": 2,
            "2026-05-18": 1,
            "2026-05-19": 4,
            "2026-05-20": 1,
            "2026-05-21": 5,
            "2026-05-22": 2,
            "2026-05-23": 1,
            "2026-05-25": 2,
            "2026-05-26": 3,
            "2026-05-27": 5,
            "2026-05-28": 3,
            "2026-05-29": 4,
            "2026-05-30": 1,
            "2026-06-01": 6,
            "2026-06-02": 6,
            "2026-06-03": 4,
            "2026-06-05": 4,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 223.2,
          "mode_time_hours": 9.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 4,
            "16-18h": 1,
            "20-22h": 2,
            "28-30h": 2,
            "54-56h": 1,
            "64-66h": 1,
            "74-76h": 1,
            "80-82h": 1,
            "90-92h": 1,
            "152-154h": 1,
            "174-176h": 1,
            "176-178h": 1,
            "316-318h": 1,
            "386-388h": 1,
            "422-424h": 1,
            "478-480h": 1,
            "490-492h": 1,
            "524-526h": 1,
            "714-716h": 1,
            "794-796h": 1,
            "896-898h": 1,
            "1732-1734h": 1
          },
          "tickets_count": 36,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-04": 1,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-26": 1,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-12": 1,
            "2025-12-15": 2,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 1,
            "2026-01-23": 1,
            "2026-02-02": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 3,
            "2026-03-11": 1,
            "2026-03-27": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-11-04": 4.008627222222223,
            "2025-11-17": 1.021188611111111,
            "2025-11-19": 9.841457222222221,
            "2025-11-24": 64.44629277777778,
            "2025-11-25": 91.64814666666666,
            "2025-11-26": 386.2168741666667,
            "2025-12-09": 172.33661972222222,
            "2025-12-10": 197.4414911111111,
            "2025-12-12": 74.52195166666667,
            "2025-12-15": 795.4829358333333,
            "2025-12-26": 715.1154475,
            "2026-01-07": 795.735585,
            "2026-01-08": 1.8367327777777778,
            "2026-01-13": 2.0666180555555553,
            "2026-01-15": 80.56043388888888,
            "2026-01-16": 6.811076944444444,
            "2026-01-20": 55.64463194444444,
            "2026-01-23": 3.683469722222222,
            "2026-02-02": 3.609780833333333,
            "2026-02-04": 20.13593,
            "2026-02-10": 525.3461619444445,
            "2026-02-11": 8.980015833333333,
            "2026-02-12": 2646.7278377777775,
            "2026-02-13": 233.4745961111111,
            "2026-03-11": 896.9744666666667,
            "2026-03-27": 16.7574575,
            "2026-03-31": 1.5595241666666668
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-26": 1,
            "2025-12-09": 3,
            "2025-12-10": 2,
            "2025-12-12": 1,
            "2025-12-15": 2,
            "2025-12-26": 1,
            "2026-01-07": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 1,
            "2026-01-23": 1,
            "2026-02-02": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-12": 3,
            "2026-02-13": 3,
            "2026-03-11": 1,
            "2026-03-27": 1,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 161.66,
          "mode_time_hours": 17.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 2,
            "8-10h": 2,
            "10-12h": 4,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 4,
            "24-26h": 2,
            "28-30h": 1,
            "36-38h": 1,
            "42-44h": 1,
            "44-46h": 4,
            "46-48h": 1,
            "50-52h": 3,
            "52-54h": 1,
            "56-58h": 2,
            "66-68h": 2,
            "70-72h": 1,
            "76-78h": 1,
            "80-82h": 1,
            "86-88h": 1,
            "94-96h": 2,
            "98-100h": 2,
            "102-104h": 1,
            "104-106h": 2,
            "112-114h": 1,
            "114-116h": 1,
            "120-122h": 3,
            "122-124h": 1,
            "138-140h": 1,
            "140-142h": 2,
            "144-146h": 1,
            "146-148h": 1,
            "148-150h": 1,
            "162-164h": 1,
            "166-168h": 1,
            "172-174h": 1,
            "186-188h": 1,
            "198-200h": 1,
            "212-214h": 1,
            "228-230h": 1,
            "240-242h": 1,
            "324-326h": 1,
            "338-340h": 1,
            "386-388h": 1,
            "388-390h": 1,
            "398-400h": 1,
            "406-408h": 1,
            "408-410h": 1,
            "424-426h": 1,
            "432-434h": 1,
            "448-450h": 1,
            "454-456h": 1,
            "456-458h": 1,
            "462-464h": 1,
            "474-476h": 1,
            "492-494h": 1,
            "622-624h": 1,
            "652-654h": 1,
            "654-656h": 1
          },
          "tickets_count": 89,
          "tickets_per_day": {
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-17": 1,
            "2025-10-22": 1,
            "2025-10-31": 1,
            "2025-11-05": 3,
            "2025-11-06": 3,
            "2025-11-10": 2,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-19": 2,
            "2025-11-21": 1,
            "2025-11-25": 1,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-03": 2,
            "2025-12-04": 2,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-17": 1,
            "2026-01-21": 2,
            "2026-01-24": 3,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-09": 1,
            "2026-02-11": 1,
            "2026-02-21": 2,
            "2026-02-23": 2,
            "2026-02-25": 1,
            "2026-02-28": 3,
            "2026-03-17": 4,
            "2026-03-18": 21,
            "2026-03-24": 1,
            "2026-03-26": 3,
            "2026-03-30": 1,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-05-11": 1,
            "2026-05-21": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-10": 110.0244586111111,
            "2025-10-13": 226.76580166666668,
            "2025-10-17": 24.595296111111114,
            "2025-10-22": 167.75723055555557,
            "2025-10-31": 47.19441833333333,
            "2025-11-05": 371.41539083333333,
            "2025-11-06": 232.91048722222226,
            "2025-11-10": 96.20770277777778,
            "2025-11-12": 89.15931111111112,
            "2025-11-13": 122.35577083333334,
            "2025-11-19": 293.5301944444444,
            "2025-11-21": 241.33788194444443,
            "2025-11-25": 9.190666111111112,
            "2025-11-29": 463.29808722222225,
            "2025-11-30": 44.71778611111111,
            "2025-12-03": 20.439880833333333,
            "2025-12-04": 147.24221555555556,
            "2025-12-15": 50.14469,
            "2026-01-02": 11.003673055555556,
            "2026-01-17": 4.429736388888888,
            "2026-01-21": 134.15526972222222,
            "2026-01-24": 294.5730658333333,
            "2026-01-27": 87.59708722222223,
            "2026-02-02": 2.757923055555555,
            "2026-02-05": 147.9869963888889,
            "2026-02-06": 442.67577000000006,
            "2026-02-09": 81.7746261111111,
            "2026-02-11": 228.2451722222222,
            "2026-02-21": 34.822161111111114,
            "2026-02-23": 106.12320861111111,
            "2026-02-25": 0.16812472222222222,
            "2026-02-28": 55.543055833333334,
            "2026-03-17": 85.3075425,
            "2026-03-18": 6731.762303333334,
            "2026-03-24": 95.32014000000001,
            "2026-03-26": 1931.2074002777777,
            "2026-03-30": 50.611542500000006,
            "2026-04-22": 122.0250275,
            "2026-06-03": 11.576756388888889
          },
          "time_count_per_day": {
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-17": 1,
            "2025-10-22": 1,
            "2025-10-31": 1,
            "2025-11-05": 3,
            "2025-11-06": 3,
            "2025-11-10": 2,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-19": 2,
            "2025-11-21": 1,
            "2025-11-25": 1,
            "2025-11-29": 1,
            "2025-11-30": 1,
            "2025-12-03": 2,
            "2025-12-04": 2,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-17": 1,
            "2026-01-21": 2,
            "2026-01-24": 3,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-05": 1,
            "2026-02-06": 2,
            "2026-02-09": 1,
            "2026-02-11": 1,
            "2026-02-21": 2,
            "2026-02-23": 2,
            "2026-02-25": 1,
            "2026-02-28": 2,
            "2026-03-17": 4,
            "2026-03-18": 21,
            "2026-03-24": 1,
            "2026-03-26": 3,
            "2026-03-30": 1,
            "2026-04-22": 1,
            "2026-06-03": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 424.24,
          "mode_time_hours": 495.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "136-138h": 1,
            "142-144h": 1,
            "158-160h": 1,
            "160-162h": 1,
            "240-242h": 1,
            "306-308h": 1,
            "318-320h": 1,
            "494-496h": 1,
            "522-524h": 1,
            "692-694h": 1,
            "736-738h": 1,
            "804-806h": 1,
            "1216-1218h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2026-02-16": 1,
            "2026-02-19": 10,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-03-11": 1,
            "2026-03-21": 1
          },
          "time_per_day": {
            "2025-12-02": 136.53833916666667,
            "2025-12-03": 4.618305833333334,
            "2025-12-11": 495.9739572222222,
            "2025-12-15": 318.8131186111111,
            "2026-02-19": 4983.427045277776
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-11": 1,
            "2025-12-15": 1,
            "2026-02-19": 10
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 102.21,
            "mode_time_hours": 1.0,
            "mode_frequency": 78,
            "time_distribution": {
              "0-2h": 78,
              "2-4h": 36,
              "4-6h": 18,
              "6-8h": 19,
              "8-10h": 15,
              "10-12h": 9,
              "12-14h": 8,
              "14-16h": 4,
              "16-18h": 10,
              "18-20h": 16,
              "20-22h": 22,
              "22-24h": 1,
              "24-26h": 8,
              "26-28h": 3,
              "28-30h": 11,
              "30-32h": 7,
              "32-34h": 12,
              "34-36h": 2,
              "36-38h": 1,
              "40-42h": 7,
              "42-44h": 16,
              "44-46h": 10,
              "46-48h": 1,
              "48-50h": 3,
              "50-52h": 4,
              "52-54h": 3,
              "54-56h": 7,
              "56-58h": 5,
              "58-60h": 2,
              "60-62h": 1,
              "64-66h": 1,
              "66-68h": 15,
              "68-70h": 5,
              "70-72h": 2,
              "72-74h": 1,
              "74-76h": 2,
              "76-78h": 1,
              "78-80h": 2,
              "80-82h": 3,
              "82-84h": 1,
              "84-86h": 3,
              "86-88h": 2,
              "88-90h": 1,
              "90-92h": 4,
              "92-94h": 2,
              "94-96h": 2,
              "96-98h": 1,
              "98-100h": 2,
              "102-104h": 1,
              "104-106h": 2,
              "106-108h": 1,
              "112-114h": 1,
              "114-116h": 2,
              "116-118h": 2,
              "120-122h": 3,
              "122-124h": 1,
              "132-134h": 2,
              "134-136h": 1,
              "136-138h": 1,
              "138-140h": 6,
              "140-142h": 2,
              "142-144h": 2,
              "144-146h": 2,
              "146-148h": 1,
              "148-150h": 1,
              "152-154h": 1,
              "158-160h": 1,
              "160-162h": 1,
              "162-164h": 1,
              "166-168h": 1,
              "168-170h": 1,
              "170-172h": 1,
              "172-174h": 2,
              "174-176h": 1,
              "176-178h": 1,
              "180-182h": 1,
              "186-188h": 1,
              "198-200h": 1,
              "200-202h": 1,
              "208-210h": 1,
              "212-214h": 1,
              "228-230h": 1,
              "240-242h": 2,
              "252-254h": 1,
              "260-262h": 1,
              "300-302h": 1,
              "306-308h": 3,
              "308-310h": 1,
              "314-316h": 1,
              "316-318h": 1,
              "318-320h": 1,
              "324-326h": 1,
              "336-338h": 2,
              "338-340h": 3,
              "362-364h": 1,
              "384-386h": 1,
              "386-388h": 2,
              "388-390h": 1,
              "390-392h": 1,
              "398-400h": 1,
              "402-404h": 1,
              "404-406h": 4,
              "406-408h": 1,
              "408-410h": 2,
              "414-416h": 1,
              "422-424h": 1,
              "424-426h": 1,
              "432-434h": 1,
              "448-450h": 2,
              "454-456h": 1,
              "456-458h": 1,
              "462-464h": 1,
              "474-476h": 1,
              "478-480h": 1,
              "490-492h": 1,
              "492-494h": 1,
              "494-496h": 1,
              "504-506h": 1,
              "522-524h": 1,
              "524-526h": 1,
              "560-562h": 1,
              "622-624h": 1,
              "652-654h": 1,
              "654-656h": 1,
              "692-694h": 1,
              "714-716h": 1,
              "736-738h": 1,
              "794-796h": 1,
              "804-806h": 1,
              "816-818h": 1,
              "834-836h": 1,
              "896-898h": 1,
              "990-992h": 1,
              "1018-1020h": 1,
              "1216-1218h": 1,
              "1414-1416h": 1,
              "1732-1734h": 1
            },
            "tickets_count": 505,
            "tickets_per_day": {
              "2025-10-10": 2,
              "2025-10-13": 2,
              "2025-10-17": 1,
              "2025-10-22": 2,
              "2025-10-27": 1,
              "2025-10-28": 2,
              "2025-10-31": 1,
              "2025-11-03": 8,
              "2025-11-04": 2,
              "2025-11-05": 4,
              "2025-11-06": 5,
              "2025-11-10": 7,
              "2025-11-12": 4,
              "2025-11-13": 5,
              "2025-11-14": 2,
              "2025-11-16": 1,
              "2025-11-17": 5,
              "2025-11-19": 3,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-25": 2,
              "2025-11-26": 3,
              "2025-11-27": 3,
              "2025-11-28": 3,
              "2025-11-29": 2,
              "2025-11-30": 2,
              "2025-12-02": 2,
              "2025-12-03": 8,
              "2025-12-04": 2,
              "2025-12-05": 2,
              "2025-12-09": 5,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-12": 1,
              "2025-12-15": 9,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-02": 2,
              "2026-01-05": 1,
              "2026-01-07": 1,
              "2026-01-08": 2,
              "2026-01-12": 1,
              "2026-01-13": 3,
              "2026-01-14": 1,
              "2026-01-15": 3,
              "2026-01-16": 2,
              "2026-01-17": 2,
              "2026-01-20": 5,
              "2026-01-21": 7,
              "2026-01-22": 3,
              "2026-01-23": 6,
              "2026-01-24": 3,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-29": 4,
              "2026-01-30": 1,
              "2026-02-02": 5,
              "2026-02-03": 2,
              "2026-02-04": 3,
              "2026-02-05": 1,
              "2026-02-06": 2,
              "2026-02-09": 3,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-02-12": 3,
              "2026-02-13": 7,
              "2026-02-16": 2,
              "2026-02-18": 4,
              "2026-02-19": 10,
              "2026-02-21": 2,
              "2026-02-23": 8,
              "2026-02-25": 1,
              "2026-02-27": 4,
              "2026-02-28": 5,
              "2026-03-01": 9,
              "2026-03-02": 12,
              "2026-03-03": 10,
              "2026-03-04": 3,
              "2026-03-05": 2,
              "2026-03-06": 3,
              "2026-03-08": 2,
              "2026-03-09": 5,
              "2026-03-11": 3,
              "2026-03-12": 5,
              "2026-03-13": 3,
              "2026-03-16": 4,
              "2026-03-17": 9,
              "2026-03-18": 24,
              "2026-03-19": 4,
              "2026-03-20": 2,
              "2026-03-23": 3,
              "2026-03-24": 4,
              "2026-03-25": 1,
              "2026-03-26": 4,
              "2026-03-27": 2,
              "2026-03-30": 9,
              "2026-03-31": 7,
              "2026-04-01": 2,
              "2026-04-04": 2,
              "2026-04-06": 4,
              "2026-04-07": 3,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-14": 6,
              "2026-04-17": 9,
              "2026-04-18": 1,
              "2026-04-20": 2,
              "2026-04-22": 3,
              "2026-04-23": 2,
              "2026-04-24": 2,
              "2026-04-27": 8,
              "2026-04-28": 3,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-04": 6,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 3,
              "2026-05-10": 1,
              "2026-05-11": 1,
              "2026-05-12": 7,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-15": 2,
              "2026-05-16": 2,
              "2026-05-18": 1,
              "2026-05-19": 4,
              "2026-05-20": 1,
              "2026-05-21": 5,
              "2026-05-22": 2,
              "2026-05-23": 1,
              "2026-05-25": 4,
              "2026-05-26": 3,
              "2026-05-27": 5,
              "2026-05-28": 3,
              "2026-05-29": 4,
              "2026-05-30": 1,
              "2026-06-01": 6,
              "2026-06-02": 6,
              "2026-06-03": 5,
              "2026-06-05": 5,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-10": 110.0244586111111,
              "2025-10-13": 226.76580166666668,
              "2025-10-17": 24.595296111111114,
              "2025-10-22": 169.61350805555557,
              "2025-10-27": 0.3379758333333333,
              "2025-10-28": 87.47993277777778,
              "2025-10-31": 47.19441833333333,
              "2025-11-03": 215.72651416666668,
              "2025-11-04": 59.406085833333336,
              "2025-11-05": 416.32277555555555,
              "2025-11-06": 273.13589888888896,
              "2025-11-10": 225.66614194444446,
              "2025-11-12": 111.26079305555557,
              "2025-11-13": 286.2641144444445,
              "2025-11-14": 45.1022225,
              "2025-11-16": 0.1001375,
              "2025-11-17": 68.08685,
              "2025-11-19": 303.37165166666665,
              "2025-11-21": 450.2005322222222,
              "2025-11-24": 64.44629277777778,
              "2025-11-25": 100.83881277777778,
              "2025-11-26": 412.27397222222226,
              "2025-11-27": 212.08139305555557,
              "2025-11-28": 75.26212305555556,
              "2025-11-29": 578.5283044444445,
              "2025-11-30": 129.94219222222222,
              "2025-12-02": 436.74849,
              "2025-12-03": 52.91439527777777,
              "2025-12-04": 147.24221555555556,
              "2025-12-05": 78.71027444444445,
              "2025-12-09": 272.7638483333334,
              "2025-12-10": 503.9093661111112,
              "2025-12-11": 537.0377288888889,
              "2025-12-12": 74.52195166666667,
              "2025-12-15": 2148.7910222222226,
              "2025-12-17": 0.06531527777777778,
              "2025-12-18": 0.3389519444444445,
              "2025-12-26": 715.1154475,
              "2026-01-02": 14.86838,
              "2026-01-05": 132.77725388888888,
              "2026-01-07": 795.735585,
              "2026-01-08": 99.76179916666668,
              "2026-01-12": 8.473508055555556,
              "2026-01-13": 104.99412694444445,
              "2026-01-14": 20.660363888888888,
              "2026-01-15": 104.03432027777777,
              "2026-01-16": 11.936634999999999,
              "2026-01-17": 23.743889999999997,
              "2026-01-20": 252.42847333333333,
              "2026-01-21": 257.1723213888889,
              "2026-01-22": 23.0153225,
              "2026-01-23": 836.389176111111,
              "2026-01-24": 294.5730658333333,
              "2026-01-26": 116.35523416666666,
              "2026-01-27": 141.1425127777778,
              "2026-01-29": 52.588408055555554,
              "2026-01-30": 26.27584722222222,
              "2026-02-02": 86.18857249999999,
              "2026-02-03": 59.507508055555554,
              "2026-02-04": 101.83301666666667,
              "2026-02-05": 147.9869963888889,
              "2026-02-06": 442.67577000000006,
              "2026-02-09": 86.30399444444444,
              "2026-02-10": 525.3461619444445,
              "2026-02-11": 237.22518805555555,
              "2026-02-12": 2646.7278377777775,
              "2026-02-13": 531.2284736111111,
              "2026-02-16": 69.98440861111112,
              "2026-02-18": 1035.6333213888888,
              "2026-02-19": 4983.427045277776,
              "2026-02-21": 34.822161111111114,
              "2026-02-23": 264.31467638888887,
              "2026-02-25": 0.16812472222222222,
              "2026-02-27": 97.94562583333334,
              "2026-02-28": 83.22441694444444,
              "2026-03-01": 380.9603463888889,
              "2026-03-02": 555.6983758333333,
              "2026-03-03": 415.65389805555554,
              "2026-03-04": 52.5657688888889,
              "2026-03-05": 51.90006138888889,
              "2026-03-06": 50.40215333333333,
              "2026-03-08": 0.020296944444444444,
              "2026-03-09": 1771.4054927777777,
              "2026-03-11": 1042.8122516666667,
              "2026-03-12": 63.89656777777778,
              "2026-03-13": 54.25776416666666,
              "2026-03-16": 17.35059972222222,
              "2026-03-17": 670.6764133333332,
              "2026-03-18": 6834.9739802777785,
              "2026-03-19": 212.91002055555555,
              "2026-03-20": 998.1417583333333,
              "2026-03-23": 113.63565861111111,
              "2026-03-24": 129.3362277777778,
              "2026-03-25": 19.957144722222225,
              "2026-03-26": 2010.1129008333332,
              "2026-03-27": 84.09460833333333,
              "2026-03-30": 631.2030419444446,
              "2026-03-31": 138.80231611111114,
              "2026-04-01": 467.56694055555556,
              "2026-04-04": 6.223869722222222,
              "2026-04-06": 213.3823363888889,
              "2026-04-07": 130.33135305555555,
              "2026-04-08": 171.02021194444444,
              "2026-04-09": 42.646448888888884,
              "2026-04-10": 20.88860222222222,
              "2026-04-14": 1373.4276855555554,
              "2026-04-17": 2361.252085555556,
              "2026-04-18": 2.185453611111111,
              "2026-04-20": 73.09460583333333,
              "2026-04-22": 162.42378472222222,
              "2026-04-23": 10.72691888888889,
              "2026-04-24": 2.2204052777777776,
              "2026-04-27": 160.00315583333332,
              "2026-04-28": 44.389922500000004,
              "2026-04-29": 19.342809444444445,
              "2026-05-02": 0.27299444444444443,
              "2026-05-04": 219.0021102777778,
              "2026-05-05": 650.7460336111111,
              "2026-05-06": 1513.5424669444442,
              "2026-05-07": 2.3821930555555557,
              "2026-05-08": 35.61870555555556,
              "2026-05-09": 20.906869444444443,
              "2026-05-10": 67.14293611111111,
              "2026-05-11": 0.46896222222222217,
              "2026-05-12": 334.18457611111114,
              "2026-05-13": 143.1730636111111,
              "2026-05-14": 2.1729072222222223,
              "2026-05-15": 11.125628888888889,
              "2026-05-16": 3.3792980555555556,
              "2026-05-18": 3.462464444444444,
              "2026-05-19": 50.86221666666667,
              "2026-05-20": 2.2973886111111113,
              "2026-05-21": 314.82150888888884,
              "2026-05-22": 2.5376255555555556,
              "2026-05-23": 2.543711388888889,
              "2026-05-25": 174.0750497222222,
              "2026-05-26": 31.322801388888887,
              "2026-05-27": 170.0999238888889,
              "2026-05-28": 26.74279861111111,
              "2026-05-29": 45.57301638888889,
              "2026-05-30": 1414.279821111111,
              "2026-06-01": 100.8101875,
              "2026-06-02": 139.92116083333332,
              "2026-06-03": 65.80446972222222,
              "2026-06-05": 90.01720583333334,
              "2026-06-08": 0.3132997222222222
            },
            "time_count_per_day": {
              "2025-10-10": 2,
              "2025-10-13": 2,
              "2025-10-17": 1,
              "2025-10-22": 2,
              "2025-10-27": 1,
              "2025-10-28": 2,
              "2025-10-31": 1,
              "2025-11-03": 8,
              "2025-11-04": 2,
              "2025-11-05": 4,
              "2025-11-06": 5,
              "2025-11-10": 7,
              "2025-11-12": 4,
              "2025-11-13": 5,
              "2025-11-14": 2,
              "2025-11-16": 1,
              "2025-11-17": 5,
              "2025-11-19": 3,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-11-25": 2,
              "2025-11-26": 3,
              "2025-11-27": 3,
              "2025-11-28": 3,
              "2025-11-29": 2,
              "2025-11-30": 2,
              "2025-12-02": 2,
              "2025-12-03": 8,
              "2025-12-04": 2,
              "2025-12-05": 2,
              "2025-12-09": 5,
              "2025-12-10": 3,
              "2025-12-11": 2,
              "2025-12-12": 1,
              "2025-12-15": 9,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-02": 2,
              "2026-01-05": 1,
              "2026-01-07": 1,
              "2026-01-08": 2,
              "2026-01-12": 1,
              "2026-01-13": 3,
              "2026-01-14": 1,
              "2026-01-15": 3,
              "2026-01-16": 2,
              "2026-01-17": 2,
              "2026-01-20": 5,
              "2026-01-21": 7,
              "2026-01-22": 3,
              "2026-01-23": 6,
              "2026-01-24": 3,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-29": 4,
              "2026-01-30": 1,
              "2026-02-02": 5,
              "2026-02-03": 2,
              "2026-02-04": 3,
              "2026-02-05": 1,
              "2026-02-06": 2,
              "2026-02-09": 3,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-02-12": 3,
              "2026-02-13": 7,
              "2026-02-16": 2,
              "2026-02-18": 4,
              "2026-02-19": 10,
              "2026-02-21": 2,
              "2026-02-23": 8,
              "2026-02-25": 1,
              "2026-02-27": 4,
              "2026-02-28": 5,
              "2026-03-01": 9,
              "2026-03-02": 12,
              "2026-03-03": 10,
              "2026-03-04": 3,
              "2026-03-05": 2,
              "2026-03-06": 3,
              "2026-03-08": 2,
              "2026-03-09": 5,
              "2026-03-11": 3,
              "2026-03-12": 5,
              "2026-03-13": 3,
              "2026-03-16": 4,
              "2026-03-17": 9,
              "2026-03-18": 24,
              "2026-03-19": 4,
              "2026-03-20": 2,
              "2026-03-23": 3,
              "2026-03-24": 4,
              "2026-03-25": 1,
              "2026-03-26": 4,
              "2026-03-27": 2,
              "2026-03-30": 9,
              "2026-03-31": 7,
              "2026-04-01": 2,
              "2026-04-04": 2,
              "2026-04-06": 4,
              "2026-04-07": 3,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-14": 6,
              "2026-04-17": 9,
              "2026-04-18": 1,
              "2026-04-20": 2,
              "2026-04-22": 3,
              "2026-04-23": 2,
              "2026-04-24": 2,
              "2026-04-27": 8,
              "2026-04-28": 3,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-04": 6,
              "2026-05-05": 5,
              "2026-05-06": 5,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 3,
              "2026-05-10": 1,
              "2026-05-11": 1,
              "2026-05-12": 7,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-15": 2,
              "2026-05-16": 2,
              "2026-05-18": 1,
              "2026-05-19": 4,
              "2026-05-20": 1,
              "2026-05-21": 5,
              "2026-05-22": 2,
              "2026-05-23": 1,
              "2026-05-25": 4,
              "2026-05-26": 3,
              "2026-05-27": 5,
              "2026-05-28": 3,
              "2026-05-29": 4,
              "2026-05-30": 1,
              "2026-06-01": 6,
              "2026-06-02": 6,
              "2026-06-03": 5,
              "2026-06-05": 5,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 39.61,
              "mode_time_hours": 7.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 4,
                "6-8h": 8,
                "8-10h": 3,
                "10-12h": 2,
                "12-14h": 2,
                "14-16h": 1,
                "18-20h": 2,
                "20-22h": 3,
                "24-26h": 1,
                "26-28h": 2,
                "28-30h": 1,
                "30-32h": 3,
                "32-34h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "48-50h": 2,
                "52-54h": 1,
                "54-56h": 3,
                "56-58h": 1,
                "58-60h": 1,
                "66-68h": 3,
                "74-76h": 1,
                "82-84h": 1,
                "84-86h": 1,
                "132-134h": 1,
                "306-308h": 1,
                "402-404h": 1
              },
              "tickets_count": 58,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-03": 3,
                "2025-12-09": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2026-01-12": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-09": 2,
                "2026-02-23": 3,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 3,
                "2026-03-17": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-31": 3,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-04-14": 2,
                "2026-04-17": 1,
                "2026-04-20": 2,
                "2026-05-04": 4,
                "2026-05-06": 1,
                "2026-05-10": 1,
                "2026-05-12": 1,
                "2026-05-25": 2,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-11-06": 27.529957777777778,
                "2025-11-10": 6.358011944444445,
                "2025-11-13": 14.662340833333333,
                "2025-11-27": 10.394558611111112,
                "2025-11-28": 12.524309722222222,
                "2025-12-03": 13.04123111111111,
                "2025-12-09": 6.758991944444444,
                "2025-12-11": 41.06377166666667,
                "2025-12-15": 133.2801411111111,
                "2026-01-12": 8.473508055555556,
                "2026-01-13": 30.37377027777778,
                "2026-01-22": 0.3549558333333333,
                "2026-01-23": 8.193075833333333,
                "2026-01-29": 6.405734166666667,
                "2026-01-30": 26.27584722222222,
                "2026-02-02": 79.56966555555556,
                "2026-02-03": 29.762671666666666,
                "2026-02-04": 54.2752175,
                "2026-02-09": 4.529368333333334,
                "2026-02-23": 20.873534166666666,
                "2026-03-02": 109.2712363888889,
                "2026-03-03": 67.82572,
                "2026-03-11": 1.631247222222222,
                "2026-03-12": 1.6545927777777776,
                "2026-03-13": 54.25776416666666,
                "2026-03-17": 402.9234177777778,
                "2026-03-23": 53.183791666666664,
                "2026-03-24": 32.702583611111116,
                "2026-03-31": 82.55449527777778,
                "2026-04-01": 18.798235,
                "2026-04-06": 61.578377499999995,
                "2026-04-14": 20.964566666666666,
                "2026-04-17": 2.5466955555555555,
                "2026-04-20": 73.09460583333333,
                "2026-05-04": 168.2645161111111,
                "2026-05-06": 306.94763277777776,
                "2026-05-10": 67.14293611111111,
                "2026-05-12": 25.412093055555555,
                "2026-05-25": 168.9372897222222,
                "2026-06-05": 42.998759444444445
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-13": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-03": 3,
                "2025-12-09": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2026-01-12": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-02": 2,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-09": 2,
                "2026-02-23": 3,
                "2026-03-02": 2,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 3,
                "2026-03-17": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-31": 3,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-04-14": 2,
                "2026-04-17": 1,
                "2026-04-20": 2,
                "2026-05-04": 4,
                "2026-05-06": 1,
                "2026-05-10": 1,
                "2026-05-12": 1,
                "2026-05-25": 2,
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 70.31,
              "mode_time_hours": 1.0,
              "mode_frequency": 68,
              "time_distribution": {
                "0-2h": 68,
                "2-4h": 28,
                "4-6h": 14,
                "6-8h": 10,
                "8-10h": 6,
                "10-12h": 3,
                "12-14h": 5,
                "14-16h": 2,
                "16-18h": 5,
                "18-20h": 14,
                "20-22h": 17,
                "22-24h": 1,
                "24-26h": 5,
                "26-28h": 1,
                "28-30h": 7,
                "30-32h": 4,
                "32-34h": 11,
                "34-36h": 2,
                "40-42h": 6,
                "42-44h": 14,
                "44-46h": 6,
                "48-50h": 1,
                "50-52h": 1,
                "52-54h": 1,
                "54-56h": 3,
                "56-58h": 2,
                "58-60h": 1,
                "60-62h": 1,
                "66-68h": 10,
                "68-70h": 5,
                "70-72h": 1,
                "72-74h": 1,
                "78-80h": 2,
                "80-82h": 1,
                "84-86h": 2,
                "86-88h": 1,
                "88-90h": 1,
                "90-92h": 3,
                "92-94h": 2,
                "96-98h": 1,
                "106-108h": 1,
                "114-116h": 1,
                "116-118h": 2,
                "132-134h": 1,
                "134-136h": 1,
                "138-140h": 5,
                "142-144h": 1,
                "144-146h": 1,
                "168-170h": 1,
                "170-172h": 1,
                "172-174h": 1,
                "180-182h": 1,
                "200-202h": 1,
                "208-210h": 1,
                "252-254h": 1,
                "260-262h": 1,
                "300-302h": 1,
                "306-308h": 1,
                "308-310h": 1,
                "314-316h": 1,
                "336-338h": 2,
                "338-340h": 2,
                "362-364h": 1,
                "384-386h": 1,
                "390-392h": 1,
                "404-406h": 4,
                "408-410h": 1,
                "414-416h": 1,
                "448-450h": 1,
                "504-506h": 1,
                "560-562h": 1,
                "816-818h": 1,
                "834-836h": 1,
                "990-992h": 1,
                "1018-1020h": 1,
                "1414-1416h": 1
              },
              "tickets_count": 315,
              "tickets_per_day": {
                "2025-10-22": 1,
                "2025-10-27": 1,
                "2025-10-28": 2,
                "2025-11-03": 8,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-10": 4,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-14": 2,
                "2025-11-16": 1,
                "2025-11-17": 4,
                "2025-11-21": 1,
                "2025-11-26": 2,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-02": 1,
                "2025-12-03": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-15": 4,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 2,
                "2026-01-16": 1,
                "2026-01-17": 1,
                "2026-01-20": 4,
                "2026-01-21": 5,
                "2026-01-22": 2,
                "2026-01-23": 4,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-29": 3,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-13": 4,
                "2026-02-16": 2,
                "2026-02-18": 4,
                "2026-02-23": 3,
                "2026-02-27": 4,
                "2026-02-28": 3,
                "2026-03-01": 9,
                "2026-03-02": 10,
                "2026-03-03": 9,
                "2026-03-04": 3,
                "2026-03-05": 2,
                "2026-03-06": 3,
                "2026-03-08": 2,
                "2026-03-09": 5,
                "2026-03-11": 1,
                "2026-03-12": 4,
                "2026-03-16": 4,
                "2026-03-17": 4,
                "2026-03-18": 3,
                "2026-03-19": 4,
                "2026-03-20": 2,
                "2026-03-23": 2,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-30": 8,
                "2026-03-31": 3,
                "2026-04-01": 1,
                "2026-04-04": 2,
                "2026-04-06": 2,
                "2026-04-07": 3,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-14": 4,
                "2026-04-17": 8,
                "2026-04-18": 1,
                "2026-04-22": 2,
                "2026-04-23": 2,
                "2026-04-24": 2,
                "2026-04-27": 8,
                "2026-04-28": 3,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-04": 2,
                "2026-05-05": 5,
                "2026-05-06": 4,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 3,
                "2026-05-11": 1,
                "2026-05-12": 6,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-15": 2,
                "2026-05-16": 2,
                "2026-05-18": 1,
                "2026-05-19": 4,
                "2026-05-20": 1,
                "2026-05-21": 5,
                "2026-05-22": 2,
                "2026-05-23": 1,
                "2026-05-25": 2,
                "2026-05-26": 3,
                "2026-05-27": 5,
                "2026-05-28": 3,
                "2026-05-29": 4,
                "2026-05-30": 1,
                "2026-06-01": 6,
                "2026-06-02": 6,
                "2026-06-03": 4,
                "2026-06-05": 4,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-22": 1.8562775,
                "2025-10-27": 0.3379758333333333,
                "2025-10-28": 87.47993277777778,
                "2025-11-03": 215.72651416666668,
                "2025-11-04": 55.39745861111111,
                "2025-11-05": 44.90738472222222,
                "2025-11-06": 12.695453888888888,
                "2025-11-10": 123.10042722222222,
                "2025-11-12": 22.101481944444444,
                "2025-11-13": 149.24600277777776,
                "2025-11-14": 45.1022225,
                "2025-11-16": 0.1001375,
                "2025-11-17": 67.06566138888888,
                "2025-11-21": 208.86265027777776,
                "2025-11-26": 26.057098055555556,
                "2025-11-27": 201.68683444444446,
                "2025-11-28": 62.737813333333335,
                "2025-11-29": 115.23021722222222,
                "2025-11-30": 85.22440611111112,
                "2025-12-02": 300.21015083333333,
                "2025-12-03": 14.814977500000001,
                "2025-12-05": 78.71027444444445,
                "2025-12-09": 93.66823666666667,
                "2025-12-10": 306.46787500000005,
                "2025-12-15": 851.0701366666668,
                "2025-12-17": 0.06531527777777778,
                "2025-12-18": 0.3389519444444445,
                "2026-01-02": 3.8647069444444444,
                "2026-01-05": 132.77725388888888,
                "2026-01-08": 97.9250663888889,
                "2026-01-13": 72.55373861111111,
                "2026-01-14": 20.660363888888888,
                "2026-01-15": 23.473886388888886,
                "2026-01-16": 5.125558055555555,
                "2026-01-17": 19.31415361111111,
                "2026-01-20": 196.7838413888889,
                "2026-01-21": 123.01705166666666,
                "2026-01-22": 22.66036666666667,
                "2026-01-23": 824.5126305555556,
                "2026-01-26": 116.35523416666666,
                "2026-01-27": 53.54542555555556,
                "2026-01-29": 46.182673888888885,
                "2026-02-02": 0.25120305555555555,
                "2026-02-03": 29.74483638888889,
                "2026-02-04": 27.421869166666667,
                "2026-02-13": 297.75387750000004,
                "2026-02-16": 69.98440861111112,
                "2026-02-18": 1035.6333213888888,
                "2026-02-23": 137.3179336111111,
                "2026-02-27": 97.94562583333334,
                "2026-02-28": 27.681361111111112,
                "2026-03-01": 380.9603463888889,
                "2026-03-02": 446.42713944444444,
                "2026-03-03": 347.82817805555555,
                "2026-03-04": 52.5657688888889,
                "2026-03-05": 51.90006138888889,
                "2026-03-06": 50.40215333333333,
                "2026-03-08": 0.020296944444444444,
                "2026-03-09": 1771.4054927777777,
                "2026-03-11": 144.20653777777778,
                "2026-03-12": 62.241975000000004,
                "2026-03-16": 17.35059972222222,
                "2026-03-17": 182.44545305555553,
                "2026-03-18": 103.21167694444445,
                "2026-03-19": 212.91002055555555,
                "2026-03-20": 998.1417583333333,
                "2026-03-23": 60.45186694444445,
                "2026-03-24": 1.3135041666666667,
                "2026-03-25": 19.957144722222225,
                "2026-03-26": 78.90550055555556,
                "2026-03-27": 67.33715083333333,
                "2026-03-30": 580.5914994444446,
                "2026-03-31": 54.68829666666666,
                "2026-04-01": 448.7687055555556,
                "2026-04-04": 6.223869722222222,
                "2026-04-06": 151.80395888888887,
                "2026-04-07": 130.33135305555555,
                "2026-04-08": 171.02021194444444,
                "2026-04-09": 42.646448888888884,
                "2026-04-10": 20.88860222222222,
                "2026-04-14": 1352.4631188888889,
                "2026-04-17": 2358.70539,
                "2026-04-18": 2.185453611111111,
                "2026-04-22": 40.398757222222216,
                "2026-04-23": 10.72691888888889,
                "2026-04-24": 2.2204052777777776,
                "2026-04-27": 160.00315583333332,
                "2026-04-28": 44.389922500000004,
                "2026-04-29": 19.342809444444445,
                "2026-05-02": 0.27299444444444443,
                "2026-05-04": 50.73759416666666,
                "2026-05-05": 650.7460336111111,
                "2026-05-06": 1206.5948341666665,
                "2026-05-07": 2.3821930555555557,
                "2026-05-08": 35.61870555555556,
                "2026-05-09": 20.906869444444443,
                "2026-05-11": 0.46896222222222217,
                "2026-05-12": 308.77248305555554,
                "2026-05-13": 143.1730636111111,
                "2026-05-14": 2.1729072222222223,
                "2026-05-15": 11.125628888888889,
                "2026-05-16": 3.3792980555555556,
                "2026-05-18": 3.462464444444444,
                "2026-05-19": 50.86221666666667,
                "2026-05-20": 2.2973886111111113,
                "2026-05-21": 314.82150888888884,
                "2026-05-22": 2.5376255555555556,
                "2026-05-23": 2.543711388888889,
                "2026-05-25": 5.13776,
                "2026-05-26": 31.322801388888887,
                "2026-05-27": 170.0999238888889,
                "2026-05-28": 26.74279861111111,
                "2026-05-29": 45.57301638888889,
                "2026-05-30": 1414.279821111111,
                "2026-06-01": 100.8101875,
                "2026-06-02": 139.92116083333332,
                "2026-06-03": 54.22771333333333,
                "2026-06-05": 47.01844638888889,
                "2026-06-08": 0.3132997222222222
              },
              "time_count_per_day": {
                "2025-10-22": 1,
                "2025-10-27": 1,
                "2025-10-28": 2,
                "2025-11-03": 8,
                "2025-11-04": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-10": 4,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-14": 2,
                "2025-11-16": 1,
                "2025-11-17": 4,
                "2025-11-21": 1,
                "2025-11-26": 2,
                "2025-11-27": 2,
                "2025-11-28": 2,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-02": 1,
                "2025-12-03": 2,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 1,
                "2025-12-15": 4,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 2,
                "2026-01-16": 1,
                "2026-01-17": 1,
                "2026-01-20": 4,
                "2026-01-21": 5,
                "2026-01-22": 2,
                "2026-01-23": 4,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-29": 3,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-13": 4,
                "2026-02-16": 2,
                "2026-02-18": 4,
                "2026-02-23": 3,
                "2026-02-27": 4,
                "2026-02-28": 3,
                "2026-03-01": 9,
                "2026-03-02": 10,
                "2026-03-03": 9,
                "2026-03-04": 3,
                "2026-03-05": 2,
                "2026-03-06": 3,
                "2026-03-08": 2,
                "2026-03-09": 5,
                "2026-03-11": 1,
                "2026-03-12": 4,
                "2026-03-16": 4,
                "2026-03-17": 4,
                "2026-03-18": 3,
                "2026-03-19": 4,
                "2026-03-20": 2,
                "2026-03-23": 2,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-03-27": 1,
                "2026-03-30": 8,
                "2026-03-31": 3,
                "2026-04-01": 1,
                "2026-04-04": 2,
                "2026-04-06": 2,
                "2026-04-07": 3,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-14": 4,
                "2026-04-17": 8,
                "2026-04-18": 1,
                "2026-04-22": 2,
                "2026-04-23": 2,
                "2026-04-24": 2,
                "2026-04-27": 8,
                "2026-04-28": 3,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-04": 2,
                "2026-05-05": 5,
                "2026-05-06": 4,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 3,
                "2026-05-11": 1,
                "2026-05-12": 6,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-15": 2,
                "2026-05-16": 2,
                "2026-05-18": 1,
                "2026-05-19": 4,
                "2026-05-20": 1,
                "2026-05-21": 5,
                "2026-05-22": 2,
                "2026-05-23": 1,
                "2026-05-25": 2,
                "2026-05-26": 3,
                "2026-05-27": 5,
                "2026-05-28": 3,
                "2026-05-29": 4,
                "2026-05-30": 1,
                "2026-06-01": 6,
                "2026-06-02": 6,
                "2026-06-03": 4,
                "2026-06-05": 4,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 223.2,
              "mode_time_hours": 9.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 4,
                "16-18h": 1,
                "20-22h": 2,
                "28-30h": 2,
                "54-56h": 1,
                "64-66h": 1,
                "74-76h": 1,
                "80-82h": 1,
                "90-92h": 1,
                "152-154h": 1,
                "174-176h": 1,
                "176-178h": 1,
                "316-318h": 1,
                "386-388h": 1,
                "422-424h": 1,
                "478-480h": 1,
                "490-492h": 1,
                "524-526h": 1,
                "714-716h": 1,
                "794-796h": 1,
                "896-898h": 1,
                "1732-1734h": 1
              },
              "tickets_count": 35,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-26": 1,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-12": 1,
                "2025-12-15": 2,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 1,
                "2026-01-23": 1,
                "2026-02-02": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 3,
                "2026-03-11": 1,
                "2026-03-27": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-11-04": 4.008627222222223,
                "2025-11-17": 1.021188611111111,
                "2025-11-19": 9.841457222222221,
                "2025-11-24": 64.44629277777778,
                "2025-11-25": 91.64814666666666,
                "2025-11-26": 386.2168741666667,
                "2025-12-09": 172.33661972222222,
                "2025-12-10": 197.4414911111111,
                "2025-12-12": 74.52195166666667,
                "2025-12-15": 795.4829358333333,
                "2025-12-26": 715.1154475,
                "2026-01-07": 795.735585,
                "2026-01-08": 1.8367327777777778,
                "2026-01-13": 2.0666180555555553,
                "2026-01-15": 80.56043388888888,
                "2026-01-16": 6.811076944444444,
                "2026-01-20": 55.64463194444444,
                "2026-01-23": 3.683469722222222,
                "2026-02-02": 3.609780833333333,
                "2026-02-04": 20.13593,
                "2026-02-10": 525.3461619444445,
                "2026-02-11": 8.980015833333333,
                "2026-02-12": 2646.7278377777775,
                "2026-02-13": 233.4745961111111,
                "2026-03-11": 896.9744666666667,
                "2026-03-27": 16.7574575,
                "2026-03-31": 1.5595241666666668
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-26": 1,
                "2025-12-09": 3,
                "2025-12-10": 2,
                "2025-12-12": 1,
                "2025-12-15": 2,
                "2025-12-26": 1,
                "2026-01-07": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 1,
                "2026-01-23": 1,
                "2026-02-02": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-12": 3,
                "2026-02-13": 3,
                "2026-03-11": 1,
                "2026-03-27": 1,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 161.66,
              "mode_time_hours": 17.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 2,
                "8-10h": 2,
                "10-12h": 4,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 4,
                "24-26h": 2,
                "28-30h": 1,
                "36-38h": 1,
                "42-44h": 1,
                "44-46h": 4,
                "46-48h": 1,
                "50-52h": 3,
                "52-54h": 1,
                "56-58h": 2,
                "66-68h": 2,
                "70-72h": 1,
                "76-78h": 1,
                "80-82h": 1,
                "86-88h": 1,
                "94-96h": 2,
                "98-100h": 2,
                "102-104h": 1,
                "104-106h": 2,
                "112-114h": 1,
                "114-116h": 1,
                "120-122h": 3,
                "122-124h": 1,
                "138-140h": 1,
                "140-142h": 2,
                "144-146h": 1,
                "146-148h": 1,
                "148-150h": 1,
                "162-164h": 1,
                "166-168h": 1,
                "172-174h": 1,
                "186-188h": 1,
                "198-200h": 1,
                "212-214h": 1,
                "228-230h": 1,
                "240-242h": 1,
                "324-326h": 1,
                "338-340h": 1,
                "386-388h": 1,
                "388-390h": 1,
                "398-400h": 1,
                "406-408h": 1,
                "408-410h": 1,
                "424-426h": 1,
                "432-434h": 1,
                "448-450h": 1,
                "454-456h": 1,
                "456-458h": 1,
                "462-464h": 1,
                "474-476h": 1,
                "492-494h": 1,
                "622-624h": 1,
                "652-654h": 1,
                "654-656h": 1
              },
              "tickets_count": 83,
              "tickets_per_day": {
                "2025-10-10": 2,
                "2025-10-13": 2,
                "2025-10-17": 1,
                "2025-10-22": 1,
                "2025-10-31": 1,
                "2025-11-05": 3,
                "2025-11-06": 3,
                "2025-11-10": 2,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-19": 2,
                "2025-11-21": 1,
                "2025-11-25": 1,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-03": 2,
                "2025-12-04": 2,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-17": 1,
                "2026-01-21": 2,
                "2026-01-24": 3,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-09": 1,
                "2026-02-11": 1,
                "2026-02-21": 2,
                "2026-02-23": 2,
                "2026-02-25": 1,
                "2026-02-28": 2,
                "2026-03-17": 4,
                "2026-03-18": 21,
                "2026-03-24": 1,
                "2026-03-26": 3,
                "2026-03-30": 1,
                "2026-04-22": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-10-10": 110.0244586111111,
                "2025-10-13": 226.76580166666668,
                "2025-10-17": 24.595296111111114,
                "2025-10-22": 167.75723055555557,
                "2025-10-31": 47.19441833333333,
                "2025-11-05": 371.41539083333333,
                "2025-11-06": 232.91048722222226,
                "2025-11-10": 96.20770277777778,
                "2025-11-12": 89.15931111111112,
                "2025-11-13": 122.35577083333334,
                "2025-11-19": 293.5301944444444,
                "2025-11-21": 241.33788194444443,
                "2025-11-25": 9.190666111111112,
                "2025-11-29": 463.29808722222225,
                "2025-11-30": 44.71778611111111,
                "2025-12-03": 20.439880833333333,
                "2025-12-04": 147.24221555555556,
                "2025-12-15": 50.14469,
                "2026-01-02": 11.003673055555556,
                "2026-01-17": 4.429736388888888,
                "2026-01-21": 134.15526972222222,
                "2026-01-24": 294.5730658333333,
                "2026-01-27": 87.59708722222223,
                "2026-02-02": 2.757923055555555,
                "2026-02-05": 147.9869963888889,
                "2026-02-06": 442.67577000000006,
                "2026-02-09": 81.7746261111111,
                "2026-02-11": 228.2451722222222,
                "2026-02-21": 34.822161111111114,
                "2026-02-23": 106.12320861111111,
                "2026-02-25": 0.16812472222222222,
                "2026-02-28": 55.543055833333334,
                "2026-03-17": 85.3075425,
                "2026-03-18": 6731.762303333334,
                "2026-03-24": 95.32014000000001,
                "2026-03-26": 1931.2074002777777,
                "2026-03-30": 50.611542500000006,
                "2026-04-22": 122.0250275,
                "2026-06-03": 11.576756388888889
              },
              "time_count_per_day": {
                "2025-10-10": 2,
                "2025-10-13": 2,
                "2025-10-17": 1,
                "2025-10-22": 1,
                "2025-10-31": 1,
                "2025-11-05": 3,
                "2025-11-06": 3,
                "2025-11-10": 2,
                "2025-11-12": 2,
                "2025-11-13": 2,
                "2025-11-19": 2,
                "2025-11-21": 1,
                "2025-11-25": 1,
                "2025-11-29": 1,
                "2025-11-30": 1,
                "2025-12-03": 2,
                "2025-12-04": 2,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-17": 1,
                "2026-01-21": 2,
                "2026-01-24": 3,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-05": 1,
                "2026-02-06": 2,
                "2026-02-09": 1,
                "2026-02-11": 1,
                "2026-02-21": 2,
                "2026-02-23": 2,
                "2026-02-25": 1,
                "2026-02-28": 2,
                "2026-03-17": 4,
                "2026-03-18": 21,
                "2026-03-24": 1,
                "2026-03-26": 3,
                "2026-03-30": 1,
                "2026-04-22": 1,
                "2026-06-03": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 424.24,
              "mode_time_hours": 495.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "136-138h": 1,
                "142-144h": 1,
                "158-160h": 1,
                "160-162h": 1,
                "240-242h": 1,
                "306-308h": 1,
                "318-320h": 1,
                "494-496h": 1,
                "522-524h": 1,
                "692-694h": 1,
                "736-738h": 1,
                "804-806h": 1,
                "1216-1218h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2026-02-19": 10
              },
              "time_per_day": {
                "2025-12-02": 136.53833916666667,
                "2025-12-03": 4.618305833333334,
                "2025-12-11": 495.9739572222222,
                "2025-12-15": 318.8131186111111,
                "2026-02-19": 4983.427045277776
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-11": 1,
                "2025-12-15": 1,
                "2026-02-19": 10
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-02-16": 1,
              "2026-02-20": 1,
              "2026-02-28": 1,
              "2026-03-11": 1,
              "2026-03-21": 1,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-16": 1,
              "2026-05-11": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-28": 1,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-16": 1,
                "2026-05-11": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-16": 1,
                "2026-02-20": 1,
                "2026-03-11": 1,
                "2026-03-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-20": 1,
              "2026-05-28": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-20": 1,
                "2026-05-28": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 22,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2026-02-23": 1,
              "2026-03-02": 2,
              "2026-03-28": 1,
              "2026-03-31": 1,
              "2026-04-16": 1,
              "2026-05-06": 5,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-28": 1,
              "2026-06-02": 1,
              "2026-06-03": 4
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-04-16": 1,
                "2026-06-03": 4
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-03-28": 1,
                "2026-03-31": 1,
                "2026-05-06": 5,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-28": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-04-01": 1,
              "2026-04-24": 1,
              "2026-05-23": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-04-01": 1,
                "2026-04-24": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_115": {
      "overall": {
        "avg_time_hours": 208.82,
        "mode_time_hours": 1.0,
        "mode_frequency": 14,
        "time_distribution": {
          "0-2h": 14,
          "2-4h": 8,
          "4-6h": 4,
          "6-8h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "48-50h": 1,
          "56-58h": 1,
          "64-66h": 4,
          "66-68h": 2,
          "68-70h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "80-82h": 1,
          "98-100h": 1,
          "100-102h": 1,
          "124-126h": 1,
          "126-128h": 2,
          "190-192h": 1,
          "226-228h": 1,
          "266-268h": 1,
          "364-366h": 1,
          "378-380h": 1,
          "424-426h": 1,
          "516-518h": 2,
          "522-524h": 1,
          "530-532h": 1,
          "582-584h": 1,
          "634-636h": 1,
          "708-710h": 1,
          "812-814h": 1,
          "816-818h": 1,
          "866-868h": 1,
          "890-892h": 1,
          "1054-1056h": 1,
          "1158-1160h": 1,
          "1180-1182h": 1
        },
        "tickets_count": 70,
        "tickets_per_day": {
          "2025-10-08": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-17": 1,
          "2025-10-27": 2,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-11-12": 4,
          "2025-11-13": 2,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2025-12-06": 1,
          "2025-12-08": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-05": 1,
          "2026-01-13": 5,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-21": 3,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 3,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-11": 1,
          "2026-02-12": 2,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-05": 1,
          "2026-03-12": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-04-02": 1,
          "2026-04-04": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-22": 2,
          "2026-04-23": 2,
          "2026-04-24": 1,
          "2026-04-30": 1,
          "2026-05-12": 1,
          "2026-06-03": 1,
          "2026-06-05": 2,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-08": 1.7073763888888889,
          "2025-10-13": 101.76109638888889,
          "2025-10-14": 0.7447422222222223,
          "2025-10-17": 5.877694444444445,
          "2025-10-27": 7.5735166666666665,
          "2025-11-04": 0.20167249999999998,
          "2025-11-06": 6.498856666666667,
          "2025-11-12": 11.534833333333333,
          "2025-11-13": 54.48591944444444,
          "2025-11-20": 378.6008102777777,
          "2025-11-21": 530.4821577777777,
          "2025-11-24": 72.3816261111111,
          "2025-12-04": 1.6748691666666669,
          "2025-12-06": 66.72490305555556,
          "2025-12-08": 124.1030525,
          "2025-12-15": 69.63751861111112,
          "2025-12-19": 226.8685688888889,
          "2026-01-05": 635.7389622222222,
          "2026-01-13": 327.1533072222222,
          "2026-01-14": 5.048978333333333,
          "2026-01-17": 127.2554925,
          "2026-01-21": 869.5080772222223,
          "2026-01-27": 126.08799138888888,
          "2026-01-29": 23.1520225,
          "2026-02-03": 2215.7717555555555,
          "2026-02-06": 365.6095394444444,
          "2026-02-10": 267.6237225,
          "2026-02-11": 1.2553952777777777,
          "2026-02-12": 124.63586749999999,
          "2026-02-14": 424.3768836111111,
          "2026-02-19": 709.1718444444444,
          "2026-02-27": 5.651159166666666,
          "2026-02-28": 80.45731444444445,
          "2026-03-05": 1.1620891666666666,
          "2026-03-12": 523.3894827777777,
          "2026-03-20": 866.4556611111111,
          "2026-03-27": 582.9000422222222,
          "2026-04-02": 0.08119861111111111,
          "2026-04-04": 2.9835783333333334,
          "2026-04-06": 3.6813788888888888,
          "2026-04-08": 190.34037750000002,
          "2026-04-14": 125.65608222222221,
          "2026-04-22": 2214.679811111111,
          "2026-04-23": 1708.6532752777775,
          "2026-04-24": 3.516017222222222,
          "2026-04-30": 1.6336436111111112,
          "2026-05-12": 1.3543541666666667,
          "2026-06-03": 0.9676366666666667,
          "2026-06-05": 3.055102777777778,
          "2026-06-06": 0.05984083333333333
        },
        "time_count_per_day": {
          "2025-10-08": 1,
          "2025-10-13": 1,
          "2025-10-14": 1,
          "2025-10-17": 1,
          "2025-10-27": 2,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-11-12": 4,
          "2025-11-13": 2,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2025-12-06": 1,
          "2025-12-08": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-05": 1,
          "2026-01-13": 5,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-21": 2,
          "2026-01-27": 1,
          "2026-01-29": 1,
          "2026-02-03": 3,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-11": 1,
          "2026-02-12": 2,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-05": 1,
          "2026-03-12": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-04-02": 1,
          "2026-04-04": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-22": 2,
          "2026-04-23": 2,
          "2026-04-24": 1,
          "2026-04-30": 1,
          "2026-05-12": 1,
          "2026-06-03": 1,
          "2026-06-05": 2,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 199.3,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "56-58h": 1,
            "890-892h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2026-01-21": 1,
            "2026-01-29": 1,
            "2026-02-11": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-11-13": 24.50259361111111,
            "2026-01-21": 56.02625,
            "2026-01-29": 23.1520225,
            "2026-02-11": 1.2553952777777777,
            "2026-04-23": 891.5824477777777
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2026-01-21": 1,
            "2026-01-29": 1,
            "2026-02-11": 1,
            "2026-04-23": 1
          }
        },
        "P2": {
          "avg_time_hours": 199.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 13,
          "time_distribution": {
            "0-2h": 13,
            "2-4h": 8,
            "4-6h": 4,
            "6-8h": 1,
            "26-28h": 1,
            "48-50h": 1,
            "64-66h": 4,
            "66-68h": 2,
            "68-70h": 1,
            "98-100h": 1,
            "190-192h": 1,
            "226-228h": 1,
            "266-268h": 1,
            "424-426h": 1,
            "522-524h": 1,
            "530-532h": 1,
            "582-584h": 1,
            "634-636h": 1,
            "812-814h": 1,
            "816-818h": 1,
            "866-868h": 1,
            "1054-1056h": 1,
            "1158-1160h": 1,
            "1180-1182h": 1
          },
          "tickets_count": 50,
          "tickets_per_day": {
            "2025-10-08": 1,
            "2025-10-14": 1,
            "2025-10-17": 1,
            "2025-10-27": 2,
            "2025-11-04": 1,
            "2025-11-06": 2,
            "2025-11-12": 4,
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2025-12-06": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-05": 1,
            "2026-01-13": 5,
            "2026-01-14": 1,
            "2026-01-21": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-02-27": 1,
            "2026-03-05": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-02": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-14": 2,
            "2026-04-22": 2,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-30": 1,
            "2026-05-12": 1,
            "2026-06-03": 1,
            "2026-06-05": 2,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-08": 1.7073763888888889,
            "2025-10-14": 0.7447422222222223,
            "2025-10-17": 5.877694444444445,
            "2025-10-27": 7.5735166666666665,
            "2025-11-04": 0.20167249999999998,
            "2025-11-06": 6.498856666666667,
            "2025-11-12": 11.534833333333333,
            "2025-11-21": 530.4821577777777,
            "2025-12-04": 1.6748691666666669,
            "2025-12-06": 66.72490305555556,
            "2025-12-15": 69.63751861111112,
            "2025-12-19": 226.8685688888889,
            "2026-01-05": 635.7389622222222,
            "2026-01-13": 327.1533072222222,
            "2026-01-14": 5.048978333333333,
            "2026-01-21": 813.4818272222223,
            "2026-02-03": 1181.8624252777777,
            "2026-02-10": 267.6237225,
            "2026-02-12": 49.47417333333333,
            "2026-02-14": 424.3768836111111,
            "2026-02-27": 5.651159166666666,
            "2026-03-05": 1.1620891666666666,
            "2026-03-12": 523.3894827777777,
            "2026-03-20": 866.4556611111111,
            "2026-03-27": 582.9000422222222,
            "2026-04-02": 0.08119861111111111,
            "2026-04-04": 2.9835783333333334,
            "2026-04-06": 3.6813788888888888,
            "2026-04-08": 190.34037750000002,
            "2026-04-14": 125.65608222222221,
            "2026-04-22": 2214.679811111111,
            "2026-04-23": 817.0708275,
            "2026-04-24": 3.516017222222222,
            "2026-04-30": 1.6336436111111112,
            "2026-05-12": 1.3543541666666667,
            "2026-06-03": 0.9676366666666667,
            "2026-06-05": 3.055102777777778,
            "2026-06-06": 0.05984083333333333
          },
          "time_count_per_day": {
            "2025-10-08": 1,
            "2025-10-14": 1,
            "2025-10-17": 1,
            "2025-10-27": 2,
            "2025-11-04": 1,
            "2025-11-06": 2,
            "2025-11-12": 4,
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2025-12-06": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-05": 1,
            "2026-01-13": 5,
            "2026-01-14": 1,
            "2026-01-21": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-02-27": 1,
            "2026-03-05": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-02": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-14": 2,
            "2026-04-22": 2,
            "2026-04-23": 1,
            "2026-04-24": 1,
            "2026-04-30": 1,
            "2026-05-12": 1,
            "2026-06-03": 1,
            "2026-06-05": 2,
            "2026-06-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 371.92,
          "mode_time_hours": 517.0,
          "mode_frequency": 2,
          "time_distribution": {
            "74-76h": 1,
            "378-380h": 1,
            "516-518h": 2
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-20": 1,
            "2026-02-03": 2,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-20": 378.6008102777777,
            "2026-02-03": 1033.9093302777778,
            "2026-02-12": 75.16169416666666
          },
          "time_count_per_day": {
            "2025-11-20": 1,
            "2026-02-03": 2,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 129.38,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1,
            "72-74h": 1,
            "80-82h": 1,
            "100-102h": 1,
            "126-128h": 1,
            "364-366h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2026-01-27": 1,
            "2026-02-06": 1,
            "2026-02-28": 1
          },
          "time_per_day": {
            "2025-10-13": 101.76109638888889,
            "2025-11-13": 29.983325833333332,
            "2025-11-24": 72.3816261111111,
            "2026-01-27": 126.08799138888888,
            "2026-02-06": 365.6095394444444,
            "2026-02-28": 80.45731444444445
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2026-01-27": 1,
            "2026-02-06": 1,
            "2026-02-28": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 320.18,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1,
            "126-128h": 1,
            "708-710h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-08": 1,
            "2026-01-17": 1,
            "2026-01-21": 1,
            "2026-02-19": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-12-08": 124.1030525,
            "2026-01-17": 127.2554925,
            "2026-02-19": 709.1718444444444
          },
          "time_count_per_day": {
            "2025-12-08": 1,
            "2026-01-17": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 208.82,
            "mode_time_hours": 1.0,
            "mode_frequency": 14,
            "time_distribution": {
              "0-2h": 14,
              "2-4h": 8,
              "4-6h": 4,
              "6-8h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "48-50h": 1,
              "56-58h": 1,
              "64-66h": 4,
              "66-68h": 2,
              "68-70h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "80-82h": 1,
              "98-100h": 1,
              "100-102h": 1,
              "124-126h": 1,
              "126-128h": 2,
              "190-192h": 1,
              "226-228h": 1,
              "266-268h": 1,
              "364-366h": 1,
              "378-380h": 1,
              "424-426h": 1,
              "516-518h": 2,
              "522-524h": 1,
              "530-532h": 1,
              "582-584h": 1,
              "634-636h": 1,
              "708-710h": 1,
              "812-814h": 1,
              "816-818h": 1,
              "866-868h": 1,
              "890-892h": 1,
              "1054-1056h": 1,
              "1158-1160h": 1,
              "1180-1182h": 1
            },
            "tickets_count": 68,
            "tickets_per_day": {
              "2025-10-08": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-17": 1,
              "2025-10-27": 2,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-11-12": 4,
              "2025-11-13": 2,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2025-12-06": 1,
              "2025-12-08": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-05": 1,
              "2026-01-13": 5,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-21": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 3,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-11": 1,
              "2026-02-12": 2,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-12": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-02": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-14": 2,
              "2026-04-22": 2,
              "2026-04-23": 2,
              "2026-04-24": 1,
              "2026-04-30": 1,
              "2026-05-12": 1,
              "2026-06-03": 1,
              "2026-06-05": 2,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2025-10-08": 1.7073763888888889,
              "2025-10-13": 101.76109638888889,
              "2025-10-14": 0.7447422222222223,
              "2025-10-17": 5.877694444444445,
              "2025-10-27": 7.5735166666666665,
              "2025-11-04": 0.20167249999999998,
              "2025-11-06": 6.498856666666667,
              "2025-11-12": 11.534833333333333,
              "2025-11-13": 54.48591944444444,
              "2025-11-20": 378.6008102777777,
              "2025-11-21": 530.4821577777777,
              "2025-11-24": 72.3816261111111,
              "2025-12-04": 1.6748691666666669,
              "2025-12-06": 66.72490305555556,
              "2025-12-08": 124.1030525,
              "2025-12-15": 69.63751861111112,
              "2025-12-19": 226.8685688888889,
              "2026-01-05": 635.7389622222222,
              "2026-01-13": 327.1533072222222,
              "2026-01-14": 5.048978333333333,
              "2026-01-17": 127.2554925,
              "2026-01-21": 869.5080772222223,
              "2026-01-27": 126.08799138888888,
              "2026-01-29": 23.1520225,
              "2026-02-03": 2215.7717555555555,
              "2026-02-06": 365.6095394444444,
              "2026-02-10": 267.6237225,
              "2026-02-11": 1.2553952777777777,
              "2026-02-12": 124.63586749999999,
              "2026-02-14": 424.3768836111111,
              "2026-02-19": 709.1718444444444,
              "2026-02-27": 5.651159166666666,
              "2026-02-28": 80.45731444444445,
              "2026-03-05": 1.1620891666666666,
              "2026-03-12": 523.3894827777777,
              "2026-03-20": 866.4556611111111,
              "2026-03-27": 582.9000422222222,
              "2026-04-02": 0.08119861111111111,
              "2026-04-04": 2.9835783333333334,
              "2026-04-06": 3.6813788888888888,
              "2026-04-08": 190.34037750000002,
              "2026-04-14": 125.65608222222221,
              "2026-04-22": 2214.679811111111,
              "2026-04-23": 1708.6532752777775,
              "2026-04-24": 3.516017222222222,
              "2026-04-30": 1.6336436111111112,
              "2026-05-12": 1.3543541666666667,
              "2026-06-03": 0.9676366666666667,
              "2026-06-05": 3.055102777777778,
              "2026-06-06": 0.05984083333333333
            },
            "time_count_per_day": {
              "2025-10-08": 1,
              "2025-10-13": 1,
              "2025-10-14": 1,
              "2025-10-17": 1,
              "2025-10-27": 2,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-11-12": 4,
              "2025-11-13": 2,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2025-12-06": 1,
              "2025-12-08": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-05": 1,
              "2026-01-13": 5,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-21": 2,
              "2026-01-27": 1,
              "2026-01-29": 1,
              "2026-02-03": 3,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-11": 1,
              "2026-02-12": 2,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-05": 1,
              "2026-03-12": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-02": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-14": 2,
              "2026-04-22": 2,
              "2026-04-23": 2,
              "2026-04-24": 1,
              "2026-04-30": 1,
              "2026-05-12": 1,
              "2026-06-03": 1,
              "2026-06-05": 2,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 199.3,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "56-58h": 1,
                "890-892h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2026-01-21": 1,
                "2026-01-29": 1,
                "2026-02-11": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-11-13": 24.50259361111111,
                "2026-01-21": 56.02625,
                "2026-01-29": 23.1520225,
                "2026-02-11": 1.2553952777777777,
                "2026-04-23": 891.5824477777777
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2026-01-21": 1,
                "2026-01-29": 1,
                "2026-02-11": 1,
                "2026-04-23": 1
              }
            },
            "P2": {
              "avg_time_hours": 199.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 13,
              "time_distribution": {
                "0-2h": 13,
                "2-4h": 8,
                "4-6h": 4,
                "6-8h": 1,
                "26-28h": 1,
                "48-50h": 1,
                "64-66h": 4,
                "66-68h": 2,
                "68-70h": 1,
                "98-100h": 1,
                "190-192h": 1,
                "226-228h": 1,
                "266-268h": 1,
                "424-426h": 1,
                "522-524h": 1,
                "530-532h": 1,
                "582-584h": 1,
                "634-636h": 1,
                "812-814h": 1,
                "816-818h": 1,
                "866-868h": 1,
                "1054-1056h": 1,
                "1158-1160h": 1,
                "1180-1182h": 1
              },
              "tickets_count": 50,
              "tickets_per_day": {
                "2025-10-08": 1,
                "2025-10-14": 1,
                "2025-10-17": 1,
                "2025-10-27": 2,
                "2025-11-04": 1,
                "2025-11-06": 2,
                "2025-11-12": 4,
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2025-12-06": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-05": 1,
                "2026-01-13": 5,
                "2026-01-14": 1,
                "2026-01-21": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-14": 1,
                "2026-02-27": 1,
                "2026-03-05": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-02": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-14": 2,
                "2026-04-22": 2,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-30": 1,
                "2026-05-12": 1,
                "2026-06-03": 1,
                "2026-06-05": 2,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-08": 1.7073763888888889,
                "2025-10-14": 0.7447422222222223,
                "2025-10-17": 5.877694444444445,
                "2025-10-27": 7.5735166666666665,
                "2025-11-04": 0.20167249999999998,
                "2025-11-06": 6.498856666666667,
                "2025-11-12": 11.534833333333333,
                "2025-11-21": 530.4821577777777,
                "2025-12-04": 1.6748691666666669,
                "2025-12-06": 66.72490305555556,
                "2025-12-15": 69.63751861111112,
                "2025-12-19": 226.8685688888889,
                "2026-01-05": 635.7389622222222,
                "2026-01-13": 327.1533072222222,
                "2026-01-14": 5.048978333333333,
                "2026-01-21": 813.4818272222223,
                "2026-02-03": 1181.8624252777777,
                "2026-02-10": 267.6237225,
                "2026-02-12": 49.47417333333333,
                "2026-02-14": 424.3768836111111,
                "2026-02-27": 5.651159166666666,
                "2026-03-05": 1.1620891666666666,
                "2026-03-12": 523.3894827777777,
                "2026-03-20": 866.4556611111111,
                "2026-03-27": 582.9000422222222,
                "2026-04-02": 0.08119861111111111,
                "2026-04-04": 2.9835783333333334,
                "2026-04-06": 3.6813788888888888,
                "2026-04-08": 190.34037750000002,
                "2026-04-14": 125.65608222222221,
                "2026-04-22": 2214.679811111111,
                "2026-04-23": 817.0708275,
                "2026-04-24": 3.516017222222222,
                "2026-04-30": 1.6336436111111112,
                "2026-05-12": 1.3543541666666667,
                "2026-06-03": 0.9676366666666667,
                "2026-06-05": 3.055102777777778,
                "2026-06-06": 0.05984083333333333
              },
              "time_count_per_day": {
                "2025-10-08": 1,
                "2025-10-14": 1,
                "2025-10-17": 1,
                "2025-10-27": 2,
                "2025-11-04": 1,
                "2025-11-06": 2,
                "2025-11-12": 4,
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2025-12-06": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-05": 1,
                "2026-01-13": 5,
                "2026-01-14": 1,
                "2026-01-21": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-14": 1,
                "2026-02-27": 1,
                "2026-03-05": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-02": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-14": 2,
                "2026-04-22": 2,
                "2026-04-23": 1,
                "2026-04-24": 1,
                "2026-04-30": 1,
                "2026-05-12": 1,
                "2026-06-03": 1,
                "2026-06-05": 2,
                "2026-06-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 371.92,
              "mode_time_hours": 517.0,
              "mode_frequency": 2,
              "time_distribution": {
                "74-76h": 1,
                "378-380h": 1,
                "516-518h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-20": 1,
                "2026-02-03": 2,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-20": 378.6008102777777,
                "2026-02-03": 1033.9093302777778,
                "2026-02-12": 75.16169416666666
              },
              "time_count_per_day": {
                "2025-11-20": 1,
                "2026-02-03": 2,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 129.38,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1,
                "72-74h": 1,
                "80-82h": 1,
                "100-102h": 1,
                "126-128h": 1,
                "364-366h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2026-01-27": 1,
                "2026-02-06": 1,
                "2026-02-28": 1
              },
              "time_per_day": {
                "2025-10-13": 101.76109638888889,
                "2025-11-13": 29.983325833333332,
                "2025-11-24": 72.3816261111111,
                "2026-01-27": 126.08799138888888,
                "2026-02-06": 365.6095394444444,
                "2026-02-28": 80.45731444444445
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2026-01-27": 1,
                "2026-02-06": 1,
                "2026-02-28": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 320.18,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1,
                "126-128h": 1,
                "708-710h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-08": 1,
                "2026-01-17": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-12-08": 124.1030525,
                "2026-01-17": 127.2554925,
                "2026-02-19": 709.1718444444444
              },
              "time_count_per_day": {
                "2025-12-08": 1,
                "2026-01-17": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_77": {
      "overall": {
        "avg_time_hours": 177.13,
        "mode_time_hours": 3.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 7,
          "4-6h": 1,
          "8-10h": 2,
          "10-12h": 2,
          "16-18h": 2,
          "18-20h": 1,
          "20-22h": 2,
          "22-24h": 5,
          "24-26h": 1,
          "32-34h": 3,
          "44-46h": 1,
          "60-62h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "126-128h": 1,
          "130-132h": 1,
          "142-144h": 1,
          "150-152h": 1,
          "176-178h": 1,
          "190-192h": 1,
          "196-198h": 1,
          "198-200h": 1,
          "204-206h": 1,
          "214-216h": 1,
          "224-226h": 1,
          "312-314h": 1,
          "356-358h": 1,
          "386-388h": 2,
          "454-456h": 1,
          "482-484h": 1,
          "546-548h": 1,
          "582-584h": 1,
          "642-644h": 2,
          "670-672h": 1,
          "906-908h": 1,
          "1096-1098h": 1
        },
        "tickets_count": 63,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-10-24": 2,
          "2025-11-04": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-12-02": 2,
          "2025-12-05": 1,
          "2026-01-07": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-02": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-11": 1,
          "2026-02-14": 5,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-27": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-12": 3,
          "2026-03-16": 1,
          "2026-03-17": 1,
          "2026-03-23": 2,
          "2026-03-25": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-07": 1,
          "2026-04-27": 2,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-07": 1,
          "2026-05-11": 2,
          "2026-05-14": 1,
          "2026-05-15": 4,
          "2026-05-18": 2,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-26": 1,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-10-23": 197.79105638888888,
          "2025-10-24": 229.7920022222222,
          "2025-11-04": 643.0679461111112,
          "2025-11-19": 177.05001166666668,
          "2025-11-21": 582.7987752777777,
          "2025-11-22": 22.165390833333333,
          "2025-12-02": 101.92630472222223,
          "2025-12-05": 22.662233055555557,
          "2026-01-07": 454.80400833333334,
          "2026-01-22": 35.49987055555555,
          "2026-01-23": 44.44125472222222,
          "2026-01-26": 96.48734277777778,
          "2026-02-02": 151.4911036111111,
          "2026-02-09": 528.2352141666668,
          "2026-02-10": 131.16075083333334,
          "2026-02-11": 2.057486111111111,
          "2026-02-14": 137.55963500000001,
          "2026-02-18": 126.34274166666667,
          "2026-02-19": 204.82091,
          "2026-02-20": 8.218855277777777,
          "2026-02-27": 1.3815463888888888,
          "2026-03-05": 546.88607,
          "2026-03-07": 10.713954444444443,
          "2026-03-12": 646.5778691666667,
          "2026-03-16": 2.6931619444444443,
          "2026-03-17": 199.31624472222222,
          "2026-03-23": 775.0866191666667,
          "2026-03-25": 16.96313472222222,
          "2026-03-27": 357.6804325,
          "2026-03-31": 70.02261666666666,
          "2026-04-07": 1097.5854602777779,
          "2026-04-27": 134.93732194444445,
          "2026-05-04": 2.414140277777778,
          "2026-05-05": 190.81702277777777,
          "2026-05-07": 32.06710638888889,
          "2026-05-11": 19.260620555555555,
          "2026-05-14": 642.2583833333334,
          "2026-05-15": 11.509483333333332,
          "2026-05-18": 1.7061144444444443,
          "2026-05-21": 16.518396944444444,
          "2026-05-26": 21.21796722222222,
          "2026-05-30": 906.4486791666667,
          "2026-06-05": 671.2827441666667
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-10-24": 2,
          "2025-11-04": 1,
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-12-02": 2,
          "2025-12-05": 1,
          "2026-01-07": 1,
          "2026-01-22": 2,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-02": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-11": 1,
          "2026-02-14": 5,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-27": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-12": 3,
          "2026-03-16": 1,
          "2026-03-17": 1,
          "2026-03-23": 2,
          "2026-03-25": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-07": 1,
          "2026-04-27": 2,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-07": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-15": 4,
          "2026-05-18": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 671.28,
          "mode_time_hours": 671.0,
          "mode_frequency": 1,
          "time_distribution": {
            "670-672h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-06-05": 671.2827441666667
          },
          "time_count_per_day": {
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 170.34,
          "mode_time_hours": 3.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 7,
            "4-6h": 1,
            "8-10h": 2,
            "10-12h": 1,
            "16-18h": 2,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 1,
            "32-34h": 1,
            "60-62h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "92-94h": 1,
            "96-98h": 1,
            "130-132h": 1,
            "142-144h": 1,
            "150-152h": 1,
            "190-192h": 1,
            "196-198h": 1,
            "198-200h": 1,
            "214-216h": 1,
            "312-314h": 1,
            "356-358h": 1,
            "386-388h": 2,
            "482-484h": 1,
            "582-584h": 1,
            "642-644h": 1,
            "906-908h": 1,
            "1096-1098h": 1
          },
          "tickets_count": 46,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-12-02": 2,
            "2026-01-26": 1,
            "2026-02-02": 1,
            "2026-02-09": 2,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-03-07": 1,
            "2026-03-12": 3,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-07": 1,
            "2026-04-27": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-07": 1,
            "2026-05-11": 2,
            "2026-05-14": 1,
            "2026-05-15": 4,
            "2026-05-18": 2,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-26": 1,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-23": 197.79105638888888,
            "2025-10-24": 4.462044722222222,
            "2025-11-21": 582.7987752777777,
            "2025-11-22": 22.165390833333333,
            "2025-12-02": 101.92630472222223,
            "2026-01-26": 96.48734277777778,
            "2026-02-02": 151.4911036111111,
            "2026-02-09": 528.2352141666668,
            "2026-02-10": 131.16075083333334,
            "2026-02-11": 2.057486111111111,
            "2026-02-20": 8.218855277777777,
            "2026-02-27": 1.3815463888888888,
            "2026-03-07": 10.713954444444443,
            "2026-03-12": 646.5778691666667,
            "2026-03-16": 2.6931619444444443,
            "2026-03-17": 199.31624472222222,
            "2026-03-23": 775.0866191666667,
            "2026-03-25": 16.96313472222222,
            "2026-03-27": 357.6804325,
            "2026-03-31": 70.02261666666666,
            "2026-04-07": 1097.5854602777779,
            "2026-04-27": 134.93732194444445,
            "2026-05-04": 2.414140277777778,
            "2026-05-05": 190.81702277777777,
            "2026-05-07": 32.06710638888889,
            "2026-05-11": 19.260620555555555,
            "2026-05-14": 642.2583833333334,
            "2026-05-15": 11.509483333333332,
            "2026-05-18": 1.7061144444444443,
            "2026-05-21": 16.518396944444444,
            "2026-05-26": 21.21796722222222,
            "2026-05-30": 906.4486791666667
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-12-02": 2,
            "2026-01-26": 1,
            "2026-02-02": 1,
            "2026-02-09": 2,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-03-07": 1,
            "2026-03-12": 3,
            "2026-03-16": 1,
            "2026-03-17": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-07": 1,
            "2026-04-27": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-07": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-15": 4,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 160.91,
          "mode_time_hours": 23.0,
          "mode_frequency": 4,
          "time_distribution": {
            "10-12h": 1,
            "22-24h": 4,
            "24-26h": 1,
            "32-34h": 2,
            "44-46h": 1,
            "126-128h": 1,
            "176-178h": 1,
            "224-226h": 1,
            "454-456h": 1,
            "546-548h": 1,
            "642-644h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-10-24": 1,
            "2025-11-04": 1,
            "2025-11-19": 1,
            "2025-12-05": 1,
            "2026-01-07": 1,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-02-14": 5,
            "2026-02-18": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2025-10-24": 225.32995749999998,
            "2025-11-04": 643.0679461111112,
            "2025-11-19": 177.05001166666668,
            "2025-12-05": 22.662233055555557,
            "2026-01-07": 454.80400833333334,
            "2026-01-22": 35.49987055555555,
            "2026-01-23": 44.44125472222222,
            "2026-02-14": 137.55963500000001,
            "2026-02-18": 126.34274166666667,
            "2026-03-05": 546.88607
          },
          "time_count_per_day": {
            "2025-10-24": 1,
            "2025-11-04": 1,
            "2025-11-19": 1,
            "2025-12-05": 1,
            "2026-01-07": 1,
            "2026-01-22": 2,
            "2026-01-23": 1,
            "2026-02-14": 5,
            "2026-02-18": 1,
            "2026-03-05": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 204.82,
          "mode_time_hours": 205.0,
          "mode_frequency": 1,
          "time_distribution": {
            "204-206h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 204.82091
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 177.13,
            "mode_time_hours": 3.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 7,
              "4-6h": 1,
              "8-10h": 2,
              "10-12h": 2,
              "16-18h": 2,
              "18-20h": 1,
              "20-22h": 2,
              "22-24h": 5,
              "24-26h": 1,
              "32-34h": 3,
              "44-46h": 1,
              "60-62h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "126-128h": 1,
              "130-132h": 1,
              "142-144h": 1,
              "150-152h": 1,
              "176-178h": 1,
              "190-192h": 1,
              "196-198h": 1,
              "198-200h": 1,
              "204-206h": 1,
              "214-216h": 1,
              "224-226h": 1,
              "312-314h": 1,
              "356-358h": 1,
              "386-388h": 2,
              "454-456h": 1,
              "482-484h": 1,
              "546-548h": 1,
              "582-584h": 1,
              "642-644h": 2,
              "670-672h": 1,
              "906-908h": 1,
              "1096-1098h": 1
            },
            "tickets_count": 58,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-10-24": 2,
              "2025-11-04": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-12-02": 2,
              "2025-12-05": 1,
              "2026-01-07": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-02": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-11": 1,
              "2026-02-14": 5,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-27": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-12": 3,
              "2026-03-16": 1,
              "2026-03-17": 1,
              "2026-03-23": 2,
              "2026-03-25": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-07": 1,
              "2026-04-27": 2,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-07": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-15": 4,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-23": 197.79105638888888,
              "2025-10-24": 229.7920022222222,
              "2025-11-04": 643.0679461111112,
              "2025-11-19": 177.05001166666668,
              "2025-11-21": 582.7987752777777,
              "2025-11-22": 22.165390833333333,
              "2025-12-02": 101.92630472222223,
              "2025-12-05": 22.662233055555557,
              "2026-01-07": 454.80400833333334,
              "2026-01-22": 35.49987055555555,
              "2026-01-23": 44.44125472222222,
              "2026-01-26": 96.48734277777778,
              "2026-02-02": 151.4911036111111,
              "2026-02-09": 528.2352141666668,
              "2026-02-10": 131.16075083333334,
              "2026-02-11": 2.057486111111111,
              "2026-02-14": 137.55963500000001,
              "2026-02-18": 126.34274166666667,
              "2026-02-19": 204.82091,
              "2026-02-20": 8.218855277777777,
              "2026-02-27": 1.3815463888888888,
              "2026-03-05": 546.88607,
              "2026-03-07": 10.713954444444443,
              "2026-03-12": 646.5778691666667,
              "2026-03-16": 2.6931619444444443,
              "2026-03-17": 199.31624472222222,
              "2026-03-23": 775.0866191666667,
              "2026-03-25": 16.96313472222222,
              "2026-03-27": 357.6804325,
              "2026-03-31": 70.02261666666666,
              "2026-04-07": 1097.5854602777779,
              "2026-04-27": 134.93732194444445,
              "2026-05-04": 2.414140277777778,
              "2026-05-05": 190.81702277777777,
              "2026-05-07": 32.06710638888889,
              "2026-05-11": 19.260620555555555,
              "2026-05-14": 642.2583833333334,
              "2026-05-15": 11.509483333333332,
              "2026-05-18": 1.7061144444444443,
              "2026-05-21": 16.518396944444444,
              "2026-05-26": 21.21796722222222,
              "2026-05-30": 906.4486791666667,
              "2026-06-05": 671.2827441666667
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-10-24": 2,
              "2025-11-04": 1,
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-12-02": 2,
              "2025-12-05": 1,
              "2026-01-07": 1,
              "2026-01-22": 2,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-02": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-11": 1,
              "2026-02-14": 5,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-27": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-12": 3,
              "2026-03-16": 1,
              "2026-03-17": 1,
              "2026-03-23": 2,
              "2026-03-25": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-07": 1,
              "2026-04-27": 2,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-07": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-15": 4,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 671.28,
              "mode_time_hours": 671.0,
              "mode_frequency": 1,
              "time_distribution": {
                "670-672h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-06-05": 671.2827441666667
              },
              "time_count_per_day": {
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 170.34,
              "mode_time_hours": 3.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 7,
                "4-6h": 1,
                "8-10h": 2,
                "10-12h": 1,
                "16-18h": 2,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 1,
                "32-34h": 1,
                "60-62h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "92-94h": 1,
                "96-98h": 1,
                "130-132h": 1,
                "142-144h": 1,
                "150-152h": 1,
                "190-192h": 1,
                "196-198h": 1,
                "198-200h": 1,
                "214-216h": 1,
                "312-314h": 1,
                "356-358h": 1,
                "386-388h": 2,
                "482-484h": 1,
                "582-584h": 1,
                "642-644h": 1,
                "906-908h": 1,
                "1096-1098h": 1
              },
              "tickets_count": 41,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-12-02": 2,
                "2026-01-26": 1,
                "2026-02-02": 1,
                "2026-02-09": 2,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-03-07": 1,
                "2026-03-12": 3,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-07": 1,
                "2026-04-27": 2,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-07": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-15": 4,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-10-23": 197.79105638888888,
                "2025-10-24": 4.462044722222222,
                "2025-11-21": 582.7987752777777,
                "2025-11-22": 22.165390833333333,
                "2025-12-02": 101.92630472222223,
                "2026-01-26": 96.48734277777778,
                "2026-02-02": 151.4911036111111,
                "2026-02-09": 528.2352141666668,
                "2026-02-10": 131.16075083333334,
                "2026-02-11": 2.057486111111111,
                "2026-02-20": 8.218855277777777,
                "2026-02-27": 1.3815463888888888,
                "2026-03-07": 10.713954444444443,
                "2026-03-12": 646.5778691666667,
                "2026-03-16": 2.6931619444444443,
                "2026-03-17": 199.31624472222222,
                "2026-03-23": 775.0866191666667,
                "2026-03-25": 16.96313472222222,
                "2026-03-27": 357.6804325,
                "2026-03-31": 70.02261666666666,
                "2026-04-07": 1097.5854602777779,
                "2026-04-27": 134.93732194444445,
                "2026-05-04": 2.414140277777778,
                "2026-05-05": 190.81702277777777,
                "2026-05-07": 32.06710638888889,
                "2026-05-11": 19.260620555555555,
                "2026-05-14": 642.2583833333334,
                "2026-05-15": 11.509483333333332,
                "2026-05-18": 1.7061144444444443,
                "2026-05-21": 16.518396944444444,
                "2026-05-26": 21.21796722222222,
                "2026-05-30": 906.4486791666667
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-12-02": 2,
                "2026-01-26": 1,
                "2026-02-02": 1,
                "2026-02-09": 2,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-03-07": 1,
                "2026-03-12": 3,
                "2026-03-16": 1,
                "2026-03-17": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-07": 1,
                "2026-04-27": 2,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-07": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-15": 4,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 160.91,
              "mode_time_hours": 23.0,
              "mode_frequency": 4,
              "time_distribution": {
                "10-12h": 1,
                "22-24h": 4,
                "24-26h": 1,
                "32-34h": 2,
                "44-46h": 1,
                "126-128h": 1,
                "176-178h": 1,
                "224-226h": 1,
                "454-456h": 1,
                "546-548h": 1,
                "642-644h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-10-24": 1,
                "2025-11-04": 1,
                "2025-11-19": 1,
                "2025-12-05": 1,
                "2026-01-07": 1,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-02-14": 5,
                "2026-02-18": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2025-10-24": 225.32995749999998,
                "2025-11-04": 643.0679461111112,
                "2025-11-19": 177.05001166666668,
                "2025-12-05": 22.662233055555557,
                "2026-01-07": 454.80400833333334,
                "2026-01-22": 35.49987055555555,
                "2026-01-23": 44.44125472222222,
                "2026-02-14": 137.55963500000001,
                "2026-02-18": 126.34274166666667,
                "2026-03-05": 546.88607
              },
              "time_count_per_day": {
                "2025-10-24": 1,
                "2025-11-04": 1,
                "2025-11-19": 1,
                "2025-12-05": 1,
                "2026-01-07": 1,
                "2026-01-22": 2,
                "2026-01-23": 1,
                "2026-02-14": 5,
                "2026-02-18": 1,
                "2026-03-05": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 204.82,
              "mode_time_hours": 205.0,
              "mode_frequency": 1,
              "time_distribution": {
                "204-206h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 204.82091
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-18": 1,
              "2026-06-01": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-18": 1,
                "2026-06-01": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_205": {
      "overall": {
        "avg_time_hours": 25.85,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-09": 1
        },
        "time_per_day": {
          "2025-10-09": 25.853180555555554
        },
        "time_count_per_day": {
          "2025-10-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 25.85,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-09": 1
          },
          "time_per_day": {
            "2025-10-09": 25.853180555555554
          },
          "time_count_per_day": {
            "2025-10-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 25.85,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-09": 1
            },
            "time_per_day": {
              "2025-10-09": 25.853180555555554
            },
            "time_count_per_day": {
              "2025-10-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 25.85,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-09": 1
              },
              "time_per_day": {
                "2025-10-09": 25.853180555555554
              },
              "time_count_per_day": {
                "2025-10-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_210": {
      "overall": {
        "avg_time_hours": 0.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-08": 1
        },
        "time_per_day": {
          "2025-10-08": 0.4372563888888889
        },
        "time_count_per_day": {
          "2025-10-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-08": 1
          },
          "time_per_day": {
            "2025-10-08": 0.4372563888888889
          },
          "time_count_per_day": {
            "2025-10-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-08": 1
            },
            "time_per_day": {
              "2025-10-08": 0.4372563888888889
            },
            "time_count_per_day": {
              "2025-10-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-08": 1
              },
              "time_per_day": {
                "2025-10-08": 0.4372563888888889
              },
              "time_count_per_day": {
                "2025-10-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_211": {
      "overall": {
        "avg_time_hours": 303.57,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "12-14h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "42-44h": 1,
          "48-50h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "134-136h": 1,
          "164-166h": 1,
          "194-196h": 1,
          "206-208h": 1,
          "240-242h": 1,
          "348-350h": 1,
          "428-430h": 1,
          "506-508h": 1,
          "622-624h": 1,
          "700-702h": 1,
          "840-842h": 1,
          "1212-1214h": 1,
          "1242-1244h": 1,
          "1276-1278h": 1
        },
        "tickets_count": 36,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-13": 1,
          "2025-11-18": 1,
          "2025-12-04": 1,
          "2025-12-09": 2,
          "2025-12-13": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-02-25": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-12": 3,
          "2026-03-19": 1,
          "2026-03-24": 2,
          "2026-04-06": 1,
          "2026-04-07": 2,
          "2026-04-09": 1,
          "2026-04-17": 1,
          "2026-04-23": 3,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-13": 2,
          "2026-06-02": 2,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-29": 506.04429805555554,
          "2025-11-13": 22.044904444444445,
          "2025-11-18": 27.97787222222222,
          "2025-12-04": 42.53613333333333,
          "2025-12-09": 376.42202,
          "2025-12-13": 207.339645,
          "2026-01-31": 20.281876944444445,
          "2026-02-03": 1212.6243833333333,
          "2026-02-10": 74.68573277777777,
          "2026-02-25": 29.381116111111112,
          "2026-03-06": 0.6130605555555556,
          "2026-03-10": 165.29195638888888,
          "2026-03-11": 49.4663,
          "2026-03-12": 841.4067844444444,
          "2026-03-19": 73.04071194444445,
          "2026-03-24": 1290.1247063888889,
          "2026-04-06": 428.55958388888894,
          "2026-04-07": 641.1450330555556,
          "2026-04-09": 195.2260136111111,
          "2026-04-23": 1943.790818888889,
          "2026-05-06": 349.50345444444446,
          "2026-05-07": 2.522426388888889
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-11-13": 1,
          "2025-11-18": 1,
          "2025-12-04": 1,
          "2025-12-09": 2,
          "2025-12-13": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-25": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-12": 2,
          "2026-03-19": 1,
          "2026-03-24": 2,
          "2026-04-06": 1,
          "2026-04-07": 2,
          "2026-04-09": 1,
          "2026-04-23": 3,
          "2026-05-06": 1,
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 796.28,
          "mode_time_hours": 1243.0,
          "mode_frequency": 1,
          "time_distribution": {
            "348-350h": 1,
            "1242-1244h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-23": 1,
            "2026-05-06": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-04-23": 1243.0557030555556,
            "2026-05-06": 349.50345444444446
          },
          "time_count_per_day": {
            "2026-04-23": 1,
            "2026-05-06": 1
          }
        },
        "P2": {
          "avg_time_hours": 243.26,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "28-30h": 1,
            "42-44h": 1,
            "48-50h": 1,
            "72-74h": 1,
            "194-196h": 1,
            "206-208h": 1,
            "506-508h": 1,
            "622-624h": 1,
            "700-702h": 1,
            "840-842h": 1,
            "1276-1278h": 1
          },
          "tickets_count": 25,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-13": 1,
            "2025-12-04": 1,
            "2025-12-13": 1,
            "2026-01-31": 1,
            "2026-02-25": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-12": 3,
            "2026-03-19": 1,
            "2026-03-24": 2,
            "2026-04-07": 2,
            "2026-04-09": 1,
            "2026-04-17": 1,
            "2026-04-23": 2,
            "2026-05-07": 1,
            "2026-05-13": 2,
            "2026-06-02": 2
          },
          "time_per_day": {
            "2025-10-29": 506.04429805555554,
            "2025-11-13": 22.044904444444445,
            "2025-12-04": 42.53613333333333,
            "2025-12-13": 207.339645,
            "2026-01-31": 20.281876944444445,
            "2026-02-25": 29.381116111111112,
            "2026-03-06": 0.6130605555555556,
            "2026-03-11": 49.4663,
            "2026-03-12": 841.4067844444444,
            "2026-03-19": 73.04071194444445,
            "2026-03-24": 1290.1247063888889,
            "2026-04-07": 641.1450330555556,
            "2026-04-09": 195.2260136111111,
            "2026-04-23": 700.7351158333335,
            "2026-05-07": 2.522426388888889
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-11-13": 1,
            "2025-12-04": 1,
            "2025-12-13": 1,
            "2026-01-31": 1,
            "2026-02-25": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-12": 2,
            "2026-03-19": 1,
            "2026-03-24": 2,
            "2026-04-07": 2,
            "2026-04-09": 1,
            "2026-04-23": 2,
            "2026-05-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 326.51,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1,
            "74-76h": 1,
            "134-136h": 1,
            "164-166h": 1,
            "240-242h": 1,
            "428-430h": 1,
            "1212-1214h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-12-09": 2,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-04-06": 1
          },
          "time_per_day": {
            "2025-11-18": 27.97787222222222,
            "2025-12-09": 376.42202,
            "2026-02-03": 1212.6243833333333,
            "2026-02-10": 74.68573277777777,
            "2026-03-10": 165.29195638888888,
            "2026-04-06": 428.55958388888894
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-12-09": 2,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-04-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 303.57,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "12-14h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "42-44h": 1,
              "48-50h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "134-136h": 1,
              "164-166h": 1,
              "194-196h": 1,
              "206-208h": 1,
              "240-242h": 1,
              "348-350h": 1,
              "428-430h": 1,
              "506-508h": 1,
              "622-624h": 1,
              "700-702h": 1,
              "840-842h": 1,
              "1212-1214h": 1,
              "1242-1244h": 1,
              "1276-1278h": 1
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-11-13": 1,
              "2025-11-18": 1,
              "2025-12-04": 1,
              "2025-12-09": 2,
              "2025-12-13": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-25": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-12": 2,
              "2026-03-19": 1,
              "2026-03-24": 2,
              "2026-04-06": 1,
              "2026-04-07": 2,
              "2026-04-09": 1,
              "2026-04-23": 3,
              "2026-05-06": 1,
              "2026-05-07": 1
            },
            "time_per_day": {
              "2025-10-29": 506.04429805555554,
              "2025-11-13": 22.044904444444445,
              "2025-11-18": 27.97787222222222,
              "2025-12-04": 42.53613333333333,
              "2025-12-09": 376.42202,
              "2025-12-13": 207.339645,
              "2026-01-31": 20.281876944444445,
              "2026-02-03": 1212.6243833333333,
              "2026-02-10": 74.68573277777777,
              "2026-02-25": 29.381116111111112,
              "2026-03-06": 0.6130605555555556,
              "2026-03-10": 165.29195638888888,
              "2026-03-11": 49.4663,
              "2026-03-12": 841.4067844444444,
              "2026-03-19": 73.04071194444445,
              "2026-03-24": 1290.1247063888889,
              "2026-04-06": 428.55958388888894,
              "2026-04-07": 641.1450330555556,
              "2026-04-09": 195.2260136111111,
              "2026-04-23": 1943.790818888889,
              "2026-05-06": 349.50345444444446,
              "2026-05-07": 2.522426388888889
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-11-13": 1,
              "2025-11-18": 1,
              "2025-12-04": 1,
              "2025-12-09": 2,
              "2025-12-13": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-25": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-12": 2,
              "2026-03-19": 1,
              "2026-03-24": 2,
              "2026-04-06": 1,
              "2026-04-07": 2,
              "2026-04-09": 1,
              "2026-04-23": 3,
              "2026-05-06": 1,
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 796.28,
              "mode_time_hours": 1243.0,
              "mode_frequency": 1,
              "time_distribution": {
                "348-350h": 1,
                "1242-1244h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-04-23": 1243.0557030555556,
                "2026-05-06": 349.50345444444446
              },
              "time_count_per_day": {
                "2026-04-23": 1,
                "2026-05-06": 1
              }
            },
            "P2": {
              "avg_time_hours": 243.26,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "28-30h": 1,
                "42-44h": 1,
                "48-50h": 1,
                "72-74h": 1,
                "194-196h": 1,
                "206-208h": 1,
                "506-508h": 1,
                "622-624h": 1,
                "700-702h": 1,
                "840-842h": 1,
                "1276-1278h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-13": 1,
                "2025-12-04": 1,
                "2025-12-13": 1,
                "2026-01-31": 1,
                "2026-02-25": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-12": 2,
                "2026-03-19": 1,
                "2026-03-24": 2,
                "2026-04-07": 2,
                "2026-04-09": 1,
                "2026-04-23": 2,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2025-10-29": 506.04429805555554,
                "2025-11-13": 22.044904444444445,
                "2025-12-04": 42.53613333333333,
                "2025-12-13": 207.339645,
                "2026-01-31": 20.281876944444445,
                "2026-02-25": 29.381116111111112,
                "2026-03-06": 0.6130605555555556,
                "2026-03-11": 49.4663,
                "2026-03-12": 841.4067844444444,
                "2026-03-19": 73.04071194444445,
                "2026-03-24": 1290.1247063888889,
                "2026-04-07": 641.1450330555556,
                "2026-04-09": 195.2260136111111,
                "2026-04-23": 700.7351158333335,
                "2026-05-07": 2.522426388888889
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-11-13": 1,
                "2025-12-04": 1,
                "2025-12-13": 1,
                "2026-01-31": 1,
                "2026-02-25": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-12": 2,
                "2026-03-19": 1,
                "2026-03-24": 2,
                "2026-04-07": 2,
                "2026-04-09": 1,
                "2026-04-23": 2,
                "2026-05-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 326.51,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1,
                "74-76h": 1,
                "134-136h": 1,
                "164-166h": 1,
                "240-242h": 1,
                "428-430h": 1,
                "1212-1214h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-12-09": 2,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-04-06": 1
              },
              "time_per_day": {
                "2025-11-18": 27.97787222222222,
                "2025-12-09": 376.42202,
                "2026-02-03": 1212.6243833333333,
                "2026-02-10": 74.68573277777777,
                "2026-03-10": 165.29195638888888,
                "2026-04-06": 428.55958388888894
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-12-09": 2,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-04-06": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-02": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-12": 1,
              "2026-04-17": 1,
              "2026-05-13": 2,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-12": 1,
                "2026-04-17": 1,
                "2026-05-13": 2,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_56": {
      "overall": {
        "avg_time_hours": 523.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "46-48h": 1,
          "52-54h": 1,
          "68-70h": 1,
          "138-140h": 1,
          "624-626h": 1,
          "3246-3248h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-10-24": 1,
          "2025-10-27": 2,
          "2025-11-04": 1,
          "2025-11-18": 1,
          "2025-12-04": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-10-15": 47.564485000000005,
          "2025-10-24": 1.9660358333333334,
          "2025-10-27": 70.66213277777779,
          "2025-11-04": 625.1649097222222,
          "2025-11-18": 139.55627805555557,
          "2025-12-04": 53.792455,
          "2026-02-12": 3247.9919216666667
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-10-24": 1,
          "2025-10-27": 2,
          "2025-11-04": 1,
          "2025-11-18": 1,
          "2025-12-04": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 34.8,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "46-48h": 1,
            "52-54h": 1,
            "68-70h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-10-24": 1,
            "2025-10-27": 2,
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-10-15": 47.564485000000005,
            "2025-10-24": 1.9660358333333334,
            "2025-10-27": 70.66213277777779,
            "2025-12-04": 53.792455
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-10-24": 1,
            "2025-10-27": 2,
            "2025-12-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 1337.57,
          "mode_time_hours": 625.0,
          "mode_frequency": 1,
          "time_distribution": {
            "138-140h": 1,
            "624-626h": 1,
            "3246-3248h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-11-18": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-04": 625.1649097222222,
            "2025-11-18": 139.55627805555557,
            "2026-02-12": 3247.9919216666667
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-11-18": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 523.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "46-48h": 1,
              "52-54h": 1,
              "68-70h": 1,
              "138-140h": 1,
              "624-626h": 1,
              "3246-3248h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-10-24": 1,
              "2025-10-27": 2,
              "2025-11-04": 1,
              "2025-11-18": 1,
              "2025-12-04": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-10-15": 47.564485000000005,
              "2025-10-24": 1.9660358333333334,
              "2025-10-27": 70.66213277777779,
              "2025-11-04": 625.1649097222222,
              "2025-11-18": 139.55627805555557,
              "2025-12-04": 53.792455,
              "2026-02-12": 3247.9919216666667
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-10-24": 1,
              "2025-10-27": 2,
              "2025-11-04": 1,
              "2025-11-18": 1,
              "2025-12-04": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 34.8,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "46-48h": 1,
                "52-54h": 1,
                "68-70h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-10-24": 1,
                "2025-10-27": 2,
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-10-15": 47.564485000000005,
                "2025-10-24": 1.9660358333333334,
                "2025-10-27": 70.66213277777779,
                "2025-12-04": 53.792455
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-10-24": 1,
                "2025-10-27": 2,
                "2025-12-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 1337.57,
              "mode_time_hours": 625.0,
              "mode_frequency": 1,
              "time_distribution": {
                "138-140h": 1,
                "624-626h": 1,
                "3246-3248h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-11-18": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-04": 625.1649097222222,
                "2025-11-18": 139.55627805555557,
                "2026-02-12": 3247.9919216666667
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-11-18": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_217": {
      "overall": {
        "avg_time_hours": 651.91,
        "mode_time_hours": 651.0,
        "mode_frequency": 1,
        "time_distribution": {
          "650-652h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-05": 1
        },
        "time_per_day": {
          "2025-11-05": 651.9148241666667
        },
        "time_count_per_day": {
          "2025-11-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 651.91,
          "mode_time_hours": 651.0,
          "mode_frequency": 1,
          "time_distribution": {
            "650-652h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-05": 1
          },
          "time_per_day": {
            "2025-11-05": 651.9148241666667
          },
          "time_count_per_day": {
            "2025-11-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 651.91,
            "mode_time_hours": 651.0,
            "mode_frequency": 1,
            "time_distribution": {
              "650-652h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-05": 1
            },
            "time_per_day": {
              "2025-11-05": 651.9148241666667
            },
            "time_count_per_day": {
              "2025-11-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 651.91,
              "mode_time_hours": 651.0,
              "mode_frequency": 1,
              "time_distribution": {
                "650-652h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-05": 1
              },
              "time_per_day": {
                "2025-11-05": 651.9148241666667
              },
              "time_count_per_day": {
                "2025-11-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_218": {
      "overall": {
        "avg_time_hours": 77.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 298,
        "time_distribution": {
          "0-2h": 298,
          "2-4h": 66,
          "4-6h": 44,
          "6-8h": 46,
          "8-10h": 8,
          "10-12h": 7,
          "12-14h": 3,
          "14-16h": 3,
          "16-18h": 3,
          "18-20h": 5,
          "20-22h": 6,
          "22-24h": 7,
          "24-26h": 3,
          "26-28h": 1,
          "28-30h": 18,
          "30-32h": 4,
          "32-34h": 2,
          "36-38h": 4,
          "40-42h": 5,
          "42-44h": 3,
          "44-46h": 2,
          "46-48h": 3,
          "48-50h": 2,
          "50-52h": 1,
          "52-54h": 3,
          "56-58h": 1,
          "60-62h": 3,
          "64-66h": 3,
          "66-68h": 1,
          "68-70h": 3,
          "72-74h": 1,
          "74-76h": 4,
          "76-78h": 4,
          "78-80h": 3,
          "80-82h": 4,
          "82-84h": 2,
          "88-90h": 1,
          "90-92h": 1,
          "96-98h": 1,
          "100-102h": 1,
          "114-116h": 1,
          "118-120h": 1,
          "120-122h": 1,
          "132-134h": 1,
          "138-140h": 1,
          "140-142h": 2,
          "146-148h": 1,
          "162-164h": 8,
          "164-166h": 1,
          "168-170h": 1,
          "172-174h": 2,
          "174-176h": 1,
          "176-178h": 1,
          "178-180h": 3,
          "188-190h": 1,
          "190-192h": 3,
          "192-194h": 1,
          "194-196h": 4,
          "198-200h": 5,
          "212-214h": 1,
          "214-216h": 2,
          "216-218h": 4,
          "242-244h": 4,
          "244-246h": 1,
          "250-252h": 1,
          "252-254h": 1,
          "254-256h": 1,
          "260-262h": 1,
          "262-264h": 1,
          "264-266h": 1,
          "268-270h": 1,
          "280-282h": 1,
          "288-290h": 1,
          "294-296h": 1,
          "302-304h": 1,
          "304-306h": 1,
          "306-308h": 2,
          "310-312h": 1,
          "314-316h": 1,
          "324-326h": 4,
          "326-328h": 1,
          "328-330h": 1,
          "334-336h": 2,
          "340-342h": 1,
          "348-350h": 2,
          "352-354h": 1,
          "354-356h": 1,
          "364-366h": 1,
          "366-368h": 1,
          "372-374h": 4,
          "382-384h": 1,
          "384-386h": 1,
          "386-388h": 3,
          "400-402h": 2,
          "402-404h": 1,
          "408-410h": 1,
          "416-418h": 1,
          "428-430h": 2,
          "452-454h": 1,
          "456-458h": 3,
          "496-498h": 1,
          "504-506h": 1,
          "506-508h": 1,
          "514-516h": 1,
          "524-526h": 2,
          "528-530h": 1,
          "574-576h": 1,
          "576-578h": 1,
          "580-582h": 2,
          "582-584h": 1,
          "596-598h": 1,
          "616-618h": 1,
          "622-624h": 1,
          "744-746h": 1,
          "786-788h": 1,
          "804-806h": 2,
          "816-818h": 1,
          "844-846h": 1,
          "852-854h": 1,
          "876-878h": 1,
          "896-898h": 1,
          "898-900h": 1,
          "1076-1078h": 1,
          "1100-1102h": 1,
          "1104-1106h": 1,
          "1718-1720h": 1
        },
        "tickets_count": 774,
        "tickets_per_day": {
          "2025-10-09": 1,
          "2025-10-14": 2,
          "2025-10-15": 1,
          "2025-10-16": 1,
          "2025-10-21": 2,
          "2025-10-22": 1,
          "2025-10-23": 3,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-29": 2,
          "2025-10-31": 4,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-11-07": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-20": 2,
          "2025-11-21": 5,
          "2025-11-22": 1,
          "2025-11-24": 5,
          "2025-11-25": 1,
          "2025-11-26": 3,
          "2025-11-28": 9,
          "2025-11-29": 2,
          "2025-12-02": 3,
          "2025-12-03": 1,
          "2025-12-04": 3,
          "2025-12-05": 4,
          "2025-12-09": 1,
          "2025-12-10": 4,
          "2025-12-11": 2,
          "2025-12-12": 6,
          "2025-12-15": 10,
          "2025-12-17": 1,
          "2025-12-18": 3,
          "2025-12-19": 6,
          "2025-12-22": 3,
          "2025-12-26": 9,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-02": 4,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-07": 2,
          "2026-01-08": 2,
          "2026-01-13": 3,
          "2026-01-14": 3,
          "2026-01-15": 2,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-18": 2,
          "2026-01-20": 10,
          "2026-01-22": 1,
          "2026-01-23": 5,
          "2026-01-26": 12,
          "2026-01-27": 5,
          "2026-01-28": 1,
          "2026-01-30": 4,
          "2026-02-02": 2,
          "2026-02-03": 2,
          "2026-02-04": 2,
          "2026-02-05": 2,
          "2026-02-06": 5,
          "2026-02-09": 7,
          "2026-02-10": 7,
          "2026-02-11": 5,
          "2026-02-12": 4,
          "2026-02-13": 3,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-19": 15,
          "2026-02-20": 11,
          "2026-02-21": 5,
          "2026-02-23": 24,
          "2026-02-24": 3,
          "2026-02-25": 4,
          "2026-02-26": 3,
          "2026-02-28": 13,
          "2026-03-02": 21,
          "2026-03-03": 5,
          "2026-03-04": 3,
          "2026-03-05": 4,
          "2026-03-06": 6,
          "2026-03-07": 1,
          "2026-03-09": 25,
          "2026-03-10": 2,
          "2026-03-11": 2,
          "2026-03-12": 6,
          "2026-03-13": 9,
          "2026-03-14": 4,
          "2026-03-16": 3,
          "2026-03-17": 6,
          "2026-03-18": 30,
          "2026-03-19": 1,
          "2026-03-20": 15,
          "2026-03-23": 5,
          "2026-03-24": 5,
          "2026-03-25": 4,
          "2026-03-27": 4,
          "2026-03-30": 2,
          "2026-04-02": 2,
          "2026-04-06": 6,
          "2026-04-07": 4,
          "2026-04-08": 9,
          "2026-04-10": 3,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 4,
          "2026-04-16": 6,
          "2026-04-17": 6,
          "2026-04-20": 9,
          "2026-04-21": 3,
          "2026-04-22": 9,
          "2026-04-23": 4,
          "2026-04-24": 7,
          "2026-04-27": 6,
          "2026-04-28": 8,
          "2026-04-29": 4,
          "2026-04-30": 12,
          "2026-05-04": 5,
          "2026-05-05": 2,
          "2026-05-06": 4,
          "2026-05-07": 14,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 5,
          "2026-05-12": 7,
          "2026-05-13": 6,
          "2026-05-14": 6,
          "2026-05-15": 3,
          "2026-05-16": 1,
          "2026-05-18": 6,
          "2026-05-19": 15,
          "2026-05-20": 6,
          "2026-05-21": 12,
          "2026-05-22": 6,
          "2026-05-25": 10,
          "2026-05-26": 10,
          "2026-05-27": 11,
          "2026-05-28": 11,
          "2026-05-29": 13,
          "2026-05-30": 3,
          "2026-06-01": 2,
          "2026-06-02": 11,
          "2026-06-03": 8,
          "2026-06-05": 23,
          "2026-06-06": 4,
          "2026-06-08": 6
        },
        "time_per_day": {
          "2025-10-09": 5.928514444444444,
          "2025-10-14": 38.00605638888889,
          "2025-10-15": 7.295897222222222,
          "2025-10-16": 23.084178333333334,
          "2025-10-21": 57.306424444444445,
          "2025-10-22": 53.046421111111115,
          "2025-10-23": 9.07178888888889,
          "2025-10-24": 91.64413611111111,
          "2025-10-27": 4.266186388888889,
          "2025-10-28": 264.8675416666667,
          "2025-10-29": 2.1836458333333333,
          "2025-10-31": 798.3140130555556,
          "2025-11-04": 28.078527222222224,
          "2025-11-06": 16.91294861111111,
          "2025-11-07": 7.182623333333333,
          "2025-11-18": 7.580475833333333,
          "2025-11-19": 0.7761488888888889,
          "2025-11-20": 3.1897516666666665,
          "2025-11-21": 85.33554861111111,
          "2025-11-22": 18.174256944444444,
          "2025-11-24": 1195.7549269444446,
          "2025-11-25": 118.70935944444444,
          "2025-11-26": 196.2162836111111,
          "2025-11-28": 14.103290833333332,
          "2025-11-29": 279.24321944444443,
          "2025-12-02": 156.8522625,
          "2025-12-03": 20.073528611111108,
          "2025-12-04": 176.0677008333333,
          "2025-12-05": 102.13382277777777,
          "2025-12-09": 0.1919038888888889,
          "2025-12-10": 453.6337369444445,
          "2025-12-11": 30.260379999999998,
          "2025-12-12": 66.02607361111112,
          "2025-12-15": 2403.504206944445,
          "2025-12-17": 18.473275833333336,
          "2025-12-18": 68.5491886111111,
          "2025-12-19": 149.80121333333332,
          "2025-12-22": 752.3575005555556,
          "2025-12-26": 110.64652222222222,
          "2025-12-29": 0.13212583333333333,
          "2025-12-30": 29.886094722222225,
          "2026-01-02": 2.509909722222222,
          "2026-01-05": 1.1636530555555555,
          "2026-01-06": 8.139582222222222,
          "2026-01-07": 1.8825800000000001,
          "2026-01-08": 26.05435166666667,
          "2026-01-13": 28.598543333333332,
          "2026-01-14": 14.965724166666664,
          "2026-01-15": 0.9189622222222223,
          "2026-01-16": 5.1070475,
          "2026-01-17": 20.766351666666665,
          "2026-01-20": 246.0382525,
          "2026-01-22": 0.5369391666666666,
          "2026-01-23": 1404.7593555555557,
          "2026-01-26": 40.1981086111111,
          "2026-01-27": 189.60984722222221,
          "2026-01-28": 7.752356388888889,
          "2026-01-30": 191.42412777777778,
          "2026-02-02": 139.03100999999998,
          "2026-02-03": 1018.0654852777777,
          "2026-02-04": 144.14738499999999,
          "2026-02-05": 355.35785027777774,
          "2026-02-06": 480.1943238888889,
          "2026-02-09": 112.26011638888889,
          "2026-02-10": 1421.688293888889,
          "2026-02-11": 218.77680944444447,
          "2026-02-12": 1447.3743430555553,
          "2026-02-13": 580.3572777777778,
          "2026-02-17": 31.069153888888888,
          "2026-02-18": 3.037431111111111,
          "2026-02-19": 6217.55236388889,
          "2026-02-20": 279.08703083333336,
          "2026-02-21": 102.77000805555555,
          "2026-02-23": 251.2666969444444,
          "2026-02-24": 3.2309469444444443,
          "2026-02-25": 23.807555,
          "2026-02-26": 1.8413919444444444,
          "2026-02-28": 427.0689497222221,
          "2026-03-02": 344.27808722222227,
          "2026-03-03": 90.44204833333335,
          "2026-03-04": 222.0387047222222,
          "2026-03-05": 14.212225833333335,
          "2026-03-06": 2189.130240833333,
          "2026-03-07": 1.0339847222222223,
          "2026-03-09": 192.5535361111112,
          "2026-03-10": 39.49731611111111,
          "2026-03-11": 288.8341894444444,
          "2026-03-12": 2.1604824999999996,
          "2026-03-13": 1307.3017847222222,
          "2026-03-14": 562.0816311111112,
          "2026-03-16": 8.92832638888889,
          "2026-03-17": 116.5430188888889,
          "2026-03-18": 9047.802800277776,
          "2026-03-19": 1.0079997222222221,
          "2026-03-20": 1269.3310127777784,
          "2026-03-23": 84.85680861111112,
          "2026-03-24": 14.85594,
          "2026-03-25": 8.887294999999998,
          "2026-03-27": 2.7066569444444446,
          "2026-03-30": 78.04916222222222,
          "2026-04-02": 7.634425833333333,
          "2026-04-06": 12.688513055555555,
          "2026-04-07": 198.04102833333334,
          "2026-04-08": 8.069338055555557,
          "2026-04-10": 1718.44988,
          "2026-04-13": 1.1621641666666667,
          "2026-04-14": 464.4814772222222,
          "2026-04-15": 411.74581916666665,
          "2026-04-16": 1246.200762777778,
          "2026-04-17": 2.786992222222222,
          "2026-04-21": 1.5019108333333335,
          "2026-04-22": 558.4180461111112,
          "2026-04-23": 191.94598694444446,
          "2026-04-24": 2.542661388888889,
          "2026-04-27": 4.784105277777778,
          "2026-04-28": 974.1243686111111,
          "2026-04-29": 178.8740752777778,
          "2026-04-30": 25.881642499999998,
          "2026-05-04": 1142.5189241666665,
          "2026-05-06": 1668.0385097222222,
          "2026-05-07": 217.12104805555558,
          "2026-05-08": 13.58359,
          "2026-05-09": 46.74550027777778,
          "2026-05-11": 7.627616388888888,
          "2026-05-12": 124.8015361111111,
          "2026-05-13": 0.7391647222222222,
          "2026-05-14": 584.4481172222222,
          "2026-05-15": 8.194653888888888,
          "2026-05-16": 96.31714888888888,
          "2026-05-18": 509.1349808333333,
          "2026-05-19": 298.6145969444445,
          "2026-05-20": 46.16727388888888,
          "2026-05-21": 1730.3259594444444,
          "2026-05-22": 1305.800988888889,
          "2026-05-25": 1092.3494805555558,
          "2026-05-26": 5.780608333333333,
          "2026-05-27": 13.419250277777778,
          "2026-05-28": 2.3508791666666666,
          "2026-05-29": 73.96287666666667,
          "2026-05-30": 222.98155527777777,
          "2026-06-01": 3.4871286111111113,
          "2026-06-02": 6.061820555555555,
          "2026-06-03": 190.4959638888889,
          "2026-06-05": 13.606836388888889,
          "2026-06-06": 51.85606666666666,
          "2026-06-08": 68.62411527777778
        },
        "time_count_per_day": {
          "2025-10-09": 1,
          "2025-10-14": 2,
          "2025-10-15": 1,
          "2025-10-16": 1,
          "2025-10-21": 2,
          "2025-10-22": 1,
          "2025-10-23": 3,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-10-29": 2,
          "2025-10-31": 4,
          "2025-11-04": 1,
          "2025-11-06": 2,
          "2025-11-07": 1,
          "2025-11-18": 1,
          "2025-11-19": 1,
          "2025-11-20": 2,
          "2025-11-21": 5,
          "2025-11-22": 1,
          "2025-11-24": 5,
          "2025-11-25": 1,
          "2025-11-26": 3,
          "2025-11-28": 9,
          "2025-11-29": 2,
          "2025-12-02": 3,
          "2025-12-03": 1,
          "2025-12-04": 3,
          "2025-12-05": 4,
          "2025-12-09": 1,
          "2025-12-10": 4,
          "2025-12-11": 2,
          "2025-12-12": 6,
          "2025-12-15": 10,
          "2025-12-17": 1,
          "2025-12-18": 3,
          "2025-12-19": 6,
          "2025-12-22": 3,
          "2025-12-26": 9,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-02": 4,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-07": 2,
          "2026-01-08": 2,
          "2026-01-13": 3,
          "2026-01-14": 3,
          "2026-01-15": 2,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-20": 10,
          "2026-01-22": 1,
          "2026-01-23": 5,
          "2026-01-26": 12,
          "2026-01-27": 5,
          "2026-01-28": 1,
          "2026-01-30": 4,
          "2026-02-02": 2,
          "2026-02-03": 2,
          "2026-02-04": 2,
          "2026-02-05": 2,
          "2026-02-06": 5,
          "2026-02-09": 7,
          "2026-02-10": 7,
          "2026-02-11": 5,
          "2026-02-12": 4,
          "2026-02-13": 3,
          "2026-02-17": 1,
          "2026-02-18": 2,
          "2026-02-19": 14,
          "2026-02-20": 11,
          "2026-02-21": 4,
          "2026-02-23": 23,
          "2026-02-24": 2,
          "2026-02-25": 4,
          "2026-02-26": 3,
          "2026-02-28": 12,
          "2026-03-02": 21,
          "2026-03-03": 5,
          "2026-03-04": 3,
          "2026-03-05": 3,
          "2026-03-06": 6,
          "2026-03-07": 1,
          "2026-03-09": 25,
          "2026-03-10": 2,
          "2026-03-11": 2,
          "2026-03-12": 6,
          "2026-03-13": 9,
          "2026-03-14": 4,
          "2026-03-16": 3,
          "2026-03-17": 6,
          "2026-03-18": 30,
          "2026-03-19": 1,
          "2026-03-20": 15,
          "2026-03-23": 5,
          "2026-03-24": 5,
          "2026-03-25": 4,
          "2026-03-27": 4,
          "2026-03-30": 2,
          "2026-04-02": 2,
          "2026-04-06": 5,
          "2026-04-07": 4,
          "2026-04-08": 9,
          "2026-04-10": 3,
          "2026-04-13": 2,
          "2026-04-14": 2,
          "2026-04-15": 4,
          "2026-04-16": 6,
          "2026-04-17": 6,
          "2026-04-21": 2,
          "2026-04-22": 8,
          "2026-04-23": 4,
          "2026-04-24": 7,
          "2026-04-27": 5,
          "2026-04-28": 8,
          "2026-04-29": 4,
          "2026-04-30": 12,
          "2026-05-04": 5,
          "2026-05-06": 4,
          "2026-05-07": 1,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-11": 5,
          "2026-05-12": 3,
          "2026-05-13": 3,
          "2026-05-14": 6,
          "2026-05-15": 3,
          "2026-05-16": 1,
          "2026-05-18": 4,
          "2026-05-19": 11,
          "2026-05-20": 4,
          "2026-05-21": 12,
          "2026-05-22": 6,
          "2026-05-25": 8,
          "2026-05-26": 9,
          "2026-05-27": 11,
          "2026-05-28": 10,
          "2026-05-29": 11,
          "2026-05-30": 3,
          "2026-06-01": 2,
          "2026-06-02": 11,
          "2026-06-03": 7,
          "2026-06-05": 18,
          "2026-06-06": 4,
          "2026-06-08": 6
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 59.68,
          "mode_time_hours": 3.0,
          "mode_frequency": 26,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 26,
            "4-6h": 3,
            "6-8h": 12,
            "8-10h": 3,
            "18-20h": 1,
            "22-24h": 1,
            "28-30h": 2,
            "30-32h": 2,
            "32-34h": 1,
            "48-50h": 1,
            "64-66h": 1,
            "66-68h": 1,
            "76-78h": 1,
            "138-140h": 1,
            "192-194h": 1,
            "194-196h": 3,
            "250-252h": 1,
            "262-264h": 1,
            "280-282h": 1,
            "306-308h": 1,
            "844-846h": 1,
            "896-898h": 1
          },
          "tickets_count": 86,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2025-11-04": 1,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 3,
            "2025-12-05": 2,
            "2025-12-12": 1,
            "2025-12-22": 1,
            "2026-01-06": 1,
            "2026-01-20": 1,
            "2026-01-26": 2,
            "2026-01-28": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-17": 1,
            "2026-02-20": 1,
            "2026-03-02": 8,
            "2026-03-03": 3,
            "2026-03-05": 1,
            "2026-03-09": 16,
            "2026-03-10": 1,
            "2026-03-16": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-23": 4,
            "2026-04-16": 1,
            "2026-04-20": 3,
            "2026-04-28": 4,
            "2026-05-07": 1,
            "2026-05-11": 1,
            "2026-05-12": 1,
            "2026-05-19": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-29": 1,
            "2026-06-05": 5
          },
          "time_per_day": {
            "2025-10-27": 4.266186388888889,
            "2025-11-04": 28.078527222222224,
            "2025-11-18": 7.580475833333333,
            "2025-11-19": 0.7761488888888889,
            "2025-11-20": 3.1897516666666665,
            "2025-11-21": 9.812267222222221,
            "2025-11-24": 8.460521388888889,
            "2025-12-05": 23.87092722222222,
            "2025-12-12": 3.2853466666666664,
            "2025-12-22": 2.3250313888888887,
            "2026-01-06": 8.139582222222222,
            "2026-01-20": 8.536498611111112,
            "2026-01-26": 13.122520555555557,
            "2026-01-28": 7.752356388888889,
            "2026-01-30": 2.8413155555555556,
            "2026-02-02": 138.90708388888888,
            "2026-02-09": 4.91489,
            "2026-02-10": 29.27026638888889,
            "2026-02-17": 31.069153888888888,
            "2026-02-20": 263.7448591666667,
            "2026-03-02": 99.20282277777778,
            "2026-03-03": 30.689290555555555,
            "2026-03-05": 1.071865,
            "2026-03-09": 172.59003944444453,
            "2026-03-10": 32.63545638888889,
            "2026-03-16": 7.221163611111111,
            "2026-03-18": 306.05299194444444,
            "2026-03-20": 2.031414166666667,
            "2026-03-23": 84.30769083333334,
            "2026-04-16": 897.6813783333333,
            "2026-04-28": 776.5194027777777,
            "2026-05-11": 0.07928944444444444,
            "2026-05-12": 7.821209166666667,
            "2026-05-19": 284.3649266666667,
            "2026-05-21": 19.5824275,
            "2026-05-22": 250.13939944444445,
            "2026-05-25": 844.4759944444445
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2025-11-04": 1,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 3,
            "2025-12-05": 2,
            "2025-12-12": 1,
            "2025-12-22": 1,
            "2026-01-06": 1,
            "2026-01-20": 1,
            "2026-01-26": 2,
            "2026-01-28": 1,
            "2026-01-30": 1,
            "2026-02-02": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-17": 1,
            "2026-02-20": 1,
            "2026-03-02": 8,
            "2026-03-03": 3,
            "2026-03-05": 1,
            "2026-03-09": 16,
            "2026-03-10": 1,
            "2026-03-16": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-23": 4,
            "2026-04-16": 1,
            "2026-04-28": 4,
            "2026-05-11": 1,
            "2026-05-12": 1,
            "2026-05-19": 2,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-25": 1
          }
        },
        "P2": {
          "avg_time_hours": 42.43,
          "mode_time_hours": 1.0,
          "mode_frequency": 280,
          "time_distribution": {
            "0-2h": 280,
            "2-4h": 34,
            "4-6h": 38,
            "6-8h": 18,
            "8-10h": 4,
            "10-12h": 3,
            "12-14h": 2,
            "14-16h": 3,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 4,
            "22-24h": 3,
            "24-26h": 1,
            "28-30h": 13,
            "30-32h": 1,
            "40-42h": 5,
            "42-44h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "50-52h": 1,
            "60-62h": 2,
            "64-66h": 2,
            "68-70h": 2,
            "72-74h": 1,
            "74-76h": 4,
            "76-78h": 3,
            "78-80h": 1,
            "80-82h": 3,
            "88-90h": 1,
            "96-98h": 1,
            "114-116h": 1,
            "162-164h": 7,
            "164-166h": 1,
            "168-170h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "190-192h": 3,
            "194-196h": 1,
            "212-214h": 1,
            "216-218h": 1,
            "252-254h": 1,
            "254-256h": 1,
            "260-262h": 1,
            "288-290h": 1,
            "294-296h": 1,
            "314-316h": 1,
            "324-326h": 4,
            "328-330h": 1,
            "340-342h": 1,
            "348-350h": 2,
            "354-356h": 1,
            "364-366h": 1,
            "366-368h": 1,
            "382-384h": 1,
            "386-388h": 2,
            "408-410h": 1,
            "514-516h": 1,
            "524-526h": 2,
            "580-582h": 1,
            "582-584h": 1,
            "616-618h": 1,
            "744-746h": 1,
            "876-878h": 1,
            "1076-1078h": 1,
            "1100-1102h": 1
          },
          "tickets_count": 528,
          "tickets_per_day": {
            "2025-10-09": 1,
            "2025-10-14": 1,
            "2025-10-21": 1,
            "2025-10-29": 1,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-21": 2,
            "2025-11-26": 2,
            "2025-11-28": 9,
            "2025-12-02": 2,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 4,
            "2025-12-11": 1,
            "2025-12-12": 3,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-22": 2,
            "2025-12-26": 7,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2026-01-02": 4,
            "2026-01-05": 1,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-18": 1,
            "2026-01-20": 9,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 7,
            "2026-01-27": 2,
            "2026-01-30": 3,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-06": 2,
            "2026-02-09": 3,
            "2026-02-10": 3,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 2,
            "2026-02-19": 1,
            "2026-02-20": 10,
            "2026-02-23": 19,
            "2026-02-24": 2,
            "2026-02-25": 4,
            "2026-02-26": 3,
            "2026-02-28": 4,
            "2026-03-02": 12,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-05": 3,
            "2026-03-06": 5,
            "2026-03-07": 1,
            "2026-03-09": 9,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-12": 6,
            "2026-03-13": 9,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 4,
            "2026-03-19": 1,
            "2026-03-20": 14,
            "2026-03-23": 1,
            "2026-03-24": 4,
            "2026-03-25": 4,
            "2026-03-27": 4,
            "2026-03-30": 2,
            "2026-04-02": 2,
            "2026-04-06": 6,
            "2026-04-07": 4,
            "2026-04-08": 9,
            "2026-04-10": 2,
            "2026-04-13": 2,
            "2026-04-14": 2,
            "2026-04-15": 4,
            "2026-04-16": 5,
            "2026-04-17": 6,
            "2026-04-20": 6,
            "2026-04-21": 3,
            "2026-04-22": 8,
            "2026-04-23": 4,
            "2026-04-24": 7,
            "2026-04-27": 6,
            "2026-04-28": 4,
            "2026-04-29": 4,
            "2026-04-30": 12,
            "2026-05-04": 5,
            "2026-05-05": 2,
            "2026-05-06": 4,
            "2026-05-07": 13,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 4,
            "2026-05-12": 6,
            "2026-05-13": 6,
            "2026-05-14": 6,
            "2026-05-15": 3,
            "2026-05-16": 1,
            "2026-05-18": 6,
            "2026-05-19": 13,
            "2026-05-20": 6,
            "2026-05-21": 11,
            "2026-05-22": 5,
            "2026-05-25": 8,
            "2026-05-26": 9,
            "2026-05-27": 11,
            "2026-05-28": 11,
            "2026-05-29": 11,
            "2026-05-30": 3,
            "2026-06-01": 2,
            "2026-06-02": 11,
            "2026-06-03": 7,
            "2026-06-05": 18,
            "2026-06-06": 4,
            "2026-06-08": 6
          },
          "time_per_day": {
            "2025-10-09": 5.928514444444444,
            "2025-10-14": 10.375725000000001,
            "2025-10-21": 1.0502052777777777,
            "2025-10-29": 1.4241794444444444,
            "2025-11-06": 0.37925166666666665,
            "2025-11-07": 7.182623333333333,
            "2025-11-21": 19.655404722222222,
            "2025-11-26": 6.701211944444444,
            "2025-11-28": 14.103290833333332,
            "2025-12-02": 9.051125833333334,
            "2025-12-03": 20.073528611111108,
            "2025-12-04": 48.11912611111111,
            "2025-12-05": 78.26289555555555,
            "2025-12-09": 0.1919038888888889,
            "2025-12-10": 453.6337369444445,
            "2025-12-11": 0.5300194444444444,
            "2025-12-12": 3.54315,
            "2025-12-15": 0.12660194444444445,
            "2025-12-17": 18.473275833333336,
            "2025-12-19": 76.94813111111111,
            "2025-12-22": 750.0324691666667,
            "2025-12-26": 9.158658888888889,
            "2025-12-29": 0.13212583333333333,
            "2025-12-30": 29.886094722222225,
            "2026-01-02": 2.509909722222222,
            "2026-01-05": 1.1636530555555555,
            "2026-01-07": 1.8825800000000001,
            "2026-01-08": 23.29052111111111,
            "2026-01-13": 25.49321638888889,
            "2026-01-14": 1.2775366666666665,
            "2026-01-15": 0.8523030555555556,
            "2026-01-16": 5.1070475,
            "2026-01-20": 237.50175388888889,
            "2026-01-22": 0.5369391666666666,
            "2026-01-23": 854.3010816666666,
            "2026-01-26": 18.0171225,
            "2026-01-27": 88.60856138888889,
            "2026-01-30": 188.58281222222223,
            "2026-02-02": 0.12392611111111111,
            "2026-02-03": 876.2290647222222,
            "2026-02-04": 11.077025,
            "2026-02-06": 1.1342697222222222,
            "2026-02-09": 79.33257722222223,
            "2026-02-10": 284.6330883333334,
            "2026-02-11": 2.310083333333333,
            "2026-02-12": 314.3810136111111,
            "2026-02-13": 0.18202249999999998,
            "2026-02-18": 3.037431111111111,
            "2026-02-19": 0.09331333333333333,
            "2026-02-20": 15.342171666666667,
            "2026-02-23": 131.66519805555555,
            "2026-02-24": 3.2309469444444443,
            "2026-02-25": 23.807555,
            "2026-02-26": 1.8413919444444444,
            "2026-02-28": 24.4236525,
            "2026-03-02": 221.81369250000003,
            "2026-03-03": 59.752757777777774,
            "2026-03-04": 221.51173888888889,
            "2026-03-05": 13.140360833333334,
            "2026-03-06": 1659.5557027777777,
            "2026-03-07": 1.0339847222222223,
            "2026-03-09": 19.963496666666664,
            "2026-03-10": 6.861859722222222,
            "2026-03-11": 288.8341894444444,
            "2026-03-12": 2.1604824999999996,
            "2026-03-13": 1307.3017847222222,
            "2026-03-16": 1.7071627777777778,
            "2026-03-17": 0.17112527777777778,
            "2026-03-18": 10.00356611111111,
            "2026-03-19": 1.0079997222222221,
            "2026-03-20": 1267.2995986111116,
            "2026-03-23": 0.5491177777777778,
            "2026-03-24": 6.8653772222222225,
            "2026-03-25": 8.887294999999998,
            "2026-03-27": 2.7066569444444446,
            "2026-03-30": 78.04916222222222,
            "2026-04-02": 7.634425833333333,
            "2026-04-06": 12.688513055555555,
            "2026-04-07": 198.04102833333334,
            "2026-04-08": 8.069338055555557,
            "2026-04-10": 0.10396944444444445,
            "2026-04-13": 1.1621641666666667,
            "2026-04-14": 464.4814772222222,
            "2026-04-15": 411.74581916666665,
            "2026-04-16": 348.5193844444444,
            "2026-04-17": 2.786992222222222,
            "2026-04-21": 1.5019108333333335,
            "2026-04-22": 416.8580191666666,
            "2026-04-23": 191.94598694444446,
            "2026-04-24": 2.542661388888889,
            "2026-04-27": 4.784105277777778,
            "2026-04-28": 197.60496583333332,
            "2026-04-29": 178.8740752777778,
            "2026-04-30": 25.881642499999998,
            "2026-05-04": 1142.5189241666665,
            "2026-05-06": 1668.0385097222222,
            "2026-05-07": 217.12104805555558,
            "2026-05-08": 13.58359,
            "2026-05-09": 46.74550027777778,
            "2026-05-11": 7.548326944444444,
            "2026-05-12": 116.98032694444444,
            "2026-05-13": 0.7391647222222222,
            "2026-05-14": 584.4481172222222,
            "2026-05-15": 8.194653888888888,
            "2026-05-16": 96.31714888888888,
            "2026-05-18": 509.1349808333333,
            "2026-05-19": 14.249670277777778,
            "2026-05-20": 46.16727388888888,
            "2026-05-21": 1710.7435319444444,
            "2026-05-22": 1055.6615894444444,
            "2026-05-25": 247.87348611111113,
            "2026-05-26": 5.780608333333333,
            "2026-05-27": 13.419250277777778,
            "2026-05-28": 2.3508791666666666,
            "2026-05-29": 73.96287666666667,
            "2026-05-30": 222.98155527777777,
            "2026-06-01": 3.4871286111111113,
            "2026-06-02": 6.061820555555555,
            "2026-06-03": 190.4959638888889,
            "2026-06-05": 13.606836388888889,
            "2026-06-06": 51.85606666666666,
            "2026-06-08": 68.62411527777778
          },
          "time_count_per_day": {
            "2025-10-09": 1,
            "2025-10-14": 1,
            "2025-10-21": 1,
            "2025-10-29": 1,
            "2025-11-06": 1,
            "2025-11-07": 1,
            "2025-11-21": 2,
            "2025-11-26": 2,
            "2025-11-28": 9,
            "2025-12-02": 2,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 4,
            "2025-12-11": 1,
            "2025-12-12": 3,
            "2025-12-15": 2,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-22": 2,
            "2025-12-26": 7,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2026-01-02": 4,
            "2026-01-05": 1,
            "2026-01-07": 2,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 9,
            "2026-01-22": 1,
            "2026-01-23": 3,
            "2026-01-26": 7,
            "2026-01-27": 2,
            "2026-01-30": 3,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-06": 2,
            "2026-02-09": 3,
            "2026-02-10": 3,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 2,
            "2026-02-19": 1,
            "2026-02-20": 10,
            "2026-02-23": 19,
            "2026-02-24": 2,
            "2026-02-25": 4,
            "2026-02-26": 3,
            "2026-02-28": 4,
            "2026-03-02": 12,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-05": 2,
            "2026-03-06": 5,
            "2026-03-07": 1,
            "2026-03-09": 9,
            "2026-03-10": 1,
            "2026-03-11": 2,
            "2026-03-12": 6,
            "2026-03-13": 9,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 4,
            "2026-03-19": 1,
            "2026-03-20": 14,
            "2026-03-23": 1,
            "2026-03-24": 4,
            "2026-03-25": 4,
            "2026-03-27": 4,
            "2026-03-30": 2,
            "2026-04-02": 2,
            "2026-04-06": 5,
            "2026-04-07": 4,
            "2026-04-08": 9,
            "2026-04-10": 2,
            "2026-04-13": 2,
            "2026-04-14": 2,
            "2026-04-15": 4,
            "2026-04-16": 5,
            "2026-04-17": 6,
            "2026-04-21": 2,
            "2026-04-22": 7,
            "2026-04-23": 4,
            "2026-04-24": 7,
            "2026-04-27": 5,
            "2026-04-28": 4,
            "2026-04-29": 4,
            "2026-04-30": 12,
            "2026-05-04": 5,
            "2026-05-06": 4,
            "2026-05-07": 1,
            "2026-05-08": 2,
            "2026-05-09": 1,
            "2026-05-11": 4,
            "2026-05-12": 2,
            "2026-05-13": 3,
            "2026-05-14": 6,
            "2026-05-15": 3,
            "2026-05-16": 1,
            "2026-05-18": 4,
            "2026-05-19": 9,
            "2026-05-20": 4,
            "2026-05-21": 11,
            "2026-05-22": 5,
            "2026-05-25": 7,
            "2026-05-26": 9,
            "2026-05-27": 11,
            "2026-05-28": 10,
            "2026-05-29": 11,
            "2026-05-30": 3,
            "2026-06-01": 2,
            "2026-06-02": 11,
            "2026-06-03": 7,
            "2026-06-05": 18,
            "2026-06-06": 4,
            "2026-06-08": 6
          }
        },
        "P3": {
          "avg_time_hours": 217.65,
          "mode_time_hours": 7.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 5,
            "4-6h": 1,
            "6-8h": 9,
            "68-70h": 1,
            "78-80h": 1,
            "188-190h": 1,
            "242-244h": 4,
            "268-270h": 1,
            "386-388h": 1,
            "504-506h": 1,
            "506-508h": 1,
            "528-530h": 1,
            "580-582h": 1,
            "596-598h": 1,
            "898-900h": 1,
            "1104-1106h": 1,
            "1718-1720h": 1
          },
          "tickets_count": 40,
          "tickets_per_day": {
            "2025-10-23": 3,
            "2025-11-24": 1,
            "2025-11-26": 1,
            "2025-12-04": 1,
            "2025-12-12": 1,
            "2025-12-15": 7,
            "2025-12-18": 3,
            "2025-12-19": 4,
            "2025-12-26": 1,
            "2026-01-08": 1,
            "2026-01-15": 1,
            "2026-01-18": 1,
            "2026-01-23": 1,
            "2026-01-26": 3,
            "2026-02-09": 2,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-04-10": 1
          },
          "time_per_day": {
            "2025-10-23": 9.07178888888889,
            "2025-11-24": 1104.1482972222223,
            "2025-11-26": 189.51507166666667,
            "2025-12-04": 6.322555,
            "2025-12-12": 6.035274722222223,
            "2025-12-15": 1828.0507011111113,
            "2025-12-18": 68.5491886111111,
            "2025-12-19": 26.88070361111111,
            "2025-12-26": 0.20433333333333334,
            "2026-01-08": 2.763830555555556,
            "2026-01-15": 0.06665916666666667,
            "2026-01-23": 387.74735027777774,
            "2026-01-26": 9.058465555555555,
            "2026-02-09": 14.7863175,
            "2026-02-10": 1107.7849391666668,
            "2026-02-11": 0.5483430555555556,
            "2026-02-12": 898.1952222222221,
            "2026-02-13": 580.1752552777778,
            "2026-03-04": 0.5269658333333334,
            "2026-03-06": 529.5745380555555,
            "2026-04-10": 1718.3459105555555
          },
          "time_count_per_day": {
            "2025-10-23": 3,
            "2025-11-24": 1,
            "2025-11-26": 1,
            "2025-12-04": 1,
            "2025-12-12": 1,
            "2025-12-15": 7,
            "2025-12-18": 3,
            "2025-12-19": 4,
            "2025-12-26": 1,
            "2026-01-08": 1,
            "2026-01-15": 1,
            "2026-01-23": 1,
            "2026-01-26": 3,
            "2026-02-09": 2,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-04-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 151.69,
          "mode_time_hours": 7.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 7,
            "8-10h": 1,
            "10-12h": 4,
            "12-14h": 1,
            "16-18h": 2,
            "18-20h": 3,
            "20-22h": 1,
            "22-24h": 3,
            "24-26h": 2,
            "26-28h": 1,
            "28-30h": 2,
            "30-32h": 1,
            "32-34h": 1,
            "36-38h": 4,
            "42-44h": 2,
            "44-46h": 2,
            "46-48h": 1,
            "52-54h": 2,
            "56-58h": 1,
            "60-62h": 1,
            "78-80h": 1,
            "80-82h": 1,
            "82-84h": 2,
            "90-92h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "132-134h": 1,
            "140-142h": 2,
            "146-148h": 1,
            "162-164h": 1,
            "172-174h": 1,
            "176-178h": 1,
            "178-180h": 3,
            "198-200h": 5,
            "214-216h": 2,
            "216-218h": 2,
            "244-246h": 1,
            "264-266h": 1,
            "302-304h": 1,
            "304-306h": 1,
            "306-308h": 1,
            "310-312h": 1,
            "334-336h": 1,
            "352-354h": 1,
            "372-374h": 3,
            "384-386h": 1,
            "400-402h": 2,
            "402-404h": 1,
            "416-418h": 1,
            "428-430h": 2,
            "452-454h": 1,
            "456-458h": 3,
            "574-576h": 1,
            "816-818h": 1
          },
          "tickets_count": 102,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-21": 1,
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-10-31": 4,
            "2025-11-06": 1,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-29": 2,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-23": 1,
            "2026-01-27": 3,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-11": 2,
            "2026-02-12": 2,
            "2026-02-19": 2,
            "2026-02-21": 4,
            "2026-02-23": 4,
            "2026-02-24": 1,
            "2026-02-28": 9,
            "2026-03-02": 1,
            "2026-03-14": 4,
            "2026-03-17": 4,
            "2026-03-18": 25,
            "2026-03-24": 1,
            "2026-04-22": 1,
            "2026-05-29": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-14": 27.630331388888887,
            "2025-10-15": 7.295897222222222,
            "2025-10-16": 23.084178333333334,
            "2025-10-21": 56.25621916666667,
            "2025-10-22": 53.046421111111115,
            "2025-10-24": 91.64413611111111,
            "2025-10-28": 264.8675416666667,
            "2025-10-29": 0.759466388888889,
            "2025-10-31": 798.3140130555556,
            "2025-11-06": 16.533696944444443,
            "2025-11-21": 55.867876666666675,
            "2025-11-22": 18.174256944444444,
            "2025-11-24": 83.14610833333333,
            "2025-11-25": 118.70935944444444,
            "2025-11-29": 279.24321944444443,
            "2025-12-02": 147.80113666666665,
            "2025-12-04": 121.62601972222221,
            "2025-12-15": 575.3269038888889,
            "2025-12-19": 45.97237861111111,
            "2026-01-13": 3.1053269444444447,
            "2026-01-14": 13.688187499999998,
            "2026-01-23": 162.7109236111111,
            "2026-01-27": 101.00128583333334,
            "2026-02-03": 141.83642055555555,
            "2026-02-04": 133.07036,
            "2026-02-05": 355.35785027777774,
            "2026-02-06": 479.0600541666667,
            "2026-02-09": 13.226331666666667,
            "2026-02-11": 215.91838305555558,
            "2026-02-12": 234.7981072222222,
            "2026-02-19": 18.23057888888889,
            "2026-02-21": 102.77000805555555,
            "2026-02-23": 119.60149888888888,
            "2026-02-28": 402.64529722222215,
            "2026-03-02": 23.261571944444444,
            "2026-03-14": 562.0816311111112,
            "2026-03-17": 116.37189361111112,
            "2026-03-18": 8731.746242222223,
            "2026-03-24": 7.990562777777778,
            "2026-04-22": 141.56002694444445
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-21": 1,
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-10-31": 4,
            "2025-11-06": 1,
            "2025-11-21": 2,
            "2025-11-22": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-11-29": 2,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-23": 1,
            "2026-01-27": 3,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-06": 3,
            "2026-02-09": 1,
            "2026-02-11": 2,
            "2026-02-12": 2,
            "2026-02-19": 2,
            "2026-02-21": 4,
            "2026-02-23": 4,
            "2026-02-28": 8,
            "2026-03-02": 1,
            "2026-03-14": 4,
            "2026-03-17": 4,
            "2026-03-18": 25,
            "2026-03-24": 1,
            "2026-04-22": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 426.94,
          "mode_time_hours": 805.0,
          "mode_frequency": 2,
          "time_distribution": {
            "20-22h": 1,
            "28-30h": 1,
            "52-54h": 1,
            "100-102h": 1,
            "216-218h": 1,
            "326-328h": 1,
            "334-336h": 1,
            "372-374h": 1,
            "496-498h": 1,
            "576-578h": 1,
            "622-624h": 1,
            "786-788h": 1,
            "804-806h": 2,
            "852-854h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2025-12-26": 1,
            "2026-01-17": 1,
            "2026-02-19": 12,
            "2026-02-21": 1,
            "2026-02-23": 1
          },
          "time_per_day": {
            "2025-12-11": 29.730360555555553,
            "2025-12-12": 53.16230222222222,
            "2025-12-26": 101.28353,
            "2026-01-17": 20.766351666666665,
            "2026-02-19": 6199.228471666667
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2025-12-26": 1,
            "2026-01-17": 1,
            "2026-02-19": 11
          }
        }
      },
      "states": {
        "Aguarda Assinatura (rgpd Cvo)": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-18": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Closed": {
          "overall": {
            "avg_time_hours": 77.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 298,
            "time_distribution": {
              "0-2h": 298,
              "2-4h": 66,
              "4-6h": 44,
              "6-8h": 46,
              "8-10h": 8,
              "10-12h": 7,
              "12-14h": 3,
              "14-16h": 3,
              "16-18h": 3,
              "18-20h": 5,
              "20-22h": 6,
              "22-24h": 7,
              "24-26h": 3,
              "26-28h": 1,
              "28-30h": 18,
              "30-32h": 4,
              "32-34h": 2,
              "36-38h": 4,
              "40-42h": 5,
              "42-44h": 3,
              "44-46h": 2,
              "46-48h": 3,
              "48-50h": 2,
              "50-52h": 1,
              "52-54h": 3,
              "56-58h": 1,
              "60-62h": 3,
              "64-66h": 3,
              "66-68h": 1,
              "68-70h": 3,
              "72-74h": 1,
              "74-76h": 4,
              "76-78h": 4,
              "78-80h": 3,
              "80-82h": 4,
              "82-84h": 2,
              "88-90h": 1,
              "90-92h": 1,
              "96-98h": 1,
              "100-102h": 1,
              "114-116h": 1,
              "118-120h": 1,
              "120-122h": 1,
              "132-134h": 1,
              "138-140h": 1,
              "140-142h": 2,
              "146-148h": 1,
              "162-164h": 8,
              "164-166h": 1,
              "168-170h": 1,
              "172-174h": 2,
              "174-176h": 1,
              "176-178h": 1,
              "178-180h": 3,
              "188-190h": 1,
              "190-192h": 3,
              "192-194h": 1,
              "194-196h": 4,
              "198-200h": 5,
              "212-214h": 1,
              "214-216h": 2,
              "216-218h": 4,
              "242-244h": 4,
              "244-246h": 1,
              "250-252h": 1,
              "252-254h": 1,
              "254-256h": 1,
              "260-262h": 1,
              "262-264h": 1,
              "264-266h": 1,
              "268-270h": 1,
              "280-282h": 1,
              "288-290h": 1,
              "294-296h": 1,
              "302-304h": 1,
              "304-306h": 1,
              "306-308h": 2,
              "310-312h": 1,
              "314-316h": 1,
              "324-326h": 4,
              "326-328h": 1,
              "328-330h": 1,
              "334-336h": 2,
              "340-342h": 1,
              "348-350h": 2,
              "352-354h": 1,
              "354-356h": 1,
              "364-366h": 1,
              "366-368h": 1,
              "372-374h": 4,
              "382-384h": 1,
              "384-386h": 1,
              "386-388h": 3,
              "400-402h": 2,
              "402-404h": 1,
              "408-410h": 1,
              "416-418h": 1,
              "428-430h": 2,
              "452-454h": 1,
              "456-458h": 3,
              "496-498h": 1,
              "504-506h": 1,
              "506-508h": 1,
              "514-516h": 1,
              "524-526h": 2,
              "528-530h": 1,
              "574-576h": 1,
              "576-578h": 1,
              "580-582h": 2,
              "582-584h": 1,
              "596-598h": 1,
              "616-618h": 1,
              "622-624h": 1,
              "744-746h": 1,
              "786-788h": 1,
              "804-806h": 2,
              "816-818h": 1,
              "844-846h": 1,
              "852-854h": 1,
              "876-878h": 1,
              "896-898h": 1,
              "898-900h": 1,
              "1076-1078h": 1,
              "1100-1102h": 1,
              "1104-1106h": 1,
              "1718-1720h": 1
            },
            "tickets_count": 711,
            "tickets_per_day": {
              "2025-10-09": 1,
              "2025-10-14": 2,
              "2025-10-15": 1,
              "2025-10-16": 1,
              "2025-10-21": 2,
              "2025-10-22": 1,
              "2025-10-23": 3,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-29": 2,
              "2025-10-31": 4,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-11-07": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-20": 2,
              "2025-11-21": 5,
              "2025-11-22": 1,
              "2025-11-24": 5,
              "2025-11-25": 1,
              "2025-11-26": 3,
              "2025-11-28": 9,
              "2025-11-29": 2,
              "2025-12-02": 3,
              "2025-12-03": 1,
              "2025-12-04": 3,
              "2025-12-05": 4,
              "2025-12-09": 1,
              "2025-12-10": 4,
              "2025-12-11": 2,
              "2025-12-12": 6,
              "2025-12-15": 10,
              "2025-12-17": 1,
              "2025-12-18": 3,
              "2025-12-19": 6,
              "2025-12-22": 3,
              "2025-12-26": 9,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-02": 4,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-07": 2,
              "2026-01-08": 2,
              "2026-01-13": 3,
              "2026-01-14": 3,
              "2026-01-15": 2,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-20": 10,
              "2026-01-22": 1,
              "2026-01-23": 5,
              "2026-01-26": 12,
              "2026-01-27": 5,
              "2026-01-28": 1,
              "2026-01-30": 4,
              "2026-02-02": 2,
              "2026-02-03": 2,
              "2026-02-04": 2,
              "2026-02-05": 2,
              "2026-02-06": 5,
              "2026-02-09": 7,
              "2026-02-10": 7,
              "2026-02-11": 5,
              "2026-02-12": 4,
              "2026-02-13": 3,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-19": 14,
              "2026-02-20": 11,
              "2026-02-21": 4,
              "2026-02-23": 23,
              "2026-02-24": 2,
              "2026-02-25": 4,
              "2026-02-26": 3,
              "2026-02-28": 12,
              "2026-03-02": 21,
              "2026-03-03": 5,
              "2026-03-04": 3,
              "2026-03-05": 3,
              "2026-03-06": 6,
              "2026-03-07": 1,
              "2026-03-09": 25,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-12": 6,
              "2026-03-13": 9,
              "2026-03-14": 4,
              "2026-03-16": 3,
              "2026-03-17": 6,
              "2026-03-18": 30,
              "2026-03-19": 1,
              "2026-03-20": 15,
              "2026-03-23": 5,
              "2026-03-24": 5,
              "2026-03-25": 4,
              "2026-03-27": 4,
              "2026-03-30": 2,
              "2026-04-02": 2,
              "2026-04-06": 5,
              "2026-04-07": 4,
              "2026-04-08": 9,
              "2026-04-10": 3,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 4,
              "2026-04-16": 6,
              "2026-04-17": 6,
              "2026-04-21": 2,
              "2026-04-22": 8,
              "2026-04-23": 4,
              "2026-04-24": 7,
              "2026-04-27": 5,
              "2026-04-28": 8,
              "2026-04-29": 4,
              "2026-04-30": 12,
              "2026-05-04": 5,
              "2026-05-06": 4,
              "2026-05-07": 1,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 5,
              "2026-05-12": 3,
              "2026-05-13": 3,
              "2026-05-14": 6,
              "2026-05-15": 3,
              "2026-05-16": 1,
              "2026-05-18": 4,
              "2026-05-19": 11,
              "2026-05-20": 4,
              "2026-05-21": 12,
              "2026-05-22": 6,
              "2026-05-25": 8,
              "2026-05-26": 9,
              "2026-05-27": 11,
              "2026-05-28": 10,
              "2026-05-29": 11,
              "2026-05-30": 3,
              "2026-06-01": 2,
              "2026-06-02": 11,
              "2026-06-03": 7,
              "2026-06-05": 18,
              "2026-06-06": 4,
              "2026-06-08": 6
            },
            "time_per_day": {
              "2025-10-09": 5.928514444444444,
              "2025-10-14": 38.00605638888889,
              "2025-10-15": 7.295897222222222,
              "2025-10-16": 23.084178333333334,
              "2025-10-21": 57.306424444444445,
              "2025-10-22": 53.046421111111115,
              "2025-10-23": 9.07178888888889,
              "2025-10-24": 91.64413611111111,
              "2025-10-27": 4.266186388888889,
              "2025-10-28": 264.8675416666667,
              "2025-10-29": 2.1836458333333333,
              "2025-10-31": 798.3140130555556,
              "2025-11-04": 28.078527222222224,
              "2025-11-06": 16.91294861111111,
              "2025-11-07": 7.182623333333333,
              "2025-11-18": 7.580475833333333,
              "2025-11-19": 0.7761488888888889,
              "2025-11-20": 3.1897516666666665,
              "2025-11-21": 85.33554861111111,
              "2025-11-22": 18.174256944444444,
              "2025-11-24": 1195.7549269444446,
              "2025-11-25": 118.70935944444444,
              "2025-11-26": 196.2162836111111,
              "2025-11-28": 14.103290833333332,
              "2025-11-29": 279.24321944444443,
              "2025-12-02": 156.8522625,
              "2025-12-03": 20.073528611111108,
              "2025-12-04": 176.0677008333333,
              "2025-12-05": 102.13382277777777,
              "2025-12-09": 0.1919038888888889,
              "2025-12-10": 453.6337369444445,
              "2025-12-11": 30.260379999999998,
              "2025-12-12": 66.02607361111112,
              "2025-12-15": 2403.504206944445,
              "2025-12-17": 18.473275833333336,
              "2025-12-18": 68.5491886111111,
              "2025-12-19": 149.80121333333332,
              "2025-12-22": 752.3575005555556,
              "2025-12-26": 110.64652222222222,
              "2025-12-29": 0.13212583333333333,
              "2025-12-30": 29.886094722222225,
              "2026-01-02": 2.509909722222222,
              "2026-01-05": 1.1636530555555555,
              "2026-01-06": 8.139582222222222,
              "2026-01-07": 1.8825800000000001,
              "2026-01-08": 26.05435166666667,
              "2026-01-13": 28.598543333333332,
              "2026-01-14": 14.965724166666664,
              "2026-01-15": 0.9189622222222223,
              "2026-01-16": 5.1070475,
              "2026-01-17": 20.766351666666665,
              "2026-01-20": 246.0382525,
              "2026-01-22": 0.5369391666666666,
              "2026-01-23": 1404.7593555555557,
              "2026-01-26": 40.1981086111111,
              "2026-01-27": 189.60984722222221,
              "2026-01-28": 7.752356388888889,
              "2026-01-30": 191.42412777777778,
              "2026-02-02": 139.03100999999998,
              "2026-02-03": 1018.0654852777777,
              "2026-02-04": 144.14738499999999,
              "2026-02-05": 355.35785027777774,
              "2026-02-06": 480.1943238888889,
              "2026-02-09": 112.26011638888889,
              "2026-02-10": 1421.688293888889,
              "2026-02-11": 218.77680944444447,
              "2026-02-12": 1447.3743430555553,
              "2026-02-13": 580.3572777777778,
              "2026-02-17": 31.069153888888888,
              "2026-02-18": 3.037431111111111,
              "2026-02-19": 6217.55236388889,
              "2026-02-20": 279.08703083333336,
              "2026-02-21": 102.77000805555555,
              "2026-02-23": 251.2666969444444,
              "2026-02-24": 3.2309469444444443,
              "2026-02-25": 23.807555,
              "2026-02-26": 1.8413919444444444,
              "2026-02-28": 427.0689497222221,
              "2026-03-02": 344.27808722222227,
              "2026-03-03": 90.44204833333335,
              "2026-03-04": 222.0387047222222,
              "2026-03-05": 14.212225833333335,
              "2026-03-06": 2189.130240833333,
              "2026-03-07": 1.0339847222222223,
              "2026-03-09": 192.5535361111112,
              "2026-03-10": 39.49731611111111,
              "2026-03-11": 288.8341894444444,
              "2026-03-12": 2.1604824999999996,
              "2026-03-13": 1307.3017847222222,
              "2026-03-14": 562.0816311111112,
              "2026-03-16": 8.92832638888889,
              "2026-03-17": 116.5430188888889,
              "2026-03-18": 9047.802800277776,
              "2026-03-19": 1.0079997222222221,
              "2026-03-20": 1269.3310127777784,
              "2026-03-23": 84.85680861111112,
              "2026-03-24": 14.85594,
              "2026-03-25": 8.887294999999998,
              "2026-03-27": 2.7066569444444446,
              "2026-03-30": 78.04916222222222,
              "2026-04-02": 7.634425833333333,
              "2026-04-06": 12.688513055555555,
              "2026-04-07": 198.04102833333334,
              "2026-04-08": 8.069338055555557,
              "2026-04-10": 1718.44988,
              "2026-04-13": 1.1621641666666667,
              "2026-04-14": 464.4814772222222,
              "2026-04-15": 411.74581916666665,
              "2026-04-16": 1246.200762777778,
              "2026-04-17": 2.786992222222222,
              "2026-04-21": 1.5019108333333335,
              "2026-04-22": 558.4180461111112,
              "2026-04-23": 191.94598694444446,
              "2026-04-24": 2.542661388888889,
              "2026-04-27": 4.784105277777778,
              "2026-04-28": 974.1243686111111,
              "2026-04-29": 178.8740752777778,
              "2026-04-30": 25.881642499999998,
              "2026-05-04": 1142.5189241666665,
              "2026-05-06": 1668.0385097222222,
              "2026-05-07": 217.12104805555558,
              "2026-05-08": 13.58359,
              "2026-05-09": 46.74550027777778,
              "2026-05-11": 7.627616388888888,
              "2026-05-12": 124.8015361111111,
              "2026-05-13": 0.7391647222222222,
              "2026-05-14": 584.4481172222222,
              "2026-05-15": 8.194653888888888,
              "2026-05-16": 96.31714888888888,
              "2026-05-18": 509.1349808333333,
              "2026-05-19": 298.6145969444445,
              "2026-05-20": 46.16727388888888,
              "2026-05-21": 1730.3259594444444,
              "2026-05-22": 1305.800988888889,
              "2026-05-25": 1092.3494805555558,
              "2026-05-26": 5.780608333333333,
              "2026-05-27": 13.419250277777778,
              "2026-05-28": 2.3508791666666666,
              "2026-05-29": 73.96287666666667,
              "2026-05-30": 222.98155527777777,
              "2026-06-01": 3.4871286111111113,
              "2026-06-02": 6.061820555555555,
              "2026-06-03": 190.4959638888889,
              "2026-06-05": 13.606836388888889,
              "2026-06-06": 51.85606666666666,
              "2026-06-08": 68.62411527777778
            },
            "time_count_per_day": {
              "2025-10-09": 1,
              "2025-10-14": 2,
              "2025-10-15": 1,
              "2025-10-16": 1,
              "2025-10-21": 2,
              "2025-10-22": 1,
              "2025-10-23": 3,
              "2025-10-24": 1,
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-10-29": 2,
              "2025-10-31": 4,
              "2025-11-04": 1,
              "2025-11-06": 2,
              "2025-11-07": 1,
              "2025-11-18": 1,
              "2025-11-19": 1,
              "2025-11-20": 2,
              "2025-11-21": 5,
              "2025-11-22": 1,
              "2025-11-24": 5,
              "2025-11-25": 1,
              "2025-11-26": 3,
              "2025-11-28": 9,
              "2025-11-29": 2,
              "2025-12-02": 3,
              "2025-12-03": 1,
              "2025-12-04": 3,
              "2025-12-05": 4,
              "2025-12-09": 1,
              "2025-12-10": 4,
              "2025-12-11": 2,
              "2025-12-12": 6,
              "2025-12-15": 10,
              "2025-12-17": 1,
              "2025-12-18": 3,
              "2025-12-19": 6,
              "2025-12-22": 3,
              "2025-12-26": 9,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-02": 4,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-07": 2,
              "2026-01-08": 2,
              "2026-01-13": 3,
              "2026-01-14": 3,
              "2026-01-15": 2,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-20": 10,
              "2026-01-22": 1,
              "2026-01-23": 5,
              "2026-01-26": 12,
              "2026-01-27": 5,
              "2026-01-28": 1,
              "2026-01-30": 4,
              "2026-02-02": 2,
              "2026-02-03": 2,
              "2026-02-04": 2,
              "2026-02-05": 2,
              "2026-02-06": 5,
              "2026-02-09": 7,
              "2026-02-10": 7,
              "2026-02-11": 5,
              "2026-02-12": 4,
              "2026-02-13": 3,
              "2026-02-17": 1,
              "2026-02-18": 2,
              "2026-02-19": 14,
              "2026-02-20": 11,
              "2026-02-21": 4,
              "2026-02-23": 23,
              "2026-02-24": 2,
              "2026-02-25": 4,
              "2026-02-26": 3,
              "2026-02-28": 12,
              "2026-03-02": 21,
              "2026-03-03": 5,
              "2026-03-04": 3,
              "2026-03-05": 3,
              "2026-03-06": 6,
              "2026-03-07": 1,
              "2026-03-09": 25,
              "2026-03-10": 2,
              "2026-03-11": 2,
              "2026-03-12": 6,
              "2026-03-13": 9,
              "2026-03-14": 4,
              "2026-03-16": 3,
              "2026-03-17": 6,
              "2026-03-18": 30,
              "2026-03-19": 1,
              "2026-03-20": 15,
              "2026-03-23": 5,
              "2026-03-24": 5,
              "2026-03-25": 4,
              "2026-03-27": 4,
              "2026-03-30": 2,
              "2026-04-02": 2,
              "2026-04-06": 5,
              "2026-04-07": 4,
              "2026-04-08": 9,
              "2026-04-10": 3,
              "2026-04-13": 2,
              "2026-04-14": 2,
              "2026-04-15": 4,
              "2026-04-16": 6,
              "2026-04-17": 6,
              "2026-04-21": 2,
              "2026-04-22": 8,
              "2026-04-23": 4,
              "2026-04-24": 7,
              "2026-04-27": 5,
              "2026-04-28": 8,
              "2026-04-29": 4,
              "2026-04-30": 12,
              "2026-05-04": 5,
              "2026-05-06": 4,
              "2026-05-07": 1,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-11": 5,
              "2026-05-12": 3,
              "2026-05-13": 3,
              "2026-05-14": 6,
              "2026-05-15": 3,
              "2026-05-16": 1,
              "2026-05-18": 4,
              "2026-05-19": 11,
              "2026-05-20": 4,
              "2026-05-21": 12,
              "2026-05-22": 6,
              "2026-05-25": 8,
              "2026-05-26": 9,
              "2026-05-27": 11,
              "2026-05-28": 10,
              "2026-05-29": 11,
              "2026-05-30": 3,
              "2026-06-01": 2,
              "2026-06-02": 11,
              "2026-06-03": 7,
              "2026-06-05": 18,
              "2026-06-06": 4,
              "2026-06-08": 6
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 59.68,
              "mode_time_hours": 3.0,
              "mode_frequency": 26,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 26,
                "4-6h": 3,
                "6-8h": 12,
                "8-10h": 3,
                "18-20h": 1,
                "22-24h": 1,
                "28-30h": 2,
                "30-32h": 2,
                "32-34h": 1,
                "48-50h": 1,
                "64-66h": 1,
                "66-68h": 1,
                "76-78h": 1,
                "138-140h": 1,
                "192-194h": 1,
                "194-196h": 3,
                "250-252h": 1,
                "262-264h": 1,
                "280-282h": 1,
                "306-308h": 1,
                "844-846h": 1,
                "896-898h": 1
              },
              "tickets_count": 74,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2025-11-04": 1,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-24": 3,
                "2025-12-05": 2,
                "2025-12-12": 1,
                "2025-12-22": 1,
                "2026-01-06": 1,
                "2026-01-20": 1,
                "2026-01-26": 2,
                "2026-01-28": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-17": 1,
                "2026-02-20": 1,
                "2026-03-02": 8,
                "2026-03-03": 3,
                "2026-03-05": 1,
                "2026-03-09": 16,
                "2026-03-10": 1,
                "2026-03-16": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-23": 4,
                "2026-04-16": 1,
                "2026-04-28": 4,
                "2026-05-11": 1,
                "2026-05-12": 1,
                "2026-05-19": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-10-27": 4.266186388888889,
                "2025-11-04": 28.078527222222224,
                "2025-11-18": 7.580475833333333,
                "2025-11-19": 0.7761488888888889,
                "2025-11-20": 3.1897516666666665,
                "2025-11-21": 9.812267222222221,
                "2025-11-24": 8.460521388888889,
                "2025-12-05": 23.87092722222222,
                "2025-12-12": 3.2853466666666664,
                "2025-12-22": 2.3250313888888887,
                "2026-01-06": 8.139582222222222,
                "2026-01-20": 8.536498611111112,
                "2026-01-26": 13.122520555555557,
                "2026-01-28": 7.752356388888889,
                "2026-01-30": 2.8413155555555556,
                "2026-02-02": 138.90708388888888,
                "2026-02-09": 4.91489,
                "2026-02-10": 29.27026638888889,
                "2026-02-17": 31.069153888888888,
                "2026-02-20": 263.7448591666667,
                "2026-03-02": 99.20282277777778,
                "2026-03-03": 30.689290555555555,
                "2026-03-05": 1.071865,
                "2026-03-09": 172.59003944444453,
                "2026-03-10": 32.63545638888889,
                "2026-03-16": 7.221163611111111,
                "2026-03-18": 306.05299194444444,
                "2026-03-20": 2.031414166666667,
                "2026-03-23": 84.30769083333334,
                "2026-04-16": 897.6813783333333,
                "2026-04-28": 776.5194027777777,
                "2026-05-11": 0.07928944444444444,
                "2026-05-12": 7.821209166666667,
                "2026-05-19": 284.3649266666667,
                "2026-05-21": 19.5824275,
                "2026-05-22": 250.13939944444445,
                "2026-05-25": 844.4759944444445
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2025-11-04": 1,
                "2025-11-18": 1,
                "2025-11-19": 1,
                "2025-11-20": 2,
                "2025-11-21": 1,
                "2025-11-24": 3,
                "2025-12-05": 2,
                "2025-12-12": 1,
                "2025-12-22": 1,
                "2026-01-06": 1,
                "2026-01-20": 1,
                "2026-01-26": 2,
                "2026-01-28": 1,
                "2026-01-30": 1,
                "2026-02-02": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-17": 1,
                "2026-02-20": 1,
                "2026-03-02": 8,
                "2026-03-03": 3,
                "2026-03-05": 1,
                "2026-03-09": 16,
                "2026-03-10": 1,
                "2026-03-16": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-23": 4,
                "2026-04-16": 1,
                "2026-04-28": 4,
                "2026-05-11": 1,
                "2026-05-12": 1,
                "2026-05-19": 2,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-25": 1
              }
            },
            "P2": {
              "avg_time_hours": 42.43,
              "mode_time_hours": 1.0,
              "mode_frequency": 280,
              "time_distribution": {
                "0-2h": 280,
                "2-4h": 34,
                "4-6h": 38,
                "6-8h": 18,
                "8-10h": 4,
                "10-12h": 3,
                "12-14h": 2,
                "14-16h": 3,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 4,
                "22-24h": 3,
                "24-26h": 1,
                "28-30h": 13,
                "30-32h": 1,
                "40-42h": 5,
                "42-44h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "50-52h": 1,
                "60-62h": 2,
                "64-66h": 2,
                "68-70h": 2,
                "72-74h": 1,
                "74-76h": 4,
                "76-78h": 3,
                "78-80h": 1,
                "80-82h": 3,
                "88-90h": 1,
                "96-98h": 1,
                "114-116h": 1,
                "162-164h": 7,
                "164-166h": 1,
                "168-170h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "190-192h": 3,
                "194-196h": 1,
                "212-214h": 1,
                "216-218h": 1,
                "252-254h": 1,
                "254-256h": 1,
                "260-262h": 1,
                "288-290h": 1,
                "294-296h": 1,
                "314-316h": 1,
                "324-326h": 4,
                "328-330h": 1,
                "340-342h": 1,
                "348-350h": 2,
                "354-356h": 1,
                "364-366h": 1,
                "366-368h": 1,
                "382-384h": 1,
                "386-388h": 2,
                "408-410h": 1,
                "514-516h": 1,
                "524-526h": 2,
                "580-582h": 1,
                "582-584h": 1,
                "616-618h": 1,
                "744-746h": 1,
                "876-878h": 1,
                "1076-1078h": 1,
                "1100-1102h": 1
              },
              "tickets_count": 485,
              "tickets_per_day": {
                "2025-10-09": 1,
                "2025-10-14": 1,
                "2025-10-21": 1,
                "2025-10-29": 1,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-21": 2,
                "2025-11-26": 2,
                "2025-11-28": 9,
                "2025-12-02": 2,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 4,
                "2025-12-11": 1,
                "2025-12-12": 3,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-22": 2,
                "2025-12-26": 7,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2026-01-02": 4,
                "2026-01-05": 1,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 9,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 7,
                "2026-01-27": 2,
                "2026-01-30": 3,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-06": 2,
                "2026-02-09": 3,
                "2026-02-10": 3,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 2,
                "2026-02-19": 1,
                "2026-02-20": 10,
                "2026-02-23": 19,
                "2026-02-24": 2,
                "2026-02-25": 4,
                "2026-02-26": 3,
                "2026-02-28": 4,
                "2026-03-02": 12,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-05": 2,
                "2026-03-06": 5,
                "2026-03-07": 1,
                "2026-03-09": 9,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 6,
                "2026-03-13": 9,
                "2026-03-16": 1,
                "2026-03-17": 2,
                "2026-03-18": 4,
                "2026-03-19": 1,
                "2026-03-20": 14,
                "2026-03-23": 1,
                "2026-03-24": 4,
                "2026-03-25": 4,
                "2026-03-27": 4,
                "2026-03-30": 2,
                "2026-04-02": 2,
                "2026-04-06": 5,
                "2026-04-07": 4,
                "2026-04-08": 9,
                "2026-04-10": 2,
                "2026-04-13": 2,
                "2026-04-14": 2,
                "2026-04-15": 4,
                "2026-04-16": 5,
                "2026-04-17": 6,
                "2026-04-21": 2,
                "2026-04-22": 7,
                "2026-04-23": 4,
                "2026-04-24": 7,
                "2026-04-27": 5,
                "2026-04-28": 4,
                "2026-04-29": 4,
                "2026-04-30": 12,
                "2026-05-04": 5,
                "2026-05-06": 4,
                "2026-05-07": 1,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 4,
                "2026-05-12": 2,
                "2026-05-13": 3,
                "2026-05-14": 6,
                "2026-05-15": 3,
                "2026-05-16": 1,
                "2026-05-18": 4,
                "2026-05-19": 9,
                "2026-05-20": 4,
                "2026-05-21": 11,
                "2026-05-22": 5,
                "2026-05-25": 7,
                "2026-05-26": 9,
                "2026-05-27": 11,
                "2026-05-28": 10,
                "2026-05-29": 11,
                "2026-05-30": 3,
                "2026-06-01": 2,
                "2026-06-02": 11,
                "2026-06-03": 7,
                "2026-06-05": 18,
                "2026-06-06": 4,
                "2026-06-08": 6
              },
              "time_per_day": {
                "2025-10-09": 5.928514444444444,
                "2025-10-14": 10.375725000000001,
                "2025-10-21": 1.0502052777777777,
                "2025-10-29": 1.4241794444444444,
                "2025-11-06": 0.37925166666666665,
                "2025-11-07": 7.182623333333333,
                "2025-11-21": 19.655404722222222,
                "2025-11-26": 6.701211944444444,
                "2025-11-28": 14.103290833333332,
                "2025-12-02": 9.051125833333334,
                "2025-12-03": 20.073528611111108,
                "2025-12-04": 48.11912611111111,
                "2025-12-05": 78.26289555555555,
                "2025-12-09": 0.1919038888888889,
                "2025-12-10": 453.6337369444445,
                "2025-12-11": 0.5300194444444444,
                "2025-12-12": 3.54315,
                "2025-12-15": 0.12660194444444445,
                "2025-12-17": 18.473275833333336,
                "2025-12-19": 76.94813111111111,
                "2025-12-22": 750.0324691666667,
                "2025-12-26": 9.158658888888889,
                "2025-12-29": 0.13212583333333333,
                "2025-12-30": 29.886094722222225,
                "2026-01-02": 2.509909722222222,
                "2026-01-05": 1.1636530555555555,
                "2026-01-07": 1.8825800000000001,
                "2026-01-08": 23.29052111111111,
                "2026-01-13": 25.49321638888889,
                "2026-01-14": 1.2775366666666665,
                "2026-01-15": 0.8523030555555556,
                "2026-01-16": 5.1070475,
                "2026-01-20": 237.50175388888889,
                "2026-01-22": 0.5369391666666666,
                "2026-01-23": 854.3010816666666,
                "2026-01-26": 18.0171225,
                "2026-01-27": 88.60856138888889,
                "2026-01-30": 188.58281222222223,
                "2026-02-02": 0.12392611111111111,
                "2026-02-03": 876.2290647222222,
                "2026-02-04": 11.077025,
                "2026-02-06": 1.1342697222222222,
                "2026-02-09": 79.33257722222223,
                "2026-02-10": 284.6330883333334,
                "2026-02-11": 2.310083333333333,
                "2026-02-12": 314.3810136111111,
                "2026-02-13": 0.18202249999999998,
                "2026-02-18": 3.037431111111111,
                "2026-02-19": 0.09331333333333333,
                "2026-02-20": 15.342171666666667,
                "2026-02-23": 131.66519805555555,
                "2026-02-24": 3.2309469444444443,
                "2026-02-25": 23.807555,
                "2026-02-26": 1.8413919444444444,
                "2026-02-28": 24.4236525,
                "2026-03-02": 221.81369250000003,
                "2026-03-03": 59.752757777777774,
                "2026-03-04": 221.51173888888889,
                "2026-03-05": 13.140360833333334,
                "2026-03-06": 1659.5557027777777,
                "2026-03-07": 1.0339847222222223,
                "2026-03-09": 19.963496666666664,
                "2026-03-10": 6.861859722222222,
                "2026-03-11": 288.8341894444444,
                "2026-03-12": 2.1604824999999996,
                "2026-03-13": 1307.3017847222222,
                "2026-03-16": 1.7071627777777778,
                "2026-03-17": 0.17112527777777778,
                "2026-03-18": 10.00356611111111,
                "2026-03-19": 1.0079997222222221,
                "2026-03-20": 1267.2995986111116,
                "2026-03-23": 0.5491177777777778,
                "2026-03-24": 6.8653772222222225,
                "2026-03-25": 8.887294999999998,
                "2026-03-27": 2.7066569444444446,
                "2026-03-30": 78.04916222222222,
                "2026-04-02": 7.634425833333333,
                "2026-04-06": 12.688513055555555,
                "2026-04-07": 198.04102833333334,
                "2026-04-08": 8.069338055555557,
                "2026-04-10": 0.10396944444444445,
                "2026-04-13": 1.1621641666666667,
                "2026-04-14": 464.4814772222222,
                "2026-04-15": 411.74581916666665,
                "2026-04-16": 348.5193844444444,
                "2026-04-17": 2.786992222222222,
                "2026-04-21": 1.5019108333333335,
                "2026-04-22": 416.8580191666666,
                "2026-04-23": 191.94598694444446,
                "2026-04-24": 2.542661388888889,
                "2026-04-27": 4.784105277777778,
                "2026-04-28": 197.60496583333332,
                "2026-04-29": 178.8740752777778,
                "2026-04-30": 25.881642499999998,
                "2026-05-04": 1142.5189241666665,
                "2026-05-06": 1668.0385097222222,
                "2026-05-07": 217.12104805555558,
                "2026-05-08": 13.58359,
                "2026-05-09": 46.74550027777778,
                "2026-05-11": 7.548326944444444,
                "2026-05-12": 116.98032694444444,
                "2026-05-13": 0.7391647222222222,
                "2026-05-14": 584.4481172222222,
                "2026-05-15": 8.194653888888888,
                "2026-05-16": 96.31714888888888,
                "2026-05-18": 509.1349808333333,
                "2026-05-19": 14.249670277777778,
                "2026-05-20": 46.16727388888888,
                "2026-05-21": 1710.7435319444444,
                "2026-05-22": 1055.6615894444444,
                "2026-05-25": 247.87348611111113,
                "2026-05-26": 5.780608333333333,
                "2026-05-27": 13.419250277777778,
                "2026-05-28": 2.3508791666666666,
                "2026-05-29": 73.96287666666667,
                "2026-05-30": 222.98155527777777,
                "2026-06-01": 3.4871286111111113,
                "2026-06-02": 6.061820555555555,
                "2026-06-03": 190.4959638888889,
                "2026-06-05": 13.606836388888889,
                "2026-06-06": 51.85606666666666,
                "2026-06-08": 68.62411527777778
              },
              "time_count_per_day": {
                "2025-10-09": 1,
                "2025-10-14": 1,
                "2025-10-21": 1,
                "2025-10-29": 1,
                "2025-11-06": 1,
                "2025-11-07": 1,
                "2025-11-21": 2,
                "2025-11-26": 2,
                "2025-11-28": 9,
                "2025-12-02": 2,
                "2025-12-03": 1,
                "2025-12-04": 1,
                "2025-12-05": 2,
                "2025-12-09": 1,
                "2025-12-10": 4,
                "2025-12-11": 1,
                "2025-12-12": 3,
                "2025-12-15": 2,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-22": 2,
                "2025-12-26": 7,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2026-01-02": 4,
                "2026-01-05": 1,
                "2026-01-07": 2,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 9,
                "2026-01-22": 1,
                "2026-01-23": 3,
                "2026-01-26": 7,
                "2026-01-27": 2,
                "2026-01-30": 3,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-06": 2,
                "2026-02-09": 3,
                "2026-02-10": 3,
                "2026-02-11": 2,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 2,
                "2026-02-19": 1,
                "2026-02-20": 10,
                "2026-02-23": 19,
                "2026-02-24": 2,
                "2026-02-25": 4,
                "2026-02-26": 3,
                "2026-02-28": 4,
                "2026-03-02": 12,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-05": 2,
                "2026-03-06": 5,
                "2026-03-07": 1,
                "2026-03-09": 9,
                "2026-03-10": 1,
                "2026-03-11": 2,
                "2026-03-12": 6,
                "2026-03-13": 9,
                "2026-03-16": 1,
                "2026-03-17": 2,
                "2026-03-18": 4,
                "2026-03-19": 1,
                "2026-03-20": 14,
                "2026-03-23": 1,
                "2026-03-24": 4,
                "2026-03-25": 4,
                "2026-03-27": 4,
                "2026-03-30": 2,
                "2026-04-02": 2,
                "2026-04-06": 5,
                "2026-04-07": 4,
                "2026-04-08": 9,
                "2026-04-10": 2,
                "2026-04-13": 2,
                "2026-04-14": 2,
                "2026-04-15": 4,
                "2026-04-16": 5,
                "2026-04-17": 6,
                "2026-04-21": 2,
                "2026-04-22": 7,
                "2026-04-23": 4,
                "2026-04-24": 7,
                "2026-04-27": 5,
                "2026-04-28": 4,
                "2026-04-29": 4,
                "2026-04-30": 12,
                "2026-05-04": 5,
                "2026-05-06": 4,
                "2026-05-07": 1,
                "2026-05-08": 2,
                "2026-05-09": 1,
                "2026-05-11": 4,
                "2026-05-12": 2,
                "2026-05-13": 3,
                "2026-05-14": 6,
                "2026-05-15": 3,
                "2026-05-16": 1,
                "2026-05-18": 4,
                "2026-05-19": 9,
                "2026-05-20": 4,
                "2026-05-21": 11,
                "2026-05-22": 5,
                "2026-05-25": 7,
                "2026-05-26": 9,
                "2026-05-27": 11,
                "2026-05-28": 10,
                "2026-05-29": 11,
                "2026-05-30": 3,
                "2026-06-01": 2,
                "2026-06-02": 11,
                "2026-06-03": 7,
                "2026-06-05": 18,
                "2026-06-06": 4,
                "2026-06-08": 6
              }
            },
            "P3": {
              "avg_time_hours": 217.65,
              "mode_time_hours": 7.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 5,
                "4-6h": 1,
                "6-8h": 9,
                "68-70h": 1,
                "78-80h": 1,
                "188-190h": 1,
                "242-244h": 4,
                "268-270h": 1,
                "386-388h": 1,
                "504-506h": 1,
                "506-508h": 1,
                "528-530h": 1,
                "580-582h": 1,
                "596-598h": 1,
                "898-900h": 1,
                "1104-1106h": 1,
                "1718-1720h": 1
              },
              "tickets_count": 39,
              "tickets_per_day": {
                "2025-10-23": 3,
                "2025-11-24": 1,
                "2025-11-26": 1,
                "2025-12-04": 1,
                "2025-12-12": 1,
                "2025-12-15": 7,
                "2025-12-18": 3,
                "2025-12-19": 4,
                "2025-12-26": 1,
                "2026-01-08": 1,
                "2026-01-15": 1,
                "2026-01-23": 1,
                "2026-01-26": 3,
                "2026-02-09": 2,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2025-10-23": 9.07178888888889,
                "2025-11-24": 1104.1482972222223,
                "2025-11-26": 189.51507166666667,
                "2025-12-04": 6.322555,
                "2025-12-12": 6.035274722222223,
                "2025-12-15": 1828.0507011111113,
                "2025-12-18": 68.5491886111111,
                "2025-12-19": 26.88070361111111,
                "2025-12-26": 0.20433333333333334,
                "2026-01-08": 2.763830555555556,
                "2026-01-15": 0.06665916666666667,
                "2026-01-23": 387.74735027777774,
                "2026-01-26": 9.058465555555555,
                "2026-02-09": 14.7863175,
                "2026-02-10": 1107.7849391666668,
                "2026-02-11": 0.5483430555555556,
                "2026-02-12": 898.1952222222221,
                "2026-02-13": 580.1752552777778,
                "2026-03-04": 0.5269658333333334,
                "2026-03-06": 529.5745380555555,
                "2026-04-10": 1718.3459105555555
              },
              "time_count_per_day": {
                "2025-10-23": 3,
                "2025-11-24": 1,
                "2025-11-26": 1,
                "2025-12-04": 1,
                "2025-12-12": 1,
                "2025-12-15": 7,
                "2025-12-18": 3,
                "2025-12-19": 4,
                "2025-12-26": 1,
                "2026-01-08": 1,
                "2026-01-15": 1,
                "2026-01-23": 1,
                "2026-01-26": 3,
                "2026-02-09": 2,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-04-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 151.69,
              "mode_time_hours": 7.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 7,
                "8-10h": 1,
                "10-12h": 4,
                "12-14h": 1,
                "16-18h": 2,
                "18-20h": 3,
                "20-22h": 1,
                "22-24h": 3,
                "24-26h": 2,
                "26-28h": 1,
                "28-30h": 2,
                "30-32h": 1,
                "32-34h": 1,
                "36-38h": 4,
                "42-44h": 2,
                "44-46h": 2,
                "46-48h": 1,
                "52-54h": 2,
                "56-58h": 1,
                "60-62h": 1,
                "78-80h": 1,
                "80-82h": 1,
                "82-84h": 2,
                "90-92h": 1,
                "118-120h": 1,
                "120-122h": 1,
                "132-134h": 1,
                "140-142h": 2,
                "146-148h": 1,
                "162-164h": 1,
                "172-174h": 1,
                "176-178h": 1,
                "178-180h": 3,
                "198-200h": 5,
                "214-216h": 2,
                "216-218h": 2,
                "244-246h": 1,
                "264-266h": 1,
                "302-304h": 1,
                "304-306h": 1,
                "306-308h": 1,
                "310-312h": 1,
                "334-336h": 1,
                "352-354h": 1,
                "372-374h": 3,
                "384-386h": 1,
                "400-402h": 2,
                "402-404h": 1,
                "416-418h": 1,
                "428-430h": 2,
                "452-454h": 1,
                "456-458h": 3,
                "574-576h": 1,
                "816-818h": 1
              },
              "tickets_count": 98,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-21": 1,
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-10-31": 4,
                "2025-11-06": 1,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-29": 2,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-13": 2,
                "2026-01-14": 2,
                "2026-01-23": 1,
                "2026-01-27": 3,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-11": 2,
                "2026-02-12": 2,
                "2026-02-19": 2,
                "2026-02-21": 4,
                "2026-02-23": 4,
                "2026-02-28": 8,
                "2026-03-02": 1,
                "2026-03-14": 4,
                "2026-03-17": 4,
                "2026-03-18": 25,
                "2026-03-24": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2025-10-14": 27.630331388888887,
                "2025-10-15": 7.295897222222222,
                "2025-10-16": 23.084178333333334,
                "2025-10-21": 56.25621916666667,
                "2025-10-22": 53.046421111111115,
                "2025-10-24": 91.64413611111111,
                "2025-10-28": 264.8675416666667,
                "2025-10-29": 0.759466388888889,
                "2025-10-31": 798.3140130555556,
                "2025-11-06": 16.533696944444443,
                "2025-11-21": 55.867876666666675,
                "2025-11-22": 18.174256944444444,
                "2025-11-24": 83.14610833333333,
                "2025-11-25": 118.70935944444444,
                "2025-11-29": 279.24321944444443,
                "2025-12-02": 147.80113666666665,
                "2025-12-04": 121.62601972222221,
                "2025-12-15": 575.3269038888889,
                "2025-12-19": 45.97237861111111,
                "2026-01-13": 3.1053269444444447,
                "2026-01-14": 13.688187499999998,
                "2026-01-23": 162.7109236111111,
                "2026-01-27": 101.00128583333334,
                "2026-02-03": 141.83642055555555,
                "2026-02-04": 133.07036,
                "2026-02-05": 355.35785027777774,
                "2026-02-06": 479.0600541666667,
                "2026-02-09": 13.226331666666667,
                "2026-02-11": 215.91838305555558,
                "2026-02-12": 234.7981072222222,
                "2026-02-19": 18.23057888888889,
                "2026-02-21": 102.77000805555555,
                "2026-02-23": 119.60149888888888,
                "2026-02-28": 402.64529722222215,
                "2026-03-02": 23.261571944444444,
                "2026-03-14": 562.0816311111112,
                "2026-03-17": 116.37189361111112,
                "2026-03-18": 8731.746242222223,
                "2026-03-24": 7.990562777777778,
                "2026-04-22": 141.56002694444445
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-15": 1,
                "2025-10-16": 1,
                "2025-10-21": 1,
                "2025-10-22": 1,
                "2025-10-24": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-10-31": 4,
                "2025-11-06": 1,
                "2025-11-21": 2,
                "2025-11-22": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-11-29": 2,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-13": 2,
                "2026-01-14": 2,
                "2026-01-23": 1,
                "2026-01-27": 3,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-06": 3,
                "2026-02-09": 1,
                "2026-02-11": 2,
                "2026-02-12": 2,
                "2026-02-19": 2,
                "2026-02-21": 4,
                "2026-02-23": 4,
                "2026-02-28": 8,
                "2026-03-02": 1,
                "2026-03-14": 4,
                "2026-03-17": 4,
                "2026-03-18": 25,
                "2026-03-24": 1,
                "2026-04-22": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 426.94,
              "mode_time_hours": 805.0,
              "mode_frequency": 2,
              "time_distribution": {
                "20-22h": 1,
                "28-30h": 1,
                "52-54h": 1,
                "100-102h": 1,
                "216-218h": 1,
                "326-328h": 1,
                "334-336h": 1,
                "372-374h": 1,
                "496-498h": 1,
                "576-578h": 1,
                "622-624h": 1,
                "786-788h": 1,
                "804-806h": 2,
                "852-854h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2025-12-26": 1,
                "2026-01-17": 1,
                "2026-02-19": 11
              },
              "time_per_day": {
                "2025-12-11": 29.730360555555553,
                "2025-12-12": 53.16230222222222,
                "2025-12-26": 101.28353,
                "2026-01-17": 20.766351666666665,
                "2026-02-19": 6199.228471666667
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2025-12-26": 1,
                "2026-01-17": 1,
                "2026-02-19": 11
              }
            }
          }
        },
        "Cuba Remarcado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-24": 1,
              "2026-02-28": 1,
              "2026-05-29": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-24": 1,
                "2026-02-28": 1,
                "2026-05-29": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 1,
                "2026-02-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 35,
            "tickets_per_day": {
              "2026-02-23": 1,
              "2026-03-05": 1,
              "2026-04-20": 6,
              "2026-04-21": 1,
              "2026-05-05": 2,
              "2026-05-07": 5,
              "2026-05-12": 4,
              "2026-05-13": 3,
              "2026-05-18": 2,
              "2026-05-19": 4,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-20": 1,
                "2026-05-25": 1,
                "2026-05-29": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 30,
              "tickets_per_day": {
                "2026-03-05": 1,
                "2026-04-20": 5,
                "2026-04-21": 1,
                "2026-05-05": 2,
                "2026-05-07": 5,
                "2026-05-12": 4,
                "2026-05-13": 3,
                "2026-05-18": 2,
                "2026-05-19": 4,
                "2026-05-20": 1,
                "2026-05-25": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 17,
            "tickets_per_day": {
              "2026-04-06": 1,
              "2026-04-20": 3,
              "2026-04-27": 1,
              "2026-05-07": 7,
              "2026-05-26": 1,
              "2026-06-05": 4
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-04-20": 2,
                "2026-05-07": 1,
                "2026-05-26": 1,
                "2026-06-05": 4
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-04-06": 1,
                "2026-04-20": 1,
                "2026-04-27": 1,
                "2026-05-07": 6
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-07": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-07": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_222": {
      "overall": {
        "avg_time_hours": 648.17,
        "mode_time_hours": 117.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1,
          "16-18h": 1,
          "44-46h": 1,
          "116-118h": 1,
          "940-942h": 1,
          "992-994h": 1,
          "1200-1202h": 1,
          "1852-1854h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2026-02-03": 1,
          "2026-03-09": 1,
          "2026-03-20": 1,
          "2026-04-10": 1,
          "2026-04-16": 1,
          "2026-05-11": 1
        },
        "time_per_day": {
          "2025-10-14": 116.87551194444444,
          "2025-12-17": 45.79436388888889,
          "2025-12-23": 16.178661666666667,
          "2026-02-03": 15.976271944444443,
          "2026-03-09": 941.9305055555556,
          "2026-03-20": 1201.5557166666667,
          "2026-04-10": 993.8288211111111,
          "2026-04-16": 1853.2356719444444
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2026-02-03": 1,
          "2026-03-09": 1,
          "2026-03-20": 1,
          "2026-04-10": 1,
          "2026-04-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 738.49,
          "mode_time_hours": 117.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "44-46h": 1,
            "116-118h": 1,
            "940-942h": 1,
            "992-994h": 1,
            "1200-1202h": 1,
            "1852-1854h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-12-17": 1,
            "2025-12-23": 1,
            "2026-03-09": 1,
            "2026-03-20": 1,
            "2026-04-10": 1,
            "2026-04-16": 1
          },
          "time_per_day": {
            "2025-10-14": 116.87551194444444,
            "2025-12-17": 45.79436388888889,
            "2025-12-23": 16.178661666666667,
            "2026-03-09": 941.9305055555556,
            "2026-03-20": 1201.5557166666667,
            "2026-04-10": 993.8288211111111,
            "2026-04-16": 1853.2356719444444
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-12-17": 1,
            "2025-12-23": 1,
            "2026-03-09": 1,
            "2026-03-20": 1,
            "2026-04-10": 1,
            "2026-04-16": 1
          }
        },
        "P3": {
          "avg_time_hours": 15.98,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-05-11": 1
          },
          "time_per_day": {
            "2026-02-03": 15.976271944444443
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 648.17,
            "mode_time_hours": 117.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1,
              "16-18h": 1,
              "44-46h": 1,
              "116-118h": 1,
              "940-942h": 1,
              "992-994h": 1,
              "1200-1202h": 1,
              "1852-1854h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2026-02-03": 1,
              "2026-03-09": 1,
              "2026-03-20": 1,
              "2026-04-10": 1,
              "2026-04-16": 1
            },
            "time_per_day": {
              "2025-10-14": 116.87551194444444,
              "2025-12-17": 45.79436388888889,
              "2025-12-23": 16.178661666666667,
              "2026-02-03": 15.976271944444443,
              "2026-03-09": 941.9305055555556,
              "2026-03-20": 1201.5557166666667,
              "2026-04-10": 993.8288211111111,
              "2026-04-16": 1853.2356719444444
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2026-02-03": 1,
              "2026-03-09": 1,
              "2026-03-20": 1,
              "2026-04-10": 1,
              "2026-04-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 738.49,
              "mode_time_hours": 117.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "44-46h": 1,
                "116-118h": 1,
                "940-942h": 1,
                "992-994h": 1,
                "1200-1202h": 1,
                "1852-1854h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-12-17": 1,
                "2025-12-23": 1,
                "2026-03-09": 1,
                "2026-03-20": 1,
                "2026-04-10": 1,
                "2026-04-16": 1
              },
              "time_per_day": {
                "2025-10-14": 116.87551194444444,
                "2025-12-17": 45.79436388888889,
                "2025-12-23": 16.178661666666667,
                "2026-03-09": 941.9305055555556,
                "2026-03-20": 1201.5557166666667,
                "2026-04-10": 993.8288211111111,
                "2026-04-16": 1853.2356719444444
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-12-17": 1,
                "2025-12-23": 1,
                "2026-03-09": 1,
                "2026-03-20": 1,
                "2026-04-10": 1,
                "2026-04-16": 1
              }
            },
            "P3": {
              "avg_time_hours": 15.98,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 15.976271944444443
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_192": {
      "overall": {
        "avg_time_hours": 265.67,
        "mode_time_hours": 169.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "30-32h": 1,
          "38-40h": 1,
          "44-46h": 1,
          "68-70h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "88-90h": 1,
          "100-102h": 1,
          "124-126h": 2,
          "168-170h": 2,
          "268-270h": 1,
          "318-320h": 1,
          "358-360h": 1,
          "360-362h": 1,
          "406-408h": 1,
          "540-542h": 1,
          "576-578h": 1,
          "696-698h": 1,
          "750-752h": 1,
          "892-894h": 1,
          "1338-1340h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-22": 1,
          "2025-12-02": 2,
          "2025-12-04": 3,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-23": 1,
          "2025-12-29": 1,
          "2026-02-09": 1,
          "2026-03-02": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-04-10": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-04-27": 2,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-07": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-11-17": 70.96203805555555,
          "2025-11-19": 45.718111111111114,
          "2025-11-20": 169.7009072222222,
          "2025-11-22": 100.31676388888889,
          "2025-12-02": 588.036095,
          "2025-12-04": 1589.0314952777776,
          "2025-12-09": 25.706266666666664,
          "2025-12-10": 359.99179555555554,
          "2025-12-14": 38.91262138888889,
          "2025-12-15": 750.6413708333333,
          "2025-12-23": 14.361381666666666,
          "2025-12-29": 68.67186833333334,
          "2026-02-09": 168.03846305555555,
          "2026-03-02": 27.404085555555554,
          "2026-03-20": 892.1218652777777,
          "2026-03-26": 16.837666111111112,
          "2026-04-10": 30.448410555555558,
          "2026-04-16": 407.26850472222225,
          "2026-04-21": 2.1077405555555555,
          "2026-04-23": 1273.986338888889,
          "2026-04-27": 88.91932972222222,
          "2026-05-05": 361.00185388888895,
          "2026-05-06": 541.8382538888889,
          "2026-05-07": 72.4657213888889
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-22": 1,
          "2025-12-02": 2,
          "2025-12-04": 3,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-23": 1,
          "2025-12-29": 1,
          "2026-02-09": 1,
          "2026-03-02": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-04-10": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-04-27": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 16.84,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 16.837666111111112
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 303.37,
          "mode_time_hours": 1339.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "30-32h": 1,
            "38-40h": 1,
            "44-46h": 1,
            "68-70h": 1,
            "70-72h": 1,
            "72-74h": 1,
            "88-90h": 1,
            "318-320h": 1,
            "360-362h": 1,
            "406-408h": 1,
            "540-542h": 1,
            "576-578h": 1,
            "696-698h": 1,
            "750-752h": 1,
            "892-894h": 1,
            "1338-1340h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2025-12-23": 1,
            "2025-12-29": 1,
            "2026-03-02": 1,
            "2026-03-20": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-23": 2,
            "2026-04-27": 2,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-11-17": 70.96203805555555,
            "2025-11-19": 45.718111111111114,
            "2025-12-02": 318.84205472222226,
            "2025-12-04": 1339.464151111111,
            "2025-12-09": 25.706266666666664,
            "2025-12-14": 38.91262138888889,
            "2025-12-15": 750.6413708333333,
            "2025-12-23": 14.361381666666666,
            "2025-12-29": 68.67186833333334,
            "2026-03-02": 27.404085555555554,
            "2026-03-20": 892.1218652777777,
            "2026-04-10": 30.448410555555558,
            "2026-04-16": 407.26850472222225,
            "2026-04-21": 2.1077405555555555,
            "2026-04-23": 1273.986338888889,
            "2026-04-27": 88.91932972222222,
            "2026-05-05": 361.00185388888895,
            "2026-05-06": 541.8382538888889,
            "2026-05-07": 72.4657213888889
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-09": 1,
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2025-12-23": 1,
            "2025-12-29": 1,
            "2026-03-02": 1,
            "2026-03-20": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-23": 2,
            "2026-04-27": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 188.12,
          "mode_time_hours": 169.0,
          "mode_frequency": 2,
          "time_distribution": {
            "100-102h": 1,
            "124-126h": 2,
            "168-170h": 2,
            "268-270h": 1,
            "358-360h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-20": 1,
            "2025-11-22": 1,
            "2025-12-02": 1,
            "2025-12-04": 2,
            "2025-12-10": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2025-11-20": 169.7009072222222,
            "2025-11-22": 100.31676388888889,
            "2025-12-02": 269.1940402777778,
            "2025-12-04": 249.56734416666666,
            "2025-12-10": 359.99179555555554,
            "2026-02-09": 168.03846305555555
          },
          "time_count_per_day": {
            "2025-11-20": 1,
            "2025-11-22": 1,
            "2025-12-02": 1,
            "2025-12-04": 2,
            "2025-12-10": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 265.67,
            "mode_time_hours": 169.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "30-32h": 1,
              "38-40h": 1,
              "44-46h": 1,
              "68-70h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "88-90h": 1,
              "100-102h": 1,
              "124-126h": 2,
              "168-170h": 2,
              "268-270h": 1,
              "318-320h": 1,
              "358-360h": 1,
              "360-362h": 1,
              "406-408h": 1,
              "540-542h": 1,
              "576-578h": 1,
              "696-698h": 1,
              "750-752h": 1,
              "892-894h": 1,
              "1338-1340h": 1
            },
            "tickets_count": 29,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-22": 1,
              "2025-12-02": 2,
              "2025-12-04": 3,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-23": 1,
              "2025-12-29": 1,
              "2026-02-09": 1,
              "2026-03-02": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-04-10": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-04-27": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 1
            },
            "time_per_day": {
              "2025-11-17": 70.96203805555555,
              "2025-11-19": 45.718111111111114,
              "2025-11-20": 169.7009072222222,
              "2025-11-22": 100.31676388888889,
              "2025-12-02": 588.036095,
              "2025-12-04": 1589.0314952777776,
              "2025-12-09": 25.706266666666664,
              "2025-12-10": 359.99179555555554,
              "2025-12-14": 38.91262138888889,
              "2025-12-15": 750.6413708333333,
              "2025-12-23": 14.361381666666666,
              "2025-12-29": 68.67186833333334,
              "2026-02-09": 168.03846305555555,
              "2026-03-02": 27.404085555555554,
              "2026-03-20": 892.1218652777777,
              "2026-03-26": 16.837666111111112,
              "2026-04-10": 30.448410555555558,
              "2026-04-16": 407.26850472222225,
              "2026-04-21": 2.1077405555555555,
              "2026-04-23": 1273.986338888889,
              "2026-04-27": 88.91932972222222,
              "2026-05-05": 361.00185388888895,
              "2026-05-06": 541.8382538888889,
              "2026-05-07": 72.4657213888889
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-22": 1,
              "2025-12-02": 2,
              "2025-12-04": 3,
              "2025-12-09": 1,
              "2025-12-10": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-23": 1,
              "2025-12-29": 1,
              "2026-02-09": 1,
              "2026-03-02": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-04-10": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-04-27": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 16.84,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 16.837666111111112
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 303.37,
              "mode_time_hours": 1339.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "30-32h": 1,
                "38-40h": 1,
                "44-46h": 1,
                "68-70h": 1,
                "70-72h": 1,
                "72-74h": 1,
                "88-90h": 1,
                "318-320h": 1,
                "360-362h": 1,
                "406-408h": 1,
                "540-542h": 1,
                "576-578h": 1,
                "696-698h": 1,
                "750-752h": 1,
                "892-894h": 1,
                "1338-1340h": 1
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2025-12-23": 1,
                "2025-12-29": 1,
                "2026-03-02": 1,
                "2026-03-20": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-23": 2,
                "2026-04-27": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2025-11-17": 70.96203805555555,
                "2025-11-19": 45.718111111111114,
                "2025-12-02": 318.84205472222226,
                "2025-12-04": 1339.464151111111,
                "2025-12-09": 25.706266666666664,
                "2025-12-14": 38.91262138888889,
                "2025-12-15": 750.6413708333333,
                "2025-12-23": 14.361381666666666,
                "2025-12-29": 68.67186833333334,
                "2026-03-02": 27.404085555555554,
                "2026-03-20": 892.1218652777777,
                "2026-04-10": 30.448410555555558,
                "2026-04-16": 407.26850472222225,
                "2026-04-21": 2.1077405555555555,
                "2026-04-23": 1273.986338888889,
                "2026-04-27": 88.91932972222222,
                "2026-05-05": 361.00185388888895,
                "2026-05-06": 541.8382538888889,
                "2026-05-07": 72.4657213888889
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2025-12-09": 1,
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2025-12-23": 1,
                "2025-12-29": 1,
                "2026-03-02": 1,
                "2026-03-20": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-23": 2,
                "2026-04-27": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 188.12,
              "mode_time_hours": 169.0,
              "mode_frequency": 2,
              "time_distribution": {
                "100-102h": 1,
                "124-126h": 2,
                "168-170h": 2,
                "268-270h": 1,
                "358-360h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-20": 1,
                "2025-11-22": 1,
                "2025-12-02": 1,
                "2025-12-04": 2,
                "2025-12-10": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2025-11-20": 169.7009072222222,
                "2025-11-22": 100.31676388888889,
                "2025-12-02": 269.1940402777778,
                "2025-12-04": 249.56734416666666,
                "2025-12-10": 359.99179555555554,
                "2026-02-09": 168.03846305555555
              },
              "time_count_per_day": {
                "2025-11-20": 1,
                "2025-11-22": 1,
                "2025-12-02": 1,
                "2025-12-04": 2,
                "2025-12-10": 1,
                "2026-02-09": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-06": 1,
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-06": 1,
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_226": {
      "overall": {
        "avg_time_hours": 243.81,
        "mode_time_hours": 243.0,
        "mode_frequency": 1,
        "time_distribution": {
          "242-244h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-20": 1
        },
        "time_per_day": {
          "2025-10-20": 243.81400194444444
        },
        "time_count_per_day": {
          "2025-10-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 243.81,
          "mode_time_hours": 243.0,
          "mode_frequency": 1,
          "time_distribution": {
            "242-244h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-20": 1
          },
          "time_per_day": {
            "2025-10-20": 243.81400194444444
          },
          "time_count_per_day": {
            "2025-10-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 243.81,
            "mode_time_hours": 243.0,
            "mode_frequency": 1,
            "time_distribution": {
              "242-244h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-20": 1
            },
            "time_per_day": {
              "2025-10-20": 243.81400194444444
            },
            "time_count_per_day": {
              "2025-10-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 243.81,
              "mode_time_hours": 243.0,
              "mode_frequency": 1,
              "time_distribution": {
                "242-244h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-20": 1
              },
              "time_per_day": {
                "2025-10-20": 243.81400194444444
              },
              "time_count_per_day": {
                "2025-10-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_153": {
      "overall": {
        "avg_time_hours": 251.98,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "30-32h": 1,
          "424-426h": 1,
          "514-516h": 1,
          "538-540h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-10": 1,
          "2025-10-21": 1,
          "2025-12-15": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-10-10": 0.3208552777777778,
          "2025-10-21": 2.3650305555555557,
          "2025-12-15": 425.1928852777778,
          "2026-01-29": 30.24724666666667,
          "2026-02-03": 515.3755113888889,
          "2026-02-12": 538.3871313888889
        },
        "time_count_per_day": {
          "2025-10-10": 1,
          "2025-10-21": 1,
          "2025-12-15": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-10": 1,
            "2025-10-21": 1
          },
          "time_per_day": {
            "2025-10-10": 0.3208552777777778,
            "2025-10-21": 2.3650305555555557
          },
          "time_count_per_day": {
            "2025-10-10": 1,
            "2025-10-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 377.3,
          "mode_time_hours": 425.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1,
            "424-426h": 1,
            "514-516h": 1,
            "538-540h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-15": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-12-15": 425.1928852777778,
            "2026-01-29": 30.24724666666667,
            "2026-02-03": 515.3755113888889,
            "2026-02-12": 538.3871313888889
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 251.98,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "30-32h": 1,
              "424-426h": 1,
              "514-516h": 1,
              "538-540h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-10": 1,
              "2025-10-21": 1,
              "2025-12-15": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-10-10": 0.3208552777777778,
              "2025-10-21": 2.3650305555555557,
              "2025-12-15": 425.1928852777778,
              "2026-01-29": 30.24724666666667,
              "2026-02-03": 515.3755113888889,
              "2026-02-12": 538.3871313888889
            },
            "time_count_per_day": {
              "2025-10-10": 1,
              "2025-10-21": 1,
              "2025-12-15": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-10": 1,
                "2025-10-21": 1
              },
              "time_per_day": {
                "2025-10-10": 0.3208552777777778,
                "2025-10-21": 2.3650305555555557
              },
              "time_count_per_day": {
                "2025-10-10": 1,
                "2025-10-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 377.3,
              "mode_time_hours": 425.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1,
                "424-426h": 1,
                "514-516h": 1,
                "538-540h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-12-15": 425.1928852777778,
                "2026-01-29": 30.24724666666667,
                "2026-02-03": 515.3755113888889,
                "2026-02-12": 538.3871313888889
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-12": 1
              }
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_228": {
      "overall": {
        "avg_time_hours": 3.92,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-10": 1
        },
        "time_per_day": {
          "2025-10-10": 3.9155277777777777
        },
        "time_count_per_day": {
          "2025-10-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.92,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-10": 1
          },
          "time_per_day": {
            "2025-10-10": 3.9155277777777777
          },
          "time_count_per_day": {
            "2025-10-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.92,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-10": 1
            },
            "time_per_day": {
              "2025-10-10": 3.9155277777777777
            },
            "time_count_per_day": {
              "2025-10-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.92,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-10": 1
              },
              "time_per_day": {
                "2025-10-10": 3.9155277777777777
              },
              "time_count_per_day": {
                "2025-10-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_230": {
      "overall": {
        "avg_time_hours": 33.84,
        "mode_time_hours": 1.0,
        "mode_frequency": 11,
        "time_distribution": {
          "0-2h": 11,
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "24-26h": 2,
          "26-28h": 1,
          "50-52h": 3,
          "454-456h": 1
        },
        "tickets_count": 22,
        "tickets_per_day": {
          "2025-10-10": 2,
          "2025-10-13": 1,
          "2025-10-15": 4,
          "2026-01-21": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 2,
          "2026-04-13": 1,
          "2026-05-21": 2,
          "2026-05-22": 2,
          "2026-06-02": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-10": 2.091756111111111,
          "2025-10-13": 1.3217644444444443,
          "2025-10-15": 152.39732194444443,
          "2026-01-21": 4.293912222222223,
          "2026-02-24": 1.1323863888888888,
          "2026-02-25": 9.030615277777777,
          "2026-03-23": 3.263139444444444,
          "2026-03-24": 26.780874722222222,
          "2026-03-27": 0.5043983333333334,
          "2026-04-13": 455.7884647222222,
          "2026-05-21": 1.3571180555555555,
          "2026-05-22": 51.391443055555555,
          "2026-06-02": 1.3699455555555555
        },
        "time_count_per_day": {
          "2025-10-10": 2,
          "2025-10-13": 1,
          "2025-10-15": 4,
          "2026-01-21": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 2,
          "2026-04-13": 1,
          "2026-05-21": 2,
          "2026-05-22": 2,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 33.79,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "24-26h": 2,
            "26-28h": 1,
            "50-52h": 1,
            "454-456h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-10-10": 2,
            "2025-10-15": 2,
            "2026-01-21": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 2,
            "2026-04-13": 1,
            "2026-05-21": 2,
            "2026-05-22": 2,
            "2026-06-02": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-10": 2.091756111111111,
            "2025-10-15": 51.235326388888886,
            "2026-01-21": 4.293912222222223,
            "2026-02-24": 1.1323863888888888,
            "2026-02-25": 9.030615277777777,
            "2026-03-23": 3.263139444444444,
            "2026-03-24": 26.780874722222222,
            "2026-03-27": 0.5043983333333334,
            "2026-04-13": 455.7884647222222,
            "2026-05-21": 1.3571180555555555,
            "2026-05-22": 51.391443055555555,
            "2026-06-02": 1.3699455555555555
          },
          "time_count_per_day": {
            "2025-10-10": 2,
            "2025-10-15": 2,
            "2026-01-21": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 2,
            "2026-04-13": 1,
            "2026-05-21": 2,
            "2026-05-22": 2,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 34.16,
          "mode_time_hours": 51.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "50-52h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-10-15": 2
          },
          "time_per_day": {
            "2025-10-13": 1.3217644444444443,
            "2025-10-15": 101.16199555555556
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-10-15": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 33.84,
            "mode_time_hours": 1.0,
            "mode_frequency": 11,
            "time_distribution": {
              "0-2h": 11,
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "24-26h": 2,
              "26-28h": 1,
              "50-52h": 3,
              "454-456h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-10-10": 2,
              "2025-10-13": 1,
              "2025-10-15": 4,
              "2026-01-21": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 2,
              "2026-04-13": 1,
              "2026-05-21": 2,
              "2026-05-22": 2,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-10-10": 2.091756111111111,
              "2025-10-13": 1.3217644444444443,
              "2025-10-15": 152.39732194444443,
              "2026-01-21": 4.293912222222223,
              "2026-02-24": 1.1323863888888888,
              "2026-02-25": 9.030615277777777,
              "2026-03-23": 3.263139444444444,
              "2026-03-24": 26.780874722222222,
              "2026-03-27": 0.5043983333333334,
              "2026-04-13": 455.7884647222222,
              "2026-05-21": 1.3571180555555555,
              "2026-05-22": 51.391443055555555,
              "2026-06-02": 1.3699455555555555
            },
            "time_count_per_day": {
              "2025-10-10": 2,
              "2025-10-13": 1,
              "2025-10-15": 4,
              "2026-01-21": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 2,
              "2026-04-13": 1,
              "2026-05-21": 2,
              "2026-05-22": 2,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 33.79,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "24-26h": 2,
                "26-28h": 1,
                "50-52h": 1,
                "454-456h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-10-10": 2,
                "2025-10-15": 2,
                "2026-01-21": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 2,
                "2026-04-13": 1,
                "2026-05-21": 2,
                "2026-05-22": 2,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-10": 2.091756111111111,
                "2025-10-15": 51.235326388888886,
                "2026-01-21": 4.293912222222223,
                "2026-02-24": 1.1323863888888888,
                "2026-02-25": 9.030615277777777,
                "2026-03-23": 3.263139444444444,
                "2026-03-24": 26.780874722222222,
                "2026-03-27": 0.5043983333333334,
                "2026-04-13": 455.7884647222222,
                "2026-05-21": 1.3571180555555555,
                "2026-05-22": 51.391443055555555,
                "2026-06-02": 1.3699455555555555
              },
              "time_count_per_day": {
                "2025-10-10": 2,
                "2025-10-15": 2,
                "2026-01-21": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 2,
                "2026-04-13": 1,
                "2026-05-21": 2,
                "2026-05-22": 2,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 34.16,
              "mode_time_hours": 51.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "50-52h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-10-15": 2
              },
              "time_per_day": {
                "2025-10-13": 1.3217644444444443,
                "2025-10-15": 101.16199555555556
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-10-15": 2
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_231": {
      "overall": {
        "avg_time_hours": 130.87,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 2,
          "4-6h": 2,
          "14-16h": 1,
          "18-20h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "50-52h": 1,
          "58-60h": 1,
          "62-64h": 1,
          "78-80h": 2,
          "100-102h": 1,
          "112-114h": 1,
          "244-246h": 1,
          "336-338h": 1,
          "372-374h": 1,
          "388-390h": 1,
          "568-570h": 1,
          "578-580h": 1
        },
        "tickets_count": 26,
        "tickets_per_day": {
          "2025-10-11": 1,
          "2025-10-13": 1,
          "2025-11-19": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-02-23": 1,
          "2026-03-11": 2,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-07": 2,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-05-09": 1,
          "2026-05-27": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-10-11": 4.935856944444444,
          "2025-10-13": 0.2921977777777778,
          "2025-11-19": 101.3975036111111,
          "2026-01-15": 105.42574027777778,
          "2026-01-17": 19.42611861111111,
          "2026-01-26": 79.1036025,
          "2026-02-03": 336.2061552777778,
          "2026-02-10": 0.1407936111111111,
          "2026-02-12": 59.11328555555556,
          "2026-02-14": 63.747480555555555,
          "2026-02-23": 2.3069191666666664,
          "2026-03-11": 633.1491477777777,
          "2026-03-18": 0.961455,
          "2026-03-20": 3.671761666666667,
          "2026-04-07": 55.64008333333334,
          "2026-04-16": 941.9387272222223,
          "2026-04-22": 113.92628694444444,
          "2026-04-23": 578.8590322222223,
          "2026-05-09": 15.779768888888889,
          "2026-05-27": 24.803070277777778
        },
        "time_count_per_day": {
          "2025-10-11": 1,
          "2025-10-13": 1,
          "2025-11-19": 1,
          "2026-01-15": 2,
          "2026-01-17": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-02-23": 1,
          "2026-03-11": 2,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-07": 2,
          "2026-04-16": 2,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-05-09": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 156.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "4-6h": 2,
            "14-16h": 1,
            "24-26h": 1,
            "50-52h": 1,
            "100-102h": 1,
            "112-114h": 1,
            "244-246h": 1,
            "336-338h": 1,
            "372-374h": 1,
            "388-390h": 1,
            "568-570h": 1,
            "578-580h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-11": 1,
            "2025-10-13": 1,
            "2025-11-19": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-23": 1,
            "2026-03-11": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-04-07": 2,
            "2026-04-16": 2,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-09": 1,
            "2026-05-27": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-11": 4.935856944444444,
            "2025-10-13": 0.2921977777777778,
            "2025-11-19": 101.3975036111111,
            "2026-02-03": 336.2061552777778,
            "2026-02-10": 0.1407936111111111,
            "2026-02-23": 2.3069191666666664,
            "2026-03-11": 633.1491477777777,
            "2026-03-18": 0.961455,
            "2026-03-20": 3.671761666666667,
            "2026-04-07": 55.64008333333334,
            "2026-04-16": 941.9387272222223,
            "2026-04-22": 113.92628694444444,
            "2026-04-23": 578.8590322222223,
            "2026-05-09": 15.779768888888889,
            "2026-05-27": 24.803070277777778
          },
          "time_count_per_day": {
            "2025-10-11": 1,
            "2025-10-13": 1,
            "2025-11-19": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-23": 1,
            "2026-03-11": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-04-07": 2,
            "2026-04-16": 2,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-05-09": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 53.54,
          "mode_time_hours": 79.0,
          "mode_frequency": 2,
          "time_distribution": {
            "18-20h": 1,
            "26-28h": 1,
            "62-64h": 1,
            "78-80h": 2
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-01-15": 2,
            "2026-01-17": 1,
            "2026-01-26": 1,
            "2026-02-14": 1
          },
          "time_per_day": {
            "2026-01-15": 105.42574027777778,
            "2026-01-17": 19.42611861111111,
            "2026-01-26": 79.1036025,
            "2026-02-14": 63.747480555555555
          },
          "time_count_per_day": {
            "2026-01-15": 2,
            "2026-01-17": 1,
            "2026-01-26": 1,
            "2026-02-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 59.11,
          "mode_time_hours": 59.0,
          "mode_frequency": 1,
          "time_distribution": {
            "58-60h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 59.11328555555556
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 130.87,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 2,
              "4-6h": 2,
              "14-16h": 1,
              "18-20h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "50-52h": 1,
              "58-60h": 1,
              "62-64h": 1,
              "78-80h": 2,
              "100-102h": 1,
              "112-114h": 1,
              "244-246h": 1,
              "336-338h": 1,
              "372-374h": 1,
              "388-390h": 1,
              "568-570h": 1,
              "578-580h": 1
            },
            "tickets_count": 24,
            "tickets_per_day": {
              "2025-10-11": 1,
              "2025-10-13": 1,
              "2025-11-19": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-02-23": 1,
              "2026-03-11": 2,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-07": 2,
              "2026-04-16": 2,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-09": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-10-11": 4.935856944444444,
              "2025-10-13": 0.2921977777777778,
              "2025-11-19": 101.3975036111111,
              "2026-01-15": 105.42574027777778,
              "2026-01-17": 19.42611861111111,
              "2026-01-26": 79.1036025,
              "2026-02-03": 336.2061552777778,
              "2026-02-10": 0.1407936111111111,
              "2026-02-12": 59.11328555555556,
              "2026-02-14": 63.747480555555555,
              "2026-02-23": 2.3069191666666664,
              "2026-03-11": 633.1491477777777,
              "2026-03-18": 0.961455,
              "2026-03-20": 3.671761666666667,
              "2026-04-07": 55.64008333333334,
              "2026-04-16": 941.9387272222223,
              "2026-04-22": 113.92628694444444,
              "2026-04-23": 578.8590322222223,
              "2026-05-09": 15.779768888888889,
              "2026-05-27": 24.803070277777778
            },
            "time_count_per_day": {
              "2025-10-11": 1,
              "2025-10-13": 1,
              "2025-11-19": 1,
              "2026-01-15": 2,
              "2026-01-17": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-02-23": 1,
              "2026-03-11": 2,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-07": 2,
              "2026-04-16": 2,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-05-09": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 156.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "4-6h": 2,
                "14-16h": 1,
                "24-26h": 1,
                "50-52h": 1,
                "100-102h": 1,
                "112-114h": 1,
                "244-246h": 1,
                "336-338h": 1,
                "372-374h": 1,
                "388-390h": 1,
                "568-570h": 1,
                "578-580h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-10-11": 1,
                "2025-10-13": 1,
                "2025-11-19": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-23": 1,
                "2026-03-11": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-04-07": 2,
                "2026-04-16": 2,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-09": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2025-10-11": 4.935856944444444,
                "2025-10-13": 0.2921977777777778,
                "2025-11-19": 101.3975036111111,
                "2026-02-03": 336.2061552777778,
                "2026-02-10": 0.1407936111111111,
                "2026-02-23": 2.3069191666666664,
                "2026-03-11": 633.1491477777777,
                "2026-03-18": 0.961455,
                "2026-03-20": 3.671761666666667,
                "2026-04-07": 55.64008333333334,
                "2026-04-16": 941.9387272222223,
                "2026-04-22": 113.92628694444444,
                "2026-04-23": 578.8590322222223,
                "2026-05-09": 15.779768888888889,
                "2026-05-27": 24.803070277777778
              },
              "time_count_per_day": {
                "2025-10-11": 1,
                "2025-10-13": 1,
                "2025-11-19": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-23": 1,
                "2026-03-11": 2,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-04-07": 2,
                "2026-04-16": 2,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-05-09": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 53.54,
              "mode_time_hours": 79.0,
              "mode_frequency": 2,
              "time_distribution": {
                "18-20h": 1,
                "26-28h": 1,
                "62-64h": 1,
                "78-80h": 2
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-15": 2,
                "2026-01-17": 1,
                "2026-01-26": 1,
                "2026-02-14": 1
              },
              "time_per_day": {
                "2026-01-15": 105.42574027777778,
                "2026-01-17": 19.42611861111111,
                "2026-01-26": 79.1036025,
                "2026-02-14": 63.747480555555555
              },
              "time_count_per_day": {
                "2026-01-15": 2,
                "2026-01-17": 1,
                "2026-01-26": 1,
                "2026-02-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 59.11,
              "mode_time_hours": 59.0,
              "mode_frequency": 1,
              "time_distribution": {
                "58-60h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 59.11328555555556
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-17": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_233": {
      "overall": {
        "avg_time_hours": 153.24,
        "mode_time_hours": 3.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 4,
          "6-8h": 3,
          "18-20h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "54-56h": 1,
          "66-68h": 1,
          "68-70h": 1,
          "72-74h": 1,
          "104-106h": 1,
          "268-270h": 1,
          "476-478h": 1,
          "516-518h": 1,
          "558-560h": 1,
          "1632-1634h": 1
        },
        "tickets_count": 26,
        "tickets_per_day": {
          "2025-10-14": 1,
          "2025-10-20": 1,
          "2025-10-28": 2,
          "2025-10-30": 1,
          "2025-10-31": 2,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-12-02": 3,
          "2025-12-04": 1,
          "2025-12-08": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-20": 2,
          "2026-03-06": 2,
          "2026-03-31": 1,
          "2026-04-18": 1
        },
        "time_per_day": {
          "2025-10-14": 33.49385916666667,
          "2025-10-20": 6.191918055555555,
          "2025-10-28": 4.456038055555555,
          "2025-10-30": 20.690260833333333,
          "2025-10-31": 135.3890538888889,
          "2025-11-11": 7.61492361111111,
          "2025-11-13": 55.452886666666664,
          "2025-12-02": 29.932144722222223,
          "2025-12-04": 476.08177722222223,
          "2025-12-08": 7.4826652777777785,
          "2026-01-08": 0.047363611111111106,
          "2026-01-14": 19.168210277777778,
          "2026-01-23": 29.051951944444443,
          "2026-01-27": 73.78153361111112,
          "2026-02-03": 516.2655469444445,
          "2026-02-18": 558.1094822222223,
          "2026-02-20": 3.1779619444444447,
          "2026-03-06": 268.47790083333336,
          "2026-03-31": 105.43656055555556,
          "2026-04-18": 1633.814821111111
        },
        "time_count_per_day": {
          "2025-10-14": 1,
          "2025-10-20": 1,
          "2025-10-28": 2,
          "2025-10-30": 1,
          "2025-10-31": 2,
          "2025-11-11": 1,
          "2025-11-13": 1,
          "2025-12-02": 3,
          "2025-12-04": 1,
          "2025-12-08": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-20": 2,
          "2026-03-06": 2,
          "2026-03-31": 1,
          "2026-04-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 149.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 3,
            "6-8h": 3,
            "18-20h": 1,
            "20-22h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "32-34h": 1,
            "54-56h": 1,
            "66-68h": 1,
            "68-70h": 1,
            "268-270h": 1,
            "476-478h": 1,
            "558-560h": 1,
            "1632-1634h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-10-14": 1,
            "2025-10-20": 1,
            "2025-10-28": 2,
            "2025-10-30": 1,
            "2025-10-31": 2,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-12-02": 2,
            "2025-12-04": 1,
            "2025-12-08": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-06": 2,
            "2026-04-18": 1
          },
          "time_per_day": {
            "2025-10-14": 33.49385916666667,
            "2025-10-20": 6.191918055555555,
            "2025-10-28": 4.456038055555555,
            "2025-10-30": 20.690260833333333,
            "2025-10-31": 135.3890538888889,
            "2025-11-11": 7.61492361111111,
            "2025-11-13": 55.452886666666664,
            "2025-12-02": 27.131500833333334,
            "2025-12-04": 476.08177722222223,
            "2025-12-08": 7.4826652777777785,
            "2026-01-08": 0.047363611111111106,
            "2026-01-14": 19.168210277777778,
            "2026-01-23": 29.051951944444443,
            "2026-02-18": 558.1094822222223,
            "2026-02-20": 3.1779619444444447,
            "2026-03-06": 268.47790083333336,
            "2026-04-18": 1633.814821111111
          },
          "time_count_per_day": {
            "2025-10-14": 1,
            "2025-10-20": 1,
            "2025-10-28": 2,
            "2025-10-30": 1,
            "2025-10-31": 2,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-12-02": 2,
            "2025-12-04": 1,
            "2025-12-08": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-06": 2,
            "2026-04-18": 1
          }
        },
        "P3": {
          "avg_time_hours": 174.57,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "72-74h": 1,
            "104-106h": 1,
            "516-518h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-12-02": 2.8006438888888887,
            "2026-01-27": 73.78153361111112,
            "2026-02-03": 516.2655469444445,
            "2026-03-31": 105.43656055555556
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-03-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 153.24,
            "mode_time_hours": 3.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 4,
              "6-8h": 3,
              "18-20h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "54-56h": 1,
              "66-68h": 1,
              "68-70h": 1,
              "72-74h": 1,
              "104-106h": 1,
              "268-270h": 1,
              "476-478h": 1,
              "516-518h": 1,
              "558-560h": 1,
              "1632-1634h": 1
            },
            "tickets_count": 26,
            "tickets_per_day": {
              "2025-10-14": 1,
              "2025-10-20": 1,
              "2025-10-28": 2,
              "2025-10-30": 1,
              "2025-10-31": 2,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-12-02": 3,
              "2025-12-04": 1,
              "2025-12-08": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-20": 2,
              "2026-03-06": 2,
              "2026-03-31": 1,
              "2026-04-18": 1
            },
            "time_per_day": {
              "2025-10-14": 33.49385916666667,
              "2025-10-20": 6.191918055555555,
              "2025-10-28": 4.456038055555555,
              "2025-10-30": 20.690260833333333,
              "2025-10-31": 135.3890538888889,
              "2025-11-11": 7.61492361111111,
              "2025-11-13": 55.452886666666664,
              "2025-12-02": 29.932144722222223,
              "2025-12-04": 476.08177722222223,
              "2025-12-08": 7.4826652777777785,
              "2026-01-08": 0.047363611111111106,
              "2026-01-14": 19.168210277777778,
              "2026-01-23": 29.051951944444443,
              "2026-01-27": 73.78153361111112,
              "2026-02-03": 516.2655469444445,
              "2026-02-18": 558.1094822222223,
              "2026-02-20": 3.1779619444444447,
              "2026-03-06": 268.47790083333336,
              "2026-03-31": 105.43656055555556,
              "2026-04-18": 1633.814821111111
            },
            "time_count_per_day": {
              "2025-10-14": 1,
              "2025-10-20": 1,
              "2025-10-28": 2,
              "2025-10-30": 1,
              "2025-10-31": 2,
              "2025-11-11": 1,
              "2025-11-13": 1,
              "2025-12-02": 3,
              "2025-12-04": 1,
              "2025-12-08": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-20": 2,
              "2026-03-06": 2,
              "2026-03-31": 1,
              "2026-04-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 149.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 3,
                "6-8h": 3,
                "18-20h": 1,
                "20-22h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "32-34h": 1,
                "54-56h": 1,
                "66-68h": 1,
                "68-70h": 1,
                "268-270h": 1,
                "476-478h": 1,
                "558-560h": 1,
                "1632-1634h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-10-14": 1,
                "2025-10-20": 1,
                "2025-10-28": 2,
                "2025-10-30": 1,
                "2025-10-31": 2,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-12-02": 2,
                "2025-12-04": 1,
                "2025-12-08": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-06": 2,
                "2026-04-18": 1
              },
              "time_per_day": {
                "2025-10-14": 33.49385916666667,
                "2025-10-20": 6.191918055555555,
                "2025-10-28": 4.456038055555555,
                "2025-10-30": 20.690260833333333,
                "2025-10-31": 135.3890538888889,
                "2025-11-11": 7.61492361111111,
                "2025-11-13": 55.452886666666664,
                "2025-12-02": 27.131500833333334,
                "2025-12-04": 476.08177722222223,
                "2025-12-08": 7.4826652777777785,
                "2026-01-08": 0.047363611111111106,
                "2026-01-14": 19.168210277777778,
                "2026-01-23": 29.051951944444443,
                "2026-02-18": 558.1094822222223,
                "2026-02-20": 3.1779619444444447,
                "2026-03-06": 268.47790083333336,
                "2026-04-18": 1633.814821111111
              },
              "time_count_per_day": {
                "2025-10-14": 1,
                "2025-10-20": 1,
                "2025-10-28": 2,
                "2025-10-30": 1,
                "2025-10-31": 2,
                "2025-11-11": 1,
                "2025-11-13": 1,
                "2025-12-02": 2,
                "2025-12-04": 1,
                "2025-12-08": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-06": 2,
                "2026-04-18": 1
              }
            },
            "P3": {
              "avg_time_hours": 174.57,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "72-74h": 1,
                "104-106h": 1,
                "516-518h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-12-02": 2.8006438888888887,
                "2026-01-27": 73.78153361111112,
                "2026-02-03": 516.2655469444445,
                "2026-03-31": 105.43656055555556
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-03-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_234": {
      "overall": {
        "avg_time_hours": 79.83,
        "mode_time_hours": 79.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-16": 1
        },
        "time_per_day": {
          "2025-10-16": 79.83264916666667
        },
        "time_count_per_day": {
          "2025-10-16": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 79.83,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-16": 1
          },
          "time_per_day": {
            "2025-10-16": 79.83264916666667
          },
          "time_count_per_day": {
            "2025-10-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 79.83,
            "mode_time_hours": 79.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-16": 1
            },
            "time_per_day": {
              "2025-10-16": 79.83264916666667
            },
            "time_count_per_day": {
              "2025-10-16": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 79.83,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-16": 1
              },
              "time_per_day": {
                "2025-10-16": 79.83264916666667
              },
              "time_count_per_day": {
                "2025-10-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_235": {
      "overall": {
        "avg_time_hours": 231.57,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "6-8h": 1,
          "22-24h": 1,
          "94-96h": 1,
          "170-172h": 1,
          "412-414h": 1,
          "422-424h": 1,
          "432-434h": 1,
          "548-550h": 1,
          "892-894h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-10-13": 1,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-12-09": 1,
          "2025-12-15": 2,
          "2025-12-19": 1,
          "2026-03-18": 1,
          "2026-03-24": 1,
          "2026-04-08": 1,
          "2026-04-22": 1,
          "2026-04-23": 2
        },
        "time_per_day": {
          "2025-10-13": 0.324295,
          "2025-11-26": 22.015575000000002,
          "2025-11-27": 0.49845222222222224,
          "2025-12-09": 3.905713611111111,
          "2025-12-15": 981.0078166666667,
          "2025-12-19": 413.55938861111116,
          "2026-03-18": 422.7266408333333,
          "2026-03-24": 95.06948555555554,
          "2026-04-08": 171.0420797222222,
          "2026-04-22": 6.531539444444445,
          "2026-04-23": 893.7461652777778
        },
        "time_count_per_day": {
          "2025-10-13": 1,
          "2025-11-26": 1,
          "2025-11-27": 1,
          "2025-12-09": 1,
          "2025-12-15": 2,
          "2025-12-19": 1,
          "2026-03-18": 1,
          "2026-03-24": 1,
          "2026-04-08": 1,
          "2026-04-22": 1,
          "2026-04-23": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 66.53,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "22-24h": 1,
            "170-172h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-26": 1,
            "2026-04-08": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2025-11-26": 22.015575000000002,
            "2026-04-08": 171.0420797222222,
            "2026-04-22": 6.531539444444445
          },
          "time_count_per_day": {
            "2025-11-26": 1,
            "2026-04-08": 1,
            "2026-04-22": 1
          }
        },
        "P2": {
          "avg_time_hours": 265.84,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "412-414h": 1,
            "548-550h": 1,
            "892-894h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-13": 1,
            "2025-11-27": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-04-23": 2
          },
          "time_per_day": {
            "2025-10-13": 0.324295,
            "2025-11-27": 0.49845222222222224,
            "2025-12-09": 3.905713611111111,
            "2025-12-15": 548.8685405555556,
            "2025-12-19": 413.55938861111116,
            "2026-04-23": 893.7461652777778
          },
          "time_count_per_day": {
            "2025-10-13": 1,
            "2025-11-27": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-04-23": 2
          }
        },
        "P3": {
          "avg_time_hours": 432.14,
          "mode_time_hours": 433.0,
          "mode_frequency": 1,
          "time_distribution": {
            "432-434h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 432.13927611111114
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 258.9,
          "mode_time_hours": 423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1,
            "422-424h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 1,
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-18": 422.7266408333333,
            "2026-03-24": 95.06948555555554
          },
          "time_count_per_day": {
            "2026-03-18": 1,
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 231.57,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "6-8h": 1,
              "22-24h": 1,
              "94-96h": 1,
              "170-172h": 1,
              "412-414h": 1,
              "422-424h": 1,
              "432-434h": 1,
              "548-550h": 1,
              "892-894h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-10-13": 1,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-12-09": 1,
              "2025-12-15": 2,
              "2025-12-19": 1,
              "2026-03-18": 1,
              "2026-03-24": 1,
              "2026-04-08": 1,
              "2026-04-22": 1,
              "2026-04-23": 2
            },
            "time_per_day": {
              "2025-10-13": 0.324295,
              "2025-11-26": 22.015575000000002,
              "2025-11-27": 0.49845222222222224,
              "2025-12-09": 3.905713611111111,
              "2025-12-15": 981.0078166666667,
              "2025-12-19": 413.55938861111116,
              "2026-03-18": 422.7266408333333,
              "2026-03-24": 95.06948555555554,
              "2026-04-08": 171.0420797222222,
              "2026-04-22": 6.531539444444445,
              "2026-04-23": 893.7461652777778
            },
            "time_count_per_day": {
              "2025-10-13": 1,
              "2025-11-26": 1,
              "2025-11-27": 1,
              "2025-12-09": 1,
              "2025-12-15": 2,
              "2025-12-19": 1,
              "2026-03-18": 1,
              "2026-03-24": 1,
              "2026-04-08": 1,
              "2026-04-22": 1,
              "2026-04-23": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 66.53,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "22-24h": 1,
                "170-172h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-26": 1,
                "2026-04-08": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2025-11-26": 22.015575000000002,
                "2026-04-08": 171.0420797222222,
                "2026-04-22": 6.531539444444445
              },
              "time_count_per_day": {
                "2025-11-26": 1,
                "2026-04-08": 1,
                "2026-04-22": 1
              }
            },
            "P2": {
              "avg_time_hours": 265.84,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "412-414h": 1,
                "548-550h": 1,
                "892-894h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-13": 1,
                "2025-11-27": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-04-23": 2
              },
              "time_per_day": {
                "2025-10-13": 0.324295,
                "2025-11-27": 0.49845222222222224,
                "2025-12-09": 3.905713611111111,
                "2025-12-15": 548.8685405555556,
                "2025-12-19": 413.55938861111116,
                "2026-04-23": 893.7461652777778
              },
              "time_count_per_day": {
                "2025-10-13": 1,
                "2025-11-27": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-04-23": 2
              }
            },
            "P3": {
              "avg_time_hours": 432.14,
              "mode_time_hours": 433.0,
              "mode_frequency": 1,
              "time_distribution": {
                "432-434h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 432.13927611111114
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 258.9,
              "mode_time_hours": 423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1,
                "422-424h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 1,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-18": 422.7266408333333,
                "2026-03-24": 95.06948555555554
              },
              "time_count_per_day": {
                "2026-03-18": 1,
                "2026-03-24": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_232": {
      "overall": {
        "avg_time_hours": 170.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 9,
        "time_distribution": {
          "0-2h": 9,
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 2,
          "12-14h": 1,
          "14-16h": 2,
          "16-18h": 2,
          "18-20h": 2,
          "22-24h": 1,
          "26-28h": 2,
          "32-34h": 1,
          "42-44h": 2,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "52-54h": 1,
          "58-60h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "74-76h": 2,
          "82-84h": 1,
          "84-86h": 1,
          "106-108h": 1,
          "126-128h": 1,
          "138-140h": 1,
          "146-148h": 1,
          "174-176h": 1,
          "184-186h": 1,
          "210-212h": 1,
          "256-258h": 1,
          "288-290h": 1,
          "292-294h": 1,
          "300-302h": 1,
          "310-312h": 1,
          "342-344h": 1,
          "372-374h": 1,
          "380-382h": 1,
          "480-482h": 1,
          "492-494h": 1,
          "496-498h": 1,
          "524-526h": 1,
          "526-528h": 1,
          "660-662h": 1,
          "1080-1082h": 1,
          "1362-1364h": 1
        },
        "tickets_count": 62,
        "tickets_per_day": {
          "2025-10-15": 2,
          "2025-10-17": 1,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-25": 1,
          "2025-12-04": 1,
          "2025-12-05": 2,
          "2025-12-06": 1,
          "2025-12-12": 1,
          "2025-12-14": 1,
          "2025-12-15": 2,
          "2025-12-29": 1,
          "2026-01-13": 2,
          "2026-01-14": 1,
          "2026-01-19": 1,
          "2026-01-23": 2,
          "2026-01-29": 2,
          "2026-01-30": 1,
          "2026-01-31": 2,
          "2026-02-03": 4,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-10": 4,
          "2026-02-11": 2,
          "2026-02-12": 2,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-20": 3,
          "2026-03-26": 1,
          "2026-04-09": 1,
          "2026-04-14": 1,
          "2026-04-23": 1,
          "2026-05-14": 1,
          "2026-05-18": 3,
          "2026-05-22": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-10-15": 46.79554777777777,
          "2025-10-17": 42.80797555555556,
          "2025-11-13": 4.389436111111111,
          "2025-11-19": 185.29528000000002,
          "2025-11-25": 0.5279297222222222,
          "2025-12-04": 311.7212333333333,
          "2025-12-05": 45.47252388888889,
          "2025-12-06": 3.4375983333333333,
          "2025-12-12": 147.98746472222223,
          "2025-12-14": 107.92417388888889,
          "2025-12-15": 48.372764444444435,
          "2025-12-29": 127.17127777777777,
          "2026-01-13": 29.031693055555557,
          "2026-01-14": 0.11452555555555555,
          "2026-01-19": 0.5856088888888888,
          "2026-01-23": 105.31818944444444,
          "2026-01-29": 71.98789722222223,
          "2026-01-30": 32.21393277777778,
          "2026-01-31": 56.75680333333333,
          "2026-02-03": 790.3403538888889,
          "2026-02-04": 18.226390277777778,
          "2026-02-05": 16.59387638888889,
          "2026-02-06": 153.46075666666667,
          "2026-02-10": 1926.9689980555556,
          "2026-02-11": 769.1750847222222,
          "2026-02-12": 150.6273297222222,
          "2026-02-13": 7.145371944444444,
          "2026-02-18": 175.06450361111112,
          "2026-02-23": 73.08021638888889,
          "2026-02-25": 527.8596258333333,
          "2026-03-04": 381.67997833333334,
          "2026-03-06": 211.87327555555555,
          "2026-03-20": 1295.5653916666668,
          "2026-03-26": 524.4125541666667,
          "2026-04-09": 300.46393472222223,
          "2026-04-14": 493.51470916666665,
          "2026-04-23": 1081.9742841666666,
          "2026-05-14": 0.13331083333333332,
          "2026-05-18": 92.42671499999999,
          "2026-05-22": 19.144274444444445,
          "2026-06-01": 0.1051688888888889
        },
        "time_count_per_day": {
          "2025-10-15": 2,
          "2025-10-17": 1,
          "2025-11-13": 1,
          "2025-11-19": 1,
          "2025-11-25": 1,
          "2025-12-04": 1,
          "2025-12-05": 2,
          "2025-12-06": 1,
          "2025-12-12": 1,
          "2025-12-14": 1,
          "2025-12-15": 2,
          "2025-12-29": 1,
          "2026-01-13": 2,
          "2026-01-14": 1,
          "2026-01-19": 1,
          "2026-01-23": 2,
          "2026-01-29": 2,
          "2026-01-30": 1,
          "2026-01-31": 2,
          "2026-02-03": 4,
          "2026-02-04": 1,
          "2026-02-05": 1,
          "2026-02-06": 3,
          "2026-02-10": 4,
          "2026-02-11": 2,
          "2026-02-12": 2,
          "2026-02-13": 1,
          "2026-02-18": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-20": 3,
          "2026-03-26": 1,
          "2026-04-09": 1,
          "2026-04-14": 1,
          "2026-04-23": 1,
          "2026-05-14": 1,
          "2026-05-18": 2,
          "2026-05-22": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 87.11,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "18-20h": 1,
            "138-140h": 1,
            "174-176h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-18": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-02-04": 18.226390277777778,
            "2026-02-05": 16.59387638888889,
            "2026-02-18": 175.06450361111112,
            "2026-03-20": 138.55896638888888
          },
          "time_count_per_day": {
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-18": 1,
            "2026-03-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 165.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "14-16h": 2,
            "16-18h": 1,
            "18-20h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "32-34h": 1,
            "48-50h": 1,
            "72-74h": 1,
            "84-86h": 1,
            "106-108h": 1,
            "146-148h": 1,
            "256-258h": 1,
            "288-290h": 1,
            "292-294h": 1,
            "300-302h": 1,
            "310-312h": 1,
            "380-382h": 1,
            "480-482h": 1,
            "492-494h": 1,
            "496-498h": 1,
            "524-526h": 1,
            "526-528h": 1,
            "660-662h": 1
          },
          "tickets_count": 35,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-13": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-06": 1,
            "2025-12-12": 1,
            "2025-12-14": 1,
            "2025-12-15": 2,
            "2026-01-13": 2,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-10": 3,
            "2026-02-11": 2,
            "2026-02-23": 1,
            "2026-02-25": 1,
            "2026-03-04": 1,
            "2026-03-20": 2,
            "2026-03-26": 1,
            "2026-04-09": 1,
            "2026-04-14": 1,
            "2026-05-14": 1,
            "2026-05-18": 3,
            "2026-05-22": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-15": 0.27285805555555553,
            "2025-11-13": 4.389436111111111,
            "2025-12-04": 311.7212333333333,
            "2025-12-05": 17.863089166666665,
            "2025-12-06": 3.4375983333333333,
            "2025-12-12": 147.98746472222223,
            "2025-12-14": 107.92417388888889,
            "2025-12-15": 48.372764444444435,
            "2026-01-13": 29.031693055555557,
            "2026-01-14": 0.11452555555555555,
            "2026-01-19": 0.5856088888888888,
            "2026-01-23": 22.323898055555553,
            "2026-01-30": 32.21393277777778,
            "2026-01-31": 14.741886944444444,
            "2026-02-10": 563.8440080555555,
            "2026-02-11": 769.1750847222222,
            "2026-02-23": 73.08021638888889,
            "2026-02-25": 527.8596258333333,
            "2026-03-04": 381.67997833333334,
            "2026-03-20": 1157.006425277778,
            "2026-03-26": 524.4125541666667,
            "2026-04-09": 300.46393472222223,
            "2026-04-14": 493.51470916666665,
            "2026-05-14": 0.13331083333333332,
            "2026-05-18": 92.42671499999999,
            "2026-05-22": 19.144274444444445,
            "2026-06-01": 0.1051688888888889
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-13": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-06": 1,
            "2025-12-12": 1,
            "2025-12-14": 1,
            "2025-12-15": 2,
            "2026-01-13": 2,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-10": 3,
            "2026-02-11": 2,
            "2026-02-23": 1,
            "2026-02-25": 1,
            "2026-03-04": 1,
            "2026-03-20": 2,
            "2026-03-26": 1,
            "2026-04-09": 1,
            "2026-04-14": 1,
            "2026-05-14": 1,
            "2026-05-18": 2,
            "2026-05-22": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 197.39,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "6-8h": 1,
            "12-14h": 1,
            "26-28h": 1,
            "42-44h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "52-54h": 1,
            "58-60h": 1,
            "70-72h": 1,
            "74-76h": 2,
            "82-84h": 1,
            "126-128h": 1,
            "184-186h": 1,
            "210-212h": 1,
            "342-344h": 1,
            "372-374h": 1,
            "1080-1082h": 1,
            "1362-1364h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-19": 1,
            "2025-11-25": 1,
            "2025-12-05": 1,
            "2025-12-29": 1,
            "2026-01-23": 1,
            "2026-01-29": 2,
            "2026-01-31": 1,
            "2026-02-03": 4,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-12": 2,
            "2026-02-13": 1,
            "2026-03-06": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-10-15": 46.52268972222222,
            "2025-11-19": 185.29528000000002,
            "2025-11-25": 0.5279297222222222,
            "2025-12-05": 27.609434722222222,
            "2025-12-29": 127.17127777777777,
            "2026-01-23": 82.9942913888889,
            "2026-01-29": 71.98789722222223,
            "2026-01-31": 42.014916388888885,
            "2026-02-03": 790.3403538888889,
            "2026-02-06": 153.46075666666667,
            "2026-02-10": 1363.12499,
            "2026-02-12": 150.6273297222222,
            "2026-02-13": 7.145371944444444,
            "2026-03-06": 211.87327555555555,
            "2026-04-23": 1081.9742841666666
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-19": 1,
            "2025-11-25": 1,
            "2025-12-05": 1,
            "2025-12-29": 1,
            "2026-01-23": 1,
            "2026-01-29": 2,
            "2026-01-31": 1,
            "2026-02-03": 4,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-12": 2,
            "2026-02-13": 1,
            "2026-03-06": 1,
            "2026-04-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 42.81,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-17": 1
          },
          "time_per_day": {
            "2025-10-17": 42.80797555555556
          },
          "time_count_per_day": {
            "2025-10-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 170.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 9,
            "time_distribution": {
              "0-2h": 9,
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 2,
              "12-14h": 1,
              "14-16h": 2,
              "16-18h": 2,
              "18-20h": 2,
              "22-24h": 1,
              "26-28h": 2,
              "32-34h": 1,
              "42-44h": 2,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "52-54h": 1,
              "58-60h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "74-76h": 2,
              "82-84h": 1,
              "84-86h": 1,
              "106-108h": 1,
              "126-128h": 1,
              "138-140h": 1,
              "146-148h": 1,
              "174-176h": 1,
              "184-186h": 1,
              "210-212h": 1,
              "256-258h": 1,
              "288-290h": 1,
              "292-294h": 1,
              "300-302h": 1,
              "310-312h": 1,
              "342-344h": 1,
              "372-374h": 1,
              "380-382h": 1,
              "480-482h": 1,
              "492-494h": 1,
              "496-498h": 1,
              "524-526h": 1,
              "526-528h": 1,
              "660-662h": 1,
              "1080-1082h": 1,
              "1362-1364h": 1
            },
            "tickets_count": 61,
            "tickets_per_day": {
              "2025-10-15": 2,
              "2025-10-17": 1,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-25": 1,
              "2025-12-04": 1,
              "2025-12-05": 2,
              "2025-12-06": 1,
              "2025-12-12": 1,
              "2025-12-14": 1,
              "2025-12-15": 2,
              "2025-12-29": 1,
              "2026-01-13": 2,
              "2026-01-14": 1,
              "2026-01-19": 1,
              "2026-01-23": 2,
              "2026-01-29": 2,
              "2026-01-30": 1,
              "2026-01-31": 2,
              "2026-02-03": 4,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-10": 4,
              "2026-02-11": 2,
              "2026-02-12": 2,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-20": 3,
              "2026-03-26": 1,
              "2026-04-09": 1,
              "2026-04-14": 1,
              "2026-04-23": 1,
              "2026-05-14": 1,
              "2026-05-18": 2,
              "2026-05-22": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-15": 46.79554777777777,
              "2025-10-17": 42.80797555555556,
              "2025-11-13": 4.389436111111111,
              "2025-11-19": 185.29528000000002,
              "2025-11-25": 0.5279297222222222,
              "2025-12-04": 311.7212333333333,
              "2025-12-05": 45.47252388888889,
              "2025-12-06": 3.4375983333333333,
              "2025-12-12": 147.98746472222223,
              "2025-12-14": 107.92417388888889,
              "2025-12-15": 48.372764444444435,
              "2025-12-29": 127.17127777777777,
              "2026-01-13": 29.031693055555557,
              "2026-01-14": 0.11452555555555555,
              "2026-01-19": 0.5856088888888888,
              "2026-01-23": 105.31818944444444,
              "2026-01-29": 71.98789722222223,
              "2026-01-30": 32.21393277777778,
              "2026-01-31": 56.75680333333333,
              "2026-02-03": 790.3403538888889,
              "2026-02-04": 18.226390277777778,
              "2026-02-05": 16.59387638888889,
              "2026-02-06": 153.46075666666667,
              "2026-02-10": 1926.9689980555556,
              "2026-02-11": 769.1750847222222,
              "2026-02-12": 150.6273297222222,
              "2026-02-13": 7.145371944444444,
              "2026-02-18": 175.06450361111112,
              "2026-02-23": 73.08021638888889,
              "2026-02-25": 527.8596258333333,
              "2026-03-04": 381.67997833333334,
              "2026-03-06": 211.87327555555555,
              "2026-03-20": 1295.5653916666668,
              "2026-03-26": 524.4125541666667,
              "2026-04-09": 300.46393472222223,
              "2026-04-14": 493.51470916666665,
              "2026-04-23": 1081.9742841666666,
              "2026-05-14": 0.13331083333333332,
              "2026-05-18": 92.42671499999999,
              "2026-05-22": 19.144274444444445,
              "2026-06-01": 0.1051688888888889
            },
            "time_count_per_day": {
              "2025-10-15": 2,
              "2025-10-17": 1,
              "2025-11-13": 1,
              "2025-11-19": 1,
              "2025-11-25": 1,
              "2025-12-04": 1,
              "2025-12-05": 2,
              "2025-12-06": 1,
              "2025-12-12": 1,
              "2025-12-14": 1,
              "2025-12-15": 2,
              "2025-12-29": 1,
              "2026-01-13": 2,
              "2026-01-14": 1,
              "2026-01-19": 1,
              "2026-01-23": 2,
              "2026-01-29": 2,
              "2026-01-30": 1,
              "2026-01-31": 2,
              "2026-02-03": 4,
              "2026-02-04": 1,
              "2026-02-05": 1,
              "2026-02-06": 3,
              "2026-02-10": 4,
              "2026-02-11": 2,
              "2026-02-12": 2,
              "2026-02-13": 1,
              "2026-02-18": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-20": 3,
              "2026-03-26": 1,
              "2026-04-09": 1,
              "2026-04-14": 1,
              "2026-04-23": 1,
              "2026-05-14": 1,
              "2026-05-18": 2,
              "2026-05-22": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 87.11,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "18-20h": 1,
                "138-140h": 1,
                "174-176h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-18": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-02-04": 18.226390277777778,
                "2026-02-05": 16.59387638888889,
                "2026-02-18": 175.06450361111112,
                "2026-03-20": 138.55896638888888
              },
              "time_count_per_day": {
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-02-18": 1,
                "2026-03-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 165.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "14-16h": 2,
                "16-18h": 1,
                "18-20h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "32-34h": 1,
                "48-50h": 1,
                "72-74h": 1,
                "84-86h": 1,
                "106-108h": 1,
                "146-148h": 1,
                "256-258h": 1,
                "288-290h": 1,
                "292-294h": 1,
                "300-302h": 1,
                "310-312h": 1,
                "380-382h": 1,
                "480-482h": 1,
                "492-494h": 1,
                "496-498h": 1,
                "524-526h": 1,
                "526-528h": 1,
                "660-662h": 1
              },
              "tickets_count": 34,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-13": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-06": 1,
                "2025-12-12": 1,
                "2025-12-14": 1,
                "2025-12-15": 2,
                "2026-01-13": 2,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-10": 3,
                "2026-02-11": 2,
                "2026-02-23": 1,
                "2026-02-25": 1,
                "2026-03-04": 1,
                "2026-03-20": 2,
                "2026-03-26": 1,
                "2026-04-09": 1,
                "2026-04-14": 1,
                "2026-05-14": 1,
                "2026-05-18": 2,
                "2026-05-22": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-15": 0.27285805555555553,
                "2025-11-13": 4.389436111111111,
                "2025-12-04": 311.7212333333333,
                "2025-12-05": 17.863089166666665,
                "2025-12-06": 3.4375983333333333,
                "2025-12-12": 147.98746472222223,
                "2025-12-14": 107.92417388888889,
                "2025-12-15": 48.372764444444435,
                "2026-01-13": 29.031693055555557,
                "2026-01-14": 0.11452555555555555,
                "2026-01-19": 0.5856088888888888,
                "2026-01-23": 22.323898055555553,
                "2026-01-30": 32.21393277777778,
                "2026-01-31": 14.741886944444444,
                "2026-02-10": 563.8440080555555,
                "2026-02-11": 769.1750847222222,
                "2026-02-23": 73.08021638888889,
                "2026-02-25": 527.8596258333333,
                "2026-03-04": 381.67997833333334,
                "2026-03-20": 1157.006425277778,
                "2026-03-26": 524.4125541666667,
                "2026-04-09": 300.46393472222223,
                "2026-04-14": 493.51470916666665,
                "2026-05-14": 0.13331083333333332,
                "2026-05-18": 92.42671499999999,
                "2026-05-22": 19.144274444444445,
                "2026-06-01": 0.1051688888888889
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-13": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2025-12-06": 1,
                "2025-12-12": 1,
                "2025-12-14": 1,
                "2025-12-15": 2,
                "2026-01-13": 2,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-10": 3,
                "2026-02-11": 2,
                "2026-02-23": 1,
                "2026-02-25": 1,
                "2026-03-04": 1,
                "2026-03-20": 2,
                "2026-03-26": 1,
                "2026-04-09": 1,
                "2026-04-14": 1,
                "2026-05-14": 1,
                "2026-05-18": 2,
                "2026-05-22": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 197.39,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "6-8h": 1,
                "12-14h": 1,
                "26-28h": 1,
                "42-44h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "52-54h": 1,
                "58-60h": 1,
                "70-72h": 1,
                "74-76h": 2,
                "82-84h": 1,
                "126-128h": 1,
                "184-186h": 1,
                "210-212h": 1,
                "342-344h": 1,
                "372-374h": 1,
                "1080-1082h": 1,
                "1362-1364h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-19": 1,
                "2025-11-25": 1,
                "2025-12-05": 1,
                "2025-12-29": 1,
                "2026-01-23": 1,
                "2026-01-29": 2,
                "2026-01-31": 1,
                "2026-02-03": 4,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-12": 2,
                "2026-02-13": 1,
                "2026-03-06": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-10-15": 46.52268972222222,
                "2025-11-19": 185.29528000000002,
                "2025-11-25": 0.5279297222222222,
                "2025-12-05": 27.609434722222222,
                "2025-12-29": 127.17127777777777,
                "2026-01-23": 82.9942913888889,
                "2026-01-29": 71.98789722222223,
                "2026-01-31": 42.014916388888885,
                "2026-02-03": 790.3403538888889,
                "2026-02-06": 153.46075666666667,
                "2026-02-10": 1363.12499,
                "2026-02-12": 150.6273297222222,
                "2026-02-13": 7.145371944444444,
                "2026-03-06": 211.87327555555555,
                "2026-04-23": 1081.9742841666666
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-19": 1,
                "2025-11-25": 1,
                "2025-12-05": 1,
                "2025-12-29": 1,
                "2026-01-23": 1,
                "2026-01-29": 2,
                "2026-01-31": 1,
                "2026-02-03": 4,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-12": 2,
                "2026-02-13": 1,
                "2026-03-06": 1,
                "2026-04-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 42.81,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-17": 1
              },
              "time_per_day": {
                "2025-10-17": 42.80797555555556
              },
              "time_count_per_day": {
                "2025-10-17": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_240": {
      "overall": {
        "avg_time_hours": 16.26,
        "mode_time_hours": 33.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "32-34h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-14": 2
        },
        "time_per_day": {
          "2025-10-14": 32.52225083333334
        },
        "time_count_per_day": {
          "2025-10-14": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.04,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-14": 1
          },
          "time_per_day": {
            "2025-10-14": 0.04241916666666667
          },
          "time_count_per_day": {
            "2025-10-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 32.48,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-14": 1
          },
          "time_per_day": {
            "2025-10-14": 32.47983166666667
          },
          "time_count_per_day": {
            "2025-10-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.26,
            "mode_time_hours": 33.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "32-34h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-14": 2
            },
            "time_per_day": {
              "2025-10-14": 32.52225083333334
            },
            "time_count_per_day": {
              "2025-10-14": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.04,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-14": 1
              },
              "time_per_day": {
                "2025-10-14": 0.04241916666666667
              },
              "time_count_per_day": {
                "2025-10-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 32.48,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-14": 1
              },
              "time_per_day": {
                "2025-10-14": 32.47983166666667
              },
              "time_count_per_day": {
                "2025-10-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_242": {
      "overall": {
        "avg_time_hours": 11.92,
        "mode_time_hours": 7.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 6,
          "4-6h": 5,
          "6-8h": 6,
          "16-18h": 4,
          "28-30h": 1,
          "66-68h": 1,
          "72-74h": 1
        },
        "tickets_count": 27,
        "tickets_per_day": {
          "2025-10-14": 4,
          "2025-10-18": 2,
          "2025-11-07": 12,
          "2025-11-11": 4,
          "2025-11-13": 2,
          "2025-12-02": 2,
          "2026-01-13": 1
        },
        "time_per_day": {
          "2025-10-14": 70.68604500000001,
          "2025-10-18": 140.85364166666668,
          "2025-11-07": 52.41845138888888,
          "2025-11-11": 34.76105083333333,
          "2025-11-13": 8.182059722222222,
          "2025-12-02": 14.556475833333334,
          "2026-01-13": 0.46727222222222226
        },
        "time_count_per_day": {
          "2025-10-14": 4,
          "2025-10-18": 2,
          "2025-11-07": 12,
          "2025-11-11": 4,
          "2025-11-13": 2,
          "2025-12-02": 2,
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 23.72,
          "mode_time_hours": 17.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 3,
            "16-18h": 4,
            "66-68h": 1,
            "72-74h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-14": 4,
            "2025-10-18": 2,
            "2025-11-11": 2,
            "2026-01-13": 1
          },
          "time_per_day": {
            "2025-10-14": 70.68604500000001,
            "2025-10-18": 140.85364166666668,
            "2025-11-11": 1.4526619444444444,
            "2026-01-13": 0.46727222222222226
          },
          "time_count_per_day": {
            "2025-10-14": 4,
            "2025-10-18": 2,
            "2025-11-11": 2,
            "2026-01-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.03,
          "mode_time_hours": 7.0,
          "mode_frequency": 6,
          "time_distribution": {
            "2-4h": 6,
            "4-6h": 5,
            "6-8h": 6,
            "28-30h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-11-07": 12,
            "2025-11-11": 2,
            "2025-11-13": 2,
            "2025-12-02": 2
          },
          "time_per_day": {
            "2025-11-07": 52.41845138888888,
            "2025-11-11": 33.308388888888885,
            "2025-11-13": 8.182059722222222,
            "2025-12-02": 14.556475833333334
          },
          "time_count_per_day": {
            "2025-11-07": 12,
            "2025-11-11": 2,
            "2025-11-13": 2,
            "2025-12-02": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.92,
            "mode_time_hours": 7.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 6,
              "4-6h": 5,
              "6-8h": 6,
              "16-18h": 4,
              "28-30h": 1,
              "66-68h": 1,
              "72-74h": 1
            },
            "tickets_count": 27,
            "tickets_per_day": {
              "2025-10-14": 4,
              "2025-10-18": 2,
              "2025-11-07": 12,
              "2025-11-11": 4,
              "2025-11-13": 2,
              "2025-12-02": 2,
              "2026-01-13": 1
            },
            "time_per_day": {
              "2025-10-14": 70.68604500000001,
              "2025-10-18": 140.85364166666668,
              "2025-11-07": 52.41845138888888,
              "2025-11-11": 34.76105083333333,
              "2025-11-13": 8.182059722222222,
              "2025-12-02": 14.556475833333334,
              "2026-01-13": 0.46727222222222226
            },
            "time_count_per_day": {
              "2025-10-14": 4,
              "2025-10-18": 2,
              "2025-11-07": 12,
              "2025-11-11": 4,
              "2025-11-13": 2,
              "2025-12-02": 2,
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 23.72,
              "mode_time_hours": 17.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 3,
                "16-18h": 4,
                "66-68h": 1,
                "72-74h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-14": 4,
                "2025-10-18": 2,
                "2025-11-11": 2,
                "2026-01-13": 1
              },
              "time_per_day": {
                "2025-10-14": 70.68604500000001,
                "2025-10-18": 140.85364166666668,
                "2025-11-11": 1.4526619444444444,
                "2026-01-13": 0.46727222222222226
              },
              "time_count_per_day": {
                "2025-10-14": 4,
                "2025-10-18": 2,
                "2025-11-11": 2,
                "2026-01-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.03,
              "mode_time_hours": 7.0,
              "mode_frequency": 6,
              "time_distribution": {
                "2-4h": 6,
                "4-6h": 5,
                "6-8h": 6,
                "28-30h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-11-07": 12,
                "2025-11-11": 2,
                "2025-11-13": 2,
                "2025-12-02": 2
              },
              "time_per_day": {
                "2025-11-07": 52.41845138888888,
                "2025-11-11": 33.308388888888885,
                "2025-11-13": 8.182059722222222,
                "2025-12-02": 14.556475833333334
              },
              "time_count_per_day": {
                "2025-11-07": 12,
                "2025-11-11": 2,
                "2025-11-13": 2,
                "2025-12-02": 2
              }
            }
          }
        }
      }
    },
    "cliente_214": {
      "overall": {
        "avg_time_hours": 107.9,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 3,
          "4-6h": 3,
          "8-10h": 1,
          "14-16h": 2,
          "16-18h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "30-32h": 2,
          "32-34h": 1,
          "40-42h": 1,
          "42-44h": 1,
          "58-60h": 1,
          "60-62h": 2,
          "64-66h": 1,
          "94-96h": 1,
          "100-102h": 1,
          "102-104h": 1,
          "140-142h": 1,
          "156-158h": 1,
          "164-166h": 1,
          "168-170h": 1,
          "182-184h": 1,
          "216-218h": 1,
          "308-310h": 1,
          "322-324h": 1,
          "348-350h": 1,
          "420-422h": 1,
          "560-562h": 1,
          "626-628h": 1
        },
        "tickets_count": 44,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-10-23": 2,
          "2025-10-30": 1,
          "2025-11-04": 1,
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-11": 1,
          "2026-01-13": 3,
          "2026-01-16": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-29": 2,
          "2026-01-31": 2,
          "2026-02-03": 1,
          "2026-02-07": 2,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-27": 1,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-10-15": 42.467326388888885,
          "2025-10-23": 67.26187388888889,
          "2025-10-30": 102.06702222222223,
          "2025-11-04": 349.87705111111114,
          "2025-11-13": 168.4804902777778,
          "2025-11-24": 626.7460980555556,
          "2025-12-11": 100.12262777777778,
          "2026-01-13": 10.569491944444444,
          "2026-01-16": 19.691521944444446,
          "2026-01-19": 14.760118611111112,
          "2026-01-20": 17.07020111111111,
          "2026-01-29": 8.217941666666666,
          "2026-01-31": 64.5813286111111,
          "2026-02-03": 30.616864722222225,
          "2026-02-07": 120.96012250000001,
          "2026-02-10": 84.5710386111111,
          "2026-02-12": 182.6889588888889,
          "2026-02-13": 323.8621038888889,
          "2026-02-14": 60.73197555555555,
          "2026-03-02": 2.905234444444444,
          "2026-03-04": 0.5257197222222222,
          "2026-03-06": 94.03351722222223,
          "2026-03-11": 0.16725361111111112,
          "2026-03-13": 15.453824166666667,
          "2026-03-25": 18.405183055555554,
          "2026-03-31": 25.108855277777778,
          "2026-04-08": 157.50803416666665,
          "2026-04-09": 217.20934833333334,
          "2026-04-10": 9.06903,
          "2026-04-15": 140.5002125,
          "2026-04-16": 560.7077405555556,
          "2026-05-04": 164.77541,
          "2026-05-14": 421.35525638888885,
          "2026-05-27": 308.6965025
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-10-23": 2,
          "2025-10-30": 1,
          "2025-11-04": 1,
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-12-11": 1,
          "2026-01-13": 3,
          "2026-01-16": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-29": 2,
          "2026-01-31": 2,
          "2026-02-03": 1,
          "2026-02-07": 2,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 308.7,
          "mode_time_hours": 309.0,
          "mode_frequency": 1,
          "time_distribution": {
            "308-310h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-27": 1
          },
          "time_per_day": {
            "2026-05-27": 308.6965025
          },
          "time_count_per_day": {
            "2026-05-27": 1
          }
        },
        "P2": {
          "avg_time_hours": 140.09,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3,
            "4-6h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "64-66h": 1,
            "94-96h": 1,
            "100-102h": 1,
            "102-104h": 1,
            "140-142h": 1,
            "156-158h": 1,
            "164-166h": 1,
            "216-218h": 1,
            "348-350h": 1,
            "420-422h": 1,
            "560-562h": 1,
            "626-628h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-10-23": 2,
            "2025-10-30": 1,
            "2025-11-04": 1,
            "2025-11-24": 1,
            "2025-12-11": 1,
            "2026-01-29": 2,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-27": 1,
            "2026-05-04": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-10-23": 67.26187388888889,
            "2025-10-30": 102.06702222222223,
            "2025-11-04": 349.87705111111114,
            "2025-11-24": 626.7460980555556,
            "2025-12-11": 100.12262777777778,
            "2026-01-29": 8.217941666666666,
            "2026-03-02": 2.905234444444444,
            "2026-03-04": 0.5257197222222222,
            "2026-03-06": 94.03351722222223,
            "2026-03-11": 0.16725361111111112,
            "2026-03-13": 15.453824166666667,
            "2026-03-25": 18.405183055555554,
            "2026-03-31": 25.108855277777778,
            "2026-04-08": 157.50803416666665,
            "2026-04-09": 217.20934833333334,
            "2026-04-10": 9.06903,
            "2026-04-15": 140.5002125,
            "2026-04-16": 560.7077405555556,
            "2026-05-04": 164.77541,
            "2026-05-14": 421.35525638888885
          },
          "time_count_per_day": {
            "2025-10-23": 2,
            "2025-10-30": 1,
            "2025-11-04": 1,
            "2025-11-24": 1,
            "2025-12-11": 1,
            "2026-01-29": 2,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-05-04": 1,
            "2026-05-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 60.06,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 2,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "30-32h": 2,
            "32-34h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "58-60h": 1,
            "60-62h": 2,
            "168-170h": 1,
            "182-184h": 1,
            "322-324h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-13": 1,
            "2025-11-27": 1,
            "2026-01-13": 3,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-31": 2,
            "2026-02-03": 1,
            "2026-02-07": 2,
            "2026-02-10": 3,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 1
          },
          "time_per_day": {
            "2025-10-15": 42.467326388888885,
            "2025-11-13": 168.4804902777778,
            "2026-01-13": 10.569491944444444,
            "2026-01-16": 19.691521944444446,
            "2026-01-19": 14.760118611111112,
            "2026-01-20": 17.07020111111111,
            "2026-01-31": 64.5813286111111,
            "2026-02-03": 30.616864722222225,
            "2026-02-07": 120.96012250000001,
            "2026-02-10": 84.5710386111111,
            "2026-02-12": 182.6889588888889,
            "2026-02-13": 323.8621038888889,
            "2026-02-14": 60.73197555555555
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-13": 1,
            "2026-01-13": 3,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-31": 2,
            "2026-02-03": 1,
            "2026-02-07": 2,
            "2026-02-10": 3,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 107.9,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 3,
              "4-6h": 3,
              "8-10h": 1,
              "14-16h": 2,
              "16-18h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "30-32h": 2,
              "32-34h": 1,
              "40-42h": 1,
              "42-44h": 1,
              "58-60h": 1,
              "60-62h": 2,
              "64-66h": 1,
              "94-96h": 1,
              "100-102h": 1,
              "102-104h": 1,
              "140-142h": 1,
              "156-158h": 1,
              "164-166h": 1,
              "168-170h": 1,
              "182-184h": 1,
              "216-218h": 1,
              "308-310h": 1,
              "322-324h": 1,
              "348-350h": 1,
              "420-422h": 1,
              "560-562h": 1,
              "626-628h": 1
            },
            "tickets_count": 42,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-10-23": 2,
              "2025-10-30": 1,
              "2025-11-04": 1,
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-12-11": 1,
              "2026-01-13": 3,
              "2026-01-16": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-29": 2,
              "2026-01-31": 2,
              "2026-02-03": 1,
              "2026-02-07": 2,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-10-15": 42.467326388888885,
              "2025-10-23": 67.26187388888889,
              "2025-10-30": 102.06702222222223,
              "2025-11-04": 349.87705111111114,
              "2025-11-13": 168.4804902777778,
              "2025-11-24": 626.7460980555556,
              "2025-12-11": 100.12262777777778,
              "2026-01-13": 10.569491944444444,
              "2026-01-16": 19.691521944444446,
              "2026-01-19": 14.760118611111112,
              "2026-01-20": 17.07020111111111,
              "2026-01-29": 8.217941666666666,
              "2026-01-31": 64.5813286111111,
              "2026-02-03": 30.616864722222225,
              "2026-02-07": 120.96012250000001,
              "2026-02-10": 84.5710386111111,
              "2026-02-12": 182.6889588888889,
              "2026-02-13": 323.8621038888889,
              "2026-02-14": 60.73197555555555,
              "2026-03-02": 2.905234444444444,
              "2026-03-04": 0.5257197222222222,
              "2026-03-06": 94.03351722222223,
              "2026-03-11": 0.16725361111111112,
              "2026-03-13": 15.453824166666667,
              "2026-03-25": 18.405183055555554,
              "2026-03-31": 25.108855277777778,
              "2026-04-08": 157.50803416666665,
              "2026-04-09": 217.20934833333334,
              "2026-04-10": 9.06903,
              "2026-04-15": 140.5002125,
              "2026-04-16": 560.7077405555556,
              "2026-05-04": 164.77541,
              "2026-05-14": 421.35525638888885,
              "2026-05-27": 308.6965025
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-10-23": 2,
              "2025-10-30": 1,
              "2025-11-04": 1,
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-12-11": 1,
              "2026-01-13": 3,
              "2026-01-16": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-29": 2,
              "2026-01-31": 2,
              "2026-02-03": 1,
              "2026-02-07": 2,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-05-04": 1,
              "2026-05-14": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 308.7,
              "mode_time_hours": 309.0,
              "mode_frequency": 1,
              "time_distribution": {
                "308-310h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {
                "2026-05-27": 308.6965025
              },
              "time_count_per_day": {
                "2026-05-27": 1
              }
            },
            "P2": {
              "avg_time_hours": 140.09,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3,
                "4-6h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "64-66h": 1,
                "94-96h": 1,
                "100-102h": 1,
                "102-104h": 1,
                "140-142h": 1,
                "156-158h": 1,
                "164-166h": 1,
                "216-218h": 1,
                "348-350h": 1,
                "420-422h": 1,
                "560-562h": 1,
                "626-628h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-10-23": 2,
                "2025-10-30": 1,
                "2025-11-04": 1,
                "2025-11-24": 1,
                "2025-12-11": 1,
                "2026-01-29": 2,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-05-04": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-10-23": 67.26187388888889,
                "2025-10-30": 102.06702222222223,
                "2025-11-04": 349.87705111111114,
                "2025-11-24": 626.7460980555556,
                "2025-12-11": 100.12262777777778,
                "2026-01-29": 8.217941666666666,
                "2026-03-02": 2.905234444444444,
                "2026-03-04": 0.5257197222222222,
                "2026-03-06": 94.03351722222223,
                "2026-03-11": 0.16725361111111112,
                "2026-03-13": 15.453824166666667,
                "2026-03-25": 18.405183055555554,
                "2026-03-31": 25.108855277777778,
                "2026-04-08": 157.50803416666665,
                "2026-04-09": 217.20934833333334,
                "2026-04-10": 9.06903,
                "2026-04-15": 140.5002125,
                "2026-04-16": 560.7077405555556,
                "2026-05-04": 164.77541,
                "2026-05-14": 421.35525638888885
              },
              "time_count_per_day": {
                "2025-10-23": 2,
                "2025-10-30": 1,
                "2025-11-04": 1,
                "2025-11-24": 1,
                "2025-12-11": 1,
                "2026-01-29": 2,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-05-04": 1,
                "2026-05-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 60.06,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 2,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "30-32h": 2,
                "32-34h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "58-60h": 1,
                "60-62h": 2,
                "168-170h": 1,
                "182-184h": 1,
                "322-324h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-13": 1,
                "2026-01-13": 3,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-31": 2,
                "2026-02-03": 1,
                "2026-02-07": 2,
                "2026-02-10": 3,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 1
              },
              "time_per_day": {
                "2025-10-15": 42.467326388888885,
                "2025-11-13": 168.4804902777778,
                "2026-01-13": 10.569491944444444,
                "2026-01-16": 19.691521944444446,
                "2026-01-19": 14.760118611111112,
                "2026-01-20": 17.07020111111111,
                "2026-01-31": 64.5813286111111,
                "2026-02-03": 30.616864722222225,
                "2026-02-07": 120.96012250000001,
                "2026-02-10": 84.5710386111111,
                "2026-02-12": 182.6889588888889,
                "2026-02-13": 323.8621038888889,
                "2026-02-14": 60.73197555555555
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-13": 1,
                "2026-01-13": 3,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-31": 2,
                "2026-02-03": 1,
                "2026-02-07": 2,
                "2026-02-10": 3,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-14": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_52": {
      "overall": {
        "avg_time_hours": 86.97,
        "mode_time_hours": 215.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "26-28h": 1,
          "100-102h": 1,
          "214-216h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-17": 1,
          "2025-12-05": 1,
          "2026-01-22": 1
        },
        "time_per_day": {
          "2025-10-23": 215.41615916666666,
          "2025-11-17": 101.04340194444444,
          "2025-12-05": 26.181333055555555,
          "2026-01-22": 5.233834166666667
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-17": 1,
          "2025-12-05": 1,
          "2026-01-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 110.32,
          "mode_time_hours": 215.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "214-216h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2026-01-22": 1
          },
          "time_per_day": {
            "2025-10-23": 215.41615916666666,
            "2026-01-22": 5.233834166666667
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2026-01-22": 1
          }
        },
        "P3": {
          "avg_time_hours": 63.61,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1,
            "100-102h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-11-17": 101.04340194444444,
            "2025-12-05": 26.181333055555555
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 86.97,
            "mode_time_hours": 215.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "26-28h": 1,
              "100-102h": 1,
              "214-216h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-17": 1,
              "2025-12-05": 1,
              "2026-01-22": 1
            },
            "time_per_day": {
              "2025-10-23": 215.41615916666666,
              "2025-11-17": 101.04340194444444,
              "2025-12-05": 26.181333055555555,
              "2026-01-22": 5.233834166666667
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-17": 1,
              "2025-12-05": 1,
              "2026-01-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 110.32,
              "mode_time_hours": 215.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "214-216h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2026-01-22": 1
              },
              "time_per_day": {
                "2025-10-23": 215.41615916666666,
                "2026-01-22": 5.233834166666667
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2026-01-22": 1
              }
            },
            "P3": {
              "avg_time_hours": 63.61,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1,
                "100-102h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-11-17": 101.04340194444444,
                "2025-12-05": 26.181333055555555
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_246": {
      "overall": {
        "avg_time_hours": 64.87,
        "mode_time_hours": 25.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "24-26h": 2,
          "102-104h": 1,
          "230-232h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-11-18": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-02-19": 1,
          "2026-02-28": 1
        },
        "time_per_day": {
          "2025-10-15": 24.073930833333332,
          "2025-11-18": 6.16564,
          "2026-01-14": 1.923925,
          "2026-01-16": 24.291067222222225,
          "2026-02-19": 230.2248252777778,
          "2026-02-28": 102.5467225
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-11-18": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-02-19": 1,
          "2026-02-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.07,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-15": 1
          },
          "time_per_day": {
            "2025-10-15": 24.073930833333332
          },
          "time_count_per_day": {
            "2025-10-15": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.17,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-18": 1
          },
          "time_per_day": {
            "2025-11-18": 6.16564
          },
          "time_count_per_day": {
            "2025-11-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 63.42,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "102-104h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-16": 1,
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-01-16": 24.291067222222225,
            "2026-02-28": 102.5467225
          },
          "time_count_per_day": {
            "2026-01-16": 1,
            "2026-02-28": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 116.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "230-232h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-14": 1.923925,
            "2026-02-19": 230.2248252777778
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 64.87,
            "mode_time_hours": 25.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "24-26h": 2,
              "102-104h": 1,
              "230-232h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-11-18": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-02-19": 1,
              "2026-02-28": 1
            },
            "time_per_day": {
              "2025-10-15": 24.073930833333332,
              "2025-11-18": 6.16564,
              "2026-01-14": 1.923925,
              "2026-01-16": 24.291067222222225,
              "2026-02-19": 230.2248252777778,
              "2026-02-28": 102.5467225
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-11-18": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-02-19": 1,
              "2026-02-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.07,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-15": 1
              },
              "time_per_day": {
                "2025-10-15": 24.073930833333332
              },
              "time_count_per_day": {
                "2025-10-15": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.17,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-18": 1
              },
              "time_per_day": {
                "2025-11-18": 6.16564
              },
              "time_count_per_day": {
                "2025-11-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 63.42,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "102-104h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-01-16": 24.291067222222225,
                "2026-02-28": 102.5467225
              },
              "time_count_per_day": {
                "2026-01-16": 1,
                "2026-02-28": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 116.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "230-232h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-14": 1.923925,
                "2026-02-19": 230.2248252777778
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_247": {
      "overall": {
        "avg_time_hours": 502.3,
        "mode_time_hours": 887.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1,
          "242-244h": 1,
          "862-864h": 1,
          "886-888h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-11-20": 1,
          "2025-12-04": 1,
          "2025-12-16": 2,
          "2026-03-19": 2
        },
        "time_per_day": {
          "2025-11-20": 886.4571147222222,
          "2025-12-04": 242.08668583333335,
          "2025-12-16": 880.6665733333334
        },
        "time_count_per_day": {
          "2025-11-20": 1,
          "2025-12-04": 1,
          "2025-12-16": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-19": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 374.25,
          "mode_time_hours": 243.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "242-244h": 1,
            "862-864h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-04": 1,
            "2025-12-16": 2,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2025-12-04": 242.08668583333335,
            "2025-12-16": 880.6665733333334
          },
          "time_count_per_day": {
            "2025-12-04": 1,
            "2025-12-16": 2
          }
        },
        "P3": {
          "avg_time_hours": 886.46,
          "mode_time_hours": 887.0,
          "mode_frequency": 1,
          "time_distribution": {
            "886-888h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-20": 1
          },
          "time_per_day": {
            "2025-11-20": 886.4571147222222
          },
          "time_count_per_day": {
            "2025-11-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 502.3,
            "mode_time_hours": 887.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1,
              "242-244h": 1,
              "862-864h": 1,
              "886-888h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-20": 1,
              "2025-12-04": 1,
              "2025-12-16": 2
            },
            "time_per_day": {
              "2025-11-20": 886.4571147222222,
              "2025-12-04": 242.08668583333335,
              "2025-12-16": 880.6665733333334
            },
            "time_count_per_day": {
              "2025-11-20": 1,
              "2025-12-04": 1,
              "2025-12-16": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 374.25,
              "mode_time_hours": 243.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "242-244h": 1,
                "862-864h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-04": 1,
                "2025-12-16": 2
              },
              "time_per_day": {
                "2025-12-04": 242.08668583333335,
                "2025-12-16": 880.6665733333334
              },
              "time_count_per_day": {
                "2025-12-04": 1,
                "2025-12-16": 2
              }
            },
            "P3": {
              "avg_time_hours": 886.46,
              "mode_time_hours": 887.0,
              "mode_frequency": 1,
              "time_distribution": {
                "886-888h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-20": 1
              },
              "time_per_day": {
                "2025-11-20": 886.4571147222222
              },
              "time_count_per_day": {
                "2025-11-20": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-19": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_248": {
      "overall": {
        "avg_time_hours": 88.82,
        "mode_time_hours": 89.0,
        "mode_frequency": 1,
        "time_distribution": {
          "88-90h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-18": 1
        },
        "time_per_day": {
          "2025-10-18": 88.81827666666666
        },
        "time_count_per_day": {
          "2025-10-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 88.82,
          "mode_time_hours": 89.0,
          "mode_frequency": 1,
          "time_distribution": {
            "88-90h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-18": 1
          },
          "time_per_day": {
            "2025-10-18": 88.81827666666666
          },
          "time_count_per_day": {
            "2025-10-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 88.82,
            "mode_time_hours": 89.0,
            "mode_frequency": 1,
            "time_distribution": {
              "88-90h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-18": 1
            },
            "time_per_day": {
              "2025-10-18": 88.81827666666666
            },
            "time_count_per_day": {
              "2025-10-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 88.82,
              "mode_time_hours": 89.0,
              "mode_frequency": 1,
              "time_distribution": {
                "88-90h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-18": 1
              },
              "time_per_day": {
                "2025-10-18": 88.81827666666666
              },
              "time_count_per_day": {
                "2025-10-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_249": {
      "overall": {
        "avg_time_hours": 99.25,
        "mode_time_hours": 27.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 2,
          "4-6h": 2,
          "6-8h": 1,
          "12-14h": 2,
          "14-16h": 1,
          "24-26h": 1,
          "26-28h": 3,
          "32-34h": 1,
          "42-44h": 2,
          "168-170h": 1,
          "232-234h": 1,
          "668-670h": 1,
          "718-720h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-11-06": 1,
          "2025-11-26": 1,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-01-27": 3,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-07": 2,
          "2026-02-09": 1,
          "2026-02-20": 1,
          "2026-03-27": 1,
          "2026-04-02": 1,
          "2026-04-04": 1,
          "2026-04-13": 1,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-05-28": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-15": 13.792386944444445,
          "2025-11-06": 168.5886413888889,
          "2025-11-26": 27.325801944444446,
          "2026-01-14": 13.850365555555555,
          "2026-01-23": 26.92487611111111,
          "2026-01-27": 57.275642500000004,
          "2026-01-28": 7.561896111111111,
          "2026-02-03": 15.943098055555556,
          "2026-02-07": 85.38441166666667,
          "2026-02-09": 233.90556027777777,
          "2026-02-20": 32.41618361111111,
          "2026-03-27": 0.7036041666666666,
          "2026-04-02": 2.815885833333333,
          "2026-04-13": 3.5988305555555558,
          "2026-04-23": 719.0970858333334,
          "2026-05-04": 5.1521325,
          "2026-05-30": 668.8754197222222,
          "2026-06-05": 1.033798888888889
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-11-06": 1,
          "2025-11-26": 1,
          "2026-01-14": 1,
          "2026-01-23": 1,
          "2026-01-27": 3,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-07": 2,
          "2026-02-09": 1,
          "2026-02-20": 1,
          "2026-03-27": 1,
          "2026-04-02": 1,
          "2026-04-13": 1,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 167.6,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "4-6h": 1,
            "12-14h": 1,
            "26-28h": 1,
            "232-234h": 1,
            "668-670h": 1,
            "718-720h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-02-09": 1,
            "2026-03-27": 1,
            "2026-04-02": 1,
            "2026-04-04": 1,
            "2026-04-13": 1,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-05-28": 1,
            "2026-05-30": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-01-14": 13.850365555555555,
            "2026-01-23": 26.92487611111111,
            "2026-02-09": 233.90556027777777,
            "2026-03-27": 0.7036041666666666,
            "2026-04-02": 2.815885833333333,
            "2026-04-13": 3.5988305555555558,
            "2026-04-23": 719.0970858333334,
            "2026-05-04": 5.1521325,
            "2026-05-30": 668.8754197222222,
            "2026-06-05": 1.033798888888889
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-01-23": 1,
            "2026-02-09": 1,
            "2026-03-27": 1,
            "2026-04-02": 1,
            "2026-04-13": 1,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-05-30": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 37.12,
          "mode_time_hours": 27.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "14-16h": 1,
            "24-26h": 1,
            "26-28h": 2,
            "32-34h": 1,
            "42-44h": 2,
            "168-170h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-06": 1,
            "2025-11-26": 1,
            "2026-01-27": 3,
            "2026-01-28": 1,
            "2026-02-03": 1,
            "2026-02-07": 2,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-10-15": 13.792386944444445,
            "2025-11-06": 168.5886413888889,
            "2025-11-26": 27.325801944444446,
            "2026-01-27": 57.275642500000004,
            "2026-01-28": 7.561896111111111,
            "2026-02-03": 15.943098055555556,
            "2026-02-07": 85.38441166666667,
            "2026-02-20": 32.41618361111111
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-06": 1,
            "2025-11-26": 1,
            "2026-01-27": 3,
            "2026-01-28": 1,
            "2026-02-03": 1,
            "2026-02-07": 2,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 99.25,
            "mode_time_hours": 27.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 2,
              "4-6h": 2,
              "6-8h": 1,
              "12-14h": 2,
              "14-16h": 1,
              "24-26h": 1,
              "26-28h": 3,
              "32-34h": 1,
              "42-44h": 2,
              "168-170h": 1,
              "232-234h": 1,
              "668-670h": 1,
              "718-720h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-11-06": 1,
              "2025-11-26": 1,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-01-27": 3,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-07": 2,
              "2026-02-09": 1,
              "2026-02-20": 1,
              "2026-03-27": 1,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-15": 13.792386944444445,
              "2025-11-06": 168.5886413888889,
              "2025-11-26": 27.325801944444446,
              "2026-01-14": 13.850365555555555,
              "2026-01-23": 26.92487611111111,
              "2026-01-27": 57.275642500000004,
              "2026-01-28": 7.561896111111111,
              "2026-02-03": 15.943098055555556,
              "2026-02-07": 85.38441166666667,
              "2026-02-09": 233.90556027777777,
              "2026-02-20": 32.41618361111111,
              "2026-03-27": 0.7036041666666666,
              "2026-04-02": 2.815885833333333,
              "2026-04-13": 3.5988305555555558,
              "2026-04-23": 719.0970858333334,
              "2026-05-04": 5.1521325,
              "2026-05-30": 668.8754197222222,
              "2026-06-05": 1.033798888888889
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-11-06": 1,
              "2025-11-26": 1,
              "2026-01-14": 1,
              "2026-01-23": 1,
              "2026-01-27": 3,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-07": 2,
              "2026-02-09": 1,
              "2026-02-20": 1,
              "2026-03-27": 1,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 167.6,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "4-6h": 1,
                "12-14h": 1,
                "26-28h": 1,
                "232-234h": 1,
                "668-670h": 1,
                "718-720h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-02-09": 1,
                "2026-03-27": 1,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-01-14": 13.850365555555555,
                "2026-01-23": 26.92487611111111,
                "2026-02-09": 233.90556027777777,
                "2026-03-27": 0.7036041666666666,
                "2026-04-02": 2.815885833333333,
                "2026-04-13": 3.5988305555555558,
                "2026-04-23": 719.0970858333334,
                "2026-05-04": 5.1521325,
                "2026-05-30": 668.8754197222222,
                "2026-06-05": 1.033798888888889
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-01-23": 1,
                "2026-02-09": 1,
                "2026-03-27": 1,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 37.12,
              "mode_time_hours": 27.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "14-16h": 1,
                "24-26h": 1,
                "26-28h": 2,
                "32-34h": 1,
                "42-44h": 2,
                "168-170h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-06": 1,
                "2025-11-26": 1,
                "2026-01-27": 3,
                "2026-01-28": 1,
                "2026-02-03": 1,
                "2026-02-07": 2,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2025-10-15": 13.792386944444445,
                "2025-11-06": 168.5886413888889,
                "2025-11-26": 27.325801944444446,
                "2026-01-27": 57.275642500000004,
                "2026-01-28": 7.561896111111111,
                "2026-02-03": 15.943098055555556,
                "2026-02-07": 85.38441166666667,
                "2026-02-20": 32.41618361111111
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-06": 1,
                "2025-11-26": 1,
                "2026-01-27": 3,
                "2026-01-28": 1,
                "2026-02-03": 1,
                "2026-02-07": 2,
                "2026-02-20": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_251": {
      "overall": {
        "avg_time_hours": 208.54,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "10-12h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "24-26h": 1,
          "36-38h": 1,
          "76-78h": 2,
          "96-98h": 1,
          "98-100h": 1,
          "104-106h": 1,
          "122-124h": 1,
          "152-154h": 1,
          "256-258h": 1,
          "276-278h": 1,
          "286-288h": 1,
          "302-304h": 1,
          "310-312h": 1,
          "408-410h": 1,
          "420-422h": 2,
          "466-468h": 1,
          "494-496h": 1,
          "536-538h": 1,
          "558-560h": 1,
          "854-856h": 1
        },
        "tickets_count": 33,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-10-21": 1,
          "2025-10-25": 1,
          "2025-11-20": 3,
          "2025-11-29": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2026-01-21": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 5,
          "2026-03-17": 1,
          "2026-03-18": 4,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-04-08": 1,
          "2026-04-13": 1,
          "2026-04-30": 2,
          "2026-05-13": 1,
          "2026-05-21": 1
        },
        "time_per_day": {
          "2025-10-15": 11.88493388888889,
          "2025-10-21": 152.97903861111112,
          "2025-10-25": 16.70201472222222,
          "2025-11-20": 169.49618694444445,
          "2025-11-29": 257.80975416666666,
          "2025-12-03": 99.08790027777778,
          "2025-12-05": 105.44115166666667,
          "2025-12-09": 277.78615472222225,
          "2026-01-21": 0.23897111111111113,
          "2026-02-10": 519.9542513888889,
          "2026-02-12": 559.6748722222222,
          "2026-02-18": 122.99625666666665,
          "2026-02-19": 1900.2386955555553,
          "2026-03-17": 37.44888833333333,
          "2026-03-18": 1597.8756922222221,
          "2026-03-20": 536.1861708333333,
          "2026-03-24": 96.17529777777777,
          "2026-04-13": 0.2902436111111111,
          "2026-04-30": 2.547782222222222,
          "2026-05-13": 0.05110694444444445
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-10-21": 1,
          "2025-10-25": 1,
          "2025-11-20": 3,
          "2025-11-29": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2026-01-21": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 5,
          "2026-03-17": 1,
          "2026-03-18": 4,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-04-13": 1,
          "2026-04-30": 2,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 93.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "10-12h": 1,
            "14-16h": 1,
            "276-278h": 1,
            "536-538h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-20": 1,
            "2025-12-09": 1,
            "2026-01-21": 1,
            "2026-03-20": 1,
            "2026-04-13": 1,
            "2026-04-30": 2,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2025-10-15": 11.88493388888889,
            "2025-11-20": 15.449902777777778,
            "2025-12-09": 277.78615472222225,
            "2026-01-21": 0.23897111111111113,
            "2026-03-20": 536.1861708333333,
            "2026-04-13": 0.2902436111111111,
            "2026-04-30": 2.547782222222222,
            "2026-05-13": 0.05110694444444445
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-20": 1,
            "2025-12-09": 1,
            "2026-01-21": 1,
            "2026-03-20": 1,
            "2026-04-13": 1,
            "2026-04-30": 2,
            "2026-05-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 232.69,
          "mode_time_hours": 153.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "152-154h": 1,
            "256-258h": 1,
            "494-496h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-11-29": 1,
            "2026-02-10": 2
          },
          "time_per_day": {
            "2025-10-21": 152.97903861111112,
            "2025-11-29": 257.80975416666666,
            "2026-02-10": 519.9542513888889
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-11-29": 1,
            "2026-02-10": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 223.67,
          "mode_time_hours": 77.0,
          "mode_frequency": 2,
          "time_distribution": {
            "16-18h": 1,
            "36-38h": 1,
            "76-78h": 2,
            "96-98h": 1,
            "98-100h": 1,
            "122-124h": 1,
            "286-288h": 1,
            "420-422h": 2,
            "466-468h": 1,
            "558-560h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-10-25": 1,
            "2025-11-20": 2,
            "2025-12-03": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-24": 1,
            "2026-04-08": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2025-10-25": 16.70201472222222,
            "2025-11-20": 154.04628416666668,
            "2025-12-03": 99.08790027777778,
            "2026-02-12": 559.6748722222222,
            "2026-02-18": 122.99625666666665,
            "2026-03-17": 37.44888833333333,
            "2026-03-18": 1597.8756922222221,
            "2026-03-24": 96.17529777777777
          },
          "time_count_per_day": {
            "2025-10-25": 1,
            "2025-11-20": 2,
            "2025-12-03": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-17": 1,
            "2026-03-18": 4,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 334.28,
          "mode_time_hours": 105.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "104-106h": 1,
            "302-304h": 1,
            "310-312h": 1,
            "408-410h": 1,
            "854-856h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-02-19": 5
          },
          "time_per_day": {
            "2025-12-05": 105.44115166666667,
            "2026-02-19": 1900.2386955555553
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-02-19": 5
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 208.54,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "10-12h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "24-26h": 1,
              "36-38h": 1,
              "76-78h": 2,
              "96-98h": 1,
              "98-100h": 1,
              "104-106h": 1,
              "122-124h": 1,
              "152-154h": 1,
              "256-258h": 1,
              "276-278h": 1,
              "286-288h": 1,
              "302-304h": 1,
              "310-312h": 1,
              "408-410h": 1,
              "420-422h": 2,
              "466-468h": 1,
              "494-496h": 1,
              "536-538h": 1,
              "558-560h": 1,
              "854-856h": 1
            },
            "tickets_count": 31,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-10-21": 1,
              "2025-10-25": 1,
              "2025-11-20": 3,
              "2025-11-29": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2026-01-21": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 5,
              "2026-03-17": 1,
              "2026-03-18": 4,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-04-13": 1,
              "2026-04-30": 2,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2025-10-15": 11.88493388888889,
              "2025-10-21": 152.97903861111112,
              "2025-10-25": 16.70201472222222,
              "2025-11-20": 169.49618694444445,
              "2025-11-29": 257.80975416666666,
              "2025-12-03": 99.08790027777778,
              "2025-12-05": 105.44115166666667,
              "2025-12-09": 277.78615472222225,
              "2026-01-21": 0.23897111111111113,
              "2026-02-10": 519.9542513888889,
              "2026-02-12": 559.6748722222222,
              "2026-02-18": 122.99625666666665,
              "2026-02-19": 1900.2386955555553,
              "2026-03-17": 37.44888833333333,
              "2026-03-18": 1597.8756922222221,
              "2026-03-20": 536.1861708333333,
              "2026-03-24": 96.17529777777777,
              "2026-04-13": 0.2902436111111111,
              "2026-04-30": 2.547782222222222,
              "2026-05-13": 0.05110694444444445
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-10-21": 1,
              "2025-10-25": 1,
              "2025-11-20": 3,
              "2025-11-29": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2026-01-21": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 5,
              "2026-03-17": 1,
              "2026-03-18": 4,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-04-13": 1,
              "2026-04-30": 2,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 93.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "10-12h": 1,
                "14-16h": 1,
                "276-278h": 1,
                "536-538h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-20": 1,
                "2025-12-09": 1,
                "2026-01-21": 1,
                "2026-03-20": 1,
                "2026-04-13": 1,
                "2026-04-30": 2,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2025-10-15": 11.88493388888889,
                "2025-11-20": 15.449902777777778,
                "2025-12-09": 277.78615472222225,
                "2026-01-21": 0.23897111111111113,
                "2026-03-20": 536.1861708333333,
                "2026-04-13": 0.2902436111111111,
                "2026-04-30": 2.547782222222222,
                "2026-05-13": 0.05110694444444445
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-20": 1,
                "2025-12-09": 1,
                "2026-01-21": 1,
                "2026-03-20": 1,
                "2026-04-13": 1,
                "2026-04-30": 2,
                "2026-05-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 232.69,
              "mode_time_hours": 153.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "152-154h": 1,
                "256-258h": 1,
                "494-496h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-11-29": 1,
                "2026-02-10": 2
              },
              "time_per_day": {
                "2025-10-21": 152.97903861111112,
                "2025-11-29": 257.80975416666666,
                "2026-02-10": 519.9542513888889
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-11-29": 1,
                "2026-02-10": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 223.67,
              "mode_time_hours": 77.0,
              "mode_frequency": 2,
              "time_distribution": {
                "16-18h": 1,
                "36-38h": 1,
                "76-78h": 2,
                "96-98h": 1,
                "98-100h": 1,
                "122-124h": 1,
                "286-288h": 1,
                "420-422h": 2,
                "466-468h": 1,
                "558-560h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-10-25": 1,
                "2025-11-20": 2,
                "2025-12-03": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-10-25": 16.70201472222222,
                "2025-11-20": 154.04628416666668,
                "2025-12-03": 99.08790027777778,
                "2026-02-12": 559.6748722222222,
                "2026-02-18": 122.99625666666665,
                "2026-03-17": 37.44888833333333,
                "2026-03-18": 1597.8756922222221,
                "2026-03-24": 96.17529777777777
              },
              "time_count_per_day": {
                "2025-10-25": 1,
                "2025-11-20": 2,
                "2025-12-03": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-17": 1,
                "2026-03-18": 4,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 334.28,
              "mode_time_hours": 105.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "104-106h": 1,
                "302-304h": 1,
                "310-312h": 1,
                "408-410h": 1,
                "854-856h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-02-19": 5
              },
              "time_per_day": {
                "2025-12-05": 105.44115166666667,
                "2026-02-19": 1900.2386955555553
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-02-19": 5
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-08": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-08": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_79": {
      "overall": {
        "avg_time_hours": 4.0,
        "mode_time_hours": 5.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 3
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-15": 2,
          "2026-01-12": 1,
          "2026-01-13": 1
        },
        "time_per_day": {
          "2025-10-15": 11.637629444444444,
          "2026-01-12": 0.15279944444444443,
          "2026-01-13": 4.198833611111111
        },
        "time_count_per_day": {
          "2025-10-15": 2,
          "2026-01-12": 1,
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.93,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-15": 2,
            "2026-01-12": 1
          },
          "time_per_day": {
            "2025-10-15": 11.637629444444444,
            "2026-01-12": 0.15279944444444443
          },
          "time_count_per_day": {
            "2025-10-15": 2,
            "2026-01-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 4.2,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 4.198833611111111
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.0,
            "mode_time_hours": 5.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 3
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-15": 2,
              "2026-01-12": 1,
              "2026-01-13": 1
            },
            "time_per_day": {
              "2025-10-15": 11.637629444444444,
              "2026-01-12": 0.15279944444444443,
              "2026-01-13": 4.198833611111111
            },
            "time_count_per_day": {
              "2025-10-15": 2,
              "2026-01-12": 1,
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.93,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-15": 2,
                "2026-01-12": 1
              },
              "time_per_day": {
                "2025-10-15": 11.637629444444444,
                "2026-01-12": 0.15279944444444443
              },
              "time_count_per_day": {
                "2025-10-15": 2,
                "2026-01-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 4.2,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 4.198833611111111
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_257": {
      "overall": {
        "avg_time_hours": 138.8,
        "mode_time_hours": 1.0,
        "mode_frequency": 96,
        "time_distribution": {
          "0-2h": 96,
          "2-4h": 13,
          "4-6h": 7,
          "6-8h": 7,
          "8-10h": 3,
          "10-12h": 2,
          "12-14h": 1,
          "14-16h": 3,
          "16-18h": 2,
          "18-20h": 2,
          "20-22h": 1,
          "26-28h": 4,
          "30-32h": 1,
          "34-36h": 1,
          "36-38h": 4,
          "46-48h": 1,
          "48-50h": 1,
          "64-66h": 1,
          "70-72h": 1,
          "72-74h": 5,
          "74-76h": 4,
          "78-80h": 5,
          "80-82h": 1,
          "94-96h": 1,
          "96-98h": 1,
          "98-100h": 2,
          "100-102h": 1,
          "104-106h": 2,
          "138-140h": 1,
          "144-146h": 1,
          "146-148h": 2,
          "150-152h": 2,
          "156-158h": 1,
          "166-168h": 1,
          "180-182h": 1,
          "182-184h": 2,
          "186-188h": 1,
          "192-194h": 1,
          "198-200h": 1,
          "202-204h": 1,
          "204-206h": 1,
          "206-208h": 2,
          "218-220h": 1,
          "236-238h": 1,
          "240-242h": 1,
          "284-286h": 1,
          "306-308h": 1,
          "308-310h": 1,
          "312-314h": 1,
          "336-338h": 1,
          "358-360h": 1,
          "400-402h": 1,
          "412-414h": 1,
          "414-416h": 1,
          "420-422h": 1,
          "424-426h": 1,
          "430-432h": 1,
          "432-434h": 1,
          "446-448h": 1,
          "482-484h": 1,
          "490-492h": 1,
          "500-502h": 1,
          "508-510h": 1,
          "528-530h": 1,
          "558-560h": 1,
          "568-570h": 1,
          "576-578h": 4,
          "660-662h": 1,
          "668-670h": 1,
          "744-746h": 1,
          "760-762h": 1,
          "764-766h": 1,
          "772-774h": 1,
          "814-816h": 1,
          "860-862h": 1,
          "1086-1088h": 1,
          "1258-1260h": 1,
          "1830-1832h": 1,
          "2044-2046h": 1,
          "2060-2062h": 1
        },
        "tickets_count": 299,
        "tickets_per_day": {
          "2025-10-15": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-20": 2,
          "2025-11-21": 1,
          "2025-11-23": 1,
          "2025-11-24": 2,
          "2025-11-27": 1,
          "2025-11-29": 2,
          "2025-12-02": 2,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-05": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-05": 4,
          "2026-02-06": 3,
          "2026-02-07": 1,
          "2026-02-10": 4,
          "2026-02-11": 1,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-16": 9,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 15,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-27": 1,
          "2026-02-28": 3,
          "2026-03-02": 2,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-06": 2,
          "2026-03-09": 2,
          "2026-03-10": 5,
          "2026-03-12": 2,
          "2026-03-17": 3,
          "2026-03-18": 15,
          "2026-03-19": 3,
          "2026-03-20": 6,
          "2026-03-23": 2,
          "2026-03-24": 3,
          "2026-03-26": 2,
          "2026-03-30": 2,
          "2026-04-02": 2,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 4,
          "2026-04-10": 5,
          "2026-04-14": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 9,
          "2026-04-24": 4,
          "2026-04-27": 4,
          "2026-04-28": 3,
          "2026-04-29": 6,
          "2026-04-30": 4,
          "2026-05-02": 2,
          "2026-05-04": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 2,
          "2026-05-11": 2,
          "2026-05-12": 37,
          "2026-05-13": 4,
          "2026-05-14": 20,
          "2026-05-15": 2,
          "2026-05-18": 2,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 6,
          "2026-05-22": 6,
          "2026-05-25": 1,
          "2026-05-26": 4,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-05-29": 2,
          "2026-06-01": 1,
          "2026-06-02": 3,
          "2026-06-03": 3,
          "2026-06-05": 5,
          "2026-06-06": 1,
          "2026-06-08": 5
        },
        "time_per_day": {
          "2025-10-15": 1.5041441666666666,
          "2025-11-12": 80.24346694444445,
          "2025-11-13": 73.68127638888888,
          "2025-11-20": 140.70189944444445,
          "2025-11-21": 0.3716466666666667,
          "2025-11-23": 35.12647472222222,
          "2025-11-24": 92.94015722222221,
          "2025-11-27": 0.39415833333333333,
          "2025-11-29": 159.77094083333333,
          "2025-12-02": 8.173456111111111,
          "2025-12-10": 431.19249638888886,
          "2025-12-12": 237.06135500000002,
          "2025-12-15": 414.5896119444444,
          "2025-12-19": 558.6822730555556,
          "2026-01-05": 71.49089305555556,
          "2026-01-14": 0.6270791666666667,
          "2026-01-17": 98.643685,
          "2026-01-23": 75.05059138888889,
          "2026-01-26": 6.711571111111111,
          "2026-01-27": 68.037315,
          "2026-01-30": 413.64857722222223,
          "2026-02-03": 192.04518305555555,
          "2026-02-05": 449.1215544444445,
          "2026-02-06": 450.64352166666663,
          "2026-02-07": 2.790459166666667,
          "2026-02-10": 829.5929488888889,
          "2026-02-11": 0.3995883333333333,
          "2026-02-12": 31.989818888888887,
          "2026-02-13": 172.16507083333335,
          "2026-02-16": 1831.8803725,
          "2026-02-17": 482.18489805555555,
          "2026-02-18": 0.37526,
          "2026-02-19": 7125.990330555556,
          "2026-02-20": 96.18127305555555,
          "2026-02-21": 3.4740744444444442,
          "2026-02-27": 9.37832472222222,
          "2026-02-28": 150.17267944444447,
          "2026-03-02": 157.90107444444448,
          "2026-03-03": 13.022444722222222,
          "2026-03-04": 0.12382583333333333,
          "2026-03-09": 848.0884936111111,
          "2026-03-10": 19.37668027777778,
          "2026-03-12": 2.087009722222222,
          "2026-03-17": 196.1322572222222,
          "2026-03-18": 4970.225528333333,
          "2026-03-19": 1.5151463888888888,
          "2026-03-20": 2744.598085555556,
          "2026-03-23": 1.8361044444444443,
          "2026-03-24": 46.54857444444445,
          "2026-03-26": 0.9225263888888888,
          "2026-03-30": 146.89748305555554,
          "2026-04-02": 1086.5316547222221,
          "2026-04-06": 0.9625144444444445,
          "2026-04-07": 4.121739722222222,
          "2026-04-08": 3.6459891666666664,
          "2026-04-10": 1262.8605616666666,
          "2026-04-14": 0.3956922222222222,
          "2026-04-16": 0.18215194444444444,
          "2026-04-17": 0.07356694444444445,
          "2026-04-21": 0.12620916666666668,
          "2026-04-22": 652.431825,
          "2026-04-24": 5.36580361111111,
          "2026-04-27": 95.19655472222222,
          "2026-04-28": 0.4667027777777778,
          "2026-04-29": 2.6922875,
          "2026-04-30": 6.646862500000001,
          "2026-05-02": 37.22658861111111,
          "2026-05-04": 0.09492166666666667,
          "2026-05-06": 528.3157358333333,
          "2026-05-07": 0.7477444444444444,
          "2026-05-08": 4.140524166666667,
          "2026-05-09": 12.972728333333333,
          "2026-05-11": 0.652855,
          "2026-05-12": 2049.8015030555553,
          "2026-05-13": 2061.4253625,
          "2026-05-14": 18.530320555555555,
          "2026-05-15": 9.546603333333334,
          "2026-05-18": 1.5239872222222224,
          "2026-05-19": 0.20422,
          "2026-05-20": 0.1506222222222222,
          "2026-05-21": 1.2492502777777779,
          "2026-05-22": 9.365271944444444,
          "2026-05-26": 37.35865611111112,
          "2026-05-28": 0.28647694444444444,
          "2026-05-29": 17.57522277777778,
          "2026-06-01": 0.14561833333333332,
          "2026-06-02": 20.18678555555556,
          "2026-06-03": 11.907903333333334,
          "2026-06-05": 103.68516277777778,
          "2026-06-06": 199.65363333333332,
          "2026-06-08": 6.996417777777778
        },
        "time_count_per_day": {
          "2025-10-15": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-20": 2,
          "2025-11-21": 1,
          "2025-11-23": 1,
          "2025-11-24": 2,
          "2025-11-27": 1,
          "2025-11-29": 2,
          "2025-12-02": 2,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-19": 1,
          "2026-01-05": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-05": 4,
          "2026-02-06": 3,
          "2026-02-07": 1,
          "2026-02-10": 4,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-16": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 15,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-27": 1,
          "2026-02-28": 3,
          "2026-03-02": 2,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-09": 2,
          "2026-03-10": 4,
          "2026-03-12": 2,
          "2026-03-17": 3,
          "2026-03-18": 15,
          "2026-03-19": 2,
          "2026-03-20": 6,
          "2026-03-23": 2,
          "2026-03-24": 3,
          "2026-03-26": 2,
          "2026-03-30": 2,
          "2026-04-02": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-10": 3,
          "2026-04-14": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-04-22": 7,
          "2026-04-24": 4,
          "2026-04-27": 2,
          "2026-04-28": 1,
          "2026-04-29": 6,
          "2026-04-30": 4,
          "2026-05-02": 2,
          "2026-05-04": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 2,
          "2026-05-11": 2,
          "2026-05-12": 12,
          "2026-05-13": 1,
          "2026-05-14": 16,
          "2026-05-15": 2,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 3,
          "2026-05-22": 5,
          "2026-05-26": 4,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 3,
          "2026-06-03": 3,
          "2026-06-05": 5,
          "2026-06-06": 1,
          "2026-06-08": 5
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 923.78,
          "mode_time_hours": 1087.0,
          "mode_frequency": 1,
          "time_distribution": {
            "760-762h": 1,
            "1086-1088h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-03-20": 761.0296247222223,
            "2026-04-02": 1086.5316547222221
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-04-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 72.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 95,
          "time_distribution": {
            "0-2h": 95,
            "2-4h": 10,
            "4-6h": 7,
            "6-8h": 6,
            "8-10h": 2,
            "10-12h": 2,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "26-28h": 2,
            "30-32h": 1,
            "36-38h": 2,
            "70-72h": 1,
            "72-74h": 1,
            "74-76h": 2,
            "78-80h": 1,
            "96-98h": 1,
            "100-102h": 1,
            "236-238h": 1,
            "414-416h": 1,
            "482-484h": 1,
            "508-510h": 1,
            "528-530h": 1,
            "660-662h": 1,
            "764-766h": 1,
            "772-774h": 1,
            "1258-1260h": 1,
            "2044-2046h": 1,
            "2060-2062h": 1
          },
          "tickets_count": 193,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2026-01-05": 1,
            "2026-01-14": 1,
            "2026-01-27": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-12": 2,
            "2026-02-16": 8,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-19": 3,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-09": 2,
            "2026-03-10": 4,
            "2026-03-12": 2,
            "2026-03-19": 3,
            "2026-03-20": 4,
            "2026-03-23": 2,
            "2026-03-26": 2,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-10": 3,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-22": 2,
            "2026-04-24": 4,
            "2026-04-27": 2,
            "2026-04-28": 1,
            "2026-04-29": 6,
            "2026-04-30": 4,
            "2026-05-02": 2,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 2,
            "2026-05-11": 2,
            "2026-05-12": 37,
            "2026-05-13": 4,
            "2026-05-14": 20,
            "2026-05-15": 2,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-21": 3,
            "2026-05-22": 5,
            "2026-05-25": 1,
            "2026-05-26": 4,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-02": 3,
            "2026-06-03": 3,
            "2026-06-05": 5,
            "2026-06-08": 5
          },
          "time_per_day": {
            "2025-10-15": 1.5041441666666666,
            "2025-11-21": 0.3716466666666667,
            "2025-11-27": 0.39415833333333333,
            "2025-12-02": 5.461725555555556,
            "2025-12-12": 237.06135500000002,
            "2025-12-15": 414.5896119444444,
            "2026-01-05": 71.49089305555556,
            "2026-01-14": 0.6270791666666667,
            "2026-01-27": 12.282449444444444,
            "2026-02-03": 52.28478694444445,
            "2026-02-05": 2.63625,
            "2026-02-12": 31.989818888888887,
            "2026-02-17": 482.18489805555555,
            "2026-02-18": 0.37526,
            "2026-02-19": 226.7458538888889,
            "2026-02-20": 96.18127305555555,
            "2026-02-27": 9.37832472222222,
            "2026-02-28": 2.2983405555555554,
            "2026-03-02": 0.6642033333333334,
            "2026-03-03": 13.022444722222222,
            "2026-03-04": 0.12382583333333333,
            "2026-03-09": 848.0884936111111,
            "2026-03-10": 19.37668027777778,
            "2026-03-12": 2.087009722222222,
            "2026-03-19": 1.5151463888888888,
            "2026-03-20": 1937.0185561111111,
            "2026-03-23": 1.8361044444444443,
            "2026-03-26": 0.9225263888888888,
            "2026-04-06": 0.9625144444444445,
            "2026-04-07": 4.121739722222222,
            "2026-04-08": 3.6459891666666664,
            "2026-04-10": 1262.8605616666666,
            "2026-04-14": 0.3956922222222222,
            "2026-04-16": 0.18215194444444444,
            "2026-04-17": 0.07356694444444445,
            "2026-04-21": 0.12620916666666668,
            "2026-04-22": 10.722925555555555,
            "2026-04-24": 5.36580361111111,
            "2026-04-27": 0.03897916666666666,
            "2026-04-28": 0.4667027777777778,
            "2026-04-29": 2.6922875,
            "2026-04-30": 6.646862500000001,
            "2026-05-02": 37.22658861111111,
            "2026-05-04": 0.09492166666666667,
            "2026-05-06": 528.3157358333333,
            "2026-05-07": 0.7477444444444444,
            "2026-05-08": 4.140524166666667,
            "2026-05-09": 12.972728333333333,
            "2026-05-11": 0.652855,
            "2026-05-12": 2049.8015030555553,
            "2026-05-13": 2061.4253625,
            "2026-05-14": 18.530320555555555,
            "2026-05-15": 9.546603333333334,
            "2026-05-18": 1.5239872222222224,
            "2026-05-19": 0.20422,
            "2026-05-20": 0.1506222222222222,
            "2026-05-21": 1.2492502777777779,
            "2026-05-22": 9.365271944444444,
            "2026-05-26": 37.35865611111112,
            "2026-05-28": 0.28647694444444444,
            "2026-05-29": 17.57522277777778,
            "2026-06-01": 0.14561833333333332,
            "2026-06-02": 20.18678555555556,
            "2026-06-03": 11.907903333333334,
            "2026-06-05": 103.68516277777778,
            "2026-06-08": 6.996417777777778
          },
          "time_count_per_day": {
            "2025-10-15": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-02": 1,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2026-01-05": 1,
            "2026-01-14": 1,
            "2026-01-27": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-12": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-19": 3,
            "2026-02-20": 1,
            "2026-02-27": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-09": 2,
            "2026-03-10": 4,
            "2026-03-12": 2,
            "2026-03-19": 2,
            "2026-03-20": 4,
            "2026-03-23": 2,
            "2026-03-26": 2,
            "2026-04-06": 2,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-10": 3,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-04-22": 2,
            "2026-04-24": 4,
            "2026-04-27": 1,
            "2026-04-28": 1,
            "2026-04-29": 6,
            "2026-04-30": 4,
            "2026-05-02": 2,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 2,
            "2026-05-11": 2,
            "2026-05-12": 12,
            "2026-05-13": 1,
            "2026-05-14": 16,
            "2026-05-15": 2,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-21": 3,
            "2026-05-22": 5,
            "2026-05-26": 4,
            "2026-05-28": 1,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 3,
            "2026-06-03": 3,
            "2026-06-05": 5,
            "2026-06-08": 5
          }
        },
        "P3": {
          "avg_time_hours": 306.86,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2,
            "26-28h": 1,
            "144-146h": 1,
            "150-152h": 1,
            "166-168h": 1,
            "308-310h": 1,
            "430-432h": 1,
            "1830-1832h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-10": 1,
            "2026-02-07": 1,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-12-02": 2.7117305555555555,
            "2025-12-10": 431.19249638888886,
            "2026-02-07": 2.790459166666667,
            "2026-02-10": 627.4781833333334,
            "2026-02-11": 0.3995883333333333,
            "2026-02-13": 172.16507083333335,
            "2026-02-16": 1831.8803725
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-10": 1,
            "2026-02-07": 1,
            "2026-02-10": 3,
            "2026-02-11": 1,
            "2026-02-13": 2,
            "2026-02-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 157.0,
          "mode_time_hours": 73.0,
          "mode_frequency": 4,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1,
            "8-10h": 1,
            "14-16h": 2,
            "16-18h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "26-28h": 1,
            "34-36h": 1,
            "36-38h": 2,
            "46-48h": 1,
            "48-50h": 1,
            "64-66h": 1,
            "72-74h": 4,
            "74-76h": 1,
            "78-80h": 4,
            "80-82h": 1,
            "94-96h": 1,
            "98-100h": 1,
            "104-106h": 2,
            "138-140h": 1,
            "146-148h": 2,
            "150-152h": 1,
            "156-158h": 1,
            "180-182h": 1,
            "182-184h": 2,
            "186-188h": 1,
            "192-194h": 1,
            "198-200h": 1,
            "202-204h": 1,
            "204-206h": 1,
            "206-208h": 2,
            "218-220h": 1,
            "240-242h": 1,
            "312-314h": 1,
            "358-360h": 1,
            "400-402h": 1,
            "412-414h": 1,
            "420-422h": 1,
            "424-426h": 1,
            "432-434h": 1,
            "446-448h": 1,
            "490-492h": 1,
            "500-502h": 1
          },
          "tickets_count": 79,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-20": 2,
            "2025-11-23": 1,
            "2025-11-24": 2,
            "2025-11-29": 2,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-05": 3,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-21": 1,
            "2026-02-28": 2,
            "2026-03-02": 1,
            "2026-03-06": 2,
            "2026-03-10": 1,
            "2026-03-17": 3,
            "2026-03-18": 15,
            "2026-03-20": 1,
            "2026-03-24": 3,
            "2026-03-30": 2,
            "2026-04-02": 1,
            "2026-04-09": 4,
            "2026-04-10": 2,
            "2026-04-20": 1,
            "2026-04-22": 7,
            "2026-04-27": 2,
            "2026-04-28": 2,
            "2026-05-18": 1,
            "2026-05-21": 3,
            "2026-05-22": 1,
            "2026-05-27": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-11-12": 80.24346694444445,
            "2025-11-13": 73.68127638888888,
            "2025-11-20": 140.70189944444445,
            "2025-11-23": 35.12647472222222,
            "2025-11-24": 92.94015722222221,
            "2025-11-29": 159.77094083333333,
            "2026-01-26": 6.711571111111111,
            "2026-01-27": 55.754865555555554,
            "2026-01-30": 413.64857722222223,
            "2026-02-03": 139.7603961111111,
            "2026-02-05": 446.48530444444447,
            "2026-02-06": 450.64352166666663,
            "2026-02-10": 202.11476555555555,
            "2026-02-21": 3.4740744444444442,
            "2026-02-28": 147.8743388888889,
            "2026-03-02": 157.23687111111113,
            "2026-03-17": 196.1322572222222,
            "2026-03-18": 4970.225528333333,
            "2026-03-20": 46.54990472222222,
            "2026-03-24": 46.54857444444445,
            "2026-03-30": 146.89748305555554,
            "2026-04-22": 641.7088994444445,
            "2026-04-27": 95.15757555555555,
            "2026-06-06": 199.65363333333332
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-20": 2,
            "2025-11-23": 1,
            "2025-11-24": 2,
            "2025-11-29": 2,
            "2026-01-26": 1,
            "2026-01-27": 3,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-05": 3,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-21": 1,
            "2026-02-28": 2,
            "2026-03-02": 1,
            "2026-03-17": 3,
            "2026-03-18": 15,
            "2026-03-20": 1,
            "2026-03-24": 3,
            "2026-03-30": 2,
            "2026-04-22": 5,
            "2026-04-27": 1,
            "2026-06-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 508.77,
          "mode_time_hours": 577.0,
          "mode_frequency": 4,
          "time_distribution": {
            "74-76h": 1,
            "98-100h": 1,
            "284-286h": 1,
            "306-308h": 1,
            "336-338h": 1,
            "558-560h": 1,
            "568-570h": 1,
            "576-578h": 4,
            "668-670h": 1,
            "744-746h": 1,
            "814-816h": 1,
            "860-862h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-02-19": 12
          },
          "time_per_day": {
            "2025-12-19": 558.6822730555556,
            "2026-01-17": 98.643685,
            "2026-01-23": 75.05059138888889,
            "2026-02-19": 6899.244476666668
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-02-19": 12
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 138.8,
            "mode_time_hours": 1.0,
            "mode_frequency": 96,
            "time_distribution": {
              "0-2h": 96,
              "2-4h": 13,
              "4-6h": 7,
              "6-8h": 7,
              "8-10h": 3,
              "10-12h": 2,
              "12-14h": 1,
              "14-16h": 3,
              "16-18h": 2,
              "18-20h": 2,
              "20-22h": 1,
              "26-28h": 4,
              "30-32h": 1,
              "34-36h": 1,
              "36-38h": 4,
              "46-48h": 1,
              "48-50h": 1,
              "64-66h": 1,
              "70-72h": 1,
              "72-74h": 5,
              "74-76h": 4,
              "78-80h": 5,
              "80-82h": 1,
              "94-96h": 1,
              "96-98h": 1,
              "98-100h": 2,
              "100-102h": 1,
              "104-106h": 2,
              "138-140h": 1,
              "144-146h": 1,
              "146-148h": 2,
              "150-152h": 2,
              "156-158h": 1,
              "166-168h": 1,
              "180-182h": 1,
              "182-184h": 2,
              "186-188h": 1,
              "192-194h": 1,
              "198-200h": 1,
              "202-204h": 1,
              "204-206h": 1,
              "206-208h": 2,
              "218-220h": 1,
              "236-238h": 1,
              "240-242h": 1,
              "284-286h": 1,
              "306-308h": 1,
              "308-310h": 1,
              "312-314h": 1,
              "336-338h": 1,
              "358-360h": 1,
              "400-402h": 1,
              "412-414h": 1,
              "414-416h": 1,
              "420-422h": 1,
              "424-426h": 1,
              "430-432h": 1,
              "432-434h": 1,
              "446-448h": 1,
              "482-484h": 1,
              "490-492h": 1,
              "500-502h": 1,
              "508-510h": 1,
              "528-530h": 1,
              "558-560h": 1,
              "568-570h": 1,
              "576-578h": 4,
              "660-662h": 1,
              "668-670h": 1,
              "744-746h": 1,
              "760-762h": 1,
              "764-766h": 1,
              "772-774h": 1,
              "814-816h": 1,
              "860-862h": 1,
              "1086-1088h": 1,
              "1258-1260h": 1,
              "1830-1832h": 1,
              "2044-2046h": 1,
              "2060-2062h": 1
            },
            "tickets_count": 232,
            "tickets_per_day": {
              "2025-10-15": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-20": 2,
              "2025-11-21": 1,
              "2025-11-23": 1,
              "2025-11-24": 2,
              "2025-11-27": 1,
              "2025-11-29": 2,
              "2025-12-02": 2,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-05": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-05": 4,
              "2026-02-06": 3,
              "2026-02-07": 1,
              "2026-02-10": 4,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 15,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-27": 1,
              "2026-02-28": 3,
              "2026-03-02": 2,
              "2026-03-03": 2,
              "2026-03-04": 2,
              "2026-03-09": 2,
              "2026-03-10": 4,
              "2026-03-12": 2,
              "2026-03-17": 3,
              "2026-03-18": 15,
              "2026-03-19": 2,
              "2026-03-20": 6,
              "2026-03-23": 2,
              "2026-03-24": 3,
              "2026-03-26": 2,
              "2026-03-30": 2,
              "2026-04-02": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-10": 3,
              "2026-04-14": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-22": 7,
              "2026-04-24": 4,
              "2026-04-27": 2,
              "2026-04-28": 1,
              "2026-04-29": 6,
              "2026-04-30": 4,
              "2026-05-02": 2,
              "2026-05-04": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 2,
              "2026-05-11": 2,
              "2026-05-12": 12,
              "2026-05-13": 1,
              "2026-05-14": 16,
              "2026-05-15": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 3,
              "2026-05-22": 5,
              "2026-05-26": 4,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 3,
              "2026-06-03": 3,
              "2026-06-05": 5,
              "2026-06-06": 1,
              "2026-06-08": 5
            },
            "time_per_day": {
              "2025-10-15": 1.5041441666666666,
              "2025-11-12": 80.24346694444445,
              "2025-11-13": 73.68127638888888,
              "2025-11-20": 140.70189944444445,
              "2025-11-21": 0.3716466666666667,
              "2025-11-23": 35.12647472222222,
              "2025-11-24": 92.94015722222221,
              "2025-11-27": 0.39415833333333333,
              "2025-11-29": 159.77094083333333,
              "2025-12-02": 8.173456111111111,
              "2025-12-10": 431.19249638888886,
              "2025-12-12": 237.06135500000002,
              "2025-12-15": 414.5896119444444,
              "2025-12-19": 558.6822730555556,
              "2026-01-05": 71.49089305555556,
              "2026-01-14": 0.6270791666666667,
              "2026-01-17": 98.643685,
              "2026-01-23": 75.05059138888889,
              "2026-01-26": 6.711571111111111,
              "2026-01-27": 68.037315,
              "2026-01-30": 413.64857722222223,
              "2026-02-03": 192.04518305555555,
              "2026-02-05": 449.1215544444445,
              "2026-02-06": 450.64352166666663,
              "2026-02-07": 2.790459166666667,
              "2026-02-10": 829.5929488888889,
              "2026-02-11": 0.3995883333333333,
              "2026-02-12": 31.989818888888887,
              "2026-02-13": 172.16507083333335,
              "2026-02-16": 1831.8803725,
              "2026-02-17": 482.18489805555555,
              "2026-02-18": 0.37526,
              "2026-02-19": 7125.990330555556,
              "2026-02-20": 96.18127305555555,
              "2026-02-21": 3.4740744444444442,
              "2026-02-27": 9.37832472222222,
              "2026-02-28": 150.17267944444447,
              "2026-03-02": 157.90107444444448,
              "2026-03-03": 13.022444722222222,
              "2026-03-04": 0.12382583333333333,
              "2026-03-09": 848.0884936111111,
              "2026-03-10": 19.37668027777778,
              "2026-03-12": 2.087009722222222,
              "2026-03-17": 196.1322572222222,
              "2026-03-18": 4970.225528333333,
              "2026-03-19": 1.5151463888888888,
              "2026-03-20": 2744.598085555556,
              "2026-03-23": 1.8361044444444443,
              "2026-03-24": 46.54857444444445,
              "2026-03-26": 0.9225263888888888,
              "2026-03-30": 146.89748305555554,
              "2026-04-02": 1086.5316547222221,
              "2026-04-06": 0.9625144444444445,
              "2026-04-07": 4.121739722222222,
              "2026-04-08": 3.6459891666666664,
              "2026-04-10": 1262.8605616666666,
              "2026-04-14": 0.3956922222222222,
              "2026-04-16": 0.18215194444444444,
              "2026-04-17": 0.07356694444444445,
              "2026-04-21": 0.12620916666666668,
              "2026-04-22": 652.431825,
              "2026-04-24": 5.36580361111111,
              "2026-04-27": 95.19655472222222,
              "2026-04-28": 0.4667027777777778,
              "2026-04-29": 2.6922875,
              "2026-04-30": 6.646862500000001,
              "2026-05-02": 37.22658861111111,
              "2026-05-04": 0.09492166666666667,
              "2026-05-06": 528.3157358333333,
              "2026-05-07": 0.7477444444444444,
              "2026-05-08": 4.140524166666667,
              "2026-05-09": 12.972728333333333,
              "2026-05-11": 0.652855,
              "2026-05-12": 2049.8015030555553,
              "2026-05-13": 2061.4253625,
              "2026-05-14": 18.530320555555555,
              "2026-05-15": 9.546603333333334,
              "2026-05-18": 1.5239872222222224,
              "2026-05-19": 0.20422,
              "2026-05-20": 0.1506222222222222,
              "2026-05-21": 1.2492502777777779,
              "2026-05-22": 9.365271944444444,
              "2026-05-26": 37.35865611111112,
              "2026-05-28": 0.28647694444444444,
              "2026-05-29": 17.57522277777778,
              "2026-06-01": 0.14561833333333332,
              "2026-06-02": 20.18678555555556,
              "2026-06-03": 11.907903333333334,
              "2026-06-05": 103.68516277777778,
              "2026-06-06": 199.65363333333332,
              "2026-06-08": 6.996417777777778
            },
            "time_count_per_day": {
              "2025-10-15": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-20": 2,
              "2025-11-21": 1,
              "2025-11-23": 1,
              "2025-11-24": 2,
              "2025-11-27": 1,
              "2025-11-29": 2,
              "2025-12-02": 2,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-19": 1,
              "2026-01-05": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-05": 4,
              "2026-02-06": 3,
              "2026-02-07": 1,
              "2026-02-10": 4,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-16": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 15,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-27": 1,
              "2026-02-28": 3,
              "2026-03-02": 2,
              "2026-03-03": 2,
              "2026-03-04": 2,
              "2026-03-09": 2,
              "2026-03-10": 4,
              "2026-03-12": 2,
              "2026-03-17": 3,
              "2026-03-18": 15,
              "2026-03-19": 2,
              "2026-03-20": 6,
              "2026-03-23": 2,
              "2026-03-24": 3,
              "2026-03-26": 2,
              "2026-03-30": 2,
              "2026-04-02": 1,
              "2026-04-06": 2,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-10": 3,
              "2026-04-14": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-04-22": 7,
              "2026-04-24": 4,
              "2026-04-27": 2,
              "2026-04-28": 1,
              "2026-04-29": 6,
              "2026-04-30": 4,
              "2026-05-02": 2,
              "2026-05-04": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-09": 2,
              "2026-05-11": 2,
              "2026-05-12": 12,
              "2026-05-13": 1,
              "2026-05-14": 16,
              "2026-05-15": 2,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 3,
              "2026-05-22": 5,
              "2026-05-26": 4,
              "2026-05-28": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 3,
              "2026-06-03": 3,
              "2026-06-05": 5,
              "2026-06-06": 1,
              "2026-06-08": 5
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 923.78,
              "mode_time_hours": 1087.0,
              "mode_frequency": 1,
              "time_distribution": {
                "760-762h": 1,
                "1086-1088h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-03-20": 761.0296247222223,
                "2026-04-02": 1086.5316547222221
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-04-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 72.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 95,
              "time_distribution": {
                "0-2h": 95,
                "2-4h": 10,
                "4-6h": 7,
                "6-8h": 6,
                "8-10h": 2,
                "10-12h": 2,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "26-28h": 2,
                "30-32h": 1,
                "36-38h": 2,
                "70-72h": 1,
                "72-74h": 1,
                "74-76h": 2,
                "78-80h": 1,
                "96-98h": 1,
                "100-102h": 1,
                "236-238h": 1,
                "414-416h": 1,
                "482-484h": 1,
                "508-510h": 1,
                "528-530h": 1,
                "660-662h": 1,
                "764-766h": 1,
                "772-774h": 1,
                "1258-1260h": 1,
                "2044-2046h": 1,
                "2060-2062h": 1
              },
              "tickets_count": 148,
              "tickets_per_day": {
                "2025-10-15": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2026-01-05": 1,
                "2026-01-14": 1,
                "2026-01-27": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-12": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-19": 3,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-09": 2,
                "2026-03-10": 4,
                "2026-03-12": 2,
                "2026-03-19": 2,
                "2026-03-20": 4,
                "2026-03-23": 2,
                "2026-03-26": 2,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-10": 3,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-22": 2,
                "2026-04-24": 4,
                "2026-04-27": 1,
                "2026-04-28": 1,
                "2026-04-29": 6,
                "2026-04-30": 4,
                "2026-05-02": 2,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 2,
                "2026-05-11": 2,
                "2026-05-12": 12,
                "2026-05-13": 1,
                "2026-05-14": 16,
                "2026-05-15": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-21": 3,
                "2026-05-22": 5,
                "2026-05-26": 4,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 3,
                "2026-06-03": 3,
                "2026-06-05": 5,
                "2026-06-08": 5
              },
              "time_per_day": {
                "2025-10-15": 1.5041441666666666,
                "2025-11-21": 0.3716466666666667,
                "2025-11-27": 0.39415833333333333,
                "2025-12-02": 5.461725555555556,
                "2025-12-12": 237.06135500000002,
                "2025-12-15": 414.5896119444444,
                "2026-01-05": 71.49089305555556,
                "2026-01-14": 0.6270791666666667,
                "2026-01-27": 12.282449444444444,
                "2026-02-03": 52.28478694444445,
                "2026-02-05": 2.63625,
                "2026-02-12": 31.989818888888887,
                "2026-02-17": 482.18489805555555,
                "2026-02-18": 0.37526,
                "2026-02-19": 226.7458538888889,
                "2026-02-20": 96.18127305555555,
                "2026-02-27": 9.37832472222222,
                "2026-02-28": 2.2983405555555554,
                "2026-03-02": 0.6642033333333334,
                "2026-03-03": 13.022444722222222,
                "2026-03-04": 0.12382583333333333,
                "2026-03-09": 848.0884936111111,
                "2026-03-10": 19.37668027777778,
                "2026-03-12": 2.087009722222222,
                "2026-03-19": 1.5151463888888888,
                "2026-03-20": 1937.0185561111111,
                "2026-03-23": 1.8361044444444443,
                "2026-03-26": 0.9225263888888888,
                "2026-04-06": 0.9625144444444445,
                "2026-04-07": 4.121739722222222,
                "2026-04-08": 3.6459891666666664,
                "2026-04-10": 1262.8605616666666,
                "2026-04-14": 0.3956922222222222,
                "2026-04-16": 0.18215194444444444,
                "2026-04-17": 0.07356694444444445,
                "2026-04-21": 0.12620916666666668,
                "2026-04-22": 10.722925555555555,
                "2026-04-24": 5.36580361111111,
                "2026-04-27": 0.03897916666666666,
                "2026-04-28": 0.4667027777777778,
                "2026-04-29": 2.6922875,
                "2026-04-30": 6.646862500000001,
                "2026-05-02": 37.22658861111111,
                "2026-05-04": 0.09492166666666667,
                "2026-05-06": 528.3157358333333,
                "2026-05-07": 0.7477444444444444,
                "2026-05-08": 4.140524166666667,
                "2026-05-09": 12.972728333333333,
                "2026-05-11": 0.652855,
                "2026-05-12": 2049.8015030555553,
                "2026-05-13": 2061.4253625,
                "2026-05-14": 18.530320555555555,
                "2026-05-15": 9.546603333333334,
                "2026-05-18": 1.5239872222222224,
                "2026-05-19": 0.20422,
                "2026-05-20": 0.1506222222222222,
                "2026-05-21": 1.2492502777777779,
                "2026-05-22": 9.365271944444444,
                "2026-05-26": 37.35865611111112,
                "2026-05-28": 0.28647694444444444,
                "2026-05-29": 17.57522277777778,
                "2026-06-01": 0.14561833333333332,
                "2026-06-02": 20.18678555555556,
                "2026-06-03": 11.907903333333334,
                "2026-06-05": 103.68516277777778,
                "2026-06-08": 6.996417777777778
              },
              "time_count_per_day": {
                "2025-10-15": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-02": 1,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2026-01-05": 1,
                "2026-01-14": 1,
                "2026-01-27": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-12": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-19": 3,
                "2026-02-20": 1,
                "2026-02-27": 1,
                "2026-02-28": 1,
                "2026-03-02": 1,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-09": 2,
                "2026-03-10": 4,
                "2026-03-12": 2,
                "2026-03-19": 2,
                "2026-03-20": 4,
                "2026-03-23": 2,
                "2026-03-26": 2,
                "2026-04-06": 2,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-10": 3,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-04-22": 2,
                "2026-04-24": 4,
                "2026-04-27": 1,
                "2026-04-28": 1,
                "2026-04-29": 6,
                "2026-04-30": 4,
                "2026-05-02": 2,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-09": 2,
                "2026-05-11": 2,
                "2026-05-12": 12,
                "2026-05-13": 1,
                "2026-05-14": 16,
                "2026-05-15": 2,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-21": 3,
                "2026-05-22": 5,
                "2026-05-26": 4,
                "2026-05-28": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 3,
                "2026-06-03": 3,
                "2026-06-05": 5,
                "2026-06-08": 5
              }
            },
            "P3": {
              "avg_time_hours": 306.86,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2,
                "26-28h": 1,
                "144-146h": 1,
                "150-152h": 1,
                "166-168h": 1,
                "308-310h": 1,
                "430-432h": 1,
                "1830-1832h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-10": 1,
                "2026-02-07": 1,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-12-02": 2.7117305555555555,
                "2025-12-10": 431.19249638888886,
                "2026-02-07": 2.790459166666667,
                "2026-02-10": 627.4781833333334,
                "2026-02-11": 0.3995883333333333,
                "2026-02-13": 172.16507083333335,
                "2026-02-16": 1831.8803725
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-10": 1,
                "2026-02-07": 1,
                "2026-02-10": 3,
                "2026-02-11": 1,
                "2026-02-13": 2,
                "2026-02-16": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 157.0,
              "mode_time_hours": 73.0,
              "mode_frequency": 4,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1,
                "8-10h": 1,
                "14-16h": 2,
                "16-18h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "26-28h": 1,
                "34-36h": 1,
                "36-38h": 2,
                "46-48h": 1,
                "48-50h": 1,
                "64-66h": 1,
                "72-74h": 4,
                "74-76h": 1,
                "78-80h": 4,
                "80-82h": 1,
                "94-96h": 1,
                "98-100h": 1,
                "104-106h": 2,
                "138-140h": 1,
                "146-148h": 2,
                "150-152h": 1,
                "156-158h": 1,
                "180-182h": 1,
                "182-184h": 2,
                "186-188h": 1,
                "192-194h": 1,
                "198-200h": 1,
                "202-204h": 1,
                "204-206h": 1,
                "206-208h": 2,
                "218-220h": 1,
                "240-242h": 1,
                "312-314h": 1,
                "358-360h": 1,
                "400-402h": 1,
                "412-414h": 1,
                "420-422h": 1,
                "424-426h": 1,
                "432-434h": 1,
                "446-448h": 1,
                "490-492h": 1,
                "500-502h": 1
              },
              "tickets_count": 57,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-20": 2,
                "2025-11-23": 1,
                "2025-11-24": 2,
                "2025-11-29": 2,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-05": 3,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-21": 1,
                "2026-02-28": 2,
                "2026-03-02": 1,
                "2026-03-17": 3,
                "2026-03-18": 15,
                "2026-03-20": 1,
                "2026-03-24": 3,
                "2026-03-30": 2,
                "2026-04-22": 5,
                "2026-04-27": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-11-12": 80.24346694444445,
                "2025-11-13": 73.68127638888888,
                "2025-11-20": 140.70189944444445,
                "2025-11-23": 35.12647472222222,
                "2025-11-24": 92.94015722222221,
                "2025-11-29": 159.77094083333333,
                "2026-01-26": 6.711571111111111,
                "2026-01-27": 55.754865555555554,
                "2026-01-30": 413.64857722222223,
                "2026-02-03": 139.7603961111111,
                "2026-02-05": 446.48530444444447,
                "2026-02-06": 450.64352166666663,
                "2026-02-10": 202.11476555555555,
                "2026-02-21": 3.4740744444444442,
                "2026-02-28": 147.8743388888889,
                "2026-03-02": 157.23687111111113,
                "2026-03-17": 196.1322572222222,
                "2026-03-18": 4970.225528333333,
                "2026-03-20": 46.54990472222222,
                "2026-03-24": 46.54857444444445,
                "2026-03-30": 146.89748305555554,
                "2026-04-22": 641.7088994444445,
                "2026-04-27": 95.15757555555555,
                "2026-06-06": 199.65363333333332
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-20": 2,
                "2025-11-23": 1,
                "2025-11-24": 2,
                "2025-11-29": 2,
                "2026-01-26": 1,
                "2026-01-27": 3,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-05": 3,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-21": 1,
                "2026-02-28": 2,
                "2026-03-02": 1,
                "2026-03-17": 3,
                "2026-03-18": 15,
                "2026-03-20": 1,
                "2026-03-24": 3,
                "2026-03-30": 2,
                "2026-04-22": 5,
                "2026-04-27": 1,
                "2026-06-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 508.77,
              "mode_time_hours": 577.0,
              "mode_frequency": 4,
              "time_distribution": {
                "74-76h": 1,
                "98-100h": 1,
                "284-286h": 1,
                "306-308h": 1,
                "336-338h": 1,
                "558-560h": 1,
                "568-570h": 1,
                "576-578h": 4,
                "668-670h": 1,
                "744-746h": 1,
                "814-816h": 1,
                "860-862h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-02-19": 12
              },
              "time_per_day": {
                "2025-12-19": 558.6822730555556,
                "2026-01-17": 98.643685,
                "2026-01-23": 75.05059138888889,
                "2026-02-19": 6899.244476666668
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-02-19": 12
              }
            }
          }
        },
        "Cuba Cancelado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-02-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Cuba Remarcado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 22,
            "tickets_per_day": {
              "2026-03-06": 2,
              "2026-03-10": 1,
              "2026-04-02": 1,
              "2026-04-09": 4,
              "2026-04-10": 2,
              "2026-04-20": 1,
              "2026-04-22": 2,
              "2026-04-27": 1,
              "2026-04-28": 2,
              "2026-05-18": 1,
              "2026-05-21": 3,
              "2026-05-22": 1,
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 22,
              "tickets_per_day": {
                "2026-03-06": 2,
                "2026-03-10": 1,
                "2026-04-02": 1,
                "2026-04-09": 4,
                "2026-04-10": 2,
                "2026-04-20": 1,
                "2026-04-22": 2,
                "2026-04-27": 1,
                "2026-04-28": 2,
                "2026-05-18": 1,
                "2026-05-21": 3,
                "2026-05-22": 1,
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-14": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-14": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 36,
            "tickets_per_day": {
              "2026-02-16": 4,
              "2026-05-12": 25,
              "2026-05-13": 3,
              "2026-05-14": 3,
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 36,
              "tickets_per_day": {
                "2026-02-16": 4,
                "2026-05-12": 25,
                "2026-05-13": 3,
                "2026-05-14": 3,
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-16": 2,
              "2026-03-19": 1,
              "2026-04-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-16": 2,
                "2026-03-19": 1,
                "2026-04-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_111": {
      "overall": {
        "avg_time_hours": 83.09,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "6-8h": 1,
          "10-12h": 2,
          "18-20h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "32-34h": 1,
          "70-72h": 2,
          "100-102h": 1,
          "114-116h": 1,
          "126-128h": 1,
          "146-148h": 1,
          "148-150h": 1,
          "188-190h": 1,
          "216-218h": 1,
          "248-250h": 1,
          "260-262h": 1
        },
        "tickets_count": 22,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2026-01-02": 1,
          "2026-01-07": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-19": 1,
          "2026-01-27": 1,
          "2026-02-11": 1,
          "2026-02-25": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-09": 1,
          "2026-03-20": 2,
          "2026-03-25": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-04-30": 1
        },
        "time_per_day": {
          "2025-10-23": 189.8681163888889,
          "2025-10-27": 10.591489166666666,
          "2025-11-10": 70.86863,
          "2025-11-11": 26.39227916666667,
          "2026-01-02": 0.10317583333333333,
          "2026-01-07": 115.34832305555555,
          "2026-01-14": 11.989598611111111,
          "2026-01-15": 21.686990555555553,
          "2026-01-19": 126.07056222222222,
          "2026-01-27": 100.6161438888889,
          "2026-02-11": 148.68617138888888,
          "2026-02-25": 18.943548333333336,
          "2026-03-05": 0.8624177777777778,
          "2026-03-07": 261.25927333333334,
          "2026-03-09": 6.385831944444444,
          "2026-03-20": 320.20038361111114,
          "2026-03-25": 217.10781583333332,
          "2026-04-22": 1.4064916666666667,
          "2026-04-28": 146.51736499999998,
          "2026-04-30": 33.03507583333333
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-10": 1,
          "2025-11-11": 1,
          "2026-01-02": 1,
          "2026-01-07": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-19": 1,
          "2026-01-27": 1,
          "2026-02-11": 1,
          "2026-02-25": 1,
          "2026-03-05": 1,
          "2026-03-07": 1,
          "2026-03-09": 1,
          "2026-03-20": 2,
          "2026-03-25": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-04-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 76.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "6-8h": 1,
            "10-12h": 2,
            "18-20h": 1,
            "26-28h": 1,
            "32-34h": 1,
            "70-72h": 2,
            "114-116h": 1,
            "126-128h": 1,
            "146-148h": 1,
            "148-150h": 1,
            "188-190h": 1,
            "216-218h": 1,
            "260-262h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2026-01-02": 1,
            "2026-01-07": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-05": 1,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-04-30": 1
          },
          "time_per_day": {
            "2025-10-23": 189.8681163888889,
            "2025-10-27": 10.591489166666666,
            "2025-11-10": 70.86863,
            "2025-11-11": 26.39227916666667,
            "2026-01-02": 0.10317583333333333,
            "2026-01-07": 115.34832305555555,
            "2026-01-14": 11.989598611111111,
            "2026-01-15": 0.6148780555555556,
            "2026-01-19": 126.07056222222222,
            "2026-02-11": 148.68617138888888,
            "2026-02-25": 18.943548333333336,
            "2026-03-05": 0.8624177777777778,
            "2026-03-07": 261.25927333333334,
            "2026-03-09": 6.385831944444444,
            "2026-03-20": 71.726445,
            "2026-03-25": 217.10781583333332,
            "2026-04-22": 1.4064916666666667,
            "2026-04-28": 146.51736499999998,
            "2026-04-30": 33.03507583333333
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-11-10": 1,
            "2025-11-11": 1,
            "2026-01-02": 1,
            "2026-01-07": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-05": 1,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-04-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 123.39,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "100-102h": 1,
            "248-250h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-01-15": 21.0721125,
            "2026-01-27": 100.6161438888889,
            "2026-03-20": 248.47393861111112
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-01-27": 1,
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 83.09,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "6-8h": 1,
              "10-12h": 2,
              "18-20h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "32-34h": 1,
              "70-72h": 2,
              "100-102h": 1,
              "114-116h": 1,
              "126-128h": 1,
              "146-148h": 1,
              "148-150h": 1,
              "188-190h": 1,
              "216-218h": 1,
              "248-250h": 1,
              "260-262h": 1
            },
            "tickets_count": 22,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2026-01-02": 1,
              "2026-01-07": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-19": 1,
              "2026-01-27": 1,
              "2026-02-11": 1,
              "2026-02-25": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-09": 1,
              "2026-03-20": 2,
              "2026-03-25": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-04-30": 1
            },
            "time_per_day": {
              "2025-10-23": 189.8681163888889,
              "2025-10-27": 10.591489166666666,
              "2025-11-10": 70.86863,
              "2025-11-11": 26.39227916666667,
              "2026-01-02": 0.10317583333333333,
              "2026-01-07": 115.34832305555555,
              "2026-01-14": 11.989598611111111,
              "2026-01-15": 21.686990555555553,
              "2026-01-19": 126.07056222222222,
              "2026-01-27": 100.6161438888889,
              "2026-02-11": 148.68617138888888,
              "2026-02-25": 18.943548333333336,
              "2026-03-05": 0.8624177777777778,
              "2026-03-07": 261.25927333333334,
              "2026-03-09": 6.385831944444444,
              "2026-03-20": 320.20038361111114,
              "2026-03-25": 217.10781583333332,
              "2026-04-22": 1.4064916666666667,
              "2026-04-28": 146.51736499999998,
              "2026-04-30": 33.03507583333333
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-10": 1,
              "2025-11-11": 1,
              "2026-01-02": 1,
              "2026-01-07": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-19": 1,
              "2026-01-27": 1,
              "2026-02-11": 1,
              "2026-02-25": 1,
              "2026-03-05": 1,
              "2026-03-07": 1,
              "2026-03-09": 1,
              "2026-03-20": 2,
              "2026-03-25": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-04-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 76.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "6-8h": 1,
                "10-12h": 2,
                "18-20h": 1,
                "26-28h": 1,
                "32-34h": 1,
                "70-72h": 2,
                "114-116h": 1,
                "126-128h": 1,
                "146-148h": 1,
                "148-150h": 1,
                "188-190h": 1,
                "216-218h": 1,
                "260-262h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2026-01-02": 1,
                "2026-01-07": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-05": 1,
                "2026-03-07": 1,
                "2026-03-09": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-04-30": 1
              },
              "time_per_day": {
                "2025-10-23": 189.8681163888889,
                "2025-10-27": 10.591489166666666,
                "2025-11-10": 70.86863,
                "2025-11-11": 26.39227916666667,
                "2026-01-02": 0.10317583333333333,
                "2026-01-07": 115.34832305555555,
                "2026-01-14": 11.989598611111111,
                "2026-01-15": 0.6148780555555556,
                "2026-01-19": 126.07056222222222,
                "2026-02-11": 148.68617138888888,
                "2026-02-25": 18.943548333333336,
                "2026-03-05": 0.8624177777777778,
                "2026-03-07": 261.25927333333334,
                "2026-03-09": 6.385831944444444,
                "2026-03-20": 71.726445,
                "2026-03-25": 217.10781583333332,
                "2026-04-22": 1.4064916666666667,
                "2026-04-28": 146.51736499999998,
                "2026-04-30": 33.03507583333333
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-11-10": 1,
                "2025-11-11": 1,
                "2026-01-02": 1,
                "2026-01-07": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-05": 1,
                "2026-03-07": 1,
                "2026-03-09": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-04-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 123.39,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "100-102h": 1,
                "248-250h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-01-15": 21.0721125,
                "2026-01-27": 100.6161438888889,
                "2026-03-20": 248.47393861111112
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-01-27": 1,
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_259": {
      "overall": {
        "avg_time_hours": 100.17,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 1,
          "6-8h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "40-42h": 1,
          "74-76h": 2,
          "98-100h": 1,
          "162-164h": 1,
          "334-336h": 1,
          "844-846h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-10-22": 1,
          "2025-11-17": 2,
          "2025-11-28": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-22": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-03-06": 1,
          "2026-04-06": 5,
          "2026-04-20": 1
        },
        "time_per_day": {
          "2025-10-22": 162.69139972222223,
          "2025-11-17": 173.33205555555557,
          "2025-11-28": 40.81485055555556,
          "2026-01-08": 0.14448916666666664,
          "2026-01-14": 0.20988027777777776,
          "2026-01-17": 17.646595833333333,
          "2026-01-22": 74.37804611111112,
          "2026-02-04": 334.6776536111111,
          "2026-02-10": 20.462651944444445,
          "2026-03-06": 19.602308333333333,
          "2026-04-06": 14.328930555555557,
          "2026-04-20": 844.6789738888889
        },
        "time_count_per_day": {
          "2025-10-22": 1,
          "2025-11-17": 2,
          "2025-11-28": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-22": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-03-06": 1,
          "2026-04-06": 5,
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 162.69,
          "mode_time_hours": 163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "162-164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-22": 1
          },
          "time_per_day": {
            "2025-10-22": 162.69139972222223
          },
          "time_count_per_day": {
            "2025-10-22": 1
          }
        },
        "P2": {
          "avg_time_hours": 44.37,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1,
            "6-8h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "40-42h": 1,
            "74-76h": 2,
            "334-336h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-28": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-22": 1,
            "2026-02-04": 1,
            "2026-03-06": 1,
            "2026-04-06": 5
          },
          "time_per_day": {
            "2025-11-17": 74.95170833333334,
            "2025-11-28": 40.81485055555556,
            "2026-01-08": 0.14448916666666664,
            "2026-01-14": 0.20988027777777776,
            "2026-01-17": 17.646595833333333,
            "2026-01-22": 74.37804611111112,
            "2026-02-04": 334.6776536111111,
            "2026-03-06": 19.602308333333333,
            "2026-04-06": 14.328930555555557
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-28": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-22": 1,
            "2026-02-04": 1,
            "2026-03-06": 1,
            "2026-04-06": 5
          }
        },
        "P3": {
          "avg_time_hours": 321.17,
          "mode_time_hours": 99.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "98-100h": 1,
            "844-846h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-02-10": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2025-11-17": 98.38034722222223,
            "2026-02-10": 20.462651944444445,
            "2026-04-20": 844.6789738888889
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-02-10": 1,
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 100.17,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 1,
              "6-8h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "40-42h": 1,
              "74-76h": 2,
              "98-100h": 1,
              "162-164h": 1,
              "334-336h": 1,
              "844-846h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-10-22": 1,
              "2025-11-17": 2,
              "2025-11-28": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-22": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-03-06": 1,
              "2026-04-06": 5,
              "2026-04-20": 1
            },
            "time_per_day": {
              "2025-10-22": 162.69139972222223,
              "2025-11-17": 173.33205555555557,
              "2025-11-28": 40.81485055555556,
              "2026-01-08": 0.14448916666666664,
              "2026-01-14": 0.20988027777777776,
              "2026-01-17": 17.646595833333333,
              "2026-01-22": 74.37804611111112,
              "2026-02-04": 334.6776536111111,
              "2026-02-10": 20.462651944444445,
              "2026-03-06": 19.602308333333333,
              "2026-04-06": 14.328930555555557,
              "2026-04-20": 844.6789738888889
            },
            "time_count_per_day": {
              "2025-10-22": 1,
              "2025-11-17": 2,
              "2025-11-28": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-22": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-03-06": 1,
              "2026-04-06": 5,
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 162.69,
              "mode_time_hours": 163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "162-164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-22": 1
              },
              "time_per_day": {
                "2025-10-22": 162.69139972222223
              },
              "time_count_per_day": {
                "2025-10-22": 1
              }
            },
            "P2": {
              "avg_time_hours": 44.37,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1,
                "6-8h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "40-42h": 1,
                "74-76h": 2,
                "334-336h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-28": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-22": 1,
                "2026-02-04": 1,
                "2026-03-06": 1,
                "2026-04-06": 5
              },
              "time_per_day": {
                "2025-11-17": 74.95170833333334,
                "2025-11-28": 40.81485055555556,
                "2026-01-08": 0.14448916666666664,
                "2026-01-14": 0.20988027777777776,
                "2026-01-17": 17.646595833333333,
                "2026-01-22": 74.37804611111112,
                "2026-02-04": 334.6776536111111,
                "2026-03-06": 19.602308333333333,
                "2026-04-06": 14.328930555555557
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-28": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-22": 1,
                "2026-02-04": 1,
                "2026-03-06": 1,
                "2026-04-06": 5
              }
            },
            "P3": {
              "avg_time_hours": 321.17,
              "mode_time_hours": 99.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "98-100h": 1,
                "844-846h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-02-10": 1,
                "2026-04-20": 1
              },
              "time_per_day": {
                "2025-11-17": 98.38034722222223,
                "2026-02-10": 20.462651944444445,
                "2026-04-20": 844.6789738888889
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-02-10": 1,
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_239": {
      "overall": {
        "avg_time_hours": 14.96,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "4-6h": 1,
          "6-8h": 1,
          "12-14h": 1,
          "94-96h": 1,
          "170-172h": 1
        },
        "tickets_count": 22,
        "tickets_per_day": {
          "2025-10-20": 1,
          "2025-10-29": 1,
          "2025-11-13": 1,
          "2026-01-05": 1,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-11": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-05-02": 1,
          "2026-05-09": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-29": 4
        },
        "time_per_day": {
          "2025-10-20": 94.13243416666666,
          "2025-10-29": 7.669025277777778,
          "2025-11-13": 0.9049438888888889,
          "2026-01-05": 170.7457136111111,
          "2026-03-03": 6.001200555555556,
          "2026-03-04": 12.65282111111111,
          "2026-03-11": 0.2867969444444445,
          "2026-03-31": 0.6561825,
          "2026-04-08": 1.229389722222222,
          "2026-04-16": 0.9026130555555556,
          "2026-04-21": 0.2135022222222222,
          "2026-04-22": 0.06066888888888888,
          "2026-05-02": 1.4215694444444444,
          "2026-05-09": 1.4334013888888888,
          "2026-05-29": 0.9206691666666666
        },
        "time_count_per_day": {
          "2025-10-20": 1,
          "2025-10-29": 1,
          "2025-11-13": 1,
          "2026-01-05": 1,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-11": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-05-02": 1,
          "2026-05-09": 1,
          "2026-05-29": 4
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 15.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 14,
          "time_distribution": {
            "0-2h": 14,
            "4-6h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "94-96h": 1,
            "170-172h": 1
          },
          "tickets_count": 21,
          "tickets_per_day": {
            "2025-10-20": 1,
            "2025-10-29": 1,
            "2026-01-05": 1,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-11": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-05-02": 1,
            "2026-05-09": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-29": 4
          },
          "time_per_day": {
            "2025-10-20": 94.13243416666666,
            "2025-10-29": 7.669025277777778,
            "2026-01-05": 170.7457136111111,
            "2026-03-03": 6.001200555555556,
            "2026-03-04": 12.65282111111111,
            "2026-03-11": 0.2867969444444445,
            "2026-03-31": 0.6561825,
            "2026-04-08": 1.229389722222222,
            "2026-04-16": 0.9026130555555556,
            "2026-04-21": 0.2135022222222222,
            "2026-04-22": 0.06066888888888888,
            "2026-05-02": 1.4215694444444444,
            "2026-05-09": 1.4334013888888888,
            "2026-05-29": 0.9206691666666666
          },
          "time_count_per_day": {
            "2025-10-20": 1,
            "2025-10-29": 1,
            "2026-01-05": 1,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-11": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-05-02": 1,
            "2026-05-09": 1,
            "2026-05-29": 4
          }
        },
        "P3": {
          "avg_time_hours": 0.9,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 0.9049438888888889
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.96,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "4-6h": 1,
              "6-8h": 1,
              "12-14h": 1,
              "94-96h": 1,
              "170-172h": 1
            },
            "tickets_count": 20,
            "tickets_per_day": {
              "2025-10-20": 1,
              "2025-10-29": 1,
              "2025-11-13": 1,
              "2026-01-05": 1,
              "2026-03-03": 2,
              "2026-03-04": 2,
              "2026-03-11": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-05-02": 1,
              "2026-05-09": 1,
              "2026-05-29": 4
            },
            "time_per_day": {
              "2025-10-20": 94.13243416666666,
              "2025-10-29": 7.669025277777778,
              "2025-11-13": 0.9049438888888889,
              "2026-01-05": 170.7457136111111,
              "2026-03-03": 6.001200555555556,
              "2026-03-04": 12.65282111111111,
              "2026-03-11": 0.2867969444444445,
              "2026-03-31": 0.6561825,
              "2026-04-08": 1.229389722222222,
              "2026-04-16": 0.9026130555555556,
              "2026-04-21": 0.2135022222222222,
              "2026-04-22": 0.06066888888888888,
              "2026-05-02": 1.4215694444444444,
              "2026-05-09": 1.4334013888888888,
              "2026-05-29": 0.9206691666666666
            },
            "time_count_per_day": {
              "2025-10-20": 1,
              "2025-10-29": 1,
              "2025-11-13": 1,
              "2026-01-05": 1,
              "2026-03-03": 2,
              "2026-03-04": 2,
              "2026-03-11": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-05-02": 1,
              "2026-05-09": 1,
              "2026-05-29": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 15.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 14,
              "time_distribution": {
                "0-2h": 14,
                "4-6h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "94-96h": 1,
                "170-172h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-20": 1,
                "2025-10-29": 1,
                "2026-01-05": 1,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-11": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-05-02": 1,
                "2026-05-09": 1,
                "2026-05-29": 4
              },
              "time_per_day": {
                "2025-10-20": 94.13243416666666,
                "2025-10-29": 7.669025277777778,
                "2026-01-05": 170.7457136111111,
                "2026-03-03": 6.001200555555556,
                "2026-03-04": 12.65282111111111,
                "2026-03-11": 0.2867969444444445,
                "2026-03-31": 0.6561825,
                "2026-04-08": 1.229389722222222,
                "2026-04-16": 0.9026130555555556,
                "2026-04-21": 0.2135022222222222,
                "2026-04-22": 0.06066888888888888,
                "2026-05-02": 1.4215694444444444,
                "2026-05-09": 1.4334013888888888,
                "2026-05-29": 0.9206691666666666
              },
              "time_count_per_day": {
                "2025-10-20": 1,
                "2025-10-29": 1,
                "2026-01-05": 1,
                "2026-03-03": 2,
                "2026-03-04": 2,
                "2026-03-11": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-05-02": 1,
                "2026-05-09": 1,
                "2026-05-29": 4
              }
            },
            "P3": {
              "avg_time_hours": 0.9,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 0.9049438888888889
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_264": {
      "overall": {
        "avg_time_hours": 1.35,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-16": 1
        },
        "time_per_day": {
          "2025-10-16": 1.3490416666666667
        },
        "time_count_per_day": {
          "2025-10-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.35,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-16": 1
          },
          "time_per_day": {
            "2025-10-16": 1.3490416666666667
          },
          "time_count_per_day": {
            "2025-10-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.35,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-16": 1
            },
            "time_per_day": {
              "2025-10-16": 1.3490416666666667
            },
            "time_count_per_day": {
              "2025-10-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.35,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-16": 1
              },
              "time_per_day": {
                "2025-10-16": 1.3490416666666667
              },
              "time_count_per_day": {
                "2025-10-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_265": {
      "overall": {
        "avg_time_hours": 5.76,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-16": 1
        },
        "time_per_day": {
          "2025-10-16": 5.763598888888889
        },
        "time_count_per_day": {
          "2025-10-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.76,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-16": 1
          },
          "time_per_day": {
            "2025-10-16": 5.763598888888889
          },
          "time_count_per_day": {
            "2025-10-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.76,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-16": 1
            },
            "time_per_day": {
              "2025-10-16": 5.763598888888889
            },
            "time_count_per_day": {
              "2025-10-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.76,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-16": 1
              },
              "time_per_day": {
                "2025-10-16": 5.763598888888889
              },
              "time_count_per_day": {
                "2025-10-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_272": {
      "overall": {
        "avg_time_hours": 24.46,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-18": 1
        },
        "time_per_day": {
          "2025-10-18": 24.458301388888888
        },
        "time_count_per_day": {
          "2025-10-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.46,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-18": 1
          },
          "time_per_day": {
            "2025-10-18": 24.458301388888888
          },
          "time_count_per_day": {
            "2025-10-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.46,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-18": 1
            },
            "time_per_day": {
              "2025-10-18": 24.458301388888888
            },
            "time_count_per_day": {
              "2025-10-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.46,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-18": 1
              },
              "time_per_day": {
                "2025-10-18": 24.458301388888888
              },
              "time_count_per_day": {
                "2025-10-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_274": {
      "overall": {
        "avg_time_hours": 3.69,
        "mode_time_hours": 3.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 4,
          "14-16h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-17": 2,
          "2025-10-21": 1,
          "2025-10-27": 2,
          "2026-01-07": 1,
          "2026-01-28": 1
        },
        "time_per_day": {
          "2025-10-17": 0.49243305555555555,
          "2025-10-21": 2.417156388888889,
          "2025-10-27": 5.349748611111111,
          "2026-01-07": 14.922077222222223,
          "2026-01-28": 2.6334311111111113
        },
        "time_count_per_day": {
          "2025-10-17": 2,
          "2025-10-21": 1,
          "2025-10-27": 2,
          "2026-01-07": 1,
          "2026-01-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.69,
          "mode_time_hours": 3.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 4,
            "14-16h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-17": 2,
            "2025-10-21": 1,
            "2025-10-27": 2,
            "2026-01-07": 1,
            "2026-01-28": 1
          },
          "time_per_day": {
            "2025-10-17": 0.49243305555555555,
            "2025-10-21": 2.417156388888889,
            "2025-10-27": 5.349748611111111,
            "2026-01-07": 14.922077222222223,
            "2026-01-28": 2.6334311111111113
          },
          "time_count_per_day": {
            "2025-10-17": 2,
            "2025-10-21": 1,
            "2025-10-27": 2,
            "2026-01-07": 1,
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.69,
            "mode_time_hours": 3.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 4,
              "14-16h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-17": 2,
              "2025-10-21": 1,
              "2025-10-27": 2,
              "2026-01-07": 1,
              "2026-01-28": 1
            },
            "time_per_day": {
              "2025-10-17": 0.49243305555555555,
              "2025-10-21": 2.417156388888889,
              "2025-10-27": 5.349748611111111,
              "2026-01-07": 14.922077222222223,
              "2026-01-28": 2.6334311111111113
            },
            "time_count_per_day": {
              "2025-10-17": 2,
              "2025-10-21": 1,
              "2025-10-27": 2,
              "2026-01-07": 1,
              "2026-01-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.69,
              "mode_time_hours": 3.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 4,
                "14-16h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-17": 2,
                "2025-10-21": 1,
                "2025-10-27": 2,
                "2026-01-07": 1,
                "2026-01-28": 1
              },
              "time_per_day": {
                "2025-10-17": 0.49243305555555555,
                "2025-10-21": 2.417156388888889,
                "2025-10-27": 5.349748611111111,
                "2026-01-07": 14.922077222222223,
                "2026-01-28": 2.6334311111111113
              },
              "time_count_per_day": {
                "2025-10-17": 2,
                "2025-10-21": 1,
                "2025-10-27": 2,
                "2026-01-07": 1,
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_273": {
      "overall": {
        "avg_time_hours": 126.38,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 1,
          "4-6h": 1,
          "8-10h": 1,
          "14-16h": 1,
          "18-20h": 3,
          "20-22h": 3,
          "22-24h": 1,
          "26-28h": 1,
          "30-32h": 1,
          "32-34h": 2,
          "40-42h": 1,
          "42-44h": 1,
          "44-46h": 1,
          "46-48h": 1,
          "50-52h": 1,
          "52-54h": 1,
          "74-76h": 2,
          "84-86h": 1,
          "96-98h": 1,
          "106-108h": 1,
          "126-128h": 1,
          "138-140h": 1,
          "140-142h": 3,
          "192-194h": 1,
          "212-214h": 1,
          "298-300h": 1,
          "304-306h": 1,
          "392-394h": 1,
          "430-432h": 1,
          "456-458h": 1,
          "496-498h": 1,
          "702-704h": 1,
          "984-986h": 1
        },
        "tickets_count": 52,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-10-24": 1,
          "2025-10-31": 1,
          "2025-11-05": 1,
          "2025-11-10": 1,
          "2025-11-26": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-19": 1,
          "2026-01-29": 1,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-21": 1,
          "2026-03-06": 1,
          "2026-03-11": 2,
          "2026-03-14": 2,
          "2026-03-25": 2,
          "2026-03-26": 1,
          "2026-03-28": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-04-30": 2,
          "2026-05-05": 2,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-28": 2,
          "2026-06-02": 2,
          "2026-06-03": 2,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-23": 139.70843166666666,
          "2025-10-24": 22.375565555555553,
          "2025-10-31": 1.7546097222222223,
          "2025-11-05": 52.729326944444445,
          "2025-11-10": 96.90204194444445,
          "2025-11-26": 41.832235833333336,
          "2025-12-03": 305.4125719444445,
          "2025-12-05": 45.929295277777776,
          "2026-01-09": 2.1208294444444444,
          "2026-01-13": 26.468559722222224,
          "2026-01-15": 32.439935,
          "2026-01-16": 161.2465325,
          "2026-01-19": 85.36284583333334,
          "2026-01-29": 5.7223436111111114,
          "2026-02-03": 149.1080636111111,
          "2026-02-05": 141.78444333333334,
          "2026-02-10": 31.501046111111112,
          "2026-02-12": 18.27774027777778,
          "2026-02-18": 50.374495833333334,
          "2026-02-21": 192.8965561111111,
          "2026-03-06": 141.698755,
          "2026-03-11": 394.7212130555556,
          "2026-03-14": 35.46438611111111,
          "2026-03-25": 888.1792,
          "2026-03-26": 496.70003499999996,
          "2026-03-28": 1.3170266666666666,
          "2026-04-09": 299.6190652777778,
          "2026-04-10": 984.2554141666667,
          "2026-04-11": 213.39262638888889,
          "2026-04-16": 126.36274499999999,
          "2026-04-23": 703.6891208333333,
          "2026-04-30": 64.21241083333334,
          "2026-05-05": 40.40764444444444,
          "2026-05-19": 0.9304061111111112,
          "2026-05-21": 19.728247777777778,
          "2026-05-26": 0.8387891666666667,
          "2026-05-28": 21.344079999999998,
          "2026-06-02": 1.2419133333333332,
          "2026-06-03": 154.01793444444445,
          "2026-06-05": 0.40986361111111114
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-10-24": 1,
          "2025-10-31": 1,
          "2025-11-05": 1,
          "2025-11-10": 1,
          "2025-11-26": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-19": 1,
          "2026-01-29": 1,
          "2026-02-03": 2,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-21": 1,
          "2026-03-06": 1,
          "2026-03-11": 2,
          "2026-03-14": 2,
          "2026-03-25": 2,
          "2026-03-26": 1,
          "2026-03-28": 2,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-04-30": 2,
          "2026-05-05": 2,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-06-02": 1,
          "2026-06-03": 2,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 141.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 1,
            "32-34h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "46-48h": 1,
            "52-54h": 1,
            "74-76h": 1,
            "84-86h": 1,
            "96-98h": 1,
            "106-108h": 1,
            "126-128h": 1,
            "138-140h": 1,
            "140-142h": 2,
            "192-194h": 1,
            "298-300h": 1,
            "392-394h": 1,
            "430-432h": 1,
            "456-458h": 1,
            "496-498h": 1,
            "702-704h": 1,
            "984-986h": 1
          },
          "tickets_count": 39,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-10-31": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-26": 1,
            "2025-12-05": 1,
            "2026-01-09": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-21": 1,
            "2026-03-06": 1,
            "2026-03-11": 2,
            "2026-03-14": 1,
            "2026-03-25": 2,
            "2026-03-26": 1,
            "2026-03-28": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-04-30": 2,
            "2026-05-05": 2,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-28": 1,
            "2026-06-02": 2,
            "2026-06-03": 2,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-23": 139.70843166666666,
            "2025-10-24": 22.375565555555553,
            "2025-10-31": 1.7546097222222223,
            "2025-11-05": 52.729326944444445,
            "2025-11-10": 96.90204194444445,
            "2025-11-26": 41.832235833333336,
            "2025-12-05": 45.929295277777776,
            "2026-01-09": 2.1208294444444444,
            "2026-01-16": 140.317765,
            "2026-01-19": 85.36284583333334,
            "2026-02-03": 74.51728194444445,
            "2026-02-21": 192.8965561111111,
            "2026-03-06": 141.698755,
            "2026-03-11": 394.7212130555556,
            "2026-03-14": 15.61801611111111,
            "2026-03-25": 888.1792,
            "2026-03-26": 496.70003499999996,
            "2026-03-28": 1.3170266666666666,
            "2026-04-09": 299.6190652777778,
            "2026-04-10": 984.2554141666667,
            "2026-04-16": 126.36274499999999,
            "2026-04-23": 703.6891208333333,
            "2026-04-30": 64.21241083333334,
            "2026-05-05": 40.40764444444444,
            "2026-05-19": 0.9304061111111112,
            "2026-05-21": 19.728247777777778,
            "2026-05-26": 0.8387891666666667,
            "2026-05-28": 21.344079999999998,
            "2026-06-02": 1.2419133333333332,
            "2026-06-03": 154.01793444444445,
            "2026-06-05": 0.40986361111111114
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-10-24": 1,
            "2025-10-31": 1,
            "2025-11-05": 1,
            "2025-11-10": 1,
            "2025-11-26": 1,
            "2025-12-05": 1,
            "2026-01-09": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-03": 1,
            "2026-02-21": 1,
            "2026-03-06": 1,
            "2026-03-11": 2,
            "2026-03-14": 1,
            "2026-03-25": 2,
            "2026-03-26": 1,
            "2026-03-28": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-04-30": 2,
            "2026-05-05": 2,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-28": 1,
            "2026-06-02": 1,
            "2026-06-03": 2,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 62.86,
          "mode_time_hours": 305.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "26-28h": 1,
            "30-32h": 1,
            "32-34h": 1,
            "50-52h": 1,
            "74-76h": 1,
            "304-306h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-12-03": 305.4125719444445,
            "2026-01-13": 26.468559722222224,
            "2026-01-15": 32.439935,
            "2026-01-16": 20.9287675,
            "2026-01-29": 5.7223436111111114,
            "2026-02-03": 74.59078166666667,
            "2026-02-10": 31.501046111111112,
            "2026-02-12": 18.27774027777778,
            "2026-02-18": 50.374495833333334
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-12": 1,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 125.01,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "140-142h": 1,
            "212-214h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-05": 1,
            "2026-03-14": 1,
            "2026-04-11": 1
          },
          "time_per_day": {
            "2026-02-05": 141.78444333333334,
            "2026-03-14": 19.84637,
            "2026-04-11": 213.39262638888889
          },
          "time_count_per_day": {
            "2026-02-05": 1,
            "2026-03-14": 1,
            "2026-04-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 126.38,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 1,
              "4-6h": 1,
              "8-10h": 1,
              "14-16h": 1,
              "18-20h": 3,
              "20-22h": 3,
              "22-24h": 1,
              "26-28h": 1,
              "30-32h": 1,
              "32-34h": 2,
              "40-42h": 1,
              "42-44h": 1,
              "44-46h": 1,
              "46-48h": 1,
              "50-52h": 1,
              "52-54h": 1,
              "74-76h": 2,
              "84-86h": 1,
              "96-98h": 1,
              "106-108h": 1,
              "126-128h": 1,
              "138-140h": 1,
              "140-142h": 3,
              "192-194h": 1,
              "212-214h": 1,
              "298-300h": 1,
              "304-306h": 1,
              "392-394h": 1,
              "430-432h": 1,
              "456-458h": 1,
              "496-498h": 1,
              "702-704h": 1,
              "984-986h": 1
            },
            "tickets_count": 49,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-10-24": 1,
              "2025-10-31": 1,
              "2025-11-05": 1,
              "2025-11-10": 1,
              "2025-11-26": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-19": 1,
              "2026-01-29": 1,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-21": 1,
              "2026-03-06": 1,
              "2026-03-11": 2,
              "2026-03-14": 2,
              "2026-03-25": 2,
              "2026-03-26": 1,
              "2026-03-28": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-30": 2,
              "2026-05-05": 2,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-23": 139.70843166666666,
              "2025-10-24": 22.375565555555553,
              "2025-10-31": 1.7546097222222223,
              "2025-11-05": 52.729326944444445,
              "2025-11-10": 96.90204194444445,
              "2025-11-26": 41.832235833333336,
              "2025-12-03": 305.4125719444445,
              "2025-12-05": 45.929295277777776,
              "2026-01-09": 2.1208294444444444,
              "2026-01-13": 26.468559722222224,
              "2026-01-15": 32.439935,
              "2026-01-16": 161.2465325,
              "2026-01-19": 85.36284583333334,
              "2026-01-29": 5.7223436111111114,
              "2026-02-03": 149.1080636111111,
              "2026-02-05": 141.78444333333334,
              "2026-02-10": 31.501046111111112,
              "2026-02-12": 18.27774027777778,
              "2026-02-18": 50.374495833333334,
              "2026-02-21": 192.8965561111111,
              "2026-03-06": 141.698755,
              "2026-03-11": 394.7212130555556,
              "2026-03-14": 35.46438611111111,
              "2026-03-25": 888.1792,
              "2026-03-26": 496.70003499999996,
              "2026-03-28": 1.3170266666666666,
              "2026-04-09": 299.6190652777778,
              "2026-04-10": 984.2554141666667,
              "2026-04-11": 213.39262638888889,
              "2026-04-16": 126.36274499999999,
              "2026-04-23": 703.6891208333333,
              "2026-04-30": 64.21241083333334,
              "2026-05-05": 40.40764444444444,
              "2026-05-19": 0.9304061111111112,
              "2026-05-21": 19.728247777777778,
              "2026-05-26": 0.8387891666666667,
              "2026-05-28": 21.344079999999998,
              "2026-06-02": 1.2419133333333332,
              "2026-06-03": 154.01793444444445,
              "2026-06-05": 0.40986361111111114
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-10-24": 1,
              "2025-10-31": 1,
              "2025-11-05": 1,
              "2025-11-10": 1,
              "2025-11-26": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-19": 1,
              "2026-01-29": 1,
              "2026-02-03": 2,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-21": 1,
              "2026-03-06": 1,
              "2026-03-11": 2,
              "2026-03-14": 2,
              "2026-03-25": 2,
              "2026-03-26": 1,
              "2026-03-28": 2,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-11": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-30": 2,
              "2026-05-05": 2,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-06-02": 1,
              "2026-06-03": 2,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 141.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 1,
                "32-34h": 1,
                "40-42h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "46-48h": 1,
                "52-54h": 1,
                "74-76h": 1,
                "84-86h": 1,
                "96-98h": 1,
                "106-108h": 1,
                "126-128h": 1,
                "138-140h": 1,
                "140-142h": 2,
                "192-194h": 1,
                "298-300h": 1,
                "392-394h": 1,
                "430-432h": 1,
                "456-458h": 1,
                "496-498h": 1,
                "702-704h": 1,
                "984-986h": 1
              },
              "tickets_count": 37,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-10-31": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-26": 1,
                "2025-12-05": 1,
                "2026-01-09": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-21": 1,
                "2026-03-06": 1,
                "2026-03-11": 2,
                "2026-03-14": 1,
                "2026-03-25": 2,
                "2026-03-26": 1,
                "2026-03-28": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-30": 2,
                "2026-05-05": 2,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-28": 1,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-23": 139.70843166666666,
                "2025-10-24": 22.375565555555553,
                "2025-10-31": 1.7546097222222223,
                "2025-11-05": 52.729326944444445,
                "2025-11-10": 96.90204194444445,
                "2025-11-26": 41.832235833333336,
                "2025-12-05": 45.929295277777776,
                "2026-01-09": 2.1208294444444444,
                "2026-01-16": 140.317765,
                "2026-01-19": 85.36284583333334,
                "2026-02-03": 74.51728194444445,
                "2026-02-21": 192.8965561111111,
                "2026-03-06": 141.698755,
                "2026-03-11": 394.7212130555556,
                "2026-03-14": 15.61801611111111,
                "2026-03-25": 888.1792,
                "2026-03-26": 496.70003499999996,
                "2026-03-28": 1.3170266666666666,
                "2026-04-09": 299.6190652777778,
                "2026-04-10": 984.2554141666667,
                "2026-04-16": 126.36274499999999,
                "2026-04-23": 703.6891208333333,
                "2026-04-30": 64.21241083333334,
                "2026-05-05": 40.40764444444444,
                "2026-05-19": 0.9304061111111112,
                "2026-05-21": 19.728247777777778,
                "2026-05-26": 0.8387891666666667,
                "2026-05-28": 21.344079999999998,
                "2026-06-02": 1.2419133333333332,
                "2026-06-03": 154.01793444444445,
                "2026-06-05": 0.40986361111111114
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-10-24": 1,
                "2025-10-31": 1,
                "2025-11-05": 1,
                "2025-11-10": 1,
                "2025-11-26": 1,
                "2025-12-05": 1,
                "2026-01-09": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-03": 1,
                "2026-02-21": 1,
                "2026-03-06": 1,
                "2026-03-11": 2,
                "2026-03-14": 1,
                "2026-03-25": 2,
                "2026-03-26": 1,
                "2026-03-28": 2,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-30": 2,
                "2026-05-05": 2,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-28": 1,
                "2026-06-02": 1,
                "2026-06-03": 2,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 62.86,
              "mode_time_hours": 305.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "26-28h": 1,
                "30-32h": 1,
                "32-34h": 1,
                "50-52h": 1,
                "74-76h": 1,
                "304-306h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-12-03": 305.4125719444445,
                "2026-01-13": 26.468559722222224,
                "2026-01-15": 32.439935,
                "2026-01-16": 20.9287675,
                "2026-01-29": 5.7223436111111114,
                "2026-02-03": 74.59078166666667,
                "2026-02-10": 31.501046111111112,
                "2026-02-12": 18.27774027777778,
                "2026-02-18": 50.374495833333334
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-12": 1,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 125.01,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "140-142h": 1,
                "212-214h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-05": 1,
                "2026-03-14": 1,
                "2026-04-11": 1
              },
              "time_per_day": {
                "2026-02-05": 141.78444333333334,
                "2026-03-14": 19.84637,
                "2026-04-11": 213.39262638888889
              },
              "time_count_per_day": {
                "2026-02-05": 1,
                "2026-03-14": 1,
                "2026-04-11": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-28": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_275": {
      "overall": {
        "avg_time_hours": 13.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 2,
          "70-72h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-10-17": 1,
          "2025-10-27": 1,
          "2025-11-03": 2,
          "2026-02-02": 1,
          "2026-05-14": 1
        },
        "time_per_day": {
          "2025-10-17": 3.245453055555555,
          "2025-10-27": 0.5014519444444445,
          "2025-11-03": 73.3663038888889,
          "2026-02-02": 2.348363611111111,
          "2026-05-14": 0.19803166666666666
        },
        "time_count_per_day": {
          "2025-10-17": 1,
          "2025-10-27": 1,
          "2025-11-03": 2,
          "2026-02-02": 1,
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 15.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "70-72h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-17": 1,
            "2025-10-27": 1,
            "2025-11-03": 2,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-10-17": 3.245453055555555,
            "2025-10-27": 0.5014519444444445,
            "2025-11-03": 73.3663038888889,
            "2026-05-14": 0.19803166666666666
          },
          "time_count_per_day": {
            "2025-10-17": 1,
            "2025-10-27": 1,
            "2025-11-03": 2,
            "2026-05-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 2.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 2.348363611111111
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 2,
              "70-72h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-17": 1,
              "2025-10-27": 1,
              "2025-11-03": 2,
              "2026-02-02": 1,
              "2026-05-14": 1
            },
            "time_per_day": {
              "2025-10-17": 3.245453055555555,
              "2025-10-27": 0.5014519444444445,
              "2025-11-03": 73.3663038888889,
              "2026-02-02": 2.348363611111111,
              "2026-05-14": 0.19803166666666666
            },
            "time_count_per_day": {
              "2025-10-17": 1,
              "2025-10-27": 1,
              "2025-11-03": 2,
              "2026-02-02": 1,
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 15.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "70-72h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-17": 1,
                "2025-10-27": 1,
                "2025-11-03": 2,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-10-17": 3.245453055555555,
                "2025-10-27": 0.5014519444444445,
                "2025-11-03": 73.3663038888889,
                "2026-05-14": 0.19803166666666666
              },
              "time_count_per_day": {
                "2025-10-17": 1,
                "2025-10-27": 1,
                "2025-11-03": 2,
                "2026-05-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 2.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 2.348363611111111
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_281": {
      "overall": {
        "avg_time_hours": 186.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "22-24h": 1,
          "158-160h": 1,
          "566-568h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-17": 1,
          "2025-12-11": 1,
          "2025-12-29": 1,
          "2026-02-19": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-17": 0.029785,
          "2025-12-11": 22.036226666666664,
          "2025-12-29": 159.5571613888889,
          "2026-02-19": 566.1556411111111
        },
        "time_count_per_day": {
          "2025-10-17": 1,
          "2025-12-11": 1,
          "2025-12-29": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 60.54,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1,
            "158-160h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-17": 1,
            "2025-12-11": 1,
            "2025-12-29": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-17": 0.029785,
            "2025-12-11": 22.036226666666664,
            "2025-12-29": 159.5571613888889
          },
          "time_count_per_day": {
            "2025-10-17": 1,
            "2025-12-11": 1,
            "2025-12-29": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 566.16,
          "mode_time_hours": 567.0,
          "mode_frequency": 1,
          "time_distribution": {
            "566-568h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 566.1556411111111
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 186.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "22-24h": 1,
              "158-160h": 1,
              "566-568h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-17": 1,
              "2025-12-11": 1,
              "2025-12-29": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2025-10-17": 0.029785,
              "2025-12-11": 22.036226666666664,
              "2025-12-29": 159.5571613888889,
              "2026-02-19": 566.1556411111111
            },
            "time_count_per_day": {
              "2025-10-17": 1,
              "2025-12-11": 1,
              "2025-12-29": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 60.54,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1,
                "158-160h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-17": 1,
                "2025-12-11": 1,
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-10-17": 0.029785,
                "2025-12-11": 22.036226666666664,
                "2025-12-29": 159.5571613888889
              },
              "time_count_per_day": {
                "2025-10-17": 1,
                "2025-12-11": 1,
                "2025-12-29": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 566.16,
              "mode_time_hours": 567.0,
              "mode_frequency": 1,
              "time_distribution": {
                "566-568h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 566.1556411111111
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_283": {
      "overall": {
        "avg_time_hours": 384.51,
        "mode_time_hours": 385.0,
        "mode_frequency": 1,
        "time_distribution": {
          "384-386h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-04": 1
        },
        "time_per_day": {
          "2025-11-04": 384.508065
        },
        "time_count_per_day": {
          "2025-11-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 384.51,
          "mode_time_hours": 385.0,
          "mode_frequency": 1,
          "time_distribution": {
            "384-386h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-11-04": 384.508065
          },
          "time_count_per_day": {
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 384.51,
            "mode_time_hours": 385.0,
            "mode_frequency": 1,
            "time_distribution": {
              "384-386h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-04": 1
            },
            "time_per_day": {
              "2025-11-04": 384.508065
            },
            "time_count_per_day": {
              "2025-11-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 384.51,
              "mode_time_hours": 385.0,
              "mode_frequency": 1,
              "time_distribution": {
                "384-386h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-11-04": 384.508065
              },
              "time_count_per_day": {
                "2025-11-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_285": {
      "overall": {
        "avg_time_hours": 46.82,
        "mode_time_hours": 3.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 5,
          "6-8h": 2,
          "8-10h": 2,
          "18-20h": 1,
          "38-40h": 1,
          "88-90h": 1,
          "228-230h": 2,
          "242-244h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-20": 1,
          "2025-10-24": 2,
          "2025-10-28": 1,
          "2025-10-29": 1,
          "2025-11-17": 4,
          "2026-01-22": 1,
          "2026-02-06": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-26": 1,
          "2026-03-06": 1,
          "2026-04-22": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-06-02": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-20": 19.72012611111111,
          "2025-10-24": 4.242933888888889,
          "2025-10-28": 0.11560055555555555,
          "2025-10-29": 2.7886172222222223,
          "2025-11-17": 22.210347777777777,
          "2026-01-22": 2.2283619444444445,
          "2026-02-06": 0.18088972222222222,
          "2026-02-09": 8.840938055555556,
          "2026-02-10": 242.5178961111111,
          "2026-02-11": 456.2826408333333,
          "2026-04-22": 2.962573611111111,
          "2026-05-04": 88.34767944444445,
          "2026-06-05": 39.0485325
        },
        "time_count_per_day": {
          "2025-10-20": 1,
          "2025-10-24": 2,
          "2025-10-28": 1,
          "2025-10-29": 1,
          "2025-11-17": 4,
          "2026-01-22": 1,
          "2026-02-06": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-04-22": 1,
          "2026-05-04": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 14.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 3,
            "8-10h": 1,
            "18-20h": 1,
            "38-40h": 1,
            "88-90h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-10-20": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-17": 1,
            "2026-01-22": 1,
            "2026-02-06": 1,
            "2026-02-09": 2,
            "2026-03-06": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-20": 19.72012611111111,
            "2025-10-28": 0.11560055555555555,
            "2025-10-29": 2.7886172222222223,
            "2025-11-17": 0.6307141666666667,
            "2026-01-22": 2.2283619444444445,
            "2026-02-06": 0.18088972222222222,
            "2026-02-09": 8.840938055555556,
            "2026-04-22": 2.962573611111111,
            "2026-05-04": 88.34767944444445,
            "2026-06-05": 39.0485325
          },
          "time_count_per_day": {
            "2025-10-20": 1,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-17": 1,
            "2026-01-22": 1,
            "2026-02-06": 1,
            "2026-02-09": 2,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 44.72,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "6-8h": 2,
            "8-10h": 1,
            "242-244h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-24": 2,
            "2025-11-17": 3,
            "2026-02-10": 1
          },
          "time_per_day": {
            "2025-10-24": 4.242933888888889,
            "2025-11-17": 21.57963361111111,
            "2026-02-10": 242.5178961111111
          },
          "time_count_per_day": {
            "2025-10-24": 2,
            "2025-11-17": 3,
            "2026-02-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 228.14,
          "mode_time_hours": 229.0,
          "mode_frequency": 2,
          "time_distribution": {
            "228-230h": 2
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-11": 2,
            "2026-02-26": 1,
            "2026-04-30": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-02-11": 456.2826408333333
          },
          "time_count_per_day": {
            "2026-02-11": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 46.82,
            "mode_time_hours": 3.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 5,
              "6-8h": 2,
              "8-10h": 2,
              "18-20h": 1,
              "38-40h": 1,
              "88-90h": 1,
              "228-230h": 2,
              "242-244h": 1
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-10-20": 1,
              "2025-10-24": 2,
              "2025-10-28": 1,
              "2025-10-29": 1,
              "2025-11-17": 4,
              "2026-01-22": 1,
              "2026-02-06": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-04-22": 1,
              "2026-05-04": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-20": 19.72012611111111,
              "2025-10-24": 4.242933888888889,
              "2025-10-28": 0.11560055555555555,
              "2025-10-29": 2.7886172222222223,
              "2025-11-17": 22.210347777777777,
              "2026-01-22": 2.2283619444444445,
              "2026-02-06": 0.18088972222222222,
              "2026-02-09": 8.840938055555556,
              "2026-02-10": 242.5178961111111,
              "2026-02-11": 456.2826408333333,
              "2026-04-22": 2.962573611111111,
              "2026-05-04": 88.34767944444445,
              "2026-06-05": 39.0485325
            },
            "time_count_per_day": {
              "2025-10-20": 1,
              "2025-10-24": 2,
              "2025-10-28": 1,
              "2025-10-29": 1,
              "2025-11-17": 4,
              "2026-01-22": 1,
              "2026-02-06": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-11": 2,
              "2026-04-22": 1,
              "2026-05-04": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 14.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 3,
                "8-10h": 1,
                "18-20h": 1,
                "38-40h": 1,
                "88-90h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-20": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-17": 1,
                "2026-01-22": 1,
                "2026-02-06": 1,
                "2026-02-09": 2,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-20": 19.72012611111111,
                "2025-10-28": 0.11560055555555555,
                "2025-10-29": 2.7886172222222223,
                "2025-11-17": 0.6307141666666667,
                "2026-01-22": 2.2283619444444445,
                "2026-02-06": 0.18088972222222222,
                "2026-02-09": 8.840938055555556,
                "2026-04-22": 2.962573611111111,
                "2026-05-04": 88.34767944444445,
                "2026-06-05": 39.0485325
              },
              "time_count_per_day": {
                "2025-10-20": 1,
                "2025-10-28": 1,
                "2025-10-29": 1,
                "2025-11-17": 1,
                "2026-01-22": 1,
                "2026-02-06": 1,
                "2026-02-09": 2,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 44.72,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "6-8h": 2,
                "8-10h": 1,
                "242-244h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-24": 2,
                "2025-11-17": 3,
                "2026-02-10": 1
              },
              "time_per_day": {
                "2025-10-24": 4.242933888888889,
                "2025-11-17": 21.57963361111111,
                "2026-02-10": 242.5178961111111
              },
              "time_count_per_day": {
                "2025-10-24": 2,
                "2025-11-17": 3,
                "2026-02-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 228.14,
              "mode_time_hours": 229.0,
              "mode_frequency": 2,
              "time_distribution": {
                "228-230h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-11": 2
              },
              "time_per_day": {
                "2026-02-11": 456.2826408333333
              },
              "time_count_per_day": {
                "2026-02-11": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-26": 1,
              "2026-04-30": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-26": 1,
                "2026-04-30": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_286": {
      "overall": {
        "avg_time_hours": 118.32,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 1,
          "4-6h": 1,
          "12-14h": 2,
          "14-16h": 1,
          "16-18h": 2,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "26-28h": 1,
          "50-52h": 1,
          "58-60h": 1,
          "80-82h": 1,
          "100-102h": 1,
          "144-146h": 1,
          "192-194h": 1,
          "198-200h": 1,
          "304-306h": 1,
          "348-350h": 1,
          "356-358h": 1,
          "360-362h": 1,
          "816-818h": 1
        },
        "tickets_count": 27,
        "tickets_per_day": {
          "2025-10-20": 1,
          "2025-10-27": 1,
          "2025-11-04": 1,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2026-01-14": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-24": 1,
          "2026-04-02": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-05-06": 1,
          "2026-05-14": 2,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-25": 2,
          "2026-05-26": 3
        },
        "time_per_day": {
          "2025-10-20": 0.6860025,
          "2025-10-27": 81.11781194444445,
          "2025-11-04": 26.587162222222222,
          "2025-11-17": 100.54826027777779,
          "2025-12-11": 145.0316838888889,
          "2026-01-14": 14.635356388888889,
          "2026-01-26": 4.3154691666666665,
          "2026-01-28": 18.33869361111111,
          "2026-02-03": 357.97938666666664,
          "2026-03-06": 198.5312513888889,
          "2026-03-11": 17.09142138888889,
          "2026-03-17": 22.76893472222222,
          "2026-03-24": 0.23260305555555555,
          "2026-04-02": 17.8028025,
          "2026-04-16": 13.923803055555556,
          "2026-04-21": 3.1228425,
          "2026-04-23": 817.8408052777778,
          "2026-05-06": 361.18340888888895,
          "2026-05-14": 399.77634083333334,
          "2026-05-19": 12.315959166666667,
          "2026-05-20": 59.27088222222223,
          "2026-05-25": 1.636961111111111,
          "2026-05-26": 519.815811388889
        },
        "time_count_per_day": {
          "2025-10-20": 1,
          "2025-10-27": 1,
          "2025-11-04": 1,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2026-01-14": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-24": 1,
          "2026-04-02": 1,
          "2026-04-16": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-05-06": 1,
          "2026-05-14": 2,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-25": 2,
          "2026-05-26": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 123.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 1,
            "4-6h": 1,
            "12-14h": 2,
            "14-16h": 1,
            "16-18h": 2,
            "20-22h": 1,
            "22-24h": 1,
            "26-28h": 1,
            "50-52h": 1,
            "58-60h": 1,
            "80-82h": 1,
            "144-146h": 1,
            "192-194h": 1,
            "198-200h": 1,
            "304-306h": 1,
            "348-350h": 1,
            "356-358h": 1,
            "360-362h": 1,
            "816-818h": 1
          },
          "tickets_count": 25,
          "tickets_per_day": {
            "2025-10-20": 1,
            "2025-10-27": 1,
            "2025-11-04": 1,
            "2025-12-11": 1,
            "2026-01-14": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-24": 1,
            "2026-04-02": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-05-06": 1,
            "2026-05-14": 2,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-25": 2,
            "2026-05-26": 3
          },
          "time_per_day": {
            "2025-10-20": 0.6860025,
            "2025-10-27": 81.11781194444445,
            "2025-11-04": 26.587162222222222,
            "2025-12-11": 145.0316838888889,
            "2026-01-14": 14.635356388888889,
            "2026-01-26": 4.3154691666666665,
            "2026-02-03": 357.97938666666664,
            "2026-03-06": 198.5312513888889,
            "2026-03-11": 17.09142138888889,
            "2026-03-17": 22.76893472222222,
            "2026-03-24": 0.23260305555555555,
            "2026-04-02": 17.8028025,
            "2026-04-16": 13.923803055555556,
            "2026-04-21": 3.1228425,
            "2026-04-23": 817.8408052777778,
            "2026-05-06": 361.18340888888895,
            "2026-05-14": 399.77634083333334,
            "2026-05-19": 12.315959166666667,
            "2026-05-20": 59.27088222222223,
            "2026-05-25": 1.636961111111111,
            "2026-05-26": 519.815811388889
          },
          "time_count_per_day": {
            "2025-10-20": 1,
            "2025-10-27": 1,
            "2025-11-04": 1,
            "2025-12-11": 1,
            "2026-01-14": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-03-06": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-24": 1,
            "2026-04-02": 1,
            "2026-04-16": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-05-06": 1,
            "2026-05-14": 2,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-25": 2,
            "2026-05-26": 3
          }
        },
        "P3": {
          "avg_time_hours": 59.44,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "100-102h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-01-28": 1
          },
          "time_per_day": {
            "2025-11-17": 100.54826027777779,
            "2026-01-28": 18.33869361111111
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 118.32,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 1,
              "4-6h": 1,
              "12-14h": 2,
              "14-16h": 1,
              "16-18h": 2,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "26-28h": 1,
              "50-52h": 1,
              "58-60h": 1,
              "80-82h": 1,
              "100-102h": 1,
              "144-146h": 1,
              "192-194h": 1,
              "198-200h": 1,
              "304-306h": 1,
              "348-350h": 1,
              "356-358h": 1,
              "360-362h": 1,
              "816-818h": 1
            },
            "tickets_count": 27,
            "tickets_per_day": {
              "2025-10-20": 1,
              "2025-10-27": 1,
              "2025-11-04": 1,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2026-01-14": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-24": 1,
              "2026-04-02": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-06": 1,
              "2026-05-14": 2,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-05-26": 3
            },
            "time_per_day": {
              "2025-10-20": 0.6860025,
              "2025-10-27": 81.11781194444445,
              "2025-11-04": 26.587162222222222,
              "2025-11-17": 100.54826027777779,
              "2025-12-11": 145.0316838888889,
              "2026-01-14": 14.635356388888889,
              "2026-01-26": 4.3154691666666665,
              "2026-01-28": 18.33869361111111,
              "2026-02-03": 357.97938666666664,
              "2026-03-06": 198.5312513888889,
              "2026-03-11": 17.09142138888889,
              "2026-03-17": 22.76893472222222,
              "2026-03-24": 0.23260305555555555,
              "2026-04-02": 17.8028025,
              "2026-04-16": 13.923803055555556,
              "2026-04-21": 3.1228425,
              "2026-04-23": 817.8408052777778,
              "2026-05-06": 361.18340888888895,
              "2026-05-14": 399.77634083333334,
              "2026-05-19": 12.315959166666667,
              "2026-05-20": 59.27088222222223,
              "2026-05-25": 1.636961111111111,
              "2026-05-26": 519.815811388889
            },
            "time_count_per_day": {
              "2025-10-20": 1,
              "2025-10-27": 1,
              "2025-11-04": 1,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2026-01-14": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-24": 1,
              "2026-04-02": 1,
              "2026-04-16": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-06": 1,
              "2026-05-14": 2,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-25": 2,
              "2026-05-26": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 123.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 1,
                "4-6h": 1,
                "12-14h": 2,
                "14-16h": 1,
                "16-18h": 2,
                "20-22h": 1,
                "22-24h": 1,
                "26-28h": 1,
                "50-52h": 1,
                "58-60h": 1,
                "80-82h": 1,
                "144-146h": 1,
                "192-194h": 1,
                "198-200h": 1,
                "304-306h": 1,
                "348-350h": 1,
                "356-358h": 1,
                "360-362h": 1,
                "816-818h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-10-20": 1,
                "2025-10-27": 1,
                "2025-11-04": 1,
                "2025-12-11": 1,
                "2026-01-14": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-24": 1,
                "2026-04-02": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-06": 1,
                "2026-05-14": 2,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-25": 2,
                "2026-05-26": 3
              },
              "time_per_day": {
                "2025-10-20": 0.6860025,
                "2025-10-27": 81.11781194444445,
                "2025-11-04": 26.587162222222222,
                "2025-12-11": 145.0316838888889,
                "2026-01-14": 14.635356388888889,
                "2026-01-26": 4.3154691666666665,
                "2026-02-03": 357.97938666666664,
                "2026-03-06": 198.5312513888889,
                "2026-03-11": 17.09142138888889,
                "2026-03-17": 22.76893472222222,
                "2026-03-24": 0.23260305555555555,
                "2026-04-02": 17.8028025,
                "2026-04-16": 13.923803055555556,
                "2026-04-21": 3.1228425,
                "2026-04-23": 817.8408052777778,
                "2026-05-06": 361.18340888888895,
                "2026-05-14": 399.77634083333334,
                "2026-05-19": 12.315959166666667,
                "2026-05-20": 59.27088222222223,
                "2026-05-25": 1.636961111111111,
                "2026-05-26": 519.815811388889
              },
              "time_count_per_day": {
                "2025-10-20": 1,
                "2025-10-27": 1,
                "2025-11-04": 1,
                "2025-12-11": 1,
                "2026-01-14": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-03-06": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-24": 1,
                "2026-04-02": 1,
                "2026-04-16": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-06": 1,
                "2026-05-14": 2,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-25": 2,
                "2026-05-26": 3
              }
            },
            "P3": {
              "avg_time_hours": 59.44,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "100-102h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-01-28": 1
              },
              "time_per_day": {
                "2025-11-17": 100.54826027777779,
                "2026-01-28": 18.33869361111111
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_287": {
      "overall": {
        "avg_time_hours": 165.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "4-6h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "28-30h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "138-140h": 1,
          "156-158h": 1,
          "256-258h": 1,
          "268-270h": 1,
          "328-330h": 1,
          "562-564h": 1,
          "714-716h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-10-28": 1,
          "2025-10-31": 1,
          "2025-11-24": 1,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2025-12-16": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-02-06": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-04-01": 1,
          "2026-04-17": 1,
          "2026-04-23": 1,
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-22": 1
        },
        "time_per_day": {
          "2025-10-28": 75.89008555555556,
          "2025-10-31": 268.3835394444444,
          "2025-11-24": 14.668112777777777,
          "2025-12-05": 0.6201916666666667,
          "2025-12-09": 73.15211027777778,
          "2025-12-16": 328.9788091666667,
          "2026-01-19": 141.8931163888889,
          "2026-01-27": 29.10080388888889,
          "2026-02-06": 256.15421416666663,
          "2026-02-18": 715.1652833333334,
          "2026-02-20": 1.09164,
          "2026-04-01": 5.820499166666666,
          "2026-04-17": 17.69042,
          "2026-05-06": 563.9961097222223,
          "2026-05-18": 157.0644477777778
        },
        "time_count_per_day": {
          "2025-10-28": 1,
          "2025-10-31": 1,
          "2025-11-24": 1,
          "2025-12-05": 1,
          "2025-12-09": 1,
          "2025-12-16": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-02-06": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-04-01": 1,
          "2026-04-17": 1,
          "2026-05-06": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 175.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "16-18h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "138-140h": 1,
            "156-158h": 1,
            "256-258h": 1,
            "268-270h": 1,
            "562-564h": 1,
            "714-716h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2025-10-31": 1,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2026-01-19": 2,
            "2026-02-06": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-01": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-05-06": 1,
            "2026-05-18": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2025-10-28": 75.89008555555556,
            "2025-10-31": 268.3835394444444,
            "2025-12-05": 0.6201916666666667,
            "2025-12-09": 73.15211027777778,
            "2026-01-19": 141.8931163888889,
            "2026-02-06": 256.15421416666663,
            "2026-02-18": 715.1652833333334,
            "2026-02-20": 1.09164,
            "2026-04-01": 5.820499166666666,
            "2026-04-17": 17.69042,
            "2026-05-06": 563.9961097222223,
            "2026-05-18": 157.0644477777778
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2025-10-31": 1,
            "2025-12-05": 1,
            "2025-12-09": 1,
            "2026-01-19": 2,
            "2026-02-06": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-01": 1,
            "2026-04-17": 1,
            "2026-05-06": 1,
            "2026-05-18": 1
          }
        },
        "P3": {
          "avg_time_hours": 124.25,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "28-30h": 1,
            "328-330h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-16": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-11-24": 14.668112777777777,
            "2025-12-16": 328.9788091666667,
            "2026-01-27": 29.10080388888889
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-16": 1,
            "2026-01-27": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-14": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "4-6h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "28-30h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "138-140h": 1,
              "156-158h": 1,
              "256-258h": 1,
              "268-270h": 1,
              "328-330h": 1,
              "562-564h": 1,
              "714-716h": 1
            },
            "tickets_count": 16,
            "tickets_per_day": {
              "2025-10-28": 1,
              "2025-10-31": 1,
              "2025-11-24": 1,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2025-12-16": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-02-06": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-04-01": 1,
              "2026-04-17": 1,
              "2026-05-06": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2025-10-28": 75.89008555555556,
              "2025-10-31": 268.3835394444444,
              "2025-11-24": 14.668112777777777,
              "2025-12-05": 0.6201916666666667,
              "2025-12-09": 73.15211027777778,
              "2025-12-16": 328.9788091666667,
              "2026-01-19": 141.8931163888889,
              "2026-01-27": 29.10080388888889,
              "2026-02-06": 256.15421416666663,
              "2026-02-18": 715.1652833333334,
              "2026-02-20": 1.09164,
              "2026-04-01": 5.820499166666666,
              "2026-04-17": 17.69042,
              "2026-05-06": 563.9961097222223,
              "2026-05-18": 157.0644477777778
            },
            "time_count_per_day": {
              "2025-10-28": 1,
              "2025-10-31": 1,
              "2025-11-24": 1,
              "2025-12-05": 1,
              "2025-12-09": 1,
              "2025-12-16": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-02-06": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-04-01": 1,
              "2026-04-17": 1,
              "2026-05-06": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 175.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "16-18h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "138-140h": 1,
                "156-158h": 1,
                "256-258h": 1,
                "268-270h": 1,
                "562-564h": 1,
                "714-716h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2025-10-31": 1,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2026-01-19": 2,
                "2026-02-06": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-01": 1,
                "2026-04-17": 1,
                "2026-05-06": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2025-10-28": 75.89008555555556,
                "2025-10-31": 268.3835394444444,
                "2025-12-05": 0.6201916666666667,
                "2025-12-09": 73.15211027777778,
                "2026-01-19": 141.8931163888889,
                "2026-02-06": 256.15421416666663,
                "2026-02-18": 715.1652833333334,
                "2026-02-20": 1.09164,
                "2026-04-01": 5.820499166666666,
                "2026-04-17": 17.69042,
                "2026-05-06": 563.9961097222223,
                "2026-05-18": 157.0644477777778
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2025-10-31": 1,
                "2025-12-05": 1,
                "2025-12-09": 1,
                "2026-01-19": 2,
                "2026-02-06": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-01": 1,
                "2026-04-17": 1,
                "2026-05-06": 1,
                "2026-05-18": 1
              }
            },
            "P3": {
              "avg_time_hours": 124.25,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "28-30h": 1,
                "328-330h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-16": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-11-24": 14.668112777777777,
                "2025-12-16": 328.9788091666667,
                "2026-01-27": 29.10080388888889
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-16": 1,
                "2026-01-27": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-23": 1,
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_288": {
      "overall": {
        "avg_time_hours": 200.78,
        "mode_time_hours": 49.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "24-26h": 1,
          "30-32h": 1,
          "48-50h": 2,
          "64-66h": 1,
          "68-70h": 2,
          "106-108h": 1,
          "122-124h": 1,
          "158-160h": 1,
          "234-236h": 1,
          "260-262h": 1,
          "268-270h": 1,
          "282-284h": 1,
          "304-306h": 1,
          "374-376h": 1,
          "1340-1342h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-19": 3,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-12-02": 3,
          "2025-12-03": 1,
          "2025-12-10": 1,
          "2025-12-19": 1,
          "2025-12-29": 1,
          "2026-01-19": 1,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-03-05": 1,
          "2026-03-24": 1,
          "2026-04-07": 1
        },
        "time_per_day": {
          "2025-10-31": 269.8745961111111,
          "2025-11-19": 746.9891586111111,
          "2025-11-24": 122.41995944444444,
          "2025-11-28": 106.72724388888888,
          "2025-12-02": 104.92025749999999,
          "2025-12-03": 69.19919222222222,
          "2025-12-10": 374.25647444444445,
          "2025-12-19": 49.97045,
          "2025-12-29": 1.3257575,
          "2026-01-19": 68.59207555555555,
          "2026-02-09": 260.19926805555554,
          "2026-02-16": 64.35618777777778,
          "2026-03-05": 234.12490027777775,
          "2026-03-24": 1341.4883447222223,
          "2026-04-07": 0.3151838888888889
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-19": 3,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2025-12-02": 3,
          "2025-12-03": 1,
          "2025-12-10": 1,
          "2025-12-19": 1,
          "2025-12-29": 1,
          "2026-01-19": 1,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-03-05": 1,
          "2026-03-24": 1,
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 282.19,
          "mode_time_hours": 69.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "48-50h": 1,
            "68-70h": 2,
            "106-108h": 1,
            "260-262h": 1,
            "268-270h": 1,
            "374-376h": 1,
            "1340-1342h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-10": 1,
            "2026-01-19": 1,
            "2026-02-09": 1,
            "2026-03-24": 1,
            "2026-04-07": 1
          },
          "time_per_day": {
            "2025-10-31": 269.8745961111111,
            "2025-11-28": 106.72724388888888,
            "2025-12-02": 49.05510361111111,
            "2025-12-03": 69.19919222222222,
            "2025-12-10": 374.25647444444445,
            "2026-01-19": 68.59207555555555,
            "2026-02-09": 260.19926805555554,
            "2026-03-24": 1341.4883447222223,
            "2026-04-07": 0.3151838888888889
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-10": 1,
            "2026-01-19": 1,
            "2026-02-09": 1,
            "2026-03-24": 1,
            "2026-04-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 127.51,
          "mode_time_hours": 305.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "24-26h": 1,
            "30-32h": 1,
            "48-50h": 1,
            "64-66h": 1,
            "122-124h": 1,
            "158-160h": 1,
            "234-236h": 1,
            "282-284h": 1,
            "304-306h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-19": 3,
            "2025-11-24": 1,
            "2025-12-02": 2,
            "2025-12-19": 1,
            "2025-12-29": 1,
            "2026-02-16": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2025-11-19": 746.9891586111111,
            "2025-11-24": 122.41995944444444,
            "2025-12-02": 55.86515388888889,
            "2025-12-19": 49.97045,
            "2025-12-29": 1.3257575,
            "2026-02-16": 64.35618777777778,
            "2026-03-05": 234.12490027777775
          },
          "time_count_per_day": {
            "2025-11-19": 3,
            "2025-11-24": 1,
            "2025-12-02": 2,
            "2025-12-19": 1,
            "2025-12-29": 1,
            "2026-02-16": 1,
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 200.78,
            "mode_time_hours": 49.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "24-26h": 1,
              "30-32h": 1,
              "48-50h": 2,
              "64-66h": 1,
              "68-70h": 2,
              "106-108h": 1,
              "122-124h": 1,
              "158-160h": 1,
              "234-236h": 1,
              "260-262h": 1,
              "268-270h": 1,
              "282-284h": 1,
              "304-306h": 1,
              "374-376h": 1,
              "1340-1342h": 1
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-19": 3,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-12-02": 3,
              "2025-12-03": 1,
              "2025-12-10": 1,
              "2025-12-19": 1,
              "2025-12-29": 1,
              "2026-01-19": 1,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-03-05": 1,
              "2026-03-24": 1,
              "2026-04-07": 1
            },
            "time_per_day": {
              "2025-10-31": 269.8745961111111,
              "2025-11-19": 746.9891586111111,
              "2025-11-24": 122.41995944444444,
              "2025-11-28": 106.72724388888888,
              "2025-12-02": 104.92025749999999,
              "2025-12-03": 69.19919222222222,
              "2025-12-10": 374.25647444444445,
              "2025-12-19": 49.97045,
              "2025-12-29": 1.3257575,
              "2026-01-19": 68.59207555555555,
              "2026-02-09": 260.19926805555554,
              "2026-02-16": 64.35618777777778,
              "2026-03-05": 234.12490027777775,
              "2026-03-24": 1341.4883447222223,
              "2026-04-07": 0.3151838888888889
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-19": 3,
              "2025-11-24": 1,
              "2025-11-28": 1,
              "2025-12-02": 3,
              "2025-12-03": 1,
              "2025-12-10": 1,
              "2025-12-19": 1,
              "2025-12-29": 1,
              "2026-01-19": 1,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-03-05": 1,
              "2026-03-24": 1,
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 282.19,
              "mode_time_hours": 69.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "48-50h": 1,
                "68-70h": 2,
                "106-108h": 1,
                "260-262h": 1,
                "268-270h": 1,
                "374-376h": 1,
                "1340-1342h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-10": 1,
                "2026-01-19": 1,
                "2026-02-09": 1,
                "2026-03-24": 1,
                "2026-04-07": 1
              },
              "time_per_day": {
                "2025-10-31": 269.8745961111111,
                "2025-11-28": 106.72724388888888,
                "2025-12-02": 49.05510361111111,
                "2025-12-03": 69.19919222222222,
                "2025-12-10": 374.25647444444445,
                "2026-01-19": 68.59207555555555,
                "2026-02-09": 260.19926805555554,
                "2026-03-24": 1341.4883447222223,
                "2026-04-07": 0.3151838888888889
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-10": 1,
                "2026-01-19": 1,
                "2026-02-09": 1,
                "2026-03-24": 1,
                "2026-04-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 127.51,
              "mode_time_hours": 305.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "24-26h": 1,
                "30-32h": 1,
                "48-50h": 1,
                "64-66h": 1,
                "122-124h": 1,
                "158-160h": 1,
                "234-236h": 1,
                "282-284h": 1,
                "304-306h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-19": 3,
                "2025-11-24": 1,
                "2025-12-02": 2,
                "2025-12-19": 1,
                "2025-12-29": 1,
                "2026-02-16": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2025-11-19": 746.9891586111111,
                "2025-11-24": 122.41995944444444,
                "2025-12-02": 55.86515388888889,
                "2025-12-19": 49.97045,
                "2025-12-29": 1.3257575,
                "2026-02-16": 64.35618777777778,
                "2026-03-05": 234.12490027777775
              },
              "time_count_per_day": {
                "2025-11-19": 3,
                "2025-11-24": 1,
                "2025-12-02": 2,
                "2025-12-19": 1,
                "2025-12-29": 1,
                "2026-02-16": 1,
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_291": {
      "overall": {
        "avg_time_hours": 301.61,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "48-50h": 1,
          "68-70h": 1,
          "72-74h": 1,
          "208-210h": 1,
          "278-280h": 1,
          "290-292h": 1,
          "404-406h": 1,
          "790-792h": 1,
          "876-878h": 2
        },
        "tickets_count": 16,
        "tickets_per_day": {
          "2025-10-22": 1,
          "2025-10-29": 1,
          "2025-10-30": 1,
          "2025-11-24": 1,
          "2026-02-18": 1,
          "2026-02-19": 4,
          "2026-02-21": 2,
          "2026-03-18": 2,
          "2026-03-24": 1,
          "2026-05-06": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-22": 49.927706666666666,
          "2025-10-29": 0.5831013888888888,
          "2025-10-30": 72.26241527777778,
          "2025-11-24": 290.7521516666667,
          "2026-02-19": 2753.9831033333335,
          "2026-02-21": 69.24542972222223,
          "2026-03-18": 682.1391897222222,
          "2026-03-24": 2.021336388888889
        },
        "time_count_per_day": {
          "2025-10-22": 1,
          "2025-10-29": 1,
          "2025-10-30": 1,
          "2025-11-24": 1,
          "2026-02-19": 4,
          "2026-02-21": 2,
          "2026-03-18": 2,
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.76,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2026-02-21": 1
          },
          "time_per_day": {
            "2025-10-29": 0.5831013888888888,
            "2026-02-21": 0.9384833333333333
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2026-02-21": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 166.49,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "48-50h": 1,
            "68-70h": 1,
            "72-74h": 1,
            "278-280h": 1,
            "290-292h": 1,
            "404-406h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-22": 1,
            "2025-10-30": 1,
            "2025-11-24": 1,
            "2026-02-21": 1,
            "2026-03-18": 2,
            "2026-03-24": 1,
            "2026-05-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-22": 49.927706666666666,
            "2025-10-30": 72.26241527777778,
            "2025-11-24": 290.7521516666667,
            "2026-02-21": 68.30694638888889,
            "2026-03-18": 682.1391897222222,
            "2026-03-24": 2.021336388888889
          },
          "time_count_per_day": {
            "2025-10-22": 1,
            "2025-10-30": 1,
            "2025-11-24": 1,
            "2026-02-21": 1,
            "2026-03-18": 2,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 688.5,
          "mode_time_hours": 877.0,
          "mode_frequency": 2,
          "time_distribution": {
            "208-210h": 1,
            "790-792h": 1,
            "876-878h": 2
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-02-19": 4
          },
          "time_per_day": {
            "2026-02-19": 2753.9831033333335
          },
          "time_count_per_day": {
            "2026-02-19": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 301.61,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "48-50h": 1,
              "68-70h": 1,
              "72-74h": 1,
              "208-210h": 1,
              "278-280h": 1,
              "290-292h": 1,
              "404-406h": 1,
              "790-792h": 1,
              "876-878h": 2
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-10-22": 1,
              "2025-10-29": 1,
              "2025-10-30": 1,
              "2025-11-24": 1,
              "2026-02-19": 4,
              "2026-02-21": 2,
              "2026-03-18": 2,
              "2026-03-24": 1
            },
            "time_per_day": {
              "2025-10-22": 49.927706666666666,
              "2025-10-29": 0.5831013888888888,
              "2025-10-30": 72.26241527777778,
              "2025-11-24": 290.7521516666667,
              "2026-02-19": 2753.9831033333335,
              "2026-02-21": 69.24542972222223,
              "2026-03-18": 682.1391897222222,
              "2026-03-24": 2.021336388888889
            },
            "time_count_per_day": {
              "2025-10-22": 1,
              "2025-10-29": 1,
              "2025-10-30": 1,
              "2025-11-24": 1,
              "2026-02-19": 4,
              "2026-02-21": 2,
              "2026-03-18": 2,
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.76,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2026-02-21": 1
              },
              "time_per_day": {
                "2025-10-29": 0.5831013888888888,
                "2026-02-21": 0.9384833333333333
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2026-02-21": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 166.49,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "48-50h": 1,
                "68-70h": 1,
                "72-74h": 1,
                "278-280h": 1,
                "290-292h": 1,
                "404-406h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-22": 1,
                "2025-10-30": 1,
                "2025-11-24": 1,
                "2026-02-21": 1,
                "2026-03-18": 2,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-10-22": 49.927706666666666,
                "2025-10-30": 72.26241527777778,
                "2025-11-24": 290.7521516666667,
                "2026-02-21": 68.30694638888889,
                "2026-03-18": 682.1391897222222,
                "2026-03-24": 2.021336388888889
              },
              "time_count_per_day": {
                "2025-10-22": 1,
                "2025-10-30": 1,
                "2025-11-24": 1,
                "2026-02-21": 1,
                "2026-03-18": 2,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 688.5,
              "mode_time_hours": 877.0,
              "mode_frequency": 2,
              "time_distribution": {
                "208-210h": 1,
                "790-792h": 1,
                "876-878h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-19": 4
              },
              "time_per_day": {
                "2026-02-19": 2753.9831033333335
              },
              "time_count_per_day": {
                "2026-02-19": 4
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-05-06": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-06": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_243": {
      "overall": {
        "avg_time_hours": 86.69,
        "mode_time_hours": 1.0,
        "mode_frequency": 9,
        "time_distribution": {
          "0-2h": 9,
          "2-4h": 4,
          "4-6h": 4,
          "6-8h": 1,
          "10-12h": 1,
          "12-14h": 2,
          "14-16h": 2,
          "16-18h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "22-24h": 2,
          "24-26h": 4,
          "26-28h": 2,
          "28-30h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "64-66h": 1,
          "72-74h": 1,
          "78-80h": 3,
          "120-122h": 1,
          "144-146h": 1,
          "148-150h": 1,
          "150-152h": 2,
          "158-160h": 1,
          "174-176h": 1,
          "186-188h": 1,
          "222-224h": 1,
          "248-250h": 1,
          "256-258h": 1,
          "292-294h": 1,
          "336-338h": 1,
          "366-368h": 1,
          "1244-1246h": 1
        },
        "tickets_count": 70,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-21": 2,
          "2025-11-22": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-15": 5,
          "2026-01-16": 2,
          "2026-01-17": 1,
          "2026-01-20": 1,
          "2026-02-03": 2,
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-03-11": 1,
          "2026-03-16": 1,
          "2026-03-18": 2,
          "2026-03-24": 6,
          "2026-03-25": 1,
          "2026-03-30": 3,
          "2026-03-31": 3,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-04": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-23": 2,
          "2026-04-24": 1,
          "2026-04-28": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-09": 1,
          "2026-05-11": 1,
          "2026-05-22": 2,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-05-29": 1,
          "2026-05-31": 1,
          "2026-06-02": 2,
          "2026-06-05": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-29": 150.60860055555557,
          "2025-10-31": 257.1734986111111,
          "2025-11-21": 27.133477222222222,
          "2025-11-22": 51.50287083333333,
          "2025-11-27": 222.22602333333333,
          "2025-12-04": 151.38429305555553,
          "2025-12-18": 24.475942777777778,
          "2026-01-13": 13.339140555555556,
          "2026-01-15": 331.1935288888889,
          "2026-01-16": 48.9985875,
          "2026-01-17": 10.937808055555555,
          "2026-01-20": 22.748215,
          "2026-02-03": 306.4620452777778,
          "2026-02-10": 28.63256527777778,
          "2026-02-19": 65.56421472222222,
          "2026-03-11": 0.06162555555555556,
          "2026-03-16": 1.0674863888888888,
          "2026-03-18": 280.697895,
          "2026-03-24": 197.1438561111111,
          "2026-03-25": 49.86609722222222,
          "2026-03-30": 91.56941,
          "2026-03-31": 169.96113666666668,
          "2026-04-02": 27.844124166666663,
          "2026-04-04": 2.4803991666666665,
          "2026-04-09": 249.53424694444445,
          "2026-04-10": 388.61454527777784,
          "2026-04-23": 1391.486073888889,
          "2026-04-24": 1.4535475,
          "2026-05-05": 337.4498033333333,
          "2026-05-06": 18.97402861111111,
          "2026-05-07": 46.58063166666667,
          "2026-05-08": 7.146491944444445,
          "2026-05-11": 5.348739444444444,
          "2026-05-22": 6.386685833333333,
          "2026-05-25": 4.133258055555555,
          "2026-05-26": 0.9726827777777778,
          "2026-05-28": 186.57898666666665,
          "2026-05-29": 23.903818055555554
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-21": 2,
          "2025-11-22": 1,
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-15": 5,
          "2026-01-16": 2,
          "2026-01-17": 1,
          "2026-01-20": 1,
          "2026-02-03": 2,
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-03-11": 1,
          "2026-03-16": 1,
          "2026-03-18": 2,
          "2026-03-24": 6,
          "2026-03-25": 1,
          "2026-03-30": 3,
          "2026-03-31": 3,
          "2026-04-02": 1,
          "2026-04-04": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-23": 2,
          "2026-04-24": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-22": 2,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 186.58,
          "mode_time_hours": 187.0,
          "mode_frequency": 1,
          "time_distribution": {
            "186-188h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-31": 1
          },
          "time_per_day": {
            "2026-05-28": 186.57898666666665
          },
          "time_count_per_day": {
            "2026-05-28": 1
          }
        },
        "P2": {
          "avg_time_hours": 83.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 9,
            "2-4h": 4,
            "4-6h": 4,
            "6-8h": 1,
            "10-12h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "22-24h": 2,
            "24-26h": 1,
            "26-28h": 1,
            "46-48h": 1,
            "48-50h": 1,
            "72-74h": 1,
            "144-146h": 1,
            "150-152h": 1,
            "248-250h": 1,
            "256-258h": 1,
            "336-338h": 1,
            "366-368h": 1,
            "1244-1246h": 1
          },
          "tickets_count": 43,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2025-11-21": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-24": 5,
            "2026-03-25": 1,
            "2026-03-30": 2,
            "2026-03-31": 2,
            "2026-04-02": 1,
            "2026-04-04": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-23": 2,
            "2026-04-24": 1,
            "2026-04-28": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-11": 1,
            "2026-05-22": 2,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-29": 1,
            "2026-06-02": 1,
            "2026-06-05": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-29": 150.60860055555557,
            "2025-10-31": 257.1734986111111,
            "2025-11-21": 0.6311544444444445,
            "2026-01-15": 72.32307444444444,
            "2026-01-16": 24.524713055555555,
            "2026-01-17": 10.937808055555555,
            "2026-01-20": 22.748215,
            "2026-03-11": 0.06162555555555556,
            "2026-03-16": 1.0674863888888888,
            "2026-03-24": 22.348070000000003,
            "2026-03-25": 49.86609722222222,
            "2026-03-30": 25.630700555555556,
            "2026-03-31": 20.539896666666667,
            "2026-04-02": 27.844124166666663,
            "2026-04-04": 2.4803991666666665,
            "2026-04-09": 249.53424694444445,
            "2026-04-10": 388.61454527777784,
            "2026-04-23": 1391.486073888889,
            "2026-04-24": 1.4535475,
            "2026-05-05": 337.4498033333333,
            "2026-05-06": 18.97402861111111,
            "2026-05-07": 46.58063166666667,
            "2026-05-08": 7.146491944444445,
            "2026-05-11": 5.348739444444444,
            "2026-05-22": 6.386685833333333,
            "2026-05-25": 4.133258055555555,
            "2026-05-26": 0.9726827777777778,
            "2026-05-29": 23.903818055555554
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2025-11-21": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-17": 1,
            "2026-01-20": 1,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-24": 5,
            "2026-03-25": 1,
            "2026-03-30": 2,
            "2026-03-31": 2,
            "2026-04-02": 1,
            "2026-04-04": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-23": 2,
            "2026-04-24": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-22": 2,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 77.81,
          "mode_time_hours": 25.0,
          "mode_frequency": 3,
          "time_distribution": {
            "12-14h": 2,
            "14-16h": 1,
            "24-26h": 3,
            "26-28h": 1,
            "28-30h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "78-80h": 3,
            "148-150h": 1,
            "150-152h": 1,
            "222-224h": 1,
            "292-294h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-02-03": 2,
            "2026-02-10": 1,
            "2026-02-19": 2,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-11-21": 26.502322777777778,
            "2025-11-22": 51.50287083333333,
            "2025-11-27": 222.22602333333333,
            "2025-12-04": 151.38429305555553,
            "2025-12-18": 24.475942777777778,
            "2026-01-13": 13.339140555555556,
            "2026-01-15": 258.8704544444445,
            "2026-01-16": 24.473874444444444,
            "2026-02-03": 306.4620452777778,
            "2026-02-10": 28.63256527777778,
            "2026-02-19": 65.56421472222222,
            "2026-03-31": 149.42124
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-02-03": 2,
            "2026-02-10": 1,
            "2026-02-19": 2,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 130.36,
          "mode_time_hours": 159.0,
          "mode_frequency": 1,
          "time_distribution": {
            "64-66h": 1,
            "120-122h": 1,
            "158-160h": 1,
            "174-176h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-03-18": 2,
            "2026-03-24": 1,
            "2026-03-30": 1,
            "2026-04-01": 1,
            "2026-05-04": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-03-18": 280.697895,
            "2026-03-24": 174.7957861111111,
            "2026-03-30": 65.93870944444444
          },
          "time_count_per_day": {
            "2026-03-18": 2,
            "2026-03-24": 1,
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 86.69,
            "mode_time_hours": 1.0,
            "mode_frequency": 9,
            "time_distribution": {
              "0-2h": 9,
              "2-4h": 4,
              "4-6h": 4,
              "6-8h": 1,
              "10-12h": 1,
              "12-14h": 2,
              "14-16h": 2,
              "16-18h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "22-24h": 2,
              "24-26h": 4,
              "26-28h": 2,
              "28-30h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "64-66h": 1,
              "72-74h": 1,
              "78-80h": 3,
              "120-122h": 1,
              "144-146h": 1,
              "148-150h": 1,
              "150-152h": 2,
              "158-160h": 1,
              "174-176h": 1,
              "186-188h": 1,
              "222-224h": 1,
              "248-250h": 1,
              "256-258h": 1,
              "292-294h": 1,
              "336-338h": 1,
              "366-368h": 1,
              "1244-1246h": 1
            },
            "tickets_count": 60,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-21": 2,
              "2025-11-22": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-15": 5,
              "2026-01-16": 2,
              "2026-01-17": 1,
              "2026-01-20": 1,
              "2026-02-03": 2,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-11": 1,
              "2026-03-16": 1,
              "2026-03-18": 2,
              "2026-03-24": 6,
              "2026-03-25": 1,
              "2026-03-30": 3,
              "2026-03-31": 3,
              "2026-04-02": 1,
              "2026-04-04": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-23": 2,
              "2026-04-24": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-22": 2,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2025-10-29": 150.60860055555557,
              "2025-10-31": 257.1734986111111,
              "2025-11-21": 27.133477222222222,
              "2025-11-22": 51.50287083333333,
              "2025-11-27": 222.22602333333333,
              "2025-12-04": 151.38429305555553,
              "2025-12-18": 24.475942777777778,
              "2026-01-13": 13.339140555555556,
              "2026-01-15": 331.1935288888889,
              "2026-01-16": 48.9985875,
              "2026-01-17": 10.937808055555555,
              "2026-01-20": 22.748215,
              "2026-02-03": 306.4620452777778,
              "2026-02-10": 28.63256527777778,
              "2026-02-19": 65.56421472222222,
              "2026-03-11": 0.06162555555555556,
              "2026-03-16": 1.0674863888888888,
              "2026-03-18": 280.697895,
              "2026-03-24": 197.1438561111111,
              "2026-03-25": 49.86609722222222,
              "2026-03-30": 91.56941,
              "2026-03-31": 169.96113666666668,
              "2026-04-02": 27.844124166666663,
              "2026-04-04": 2.4803991666666665,
              "2026-04-09": 249.53424694444445,
              "2026-04-10": 388.61454527777784,
              "2026-04-23": 1391.486073888889,
              "2026-04-24": 1.4535475,
              "2026-05-05": 337.4498033333333,
              "2026-05-06": 18.97402861111111,
              "2026-05-07": 46.58063166666667,
              "2026-05-08": 7.146491944444445,
              "2026-05-11": 5.348739444444444,
              "2026-05-22": 6.386685833333333,
              "2026-05-25": 4.133258055555555,
              "2026-05-26": 0.9726827777777778,
              "2026-05-28": 186.57898666666665,
              "2026-05-29": 23.903818055555554
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-21": 2,
              "2025-11-22": 1,
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-15": 5,
              "2026-01-16": 2,
              "2026-01-17": 1,
              "2026-01-20": 1,
              "2026-02-03": 2,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-11": 1,
              "2026-03-16": 1,
              "2026-03-18": 2,
              "2026-03-24": 6,
              "2026-03-25": 1,
              "2026-03-30": 3,
              "2026-03-31": 3,
              "2026-04-02": 1,
              "2026-04-04": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-23": 2,
              "2026-04-24": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-22": 2,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-28": 1,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 186.58,
              "mode_time_hours": 187.0,
              "mode_frequency": 1,
              "time_distribution": {
                "186-188h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-05-28": 186.57898666666665
              },
              "time_count_per_day": {
                "2026-05-28": 1
              }
            },
            "P2": {
              "avg_time_hours": 83.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 9,
                "2-4h": 4,
                "4-6h": 4,
                "6-8h": 1,
                "10-12h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "22-24h": 2,
                "24-26h": 1,
                "26-28h": 1,
                "46-48h": 1,
                "48-50h": 1,
                "72-74h": 1,
                "144-146h": 1,
                "150-152h": 1,
                "248-250h": 1,
                "256-258h": 1,
                "336-338h": 1,
                "366-368h": 1,
                "1244-1246h": 1
              },
              "tickets_count": 38,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2025-11-21": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-24": 5,
                "2026-03-25": 1,
                "2026-03-30": 2,
                "2026-03-31": 2,
                "2026-04-02": 1,
                "2026-04-04": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-23": 2,
                "2026-04-24": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-22": 2,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2025-10-29": 150.60860055555557,
                "2025-10-31": 257.1734986111111,
                "2025-11-21": 0.6311544444444445,
                "2026-01-15": 72.32307444444444,
                "2026-01-16": 24.524713055555555,
                "2026-01-17": 10.937808055555555,
                "2026-01-20": 22.748215,
                "2026-03-11": 0.06162555555555556,
                "2026-03-16": 1.0674863888888888,
                "2026-03-24": 22.348070000000003,
                "2026-03-25": 49.86609722222222,
                "2026-03-30": 25.630700555555556,
                "2026-03-31": 20.539896666666667,
                "2026-04-02": 27.844124166666663,
                "2026-04-04": 2.4803991666666665,
                "2026-04-09": 249.53424694444445,
                "2026-04-10": 388.61454527777784,
                "2026-04-23": 1391.486073888889,
                "2026-04-24": 1.4535475,
                "2026-05-05": 337.4498033333333,
                "2026-05-06": 18.97402861111111,
                "2026-05-07": 46.58063166666667,
                "2026-05-08": 7.146491944444445,
                "2026-05-11": 5.348739444444444,
                "2026-05-22": 6.386685833333333,
                "2026-05-25": 4.133258055555555,
                "2026-05-26": 0.9726827777777778,
                "2026-05-29": 23.903818055555554
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2025-11-21": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-17": 1,
                "2026-01-20": 1,
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-24": 5,
                "2026-03-25": 1,
                "2026-03-30": 2,
                "2026-03-31": 2,
                "2026-04-02": 1,
                "2026-04-04": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-23": 2,
                "2026-04-24": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-22": 2,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 77.81,
              "mode_time_hours": 25.0,
              "mode_frequency": 3,
              "time_distribution": {
                "12-14h": 2,
                "14-16h": 1,
                "24-26h": 3,
                "26-28h": 1,
                "28-30h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "78-80h": 3,
                "148-150h": 1,
                "150-152h": 1,
                "222-224h": 1,
                "292-294h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-02-03": 2,
                "2026-02-10": 1,
                "2026-02-19": 2,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-11-21": 26.502322777777778,
                "2025-11-22": 51.50287083333333,
                "2025-11-27": 222.22602333333333,
                "2025-12-04": 151.38429305555553,
                "2025-12-18": 24.475942777777778,
                "2026-01-13": 13.339140555555556,
                "2026-01-15": 258.8704544444445,
                "2026-01-16": 24.473874444444444,
                "2026-02-03": 306.4620452777778,
                "2026-02-10": 28.63256527777778,
                "2026-02-19": 65.56421472222222,
                "2026-03-31": 149.42124
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-15": 4,
                "2026-01-16": 1,
                "2026-02-03": 2,
                "2026-02-10": 1,
                "2026-02-19": 2,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 130.36,
              "mode_time_hours": 159.0,
              "mode_frequency": 1,
              "time_distribution": {
                "64-66h": 1,
                "120-122h": 1,
                "158-160h": 1,
                "174-176h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-18": 2,
                "2026-03-24": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-03-18": 280.697895,
                "2026-03-24": 174.7957861111111,
                "2026-03-30": 65.93870944444444
              },
              "time_count_per_day": {
                "2026-03-18": 2,
                "2026-03-24": 1,
                "2026-03-30": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-01": 1,
              "2026-05-04": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-01": 1,
                "2026-05-04": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-09": 1,
              "2026-05-31": 1,
              "2026-06-05": 1,
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-31": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-09": 1,
                "2026-06-05": 1,
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-27": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_295": {
      "overall": {
        "avg_time_hours": 29.51,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 2,
          "4-6h": 1,
          "12-14h": 1,
          "52-54h": 1,
          "70-72h": 1,
          "116-118h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-10-21": 1,
          "2025-11-17": 1,
          "2025-11-20": 1,
          "2025-12-26": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-03-05": 1,
          "2026-03-18": 1,
          "2026-04-09": 1,
          "2026-05-08": 1
        },
        "time_per_day": {
          "2025-10-21": 4.543904722222223,
          "2025-11-17": 71.55403666666666,
          "2025-11-20": 0.17157583333333334,
          "2025-12-26": 52.28144944444444,
          "2026-02-03": 12.398409166666667,
          "2026-02-05": 2.7167347222222222,
          "2026-03-05": 0.8973619444444445,
          "2026-03-18": 117.27226833333334,
          "2026-04-09": 3.751376666666667
        },
        "time_count_per_day": {
          "2025-10-21": 1,
          "2025-11-17": 1,
          "2025-11-20": 1,
          "2025-12-26": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-03-05": 1,
          "2026-03-18": 1,
          "2026-04-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 13.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "4-6h": 1,
            "70-72h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2026-02-05": 1,
            "2026-03-05": 1,
            "2026-04-09": 1,
            "2026-05-08": 1
          },
          "time_per_day": {
            "2025-10-21": 4.543904722222223,
            "2025-11-17": 71.55403666666666,
            "2025-11-20": 0.17157583333333334,
            "2026-02-05": 2.7167347222222222,
            "2026-03-05": 0.8973619444444445,
            "2026-04-09": 3.751376666666667
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2026-02-05": 1,
            "2026-03-05": 1,
            "2026-04-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 32.34,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "52-54h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-12-26": 52.28144944444444,
            "2026-02-03": 12.398409166666667
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2026-02-03": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 117.27,
          "mode_time_hours": 117.0,
          "mode_frequency": 1,
          "time_distribution": {
            "116-118h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 117.27226833333334
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.51,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 2,
              "4-6h": 1,
              "12-14h": 1,
              "52-54h": 1,
              "70-72h": 1,
              "116-118h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2025-10-21": 1,
              "2025-11-17": 1,
              "2025-11-20": 1,
              "2025-12-26": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-03-05": 1,
              "2026-03-18": 1,
              "2026-04-09": 1
            },
            "time_per_day": {
              "2025-10-21": 4.543904722222223,
              "2025-11-17": 71.55403666666666,
              "2025-11-20": 0.17157583333333334,
              "2025-12-26": 52.28144944444444,
              "2026-02-03": 12.398409166666667,
              "2026-02-05": 2.7167347222222222,
              "2026-03-05": 0.8973619444444445,
              "2026-03-18": 117.27226833333334,
              "2026-04-09": 3.751376666666667
            },
            "time_count_per_day": {
              "2025-10-21": 1,
              "2025-11-17": 1,
              "2025-11-20": 1,
              "2025-12-26": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-03-05": 1,
              "2026-03-18": 1,
              "2026-04-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 13.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "4-6h": 1,
                "70-72h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2026-02-05": 1,
                "2026-03-05": 1,
                "2026-04-09": 1
              },
              "time_per_day": {
                "2025-10-21": 4.543904722222223,
                "2025-11-17": 71.55403666666666,
                "2025-11-20": 0.17157583333333334,
                "2026-02-05": 2.7167347222222222,
                "2026-03-05": 0.8973619444444445,
                "2026-04-09": 3.751376666666667
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2026-02-05": 1,
                "2026-03-05": 1,
                "2026-04-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 32.34,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "52-54h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-12-26": 52.28144944444444,
                "2026-02-03": 12.398409166666667
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2026-02-03": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 117.27,
              "mode_time_hours": 117.0,
              "mode_frequency": 1,
              "time_distribution": {
                "116-118h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 117.27226833333334
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_297": {
      "overall": {
        "avg_time_hours": 167.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "2-4h": 6,
          "4-6h": 2,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 2,
          "26-28h": 1,
          "28-30h": 1,
          "30-32h": 1,
          "36-38h": 2,
          "38-40h": 1,
          "54-56h": 2,
          "64-66h": 2,
          "68-70h": 1,
          "118-120h": 1,
          "170-172h": 1,
          "184-186h": 1,
          "310-312h": 1,
          "364-366h": 1,
          "436-438h": 1,
          "460-462h": 1,
          "462-464h": 1,
          "510-512h": 1,
          "538-540h": 1,
          "570-572h": 1,
          "578-580h": 1,
          "1036-1038h": 1,
          "1054-1056h": 1,
          "1460-1462h": 1
        },
        "tickets_count": 66,
        "tickets_per_day": {
          "2025-10-21": 1,
          "2025-10-23": 2,
          "2025-10-24": 1,
          "2025-10-31": 1,
          "2025-11-06": 1,
          "2025-11-21": 2,
          "2025-11-25": 2,
          "2025-11-27": 3,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-01-05": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-19": 1,
          "2026-01-23": 1,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-03-05": 2,
          "2026-03-09": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-30": 1,
          "2026-04-09": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 3,
          "2026-05-21": 1,
          "2026-05-26": 3,
          "2026-05-27": 4,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-21": 1.1087530555555556,
          "2025-10-23": 110.06882055555556,
          "2025-10-24": 3.0764133333333334,
          "2025-10-31": 171.0229497222222,
          "2025-11-06": 0.4233675,
          "2025-11-21": 0.54352,
          "2025-11-25": 3.7670377777777775,
          "2025-11-27": 146.0869163888889,
          "2025-12-15": 460.4767986111111,
          "2025-12-17": 29.475828888888888,
          "2026-01-05": 5.666371111111111,
          "2026-01-13": 1.4317616666666666,
          "2026-01-14": 37.93060333333333,
          "2026-01-19": 3.1459372222222224,
          "2026-01-23": 436.1535711111111,
          "2026-01-30": 2.9015561111111112,
          "2026-02-03": 1214.4052394444445,
          "2026-02-09": 578.5357372222222,
          "2026-02-10": 1037.2911777777779,
          "2026-02-18": 2515.0679730555557,
          "2026-03-05": 0.5513991666666667,
          "2026-03-09": 462.2799630555556,
          "2026-03-16": 130.9783511111111,
          "2026-03-17": 1.72347,
          "2026-03-20": 2.025882777777778,
          "2026-04-16": 510.082515,
          "2026-04-17": 184.46810666666667,
          "2026-04-20": 68.28941611111111,
          "2026-04-21": 1.0436730555555556,
          "2026-04-22": 0.3192816666666667,
          "2026-04-23": 42.53285666666666,
          "2026-05-05": 36.644421666666666,
          "2026-05-06": 38.68372694444444,
          "2026-05-08": 570.3644230555556,
          "2026-05-12": 4.200330833333333,
          "2026-05-13": 0.05925166666666667,
          "2026-05-14": 41.941850277777775,
          "2026-05-26": 2.787239722222222,
          "2026-05-27": 31.696302777777777
        },
        "time_count_per_day": {
          "2025-10-21": 1,
          "2025-10-23": 2,
          "2025-10-24": 1,
          "2025-10-31": 1,
          "2025-11-06": 1,
          "2025-11-21": 2,
          "2025-11-25": 2,
          "2025-11-27": 3,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-01-05": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-19": 1,
          "2026-01-23": 1,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-03-05": 2,
          "2026-03-09": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-04-16": 1,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-26": 1,
          "2026-05-27": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-09": 1,
            "2026-05-14": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 162.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 5,
            "4-6h": 2,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 2,
            "26-28h": 1,
            "28-30h": 1,
            "30-32h": 1,
            "36-38h": 2,
            "38-40h": 1,
            "54-56h": 2,
            "64-66h": 2,
            "68-70h": 1,
            "170-172h": 1,
            "184-186h": 1,
            "310-312h": 1,
            "364-366h": 1,
            "436-438h": 1,
            "460-462h": 1,
            "462-464h": 1,
            "510-512h": 1,
            "570-572h": 1,
            "578-580h": 1,
            "1036-1038h": 1,
            "1460-1462h": 1
          },
          "tickets_count": 55,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 2,
            "2025-10-24": 1,
            "2025-10-31": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-05": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-03": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-03-05": 2,
            "2026-03-09": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-30": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-14": 2,
            "2026-05-21": 1,
            "2026-05-26": 3,
            "2026-05-27": 4,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-21": 1.1087530555555556,
            "2025-10-23": 110.06882055555556,
            "2025-10-24": 3.0764133333333334,
            "2025-10-31": 171.0229497222222,
            "2025-11-21": 0.4735188888888889,
            "2025-11-27": 26.90742777777778,
            "2025-12-15": 460.4767986111111,
            "2025-12-17": 29.475828888888888,
            "2026-01-05": 5.666371111111111,
            "2026-01-14": 37.93060333333333,
            "2026-01-19": 3.1459372222222224,
            "2026-01-23": 436.1535711111111,
            "2026-01-30": 2.9015561111111112,
            "2026-02-03": 675.9534808333334,
            "2026-02-09": 578.5357372222222,
            "2026-02-10": 1037.2911777777779,
            "2026-02-18": 1460.3970266666668,
            "2026-03-05": 0.5513991666666667,
            "2026-03-09": 462.2799630555556,
            "2026-03-16": 130.9783511111111,
            "2026-03-17": 1.72347,
            "2026-03-20": 2.025882777777778,
            "2026-04-16": 510.082515,
            "2026-04-17": 184.46810666666667,
            "2026-04-20": 68.28941611111111,
            "2026-04-21": 1.0436730555555556,
            "2026-04-22": 0.3192816666666667,
            "2026-04-23": 42.53285666666666,
            "2026-05-05": 36.644421666666666,
            "2026-05-06": 38.68372694444444,
            "2026-05-08": 570.3644230555556,
            "2026-05-12": 4.200330833333333,
            "2026-05-13": 0.05925166666666667,
            "2026-05-14": 41.941850277777775,
            "2026-05-26": 2.787239722222222,
            "2026-05-27": 31.696302777777777
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-10-23": 2,
            "2025-10-24": 1,
            "2025-10-31": 1,
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2026-01-05": 1,
            "2026-01-14": 1,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-03": 2,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-03-05": 2,
            "2026-03-09": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-14": 2,
            "2026-05-26": 1,
            "2026-05-27": 3
          }
        },
        "P3": {
          "avg_time_hours": 190.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1,
            "118-120h": 1,
            "538-540h": 1,
            "1054-1056h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-21": 1,
            "2025-11-25": 2,
            "2025-11-27": 2,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-11-06": 0.4233675,
            "2025-11-21": 0.07000111111111111,
            "2025-11-25": 3.7670377777777775,
            "2025-11-27": 119.17948861111111,
            "2026-01-13": 1.4317616666666666,
            "2026-02-03": 538.4517586111111,
            "2026-02-18": 1054.670946388889
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-21": 1,
            "2025-11-25": 2,
            "2025-11-27": 2,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 167.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "2-4h": 6,
              "4-6h": 2,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 2,
              "26-28h": 1,
              "28-30h": 1,
              "30-32h": 1,
              "36-38h": 2,
              "38-40h": 1,
              "54-56h": 2,
              "64-66h": 2,
              "68-70h": 1,
              "118-120h": 1,
              "170-172h": 1,
              "184-186h": 1,
              "310-312h": 1,
              "364-366h": 1,
              "436-438h": 1,
              "460-462h": 1,
              "462-464h": 1,
              "510-512h": 1,
              "538-540h": 1,
              "570-572h": 1,
              "578-580h": 1,
              "1036-1038h": 1,
              "1054-1056h": 1,
              "1460-1462h": 1
            },
            "tickets_count": 53,
            "tickets_per_day": {
              "2025-10-21": 1,
              "2025-10-23": 2,
              "2025-10-24": 1,
              "2025-10-31": 1,
              "2025-11-06": 1,
              "2025-11-21": 2,
              "2025-11-25": 2,
              "2025-11-27": 3,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-01-05": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-19": 1,
              "2026-01-23": 1,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-03-05": 2,
              "2026-03-09": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 2,
              "2026-05-26": 1,
              "2026-05-27": 3
            },
            "time_per_day": {
              "2025-10-21": 1.1087530555555556,
              "2025-10-23": 110.06882055555556,
              "2025-10-24": 3.0764133333333334,
              "2025-10-31": 171.0229497222222,
              "2025-11-06": 0.4233675,
              "2025-11-21": 0.54352,
              "2025-11-25": 3.7670377777777775,
              "2025-11-27": 146.0869163888889,
              "2025-12-15": 460.4767986111111,
              "2025-12-17": 29.475828888888888,
              "2026-01-05": 5.666371111111111,
              "2026-01-13": 1.4317616666666666,
              "2026-01-14": 37.93060333333333,
              "2026-01-19": 3.1459372222222224,
              "2026-01-23": 436.1535711111111,
              "2026-01-30": 2.9015561111111112,
              "2026-02-03": 1214.4052394444445,
              "2026-02-09": 578.5357372222222,
              "2026-02-10": 1037.2911777777779,
              "2026-02-18": 2515.0679730555557,
              "2026-03-05": 0.5513991666666667,
              "2026-03-09": 462.2799630555556,
              "2026-03-16": 130.9783511111111,
              "2026-03-17": 1.72347,
              "2026-03-20": 2.025882777777778,
              "2026-04-16": 510.082515,
              "2026-04-17": 184.46810666666667,
              "2026-04-20": 68.28941611111111,
              "2026-04-21": 1.0436730555555556,
              "2026-04-22": 0.3192816666666667,
              "2026-04-23": 42.53285666666666,
              "2026-05-05": 36.644421666666666,
              "2026-05-06": 38.68372694444444,
              "2026-05-08": 570.3644230555556,
              "2026-05-12": 4.200330833333333,
              "2026-05-13": 0.05925166666666667,
              "2026-05-14": 41.941850277777775,
              "2026-05-26": 2.787239722222222,
              "2026-05-27": 31.696302777777777
            },
            "time_count_per_day": {
              "2025-10-21": 1,
              "2025-10-23": 2,
              "2025-10-24": 1,
              "2025-10-31": 1,
              "2025-11-06": 1,
              "2025-11-21": 2,
              "2025-11-25": 2,
              "2025-11-27": 3,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-01-05": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-19": 1,
              "2026-01-23": 1,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-03-05": 2,
              "2026-03-09": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-04-16": 1,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-23": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 2,
              "2026-05-26": 1,
              "2026-05-27": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 162.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 5,
                "4-6h": 2,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 2,
                "26-28h": 1,
                "28-30h": 1,
                "30-32h": 1,
                "36-38h": 2,
                "38-40h": 1,
                "54-56h": 2,
                "64-66h": 2,
                "68-70h": 1,
                "170-172h": 1,
                "184-186h": 1,
                "310-312h": 1,
                "364-366h": 1,
                "436-438h": 1,
                "460-462h": 1,
                "462-464h": 1,
                "510-512h": 1,
                "570-572h": 1,
                "578-580h": 1,
                "1036-1038h": 1,
                "1460-1462h": 1
              },
              "tickets_count": 44,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 2,
                "2025-10-24": 1,
                "2025-10-31": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-05": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-03": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-03-05": 2,
                "2026-03-09": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-14": 2,
                "2026-05-26": 1,
                "2026-05-27": 3
              },
              "time_per_day": {
                "2025-10-21": 1.1087530555555556,
                "2025-10-23": 110.06882055555556,
                "2025-10-24": 3.0764133333333334,
                "2025-10-31": 171.0229497222222,
                "2025-11-21": 0.4735188888888889,
                "2025-11-27": 26.90742777777778,
                "2025-12-15": 460.4767986111111,
                "2025-12-17": 29.475828888888888,
                "2026-01-05": 5.666371111111111,
                "2026-01-14": 37.93060333333333,
                "2026-01-19": 3.1459372222222224,
                "2026-01-23": 436.1535711111111,
                "2026-01-30": 2.9015561111111112,
                "2026-02-03": 675.9534808333334,
                "2026-02-09": 578.5357372222222,
                "2026-02-10": 1037.2911777777779,
                "2026-02-18": 1460.3970266666668,
                "2026-03-05": 0.5513991666666667,
                "2026-03-09": 462.2799630555556,
                "2026-03-16": 130.9783511111111,
                "2026-03-17": 1.72347,
                "2026-03-20": 2.025882777777778,
                "2026-04-16": 510.082515,
                "2026-04-17": 184.46810666666667,
                "2026-04-20": 68.28941611111111,
                "2026-04-21": 1.0436730555555556,
                "2026-04-22": 0.3192816666666667,
                "2026-04-23": 42.53285666666666,
                "2026-05-05": 36.644421666666666,
                "2026-05-06": 38.68372694444444,
                "2026-05-08": 570.3644230555556,
                "2026-05-12": 4.200330833333333,
                "2026-05-13": 0.05925166666666667,
                "2026-05-14": 41.941850277777775,
                "2026-05-26": 2.787239722222222,
                "2026-05-27": 31.696302777777777
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-10-23": 2,
                "2025-10-24": 1,
                "2025-10-31": 1,
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2026-01-05": 1,
                "2026-01-14": 1,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-03": 2,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-03-05": 2,
                "2026-03-09": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-22": 1,
                "2026-04-23": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-13": 1,
                "2026-05-14": 2,
                "2026-05-26": 1,
                "2026-05-27": 3
              }
            },
            "P3": {
              "avg_time_hours": 190.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1,
                "118-120h": 1,
                "538-540h": 1,
                "1054-1056h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-21": 1,
                "2025-11-25": 2,
                "2025-11-27": 2,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-11-06": 0.4233675,
                "2025-11-21": 0.07000111111111111,
                "2025-11-25": 3.7670377777777775,
                "2025-11-27": 119.17948861111111,
                "2026-01-13": 1.4317616666666666,
                "2026-02-03": 538.4517586111111,
                "2026-02-18": 1054.670946388889
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-21": 1,
                "2025-11-25": 2,
                "2025-11-27": 2,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-04-09": 1,
              "2026-05-04": 1,
              "2026-05-11": 1,
              "2026-05-26": 2,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-05-04": 1,
                "2026-05-11": 1,
                "2026-05-26": 2,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-30": 1,
              "2026-05-06": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-30": 1,
                "2026-05-06": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_279": {
      "overall": {
        "avg_time_hours": 186.42,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "6-8h": 1,
          "12-14h": 2,
          "14-16h": 2,
          "16-18h": 2,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 2,
          "30-32h": 1,
          "32-34h": 1,
          "34-36h": 1,
          "38-40h": 1,
          "46-48h": 2,
          "52-54h": 1,
          "54-56h": 2,
          "80-82h": 1,
          "94-96h": 1,
          "114-116h": 1,
          "120-122h": 1,
          "164-166h": 1,
          "180-182h": 2,
          "194-196h": 1,
          "216-218h": 1,
          "232-234h": 1,
          "252-254h": 1,
          "288-290h": 1,
          "312-314h": 2,
          "316-318h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "368-370h": 1,
          "370-372h": 1,
          "406-408h": 1,
          "420-422h": 1,
          "544-546h": 1,
          "550-552h": 2,
          "576-578h": 1,
          "738-740h": 1,
          "780-782h": 1,
          "790-792h": 1
        },
        "tickets_count": 61,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-10": 1,
          "2025-11-14": 1,
          "2025-11-16": 1,
          "2025-11-17": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-12-05": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-22": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-01-29": 3,
          "2026-02-05": 1,
          "2026-02-07": 2,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-19": 6,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 3,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-18": 1,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-15": 3,
          "2026-05-18": 1,
          "2026-05-25": 4,
          "2026-06-01": 2
        },
        "time_per_day": {
          "2025-10-23": 55.046978888888894,
          "2025-11-10": 12.250313055555555,
          "2025-11-14": 52.343740000000004,
          "2025-11-16": 253.38371305555555,
          "2025-11-17": 114.53584194444444,
          "2025-11-21": 237.65324222222225,
          "2025-11-24": 0.7049916666666666,
          "2025-12-05": 55.77497416666667,
          "2025-12-12": 17.635466944444442,
          "2025-12-15": 316.1746458333334,
          "2025-12-22": 289.46046333333334,
          "2026-01-13": 31.797178055555555,
          "2026-01-14": 2.0422016666666667,
          "2026-01-16": 25.24613861111111,
          "2026-01-19": 50.443353055555555,
          "2026-01-22": 38.63096944444444,
          "2026-01-27": 32.244862777777776,
          "2026-01-28": 6.3453725,
          "2026-01-29": 32.26069888888889,
          "2026-02-05": 194.2739202777778,
          "2026-02-07": 94.7056675,
          "2026-02-10": 164.33493666666666,
          "2026-02-12": 387.6952036111111,
          "2026-02-13": 1107.9380636111111,
          "2026-02-18": 24.389103055555555,
          "2026-02-19": 3099.4548950000003,
          "2026-02-28": 80.3016261111111,
          "2026-03-02": 22.956364166666663,
          "2026-03-06": 95.00396666666667,
          "2026-03-10": 121.33517222222223,
          "2026-03-18": 780.5973394444445,
          "2026-04-07": 780.2738330555555,
          "2026-04-08": 233.83078138888888,
          "2026-04-09": 407.98633083333334,
          "2026-04-18": 545.1426636111111,
          "2026-04-30": 334.91657499999997,
          "2026-05-06": 336.1169380555555,
          "2026-05-15": 0.4140336111111111,
          "2026-05-18": 0.1521811111111111,
          "2026-05-25": 1.11884,
          "2026-06-01": 2.429305277777778
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-10": 1,
          "2025-11-14": 1,
          "2025-11-16": 1,
          "2025-11-17": 1,
          "2025-11-21": 2,
          "2025-11-24": 1,
          "2025-12-05": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-22": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-01-29": 3,
          "2026-02-05": 1,
          "2026-02-07": 2,
          "2026-02-10": 1,
          "2026-02-12": 2,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-02-19": 6,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 3,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-18": 1,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-05-25": 2,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 22.96,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-02": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-03-02": 22.956364166666663
          },
          "time_count_per_day": {
            "2026-03-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 165.43,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 2,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "24-26h": 2,
            "32-34h": 1,
            "34-36h": 1,
            "54-56h": 2,
            "94-96h": 1,
            "120-122h": 1,
            "232-234h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "368-370h": 1,
            "370-372h": 1,
            "406-408h": 1,
            "544-546h": 1,
            "738-740h": 1,
            "780-782h": 1
          },
          "tickets_count": 29,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-11-10": 1,
            "2025-11-24": 1,
            "2025-12-05": 1,
            "2025-12-12": 1,
            "2026-01-16": 1,
            "2026-01-19": 2,
            "2026-01-27": 1,
            "2026-01-29": 2,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-18": 1,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-25": 2,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2025-10-23": 55.046978888888894,
            "2025-11-10": 12.250313055555555,
            "2025-11-24": 0.7049916666666666,
            "2025-12-05": 55.77497416666667,
            "2025-12-12": 17.635466944444442,
            "2026-01-16": 25.24613861111111,
            "2026-01-19": 50.443353055555555,
            "2026-01-27": 32.244862777777776,
            "2026-01-29": 19.569258333333334,
            "2026-02-12": 371.96236805555554,
            "2026-02-13": 1107.9380636111111,
            "2026-02-18": 24.389103055555555,
            "2026-03-06": 95.00396666666667,
            "2026-03-10": 121.33517222222223,
            "2026-04-07": 780.2738330555555,
            "2026-04-08": 233.83078138888888,
            "2026-04-09": 407.98633083333334,
            "2026-04-18": 545.1426636111111,
            "2026-04-30": 334.91657499999997,
            "2026-05-06": 336.1169380555555,
            "2026-05-15": 0.4140336111111111,
            "2026-05-18": 0.1521811111111111,
            "2026-05-25": 1.11884,
            "2026-06-01": 2.429305277777778
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-11-10": 1,
            "2025-11-24": 1,
            "2025-12-05": 1,
            "2025-12-12": 1,
            "2026-01-16": 1,
            "2026-01-19": 2,
            "2026-01-27": 1,
            "2026-01-29": 2,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-18": 1,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-25": 2,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 101.86,
          "mode_time_hours": 47.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "14-16h": 1,
            "20-22h": 1,
            "30-32h": 1,
            "38-40h": 1,
            "46-48h": 2,
            "52-54h": 1,
            "114-116h": 1,
            "164-166h": 1,
            "216-218h": 1,
            "252-254h": 1,
            "288-290h": 1,
            "316-318h": 1
          },
          "tickets_count": 16,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-11-16": 1,
            "2025-11-17": 1,
            "2025-11-21": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-02-07": 2,
            "2026-02-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-14": 52.343740000000004,
            "2025-11-16": 253.38371305555555,
            "2025-11-17": 114.53584194444444,
            "2025-11-21": 237.65324222222225,
            "2025-12-15": 316.1746458333334,
            "2025-12-22": 289.46046333333334,
            "2026-01-13": 31.797178055555555,
            "2026-01-14": 2.0422016666666667,
            "2026-01-22": 38.63096944444444,
            "2026-01-28": 6.3453725,
            "2026-01-29": 12.691440555555555,
            "2026-02-07": 94.7056675,
            "2026-02-10": 164.33493666666666,
            "2026-02-12": 15.732835555555555
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2025-11-16": 1,
            "2025-11-17": 1,
            "2025-11-21": 2,
            "2025-12-15": 1,
            "2025-12-22": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-02-07": 2,
            "2026-02-10": 1,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 211.03,
          "mode_time_hours": 181.0,
          "mode_frequency": 2,
          "time_distribution": {
            "80-82h": 1,
            "180-182h": 2,
            "194-196h": 1,
            "420-422h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-02-05": 1,
            "2026-02-28": 1,
            "2026-03-18": 3,
            "2026-05-15": 2,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-02-05": 194.2739202777778,
            "2026-02-28": 80.3016261111111,
            "2026-03-18": 780.5973394444445
          },
          "time_count_per_day": {
            "2026-02-05": 1,
            "2026-02-28": 1,
            "2026-03-18": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 516.58,
          "mode_time_hours": 551.0,
          "mode_frequency": 2,
          "time_distribution": {
            "312-314h": 2,
            "550-552h": 2,
            "576-578h": 1,
            "790-792h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-19": 6
          },
          "time_per_day": {
            "2026-02-19": 3099.4548950000003
          },
          "time_count_per_day": {
            "2026-02-19": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 186.42,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "6-8h": 1,
              "12-14h": 2,
              "14-16h": 2,
              "16-18h": 2,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 2,
              "30-32h": 1,
              "32-34h": 1,
              "34-36h": 1,
              "38-40h": 1,
              "46-48h": 2,
              "52-54h": 1,
              "54-56h": 2,
              "80-82h": 1,
              "94-96h": 1,
              "114-116h": 1,
              "120-122h": 1,
              "164-166h": 1,
              "180-182h": 2,
              "194-196h": 1,
              "216-218h": 1,
              "232-234h": 1,
              "252-254h": 1,
              "288-290h": 1,
              "312-314h": 2,
              "316-318h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "368-370h": 1,
              "370-372h": 1,
              "406-408h": 1,
              "420-422h": 1,
              "544-546h": 1,
              "550-552h": 2,
              "576-578h": 1,
              "738-740h": 1,
              "780-782h": 1,
              "790-792h": 1
            },
            "tickets_count": 56,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-10": 1,
              "2025-11-14": 1,
              "2025-11-16": 1,
              "2025-11-17": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-12-05": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-22": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-01-29": 3,
              "2026-02-05": 1,
              "2026-02-07": 2,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-19": 6,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 3,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-18": 1,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-05-25": 2,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-23": 55.046978888888894,
              "2025-11-10": 12.250313055555555,
              "2025-11-14": 52.343740000000004,
              "2025-11-16": 253.38371305555555,
              "2025-11-17": 114.53584194444444,
              "2025-11-21": 237.65324222222225,
              "2025-11-24": 0.7049916666666666,
              "2025-12-05": 55.77497416666667,
              "2025-12-12": 17.635466944444442,
              "2025-12-15": 316.1746458333334,
              "2025-12-22": 289.46046333333334,
              "2026-01-13": 31.797178055555555,
              "2026-01-14": 2.0422016666666667,
              "2026-01-16": 25.24613861111111,
              "2026-01-19": 50.443353055555555,
              "2026-01-22": 38.63096944444444,
              "2026-01-27": 32.244862777777776,
              "2026-01-28": 6.3453725,
              "2026-01-29": 32.26069888888889,
              "2026-02-05": 194.2739202777778,
              "2026-02-07": 94.7056675,
              "2026-02-10": 164.33493666666666,
              "2026-02-12": 387.6952036111111,
              "2026-02-13": 1107.9380636111111,
              "2026-02-18": 24.389103055555555,
              "2026-02-19": 3099.4548950000003,
              "2026-02-28": 80.3016261111111,
              "2026-03-02": 22.956364166666663,
              "2026-03-06": 95.00396666666667,
              "2026-03-10": 121.33517222222223,
              "2026-03-18": 780.5973394444445,
              "2026-04-07": 780.2738330555555,
              "2026-04-08": 233.83078138888888,
              "2026-04-09": 407.98633083333334,
              "2026-04-18": 545.1426636111111,
              "2026-04-30": 334.91657499999997,
              "2026-05-06": 336.1169380555555,
              "2026-05-15": 0.4140336111111111,
              "2026-05-18": 0.1521811111111111,
              "2026-05-25": 1.11884,
              "2026-06-01": 2.429305277777778
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-10": 1,
              "2025-11-14": 1,
              "2025-11-16": 1,
              "2025-11-17": 1,
              "2025-11-21": 2,
              "2025-11-24": 1,
              "2025-12-05": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-22": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-01-29": 3,
              "2026-02-05": 1,
              "2026-02-07": 2,
              "2026-02-10": 1,
              "2026-02-12": 2,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-02-19": 6,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 3,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-18": 1,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-05-25": 2,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 22.96,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-02": 1
              },
              "time_per_day": {
                "2026-03-02": 22.956364166666663
              },
              "time_count_per_day": {
                "2026-03-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 165.43,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 2,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "24-26h": 2,
                "32-34h": 1,
                "34-36h": 1,
                "54-56h": 2,
                "94-96h": 1,
                "120-122h": 1,
                "232-234h": 1,
                "334-336h": 1,
                "336-338h": 1,
                "368-370h": 1,
                "370-372h": 1,
                "406-408h": 1,
                "544-546h": 1,
                "738-740h": 1,
                "780-782h": 1
              },
              "tickets_count": 28,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-11-10": 1,
                "2025-11-24": 1,
                "2025-12-05": 1,
                "2025-12-12": 1,
                "2026-01-16": 1,
                "2026-01-19": 2,
                "2026-01-27": 1,
                "2026-01-29": 2,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-18": 1,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-25": 2,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-23": 55.046978888888894,
                "2025-11-10": 12.250313055555555,
                "2025-11-24": 0.7049916666666666,
                "2025-12-05": 55.77497416666667,
                "2025-12-12": 17.635466944444442,
                "2026-01-16": 25.24613861111111,
                "2026-01-19": 50.443353055555555,
                "2026-01-27": 32.244862777777776,
                "2026-01-29": 19.569258333333334,
                "2026-02-12": 371.96236805555554,
                "2026-02-13": 1107.9380636111111,
                "2026-02-18": 24.389103055555555,
                "2026-03-06": 95.00396666666667,
                "2026-03-10": 121.33517222222223,
                "2026-04-07": 780.2738330555555,
                "2026-04-08": 233.83078138888888,
                "2026-04-09": 407.98633083333334,
                "2026-04-18": 545.1426636111111,
                "2026-04-30": 334.91657499999997,
                "2026-05-06": 336.1169380555555,
                "2026-05-15": 0.4140336111111111,
                "2026-05-18": 0.1521811111111111,
                "2026-05-25": 1.11884,
                "2026-06-01": 2.429305277777778
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-11-10": 1,
                "2025-11-24": 1,
                "2025-12-05": 1,
                "2025-12-12": 1,
                "2026-01-16": 1,
                "2026-01-19": 2,
                "2026-01-27": 1,
                "2026-01-29": 2,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-18": 1,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-25": 2,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 101.86,
              "mode_time_hours": 47.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "14-16h": 1,
                "20-22h": 1,
                "30-32h": 1,
                "38-40h": 1,
                "46-48h": 2,
                "52-54h": 1,
                "114-116h": 1,
                "164-166h": 1,
                "216-218h": 1,
                "252-254h": 1,
                "288-290h": 1,
                "316-318h": 1
              },
              "tickets_count": 16,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-11-16": 1,
                "2025-11-17": 1,
                "2025-11-21": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-02-07": 2,
                "2026-02-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-14": 52.343740000000004,
                "2025-11-16": 253.38371305555555,
                "2025-11-17": 114.53584194444444,
                "2025-11-21": 237.65324222222225,
                "2025-12-15": 316.1746458333334,
                "2025-12-22": 289.46046333333334,
                "2026-01-13": 31.797178055555555,
                "2026-01-14": 2.0422016666666667,
                "2026-01-22": 38.63096944444444,
                "2026-01-28": 6.3453725,
                "2026-01-29": 12.691440555555555,
                "2026-02-07": 94.7056675,
                "2026-02-10": 164.33493666666666,
                "2026-02-12": 15.732835555555555
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2025-11-16": 1,
                "2025-11-17": 1,
                "2025-11-21": 2,
                "2025-12-15": 1,
                "2025-12-22": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-28": 1,
                "2026-01-29": 1,
                "2026-02-07": 2,
                "2026-02-10": 1,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 211.03,
              "mode_time_hours": 181.0,
              "mode_frequency": 2,
              "time_distribution": {
                "80-82h": 1,
                "180-182h": 2,
                "194-196h": 1,
                "420-422h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-05": 1,
                "2026-02-28": 1,
                "2026-03-18": 3
              },
              "time_per_day": {
                "2026-02-05": 194.2739202777778,
                "2026-02-28": 80.3016261111111,
                "2026-03-18": 780.5973394444445
              },
              "time_count_per_day": {
                "2026-02-05": 1,
                "2026-02-28": 1,
                "2026-03-18": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 516.58,
              "mode_time_hours": 551.0,
              "mode_frequency": 2,
              "time_distribution": {
                "312-314h": 2,
                "550-552h": 2,
                "576-578h": 1,
                "790-792h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-19": 6
              },
              "time_per_day": {
                "2026-02-19": 3099.4548950000003
              },
              "time_count_per_day": {
                "2026-02-19": 6
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-15": 2,
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-15": 2,
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-25": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_298": {
      "overall": {
        "avg_time_hours": 3.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 11,
        "time_distribution": {
          "0-2h": 11,
          "2-4h": 1,
          "4-6h": 2,
          "6-8h": 2,
          "30-32h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-10-21": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-20": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-11": 1,
          "2026-02-25": 1,
          "2026-03-16": 1,
          "2026-03-23": 1,
          "2026-05-22": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2025-10-21": 0.6583905555555556,
          "2025-12-17": 0.137715,
          "2025-12-18": 1.4432666666666667,
          "2026-01-13": 4.381707777777778,
          "2026-01-20": 2.7217019444444444,
          "2026-01-26": 7.597497777777777,
          "2026-01-27": 30.840339166666666,
          "2026-01-28": 4.637632777777777,
          "2026-02-03": 0.021739166666666667,
          "2026-02-06": 1.3544716666666667,
          "2026-02-11": 0.1984813888888889,
          "2026-02-25": 0.6701875,
          "2026-03-16": 6.771749166666666,
          "2026-03-23": 2.262981388888889,
          "2026-05-22": 0.20744833333333332,
          "2026-05-29": 0.5480444444444444
        },
        "time_count_per_day": {
          "2025-10-21": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-20": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-11": 1,
          "2026-02-25": 1,
          "2026-03-16": 1,
          "2026-03-23": 1,
          "2026-05-22": 1,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.04,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 2
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-20": 2,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-16": 1,
            "2026-03-23": 1,
            "2026-05-22": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2025-12-17": 0.137715,
            "2025-12-18": 1.4432666666666667,
            "2026-01-20": 2.7217019444444444,
            "2026-01-26": 7.597497777777777,
            "2026-01-28": 4.637632777777777,
            "2026-02-03": 0.021739166666666667,
            "2026-02-06": 1.3544716666666667,
            "2026-02-11": 0.1984813888888889,
            "2026-02-25": 0.6701875,
            "2026-03-16": 6.771749166666666,
            "2026-03-23": 2.262981388888889,
            "2026-05-22": 0.20744833333333332,
            "2026-05-29": 0.5480444444444444
          },
          "time_count_per_day": {
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-20": 2,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-16": 1,
            "2026-03-23": 1,
            "2026-05-22": 1,
            "2026-05-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 11.96,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "30-32h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2026-01-13": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-10-21": 0.6583905555555556,
            "2026-01-13": 4.381707777777778,
            "2026-01-27": 30.840339166666666
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2026-01-13": 1,
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 11,
            "time_distribution": {
              "0-2h": 11,
              "2-4h": 1,
              "4-6h": 2,
              "6-8h": 2,
              "30-32h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-10-21": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-20": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-11": 1,
              "2026-02-25": 1,
              "2026-03-16": 1,
              "2026-03-23": 1,
              "2026-05-22": 1,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2025-10-21": 0.6583905555555556,
              "2025-12-17": 0.137715,
              "2025-12-18": 1.4432666666666667,
              "2026-01-13": 4.381707777777778,
              "2026-01-20": 2.7217019444444444,
              "2026-01-26": 7.597497777777777,
              "2026-01-27": 30.840339166666666,
              "2026-01-28": 4.637632777777777,
              "2026-02-03": 0.021739166666666667,
              "2026-02-06": 1.3544716666666667,
              "2026-02-11": 0.1984813888888889,
              "2026-02-25": 0.6701875,
              "2026-03-16": 6.771749166666666,
              "2026-03-23": 2.262981388888889,
              "2026-05-22": 0.20744833333333332,
              "2026-05-29": 0.5480444444444444
            },
            "time_count_per_day": {
              "2025-10-21": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-20": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-11": 1,
              "2026-02-25": 1,
              "2026-03-16": 1,
              "2026-03-23": 1,
              "2026-05-22": 1,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.04,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 2
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-20": 2,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-16": 1,
                "2026-03-23": 1,
                "2026-05-22": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2025-12-17": 0.137715,
                "2025-12-18": 1.4432666666666667,
                "2026-01-20": 2.7217019444444444,
                "2026-01-26": 7.597497777777777,
                "2026-01-28": 4.637632777777777,
                "2026-02-03": 0.021739166666666667,
                "2026-02-06": 1.3544716666666667,
                "2026-02-11": 0.1984813888888889,
                "2026-02-25": 0.6701875,
                "2026-03-16": 6.771749166666666,
                "2026-03-23": 2.262981388888889,
                "2026-05-22": 0.20744833333333332,
                "2026-05-29": 0.5480444444444444
              },
              "time_count_per_day": {
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-20": 2,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-16": 1,
                "2026-03-23": 1,
                "2026-05-22": 1,
                "2026-05-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 11.96,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "30-32h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2026-01-13": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-10-21": 0.6583905555555556,
                "2026-01-13": 4.381707777777778,
                "2026-01-27": 30.840339166666666
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2026-01-13": 1,
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_299": {
      "overall": {
        "avg_time_hours": 168.38,
        "mode_time_hours": 45.0,
        "mode_frequency": 4,
        "time_distribution": {
          "2-4h": 2,
          "4-6h": 1,
          "6-8h": 2,
          "12-14h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "24-26h": 1,
          "44-46h": 4,
          "48-50h": 1,
          "66-68h": 2,
          "70-72h": 1,
          "98-100h": 1,
          "100-102h": 1,
          "122-124h": 1,
          "164-166h": 1,
          "170-172h": 1,
          "180-182h": 1,
          "268-270h": 1,
          "524-526h": 1,
          "818-820h": 1,
          "836-838h": 1,
          "890-892h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-12-05": 1,
          "2025-12-26": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-22": 3,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-18": 3,
          "2026-02-25": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-27": 1,
          "2026-04-04": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-14": 2,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-06": 1,
          "2026-05-21": 1
        },
        "time_per_day": {
          "2025-10-23": 48.709827499999996,
          "2025-11-11": 98.71587833333334,
          "2025-11-14": 268.19446166666665,
          "2025-12-05": 2.2826666666666666,
          "2025-12-26": 71.98823222222222,
          "2026-01-13": 100.9135575,
          "2026-01-14": 6.873990277777779,
          "2026-01-17": 13.720363055555556,
          "2026-01-22": 133.8833925,
          "2026-02-14": 134.50985111111112,
          "2026-02-16": 123.71852972222221,
          "2026-02-18": 721.7863372222223,
          "2026-02-25": 180.6259738888889,
          "2026-03-17": 837.9279311111112,
          "2026-03-18": 4.973459999999999,
          "2026-03-27": 3.5997791666666665,
          "2026-04-04": 18.9324625,
          "2026-04-06": 45.584655,
          "2026-04-14": 6.145121111111112,
          "2026-04-22": 890.2183033333333,
          "2026-04-28": 819.2675019444445,
          "2026-05-06": 165.49371916666666,
          "2026-05-21": 16.661681944444446
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-11": 1,
          "2025-11-14": 1,
          "2025-12-05": 1,
          "2025-12-26": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-22": 3,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-18": 3,
          "2026-02-25": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-27": 1,
          "2026-04-04": 1,
          "2026-04-06": 1,
          "2026-04-14": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-06": 1,
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 206.06,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 2,
            "12-14h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "44-46h": 2,
            "48-50h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "164-166h": 1,
            "180-182h": 1,
            "268-270h": 1,
            "524-526h": 1,
            "818-820h": 1,
            "836-838h": 1,
            "890-892h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-22": 1,
            "2026-02-18": 2,
            "2026-02-25": 1,
            "2026-03-13": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-27": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-14": 2,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-06": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2025-10-23": 48.709827499999996,
            "2025-11-11": 98.71587833333334,
            "2025-11-14": 268.19446166666665,
            "2026-01-13": 100.9135575,
            "2026-01-14": 6.873990277777779,
            "2026-01-17": 13.720363055555556,
            "2026-01-22": 44.609500555555556,
            "2026-02-18": 550.1251161111111,
            "2026-02-25": 180.6259738888889,
            "2026-03-17": 837.9279311111112,
            "2026-03-18": 4.973459999999999,
            "2026-03-27": 3.5997791666666665,
            "2026-04-04": 18.9324625,
            "2026-04-06": 45.584655,
            "2026-04-14": 6.145121111111112,
            "2026-04-22": 890.2183033333333,
            "2026-04-28": 819.2675019444445,
            "2026-05-06": 165.49371916666666,
            "2026-05-21": 16.661681944444446
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-11-11": 1,
            "2025-11-14": 1,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-17": 1,
            "2026-01-22": 1,
            "2026-02-18": 2,
            "2026-02-25": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-27": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-14": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-06": 1,
            "2026-05-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 74.18,
          "mode_time_hours": 45.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "44-46h": 2,
            "66-68h": 2,
            "70-72h": 1,
            "122-124h": 1,
            "170-172h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2025-12-26": 1,
            "2026-01-22": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-12-05": 2.2826666666666666,
            "2025-12-26": 71.98823222222222,
            "2026-01-22": 89.27389194444444,
            "2026-02-14": 134.50985111111112,
            "2026-02-16": 123.71852972222221,
            "2026-02-18": 171.6612211111111
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2025-12-26": 1,
            "2026-01-22": 2,
            "2026-02-14": 2,
            "2026-02-16": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 168.38,
            "mode_time_hours": 45.0,
            "mode_frequency": 4,
            "time_distribution": {
              "2-4h": 2,
              "4-6h": 1,
              "6-8h": 2,
              "12-14h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "24-26h": 1,
              "44-46h": 4,
              "48-50h": 1,
              "66-68h": 2,
              "70-72h": 1,
              "98-100h": 1,
              "100-102h": 1,
              "122-124h": 1,
              "164-166h": 1,
              "170-172h": 1,
              "180-182h": 1,
              "268-270h": 1,
              "524-526h": 1,
              "818-820h": 1,
              "836-838h": 1,
              "890-892h": 1
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-12-05": 1,
              "2025-12-26": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-22": 3,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-18": 3,
              "2026-02-25": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-27": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-14": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-06": 1,
              "2026-05-21": 1
            },
            "time_per_day": {
              "2025-10-23": 48.709827499999996,
              "2025-11-11": 98.71587833333334,
              "2025-11-14": 268.19446166666665,
              "2025-12-05": 2.2826666666666666,
              "2025-12-26": 71.98823222222222,
              "2026-01-13": 100.9135575,
              "2026-01-14": 6.873990277777779,
              "2026-01-17": 13.720363055555556,
              "2026-01-22": 133.8833925,
              "2026-02-14": 134.50985111111112,
              "2026-02-16": 123.71852972222221,
              "2026-02-18": 721.7863372222223,
              "2026-02-25": 180.6259738888889,
              "2026-03-17": 837.9279311111112,
              "2026-03-18": 4.973459999999999,
              "2026-03-27": 3.5997791666666665,
              "2026-04-04": 18.9324625,
              "2026-04-06": 45.584655,
              "2026-04-14": 6.145121111111112,
              "2026-04-22": 890.2183033333333,
              "2026-04-28": 819.2675019444445,
              "2026-05-06": 165.49371916666666,
              "2026-05-21": 16.661681944444446
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-11": 1,
              "2025-11-14": 1,
              "2025-12-05": 1,
              "2025-12-26": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-22": 3,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-18": 3,
              "2026-02-25": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-27": 1,
              "2026-04-04": 1,
              "2026-04-06": 1,
              "2026-04-14": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-06": 1,
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 206.06,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 2,
                "12-14h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "44-46h": 2,
                "48-50h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "164-166h": 1,
                "180-182h": 1,
                "268-270h": 1,
                "524-526h": 1,
                "818-820h": 1,
                "836-838h": 1,
                "890-892h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-22": 1,
                "2026-02-18": 2,
                "2026-02-25": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-27": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-14": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-06": 1,
                "2026-05-21": 1
              },
              "time_per_day": {
                "2025-10-23": 48.709827499999996,
                "2025-11-11": 98.71587833333334,
                "2025-11-14": 268.19446166666665,
                "2026-01-13": 100.9135575,
                "2026-01-14": 6.873990277777779,
                "2026-01-17": 13.720363055555556,
                "2026-01-22": 44.609500555555556,
                "2026-02-18": 550.1251161111111,
                "2026-02-25": 180.6259738888889,
                "2026-03-17": 837.9279311111112,
                "2026-03-18": 4.973459999999999,
                "2026-03-27": 3.5997791666666665,
                "2026-04-04": 18.9324625,
                "2026-04-06": 45.584655,
                "2026-04-14": 6.145121111111112,
                "2026-04-22": 890.2183033333333,
                "2026-04-28": 819.2675019444445,
                "2026-05-06": 165.49371916666666,
                "2026-05-21": 16.661681944444446
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-11-11": 1,
                "2025-11-14": 1,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-17": 1,
                "2026-01-22": 1,
                "2026-02-18": 2,
                "2026-02-25": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-27": 1,
                "2026-04-04": 1,
                "2026-04-06": 1,
                "2026-04-14": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-06": 1,
                "2026-05-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 74.18,
              "mode_time_hours": 45.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "44-46h": 2,
                "66-68h": 2,
                "70-72h": 1,
                "122-124h": 1,
                "170-172h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2025-12-26": 1,
                "2026-01-22": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-12-05": 2.2826666666666666,
                "2025-12-26": 71.98823222222222,
                "2026-01-22": 89.27389194444444,
                "2026-02-14": 134.50985111111112,
                "2026-02-16": 123.71852972222221,
                "2026-02-18": 171.6612211111111
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2025-12-26": 1,
                "2026-01-22": 2,
                "2026-02-14": 2,
                "2026-02-16": 1,
                "2026-02-18": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-08": 1,
              "2026-04-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-08": 1,
                "2026-04-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_302": {
      "overall": {
        "avg_time_hours": 392.37,
        "mode_time_hours": 51.0,
        "mode_frequency": 2,
        "time_distribution": {
          "20-22h": 1,
          "32-34h": 1,
          "40-42h": 1,
          "50-52h": 2,
          "2160-2162h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-13": 1,
          "2025-11-22": 1,
          "2026-01-30": 1,
          "2026-04-29": 1,
          "2026-05-14": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-10-23": 50.06450777777778,
          "2025-11-13": 20.039610555555555,
          "2025-11-22": 50.495240833333334,
          "2026-01-30": 32.090313055555555,
          "2026-04-29": 2160.103904166667,
          "2026-05-27": 41.40845777777778
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-13": 1,
          "2025-11-22": 1,
          "2026-01-30": 1,
          "2026-04-29": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 50.06,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-23": 1
          },
          "time_per_day": {
            "2025-10-23": 50.06450777777778
          },
          "time_count_per_day": {
            "2025-10-23": 1
          }
        },
        "P2": {
          "avg_time_hours": 36.75,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "40-42h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-05-14": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2026-01-30": 32.090313055555555,
            "2026-05-27": 41.40845777777778
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 743.55,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "50-52h": 1,
            "2160-2162h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2025-11-22": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2025-11-13": 20.039610555555555,
            "2025-11-22": 50.495240833333334,
            "2026-04-29": 2160.103904166667
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2025-11-22": 1,
            "2026-04-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 392.37,
            "mode_time_hours": 51.0,
            "mode_frequency": 2,
            "time_distribution": {
              "20-22h": 1,
              "32-34h": 1,
              "40-42h": 1,
              "50-52h": 2,
              "2160-2162h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-13": 1,
              "2025-11-22": 1,
              "2026-01-30": 1,
              "2026-04-29": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-10-23": 50.06450777777778,
              "2025-11-13": 20.039610555555555,
              "2025-11-22": 50.495240833333334,
              "2026-01-30": 32.090313055555555,
              "2026-04-29": 2160.103904166667,
              "2026-05-27": 41.40845777777778
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-13": 1,
              "2025-11-22": 1,
              "2026-01-30": 1,
              "2026-04-29": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 50.06,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-23": 1
              },
              "time_per_day": {
                "2025-10-23": 50.06450777777778
              },
              "time_count_per_day": {
                "2025-10-23": 1
              }
            },
            "P2": {
              "avg_time_hours": 36.75,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "40-42h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2026-01-30": 32.090313055555555,
                "2026-05-27": 41.40845777777778
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 743.55,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "50-52h": 1,
                "2160-2162h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2025-11-22": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2025-11-13": 20.039610555555555,
                "2025-11-22": 50.495240833333334,
                "2026-04-29": 2160.103904166667
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2025-11-22": 1,
                "2026-04-29": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_303": {
      "overall": {
        "avg_time_hours": 2.38,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-21": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-10-21": 4.7447486111111115,
          "2026-05-30": 0.012305
        },
        "time_count_per_day": {
          "2025-10-21": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.38,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-10-21": 4.7447486111111115,
            "2026-05-30": 0.012305
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.38,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-21": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-10-21": 4.7447486111111115,
              "2026-05-30": 0.012305
            },
            "time_count_per_day": {
              "2025-10-21": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.38,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-10-21": 4.7447486111111115,
                "2026-05-30": 0.012305
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_304": {
      "overall": {
        "avg_time_hours": 149.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 1,
          "6-8h": 2,
          "12-14h": 2,
          "16-18h": 5,
          "20-22h": 1,
          "22-24h": 2,
          "24-26h": 2,
          "26-28h": 4,
          "28-30h": 1,
          "32-34h": 2,
          "38-40h": 2,
          "42-44h": 1,
          "48-50h": 1,
          "50-52h": 2,
          "54-56h": 1,
          "72-74h": 1,
          "78-80h": 1,
          "88-90h": 1,
          "140-142h": 1,
          "142-144h": 1,
          "146-148h": 1,
          "188-190h": 1,
          "218-220h": 1,
          "240-242h": 1,
          "408-410h": 1,
          "430-432h": 1,
          "508-510h": 1,
          "674-676h": 1,
          "888-890h": 1,
          "1124-1126h": 1,
          "1468-1470h": 1
        },
        "tickets_count": 55,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-22": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2026-01-15": 1,
          "2026-01-17": 1,
          "2026-01-23": 1,
          "2026-01-28": 5,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-14": 2,
          "2026-02-19": 1,
          "2026-02-23": 2,
          "2026-02-24": 2,
          "2026-02-26": 1,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-11": 1,
          "2026-03-17": 2,
          "2026-03-18": 2,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-10": 1,
          "2026-04-14": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-23": 49.284190833333334,
          "2025-11-22": 20.43649361111111,
          "2025-12-02": 0.05849916666666667,
          "2025-12-04": 142.69558111111112,
          "2026-01-15": 1.2270366666666668,
          "2026-01-17": 33.6462875,
          "2026-01-23": 430.0388866666667,
          "2026-01-28": 131.58175194444445,
          "2026-01-30": 7.8660275,
          "2026-01-31": 17.427240277777777,
          "2026-02-09": 50.40468944444445,
          "2026-02-10": 32.51359055555556,
          "2026-02-14": 78.84164944444444,
          "2026-02-23": 42.61685333333333,
          "2026-02-24": 147.23009249999998,
          "2026-02-26": 22.553340000000002,
          "2026-02-28": 79.37093583333333,
          "2026-03-02": 0.9182075,
          "2026-03-04": 7.416329444444444,
          "2026-03-06": 240.3463225,
          "2026-03-09": 509.0830597222222,
          "2026-03-11": 889.1586827777777,
          "2026-03-17": 74.71551055555555,
          "2026-03-18": 33.770896944444445,
          "2026-03-20": 218.50110527777778,
          "2026-03-23": 141.80819222222223,
          "2026-03-24": 16.642145555555555,
          "2026-03-31": 28.57872861111111,
          "2026-04-06": 50.43570361111111,
          "2026-04-07": 22.3874325,
          "2026-04-10": 674.3012722222222,
          "2026-04-14": 1124.3934202777778,
          "2026-04-23": 409.9053097222222,
          "2026-05-05": 189.02691611111112,
          "2026-05-13": 13.547713611111112,
          "2026-05-14": 1469.9602383333336,
          "2026-05-22": 0.7465672222222222,
          "2026-05-26": 13.626547777777779,
          "2026-05-27": 27.365009444444443,
          "2026-05-29": 17.58128388888889,
          "2026-06-05": 54.125810277777774,
          "2026-06-08": 88.53920388888889
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-22": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2026-01-15": 1,
          "2026-01-17": 1,
          "2026-01-23": 1,
          "2026-01-28": 5,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-14": 2,
          "2026-02-23": 2,
          "2026-02-24": 1,
          "2026-02-26": 1,
          "2026-02-28": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-11": 1,
          "2026-03-17": 2,
          "2026-03-18": 2,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-10": 1,
          "2026-04-14": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-29": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 72.6,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "72-74h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 72.59561555555555
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        },
        "P2": {
          "avg_time_hours": 136.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 1,
            "6-8h": 2,
            "12-14h": 2,
            "16-18h": 5,
            "20-22h": 1,
            "22-24h": 2,
            "26-28h": 1,
            "28-30h": 1,
            "38-40h": 2,
            "42-44h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "54-56h": 1,
            "88-90h": 1,
            "140-142h": 1,
            "142-144h": 1,
            "146-148h": 1,
            "188-190h": 1,
            "218-220h": 1,
            "240-242h": 1,
            "408-410h": 1,
            "508-510h": 1,
            "674-676h": 1,
            "888-890h": 1,
            "1124-1126h": 1
          },
          "tickets_count": 42,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-11-22": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2026-01-15": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-14": 2,
            "2026-02-23": 2,
            "2026-02-24": 2,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-10": 1,
            "2026-04-14": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-23": 49.284190833333334,
            "2025-11-22": 20.43649361111111,
            "2025-12-02": 0.05849916666666667,
            "2025-12-04": 142.69558111111112,
            "2026-01-15": 1.2270366666666668,
            "2026-01-30": 7.8660275,
            "2026-01-31": 17.427240277777777,
            "2026-02-14": 78.84164944444444,
            "2026-02-23": 42.61685333333333,
            "2026-02-24": 147.23009249999998,
            "2026-02-26": 22.553340000000002,
            "2026-03-02": 0.9182075,
            "2026-03-04": 7.416329444444444,
            "2026-03-06": 240.3463225,
            "2026-03-09": 509.0830597222222,
            "2026-03-11": 889.1586827777777,
            "2026-03-17": 2.119895,
            "2026-03-18": 33.770896944444445,
            "2026-03-20": 218.50110527777778,
            "2026-03-23": 141.80819222222223,
            "2026-03-24": 16.642145555555555,
            "2026-03-31": 28.57872861111111,
            "2026-04-06": 50.43570361111111,
            "2026-04-07": 22.3874325,
            "2026-04-10": 674.3012722222222,
            "2026-04-14": 1124.3934202777778,
            "2026-04-23": 409.9053097222222,
            "2026-05-05": 189.02691611111112,
            "2026-05-13": 13.547713611111112,
            "2026-05-14": 0.0648275,
            "2026-05-22": 0.7465672222222222,
            "2026-05-26": 13.626547777777779,
            "2026-05-27": 27.365009444444443,
            "2026-05-29": 17.58128388888889,
            "2026-06-05": 54.125810277777774,
            "2026-06-08": 88.53920388888889
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-11-22": 1,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2026-01-15": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-14": 2,
            "2026-02-23": 2,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-18": 2,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-31": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-10": 1,
            "2026-04-14": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 214.81,
          "mode_time_hours": 27.0,
          "mode_frequency": 3,
          "time_distribution": {
            "24-26h": 2,
            "26-28h": 3,
            "32-34h": 2,
            "50-52h": 1,
            "430-432h": 1,
            "1468-1470h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-01-28": 5,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-01-17": 33.6462875,
            "2026-01-23": 430.0388866666667,
            "2026-01-28": 131.58175194444445,
            "2026-02-09": 50.40468944444445,
            "2026-02-10": 32.51359055555556,
            "2026-05-14": 1469.8954108333335
          },
          "time_count_per_day": {
            "2026-01-17": 1,
            "2026-01-23": 1,
            "2026-01-28": 5,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-05-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 79.37,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 79.37093583333333
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 149.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 1,
              "6-8h": 2,
              "12-14h": 2,
              "16-18h": 5,
              "20-22h": 1,
              "22-24h": 2,
              "24-26h": 2,
              "26-28h": 4,
              "28-30h": 1,
              "32-34h": 2,
              "38-40h": 2,
              "42-44h": 1,
              "48-50h": 1,
              "50-52h": 2,
              "54-56h": 1,
              "72-74h": 1,
              "78-80h": 1,
              "88-90h": 1,
              "140-142h": 1,
              "142-144h": 1,
              "146-148h": 1,
              "188-190h": 1,
              "218-220h": 1,
              "240-242h": 1,
              "408-410h": 1,
              "430-432h": 1,
              "508-510h": 1,
              "674-676h": 1,
              "888-890h": 1,
              "1124-1126h": 1,
              "1468-1470h": 1
            },
            "tickets_count": 51,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-22": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2026-01-15": 1,
              "2026-01-17": 1,
              "2026-01-23": 1,
              "2026-01-28": 5,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-14": 2,
              "2026-02-23": 2,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-11": 1,
              "2026-03-17": 2,
              "2026-03-18": 2,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-10": 1,
              "2026-04-14": 1,
              "2026-04-23": 1,
              "2026-05-05": 1,
              "2026-05-13": 1,
              "2026-05-14": 2,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-29": 1,
              "2026-06-05": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-10-23": 49.284190833333334,
              "2025-11-22": 20.43649361111111,
              "2025-12-02": 0.05849916666666667,
              "2025-12-04": 142.69558111111112,
              "2026-01-15": 1.2270366666666668,
              "2026-01-17": 33.6462875,
              "2026-01-23": 430.0388866666667,
              "2026-01-28": 131.58175194444445,
              "2026-01-30": 7.8660275,
              "2026-01-31": 17.427240277777777,
              "2026-02-09": 50.40468944444445,
              "2026-02-10": 32.51359055555556,
              "2026-02-14": 78.84164944444444,
              "2026-02-23": 42.61685333333333,
              "2026-02-24": 147.23009249999998,
              "2026-02-26": 22.553340000000002,
              "2026-02-28": 79.37093583333333,
              "2026-03-02": 0.9182075,
              "2026-03-04": 7.416329444444444,
              "2026-03-06": 240.3463225,
              "2026-03-09": 509.0830597222222,
              "2026-03-11": 889.1586827777777,
              "2026-03-17": 74.71551055555555,
              "2026-03-18": 33.770896944444445,
              "2026-03-20": 218.50110527777778,
              "2026-03-23": 141.80819222222223,
              "2026-03-24": 16.642145555555555,
              "2026-03-31": 28.57872861111111,
              "2026-04-06": 50.43570361111111,
              "2026-04-07": 22.3874325,
              "2026-04-10": 674.3012722222222,
              "2026-04-14": 1124.3934202777778,
              "2026-04-23": 409.9053097222222,
              "2026-05-05": 189.02691611111112,
              "2026-05-13": 13.547713611111112,
              "2026-05-14": 1469.9602383333336,
              "2026-05-22": 0.7465672222222222,
              "2026-05-26": 13.626547777777779,
              "2026-05-27": 27.365009444444443,
              "2026-05-29": 17.58128388888889,
              "2026-06-05": 54.125810277777774,
              "2026-06-08": 88.53920388888889
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-22": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2026-01-15": 1,
              "2026-01-17": 1,
              "2026-01-23": 1,
              "2026-01-28": 5,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-14": 2,
              "2026-02-23": 2,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-02-28": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-11": 1,
              "2026-03-17": 2,
              "2026-03-18": 2,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-10": 1,
              "2026-04-14": 1,
              "2026-04-23": 1,
              "2026-05-05": 1,
              "2026-05-13": 1,
              "2026-05-14": 2,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-29": 1,
              "2026-06-05": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 72.6,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "72-74h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 72.59561555555555
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            },
            "P2": {
              "avg_time_hours": 136.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 1,
                "6-8h": 2,
                "12-14h": 2,
                "16-18h": 5,
                "20-22h": 1,
                "22-24h": 2,
                "26-28h": 1,
                "28-30h": 1,
                "38-40h": 2,
                "42-44h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "54-56h": 1,
                "88-90h": 1,
                "140-142h": 1,
                "142-144h": 1,
                "146-148h": 1,
                "188-190h": 1,
                "218-220h": 1,
                "240-242h": 1,
                "408-410h": 1,
                "508-510h": 1,
                "674-676h": 1,
                "888-890h": 1,
                "1124-1126h": 1
              },
              "tickets_count": 39,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-11-22": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2026-01-15": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-14": 2,
                "2026-02-23": 2,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-31": 1,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-10": 1,
                "2026-04-14": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-29": 1,
                "2026-06-05": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-10-23": 49.284190833333334,
                "2025-11-22": 20.43649361111111,
                "2025-12-02": 0.05849916666666667,
                "2025-12-04": 142.69558111111112,
                "2026-01-15": 1.2270366666666668,
                "2026-01-30": 7.8660275,
                "2026-01-31": 17.427240277777777,
                "2026-02-14": 78.84164944444444,
                "2026-02-23": 42.61685333333333,
                "2026-02-24": 147.23009249999998,
                "2026-02-26": 22.553340000000002,
                "2026-03-02": 0.9182075,
                "2026-03-04": 7.416329444444444,
                "2026-03-06": 240.3463225,
                "2026-03-09": 509.0830597222222,
                "2026-03-11": 889.1586827777777,
                "2026-03-17": 2.119895,
                "2026-03-18": 33.770896944444445,
                "2026-03-20": 218.50110527777778,
                "2026-03-23": 141.80819222222223,
                "2026-03-24": 16.642145555555555,
                "2026-03-31": 28.57872861111111,
                "2026-04-06": 50.43570361111111,
                "2026-04-07": 22.3874325,
                "2026-04-10": 674.3012722222222,
                "2026-04-14": 1124.3934202777778,
                "2026-04-23": 409.9053097222222,
                "2026-05-05": 189.02691611111112,
                "2026-05-13": 13.547713611111112,
                "2026-05-14": 0.0648275,
                "2026-05-22": 0.7465672222222222,
                "2026-05-26": 13.626547777777779,
                "2026-05-27": 27.365009444444443,
                "2026-05-29": 17.58128388888889,
                "2026-06-05": 54.125810277777774,
                "2026-06-08": 88.53920388888889
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-11-22": 1,
                "2025-12-02": 1,
                "2025-12-04": 1,
                "2026-01-15": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-14": 2,
                "2026-02-23": 2,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-18": 2,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-31": 1,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-10": 1,
                "2026-04-14": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-29": 1,
                "2026-06-05": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 214.81,
              "mode_time_hours": 27.0,
              "mode_frequency": 3,
              "time_distribution": {
                "24-26h": 2,
                "26-28h": 3,
                "32-34h": 2,
                "50-52h": 1,
                "430-432h": 1,
                "1468-1470h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-01-28": 5,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-01-17": 33.6462875,
                "2026-01-23": 430.0388866666667,
                "2026-01-28": 131.58175194444445,
                "2026-02-09": 50.40468944444445,
                "2026-02-10": 32.51359055555556,
                "2026-05-14": 1469.8954108333335
              },
              "time_count_per_day": {
                "2026-01-17": 1,
                "2026-01-23": 1,
                "2026-01-28": 5,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-05-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 79.37,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 79.37093583333333
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-24": 1,
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_305": {
      "overall": {
        "avg_time_hours": 320.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 1,
          "6-8h": 2,
          "16-18h": 1,
          "22-24h": 2,
          "74-76h": 1,
          "144-146h": 1,
          "238-240h": 1,
          "240-242h": 1,
          "310-312h": 1,
          "384-386h": 1,
          "426-428h": 1,
          "514-516h": 1,
          "652-654h": 1,
          "668-670h": 1,
          "682-684h": 1,
          "988-990h": 1,
          "1634-1636h": 1
        },
        "tickets_count": 22,
        "tickets_per_day": {
          "2025-10-21": 1,
          "2025-11-17": 1,
          "2025-12-29": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-02-03": 3,
          "2026-02-13": 1,
          "2026-02-19": 1,
          "2026-03-05": 2,
          "2026-03-19": 1,
          "2026-03-23": 1,
          "2026-04-09": 2,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-04-29": 1
        },
        "time_per_day": {
          "2025-10-21": 6.140098611111111,
          "2025-11-17": 144.08582222222222,
          "2025-12-29": 1635.6202116666666,
          "2026-01-08": 0.11379638888888888,
          "2026-01-13": 384.8780997222222,
          "2026-01-22": 5.399786388888889,
          "2026-01-27": 23.967156666666664,
          "2026-02-03": 1171.254365,
          "2026-02-13": 989.5725163888889,
          "2026-02-19": 0.6517105555555556,
          "2026-03-05": 548.8727891666667,
          "2026-03-19": 653.642028888889,
          "2026-03-23": 241.99137166666665,
          "2026-04-09": 23.882895277777777,
          "2026-04-15": 23.22356472222222,
          "2026-04-16": 682.0668877777778,
          "2026-04-23": 0.4256333333333333,
          "2026-04-29": 515.7263330555556
        },
        "time_count_per_day": {
          "2025-10-21": 1,
          "2025-11-17": 1,
          "2025-12-29": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-22": 1,
          "2026-01-27": 1,
          "2026-02-03": 3,
          "2026-02-13": 1,
          "2026-02-19": 1,
          "2026-03-05": 2,
          "2026-03-19": 1,
          "2026-03-23": 1,
          "2026-04-09": 2,
          "2026-04-15": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 318.18,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 1,
            "6-8h": 2,
            "16-18h": 1,
            "22-24h": 1,
            "74-76h": 1,
            "144-146h": 1,
            "238-240h": 1,
            "240-242h": 1,
            "384-386h": 1,
            "426-428h": 1,
            "514-516h": 1,
            "652-654h": 1,
            "668-670h": 1,
            "682-684h": 1,
            "1634-1636h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-10-21": 1,
            "2025-11-17": 1,
            "2025-12-29": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-02-03": 3,
            "2026-03-05": 1,
            "2026-03-19": 1,
            "2026-03-23": 1,
            "2026-04-09": 2,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2025-10-21": 6.140098611111111,
            "2025-11-17": 144.08582222222222,
            "2025-12-29": 1635.6202116666666,
            "2026-01-08": 0.11379638888888888,
            "2026-01-13": 384.8780997222222,
            "2026-01-22": 5.399786388888889,
            "2026-02-03": 1171.254365,
            "2026-03-05": 238.76344305555557,
            "2026-03-19": 653.642028888889,
            "2026-03-23": 241.99137166666665,
            "2026-04-09": 23.882895277777777,
            "2026-04-15": 23.22356472222222,
            "2026-04-16": 682.0668877777778,
            "2026-04-23": 0.4256333333333333,
            "2026-04-29": 515.7263330555556
          },
          "time_count_per_day": {
            "2025-10-21": 1,
            "2025-11-17": 1,
            "2025-12-29": 1,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-02-03": 3,
            "2026-03-05": 1,
            "2026-03-19": 1,
            "2026-03-23": 1,
            "2026-04-09": 2,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-04-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 331.08,
          "mode_time_hours": 989.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1,
            "310-312h": 1,
            "988-990h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-02-13": 1,
            "2026-02-19": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-01-27": 23.967156666666664,
            "2026-02-13": 989.5725163888889,
            "2026-02-19": 0.6517105555555556,
            "2026-03-05": 310.1093461111111
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-02-13": 1,
            "2026-02-19": 1,
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 320.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 1,
              "6-8h": 2,
              "16-18h": 1,
              "22-24h": 2,
              "74-76h": 1,
              "144-146h": 1,
              "238-240h": 1,
              "240-242h": 1,
              "310-312h": 1,
              "384-386h": 1,
              "426-428h": 1,
              "514-516h": 1,
              "652-654h": 1,
              "668-670h": 1,
              "682-684h": 1,
              "988-990h": 1,
              "1634-1636h": 1
            },
            "tickets_count": 22,
            "tickets_per_day": {
              "2025-10-21": 1,
              "2025-11-17": 1,
              "2025-12-29": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-02-03": 3,
              "2026-02-13": 1,
              "2026-02-19": 1,
              "2026-03-05": 2,
              "2026-03-19": 1,
              "2026-03-23": 1,
              "2026-04-09": 2,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-29": 1
            },
            "time_per_day": {
              "2025-10-21": 6.140098611111111,
              "2025-11-17": 144.08582222222222,
              "2025-12-29": 1635.6202116666666,
              "2026-01-08": 0.11379638888888888,
              "2026-01-13": 384.8780997222222,
              "2026-01-22": 5.399786388888889,
              "2026-01-27": 23.967156666666664,
              "2026-02-03": 1171.254365,
              "2026-02-13": 989.5725163888889,
              "2026-02-19": 0.6517105555555556,
              "2026-03-05": 548.8727891666667,
              "2026-03-19": 653.642028888889,
              "2026-03-23": 241.99137166666665,
              "2026-04-09": 23.882895277777777,
              "2026-04-15": 23.22356472222222,
              "2026-04-16": 682.0668877777778,
              "2026-04-23": 0.4256333333333333,
              "2026-04-29": 515.7263330555556
            },
            "time_count_per_day": {
              "2025-10-21": 1,
              "2025-11-17": 1,
              "2025-12-29": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-22": 1,
              "2026-01-27": 1,
              "2026-02-03": 3,
              "2026-02-13": 1,
              "2026-02-19": 1,
              "2026-03-05": 2,
              "2026-03-19": 1,
              "2026-03-23": 1,
              "2026-04-09": 2,
              "2026-04-15": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 318.18,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 1,
                "6-8h": 2,
                "16-18h": 1,
                "22-24h": 1,
                "74-76h": 1,
                "144-146h": 1,
                "238-240h": 1,
                "240-242h": 1,
                "384-386h": 1,
                "426-428h": 1,
                "514-516h": 1,
                "652-654h": 1,
                "668-670h": 1,
                "682-684h": 1,
                "1634-1636h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-10-21": 1,
                "2025-11-17": 1,
                "2025-12-29": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-02-03": 3,
                "2026-03-05": 1,
                "2026-03-19": 1,
                "2026-03-23": 1,
                "2026-04-09": 2,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2025-10-21": 6.140098611111111,
                "2025-11-17": 144.08582222222222,
                "2025-12-29": 1635.6202116666666,
                "2026-01-08": 0.11379638888888888,
                "2026-01-13": 384.8780997222222,
                "2026-01-22": 5.399786388888889,
                "2026-02-03": 1171.254365,
                "2026-03-05": 238.76344305555557,
                "2026-03-19": 653.642028888889,
                "2026-03-23": 241.99137166666665,
                "2026-04-09": 23.882895277777777,
                "2026-04-15": 23.22356472222222,
                "2026-04-16": 682.0668877777778,
                "2026-04-23": 0.4256333333333333,
                "2026-04-29": 515.7263330555556
              },
              "time_count_per_day": {
                "2025-10-21": 1,
                "2025-11-17": 1,
                "2025-12-29": 1,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-02-03": 3,
                "2026-03-05": 1,
                "2026-03-19": 1,
                "2026-03-23": 1,
                "2026-04-09": 2,
                "2026-04-15": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 331.08,
              "mode_time_hours": 989.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1,
                "310-312h": 1,
                "988-990h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-02-13": 1,
                "2026-02-19": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-01-27": 23.967156666666664,
                "2026-02-13": 989.5725163888889,
                "2026-02-19": 0.6517105555555556,
                "2026-03-05": 310.1093461111111
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-02-13": 1,
                "2026-02-19": 1,
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_306": {
      "overall": {
        "avg_time_hours": 62.02,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "42-44h": 1,
          "48-50h": 1,
          "74-76h": 1,
          "124-126h": 1,
          "144-146h": 1,
          "532-534h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-19": 1,
          "2026-02-24": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-28": 2,
          "2026-03-31": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-06": 1,
          "2026-05-18": 1,
          "2026-05-29": 2,
          "2026-06-01": 2,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-10-23": 48.83804055555555,
          "2025-11-19": 1.6435324999999998,
          "2026-02-24": 0.5328702777777778,
          "2026-03-12": 144.43819666666667,
          "2026-03-18": 5.9951308333333335,
          "2026-03-20": 533.3594494444444,
          "2026-03-28": 3.2425611111111112,
          "2026-03-31": 74.49760111111111,
          "2026-04-22": 0.2712441666666667,
          "2026-04-28": 6.844264722222222,
          "2026-05-06": 42.360278888888885,
          "2026-05-18": 124.6729111111111,
          "2026-05-29": 1.6960583333333334,
          "2026-06-01": 2.4290619444444443,
          "2026-06-05": 1.466998611111111
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-19": 1,
          "2026-02-24": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-28": 2,
          "2026-03-31": 1,
          "2026-04-22": 1,
          "2026-04-28": 1,
          "2026-05-06": 1,
          "2026-05-18": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 66.04,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "42-44h": 1,
            "48-50h": 1,
            "74-76h": 1,
            "124-126h": 1,
            "144-146h": 1,
            "532-534h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2026-02-24": 1,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-28": 2,
            "2026-03-31": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-06": 1,
            "2026-05-18": 1,
            "2026-05-29": 2,
            "2026-06-01": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-10-23": 48.83804055555555,
            "2026-02-24": 0.5328702777777778,
            "2026-03-12": 144.43819666666667,
            "2026-03-18": 5.9951308333333335,
            "2026-03-20": 533.3594494444444,
            "2026-03-28": 3.2425611111111112,
            "2026-03-31": 74.49760111111111,
            "2026-04-22": 0.2712441666666667,
            "2026-04-28": 6.844264722222222,
            "2026-05-06": 42.360278888888885,
            "2026-05-18": 124.6729111111111,
            "2026-05-29": 1.6960583333333334,
            "2026-06-01": 2.4290619444444443,
            "2026-06-05": 1.466998611111111
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2026-02-24": 1,
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-28": 2,
            "2026-03-31": 1,
            "2026-04-22": 1,
            "2026-04-28": 1,
            "2026-05-06": 1,
            "2026-05-18": 1,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 1.64,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-11-19": 1.6435324999999998
          },
          "time_count_per_day": {
            "2025-11-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 62.02,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "42-44h": 1,
              "48-50h": 1,
              "74-76h": 1,
              "124-126h": 1,
              "144-146h": 1,
              "532-534h": 1
            },
            "tickets_count": 16,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-19": 1,
              "2026-02-24": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-28": 2,
              "2026-03-31": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-06": 1,
              "2026-05-18": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-23": 48.83804055555555,
              "2025-11-19": 1.6435324999999998,
              "2026-02-24": 0.5328702777777778,
              "2026-03-12": 144.43819666666667,
              "2026-03-18": 5.9951308333333335,
              "2026-03-20": 533.3594494444444,
              "2026-03-28": 3.2425611111111112,
              "2026-03-31": 74.49760111111111,
              "2026-04-22": 0.2712441666666667,
              "2026-04-28": 6.844264722222222,
              "2026-05-06": 42.360278888888885,
              "2026-05-18": 124.6729111111111,
              "2026-05-29": 1.6960583333333334,
              "2026-06-01": 2.4290619444444443,
              "2026-06-05": 1.466998611111111
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-19": 1,
              "2026-02-24": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-28": 2,
              "2026-03-31": 1,
              "2026-04-22": 1,
              "2026-04-28": 1,
              "2026-05-06": 1,
              "2026-05-18": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 66.04,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "42-44h": 1,
                "48-50h": 1,
                "74-76h": 1,
                "124-126h": 1,
                "144-146h": 1,
                "532-534h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2026-02-24": 1,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-28": 2,
                "2026-03-31": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-06": 1,
                "2026-05-18": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-23": 48.83804055555555,
                "2026-02-24": 0.5328702777777778,
                "2026-03-12": 144.43819666666667,
                "2026-03-18": 5.9951308333333335,
                "2026-03-20": 533.3594494444444,
                "2026-03-28": 3.2425611111111112,
                "2026-03-31": 74.49760111111111,
                "2026-04-22": 0.2712441666666667,
                "2026-04-28": 6.844264722222222,
                "2026-05-06": 42.360278888888885,
                "2026-05-18": 124.6729111111111,
                "2026-05-29": 1.6960583333333334,
                "2026-06-01": 2.4290619444444443,
                "2026-06-05": 1.466998611111111
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2026-02-24": 1,
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-03-28": 2,
                "2026-03-31": 1,
                "2026-04-22": 1,
                "2026-04-28": 1,
                "2026-05-06": 1,
                "2026-05-18": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 1.64,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-19": 1
              },
              "time_per_day": {
                "2025-11-19": 1.6435324999999998
              },
              "time_count_per_day": {
                "2025-11-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-29": 1,
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_308": {
      "overall": {
        "avg_time_hours": 68.39,
        "mode_time_hours": 1.0,
        "mode_frequency": 29,
        "time_distribution": {
          "0-2h": 29,
          "2-4h": 9,
          "4-6h": 2,
          "6-8h": 6,
          "8-10h": 1,
          "20-22h": 1,
          "24-26h": 1,
          "30-32h": 3,
          "32-34h": 1,
          "44-46h": 1,
          "48-50h": 1,
          "60-62h": 1,
          "72-74h": 1,
          "82-84h": 2,
          "102-104h": 2,
          "114-116h": 1,
          "154-156h": 1,
          "176-178h": 1,
          "180-182h": 1,
          "224-226h": 1,
          "274-276h": 2,
          "322-324h": 1,
          "380-382h": 1,
          "398-400h": 1,
          "594-596h": 1,
          "1008-1010h": 1
        },
        "tickets_count": 81,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-24": 1,
          "2025-11-30": 2,
          "2025-12-02": 3,
          "2025-12-03": 2,
          "2025-12-11": 1,
          "2025-12-12": 1,
          "2025-12-15": 4,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-30": 1,
          "2026-01-02": 2,
          "2026-01-08": 1,
          "2026-01-12": 2,
          "2026-01-13": 2,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-26": 2,
          "2026-01-30": 1,
          "2026-02-02": 2,
          "2026-02-05": 1,
          "2026-02-11": 2,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-02-28": 1,
          "2026-03-03": 1,
          "2026-03-05": 2,
          "2026-03-18": 5,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-24": 1,
          "2026-04-27": 2,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-09": 1,
          "2026-05-11": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-26": 2,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-05-30": 2,
          "2026-06-03": 1,
          "2026-06-06": 1,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-29": 30.667183333333334,
          "2025-10-31": 224.44245972222222,
          "2025-11-24": 177.48948194444444,
          "2025-11-30": 4.148313611111111,
          "2025-12-02": 137.14200333333335,
          "2025-12-03": 37.87323722222222,
          "2025-12-11": 322.55248,
          "2025-12-12": 6.034345277777778,
          "2025-12-15": 120.42919444444445,
          "2025-12-16": 1.7685433333333334,
          "2025-12-17": 0.204475,
          "2025-12-18": 0.23774638888888888,
          "2025-12-30": 0.907881111111111,
          "2026-01-02": 74.40484027777778,
          "2026-01-08": 8.312381666666667,
          "2026-01-12": 6.076210277777778,
          "2026-01-13": 85.27708055555556,
          "2026-01-14": 1.3308752777777777,
          "2026-01-15": 2.5653191666666664,
          "2026-01-16": 8.034496944444445,
          "2026-01-21": 0.16222722222222222,
          "2026-01-22": 3.5931438888888887,
          "2026-01-23": 0.9440766666666667,
          "2026-01-24": 108.61886305555556,
          "2026-01-26": 7.049937222222223,
          "2026-01-30": 1.625655277777778,
          "2026-02-02": 4.423465,
          "2026-02-05": 0.9291963888888889,
          "2026-02-11": 455.77425583333337,
          "2026-02-18": 61.3663675,
          "2026-02-19": 1207.901695,
          "2026-02-28": 275.7878352777778,
          "2026-03-05": 28.80785333333333,
          "2026-03-18": 939.6330230555556,
          "2026-03-20": 7.3397,
          "2026-03-23": 1.8390247222222222,
          "2026-03-24": 32.39935611111111,
          "2026-05-04": 0.04956222222222222,
          "2026-05-05": 0.24376916666666665,
          "2026-05-09": 0.3030919444444445,
          "2026-05-11": 0.2000313888888889,
          "2026-05-21": 1.859115,
          "2026-05-26": 0.03345027777777778,
          "2026-05-27": 1.5098138888888888,
          "2026-05-28": 4.123704444444444,
          "2026-05-30": 0.4233013888888889,
          "2026-06-06": 595.4352588888889,
          "2026-06-08": 0.5293622222222223
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-24": 1,
          "2025-11-30": 2,
          "2025-12-02": 3,
          "2025-12-03": 2,
          "2025-12-11": 1,
          "2025-12-12": 1,
          "2025-12-15": 4,
          "2025-12-16": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-30": 1,
          "2026-01-02": 2,
          "2026-01-08": 1,
          "2026-01-12": 2,
          "2026-01-13": 2,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-26": 2,
          "2026-01-30": 1,
          "2026-02-02": 2,
          "2026-02-05": 1,
          "2026-02-11": 2,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-02-28": 1,
          "2026-03-05": 2,
          "2026-03-18": 5,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-24": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-09": 1,
          "2026-05-11": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-28": 1,
          "2026-05-30": 2,
          "2026-06-06": 1,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 4.64,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "6-8h": 2
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-30": 2,
            "2025-12-03": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2025-11-30": 4.148313611111111,
            "2025-12-03": 7.062558611111111,
            "2026-03-20": 7.3397
          },
          "time_count_per_day": {
            "2025-11-30": 2,
            "2025-12-03": 1,
            "2026-03-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 20.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 27,
          "time_distribution": {
            "0-2h": 27,
            "2-4h": 5,
            "4-6h": 2,
            "6-8h": 2,
            "8-10h": 1,
            "20-22h": 1,
            "30-32h": 2,
            "102-104h": 1,
            "594-596h": 1
          },
          "tickets_count": 42,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-02": 1,
            "2026-01-08": 1,
            "2026-01-12": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-30": 1,
            "2026-02-05": 1,
            "2026-03-05": 2,
            "2026-03-18": 2,
            "2026-03-23": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-09": 1,
            "2026-05-11": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-30": 2,
            "2026-06-06": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-29": 30.667183333333334,
            "2025-12-02": 103.62102750000001,
            "2025-12-03": 30.81067861111111,
            "2025-12-15": 0.8605866666666667,
            "2025-12-16": 1.7685433333333334,
            "2025-12-17": 0.204475,
            "2025-12-18": 0.23774638888888888,
            "2026-01-02": 1.874933888888889,
            "2026-01-08": 8.312381666666667,
            "2026-01-12": 6.076210277777778,
            "2026-01-13": 1.6444438888888888,
            "2026-01-14": 1.3308752777777777,
            "2026-01-15": 2.5653191666666664,
            "2026-01-16": 8.034496944444445,
            "2026-01-21": 0.16222722222222222,
            "2026-01-22": 3.5931438888888887,
            "2026-01-23": 0.9440766666666667,
            "2026-01-26": 7.049937222222223,
            "2026-01-30": 1.625655277777778,
            "2026-02-05": 0.9291963888888889,
            "2026-03-05": 28.80785333333333,
            "2026-03-18": 2.7362433333333334,
            "2026-03-23": 1.8390247222222222,
            "2026-05-04": 0.04956222222222222,
            "2026-05-05": 0.24376916666666665,
            "2026-05-09": 0.3030919444444445,
            "2026-05-11": 0.2000313888888889,
            "2026-05-21": 1.859115,
            "2026-05-26": 0.03345027777777778,
            "2026-05-27": 1.5098138888888888,
            "2026-05-28": 4.123704444444444,
            "2026-05-30": 0.4233013888888889,
            "2026-06-06": 595.4352588888889,
            "2026-06-08": 0.5293622222222223
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-15": 1,
            "2025-12-16": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2026-01-02": 1,
            "2026-01-08": 1,
            "2026-01-12": 2,
            "2026-01-13": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-16": 2,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-30": 1,
            "2026-02-05": 1,
            "2026-03-05": 2,
            "2026-03-18": 2,
            "2026-03-23": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-09": 1,
            "2026-05-11": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-30": 2,
            "2026-06-06": 1,
            "2026-06-08": 2
          }
        },
        "P3": {
          "avg_time_hours": 11.52,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 3,
            "6-8h": 1,
            "24-26h": 1,
            "30-32h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-02": 2,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2026-02-02": 2
          },
          "time_per_day": {
            "2025-12-02": 33.52097583333333,
            "2025-12-12": 6.034345277777778,
            "2025-12-15": 25.11515361111111,
            "2026-02-02": 4.423465
          },
          "time_count_per_day": {
            "2025-12-02": 2,
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2026-02-02": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 143.29,
          "mode_time_hours": 83.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "32-34h": 1,
            "44-46h": 1,
            "48-50h": 1,
            "60-62h": 1,
            "72-74h": 1,
            "82-84h": 2,
            "102-104h": 1,
            "114-116h": 1,
            "154-156h": 1,
            "176-178h": 1,
            "180-182h": 1,
            "224-226h": 1,
            "274-276h": 2,
            "380-382h": 1,
            "398-400h": 1
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2025-11-24": 1,
            "2025-12-15": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-13": 1,
            "2026-01-24": 2,
            "2026-02-11": 2,
            "2026-02-18": 1,
            "2026-02-19": 2,
            "2026-02-28": 1,
            "2026-03-03": 1,
            "2026-03-18": 3,
            "2026-03-24": 1,
            "2026-04-27": 2,
            "2026-04-29": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-31": 224.44245972222222,
            "2025-11-24": 177.48948194444444,
            "2025-12-15": 94.45345416666667,
            "2025-12-30": 0.907881111111111,
            "2026-01-02": 72.52990638888889,
            "2026-01-13": 83.63263666666667,
            "2026-01-24": 108.61886305555556,
            "2026-02-11": 455.77425583333337,
            "2026-02-18": 61.3663675,
            "2026-02-19": 198.27589,
            "2026-02-28": 275.7878352777778,
            "2026-03-18": 936.8967797222222,
            "2026-03-24": 32.39935611111111
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2025-11-24": 1,
            "2025-12-15": 2,
            "2025-12-30": 1,
            "2026-01-02": 1,
            "2026-01-13": 1,
            "2026-01-24": 2,
            "2026-02-11": 2,
            "2026-02-18": 1,
            "2026-02-19": 2,
            "2026-02-28": 1,
            "2026-03-18": 3,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 666.09,
          "mode_time_hours": 323.0,
          "mode_frequency": 1,
          "time_distribution": {
            "322-324h": 1,
            "1008-1010h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2026-02-14": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-12-11": 322.55248,
            "2026-02-19": 1009.625805
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 68.39,
            "mode_time_hours": 1.0,
            "mode_frequency": 29,
            "time_distribution": {
              "0-2h": 29,
              "2-4h": 9,
              "4-6h": 2,
              "6-8h": 6,
              "8-10h": 1,
              "20-22h": 1,
              "24-26h": 1,
              "30-32h": 3,
              "32-34h": 1,
              "44-46h": 1,
              "48-50h": 1,
              "60-62h": 1,
              "72-74h": 1,
              "82-84h": 2,
              "102-104h": 2,
              "114-116h": 1,
              "154-156h": 1,
              "176-178h": 1,
              "180-182h": 1,
              "224-226h": 1,
              "274-276h": 2,
              "322-324h": 1,
              "380-382h": 1,
              "398-400h": 1,
              "594-596h": 1,
              "1008-1010h": 1
            },
            "tickets_count": 73,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-24": 1,
              "2025-11-30": 2,
              "2025-12-02": 3,
              "2025-12-03": 2,
              "2025-12-11": 1,
              "2025-12-12": 1,
              "2025-12-15": 4,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-30": 1,
              "2026-01-02": 2,
              "2026-01-08": 1,
              "2026-01-12": 2,
              "2026-01-13": 2,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-26": 2,
              "2026-01-30": 1,
              "2026-02-02": 2,
              "2026-02-05": 1,
              "2026-02-11": 2,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-02-28": 1,
              "2026-03-05": 2,
              "2026-03-18": 5,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-24": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-09": 1,
              "2026-05-11": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-28": 1,
              "2026-05-30": 2,
              "2026-06-06": 1,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-29": 30.667183333333334,
              "2025-10-31": 224.44245972222222,
              "2025-11-24": 177.48948194444444,
              "2025-11-30": 4.148313611111111,
              "2025-12-02": 137.14200333333335,
              "2025-12-03": 37.87323722222222,
              "2025-12-11": 322.55248,
              "2025-12-12": 6.034345277777778,
              "2025-12-15": 120.42919444444445,
              "2025-12-16": 1.7685433333333334,
              "2025-12-17": 0.204475,
              "2025-12-18": 0.23774638888888888,
              "2025-12-30": 0.907881111111111,
              "2026-01-02": 74.40484027777778,
              "2026-01-08": 8.312381666666667,
              "2026-01-12": 6.076210277777778,
              "2026-01-13": 85.27708055555556,
              "2026-01-14": 1.3308752777777777,
              "2026-01-15": 2.5653191666666664,
              "2026-01-16": 8.034496944444445,
              "2026-01-21": 0.16222722222222222,
              "2026-01-22": 3.5931438888888887,
              "2026-01-23": 0.9440766666666667,
              "2026-01-24": 108.61886305555556,
              "2026-01-26": 7.049937222222223,
              "2026-01-30": 1.625655277777778,
              "2026-02-02": 4.423465,
              "2026-02-05": 0.9291963888888889,
              "2026-02-11": 455.77425583333337,
              "2026-02-18": 61.3663675,
              "2026-02-19": 1207.901695,
              "2026-02-28": 275.7878352777778,
              "2026-03-05": 28.80785333333333,
              "2026-03-18": 939.6330230555556,
              "2026-03-20": 7.3397,
              "2026-03-23": 1.8390247222222222,
              "2026-03-24": 32.39935611111111,
              "2026-05-04": 0.04956222222222222,
              "2026-05-05": 0.24376916666666665,
              "2026-05-09": 0.3030919444444445,
              "2026-05-11": 0.2000313888888889,
              "2026-05-21": 1.859115,
              "2026-05-26": 0.03345027777777778,
              "2026-05-27": 1.5098138888888888,
              "2026-05-28": 4.123704444444444,
              "2026-05-30": 0.4233013888888889,
              "2026-06-06": 595.4352588888889,
              "2026-06-08": 0.5293622222222223
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-24": 1,
              "2025-11-30": 2,
              "2025-12-02": 3,
              "2025-12-03": 2,
              "2025-12-11": 1,
              "2025-12-12": 1,
              "2025-12-15": 4,
              "2025-12-16": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-30": 1,
              "2026-01-02": 2,
              "2026-01-08": 1,
              "2026-01-12": 2,
              "2026-01-13": 2,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-24": 2,
              "2026-01-26": 2,
              "2026-01-30": 1,
              "2026-02-02": 2,
              "2026-02-05": 1,
              "2026-02-11": 2,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-02-28": 1,
              "2026-03-05": 2,
              "2026-03-18": 5,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-24": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-09": 1,
              "2026-05-11": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-05-28": 1,
              "2026-05-30": 2,
              "2026-06-06": 1,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 4.64,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "6-8h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-30": 2,
                "2025-12-03": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2025-11-30": 4.148313611111111,
                "2025-12-03": 7.062558611111111,
                "2026-03-20": 7.3397
              },
              "time_count_per_day": {
                "2025-11-30": 2,
                "2025-12-03": 1,
                "2026-03-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 20.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 27,
              "time_distribution": {
                "0-2h": 27,
                "2-4h": 5,
                "4-6h": 2,
                "6-8h": 2,
                "8-10h": 1,
                "20-22h": 1,
                "30-32h": 2,
                "102-104h": 1,
                "594-596h": 1
              },
              "tickets_count": 42,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-02": 1,
                "2026-01-08": 1,
                "2026-01-12": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-30": 1,
                "2026-02-05": 1,
                "2026-03-05": 2,
                "2026-03-18": 2,
                "2026-03-23": 2,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-09": 1,
                "2026-05-11": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-05-30": 2,
                "2026-06-06": 1,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-10-29": 30.667183333333334,
                "2025-12-02": 103.62102750000001,
                "2025-12-03": 30.81067861111111,
                "2025-12-15": 0.8605866666666667,
                "2025-12-16": 1.7685433333333334,
                "2025-12-17": 0.204475,
                "2025-12-18": 0.23774638888888888,
                "2026-01-02": 1.874933888888889,
                "2026-01-08": 8.312381666666667,
                "2026-01-12": 6.076210277777778,
                "2026-01-13": 1.6444438888888888,
                "2026-01-14": 1.3308752777777777,
                "2026-01-15": 2.5653191666666664,
                "2026-01-16": 8.034496944444445,
                "2026-01-21": 0.16222722222222222,
                "2026-01-22": 3.5931438888888887,
                "2026-01-23": 0.9440766666666667,
                "2026-01-26": 7.049937222222223,
                "2026-01-30": 1.625655277777778,
                "2026-02-05": 0.9291963888888889,
                "2026-03-05": 28.80785333333333,
                "2026-03-18": 2.7362433333333334,
                "2026-03-23": 1.8390247222222222,
                "2026-05-04": 0.04956222222222222,
                "2026-05-05": 0.24376916666666665,
                "2026-05-09": 0.3030919444444445,
                "2026-05-11": 0.2000313888888889,
                "2026-05-21": 1.859115,
                "2026-05-26": 0.03345027777777778,
                "2026-05-27": 1.5098138888888888,
                "2026-05-28": 4.123704444444444,
                "2026-05-30": 0.4233013888888889,
                "2026-06-06": 595.4352588888889,
                "2026-06-08": 0.5293622222222223
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-15": 1,
                "2025-12-16": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2026-01-02": 1,
                "2026-01-08": 1,
                "2026-01-12": 2,
                "2026-01-13": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-16": 2,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-26": 2,
                "2026-01-30": 1,
                "2026-02-05": 1,
                "2026-03-05": 2,
                "2026-03-18": 2,
                "2026-03-23": 2,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-09": 1,
                "2026-05-11": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-05-28": 1,
                "2026-05-30": 2,
                "2026-06-06": 1,
                "2026-06-08": 2
              }
            },
            "P3": {
              "avg_time_hours": 11.52,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 3,
                "6-8h": 1,
                "24-26h": 1,
                "30-32h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-02": 2,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2026-02-02": 2
              },
              "time_per_day": {
                "2025-12-02": 33.52097583333333,
                "2025-12-12": 6.034345277777778,
                "2025-12-15": 25.11515361111111,
                "2026-02-02": 4.423465
              },
              "time_count_per_day": {
                "2025-12-02": 2,
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2026-02-02": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 143.29,
              "mode_time_hours": 83.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "32-34h": 1,
                "44-46h": 1,
                "48-50h": 1,
                "60-62h": 1,
                "72-74h": 1,
                "82-84h": 2,
                "102-104h": 1,
                "114-116h": 1,
                "154-156h": 1,
                "176-178h": 1,
                "180-182h": 1,
                "224-226h": 1,
                "274-276h": 2,
                "380-382h": 1,
                "398-400h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2025-11-24": 1,
                "2025-12-15": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-13": 1,
                "2026-01-24": 2,
                "2026-02-11": 2,
                "2026-02-18": 1,
                "2026-02-19": 2,
                "2026-02-28": 1,
                "2026-03-18": 3,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-10-31": 224.44245972222222,
                "2025-11-24": 177.48948194444444,
                "2025-12-15": 94.45345416666667,
                "2025-12-30": 0.907881111111111,
                "2026-01-02": 72.52990638888889,
                "2026-01-13": 83.63263666666667,
                "2026-01-24": 108.61886305555556,
                "2026-02-11": 455.77425583333337,
                "2026-02-18": 61.3663675,
                "2026-02-19": 198.27589,
                "2026-02-28": 275.7878352777778,
                "2026-03-18": 936.8967797222222,
                "2026-03-24": 32.39935611111111
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2025-11-24": 1,
                "2025-12-15": 2,
                "2025-12-30": 1,
                "2026-01-02": 1,
                "2026-01-13": 1,
                "2026-01-24": 2,
                "2026-02-11": 2,
                "2026-02-18": 1,
                "2026-02-19": 2,
                "2026-02-28": 1,
                "2026-03-18": 3,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 666.09,
              "mode_time_hours": 323.0,
              "mode_frequency": 1,
              "time_distribution": {
                "322-324h": 1,
                "1008-1010h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-12-11": 322.55248,
                "2026-02-19": 1009.625805
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-04-27": 2,
              "2026-04-29": 1,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-04-27": 2,
                "2026-04-29": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_310": {
      "overall": {
        "avg_time_hours": 5.48,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-22": 1
        },
        "time_per_day": {
          "2025-10-22": 5.478326111111111
        },
        "time_count_per_day": {
          "2025-10-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.48,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-22": 1
          },
          "time_per_day": {
            "2025-10-22": 5.478326111111111
          },
          "time_count_per_day": {
            "2025-10-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.48,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-22": 1
            },
            "time_per_day": {
              "2025-10-22": 5.478326111111111
            },
            "time_count_per_day": {
              "2025-10-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.48,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-22": 1
              },
              "time_per_day": {
                "2025-10-22": 5.478326111111111
              },
              "time_count_per_day": {
                "2025-10-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_311": {
      "overall": {
        "avg_time_hours": 339.96,
        "mode_time_hours": 145.0,
        "mode_frequency": 1,
        "time_distribution": {
          "144-146h": 1,
          "534-536h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-28": 1,
          "2026-02-17": 1
        },
        "time_per_day": {
          "2025-10-28": 144.36428777777778,
          "2026-02-17": 535.5603763888889
        },
        "time_count_per_day": {
          "2025-10-28": 1,
          "2026-02-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 339.96,
          "mode_time_hours": 145.0,
          "mode_frequency": 1,
          "time_distribution": {
            "144-146h": 1,
            "534-536h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2026-02-17": 1
          },
          "time_per_day": {
            "2025-10-28": 144.36428777777778,
            "2026-02-17": 535.5603763888889
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2026-02-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 339.96,
            "mode_time_hours": 145.0,
            "mode_frequency": 1,
            "time_distribution": {
              "144-146h": 1,
              "534-536h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-28": 1,
              "2026-02-17": 1
            },
            "time_per_day": {
              "2025-10-28": 144.36428777777778,
              "2026-02-17": 535.5603763888889
            },
            "time_count_per_day": {
              "2025-10-28": 1,
              "2026-02-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 339.96,
              "mode_time_hours": 145.0,
              "mode_frequency": 1,
              "time_distribution": {
                "144-146h": 1,
                "534-536h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2026-02-17": 1
              },
              "time_per_day": {
                "2025-10-28": 144.36428777777778,
                "2026-02-17": 535.5603763888889
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2026-02-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_312": {
      "overall": {
        "avg_time_hours": 40.33,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "16-18h": 1,
          "144-146h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-28": 2,
          "2026-04-11": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-10-28": 144.5571363888889,
          "2026-04-11": 16.76419333333333,
          "2026-05-30": 0.012914444444444444
        },
        "time_count_per_day": {
          "2025-10-28": 2,
          "2026-04-11": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "16-18h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2026-04-11": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-10-28": 0.18923777777777778,
            "2026-04-11": 16.76419333333333,
            "2026-05-30": 0.012914444444444444
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2026-04-11": 1,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 144.37,
          "mode_time_hours": 145.0,
          "mode_frequency": 1,
          "time_distribution": {
            "144-146h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 144.36789861111112
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 40.33,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "16-18h": 1,
              "144-146h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-28": 2,
              "2026-04-11": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-10-28": 144.5571363888889,
              "2026-04-11": 16.76419333333333,
              "2026-05-30": 0.012914444444444444
            },
            "time_count_per_day": {
              "2025-10-28": 2,
              "2026-04-11": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "16-18h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2026-04-11": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-10-28": 0.18923777777777778,
                "2026-04-11": 16.76419333333333,
                "2026-05-30": 0.012914444444444444
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2026-04-11": 1,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 144.37,
              "mode_time_hours": 145.0,
              "mode_frequency": 1,
              "time_distribution": {
                "144-146h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 144.36789861111112
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_201": {
      "overall": {
        "avg_time_hours": 191.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 1,
          "14-16h": 1,
          "22-24h": 1,
          "42-44h": 1,
          "68-70h": 1,
          "100-102h": 2,
          "530-532h": 1,
          "654-656h": 1,
          "940-942h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-10-23": 3,
          "2025-10-27": 2,
          "2025-12-09": 1,
          "2026-01-30": 1,
          "2026-02-04": 1,
          "2026-02-06": 2,
          "2026-03-20": 1,
          "2026-04-08": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-10-23": 24.322087777777778,
          "2025-10-27": 201.33656583333334,
          "2025-12-09": 69.79827888888889,
          "2026-01-30": 940.7604397222223,
          "2026-02-04": 0.8882641666666667,
          "2026-02-06": 48.003099444444445,
          "2026-03-20": 530.229545,
          "2026-04-08": 15.214073055555556,
          "2026-04-23": 654.07782
        },
        "time_count_per_day": {
          "2025-10-23": 3,
          "2025-10-27": 2,
          "2025-12-09": 1,
          "2026-01-30": 1,
          "2026-02-04": 1,
          "2026-02-06": 2,
          "2026-03-20": 1,
          "2026-04-08": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 940.76,
          "mode_time_hours": 941.0,
          "mode_frequency": 1,
          "time_distribution": {
            "940-942h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-30": 1
          },
          "time_per_day": {
            "2026-01-30": 940.7604397222223
          },
          "time_count_per_day": {
            "2026-01-30": 1
          }
        },
        "P2": {
          "avg_time_hours": 138.19,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 1,
            "14-16h": 1,
            "42-44h": 1,
            "68-70h": 1,
            "100-102h": 2,
            "530-532h": 1,
            "654-656h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-23": 2,
            "2025-10-27": 2,
            "2025-12-09": 1,
            "2026-02-04": 1,
            "2026-02-06": 2,
            "2026-03-20": 1,
            "2026-04-08": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-10-23": 0.5533819444444444,
            "2025-10-27": 201.33656583333334,
            "2025-12-09": 69.79827888888889,
            "2026-02-04": 0.8882641666666667,
            "2026-02-06": 48.003099444444445,
            "2026-03-20": 530.229545,
            "2026-04-08": 15.214073055555556,
            "2026-04-23": 654.07782
          },
          "time_count_per_day": {
            "2025-10-23": 2,
            "2025-10-27": 2,
            "2025-12-09": 1,
            "2026-02-04": 1,
            "2026-02-06": 2,
            "2026-03-20": 1,
            "2026-04-08": 1,
            "2026-04-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 23.77,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-23": 1
          },
          "time_per_day": {
            "2025-10-23": 23.768705833333332
          },
          "time_count_per_day": {
            "2025-10-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 191.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 1,
              "14-16h": 1,
              "22-24h": 1,
              "42-44h": 1,
              "68-70h": 1,
              "100-102h": 2,
              "530-532h": 1,
              "654-656h": 1,
              "940-942h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-10-23": 3,
              "2025-10-27": 2,
              "2025-12-09": 1,
              "2026-01-30": 1,
              "2026-02-04": 1,
              "2026-02-06": 2,
              "2026-03-20": 1,
              "2026-04-08": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-10-23": 24.322087777777778,
              "2025-10-27": 201.33656583333334,
              "2025-12-09": 69.79827888888889,
              "2026-01-30": 940.7604397222223,
              "2026-02-04": 0.8882641666666667,
              "2026-02-06": 48.003099444444445,
              "2026-03-20": 530.229545,
              "2026-04-08": 15.214073055555556,
              "2026-04-23": 654.07782
            },
            "time_count_per_day": {
              "2025-10-23": 3,
              "2025-10-27": 2,
              "2025-12-09": 1,
              "2026-01-30": 1,
              "2026-02-04": 1,
              "2026-02-06": 2,
              "2026-03-20": 1,
              "2026-04-08": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 940.76,
              "mode_time_hours": 941.0,
              "mode_frequency": 1,
              "time_distribution": {
                "940-942h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-30": 1
              },
              "time_per_day": {
                "2026-01-30": 940.7604397222223
              },
              "time_count_per_day": {
                "2026-01-30": 1
              }
            },
            "P2": {
              "avg_time_hours": 138.19,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 1,
                "14-16h": 1,
                "42-44h": 1,
                "68-70h": 1,
                "100-102h": 2,
                "530-532h": 1,
                "654-656h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-10-23": 2,
                "2025-10-27": 2,
                "2025-12-09": 1,
                "2026-02-04": 1,
                "2026-02-06": 2,
                "2026-03-20": 1,
                "2026-04-08": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-10-23": 0.5533819444444444,
                "2025-10-27": 201.33656583333334,
                "2025-12-09": 69.79827888888889,
                "2026-02-04": 0.8882641666666667,
                "2026-02-06": 48.003099444444445,
                "2026-03-20": 530.229545,
                "2026-04-08": 15.214073055555556,
                "2026-04-23": 654.07782
              },
              "time_count_per_day": {
                "2025-10-23": 2,
                "2025-10-27": 2,
                "2025-12-09": 1,
                "2026-02-04": 1,
                "2026-02-06": 2,
                "2026-03-20": 1,
                "2026-04-08": 1,
                "2026-04-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 23.77,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-23": 1
              },
              "time_per_day": {
                "2025-10-23": 23.768705833333332
              },
              "time_count_per_day": {
                "2025-10-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_68": {
      "overall": {
        "avg_time_hours": 140.45,
        "mode_time_hours": 141.0,
        "mode_frequency": 1,
        "time_distribution": {
          "140-142h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-28": 1,
          "2026-04-24": 1
        },
        "time_per_day": {
          "2025-10-28": 140.44805833333334
        },
        "time_count_per_day": {
          "2025-10-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-24": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": 140.45,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 140.44805833333334
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 140.45,
            "mode_time_hours": 141.0,
            "mode_frequency": 1,
            "time_distribution": {
              "140-142h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-28": 1
            },
            "time_per_day": {
              "2025-10-28": 140.44805833333334
            },
            "time_count_per_day": {
              "2025-10-28": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 140.45,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 140.44805833333334
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_317": {
      "overall": {
        "avg_time_hours": 128.45,
        "mode_time_hours": 129.0,
        "mode_frequency": 1,
        "time_distribution": {
          "128-130h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-28": 1
        },
        "time_per_day": {
          "2025-10-28": 128.4464625
        },
        "time_count_per_day": {
          "2025-10-28": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 128.45,
          "mode_time_hours": 129.0,
          "mode_frequency": 1,
          "time_distribution": {
            "128-130h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 128.4464625
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 128.45,
            "mode_time_hours": 129.0,
            "mode_frequency": 1,
            "time_distribution": {
              "128-130h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-28": 1
            },
            "time_per_day": {
              "2025-10-28": 128.4464625
            },
            "time_count_per_day": {
              "2025-10-28": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 128.45,
              "mode_time_hours": 129.0,
              "mode_frequency": 1,
              "time_distribution": {
                "128-130h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 128.4464625
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_282": {
      "overall": {
        "avg_time_hours": 137.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 16,
        "time_distribution": {
          "0-2h": 16,
          "2-4h": 3,
          "8-10h": 1,
          "12-14h": 3,
          "14-16h": 2,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "40-42h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "56-58h": 1,
          "58-60h": 1,
          "60-62h": 1,
          "62-64h": 1,
          "74-76h": 1,
          "86-88h": 1,
          "92-94h": 2,
          "94-96h": 1,
          "100-102h": 1,
          "110-112h": 1,
          "148-150h": 1,
          "182-184h": 1,
          "202-204h": 1,
          "204-206h": 1,
          "208-210h": 1,
          "306-308h": 1,
          "372-374h": 1,
          "378-380h": 2,
          "472-474h": 1,
          "528-530h": 1,
          "540-542h": 1,
          "616-618h": 1,
          "696-698h": 1,
          "724-726h": 1,
          "730-732h": 1,
          "732-734h": 1
        },
        "tickets_count": 75,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2025-12-05": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-01-23": 2,
          "2026-01-27": 1,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-28": 2,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 4,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-06": 9,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-14": 1,
          "2026-04-16": 1,
          "2026-04-17": 2,
          "2026-04-23": 2,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-05": 2,
          "2026-05-06": 4,
          "2026-05-08": 1,
          "2026-05-13": 1,
          "2026-05-22": 1,
          "2026-05-26": 2,
          "2026-06-02": 1,
          "2026-06-05": 2,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2025-10-23": 0.5085061111111111,
          "2025-10-27": 29.283506666666664,
          "2025-11-17": 101.23430611111111,
          "2025-11-19": 18.03894888888889,
          "2025-11-20": 23.0173075,
          "2025-11-21": 48.77959555555555,
          "2025-11-24": 148.3761788888889,
          "2025-12-04": 16.610202222222224,
          "2025-12-05": 40.192189722222224,
          "2026-01-08": 0.16816166666666665,
          "2026-01-13": 1.5084827777777776,
          "2026-01-14": 21.024493888888887,
          "2026-01-15": 24.132896388888888,
          "2026-01-22": 51.19769527777778,
          "2026-01-23": 112.8816361111111,
          "2026-01-27": 110.73352916666667,
          "2026-01-31": 2.6259602777777777,
          "2026-02-03": 134.0128936111111,
          "2026-02-04": 307.93972527777777,
          "2026-02-10": 472.8589602777778,
          "2026-02-18": 118.79044499999999,
          "2026-02-19": 732.9221688888889,
          "2026-02-28": 186.47370305555555,
          "2026-03-04": 0.4067397222222222,
          "2026-03-06": 208.63359222222223,
          "2026-03-10": 183.24211472222223,
          "2026-03-18": 1687.798175,
          "2026-03-25": 12.822882777777776,
          "2026-03-31": 8.471599722222221,
          "2026-04-02": 0.6671658333333333,
          "2026-04-06": 102.75501138888887,
          "2026-04-07": 0.19231805555555556,
          "2026-04-08": 29.273984444444444,
          "2026-04-09": 12.902833333333332,
          "2026-04-14": 0.08069222222222222,
          "2026-04-16": 731.4764961111111,
          "2026-04-23": 697.3143769444445,
          "2026-04-27": 62.39317333333333,
          "2026-05-04": 48.05774277777778,
          "2026-05-05": 528.4896791666666,
          "2026-05-06": 1207.0896188888892,
          "2026-05-08": 540.6187125,
          "2026-05-22": 0.1839711111111111,
          "2026-05-26": 0.18225444444444444,
          "2026-06-02": 3.27009
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-10-27": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-20": 1,
          "2025-11-21": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2025-12-05": 1,
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-01-23": 2,
          "2026-01-27": 1,
          "2026-01-31": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-02-19": 1,
          "2026-02-28": 2,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 4,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-06": 9,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-09": 1,
          "2026-04-14": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 4,
          "2026-05-08": 1,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 109.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 3,
            "8-10h": 1,
            "12-14h": 3,
            "14-16h": 2,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "28-30h": 1,
            "40-42h": 1,
            "48-50h": 2,
            "62-64h": 1,
            "74-76h": 1,
            "94-96h": 1,
            "182-184h": 1,
            "204-206h": 1,
            "306-308h": 1,
            "372-374h": 1,
            "528-530h": 1,
            "540-542h": 1,
            "616-618h": 1,
            "696-698h": 1,
            "730-732h": 1
          },
          "tickets_count": 53,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-11-19": 1,
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-03-04": 1,
            "2026-03-10": 1,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-06": 9,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-17": 2,
            "2026-04-23": 2,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-05": 2,
            "2026-05-06": 4,
            "2026-05-08": 1,
            "2026-05-13": 1,
            "2026-05-22": 1,
            "2026-05-26": 2,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2025-10-23": 0.5085061111111111,
            "2025-10-27": 29.283506666666664,
            "2025-11-19": 18.03894888888889,
            "2025-11-21": 48.77959555555555,
            "2025-12-04": 16.610202222222224,
            "2025-12-05": 40.192189722222224,
            "2026-01-08": 0.16816166666666665,
            "2026-01-14": 21.024493888888887,
            "2026-01-31": 2.6259602777777777,
            "2026-02-03": 74.41934527777778,
            "2026-02-04": 307.93972527777777,
            "2026-03-04": 0.4067397222222222,
            "2026-03-10": 183.24211472222223,
            "2026-03-25": 12.822882777777776,
            "2026-03-31": 8.471599722222221,
            "2026-04-02": 0.6671658333333333,
            "2026-04-06": 102.75501138888887,
            "2026-04-07": 0.19231805555555556,
            "2026-04-08": 29.273984444444444,
            "2026-04-09": 12.902833333333332,
            "2026-04-14": 0.08069222222222222,
            "2026-04-16": 731.4764961111111,
            "2026-04-23": 697.3143769444445,
            "2026-04-27": 62.39317333333333,
            "2026-05-04": 48.05774277777778,
            "2026-05-05": 528.4896791666666,
            "2026-05-06": 1207.0896188888892,
            "2026-05-08": 540.6187125,
            "2026-05-22": 0.1839711111111111,
            "2026-05-26": 0.18225444444444444,
            "2026-06-02": 3.27009
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-10-27": 1,
            "2025-11-19": 1,
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-03-04": 1,
            "2026-03-10": 1,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-06": 9,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 1,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-08": 1,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 103.57,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "50-52h": 1,
            "56-58h": 1,
            "58-60h": 1,
            "60-62h": 1,
            "100-102h": 1,
            "110-112h": 1,
            "148-150h": 1,
            "208-210h": 1,
            "472-474h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-11-24": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-18": 2,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2025-11-17": 101.23430611111111,
            "2025-11-20": 23.0173075,
            "2025-11-24": 148.3761788888889,
            "2026-01-13": 1.5084827777777776,
            "2026-01-15": 24.132896388888888,
            "2026-01-22": 51.19769527777778,
            "2026-01-23": 26.389730833333335,
            "2026-01-27": 110.73352916666667,
            "2026-02-03": 59.59354833333334,
            "2026-02-10": 472.8589602777778,
            "2026-02-18": 118.79044499999999,
            "2026-03-06": 208.63359222222223
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-20": 1,
            "2025-11-24": 1,
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-18": 2,
            "2026-03-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 280.11,
          "mode_time_hours": 93.0,
          "mode_frequency": 2,
          "time_distribution": {
            "86-88h": 1,
            "92-94h": 2,
            "202-204h": 1,
            "378-380h": 2,
            "724-726h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-01-23": 1,
            "2026-02-28": 2,
            "2026-03-18": 4
          },
          "time_per_day": {
            "2026-01-23": 86.49190527777778,
            "2026-02-28": 186.47370305555555,
            "2026-03-18": 1687.798175
          },
          "time_count_per_day": {
            "2026-01-23": 1,
            "2026-02-28": 2,
            "2026-03-18": 4
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 732.92,
          "mode_time_hours": 733.0,
          "mode_frequency": 1,
          "time_distribution": {
            "732-734h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-19": 732.9221688888889
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 137.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 16,
            "time_distribution": {
              "0-2h": 16,
              "2-4h": 3,
              "8-10h": 1,
              "12-14h": 3,
              "14-16h": 2,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "40-42h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "56-58h": 1,
              "58-60h": 1,
              "60-62h": 1,
              "62-64h": 1,
              "74-76h": 1,
              "86-88h": 1,
              "92-94h": 2,
              "94-96h": 1,
              "100-102h": 1,
              "110-112h": 1,
              "148-150h": 1,
              "182-184h": 1,
              "202-204h": 1,
              "204-206h": 1,
              "208-210h": 1,
              "306-308h": 1,
              "372-374h": 1,
              "378-380h": 2,
              "472-474h": 1,
              "528-530h": 1,
              "540-542h": 1,
              "616-618h": 1,
              "696-698h": 1,
              "724-726h": 1,
              "730-732h": 1,
              "732-734h": 1
            },
            "tickets_count": 64,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2025-12-05": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-01-23": 2,
              "2026-01-27": 1,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-02-19": 1,
              "2026-02-28": 2,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 4,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-06": 9,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-14": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-08": 1,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-10-23": 0.5085061111111111,
              "2025-10-27": 29.283506666666664,
              "2025-11-17": 101.23430611111111,
              "2025-11-19": 18.03894888888889,
              "2025-11-20": 23.0173075,
              "2025-11-21": 48.77959555555555,
              "2025-11-24": 148.3761788888889,
              "2025-12-04": 16.610202222222224,
              "2025-12-05": 40.192189722222224,
              "2026-01-08": 0.16816166666666665,
              "2026-01-13": 1.5084827777777776,
              "2026-01-14": 21.024493888888887,
              "2026-01-15": 24.132896388888888,
              "2026-01-22": 51.19769527777778,
              "2026-01-23": 112.8816361111111,
              "2026-01-27": 110.73352916666667,
              "2026-01-31": 2.6259602777777777,
              "2026-02-03": 134.0128936111111,
              "2026-02-04": 307.93972527777777,
              "2026-02-10": 472.8589602777778,
              "2026-02-18": 118.79044499999999,
              "2026-02-19": 732.9221688888889,
              "2026-02-28": 186.47370305555555,
              "2026-03-04": 0.4067397222222222,
              "2026-03-06": 208.63359222222223,
              "2026-03-10": 183.24211472222223,
              "2026-03-18": 1687.798175,
              "2026-03-25": 12.822882777777776,
              "2026-03-31": 8.471599722222221,
              "2026-04-02": 0.6671658333333333,
              "2026-04-06": 102.75501138888887,
              "2026-04-07": 0.19231805555555556,
              "2026-04-08": 29.273984444444444,
              "2026-04-09": 12.902833333333332,
              "2026-04-14": 0.08069222222222222,
              "2026-04-16": 731.4764961111111,
              "2026-04-23": 697.3143769444445,
              "2026-04-27": 62.39317333333333,
              "2026-05-04": 48.05774277777778,
              "2026-05-05": 528.4896791666666,
              "2026-05-06": 1207.0896188888892,
              "2026-05-08": 540.6187125,
              "2026-05-22": 0.1839711111111111,
              "2026-05-26": 0.18225444444444444,
              "2026-06-02": 3.27009
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-10-27": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-20": 1,
              "2025-11-21": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2025-12-05": 1,
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-01-23": 2,
              "2026-01-27": 1,
              "2026-01-31": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-02-19": 1,
              "2026-02-28": 2,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 4,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-06": 9,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 1,
              "2026-04-14": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-08": 1,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 109.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 3,
                "8-10h": 1,
                "12-14h": 3,
                "14-16h": 2,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "28-30h": 1,
                "40-42h": 1,
                "48-50h": 2,
                "62-64h": 1,
                "74-76h": 1,
                "94-96h": 1,
                "182-184h": 1,
                "204-206h": 1,
                "306-308h": 1,
                "372-374h": 1,
                "528-530h": 1,
                "540-542h": 1,
                "616-618h": 1,
                "696-698h": 1,
                "730-732h": 1
              },
              "tickets_count": 43,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-11-19": 1,
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-03-04": 1,
                "2026-03-10": 1,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-06": 9,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-08": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-10-23": 0.5085061111111111,
                "2025-10-27": 29.283506666666664,
                "2025-11-19": 18.03894888888889,
                "2025-11-21": 48.77959555555555,
                "2025-12-04": 16.610202222222224,
                "2025-12-05": 40.192189722222224,
                "2026-01-08": 0.16816166666666665,
                "2026-01-14": 21.024493888888887,
                "2026-01-31": 2.6259602777777777,
                "2026-02-03": 74.41934527777778,
                "2026-02-04": 307.93972527777777,
                "2026-03-04": 0.4067397222222222,
                "2026-03-10": 183.24211472222223,
                "2026-03-25": 12.822882777777776,
                "2026-03-31": 8.471599722222221,
                "2026-04-02": 0.6671658333333333,
                "2026-04-06": 102.75501138888887,
                "2026-04-07": 0.19231805555555556,
                "2026-04-08": 29.273984444444444,
                "2026-04-09": 12.902833333333332,
                "2026-04-14": 0.08069222222222222,
                "2026-04-16": 731.4764961111111,
                "2026-04-23": 697.3143769444445,
                "2026-04-27": 62.39317333333333,
                "2026-05-04": 48.05774277777778,
                "2026-05-05": 528.4896791666666,
                "2026-05-06": 1207.0896188888892,
                "2026-05-08": 540.6187125,
                "2026-05-22": 0.1839711111111111,
                "2026-05-26": 0.18225444444444444,
                "2026-06-02": 3.27009
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-10-27": 1,
                "2025-11-19": 1,
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2025-12-05": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-03-04": 1,
                "2026-03-10": 1,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-06": 9,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 1,
                "2026-04-14": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-04-27": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-08": 1,
                "2026-05-22": 1,
                "2026-05-26": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 103.57,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "50-52h": 1,
                "56-58h": 1,
                "58-60h": 1,
                "60-62h": 1,
                "100-102h": 1,
                "110-112h": 1,
                "148-150h": 1,
                "208-210h": 1,
                "472-474h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-11-24": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-18": 2,
                "2026-03-06": 1
              },
              "time_per_day": {
                "2025-11-17": 101.23430611111111,
                "2025-11-20": 23.0173075,
                "2025-11-24": 148.3761788888889,
                "2026-01-13": 1.5084827777777776,
                "2026-01-15": 24.132896388888888,
                "2026-01-22": 51.19769527777778,
                "2026-01-23": 26.389730833333335,
                "2026-01-27": 110.73352916666667,
                "2026-02-03": 59.59354833333334,
                "2026-02-10": 472.8589602777778,
                "2026-02-18": 118.79044499999999,
                "2026-03-06": 208.63359222222223
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-20": 1,
                "2025-11-24": 1,
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-18": 2,
                "2026-03-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 280.11,
              "mode_time_hours": 93.0,
              "mode_frequency": 2,
              "time_distribution": {
                "86-88h": 1,
                "92-94h": 2,
                "202-204h": 1,
                "378-380h": 2,
                "724-726h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-01-23": 1,
                "2026-02-28": 2,
                "2026-03-18": 4
              },
              "time_per_day": {
                "2026-01-23": 86.49190527777778,
                "2026-02-28": 186.47370305555555,
                "2026-03-18": 1687.798175
              },
              "time_count_per_day": {
                "2026-01-23": 1,
                "2026-02-28": 2,
                "2026-03-18": 4
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 732.92,
              "mode_time_hours": 733.0,
              "mode_frequency": 1,
              "time_distribution": {
                "732-734h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 732.9221688888889
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-04-23": 1,
              "2026-04-29": 1,
              "2026-05-13": 1,
              "2026-05-26": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-04-29": 1,
                "2026-05-13": 1,
                "2026-05-26": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-17": 1,
              "2026-05-05": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-05-05": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_179": {
      "overall": {
        "avg_time_hours": 222.04,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 2,
          "6-8h": 2,
          "8-10h": 1,
          "18-20h": 2,
          "42-44h": 1,
          "44-46h": 1,
          "50-52h": 1,
          "58-60h": 1,
          "72-74h": 1,
          "78-80h": 2,
          "90-92h": 1,
          "100-102h": 1,
          "130-132h": 1,
          "176-178h": 2,
          "216-218h": 1,
          "236-238h": 1,
          "310-312h": 1,
          "338-340h": 1,
          "344-346h": 1,
          "546-548h": 1,
          "702-704h": 1,
          "724-726h": 1,
          "744-746h": 1,
          "766-768h": 1,
          "842-844h": 1,
          "1264-1266h": 1
        },
        "tickets_count": 39,
        "tickets_per_day": {
          "2025-10-23": 1,
          "2025-11-05": 1,
          "2025-11-06": 2,
          "2025-11-11": 1,
          "2025-11-13": 2,
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2025-12-29": 3,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-20": 2,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-26": 1,
          "2026-04-02": 3,
          "2026-04-23": 3,
          "2026-05-04": 1,
          "2026-05-06": 2,
          "2026-05-22": 1,
          "2026-06-06": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-23": 0.4330205555555556,
          "2025-11-05": 702.3882947222222,
          "2025-11-06": 110.59877499999999,
          "2025-11-11": 8.753258333333333,
          "2025-11-13": 220.98830277777776,
          "2025-11-17": 100.59612750000001,
          "2025-12-02": 44.72761305555556,
          "2025-12-03": 310.17529388888886,
          "2025-12-05": 73.4046425,
          "2025-12-29": 842.8265150000001,
          "2026-01-14": 43.031016666666666,
          "2026-01-15": 79.17580666666666,
          "2026-01-19": 237.51499833333332,
          "2026-01-26": 78.8710413888889,
          "2026-01-28": 3.1639144444444445,
          "2026-02-10": 176.07918194444446,
          "2026-02-13": 344.6006105555556,
          "2026-02-20": 15.788993055555554,
          "2026-03-09": 2.0843219444444445,
          "2026-03-12": 744.9844738888889,
          "2026-03-26": 546.3158324999999,
          "2026-04-02": 1491.9451844444445,
          "2026-04-23": 1441.8273619444446,
          "2026-05-04": 18.801325833333333,
          "2026-05-06": 556.4414566666667,
          "2026-05-22": 19.967836944444446,
          "2026-06-06": 0.09319361111111112
        },
        "time_count_per_day": {
          "2025-10-23": 1,
          "2025-11-05": 1,
          "2025-11-06": 2,
          "2025-11-11": 1,
          "2025-11-13": 2,
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-03": 1,
          "2025-12-05": 1,
          "2025-12-29": 3,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-02-20": 2,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-26": 1,
          "2026-04-02": 3,
          "2026-04-23": 3,
          "2026-05-04": 1,
          "2026-05-06": 2,
          "2026-05-22": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 261.43,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 1,
            "6-8h": 1,
            "8-10h": 1,
            "18-20h": 2,
            "90-92h": 1,
            "130-132h": 1,
            "176-178h": 2,
            "216-218h": 1,
            "236-238h": 1,
            "338-340h": 1,
            "546-548h": 1,
            "702-704h": 1,
            "724-726h": 1,
            "766-768h": 1,
            "842-844h": 1,
            "1264-1266h": 1
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-10-23": 1,
            "2025-11-05": 1,
            "2025-11-11": 1,
            "2025-11-13": 2,
            "2025-12-29": 3,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-02-10": 1,
            "2026-02-20": 1,
            "2026-03-09": 1,
            "2026-03-26": 1,
            "2026-04-02": 3,
            "2026-04-23": 3,
            "2026-05-04": 1,
            "2026-05-06": 2,
            "2026-05-22": 1,
            "2026-06-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-10-23": 0.4330205555555556,
            "2025-11-05": 702.3882947222222,
            "2025-11-11": 8.753258333333333,
            "2025-11-13": 220.98830277777776,
            "2025-12-29": 842.8265150000001,
            "2026-01-19": 237.51499833333332,
            "2026-02-10": 176.07918194444446,
            "2026-02-20": 7.89103,
            "2026-03-09": 2.0843219444444445,
            "2026-03-26": 546.3158324999999,
            "2026-04-02": 1491.9451844444445,
            "2026-04-23": 1441.8273619444446,
            "2026-05-04": 18.801325833333333,
            "2026-05-06": 556.4414566666667,
            "2026-05-22": 19.967836944444446,
            "2026-06-06": 0.09319361111111112
          },
          "time_count_per_day": {
            "2025-10-23": 1,
            "2025-11-05": 1,
            "2025-11-11": 1,
            "2025-11-13": 2,
            "2025-12-29": 3,
            "2026-01-19": 1,
            "2026-02-10": 1,
            "2026-02-20": 1,
            "2026-03-09": 1,
            "2026-03-26": 1,
            "2026-04-02": 3,
            "2026-04-23": 3,
            "2026-05-04": 1,
            "2026-05-06": 2,
            "2026-05-22": 1,
            "2026-06-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 149.33,
          "mode_time_hours": 79.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "50-52h": 1,
            "58-60h": 1,
            "72-74h": 1,
            "78-80h": 2,
            "100-102h": 1,
            "310-312h": 1,
            "344-346h": 1,
            "744-746h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-11-06": 2,
            "2025-11-17": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-03-12": 1
          },
          "time_per_day": {
            "2025-11-06": 110.59877499999999,
            "2025-11-17": 100.59612750000001,
            "2025-12-02": 44.72761305555556,
            "2025-12-03": 310.17529388888886,
            "2025-12-05": 73.4046425,
            "2026-01-14": 43.031016666666666,
            "2026-01-15": 79.17580666666666,
            "2026-01-26": 78.8710413888889,
            "2026-01-28": 3.1639144444444445,
            "2026-02-13": 344.6006105555556,
            "2026-02-20": 7.897963055555556,
            "2026-03-12": 744.9844738888889
          },
          "time_count_per_day": {
            "2025-11-06": 2,
            "2025-11-17": 1,
            "2025-12-02": 1,
            "2025-12-03": 1,
            "2025-12-05": 1,
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 222.04,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 2,
              "6-8h": 2,
              "8-10h": 1,
              "18-20h": 2,
              "42-44h": 1,
              "44-46h": 1,
              "50-52h": 1,
              "58-60h": 1,
              "72-74h": 1,
              "78-80h": 2,
              "90-92h": 1,
              "100-102h": 1,
              "130-132h": 1,
              "176-178h": 2,
              "216-218h": 1,
              "236-238h": 1,
              "310-312h": 1,
              "338-340h": 1,
              "344-346h": 1,
              "546-548h": 1,
              "702-704h": 1,
              "724-726h": 1,
              "744-746h": 1,
              "766-768h": 1,
              "842-844h": 1,
              "1264-1266h": 1
            },
            "tickets_count": 37,
            "tickets_per_day": {
              "2025-10-23": 1,
              "2025-11-05": 1,
              "2025-11-06": 2,
              "2025-11-11": 1,
              "2025-11-13": 2,
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2025-12-29": 3,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-20": 2,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-26": 1,
              "2026-04-02": 3,
              "2026-04-23": 3,
              "2026-05-04": 1,
              "2026-05-06": 2,
              "2026-05-22": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2025-10-23": 0.4330205555555556,
              "2025-11-05": 702.3882947222222,
              "2025-11-06": 110.59877499999999,
              "2025-11-11": 8.753258333333333,
              "2025-11-13": 220.98830277777776,
              "2025-11-17": 100.59612750000001,
              "2025-12-02": 44.72761305555556,
              "2025-12-03": 310.17529388888886,
              "2025-12-05": 73.4046425,
              "2025-12-29": 842.8265150000001,
              "2026-01-14": 43.031016666666666,
              "2026-01-15": 79.17580666666666,
              "2026-01-19": 237.51499833333332,
              "2026-01-26": 78.8710413888889,
              "2026-01-28": 3.1639144444444445,
              "2026-02-10": 176.07918194444446,
              "2026-02-13": 344.6006105555556,
              "2026-02-20": 15.788993055555554,
              "2026-03-09": 2.0843219444444445,
              "2026-03-12": 744.9844738888889,
              "2026-03-26": 546.3158324999999,
              "2026-04-02": 1491.9451844444445,
              "2026-04-23": 1441.8273619444446,
              "2026-05-04": 18.801325833333333,
              "2026-05-06": 556.4414566666667,
              "2026-05-22": 19.967836944444446,
              "2026-06-06": 0.09319361111111112
            },
            "time_count_per_day": {
              "2025-10-23": 1,
              "2025-11-05": 1,
              "2025-11-06": 2,
              "2025-11-11": 1,
              "2025-11-13": 2,
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-03": 1,
              "2025-12-05": 1,
              "2025-12-29": 3,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-26": 1,
              "2026-01-28": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-02-20": 2,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-26": 1,
              "2026-04-02": 3,
              "2026-04-23": 3,
              "2026-05-04": 1,
              "2026-05-06": 2,
              "2026-05-22": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 261.43,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 1,
                "6-8h": 1,
                "8-10h": 1,
                "18-20h": 2,
                "90-92h": 1,
                "130-132h": 1,
                "176-178h": 2,
                "216-218h": 1,
                "236-238h": 1,
                "338-340h": 1,
                "546-548h": 1,
                "702-704h": 1,
                "724-726h": 1,
                "766-768h": 1,
                "842-844h": 1,
                "1264-1266h": 1
              },
              "tickets_count": 24,
              "tickets_per_day": {
                "2025-10-23": 1,
                "2025-11-05": 1,
                "2025-11-11": 1,
                "2025-11-13": 2,
                "2025-12-29": 3,
                "2026-01-19": 1,
                "2026-02-10": 1,
                "2026-02-20": 1,
                "2026-03-09": 1,
                "2026-03-26": 1,
                "2026-04-02": 3,
                "2026-04-23": 3,
                "2026-05-04": 1,
                "2026-05-06": 2,
                "2026-05-22": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2025-10-23": 0.4330205555555556,
                "2025-11-05": 702.3882947222222,
                "2025-11-11": 8.753258333333333,
                "2025-11-13": 220.98830277777776,
                "2025-12-29": 842.8265150000001,
                "2026-01-19": 237.51499833333332,
                "2026-02-10": 176.07918194444446,
                "2026-02-20": 7.89103,
                "2026-03-09": 2.0843219444444445,
                "2026-03-26": 546.3158324999999,
                "2026-04-02": 1491.9451844444445,
                "2026-04-23": 1441.8273619444446,
                "2026-05-04": 18.801325833333333,
                "2026-05-06": 556.4414566666667,
                "2026-05-22": 19.967836944444446,
                "2026-06-06": 0.09319361111111112
              },
              "time_count_per_day": {
                "2025-10-23": 1,
                "2025-11-05": 1,
                "2025-11-11": 1,
                "2025-11-13": 2,
                "2025-12-29": 3,
                "2026-01-19": 1,
                "2026-02-10": 1,
                "2026-02-20": 1,
                "2026-03-09": 1,
                "2026-03-26": 1,
                "2026-04-02": 3,
                "2026-04-23": 3,
                "2026-05-04": 1,
                "2026-05-06": 2,
                "2026-05-22": 1,
                "2026-06-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 149.33,
              "mode_time_hours": 79.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "50-52h": 1,
                "58-60h": 1,
                "72-74h": 1,
                "78-80h": 2,
                "100-102h": 1,
                "310-312h": 1,
                "344-346h": 1,
                "744-746h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-11-06": 2,
                "2025-11-17": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-03-12": 1
              },
              "time_per_day": {
                "2025-11-06": 110.59877499999999,
                "2025-11-17": 100.59612750000001,
                "2025-12-02": 44.72761305555556,
                "2025-12-03": 310.17529388888886,
                "2025-12-05": 73.4046425,
                "2026-01-14": 43.031016666666666,
                "2026-01-15": 79.17580666666666,
                "2026-01-26": 78.8710413888889,
                "2026-01-28": 3.1639144444444445,
                "2026-02-13": 344.6006105555556,
                "2026-02-20": 7.897963055555556,
                "2026-03-12": 744.9844738888889
              },
              "time_count_per_day": {
                "2025-11-06": 2,
                "2025-11-17": 1,
                "2025-12-02": 1,
                "2025-12-03": 1,
                "2025-12-05": 1,
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-01-28": 1,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-03-12": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_318": {
      "overall": {
        "avg_time_hours": 128.2,
        "mode_time_hours": 129.0,
        "mode_frequency": 1,
        "time_distribution": {
          "128-130h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-28": 1
        },
        "time_per_day": {
          "2025-10-28": 128.19979722222223
        },
        "time_count_per_day": {
          "2025-10-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 128.2,
          "mode_time_hours": 129.0,
          "mode_frequency": 1,
          "time_distribution": {
            "128-130h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 128.19979722222223
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 128.2,
            "mode_time_hours": 129.0,
            "mode_frequency": 1,
            "time_distribution": {
              "128-130h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-28": 1
            },
            "time_per_day": {
              "2025-10-28": 128.19979722222223
            },
            "time_count_per_day": {
              "2025-10-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 128.2,
              "mode_time_hours": 129.0,
              "mode_frequency": 1,
              "time_distribution": {
                "128-130h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 128.19979722222223
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_319": {
      "overall": {
        "avg_time_hours": 6.82,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-23": 1
        },
        "time_per_day": {
          "2025-10-23": 6.819676666666666
        },
        "time_count_per_day": {
          "2025-10-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.82,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-23": 1
          },
          "time_per_day": {
            "2025-10-23": 6.819676666666666
          },
          "time_count_per_day": {
            "2025-10-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.82,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-23": 1
            },
            "time_per_day": {
              "2025-10-23": 6.819676666666666
            },
            "time_count_per_day": {
              "2025-10-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.82,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-23": 1
              },
              "time_per_day": {
                "2025-10-23": 6.819676666666666
              },
              "time_count_per_day": {
                "2025-10-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_320": {
      "overall": {
        "avg_time_hours": 150.93,
        "mode_time_hours": 151.0,
        "mode_frequency": 1,
        "time_distribution": {
          "150-152h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-29": 1
        },
        "time_per_day": {
          "2025-10-29": 150.93492194444445
        },
        "time_count_per_day": {
          "2025-10-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 150.93,
          "mode_time_hours": 151.0,
          "mode_frequency": 1,
          "time_distribution": {
            "150-152h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-29": 1
          },
          "time_per_day": {
            "2025-10-29": 150.93492194444445
          },
          "time_count_per_day": {
            "2025-10-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 150.93,
            "mode_time_hours": 151.0,
            "mode_frequency": 1,
            "time_distribution": {
              "150-152h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-29": 1
            },
            "time_per_day": {
              "2025-10-29": 150.93492194444445
            },
            "time_count_per_day": {
              "2025-10-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 150.93,
              "mode_time_hours": 151.0,
              "mode_frequency": 1,
              "time_distribution": {
                "150-152h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-29": 1
              },
              "time_per_day": {
                "2025-10-29": 150.93492194444445
              },
              "time_count_per_day": {
                "2025-10-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_219": {
      "overall": {
        "avg_time_hours": 1177.54,
        "mode_time_hours": 1177.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1176-1178h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 1177.538015
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1177.54,
          "mode_time_hours": 1177.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1176-1178h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 1177.538015
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1177.54,
            "mode_time_hours": 1177.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1176-1178h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 1177.538015
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1177.54,
              "mode_time_hours": 1177.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1176-1178h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 1177.538015
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_322": {
      "overall": {
        "avg_time_hours": 369.76,
        "mode_time_hours": 117.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 1,
          "14-16h": 1,
          "16-18h": 2,
          "62-64h": 1,
          "116-118h": 2,
          "150-152h": 1,
          "504-506h": 1,
          "572-574h": 1,
          "1006-1008h": 1,
          "1028-1030h": 1,
          "1190-1192h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-11-21": 1,
          "2025-11-24": 3,
          "2025-12-15": 1,
          "2025-12-26": 1,
          "2026-01-14": 1,
          "2026-02-14": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-31": 1
        },
        "time_per_day": {
          "2025-10-27": 63.222274722222224,
          "2025-10-28": 117.43815055555555,
          "2025-11-21": 16.396351666666668,
          "2025-11-24": 606.9618288888889,
          "2025-12-15": 150.18296222222222,
          "2025-12-26": 505.51203749999996,
          "2026-01-14": 2.330120833333333,
          "2026-02-14": 117.36212277777777,
          "2026-03-24": 1029.4965419444445,
          "2026-03-25": 1007.0330536111111,
          "2026-03-31": 1190.9448594444443
        },
        "time_count_per_day": {
          "2025-10-27": 1,
          "2025-10-28": 1,
          "2025-11-21": 1,
          "2025-11-24": 3,
          "2025-12-15": 1,
          "2025-12-26": 1,
          "2026-01-14": 1,
          "2026-02-14": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1190.94,
          "mode_time_hours": 1191.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1190-1192h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-03-31": 1190.9448594444443
          },
          "time_count_per_day": {
            "2026-03-31": 1
          }
        },
        "P2": {
          "avg_time_hours": 445.82,
          "mode_time_hours": 117.0,
          "mode_frequency": 1,
          "time_distribution": {
            "62-64h": 1,
            "116-118h": 1,
            "572-574h": 1,
            "1028-1030h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-11-24": 1,
            "2026-03-24": 1
          },
          "time_per_day": {
            "2025-10-27": 63.222274722222224,
            "2025-10-28": 117.43815055555555,
            "2025-11-24": 573.13022,
            "2026-03-24": 1029.4965419444445
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2025-10-28": 1,
            "2025-11-24": 1,
            "2026-03-24": 1
          }
        },
        "P3": {
          "avg_time_hours": 229.08,
          "mode_time_hours": 17.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "14-16h": 1,
            "16-18h": 2,
            "116-118h": 1,
            "150-152h": 1,
            "504-506h": 1,
            "1006-1008h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-14": 1,
            "2026-02-14": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-11-21": 16.396351666666668,
            "2025-11-24": 33.83160888888889,
            "2025-12-15": 150.18296222222222,
            "2025-12-26": 505.51203749999996,
            "2026-01-14": 2.330120833333333,
            "2026-02-14": 117.36212277777777,
            "2026-03-25": 1007.0330536111111
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2025-11-24": 2,
            "2025-12-15": 1,
            "2025-12-26": 1,
            "2026-01-14": 1,
            "2026-02-14": 1,
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 369.76,
            "mode_time_hours": 117.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 1,
              "14-16h": 1,
              "16-18h": 2,
              "62-64h": 1,
              "116-118h": 2,
              "150-152h": 1,
              "504-506h": 1,
              "572-574h": 1,
              "1006-1008h": 1,
              "1028-1030h": 1,
              "1190-1192h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-11-21": 1,
              "2025-11-24": 3,
              "2025-12-15": 1,
              "2025-12-26": 1,
              "2026-01-14": 1,
              "2026-02-14": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-31": 1
            },
            "time_per_day": {
              "2025-10-27": 63.222274722222224,
              "2025-10-28": 117.43815055555555,
              "2025-11-21": 16.396351666666668,
              "2025-11-24": 606.9618288888889,
              "2025-12-15": 150.18296222222222,
              "2025-12-26": 505.51203749999996,
              "2026-01-14": 2.330120833333333,
              "2026-02-14": 117.36212277777777,
              "2026-03-24": 1029.4965419444445,
              "2026-03-25": 1007.0330536111111,
              "2026-03-31": 1190.9448594444443
            },
            "time_count_per_day": {
              "2025-10-27": 1,
              "2025-10-28": 1,
              "2025-11-21": 1,
              "2025-11-24": 3,
              "2025-12-15": 1,
              "2025-12-26": 1,
              "2026-01-14": 1,
              "2026-02-14": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1190.94,
              "mode_time_hours": 1191.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1190-1192h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-03-31": 1190.9448594444443
              },
              "time_count_per_day": {
                "2026-03-31": 1
              }
            },
            "P2": {
              "avg_time_hours": 445.82,
              "mode_time_hours": 117.0,
              "mode_frequency": 1,
              "time_distribution": {
                "62-64h": 1,
                "116-118h": 1,
                "572-574h": 1,
                "1028-1030h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-11-24": 1,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-10-27": 63.222274722222224,
                "2025-10-28": 117.43815055555555,
                "2025-11-24": 573.13022,
                "2026-03-24": 1029.4965419444445
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2025-10-28": 1,
                "2025-11-24": 1,
                "2026-03-24": 1
              }
            },
            "P3": {
              "avg_time_hours": 229.08,
              "mode_time_hours": 17.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "14-16h": 1,
                "16-18h": 2,
                "116-118h": 1,
                "150-152h": 1,
                "504-506h": 1,
                "1006-1008h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-14": 1,
                "2026-02-14": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-11-21": 16.396351666666668,
                "2025-11-24": 33.83160888888889,
                "2025-12-15": 150.18296222222222,
                "2025-12-26": 505.51203749999996,
                "2026-01-14": 2.330120833333333,
                "2026-02-14": 117.36212277777777,
                "2026-03-25": 1007.0330536111111
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2025-11-24": 2,
                "2025-12-15": 1,
                "2025-12-26": 1,
                "2026-01-14": 1,
                "2026-02-14": 1,
                "2026-03-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_324": {
      "overall": {
        "avg_time_hours": 66.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 2,
          "4-6h": 1,
          "8-10h": 1,
          "12-14h": 1,
          "50-52h": 1,
          "72-74h": 1,
          "76-78h": 1,
          "128-130h": 1,
          "218-220h": 2,
          "248-250h": 1,
          "338-340h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2026-01-19": 1,
          "2026-03-16": 1,
          "2026-03-26": 1,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 3,
          "2026-05-11": 1,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-23": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-02": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-29": 129.80606722222223,
          "2026-01-19": 51.34674555555556,
          "2026-03-16": 77.59906166666666,
          "2026-03-26": 248.13852416666668,
          "2026-04-13": 5.359761388888889,
          "2026-04-14": 0.31047888888888886,
          "2026-04-20": 2.400432777777778,
          "2026-04-21": 0.21018888888888887,
          "2026-04-28": 2.7330180555555557,
          "2026-04-29": 1.7627436111111112,
          "2026-05-04": 1.9465730555555554,
          "2026-05-05": 73.06143833333334,
          "2026-05-06": 778.0693924999999,
          "2026-05-11": 1.2633877777777778,
          "2026-05-16": 1.6237844444444445,
          "2026-05-18": 1.147291111111111,
          "2026-05-23": 8.843885,
          "2026-05-27": 12.303292777777777,
          "2026-06-03": 0.6446686111111111
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2026-01-19": 1,
          "2026-03-16": 1,
          "2026-03-26": 1,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-20": 1,
          "2026-04-21": 1,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-04": 1,
          "2026-05-05": 1,
          "2026-05-06": 3,
          "2026-05-11": 1,
          "2026-05-16": 1,
          "2026-05-18": 1,
          "2026-05-23": 1,
          "2026-05-27": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 66.6,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 2,
            "4-6h": 1,
            "8-10h": 1,
            "12-14h": 1,
            "50-52h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "128-130h": 1,
            "218-220h": 2,
            "248-250h": 1,
            "338-340h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2026-01-19": 1,
            "2026-03-16": 1,
            "2026-03-26": 1,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 3,
            "2026-05-11": 1,
            "2026-05-16": 1,
            "2026-05-18": 1,
            "2026-05-23": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-02": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-29": 129.80606722222223,
            "2026-01-19": 51.34674555555556,
            "2026-03-16": 77.59906166666666,
            "2026-03-26": 248.13852416666668,
            "2026-04-13": 5.359761388888889,
            "2026-04-14": 0.31047888888888886,
            "2026-04-20": 2.400432777777778,
            "2026-04-21": 0.21018888888888887,
            "2026-04-28": 2.7330180555555557,
            "2026-04-29": 1.7627436111111112,
            "2026-05-04": 1.9465730555555554,
            "2026-05-05": 73.06143833333334,
            "2026-05-06": 778.0693924999999,
            "2026-05-11": 1.2633877777777778,
            "2026-05-16": 1.6237844444444445,
            "2026-05-18": 1.147291111111111,
            "2026-05-23": 8.843885,
            "2026-05-27": 12.303292777777777,
            "2026-06-03": 0.6446686111111111
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2026-01-19": 1,
            "2026-03-16": 1,
            "2026-03-26": 1,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-20": 1,
            "2026-04-21": 1,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 3,
            "2026-05-11": 1,
            "2026-05-16": 1,
            "2026-05-18": 1,
            "2026-05-23": 1,
            "2026-05-27": 1,
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 66.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 2,
              "4-6h": 1,
              "8-10h": 1,
              "12-14h": 1,
              "50-52h": 1,
              "72-74h": 1,
              "76-78h": 1,
              "128-130h": 1,
              "218-220h": 2,
              "248-250h": 1,
              "338-340h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2026-01-19": 1,
              "2026-03-16": 1,
              "2026-03-26": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 3,
              "2026-05-11": 1,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-23": 1,
              "2026-05-27": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-10-29": 129.80606722222223,
              "2026-01-19": 51.34674555555556,
              "2026-03-16": 77.59906166666666,
              "2026-03-26": 248.13852416666668,
              "2026-04-13": 5.359761388888889,
              "2026-04-14": 0.31047888888888886,
              "2026-04-20": 2.400432777777778,
              "2026-04-21": 0.21018888888888887,
              "2026-04-28": 2.7330180555555557,
              "2026-04-29": 1.7627436111111112,
              "2026-05-04": 1.9465730555555554,
              "2026-05-05": 73.06143833333334,
              "2026-05-06": 778.0693924999999,
              "2026-05-11": 1.2633877777777778,
              "2026-05-16": 1.6237844444444445,
              "2026-05-18": 1.147291111111111,
              "2026-05-23": 8.843885,
              "2026-05-27": 12.303292777777777,
              "2026-06-03": 0.6446686111111111
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2026-01-19": 1,
              "2026-03-16": 1,
              "2026-03-26": 1,
              "2026-04-13": 1,
              "2026-04-14": 1,
              "2026-04-20": 1,
              "2026-04-21": 1,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-04": 1,
              "2026-05-05": 1,
              "2026-05-06": 3,
              "2026-05-11": 1,
              "2026-05-16": 1,
              "2026-05-18": 1,
              "2026-05-23": 1,
              "2026-05-27": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 66.6,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 2,
                "4-6h": 1,
                "8-10h": 1,
                "12-14h": 1,
                "50-52h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "128-130h": 1,
                "218-220h": 2,
                "248-250h": 1,
                "338-340h": 1
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2026-01-19": 1,
                "2026-03-16": 1,
                "2026-03-26": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 3,
                "2026-05-11": 1,
                "2026-05-16": 1,
                "2026-05-18": 1,
                "2026-05-23": 1,
                "2026-05-27": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-10-29": 129.80606722222223,
                "2026-01-19": 51.34674555555556,
                "2026-03-16": 77.59906166666666,
                "2026-03-26": 248.13852416666668,
                "2026-04-13": 5.359761388888889,
                "2026-04-14": 0.31047888888888886,
                "2026-04-20": 2.400432777777778,
                "2026-04-21": 0.21018888888888887,
                "2026-04-28": 2.7330180555555557,
                "2026-04-29": 1.7627436111111112,
                "2026-05-04": 1.9465730555555554,
                "2026-05-05": 73.06143833333334,
                "2026-05-06": 778.0693924999999,
                "2026-05-11": 1.2633877777777778,
                "2026-05-16": 1.6237844444444445,
                "2026-05-18": 1.147291111111111,
                "2026-05-23": 8.843885,
                "2026-05-27": 12.303292777777777,
                "2026-06-03": 0.6446686111111111
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2026-01-19": 1,
                "2026-03-16": 1,
                "2026-03-26": 1,
                "2026-04-13": 1,
                "2026-04-14": 1,
                "2026-04-20": 1,
                "2026-04-21": 1,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-04": 1,
                "2026-05-05": 1,
                "2026-05-06": 3,
                "2026-05-11": 1,
                "2026-05-16": 1,
                "2026-05-18": 1,
                "2026-05-23": 1,
                "2026-05-27": 1,
                "2026-06-03": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-26": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-26": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_138": {
      "overall": {
        "avg_time_hours": 157.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "4-6h": 1,
          "6-8h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "46-48h": 1,
          "70-72h": 1,
          "72-74h": 1,
          "114-116h": 1,
          "126-128h": 1,
          "128-130h": 1,
          "262-264h": 1,
          "314-316h": 1,
          "340-342h": 1,
          "416-418h": 1,
          "478-480h": 1,
          "616-618h": 1,
          "894-896h": 1
        },
        "tickets_count": 26,
        "tickets_per_day": {
          "2025-10-24": 1,
          "2025-10-28": 1,
          "2025-10-29": 3,
          "2025-11-14": 1,
          "2025-11-20": 2,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-01-23": 1,
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-04-30": 1,
          "2026-05-02": 2,
          "2026-05-05": 1,
          "2026-05-09": 1,
          "2026-05-25": 2,
          "2026-06-01": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-24": 1.18273,
          "2025-10-28": 15.206938333333333,
          "2025-10-29": 372.5036525,
          "2025-11-14": 341.4449661111111,
          "2025-11-20": 11.980276666666665,
          "2025-11-28": 71.25728694444444,
          "2025-12-04": 314.8403919444445,
          "2025-12-10": 416.25238,
          "2025-12-12": 263.1820011111111,
          "2025-12-15": 479.5483977777778,
          "2025-12-17": 16.390971666666665,
          "2026-01-23": 895.1504491666667,
          "2026-02-09": 72.3535575,
          "2026-02-19": 616.8836877777778,
          "2026-04-30": 3.3742977777777776,
          "2026-05-02": 46.79405472222223,
          "2026-05-05": 1.147203888888889,
          "2026-05-09": 3.3633655555555557,
          "2026-05-25": 2.6270405555555554,
          "2026-06-01": 2.435480833333333,
          "2026-06-05": 1.2645802777777777
        },
        "time_count_per_day": {
          "2025-10-24": 1,
          "2025-10-28": 1,
          "2025-10-29": 3,
          "2025-11-14": 1,
          "2025-11-20": 2,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2026-01-23": 1,
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-09": 1,
          "2026-05-25": 2,
          "2026-06-01": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 75.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 3,
            "16-18h": 1,
            "46-48h": 1,
            "72-74h": 1,
            "114-116h": 1,
            "126-128h": 1,
            "128-130h": 1,
            "262-264h": 1,
            "416-418h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-10-24": 1,
            "2025-10-29": 3,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-17": 1,
            "2026-02-09": 1,
            "2026-04-30": 1,
            "2026-05-02": 2,
            "2026-05-05": 1,
            "2026-05-09": 1,
            "2026-05-25": 2,
            "2026-06-01": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-24": 1.18273,
            "2025-10-29": 372.5036525,
            "2025-12-10": 416.25238,
            "2025-12-12": 263.1820011111111,
            "2025-12-17": 16.390971666666665,
            "2026-02-09": 72.3535575,
            "2026-04-30": 3.3742977777777776,
            "2026-05-02": 46.79405472222223,
            "2026-05-05": 1.147203888888889,
            "2026-05-09": 3.3633655555555557,
            "2026-05-25": 2.6270405555555554,
            "2026-06-01": 2.435480833333333,
            "2026-06-05": 1.2645802777777777
          },
          "time_count_per_day": {
            "2025-10-24": 1,
            "2025-10-29": 3,
            "2025-12-10": 1,
            "2025-12-12": 1,
            "2025-12-17": 1,
            "2026-02-09": 1,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-09": 1,
            "2026-05-25": 2,
            "2026-06-01": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 266.18,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "14-16h": 1,
            "70-72h": 1,
            "314-316h": 1,
            "340-342h": 1,
            "478-480h": 1,
            "894-896h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2025-11-14": 1,
            "2025-11-20": 2,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2026-01-23": 1
          },
          "time_per_day": {
            "2025-10-28": 15.206938333333333,
            "2025-11-14": 341.4449661111111,
            "2025-11-20": 11.980276666666665,
            "2025-11-28": 71.25728694444444,
            "2025-12-04": 314.8403919444445,
            "2025-12-15": 479.5483977777778,
            "2026-01-23": 895.1504491666667
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2025-11-14": 1,
            "2025-11-20": 2,
            "2025-11-28": 1,
            "2025-12-04": 1,
            "2025-12-15": 1,
            "2026-01-23": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 616.88,
          "mode_time_hours": 617.0,
          "mode_frequency": 1,
          "time_distribution": {
            "616-618h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 616.8836877777778
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "4-6h": 1,
              "6-8h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "46-48h": 1,
              "70-72h": 1,
              "72-74h": 1,
              "114-116h": 1,
              "126-128h": 1,
              "128-130h": 1,
              "262-264h": 1,
              "314-316h": 1,
              "340-342h": 1,
              "416-418h": 1,
              "478-480h": 1,
              "616-618h": 1,
              "894-896h": 1
            },
            "tickets_count": 25,
            "tickets_per_day": {
              "2025-10-24": 1,
              "2025-10-28": 1,
              "2025-10-29": 3,
              "2025-11-14": 1,
              "2025-11-20": 2,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-01-23": 1,
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-09": 1,
              "2026-05-25": 2,
              "2026-06-01": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-24": 1.18273,
              "2025-10-28": 15.206938333333333,
              "2025-10-29": 372.5036525,
              "2025-11-14": 341.4449661111111,
              "2025-11-20": 11.980276666666665,
              "2025-11-28": 71.25728694444444,
              "2025-12-04": 314.8403919444445,
              "2025-12-10": 416.25238,
              "2025-12-12": 263.1820011111111,
              "2025-12-15": 479.5483977777778,
              "2025-12-17": 16.390971666666665,
              "2026-01-23": 895.1504491666667,
              "2026-02-09": 72.3535575,
              "2026-02-19": 616.8836877777778,
              "2026-04-30": 3.3742977777777776,
              "2026-05-02": 46.79405472222223,
              "2026-05-05": 1.147203888888889,
              "2026-05-09": 3.3633655555555557,
              "2026-05-25": 2.6270405555555554,
              "2026-06-01": 2.435480833333333,
              "2026-06-05": 1.2645802777777777
            },
            "time_count_per_day": {
              "2025-10-24": 1,
              "2025-10-28": 1,
              "2025-10-29": 3,
              "2025-11-14": 1,
              "2025-11-20": 2,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-12": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2026-01-23": 1,
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-09": 1,
              "2026-05-25": 2,
              "2026-06-01": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 75.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 3,
                "16-18h": 1,
                "46-48h": 1,
                "72-74h": 1,
                "114-116h": 1,
                "126-128h": 1,
                "128-130h": 1,
                "262-264h": 1,
                "416-418h": 1
              },
              "tickets_count": 16,
              "tickets_per_day": {
                "2025-10-24": 1,
                "2025-10-29": 3,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-17": 1,
                "2026-02-09": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-09": 1,
                "2026-05-25": 2,
                "2026-06-01": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-24": 1.18273,
                "2025-10-29": 372.5036525,
                "2025-12-10": 416.25238,
                "2025-12-12": 263.1820011111111,
                "2025-12-17": 16.390971666666665,
                "2026-02-09": 72.3535575,
                "2026-04-30": 3.3742977777777776,
                "2026-05-02": 46.79405472222223,
                "2026-05-05": 1.147203888888889,
                "2026-05-09": 3.3633655555555557,
                "2026-05-25": 2.6270405555555554,
                "2026-06-01": 2.435480833333333,
                "2026-06-05": 1.2645802777777777
              },
              "time_count_per_day": {
                "2025-10-24": 1,
                "2025-10-29": 3,
                "2025-12-10": 1,
                "2025-12-12": 1,
                "2025-12-17": 1,
                "2026-02-09": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-09": 1,
                "2026-05-25": 2,
                "2026-06-01": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 266.18,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "14-16h": 1,
                "70-72h": 1,
                "314-316h": 1,
                "340-342h": 1,
                "478-480h": 1,
                "894-896h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2025-11-14": 1,
                "2025-11-20": 2,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2026-01-23": 1
              },
              "time_per_day": {
                "2025-10-28": 15.206938333333333,
                "2025-11-14": 341.4449661111111,
                "2025-11-20": 11.980276666666665,
                "2025-11-28": 71.25728694444444,
                "2025-12-04": 314.8403919444445,
                "2025-12-15": 479.5483977777778,
                "2026-01-23": 895.1504491666667
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2025-11-14": 1,
                "2025-11-20": 2,
                "2025-11-28": 1,
                "2025-12-04": 1,
                "2025-12-15": 1,
                "2026-01-23": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 616.88,
              "mode_time_hours": 617.0,
              "mode_frequency": 1,
              "time_distribution": {
                "616-618h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 616.8836877777778
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_325": {
      "overall": {
        "avg_time_hours": 98.32,
        "mode_time_hours": 171.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1,
          "170-172h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-27": 1,
          "2025-10-31": 1
        },
        "time_per_day": {
          "2025-10-27": 25.573144444444445,
          "2025-10-31": 171.07294666666667
        },
        "time_count_per_day": {
          "2025-10-27": 1,
          "2025-10-31": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 98.32,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "170-172h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2025-10-31": 1
          },
          "time_per_day": {
            "2025-10-27": 25.573144444444445,
            "2025-10-31": 171.07294666666667
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2025-10-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 98.32,
            "mode_time_hours": 171.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1,
              "170-172h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-27": 1,
              "2025-10-31": 1
            },
            "time_per_day": {
              "2025-10-27": 25.573144444444445,
              "2025-10-31": 171.07294666666667
            },
            "time_count_per_day": {
              "2025-10-27": 1,
              "2025-10-31": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 98.32,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "170-172h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2025-10-31": 1
              },
              "time_per_day": {
                "2025-10-27": 25.573144444444445,
                "2025-10-31": 171.07294666666667
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2025-10-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_269": {
      "overall": {
        "avg_time_hours": 4.43,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-24": 1,
          "2026-03-04": 1
        },
        "time_per_day": {
          "2025-10-24": 5.566822500000001,
          "2026-03-04": 3.3009719444444445
        },
        "time_count_per_day": {
          "2025-10-24": 1,
          "2026-03-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.3,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-04": 1
          },
          "time_per_day": {
            "2026-03-04": 3.3009719444444445
          },
          "time_count_per_day": {
            "2026-03-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 5.57,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-24": 1
          },
          "time_per_day": {
            "2025-10-24": 5.566822500000001
          },
          "time_count_per_day": {
            "2025-10-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.43,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-24": 1,
              "2026-03-04": 1
            },
            "time_per_day": {
              "2025-10-24": 5.566822500000001,
              "2026-03-04": 3.3009719444444445
            },
            "time_count_per_day": {
              "2025-10-24": 1,
              "2026-03-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.3,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-04": 1
              },
              "time_per_day": {
                "2026-03-04": 3.3009719444444445
              },
              "time_count_per_day": {
                "2026-03-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 5.57,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-24": 1
              },
              "time_per_day": {
                "2025-10-24": 5.566822500000001
              },
              "time_count_per_day": {
                "2025-10-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_327": {
      "overall": {
        "avg_time_hours": 358.84,
        "mode_time_hours": 359.0,
        "mode_frequency": 1,
        "time_distribution": {
          "358-360h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-08": 1
        },
        "time_per_day": {
          "2025-11-08": 358.8417494444444
        },
        "time_count_per_day": {
          "2025-11-08": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 358.84,
          "mode_time_hours": 359.0,
          "mode_frequency": 1,
          "time_distribution": {
            "358-360h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-08": 1
          },
          "time_per_day": {
            "2025-11-08": 358.8417494444444
          },
          "time_count_per_day": {
            "2025-11-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 358.84,
            "mode_time_hours": 359.0,
            "mode_frequency": 1,
            "time_distribution": {
              "358-360h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-08": 1
            },
            "time_per_day": {
              "2025-11-08": 358.8417494444444
            },
            "time_count_per_day": {
              "2025-11-08": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 358.84,
              "mode_time_hours": 359.0,
              "mode_frequency": 1,
              "time_distribution": {
                "358-360h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-08": 1
              },
              "time_per_day": {
                "2025-11-08": 358.8417494444444
              },
              "time_count_per_day": {
                "2025-11-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_270": {
      "overall": {
        "avg_time_hours": 127.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "40-42h": 1,
          "122-124h": 1,
          "724-726h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-24": 1,
          "2026-02-13": 1,
          "2026-03-09": 1,
          "2026-04-06": 1,
          "2026-04-23": 1,
          "2026-05-11": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2025-10-24": 0.8984202777777778,
          "2026-02-13": 40.572491666666664,
          "2026-03-09": 122.00514583333334,
          "2026-04-06": 0.9134741666666667,
          "2026-04-23": 724.8961194444444,
          "2026-05-11": 1.394633611111111,
          "2026-05-20": 3.8762108333333334
        },
        "time_count_per_day": {
          "2025-10-24": 1,
          "2026-02-13": 1,
          "2026-03-09": 1,
          "2026-04-06": 1,
          "2026-04-23": 1,
          "2026-05-11": 1,
          "2026-05-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 142.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "122-124h": 1,
            "724-726h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-24": 1,
            "2026-03-09": 1,
            "2026-04-06": 1,
            "2026-04-23": 1,
            "2026-05-11": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2025-10-24": 0.8984202777777778,
            "2026-03-09": 122.00514583333334,
            "2026-04-06": 0.9134741666666667,
            "2026-04-23": 724.8961194444444,
            "2026-05-11": 1.394633611111111,
            "2026-05-20": 3.8762108333333334
          },
          "time_count_per_day": {
            "2025-10-24": 1,
            "2026-03-09": 1,
            "2026-04-06": 1,
            "2026-04-23": 1,
            "2026-05-11": 1,
            "2026-05-20": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 40.57,
          "mode_time_hours": 41.0,
          "mode_frequency": 1,
          "time_distribution": {
            "40-42h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 40.572491666666664
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 127.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "40-42h": 1,
              "122-124h": 1,
              "724-726h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-24": 1,
              "2026-02-13": 1,
              "2026-03-09": 1,
              "2026-04-06": 1,
              "2026-04-23": 1,
              "2026-05-11": 1,
              "2026-05-20": 1
            },
            "time_per_day": {
              "2025-10-24": 0.8984202777777778,
              "2026-02-13": 40.572491666666664,
              "2026-03-09": 122.00514583333334,
              "2026-04-06": 0.9134741666666667,
              "2026-04-23": 724.8961194444444,
              "2026-05-11": 1.394633611111111,
              "2026-05-20": 3.8762108333333334
            },
            "time_count_per_day": {
              "2025-10-24": 1,
              "2026-02-13": 1,
              "2026-03-09": 1,
              "2026-04-06": 1,
              "2026-04-23": 1,
              "2026-05-11": 1,
              "2026-05-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 142.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "122-124h": 1,
                "724-726h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-24": 1,
                "2026-03-09": 1,
                "2026-04-06": 1,
                "2026-04-23": 1,
                "2026-05-11": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2025-10-24": 0.8984202777777778,
                "2026-03-09": 122.00514583333334,
                "2026-04-06": 0.9134741666666667,
                "2026-04-23": 724.8961194444444,
                "2026-05-11": 1.394633611111111,
                "2026-05-20": 3.8762108333333334
              },
              "time_count_per_day": {
                "2025-10-24": 1,
                "2026-03-09": 1,
                "2026-04-06": 1,
                "2026-04-23": 1,
                "2026-05-11": 1,
                "2026-05-20": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 40.57,
              "mode_time_hours": 41.0,
              "mode_frequency": 1,
              "time_distribution": {
                "40-42h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 40.572491666666664
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_328": {
      "overall": {
        "avg_time_hours": 5.46,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-24": 1
        },
        "time_per_day": {
          "2025-10-24": 5.462781666666666
        },
        "time_count_per_day": {
          "2025-10-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.46,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-24": 1
          },
          "time_per_day": {
            "2025-10-24": 5.462781666666666
          },
          "time_count_per_day": {
            "2025-10-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.46,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-24": 1
            },
            "time_per_day": {
              "2025-10-24": 5.462781666666666
            },
            "time_count_per_day": {
              "2025-10-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.46,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-24": 1
              },
              "time_per_day": {
                "2025-10-24": 5.462781666666666
              },
              "time_count_per_day": {
                "2025-10-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_329": {
      "overall": {
        "avg_time_hours": 98.43,
        "mode_time_hours": 31.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 2,
          "4-6h": 1,
          "6-8h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "18-20h": 1,
          "20-22h": 2,
          "22-24h": 1,
          "24-26h": 2,
          "30-32h": 3,
          "50-52h": 1,
          "52-54h": 1,
          "54-56h": 1,
          "60-62h": 1,
          "70-72h": 1,
          "80-82h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "122-124h": 2,
          "152-154h": 1,
          "154-156h": 1,
          "284-286h": 1,
          "320-322h": 1,
          "340-342h": 1,
          "348-350h": 1,
          "360-362h": 1,
          "394-396h": 1
        },
        "tickets_count": 36,
        "tickets_per_day": {
          "2025-11-06": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2026-01-19": 1,
          "2026-01-21": 3,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-28": 1,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-26": 1,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-04-01": 1,
          "2026-04-29": 2,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-22": 2,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2025-11-06": 321.53299055555556,
          "2025-12-11": 1.8357597222222222,
          "2025-12-17": 394.15899777777776,
          "2026-01-19": 55.35319027777778,
          "2026-01-21": 11.015559999999999,
          "2026-01-26": 80.38457972222223,
          "2026-01-27": 251.75190583333335,
          "2026-01-28": 18.97073277777778,
          "2026-02-02": 285.44804916666664,
          "2026-02-03": 13.698601111111111,
          "2026-02-06": 51.335673611111105,
          "2026-02-09": 60.75415611111111,
          "2026-02-13": 152.7770761111111,
          "2026-02-16": 70.97693027777778,
          "2026-02-18": 360.3710025,
          "2026-02-20": 0.2515297222222222,
          "2026-02-21": 24.979637222222223,
          "2026-02-23": 7.3853905555555555,
          "2026-02-26": 20.578641944444445,
          "2026-03-11": 349.0326747222222,
          "2026-03-20": 52.33188333333333,
          "2026-03-23": 247.1113433333333,
          "2026-04-01": 340.28477194444446,
          "2026-04-29": 15.974391944444445,
          "2026-05-14": 21.49134861111111,
          "2026-05-19": 154.31001444444445,
          "2026-05-22": 56.90840583333333,
          "2026-05-29": 23.92174166666667
        },
        "time_count_per_day": {
          "2025-11-06": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2026-01-19": 1,
          "2026-01-21": 3,
          "2026-01-26": 1,
          "2026-01-27": 4,
          "2026-01-28": 1,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-26": 1,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-04-01": 1,
          "2026-04-29": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-22": 2,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 108.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "4-6h": 1,
            "14-16h": 1,
            "20-22h": 2,
            "22-24h": 1,
            "24-26h": 1,
            "30-32h": 1,
            "52-54h": 1,
            "122-124h": 2,
            "152-154h": 1,
            "154-156h": 1,
            "320-322h": 1,
            "340-342h": 1,
            "348-350h": 1,
            "394-396h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2026-01-21": 3,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-02-26": 1,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-04-01": 1,
            "2026-04-29": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-22": 2,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2025-11-06": 321.53299055555556,
            "2025-12-11": 1.8357597222222222,
            "2025-12-17": 394.15899777777776,
            "2026-01-21": 11.015559999999999,
            "2026-02-13": 152.7770761111111,
            "2026-02-20": 0.2515297222222222,
            "2026-02-26": 20.578641944444445,
            "2026-03-11": 349.0326747222222,
            "2026-03-20": 52.33188333333333,
            "2026-03-23": 247.1113433333333,
            "2026-04-01": 340.28477194444446,
            "2026-04-29": 15.974391944444445,
            "2026-05-14": 21.49134861111111,
            "2026-05-19": 154.31001444444445,
            "2026-05-22": 56.90840583333333,
            "2026-05-29": 23.92174166666667
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2026-01-21": 3,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-02-26": 1,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-04-01": 1,
            "2026-04-29": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-22": 2,
            "2026-05-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 96.08,
          "mode_time_hours": 31.0,
          "mode_frequency": 2,
          "time_distribution": {
            "12-14h": 1,
            "18-20h": 1,
            "30-32h": 2,
            "50-52h": 1,
            "54-56h": 1,
            "60-62h": 1,
            "70-72h": 1,
            "80-82h": 1,
            "92-94h": 1,
            "96-98h": 1,
            "284-286h": 1,
            "360-362h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-01-27": 4,
            "2026-01-28": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-19": 55.35319027777778,
            "2026-01-26": 80.38457972222223,
            "2026-01-27": 251.75190583333335,
            "2026-01-28": 18.97073277777778,
            "2026-02-02": 285.44804916666664,
            "2026-02-03": 13.698601111111111,
            "2026-02-06": 51.335673611111105,
            "2026-02-09": 60.75415611111111,
            "2026-02-16": 70.97693027777778,
            "2026-02-18": 360.3710025
          },
          "time_count_per_day": {
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-01-27": 4,
            "2026-01-28": 1,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 16.18,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "24-26h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-02-21": 24.979637222222223,
            "2026-02-23": 7.3853905555555555
          },
          "time_count_per_day": {
            "2026-02-21": 1,
            "2026-02-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 98.43,
            "mode_time_hours": 31.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 2,
              "4-6h": 1,
              "6-8h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "18-20h": 1,
              "20-22h": 2,
              "22-24h": 1,
              "24-26h": 2,
              "30-32h": 3,
              "50-52h": 1,
              "52-54h": 1,
              "54-56h": 1,
              "60-62h": 1,
              "70-72h": 1,
              "80-82h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "122-124h": 2,
              "152-154h": 1,
              "154-156h": 1,
              "284-286h": 1,
              "320-322h": 1,
              "340-342h": 1,
              "348-350h": 1,
              "360-362h": 1,
              "394-396h": 1
            },
            "tickets_count": 35,
            "tickets_per_day": {
              "2025-11-06": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2026-01-19": 1,
              "2026-01-21": 3,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-28": 1,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-26": 1,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-04-01": 1,
              "2026-04-29": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-22": 2,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2025-11-06": 321.53299055555556,
              "2025-12-11": 1.8357597222222222,
              "2025-12-17": 394.15899777777776,
              "2026-01-19": 55.35319027777778,
              "2026-01-21": 11.015559999999999,
              "2026-01-26": 80.38457972222223,
              "2026-01-27": 251.75190583333335,
              "2026-01-28": 18.97073277777778,
              "2026-02-02": 285.44804916666664,
              "2026-02-03": 13.698601111111111,
              "2026-02-06": 51.335673611111105,
              "2026-02-09": 60.75415611111111,
              "2026-02-13": 152.7770761111111,
              "2026-02-16": 70.97693027777778,
              "2026-02-18": 360.3710025,
              "2026-02-20": 0.2515297222222222,
              "2026-02-21": 24.979637222222223,
              "2026-02-23": 7.3853905555555555,
              "2026-02-26": 20.578641944444445,
              "2026-03-11": 349.0326747222222,
              "2026-03-20": 52.33188333333333,
              "2026-03-23": 247.1113433333333,
              "2026-04-01": 340.28477194444446,
              "2026-04-29": 15.974391944444445,
              "2026-05-14": 21.49134861111111,
              "2026-05-19": 154.31001444444445,
              "2026-05-22": 56.90840583333333,
              "2026-05-29": 23.92174166666667
            },
            "time_count_per_day": {
              "2025-11-06": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2026-01-19": 1,
              "2026-01-21": 3,
              "2026-01-26": 1,
              "2026-01-27": 4,
              "2026-01-28": 1,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-26": 1,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-04-01": 1,
              "2026-04-29": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-22": 2,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 108.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "4-6h": 1,
                "14-16h": 1,
                "20-22h": 2,
                "22-24h": 1,
                "24-26h": 1,
                "30-32h": 1,
                "52-54h": 1,
                "122-124h": 2,
                "152-154h": 1,
                "154-156h": 1,
                "320-322h": 1,
                "340-342h": 1,
                "348-350h": 1,
                "394-396h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2026-01-21": 3,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-02-26": 1,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-04-01": 1,
                "2026-04-29": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-22": 2,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2025-11-06": 321.53299055555556,
                "2025-12-11": 1.8357597222222222,
                "2025-12-17": 394.15899777777776,
                "2026-01-21": 11.015559999999999,
                "2026-02-13": 152.7770761111111,
                "2026-02-20": 0.2515297222222222,
                "2026-02-26": 20.578641944444445,
                "2026-03-11": 349.0326747222222,
                "2026-03-20": 52.33188333333333,
                "2026-03-23": 247.1113433333333,
                "2026-04-01": 340.28477194444446,
                "2026-04-29": 15.974391944444445,
                "2026-05-14": 21.49134861111111,
                "2026-05-19": 154.31001444444445,
                "2026-05-22": 56.90840583333333,
                "2026-05-29": 23.92174166666667
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2026-01-21": 3,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-02-26": 1,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-04-01": 1,
                "2026-04-29": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-22": 2,
                "2026-05-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 96.08,
              "mode_time_hours": 31.0,
              "mode_frequency": 2,
              "time_distribution": {
                "12-14h": 1,
                "18-20h": 1,
                "30-32h": 2,
                "50-52h": 1,
                "54-56h": 1,
                "60-62h": 1,
                "70-72h": 1,
                "80-82h": 1,
                "92-94h": 1,
                "96-98h": 1,
                "284-286h": 1,
                "360-362h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-01-27": 4,
                "2026-01-28": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-19": 55.35319027777778,
                "2026-01-26": 80.38457972222223,
                "2026-01-27": 251.75190583333335,
                "2026-01-28": 18.97073277777778,
                "2026-02-02": 285.44804916666664,
                "2026-02-03": 13.698601111111111,
                "2026-02-06": 51.335673611111105,
                "2026-02-09": 60.75415611111111,
                "2026-02-16": 70.97693027777778,
                "2026-02-18": 360.3710025
              },
              "time_count_per_day": {
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-01-27": 4,
                "2026-01-28": 1,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-16": 1,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 16.18,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "24-26h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-21": 1,
                "2026-02-23": 1
              },
              "time_per_day": {
                "2026-02-21": 24.979637222222223,
                "2026-02-23": 7.3853905555555555
              },
              "time_count_per_day": {
                "2026-02-21": 1,
                "2026-02-23": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_45": {
      "overall": {
        "avg_time_hours": 94.78,
        "mode_time_hours": 95.0,
        "mode_frequency": 1,
        "time_distribution": {
          "94-96h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-28": 1
        },
        "time_per_day": {
          "2025-10-28": 94.78357611111112
        },
        "time_count_per_day": {
          "2025-10-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 94.78,
          "mode_time_hours": 95.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-28": 1
          },
          "time_per_day": {
            "2025-10-28": 94.78357611111112
          },
          "time_count_per_day": {
            "2025-10-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 94.78,
            "mode_time_hours": 95.0,
            "mode_frequency": 1,
            "time_distribution": {
              "94-96h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-28": 1
            },
            "time_per_day": {
              "2025-10-28": 94.78357611111112
            },
            "time_count_per_day": {
              "2025-10-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 94.78,
              "mode_time_hours": 95.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-28": 1
              },
              "time_per_day": {
                "2025-10-28": 94.78357611111112
              },
              "time_count_per_day": {
                "2025-10-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_61": {
      "overall": {
        "avg_time_hours": 95.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 3,
          "12-14h": 1,
          "16-18h": 1,
          "18-20h": 2,
          "20-22h": 5,
          "22-24h": 4,
          "24-26h": 3,
          "28-30h": 1,
          "32-34h": 2,
          "38-40h": 1,
          "60-62h": 1,
          "64-66h": 1,
          "74-76h": 1,
          "82-84h": 1,
          "104-106h": 1,
          "134-136h": 1,
          "136-138h": 1,
          "144-146h": 1,
          "148-150h": 1,
          "172-174h": 1,
          "278-280h": 1,
          "414-416h": 1,
          "470-472h": 1,
          "618-620h": 1,
          "800-802h": 1
        },
        "tickets_count": 46,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-10": 3,
          "2025-12-23": 1,
          "2026-01-23": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-22": 1,
          "2026-02-28": 3,
          "2026-03-05": 1,
          "2026-03-07": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-15": 1,
          "2026-03-16": 2,
          "2026-03-17": 2,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-31": 1,
          "2026-04-09": 1,
          "2026-04-13": 2,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-05-25": 2,
          "2026-06-03": 3
        },
        "time_per_day": {
          "2025-10-29": 22.84589861111111,
          "2025-11-18": 144.76843444444444,
          "2025-11-19": 636.5614491666666,
          "2025-11-24": 65.52261638888889,
          "2025-11-27": 23.6250775,
          "2025-12-10": 140.77289666666667,
          "2025-12-23": 18.55293138888889,
          "2026-01-23": 16.924414444444444,
          "2026-02-03": 2.8362169444444447,
          "2026-02-04": 0.017374722222222222,
          "2026-02-10": 20.427686944444442,
          "2026-02-18": 22.369331944444443,
          "2026-02-20": 104.89020277777777,
          "2026-02-22": 29.831705277777775,
          "2026-02-28": 62.69834555555556,
          "2026-03-05": 75.33637972222222,
          "2026-03-07": 2.54558,
          "2026-03-10": 1.6037083333333335,
          "2026-03-11": 25.888493333333333,
          "2026-03-14": 23.656514444444447,
          "2026-03-15": 39.66556027777778,
          "2026-03-16": 87.38445777777777,
          "2026-03-17": 496.48918972222225,
          "2026-03-19": 470.6223508333333,
          "2026-03-20": 3.3925477777777777,
          "2026-03-31": 21.25219138888889,
          "2026-04-09": 173.34555944444443,
          "2026-04-13": 65.23308583333333,
          "2026-04-16": 800.1197591666667,
          "2026-04-22": 134.68406027777777,
          "2026-04-29": 148.42557916666667,
          "2026-05-25": 279.41197305555556,
          "2026-06-03": 37.82481888888889
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-11-18": 1,
          "2025-11-19": 2,
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2025-12-10": 3,
          "2025-12-23": 1,
          "2026-01-23": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-22": 1,
          "2026-02-28": 3,
          "2026-03-05": 1,
          "2026-03-07": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-15": 1,
          "2026-03-16": 2,
          "2026-03-17": 2,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-31": 1,
          "2026-04-09": 1,
          "2026-04-13": 2,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-05-25": 1,
          "2026-06-03": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 99.53,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 2,
            "12-14h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 2,
            "24-26h": 3,
            "32-34h": 2,
            "38-40h": 1,
            "60-62h": 1,
            "64-66h": 1,
            "74-76h": 1,
            "104-106h": 1,
            "148-150h": 1,
            "172-174h": 1,
            "278-280h": 1,
            "414-416h": 1,
            "470-472h": 1,
            "800-802h": 1
          },
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-10": 2,
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-20": 1,
            "2026-03-05": 1,
            "2026-03-07": 2,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-15": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-31": 1,
            "2026-04-09": 1,
            "2026-04-13": 2,
            "2026-04-16": 1,
            "2026-04-29": 1,
            "2026-05-25": 2,
            "2026-06-03": 3
          },
          "time_per_day": {
            "2025-10-29": 22.84589861111111,
            "2025-11-24": 65.52261638888889,
            "2025-11-27": 23.6250775,
            "2025-12-10": 4.1385008333333335,
            "2025-12-23": 18.55293138888889,
            "2026-02-03": 0.5038086111111111,
            "2026-02-04": 0.017374722222222222,
            "2026-02-20": 104.89020277777777,
            "2026-03-05": 75.33637972222222,
            "2026-03-07": 2.54558,
            "2026-03-10": 1.6037083333333335,
            "2026-03-11": 25.888493333333333,
            "2026-03-15": 39.66556027777778,
            "2026-03-16": 87.38445777777777,
            "2026-03-17": 414.2320569444445,
            "2026-03-19": 470.6223508333333,
            "2026-03-20": 3.3925477777777777,
            "2026-03-31": 21.25219138888889,
            "2026-04-09": 173.34555944444443,
            "2026-04-13": 65.23308583333333,
            "2026-04-16": 800.1197591666667,
            "2026-04-29": 148.42557916666667,
            "2026-05-25": 279.41197305555556,
            "2026-06-03": 37.82481888888889
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2025-12-10": 2,
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-20": 1,
            "2026-03-05": 1,
            "2026-03-07": 2,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-15": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-31": 1,
            "2026-04-09": 1,
            "2026-04-13": 2,
            "2026-04-16": 1,
            "2026-04-29": 1,
            "2026-05-25": 1,
            "2026-06-03": 2
          }
        },
        "P3": {
          "avg_time_hours": 125.94,
          "mode_time_hours": 619.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "28-30h": 1,
            "136-138h": 1,
            "144-146h": 1,
            "618-620h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-11-19": 2,
            "2025-12-10": 1,
            "2026-01-23": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-22": 1
          },
          "time_per_day": {
            "2025-11-18": 144.76843444444444,
            "2025-11-19": 636.5614491666666,
            "2025-12-10": 136.63439583333334,
            "2026-01-23": 16.924414444444444,
            "2026-02-10": 20.427686944444442,
            "2026-02-18": 22.369331944444443,
            "2026-02-22": 29.831705277777775
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-11-19": 2,
            "2025-12-10": 1,
            "2026-01-23": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 43.66,
          "mode_time_hours": 21.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 1,
            "20-22h": 3,
            "22-24h": 1,
            "82-84h": 1,
            "134-136h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-28": 3,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-02-03": 2.3324083333333334,
            "2026-02-28": 62.69834555555556,
            "2026-03-14": 23.656514444444447,
            "2026-03-17": 82.25713277777778,
            "2026-04-22": 134.68406027777777
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-28": 3,
            "2026-03-14": 1,
            "2026-03-17": 1,
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 95.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 3,
              "12-14h": 1,
              "16-18h": 1,
              "18-20h": 2,
              "20-22h": 5,
              "22-24h": 4,
              "24-26h": 3,
              "28-30h": 1,
              "32-34h": 2,
              "38-40h": 1,
              "60-62h": 1,
              "64-66h": 1,
              "74-76h": 1,
              "82-84h": 1,
              "104-106h": 1,
              "134-136h": 1,
              "136-138h": 1,
              "144-146h": 1,
              "148-150h": 1,
              "172-174h": 1,
              "278-280h": 1,
              "414-416h": 1,
              "470-472h": 1,
              "618-620h": 1,
              "800-802h": 1
            },
            "tickets_count": 44,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-10": 3,
              "2025-12-23": 1,
              "2026-01-23": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-22": 1,
              "2026-02-28": 3,
              "2026-03-05": 1,
              "2026-03-07": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-15": 1,
              "2026-03-16": 2,
              "2026-03-17": 2,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-31": 1,
              "2026-04-09": 1,
              "2026-04-13": 2,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-29": 1,
              "2026-05-25": 1,
              "2026-06-03": 2
            },
            "time_per_day": {
              "2025-10-29": 22.84589861111111,
              "2025-11-18": 144.76843444444444,
              "2025-11-19": 636.5614491666666,
              "2025-11-24": 65.52261638888889,
              "2025-11-27": 23.6250775,
              "2025-12-10": 140.77289666666667,
              "2025-12-23": 18.55293138888889,
              "2026-01-23": 16.924414444444444,
              "2026-02-03": 2.8362169444444447,
              "2026-02-04": 0.017374722222222222,
              "2026-02-10": 20.427686944444442,
              "2026-02-18": 22.369331944444443,
              "2026-02-20": 104.89020277777777,
              "2026-02-22": 29.831705277777775,
              "2026-02-28": 62.69834555555556,
              "2026-03-05": 75.33637972222222,
              "2026-03-07": 2.54558,
              "2026-03-10": 1.6037083333333335,
              "2026-03-11": 25.888493333333333,
              "2026-03-14": 23.656514444444447,
              "2026-03-15": 39.66556027777778,
              "2026-03-16": 87.38445777777777,
              "2026-03-17": 496.48918972222225,
              "2026-03-19": 470.6223508333333,
              "2026-03-20": 3.3925477777777777,
              "2026-03-31": 21.25219138888889,
              "2026-04-09": 173.34555944444443,
              "2026-04-13": 65.23308583333333,
              "2026-04-16": 800.1197591666667,
              "2026-04-22": 134.68406027777777,
              "2026-04-29": 148.42557916666667,
              "2026-05-25": 279.41197305555556,
              "2026-06-03": 37.82481888888889
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-11-18": 1,
              "2025-11-19": 2,
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2025-12-10": 3,
              "2025-12-23": 1,
              "2026-01-23": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-22": 1,
              "2026-02-28": 3,
              "2026-03-05": 1,
              "2026-03-07": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-15": 1,
              "2026-03-16": 2,
              "2026-03-17": 2,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-31": 1,
              "2026-04-09": 1,
              "2026-04-13": 2,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-29": 1,
              "2026-05-25": 1,
              "2026-06-03": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 99.53,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 2,
                "12-14h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 2,
                "24-26h": 3,
                "32-34h": 2,
                "38-40h": 1,
                "60-62h": 1,
                "64-66h": 1,
                "74-76h": 1,
                "104-106h": 1,
                "148-150h": 1,
                "172-174h": 1,
                "278-280h": 1,
                "414-416h": 1,
                "470-472h": 1,
                "800-802h": 1
              },
              "tickets_count": 29,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-10": 2,
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-20": 1,
                "2026-03-05": 1,
                "2026-03-07": 2,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-15": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-31": 1,
                "2026-04-09": 1,
                "2026-04-13": 2,
                "2026-04-16": 1,
                "2026-04-29": 1,
                "2026-05-25": 1,
                "2026-06-03": 2
              },
              "time_per_day": {
                "2025-10-29": 22.84589861111111,
                "2025-11-24": 65.52261638888889,
                "2025-11-27": 23.6250775,
                "2025-12-10": 4.1385008333333335,
                "2025-12-23": 18.55293138888889,
                "2026-02-03": 0.5038086111111111,
                "2026-02-04": 0.017374722222222222,
                "2026-02-20": 104.89020277777777,
                "2026-03-05": 75.33637972222222,
                "2026-03-07": 2.54558,
                "2026-03-10": 1.6037083333333335,
                "2026-03-11": 25.888493333333333,
                "2026-03-15": 39.66556027777778,
                "2026-03-16": 87.38445777777777,
                "2026-03-17": 414.2320569444445,
                "2026-03-19": 470.6223508333333,
                "2026-03-20": 3.3925477777777777,
                "2026-03-31": 21.25219138888889,
                "2026-04-09": 173.34555944444443,
                "2026-04-13": 65.23308583333333,
                "2026-04-16": 800.1197591666667,
                "2026-04-29": 148.42557916666667,
                "2026-05-25": 279.41197305555556,
                "2026-06-03": 37.82481888888889
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2025-12-10": 2,
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-20": 1,
                "2026-03-05": 1,
                "2026-03-07": 2,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-15": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-31": 1,
                "2026-04-09": 1,
                "2026-04-13": 2,
                "2026-04-16": 1,
                "2026-04-29": 1,
                "2026-05-25": 1,
                "2026-06-03": 2
              }
            },
            "P3": {
              "avg_time_hours": 125.94,
              "mode_time_hours": 619.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "28-30h": 1,
                "136-138h": 1,
                "144-146h": 1,
                "618-620h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-11-19": 2,
                "2025-12-10": 1,
                "2026-01-23": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-22": 1
              },
              "time_per_day": {
                "2025-11-18": 144.76843444444444,
                "2025-11-19": 636.5614491666666,
                "2025-12-10": 136.63439583333334,
                "2026-01-23": 16.924414444444444,
                "2026-02-10": 20.427686944444442,
                "2026-02-18": 22.369331944444443,
                "2026-02-22": 29.831705277777775
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-11-19": 2,
                "2025-12-10": 1,
                "2026-01-23": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-22": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 43.66,
              "mode_time_hours": 21.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 1,
                "20-22h": 3,
                "22-24h": 1,
                "82-84h": 1,
                "134-136h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-28": 3,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-02-03": 2.3324083333333334,
                "2026-02-28": 62.69834555555556,
                "2026-03-14": 23.656514444444447,
                "2026-03-17": 82.25713277777778,
                "2026-04-22": 134.68406027777777
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-28": 3,
                "2026-03-14": 1,
                "2026-03-17": 1,
                "2026-04-22": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_331": {
      "overall": {
        "avg_time_hours": 10.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 21,
        "time_distribution": {
          "0-2h": 21,
          "2-4h": 3,
          "4-6h": 3,
          "6-8h": 1,
          "252-254h": 1
        },
        "tickets_count": 29,
        "tickets_per_day": {
          "2025-10-25": 1,
          "2025-10-28": 3,
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-19": 1,
          "2026-01-19": 2,
          "2026-02-12": 1,
          "2026-02-26": 1,
          "2026-03-11": 2,
          "2026-03-18": 1,
          "2026-03-19": 1,
          "2026-03-31": 1,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-26": 2,
          "2026-05-29": 2,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-25": 0.5805683333333332,
          "2025-10-28": 0.6857172222222222,
          "2025-10-29": 0.8996869444444444,
          "2025-10-31": 0.3519244444444445,
          "2025-11-19": 1.386115,
          "2026-01-19": 6.4171933333333335,
          "2026-02-12": 1.174358888888889,
          "2026-02-26": 0.3874708333333333,
          "2026-03-11": 1.0487038888888887,
          "2026-03-18": 7.1086125000000004,
          "2026-03-19": 0.5217163888888889,
          "2026-03-31": 1.4804683333333333,
          "2026-04-30": 2.3728422222222223,
          "2026-05-02": 5.363859722222222,
          "2026-05-05": 0.17910777777777778,
          "2026-05-14": 253.31884666666667,
          "2026-05-19": 1.4578872222222223,
          "2026-05-21": 0.8914669444444444,
          "2026-05-25": 0.2644436111111111,
          "2026-05-26": 1.4678825000000002,
          "2026-05-29": 9.949840833333333,
          "2026-06-08": 0.717355
        },
        "time_count_per_day": {
          "2025-10-25": 1,
          "2025-10-28": 3,
          "2025-10-29": 1,
          "2025-10-31": 1,
          "2025-11-19": 1,
          "2026-01-19": 2,
          "2026-02-12": 1,
          "2026-02-26": 1,
          "2026-03-11": 2,
          "2026-03-18": 1,
          "2026-03-19": 1,
          "2026-03-31": 1,
          "2026-04-30": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-26": 2,
          "2026-05-29": 2,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.59,
          "mode_time_hours": 1.0,
          "mode_frequency": 20,
          "time_distribution": {
            "0-2h": 20,
            "2-4h": 3,
            "4-6h": 3,
            "6-8h": 1,
            "252-254h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2025-10-25": 1,
            "2025-10-28": 3,
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2026-01-19": 2,
            "2026-02-12": 1,
            "2026-02-26": 1,
            "2026-03-11": 2,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-31": 1,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-29": 2,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-25": 0.5805683333333332,
            "2025-10-28": 0.6857172222222222,
            "2025-10-29": 0.8996869444444444,
            "2025-10-31": 0.3519244444444445,
            "2026-01-19": 6.4171933333333335,
            "2026-02-12": 1.174358888888889,
            "2026-02-26": 0.3874708333333333,
            "2026-03-11": 1.0487038888888887,
            "2026-03-18": 7.1086125000000004,
            "2026-03-19": 0.5217163888888889,
            "2026-03-31": 1.4804683333333333,
            "2026-04-30": 2.3728422222222223,
            "2026-05-02": 5.363859722222222,
            "2026-05-05": 0.17910777777777778,
            "2026-05-14": 253.31884666666667,
            "2026-05-19": 1.4578872222222223,
            "2026-05-21": 0.8914669444444444,
            "2026-05-25": 0.2644436111111111,
            "2026-05-26": 1.4678825000000002,
            "2026-05-29": 9.949840833333333,
            "2026-06-08": 0.717355
          },
          "time_count_per_day": {
            "2025-10-25": 1,
            "2025-10-28": 3,
            "2025-10-29": 1,
            "2025-10-31": 1,
            "2026-01-19": 2,
            "2026-02-12": 1,
            "2026-02-26": 1,
            "2026-03-11": 2,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-31": 1,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-29": 2,
            "2026-06-08": 2
          }
        },
        "P3": {
          "avg_time_hours": 1.39,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-19": 1
          },
          "time_per_day": {
            "2025-11-19": 1.386115
          },
          "time_count_per_day": {
            "2025-11-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 21,
            "time_distribution": {
              "0-2h": 21,
              "2-4h": 3,
              "4-6h": 3,
              "6-8h": 1,
              "252-254h": 1
            },
            "tickets_count": 29,
            "tickets_per_day": {
              "2025-10-25": 1,
              "2025-10-28": 3,
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-19": 1,
              "2026-01-19": 2,
              "2026-02-12": 1,
              "2026-02-26": 1,
              "2026-03-11": 2,
              "2026-03-18": 1,
              "2026-03-19": 1,
              "2026-03-31": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-26": 2,
              "2026-05-29": 2,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-25": 0.5805683333333332,
              "2025-10-28": 0.6857172222222222,
              "2025-10-29": 0.8996869444444444,
              "2025-10-31": 0.3519244444444445,
              "2025-11-19": 1.386115,
              "2026-01-19": 6.4171933333333335,
              "2026-02-12": 1.174358888888889,
              "2026-02-26": 0.3874708333333333,
              "2026-03-11": 1.0487038888888887,
              "2026-03-18": 7.1086125000000004,
              "2026-03-19": 0.5217163888888889,
              "2026-03-31": 1.4804683333333333,
              "2026-04-30": 2.3728422222222223,
              "2026-05-02": 5.363859722222222,
              "2026-05-05": 0.17910777777777778,
              "2026-05-14": 253.31884666666667,
              "2026-05-19": 1.4578872222222223,
              "2026-05-21": 0.8914669444444444,
              "2026-05-25": 0.2644436111111111,
              "2026-05-26": 1.4678825000000002,
              "2026-05-29": 9.949840833333333,
              "2026-06-08": 0.717355
            },
            "time_count_per_day": {
              "2025-10-25": 1,
              "2025-10-28": 3,
              "2025-10-29": 1,
              "2025-10-31": 1,
              "2025-11-19": 1,
              "2026-01-19": 2,
              "2026-02-12": 1,
              "2026-02-26": 1,
              "2026-03-11": 2,
              "2026-03-18": 1,
              "2026-03-19": 1,
              "2026-03-31": 1,
              "2026-04-30": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-26": 2,
              "2026-05-29": 2,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.59,
              "mode_time_hours": 1.0,
              "mode_frequency": 20,
              "time_distribution": {
                "0-2h": 20,
                "2-4h": 3,
                "4-6h": 3,
                "6-8h": 1,
                "252-254h": 1
              },
              "tickets_count": 28,
              "tickets_per_day": {
                "2025-10-25": 1,
                "2025-10-28": 3,
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2026-01-19": 2,
                "2026-02-12": 1,
                "2026-02-26": 1,
                "2026-03-11": 2,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-31": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-26": 2,
                "2026-05-29": 2,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-10-25": 0.5805683333333332,
                "2025-10-28": 0.6857172222222222,
                "2025-10-29": 0.8996869444444444,
                "2025-10-31": 0.3519244444444445,
                "2026-01-19": 6.4171933333333335,
                "2026-02-12": 1.174358888888889,
                "2026-02-26": 0.3874708333333333,
                "2026-03-11": 1.0487038888888887,
                "2026-03-18": 7.1086125000000004,
                "2026-03-19": 0.5217163888888889,
                "2026-03-31": 1.4804683333333333,
                "2026-04-30": 2.3728422222222223,
                "2026-05-02": 5.363859722222222,
                "2026-05-05": 0.17910777777777778,
                "2026-05-14": 253.31884666666667,
                "2026-05-19": 1.4578872222222223,
                "2026-05-21": 0.8914669444444444,
                "2026-05-25": 0.2644436111111111,
                "2026-05-26": 1.4678825000000002,
                "2026-05-29": 9.949840833333333,
                "2026-06-08": 0.717355
              },
              "time_count_per_day": {
                "2025-10-25": 1,
                "2025-10-28": 3,
                "2025-10-29": 1,
                "2025-10-31": 1,
                "2026-01-19": 2,
                "2026-02-12": 1,
                "2026-02-26": 1,
                "2026-03-11": 2,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-31": 1,
                "2026-04-30": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-26": 2,
                "2026-05-29": 2,
                "2026-06-08": 2
              }
            },
            "P3": {
              "avg_time_hours": 1.39,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-19": 1
              },
              "time_per_day": {
                "2025-11-19": 1.386115
              },
              "time_count_per_day": {
                "2025-11-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_250": {
      "overall": {
        "avg_time_hours": 173.24,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 2,
          "18-20h": 1,
          "40-42h": 1,
          "84-86h": 1,
          "122-124h": 1,
          "512-514h": 1,
          "596-598h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-10-31": 2,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-12-18": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-10-31": 143.5099913888889,
          "2025-11-19": 597.4271308333333,
          "2025-11-26": 2.4913827777777775,
          "2025-12-18": 85.12831222222222,
          "2026-01-21": 41.51640583333333,
          "2026-01-27": 2.196115277777778,
          "2026-02-12": 513.6154402777778
        },
        "time_count_per_day": {
          "2025-10-31": 2,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-12-18": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 216.43,
          "mode_time_hours": 597.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "18-20h": 1,
            "40-42h": 1,
            "122-124h": 1,
            "512-514h": 1,
            "596-598h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-31": 2,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2026-01-21": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-10-31": 143.5099913888889,
            "2025-11-19": 597.4271308333333,
            "2025-11-26": 2.4913827777777775,
            "2026-01-21": 41.51640583333333,
            "2026-02-12": 513.6154402777778
          },
          "time_count_per_day": {
            "2025-10-31": 2,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2026-01-21": 1,
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 43.66,
          "mode_time_hours": 85.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "84-86h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-18": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-12-18": 85.12831222222222,
            "2026-01-27": 2.196115277777778
          },
          "time_count_per_day": {
            "2025-12-18": 1,
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 173.24,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 2,
              "18-20h": 1,
              "40-42h": 1,
              "84-86h": 1,
              "122-124h": 1,
              "512-514h": 1,
              "596-598h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-10-31": 2,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-12-18": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-10-31": 143.5099913888889,
              "2025-11-19": 597.4271308333333,
              "2025-11-26": 2.4913827777777775,
              "2025-12-18": 85.12831222222222,
              "2026-01-21": 41.51640583333333,
              "2026-01-27": 2.196115277777778,
              "2026-02-12": 513.6154402777778
            },
            "time_count_per_day": {
              "2025-10-31": 2,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-12-18": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 216.43,
              "mode_time_hours": 597.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "18-20h": 1,
                "40-42h": 1,
                "122-124h": 1,
                "512-514h": 1,
                "596-598h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-31": 2,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2026-01-21": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-10-31": 143.5099913888889,
                "2025-11-19": 597.4271308333333,
                "2025-11-26": 2.4913827777777775,
                "2026-01-21": 41.51640583333333,
                "2026-02-12": 513.6154402777778
              },
              "time_count_per_day": {
                "2025-10-31": 2,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2026-01-21": 1,
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 43.66,
              "mode_time_hours": 85.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "84-86h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-18": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-12-18": 85.12831222222222,
                "2026-01-27": 2.196115277777778
              },
              "time_count_per_day": {
                "2025-12-18": 1,
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_336": {
      "overall": {
        "avg_time_hours": 73.04,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "16-18h": 1,
          "70-72h": 1,
          "80-82h": 1,
          "194-196h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-25": 1,
          "2025-11-04": 1,
          "2025-11-11": 1,
          "2025-12-13": 1,
          "2025-12-17": 1
        },
        "time_per_day": {
          "2025-10-25": 0.29039722222222225,
          "2025-11-04": 17.308904444444444,
          "2025-11-11": 81.77996888888889,
          "2025-12-13": 194.64593527777777,
          "2025-12-17": 71.16087444444445
        },
        "time_count_per_day": {
          "2025-10-25": 1,
          "2025-11-04": 1,
          "2025-11-11": 1,
          "2025-12-13": 1,
          "2025-12-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 42.64,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "16-18h": 1,
            "70-72h": 1,
            "80-82h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-25": 1,
            "2025-11-04": 1,
            "2025-11-11": 1,
            "2025-12-17": 1
          },
          "time_per_day": {
            "2025-10-25": 0.29039722222222225,
            "2025-11-04": 17.308904444444444,
            "2025-11-11": 81.77996888888889,
            "2025-12-17": 71.16087444444445
          },
          "time_count_per_day": {
            "2025-10-25": 1,
            "2025-11-04": 1,
            "2025-11-11": 1,
            "2025-12-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 194.65,
          "mode_time_hours": 195.0,
          "mode_frequency": 1,
          "time_distribution": {
            "194-196h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-13": 1
          },
          "time_per_day": {
            "2025-12-13": 194.64593527777777
          },
          "time_count_per_day": {
            "2025-12-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 73.04,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "16-18h": 1,
              "70-72h": 1,
              "80-82h": 1,
              "194-196h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-10-25": 1,
              "2025-11-04": 1,
              "2025-11-11": 1,
              "2025-12-13": 1,
              "2025-12-17": 1
            },
            "time_per_day": {
              "2025-10-25": 0.29039722222222225,
              "2025-11-04": 17.308904444444444,
              "2025-11-11": 81.77996888888889,
              "2025-12-13": 194.64593527777777,
              "2025-12-17": 71.16087444444445
            },
            "time_count_per_day": {
              "2025-10-25": 1,
              "2025-11-04": 1,
              "2025-11-11": 1,
              "2025-12-13": 1,
              "2025-12-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 42.64,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "16-18h": 1,
                "70-72h": 1,
                "80-82h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-25": 1,
                "2025-11-04": 1,
                "2025-11-11": 1,
                "2025-12-17": 1
              },
              "time_per_day": {
                "2025-10-25": 0.29039722222222225,
                "2025-11-04": 17.308904444444444,
                "2025-11-11": 81.77996888888889,
                "2025-12-17": 71.16087444444445
              },
              "time_count_per_day": {
                "2025-10-25": 1,
                "2025-11-04": 1,
                "2025-11-11": 1,
                "2025-12-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 194.65,
              "mode_time_hours": 195.0,
              "mode_frequency": 1,
              "time_distribution": {
                "194-196h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-13": 1
              },
              "time_per_day": {
                "2025-12-13": 194.64593527777777
              },
              "time_count_per_day": {
                "2025-12-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_212": {
      "overall": {
        "avg_time_hours": 198.74,
        "mode_time_hours": 35.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 3,
          "4-6h": 3,
          "8-10h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "18-20h": 3,
          "20-22h": 3,
          "22-24h": 3,
          "24-26h": 1,
          "26-28h": 3,
          "28-30h": 1,
          "30-32h": 2,
          "34-36h": 5,
          "42-44h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 2,
          "52-54h": 1,
          "60-62h": 1,
          "72-74h": 1,
          "114-116h": 1,
          "120-122h": 2,
          "190-192h": 1,
          "226-228h": 1,
          "236-238h": 1,
          "256-258h": 1,
          "334-336h": 1,
          "336-338h": 1,
          "348-350h": 1,
          "388-390h": 1,
          "398-400h": 1,
          "492-494h": 1,
          "504-506h": 1,
          "572-574h": 1,
          "582-584h": 1,
          "936-938h": 1,
          "1050-1052h": 1,
          "1052-1054h": 1,
          "1070-1072h": 1,
          "1122-1124h": 1,
          "1144-1146h": 1
        },
        "tickets_count": 67,
        "tickets_per_day": {
          "2025-10-27": 1,
          "2025-12-14": 1,
          "2026-01-16": 1,
          "2026-01-19": 5,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-27": 3,
          "2026-02-02": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-07": 1,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-14": 1,
          "2026-03-19": 2,
          "2026-03-20": 2,
          "2026-03-24": 1,
          "2026-03-31": 3,
          "2026-04-06": 1,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-22": 3,
          "2026-04-23": 2,
          "2026-04-29": 2,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-05": 4,
          "2026-05-06": 2,
          "2026-05-11": 1,
          "2026-05-13": 2,
          "2026-05-18": 2,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-26": 2,
          "2026-05-28": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-10-27": 27.39360277777778,
          "2025-12-14": 50.887531388888895,
          "2026-01-16": 19.88397666666667,
          "2026-01-19": 170.8699275,
          "2026-01-20": 89.30498583333333,
          "2026-01-21": 27.663308333333333,
          "2026-01-23": 23.458491944444443,
          "2026-01-27": 89.31977722222223,
          "2026-02-02": 3.683951111111111,
          "2026-02-03": 540.570325,
          "2026-02-05": 72.84735416666666,
          "2026-02-07": 8.464044166666667,
          "2026-02-14": 4.330216666666667,
          "2026-02-18": 60.80754916666667,
          "2026-03-06": 2.297505,
          "2026-03-10": 21.951671666666666,
          "2026-03-12": 20.067043611111114,
          "2026-03-14": 0.7139161111111111,
          "2026-03-19": 627.5774252777778,
          "2026-03-20": 1195.5289255555556,
          "2026-03-24": 51.720005,
          "2026-03-31": 313.76189250000004,
          "2026-04-16": 170.04819277777779,
          "2026-04-17": 1145.2513358333333,
          "2026-04-22": 3225.8061141666667,
          "2026-04-23": 1407.9502813888887,
          "2026-04-29": 2.777702777777778,
          "2026-04-30": 15.228385277777777,
          "2026-05-04": 399.06576472222224,
          "2026-05-05": 1995.807135,
          "2026-05-06": 349.4731816666666,
          "2026-05-11": 19.65769361111111,
          "2026-05-13": 20.628606944444446,
          "2026-05-18": 99.9349636111111,
          "2026-05-19": 42.55113472222222,
          "2026-05-21": 114.32063555555555,
          "2026-05-22": 18.3884975,
          "2026-05-26": 251.44447055555557,
          "2026-05-28": 4.1213758333333335,
          "2026-06-01": 13.889641944444445
        },
        "time_count_per_day": {
          "2025-10-27": 1,
          "2025-12-14": 1,
          "2026-01-16": 1,
          "2026-01-19": 5,
          "2026-01-20": 3,
          "2026-01-21": 1,
          "2026-01-23": 1,
          "2026-01-27": 3,
          "2026-02-02": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-07": 1,
          "2026-02-14": 1,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-03-14": 1,
          "2026-03-19": 2,
          "2026-03-20": 2,
          "2026-03-24": 1,
          "2026-03-31": 3,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-22": 3,
          "2026-04-23": 2,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-05": 4,
          "2026-05-06": 1,
          "2026-05-11": 1,
          "2026-05-13": 2,
          "2026-05-18": 2,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-22": 1,
          "2026-05-26": 2,
          "2026-05-28": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 228.04,
          "mode_time_hours": 121.0,
          "mode_frequency": 1,
          "time_distribution": {
            "120-122h": 1,
            "334-336h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-31": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-03-31": 121.01029222222223,
            "2026-05-05": 335.0730813888889
          },
          "time_count_per_day": {
            "2026-03-31": 1,
            "2026-05-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 235.7,
          "mode_time_hours": 35.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 3,
            "4-6h": 2,
            "12-14h": 1,
            "14-16h": 1,
            "18-20h": 2,
            "20-22h": 3,
            "24-26h": 1,
            "26-28h": 3,
            "28-30h": 1,
            "30-32h": 1,
            "34-36h": 4,
            "42-44h": 1,
            "46-48h": 1,
            "48-50h": 2,
            "50-52h": 1,
            "52-54h": 1,
            "114-116h": 1,
            "190-192h": 1,
            "226-228h": 1,
            "256-258h": 1,
            "336-338h": 1,
            "348-350h": 1,
            "388-390h": 1,
            "398-400h": 1,
            "492-494h": 1,
            "504-506h": 1,
            "572-574h": 1,
            "582-584h": 1,
            "936-938h": 1,
            "1050-1052h": 1,
            "1052-1054h": 1,
            "1070-1072h": 1,
            "1122-1124h": 1,
            "1144-1146h": 1
          },
          "tickets_count": 51,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2026-01-19": 5,
            "2026-01-20": 1,
            "2026-01-21": 1,
            "2026-01-27": 2,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-14": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-14": 1,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-03-31": 2,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-22": 3,
            "2026-04-23": 2,
            "2026-04-29": 2,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-05": 3,
            "2026-05-06": 2,
            "2026-05-11": 1,
            "2026-05-13": 2,
            "2026-05-18": 2,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-26": 2,
            "2026-05-28": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-10-27": 27.39360277777778,
            "2026-01-19": 170.8699275,
            "2026-01-20": 49.1432375,
            "2026-01-21": 27.663308333333333,
            "2026-01-27": 57.94516777777778,
            "2026-02-02": 3.683951111111111,
            "2026-02-03": 493.2551225,
            "2026-02-14": 4.330216666666667,
            "2026-03-06": 2.297505,
            "2026-03-10": 21.951671666666666,
            "2026-03-12": 20.067043611111114,
            "2026-03-14": 0.7139161111111111,
            "2026-03-19": 389.95647583333334,
            "2026-03-20": 1195.5289255555556,
            "2026-03-24": 51.720005,
            "2026-03-31": 192.7516002777778,
            "2026-04-16": 48.84182861111111,
            "2026-04-17": 1145.2513358333333,
            "2026-04-22": 3225.8061141666667,
            "2026-04-23": 1407.9502813888887,
            "2026-04-29": 2.777702777777778,
            "2026-04-30": 15.228385277777777,
            "2026-05-04": 399.06576472222224,
            "2026-05-05": 1660.7340536111112,
            "2026-05-06": 349.4731816666666,
            "2026-05-11": 19.65769361111111,
            "2026-05-13": 20.628606944444446,
            "2026-05-18": 99.9349636111111,
            "2026-05-19": 42.55113472222222,
            "2026-05-21": 114.32063555555555,
            "2026-05-22": 18.3884975,
            "2026-05-26": 251.44447055555557,
            "2026-05-28": 4.1213758333333335,
            "2026-06-01": 13.889641944444445
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2026-01-19": 5,
            "2026-01-20": 1,
            "2026-01-21": 1,
            "2026-01-27": 2,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-14": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-03-14": 1,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-03-31": 2,
            "2026-04-16": 1,
            "2026-04-17": 1,
            "2026-04-22": 3,
            "2026-04-23": 2,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-04": 1,
            "2026-05-05": 3,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-13": 2,
            "2026-05-18": 2,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-22": 1,
            "2026-05-26": 2,
            "2026-05-28": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 54.93,
          "mode_time_hours": 23.0,
          "mode_frequency": 3,
          "time_distribution": {
            "4-6h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "22-24h": 3,
            "30-32h": 1,
            "34-36h": 1,
            "50-52h": 1,
            "60-62h": 1,
            "72-74h": 1,
            "120-122h": 1,
            "236-238h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-12-14": 1,
            "2026-01-16": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-18": 1,
            "2026-03-19": 1,
            "2026-04-16": 1
          },
          "time_per_day": {
            "2025-12-14": 50.887531388888895,
            "2026-01-16": 19.88397666666667,
            "2026-01-20": 40.16174833333333,
            "2026-01-23": 23.458491944444443,
            "2026-01-27": 31.374609444444445,
            "2026-02-03": 47.3152025,
            "2026-02-05": 72.84735416666666,
            "2026-02-07": 8.464044166666667,
            "2026-02-18": 60.80754916666667,
            "2026-03-19": 237.62094944444442,
            "2026-04-16": 121.20636416666667
          },
          "time_count_per_day": {
            "2025-12-14": 1,
            "2026-01-16": 1,
            "2026-01-20": 2,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-18": 1,
            "2026-03-19": 1,
            "2026-04-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 198.74,
            "mode_time_hours": 35.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 3,
              "4-6h": 3,
              "8-10h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "18-20h": 3,
              "20-22h": 3,
              "22-24h": 3,
              "24-26h": 1,
              "26-28h": 3,
              "28-30h": 1,
              "30-32h": 2,
              "34-36h": 5,
              "42-44h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 2,
              "52-54h": 1,
              "60-62h": 1,
              "72-74h": 1,
              "114-116h": 1,
              "120-122h": 2,
              "190-192h": 1,
              "226-228h": 1,
              "236-238h": 1,
              "256-258h": 1,
              "334-336h": 1,
              "336-338h": 1,
              "348-350h": 1,
              "388-390h": 1,
              "398-400h": 1,
              "492-494h": 1,
              "504-506h": 1,
              "572-574h": 1,
              "582-584h": 1,
              "936-938h": 1,
              "1050-1052h": 1,
              "1052-1054h": 1,
              "1070-1072h": 1,
              "1122-1124h": 1,
              "1144-1146h": 1
            },
            "tickets_count": 64,
            "tickets_per_day": {
              "2025-10-27": 1,
              "2025-12-14": 1,
              "2026-01-16": 1,
              "2026-01-19": 5,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-27": 3,
              "2026-02-02": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-07": 1,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-14": 1,
              "2026-03-19": 2,
              "2026-03-20": 2,
              "2026-03-24": 1,
              "2026-03-31": 3,
              "2026-04-16": 2,
              "2026-04-17": 1,
              "2026-04-22": 3,
              "2026-04-23": 2,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-05": 4,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-13": 2,
              "2026-05-18": 2,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-26": 2,
              "2026-05-28": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-10-27": 27.39360277777778,
              "2025-12-14": 50.887531388888895,
              "2026-01-16": 19.88397666666667,
              "2026-01-19": 170.8699275,
              "2026-01-20": 89.30498583333333,
              "2026-01-21": 27.663308333333333,
              "2026-01-23": 23.458491944444443,
              "2026-01-27": 89.31977722222223,
              "2026-02-02": 3.683951111111111,
              "2026-02-03": 540.570325,
              "2026-02-05": 72.84735416666666,
              "2026-02-07": 8.464044166666667,
              "2026-02-14": 4.330216666666667,
              "2026-02-18": 60.80754916666667,
              "2026-03-06": 2.297505,
              "2026-03-10": 21.951671666666666,
              "2026-03-12": 20.067043611111114,
              "2026-03-14": 0.7139161111111111,
              "2026-03-19": 627.5774252777778,
              "2026-03-20": 1195.5289255555556,
              "2026-03-24": 51.720005,
              "2026-03-31": 313.76189250000004,
              "2026-04-16": 170.04819277777779,
              "2026-04-17": 1145.2513358333333,
              "2026-04-22": 3225.8061141666667,
              "2026-04-23": 1407.9502813888887,
              "2026-04-29": 2.777702777777778,
              "2026-04-30": 15.228385277777777,
              "2026-05-04": 399.06576472222224,
              "2026-05-05": 1995.807135,
              "2026-05-06": 349.4731816666666,
              "2026-05-11": 19.65769361111111,
              "2026-05-13": 20.628606944444446,
              "2026-05-18": 99.9349636111111,
              "2026-05-19": 42.55113472222222,
              "2026-05-21": 114.32063555555555,
              "2026-05-22": 18.3884975,
              "2026-05-26": 251.44447055555557,
              "2026-05-28": 4.1213758333333335,
              "2026-06-01": 13.889641944444445
            },
            "time_count_per_day": {
              "2025-10-27": 1,
              "2025-12-14": 1,
              "2026-01-16": 1,
              "2026-01-19": 5,
              "2026-01-20": 3,
              "2026-01-21": 1,
              "2026-01-23": 1,
              "2026-01-27": 3,
              "2026-02-02": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-07": 1,
              "2026-02-14": 1,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-03-14": 1,
              "2026-03-19": 2,
              "2026-03-20": 2,
              "2026-03-24": 1,
              "2026-03-31": 3,
              "2026-04-16": 2,
              "2026-04-17": 1,
              "2026-04-22": 3,
              "2026-04-23": 2,
              "2026-04-29": 1,
              "2026-04-30": 1,
              "2026-05-04": 1,
              "2026-05-05": 4,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-13": 2,
              "2026-05-18": 2,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-22": 1,
              "2026-05-26": 2,
              "2026-05-28": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 228.04,
              "mode_time_hours": 121.0,
              "mode_frequency": 1,
              "time_distribution": {
                "120-122h": 1,
                "334-336h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-31": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-03-31": 121.01029222222223,
                "2026-05-05": 335.0730813888889
              },
              "time_count_per_day": {
                "2026-03-31": 1,
                "2026-05-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 235.7,
              "mode_time_hours": 35.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 3,
                "4-6h": 2,
                "12-14h": 1,
                "14-16h": 1,
                "18-20h": 2,
                "20-22h": 3,
                "24-26h": 1,
                "26-28h": 3,
                "28-30h": 1,
                "30-32h": 1,
                "34-36h": 4,
                "42-44h": 1,
                "46-48h": 1,
                "48-50h": 2,
                "50-52h": 1,
                "52-54h": 1,
                "114-116h": 1,
                "190-192h": 1,
                "226-228h": 1,
                "256-258h": 1,
                "336-338h": 1,
                "348-350h": 1,
                "388-390h": 1,
                "398-400h": 1,
                "492-494h": 1,
                "504-506h": 1,
                "572-574h": 1,
                "582-584h": 1,
                "936-938h": 1,
                "1050-1052h": 1,
                "1052-1054h": 1,
                "1070-1072h": 1,
                "1122-1124h": 1,
                "1144-1146h": 1
              },
              "tickets_count": 49,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2026-01-19": 5,
                "2026-01-20": 1,
                "2026-01-21": 1,
                "2026-01-27": 2,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-14": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-14": 1,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-03-31": 2,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-22": 3,
                "2026-04-23": 2,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-05": 3,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-13": 2,
                "2026-05-18": 2,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-26": 2,
                "2026-05-28": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-10-27": 27.39360277777778,
                "2026-01-19": 170.8699275,
                "2026-01-20": 49.1432375,
                "2026-01-21": 27.663308333333333,
                "2026-01-27": 57.94516777777778,
                "2026-02-02": 3.683951111111111,
                "2026-02-03": 493.2551225,
                "2026-02-14": 4.330216666666667,
                "2026-03-06": 2.297505,
                "2026-03-10": 21.951671666666666,
                "2026-03-12": 20.067043611111114,
                "2026-03-14": 0.7139161111111111,
                "2026-03-19": 389.95647583333334,
                "2026-03-20": 1195.5289255555556,
                "2026-03-24": 51.720005,
                "2026-03-31": 192.7516002777778,
                "2026-04-16": 48.84182861111111,
                "2026-04-17": 1145.2513358333333,
                "2026-04-22": 3225.8061141666667,
                "2026-04-23": 1407.9502813888887,
                "2026-04-29": 2.777702777777778,
                "2026-04-30": 15.228385277777777,
                "2026-05-04": 399.06576472222224,
                "2026-05-05": 1660.7340536111112,
                "2026-05-06": 349.4731816666666,
                "2026-05-11": 19.65769361111111,
                "2026-05-13": 20.628606944444446,
                "2026-05-18": 99.9349636111111,
                "2026-05-19": 42.55113472222222,
                "2026-05-21": 114.32063555555555,
                "2026-05-22": 18.3884975,
                "2026-05-26": 251.44447055555557,
                "2026-05-28": 4.1213758333333335,
                "2026-06-01": 13.889641944444445
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2026-01-19": 5,
                "2026-01-20": 1,
                "2026-01-21": 1,
                "2026-01-27": 2,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-14": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-12": 1,
                "2026-03-14": 1,
                "2026-03-19": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-03-31": 2,
                "2026-04-16": 1,
                "2026-04-17": 1,
                "2026-04-22": 3,
                "2026-04-23": 2,
                "2026-04-29": 1,
                "2026-04-30": 1,
                "2026-05-04": 1,
                "2026-05-05": 3,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-13": 2,
                "2026-05-18": 2,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-22": 1,
                "2026-05-26": 2,
                "2026-05-28": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 54.93,
              "mode_time_hours": 23.0,
              "mode_frequency": 3,
              "time_distribution": {
                "4-6h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "22-24h": 3,
                "30-32h": 1,
                "34-36h": 1,
                "50-52h": 1,
                "60-62h": 1,
                "72-74h": 1,
                "120-122h": 1,
                "236-238h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-12-14": 1,
                "2026-01-16": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-18": 1,
                "2026-03-19": 1,
                "2026-04-16": 1
              },
              "time_per_day": {
                "2025-12-14": 50.887531388888895,
                "2026-01-16": 19.88397666666667,
                "2026-01-20": 40.16174833333333,
                "2026-01-23": 23.458491944444443,
                "2026-01-27": 31.374609444444445,
                "2026-02-03": 47.3152025,
                "2026-02-05": 72.84735416666666,
                "2026-02-07": 8.464044166666667,
                "2026-02-18": 60.80754916666667,
                "2026-03-19": 237.62094944444442,
                "2026-04-16": 121.20636416666667
              },
              "time_count_per_day": {
                "2025-12-14": 1,
                "2026-01-16": 1,
                "2026-01-20": 2,
                "2026-01-23": 1,
                "2026-01-27": 1,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-18": 1,
                "2026-03-19": 1,
                "2026-04-16": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_338": {
      "overall": {
        "avg_time_hours": 208.8,
        "mode_time_hours": 101.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1,
          "34-36h": 1,
          "46-48h": 1,
          "76-78h": 1,
          "78-80h": 1,
          "100-102h": 1,
          "1104-1106h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-21": 1,
          "2025-12-13": 1,
          "2026-02-12": 2,
          "2026-04-13": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-10-31": 101.72595749999999,
          "2025-11-21": 78.13102416666666,
          "2025-12-13": 76.52538222222222,
          "2026-02-12": 65.91381222222222,
          "2026-04-13": 1104.407138888889,
          "2026-06-03": 34.88915
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-21": 1,
          "2025-12-13": 1,
          "2026-02-12": 2,
          "2026-04-13": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 329.39,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "34-36h": 1,
            "76-78h": 1,
            "100-102h": 1,
            "1104-1106h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2025-12-13": 1,
            "2026-04-13": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-10-31": 101.72595749999999,
            "2025-12-13": 76.52538222222222,
            "2026-04-13": 1104.407138888889,
            "2026-06-03": 34.88915
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2025-12-13": 1,
            "2026-04-13": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 48.52,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "78-80h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-21": 78.13102416666666,
            "2026-02-12": 18.907172777777777
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 47.01,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 47.006639444444446
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 208.8,
            "mode_time_hours": 101.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1,
              "34-36h": 1,
              "46-48h": 1,
              "76-78h": 1,
              "78-80h": 1,
              "100-102h": 1,
              "1104-1106h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-21": 1,
              "2025-12-13": 1,
              "2026-02-12": 2,
              "2026-04-13": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-10-31": 101.72595749999999,
              "2025-11-21": 78.13102416666666,
              "2025-12-13": 76.52538222222222,
              "2026-02-12": 65.91381222222222,
              "2026-04-13": 1104.407138888889,
              "2026-06-03": 34.88915
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-21": 1,
              "2025-12-13": 1,
              "2026-02-12": 2,
              "2026-04-13": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 329.39,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "34-36h": 1,
                "76-78h": 1,
                "100-102h": 1,
                "1104-1106h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2025-12-13": 1,
                "2026-04-13": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-10-31": 101.72595749999999,
                "2025-12-13": 76.52538222222222,
                "2026-04-13": 1104.407138888889,
                "2026-06-03": 34.88915
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2025-12-13": 1,
                "2026-04-13": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 48.52,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "78-80h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-21": 78.13102416666666,
                "2026-02-12": 18.907172777777777
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 47.01,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 47.006639444444446
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_340": {
      "overall": {
        "avg_time_hours": 20.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "26-28h": 1,
          "52-54h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-28": 1,
          "2025-11-07": 1,
          "2026-02-23": 1,
          "2026-03-25": 1
        },
        "time_per_day": {
          "2025-10-28": 27.8789975,
          "2025-11-07": 0.6331616666666667,
          "2026-02-23": 53.37595944444445,
          "2026-03-25": 1.2729158333333335
        },
        "time_count_per_day": {
          "2025-10-28": 1,
          "2025-11-07": 1,
          "2026-02-23": 1,
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.51,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "26-28h": 1,
            "52-54h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2026-02-23": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-10-28": 27.8789975,
            "2026-02-23": 53.37595944444445,
            "2026-03-25": 1.2729158333333335
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2026-02-23": 1,
            "2026-03-25": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-07": 1
          },
          "time_per_day": {
            "2025-11-07": 0.6331616666666667
          },
          "time_count_per_day": {
            "2025-11-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "26-28h": 1,
              "52-54h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-28": 1,
              "2025-11-07": 1,
              "2026-02-23": 1,
              "2026-03-25": 1
            },
            "time_per_day": {
              "2025-10-28": 27.8789975,
              "2025-11-07": 0.6331616666666667,
              "2026-02-23": 53.37595944444445,
              "2026-03-25": 1.2729158333333335
            },
            "time_count_per_day": {
              "2025-10-28": 1,
              "2025-11-07": 1,
              "2026-02-23": 1,
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.51,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "26-28h": 1,
                "52-54h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2026-02-23": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-10-28": 27.8789975,
                "2026-02-23": 53.37595944444445,
                "2026-03-25": 1.2729158333333335
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2026-02-23": 1,
                "2026-03-25": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-07": 1
              },
              "time_per_day": {
                "2025-11-07": 0.6331616666666667
              },
              "time_count_per_day": {
                "2025-11-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_342": {
      "overall": {
        "avg_time_hours": 9.17,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-27": 1
        },
        "time_per_day": {
          "2025-10-27": 9.171929722222222
        },
        "time_count_per_day": {
          "2025-10-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 9.17,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-27": 1
          },
          "time_per_day": {
            "2025-10-27": 9.171929722222222
          },
          "time_count_per_day": {
            "2025-10-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.17,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-27": 1
            },
            "time_per_day": {
              "2025-10-27": 9.171929722222222
            },
            "time_count_per_day": {
              "2025-10-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.17,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-27": 1
              },
              "time_per_day": {
                "2025-10-27": 9.171929722222222
              },
              "time_count_per_day": {
                "2025-10-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_314": {
      "overall": {
        "avg_time_hours": 413.17,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "450-452h": 1,
          "782-784h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-27": 1,
          "2025-12-09": 2,
          "2026-02-09": 1,
          "2026-03-11": 1,
          "2026-05-04": 1,
          "2026-05-12": 1
        },
        "time_per_day": {
          "2025-10-27": 6.0113280555555555,
          "2026-02-09": 782.1928941666667,
          "2026-03-11": 451.31301333333334
        },
        "time_count_per_day": {
          "2025-10-27": 1,
          "2026-02-09": 1,
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 228.66,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "450-452h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-27": 1,
            "2025-12-09": 2,
            "2026-03-11": 1,
            "2026-05-04": 1,
            "2026-05-12": 1
          },
          "time_per_day": {
            "2025-10-27": 6.0113280555555555,
            "2026-03-11": 451.31301333333334
          },
          "time_count_per_day": {
            "2025-10-27": 1,
            "2026-03-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 782.19,
          "mode_time_hours": 783.0,
          "mode_frequency": 1,
          "time_distribution": {
            "782-784h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 782.1928941666667
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 413.17,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "450-452h": 1,
              "782-784h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-27": 1,
              "2026-02-09": 1,
              "2026-03-11": 1
            },
            "time_per_day": {
              "2025-10-27": 6.0113280555555555,
              "2026-02-09": 782.1928941666667,
              "2026-03-11": 451.31301333333334
            },
            "time_count_per_day": {
              "2025-10-27": 1,
              "2026-02-09": 1,
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 228.66,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "450-452h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-27": 1,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2025-10-27": 6.0113280555555555,
                "2026-03-11": 451.31301333333334
              },
              "time_count_per_day": {
                "2025-10-27": 1,
                "2026-03-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 782.19,
              "mode_time_hours": 783.0,
              "mode_frequency": 1,
              "time_distribution": {
                "782-784h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 782.1928941666667
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2026-05-04": 1,
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2026-05-04": 1,
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_346": {
      "overall": {
        "avg_time_hours": 88.21,
        "mode_time_hours": 1.0,
        "mode_frequency": 35,
        "time_distribution": {
          "0-2h": 35,
          "2-4h": 12,
          "4-6h": 3,
          "6-8h": 8,
          "8-10h": 6,
          "22-24h": 2,
          "24-26h": 1,
          "32-34h": 2,
          "46-48h": 3,
          "48-50h": 1,
          "52-54h": 2,
          "54-56h": 7,
          "76-78h": 1,
          "94-96h": 2,
          "98-100h": 2,
          "102-104h": 1,
          "118-120h": 3,
          "124-126h": 1,
          "128-130h": 4,
          "132-134h": 1,
          "144-146h": 2,
          "148-150h": 8,
          "164-166h": 1,
          "532-534h": 1,
          "576-578h": 5,
          "1236-1238h": 2
        },
        "tickets_count": 116,
        "tickets_per_day": {
          "2025-10-28": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-11-21": 1,
          "2025-11-24": 5,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-11-28": 2,
          "2025-12-02": 1,
          "2025-12-04": 3,
          "2025-12-10": 1,
          "2025-12-11": 3,
          "2025-12-31": 1,
          "2026-01-14": 5,
          "2026-01-21": 4,
          "2026-01-26": 5,
          "2026-01-27": 14,
          "2026-01-30": 2,
          "2026-02-04": 16,
          "2026-02-05": 1,
          "2026-02-16": 2,
          "2026-02-24": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-05": 7,
          "2026-03-19": 3,
          "2026-03-23": 4,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-07": 3,
          "2026-04-08": 1,
          "2026-04-10": 2,
          "2026-04-15": 1,
          "2026-04-29": 3,
          "2026-05-06": 1,
          "2026-05-11": 1,
          "2026-05-13": 2,
          "2026-05-18": 1,
          "2026-05-20": 8,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-28": 1
        },
        "time_per_day": {
          "2025-10-28": 22.12608527777778,
          "2025-11-13": 24.376743055555554,
          "2025-11-17": 0.2946747222222222,
          "2025-11-21": 533.5787288888889,
          "2025-11-24": 464.5735613888889,
          "2025-11-25": 1.5489966666666666,
          "2025-11-27": 3.2553675,
          "2025-11-28": 3.4842022222222226,
          "2025-12-02": 9.205409722222221,
          "2025-12-04": 8.784134166666666,
          "2025-12-10": 128.0697711111111,
          "2025-12-11": 312.9342975,
          "2025-12-31": 52.349401944444445,
          "2026-01-14": 140.90141638888886,
          "2026-01-21": 523.8511975,
          "2026-01-26": 15.598016944444446,
          "2026-01-27": 492.7766525,
          "2026-01-30": 9.571694722222222,
          "2026-02-04": 1628.3279975000003,
          "2026-02-05": 4.733503333333333,
          "2026-02-16": 256.01862555555556,
          "2026-02-24": 1.2733094444444444,
          "2026-03-02": 132.71964111111112,
          "2026-03-04": 0.2729216666666667,
          "2026-03-05": 2902.537521666667,
          "2026-03-19": 0.7585288888888888,
          "2026-03-23": 3.434922222222222,
          "2026-03-25": 1.5524191666666667,
          "2026-03-31": 0.44146444444444444,
          "2026-04-07": 15.098674444444445,
          "2026-04-08": 1.2859894444444444,
          "2026-04-10": 2475.7292158333335,
          "2026-04-15": 49.872146666666666,
          "2026-04-29": 0.060326111111111115,
          "2026-05-06": 2.0933091666666663,
          "2026-05-11": 1.4044097222222223,
          "2026-05-13": 1.307315,
          "2026-05-18": 1.0705058333333333,
          "2026-05-20": 0.35300694444444447,
          "2026-05-21": 0.17705055555555554,
          "2026-05-25": 2.2171694444444445,
          "2026-05-28": 2.2176602777777776
        },
        "time_count_per_day": {
          "2025-10-28": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-11-21": 1,
          "2025-11-24": 5,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-11-28": 2,
          "2025-12-02": 1,
          "2025-12-04": 3,
          "2025-12-10": 1,
          "2025-12-11": 3,
          "2025-12-31": 1,
          "2026-01-14": 5,
          "2026-01-21": 4,
          "2026-01-26": 5,
          "2026-01-27": 14,
          "2026-01-30": 2,
          "2026-02-04": 16,
          "2026-02-05": 1,
          "2026-02-16": 2,
          "2026-02-24": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-05": 7,
          "2026-03-19": 3,
          "2026-03-23": 4,
          "2026-03-25": 1,
          "2026-03-31": 1,
          "2026-04-07": 3,
          "2026-04-08": 1,
          "2026-04-10": 2,
          "2026-04-15": 1,
          "2026-04-29": 3,
          "2026-05-06": 1,
          "2026-05-11": 1,
          "2026-05-13": 2,
          "2026-05-18": 1,
          "2026-05-20": 8,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 49.87,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-15": 1
          },
          "time_per_day": {
            "2026-04-15": 49.872146666666666
          },
          "time_count_per_day": {
            "2026-04-15": 1
          }
        },
        "P2": {
          "avg_time_hours": 63.0,
          "mode_time_hours": 1.0,
          "mode_frequency": 30,
          "time_distribution": {
            "0-2h": 30,
            "2-4h": 8,
            "4-6h": 3,
            "6-8h": 5,
            "22-24h": 1,
            "24-26h": 1,
            "132-134h": 1,
            "532-534h": 1,
            "1236-1238h": 2
          },
          "tickets_count": 52,
          "tickets_per_day": {
            "2025-10-28": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2026-01-26": 5,
            "2026-01-27": 1,
            "2026-01-30": 2,
            "2026-02-05": 1,
            "2026-02-24": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-05": 2,
            "2026-03-19": 3,
            "2026-03-23": 4,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-07": 3,
            "2026-04-08": 1,
            "2026-04-10": 2,
            "2026-04-29": 3,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-13": 2,
            "2026-05-18": 1,
            "2026-05-20": 8,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2025-10-28": 22.12608527777778,
            "2025-11-13": 24.376743055555554,
            "2025-11-17": 0.2946747222222222,
            "2025-11-21": 533.5787288888889,
            "2026-01-26": 15.598016944444446,
            "2026-01-27": 7.639435,
            "2026-01-30": 9.571694722222222,
            "2026-02-05": 4.733503333333333,
            "2026-02-24": 1.2733094444444444,
            "2026-03-02": 132.71964111111112,
            "2026-03-04": 0.2729216666666667,
            "2026-03-05": 14.540566944444445,
            "2026-03-19": 0.7585288888888888,
            "2026-03-23": 3.434922222222222,
            "2026-03-25": 1.5524191666666667,
            "2026-03-31": 0.44146444444444444,
            "2026-04-07": 15.098674444444445,
            "2026-04-08": 1.2859894444444444,
            "2026-04-10": 2475.7292158333335,
            "2026-04-29": 0.060326111111111115,
            "2026-05-06": 2.0933091666666663,
            "2026-05-11": 1.4044097222222223,
            "2026-05-13": 1.307315,
            "2026-05-18": 1.0705058333333333,
            "2026-05-20": 0.35300694444444447,
            "2026-05-21": 0.17705055555555554,
            "2026-05-25": 2.2171694444444445,
            "2026-05-28": 2.2176602777777776
          },
          "time_count_per_day": {
            "2025-10-28": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2026-01-26": 5,
            "2026-01-27": 1,
            "2026-01-30": 2,
            "2026-02-05": 1,
            "2026-02-24": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-05": 2,
            "2026-03-19": 3,
            "2026-03-23": 4,
            "2026-03-25": 1,
            "2026-03-31": 1,
            "2026-04-07": 3,
            "2026-04-08": 1,
            "2026-04-10": 2,
            "2026-04-29": 3,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-13": 2,
            "2026-05-18": 1,
            "2026-05-20": 8,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-05-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 109.63,
          "mode_time_hours": 149.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 4,
            "6-8h": 3,
            "8-10h": 6,
            "22-24h": 1,
            "32-34h": 2,
            "46-48h": 3,
            "52-54h": 2,
            "54-56h": 7,
            "76-78h": 1,
            "94-96h": 2,
            "98-100h": 2,
            "102-104h": 1,
            "118-120h": 3,
            "124-126h": 1,
            "128-130h": 4,
            "144-146h": 2,
            "148-150h": 8,
            "164-166h": 1,
            "576-578h": 5
          },
          "tickets_count": 63,
          "tickets_per_day": {
            "2025-11-24": 5,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-12-02": 1,
            "2025-12-04": 3,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-31": 1,
            "2026-01-14": 5,
            "2026-01-21": 4,
            "2026-01-27": 13,
            "2026-02-04": 16,
            "2026-02-16": 2,
            "2026-03-05": 5
          },
          "time_per_day": {
            "2025-11-24": 464.5735613888889,
            "2025-11-25": 1.5489966666666666,
            "2025-11-27": 3.2553675,
            "2025-11-28": 3.4842022222222226,
            "2025-12-02": 9.205409722222221,
            "2025-12-04": 8.784134166666666,
            "2025-12-10": 128.0697711111111,
            "2025-12-11": 312.9342975,
            "2025-12-31": 52.349401944444445,
            "2026-01-14": 140.90141638888886,
            "2026-01-21": 523.8511975,
            "2026-01-27": 485.1372175,
            "2026-02-04": 1628.3279975000003,
            "2026-02-16": 256.01862555555556,
            "2026-03-05": 2887.9969547222227
          },
          "time_count_per_day": {
            "2025-11-24": 5,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-12-02": 1,
            "2025-12-04": 3,
            "2025-12-10": 1,
            "2025-12-11": 3,
            "2025-12-31": 1,
            "2026-01-14": 5,
            "2026-01-21": 4,
            "2026-01-27": 13,
            "2026-02-04": 16,
            "2026-02-16": 2,
            "2026-03-05": 5
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 88.21,
            "mode_time_hours": 1.0,
            "mode_frequency": 35,
            "time_distribution": {
              "0-2h": 35,
              "2-4h": 12,
              "4-6h": 3,
              "6-8h": 8,
              "8-10h": 6,
              "22-24h": 2,
              "24-26h": 1,
              "32-34h": 2,
              "46-48h": 3,
              "48-50h": 1,
              "52-54h": 2,
              "54-56h": 7,
              "76-78h": 1,
              "94-96h": 2,
              "98-100h": 2,
              "102-104h": 1,
              "118-120h": 3,
              "124-126h": 1,
              "128-130h": 4,
              "132-134h": 1,
              "144-146h": 2,
              "148-150h": 8,
              "164-166h": 1,
              "532-534h": 1,
              "576-578h": 5,
              "1236-1238h": 2
            },
            "tickets_count": 116,
            "tickets_per_day": {
              "2025-10-28": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-11-21": 1,
              "2025-11-24": 5,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-11-28": 2,
              "2025-12-02": 1,
              "2025-12-04": 3,
              "2025-12-10": 1,
              "2025-12-11": 3,
              "2025-12-31": 1,
              "2026-01-14": 5,
              "2026-01-21": 4,
              "2026-01-26": 5,
              "2026-01-27": 14,
              "2026-01-30": 2,
              "2026-02-04": 16,
              "2026-02-05": 1,
              "2026-02-16": 2,
              "2026-02-24": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-05": 7,
              "2026-03-19": 3,
              "2026-03-23": 4,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-07": 3,
              "2026-04-08": 1,
              "2026-04-10": 2,
              "2026-04-15": 1,
              "2026-04-29": 3,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-13": 2,
              "2026-05-18": 1,
              "2026-05-20": 8,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-28": 1
            },
            "time_per_day": {
              "2025-10-28": 22.12608527777778,
              "2025-11-13": 24.376743055555554,
              "2025-11-17": 0.2946747222222222,
              "2025-11-21": 533.5787288888889,
              "2025-11-24": 464.5735613888889,
              "2025-11-25": 1.5489966666666666,
              "2025-11-27": 3.2553675,
              "2025-11-28": 3.4842022222222226,
              "2025-12-02": 9.205409722222221,
              "2025-12-04": 8.784134166666666,
              "2025-12-10": 128.0697711111111,
              "2025-12-11": 312.9342975,
              "2025-12-31": 52.349401944444445,
              "2026-01-14": 140.90141638888886,
              "2026-01-21": 523.8511975,
              "2026-01-26": 15.598016944444446,
              "2026-01-27": 492.7766525,
              "2026-01-30": 9.571694722222222,
              "2026-02-04": 1628.3279975000003,
              "2026-02-05": 4.733503333333333,
              "2026-02-16": 256.01862555555556,
              "2026-02-24": 1.2733094444444444,
              "2026-03-02": 132.71964111111112,
              "2026-03-04": 0.2729216666666667,
              "2026-03-05": 2902.537521666667,
              "2026-03-19": 0.7585288888888888,
              "2026-03-23": 3.434922222222222,
              "2026-03-25": 1.5524191666666667,
              "2026-03-31": 0.44146444444444444,
              "2026-04-07": 15.098674444444445,
              "2026-04-08": 1.2859894444444444,
              "2026-04-10": 2475.7292158333335,
              "2026-04-15": 49.872146666666666,
              "2026-04-29": 0.060326111111111115,
              "2026-05-06": 2.0933091666666663,
              "2026-05-11": 1.4044097222222223,
              "2026-05-13": 1.307315,
              "2026-05-18": 1.0705058333333333,
              "2026-05-20": 0.35300694444444447,
              "2026-05-21": 0.17705055555555554,
              "2026-05-25": 2.2171694444444445,
              "2026-05-28": 2.2176602777777776
            },
            "time_count_per_day": {
              "2025-10-28": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-11-21": 1,
              "2025-11-24": 5,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-11-28": 2,
              "2025-12-02": 1,
              "2025-12-04": 3,
              "2025-12-10": 1,
              "2025-12-11": 3,
              "2025-12-31": 1,
              "2026-01-14": 5,
              "2026-01-21": 4,
              "2026-01-26": 5,
              "2026-01-27": 14,
              "2026-01-30": 2,
              "2026-02-04": 16,
              "2026-02-05": 1,
              "2026-02-16": 2,
              "2026-02-24": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-05": 7,
              "2026-03-19": 3,
              "2026-03-23": 4,
              "2026-03-25": 1,
              "2026-03-31": 1,
              "2026-04-07": 3,
              "2026-04-08": 1,
              "2026-04-10": 2,
              "2026-04-15": 1,
              "2026-04-29": 3,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-13": 2,
              "2026-05-18": 1,
              "2026-05-20": 8,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 49.87,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-15": 1
              },
              "time_per_day": {
                "2026-04-15": 49.872146666666666
              },
              "time_count_per_day": {
                "2026-04-15": 1
              }
            },
            "P2": {
              "avg_time_hours": 63.0,
              "mode_time_hours": 1.0,
              "mode_frequency": 30,
              "time_distribution": {
                "0-2h": 30,
                "2-4h": 8,
                "4-6h": 3,
                "6-8h": 5,
                "22-24h": 1,
                "24-26h": 1,
                "132-134h": 1,
                "532-534h": 1,
                "1236-1238h": 2
              },
              "tickets_count": 52,
              "tickets_per_day": {
                "2025-10-28": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2026-01-26": 5,
                "2026-01-27": 1,
                "2026-01-30": 2,
                "2026-02-05": 1,
                "2026-02-24": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-05": 2,
                "2026-03-19": 3,
                "2026-03-23": 4,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-07": 3,
                "2026-04-08": 1,
                "2026-04-10": 2,
                "2026-04-29": 3,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-13": 2,
                "2026-05-18": 1,
                "2026-05-20": 8,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2025-10-28": 22.12608527777778,
                "2025-11-13": 24.376743055555554,
                "2025-11-17": 0.2946747222222222,
                "2025-11-21": 533.5787288888889,
                "2026-01-26": 15.598016944444446,
                "2026-01-27": 7.639435,
                "2026-01-30": 9.571694722222222,
                "2026-02-05": 4.733503333333333,
                "2026-02-24": 1.2733094444444444,
                "2026-03-02": 132.71964111111112,
                "2026-03-04": 0.2729216666666667,
                "2026-03-05": 14.540566944444445,
                "2026-03-19": 0.7585288888888888,
                "2026-03-23": 3.434922222222222,
                "2026-03-25": 1.5524191666666667,
                "2026-03-31": 0.44146444444444444,
                "2026-04-07": 15.098674444444445,
                "2026-04-08": 1.2859894444444444,
                "2026-04-10": 2475.7292158333335,
                "2026-04-29": 0.060326111111111115,
                "2026-05-06": 2.0933091666666663,
                "2026-05-11": 1.4044097222222223,
                "2026-05-13": 1.307315,
                "2026-05-18": 1.0705058333333333,
                "2026-05-20": 0.35300694444444447,
                "2026-05-21": 0.17705055555555554,
                "2026-05-25": 2.2171694444444445,
                "2026-05-28": 2.2176602777777776
              },
              "time_count_per_day": {
                "2025-10-28": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2026-01-26": 5,
                "2026-01-27": 1,
                "2026-01-30": 2,
                "2026-02-05": 1,
                "2026-02-24": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-05": 2,
                "2026-03-19": 3,
                "2026-03-23": 4,
                "2026-03-25": 1,
                "2026-03-31": 1,
                "2026-04-07": 3,
                "2026-04-08": 1,
                "2026-04-10": 2,
                "2026-04-29": 3,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-13": 2,
                "2026-05-18": 1,
                "2026-05-20": 8,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-05-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 109.63,
              "mode_time_hours": 149.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 4,
                "6-8h": 3,
                "8-10h": 6,
                "22-24h": 1,
                "32-34h": 2,
                "46-48h": 3,
                "52-54h": 2,
                "54-56h": 7,
                "76-78h": 1,
                "94-96h": 2,
                "98-100h": 2,
                "102-104h": 1,
                "118-120h": 3,
                "124-126h": 1,
                "128-130h": 4,
                "144-146h": 2,
                "148-150h": 8,
                "164-166h": 1,
                "576-578h": 5
              },
              "tickets_count": 63,
              "tickets_per_day": {
                "2025-11-24": 5,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-12-02": 1,
                "2025-12-04": 3,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-31": 1,
                "2026-01-14": 5,
                "2026-01-21": 4,
                "2026-01-27": 13,
                "2026-02-04": 16,
                "2026-02-16": 2,
                "2026-03-05": 5
              },
              "time_per_day": {
                "2025-11-24": 464.5735613888889,
                "2025-11-25": 1.5489966666666666,
                "2025-11-27": 3.2553675,
                "2025-11-28": 3.4842022222222226,
                "2025-12-02": 9.205409722222221,
                "2025-12-04": 8.784134166666666,
                "2025-12-10": 128.0697711111111,
                "2025-12-11": 312.9342975,
                "2025-12-31": 52.349401944444445,
                "2026-01-14": 140.90141638888886,
                "2026-01-21": 523.8511975,
                "2026-01-27": 485.1372175,
                "2026-02-04": 1628.3279975000003,
                "2026-02-16": 256.01862555555556,
                "2026-03-05": 2887.9969547222227
              },
              "time_count_per_day": {
                "2025-11-24": 5,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-11-28": 2,
                "2025-12-02": 1,
                "2025-12-04": 3,
                "2025-12-10": 1,
                "2025-12-11": 3,
                "2025-12-31": 1,
                "2026-01-14": 5,
                "2026-01-21": 4,
                "2026-01-27": 13,
                "2026-02-04": 16,
                "2026-02-16": 2,
                "2026-03-05": 5
              }
            }
          }
        }
      }
    },
    "cliente_284": {
      "overall": {
        "avg_time_hours": 166.26,
        "mode_time_hours": 167.0,
        "mode_frequency": 1,
        "time_distribution": {
          "166-168h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-19": 1,
          "2025-11-04": 1
        },
        "time_per_day": {
          "2025-11-04": 166.25817666666666
        },
        "time_count_per_day": {
          "2025-11-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 166.26,
          "mode_time_hours": 167.0,
          "mode_frequency": 1,
          "time_distribution": {
            "166-168h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-19": 1,
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-11-04": 166.25817666666666
          },
          "time_count_per_day": {
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 166.26,
            "mode_time_hours": 167.0,
            "mode_frequency": 1,
            "time_distribution": {
              "166-168h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-04": 1
            },
            "time_per_day": {
              "2025-11-04": 166.25817666666666
            },
            "time_count_per_day": {
              "2025-11-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 166.26,
              "mode_time_hours": 167.0,
              "mode_frequency": 1,
              "time_distribution": {
                "166-168h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-11-04": 166.25817666666666
              },
              "time_count_per_day": {
                "2025-11-04": 1
              }
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_350": {
      "overall": {
        "avg_time_hours": 80.69,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "46-48h": 1,
          "114-116h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-12-10": 1
        },
        "time_per_day": {
          "2025-10-30": 46.66518722222222,
          "2025-12-10": 114.71636694444443
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-12-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 46.67,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-30": 1
          },
          "time_per_day": {
            "2025-10-30": 46.66518722222222
          },
          "time_count_per_day": {
            "2025-10-30": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 114.72,
          "mode_time_hours": 115.0,
          "mode_frequency": 1,
          "time_distribution": {
            "114-116h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-12-10": 114.71636694444443
          },
          "time_count_per_day": {
            "2025-12-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 80.69,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "46-48h": 1,
              "114-116h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-12-10": 1
            },
            "time_per_day": {
              "2025-10-30": 46.66518722222222,
              "2025-12-10": 114.71636694444443
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-12-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 46.67,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-30": 1
              },
              "time_per_day": {
                "2025-10-30": 46.66518722222222
              },
              "time_count_per_day": {
                "2025-10-30": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 114.72,
              "mode_time_hours": 115.0,
              "mode_frequency": 1,
              "time_distribution": {
                "114-116h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-12-10": 114.71636694444443
              },
              "time_count_per_day": {
                "2025-12-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_351": {
      "overall": {
        "avg_time_hours": 0.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-28": 2
        },
        "time_per_day": {
          "2025-10-28": 0.44346416666666666
        },
        "time_count_per_day": {
          "2025-10-28": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-28": 2
          },
          "time_per_day": {
            "2025-10-28": 0.44346416666666666
          },
          "time_count_per_day": {
            "2025-10-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-28": 2
            },
            "time_per_day": {
              "2025-10-28": 0.44346416666666666
            },
            "time_count_per_day": {
              "2025-10-28": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-28": 2
              },
              "time_per_day": {
                "2025-10-28": 0.44346416666666666
              },
              "time_count_per_day": {
                "2025-10-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_354": {
      "overall": {
        "avg_time_hours": 141.8,
        "mode_time_hours": 19.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "18-20h": 2,
          "62-64h": 1,
          "166-168h": 1,
          "718-720h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-11-26": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-05-12": 2
        },
        "time_per_day": {
          "2025-10-31": 63.70837638888889,
          "2025-11-10": 2.876561388888889,
          "2025-11-26": 167.61137527777777,
          "2026-03-10": 1.0024525,
          "2026-03-12": 719.7194811111111,
          "2026-05-12": 37.69793222222222
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-11-26": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-05-12": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 32.36,
          "mode_time_hours": 63.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "62-64h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2026-03-10": 1
          },
          "time_per_day": {
            "2025-10-31": 63.70837638888889,
            "2026-03-10": 1.0024525
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2026-03-10": 1
          }
        },
        "P2": {
          "avg_time_hours": 185.58,
          "mode_time_hours": 19.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "18-20h": 2,
            "166-168h": 1,
            "718-720h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-10": 1,
            "2025-11-26": 1,
            "2026-03-12": 1,
            "2026-05-12": 2
          },
          "time_per_day": {
            "2025-11-10": 2.876561388888889,
            "2025-11-26": 167.61137527777777,
            "2026-03-12": 719.7194811111111,
            "2026-05-12": 37.69793222222222
          },
          "time_count_per_day": {
            "2025-11-10": 1,
            "2025-11-26": 1,
            "2026-03-12": 1,
            "2026-05-12": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.8,
            "mode_time_hours": 19.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "18-20h": 2,
              "62-64h": 1,
              "166-168h": 1,
              "718-720h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-11-26": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-05-12": 2
            },
            "time_per_day": {
              "2025-10-31": 63.70837638888889,
              "2025-11-10": 2.876561388888889,
              "2025-11-26": 167.61137527777777,
              "2026-03-10": 1.0024525,
              "2026-03-12": 719.7194811111111,
              "2026-05-12": 37.69793222222222
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-11-26": 1,
              "2026-03-10": 1,
              "2026-03-12": 1,
              "2026-05-12": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 32.36,
              "mode_time_hours": 63.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "62-64h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2026-03-10": 1
              },
              "time_per_day": {
                "2025-10-31": 63.70837638888889,
                "2026-03-10": 1.0024525
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2026-03-10": 1
              }
            },
            "P2": {
              "avg_time_hours": 185.58,
              "mode_time_hours": 19.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "18-20h": 2,
                "166-168h": 1,
                "718-720h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-10": 1,
                "2025-11-26": 1,
                "2026-03-12": 1,
                "2026-05-12": 2
              },
              "time_per_day": {
                "2025-11-10": 2.876561388888889,
                "2025-11-26": 167.61137527777777,
                "2026-03-12": 719.7194811111111,
                "2026-05-12": 37.69793222222222
              },
              "time_count_per_day": {
                "2025-11-10": 1,
                "2025-11-26": 1,
                "2026-03-12": 1,
                "2026-05-12": 2
              }
            }
          }
        }
      }
    },
    "cliente_309": {
      "overall": {
        "avg_time_hours": 237.04,
        "mode_time_hours": 65.0,
        "mode_frequency": 1,
        "time_distribution": {
          "64-66h": 1,
          "236-238h": 1,
          "408-410h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2026-01-19": 1,
          "2026-03-05": 1,
          "2026-04-22": 1,
          "2026-05-14": 1
        },
        "time_per_day": {
          "2025-10-31": 64.55208888888889,
          "2026-03-05": 236.86315916666666,
          "2026-05-14": 409.7053022222222
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2026-03-05": 1,
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 237.04,
          "mode_time_hours": 65.0,
          "mode_frequency": 1,
          "time_distribution": {
            "64-66h": 1,
            "236-238h": 1,
            "408-410h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2026-01-19": 1,
            "2026-03-05": 1,
            "2026-04-22": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-10-31": 64.55208888888889,
            "2026-03-05": 236.86315916666666,
            "2026-05-14": 409.7053022222222
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2026-03-05": 1,
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 237.04,
            "mode_time_hours": 65.0,
            "mode_frequency": 1,
            "time_distribution": {
              "64-66h": 1,
              "236-238h": 1,
              "408-410h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2026-03-05": 1,
              "2026-05-14": 1
            },
            "time_per_day": {
              "2025-10-31": 64.55208888888889,
              "2026-03-05": 236.86315916666666,
              "2026-05-14": 409.7053022222222
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2026-03-05": 1,
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 237.04,
              "mode_time_hours": 65.0,
              "mode_frequency": 1,
              "time_distribution": {
                "64-66h": 1,
                "236-238h": 1,
                "408-410h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2026-03-05": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-10-31": 64.55208888888889,
                "2026-03-05": 236.86315916666666,
                "2026-05-14": 409.7053022222222
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2026-03-05": 1,
                "2026-05-14": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_358": {
      "overall": {
        "avg_time_hours": 16.5,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "12-14h": 1,
          "16-18h": 1,
          "36-38h": 1,
          "44-46h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-12-15": 1,
          "2026-01-14": 1,
          "2026-01-30": 2,
          "2026-02-11": 1,
          "2026-03-19": 1
        },
        "time_per_day": {
          "2025-10-29": 12.503661388888888,
          "2025-12-15": 0.04547333333333334,
          "2026-01-14": 44.99784805555556,
          "2026-01-30": 52.9236875,
          "2026-02-11": 1.1511650000000002,
          "2026-03-19": 3.895569722222222
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-12-15": 1,
          "2026-01-14": 1,
          "2026-01-30": 2,
          "2026-02-11": 1,
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.75,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "36-38h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-12-15": 1,
            "2026-01-30": 2,
            "2026-02-11": 1,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2025-10-29": 12.503661388888888,
            "2025-12-15": 0.04547333333333334,
            "2026-01-30": 52.9236875,
            "2026-02-11": 1.1511650000000002,
            "2026-03-19": 3.895569722222222
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-12-15": 1,
            "2026-01-30": 2,
            "2026-02-11": 1,
            "2026-03-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 45.0,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 44.99784805555556
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.5,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "12-14h": 1,
              "16-18h": 1,
              "36-38h": 1,
              "44-46h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-12-15": 1,
              "2026-01-14": 1,
              "2026-01-30": 2,
              "2026-02-11": 1,
              "2026-03-19": 1
            },
            "time_per_day": {
              "2025-10-29": 12.503661388888888,
              "2025-12-15": 0.04547333333333334,
              "2026-01-14": 44.99784805555556,
              "2026-01-30": 52.9236875,
              "2026-02-11": 1.1511650000000002,
              "2026-03-19": 3.895569722222222
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-12-15": 1,
              "2026-01-14": 1,
              "2026-01-30": 2,
              "2026-02-11": 1,
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.75,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "36-38h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-12-15": 1,
                "2026-01-30": 2,
                "2026-02-11": 1,
                "2026-03-19": 1
              },
              "time_per_day": {
                "2025-10-29": 12.503661388888888,
                "2025-12-15": 0.04547333333333334,
                "2026-01-30": 52.9236875,
                "2026-02-11": 1.1511650000000002,
                "2026-03-19": 3.895569722222222
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-12-15": 1,
                "2026-01-30": 2,
                "2026-02-11": 1,
                "2026-03-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 45.0,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 44.99784805555556
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_357": {
      "overall": {
        "avg_time_hours": 54.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 19,
        "time_distribution": {
          "0-2h": 19,
          "2-4h": 6,
          "4-6h": 2,
          "8-10h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "16-18h": 1,
          "30-32h": 1,
          "34-36h": 1,
          "46-48h": 2,
          "50-52h": 1,
          "72-74h": 1,
          "76-78h": 1,
          "78-80h": 1,
          "90-92h": 1,
          "102-104h": 1,
          "110-112h": 1,
          "116-118h": 1,
          "216-218h": 1,
          "278-280h": 1,
          "282-284h": 1,
          "400-402h": 1,
          "480-482h": 1
        },
        "tickets_count": 50,
        "tickets_per_day": {
          "2025-10-29": 3,
          "2025-11-21": 2,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-13": 2,
          "2026-02-19": 3,
          "2026-03-18": 3,
          "2026-03-21": 1,
          "2026-03-25": 2,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-04-17": 2,
          "2026-04-22": 2,
          "2026-04-24": 1,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 3,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-25": 1,
          "2026-05-30": 1,
          "2026-06-05": 5
        },
        "time_per_day": {
          "2025-10-29": 27.164413333333336,
          "2025-11-21": 126.54311916666668,
          "2025-12-18": 51.5127975,
          "2026-01-13": 78.95868416666666,
          "2026-01-21": 103.64431499999999,
          "2026-01-27": 76.23573194444445,
          "2026-02-03": 2.1019758333333334,
          "2026-02-06": 30.870078333333336,
          "2026-02-13": 94.63782777777777,
          "2026-02-19": 590.8387594444445,
          "2026-03-18": 778.8495308333333,
          "2026-03-21": 0.18511083333333334,
          "2026-03-25": 2.0901538888888886,
          "2026-04-14": 0.011718055555555556,
          "2026-04-15": 1.5177411111111112,
          "2026-04-17": 1.8665047222222224,
          "2026-04-22": 121.19504916666666,
          "2026-04-24": 2.565347222222222,
          "2026-04-29": 0.6490647222222222,
          "2026-05-02": 1.419651111111111,
          "2026-05-05": 481.25408305555555,
          "2026-05-06": 3.0478591666666666,
          "2026-05-11": 13.328854722222223,
          "2026-05-12": 0.4308158333333333,
          "2026-05-13": 7.539924166666667,
          "2026-05-14": 0.12437305555555556,
          "2026-05-15": 0.4266341666666667,
          "2026-05-18": 0.15903694444444444,
          "2026-05-30": 0.24509972222222223,
          "2026-06-05": 13.575454722222222
        },
        "time_count_per_day": {
          "2025-10-29": 3,
          "2025-11-21": 2,
          "2025-12-18": 1,
          "2026-01-13": 1,
          "2026-01-21": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-13": 2,
          "2026-02-19": 3,
          "2026-03-18": 3,
          "2026-03-21": 1,
          "2026-03-25": 2,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-04-17": 2,
          "2026-04-22": 2,
          "2026-04-24": 1,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 3,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-30": 1,
          "2026-06-05": 4
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 18.68,
          "mode_time_hours": 1.0,
          "mode_frequency": 18,
          "time_distribution": {
            "0-2h": 18,
            "2-4h": 6,
            "4-6h": 2,
            "10-12h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "480-482h": 1
          },
          "tickets_count": 30,
          "tickets_per_day": {
            "2025-10-29": 2,
            "2026-02-03": 1,
            "2026-03-21": 1,
            "2026-03-25": 1,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-04-17": 2,
            "2026-04-22": 1,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 3,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 2,
            "2026-05-30": 1,
            "2026-06-05": 4
          },
          "time_per_day": {
            "2025-10-29": 18.345982222222226,
            "2026-02-03": 2.1019758333333334,
            "2026-03-21": 0.18511083333333334,
            "2026-03-25": 0.9092055555555555,
            "2026-04-14": 0.011718055555555556,
            "2026-04-15": 1.5177411111111112,
            "2026-04-17": 1.8665047222222224,
            "2026-04-22": 10.596879999999999,
            "2026-04-24": 2.565347222222222,
            "2026-04-29": 0.6490647222222222,
            "2026-05-02": 1.419651111111111,
            "2026-05-05": 481.25408305555555,
            "2026-05-06": 3.0478591666666666,
            "2026-05-11": 13.328854722222223,
            "2026-05-12": 0.4308158333333333,
            "2026-05-13": 7.539924166666667,
            "2026-05-14": 0.12437305555555556,
            "2026-05-15": 0.4266341666666667,
            "2026-05-18": 0.15903694444444444,
            "2026-05-30": 0.24509972222222223,
            "2026-06-05": 13.575454722222222
          },
          "time_count_per_day": {
            "2025-10-29": 2,
            "2026-02-03": 1,
            "2026-03-21": 1,
            "2026-03-25": 1,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-04-17": 2,
            "2026-04-22": 1,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 3,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 2,
            "2026-05-30": 1,
            "2026-06-05": 4
          }
        },
        "P3": {
          "avg_time_hours": 47.32,
          "mode_time_hours": 47.0,
          "mode_frequency": 2,
          "time_distribution": {
            "46-48h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-13": 2
          },
          "time_per_day": {
            "2026-02-13": 94.63782777777777
          },
          "time_count_per_day": {
            "2026-02-13": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 105.17,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1,
            "30-32h": 1,
            "34-36h": 1,
            "50-52h": 1,
            "76-78h": 1,
            "78-80h": 1,
            "90-92h": 1,
            "102-104h": 1,
            "110-112h": 1,
            "216-218h": 1,
            "278-280h": 1,
            "282-284h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-21": 2,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-21": 1,
            "2026-01-27": 1,
            "2026-02-06": 1,
            "2026-03-18": 3,
            "2026-03-25": 1,
            "2026-04-22": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-29": 8.81843111111111,
            "2025-11-21": 126.54311916666668,
            "2025-12-18": 51.5127975,
            "2026-01-13": 78.95868416666666,
            "2026-01-21": 103.64431499999999,
            "2026-01-27": 76.23573194444445,
            "2026-02-06": 30.870078333333336,
            "2026-03-18": 778.8495308333333,
            "2026-03-25": 1.1809483333333333,
            "2026-04-22": 110.59816916666666
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2025-11-21": 2,
            "2025-12-18": 1,
            "2026-01-13": 1,
            "2026-01-21": 1,
            "2026-01-27": 1,
            "2026-02-06": 1,
            "2026-03-18": 3,
            "2026-03-25": 1,
            "2026-04-22": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 196.95,
          "mode_time_hours": 401.0,
          "mode_frequency": 1,
          "time_distribution": {
            "72-74h": 1,
            "116-118h": 1,
            "400-402h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 590.8387594444445
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 54.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 19,
            "time_distribution": {
              "0-2h": 19,
              "2-4h": 6,
              "4-6h": 2,
              "8-10h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "16-18h": 1,
              "30-32h": 1,
              "34-36h": 1,
              "46-48h": 2,
              "50-52h": 1,
              "72-74h": 1,
              "76-78h": 1,
              "78-80h": 1,
              "90-92h": 1,
              "102-104h": 1,
              "110-112h": 1,
              "116-118h": 1,
              "216-218h": 1,
              "278-280h": 1,
              "282-284h": 1,
              "400-402h": 1,
              "480-482h": 1
            },
            "tickets_count": 48,
            "tickets_per_day": {
              "2025-10-29": 3,
              "2025-11-21": 2,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-13": 2,
              "2026-02-19": 3,
              "2026-03-18": 3,
              "2026-03-21": 1,
              "2026-03-25": 2,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-04-17": 2,
              "2026-04-22": 2,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 3,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-30": 1,
              "2026-06-05": 4
            },
            "time_per_day": {
              "2025-10-29": 27.164413333333336,
              "2025-11-21": 126.54311916666668,
              "2025-12-18": 51.5127975,
              "2026-01-13": 78.95868416666666,
              "2026-01-21": 103.64431499999999,
              "2026-01-27": 76.23573194444445,
              "2026-02-03": 2.1019758333333334,
              "2026-02-06": 30.870078333333336,
              "2026-02-13": 94.63782777777777,
              "2026-02-19": 590.8387594444445,
              "2026-03-18": 778.8495308333333,
              "2026-03-21": 0.18511083333333334,
              "2026-03-25": 2.0901538888888886,
              "2026-04-14": 0.011718055555555556,
              "2026-04-15": 1.5177411111111112,
              "2026-04-17": 1.8665047222222224,
              "2026-04-22": 121.19504916666666,
              "2026-04-24": 2.565347222222222,
              "2026-04-29": 0.6490647222222222,
              "2026-05-02": 1.419651111111111,
              "2026-05-05": 481.25408305555555,
              "2026-05-06": 3.0478591666666666,
              "2026-05-11": 13.328854722222223,
              "2026-05-12": 0.4308158333333333,
              "2026-05-13": 7.539924166666667,
              "2026-05-14": 0.12437305555555556,
              "2026-05-15": 0.4266341666666667,
              "2026-05-18": 0.15903694444444444,
              "2026-05-30": 0.24509972222222223,
              "2026-06-05": 13.575454722222222
            },
            "time_count_per_day": {
              "2025-10-29": 3,
              "2025-11-21": 2,
              "2025-12-18": 1,
              "2026-01-13": 1,
              "2026-01-21": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-13": 2,
              "2026-02-19": 3,
              "2026-03-18": 3,
              "2026-03-21": 1,
              "2026-03-25": 2,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-04-17": 2,
              "2026-04-22": 2,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-11": 2,
              "2026-05-12": 1,
              "2026-05-13": 3,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-30": 1,
              "2026-06-05": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 18.68,
              "mode_time_hours": 1.0,
              "mode_frequency": 18,
              "time_distribution": {
                "0-2h": 18,
                "2-4h": 6,
                "4-6h": 2,
                "10-12h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "480-482h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2025-10-29": 2,
                "2026-02-03": 1,
                "2026-03-21": 1,
                "2026-03-25": 1,
                "2026-04-14": 1,
                "2026-04-15": 1,
                "2026-04-17": 2,
                "2026-04-22": 1,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-13": 3,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-30": 1,
                "2026-06-05": 4
              },
              "time_per_day": {
                "2025-10-29": 18.345982222222226,
                "2026-02-03": 2.1019758333333334,
                "2026-03-21": 0.18511083333333334,
                "2026-03-25": 0.9092055555555555,
                "2026-04-14": 0.011718055555555556,
                "2026-04-15": 1.5177411111111112,
                "2026-04-17": 1.8665047222222224,
                "2026-04-22": 10.596879999999999,
                "2026-04-24": 2.565347222222222,
                "2026-04-29": 0.6490647222222222,
                "2026-05-02": 1.419651111111111,
                "2026-05-05": 481.25408305555555,
                "2026-05-06": 3.0478591666666666,
                "2026-05-11": 13.328854722222223,
                "2026-05-12": 0.4308158333333333,
                "2026-05-13": 7.539924166666667,
                "2026-05-14": 0.12437305555555556,
                "2026-05-15": 0.4266341666666667,
                "2026-05-18": 0.15903694444444444,
                "2026-05-30": 0.24509972222222223,
                "2026-06-05": 13.575454722222222
              },
              "time_count_per_day": {
                "2025-10-29": 2,
                "2026-02-03": 1,
                "2026-03-21": 1,
                "2026-03-25": 1,
                "2026-04-14": 1,
                "2026-04-15": 1,
                "2026-04-17": 2,
                "2026-04-22": 1,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-11": 2,
                "2026-05-12": 1,
                "2026-05-13": 3,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-30": 1,
                "2026-06-05": 4
              }
            },
            "P3": {
              "avg_time_hours": 47.32,
              "mode_time_hours": 47.0,
              "mode_frequency": 2,
              "time_distribution": {
                "46-48h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-13": 2
              },
              "time_per_day": {
                "2026-02-13": 94.63782777777777
              },
              "time_count_per_day": {
                "2026-02-13": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 105.17,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1,
                "30-32h": 1,
                "34-36h": 1,
                "50-52h": 1,
                "76-78h": 1,
                "78-80h": 1,
                "90-92h": 1,
                "102-104h": 1,
                "110-112h": 1,
                "216-218h": 1,
                "278-280h": 1,
                "282-284h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2025-11-21": 2,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-21": 1,
                "2026-01-27": 1,
                "2026-02-06": 1,
                "2026-03-18": 3,
                "2026-03-25": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2025-10-29": 8.81843111111111,
                "2025-11-21": 126.54311916666668,
                "2025-12-18": 51.5127975,
                "2026-01-13": 78.95868416666666,
                "2026-01-21": 103.64431499999999,
                "2026-01-27": 76.23573194444445,
                "2026-02-06": 30.870078333333336,
                "2026-03-18": 778.8495308333333,
                "2026-03-25": 1.1809483333333333,
                "2026-04-22": 110.59816916666666
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2025-11-21": 2,
                "2025-12-18": 1,
                "2026-01-13": 1,
                "2026-01-21": 1,
                "2026-01-27": 1,
                "2026-02-06": 1,
                "2026-03-18": 3,
                "2026-03-25": 1,
                "2026-04-22": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 196.95,
              "mode_time_hours": 401.0,
              "mode_frequency": 1,
              "time_distribution": {
                "72-74h": 1,
                "116-118h": 1,
                "400-402h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 590.8387594444445
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_359": {
      "overall": {
        "avg_time_hours": 92.52,
        "mode_time_hours": 7.0,
        "mode_frequency": 12,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "4-6h": 2,
          "6-8h": 12,
          "8-10h": 10,
          "24-26h": 3,
          "28-30h": 1,
          "30-32h": 4,
          "32-34h": 2,
          "48-50h": 1,
          "50-52h": 1,
          "52-54h": 3,
          "54-56h": 2,
          "56-58h": 1,
          "68-70h": 1,
          "76-78h": 2,
          "78-80h": 2,
          "80-82h": 4,
          "86-88h": 1,
          "102-104h": 1,
          "104-106h": 1,
          "126-128h": 1,
          "128-130h": 1,
          "144-146h": 2,
          "148-150h": 1,
          "176-178h": 1,
          "240-242h": 1,
          "246-248h": 1,
          "250-252h": 1,
          "270-272h": 1,
          "272-274h": 3,
          "292-294h": 2,
          "316-318h": 1,
          "342-344h": 2,
          "360-362h": 1,
          "366-368h": 1,
          "390-392h": 1
        },
        "tickets_count": 82,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-03": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 2,
          "2025-11-12": 1,
          "2025-11-14": 1,
          "2025-11-18": 2,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-22": 1,
          "2025-12-30": 1,
          "2026-01-02": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-07": 2,
          "2026-01-12": 3,
          "2026-01-15": 1,
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-27": 3,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-03-02": 2,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-09": 4,
          "2026-03-18": 2,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-03-30": 1,
          "2026-04-06": 2,
          "2026-04-09": 1,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-24": 2,
          "2026-04-28": 4,
          "2026-04-30": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-29": 1.4751697222222222,
          "2025-11-03": 79.51538194444444,
          "2025-11-05": 56.554673333333334,
          "2025-11-06": 30.751783333333332,
          "2025-11-10": 51.74797388888889,
          "2025-11-11": 83.06663222222222,
          "2025-11-12": 103.68759527777777,
          "2025-11-14": 8.361316944444445,
          "2025-11-18": 111.81828916666666,
          "2025-12-09": 30.95864861111111,
          "2025-12-15": 144.90149694444446,
          "2025-12-22": 250.23571166666667,
          "2025-12-30": 8.50051,
          "2026-01-02": 8.952658611111111,
          "2026-01-05": 343.63481,
          "2026-01-06": 310.8446544444445,
          "2026-01-07": 56.613777222222225,
          "2026-01-12": 189.99320999999998,
          "2026-01-15": 9.561601944444444,
          "2026-01-20": 29.749410277777777,
          "2026-01-22": 8.15092638888889,
          "2026-01-27": 821.6972619444446,
          "2026-02-03": 77.48034333333332,
          "2026-02-04": 5.565739444444445,
          "2026-02-06": 176.57496,
          "2026-02-10": 17.113879722222222,
          "2026-02-13": 8.250479444444444,
          "2026-02-16": 80.21988083333333,
          "2026-02-18": 128.75899722222223,
          "2026-03-02": 231.32658083333334,
          "2026-03-04": 3.3256366666666666,
          "2026-03-05": 390.82849444444446,
          "2026-03-09": 99.3589963888889,
          "2026-03-18": 64.15124416666667,
          "2026-03-19": 247.87816722222223,
          "2026-03-20": 360.59059083333335,
          "2026-03-26": 293.9926155555556,
          "2026-03-30": 1.1338752777777779,
          "2026-04-06": 107.4664913888889,
          "2026-04-14": 8.329652777777778,
          "2026-04-15": 7.099640833333333,
          "2026-04-16": 372.0667569444445,
          "2026-04-17": 6.236461944444444,
          "2026-04-20": 292.17866944444444,
          "2026-04-24": 160.59537444444445,
          "2026-04-28": 651.4135886111111,
          "2026-04-30": 24.841344444444445,
          "2026-05-04": 133.73014666666668,
          "2026-05-05": 6.95549,
          "2026-05-08": 24.15327888888889,
          "2026-05-12": 5.037128333333333,
          "2026-05-18": 316.24260305555555,
          "2026-05-19": 24.463036388888888,
          "2026-05-20": 6.397621388888889,
          "2026-05-21": 1.6938513888888889,
          "2026-06-01": 148.79019666666667,
          "2026-06-02": 30.86459972222222,
          "2026-06-05": 53.51367138888889
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2025-11-03": 1,
          "2025-11-05": 1,
          "2025-11-06": 1,
          "2025-11-10": 1,
          "2025-11-11": 2,
          "2025-11-12": 1,
          "2025-11-14": 1,
          "2025-11-18": 2,
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-22": 1,
          "2025-12-30": 1,
          "2026-01-02": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-07": 2,
          "2026-01-12": 3,
          "2026-01-15": 1,
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-27": 3,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-10": 2,
          "2026-02-13": 1,
          "2026-02-16": 1,
          "2026-02-18": 1,
          "2026-03-02": 2,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-09": 4,
          "2026-03-18": 2,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-03-30": 1,
          "2026-04-06": 2,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-20": 1,
          "2026-04-24": 2,
          "2026-04-28": 4,
          "2026-04-30": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 22.64,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 2,
            "8-10h": 1,
            "24-26h": 2,
            "86-88h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2026-01-07": 1,
            "2026-03-02": 1,
            "2026-04-15": 1,
            "2026-04-17": 1,
            "2026-04-30": 1,
            "2026-05-19": 1
          },
          "time_per_day": {
            "2025-10-29": 1.4751697222222222,
            "2026-01-07": 8.134878055555555,
            "2026-03-02": 86.22795472222222,
            "2026-04-15": 7.099640833333333,
            "2026-04-17": 6.236461944444444,
            "2026-04-30": 24.841344444444445,
            "2026-05-19": 24.463036388888888
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2026-01-07": 1,
            "2026-03-02": 1,
            "2026-04-15": 1,
            "2026-04-17": 1,
            "2026-04-30": 1,
            "2026-05-19": 1
          }
        },
        "P2": {
          "avg_time_hours": 97.92,
          "mode_time_hours": 7.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 9,
            "8-10h": 5,
            "24-26h": 1,
            "28-30h": 1,
            "30-32h": 4,
            "48-50h": 1,
            "50-52h": 1,
            "52-54h": 3,
            "54-56h": 2,
            "56-58h": 1,
            "68-70h": 1,
            "76-78h": 2,
            "78-80h": 2,
            "80-82h": 3,
            "102-104h": 1,
            "104-106h": 1,
            "126-128h": 1,
            "144-146h": 2,
            "148-150h": 1,
            "240-242h": 1,
            "246-248h": 1,
            "270-272h": 1,
            "292-294h": 2,
            "316-318h": 1,
            "342-344h": 2,
            "360-362h": 1,
            "366-368h": 1,
            "390-392h": 1
          },
          "tickets_count": 60,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-11": 2,
            "2025-11-12": 1,
            "2025-11-14": 1,
            "2025-11-18": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-07": 1,
            "2026-01-12": 3,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-03-02": 1,
            "2026-03-04": 2,
            "2026-03-05": 1,
            "2026-03-09": 4,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-06": 2,
            "2026-04-09": 1,
            "2026-04-14": 1,
            "2026-04-16": 2,
            "2026-04-20": 1,
            "2026-04-24": 2,
            "2026-04-28": 4,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-03": 79.51538194444444,
            "2025-11-05": 56.554673333333334,
            "2025-11-06": 30.751783333333332,
            "2025-11-10": 51.74797388888889,
            "2025-11-11": 83.06663222222222,
            "2025-11-12": 103.68759527777777,
            "2025-11-14": 8.361316944444445,
            "2025-11-18": 104.22387277777777,
            "2025-12-09": 30.95864861111111,
            "2025-12-15": 144.90149694444446,
            "2026-01-02": 8.952658611111111,
            "2026-01-05": 343.63481,
            "2026-01-06": 310.8446544444445,
            "2026-01-07": 48.47889916666667,
            "2026-01-12": 189.99320999999998,
            "2026-01-20": 29.749410277777777,
            "2026-01-22": 8.15092638888889,
            "2026-02-03": 77.48034333333332,
            "2026-02-10": 8.564288333333334,
            "2026-03-02": 145.09862611111112,
            "2026-03-04": 3.3256366666666666,
            "2026-03-05": 390.82849444444446,
            "2026-03-09": 99.3589963888889,
            "2026-03-19": 247.87816722222223,
            "2026-03-20": 360.59059083333335,
            "2026-03-26": 293.9926155555556,
            "2026-03-30": 1.1338752777777779,
            "2026-04-06": 107.4664913888889,
            "2026-04-14": 8.329652777777778,
            "2026-04-16": 372.0667569444445,
            "2026-04-20": 292.17866944444444,
            "2026-04-24": 160.59537444444445,
            "2026-04-28": 651.4135886111111,
            "2026-05-04": 133.73014666666668,
            "2026-05-05": 6.95549,
            "2026-05-08": 24.15327888888889,
            "2026-05-12": 5.037128333333333,
            "2026-05-18": 316.24260305555555,
            "2026-05-20": 6.397621388888889,
            "2026-05-21": 1.6938513888888889,
            "2026-06-01": 148.79019666666667,
            "2026-06-02": 30.86459972222222,
            "2026-06-05": 53.51367138888889
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-10": 1,
            "2025-11-11": 2,
            "2025-11-12": 1,
            "2025-11-14": 1,
            "2025-11-18": 1,
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2026-01-02": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-07": 1,
            "2026-01-12": 3,
            "2026-01-20": 1,
            "2026-01-22": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-09": 4,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 1,
            "2026-04-06": 2,
            "2026-04-14": 1,
            "2026-04-16": 2,
            "2026-04-20": 1,
            "2026-04-24": 2,
            "2026-04-28": 4,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 104.64,
          "mode_time_hours": 9.0,
          "mode_frequency": 4,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 4,
            "32-34h": 2,
            "80-82h": 1,
            "128-130h": 1,
            "176-178h": 1,
            "250-252h": 1,
            "272-274h": 3
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-12-22": 1,
            "2025-12-30": 1,
            "2026-01-15": 1,
            "2026-01-27": 3,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-03-18": 2
          },
          "time_per_day": {
            "2025-11-18": 7.594416388888889,
            "2025-12-22": 250.23571166666667,
            "2025-12-30": 8.50051,
            "2026-01-15": 9.561601944444444,
            "2026-01-27": 821.6972619444446,
            "2026-02-04": 5.565739444444445,
            "2026-02-06": 176.57496,
            "2026-02-10": 8.549591388888889,
            "2026-02-13": 8.250479444444444,
            "2026-02-16": 80.21988083333333,
            "2026-02-18": 128.75899722222223,
            "2026-03-18": 64.15124416666667
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-12-22": 1,
            "2025-12-30": 1,
            "2026-01-15": 1,
            "2026-01-27": 3,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-18": 1,
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 92.52,
            "mode_time_hours": 7.0,
            "mode_frequency": 12,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "4-6h": 2,
              "6-8h": 12,
              "8-10h": 10,
              "24-26h": 3,
              "28-30h": 1,
              "30-32h": 4,
              "32-34h": 2,
              "48-50h": 1,
              "50-52h": 1,
              "52-54h": 3,
              "54-56h": 2,
              "56-58h": 1,
              "68-70h": 1,
              "76-78h": 2,
              "78-80h": 2,
              "80-82h": 4,
              "86-88h": 1,
              "102-104h": 1,
              "104-106h": 1,
              "126-128h": 1,
              "128-130h": 1,
              "144-146h": 2,
              "148-150h": 1,
              "176-178h": 1,
              "240-242h": 1,
              "246-248h": 1,
              "250-252h": 1,
              "270-272h": 1,
              "272-274h": 3,
              "292-294h": 2,
              "316-318h": 1,
              "342-344h": 2,
              "360-362h": 1,
              "366-368h": 1,
              "390-392h": 1
            },
            "tickets_count": 79,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2025-11-03": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 2,
              "2025-11-12": 1,
              "2025-11-14": 1,
              "2025-11-18": 2,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-22": 1,
              "2025-12-30": 1,
              "2026-01-02": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-07": 2,
              "2026-01-12": 3,
              "2026-01-15": 1,
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-27": 3,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-09": 4,
              "2026-03-18": 2,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-03-30": 1,
              "2026-04-06": 2,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-04-16": 2,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-24": 2,
              "2026-04-28": 4,
              "2026-04-30": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-29": 1.4751697222222222,
              "2025-11-03": 79.51538194444444,
              "2025-11-05": 56.554673333333334,
              "2025-11-06": 30.751783333333332,
              "2025-11-10": 51.74797388888889,
              "2025-11-11": 83.06663222222222,
              "2025-11-12": 103.68759527777777,
              "2025-11-14": 8.361316944444445,
              "2025-11-18": 111.81828916666666,
              "2025-12-09": 30.95864861111111,
              "2025-12-15": 144.90149694444446,
              "2025-12-22": 250.23571166666667,
              "2025-12-30": 8.50051,
              "2026-01-02": 8.952658611111111,
              "2026-01-05": 343.63481,
              "2026-01-06": 310.8446544444445,
              "2026-01-07": 56.613777222222225,
              "2026-01-12": 189.99320999999998,
              "2026-01-15": 9.561601944444444,
              "2026-01-20": 29.749410277777777,
              "2026-01-22": 8.15092638888889,
              "2026-01-27": 821.6972619444446,
              "2026-02-03": 77.48034333333332,
              "2026-02-04": 5.565739444444445,
              "2026-02-06": 176.57496,
              "2026-02-10": 17.113879722222222,
              "2026-02-13": 8.250479444444444,
              "2026-02-16": 80.21988083333333,
              "2026-02-18": 128.75899722222223,
              "2026-03-02": 231.32658083333334,
              "2026-03-04": 3.3256366666666666,
              "2026-03-05": 390.82849444444446,
              "2026-03-09": 99.3589963888889,
              "2026-03-18": 64.15124416666667,
              "2026-03-19": 247.87816722222223,
              "2026-03-20": 360.59059083333335,
              "2026-03-26": 293.9926155555556,
              "2026-03-30": 1.1338752777777779,
              "2026-04-06": 107.4664913888889,
              "2026-04-14": 8.329652777777778,
              "2026-04-15": 7.099640833333333,
              "2026-04-16": 372.0667569444445,
              "2026-04-17": 6.236461944444444,
              "2026-04-20": 292.17866944444444,
              "2026-04-24": 160.59537444444445,
              "2026-04-28": 651.4135886111111,
              "2026-04-30": 24.841344444444445,
              "2026-05-04": 133.73014666666668,
              "2026-05-05": 6.95549,
              "2026-05-08": 24.15327888888889,
              "2026-05-12": 5.037128333333333,
              "2026-05-18": 316.24260305555555,
              "2026-05-19": 24.463036388888888,
              "2026-05-20": 6.397621388888889,
              "2026-05-21": 1.6938513888888889,
              "2026-06-01": 148.79019666666667,
              "2026-06-02": 30.86459972222222,
              "2026-06-05": 53.51367138888889
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2025-11-03": 1,
              "2025-11-05": 1,
              "2025-11-06": 1,
              "2025-11-10": 1,
              "2025-11-11": 2,
              "2025-11-12": 1,
              "2025-11-14": 1,
              "2025-11-18": 2,
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-22": 1,
              "2025-12-30": 1,
              "2026-01-02": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-07": 2,
              "2026-01-12": 3,
              "2026-01-15": 1,
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-27": 3,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-10": 2,
              "2026-02-13": 1,
              "2026-02-16": 1,
              "2026-02-18": 1,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-09": 4,
              "2026-03-18": 2,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-03-30": 1,
              "2026-04-06": 2,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-04-16": 2,
              "2026-04-17": 1,
              "2026-04-20": 1,
              "2026-04-24": 2,
              "2026-04-28": 4,
              "2026-04-30": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 22.64,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 2,
                "8-10h": 1,
                "24-26h": 2,
                "86-88h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2026-01-07": 1,
                "2026-03-02": 1,
                "2026-04-15": 1,
                "2026-04-17": 1,
                "2026-04-30": 1,
                "2026-05-19": 1
              },
              "time_per_day": {
                "2025-10-29": 1.4751697222222222,
                "2026-01-07": 8.134878055555555,
                "2026-03-02": 86.22795472222222,
                "2026-04-15": 7.099640833333333,
                "2026-04-17": 6.236461944444444,
                "2026-04-30": 24.841344444444445,
                "2026-05-19": 24.463036388888888
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2026-01-07": 1,
                "2026-03-02": 1,
                "2026-04-15": 1,
                "2026-04-17": 1,
                "2026-04-30": 1,
                "2026-05-19": 1
              }
            },
            "P2": {
              "avg_time_hours": 97.92,
              "mode_time_hours": 7.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 9,
                "8-10h": 5,
                "24-26h": 1,
                "28-30h": 1,
                "30-32h": 4,
                "48-50h": 1,
                "50-52h": 1,
                "52-54h": 3,
                "54-56h": 2,
                "56-58h": 1,
                "68-70h": 1,
                "76-78h": 2,
                "78-80h": 2,
                "80-82h": 3,
                "102-104h": 1,
                "104-106h": 1,
                "126-128h": 1,
                "144-146h": 2,
                "148-150h": 1,
                "240-242h": 1,
                "246-248h": 1,
                "270-272h": 1,
                "292-294h": 2,
                "316-318h": 1,
                "342-344h": 2,
                "360-362h": 1,
                "366-368h": 1,
                "390-392h": 1
              },
              "tickets_count": 57,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-11": 2,
                "2025-11-12": 1,
                "2025-11-14": 1,
                "2025-11-18": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-07": 1,
                "2026-01-12": 3,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-09": 4,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-06": 2,
                "2026-04-14": 1,
                "2026-04-16": 2,
                "2026-04-20": 1,
                "2026-04-24": 2,
                "2026-04-28": 4,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-11-03": 79.51538194444444,
                "2025-11-05": 56.554673333333334,
                "2025-11-06": 30.751783333333332,
                "2025-11-10": 51.74797388888889,
                "2025-11-11": 83.06663222222222,
                "2025-11-12": 103.68759527777777,
                "2025-11-14": 8.361316944444445,
                "2025-11-18": 104.22387277777777,
                "2025-12-09": 30.95864861111111,
                "2025-12-15": 144.90149694444446,
                "2026-01-02": 8.952658611111111,
                "2026-01-05": 343.63481,
                "2026-01-06": 310.8446544444445,
                "2026-01-07": 48.47889916666667,
                "2026-01-12": 189.99320999999998,
                "2026-01-20": 29.749410277777777,
                "2026-01-22": 8.15092638888889,
                "2026-02-03": 77.48034333333332,
                "2026-02-10": 8.564288333333334,
                "2026-03-02": 145.09862611111112,
                "2026-03-04": 3.3256366666666666,
                "2026-03-05": 390.82849444444446,
                "2026-03-09": 99.3589963888889,
                "2026-03-19": 247.87816722222223,
                "2026-03-20": 360.59059083333335,
                "2026-03-26": 293.9926155555556,
                "2026-03-30": 1.1338752777777779,
                "2026-04-06": 107.4664913888889,
                "2026-04-14": 8.329652777777778,
                "2026-04-16": 372.0667569444445,
                "2026-04-20": 292.17866944444444,
                "2026-04-24": 160.59537444444445,
                "2026-04-28": 651.4135886111111,
                "2026-05-04": 133.73014666666668,
                "2026-05-05": 6.95549,
                "2026-05-08": 24.15327888888889,
                "2026-05-12": 5.037128333333333,
                "2026-05-18": 316.24260305555555,
                "2026-05-20": 6.397621388888889,
                "2026-05-21": 1.6938513888888889,
                "2026-06-01": 148.79019666666667,
                "2026-06-02": 30.86459972222222,
                "2026-06-05": 53.51367138888889
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2025-11-05": 1,
                "2025-11-06": 1,
                "2025-11-10": 1,
                "2025-11-11": 2,
                "2025-11-12": 1,
                "2025-11-14": 1,
                "2025-11-18": 1,
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2026-01-02": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-07": 1,
                "2026-01-12": 3,
                "2026-01-20": 1,
                "2026-01-22": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-09": 4,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 1,
                "2026-04-06": 2,
                "2026-04-14": 1,
                "2026-04-16": 2,
                "2026-04-20": 1,
                "2026-04-24": 2,
                "2026-04-28": 4,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 104.64,
              "mode_time_hours": 9.0,
              "mode_frequency": 4,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 4,
                "32-34h": 2,
                "80-82h": 1,
                "128-130h": 1,
                "176-178h": 1,
                "250-252h": 1,
                "272-274h": 3
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-12-22": 1,
                "2025-12-30": 1,
                "2026-01-15": 1,
                "2026-01-27": 3,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-03-18": 2
              },
              "time_per_day": {
                "2025-11-18": 7.594416388888889,
                "2025-12-22": 250.23571166666667,
                "2025-12-30": 8.50051,
                "2026-01-15": 9.561601944444444,
                "2026-01-27": 821.6972619444446,
                "2026-02-04": 5.565739444444445,
                "2026-02-06": 176.57496,
                "2026-02-10": 8.549591388888889,
                "2026-02-13": 8.250479444444444,
                "2026-02-16": 80.21988083333333,
                "2026-02-18": 128.75899722222223,
                "2026-03-18": 64.15124416666667
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-12-22": 1,
                "2025-12-30": 1,
                "2026-01-15": 1,
                "2026-01-27": 3,
                "2026-02-04": 1,
                "2026-02-06": 1,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-18": 1,
                "2026-03-18": 2
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-04": 1,
              "2026-04-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-04-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_289": {
      "overall": {
        "avg_time_hours": 287.58,
        "mode_time_hours": 49.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "4-6h": 1,
          "8-10h": 2,
          "14-16h": 1,
          "16-18h": 3,
          "22-24h": 1,
          "24-26h": 1,
          "48-50h": 3,
          "50-52h": 1,
          "64-66h": 1,
          "72-74h": 1,
          "74-76h": 1,
          "120-122h": 1,
          "138-140h": 1,
          "172-174h": 1,
          "218-220h": 1,
          "278-280h": 1,
          "362-364h": 1,
          "452-454h": 1,
          "496-498h": 1,
          "1000-1002h": 1,
          "1012-1014h": 1,
          "1060-1062h": 1,
          "1634-1636h": 1,
          "1686-1688h": 1
        },
        "tickets_count": 39,
        "tickets_per_day": {
          "2025-12-12": 3,
          "2025-12-15": 1,
          "2025-12-23": 1,
          "2025-12-29": 1,
          "2026-01-14": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-02-13": 1,
          "2026-02-16": 2,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-03": 2,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-03-26": 1,
          "2026-03-31": 1,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-04": 1,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-19": 3,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-12-12": 1160.8452636111112,
          "2025-12-15": 1.199951111111111,
          "2025-12-23": 16.541344166666665,
          "2025-12-29": 1687.016876388889,
          "2026-01-14": 453.5502247222222,
          "2026-01-21": 15.547033888888889,
          "2026-01-22": 51.61250444444445,
          "2026-02-13": 75.34897277777779,
          "2026-02-16": 2648.484304722222,
          "2026-02-23": 138.6065725,
          "2026-02-28": 49.375636388888886,
          "2026-03-03": 19.69068083333333,
          "2026-03-05": 73.05286638888889,
          "2026-03-06": 5.735876666666666,
          "2026-03-09": 1.020081111111111,
          "2026-03-19": 363.03369111111107,
          "2026-03-26": 3.4707697222222222,
          "2026-04-01": 16.6927375,
          "2026-04-02": 22.53028138888889,
          "2026-04-09": 173.4030097222222,
          "2026-04-10": 497.8474347222222,
          "2026-04-22": 1000.8410775000001,
          "2026-05-06": 497.7828269444444,
          "2026-05-08": 16.343338888888887,
          "2026-05-19": 147.07922555555555,
          "2026-06-08": 65.89519
        },
        "time_count_per_day": {
          "2025-12-12": 3,
          "2025-12-15": 1,
          "2025-12-23": 1,
          "2025-12-29": 1,
          "2026-01-14": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-02-13": 1,
          "2026-02-16": 2,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-03": 2,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-03-26": 1,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-22": 1,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-19": 2,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-30": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 244.73,
          "mode_time_hours": 49.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "8-10h": 2,
            "14-16h": 1,
            "16-18h": 2,
            "22-24h": 1,
            "24-26h": 1,
            "48-50h": 2,
            "50-52h": 1,
            "64-66h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "120-122h": 1,
            "138-140h": 1,
            "172-174h": 1,
            "218-220h": 1,
            "278-280h": 1,
            "362-364h": 1,
            "496-498h": 1,
            "1000-1002h": 1,
            "1634-1636h": 1,
            "1686-1688h": 1
          },
          "tickets_count": 33,
          "tickets_per_day": {
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2025-12-29": 1,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-03": 2,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-03-26": 1,
            "2026-03-31": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-22": 1,
            "2026-04-29": 1,
            "2026-05-04": 1,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-19": 3,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-12-12": 49.51733055555556,
            "2025-12-15": 1.199951111111111,
            "2025-12-29": 1687.016876388889,
            "2026-01-21": 15.547033888888889,
            "2026-01-22": 51.61250444444445,
            "2026-02-13": 75.34897277777779,
            "2026-02-16": 1635.0334177777777,
            "2026-02-23": 138.6065725,
            "2026-02-28": 49.375636388888886,
            "2026-03-03": 19.69068083333333,
            "2026-03-05": 73.05286638888889,
            "2026-03-06": 5.735876666666666,
            "2026-03-09": 1.020081111111111,
            "2026-03-19": 363.03369111111107,
            "2026-03-26": 3.4707697222222222,
            "2026-04-01": 16.6927375,
            "2026-04-02": 22.53028138888889,
            "2026-04-09": 173.4030097222222,
            "2026-04-10": 497.8474347222222,
            "2026-04-22": 1000.8410775000001,
            "2026-05-06": 497.7828269444444,
            "2026-05-08": 16.343338888888887,
            "2026-05-19": 147.07922555555555,
            "2026-06-08": 65.89519
          },
          "time_count_per_day": {
            "2025-12-12": 1,
            "2025-12-15": 1,
            "2025-12-29": 1,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-02-13": 1,
            "2026-02-16": 1,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-03": 2,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-03-26": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-22": 1,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-19": 2,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 518.97,
          "mode_time_hours": 1061.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "48-50h": 1,
            "452-454h": 1,
            "1012-1014h": 1,
            "1060-1062h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-12": 2,
            "2025-12-23": 1,
            "2026-01-14": 1,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-12-12": 1111.3279330555556,
            "2025-12-23": 16.541344166666665,
            "2026-01-14": 453.5502247222222,
            "2026-02-16": 1013.4508869444444
          },
          "time_count_per_day": {
            "2025-12-12": 2,
            "2025-12-23": 1,
            "2026-01-14": 1,
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 287.58,
            "mode_time_hours": 49.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "4-6h": 1,
              "8-10h": 2,
              "14-16h": 1,
              "16-18h": 3,
              "22-24h": 1,
              "24-26h": 1,
              "48-50h": 3,
              "50-52h": 1,
              "64-66h": 1,
              "72-74h": 1,
              "74-76h": 1,
              "120-122h": 1,
              "138-140h": 1,
              "172-174h": 1,
              "218-220h": 1,
              "278-280h": 1,
              "362-364h": 1,
              "452-454h": 1,
              "496-498h": 1,
              "1000-1002h": 1,
              "1012-1014h": 1,
              "1060-1062h": 1,
              "1634-1636h": 1,
              "1686-1688h": 1
            },
            "tickets_count": 32,
            "tickets_per_day": {
              "2025-12-12": 3,
              "2025-12-15": 1,
              "2025-12-23": 1,
              "2025-12-29": 1,
              "2026-01-14": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-02-13": 1,
              "2026-02-16": 2,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-03": 2,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-03-26": 1,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-22": 1,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-19": 2,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-12-12": 1160.8452636111112,
              "2025-12-15": 1.199951111111111,
              "2025-12-23": 16.541344166666665,
              "2025-12-29": 1687.016876388889,
              "2026-01-14": 453.5502247222222,
              "2026-01-21": 15.547033888888889,
              "2026-01-22": 51.61250444444445,
              "2026-02-13": 75.34897277777779,
              "2026-02-16": 2648.484304722222,
              "2026-02-23": 138.6065725,
              "2026-02-28": 49.375636388888886,
              "2026-03-03": 19.69068083333333,
              "2026-03-05": 73.05286638888889,
              "2026-03-06": 5.735876666666666,
              "2026-03-09": 1.020081111111111,
              "2026-03-19": 363.03369111111107,
              "2026-03-26": 3.4707697222222222,
              "2026-04-01": 16.6927375,
              "2026-04-02": 22.53028138888889,
              "2026-04-09": 173.4030097222222,
              "2026-04-10": 497.8474347222222,
              "2026-04-22": 1000.8410775000001,
              "2026-05-06": 497.7828269444444,
              "2026-05-08": 16.343338888888887,
              "2026-05-19": 147.07922555555555,
              "2026-06-08": 65.89519
            },
            "time_count_per_day": {
              "2025-12-12": 3,
              "2025-12-15": 1,
              "2025-12-23": 1,
              "2025-12-29": 1,
              "2026-01-14": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-02-13": 1,
              "2026-02-16": 2,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-03": 2,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-03-26": 1,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-22": 1,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-19": 2,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 244.73,
              "mode_time_hours": 49.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "8-10h": 2,
                "14-16h": 1,
                "16-18h": 2,
                "22-24h": 1,
                "24-26h": 1,
                "48-50h": 2,
                "50-52h": 1,
                "64-66h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "120-122h": 1,
                "138-140h": 1,
                "172-174h": 1,
                "218-220h": 1,
                "278-280h": 1,
                "362-364h": 1,
                "496-498h": 1,
                "1000-1002h": 1,
                "1634-1636h": 1,
                "1686-1688h": 1
              },
              "tickets_count": 27,
              "tickets_per_day": {
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2025-12-29": 1,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-03": 2,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-03-26": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-22": 1,
                "2026-05-06": 2,
                "2026-05-08": 1,
                "2026-05-19": 2,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-12-12": 49.51733055555556,
                "2025-12-15": 1.199951111111111,
                "2025-12-29": 1687.016876388889,
                "2026-01-21": 15.547033888888889,
                "2026-01-22": 51.61250444444445,
                "2026-02-13": 75.34897277777779,
                "2026-02-16": 1635.0334177777777,
                "2026-02-23": 138.6065725,
                "2026-02-28": 49.375636388888886,
                "2026-03-03": 19.69068083333333,
                "2026-03-05": 73.05286638888889,
                "2026-03-06": 5.735876666666666,
                "2026-03-09": 1.020081111111111,
                "2026-03-19": 363.03369111111107,
                "2026-03-26": 3.4707697222222222,
                "2026-04-01": 16.6927375,
                "2026-04-02": 22.53028138888889,
                "2026-04-09": 173.4030097222222,
                "2026-04-10": 497.8474347222222,
                "2026-04-22": 1000.8410775000001,
                "2026-05-06": 497.7828269444444,
                "2026-05-08": 16.343338888888887,
                "2026-05-19": 147.07922555555555,
                "2026-06-08": 65.89519
              },
              "time_count_per_day": {
                "2025-12-12": 1,
                "2025-12-15": 1,
                "2025-12-29": 1,
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-02-13": 1,
                "2026-02-16": 1,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-03": 2,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-03-26": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-22": 1,
                "2026-05-06": 2,
                "2026-05-08": 1,
                "2026-05-19": 2,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 518.97,
              "mode_time_hours": 1061.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "48-50h": 1,
                "452-454h": 1,
                "1012-1014h": 1,
                "1060-1062h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-12": 2,
                "2025-12-23": 1,
                "2026-01-14": 1,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-12-12": 1111.3279330555556,
                "2025-12-23": 16.541344166666665,
                "2026-01-14": 453.5502247222222,
                "2026-02-16": 1013.4508869444444
              },
              "time_count_per_day": {
                "2025-12-12": 2,
                "2025-12-23": 1,
                "2026-01-14": 1,
                "2026-02-16": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-30": 1,
              "2026-05-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-07": 1,
              "2026-03-31": 1,
              "2026-04-10": 1,
              "2026-04-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-07": 1,
                "2026-03-31": 1,
                "2026-04-10": 1,
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_360": {
      "overall": {
        "avg_time_hours": 14.32,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 6,
          "4-6h": 3,
          "24-26h": 1,
          "28-30h": 1,
          "30-32h": 2,
          "70-72h": 1,
          "78-80h": 1
        },
        "tickets_count": 21,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-12-30": 1,
          "2026-01-12": 2,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-02-19": 2,
          "2026-02-26": 1,
          "2026-02-27": 1,
          "2026-03-04": 1,
          "2026-03-26": 1,
          "2026-03-30": 2,
          "2026-04-08": 1,
          "2026-04-28": 1,
          "2026-05-12": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-06-02": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-10-30": 30.10613611111111,
          "2025-12-30": 30.64039277777778,
          "2026-01-12": 5.606758611111111,
          "2026-01-15": 0.042466666666666666,
          "2026-01-22": 3.97502,
          "2026-02-19": 79.21968166666667,
          "2026-02-26": 4.950763055555555,
          "2026-02-27": 2.9306611111111107,
          "2026-03-04": 2.4051891666666667,
          "2026-03-26": 1.1031352777777776,
          "2026-03-30": 4.803260833333333,
          "2026-04-08": 0.8647386111111112,
          "2026-04-28": 29.476211666666664,
          "2026-05-12": 24.545638888888888,
          "2026-05-21": 2.1511341666666666,
          "2026-05-25": 71.24185694444445,
          "2026-06-02": 4.313272222222222,
          "2026-06-05": 2.3396938888888887
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-12-30": 1,
          "2026-01-12": 2,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-02-19": 2,
          "2026-02-26": 1,
          "2026-02-27": 1,
          "2026-03-04": 1,
          "2026-03-26": 1,
          "2026-03-30": 2,
          "2026-04-08": 1,
          "2026-04-28": 1,
          "2026-05-12": 1,
          "2026-05-21": 1,
          "2026-05-25": 1,
          "2026-06-02": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 14.95,
          "mode_time_hours": 3.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 6,
            "4-6h": 3,
            "24-26h": 1,
            "28-30h": 1,
            "30-32h": 1,
            "70-72h": 1,
            "78-80h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2026-01-12": 2,
            "2026-01-22": 1,
            "2026-02-19": 2,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-04": 1,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-28": 1,
            "2026-05-12": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-06-02": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-10-30": 30.10613611111111,
            "2026-01-12": 5.606758611111111,
            "2026-01-22": 3.97502,
            "2026-02-19": 79.21968166666667,
            "2026-02-26": 4.950763055555555,
            "2026-02-27": 2.9306611111111107,
            "2026-03-04": 2.4051891666666667,
            "2026-03-26": 1.1031352777777776,
            "2026-03-30": 4.803260833333333,
            "2026-04-28": 29.476211666666664,
            "2026-05-12": 24.545638888888888,
            "2026-05-21": 2.1511341666666666,
            "2026-05-25": 71.24185694444445,
            "2026-06-02": 4.313272222222222,
            "2026-06-05": 2.3396938888888887
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2026-01-12": 2,
            "2026-01-22": 1,
            "2026-02-19": 2,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-03-04": 1,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-28": 1,
            "2026-05-12": 1,
            "2026-05-21": 1,
            "2026-05-25": 1,
            "2026-06-02": 1,
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 10.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "30-32h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-30": 1,
            "2026-01-15": 1,
            "2026-04-08": 1
          },
          "time_per_day": {
            "2025-12-30": 30.64039277777778,
            "2026-01-15": 0.042466666666666666,
            "2026-04-08": 0.8647386111111112
          },
          "time_count_per_day": {
            "2025-12-30": 1,
            "2026-01-15": 1,
            "2026-04-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.32,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 6,
              "4-6h": 3,
              "24-26h": 1,
              "28-30h": 1,
              "30-32h": 2,
              "70-72h": 1,
              "78-80h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-12-30": 1,
              "2026-01-12": 2,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-02-19": 2,
              "2026-02-26": 1,
              "2026-02-27": 1,
              "2026-03-04": 1,
              "2026-03-26": 1,
              "2026-03-30": 2,
              "2026-04-08": 1,
              "2026-04-28": 1,
              "2026-05-12": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-06-02": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-10-30": 30.10613611111111,
              "2025-12-30": 30.64039277777778,
              "2026-01-12": 5.606758611111111,
              "2026-01-15": 0.042466666666666666,
              "2026-01-22": 3.97502,
              "2026-02-19": 79.21968166666667,
              "2026-02-26": 4.950763055555555,
              "2026-02-27": 2.9306611111111107,
              "2026-03-04": 2.4051891666666667,
              "2026-03-26": 1.1031352777777776,
              "2026-03-30": 4.803260833333333,
              "2026-04-08": 0.8647386111111112,
              "2026-04-28": 29.476211666666664,
              "2026-05-12": 24.545638888888888,
              "2026-05-21": 2.1511341666666666,
              "2026-05-25": 71.24185694444445,
              "2026-06-02": 4.313272222222222,
              "2026-06-05": 2.3396938888888887
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-12-30": 1,
              "2026-01-12": 2,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-02-19": 2,
              "2026-02-26": 1,
              "2026-02-27": 1,
              "2026-03-04": 1,
              "2026-03-26": 1,
              "2026-03-30": 2,
              "2026-04-08": 1,
              "2026-04-28": 1,
              "2026-05-12": 1,
              "2026-05-21": 1,
              "2026-05-25": 1,
              "2026-06-02": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 14.95,
              "mode_time_hours": 3.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 6,
                "4-6h": 3,
                "24-26h": 1,
                "28-30h": 1,
                "30-32h": 1,
                "70-72h": 1,
                "78-80h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2026-01-12": 2,
                "2026-01-22": 1,
                "2026-02-19": 2,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-04": 1,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-28": 1,
                "2026-05-12": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-06-02": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-10-30": 30.10613611111111,
                "2026-01-12": 5.606758611111111,
                "2026-01-22": 3.97502,
                "2026-02-19": 79.21968166666667,
                "2026-02-26": 4.950763055555555,
                "2026-02-27": 2.9306611111111107,
                "2026-03-04": 2.4051891666666667,
                "2026-03-26": 1.1031352777777776,
                "2026-03-30": 4.803260833333333,
                "2026-04-28": 29.476211666666664,
                "2026-05-12": 24.545638888888888,
                "2026-05-21": 2.1511341666666666,
                "2026-05-25": 71.24185694444445,
                "2026-06-02": 4.313272222222222,
                "2026-06-05": 2.3396938888888887
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2026-01-12": 2,
                "2026-01-22": 1,
                "2026-02-19": 2,
                "2026-02-26": 1,
                "2026-02-27": 1,
                "2026-03-04": 1,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-28": 1,
                "2026-05-12": 1,
                "2026-05-21": 1,
                "2026-05-25": 1,
                "2026-06-02": 1,
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 10.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "30-32h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-30": 1,
                "2026-01-15": 1,
                "2026-04-08": 1
              },
              "time_per_day": {
                "2025-12-30": 30.64039277777778,
                "2026-01-15": 0.042466666666666666,
                "2026-04-08": 0.8647386111111112
              },
              "time_count_per_day": {
                "2025-12-30": 1,
                "2026-01-15": 1,
                "2026-04-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_266": {
      "overall": {
        "avg_time_hours": 144.76,
        "mode_time_hours": 145.0,
        "mode_frequency": 1,
        "time_distribution": {
          "144-146h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-04": 1
        },
        "time_per_day": {
          "2025-11-04": 144.75624555555555
        },
        "time_count_per_day": {
          "2025-11-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 144.76,
          "mode_time_hours": 145.0,
          "mode_frequency": 1,
          "time_distribution": {
            "144-146h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-11-04": 144.75624555555555
          },
          "time_count_per_day": {
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 144.76,
            "mode_time_hours": 145.0,
            "mode_frequency": 1,
            "time_distribution": {
              "144-146h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-04": 1
            },
            "time_per_day": {
              "2025-11-04": 144.75624555555555
            },
            "time_count_per_day": {
              "2025-11-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 144.76,
              "mode_time_hours": 145.0,
              "mode_frequency": 1,
              "time_distribution": {
                "144-146h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-11-04": 144.75624555555555
              },
              "time_count_per_day": {
                "2025-11-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_362": {
      "overall": {
        "avg_time_hours": 2.77,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2026-02-09": 1
        },
        "time_per_day": {
          "2025-10-29": 4.876038611111111,
          "2026-02-09": 0.658725
        },
        "time_count_per_day": {
          "2025-10-29": 1,
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.77,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2025-10-29": 4.876038611111111,
            "2026-02-09": 0.658725
          },
          "time_count_per_day": {
            "2025-10-29": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.77,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-29": 1,
              "2026-02-09": 1
            },
            "time_per_day": {
              "2025-10-29": 4.876038611111111,
              "2026-02-09": 0.658725
            },
            "time_count_per_day": {
              "2025-10-29": 1,
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.77,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-29": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2025-10-29": 4.876038611111111,
                "2026-02-09": 0.658725
              },
              "time_count_per_day": {
                "2025-10-29": 1,
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_363": {
      "overall": {
        "avg_time_hours": 3.98,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-29": 1
        },
        "time_per_day": {
          "2025-10-29": 3.979985
        },
        "time_count_per_day": {
          "2025-10-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.98,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-29": 1
          },
          "time_per_day": {
            "2025-10-29": 3.979985
          },
          "time_count_per_day": {
            "2025-10-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.98,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-29": 1
            },
            "time_per_day": {
              "2025-10-29": 3.979985
            },
            "time_count_per_day": {
              "2025-10-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.98,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-29": 1
              },
              "time_per_day": {
                "2025-10-29": 3.979985
              },
              "time_count_per_day": {
                "2025-10-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_365": {
      "overall": {
        "avg_time_hours": 3.87,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "6-8h": 1,
          "10-12h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-25": 1,
          "2026-04-27": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2025-10-30": 1.1870825,
          "2026-03-06": 0.4617558333333333,
          "2026-03-10": 10.448384444444445,
          "2026-03-25": 7.009547222222222,
          "2026-04-27": 0.20440694444444446,
          "2026-05-15": 3.8974772222222223
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-25": 1,
          "2026-04-27": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-03-06": 0.4617558333333333
          },
          "time_count_per_day": {
            "2026-03-06": 1
          }
        },
        "P2": {
          "avg_time_hours": 4.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "6-8h": 1,
            "10-12h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2026-03-10": 1,
            "2026-03-25": 1,
            "2026-04-27": 1,
            "2026-05-15": 1
          },
          "time_per_day": {
            "2025-10-30": 1.1870825,
            "2026-03-10": 10.448384444444445,
            "2026-03-25": 7.009547222222222,
            "2026-04-27": 0.20440694444444446,
            "2026-05-15": 3.8974772222222223
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2026-03-10": 1,
            "2026-03-25": 1,
            "2026-04-27": 1,
            "2026-05-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.87,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "6-8h": 1,
              "10-12h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-25": 1,
              "2026-04-27": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2025-10-30": 1.1870825,
              "2026-03-06": 0.4617558333333333,
              "2026-03-10": 10.448384444444445,
              "2026-03-25": 7.009547222222222,
              "2026-04-27": 0.20440694444444446,
              "2026-05-15": 3.8974772222222223
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-25": 1,
              "2026-04-27": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {
                "2026-03-06": 0.4617558333333333
              },
              "time_count_per_day": {
                "2026-03-06": 1
              }
            },
            "P2": {
              "avg_time_hours": 4.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "6-8h": 1,
                "10-12h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2026-03-10": 1,
                "2026-03-25": 1,
                "2026-04-27": 1,
                "2026-05-15": 1
              },
              "time_per_day": {
                "2025-10-30": 1.1870825,
                "2026-03-10": 10.448384444444445,
                "2026-03-25": 7.009547222222222,
                "2026-04-27": 0.20440694444444446,
                "2026-05-15": 3.8974772222222223
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2026-03-10": 1,
                "2026-03-25": 1,
                "2026-04-27": 1,
                "2026-05-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_369": {
      "overall": {
        "avg_time_hours": 48.94,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1,
          "70-72h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-17": 1
        },
        "time_per_day": {
          "2025-10-31": 27.36352361111111,
          "2025-11-17": 70.51352638888889
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.36,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-31": 1
          },
          "time_per_day": {
            "2025-10-31": 27.36352361111111
          },
          "time_count_per_day": {
            "2025-10-31": 1
          }
        },
        "P3": {
          "avg_time_hours": 70.51,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 70.51352638888889
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.94,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1,
              "70-72h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-17": 1
            },
            "time_per_day": {
              "2025-10-31": 27.36352361111111,
              "2025-11-17": 70.51352638888889
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.36,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-31": 1
              },
              "time_per_day": {
                "2025-10-31": 27.36352361111111
              },
              "time_count_per_day": {
                "2025-10-31": 1
              }
            },
            "P3": {
              "avg_time_hours": 70.51,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 70.51352638888889
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_371": {
      "overall": {
        "avg_time_hours": 171.59,
        "mode_time_hours": 341.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "340-342h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-10-30": 2.9274666666666667,
          "2025-11-13": 340.26011861111107
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 171.59,
          "mode_time_hours": 341.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "340-342h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-10-30": 2.9274666666666667,
            "2025-11-13": 340.26011861111107
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 171.59,
            "mode_time_hours": 341.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "340-342h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-10-30": 2.9274666666666667,
              "2025-11-13": 340.26011861111107
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 171.59,
              "mode_time_hours": 341.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "340-342h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-10-30": 2.9274666666666667,
                "2025-11-13": 340.26011861111107
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_374": {
      "overall": {
        "avg_time_hours": 115.76,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "4-6h": 1,
          "122-124h": 2,
          "788-790h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2025-10-30": 2,
          "2025-11-25": 2,
          "2025-12-03": 2,
          "2026-03-12": 1,
          "2026-04-02": 1,
          "2026-05-02": 1,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-30": 0.8924169444444445,
          "2025-11-25": 0.32287,
          "2025-12-03": 245.4986947222222,
          "2026-03-12": 0.14245944444444444,
          "2026-04-02": 789.6827227777778,
          "2026-05-02": 5.332846944444444
        },
        "time_count_per_day": {
          "2025-10-30": 2,
          "2025-11-25": 2,
          "2025-12-03": 2,
          "2026-03-12": 1,
          "2026-04-02": 1,
          "2026-05-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 132.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "4-6h": 1,
            "788-790h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-10-30": 2,
            "2025-11-25": 1,
            "2026-03-12": 1,
            "2026-04-02": 1,
            "2026-05-02": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-30": 0.8924169444444445,
            "2025-11-25": 0.15677777777777777,
            "2026-03-12": 0.14245944444444444,
            "2026-04-02": 789.6827227777778,
            "2026-05-02": 5.332846944444444
          },
          "time_count_per_day": {
            "2025-10-30": 2,
            "2025-11-25": 1,
            "2026-03-12": 1,
            "2026-04-02": 1,
            "2026-05-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.17,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-11-25": 0.16609222222222222
          },
          "time_count_per_day": {
            "2025-11-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 122.75,
          "mode_time_hours": 123.0,
          "mode_frequency": 2,
          "time_distribution": {
            "122-124h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-03": 2
          },
          "time_per_day": {
            "2025-12-03": 245.4986947222222
          },
          "time_count_per_day": {
            "2025-12-03": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 115.76,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "4-6h": 1,
              "122-124h": 2,
              "788-790h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2025-10-30": 2,
              "2025-11-25": 2,
              "2025-12-03": 2,
              "2026-03-12": 1,
              "2026-04-02": 1,
              "2026-05-02": 1
            },
            "time_per_day": {
              "2025-10-30": 0.8924169444444445,
              "2025-11-25": 0.32287,
              "2025-12-03": 245.4986947222222,
              "2026-03-12": 0.14245944444444444,
              "2026-04-02": 789.6827227777778,
              "2026-05-02": 5.332846944444444
            },
            "time_count_per_day": {
              "2025-10-30": 2,
              "2025-11-25": 2,
              "2025-12-03": 2,
              "2026-03-12": 1,
              "2026-04-02": 1,
              "2026-05-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 132.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "4-6h": 1,
                "788-790h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-10-30": 2,
                "2025-11-25": 1,
                "2026-03-12": 1,
                "2026-04-02": 1,
                "2026-05-02": 1
              },
              "time_per_day": {
                "2025-10-30": 0.8924169444444445,
                "2025-11-25": 0.15677777777777777,
                "2026-03-12": 0.14245944444444444,
                "2026-04-02": 789.6827227777778,
                "2026-05-02": 5.332846944444444
              },
              "time_count_per_day": {
                "2025-10-30": 2,
                "2025-11-25": 1,
                "2026-03-12": 1,
                "2026-04-02": 1,
                "2026-05-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.17,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-11-25": 0.16609222222222222
              },
              "time_count_per_day": {
                "2025-11-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 122.75,
              "mode_time_hours": 123.0,
              "mode_frequency": 2,
              "time_distribution": {
                "122-124h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-03": 2
              },
              "time_per_day": {
                "2025-12-03": 245.4986947222222
              },
              "time_count_per_day": {
                "2025-12-03": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_375": {
      "overall": {
        "avg_time_hours": 69.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 2,
          "4-6h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "24-26h": 2,
          "372-374h": 1,
          "422-424h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-11-28": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-03-03": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-04-18": 1,
          "2026-04-29": 2,
          "2026-05-04": 1,
          "2026-06-05": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-10-30": 0.3577161111111111,
          "2025-11-28": 3.1542327777777777,
          "2026-02-03": 25.438082222222224,
          "2026-02-10": 5.926071111111111,
          "2026-02-13": 373.3257213888889,
          "2026-03-03": 17.639064166666667,
          "2026-03-11": 0.6079169444444446,
          "2026-03-12": 24.683326944444445,
          "2026-03-18": 423.29034083333335,
          "2026-04-18": 2.6868855555555555,
          "2026-04-29": 22.094605555555557,
          "2026-05-04": 0.10668972222222223
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-11-28": 1,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-13": 1,
          "2026-03-03": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-04-18": 1,
          "2026-04-29": 2,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.92,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "4-6h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-02-10": 1,
            "2026-04-18": 1,
            "2026-06-05": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-28": 3.1542327777777777,
            "2026-02-10": 5.926071111111111,
            "2026-04-18": 2.6868855555555555
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2026-02-10": 1,
            "2026-04-18": 1
          }
        },
        "P2": {
          "avg_time_hours": 54.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "16-18h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "372-374h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2026-02-13": 1,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-04-29": 2,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2025-10-30": 0.3577161111111111,
            "2026-02-13": 373.3257213888889,
            "2026-03-03": 17.639064166666667,
            "2026-03-11": 0.6079169444444446,
            "2026-03-12": 24.683326944444445,
            "2026-04-29": 22.094605555555557,
            "2026-05-04": 0.10668972222222223
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2026-02-13": 1,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-04-29": 2,
            "2026-05-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 25.44,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 25.438082222222224
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 423.29,
          "mode_time_hours": 423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "422-424h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 423.29034083333335
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 69.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 2,
              "4-6h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "24-26h": 2,
              "372-374h": 1,
              "422-424h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-11-28": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-03-03": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-04-18": 1,
              "2026-04-29": 2,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2025-10-30": 0.3577161111111111,
              "2025-11-28": 3.1542327777777777,
              "2026-02-03": 25.438082222222224,
              "2026-02-10": 5.926071111111111,
              "2026-02-13": 373.3257213888889,
              "2026-03-03": 17.639064166666667,
              "2026-03-11": 0.6079169444444446,
              "2026-03-12": 24.683326944444445,
              "2026-03-18": 423.29034083333335,
              "2026-04-18": 2.6868855555555555,
              "2026-04-29": 22.094605555555557,
              "2026-05-04": 0.10668972222222223
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-11-28": 1,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-13": 1,
              "2026-03-03": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-04-18": 1,
              "2026-04-29": 2,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.92,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "4-6h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-02-10": 1,
                "2026-04-18": 1
              },
              "time_per_day": {
                "2025-11-28": 3.1542327777777777,
                "2026-02-10": 5.926071111111111,
                "2026-04-18": 2.6868855555555555
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2026-02-10": 1,
                "2026-04-18": 1
              }
            },
            "P2": {
              "avg_time_hours": 54.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "16-18h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "372-374h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2026-02-13": 1,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-04-29": 2,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2025-10-30": 0.3577161111111111,
                "2026-02-13": 373.3257213888889,
                "2026-03-03": 17.639064166666667,
                "2026-03-11": 0.6079169444444446,
                "2026-03-12": 24.683326944444445,
                "2026-04-29": 22.094605555555557,
                "2026-05-04": 0.10668972222222223
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2026-02-13": 1,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-04-29": 2,
                "2026-05-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 25.44,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 25.438082222222224
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 423.29,
              "mode_time_hours": 423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "422-424h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 423.29034083333335
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_91": {
      "overall": {
        "avg_time_hours": 30.4,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "72-74h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-12-10": 1,
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-10-31": 26.479703611111113,
          "2025-11-10": 1.1560083333333333,
          "2025-12-10": 21.186230277777778,
          "2025-12-30": 72.7794488888889
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-10": 1,
          "2025-12-10": 1,
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 33.47,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "26-28h": 1,
            "72-74h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2025-11-10": 1,
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-10-31": 26.479703611111113,
            "2025-11-10": 1.1560083333333333,
            "2025-12-30": 72.7794488888889
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2025-11-10": 1,
            "2025-12-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 21.19,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-12-10": 21.186230277777778
          },
          "time_count_per_day": {
            "2025-12-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 30.4,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "72-74h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-12-10": 1,
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-10-31": 26.479703611111113,
              "2025-11-10": 1.1560083333333333,
              "2025-12-10": 21.186230277777778,
              "2025-12-30": 72.7794488888889
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-10": 1,
              "2025-12-10": 1,
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 33.47,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "26-28h": 1,
                "72-74h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2025-11-10": 1,
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-10-31": 26.479703611111113,
                "2025-11-10": 1.1560083333333333,
                "2025-12-30": 72.7794488888889
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2025-11-10": 1,
                "2025-12-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 21.19,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-12-10": 21.186230277777778
              },
              "time_count_per_day": {
                "2025-12-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_372": {
      "overall": {
        "avg_time_hours": 3.01,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-30": 1
        },
        "time_per_day": {
          "2025-10-30": 3.0101958333333334
        },
        "time_count_per_day": {
          "2025-10-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.01,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-30": 1
          },
          "time_per_day": {
            "2025-10-30": 3.0101958333333334
          },
          "time_count_per_day": {
            "2025-10-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.01,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-30": 1
            },
            "time_per_day": {
              "2025-10-30": 3.0101958333333334
            },
            "time_count_per_day": {
              "2025-10-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.01,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-30": 1
              },
              "time_per_day": {
                "2025-10-30": 3.0101958333333334
              },
              "time_count_per_day": {
                "2025-10-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_380": {
      "overall": {
        "avg_time_hours": 176.95,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "6-8h": 1,
          "14-16h": 2,
          "16-18h": 1,
          "20-22h": 1,
          "22-24h": 2,
          "54-56h": 1,
          "78-80h": 1,
          "104-106h": 1,
          "214-216h": 1,
          "438-440h": 1,
          "574-576h": 1,
          "1416-1418h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-12-04": 1,
          "2025-12-17": 2,
          "2025-12-31": 1,
          "2026-01-06": 1,
          "2026-01-10": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-31": 1,
          "2026-02-14": 1,
          "2026-03-20": 2,
          "2026-03-21": 2,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-10-30": 0.4916183333333333,
          "2025-10-31": 21.098474166666666,
          "2025-12-04": 23.653253055555556,
          "2025-12-17": 494.9757938888889,
          "2025-12-31": 17.001984444444446,
          "2026-01-06": 214.38535861111112,
          "2026-01-10": 0.3711736111111111,
          "2026-01-13": 7.013826944444444,
          "2026-01-15": 78.29134777777779,
          "2026-01-31": 23.199232222222225,
          "2026-02-14": 104.34233805555556,
          "2026-03-20": 577.5299116666666,
          "2026-03-21": 29.10317472222222,
          "2026-04-23": 1416.6490900000001
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-10-31": 1,
          "2025-12-04": 1,
          "2025-12-17": 2,
          "2025-12-31": 1,
          "2026-01-06": 1,
          "2026-01-10": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-31": 1,
          "2026-02-14": 1,
          "2026-03-20": 2,
          "2026-03-21": 2,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 215.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "14-16h": 2,
            "16-18h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "54-56h": 1,
            "214-216h": 1,
            "438-440h": 1,
            "574-576h": 1,
            "1416-1418h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2025-10-31": 1,
            "2025-12-04": 1,
            "2025-12-17": 2,
            "2025-12-31": 1,
            "2026-01-06": 1,
            "2026-01-10": 1,
            "2026-03-20": 2,
            "2026-03-21": 2,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-10-30": 0.4916183333333333,
            "2025-10-31": 21.098474166666666,
            "2025-12-04": 23.653253055555556,
            "2025-12-17": 494.9757938888889,
            "2025-12-31": 17.001984444444446,
            "2026-01-06": 214.38535861111112,
            "2026-01-10": 0.3711736111111111,
            "2026-03-20": 577.5299116666666,
            "2026-03-21": 29.10317472222222,
            "2026-04-23": 1416.6490900000001
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2025-10-31": 1,
            "2025-12-04": 1,
            "2025-12-17": 2,
            "2025-12-31": 1,
            "2026-01-06": 1,
            "2026-01-10": 1,
            "2026-03-20": 2,
            "2026-03-21": 2,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 53.21,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "22-24h": 1,
            "78-80h": 1,
            "104-106h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-31": 1,
            "2026-02-14": 1
          },
          "time_per_day": {
            "2026-01-13": 7.013826944444444,
            "2026-01-15": 78.29134777777779,
            "2026-01-31": 23.199232222222225,
            "2026-02-14": 104.34233805555556
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-31": 1,
            "2026-02-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 176.95,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "6-8h": 1,
              "14-16h": 2,
              "16-18h": 1,
              "20-22h": 1,
              "22-24h": 2,
              "54-56h": 1,
              "78-80h": 1,
              "104-106h": 1,
              "214-216h": 1,
              "438-440h": 1,
              "574-576h": 1,
              "1416-1418h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-12-04": 1,
              "2025-12-17": 2,
              "2025-12-31": 1,
              "2026-01-06": 1,
              "2026-01-10": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-31": 1,
              "2026-02-14": 1,
              "2026-03-20": 2,
              "2026-03-21": 2,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-10-30": 0.4916183333333333,
              "2025-10-31": 21.098474166666666,
              "2025-12-04": 23.653253055555556,
              "2025-12-17": 494.9757938888889,
              "2025-12-31": 17.001984444444446,
              "2026-01-06": 214.38535861111112,
              "2026-01-10": 0.3711736111111111,
              "2026-01-13": 7.013826944444444,
              "2026-01-15": 78.29134777777779,
              "2026-01-31": 23.199232222222225,
              "2026-02-14": 104.34233805555556,
              "2026-03-20": 577.5299116666666,
              "2026-03-21": 29.10317472222222,
              "2026-04-23": 1416.6490900000001
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-10-31": 1,
              "2025-12-04": 1,
              "2025-12-17": 2,
              "2025-12-31": 1,
              "2026-01-06": 1,
              "2026-01-10": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-31": 1,
              "2026-02-14": 1,
              "2026-03-20": 2,
              "2026-03-21": 2,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 215.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "14-16h": 2,
                "16-18h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "54-56h": 1,
                "214-216h": 1,
                "438-440h": 1,
                "574-576h": 1,
                "1416-1418h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2025-10-31": 1,
                "2025-12-04": 1,
                "2025-12-17": 2,
                "2025-12-31": 1,
                "2026-01-06": 1,
                "2026-01-10": 1,
                "2026-03-20": 2,
                "2026-03-21": 2,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-10-30": 0.4916183333333333,
                "2025-10-31": 21.098474166666666,
                "2025-12-04": 23.653253055555556,
                "2025-12-17": 494.9757938888889,
                "2025-12-31": 17.001984444444446,
                "2026-01-06": 214.38535861111112,
                "2026-01-10": 0.3711736111111111,
                "2026-03-20": 577.5299116666666,
                "2026-03-21": 29.10317472222222,
                "2026-04-23": 1416.6490900000001
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2025-10-31": 1,
                "2025-12-04": 1,
                "2025-12-17": 2,
                "2025-12-31": 1,
                "2026-01-06": 1,
                "2026-01-10": 1,
                "2026-03-20": 2,
                "2026-03-21": 2,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 53.21,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "22-24h": 1,
                "78-80h": 1,
                "104-106h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-31": 1,
                "2026-02-14": 1
              },
              "time_per_day": {
                "2026-01-13": 7.013826944444444,
                "2026-01-15": 78.29134777777779,
                "2026-01-31": 23.199232222222225,
                "2026-02-14": 104.34233805555556
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-31": 1,
                "2026-02-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_381": {
      "overall": {
        "avg_time_hours": 220.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "6-8h": 1,
          "22-24h": 1,
          "26-28h": 1,
          "30-32h": 1,
          "34-36h": 1,
          "44-46h": 1,
          "70-72h": 1,
          "188-190h": 1,
          "508-510h": 1,
          "894-896h": 1,
          "1252-1254h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-24": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-17": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-03-06": 1
        },
        "time_per_day": {
          "2025-10-30": 0.48375277777777775,
          "2025-11-17": 7.4388177777777775,
          "2025-11-18": 30.365600833333332,
          "2025-11-24": 0.03655194444444444,
          "2025-11-26": 26.860429166666666,
          "2025-11-28": 1.0514941666666666,
          "2025-12-17": 44.20554666666666,
          "2025-12-29": 70.58798861111111,
          "2025-12-30": 23.430758333333333,
          "2026-02-12": 895.9329963888889,
          "2026-02-14": 34.50747944444445,
          "2026-02-16": 1253.801281111111,
          "2026-02-24": 188.96877027777776,
          "2026-03-06": 508.57728555555553
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2025-11-17": 1,
          "2025-11-18": 1,
          "2025-11-24": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-17": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-03-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 327.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "6-8h": 1,
            "22-24h": 1,
            "70-72h": 1,
            "188-190h": 1,
            "508-510h": 1,
            "894-896h": 1,
            "1252-1254h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2026-02-12": 1,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2025-10-30": 0.48375277777777775,
            "2025-11-17": 7.4388177777777775,
            "2025-11-24": 0.03655194444444444,
            "2025-12-29": 70.58798861111111,
            "2025-12-30": 23.430758333333333,
            "2026-02-12": 895.9329963888889,
            "2026-02-16": 1253.801281111111,
            "2026-02-24": 188.96877027777776,
            "2026-03-06": 508.57728555555553
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2025-11-17": 1,
            "2025-11-24": 1,
            "2025-12-29": 1,
            "2025-12-30": 1,
            "2026-02-12": 1,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-03-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 27.4,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "26-28h": 1,
            "30-32h": 1,
            "34-36h": 1,
            "44-46h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-18": 1,
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2025-12-17": 1,
            "2026-02-14": 1
          },
          "time_per_day": {
            "2025-11-18": 30.365600833333332,
            "2025-11-26": 26.860429166666666,
            "2025-11-28": 1.0514941666666666,
            "2025-12-17": 44.20554666666666,
            "2026-02-14": 34.50747944444445
          },
          "time_count_per_day": {
            "2025-11-18": 1,
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2025-12-17": 1,
            "2026-02-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 220.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "6-8h": 1,
              "22-24h": 1,
              "26-28h": 1,
              "30-32h": 1,
              "34-36h": 1,
              "44-46h": 1,
              "70-72h": 1,
              "188-190h": 1,
              "508-510h": 1,
              "894-896h": 1,
              "1252-1254h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-24": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-17": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-03-06": 1
            },
            "time_per_day": {
              "2025-10-30": 0.48375277777777775,
              "2025-11-17": 7.4388177777777775,
              "2025-11-18": 30.365600833333332,
              "2025-11-24": 0.03655194444444444,
              "2025-11-26": 26.860429166666666,
              "2025-11-28": 1.0514941666666666,
              "2025-12-17": 44.20554666666666,
              "2025-12-29": 70.58798861111111,
              "2025-12-30": 23.430758333333333,
              "2026-02-12": 895.9329963888889,
              "2026-02-14": 34.50747944444445,
              "2026-02-16": 1253.801281111111,
              "2026-02-24": 188.96877027777776,
              "2026-03-06": 508.57728555555553
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2025-11-17": 1,
              "2025-11-18": 1,
              "2025-11-24": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-17": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-03-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 327.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "6-8h": 1,
                "22-24h": 1,
                "70-72h": 1,
                "188-190h": 1,
                "508-510h": 1,
                "894-896h": 1,
                "1252-1254h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2026-02-12": 1,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-03-06": 1
              },
              "time_per_day": {
                "2025-10-30": 0.48375277777777775,
                "2025-11-17": 7.4388177777777775,
                "2025-11-24": 0.03655194444444444,
                "2025-12-29": 70.58798861111111,
                "2025-12-30": 23.430758333333333,
                "2026-02-12": 895.9329963888889,
                "2026-02-16": 1253.801281111111,
                "2026-02-24": 188.96877027777776,
                "2026-03-06": 508.57728555555553
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2025-11-17": 1,
                "2025-11-24": 1,
                "2025-12-29": 1,
                "2025-12-30": 1,
                "2026-02-12": 1,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-03-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 27.4,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "26-28h": 1,
                "30-32h": 1,
                "34-36h": 1,
                "44-46h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-18": 1,
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2025-12-17": 1,
                "2026-02-14": 1
              },
              "time_per_day": {
                "2025-11-18": 30.365600833333332,
                "2025-11-26": 26.860429166666666,
                "2025-11-28": 1.0514941666666666,
                "2025-12-17": 44.20554666666666,
                "2026-02-14": 34.50747944444445
              },
              "time_count_per_day": {
                "2025-11-18": 1,
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2025-12-17": 1,
                "2026-02-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_345": {
      "overall": {
        "avg_time_hours": 1367.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2734-2736h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-30": 1,
          "2026-02-18": 1
        },
        "time_per_day": {
          "2025-10-30": 1.3021802777777778,
          "2026-02-18": 2734.638932222222
        },
        "time_count_per_day": {
          "2025-10-30": 1,
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1367.97,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2734-2736h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-30": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-10-30": 1.3021802777777778,
            "2026-02-18": 2734.638932222222
          },
          "time_count_per_day": {
            "2025-10-30": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1367.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2734-2736h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-30": 1,
              "2026-02-18": 1
            },
            "time_per_day": {
              "2025-10-30": 1.3021802777777778,
              "2026-02-18": 2734.638932222222
            },
            "time_count_per_day": {
              "2025-10-30": 1,
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1367.97,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2734-2736h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-30": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-10-30": 1.3021802777777778,
                "2026-02-18": 2734.638932222222
              },
              "time_count_per_day": {
                "2025-10-30": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_382": {
      "overall": {
        "avg_time_hours": 292.06,
        "mode_time_hours": 313.0,
        "mode_frequency": 1,
        "time_distribution": {
          "270-272h": 1,
          "312-314h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2025-11-14": 1
        },
        "time_per_day": {
          "2025-11-12": 313.8674477777777,
          "2025-11-14": 270.2469736111111
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2025-11-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 292.06,
          "mode_time_hours": 313.0,
          "mode_frequency": 1,
          "time_distribution": {
            "270-272h": 1,
            "312-314h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-12": 313.8674477777777,
            "2025-11-14": 270.2469736111111
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 292.06,
            "mode_time_hours": 313.0,
            "mode_frequency": 1,
            "time_distribution": {
              "270-272h": 1,
              "312-314h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2025-11-14": 1
            },
            "time_per_day": {
              "2025-11-12": 313.8674477777777,
              "2025-11-14": 270.2469736111111
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2025-11-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 292.06,
              "mode_time_hours": 313.0,
              "mode_frequency": 1,
              "time_distribution": {
                "270-272h": 1,
                "312-314h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-12": 313.8674477777777,
                "2025-11-14": 270.2469736111111
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_384": {
      "overall": {
        "avg_time_hours": 9.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 3,
          "4-6h": 1,
          "8-10h": 1,
          "18-20h": 1,
          "20-22h": 2,
          "72-74h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2025-11-19": 1,
          "2025-11-27": 1,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-03-12": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-06-03": 1,
          "2026-06-05": 1,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2025-10-31": 18.858826388888886,
          "2025-11-19": 0.20935805555555553,
          "2025-11-27": 0.4174891666666667,
          "2026-02-10": 8.470398888888889,
          "2026-02-19": 0.41940555555555553,
          "2026-03-12": 20.691211111111112,
          "2026-04-20": 0.39643944444444446,
          "2026-04-23": 2.1247894444444446,
          "2026-05-05": 0.23143916666666667,
          "2026-05-15": 1.437380277777778,
          "2026-05-18": 3.017084722222222,
          "2026-05-20": 21.742966666666664,
          "2026-05-21": 5.108451111111111,
          "2026-06-03": 3.2237194444444444,
          "2026-06-05": 1.4092986111111112,
          "2026-06-08": 72.97508166666667
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2025-11-19": 1,
          "2025-11-27": 1,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-03-12": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-05-05": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-06-03": 1,
          "2026-06-05": 1,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 9.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 3,
            "4-6h": 1,
            "8-10h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "72-74h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2025-11-19": 1,
            "2025-11-27": 1,
            "2026-02-10": 1,
            "2026-02-19": 1,
            "2026-03-12": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-06-03": 1,
            "2026-06-05": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-10-31": 18.858826388888886,
            "2025-11-19": 0.20935805555555553,
            "2025-11-27": 0.4174891666666667,
            "2026-02-10": 8.470398888888889,
            "2026-02-19": 0.41940555555555553,
            "2026-03-12": 20.691211111111112,
            "2026-04-20": 0.39643944444444446,
            "2026-04-23": 2.1247894444444446,
            "2026-05-05": 0.23143916666666667,
            "2026-05-15": 1.437380277777778,
            "2026-05-18": 3.017084722222222,
            "2026-05-20": 21.742966666666664,
            "2026-05-21": 5.108451111111111,
            "2026-06-03": 3.2237194444444444,
            "2026-06-05": 1.4092986111111112,
            "2026-06-08": 72.97508166666667
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2025-11-19": 1,
            "2025-11-27": 1,
            "2026-02-10": 1,
            "2026-02-19": 1,
            "2026-03-12": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-05-05": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-06-03": 1,
            "2026-06-05": 1,
            "2026-06-08": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 3,
              "4-6h": 1,
              "8-10h": 1,
              "18-20h": 1,
              "20-22h": 2,
              "72-74h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2025-11-19": 1,
              "2025-11-27": 1,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-03-12": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-05-05": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-06-03": 1,
              "2026-06-05": 1,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2025-10-31": 18.858826388888886,
              "2025-11-19": 0.20935805555555553,
              "2025-11-27": 0.4174891666666667,
              "2026-02-10": 8.470398888888889,
              "2026-02-19": 0.41940555555555553,
              "2026-03-12": 20.691211111111112,
              "2026-04-20": 0.39643944444444446,
              "2026-04-23": 2.1247894444444446,
              "2026-05-05": 0.23143916666666667,
              "2026-05-15": 1.437380277777778,
              "2026-05-18": 3.017084722222222,
              "2026-05-20": 21.742966666666664,
              "2026-05-21": 5.108451111111111,
              "2026-06-03": 3.2237194444444444,
              "2026-06-05": 1.4092986111111112,
              "2026-06-08": 72.97508166666667
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2025-11-19": 1,
              "2025-11-27": 1,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-03-12": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-05-05": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-06-03": 1,
              "2026-06-05": 1,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 3,
                "4-6h": 1,
                "8-10h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "72-74h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2025-11-19": 1,
                "2025-11-27": 1,
                "2026-02-10": 1,
                "2026-02-19": 1,
                "2026-03-12": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-06-03": 1,
                "2026-06-05": 1,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2025-10-31": 18.858826388888886,
                "2025-11-19": 0.20935805555555553,
                "2025-11-27": 0.4174891666666667,
                "2026-02-10": 8.470398888888889,
                "2026-02-19": 0.41940555555555553,
                "2026-03-12": 20.691211111111112,
                "2026-04-20": 0.39643944444444446,
                "2026-04-23": 2.1247894444444446,
                "2026-05-05": 0.23143916666666667,
                "2026-05-15": 1.437380277777778,
                "2026-05-18": 3.017084722222222,
                "2026-05-20": 21.742966666666664,
                "2026-05-21": 5.108451111111111,
                "2026-06-03": 3.2237194444444444,
                "2026-06-05": 1.4092986111111112,
                "2026-06-08": 72.97508166666667
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2025-11-19": 1,
                "2025-11-27": 1,
                "2026-02-10": 1,
                "2026-02-19": 1,
                "2026-03-12": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-05-05": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-06-03": 1,
                "2026-06-05": 1,
                "2026-06-08": 2
              }
            }
          }
        }
      }
    },
    "cliente_69": {
      "overall": {
        "avg_time_hours": 2.46,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-10-31": 1
        },
        "time_per_day": {
          "2025-10-31": 2.4577744444444445
        },
        "time_count_per_day": {
          "2025-10-31": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.46,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-31": 1
          },
          "time_per_day": {
            "2025-10-31": 2.4577744444444445
          },
          "time_count_per_day": {
            "2025-10-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.46,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-10-31": 1
            },
            "time_per_day": {
              "2025-10-31": 2.4577744444444445
            },
            "time_count_per_day": {
              "2025-10-31": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.46,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-31": 1
              },
              "time_per_day": {
                "2025-10-31": 2.4577744444444445
              },
              "time_count_per_day": {
                "2025-10-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_387": {
      "overall": {
        "avg_time_hours": 28.86,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "8-10h": 1,
          "44-46h": 1,
          "90-92h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2026-02-05": 1,
          "2026-05-22": 1,
          "2026-05-25": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-10-31": 0.6922163888888888,
          "2026-02-05": 8.419693055555555,
          "2026-05-22": 0.5386813888888888,
          "2026-05-25": 44.10699416666667,
          "2026-05-26": 90.55074472222222
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2026-02-05": 1,
          "2026-05-22": 1,
          "2026-05-25": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 4.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-10-31": 1,
            "2026-02-05": 1
          },
          "time_per_day": {
            "2025-10-31": 0.6922163888888888,
            "2026-02-05": 8.419693055555555
          },
          "time_count_per_day": {
            "2025-10-31": 1,
            "2026-02-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 45.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "44-46h": 1,
            "90-92h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-22": 0.5386813888888888,
            "2026-05-25": 44.10699416666667,
            "2026-05-26": 90.55074472222222
          },
          "time_count_per_day": {
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.86,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "8-10h": 1,
              "44-46h": 1,
              "90-92h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2026-02-05": 1,
              "2026-05-22": 1,
              "2026-05-25": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-10-31": 0.6922163888888888,
              "2026-02-05": 8.419693055555555,
              "2026-05-22": 0.5386813888888888,
              "2026-05-25": 44.10699416666667,
              "2026-05-26": 90.55074472222222
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2026-02-05": 1,
              "2026-05-22": 1,
              "2026-05-25": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 4.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-10-31": 1,
                "2026-02-05": 1
              },
              "time_per_day": {
                "2025-10-31": 0.6922163888888888,
                "2026-02-05": 8.419693055555555
              },
              "time_count_per_day": {
                "2025-10-31": 1,
                "2026-02-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 45.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "44-46h": 1,
                "90-92h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-22": 0.5386813888888888,
                "2026-05-25": 44.10699416666667,
                "2026-05-26": 90.55074472222222
              },
              "time_count_per_day": {
                "2026-05-22": 1,
                "2026-05-25": 1,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_388": {
      "overall": {
        "avg_time_hours": 0.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-10-31": 1,
          "2026-02-05": 1
        },
        "time_per_day": {
          "2025-10-31": 0.030245277777777777,
          "2026-02-05": 1.1771744444444445
        },
        "time_count_per_day": {
          "2025-10-31": 1,
          "2026-02-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-10-31": 1
          },
          "time_per_day": {
            "2025-10-31": 0.030245277777777777
          },
          "time_count_per_day": {
            "2025-10-31": 1
          }
        },
        "P3": {
          "avg_time_hours": 1.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 1.1771744444444445
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-10-31": 1,
              "2026-02-05": 1
            },
            "time_per_day": {
              "2025-10-31": 0.030245277777777777,
              "2026-02-05": 1.1771744444444445
            },
            "time_count_per_day": {
              "2025-10-31": 1,
              "2026-02-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-10-31": 1
              },
              "time_per_day": {
                "2025-10-31": 0.030245277777777777
              },
              "time_count_per_day": {
                "2025-10-31": 1
              }
            },
            "P3": {
              "avg_time_hours": 1.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 1.1771744444444445
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_389": {
      "overall": {
        "avg_time_hours": 985.04,
        "mode_time_hours": 985.0,
        "mode_frequency": 1,
        "time_distribution": {
          "984-986h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 985.0438444444444
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 985.04,
          "mode_time_hours": 985.0,
          "mode_frequency": 1,
          "time_distribution": {
            "984-986h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 985.0438444444444
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 985.04,
            "mode_time_hours": 985.0,
            "mode_frequency": 1,
            "time_distribution": {
              "984-986h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 985.0438444444444
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 985.04,
              "mode_time_hours": 985.0,
              "mode_frequency": 1,
              "time_distribution": {
                "984-986h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 985.0438444444444
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_207": {
      "overall": {
        "avg_time_hours": 74.63,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "54-56h": 1,
          "56-58h": 1,
          "148-150h": 1,
          "330-332h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-06": 1,
          "2025-11-20": 1,
          "2025-12-04": 1,
          "2026-02-04": 1,
          "2026-02-13": 3,
          "2026-03-11": 1
        },
        "time_per_day": {
          "2025-11-06": 148.11961916666667,
          "2025-11-20": 0.07797972222222221,
          "2025-12-04": 331.799555,
          "2026-02-04": 0.9291058333333333,
          "2026-02-13": 114.27941666666666,
          "2026-03-11": 1.7978591666666666
        },
        "time_count_per_day": {
          "2025-11-06": 1,
          "2025-11-20": 1,
          "2025-12-04": 1,
          "2026-02-04": 1,
          "2026-02-13": 3,
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 331.8,
          "mode_time_hours": 331.0,
          "mode_frequency": 1,
          "time_distribution": {
            "330-332h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-12-04": 331.799555
          },
          "time_count_per_day": {
            "2025-12-04": 1
          }
        },
        "P2": {
          "avg_time_hours": 37.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "54-56h": 1,
            "56-58h": 1,
            "148-150h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-20": 1,
            "2026-02-04": 1,
            "2026-02-13": 3,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-11-06": 148.11961916666667,
            "2025-11-20": 0.07797972222222221,
            "2026-02-04": 0.9291058333333333,
            "2026-02-13": 114.27941666666666,
            "2026-03-11": 1.7978591666666666
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-20": 1,
            "2026-02-04": 1,
            "2026-02-13": 3,
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 74.63,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "54-56h": 1,
              "56-58h": 1,
              "148-150h": 1,
              "330-332h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-11-06": 1,
              "2025-11-20": 1,
              "2025-12-04": 1,
              "2026-02-04": 1,
              "2026-02-13": 3,
              "2026-03-11": 1
            },
            "time_per_day": {
              "2025-11-06": 148.11961916666667,
              "2025-11-20": 0.07797972222222221,
              "2025-12-04": 331.799555,
              "2026-02-04": 0.9291058333333333,
              "2026-02-13": 114.27941666666666,
              "2026-03-11": 1.7978591666666666
            },
            "time_count_per_day": {
              "2025-11-06": 1,
              "2025-11-20": 1,
              "2025-12-04": 1,
              "2026-02-04": 1,
              "2026-02-13": 3,
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 331.8,
              "mode_time_hours": 331.0,
              "mode_frequency": 1,
              "time_distribution": {
                "330-332h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-12-04": 331.799555
              },
              "time_count_per_day": {
                "2025-12-04": 1
              }
            },
            "P2": {
              "avg_time_hours": 37.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "54-56h": 1,
                "56-58h": 1,
                "148-150h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-20": 1,
                "2026-02-04": 1,
                "2026-02-13": 3,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2025-11-06": 148.11961916666667,
                "2025-11-20": 0.07797972222222221,
                "2026-02-04": 0.9291058333333333,
                "2026-02-13": 114.27941666666666,
                "2026-03-11": 1.7978591666666666
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-20": 1,
                "2026-02-04": 1,
                "2026-02-13": 3,
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_391": {
      "overall": {
        "avg_time_hours": 94.12,
        "mode_time_hours": 79.0,
        "mode_frequency": 2,
        "time_distribution": {
          "54-56h": 1,
          "78-80h": 2,
          "164-166h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-04": 2,
          "2025-12-29": 1,
          "2026-01-06": 1
        },
        "time_per_day": {
          "2025-11-04": 156.9659227777778,
          "2025-12-29": 55.253125555555556,
          "2026-01-06": 164.2557588888889
        },
        "time_count_per_day": {
          "2025-11-04": 2,
          "2025-12-29": 1,
          "2026-01-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 94.12,
          "mode_time_hours": 79.0,
          "mode_frequency": 2,
          "time_distribution": {
            "54-56h": 1,
            "78-80h": 2,
            "164-166h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-04": 2,
            "2025-12-29": 1,
            "2026-01-06": 1
          },
          "time_per_day": {
            "2025-11-04": 156.9659227777778,
            "2025-12-29": 55.253125555555556,
            "2026-01-06": 164.2557588888889
          },
          "time_count_per_day": {
            "2025-11-04": 2,
            "2025-12-29": 1,
            "2026-01-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 94.12,
            "mode_time_hours": 79.0,
            "mode_frequency": 2,
            "time_distribution": {
              "54-56h": 1,
              "78-80h": 2,
              "164-166h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-04": 2,
              "2025-12-29": 1,
              "2026-01-06": 1
            },
            "time_per_day": {
              "2025-11-04": 156.9659227777778,
              "2025-12-29": 55.253125555555556,
              "2026-01-06": 164.2557588888889
            },
            "time_count_per_day": {
              "2025-11-04": 2,
              "2025-12-29": 1,
              "2026-01-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 94.12,
              "mode_time_hours": 79.0,
              "mode_frequency": 2,
              "time_distribution": {
                "54-56h": 1,
                "78-80h": 2,
                "164-166h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-04": 2,
                "2025-12-29": 1,
                "2026-01-06": 1
              },
              "time_per_day": {
                "2025-11-04": 156.9659227777778,
                "2025-12-29": 55.253125555555556,
                "2026-01-06": 164.2557588888889
              },
              "time_count_per_day": {
                "2025-11-04": 2,
                "2025-12-29": 1,
                "2026-01-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_393": {
      "overall": {
        "avg_time_hours": 160.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 2,
          "4-6h": 1,
          "6-8h": 1,
          "10-12h": 3,
          "14-16h": 2,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 2,
          "26-28h": 1,
          "30-32h": 1,
          "34-36h": 1,
          "40-42h": 2,
          "42-44h": 1,
          "44-46h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "56-58h": 3,
          "58-60h": 1,
          "64-66h": 1,
          "66-68h": 1,
          "72-74h": 1,
          "78-80h": 1,
          "82-84h": 1,
          "92-94h": 1,
          "102-104h": 1,
          "114-116h": 1,
          "118-120h": 2,
          "122-124h": 1,
          "136-138h": 1,
          "142-144h": 1,
          "146-148h": 1,
          "154-156h": 1,
          "162-164h": 1,
          "166-168h": 1,
          "190-192h": 1,
          "204-206h": 1,
          "220-222h": 1,
          "228-230h": 1,
          "292-294h": 1,
          "304-306h": 1,
          "306-308h": 1,
          "338-340h": 2,
          "340-342h": 1,
          "346-348h": 1,
          "364-366h": 1,
          "386-388h": 1,
          "416-418h": 1,
          "476-478h": 1,
          "532-534h": 1,
          "536-538h": 1,
          "566-568h": 1,
          "672-674h": 1,
          "682-684h": 1,
          "766-768h": 1,
          "848-850h": 1
        },
        "tickets_count": 81,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2025-11-24": 1,
          "2025-12-19": 1,
          "2025-12-29": 1,
          "2026-01-02": 2,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-16": 4,
          "2026-01-19": 2,
          "2026-01-20": 2,
          "2026-01-21": 1,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-11": 2,
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-02-18": 2,
          "2026-02-19": 2,
          "2026-02-20": 1,
          "2026-03-10": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-03-20": 2,
          "2026-03-26": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 2,
          "2026-04-08": 2,
          "2026-04-09": 4,
          "2026-04-10": 5,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-17": 2,
          "2026-04-21": 2,
          "2026-04-22": 1,
          "2026-04-26": 2,
          "2026-04-27": 1,
          "2026-05-05": 2,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-18": 2,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-01": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-14": 21.684856666666665,
          "2025-11-24": 536.7875486111111,
          "2025-12-19": 417.16237916666665,
          "2025-12-29": 147.29193305555557,
          "2026-01-02": 113.18687277777778,
          "2026-01-05": 162.37385361111112,
          "2026-01-06": 0.6051113888888888,
          "2026-01-08": 0.3916077777777778,
          "2026-01-14": 11.377314722222222,
          "2026-01-16": 440.66709888888886,
          "2026-01-19": 108.28831027777778,
          "2026-01-20": 241.6314036111111,
          "2026-01-21": 143.98037472222222,
          "2026-01-30": 10.100103333333335,
          "2026-01-31": 17.413118333333333,
          "2026-02-03": 190.40246638888888,
          "2026-02-05": 155.0398236111111,
          "2026-02-09": 122.5473638888889,
          "2026-02-10": 385.9778669444445,
          "2026-02-11": 50.31855138888889,
          "2026-02-14": 57.28225472222222,
          "2026-02-16": 67.70506583333334,
          "2026-02-18": 340.1168386111111,
          "2026-02-19": 478.0355736111111,
          "2026-02-20": 10.136367777777778,
          "2026-03-10": 64.52668750000001,
          "2026-03-17": 30.466395,
          "2026-03-19": 41.362345833333336,
          "2026-03-20": 571.1712580555554,
          "2026-03-26": 14.712465000000002,
          "2026-03-30": 423.57817361111114,
          "2026-03-31": 0.0693275,
          "2026-04-06": 3.1509605555555558,
          "2026-04-07": 4.7835680555555555,
          "2026-04-08": 63.382645555555555,
          "2026-04-09": 202.40694888888888,
          "2026-04-10": 1602.1856202777778,
          "2026-04-11": 18.9226825,
          "2026-04-13": 73.17409805555556,
          "2026-04-17": 674.0826975,
          "2026-04-21": 566.1962222222222,
          "2026-04-22": 0.8236622222222223,
          "2026-04-26": 1153.7789744444444,
          "2026-05-05": 886.8206533333332,
          "2026-05-08": 34.88556472222222,
          "2026-05-11": 0.054530277777777775,
          "2026-05-14": 2.712738888888889,
          "2026-05-18": 115.8146475,
          "2026-05-21": 306.75999583333333,
          "2026-05-26": 22.639452777777777,
          "2026-05-27": 46.24433805555555,
          "2026-06-01": 848.6518102777778,
          "2026-06-08": 167.70976916666666
        },
        "time_count_per_day": {
          "2025-11-14": 1,
          "2025-11-24": 1,
          "2025-12-19": 1,
          "2025-12-29": 1,
          "2026-01-02": 2,
          "2026-01-05": 1,
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-14": 1,
          "2026-01-16": 4,
          "2026-01-19": 2,
          "2026-01-20": 2,
          "2026-01-21": 1,
          "2026-01-30": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-11": 2,
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-02-18": 2,
          "2026-02-19": 2,
          "2026-02-20": 1,
          "2026-03-10": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-03-20": 2,
          "2026-03-26": 1,
          "2026-03-30": 2,
          "2026-03-31": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 2,
          "2026-04-09": 4,
          "2026-04-10": 5,
          "2026-04-11": 1,
          "2026-04-13": 1,
          "2026-04-17": 2,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-26": 2,
          "2026-05-05": 2,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-01": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 422.39,
          "mode_time_hours": 567.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "566-568h": 1,
            "682-684h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-11": 1,
            "2026-04-21": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-04-11": 18.9226825,
            "2026-04-21": 566.1962222222222,
            "2026-05-05": 682.0398291666666
          },
          "time_count_per_day": {
            "2026-04-11": 1,
            "2026-04-21": 1,
            "2026-05-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 144.71,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 2,
            "4-6h": 1,
            "6-8h": 1,
            "10-12h": 3,
            "14-16h": 2,
            "16-18h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "34-36h": 1,
            "40-42h": 2,
            "44-46h": 1,
            "46-48h": 1,
            "48-50h": 2,
            "64-66h": 1,
            "72-74h": 1,
            "78-80h": 1,
            "82-84h": 1,
            "102-104h": 1,
            "114-116h": 1,
            "118-120h": 1,
            "136-138h": 1,
            "142-144h": 1,
            "146-148h": 1,
            "154-156h": 1,
            "162-164h": 1,
            "166-168h": 1,
            "190-192h": 1,
            "204-206h": 1,
            "292-294h": 1,
            "304-306h": 1,
            "306-308h": 1,
            "338-340h": 2,
            "340-342h": 1,
            "346-348h": 1,
            "364-366h": 1,
            "386-388h": 1,
            "532-534h": 1,
            "536-538h": 1,
            "672-674h": 1,
            "766-768h": 1
          },
          "tickets_count": 57,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-16": 3,
            "2026-01-19": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-03-10": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 4,
            "2026-04-10": 5,
            "2026-04-13": 1,
            "2026-04-17": 2,
            "2026-04-21": 1,
            "2026-04-22": 1,
            "2026-04-26": 2,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-18": 2,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-24": 536.7875486111111,
            "2025-12-29": 147.29193305555557,
            "2026-01-05": 162.37385361111112,
            "2026-01-06": 0.6051113888888888,
            "2026-01-08": 0.3916077777777778,
            "2026-01-14": 11.377314722222222,
            "2026-01-16": 398.44479916666666,
            "2026-01-19": 48.86519805555555,
            "2026-01-20": 241.6314036111111,
            "2026-01-21": 143.98037472222222,
            "2026-01-30": 10.100103333333335,
            "2026-01-31": 17.413118333333333,
            "2026-02-03": 190.40246638888888,
            "2026-02-05": 155.0398236111111,
            "2026-02-10": 293.87288805555556,
            "2026-02-11": 24.91519388888889,
            "2026-02-19": 0.15325444444444444,
            "2026-02-20": 10.136367777777778,
            "2026-03-10": 64.52668750000001,
            "2026-03-19": 41.362345833333336,
            "2026-03-20": 341.4585016666666,
            "2026-03-26": 14.712465000000002,
            "2026-03-30": 423.57817361111114,
            "2026-04-06": 3.1509605555555558,
            "2026-04-07": 4.7835680555555555,
            "2026-04-08": 63.382645555555555,
            "2026-04-09": 202.40694888888888,
            "2026-04-10": 1602.1856202777778,
            "2026-04-13": 73.17409805555556,
            "2026-04-17": 674.0826975,
            "2026-04-22": 0.8236622222222223,
            "2026-04-26": 1153.7789744444444,
            "2026-05-05": 204.78082416666666,
            "2026-05-08": 34.88556472222222,
            "2026-05-11": 0.054530277777777775,
            "2026-05-14": 2.712738888888889,
            "2026-05-18": 115.8146475,
            "2026-05-21": 306.75999583333333,
            "2026-05-26": 22.639452777777777,
            "2026-05-27": 46.24433805555555,
            "2026-06-08": 167.70976916666666
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-29": 1,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-08": 1,
            "2026-01-14": 1,
            "2026-01-16": 3,
            "2026-01-19": 1,
            "2026-01-20": 2,
            "2026-01-21": 1,
            "2026-01-30": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-03-10": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-09": 4,
            "2026-04-10": 5,
            "2026-04-13": 1,
            "2026-04-17": 2,
            "2026-04-22": 1,
            "2026-04-26": 2,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 113.49,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "20-22h": 1,
            "24-26h": 1,
            "42-44h": 1,
            "56-58h": 1,
            "58-60h": 1,
            "66-68h": 1,
            "92-94h": 1,
            "118-120h": 1,
            "122-124h": 1,
            "220-222h": 1,
            "228-230h": 1,
            "416-418h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-12-19": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-14": 1,
            "2026-02-16": 1,
            "2026-02-18": 2,
            "2026-03-20": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2025-11-14": 21.684856666666665,
            "2025-12-19": 417.16237916666665,
            "2026-01-16": 42.222299722222225,
            "2026-01-19": 59.42311222222222,
            "2026-02-09": 122.5473638888889,
            "2026-02-10": 92.1049788888889,
            "2026-02-11": 25.4033575,
            "2026-02-14": 57.28225472222222,
            "2026-02-16": 67.70506583333334,
            "2026-02-18": 340.1168386111111,
            "2026-03-20": 229.71275638888886,
            "2026-03-31": 0.0693275
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2025-12-19": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-14": 1,
            "2026-02-16": 1,
            "2026-02-18": 2,
            "2026-03-20": 1,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 439.56,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1,
            "848-850h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-04-07": 1,
            "2026-04-27": 1,
            "2026-05-06": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-03-17": 30.466395,
            "2026-06-01": 848.6518102777778
          },
          "time_count_per_day": {
            "2026-03-17": 1,
            "2026-06-01": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 197.02,
          "mode_time_hours": 57.0,
          "mode_frequency": 2,
          "time_distribution": {
            "56-58h": 2,
            "476-478h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-02": 2,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-02": 113.18687277777778,
            "2026-02-19": 477.88231916666666
          },
          "time_count_per_day": {
            "2026-01-02": 2,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 160.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 2,
              "4-6h": 1,
              "6-8h": 1,
              "10-12h": 3,
              "14-16h": 2,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 2,
              "26-28h": 1,
              "30-32h": 1,
              "34-36h": 1,
              "40-42h": 2,
              "42-44h": 1,
              "44-46h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "56-58h": 3,
              "58-60h": 1,
              "64-66h": 1,
              "66-68h": 1,
              "72-74h": 1,
              "78-80h": 1,
              "82-84h": 1,
              "92-94h": 1,
              "102-104h": 1,
              "114-116h": 1,
              "118-120h": 2,
              "122-124h": 1,
              "136-138h": 1,
              "142-144h": 1,
              "146-148h": 1,
              "154-156h": 1,
              "162-164h": 1,
              "166-168h": 1,
              "190-192h": 1,
              "204-206h": 1,
              "220-222h": 1,
              "228-230h": 1,
              "292-294h": 1,
              "304-306h": 1,
              "306-308h": 1,
              "338-340h": 2,
              "340-342h": 1,
              "346-348h": 1,
              "364-366h": 1,
              "386-388h": 1,
              "416-418h": 1,
              "476-478h": 1,
              "532-534h": 1,
              "536-538h": 1,
              "566-568h": 1,
              "672-674h": 1,
              "682-684h": 1,
              "766-768h": 1,
              "848-850h": 1
            },
            "tickets_count": 76,
            "tickets_per_day": {
              "2025-11-14": 1,
              "2025-11-24": 1,
              "2025-12-19": 1,
              "2025-12-29": 1,
              "2026-01-02": 2,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-16": 4,
              "2026-01-19": 2,
              "2026-01-20": 2,
              "2026-01-21": 1,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-11": 2,
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-02-18": 2,
              "2026-02-19": 2,
              "2026-02-20": 1,
              "2026-03-10": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-03-20": 2,
              "2026-03-26": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 4,
              "2026-04-10": 5,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-17": 2,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-26": 2,
              "2026-05-05": 2,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2025-11-14": 21.684856666666665,
              "2025-11-24": 536.7875486111111,
              "2025-12-19": 417.16237916666665,
              "2025-12-29": 147.29193305555557,
              "2026-01-02": 113.18687277777778,
              "2026-01-05": 162.37385361111112,
              "2026-01-06": 0.6051113888888888,
              "2026-01-08": 0.3916077777777778,
              "2026-01-14": 11.377314722222222,
              "2026-01-16": 440.66709888888886,
              "2026-01-19": 108.28831027777778,
              "2026-01-20": 241.6314036111111,
              "2026-01-21": 143.98037472222222,
              "2026-01-30": 10.100103333333335,
              "2026-01-31": 17.413118333333333,
              "2026-02-03": 190.40246638888888,
              "2026-02-05": 155.0398236111111,
              "2026-02-09": 122.5473638888889,
              "2026-02-10": 385.9778669444445,
              "2026-02-11": 50.31855138888889,
              "2026-02-14": 57.28225472222222,
              "2026-02-16": 67.70506583333334,
              "2026-02-18": 340.1168386111111,
              "2026-02-19": 478.0355736111111,
              "2026-02-20": 10.136367777777778,
              "2026-03-10": 64.52668750000001,
              "2026-03-17": 30.466395,
              "2026-03-19": 41.362345833333336,
              "2026-03-20": 571.1712580555554,
              "2026-03-26": 14.712465000000002,
              "2026-03-30": 423.57817361111114,
              "2026-03-31": 0.0693275,
              "2026-04-06": 3.1509605555555558,
              "2026-04-07": 4.7835680555555555,
              "2026-04-08": 63.382645555555555,
              "2026-04-09": 202.40694888888888,
              "2026-04-10": 1602.1856202777778,
              "2026-04-11": 18.9226825,
              "2026-04-13": 73.17409805555556,
              "2026-04-17": 674.0826975,
              "2026-04-21": 566.1962222222222,
              "2026-04-22": 0.8236622222222223,
              "2026-04-26": 1153.7789744444444,
              "2026-05-05": 886.8206533333332,
              "2026-05-08": 34.88556472222222,
              "2026-05-11": 0.054530277777777775,
              "2026-05-14": 2.712738888888889,
              "2026-05-18": 115.8146475,
              "2026-05-21": 306.75999583333333,
              "2026-05-26": 22.639452777777777,
              "2026-05-27": 46.24433805555555,
              "2026-06-01": 848.6518102777778,
              "2026-06-08": 167.70976916666666
            },
            "time_count_per_day": {
              "2025-11-14": 1,
              "2025-11-24": 1,
              "2025-12-19": 1,
              "2025-12-29": 1,
              "2026-01-02": 2,
              "2026-01-05": 1,
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-14": 1,
              "2026-01-16": 4,
              "2026-01-19": 2,
              "2026-01-20": 2,
              "2026-01-21": 1,
              "2026-01-30": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-11": 2,
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-02-18": 2,
              "2026-02-19": 2,
              "2026-02-20": 1,
              "2026-03-10": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-03-20": 2,
              "2026-03-26": 1,
              "2026-03-30": 2,
              "2026-03-31": 1,
              "2026-04-06": 1,
              "2026-04-07": 1,
              "2026-04-08": 2,
              "2026-04-09": 4,
              "2026-04-10": 5,
              "2026-04-11": 1,
              "2026-04-13": 1,
              "2026-04-17": 2,
              "2026-04-21": 1,
              "2026-04-22": 1,
              "2026-04-26": 2,
              "2026-05-05": 2,
              "2026-05-08": 1,
              "2026-05-11": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-21": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 422.39,
              "mode_time_hours": 567.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "566-568h": 1,
                "682-684h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-11": 1,
                "2026-04-21": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-04-11": 18.9226825,
                "2026-04-21": 566.1962222222222,
                "2026-05-05": 682.0398291666666
              },
              "time_count_per_day": {
                "2026-04-11": 1,
                "2026-04-21": 1,
                "2026-05-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 144.71,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 2,
                "4-6h": 1,
                "6-8h": 1,
                "10-12h": 3,
                "14-16h": 2,
                "16-18h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "34-36h": 1,
                "40-42h": 2,
                "44-46h": 1,
                "46-48h": 1,
                "48-50h": 2,
                "64-66h": 1,
                "72-74h": 1,
                "78-80h": 1,
                "82-84h": 1,
                "102-104h": 1,
                "114-116h": 1,
                "118-120h": 1,
                "136-138h": 1,
                "142-144h": 1,
                "146-148h": 1,
                "154-156h": 1,
                "162-164h": 1,
                "166-168h": 1,
                "190-192h": 1,
                "204-206h": 1,
                "292-294h": 1,
                "304-306h": 1,
                "306-308h": 1,
                "338-340h": 2,
                "340-342h": 1,
                "346-348h": 1,
                "364-366h": 1,
                "386-388h": 1,
                "532-534h": 1,
                "536-538h": 1,
                "672-674h": 1,
                "766-768h": 1
              },
              "tickets_count": 55,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-16": 3,
                "2026-01-19": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-03-10": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 4,
                "2026-04-10": 5,
                "2026-04-13": 1,
                "2026-04-17": 2,
                "2026-04-22": 1,
                "2026-04-26": 2,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2025-11-24": 536.7875486111111,
                "2025-12-29": 147.29193305555557,
                "2026-01-05": 162.37385361111112,
                "2026-01-06": 0.6051113888888888,
                "2026-01-08": 0.3916077777777778,
                "2026-01-14": 11.377314722222222,
                "2026-01-16": 398.44479916666666,
                "2026-01-19": 48.86519805555555,
                "2026-01-20": 241.6314036111111,
                "2026-01-21": 143.98037472222222,
                "2026-01-30": 10.100103333333335,
                "2026-01-31": 17.413118333333333,
                "2026-02-03": 190.40246638888888,
                "2026-02-05": 155.0398236111111,
                "2026-02-10": 293.87288805555556,
                "2026-02-11": 24.91519388888889,
                "2026-02-19": 0.15325444444444444,
                "2026-02-20": 10.136367777777778,
                "2026-03-10": 64.52668750000001,
                "2026-03-19": 41.362345833333336,
                "2026-03-20": 341.4585016666666,
                "2026-03-26": 14.712465000000002,
                "2026-03-30": 423.57817361111114,
                "2026-04-06": 3.1509605555555558,
                "2026-04-07": 4.7835680555555555,
                "2026-04-08": 63.382645555555555,
                "2026-04-09": 202.40694888888888,
                "2026-04-10": 1602.1856202777778,
                "2026-04-13": 73.17409805555556,
                "2026-04-17": 674.0826975,
                "2026-04-22": 0.8236622222222223,
                "2026-04-26": 1153.7789744444444,
                "2026-05-05": 204.78082416666666,
                "2026-05-08": 34.88556472222222,
                "2026-05-11": 0.054530277777777775,
                "2026-05-14": 2.712738888888889,
                "2026-05-18": 115.8146475,
                "2026-05-21": 306.75999583333333,
                "2026-05-26": 22.639452777777777,
                "2026-05-27": 46.24433805555555,
                "2026-06-08": 167.70976916666666
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-29": 1,
                "2026-01-05": 1,
                "2026-01-06": 1,
                "2026-01-08": 1,
                "2026-01-14": 1,
                "2026-01-16": 3,
                "2026-01-19": 1,
                "2026-01-20": 2,
                "2026-01-21": 1,
                "2026-01-30": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-19": 1,
                "2026-02-20": 1,
                "2026-03-10": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-30": 2,
                "2026-04-06": 1,
                "2026-04-07": 1,
                "2026-04-08": 2,
                "2026-04-09": 4,
                "2026-04-10": 5,
                "2026-04-13": 1,
                "2026-04-17": 2,
                "2026-04-22": 1,
                "2026-04-26": 2,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-11": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 113.49,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "20-22h": 1,
                "24-26h": 1,
                "42-44h": 1,
                "56-58h": 1,
                "58-60h": 1,
                "66-68h": 1,
                "92-94h": 1,
                "118-120h": 1,
                "122-124h": 1,
                "220-222h": 1,
                "228-230h": 1,
                "416-418h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-12-19": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-14": 1,
                "2026-02-16": 1,
                "2026-02-18": 2,
                "2026-03-20": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2025-11-14": 21.684856666666665,
                "2025-12-19": 417.16237916666665,
                "2026-01-16": 42.222299722222225,
                "2026-01-19": 59.42311222222222,
                "2026-02-09": 122.5473638888889,
                "2026-02-10": 92.1049788888889,
                "2026-02-11": 25.4033575,
                "2026-02-14": 57.28225472222222,
                "2026-02-16": 67.70506583333334,
                "2026-02-18": 340.1168386111111,
                "2026-03-20": 229.71275638888886,
                "2026-03-31": 0.0693275
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2025-12-19": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-14": 1,
                "2026-02-16": 1,
                "2026-02-18": 2,
                "2026-03-20": 1,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 439.56,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1,
                "848-850h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-17": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-03-17": 30.466395,
                "2026-06-01": 848.6518102777778
              },
              "time_count_per_day": {
                "2026-03-17": 1,
                "2026-06-01": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 197.02,
              "mode_time_hours": 57.0,
              "mode_frequency": 2,
              "time_distribution": {
                "56-58h": 2,
                "476-478h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-02": 2,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-02": 113.18687277777778,
                "2026-02-19": 477.88231916666666
              },
              "time_count_per_day": {
                "2026-01-02": 2,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-04-27": 1,
              "2026-05-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-04-27": 1,
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_394": {
      "overall": {
        "avg_time_hours": 431.11,
        "mode_time_hours": 431.0,
        "mode_frequency": 1,
        "time_distribution": {
          "430-432h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-20": 1
        },
        "time_per_day": {
          "2025-11-20": 431.11313416666667
        },
        "time_count_per_day": {
          "2025-11-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 431.11,
          "mode_time_hours": 431.0,
          "mode_frequency": 1,
          "time_distribution": {
            "430-432h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-20": 1
          },
          "time_per_day": {
            "2025-11-20": 431.11313416666667
          },
          "time_count_per_day": {
            "2025-11-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 431.11,
            "mode_time_hours": 431.0,
            "mode_frequency": 1,
            "time_distribution": {
              "430-432h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-20": 1
            },
            "time_per_day": {
              "2025-11-20": 431.11313416666667
            },
            "time_count_per_day": {
              "2025-11-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 431.11,
              "mode_time_hours": 431.0,
              "mode_frequency": 1,
              "time_distribution": {
                "430-432h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-20": 1
              },
              "time_per_day": {
                "2025-11-20": 431.11313416666667
              },
              "time_count_per_day": {
                "2025-11-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_397": {
      "overall": {
        "avg_time_hours": 17.05,
        "mode_time_hours": 57.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "6-8h": 1,
          "56-58h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-05": 1,
          "2025-12-11": 1,
          "2026-01-12": 1,
          "2026-01-13": 1
        },
        "time_per_day": {
          "2025-11-05": 56.894191944444444,
          "2025-12-11": 2.930281388888889,
          "2026-01-12": 1.7704352777777779,
          "2026-01-13": 6.615866388888889
        },
        "time_count_per_day": {
          "2025-11-05": 1,
          "2025-12-11": 1,
          "2026-01-12": 1,
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 29.33,
          "mode_time_hours": 57.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "56-58h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2026-01-12": 1
          },
          "time_per_day": {
            "2025-11-05": 56.894191944444444,
            "2026-01-12": 1.7704352777777779
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2026-01-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 4.77,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-11": 1,
            "2026-01-13": 1
          },
          "time_per_day": {
            "2025-12-11": 2.930281388888889,
            "2026-01-13": 6.615866388888889
          },
          "time_count_per_day": {
            "2025-12-11": 1,
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.05,
            "mode_time_hours": 57.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "6-8h": 1,
              "56-58h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-05": 1,
              "2025-12-11": 1,
              "2026-01-12": 1,
              "2026-01-13": 1
            },
            "time_per_day": {
              "2025-11-05": 56.894191944444444,
              "2025-12-11": 2.930281388888889,
              "2026-01-12": 1.7704352777777779,
              "2026-01-13": 6.615866388888889
            },
            "time_count_per_day": {
              "2025-11-05": 1,
              "2025-12-11": 1,
              "2026-01-12": 1,
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 29.33,
              "mode_time_hours": 57.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "56-58h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2026-01-12": 1
              },
              "time_per_day": {
                "2025-11-05": 56.894191944444444,
                "2026-01-12": 1.7704352777777779
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2026-01-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 4.77,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-11": 1,
                "2026-01-13": 1
              },
              "time_per_day": {
                "2025-12-11": 2.930281388888889,
                "2026-01-13": 6.615866388888889
              },
              "time_count_per_day": {
                "2025-12-11": 1,
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_398": {
      "overall": {
        "avg_time_hours": 165.26,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1,
          "18-20h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "48-50h": 1,
          "140-142h": 1,
          "882-884h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-11-04": 1,
          "2025-12-04": 1,
          "2025-12-12": 1,
          "2025-12-19": 1,
          "2026-01-13": 1,
          "2026-01-23": 1,
          "2026-02-03": 1
        },
        "time_per_day": {
          "2025-11-04": 26.887950555555555,
          "2025-12-04": 141.10372583333333,
          "2025-12-12": 24.35603,
          "2025-12-19": 48.584654722222226,
          "2026-01-13": 13.646143333333335,
          "2026-01-23": 882.3115405555556,
          "2026-02-03": 19.94816361111111
        },
        "time_count_per_day": {
          "2025-11-04": 1,
          "2025-12-04": 1,
          "2025-12-12": 1,
          "2025-12-19": 1,
          "2026-01-13": 1,
          "2026-01-23": 1,
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 24.36,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-12": 1
          },
          "time_per_day": {
            "2025-12-12": 24.35603
          },
          "time_count_per_day": {
            "2025-12-12": 1
          }
        },
        "P2": {
          "avg_time_hours": 62.65,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "26-28h": 1,
            "140-142h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-12-04": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-11-04": 26.887950555555555,
            "2025-12-04": 141.10372583333333,
            "2026-02-03": 19.94816361111111
          },
          "time_count_per_day": {
            "2025-11-04": 1,
            "2025-12-04": 1,
            "2026-02-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 314.85,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "48-50h": 1,
            "882-884h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-01-13": 1,
            "2026-01-23": 1
          },
          "time_per_day": {
            "2025-12-19": 48.584654722222226,
            "2026-01-13": 13.646143333333335,
            "2026-01-23": 882.3115405555556
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-01-13": 1,
            "2026-01-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.26,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1,
              "18-20h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "48-50h": 1,
              "140-142h": 1,
              "882-884h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-04": 1,
              "2025-12-04": 1,
              "2025-12-12": 1,
              "2025-12-19": 1,
              "2026-01-13": 1,
              "2026-01-23": 1,
              "2026-02-03": 1
            },
            "time_per_day": {
              "2025-11-04": 26.887950555555555,
              "2025-12-04": 141.10372583333333,
              "2025-12-12": 24.35603,
              "2025-12-19": 48.584654722222226,
              "2026-01-13": 13.646143333333335,
              "2026-01-23": 882.3115405555556,
              "2026-02-03": 19.94816361111111
            },
            "time_count_per_day": {
              "2025-11-04": 1,
              "2025-12-04": 1,
              "2025-12-12": 1,
              "2025-12-19": 1,
              "2026-01-13": 1,
              "2026-01-23": 1,
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 24.36,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-12": 1
              },
              "time_per_day": {
                "2025-12-12": 24.35603
              },
              "time_count_per_day": {
                "2025-12-12": 1
              }
            },
            "P2": {
              "avg_time_hours": 62.65,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "26-28h": 1,
                "140-142h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-04": 1,
                "2025-12-04": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-11-04": 26.887950555555555,
                "2025-12-04": 141.10372583333333,
                "2026-02-03": 19.94816361111111
              },
              "time_count_per_day": {
                "2025-11-04": 1,
                "2025-12-04": 1,
                "2026-02-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 314.85,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "48-50h": 1,
                "882-884h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-01-13": 1,
                "2026-01-23": 1
              },
              "time_per_day": {
                "2025-12-19": 48.584654722222226,
                "2026-01-13": 13.646143333333335,
                "2026-01-23": 882.3115405555556
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-01-13": 1,
                "2026-01-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_399": {
      "overall": {
        "avg_time_hours": 197.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "22-24h": 2,
          "24-26h": 1,
          "26-28h": 1,
          "44-46h": 1,
          "68-70h": 1,
          "76-78h": 1,
          "98-100h": 1,
          "170-172h": 1,
          "644-646h": 1,
          "1362-1364h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-11-03": 1,
          "2025-11-04": 1,
          "2025-11-17": 1,
          "2025-11-26": 1,
          "2025-12-18": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-07": 1,
          "2026-02-20": 1,
          "2026-03-17": 1,
          "2026-05-04": 2,
          "2026-05-08": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-11-03": 1.4456941666666665,
          "2025-11-04": 25.622132222222223,
          "2025-11-17": 99.86929805555556,
          "2025-11-26": 26.747685833333332,
          "2025-12-18": 170.23673694444446,
          "2026-01-27": 23.54254138888889,
          "2026-02-03": 77.8975525,
          "2026-02-07": 69.67431583333334,
          "2026-02-20": 45.06869416666667,
          "2026-03-17": 645.3239613888888,
          "2026-05-04": 0.02913888888888889,
          "2026-05-08": 22.706706944444445,
          "2026-05-26": 1362.251945
        },
        "time_count_per_day": {
          "2025-11-03": 1,
          "2025-11-04": 1,
          "2025-11-17": 1,
          "2025-11-26": 1,
          "2025-12-18": 1,
          "2026-01-27": 1,
          "2026-02-03": 1,
          "2026-02-07": 1,
          "2026-02-20": 1,
          "2026-03-17": 1,
          "2026-05-04": 1,
          "2026-05-08": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 305.04,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "22-24h": 1,
            "24-26h": 1,
            "76-78h": 1,
            "644-646h": 1,
            "1362-1364h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2026-02-03": 1,
            "2026-03-17": 1,
            "2026-05-04": 1,
            "2026-05-08": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-11-03": 1.4456941666666665,
            "2025-11-04": 25.622132222222223,
            "2026-02-03": 77.8975525,
            "2026-03-17": 645.3239613888888,
            "2026-05-04": 0.02913888888888889,
            "2026-05-08": 22.706706944444445,
            "2026-05-26": 1362.251945
          },
          "time_count_per_day": {
            "2025-11-03": 1,
            "2025-11-04": 1,
            "2026-02-03": 1,
            "2026-03-17": 1,
            "2026-05-04": 1,
            "2026-05-08": 1,
            "2026-05-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 72.52,
          "mode_time_hours": 99.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "26-28h": 1,
            "44-46h": 1,
            "68-70h": 1,
            "98-100h": 1,
            "170-172h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-26": 1,
            "2025-12-18": 1,
            "2026-01-27": 1,
            "2026-02-07": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-11-17": 99.86929805555556,
            "2025-11-26": 26.747685833333332,
            "2025-12-18": 170.23673694444446,
            "2026-01-27": 23.54254138888889,
            "2026-02-07": 69.67431583333334,
            "2026-02-20": 45.06869416666667
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-26": 1,
            "2025-12-18": 1,
            "2026-01-27": 1,
            "2026-02-07": 1,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 197.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "22-24h": 2,
              "24-26h": 1,
              "26-28h": 1,
              "44-46h": 1,
              "68-70h": 1,
              "76-78h": 1,
              "98-100h": 1,
              "170-172h": 1,
              "644-646h": 1,
              "1362-1364h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-11-03": 1,
              "2025-11-04": 1,
              "2025-11-17": 1,
              "2025-11-26": 1,
              "2025-12-18": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-07": 1,
              "2026-02-20": 1,
              "2026-03-17": 1,
              "2026-05-04": 1,
              "2026-05-08": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-11-03": 1.4456941666666665,
              "2025-11-04": 25.622132222222223,
              "2025-11-17": 99.86929805555556,
              "2025-11-26": 26.747685833333332,
              "2025-12-18": 170.23673694444446,
              "2026-01-27": 23.54254138888889,
              "2026-02-03": 77.8975525,
              "2026-02-07": 69.67431583333334,
              "2026-02-20": 45.06869416666667,
              "2026-03-17": 645.3239613888888,
              "2026-05-04": 0.02913888888888889,
              "2026-05-08": 22.706706944444445,
              "2026-05-26": 1362.251945
            },
            "time_count_per_day": {
              "2025-11-03": 1,
              "2025-11-04": 1,
              "2025-11-17": 1,
              "2025-11-26": 1,
              "2025-12-18": 1,
              "2026-01-27": 1,
              "2026-02-03": 1,
              "2026-02-07": 1,
              "2026-02-20": 1,
              "2026-03-17": 1,
              "2026-05-04": 1,
              "2026-05-08": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 305.04,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "22-24h": 1,
                "24-26h": 1,
                "76-78h": 1,
                "644-646h": 1,
                "1362-1364h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2026-02-03": 1,
                "2026-03-17": 1,
                "2026-05-04": 1,
                "2026-05-08": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-11-03": 1.4456941666666665,
                "2025-11-04": 25.622132222222223,
                "2026-02-03": 77.8975525,
                "2026-03-17": 645.3239613888888,
                "2026-05-04": 0.02913888888888889,
                "2026-05-08": 22.706706944444445,
                "2026-05-26": 1362.251945
              },
              "time_count_per_day": {
                "2025-11-03": 1,
                "2025-11-04": 1,
                "2026-02-03": 1,
                "2026-03-17": 1,
                "2026-05-04": 1,
                "2026-05-08": 1,
                "2026-05-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 72.52,
              "mode_time_hours": 99.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "26-28h": 1,
                "44-46h": 1,
                "68-70h": 1,
                "98-100h": 1,
                "170-172h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-26": 1,
                "2025-12-18": 1,
                "2026-01-27": 1,
                "2026-02-07": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2025-11-17": 99.86929805555556,
                "2025-11-26": 26.747685833333332,
                "2025-12-18": 170.23673694444446,
                "2026-01-27": 23.54254138888889,
                "2026-02-07": 69.67431583333334,
                "2026-02-20": 45.06869416666667
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-26": 1,
                "2025-12-18": 1,
                "2026-01-27": 1,
                "2026-02-07": 1,
                "2026-02-20": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_132": {
      "overall": {
        "avg_time_hours": 151.98,
        "mode_time_hours": 93.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "82-84h": 1,
          "92-94h": 1,
          "116-118h": 1,
          "172-174h": 1,
          "282-284h": 1,
          "312-314h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-11-07": 1,
          "2025-11-18": 1,
          "2025-11-25": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-11-07": 93.42756416666667,
          "2025-11-18": 116.89192999999999,
          "2025-11-25": 282.50506,
          "2025-12-17": 313.138505,
          "2025-12-18": 82.84034111111112,
          "2025-12-26": 172.64362277777778,
          "2025-12-30": 2.4048794444444446
        },
        "time_count_per_day": {
          "2025-11-07": 1,
          "2025-11-18": 1,
          "2025-11-25": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 121.74,
          "mode_time_hours": 93.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "82-84h": 1,
            "92-94h": 1,
            "116-118h": 1,
            "312-314h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-07": 1,
            "2025-11-18": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-11-07": 93.42756416666667,
            "2025-11-18": 116.89192999999999,
            "2025-12-17": 313.138505,
            "2025-12-18": 82.84034111111112,
            "2025-12-30": 2.4048794444444446
          },
          "time_count_per_day": {
            "2025-11-07": 1,
            "2025-11-18": 1,
            "2025-12-17": 1,
            "2025-12-18": 1,
            "2025-12-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 227.57,
          "mode_time_hours": 283.0,
          "mode_frequency": 1,
          "time_distribution": {
            "172-174h": 1,
            "282-284h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-11-25": 282.50506,
            "2025-12-26": 172.64362277777778
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2025-12-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 151.98,
            "mode_time_hours": 93.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "82-84h": 1,
              "92-94h": 1,
              "116-118h": 1,
              "172-174h": 1,
              "282-284h": 1,
              "312-314h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-07": 1,
              "2025-11-18": 1,
              "2025-11-25": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-11-07": 93.42756416666667,
              "2025-11-18": 116.89192999999999,
              "2025-11-25": 282.50506,
              "2025-12-17": 313.138505,
              "2025-12-18": 82.84034111111112,
              "2025-12-26": 172.64362277777778,
              "2025-12-30": 2.4048794444444446
            },
            "time_count_per_day": {
              "2025-11-07": 1,
              "2025-11-18": 1,
              "2025-11-25": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 121.74,
              "mode_time_hours": 93.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "82-84h": 1,
                "92-94h": 1,
                "116-118h": 1,
                "312-314h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-07": 1,
                "2025-11-18": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-11-07": 93.42756416666667,
                "2025-11-18": 116.89192999999999,
                "2025-12-17": 313.138505,
                "2025-12-18": 82.84034111111112,
                "2025-12-30": 2.4048794444444446
              },
              "time_count_per_day": {
                "2025-11-07": 1,
                "2025-11-18": 1,
                "2025-12-17": 1,
                "2025-12-18": 1,
                "2025-12-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 227.57,
              "mode_time_hours": 283.0,
              "mode_frequency": 1,
              "time_distribution": {
                "172-174h": 1,
                "282-284h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-11-25": 282.50506,
                "2025-12-26": 172.64362277777778
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2025-12-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_405": {
      "overall": {
        "avg_time_hours": 399.83,
        "mode_time_hours": 691.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "94-96h": 1,
          "284-286h": 1,
          "690-692h": 1,
          "1324-1326h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-12-02": 1,
          "2026-01-08": 1,
          "2026-02-09": 2,
          "2026-02-20": 1,
          "2026-03-09": 1,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2025-12-02": 691.0816841666667,
          "2026-01-08": 0.22953361111111112,
          "2026-02-09": 379.897135,
          "2026-03-09": 2.2663241666666667,
          "2026-04-22": 1325.4917419444444
        },
        "time_count_per_day": {
          "2025-12-02": 1,
          "2026-01-08": 1,
          "2026-02-09": 2,
          "2026-03-09": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 95.54,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "284-286h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-02-09": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-01-08": 0.22953361111111112,
            "2026-02-09": 284.1308227777778,
            "2026-03-09": 2.2663241666666667
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-02-09": 1,
            "2026-03-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 704.11,
          "mode_time_hours": 691.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1,
            "690-692h": 1,
            "1324-1326h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1,
            "2026-02-20": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2025-12-02": 691.0816841666667,
            "2026-02-09": 95.76631222222223,
            "2026-04-22": 1325.4917419444444
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1,
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 399.83,
            "mode_time_hours": 691.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "94-96h": 1,
              "284-286h": 1,
              "690-692h": 1,
              "1324-1326h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-12-02": 1,
              "2026-01-08": 1,
              "2026-02-09": 2,
              "2026-03-09": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2025-12-02": 691.0816841666667,
              "2026-01-08": 0.22953361111111112,
              "2026-02-09": 379.897135,
              "2026-03-09": 2.2663241666666667,
              "2026-04-22": 1325.4917419444444
            },
            "time_count_per_day": {
              "2025-12-02": 1,
              "2026-01-08": 1,
              "2026-02-09": 2,
              "2026-03-09": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 95.54,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "284-286h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-02-09": 1,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-01-08": 0.22953361111111112,
                "2026-02-09": 284.1308227777778,
                "2026-03-09": 2.2663241666666667
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-02-09": 1,
                "2026-03-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 704.11,
              "mode_time_hours": 691.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1,
                "690-692h": 1,
                "1324-1326h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2025-12-02": 691.0816841666667,
                "2026-02-09": 95.76631222222223,
                "2026-04-22": 1325.4917419444444
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1,
                "2026-04-22": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_406": {
      "overall": {
        "avg_time_hours": 0.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-03": 1
        },
        "time_per_day": {
          "2025-11-03": 0.7188436111111111
        },
        "time_count_per_day": {
          "2025-11-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.72,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-03": 1
          },
          "time_per_day": {
            "2025-11-03": 0.7188436111111111
          },
          "time_count_per_day": {
            "2025-11-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-03": 1
            },
            "time_per_day": {
              "2025-11-03": 0.7188436111111111
            },
            "time_count_per_day": {
              "2025-11-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.72,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-03": 1
              },
              "time_per_day": {
                "2025-11-03": 0.7188436111111111
              },
              "time_count_per_day": {
                "2025-11-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_407": {
      "overall": {
        "avg_time_hours": 85.29,
        "mode_time_hours": 169.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "168-170h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-06": 1,
          "2025-11-10": 1
        },
        "time_per_day": {
          "2025-11-06": 1.4017355555555555,
          "2025-11-10": 169.1870427777778
        },
        "time_count_per_day": {
          "2025-11-06": 1,
          "2025-11-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 85.29,
          "mode_time_hours": 169.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "168-170h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-11-10": 1
          },
          "time_per_day": {
            "2025-11-06": 1.4017355555555555,
            "2025-11-10": 169.1870427777778
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-11-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 85.29,
            "mode_time_hours": 169.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "168-170h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-06": 1,
              "2025-11-10": 1
            },
            "time_per_day": {
              "2025-11-06": 1.4017355555555555,
              "2025-11-10": 169.1870427777778
            },
            "time_count_per_day": {
              "2025-11-06": 1,
              "2025-11-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 85.29,
              "mode_time_hours": 169.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "168-170h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-11-10": 1
              },
              "time_per_day": {
                "2025-11-06": 1.4017355555555555,
                "2025-11-10": 169.1870427777778
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-11-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_353": {
      "overall": {
        "avg_time_hours": 517.08,
        "mode_time_hours": 357.0,
        "mode_frequency": 1,
        "time_distribution": {
          "356-358h": 1,
          "676-678h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-18": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-11-18": 356.58646527777773,
          "2026-02-12": 677.5777077777778
        },
        "time_count_per_day": {
          "2025-11-18": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 677.58,
          "mode_time_hours": 677.0,
          "mode_frequency": 1,
          "time_distribution": {
            "676-678h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 677.5777077777778
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 356.59,
          "mode_time_hours": 357.0,
          "mode_frequency": 1,
          "time_distribution": {
            "356-358h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-18": 1
          },
          "time_per_day": {
            "2025-11-18": 356.58646527777773
          },
          "time_count_per_day": {
            "2025-11-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 517.08,
            "mode_time_hours": 357.0,
            "mode_frequency": 1,
            "time_distribution": {
              "356-358h": 1,
              "676-678h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-18": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-11-18": 356.58646527777773,
              "2026-02-12": 677.5777077777778
            },
            "time_count_per_day": {
              "2025-11-18": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 677.58,
              "mode_time_hours": 677.0,
              "mode_frequency": 1,
              "time_distribution": {
                "676-678h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 677.5777077777778
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 356.59,
              "mode_time_hours": 357.0,
              "mode_frequency": 1,
              "time_distribution": {
                "356-358h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-18": 1
              },
              "time_per_day": {
                "2025-11-18": 356.58646527777773
              },
              "time_count_per_day": {
                "2025-11-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_411": {
      "overall": {
        "avg_time_hours": 8.64,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-04": 1,
          "2026-01-02": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-11-04": 8.636710555555556
        },
        "time_count_per_day": {
          "2025-11-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-02": 1,
            "2026-05-26": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": 8.64,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-04": 1
          },
          "time_per_day": {
            "2025-11-04": 8.636710555555556
          },
          "time_count_per_day": {
            "2025-11-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.64,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-04": 1
            },
            "time_per_day": {
              "2025-11-04": 8.636710555555556
            },
            "time_count_per_day": {
              "2025-11-04": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.64,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-04": 1
              },
              "time_per_day": {
                "2025-11-04": 8.636710555555556
              },
              "time_count_per_day": {
                "2025-11-04": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_296": {
      "overall": {
        "avg_time_hours": 32.44,
        "mode_time_hours": 33.0,
        "mode_frequency": 1,
        "time_distribution": {
          "32-34h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-05": 1
        },
        "time_per_day": {
          "2025-11-05": 32.44465
        },
        "time_count_per_day": {
          "2025-11-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 32.44,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-05": 1
          },
          "time_per_day": {
            "2025-11-05": 32.44465
          },
          "time_count_per_day": {
            "2025-11-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 32.44,
            "mode_time_hours": 33.0,
            "mode_frequency": 1,
            "time_distribution": {
              "32-34h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-05": 1
            },
            "time_per_day": {
              "2025-11-05": 32.44465
            },
            "time_count_per_day": {
              "2025-11-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 32.44,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-05": 1
              },
              "time_per_day": {
                "2025-11-05": 32.44465
              },
              "time_count_per_day": {
                "2025-11-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_198": {
      "overall": {
        "avg_time_hours": 147.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 5,
          "4-6h": 2,
          "10-12h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "42-44h": 1,
          "72-74h": 1,
          "98-100h": 1,
          "122-124h": 1,
          "316-318h": 1,
          "360-362h": 1,
          "464-466h": 1,
          "582-584h": 1,
          "842-844h": 1,
          "1244-1246h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-11-06": 5,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-12-03": 1,
          "2026-01-09": 1,
          "2026-01-27": 2,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-06": 1,
          "2026-03-09": 3,
          "2026-03-13": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-05-06": 2,
          "2026-05-12": 1,
          "2026-05-26": 1,
          "2026-05-29": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-11-06": 2.509806388888889,
          "2025-11-11": 122.44230777777778,
          "2025-11-12": 25.84894305555556,
          "2025-11-17": 0.4752180555555556,
          "2025-11-19": 361.49939277777776,
          "2025-11-26": 2.316973055555555,
          "2025-12-03": 317.2864766666667,
          "2026-01-09": 10.217611111111111,
          "2026-01-27": 4.899173611111111,
          "2026-02-03": 464.63009750000003,
          "2026-02-10": 98.18917194444444,
          "2026-02-27": 5.704406666666667,
          "2026-02-28": 43.23732277777778,
          "2026-03-06": 1.2967358333333332,
          "2026-03-09": 848.2202863888888,
          "2026-03-13": 5.57576,
          "2026-04-16": 583.6017155555555,
          "2026-04-23": 1244.9749486111111,
          "2026-05-06": 0.31705083333333334,
          "2026-05-26": 26.844470833333332,
          "2026-05-29": 73.13772527777778,
          "2026-06-02": 22.122173333333333
        },
        "time_count_per_day": {
          "2025-11-06": 5,
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-26": 1,
          "2025-12-03": 1,
          "2026-01-09": 1,
          "2026-01-27": 2,
          "2026-02-03": 1,
          "2026-02-10": 1,
          "2026-02-27": 1,
          "2026-02-28": 1,
          "2026-03-06": 1,
          "2026-03-09": 3,
          "2026-03-13": 1,
          "2026-04-16": 1,
          "2026-04-23": 1,
          "2026-05-06": 1,
          "2026-05-26": 1,
          "2026-05-29": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 26.45,
          "mode_time_hours": 3.0,
          "mode_frequency": 4,
          "time_distribution": {
            "2-4h": 4,
            "26-28h": 1,
            "122-124h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-11": 1,
            "2026-01-27": 2,
            "2026-03-09": 2,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-11-11": 122.44230777777778,
            "2026-01-27": 4.899173611111111,
            "2026-03-09": 4.485683055555555,
            "2026-05-26": 26.844470833333332
          },
          "time_count_per_day": {
            "2025-11-11": 1,
            "2026-01-27": 2,
            "2026-03-09": 2,
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 195.27,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 1,
            "4-6h": 2,
            "22-24h": 1,
            "72-74h": 1,
            "98-100h": 1,
            "360-362h": 1,
            "464-466h": 1,
            "582-584h": 1,
            "842-844h": 1,
            "1244-1246h": 1
          },
          "tickets_count": 21,
          "tickets_per_day": {
            "2025-11-06": 5,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-27": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-05-06": 2,
            "2026-05-12": 1,
            "2026-05-29": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-11-06": 2.509806388888889,
            "2025-11-17": 0.4752180555555556,
            "2025-11-19": 361.49939277777776,
            "2025-11-26": 2.316973055555555,
            "2026-02-03": 464.63009750000003,
            "2026-02-10": 98.18917194444444,
            "2026-02-27": 5.704406666666667,
            "2026-03-06": 1.2967358333333332,
            "2026-03-09": 843.7346033333333,
            "2026-03-13": 5.57576,
            "2026-04-16": 583.6017155555555,
            "2026-04-23": 1244.9749486111111,
            "2026-05-06": 0.31705083333333334,
            "2026-05-29": 73.13772527777778,
            "2026-06-02": 22.122173333333333
          },
          "time_count_per_day": {
            "2025-11-06": 5,
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-11-26": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-27": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-04-16": 1,
            "2026-04-23": 1,
            "2026-05-06": 1,
            "2026-05-29": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 180.26,
          "mode_time_hours": 317.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1,
            "316-318h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2026-02-28": 1
          },
          "time_per_day": {
            "2025-12-03": 317.2864766666667,
            "2026-02-28": 43.23732277777778
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2026-02-28": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 18.03,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1,
            "24-26h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2026-01-09": 1
          },
          "time_per_day": {
            "2025-11-12": 25.84894305555556,
            "2026-01-09": 10.217611111111111
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2026-01-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 147.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 5,
              "4-6h": 2,
              "10-12h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "42-44h": 1,
              "72-74h": 1,
              "98-100h": 1,
              "122-124h": 1,
              "316-318h": 1,
              "360-362h": 1,
              "464-466h": 1,
              "582-584h": 1,
              "842-844h": 1,
              "1244-1246h": 1
            },
            "tickets_count": 29,
            "tickets_per_day": {
              "2025-11-06": 5,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-12-03": 1,
              "2026-01-09": 1,
              "2026-01-27": 2,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-06": 1,
              "2026-03-09": 3,
              "2026-03-13": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-05-06": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-06": 2.509806388888889,
              "2025-11-11": 122.44230777777778,
              "2025-11-12": 25.84894305555556,
              "2025-11-17": 0.4752180555555556,
              "2025-11-19": 361.49939277777776,
              "2025-11-26": 2.316973055555555,
              "2025-12-03": 317.2864766666667,
              "2026-01-09": 10.217611111111111,
              "2026-01-27": 4.899173611111111,
              "2026-02-03": 464.63009750000003,
              "2026-02-10": 98.18917194444444,
              "2026-02-27": 5.704406666666667,
              "2026-02-28": 43.23732277777778,
              "2026-03-06": 1.2967358333333332,
              "2026-03-09": 848.2202863888888,
              "2026-03-13": 5.57576,
              "2026-04-16": 583.6017155555555,
              "2026-04-23": 1244.9749486111111,
              "2026-05-06": 0.31705083333333334,
              "2026-05-26": 26.844470833333332,
              "2026-05-29": 73.13772527777778,
              "2026-06-02": 22.122173333333333
            },
            "time_count_per_day": {
              "2025-11-06": 5,
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-26": 1,
              "2025-12-03": 1,
              "2026-01-09": 1,
              "2026-01-27": 2,
              "2026-02-03": 1,
              "2026-02-10": 1,
              "2026-02-27": 1,
              "2026-02-28": 1,
              "2026-03-06": 1,
              "2026-03-09": 3,
              "2026-03-13": 1,
              "2026-04-16": 1,
              "2026-04-23": 1,
              "2026-05-06": 1,
              "2026-05-26": 1,
              "2026-05-29": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 26.45,
              "mode_time_hours": 3.0,
              "mode_frequency": 4,
              "time_distribution": {
                "2-4h": 4,
                "26-28h": 1,
                "122-124h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-11": 1,
                "2026-01-27": 2,
                "2026-03-09": 2,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-11-11": 122.44230777777778,
                "2026-01-27": 4.899173611111111,
                "2026-03-09": 4.485683055555555,
                "2026-05-26": 26.844470833333332
              },
              "time_count_per_day": {
                "2025-11-11": 1,
                "2026-01-27": 2,
                "2026-03-09": 2,
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 195.27,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 1,
                "4-6h": 2,
                "22-24h": 1,
                "72-74h": 1,
                "98-100h": 1,
                "360-362h": 1,
                "464-466h": 1,
                "582-584h": 1,
                "842-844h": 1,
                "1244-1246h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-11-06": 5,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-27": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-05-06": 1,
                "2026-05-29": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-11-06": 2.509806388888889,
                "2025-11-17": 0.4752180555555556,
                "2025-11-19": 361.49939277777776,
                "2025-11-26": 2.316973055555555,
                "2026-02-03": 464.63009750000003,
                "2026-02-10": 98.18917194444444,
                "2026-02-27": 5.704406666666667,
                "2026-03-06": 1.2967358333333332,
                "2026-03-09": 843.7346033333333,
                "2026-03-13": 5.57576,
                "2026-04-16": 583.6017155555555,
                "2026-04-23": 1244.9749486111111,
                "2026-05-06": 0.31705083333333334,
                "2026-05-29": 73.13772527777778,
                "2026-06-02": 22.122173333333333
              },
              "time_count_per_day": {
                "2025-11-06": 5,
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-11-26": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-27": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-04-16": 1,
                "2026-04-23": 1,
                "2026-05-06": 1,
                "2026-05-29": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 180.26,
              "mode_time_hours": 317.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1,
                "316-318h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2026-02-28": 1
              },
              "time_per_day": {
                "2025-12-03": 317.2864766666667,
                "2026-02-28": 43.23732277777778
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2026-02-28": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 18.03,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1,
                "24-26h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2026-01-09": 1
              },
              "time_per_day": {
                "2025-11-12": 25.84894305555556,
                "2026-01-09": 10.217611111111111
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2026-01-09": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-06": 1,
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-06": 1,
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_416": {
      "overall": {
        "avg_time_hours": 0.68,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-11-05": 4,
          "2025-11-08": 1
        },
        "time_per_day": {
          "2025-11-05": 2.901303611111111,
          "2025-11-08": 0.5027602777777778
        },
        "time_count_per_day": {
          "2025-11-05": 4,
          "2025-11-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-08": 1
          },
          "time_per_day": {
            "2025-11-08": 0.5027602777777778
          },
          "time_count_per_day": {
            "2025-11-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-05": 4
          },
          "time_per_day": {
            "2025-11-05": 2.901303611111111
          },
          "time_count_per_day": {
            "2025-11-05": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.68,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-11-05": 4,
              "2025-11-08": 1
            },
            "time_per_day": {
              "2025-11-05": 2.901303611111111,
              "2025-11-08": 0.5027602777777778
            },
            "time_count_per_day": {
              "2025-11-05": 4,
              "2025-11-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-08": 1
              },
              "time_per_day": {
                "2025-11-08": 0.5027602777777778
              },
              "time_count_per_day": {
                "2025-11-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-05": 4
              },
              "time_per_day": {
                "2025-11-05": 2.901303611111111
              },
              "time_count_per_day": {
                "2025-11-05": 4
              }
            }
          }
        }
      }
    },
    "cliente_417": {
      "overall": {
        "avg_time_hours": 165.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "14-16h": 1,
          "28-30h": 1,
          "160-162h": 1,
          "952-954h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-11-06": 1,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-22": 2,
          "2026-05-07": 1,
          "2026-05-08": 1,
          "2026-06-02": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-06": 28.176208333333335,
          "2026-03-25": 952.2374958333332,
          "2026-04-02": 0.40654388888888887,
          "2026-04-22": 176.00389694444448,
          "2026-05-08": 0.04809694444444444,
          "2026-06-02": 0.11764083333333333
        },
        "time_count_per_day": {
          "2025-11-06": 1,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-22": 2,
          "2026-05-08": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 35.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "14-16h": 1,
            "160-162h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-04-02": 1,
            "2026-04-22": 2,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-04-02": 0.40654388888888887,
            "2026-04-22": 176.00389694444448,
            "2026-05-08": 0.04809694444444444,
            "2026-06-02": 0.11764083333333333
          },
          "time_count_per_day": {
            "2026-04-02": 1,
            "2026-04-22": 2,
            "2026-05-08": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 490.21,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1,
            "952-954h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-11-06": 28.176208333333335,
            "2026-03-25": 952.2374958333332
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2026-03-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "14-16h": 1,
              "28-30h": 1,
              "160-162h": 1,
              "952-954h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-06": 1,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-22": 2,
              "2026-05-08": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-06": 28.176208333333335,
              "2026-03-25": 952.2374958333332,
              "2026-04-02": 0.40654388888888887,
              "2026-04-22": 176.00389694444448,
              "2026-05-08": 0.04809694444444444,
              "2026-06-02": 0.11764083333333333
            },
            "time_count_per_day": {
              "2025-11-06": 1,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-22": 2,
              "2026-05-08": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 35.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "14-16h": 1,
                "160-162h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-02": 1,
                "2026-04-22": 2,
                "2026-05-08": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-04-02": 0.40654388888888887,
                "2026-04-22": 176.00389694444448,
                "2026-05-08": 0.04809694444444444,
                "2026-06-02": 0.11764083333333333
              },
              "time_count_per_day": {
                "2026-04-02": 1,
                "2026-04-22": 2,
                "2026-05-08": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 490.21,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1,
                "952-954h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-11-06": 28.176208333333335,
                "2026-03-25": 952.2374958333332
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2026-03-25": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_418": {
      "overall": {
        "avg_time_hours": 73.64,
        "mode_time_hours": 25.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "8-10h": 1,
          "24-26h": 3,
          "28-30h": 1,
          "44-46h": 1,
          "52-54h": 1,
          "190-192h": 1,
          "406-408h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2025-11-05": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-18": 2,
          "2026-01-05": 1,
          "2026-01-14": 2,
          "2026-01-21": 2,
          "2026-02-04": 1
        },
        "time_per_day": {
          "2025-11-05": 8.505236388888889,
          "2025-12-02": 45.64864722222222,
          "2025-12-04": 29.17641027777778,
          "2025-12-18": 48.078560833333334,
          "2026-01-05": 406.6511561111111,
          "2026-01-14": 216.5204325,
          "2026-01-21": 1.4422350000000002,
          "2026-02-04": 53.990766111111114
        },
        "time_count_per_day": {
          "2025-11-05": 1,
          "2025-12-02": 1,
          "2025-12-04": 1,
          "2025-12-18": 2,
          "2026-01-05": 1,
          "2026-01-14": 2,
          "2026-01-21": 2,
          "2026-02-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 45.65,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-12-02": 45.64864722222222
          },
          "time_count_per_day": {
            "2025-12-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 76.44,
          "mode_time_hours": 25.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "8-10h": 1,
            "24-26h": 3,
            "28-30h": 1,
            "52-54h": 1,
            "190-192h": 1,
            "406-408h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-05": 1,
            "2025-12-04": 1,
            "2025-12-18": 2,
            "2026-01-05": 1,
            "2026-01-14": 2,
            "2026-01-21": 2,
            "2026-02-04": 1
          },
          "time_per_day": {
            "2025-11-05": 8.505236388888889,
            "2025-12-04": 29.17641027777778,
            "2025-12-18": 48.078560833333334,
            "2026-01-05": 406.6511561111111,
            "2026-01-14": 216.5204325,
            "2026-01-21": 1.4422350000000002,
            "2026-02-04": 53.990766111111114
          },
          "time_count_per_day": {
            "2025-11-05": 1,
            "2025-12-04": 1,
            "2025-12-18": 2,
            "2026-01-05": 1,
            "2026-01-14": 2,
            "2026-01-21": 2,
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 73.64,
            "mode_time_hours": 25.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "8-10h": 1,
              "24-26h": 3,
              "28-30h": 1,
              "44-46h": 1,
              "52-54h": 1,
              "190-192h": 1,
              "406-408h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2025-11-05": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-18": 2,
              "2026-01-05": 1,
              "2026-01-14": 2,
              "2026-01-21": 2,
              "2026-02-04": 1
            },
            "time_per_day": {
              "2025-11-05": 8.505236388888889,
              "2025-12-02": 45.64864722222222,
              "2025-12-04": 29.17641027777778,
              "2025-12-18": 48.078560833333334,
              "2026-01-05": 406.6511561111111,
              "2026-01-14": 216.5204325,
              "2026-01-21": 1.4422350000000002,
              "2026-02-04": 53.990766111111114
            },
            "time_count_per_day": {
              "2025-11-05": 1,
              "2025-12-02": 1,
              "2025-12-04": 1,
              "2025-12-18": 2,
              "2026-01-05": 1,
              "2026-01-14": 2,
              "2026-01-21": 2,
              "2026-02-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 45.65,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-12-02": 45.64864722222222
              },
              "time_count_per_day": {
                "2025-12-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 76.44,
              "mode_time_hours": 25.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "8-10h": 1,
                "24-26h": 3,
                "28-30h": 1,
                "52-54h": 1,
                "190-192h": 1,
                "406-408h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-05": 1,
                "2025-12-04": 1,
                "2025-12-18": 2,
                "2026-01-05": 1,
                "2026-01-14": 2,
                "2026-01-21": 2,
                "2026-02-04": 1
              },
              "time_per_day": {
                "2025-11-05": 8.505236388888889,
                "2025-12-04": 29.17641027777778,
                "2025-12-18": 48.078560833333334,
                "2026-01-05": 406.6511561111111,
                "2026-01-14": 216.5204325,
                "2026-01-21": 1.4422350000000002,
                "2026-02-04": 53.990766111111114
              },
              "time_count_per_day": {
                "2025-11-05": 1,
                "2025-12-04": 1,
                "2025-12-18": 2,
                "2026-01-05": 1,
                "2026-01-14": 2,
                "2026-01-21": 2,
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_419": {
      "overall": {
        "avg_time_hours": 28.52,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-06": 1
        },
        "time_per_day": {
          "2025-11-06": 28.519268055555557
        },
        "time_count_per_day": {
          "2025-11-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 28.52,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-06": 1
          },
          "time_per_day": {
            "2025-11-06": 28.519268055555557
          },
          "time_count_per_day": {
            "2025-11-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.52,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-06": 1
            },
            "time_per_day": {
              "2025-11-06": 28.519268055555557
            },
            "time_count_per_day": {
              "2025-11-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 28.52,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-06": 1
              },
              "time_per_day": {
                "2025-11-06": 28.519268055555557
              },
              "time_count_per_day": {
                "2025-11-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_343": {
      "overall": {
        "avg_time_hours": 172.82,
        "mode_time_hours": 117.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "26-28h": 1,
          "62-64h": 1,
          "98-100h": 1,
          "116-118h": 1,
          "146-148h": 1,
          "166-168h": 1,
          "172-174h": 1,
          "266-268h": 1,
          "668-670h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-11-10": 1,
          "2025-11-19": 1,
          "2025-11-24": 1,
          "2025-12-10": 1,
          "2025-12-17": 1,
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-01-30": 1,
          "2026-02-23": 1,
          "2026-03-09": 1
        },
        "time_per_day": {
          "2025-11-10": 116.15197888888889,
          "2025-11-19": 167.34778333333333,
          "2025-11-24": 63.65241722222222,
          "2025-12-10": 172.24067666666667,
          "2025-12-17": 98.26586305555556,
          "2026-01-08": 2.0898872222222225,
          "2026-01-09": 26.609040277777776,
          "2026-01-30": 147.40264472222222,
          "2026-02-23": 668.00976,
          "2026-03-09": 266.4642905555556
        },
        "time_count_per_day": {
          "2025-11-10": 1,
          "2025-11-19": 1,
          "2025-11-24": 1,
          "2025-12-10": 1,
          "2025-12-17": 1,
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-01-30": 1,
          "2026-02-23": 1,
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 233.7,
          "mode_time_hours": 117.0,
          "mode_frequency": 1,
          "time_distribution": {
            "98-100h": 1,
            "116-118h": 1,
            "146-148h": 1,
            "166-168h": 1,
            "172-174h": 1,
            "266-268h": 1,
            "668-670h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-10": 1,
            "2025-11-19": 1,
            "2025-12-10": 1,
            "2025-12-17": 1,
            "2026-01-30": 1,
            "2026-02-23": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2025-11-10": 116.15197888888889,
            "2025-11-19": 167.34778333333333,
            "2025-12-10": 172.24067666666667,
            "2025-12-17": 98.26586305555556,
            "2026-01-30": 147.40264472222222,
            "2026-02-23": 668.00976,
            "2026-03-09": 266.4642905555556
          },
          "time_count_per_day": {
            "2025-11-10": 1,
            "2025-11-19": 1,
            "2025-12-10": 1,
            "2025-12-17": 1,
            "2026-01-30": 1,
            "2026-02-23": 1,
            "2026-03-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 63.65,
          "mode_time_hours": 63.0,
          "mode_frequency": 1,
          "time_distribution": {
            "62-64h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-11-24": 63.65241722222222
          },
          "time_count_per_day": {
            "2025-11-24": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 14.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "26-28h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-09": 1
          },
          "time_per_day": {
            "2026-01-08": 2.0898872222222225,
            "2026-01-09": 26.609040277777776
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 172.82,
            "mode_time_hours": 117.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "26-28h": 1,
              "62-64h": 1,
              "98-100h": 1,
              "116-118h": 1,
              "146-148h": 1,
              "166-168h": 1,
              "172-174h": 1,
              "266-268h": 1,
              "668-670h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-11-10": 1,
              "2025-11-19": 1,
              "2025-11-24": 1,
              "2025-12-10": 1,
              "2025-12-17": 1,
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-01-30": 1,
              "2026-02-23": 1,
              "2026-03-09": 1
            },
            "time_per_day": {
              "2025-11-10": 116.15197888888889,
              "2025-11-19": 167.34778333333333,
              "2025-11-24": 63.65241722222222,
              "2025-12-10": 172.24067666666667,
              "2025-12-17": 98.26586305555556,
              "2026-01-08": 2.0898872222222225,
              "2026-01-09": 26.609040277777776,
              "2026-01-30": 147.40264472222222,
              "2026-02-23": 668.00976,
              "2026-03-09": 266.4642905555556
            },
            "time_count_per_day": {
              "2025-11-10": 1,
              "2025-11-19": 1,
              "2025-11-24": 1,
              "2025-12-10": 1,
              "2025-12-17": 1,
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-01-30": 1,
              "2026-02-23": 1,
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 233.7,
              "mode_time_hours": 117.0,
              "mode_frequency": 1,
              "time_distribution": {
                "98-100h": 1,
                "116-118h": 1,
                "146-148h": 1,
                "166-168h": 1,
                "172-174h": 1,
                "266-268h": 1,
                "668-670h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-10": 1,
                "2025-11-19": 1,
                "2025-12-10": 1,
                "2025-12-17": 1,
                "2026-01-30": 1,
                "2026-02-23": 1,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2025-11-10": 116.15197888888889,
                "2025-11-19": 167.34778333333333,
                "2025-12-10": 172.24067666666667,
                "2025-12-17": 98.26586305555556,
                "2026-01-30": 147.40264472222222,
                "2026-02-23": 668.00976,
                "2026-03-09": 266.4642905555556
              },
              "time_count_per_day": {
                "2025-11-10": 1,
                "2025-11-19": 1,
                "2025-12-10": 1,
                "2025-12-17": 1,
                "2026-01-30": 1,
                "2026-02-23": 1,
                "2026-03-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 63.65,
              "mode_time_hours": 63.0,
              "mode_frequency": 1,
              "time_distribution": {
                "62-64h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-11-24": 63.65241722222222
              },
              "time_count_per_day": {
                "2025-11-24": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 14.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "26-28h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-09": 1
              },
              "time_per_day": {
                "2026-01-08": 2.0898872222222225,
                "2026-01-09": 26.609040277777776
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_278": {
      "overall": {
        "avg_time_hours": 1300.13,
        "mode_time_hours": 845.0,
        "mode_frequency": 1,
        "time_distribution": {
          "670-672h": 1,
          "844-846h": 1,
          "1500-1502h": 1,
          "2182-2184h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2026-02-03": 1,
          "2026-02-18": 1
        },
        "time_per_day": {
          "2025-12-11": 845.7978472222222,
          "2025-12-15": 670.0736566666666,
          "2026-02-03": 1501.7913727777777,
          "2026-02-18": 2182.8447505555555
        },
        "time_count_per_day": {
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2026-02-03": 1,
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 845.8,
          "mode_time_hours": 845.0,
          "mode_frequency": 1,
          "time_distribution": {
            "844-846h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 845.7978472222222
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 1451.57,
          "mode_time_hours": 671.0,
          "mode_frequency": 1,
          "time_distribution": {
            "670-672h": 1,
            "1500-1502h": 1,
            "2182-2184h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-15": 1,
            "2026-02-03": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-12-15": 670.0736566666666,
            "2026-02-03": 1501.7913727777777,
            "2026-02-18": 2182.8447505555555
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2026-02-03": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1300.13,
            "mode_time_hours": 845.0,
            "mode_frequency": 1,
            "time_distribution": {
              "670-672h": 1,
              "844-846h": 1,
              "1500-1502h": 1,
              "2182-2184h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2026-02-03": 1,
              "2026-02-18": 1
            },
            "time_per_day": {
              "2025-12-11": 845.7978472222222,
              "2025-12-15": 670.0736566666666,
              "2026-02-03": 1501.7913727777777,
              "2026-02-18": 2182.8447505555555
            },
            "time_count_per_day": {
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2026-02-03": 1,
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 845.8,
              "mode_time_hours": 845.0,
              "mode_frequency": 1,
              "time_distribution": {
                "844-846h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 845.7978472222222
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 1451.57,
              "mode_time_hours": 671.0,
              "mode_frequency": 1,
              "time_distribution": {
                "670-672h": 1,
                "1500-1502h": 1,
                "2182-2184h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2026-02-03": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-12-15": 670.0736566666666,
                "2026-02-03": 1501.7913727777777,
                "2026-02-18": 2182.8447505555555
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2026-02-03": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_423": {
      "overall": {
        "avg_time_hours": 29.94,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-07": 1
        },
        "time_per_day": {
          "2025-11-07": 29.936279722222224
        },
        "time_count_per_day": {
          "2025-11-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 29.94,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-07": 1
          },
          "time_per_day": {
            "2025-11-07": 29.936279722222224
          },
          "time_count_per_day": {
            "2025-11-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.94,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-07": 1
            },
            "time_per_day": {
              "2025-11-07": 29.936279722222224
            },
            "time_count_per_day": {
              "2025-11-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 29.94,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-07": 1
              },
              "time_per_day": {
                "2025-11-07": 29.936279722222224
              },
              "time_count_per_day": {
                "2025-11-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_392": {
      "overall": {
        "avg_time_hours": 181.5,
        "mode_time_hours": 21.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "14-16h": 1,
          "20-22h": 2,
          "22-24h": 1,
          "42-44h": 1,
          "98-100h": 1,
          "100-102h": 1,
          "124-126h": 1,
          "126-128h": 1,
          "872-874h": 1,
          "898-900h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-20": 1,
          "2026-02-12": 2
        },
        "time_per_day": {
          "2025-11-11": 127.64177,
          "2025-11-12": 43.57248444444444,
          "2025-11-13": 1.8238625,
          "2025-11-17": 99.77765277777777,
          "2025-12-11": 20.895239444444442,
          "2025-12-15": 101.21947805555556,
          "2026-01-09": 15.528124166666668,
          "2026-01-14": 7.837962500000001,
          "2026-01-15": 148.06680166666666,
          "2026-01-20": 20.03223138888889,
          "2026-02-12": 1773.0480149999999
        },
        "time_count_per_day": {
          "2025-11-11": 1,
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-17": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2026-01-09": 1,
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-20": 1,
          "2026-02-12": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 387.42,
          "mode_time_hours": 127.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "20-22h": 1,
            "126-128h": 1,
            "872-874h": 1,
            "898-900h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-11": 1,
            "2025-12-11": 1,
            "2026-01-09": 1,
            "2026-02-12": 2
          },
          "time_per_day": {
            "2025-11-11": 127.64177,
            "2025-12-11": 20.895239444444442,
            "2026-01-09": 15.528124166666668,
            "2026-02-12": 1773.0480149999999
          },
          "time_count_per_day": {
            "2025-11-11": 1,
            "2025-12-11": 1,
            "2026-01-09": 1,
            "2026-02-12": 2
          }
        },
        "P3": {
          "avg_time_hours": 59.21,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "42-44h": 1,
            "98-100h": 1,
            "100-102h": 1,
            "124-126h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-12-15": 1,
            "2026-01-15": 2,
            "2026-01-20": 1
          },
          "time_per_day": {
            "2025-11-12": 43.57248444444444,
            "2025-11-13": 1.8238625,
            "2025-11-17": 99.77765277777777,
            "2025-12-15": 101.21947805555556,
            "2026-01-15": 148.06680166666666,
            "2026-01-20": 20.03223138888889
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-17": 1,
            "2025-12-15": 1,
            "2026-01-15": 2,
            "2026-01-20": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 7.84,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 7.837962500000001
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 181.5,
            "mode_time_hours": 21.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "14-16h": 1,
              "20-22h": 2,
              "22-24h": 1,
              "42-44h": 1,
              "98-100h": 1,
              "100-102h": 1,
              "124-126h": 1,
              "126-128h": 1,
              "872-874h": 1,
              "898-900h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-20": 1,
              "2026-02-12": 2
            },
            "time_per_day": {
              "2025-11-11": 127.64177,
              "2025-11-12": 43.57248444444444,
              "2025-11-13": 1.8238625,
              "2025-11-17": 99.77765277777777,
              "2025-12-11": 20.895239444444442,
              "2025-12-15": 101.21947805555556,
              "2026-01-09": 15.528124166666668,
              "2026-01-14": 7.837962500000001,
              "2026-01-15": 148.06680166666666,
              "2026-01-20": 20.03223138888889,
              "2026-02-12": 1773.0480149999999
            },
            "time_count_per_day": {
              "2025-11-11": 1,
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-17": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2026-01-09": 1,
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-20": 1,
              "2026-02-12": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 387.42,
              "mode_time_hours": 127.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "20-22h": 1,
                "126-128h": 1,
                "872-874h": 1,
                "898-900h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-11": 1,
                "2025-12-11": 1,
                "2026-01-09": 1,
                "2026-02-12": 2
              },
              "time_per_day": {
                "2025-11-11": 127.64177,
                "2025-12-11": 20.895239444444442,
                "2026-01-09": 15.528124166666668,
                "2026-02-12": 1773.0480149999999
              },
              "time_count_per_day": {
                "2025-11-11": 1,
                "2025-12-11": 1,
                "2026-01-09": 1,
                "2026-02-12": 2
              }
            },
            "P3": {
              "avg_time_hours": 59.21,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "42-44h": 1,
                "98-100h": 1,
                "100-102h": 1,
                "124-126h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-12-15": 1,
                "2026-01-15": 2,
                "2026-01-20": 1
              },
              "time_per_day": {
                "2025-11-12": 43.57248444444444,
                "2025-11-13": 1.8238625,
                "2025-11-17": 99.77765277777777,
                "2025-12-15": 101.21947805555556,
                "2026-01-15": 148.06680166666666,
                "2026-01-20": 20.03223138888889
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-17": 1,
                "2025-12-15": 1,
                "2026-01-15": 2,
                "2026-01-20": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 7.84,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 7.837962500000001
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_425": {
      "overall": {
        "avg_time_hours": 425.48,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 2,
          "4-6h": 1,
          "362-364h": 1,
          "842-844h": 1,
          "1336-1338h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-11-06": 1,
          "2025-12-12": 1,
          "2026-03-17": 1,
          "2026-04-07": 1,
          "2026-05-26": 1,
          "2026-05-29": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-06": 4.482034444444444,
          "2025-12-12": 2.0741930555555554,
          "2026-03-17": 843.5646861111111,
          "2026-04-07": 1336.9824872222223,
          "2026-05-26": 363.0682325,
          "2026-06-03": 2.7231430555555556
        },
        "time_count_per_day": {
          "2025-11-06": 1,
          "2025-12-12": 1,
          "2026-03-17": 1,
          "2026-04-07": 1,
          "2026-05-26": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 425.48,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "4-6h": 1,
            "362-364h": 1,
            "842-844h": 1,
            "1336-1338h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-12-12": 1,
            "2026-03-17": 1,
            "2026-04-07": 1,
            "2026-05-26": 1,
            "2026-05-29": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-06": 4.482034444444444,
            "2025-12-12": 2.0741930555555554,
            "2026-03-17": 843.5646861111111,
            "2026-04-07": 1336.9824872222223,
            "2026-05-26": 363.0682325,
            "2026-06-03": 2.7231430555555556
          },
          "time_count_per_day": {
            "2025-11-06": 1,
            "2025-12-12": 1,
            "2026-03-17": 1,
            "2026-04-07": 1,
            "2026-05-26": 1,
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 425.48,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 2,
              "4-6h": 1,
              "362-364h": 1,
              "842-844h": 1,
              "1336-1338h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-11-06": 1,
              "2025-12-12": 1,
              "2026-03-17": 1,
              "2026-04-07": 1,
              "2026-05-26": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-06": 4.482034444444444,
              "2025-12-12": 2.0741930555555554,
              "2026-03-17": 843.5646861111111,
              "2026-04-07": 1336.9824872222223,
              "2026-05-26": 363.0682325,
              "2026-06-03": 2.7231430555555556
            },
            "time_count_per_day": {
              "2025-11-06": 1,
              "2025-12-12": 1,
              "2026-03-17": 1,
              "2026-04-07": 1,
              "2026-05-26": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 425.48,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "4-6h": 1,
                "362-364h": 1,
                "842-844h": 1,
                "1336-1338h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-06": 1,
                "2025-12-12": 1,
                "2026-03-17": 1,
                "2026-04-07": 1,
                "2026-05-26": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-06": 4.482034444444444,
                "2025-12-12": 2.0741930555555554,
                "2026-03-17": 843.5646861111111,
                "2026-04-07": 1336.9824872222223,
                "2026-05-26": 363.0682325,
                "2026-06-03": 2.7231430555555556
              },
              "time_count_per_day": {
                "2025-11-06": 1,
                "2025-12-12": 1,
                "2026-03-17": 1,
                "2026-04-07": 1,
                "2026-05-26": 1,
                "2026-06-03": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_426": {
      "overall": {
        "avg_time_hours": 3.29,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-06": 1
        },
        "time_per_day": {
          "2025-11-06": 3.2911027777777777
        },
        "time_count_per_day": {
          "2025-11-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.29,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-06": 1
          },
          "time_per_day": {
            "2025-11-06": 3.2911027777777777
          },
          "time_count_per_day": {
            "2025-11-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.29,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-06": 1
            },
            "time_per_day": {
              "2025-11-06": 3.2911027777777777
            },
            "time_count_per_day": {
              "2025-11-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.29,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-06": 1
              },
              "time_per_day": {
                "2025-11-06": 3.2911027777777777
              },
              "time_count_per_day": {
                "2025-11-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_427": {
      "overall": {
        "avg_time_hours": 2.87,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-06": 1
        },
        "time_per_day": {
          "2025-11-06": 2.869955
        },
        "time_count_per_day": {
          "2025-11-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.87,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-06": 1
          },
          "time_per_day": {
            "2025-11-06": 2.869955
          },
          "time_count_per_day": {
            "2025-11-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.87,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-06": 1
            },
            "time_per_day": {
              "2025-11-06": 2.869955
            },
            "time_count_per_day": {
              "2025-11-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.87,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-06": 1
              },
              "time_per_day": {
                "2025-11-06": 2.869955
              },
              "time_count_per_day": {
                "2025-11-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_429": {
      "overall": {
        "avg_time_hours": 439.04,
        "mode_time_hours": 439.0,
        "mode_frequency": 1,
        "time_distribution": {
          "438-440h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-24": 1
        },
        "time_per_day": {
          "2025-11-24": 439.04347055555553
        },
        "time_count_per_day": {
          "2025-11-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 439.04,
          "mode_time_hours": 439.0,
          "mode_frequency": 1,
          "time_distribution": {
            "438-440h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-11-24": 439.04347055555553
          },
          "time_count_per_day": {
            "2025-11-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 439.04,
            "mode_time_hours": 439.0,
            "mode_frequency": 1,
            "time_distribution": {
              "438-440h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-24": 1
            },
            "time_per_day": {
              "2025-11-24": 439.04347055555553
            },
            "time_count_per_day": {
              "2025-11-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 439.04,
              "mode_time_hours": 439.0,
              "mode_frequency": 1,
              "time_distribution": {
                "438-440h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-11-24": 439.04347055555553
              },
              "time_count_per_day": {
                "2025-11-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_412": {
      "overall": {
        "avg_time_hours": 170.64,
        "mode_time_hours": 171.0,
        "mode_frequency": 1,
        "time_distribution": {
          "170-172h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-11-13": 170.6427541666667
        },
        "time_count_per_day": {
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 170.64,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "170-172h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 170.6427541666667
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 170.64,
            "mode_time_hours": 171.0,
            "mode_frequency": 1,
            "time_distribution": {
              "170-172h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-11-13": 170.6427541666667
            },
            "time_count_per_day": {
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 170.64,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "170-172h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 170.6427541666667
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_434": {
      "overall": {
        "avg_time_hours": 963.52,
        "mode_time_hours": 81.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "80-82h": 1,
          "824-826h": 1,
          "902-904h": 1,
          "918-920h": 1,
          "1380-1382h": 1,
          "1548-1550h": 1,
          "2040-2042h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-11-10": 1,
          "2025-12-02": 1,
          "2026-03-17": 1,
          "2026-04-10": 4,
          "2026-05-06": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-10": 80.43309888888889,
          "2025-12-02": 8.640670277777778,
          "2026-03-17": 824.0757813888889,
          "2026-04-10": 4753.908964722223,
          "2026-05-06": 2041.0864441666668
        },
        "time_count_per_day": {
          "2025-11-10": 1,
          "2025-12-02": 1,
          "2026-03-17": 1,
          "2026-04-10": 4,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 710.05,
          "mode_time_hours": 81.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "80-82h": 1,
            "2040-2042h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-10": 1,
            "2025-12-02": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2025-11-10": 80.43309888888889,
            "2025-12-02": 8.640670277777778,
            "2026-05-06": 2041.0864441666668
          },
          "time_count_per_day": {
            "2025-11-10": 1,
            "2025-12-02": 1,
            "2026-05-06": 1
          }
        },
        "P2": {
          "avg_time_hours": 1124.09,
          "mode_time_hours": 1549.0,
          "mode_frequency": 1,
          "time_distribution": {
            "902-904h": 1,
            "918-920h": 1,
            "1548-1550h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-10": 3,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-04-10": 3372.2647944444443
          },
          "time_count_per_day": {
            "2026-04-10": 3
          }
        },
        "P3": {
          "avg_time_hours": 1102.86,
          "mode_time_hours": 825.0,
          "mode_frequency": 1,
          "time_distribution": {
            "824-826h": 1,
            "1380-1382h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-03-17": 824.0757813888889,
            "2026-04-10": 1381.644170277778
          },
          "time_count_per_day": {
            "2026-03-17": 1,
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 963.52,
            "mode_time_hours": 81.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "80-82h": 1,
              "824-826h": 1,
              "902-904h": 1,
              "918-920h": 1,
              "1380-1382h": 1,
              "1548-1550h": 1,
              "2040-2042h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-11-10": 1,
              "2025-12-02": 1,
              "2026-03-17": 1,
              "2026-04-10": 4,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2025-11-10": 80.43309888888889,
              "2025-12-02": 8.640670277777778,
              "2026-03-17": 824.0757813888889,
              "2026-04-10": 4753.908964722223,
              "2026-05-06": 2041.0864441666668
            },
            "time_count_per_day": {
              "2025-11-10": 1,
              "2025-12-02": 1,
              "2026-03-17": 1,
              "2026-04-10": 4,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 710.05,
              "mode_time_hours": 81.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "80-82h": 1,
                "2040-2042h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-10": 1,
                "2025-12-02": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2025-11-10": 80.43309888888889,
                "2025-12-02": 8.640670277777778,
                "2026-05-06": 2041.0864441666668
              },
              "time_count_per_day": {
                "2025-11-10": 1,
                "2025-12-02": 1,
                "2026-05-06": 1
              }
            },
            "P2": {
              "avg_time_hours": 1124.09,
              "mode_time_hours": 1549.0,
              "mode_frequency": 1,
              "time_distribution": {
                "902-904h": 1,
                "918-920h": 1,
                "1548-1550h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-10": 3
              },
              "time_per_day": {
                "2026-04-10": 3372.2647944444443
              },
              "time_count_per_day": {
                "2026-04-10": 3
              }
            },
            "P3": {
              "avg_time_hours": 1102.86,
              "mode_time_hours": 825.0,
              "mode_frequency": 1,
              "time_distribution": {
                "824-826h": 1,
                "1380-1382h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-17": 1,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-03-17": 824.0757813888889,
                "2026-04-10": 1381.644170277778
              },
              "time_count_per_day": {
                "2026-03-17": 1,
                "2026-04-10": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_440": {
      "overall": {
        "avg_time_hours": 294.58,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "182-184h": 1,
          "302-304h": 1,
          "396-398h": 1,
          "404-406h": 1,
          "492-494h": 1,
          "574-576h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-11-10": 1,
          "2025-12-15": 1,
          "2025-12-19": 2,
          "2026-01-21": 1,
          "2026-02-13": 1,
          "2026-02-19": 1,
          "2026-03-26": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2025-11-10": 0.4549158333333333,
          "2025-12-15": 397.7113327777778,
          "2025-12-19": 1066.491133611111,
          "2026-01-21": 0.17417638888888887,
          "2026-02-13": 183.40677333333332,
          "2026-02-19": 303.8314158333333,
          "2026-03-26": 404.5697977777778
        },
        "time_count_per_day": {
          "2025-11-10": 1,
          "2025-12-15": 1,
          "2025-12-19": 2,
          "2026-01-21": 1,
          "2026-02-13": 1,
          "2026-02-19": 1,
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 222.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "396-398h": 1,
            "492-494h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-10": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-21": 1
          },
          "time_per_day": {
            "2025-11-10": 0.4549158333333333,
            "2025-12-15": 397.7113327777778,
            "2025-12-19": 492.1755538888889,
            "2026-01-21": 0.17417638888888887
          },
          "time_count_per_day": {
            "2025-11-10": 1,
            "2025-12-15": 1,
            "2025-12-19": 1,
            "2026-01-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 183.41,
          "mode_time_hours": 183.0,
          "mode_frequency": 1,
          "time_distribution": {
            "182-184h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 183.40677333333332
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 404.57,
          "mode_time_hours": 405.0,
          "mode_frequency": 1,
          "time_distribution": {
            "404-406h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-26": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-03-26": 404.5697977777778
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 439.07,
          "mode_time_hours": 575.0,
          "mode_frequency": 1,
          "time_distribution": {
            "302-304h": 1,
            "574-576h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2025-12-19": 574.3155797222222,
            "2026-02-19": 303.8314158333333
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 294.58,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "182-184h": 1,
              "302-304h": 1,
              "396-398h": 1,
              "404-406h": 1,
              "492-494h": 1,
              "574-576h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-11-10": 1,
              "2025-12-15": 1,
              "2025-12-19": 2,
              "2026-01-21": 1,
              "2026-02-13": 1,
              "2026-02-19": 1,
              "2026-03-26": 1
            },
            "time_per_day": {
              "2025-11-10": 0.4549158333333333,
              "2025-12-15": 397.7113327777778,
              "2025-12-19": 1066.491133611111,
              "2026-01-21": 0.17417638888888887,
              "2026-02-13": 183.40677333333332,
              "2026-02-19": 303.8314158333333,
              "2026-03-26": 404.5697977777778
            },
            "time_count_per_day": {
              "2025-11-10": 1,
              "2025-12-15": 1,
              "2025-12-19": 2,
              "2026-01-21": 1,
              "2026-02-13": 1,
              "2026-02-19": 1,
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 222.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "396-398h": 1,
                "492-494h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-10": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-21": 1
              },
              "time_per_day": {
                "2025-11-10": 0.4549158333333333,
                "2025-12-15": 397.7113327777778,
                "2025-12-19": 492.1755538888889,
                "2026-01-21": 0.17417638888888887
              },
              "time_count_per_day": {
                "2025-11-10": 1,
                "2025-12-15": 1,
                "2025-12-19": 1,
                "2026-01-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 183.41,
              "mode_time_hours": 183.0,
              "mode_frequency": 1,
              "time_distribution": {
                "182-184h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 183.40677333333332
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 404.57,
              "mode_time_hours": 405.0,
              "mode_frequency": 1,
              "time_distribution": {
                "404-406h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 404.5697977777778
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 439.07,
              "mode_time_hours": 575.0,
              "mode_frequency": 1,
              "time_distribution": {
                "302-304h": 1,
                "574-576h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2025-12-19": 574.3155797222222,
                "2026-02-19": 303.8314158333333
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_420": {
      "overall": {
        "avg_time_hours": 361.74,
        "mode_time_hours": 361.0,
        "mode_frequency": 1,
        "time_distribution": {
          "360-362h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-25": 1
        },
        "time_per_day": {
          "2025-11-25": 361.7423644444445
        },
        "time_count_per_day": {
          "2025-11-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 361.74,
          "mode_time_hours": 361.0,
          "mode_frequency": 1,
          "time_distribution": {
            "360-362h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-11-25": 361.7423644444445
          },
          "time_count_per_day": {
            "2025-11-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 361.74,
            "mode_time_hours": 361.0,
            "mode_frequency": 1,
            "time_distribution": {
              "360-362h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-25": 1
            },
            "time_per_day": {
              "2025-11-25": 361.7423644444445
            },
            "time_count_per_day": {
              "2025-11-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 361.74,
              "mode_time_hours": 361.0,
              "mode_frequency": 1,
              "time_distribution": {
                "360-362h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-11-25": 361.7423644444445
              },
              "time_count_per_day": {
                "2025-11-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_441": {
      "overall": {
        "avg_time_hours": 364.63,
        "mode_time_hours": 527.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "46-48h": 1,
          "110-112h": 1,
          "142-144h": 1,
          "426-428h": 1,
          "428-430h": 1,
          "526-528h": 2,
          "578-580h": 1,
          "586-588h": 1,
          "810-812h": 1,
          "854-856h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2025-12-02": 2,
          "2026-02-07": 1,
          "2026-02-12": 2,
          "2026-02-18": 1,
          "2026-03-11": 1,
          "2026-03-23": 2,
          "2026-04-10": 2,
          "2026-04-23": 1,
          "2026-05-13": 1
        },
        "time_per_day": {
          "2025-11-14": 28.376775277777778,
          "2025-12-02": 1053.9582088888887,
          "2026-02-07": 33.79889638888889,
          "2026-02-12": 728.4326261111112,
          "2026-02-18": 47.211933888888886,
          "2026-03-11": 111.32551249999999,
          "2026-03-23": 856.3868805555555,
          "2026-04-10": 1665.6030547222222,
          "2026-04-23": 579.1797608333334,
          "2026-05-13": 0.5317433333333333
        },
        "time_count_per_day": {
          "2025-11-14": 1,
          "2025-12-02": 2,
          "2026-02-07": 1,
          "2026-02-12": 2,
          "2026-02-18": 1,
          "2026-03-11": 1,
          "2026-03-23": 2,
          "2026-04-10": 2,
          "2026-04-23": 1,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 854.3,
          "mode_time_hours": 855.0,
          "mode_frequency": 1,
          "time_distribution": {
            "854-856h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 854.3034669444445
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        },
        "P2": {
          "avg_time_hours": 368.15,
          "mode_time_hours": 527.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "28-30h": 1,
            "142-144h": 1,
            "426-428h": 1,
            "428-430h": 1,
            "526-528h": 1,
            "578-580h": 1,
            "810-812h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-12-02": 1,
            "2026-02-12": 1,
            "2026-03-23": 2,
            "2026-04-10": 1,
            "2026-04-23": 1,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2025-11-14": 28.376775277777778,
            "2025-12-02": 527.0432933333333,
            "2026-02-12": 142.36121555555556,
            "2026-03-23": 856.3868805555555,
            "2026-04-10": 811.2995877777777,
            "2026-04-23": 579.1797608333334,
            "2026-05-13": 0.5317433333333333
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2025-12-02": 1,
            "2026-02-12": 1,
            "2026-03-23": 2,
            "2026-04-10": 1,
            "2026-04-23": 1,
            "2026-05-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 261.06,
          "mode_time_hours": 527.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "46-48h": 1,
            "110-112h": 1,
            "526-528h": 1,
            "586-588h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-07": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2025-12-02": 526.9149155555556,
            "2026-02-07": 33.79889638888889,
            "2026-02-12": 586.0714105555556,
            "2026-02-18": 47.211933888888886,
            "2026-03-11": 111.32551249999999
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-07": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 364.63,
            "mode_time_hours": 527.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "46-48h": 1,
              "110-112h": 1,
              "142-144h": 1,
              "426-428h": 1,
              "428-430h": 1,
              "526-528h": 2,
              "578-580h": 1,
              "586-588h": 1,
              "810-812h": 1,
              "854-856h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-11-14": 1,
              "2025-12-02": 2,
              "2026-02-07": 1,
              "2026-02-12": 2,
              "2026-02-18": 1,
              "2026-03-11": 1,
              "2026-03-23": 2,
              "2026-04-10": 2,
              "2026-04-23": 1,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2025-11-14": 28.376775277777778,
              "2025-12-02": 1053.9582088888887,
              "2026-02-07": 33.79889638888889,
              "2026-02-12": 728.4326261111112,
              "2026-02-18": 47.211933888888886,
              "2026-03-11": 111.32551249999999,
              "2026-03-23": 856.3868805555555,
              "2026-04-10": 1665.6030547222222,
              "2026-04-23": 579.1797608333334,
              "2026-05-13": 0.5317433333333333
            },
            "time_count_per_day": {
              "2025-11-14": 1,
              "2025-12-02": 2,
              "2026-02-07": 1,
              "2026-02-12": 2,
              "2026-02-18": 1,
              "2026-03-11": 1,
              "2026-03-23": 2,
              "2026-04-10": 2,
              "2026-04-23": 1,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 854.3,
              "mode_time_hours": 855.0,
              "mode_frequency": 1,
              "time_distribution": {
                "854-856h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 854.3034669444445
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            },
            "P2": {
              "avg_time_hours": 368.15,
              "mode_time_hours": 527.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "28-30h": 1,
                "142-144h": 1,
                "426-428h": 1,
                "428-430h": 1,
                "526-528h": 1,
                "578-580h": 1,
                "810-812h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2025-12-02": 1,
                "2026-02-12": 1,
                "2026-03-23": 2,
                "2026-04-10": 1,
                "2026-04-23": 1,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2025-11-14": 28.376775277777778,
                "2025-12-02": 527.0432933333333,
                "2026-02-12": 142.36121555555556,
                "2026-03-23": 856.3868805555555,
                "2026-04-10": 811.2995877777777,
                "2026-04-23": 579.1797608333334,
                "2026-05-13": 0.5317433333333333
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2025-12-02": 1,
                "2026-02-12": 1,
                "2026-03-23": 2,
                "2026-04-10": 1,
                "2026-04-23": 1,
                "2026-05-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 261.06,
              "mode_time_hours": 527.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "46-48h": 1,
                "110-112h": 1,
                "526-528h": 1,
                "586-588h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-07": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2025-12-02": 526.9149155555556,
                "2026-02-07": 33.79889638888889,
                "2026-02-12": 586.0714105555556,
                "2026-02-18": 47.211933888888886,
                "2026-03-11": 111.32551249999999
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-07": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_442": {
      "overall": {
        "avg_time_hours": 63.49,
        "mode_time_hours": 5.0,
        "mode_frequency": 32,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 4,
          "4-6h": 32,
          "6-8h": 16,
          "8-10h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "28-30h": 5,
          "32-34h": 1,
          "46-48h": 1,
          "50-52h": 2,
          "52-54h": 1,
          "70-72h": 2,
          "72-74h": 1,
          "74-76h": 1,
          "102-104h": 1,
          "120-122h": 1,
          "144-146h": 1,
          "170-172h": 1,
          "194-196h": 4,
          "198-200h": 1,
          "214-216h": 1,
          "218-220h": 9,
          "262-264h": 1,
          "290-292h": 1,
          "364-366h": 1,
          "504-506h": 1
        },
        "tickets_count": 101,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-30": 4,
          "2026-02-02": 3,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-18": 1,
          "2026-02-27": 2,
          "2026-03-02": 2,
          "2026-03-05": 1,
          "2026-03-12": 5,
          "2026-03-17": 2,
          "2026-03-30": 2,
          "2026-04-08": 1,
          "2026-04-13": 1,
          "2026-04-22": 5,
          "2026-04-27": 7,
          "2026-04-28": 2,
          "2026-04-29": 2,
          "2026-05-04": 5,
          "2026-05-06": 3,
          "2026-05-07": 1,
          "2026-05-10": 1,
          "2026-05-11": 1,
          "2026-05-12": 2,
          "2026-05-13": 5,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-22": 16,
          "2026-05-25": 3,
          "2026-05-27": 3,
          "2026-05-28": 1,
          "2026-06-03": 6,
          "2026-06-05": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-12": 53.398085,
          "2026-01-22": 6.1422630555555555,
          "2026-01-26": 7.296999444444444,
          "2026-01-27": 121.89406944444445,
          "2026-01-30": 55.02824527777777,
          "2026-02-02": 16.800574722222223,
          "2026-02-09": 9.793761666666667,
          "2026-02-10": 13.447054722222221,
          "2026-02-18": 1.0354716666666666,
          "2026-02-27": 13.690810555555554,
          "2026-03-02": 119.91624444444444,
          "2026-03-05": 27.65022666666667,
          "2026-03-12": 242.4203547222222,
          "2026-03-17": 12.754934444444444,
          "2026-03-30": 14.024598611111111,
          "2026-04-08": 199.64447777777778,
          "2026-04-13": 4.4292758333333335,
          "2026-04-22": 190.54570277777776,
          "2026-04-27": 35.615208333333335,
          "2026-04-28": 12.201263333333333,
          "2026-04-29": 9.579164166666668,
          "2026-05-04": 16.73406166666667,
          "2026-05-06": 14.880890555555556,
          "2026-05-07": 2.6027802777777778,
          "2026-05-10": 74.07216916666667,
          "2026-05-11": 6.761735833333333,
          "2026-05-12": 56.79860111111111,
          "2026-05-13": 23.684855555555558,
          "2026-05-15": 102.3387513888889,
          "2026-05-18": 265.7426513888889,
          "2026-05-22": 3069.371595277778,
          "2026-05-25": 433.187815,
          "2026-05-27": 5.856041944444445,
          "2026-05-28": 365.8775583333333,
          "2026-06-03": 553.2485666666666
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-30": 4,
          "2026-02-02": 3,
          "2026-02-09": 2,
          "2026-02-10": 2,
          "2026-02-18": 1,
          "2026-02-27": 2,
          "2026-03-02": 2,
          "2026-03-05": 1,
          "2026-03-12": 5,
          "2026-03-17": 2,
          "2026-03-30": 2,
          "2026-04-08": 1,
          "2026-04-13": 1,
          "2026-04-22": 5,
          "2026-04-27": 7,
          "2026-04-28": 2,
          "2026-04-29": 2,
          "2026-05-04": 5,
          "2026-05-06": 3,
          "2026-05-07": 1,
          "2026-05-10": 1,
          "2026-05-11": 1,
          "2026-05-12": 2,
          "2026-05-13": 5,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-22": 16,
          "2026-05-25": 3,
          "2026-05-27": 2,
          "2026-05-28": 1,
          "2026-06-03": 6
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 50.62,
          "mode_time_hours": 7.0,
          "mode_frequency": 3,
          "time_distribution": {
            "4-6h": 2,
            "6-8h": 3,
            "8-10h": 1,
            "28-30h": 1,
            "32-34h": 1,
            "70-72h": 2,
            "72-74h": 1,
            "290-292h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-01-30": 4,
            "2026-02-02": 1,
            "2026-03-02": 1,
            "2026-04-29": 2,
            "2026-05-25": 3,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-01-30": 55.02824527777777,
            "2026-02-02": 7.878101666666667,
            "2026-03-02": 72.04813055555556,
            "2026-04-29": 9.579164166666668,
            "2026-05-25": 433.187815,
            "2026-06-03": 29.684544444444445
          },
          "time_count_per_day": {
            "2026-01-30": 4,
            "2026-02-02": 1,
            "2026-03-02": 1,
            "2026-04-29": 2,
            "2026-05-25": 3,
            "2026-06-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 68.07,
          "mode_time_hours": 5.0,
          "mode_frequency": 25,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 3,
            "4-6h": 25,
            "6-8h": 10,
            "18-20h": 1,
            "20-22h": 1,
            "26-28h": 1,
            "28-30h": 4,
            "46-48h": 1,
            "50-52h": 2,
            "52-54h": 1,
            "102-104h": 1,
            "120-122h": 1,
            "144-146h": 1,
            "170-172h": 1,
            "194-196h": 4,
            "214-216h": 1,
            "218-220h": 9,
            "364-366h": 1,
            "504-506h": 1
          },
          "tickets_count": 77,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-02-10": 2,
            "2026-02-18": 1,
            "2026-02-27": 2,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-12": 5,
            "2026-03-30": 2,
            "2026-04-22": 5,
            "2026-04-27": 7,
            "2026-04-28": 2,
            "2026-05-04": 5,
            "2026-05-06": 3,
            "2026-05-11": 1,
            "2026-05-12": 2,
            "2026-05-13": 5,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-22": 16,
            "2026-05-27": 3,
            "2026-05-28": 1,
            "2026-06-03": 5,
            "2026-06-05": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-12": 53.398085,
            "2026-01-22": 6.1422630555555555,
            "2026-01-27": 121.89406944444445,
            "2026-02-10": 13.447054722222221,
            "2026-02-18": 1.0354716666666666,
            "2026-02-27": 13.690810555555554,
            "2026-03-02": 47.868113888888885,
            "2026-03-05": 27.65022666666667,
            "2026-03-12": 242.4203547222222,
            "2026-03-30": 14.024598611111111,
            "2026-04-22": 190.54570277777776,
            "2026-04-27": 35.615208333333335,
            "2026-04-28": 12.201263333333333,
            "2026-05-04": 16.73406166666667,
            "2026-05-06": 14.880890555555556,
            "2026-05-11": 6.761735833333333,
            "2026-05-12": 56.79860111111111,
            "2026-05-13": 23.684855555555558,
            "2026-05-15": 102.3387513888889,
            "2026-05-18": 3.486883055555556,
            "2026-05-22": 3069.371595277778,
            "2026-05-27": 5.856041944444445,
            "2026-05-28": 365.8775583333333,
            "2026-06-03": 523.5640222222222
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-02-10": 2,
            "2026-02-18": 1,
            "2026-02-27": 2,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-12": 5,
            "2026-03-30": 2,
            "2026-04-22": 5,
            "2026-04-27": 7,
            "2026-04-28": 2,
            "2026-05-04": 5,
            "2026-05-06": 3,
            "2026-05-11": 1,
            "2026-05-12": 2,
            "2026-05-13": 5,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-22": 16,
            "2026-05-27": 2,
            "2026-05-28": 1,
            "2026-06-03": 5
          }
        },
        "P3": {
          "avg_time_hours": 48.48,
          "mode_time_hours": 5.0,
          "mode_frequency": 5,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 5,
            "6-8h": 3,
            "74-76h": 1,
            "198-200h": 1,
            "262-264h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-02-02": 2,
            "2026-02-09": 2,
            "2026-03-17": 2,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-01-26": 7.296999444444444,
            "2026-02-02": 8.922473055555557,
            "2026-02-09": 9.793761666666667,
            "2026-03-17": 12.754934444444444,
            "2026-04-08": 199.64447777777778,
            "2026-04-13": 4.4292758333333335,
            "2026-05-07": 2.6027802777777778,
            "2026-05-10": 74.07216916666667,
            "2026-05-18": 262.2557683333333
          },
          "time_count_per_day": {
            "2026-01-26": 1,
            "2026-02-02": 2,
            "2026-02-09": 2,
            "2026-03-17": 2,
            "2026-04-08": 1,
            "2026-04-13": 1,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 63.49,
            "mode_time_hours": 5.0,
            "mode_frequency": 32,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 4,
              "4-6h": 32,
              "6-8h": 16,
              "8-10h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "28-30h": 5,
              "32-34h": 1,
              "46-48h": 1,
              "50-52h": 2,
              "52-54h": 1,
              "70-72h": 2,
              "72-74h": 1,
              "74-76h": 1,
              "102-104h": 1,
              "120-122h": 1,
              "144-146h": 1,
              "170-172h": 1,
              "194-196h": 4,
              "198-200h": 1,
              "214-216h": 1,
              "218-220h": 9,
              "262-264h": 1,
              "290-292h": 1,
              "364-366h": 1,
              "504-506h": 1
            },
            "tickets_count": 97,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-30": 4,
              "2026-02-02": 3,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-18": 1,
              "2026-02-27": 2,
              "2026-03-02": 2,
              "2026-03-05": 1,
              "2026-03-12": 5,
              "2026-03-17": 2,
              "2026-03-30": 2,
              "2026-04-08": 1,
              "2026-04-13": 1,
              "2026-04-22": 5,
              "2026-04-27": 7,
              "2026-04-28": 2,
              "2026-04-29": 2,
              "2026-05-04": 5,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-10": 1,
              "2026-05-11": 1,
              "2026-05-12": 2,
              "2026-05-13": 5,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-22": 16,
              "2026-05-25": 3,
              "2026-05-27": 2,
              "2026-05-28": 1,
              "2026-06-03": 6
            },
            "time_per_day": {
              "2025-11-12": 53.398085,
              "2026-01-22": 6.1422630555555555,
              "2026-01-26": 7.296999444444444,
              "2026-01-27": 121.89406944444445,
              "2026-01-30": 55.02824527777777,
              "2026-02-02": 16.800574722222223,
              "2026-02-09": 9.793761666666667,
              "2026-02-10": 13.447054722222221,
              "2026-02-18": 1.0354716666666666,
              "2026-02-27": 13.690810555555554,
              "2026-03-02": 119.91624444444444,
              "2026-03-05": 27.65022666666667,
              "2026-03-12": 242.4203547222222,
              "2026-03-17": 12.754934444444444,
              "2026-03-30": 14.024598611111111,
              "2026-04-08": 199.64447777777778,
              "2026-04-13": 4.4292758333333335,
              "2026-04-22": 190.54570277777776,
              "2026-04-27": 35.615208333333335,
              "2026-04-28": 12.201263333333333,
              "2026-04-29": 9.579164166666668,
              "2026-05-04": 16.73406166666667,
              "2026-05-06": 14.880890555555556,
              "2026-05-07": 2.6027802777777778,
              "2026-05-10": 74.07216916666667,
              "2026-05-11": 6.761735833333333,
              "2026-05-12": 56.79860111111111,
              "2026-05-13": 23.684855555555558,
              "2026-05-15": 102.3387513888889,
              "2026-05-18": 265.7426513888889,
              "2026-05-22": 3069.371595277778,
              "2026-05-25": 433.187815,
              "2026-05-27": 5.856041944444445,
              "2026-05-28": 365.8775583333333,
              "2026-06-03": 553.2485666666666
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-30": 4,
              "2026-02-02": 3,
              "2026-02-09": 2,
              "2026-02-10": 2,
              "2026-02-18": 1,
              "2026-02-27": 2,
              "2026-03-02": 2,
              "2026-03-05": 1,
              "2026-03-12": 5,
              "2026-03-17": 2,
              "2026-03-30": 2,
              "2026-04-08": 1,
              "2026-04-13": 1,
              "2026-04-22": 5,
              "2026-04-27": 7,
              "2026-04-28": 2,
              "2026-04-29": 2,
              "2026-05-04": 5,
              "2026-05-06": 3,
              "2026-05-07": 1,
              "2026-05-10": 1,
              "2026-05-11": 1,
              "2026-05-12": 2,
              "2026-05-13": 5,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-22": 16,
              "2026-05-25": 3,
              "2026-05-27": 2,
              "2026-05-28": 1,
              "2026-06-03": 6
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 50.62,
              "mode_time_hours": 7.0,
              "mode_frequency": 3,
              "time_distribution": {
                "4-6h": 2,
                "6-8h": 3,
                "8-10h": 1,
                "28-30h": 1,
                "32-34h": 1,
                "70-72h": 2,
                "72-74h": 1,
                "290-292h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-01-30": 4,
                "2026-02-02": 1,
                "2026-03-02": 1,
                "2026-04-29": 2,
                "2026-05-25": 3,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-01-30": 55.02824527777777,
                "2026-02-02": 7.878101666666667,
                "2026-03-02": 72.04813055555556,
                "2026-04-29": 9.579164166666668,
                "2026-05-25": 433.187815,
                "2026-06-03": 29.684544444444445
              },
              "time_count_per_day": {
                "2026-01-30": 4,
                "2026-02-02": 1,
                "2026-03-02": 1,
                "2026-04-29": 2,
                "2026-05-25": 3,
                "2026-06-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 68.07,
              "mode_time_hours": 5.0,
              "mode_frequency": 25,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 3,
                "4-6h": 25,
                "6-8h": 10,
                "18-20h": 1,
                "20-22h": 1,
                "26-28h": 1,
                "28-30h": 4,
                "46-48h": 1,
                "50-52h": 2,
                "52-54h": 1,
                "102-104h": 1,
                "120-122h": 1,
                "144-146h": 1,
                "170-172h": 1,
                "194-196h": 4,
                "214-216h": 1,
                "218-220h": 9,
                "364-366h": 1,
                "504-506h": 1
              },
              "tickets_count": 73,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-02-10": 2,
                "2026-02-18": 1,
                "2026-02-27": 2,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-12": 5,
                "2026-03-30": 2,
                "2026-04-22": 5,
                "2026-04-27": 7,
                "2026-04-28": 2,
                "2026-05-04": 5,
                "2026-05-06": 3,
                "2026-05-11": 1,
                "2026-05-12": 2,
                "2026-05-13": 5,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-22": 16,
                "2026-05-27": 2,
                "2026-05-28": 1,
                "2026-06-03": 5
              },
              "time_per_day": {
                "2025-11-12": 53.398085,
                "2026-01-22": 6.1422630555555555,
                "2026-01-27": 121.89406944444445,
                "2026-02-10": 13.447054722222221,
                "2026-02-18": 1.0354716666666666,
                "2026-02-27": 13.690810555555554,
                "2026-03-02": 47.868113888888885,
                "2026-03-05": 27.65022666666667,
                "2026-03-12": 242.4203547222222,
                "2026-03-30": 14.024598611111111,
                "2026-04-22": 190.54570277777776,
                "2026-04-27": 35.615208333333335,
                "2026-04-28": 12.201263333333333,
                "2026-05-04": 16.73406166666667,
                "2026-05-06": 14.880890555555556,
                "2026-05-11": 6.761735833333333,
                "2026-05-12": 56.79860111111111,
                "2026-05-13": 23.684855555555558,
                "2026-05-15": 102.3387513888889,
                "2026-05-18": 3.486883055555556,
                "2026-05-22": 3069.371595277778,
                "2026-05-27": 5.856041944444445,
                "2026-05-28": 365.8775583333333,
                "2026-06-03": 523.5640222222222
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-02-10": 2,
                "2026-02-18": 1,
                "2026-02-27": 2,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-12": 5,
                "2026-03-30": 2,
                "2026-04-22": 5,
                "2026-04-27": 7,
                "2026-04-28": 2,
                "2026-05-04": 5,
                "2026-05-06": 3,
                "2026-05-11": 1,
                "2026-05-12": 2,
                "2026-05-13": 5,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-05-22": 16,
                "2026-05-27": 2,
                "2026-05-28": 1,
                "2026-06-03": 5
              }
            },
            "P3": {
              "avg_time_hours": 48.48,
              "mode_time_hours": 5.0,
              "mode_frequency": 5,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 5,
                "6-8h": 3,
                "74-76h": 1,
                "198-200h": 1,
                "262-264h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-01-26": 1,
                "2026-02-02": 2,
                "2026-02-09": 2,
                "2026-03-17": 2,
                "2026-04-08": 1,
                "2026-04-13": 1,
                "2026-05-07": 1,
                "2026-05-10": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-01-26": 7.296999444444444,
                "2026-02-02": 8.922473055555557,
                "2026-02-09": 9.793761666666667,
                "2026-03-17": 12.754934444444444,
                "2026-04-08": 199.64447777777778,
                "2026-04-13": 4.4292758333333335,
                "2026-05-07": 2.6027802777777778,
                "2026-05-10": 74.07216916666667,
                "2026-05-18": 262.2557683333333
              },
              "time_count_per_day": {
                "2026-01-26": 1,
                "2026-02-02": 2,
                "2026-02-09": 2,
                "2026-03-17": 2,
                "2026-04-08": 1,
                "2026-04-13": 1,
                "2026-05-07": 1,
                "2026-05-10": 1,
                "2026-05-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-06-05": 2,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-06-05": 2,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_444": {
      "overall": {
        "avg_time_hours": 73.69,
        "mode_time_hours": 73.0,
        "mode_frequency": 1,
        "time_distribution": {
          "72-74h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-11-13": 73.69022249999999
        },
        "time_count_per_day": {
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 73.69,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "72-74h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 73.69022249999999
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 73.69,
            "mode_time_hours": 73.0,
            "mode_frequency": 1,
            "time_distribution": {
              "72-74h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-11-13": 73.69022249999999
            },
            "time_count_per_day": {
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 73.69,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "72-74h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 73.69022249999999
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_447": {
      "overall": {
        "avg_time_hours": 592.31,
        "mode_time_hours": 593.0,
        "mode_frequency": 1,
        "time_distribution": {
          "592-594h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-12-05": 592.3053
        },
        "time_count_per_day": {
          "2025-12-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 592.31,
          "mode_time_hours": 593.0,
          "mode_frequency": 1,
          "time_distribution": {
            "592-594h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 592.3053
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 592.31,
            "mode_time_hours": 593.0,
            "mode_frequency": 1,
            "time_distribution": {
              "592-594h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-12-05": 592.3053
            },
            "time_count_per_day": {
              "2025-12-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 592.31,
              "mode_time_hours": 593.0,
              "mode_frequency": 1,
              "time_distribution": {
                "592-594h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 592.3053
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_448": {
      "overall": {
        "avg_time_hours": 130.27,
        "mode_time_hours": 423.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1,
          "16-18h": 1,
          "68-70h": 1,
          "422-424h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-11-28": 1,
          "2026-02-02": 1,
          "2026-03-10": 1,
          "2026-04-27": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-11-28": 423.70674527777777,
          "2026-02-02": 11.739679166666667,
          "2026-03-10": 68.59587166666667,
          "2026-06-02": 17.04182861111111
        },
        "time_count_per_day": {
          "2025-11-28": 1,
          "2026-02-02": 1,
          "2026-03-10": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 17.04,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 17.04182861111111
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 246.15,
          "mode_time_hours": 423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1,
            "422-424h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-03-10": 1
          },
          "time_per_day": {
            "2025-11-28": 423.70674527777777,
            "2026-03-10": 68.59587166666667
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2026-03-10": 1
          }
        },
        "P3": {
          "avg_time_hours": 11.74,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 11.739679166666667
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 130.27,
            "mode_time_hours": 423.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1,
              "16-18h": 1,
              "68-70h": 1,
              "422-424h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2026-02-02": 1,
              "2026-03-10": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-28": 423.70674527777777,
              "2026-02-02": 11.739679166666667,
              "2026-03-10": 68.59587166666667,
              "2026-06-02": 17.04182861111111
            },
            "time_count_per_day": {
              "2025-11-28": 1,
              "2026-02-02": 1,
              "2026-03-10": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 17.04,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 17.04182861111111
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 246.15,
              "mode_time_hours": 423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1,
                "422-424h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-03-10": 1
              },
              "time_per_day": {
                "2025-11-28": 423.70674527777777,
                "2026-03-10": 68.59587166666667
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2026-03-10": 1
              }
            },
            "P3": {
              "avg_time_hours": 11.74,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 11.739679166666667
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_300": {
      "overall": {
        "avg_time_hours": 132.32,
        "mode_time_hours": 33.0,
        "mode_frequency": 2,
        "time_distribution": {
          "32-34h": 2,
          "38-40h": 1,
          "42-44h": 1,
          "64-66h": 1,
          "80-82h": 1,
          "92-94h": 1,
          "670-672h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2026-02-23": 1,
          "2026-03-02": 2,
          "2026-03-04": 1,
          "2026-04-23": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2025-11-14": 92.28892916666668,
          "2025-11-17": 81.49953166666667,
          "2026-02-23": 65.45367722222223,
          "2026-03-02": 66.02860472222221,
          "2026-03-04": 42.899946944444444,
          "2026-04-23": 671.7293316666667,
          "2026-05-04": 38.66973027777778
        },
        "time_count_per_day": {
          "2025-11-14": 1,
          "2025-11-17": 1,
          "2026-02-23": 1,
          "2026-03-02": 2,
          "2026-03-04": 1,
          "2026-04-23": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 139.58,
          "mode_time_hours": 33.0,
          "mode_frequency": 2,
          "time_distribution": {
            "32-34h": 2,
            "38-40h": 1,
            "42-44h": 1,
            "64-66h": 1,
            "92-94h": 1,
            "670-672h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2026-02-23": 1,
            "2026-03-02": 2,
            "2026-03-04": 1,
            "2026-04-23": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2025-11-14": 92.28892916666668,
            "2026-02-23": 65.45367722222223,
            "2026-03-02": 66.02860472222221,
            "2026-03-04": 42.899946944444444,
            "2026-04-23": 671.7293316666667,
            "2026-05-04": 38.66973027777778
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2026-02-23": 1,
            "2026-03-02": 2,
            "2026-03-04": 1,
            "2026-04-23": 1,
            "2026-05-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 81.5,
          "mode_time_hours": 81.0,
          "mode_frequency": 1,
          "time_distribution": {
            "80-82h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 81.49953166666667
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 132.32,
            "mode_time_hours": 33.0,
            "mode_frequency": 2,
            "time_distribution": {
              "32-34h": 2,
              "38-40h": 1,
              "42-44h": 1,
              "64-66h": 1,
              "80-82h": 1,
              "92-94h": 1,
              "670-672h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2026-02-23": 1,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-04-23": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2025-11-14": 92.28892916666668,
              "2025-11-17": 81.49953166666667,
              "2026-02-23": 65.45367722222223,
              "2026-03-02": 66.02860472222221,
              "2026-03-04": 42.899946944444444,
              "2026-04-23": 671.7293316666667,
              "2026-05-04": 38.66973027777778
            },
            "time_count_per_day": {
              "2025-11-14": 1,
              "2025-11-17": 1,
              "2026-02-23": 1,
              "2026-03-02": 2,
              "2026-03-04": 1,
              "2026-04-23": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 139.58,
              "mode_time_hours": 33.0,
              "mode_frequency": 2,
              "time_distribution": {
                "32-34h": 2,
                "38-40h": 1,
                "42-44h": 1,
                "64-66h": 1,
                "92-94h": 1,
                "670-672h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2026-02-23": 1,
                "2026-03-02": 2,
                "2026-03-04": 1,
                "2026-04-23": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2025-11-14": 92.28892916666668,
                "2026-02-23": 65.45367722222223,
                "2026-03-02": 66.02860472222221,
                "2026-03-04": 42.899946944444444,
                "2026-04-23": 671.7293316666667,
                "2026-05-04": 38.66973027777778
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2026-02-23": 1,
                "2026-03-02": 2,
                "2026-03-04": 1,
                "2026-04-23": 1,
                "2026-05-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 81.5,
              "mode_time_hours": 81.0,
              "mode_frequency": 1,
              "time_distribution": {
                "80-82h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 81.49953166666667
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_453": {
      "overall": {
        "avg_time_hours": 160.24,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "24-26h": 1,
          "62-64h": 1,
          "68-70h": 1,
          "76-78h": 1,
          "84-86h": 1,
          "118-120h": 1,
          "126-128h": 1,
          "192-194h": 1,
          "246-248h": 1,
          "756-758h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2025-11-21": 2,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-03-16": 1,
          "2026-04-10": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-05-04": 1,
          "2026-05-17": 1
        },
        "time_per_day": {
          "2025-11-12": 25.25656944444444,
          "2025-11-17": 76.18902583333333,
          "2025-11-21": 121.60709777777778,
          "2025-12-18": 85.17574111111111,
          "2025-12-26": 127.24773416666666,
          "2026-03-16": 69.29073916666667,
          "2026-04-10": 247.02577527777777,
          "2026-04-20": 62.22989333333334,
          "2026-04-23": 756.0410836111112,
          "2026-05-17": 192.58819499999998
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2025-11-21": 2,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-03-16": 1,
          "2026-04-10": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-05-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 179.73,
          "mode_time_hours": 77.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "62-64h": 1,
            "68-70h": 1,
            "76-78h": 1,
            "84-86h": 1,
            "126-128h": 1,
            "192-194h": 1,
            "246-248h": 1,
            "756-758h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-03-16": 1,
            "2026-04-10": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-04-27": 1,
            "2026-05-04": 1,
            "2026-05-17": 1
          },
          "time_per_day": {
            "2025-11-17": 76.18902583333333,
            "2025-11-21": 1.814517777777778,
            "2025-12-18": 85.17574111111111,
            "2025-12-26": 127.24773416666666,
            "2026-03-16": 69.29073916666667,
            "2026-04-10": 247.02577527777777,
            "2026-04-20": 62.22989333333334,
            "2026-04-23": 756.0410836111112,
            "2026-05-17": 192.58819499999998
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-21": 1,
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-03-16": 1,
            "2026-04-10": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-05-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 72.52,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "118-120h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-21": 1
          },
          "time_per_day": {
            "2025-11-12": 25.25656944444444,
            "2025-11-21": 119.79258
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 160.24,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "24-26h": 1,
              "62-64h": 1,
              "68-70h": 1,
              "76-78h": 1,
              "84-86h": 1,
              "118-120h": 1,
              "126-128h": 1,
              "192-194h": 1,
              "246-248h": 1,
              "756-758h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2025-11-21": 2,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-03-16": 1,
              "2026-04-10": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-05-17": 1
            },
            "time_per_day": {
              "2025-11-12": 25.25656944444444,
              "2025-11-17": 76.18902583333333,
              "2025-11-21": 121.60709777777778,
              "2025-12-18": 85.17574111111111,
              "2025-12-26": 127.24773416666666,
              "2026-03-16": 69.29073916666667,
              "2026-04-10": 247.02577527777777,
              "2026-04-20": 62.22989333333334,
              "2026-04-23": 756.0410836111112,
              "2026-05-17": 192.58819499999998
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2025-11-21": 2,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-03-16": 1,
              "2026-04-10": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-05-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 179.73,
              "mode_time_hours": 77.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "62-64h": 1,
                "68-70h": 1,
                "76-78h": 1,
                "84-86h": 1,
                "126-128h": 1,
                "192-194h": 1,
                "246-248h": 1,
                "756-758h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-03-16": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-05-17": 1
              },
              "time_per_day": {
                "2025-11-17": 76.18902583333333,
                "2025-11-21": 1.814517777777778,
                "2025-12-18": 85.17574111111111,
                "2025-12-26": 127.24773416666666,
                "2026-03-16": 69.29073916666667,
                "2026-04-10": 247.02577527777777,
                "2026-04-20": 62.22989333333334,
                "2026-04-23": 756.0410836111112,
                "2026-05-17": 192.58819499999998
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-21": 1,
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-03-16": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-05-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 72.52,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "118-120h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-21": 1
              },
              "time_per_day": {
                "2025-11-12": 25.25656944444444,
                "2025-11-21": 119.79258
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-21": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_460": {
      "overall": {
        "avg_time_hours": 301.23,
        "mode_time_hours": 507.0,
        "mode_frequency": 1,
        "time_distribution": {
          "94-96h": 1,
          "506-508h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-02": 1,
          "2026-02-03": 1
        },
        "time_per_day": {
          "2025-12-02": 506.5078663888889,
          "2026-02-03": 95.946235
        },
        "time_count_per_day": {
          "2025-12-02": 1,
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 301.23,
          "mode_time_hours": 507.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1,
            "506-508h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-12-02": 506.5078663888889,
            "2026-02-03": 95.946235
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 301.23,
            "mode_time_hours": 507.0,
            "mode_frequency": 1,
            "time_distribution": {
              "94-96h": 1,
              "506-508h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-02": 1,
              "2026-02-03": 1
            },
            "time_per_day": {
              "2025-12-02": 506.5078663888889,
              "2026-02-03": 95.946235
            },
            "time_count_per_day": {
              "2025-12-02": 1,
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 301.23,
              "mode_time_hours": 507.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1,
                "506-508h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-12-02": 506.5078663888889,
                "2026-02-03": 95.946235
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "Inês Martinho": {
      "overall": {
        "avg_time_hours": 225.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 18,
        "time_distribution": {
          "0-2h": 18,
          "2-4h": 4,
          "4-6h": 3,
          "6-8h": 2,
          "10-12h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "28-30h": 1,
          "54-56h": 1,
          "64-66h": 1,
          "66-68h": 1,
          "216-218h": 1,
          "238-240h": 1,
          "262-264h": 1,
          "290-292h": 1,
          "308-310h": 1,
          "348-350h": 1,
          "376-378h": 1,
          "526-528h": 2,
          "548-550h": 2,
          "550-552h": 1,
          "570-572h": 1,
          "748-750h": 1,
          "1178-1180h": 1,
          "1964-1966h": 2
        },
        "tickets_count": 52,
        "tickets_per_day": {
          "2025-11-21": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-05": 1,
          "2025-12-10": 2,
          "2025-12-11": 2,
          "2025-12-12": 2,
          "2026-01-13": 2,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-21": 2,
          "2026-01-28": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 4,
          "2026-02-19": 3,
          "2026-02-20": 2,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-06": 2,
          "2026-04-13": 2,
          "2026-04-27": 3,
          "2026-05-02": 1,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-26": 2,
          "2026-05-29": 2
        },
        "time_per_day": {
          "2025-11-21": 55.702959722222225,
          "2025-11-27": 377.53523416666667,
          "2025-11-28": 65.32657527777778,
          "2025-12-05": 66.83238083333333,
          "2025-12-10": 0.7750708333333334,
          "2025-12-11": 1097.0582125,
          "2025-12-12": 1076.9807697222222,
          "2026-01-13": 4.383725277777778,
          "2026-01-15": 748.9313886111111,
          "2026-01-19": 0.05395916666666666,
          "2026-01-21": 291.57637444444447,
          "2026-01-28": 20.397658055555556,
          "2026-02-04": 16.701214166666666,
          "2026-02-10": 263.54914861111115,
          "2026-02-18": 529.2342805555556,
          "2026-02-19": 4499.0419108333335,
          "2026-02-20": 0.04142222222222223,
          "2026-02-23": 308.14055583333334,
          "2026-02-25": 348.57822444444446,
          "2026-02-26": 0.22124833333333335,
          "2026-03-04": 28.9409075,
          "2026-03-06": 0.2590311111111111,
          "2026-03-10": 239.0414788888889,
          "2026-03-18": 216.16211388888888,
          "2026-03-20": 1179.3464297222222,
          "2026-04-06": 9.702935555555555,
          "2026-04-13": 1.2565858333333333,
          "2026-04-27": 1.3541961111111114,
          "2026-05-06": 2.9222366666666666,
          "2026-05-07": 11.49567888888889,
          "2026-05-12": 2.791219722222222,
          "2026-05-18": 0.26078416666666665,
          "2026-05-26": 12.423181944444444,
          "2026-05-29": 9.398437222222222
        },
        "time_count_per_day": {
          "2025-11-21": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2025-12-05": 1,
          "2025-12-10": 2,
          "2025-12-11": 2,
          "2025-12-12": 2,
          "2026-01-13": 2,
          "2026-01-15": 1,
          "2026-01-19": 1,
          "2026-01-21": 2,
          "2026-01-28": 1,
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-18": 4,
          "2026-02-19": 3,
          "2026-02-20": 2,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-03-04": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-06": 2,
          "2026-04-13": 2,
          "2026-04-27": 3,
          "2026-05-06": 1,
          "2026-05-07": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-26": 2,
          "2026-05-29": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 117.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 16,
          "time_distribution": {
            "0-2h": 16,
            "2-4h": 3,
            "4-6h": 3,
            "6-8h": 2,
            "10-12h": 1,
            "16-18h": 1,
            "28-30h": 1,
            "238-240h": 1,
            "290-292h": 1,
            "348-350h": 1,
            "526-528h": 1,
            "550-552h": 1,
            "748-750h": 1,
            "1178-1180h": 1
          },
          "tickets_count": 34,
          "tickets_per_day": {
            "2025-12-10": 1,
            "2025-12-12": 2,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-01-21": 2,
            "2026-02-04": 1,
            "2026-02-18": 3,
            "2026-02-20": 2,
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-06": 2,
            "2026-04-13": 2,
            "2026-04-27": 3,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-26": 2,
            "2026-05-29": 2
          },
          "time_per_day": {
            "2025-12-10": 0.39130833333333337,
            "2025-12-12": 1076.9807697222222,
            "2026-01-15": 748.9313886111111,
            "2026-01-19": 0.05395916666666666,
            "2026-01-21": 291.57637444444447,
            "2026-02-04": 16.701214166666666,
            "2026-02-18": 2.974482777777778,
            "2026-02-20": 0.04142222222222223,
            "2026-02-25": 348.57822444444446,
            "2026-02-26": 0.22124833333333335,
            "2026-03-04": 28.9409075,
            "2026-03-06": 0.2590311111111111,
            "2026-03-10": 239.0414788888889,
            "2026-03-20": 1179.3464297222222,
            "2026-04-06": 9.702935555555555,
            "2026-04-13": 1.2565858333333333,
            "2026-04-27": 1.3541961111111114,
            "2026-05-06": 2.9222366666666666,
            "2026-05-07": 11.49567888888889,
            "2026-05-12": 2.791219722222222,
            "2026-05-18": 0.26078416666666665,
            "2026-05-26": 12.423181944444444,
            "2026-05-29": 9.398437222222222
          },
          "time_count_per_day": {
            "2025-12-10": 1,
            "2025-12-12": 2,
            "2026-01-15": 1,
            "2026-01-19": 1,
            "2026-01-21": 2,
            "2026-02-04": 1,
            "2026-02-18": 3,
            "2026-02-20": 2,
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-03-04": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-06": 2,
            "2026-04-13": 2,
            "2026-04-27": 3,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-26": 2,
            "2026-05-29": 2
          }
        },
        "P3": {
          "avg_time_hours": 150.9,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "20-22h": 1,
            "54-56h": 1,
            "64-66h": 1,
            "308-310h": 1,
            "376-378h": 1,
            "526-528h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-10": 1,
            "2026-01-13": 2,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-23": 1
          },
          "time_per_day": {
            "2025-11-21": 55.702959722222225,
            "2025-11-27": 377.53523416666667,
            "2025-11-28": 65.32657527777778,
            "2025-12-10": 0.3837625,
            "2026-01-13": 4.383725277777778,
            "2026-01-28": 20.397658055555556,
            "2026-02-18": 526.2597977777779,
            "2026-02-23": 308.14055583333334
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-10": 1,
            "2026-01-13": 2,
            "2026-01-28": 1,
            "2026-02-18": 1,
            "2026-02-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 182.18,
          "mode_time_hours": 67.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1,
            "216-218h": 1,
            "262-264h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-02-10": 1,
            "2026-03-18": 1,
            "2026-05-02": 1
          },
          "time_per_day": {
            "2025-12-05": 66.83238083333333,
            "2026-02-10": 263.54914861111115,
            "2026-03-18": 216.16211388888888
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-02-10": 1,
            "2026-03-18": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1119.22,
          "mode_time_hours": 549.0,
          "mode_frequency": 2,
          "time_distribution": {
            "548-550h": 2,
            "570-572h": 1,
            "1964-1966h": 2
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-11": 2,
            "2026-02-19": 3
          },
          "time_per_day": {
            "2025-12-11": 1097.0582125,
            "2026-02-19": 4499.0419108333335
          },
          "time_count_per_day": {
            "2025-12-11": 2,
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 225.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 18,
            "time_distribution": {
              "0-2h": 18,
              "2-4h": 4,
              "4-6h": 3,
              "6-8h": 2,
              "10-12h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "28-30h": 1,
              "54-56h": 1,
              "64-66h": 1,
              "66-68h": 1,
              "216-218h": 1,
              "238-240h": 1,
              "262-264h": 1,
              "290-292h": 1,
              "308-310h": 1,
              "348-350h": 1,
              "376-378h": 1,
              "526-528h": 2,
              "548-550h": 2,
              "550-552h": 1,
              "570-572h": 1,
              "748-750h": 1,
              "1178-1180h": 1,
              "1964-1966h": 2
            },
            "tickets_count": 51,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-05": 1,
              "2025-12-10": 2,
              "2025-12-11": 2,
              "2025-12-12": 2,
              "2026-01-13": 2,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-21": 2,
              "2026-01-28": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 4,
              "2026-02-19": 3,
              "2026-02-20": 2,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-06": 2,
              "2026-04-13": 2,
              "2026-04-27": 3,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-26": 2,
              "2026-05-29": 2
            },
            "time_per_day": {
              "2025-11-21": 55.702959722222225,
              "2025-11-27": 377.53523416666667,
              "2025-11-28": 65.32657527777778,
              "2025-12-05": 66.83238083333333,
              "2025-12-10": 0.7750708333333334,
              "2025-12-11": 1097.0582125,
              "2025-12-12": 1076.9807697222222,
              "2026-01-13": 4.383725277777778,
              "2026-01-15": 748.9313886111111,
              "2026-01-19": 0.05395916666666666,
              "2026-01-21": 291.57637444444447,
              "2026-01-28": 20.397658055555556,
              "2026-02-04": 16.701214166666666,
              "2026-02-10": 263.54914861111115,
              "2026-02-18": 529.2342805555556,
              "2026-02-19": 4499.0419108333335,
              "2026-02-20": 0.04142222222222223,
              "2026-02-23": 308.14055583333334,
              "2026-02-25": 348.57822444444446,
              "2026-02-26": 0.22124833333333335,
              "2026-03-04": 28.9409075,
              "2026-03-06": 0.2590311111111111,
              "2026-03-10": 239.0414788888889,
              "2026-03-18": 216.16211388888888,
              "2026-03-20": 1179.3464297222222,
              "2026-04-06": 9.702935555555555,
              "2026-04-13": 1.2565858333333333,
              "2026-04-27": 1.3541961111111114,
              "2026-05-06": 2.9222366666666666,
              "2026-05-07": 11.49567888888889,
              "2026-05-12": 2.791219722222222,
              "2026-05-18": 0.26078416666666665,
              "2026-05-26": 12.423181944444444,
              "2026-05-29": 9.398437222222222
            },
            "time_count_per_day": {
              "2025-11-21": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2025-12-05": 1,
              "2025-12-10": 2,
              "2025-12-11": 2,
              "2025-12-12": 2,
              "2026-01-13": 2,
              "2026-01-15": 1,
              "2026-01-19": 1,
              "2026-01-21": 2,
              "2026-01-28": 1,
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-18": 4,
              "2026-02-19": 3,
              "2026-02-20": 2,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-03-04": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-06": 2,
              "2026-04-13": 2,
              "2026-04-27": 3,
              "2026-05-06": 1,
              "2026-05-07": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-26": 2,
              "2026-05-29": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 117.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 16,
              "time_distribution": {
                "0-2h": 16,
                "2-4h": 3,
                "4-6h": 3,
                "6-8h": 2,
                "10-12h": 1,
                "16-18h": 1,
                "28-30h": 1,
                "238-240h": 1,
                "290-292h": 1,
                "348-350h": 1,
                "526-528h": 1,
                "550-552h": 1,
                "748-750h": 1,
                "1178-1180h": 1
              },
              "tickets_count": 34,
              "tickets_per_day": {
                "2025-12-10": 1,
                "2025-12-12": 2,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-01-21": 2,
                "2026-02-04": 1,
                "2026-02-18": 3,
                "2026-02-20": 2,
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-06": 2,
                "2026-04-13": 2,
                "2026-04-27": 3,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-26": 2,
                "2026-05-29": 2
              },
              "time_per_day": {
                "2025-12-10": 0.39130833333333337,
                "2025-12-12": 1076.9807697222222,
                "2026-01-15": 748.9313886111111,
                "2026-01-19": 0.05395916666666666,
                "2026-01-21": 291.57637444444447,
                "2026-02-04": 16.701214166666666,
                "2026-02-18": 2.974482777777778,
                "2026-02-20": 0.04142222222222223,
                "2026-02-25": 348.57822444444446,
                "2026-02-26": 0.22124833333333335,
                "2026-03-04": 28.9409075,
                "2026-03-06": 0.2590311111111111,
                "2026-03-10": 239.0414788888889,
                "2026-03-20": 1179.3464297222222,
                "2026-04-06": 9.702935555555555,
                "2026-04-13": 1.2565858333333333,
                "2026-04-27": 1.3541961111111114,
                "2026-05-06": 2.9222366666666666,
                "2026-05-07": 11.49567888888889,
                "2026-05-12": 2.791219722222222,
                "2026-05-18": 0.26078416666666665,
                "2026-05-26": 12.423181944444444,
                "2026-05-29": 9.398437222222222
              },
              "time_count_per_day": {
                "2025-12-10": 1,
                "2025-12-12": 2,
                "2026-01-15": 1,
                "2026-01-19": 1,
                "2026-01-21": 2,
                "2026-02-04": 1,
                "2026-02-18": 3,
                "2026-02-20": 2,
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-03-04": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-06": 2,
                "2026-04-13": 2,
                "2026-04-27": 3,
                "2026-05-06": 1,
                "2026-05-07": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-26": 2,
                "2026-05-29": 2
              }
            },
            "P3": {
              "avg_time_hours": 150.9,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "20-22h": 1,
                "54-56h": 1,
                "64-66h": 1,
                "308-310h": 1,
                "376-378h": 1,
                "526-528h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-10": 1,
                "2026-01-13": 2,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-23": 1
              },
              "time_per_day": {
                "2025-11-21": 55.702959722222225,
                "2025-11-27": 377.53523416666667,
                "2025-11-28": 65.32657527777778,
                "2025-12-10": 0.3837625,
                "2026-01-13": 4.383725277777778,
                "2026-01-28": 20.397658055555556,
                "2026-02-18": 526.2597977777779,
                "2026-02-23": 308.14055583333334
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2025-12-10": 1,
                "2026-01-13": 2,
                "2026-01-28": 1,
                "2026-02-18": 1,
                "2026-02-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 182.18,
              "mode_time_hours": 67.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1,
                "216-218h": 1,
                "262-264h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-02-10": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2025-12-05": 66.83238083333333,
                "2026-02-10": 263.54914861111115,
                "2026-03-18": 216.16211388888888
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-02-10": 1,
                "2026-03-18": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1119.22,
              "mode_time_hours": 549.0,
              "mode_frequency": 2,
              "time_distribution": {
                "548-550h": 2,
                "570-572h": 1,
                "1964-1966h": 2
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-11": 2,
                "2026-02-19": 3
              },
              "time_per_day": {
                "2025-12-11": 1097.0582125,
                "2026-02-19": 4499.0419108333335
              },
              "time_count_per_day": {
                "2025-12-11": 2,
                "2026-02-19": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_462": {
      "overall": {
        "avg_time_hours": 5.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "2-4h": 5,
          "16-18h": 1,
          "18-20h": 1,
          "62-64h": 1
        },
        "tickets_count": 23,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2026-02-20": 1,
          "2026-02-26": 1,
          "2026-03-24": 2,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-10": 6,
          "2026-04-27": 2,
          "2026-04-30": 1,
          "2026-05-05": 2,
          "2026-05-08": 2,
          "2026-05-11": 2,
          "2026-05-25": 1
        },
        "time_per_day": {
          "2025-11-12": 16.253771944444445,
          "2026-02-20": 0.07834,
          "2026-02-26": 0.02675472222222222,
          "2026-03-24": 0.043583055555555555,
          "2026-03-25": 0.05215277777777778,
          "2026-04-02": 0.04966555555555555,
          "2026-04-10": 0.39688,
          "2026-04-27": 65.655925,
          "2026-04-30": 18.942293055555556,
          "2026-05-05": 1.3730547222222222,
          "2026-05-08": 7.928483333333334,
          "2026-05-11": 6.966011666666667,
          "2026-05-25": 0.0167225
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2026-02-20": 1,
          "2026-02-26": 1,
          "2026-03-24": 2,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-10": 6,
          "2026-04-27": 2,
          "2026-04-30": 1,
          "2026-05-05": 2,
          "2026-05-08": 2,
          "2026-05-11": 2,
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 5,
            "16-18h": 1,
            "18-20h": 1,
            "62-64h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2026-02-20": 1,
            "2026-02-26": 1,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-04-02": 1,
            "2026-04-10": 6,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-05": 2,
            "2026-05-08": 2,
            "2026-05-11": 2,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2025-11-12": 16.253771944444445,
            "2026-02-20": 0.07834,
            "2026-02-26": 0.02675472222222222,
            "2026-03-24": 0.043583055555555555,
            "2026-03-25": 0.05215277777777778,
            "2026-04-02": 0.04966555555555555,
            "2026-04-10": 0.39688,
            "2026-04-27": 65.655925,
            "2026-04-30": 18.942293055555556,
            "2026-05-05": 1.3730547222222222,
            "2026-05-08": 7.928483333333334,
            "2026-05-11": 6.966011666666667,
            "2026-05-25": 0.0167225
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2026-02-20": 1,
            "2026-02-26": 1,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-04-02": 1,
            "2026-04-10": 6,
            "2026-04-27": 2,
            "2026-04-30": 1,
            "2026-05-05": 2,
            "2026-05-08": 2,
            "2026-05-11": 2,
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "2-4h": 5,
              "16-18h": 1,
              "18-20h": 1,
              "62-64h": 1
            },
            "tickets_count": 23,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2026-02-20": 1,
              "2026-02-26": 1,
              "2026-03-24": 2,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-10": 6,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-05": 2,
              "2026-05-08": 2,
              "2026-05-11": 2,
              "2026-05-25": 1
            },
            "time_per_day": {
              "2025-11-12": 16.253771944444445,
              "2026-02-20": 0.07834,
              "2026-02-26": 0.02675472222222222,
              "2026-03-24": 0.043583055555555555,
              "2026-03-25": 0.05215277777777778,
              "2026-04-02": 0.04966555555555555,
              "2026-04-10": 0.39688,
              "2026-04-27": 65.655925,
              "2026-04-30": 18.942293055555556,
              "2026-05-05": 1.3730547222222222,
              "2026-05-08": 7.928483333333334,
              "2026-05-11": 6.966011666666667,
              "2026-05-25": 0.0167225
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2026-02-20": 1,
              "2026-02-26": 1,
              "2026-03-24": 2,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-10": 6,
              "2026-04-27": 2,
              "2026-04-30": 1,
              "2026-05-05": 2,
              "2026-05-08": 2,
              "2026-05-11": 2,
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 5,
                "16-18h": 1,
                "18-20h": 1,
                "62-64h": 1
              },
              "tickets_count": 23,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2026-02-20": 1,
                "2026-02-26": 1,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-04-02": 1,
                "2026-04-10": 6,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-05": 2,
                "2026-05-08": 2,
                "2026-05-11": 2,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2025-11-12": 16.253771944444445,
                "2026-02-20": 0.07834,
                "2026-02-26": 0.02675472222222222,
                "2026-03-24": 0.043583055555555555,
                "2026-03-25": 0.05215277777777778,
                "2026-04-02": 0.04966555555555555,
                "2026-04-10": 0.39688,
                "2026-04-27": 65.655925,
                "2026-04-30": 18.942293055555556,
                "2026-05-05": 1.3730547222222222,
                "2026-05-08": 7.928483333333334,
                "2026-05-11": 6.966011666666667,
                "2026-05-25": 0.0167225
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2026-02-20": 1,
                "2026-02-26": 1,
                "2026-03-24": 2,
                "2026-03-25": 1,
                "2026-04-02": 1,
                "2026-04-10": 6,
                "2026-04-27": 2,
                "2026-04-30": 1,
                "2026-05-05": 2,
                "2026-05-08": 2,
                "2026-05-11": 2,
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_463": {
      "overall": {
        "avg_time_hours": 43.93,
        "mode_time_hours": 43.0,
        "mode_frequency": 1,
        "time_distribution": {
          "42-44h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-11-13": 43.93203694444445
        },
        "time_count_per_day": {
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 43.93,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 43.93203694444445
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 43.93,
            "mode_time_hours": 43.0,
            "mode_frequency": 1,
            "time_distribution": {
              "42-44h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-11-13": 43.93203694444445
            },
            "time_count_per_day": {
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 43.93,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 43.93203694444445
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_464": {
      "overall": {
        "avg_time_hours": 9.96,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-12": 1
        },
        "time_per_day": {
          "2025-11-12": 9.96106638888889
        },
        "time_count_per_day": {
          "2025-11-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 9.96,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-12": 1
          },
          "time_per_day": {
            "2025-11-12": 9.96106638888889
          },
          "time_count_per_day": {
            "2025-11-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.96,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-12": 1
            },
            "time_per_day": {
              "2025-11-12": 9.96106638888889
            },
            "time_count_per_day": {
              "2025-11-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 9.96,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-12": 1
              },
              "time_per_day": {
                "2025-11-12": 9.96106638888889
              },
              "time_count_per_day": {
                "2025-11-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_466": {
      "overall": {
        "avg_time_hours": 319.02,
        "mode_time_hours": 175.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 1,
          "22-24h": 1,
          "174-176h": 2,
          "1216-1218h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-19": 2,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-11-12": 4.8381211111111115,
          "2025-11-13": 22.762789722222223,
          "2025-11-19": 350.4056013888889,
          "2026-04-23": 1217.0769691666667
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2025-11-13": 1,
          "2025-11-19": 2,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1217.08,
          "mode_time_hours": 1217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1216-1218h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 1217.0769691666667
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 94.5,
          "mode_time_hours": 175.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 1,
            "22-24h": 1,
            "174-176h": 2
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-19": 2
          },
          "time_per_day": {
            "2025-11-12": 4.8381211111111115,
            "2025-11-13": 22.762789722222223,
            "2025-11-19": 350.4056013888889
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-11-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 319.02,
            "mode_time_hours": 175.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 1,
              "22-24h": 1,
              "174-176h": 2,
              "1216-1218h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-19": 2,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-11-12": 4.8381211111111115,
              "2025-11-13": 22.762789722222223,
              "2025-11-19": 350.4056013888889,
              "2026-04-23": 1217.0769691666667
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2025-11-13": 1,
              "2025-11-19": 2,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1217.08,
              "mode_time_hours": 1217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1216-1218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 1217.0769691666667
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 94.5,
              "mode_time_hours": 175.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 1,
                "22-24h": 1,
                "174-176h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-19": 2
              },
              "time_per_day": {
                "2025-11-12": 4.8381211111111115,
                "2025-11-13": 22.762789722222223,
                "2025-11-19": 350.4056013888889
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2025-11-13": 1,
                "2025-11-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_468": {
      "overall": {
        "avg_time_hours": 5.6,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2026-03-23": 1,
          "2026-03-25": 1
        },
        "time_per_day": {
          "2025-11-12": 9.633716388888889,
          "2025-11-17": 6.722925277777778,
          "2026-03-23": 0.04945777777777778,
          "2026-03-25": 5.990718055555555
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2025-11-17": 1,
          "2026-03-23": 1,
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.25,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "6-8h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-03-23": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2025-11-17": 6.722925277777778,
            "2026-03-23": 0.04945777777777778,
            "2026-03-25": 5.990718055555555
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-03-23": 1,
            "2026-03-25": 1
          }
        },
        "P3": {
          "avg_time_hours": 9.63,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-12": 1
          },
          "time_per_day": {
            "2025-11-12": 9.633716388888889
          },
          "time_count_per_day": {
            "2025-11-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.6,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2026-03-23": 1,
              "2026-03-25": 1
            },
            "time_per_day": {
              "2025-11-12": 9.633716388888889,
              "2025-11-17": 6.722925277777778,
              "2026-03-23": 0.04945777777777778,
              "2026-03-25": 5.990718055555555
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2025-11-17": 1,
              "2026-03-23": 1,
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.25,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "6-8h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-03-23": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2025-11-17": 6.722925277777778,
                "2026-03-23": 0.04945777777777778,
                "2026-03-25": 5.990718055555555
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-03-23": 1,
                "2026-03-25": 1
              }
            },
            "P3": {
              "avg_time_hours": 9.63,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-12": 1
              },
              "time_per_day": {
                "2025-11-12": 9.633716388888889
              },
              "time_count_per_day": {
                "2025-11-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_469": {
      "overall": {
        "avg_time_hours": 11.54,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "16-18h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-12": 1,
          "2026-01-21": 1
        },
        "time_per_day": {
          "2025-11-12": 6.298097777777778,
          "2026-01-21": 16.783660277777777
        },
        "time_count_per_day": {
          "2025-11-12": 1,
          "2026-01-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.54,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "16-18h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-12": 1,
            "2026-01-21": 1
          },
          "time_per_day": {
            "2025-11-12": 6.298097777777778,
            "2026-01-21": 16.783660277777777
          },
          "time_count_per_day": {
            "2025-11-12": 1,
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.54,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "16-18h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-12": 1,
              "2026-01-21": 1
            },
            "time_per_day": {
              "2025-11-12": 6.298097777777778,
              "2026-01-21": 16.783660277777777
            },
            "time_count_per_day": {
              "2025-11-12": 1,
              "2026-01-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.54,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "16-18h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-12": 1,
                "2026-01-21": 1
              },
              "time_per_day": {
                "2025-11-12": 6.298097777777778,
                "2026-01-21": 16.783660277777777
              },
              "time_count_per_day": {
                "2025-11-12": 1,
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_470": {
      "overall": {
        "avg_time_hours": 242.38,
        "mode_time_hours": 13.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "4-6h": 2,
          "8-10h": 1,
          "12-14h": 2,
          "14-16h": 1,
          "22-24h": 1,
          "36-38h": 1,
          "72-74h": 1,
          "76-78h": 1,
          "94-96h": 1,
          "98-100h": 1,
          "114-116h": 1,
          "116-118h": 1,
          "168-170h": 1,
          "244-246h": 1,
          "472-474h": 1,
          "488-490h": 1,
          "1054-1056h": 2,
          "1390-1392h": 1
        },
        "tickets_count": 25,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-12-02": 1,
          "2026-01-27": 1,
          "2026-01-29": 4,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-19": 1,
          "2026-03-30": 1,
          "2026-04-23": 2,
          "2026-05-05": 2,
          "2026-05-27": 1,
          "2026-06-03": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-11-17": 94.8468775,
          "2025-11-24": 72.77445472222223,
          "2025-12-02": 489.7010875,
          "2026-01-27": 22.20398888888889,
          "2026-01-29": 37.120696111111116,
          "2026-01-30": 98.05877500000001,
          "2026-02-03": 129.42403194444447,
          "2026-02-18": 114.85683888888889,
          "2026-03-06": 245.65744305555558,
          "2026-03-10": 2.9941150000000003,
          "2026-03-19": 1390.7594875,
          "2026-03-30": 472.7856775,
          "2026-04-23": 2108.3394561111113,
          "2026-05-05": 285.21899527777776,
          "2026-06-03": 0.8039202777777777,
          "2026-06-05": 9.1564325
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-11-24": 1,
          "2025-12-02": 1,
          "2026-01-27": 1,
          "2026-01-29": 4,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-18": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-19": 1,
          "2026-03-30": 1,
          "2026-04-23": 2,
          "2026-05-05": 2,
          "2026-06-03": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 378.18,
          "mode_time_hours": 1055.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "8-10h": 1,
            "22-24h": 1,
            "94-96h": 1,
            "116-118h": 1,
            "168-170h": 1,
            "244-246h": 1,
            "1054-1056h": 2,
            "1390-1392h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-01-27": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-19": 1,
            "2026-04-23": 2,
            "2026-05-05": 2,
            "2026-05-27": 1,
            "2026-06-03": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-11-17": 94.8468775,
            "2026-01-27": 22.20398888888889,
            "2026-03-06": 245.65744305555558,
            "2026-03-10": 2.9941150000000003,
            "2026-03-19": 1390.7594875,
            "2026-04-23": 2108.3394561111113,
            "2026-05-05": 285.21899527777776,
            "2026-06-03": 0.8039202777777777,
            "2026-06-05": 9.1564325
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-01-27": 1,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-19": 1,
            "2026-04-23": 2,
            "2026-05-05": 2,
            "2026-06-03": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 117.89,
          "mode_time_hours": 13.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "12-14h": 2,
            "14-16h": 1,
            "36-38h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "98-100h": 1,
            "114-116h": 1,
            "472-474h": 1,
            "488-490h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2026-01-29": 4,
            "2026-01-30": 1,
            "2026-02-03": 3,
            "2026-02-18": 1,
            "2026-03-30": 1
          },
          "time_per_day": {
            "2025-11-24": 72.77445472222223,
            "2025-12-02": 489.7010875,
            "2026-01-29": 37.120696111111116,
            "2026-01-30": 98.05877500000001,
            "2026-02-03": 129.42403194444447,
            "2026-02-18": 114.85683888888889,
            "2026-03-30": 472.7856775
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-02": 1,
            "2026-01-29": 4,
            "2026-01-30": 1,
            "2026-02-03": 3,
            "2026-02-18": 1,
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 242.38,
            "mode_time_hours": 13.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "4-6h": 2,
              "8-10h": 1,
              "12-14h": 2,
              "14-16h": 1,
              "22-24h": 1,
              "36-38h": 1,
              "72-74h": 1,
              "76-78h": 1,
              "94-96h": 1,
              "98-100h": 1,
              "114-116h": 1,
              "116-118h": 1,
              "168-170h": 1,
              "244-246h": 1,
              "472-474h": 1,
              "488-490h": 1,
              "1054-1056h": 2,
              "1390-1392h": 1
            },
            "tickets_count": 23,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-12-02": 1,
              "2026-01-27": 1,
              "2026-01-29": 4,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-19": 1,
              "2026-03-30": 1,
              "2026-04-23": 2,
              "2026-05-05": 2,
              "2026-06-03": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-11-17": 94.8468775,
              "2025-11-24": 72.77445472222223,
              "2025-12-02": 489.7010875,
              "2026-01-27": 22.20398888888889,
              "2026-01-29": 37.120696111111116,
              "2026-01-30": 98.05877500000001,
              "2026-02-03": 129.42403194444447,
              "2026-02-18": 114.85683888888889,
              "2026-03-06": 245.65744305555558,
              "2026-03-10": 2.9941150000000003,
              "2026-03-19": 1390.7594875,
              "2026-03-30": 472.7856775,
              "2026-04-23": 2108.3394561111113,
              "2026-05-05": 285.21899527777776,
              "2026-06-03": 0.8039202777777777,
              "2026-06-05": 9.1564325
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-11-24": 1,
              "2025-12-02": 1,
              "2026-01-27": 1,
              "2026-01-29": 4,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-18": 1,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-19": 1,
              "2026-03-30": 1,
              "2026-04-23": 2,
              "2026-05-05": 2,
              "2026-06-03": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 378.18,
              "mode_time_hours": 1055.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "8-10h": 1,
                "22-24h": 1,
                "94-96h": 1,
                "116-118h": 1,
                "168-170h": 1,
                "244-246h": 1,
                "1054-1056h": 2,
                "1390-1392h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-01-27": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-19": 1,
                "2026-04-23": 2,
                "2026-05-05": 2,
                "2026-06-03": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-11-17": 94.8468775,
                "2026-01-27": 22.20398888888889,
                "2026-03-06": 245.65744305555558,
                "2026-03-10": 2.9941150000000003,
                "2026-03-19": 1390.7594875,
                "2026-04-23": 2108.3394561111113,
                "2026-05-05": 285.21899527777776,
                "2026-06-03": 0.8039202777777777,
                "2026-06-05": 9.1564325
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-01-27": 1,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-19": 1,
                "2026-04-23": 2,
                "2026-05-05": 2,
                "2026-06-03": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 117.89,
              "mode_time_hours": 13.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "12-14h": 2,
                "14-16h": 1,
                "36-38h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "98-100h": 1,
                "114-116h": 1,
                "472-474h": 1,
                "488-490h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2026-01-29": 4,
                "2026-01-30": 1,
                "2026-02-03": 3,
                "2026-02-18": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2025-11-24": 72.77445472222223,
                "2025-12-02": 489.7010875,
                "2026-01-29": 37.120696111111116,
                "2026-01-30": 98.05877500000001,
                "2026-02-03": 129.42403194444447,
                "2026-02-18": 114.85683888888889,
                "2026-03-30": 472.7856775
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-02": 1,
                "2026-01-29": 4,
                "2026-01-30": 1,
                "2026-02-03": 3,
                "2026-02-18": 1,
                "2026-03-30": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-27": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-27": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_471": {
      "overall": {
        "avg_time_hours": 44.34,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-14": 1
        },
        "time_per_day": {
          "2025-11-14": 44.34451388888889
        },
        "time_count_per_day": {
          "2025-11-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 44.34,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 44.34451388888889
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 44.34,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-14": 1
            },
            "time_per_day": {
              "2025-11-14": 44.34451388888889
            },
            "time_count_per_day": {
              "2025-11-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 44.34,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 44.34451388888889
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_140": {
      "overall": {
        "avg_time_hours": 21.01,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-11-13": 21.005540555555555
        },
        "time_count_per_day": {
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 21.01,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 21.005540555555555
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 21.01,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-11-13": 21.005540555555555
            },
            "time_count_per_day": {
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 21.01,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 21.005540555555555
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_473": {
      "overall": {
        "avg_time_hours": 6.24,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-12": 1
        },
        "time_per_day": {
          "2025-11-12": 6.241104444444444
        },
        "time_count_per_day": {
          "2025-11-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.24,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-12": 1
          },
          "time_per_day": {
            "2025-11-12": 6.241104444444444
          },
          "time_count_per_day": {
            "2025-11-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.24,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-12": 1
            },
            "time_per_day": {
              "2025-11-12": 6.241104444444444
            },
            "time_count_per_day": {
              "2025-11-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.24,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-12": 1
              },
              "time_per_day": {
                "2025-11-12": 6.241104444444444
              },
              "time_count_per_day": {
                "2025-11-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_474": {
      "overall": {
        "avg_time_hours": 75.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 1,
          "6-8h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "16-18h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "34-36h": 2,
          "44-46h": 1,
          "50-52h": 1,
          "168-170h": 1,
          "172-174h": 1,
          "672-674h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-11-19": 1,
          "2025-12-09": 1,
          "2025-12-11": 1,
          "2025-12-14": 1,
          "2026-02-12": 1,
          "2026-02-14": 3,
          "2026-03-04": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-04-10": 1,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-05-15": 1,
          "2026-05-29": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-19": 168.9978152777778,
          "2025-12-09": 4.110259722222222,
          "2025-12-11": 26.730019444444448,
          "2025-12-14": 45.30548833333334,
          "2026-02-12": 0.34756916666666665,
          "2026-02-14": 91.27130388888888,
          "2026-03-04": 1.0049233333333334,
          "2026-03-23": 6.403849166666666,
          "2026-03-24": 11.054658888888888,
          "2026-03-27": 16.820572777777777,
          "2026-04-10": 50.79545666666667,
          "2026-04-17": 0.19221444444444444,
          "2026-04-22": 673.1216644444445,
          "2026-04-29": 172.6751986111111,
          "2026-06-03": 13.79013
        },
        "time_count_per_day": {
          "2025-11-19": 1,
          "2025-12-09": 1,
          "2025-12-11": 1,
          "2025-12-14": 1,
          "2026-02-12": 1,
          "2026-02-14": 3,
          "2026-03-04": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-04-10": 1,
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 172.68,
          "mode_time_hours": 173.0,
          "mode_frequency": 1,
          "time_distribution": {
            "172-174h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-04-29": 172.6751986111111
          },
          "time_count_per_day": {
            "2026-04-29": 1
          }
        },
        "P2": {
          "avg_time_hours": 77.76,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 1,
            "6-8h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "50-52h": 1,
            "672-674h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2026-02-12": 1,
            "2026-03-04": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-04-10": 1,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-05-15": 1,
            "2026-05-29": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-12-09": 4.110259722222222,
            "2026-02-12": 0.34756916666666665,
            "2026-03-04": 1.0049233333333334,
            "2026-03-23": 6.403849166666666,
            "2026-03-24": 11.054658888888888,
            "2026-03-27": 16.820572777777777,
            "2026-04-10": 50.79545666666667,
            "2026-04-17": 0.19221444444444444,
            "2026-04-22": 673.1216644444445,
            "2026-06-03": 13.79013
          },
          "time_count_per_day": {
            "2025-12-09": 1,
            "2026-02-12": 1,
            "2026-03-04": 1,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-04-10": 1,
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 55.38,
          "mode_time_hours": 35.0,
          "mode_frequency": 2,
          "time_distribution": {
            "20-22h": 1,
            "26-28h": 1,
            "34-36h": 2,
            "44-46h": 1,
            "168-170h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2025-12-11": 1,
            "2025-12-14": 1,
            "2026-02-14": 3
          },
          "time_per_day": {
            "2025-11-19": 168.9978152777778,
            "2025-12-11": 26.730019444444448,
            "2025-12-14": 45.30548833333334,
            "2026-02-14": 91.27130388888888
          },
          "time_count_per_day": {
            "2025-11-19": 1,
            "2025-12-11": 1,
            "2025-12-14": 1,
            "2026-02-14": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 75.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 1,
              "6-8h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "16-18h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "34-36h": 2,
              "44-46h": 1,
              "50-52h": 1,
              "168-170h": 1,
              "172-174h": 1,
              "672-674h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-11-19": 1,
              "2025-12-09": 1,
              "2025-12-11": 1,
              "2025-12-14": 1,
              "2026-02-12": 1,
              "2026-02-14": 3,
              "2026-03-04": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-04-10": 1,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-29": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-19": 168.9978152777778,
              "2025-12-09": 4.110259722222222,
              "2025-12-11": 26.730019444444448,
              "2025-12-14": 45.30548833333334,
              "2026-02-12": 0.34756916666666665,
              "2026-02-14": 91.27130388888888,
              "2026-03-04": 1.0049233333333334,
              "2026-03-23": 6.403849166666666,
              "2026-03-24": 11.054658888888888,
              "2026-03-27": 16.820572777777777,
              "2026-04-10": 50.79545666666667,
              "2026-04-17": 0.19221444444444444,
              "2026-04-22": 673.1216644444445,
              "2026-04-29": 172.6751986111111,
              "2026-06-03": 13.79013
            },
            "time_count_per_day": {
              "2025-11-19": 1,
              "2025-12-09": 1,
              "2025-12-11": 1,
              "2025-12-14": 1,
              "2026-02-12": 1,
              "2026-02-14": 3,
              "2026-03-04": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-04-10": 1,
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-04-29": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 172.68,
              "mode_time_hours": 173.0,
              "mode_frequency": 1,
              "time_distribution": {
                "172-174h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-04-29": 172.6751986111111
              },
              "time_count_per_day": {
                "2026-04-29": 1
              }
            },
            "P2": {
              "avg_time_hours": 77.76,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 1,
                "6-8h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "50-52h": 1,
                "672-674h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2026-02-12": 1,
                "2026-03-04": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-04-10": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-12-09": 4.110259722222222,
                "2026-02-12": 0.34756916666666665,
                "2026-03-04": 1.0049233333333334,
                "2026-03-23": 6.403849166666666,
                "2026-03-24": 11.054658888888888,
                "2026-03-27": 16.820572777777777,
                "2026-04-10": 50.79545666666667,
                "2026-04-17": 0.19221444444444444,
                "2026-04-22": 673.1216644444445,
                "2026-06-03": 13.79013
              },
              "time_count_per_day": {
                "2025-12-09": 1,
                "2026-02-12": 1,
                "2026-03-04": 1,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-04-10": 1,
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 55.38,
              "mode_time_hours": 35.0,
              "mode_frequency": 2,
              "time_distribution": {
                "20-22h": 1,
                "26-28h": 1,
                "34-36h": 2,
                "44-46h": 1,
                "168-170h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-19": 1,
                "2025-12-11": 1,
                "2025-12-14": 1,
                "2026-02-14": 3
              },
              "time_per_day": {
                "2025-11-19": 168.9978152777778,
                "2025-12-11": 26.730019444444448,
                "2025-12-14": 45.30548833333334,
                "2026-02-14": 91.27130388888888
              },
              "time_count_per_day": {
                "2025-11-19": 1,
                "2025-12-11": 1,
                "2025-12-14": 1,
                "2026-02-14": 3
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-15": 1,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-15": 1,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_156": {
      "overall": {
        "avg_time_hours": 17.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 182,
        "time_distribution": {
          "0-2h": 182,
          "2-4h": 48,
          "4-6h": 16,
          "6-8h": 8,
          "10-12h": 6,
          "12-14h": 7,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 2,
          "22-24h": 1,
          "36-38h": 2,
          "38-40h": 4,
          "64-66h": 2,
          "88-90h": 1,
          "96-98h": 1,
          "124-126h": 1,
          "496-498h": 1,
          "548-550h": 1,
          "572-574h": 1,
          "600-602h": 1,
          "746-748h": 1,
          "786-788h": 1
        },
        "tickets_count": 330,
        "tickets_per_day": {
          "2025-11-13": 1,
          "2025-12-07": 1,
          "2025-12-19": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-18": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-23": 5,
          "2026-03-09": 2,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-03-27": 3,
          "2026-03-30": 1,
          "2026-04-01": 1,
          "2026-04-02": 3,
          "2026-04-13": 1,
          "2026-04-30": 9,
          "2026-05-02": 10,
          "2026-05-04": 11,
          "2026-05-05": 3,
          "2026-05-06": 6,
          "2026-05-07": 11,
          "2026-05-08": 5,
          "2026-05-09": 6,
          "2026-05-11": 10,
          "2026-05-12": 7,
          "2026-05-13": 3,
          "2026-05-14": 9,
          "2026-05-15": 5,
          "2026-05-16": 1,
          "2026-05-18": 11,
          "2026-05-19": 19,
          "2026-05-20": 23,
          "2026-05-21": 19,
          "2026-05-22": 11,
          "2026-05-23": 5,
          "2026-05-25": 9,
          "2026-05-26": 16,
          "2026-05-27": 16,
          "2026-05-28": 2,
          "2026-05-29": 11,
          "2026-05-30": 6,
          "2026-06-01": 11,
          "2026-06-02": 19,
          "2026-06-03": 11,
          "2026-06-05": 6,
          "2026-06-06": 1,
          "2026-06-08": 11
        },
        "time_per_day": {
          "2025-11-13": 12.5855175,
          "2025-12-07": 0.18633083333333333,
          "2025-12-19": 5.068619166666666,
          "2026-01-14": 0.47695138888888894,
          "2026-01-17": 0.28999027777777775,
          "2026-01-18": 1.3861633333333334,
          "2026-01-30": 0.9634677777777778,
          "2026-02-09": 5.065665833333334,
          "2026-02-23": 124.99395861111113,
          "2026-03-09": 1.4818375,
          "2026-03-11": 0.07811583333333333,
          "2026-03-20": 600.0816230555555,
          "2026-03-26": 747.5918308333333,
          "2026-03-27": 5.3660105555555555,
          "2026-03-30": 497.95130916666665,
          "2026-04-01": 549.7094466666666,
          "2026-04-02": 0.48567916666666666,
          "2026-04-13": 787.3171486111111,
          "2026-04-30": 3.4262305555555557,
          "2026-05-02": 212.17499083333325,
          "2026-05-04": 19.15422722222222,
          "2026-05-05": 0.6769855555555556,
          "2026-05-06": 98.75792333333334,
          "2026-05-07": 16.436837777777782,
          "2026-05-08": 35.169357777777776,
          "2026-05-09": 31.034979999999997,
          "2026-05-11": 5.595398055555555,
          "2026-05-12": 8.887135277777777,
          "2026-05-13": 0.06584916666666667,
          "2026-05-14": 28.246594166666668,
          "2026-05-15": 1.5961105555555557,
          "2026-05-16": 17.723210833333333,
          "2026-05-18": 85.15305916666667,
          "2026-05-19": 149.99216527777776,
          "2026-05-20": 57.59739361111111,
          "2026-05-21": 27.47781249999999,
          "2026-05-22": 26.779635,
          "2026-05-23": 9.541636388888888,
          "2026-05-25": 6.7585275,
          "2026-05-26": 21.577936388888887,
          "2026-05-27": 48.342972222222215,
          "2026-05-28": 3.701981388888889,
          "2026-05-29": 13.195006111111113,
          "2026-05-30": 5.666988055555555,
          "2026-06-01": 34.635331111111114,
          "2026-06-02": 21.074491944444443,
          "2026-06-03": 53.82521861111111,
          "2026-06-05": 39.32898194444444,
          "2026-06-06": 572.3348752777778,
          "2026-06-08": 67.6122186111111
        },
        "time_count_per_day": {
          "2025-11-13": 1,
          "2025-12-07": 1,
          "2025-12-19": 1,
          "2026-01-14": 1,
          "2026-01-17": 1,
          "2026-01-18": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-23": 5,
          "2026-03-09": 2,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-03-26": 1,
          "2026-03-27": 3,
          "2026-03-30": 1,
          "2026-04-01": 1,
          "2026-04-02": 3,
          "2026-04-13": 1,
          "2026-04-30": 2,
          "2026-05-02": 10,
          "2026-05-04": 10,
          "2026-05-05": 1,
          "2026-05-06": 4,
          "2026-05-07": 10,
          "2026-05-08": 5,
          "2026-05-09": 4,
          "2026-05-11": 10,
          "2026-05-12": 6,
          "2026-05-13": 1,
          "2026-05-14": 9,
          "2026-05-15": 5,
          "2026-05-16": 1,
          "2026-05-18": 11,
          "2026-05-19": 19,
          "2026-05-20": 18,
          "2026-05-21": 18,
          "2026-05-22": 10,
          "2026-05-23": 5,
          "2026-05-25": 7,
          "2026-05-26": 16,
          "2026-05-27": 14,
          "2026-05-28": 2,
          "2026-05-29": 7,
          "2026-05-30": 4,
          "2026-06-01": 11,
          "2026-06-02": 18,
          "2026-06-03": 9,
          "2026-06-05": 4,
          "2026-06-06": 1,
          "2026-06-08": 10
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.24,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-01-14": 0.47695138888888894,
            "2026-06-01": 6.011644722222222
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-06-01": 1
          }
        },
        "P2": {
          "avg_time_hours": 17.69,
          "mode_time_hours": 1.0,
          "mode_frequency": 181,
          "time_distribution": {
            "0-2h": 181,
            "2-4h": 48,
            "4-6h": 15,
            "6-8h": 7,
            "10-12h": 6,
            "12-14h": 6,
            "16-18h": 1,
            "18-20h": 1,
            "20-22h": 2,
            "22-24h": 1,
            "36-38h": 2,
            "38-40h": 4,
            "64-66h": 2,
            "88-90h": 1,
            "96-98h": 1,
            "124-126h": 1,
            "496-498h": 1,
            "548-550h": 1,
            "572-574h": 1,
            "600-602h": 1,
            "746-748h": 1,
            "786-788h": 1
          },
          "tickets_count": 303,
          "tickets_per_day": {
            "2025-12-07": 1,
            "2025-12-19": 1,
            "2026-01-17": 1,
            "2026-01-18": 1,
            "2026-01-30": 1,
            "2026-02-23": 5,
            "2026-03-09": 2,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-27": 3,
            "2026-03-30": 1,
            "2026-04-01": 1,
            "2026-04-02": 3,
            "2026-04-13": 1,
            "2026-04-30": 4,
            "2026-05-02": 10,
            "2026-05-04": 10,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-07": 10,
            "2026-05-08": 5,
            "2026-05-09": 5,
            "2026-05-11": 10,
            "2026-05-12": 6,
            "2026-05-13": 3,
            "2026-05-14": 9,
            "2026-05-15": 5,
            "2026-05-16": 1,
            "2026-05-18": 11,
            "2026-05-19": 19,
            "2026-05-20": 20,
            "2026-05-21": 19,
            "2026-05-22": 11,
            "2026-05-23": 5,
            "2026-05-25": 7,
            "2026-05-26": 16,
            "2026-05-27": 15,
            "2026-05-28": 2,
            "2026-05-29": 9,
            "2026-05-30": 5,
            "2026-06-01": 10,
            "2026-06-02": 19,
            "2026-06-03": 11,
            "2026-06-05": 6,
            "2026-06-06": 1,
            "2026-06-08": 10
          },
          "time_per_day": {
            "2025-12-07": 0.18633083333333333,
            "2025-12-19": 5.068619166666666,
            "2026-01-17": 0.28999027777777775,
            "2026-01-18": 1.3861633333333334,
            "2026-01-30": 0.9634677777777778,
            "2026-02-23": 124.99395861111113,
            "2026-03-09": 1.4818375,
            "2026-03-11": 0.07811583333333333,
            "2026-03-20": 600.0816230555555,
            "2026-03-26": 747.5918308333333,
            "2026-03-27": 5.3660105555555555,
            "2026-03-30": 497.95130916666665,
            "2026-04-01": 549.7094466666666,
            "2026-04-02": 0.48567916666666666,
            "2026-04-13": 787.3171486111111,
            "2026-04-30": 3.4262305555555557,
            "2026-05-02": 212.17499083333325,
            "2026-05-04": 19.15422722222222,
            "2026-05-05": 0.6769855555555556,
            "2026-05-06": 98.75792333333334,
            "2026-05-07": 16.436837777777782,
            "2026-05-08": 35.169357777777776,
            "2026-05-09": 31.034979999999997,
            "2026-05-11": 5.595398055555555,
            "2026-05-12": 8.887135277777777,
            "2026-05-13": 0.06584916666666667,
            "2026-05-14": 28.246594166666668,
            "2026-05-15": 1.5961105555555557,
            "2026-05-16": 17.723210833333333,
            "2026-05-18": 85.15305916666667,
            "2026-05-19": 149.99216527777776,
            "2026-05-20": 57.59739361111111,
            "2026-05-21": 27.47781249999999,
            "2026-05-22": 26.779635,
            "2026-05-23": 9.541636388888888,
            "2026-05-25": 6.7585275,
            "2026-05-26": 21.577936388888887,
            "2026-05-27": 48.342972222222215,
            "2026-05-28": 3.701981388888889,
            "2026-05-29": 13.195006111111113,
            "2026-05-30": 5.666988055555555,
            "2026-06-01": 28.62368638888889,
            "2026-06-02": 21.074491944444443,
            "2026-06-03": 53.82521861111111,
            "2026-06-05": 39.32898194444444,
            "2026-06-06": 572.3348752777778,
            "2026-06-08": 67.6122186111111
          },
          "time_count_per_day": {
            "2025-12-07": 1,
            "2025-12-19": 1,
            "2026-01-17": 1,
            "2026-01-18": 1,
            "2026-01-30": 1,
            "2026-02-23": 5,
            "2026-03-09": 2,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-03-27": 3,
            "2026-03-30": 1,
            "2026-04-01": 1,
            "2026-04-02": 3,
            "2026-04-13": 1,
            "2026-04-30": 2,
            "2026-05-02": 10,
            "2026-05-04": 10,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-07": 10,
            "2026-05-08": 5,
            "2026-05-09": 4,
            "2026-05-11": 10,
            "2026-05-12": 6,
            "2026-05-13": 1,
            "2026-05-14": 9,
            "2026-05-15": 5,
            "2026-05-16": 1,
            "2026-05-18": 11,
            "2026-05-19": 19,
            "2026-05-20": 18,
            "2026-05-21": 18,
            "2026-05-22": 10,
            "2026-05-23": 5,
            "2026-05-25": 7,
            "2026-05-26": 16,
            "2026-05-27": 14,
            "2026-05-28": 2,
            "2026-05-29": 7,
            "2026-05-30": 4,
            "2026-06-01": 10,
            "2026-06-02": 18,
            "2026-06-03": 9,
            "2026-06-05": 4,
            "2026-06-06": 1,
            "2026-06-08": 10
          }
        },
        "P3": {
          "avg_time_hours": 12.59,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 12.5855175
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 5.07,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2026-02-09": 1,
            "2026-04-30": 5,
            "2026-05-04": 1,
            "2026-05-05": 2,
            "2026-05-06": 2,
            "2026-05-07": 1,
            "2026-05-09": 1,
            "2026-05-12": 1,
            "2026-05-20": 3,
            "2026-05-25": 2,
            "2026-05-27": 1,
            "2026-05-29": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-02-09": 5.065665833333334
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 182,
            "time_distribution": {
              "0-2h": 182,
              "2-4h": 48,
              "4-6h": 16,
              "6-8h": 8,
              "10-12h": 6,
              "12-14h": 7,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 2,
              "22-24h": 1,
              "36-38h": 2,
              "38-40h": 4,
              "64-66h": 2,
              "88-90h": 1,
              "96-98h": 1,
              "124-126h": 1,
              "496-498h": 1,
              "548-550h": 1,
              "572-574h": 1,
              "600-602h": 1,
              "746-748h": 1,
              "786-788h": 1
            },
            "tickets_count": 289,
            "tickets_per_day": {
              "2025-11-13": 1,
              "2025-12-07": 1,
              "2025-12-19": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-18": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-23": 5,
              "2026-03-09": 2,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-03-27": 3,
              "2026-03-30": 1,
              "2026-04-01": 1,
              "2026-04-02": 3,
              "2026-04-13": 1,
              "2026-04-30": 2,
              "2026-05-02": 10,
              "2026-05-04": 10,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-07": 10,
              "2026-05-08": 5,
              "2026-05-09": 4,
              "2026-05-11": 10,
              "2026-05-12": 6,
              "2026-05-13": 1,
              "2026-05-14": 9,
              "2026-05-15": 5,
              "2026-05-16": 1,
              "2026-05-18": 11,
              "2026-05-19": 19,
              "2026-05-20": 18,
              "2026-05-21": 18,
              "2026-05-22": 10,
              "2026-05-23": 5,
              "2026-05-25": 7,
              "2026-05-26": 16,
              "2026-05-27": 14,
              "2026-05-28": 2,
              "2026-05-29": 7,
              "2026-05-30": 4,
              "2026-06-01": 11,
              "2026-06-02": 18,
              "2026-06-03": 9,
              "2026-06-05": 4,
              "2026-06-06": 1,
              "2026-06-08": 10
            },
            "time_per_day": {
              "2025-11-13": 12.5855175,
              "2025-12-07": 0.18633083333333333,
              "2025-12-19": 5.068619166666666,
              "2026-01-14": 0.47695138888888894,
              "2026-01-17": 0.28999027777777775,
              "2026-01-18": 1.3861633333333334,
              "2026-01-30": 0.9634677777777778,
              "2026-02-09": 5.065665833333334,
              "2026-02-23": 124.99395861111113,
              "2026-03-09": 1.4818375,
              "2026-03-11": 0.07811583333333333,
              "2026-03-20": 600.0816230555555,
              "2026-03-26": 747.5918308333333,
              "2026-03-27": 5.3660105555555555,
              "2026-03-30": 497.95130916666665,
              "2026-04-01": 549.7094466666666,
              "2026-04-02": 0.48567916666666666,
              "2026-04-13": 787.3171486111111,
              "2026-04-30": 3.4262305555555557,
              "2026-05-02": 212.17499083333325,
              "2026-05-04": 19.15422722222222,
              "2026-05-05": 0.6769855555555556,
              "2026-05-06": 98.75792333333334,
              "2026-05-07": 16.436837777777782,
              "2026-05-08": 35.169357777777776,
              "2026-05-09": 31.034979999999997,
              "2026-05-11": 5.595398055555555,
              "2026-05-12": 8.887135277777777,
              "2026-05-13": 0.06584916666666667,
              "2026-05-14": 28.246594166666668,
              "2026-05-15": 1.5961105555555557,
              "2026-05-16": 17.723210833333333,
              "2026-05-18": 85.15305916666667,
              "2026-05-19": 149.99216527777776,
              "2026-05-20": 57.59739361111111,
              "2026-05-21": 27.47781249999999,
              "2026-05-22": 26.779635,
              "2026-05-23": 9.541636388888888,
              "2026-05-25": 6.7585275,
              "2026-05-26": 21.577936388888887,
              "2026-05-27": 48.342972222222215,
              "2026-05-28": 3.701981388888889,
              "2026-05-29": 13.195006111111113,
              "2026-05-30": 5.666988055555555,
              "2026-06-01": 34.635331111111114,
              "2026-06-02": 21.074491944444443,
              "2026-06-03": 53.82521861111111,
              "2026-06-05": 39.32898194444444,
              "2026-06-06": 572.3348752777778,
              "2026-06-08": 67.6122186111111
            },
            "time_count_per_day": {
              "2025-11-13": 1,
              "2025-12-07": 1,
              "2025-12-19": 1,
              "2026-01-14": 1,
              "2026-01-17": 1,
              "2026-01-18": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-23": 5,
              "2026-03-09": 2,
              "2026-03-11": 1,
              "2026-03-20": 1,
              "2026-03-26": 1,
              "2026-03-27": 3,
              "2026-03-30": 1,
              "2026-04-01": 1,
              "2026-04-02": 3,
              "2026-04-13": 1,
              "2026-04-30": 2,
              "2026-05-02": 10,
              "2026-05-04": 10,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-07": 10,
              "2026-05-08": 5,
              "2026-05-09": 4,
              "2026-05-11": 10,
              "2026-05-12": 6,
              "2026-05-13": 1,
              "2026-05-14": 9,
              "2026-05-15": 5,
              "2026-05-16": 1,
              "2026-05-18": 11,
              "2026-05-19": 19,
              "2026-05-20": 18,
              "2026-05-21": 18,
              "2026-05-22": 10,
              "2026-05-23": 5,
              "2026-05-25": 7,
              "2026-05-26": 16,
              "2026-05-27": 14,
              "2026-05-28": 2,
              "2026-05-29": 7,
              "2026-05-30": 4,
              "2026-06-01": 11,
              "2026-06-02": 18,
              "2026-06-03": 9,
              "2026-06-05": 4,
              "2026-06-06": 1,
              "2026-06-08": 10
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.24,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-01-14": 0.47695138888888894,
                "2026-06-01": 6.011644722222222
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-06-01": 1
              }
            },
            "P2": {
              "avg_time_hours": 17.69,
              "mode_time_hours": 1.0,
              "mode_frequency": 181,
              "time_distribution": {
                "0-2h": 181,
                "2-4h": 48,
                "4-6h": 15,
                "6-8h": 7,
                "10-12h": 6,
                "12-14h": 6,
                "16-18h": 1,
                "18-20h": 1,
                "20-22h": 2,
                "22-24h": 1,
                "36-38h": 2,
                "38-40h": 4,
                "64-66h": 2,
                "88-90h": 1,
                "96-98h": 1,
                "124-126h": 1,
                "496-498h": 1,
                "548-550h": 1,
                "572-574h": 1,
                "600-602h": 1,
                "746-748h": 1,
                "786-788h": 1
              },
              "tickets_count": 285,
              "tickets_per_day": {
                "2025-12-07": 1,
                "2025-12-19": 1,
                "2026-01-17": 1,
                "2026-01-18": 1,
                "2026-01-30": 1,
                "2026-02-23": 5,
                "2026-03-09": 2,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-27": 3,
                "2026-03-30": 1,
                "2026-04-01": 1,
                "2026-04-02": 3,
                "2026-04-13": 1,
                "2026-04-30": 2,
                "2026-05-02": 10,
                "2026-05-04": 10,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-07": 10,
                "2026-05-08": 5,
                "2026-05-09": 4,
                "2026-05-11": 10,
                "2026-05-12": 6,
                "2026-05-13": 1,
                "2026-05-14": 9,
                "2026-05-15": 5,
                "2026-05-16": 1,
                "2026-05-18": 11,
                "2026-05-19": 19,
                "2026-05-20": 18,
                "2026-05-21": 18,
                "2026-05-22": 10,
                "2026-05-23": 5,
                "2026-05-25": 7,
                "2026-05-26": 16,
                "2026-05-27": 14,
                "2026-05-28": 2,
                "2026-05-29": 7,
                "2026-05-30": 4,
                "2026-06-01": 10,
                "2026-06-02": 18,
                "2026-06-03": 9,
                "2026-06-05": 4,
                "2026-06-06": 1,
                "2026-06-08": 10
              },
              "time_per_day": {
                "2025-12-07": 0.18633083333333333,
                "2025-12-19": 5.068619166666666,
                "2026-01-17": 0.28999027777777775,
                "2026-01-18": 1.3861633333333334,
                "2026-01-30": 0.9634677777777778,
                "2026-02-23": 124.99395861111113,
                "2026-03-09": 1.4818375,
                "2026-03-11": 0.07811583333333333,
                "2026-03-20": 600.0816230555555,
                "2026-03-26": 747.5918308333333,
                "2026-03-27": 5.3660105555555555,
                "2026-03-30": 497.95130916666665,
                "2026-04-01": 549.7094466666666,
                "2026-04-02": 0.48567916666666666,
                "2026-04-13": 787.3171486111111,
                "2026-04-30": 3.4262305555555557,
                "2026-05-02": 212.17499083333325,
                "2026-05-04": 19.15422722222222,
                "2026-05-05": 0.6769855555555556,
                "2026-05-06": 98.75792333333334,
                "2026-05-07": 16.436837777777782,
                "2026-05-08": 35.169357777777776,
                "2026-05-09": 31.034979999999997,
                "2026-05-11": 5.595398055555555,
                "2026-05-12": 8.887135277777777,
                "2026-05-13": 0.06584916666666667,
                "2026-05-14": 28.246594166666668,
                "2026-05-15": 1.5961105555555557,
                "2026-05-16": 17.723210833333333,
                "2026-05-18": 85.15305916666667,
                "2026-05-19": 149.99216527777776,
                "2026-05-20": 57.59739361111111,
                "2026-05-21": 27.47781249999999,
                "2026-05-22": 26.779635,
                "2026-05-23": 9.541636388888888,
                "2026-05-25": 6.7585275,
                "2026-05-26": 21.577936388888887,
                "2026-05-27": 48.342972222222215,
                "2026-05-28": 3.701981388888889,
                "2026-05-29": 13.195006111111113,
                "2026-05-30": 5.666988055555555,
                "2026-06-01": 28.62368638888889,
                "2026-06-02": 21.074491944444443,
                "2026-06-03": 53.82521861111111,
                "2026-06-05": 39.32898194444444,
                "2026-06-06": 572.3348752777778,
                "2026-06-08": 67.6122186111111
              },
              "time_count_per_day": {
                "2025-12-07": 1,
                "2025-12-19": 1,
                "2026-01-17": 1,
                "2026-01-18": 1,
                "2026-01-30": 1,
                "2026-02-23": 5,
                "2026-03-09": 2,
                "2026-03-11": 1,
                "2026-03-20": 1,
                "2026-03-26": 1,
                "2026-03-27": 3,
                "2026-03-30": 1,
                "2026-04-01": 1,
                "2026-04-02": 3,
                "2026-04-13": 1,
                "2026-04-30": 2,
                "2026-05-02": 10,
                "2026-05-04": 10,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-07": 10,
                "2026-05-08": 5,
                "2026-05-09": 4,
                "2026-05-11": 10,
                "2026-05-12": 6,
                "2026-05-13": 1,
                "2026-05-14": 9,
                "2026-05-15": 5,
                "2026-05-16": 1,
                "2026-05-18": 11,
                "2026-05-19": 19,
                "2026-05-20": 18,
                "2026-05-21": 18,
                "2026-05-22": 10,
                "2026-05-23": 5,
                "2026-05-25": 7,
                "2026-05-26": 16,
                "2026-05-27": 14,
                "2026-05-28": 2,
                "2026-05-29": 7,
                "2026-05-30": 4,
                "2026-06-01": 10,
                "2026-06-02": 18,
                "2026-06-03": 9,
                "2026-06-05": 4,
                "2026-06-06": 1,
                "2026-06-08": 10
              }
            },
            "P3": {
              "avg_time_hours": 12.59,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 12.5855175
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 5.07,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 5.065665833333334
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 20,
            "tickets_per_day": {
              "2026-04-30": 4,
              "2026-05-04": 1,
              "2026-05-05": 2,
              "2026-05-06": 2,
              "2026-05-07": 1,
              "2026-05-09": 1,
              "2026-05-12": 1,
              "2026-05-20": 3,
              "2026-05-25": 2,
              "2026-05-27": 1,
              "2026-05-29": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 20,
              "tickets_per_day": {
                "2026-04-30": 4,
                "2026-05-04": 1,
                "2026-05-05": 2,
                "2026-05-06": 2,
                "2026-05-07": 1,
                "2026-05-09": 1,
                "2026-05-12": 1,
                "2026-05-20": 3,
                "2026-05-25": 2,
                "2026-05-27": 1,
                "2026-05-29": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-30": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 11,
            "tickets_per_day": {
              "2026-04-30": 2,
              "2026-05-09": 1,
              "2026-05-13": 2,
              "2026-05-20": 2,
              "2026-05-21": 1,
              "2026-05-29": 2,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-04-30": 2,
                "2026-05-09": 1,
                "2026-05-13": 2,
                "2026-05-20": 2,
                "2026-05-21": 1,
                "2026-05-29": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-05-22": 1,
              "2026-05-29": 1,
              "2026-05-30": 2,
              "2026-06-02": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-05-22": 1,
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-02": 1,
                "2026-06-03": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_478": {
      "overall": {
        "avg_time_hours": 4.64,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-13": 1,
          "2026-05-22": 1
        },
        "time_per_day": {
          "2025-11-13": 7.715464444444444,
          "2026-05-22": 1.567989722222222
        },
        "time_count_per_day": {
          "2025-11-13": 1,
          "2026-05-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.64,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2025-11-13": 7.715464444444444,
            "2026-05-22": 1.567989722222222
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2026-05-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.64,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-13": 1,
              "2026-05-22": 1
            },
            "time_per_day": {
              "2025-11-13": 7.715464444444444,
              "2026-05-22": 1.567989722222222
            },
            "time_count_per_day": {
              "2025-11-13": 1,
              "2026-05-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.64,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2025-11-13": 7.715464444444444,
                "2026-05-22": 1.567989722222222
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2026-05-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_479": {
      "overall": {
        "avg_time_hours": 78.38,
        "mode_time_hours": 125.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1,
          "26-28h": 1,
          "98-100h": 1,
          "124-126h": 1,
          "126-128h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-11-18": 2,
          "2025-12-14": 1,
          "2025-12-23": 1,
          "2025-12-28": 1
        },
        "time_per_day": {
          "2025-11-18": 138.68177388888887,
          "2025-12-14": 27.638354999999997,
          "2025-12-23": 126.53545666666666,
          "2025-12-28": 99.04570694444443
        },
        "time_count_per_day": {
          "2025-11-18": 2,
          "2025-12-14": 1,
          "2025-12-23": 1,
          "2025-12-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.64,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-14": 1
          },
          "time_per_day": {
            "2025-12-14": 27.638354999999997
          },
          "time_count_per_day": {
            "2025-12-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 91.07,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "98-100h": 1,
            "124-126h": 1,
            "126-128h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-18": 2,
            "2025-12-23": 1,
            "2025-12-28": 1
          },
          "time_per_day": {
            "2025-11-18": 138.68177388888887,
            "2025-12-23": 126.53545666666666,
            "2025-12-28": 99.04570694444443
          },
          "time_count_per_day": {
            "2025-11-18": 2,
            "2025-12-23": 1,
            "2025-12-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 78.38,
            "mode_time_hours": 125.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1,
              "26-28h": 1,
              "98-100h": 1,
              "124-126h": 1,
              "126-128h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-11-18": 2,
              "2025-12-14": 1,
              "2025-12-23": 1,
              "2025-12-28": 1
            },
            "time_per_day": {
              "2025-11-18": 138.68177388888887,
              "2025-12-14": 27.638354999999997,
              "2025-12-23": 126.53545666666666,
              "2025-12-28": 99.04570694444443
            },
            "time_count_per_day": {
              "2025-11-18": 2,
              "2025-12-14": 1,
              "2025-12-23": 1,
              "2025-12-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.64,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-14": 1
              },
              "time_per_day": {
                "2025-12-14": 27.638354999999997
              },
              "time_count_per_day": {
                "2025-12-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 91.07,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "98-100h": 1,
                "124-126h": 1,
                "126-128h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-18": 2,
                "2025-12-23": 1,
                "2025-12-28": 1
              },
              "time_per_day": {
                "2025-11-18": 138.68177388888887,
                "2025-12-23": 126.53545666666666,
                "2025-12-28": 99.04570694444443
              },
              "time_count_per_day": {
                "2025-11-18": 2,
                "2025-12-23": 1,
                "2025-12-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_332": {
      "overall": {
        "avg_time_hours": 119.0,
        "mode_time_hours": 27.0,
        "mode_frequency": 2,
        "time_distribution": {
          "26-28h": 2,
          "62-64h": 1,
          "100-102h": 1,
          "128-130h": 1,
          "132-134h": 1,
          "164-166h": 1,
          "170-172h": 1,
          "256-258h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2026-01-06": 1,
          "2026-01-14": 1,
          "2026-02-07": 1,
          "2026-02-12": 1,
          "2026-03-10": 2,
          "2026-03-11": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2025-11-17": 100.56972972222222,
          "2026-01-06": 164.58213194444446,
          "2026-01-14": 133.76325972222222,
          "2026-02-07": 257.14828111111115,
          "2026-02-12": 128.20835805555555,
          "2026-03-10": 52.845377222222226,
          "2026-03-11": 62.69916472222222,
          "2026-05-04": 171.1722263888889
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2026-01-06": 1,
          "2026-01-14": 1,
          "2026-02-07": 1,
          "2026-02-12": 1,
          "2026-03-10": 2,
          "2026-03-11": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 171.17,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "170-172h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 171.1722263888889
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        },
        "P2": {
          "avg_time_hours": 82.78,
          "mode_time_hours": 27.0,
          "mode_frequency": 2,
          "time_distribution": {
            "26-28h": 2,
            "62-64h": 1,
            "132-134h": 1,
            "164-166h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-01-06": 1,
            "2026-01-14": 1,
            "2026-03-10": 2,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-01-06": 164.58213194444446,
            "2026-01-14": 133.76325972222222,
            "2026-03-10": 52.845377222222226,
            "2026-03-11": 62.69916472222222
          },
          "time_count_per_day": {
            "2026-01-06": 1,
            "2026-01-14": 1,
            "2026-03-10": 2,
            "2026-03-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 161.98,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "100-102h": 1,
            "128-130h": 1,
            "256-258h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-02-07": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-17": 100.56972972222222,
            "2026-02-07": 257.14828111111115,
            "2026-02-12": 128.20835805555555
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-02-07": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 119.0,
            "mode_time_hours": 27.0,
            "mode_frequency": 2,
            "time_distribution": {
              "26-28h": 2,
              "62-64h": 1,
              "100-102h": 1,
              "128-130h": 1,
              "132-134h": 1,
              "164-166h": 1,
              "170-172h": 1,
              "256-258h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2026-01-06": 1,
              "2026-01-14": 1,
              "2026-02-07": 1,
              "2026-02-12": 1,
              "2026-03-10": 2,
              "2026-03-11": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2025-11-17": 100.56972972222222,
              "2026-01-06": 164.58213194444446,
              "2026-01-14": 133.76325972222222,
              "2026-02-07": 257.14828111111115,
              "2026-02-12": 128.20835805555555,
              "2026-03-10": 52.845377222222226,
              "2026-03-11": 62.69916472222222,
              "2026-05-04": 171.1722263888889
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2026-01-06": 1,
              "2026-01-14": 1,
              "2026-02-07": 1,
              "2026-02-12": 1,
              "2026-03-10": 2,
              "2026-03-11": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 171.17,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "170-172h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 171.1722263888889
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            },
            "P2": {
              "avg_time_hours": 82.78,
              "mode_time_hours": 27.0,
              "mode_frequency": 2,
              "time_distribution": {
                "26-28h": 2,
                "62-64h": 1,
                "132-134h": 1,
                "164-166h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-06": 1,
                "2026-01-14": 1,
                "2026-03-10": 2,
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-01-06": 164.58213194444446,
                "2026-01-14": 133.76325972222222,
                "2026-03-10": 52.845377222222226,
                "2026-03-11": 62.69916472222222
              },
              "time_count_per_day": {
                "2026-01-06": 1,
                "2026-01-14": 1,
                "2026-03-10": 2,
                "2026-03-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 161.98,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "100-102h": 1,
                "128-130h": 1,
                "256-258h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-02-07": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-17": 100.56972972222222,
                "2026-02-07": 257.14828111111115,
                "2026-02-12": 128.20835805555555
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-02-07": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_480": {
      "overall": {
        "avg_time_hours": 234.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "4-6h": 1,
          "18-20h": 1,
          "22-24h": 1,
          "66-68h": 1,
          "92-94h": 1,
          "140-142h": 1,
          "986-988h": 1,
          "1010-1012h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-11-25": 1,
          "2025-12-09": 1,
          "2025-12-11": 1,
          "2025-12-12": 1,
          "2026-01-20": 1,
          "2026-02-04": 1,
          "2026-03-17": 2
        },
        "time_per_day": {
          "2025-11-13": 0.09976638888888889,
          "2025-11-24": 3.9216722222222224,
          "2025-11-25": 19.906040277777777,
          "2025-12-09": 4.113881666666667,
          "2025-12-11": 141.54849249999998,
          "2025-12-12": 67.53072305555555,
          "2026-01-20": 92.46763583333333,
          "2026-02-04": 22.79517472222222,
          "2026-03-17": 1997.359665833333
        },
        "time_count_per_day": {
          "2025-11-13": 1,
          "2025-11-24": 1,
          "2025-11-25": 1,
          "2025-12-09": 1,
          "2025-12-11": 1,
          "2025-12-12": 1,
          "2026-01-20": 1,
          "2026-02-04": 1,
          "2026-03-17": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 258.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 1,
            "18-20h": 1,
            "66-68h": 1,
            "92-94h": 1,
            "140-142h": 1,
            "986-988h": 1,
            "1010-1012h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-12-09": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2026-01-20": 1,
            "2026-03-17": 2
          },
          "time_per_day": {
            "2025-11-13": 0.09976638888888889,
            "2025-11-24": 3.9216722222222224,
            "2025-11-25": 19.906040277777777,
            "2025-12-09": 4.113881666666667,
            "2025-12-11": 141.54849249999998,
            "2025-12-12": 67.53072305555555,
            "2026-01-20": 92.46763583333333,
            "2026-03-17": 1997.359665833333
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2025-11-24": 1,
            "2025-11-25": 1,
            "2025-12-09": 1,
            "2025-12-11": 1,
            "2025-12-12": 1,
            "2026-01-20": 1,
            "2026-03-17": 2
          }
        },
        "P3": {
          "avg_time_hours": 22.8,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 22.79517472222222
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 234.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "4-6h": 1,
              "18-20h": 1,
              "22-24h": 1,
              "66-68h": 1,
              "92-94h": 1,
              "140-142h": 1,
              "986-988h": 1,
              "1010-1012h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-11-25": 1,
              "2025-12-09": 1,
              "2025-12-11": 1,
              "2025-12-12": 1,
              "2026-01-20": 1,
              "2026-02-04": 1,
              "2026-03-17": 2
            },
            "time_per_day": {
              "2025-11-13": 0.09976638888888889,
              "2025-11-24": 3.9216722222222224,
              "2025-11-25": 19.906040277777777,
              "2025-12-09": 4.113881666666667,
              "2025-12-11": 141.54849249999998,
              "2025-12-12": 67.53072305555555,
              "2026-01-20": 92.46763583333333,
              "2026-02-04": 22.79517472222222,
              "2026-03-17": 1997.359665833333
            },
            "time_count_per_day": {
              "2025-11-13": 1,
              "2025-11-24": 1,
              "2025-11-25": 1,
              "2025-12-09": 1,
              "2025-12-11": 1,
              "2025-12-12": 1,
              "2026-01-20": 1,
              "2026-02-04": 1,
              "2026-03-17": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 258.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 1,
                "18-20h": 1,
                "66-68h": 1,
                "92-94h": 1,
                "140-142h": 1,
                "986-988h": 1,
                "1010-1012h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-12-09": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2026-01-20": 1,
                "2026-03-17": 2
              },
              "time_per_day": {
                "2025-11-13": 0.09976638888888889,
                "2025-11-24": 3.9216722222222224,
                "2025-11-25": 19.906040277777777,
                "2025-12-09": 4.113881666666667,
                "2025-12-11": 141.54849249999998,
                "2025-12-12": 67.53072305555555,
                "2026-01-20": 92.46763583333333,
                "2026-03-17": 1997.359665833333
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2025-11-24": 1,
                "2025-11-25": 1,
                "2025-12-09": 1,
                "2025-12-11": 1,
                "2025-12-12": 1,
                "2026-01-20": 1,
                "2026-03-17": 2
              }
            },
            "P3": {
              "avg_time_hours": 22.8,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 22.79517472222222
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_481": {
      "overall": {
        "avg_time_hours": 0.47,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-13": 1
        },
        "time_per_day": {
          "2025-11-13": 0.46503222222222224
        },
        "time_count_per_day": {
          "2025-11-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 0.46503222222222224
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.47,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-13": 1
            },
            "time_per_day": {
              "2025-11-13": 0.46503222222222224
            },
            "time_count_per_day": {
              "2025-11-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 0.46503222222222224
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_482": {
      "overall": {
        "avg_time_hours": 6.99,
        "mode_time_hours": 1.0,
        "mode_frequency": 24,
        "time_distribution": {
          "0-2h": 24,
          "20-22h": 1,
          "34-36h": 1,
          "122-124h": 1
        },
        "tickets_count": 27,
        "tickets_per_day": {
          "2025-11-13": 1,
          "2026-01-13": 5,
          "2026-01-19": 1,
          "2026-01-23": 1,
          "2026-01-29": 1,
          "2026-01-30": 3,
          "2026-02-03": 3,
          "2026-02-07": 1,
          "2026-02-10": 4,
          "2026-02-14": 5,
          "2026-02-19": 1,
          "2026-03-10": 1
        },
        "time_per_day": {
          "2025-11-13": 0.47957472222222225,
          "2026-01-13": 2.3068727777777776,
          "2026-01-19": 35.73970444444444,
          "2026-01-23": 0.17810499999999999,
          "2026-01-29": 0.7722061111111111,
          "2026-01-30": 0.49907833333333335,
          "2026-02-03": 0.07717972222222222,
          "2026-02-07": 20.467271666666665,
          "2026-02-10": 0.6307119444444445,
          "2026-02-14": 2.4644794444444447,
          "2026-02-19": 1.1018822222222222,
          "2026-03-10": 123.9617725
        },
        "time_count_per_day": {
          "2025-11-13": 1,
          "2026-01-13": 5,
          "2026-01-19": 1,
          "2026-01-23": 1,
          "2026-01-29": 1,
          "2026-01-30": 3,
          "2026-02-03": 3,
          "2026-02-07": 1,
          "2026-02-10": 4,
          "2026-02-14": 5,
          "2026-02-19": 1,
          "2026-03-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 24,
          "time_distribution": {
            "0-2h": 24,
            "34-36h": 1,
            "122-124h": 1
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-11-13": 1,
            "2026-01-13": 5,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 3,
            "2026-02-03": 3,
            "2026-02-10": 4,
            "2026-02-14": 5,
            "2026-02-19": 1,
            "2026-03-10": 1
          },
          "time_per_day": {
            "2025-11-13": 0.47957472222222225,
            "2026-01-13": 2.3068727777777776,
            "2026-01-19": 35.73970444444444,
            "2026-01-23": 0.17810499999999999,
            "2026-01-29": 0.7722061111111111,
            "2026-01-30": 0.49907833333333335,
            "2026-02-03": 0.07717972222222222,
            "2026-02-10": 0.6307119444444445,
            "2026-02-14": 2.4644794444444447,
            "2026-02-19": 1.1018822222222222,
            "2026-03-10": 123.9617725
          },
          "time_count_per_day": {
            "2025-11-13": 1,
            "2026-01-13": 5,
            "2026-01-19": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 3,
            "2026-02-03": 3,
            "2026-02-10": 4,
            "2026-02-14": 5,
            "2026-02-19": 1,
            "2026-03-10": 1
          }
        },
        "P3": {
          "avg_time_hours": 20.47,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-07": 1
          },
          "time_per_day": {
            "2026-02-07": 20.467271666666665
          },
          "time_count_per_day": {
            "2026-02-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.99,
            "mode_time_hours": 1.0,
            "mode_frequency": 24,
            "time_distribution": {
              "0-2h": 24,
              "20-22h": 1,
              "34-36h": 1,
              "122-124h": 1
            },
            "tickets_count": 27,
            "tickets_per_day": {
              "2025-11-13": 1,
              "2026-01-13": 5,
              "2026-01-19": 1,
              "2026-01-23": 1,
              "2026-01-29": 1,
              "2026-01-30": 3,
              "2026-02-03": 3,
              "2026-02-07": 1,
              "2026-02-10": 4,
              "2026-02-14": 5,
              "2026-02-19": 1,
              "2026-03-10": 1
            },
            "time_per_day": {
              "2025-11-13": 0.47957472222222225,
              "2026-01-13": 2.3068727777777776,
              "2026-01-19": 35.73970444444444,
              "2026-01-23": 0.17810499999999999,
              "2026-01-29": 0.7722061111111111,
              "2026-01-30": 0.49907833333333335,
              "2026-02-03": 0.07717972222222222,
              "2026-02-07": 20.467271666666665,
              "2026-02-10": 0.6307119444444445,
              "2026-02-14": 2.4644794444444447,
              "2026-02-19": 1.1018822222222222,
              "2026-03-10": 123.9617725
            },
            "time_count_per_day": {
              "2025-11-13": 1,
              "2026-01-13": 5,
              "2026-01-19": 1,
              "2026-01-23": 1,
              "2026-01-29": 1,
              "2026-01-30": 3,
              "2026-02-03": 3,
              "2026-02-07": 1,
              "2026-02-10": 4,
              "2026-02-14": 5,
              "2026-02-19": 1,
              "2026-03-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 24,
              "time_distribution": {
                "0-2h": 24,
                "34-36h": 1,
                "122-124h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2025-11-13": 1,
                "2026-01-13": 5,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 3,
                "2026-02-03": 3,
                "2026-02-10": 4,
                "2026-02-14": 5,
                "2026-02-19": 1,
                "2026-03-10": 1
              },
              "time_per_day": {
                "2025-11-13": 0.47957472222222225,
                "2026-01-13": 2.3068727777777776,
                "2026-01-19": 35.73970444444444,
                "2026-01-23": 0.17810499999999999,
                "2026-01-29": 0.7722061111111111,
                "2026-01-30": 0.49907833333333335,
                "2026-02-03": 0.07717972222222222,
                "2026-02-10": 0.6307119444444445,
                "2026-02-14": 2.4644794444444447,
                "2026-02-19": 1.1018822222222222,
                "2026-03-10": 123.9617725
              },
              "time_count_per_day": {
                "2025-11-13": 1,
                "2026-01-13": 5,
                "2026-01-19": 1,
                "2026-01-23": 1,
                "2026-01-29": 1,
                "2026-01-30": 3,
                "2026-02-03": 3,
                "2026-02-10": 4,
                "2026-02-14": 5,
                "2026-02-19": 1,
                "2026-03-10": 1
              }
            },
            "P3": {
              "avg_time_hours": 20.47,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-07": 1
              },
              "time_per_day": {
                "2026-02-07": 20.467271666666665
              },
              "time_count_per_day": {
                "2026-02-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_370": {
      "overall": {
        "avg_time_hours": 98.34,
        "mode_time_hours": 99.0,
        "mode_frequency": 1,
        "time_distribution": {
          "98-100h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-17": 1
        },
        "time_per_day": {
          "2025-11-17": 98.34374444444444
        },
        "time_count_per_day": {
          "2025-11-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 98.34,
          "mode_time_hours": 99.0,
          "mode_frequency": 1,
          "time_distribution": {
            "98-100h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 98.34374444444444
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 98.34,
            "mode_time_hours": 99.0,
            "mode_frequency": 1,
            "time_distribution": {
              "98-100h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-17": 1
            },
            "time_per_day": {
              "2025-11-17": 98.34374444444444
            },
            "time_count_per_day": {
              "2025-11-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 98.34,
              "mode_time_hours": 99.0,
              "mode_frequency": 1,
              "time_distribution": {
                "98-100h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 98.34374444444444
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_484": {
      "overall": {
        "avg_time_hours": 246.19,
        "mode_time_hours": 57.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 1,
          "26-28h": 1,
          "48-50h": 1,
          "54-56h": 1,
          "56-58h": 2,
          "96-98h": 1,
          "98-100h": 1,
          "126-128h": 1,
          "144-146h": 1,
          "160-162h": 1,
          "238-240h": 1,
          "344-346h": 1,
          "380-382h": 1,
          "558-560h": 1,
          "762-764h": 1,
          "848-850h": 1,
          "1138-1140h": 1
        },
        "tickets_count": 21,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-24": 1,
          "2025-12-02": 1,
          "2025-12-18": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-02-25": 1,
          "2026-03-23": 2,
          "2026-04-09": 1,
          "2026-04-23": 2,
          "2026-04-30": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-17": 99.1419125,
          "2025-11-19": 126.40748111111111,
          "2025-11-24": 48.23822861111111,
          "2025-12-02": 160.34365833333334,
          "2025-12-18": 8.639618055555555,
          "2025-12-19": 380.3274533333333,
          "2025-12-22": 97.87106777777777,
          "2026-02-03": 139.6539786111111,
          "2026-02-05": 54.191428888888886,
          "2026-02-09": 239.12176166666666,
          "2026-02-19": 1139.7778044444444,
          "2026-02-25": 3.0754697222222225,
          "2026-03-23": 1611.3889152777779,
          "2026-04-09": 7.457908888888889,
          "2026-04-23": 904.1837561111112,
          "2026-04-30": 144.79910166666667,
          "2026-06-03": 5.450779722222222
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-11-19": 1,
          "2025-11-24": 1,
          "2025-12-02": 1,
          "2025-12-18": 1,
          "2025-12-19": 1,
          "2025-12-22": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-02-25": 1,
          "2026-03-23": 2,
          "2026-04-09": 1,
          "2026-04-23": 2,
          "2026-04-30": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 185.7,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 1,
            "48-50h": 1,
            "96-98h": 1,
            "144-146h": 1,
            "238-240h": 1,
            "344-346h": 1,
            "380-382h": 1,
            "762-764h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2026-02-09": 1,
            "2026-02-25": 1,
            "2026-03-23": 1,
            "2026-04-09": 1,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-24": 48.23822861111111,
            "2025-12-18": 8.639618055555555,
            "2025-12-19": 380.3274533333333,
            "2025-12-22": 97.87106777777777,
            "2026-02-09": 239.12176166666666,
            "2026-02-25": 3.0754697222222225,
            "2026-03-23": 762.735903888889,
            "2026-04-09": 7.457908888888889,
            "2026-04-23": 344.99663083333337,
            "2026-04-30": 144.79910166666667,
            "2026-06-03": 5.450779722222222
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2026-02-09": 1,
            "2026-02-25": 1,
            "2026-03-23": 1,
            "2026-04-09": 1,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 220.84,
          "mode_time_hours": 57.0,
          "mode_frequency": 2,
          "time_distribution": {
            "26-28h": 1,
            "54-56h": 1,
            "56-58h": 2,
            "98-100h": 1,
            "126-128h": 1,
            "160-162h": 1,
            "558-560h": 1,
            "848-850h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-02": 1,
            "2026-02-03": 3,
            "2026-02-05": 1,
            "2026-03-23": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-11-17": 99.1419125,
            "2025-11-19": 126.40748111111111,
            "2025-12-02": 160.34365833333334,
            "2026-02-03": 139.6539786111111,
            "2026-02-05": 54.191428888888886,
            "2026-03-23": 848.6530113888889,
            "2026-04-23": 559.1871252777778
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-19": 1,
            "2025-12-02": 1,
            "2026-02-03": 3,
            "2026-02-05": 1,
            "2026-03-23": 1,
            "2026-04-23": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1139.78,
          "mode_time_hours": 1139.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1138-1140h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 1139.7778044444444
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 246.19,
            "mode_time_hours": 57.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 1,
              "26-28h": 1,
              "48-50h": 1,
              "54-56h": 1,
              "56-58h": 2,
              "96-98h": 1,
              "98-100h": 1,
              "126-128h": 1,
              "144-146h": 1,
              "160-162h": 1,
              "238-240h": 1,
              "344-346h": 1,
              "380-382h": 1,
              "558-560h": 1,
              "762-764h": 1,
              "848-850h": 1,
              "1138-1140h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-24": 1,
              "2025-12-02": 1,
              "2025-12-18": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-02-25": 1,
              "2026-03-23": 2,
              "2026-04-09": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-17": 99.1419125,
              "2025-11-19": 126.40748111111111,
              "2025-11-24": 48.23822861111111,
              "2025-12-02": 160.34365833333334,
              "2025-12-18": 8.639618055555555,
              "2025-12-19": 380.3274533333333,
              "2025-12-22": 97.87106777777777,
              "2026-02-03": 139.6539786111111,
              "2026-02-05": 54.191428888888886,
              "2026-02-09": 239.12176166666666,
              "2026-02-19": 1139.7778044444444,
              "2026-02-25": 3.0754697222222225,
              "2026-03-23": 1611.3889152777779,
              "2026-04-09": 7.457908888888889,
              "2026-04-23": 904.1837561111112,
              "2026-04-30": 144.79910166666667,
              "2026-06-03": 5.450779722222222
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-11-19": 1,
              "2025-11-24": 1,
              "2025-12-02": 1,
              "2025-12-18": 1,
              "2025-12-19": 1,
              "2025-12-22": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-02-25": 1,
              "2026-03-23": 2,
              "2026-04-09": 1,
              "2026-04-23": 2,
              "2026-04-30": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 185.7,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 1,
                "48-50h": 1,
                "96-98h": 1,
                "144-146h": 1,
                "238-240h": 1,
                "344-346h": 1,
                "380-382h": 1,
                "762-764h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2026-02-09": 1,
                "2026-02-25": 1,
                "2026-03-23": 1,
                "2026-04-09": 1,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-24": 48.23822861111111,
                "2025-12-18": 8.639618055555555,
                "2025-12-19": 380.3274533333333,
                "2025-12-22": 97.87106777777777,
                "2026-02-09": 239.12176166666666,
                "2026-02-25": 3.0754697222222225,
                "2026-03-23": 762.735903888889,
                "2026-04-09": 7.457908888888889,
                "2026-04-23": 344.99663083333337,
                "2026-04-30": 144.79910166666667,
                "2026-06-03": 5.450779722222222
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-18": 1,
                "2025-12-19": 1,
                "2025-12-22": 1,
                "2026-02-09": 1,
                "2026-02-25": 1,
                "2026-03-23": 1,
                "2026-04-09": 1,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 220.84,
              "mode_time_hours": 57.0,
              "mode_frequency": 2,
              "time_distribution": {
                "26-28h": 1,
                "54-56h": 1,
                "56-58h": 2,
                "98-100h": 1,
                "126-128h": 1,
                "160-162h": 1,
                "558-560h": 1,
                "848-850h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-02": 1,
                "2026-02-03": 3,
                "2026-02-05": 1,
                "2026-03-23": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-11-17": 99.1419125,
                "2025-11-19": 126.40748111111111,
                "2025-12-02": 160.34365833333334,
                "2026-02-03": 139.6539786111111,
                "2026-02-05": 54.191428888888886,
                "2026-03-23": 848.6530113888889,
                "2026-04-23": 559.1871252777778
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-19": 1,
                "2025-12-02": 1,
                "2026-02-03": 3,
                "2026-02-05": 1,
                "2026-03-23": 1,
                "2026-04-23": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1139.78,
              "mode_time_hours": 1139.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1138-1140h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 1139.7778044444444
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_485": {
      "overall": {
        "avg_time_hours": 86.65,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "164-166h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-13": 1,
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-11-13": 7.364050833333333,
          "2025-12-11": 165.9429172222222
        },
        "time_count_per_day": {
          "2025-11-13": 1,
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 165.94,
          "mode_time_hours": 165.0,
          "mode_frequency": 1,
          "time_distribution": {
            "164-166h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 165.9429172222222
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 7.36,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-13": 1
          },
          "time_per_day": {
            "2025-11-13": 7.364050833333333
          },
          "time_count_per_day": {
            "2025-11-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 86.65,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "164-166h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-13": 1,
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-11-13": 7.364050833333333,
              "2025-12-11": 165.9429172222222
            },
            "time_count_per_day": {
              "2025-11-13": 1,
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 165.94,
              "mode_time_hours": 165.0,
              "mode_frequency": 1,
              "time_distribution": {
                "164-166h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 165.9429172222222
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 7.36,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-13": 1
              },
              "time_per_day": {
                "2025-11-13": 7.364050833333333
              },
              "time_count_per_day": {
                "2025-11-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_215": {
      "overall": {
        "avg_time_hours": 239.95,
        "mode_time_hours": 41.0,
        "mode_frequency": 2,
        "time_distribution": {
          "6-8h": 1,
          "16-18h": 1,
          "40-42h": 2,
          "262-264h": 1,
          "278-280h": 1,
          "1030-1032h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-22": 1,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2026-02-18": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2025-11-17": 7.538563611111112,
          "2025-11-22": 40.87185638888889,
          "2025-11-25": 279.98994166666665,
          "2025-11-27": 40.97663277777778,
          "2025-11-28": 17.182329722222224,
          "2026-02-18": 262.27810305555556,
          "2026-03-20": 1030.8084361111112
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-11-22": 1,
          "2025-11-25": 1,
          "2025-11-27": 1,
          "2025-11-28": 1,
          "2026-02-18": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 239.95,
          "mode_time_hours": 41.0,
          "mode_frequency": 2,
          "time_distribution": {
            "6-8h": 1,
            "16-18h": 1,
            "40-42h": 2,
            "262-264h": 1,
            "278-280h": 1,
            "1030-1032h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2026-02-18": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2025-11-17": 7.538563611111112,
            "2025-11-22": 40.87185638888889,
            "2025-11-25": 279.98994166666665,
            "2025-11-27": 40.97663277777778,
            "2025-11-28": 17.182329722222224,
            "2026-02-18": 262.27810305555556,
            "2026-03-20": 1030.8084361111112
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2026-02-18": 1,
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 239.95,
            "mode_time_hours": 41.0,
            "mode_frequency": 2,
            "time_distribution": {
              "6-8h": 1,
              "16-18h": 1,
              "40-42h": 2,
              "262-264h": 1,
              "278-280h": 1,
              "1030-1032h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-22": 1,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2026-02-18": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2025-11-17": 7.538563611111112,
              "2025-11-22": 40.87185638888889,
              "2025-11-25": 279.98994166666665,
              "2025-11-27": 40.97663277777778,
              "2025-11-28": 17.182329722222224,
              "2026-02-18": 262.27810305555556,
              "2026-03-20": 1030.8084361111112
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-11-22": 1,
              "2025-11-25": 1,
              "2025-11-27": 1,
              "2025-11-28": 1,
              "2026-02-18": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 239.95,
              "mode_time_hours": 41.0,
              "mode_frequency": 2,
              "time_distribution": {
                "6-8h": 1,
                "16-18h": 1,
                "40-42h": 2,
                "262-264h": 1,
                "278-280h": 1,
                "1030-1032h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2026-02-18": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2025-11-17": 7.538563611111112,
                "2025-11-22": 40.87185638888889,
                "2025-11-25": 279.98994166666665,
                "2025-11-27": 40.97663277777778,
                "2025-11-28": 17.182329722222224,
                "2026-02-18": 262.27810305555556,
                "2026-03-20": 1030.8084361111112
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-11-25": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2026-02-18": 1,
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_487": {
      "overall": {
        "avg_time_hours": 170.62,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "14-16h": 2,
          "32-34h": 1,
          "40-42h": 1,
          "44-46h": 1,
          "50-52h": 1,
          "52-54h": 2,
          "68-70h": 1,
          "96-98h": 1,
          "162-164h": 1,
          "192-194h": 1,
          "232-234h": 1,
          "284-286h": 1,
          "320-322h": 1,
          "348-350h": 1,
          "518-520h": 1,
          "1046-1048h": 1
        },
        "tickets_count": 21,
        "tickets_per_day": {
          "2025-11-28": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-18": 2,
          "2026-02-20": 2,
          "2026-03-02": 1,
          "2026-03-16": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-31": 1,
          "2026-04-17": 1,
          "2026-04-23": 1,
          "2026-04-29": 1,
          "2026-05-06": 1,
          "2026-05-19": 1,
          "2026-05-21": 1
        },
        "time_per_day": {
          "2025-11-28": 348.7833944444444,
          "2026-01-28": 96.25148888888889,
          "2026-02-03": 519.5447752777778,
          "2026-02-09": 233.8540036111111,
          "2026-02-18": 1330.055411111111,
          "2026-02-20": 2.2134438888888885,
          "2026-03-02": 51.60333388888889,
          "2026-03-16": 33.85293277777778,
          "2026-03-19": 0.5510944444444444,
          "2026-03-20": 68.95455305555555,
          "2026-03-23": 104.51502444444444,
          "2026-03-31": 14.036026944444444,
          "2026-04-17": 14.801445555555555,
          "2026-04-23": 321.74274472222226,
          "2026-04-29": 44.51344638888889,
          "2026-05-06": 193.28916777777778,
          "2026-05-19": 163.3858936111111,
          "2026-05-21": 41.119275
        },
        "time_count_per_day": {
          "2025-11-28": 1,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-18": 2,
          "2026-02-20": 2,
          "2026-03-02": 1,
          "2026-03-16": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-31": 1,
          "2026-04-17": 1,
          "2026-04-23": 1,
          "2026-04-29": 1,
          "2026-05-06": 1,
          "2026-05-19": 1,
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 68.95,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 68.95455305555555
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 119.0,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "14-16h": 2,
            "32-34h": 1,
            "40-42h": 1,
            "44-46h": 1,
            "50-52h": 1,
            "52-54h": 2,
            "162-164h": 1,
            "192-194h": 1,
            "232-234h": 1,
            "284-286h": 1,
            "320-322h": 1,
            "518-520h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-02": 1,
            "2026-03-16": 1,
            "2026-03-19": 1,
            "2026-03-23": 2,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-04-29": 1,
            "2026-05-06": 1,
            "2026-05-19": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-02-03": 519.5447752777778,
            "2026-02-09": 233.8540036111111,
            "2026-02-18": 284.0122597222222,
            "2026-02-20": 2.2134438888888885,
            "2026-03-02": 51.60333388888889,
            "2026-03-16": 33.85293277777778,
            "2026-03-19": 0.5510944444444444,
            "2026-03-23": 104.51502444444444,
            "2026-03-31": 14.036026944444444,
            "2026-04-17": 14.801445555555555,
            "2026-04-23": 321.74274472222226,
            "2026-04-29": 44.51344638888889,
            "2026-05-06": 193.28916777777778,
            "2026-05-19": 163.3858936111111,
            "2026-05-21": 41.119275
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-18": 1,
            "2026-02-20": 2,
            "2026-03-02": 1,
            "2026-03-16": 1,
            "2026-03-19": 1,
            "2026-03-23": 2,
            "2026-03-31": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-04-29": 1,
            "2026-05-06": 1,
            "2026-05-19": 1,
            "2026-05-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 497.03,
          "mode_time_hours": 349.0,
          "mode_frequency": 1,
          "time_distribution": {
            "96-98h": 1,
            "348-350h": 1,
            "1046-1048h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-01-28": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-11-28": 348.7833944444444,
            "2026-01-28": 96.25148888888889,
            "2026-02-18": 1046.0431513888889
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2026-01-28": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 170.62,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "14-16h": 2,
              "32-34h": 1,
              "40-42h": 1,
              "44-46h": 1,
              "50-52h": 1,
              "52-54h": 2,
              "68-70h": 1,
              "96-98h": 1,
              "162-164h": 1,
              "192-194h": 1,
              "232-234h": 1,
              "284-286h": 1,
              "320-322h": 1,
              "348-350h": 1,
              "518-520h": 1,
              "1046-1048h": 1
            },
            "tickets_count": 21,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-18": 2,
              "2026-02-20": 2,
              "2026-03-02": 1,
              "2026-03-16": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-31": 1,
              "2026-04-17": 1,
              "2026-04-23": 1,
              "2026-04-29": 1,
              "2026-05-06": 1,
              "2026-05-19": 1,
              "2026-05-21": 1
            },
            "time_per_day": {
              "2025-11-28": 348.7833944444444,
              "2026-01-28": 96.25148888888889,
              "2026-02-03": 519.5447752777778,
              "2026-02-09": 233.8540036111111,
              "2026-02-18": 1330.055411111111,
              "2026-02-20": 2.2134438888888885,
              "2026-03-02": 51.60333388888889,
              "2026-03-16": 33.85293277777778,
              "2026-03-19": 0.5510944444444444,
              "2026-03-20": 68.95455305555555,
              "2026-03-23": 104.51502444444444,
              "2026-03-31": 14.036026944444444,
              "2026-04-17": 14.801445555555555,
              "2026-04-23": 321.74274472222226,
              "2026-04-29": 44.51344638888889,
              "2026-05-06": 193.28916777777778,
              "2026-05-19": 163.3858936111111,
              "2026-05-21": 41.119275
            },
            "time_count_per_day": {
              "2025-11-28": 1,
              "2026-01-28": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-18": 2,
              "2026-02-20": 2,
              "2026-03-02": 1,
              "2026-03-16": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-31": 1,
              "2026-04-17": 1,
              "2026-04-23": 1,
              "2026-04-29": 1,
              "2026-05-06": 1,
              "2026-05-19": 1,
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 68.95,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 68.95455305555555
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 119.0,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "14-16h": 2,
                "32-34h": 1,
                "40-42h": 1,
                "44-46h": 1,
                "50-52h": 1,
                "52-54h": 2,
                "162-164h": 1,
                "192-194h": 1,
                "232-234h": 1,
                "284-286h": 1,
                "320-322h": 1,
                "518-520h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-02": 1,
                "2026-03-16": 1,
                "2026-03-19": 1,
                "2026-03-23": 2,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-04-29": 1,
                "2026-05-06": 1,
                "2026-05-19": 1,
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-02-03": 519.5447752777778,
                "2026-02-09": 233.8540036111111,
                "2026-02-18": 284.0122597222222,
                "2026-02-20": 2.2134438888888885,
                "2026-03-02": 51.60333388888889,
                "2026-03-16": 33.85293277777778,
                "2026-03-19": 0.5510944444444444,
                "2026-03-23": 104.51502444444444,
                "2026-03-31": 14.036026944444444,
                "2026-04-17": 14.801445555555555,
                "2026-04-23": 321.74274472222226,
                "2026-04-29": 44.51344638888889,
                "2026-05-06": 193.28916777777778,
                "2026-05-19": 163.3858936111111,
                "2026-05-21": 41.119275
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-18": 1,
                "2026-02-20": 2,
                "2026-03-02": 1,
                "2026-03-16": 1,
                "2026-03-19": 1,
                "2026-03-23": 2,
                "2026-03-31": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-04-29": 1,
                "2026-05-06": 1,
                "2026-05-19": 1,
                "2026-05-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 497.03,
              "mode_time_hours": 349.0,
              "mode_frequency": 1,
              "time_distribution": {
                "96-98h": 1,
                "348-350h": 1,
                "1046-1048h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-01-28": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-11-28": 348.7833944444444,
                "2026-01-28": 96.25148888888889,
                "2026-02-18": 1046.0431513888889
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2026-01-28": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_492": {
      "overall": {
        "avg_time_hours": 0.56,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-14": 1
        },
        "time_per_day": {
          "2025-11-14": 0.5645083333333334
        },
        "time_count_per_day": {
          "2025-11-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 0.5645083333333334
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.56,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-14": 1
            },
            "time_per_day": {
              "2025-11-14": 0.5645083333333334
            },
            "time_count_per_day": {
              "2025-11-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 0.5645083333333334
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_107": {
      "overall": {
        "avg_time_hours": 43.27,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "50-52h": 1,
          "64-66h": 2,
          "160-162h": 1,
          "168-170h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2025-11-14": 3,
          "2025-11-18": 1,
          "2025-11-24": 4,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2026-05-12": 2
        },
        "time_per_day": {
          "2025-11-14": 3.30732,
          "2025-11-18": 0.7710666666666667,
          "2025-11-24": 351.0619377777778,
          "2025-11-28": 161.28830305555553,
          "2025-12-04": 1.5196819444444443,
          "2026-05-12": 1.275517777777778
        },
        "time_count_per_day": {
          "2025-11-14": 3,
          "2025-11-18": 1,
          "2025-11-24": 4,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2026-05-12": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.75,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 0.7499077777777778
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 48.16,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "50-52h": 1,
            "160-162h": 1,
            "168-170h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-14": 2,
            "2025-11-18": 1,
            "2025-11-24": 2,
            "2025-11-28": 1,
            "2026-05-12": 2
          },
          "time_per_day": {
            "2025-11-14": 2.557412222222222,
            "2025-11-18": 0.7710666666666667,
            "2025-11-24": 219.38195,
            "2025-11-28": 161.28830305555553,
            "2026-05-12": 1.275517777777778
          },
          "time_count_per_day": {
            "2025-11-14": 2,
            "2025-11-18": 1,
            "2025-11-24": 2,
            "2025-11-28": 1,
            "2026-05-12": 2
          }
        },
        "P3": {
          "avg_time_hours": 44.4,
          "mode_time_hours": 65.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "64-66h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-24": 2,
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-11-24": 131.6799877777778,
            "2025-12-04": 1.5196819444444443
          },
          "time_count_per_day": {
            "2025-11-24": 2,
            "2025-12-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 43.27,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "50-52h": 1,
              "64-66h": 2,
              "160-162h": 1,
              "168-170h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2025-11-14": 3,
              "2025-11-18": 1,
              "2025-11-24": 4,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2026-05-12": 2
            },
            "time_per_day": {
              "2025-11-14": 3.30732,
              "2025-11-18": 0.7710666666666667,
              "2025-11-24": 351.0619377777778,
              "2025-11-28": 161.28830305555553,
              "2025-12-04": 1.5196819444444443,
              "2026-05-12": 1.275517777777778
            },
            "time_count_per_day": {
              "2025-11-14": 3,
              "2025-11-18": 1,
              "2025-11-24": 4,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2026-05-12": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.75,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 0.7499077777777778
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 48.16,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "50-52h": 1,
                "160-162h": 1,
                "168-170h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-11-14": 2,
                "2025-11-18": 1,
                "2025-11-24": 2,
                "2025-11-28": 1,
                "2026-05-12": 2
              },
              "time_per_day": {
                "2025-11-14": 2.557412222222222,
                "2025-11-18": 0.7710666666666667,
                "2025-11-24": 219.38195,
                "2025-11-28": 161.28830305555553,
                "2026-05-12": 1.275517777777778
              },
              "time_count_per_day": {
                "2025-11-14": 2,
                "2025-11-18": 1,
                "2025-11-24": 2,
                "2025-11-28": 1,
                "2026-05-12": 2
              }
            },
            "P3": {
              "avg_time_hours": 44.4,
              "mode_time_hours": 65.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "64-66h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-24": 2,
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-11-24": 131.6799877777778,
                "2025-12-04": 1.5196819444444443
              },
              "time_count_per_day": {
                "2025-11-24": 2,
                "2025-12-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_495": {
      "overall": {
        "avg_time_hours": 70.33,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-17": 1
        },
        "time_per_day": {
          "2025-11-17": 70.33223194444444
        },
        "time_count_per_day": {
          "2025-11-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 70.33,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 70.33223194444444
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.33,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-17": 1
            },
            "time_per_day": {
              "2025-11-17": 70.33223194444444
            },
            "time_count_per_day": {
              "2025-11-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 70.33,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 70.33223194444444
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_496": {
      "overall": {
        "avg_time_hours": 0.4,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-14": 1
        },
        "time_per_day": {
          "2025-11-14": 0.40256749999999997
        },
        "time_count_per_day": {
          "2025-11-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.4,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {
            "2025-11-14": 0.40256749999999997
          },
          "time_count_per_day": {
            "2025-11-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.4,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-14": 1
            },
            "time_per_day": {
              "2025-11-14": 0.40256749999999997
            },
            "time_count_per_day": {
              "2025-11-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.4,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {
                "2025-11-14": 0.40256749999999997
              },
              "time_count_per_day": {
                "2025-11-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_499": {
      "overall": {
        "avg_time_hours": 66.88,
        "mode_time_hours": 67.0,
        "mode_frequency": 1,
        "time_distribution": {
          "66-68h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-17": 1
        },
        "time_per_day": {
          "2025-11-17": 66.8785325
        },
        "time_count_per_day": {
          "2025-11-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 66.88,
          "mode_time_hours": 67.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 66.8785325
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 66.88,
            "mode_time_hours": 67.0,
            "mode_frequency": 1,
            "time_distribution": {
              "66-68h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-17": 1
            },
            "time_per_day": {
              "2025-11-17": 66.8785325
            },
            "time_count_per_day": {
              "2025-11-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 66.88,
              "mode_time_hours": 67.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 66.8785325
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_148": {
      "overall": {
        "avg_time_hours": 8.09,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "18-20h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2026-03-25": 1,
          "2026-04-01": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-14": 2.019395,
          "2026-03-25": 7.985901666666666,
          "2026-04-01": 4.023446666666667,
          "2026-06-03": 18.342879444444442
        },
        "time_count_per_day": {
          "2025-11-14": 1,
          "2026-03-25": 1,
          "2026-04-01": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 8.09,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "18-20h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2026-03-25": 1,
            "2026-04-01": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-14": 2.019395,
            "2026-03-25": 7.985901666666666,
            "2026-04-01": 4.023446666666667,
            "2026-06-03": 18.342879444444442
          },
          "time_count_per_day": {
            "2025-11-14": 1,
            "2026-03-25": 1,
            "2026-04-01": 1,
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.09,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "18-20h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-14": 1,
              "2026-03-25": 1,
              "2026-04-01": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-14": 2.019395,
              "2026-03-25": 7.985901666666666,
              "2026-04-01": 4.023446666666667,
              "2026-06-03": 18.342879444444442
            },
            "time_count_per_day": {
              "2025-11-14": 1,
              "2026-03-25": 1,
              "2026-04-01": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 8.09,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "18-20h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-14": 1,
                "2026-03-25": 1,
                "2026-04-01": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-14": 2.019395,
                "2026-03-25": 7.985901666666666,
                "2026-04-01": 4.023446666666667,
                "2026-06-03": 18.342879444444442
              },
              "time_count_per_day": {
                "2025-11-14": 1,
                "2026-03-25": 1,
                "2026-04-01": 1,
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_439": {
      "overall": {
        "avg_time_hours": 97.42,
        "mode_time_hours": 97.0,
        "mode_frequency": 1,
        "time_distribution": {
          "96-98h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-19": 1
        },
        "time_per_day": {
          "2025-11-19": 97.42089777777778
        },
        "time_count_per_day": {
          "2025-11-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 97.42,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "96-98h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-19": 1
          },
          "time_per_day": {
            "2025-11-19": 97.42089777777778
          },
          "time_count_per_day": {
            "2025-11-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 97.42,
            "mode_time_hours": 97.0,
            "mode_frequency": 1,
            "time_distribution": {
              "96-98h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-19": 1
            },
            "time_per_day": {
              "2025-11-19": 97.42089777777778
            },
            "time_count_per_day": {
              "2025-11-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 97.42,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "96-98h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-19": 1
              },
              "time_per_day": {
                "2025-11-19": 97.42089777777778
              },
              "time_count_per_day": {
                "2025-11-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_203": {
      "overall": {
        "avg_time_hours": 641.84,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "382-384h": 1,
          "1514-1516h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2026-01-07": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2025-11-17": 29.022824444444446,
          "2026-01-07": 382.2063791666667,
          "2026-03-20": 1514.3029319444443
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2026-01-07": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 205.61,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1,
            "382-384h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2026-01-07": 1
          },
          "time_per_day": {
            "2025-11-17": 29.022824444444446,
            "2026-01-07": 382.2063791666667
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2026-01-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 1514.3,
          "mode_time_hours": 1515.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1514-1516h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 1514.3029319444443
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 641.84,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "382-384h": 1,
              "1514-1516h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2026-01-07": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2025-11-17": 29.022824444444446,
              "2026-01-07": 382.2063791666667,
              "2026-03-20": 1514.3029319444443
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2026-01-07": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 205.61,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1,
                "382-384h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2026-01-07": 1
              },
              "time_per_day": {
                "2025-11-17": 29.022824444444446,
                "2026-01-07": 382.2063791666667
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2026-01-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 1514.3,
              "mode_time_hours": 1515.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1514-1516h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 1514.3029319444443
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_415": {
      "overall": {
        "avg_time_hours": 172.85,
        "mode_time_hours": 1.0,
        "mode_frequency": 10,
        "time_distribution": {
          "0-2h": 10,
          "2-4h": 2,
          "8-10h": 1,
          "10-12h": 2,
          "12-14h": 3,
          "14-16h": 4,
          "16-18h": 1,
          "18-20h": 1,
          "24-26h": 1,
          "30-32h": 1,
          "36-38h": 1,
          "38-40h": 1,
          "56-58h": 1,
          "62-64h": 1,
          "66-68h": 1,
          "70-72h": 1,
          "84-86h": 1,
          "86-88h": 2,
          "114-116h": 1,
          "138-140h": 1,
          "200-202h": 1,
          "204-206h": 1,
          "244-246h": 1,
          "310-312h": 1,
          "320-322h": 1,
          "328-330h": 1,
          "384-386h": 1,
          "408-410h": 1,
          "538-540h": 1,
          "624-626h": 2,
          "722-724h": 1,
          "824-826h": 1,
          "864-866h": 1,
          "1298-1300h": 1
        },
        "tickets_count": 59,
        "tickets_per_day": {
          "2025-11-27": 4,
          "2025-12-10": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-14": 1,
          "2026-02-17": 1,
          "2026-02-23": 4,
          "2026-02-28": 1,
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-11": 1,
          "2026-03-18": 4,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-03-27": 1,
          "2026-03-31": 2,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-11": 1,
          "2026-04-13": 2,
          "2026-04-16": 3,
          "2026-04-18": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-02": 1,
          "2026-05-06": 3,
          "2026-05-15": 2,
          "2026-05-27": 2,
          "2026-05-28": 1,
          "2026-06-02": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-27": 288.92243083333335,
          "2025-12-10": 9.748066388888889,
          "2025-12-15": 3.5408375,
          "2025-12-17": 24.30912916666667,
          "2025-12-23": 0.05553361111111111,
          "2026-01-22": 38.939681944444445,
          "2026-01-26": 86.26465333333333,
          "2026-02-03": 205.5188588888889,
          "2026-02-04": 0.34682666666666667,
          "2026-02-06": 385.30351027777783,
          "2026-02-07": 62.519485277777775,
          "2026-02-10": 436.2768555555556,
          "2026-02-11": 30.170148888888885,
          "2026-02-14": 70.27038472222222,
          "2026-02-17": 311.8699105555556,
          "2026-02-23": 152.73206444444443,
          "2026-02-28": 201.0962197222222,
          "2026-03-04": 0.9503747222222223,
          "2026-03-11": 1298.073498888889,
          "2026-03-18": 1789.2755630555557,
          "2026-03-23": 17.560457222222222,
          "2026-03-26": 824.2058644444445,
          "2026-03-31": 878.1922355555555,
          "2026-04-06": 87.77309361111111,
          "2026-04-08": 139.9701122222222,
          "2026-04-11": 0.4490480555555556,
          "2026-04-13": 0.8596702777777777,
          "2026-04-16": 483.7814988888889,
          "2026-04-18": 0.10361055555555555,
          "2026-04-23": 722.7883658333334,
          "2026-04-28": 0.40939583333333335,
          "2026-04-29": 15.298083333333333,
          "2026-05-06": 355.6516183333334,
          "2026-05-27": 23.688666666666663,
          "2026-06-02": 3.7643791666666666,
          "2026-06-03": 37.726327777777776
        },
        "time_count_per_day": {
          "2025-11-27": 4,
          "2025-12-10": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-23": 1,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-14": 1,
          "2026-02-17": 1,
          "2026-02-23": 4,
          "2026-02-28": 1,
          "2026-03-04": 1,
          "2026-03-11": 1,
          "2026-03-18": 3,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-03-31": 2,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-11": 1,
          "2026-04-13": 2,
          "2026-04-16": 3,
          "2026-04-18": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-04-29": 1,
          "2026-05-06": 3,
          "2026-05-27": 2,
          "2026-06-02": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-05-15": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 138.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 1,
            "8-10h": 1,
            "10-12h": 2,
            "12-14h": 3,
            "14-16h": 4,
            "16-18h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "36-38h": 1,
            "56-58h": 1,
            "66-68h": 1,
            "86-88h": 1,
            "114-116h": 1,
            "138-140h": 1,
            "204-206h": 1,
            "310-312h": 1,
            "328-330h": 1,
            "408-410h": 1,
            "722-724h": 1,
            "864-866h": 1,
            "1298-1300h": 1
          },
          "tickets_count": 38,
          "tickets_per_day": {
            "2025-11-27": 3,
            "2025-12-10": 1,
            "2025-12-17": 1,
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-17": 1,
            "2026-02-23": 1,
            "2026-03-04": 1,
            "2026-03-11": 1,
            "2026-03-18": 1,
            "2026-03-23": 1,
            "2026-03-31": 2,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-11": 1,
            "2026-04-13": 2,
            "2026-04-16": 3,
            "2026-04-18": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-02": 1,
            "2026-05-06": 3,
            "2026-05-15": 1,
            "2026-05-27": 2,
            "2026-06-02": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-27": 43.88577,
            "2025-12-10": 9.748066388888889,
            "2025-12-17": 24.30912916666667,
            "2025-12-23": 0.05553361111111111,
            "2026-02-03": 205.5188588888889,
            "2026-02-04": 0.34682666666666667,
            "2026-02-10": 115.41172055555556,
            "2026-02-17": 311.8699105555556,
            "2026-02-23": 67.70102972222222,
            "2026-03-04": 0.9503747222222223,
            "2026-03-11": 1298.073498888889,
            "2026-03-23": 17.560457222222222,
            "2026-03-31": 878.1922355555555,
            "2026-04-06": 87.77309361111111,
            "2026-04-08": 139.9701122222222,
            "2026-04-11": 0.4490480555555556,
            "2026-04-13": 0.8596702777777777,
            "2026-04-16": 483.7814988888889,
            "2026-04-18": 0.10361055555555555,
            "2026-04-23": 722.7883658333334,
            "2026-04-28": 0.40939583333333335,
            "2026-04-29": 15.298083333333333,
            "2026-05-06": 355.6516183333334,
            "2026-05-27": 23.688666666666663,
            "2026-06-02": 3.7643791666666666,
            "2026-06-03": 37.726327777777776
          },
          "time_count_per_day": {
            "2025-11-27": 3,
            "2025-12-10": 1,
            "2025-12-17": 1,
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-17": 1,
            "2026-02-23": 1,
            "2026-03-04": 1,
            "2026-03-11": 1,
            "2026-03-23": 1,
            "2026-03-31": 2,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-11": 1,
            "2026-04-13": 2,
            "2026-04-16": 3,
            "2026-04-18": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-04-29": 1,
            "2026-05-06": 3,
            "2026-05-27": 2,
            "2026-06-02": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 137.32,
          "mode_time_hours": 245.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1,
            "62-64h": 1,
            "70-72h": 1,
            "86-88h": 1,
            "244-246h": 1,
            "320-322h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-02-07": 1,
            "2026-02-10": 1,
            "2026-02-14": 1
          },
          "time_per_day": {
            "2025-11-27": 245.03666083333334,
            "2026-01-22": 38.939681944444445,
            "2026-01-26": 86.26465333333333,
            "2026-02-07": 62.519485277777775,
            "2026-02-10": 320.865135,
            "2026-02-14": 70.27038472222222
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-02-07": 1,
            "2026-02-10": 1,
            "2026-02-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 331.51,
          "mode_time_hours": 625.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "30-32h": 1,
            "84-86h": 1,
            "200-202h": 1,
            "384-386h": 1,
            "538-540h": 1,
            "624-626h": 2,
            "824-826h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-02-06": 1,
            "2026-02-11": 1,
            "2026-02-23": 3,
            "2026-02-28": 1,
            "2026-03-18": 3,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-02-06": 385.30351027777783,
            "2026-02-11": 30.170148888888885,
            "2026-02-23": 85.03103472222222,
            "2026-02-28": 201.0962197222222,
            "2026-03-18": 1789.2755630555557,
            "2026-03-26": 824.2058644444445
          },
          "time_count_per_day": {
            "2026-02-06": 1,
            "2026-02-11": 1,
            "2026-02-23": 3,
            "2026-02-28": 1,
            "2026-03-18": 3,
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 3.54,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 3.5408375
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 172.85,
            "mode_time_hours": 1.0,
            "mode_frequency": 10,
            "time_distribution": {
              "0-2h": 10,
              "2-4h": 2,
              "8-10h": 1,
              "10-12h": 2,
              "12-14h": 3,
              "14-16h": 4,
              "16-18h": 1,
              "18-20h": 1,
              "24-26h": 1,
              "30-32h": 1,
              "36-38h": 1,
              "38-40h": 1,
              "56-58h": 1,
              "62-64h": 1,
              "66-68h": 1,
              "70-72h": 1,
              "84-86h": 1,
              "86-88h": 2,
              "114-116h": 1,
              "138-140h": 1,
              "200-202h": 1,
              "204-206h": 1,
              "244-246h": 1,
              "310-312h": 1,
              "320-322h": 1,
              "328-330h": 1,
              "384-386h": 1,
              "408-410h": 1,
              "538-540h": 1,
              "624-626h": 2,
              "722-724h": 1,
              "824-826h": 1,
              "864-866h": 1,
              "1298-1300h": 1
            },
            "tickets_count": 52,
            "tickets_per_day": {
              "2025-11-27": 4,
              "2025-12-10": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-14": 1,
              "2026-02-17": 1,
              "2026-02-23": 4,
              "2026-02-28": 1,
              "2026-03-04": 1,
              "2026-03-11": 1,
              "2026-03-18": 3,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-03-31": 2,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-11": 1,
              "2026-04-13": 2,
              "2026-04-16": 3,
              "2026-04-18": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-06": 3,
              "2026-05-27": 2,
              "2026-06-02": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-27": 288.92243083333335,
              "2025-12-10": 9.748066388888889,
              "2025-12-15": 3.5408375,
              "2025-12-17": 24.30912916666667,
              "2025-12-23": 0.05553361111111111,
              "2026-01-22": 38.939681944444445,
              "2026-01-26": 86.26465333333333,
              "2026-02-03": 205.5188588888889,
              "2026-02-04": 0.34682666666666667,
              "2026-02-06": 385.30351027777783,
              "2026-02-07": 62.519485277777775,
              "2026-02-10": 436.2768555555556,
              "2026-02-11": 30.170148888888885,
              "2026-02-14": 70.27038472222222,
              "2026-02-17": 311.8699105555556,
              "2026-02-23": 152.73206444444443,
              "2026-02-28": 201.0962197222222,
              "2026-03-04": 0.9503747222222223,
              "2026-03-11": 1298.073498888889,
              "2026-03-18": 1789.2755630555557,
              "2026-03-23": 17.560457222222222,
              "2026-03-26": 824.2058644444445,
              "2026-03-31": 878.1922355555555,
              "2026-04-06": 87.77309361111111,
              "2026-04-08": 139.9701122222222,
              "2026-04-11": 0.4490480555555556,
              "2026-04-13": 0.8596702777777777,
              "2026-04-16": 483.7814988888889,
              "2026-04-18": 0.10361055555555555,
              "2026-04-23": 722.7883658333334,
              "2026-04-28": 0.40939583333333335,
              "2026-04-29": 15.298083333333333,
              "2026-05-06": 355.6516183333334,
              "2026-05-27": 23.688666666666663,
              "2026-06-02": 3.7643791666666666,
              "2026-06-03": 37.726327777777776
            },
            "time_count_per_day": {
              "2025-11-27": 4,
              "2025-12-10": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-23": 1,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-04": 1,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-14": 1,
              "2026-02-17": 1,
              "2026-02-23": 4,
              "2026-02-28": 1,
              "2026-03-04": 1,
              "2026-03-11": 1,
              "2026-03-18": 3,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-03-31": 2,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-11": 1,
              "2026-04-13": 2,
              "2026-04-16": 3,
              "2026-04-18": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-04-29": 1,
              "2026-05-06": 3,
              "2026-05-27": 2,
              "2026-06-02": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 138.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 1,
                "8-10h": 1,
                "10-12h": 2,
                "12-14h": 3,
                "14-16h": 4,
                "16-18h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "36-38h": 1,
                "56-58h": 1,
                "66-68h": 1,
                "86-88h": 1,
                "114-116h": 1,
                "138-140h": 1,
                "204-206h": 1,
                "310-312h": 1,
                "328-330h": 1,
                "408-410h": 1,
                "722-724h": 1,
                "864-866h": 1,
                "1298-1300h": 1
              },
              "tickets_count": 35,
              "tickets_per_day": {
                "2025-11-27": 3,
                "2025-12-10": 1,
                "2025-12-17": 1,
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-17": 1,
                "2026-02-23": 1,
                "2026-03-04": 1,
                "2026-03-11": 1,
                "2026-03-23": 1,
                "2026-03-31": 2,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-11": 1,
                "2026-04-13": 2,
                "2026-04-16": 3,
                "2026-04-18": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-06": 3,
                "2026-05-27": 2,
                "2026-06-02": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-27": 43.88577,
                "2025-12-10": 9.748066388888889,
                "2025-12-17": 24.30912916666667,
                "2025-12-23": 0.05553361111111111,
                "2026-02-03": 205.5188588888889,
                "2026-02-04": 0.34682666666666667,
                "2026-02-10": 115.41172055555556,
                "2026-02-17": 311.8699105555556,
                "2026-02-23": 67.70102972222222,
                "2026-03-04": 0.9503747222222223,
                "2026-03-11": 1298.073498888889,
                "2026-03-23": 17.560457222222222,
                "2026-03-31": 878.1922355555555,
                "2026-04-06": 87.77309361111111,
                "2026-04-08": 139.9701122222222,
                "2026-04-11": 0.4490480555555556,
                "2026-04-13": 0.8596702777777777,
                "2026-04-16": 483.7814988888889,
                "2026-04-18": 0.10361055555555555,
                "2026-04-23": 722.7883658333334,
                "2026-04-28": 0.40939583333333335,
                "2026-04-29": 15.298083333333333,
                "2026-05-06": 355.6516183333334,
                "2026-05-27": 23.688666666666663,
                "2026-06-02": 3.7643791666666666,
                "2026-06-03": 37.726327777777776
              },
              "time_count_per_day": {
                "2025-11-27": 3,
                "2025-12-10": 1,
                "2025-12-17": 1,
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-17": 1,
                "2026-02-23": 1,
                "2026-03-04": 1,
                "2026-03-11": 1,
                "2026-03-23": 1,
                "2026-03-31": 2,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-11": 1,
                "2026-04-13": 2,
                "2026-04-16": 3,
                "2026-04-18": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-04-29": 1,
                "2026-05-06": 3,
                "2026-05-27": 2,
                "2026-06-02": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 137.32,
              "mode_time_hours": 245.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1,
                "62-64h": 1,
                "70-72h": 1,
                "86-88h": 1,
                "244-246h": 1,
                "320-322h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-02-07": 1,
                "2026-02-10": 1,
                "2026-02-14": 1
              },
              "time_per_day": {
                "2025-11-27": 245.03666083333334,
                "2026-01-22": 38.939681944444445,
                "2026-01-26": 86.26465333333333,
                "2026-02-07": 62.519485277777775,
                "2026-02-10": 320.865135,
                "2026-02-14": 70.27038472222222
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-02-07": 1,
                "2026-02-10": 1,
                "2026-02-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 331.51,
              "mode_time_hours": 625.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "30-32h": 1,
                "84-86h": 1,
                "200-202h": 1,
                "384-386h": 1,
                "538-540h": 1,
                "624-626h": 2,
                "824-826h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-02-06": 1,
                "2026-02-11": 1,
                "2026-02-23": 3,
                "2026-02-28": 1,
                "2026-03-18": 3,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-02-06": 385.30351027777783,
                "2026-02-11": 30.170148888888885,
                "2026-02-23": 85.03103472222222,
                "2026-02-28": 201.0962197222222,
                "2026-03-18": 1789.2755630555557,
                "2026-03-26": 824.2058644444445
              },
              "time_count_per_day": {
                "2026-02-06": 1,
                "2026-02-11": 1,
                "2026-02-23": 3,
                "2026-02-28": 1,
                "2026-03-18": 3,
                "2026-03-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 3.54,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 3.5408375
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-27": 1,
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-27": 1,
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-15": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_133": {
      "overall": {
        "avg_time_hours": 121.48,
        "mode_time_hours": 1.0,
        "mode_frequency": 11,
        "time_distribution": {
          "0-2h": 11,
          "2-4h": 3,
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 1,
          "10-12h": 1,
          "12-14h": 2,
          "18-20h": 2,
          "22-24h": 3,
          "24-26h": 1,
          "32-34h": 2,
          "46-48h": 1,
          "48-50h": 1,
          "54-56h": 2,
          "56-58h": 1,
          "62-64h": 1,
          "66-68h": 1,
          "74-76h": 1,
          "78-80h": 1,
          "100-102h": 2,
          "104-106h": 1,
          "116-118h": 1,
          "140-142h": 2,
          "148-150h": 1,
          "188-190h": 1,
          "202-204h": 1,
          "290-292h": 1,
          "318-320h": 1,
          "356-358h": 1,
          "444-446h": 1,
          "530-532h": 1,
          "662-664h": 1,
          "1770-1772h": 1
        },
        "tickets_count": 62,
        "tickets_per_day": {
          "2025-11-20": 1,
          "2025-11-22": 1,
          "2025-11-27": 2,
          "2025-11-28": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-07": 1,
          "2026-01-09": 1,
          "2026-01-10": 1,
          "2026-01-13": 2,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-02-05": 1,
          "2026-02-07": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-17": 3,
          "2026-04-02": 1,
          "2026-04-06": 1,
          "2026-04-11": 1,
          "2026-04-14": 1,
          "2026-04-17": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 9,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-03": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-11-20": 78.38503388888888,
          "2025-11-22": 100.076505,
          "2025-11-27": 27.017232777777778,
          "2025-11-28": 23.859059444444444,
          "2025-12-17": 117.45160083333333,
          "2025-12-18": 290.3610461111111,
          "2026-01-07": 48.20570777777778,
          "2026-01-09": 5.341121111111111,
          "2026-01-10": 3.105666388888889,
          "2026-01-13": 27.227013055555556,
          "2026-01-16": 662.9974083333333,
          "2026-01-19": 109.13416333333333,
          "2026-01-27": 25.859201666666667,
          "2026-02-05": 62.733182222222226,
          "2026-02-07": 57.81500972222222,
          "2026-02-09": 7.927628611111111,
          "2026-02-10": 64.15716888888889,
          "2026-02-12": 0.06232027777777778,
          "2026-02-13": 100.56052361111111,
          "2026-02-14": 46.142309166666664,
          "2026-02-23": 1.0528697222222223,
          "2026-03-03": 18.95895722222222,
          "2026-03-05": 318.25328222222225,
          "2026-03-10": 8.362206666666667,
          "2026-03-11": 203.8857838888889,
          "2026-03-17": 603.5810847222223,
          "2026-04-02": 74.01121749999999,
          "2026-04-06": 0.5988761111111112,
          "2026-04-11": 1.3590483333333332,
          "2026-04-14": 148.22975944444443,
          "2026-04-17": 0.0829136111111111,
          "2026-05-05": 444.04945250000003,
          "2026-05-06": 531.2601622222222,
          "2026-05-08": 1771.8535227777777,
          "2026-05-18": 18.140982222222224,
          "2026-05-19": 22.396551944444443,
          "2026-05-21": 66.78067444444444,
          "2026-05-26": 189.6064369444444,
          "2026-06-01": 140.92760638888888,
          "2026-06-03": 11.842188333333333,
          "2026-06-05": 4.540348333333333
        },
        "time_count_per_day": {
          "2025-11-20": 1,
          "2025-11-22": 1,
          "2025-11-27": 2,
          "2025-11-28": 1,
          "2025-12-17": 1,
          "2025-12-18": 1,
          "2026-01-07": 1,
          "2026-01-09": 1,
          "2026-01-10": 1,
          "2026-01-13": 2,
          "2026-01-16": 1,
          "2026-01-19": 2,
          "2026-01-27": 1,
          "2026-02-05": 1,
          "2026-02-07": 1,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 1,
          "2026-02-23": 1,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-17": 3,
          "2026-04-02": 1,
          "2026-04-06": 1,
          "2026-04-11": 1,
          "2026-04-14": 1,
          "2026-04-17": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-05-21": 1,
          "2026-05-26": 6,
          "2026-06-01": 1,
          "2026-06-03": 1,
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 148.23,
          "mode_time_hours": 149.0,
          "mode_frequency": 1,
          "time_distribution": {
            "148-150h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-14": 1
          },
          "time_per_day": {
            "2026-04-14": 148.22975944444443
          },
          "time_count_per_day": {
            "2026-04-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 142.17,
          "mode_time_hours": 1.0,
          "mode_frequency": 11,
          "time_distribution": {
            "0-2h": 11,
            "2-4h": 2,
            "6-8h": 1,
            "8-10h": 1,
            "10-12h": 1,
            "18-20h": 2,
            "22-24h": 3,
            "66-68h": 1,
            "74-76h": 1,
            "78-80h": 1,
            "100-102h": 1,
            "104-106h": 1,
            "140-142h": 1,
            "188-190h": 1,
            "202-204h": 1,
            "318-320h": 1,
            "444-446h": 1,
            "530-532h": 1,
            "662-664h": 1,
            "1770-1772h": 1
          },
          "tickets_count": 43,
          "tickets_per_day": {
            "2025-11-20": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-26": 1,
            "2026-01-10": 1,
            "2026-01-16": 1,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-04-02": 1,
            "2026-04-06": 1,
            "2026-04-11": 1,
            "2026-04-17": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 9,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-03": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-11-20": 78.38503388888888,
            "2025-11-27": 23.4287875,
            "2025-11-28": 23.859059444444444,
            "2026-01-10": 3.105666388888889,
            "2026-01-16": 662.9974083333333,
            "2026-02-09": 7.927628611111111,
            "2026-02-12": 0.06232027777777778,
            "2026-02-13": 100.56052361111111,
            "2026-02-23": 1.0528697222222223,
            "2026-03-03": 18.95895722222222,
            "2026-03-05": 318.25328222222225,
            "2026-03-10": 8.362206666666667,
            "2026-03-11": 203.8857838888889,
            "2026-03-17": 105.60553416666667,
            "2026-04-02": 74.01121749999999,
            "2026-04-06": 0.5988761111111112,
            "2026-04-11": 1.3590483333333332,
            "2026-04-17": 0.0829136111111111,
            "2026-05-05": 444.04945250000003,
            "2026-05-06": 531.2601622222222,
            "2026-05-08": 1771.8535227777777,
            "2026-05-18": 18.140982222222224,
            "2026-05-19": 22.396551944444443,
            "2026-05-21": 66.78067444444444,
            "2026-05-26": 189.6064369444444,
            "2026-06-01": 140.92760638888888,
            "2026-06-03": 11.842188333333333,
            "2026-06-05": 4.540348333333333
          },
          "time_count_per_day": {
            "2025-11-20": 1,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2026-01-10": 1,
            "2026-01-16": 1,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-23": 1,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-04-02": 1,
            "2026-04-06": 1,
            "2026-04-11": 1,
            "2026-04-17": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 6,
            "2026-06-01": 1,
            "2026-06-03": 1,
            "2026-06-05": 2
          }
        },
        "P3": {
          "avg_time_hours": 68.57,
          "mode_time_hours": 13.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "12-14h": 2,
            "24-26h": 1,
            "32-34h": 2,
            "46-48h": 1,
            "48-50h": 1,
            "54-56h": 2,
            "56-58h": 1,
            "62-64h": 1,
            "100-102h": 1,
            "116-118h": 1,
            "140-142h": 1,
            "356-358h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-11-22": 1,
            "2025-11-27": 1,
            "2025-12-17": 1,
            "2026-01-07": 1,
            "2026-01-09": 1,
            "2026-01-13": 2,
            "2026-01-19": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-10": 2,
            "2026-02-14": 1,
            "2026-03-17": 2
          },
          "time_per_day": {
            "2025-11-22": 100.076505,
            "2025-11-27": 3.5884452777777778,
            "2025-12-17": 117.45160083333333,
            "2026-01-07": 48.20570777777778,
            "2026-01-09": 5.341121111111111,
            "2026-01-13": 27.227013055555556,
            "2026-01-19": 109.13416333333333,
            "2026-01-27": 25.859201666666667,
            "2026-02-05": 62.733182222222226,
            "2026-02-07": 57.81500972222222,
            "2026-02-10": 64.15716888888889,
            "2026-02-14": 46.142309166666664,
            "2026-03-17": 497.9755505555556
          },
          "time_count_per_day": {
            "2025-11-22": 1,
            "2025-11-27": 1,
            "2025-12-17": 1,
            "2026-01-07": 1,
            "2026-01-09": 1,
            "2026-01-13": 2,
            "2026-01-19": 2,
            "2026-01-27": 1,
            "2026-02-05": 1,
            "2026-02-07": 1,
            "2026-02-10": 2,
            "2026-02-14": 1,
            "2026-03-17": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 290.36,
          "mode_time_hours": 291.0,
          "mode_frequency": 1,
          "time_distribution": {
            "290-292h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 290.3610461111111
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 121.48,
            "mode_time_hours": 1.0,
            "mode_frequency": 11,
            "time_distribution": {
              "0-2h": 11,
              "2-4h": 3,
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 1,
              "10-12h": 1,
              "12-14h": 2,
              "18-20h": 2,
              "22-24h": 3,
              "24-26h": 1,
              "32-34h": 2,
              "46-48h": 1,
              "48-50h": 1,
              "54-56h": 2,
              "56-58h": 1,
              "62-64h": 1,
              "66-68h": 1,
              "74-76h": 1,
              "78-80h": 1,
              "100-102h": 2,
              "104-106h": 1,
              "116-118h": 1,
              "140-142h": 2,
              "148-150h": 1,
              "188-190h": 1,
              "202-204h": 1,
              "290-292h": 1,
              "318-320h": 1,
              "356-358h": 1,
              "444-446h": 1,
              "530-532h": 1,
              "662-664h": 1,
              "1770-1772h": 1
            },
            "tickets_count": 53,
            "tickets_per_day": {
              "2025-11-20": 1,
              "2025-11-22": 1,
              "2025-11-27": 2,
              "2025-11-28": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-07": 1,
              "2026-01-09": 1,
              "2026-01-10": 1,
              "2026-01-13": 2,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-02-05": 1,
              "2026-02-07": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-23": 1,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-17": 3,
              "2026-04-02": 1,
              "2026-04-06": 1,
              "2026-04-11": 1,
              "2026-04-14": 1,
              "2026-04-17": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 6,
              "2026-06-01": 1,
              "2026-06-03": 1,
              "2026-06-05": 2
            },
            "time_per_day": {
              "2025-11-20": 78.38503388888888,
              "2025-11-22": 100.076505,
              "2025-11-27": 27.017232777777778,
              "2025-11-28": 23.859059444444444,
              "2025-12-17": 117.45160083333333,
              "2025-12-18": 290.3610461111111,
              "2026-01-07": 48.20570777777778,
              "2026-01-09": 5.341121111111111,
              "2026-01-10": 3.105666388888889,
              "2026-01-13": 27.227013055555556,
              "2026-01-16": 662.9974083333333,
              "2026-01-19": 109.13416333333333,
              "2026-01-27": 25.859201666666667,
              "2026-02-05": 62.733182222222226,
              "2026-02-07": 57.81500972222222,
              "2026-02-09": 7.927628611111111,
              "2026-02-10": 64.15716888888889,
              "2026-02-12": 0.06232027777777778,
              "2026-02-13": 100.56052361111111,
              "2026-02-14": 46.142309166666664,
              "2026-02-23": 1.0528697222222223,
              "2026-03-03": 18.95895722222222,
              "2026-03-05": 318.25328222222225,
              "2026-03-10": 8.362206666666667,
              "2026-03-11": 203.8857838888889,
              "2026-03-17": 603.5810847222223,
              "2026-04-02": 74.01121749999999,
              "2026-04-06": 0.5988761111111112,
              "2026-04-11": 1.3590483333333332,
              "2026-04-14": 148.22975944444443,
              "2026-04-17": 0.0829136111111111,
              "2026-05-05": 444.04945250000003,
              "2026-05-06": 531.2601622222222,
              "2026-05-08": 1771.8535227777777,
              "2026-05-18": 18.140982222222224,
              "2026-05-19": 22.396551944444443,
              "2026-05-21": 66.78067444444444,
              "2026-05-26": 189.6064369444444,
              "2026-06-01": 140.92760638888888,
              "2026-06-03": 11.842188333333333,
              "2026-06-05": 4.540348333333333
            },
            "time_count_per_day": {
              "2025-11-20": 1,
              "2025-11-22": 1,
              "2025-11-27": 2,
              "2025-11-28": 1,
              "2025-12-17": 1,
              "2025-12-18": 1,
              "2026-01-07": 1,
              "2026-01-09": 1,
              "2026-01-10": 1,
              "2026-01-13": 2,
              "2026-01-16": 1,
              "2026-01-19": 2,
              "2026-01-27": 1,
              "2026-02-05": 1,
              "2026-02-07": 1,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 1,
              "2026-02-23": 1,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-17": 3,
              "2026-04-02": 1,
              "2026-04-06": 1,
              "2026-04-11": 1,
              "2026-04-14": 1,
              "2026-04-17": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-18": 1,
              "2026-05-19": 1,
              "2026-05-21": 1,
              "2026-05-26": 6,
              "2026-06-01": 1,
              "2026-06-03": 1,
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 148.23,
              "mode_time_hours": 149.0,
              "mode_frequency": 1,
              "time_distribution": {
                "148-150h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {
                "2026-04-14": 148.22975944444443
              },
              "time_count_per_day": {
                "2026-04-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 142.17,
              "mode_time_hours": 1.0,
              "mode_frequency": 11,
              "time_distribution": {
                "0-2h": 11,
                "2-4h": 2,
                "6-8h": 1,
                "8-10h": 1,
                "10-12h": 1,
                "18-20h": 2,
                "22-24h": 3,
                "66-68h": 1,
                "74-76h": 1,
                "78-80h": 1,
                "100-102h": 1,
                "104-106h": 1,
                "140-142h": 1,
                "188-190h": 1,
                "202-204h": 1,
                "318-320h": 1,
                "444-446h": 1,
                "530-532h": 1,
                "662-664h": 1,
                "1770-1772h": 1
              },
              "tickets_count": 34,
              "tickets_per_day": {
                "2025-11-20": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2026-01-10": 1,
                "2026-01-16": 1,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-23": 1,
                "2026-03-03": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-04-02": 1,
                "2026-04-06": 1,
                "2026-04-11": 1,
                "2026-04-17": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 6,
                "2026-06-01": 1,
                "2026-06-03": 1,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-11-20": 78.38503388888888,
                "2025-11-27": 23.4287875,
                "2025-11-28": 23.859059444444444,
                "2026-01-10": 3.105666388888889,
                "2026-01-16": 662.9974083333333,
                "2026-02-09": 7.927628611111111,
                "2026-02-12": 0.06232027777777778,
                "2026-02-13": 100.56052361111111,
                "2026-02-23": 1.0528697222222223,
                "2026-03-03": 18.95895722222222,
                "2026-03-05": 318.25328222222225,
                "2026-03-10": 8.362206666666667,
                "2026-03-11": 203.8857838888889,
                "2026-03-17": 105.60553416666667,
                "2026-04-02": 74.01121749999999,
                "2026-04-06": 0.5988761111111112,
                "2026-04-11": 1.3590483333333332,
                "2026-04-17": 0.0829136111111111,
                "2026-05-05": 444.04945250000003,
                "2026-05-06": 531.2601622222222,
                "2026-05-08": 1771.8535227777777,
                "2026-05-18": 18.140982222222224,
                "2026-05-19": 22.396551944444443,
                "2026-05-21": 66.78067444444444,
                "2026-05-26": 189.6064369444444,
                "2026-06-01": 140.92760638888888,
                "2026-06-03": 11.842188333333333,
                "2026-06-05": 4.540348333333333
              },
              "time_count_per_day": {
                "2025-11-20": 1,
                "2025-11-27": 1,
                "2025-11-28": 1,
                "2026-01-10": 1,
                "2026-01-16": 1,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-23": 1,
                "2026-03-03": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-04-02": 1,
                "2026-04-06": 1,
                "2026-04-11": 1,
                "2026-04-17": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-18": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 6,
                "2026-06-01": 1,
                "2026-06-03": 1,
                "2026-06-05": 2
              }
            },
            "P3": {
              "avg_time_hours": 68.57,
              "mode_time_hours": 13.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "12-14h": 2,
                "24-26h": 1,
                "32-34h": 2,
                "46-48h": 1,
                "48-50h": 1,
                "54-56h": 2,
                "56-58h": 1,
                "62-64h": 1,
                "100-102h": 1,
                "116-118h": 1,
                "140-142h": 1,
                "356-358h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-11-22": 1,
                "2025-11-27": 1,
                "2025-12-17": 1,
                "2026-01-07": 1,
                "2026-01-09": 1,
                "2026-01-13": 2,
                "2026-01-19": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-10": 2,
                "2026-02-14": 1,
                "2026-03-17": 2
              },
              "time_per_day": {
                "2025-11-22": 100.076505,
                "2025-11-27": 3.5884452777777778,
                "2025-12-17": 117.45160083333333,
                "2026-01-07": 48.20570777777778,
                "2026-01-09": 5.341121111111111,
                "2026-01-13": 27.227013055555556,
                "2026-01-19": 109.13416333333333,
                "2026-01-27": 25.859201666666667,
                "2026-02-05": 62.733182222222226,
                "2026-02-07": 57.81500972222222,
                "2026-02-10": 64.15716888888889,
                "2026-02-14": 46.142309166666664,
                "2026-03-17": 497.9755505555556
              },
              "time_count_per_day": {
                "2025-11-22": 1,
                "2025-11-27": 1,
                "2025-12-17": 1,
                "2026-01-07": 1,
                "2026-01-09": 1,
                "2026-01-13": 2,
                "2026-01-19": 2,
                "2026-01-27": 1,
                "2026-02-05": 1,
                "2026-02-07": 1,
                "2026-02-10": 2,
                "2026-02-14": 1,
                "2026-03-17": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 290.36,
              "mode_time_hours": 291.0,
              "mode_frequency": 1,
              "time_distribution": {
                "290-292h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 290.3610461111111
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-26": 2,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-26": 2,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-26": 1,
              "2026-03-02": 1,
              "2026-05-12": 1,
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-03-02": 1,
                "2026-05-12": 1,
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_504": {
      "overall": {
        "avg_time_hours": 621.68,
        "mode_time_hours": 393.0,
        "mode_frequency": 1,
        "time_distribution": {
          "344-346h": 1,
          "392-394h": 1,
          "548-550h": 1,
          "1200-1202h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-03": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-12-03": 392.28247833333336,
          "2026-03-20": 344.97151694444443,
          "2026-03-24": 1200.7979683333333,
          "2026-04-23": 548.67571
        },
        "time_count_per_day": {
          "2025-12-03": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 772.88,
          "mode_time_hours": 1201.0,
          "mode_frequency": 1,
          "time_distribution": {
            "344-346h": 1,
            "1200-1202h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-20": 344.97151694444443,
            "2026-03-24": 1200.7979683333333
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-03-24": 1
          }
        },
        "P2": {
          "avg_time_hours": 470.48,
          "mode_time_hours": 393.0,
          "mode_frequency": 1,
          "time_distribution": {
            "392-394h": 1,
            "548-550h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-12-03": 392.28247833333336,
            "2026-04-23": 548.67571
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 621.68,
            "mode_time_hours": 393.0,
            "mode_frequency": 1,
            "time_distribution": {
              "344-346h": 1,
              "392-394h": 1,
              "548-550h": 1,
              "1200-1202h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-03": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-12-03": 392.28247833333336,
              "2026-03-20": 344.97151694444443,
              "2026-03-24": 1200.7979683333333,
              "2026-04-23": 548.67571
            },
            "time_count_per_day": {
              "2025-12-03": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 772.88,
              "mode_time_hours": 1201.0,
              "mode_frequency": 1,
              "time_distribution": {
                "344-346h": 1,
                "1200-1202h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-20": 344.97151694444443,
                "2026-03-24": 1200.7979683333333
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-03-24": 1
              }
            },
            "P2": {
              "avg_time_hours": 470.48,
              "mode_time_hours": 393.0,
              "mode_frequency": 1,
              "time_distribution": {
                "392-394h": 1,
                "548-550h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-12-03": 392.28247833333336,
                "2026-04-23": 548.67571
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_506": {
      "overall": {
        "avg_time_hours": 1.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2026-02-10": 1
        },
        "time_per_day": {
          "2025-11-17": 1.6680563888888889,
          "2026-02-10": 0.4558213888888889
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 0.4558213888888889
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "P3": {
          "avg_time_hours": 1.67,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 1.6680563888888889
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2026-02-10": 1
            },
            "time_per_day": {
              "2025-11-17": 1.6680563888888889,
              "2026-02-10": 0.4558213888888889
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 0.4558213888888889
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "P3": {
              "avg_time_hours": 1.67,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 1.6680563888888889
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_509": {
      "overall": {
        "avg_time_hours": 8.54,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-17": 1
        },
        "time_per_day": {
          "2025-11-17": 8.544499166666666
        },
        "time_count_per_day": {
          "2025-11-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.54,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 8.544499166666666
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.54,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-17": 1
            },
            "time_per_day": {
              "2025-11-17": 8.544499166666666
            },
            "time_count_per_day": {
              "2025-11-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.54,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 8.544499166666666
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_445": {
      "overall": {
        "avg_time_hours": 248.09,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "18-20h": 1,
          "30-32h": 2,
          "42-44h": 1,
          "60-62h": 1,
          "64-66h": 1,
          "70-72h": 1,
          "134-136h": 1,
          "360-362h": 1,
          "412-414h": 1,
          "756-758h": 1,
          "1072-1074h": 1,
          "1152-1154h": 1
        },
        "tickets_count": 20,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-16": 2,
          "2026-01-19": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-03-03": 1,
          "2026-03-26": 1,
          "2026-03-30": 2,
          "2026-04-02": 1,
          "2026-04-23": 2,
          "2026-05-14": 1
        },
        "time_per_day": {
          "2025-11-17": 0.30923500000000004,
          "2025-12-02": 360.62851388888885,
          "2025-12-29": 71.571405,
          "2025-12-30": 0.02759,
          "2026-01-16": 60.90495388888888,
          "2026-01-19": 135.72791750000002,
          "2026-01-26": 412.04478305555557,
          "2026-02-03": 19.227865,
          "2026-02-09": 61.44550777777778,
          "2026-02-10": 1.784383611111111,
          "2026-02-19": 64.35175583333333,
          "2026-03-03": 3.3757294444444446,
          "2026-04-02": 43.633133611111106,
          "2026-04-23": 1909.102681111111,
          "2026-05-14": 1073.3146025
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-12-02": 1,
          "2025-12-29": 1,
          "2025-12-30": 1,
          "2026-01-16": 2,
          "2026-01-19": 1,
          "2026-01-26": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-03-03": 1,
          "2026-04-02": 1,
          "2026-04-23": 2,
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 305.24,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "18-20h": 1,
            "42-44h": 1,
            "64-66h": 1,
            "134-136h": 1,
            "412-414h": 1,
            "756-758h": 1,
            "1072-1074h": 1,
            "1152-1154h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-12-30": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-19": 1,
            "2026-03-03": 1,
            "2026-03-26": 1,
            "2026-03-30": 2,
            "2026-04-02": 1,
            "2026-04-23": 2,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-11-17": 0.30923500000000004,
            "2025-12-30": 0.02759,
            "2026-01-19": 135.72791750000002,
            "2026-01-26": 412.04478305555557,
            "2026-02-03": 19.227865,
            "2026-02-10": 1.784383611111111,
            "2026-02-19": 64.35175583333333,
            "2026-03-03": 3.3757294444444446,
            "2026-04-02": 43.633133611111106,
            "2026-04-23": 1909.102681111111,
            "2026-05-14": 1073.3146025
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-12-30": 1,
            "2026-01-19": 1,
            "2026-01-26": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-19": 1,
            "2026-03-03": 1,
            "2026-04-02": 1,
            "2026-04-23": 2,
            "2026-05-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 110.91,
          "mode_time_hours": 31.0,
          "mode_frequency": 2,
          "time_distribution": {
            "30-32h": 2,
            "60-62h": 1,
            "70-72h": 1,
            "360-362h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-29": 1,
            "2026-01-16": 2,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2025-12-02": 360.62851388888885,
            "2025-12-29": 71.571405,
            "2026-01-16": 60.90495388888888,
            "2026-02-09": 61.44550777777778
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2025-12-29": 1,
            "2026-01-16": 2,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 248.09,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "18-20h": 1,
              "30-32h": 2,
              "42-44h": 1,
              "60-62h": 1,
              "64-66h": 1,
              "70-72h": 1,
              "134-136h": 1,
              "360-362h": 1,
              "412-414h": 1,
              "756-758h": 1,
              "1072-1074h": 1,
              "1152-1154h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-16": 2,
              "2026-01-19": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-03-03": 1,
              "2026-04-02": 1,
              "2026-04-23": 2,
              "2026-05-14": 1
            },
            "time_per_day": {
              "2025-11-17": 0.30923500000000004,
              "2025-12-02": 360.62851388888885,
              "2025-12-29": 71.571405,
              "2025-12-30": 0.02759,
              "2026-01-16": 60.90495388888888,
              "2026-01-19": 135.72791750000002,
              "2026-01-26": 412.04478305555557,
              "2026-02-03": 19.227865,
              "2026-02-09": 61.44550777777778,
              "2026-02-10": 1.784383611111111,
              "2026-02-19": 64.35175583333333,
              "2026-03-03": 3.3757294444444446,
              "2026-04-02": 43.633133611111106,
              "2026-04-23": 1909.102681111111,
              "2026-05-14": 1073.3146025
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-12-02": 1,
              "2025-12-29": 1,
              "2025-12-30": 1,
              "2026-01-16": 2,
              "2026-01-19": 1,
              "2026-01-26": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-03-03": 1,
              "2026-04-02": 1,
              "2026-04-23": 2,
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 305.24,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "18-20h": 1,
                "42-44h": 1,
                "64-66h": 1,
                "134-136h": 1,
                "412-414h": 1,
                "756-758h": 1,
                "1072-1074h": 1,
                "1152-1154h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-12-30": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-19": 1,
                "2026-03-03": 1,
                "2026-04-02": 1,
                "2026-04-23": 2,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-11-17": 0.30923500000000004,
                "2025-12-30": 0.02759,
                "2026-01-19": 135.72791750000002,
                "2026-01-26": 412.04478305555557,
                "2026-02-03": 19.227865,
                "2026-02-10": 1.784383611111111,
                "2026-02-19": 64.35175583333333,
                "2026-03-03": 3.3757294444444446,
                "2026-04-02": 43.633133611111106,
                "2026-04-23": 1909.102681111111,
                "2026-05-14": 1073.3146025
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-12-30": 1,
                "2026-01-19": 1,
                "2026-01-26": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-19": 1,
                "2026-03-03": 1,
                "2026-04-02": 1,
                "2026-04-23": 2,
                "2026-05-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 110.91,
              "mode_time_hours": 31.0,
              "mode_frequency": 2,
              "time_distribution": {
                "30-32h": 2,
                "60-62h": 1,
                "70-72h": 1,
                "360-362h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2025-12-29": 1,
                "2026-01-16": 2,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2025-12-02": 360.62851388888885,
                "2025-12-29": 71.571405,
                "2026-01-16": 60.90495388888888,
                "2026-02-09": 61.44550777777778
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2025-12-29": 1,
                "2026-01-16": 2,
                "2026-02-09": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-30": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-30": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_512": {
      "overall": {
        "avg_time_hours": 51.16,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "36-38h": 1,
          "66-68h": 1,
          "94-96h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-22": 1,
          "2025-11-28": 1,
          "2025-12-03": 1
        },
        "time_per_day": {
          "2025-11-17": 5.750876666666667,
          "2025-11-22": 94.43205333333333,
          "2025-11-28": 37.42418194444444,
          "2025-12-03": 67.04425361111112
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2025-11-22": 1,
          "2025-11-28": 1,
          "2025-12-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 37.42,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-28": 1
          },
          "time_per_day": {
            "2025-11-28": 37.42418194444444
          },
          "time_count_per_day": {
            "2025-11-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 55.74,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "66-68h": 1,
            "94-96h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-12-03": 1
          },
          "time_per_day": {
            "2025-11-17": 5.750876666666667,
            "2025-11-22": 94.43205333333333,
            "2025-12-03": 67.04425361111112
          },
          "time_count_per_day": {
            "2025-11-17": 1,
            "2025-11-22": 1,
            "2025-12-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 51.16,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "36-38h": 1,
              "66-68h": 1,
              "94-96h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2025-11-22": 1,
              "2025-11-28": 1,
              "2025-12-03": 1
            },
            "time_per_day": {
              "2025-11-17": 5.750876666666667,
              "2025-11-22": 94.43205333333333,
              "2025-11-28": 37.42418194444444,
              "2025-12-03": 67.04425361111112
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2025-11-22": 1,
              "2025-11-28": 1,
              "2025-12-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 37.42,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-28": 1
              },
              "time_per_day": {
                "2025-11-28": 37.42418194444444
              },
              "time_count_per_day": {
                "2025-11-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 55.74,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "66-68h": 1,
                "94-96h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-11-17": 5.750876666666667,
                "2025-11-22": 94.43205333333333,
                "2025-12-03": 67.04425361111112
              },
              "time_count_per_day": {
                "2025-11-17": 1,
                "2025-11-22": 1,
                "2025-12-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_514": {
      "overall": {
        "avg_time_hours": 20.33,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-18": 1
        },
        "time_per_day": {
          "2025-11-18": 20.3284025
        },
        "time_count_per_day": {
          "2025-11-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 20.33,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-18": 1
          },
          "time_per_day": {
            "2025-11-18": 20.3284025
          },
          "time_count_per_day": {
            "2025-11-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.33,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-18": 1
            },
            "time_per_day": {
              "2025-11-18": 20.3284025
            },
            "time_count_per_day": {
              "2025-11-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 20.33,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-18": 1
              },
              "time_per_day": {
                "2025-11-18": 20.3284025
              },
              "time_count_per_day": {
                "2025-11-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_515": {
      "overall": {
        "avg_time_hours": 117.66,
        "mode_time_hours": 235.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "234-236h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-11-27": 234.54333638888892,
          "2025-12-05": 0.7865858333333333
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2025-12-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.79,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 0.7865858333333333
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 234.54,
          "mode_time_hours": 235.0,
          "mode_frequency": 1,
          "time_distribution": {
            "234-236h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {
            "2025-11-27": 234.54333638888892
          },
          "time_count_per_day": {
            "2025-11-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 117.66,
            "mode_time_hours": 235.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "234-236h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-11-27": 234.54333638888892,
              "2025-12-05": 0.7865858333333333
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2025-12-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.79,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 0.7865858333333333
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 234.54,
              "mode_time_hours": 235.0,
              "mode_frequency": 1,
              "time_distribution": {
                "234-236h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-27": 234.54333638888892
              },
              "time_count_per_day": {
                "2025-11-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_516": {
      "overall": {
        "avg_time_hours": 102.88,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "6-8h": 2,
          "8-10h": 2,
          "10-12h": 1,
          "14-16h": 2,
          "16-18h": 1,
          "18-20h": 4,
          "24-26h": 1,
          "30-32h": 3,
          "36-38h": 1,
          "40-42h": 1,
          "48-50h": 1,
          "50-52h": 1,
          "56-58h": 1,
          "62-64h": 1,
          "66-68h": 1,
          "80-82h": 1,
          "82-84h": 1,
          "120-122h": 1,
          "162-164h": 1,
          "188-190h": 1,
          "204-206h": 1,
          "246-248h": 1,
          "410-412h": 1,
          "460-462h": 1,
          "492-494h": 1,
          "542-544h": 1,
          "670-672h": 1
        },
        "tickets_count": 42,
        "tickets_per_day": {
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-01-28": 2,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-19": 4,
          "2026-02-20": 3,
          "2026-02-21": 3,
          "2026-02-24": 1,
          "2026-03-05": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-16": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-13": 1
        },
        "time_per_day": {
          "2025-11-19": 30.501942777777778,
          "2025-11-21": 0.3566302777777777,
          "2026-01-14": 189.20924250000002,
          "2026-01-15": 24.650622777777777,
          "2026-01-22": 51.07919777777778,
          "2026-01-28": 27.871885,
          "2026-01-30": 246.5102686111111,
          "2026-02-03": 566.5374155555555,
          "2026-02-05": 62.74326222222222,
          "2026-02-10": 15.753433333333334,
          "2026-02-12": 48.60207222222222,
          "2026-02-13": 410.5228652777778,
          "2026-02-14": 164.18637333333334,
          "2026-02-16": 671.1329905555555,
          "2026-02-19": 206.54493805555555,
          "2026-02-20": 46.374385,
          "2026-02-21": 102.0778138888889,
          "2026-02-24": 15.024539444444443,
          "2026-03-05": 1.9763269444444445,
          "2026-03-11": 0.031093333333333334,
          "2026-03-12": 460.08767611111114,
          "2026-03-16": 121.23318083333334,
          "2026-03-20": 162.18627777777778,
          "2026-03-27": 11.21986388888889,
          "2026-03-31": 18.980799166666664,
          "2026-04-02": 67.40897805555555,
          "2026-04-30": 37.51313416666667,
          "2026-05-06": 543.1318947222222,
          "2026-05-13": 17.481806944444443
        },
        "time_count_per_day": {
          "2025-11-19": 1,
          "2025-11-21": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-22": 1,
          "2026-01-28": 2,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-05": 1,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-14": 2,
          "2026-02-16": 1,
          "2026-02-19": 4,
          "2026-02-20": 3,
          "2026-02-21": 3,
          "2026-02-24": 1,
          "2026-03-05": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-16": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-03-31": 1,
          "2026-04-02": 1,
          "2026-04-30": 1,
          "2026-05-06": 1,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 410.52,
          "mode_time_hours": 411.0,
          "mode_frequency": 1,
          "time_distribution": {
            "410-412h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 410.5228652777778
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        },
        "P2": {
          "avg_time_hours": 163.17,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "10-12h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "36-38h": 1,
            "66-68h": 1,
            "188-190h": 1,
            "246-248h": 1,
            "460-462h": 1,
            "492-494h": 1,
            "542-544h": 1,
            "670-672h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2026-01-14": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-16": 1,
            "2026-02-19": 1,
            "2026-02-24": 1,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2025-11-21": 0.3566302777777777,
            "2026-01-14": 189.20924250000002,
            "2026-01-30": 246.5102686111111,
            "2026-02-03": 493.2454427777778,
            "2026-02-10": 0.275495,
            "2026-02-16": 671.1329905555555,
            "2026-02-19": 0.22426194444444444,
            "2026-02-24": 15.024539444444443,
            "2026-03-05": 1.9763269444444445,
            "2026-03-11": 0.031093333333333334,
            "2026-03-12": 460.08767611111114,
            "2026-03-27": 11.21986388888889,
            "2026-03-31": 18.980799166666664,
            "2026-04-02": 67.40897805555555,
            "2026-04-30": 37.51313416666667,
            "2026-05-06": 543.1318947222222,
            "2026-05-13": 17.481806944444443
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2026-01-14": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-10": 1,
            "2026-02-16": 1,
            "2026-02-19": 1,
            "2026-02-24": 1,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-27": 1,
            "2026-03-31": 1,
            "2026-04-02": 1,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 50.94,
          "mode_time_hours": 19.0,
          "mode_frequency": 3,
          "time_distribution": {
            "8-10h": 2,
            "14-16h": 1,
            "18-20h": 3,
            "24-26h": 1,
            "30-32h": 1,
            "50-52h": 1,
            "56-58h": 1,
            "62-64h": 1,
            "80-82h": 1,
            "82-84h": 1,
            "120-122h": 1,
            "162-164h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-28": 2,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-14": 2,
            "2026-02-20": 3,
            "2026-03-16": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2025-11-19": 30.501942777777778,
            "2026-01-15": 24.650622777777777,
            "2026-01-22": 51.07919777777778,
            "2026-01-28": 27.871885,
            "2026-02-03": 73.29197277777777,
            "2026-02-05": 62.74326222222222,
            "2026-02-14": 164.18637333333334,
            "2026-02-20": 46.374385,
            "2026-03-16": 121.23318083333334,
            "2026-03-20": 162.18627777777778
          },
          "time_count_per_day": {
            "2025-11-19": 1,
            "2026-01-15": 1,
            "2026-01-22": 1,
            "2026-01-28": 2,
            "2026-02-03": 2,
            "2026-02-05": 1,
            "2026-02-14": 2,
            "2026-02-20": 3,
            "2026-03-16": 1,
            "2026-03-20": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 20.96,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "6-8h": 2,
            "30-32h": 2,
            "40-42h": 1,
            "48-50h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-19": 2,
            "2026-02-21": 3
          },
          "time_per_day": {
            "2026-02-10": 15.477938333333334,
            "2026-02-12": 48.60207222222222,
            "2026-02-19": 1.5018369444444446,
            "2026-02-21": 102.0778138888889
          },
          "time_count_per_day": {
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-19": 2,
            "2026-02-21": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 204.82,
          "mode_time_hours": 205.0,
          "mode_frequency": 1,
          "time_distribution": {
            "204-206h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 204.81883916666666
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 102.88,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "6-8h": 2,
              "8-10h": 2,
              "10-12h": 1,
              "14-16h": 2,
              "16-18h": 1,
              "18-20h": 4,
              "24-26h": 1,
              "30-32h": 3,
              "36-38h": 1,
              "40-42h": 1,
              "48-50h": 1,
              "50-52h": 1,
              "56-58h": 1,
              "62-64h": 1,
              "66-68h": 1,
              "80-82h": 1,
              "82-84h": 1,
              "120-122h": 1,
              "162-164h": 1,
              "188-190h": 1,
              "204-206h": 1,
              "246-248h": 1,
              "410-412h": 1,
              "460-462h": 1,
              "492-494h": 1,
              "542-544h": 1,
              "670-672h": 1
            },
            "tickets_count": 42,
            "tickets_per_day": {
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-01-28": 2,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-19": 4,
              "2026-02-20": 3,
              "2026-02-21": 3,
              "2026-02-24": 1,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2025-11-19": 30.501942777777778,
              "2025-11-21": 0.3566302777777777,
              "2026-01-14": 189.20924250000002,
              "2026-01-15": 24.650622777777777,
              "2026-01-22": 51.07919777777778,
              "2026-01-28": 27.871885,
              "2026-01-30": 246.5102686111111,
              "2026-02-03": 566.5374155555555,
              "2026-02-05": 62.74326222222222,
              "2026-02-10": 15.753433333333334,
              "2026-02-12": 48.60207222222222,
              "2026-02-13": 410.5228652777778,
              "2026-02-14": 164.18637333333334,
              "2026-02-16": 671.1329905555555,
              "2026-02-19": 206.54493805555555,
              "2026-02-20": 46.374385,
              "2026-02-21": 102.0778138888889,
              "2026-02-24": 15.024539444444443,
              "2026-03-05": 1.9763269444444445,
              "2026-03-11": 0.031093333333333334,
              "2026-03-12": 460.08767611111114,
              "2026-03-16": 121.23318083333334,
              "2026-03-20": 162.18627777777778,
              "2026-03-27": 11.21986388888889,
              "2026-03-31": 18.980799166666664,
              "2026-04-02": 67.40897805555555,
              "2026-04-30": 37.51313416666667,
              "2026-05-06": 543.1318947222222,
              "2026-05-13": 17.481806944444443
            },
            "time_count_per_day": {
              "2025-11-19": 1,
              "2025-11-21": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-22": 1,
              "2026-01-28": 2,
              "2026-01-30": 1,
              "2026-02-03": 3,
              "2026-02-05": 1,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-14": 2,
              "2026-02-16": 1,
              "2026-02-19": 4,
              "2026-02-20": 3,
              "2026-02-21": 3,
              "2026-02-24": 1,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-16": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-03-31": 1,
              "2026-04-02": 1,
              "2026-04-30": 1,
              "2026-05-06": 1,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 410.52,
              "mode_time_hours": 411.0,
              "mode_frequency": 1,
              "time_distribution": {
                "410-412h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 410.5228652777778
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            },
            "P2": {
              "avg_time_hours": 163.17,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "10-12h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "36-38h": 1,
                "66-68h": 1,
                "188-190h": 1,
                "246-248h": 1,
                "460-462h": 1,
                "492-494h": 1,
                "542-544h": 1,
                "670-672h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2026-01-14": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-16": 1,
                "2026-02-19": 1,
                "2026-02-24": 1,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2025-11-21": 0.3566302777777777,
                "2026-01-14": 189.20924250000002,
                "2026-01-30": 246.5102686111111,
                "2026-02-03": 493.2454427777778,
                "2026-02-10": 0.275495,
                "2026-02-16": 671.1329905555555,
                "2026-02-19": 0.22426194444444444,
                "2026-02-24": 15.024539444444443,
                "2026-03-05": 1.9763269444444445,
                "2026-03-11": 0.031093333333333334,
                "2026-03-12": 460.08767611111114,
                "2026-03-27": 11.21986388888889,
                "2026-03-31": 18.980799166666664,
                "2026-04-02": 67.40897805555555,
                "2026-04-30": 37.51313416666667,
                "2026-05-06": 543.1318947222222,
                "2026-05-13": 17.481806944444443
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2026-01-14": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-10": 1,
                "2026-02-16": 1,
                "2026-02-19": 1,
                "2026-02-24": 1,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-27": 1,
                "2026-03-31": 1,
                "2026-04-02": 1,
                "2026-04-30": 1,
                "2026-05-06": 1,
                "2026-05-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 50.94,
              "mode_time_hours": 19.0,
              "mode_frequency": 3,
              "time_distribution": {
                "8-10h": 2,
                "14-16h": 1,
                "18-20h": 3,
                "24-26h": 1,
                "30-32h": 1,
                "50-52h": 1,
                "56-58h": 1,
                "62-64h": 1,
                "80-82h": 1,
                "82-84h": 1,
                "120-122h": 1,
                "162-164h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-11-19": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-28": 2,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-14": 2,
                "2026-02-20": 3,
                "2026-03-16": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2025-11-19": 30.501942777777778,
                "2026-01-15": 24.650622777777777,
                "2026-01-22": 51.07919777777778,
                "2026-01-28": 27.871885,
                "2026-02-03": 73.29197277777777,
                "2026-02-05": 62.74326222222222,
                "2026-02-14": 164.18637333333334,
                "2026-02-20": 46.374385,
                "2026-03-16": 121.23318083333334,
                "2026-03-20": 162.18627777777778
              },
              "time_count_per_day": {
                "2025-11-19": 1,
                "2026-01-15": 1,
                "2026-01-22": 1,
                "2026-01-28": 2,
                "2026-02-03": 2,
                "2026-02-05": 1,
                "2026-02-14": 2,
                "2026-02-20": 3,
                "2026-03-16": 1,
                "2026-03-20": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 20.96,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "6-8h": 2,
                "30-32h": 2,
                "40-42h": 1,
                "48-50h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-19": 2,
                "2026-02-21": 3
              },
              "time_per_day": {
                "2026-02-10": 15.477938333333334,
                "2026-02-12": 48.60207222222222,
                "2026-02-19": 1.5018369444444446,
                "2026-02-21": 102.0778138888889
              },
              "time_count_per_day": {
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-19": 2,
                "2026-02-21": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 204.82,
              "mode_time_hours": 205.0,
              "mode_frequency": 1,
              "time_distribution": {
                "204-206h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 204.81883916666666
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_517": {
      "overall": {
        "avg_time_hours": 134.88,
        "mode_time_hours": 219.0,
        "mode_frequency": 1,
        "time_distribution": {
          "50-52h": 1,
          "218-220h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2026-01-22": 1
        },
        "time_per_day": {
          "2025-11-27": 219.13785166666665,
          "2026-01-22": 50.63121777777778
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2026-01-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 50.63,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-22": 1
          },
          "time_per_day": {
            "2026-01-22": 50.63121777777778
          },
          "time_count_per_day": {
            "2026-01-22": 1
          }
        },
        "P3": {
          "avg_time_hours": 219.14,
          "mode_time_hours": 219.0,
          "mode_frequency": 1,
          "time_distribution": {
            "218-220h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {
            "2025-11-27": 219.13785166666665
          },
          "time_count_per_day": {
            "2025-11-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 134.88,
            "mode_time_hours": 219.0,
            "mode_frequency": 1,
            "time_distribution": {
              "50-52h": 1,
              "218-220h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2026-01-22": 1
            },
            "time_per_day": {
              "2025-11-27": 219.13785166666665,
              "2026-01-22": 50.63121777777778
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2026-01-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 50.63,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-22": 1
              },
              "time_per_day": {
                "2026-01-22": 50.63121777777778
              },
              "time_count_per_day": {
                "2026-01-22": 1
              }
            },
            "P3": {
              "avg_time_hours": 219.14,
              "mode_time_hours": 219.0,
              "mode_frequency": 1,
              "time_distribution": {
                "218-220h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-27": 219.13785166666665
              },
              "time_count_per_day": {
                "2025-11-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_518": {
      "overall": {
        "avg_time_hours": 57.86,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "4-6h": 1,
          "8-10h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "46-48h": 1,
          "74-76h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "170-172h": 1,
          "228-230h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-11-22": 1,
          "2025-11-27": 1,
          "2026-01-08": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-02-23": 1,
          "2026-03-10": 2,
          "2026-04-02": 1,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-11-22": 97.90723472222221,
          "2025-11-27": 28.41230638888889,
          "2026-01-08": 0.15535972222222222,
          "2026-01-27": 5.98666,
          "2026-01-28": 21.9781725,
          "2026-02-09": 229.63322166666666,
          "2026-02-16": 170.40494388888888,
          "2026-02-23": 1.808455,
          "2026-03-10": 11.509516944444446,
          "2026-04-02": 26.64336861111111,
          "2026-04-15": 47.24715,
          "2026-04-20": 75.45465250000001,
          "2026-06-01": 92.8784675
        },
        "time_count_per_day": {
          "2025-11-22": 1,
          "2025-11-27": 1,
          "2026-01-08": 1,
          "2026-01-27": 1,
          "2026-01-28": 1,
          "2026-02-09": 1,
          "2026-02-16": 1,
          "2026-02-23": 1,
          "2026-03-10": 2,
          "2026-04-02": 1,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 47.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "8-10h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "46-48h": 1,
            "74-76h": 1,
            "92-94h": 1,
            "228-230h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-01-08": 1,
            "2026-01-27": 1,
            "2026-02-09": 1,
            "2026-02-23": 1,
            "2026-03-10": 2,
            "2026-04-02": 1,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-11-27": 28.41230638888889,
            "2026-01-08": 0.15535972222222222,
            "2026-01-27": 5.98666,
            "2026-02-09": 229.63322166666666,
            "2026-02-23": 1.808455,
            "2026-03-10": 11.509516944444446,
            "2026-04-02": 26.64336861111111,
            "2026-04-15": 47.24715,
            "2026-04-20": 75.45465250000001,
            "2026-06-01": 92.8784675
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-01-08": 1,
            "2026-01-27": 1,
            "2026-02-09": 1,
            "2026-02-23": 1,
            "2026-03-10": 2,
            "2026-04-02": 1,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 96.76,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "96-98h": 1,
            "170-172h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-22": 1,
            "2026-01-28": 1,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2025-11-22": 97.90723472222221,
            "2026-01-28": 21.9781725,
            "2026-02-16": 170.40494388888888
          },
          "time_count_per_day": {
            "2025-11-22": 1,
            "2026-01-28": 1,
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 57.86,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "4-6h": 1,
              "8-10h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "46-48h": 1,
              "74-76h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "170-172h": 1,
              "228-230h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-11-22": 1,
              "2025-11-27": 1,
              "2026-01-08": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-02-23": 1,
              "2026-03-10": 2,
              "2026-04-02": 1,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-11-22": 97.90723472222221,
              "2025-11-27": 28.41230638888889,
              "2026-01-08": 0.15535972222222222,
              "2026-01-27": 5.98666,
              "2026-01-28": 21.9781725,
              "2026-02-09": 229.63322166666666,
              "2026-02-16": 170.40494388888888,
              "2026-02-23": 1.808455,
              "2026-03-10": 11.509516944444446,
              "2026-04-02": 26.64336861111111,
              "2026-04-15": 47.24715,
              "2026-04-20": 75.45465250000001,
              "2026-06-01": 92.8784675
            },
            "time_count_per_day": {
              "2025-11-22": 1,
              "2025-11-27": 1,
              "2026-01-08": 1,
              "2026-01-27": 1,
              "2026-01-28": 1,
              "2026-02-09": 1,
              "2026-02-16": 1,
              "2026-02-23": 1,
              "2026-03-10": 2,
              "2026-04-02": 1,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 47.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "8-10h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "46-48h": 1,
                "74-76h": 1,
                "92-94h": 1,
                "228-230h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-01-08": 1,
                "2026-01-27": 1,
                "2026-02-09": 1,
                "2026-02-23": 1,
                "2026-03-10": 2,
                "2026-04-02": 1,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-11-27": 28.41230638888889,
                "2026-01-08": 0.15535972222222222,
                "2026-01-27": 5.98666,
                "2026-02-09": 229.63322166666666,
                "2026-02-23": 1.808455,
                "2026-03-10": 11.509516944444446,
                "2026-04-02": 26.64336861111111,
                "2026-04-15": 47.24715,
                "2026-04-20": 75.45465250000001,
                "2026-06-01": 92.8784675
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-01-08": 1,
                "2026-01-27": 1,
                "2026-02-09": 1,
                "2026-02-23": 1,
                "2026-03-10": 2,
                "2026-04-02": 1,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 96.76,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "96-98h": 1,
                "170-172h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-22": 1,
                "2026-01-28": 1,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2025-11-22": 97.90723472222221,
                "2026-01-28": 21.9781725,
                "2026-02-16": 170.40494388888888
              },
              "time_count_per_day": {
                "2025-11-22": 1,
                "2026-01-28": 1,
                "2026-02-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_520": {
      "overall": {
        "avg_time_hours": 817.63,
        "mode_time_hours": 75.0,
        "mode_frequency": 1,
        "time_distribution": {
          "74-76h": 1,
          "1560-1562h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-21": 1,
          "2026-02-18": 1
        },
        "time_per_day": {
          "2025-11-21": 74.85251777777778,
          "2026-02-18": 1560.4081719444443
        },
        "time_count_per_day": {
          "2025-11-21": 1,
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1560.41,
          "mode_time_hours": 1561.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1560-1562h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 1560.4081719444443
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 74.85,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-21": 1
          },
          "time_per_day": {
            "2025-11-21": 74.85251777777778
          },
          "time_count_per_day": {
            "2025-11-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 817.63,
            "mode_time_hours": 75.0,
            "mode_frequency": 1,
            "time_distribution": {
              "74-76h": 1,
              "1560-1562h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2026-02-18": 1
            },
            "time_per_day": {
              "2025-11-21": 74.85251777777778,
              "2026-02-18": 1560.4081719444443
            },
            "time_count_per_day": {
              "2025-11-21": 1,
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1560.41,
              "mode_time_hours": 1561.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1560-1562h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 1560.4081719444443
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 74.85,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-21": 1
              },
              "time_per_day": {
                "2025-11-21": 74.85251777777778
              },
              "time_count_per_day": {
                "2025-11-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_521": {
      "overall": {
        "avg_time_hours": 593.78,
        "mode_time_hours": 593.0,
        "mode_frequency": 1,
        "time_distribution": {
          "592-594h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-13": 1
        },
        "time_per_day": {
          "2025-12-13": 593.7800633333334
        },
        "time_count_per_day": {
          "2025-12-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 593.78,
          "mode_time_hours": 593.0,
          "mode_frequency": 1,
          "time_distribution": {
            "592-594h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-13": 1
          },
          "time_per_day": {
            "2025-12-13": 593.7800633333334
          },
          "time_count_per_day": {
            "2025-12-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 593.78,
            "mode_time_hours": 593.0,
            "mode_frequency": 1,
            "time_distribution": {
              "592-594h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-13": 1
            },
            "time_per_day": {
              "2025-12-13": 593.7800633333334
            },
            "time_count_per_day": {
              "2025-12-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 593.78,
              "mode_time_hours": 593.0,
              "mode_frequency": 1,
              "time_distribution": {
                "592-594h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-13": 1
              },
              "time_per_day": {
                "2025-12-13": 593.7800633333334
              },
              "time_count_per_day": {
                "2025-12-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_513": {
      "overall": {
        "avg_time_hours": 377.8,
        "mode_time_hours": 377.0,
        "mode_frequency": 1,
        "time_distribution": {
          "376-378h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-04": 1
        },
        "time_per_day": {
          "2025-12-04": 377.79629222222223
        },
        "time_count_per_day": {
          "2025-12-04": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 377.8,
          "mode_time_hours": 377.0,
          "mode_frequency": 1,
          "time_distribution": {
            "376-378h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-12-04": 377.79629222222223
          },
          "time_count_per_day": {
            "2025-12-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 377.8,
            "mode_time_hours": 377.0,
            "mode_frequency": 1,
            "time_distribution": {
              "376-378h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-04": 1
            },
            "time_per_day": {
              "2025-12-04": 377.79629222222223
            },
            "time_count_per_day": {
              "2025-12-04": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 377.8,
              "mode_time_hours": 377.0,
              "mode_frequency": 1,
              "time_distribution": {
                "376-378h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-12-04": 377.79629222222223
              },
              "time_count_per_day": {
                "2025-12-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_523": {
      "overall": {
        "avg_time_hours": 4.18,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-19": 1
        },
        "time_per_day": {
          "2025-11-19": 4.184505277777777
        },
        "time_count_per_day": {
          "2025-11-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.18,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-19": 1
          },
          "time_per_day": {
            "2025-11-19": 4.184505277777777
          },
          "time_count_per_day": {
            "2025-11-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.18,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-19": 1
            },
            "time_per_day": {
              "2025-11-19": 4.184505277777777
            },
            "time_count_per_day": {
              "2025-11-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.18,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-19": 1
              },
              "time_per_day": {
                "2025-11-19": 4.184505277777777
              },
              "time_count_per_day": {
                "2025-11-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_524": {
      "overall": {
        "avg_time_hours": 204.59,
        "mode_time_hours": 205.0,
        "mode_frequency": 1,
        "time_distribution": {
          "204-206h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-28": 1
        },
        "time_per_day": {
          "2025-11-28": 204.5883613888889
        },
        "time_count_per_day": {
          "2025-11-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 204.59,
          "mode_time_hours": 205.0,
          "mode_frequency": 1,
          "time_distribution": {
            "204-206h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-28": 1
          },
          "time_per_day": {
            "2025-11-28": 204.5883613888889
          },
          "time_count_per_day": {
            "2025-11-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 204.59,
            "mode_time_hours": 205.0,
            "mode_frequency": 1,
            "time_distribution": {
              "204-206h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-28": 1
            },
            "time_per_day": {
              "2025-11-28": 204.5883613888889
            },
            "time_count_per_day": {
              "2025-11-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 204.59,
              "mode_time_hours": 205.0,
              "mode_frequency": 1,
              "time_distribution": {
                "204-206h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-28": 1
              },
              "time_per_day": {
                "2025-11-28": 204.5883613888889
              },
              "time_count_per_day": {
                "2025-11-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_530": {
      "overall": {
        "avg_time_hours": 212.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 2,
          "14-16h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "30-32h": 1,
          "40-42h": 1,
          "52-54h": 1,
          "100-102h": 1,
          "204-206h": 1,
          "280-282h": 1,
          "388-390h": 1,
          "412-414h": 1,
          "1018-1020h": 1,
          "1222-1224h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-11-28": 2,
          "2025-12-02": 1,
          "2025-12-18": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-20": 1,
          "2026-02-03": 1,
          "2026-02-23": 1,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-20": 2,
          "2026-03-24": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-11-28": 227.4173188888889,
          "2025-12-02": 3.4241425000000003,
          "2025-12-18": 40.646685,
          "2026-01-15": 23.91629888888889,
          "2026-01-16": 31.243655555555556,
          "2026-01-20": 100.43285388888889,
          "2026-02-03": 388.96408527777777,
          "2026-02-23": 0.05531944444444445,
          "2026-03-09": 3.0375213888888886,
          "2026-03-20": 465.92665999999997,
          "2026-03-24": 281.57913,
          "2026-04-06": 0.4501011111111111,
          "2026-04-08": 14.53568111111111,
          "2026-04-23": 1018.3329430555556,
          "2026-04-27": 0.17370027777777777,
          "2026-05-27": 1222.0353944444444
        },
        "time_count_per_day": {
          "2025-11-28": 2,
          "2025-12-02": 1,
          "2025-12-18": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-20": 1,
          "2026-02-03": 1,
          "2026-02-23": 1,
          "2026-03-09": 1,
          "2026-03-20": 2,
          "2026-03-24": 1,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-23": 1,
          "2026-04-27": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 202.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "14-16h": 1,
            "40-42h": 1,
            "52-54h": 1,
            "204-206h": 1,
            "280-282h": 1,
            "388-390h": 1,
            "412-414h": 1,
            "1222-1224h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-18": 1,
            "2026-02-03": 1,
            "2026-02-23": 1,
            "2026-03-09": 1,
            "2026-03-12": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-27": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2025-11-28": 205.5382502777778,
            "2025-12-02": 3.4241425000000003,
            "2025-12-18": 40.646685,
            "2026-02-03": 388.96408527777777,
            "2026-02-23": 0.05531944444444445,
            "2026-03-09": 3.0375213888888886,
            "2026-03-20": 465.92665999999997,
            "2026-03-24": 281.57913,
            "2026-04-06": 0.4501011111111111,
            "2026-04-08": 14.53568111111111,
            "2026-04-27": 0.17370027777777777,
            "2026-05-27": 1222.0353944444444
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2025-12-02": 1,
            "2025-12-18": 1,
            "2026-02-03": 1,
            "2026-02-23": 1,
            "2026-03-09": 1,
            "2026-03-20": 2,
            "2026-03-24": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-27": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 239.16,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "22-24h": 1,
            "30-32h": 1,
            "100-102h": 1,
            "1018-1020h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-11-28": 21.87906861111111,
            "2026-01-15": 23.91629888888889,
            "2026-01-16": 31.243655555555556,
            "2026-01-20": 100.43285388888889,
            "2026-04-23": 1018.3329430555556
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2026-01-15": 1,
            "2026-01-16": 1,
            "2026-01-20": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 212.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 2,
              "14-16h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "30-32h": 1,
              "40-42h": 1,
              "52-54h": 1,
              "100-102h": 1,
              "204-206h": 1,
              "280-282h": 1,
              "388-390h": 1,
              "412-414h": 1,
              "1018-1020h": 1,
              "1222-1224h": 1
            },
            "tickets_count": 18,
            "tickets_per_day": {
              "2025-11-28": 2,
              "2025-12-02": 1,
              "2025-12-18": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-20": 1,
              "2026-02-03": 1,
              "2026-02-23": 1,
              "2026-03-09": 1,
              "2026-03-20": 2,
              "2026-03-24": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-11-28": 227.4173188888889,
              "2025-12-02": 3.4241425000000003,
              "2025-12-18": 40.646685,
              "2026-01-15": 23.91629888888889,
              "2026-01-16": 31.243655555555556,
              "2026-01-20": 100.43285388888889,
              "2026-02-03": 388.96408527777777,
              "2026-02-23": 0.05531944444444445,
              "2026-03-09": 3.0375213888888886,
              "2026-03-20": 465.92665999999997,
              "2026-03-24": 281.57913,
              "2026-04-06": 0.4501011111111111,
              "2026-04-08": 14.53568111111111,
              "2026-04-23": 1018.3329430555556,
              "2026-04-27": 0.17370027777777777,
              "2026-05-27": 1222.0353944444444
            },
            "time_count_per_day": {
              "2025-11-28": 2,
              "2025-12-02": 1,
              "2025-12-18": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-20": 1,
              "2026-02-03": 1,
              "2026-02-23": 1,
              "2026-03-09": 1,
              "2026-03-20": 2,
              "2026-03-24": 1,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-23": 1,
              "2026-04-27": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 202.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "14-16h": 1,
                "40-42h": 1,
                "52-54h": 1,
                "204-206h": 1,
                "280-282h": 1,
                "388-390h": 1,
                "412-414h": 1,
                "1222-1224h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-18": 1,
                "2026-02-03": 1,
                "2026-02-23": 1,
                "2026-03-09": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-27": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2025-11-28": 205.5382502777778,
                "2025-12-02": 3.4241425000000003,
                "2025-12-18": 40.646685,
                "2026-02-03": 388.96408527777777,
                "2026-02-23": 0.05531944444444445,
                "2026-03-09": 3.0375213888888886,
                "2026-03-20": 465.92665999999997,
                "2026-03-24": 281.57913,
                "2026-04-06": 0.4501011111111111,
                "2026-04-08": 14.53568111111111,
                "2026-04-27": 0.17370027777777777,
                "2026-05-27": 1222.0353944444444
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2025-12-02": 1,
                "2025-12-18": 1,
                "2026-02-03": 1,
                "2026-02-23": 1,
                "2026-03-09": 1,
                "2026-03-20": 2,
                "2026-03-24": 1,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-27": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 239.16,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "22-24h": 1,
                "30-32h": 1,
                "100-102h": 1,
                "1018-1020h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-11-28": 21.87906861111111,
                "2026-01-15": 23.91629888888889,
                "2026-01-16": 31.243655555555556,
                "2026-01-20": 100.43285388888889,
                "2026-04-23": 1018.3329430555556
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2026-01-15": 1,
                "2026-01-16": 1,
                "2026-01-20": 1,
                "2026-04-23": 1
              }
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_531": {
      "overall": {
        "avg_time_hours": 10.36,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-20": 1
        },
        "time_per_day": {
          "2025-11-20": 10.361776388888888
        },
        "time_count_per_day": {
          "2025-11-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.36,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-20": 1
          },
          "time_per_day": {
            "2025-11-20": 10.361776388888888
          },
          "time_count_per_day": {
            "2025-11-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.36,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-20": 1
            },
            "time_per_day": {
              "2025-11-20": 10.361776388888888
            },
            "time_count_per_day": {
              "2025-11-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.36,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-20": 1
              },
              "time_per_day": {
                "2025-11-20": 10.361776388888888
              },
              "time_count_per_day": {
                "2025-11-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_533": {
      "overall": {
        "avg_time_hours": 4.39,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-20": 1
        },
        "time_per_day": {
          "2025-11-20": 4.389062222222222
        },
        "time_count_per_day": {
          "2025-11-20": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.39,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-20": 1
          },
          "time_per_day": {
            "2025-11-20": 4.389062222222222
          },
          "time_count_per_day": {
            "2025-11-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.39,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-20": 1
            },
            "time_per_day": {
              "2025-11-20": 4.389062222222222
            },
            "time_count_per_day": {
              "2025-11-20": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.39,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-20": 1
              },
              "time_per_day": {
                "2025-11-20": 4.389062222222222
              },
              "time_count_per_day": {
                "2025-11-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_534": {
      "overall": {
        "avg_time_hours": 2.36,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-20": 1
        },
        "time_per_day": {
          "2025-11-20": 2.356298611111111
        },
        "time_count_per_day": {
          "2025-11-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.36,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-20": 1
          },
          "time_per_day": {
            "2025-11-20": 2.356298611111111
          },
          "time_count_per_day": {
            "2025-11-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.36,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-20": 1
            },
            "time_per_day": {
              "2025-11-20": 2.356298611111111
            },
            "time_count_per_day": {
              "2025-11-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.36,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-20": 1
              },
              "time_per_day": {
                "2025-11-20": 2.356298611111111
              },
              "time_count_per_day": {
                "2025-11-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_535": {
      "overall": {
        "avg_time_hours": 236.48,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "696-698h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-20": 2,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-11-20": 11.61099138888889,
          "2026-04-23": 697.8358622222222
        },
        "time_count_per_day": {
          "2025-11-20": 2,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 697.84,
          "mode_time_hours": 697.0,
          "mode_frequency": 1,
          "time_distribution": {
            "696-698h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 697.8358622222222
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 5.81,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-20": 2
          },
          "time_per_day": {
            "2025-11-20": 11.61099138888889
          },
          "time_count_per_day": {
            "2025-11-20": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 236.48,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "696-698h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-20": 2,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-11-20": 11.61099138888889,
              "2026-04-23": 697.8358622222222
            },
            "time_count_per_day": {
              "2025-11-20": 2,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 697.84,
              "mode_time_hours": 697.0,
              "mode_frequency": 1,
              "time_distribution": {
                "696-698h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 697.8358622222222
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 5.81,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-20": 2
              },
              "time_per_day": {
                "2025-11-20": 11.61099138888889
              },
              "time_count_per_day": {
                "2025-11-20": 2
              }
            }
          }
        }
      }
    },
    "cliente_539": {
      "overall": {
        "avg_time_hours": 93.75,
        "mode_time_hours": 113.0,
        "mode_frequency": 1,
        "time_distribution": {
          "72-74h": 1,
          "112-114h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-25": 1,
          "2026-01-19": 1
        },
        "time_per_day": {
          "2025-11-25": 113.66069527777779,
          "2026-01-19": 73.83694222222223
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 93.75,
          "mode_time_hours": 113.0,
          "mode_frequency": 1,
          "time_distribution": {
            "72-74h": 1,
            "112-114h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2026-01-19": 1
          },
          "time_per_day": {
            "2025-11-25": 113.66069527777779,
            "2026-01-19": 73.83694222222223
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 93.75,
            "mode_time_hours": 113.0,
            "mode_frequency": 1,
            "time_distribution": {
              "72-74h": 1,
              "112-114h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2026-01-19": 1
            },
            "time_per_day": {
              "2025-11-25": 113.66069527777779,
              "2026-01-19": 73.83694222222223
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 93.75,
              "mode_time_hours": 113.0,
              "mode_frequency": 1,
              "time_distribution": {
                "72-74h": 1,
                "112-114h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2026-01-19": 1
              },
              "time_per_day": {
                "2025-11-25": 113.66069527777779,
                "2026-01-19": 73.83694222222223
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_104": {
      "overall": {
        "avg_time_hours": 91.81,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 2,
          "4-6h": 2,
          "6-8h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "22-24h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "38-40h": 1,
          "40-42h": 1,
          "42-44h": 1,
          "52-54h": 1,
          "58-60h": 1,
          "62-64h": 1,
          "66-68h": 1,
          "72-74h": 2,
          "74-76h": 1,
          "76-78h": 1,
          "84-86h": 1,
          "86-88h": 1,
          "128-130h": 1,
          "142-144h": 1,
          "146-148h": 1,
          "148-150h": 1,
          "164-166h": 1,
          "190-192h": 1,
          "256-258h": 1,
          "348-350h": 1,
          "798-800h": 1
        },
        "tickets_count": 41,
        "tickets_per_day": {
          "2025-11-22": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-13": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-03-06": 1,
          "2026-03-14": 1,
          "2026-03-16": 2,
          "2026-03-21": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-04-16": 1,
          "2026-04-18": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-04-30": 1,
          "2026-05-11": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-05-28": 1,
          "2026-05-30": 1,
          "2026-06-05": 1,
          "2026-06-06": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-22": 43.00660166666667,
          "2025-11-26": 4.785578333333333,
          "2025-11-28": 0.5882827777777778,
          "2025-12-04": 142.47905527777777,
          "2025-12-13": 147.07601416666665,
          "2026-01-14": 164.60346361111112,
          "2026-01-16": 40.035021388888886,
          "2026-01-22": 38.17403194444445,
          "2026-01-23": 72.1706311111111,
          "2026-01-26": 72.56117694444444,
          "2026-02-03": 103.0559775,
          "2026-02-04": 52.967490833333336,
          "2026-02-10": 223.4486777777778,
          "2026-02-12": 85.61465638888889,
          "2026-02-18": 348.2558486111111,
          "2026-02-19": 76.84427388888889,
          "2026-02-21": 128.33507527777778,
          "2026-02-23": 62.66969111111111,
          "2026-03-06": 256.6774272222222,
          "2026-03-14": 2.304027222222222,
          "2026-03-16": 207.50850527777777,
          "2026-03-21": 28.306140833333334,
          "2026-03-23": 23.496517222222224,
          "2026-03-24": 10.044375277777776,
          "2026-03-27": 0.3753672222222222,
          "2026-04-16": 5.479309444444445,
          "2026-04-18": 798.6522355555555,
          "2026-04-20": 13.634943333333334,
          "2026-04-23": 66.8831225,
          "2026-04-30": 74.85183861111112,
          "2026-05-15": 2.566950277777778,
          "2026-05-18": 7.02388,
          "2026-06-05": 0.5290286111111111
        },
        "time_count_per_day": {
          "2025-11-22": 1,
          "2025-11-26": 1,
          "2025-11-28": 1,
          "2025-12-04": 1,
          "2025-12-13": 1,
          "2026-01-14": 1,
          "2026-01-16": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-02-03": 2,
          "2026-02-04": 1,
          "2026-02-10": 2,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-03-06": 1,
          "2026-03-14": 1,
          "2026-03-16": 2,
          "2026-03-21": 1,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-03-27": 1,
          "2026-04-16": 1,
          "2026-04-18": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-04-30": 1,
          "2026-05-15": 1,
          "2026-05-18": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 28.31,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-21": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-03-21": 28.306140833333334
          },
          "time_count_per_day": {
            "2026-03-21": 1
          }
        },
        "P2": {
          "avg_time_hours": 101.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 2,
            "4-6h": 2,
            "6-8h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "22-24h": 1,
            "40-42h": 1,
            "58-60h": 1,
            "62-64h": 1,
            "66-68h": 1,
            "72-74h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "128-130h": 1,
            "146-148h": 1,
            "148-150h": 1,
            "190-192h": 1,
            "256-258h": 1,
            "348-350h": 1,
            "798-800h": 1
          },
          "tickets_count": 29,
          "tickets_per_day": {
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2025-12-13": 1,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-03-06": 1,
            "2026-03-14": 1,
            "2026-03-16": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-04-16": 1,
            "2026-04-18": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-30": 1,
            "2026-06-05": 1,
            "2026-06-06": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-26": 4.785578333333333,
            "2025-11-28": 0.5882827777777778,
            "2025-12-13": 147.07601416666665,
            "2026-01-16": 40.035021388888886,
            "2026-01-26": 72.56117694444444,
            "2026-02-10": 191.42594,
            "2026-02-18": 348.2558486111111,
            "2026-02-19": 76.84427388888889,
            "2026-02-21": 128.33507527777778,
            "2026-02-23": 62.66969111111111,
            "2026-03-06": 256.6774272222222,
            "2026-03-14": 2.304027222222222,
            "2026-03-16": 207.50850527777777,
            "2026-03-23": 23.496517222222224,
            "2026-03-24": 10.044375277777776,
            "2026-03-27": 0.3753672222222222,
            "2026-04-16": 5.479309444444445,
            "2026-04-18": 798.6522355555555,
            "2026-04-20": 13.634943333333334,
            "2026-04-23": 66.8831225,
            "2026-04-30": 74.85183861111112,
            "2026-05-15": 2.566950277777778,
            "2026-05-18": 7.02388,
            "2026-06-05": 0.5290286111111111
          },
          "time_count_per_day": {
            "2025-11-26": 1,
            "2025-11-28": 1,
            "2025-12-13": 1,
            "2026-01-16": 1,
            "2026-01-26": 1,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-23": 1,
            "2026-03-06": 1,
            "2026-03-14": 1,
            "2026-03-16": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-03-27": 1,
            "2026-04-16": 1,
            "2026-04-18": 1,
            "2026-04-20": 1,
            "2026-04-23": 1,
            "2026-04-30": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 73.41,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "32-34h": 1,
            "38-40h": 1,
            "42-44h": 1,
            "52-54h": 1,
            "72-74h": 1,
            "84-86h": 1,
            "86-88h": 1,
            "142-144h": 1,
            "164-166h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-22": 1,
            "2025-12-04": 1,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-11-22": 43.00660166666667,
            "2025-12-04": 142.47905527777777,
            "2026-01-14": 164.60346361111112,
            "2026-01-22": 38.17403194444445,
            "2026-01-23": 72.1706311111111,
            "2026-02-03": 103.0559775,
            "2026-02-04": 52.967490833333336,
            "2026-02-10": 32.02273777777778,
            "2026-02-12": 85.61465638888889
          },
          "time_count_per_day": {
            "2025-11-22": 1,
            "2025-12-04": 1,
            "2026-01-14": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-10": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 91.81,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 2,
              "4-6h": 2,
              "6-8h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "22-24h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "38-40h": 1,
              "40-42h": 1,
              "42-44h": 1,
              "52-54h": 1,
              "58-60h": 1,
              "62-64h": 1,
              "66-68h": 1,
              "72-74h": 2,
              "74-76h": 1,
              "76-78h": 1,
              "84-86h": 1,
              "86-88h": 1,
              "128-130h": 1,
              "142-144h": 1,
              "146-148h": 1,
              "148-150h": 1,
              "164-166h": 1,
              "190-192h": 1,
              "256-258h": 1,
              "348-350h": 1,
              "798-800h": 1
            },
            "tickets_count": 36,
            "tickets_per_day": {
              "2025-11-22": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-13": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-03-06": 1,
              "2026-03-14": 1,
              "2026-03-16": 2,
              "2026-03-21": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-04-16": 1,
              "2026-04-18": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-04-30": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-11-22": 43.00660166666667,
              "2025-11-26": 4.785578333333333,
              "2025-11-28": 0.5882827777777778,
              "2025-12-04": 142.47905527777777,
              "2025-12-13": 147.07601416666665,
              "2026-01-14": 164.60346361111112,
              "2026-01-16": 40.035021388888886,
              "2026-01-22": 38.17403194444445,
              "2026-01-23": 72.1706311111111,
              "2026-01-26": 72.56117694444444,
              "2026-02-03": 103.0559775,
              "2026-02-04": 52.967490833333336,
              "2026-02-10": 223.4486777777778,
              "2026-02-12": 85.61465638888889,
              "2026-02-18": 348.2558486111111,
              "2026-02-19": 76.84427388888889,
              "2026-02-21": 128.33507527777778,
              "2026-02-23": 62.66969111111111,
              "2026-03-06": 256.6774272222222,
              "2026-03-14": 2.304027222222222,
              "2026-03-16": 207.50850527777777,
              "2026-03-21": 28.306140833333334,
              "2026-03-23": 23.496517222222224,
              "2026-03-24": 10.044375277777776,
              "2026-03-27": 0.3753672222222222,
              "2026-04-16": 5.479309444444445,
              "2026-04-18": 798.6522355555555,
              "2026-04-20": 13.634943333333334,
              "2026-04-23": 66.8831225,
              "2026-04-30": 74.85183861111112,
              "2026-05-15": 2.566950277777778,
              "2026-05-18": 7.02388,
              "2026-06-05": 0.5290286111111111
            },
            "time_count_per_day": {
              "2025-11-22": 1,
              "2025-11-26": 1,
              "2025-11-28": 1,
              "2025-12-04": 1,
              "2025-12-13": 1,
              "2026-01-14": 1,
              "2026-01-16": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-02-03": 2,
              "2026-02-04": 1,
              "2026-02-10": 2,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-03-06": 1,
              "2026-03-14": 1,
              "2026-03-16": 2,
              "2026-03-21": 1,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-03-27": 1,
              "2026-04-16": 1,
              "2026-04-18": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-04-30": 1,
              "2026-05-15": 1,
              "2026-05-18": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 28.31,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-21": 1
              },
              "time_per_day": {
                "2026-03-21": 28.306140833333334
              },
              "time_count_per_day": {
                "2026-03-21": 1
              }
            },
            "P2": {
              "avg_time_hours": 101.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 2,
                "4-6h": 2,
                "6-8h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "22-24h": 1,
                "40-42h": 1,
                "58-60h": 1,
                "62-64h": 1,
                "66-68h": 1,
                "72-74h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "128-130h": 1,
                "146-148h": 1,
                "148-150h": 1,
                "190-192h": 1,
                "256-258h": 1,
                "348-350h": 1,
                "798-800h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2025-12-13": 1,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-03-06": 1,
                "2026-03-14": 1,
                "2026-03-16": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-04-16": 1,
                "2026-04-18": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-11-26": 4.785578333333333,
                "2025-11-28": 0.5882827777777778,
                "2025-12-13": 147.07601416666665,
                "2026-01-16": 40.035021388888886,
                "2026-01-26": 72.56117694444444,
                "2026-02-10": 191.42594,
                "2026-02-18": 348.2558486111111,
                "2026-02-19": 76.84427388888889,
                "2026-02-21": 128.33507527777778,
                "2026-02-23": 62.66969111111111,
                "2026-03-06": 256.6774272222222,
                "2026-03-14": 2.304027222222222,
                "2026-03-16": 207.50850527777777,
                "2026-03-23": 23.496517222222224,
                "2026-03-24": 10.044375277777776,
                "2026-03-27": 0.3753672222222222,
                "2026-04-16": 5.479309444444445,
                "2026-04-18": 798.6522355555555,
                "2026-04-20": 13.634943333333334,
                "2026-04-23": 66.8831225,
                "2026-04-30": 74.85183861111112,
                "2026-05-15": 2.566950277777778,
                "2026-05-18": 7.02388,
                "2026-06-05": 0.5290286111111111
              },
              "time_count_per_day": {
                "2025-11-26": 1,
                "2025-11-28": 1,
                "2025-12-13": 1,
                "2026-01-16": 1,
                "2026-01-26": 1,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-23": 1,
                "2026-03-06": 1,
                "2026-03-14": 1,
                "2026-03-16": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-03-27": 1,
                "2026-04-16": 1,
                "2026-04-18": 1,
                "2026-04-20": 1,
                "2026-04-23": 1,
                "2026-04-30": 1,
                "2026-05-15": 1,
                "2026-05-18": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 73.41,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "32-34h": 1,
                "38-40h": 1,
                "42-44h": 1,
                "52-54h": 1,
                "72-74h": 1,
                "84-86h": 1,
                "86-88h": 1,
                "142-144h": 1,
                "164-166h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-22": 1,
                "2025-12-04": 1,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-11-22": 43.00660166666667,
                "2025-12-04": 142.47905527777777,
                "2026-01-14": 164.60346361111112,
                "2026-01-22": 38.17403194444445,
                "2026-01-23": 72.1706311111111,
                "2026-02-03": 103.0559775,
                "2026-02-04": 52.967490833333336,
                "2026-02-10": 32.02273777777778,
                "2026-02-12": 85.61465638888889
              },
              "time_count_per_day": {
                "2025-11-22": 1,
                "2025-12-04": 1,
                "2026-01-14": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 2,
                "2026-02-04": 1,
                "2026-02-10": 1,
                "2026-02-12": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-28": 1,
              "2026-05-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_541": {
      "overall": {
        "avg_time_hours": 150.33,
        "mode_time_hours": 1.0,
        "mode_frequency": 10,
        "time_distribution": {
          "0-2h": 10,
          "2-4h": 4,
          "4-6h": 5,
          "6-8h": 3,
          "8-10h": 4,
          "10-12h": 3,
          "12-14h": 2,
          "14-16h": 2,
          "18-20h": 1,
          "22-24h": 4,
          "24-26h": 3,
          "26-28h": 4,
          "28-30h": 1,
          "30-32h": 1,
          "32-34h": 1,
          "34-36h": 1,
          "46-48h": 1,
          "48-50h": 2,
          "50-52h": 1,
          "56-58h": 1,
          "70-72h": 1,
          "72-74h": 4,
          "76-78h": 1,
          "78-80h": 1,
          "80-82h": 1,
          "84-86h": 1,
          "86-88h": 1,
          "120-122h": 2,
          "122-124h": 1,
          "124-126h": 1,
          "130-132h": 1,
          "142-144h": 1,
          "182-184h": 1,
          "184-186h": 2,
          "192-194h": 1,
          "226-228h": 1,
          "234-236h": 1,
          "326-328h": 1,
          "334-336h": 1,
          "342-344h": 1,
          "366-368h": 1,
          "372-374h": 1,
          "522-524h": 1,
          "538-540h": 1,
          "556-558h": 1,
          "590-592h": 1,
          "616-618h": 1,
          "642-644h": 3,
          "696-698h": 1,
          "698-700h": 1,
          "756-758h": 1,
          "850-852h": 1,
          "1012-1014h": 1
        },
        "tickets_count": 98,
        "tickets_per_day": {
          "2025-11-23": 1,
          "2025-12-10": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-30": 1,
          "2026-01-11": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-15": 4,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-01-28": 2,
          "2026-01-31": 1,
          "2026-02-02": 1,
          "2026-02-03": 6,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-13": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-04": 4,
          "2026-03-05": 1,
          "2026-03-11": 1,
          "2026-03-18": 4,
          "2026-03-25": 2,
          "2026-03-30": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-16": 5,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-04-23": 3,
          "2026-04-24": 1,
          "2026-04-29": 2,
          "2026-04-30": 2,
          "2026-05-05": 1,
          "2026-05-06": 4,
          "2026-05-08": 4,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-16": 3,
          "2026-05-19": 1,
          "2026-05-21": 2,
          "2026-05-22": 2,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-01": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-23": 72.40252111111111,
          "2025-12-10": 342.2195752777778,
          "2025-12-11": 23.899174444444444,
          "2025-12-15": 84.98194694444445,
          "2025-12-18": 122.40302138888889,
          "2025-12-30": 1.2901238888888888,
          "2026-01-11": 851.3185219444445,
          "2026-01-12": 1.1751683333333334,
          "2026-01-13": 104.80382500000002,
          "2026-01-15": 376.8173275,
          "2026-01-16": 26.81284555555556,
          "2026-01-17": 15.441747777777778,
          "2026-01-19": 17.512973055555555,
          "2026-01-22": 24.50891027777778,
          "2026-01-23": 47.41308777777778,
          "2026-01-27": 54.42075666666666,
          "2026-01-28": 27.6947125,
          "2026-01-31": 23.298321944444446,
          "2026-02-02": 0.9485827777777778,
          "2026-02-03": 299.6639558333334,
          "2026-02-09": 9.288044722222223,
          "2026-02-10": 32.877377777777774,
          "2026-02-11": 2.6641425,
          "2026-02-13": 591.4476027777778,
          "2026-02-20": 48.47216805555556,
          "2026-02-25": 24.095361944444445,
          "2026-03-04": 42.27103166666667,
          "2026-03-05": 335.7071319444445,
          "2026-03-11": 182.39553527777778,
          "2026-03-18": 511.2759211111111,
          "2026-03-25": 589.3661702777778,
          "2026-03-30": 87.98863944444444,
          "2026-04-07": 4.938474722222222,
          "2026-04-08": 0.11812472222222223,
          "2026-04-09": 326.8176338888889,
          "2026-04-10": 437.6557172222223,
          "2026-04-16": 2081.5555005555557,
          "2026-04-21": 13.33985388888889,
          "2026-04-22": 368.5056097222222,
          "2026-04-23": 2012.5656758333334,
          "2026-04-24": 0.8960897222222222,
          "2026-04-29": 0.047247777777777784,
          "2026-04-30": 50.678398611111106,
          "2026-05-05": 193.48569277777776,
          "2026-05-06": 1186.034141111111,
          "2026-05-08": 1929.3955241666667,
          "2026-05-12": 33.92639194444445,
          "2026-05-13": 11.306053055555555,
          "2026-05-14": 15.610050555555556,
          "2026-05-16": 11.325039722222222,
          "2026-05-19": 11.929583055555556,
          "2026-05-21": 128.5901311111111,
          "2026-05-22": 235.65899722222224,
          "2026-05-26": 72.00396722222223,
          "2026-05-27": 27.6981975,
          "2026-06-01": 0.4380261111111111
        },
        "time_count_per_day": {
          "2025-11-23": 1,
          "2025-12-10": 1,
          "2025-12-11": 1,
          "2025-12-15": 1,
          "2025-12-18": 1,
          "2025-12-30": 1,
          "2026-01-11": 1,
          "2026-01-12": 1,
          "2026-01-13": 2,
          "2026-01-15": 4,
          "2026-01-16": 1,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-27": 2,
          "2026-01-28": 2,
          "2026-01-31": 1,
          "2026-02-02": 1,
          "2026-02-03": 6,
          "2026-02-09": 1,
          "2026-02-10": 2,
          "2026-02-11": 1,
          "2026-02-13": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-04": 4,
          "2026-03-05": 1,
          "2026-03-11": 1,
          "2026-03-18": 4,
          "2026-03-25": 2,
          "2026-03-30": 1,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-10": 2,
          "2026-04-16": 5,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-04-23": 3,
          "2026-04-24": 1,
          "2026-04-29": 1,
          "2026-04-30": 2,
          "2026-05-05": 1,
          "2026-05-06": 4,
          "2026-05-08": 3,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-05-16": 3,
          "2026-05-19": 1,
          "2026-05-21": 2,
          "2026-05-22": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-06-01": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 134.79,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "234-236h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-12": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2026-05-12": 33.92639194444445,
            "2026-05-22": 235.65899722222224
          },
          "time_count_per_day": {
            "2026-05-12": 1,
            "2026-05-22": 1
          }
        },
        "P2": {
          "avg_time_hours": 160.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 4,
            "4-6h": 5,
            "6-8h": 3,
            "8-10h": 2,
            "10-12h": 3,
            "12-14h": 1,
            "14-16h": 1,
            "22-24h": 3,
            "24-26h": 1,
            "26-28h": 2,
            "28-30h": 1,
            "34-36h": 1,
            "48-50h": 1,
            "50-52h": 1,
            "70-72h": 1,
            "72-74h": 3,
            "120-122h": 2,
            "122-124h": 1,
            "182-184h": 1,
            "192-194h": 1,
            "226-228h": 1,
            "326-328h": 1,
            "342-344h": 1,
            "366-368h": 1,
            "522-524h": 1,
            "538-540h": 1,
            "556-558h": 1,
            "616-618h": 1,
            "642-644h": 3,
            "696-698h": 1,
            "698-700h": 1,
            "756-758h": 1,
            "1012-1014h": 1
          },
          "tickets_count": 66,
          "tickets_per_day": {
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2025-12-30": 1,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-03": 3,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-04": 4,
            "2026-03-11": 1,
            "2026-03-18": 2,
            "2026-03-25": 2,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-16": 5,
            "2026-04-21": 1,
            "2026-04-23": 3,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-04-30": 2,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-08": 4,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-16": 3,
            "2026-05-19": 1,
            "2026-05-21": 2,
            "2026-05-22": 1,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-01": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-12-10": 342.2195752777778,
            "2025-12-11": 23.899174444444444,
            "2025-12-18": 122.40302138888889,
            "2025-12-30": 1.2901238888888888,
            "2026-01-12": 1.1751683333333334,
            "2026-01-16": 26.81284555555556,
            "2026-01-19": 8.4622525,
            "2026-01-27": 28.441950277777774,
            "2026-02-02": 0.9485827777777778,
            "2026-02-03": 151.48397527777777,
            "2026-02-09": 9.288044722222223,
            "2026-02-10": 1.5085033333333333,
            "2026-02-11": 2.6641425,
            "2026-02-25": 24.095361944444445,
            "2026-03-04": 42.27103166666667,
            "2026-03-11": 182.39553527777778,
            "2026-03-18": 5.832186388888889,
            "2026-03-25": 589.3661702777778,
            "2026-04-07": 4.938474722222222,
            "2026-04-08": 0.11812472222222223,
            "2026-04-09": 326.8176338888889,
            "2026-04-10": 437.6557172222223,
            "2026-04-16": 2081.5555005555557,
            "2026-04-21": 13.33985388888889,
            "2026-04-23": 2012.5656758333334,
            "2026-04-24": 0.8960897222222222,
            "2026-04-29": 0.047247777777777784,
            "2026-04-30": 50.678398611111106,
            "2026-05-05": 193.48569277777776,
            "2026-05-06": 1186.034141111111,
            "2026-05-08": 1929.3955241666667,
            "2026-05-13": 11.306053055555555,
            "2026-05-14": 15.610050555555556,
            "2026-05-16": 11.325039722222222,
            "2026-05-19": 11.929583055555556,
            "2026-05-21": 128.5901311111111,
            "2026-05-26": 72.00396722222223,
            "2026-05-27": 27.6981975,
            "2026-06-01": 0.4380261111111111
          },
          "time_count_per_day": {
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-18": 1,
            "2025-12-30": 1,
            "2026-01-12": 1,
            "2026-01-16": 1,
            "2026-01-19": 1,
            "2026-01-27": 1,
            "2026-02-02": 1,
            "2026-02-03": 3,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-11": 1,
            "2026-02-25": 1,
            "2026-03-04": 4,
            "2026-03-11": 1,
            "2026-03-18": 2,
            "2026-03-25": 2,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-10": 2,
            "2026-04-16": 5,
            "2026-04-21": 1,
            "2026-04-23": 3,
            "2026-04-24": 1,
            "2026-04-29": 1,
            "2026-04-30": 2,
            "2026-05-05": 1,
            "2026-05-06": 4,
            "2026-05-08": 3,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-16": 3,
            "2026-05-19": 1,
            "2026-05-21": 2,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-06-01": 2
          }
        },
        "P3": {
          "avg_time_hours": 129.08,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 2,
            "12-14h": 1,
            "14-16h": 1,
            "18-20h": 1,
            "22-24h": 1,
            "24-26h": 2,
            "26-28h": 1,
            "30-32h": 1,
            "48-50h": 1,
            "56-58h": 1,
            "72-74h": 1,
            "76-78h": 1,
            "80-82h": 1,
            "124-126h": 1,
            "142-144h": 1,
            "334-336h": 1,
            "590-592h": 1,
            "850-852h": 1
          },
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-11-23": 1,
            "2026-01-11": 1,
            "2026-01-15": 4,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-03": 3,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2025-11-23": 72.40252111111111,
            "2026-01-11": 851.3185219444445,
            "2026-01-15": 376.8173275,
            "2026-01-17": 15.441747777777778,
            "2026-01-19": 9.050720555555555,
            "2026-01-22": 24.50891027777778,
            "2026-01-27": 25.978806388888888,
            "2026-01-28": 27.6947125,
            "2026-01-31": 23.298321944444446,
            "2026-02-03": 148.17998055555555,
            "2026-02-10": 31.368874444444444,
            "2026-02-13": 591.4476027777778,
            "2026-02-20": 48.47216805555556,
            "2026-03-05": 335.7071319444445
          },
          "time_count_per_day": {
            "2025-11-23": 1,
            "2026-01-11": 1,
            "2026-01-15": 4,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-22": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-01-31": 1,
            "2026-02-03": 3,
            "2026-02-10": 1,
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-03-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 146.56,
          "mode_time_hours": 185.0,
          "mode_frequency": 2,
          "time_distribution": {
            "46-48h": 1,
            "78-80h": 1,
            "84-86h": 1,
            "86-88h": 1,
            "130-132h": 1,
            "184-186h": 2,
            "372-374h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-12-15": 1,
            "2026-01-13": 1,
            "2026-01-23": 1,
            "2026-03-18": 2,
            "2026-03-30": 1,
            "2026-04-22": 2,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2025-12-15": 84.98194694444445,
            "2026-01-13": 78.15498416666668,
            "2026-01-23": 47.41308777777778,
            "2026-03-18": 505.4437347222222,
            "2026-03-30": 87.98863944444444,
            "2026-04-22": 368.5056097222222
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2026-01-13": 1,
            "2026-01-23": 1,
            "2026-03-18": 2,
            "2026-03-30": 1,
            "2026-04-22": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 26.65,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 26.648840833333335
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 150.33,
            "mode_time_hours": 1.0,
            "mode_frequency": 10,
            "time_distribution": {
              "0-2h": 10,
              "2-4h": 4,
              "4-6h": 5,
              "6-8h": 3,
              "8-10h": 4,
              "10-12h": 3,
              "12-14h": 2,
              "14-16h": 2,
              "18-20h": 1,
              "22-24h": 4,
              "24-26h": 3,
              "26-28h": 4,
              "28-30h": 1,
              "30-32h": 1,
              "32-34h": 1,
              "34-36h": 1,
              "46-48h": 1,
              "48-50h": 2,
              "50-52h": 1,
              "56-58h": 1,
              "70-72h": 1,
              "72-74h": 4,
              "76-78h": 1,
              "78-80h": 1,
              "80-82h": 1,
              "84-86h": 1,
              "86-88h": 1,
              "120-122h": 2,
              "122-124h": 1,
              "124-126h": 1,
              "130-132h": 1,
              "142-144h": 1,
              "182-184h": 1,
              "184-186h": 2,
              "192-194h": 1,
              "226-228h": 1,
              "234-236h": 1,
              "326-328h": 1,
              "334-336h": 1,
              "342-344h": 1,
              "366-368h": 1,
              "372-374h": 1,
              "522-524h": 1,
              "538-540h": 1,
              "556-558h": 1,
              "590-592h": 1,
              "616-618h": 1,
              "642-644h": 3,
              "696-698h": 1,
              "698-700h": 1,
              "756-758h": 1,
              "850-852h": 1,
              "1012-1014h": 1
            },
            "tickets_count": 94,
            "tickets_per_day": {
              "2025-11-23": 1,
              "2025-12-10": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-30": 1,
              "2026-01-11": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-15": 4,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-01-28": 2,
              "2026-01-31": 1,
              "2026-02-02": 1,
              "2026-02-03": 6,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-13": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-04": 4,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-18": 4,
              "2026-03-25": 2,
              "2026-03-30": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-16": 5,
              "2026-04-21": 1,
              "2026-04-22": 2,
              "2026-04-23": 3,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-04-30": 2,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-08": 3,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-16": 3,
              "2026-05-19": 1,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 2
            },
            "time_per_day": {
              "2025-11-23": 72.40252111111111,
              "2025-12-10": 342.2195752777778,
              "2025-12-11": 23.899174444444444,
              "2025-12-15": 84.98194694444445,
              "2025-12-18": 122.40302138888889,
              "2025-12-30": 1.2901238888888888,
              "2026-01-11": 851.3185219444445,
              "2026-01-12": 1.1751683333333334,
              "2026-01-13": 104.80382500000002,
              "2026-01-15": 376.8173275,
              "2026-01-16": 26.81284555555556,
              "2026-01-17": 15.441747777777778,
              "2026-01-19": 17.512973055555555,
              "2026-01-22": 24.50891027777778,
              "2026-01-23": 47.41308777777778,
              "2026-01-27": 54.42075666666666,
              "2026-01-28": 27.6947125,
              "2026-01-31": 23.298321944444446,
              "2026-02-02": 0.9485827777777778,
              "2026-02-03": 299.6639558333334,
              "2026-02-09": 9.288044722222223,
              "2026-02-10": 32.877377777777774,
              "2026-02-11": 2.6641425,
              "2026-02-13": 591.4476027777778,
              "2026-02-20": 48.47216805555556,
              "2026-02-25": 24.095361944444445,
              "2026-03-04": 42.27103166666667,
              "2026-03-05": 335.7071319444445,
              "2026-03-11": 182.39553527777778,
              "2026-03-18": 511.2759211111111,
              "2026-03-25": 589.3661702777778,
              "2026-03-30": 87.98863944444444,
              "2026-04-07": 4.938474722222222,
              "2026-04-08": 0.11812472222222223,
              "2026-04-09": 326.8176338888889,
              "2026-04-10": 437.6557172222223,
              "2026-04-16": 2081.5555005555557,
              "2026-04-21": 13.33985388888889,
              "2026-04-22": 368.5056097222222,
              "2026-04-23": 2012.5656758333334,
              "2026-04-24": 0.8960897222222222,
              "2026-04-29": 0.047247777777777784,
              "2026-04-30": 50.678398611111106,
              "2026-05-05": 193.48569277777776,
              "2026-05-06": 1186.034141111111,
              "2026-05-08": 1929.3955241666667,
              "2026-05-12": 33.92639194444445,
              "2026-05-13": 11.306053055555555,
              "2026-05-14": 15.610050555555556,
              "2026-05-16": 11.325039722222222,
              "2026-05-19": 11.929583055555556,
              "2026-05-21": 128.5901311111111,
              "2026-05-22": 235.65899722222224,
              "2026-05-26": 72.00396722222223,
              "2026-05-27": 27.6981975,
              "2026-06-01": 0.4380261111111111
            },
            "time_count_per_day": {
              "2025-11-23": 1,
              "2025-12-10": 1,
              "2025-12-11": 1,
              "2025-12-15": 1,
              "2025-12-18": 1,
              "2025-12-30": 1,
              "2026-01-11": 1,
              "2026-01-12": 1,
              "2026-01-13": 2,
              "2026-01-15": 4,
              "2026-01-16": 1,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-01-27": 2,
              "2026-01-28": 2,
              "2026-01-31": 1,
              "2026-02-02": 1,
              "2026-02-03": 6,
              "2026-02-09": 1,
              "2026-02-10": 2,
              "2026-02-11": 1,
              "2026-02-13": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-04": 4,
              "2026-03-05": 1,
              "2026-03-11": 1,
              "2026-03-18": 4,
              "2026-03-25": 2,
              "2026-03-30": 1,
              "2026-04-07": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-10": 2,
              "2026-04-16": 5,
              "2026-04-21": 1,
              "2026-04-22": 2,
              "2026-04-23": 3,
              "2026-04-24": 1,
              "2026-04-29": 1,
              "2026-04-30": 2,
              "2026-05-05": 1,
              "2026-05-06": 4,
              "2026-05-08": 3,
              "2026-05-12": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-05-16": 3,
              "2026-05-19": 1,
              "2026-05-21": 2,
              "2026-05-22": 1,
              "2026-05-26": 1,
              "2026-05-27": 1,
              "2026-06-01": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 134.79,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "234-236h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-12": 1,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2026-05-12": 33.92639194444445,
                "2026-05-22": 235.65899722222224
              },
              "time_count_per_day": {
                "2026-05-12": 1,
                "2026-05-22": 1
              }
            },
            "P2": {
              "avg_time_hours": 160.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 4,
                "4-6h": 5,
                "6-8h": 3,
                "8-10h": 2,
                "10-12h": 3,
                "12-14h": 1,
                "14-16h": 1,
                "22-24h": 3,
                "24-26h": 1,
                "26-28h": 2,
                "28-30h": 1,
                "34-36h": 1,
                "48-50h": 1,
                "50-52h": 1,
                "70-72h": 1,
                "72-74h": 3,
                "120-122h": 2,
                "122-124h": 1,
                "182-184h": 1,
                "192-194h": 1,
                "226-228h": 1,
                "326-328h": 1,
                "342-344h": 1,
                "366-368h": 1,
                "522-524h": 1,
                "538-540h": 1,
                "556-558h": 1,
                "616-618h": 1,
                "642-644h": 3,
                "696-698h": 1,
                "698-700h": 1,
                "756-758h": 1,
                "1012-1014h": 1
              },
              "tickets_count": 63,
              "tickets_per_day": {
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2025-12-30": 1,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-03": 3,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-04": 4,
                "2026-03-11": 1,
                "2026-03-18": 2,
                "2026-03-25": 2,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-16": 5,
                "2026-04-21": 1,
                "2026-04-23": 3,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-04-30": 2,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-08": 3,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-16": 3,
                "2026-05-19": 1,
                "2026-05-21": 2,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-01": 2
              },
              "time_per_day": {
                "2025-12-10": 342.2195752777778,
                "2025-12-11": 23.899174444444444,
                "2025-12-18": 122.40302138888889,
                "2025-12-30": 1.2901238888888888,
                "2026-01-12": 1.1751683333333334,
                "2026-01-16": 26.81284555555556,
                "2026-01-19": 8.4622525,
                "2026-01-27": 28.441950277777774,
                "2026-02-02": 0.9485827777777778,
                "2026-02-03": 151.48397527777777,
                "2026-02-09": 9.288044722222223,
                "2026-02-10": 1.5085033333333333,
                "2026-02-11": 2.6641425,
                "2026-02-25": 24.095361944444445,
                "2026-03-04": 42.27103166666667,
                "2026-03-11": 182.39553527777778,
                "2026-03-18": 5.832186388888889,
                "2026-03-25": 589.3661702777778,
                "2026-04-07": 4.938474722222222,
                "2026-04-08": 0.11812472222222223,
                "2026-04-09": 326.8176338888889,
                "2026-04-10": 437.6557172222223,
                "2026-04-16": 2081.5555005555557,
                "2026-04-21": 13.33985388888889,
                "2026-04-23": 2012.5656758333334,
                "2026-04-24": 0.8960897222222222,
                "2026-04-29": 0.047247777777777784,
                "2026-04-30": 50.678398611111106,
                "2026-05-05": 193.48569277777776,
                "2026-05-06": 1186.034141111111,
                "2026-05-08": 1929.3955241666667,
                "2026-05-13": 11.306053055555555,
                "2026-05-14": 15.610050555555556,
                "2026-05-16": 11.325039722222222,
                "2026-05-19": 11.929583055555556,
                "2026-05-21": 128.5901311111111,
                "2026-05-26": 72.00396722222223,
                "2026-05-27": 27.6981975,
                "2026-06-01": 0.4380261111111111
              },
              "time_count_per_day": {
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-18": 1,
                "2025-12-30": 1,
                "2026-01-12": 1,
                "2026-01-16": 1,
                "2026-01-19": 1,
                "2026-01-27": 1,
                "2026-02-02": 1,
                "2026-02-03": 3,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-11": 1,
                "2026-02-25": 1,
                "2026-03-04": 4,
                "2026-03-11": 1,
                "2026-03-18": 2,
                "2026-03-25": 2,
                "2026-04-07": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-10": 2,
                "2026-04-16": 5,
                "2026-04-21": 1,
                "2026-04-23": 3,
                "2026-04-24": 1,
                "2026-04-29": 1,
                "2026-04-30": 2,
                "2026-05-05": 1,
                "2026-05-06": 4,
                "2026-05-08": 3,
                "2026-05-13": 1,
                "2026-05-14": 1,
                "2026-05-16": 3,
                "2026-05-19": 1,
                "2026-05-21": 2,
                "2026-05-26": 1,
                "2026-05-27": 1,
                "2026-06-01": 2
              }
            },
            "P3": {
              "avg_time_hours": 129.08,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 2,
                "12-14h": 1,
                "14-16h": 1,
                "18-20h": 1,
                "22-24h": 1,
                "24-26h": 2,
                "26-28h": 1,
                "30-32h": 1,
                "48-50h": 1,
                "56-58h": 1,
                "72-74h": 1,
                "76-78h": 1,
                "80-82h": 1,
                "124-126h": 1,
                "142-144h": 1,
                "334-336h": 1,
                "590-592h": 1,
                "850-852h": 1
              },
              "tickets_count": 20,
              "tickets_per_day": {
                "2025-11-23": 1,
                "2026-01-11": 1,
                "2026-01-15": 4,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-03": 3,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2025-11-23": 72.40252111111111,
                "2026-01-11": 851.3185219444445,
                "2026-01-15": 376.8173275,
                "2026-01-17": 15.441747777777778,
                "2026-01-19": 9.050720555555555,
                "2026-01-22": 24.50891027777778,
                "2026-01-27": 25.978806388888888,
                "2026-01-28": 27.6947125,
                "2026-01-31": 23.298321944444446,
                "2026-02-03": 148.17998055555555,
                "2026-02-10": 31.368874444444444,
                "2026-02-13": 591.4476027777778,
                "2026-02-20": 48.47216805555556,
                "2026-03-05": 335.7071319444445
              },
              "time_count_per_day": {
                "2025-11-23": 1,
                "2026-01-11": 1,
                "2026-01-15": 4,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-22": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-01-31": 1,
                "2026-02-03": 3,
                "2026-02-10": 1,
                "2026-02-13": 1,
                "2026-02-20": 1,
                "2026-03-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 146.56,
              "mode_time_hours": 185.0,
              "mode_frequency": 2,
              "time_distribution": {
                "46-48h": 1,
                "78-80h": 1,
                "84-86h": 1,
                "86-88h": 1,
                "130-132h": 1,
                "184-186h": 2,
                "372-374h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2026-01-13": 1,
                "2026-01-23": 1,
                "2026-03-18": 2,
                "2026-03-30": 1,
                "2026-04-22": 2
              },
              "time_per_day": {
                "2025-12-15": 84.98194694444445,
                "2026-01-13": 78.15498416666668,
                "2026-01-23": 47.41308777777778,
                "2026-03-18": 505.4437347222222,
                "2026-03-30": 87.98863944444444,
                "2026-04-22": 368.5056097222222
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2026-01-13": 1,
                "2026-01-23": 1,
                "2026-03-18": 2,
                "2026-03-30": 1,
                "2026-04-22": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 26.65,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 26.648840833333335
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-29": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-08": 1,
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-08": 1,
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_542": {
      "overall": {
        "avg_time_hours": 13.12,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "6-8h": 1,
          "28-30h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-12-02": 1
        },
        "time_per_day": {
          "2025-11-21": 2.346012777777778,
          "2025-11-22": 29.5325725,
          "2025-12-02": 7.481237777777777
        },
        "time_count_per_day": {
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-12-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-21": 1
          },
          "time_per_day": {
            "2025-11-21": 2.346012777777778
          },
          "time_count_per_day": {
            "2025-11-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 18.51,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "28-30h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-22": 1,
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-11-22": 29.5325725,
            "2025-12-02": 7.481237777777777
          },
          "time_count_per_day": {
            "2025-11-22": 1,
            "2025-12-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.12,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "6-8h": 1,
              "28-30h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-12-02": 1
            },
            "time_per_day": {
              "2025-11-21": 2.346012777777778,
              "2025-11-22": 29.5325725,
              "2025-12-02": 7.481237777777777
            },
            "time_count_per_day": {
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-12-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-21": 1
              },
              "time_per_day": {
                "2025-11-21": 2.346012777777778
              },
              "time_count_per_day": {
                "2025-11-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 18.51,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "28-30h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-22": 1,
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-11-22": 29.5325725,
                "2025-12-02": 7.481237777777777
              },
              "time_count_per_day": {
                "2025-11-22": 1,
                "2025-12-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_543": {
      "overall": {
        "avg_time_hours": 485.17,
        "mode_time_hours": 509.0,
        "mode_frequency": 1,
        "time_distribution": {
          "150-152h": 1,
          "508-510h": 1,
          "536-538h": 1,
          "744-746h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-12-12": 1,
          "2025-12-29": 1,
          "2026-01-16": 3,
          "2026-01-21": 1,
          "2026-03-17": 2,
          "2026-03-24": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-12-12": 509.17330555555554,
          "2026-01-16": 744.4864816666666,
          "2026-03-17": 687.0324755555555
        },
        "time_count_per_day": {
          "2025-12-12": 1,
          "2026-01-16": 1,
          "2026-03-17": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 485.17,
          "mode_time_hours": 509.0,
          "mode_frequency": 1,
          "time_distribution": {
            "150-152h": 1,
            "508-510h": 1,
            "536-538h": 1,
            "744-746h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-12-12": 1,
            "2026-01-16": 2,
            "2026-03-17": 2,
            "2026-03-24": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-12-12": 509.17330555555554,
            "2026-01-16": 744.4864816666666,
            "2026-03-17": 687.0324755555555
          },
          "time_count_per_day": {
            "2025-12-12": 1,
            "2026-01-16": 1,
            "2026-03-17": 2
          }
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-29": 1,
            "2026-01-16": 1,
            "2026-01-21": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 485.17,
            "mode_time_hours": 509.0,
            "mode_frequency": 1,
            "time_distribution": {
              "150-152h": 1,
              "508-510h": 1,
              "536-538h": 1,
              "744-746h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-12": 1,
              "2026-01-16": 1,
              "2026-03-17": 2
            },
            "time_per_day": {
              "2025-12-12": 509.17330555555554,
              "2026-01-16": 744.4864816666666,
              "2026-03-17": 687.0324755555555
            },
            "time_count_per_day": {
              "2025-12-12": 1,
              "2026-01-16": 1,
              "2026-03-17": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 485.17,
              "mode_time_hours": 509.0,
              "mode_frequency": 1,
              "time_distribution": {
                "150-152h": 1,
                "508-510h": 1,
                "536-538h": 1,
                "744-746h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-12": 1,
                "2026-01-16": 1,
                "2026-03-17": 2
              },
              "time_per_day": {
                "2025-12-12": 509.17330555555554,
                "2026-01-16": 744.4864816666666,
                "2026-03-17": 687.0324755555555
              },
              "time_count_per_day": {
                "2025-12-12": 1,
                "2026-01-16": 1,
                "2026-03-17": 2
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-16": 2,
              "2026-01-21": 1,
              "2026-03-24": 1,
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-03-24": 1,
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-01-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_544": {
      "overall": {
        "avg_time_hours": 15.95,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 1,
          "28-30h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-22": 1,
          "2025-12-03": 1,
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-11-22": 28.533474166666664,
          "2025-12-03": 18.724393055555556,
          "2025-12-30": 0.5810425
        },
        "time_count_per_day": {
          "2025-11-22": 1,
          "2025-12-03": 1,
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-12-30": 0.5810425
          },
          "time_count_per_day": {
            "2025-12-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 23.63,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "28-30h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-22": 1,
            "2025-12-03": 1
          },
          "time_per_day": {
            "2025-11-22": 28.533474166666664,
            "2025-12-03": 18.724393055555556
          },
          "time_count_per_day": {
            "2025-11-22": 1,
            "2025-12-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.95,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 1,
              "28-30h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-22": 1,
              "2025-12-03": 1,
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-11-22": 28.533474166666664,
              "2025-12-03": 18.724393055555556,
              "2025-12-30": 0.5810425
            },
            "time_count_per_day": {
              "2025-11-22": 1,
              "2025-12-03": 1,
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-12-30": 0.5810425
              },
              "time_count_per_day": {
                "2025-12-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 23.63,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "28-30h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-22": 1,
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-11-22": 28.533474166666664,
                "2025-12-03": 18.724393055555556
              },
              "time_count_per_day": {
                "2025-11-22": 1,
                "2025-12-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_545": {
      "overall": {
        "avg_time_hours": 4.61,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-21": 1
        },
        "time_per_day": {
          "2025-11-21": 4.607036111111111
        },
        "time_count_per_day": {
          "2025-11-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.61,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-21": 1
          },
          "time_per_day": {
            "2025-11-21": 4.607036111111111
          },
          "time_count_per_day": {
            "2025-11-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.61,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-21": 1
            },
            "time_per_day": {
              "2025-11-21": 4.607036111111111
            },
            "time_count_per_day": {
              "2025-11-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.61,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-21": 1
              },
              "time_per_day": {
                "2025-11-21": 4.607036111111111
              },
              "time_count_per_day": {
                "2025-11-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_436": {
      "overall": {
        "avg_time_hours": 140.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 1,
          "4-6h": 2,
          "6-8h": 2,
          "8-10h": 1,
          "12-14h": 2,
          "18-20h": 1,
          "24-26h": 2,
          "32-34h": 1,
          "36-38h": 1,
          "70-72h": 1,
          "80-82h": 1,
          "92-94h": 1,
          "118-120h": 1,
          "128-130h": 1,
          "138-140h": 1,
          "142-144h": 1,
          "160-162h": 1,
          "264-266h": 1,
          "382-384h": 1,
          "728-730h": 1,
          "762-764h": 1,
          "1060-1062h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-11-21": 1,
          "2025-12-04": 1,
          "2026-01-05": 1,
          "2026-01-12": 1,
          "2026-01-15": 3,
          "2026-01-16": 1,
          "2026-01-17": 3,
          "2026-01-26": 1,
          "2026-02-03": 3,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-03-23": 2,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-04-29": 2,
          "2026-05-07": 1,
          "2026-05-25": 2,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-11-21": 0.34445194444444444,
          "2025-12-04": 264.8390261111111,
          "2026-01-05": 8.823498888888889,
          "2026-01-12": 160.96238555555556,
          "2026-01-15": 86.17161333333334,
          "2026-01-16": 12.234117499999998,
          "2026-01-17": 81.47767527777778,
          "2026-01-26": 383.04077472222224,
          "2026-02-03": 1011.5053444444444,
          "2026-02-18": 1061.3193569444445,
          "2026-02-19": 762.1332836111111,
          "2026-03-09": 128.50238055555556,
          "2026-03-19": 0.7202630555555556,
          "2026-03-23": 13.507914166666666,
          "2026-03-25": 118.10684833333333,
          "2026-04-02": 18.55709583333333,
          "2026-04-20": 1.5283586111111112,
          "2026-04-23": 71.45151444444444,
          "2026-04-29": 51.656258333333334,
          "2026-05-07": 4.809958611111111,
          "2026-05-25": 7.3724902777777785,
          "2026-06-02": 92.53847055555556
        },
        "time_count_per_day": {
          "2025-11-21": 1,
          "2025-12-04": 1,
          "2026-01-05": 1,
          "2026-01-12": 1,
          "2026-01-15": 3,
          "2026-01-16": 1,
          "2026-01-17": 3,
          "2026-01-26": 1,
          "2026-02-03": 3,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-09": 1,
          "2026-03-19": 1,
          "2026-03-23": 2,
          "2026-03-25": 1,
          "2026-04-02": 1,
          "2026-04-20": 1,
          "2026-04-23": 1,
          "2026-04-29": 2,
          "2026-05-07": 1,
          "2026-05-25": 2,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.53,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-20": 1.5283586111111112
          },
          "time_count_per_day": {
            "2026-04-20": 1
          }
        },
        "P2": {
          "avg_time_hours": 75.88,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "4-6h": 2,
            "6-8h": 2,
            "18-20h": 1,
            "24-26h": 2,
            "70-72h": 1,
            "92-94h": 1,
            "118-120h": 1,
            "128-130h": 1,
            "138-140h": 1,
            "142-144h": 1,
            "264-266h": 1,
            "382-384h": 1
          },
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-04-02": 1,
            "2026-04-23": 1,
            "2026-04-29": 2,
            "2026-05-07": 1,
            "2026-05-25": 2,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-11-21": 0.34445194444444444,
            "2025-12-04": 264.8390261111111,
            "2026-01-15": 2.9463541666666666,
            "2026-01-26": 383.04077472222224,
            "2026-02-03": 283.2946483333333,
            "2026-03-09": 128.50238055555556,
            "2026-03-19": 0.7202630555555556,
            "2026-03-23": 13.507914166666666,
            "2026-03-25": 118.10684833333333,
            "2026-04-02": 18.55709583333333,
            "2026-04-23": 71.45151444444444,
            "2026-04-29": 51.656258333333334,
            "2026-05-07": 4.809958611111111,
            "2026-05-25": 7.3724902777777785,
            "2026-06-02": 92.53847055555556
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2025-12-04": 1,
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-02-03": 2,
            "2026-03-09": 1,
            "2026-03-19": 1,
            "2026-03-23": 2,
            "2026-03-25": 1,
            "2026-04-02": 1,
            "2026-04-23": 1,
            "2026-04-29": 2,
            "2026-05-07": 1,
            "2026-05-25": 2,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 230.93,
          "mode_time_hours": 1061.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "32-34h": 1,
            "36-38h": 1,
            "80-82h": 1,
            "160-162h": 1,
            "1060-1062h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-12": 1,
            "2026-01-15": 1,
            "2026-01-17": 3,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-12": 160.96238555555556,
            "2026-01-15": 81.80304333333333,
            "2026-01-17": 81.47767527777778,
            "2026-02-18": 1061.3193569444445
          },
          "time_count_per_day": {
            "2026-01-12": 1,
            "2026-01-15": 1,
            "2026-01-17": 3,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 6.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "12-14h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-15": 1.4222158333333332,
            "2026-01-16": 12.234117499999998
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-01-16": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 499.72,
          "mode_time_hours": 729.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "728-730h": 1,
            "762-764h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-02-03": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-05": 8.823498888888889,
            "2026-02-03": 728.2106961111111,
            "2026-02-19": 762.1332836111111
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-02-03": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 140.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 1,
              "4-6h": 2,
              "6-8h": 2,
              "8-10h": 1,
              "12-14h": 2,
              "18-20h": 1,
              "24-26h": 2,
              "32-34h": 1,
              "36-38h": 1,
              "70-72h": 1,
              "80-82h": 1,
              "92-94h": 1,
              "118-120h": 1,
              "128-130h": 1,
              "138-140h": 1,
              "142-144h": 1,
              "160-162h": 1,
              "264-266h": 1,
              "382-384h": 1,
              "728-730h": 1,
              "762-764h": 1,
              "1060-1062h": 1
            },
            "tickets_count": 31,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2025-12-04": 1,
              "2026-01-05": 1,
              "2026-01-12": 1,
              "2026-01-15": 3,
              "2026-01-16": 1,
              "2026-01-17": 3,
              "2026-01-26": 1,
              "2026-02-03": 3,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-03-23": 2,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-04-29": 2,
              "2026-05-07": 1,
              "2026-05-25": 2,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-21": 0.34445194444444444,
              "2025-12-04": 264.8390261111111,
              "2026-01-05": 8.823498888888889,
              "2026-01-12": 160.96238555555556,
              "2026-01-15": 86.17161333333334,
              "2026-01-16": 12.234117499999998,
              "2026-01-17": 81.47767527777778,
              "2026-01-26": 383.04077472222224,
              "2026-02-03": 1011.5053444444444,
              "2026-02-18": 1061.3193569444445,
              "2026-02-19": 762.1332836111111,
              "2026-03-09": 128.50238055555556,
              "2026-03-19": 0.7202630555555556,
              "2026-03-23": 13.507914166666666,
              "2026-03-25": 118.10684833333333,
              "2026-04-02": 18.55709583333333,
              "2026-04-20": 1.5283586111111112,
              "2026-04-23": 71.45151444444444,
              "2026-04-29": 51.656258333333334,
              "2026-05-07": 4.809958611111111,
              "2026-05-25": 7.3724902777777785,
              "2026-06-02": 92.53847055555556
            },
            "time_count_per_day": {
              "2025-11-21": 1,
              "2025-12-04": 1,
              "2026-01-05": 1,
              "2026-01-12": 1,
              "2026-01-15": 3,
              "2026-01-16": 1,
              "2026-01-17": 3,
              "2026-01-26": 1,
              "2026-02-03": 3,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-09": 1,
              "2026-03-19": 1,
              "2026-03-23": 2,
              "2026-03-25": 1,
              "2026-04-02": 1,
              "2026-04-20": 1,
              "2026-04-23": 1,
              "2026-04-29": 2,
              "2026-05-07": 1,
              "2026-05-25": 2,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.53,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-20": 1.5283586111111112
              },
              "time_count_per_day": {
                "2026-04-20": 1
              }
            },
            "P2": {
              "avg_time_hours": 75.88,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "4-6h": 2,
                "6-8h": 2,
                "18-20h": 1,
                "24-26h": 2,
                "70-72h": 1,
                "92-94h": 1,
                "118-120h": 1,
                "128-130h": 1,
                "138-140h": 1,
                "142-144h": 1,
                "264-266h": 1,
                "382-384h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-04-02": 1,
                "2026-04-23": 1,
                "2026-04-29": 2,
                "2026-05-07": 1,
                "2026-05-25": 2,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-11-21": 0.34445194444444444,
                "2025-12-04": 264.8390261111111,
                "2026-01-15": 2.9463541666666666,
                "2026-01-26": 383.04077472222224,
                "2026-02-03": 283.2946483333333,
                "2026-03-09": 128.50238055555556,
                "2026-03-19": 0.7202630555555556,
                "2026-03-23": 13.507914166666666,
                "2026-03-25": 118.10684833333333,
                "2026-04-02": 18.55709583333333,
                "2026-04-23": 71.45151444444444,
                "2026-04-29": 51.656258333333334,
                "2026-05-07": 4.809958611111111,
                "2026-05-25": 7.3724902777777785,
                "2026-06-02": 92.53847055555556
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2025-12-04": 1,
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-02-03": 2,
                "2026-03-09": 1,
                "2026-03-19": 1,
                "2026-03-23": 2,
                "2026-03-25": 1,
                "2026-04-02": 1,
                "2026-04-23": 1,
                "2026-04-29": 2,
                "2026-05-07": 1,
                "2026-05-25": 2,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 230.93,
              "mode_time_hours": 1061.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "32-34h": 1,
                "36-38h": 1,
                "80-82h": 1,
                "160-162h": 1,
                "1060-1062h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-12": 1,
                "2026-01-15": 1,
                "2026-01-17": 3,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-12": 160.96238555555556,
                "2026-01-15": 81.80304333333333,
                "2026-01-17": 81.47767527777778,
                "2026-02-18": 1061.3193569444445
              },
              "time_count_per_day": {
                "2026-01-12": 1,
                "2026-01-15": 1,
                "2026-01-17": 3,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 6.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "12-14h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-15": 1.4222158333333332,
                "2026-01-16": 12.234117499999998
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-01-16": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 499.72,
              "mode_time_hours": 729.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "728-730h": 1,
                "762-764h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-02-03": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-05": 8.823498888888889,
                "2026-02-03": 728.2106961111111,
                "2026-02-19": 762.1332836111111
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-02-03": 1,
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_546": {
      "overall": {
        "avg_time_hours": 67.88,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "12-14h": 1,
          "18-20h": 1,
          "40-42h": 1,
          "68-70h": 1,
          "72-74h": 1,
          "144-146h": 1,
          "180-182h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2026-01-08": 1,
          "2026-01-23": 1,
          "2026-04-27": 1,
          "2026-05-13": 1
        },
        "time_per_day": {
          "2025-11-21": 0.7560466666666666,
          "2025-11-22": 19.075771666666668,
          "2025-11-24": 41.93586722222222,
          "2025-12-04": 144.5640425,
          "2026-01-08": 12.859630277777779,
          "2026-01-23": 69.44553583333334,
          "2026-04-27": 72.87434499999999,
          "2026-05-13": 181.51605055555555
        },
        "time_count_per_day": {
          "2025-11-21": 1,
          "2025-11-22": 1,
          "2025-11-24": 1,
          "2025-12-04": 1,
          "2026-01-08": 1,
          "2026-01-23": 1,
          "2026-04-27": 1,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 67.88,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "12-14h": 1,
            "18-20h": 1,
            "40-42h": 1,
            "68-70h": 1,
            "72-74h": 1,
            "144-146h": 1,
            "180-182h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-24": 1,
            "2025-12-04": 1,
            "2026-01-08": 1,
            "2026-01-23": 1,
            "2026-04-27": 1,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2025-11-21": 0.7560466666666666,
            "2025-11-22": 19.075771666666668,
            "2025-11-24": 41.93586722222222,
            "2025-12-04": 144.5640425,
            "2026-01-08": 12.859630277777779,
            "2026-01-23": 69.44553583333334,
            "2026-04-27": 72.87434499999999,
            "2026-05-13": 181.51605055555555
          },
          "time_count_per_day": {
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-24": 1,
            "2025-12-04": 1,
            "2026-01-08": 1,
            "2026-01-23": 1,
            "2026-04-27": 1,
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 67.88,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "12-14h": 1,
              "18-20h": 1,
              "40-42h": 1,
              "68-70h": 1,
              "72-74h": 1,
              "144-146h": 1,
              "180-182h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2026-01-08": 1,
              "2026-01-23": 1,
              "2026-04-27": 1,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2025-11-21": 0.7560466666666666,
              "2025-11-22": 19.075771666666668,
              "2025-11-24": 41.93586722222222,
              "2025-12-04": 144.5640425,
              "2026-01-08": 12.859630277777779,
              "2026-01-23": 69.44553583333334,
              "2026-04-27": 72.87434499999999,
              "2026-05-13": 181.51605055555555
            },
            "time_count_per_day": {
              "2025-11-21": 1,
              "2025-11-22": 1,
              "2025-11-24": 1,
              "2025-12-04": 1,
              "2026-01-08": 1,
              "2026-01-23": 1,
              "2026-04-27": 1,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 67.88,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "12-14h": 1,
                "18-20h": 1,
                "40-42h": 1,
                "68-70h": 1,
                "72-74h": 1,
                "144-146h": 1,
                "180-182h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-24": 1,
                "2025-12-04": 1,
                "2026-01-08": 1,
                "2026-01-23": 1,
                "2026-04-27": 1,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2025-11-21": 0.7560466666666666,
                "2025-11-22": 19.075771666666668,
                "2025-11-24": 41.93586722222222,
                "2025-12-04": 144.5640425,
                "2026-01-08": 12.859630277777779,
                "2026-01-23": 69.44553583333334,
                "2026-04-27": 72.87434499999999,
                "2026-05-13": 181.51605055555555
              },
              "time_count_per_day": {
                "2025-11-21": 1,
                "2025-11-22": 1,
                "2025-11-24": 1,
                "2025-12-04": 1,
                "2026-01-08": 1,
                "2026-01-23": 1,
                "2026-04-27": 1,
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_547": {
      "overall": {
        "avg_time_hours": 36.87,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1,
          "46-48h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-25": 1,
          "2025-11-27": 1
        },
        "time_per_day": {
          "2025-11-25": 46.59135861111111,
          "2025-11-27": 27.146326666666667
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2025-11-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.15,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {
            "2025-11-27": 27.146326666666667
          },
          "time_count_per_day": {
            "2025-11-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 46.59,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-11-25": 46.59135861111111
          },
          "time_count_per_day": {
            "2025-11-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 36.87,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1,
              "46-48h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2025-11-27": 1
            },
            "time_per_day": {
              "2025-11-25": 46.59135861111111,
              "2025-11-27": 27.146326666666667
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2025-11-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.15,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-27": 27.146326666666667
              },
              "time_count_per_day": {
                "2025-11-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 46.59,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-11-25": 46.59135861111111
              },
              "time_count_per_day": {
                "2025-11-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_548": {
      "overall": {
        "avg_time_hours": 204.21,
        "mode_time_hours": 381.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "380-382h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-09": 1,
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-09": 380.36717944444445,
          "2025-12-18": 28.056221666666666
        },
        "time_count_per_day": {
          "2025-12-09": 1,
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 380.37,
          "mode_time_hours": 381.0,
          "mode_frequency": 1,
          "time_distribution": {
            "380-382h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-09": 1
          },
          "time_per_day": {
            "2025-12-09": 380.36717944444445
          },
          "time_count_per_day": {
            "2025-12-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 28.06,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 28.056221666666666
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 204.21,
            "mode_time_hours": 381.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "380-382h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-09": 380.36717944444445,
              "2025-12-18": 28.056221666666666
            },
            "time_count_per_day": {
              "2025-12-09": 1,
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 380.37,
              "mode_time_hours": 381.0,
              "mode_frequency": 1,
              "time_distribution": {
                "380-382h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-09": 1
              },
              "time_per_day": {
                "2025-12-09": 380.36717944444445
              },
              "time_count_per_day": {
                "2025-12-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 28.06,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 28.056221666666666
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_551": {
      "overall": {
        "avg_time_hours": 58.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "28-30h": 1,
          "100-102h": 1,
          "138-140h": 1,
          "238-240h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2026-01-06": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-04-07": 1,
          "2026-04-18": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-28": 1
        },
        "time_per_day": {
          "2025-11-24": 22.205225,
          "2025-11-27": 25.356044722222222,
          "2026-01-06": 20.040915277777778,
          "2026-01-29": 1.5679044444444445,
          "2026-02-03": 100.24702916666666,
          "2026-04-07": 1.3607133333333334,
          "2026-04-18": 1.6630741666666666,
          "2026-04-22": 139.62305194444446,
          "2026-04-23": 239.9342047222222,
          "2026-04-28": 28.694265833333333
        },
        "time_count_per_day": {
          "2025-11-24": 1,
          "2025-11-27": 1,
          "2026-01-06": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-04-07": 1,
          "2026-04-18": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-04-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 62.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "22-24h": 1,
            "24-26h": 1,
            "28-30h": 1,
            "100-102h": 1,
            "138-140h": 1,
            "238-240h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-04-07": 1,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-28": 1
          },
          "time_per_day": {
            "2025-11-24": 22.205225,
            "2025-11-27": 25.356044722222222,
            "2026-01-29": 1.5679044444444445,
            "2026-02-03": 100.24702916666666,
            "2026-04-07": 1.3607133333333334,
            "2026-04-18": 1.6630741666666666,
            "2026-04-22": 139.62305194444446,
            "2026-04-23": 239.9342047222222,
            "2026-04-28": 28.694265833333333
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-11-27": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-04-07": 1,
            "2026-04-18": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-04-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 20.04,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-06": 1
          },
          "time_per_day": {
            "2026-01-06": 20.040915277777778
          },
          "time_count_per_day": {
            "2026-01-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 58.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "28-30h": 1,
              "100-102h": 1,
              "138-140h": 1,
              "238-240h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2026-01-06": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-04-07": 1,
              "2026-04-18": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-28": 1
            },
            "time_per_day": {
              "2025-11-24": 22.205225,
              "2025-11-27": 25.356044722222222,
              "2026-01-06": 20.040915277777778,
              "2026-01-29": 1.5679044444444445,
              "2026-02-03": 100.24702916666666,
              "2026-04-07": 1.3607133333333334,
              "2026-04-18": 1.6630741666666666,
              "2026-04-22": 139.62305194444446,
              "2026-04-23": 239.9342047222222,
              "2026-04-28": 28.694265833333333
            },
            "time_count_per_day": {
              "2025-11-24": 1,
              "2025-11-27": 1,
              "2026-01-06": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-04-07": 1,
              "2026-04-18": 1,
              "2026-04-22": 1,
              "2026-04-23": 1,
              "2026-04-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 62.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "22-24h": 1,
                "24-26h": 1,
                "28-30h": 1,
                "100-102h": 1,
                "138-140h": 1,
                "238-240h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-04-07": 1,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-28": 1
              },
              "time_per_day": {
                "2025-11-24": 22.205225,
                "2025-11-27": 25.356044722222222,
                "2026-01-29": 1.5679044444444445,
                "2026-02-03": 100.24702916666666,
                "2026-04-07": 1.3607133333333334,
                "2026-04-18": 1.6630741666666666,
                "2026-04-22": 139.62305194444446,
                "2026-04-23": 239.9342047222222,
                "2026-04-28": 28.694265833333333
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-11-27": 1,
                "2026-01-29": 1,
                "2026-02-03": 1,
                "2026-04-07": 1,
                "2026-04-18": 1,
                "2026-04-22": 1,
                "2026-04-23": 1,
                "2026-04-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 20.04,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-06": 1
              },
              "time_per_day": {
                "2026-01-06": 20.040915277777778
              },
              "time_count_per_day": {
                "2026-01-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_552": {
      "overall": {
        "avg_time_hours": 0.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-24": 1
        },
        "time_per_day": {
          "2025-11-24": 0.5161247222222222
        },
        "time_count_per_day": {
          "2025-11-24": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 0.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-11-24": 0.5161247222222222
          },
          "time_count_per_day": {
            "2025-11-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-24": 1
            },
            "time_per_day": {
              "2025-11-24": 0.5161247222222222
            },
            "time_count_per_day": {
              "2025-11-24": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 0.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-11-24": 0.5161247222222222
              },
              "time_count_per_day": {
                "2025-11-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_559": {
      "overall": {
        "avg_time_hours": 20.35,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-25": 1
        },
        "time_per_day": {
          "2025-11-25": 20.351848333333333
        },
        "time_count_per_day": {
          "2025-11-25": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 20.35,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-11-25": 20.351848333333333
          },
          "time_count_per_day": {
            "2025-11-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.35,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-25": 1
            },
            "time_per_day": {
              "2025-11-25": 20.351848333333333
            },
            "time_count_per_day": {
              "2025-11-25": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 20.35,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-11-25": 20.351848333333333
              },
              "time_count_per_day": {
                "2025-11-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_562": {
      "overall": {
        "avg_time_hours": 0.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-24": 1
        },
        "time_per_day": {
          "2025-11-24": 0.07424444444444443
        },
        "time_count_per_day": {
          "2025-11-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-24": 1
          },
          "time_per_day": {
            "2025-11-24": 0.07424444444444443
          },
          "time_count_per_day": {
            "2025-11-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-24": 1
            },
            "time_per_day": {
              "2025-11-24": 0.07424444444444443
            },
            "time_count_per_day": {
              "2025-11-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {
                "2025-11-24": 0.07424444444444443
              },
              "time_count_per_day": {
                "2025-11-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_241": {
      "overall": {
        "avg_time_hours": 189.36,
        "mode_time_hours": 15.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "4-6h": 1,
          "14-16h": 3,
          "16-18h": 1,
          "20-22h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "32-34h": 1,
          "34-36h": 1,
          "38-40h": 1,
          "60-62h": 1,
          "72-74h": 2,
          "76-78h": 2,
          "96-98h": 1,
          "122-124h": 1,
          "198-200h": 1,
          "240-242h": 1,
          "282-284h": 1,
          "316-318h": 1,
          "352-354h": 1,
          "2886-2888h": 1
        },
        "tickets_count": 27,
        "tickets_per_day": {
          "2025-11-24": 1,
          "2025-12-10": 1,
          "2025-12-11": 2,
          "2025-12-18": 1,
          "2025-12-23": 2,
          "2025-12-30": 1,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-28": 1,
          "2026-03-10": 1,
          "2026-03-16": 2,
          "2026-03-25": 1,
          "2026-04-09": 1,
          "2026-04-20": 1,
          "2026-05-18": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-11-24": 0.20473416666666666,
          "2025-12-10": 20.511571666666665,
          "2025-12-11": 159.10311805555557,
          "2025-12-18": 73.70256027777778,
          "2025-12-23": 170.17698333333334,
          "2025-12-30": 240.4240663888889,
          "2026-02-02": 4.817692222222222,
          "2026-02-03": 15.96061888888889,
          "2026-02-10": 3039.8442274999998,
          "2026-02-12": 17.67606027777778,
          "2026-02-13": 38.65868416666667,
          "2026-02-17": 26.632512777777777,
          "2026-02-18": 60.78500138888889,
          "2026-02-20": 316.42330472222227,
          "2026-02-28": 25.776114999999997,
          "2026-03-10": 283.4771713888889,
          "2026-03-16": 31.102647222222224,
          "2026-03-25": 353.3210133333333,
          "2026-04-09": 33.075743055555556,
          "2026-04-20": 198.77591166666667,
          "2026-05-18": 2.0782374999999997,
          "2026-05-27": 0.25072972222222223
        },
        "time_count_per_day": {
          "2025-11-24": 1,
          "2025-12-10": 1,
          "2025-12-11": 2,
          "2025-12-18": 1,
          "2025-12-23": 2,
          "2025-12-30": 1,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-10": 3,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-20": 1,
          "2026-02-28": 1,
          "2026-03-10": 1,
          "2026-03-16": 2,
          "2026-03-25": 1,
          "2026-04-09": 1,
          "2026-04-20": 1,
          "2026-05-18": 1,
          "2026-05-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 246.26,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "4-6h": 1,
            "14-16h": 2,
            "20-22h": 1,
            "24-26h": 1,
            "32-34h": 1,
            "34-36h": 1,
            "72-74h": 2,
            "122-124h": 1,
            "240-242h": 1,
            "282-284h": 1,
            "352-354h": 1,
            "2886-2888h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-18": 1,
            "2025-12-23": 1,
            "2025-12-30": 1,
            "2026-02-02": 1,
            "2026-02-10": 1,
            "2026-02-28": 1,
            "2026-03-10": 1,
            "2026-03-16": 2,
            "2026-03-25": 1,
            "2026-04-09": 1,
            "2026-05-18": 1,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2025-11-24": 0.20473416666666666,
            "2025-12-10": 20.511571666666665,
            "2025-12-11": 159.10311805555557,
            "2025-12-18": 73.70256027777778,
            "2025-12-23": 72.33524388888888,
            "2025-12-30": 240.4240663888889,
            "2026-02-02": 4.817692222222222,
            "2026-02-10": 2886.23031,
            "2026-02-28": 25.776114999999997,
            "2026-03-10": 283.4771713888889,
            "2026-03-16": 31.102647222222224,
            "2026-03-25": 353.3210133333333,
            "2026-04-09": 33.075743055555556,
            "2026-05-18": 2.0782374999999997,
            "2026-05-27": 0.25072972222222223
          },
          "time_count_per_day": {
            "2025-11-24": 1,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-18": 1,
            "2025-12-23": 1,
            "2025-12-30": 1,
            "2026-02-02": 1,
            "2026-02-10": 1,
            "2026-02-28": 1,
            "2026-03-10": 1,
            "2026-03-16": 2,
            "2026-03-25": 1,
            "2026-04-09": 1,
            "2026-05-18": 1,
            "2026-05-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 92.64,
          "mode_time_hours": 77.0,
          "mode_frequency": 2,
          "time_distribution": {
            "14-16h": 1,
            "16-18h": 1,
            "26-28h": 1,
            "38-40h": 1,
            "60-62h": 1,
            "76-78h": 2,
            "96-98h": 1,
            "198-200h": 1,
            "316-318h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2025-12-23": 97.84173944444444,
            "2026-02-03": 15.96061888888889,
            "2026-02-10": 153.6139175,
            "2026-02-12": 17.67606027777778,
            "2026-02-13": 38.65868416666667,
            "2026-02-17": 26.632512777777777,
            "2026-02-18": 60.78500138888889,
            "2026-02-20": 316.42330472222227,
            "2026-04-20": 198.77591166666667
          },
          "time_count_per_day": {
            "2025-12-23": 1,
            "2026-02-03": 1,
            "2026-02-10": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-02-20": 1,
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 189.36,
            "mode_time_hours": 15.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "4-6h": 1,
              "14-16h": 3,
              "16-18h": 1,
              "20-22h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "32-34h": 1,
              "34-36h": 1,
              "38-40h": 1,
              "60-62h": 1,
              "72-74h": 2,
              "76-78h": 2,
              "96-98h": 1,
              "122-124h": 1,
              "198-200h": 1,
              "240-242h": 1,
              "282-284h": 1,
              "316-318h": 1,
              "352-354h": 1,
              "2886-2888h": 1
            },
            "tickets_count": 27,
            "tickets_per_day": {
              "2025-11-24": 1,
              "2025-12-10": 1,
              "2025-12-11": 2,
              "2025-12-18": 1,
              "2025-12-23": 2,
              "2025-12-30": 1,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-28": 1,
              "2026-03-10": 1,
              "2026-03-16": 2,
              "2026-03-25": 1,
              "2026-04-09": 1,
              "2026-04-20": 1,
              "2026-05-18": 1,
              "2026-05-27": 1
            },
            "time_per_day": {
              "2025-11-24": 0.20473416666666666,
              "2025-12-10": 20.511571666666665,
              "2025-12-11": 159.10311805555557,
              "2025-12-18": 73.70256027777778,
              "2025-12-23": 170.17698333333334,
              "2025-12-30": 240.4240663888889,
              "2026-02-02": 4.817692222222222,
              "2026-02-03": 15.96061888888889,
              "2026-02-10": 3039.8442274999998,
              "2026-02-12": 17.67606027777778,
              "2026-02-13": 38.65868416666667,
              "2026-02-17": 26.632512777777777,
              "2026-02-18": 60.78500138888889,
              "2026-02-20": 316.42330472222227,
              "2026-02-28": 25.776114999999997,
              "2026-03-10": 283.4771713888889,
              "2026-03-16": 31.102647222222224,
              "2026-03-25": 353.3210133333333,
              "2026-04-09": 33.075743055555556,
              "2026-04-20": 198.77591166666667,
              "2026-05-18": 2.0782374999999997,
              "2026-05-27": 0.25072972222222223
            },
            "time_count_per_day": {
              "2025-11-24": 1,
              "2025-12-10": 1,
              "2025-12-11": 2,
              "2025-12-18": 1,
              "2025-12-23": 2,
              "2025-12-30": 1,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-10": 3,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-20": 1,
              "2026-02-28": 1,
              "2026-03-10": 1,
              "2026-03-16": 2,
              "2026-03-25": 1,
              "2026-04-09": 1,
              "2026-04-20": 1,
              "2026-05-18": 1,
              "2026-05-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 246.26,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "4-6h": 1,
                "14-16h": 2,
                "20-22h": 1,
                "24-26h": 1,
                "32-34h": 1,
                "34-36h": 1,
                "72-74h": 2,
                "122-124h": 1,
                "240-242h": 1,
                "282-284h": 1,
                "352-354h": 1,
                "2886-2888h": 1
              },
              "tickets_count": 17,
              "tickets_per_day": {
                "2025-11-24": 1,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-18": 1,
                "2025-12-23": 1,
                "2025-12-30": 1,
                "2026-02-02": 1,
                "2026-02-10": 1,
                "2026-02-28": 1,
                "2026-03-10": 1,
                "2026-03-16": 2,
                "2026-03-25": 1,
                "2026-04-09": 1,
                "2026-05-18": 1,
                "2026-05-27": 1
              },
              "time_per_day": {
                "2025-11-24": 0.20473416666666666,
                "2025-12-10": 20.511571666666665,
                "2025-12-11": 159.10311805555557,
                "2025-12-18": 73.70256027777778,
                "2025-12-23": 72.33524388888888,
                "2025-12-30": 240.4240663888889,
                "2026-02-02": 4.817692222222222,
                "2026-02-10": 2886.23031,
                "2026-02-28": 25.776114999999997,
                "2026-03-10": 283.4771713888889,
                "2026-03-16": 31.102647222222224,
                "2026-03-25": 353.3210133333333,
                "2026-04-09": 33.075743055555556,
                "2026-05-18": 2.0782374999999997,
                "2026-05-27": 0.25072972222222223
              },
              "time_count_per_day": {
                "2025-11-24": 1,
                "2025-12-10": 1,
                "2025-12-11": 2,
                "2025-12-18": 1,
                "2025-12-23": 1,
                "2025-12-30": 1,
                "2026-02-02": 1,
                "2026-02-10": 1,
                "2026-02-28": 1,
                "2026-03-10": 1,
                "2026-03-16": 2,
                "2026-03-25": 1,
                "2026-04-09": 1,
                "2026-05-18": 1,
                "2026-05-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 92.64,
              "mode_time_hours": 77.0,
              "mode_frequency": 2,
              "time_distribution": {
                "14-16h": 1,
                "16-18h": 1,
                "26-28h": 1,
                "38-40h": 1,
                "60-62h": 1,
                "76-78h": 2,
                "96-98h": 1,
                "198-200h": 1,
                "316-318h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-20": 1
              },
              "time_per_day": {
                "2025-12-23": 97.84173944444444,
                "2026-02-03": 15.96061888888889,
                "2026-02-10": 153.6139175,
                "2026-02-12": 17.67606027777778,
                "2026-02-13": 38.65868416666667,
                "2026-02-17": 26.632512777777777,
                "2026-02-18": 60.78500138888889,
                "2026-02-20": 316.42330472222227,
                "2026-04-20": 198.77591166666667
              },
              "time_count_per_day": {
                "2025-12-23": 1,
                "2026-02-03": 1,
                "2026-02-10": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-02-20": 1,
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_564": {
      "overall": {
        "avg_time_hours": 16.3,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-25": 1
        },
        "time_per_day": {
          "2025-11-25": 16.300656944444444
        },
        "time_count_per_day": {
          "2025-11-25": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 16.3,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-25": 1
          },
          "time_per_day": {
            "2025-11-25": 16.300656944444444
          },
          "time_count_per_day": {
            "2025-11-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.3,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-25": 1
            },
            "time_per_day": {
              "2025-11-25": 16.300656944444444
            },
            "time_count_per_day": {
              "2025-11-25": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 16.3,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-25": 1
              },
              "time_per_day": {
                "2025-11-25": 16.300656944444444
              },
              "time_count_per_day": {
                "2025-11-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_566": {
      "overall": {
        "avg_time_hours": 0.89,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-11-25": 1,
          "2026-02-24": 1,
          "2026-02-26": 1,
          "2026-03-10": 1,
          "2026-03-26": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2025-11-25": 0.41788722222222224,
          "2026-02-24": 0.21859055555555557,
          "2026-02-26": 0.43507611111111105,
          "2026-03-10": 2.139497222222222,
          "2026-03-26": 0.15107416666666665,
          "2026-05-15": 1.979023888888889
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2026-02-24": 1,
          "2026-02-26": 1,
          "2026-03-10": 1,
          "2026-03-26": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-03-10": 1,
            "2026-03-26": 1,
            "2026-05-15": 1
          },
          "time_per_day": {
            "2025-11-25": 0.41788722222222224,
            "2026-02-24": 0.21859055555555557,
            "2026-02-26": 0.43507611111111105,
            "2026-03-10": 2.139497222222222,
            "2026-03-26": 0.15107416666666665,
            "2026-05-15": 1.979023888888889
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-03-10": 1,
            "2026-03-26": 1,
            "2026-05-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.89,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-03-10": 1,
              "2026-03-26": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2025-11-25": 0.41788722222222224,
              "2026-02-24": 0.21859055555555557,
              "2026-02-26": 0.43507611111111105,
              "2026-03-10": 2.139497222222222,
              "2026-03-26": 0.15107416666666665,
              "2026-05-15": 1.979023888888889
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-03-10": 1,
              "2026-03-26": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-10": 1,
                "2026-03-26": 1,
                "2026-05-15": 1
              },
              "time_per_day": {
                "2025-11-25": 0.41788722222222224,
                "2026-02-24": 0.21859055555555557,
                "2026-02-26": 0.43507611111111105,
                "2026-03-10": 2.139497222222222,
                "2026-03-26": 0.15107416666666665,
                "2026-05-15": 1.979023888888889
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-10": 1,
                "2026-03-26": 1,
                "2026-05-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_316": {
      "overall": {
        "avg_time_hours": 60.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 1,
          "14-16h": 1,
          "30-32h": 1,
          "64-66h": 1,
          "120-122h": 1,
          "122-124h": 1,
          "312-314h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2025-11-25": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-16": 1,
          "2026-01-14": 1,
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-24": 1,
          "2026-06-01": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-25": 0.6659408333333334,
          "2025-12-14": 64.17091638888888,
          "2025-12-15": 0.2116675,
          "2025-12-16": 2.118203888888889,
          "2026-01-14": 14.804965833333334,
          "2026-02-03": 30.659129444444442,
          "2026-02-19": 0.17717361111111113,
          "2026-02-23": 123.4639325,
          "2026-02-25": 312.00210527777773,
          "2026-03-24": 120.91593888888889,
          "2026-06-01": 1.0981319444444444
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2025-12-14": 1,
          "2025-12-15": 1,
          "2025-12-16": 1,
          "2026-01-14": 1,
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-02-25": 1,
          "2026-03-24": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 51.67,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "64-66h": 1,
            "120-122h": 1,
            "122-124h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2026-02-19": 1,
            "2026-02-23": 1,
            "2026-03-24": 1,
            "2026-06-01": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-12-14": 64.17091638888888,
            "2025-12-15": 0.2116675,
            "2026-02-19": 0.17717361111111113,
            "2026-02-23": 123.4639325,
            "2026-03-24": 120.91593888888889,
            "2026-06-01": 1.0981319444444444
          },
          "time_count_per_day": {
            "2025-12-14": 1,
            "2025-12-15": 1,
            "2026-02-19": 1,
            "2026-02-23": 1,
            "2026-03-24": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 82.4,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1,
            "312-314h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-11-25": 1,
            "2025-12-16": 1,
            "2026-01-14": 1,
            "2026-02-25": 1
          },
          "time_per_day": {
            "2025-11-25": 0.6659408333333334,
            "2025-12-16": 2.118203888888889,
            "2026-01-14": 14.804965833333334,
            "2026-02-25": 312.00210527777773
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2025-12-16": 1,
            "2026-01-14": 1,
            "2026-02-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 30.66,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 30.659129444444442
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 60.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 1,
              "14-16h": 1,
              "30-32h": 1,
              "64-66h": 1,
              "120-122h": 1,
              "122-124h": 1,
              "312-314h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-16": 1,
              "2026-01-14": 1,
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-24": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-11-25": 0.6659408333333334,
              "2025-12-14": 64.17091638888888,
              "2025-12-15": 0.2116675,
              "2025-12-16": 2.118203888888889,
              "2026-01-14": 14.804965833333334,
              "2026-02-03": 30.659129444444442,
              "2026-02-19": 0.17717361111111113,
              "2026-02-23": 123.4639325,
              "2026-02-25": 312.00210527777773,
              "2026-03-24": 120.91593888888889,
              "2026-06-01": 1.0981319444444444
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2025-12-14": 1,
              "2025-12-15": 1,
              "2025-12-16": 1,
              "2026-01-14": 1,
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-02-25": 1,
              "2026-03-24": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 51.67,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "64-66h": 1,
                "120-122h": 1,
                "122-124h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2026-02-19": 1,
                "2026-02-23": 1,
                "2026-03-24": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-12-14": 64.17091638888888,
                "2025-12-15": 0.2116675,
                "2026-02-19": 0.17717361111111113,
                "2026-02-23": 123.4639325,
                "2026-03-24": 120.91593888888889,
                "2026-06-01": 1.0981319444444444
              },
              "time_count_per_day": {
                "2025-12-14": 1,
                "2025-12-15": 1,
                "2026-02-19": 1,
                "2026-02-23": 1,
                "2026-03-24": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 82.4,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1,
                "312-314h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2025-12-16": 1,
                "2026-01-14": 1,
                "2026-02-25": 1
              },
              "time_per_day": {
                "2025-11-25": 0.6659408333333334,
                "2025-12-16": 2.118203888888889,
                "2026-01-14": 14.804965833333334,
                "2026-02-25": 312.00210527777773
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2025-12-16": 1,
                "2026-01-14": 1,
                "2026-02-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 30.66,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 30.659129444444442
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_349": {
      "overall": {
        "avg_time_hours": 211.01,
        "mode_time_hours": 55.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 1,
          "54-56h": 2,
          "56-58h": 1,
          "330-332h": 1,
          "338-340h": 1,
          "634-636h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-25": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-03-09": 1,
          "2026-04-21": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2025-11-25": 3.9812619444444444,
          "2026-02-12": 55.92709472222222,
          "2026-02-13": 111.67641277777778,
          "2026-02-18": 339.76393833333333,
          "2026-03-09": 635.2885558333334,
          "2026-05-06": 330.43506305555553
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2026-02-12": 1,
          "2026-02-13": 2,
          "2026-02-18": 1,
          "2026-03-09": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 211.01,
          "mode_time_hours": 55.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "54-56h": 2,
            "56-58h": 1,
            "330-332h": 1,
            "338-340h": 1,
            "634-636h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-03-09": 1,
            "2026-04-21": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2025-11-25": 3.9812619444444444,
            "2026-02-12": 55.92709472222222,
            "2026-02-13": 111.67641277777778,
            "2026-02-18": 339.76393833333333,
            "2026-03-09": 635.2885558333334,
            "2026-05-06": 330.43506305555553
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2026-02-12": 1,
            "2026-02-13": 2,
            "2026-02-18": 1,
            "2026-03-09": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 211.01,
            "mode_time_hours": 55.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 1,
              "54-56h": 2,
              "56-58h": 1,
              "330-332h": 1,
              "338-340h": 1,
              "634-636h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-03-09": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2025-11-25": 3.9812619444444444,
              "2026-02-12": 55.92709472222222,
              "2026-02-13": 111.67641277777778,
              "2026-02-18": 339.76393833333333,
              "2026-03-09": 635.2885558333334,
              "2026-05-06": 330.43506305555553
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2026-02-12": 1,
              "2026-02-13": 2,
              "2026-02-18": 1,
              "2026-03-09": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 211.01,
              "mode_time_hours": 55.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "54-56h": 2,
                "56-58h": 1,
                "330-332h": 1,
                "338-340h": 1,
                "634-636h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-03-09": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2025-11-25": 3.9812619444444444,
                "2026-02-12": 55.92709472222222,
                "2026-02-13": 111.67641277777778,
                "2026-02-18": 339.76393833333333,
                "2026-03-09": 635.2885558333334,
                "2026-05-06": 330.43506305555553
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2026-02-12": 1,
                "2026-02-13": 2,
                "2026-02-18": 1,
                "2026-03-09": 1,
                "2026-05-06": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_569": {
      "overall": {
        "avg_time_hours": 26.49,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-26": 1
        },
        "time_per_day": {
          "2025-11-26": 26.488642777777777
        },
        "time_count_per_day": {
          "2025-11-26": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 26.49,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-26": 1
          },
          "time_per_day": {
            "2025-11-26": 26.488642777777777
          },
          "time_count_per_day": {
            "2025-11-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.49,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-26": 1
            },
            "time_per_day": {
              "2025-11-26": 26.488642777777777
            },
            "time_count_per_day": {
              "2025-11-26": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 26.49,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-26": 1
              },
              "time_per_day": {
                "2025-11-26": 26.488642777777777
              },
              "time_count_per_day": {
                "2025-11-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_572": {
      "overall": {
        "avg_time_hours": 0.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-25": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-11-25": 0.1397563888888889,
          "2026-05-26": 0.16539055555555554
        },
        "time_count_per_day": {
          "2025-11-25": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-11-25": 0.1397563888888889,
            "2026-05-26": 0.16539055555555554
          },
          "time_count_per_day": {
            "2025-11-25": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-25": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-11-25": 0.1397563888888889,
              "2026-05-26": 0.16539055555555554
            },
            "time_count_per_day": {
              "2025-11-25": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-25": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-11-25": 0.1397563888888889,
                "2026-05-26": 0.16539055555555554
              },
              "time_count_per_day": {
                "2025-11-25": 1,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_574": {
      "overall": {
        "avg_time_hours": 4.75,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-26": 1
        },
        "time_per_day": {
          "2025-11-26": 4.750385277777777
        },
        "time_count_per_day": {
          "2025-11-26": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.75,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-26": 1
          },
          "time_per_day": {
            "2025-11-26": 4.750385277777777
          },
          "time_count_per_day": {
            "2025-11-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.75,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-26": 1
            },
            "time_per_day": {
              "2025-11-26": 4.750385277777777
            },
            "time_count_per_day": {
              "2025-11-26": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.75,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-26": 1
              },
              "time_per_day": {
                "2025-11-26": 4.750385277777777
              },
              "time_count_per_day": {
                "2025-11-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_573": {
      "overall": {
        "avg_time_hours": 218.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "4-6h": 2,
          "1078-1080h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-11-26": 2,
          "2026-03-13": 1,
          "2026-04-15": 1,
          "2026-04-23": 1,
          "2026-05-28": 1
        },
        "time_per_day": {
          "2025-11-26": 0.5327869444444444,
          "2026-03-13": 4.065282222222222,
          "2026-04-15": 5.933084444444444,
          "2026-04-23": 1079.618258888889
        },
        "time_count_per_day": {
          "2025-11-26": 2,
          "2026-03-13": 1,
          "2026-04-15": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.27,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-26": 2
          },
          "time_per_day": {
            "2025-11-26": 0.5327869444444444
          },
          "time_count_per_day": {
            "2025-11-26": 2
          }
        },
        "P2": {
          "avg_time_hours": 363.21,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "1078-1080h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-13": 1,
            "2026-04-15": 1,
            "2026-04-23": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-03-13": 4.065282222222222,
            "2026-04-15": 5.933084444444444,
            "2026-04-23": 1079.618258888889
          },
          "time_count_per_day": {
            "2026-03-13": 1,
            "2026-04-15": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 218.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "4-6h": 2,
              "1078-1080h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-11-26": 2,
              "2026-03-13": 1,
              "2026-04-15": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-11-26": 0.5327869444444444,
              "2026-03-13": 4.065282222222222,
              "2026-04-15": 5.933084444444444,
              "2026-04-23": 1079.618258888889
            },
            "time_count_per_day": {
              "2025-11-26": 2,
              "2026-03-13": 1,
              "2026-04-15": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.27,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-26": 2
              },
              "time_per_day": {
                "2025-11-26": 0.5327869444444444
              },
              "time_count_per_day": {
                "2025-11-26": 2
              }
            },
            "P2": {
              "avg_time_hours": 363.21,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "1078-1080h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-13": 1,
                "2026-04-15": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-03-13": 4.065282222222222,
                "2026-04-15": 5.933084444444444,
                "2026-04-23": 1079.618258888889
              },
              "time_count_per_day": {
                "2026-03-13": 1,
                "2026-04-15": 1,
                "2026-04-23": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_527": {
      "overall": {
        "avg_time_hours": 248.87,
        "mode_time_hours": 7.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "6-8h": 2,
          "18-20h": 2,
          "22-24h": 1,
          "24-26h": 2,
          "26-28h": 2,
          "50-52h": 1,
          "84-86h": 1,
          "722-724h": 1,
          "906-908h": 1,
          "1046-1048h": 1,
          "1222-1224h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2025-12-13": 1,
          "2025-12-19": 1,
          "2026-01-02": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-28": 2,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-18": 1,
          "2026-03-01": 1,
          "2026-03-06": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-11-27": 23.668839722222224,
          "2025-12-13": 51.08929944444444,
          "2025-12-19": 723.4319316666666,
          "2026-01-02": 7.626338333333333,
          "2026-01-15": 26.663066666666666,
          "2026-01-16": 25.278771944444443,
          "2026-01-28": 39.46164638888889,
          "2026-01-29": 25.345255833333333,
          "2026-01-30": 26.938355833333336,
          "2026-02-18": 1047.712072222222,
          "2026-03-01": 5.153249166666667,
          "2026-03-06": 907.0778583333333,
          "2026-04-21": 5.291781111111111,
          "2026-04-23": 1223.4875416666669,
          "2026-05-04": 85.43126527777778,
          "2026-06-02": 7.068679722222222
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2025-12-13": 1,
          "2025-12-19": 1,
          "2026-01-02": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-01-28": 2,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-18": 1,
          "2026-03-01": 1,
          "2026-03-06": 1,
          "2026-04-21": 1,
          "2026-04-23": 1,
          "2026-05-04": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 143.53,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "6-8h": 2,
            "22-24h": 1,
            "24-26h": 2,
            "26-28h": 1,
            "84-86h": 1,
            "1222-1224h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-01-02": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-03-01": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-11-27": 23.668839722222224,
            "2026-01-02": 7.626338333333333,
            "2026-01-16": 25.278771944444443,
            "2026-01-29": 25.345255833333333,
            "2026-01-30": 26.938355833333336,
            "2026-03-01": 5.153249166666667,
            "2026-04-21": 5.291781111111111,
            "2026-04-23": 1223.4875416666669,
            "2026-05-04": 85.43126527777778,
            "2026-06-02": 7.068679722222222
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-01-02": 1,
            "2026-01-16": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-03-01": 1,
            "2026-04-21": 1,
            "2026-04-23": 1,
            "2026-05-04": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 399.35,
          "mode_time_hours": 19.0,
          "mode_frequency": 2,
          "time_distribution": {
            "18-20h": 2,
            "26-28h": 1,
            "50-52h": 1,
            "722-724h": 1,
            "906-908h": 1,
            "1046-1048h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-12-13": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-01-28": 2,
            "2026-02-18": 1,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2025-12-13": 51.08929944444444,
            "2025-12-19": 723.4319316666666,
            "2026-01-15": 26.663066666666666,
            "2026-01-28": 39.46164638888889,
            "2026-02-18": 1047.712072222222,
            "2026-03-06": 907.0778583333333
          },
          "time_count_per_day": {
            "2025-12-13": 1,
            "2025-12-19": 1,
            "2026-01-15": 1,
            "2026-01-28": 2,
            "2026-02-18": 1,
            "2026-03-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 248.87,
            "mode_time_hours": 7.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "6-8h": 2,
              "18-20h": 2,
              "22-24h": 1,
              "24-26h": 2,
              "26-28h": 2,
              "50-52h": 1,
              "84-86h": 1,
              "722-724h": 1,
              "906-908h": 1,
              "1046-1048h": 1,
              "1222-1224h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2025-12-13": 1,
              "2025-12-19": 1,
              "2026-01-02": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-28": 2,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-18": 1,
              "2026-03-01": 1,
              "2026-03-06": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-27": 23.668839722222224,
              "2025-12-13": 51.08929944444444,
              "2025-12-19": 723.4319316666666,
              "2026-01-02": 7.626338333333333,
              "2026-01-15": 26.663066666666666,
              "2026-01-16": 25.278771944444443,
              "2026-01-28": 39.46164638888889,
              "2026-01-29": 25.345255833333333,
              "2026-01-30": 26.938355833333336,
              "2026-02-18": 1047.712072222222,
              "2026-03-01": 5.153249166666667,
              "2026-03-06": 907.0778583333333,
              "2026-04-21": 5.291781111111111,
              "2026-04-23": 1223.4875416666669,
              "2026-05-04": 85.43126527777778,
              "2026-06-02": 7.068679722222222
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2025-12-13": 1,
              "2025-12-19": 1,
              "2026-01-02": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-01-28": 2,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-18": 1,
              "2026-03-01": 1,
              "2026-03-06": 1,
              "2026-04-21": 1,
              "2026-04-23": 1,
              "2026-05-04": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 143.53,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "6-8h": 2,
                "22-24h": 1,
                "24-26h": 2,
                "26-28h": 1,
                "84-86h": 1,
                "1222-1224h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-01-02": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-03-01": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-11-27": 23.668839722222224,
                "2026-01-02": 7.626338333333333,
                "2026-01-16": 25.278771944444443,
                "2026-01-29": 25.345255833333333,
                "2026-01-30": 26.938355833333336,
                "2026-03-01": 5.153249166666667,
                "2026-04-21": 5.291781111111111,
                "2026-04-23": 1223.4875416666669,
                "2026-05-04": 85.43126527777778,
                "2026-06-02": 7.068679722222222
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-01-02": 1,
                "2026-01-16": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-03-01": 1,
                "2026-04-21": 1,
                "2026-04-23": 1,
                "2026-05-04": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 399.35,
              "mode_time_hours": 19.0,
              "mode_frequency": 2,
              "time_distribution": {
                "18-20h": 2,
                "26-28h": 1,
                "50-52h": 1,
                "722-724h": 1,
                "906-908h": 1,
                "1046-1048h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-12-13": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-01-28": 2,
                "2026-02-18": 1,
                "2026-03-06": 1
              },
              "time_per_day": {
                "2025-12-13": 51.08929944444444,
                "2025-12-19": 723.4319316666666,
                "2026-01-15": 26.663066666666666,
                "2026-01-28": 39.46164638888889,
                "2026-02-18": 1047.712072222222,
                "2026-03-06": 907.0778583333333
              },
              "time_count_per_day": {
                "2025-12-13": 1,
                "2025-12-19": 1,
                "2026-01-15": 1,
                "2026-01-28": 2,
                "2026-02-18": 1,
                "2026-03-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_364": {
      "overall": {
        "avg_time_hours": 218.77,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 1,
          "6-8h": 1,
          "10-12h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "26-28h": 1,
          "28-30h": 1,
          "40-42h": 1,
          "44-46h": 1,
          "84-86h": 1,
          "86-88h": 1,
          "88-90h": 1,
          "96-98h": 1,
          "144-146h": 1,
          "164-166h": 1,
          "166-168h": 2,
          "218-220h": 1,
          "238-240h": 1,
          "352-354h": 1,
          "410-412h": 1,
          "506-508h": 1,
          "578-580h": 1,
          "582-584h": 1,
          "604-606h": 1,
          "810-812h": 1,
          "1268-1270h": 1
        },
        "tickets_count": 35,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2025-12-26": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-08": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-19": 2,
          "2026-03-10": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-09": 1,
          "2026-04-16": 1,
          "2026-04-24": 1,
          "2026-05-07": 2,
          "2026-05-14": 2,
          "2026-05-18": 1,
          "2026-05-22": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-11-27": 20.334100833333334,
          "2025-12-04": 26.141259444444444,
          "2025-12-10": 167.11623250000002,
          "2025-12-11": 96.61756416666667,
          "2025-12-17": 45.63903138888889,
          "2025-12-19": 1160.9136033333334,
          "2025-12-26": 238.8439052777778,
          "2026-01-05": 507.7995005555556,
          "2026-01-06": 333.27675888888893,
          "2026-01-08": 0.30756083333333334,
          "2026-02-03": 6.069664444444445,
          "2026-02-09": 89.46196555555555,
          "2026-02-10": 144.93247055555554,
          "2026-02-12": 85.44678777777777,
          "2026-02-19": 18.37773111111111,
          "2026-03-10": 40.14706611111111,
          "2026-03-17": 1268.3360661111112,
          "2026-03-18": 1.5991413888888888,
          "2026-03-19": 10.192121944444445,
          "2026-03-20": 28.63942888888889,
          "2026-03-25": 811.8817580555556,
          "2026-03-26": 219.38792694444444,
          "2026-04-09": 3.0484175,
          "2026-04-16": 352.97287694444447,
          "2026-04-24": 1.6922483333333334,
          "2026-05-14": 411.44026,
          "2026-05-22": 86.81775416666666,
          "2026-05-30": 604.5862802777779
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2025-12-04": 1,
          "2025-12-10": 1,
          "2025-12-11": 1,
          "2025-12-17": 1,
          "2025-12-19": 2,
          "2025-12-26": 1,
          "2026-01-05": 1,
          "2026-01-06": 2,
          "2026-01-08": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-19": 2,
          "2026-03-10": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-09": 1,
          "2026-04-16": 1,
          "2026-04-24": 1,
          "2026-05-14": 1,
          "2026-05-22": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 604.59,
          "mode_time_hours": 605.0,
          "mode_frequency": 1,
          "time_distribution": {
            "604-606h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 604.5862802777779
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        },
        "P2": {
          "avg_time_hours": 234.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "10-12h": 1,
            "20-22h": 1,
            "26-28h": 1,
            "28-30h": 1,
            "40-42h": 1,
            "44-46h": 1,
            "86-88h": 1,
            "96-98h": 1,
            "144-146h": 1,
            "164-166h": 1,
            "166-168h": 2,
            "218-220h": 1,
            "238-240h": 1,
            "352-354h": 1,
            "410-412h": 1,
            "506-508h": 1,
            "578-580h": 1,
            "810-812h": 1,
            "1268-1270h": 1
          },
          "tickets_count": 27,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-26": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-08": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-04-16": 1,
            "2026-04-24": 1,
            "2026-05-07": 2,
            "2026-05-14": 2,
            "2026-05-18": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2025-11-27": 20.334100833333334,
            "2025-12-04": 26.141259444444444,
            "2025-12-10": 167.11623250000002,
            "2025-12-11": 96.61756416666667,
            "2025-12-17": 45.63903138888889,
            "2025-12-19": 578.7937347222222,
            "2025-12-26": 238.8439052777778,
            "2026-01-05": 507.7995005555556,
            "2026-01-06": 333.27675888888893,
            "2026-01-08": 0.30756083333333334,
            "2026-02-10": 144.93247055555554,
            "2026-03-10": 40.14706611111111,
            "2026-03-17": 1268.3360661111112,
            "2026-03-18": 1.5991413888888888,
            "2026-03-19": 10.192121944444445,
            "2026-03-20": 28.63942888888889,
            "2026-03-25": 811.8817580555556,
            "2026-03-26": 219.38792694444444,
            "2026-04-16": 352.97287694444447,
            "2026-04-24": 1.6922483333333334,
            "2026-05-14": 411.44026,
            "2026-05-22": 86.81775416666666
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2025-12-04": 1,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-17": 1,
            "2025-12-19": 1,
            "2025-12-26": 1,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-08": 1,
            "2026-02-10": 1,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-04-16": 1,
            "2026-04-24": 1,
            "2026-05-14": 1,
            "2026-05-22": 1
          }
        },
        "P3": {
          "avg_time_hours": 112.07,
          "mode_time_hours": 583.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "6-8h": 1,
            "18-20h": 1,
            "84-86h": 1,
            "88-90h": 1,
            "582-584h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-19": 2,
            "2026-04-09": 1
          },
          "time_per_day": {
            "2025-12-19": 582.1198686111111,
            "2026-02-03": 6.069664444444445,
            "2026-02-09": 89.46196555555555,
            "2026-02-12": 85.44678777777777,
            "2026-02-19": 18.37773111111111,
            "2026-04-09": 3.0484175
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-12": 1,
            "2026-02-19": 2,
            "2026-04-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 218.77,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 1,
              "6-8h": 1,
              "10-12h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "26-28h": 1,
              "28-30h": 1,
              "40-42h": 1,
              "44-46h": 1,
              "84-86h": 1,
              "86-88h": 1,
              "88-90h": 1,
              "96-98h": 1,
              "144-146h": 1,
              "164-166h": 1,
              "166-168h": 2,
              "218-220h": 1,
              "238-240h": 1,
              "352-354h": 1,
              "410-412h": 1,
              "506-508h": 1,
              "578-580h": 1,
              "582-584h": 1,
              "604-606h": 1,
              "810-812h": 1,
              "1268-1270h": 1
            },
            "tickets_count": 31,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2025-12-26": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-08": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-19": 2,
              "2026-03-10": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-09": 1,
              "2026-04-16": 1,
              "2026-04-24": 1,
              "2026-05-14": 1,
              "2026-05-22": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-11-27": 20.334100833333334,
              "2025-12-04": 26.141259444444444,
              "2025-12-10": 167.11623250000002,
              "2025-12-11": 96.61756416666667,
              "2025-12-17": 45.63903138888889,
              "2025-12-19": 1160.9136033333334,
              "2025-12-26": 238.8439052777778,
              "2026-01-05": 507.7995005555556,
              "2026-01-06": 333.27675888888893,
              "2026-01-08": 0.30756083333333334,
              "2026-02-03": 6.069664444444445,
              "2026-02-09": 89.46196555555555,
              "2026-02-10": 144.93247055555554,
              "2026-02-12": 85.44678777777777,
              "2026-02-19": 18.37773111111111,
              "2026-03-10": 40.14706611111111,
              "2026-03-17": 1268.3360661111112,
              "2026-03-18": 1.5991413888888888,
              "2026-03-19": 10.192121944444445,
              "2026-03-20": 28.63942888888889,
              "2026-03-25": 811.8817580555556,
              "2026-03-26": 219.38792694444444,
              "2026-04-09": 3.0484175,
              "2026-04-16": 352.97287694444447,
              "2026-04-24": 1.6922483333333334,
              "2026-05-14": 411.44026,
              "2026-05-22": 86.81775416666666,
              "2026-05-30": 604.5862802777779
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2025-12-04": 1,
              "2025-12-10": 1,
              "2025-12-11": 1,
              "2025-12-17": 1,
              "2025-12-19": 2,
              "2025-12-26": 1,
              "2026-01-05": 1,
              "2026-01-06": 2,
              "2026-01-08": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-19": 2,
              "2026-03-10": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-09": 1,
              "2026-04-16": 1,
              "2026-04-24": 1,
              "2026-05-14": 1,
              "2026-05-22": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 604.59,
              "mode_time_hours": 605.0,
              "mode_frequency": 1,
              "time_distribution": {
                "604-606h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 604.5862802777779
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            },
            "P2": {
              "avg_time_hours": 234.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "10-12h": 1,
                "20-22h": 1,
                "26-28h": 1,
                "28-30h": 1,
                "40-42h": 1,
                "44-46h": 1,
                "86-88h": 1,
                "96-98h": 1,
                "144-146h": 1,
                "164-166h": 1,
                "166-168h": 2,
                "218-220h": 1,
                "238-240h": 1,
                "352-354h": 1,
                "410-412h": 1,
                "506-508h": 1,
                "578-580h": 1,
                "810-812h": 1,
                "1268-1270h": 1
              },
              "tickets_count": 23,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-26": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-08": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-04-16": 1,
                "2026-04-24": 1,
                "2026-05-14": 1,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2025-11-27": 20.334100833333334,
                "2025-12-04": 26.141259444444444,
                "2025-12-10": 167.11623250000002,
                "2025-12-11": 96.61756416666667,
                "2025-12-17": 45.63903138888889,
                "2025-12-19": 578.7937347222222,
                "2025-12-26": 238.8439052777778,
                "2026-01-05": 507.7995005555556,
                "2026-01-06": 333.27675888888893,
                "2026-01-08": 0.30756083333333334,
                "2026-02-10": 144.93247055555554,
                "2026-03-10": 40.14706611111111,
                "2026-03-17": 1268.3360661111112,
                "2026-03-18": 1.5991413888888888,
                "2026-03-19": 10.192121944444445,
                "2026-03-20": 28.63942888888889,
                "2026-03-25": 811.8817580555556,
                "2026-03-26": 219.38792694444444,
                "2026-04-16": 352.97287694444447,
                "2026-04-24": 1.6922483333333334,
                "2026-05-14": 411.44026,
                "2026-05-22": 86.81775416666666
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2025-12-04": 1,
                "2025-12-10": 1,
                "2025-12-11": 1,
                "2025-12-17": 1,
                "2025-12-19": 1,
                "2025-12-26": 1,
                "2026-01-05": 1,
                "2026-01-06": 2,
                "2026-01-08": 1,
                "2026-02-10": 1,
                "2026-03-10": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-25": 1,
                "2026-03-26": 1,
                "2026-04-16": 1,
                "2026-04-24": 1,
                "2026-05-14": 1,
                "2026-05-22": 1
              }
            },
            "P3": {
              "avg_time_hours": 112.07,
              "mode_time_hours": 583.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "6-8h": 1,
                "18-20h": 1,
                "84-86h": 1,
                "88-90h": 1,
                "582-584h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-19": 2,
                "2026-04-09": 1
              },
              "time_per_day": {
                "2025-12-19": 582.1198686111111,
                "2026-02-03": 6.069664444444445,
                "2026-02-09": 89.46196555555555,
                "2026-02-12": 85.44678777777777,
                "2026-02-19": 18.37773111111111,
                "2026-04-09": 3.0484175
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-02-03": 1,
                "2026-02-09": 1,
                "2026-02-12": 1,
                "2026-02-19": 2,
                "2026-04-09": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-07": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-07": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_576": {
      "overall": {
        "avg_time_hours": 22.86,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 1,
          "48-50h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2026-01-21": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-27": 19.05793388888889,
          "2026-01-21": 49.015458611111114,
          "2026-06-03": 0.5011119444444444
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2026-01-21": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 9.78,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "18-20h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-27": 19.05793388888889,
            "2026-06-03": 0.5011119444444444
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 49.02,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 49.015458611111114
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 22.86,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 1,
              "48-50h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2026-01-21": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-27": 19.05793388888889,
              "2026-01-21": 49.015458611111114,
              "2026-06-03": 0.5011119444444444
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2026-01-21": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.78,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "18-20h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-27": 19.05793388888889,
                "2026-06-03": 0.5011119444444444
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 49.02,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 49.015458611111114
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_577": {
      "overall": {
        "avg_time_hours": 18.63,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-27": 1
        },
        "time_per_day": {
          "2025-11-27": 18.631533333333334
        },
        "time_count_per_day": {
          "2025-11-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 18.63,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {
            "2025-11-27": 18.631533333333334
          },
          "time_count_per_day": {
            "2025-11-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 18.63,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-27": 1
            },
            "time_per_day": {
              "2025-11-27": 18.631533333333334
            },
            "time_count_per_day": {
              "2025-11-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 18.63,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-27": 18.631533333333334
              },
              "time_count_per_day": {
                "2025-11-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_578": {
      "overall": {
        "avg_time_hours": 0.71,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-11-26": 1,
          "2026-05-30": 2
        },
        "time_per_day": {
          "2025-11-26": 1.7572477777777777,
          "2026-05-30": 0.3653486111111111
        },
        "time_count_per_day": {
          "2025-11-26": 1,
          "2026-05-30": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.71,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-26": 1,
            "2026-05-30": 2
          },
          "time_per_day": {
            "2025-11-26": 1.7572477777777777,
            "2026-05-30": 0.3653486111111111
          },
          "time_count_per_day": {
            "2025-11-26": 1,
            "2026-05-30": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.71,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-26": 1,
              "2026-05-30": 2
            },
            "time_per_day": {
              "2025-11-26": 1.7572477777777777,
              "2026-05-30": 0.3653486111111111
            },
            "time_count_per_day": {
              "2025-11-26": 1,
              "2026-05-30": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.71,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-11-26": 1,
                "2026-05-30": 2
              },
              "time_per_day": {
                "2025-11-26": 1.7572477777777777,
                "2026-05-30": 0.3653486111111111
              },
              "time_count_per_day": {
                "2025-11-26": 1,
                "2026-05-30": 2
              }
            }
          }
        }
      }
    },
    "cliente_579": {
      "overall": {
        "avg_time_hours": 114.29,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 2,
          "4-6h": 2,
          "8-10h": 2,
          "10-12h": 3,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "28-30h": 1,
          "32-34h": 1,
          "34-36h": 1,
          "36-38h": 1,
          "54-56h": 1,
          "64-66h": 2,
          "72-74h": 1,
          "76-78h": 2,
          "190-192h": 1,
          "282-284h": 1,
          "284-286h": 2,
          "286-288h": 1,
          "454-456h": 1,
          "474-476h": 1,
          "648-650h": 1,
          "866-868h": 1
        },
        "tickets_count": 43,
        "tickets_per_day": {
          "2025-11-26": 1,
          "2025-12-28": 1,
          "2026-01-05": 2,
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-02-02": 1,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-09": 1,
          "2026-02-10": 3,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-02-26": 1,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-10": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-26": 1,
          "2026-05-06": 2,
          "2026-05-11": 1,
          "2026-05-15": 2,
          "2026-05-18": 2,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-29": 1,
          "2026-06-01": 2,
          "2026-06-02": 1,
          "2026-06-05": 2,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2025-11-26": 0.21389972222222223,
          "2025-12-28": 19.969942500000002,
          "2026-01-05": 130.69208694444444,
          "2026-01-08": 0.08142222222222223,
          "2026-01-09": 0.22053833333333334,
          "2026-02-02": 1.1085927777777778,
          "2026-02-04": 37.59851888888889,
          "2026-02-05": 1.499174722222222,
          "2026-02-09": 284.910015,
          "2026-02-10": 757.6216202777778,
          "2026-02-16": 455.78367305555554,
          "2026-02-24": 2.114790277777778,
          "2026-02-26": 34.79779194444445,
          "2026-03-04": 23.519853055555554,
          "2026-03-05": 648.2220597222222,
          "2026-03-10": 43.68518888888889,
          "2026-03-17": 866.1602619444444,
          "2026-03-20": 5.324588333333334,
          "2026-03-23": 552.0063005555556,
          "2026-03-26": 76.18146194444444,
          "2026-05-06": 287.0428180555556,
          "2026-05-11": 54.97647083333334,
          "2026-05-15": 3.117223055555556,
          "2026-05-18": 19.58756916666667,
          "2026-05-20": 29.2763175,
          "2026-05-21": 73.19751027777778,
          "2026-05-29": 5.900988055555556,
          "2026-06-01": 8.502150833333333,
          "2026-06-02": 32.66028527777778,
          "2026-06-05": 1.1605205555555556
        },
        "time_count_per_day": {
          "2025-11-26": 1,
          "2025-12-28": 1,
          "2026-01-05": 2,
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-02-02": 1,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-09": 1,
          "2026-02-10": 3,
          "2026-02-16": 1,
          "2026-02-24": 1,
          "2026-02-26": 1,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-10": 2,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-03-23": 2,
          "2026-03-26": 1,
          "2026-05-06": 1,
          "2026-05-11": 1,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-20": 1,
          "2026-05-21": 1,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 115.28,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 2,
            "4-6h": 2,
            "8-10h": 2,
            "10-12h": 3,
            "18-20h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "28-30h": 1,
            "32-34h": 1,
            "34-36h": 1,
            "36-38h": 1,
            "54-56h": 1,
            "64-66h": 2,
            "72-74h": 1,
            "76-78h": 2,
            "282-284h": 1,
            "284-286h": 2,
            "286-288h": 1,
            "454-456h": 1,
            "474-476h": 1,
            "648-650h": 1,
            "866-868h": 1
          },
          "tickets_count": 40,
          "tickets_per_day": {
            "2025-11-26": 1,
            "2025-12-28": 1,
            "2026-01-05": 2,
            "2026-01-08": 1,
            "2026-01-09": 1,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-03-04": 2,
            "2026-03-05": 1,
            "2026-03-10": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-03-26": 1,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-15": 2,
            "2026-05-18": 2,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-29": 1,
            "2026-06-01": 2,
            "2026-06-02": 1,
            "2026-06-05": 2,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2025-11-26": 0.21389972222222223,
            "2025-12-28": 19.969942500000002,
            "2026-01-05": 130.69208694444444,
            "2026-01-08": 0.08142222222222223,
            "2026-01-09": 0.22053833333333334,
            "2026-02-04": 37.59851888888889,
            "2026-02-05": 1.499174722222222,
            "2026-02-09": 284.910015,
            "2026-02-10": 567.0412305555556,
            "2026-02-16": 455.78367305555554,
            "2026-02-24": 2.114790277777778,
            "2026-02-26": 34.79779194444445,
            "2026-03-04": 23.519853055555554,
            "2026-03-05": 648.2220597222222,
            "2026-03-10": 43.68518888888889,
            "2026-03-17": 866.1602619444444,
            "2026-03-20": 5.324588333333334,
            "2026-03-23": 552.0063005555556,
            "2026-03-26": 76.18146194444444,
            "2026-05-06": 287.0428180555556,
            "2026-05-11": 54.97647083333334,
            "2026-05-15": 3.117223055555556,
            "2026-05-18": 19.58756916666667,
            "2026-05-20": 29.2763175,
            "2026-05-21": 73.19751027777778,
            "2026-05-29": 5.900988055555556,
            "2026-06-01": 8.502150833333333,
            "2026-06-02": 32.66028527777778,
            "2026-06-05": 1.1605205555555556
          },
          "time_count_per_day": {
            "2025-11-26": 1,
            "2025-12-28": 1,
            "2026-01-05": 2,
            "2026-01-08": 1,
            "2026-01-09": 1,
            "2026-02-04": 1,
            "2026-02-05": 2,
            "2026-02-09": 1,
            "2026-02-10": 2,
            "2026-02-16": 1,
            "2026-02-24": 1,
            "2026-02-26": 1,
            "2026-03-04": 2,
            "2026-03-05": 1,
            "2026-03-10": 2,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-03-23": 2,
            "2026-03-26": 1,
            "2026-05-06": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-18": 2,
            "2026-05-20": 1,
            "2026-05-21": 1,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1,
            "2026-06-05": 2
          }
        },
        "P3": {
          "avg_time_hours": 95.84,
          "mode_time_hours": 191.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "190-192h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-02": 1,
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-02": 1.1085927777777778,
            "2026-02-10": 190.58038972222224
          },
          "time_count_per_day": {
            "2026-02-02": 1,
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 114.29,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 2,
              "4-6h": 2,
              "8-10h": 2,
              "10-12h": 3,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "28-30h": 1,
              "32-34h": 1,
              "34-36h": 1,
              "36-38h": 1,
              "54-56h": 1,
              "64-66h": 2,
              "72-74h": 1,
              "76-78h": 2,
              "190-192h": 1,
              "282-284h": 1,
              "284-286h": 2,
              "286-288h": 1,
              "454-456h": 1,
              "474-476h": 1,
              "648-650h": 1,
              "866-868h": 1
            },
            "tickets_count": 39,
            "tickets_per_day": {
              "2025-11-26": 1,
              "2025-12-28": 1,
              "2026-01-05": 2,
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-02-02": 1,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-09": 1,
              "2026-02-10": 3,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-03-04": 2,
              "2026-03-05": 1,
              "2026-03-10": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-26": 1,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 2
            },
            "time_per_day": {
              "2025-11-26": 0.21389972222222223,
              "2025-12-28": 19.969942500000002,
              "2026-01-05": 130.69208694444444,
              "2026-01-08": 0.08142222222222223,
              "2026-01-09": 0.22053833333333334,
              "2026-02-02": 1.1085927777777778,
              "2026-02-04": 37.59851888888889,
              "2026-02-05": 1.499174722222222,
              "2026-02-09": 284.910015,
              "2026-02-10": 757.6216202777778,
              "2026-02-16": 455.78367305555554,
              "2026-02-24": 2.114790277777778,
              "2026-02-26": 34.79779194444445,
              "2026-03-04": 23.519853055555554,
              "2026-03-05": 648.2220597222222,
              "2026-03-10": 43.68518888888889,
              "2026-03-17": 866.1602619444444,
              "2026-03-20": 5.324588333333334,
              "2026-03-23": 552.0063005555556,
              "2026-03-26": 76.18146194444444,
              "2026-05-06": 287.0428180555556,
              "2026-05-11": 54.97647083333334,
              "2026-05-15": 3.117223055555556,
              "2026-05-18": 19.58756916666667,
              "2026-05-20": 29.2763175,
              "2026-05-21": 73.19751027777778,
              "2026-05-29": 5.900988055555556,
              "2026-06-01": 8.502150833333333,
              "2026-06-02": 32.66028527777778,
              "2026-06-05": 1.1605205555555556
            },
            "time_count_per_day": {
              "2025-11-26": 1,
              "2025-12-28": 1,
              "2026-01-05": 2,
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-02-02": 1,
              "2026-02-04": 1,
              "2026-02-05": 2,
              "2026-02-09": 1,
              "2026-02-10": 3,
              "2026-02-16": 1,
              "2026-02-24": 1,
              "2026-02-26": 1,
              "2026-03-04": 2,
              "2026-03-05": 1,
              "2026-03-10": 2,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-03-23": 2,
              "2026-03-26": 1,
              "2026-05-06": 1,
              "2026-05-11": 1,
              "2026-05-15": 1,
              "2026-05-18": 2,
              "2026-05-20": 1,
              "2026-05-21": 1,
              "2026-05-29": 1,
              "2026-06-01": 1,
              "2026-06-02": 1,
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 115.28,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 2,
                "4-6h": 2,
                "8-10h": 2,
                "10-12h": 3,
                "18-20h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "28-30h": 1,
                "32-34h": 1,
                "34-36h": 1,
                "36-38h": 1,
                "54-56h": 1,
                "64-66h": 2,
                "72-74h": 1,
                "76-78h": 2,
                "282-284h": 1,
                "284-286h": 2,
                "286-288h": 1,
                "454-456h": 1,
                "474-476h": 1,
                "648-650h": 1,
                "866-868h": 1
              },
              "tickets_count": 37,
              "tickets_per_day": {
                "2025-11-26": 1,
                "2025-12-28": 1,
                "2026-01-05": 2,
                "2026-01-08": 1,
                "2026-01-09": 1,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-04": 2,
                "2026-03-05": 1,
                "2026-03-10": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-03-26": 1,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-11-26": 0.21389972222222223,
                "2025-12-28": 19.969942500000002,
                "2026-01-05": 130.69208694444444,
                "2026-01-08": 0.08142222222222223,
                "2026-01-09": 0.22053833333333334,
                "2026-02-04": 37.59851888888889,
                "2026-02-05": 1.499174722222222,
                "2026-02-09": 284.910015,
                "2026-02-10": 567.0412305555556,
                "2026-02-16": 455.78367305555554,
                "2026-02-24": 2.114790277777778,
                "2026-02-26": 34.79779194444445,
                "2026-03-04": 23.519853055555554,
                "2026-03-05": 648.2220597222222,
                "2026-03-10": 43.68518888888889,
                "2026-03-17": 866.1602619444444,
                "2026-03-20": 5.324588333333334,
                "2026-03-23": 552.0063005555556,
                "2026-03-26": 76.18146194444444,
                "2026-05-06": 287.0428180555556,
                "2026-05-11": 54.97647083333334,
                "2026-05-15": 3.117223055555556,
                "2026-05-18": 19.58756916666667,
                "2026-05-20": 29.2763175,
                "2026-05-21": 73.19751027777778,
                "2026-05-29": 5.900988055555556,
                "2026-06-01": 8.502150833333333,
                "2026-06-02": 32.66028527777778,
                "2026-06-05": 1.1605205555555556
              },
              "time_count_per_day": {
                "2025-11-26": 1,
                "2025-12-28": 1,
                "2026-01-05": 2,
                "2026-01-08": 1,
                "2026-01-09": 1,
                "2026-02-04": 1,
                "2026-02-05": 2,
                "2026-02-09": 1,
                "2026-02-10": 2,
                "2026-02-16": 1,
                "2026-02-24": 1,
                "2026-02-26": 1,
                "2026-03-04": 2,
                "2026-03-05": 1,
                "2026-03-10": 2,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-03-23": 2,
                "2026-03-26": 1,
                "2026-05-06": 1,
                "2026-05-11": 1,
                "2026-05-15": 1,
                "2026-05-18": 2,
                "2026-05-20": 1,
                "2026-05-21": 1,
                "2026-05-29": 1,
                "2026-06-01": 1,
                "2026-06-02": 1,
                "2026-06-05": 2
              }
            },
            "P3": {
              "avg_time_hours": 95.84,
              "mode_time_hours": 191.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "190-192h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-02": 1,
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-02": 1.1085927777777778,
                "2026-02-10": 190.58038972222224
              },
              "time_count_per_day": {
                "2026-02-02": 1,
                "2026-02-10": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-06": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-15": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Carolina Ferreirinha": {
      "overall": {
        "avg_time_hours": 65.9,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "6-8h": 1,
          "316-318h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-12-04": 1,
          "2025-12-10": 2,
          "2026-02-13": 1,
          "2026-03-17": 1
        },
        "time_per_day": {
          "2025-12-04": 6.352354722222222,
          "2025-12-10": 318.2478697222223,
          "2026-02-13": 3.4404697222222222,
          "2026-03-17": 1.4391469444444445
        },
        "time_count_per_day": {
          "2025-12-04": 1,
          "2025-12-10": 2,
          "2026-02-13": 1,
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.72,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-10": 1,
            "2026-02-13": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2025-12-10": 0.27976388888888887,
            "2026-02-13": 3.4404697222222222,
            "2026-03-17": 1.4391469444444445
          },
          "time_count_per_day": {
            "2025-12-10": 1,
            "2026-02-13": 1,
            "2026-03-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 162.16,
          "mode_time_hours": 317.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "316-318h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-04": 1,
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-12-04": 6.352354722222222,
            "2025-12-10": 317.96810583333337
          },
          "time_count_per_day": {
            "2025-12-04": 1,
            "2025-12-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 65.9,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "6-8h": 1,
              "316-318h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-12-04": 1,
              "2025-12-10": 2,
              "2026-02-13": 1,
              "2026-03-17": 1
            },
            "time_per_day": {
              "2025-12-04": 6.352354722222222,
              "2025-12-10": 318.2478697222223,
              "2026-02-13": 3.4404697222222222,
              "2026-03-17": 1.4391469444444445
            },
            "time_count_per_day": {
              "2025-12-04": 1,
              "2025-12-10": 2,
              "2026-02-13": 1,
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.72,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-10": 1,
                "2026-02-13": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2025-12-10": 0.27976388888888887,
                "2026-02-13": 3.4404697222222222,
                "2026-03-17": 1.4391469444444445
              },
              "time_count_per_day": {
                "2025-12-10": 1,
                "2026-02-13": 1,
                "2026-03-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 162.16,
              "mode_time_hours": 317.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "316-318h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-04": 1,
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-12-04": 6.352354722222222,
                "2025-12-10": 317.96810583333337
              },
              "time_count_per_day": {
                "2025-12-04": 1,
                "2025-12-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_580": {
      "overall": {
        "avg_time_hours": 27.0,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-28": 1
        },
        "time_per_day": {
          "2025-11-28": 26.998956944444444
        },
        "time_count_per_day": {
          "2025-11-28": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 27.0,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-28": 1
          },
          "time_per_day": {
            "2025-11-28": 26.998956944444444
          },
          "time_count_per_day": {
            "2025-11-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 27.0,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-28": 1
            },
            "time_per_day": {
              "2025-11-28": 26.998956944444444
            },
            "time_count_per_day": {
              "2025-11-28": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 27.0,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-28": 1
              },
              "time_per_day": {
                "2025-11-28": 26.998956944444444
              },
              "time_count_per_day": {
                "2025-11-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_581": {
      "overall": {
        "avg_time_hours": 2.26,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-27": 1
        },
        "time_per_day": {
          "2025-11-27": 2.259969722222222
        },
        "time_count_per_day": {
          "2025-11-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.26,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {
            "2025-11-27": 2.259969722222222
          },
          "time_count_per_day": {
            "2025-11-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.26,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-27": 1
            },
            "time_per_day": {
              "2025-11-27": 2.259969722222222
            },
            "time_count_per_day": {
              "2025-11-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.26,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-27": 1
              },
              "time_per_day": {
                "2025-11-27": 2.259969722222222
              },
              "time_count_per_day": {
                "2025-11-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_583": {
      "overall": {
        "avg_time_hours": 162.15,
        "mode_time_hours": 163.0,
        "mode_frequency": 1,
        "time_distribution": {
          "162-164h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-04": 1
        },
        "time_per_day": {
          "2025-12-04": 162.14741694444444
        },
        "time_count_per_day": {
          "2025-12-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 162.15,
          "mode_time_hours": 163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "162-164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-12-04": 162.14741694444444
          },
          "time_count_per_day": {
            "2025-12-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 162.15,
            "mode_time_hours": 163.0,
            "mode_frequency": 1,
            "time_distribution": {
              "162-164h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-04": 1
            },
            "time_per_day": {
              "2025-12-04": 162.14741694444444
            },
            "time_count_per_day": {
              "2025-12-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 162.15,
              "mode_time_hours": 163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "162-164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-12-04": 162.14741694444444
              },
              "time_count_per_day": {
                "2025-12-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_585": {
      "overall": {
        "avg_time_hours": 1.35,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 1,
          "4-6h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2026-01-13": 1,
          "2026-01-21": 2,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-02-12": 1,
          "2026-05-12": 1,
          "2026-05-30": 2
        },
        "time_per_day": {
          "2025-11-27": 0.5467319444444444,
          "2026-01-13": 0.9563677777777778,
          "2026-01-21": 1.6185533333333333,
          "2026-01-22": 3.3989352777777775,
          "2026-01-26": 5.743899166666667,
          "2026-02-12": 1.130416111111111,
          "2026-05-12": 0.03539222222222222,
          "2026-05-30": 0.0278075
        },
        "time_count_per_day": {
          "2025-11-27": 1,
          "2026-01-13": 1,
          "2026-01-21": 2,
          "2026-01-22": 1,
          "2026-01-26": 1,
          "2026-02-12": 1,
          "2026-05-12": 1,
          "2026-05-30": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.35,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 1,
            "4-6h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2025-11-27": 1,
            "2026-01-13": 1,
            "2026-01-21": 2,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-02-12": 1,
            "2026-05-12": 1,
            "2026-05-30": 2
          },
          "time_per_day": {
            "2025-11-27": 0.5467319444444444,
            "2026-01-13": 0.9563677777777778,
            "2026-01-21": 1.6185533333333333,
            "2026-01-22": 3.3989352777777775,
            "2026-01-26": 5.743899166666667,
            "2026-02-12": 1.130416111111111,
            "2026-05-12": 0.03539222222222222,
            "2026-05-30": 0.0278075
          },
          "time_count_per_day": {
            "2025-11-27": 1,
            "2026-01-13": 1,
            "2026-01-21": 2,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-02-12": 1,
            "2026-05-12": 1,
            "2026-05-30": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.35,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 1,
              "4-6h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-11-27": 1,
              "2026-01-13": 1,
              "2026-01-21": 2,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-02-12": 1,
              "2026-05-12": 1,
              "2026-05-30": 2
            },
            "time_per_day": {
              "2025-11-27": 0.5467319444444444,
              "2026-01-13": 0.9563677777777778,
              "2026-01-21": 1.6185533333333333,
              "2026-01-22": 3.3989352777777775,
              "2026-01-26": 5.743899166666667,
              "2026-02-12": 1.130416111111111,
              "2026-05-12": 0.03539222222222222,
              "2026-05-30": 0.0278075
            },
            "time_count_per_day": {
              "2025-11-27": 1,
              "2026-01-13": 1,
              "2026-01-21": 2,
              "2026-01-22": 1,
              "2026-01-26": 1,
              "2026-02-12": 1,
              "2026-05-12": 1,
              "2026-05-30": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.35,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 1,
                "4-6h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-11-27": 1,
                "2026-01-13": 1,
                "2026-01-21": 2,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-02-12": 1,
                "2026-05-12": 1,
                "2026-05-30": 2
              },
              "time_per_day": {
                "2025-11-27": 0.5467319444444444,
                "2026-01-13": 0.9563677777777778,
                "2026-01-21": 1.6185533333333333,
                "2026-01-22": 3.3989352777777775,
                "2026-01-26": 5.743899166666667,
                "2026-02-12": 1.130416111111111,
                "2026-05-12": 0.03539222222222222,
                "2026-05-30": 0.0278075
              },
              "time_count_per_day": {
                "2025-11-27": 1,
                "2026-01-13": 1,
                "2026-01-21": 2,
                "2026-01-22": 1,
                "2026-01-26": 1,
                "2026-02-12": 1,
                "2026-05-12": 1,
                "2026-05-30": 2
              }
            }
          }
        }
      }
    },
    "cliente_586": {
      "overall": {
        "avg_time_hours": 19.4,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-28": 1
        },
        "time_per_day": {
          "2025-11-28": 19.404611111111112
        },
        "time_count_per_day": {
          "2025-11-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 19.4,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-28": 1
          },
          "time_per_day": {
            "2025-11-28": 19.404611111111112
          },
          "time_count_per_day": {
            "2025-11-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.4,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-28": 1
            },
            "time_per_day": {
              "2025-11-28": 19.404611111111112
            },
            "time_count_per_day": {
              "2025-11-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 19.4,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-28": 1
              },
              "time_per_day": {
                "2025-11-28": 19.404611111111112
              },
              "time_count_per_day": {
                "2025-11-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_588": {
      "overall": {
        "avg_time_hours": 5.95,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 2,
          "16-18h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-28": 1,
          "2026-02-06": 1,
          "2026-05-27": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-11-28": 3.5240386111111115,
          "2026-02-06": 1.527673611111111,
          "2026-05-27": 2.2925,
          "2026-06-02": 16.47525138888889
        },
        "time_count_per_day": {
          "2025-11-28": 1,
          "2026-02-06": 1,
          "2026-05-27": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.95,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2,
            "16-18h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-02-06": 1,
            "2026-05-27": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-11-28": 3.5240386111111115,
            "2026-02-06": 1.527673611111111,
            "2026-05-27": 2.2925,
            "2026-06-02": 16.47525138888889
          },
          "time_count_per_day": {
            "2025-11-28": 1,
            "2026-02-06": 1,
            "2026-05-27": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.95,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 2,
              "16-18h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-11-28": 1,
              "2026-02-06": 1,
              "2026-05-27": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2025-11-28": 3.5240386111111115,
              "2026-02-06": 1.527673611111111,
              "2026-05-27": 2.2925,
              "2026-06-02": 16.47525138888889
            },
            "time_count_per_day": {
              "2025-11-28": 1,
              "2026-02-06": 1,
              "2026-05-27": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.95,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2,
                "16-18h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-11-28": 1,
                "2026-02-06": 1,
                "2026-05-27": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2025-11-28": 3.5240386111111115,
                "2026-02-06": 1.527673611111111,
                "2026-05-27": 2.2925,
                "2026-06-02": 16.47525138888889
              },
              "time_count_per_day": {
                "2025-11-28": 1,
                "2026-02-06": 1,
                "2026-05-27": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_593": {
      "overall": {
        "avg_time_hours": 31.78,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "30-32h": 1,
          "154-156h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-11-29": 1,
          "2026-01-28": 1,
          "2026-02-06": 1,
          "2026-04-09": 1,
          "2026-05-13": 1,
          "2026-05-14": 1
        },
        "time_per_day": {
          "2025-11-29": 1.2824063888888888,
          "2026-01-28": 0.4589347222222222,
          "2026-02-06": 155.58439777777778,
          "2026-04-09": 1.0909219444444445,
          "2026-05-13": 30.636013611111114,
          "2026-05-14": 1.6568961111111111
        },
        "time_count_per_day": {
          "2025-11-29": 1,
          "2026-01-28": 1,
          "2026-02-06": 1,
          "2026-04-09": 1,
          "2026-05-13": 1,
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "30-32h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-11-29": 1,
            "2026-01-28": 1,
            "2026-04-09": 1,
            "2026-05-13": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2025-11-29": 1.2824063888888888,
            "2026-01-28": 0.4589347222222222,
            "2026-04-09": 1.0909219444444445,
            "2026-05-13": 30.636013611111114,
            "2026-05-14": 1.6568961111111111
          },
          "time_count_per_day": {
            "2025-11-29": 1,
            "2026-01-28": 1,
            "2026-04-09": 1,
            "2026-05-13": 1,
            "2026-05-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 155.58,
          "mode_time_hours": 155.0,
          "mode_frequency": 1,
          "time_distribution": {
            "154-156h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 155.58439777777778
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 31.78,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "30-32h": 1,
              "154-156h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-11-29": 1,
              "2026-01-28": 1,
              "2026-02-06": 1,
              "2026-04-09": 1,
              "2026-05-13": 1,
              "2026-05-14": 1
            },
            "time_per_day": {
              "2025-11-29": 1.2824063888888888,
              "2026-01-28": 0.4589347222222222,
              "2026-02-06": 155.58439777777778,
              "2026-04-09": 1.0909219444444445,
              "2026-05-13": 30.636013611111114,
              "2026-05-14": 1.6568961111111111
            },
            "time_count_per_day": {
              "2025-11-29": 1,
              "2026-01-28": 1,
              "2026-02-06": 1,
              "2026-04-09": 1,
              "2026-05-13": 1,
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "30-32h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-11-29": 1,
                "2026-01-28": 1,
                "2026-04-09": 1,
                "2026-05-13": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2025-11-29": 1.2824063888888888,
                "2026-01-28": 0.4589347222222222,
                "2026-04-09": 1.0909219444444445,
                "2026-05-13": 30.636013611111114,
                "2026-05-14": 1.6568961111111111
              },
              "time_count_per_day": {
                "2025-11-29": 1,
                "2026-01-28": 1,
                "2026-04-09": 1,
                "2026-05-13": 1,
                "2026-05-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 155.58,
              "mode_time_hours": 155.0,
              "mode_frequency": 1,
              "time_distribution": {
                "154-156h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 155.58439777777778
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_587": {
      "overall": {
        "avg_time_hours": 132.88,
        "mode_time_hours": 83.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 2,
          "6-8h": 1,
          "8-10h": 1,
          "30-32h": 1,
          "68-70h": 1,
          "80-82h": 2,
          "82-84h": 2,
          "1138-1140h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2025-12-03": 2,
          "2025-12-16": 2,
          "2026-01-13": 4,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2025-12-03": 164.09753916666668,
          "2025-12-16": 8.411349444444445,
          "2026-01-13": 173.75595722222224,
          "2026-01-14": 8.029784166666667,
          "2026-01-15": 30.950842222222224,
          "2026-01-16": 69.52728638888888,
          "2026-02-19": 1139.7765422222224
        },
        "time_count_per_day": {
          "2025-12-03": 2,
          "2025-12-16": 2,
          "2026-01-13": 4,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-01-16": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 69.53,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 69.52728638888888
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.66,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 6.660553055555556
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 42.06,
          "mode_time_hours": 83.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 2,
            "8-10h": 1,
            "30-32h": 1,
            "80-82h": 2,
            "82-84h": 2
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-12-03": 2,
            "2025-12-16": 2,
            "2026-01-13": 3,
            "2026-01-14": 1,
            "2026-01-15": 1
          },
          "time_per_day": {
            "2025-12-03": 164.09753916666668,
            "2025-12-16": 8.411349444444445,
            "2026-01-13": 167.09540416666667,
            "2026-01-14": 8.029784166666667,
            "2026-01-15": 30.950842222222224
          },
          "time_count_per_day": {
            "2025-12-03": 2,
            "2025-12-16": 2,
            "2026-01-13": 3,
            "2026-01-14": 1,
            "2026-01-15": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1139.78,
          "mode_time_hours": 1139.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1138-1140h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 1139.7765422222224
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 132.88,
            "mode_time_hours": 83.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 2,
              "6-8h": 1,
              "8-10h": 1,
              "30-32h": 1,
              "68-70h": 1,
              "80-82h": 2,
              "82-84h": 2,
              "1138-1140h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2025-12-03": 2,
              "2025-12-16": 2,
              "2026-01-13": 4,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2025-12-03": 164.09753916666668,
              "2025-12-16": 8.411349444444445,
              "2026-01-13": 173.75595722222224,
              "2026-01-14": 8.029784166666667,
              "2026-01-15": 30.950842222222224,
              "2026-01-16": 69.52728638888888,
              "2026-02-19": 1139.7765422222224
            },
            "time_count_per_day": {
              "2025-12-03": 2,
              "2025-12-16": 2,
              "2026-01-13": 4,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-01-16": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 69.53,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 69.52728638888888
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.66,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 6.660553055555556
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 42.06,
              "mode_time_hours": 83.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 2,
                "8-10h": 1,
                "30-32h": 1,
                "80-82h": 2,
                "82-84h": 2
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2025-12-03": 2,
                "2025-12-16": 2,
                "2026-01-13": 3,
                "2026-01-14": 1,
                "2026-01-15": 1
              },
              "time_per_day": {
                "2025-12-03": 164.09753916666668,
                "2025-12-16": 8.411349444444445,
                "2026-01-13": 167.09540416666667,
                "2026-01-14": 8.029784166666667,
                "2026-01-15": 30.950842222222224
              },
              "time_count_per_day": {
                "2025-12-03": 2,
                "2025-12-16": 2,
                "2026-01-13": 3,
                "2026-01-14": 1,
                "2026-01-15": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1139.78,
              "mode_time_hours": 1139.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1138-1140h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 1139.7765422222224
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_108": {
      "overall": {
        "avg_time_hours": 307.09,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 3,
          "4-6h": 1,
          "6-8h": 1,
          "12-14h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "70-72h": 1,
          "172-174h": 1,
          "368-370h": 1,
          "406-408h": 1,
          "462-464h": 1,
          "478-480h": 2,
          "502-504h": 1,
          "750-752h": 1,
          "754-756h": 1,
          "766-768h": 1,
          "1054-1056h": 1,
          "1366-1368h": 1,
          "1486-1488h": 1
        },
        "tickets_count": 31,
        "tickets_per_day": {
          "2025-11-30": 1,
          "2025-12-15": 3,
          "2026-01-19": 3,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 2,
          "2026-02-05": 2,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-15": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-02": 1,
          "2026-04-23": 1,
          "2026-04-30": 2,
          "2026-05-06": 1,
          "2026-05-22": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-11-30": 0.03324916666666667,
          "2025-12-15": 1419.9156002777777,
          "2026-01-19": 10.31342888888889,
          "2026-01-23": 1.207796388888889,
          "2026-01-26": 2.554119722222222,
          "2026-01-29": 0.2354152777777778,
          "2026-01-30": 13.678265277777777,
          "2026-02-03": 542.3914813888889,
          "2026-02-05": 71.32295222222223,
          "2026-02-11": 0.5910491666666666,
          "2026-02-12": 755.1495347222223,
          "2026-02-13": 750.4606211111111,
          "2026-02-17": 767.4968855555557,
          "2026-03-09": 4.209194166666666,
          "2026-03-12": 502.0136102777778,
          "2026-03-15": 24.81566361111111,
          "2026-03-18": 22.03158388888889,
          "2026-03-20": 1055.3288108333334,
          "2026-04-02": 1367.484501111111,
          "2026-04-23": 407.7055936111111,
          "2026-04-30": 5.006900833333333,
          "2026-05-06": 1486.6888997222222,
          "2026-06-03": 1.9689069444444443
        },
        "time_count_per_day": {
          "2025-11-30": 1,
          "2025-12-15": 3,
          "2026-01-19": 3,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-29": 1,
          "2026-01-30": 1,
          "2026-02-03": 2,
          "2026-02-05": 2,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-02-17": 1,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-15": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-02": 1,
          "2026-04-23": 1,
          "2026-04-30": 2,
          "2026-05-06": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 315.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 3,
            "4-6h": 1,
            "6-8h": 1,
            "12-14h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "70-72h": 1,
            "172-174h": 1,
            "406-408h": 1,
            "478-480h": 1,
            "502-504h": 1,
            "750-752h": 1,
            "754-756h": 1,
            "766-768h": 1,
            "1054-1056h": 1,
            "1366-1368h": 1,
            "1486-1488h": 1
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-11-30": 1,
            "2025-12-15": 1,
            "2026-01-19": 3,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-05": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-03-09": 1,
            "2026-03-12": 1,
            "2026-03-15": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-04-02": 1,
            "2026-04-23": 1,
            "2026-04-30": 2,
            "2026-05-06": 1,
            "2026-05-22": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-11-30": 0.03324916666666667,
            "2025-12-15": 478.49263583333334,
            "2026-01-19": 10.31342888888889,
            "2026-01-26": 2.554119722222222,
            "2026-01-29": 0.2354152777777778,
            "2026-01-30": 13.678265277777777,
            "2026-02-03": 172.87435777777776,
            "2026-02-05": 71.32295222222223,
            "2026-02-12": 755.1495347222223,
            "2026-02-13": 750.4606211111111,
            "2026-02-17": 767.4968855555557,
            "2026-03-09": 4.209194166666666,
            "2026-03-12": 502.0136102777778,
            "2026-03-15": 24.81566361111111,
            "2026-03-18": 22.03158388888889,
            "2026-03-20": 1055.3288108333334,
            "2026-04-02": 1367.484501111111,
            "2026-04-23": 407.7055936111111,
            "2026-04-30": 5.006900833333333,
            "2026-05-06": 1486.6888997222222,
            "2026-06-03": 1.9689069444444443
          },
          "time_count_per_day": {
            "2025-11-30": 1,
            "2025-12-15": 1,
            "2026-01-19": 3,
            "2026-01-26": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 1,
            "2026-02-05": 2,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-17": 1,
            "2026-03-09": 1,
            "2026-03-12": 1,
            "2026-03-15": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-04-02": 1,
            "2026-04-23": 1,
            "2026-04-30": 2,
            "2026-05-06": 1,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 262.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "368-370h": 1,
            "462-464h": 1,
            "478-480h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2025-12-15": 2,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-11": 1
          },
          "time_per_day": {
            "2025-12-15": 941.4229644444445,
            "2026-01-23": 1.207796388888889,
            "2026-02-03": 369.5171236111111,
            "2026-02-11": 0.5910491666666666
          },
          "time_count_per_day": {
            "2025-12-15": 2,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 307.09,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 3,
              "4-6h": 1,
              "6-8h": 1,
              "12-14h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "70-72h": 1,
              "172-174h": 1,
              "368-370h": 1,
              "406-408h": 1,
              "462-464h": 1,
              "478-480h": 2,
              "502-504h": 1,
              "750-752h": 1,
              "754-756h": 1,
              "766-768h": 1,
              "1054-1056h": 1,
              "1366-1368h": 1,
              "1486-1488h": 1
            },
            "tickets_count": 30,
            "tickets_per_day": {
              "2025-11-30": 1,
              "2025-12-15": 3,
              "2026-01-19": 3,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 2,
              "2026-02-05": 2,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-15": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-02": 1,
              "2026-04-23": 1,
              "2026-04-30": 2,
              "2026-05-06": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-11-30": 0.03324916666666667,
              "2025-12-15": 1419.9156002777777,
              "2026-01-19": 10.31342888888889,
              "2026-01-23": 1.207796388888889,
              "2026-01-26": 2.554119722222222,
              "2026-01-29": 0.2354152777777778,
              "2026-01-30": 13.678265277777777,
              "2026-02-03": 542.3914813888889,
              "2026-02-05": 71.32295222222223,
              "2026-02-11": 0.5910491666666666,
              "2026-02-12": 755.1495347222223,
              "2026-02-13": 750.4606211111111,
              "2026-02-17": 767.4968855555557,
              "2026-03-09": 4.209194166666666,
              "2026-03-12": 502.0136102777778,
              "2026-03-15": 24.81566361111111,
              "2026-03-18": 22.03158388888889,
              "2026-03-20": 1055.3288108333334,
              "2026-04-02": 1367.484501111111,
              "2026-04-23": 407.7055936111111,
              "2026-04-30": 5.006900833333333,
              "2026-05-06": 1486.6888997222222,
              "2026-06-03": 1.9689069444444443
            },
            "time_count_per_day": {
              "2025-11-30": 1,
              "2025-12-15": 3,
              "2026-01-19": 3,
              "2026-01-23": 1,
              "2026-01-26": 1,
              "2026-01-29": 1,
              "2026-01-30": 1,
              "2026-02-03": 2,
              "2026-02-05": 2,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-02-17": 1,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-15": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-02": 1,
              "2026-04-23": 1,
              "2026-04-30": 2,
              "2026-05-06": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 315.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 3,
                "4-6h": 1,
                "6-8h": 1,
                "12-14h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "70-72h": 1,
                "172-174h": 1,
                "406-408h": 1,
                "478-480h": 1,
                "502-504h": 1,
                "750-752h": 1,
                "754-756h": 1,
                "766-768h": 1,
                "1054-1056h": 1,
                "1366-1368h": 1,
                "1486-1488h": 1
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-11-30": 1,
                "2025-12-15": 1,
                "2026-01-19": 3,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-05": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-03-09": 1,
                "2026-03-12": 1,
                "2026-03-15": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-04-02": 1,
                "2026-04-23": 1,
                "2026-04-30": 2,
                "2026-05-06": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-11-30": 0.03324916666666667,
                "2025-12-15": 478.49263583333334,
                "2026-01-19": 10.31342888888889,
                "2026-01-26": 2.554119722222222,
                "2026-01-29": 0.2354152777777778,
                "2026-01-30": 13.678265277777777,
                "2026-02-03": 172.87435777777776,
                "2026-02-05": 71.32295222222223,
                "2026-02-12": 755.1495347222223,
                "2026-02-13": 750.4606211111111,
                "2026-02-17": 767.4968855555557,
                "2026-03-09": 4.209194166666666,
                "2026-03-12": 502.0136102777778,
                "2026-03-15": 24.81566361111111,
                "2026-03-18": 22.03158388888889,
                "2026-03-20": 1055.3288108333334,
                "2026-04-02": 1367.484501111111,
                "2026-04-23": 407.7055936111111,
                "2026-04-30": 5.006900833333333,
                "2026-05-06": 1486.6888997222222,
                "2026-06-03": 1.9689069444444443
              },
              "time_count_per_day": {
                "2025-11-30": 1,
                "2025-12-15": 1,
                "2026-01-19": 3,
                "2026-01-26": 1,
                "2026-01-29": 1,
                "2026-01-30": 1,
                "2026-02-03": 1,
                "2026-02-05": 2,
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-02-17": 1,
                "2026-03-09": 1,
                "2026-03-12": 1,
                "2026-03-15": 1,
                "2026-03-18": 1,
                "2026-03-20": 1,
                "2026-04-02": 1,
                "2026-04-23": 1,
                "2026-04-30": 2,
                "2026-05-06": 1,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 262.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "368-370h": 1,
                "462-464h": 1,
                "478-480h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-15": 2,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-11": 1
              },
              "time_per_day": {
                "2025-12-15": 941.4229644444445,
                "2026-01-23": 1.207796388888889,
                "2026-02-03": 369.5171236111111,
                "2026-02-11": 0.5910491666666666
              },
              "time_count_per_day": {
                "2025-12-15": 2,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-11": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_422": {
      "overall": {
        "avg_time_hours": 854.33,
        "mode_time_hours": 53.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "52-54h": 1,
          "2510-2512h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-02": 2,
          "2026-02-18": 1
        },
        "time_per_day": {
          "2025-12-02": 52.771166666666666,
          "2026-02-18": 2510.231462777778
        },
        "time_count_per_day": {
          "2025-12-02": 2,
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.26,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-02": 1
          },
          "time_per_day": {
            "2025-12-02": 0.2569183333333333
          },
          "time_count_per_day": {
            "2025-12-02": 1
          }
        },
        "P2": {
          "avg_time_hours": 1281.37,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "52-54h": 1,
            "2510-2512h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2025-12-02": 52.514248333333335,
            "2026-02-18": 2510.231462777778
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 854.33,
            "mode_time_hours": 53.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "52-54h": 1,
              "2510-2512h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-02": 2,
              "2026-02-18": 1
            },
            "time_per_day": {
              "2025-12-02": 52.771166666666666,
              "2026-02-18": 2510.231462777778
            },
            "time_count_per_day": {
              "2025-12-02": 2,
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.26,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-02": 1
              },
              "time_per_day": {
                "2025-12-02": 0.2569183333333333
              },
              "time_count_per_day": {
                "2025-12-02": 1
              }
            },
            "P2": {
              "avg_time_hours": 1281.37,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "52-54h": 1,
                "2510-2512h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2025-12-02": 52.514248333333335,
                "2026-02-18": 2510.231462777778
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_596": {
      "overall": {
        "avg_time_hours": 56.78,
        "mode_time_hours": 57.0,
        "mode_frequency": 1,
        "time_distribution": {
          "56-58h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-03": 1
        },
        "time_per_day": {
          "2025-12-03": 56.779090555555555
        },
        "time_count_per_day": {
          "2025-12-03": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 56.78,
          "mode_time_hours": 57.0,
          "mode_frequency": 1,
          "time_distribution": {
            "56-58h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-03": 1
          },
          "time_per_day": {
            "2025-12-03": 56.779090555555555
          },
          "time_count_per_day": {
            "2025-12-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 56.78,
            "mode_time_hours": 57.0,
            "mode_frequency": 1,
            "time_distribution": {
              "56-58h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-03": 1
            },
            "time_per_day": {
              "2025-12-03": 56.779090555555555
            },
            "time_count_per_day": {
              "2025-12-03": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 56.78,
              "mode_time_hours": 57.0,
              "mode_frequency": 1,
              "time_distribution": {
                "56-58h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-12-03": 56.779090555555555
              },
              "time_count_per_day": {
                "2025-12-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_271": {
      "overall": {
        "avg_time_hours": 1.43,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-01": 1
        },
        "time_per_day": {
          "2025-12-01": 1.4348958333333333
        },
        "time_count_per_day": {
          "2025-12-01": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1.43,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-01": 1
          },
          "time_per_day": {
            "2025-12-01": 1.4348958333333333
          },
          "time_count_per_day": {
            "2025-12-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.43,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-01": 1
            },
            "time_per_day": {
              "2025-12-01": 1.4348958333333333
            },
            "time_count_per_day": {
              "2025-12-01": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1.43,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-01": 1
              },
              "time_per_day": {
                "2025-12-01": 1.4348958333333333
              },
              "time_count_per_day": {
                "2025-12-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_598": {
      "overall": {
        "avg_time_hours": 71.62,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-12-05": 71.61971583333333
        },
        "time_count_per_day": {
          "2025-12-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 71.62,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 71.61971583333333
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 71.62,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-12-05": 71.61971583333333
            },
            "time_count_per_day": {
              "2025-12-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 71.62,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 71.61971583333333
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_599": {
      "overall": {
        "avg_time_hours": 6.11,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "8-10h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-02": 1,
          "2026-02-05": 1,
          "2026-02-09": 1
        },
        "time_per_day": {
          "2025-12-02": 4.968060555555556,
          "2026-02-05": 5.155868611111111,
          "2026-02-09": 8.194606666666667
        },
        "time_count_per_day": {
          "2025-12-02": 1,
          "2026-02-05": 1,
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.16,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 5.155868611111111
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.58,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "8-10h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2025-12-02": 4.968060555555556,
            "2026-02-09": 8.194606666666667
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.11,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "8-10h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-02": 1,
              "2026-02-05": 1,
              "2026-02-09": 1
            },
            "time_per_day": {
              "2025-12-02": 4.968060555555556,
              "2026-02-05": 5.155868611111111,
              "2026-02-09": 8.194606666666667
            },
            "time_count_per_day": {
              "2025-12-02": 1,
              "2026-02-05": 1,
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.16,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 5.155868611111111
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.58,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "8-10h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2025-12-02": 4.968060555555556,
                "2026-02-09": 8.194606666666667
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_601": {
      "overall": {
        "avg_time_hours": 222.4,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "12-14h": 1,
          "14-16h": 1,
          "208-210h": 1,
          "222-224h": 1,
          "312-314h": 1,
          "330-332h": 1,
          "358-360h": 1,
          "570-572h": 1,
          "594-596h": 1,
          "910-912h": 1
        },
        "tickets_count": 32,
        "tickets_per_day": {
          "2025-12-02": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-03": 14,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-04-02": 2,
          "2026-04-07": 2,
          "2026-04-14": 2,
          "2026-04-28": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2025-12-02": 1.6098702777777778,
          "2026-02-03": 12.380596388888888,
          "2026-02-09": 0.748905,
          "2026-02-10": 359.30746111111114,
          "2026-02-20": 594.7829136111111,
          "2026-02-25": 209.8929386111111,
          "2026-03-03": 1.6602963888888889,
          "2026-03-06": 7.518385277777778,
          "2026-03-09": 312.22651916666666,
          "2026-03-17": 331.4822836111111,
          "2026-03-20": 570.9423830555555,
          "2026-04-02": 1133.5454625,
          "2026-04-07": 18.67578111111111,
          "2026-04-14": 3.5699733333333334
        },
        "time_count_per_day": {
          "2025-12-02": 1,
          "2026-02-03": 1,
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-03": 1,
          "2026-03-06": 1,
          "2026-03-09": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-04-02": 2,
          "2026-04-07": 2,
          "2026-04-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 210.8,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "14-16h": 1,
            "208-210h": 1,
            "222-224h": 1,
            "312-314h": 1,
            "330-332h": 1,
            "358-360h": 1,
            "570-572h": 1,
            "910-912h": 1
          },
          "tickets_count": 30,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-25": 1,
            "2026-03-03": 14,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-04-02": 2,
            "2026-04-07": 2,
            "2026-04-14": 2,
            "2026-04-28": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2025-12-02": 1.6098702777777778,
            "2026-02-09": 0.748905,
            "2026-02-10": 359.30746111111114,
            "2026-02-25": 209.8929386111111,
            "2026-03-03": 1.6602963888888889,
            "2026-03-06": 7.518385277777778,
            "2026-03-09": 312.22651916666666,
            "2026-03-17": 331.4822836111111,
            "2026-03-20": 570.9423830555555,
            "2026-04-02": 1133.5454625,
            "2026-04-07": 18.67578111111111,
            "2026-04-14": 3.5699733333333334
          },
          "time_count_per_day": {
            "2025-12-02": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-25": 1,
            "2026-03-03": 1,
            "2026-03-06": 1,
            "2026-03-09": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-04-02": 2,
            "2026-04-07": 2,
            "2026-04-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 303.58,
          "mode_time_hours": 595.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1,
            "594-596h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-03": 12.380596388888888,
            "2026-02-20": 594.7829136111111
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 222.4,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "12-14h": 1,
              "14-16h": 1,
              "208-210h": 1,
              "222-224h": 1,
              "312-314h": 1,
              "330-332h": 1,
              "358-360h": 1,
              "570-572h": 1,
              "594-596h": 1,
              "910-912h": 1
            },
            "tickets_count": 16,
            "tickets_per_day": {
              "2025-12-02": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-03": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-04-02": 2,
              "2026-04-07": 2,
              "2026-04-14": 1
            },
            "time_per_day": {
              "2025-12-02": 1.6098702777777778,
              "2026-02-03": 12.380596388888888,
              "2026-02-09": 0.748905,
              "2026-02-10": 359.30746111111114,
              "2026-02-20": 594.7829136111111,
              "2026-02-25": 209.8929386111111,
              "2026-03-03": 1.6602963888888889,
              "2026-03-06": 7.518385277777778,
              "2026-03-09": 312.22651916666666,
              "2026-03-17": 331.4822836111111,
              "2026-03-20": 570.9423830555555,
              "2026-04-02": 1133.5454625,
              "2026-04-07": 18.67578111111111,
              "2026-04-14": 3.5699733333333334
            },
            "time_count_per_day": {
              "2025-12-02": 1,
              "2026-02-03": 1,
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-03": 1,
              "2026-03-06": 1,
              "2026-03-09": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-04-02": 2,
              "2026-04-07": 2,
              "2026-04-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 210.8,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "14-16h": 1,
                "208-210h": 1,
                "222-224h": 1,
                "312-314h": 1,
                "330-332h": 1,
                "358-360h": 1,
                "570-572h": 1,
                "910-912h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-04-02": 2,
                "2026-04-07": 2,
                "2026-04-14": 1
              },
              "time_per_day": {
                "2025-12-02": 1.6098702777777778,
                "2026-02-09": 0.748905,
                "2026-02-10": 359.30746111111114,
                "2026-02-25": 209.8929386111111,
                "2026-03-03": 1.6602963888888889,
                "2026-03-06": 7.518385277777778,
                "2026-03-09": 312.22651916666666,
                "2026-03-17": 331.4822836111111,
                "2026-03-20": 570.9423830555555,
                "2026-04-02": 1133.5454625,
                "2026-04-07": 18.67578111111111,
                "2026-04-14": 3.5699733333333334
              },
              "time_count_per_day": {
                "2025-12-02": 1,
                "2026-02-09": 1,
                "2026-02-10": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-06": 1,
                "2026-03-09": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-04-02": 2,
                "2026-04-07": 2,
                "2026-04-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 303.58,
              "mode_time_hours": 595.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1,
                "594-596h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-03": 12.380596388888888,
                "2026-02-20": 594.7829136111111
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-20": 1
              }
            }
          }
        },
        "Cuba Cancelado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 13,
            "tickets_per_day": {
              "2026-03-03": 13
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-03-03": 13
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-14": 1,
              "2026-04-28": 1,
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-14": 1,
                "2026-04-28": 1,
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_602": {
      "overall": {
        "avg_time_hours": 24.91,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-03": 1
        },
        "time_per_day": {
          "2025-12-03": 24.912949166666667
        },
        "time_count_per_day": {
          "2025-12-03": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 24.91,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-03": 1
          },
          "time_per_day": {
            "2025-12-03": 24.912949166666667
          },
          "time_count_per_day": {
            "2025-12-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.91,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-03": 1
            },
            "time_per_day": {
              "2025-12-03": 24.912949166666667
            },
            "time_count_per_day": {
              "2025-12-03": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 24.91,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-03": 1
              },
              "time_per_day": {
                "2025-12-03": 24.912949166666667
              },
              "time_count_per_day": {
                "2025-12-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_603": {
      "overall": {
        "avg_time_hours": 191.57,
        "mode_time_hours": 69.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "64-66h": 1,
          "68-70h": 1,
          "76-78h": 1,
          "86-88h": 1,
          "280-282h": 1,
          "292-294h": 1,
          "654-656h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-12-05": 1,
          "2026-03-20": 1,
          "2026-04-06": 1,
          "2026-04-09": 2,
          "2026-04-23": 1,
          "2026-05-18": 1,
          "2026-05-26": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-12-05": 69.53919388888889,
          "2026-03-20": 655.7907377777777,
          "2026-04-06": 65.74305944444444,
          "2026-04-09": 294.7116455555555,
          "2026-04-23": 77.74105944444445,
          "2026-05-18": 281.20695361111115,
          "2026-06-01": 87.82684222222221
        },
        "time_count_per_day": {
          "2025-12-05": 1,
          "2026-03-20": 1,
          "2026-04-06": 1,
          "2026-04-09": 2,
          "2026-04-23": 1,
          "2026-05-18": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 209.0,
          "mode_time_hours": 655.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "64-66h": 1,
            "76-78h": 1,
            "86-88h": 1,
            "280-282h": 1,
            "292-294h": 1,
            "654-656h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-04-06": 1,
            "2026-04-09": 2,
            "2026-04-23": 1,
            "2026-05-18": 1,
            "2026-05-26": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-03-20": 655.7907377777777,
            "2026-04-06": 65.74305944444444,
            "2026-04-09": 294.7116455555555,
            "2026-04-23": 77.74105944444445,
            "2026-05-18": 281.20695361111115,
            "2026-06-01": 87.82684222222221
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-04-06": 1,
            "2026-04-09": 2,
            "2026-04-23": 1,
            "2026-05-18": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 69.54,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 69.53919388888889
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 191.57,
            "mode_time_hours": 69.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "64-66h": 1,
              "68-70h": 1,
              "76-78h": 1,
              "86-88h": 1,
              "280-282h": 1,
              "292-294h": 1,
              "654-656h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-12-05": 1,
              "2026-03-20": 1,
              "2026-04-06": 1,
              "2026-04-09": 2,
              "2026-04-23": 1,
              "2026-05-18": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-12-05": 69.53919388888889,
              "2026-03-20": 655.7907377777777,
              "2026-04-06": 65.74305944444444,
              "2026-04-09": 294.7116455555555,
              "2026-04-23": 77.74105944444445,
              "2026-05-18": 281.20695361111115,
              "2026-06-01": 87.82684222222221
            },
            "time_count_per_day": {
              "2025-12-05": 1,
              "2026-03-20": 1,
              "2026-04-06": 1,
              "2026-04-09": 2,
              "2026-04-23": 1,
              "2026-05-18": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 209.0,
              "mode_time_hours": 655.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "64-66h": 1,
                "76-78h": 1,
                "86-88h": 1,
                "280-282h": 1,
                "292-294h": 1,
                "654-656h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-04-06": 1,
                "2026-04-09": 2,
                "2026-04-23": 1,
                "2026-05-18": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-03-20": 655.7907377777777,
                "2026-04-06": 65.74305944444444,
                "2026-04-09": 294.7116455555555,
                "2026-04-23": 77.74105944444445,
                "2026-05-18": 281.20695361111115,
                "2026-06-01": 87.82684222222221
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-04-06": 1,
                "2026-04-09": 2,
                "2026-04-23": 1,
                "2026-05-18": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 69.54,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 69.53919388888889
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_606": {
      "overall": {
        "avg_time_hours": 0.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-12-03": 1,
          "2025-12-05": 6,
          "2026-03-23": 1
        },
        "time_per_day": {
          "2025-12-03": 1.9778144444444443,
          "2025-12-05": 4.611390277777778,
          "2026-03-23": 0.9282361111111112
        },
        "time_count_per_day": {
          "2025-12-03": 1,
          "2025-12-05": 6,
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 0.9282361111111112
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 6
          },
          "time_per_day": {
            "2025-12-03": 1.9778144444444443,
            "2025-12-05": 4.611390277777778
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-05": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-12-03": 1,
              "2025-12-05": 6,
              "2026-03-23": 1
            },
            "time_per_day": {
              "2025-12-03": 1.9778144444444443,
              "2025-12-05": 4.611390277777778,
              "2026-03-23": 0.9282361111111112
            },
            "time_count_per_day": {
              "2025-12-03": 1,
              "2025-12-05": 6,
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 0.9282361111111112
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 6
              },
              "time_per_day": {
                "2025-12-03": 1.9778144444444443,
                "2025-12-05": 4.611390277777778
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-05": 6
              }
            }
          }
        }
      }
    },
    "cliente_608": {
      "overall": {
        "avg_time_hours": 186.73,
        "mode_time_hours": 187.0,
        "mode_frequency": 1,
        "time_distribution": {
          "186-188h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 186.72800583333333
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 186.73,
          "mode_time_hours": 187.0,
          "mode_frequency": 1,
          "time_distribution": {
            "186-188h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 186.72800583333333
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 186.73,
            "mode_time_hours": 187.0,
            "mode_frequency": 1,
            "time_distribution": {
              "186-188h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 186.72800583333333
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 186.73,
              "mode_time_hours": 187.0,
              "mode_frequency": 1,
              "time_distribution": {
                "186-188h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 186.72800583333333
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_609": {
      "overall": {
        "avg_time_hours": 103.68,
        "mode_time_hours": 3.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 5,
          "6-8h": 1,
          "12-14h": 1,
          "14-16h": 2,
          "16-18h": 5,
          "22-24h": 2,
          "24-26h": 1,
          "28-30h": 2,
          "30-32h": 1,
          "34-36h": 4,
          "40-42h": 2,
          "42-44h": 1,
          "44-46h": 2,
          "70-72h": 1,
          "74-76h": 1,
          "78-80h": 1,
          "140-142h": 1,
          "144-146h": 1,
          "326-328h": 1,
          "786-788h": 1,
          "816-818h": 1,
          "1146-1148h": 1
        },
        "tickets_count": 45,
        "tickets_per_day": {
          "2025-12-03": 1,
          "2025-12-10": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-14": 5,
          "2026-01-16": 1,
          "2026-01-19": 3,
          "2026-01-21": 2,
          "2026-01-31": 1,
          "2026-02-02": 1,
          "2026-02-03": 3,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-18": 1,
          "2026-03-03": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-04-07": 1,
          "2026-04-10": 1,
          "2026-04-13": 4,
          "2026-04-14": 1,
          "2026-04-18": 1,
          "2026-05-04": 2,
          "2026-05-14": 1,
          "2026-05-21": 1,
          "2026-05-29": 1,
          "2026-05-30": 1,
          "2026-06-02": 2,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-12-03": 2.3964569444444446,
          "2025-12-10": 140.52417111111112,
          "2025-12-18": 43.864643055555554,
          "2025-12-26": 0.7983636111111111,
          "2026-01-14": 137.4591538888889,
          "2026-01-16": 31.252934444444445,
          "2026-01-19": 74.12067833333333,
          "2026-01-21": 6.387703611111111,
          "2026-01-31": 23.30773138888889,
          "2026-02-02": 71.20738055555556,
          "2026-02-03": 168.02865250000002,
          "2026-02-06": 2.14423,
          "2026-02-07": 45.748957222222224,
          "2026-02-18": 23.297984444444445,
          "2026-03-03": 24.927428055555556,
          "2026-03-11": 816.8901630555555,
          "2026-03-17": 17.312110277777776,
          "2026-03-19": 144.16114666666667,
          "2026-04-07": 6.962201111111111,
          "2026-04-10": 326.8966713888889,
          "2026-04-13": 66.87526166666666,
          "2026-04-14": 45.083439166666665,
          "2026-04-18": 1146.6765994444445,
          "2026-05-04": 80.69046833333334,
          "2026-05-21": 0.5240508333333334,
          "2026-05-29": 3.810871111111111,
          "2026-05-30": 786.5551041666666,
          "2026-06-05": 12.998588611111112
        },
        "time_count_per_day": {
          "2025-12-03": 1,
          "2025-12-10": 1,
          "2025-12-18": 1,
          "2025-12-26": 1,
          "2026-01-14": 5,
          "2026-01-16": 1,
          "2026-01-19": 3,
          "2026-01-21": 2,
          "2026-01-31": 1,
          "2026-02-02": 1,
          "2026-02-03": 3,
          "2026-02-06": 1,
          "2026-02-07": 1,
          "2026-02-18": 1,
          "2026-03-03": 1,
          "2026-03-11": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-04-07": 1,
          "2026-04-10": 1,
          "2026-04-13": 4,
          "2026-04-14": 1,
          "2026-04-18": 1,
          "2026-05-04": 2,
          "2026-05-21": 1,
          "2026-05-29": 1,
          "2026-05-30": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 121.52,
          "mode_time_hours": 17.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 4,
            "6-8h": 1,
            "12-14h": 1,
            "14-16h": 1,
            "16-18h": 5,
            "22-24h": 1,
            "24-26h": 1,
            "28-30h": 2,
            "34-36h": 4,
            "40-42h": 2,
            "44-46h": 1,
            "70-72h": 1,
            "74-76h": 1,
            "140-142h": 1,
            "144-146h": 1,
            "326-328h": 1,
            "786-788h": 1,
            "816-818h": 1,
            "1146-1148h": 1
          },
          "tickets_count": 36,
          "tickets_per_day": {
            "2025-12-03": 1,
            "2025-12-10": 1,
            "2026-01-14": 5,
            "2026-01-19": 3,
            "2026-01-21": 2,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-18": 1,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-04-07": 1,
            "2026-04-10": 1,
            "2026-04-13": 4,
            "2026-04-14": 1,
            "2026-04-18": 1,
            "2026-05-04": 2,
            "2026-05-14": 1,
            "2026-05-21": 1,
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-02": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-12-03": 2.3964569444444446,
            "2025-12-10": 140.52417111111112,
            "2026-01-14": 137.4591538888889,
            "2026-01-19": 74.12067833333333,
            "2026-01-21": 6.387703611111111,
            "2026-02-02": 71.20738055555556,
            "2026-02-03": 74.36098722222222,
            "2026-02-18": 23.297984444444445,
            "2026-03-03": 24.927428055555556,
            "2026-03-11": 816.8901630555555,
            "2026-03-17": 17.312110277777776,
            "2026-03-19": 144.16114666666667,
            "2026-04-07": 6.962201111111111,
            "2026-04-10": 326.8966713888889,
            "2026-04-13": 66.87526166666666,
            "2026-04-14": 45.083439166666665,
            "2026-04-18": 1146.6765994444445,
            "2026-05-04": 80.69046833333334,
            "2026-05-21": 0.5240508333333334,
            "2026-05-29": 3.810871111111111,
            "2026-05-30": 786.5551041666666,
            "2026-06-05": 12.998588611111112
          },
          "time_count_per_day": {
            "2025-12-03": 1,
            "2025-12-10": 1,
            "2026-01-14": 5,
            "2026-01-19": 3,
            "2026-01-21": 2,
            "2026-02-02": 1,
            "2026-02-03": 1,
            "2026-02-18": 1,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-17": 1,
            "2026-03-19": 1,
            "2026-04-07": 1,
            "2026-04-10": 1,
            "2026-04-13": 4,
            "2026-04-14": 1,
            "2026-04-18": 1,
            "2026-05-04": 2,
            "2026-05-21": 1,
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 30.1,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1,
            "22-24h": 1,
            "30-32h": 1,
            "42-44h": 1,
            "44-46h": 1,
            "78-80h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-01-16": 1,
            "2026-01-31": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-07": 1
          },
          "time_per_day": {
            "2025-12-18": 43.864643055555554,
            "2025-12-26": 0.7983636111111111,
            "2026-01-16": 31.252934444444445,
            "2026-01-31": 23.30773138888889,
            "2026-02-03": 93.66766527777777,
            "2026-02-06": 2.14423,
            "2026-02-07": 45.748957222222224
          },
          "time_count_per_day": {
            "2025-12-18": 1,
            "2025-12-26": 1,
            "2026-01-16": 1,
            "2026-01-31": 1,
            "2026-02-03": 2,
            "2026-02-06": 1,
            "2026-02-07": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 103.68,
            "mode_time_hours": 3.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 5,
              "6-8h": 1,
              "12-14h": 1,
              "14-16h": 2,
              "16-18h": 5,
              "22-24h": 2,
              "24-26h": 1,
              "28-30h": 2,
              "30-32h": 1,
              "34-36h": 4,
              "40-42h": 2,
              "42-44h": 1,
              "44-46h": 2,
              "70-72h": 1,
              "74-76h": 1,
              "78-80h": 1,
              "140-142h": 1,
              "144-146h": 1,
              "326-328h": 1,
              "786-788h": 1,
              "816-818h": 1,
              "1146-1148h": 1
            },
            "tickets_count": 41,
            "tickets_per_day": {
              "2025-12-03": 1,
              "2025-12-10": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-14": 5,
              "2026-01-16": 1,
              "2026-01-19": 3,
              "2026-01-21": 2,
              "2026-01-31": 1,
              "2026-02-02": 1,
              "2026-02-03": 3,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-18": 1,
              "2026-03-03": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-04-07": 1,
              "2026-04-10": 1,
              "2026-04-13": 4,
              "2026-04-14": 1,
              "2026-04-18": 1,
              "2026-05-04": 2,
              "2026-05-21": 1,
              "2026-05-29": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-12-03": 2.3964569444444446,
              "2025-12-10": 140.52417111111112,
              "2025-12-18": 43.864643055555554,
              "2025-12-26": 0.7983636111111111,
              "2026-01-14": 137.4591538888889,
              "2026-01-16": 31.252934444444445,
              "2026-01-19": 74.12067833333333,
              "2026-01-21": 6.387703611111111,
              "2026-01-31": 23.30773138888889,
              "2026-02-02": 71.20738055555556,
              "2026-02-03": 168.02865250000002,
              "2026-02-06": 2.14423,
              "2026-02-07": 45.748957222222224,
              "2026-02-18": 23.297984444444445,
              "2026-03-03": 24.927428055555556,
              "2026-03-11": 816.8901630555555,
              "2026-03-17": 17.312110277777776,
              "2026-03-19": 144.16114666666667,
              "2026-04-07": 6.962201111111111,
              "2026-04-10": 326.8966713888889,
              "2026-04-13": 66.87526166666666,
              "2026-04-14": 45.083439166666665,
              "2026-04-18": 1146.6765994444445,
              "2026-05-04": 80.69046833333334,
              "2026-05-21": 0.5240508333333334,
              "2026-05-29": 3.810871111111111,
              "2026-05-30": 786.5551041666666,
              "2026-06-05": 12.998588611111112
            },
            "time_count_per_day": {
              "2025-12-03": 1,
              "2025-12-10": 1,
              "2025-12-18": 1,
              "2025-12-26": 1,
              "2026-01-14": 5,
              "2026-01-16": 1,
              "2026-01-19": 3,
              "2026-01-21": 2,
              "2026-01-31": 1,
              "2026-02-02": 1,
              "2026-02-03": 3,
              "2026-02-06": 1,
              "2026-02-07": 1,
              "2026-02-18": 1,
              "2026-03-03": 1,
              "2026-03-11": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-04-07": 1,
              "2026-04-10": 1,
              "2026-04-13": 4,
              "2026-04-14": 1,
              "2026-04-18": 1,
              "2026-05-04": 2,
              "2026-05-21": 1,
              "2026-05-29": 1,
              "2026-05-30": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 121.52,
              "mode_time_hours": 17.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 4,
                "6-8h": 1,
                "12-14h": 1,
                "14-16h": 1,
                "16-18h": 5,
                "22-24h": 1,
                "24-26h": 1,
                "28-30h": 2,
                "34-36h": 4,
                "40-42h": 2,
                "44-46h": 1,
                "70-72h": 1,
                "74-76h": 1,
                "140-142h": 1,
                "144-146h": 1,
                "326-328h": 1,
                "786-788h": 1,
                "816-818h": 1,
                "1146-1148h": 1
              },
              "tickets_count": 33,
              "tickets_per_day": {
                "2025-12-03": 1,
                "2025-12-10": 1,
                "2026-01-14": 5,
                "2026-01-19": 3,
                "2026-01-21": 2,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-18": 1,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-04-07": 1,
                "2026-04-10": 1,
                "2026-04-13": 4,
                "2026-04-14": 1,
                "2026-04-18": 1,
                "2026-05-04": 2,
                "2026-05-21": 1,
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-12-03": 2.3964569444444446,
                "2025-12-10": 140.52417111111112,
                "2026-01-14": 137.4591538888889,
                "2026-01-19": 74.12067833333333,
                "2026-01-21": 6.387703611111111,
                "2026-02-02": 71.20738055555556,
                "2026-02-03": 74.36098722222222,
                "2026-02-18": 23.297984444444445,
                "2026-03-03": 24.927428055555556,
                "2026-03-11": 816.8901630555555,
                "2026-03-17": 17.312110277777776,
                "2026-03-19": 144.16114666666667,
                "2026-04-07": 6.962201111111111,
                "2026-04-10": 326.8966713888889,
                "2026-04-13": 66.87526166666666,
                "2026-04-14": 45.083439166666665,
                "2026-04-18": 1146.6765994444445,
                "2026-05-04": 80.69046833333334,
                "2026-05-21": 0.5240508333333334,
                "2026-05-29": 3.810871111111111,
                "2026-05-30": 786.5551041666666,
                "2026-06-05": 12.998588611111112
              },
              "time_count_per_day": {
                "2025-12-03": 1,
                "2025-12-10": 1,
                "2026-01-14": 5,
                "2026-01-19": 3,
                "2026-01-21": 2,
                "2026-02-02": 1,
                "2026-02-03": 1,
                "2026-02-18": 1,
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-17": 1,
                "2026-03-19": 1,
                "2026-04-07": 1,
                "2026-04-10": 1,
                "2026-04-13": 4,
                "2026-04-14": 1,
                "2026-04-18": 1,
                "2026-05-04": 2,
                "2026-05-21": 1,
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 30.1,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1,
                "22-24h": 1,
                "30-32h": 1,
                "42-44h": 1,
                "44-46h": 1,
                "78-80h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-01-16": 1,
                "2026-01-31": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-07": 1
              },
              "time_per_day": {
                "2025-12-18": 43.864643055555554,
                "2025-12-26": 0.7983636111111111,
                "2026-01-16": 31.252934444444445,
                "2026-01-31": 23.30773138888889,
                "2026-02-03": 93.66766527777777,
                "2026-02-06": 2.14423,
                "2026-02-07": 45.748957222222224
              },
              "time_count_per_day": {
                "2025-12-18": 1,
                "2025-12-26": 1,
                "2026-01-16": 1,
                "2026-01-31": 1,
                "2026-02-03": 2,
                "2026-02-06": 1,
                "2026-02-07": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-02": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-02": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_611": {
      "overall": {
        "avg_time_hours": 49.64,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "10-12h": 1,
          "38-40h": 1,
          "114-116h": 1,
          "140-142h": 1,
          "166-168h": 1,
          "168-170h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2025-12-10": 1,
          "2025-12-17": 4,
          "2025-12-29": 1,
          "2026-01-08": 1,
          "2026-01-16": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-06": 1,
          "2026-03-17": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-12-10": 168.49484361111112,
          "2025-12-17": 0.4735411111111111,
          "2025-12-29": 0.8930755555555556,
          "2026-01-08": 141.39032055555555,
          "2026-01-16": 10.021557222222222,
          "2026-01-22": 1.6161761111111113,
          "2026-01-23": 114.41559444444445,
          "2026-02-06": 167.07783555555554,
          "2026-03-17": 1.8727238888888889,
          "2026-06-05": 39.1029325
        },
        "time_count_per_day": {
          "2025-12-10": 1,
          "2025-12-17": 4,
          "2025-12-29": 1,
          "2026-01-08": 1,
          "2026-01-16": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-06": 1,
          "2026-03-17": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.87,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "38-40h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-29": 1,
            "2026-01-22": 1,
            "2026-03-17": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2025-12-29": 0.8930755555555556,
            "2026-01-22": 1.6161761111111113,
            "2026-03-17": 1.8727238888888889,
            "2026-06-05": 39.1029325
          },
          "time_count_per_day": {
            "2025-12-29": 1,
            "2026-01-22": 1,
            "2026-03-17": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-17": 4
          },
          "time_per_day": {
            "2025-12-17": 0.4735411111111111
          },
          "time_count_per_day": {
            "2025-12-17": 4
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 140.96,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "114-116h": 1,
            "140-142h": 1,
            "166-168h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-23": 1,
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-01-08": 141.39032055555555,
            "2026-01-23": 114.41559444444445,
            "2026-02-06": 167.07783555555554
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-23": 1,
            "2026-02-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 89.26,
          "mode_time_hours": 169.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1,
            "168-170h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-10": 1,
            "2026-01-16": 1
          },
          "time_per_day": {
            "2025-12-10": 168.49484361111112,
            "2026-01-16": 10.021557222222222
          },
          "time_count_per_day": {
            "2025-12-10": 1,
            "2026-01-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 49.64,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "10-12h": 1,
              "38-40h": 1,
              "114-116h": 1,
              "140-142h": 1,
              "166-168h": 1,
              "168-170h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2025-12-10": 1,
              "2025-12-17": 4,
              "2025-12-29": 1,
              "2026-01-08": 1,
              "2026-01-16": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-06": 1,
              "2026-03-17": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2025-12-10": 168.49484361111112,
              "2025-12-17": 0.4735411111111111,
              "2025-12-29": 0.8930755555555556,
              "2026-01-08": 141.39032055555555,
              "2026-01-16": 10.021557222222222,
              "2026-01-22": 1.6161761111111113,
              "2026-01-23": 114.41559444444445,
              "2026-02-06": 167.07783555555554,
              "2026-03-17": 1.8727238888888889,
              "2026-06-05": 39.1029325
            },
            "time_count_per_day": {
              "2025-12-10": 1,
              "2025-12-17": 4,
              "2025-12-29": 1,
              "2026-01-08": 1,
              "2026-01-16": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-06": 1,
              "2026-03-17": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.87,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "38-40h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-29": 1,
                "2026-01-22": 1,
                "2026-03-17": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2025-12-29": 0.8930755555555556,
                "2026-01-22": 1.6161761111111113,
                "2026-03-17": 1.8727238888888889,
                "2026-06-05": 39.1029325
              },
              "time_count_per_day": {
                "2025-12-29": 1,
                "2026-01-22": 1,
                "2026-03-17": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-17": 4
              },
              "time_per_day": {
                "2025-12-17": 0.4735411111111111
              },
              "time_count_per_day": {
                "2025-12-17": 4
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 140.96,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "114-116h": 1,
                "140-142h": 1,
                "166-168h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-23": 1,
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-01-08": 141.39032055555555,
                "2026-01-23": 114.41559444444445,
                "2026-02-06": 167.07783555555554
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-23": 1,
                "2026-02-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 89.26,
              "mode_time_hours": 169.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1,
                "168-170h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-10": 1,
                "2026-01-16": 1
              },
              "time_per_day": {
                "2025-12-10": 168.49484361111112,
                "2026-01-16": 10.021557222222222
              },
              "time_count_per_day": {
                "2025-12-10": 1,
                "2026-01-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_612": {
      "overall": {
        "avg_time_hours": 189.9,
        "mode_time_hours": 189.0,
        "mode_frequency": 1,
        "time_distribution": {
          "188-190h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-10": 1,
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 189.90357833333334
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 189.9,
          "mode_time_hours": 189.0,
          "mode_frequency": 1,
          "time_distribution": {
            "188-190h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-10": 1,
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 189.90357833333334
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 189.9,
            "mode_time_hours": 189.0,
            "mode_frequency": 1,
            "time_distribution": {
              "188-190h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 189.90357833333334
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 189.9,
              "mode_time_hours": 189.0,
              "mode_frequency": 1,
              "time_distribution": {
                "188-190h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 189.90357833333334
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_186": {
      "overall": {
        "avg_time_hours": 500.15,
        "mode_time_hours": 41.0,
        "mode_frequency": 1,
        "time_distribution": {
          "32-34h": 1,
          "40-42h": 1,
          "1426-1428h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-05": 1,
          "2026-01-05": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-12-05": 41.28489166666666,
          "2026-01-05": 32.29163027777778,
          "2026-02-12": 1426.865115
        },
        "time_count_per_day": {
          "2025-12-05": 1,
          "2026-01-05": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 500.15,
          "mode_time_hours": 41.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "40-42h": 1,
            "1426-1428h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-01-05": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2025-12-05": 41.28489166666666,
            "2026-01-05": 32.29163027777778,
            "2026-02-12": 1426.865115
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-01-05": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 500.15,
            "mode_time_hours": 41.0,
            "mode_frequency": 1,
            "time_distribution": {
              "32-34h": 1,
              "40-42h": 1,
              "1426-1428h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-05": 1,
              "2026-01-05": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-12-05": 41.28489166666666,
              "2026-01-05": 32.29163027777778,
              "2026-02-12": 1426.865115
            },
            "time_count_per_day": {
              "2025-12-05": 1,
              "2026-01-05": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 500.15,
              "mode_time_hours": 41.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "40-42h": 1,
                "1426-1428h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-01-05": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2025-12-05": 41.28489166666666,
                "2026-01-05": 32.29163027777778,
                "2026-02-12": 1426.865115
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-01-05": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_237": {
      "overall": {
        "avg_time_hours": 12.4,
        "mode_time_hours": 19.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 2
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-04": 2,
          "2026-04-23": 1,
          "2026-04-24": 1
        },
        "time_per_day": {
          "2025-12-04": 36.54026388888889,
          "2026-04-24": 0.6597272222222222
        },
        "time_count_per_day": {
          "2025-12-04": 2,
          "2026-04-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-24": 1
          },
          "time_per_day": {
            "2026-04-24": 0.6597272222222222
          },
          "time_count_per_day": {
            "2026-04-24": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 18.27,
          "mode_time_hours": 19.0,
          "mode_frequency": 2,
          "time_distribution": {
            "18-20h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-04": 2,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-12-04": 36.54026388888889
          },
          "time_count_per_day": {
            "2025-12-04": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 12.4,
            "mode_time_hours": 19.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 2
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-04": 2,
              "2026-04-24": 1
            },
            "time_per_day": {
              "2025-12-04": 36.54026388888889,
              "2026-04-24": 0.6597272222222222
            },
            "time_count_per_day": {
              "2025-12-04": 2,
              "2026-04-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-24": 1
              },
              "time_per_day": {
                "2026-04-24": 0.6597272222222222
              },
              "time_count_per_day": {
                "2026-04-24": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 18.27,
              "mode_time_hours": 19.0,
              "mode_frequency": 2,
              "time_distribution": {
                "18-20h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-04": 2
              },
              "time_per_day": {
                "2025-12-04": 36.54026388888889
              },
              "time_count_per_day": {
                "2025-12-04": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_616": {
      "overall": {
        "avg_time_hours": 24.46,
        "mode_time_hours": 3.0,
        "mode_frequency": 10,
        "time_distribution": {
          "0-2h": 9,
          "2-4h": 10,
          "4-6h": 4,
          "6-8h": 7,
          "8-10h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "28-30h": 3,
          "30-32h": 2,
          "46-48h": 3,
          "48-50h": 1,
          "98-100h": 1,
          "148-150h": 2,
          "234-236h": 1
        },
        "tickets_count": 46,
        "tickets_per_day": {
          "2025-12-04": 1,
          "2026-01-08": 1,
          "2026-01-27": 1,
          "2026-01-30": 1,
          "2026-02-02": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-16": 5,
          "2026-03-17": 2,
          "2026-04-01": 1,
          "2026-04-06": 2,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-05-05": 1,
          "2026-05-13": 3,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-19": 7,
          "2026-05-21": 8,
          "2026-05-27": 1,
          "2026-06-02": 2
        },
        "time_per_day": {
          "2025-12-04": 4.150006111111112,
          "2026-01-08": 21.857035,
          "2026-01-27": 0.19442694444444444,
          "2026-01-30": 99.04004972222222,
          "2026-02-02": 5.855209166666667,
          "2026-02-17": 29.255626944444444,
          "2026-02-18": 31.02307388888889,
          "2026-03-04": 1.58622,
          "2026-03-05": 28.034272777777776,
          "2026-03-16": 16.940724166666666,
          "2026-03-17": 7.299347222222222,
          "2026-04-01": 30.022591111111108,
          "2026-04-06": 299.6327919444444,
          "2026-04-08": 29.076581944444445,
          "2026-04-14": 2.5859555555555556,
          "2026-05-05": 6.243789166666667,
          "2026-05-13": 139.28094083333332,
          "2026-05-14": 4.8587872222222215,
          "2026-05-15": 4.845808333333333,
          "2026-05-19": 60.873287222222224,
          "2026-05-21": 286.54666944444443,
          "2026-05-27": 8.320990277777778,
          "2026-06-02": 7.80802
        },
        "time_count_per_day": {
          "2025-12-04": 1,
          "2026-01-08": 1,
          "2026-01-27": 1,
          "2026-01-30": 1,
          "2026-02-02": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-03-04": 2,
          "2026-03-05": 1,
          "2026-03-16": 5,
          "2026-03-17": 2,
          "2026-04-01": 1,
          "2026-04-06": 2,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-05-05": 1,
          "2026-05-13": 3,
          "2026-05-14": 1,
          "2026-05-15": 1,
          "2026-05-19": 7,
          "2026-05-21": 8,
          "2026-05-27": 1,
          "2026-06-02": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 34.48,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "98-100h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-04": 1,
            "2026-01-30": 1,
            "2026-03-04": 1
          },
          "time_per_day": {
            "2025-12-04": 4.150006111111112,
            "2026-01-30": 99.04004972222222,
            "2026-03-04": 0.2446586111111111
          },
          "time_count_per_day": {
            "2025-12-04": 1,
            "2026-01-30": 1,
            "2026-03-04": 1
          }
        },
        "P2": {
          "avg_time_hours": 17.08,
          "mode_time_hours": 3.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 8,
            "2-4h": 9,
            "4-6h": 2,
            "6-8h": 7,
            "8-10h": 1,
            "22-24h": 1,
            "28-30h": 3,
            "30-32h": 1,
            "46-48h": 2,
            "48-50h": 1,
            "234-236h": 1
          },
          "tickets_count": 36,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-16": 4,
            "2026-03-17": 2,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-05-05": 1,
            "2026-05-13": 2,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-19": 7,
            "2026-05-21": 8,
            "2026-05-27": 1,
            "2026-06-02": 2
          },
          "time_per_day": {
            "2026-01-27": 0.19442694444444444,
            "2026-02-17": 29.255626944444444,
            "2026-02-18": 31.02307388888889,
            "2026-03-04": 1.3415613888888889,
            "2026-03-05": 28.034272777777776,
            "2026-03-16": 13.58147861111111,
            "2026-03-17": 7.299347222222222,
            "2026-04-08": 29.076581944444445,
            "2026-04-14": 2.5859555555555556,
            "2026-05-05": 6.243789166666667,
            "2026-05-13": 92.89655555555555,
            "2026-05-14": 4.8587872222222215,
            "2026-05-15": 4.845808333333333,
            "2026-05-19": 60.873287222222224,
            "2026-05-21": 286.54666944444443,
            "2026-05-27": 8.320990277777778,
            "2026-06-02": 7.80802
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-16": 4,
            "2026-03-17": 2,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-05-05": 1,
            "2026-05-13": 2,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-19": 7,
            "2026-05-21": 8,
            "2026-05-27": 1,
            "2026-06-02": 2
          }
        },
        "P3": {
          "avg_time_hours": 58.16,
          "mode_time_hours": 149.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1,
            "20-22h": 1,
            "30-32h": 1,
            "46-48h": 1,
            "148-150h": 2
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-02-02": 1,
            "2026-03-16": 1,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-01-08": 21.857035,
            "2026-02-02": 5.855209166666667,
            "2026-03-16": 3.3592455555555554,
            "2026-04-01": 30.022591111111108,
            "2026-04-06": 299.6327919444444,
            "2026-05-13": 46.38438527777778
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-02-02": 1,
            "2026-03-16": 1,
            "2026-04-01": 1,
            "2026-04-06": 2,
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.46,
            "mode_time_hours": 3.0,
            "mode_frequency": 10,
            "time_distribution": {
              "0-2h": 9,
              "2-4h": 10,
              "4-6h": 4,
              "6-8h": 7,
              "8-10h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "28-30h": 3,
              "30-32h": 2,
              "46-48h": 3,
              "48-50h": 1,
              "98-100h": 1,
              "148-150h": 2,
              "234-236h": 1
            },
            "tickets_count": 46,
            "tickets_per_day": {
              "2025-12-04": 1,
              "2026-01-08": 1,
              "2026-01-27": 1,
              "2026-01-30": 1,
              "2026-02-02": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-03-04": 2,
              "2026-03-05": 1,
              "2026-03-16": 5,
              "2026-03-17": 2,
              "2026-04-01": 1,
              "2026-04-06": 2,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-05-05": 1,
              "2026-05-13": 3,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-19": 7,
              "2026-05-21": 8,
              "2026-05-27": 1,
              "2026-06-02": 2
            },
            "time_per_day": {
              "2025-12-04": 4.150006111111112,
              "2026-01-08": 21.857035,
              "2026-01-27": 0.19442694444444444,
              "2026-01-30": 99.04004972222222,
              "2026-02-02": 5.855209166666667,
              "2026-02-17": 29.255626944444444,
              "2026-02-18": 31.02307388888889,
              "2026-03-04": 1.58622,
              "2026-03-05": 28.034272777777776,
              "2026-03-16": 16.940724166666666,
              "2026-03-17": 7.299347222222222,
              "2026-04-01": 30.022591111111108,
              "2026-04-06": 299.6327919444444,
              "2026-04-08": 29.076581944444445,
              "2026-04-14": 2.5859555555555556,
              "2026-05-05": 6.243789166666667,
              "2026-05-13": 139.28094083333332,
              "2026-05-14": 4.8587872222222215,
              "2026-05-15": 4.845808333333333,
              "2026-05-19": 60.873287222222224,
              "2026-05-21": 286.54666944444443,
              "2026-05-27": 8.320990277777778,
              "2026-06-02": 7.80802
            },
            "time_count_per_day": {
              "2025-12-04": 1,
              "2026-01-08": 1,
              "2026-01-27": 1,
              "2026-01-30": 1,
              "2026-02-02": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-03-04": 2,
              "2026-03-05": 1,
              "2026-03-16": 5,
              "2026-03-17": 2,
              "2026-04-01": 1,
              "2026-04-06": 2,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-05-05": 1,
              "2026-05-13": 3,
              "2026-05-14": 1,
              "2026-05-15": 1,
              "2026-05-19": 7,
              "2026-05-21": 8,
              "2026-05-27": 1,
              "2026-06-02": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 34.48,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "98-100h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-04": 1,
                "2026-01-30": 1,
                "2026-03-04": 1
              },
              "time_per_day": {
                "2025-12-04": 4.150006111111112,
                "2026-01-30": 99.04004972222222,
                "2026-03-04": 0.2446586111111111
              },
              "time_count_per_day": {
                "2025-12-04": 1,
                "2026-01-30": 1,
                "2026-03-04": 1
              }
            },
            "P2": {
              "avg_time_hours": 17.08,
              "mode_time_hours": 3.0,
              "mode_frequency": 9,
              "time_distribution": {
                "0-2h": 8,
                "2-4h": 9,
                "4-6h": 2,
                "6-8h": 7,
                "8-10h": 1,
                "22-24h": 1,
                "28-30h": 3,
                "30-32h": 1,
                "46-48h": 2,
                "48-50h": 1,
                "234-236h": 1
              },
              "tickets_count": 36,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-16": 4,
                "2026-03-17": 2,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-05-05": 1,
                "2026-05-13": 2,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-19": 7,
                "2026-05-21": 8,
                "2026-05-27": 1,
                "2026-06-02": 2
              },
              "time_per_day": {
                "2026-01-27": 0.19442694444444444,
                "2026-02-17": 29.255626944444444,
                "2026-02-18": 31.02307388888889,
                "2026-03-04": 1.3415613888888889,
                "2026-03-05": 28.034272777777776,
                "2026-03-16": 13.58147861111111,
                "2026-03-17": 7.299347222222222,
                "2026-04-08": 29.076581944444445,
                "2026-04-14": 2.5859555555555556,
                "2026-05-05": 6.243789166666667,
                "2026-05-13": 92.89655555555555,
                "2026-05-14": 4.8587872222222215,
                "2026-05-15": 4.845808333333333,
                "2026-05-19": 60.873287222222224,
                "2026-05-21": 286.54666944444443,
                "2026-05-27": 8.320990277777778,
                "2026-06-02": 7.80802
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-16": 4,
                "2026-03-17": 2,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-05-05": 1,
                "2026-05-13": 2,
                "2026-05-14": 1,
                "2026-05-15": 1,
                "2026-05-19": 7,
                "2026-05-21": 8,
                "2026-05-27": 1,
                "2026-06-02": 2
              }
            },
            "P3": {
              "avg_time_hours": 58.16,
              "mode_time_hours": 149.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1,
                "20-22h": 1,
                "30-32h": 1,
                "46-48h": 1,
                "148-150h": 2
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-02-02": 1,
                "2026-03-16": 1,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-01-08": 21.857035,
                "2026-02-02": 5.855209166666667,
                "2026-03-16": 3.3592455555555554,
                "2026-04-01": 30.022591111111108,
                "2026-04-06": 299.6327919444444,
                "2026-05-13": 46.38438527777778
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-02-02": 1,
                "2026-03-16": 1,
                "2026-04-01": 1,
                "2026-04-06": 2,
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_617": {
      "overall": {
        "avg_time_hours": 0.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-04": 1
        },
        "time_per_day": {
          "2025-12-04": 0.11743472222222222
        },
        "time_count_per_day": {
          "2025-12-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-04": 1
          },
          "time_per_day": {
            "2025-12-04": 0.11743472222222222
          },
          "time_count_per_day": {
            "2025-12-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-04": 1
            },
            "time_per_day": {
              "2025-12-04": 0.11743472222222222
            },
            "time_count_per_day": {
              "2025-12-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-04": 1
              },
              "time_per_day": {
                "2025-12-04": 0.11743472222222222
              },
              "time_count_per_day": {
                "2025-12-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_620": {
      "overall": {
        "avg_time_hours": 20.43,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-12-05": 20.434419166666668
        },
        "time_count_per_day": {
          "2025-12-05": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 20.43,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 20.434419166666668
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.43,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-12-05": 20.434419166666668
            },
            "time_count_per_day": {
              "2025-12-05": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 20.43,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 20.434419166666668
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_622": {
      "overall": {
        "avg_time_hours": 109.64,
        "mode_time_hours": 109.0,
        "mode_frequency": 1,
        "time_distribution": {
          "108-110h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-09": 1
        },
        "time_per_day": {
          "2025-12-09": 109.6433836111111
        },
        "time_count_per_day": {
          "2025-12-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 109.64,
          "mode_time_hours": 109.0,
          "mode_frequency": 1,
          "time_distribution": {
            "108-110h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-09": 1
          },
          "time_per_day": {
            "2025-12-09": 109.6433836111111
          },
          "time_count_per_day": {
            "2025-12-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 109.64,
            "mode_time_hours": 109.0,
            "mode_frequency": 1,
            "time_distribution": {
              "108-110h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-09": 1
            },
            "time_per_day": {
              "2025-12-09": 109.6433836111111
            },
            "time_count_per_day": {
              "2025-12-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 109.64,
              "mode_time_hours": 109.0,
              "mode_frequency": 1,
              "time_distribution": {
                "108-110h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-09": 1
              },
              "time_per_day": {
                "2025-12-09": 109.6433836111111
              },
              "time_count_per_day": {
                "2025-12-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_624": {
      "overall": {
        "avg_time_hours": 62.82,
        "mode_time_hours": 123.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "122-124h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-10": 1,
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-10": 123.30806777777778,
          "2025-12-11": 2.341189166666667
        },
        "time_count_per_day": {
          "2025-12-10": 1,
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.34,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 2.341189166666667
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 123.31,
          "mode_time_hours": 123.0,
          "mode_frequency": 1,
          "time_distribution": {
            "122-124h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-12-10": 123.30806777777778
          },
          "time_count_per_day": {
            "2025-12-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 62.82,
            "mode_time_hours": 123.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "122-124h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-10": 1,
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-10": 123.30806777777778,
              "2025-12-11": 2.341189166666667
            },
            "time_count_per_day": {
              "2025-12-10": 1,
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.34,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 2.341189166666667
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 123.31,
              "mode_time_hours": 123.0,
              "mode_frequency": 1,
              "time_distribution": {
                "122-124h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-12-10": 123.30806777777778
              },
              "time_count_per_day": {
                "2025-12-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_627": {
      "overall": {
        "avg_time_hours": 0.5,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-05": 1,
          "2026-01-23": 1,
          "2026-04-24": 1
        },
        "time_per_day": {
          "2025-12-05": 0.27896027777777777,
          "2026-01-23": 0.3578586111111111,
          "2026-04-24": 0.8594530555555555
        },
        "time_count_per_day": {
          "2025-12-05": 1,
          "2026-01-23": 1,
          "2026-04-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-01-23": 1,
            "2026-04-24": 1
          },
          "time_per_day": {
            "2025-12-05": 0.27896027777777777,
            "2026-01-23": 0.3578586111111111,
            "2026-04-24": 0.8594530555555555
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-01-23": 1,
            "2026-04-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.5,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-05": 1,
              "2026-01-23": 1,
              "2026-04-24": 1
            },
            "time_per_day": {
              "2025-12-05": 0.27896027777777777,
              "2026-01-23": 0.3578586111111111,
              "2026-04-24": 0.8594530555555555
            },
            "time_count_per_day": {
              "2025-12-05": 1,
              "2026-01-23": 1,
              "2026-04-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-01-23": 1,
                "2026-04-24": 1
              },
              "time_per_day": {
                "2025-12-05": 0.27896027777777777,
                "2026-01-23": 0.3578586111111111,
                "2026-04-24": 0.8594530555555555
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-01-23": 1,
                "2026-04-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_628": {
      "overall": {
        "avg_time_hours": 146.92,
        "mode_time_hours": 147.0,
        "mode_frequency": 1,
        "time_distribution": {
          "146-148h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 146.91752416666668
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 146.92,
          "mode_time_hours": 147.0,
          "mode_frequency": 1,
          "time_distribution": {
            "146-148h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 146.91752416666668
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 146.92,
            "mode_time_hours": 147.0,
            "mode_frequency": 1,
            "time_distribution": {
              "146-148h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 146.91752416666668
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 146.92,
              "mode_time_hours": 147.0,
              "mode_frequency": 1,
              "time_distribution": {
                "146-148h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 146.91752416666668
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_629": {
      "overall": {
        "avg_time_hours": 0.14,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-05": 1,
          "2026-03-02": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-12-05": 0.2784055555555556,
          "2026-03-02": 0.11802833333333333,
          "2026-05-30": 0.01588777777777778
        },
        "time_count_per_day": {
          "2025-12-05": 1,
          "2026-03-02": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-03-02": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-12-05": 0.2784055555555556,
            "2026-03-02": 0.11802833333333333,
            "2026-05-30": 0.01588777777777778
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-03-02": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.14,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-05": 1,
              "2026-03-02": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-12-05": 0.2784055555555556,
              "2026-03-02": 0.11802833333333333,
              "2026-05-30": 0.01588777777777778
            },
            "time_count_per_day": {
              "2025-12-05": 1,
              "2026-03-02": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-03-02": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-12-05": 0.2784055555555556,
                "2026-03-02": 0.11802833333333333,
                "2026-05-30": 0.01588777777777778
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-03-02": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_630": {
      "overall": {
        "avg_time_hours": 0.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-12-05": 0.29883750000000003
        },
        "time_count_per_day": {
          "2025-12-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 0.29883750000000003
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-12-05": 0.29883750000000003
            },
            "time_count_per_day": {
              "2025-12-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 0.29883750000000003
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "Magali Morim": {
      "overall": {
        "avg_time_hours": 122.03,
        "mode_time_hours": 203.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "8-10h": 1,
          "12-14h": 2,
          "98-100h": 1,
          "202-204h": 2,
          "430-432h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-12-09": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-20": 1,
          "2026-04-09": 1,
          "2026-04-22": 1,
          "2026-05-04": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2025-12-09": 99.7500613888889,
          "2026-03-11": 203.98639111111112,
          "2026-03-13": 203.25857166666668,
          "2026-03-20": 431.64079722222226,
          "2026-04-09": 13.801197777777777,
          "2026-04-22": 9.811291111111112,
          "2026-05-04": 13.926525,
          "2026-05-06": 0.08716694444444444
        },
        "time_count_per_day": {
          "2025-12-09": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-20": 1,
          "2026-04-09": 1,
          "2026-04-22": 1,
          "2026-05-04": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 122.03,
          "mode_time_hours": 203.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1,
            "12-14h": 2,
            "98-100h": 1,
            "202-204h": 2,
            "430-432h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-20": 1,
            "2026-04-09": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2025-12-09": 99.7500613888889,
            "2026-03-11": 203.98639111111112,
            "2026-03-13": 203.25857166666668,
            "2026-03-20": 431.64079722222226,
            "2026-04-09": 13.801197777777777,
            "2026-04-22": 9.811291111111112,
            "2026-05-04": 13.926525,
            "2026-05-06": 0.08716694444444444
          },
          "time_count_per_day": {
            "2025-12-09": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-20": 1,
            "2026-04-09": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 122.03,
            "mode_time_hours": 203.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "8-10h": 1,
              "12-14h": 2,
              "98-100h": 1,
              "202-204h": 2,
              "430-432h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-20": 1,
              "2026-04-09": 1,
              "2026-04-22": 1,
              "2026-05-04": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2025-12-09": 99.7500613888889,
              "2026-03-11": 203.98639111111112,
              "2026-03-13": 203.25857166666668,
              "2026-03-20": 431.64079722222226,
              "2026-04-09": 13.801197777777777,
              "2026-04-22": 9.811291111111112,
              "2026-05-04": 13.926525,
              "2026-05-06": 0.08716694444444444
            },
            "time_count_per_day": {
              "2025-12-09": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-20": 1,
              "2026-04-09": 1,
              "2026-04-22": 1,
              "2026-05-04": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 122.03,
              "mode_time_hours": 203.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1,
                "12-14h": 2,
                "98-100h": 1,
                "202-204h": 2,
                "430-432h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-20": 1,
                "2026-04-09": 1,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2025-12-09": 99.7500613888889,
                "2026-03-11": 203.98639111111112,
                "2026-03-13": 203.25857166666668,
                "2026-03-20": 431.64079722222226,
                "2026-04-09": 13.801197777777777,
                "2026-04-22": 9.811291111111112,
                "2026-05-04": 13.926525,
                "2026-05-06": 0.08716694444444444
              },
              "time_count_per_day": {
                "2025-12-09": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-20": 1,
                "2026-04-09": 1,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-05-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_634": {
      "overall": {
        "avg_time_hours": 0.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-05": 1
        },
        "time_per_day": {
          "2025-12-05": 0.6503111111111111
        },
        "time_count_per_day": {
          "2025-12-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-05": 1
          },
          "time_per_day": {
            "2025-12-05": 0.6503111111111111
          },
          "time_count_per_day": {
            "2025-12-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-05": 1
            },
            "time_per_day": {
              "2025-12-05": 0.6503111111111111
            },
            "time_count_per_day": {
              "2025-12-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-05": 1
              },
              "time_per_day": {
                "2025-12-05": 0.6503111111111111
              },
              "time_count_per_day": {
                "2025-12-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_597": {
      "overall": {
        "avg_time_hours": 0.74,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-12-05": 1,
          "2026-01-26": 1,
          "2026-01-31": 1,
          "2026-02-09": 1,
          "2026-05-04": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2025-12-05": 0.7478544444444444,
          "2026-01-26": 2.503171111111111,
          "2026-01-31": 0.4586027777777778,
          "2026-02-09": 0.07700527777777777,
          "2026-05-04": 0.6446580555555554,
          "2026-05-30": 0.01566027777777778
        },
        "time_count_per_day": {
          "2025-12-05": 1,
          "2026-01-26": 1,
          "2026-01-31": 1,
          "2026-02-09": 1,
          "2026-05-04": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.74,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-05": 1,
            "2026-01-26": 1,
            "2026-01-31": 1,
            "2026-02-09": 1,
            "2026-05-04": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2025-12-05": 0.7478544444444444,
            "2026-01-26": 2.503171111111111,
            "2026-01-31": 0.4586027777777778,
            "2026-02-09": 0.07700527777777777,
            "2026-05-04": 0.6446580555555554,
            "2026-05-30": 0.01566027777777778
          },
          "time_count_per_day": {
            "2025-12-05": 1,
            "2026-01-26": 1,
            "2026-01-31": 1,
            "2026-02-09": 1,
            "2026-05-04": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.74,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-12-05": 1,
              "2026-01-26": 1,
              "2026-01-31": 1,
              "2026-02-09": 1,
              "2026-05-04": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2025-12-05": 0.7478544444444444,
              "2026-01-26": 2.503171111111111,
              "2026-01-31": 0.4586027777777778,
              "2026-02-09": 0.07700527777777777,
              "2026-05-04": 0.6446580555555554,
              "2026-05-30": 0.01566027777777778
            },
            "time_count_per_day": {
              "2025-12-05": 1,
              "2026-01-26": 1,
              "2026-01-31": 1,
              "2026-02-09": 1,
              "2026-05-04": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.74,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-05": 1,
                "2026-01-26": 1,
                "2026-01-31": 1,
                "2026-02-09": 1,
                "2026-05-04": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2025-12-05": 0.7478544444444444,
                "2026-01-26": 2.503171111111111,
                "2026-01-31": 0.4586027777777778,
                "2026-02-09": 0.07700527777777777,
                "2026-05-04": 0.6446580555555554,
                "2026-05-30": 0.01566027777777778
              },
              "time_count_per_day": {
                "2025-12-05": 1,
                "2026-01-26": 1,
                "2026-01-31": 1,
                "2026-02-09": 1,
                "2026-05-04": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_636": {
      "overall": {
        "avg_time_hours": 100.55,
        "mode_time_hours": 115.0,
        "mode_frequency": 1,
        "time_distribution": {
          "84-86h": 1,
          "114-116h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-09": 1,
          "2025-12-10": 1
        },
        "time_per_day": {
          "2025-12-09": 85.4958513888889,
          "2025-12-10": 115.6063225
        },
        "time_count_per_day": {
          "2025-12-09": 1,
          "2025-12-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 100.55,
          "mode_time_hours": 115.0,
          "mode_frequency": 1,
          "time_distribution": {
            "84-86h": 1,
            "114-116h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2025-12-10": 1
          },
          "time_per_day": {
            "2025-12-09": 85.4958513888889,
            "2025-12-10": 115.6063225
          },
          "time_count_per_day": {
            "2025-12-09": 1,
            "2025-12-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 100.55,
            "mode_time_hours": 115.0,
            "mode_frequency": 1,
            "time_distribution": {
              "84-86h": 1,
              "114-116h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2025-12-10": 1
            },
            "time_per_day": {
              "2025-12-09": 85.4958513888889,
              "2025-12-10": 115.6063225
            },
            "time_count_per_day": {
              "2025-12-09": 1,
              "2025-12-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 100.55,
              "mode_time_hours": 115.0,
              "mode_frequency": 1,
              "time_distribution": {
                "84-86h": 1,
                "114-116h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2025-12-10": 1
              },
              "time_per_day": {
                "2025-12-09": 85.4958513888889,
                "2025-12-10": 115.6063225
              },
              "time_count_per_day": {
                "2025-12-09": 1,
                "2025-12-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_637": {
      "overall": {
        "avg_time_hours": 73.94,
        "mode_time_hours": 57.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 5,
          "4-6h": 1,
          "6-8h": 2,
          "8-10h": 2,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 2,
          "26-28h": 2,
          "38-40h": 1,
          "40-42h": 1,
          "56-58h": 6,
          "62-64h": 2,
          "66-68h": 1,
          "74-76h": 1,
          "76-78h": 1,
          "78-80h": 2,
          "86-88h": 3,
          "102-104h": 1,
          "126-128h": 3,
          "164-166h": 1,
          "216-218h": 1,
          "510-512h": 1,
          "580-582h": 1
        },
        "tickets_count": 48,
        "tickets_per_day": {
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-20": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-20": 2,
          "2026-01-26": 2,
          "2026-01-27": 7,
          "2026-01-28": 1,
          "2026-01-31": 1,
          "2026-02-05": 1,
          "2026-02-07": 6,
          "2026-02-10": 2,
          "2026-02-18": 1,
          "2026-02-26": 1,
          "2026-03-09": 3,
          "2026-03-10": 1,
          "2026-03-14": 1,
          "2026-03-18": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-28": 1,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-20": 2,
          "2026-05-23": 1,
          "2026-05-25": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-12-09": 74.30494055555556,
          "2025-12-15": 2.5688897222222224,
          "2025-12-17": 40.19418916666667,
          "2025-12-20": 164.55994805555554,
          "2026-01-09": 1.6359769444444443,
          "2026-01-13": 7.3664427777777775,
          "2026-01-15": 127.0380888888889,
          "2026-01-20": 55.35403111111111,
          "2026-01-26": 172.51213305555558,
          "2026-01-27": 522.15899,
          "2026-01-28": 8.015031666666667,
          "2026-01-31": 17.391044166666667,
          "2026-02-05": 62.810339166666665,
          "2026-02-07": 344.69441611111114,
          "2026-02-10": 159.36748777777777,
          "2026-02-18": 510.27978527777776,
          "2026-02-26": 0.7510691666666667,
          "2026-03-09": 13.187428055555555,
          "2026-03-10": 67.63137416666666,
          "2026-03-14": 2.7326658333333333,
          "2026-03-18": 216.77148055555554,
          "2026-03-23": 19.906195555555556,
          "2026-03-31": 77.77841055555555,
          "2026-04-28": 0.08207027777777777,
          "2026-05-08": 620.3253022222223,
          "2026-05-09": 15.035438888888889,
          "2026-05-23": 3.217986388888889,
          "2026-05-26": 19.569883055555554
        },
        "time_count_per_day": {
          "2025-12-09": 1,
          "2025-12-15": 1,
          "2025-12-17": 1,
          "2025-12-20": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-20": 2,
          "2026-01-26": 2,
          "2026-01-27": 7,
          "2026-01-28": 1,
          "2026-01-31": 1,
          "2026-02-05": 1,
          "2026-02-07": 6,
          "2026-02-10": 2,
          "2026-02-18": 1,
          "2026-02-26": 1,
          "2026-03-09": 3,
          "2026-03-10": 1,
          "2026-03-14": 1,
          "2026-03-18": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-28": 1,
          "2026-05-08": 2,
          "2026-05-09": 1,
          "2026-05-23": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 330.8,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1,
            "580-582h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-05-08": 1
          },
          "time_per_day": {
            "2026-02-10": 79.70536527777777,
            "2026-05-08": 581.8848891666667
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-05-08": 1
          }
        },
        "P2": {
          "avg_time_hours": 29.12,
          "mode_time_hours": 3.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 5,
            "4-6h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 2,
            "26-28h": 2,
            "38-40h": 1,
            "40-42h": 1,
            "66-68h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "164-166h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2025-12-20": 1,
            "2026-01-09": 1,
            "2026-01-20": 2,
            "2026-01-27": 1,
            "2026-01-31": 1,
            "2026-02-26": 1,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-14": 1,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-28": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-12-09": 74.30494055555556,
            "2025-12-15": 2.5688897222222224,
            "2025-12-17": 40.19418916666667,
            "2025-12-20": 164.55994805555554,
            "2026-01-09": 1.6359769444444443,
            "2026-01-20": 55.35403111111111,
            "2026-01-27": 5.188999166666667,
            "2026-01-31": 17.391044166666667,
            "2026-02-26": 0.7510691666666667,
            "2026-03-09": 5.256683611111111,
            "2026-03-10": 67.63137416666666,
            "2026-03-14": 2.7326658333333333,
            "2026-03-23": 19.906195555555556,
            "2026-03-31": 77.77841055555555,
            "2026-04-28": 0.08207027777777777,
            "2026-05-08": 38.44041305555555,
            "2026-05-09": 15.035438888888889,
            "2026-05-23": 3.217986388888889,
            "2026-05-26": 19.569883055555554
          },
          "time_count_per_day": {
            "2025-12-09": 1,
            "2025-12-15": 1,
            "2025-12-17": 1,
            "2025-12-20": 1,
            "2026-01-09": 1,
            "2026-01-20": 2,
            "2026-01-27": 1,
            "2026-01-31": 1,
            "2026-02-26": 1,
            "2026-03-09": 2,
            "2026-03-10": 1,
            "2026-03-14": 1,
            "2026-03-23": 1,
            "2026-03-31": 1,
            "2026-04-28": 1,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-23": 1,
            "2026-05-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 82.19,
          "mode_time_hours": 57.0,
          "mode_frequency": 6,
          "time_distribution": {
            "6-8h": 2,
            "8-10h": 2,
            "56-58h": 6,
            "62-64h": 2,
            "78-80h": 1,
            "86-88h": 3,
            "126-128h": 1,
            "510-512h": 1
          },
          "tickets_count": 18,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-26": 2,
            "2026-01-27": 3,
            "2026-01-28": 1,
            "2026-02-05": 1,
            "2026-02-07": 6,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-01-13": 7.3664427777777775,
            "2026-01-15": 127.0380888888889,
            "2026-01-26": 172.51213305555558,
            "2026-01-27": 159.18023916666667,
            "2026-01-28": 8.015031666666667,
            "2026-02-05": 62.810339166666665,
            "2026-02-07": 344.69441611111114,
            "2026-02-10": 79.6621225,
            "2026-02-18": 510.27978527777776,
            "2026-03-09": 7.930744444444445
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-01-15": 1,
            "2026-01-26": 2,
            "2026-01-27": 3,
            "2026-01-28": 1,
            "2026-02-05": 1,
            "2026-02-07": 6,
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-03-09": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 143.64,
          "mode_time_hours": 127.0,
          "mode_frequency": 2,
          "time_distribution": {
            "102-104h": 1,
            "126-128h": 2,
            "216-218h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-27": 3,
            "2026-03-18": 1,
            "2026-05-20": 2
          },
          "time_per_day": {
            "2026-01-27": 357.7897516666667,
            "2026-03-18": 216.77148055555554
          },
          "time_count_per_day": {
            "2026-01-27": 3,
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 73.94,
            "mode_time_hours": 57.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 5,
              "4-6h": 1,
              "6-8h": 2,
              "8-10h": 2,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 2,
              "26-28h": 2,
              "38-40h": 1,
              "40-42h": 1,
              "56-58h": 6,
              "62-64h": 2,
              "66-68h": 1,
              "74-76h": 1,
              "76-78h": 1,
              "78-80h": 2,
              "86-88h": 3,
              "102-104h": 1,
              "126-128h": 3,
              "164-166h": 1,
              "216-218h": 1,
              "510-512h": 1,
              "580-582h": 1
            },
            "tickets_count": 45,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-20": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-20": 2,
              "2026-01-26": 2,
              "2026-01-27": 7,
              "2026-01-28": 1,
              "2026-01-31": 1,
              "2026-02-05": 1,
              "2026-02-07": 6,
              "2026-02-10": 2,
              "2026-02-18": 1,
              "2026-02-26": 1,
              "2026-03-09": 3,
              "2026-03-10": 1,
              "2026-03-14": 1,
              "2026-03-18": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-28": 1,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-23": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-12-09": 74.30494055555556,
              "2025-12-15": 2.5688897222222224,
              "2025-12-17": 40.19418916666667,
              "2025-12-20": 164.55994805555554,
              "2026-01-09": 1.6359769444444443,
              "2026-01-13": 7.3664427777777775,
              "2026-01-15": 127.0380888888889,
              "2026-01-20": 55.35403111111111,
              "2026-01-26": 172.51213305555558,
              "2026-01-27": 522.15899,
              "2026-01-28": 8.015031666666667,
              "2026-01-31": 17.391044166666667,
              "2026-02-05": 62.810339166666665,
              "2026-02-07": 344.69441611111114,
              "2026-02-10": 159.36748777777777,
              "2026-02-18": 510.27978527777776,
              "2026-02-26": 0.7510691666666667,
              "2026-03-09": 13.187428055555555,
              "2026-03-10": 67.63137416666666,
              "2026-03-14": 2.7326658333333333,
              "2026-03-18": 216.77148055555554,
              "2026-03-23": 19.906195555555556,
              "2026-03-31": 77.77841055555555,
              "2026-04-28": 0.08207027777777777,
              "2026-05-08": 620.3253022222223,
              "2026-05-09": 15.035438888888889,
              "2026-05-23": 3.217986388888889,
              "2026-05-26": 19.569883055555554
            },
            "time_count_per_day": {
              "2025-12-09": 1,
              "2025-12-15": 1,
              "2025-12-17": 1,
              "2025-12-20": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-20": 2,
              "2026-01-26": 2,
              "2026-01-27": 7,
              "2026-01-28": 1,
              "2026-01-31": 1,
              "2026-02-05": 1,
              "2026-02-07": 6,
              "2026-02-10": 2,
              "2026-02-18": 1,
              "2026-02-26": 1,
              "2026-03-09": 3,
              "2026-03-10": 1,
              "2026-03-14": 1,
              "2026-03-18": 1,
              "2026-03-23": 1,
              "2026-03-31": 1,
              "2026-04-28": 1,
              "2026-05-08": 2,
              "2026-05-09": 1,
              "2026-05-23": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 330.8,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1,
                "580-582h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-05-08": 1
              },
              "time_per_day": {
                "2026-02-10": 79.70536527777777,
                "2026-05-08": 581.8848891666667
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-05-08": 1
              }
            },
            "P2": {
              "avg_time_hours": 29.12,
              "mode_time_hours": 3.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 5,
                "4-6h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 2,
                "26-28h": 2,
                "38-40h": 1,
                "40-42h": 1,
                "66-68h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "164-166h": 1
              },
              "tickets_count": 21,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2025-12-20": 1,
                "2026-01-09": 1,
                "2026-01-20": 2,
                "2026-01-27": 1,
                "2026-01-31": 1,
                "2026-02-26": 1,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-14": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-28": 1,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-23": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-12-09": 74.30494055555556,
                "2025-12-15": 2.5688897222222224,
                "2025-12-17": 40.19418916666667,
                "2025-12-20": 164.55994805555554,
                "2026-01-09": 1.6359769444444443,
                "2026-01-20": 55.35403111111111,
                "2026-01-27": 5.188999166666667,
                "2026-01-31": 17.391044166666667,
                "2026-02-26": 0.7510691666666667,
                "2026-03-09": 5.256683611111111,
                "2026-03-10": 67.63137416666666,
                "2026-03-14": 2.7326658333333333,
                "2026-03-23": 19.906195555555556,
                "2026-03-31": 77.77841055555555,
                "2026-04-28": 0.08207027777777777,
                "2026-05-08": 38.44041305555555,
                "2026-05-09": 15.035438888888889,
                "2026-05-23": 3.217986388888889,
                "2026-05-26": 19.569883055555554
              },
              "time_count_per_day": {
                "2025-12-09": 1,
                "2025-12-15": 1,
                "2025-12-17": 1,
                "2025-12-20": 1,
                "2026-01-09": 1,
                "2026-01-20": 2,
                "2026-01-27": 1,
                "2026-01-31": 1,
                "2026-02-26": 1,
                "2026-03-09": 2,
                "2026-03-10": 1,
                "2026-03-14": 1,
                "2026-03-23": 1,
                "2026-03-31": 1,
                "2026-04-28": 1,
                "2026-05-08": 1,
                "2026-05-09": 1,
                "2026-05-23": 1,
                "2026-05-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 82.19,
              "mode_time_hours": 57.0,
              "mode_frequency": 6,
              "time_distribution": {
                "6-8h": 2,
                "8-10h": 2,
                "56-58h": 6,
                "62-64h": 2,
                "78-80h": 1,
                "86-88h": 3,
                "126-128h": 1,
                "510-512h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-26": 2,
                "2026-01-27": 3,
                "2026-01-28": 1,
                "2026-02-05": 1,
                "2026-02-07": 6,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-01-13": 7.3664427777777775,
                "2026-01-15": 127.0380888888889,
                "2026-01-26": 172.51213305555558,
                "2026-01-27": 159.18023916666667,
                "2026-01-28": 8.015031666666667,
                "2026-02-05": 62.810339166666665,
                "2026-02-07": 344.69441611111114,
                "2026-02-10": 79.6621225,
                "2026-02-18": 510.27978527777776,
                "2026-03-09": 7.930744444444445
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-01-15": 1,
                "2026-01-26": 2,
                "2026-01-27": 3,
                "2026-01-28": 1,
                "2026-02-05": 1,
                "2026-02-07": 6,
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-03-09": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 143.64,
              "mode_time_hours": 127.0,
              "mode_frequency": 2,
              "time_distribution": {
                "102-104h": 1,
                "126-128h": 2,
                "216-218h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-27": 3,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-01-27": 357.7897516666667,
                "2026-03-18": 216.77148055555554
              },
              "time_count_per_day": {
                "2026-01-27": 3,
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-20": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-20": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_638": {
      "overall": {
        "avg_time_hours": 101.89,
        "mode_time_hours": 101.0,
        "mode_frequency": 1,
        "time_distribution": {
          "100-102h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 101.88809861111112
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 101.89,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "100-102h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 101.88809861111112
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 101.89,
            "mode_time_hours": 101.0,
            "mode_frequency": 1,
            "time_distribution": {
              "100-102h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 101.88809861111112
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 101.89,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "100-102h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 101.88809861111112
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_294": {
      "overall": {
        "avg_time_hours": 98.62,
        "mode_time_hours": 99.0,
        "mode_frequency": 1,
        "time_distribution": {
          "98-100h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 98.61631249999999
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 98.62,
          "mode_time_hours": 99.0,
          "mode_frequency": 1,
          "time_distribution": {
            "98-100h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 98.61631249999999
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 98.62,
            "mode_time_hours": 99.0,
            "mode_frequency": 1,
            "time_distribution": {
              "98-100h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 98.61631249999999
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 98.62,
              "mode_time_hours": 99.0,
              "mode_frequency": 1,
              "time_distribution": {
                "98-100h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 98.61631249999999
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_639": {
      "overall": {
        "avg_time_hours": 55.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "6-8h": 2,
          "12-14h": 1,
          "48-50h": 1,
          "112-114h": 1,
          "306-308h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-12-12": 1,
          "2025-12-26": 1,
          "2025-12-30": 1,
          "2026-01-13": 1,
          "2026-01-30": 2,
          "2026-02-28": 2,
          "2026-03-19": 1
        },
        "time_per_day": {
          "2025-12-12": 112.66509916666668,
          "2025-12-26": 0.8132491666666667,
          "2025-12-30": 49.8814375,
          "2026-01-13": 0.30713166666666664,
          "2026-01-30": 12.550685833333333,
          "2026-02-28": 13.894223055555555,
          "2026-03-19": 307.96183333333335
        },
        "time_count_per_day": {
          "2025-12-12": 1,
          "2025-12-26": 1,
          "2025-12-30": 1,
          "2026-01-13": 1,
          "2026-01-30": 2,
          "2026-02-28": 2,
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "6-8h": 2,
            "12-14h": 1,
            "48-50h": 1,
            "306-308h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2025-12-30": 1,
            "2026-01-13": 1,
            "2026-01-30": 2,
            "2026-02-28": 2,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2025-12-26": 0.8132491666666667,
            "2025-12-30": 49.8814375,
            "2026-01-13": 0.30713166666666664,
            "2026-01-30": 12.550685833333333,
            "2026-02-28": 13.894223055555555,
            "2026-03-19": 307.96183333333335
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2025-12-30": 1,
            "2026-01-13": 1,
            "2026-01-30": 2,
            "2026-02-28": 2,
            "2026-03-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 112.67,
          "mode_time_hours": 113.0,
          "mode_frequency": 1,
          "time_distribution": {
            "112-114h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-12": 1
          },
          "time_per_day": {
            "2025-12-12": 112.66509916666668
          },
          "time_count_per_day": {
            "2025-12-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 55.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "6-8h": 2,
              "12-14h": 1,
              "48-50h": 1,
              "112-114h": 1,
              "306-308h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2025-12-12": 1,
              "2025-12-26": 1,
              "2025-12-30": 1,
              "2026-01-13": 1,
              "2026-01-30": 2,
              "2026-02-28": 2,
              "2026-03-19": 1
            },
            "time_per_day": {
              "2025-12-12": 112.66509916666668,
              "2025-12-26": 0.8132491666666667,
              "2025-12-30": 49.8814375,
              "2026-01-13": 0.30713166666666664,
              "2026-01-30": 12.550685833333333,
              "2026-02-28": 13.894223055555555,
              "2026-03-19": 307.96183333333335
            },
            "time_count_per_day": {
              "2025-12-12": 1,
              "2025-12-26": 1,
              "2025-12-30": 1,
              "2026-01-13": 1,
              "2026-01-30": 2,
              "2026-02-28": 2,
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "6-8h": 2,
                "12-14h": 1,
                "48-50h": 1,
                "306-308h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2025-12-30": 1,
                "2026-01-13": 1,
                "2026-01-30": 2,
                "2026-02-28": 2,
                "2026-03-19": 1
              },
              "time_per_day": {
                "2025-12-26": 0.8132491666666667,
                "2025-12-30": 49.8814375,
                "2026-01-13": 0.30713166666666664,
                "2026-01-30": 12.550685833333333,
                "2026-02-28": 13.894223055555555,
                "2026-03-19": 307.96183333333335
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2025-12-30": 1,
                "2026-01-13": 1,
                "2026-01-30": 2,
                "2026-02-28": 2,
                "2026-03-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 112.67,
              "mode_time_hours": 113.0,
              "mode_frequency": 1,
              "time_distribution": {
                "112-114h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-12": 1
              },
              "time_per_day": {
                "2025-12-12": 112.66509916666668
              },
              "time_count_per_day": {
                "2025-12-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_643": {
      "overall": {
        "avg_time_hours": 69.53,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "50-52h": 1,
          "156-158h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-11": 1,
          "2026-01-06": 1,
          "2026-01-19": 1
        },
        "time_per_day": {
          "2025-12-11": 50.6144875,
          "2026-01-06": 156.3813802777778,
          "2026-01-19": 1.6009819444444444
        },
        "time_count_per_day": {
          "2025-12-11": 1,
          "2026-01-06": 1,
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 78.99,
          "mode_time_hours": 157.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "156-158h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-06": 1,
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-06": 156.3813802777778,
            "2026-01-19": 1.6009819444444444
          },
          "time_count_per_day": {
            "2026-01-06": 1,
            "2026-01-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 50.61,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 50.6144875
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 69.53,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "50-52h": 1,
              "156-158h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-11": 1,
              "2026-01-06": 1,
              "2026-01-19": 1
            },
            "time_per_day": {
              "2025-12-11": 50.6144875,
              "2026-01-06": 156.3813802777778,
              "2026-01-19": 1.6009819444444444
            },
            "time_count_per_day": {
              "2025-12-11": 1,
              "2026-01-06": 1,
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 78.99,
              "mode_time_hours": 157.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "156-158h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-06": 1,
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-06": 156.3813802777778,
                "2026-01-19": 1.6009819444444444
              },
              "time_count_per_day": {
                "2026-01-06": 1,
                "2026-01-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 50.61,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 50.6144875
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_644": {
      "overall": {
        "avg_time_hours": 1.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-09": 1,
          "2026-01-08": 1,
          "2026-01-14": 1
        },
        "time_per_day": {
          "2025-12-09": 2.8175713888888887,
          "2026-01-08": 0.33741499999999996,
          "2026-01-14": 0.1636313888888889
        },
        "time_count_per_day": {
          "2025-12-09": 1,
          "2026-01-08": 1,
          "2026-01-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.11,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2026-01-08": 1,
            "2026-01-14": 1
          },
          "time_per_day": {
            "2025-12-09": 2.8175713888888887,
            "2026-01-08": 0.33741499999999996,
            "2026-01-14": 0.1636313888888889
          },
          "time_count_per_day": {
            "2025-12-09": 1,
            "2026-01-08": 1,
            "2026-01-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-09": 1,
              "2026-01-08": 1,
              "2026-01-14": 1
            },
            "time_per_day": {
              "2025-12-09": 2.8175713888888887,
              "2026-01-08": 0.33741499999999996,
              "2026-01-14": 0.1636313888888889
            },
            "time_count_per_day": {
              "2025-12-09": 1,
              "2026-01-08": 1,
              "2026-01-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.11,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-09": 1,
                "2026-01-08": 1,
                "2026-01-14": 1
              },
              "time_per_day": {
                "2025-12-09": 2.8175713888888887,
                "2026-01-08": 0.33741499999999996,
                "2026-01-14": 0.1636313888888889
              },
              "time_count_per_day": {
                "2025-12-09": 1,
                "2026-01-08": 1,
                "2026-01-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_645": {
      "overall": {
        "avg_time_hours": 154.52,
        "mode_time_hours": 109.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1,
          "44-46h": 1,
          "66-68h": 1,
          "108-110h": 1,
          "126-128h": 1,
          "552-554h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2025-12-14": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-04-02": 1
        },
        "time_per_day": {
          "2025-12-14": 109.17859027777777,
          "2026-01-14": 45.26051277777778,
          "2026-01-15": 25.733647222222224,
          "2026-02-03": 127.09626805555556,
          "2026-02-13": 552.1817341666666,
          "2026-04-02": 67.67751694444443
        },
        "time_count_per_day": {
          "2025-12-14": 1,
          "2026-01-14": 1,
          "2026-01-15": 1,
          "2026-02-03": 1,
          "2026-02-13": 1,
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 45.26,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 45.26051277777778
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        },
        "P2": {
          "avg_time_hours": 309.93,
          "mode_time_hours": 553.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1,
            "552-554h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-13": 1,
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-02-13": 552.1817341666666,
            "2026-04-02": 67.67751694444443
          },
          "time_count_per_day": {
            "2026-02-13": 1,
            "2026-04-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 87.34,
          "mode_time_hours": 109.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "108-110h": 1,
            "126-128h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-14": 1,
            "2026-01-15": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2025-12-14": 109.17859027777777,
            "2026-01-15": 25.733647222222224,
            "2026-02-03": 127.09626805555556
          },
          "time_count_per_day": {
            "2025-12-14": 1,
            "2026-01-15": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 154.52,
            "mode_time_hours": 109.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1,
              "44-46h": 1,
              "66-68h": 1,
              "108-110h": 1,
              "126-128h": 1,
              "552-554h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-12-14": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-04-02": 1
            },
            "time_per_day": {
              "2025-12-14": 109.17859027777777,
              "2026-01-14": 45.26051277777778,
              "2026-01-15": 25.733647222222224,
              "2026-02-03": 127.09626805555556,
              "2026-02-13": 552.1817341666666,
              "2026-04-02": 67.67751694444443
            },
            "time_count_per_day": {
              "2025-12-14": 1,
              "2026-01-14": 1,
              "2026-01-15": 1,
              "2026-02-03": 1,
              "2026-02-13": 1,
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 45.26,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 45.26051277777778
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            },
            "P2": {
              "avg_time_hours": 309.93,
              "mode_time_hours": 553.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1,
                "552-554h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-13": 1,
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-02-13": 552.1817341666666,
                "2026-04-02": 67.67751694444443
              },
              "time_count_per_day": {
                "2026-02-13": 1,
                "2026-04-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 87.34,
              "mode_time_hours": 109.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "108-110h": 1,
                "126-128h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-14": 1,
                "2026-01-15": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2025-12-14": 109.17859027777777,
                "2026-01-15": 25.733647222222224,
                "2026-02-03": 127.09626805555556
              },
              "time_count_per_day": {
                "2025-12-14": 1,
                "2026-01-15": 1,
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_651": {
      "overall": {
        "avg_time_hours": 12.23,
        "mode_time_hours": 13.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-11": 1
        },
        "time_per_day": {
          "2025-12-11": 12.226175833333333
        },
        "time_count_per_day": {
          "2025-12-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 12.23,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-11": 1
          },
          "time_per_day": {
            "2025-12-11": 12.226175833333333
          },
          "time_count_per_day": {
            "2025-12-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 12.23,
            "mode_time_hours": 13.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-11": 1
            },
            "time_per_day": {
              "2025-12-11": 12.226175833333333
            },
            "time_count_per_day": {
              "2025-12-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 12.23,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-11": 1
              },
              "time_per_day": {
                "2025-12-11": 12.226175833333333
              },
              "time_count_per_day": {
                "2025-12-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_659": {
      "overall": {
        "avg_time_hours": 136.25,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "2-4h": 3,
          "42-44h": 1,
          "44-46h": 1,
          "104-106h": 1,
          "148-150h": 1,
          "254-256h": 1,
          "334-336h": 1,
          "424-426h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2025-12-12": 3,
          "2025-12-14": 2,
          "2025-12-23": 1,
          "2026-01-06": 1,
          "2026-02-04": 1,
          "2026-02-20": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2025-12-12": 8.140764444444445,
          "2025-12-14": 86.83986861111111,
          "2025-12-23": 255.052715,
          "2026-01-06": 149.28166916666666,
          "2026-02-04": 334.5495413888889,
          "2026-02-20": 104.41259027777778,
          "2026-05-04": 424.21399055555554
        },
        "time_count_per_day": {
          "2025-12-12": 3,
          "2025-12-14": 2,
          "2025-12-23": 1,
          "2026-01-06": 1,
          "2026-02-04": 1,
          "2026-02-20": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 264.07,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1,
            "254-256h": 1,
            "334-336h": 1,
            "424-426h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-14": 1,
            "2025-12-23": 1,
            "2026-02-04": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2025-12-14": 42.462678611111116,
            "2025-12-23": 255.052715,
            "2026-02-04": 334.5495413888889,
            "2026-05-04": 424.21399055555554
          },
          "time_count_per_day": {
            "2025-12-14": 1,
            "2025-12-23": 1,
            "2026-02-04": 1,
            "2026-05-04": 1
          }
        },
        "P3": {
          "avg_time_hours": 51.04,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 3,
            "44-46h": 1,
            "104-106h": 1,
            "148-150h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-12": 3,
            "2025-12-14": 1,
            "2026-01-06": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2025-12-12": 8.140764444444445,
            "2025-12-14": 44.37719,
            "2026-01-06": 149.28166916666666,
            "2026-02-20": 104.41259027777778
          },
          "time_count_per_day": {
            "2025-12-12": 3,
            "2025-12-14": 1,
            "2026-01-06": 1,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 136.25,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "2-4h": 3,
              "42-44h": 1,
              "44-46h": 1,
              "104-106h": 1,
              "148-150h": 1,
              "254-256h": 1,
              "334-336h": 1,
              "424-426h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-12-12": 3,
              "2025-12-14": 2,
              "2025-12-23": 1,
              "2026-01-06": 1,
              "2026-02-04": 1,
              "2026-02-20": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2025-12-12": 8.140764444444445,
              "2025-12-14": 86.83986861111111,
              "2025-12-23": 255.052715,
              "2026-01-06": 149.28166916666666,
              "2026-02-04": 334.5495413888889,
              "2026-02-20": 104.41259027777778,
              "2026-05-04": 424.21399055555554
            },
            "time_count_per_day": {
              "2025-12-12": 3,
              "2025-12-14": 2,
              "2025-12-23": 1,
              "2026-01-06": 1,
              "2026-02-04": 1,
              "2026-02-20": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 264.07,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1,
                "254-256h": 1,
                "334-336h": 1,
                "424-426h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-14": 1,
                "2025-12-23": 1,
                "2026-02-04": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2025-12-14": 42.462678611111116,
                "2025-12-23": 255.052715,
                "2026-02-04": 334.5495413888889,
                "2026-05-04": 424.21399055555554
              },
              "time_count_per_day": {
                "2025-12-14": 1,
                "2025-12-23": 1,
                "2026-02-04": 1,
                "2026-05-04": 1
              }
            },
            "P3": {
              "avg_time_hours": 51.04,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 3,
                "44-46h": 1,
                "104-106h": 1,
                "148-150h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-12": 3,
                "2025-12-14": 1,
                "2026-01-06": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2025-12-12": 8.140764444444445,
                "2025-12-14": 44.37719,
                "2026-01-06": 149.28166916666666,
                "2026-02-20": 104.41259027777778
              },
              "time_count_per_day": {
                "2025-12-12": 3,
                "2025-12-14": 1,
                "2026-01-06": 1,
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_662": {
      "overall": {
        "avg_time_hours": 0.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-12": 1
        },
        "time_per_day": {
          "2025-12-12": 0.10928222222222223
        },
        "time_count_per_day": {
          "2025-12-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.11,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-12": 1
          },
          "time_per_day": {
            "2025-12-12": 0.10928222222222223
          },
          "time_count_per_day": {
            "2025-12-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-12": 1
            },
            "time_per_day": {
              "2025-12-12": 0.10928222222222223
            },
            "time_count_per_day": {
              "2025-12-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.11,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-12": 1
              },
              "time_per_day": {
                "2025-12-12": 0.10928222222222223
              },
              "time_count_per_day": {
                "2025-12-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_386": {
      "overall": {
        "avg_time_hours": 65.72,
        "mode_time_hours": 65.0,
        "mode_frequency": 1,
        "time_distribution": {
          "64-66h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-15": 1
        },
        "time_per_day": {
          "2025-12-15": 65.72100472222222
        },
        "time_count_per_day": {
          "2025-12-15": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 65.72,
          "mode_time_hours": 65.0,
          "mode_frequency": 1,
          "time_distribution": {
            "64-66h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 65.72100472222222
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 65.72,
            "mode_time_hours": 65.0,
            "mode_frequency": 1,
            "time_distribution": {
              "64-66h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-15": 1
            },
            "time_per_day": {
              "2025-12-15": 65.72100472222222
            },
            "time_count_per_day": {
              "2025-12-15": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 65.72,
              "mode_time_hours": 65.0,
              "mode_frequency": 1,
              "time_distribution": {
                "64-66h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 65.72100472222222
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_663": {
      "overall": {
        "avg_time_hours": 0.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-12": 1
        },
        "time_per_day": {
          "2025-12-12": 0.24947166666666665
        },
        "time_count_per_day": {
          "2025-12-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-12": 1
          },
          "time_per_day": {
            "2025-12-12": 0.24947166666666665
          },
          "time_count_per_day": {
            "2025-12-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-12": 1
            },
            "time_per_day": {
              "2025-12-12": 0.24947166666666665
            },
            "time_count_per_day": {
              "2025-12-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-12": 1
              },
              "time_per_day": {
                "2025-12-12": 0.24947166666666665
              },
              "time_count_per_day": {
                "2025-12-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_664": {
      "overall": {
        "avg_time_hours": 202.17,
        "mode_time_hours": 45.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "4-6h": 2,
          "20-22h": 2,
          "22-24h": 1,
          "32-34h": 1,
          "44-46h": 2,
          "50-52h": 1,
          "172-174h": 1,
          "176-178h": 1,
          "286-288h": 1,
          "416-418h": 2,
          "886-888h": 1,
          "1030-1032h": 1
        },
        "tickets_count": 22,
        "tickets_per_day": {
          "2025-12-14": 1,
          "2025-12-26": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-02-18": 2,
          "2026-03-05": 1,
          "2026-03-17": 1,
          "2026-03-23": 2,
          "2026-03-26": 1,
          "2026-04-01": 1,
          "2026-04-20": 2,
          "2026-04-23": 2,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-11": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2025-12-14": 44.149615,
          "2025-12-26": 174.64307805555558,
          "2026-01-26": 0.6639122222222221,
          "2026-01-27": 32.77891805555556,
          "2026-02-18": 73.54913638888888,
          "2026-03-05": 4.407273055555556,
          "2026-03-17": 176.5627977777778,
          "2026-03-23": 832.5472172222222,
          "2026-03-26": 44.68744388888889,
          "2026-04-01": 21.761279166666665,
          "2026-04-23": 1917.2208158333333,
          "2026-05-06": 311.09885055555554,
          "2026-05-08": 4.985225277777778
        },
        "time_count_per_day": {
          "2025-12-14": 1,
          "2025-12-26": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-02-18": 2,
          "2026-03-05": 1,
          "2026-03-17": 1,
          "2026-03-23": 2,
          "2026-03-26": 1,
          "2026-04-01": 1,
          "2026-04-23": 2,
          "2026-05-06": 2,
          "2026-05-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-01-26": 0.6639122222222221
          },
          "time_count_per_day": {
            "2026-01-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 241.97,
          "mode_time_hours": 21.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 2,
            "20-22h": 2,
            "22-24h": 1,
            "44-46h": 1,
            "50-52h": 1,
            "176-178h": 1,
            "286-288h": 1,
            "416-418h": 2,
            "886-888h": 1,
            "1030-1032h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2026-02-18": 2,
            "2026-03-05": 1,
            "2026-03-17": 1,
            "2026-03-23": 2,
            "2026-03-26": 1,
            "2026-04-01": 1,
            "2026-04-20": 1,
            "2026-04-23": 2,
            "2026-05-06": 2,
            "2026-05-08": 1,
            "2026-05-11": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2025-12-26": 0.7690691666666666,
            "2026-02-18": 73.54913638888888,
            "2026-03-05": 4.407273055555556,
            "2026-03-17": 176.5627977777778,
            "2026-03-23": 832.5472172222222,
            "2026-03-26": 44.68744388888889,
            "2026-04-01": 21.761279166666665,
            "2026-04-23": 1917.2208158333333,
            "2026-05-06": 311.09885055555554,
            "2026-05-08": 4.985225277777778
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2026-02-18": 2,
            "2026-03-05": 1,
            "2026-03-17": 1,
            "2026-03-23": 2,
            "2026-03-26": 1,
            "2026-04-01": 1,
            "2026-04-23": 2,
            "2026-05-06": 2,
            "2026-05-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 83.6,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "44-46h": 1,
            "172-174h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-14": 1,
            "2025-12-26": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-12-14": 44.149615,
            "2025-12-26": 173.8740088888889,
            "2026-01-27": 32.77891805555556
          },
          "time_count_per_day": {
            "2025-12-14": 1,
            "2025-12-26": 1,
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 202.17,
            "mode_time_hours": 45.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "4-6h": 2,
              "20-22h": 2,
              "22-24h": 1,
              "32-34h": 1,
              "44-46h": 2,
              "50-52h": 1,
              "172-174h": 1,
              "176-178h": 1,
              "286-288h": 1,
              "416-418h": 2,
              "886-888h": 1,
              "1030-1032h": 1
            },
            "tickets_count": 18,
            "tickets_per_day": {
              "2025-12-14": 1,
              "2025-12-26": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-02-18": 2,
              "2026-03-05": 1,
              "2026-03-17": 1,
              "2026-03-23": 2,
              "2026-03-26": 1,
              "2026-04-01": 1,
              "2026-04-23": 2,
              "2026-05-06": 2,
              "2026-05-08": 1
            },
            "time_per_day": {
              "2025-12-14": 44.149615,
              "2025-12-26": 174.64307805555558,
              "2026-01-26": 0.6639122222222221,
              "2026-01-27": 32.77891805555556,
              "2026-02-18": 73.54913638888888,
              "2026-03-05": 4.407273055555556,
              "2026-03-17": 176.5627977777778,
              "2026-03-23": 832.5472172222222,
              "2026-03-26": 44.68744388888889,
              "2026-04-01": 21.761279166666665,
              "2026-04-23": 1917.2208158333333,
              "2026-05-06": 311.09885055555554,
              "2026-05-08": 4.985225277777778
            },
            "time_count_per_day": {
              "2025-12-14": 1,
              "2025-12-26": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-02-18": 2,
              "2026-03-05": 1,
              "2026-03-17": 1,
              "2026-03-23": 2,
              "2026-03-26": 1,
              "2026-04-01": 1,
              "2026-04-23": 2,
              "2026-05-06": 2,
              "2026-05-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-26": 1
              },
              "time_per_day": {
                "2026-01-26": 0.6639122222222221
              },
              "time_count_per_day": {
                "2026-01-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 241.97,
              "mode_time_hours": 21.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 2,
                "20-22h": 2,
                "22-24h": 1,
                "44-46h": 1,
                "50-52h": 1,
                "176-178h": 1,
                "286-288h": 1,
                "416-418h": 2,
                "886-888h": 1,
                "1030-1032h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-02-18": 2,
                "2026-03-05": 1,
                "2026-03-17": 1,
                "2026-03-23": 2,
                "2026-03-26": 1,
                "2026-04-01": 1,
                "2026-04-23": 2,
                "2026-05-06": 2,
                "2026-05-08": 1
              },
              "time_per_day": {
                "2025-12-26": 0.7690691666666666,
                "2026-02-18": 73.54913638888888,
                "2026-03-05": 4.407273055555556,
                "2026-03-17": 176.5627977777778,
                "2026-03-23": 832.5472172222222,
                "2026-03-26": 44.68744388888889,
                "2026-04-01": 21.761279166666665,
                "2026-04-23": 1917.2208158333333,
                "2026-05-06": 311.09885055555554,
                "2026-05-08": 4.985225277777778
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2026-02-18": 2,
                "2026-03-05": 1,
                "2026-03-17": 1,
                "2026-03-23": 2,
                "2026-03-26": 1,
                "2026-04-01": 1,
                "2026-04-23": 2,
                "2026-05-06": 2,
                "2026-05-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 83.6,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "44-46h": 1,
                "172-174h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-14": 1,
                "2025-12-26": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-12-14": 44.149615,
                "2025-12-26": 173.8740088888889,
                "2026-01-27": 32.77891805555556
              },
              "time_count_per_day": {
                "2025-12-14": 1,
                "2025-12-26": 1,
                "2026-01-27": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-20": 2,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-20": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_446": {
      "overall": {
        "avg_time_hours": 1080.49,
        "mode_time_hours": 1081.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1080-1082h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-26": 1
        },
        "time_per_day": {
          "2025-12-26": 1080.488341388889
        },
        "time_count_per_day": {
          "2025-12-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1080.49,
          "mode_time_hours": 1081.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1080-1082h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-12-26": 1080.488341388889
          },
          "time_count_per_day": {
            "2025-12-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1080.49,
            "mode_time_hours": 1081.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1080-1082h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-26": 1
            },
            "time_per_day": {
              "2025-12-26": 1080.488341388889
            },
            "time_count_per_day": {
              "2025-12-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1080.49,
              "mode_time_hours": 1081.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1080-1082h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-12-26": 1080.488341388889
              },
              "time_count_per_day": {
                "2025-12-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_510": {
      "overall": {
        "avg_time_hours": 2048.64,
        "mode_time_hours": 2049.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2048-2050h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 2048.637015
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 2048.64,
          "mode_time_hours": 2049.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2048-2050h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 2048.637015
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2048.64,
            "mode_time_hours": 2049.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2048-2050h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 2048.637015
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 2048.64,
              "mode_time_hours": 2049.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2048-2050h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 2048.637015
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_511": {
      "overall": {
        "avg_time_hours": 124.73,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "242-244h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2026-01-05": 1
        },
        "time_per_day": {
          "2025-11-17": 6.501731388888889,
          "2026-01-05": 242.96579666666668
        },
        "time_count_per_day": {
          "2025-11-17": 1,
          "2026-01-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.5,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-17": 1
          },
          "time_per_day": {
            "2025-11-17": 6.501731388888889
          },
          "time_count_per_day": {
            "2025-11-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 242.97,
          "mode_time_hours": 243.0,
          "mode_frequency": 1,
          "time_distribution": {
            "242-244h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-05": 1
          },
          "time_per_day": {
            "2026-01-05": 242.96579666666668
          },
          "time_count_per_day": {
            "2026-01-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 124.73,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "242-244h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-11-17": 1,
              "2026-01-05": 1
            },
            "time_per_day": {
              "2025-11-17": 6.501731388888889,
              "2026-01-05": 242.96579666666668
            },
            "time_count_per_day": {
              "2025-11-17": 1,
              "2026-01-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.5,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {
                "2025-11-17": 6.501731388888889
              },
              "time_count_per_day": {
                "2025-11-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 242.97,
              "mode_time_hours": 243.0,
              "mode_frequency": 1,
              "time_distribution": {
                "242-244h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {
                "2026-01-05": 242.96579666666668
              },
              "time_count_per_day": {
                "2026-01-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_537": {
      "overall": {
        "avg_time_hours": 1252.8,
        "mode_time_hours": 1253.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1252-1254h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-11": 1
        },
        "time_per_day": {
          "2026-01-11": 1252.7988599999999
        },
        "time_count_per_day": {
          "2026-01-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1252.8,
          "mode_time_hours": 1253.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1252-1254h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-11": 1
          },
          "time_per_day": {
            "2026-01-11": 1252.7988599999999
          },
          "time_count_per_day": {
            "2026-01-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1252.8,
            "mode_time_hours": 1253.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1252-1254h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-11": 1
            },
            "time_per_day": {
              "2026-01-11": 1252.7988599999999
            },
            "time_count_per_day": {
              "2026-01-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1252.8,
              "mode_time_hours": 1253.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1252-1254h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-11": 1
              },
              "time_per_day": {
                "2026-01-11": 1252.7988599999999
              },
              "time_count_per_day": {
                "2026-01-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_563": {
      "overall": {
        "avg_time_hours": 621.73,
        "mode_time_hours": 567.0,
        "mode_frequency": 1,
        "time_distribution": {
          "566-568h": 1,
          "674-676h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-18": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-12-18": 567.7195822222222,
          "2026-04-23": 675.7459752777778
        },
        "time_count_per_day": {
          "2025-12-18": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 621.73,
          "mode_time_hours": 567.0,
          "mode_frequency": 1,
          "time_distribution": {
            "566-568h": 1,
            "674-676h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-18": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2025-12-18": 567.7195822222222,
            "2026-04-23": 675.7459752777778
          },
          "time_count_per_day": {
            "2025-12-18": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 621.73,
            "mode_time_hours": 567.0,
            "mode_frequency": 1,
            "time_distribution": {
              "566-568h": 1,
              "674-676h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-18": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-12-18": 567.7195822222222,
              "2026-04-23": 675.7459752777778
            },
            "time_count_per_day": {
              "2025-12-18": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 621.73,
              "mode_time_hours": 567.0,
              "mode_frequency": 1,
              "time_distribution": {
                "566-568h": 1,
                "674-676h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-18": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2025-12-18": 567.7195822222222,
                "2026-04-23": 675.7459752777778
              },
              "time_count_per_day": {
                "2025-12-18": 1,
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_307": {
      "overall": {
        "avg_time_hours": 1278.47,
        "mode_time_hours": 2525.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "870-872h": 1,
          "1152-1154h": 1,
          "1416-1418h": 1,
          "1460-1462h": 1,
          "1518-1520h": 1,
          "2524-2526h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-04-22": 2
        },
        "time_per_day": {
          "2026-02-10": 1460.5243169444445,
          "2026-02-12": 1518.3335744444444,
          "2026-02-13": 1416.5753555555557,
          "2026-03-09": 3.397301111111111,
          "2026-03-10": 2524.9597302777775,
          "2026-04-22": 2025.5067744444445
        },
        "time_count_per_day": {
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-13": 1,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-04-22": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.4,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 3.397301111111111
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        },
        "P2": {
          "avg_time_hours": 1162.01,
          "mode_time_hours": 1461.0,
          "mode_frequency": 1,
          "time_distribution": {
            "870-872h": 1,
            "1152-1154h": 1,
            "1460-1462h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-04-22": 2
          },
          "time_per_day": {
            "2026-02-10": 1460.5243169444445,
            "2026-04-22": 2025.5067744444445
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-04-22": 2
          }
        },
        "P3": {
          "avg_time_hours": 1819.96,
          "mode_time_hours": 2525.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1416-1418h": 1,
            "1518-1520h": 1,
            "2524-2526h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-03-10": 1
          },
          "time_per_day": {
            "2026-02-12": 1518.3335744444444,
            "2026-02-13": 1416.5753555555557,
            "2026-03-10": 2524.9597302777775
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-03-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1278.47,
            "mode_time_hours": 2525.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "870-872h": 1,
              "1152-1154h": 1,
              "1416-1418h": 1,
              "1460-1462h": 1,
              "1518-1520h": 1,
              "2524-2526h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-04-22": 2
            },
            "time_per_day": {
              "2026-02-10": 1460.5243169444445,
              "2026-02-12": 1518.3335744444444,
              "2026-02-13": 1416.5753555555557,
              "2026-03-09": 3.397301111111111,
              "2026-03-10": 2524.9597302777775,
              "2026-04-22": 2025.5067744444445
            },
            "time_count_per_day": {
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-13": 1,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-04-22": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.4,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 3.397301111111111
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            },
            "P2": {
              "avg_time_hours": 1162.01,
              "mode_time_hours": 1461.0,
              "mode_frequency": 1,
              "time_distribution": {
                "870-872h": 1,
                "1152-1154h": 1,
                "1460-1462h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-04-22": 2
              },
              "time_per_day": {
                "2026-02-10": 1460.5243169444445,
                "2026-04-22": 2025.5067744444445
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-04-22": 2
              }
            },
            "P3": {
              "avg_time_hours": 1819.96,
              "mode_time_hours": 2525.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1416-1418h": 1,
                "1518-1520h": 1,
                "2524-2526h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-03-10": 1
              },
              "time_per_day": {
                "2026-02-12": 1518.3335744444444,
                "2026-02-13": 1416.5753555555557,
                "2026-03-10": 2524.9597302777775
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-02-13": 1,
                "2026-03-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_567": {
      "overall": {
        "avg_time_hours": 1035.3,
        "mode_time_hours": 1035.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1034-1036h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-07": 1
        },
        "time_per_day": {
          "2026-01-07": 1035.3001727777778
        },
        "time_count_per_day": {
          "2026-01-07": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1035.3,
          "mode_time_hours": 1035.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1034-1036h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 1035.3001727777778
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1035.3,
            "mode_time_hours": 1035.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1034-1036h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-07": 1
            },
            "time_per_day": {
              "2026-01-07": 1035.3001727777778
            },
            "time_count_per_day": {
              "2026-01-07": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1035.3,
              "mode_time_hours": 1035.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1034-1036h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 1035.3001727777778
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_568": {
      "overall": {
        "avg_time_hours": 91.39,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "28-30h": 1,
          "240-242h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-11-26": 1,
          "2026-01-15": 1,
          "2026-03-18": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-11-26": 28.89588638888889,
          "2026-01-15": 241.61536861111114,
          "2026-03-18": 3.657046388888889
        },
        "time_count_per_day": {
          "2025-11-26": 1,
          "2026-01-15": 1,
          "2026-03-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 122.64,
          "mode_time_hours": 241.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "240-242h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-03-18": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-01-15": 241.61536861111114,
            "2026-03-18": 3.657046388888889
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-03-18": 1
          }
        },
        "P3": {
          "avg_time_hours": 28.9,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-26": 1
          },
          "time_per_day": {
            "2025-11-26": 28.89588638888889
          },
          "time_count_per_day": {
            "2025-11-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 91.39,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "28-30h": 1,
              "240-242h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-11-26": 1,
              "2026-01-15": 1,
              "2026-03-18": 1
            },
            "time_per_day": {
              "2025-11-26": 28.89588638888889,
              "2026-01-15": 241.61536861111114,
              "2026-03-18": 3.657046388888889
            },
            "time_count_per_day": {
              "2025-11-26": 1,
              "2026-01-15": 1,
              "2026-03-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 122.64,
              "mode_time_hours": 241.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "240-242h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-01-15": 241.61536861111114,
                "2026-03-18": 3.657046388888889
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-03-18": 1
              }
            },
            "P3": {
              "avg_time_hours": 28.9,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-26": 1
              },
              "time_per_day": {
                "2025-11-26": 28.89588638888889
              },
              "time_count_per_day": {
                "2025-11-26": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_570": {
      "overall": {
        "avg_time_hours": 1031.02,
        "mode_time_hours": 1031.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1030-1032h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-07": 1
        },
        "time_per_day": {
          "2026-01-07": 1031.0169508333333
        },
        "time_count_per_day": {
          "2026-01-07": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1031.02,
          "mode_time_hours": 1031.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1030-1032h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 1031.0169508333333
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1031.02,
            "mode_time_hours": 1031.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1030-1032h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-07": 1
            },
            "time_per_day": {
              "2026-01-07": 1031.0169508333333
            },
            "time_count_per_day": {
              "2026-01-07": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1031.02,
              "mode_time_hours": 1031.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1030-1032h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 1031.0169508333333
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_607": {
      "overall": {
        "avg_time_hours": 141.75,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "4-6h": 1,
          "842-844h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-01-07": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-26": 1,
          "2026-02-16": 1,
          "2026-04-28": 1
        },
        "time_per_day": {
          "2026-01-07": 843.8079513888889,
          "2026-01-19": 1.1777502777777777,
          "2026-01-20": 0.33492111111111106,
          "2026-01-26": 4.494625833333333,
          "2026-02-16": 0.6405683333333333,
          "2026-04-28": 0.03707861111111111
        },
        "time_count_per_day": {
          "2026-01-07": 1,
          "2026-01-19": 1,
          "2026-01-20": 1,
          "2026-01-26": 1,
          "2026-02-16": 1,
          "2026-04-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "4-6h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-26": 1,
            "2026-02-16": 1,
            "2026-04-28": 1
          },
          "time_per_day": {
            "2026-01-19": 1.1777502777777777,
            "2026-01-20": 0.33492111111111106,
            "2026-01-26": 4.494625833333333,
            "2026-02-16": 0.6405683333333333,
            "2026-04-28": 0.03707861111111111
          },
          "time_count_per_day": {
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-26": 1,
            "2026-02-16": 1,
            "2026-04-28": 1
          }
        },
        "P3": {
          "avg_time_hours": 843.81,
          "mode_time_hours": 843.0,
          "mode_frequency": 1,
          "time_distribution": {
            "842-844h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 843.8079513888889
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.75,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "4-6h": 1,
              "842-844h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-01-07": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-26": 1,
              "2026-02-16": 1,
              "2026-04-28": 1
            },
            "time_per_day": {
              "2026-01-07": 843.8079513888889,
              "2026-01-19": 1.1777502777777777,
              "2026-01-20": 0.33492111111111106,
              "2026-01-26": 4.494625833333333,
              "2026-02-16": 0.6405683333333333,
              "2026-04-28": 0.03707861111111111
            },
            "time_count_per_day": {
              "2026-01-07": 1,
              "2026-01-19": 1,
              "2026-01-20": 1,
              "2026-01-26": 1,
              "2026-02-16": 1,
              "2026-04-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "4-6h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-26": 1,
                "2026-02-16": 1,
                "2026-04-28": 1
              },
              "time_per_day": {
                "2026-01-19": 1.1777502777777777,
                "2026-01-20": 0.33492111111111106,
                "2026-01-26": 4.494625833333333,
                "2026-02-16": 0.6405683333333333,
                "2026-04-28": 0.03707861111111111
              },
              "time_count_per_day": {
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-26": 1,
                "2026-02-16": 1,
                "2026-04-28": 1
              }
            },
            "P3": {
              "avg_time_hours": 843.81,
              "mode_time_hours": 843.0,
              "mode_frequency": 1,
              "time_distribution": {
                "842-844h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 843.8079513888889
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_122": {
      "overall": {
        "avg_time_hours": 271.73,
        "mode_time_hours": 723.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "360-362h": 1,
          "722-724h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-02": 1,
          "2026-03-18": 1,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2026-01-02": 722.3163430555555,
          "2026-03-18": 360.9222819444445,
          "2026-06-08": 3.673281666666667
        },
        "time_count_per_day": {
          "2026-01-02": 1,
          "2026-03-18": 1,
          "2026-06-08": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 242.0,
          "mode_time_hours": 723.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "722-724h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-02": 1,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2026-01-02": 722.3163430555555,
            "2026-06-08": 3.673281666666667
          },
          "time_count_per_day": {
            "2026-01-02": 1,
            "2026-06-08": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 360.92,
          "mode_time_hours": 361.0,
          "mode_frequency": 1,
          "time_distribution": {
            "360-362h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 360.9222819444445
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 271.73,
            "mode_time_hours": 723.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "360-362h": 1,
              "722-724h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-02": 1,
              "2026-03-18": 1,
              "2026-06-08": 2
            },
            "time_per_day": {
              "2026-01-02": 722.3163430555555,
              "2026-03-18": 360.9222819444445,
              "2026-06-08": 3.673281666666667
            },
            "time_count_per_day": {
              "2026-01-02": 1,
              "2026-03-18": 1,
              "2026-06-08": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 242.0,
              "mode_time_hours": 723.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "722-724h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-02": 1,
                "2026-06-08": 2
              },
              "time_per_day": {
                "2026-01-02": 722.3163430555555,
                "2026-06-08": 3.673281666666667
              },
              "time_count_per_day": {
                "2026-01-02": 1,
                "2026-06-08": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 360.92,
              "mode_time_hours": 361.0,
              "mode_frequency": 1,
              "time_distribution": {
                "360-362h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 360.9222819444445
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_619": {
      "overall": {
        "avg_time_hours": 534.26,
        "mode_time_hours": 535.0,
        "mode_frequency": 1,
        "time_distribution": {
          "534-536h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-26": 1
        },
        "time_per_day": {
          "2025-12-26": 534.2617983333333
        },
        "time_count_per_day": {
          "2025-12-26": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 534.26,
          "mode_time_hours": 535.0,
          "mode_frequency": 1,
          "time_distribution": {
            "534-536h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-12-26": 534.2617983333333
          },
          "time_count_per_day": {
            "2025-12-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 534.26,
            "mode_time_hours": 535.0,
            "mode_frequency": 1,
            "time_distribution": {
              "534-536h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-26": 1
            },
            "time_per_day": {
              "2025-12-26": 534.2617983333333
            },
            "time_count_per_day": {
              "2025-12-26": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 534.26,
              "mode_time_hours": 535.0,
              "mode_frequency": 1,
              "time_distribution": {
                "534-536h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-12-26": 534.2617983333333
              },
              "time_count_per_day": {
                "2025-12-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_632": {
      "overall": {
        "avg_time_hours": 1054.36,
        "mode_time_hours": 2109.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2108-2110h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-03": 1,
          "2026-04-22": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-03-03": 2108.1303505555557,
          "2026-04-22": 0.5835336111111111
        },
        "time_count_per_day": {
          "2026-03-03": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1054.36,
          "mode_time_hours": 2109.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2108-2110h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-03-03": 2108.1303505555557,
            "2026-04-22": 0.5835336111111111
          },
          "time_count_per_day": {
            "2026-03-03": 1,
            "2026-04-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1054.36,
            "mode_time_hours": 2109.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2108-2110h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-03-03": 2108.1303505555557,
              "2026-04-22": 0.5835336111111111
            },
            "time_count_per_day": {
              "2026-03-03": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1054.36,
              "mode_time_hours": 2109.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2108-2110h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-03-03": 2108.1303505555557,
                "2026-04-22": 0.5835336111111111
              },
              "time_count_per_day": {
                "2026-03-03": 1,
                "2026-04-22": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_633": {
      "overall": {
        "avg_time_hours": 240.44,
        "mode_time_hours": 241.0,
        "mode_frequency": 1,
        "time_distribution": {
          "240-242h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-15": 1
        },
        "time_per_day": {
          "2025-12-15": 240.4424311111111
        },
        "time_count_per_day": {
          "2025-12-15": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 240.44,
          "mode_time_hours": 241.0,
          "mode_frequency": 1,
          "time_distribution": {
            "240-242h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 240.4424311111111
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 240.44,
            "mode_time_hours": 241.0,
            "mode_frequency": 1,
            "time_distribution": {
              "240-242h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-15": 1
            },
            "time_per_day": {
              "2025-12-15": 240.4424311111111
            },
            "time_count_per_day": {
              "2025-12-15": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 240.44,
              "mode_time_hours": 241.0,
              "mode_frequency": 1,
              "time_distribution": {
                "240-242h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 240.4424311111111
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_646": {
      "overall": {
        "avg_time_hours": 414.53,
        "mode_time_hours": 505.0,
        "mode_frequency": 2,
        "time_distribution": {
          "126-128h": 1,
          "504-506h": 2,
          "520-522h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-02-19": 3
        },
        "time_per_day": {
          "2025-12-15": 127.00159166666666,
          "2026-02-19": 1531.1100455555556
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-02-19": 3
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 127.0,
          "mode_time_hours": 127.0,
          "mode_frequency": 1,
          "time_distribution": {
            "126-128h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 127.00159166666666
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 510.37,
          "mode_time_hours": 505.0,
          "mode_frequency": 2,
          "time_distribution": {
            "504-506h": 2,
            "520-522h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 1531.1100455555556
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 414.53,
            "mode_time_hours": 505.0,
            "mode_frequency": 2,
            "time_distribution": {
              "126-128h": 1,
              "504-506h": 2,
              "520-522h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-02-19": 3
            },
            "time_per_day": {
              "2025-12-15": 127.00159166666666,
              "2026-02-19": 1531.1100455555556
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-02-19": 3
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 127.0,
              "mode_time_hours": 127.0,
              "mode_frequency": 1,
              "time_distribution": {
                "126-128h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 127.00159166666666
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 510.37,
              "mode_time_hours": 505.0,
              "mode_frequency": 2,
              "time_distribution": {
                "504-506h": 2,
                "520-522h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 1531.1100455555556
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        }
      }
    },
    "cliente_649": {
      "overall": {
        "avg_time_hours": 36.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "22-24h": 1,
          "120-122h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-03-03": 2,
          "2026-04-20": 1,
          "2026-04-21": 1
        },
        "time_per_day": {
          "2025-12-15": 121.58293805555556,
          "2026-03-03": 23.917180277777778,
          "2026-04-21": 0.24932111111111113
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-03-03": 2,
          "2026-04-21": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 23.75,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {
            "2026-03-03": 23.74983138888889
          },
          "time_count_per_day": {
            "2026-03-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 0.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-04-20": 1,
            "2026-04-21": 1
          },
          "time_per_day": {
            "2026-03-03": 0.16734888888888888,
            "2026-04-21": 0.24932111111111113
          },
          "time_count_per_day": {
            "2026-03-03": 1,
            "2026-04-21": 1
          }
        },
        "P3": {
          "avg_time_hours": 121.58,
          "mode_time_hours": 121.0,
          "mode_frequency": 1,
          "time_distribution": {
            "120-122h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 121.58293805555556
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 36.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "22-24h": 1,
              "120-122h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-03-03": 2,
              "2026-04-21": 1
            },
            "time_per_day": {
              "2025-12-15": 121.58293805555556,
              "2026-03-03": 23.917180277777778,
              "2026-04-21": 0.24932111111111113
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-03-03": 2,
              "2026-04-21": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 23.75,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {
                "2026-03-03": 23.74983138888889
              },
              "time_count_per_day": {
                "2026-03-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 0.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-04-21": 1
              },
              "time_per_day": {
                "2026-03-03": 0.16734888888888888,
                "2026-04-21": 0.24932111111111113
              },
              "time_count_per_day": {
                "2026-03-03": 1,
                "2026-04-21": 1
              }
            },
            "P3": {
              "avg_time_hours": 121.58,
              "mode_time_hours": 121.0,
              "mode_frequency": 1,
              "time_distribution": {
                "120-122h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 121.58293805555556
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_650": {
      "overall": {
        "avg_time_hours": 1698.26,
        "mode_time_hours": 1699.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1698-1700h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 1698.257174722222
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1698.26,
          "mode_time_hours": 1699.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1698-1700h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 1698.257174722222
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1698.26,
            "mode_time_hours": 1699.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1698-1700h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 1698.257174722222
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1698.26,
              "mode_time_hours": 1699.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1698-1700h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 1698.257174722222
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_656": {
      "overall": {
        "avg_time_hours": 139.42,
        "mode_time_hours": 131.0,
        "mode_frequency": 1,
        "time_distribution": {
          "130-132h": 1,
          "146-148h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-17": 1,
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-17": 130.94058583333333,
          "2025-12-18": 147.89681861111112
        },
        "time_count_per_day": {
          "2025-12-17": 1,
          "2025-12-18": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 139.42,
          "mode_time_hours": 131.0,
          "mode_frequency": 1,
          "time_distribution": {
            "130-132h": 1,
            "146-148h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-17": 1,
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-17": 130.94058583333333,
            "2025-12-18": 147.89681861111112
          },
          "time_count_per_day": {
            "2025-12-17": 1,
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 139.42,
            "mode_time_hours": 131.0,
            "mode_frequency": 1,
            "time_distribution": {
              "130-132h": 1,
              "146-148h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-17": 1,
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-17": 130.94058583333333,
              "2025-12-18": 147.89681861111112
            },
            "time_count_per_day": {
              "2025-12-17": 1,
              "2025-12-18": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 139.42,
              "mode_time_hours": 131.0,
              "mode_frequency": 1,
              "time_distribution": {
                "130-132h": 1,
                "146-148h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-17": 1,
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-17": 130.94058583333333,
                "2025-12-18": 147.89681861111112
              },
              "time_count_per_day": {
                "2025-12-17": 1,
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_657": {
      "overall": {
        "avg_time_hours": 100.72,
        "mode_time_hours": 79.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1,
          "122-124h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-01-19": 1
        },
        "time_per_day": {
          "2025-12-15": 78.81162083333334,
          "2026-01-19": 122.63784749999999
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 122.64,
          "mode_time_hours": 123.0,
          "mode_frequency": 1,
          "time_distribution": {
            "122-124h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 122.63784749999999
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 78.81,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 78.81162083333334
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 100.72,
            "mode_time_hours": 79.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1,
              "122-124h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-01-19": 1
            },
            "time_per_day": {
              "2025-12-15": 78.81162083333334,
              "2026-01-19": 122.63784749999999
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 122.64,
              "mode_time_hours": 123.0,
              "mode_frequency": 1,
              "time_distribution": {
                "122-124h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 122.63784749999999
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 78.81,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 78.81162083333334
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_455": {
      "overall": {
        "avg_time_hours": 10.26,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 4,
          "4-6h": 1,
          "24-26h": 2,
          "72-74h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-12-15": 2,
          "2026-02-03": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-28": 2,
          "2026-03-03": 1,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-05-21": 1,
          "2026-06-03": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-12-15": 73.20791666666666,
          "2026-02-03": 0.19979333333333332,
          "2026-02-20": 25.83906111111111,
          "2026-02-24": 0.6947961111111112,
          "2026-02-28": 6.443006111111112,
          "2026-03-09": 0.8146363888888888,
          "2026-03-10": 4.5083786111111115,
          "2026-05-21": 1.7090755555555555,
          "2026-06-03": 24.57738666666667,
          "2026-06-05": 5.670357777777778
        },
        "time_count_per_day": {
          "2025-12-15": 2,
          "2026-02-03": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-02-28": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-05-21": 1,
          "2026-06-03": 1,
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 24.58,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 24.57738666666667
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 9.16,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 4,
            "4-6h": 1,
            "24-26h": 1,
            "72-74h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2025-12-15": 2,
            "2026-02-03": 1,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-28": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-05-21": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-12-15": 73.20791666666666,
            "2026-02-03": 0.19979333333333332,
            "2026-02-20": 25.83906111111111,
            "2026-02-24": 0.6947961111111112,
            "2026-02-28": 6.443006111111112,
            "2026-03-09": 0.8146363888888888,
            "2026-03-10": 4.5083786111111115,
            "2026-05-21": 1.7090755555555555,
            "2026-06-05": 5.670357777777778
          },
          "time_count_per_day": {
            "2025-12-15": 2,
            "2026-02-03": 1,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-28": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-05-21": 1,
            "2026-06-05": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.26,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 4,
              "4-6h": 1,
              "24-26h": 2,
              "72-74h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-12-15": 2,
              "2026-02-03": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-28": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-05-21": 1,
              "2026-06-03": 1,
              "2026-06-05": 2
            },
            "time_per_day": {
              "2025-12-15": 73.20791666666666,
              "2026-02-03": 0.19979333333333332,
              "2026-02-20": 25.83906111111111,
              "2026-02-24": 0.6947961111111112,
              "2026-02-28": 6.443006111111112,
              "2026-03-09": 0.8146363888888888,
              "2026-03-10": 4.5083786111111115,
              "2026-05-21": 1.7090755555555555,
              "2026-06-03": 24.57738666666667,
              "2026-06-05": 5.670357777777778
            },
            "time_count_per_day": {
              "2025-12-15": 2,
              "2026-02-03": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-02-28": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-05-21": 1,
              "2026-06-03": 1,
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 24.58,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 24.57738666666667
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 9.16,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 4,
                "4-6h": 1,
                "24-26h": 1,
                "72-74h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2025-12-15": 2,
                "2026-02-03": 1,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-28": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-05-21": 1,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-12-15": 73.20791666666666,
                "2026-02-03": 0.19979333333333332,
                "2026-02-20": 25.83906111111111,
                "2026-02-24": 0.6947961111111112,
                "2026-02-28": 6.443006111111112,
                "2026-03-09": 0.8146363888888888,
                "2026-03-10": 4.5083786111111115,
                "2026-05-21": 1.7090755555555555,
                "2026-06-05": 5.670357777777778
              },
              "time_count_per_day": {
                "2025-12-15": 2,
                "2026-02-03": 1,
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-02-28": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-05-21": 1,
                "2026-06-05": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_660": {
      "overall": {
        "avg_time_hours": 574.14,
        "mode_time_hours": 575.0,
        "mode_frequency": 1,
        "time_distribution": {
          "574-576h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-05": 1
        },
        "time_per_day": {
          "2026-01-05": 574.1438419444445
        },
        "time_count_per_day": {
          "2026-01-05": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 574.14,
          "mode_time_hours": 575.0,
          "mode_frequency": 1,
          "time_distribution": {
            "574-576h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-05": 1
          },
          "time_per_day": {
            "2026-01-05": 574.1438419444445
          },
          "time_count_per_day": {
            "2026-01-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 574.14,
            "mode_time_hours": 575.0,
            "mode_frequency": 1,
            "time_distribution": {
              "574-576h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-05": 1
            },
            "time_per_day": {
              "2026-01-05": 574.1438419444445
            },
            "time_count_per_day": {
              "2026-01-05": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 574.14,
              "mode_time_hours": 575.0,
              "mode_frequency": 1,
              "time_distribution": {
                "574-576h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {
                "2026-01-05": 574.1438419444445
              },
              "time_count_per_day": {
                "2026-01-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_661": {
      "overall": {
        "avg_time_hours": 314.8,
        "mode_time_hours": 73.0,
        "mode_frequency": 1,
        "time_distribution": {
          "72-74h": 1,
          "556-558h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-01-07": 1
        },
        "time_per_day": {
          "2025-12-15": 73.25284333333333,
          "2026-01-07": 556.352245
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-01-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 556.35,
          "mode_time_hours": 557.0,
          "mode_frequency": 1,
          "time_distribution": {
            "556-558h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 556.352245
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 73.25,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "72-74h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 73.25284333333333
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 314.8,
            "mode_time_hours": 73.0,
            "mode_frequency": 1,
            "time_distribution": {
              "72-74h": 1,
              "556-558h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-01-07": 1
            },
            "time_per_day": {
              "2025-12-15": 73.25284333333333,
              "2026-01-07": 556.352245
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-01-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 556.35,
              "mode_time_hours": 557.0,
              "mode_frequency": 1,
              "time_distribution": {
                "556-558h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 556.352245
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 73.25,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "72-74h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 73.25284333333333
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_666": {
      "overall": {
        "avg_time_hours": 1102.04,
        "mode_time_hours": 1103.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1102-1104h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-27": 1
        },
        "time_per_day": {
          "2026-01-27": 1102.0432963888888
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1102.04,
          "mode_time_hours": 1103.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1102-1104h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 1102.0432963888888
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1102.04,
            "mode_time_hours": 1103.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1102-1104h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 1102.0432963888888
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1102.04,
              "mode_time_hours": 1103.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1102-1104h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 1102.0432963888888
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_648": {
      "overall": {
        "avg_time_hours": 97.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "4-6h": 1,
          "10-12h": 1,
          "16-18h": 1,
          "24-26h": 2,
          "32-34h": 1,
          "48-50h": 1,
          "70-72h": 1,
          "84-86h": 1,
          "258-260h": 1,
          "312-314h": 1,
          "1044-1046h": 1
        },
        "tickets_count": 24,
        "tickets_per_day": {
          "2025-12-16": 1,
          "2026-01-13": 3,
          "2026-01-17": 1,
          "2026-01-22": 1,
          "2026-02-16": 3,
          "2026-02-19": 2,
          "2026-02-21": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-31": 1,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-17": 1,
          "2026-04-28": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-12-16": 85.33078166666667,
          "2026-01-13": 83.09826222222223,
          "2026-01-17": 259.3188797222222,
          "2026-01-22": 3.738845277777778,
          "2026-02-19": 1117.6547841666666,
          "2026-02-21": 17.182158055555554,
          "2026-03-17": 3.4585775,
          "2026-03-18": 312.80330277777773,
          "2026-03-20": 49.46635305555556,
          "2026-03-23": 0.4502119444444444,
          "2026-04-01": 1.5399444444444446,
          "2026-04-02": 11.240466388888889,
          "2026-04-08": 4.017108611111111,
          "2026-04-09": 2.1873227777777777,
          "2026-04-17": 0.09432638888888889,
          "2026-04-28": 0.3264077777777778,
          "2026-06-01": 0.14522111111111113
        },
        "time_count_per_day": {
          "2025-12-16": 1,
          "2026-01-13": 3,
          "2026-01-17": 1,
          "2026-01-22": 1,
          "2026-02-19": 2,
          "2026-02-21": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-17": 1,
          "2026-04-28": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 12.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 2,
            "4-6h": 1,
            "10-12h": 1,
            "32-34h": 1,
            "84-86h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-12-16": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-03-23": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-17": 1,
            "2026-04-28": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-12-16": 85.33078166666667,
            "2026-01-13": 32.28200694444445,
            "2026-01-22": 3.738845277777778,
            "2026-03-23": 0.4502119444444444,
            "2026-04-01": 1.5399444444444446,
            "2026-04-02": 11.240466388888889,
            "2026-04-08": 4.017108611111111,
            "2026-04-09": 2.1873227777777777,
            "2026-04-17": 0.09432638888888889,
            "2026-04-28": 0.3264077777777778,
            "2026-06-01": 0.14522111111111113
          },
          "time_count_per_day": {
            "2025-12-16": 1,
            "2026-01-13": 1,
            "2026-01-22": 1,
            "2026-03-23": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-08": 1,
            "2026-04-09": 1,
            "2026-04-17": 1,
            "2026-04-28": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 25.37,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 25.36715611111111
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 90.93,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "16-18h": 1,
            "48-50h": 1,
            "70-72h": 1,
            "312-314h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-02-19": 71.74803722222222,
            "2026-02-21": 17.182158055555554,
            "2026-03-17": 3.4585775,
            "2026-03-18": 312.80330277777773,
            "2026-03-20": 49.46635305555556
          },
          "time_count_per_day": {
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-03-17": 1,
            "2026-03-18": 1,
            "2026-03-20": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 443.56,
          "mode_time_hours": 1045.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "258-260h": 1,
            "1044-1046h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-01-17": 1,
            "2026-02-16": 3,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-13": 25.449099166666667,
            "2026-01-17": 259.3188797222222,
            "2026-02-19": 1045.9067469444444
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-01-17": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 97.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "4-6h": 1,
              "10-12h": 1,
              "16-18h": 1,
              "24-26h": 2,
              "32-34h": 1,
              "48-50h": 1,
              "70-72h": 1,
              "84-86h": 1,
              "258-260h": 1,
              "312-314h": 1,
              "1044-1046h": 1
            },
            "tickets_count": 20,
            "tickets_per_day": {
              "2025-12-16": 1,
              "2026-01-13": 3,
              "2026-01-17": 1,
              "2026-01-22": 1,
              "2026-02-19": 2,
              "2026-02-21": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-17": 1,
              "2026-04-28": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-12-16": 85.33078166666667,
              "2026-01-13": 83.09826222222223,
              "2026-01-17": 259.3188797222222,
              "2026-01-22": 3.738845277777778,
              "2026-02-19": 1117.6547841666666,
              "2026-02-21": 17.182158055555554,
              "2026-03-17": 3.4585775,
              "2026-03-18": 312.80330277777773,
              "2026-03-20": 49.46635305555556,
              "2026-03-23": 0.4502119444444444,
              "2026-04-01": 1.5399444444444446,
              "2026-04-02": 11.240466388888889,
              "2026-04-08": 4.017108611111111,
              "2026-04-09": 2.1873227777777777,
              "2026-04-17": 0.09432638888888889,
              "2026-04-28": 0.3264077777777778,
              "2026-06-01": 0.14522111111111113
            },
            "time_count_per_day": {
              "2025-12-16": 1,
              "2026-01-13": 3,
              "2026-01-17": 1,
              "2026-01-22": 1,
              "2026-02-19": 2,
              "2026-02-21": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-17": 1,
              "2026-04-28": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 12.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 2,
                "4-6h": 1,
                "10-12h": 1,
                "32-34h": 1,
                "84-86h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2025-12-16": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-03-23": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-17": 1,
                "2026-04-28": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-12-16": 85.33078166666667,
                "2026-01-13": 32.28200694444445,
                "2026-01-22": 3.738845277777778,
                "2026-03-23": 0.4502119444444444,
                "2026-04-01": 1.5399444444444446,
                "2026-04-02": 11.240466388888889,
                "2026-04-08": 4.017108611111111,
                "2026-04-09": 2.1873227777777777,
                "2026-04-17": 0.09432638888888889,
                "2026-04-28": 0.3264077777777778,
                "2026-06-01": 0.14522111111111113
              },
              "time_count_per_day": {
                "2025-12-16": 1,
                "2026-01-13": 1,
                "2026-01-22": 1,
                "2026-03-23": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-08": 1,
                "2026-04-09": 1,
                "2026-04-17": 1,
                "2026-04-28": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 25.37,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 25.36715611111111
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 90.93,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "16-18h": 1,
                "48-50h": 1,
                "70-72h": 1,
                "312-314h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-02-19": 71.74803722222222,
                "2026-02-21": 17.182158055555554,
                "2026-03-17": 3.4585775,
                "2026-03-18": 312.80330277777773,
                "2026-03-20": 49.46635305555556
              },
              "time_count_per_day": {
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-03-17": 1,
                "2026-03-18": 1,
                "2026-03-20": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 443.56,
              "mode_time_hours": 1045.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "258-260h": 1,
                "1044-1046h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-01-17": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-13": 25.449099166666667,
                "2026-01-17": 259.3188797222222,
                "2026-02-19": 1045.9067469444444
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-01-17": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-16": 3,
              "2026-03-31": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-16": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_670": {
      "overall": {
        "avg_time_hours": 163.67,
        "mode_time_hours": 43.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "42-44h": 1,
          "446-448h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-03-18": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2025-12-15": 43.01847083333333,
          "2026-03-18": 447.28843944444446,
          "2026-04-23": 0.7146952777777777
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-03-18": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.71,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 0.7146952777777777
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 245.15,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1,
            "446-448h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-15": 1,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2025-12-15": 43.01847083333333,
            "2026-03-18": 447.28843944444446
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 163.67,
            "mode_time_hours": 43.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "42-44h": 1,
              "446-448h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-03-18": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2025-12-15": 43.01847083333333,
              "2026-03-18": 447.28843944444446,
              "2026-04-23": 0.7146952777777777
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-03-18": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.71,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 0.7146952777777777
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 245.15,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1,
                "446-448h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2025-12-15": 43.01847083333333,
                "2026-03-18": 447.28843944444446
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_671": {
      "overall": {
        "avg_time_hours": 27.93,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-15": 1
        },
        "time_per_day": {
          "2025-12-15": 27.930587777777777
        },
        "time_count_per_day": {
          "2025-12-15": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 27.93,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 27.930587777777777
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 27.93,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-15": 1
            },
            "time_per_day": {
              "2025-12-15": 27.930587777777777
            },
            "time_count_per_day": {
              "2025-12-15": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 27.93,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 27.930587777777777
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_672": {
      "overall": {
        "avg_time_hours": 27.11,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-15": 1
        },
        "time_per_day": {
          "2025-12-15": 27.113613611111113
        },
        "time_count_per_day": {
          "2025-12-15": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 27.11,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 27.113613611111113
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 27.11,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-15": 1
            },
            "time_per_day": {
              "2025-12-15": 27.113613611111113
            },
            "time_count_per_day": {
              "2025-12-15": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 27.11,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 27.113613611111113
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_673": {
      "overall": {
        "avg_time_hours": 79.69,
        "mode_time_hours": 79.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-17": 1
        },
        "time_per_day": {
          "2025-12-17": 79.68533000000001
        },
        "time_count_per_day": {
          "2025-12-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 79.69,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-17": 1
          },
          "time_per_day": {
            "2025-12-17": 79.68533000000001
          },
          "time_count_per_day": {
            "2025-12-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 79.69,
            "mode_time_hours": 79.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-17": 1
            },
            "time_per_day": {
              "2025-12-17": 79.68533000000001
            },
            "time_count_per_day": {
              "2025-12-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 79.69,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-17": 1
              },
              "time_per_day": {
                "2025-12-17": 79.68533000000001
              },
              "time_count_per_day": {
                "2025-12-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_674": {
      "overall": {
        "avg_time_hours": 250.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "16-18h": 1,
          "20-22h": 1,
          "52-54h": 1,
          "56-58h": 2,
          "90-92h": 1,
          "148-150h": 1,
          "270-272h": 1,
          "272-274h": 2,
          "276-278h": 2,
          "306-308h": 2,
          "310-312h": 1,
          "382-384h": 1,
          "422-424h": 1,
          "444-446h": 2,
          "684-686h": 1,
          "1152-1154h": 1
        },
        "tickets_count": 30,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2025-12-30": 2,
          "2026-01-21": 2,
          "2026-01-23": 1,
          "2026-01-30": 1,
          "2026-02-06": 3,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-03-18": 3,
          "2026-03-24": 2,
          "2026-03-26": 2,
          "2026-03-27": 2,
          "2026-04-06": 1,
          "2026-05-07": 2,
          "2026-05-11": 1,
          "2026-05-16": 2
        },
        "time_per_day": {
          "2025-12-15": 20.980728611111115,
          "2025-12-30": 436.3867225,
          "2026-01-21": 112.9948161111111,
          "2026-01-23": 271.10345944444447,
          "2026-01-30": 149.10031833333332,
          "2026-02-06": 860.0487108333333,
          "2026-02-17": 276.0439463888889,
          "2026-02-19": 1297.3648161111112,
          "2026-03-18": 1312.9792288888889,
          "2026-03-24": 364.00421555555556,
          "2026-03-26": 1169.6801608333335,
          "2026-03-27": 1.1168127777777779,
          "2026-05-16": 2.3640097222222223
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2025-12-30": 2,
          "2026-01-21": 2,
          "2026-01-23": 1,
          "2026-01-30": 1,
          "2026-02-06": 3,
          "2026-02-17": 1,
          "2026-02-19": 3,
          "2026-03-18": 3,
          "2026-03-24": 2,
          "2026-03-26": 2,
          "2026-03-27": 2,
          "2026-05-16": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.87,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-27": 2,
            "2026-05-16": 2
          },
          "time_per_day": {
            "2026-03-27": 1.1168127777777779,
            "2026-05-16": 2.3640097222222223
          },
          "time_count_per_day": {
            "2026-03-27": 2,
            "2026-05-16": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 276.3,
          "mode_time_hours": 57.0,
          "mode_frequency": 2,
          "time_distribution": {
            "16-18h": 1,
            "20-22h": 1,
            "52-54h": 1,
            "56-58h": 2,
            "90-92h": 1,
            "148-150h": 1,
            "270-272h": 1,
            "272-274h": 2,
            "276-278h": 2,
            "310-312h": 1,
            "382-384h": 1,
            "422-424h": 1,
            "444-446h": 2,
            "1152-1154h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2025-12-15": 1,
            "2025-12-30": 2,
            "2026-01-21": 2,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-06": 3,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-18": 3,
            "2026-03-24": 2,
            "2026-03-26": 2,
            "2026-04-06": 1,
            "2026-05-07": 2,
            "2026-05-11": 1
          },
          "time_per_day": {
            "2025-12-15": 20.980728611111115,
            "2025-12-30": 436.3867225,
            "2026-01-21": 112.9948161111111,
            "2026-01-23": 271.10345944444447,
            "2026-01-30": 149.10031833333332,
            "2026-02-06": 860.0487108333333,
            "2026-02-17": 276.0439463888889,
            "2026-03-18": 1312.9792288888889,
            "2026-03-24": 364.00421555555556,
            "2026-03-26": 1169.6801608333335
          },
          "time_count_per_day": {
            "2025-12-15": 1,
            "2025-12-30": 2,
            "2026-01-21": 2,
            "2026-01-23": 1,
            "2026-01-30": 1,
            "2026-02-06": 3,
            "2026-02-17": 1,
            "2026-03-18": 3,
            "2026-03-24": 2,
            "2026-03-26": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 432.45,
          "mode_time_hours": 307.0,
          "mode_frequency": 2,
          "time_distribution": {
            "306-308h": 2,
            "684-686h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 1297.3648161111112
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 250.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "16-18h": 1,
              "20-22h": 1,
              "52-54h": 1,
              "56-58h": 2,
              "90-92h": 1,
              "148-150h": 1,
              "270-272h": 1,
              "272-274h": 2,
              "276-278h": 2,
              "306-308h": 2,
              "310-312h": 1,
              "382-384h": 1,
              "422-424h": 1,
              "444-446h": 2,
              "684-686h": 1,
              "1152-1154h": 1
            },
            "tickets_count": 25,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2025-12-30": 2,
              "2026-01-21": 2,
              "2026-01-23": 1,
              "2026-01-30": 1,
              "2026-02-06": 3,
              "2026-02-17": 1,
              "2026-02-19": 3,
              "2026-03-18": 3,
              "2026-03-24": 2,
              "2026-03-26": 2,
              "2026-03-27": 2,
              "2026-05-16": 2
            },
            "time_per_day": {
              "2025-12-15": 20.980728611111115,
              "2025-12-30": 436.3867225,
              "2026-01-21": 112.9948161111111,
              "2026-01-23": 271.10345944444447,
              "2026-01-30": 149.10031833333332,
              "2026-02-06": 860.0487108333333,
              "2026-02-17": 276.0439463888889,
              "2026-02-19": 1297.3648161111112,
              "2026-03-18": 1312.9792288888889,
              "2026-03-24": 364.00421555555556,
              "2026-03-26": 1169.6801608333335,
              "2026-03-27": 1.1168127777777779,
              "2026-05-16": 2.3640097222222223
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2025-12-30": 2,
              "2026-01-21": 2,
              "2026-01-23": 1,
              "2026-01-30": 1,
              "2026-02-06": 3,
              "2026-02-17": 1,
              "2026-02-19": 3,
              "2026-03-18": 3,
              "2026-03-24": 2,
              "2026-03-26": 2,
              "2026-03-27": 2,
              "2026-05-16": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.87,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-27": 2,
                "2026-05-16": 2
              },
              "time_per_day": {
                "2026-03-27": 1.1168127777777779,
                "2026-05-16": 2.3640097222222223
              },
              "time_count_per_day": {
                "2026-03-27": 2,
                "2026-05-16": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 276.3,
              "mode_time_hours": 57.0,
              "mode_frequency": 2,
              "time_distribution": {
                "16-18h": 1,
                "20-22h": 1,
                "52-54h": 1,
                "56-58h": 2,
                "90-92h": 1,
                "148-150h": 1,
                "270-272h": 1,
                "272-274h": 2,
                "276-278h": 2,
                "310-312h": 1,
                "382-384h": 1,
                "422-424h": 1,
                "444-446h": 2,
                "1152-1154h": 1
              },
              "tickets_count": 18,
              "tickets_per_day": {
                "2025-12-15": 1,
                "2025-12-30": 2,
                "2026-01-21": 2,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-06": 3,
                "2026-02-17": 1,
                "2026-03-18": 3,
                "2026-03-24": 2,
                "2026-03-26": 2
              },
              "time_per_day": {
                "2025-12-15": 20.980728611111115,
                "2025-12-30": 436.3867225,
                "2026-01-21": 112.9948161111111,
                "2026-01-23": 271.10345944444447,
                "2026-01-30": 149.10031833333332,
                "2026-02-06": 860.0487108333333,
                "2026-02-17": 276.0439463888889,
                "2026-03-18": 1312.9792288888889,
                "2026-03-24": 364.00421555555556,
                "2026-03-26": 1169.6801608333335
              },
              "time_count_per_day": {
                "2025-12-15": 1,
                "2025-12-30": 2,
                "2026-01-21": 2,
                "2026-01-23": 1,
                "2026-01-30": 1,
                "2026-02-06": 3,
                "2026-02-17": 1,
                "2026-03-18": 3,
                "2026-03-24": 2,
                "2026-03-26": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 432.45,
              "mode_time_hours": 307.0,
              "mode_frequency": 2,
              "time_distribution": {
                "306-308h": 2,
                "684-686h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 1297.3648161111112
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-06": 1,
              "2026-05-07": 2,
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-06": 1,
                "2026-05-07": 2,
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_575": {
      "overall": {
        "avg_time_hours": 273.11,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "540-542h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-15": 1,
          "2026-02-03": 1
        },
        "time_per_day": {
          "2025-12-15": 5.467918333333333,
          "2026-02-03": 540.75726
        },
        "time_count_per_day": {
          "2025-12-15": 1,
          "2026-02-03": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 5.47,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 5.467918333333333
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 540.76,
          "mode_time_hours": 541.0,
          "mode_frequency": 1,
          "time_distribution": {
            "540-542h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 540.75726
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 273.11,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "540-542h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-15": 1,
              "2026-02-03": 1
            },
            "time_per_day": {
              "2025-12-15": 5.467918333333333,
              "2026-02-03": 540.75726
            },
            "time_count_per_day": {
              "2025-12-15": 1,
              "2026-02-03": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 5.47,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 5.467918333333333
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 540.76,
              "mode_time_hours": 541.0,
              "mode_frequency": 1,
              "time_distribution": {
                "540-542h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 540.75726
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_680": {
      "overall": {
        "avg_time_hours": 338.04,
        "mode_time_hours": 339.0,
        "mode_frequency": 1,
        "time_distribution": {
          "338-340h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 338.03713305555556
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 338.04,
          "mode_time_hours": 339.0,
          "mode_frequency": 1,
          "time_distribution": {
            "338-340h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 338.03713305555556
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 338.04,
            "mode_time_hours": 339.0,
            "mode_frequency": 1,
            "time_distribution": {
              "338-340h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 338.03713305555556
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 338.04,
              "mode_time_hours": 339.0,
              "mode_frequency": 1,
              "time_distribution": {
                "338-340h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 338.03713305555556
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_681": {
      "overall": {
        "avg_time_hours": 9.51,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-15": 1
        },
        "time_per_day": {
          "2025-12-15": 9.507380555555555
        },
        "time_count_per_day": {
          "2025-12-15": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 9.51,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-15": 1
          },
          "time_per_day": {
            "2025-12-15": 9.507380555555555
          },
          "time_count_per_day": {
            "2025-12-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.51,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-15": 1
            },
            "time_per_day": {
              "2025-12-15": 9.507380555555555
            },
            "time_count_per_day": {
              "2025-12-15": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 9.51,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-15": 1
              },
              "time_per_day": {
                "2025-12-15": 9.507380555555555
              },
              "time_count_per_day": {
                "2025-12-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_301": {
      "overall": {
        "avg_time_hours": 363.7,
        "mode_time_hours": 363.0,
        "mode_frequency": 1,
        "time_distribution": {
          "362-364h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-12-30": 363.7043161111111
        },
        "time_count_per_day": {
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 363.7,
          "mode_time_hours": 363.0,
          "mode_frequency": 1,
          "time_distribution": {
            "362-364h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-12-30": 363.7043161111111
          },
          "time_count_per_day": {
            "2025-12-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 363.7,
            "mode_time_hours": 363.0,
            "mode_frequency": 1,
            "time_distribution": {
              "362-364h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-12-30": 363.7043161111111
            },
            "time_count_per_day": {
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 363.7,
              "mode_time_hours": 363.0,
              "mode_frequency": 1,
              "time_distribution": {
                "362-364h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-12-30": 363.7043161111111
              },
              "time_count_per_day": {
                "2025-12-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_682": {
      "overall": {
        "avg_time_hours": 166.26,
        "mode_time_hours": 167.0,
        "mode_frequency": 1,
        "time_distribution": {
          "166-168h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-22": 1
        },
        "time_per_day": {
          "2025-12-22": 166.26021694444444
        },
        "time_count_per_day": {
          "2025-12-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 166.26,
          "mode_time_hours": 167.0,
          "mode_frequency": 1,
          "time_distribution": {
            "166-168h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-22": 1
          },
          "time_per_day": {
            "2025-12-22": 166.26021694444444
          },
          "time_count_per_day": {
            "2025-12-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 166.26,
            "mode_time_hours": 167.0,
            "mode_frequency": 1,
            "time_distribution": {
              "166-168h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-22": 1
            },
            "time_per_day": {
              "2025-12-22": 166.26021694444444
            },
            "time_count_per_day": {
              "2025-12-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 166.26,
              "mode_time_hours": 167.0,
              "mode_frequency": 1,
              "time_distribution": {
                "166-168h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-22": 1
              },
              "time_per_day": {
                "2025-12-22": 166.26021694444444
              },
              "time_count_per_day": {
                "2025-12-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_683": {
      "overall": {
        "avg_time_hours": 70.66,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-18": 70.65572888888889
        },
        "time_count_per_day": {
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 70.66,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 70.65572888888889
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.66,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-18": 70.65572888888889
            },
            "time_count_per_day": {
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 70.66,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 70.65572888888889
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_263": {
      "overall": {
        "avg_time_hours": 905.25,
        "mode_time_hours": 1423.0,
        "mode_frequency": 1,
        "time_distribution": {
          "386-388h": 1,
          "1422-1424h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-02-12": 1423.754651388889,
          "2026-04-10": 386.7413147222222
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 386.74,
          "mode_time_hours": 387.0,
          "mode_frequency": 1,
          "time_distribution": {
            "386-388h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 386.7413147222222
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        },
        "P3": {
          "avg_time_hours": 1423.75,
          "mode_time_hours": 1423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1422-1424h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 1423.754651388889
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 905.25,
            "mode_time_hours": 1423.0,
            "mode_frequency": 1,
            "time_distribution": {
              "386-388h": 1,
              "1422-1424h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-02-12": 1423.754651388889,
              "2026-04-10": 386.7413147222222
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 386.74,
              "mode_time_hours": 387.0,
              "mode_frequency": 1,
              "time_distribution": {
                "386-388h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 386.7413147222222
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            },
            "P3": {
              "avg_time_hours": 1423.75,
              "mode_time_hours": 1423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1422-1424h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 1423.754651388889
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_685": {
      "overall": {
        "avg_time_hours": 775.23,
        "mode_time_hours": 1361.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "12-14h": 1,
          "238-240h": 1,
          "1360-1362h": 1,
          "1488-1490h": 1,
          "1546-1548h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-12-26": 1,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-05-22": 3,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2025-12-26": 0.35276861111111113,
          "2026-02-06": 238.44548416666666,
          "2026-02-10": 1361.5478094444445,
          "2026-02-19": 3037.1431022222223,
          "2026-05-22": 13.912664166666667
        },
        "time_count_per_day": {
          "2025-12-26": 1,
          "2026-02-06": 1,
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-05-22": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 13.91,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-22": 1
          },
          "time_per_day": {
            "2026-05-22": 13.912664166666667
          },
          "time_count_per_day": {
            "2026-05-22": 1
          }
        },
        "P2": {
          "avg_time_hours": 0.35,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-12-26": 0.35276861111111113
          },
          "time_count_per_day": {
            "2025-12-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 1361.55,
          "mode_time_hours": 1361.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1360-1362h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 1361.5478094444445
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 238.45,
          "mode_time_hours": 239.0,
          "mode_frequency": 1,
          "time_distribution": {
            "238-240h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-06": 1,
            "2026-05-22": 2,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-02-06": 238.44548416666666
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1518.57,
          "mode_time_hours": 1547.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1488-1490h": 1,
            "1546-1548h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 3037.1431022222223
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 775.23,
            "mode_time_hours": 1361.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "12-14h": 1,
              "238-240h": 1,
              "1360-1362h": 1,
              "1488-1490h": 1,
              "1546-1548h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2025-12-26": 1,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-05-22": 1
            },
            "time_per_day": {
              "2025-12-26": 0.35276861111111113,
              "2026-02-06": 238.44548416666666,
              "2026-02-10": 1361.5478094444445,
              "2026-02-19": 3037.1431022222223,
              "2026-05-22": 13.912664166666667
            },
            "time_count_per_day": {
              "2025-12-26": 1,
              "2026-02-06": 1,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-05-22": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 13.91,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-22": 1
              },
              "time_per_day": {
                "2026-05-22": 13.912664166666667
              },
              "time_count_per_day": {
                "2026-05-22": 1
              }
            },
            "P2": {
              "avg_time_hours": 0.35,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-12-26": 0.35276861111111113
              },
              "time_count_per_day": {
                "2025-12-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 1361.55,
              "mode_time_hours": 1361.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1360-1362h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 1361.5478094444445
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 238.45,
              "mode_time_hours": 239.0,
              "mode_frequency": 1,
              "time_distribution": {
                "238-240h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 238.44548416666666
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1518.57,
              "mode_time_hours": 1547.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1488-1490h": 1,
                "1546-1548h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 3037.1431022222223
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-22": 2,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-22": 2,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_686": {
      "overall": {
        "avg_time_hours": 68.58,
        "mode_time_hours": 67.0,
        "mode_frequency": 2,
        "time_distribution": {
          "66-68h": 2,
          "68-70h": 1,
          "70-72h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-18": 3,
          "2025-12-23": 1
        },
        "time_per_day": {
          "2025-12-18": 204.25200194444446,
          "2025-12-23": 70.06721472222222
        },
        "time_count_per_day": {
          "2025-12-18": 3,
          "2025-12-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 68.19,
          "mode_time_hours": 67.0,
          "mode_frequency": 2,
          "time_distribution": {
            "66-68h": 2,
            "70-72h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-18": 2,
            "2025-12-23": 1
          },
          "time_per_day": {
            "2025-12-18": 134.4959102777778,
            "2025-12-23": 70.06721472222222
          },
          "time_count_per_day": {
            "2025-12-18": 2,
            "2025-12-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 69.76,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 69.75609166666666
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 68.58,
            "mode_time_hours": 67.0,
            "mode_frequency": 2,
            "time_distribution": {
              "66-68h": 2,
              "68-70h": 1,
              "70-72h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-18": 3,
              "2025-12-23": 1
            },
            "time_per_day": {
              "2025-12-18": 204.25200194444446,
              "2025-12-23": 70.06721472222222
            },
            "time_count_per_day": {
              "2025-12-18": 3,
              "2025-12-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 68.19,
              "mode_time_hours": 67.0,
              "mode_frequency": 2,
              "time_distribution": {
                "66-68h": 2,
                "70-72h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-18": 2,
                "2025-12-23": 1
              },
              "time_per_day": {
                "2025-12-18": 134.4959102777778,
                "2025-12-23": 70.06721472222222
              },
              "time_count_per_day": {
                "2025-12-18": 2,
                "2025-12-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 69.76,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 69.75609166666666
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_687": {
      "overall": {
        "avg_time_hours": 55.04,
        "mode_time_hours": 55.0,
        "mode_frequency": 1,
        "time_distribution": {
          "54-56h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-18": 55.037414444444444
        },
        "time_count_per_day": {
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 55.04,
          "mode_time_hours": 55.0,
          "mode_frequency": 1,
          "time_distribution": {
            "54-56h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 55.037414444444444
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 55.04,
            "mode_time_hours": 55.0,
            "mode_frequency": 1,
            "time_distribution": {
              "54-56h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-18": 55.037414444444444
            },
            "time_count_per_day": {
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 55.04,
              "mode_time_hours": 55.0,
              "mode_frequency": 1,
              "time_distribution": {
                "54-56h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 55.037414444444444
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_688": {
      "overall": {
        "avg_time_hours": 0.63,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-16": 1,
          "2026-03-06": 1
        },
        "time_per_day": {
          "2025-12-16": 0.8651227777777778,
          "2026-03-06": 0.4027552777777778
        },
        "time_count_per_day": {
          "2025-12-16": 1,
          "2026-03-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-16": 1,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2025-12-16": 0.8651227777777778,
            "2026-03-06": 0.4027552777777778
          },
          "time_count_per_day": {
            "2025-12-16": 1,
            "2026-03-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.63,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-16": 1,
              "2026-03-06": 1
            },
            "time_per_day": {
              "2025-12-16": 0.8651227777777778,
              "2026-03-06": 0.4027552777777778
            },
            "time_count_per_day": {
              "2025-12-16": 1,
              "2026-03-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-16": 1,
                "2026-03-06": 1
              },
              "time_per_day": {
                "2025-12-16": 0.8651227777777778,
                "2026-03-06": 0.4027552777777778
              },
              "time_count_per_day": {
                "2025-12-16": 1,
                "2026-03-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_689": {
      "overall": {
        "avg_time_hours": 0.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-16": 1,
          "2026-05-12": 1
        },
        "time_per_day": {
          "2025-12-16": 0.007784166666666667,
          "2026-05-12": 0.1930361111111111
        },
        "time_count_per_day": {
          "2025-12-16": 1,
          "2026-05-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.1,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-16": 1,
            "2026-05-12": 1
          },
          "time_per_day": {
            "2025-12-16": 0.007784166666666667,
            "2026-05-12": 0.1930361111111111
          },
          "time_count_per_day": {
            "2025-12-16": 1,
            "2026-05-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-16": 1,
              "2026-05-12": 1
            },
            "time_per_day": {
              "2025-12-16": 0.007784166666666667,
              "2026-05-12": 0.1930361111111111
            },
            "time_count_per_day": {
              "2025-12-16": 1,
              "2026-05-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.1,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-16": 1,
                "2026-05-12": 1
              },
              "time_per_day": {
                "2025-12-16": 0.007784166666666667,
                "2026-05-12": 0.1930361111111111
              },
              "time_count_per_day": {
                "2025-12-16": 1,
                "2026-05-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_690": {
      "overall": {
        "avg_time_hours": 7.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "26-28h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-17": 1,
          "2026-01-27": 1,
          "2026-02-05": 1,
          "2026-04-20": 1
        },
        "time_per_day": {
          "2025-12-17": 1.1525911111111111,
          "2026-01-27": 27.417410555555556,
          "2026-02-05": 0.12447944444444443,
          "2026-04-20": 0.17955027777777777
        },
        "time_count_per_day": {
          "2025-12-17": 1,
          "2026-01-27": 1,
          "2026-02-05": 1,
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-05": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-02-05": 0.12447944444444443,
            "2026-04-20": 0.17955027777777777
          },
          "time_count_per_day": {
            "2026-02-05": 1,
            "2026-04-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 14.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "26-28h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-17": 1,
            "2026-01-27": 1
          },
          "time_per_day": {
            "2025-12-17": 1.1525911111111111,
            "2026-01-27": 27.417410555555556
          },
          "time_count_per_day": {
            "2025-12-17": 1,
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 7.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "26-28h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-17": 1,
              "2026-01-27": 1,
              "2026-02-05": 1,
              "2026-04-20": 1
            },
            "time_per_day": {
              "2025-12-17": 1.1525911111111111,
              "2026-01-27": 27.417410555555556,
              "2026-02-05": 0.12447944444444443,
              "2026-04-20": 0.17955027777777777
            },
            "time_count_per_day": {
              "2025-12-17": 1,
              "2026-01-27": 1,
              "2026-02-05": 1,
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-05": 1,
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-02-05": 0.12447944444444443,
                "2026-04-20": 0.17955027777777777
              },
              "time_count_per_day": {
                "2026-02-05": 1,
                "2026-04-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 14.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "26-28h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-17": 1,
                "2026-01-27": 1
              },
              "time_per_day": {
                "2025-12-17": 1.1525911111111111,
                "2026-01-27": 27.417410555555556
              },
              "time_count_per_day": {
                "2025-12-17": 1,
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_691": {
      "overall": {
        "avg_time_hours": 5.27,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-17": 1
        },
        "time_per_day": {
          "2025-12-17": 5.271853333333333
        },
        "time_count_per_day": {
          "2025-12-17": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 5.27,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-17": 1
          },
          "time_per_day": {
            "2025-12-17": 5.271853333333333
          },
          "time_count_per_day": {
            "2025-12-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.27,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-17": 1
            },
            "time_per_day": {
              "2025-12-17": 5.271853333333333
            },
            "time_count_per_day": {
              "2025-12-17": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 5.27,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-17": 1
              },
              "time_per_day": {
                "2025-12-17": 5.271853333333333
              },
              "time_count_per_day": {
                "2025-12-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_692": {
      "overall": {
        "avg_time_hours": 200.5,
        "mode_time_hours": 157.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "24-26h": 1,
          "26-28h": 1,
          "102-104h": 1,
          "122-124h": 1,
          "140-142h": 1,
          "156-158h": 3,
          "158-160h": 1,
          "258-260h": 1,
          "312-314h": 1,
          "330-332h": 1,
          "394-396h": 1,
          "474-476h": 1,
          "584-586h": 1
        },
        "tickets_count": 20,
        "tickets_per_day": {
          "2026-01-02": 1,
          "2026-01-08": 1,
          "2026-01-24": 3,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-04": 1,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-18": 6,
          "2026-03-24": 1,
          "2026-05-12": 1,
          "2026-05-20": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-01-02": 394.66765722222226,
          "2026-01-08": 0.08173166666666666,
          "2026-01-24": 965.8364305555556,
          "2026-02-18": 27.63991638888889,
          "2026-02-19": 475.53366083333333,
          "2026-03-11": 0.38526222222222223,
          "2026-03-14": 24.597218055555555,
          "2026-03-18": 1275.3467541666664,
          "2026-03-24": 141.0199425,
          "2026-06-02": 103.47356638888888
        },
        "time_count_per_day": {
          "2026-01-02": 1,
          "2026-01-08": 1,
          "2026-01-24": 3,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-11": 1,
          "2026-03-14": 1,
          "2026-03-18": 6,
          "2026-03-24": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 34.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "102-104h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-03-11": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-01-08": 0.08173166666666666,
            "2026-03-11": 0.38526222222222223,
            "2026-06-02": 103.47356638888888
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-03-11": 1,
            "2026-06-02": 1
          }
        },
        "P3": {
          "avg_time_hours": 306.25,
          "mode_time_hours": 585.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1,
            "584-586h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-24": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-24": 584.8514547222222,
            "2026-02-18": 27.63991638888889
          },
          "time_count_per_day": {
            "2026-01-24": 1,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 182.19,
          "mode_time_hours": 157.0,
          "mode_frequency": 3,
          "time_distribution": {
            "24-26h": 1,
            "122-124h": 1,
            "140-142h": 1,
            "156-158h": 3,
            "158-160h": 1,
            "258-260h": 1,
            "312-314h": 1,
            "330-332h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2026-01-24": 2,
            "2026-03-04": 1,
            "2026-03-14": 1,
            "2026-03-18": 6,
            "2026-03-24": 1,
            "2026-05-12": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2026-01-24": 380.9849758333333,
            "2026-03-14": 24.597218055555555,
            "2026-03-18": 1275.3467541666664,
            "2026-03-24": 141.0199425
          },
          "time_count_per_day": {
            "2026-01-24": 2,
            "2026-03-14": 1,
            "2026-03-18": 6,
            "2026-03-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 435.1,
          "mode_time_hours": 395.0,
          "mode_frequency": 1,
          "time_distribution": {
            "394-396h": 1,
            "474-476h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-02": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-02": 394.66765722222226,
            "2026-02-19": 475.53366083333333
          },
          "time_count_per_day": {
            "2026-01-02": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 200.5,
            "mode_time_hours": 157.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "24-26h": 1,
              "26-28h": 1,
              "102-104h": 1,
              "122-124h": 1,
              "140-142h": 1,
              "156-158h": 3,
              "158-160h": 1,
              "258-260h": 1,
              "312-314h": 1,
              "330-332h": 1,
              "394-396h": 1,
              "474-476h": 1,
              "584-586h": 1
            },
            "tickets_count": 17,
            "tickets_per_day": {
              "2026-01-02": 1,
              "2026-01-08": 1,
              "2026-01-24": 3,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-18": 6,
              "2026-03-24": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-01-02": 394.66765722222226,
              "2026-01-08": 0.08173166666666666,
              "2026-01-24": 965.8364305555556,
              "2026-02-18": 27.63991638888889,
              "2026-02-19": 475.53366083333333,
              "2026-03-11": 0.38526222222222223,
              "2026-03-14": 24.597218055555555,
              "2026-03-18": 1275.3467541666664,
              "2026-03-24": 141.0199425,
              "2026-06-02": 103.47356638888888
            },
            "time_count_per_day": {
              "2026-01-02": 1,
              "2026-01-08": 1,
              "2026-01-24": 3,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-11": 1,
              "2026-03-14": 1,
              "2026-03-18": 6,
              "2026-03-24": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 34.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "102-104h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-03-11": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-01-08": 0.08173166666666666,
                "2026-03-11": 0.38526222222222223,
                "2026-06-02": 103.47356638888888
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-03-11": 1,
                "2026-06-02": 1
              }
            },
            "P3": {
              "avg_time_hours": 306.25,
              "mode_time_hours": 585.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1,
                "584-586h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-24": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-24": 584.8514547222222,
                "2026-02-18": 27.63991638888889
              },
              "time_count_per_day": {
                "2026-01-24": 1,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 182.19,
              "mode_time_hours": 157.0,
              "mode_frequency": 3,
              "time_distribution": {
                "24-26h": 1,
                "122-124h": 1,
                "140-142h": 1,
                "156-158h": 3,
                "158-160h": 1,
                "258-260h": 1,
                "312-314h": 1,
                "330-332h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-24": 2,
                "2026-03-14": 1,
                "2026-03-18": 6,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-01-24": 380.9849758333333,
                "2026-03-14": 24.597218055555555,
                "2026-03-18": 1275.3467541666664,
                "2026-03-24": 141.0199425
              },
              "time_count_per_day": {
                "2026-01-24": 2,
                "2026-03-14": 1,
                "2026-03-18": 6,
                "2026-03-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 435.1,
              "mode_time_hours": 395.0,
              "mode_frequency": 1,
              "time_distribution": {
                "394-396h": 1,
                "474-476h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-02": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-02": 394.66765722222226,
                "2026-02-19": 475.53366083333333
              },
              "time_count_per_day": {
                "2026-01-02": 1,
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-04": 1,
              "2026-05-12": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-05-12": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_323": {
      "overall": {
        "avg_time_hours": 0.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-17": 2
        },
        "time_per_day": {
          "2025-12-17": 0.10357361111111112
        },
        "time_count_per_day": {
          "2025-12-17": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-17": 2
          },
          "time_per_day": {
            "2025-12-17": 0.10357361111111112
          },
          "time_count_per_day": {
            "2025-12-17": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-17": 2
            },
            "time_per_day": {
              "2025-12-17": 0.10357361111111112
            },
            "time_count_per_day": {
              "2025-12-17": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-17": 2
              },
              "time_per_day": {
                "2025-12-17": 0.10357361111111112
              },
              "time_count_per_day": {
                "2025-12-17": 2
              }
            }
          }
        }
      }
    },
    "cliente_693": {
      "overall": {
        "avg_time_hours": 1162.71,
        "mode_time_hours": 1163.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1162-1164h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 1162.7091377777779
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1162.71,
          "mode_time_hours": 1163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1162-1164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 1162.7091377777779
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1162.71,
            "mode_time_hours": 1163.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1162-1164h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 1162.7091377777779
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1162.71,
              "mode_time_hours": 1163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1162-1164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 1162.7091377777779
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_433": {
      "overall": {
        "avg_time_hours": 112.71,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 2,
          "12-14h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "26-28h": 1,
          "32-34h": 1,
          "48-50h": 1,
          "52-54h": 1,
          "124-126h": 1,
          "148-150h": 1,
          "170-172h": 1,
          "208-210h": 1,
          "262-264h": 1,
          "268-270h": 2,
          "402-404h": 1,
          "434-436h": 1
        },
        "tickets_count": 25,
        "tickets_per_day": {
          "2025-12-18": 1,
          "2026-01-22": 1,
          "2026-02-06": 1,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-03-03": 1,
          "2026-03-06": 2,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-06": 1,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-04-21": 1,
          "2026-05-07": 1,
          "2026-05-16": 1,
          "2026-05-18": 2,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-12-18": 33.2982725,
          "2026-01-22": 23.52322583333333,
          "2026-02-06": 53.5252675,
          "2026-02-11": 125.39068194444445,
          "2026-02-12": 20.62233527777778,
          "2026-02-18": 148.4389052777778,
          "2026-02-19": 209.47773194444443,
          "2026-02-20": 3.0028744444444446,
          "2026-02-21": 0.6057138888888889,
          "2026-02-23": 12.111933333333333,
          "2026-02-24": 14.8401325,
          "2026-03-03": 435.91808444444445,
          "2026-03-06": 536.6841708333333,
          "2026-04-01": 26.65867111111111,
          "2026-04-02": 18.261160833333335,
          "2026-04-06": 3.421308055555556,
          "2026-04-14": 402.84039972222223,
          "2026-04-15": 16.704761944444442,
          "2026-05-07": 24.915463888888887,
          "2026-05-18": 218.30751527777775,
          "2026-05-26": 263.8695902777778
        },
        "time_count_per_day": {
          "2025-12-18": 1,
          "2026-01-22": 1,
          "2026-02-06": 1,
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-21": 1,
          "2026-02-23": 1,
          "2026-02-24": 1,
          "2026-03-03": 1,
          "2026-03-06": 2,
          "2026-04-01": 1,
          "2026-04-02": 1,
          "2026-04-06": 1,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-05-07": 1,
          "2026-05-18": 2,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 121.54,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 2,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "24-26h": 1,
            "26-28h": 1,
            "48-50h": 1,
            "124-126h": 1,
            "170-172h": 1,
            "262-264h": 1,
            "268-270h": 1,
            "402-404h": 1,
            "434-436h": 1
          },
          "tickets_count": 17,
          "tickets_per_day": {
            "2026-02-11": 1,
            "2026-02-20": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-03-03": 1,
            "2026-03-06": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-06": 1,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-04-21": 1,
            "2026-05-07": 1,
            "2026-05-16": 1,
            "2026-05-18": 2,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-11": 125.39068194444445,
            "2026-02-20": 3.0028744444444446,
            "2026-02-21": 0.6057138888888889,
            "2026-02-24": 14.8401325,
            "2026-03-03": 435.91808444444445,
            "2026-03-06": 268.3431083333333,
            "2026-04-01": 26.65867111111111,
            "2026-04-02": 18.261160833333335,
            "2026-04-06": 3.421308055555556,
            "2026-04-14": 402.84039972222223,
            "2026-04-15": 16.704761944444442,
            "2026-05-07": 24.915463888888887,
            "2026-05-18": 218.30751527777775,
            "2026-05-26": 263.8695902777778
          },
          "time_count_per_day": {
            "2026-02-11": 1,
            "2026-02-20": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-03-03": 1,
            "2026-03-06": 1,
            "2026-04-01": 1,
            "2026-04-02": 1,
            "2026-04-06": 1,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-05-07": 1,
            "2026-05-18": 2,
            "2026-05-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 91.29,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "22-24h": 1,
            "32-34h": 1,
            "52-54h": 1,
            "148-150h": 1,
            "268-270h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-18": 1,
            "2026-01-22": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2025-12-18": 33.2982725,
            "2026-01-22": 23.52322583333333,
            "2026-02-06": 53.5252675,
            "2026-02-12": 20.62233527777778,
            "2026-02-18": 148.4389052777778,
            "2026-03-06": 268.34106249999996
          },
          "time_count_per_day": {
            "2025-12-18": 1,
            "2026-01-22": 1,
            "2026-02-06": 1,
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-03-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 12.11,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-23": 1
          },
          "time_per_day": {
            "2026-02-23": 12.111933333333333
          },
          "time_count_per_day": {
            "2026-02-23": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 209.48,
          "mode_time_hours": 209.0,
          "mode_frequency": 1,
          "time_distribution": {
            "208-210h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 209.47773194444443
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 112.71,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 2,
              "12-14h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "26-28h": 1,
              "32-34h": 1,
              "48-50h": 1,
              "52-54h": 1,
              "124-126h": 1,
              "148-150h": 1,
              "170-172h": 1,
              "208-210h": 1,
              "262-264h": 1,
              "268-270h": 2,
              "402-404h": 1,
              "434-436h": 1
            },
            "tickets_count": 23,
            "tickets_per_day": {
              "2025-12-18": 1,
              "2026-01-22": 1,
              "2026-02-06": 1,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-03-03": 1,
              "2026-03-06": 2,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-06": 1,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-05-07": 1,
              "2026-05-18": 2,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-12-18": 33.2982725,
              "2026-01-22": 23.52322583333333,
              "2026-02-06": 53.5252675,
              "2026-02-11": 125.39068194444445,
              "2026-02-12": 20.62233527777778,
              "2026-02-18": 148.4389052777778,
              "2026-02-19": 209.47773194444443,
              "2026-02-20": 3.0028744444444446,
              "2026-02-21": 0.6057138888888889,
              "2026-02-23": 12.111933333333333,
              "2026-02-24": 14.8401325,
              "2026-03-03": 435.91808444444445,
              "2026-03-06": 536.6841708333333,
              "2026-04-01": 26.65867111111111,
              "2026-04-02": 18.261160833333335,
              "2026-04-06": 3.421308055555556,
              "2026-04-14": 402.84039972222223,
              "2026-04-15": 16.704761944444442,
              "2026-05-07": 24.915463888888887,
              "2026-05-18": 218.30751527777775,
              "2026-05-26": 263.8695902777778
            },
            "time_count_per_day": {
              "2025-12-18": 1,
              "2026-01-22": 1,
              "2026-02-06": 1,
              "2026-02-11": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-21": 1,
              "2026-02-23": 1,
              "2026-02-24": 1,
              "2026-03-03": 1,
              "2026-03-06": 2,
              "2026-04-01": 1,
              "2026-04-02": 1,
              "2026-04-06": 1,
              "2026-04-14": 1,
              "2026-04-15": 1,
              "2026-05-07": 1,
              "2026-05-18": 2,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 121.54,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 2,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "24-26h": 1,
                "26-28h": 1,
                "48-50h": 1,
                "124-126h": 1,
                "170-172h": 1,
                "262-264h": 1,
                "268-270h": 1,
                "402-404h": 1,
                "434-436h": 1
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2026-02-11": 1,
                "2026-02-20": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-06": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-06": 1,
                "2026-04-14": 1,
                "2026-04-15": 1,
                "2026-05-07": 1,
                "2026-05-18": 2,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-02-11": 125.39068194444445,
                "2026-02-20": 3.0028744444444446,
                "2026-02-21": 0.6057138888888889,
                "2026-02-24": 14.8401325,
                "2026-03-03": 435.91808444444445,
                "2026-03-06": 268.3431083333333,
                "2026-04-01": 26.65867111111111,
                "2026-04-02": 18.261160833333335,
                "2026-04-06": 3.421308055555556,
                "2026-04-14": 402.84039972222223,
                "2026-04-15": 16.704761944444442,
                "2026-05-07": 24.915463888888887,
                "2026-05-18": 218.30751527777775,
                "2026-05-26": 263.8695902777778
              },
              "time_count_per_day": {
                "2026-02-11": 1,
                "2026-02-20": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-03-03": 1,
                "2026-03-06": 1,
                "2026-04-01": 1,
                "2026-04-02": 1,
                "2026-04-06": 1,
                "2026-04-14": 1,
                "2026-04-15": 1,
                "2026-05-07": 1,
                "2026-05-18": 2,
                "2026-05-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 91.29,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "22-24h": 1,
                "32-34h": 1,
                "52-54h": 1,
                "148-150h": 1,
                "268-270h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2025-12-18": 1,
                "2026-01-22": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-06": 1
              },
              "time_per_day": {
                "2025-12-18": 33.2982725,
                "2026-01-22": 23.52322583333333,
                "2026-02-06": 53.5252675,
                "2026-02-12": 20.62233527777778,
                "2026-02-18": 148.4389052777778,
                "2026-03-06": 268.34106249999996
              },
              "time_count_per_day": {
                "2025-12-18": 1,
                "2026-01-22": 1,
                "2026-02-06": 1,
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-03-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 12.11,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {
                "2026-02-23": 12.111933333333333
              },
              "time_count_per_day": {
                "2026-02-23": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 209.48,
              "mode_time_hours": 209.0,
              "mode_frequency": 1,
              "time_distribution": {
                "208-210h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 209.47773194444443
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_694": {
      "overall": {
        "avg_time_hours": 839.33,
        "mode_time_hours": 839.0,
        "mode_frequency": 1,
        "time_distribution": {
          "838-840h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-21": 1
        },
        "time_per_day": {
          "2026-01-21": 839.32918
        },
        "time_count_per_day": {
          "2026-01-21": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 839.33,
          "mode_time_hours": 839.0,
          "mode_frequency": 1,
          "time_distribution": {
            "838-840h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 839.32918
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 839.33,
            "mode_time_hours": 839.0,
            "mode_frequency": 1,
            "time_distribution": {
              "838-840h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {
              "2026-01-21": 839.32918
            },
            "time_count_per_day": {
              "2026-01-21": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 839.33,
              "mode_time_hours": 839.0,
              "mode_frequency": 1,
              "time_distribution": {
                "838-840h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 839.32918
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_695": {
      "overall": {
        "avg_time_hours": 25.74,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-18": 25.73860861111111
        },
        "time_count_per_day": {
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 25.74,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 25.73860861111111
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 25.74,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-18": 25.73860861111111
            },
            "time_count_per_day": {
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 25.74,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 25.73860861111111
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_696": {
      "overall": {
        "avg_time_hours": 688.47,
        "mode_time_hours": 1377.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "1376-1378h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-17": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2025-12-17": 0.7667794444444445,
          "2026-02-12": 1376.1744058333331
        },
        "time_count_per_day": {
          "2025-12-17": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.77,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-17": 1
          },
          "time_per_day": {
            "2025-12-17": 0.7667794444444445
          },
          "time_count_per_day": {
            "2025-12-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 1376.17,
          "mode_time_hours": 1377.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1376-1378h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 1376.1744058333331
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 688.47,
            "mode_time_hours": 1377.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "1376-1378h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-17": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2025-12-17": 0.7667794444444445,
              "2026-02-12": 1376.1744058333331
            },
            "time_count_per_day": {
              "2025-12-17": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.77,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-17": 1
              },
              "time_per_day": {
                "2025-12-17": 0.7667794444444445
              },
              "time_count_per_day": {
                "2025-12-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 1376.17,
              "mode_time_hours": 1377.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1376-1378h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 1376.1744058333331
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_697": {
      "overall": {
        "avg_time_hours": 122.23,
        "mode_time_hours": 123.0,
        "mode_frequency": 1,
        "time_distribution": {
          "122-124h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-22": 1
        },
        "time_per_day": {
          "2025-12-22": 122.23047833333334
        },
        "time_count_per_day": {
          "2025-12-22": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 122.23,
          "mode_time_hours": 123.0,
          "mode_frequency": 1,
          "time_distribution": {
            "122-124h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-22": 1
          },
          "time_per_day": {
            "2025-12-22": 122.23047833333334
          },
          "time_count_per_day": {
            "2025-12-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 122.23,
            "mode_time_hours": 123.0,
            "mode_frequency": 1,
            "time_distribution": {
              "122-124h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-22": 1
            },
            "time_per_day": {
              "2025-12-22": 122.23047833333334
            },
            "time_count_per_day": {
              "2025-12-22": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 122.23,
              "mode_time_hours": 123.0,
              "mode_frequency": 1,
              "time_distribution": {
                "122-124h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-22": 1
              },
              "time_per_day": {
                "2025-12-22": 122.23047833333334
              },
              "time_count_per_day": {
                "2025-12-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_698": {
      "overall": {
        "avg_time_hours": 1093.46,
        "mode_time_hours": 1509.0,
        "mode_frequency": 1,
        "time_distribution": {
          "470-472h": 1,
          "1300-1302h": 1,
          "1508-1510h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-07": 1,
          "2026-02-12": 1,
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-01-07": 470.9683536111111,
          "2026-02-12": 1301.1736413888889,
          "2026-02-18": 1508.2476372222222
        },
        "time_count_per_day": {
          "2026-01-07": 1,
          "2026-02-12": 1,
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1301.17,
          "mode_time_hours": 1301.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1300-1302h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 1301.1736413888889
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 989.61,
          "mode_time_hours": 1509.0,
          "mode_frequency": 1,
          "time_distribution": {
            "470-472h": 1,
            "1508-1510h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-07": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-07": 470.9683536111111,
            "2026-02-18": 1508.2476372222222
          },
          "time_count_per_day": {
            "2026-01-07": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1093.46,
            "mode_time_hours": 1509.0,
            "mode_frequency": 1,
            "time_distribution": {
              "470-472h": 1,
              "1300-1302h": 1,
              "1508-1510h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-07": 1,
              "2026-02-12": 1,
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-01-07": 470.9683536111111,
              "2026-02-12": 1301.1736413888889,
              "2026-02-18": 1508.2476372222222
            },
            "time_count_per_day": {
              "2026-01-07": 1,
              "2026-02-12": 1,
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1301.17,
              "mode_time_hours": 1301.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1300-1302h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 1301.1736413888889
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 989.61,
              "mode_time_hours": 1509.0,
              "mode_frequency": 1,
              "time_distribution": {
                "470-472h": 1,
                "1508-1510h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-07": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-07": 470.9683536111111,
                "2026-02-18": 1508.2476372222222
              },
              "time_count_per_day": {
                "2026-01-07": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_701": {
      "overall": {
        "avg_time_hours": 1503.49,
        "mode_time_hours": 1503.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1502-1504h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 1503.4851869444446
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1503.49,
          "mode_time_hours": 1503.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1502-1504h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 1503.4851869444446
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1503.49,
            "mode_time_hours": 1503.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1502-1504h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 1503.4851869444446
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1503.49,
              "mode_time_hours": 1503.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1502-1504h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 1503.4851869444446
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_702": {
      "overall": {
        "avg_time_hours": 33.61,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "14-16h": 1,
          "24-26h": 1,
          "124-126h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2025-12-18": 1,
          "2026-01-15": 1,
          "2026-02-28": 1,
          "2026-05-21": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-12-18": 14.46486611111111,
          "2026-01-15": 125.16901444444444,
          "2026-02-28": 25.510932500000003,
          "2026-05-21": 2.791790833333333,
          "2026-05-26": 0.11842472222222222
        },
        "time_count_per_day": {
          "2025-12-18": 1,
          "2026-01-15": 1,
          "2026-02-28": 1,
          "2026-05-21": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.79,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-18": 1,
            "2026-05-21": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-12-18": 14.46486611111111,
            "2026-05-21": 2.791790833333333,
            "2026-05-26": 0.11842472222222222
          },
          "time_count_per_day": {
            "2025-12-18": 1,
            "2026-05-21": 1,
            "2026-05-26": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 75.34,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "124-126h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-01-15": 125.16901444444444,
            "2026-02-28": 25.510932500000003
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 33.61,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "14-16h": 1,
              "24-26h": 1,
              "124-126h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2025-12-18": 1,
              "2026-01-15": 1,
              "2026-02-28": 1,
              "2026-05-21": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-12-18": 14.46486611111111,
              "2026-01-15": 125.16901444444444,
              "2026-02-28": 25.510932500000003,
              "2026-05-21": 2.791790833333333,
              "2026-05-26": 0.11842472222222222
            },
            "time_count_per_day": {
              "2025-12-18": 1,
              "2026-01-15": 1,
              "2026-02-28": 1,
              "2026-05-21": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.79,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-12-18": 14.46486611111111,
                "2026-05-21": 2.791790833333333,
                "2026-05-26": 0.11842472222222222
              },
              "time_count_per_day": {
                "2025-12-18": 1,
                "2026-05-21": 1,
                "2026-05-26": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 75.34,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "124-126h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-01-15": 125.16901444444444,
                "2026-02-28": 25.510932500000003
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_703": {
      "overall": {
        "avg_time_hours": 0.77,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-17": 1,
          "2026-04-10": 1
        },
        "time_per_day": {
          "2025-12-17": 0.7686530555555555
        },
        "time_count_per_day": {
          "2025-12-17": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 0.77,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-17": 1
          },
          "time_per_day": {
            "2025-12-17": 0.7686530555555555
          },
          "time_count_per_day": {
            "2025-12-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.77,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-17": 1
            },
            "time_per_day": {
              "2025-12-17": 0.7686530555555555
            },
            "time_count_per_day": {
              "2025-12-17": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 0.77,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-17": 1
              },
              "time_per_day": {
                "2025-12-17": 0.7686530555555555
              },
              "time_count_per_day": {
                "2025-12-17": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_704": {
      "overall": {
        "avg_time_hours": 1.56,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-18": 1
        },
        "time_per_day": {
          "2025-12-18": 1.5561594444444444
        },
        "time_count_per_day": {
          "2025-12-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-18": 1
          },
          "time_per_day": {
            "2025-12-18": 1.5561594444444444
          },
          "time_count_per_day": {
            "2025-12-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.56,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-18": 1
            },
            "time_per_day": {
              "2025-12-18": 1.5561594444444444
            },
            "time_count_per_day": {
              "2025-12-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-18": 1
              },
              "time_per_day": {
                "2025-12-18": 1.5561594444444444
              },
              "time_count_per_day": {
                "2025-12-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_705": {
      "overall": {
        "avg_time_hours": 8.37,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "22-24h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-19": 1,
          "2026-01-20": 1,
          "2026-03-16": 1
        },
        "time_per_day": {
          "2025-12-19": 23.5684,
          "2026-01-20": 1.1900486111111113,
          "2026-03-16": 0.3368352777777778
        },
        "time_count_per_day": {
          "2025-12-19": 1,
          "2026-01-20": 1,
          "2026-03-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.76,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-20": 1,
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-01-20": 1.1900486111111113,
            "2026-03-16": 0.3368352777777778
          },
          "time_count_per_day": {
            "2026-01-20": 1,
            "2026-03-16": 1
          }
        },
        "P3": {
          "avg_time_hours": 23.57,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-19": 1
          },
          "time_per_day": {
            "2025-12-19": 23.5684
          },
          "time_count_per_day": {
            "2025-12-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.37,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "22-24h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-19": 1,
              "2026-01-20": 1,
              "2026-03-16": 1
            },
            "time_per_day": {
              "2025-12-19": 23.5684,
              "2026-01-20": 1.1900486111111113,
              "2026-03-16": 0.3368352777777778
            },
            "time_count_per_day": {
              "2025-12-19": 1,
              "2026-01-20": 1,
              "2026-03-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.76,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-20": 1,
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-01-20": 1.1900486111111113,
                "2026-03-16": 0.3368352777777778
              },
              "time_count_per_day": {
                "2026-01-20": 1,
                "2026-03-16": 1
              }
            },
            "P3": {
              "avg_time_hours": 23.57,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-19": 1
              },
              "time_per_day": {
                "2025-12-19": 23.5684
              },
              "time_count_per_day": {
                "2025-12-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_707": {
      "overall": {
        "avg_time_hours": 322.62,
        "mode_time_hours": 1.0,
        "mode_frequency": 19,
        "time_distribution": {
          "0-2h": 19,
          "2-4h": 4,
          "4-6h": 2,
          "3002-3004h": 3
        },
        "tickets_count": 28,
        "tickets_per_day": {
          "2025-12-18": 2,
          "2026-02-20": 3,
          "2026-02-24": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-02": 2,
          "2026-04-10": 4,
          "2026-04-22": 3,
          "2026-04-27": 2,
          "2026-04-29": 2,
          "2026-05-05": 3,
          "2026-05-08": 2,
          "2026-05-25": 2
        },
        "time_per_day": {
          "2025-12-18": 10.837394166666666,
          "2026-02-20": 0.10965277777777778,
          "2026-02-24": 0.010730555555555556,
          "2026-03-24": 0.016182222222222223,
          "2026-03-25": 0.04384944444444445,
          "2026-04-02": 0.24866916666666666,
          "2026-04-10": 0.3149025,
          "2026-04-22": 9007.327404722222,
          "2026-04-27": 4.4252075,
          "2026-04-29": 0.07558333333333334,
          "2026-05-05": 1.9938694444444445,
          "2026-05-08": 7.953444444444444,
          "2026-05-25": 0.057425
        },
        "time_count_per_day": {
          "2025-12-18": 2,
          "2026-02-20": 3,
          "2026-02-24": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-02": 2,
          "2026-04-10": 4,
          "2026-04-22": 3,
          "2026-04-27": 2,
          "2026-04-29": 2,
          "2026-05-05": 3,
          "2026-05-08": 2,
          "2026-05-25": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 347.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 19,
          "time_distribution": {
            "0-2h": 19,
            "2-4h": 4,
            "3002-3004h": 3
          },
          "tickets_count": 26,
          "tickets_per_day": {
            "2026-02-20": 3,
            "2026-02-24": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-04-02": 2,
            "2026-04-10": 4,
            "2026-04-22": 3,
            "2026-04-27": 2,
            "2026-04-29": 2,
            "2026-05-05": 3,
            "2026-05-08": 2,
            "2026-05-25": 2
          },
          "time_per_day": {
            "2026-02-20": 0.10965277777777778,
            "2026-02-24": 0.010730555555555556,
            "2026-03-24": 0.016182222222222223,
            "2026-03-25": 0.04384944444444445,
            "2026-04-02": 0.24866916666666666,
            "2026-04-10": 0.3149025,
            "2026-04-22": 9007.327404722222,
            "2026-04-27": 4.4252075,
            "2026-04-29": 0.07558333333333334,
            "2026-05-05": 1.9938694444444445,
            "2026-05-08": 7.953444444444444,
            "2026-05-25": 0.057425
          },
          "time_count_per_day": {
            "2026-02-20": 3,
            "2026-02-24": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-04-02": 2,
            "2026-04-10": 4,
            "2026-04-22": 3,
            "2026-04-27": 2,
            "2026-04-29": 2,
            "2026-05-05": 3,
            "2026-05-08": 2,
            "2026-05-25": 2
          }
        },
        "P3": {
          "avg_time_hours": 5.42,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-18": 2
          },
          "time_per_day": {
            "2025-12-18": 10.837394166666666
          },
          "time_count_per_day": {
            "2025-12-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 322.62,
            "mode_time_hours": 1.0,
            "mode_frequency": 19,
            "time_distribution": {
              "0-2h": 19,
              "2-4h": 4,
              "4-6h": 2,
              "3002-3004h": 3
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2025-12-18": 2,
              "2026-02-20": 3,
              "2026-02-24": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-02": 2,
              "2026-04-10": 4,
              "2026-04-22": 3,
              "2026-04-27": 2,
              "2026-04-29": 2,
              "2026-05-05": 3,
              "2026-05-08": 2,
              "2026-05-25": 2
            },
            "time_per_day": {
              "2025-12-18": 10.837394166666666,
              "2026-02-20": 0.10965277777777778,
              "2026-02-24": 0.010730555555555556,
              "2026-03-24": 0.016182222222222223,
              "2026-03-25": 0.04384944444444445,
              "2026-04-02": 0.24866916666666666,
              "2026-04-10": 0.3149025,
              "2026-04-22": 9007.327404722222,
              "2026-04-27": 4.4252075,
              "2026-04-29": 0.07558333333333334,
              "2026-05-05": 1.9938694444444445,
              "2026-05-08": 7.953444444444444,
              "2026-05-25": 0.057425
            },
            "time_count_per_day": {
              "2025-12-18": 2,
              "2026-02-20": 3,
              "2026-02-24": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-02": 2,
              "2026-04-10": 4,
              "2026-04-22": 3,
              "2026-04-27": 2,
              "2026-04-29": 2,
              "2026-05-05": 3,
              "2026-05-08": 2,
              "2026-05-25": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 347.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 19,
              "time_distribution": {
                "0-2h": 19,
                "2-4h": 4,
                "3002-3004h": 3
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2026-02-20": 3,
                "2026-02-24": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-04-02": 2,
                "2026-04-10": 4,
                "2026-04-22": 3,
                "2026-04-27": 2,
                "2026-04-29": 2,
                "2026-05-05": 3,
                "2026-05-08": 2,
                "2026-05-25": 2
              },
              "time_per_day": {
                "2026-02-20": 0.10965277777777778,
                "2026-02-24": 0.010730555555555556,
                "2026-03-24": 0.016182222222222223,
                "2026-03-25": 0.04384944444444445,
                "2026-04-02": 0.24866916666666666,
                "2026-04-10": 0.3149025,
                "2026-04-22": 9007.327404722222,
                "2026-04-27": 4.4252075,
                "2026-04-29": 0.07558333333333334,
                "2026-05-05": 1.9938694444444445,
                "2026-05-08": 7.953444444444444,
                "2026-05-25": 0.057425
              },
              "time_count_per_day": {
                "2026-02-20": 3,
                "2026-02-24": 1,
                "2026-03-24": 1,
                "2026-03-25": 1,
                "2026-04-02": 2,
                "2026-04-10": 4,
                "2026-04-22": 3,
                "2026-04-27": 2,
                "2026-04-29": 2,
                "2026-05-05": 3,
                "2026-05-08": 2,
                "2026-05-25": 2
              }
            },
            "P3": {
              "avg_time_hours": 5.42,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-18": 2
              },
              "time_per_day": {
                "2025-12-18": 10.837394166666666
              },
              "time_count_per_day": {
                "2025-12-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_708": {
      "overall": {
        "avg_time_hours": 251.69,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "24-26h": 1,
          "724-726h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2025-12-19": 1,
          "2026-02-02": 1,
          "2026-02-21": 1,
          "2026-03-18": 1,
          "2026-03-25": 1,
          "2026-05-08": 2,
          "2026-05-18": 1,
          "2026-05-27": 1
        },
        "time_per_day": {
          "2025-12-19": 24.573463055555557,
          "2026-02-02": 4.815695833333334,
          "2026-03-18": 725.6733402777777
        },
        "time_count_per_day": {
          "2025-12-19": 1,
          "2026-02-02": 1,
          "2026-03-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": 4.82,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 4.815695833333334
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 375.12,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "724-726h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-03-18": 1,
            "2026-03-25": 1,
            "2026-05-08": 2,
            "2026-05-27": 1
          },
          "time_per_day": {
            "2025-12-19": 24.573463055555557,
            "2026-03-18": 725.6733402777777
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-03-18": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-21": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 251.69,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "24-26h": 1,
              "724-726h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-19": 1,
              "2026-02-02": 1,
              "2026-03-18": 1
            },
            "time_per_day": {
              "2025-12-19": 24.573463055555557,
              "2026-02-02": 4.815695833333334,
              "2026-03-18": 725.6733402777777
            },
            "time_count_per_day": {
              "2025-12-19": 1,
              "2026-02-02": 1,
              "2026-03-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.82,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 4.815695833333334
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 375.12,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "724-726h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2025-12-19": 24.573463055555557,
                "2026-03-18": 725.6733402777777
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-02-21": 1,
              "2026-03-25": 1,
              "2026-05-08": 2,
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-25": 1,
                "2026-05-08": 2,
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_709": {
      "overall": {
        "avg_time_hours": 105.82,
        "mode_time_hours": 23.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "16-18h": 1,
          "22-24h": 1,
          "38-40h": 1,
          "160-162h": 1,
          "186-188h": 1,
          "314-316h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2025-12-19": 1,
          "2026-03-03": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-25": 3
        },
        "time_per_day": {
          "2025-12-19": 22.0583025,
          "2026-03-12": 0.3268997222222222,
          "2026-03-18": 16.91636638888889,
          "2026-03-20": 38.61559916666667,
          "2026-03-25": 662.8160094444445
        },
        "time_count_per_day": {
          "2025-12-19": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-25": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 100.04,
          "mode_time_hours": 161.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1,
            "160-162h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-06": 1,
            "2026-03-20": 1,
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-20": 38.61559916666667,
            "2026-03-25": 161.47258
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-03-25": 1
          }
        },
        "P2": {
          "avg_time_hours": 129.65,
          "mode_time_hours": 315.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "16-18h": 1,
            "186-188h": 1,
            "314-316h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-25": 2
          },
          "time_per_day": {
            "2026-03-12": 0.3268997222222222,
            "2026-03-18": 16.91636638888889,
            "2026-03-25": 501.3434294444445
          },
          "time_count_per_day": {
            "2026-03-12": 1,
            "2026-03-18": 1,
            "2026-03-25": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 22.06,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-19": 1
          },
          "time_per_day": {
            "2025-12-19": 22.0583025
          },
          "time_count_per_day": {
            "2025-12-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 105.82,
            "mode_time_hours": 23.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "16-18h": 1,
              "22-24h": 1,
              "38-40h": 1,
              "160-162h": 1,
              "186-188h": 1,
              "314-316h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-12-19": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-25": 3
            },
            "time_per_day": {
              "2025-12-19": 22.0583025,
              "2026-03-12": 0.3268997222222222,
              "2026-03-18": 16.91636638888889,
              "2026-03-20": 38.61559916666667,
              "2026-03-25": 662.8160094444445
            },
            "time_count_per_day": {
              "2025-12-19": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-25": 3
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 100.04,
              "mode_time_hours": 161.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1,
                "160-162h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-20": 38.61559916666667,
                "2026-03-25": 161.47258
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-03-25": 1
              }
            },
            "P2": {
              "avg_time_hours": 129.65,
              "mode_time_hours": 315.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "16-18h": 1,
                "186-188h": 1,
                "314-316h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-25": 2
              },
              "time_per_day": {
                "2026-03-12": 0.3268997222222222,
                "2026-03-18": 16.91636638888889,
                "2026-03-25": 501.3434294444445
              },
              "time_count_per_day": {
                "2026-03-12": 1,
                "2026-03-18": 1,
                "2026-03-25": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 22.06,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-19": 1
              },
              "time_per_day": {
                "2025-12-19": 22.0583025
              },
              "time_count_per_day": {
                "2025-12-19": 1
              }
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-03-06": 1,
              "2026-03-11": 1,
              "2026-03-13": 1,
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-03-11": 1,
                "2026-03-13": 1,
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_710": {
      "overall": {
        "avg_time_hours": 74.88,
        "mode_time_hours": 75.0,
        "mode_frequency": 1,
        "time_distribution": {
          "74-76h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-22": 1
        },
        "time_per_day": {
          "2025-12-22": 74.87655777777778
        },
        "time_count_per_day": {
          "2025-12-22": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 74.88,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-22": 1
          },
          "time_per_day": {
            "2025-12-22": 74.87655777777778
          },
          "time_count_per_day": {
            "2025-12-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 74.88,
            "mode_time_hours": 75.0,
            "mode_frequency": 1,
            "time_distribution": {
              "74-76h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-22": 1
            },
            "time_per_day": {
              "2025-12-22": 74.87655777777778
            },
            "time_count_per_day": {
              "2025-12-22": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 74.88,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-22": 1
              },
              "time_per_day": {
                "2025-12-22": 74.87655777777778
              },
              "time_count_per_day": {
                "2025-12-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_711": {
      "overall": {
        "avg_time_hours": 164.42,
        "mode_time_hours": 217.0,
        "mode_frequency": 3,
        "time_distribution": {
          "4-6h": 1,
          "216-218h": 3
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2025-12-19": 1,
          "2026-02-19": 3
        },
        "time_per_day": {
          "2025-12-19": 5.079664166666667,
          "2026-02-19": 652.5842158333332
        },
        "time_count_per_day": {
          "2025-12-19": 1,
          "2026-02-19": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.08,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-19": 1
          },
          "time_per_day": {
            "2025-12-19": 5.079664166666667
          },
          "time_count_per_day": {
            "2025-12-19": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 217.53,
          "mode_time_hours": 217.0,
          "mode_frequency": 3,
          "time_distribution": {
            "216-218h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 652.5842158333332
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 164.42,
            "mode_time_hours": 217.0,
            "mode_frequency": 3,
            "time_distribution": {
              "4-6h": 1,
              "216-218h": 3
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2025-12-19": 1,
              "2026-02-19": 3
            },
            "time_per_day": {
              "2025-12-19": 5.079664166666667,
              "2026-02-19": 652.5842158333332
            },
            "time_count_per_day": {
              "2025-12-19": 1,
              "2026-02-19": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.08,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-19": 1
              },
              "time_per_day": {
                "2025-12-19": 5.079664166666667
              },
              "time_count_per_day": {
                "2025-12-19": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 217.53,
              "mode_time_hours": 217.0,
              "mode_frequency": 3,
              "time_distribution": {
                "216-218h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 652.5842158333332
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        }
      }
    },
    "cliente_712": {
      "overall": {
        "avg_time_hours": 234.5,
        "mode_time_hours": 577.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "178-180h": 1,
          "182-184h": 1,
          "576-578h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-12": 1,
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-01-12": 577.3386069444445,
          "2026-02-03": 178.29931305555556,
          "2026-02-19": 182.27086305555554,
          "2026-03-20": 0.08699861111111111
        },
        "time_count_per_day": {
          "2026-01-12": 1,
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 89.19,
          "mode_time_hours": 179.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "178-180h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-02-03": 178.29931305555556,
            "2026-03-20": 0.08699861111111111
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-03-20": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 577.34,
          "mode_time_hours": 577.0,
          "mode_frequency": 1,
          "time_distribution": {
            "576-578h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-12": 1
          },
          "time_per_day": {
            "2026-01-12": 577.3386069444445
          },
          "time_count_per_day": {
            "2026-01-12": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 182.27,
          "mode_time_hours": 183.0,
          "mode_frequency": 1,
          "time_distribution": {
            "182-184h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 182.27086305555554
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 234.5,
            "mode_time_hours": 577.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "178-180h": 1,
              "182-184h": 1,
              "576-578h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-12": 1,
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-01-12": 577.3386069444445,
              "2026-02-03": 178.29931305555556,
              "2026-02-19": 182.27086305555554,
              "2026-03-20": 0.08699861111111111
            },
            "time_count_per_day": {
              "2026-01-12": 1,
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 89.19,
              "mode_time_hours": 179.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "178-180h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-02-03": 178.29931305555556,
                "2026-03-20": 0.08699861111111111
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-03-20": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 577.34,
              "mode_time_hours": 577.0,
              "mode_frequency": 1,
              "time_distribution": {
                "576-578h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-12": 1
              },
              "time_per_day": {
                "2026-01-12": 577.3386069444445
              },
              "time_count_per_day": {
                "2026-01-12": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 182.27,
              "mode_time_hours": 183.0,
              "mode_frequency": 1,
              "time_distribution": {
                "182-184h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 182.27086305555554
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_713": {
      "overall": {
        "avg_time_hours": 789.21,
        "mode_time_hours": 789.0,
        "mode_frequency": 1,
        "time_distribution": {
          "788-790h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-21": 1
        },
        "time_per_day": {
          "2026-01-21": 789.2094722222223
        },
        "time_count_per_day": {
          "2026-01-21": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 789.21,
          "mode_time_hours": 789.0,
          "mode_frequency": 1,
          "time_distribution": {
            "788-790h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 789.2094722222223
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 789.21,
            "mode_time_hours": 789.0,
            "mode_frequency": 1,
            "time_distribution": {
              "788-790h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {
              "2026-01-21": 789.2094722222223
            },
            "time_count_per_day": {
              "2026-01-21": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 789.21,
              "mode_time_hours": 789.0,
              "mode_frequency": 1,
              "time_distribution": {
                "788-790h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 789.2094722222223
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_714": {
      "overall": {
        "avg_time_hours": 317.0,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "944-946h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-19": 1,
          "2026-01-12": 1,
          "2026-03-09": 1
        },
        "time_per_day": {
          "2025-12-19": 0.9602441666666667,
          "2026-01-12": 6.016322499999999,
          "2026-03-09": 944.0359588888889
        },
        "time_count_per_day": {
          "2025-12-19": 1,
          "2026-01-12": 1,
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 472.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "944-946h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-19": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2025-12-19": 0.9602441666666667,
            "2026-03-09": 944.0359588888889
          },
          "time_count_per_day": {
            "2025-12-19": 1,
            "2026-03-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 6.02,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-12": 1
          },
          "time_per_day": {
            "2026-01-12": 6.016322499999999
          },
          "time_count_per_day": {
            "2026-01-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 317.0,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "944-946h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-19": 1,
              "2026-01-12": 1,
              "2026-03-09": 1
            },
            "time_per_day": {
              "2025-12-19": 0.9602441666666667,
              "2026-01-12": 6.016322499999999,
              "2026-03-09": 944.0359588888889
            },
            "time_count_per_day": {
              "2025-12-19": 1,
              "2026-01-12": 1,
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 472.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "944-946h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-19": 1,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2025-12-19": 0.9602441666666667,
                "2026-03-09": 944.0359588888889
              },
              "time_count_per_day": {
                "2025-12-19": 1,
                "2026-03-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 6.02,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-12": 1
              },
              "time_per_day": {
                "2026-01-12": 6.016322499999999
              },
              "time_count_per_day": {
                "2026-01-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_491": {
      "overall": {
        "avg_time_hours": 205.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "22-24h": 1,
          "24-26h": 1,
          "72-74h": 1,
          "98-100h": 1,
          "132-134h": 2,
          "138-140h": 1,
          "580-582h": 1,
          "1462-1464h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-23": 1,
          "2026-02-04": 2,
          "2026-02-05": 1,
          "2026-02-18": 1,
          "2026-03-26": 1,
          "2026-05-18": 1,
          "2026-05-19": 2,
          "2026-05-22": 1
        },
        "time_per_day": {
          "2026-01-15": 581.094925,
          "2026-01-16": 99.36186805555556,
          "2026-01-23": 98.04634194444445,
          "2026-02-04": 266.1332258333333,
          "2026-02-05": 22.881896944444446,
          "2026-02-18": 1463.3165791666665,
          "2026-03-26": 139.3924963888889,
          "2026-05-18": 0.11837055555555556,
          "2026-05-19": 0.9213919444444445,
          "2026-05-22": 0.4896580555555556
        },
        "time_count_per_day": {
          "2026-01-15": 1,
          "2026-01-16": 2,
          "2026-01-23": 1,
          "2026-02-04": 2,
          "2026-02-05": 1,
          "2026-02-18": 1,
          "2026-03-26": 1,
          "2026-05-18": 1,
          "2026-05-19": 2,
          "2026-05-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.38,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-05-18": 1,
            "2026-05-19": 2,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2026-05-18": 0.11837055555555556,
            "2026-05-19": 0.9213919444444445,
            "2026-05-22": 0.4896580555555556
          },
          "time_count_per_day": {
            "2026-05-18": 1,
            "2026-05-19": 2,
            "2026-05-22": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 82.12,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "24-26h": 1,
            "72-74h": 1,
            "98-100h": 1,
            "132-134h": 1,
            "138-140h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-16": 2,
            "2026-01-23": 1,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-01-16": 99.36186805555556,
            "2026-01-23": 98.04634194444445,
            "2026-02-04": 133.04386,
            "2026-02-05": 22.881896944444446,
            "2026-03-26": 139.3924963888889
          },
          "time_count_per_day": {
            "2026-01-16": 2,
            "2026-01-23": 1,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 725.83,
          "mode_time_hours": 1463.0,
          "mode_frequency": 1,
          "time_distribution": {
            "132-134h": 1,
            "580-582h": 1,
            "1462-1464h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-02-04": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-15": 581.094925,
            "2026-02-04": 133.08936583333335,
            "2026-02-18": 1463.3165791666665
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-02-04": 1,
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 205.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "22-24h": 1,
              "24-26h": 1,
              "72-74h": 1,
              "98-100h": 1,
              "132-134h": 2,
              "138-140h": 1,
              "580-582h": 1,
              "1462-1464h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-23": 1,
              "2026-02-04": 2,
              "2026-02-05": 1,
              "2026-02-18": 1,
              "2026-03-26": 1,
              "2026-05-18": 1,
              "2026-05-19": 2,
              "2026-05-22": 1
            },
            "time_per_day": {
              "2026-01-15": 581.094925,
              "2026-01-16": 99.36186805555556,
              "2026-01-23": 98.04634194444445,
              "2026-02-04": 266.1332258333333,
              "2026-02-05": 22.881896944444446,
              "2026-02-18": 1463.3165791666665,
              "2026-03-26": 139.3924963888889,
              "2026-05-18": 0.11837055555555556,
              "2026-05-19": 0.9213919444444445,
              "2026-05-22": 0.4896580555555556
            },
            "time_count_per_day": {
              "2026-01-15": 1,
              "2026-01-16": 2,
              "2026-01-23": 1,
              "2026-02-04": 2,
              "2026-02-05": 1,
              "2026-02-18": 1,
              "2026-03-26": 1,
              "2026-05-18": 1,
              "2026-05-19": 2,
              "2026-05-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.38,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-05-18": 1,
                "2026-05-19": 2,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2026-05-18": 0.11837055555555556,
                "2026-05-19": 0.9213919444444445,
                "2026-05-22": 0.4896580555555556
              },
              "time_count_per_day": {
                "2026-05-18": 1,
                "2026-05-19": 2,
                "2026-05-22": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 82.12,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "24-26h": 1,
                "72-74h": 1,
                "98-100h": 1,
                "132-134h": 1,
                "138-140h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-16": 2,
                "2026-01-23": 1,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-01-16": 99.36186805555556,
                "2026-01-23": 98.04634194444445,
                "2026-02-04": 133.04386,
                "2026-02-05": 22.881896944444446,
                "2026-03-26": 139.3924963888889
              },
              "time_count_per_day": {
                "2026-01-16": 2,
                "2026-01-23": 1,
                "2026-02-04": 1,
                "2026-02-05": 1,
                "2026-03-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 725.83,
              "mode_time_hours": 1463.0,
              "mode_frequency": 1,
              "time_distribution": {
                "132-134h": 1,
                "580-582h": 1,
                "1462-1464h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-02-04": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-15": 581.094925,
                "2026-02-04": 133.08936583333335,
                "2026-02-18": 1463.3165791666665
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-02-04": 1,
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_715": {
      "overall": {
        "avg_time_hours": 1461.38,
        "mode_time_hours": 1461.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1460-1462h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 1461.3755666666666
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1461.38,
          "mode_time_hours": 1461.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1460-1462h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 1461.3755666666666
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1461.38,
            "mode_time_hours": 1461.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1460-1462h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 1461.3755666666666
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1461.38,
              "mode_time_hours": 1461.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1460-1462h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 1461.3755666666666
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_718": {
      "overall": {
        "avg_time_hours": 29.95,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-22": 1
        },
        "time_per_day": {
          "2025-12-22": 29.94645361111111
        },
        "time_count_per_day": {
          "2025-12-22": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 29.95,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-22": 1
          },
          "time_per_day": {
            "2025-12-22": 29.94645361111111
          },
          "time_count_per_day": {
            "2025-12-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.95,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-22": 1
            },
            "time_per_day": {
              "2025-12-22": 29.94645361111111
            },
            "time_count_per_day": {
              "2025-12-22": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 29.95,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-22": 1
              },
              "time_per_day": {
                "2025-12-22": 29.94645361111111
              },
              "time_count_per_day": {
                "2025-12-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_719": {
      "overall": {
        "avg_time_hours": 244.75,
        "mode_time_hours": 367.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "196-198h": 1,
          "366-368h": 1,
          "414-416h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-05": 2,
          "2026-02-04": 1,
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-01-05": 563.6958225000001,
          "2026-02-04": 415.0725091666667,
          "2026-03-05": 0.21837222222222222
        },
        "time_count_per_day": {
          "2026-01-05": 2,
          "2026-02-04": 1,
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 244.75,
          "mode_time_hours": 367.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "196-198h": 1,
            "366-368h": 1,
            "414-416h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-05": 2,
            "2026-02-04": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-01-05": 563.6958225000001,
            "2026-02-04": 415.0725091666667,
            "2026-03-05": 0.21837222222222222
          },
          "time_count_per_day": {
            "2026-01-05": 2,
            "2026-02-04": 1,
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 244.75,
            "mode_time_hours": 367.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "196-198h": 1,
              "366-368h": 1,
              "414-416h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-05": 2,
              "2026-02-04": 1,
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-01-05": 563.6958225000001,
              "2026-02-04": 415.0725091666667,
              "2026-03-05": 0.21837222222222222
            },
            "time_count_per_day": {
              "2026-01-05": 2,
              "2026-02-04": 1,
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 244.75,
              "mode_time_hours": 367.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "196-198h": 1,
                "366-368h": 1,
                "414-416h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-05": 2,
                "2026-02-04": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-01-05": 563.6958225000001,
                "2026-02-04": 415.0725091666667,
                "2026-03-05": 0.21837222222222222
              },
              "time_count_per_day": {
                "2026-01-05": 2,
                "2026-02-04": 1,
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_720": {
      "overall": {
        "avg_time_hours": 47.76,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "46-48h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-23": 1
        },
        "time_per_day": {
          "2025-12-23": 47.7561075
        },
        "time_count_per_day": {
          "2025-12-23": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 47.76,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-23": 1
          },
          "time_per_day": {
            "2025-12-23": 47.7561075
          },
          "time_count_per_day": {
            "2025-12-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 47.76,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "46-48h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-23": 1
            },
            "time_per_day": {
              "2025-12-23": 47.7561075
            },
            "time_count_per_day": {
              "2025-12-23": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 47.76,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-23": 1
              },
              "time_per_day": {
                "2025-12-23": 47.7561075
              },
              "time_count_per_day": {
                "2025-12-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_721": {
      "overall": {
        "avg_time_hours": 197.02,
        "mode_time_hours": 197.0,
        "mode_frequency": 1,
        "time_distribution": {
          "196-198h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 197.0205247222222
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 197.02,
          "mode_time_hours": 197.0,
          "mode_frequency": 1,
          "time_distribution": {
            "196-198h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 197.0205247222222
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 197.02,
            "mode_time_hours": 197.0,
            "mode_frequency": 1,
            "time_distribution": {
              "196-198h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 197.0205247222222
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 197.02,
              "mode_time_hours": 197.0,
              "mode_frequency": 1,
              "time_distribution": {
                "196-198h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 197.0205247222222
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_722": {
      "overall": {
        "avg_time_hours": 6.47,
        "mode_time_hours": 7.0,
        "mode_frequency": 3,
        "time_distribution": {
          "6-8h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2025-12-22": 3
        },
        "time_per_day": {
          "2025-12-22": 19.416914444444444
        },
        "time_count_per_day": {
          "2025-12-22": 3
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 6.47,
          "mode_time_hours": 7.0,
          "mode_frequency": 3,
          "time_distribution": {
            "6-8h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-22": 3
          },
          "time_per_day": {
            "2025-12-22": 19.416914444444444
          },
          "time_count_per_day": {
            "2025-12-22": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.47,
            "mode_time_hours": 7.0,
            "mode_frequency": 3,
            "time_distribution": {
              "6-8h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2025-12-22": 3
            },
            "time_per_day": {
              "2025-12-22": 19.416914444444444
            },
            "time_count_per_day": {
              "2025-12-22": 3
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 6.47,
              "mode_time_hours": 7.0,
              "mode_frequency": 3,
              "time_distribution": {
                "6-8h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-22": 3
              },
              "time_per_day": {
                "2025-12-22": 19.416914444444444
              },
              "time_count_per_day": {
                "2025-12-22": 3
              }
            }
          }
        }
      }
    },
    "cliente_725": {
      "overall": {
        "avg_time_hours": 6.96,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "2-4h": 2,
          "4-6h": 5,
          "6-8h": 2,
          "40-42h": 2
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-12-22": 2,
          "2025-12-23": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-23": 3,
          "2026-03-17": 2,
          "2026-04-13": 2,
          "2026-05-05": 1,
          "2026-05-30": 3,
          "2026-06-01": 2
        },
        "time_per_day": {
          "2025-12-22": 4.737485555555556,
          "2025-12-23": 0.39675444444444447,
          "2026-01-13": 1.5027300000000001,
          "2026-01-14": 10.032848333333332,
          "2026-01-23": 14.35583027777778,
          "2026-03-17": 2.8379741666666667,
          "2026-04-13": 82.19982222222222,
          "2026-05-05": 0.08438944444444445,
          "2026-05-30": 0.9567958333333333,
          "2026-06-01": 15.152074166666667
        },
        "time_count_per_day": {
          "2025-12-22": 2,
          "2025-12-23": 1,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-23": 3,
          "2026-03-17": 2,
          "2026-04-13": 2,
          "2026-05-05": 1,
          "2026-05-30": 3,
          "2026-06-01": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "4-6h": 3,
            "6-8h": 2,
            "40-42h": 2
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2025-12-23": 1,
            "2026-01-13": 1,
            "2026-01-23": 3,
            "2026-03-17": 2,
            "2026-04-13": 2,
            "2026-05-05": 1,
            "2026-05-30": 3,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2025-12-23": 0.39675444444444447,
            "2026-01-13": 1.5027300000000001,
            "2026-01-23": 14.35583027777778,
            "2026-03-17": 2.8379741666666667,
            "2026-04-13": 82.19982222222222,
            "2026-05-05": 0.08438944444444445,
            "2026-05-30": 0.9567958333333333,
            "2026-06-01": 15.152074166666667
          },
          "time_count_per_day": {
            "2025-12-23": 1,
            "2026-01-13": 1,
            "2026-01-23": 3,
            "2026-03-17": 2,
            "2026-04-13": 2,
            "2026-05-05": 1,
            "2026-05-30": 3,
            "2026-06-01": 2
          }
        },
        "P3": {
          "avg_time_hours": 3.69,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2,
            "4-6h": 2
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-22": 2,
            "2026-01-14": 2
          },
          "time_per_day": {
            "2025-12-22": 4.737485555555556,
            "2026-01-14": 10.032848333333332
          },
          "time_count_per_day": {
            "2025-12-22": 2,
            "2026-01-14": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.96,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "2-4h": 2,
              "4-6h": 5,
              "6-8h": 2,
              "40-42h": 2
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-12-22": 2,
              "2025-12-23": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-23": 3,
              "2026-03-17": 2,
              "2026-04-13": 2,
              "2026-05-05": 1,
              "2026-05-30": 3,
              "2026-06-01": 2
            },
            "time_per_day": {
              "2025-12-22": 4.737485555555556,
              "2025-12-23": 0.39675444444444447,
              "2026-01-13": 1.5027300000000001,
              "2026-01-14": 10.032848333333332,
              "2026-01-23": 14.35583027777778,
              "2026-03-17": 2.8379741666666667,
              "2026-04-13": 82.19982222222222,
              "2026-05-05": 0.08438944444444445,
              "2026-05-30": 0.9567958333333333,
              "2026-06-01": 15.152074166666667
            },
            "time_count_per_day": {
              "2025-12-22": 2,
              "2025-12-23": 1,
              "2026-01-13": 1,
              "2026-01-14": 2,
              "2026-01-23": 3,
              "2026-03-17": 2,
              "2026-04-13": 2,
              "2026-05-05": 1,
              "2026-05-30": 3,
              "2026-06-01": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "4-6h": 3,
                "6-8h": 2,
                "40-42h": 2
              },
              "tickets_count": 15,
              "tickets_per_day": {
                "2025-12-23": 1,
                "2026-01-13": 1,
                "2026-01-23": 3,
                "2026-03-17": 2,
                "2026-04-13": 2,
                "2026-05-05": 1,
                "2026-05-30": 3,
                "2026-06-01": 2
              },
              "time_per_day": {
                "2025-12-23": 0.39675444444444447,
                "2026-01-13": 1.5027300000000001,
                "2026-01-23": 14.35583027777778,
                "2026-03-17": 2.8379741666666667,
                "2026-04-13": 82.19982222222222,
                "2026-05-05": 0.08438944444444445,
                "2026-05-30": 0.9567958333333333,
                "2026-06-01": 15.152074166666667
              },
              "time_count_per_day": {
                "2025-12-23": 1,
                "2026-01-13": 1,
                "2026-01-23": 3,
                "2026-03-17": 2,
                "2026-04-13": 2,
                "2026-05-05": 1,
                "2026-05-30": 3,
                "2026-06-01": 2
              }
            },
            "P3": {
              "avg_time_hours": 3.69,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2,
                "4-6h": 2
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-22": 2,
                "2026-01-14": 2
              },
              "time_per_day": {
                "2025-12-22": 4.737485555555556,
                "2026-01-14": 10.032848333333332
              },
              "time_count_per_day": {
                "2025-12-22": 2,
                "2026-01-14": 2
              }
            }
          }
        }
      }
    },
    "cliente_726": {
      "overall": {
        "avg_time_hours": 877.0,
        "mode_time_hours": 1235.0,
        "mode_frequency": 1,
        "time_distribution": {
          "518-520h": 1,
          "1234-1236h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-02-12": 1235.1892441666666,
          "2026-02-13": 518.8064611111112
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 877.0,
          "mode_time_hours": 1235.0,
          "mode_frequency": 1,
          "time_distribution": {
            "518-520h": 1,
            "1234-1236h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-12": 1235.1892441666666,
            "2026-02-13": 518.8064611111112
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 877.0,
            "mode_time_hours": 1235.0,
            "mode_frequency": 1,
            "time_distribution": {
              "518-520h": 1,
              "1234-1236h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-02-12": 1235.1892441666666,
              "2026-02-13": 518.8064611111112
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 877.0,
              "mode_time_hours": 1235.0,
              "mode_frequency": 1,
              "time_distribution": {
                "518-520h": 1,
                "1234-1236h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-12": 1235.1892441666666,
                "2026-02-13": 518.8064611111112
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_728": {
      "overall": {
        "avg_time_hours": 1.58,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-23": 1
        },
        "time_per_day": {
          "2025-12-23": 1.5776730555555554
        },
        "time_count_per_day": {
          "2025-12-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-23": 1
          },
          "time_per_day": {
            "2025-12-23": 1.5776730555555554
          },
          "time_count_per_day": {
            "2025-12-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.58,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-23": 1
            },
            "time_per_day": {
              "2025-12-23": 1.5776730555555554
            },
            "time_count_per_day": {
              "2025-12-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-23": 1
              },
              "time_per_day": {
                "2025-12-23": 1.5776730555555554
              },
              "time_count_per_day": {
                "2025-12-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_730": {
      "overall": {
        "avg_time_hours": 202.61,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 3,
          "18-20h": 1,
          "20-22h": 1,
          "36-38h": 1,
          "40-42h": 1,
          "46-48h": 1,
          "58-60h": 1,
          "66-68h": 1,
          "76-78h": 1,
          "92-94h": 1,
          "96-98h": 1,
          "130-132h": 1,
          "140-142h": 1,
          "142-144h": 1,
          "172-174h": 1,
          "174-176h": 1,
          "178-180h": 1,
          "180-182h": 1,
          "188-190h": 1,
          "202-204h": 1,
          "240-242h": 1,
          "348-350h": 1,
          "356-358h": 1,
          "428-430h": 1,
          "548-550h": 1,
          "658-660h": 1,
          "792-794h": 1,
          "1020-1022h": 1
        },
        "tickets_count": 40,
        "tickets_per_day": {
          "2025-12-26": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-24": 2,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-13": 2,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-02-24": 1,
          "2026-03-18": 5,
          "2026-03-25": 1,
          "2026-03-30": 3,
          "2026-04-07": 2,
          "2026-04-10": 1,
          "2026-04-13": 1,
          "2026-04-22": 2,
          "2026-05-04": 1,
          "2026-05-14": 1,
          "2026-05-15": 2,
          "2026-05-19": 2,
          "2026-05-29": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2025-12-26": 59.37153527777778,
          "2026-01-09": 131.07209277777778,
          "2026-01-13": 3.4068055555555556,
          "2026-01-24": 413.1563330555556,
          "2026-01-31": 189.41532166666667,
          "2026-02-03": 141.3641188888889,
          "2026-02-05": 178.7987486111111,
          "2026-02-10": 181.27740583333332,
          "2026-02-13": 646.3835136111111,
          "2026-02-17": 142.79086555555554,
          "2026-02-18": 21.91476972222222,
          "2026-02-19": 2474.503728888889,
          "2026-03-18": 1358.1637516666667,
          "2026-03-25": 36.682413611111116,
          "2026-03-30": 190.73232722222224,
          "2026-04-13": 40.450275,
          "2026-04-22": 92.8219,
          "2026-05-04": 0.09746055555555555,
          "2026-05-15": 6.0970691666666665,
          "2026-06-03": 174.94298555555557
        },
        "time_count_per_day": {
          "2025-12-26": 1,
          "2026-01-09": 1,
          "2026-01-13": 1,
          "2026-01-24": 2,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-05": 1,
          "2026-02-10": 1,
          "2026-02-13": 2,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 3,
          "2026-03-18": 5,
          "2026-03-25": 1,
          "2026-03-30": 3,
          "2026-04-13": 1,
          "2026-04-22": 2,
          "2026-05-04": 1,
          "2026-05-15": 2,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 9.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 2,
            "40-42h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-04-13": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-05-15": 2
          },
          "time_per_day": {
            "2026-04-13": 40.450275,
            "2026-04-22": 0.168765,
            "2026-05-04": 0.09746055555555555,
            "2026-05-15": 6.0970691666666665
          },
          "time_count_per_day": {
            "2026-04-13": 1,
            "2026-04-22": 1,
            "2026-05-04": 1,
            "2026-05-15": 2
          }
        },
        "P3": {
          "avg_time_hours": 12.66,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "20-22h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-01-13": 3.4068055555555556,
            "2026-02-18": 21.91476972222222
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 178.95,
          "mode_time_hours": 59.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "36-38h": 1,
            "46-48h": 1,
            "58-60h": 1,
            "66-68h": 1,
            "76-78h": 1,
            "92-94h": 1,
            "96-98h": 1,
            "130-132h": 1,
            "140-142h": 1,
            "142-144h": 1,
            "172-174h": 1,
            "174-176h": 1,
            "178-180h": 1,
            "180-182h": 1,
            "188-190h": 1,
            "202-204h": 1,
            "240-242h": 1,
            "348-350h": 1,
            "356-358h": 1,
            "428-430h": 1,
            "548-550h": 1
          },
          "tickets_count": 29,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2026-01-09": 1,
            "2026-01-24": 2,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-03-18": 5,
            "2026-03-25": 1,
            "2026-03-30": 3,
            "2026-04-07": 2,
            "2026-04-10": 1,
            "2026-04-22": 1,
            "2026-05-14": 1,
            "2026-05-19": 2,
            "2026-05-29": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2025-12-26": 59.37153527777778,
            "2026-01-09": 131.07209277777778,
            "2026-01-24": 413.1563330555556,
            "2026-01-31": 189.41532166666667,
            "2026-02-03": 141.3641188888889,
            "2026-02-05": 178.7987486111111,
            "2026-02-10": 181.27740583333332,
            "2026-02-13": 646.3835136111111,
            "2026-02-17": 142.79086555555554,
            "2026-03-18": 1358.1637516666667,
            "2026-03-25": 36.682413611111116,
            "2026-03-30": 190.73232722222224,
            "2026-04-22": 92.653135,
            "2026-06-03": 174.94298555555557
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2026-01-09": 1,
            "2026-01-24": 2,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-03-18": 5,
            "2026-03-25": 1,
            "2026-03-30": 3,
            "2026-04-22": 1,
            "2026-06-03": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 824.83,
          "mode_time_hours": 1021.0,
          "mode_frequency": 1,
          "time_distribution": {
            "658-660h": 1,
            "792-794h": 1,
            "1020-1022h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-19": 3,
            "2026-02-24": 1
          },
          "time_per_day": {
            "2026-02-19": 2474.503728888889
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 202.61,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 3,
              "18-20h": 1,
              "20-22h": 1,
              "36-38h": 1,
              "40-42h": 1,
              "46-48h": 1,
              "58-60h": 1,
              "66-68h": 1,
              "76-78h": 1,
              "92-94h": 1,
              "96-98h": 1,
              "130-132h": 1,
              "140-142h": 1,
              "142-144h": 1,
              "172-174h": 1,
              "174-176h": 1,
              "178-180h": 1,
              "180-182h": 1,
              "188-190h": 1,
              "202-204h": 1,
              "240-242h": 1,
              "348-350h": 1,
              "356-358h": 1,
              "428-430h": 1,
              "548-550h": 1,
              "658-660h": 1,
              "792-794h": 1,
              "1020-1022h": 1
            },
            "tickets_count": 32,
            "tickets_per_day": {
              "2025-12-26": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-24": 2,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-13": 2,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-03-18": 5,
              "2026-03-25": 1,
              "2026-03-30": 3,
              "2026-04-13": 1,
              "2026-04-22": 2,
              "2026-05-04": 1,
              "2026-05-15": 2,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2025-12-26": 59.37153527777778,
              "2026-01-09": 131.07209277777778,
              "2026-01-13": 3.4068055555555556,
              "2026-01-24": 413.1563330555556,
              "2026-01-31": 189.41532166666667,
              "2026-02-03": 141.3641188888889,
              "2026-02-05": 178.7987486111111,
              "2026-02-10": 181.27740583333332,
              "2026-02-13": 646.3835136111111,
              "2026-02-17": 142.79086555555554,
              "2026-02-18": 21.91476972222222,
              "2026-02-19": 2474.503728888889,
              "2026-03-18": 1358.1637516666667,
              "2026-03-25": 36.682413611111116,
              "2026-03-30": 190.73232722222224,
              "2026-04-13": 40.450275,
              "2026-04-22": 92.8219,
              "2026-05-04": 0.09746055555555555,
              "2026-05-15": 6.0970691666666665,
              "2026-06-03": 174.94298555555557
            },
            "time_count_per_day": {
              "2025-12-26": 1,
              "2026-01-09": 1,
              "2026-01-13": 1,
              "2026-01-24": 2,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-05": 1,
              "2026-02-10": 1,
              "2026-02-13": 2,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 3,
              "2026-03-18": 5,
              "2026-03-25": 1,
              "2026-03-30": 3,
              "2026-04-13": 1,
              "2026-04-22": 2,
              "2026-05-04": 1,
              "2026-05-15": 2,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 2,
                "40-42h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-13": 1,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-05-15": 2
              },
              "time_per_day": {
                "2026-04-13": 40.450275,
                "2026-04-22": 0.168765,
                "2026-05-04": 0.09746055555555555,
                "2026-05-15": 6.0970691666666665
              },
              "time_count_per_day": {
                "2026-04-13": 1,
                "2026-04-22": 1,
                "2026-05-04": 1,
                "2026-05-15": 2
              }
            },
            "P3": {
              "avg_time_hours": 12.66,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "20-22h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-01-13": 3.4068055555555556,
                "2026-02-18": 21.91476972222222
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 178.95,
              "mode_time_hours": 59.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "36-38h": 1,
                "46-48h": 1,
                "58-60h": 1,
                "66-68h": 1,
                "76-78h": 1,
                "92-94h": 1,
                "96-98h": 1,
                "130-132h": 1,
                "140-142h": 1,
                "142-144h": 1,
                "172-174h": 1,
                "174-176h": 1,
                "178-180h": 1,
                "180-182h": 1,
                "188-190h": 1,
                "202-204h": 1,
                "240-242h": 1,
                "348-350h": 1,
                "356-358h": 1,
                "428-430h": 1,
                "548-550h": 1
              },
              "tickets_count": 22,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-01-09": 1,
                "2026-01-24": 2,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-10": 1,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-03-18": 5,
                "2026-03-25": 1,
                "2026-03-30": 3,
                "2026-04-22": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2025-12-26": 59.37153527777778,
                "2026-01-09": 131.07209277777778,
                "2026-01-24": 413.1563330555556,
                "2026-01-31": 189.41532166666667,
                "2026-02-03": 141.3641188888889,
                "2026-02-05": 178.7987486111111,
                "2026-02-10": 181.27740583333332,
                "2026-02-13": 646.3835136111111,
                "2026-02-17": 142.79086555555554,
                "2026-03-18": 1358.1637516666667,
                "2026-03-25": 36.682413611111116,
                "2026-03-30": 190.73232722222224,
                "2026-04-22": 92.653135,
                "2026-06-03": 174.94298555555557
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2026-01-09": 1,
                "2026-01-24": 2,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-05": 1,
                "2026-02-10": 1,
                "2026-02-13": 2,
                "2026-02-17": 1,
                "2026-03-18": 5,
                "2026-03-25": 1,
                "2026-03-30": 3,
                "2026-04-22": 1,
                "2026-06-03": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 824.83,
              "mode_time_hours": 1021.0,
              "mode_frequency": 1,
              "time_distribution": {
                "658-660h": 1,
                "792-794h": 1,
                "1020-1022h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 2474.503728888889
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-04-07": 2,
              "2026-04-10": 1,
              "2026-05-14": 1,
              "2026-05-19": 2,
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-04-07": 2,
                "2026-04-10": 1,
                "2026-05-14": 1,
                "2026-05-19": 2,
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_731": {
      "overall": {
        "avg_time_hours": 304.34,
        "mode_time_hours": 21.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "14-16h": 1,
          "20-22h": 2,
          "50-52h": 1,
          "162-164h": 1,
          "350-352h": 1,
          "876-878h": 1,
          "1236-1238h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-12-26": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-02-19": 2,
          "2026-02-23": 1,
          "2026-03-27": 2,
          "2026-04-06": 1,
          "2026-04-08": 1,
          "2026-04-09": 2,
          "2026-04-10": 1,
          "2026-05-02": 2,
          "2026-05-07": 2,
          "2026-05-11": 1
        },
        "time_per_day": {
          "2025-12-26": 50.73887222222222,
          "2026-02-10": 162.31412027777776,
          "2026-02-18": 43.79953611111111,
          "2026-02-19": 1587.972165277778,
          "2026-02-23": 877.8514341666668,
          "2026-04-10": 15.35417638888889,
          "2026-05-07": 1.0109630555555555
        },
        "time_count_per_day": {
          "2025-12-26": 1,
          "2026-02-10": 1,
          "2026-02-18": 2,
          "2026-02-19": 2,
          "2026-02-23": 1,
          "2026-04-10": 1,
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.18,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "14-16h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-10": 1,
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-04-10": 15.35417638888889,
            "2026-05-07": 1.0109630555555555
          },
          "time_count_per_day": {
            "2026-04-10": 1,
            "2026-05-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 354.03,
          "mode_time_hours": 877.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "162-164h": 1,
            "876-878h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-23": 1
          },
          "time_per_day": {
            "2026-02-10": 162.31412027777776,
            "2026-02-18": 21.91870972222222,
            "2026-02-23": 877.8514341666668
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 21.88,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-03-27": 2,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-09": 2,
            "2026-05-02": 2,
            "2026-05-07": 1,
            "2026-05-11": 1
          },
          "time_per_day": {
            "2026-02-18": 21.88082638888889
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 546.24,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1,
            "350-352h": 1,
            "1236-1238h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2026-02-19": 2
          },
          "time_per_day": {
            "2025-12-26": 50.73887222222222,
            "2026-02-19": 1587.972165277778
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 304.34,
            "mode_time_hours": 21.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "14-16h": 1,
              "20-22h": 2,
              "50-52h": 1,
              "162-164h": 1,
              "350-352h": 1,
              "876-878h": 1,
              "1236-1238h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2025-12-26": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-02-19": 2,
              "2026-02-23": 1,
              "2026-04-10": 1,
              "2026-05-07": 1
            },
            "time_per_day": {
              "2025-12-26": 50.73887222222222,
              "2026-02-10": 162.31412027777776,
              "2026-02-18": 43.79953611111111,
              "2026-02-19": 1587.972165277778,
              "2026-02-23": 877.8514341666668,
              "2026-04-10": 15.35417638888889,
              "2026-05-07": 1.0109630555555555
            },
            "time_count_per_day": {
              "2025-12-26": 1,
              "2026-02-10": 1,
              "2026-02-18": 2,
              "2026-02-19": 2,
              "2026-02-23": 1,
              "2026-04-10": 1,
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.18,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "14-16h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-10": 1,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-04-10": 15.35417638888889,
                "2026-05-07": 1.0109630555555555
              },
              "time_count_per_day": {
                "2026-04-10": 1,
                "2026-05-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 354.03,
              "mode_time_hours": 877.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "162-164h": 1,
                "876-878h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-23": 1
              },
              "time_per_day": {
                "2026-02-10": 162.31412027777776,
                "2026-02-18": 21.91870972222222,
                "2026-02-23": 877.8514341666668
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-02-18": 1,
                "2026-02-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 21.88,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 21.88082638888889
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 546.24,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1,
                "350-352h": 1,
                "1236-1238h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-02-19": 2
              },
              "time_per_day": {
                "2025-12-26": 50.73887222222222,
                "2026-02-19": 1587.972165277778
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-03-27": 2,
              "2026-04-06": 1,
              "2026-04-08": 1,
              "2026-04-09": 2,
              "2026-05-02": 2,
              "2026-05-07": 1,
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-03-27": 2,
                "2026-04-06": 1,
                "2026-04-08": 1,
                "2026-04-09": 2,
                "2026-05-02": 2,
                "2026-05-07": 1,
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_732": {
      "overall": {
        "avg_time_hours": 1.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-26": 1
        },
        "time_per_day": {
          "2025-12-26": 1.299785
        },
        "time_count_per_day": {
          "2025-12-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-26": 1
          },
          "time_per_day": {
            "2025-12-26": 1.299785
          },
          "time_count_per_day": {
            "2025-12-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-26": 1
            },
            "time_per_day": {
              "2025-12-26": 1.299785
            },
            "time_count_per_day": {
              "2025-12-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-26": 1
              },
              "time_per_day": {
                "2025-12-26": 1.299785
              },
              "time_count_per_day": {
                "2025-12-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_733": {
      "overall": {
        "avg_time_hours": 493.58,
        "mode_time_hours": 493.0,
        "mode_frequency": 1,
        "time_distribution": {
          "492-494h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 493.5818847222222
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 493.58,
          "mode_time_hours": 493.0,
          "mode_frequency": 1,
          "time_distribution": {
            "492-494h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 493.5818847222222
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 493.58,
            "mode_time_hours": 493.0,
            "mode_frequency": 1,
            "time_distribution": {
              "492-494h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 493.5818847222222
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 493.58,
              "mode_time_hours": 493.0,
              "mode_frequency": 1,
              "time_distribution": {
                "492-494h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 493.5818847222222
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_735": {
      "overall": {
        "avg_time_hours": 265.33,
        "mode_time_hours": 451.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1,
          "450-452h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-05": 1,
          "2026-01-14": 1
        },
        "time_per_day": {
          "2026-01-05": 79.63754972222222,
          "2026-01-14": 451.0249366666667
        },
        "time_count_per_day": {
          "2026-01-05": 1,
          "2026-01-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 79.64,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-05": 1
          },
          "time_per_day": {
            "2026-01-05": 79.63754972222222
          },
          "time_count_per_day": {
            "2026-01-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 451.02,
          "mode_time_hours": 451.0,
          "mode_frequency": 1,
          "time_distribution": {
            "450-452h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 451.0249366666667
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 265.33,
            "mode_time_hours": 451.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1,
              "450-452h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-05": 1,
              "2026-01-14": 1
            },
            "time_per_day": {
              "2026-01-05": 79.63754972222222,
              "2026-01-14": 451.0249366666667
            },
            "time_count_per_day": {
              "2026-01-05": 1,
              "2026-01-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 79.64,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {
                "2026-01-05": 79.63754972222222
              },
              "time_count_per_day": {
                "2026-01-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 451.02,
              "mode_time_hours": 451.0,
              "mode_frequency": 1,
              "time_distribution": {
                "450-452h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 451.0249366666667
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_736": {
      "overall": {
        "avg_time_hours": 71.01,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 71.00988611111111
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 71.01,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 71.00988611111111
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 71.01,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 71.00988611111111
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 71.01,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 71.00988611111111
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_348": {
      "overall": {
        "avg_time_hours": 0.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2025-12-26": 1,
          "2026-03-17": 1
        },
        "time_per_day": {
          "2025-12-26": 0.03320583333333333,
          "2026-03-17": 0.11725305555555555
        },
        "time_count_per_day": {
          "2025-12-26": 1,
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-26": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2025-12-26": 0.03320583333333333,
            "2026-03-17": 0.11725305555555555
          },
          "time_count_per_day": {
            "2025-12-26": 1,
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2025-12-26": 1,
              "2026-03-17": 1
            },
            "time_per_day": {
              "2025-12-26": 0.03320583333333333,
              "2026-03-17": 0.11725305555555555
            },
            "time_count_per_day": {
              "2025-12-26": 1,
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-26": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2025-12-26": 0.03320583333333333,
                "2026-03-17": 0.11725305555555555
              },
              "time_count_per_day": {
                "2025-12-26": 1,
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_737": {
      "overall": {
        "avg_time_hours": 67.48,
        "mode_time_hours": 67.0,
        "mode_frequency": 1,
        "time_distribution": {
          "66-68h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 67.47783055555556
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 67.48,
          "mode_time_hours": 67.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 67.47783055555556
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 67.48,
            "mode_time_hours": 67.0,
            "mode_frequency": 1,
            "time_distribution": {
              "66-68h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 67.47783055555556
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 67.48,
              "mode_time_hours": 67.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 67.47783055555556
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_738": {
      "overall": {
        "avg_time_hours": 53.52,
        "mode_time_hours": 53.0,
        "mode_frequency": 1,
        "time_distribution": {
          "52-54h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 53.51681305555556
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 53.52,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "52-54h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 53.51681305555556
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 53.52,
            "mode_time_hours": 53.0,
            "mode_frequency": 1,
            "time_distribution": {
              "52-54h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 53.51681305555556
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 53.52,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "52-54h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 53.51681305555556
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_740": {
      "overall": {
        "avg_time_hours": 1271.64,
        "mode_time_hours": 1271.0,
        "mode_frequency": 3,
        "time_distribution": {
          "1270-1272h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-19": 3
        },
        "time_per_day": {
          "2026-02-19": 3814.9098538888884
        },
        "time_count_per_day": {
          "2026-02-19": 3
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1271.64,
          "mode_time_hours": 1271.0,
          "mode_frequency": 3,
          "time_distribution": {
            "1270-1272h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 3814.9098538888884
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1271.64,
            "mode_time_hours": 1271.0,
            "mode_frequency": 3,
            "time_distribution": {
              "1270-1272h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-19": 3
            },
            "time_per_day": {
              "2026-02-19": 3814.9098538888884
            },
            "time_count_per_day": {
              "2026-02-19": 3
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1271.64,
              "mode_time_hours": 1271.0,
              "mode_frequency": 3,
              "time_distribution": {
                "1270-1272h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 3814.9098538888884
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        }
      }
    },
    "cliente_742": {
      "overall": {
        "avg_time_hours": 65.31,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "188-190h": 1,
          "266-268h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-12-29": 2,
          "2026-01-08": 1,
          "2026-02-10": 1,
          "2026-04-13": 1,
          "2026-04-27": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2025-12-29": 1.4963108333333333,
          "2026-01-08": 266.64291833333334,
          "2026-02-10": 188.2631327777778,
          "2026-04-13": 0.23641361111111112,
          "2026-04-27": 0.30334777777777777,
          "2026-06-01": 0.20957694444444444
        },
        "time_count_per_day": {
          "2025-12-29": 2,
          "2026-01-08": 1,
          "2026-02-10": 1,
          "2026-04-13": 1,
          "2026-04-27": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.37,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-29": 1,
            "2026-04-13": 1,
            "2026-04-27": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2025-12-29": 0.7421338888888889,
            "2026-04-13": 0.23641361111111112,
            "2026-04-27": 0.30334777777777777,
            "2026-06-01": 0.20957694444444444
          },
          "time_count_per_day": {
            "2025-12-29": 1,
            "2026-04-13": 1,
            "2026-04-27": 1,
            "2026-06-01": 1
          }
        },
        "P3": {
          "avg_time_hours": 188.26,
          "mode_time_hours": 189.0,
          "mode_frequency": 1,
          "time_distribution": {
            "188-190h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 188.2631327777778
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 133.7,
          "mode_time_hours": 267.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "266-268h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-29": 1,
            "2026-01-08": 1
          },
          "time_per_day": {
            "2025-12-29": 0.7541769444444444,
            "2026-01-08": 266.64291833333334
          },
          "time_count_per_day": {
            "2025-12-29": 1,
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 65.31,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "188-190h": 1,
              "266-268h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2025-12-29": 2,
              "2026-01-08": 1,
              "2026-02-10": 1,
              "2026-04-13": 1,
              "2026-04-27": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2025-12-29": 1.4963108333333333,
              "2026-01-08": 266.64291833333334,
              "2026-02-10": 188.2631327777778,
              "2026-04-13": 0.23641361111111112,
              "2026-04-27": 0.30334777777777777,
              "2026-06-01": 0.20957694444444444
            },
            "time_count_per_day": {
              "2025-12-29": 2,
              "2026-01-08": 1,
              "2026-02-10": 1,
              "2026-04-13": 1,
              "2026-04-27": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.37,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2025-12-29": 1,
                "2026-04-13": 1,
                "2026-04-27": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2025-12-29": 0.7421338888888889,
                "2026-04-13": 0.23641361111111112,
                "2026-04-27": 0.30334777777777777,
                "2026-06-01": 0.20957694444444444
              },
              "time_count_per_day": {
                "2025-12-29": 1,
                "2026-04-13": 1,
                "2026-04-27": 1,
                "2026-06-01": 1
              }
            },
            "P3": {
              "avg_time_hours": 188.26,
              "mode_time_hours": 189.0,
              "mode_frequency": 1,
              "time_distribution": {
                "188-190h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 188.2631327777778
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 133.7,
              "mode_time_hours": 267.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "266-268h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2025-12-29": 1,
                "2026-01-08": 1
              },
              "time_per_day": {
                "2025-12-29": 0.7541769444444444,
                "2026-01-08": 266.64291833333334
              },
              "time_count_per_day": {
                "2025-12-29": 1,
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_743": {
      "overall": {
        "avg_time_hours": 56.09,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "16-18h": 1,
          "22-24h": 1,
          "32-34h": 1,
          "100-102h": 1,
          "380-382h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2025-12-29": 1,
          "2026-02-06": 1,
          "2026-03-14": 2,
          "2026-03-23": 4,
          "2026-03-24": 1,
          "2026-04-02": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2025-12-29": 23.532374722222222,
          "2026-02-06": 381.4613411111111,
          "2026-03-14": 119.47189527777778,
          "2026-03-23": 3.1766305555555556,
          "2026-03-24": 33.112075,
          "2026-05-18": 0.11519305555555555
        },
        "time_count_per_day": {
          "2025-12-29": 1,
          "2026-02-06": 1,
          "2026-03-14": 2,
          "2026-03-23": 4,
          "2026-03-24": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-03-23": 4,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-03-23": 3.1766305555555556,
            "2026-05-18": 0.11519305555555555
          },
          "time_count_per_day": {
            "2026-03-23": 4,
            "2026-05-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 111.52,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "22-24h": 1,
            "32-34h": 1,
            "100-102h": 1,
            "380-382h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-12-29": 1,
            "2026-02-06": 1,
            "2026-03-14": 2,
            "2026-03-24": 1,
            "2026-04-02": 1
          },
          "time_per_day": {
            "2025-12-29": 23.532374722222222,
            "2026-02-06": 381.4613411111111,
            "2026-03-14": 119.47189527777778,
            "2026-03-24": 33.112075
          },
          "time_count_per_day": {
            "2025-12-29": 1,
            "2026-02-06": 1,
            "2026-03-14": 2,
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 56.09,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "16-18h": 1,
              "22-24h": 1,
              "32-34h": 1,
              "100-102h": 1,
              "380-382h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2025-12-29": 1,
              "2026-02-06": 1,
              "2026-03-14": 2,
              "2026-03-23": 4,
              "2026-03-24": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2025-12-29": 23.532374722222222,
              "2026-02-06": 381.4613411111111,
              "2026-03-14": 119.47189527777778,
              "2026-03-23": 3.1766305555555556,
              "2026-03-24": 33.112075,
              "2026-05-18": 0.11519305555555555
            },
            "time_count_per_day": {
              "2025-12-29": 1,
              "2026-02-06": 1,
              "2026-03-14": 2,
              "2026-03-23": 4,
              "2026-03-24": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-23": 4,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-03-23": 3.1766305555555556,
                "2026-05-18": 0.11519305555555555
              },
              "time_count_per_day": {
                "2026-03-23": 4,
                "2026-05-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 111.52,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "22-24h": 1,
                "32-34h": 1,
                "100-102h": 1,
                "380-382h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2025-12-29": 1,
                "2026-02-06": 1,
                "2026-03-14": 2,
                "2026-03-24": 1
              },
              "time_per_day": {
                "2025-12-29": 23.532374722222222,
                "2026-02-06": 381.4613411111111,
                "2026-03-14": 119.47189527777778,
                "2026-03-24": 33.112075
              },
              "time_count_per_day": {
                "2025-12-29": 1,
                "2026-02-06": 1,
                "2026-03-14": 2,
                "2026-03-24": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_244": {
      "overall": {
        "avg_time_hours": 121.0,
        "mode_time_hours": 241.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "240-242h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-03-07": 1
        },
        "time_per_day": {
          "2026-01-08": 241.66277277777777,
          "2026-03-07": 0.33424472222222223
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-03-07": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 241.66,
          "mode_time_hours": 241.0,
          "mode_frequency": 1,
          "time_distribution": {
            "240-242h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 241.66277277777777
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        },
        "P2": {
          "avg_time_hours": 0.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-07": 1
          },
          "time_per_day": {
            "2026-03-07": 0.33424472222222223
          },
          "time_count_per_day": {
            "2026-03-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 121.0,
            "mode_time_hours": 241.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "240-242h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-03-07": 1
            },
            "time_per_day": {
              "2026-01-08": 241.66277277777777,
              "2026-03-07": 0.33424472222222223
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-03-07": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 241.66,
              "mode_time_hours": 241.0,
              "mode_frequency": 1,
              "time_distribution": {
                "240-242h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 241.66277277777777
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            },
            "P2": {
              "avg_time_hours": 0.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-07": 1
              },
              "time_per_day": {
                "2026-03-07": 0.33424472222222223
              },
              "time_count_per_day": {
                "2026-03-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_258": {
      "overall": {
        "avg_time_hours": 2.83,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-29": 1
        },
        "time_per_day": {
          "2025-12-29": 2.8306591666666665
        },
        "time_count_per_day": {
          "2025-12-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.83,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {
            "2025-12-29": 2.8306591666666665
          },
          "time_count_per_day": {
            "2025-12-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.83,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {
              "2025-12-29": 2.8306591666666665
            },
            "time_count_per_day": {
              "2025-12-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.83,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {
                "2025-12-29": 2.8306591666666665
              },
              "time_count_per_day": {
                "2025-12-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_747": {
      "overall": {
        "avg_time_hours": 640.86,
        "mode_time_hours": 1027.0,
        "mode_frequency": 2,
        "time_distribution": {
          "28-30h": 1,
          "190-192h": 1,
          "300-302h": 1,
          "672-674h": 1,
          "1026-1028h": 2,
          "1236-1238h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-19": 5
        },
        "time_per_day": {
          "2026-02-03": 301.3532327777778,
          "2026-02-18": 28.312341666666665,
          "2026-02-19": 4156.3380872222215
        },
        "time_count_per_day": {
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-19": 5
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 28.31,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 28.312341666666665
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 301.35,
          "mode_time_hours": 301.0,
          "mode_frequency": 1,
          "time_distribution": {
            "300-302h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 301.3532327777778
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 831.27,
          "mode_time_hours": 1027.0,
          "mode_frequency": 2,
          "time_distribution": {
            "190-192h": 1,
            "672-674h": 1,
            "1026-1028h": 2,
            "1236-1238h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-19": 5
          },
          "time_per_day": {
            "2026-02-19": 4156.3380872222215
          },
          "time_count_per_day": {
            "2026-02-19": 5
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 640.86,
            "mode_time_hours": 1027.0,
            "mode_frequency": 2,
            "time_distribution": {
              "28-30h": 1,
              "190-192h": 1,
              "300-302h": 1,
              "672-674h": 1,
              "1026-1028h": 2,
              "1236-1238h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-19": 5
            },
            "time_per_day": {
              "2026-02-03": 301.3532327777778,
              "2026-02-18": 28.312341666666665,
              "2026-02-19": 4156.3380872222215
            },
            "time_count_per_day": {
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-19": 5
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 28.31,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 28.312341666666665
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 301.35,
              "mode_time_hours": 301.0,
              "mode_frequency": 1,
              "time_distribution": {
                "300-302h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 301.3532327777778
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 831.27,
              "mode_time_hours": 1027.0,
              "mode_frequency": 2,
              "time_distribution": {
                "190-192h": 1,
                "672-674h": 1,
                "1026-1028h": 2,
                "1236-1238h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-19": 5
              },
              "time_per_day": {
                "2026-02-19": 4156.3380872222215
              },
              "time_count_per_day": {
                "2026-02-19": 5
              }
            }
          }
        }
      }
    },
    "cliente_55": {
      "overall": {
        "avg_time_hours": 48.01,
        "mode_time_hours": 95.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "94-96h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-02": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-01-02": 95.08242777777778,
          "2026-05-26": 0.9288694444444444
        },
        "time_count_per_day": {
          "2026-01-02": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 0.9288694444444444
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 95.08,
          "mode_time_hours": 95.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-02": 1
          },
          "time_per_day": {
            "2026-01-02": 95.08242777777778
          },
          "time_count_per_day": {
            "2026-01-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.01,
            "mode_time_hours": 95.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "94-96h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-02": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-01-02": 95.08242777777778,
              "2026-05-26": 0.9288694444444444
            },
            "time_count_per_day": {
              "2026-01-02": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 0.9288694444444444
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 95.08,
              "mode_time_hours": 95.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-02": 1
              },
              "time_per_day": {
                "2026-01-02": 95.08242777777778
              },
              "time_count_per_day": {
                "2026-01-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_748": {
      "overall": {
        "avg_time_hours": 148.94,
        "mode_time_hours": 149.0,
        "mode_frequency": 1,
        "time_distribution": {
          "148-150h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-05": 1
        },
        "time_per_day": {
          "2026-01-05": 148.93894305555554
        },
        "time_count_per_day": {
          "2026-01-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 148.94,
          "mode_time_hours": 149.0,
          "mode_frequency": 1,
          "time_distribution": {
            "148-150h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-05": 1
          },
          "time_per_day": {
            "2026-01-05": 148.93894305555554
          },
          "time_count_per_day": {
            "2026-01-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 148.94,
            "mode_time_hours": 149.0,
            "mode_frequency": 1,
            "time_distribution": {
              "148-150h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-05": 1
            },
            "time_per_day": {
              "2026-01-05": 148.93894305555554
            },
            "time_count_per_day": {
              "2026-01-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 148.94,
              "mode_time_hours": 149.0,
              "mode_frequency": 1,
              "time_distribution": {
                "148-150h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {
                "2026-01-05": 148.93894305555554
              },
              "time_count_per_day": {
                "2026-01-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_749": {
      "overall": {
        "avg_time_hours": 134.98,
        "mode_time_hours": 161.0,
        "mode_frequency": 2,
        "time_distribution": {
          "6-8h": 1,
          "14-16h": 1,
          "20-22h": 1,
          "120-122h": 1,
          "160-162h": 2,
          "168-170h": 1,
          "424-426h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2026-01-06": 1,
          "2026-02-20": 1,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-04-17": 1,
          "2026-05-02": 1,
          "2026-05-06": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-25": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-01-06": 168.47890666666666,
          "2026-02-20": 20.20947,
          "2026-04-08": 14.607613333333335,
          "2026-04-14": 161.11483055555556,
          "2026-05-02": 6.819760277777777,
          "2026-05-06": 161.84670916666667,
          "2026-05-19": 424.9292575,
          "2026-05-25": 121.86889055555555
        },
        "time_count_per_day": {
          "2026-01-06": 1,
          "2026-02-20": 1,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-05-02": 1,
          "2026-05-06": 1,
          "2026-05-19": 1,
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 424.93,
          "mode_time_hours": 425.0,
          "mode_frequency": 1,
          "time_distribution": {
            "424-426h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-19": 1
          },
          "time_per_day": {
            "2026-05-19": 424.9292575
          },
          "time_count_per_day": {
            "2026-05-19": 1
          }
        },
        "P2": {
          "avg_time_hours": 93.56,
          "mode_time_hours": 161.0,
          "mode_frequency": 2,
          "time_distribution": {
            "6-8h": 1,
            "14-16h": 1,
            "20-22h": 1,
            "120-122h": 1,
            "160-162h": 2,
            "168-170h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-01-06": 1,
            "2026-02-20": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-17": 1,
            "2026-05-02": 1,
            "2026-05-06": 1,
            "2026-05-20": 1,
            "2026-05-25": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-01-06": 168.47890666666666,
            "2026-02-20": 20.20947,
            "2026-04-08": 14.607613333333335,
            "2026-04-14": 161.11483055555556,
            "2026-05-02": 6.819760277777777,
            "2026-05-06": 161.84670916666667,
            "2026-05-25": 121.86889055555555
          },
          "time_count_per_day": {
            "2026-01-06": 1,
            "2026-02-20": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-05-02": 1,
            "2026-05-06": 1,
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 134.98,
            "mode_time_hours": 161.0,
            "mode_frequency": 2,
            "time_distribution": {
              "6-8h": 1,
              "14-16h": 1,
              "20-22h": 1,
              "120-122h": 1,
              "160-162h": 2,
              "168-170h": 1,
              "424-426h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-01-06": 1,
              "2026-02-20": 1,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-05-02": 1,
              "2026-05-06": 1,
              "2026-05-19": 1,
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-01-06": 168.47890666666666,
              "2026-02-20": 20.20947,
              "2026-04-08": 14.607613333333335,
              "2026-04-14": 161.11483055555556,
              "2026-05-02": 6.819760277777777,
              "2026-05-06": 161.84670916666667,
              "2026-05-19": 424.9292575,
              "2026-05-25": 121.86889055555555
            },
            "time_count_per_day": {
              "2026-01-06": 1,
              "2026-02-20": 1,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-05-02": 1,
              "2026-05-06": 1,
              "2026-05-19": 1,
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 424.93,
              "mode_time_hours": 425.0,
              "mode_frequency": 1,
              "time_distribution": {
                "424-426h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-05-19": 424.9292575
              },
              "time_count_per_day": {
                "2026-05-19": 1
              }
            },
            "P2": {
              "avg_time_hours": 93.56,
              "mode_time_hours": 161.0,
              "mode_frequency": 2,
              "time_distribution": {
                "6-8h": 1,
                "14-16h": 1,
                "20-22h": 1,
                "120-122h": 1,
                "160-162h": 2,
                "168-170h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-01-06": 1,
                "2026-02-20": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-05-02": 1,
                "2026-05-06": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-01-06": 168.47890666666666,
                "2026-02-20": 20.20947,
                "2026-04-08": 14.607613333333335,
                "2026-04-14": 161.11483055555556,
                "2026-05-02": 6.819760277777777,
                "2026-05-06": 161.84670916666667,
                "2026-05-25": 121.86889055555555
              },
              "time_count_per_day": {
                "2026-01-06": 1,
                "2026-02-20": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-05-02": 1,
                "2026-05-06": 1,
                "2026-05-25": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-17": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_750": {
      "overall": {
        "avg_time_hours": 0.24,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-12-30": 0.24309555555555556
        },
        "time_count_per_day": {
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.24,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-12-30": 0.24309555555555556
          },
          "time_count_per_day": {
            "2025-12-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.24,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-12-30": 0.24309555555555556
            },
            "time_count_per_day": {
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.24,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-12-30": 0.24309555555555556
              },
              "time_count_per_day": {
                "2025-12-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_751": {
      "overall": {
        "avg_time_hours": 0.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-12-30": 1
        },
        "time_per_day": {
          "2025-12-30": 0.07473583333333332
        },
        "time_count_per_day": {
          "2025-12-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-30": 1
          },
          "time_per_day": {
            "2025-12-30": 0.07473583333333332
          },
          "time_count_per_day": {
            "2025-12-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-30": 1
            },
            "time_per_day": {
              "2025-12-30": 0.07473583333333332
            },
            "time_count_per_day": {
              "2025-12-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-30": 1
              },
              "time_per_day": {
                "2025-12-30": 0.07473583333333332
              },
              "time_count_per_day": {
                "2025-12-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_752": {
      "overall": {
        "avg_time_hours": 6.66,
        "mode_time_hours": 1.0,
        "mode_frequency": 16,
        "time_distribution": {
          "0-2h": 16,
          "2-4h": 2,
          "4-6h": 6,
          "10-12h": 2,
          "12-14h": 2,
          "14-16h": 5,
          "18-20h": 2,
          "20-22h": 2
        },
        "tickets_count": 37,
        "tickets_per_day": {
          "2025-12-30": 1,
          "2026-01-13": 4,
          "2026-01-15": 2,
          "2026-01-16": 2,
          "2026-01-18": 5,
          "2026-01-20": 1,
          "2026-02-06": 4,
          "2026-02-19": 4,
          "2026-04-15": 1,
          "2026-04-17": 2,
          "2026-04-23": 1,
          "2026-04-24": 2,
          "2026-04-29": 1,
          "2026-05-08": 2,
          "2026-06-03": 3,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2025-12-30": 0.22544333333333333,
          "2026-01-13": 17.253721111111112,
          "2026-01-15": 22.537391944444444,
          "2026-01-16": 3.823486388888889,
          "2026-01-18": 70.93317277777778,
          "2026-01-20": 4.58475,
          "2026-02-06": 79.73436472222222,
          "2026-02-19": 4.215605833333333,
          "2026-04-15": 4.225263055555556,
          "2026-04-17": 5.2778294444444445,
          "2026-04-23": 0.3699747222222223,
          "2026-04-24": 26.484526666666667,
          "2026-04-29": 1.8299830555555556,
          "2026-05-08": 1.0239363888888888,
          "2026-06-03": 0.7198899999999999,
          "2026-06-05": 3.0789919444444447
        },
        "time_count_per_day": {
          "2025-12-30": 1,
          "2026-01-13": 4,
          "2026-01-15": 2,
          "2026-01-16": 2,
          "2026-01-18": 5,
          "2026-01-20": 1,
          "2026-02-06": 4,
          "2026-02-19": 4,
          "2026-04-15": 1,
          "2026-04-17": 2,
          "2026-04-23": 1,
          "2026-04-24": 2,
          "2026-04-29": 1,
          "2026-05-08": 2,
          "2026-06-03": 3,
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.99,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 1,
            "4-6h": 1,
            "10-12h": 2,
            "12-14h": 2,
            "18-20h": 2,
            "20-22h": 2
          },
          "tickets_count": 25,
          "tickets_per_day": {
            "2025-12-30": 1,
            "2026-01-15": 2,
            "2026-02-06": 4,
            "2026-02-19": 4,
            "2026-04-15": 1,
            "2026-04-17": 2,
            "2026-04-23": 1,
            "2026-04-24": 2,
            "2026-04-29": 1,
            "2026-05-08": 2,
            "2026-06-03": 3,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2025-12-30": 0.22544333333333333,
            "2026-01-15": 22.537391944444444,
            "2026-02-06": 79.73436472222222,
            "2026-02-19": 4.215605833333333,
            "2026-04-15": 4.225263055555556,
            "2026-04-17": 5.2778294444444445,
            "2026-04-23": 0.3699747222222223,
            "2026-04-24": 26.484526666666667,
            "2026-04-29": 1.8299830555555556,
            "2026-05-08": 1.0239363888888888,
            "2026-06-03": 0.7198899999999999,
            "2026-06-05": 3.0789919444444447
          },
          "time_count_per_day": {
            "2025-12-30": 1,
            "2026-01-15": 2,
            "2026-02-06": 4,
            "2026-02-19": 4,
            "2026-04-15": 1,
            "2026-04-17": 2,
            "2026-04-23": 1,
            "2026-04-24": 2,
            "2026-04-29": 1,
            "2026-05-08": 2,
            "2026-06-03": 3,
            "2026-06-05": 2
          }
        },
        "P3": {
          "avg_time_hours": 8.05,
          "mode_time_hours": 5.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 5,
            "14-16h": 5
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2026-01-13": 4,
            "2026-01-16": 2,
            "2026-01-18": 5,
            "2026-01-20": 1
          },
          "time_per_day": {
            "2026-01-13": 17.253721111111112,
            "2026-01-16": 3.823486388888889,
            "2026-01-18": 70.93317277777778,
            "2026-01-20": 4.58475
          },
          "time_count_per_day": {
            "2026-01-13": 4,
            "2026-01-16": 2,
            "2026-01-18": 5,
            "2026-01-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.66,
            "mode_time_hours": 1.0,
            "mode_frequency": 16,
            "time_distribution": {
              "0-2h": 16,
              "2-4h": 2,
              "4-6h": 6,
              "10-12h": 2,
              "12-14h": 2,
              "14-16h": 5,
              "18-20h": 2,
              "20-22h": 2
            },
            "tickets_count": 37,
            "tickets_per_day": {
              "2025-12-30": 1,
              "2026-01-13": 4,
              "2026-01-15": 2,
              "2026-01-16": 2,
              "2026-01-18": 5,
              "2026-01-20": 1,
              "2026-02-06": 4,
              "2026-02-19": 4,
              "2026-04-15": 1,
              "2026-04-17": 2,
              "2026-04-23": 1,
              "2026-04-24": 2,
              "2026-04-29": 1,
              "2026-05-08": 2,
              "2026-06-03": 3,
              "2026-06-05": 2
            },
            "time_per_day": {
              "2025-12-30": 0.22544333333333333,
              "2026-01-13": 17.253721111111112,
              "2026-01-15": 22.537391944444444,
              "2026-01-16": 3.823486388888889,
              "2026-01-18": 70.93317277777778,
              "2026-01-20": 4.58475,
              "2026-02-06": 79.73436472222222,
              "2026-02-19": 4.215605833333333,
              "2026-04-15": 4.225263055555556,
              "2026-04-17": 5.2778294444444445,
              "2026-04-23": 0.3699747222222223,
              "2026-04-24": 26.484526666666667,
              "2026-04-29": 1.8299830555555556,
              "2026-05-08": 1.0239363888888888,
              "2026-06-03": 0.7198899999999999,
              "2026-06-05": 3.0789919444444447
            },
            "time_count_per_day": {
              "2025-12-30": 1,
              "2026-01-13": 4,
              "2026-01-15": 2,
              "2026-01-16": 2,
              "2026-01-18": 5,
              "2026-01-20": 1,
              "2026-02-06": 4,
              "2026-02-19": 4,
              "2026-04-15": 1,
              "2026-04-17": 2,
              "2026-04-23": 1,
              "2026-04-24": 2,
              "2026-04-29": 1,
              "2026-05-08": 2,
              "2026-06-03": 3,
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.99,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 1,
                "4-6h": 1,
                "10-12h": 2,
                "12-14h": 2,
                "18-20h": 2,
                "20-22h": 2
              },
              "tickets_count": 25,
              "tickets_per_day": {
                "2025-12-30": 1,
                "2026-01-15": 2,
                "2026-02-06": 4,
                "2026-02-19": 4,
                "2026-04-15": 1,
                "2026-04-17": 2,
                "2026-04-23": 1,
                "2026-04-24": 2,
                "2026-04-29": 1,
                "2026-05-08": 2,
                "2026-06-03": 3,
                "2026-06-05": 2
              },
              "time_per_day": {
                "2025-12-30": 0.22544333333333333,
                "2026-01-15": 22.537391944444444,
                "2026-02-06": 79.73436472222222,
                "2026-02-19": 4.215605833333333,
                "2026-04-15": 4.225263055555556,
                "2026-04-17": 5.2778294444444445,
                "2026-04-23": 0.3699747222222223,
                "2026-04-24": 26.484526666666667,
                "2026-04-29": 1.8299830555555556,
                "2026-05-08": 1.0239363888888888,
                "2026-06-03": 0.7198899999999999,
                "2026-06-05": 3.0789919444444447
              },
              "time_count_per_day": {
                "2025-12-30": 1,
                "2026-01-15": 2,
                "2026-02-06": 4,
                "2026-02-19": 4,
                "2026-04-15": 1,
                "2026-04-17": 2,
                "2026-04-23": 1,
                "2026-04-24": 2,
                "2026-04-29": 1,
                "2026-05-08": 2,
                "2026-06-03": 3,
                "2026-06-05": 2
              }
            },
            "P3": {
              "avg_time_hours": 8.05,
              "mode_time_hours": 5.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 5,
                "14-16h": 5
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-01-13": 4,
                "2026-01-16": 2,
                "2026-01-18": 5,
                "2026-01-20": 1
              },
              "time_per_day": {
                "2026-01-13": 17.253721111111112,
                "2026-01-16": 3.823486388888889,
                "2026-01-18": 70.93317277777778,
                "2026-01-20": 4.58475
              },
              "time_count_per_day": {
                "2026-01-13": 4,
                "2026-01-16": 2,
                "2026-01-18": 5,
                "2026-01-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_753": {
      "overall": {
        "avg_time_hours": 242.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "4-6h": 1,
          "6-8h": 1,
          "16-18h": 1,
          "38-40h": 1,
          "42-44h": 2,
          "66-68h": 1,
          "84-86h": 1,
          "138-140h": 1,
          "288-290h": 1,
          "308-310h": 1,
          "336-338h": 1,
          "350-352h": 1,
          "650-652h": 1,
          "1152-1154h": 1,
          "1202-1204h": 1,
          "1326-1328h": 1
        },
        "tickets_count": 26,
        "tickets_per_day": {
          "2026-01-05": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-23": 2,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-24": 1,
          "2026-03-04": 1,
          "2026-03-09": 1,
          "2026-03-13": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-24": 3,
          "2026-03-26": 1,
          "2026-04-23": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-01-05": 139.29470555555557,
          "2026-01-13": 6.96764,
          "2026-01-15": 84.47401194444446,
          "2026-01-23": 5.375035555555555,
          "2026-02-02": 1.0628133333333334,
          "2026-02-03": 351.55231694444444,
          "2026-02-09": 374.2746980555556,
          "2026-02-10": 17.96340027777778,
          "2026-02-14": 43.89619666666666,
          "2026-02-19": 0.3587702777777778,
          "2026-02-21": 38.19980555555555,
          "2026-02-24": 1.0121725,
          "2026-03-04": 42.50203916666666,
          "2026-03-09": 0.15751416666666668,
          "2026-03-13": 336.371035,
          "2026-03-16": 2.5490294444444443,
          "2026-03-17": 0.7799311111111111,
          "2026-03-24": 3682.911213055556,
          "2026-03-26": 650.3586863888889,
          "2026-05-06": 289.70557
        },
        "time_count_per_day": {
          "2026-01-05": 1,
          "2026-01-13": 1,
          "2026-01-15": 1,
          "2026-01-23": 2,
          "2026-02-02": 1,
          "2026-02-03": 1,
          "2026-02-09": 2,
          "2026-02-10": 1,
          "2026-02-14": 1,
          "2026-02-19": 1,
          "2026-02-21": 1,
          "2026-02-24": 1,
          "2026-03-04": 1,
          "2026-03-09": 1,
          "2026-03-13": 1,
          "2026-03-16": 2,
          "2026-03-17": 1,
          "2026-03-24": 3,
          "2026-03-26": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 351.55,
          "mode_time_hours": 351.0,
          "mode_frequency": 1,
          "time_distribution": {
            "350-352h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-02-03": 351.55231694444444
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "P2": {
          "avg_time_hours": 126.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8,
            "4-6h": 1,
            "6-8h": 1,
            "38-40h": 1,
            "42-44h": 1,
            "138-140h": 1,
            "288-290h": 1,
            "336-338h": 1,
            "1152-1154h": 1
          },
          "tickets_count": 16,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-01-13": 1,
            "2026-01-23": 2,
            "2026-02-02": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-24": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-01-05": 139.29470555555557,
            "2026-01-13": 6.96764,
            "2026-01-23": 5.375035555555555,
            "2026-02-02": 1.0628133333333334,
            "2026-02-19": 0.3587702777777778,
            "2026-02-21": 38.19980555555555,
            "2026-02-24": 1.0121725,
            "2026-03-04": 42.50203916666666,
            "2026-03-09": 0.15751416666666668,
            "2026-03-13": 336.371035,
            "2026-03-16": 2.5490294444444443,
            "2026-03-17": 0.7799311111111111,
            "2026-03-24": 1152.192245,
            "2026-05-06": 289.70557
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-01-13": 1,
            "2026-01-23": 2,
            "2026-02-02": 1,
            "2026-02-19": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-03-04": 1,
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-16": 2,
            "2026-03-17": 1,
            "2026-03-24": 1,
            "2026-05-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 435.9,
          "mode_time_hours": 85.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "42-44h": 1,
            "66-68h": 1,
            "84-86h": 1,
            "308-310h": 1,
            "1202-1204h": 1,
            "1326-1328h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-02-09": 2,
            "2026-02-10": 1,
            "2026-02-14": 1,
            "2026-03-24": 2
          },
          "time_per_day": {
            "2026-01-15": 84.47401194444446,
            "2026-02-09": 374.2746980555556,
            "2026-02-10": 17.96340027777778,
            "2026-02-14": 43.89619666666666,
            "2026-03-24": 2530.7189680555557
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-02-09": 2,
            "2026-02-10": 1,
            "2026-02-14": 1,
            "2026-03-24": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 650.36,
          "mode_time_hours": 651.0,
          "mode_frequency": 1,
          "time_distribution": {
            "650-652h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 650.3586863888889
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 242.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "4-6h": 1,
              "6-8h": 1,
              "16-18h": 1,
              "38-40h": 1,
              "42-44h": 2,
              "66-68h": 1,
              "84-86h": 1,
              "138-140h": 1,
              "288-290h": 1,
              "308-310h": 1,
              "336-338h": 1,
              "350-352h": 1,
              "650-652h": 1,
              "1152-1154h": 1,
              "1202-1204h": 1,
              "1326-1328h": 1
            },
            "tickets_count": 25,
            "tickets_per_day": {
              "2026-01-05": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-23": 2,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-24": 1,
              "2026-03-04": 1,
              "2026-03-09": 1,
              "2026-03-13": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-24": 3,
              "2026-03-26": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-01-05": 139.29470555555557,
              "2026-01-13": 6.96764,
              "2026-01-15": 84.47401194444446,
              "2026-01-23": 5.375035555555555,
              "2026-02-02": 1.0628133333333334,
              "2026-02-03": 351.55231694444444,
              "2026-02-09": 374.2746980555556,
              "2026-02-10": 17.96340027777778,
              "2026-02-14": 43.89619666666666,
              "2026-02-19": 0.3587702777777778,
              "2026-02-21": 38.19980555555555,
              "2026-02-24": 1.0121725,
              "2026-03-04": 42.50203916666666,
              "2026-03-09": 0.15751416666666668,
              "2026-03-13": 336.371035,
              "2026-03-16": 2.5490294444444443,
              "2026-03-17": 0.7799311111111111,
              "2026-03-24": 3682.911213055556,
              "2026-03-26": 650.3586863888889,
              "2026-05-06": 289.70557
            },
            "time_count_per_day": {
              "2026-01-05": 1,
              "2026-01-13": 1,
              "2026-01-15": 1,
              "2026-01-23": 2,
              "2026-02-02": 1,
              "2026-02-03": 1,
              "2026-02-09": 2,
              "2026-02-10": 1,
              "2026-02-14": 1,
              "2026-02-19": 1,
              "2026-02-21": 1,
              "2026-02-24": 1,
              "2026-03-04": 1,
              "2026-03-09": 1,
              "2026-03-13": 1,
              "2026-03-16": 2,
              "2026-03-17": 1,
              "2026-03-24": 3,
              "2026-03-26": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 351.55,
              "mode_time_hours": 351.0,
              "mode_frequency": 1,
              "time_distribution": {
                "350-352h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 351.55231694444444
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "P2": {
              "avg_time_hours": 126.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8,
                "4-6h": 1,
                "6-8h": 1,
                "38-40h": 1,
                "42-44h": 1,
                "138-140h": 1,
                "288-290h": 1,
                "336-338h": 1,
                "1152-1154h": 1
              },
              "tickets_count": 16,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-01-13": 1,
                "2026-01-23": 2,
                "2026-02-02": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-24": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-01-05": 139.29470555555557,
                "2026-01-13": 6.96764,
                "2026-01-23": 5.375035555555555,
                "2026-02-02": 1.0628133333333334,
                "2026-02-19": 0.3587702777777778,
                "2026-02-21": 38.19980555555555,
                "2026-02-24": 1.0121725,
                "2026-03-04": 42.50203916666666,
                "2026-03-09": 0.15751416666666668,
                "2026-03-13": 336.371035,
                "2026-03-16": 2.5490294444444443,
                "2026-03-17": 0.7799311111111111,
                "2026-03-24": 1152.192245,
                "2026-05-06": 289.70557
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-01-13": 1,
                "2026-01-23": 2,
                "2026-02-02": 1,
                "2026-02-19": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-03-04": 1,
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-16": 2,
                "2026-03-17": 1,
                "2026-03-24": 1,
                "2026-05-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 435.9,
              "mode_time_hours": 85.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "42-44h": 1,
                "66-68h": 1,
                "84-86h": 1,
                "308-310h": 1,
                "1202-1204h": 1,
                "1326-1328h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-02-09": 2,
                "2026-02-10": 1,
                "2026-02-14": 1,
                "2026-03-24": 2
              },
              "time_per_day": {
                "2026-01-15": 84.47401194444446,
                "2026-02-09": 374.2746980555556,
                "2026-02-10": 17.96340027777778,
                "2026-02-14": 43.89619666666666,
                "2026-03-24": 2530.7189680555557
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-02-09": 2,
                "2026-02-10": 1,
                "2026-02-14": 1,
                "2026-03-24": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 650.36,
              "mode_time_hours": 651.0,
              "mode_frequency": 1,
              "time_distribution": {
                "650-652h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 650.3586863888889
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_755": {
      "overall": {
        "avg_time_hours": 81.2,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 3,
          "10-12h": 1,
          "22-24h": 2,
          "42-44h": 1,
          "66-68h": 1,
          "74-76h": 1,
          "136-138h": 1,
          "194-196h": 1,
          "196-198h": 1,
          "258-260h": 1,
          "500-502h": 1
        },
        "tickets_count": 19,
        "tickets_per_day": {
          "2025-12-30": 1,
          "2026-01-02": 2,
          "2026-01-08": 1,
          "2026-01-13": 2,
          "2026-02-03": 2,
          "2026-02-10": 3,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-04-16": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2025-12-30": 1.014488611111111,
          "2026-01-02": 67.6762036111111,
          "2026-01-08": 0.3729152777777777,
          "2026-01-13": 46.94227444444445,
          "2026-02-03": 86.32275194444445,
          "2026-02-10": 651.9151047222222,
          "2026-02-19": 0.13990472222222222,
          "2026-02-20": 42.761991111111115,
          "2026-02-25": 0.28161166666666665,
          "2026-03-03": 3.7148397222222225,
          "2026-03-05": 2.076020277777778,
          "2026-03-10": 136.00597472222222,
          "2026-04-16": 501.0308769444444,
          "2026-05-26": 2.6120597222222224
        },
        "time_count_per_day": {
          "2025-12-30": 1,
          "2026-01-02": 2,
          "2026-01-08": 1,
          "2026-01-13": 2,
          "2026-02-03": 2,
          "2026-02-10": 3,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-25": 1,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-04-16": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 25.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 3,
            "22-24h": 1,
            "66-68h": 1,
            "74-76h": 1,
            "136-138h": 1
          },
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-12-30": 1,
            "2026-01-02": 2,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-02-25": 1,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2025-12-30": 1.014488611111111,
            "2026-01-02": 67.6762036111111,
            "2026-01-08": 0.3729152777777777,
            "2026-01-13": 23.39232972222222,
            "2026-02-03": 74.49177333333334,
            "2026-02-19": 0.13990472222222222,
            "2026-02-25": 0.28161166666666665,
            "2026-03-03": 3.7148397222222225,
            "2026-03-05": 2.076020277777778,
            "2026-03-10": 136.00597472222222,
            "2026-05-26": 2.6120597222222224
          },
          "time_count_per_day": {
            "2025-12-30": 1,
            "2026-01-02": 2,
            "2026-01-08": 1,
            "2026-01-13": 1,
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-02-25": 1,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-05-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 201.26,
          "mode_time_hours": 259.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1,
            "42-44h": 1,
            "194-196h": 1,
            "196-198h": 1,
            "258-260h": 1,
            "500-502h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-10": 3,
            "2026-02-20": 1,
            "2026-04-16": 1
          },
          "time_per_day": {
            "2026-02-03": 11.830978611111112,
            "2026-02-10": 651.9151047222222,
            "2026-02-20": 42.761991111111115,
            "2026-04-16": 501.0308769444444
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-10": 3,
            "2026-02-20": 1,
            "2026-04-16": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 23.55,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 23.549944722222225
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 81.2,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 3,
              "10-12h": 1,
              "22-24h": 2,
              "42-44h": 1,
              "66-68h": 1,
              "74-76h": 1,
              "136-138h": 1,
              "194-196h": 1,
              "196-198h": 1,
              "258-260h": 1,
              "500-502h": 1
            },
            "tickets_count": 19,
            "tickets_per_day": {
              "2025-12-30": 1,
              "2026-01-02": 2,
              "2026-01-08": 1,
              "2026-01-13": 2,
              "2026-02-03": 2,
              "2026-02-10": 3,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-04-16": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2025-12-30": 1.014488611111111,
              "2026-01-02": 67.6762036111111,
              "2026-01-08": 0.3729152777777777,
              "2026-01-13": 46.94227444444445,
              "2026-02-03": 86.32275194444445,
              "2026-02-10": 651.9151047222222,
              "2026-02-19": 0.13990472222222222,
              "2026-02-20": 42.761991111111115,
              "2026-02-25": 0.28161166666666665,
              "2026-03-03": 3.7148397222222225,
              "2026-03-05": 2.076020277777778,
              "2026-03-10": 136.00597472222222,
              "2026-04-16": 501.0308769444444,
              "2026-05-26": 2.6120597222222224
            },
            "time_count_per_day": {
              "2025-12-30": 1,
              "2026-01-02": 2,
              "2026-01-08": 1,
              "2026-01-13": 2,
              "2026-02-03": 2,
              "2026-02-10": 3,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-25": 1,
              "2026-03-03": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-04-16": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 25.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 3,
                "22-24h": 1,
                "66-68h": 1,
                "74-76h": 1,
                "136-138h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2025-12-30": 1,
                "2026-01-02": 2,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2025-12-30": 1.014488611111111,
                "2026-01-02": 67.6762036111111,
                "2026-01-08": 0.3729152777777777,
                "2026-01-13": 23.39232972222222,
                "2026-02-03": 74.49177333333334,
                "2026-02-19": 0.13990472222222222,
                "2026-02-25": 0.28161166666666665,
                "2026-03-03": 3.7148397222222225,
                "2026-03-05": 2.076020277777778,
                "2026-03-10": 136.00597472222222,
                "2026-05-26": 2.6120597222222224
              },
              "time_count_per_day": {
                "2025-12-30": 1,
                "2026-01-02": 2,
                "2026-01-08": 1,
                "2026-01-13": 1,
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-02-25": 1,
                "2026-03-03": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-05-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 201.26,
              "mode_time_hours": 259.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1,
                "42-44h": 1,
                "194-196h": 1,
                "196-198h": 1,
                "258-260h": 1,
                "500-502h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-10": 3,
                "2026-02-20": 1,
                "2026-04-16": 1
              },
              "time_per_day": {
                "2026-02-03": 11.830978611111112,
                "2026-02-10": 651.9151047222222,
                "2026-02-20": 42.761991111111115,
                "2026-04-16": 501.0308769444444
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-10": 3,
                "2026-02-20": 1,
                "2026-04-16": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 23.55,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 23.549944722222225
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_502": {
      "overall": {
        "avg_time_hours": 65.87,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "10-12h": 1,
          "12-14h": 1,
          "20-22h": 1,
          "36-38h": 2,
          "38-40h": 1,
          "62-64h": 2,
          "204-206h": 1,
          "432-434h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-12-31": 1,
          "2026-01-19": 1,
          "2026-01-27": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-03-23": 2,
          "2026-04-02": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-11": 1
        },
        "time_per_day": {
          "2025-12-31": 0.0756525,
          "2026-01-19": 36.024571111111115,
          "2026-01-27": 36.109495,
          "2026-01-30": 10.090999444444444,
          "2026-02-03": 205.65556055555555,
          "2026-02-18": 432.5954877777778,
          "2026-03-23": 126.00208777777777,
          "2026-04-02": 0.40940527777777774,
          "2026-04-13": 20.858953888888887,
          "2026-04-15": 13.652272777777778,
          "2026-05-06": 39.427688055555556,
          "2026-05-08": 0.3146475,
          "2026-05-11": 0.9017063888888889
        },
        "time_count_per_day": {
          "2025-12-31": 1,
          "2026-01-19": 1,
          "2026-01-27": 1,
          "2026-01-30": 1,
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-03-23": 2,
          "2026-04-02": 1,
          "2026-04-13": 1,
          "2026-04-15": 1,
          "2026-05-06": 1,
          "2026-05-08": 1,
          "2026-05-11": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 39.43,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-05-06": 39.427688055555556
          },
          "time_count_per_day": {
            "2026-05-06": 1
          }
        },
        "P2": {
          "avg_time_hours": 63.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "12-14h": 1,
            "20-22h": 1,
            "36-38h": 1,
            "62-64h": 2,
            "432-434h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-12-31": 1,
            "2026-01-19": 1,
            "2026-02-18": 1,
            "2026-03-23": 2,
            "2026-04-02": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-05-08": 1,
            "2026-05-11": 1
          },
          "time_per_day": {
            "2025-12-31": 0.0756525,
            "2026-01-19": 36.024571111111115,
            "2026-02-18": 432.5954877777778,
            "2026-03-23": 126.00208777777777,
            "2026-04-02": 0.40940527777777774,
            "2026-04-13": 20.858953888888887,
            "2026-04-15": 13.652272777777778,
            "2026-05-08": 0.3146475,
            "2026-05-11": 0.9017063888888889
          },
          "time_count_per_day": {
            "2025-12-31": 1,
            "2026-01-19": 1,
            "2026-02-18": 1,
            "2026-03-23": 2,
            "2026-04-02": 1,
            "2026-04-13": 1,
            "2026-04-15": 1,
            "2026-05-08": 1,
            "2026-05-11": 1
          }
        },
        "P3": {
          "avg_time_hours": 83.95,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1,
            "36-38h": 1,
            "204-206h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-01-27": 36.109495,
            "2026-01-30": 10.090999444444444,
            "2026-02-03": 205.65556055555555
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-01-30": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 65.87,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "10-12h": 1,
              "12-14h": 1,
              "20-22h": 1,
              "36-38h": 2,
              "38-40h": 1,
              "62-64h": 2,
              "204-206h": 1,
              "432-434h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2025-12-31": 1,
              "2026-01-19": 1,
              "2026-01-27": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-03-23": 2,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-11": 1
            },
            "time_per_day": {
              "2025-12-31": 0.0756525,
              "2026-01-19": 36.024571111111115,
              "2026-01-27": 36.109495,
              "2026-01-30": 10.090999444444444,
              "2026-02-03": 205.65556055555555,
              "2026-02-18": 432.5954877777778,
              "2026-03-23": 126.00208777777777,
              "2026-04-02": 0.40940527777777774,
              "2026-04-13": 20.858953888888887,
              "2026-04-15": 13.652272777777778,
              "2026-05-06": 39.427688055555556,
              "2026-05-08": 0.3146475,
              "2026-05-11": 0.9017063888888889
            },
            "time_count_per_day": {
              "2025-12-31": 1,
              "2026-01-19": 1,
              "2026-01-27": 1,
              "2026-01-30": 1,
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-03-23": 2,
              "2026-04-02": 1,
              "2026-04-13": 1,
              "2026-04-15": 1,
              "2026-05-06": 1,
              "2026-05-08": 1,
              "2026-05-11": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 39.43,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-05-06": 39.427688055555556
              },
              "time_count_per_day": {
                "2026-05-06": 1
              }
            },
            "P2": {
              "avg_time_hours": 63.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "12-14h": 1,
                "20-22h": 1,
                "36-38h": 1,
                "62-64h": 2,
                "432-434h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2025-12-31": 1,
                "2026-01-19": 1,
                "2026-02-18": 1,
                "2026-03-23": 2,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-05-08": 1,
                "2026-05-11": 1
              },
              "time_per_day": {
                "2025-12-31": 0.0756525,
                "2026-01-19": 36.024571111111115,
                "2026-02-18": 432.5954877777778,
                "2026-03-23": 126.00208777777777,
                "2026-04-02": 0.40940527777777774,
                "2026-04-13": 20.858953888888887,
                "2026-04-15": 13.652272777777778,
                "2026-05-08": 0.3146475,
                "2026-05-11": 0.9017063888888889
              },
              "time_count_per_day": {
                "2025-12-31": 1,
                "2026-01-19": 1,
                "2026-02-18": 1,
                "2026-03-23": 2,
                "2026-04-02": 1,
                "2026-04-13": 1,
                "2026-04-15": 1,
                "2026-05-08": 1,
                "2026-05-11": 1
              }
            },
            "P3": {
              "avg_time_hours": 83.95,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1,
                "36-38h": 1,
                "204-206h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-01-27": 36.109495,
                "2026-01-30": 10.090999444444444,
                "2026-02-03": 205.65556055555555
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-01-30": 1,
                "2026-02-03": 1
              }
            }
          }
        },
        "Pending Close": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_756": {
      "overall": {
        "avg_time_hours": 376.39,
        "mode_time_hours": 147.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "58-60h": 1,
          "146-148h": 1,
          "978-980h": 1,
          "1068-1070h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-02-19": 2,
          "2026-03-19": 1,
          "2026-04-16": 1
        },
        "time_per_day": {
          "2026-01-08": 146.71158,
          "2026-01-09": 59.95797861111111,
          "2026-01-12": 3.0978413888888885,
          "2026-02-19": 2048.569050277778,
          "2026-03-19": 0.01334138888888889
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-01-09": 1,
          "2026-01-12": 1,
          "2026-02-19": 2,
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.56,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-12": 1,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-01-12": 3.0978413888888885,
            "2026-03-19": 0.01334138888888889
          },
          "time_count_per_day": {
            "2026-01-12": 1,
            "2026-03-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 103.33,
          "mode_time_hours": 147.0,
          "mode_frequency": 1,
          "time_distribution": {
            "58-60h": 1,
            "146-148h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-09": 1,
            "2026-04-16": 1
          },
          "time_per_day": {
            "2026-01-08": 146.71158,
            "2026-01-09": 59.95797861111111
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-09": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1024.28,
          "mode_time_hours": 1069.0,
          "mode_frequency": 1,
          "time_distribution": {
            "978-980h": 1,
            "1068-1070h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 2048.569050277778
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 376.39,
            "mode_time_hours": 147.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "58-60h": 1,
              "146-148h": 1,
              "978-980h": 1,
              "1068-1070h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-02-19": 2,
              "2026-03-19": 1
            },
            "time_per_day": {
              "2026-01-08": 146.71158,
              "2026-01-09": 59.95797861111111,
              "2026-01-12": 3.0978413888888885,
              "2026-02-19": 2048.569050277778,
              "2026-03-19": 0.01334138888888889
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-01-09": 1,
              "2026-01-12": 1,
              "2026-02-19": 2,
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.56,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-12": 1,
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-01-12": 3.0978413888888885,
                "2026-03-19": 0.01334138888888889
              },
              "time_count_per_day": {
                "2026-01-12": 1,
                "2026-03-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 103.33,
              "mode_time_hours": 147.0,
              "mode_frequency": 1,
              "time_distribution": {
                "58-60h": 1,
                "146-148h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-09": 1
              },
              "time_per_day": {
                "2026-01-08": 146.71158,
                "2026-01-09": 59.95797861111111
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-09": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1024.28,
              "mode_time_hours": 1069.0,
              "mode_frequency": 1,
              "time_distribution": {
                "978-980h": 1,
                "1068-1070h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 2048.569050277778
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_208": {
      "overall": {
        "avg_time_hours": 288.63,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "22-24h": 1,
          "842-844h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-02": 1,
          "2026-04-22": 1,
          "2026-06-01": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-01-02": 0.812186111111111,
          "2026-04-22": 842.3390544444444,
          "2026-06-02": 22.733569166666665
        },
        "time_count_per_day": {
          "2026-01-02": 1,
          "2026-04-22": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 288.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1,
            "842-844h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-02": 1,
            "2026-04-22": 1,
            "2026-06-01": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-01-02": 0.812186111111111,
            "2026-04-22": 842.3390544444444,
            "2026-06-02": 22.733569166666665
          },
          "time_count_per_day": {
            "2026-01-02": 1,
            "2026-04-22": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 288.63,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "22-24h": 1,
              "842-844h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-02": 1,
              "2026-04-22": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-01-02": 0.812186111111111,
              "2026-04-22": 842.3390544444444,
              "2026-06-02": 22.733569166666665
            },
            "time_count_per_day": {
              "2026-01-02": 1,
              "2026-04-22": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 288.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1,
                "842-844h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-02": 1,
                "2026-04-22": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-01-02": 0.812186111111111,
                "2026-04-22": 842.3390544444444,
                "2026-06-02": 22.733569166666665
              },
              "time_count_per_day": {
                "2026-01-02": 1,
                "2026-04-22": 1,
                "2026-06-02": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_758": {
      "overall": {
        "avg_time_hours": 95.24,
        "mode_time_hours": 95.0,
        "mode_frequency": 1,
        "time_distribution": {
          "94-96h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-06": 1
        },
        "time_per_day": {
          "2026-01-06": 95.23980472222223
        },
        "time_count_per_day": {
          "2026-01-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 95.24,
          "mode_time_hours": 95.0,
          "mode_frequency": 1,
          "time_distribution": {
            "94-96h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-06": 1
          },
          "time_per_day": {
            "2026-01-06": 95.23980472222223
          },
          "time_count_per_day": {
            "2026-01-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 95.24,
            "mode_time_hours": 95.0,
            "mode_frequency": 1,
            "time_distribution": {
              "94-96h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-06": 1
            },
            "time_per_day": {
              "2026-01-06": 95.23980472222223
            },
            "time_count_per_day": {
              "2026-01-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 95.24,
              "mode_time_hours": 95.0,
              "mode_frequency": 1,
              "time_distribution": {
                "94-96h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-06": 1
              },
              "time_per_day": {
                "2026-01-06": 95.23980472222223
              },
              "time_count_per_day": {
                "2026-01-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_759": {
      "overall": {
        "avg_time_hours": 66.54,
        "mode_time_hours": 67.0,
        "mode_frequency": 1,
        "time_distribution": {
          "66-68h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-05": 1
        },
        "time_per_day": {
          "2026-01-05": 66.53986638888888
        },
        "time_count_per_day": {
          "2026-01-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 66.54,
          "mode_time_hours": 67.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-05": 1
          },
          "time_per_day": {
            "2026-01-05": 66.53986638888888
          },
          "time_count_per_day": {
            "2026-01-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 66.54,
            "mode_time_hours": 67.0,
            "mode_frequency": 1,
            "time_distribution": {
              "66-68h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-05": 1
            },
            "time_per_day": {
              "2026-01-05": 66.53986638888888
            },
            "time_count_per_day": {
              "2026-01-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 66.54,
              "mode_time_hours": 67.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-05": 1
              },
              "time_per_day": {
                "2026-01-05": 66.53986638888888
              },
              "time_count_per_day": {
                "2026-01-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_760": {
      "overall": {
        "avg_time_hours": 1106.83,
        "mode_time_hours": 1107.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1106-1108h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 1106.8318991666665
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1106.83,
          "mode_time_hours": 1107.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1106-1108h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 1106.8318991666665
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1106.83,
            "mode_time_hours": 1107.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1106-1108h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 1106.8318991666665
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1106.83,
              "mode_time_hours": 1107.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1106-1108h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 1106.8318991666665
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_761": {
      "overall": {
        "avg_time_hours": 124.06,
        "mode_time_hours": 125.0,
        "mode_frequency": 1,
        "time_distribution": {
          "124-126h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-03": 1,
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 124.05700083333333
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 124.06,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-03": 1,
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 124.05700083333333
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 124.06,
            "mode_time_hours": 125.0,
            "mode_frequency": 1,
            "time_distribution": {
              "124-126h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 124.05700083333333
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 124.06,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 124.05700083333333
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_762": {
      "overall": {
        "avg_time_hours": 120.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 8,
          "8-10h": 1,
          "10-12h": 1,
          "24-26h": 1,
          "50-52h": 4,
          "88-90h": 1,
          "104-106h": 1,
          "122-124h": 1,
          "140-142h": 1,
          "292-294h": 1,
          "382-384h": 1,
          "384-386h": 1,
          "982-984h": 1
        },
        "tickets_count": 25,
        "tickets_per_day": {
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-06": 3,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-14": 1,
          "2026-03-18": 1,
          "2026-04-06": 1,
          "2026-04-22": 3,
          "2026-04-24": 1,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-23": 2,
          "2026-05-25": 2
        },
        "time_per_day": {
          "2026-01-06": 1.986611111111111,
          "2026-01-08": 123.00637472222223,
          "2026-01-31": 89.30900916666667,
          "2026-02-03": 141.8506475,
          "2026-02-06": 873.8303652777779,
          "2026-02-10": 292.80768027777776,
          "2026-02-19": 983.2683783333333,
          "2026-02-23": 8.055662777777778,
          "2026-02-28": 51.3650325,
          "2026-03-14": 24.957686111111112,
          "2026-03-18": 11.275028333333333,
          "2026-04-06": 0.23515944444444442,
          "2026-04-22": 155.08143055555556,
          "2026-05-02": 0.4018886111111111,
          "2026-05-05": 0.5379838888888889,
          "2026-05-08": 0.5340883333333334,
          "2026-05-23": 1.6319097222222223,
          "2026-05-25": 1.4917063888888888
        },
        "time_count_per_day": {
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-31": 1,
          "2026-02-03": 1,
          "2026-02-06": 3,
          "2026-02-10": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-14": 1,
          "2026-03-18": 1,
          "2026-04-06": 1,
          "2026-04-22": 3,
          "2026-05-02": 1,
          "2026-05-05": 1,
          "2026-05-08": 1,
          "2026-05-23": 2,
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 8
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-01-06": 1,
            "2026-04-06": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-23": 2,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-01-06": 1.986611111111111,
            "2026-04-06": 0.23515944444444442,
            "2026-05-02": 0.4018886111111111,
            "2026-05-05": 0.5379838888888889,
            "2026-05-08": 0.5340883333333334,
            "2026-05-23": 1.6319097222222223,
            "2026-05-25": 1.4917063888888888
          },
          "time_count_per_day": {
            "2026-01-06": 1,
            "2026-04-06": 1,
            "2026-05-02": 1,
            "2026-05-05": 1,
            "2026-05-08": 1,
            "2026-05-23": 2,
            "2026-05-25": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 126.54,
          "mode_time_hours": 51.0,
          "mode_frequency": 4,
          "time_distribution": {
            "8-10h": 1,
            "10-12h": 1,
            "24-26h": 1,
            "50-52h": 4,
            "88-90h": 1,
            "104-106h": 1,
            "122-124h": 1,
            "140-142h": 1,
            "292-294h": 1,
            "382-384h": 1,
            "384-386h": 1
          },
          "tickets_count": 16,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-14": 1,
            "2026-03-18": 1,
            "2026-04-22": 3,
            "2026-04-24": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-01-08": 123.00637472222223,
            "2026-01-31": 89.30900916666667,
            "2026-02-03": 141.8506475,
            "2026-02-06": 873.8303652777779,
            "2026-02-10": 292.80768027777776,
            "2026-02-23": 8.055662777777778,
            "2026-02-28": 51.3650325,
            "2026-03-14": 24.957686111111112,
            "2026-03-18": 11.275028333333333,
            "2026-04-22": 155.08143055555556
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-31": 1,
            "2026-02-03": 1,
            "2026-02-06": 3,
            "2026-02-10": 1,
            "2026-02-23": 1,
            "2026-02-28": 1,
            "2026-03-14": 1,
            "2026-03-18": 1,
            "2026-04-22": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 983.27,
          "mode_time_hours": 983.0,
          "mode_frequency": 1,
          "time_distribution": {
            "982-984h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 983.2683783333333
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 120.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 8,
              "8-10h": 1,
              "10-12h": 1,
              "24-26h": 1,
              "50-52h": 4,
              "88-90h": 1,
              "104-106h": 1,
              "122-124h": 1,
              "140-142h": 1,
              "292-294h": 1,
              "382-384h": 1,
              "384-386h": 1,
              "982-984h": 1
            },
            "tickets_count": 23,
            "tickets_per_day": {
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-06": 3,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-14": 1,
              "2026-03-18": 1,
              "2026-04-06": 1,
              "2026-04-22": 3,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-23": 2,
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-01-06": 1.986611111111111,
              "2026-01-08": 123.00637472222223,
              "2026-01-31": 89.30900916666667,
              "2026-02-03": 141.8506475,
              "2026-02-06": 873.8303652777779,
              "2026-02-10": 292.80768027777776,
              "2026-02-19": 983.2683783333333,
              "2026-02-23": 8.055662777777778,
              "2026-02-28": 51.3650325,
              "2026-03-14": 24.957686111111112,
              "2026-03-18": 11.275028333333333,
              "2026-04-06": 0.23515944444444442,
              "2026-04-22": 155.08143055555556,
              "2026-05-02": 0.4018886111111111,
              "2026-05-05": 0.5379838888888889,
              "2026-05-08": 0.5340883333333334,
              "2026-05-23": 1.6319097222222223,
              "2026-05-25": 1.4917063888888888
            },
            "time_count_per_day": {
              "2026-01-06": 1,
              "2026-01-08": 1,
              "2026-01-31": 1,
              "2026-02-03": 1,
              "2026-02-06": 3,
              "2026-02-10": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-14": 1,
              "2026-03-18": 1,
              "2026-04-06": 1,
              "2026-04-22": 3,
              "2026-05-02": 1,
              "2026-05-05": 1,
              "2026-05-08": 1,
              "2026-05-23": 2,
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 8
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-01-06": 1,
                "2026-04-06": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-23": 2,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-01-06": 1.986611111111111,
                "2026-04-06": 0.23515944444444442,
                "2026-05-02": 0.4018886111111111,
                "2026-05-05": 0.5379838888888889,
                "2026-05-08": 0.5340883333333334,
                "2026-05-23": 1.6319097222222223,
                "2026-05-25": 1.4917063888888888
              },
              "time_count_per_day": {
                "2026-01-06": 1,
                "2026-04-06": 1,
                "2026-05-02": 1,
                "2026-05-05": 1,
                "2026-05-08": 1,
                "2026-05-23": 2,
                "2026-05-25": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 126.54,
              "mode_time_hours": 51.0,
              "mode_frequency": 4,
              "time_distribution": {
                "8-10h": 1,
                "10-12h": 1,
                "24-26h": 1,
                "50-52h": 4,
                "88-90h": 1,
                "104-106h": 1,
                "122-124h": 1,
                "140-142h": 1,
                "292-294h": 1,
                "382-384h": 1,
                "384-386h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-14": 1,
                "2026-03-18": 1,
                "2026-04-22": 3
              },
              "time_per_day": {
                "2026-01-08": 123.00637472222223,
                "2026-01-31": 89.30900916666667,
                "2026-02-03": 141.8506475,
                "2026-02-06": 873.8303652777779,
                "2026-02-10": 292.80768027777776,
                "2026-02-23": 8.055662777777778,
                "2026-02-28": 51.3650325,
                "2026-03-14": 24.957686111111112,
                "2026-03-18": 11.275028333333333,
                "2026-04-22": 155.08143055555556
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-31": 1,
                "2026-02-03": 1,
                "2026-02-06": 3,
                "2026-02-10": 1,
                "2026-02-23": 1,
                "2026-02-28": 1,
                "2026-03-14": 1,
                "2026-03-18": 1,
                "2026-04-22": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 983.27,
              "mode_time_hours": 983.0,
              "mode_frequency": 1,
              "time_distribution": {
                "982-984h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 983.2683783333333
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_763": {
      "overall": {
        "avg_time_hours": 229.05,
        "mode_time_hours": 229.0,
        "mode_frequency": 1,
        "time_distribution": {
          "228-230h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 229.05319305555557
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 229.05,
          "mode_time_hours": 229.0,
          "mode_frequency": 1,
          "time_distribution": {
            "228-230h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 229.05319305555557
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 229.05,
            "mode_time_hours": 229.0,
            "mode_frequency": 1,
            "time_distribution": {
              "228-230h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 229.05319305555557
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 229.05,
              "mode_time_hours": 229.0,
              "mode_frequency": 1,
              "time_distribution": {
                "228-230h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 229.05319305555557
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_764": {
      "overall": {
        "avg_time_hours": 133.57,
        "mode_time_hours": 133.0,
        "mode_frequency": 1,
        "time_distribution": {
          "132-134h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-09": 1
        },
        "time_per_day": {
          "2026-01-09": 133.56837166666665
        },
        "time_count_per_day": {
          "2026-01-09": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 133.57,
          "mode_time_hours": 133.0,
          "mode_frequency": 1,
          "time_distribution": {
            "132-134h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-09": 1
          },
          "time_per_day": {
            "2026-01-09": 133.56837166666665
          },
          "time_count_per_day": {
            "2026-01-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 133.57,
            "mode_time_hours": 133.0,
            "mode_frequency": 1,
            "time_distribution": {
              "132-134h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-09": 1
            },
            "time_per_day": {
              "2026-01-09": 133.56837166666665
            },
            "time_count_per_day": {
              "2026-01-09": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 133.57,
              "mode_time_hours": 133.0,
              "mode_frequency": 1,
              "time_distribution": {
                "132-134h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-09": 1
              },
              "time_per_day": {
                "2026-01-09": 133.56837166666665
              },
              "time_count_per_day": {
                "2026-01-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_765": {
      "overall": {
        "avg_time_hours": 225.21,
        "mode_time_hours": 225.0,
        "mode_frequency": 1,
        "time_distribution": {
          "224-226h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 225.2138586111111
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 225.21,
          "mode_time_hours": 225.0,
          "mode_frequency": 1,
          "time_distribution": {
            "224-226h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 225.2138586111111
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 225.21,
            "mode_time_hours": 225.0,
            "mode_frequency": 1,
            "time_distribution": {
              "224-226h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 225.2138586111111
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 225.21,
              "mode_time_hours": 225.0,
              "mode_frequency": 1,
              "time_distribution": {
                "224-226h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 225.2138586111111
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_766": {
      "overall": {
        "avg_time_hours": 275.73,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "544-546h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-05": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-01-05": 7.276611944444444,
          "2026-05-06": 544.1810502777778
        },
        "time_count_per_day": {
          "2026-01-05": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 275.73,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "544-546h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-01-05": 7.276611944444444,
            "2026-05-06": 544.1810502777778
          },
          "time_count_per_day": {
            "2026-01-05": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 275.73,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "544-546h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-05": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-01-05": 7.276611944444444,
              "2026-05-06": 544.1810502777778
            },
            "time_count_per_day": {
              "2026-01-05": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 275.73,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "544-546h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-05": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-01-05": 7.276611944444444,
                "2026-05-06": 544.1810502777778
              },
              "time_count_per_day": {
                "2026-01-05": 1,
                "2026-05-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_769": {
      "overall": {
        "avg_time_hours": 1078.35,
        "mode_time_hours": 1079.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1078-1080h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 1078.34743
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1078.35,
          "mode_time_hours": 1079.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1078-1080h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 1078.34743
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1078.35,
            "mode_time_hours": 1079.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1078-1080h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 1078.34743
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1078.35,
              "mode_time_hours": 1079.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1078-1080h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 1078.34743
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_770": {
      "overall": {
        "avg_time_hours": 46.05,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "46-48h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-07": 1
        },
        "time_per_day": {
          "2026-01-07": 46.05047027777778
        },
        "time_count_per_day": {
          "2026-01-07": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 46.05,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 46.05047027777778
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 46.05,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "46-48h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-07": 1
            },
            "time_per_day": {
              "2026-01-07": 46.05047027777778
            },
            "time_count_per_day": {
              "2026-01-07": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 46.05,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 46.05047027777778
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_729": {
      "overall": {
        "avg_time_hours": 19.49,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-06": 1
        },
        "time_per_day": {
          "2026-01-06": 19.490401944444443
        },
        "time_count_per_day": {
          "2026-01-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 19.49,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-06": 1
          },
          "time_per_day": {
            "2026-01-06": 19.490401944444443
          },
          "time_count_per_day": {
            "2026-01-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.49,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-06": 1
            },
            "time_per_day": {
              "2026-01-06": 19.490401944444443
            },
            "time_count_per_day": {
              "2026-01-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 19.49,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-06": 1
              },
              "time_per_day": {
                "2026-01-06": 19.490401944444443
              },
              "time_count_per_day": {
                "2026-01-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_771": {
      "overall": {
        "avg_time_hours": 26.95,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-07": 1
        },
        "time_per_day": {
          "2026-01-07": 26.94852333333333
        },
        "time_count_per_day": {
          "2026-01-07": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 26.95,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-07": 1
          },
          "time_per_day": {
            "2026-01-07": 26.94852333333333
          },
          "time_count_per_day": {
            "2026-01-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.95,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-07": 1
            },
            "time_per_day": {
              "2026-01-07": 26.94852333333333
            },
            "time_count_per_day": {
              "2026-01-07": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 26.95,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-07": 1
              },
              "time_per_day": {
                "2026-01-07": 26.94852333333333
              },
              "time_count_per_day": {
                "2026-01-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_772": {
      "overall": {
        "avg_time_hours": 40.89,
        "mode_time_hours": 53.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "52-54h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-01-08": 52.43694277777778,
          "2026-02-10": 29.345399166666667
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 29.35,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 29.345399166666667
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 52.44,
          "mode_time_hours": 53.0,
          "mode_frequency": 1,
          "time_distribution": {
            "52-54h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 52.43694277777778
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 40.89,
            "mode_time_hours": 53.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "52-54h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-01-08": 52.43694277777778,
              "2026-02-10": 29.345399166666667
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 29.35,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 29.345399166666667
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 52.44,
              "mode_time_hours": 53.0,
              "mode_frequency": 1,
              "time_distribution": {
                "52-54h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 52.43694277777778
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_773": {
      "overall": {
        "avg_time_hours": 50.44,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "50-52h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 50.442341666666664
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 50.44,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 50.442341666666664
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 50.44,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "50-52h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 50.442341666666664
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 50.44,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 50.442341666666664
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_776": {
      "overall": {
        "avg_time_hours": 292.21,
        "mode_time_hours": 293.0,
        "mode_frequency": 1,
        "time_distribution": {
          "292-294h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-19": 1
        },
        "time_per_day": {
          "2026-01-19": 292.21096027777776
        },
        "time_count_per_day": {
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 292.21,
          "mode_time_hours": 293.0,
          "mode_frequency": 1,
          "time_distribution": {
            "292-294h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 292.21096027777776
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 292.21,
            "mode_time_hours": 293.0,
            "mode_frequency": 1,
            "time_distribution": {
              "292-294h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-19": 292.21096027777776
            },
            "time_count_per_day": {
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 292.21,
              "mode_time_hours": 293.0,
              "mode_frequency": 1,
              "time_distribution": {
                "292-294h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 292.21096027777776
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_777": {
      "overall": {
        "avg_time_hours": 55.94,
        "mode_time_hours": 25.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 4,
          "4-6h": 1,
          "8-10h": 1,
          "12-14h": 3,
          "14-16h": 3,
          "16-18h": 1,
          "18-20h": 1,
          "20-22h": 1,
          "22-24h": 2,
          "24-26h": 4,
          "34-36h": 1,
          "42-44h": 1,
          "44-46h": 2,
          "58-60h": 1,
          "60-62h": 1,
          "62-64h": 2,
          "66-68h": 2,
          "74-76h": 1,
          "92-94h": 1,
          "104-106h": 1,
          "108-110h": 1,
          "122-124h": 1,
          "146-148h": 1,
          "254-256h": 1,
          "638-640h": 1
        },
        "tickets_count": 46,
        "tickets_per_day": {
          "2026-01-12": 2,
          "2026-01-13": 2,
          "2026-01-15": 3,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-20": 1,
          "2026-01-22": 2,
          "2026-01-23": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 3,
          "2026-02-03": 5,
          "2026-02-05": 2,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-03-13": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-14": 1,
          "2026-04-15": 1,
          "2026-05-02": 1,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-29": 2,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-01-12": 189.57621833333332,
          "2026-01-13": 38.52310416666667,
          "2026-01-15": 95.92449055555556,
          "2026-01-17": 22.16396027777778,
          "2026-01-19": 97.47971694444445,
          "2026-01-20": 24.20427027777778,
          "2026-01-22": 190.61411916666668,
          "2026-01-23": 62.078762222222224,
          "2026-01-26": 74.69651833333334,
          "2026-01-27": 58.48847,
          "2026-01-28": 110.35715083333334,
          "2026-02-03": 73.74872444444443,
          "2026-02-05": 125.69493861111111,
          "2026-02-10": 92.07390722222222,
          "2026-02-12": 254.310315,
          "2026-02-14": 12.825370833333332,
          "2026-03-02": 0.8192425,
          "2026-03-05": 2.6889405555555554,
          "2026-03-10": 2.252702222222222,
          "2026-03-13": 23.049165277777778,
          "2026-03-24": 638.4945047222222,
          "2026-03-25": 0.2868811111111111,
          "2026-04-15": 108.030115,
          "2026-05-02": 66.96540388888889,
          "2026-05-13": 0.11275111111111111,
          "2026-05-26": 20.93199638888889,
          "2026-05-29": 18.137118333333333,
          "2026-06-03": 0.9371958333333333
        },
        "time_count_per_day": {
          "2026-01-12": 2,
          "2026-01-13": 2,
          "2026-01-15": 3,
          "2026-01-17": 1,
          "2026-01-19": 2,
          "2026-01-20": 1,
          "2026-01-22": 2,
          "2026-01-23": 2,
          "2026-01-26": 1,
          "2026-01-27": 1,
          "2026-01-28": 3,
          "2026-02-03": 5,
          "2026-02-05": 2,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-10": 1,
          "2026-03-13": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-04-15": 1,
          "2026-05-02": 1,
          "2026-05-13": 1,
          "2026-05-26": 1,
          "2026-05-29": 2,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 638.49,
          "mode_time_hours": 639.0,
          "mode_frequency": 1,
          "time_distribution": {
            "638-640h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 638.4945047222222
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        },
        "P2": {
          "avg_time_hours": 40.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 3,
            "4-6h": 1,
            "12-14h": 2,
            "20-22h": 1,
            "22-24h": 1,
            "24-26h": 1,
            "34-36h": 1,
            "66-68h": 2,
            "108-110h": 1,
            "122-124h": 1,
            "254-256h": 1
          },
          "tickets_count": 22,
          "tickets_per_day": {
            "2026-01-12": 2,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-28": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-03-13": 1,
            "2026-03-25": 1,
            "2026-04-14": 1,
            "2026-04-15": 1,
            "2026-05-02": 1,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-21": 1,
            "2026-05-26": 1,
            "2026-05-29": 2,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-01-12": 189.57621833333332,
            "2026-01-19": 35.803801388888886,
            "2026-01-20": 24.20427027777778,
            "2026-01-28": 2.4602252777777776,
            "2026-02-12": 254.310315,
            "2026-02-14": 12.825370833333332,
            "2026-03-02": 0.8192425,
            "2026-03-05": 2.6889405555555554,
            "2026-03-10": 2.252702222222222,
            "2026-03-13": 23.049165277777778,
            "2026-03-25": 0.2868811111111111,
            "2026-04-15": 108.030115,
            "2026-05-02": 66.96540388888889,
            "2026-05-13": 0.11275111111111111,
            "2026-05-26": 20.93199638888889,
            "2026-05-29": 18.137118333333333,
            "2026-06-03": 0.9371958333333333
          },
          "time_count_per_day": {
            "2026-01-12": 2,
            "2026-01-19": 1,
            "2026-01-20": 1,
            "2026-01-28": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-10": 1,
            "2026-03-13": 1,
            "2026-03-25": 1,
            "2026-04-15": 1,
            "2026-05-02": 1,
            "2026-05-13": 1,
            "2026-05-26": 1,
            "2026-05-29": 2,
            "2026-06-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 43.63,
          "mode_time_hours": 25.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 1,
            "8-10h": 1,
            "12-14h": 1,
            "14-16h": 3,
            "16-18h": 1,
            "18-20h": 1,
            "22-24h": 1,
            "24-26h": 3,
            "42-44h": 1,
            "44-46h": 2,
            "58-60h": 1,
            "60-62h": 1,
            "62-64h": 2,
            "74-76h": 1,
            "92-94h": 1,
            "104-106h": 1,
            "146-148h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2026-01-13": 2,
            "2026-01-15": 3,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-02-03": 5,
            "2026-02-05": 2,
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-01-13": 38.52310416666667,
            "2026-01-15": 95.92449055555556,
            "2026-01-17": 22.16396027777778,
            "2026-01-19": 61.675915555555555,
            "2026-01-22": 190.61411916666668,
            "2026-01-23": 62.078762222222224,
            "2026-01-26": 74.69651833333334,
            "2026-01-27": 58.48847,
            "2026-01-28": 107.89692555555555,
            "2026-02-03": 73.74872444444443,
            "2026-02-05": 125.69493861111111,
            "2026-02-10": 92.07390722222222
          },
          "time_count_per_day": {
            "2026-01-13": 2,
            "2026-01-15": 3,
            "2026-01-17": 1,
            "2026-01-19": 1,
            "2026-01-22": 2,
            "2026-01-23": 2,
            "2026-01-26": 1,
            "2026-01-27": 1,
            "2026-01-28": 2,
            "2026-02-03": 5,
            "2026-02-05": 2,
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 55.94,
            "mode_time_hours": 25.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 4,
              "4-6h": 1,
              "8-10h": 1,
              "12-14h": 3,
              "14-16h": 3,
              "16-18h": 1,
              "18-20h": 1,
              "20-22h": 1,
              "22-24h": 2,
              "24-26h": 4,
              "34-36h": 1,
              "42-44h": 1,
              "44-46h": 2,
              "58-60h": 1,
              "60-62h": 1,
              "62-64h": 2,
              "66-68h": 2,
              "74-76h": 1,
              "92-94h": 1,
              "104-106h": 1,
              "108-110h": 1,
              "122-124h": 1,
              "146-148h": 1,
              "254-256h": 1,
              "638-640h": 1
            },
            "tickets_count": 43,
            "tickets_per_day": {
              "2026-01-12": 2,
              "2026-01-13": 2,
              "2026-01-15": 3,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-20": 1,
              "2026-01-22": 2,
              "2026-01-23": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 3,
              "2026-02-03": 5,
              "2026-02-05": 2,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-03-13": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-15": 1,
              "2026-05-02": 1,
              "2026-05-13": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-01-12": 189.57621833333332,
              "2026-01-13": 38.52310416666667,
              "2026-01-15": 95.92449055555556,
              "2026-01-17": 22.16396027777778,
              "2026-01-19": 97.47971694444445,
              "2026-01-20": 24.20427027777778,
              "2026-01-22": 190.61411916666668,
              "2026-01-23": 62.078762222222224,
              "2026-01-26": 74.69651833333334,
              "2026-01-27": 58.48847,
              "2026-01-28": 110.35715083333334,
              "2026-02-03": 73.74872444444443,
              "2026-02-05": 125.69493861111111,
              "2026-02-10": 92.07390722222222,
              "2026-02-12": 254.310315,
              "2026-02-14": 12.825370833333332,
              "2026-03-02": 0.8192425,
              "2026-03-05": 2.6889405555555554,
              "2026-03-10": 2.252702222222222,
              "2026-03-13": 23.049165277777778,
              "2026-03-24": 638.4945047222222,
              "2026-03-25": 0.2868811111111111,
              "2026-04-15": 108.030115,
              "2026-05-02": 66.96540388888889,
              "2026-05-13": 0.11275111111111111,
              "2026-05-26": 20.93199638888889,
              "2026-05-29": 18.137118333333333,
              "2026-06-03": 0.9371958333333333
            },
            "time_count_per_day": {
              "2026-01-12": 2,
              "2026-01-13": 2,
              "2026-01-15": 3,
              "2026-01-17": 1,
              "2026-01-19": 2,
              "2026-01-20": 1,
              "2026-01-22": 2,
              "2026-01-23": 2,
              "2026-01-26": 1,
              "2026-01-27": 1,
              "2026-01-28": 3,
              "2026-02-03": 5,
              "2026-02-05": 2,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-14": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-10": 1,
              "2026-03-13": 1,
              "2026-03-24": 1,
              "2026-03-25": 1,
              "2026-04-15": 1,
              "2026-05-02": 1,
              "2026-05-13": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 638.49,
              "mode_time_hours": 639.0,
              "mode_frequency": 1,
              "time_distribution": {
                "638-640h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 638.4945047222222
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            },
            "P2": {
              "avg_time_hours": 40.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 3,
                "4-6h": 1,
                "12-14h": 2,
                "20-22h": 1,
                "22-24h": 1,
                "24-26h": 1,
                "34-36h": 1,
                "66-68h": 2,
                "108-110h": 1,
                "122-124h": 1,
                "254-256h": 1
              },
              "tickets_count": 19,
              "tickets_per_day": {
                "2026-01-12": 2,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-28": 1,
                "2026-02-12": 1,
                "2026-02-14": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-03-13": 1,
                "2026-03-25": 1,
                "2026-04-15": 1,
                "2026-05-02": 1,
                "2026-05-13": 1,
                "2026-05-26": 1,
                "2026-05-29": 2,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-01-12": 189.57621833333332,
                "2026-01-19": 35.803801388888886,
                "2026-01-20": 24.20427027777778,
                "2026-01-28": 2.4602252777777776,
                "2026-02-12": 254.310315,
                "2026-02-14": 12.825370833333332,
                "2026-03-02": 0.8192425,
                "2026-03-05": 2.6889405555555554,
                "2026-03-10": 2.252702222222222,
                "2026-03-13": 23.049165277777778,
                "2026-03-25": 0.2868811111111111,
                "2026-04-15": 108.030115,
                "2026-05-02": 66.96540388888889,
                "2026-05-13": 0.11275111111111111,
                "2026-05-26": 20.93199638888889,
                "2026-05-29": 18.137118333333333,
                "2026-06-03": 0.9371958333333333
              },
              "time_count_per_day": {
                "2026-01-12": 2,
                "2026-01-19": 1,
                "2026-01-20": 1,
                "2026-01-28": 1,
                "2026-02-12": 1,
                "2026-02-14": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-10": 1,
                "2026-03-13": 1,
                "2026-03-25": 1,
                "2026-04-15": 1,
                "2026-05-02": 1,
                "2026-05-13": 1,
                "2026-05-26": 1,
                "2026-05-29": 2,
                "2026-06-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 43.63,
              "mode_time_hours": 25.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 1,
                "8-10h": 1,
                "12-14h": 1,
                "14-16h": 3,
                "16-18h": 1,
                "18-20h": 1,
                "22-24h": 1,
                "24-26h": 3,
                "42-44h": 1,
                "44-46h": 2,
                "58-60h": 1,
                "60-62h": 1,
                "62-64h": 2,
                "74-76h": 1,
                "92-94h": 1,
                "104-106h": 1,
                "146-148h": 1
              },
              "tickets_count": 23,
              "tickets_per_day": {
                "2026-01-13": 2,
                "2026-01-15": 3,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-02-03": 5,
                "2026-02-05": 2,
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-01-13": 38.52310416666667,
                "2026-01-15": 95.92449055555556,
                "2026-01-17": 22.16396027777778,
                "2026-01-19": 61.675915555555555,
                "2026-01-22": 190.61411916666668,
                "2026-01-23": 62.078762222222224,
                "2026-01-26": 74.69651833333334,
                "2026-01-27": 58.48847,
                "2026-01-28": 107.89692555555555,
                "2026-02-03": 73.74872444444443,
                "2026-02-05": 125.69493861111111,
                "2026-02-10": 92.07390722222222
              },
              "time_count_per_day": {
                "2026-01-13": 2,
                "2026-01-15": 3,
                "2026-01-17": 1,
                "2026-01-19": 1,
                "2026-01-22": 2,
                "2026-01-23": 2,
                "2026-01-26": 1,
                "2026-01-27": 1,
                "2026-01-28": 2,
                "2026-02-03": 5,
                "2026-02-05": 2,
                "2026-02-10": 1
              }
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-12": 1,
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-12": 1,
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_255": {
      "overall": {
        "avg_time_hours": 190.24,
        "mode_time_hours": 191.0,
        "mode_frequency": 1,
        "time_distribution": {
          "190-192h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 190.2385688888889
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 190.24,
          "mode_time_hours": 191.0,
          "mode_frequency": 1,
          "time_distribution": {
            "190-192h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 190.2385688888889
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 190.24,
            "mode_time_hours": 191.0,
            "mode_frequency": 1,
            "time_distribution": {
              "190-192h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 190.2385688888889
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 190.24,
              "mode_time_hours": 191.0,
              "mode_frequency": 1,
              "time_distribution": {
                "190-192h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 190.2385688888889
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_560": {
      "overall": {
        "avg_time_hours": 586.33,
        "mode_time_hours": 865.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "10-12h": 1,
          "50-52h": 1,
          "340-342h": 1,
          "508-510h": 1,
          "628-630h": 1,
          "664-666h": 1,
          "864-866h": 1,
          "908-910h": 1,
          "1176-1178h": 1,
          "1872-1874h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2025-11-24": 1,
          "2026-02-12": 1,
          "2026-02-16": 1,
          "2026-02-19": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-04-02": 1,
          "2026-04-09": 1,
          "2026-04-23": 1,
          "2026-05-18": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-02-12": 865.0432163888888,
          "2026-02-16": 629.4451736111112,
          "2026-02-19": 11.723582777777779,
          "2026-03-12": 508.08069388888885,
          "2026-03-18": 664.2777511111111,
          "2026-03-20": 1177.6360602777777,
          "2026-03-23": 51.62835166666667,
          "2026-03-26": 0.15836833333333333,
          "2026-04-02": 909.1969366666667,
          "2026-04-09": 340.0071394444445,
          "2026-04-23": 1872.7430225,
          "2026-05-18": 5.987306666666667
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-02-16": 1,
          "2026-02-19": 1,
          "2026-03-12": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-23": 1,
          "2026-03-26": 1,
          "2026-04-02": 1,
          "2026-04-09": 1,
          "2026-04-23": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 429.94,
          "mode_time_hours": 865.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "10-12h": 1,
            "50-52h": 1,
            "340-342h": 1,
            "508-510h": 1,
            "864-866h": 1,
            "908-910h": 1,
            "1176-1178h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-02-19": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-26": 1,
            "2026-04-02": 1,
            "2026-04-09": 1,
            "2026-05-18": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-12": 865.0432163888888,
            "2026-02-19": 11.723582777777779,
            "2026-03-12": 508.08069388888885,
            "2026-03-20": 1177.6360602777777,
            "2026-03-23": 51.62835166666667,
            "2026-03-26": 0.15836833333333333,
            "2026-04-02": 909.1969366666667,
            "2026-04-09": 340.0071394444445,
            "2026-05-18": 5.987306666666667
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-02-19": 1,
            "2026-03-12": 1,
            "2026-03-20": 1,
            "2026-03-23": 1,
            "2026-03-26": 1,
            "2026-04-02": 1,
            "2026-04-09": 1,
            "2026-05-18": 1
          }
        },
        "P3": {
          "avg_time_hours": 1251.09,
          "mode_time_hours": 629.0,
          "mode_frequency": 1,
          "time_distribution": {
            "628-630h": 1,
            "1872-1874h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-11-24": 1,
            "2026-02-16": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-02-16": 629.4451736111112,
            "2026-04-23": 1872.7430225
          },
          "time_count_per_day": {
            "2026-02-16": 1,
            "2026-04-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 664.28,
          "mode_time_hours": 665.0,
          "mode_frequency": 1,
          "time_distribution": {
            "664-666h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 664.2777511111111
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 586.33,
            "mode_time_hours": 865.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "10-12h": 1,
              "50-52h": 1,
              "340-342h": 1,
              "508-510h": 1,
              "628-630h": 1,
              "664-666h": 1,
              "864-866h": 1,
              "908-910h": 1,
              "1176-1178h": 1,
              "1872-1874h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-02-16": 1,
              "2026-02-19": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-02": 1,
              "2026-04-09": 1,
              "2026-04-23": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-02-12": 865.0432163888888,
              "2026-02-16": 629.4451736111112,
              "2026-02-19": 11.723582777777779,
              "2026-03-12": 508.08069388888885,
              "2026-03-18": 664.2777511111111,
              "2026-03-20": 1177.6360602777777,
              "2026-03-23": 51.62835166666667,
              "2026-03-26": 0.15836833333333333,
              "2026-04-02": 909.1969366666667,
              "2026-04-09": 340.0071394444445,
              "2026-04-23": 1872.7430225,
              "2026-05-18": 5.987306666666667
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-02-16": 1,
              "2026-02-19": 1,
              "2026-03-12": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-03-23": 1,
              "2026-03-26": 1,
              "2026-04-02": 1,
              "2026-04-09": 1,
              "2026-04-23": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 429.94,
              "mode_time_hours": 865.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "10-12h": 1,
                "50-52h": 1,
                "340-342h": 1,
                "508-510h": 1,
                "864-866h": 1,
                "908-910h": 1,
                "1176-1178h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-19": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-02-12": 865.0432163888888,
                "2026-02-19": 11.723582777777779,
                "2026-03-12": 508.08069388888885,
                "2026-03-20": 1177.6360602777777,
                "2026-03-23": 51.62835166666667,
                "2026-03-26": 0.15836833333333333,
                "2026-04-02": 909.1969366666667,
                "2026-04-09": 340.0071394444445,
                "2026-05-18": 5.987306666666667
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-02-19": 1,
                "2026-03-12": 1,
                "2026-03-20": 1,
                "2026-03-23": 1,
                "2026-03-26": 1,
                "2026-04-02": 1,
                "2026-04-09": 1,
                "2026-05-18": 1
              }
            },
            "P3": {
              "avg_time_hours": 1251.09,
              "mode_time_hours": 629.0,
              "mode_frequency": 1,
              "time_distribution": {
                "628-630h": 1,
                "1872-1874h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-16": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-02-16": 629.4451736111112,
                "2026-04-23": 1872.7430225
              },
              "time_count_per_day": {
                "2026-02-16": 1,
                "2026-04-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 664.28,
              "mode_time_hours": 665.0,
              "mode_frequency": 1,
              "time_distribution": {
                "664-666h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 664.2777511111111
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_779": {
      "overall": {
        "avg_time_hours": 5.98,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "10-12h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-08": 11.599839444444443,
          "2026-01-15": 0.3509541666666667
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-01-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.98,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "10-12h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-08": 11.599839444444443,
            "2026-01-15": 0.3509541666666667
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.98,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "10-12h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-08": 11.599839444444443,
              "2026-01-15": 0.3509541666666667
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-01-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.98,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "10-12h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-08": 11.599839444444443,
                "2026-01-15": 0.3509541666666667
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_780": {
      "overall": {
        "avg_time_hours": 0.32,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-08": 2
        },
        "time_per_day": {
          "2026-01-08": 0.6436108333333332
        },
        "time_count_per_day": {
          "2026-01-08": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 2
          },
          "time_per_day": {
            "2026-01-08": 0.6436108333333332
          },
          "time_count_per_day": {
            "2026-01-08": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.32,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-08": 2
            },
            "time_per_day": {
              "2026-01-08": 0.6436108333333332
            },
            "time_count_per_day": {
              "2026-01-08": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 2
              },
              "time_per_day": {
                "2026-01-08": 0.6436108333333332
              },
              "time_count_per_day": {
                "2026-01-08": 2
              }
            }
          }
        }
      }
    },
    "cliente_781": {
      "overall": {
        "avg_time_hours": 240.55,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "6-8h": 1,
          "10-12h": 1,
          "22-24h": 1,
          "126-128h": 1,
          "128-130h": 1,
          "272-274h": 1,
          "332-334h": 1,
          "698-700h": 1,
          "1282-1284h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-01-13": 2,
          "2026-01-15": 3,
          "2026-02-20": 1,
          "2026-03-09": 1,
          "2026-03-27": 1,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-01-08": 0.35780611111111116,
          "2026-01-13": 18.064900555555557,
          "2026-01-15": 278.1665527777778,
          "2026-02-20": 0.33287055555555556,
          "2026-03-09": 1282.5919080555555,
          "2026-03-27": 699.1513583333334,
          "2026-04-17": 273.98625305555555,
          "2026-04-21": 0.22381138888888888,
          "2026-05-05": 333.7327927777778
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-01-13": 2,
          "2026-01-15": 3,
          "2026-02-20": 1,
          "2026-03-09": 1,
          "2026-03-27": 1,
          "2026-04-17": 1,
          "2026-04-21": 1,
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 217.96,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "272-274h": 1,
            "332-334h": 1,
            "698-700h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-02-20": 1,
            "2026-03-27": 1,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-01-08": 0.35780611111111116,
            "2026-02-20": 0.33287055555555556,
            "2026-03-27": 699.1513583333334,
            "2026-04-17": 273.98625305555555,
            "2026-04-21": 0.22381138888888888,
            "2026-05-05": 333.7327927777778
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-02-20": 1,
            "2026-03-27": 1,
            "2026-04-17": 1,
            "2026-04-21": 1,
            "2026-05-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 263.14,
          "mode_time_hours": 129.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "10-12h": 1,
            "22-24h": 1,
            "126-128h": 1,
            "128-130h": 1,
            "1282-1284h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-13": 2,
            "2026-01-15": 3,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-01-13": 18.064900555555557,
            "2026-01-15": 278.1665527777778,
            "2026-03-09": 1282.5919080555555
          },
          "time_count_per_day": {
            "2026-01-13": 2,
            "2026-01-15": 3,
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 240.55,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "6-8h": 1,
              "10-12h": 1,
              "22-24h": 1,
              "126-128h": 1,
              "128-130h": 1,
              "272-274h": 1,
              "332-334h": 1,
              "698-700h": 1,
              "1282-1284h": 1
            },
            "tickets_count": 12,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-01-13": 2,
              "2026-01-15": 3,
              "2026-02-20": 1,
              "2026-03-09": 1,
              "2026-03-27": 1,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-01-08": 0.35780611111111116,
              "2026-01-13": 18.064900555555557,
              "2026-01-15": 278.1665527777778,
              "2026-02-20": 0.33287055555555556,
              "2026-03-09": 1282.5919080555555,
              "2026-03-27": 699.1513583333334,
              "2026-04-17": 273.98625305555555,
              "2026-04-21": 0.22381138888888888,
              "2026-05-05": 333.7327927777778
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-01-13": 2,
              "2026-01-15": 3,
              "2026-02-20": 1,
              "2026-03-09": 1,
              "2026-03-27": 1,
              "2026-04-17": 1,
              "2026-04-21": 1,
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 217.96,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "272-274h": 1,
                "332-334h": 1,
                "698-700h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-02-20": 1,
                "2026-03-27": 1,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-01-08": 0.35780611111111116,
                "2026-02-20": 0.33287055555555556,
                "2026-03-27": 699.1513583333334,
                "2026-04-17": 273.98625305555555,
                "2026-04-21": 0.22381138888888888,
                "2026-05-05": 333.7327927777778
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-02-20": 1,
                "2026-03-27": 1,
                "2026-04-17": 1,
                "2026-04-21": 1,
                "2026-05-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 263.14,
              "mode_time_hours": 129.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "10-12h": 1,
                "22-24h": 1,
                "126-128h": 1,
                "128-130h": 1,
                "1282-1284h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-13": 2,
                "2026-01-15": 3,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-01-13": 18.064900555555557,
                "2026-01-15": 278.1665527777778,
                "2026-03-09": 1282.5919080555555
              },
              "time_count_per_day": {
                "2026-01-13": 2,
                "2026-01-15": 3,
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_782": {
      "overall": {
        "avg_time_hours": 41.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "34-36h": 1,
          "124-126h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-02-07": 1,
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-01-08": 0.29031583333333333,
          "2026-01-13": 124.70538722222221,
          "2026-02-07": 35.50543555555556,
          "2026-02-09": 3.557796388888889
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-01-13": 1,
          "2026-02-07": 1,
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.92,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-01-08": 0.29031583333333333,
            "2026-02-09": 3.557796388888889
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-02-09": 1
          }
        },
        "P3": {
          "avg_time_hours": 80.11,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "34-36h": 1,
            "124-126h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-13": 1,
            "2026-02-07": 1
          },
          "time_per_day": {
            "2026-01-13": 124.70538722222221,
            "2026-02-07": 35.50543555555556
          },
          "time_count_per_day": {
            "2026-01-13": 1,
            "2026-02-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 41.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "34-36h": 1,
              "124-126h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-02-07": 1,
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-01-08": 0.29031583333333333,
              "2026-01-13": 124.70538722222221,
              "2026-02-07": 35.50543555555556,
              "2026-02-09": 3.557796388888889
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-01-13": 1,
              "2026-02-07": 1,
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.92,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-01-08": 0.29031583333333333,
                "2026-02-09": 3.557796388888889
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-02-09": 1
              }
            },
            "P3": {
              "avg_time_hours": 80.11,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "34-36h": 1,
                "124-126h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-13": 1,
                "2026-02-07": 1
              },
              "time_per_day": {
                "2026-01-13": 124.70538722222221,
                "2026-02-07": 35.50543555555556
              },
              "time_count_per_day": {
                "2026-01-13": 1,
                "2026-02-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_783": {
      "overall": {
        "avg_time_hours": 90.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "270-272h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-03-20": 1,
          "2026-03-30": 1
        },
        "time_per_day": {
          "2026-01-08": 0.24156305555555554,
          "2026-03-20": 270.3859630555555,
          "2026-03-30": 0.9425652777777778
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-03-20": 1,
          "2026-03-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.59,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-03-30": 1
          },
          "time_per_day": {
            "2026-01-08": 0.24156305555555554,
            "2026-03-30": 0.9425652777777778
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-03-30": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 270.39,
          "mode_time_hours": 271.0,
          "mode_frequency": 1,
          "time_distribution": {
            "270-272h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 270.3859630555555
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 90.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "270-272h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-03-20": 1,
              "2026-03-30": 1
            },
            "time_per_day": {
              "2026-01-08": 0.24156305555555554,
              "2026-03-20": 270.3859630555555,
              "2026-03-30": 0.9425652777777778
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-03-20": 1,
              "2026-03-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.59,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-01-08": 0.24156305555555554,
                "2026-03-30": 0.9425652777777778
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-03-30": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 270.39,
              "mode_time_hours": 271.0,
              "mode_frequency": 1,
              "time_distribution": {
                "270-272h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 270.3859630555555
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_784": {
      "overall": {
        "avg_time_hours": 149.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "298-300h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-01-08": 0.19448083333333333,
          "2026-02-03": 298.6915994444444
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 149.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "298-300h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-01-08": 0.19448083333333333,
            "2026-02-03": 298.6915994444444
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 149.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "298-300h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-01-08": 0.19448083333333333,
              "2026-02-03": 298.6915994444444
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 149.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "298-300h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-01-08": 0.19448083333333333,
                "2026-02-03": 298.6915994444444
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_785": {
      "overall": {
        "avg_time_hours": 0.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 0.13138722222222224
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 0.13138722222222224
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 0.13138722222222224
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 0.13138722222222224
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_786": {
      "overall": {
        "avg_time_hours": 605.72,
        "mode_time_hours": 671.0,
        "mode_frequency": 2,
        "time_distribution": {
          "70-72h": 1,
          "670-672h": 2,
          "1008-1010h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-24": 1,
          "2026-02-19": 3
        },
        "time_per_day": {
          "2026-01-24": 71.68713166666667,
          "2026-02-19": 2351.1822444444447
        },
        "time_count_per_day": {
          "2026-01-24": 1,
          "2026-02-19": 3
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 71.69,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-24": 1
          },
          "time_per_day": {
            "2026-01-24": 71.68713166666667
          },
          "time_count_per_day": {
            "2026-01-24": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 783.73,
          "mode_time_hours": 671.0,
          "mode_frequency": 2,
          "time_distribution": {
            "670-672h": 2,
            "1008-1010h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {
            "2026-02-19": 2351.1822444444447
          },
          "time_count_per_day": {
            "2026-02-19": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 605.72,
            "mode_time_hours": 671.0,
            "mode_frequency": 2,
            "time_distribution": {
              "70-72h": 1,
              "670-672h": 2,
              "1008-1010h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-24": 1,
              "2026-02-19": 3
            },
            "time_per_day": {
              "2026-01-24": 71.68713166666667,
              "2026-02-19": 2351.1822444444447
            },
            "time_count_per_day": {
              "2026-01-24": 1,
              "2026-02-19": 3
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 71.69,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-24": 1
              },
              "time_per_day": {
                "2026-01-24": 71.68713166666667
              },
              "time_count_per_day": {
                "2026-01-24": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 783.73,
              "mode_time_hours": 671.0,
              "mode_frequency": 2,
              "time_distribution": {
                "670-672h": 2,
                "1008-1010h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 3
              },
              "time_per_day": {
                "2026-02-19": 2351.1822444444447
              },
              "time_count_per_day": {
                "2026-02-19": 3
              }
            }
          }
        }
      }
    },
    "cliente_787": {
      "overall": {
        "avg_time_hours": 6.53,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 6.527722777777778
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 6.53,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 6.527722777777778
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.53,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 6.527722777777778
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 6.53,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 6.527722777777778
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_788": {
      "overall": {
        "avg_time_hours": 4.86,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 4.859203611111112
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 4.86,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 4.859203611111112
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.86,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 4.859203611111112
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 4.86,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 4.859203611111112
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_789": {
      "overall": {
        "avg_time_hours": 1003.66,
        "mode_time_hours": 1003.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1002-1004h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 1003.6637722222223
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 1003.66,
          "mode_time_hours": 1003.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1002-1004h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 1003.6637722222223
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1003.66,
            "mode_time_hours": 1003.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1002-1004h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 1003.6637722222223
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 1003.66,
              "mode_time_hours": 1003.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1002-1004h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 1003.6637722222223
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_790": {
      "overall": {
        "avg_time_hours": 4.69,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-08": 1
        },
        "time_per_day": {
          "2026-01-08": 4.6946861111111104
        },
        "time_count_per_day": {
          "2026-01-08": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 4.69,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-08": 1
          },
          "time_per_day": {
            "2026-01-08": 4.6946861111111104
          },
          "time_count_per_day": {
            "2026-01-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.69,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-08": 1
            },
            "time_per_day": {
              "2026-01-08": 4.6946861111111104
            },
            "time_count_per_day": {
              "2026-01-08": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 4.69,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-08": 1
              },
              "time_per_day": {
                "2026-01-08": 4.6946861111111104
              },
              "time_count_per_day": {
                "2026-01-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_791": {
      "overall": {
        "avg_time_hours": 0.95,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-08": 1,
          "2026-01-22": 1,
          "2026-01-29": 1
        },
        "time_per_day": {
          "2026-01-08": 1.0090580555555555,
          "2026-01-22": 1.5296452777777778,
          "2026-01-29": 0.300085
        },
        "time_count_per_day": {
          "2026-01-08": 1,
          "2026-01-22": 1,
          "2026-01-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.95,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-08": 1,
            "2026-01-22": 1,
            "2026-01-29": 1
          },
          "time_per_day": {
            "2026-01-08": 1.0090580555555555,
            "2026-01-22": 1.5296452777777778,
            "2026-01-29": 0.300085
          },
          "time_count_per_day": {
            "2026-01-08": 1,
            "2026-01-22": 1,
            "2026-01-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.95,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-08": 1,
              "2026-01-22": 1,
              "2026-01-29": 1
            },
            "time_per_day": {
              "2026-01-08": 1.0090580555555555,
              "2026-01-22": 1.5296452777777778,
              "2026-01-29": 0.300085
            },
            "time_count_per_day": {
              "2026-01-08": 1,
              "2026-01-22": 1,
              "2026-01-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.95,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-08": 1,
                "2026-01-22": 1,
                "2026-01-29": 1
              },
              "time_per_day": {
                "2026-01-08": 1.0090580555555555,
                "2026-01-22": 1.5296452777777778,
                "2026-01-29": 0.300085
              },
              "time_count_per_day": {
                "2026-01-08": 1,
                "2026-01-22": 1,
                "2026-01-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_793": {
      "overall": {
        "avg_time_hours": 614.02,
        "mode_time_hours": 615.0,
        "mode_frequency": 1,
        "time_distribution": {
          "614-616h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 614.0193805555556
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 614.02,
          "mode_time_hours": 615.0,
          "mode_frequency": 1,
          "time_distribution": {
            "614-616h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 614.0193805555556
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 614.02,
            "mode_time_hours": 615.0,
            "mode_frequency": 1,
            "time_distribution": {
              "614-616h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 614.0193805555556
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 614.02,
              "mode_time_hours": 615.0,
              "mode_frequency": 1,
              "time_distribution": {
                "614-616h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 614.0193805555556
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_794": {
      "overall": {
        "avg_time_hours": 730.55,
        "mode_time_hours": 1441.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1,
          "1440-1442h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-14": 1,
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-01-14": 20.612310555555556,
          "2026-03-09": 1440.485908611111
        },
        "time_count_per_day": {
          "2026-01-14": 1,
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 730.55,
          "mode_time_hours": 1441.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "1440-1442h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-01-14": 20.612310555555556,
            "2026-03-09": 1440.485908611111
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 730.55,
            "mode_time_hours": 1441.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1,
              "1440-1442h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-14": 1,
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-01-14": 20.612310555555556,
              "2026-03-09": 1440.485908611111
            },
            "time_count_per_day": {
              "2026-01-14": 1,
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 730.55,
              "mode_time_hours": 1441.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "1440-1442h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-01-14": 20.612310555555556,
                "2026-03-09": 1440.485908611111
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_795": {
      "overall": {
        "avg_time_hours": 134.39,
        "mode_time_hours": 119.0,
        "mode_frequency": 3,
        "time_distribution": {
          "118-120h": 3,
          "180-182h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-01-13": 3,
          "2026-02-19": 1,
          "2026-05-02": 1
        },
        "time_per_day": {
          "2026-01-13": 357.5490252777778,
          "2026-02-19": 180.01538027777775
        },
        "time_count_per_day": {
          "2026-01-13": 3,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 119.18,
          "mode_time_hours": 119.0,
          "mode_frequency": 3,
          "time_distribution": {
            "118-120h": 3
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-13": 3,
            "2026-05-02": 1
          },
          "time_per_day": {
            "2026-01-13": 357.5490252777778
          },
          "time_count_per_day": {
            "2026-01-13": 3
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 180.02,
          "mode_time_hours": 181.0,
          "mode_frequency": 1,
          "time_distribution": {
            "180-182h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 180.01538027777775
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 134.39,
            "mode_time_hours": 119.0,
            "mode_frequency": 3,
            "time_distribution": {
              "118-120h": 3,
              "180-182h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-13": 3,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-01-13": 357.5490252777778,
              "2026-02-19": 180.01538027777775
            },
            "time_count_per_day": {
              "2026-01-13": 3,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 119.18,
              "mode_time_hours": 119.0,
              "mode_frequency": 3,
              "time_distribution": {
                "118-120h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-13": 3
              },
              "time_per_day": {
                "2026-01-13": 357.5490252777778
              },
              "time_count_per_day": {
                "2026-01-13": 3
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 180.02,
              "mode_time_hours": 181.0,
              "mode_frequency": 1,
              "time_distribution": {
                "180-182h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 180.01538027777775
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_796": {
      "overall": {
        "avg_time_hours": 8.99,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-09": 1
        },
        "time_per_day": {
          "2026-01-09": 8.985233611111111
        },
        "time_count_per_day": {
          "2026-01-09": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 8.99,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-09": 1
          },
          "time_per_day": {
            "2026-01-09": 8.985233611111111
          },
          "time_count_per_day": {
            "2026-01-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.99,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-09": 1
            },
            "time_per_day": {
              "2026-01-09": 8.985233611111111
            },
            "time_count_per_day": {
              "2026-01-09": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 8.99,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-09": 1
              },
              "time_per_day": {
                "2026-01-09": 8.985233611111111
              },
              "time_count_per_day": {
                "2026-01-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_797": {
      "overall": {
        "avg_time_hours": 454.23,
        "mode_time_hours": 197.0,
        "mode_frequency": 1,
        "time_distribution": {
          "186-188h": 1,
          "196-198h": 1,
          "978-980h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-17": 1,
          "2026-01-31": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-01-17": 197.19290416666666,
          "2026-01-31": 186.4654727777778,
          "2026-02-19": 979.0277608333332
        },
        "time_count_per_day": {
          "2026-01-17": 1,
          "2026-01-31": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 186.47,
          "mode_time_hours": 187.0,
          "mode_frequency": 1,
          "time_distribution": {
            "186-188h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-31": 1
          },
          "time_per_day": {
            "2026-01-31": 186.4654727777778
          },
          "time_count_per_day": {
            "2026-01-31": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 588.11,
          "mode_time_hours": 197.0,
          "mode_frequency": 1,
          "time_distribution": {
            "196-198h": 1,
            "978-980h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-17": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-01-17": 197.19290416666666,
            "2026-02-19": 979.0277608333332
          },
          "time_count_per_day": {
            "2026-01-17": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 454.23,
            "mode_time_hours": 197.0,
            "mode_frequency": 1,
            "time_distribution": {
              "186-188h": 1,
              "196-198h": 1,
              "978-980h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-17": 1,
              "2026-01-31": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-01-17": 197.19290416666666,
              "2026-01-31": 186.4654727777778,
              "2026-02-19": 979.0277608333332
            },
            "time_count_per_day": {
              "2026-01-17": 1,
              "2026-01-31": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 186.47,
              "mode_time_hours": 187.0,
              "mode_frequency": 1,
              "time_distribution": {
                "186-188h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-31": 1
              },
              "time_per_day": {
                "2026-01-31": 186.4654727777778
              },
              "time_count_per_day": {
                "2026-01-31": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 588.11,
              "mode_time_hours": 197.0,
              "mode_frequency": 1,
              "time_distribution": {
                "196-198h": 1,
                "978-980h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-01-17": 197.19290416666666,
                "2026-02-19": 979.0277608333332
              },
              "time_count_per_day": {
                "2026-01-17": 1,
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_799": {
      "overall": {
        "avg_time_hours": 977.21,
        "mode_time_hours": 977.0,
        "mode_frequency": 1,
        "time_distribution": {
          "976-978h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 977.2091430555556
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 977.21,
          "mode_time_hours": 977.0,
          "mode_frequency": 1,
          "time_distribution": {
            "976-978h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 977.2091430555556
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 977.21,
            "mode_time_hours": 977.0,
            "mode_frequency": 1,
            "time_distribution": {
              "976-978h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 977.2091430555556
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 977.21,
              "mode_time_hours": 977.0,
              "mode_frequency": 1,
              "time_distribution": {
                "976-978h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 977.2091430555556
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_800": {
      "overall": {
        "avg_time_hours": 159.72,
        "mode_time_hours": 159.0,
        "mode_frequency": 1,
        "time_distribution": {
          "158-160h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-16": 1
        },
        "time_per_day": {
          "2026-01-16": 159.71738916666666
        },
        "time_count_per_day": {
          "2026-01-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 159.72,
          "mode_time_hours": 159.0,
          "mode_frequency": 1,
          "time_distribution": {
            "158-160h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 159.71738916666666
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 159.72,
            "mode_time_hours": 159.0,
            "mode_frequency": 1,
            "time_distribution": {
              "158-160h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-16": 1
            },
            "time_per_day": {
              "2026-01-16": 159.71738916666666
            },
            "time_count_per_day": {
              "2026-01-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 159.72,
              "mode_time_hours": 159.0,
              "mode_frequency": 1,
              "time_distribution": {
                "158-160h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 159.71738916666666
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_801": {
      "overall": {
        "avg_time_hours": 171.69,
        "mode_time_hours": 171.0,
        "mode_frequency": 1,
        "time_distribution": {
          "170-172h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-17": 1
        },
        "time_per_day": {
          "2026-01-17": 171.69447194444444
        },
        "time_count_per_day": {
          "2026-01-17": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 171.69,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "170-172h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-17": 1
          },
          "time_per_day": {
            "2026-01-17": 171.69447194444444
          },
          "time_count_per_day": {
            "2026-01-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 171.69,
            "mode_time_hours": 171.0,
            "mode_frequency": 1,
            "time_distribution": {
              "170-172h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-17": 1
            },
            "time_per_day": {
              "2026-01-17": 171.69447194444444
            },
            "time_count_per_day": {
              "2026-01-17": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 171.69,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "170-172h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-17": 1
              },
              "time_per_day": {
                "2026-01-17": 171.69447194444444
              },
              "time_count_per_day": {
                "2026-01-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_802": {
      "overall": {
        "avg_time_hours": 76.39,
        "mode_time_hours": 77.0,
        "mode_frequency": 1,
        "time_distribution": {
          "76-78h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 76.38723138888889
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 76.39,
          "mode_time_hours": 77.0,
          "mode_frequency": 1,
          "time_distribution": {
            "76-78h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 76.38723138888889
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 76.39,
            "mode_time_hours": 77.0,
            "mode_frequency": 1,
            "time_distribution": {
              "76-78h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 76.38723138888889
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 76.39,
              "mode_time_hours": 77.0,
              "mode_frequency": 1,
              "time_distribution": {
                "76-78h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 76.38723138888889
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_805": {
      "overall": {
        "avg_time_hours": 145.8,
        "mode_time_hours": 269.0,
        "mode_frequency": 1,
        "time_distribution": {
          "22-24h": 1,
          "268-270h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-15": 1,
          "2026-01-23": 1
        },
        "time_per_day": {
          "2026-01-15": 23.36654638888889,
          "2026-01-23": 268.2354961111111
        },
        "time_count_per_day": {
          "2026-01-15": 1,
          "2026-01-23": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 268.24,
          "mode_time_hours": 269.0,
          "mode_frequency": 1,
          "time_distribution": {
            "268-270h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-23": 1
          },
          "time_per_day": {
            "2026-01-23": 268.2354961111111
          },
          "time_count_per_day": {
            "2026-01-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 23.37,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 23.36654638888889
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 145.8,
            "mode_time_hours": 269.0,
            "mode_frequency": 1,
            "time_distribution": {
              "22-24h": 1,
              "268-270h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-15": 1,
              "2026-01-23": 1
            },
            "time_per_day": {
              "2026-01-15": 23.36654638888889,
              "2026-01-23": 268.2354961111111
            },
            "time_count_per_day": {
              "2026-01-15": 1,
              "2026-01-23": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 268.24,
              "mode_time_hours": 269.0,
              "mode_frequency": 1,
              "time_distribution": {
                "268-270h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-23": 1
              },
              "time_per_day": {
                "2026-01-23": 268.2354961111111
              },
              "time_count_per_day": {
                "2026-01-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 23.37,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 23.36654638888889
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_806": {
      "overall": {
        "avg_time_hours": 290.36,
        "mode_time_hours": 101.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "24-26h": 1,
          "100-102h": 1,
          "1322-1324h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-01-16": 1,
          "2026-04-27": 1,
          "2026-05-11": 1,
          "2026-05-15": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-01-16": 100.82705305555555,
          "2026-04-27": 1323.3189405555554,
          "2026-05-11": 2.334001388888889,
          "2026-05-15": 25.25245277777778,
          "2026-05-18": 0.07036611111111112
        },
        "time_count_per_day": {
          "2026-01-16": 1,
          "2026-04-27": 1,
          "2026-05-11": 1,
          "2026-05-15": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 290.36,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "24-26h": 1,
            "100-102h": 1,
            "1322-1324h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-01-16": 1,
            "2026-04-27": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-01-16": 100.82705305555555,
            "2026-04-27": 1323.3189405555554,
            "2026-05-11": 2.334001388888889,
            "2026-05-15": 25.25245277777778,
            "2026-05-18": 0.07036611111111112
          },
          "time_count_per_day": {
            "2026-01-16": 1,
            "2026-04-27": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 290.36,
            "mode_time_hours": 101.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "24-26h": 1,
              "100-102h": 1,
              "1322-1324h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-16": 1,
              "2026-04-27": 1,
              "2026-05-11": 1,
              "2026-05-15": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-01-16": 100.82705305555555,
              "2026-04-27": 1323.3189405555554,
              "2026-05-11": 2.334001388888889,
              "2026-05-15": 25.25245277777778,
              "2026-05-18": 0.07036611111111112
            },
            "time_count_per_day": {
              "2026-01-16": 1,
              "2026-04-27": 1,
              "2026-05-11": 1,
              "2026-05-15": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 290.36,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "24-26h": 1,
                "100-102h": 1,
                "1322-1324h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-04-27": 1,
                "2026-05-11": 1,
                "2026-05-15": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-01-16": 100.82705305555555,
                "2026-04-27": 1323.3189405555554,
                "2026-05-11": 2.334001388888889,
                "2026-05-15": 25.25245277777778,
                "2026-05-18": 0.07036611111111112
              },
              "time_count_per_day": {
                "2026-01-16": 1,
                "2026-04-27": 1,
                "2026-05-11": 1,
                "2026-05-15": 1,
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_522": {
      "overall": {
        "avg_time_hours": 219.95,
        "mode_time_hours": 73.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "4-6h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "72-74h": 2,
          "170-172h": 1,
          "176-178h": 1,
          "228-230h": 1,
          "300-302h": 1,
          "332-334h": 1,
          "478-480h": 2,
          "938-940h": 1
        },
        "tickets_count": 18,
        "tickets_per_day": {
          "2026-01-15": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-04": 1,
          "2026-03-05": 2,
          "2026-03-11": 1,
          "2026-03-20": 1,
          "2026-05-05": 1,
          "2026-05-21": 1,
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-01-15": 73.67967777777778,
          "2026-01-21": 17.725338333333333,
          "2026-01-22": 73.00579111111111,
          "2026-01-23": 176.91004972222223,
          "2026-02-03": 301.51515333333333,
          "2026-02-06": 4.928118055555555,
          "2026-02-09": 229.6309986111111,
          "2026-02-17": 1.3278127777777777,
          "2026-02-18": 333.16456277777775,
          "2026-02-19": 18.316586111111114,
          "2026-03-04": 1.073311111111111,
          "2026-03-05": 957.6597944444445,
          "2026-03-11": 170.6354725,
          "2026-03-20": 939.6810241666666
        },
        "time_count_per_day": {
          "2026-01-15": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-02-03": 1,
          "2026-02-06": 1,
          "2026-02-09": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-19": 1,
          "2026-03-04": 1,
          "2026-03-05": 2,
          "2026-03-11": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 227.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 1,
            "16-18h": 1,
            "72-74h": 1,
            "170-172h": 1,
            "176-178h": 1,
            "228-230h": 1,
            "300-302h": 1,
            "332-334h": 1,
            "478-480h": 1,
            "938-940h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-20": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-01-21": 17.725338333333333,
            "2026-01-22": 73.00579111111111,
            "2026-01-23": 176.91004972222223,
            "2026-02-03": 301.51515333333333,
            "2026-02-06": 4.928118055555555,
            "2026-02-09": 229.6309986111111,
            "2026-02-17": 1.3278127777777777,
            "2026-02-18": 333.16456277777775,
            "2026-03-04": 1.073311111111111,
            "2026-03-05": 478.53611666666666,
            "2026-03-11": 170.6354725,
            "2026-03-20": 939.6810241666666
          },
          "time_count_per_day": {
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-23": 1,
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-02-09": 1,
            "2026-02-17": 1,
            "2026-02-18": 1,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-11": 1,
            "2026-03-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 190.37,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "72-74h": 1,
            "478-480h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-02-19": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-01-15": 73.67967777777778,
            "2026-02-19": 18.316586111111114,
            "2026-03-05": 479.1236777777778
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-02-19": 1,
            "2026-03-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 219.95,
            "mode_time_hours": 73.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "4-6h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "72-74h": 2,
              "170-172h": 1,
              "176-178h": 1,
              "228-230h": 1,
              "300-302h": 1,
              "332-334h": 1,
              "478-480h": 2,
              "938-940h": 1
            },
            "tickets_count": 15,
            "tickets_per_day": {
              "2026-01-15": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-04": 1,
              "2026-03-05": 2,
              "2026-03-11": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-01-15": 73.67967777777778,
              "2026-01-21": 17.725338333333333,
              "2026-01-22": 73.00579111111111,
              "2026-01-23": 176.91004972222223,
              "2026-02-03": 301.51515333333333,
              "2026-02-06": 4.928118055555555,
              "2026-02-09": 229.6309986111111,
              "2026-02-17": 1.3278127777777777,
              "2026-02-18": 333.16456277777775,
              "2026-02-19": 18.316586111111114,
              "2026-03-04": 1.073311111111111,
              "2026-03-05": 957.6597944444445,
              "2026-03-11": 170.6354725,
              "2026-03-20": 939.6810241666666
            },
            "time_count_per_day": {
              "2026-01-15": 1,
              "2026-01-21": 1,
              "2026-01-22": 1,
              "2026-01-23": 1,
              "2026-02-03": 1,
              "2026-02-06": 1,
              "2026-02-09": 1,
              "2026-02-17": 1,
              "2026-02-18": 1,
              "2026-02-19": 1,
              "2026-03-04": 1,
              "2026-03-05": 2,
              "2026-03-11": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 227.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 1,
                "16-18h": 1,
                "72-74h": 1,
                "170-172h": 1,
                "176-178h": 1,
                "228-230h": 1,
                "300-302h": 1,
                "332-334h": 1,
                "478-480h": 1,
                "938-940h": 1
              },
              "tickets_count": 12,
              "tickets_per_day": {
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-01-21": 17.725338333333333,
                "2026-01-22": 73.00579111111111,
                "2026-01-23": 176.91004972222223,
                "2026-02-03": 301.51515333333333,
                "2026-02-06": 4.928118055555555,
                "2026-02-09": 229.6309986111111,
                "2026-02-17": 1.3278127777777777,
                "2026-02-18": 333.16456277777775,
                "2026-03-04": 1.073311111111111,
                "2026-03-05": 478.53611666666666,
                "2026-03-11": 170.6354725,
                "2026-03-20": 939.6810241666666
              },
              "time_count_per_day": {
                "2026-01-21": 1,
                "2026-01-22": 1,
                "2026-01-23": 1,
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-02-09": 1,
                "2026-02-17": 1,
                "2026-02-18": 1,
                "2026-03-04": 1,
                "2026-03-05": 1,
                "2026-03-11": 1,
                "2026-03-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 190.37,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "72-74h": 1,
                "478-480h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-02-19": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-01-15": 73.67967777777778,
                "2026-02-19": 18.316586111111114,
                "2026-03-05": 479.1236777777778
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-02-19": 1,
                "2026-03-05": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_808": {
      "overall": {
        "avg_time_hours": 39.56,
        "mode_time_hours": 39.0,
        "mode_frequency": 1,
        "time_distribution": {
          "38-40h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-14": 1
        },
        "time_per_day": {
          "2026-01-14": 39.56310444444445
        },
        "time_count_per_day": {
          "2026-01-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 39.56,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 39.56310444444445
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 39.56,
            "mode_time_hours": 39.0,
            "mode_frequency": 1,
            "time_distribution": {
              "38-40h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-14": 1
            },
            "time_per_day": {
              "2026-01-14": 39.56310444444445
            },
            "time_count_per_day": {
              "2026-01-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 39.56,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 39.56310444444445
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_809": {
      "overall": {
        "avg_time_hours": 115.73,
        "mode_time_hours": 115.0,
        "mode_frequency": 1,
        "time_distribution": {
          "114-116h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-17": 1
        },
        "time_per_day": {
          "2026-01-17": 115.72944111111111
        },
        "time_count_per_day": {
          "2026-01-17": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 115.73,
          "mode_time_hours": 115.0,
          "mode_frequency": 1,
          "time_distribution": {
            "114-116h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-17": 1
          },
          "time_per_day": {
            "2026-01-17": 115.72944111111111
          },
          "time_count_per_day": {
            "2026-01-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 115.73,
            "mode_time_hours": 115.0,
            "mode_frequency": 1,
            "time_distribution": {
              "114-116h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-17": 1
            },
            "time_per_day": {
              "2026-01-17": 115.72944111111111
            },
            "time_count_per_day": {
              "2026-01-17": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 115.73,
              "mode_time_hours": 115.0,
              "mode_frequency": 1,
              "time_distribution": {
                "114-116h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-17": 1
              },
              "time_per_day": {
                "2026-01-17": 115.72944111111111
              },
              "time_count_per_day": {
                "2026-01-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_277": {
      "overall": {
        "avg_time_hours": 321.61,
        "mode_time_hours": 491.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 2,
          "32-34h": 1,
          "52-54h": 1,
          "168-170h": 1,
          "234-236h": 1,
          "370-372h": 1,
          "384-386h": 1,
          "490-492h": 5,
          "516-518h": 1,
          "916-918h": 1
        },
        "tickets_count": 21,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 2,
          "2026-03-03": 1,
          "2026-03-18": 6,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-09": 5,
          "2026-04-22": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-02-03": 517.1136758333333,
          "2026-02-19": 267.3461666666667,
          "2026-03-03": 5.2557325,
          "2026-03-18": 925.6845283333334,
          "2026-03-20": 53.73174111111111,
          "2026-03-25": 4.676363055555555,
          "2026-03-26": 916.6302636111111,
          "2026-04-09": 2455.062989722222,
          "2026-06-08": 0.27702194444444445
        },
        "time_count_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 2,
          "2026-03-03": 1,
          "2026-03-18": 3,
          "2026-03-20": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-09": 5,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 308.16,
          "mode_time_hours": 491.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 2,
            "490-492h": 5
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-03-25": 1,
            "2026-04-09": 5,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-03-03": 5.2557325,
            "2026-03-25": 4.676363055555555,
            "2026-04-09": 2455.062989722222,
            "2026-06-08": 0.27702194444444445
          },
          "time_count_per_day": {
            "2026-03-03": 1,
            "2026-03-25": 1,
            "2026-04-09": 5,
            "2026-06-08": 1
          }
        },
        "P3": {
          "avg_time_hours": 517.11,
          "mode_time_hours": 517.0,
          "mode_frequency": 1,
          "time_distribution": {
            "516-518h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 517.1136758333333
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 321.4,
          "mode_time_hours": 917.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "52-54h": 1,
            "168-170h": 1,
            "370-372h": 1,
            "384-386h": 1,
            "916-918h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-03-18": 6,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-26": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-02-19": 32.345188888888885,
            "2026-03-18": 925.6845283333334,
            "2026-03-20": 53.73174111111111,
            "2026-03-26": 916.6302636111111
          },
          "time_count_per_day": {
            "2026-02-19": 1,
            "2026-03-18": 3,
            "2026-03-20": 1,
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 235.0,
          "mode_time_hours": 235.0,
          "mode_frequency": 1,
          "time_distribution": {
            "234-236h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 235.0009777777778
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 321.61,
            "mode_time_hours": 491.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 2,
              "32-34h": 1,
              "52-54h": 1,
              "168-170h": 1,
              "234-236h": 1,
              "370-372h": 1,
              "384-386h": 1,
              "490-492h": 5,
              "516-518h": 1,
              "916-918h": 1
            },
            "tickets_count": 16,
            "tickets_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 2,
              "2026-03-03": 1,
              "2026-03-18": 3,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-09": 5,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-02-03": 517.1136758333333,
              "2026-02-19": 267.3461666666667,
              "2026-03-03": 5.2557325,
              "2026-03-18": 925.6845283333334,
              "2026-03-20": 53.73174111111111,
              "2026-03-25": 4.676363055555555,
              "2026-03-26": 916.6302636111111,
              "2026-04-09": 2455.062989722222,
              "2026-06-08": 0.27702194444444445
            },
            "time_count_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 2,
              "2026-03-03": 1,
              "2026-03-18": 3,
              "2026-03-20": 1,
              "2026-03-25": 1,
              "2026-03-26": 1,
              "2026-04-09": 5,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 308.16,
              "mode_time_hours": 491.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 2,
                "490-492h": 5
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-03-25": 1,
                "2026-04-09": 5,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-03-03": 5.2557325,
                "2026-03-25": 4.676363055555555,
                "2026-04-09": 2455.062989722222,
                "2026-06-08": 0.27702194444444445
              },
              "time_count_per_day": {
                "2026-03-03": 1,
                "2026-03-25": 1,
                "2026-04-09": 5,
                "2026-06-08": 1
              }
            },
            "P3": {
              "avg_time_hours": 517.11,
              "mode_time_hours": 517.0,
              "mode_frequency": 1,
              "time_distribution": {
                "516-518h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 517.1136758333333
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 321.4,
              "mode_time_hours": 917.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "52-54h": 1,
                "168-170h": 1,
                "370-372h": 1,
                "384-386h": 1,
                "916-918h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-19": 1,
                "2026-03-18": 3,
                "2026-03-20": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-02-19": 32.345188888888885,
                "2026-03-18": 925.6845283333334,
                "2026-03-20": 53.73174111111111,
                "2026-03-26": 916.6302636111111
              },
              "time_count_per_day": {
                "2026-02-19": 1,
                "2026-03-18": 3,
                "2026-03-20": 1,
                "2026-03-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 235.0,
              "mode_time_hours": 235.0,
              "mode_frequency": 1,
              "time_distribution": {
                "234-236h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 235.0009777777778
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-18": 3,
              "2026-03-19": 1,
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-18": 3,
                "2026-03-19": 1,
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_810": {
      "overall": {
        "avg_time_hours": 8.22,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 8.222695833333335
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 8.22,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 8.222695833333335
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.22,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 8.222695833333335
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.22,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 8.222695833333335
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_811": {
      "overall": {
        "avg_time_hours": 4.7,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-13": 2
        },
        "time_per_day": {
          "2026-01-13": 9.407072222222222
        },
        "time_count_per_day": {
          "2026-01-13": 2
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.7,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-13": 2
          },
          "time_per_day": {
            "2026-01-13": 9.407072222222222
          },
          "time_count_per_day": {
            "2026-01-13": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.7,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-13": 2
            },
            "time_per_day": {
              "2026-01-13": 9.407072222222222
            },
            "time_count_per_day": {
              "2026-01-13": 2
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.7,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-13": 2
              },
              "time_per_day": {
                "2026-01-13": 9.407072222222222
              },
              "time_count_per_day": {
                "2026-01-13": 2
              }
            }
          }
        }
      }
    },
    "cliente_812": {
      "overall": {
        "avg_time_hours": 337.2,
        "mode_time_hours": 337.0,
        "mode_frequency": 1,
        "time_distribution": {
          "336-338h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-27": 1
        },
        "time_per_day": {
          "2026-01-27": 337.20051166666667
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 337.2,
          "mode_time_hours": 337.0,
          "mode_frequency": 1,
          "time_distribution": {
            "336-338h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 337.20051166666667
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 337.2,
            "mode_time_hours": 337.0,
            "mode_frequency": 1,
            "time_distribution": {
              "336-338h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 337.20051166666667
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 337.2,
              "mode_time_hours": 337.0,
              "mode_frequency": 1,
              "time_distribution": {
                "336-338h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 337.20051166666667
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_813": {
      "overall": {
        "avg_time_hours": 5.43,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 5.426084722222222
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.43,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 5.426084722222222
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.43,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 5.426084722222222
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.43,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 5.426084722222222
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_110": {
      "overall": {
        "avg_time_hours": 512.96,
        "mode_time_hours": 513.0,
        "mode_frequency": 1,
        "time_distribution": {
          "512-514h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 512.9636947222223
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 512.96,
          "mode_time_hours": 513.0,
          "mode_frequency": 1,
          "time_distribution": {
            "512-514h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 512.9636947222223
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 512.96,
            "mode_time_hours": 513.0,
            "mode_frequency": 1,
            "time_distribution": {
              "512-514h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 512.9636947222223
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 512.96,
              "mode_time_hours": 513.0,
              "mode_frequency": 1,
              "time_distribution": {
                "512-514h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 512.9636947222223
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_290": {
      "overall": {
        "avg_time_hours": 1338.0,
        "mode_time_hours": 1391.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1284-1286h": 1,
          "1390-1392h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-09": 1,
          "2026-03-12": 1
        },
        "time_per_day": {
          "2026-03-09": 1285.1162191666667,
          "2026-03-12": 1390.879412222222
        },
        "time_count_per_day": {
          "2026-03-09": 1,
          "2026-03-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 1338.0,
          "mode_time_hours": 1391.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1284-1286h": 1,
            "1390-1392h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-03-12": 1
          },
          "time_per_day": {
            "2026-03-09": 1285.1162191666667,
            "2026-03-12": 1390.879412222222
          },
          "time_count_per_day": {
            "2026-03-09": 1,
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1338.0,
            "mode_time_hours": 1391.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1284-1286h": 1,
              "1390-1392h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-09": 1,
              "2026-03-12": 1
            },
            "time_per_day": {
              "2026-03-09": 1285.1162191666667,
              "2026-03-12": 1390.879412222222
            },
            "time_count_per_day": {
              "2026-03-09": 1,
              "2026-03-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 1338.0,
              "mode_time_hours": 1391.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1284-1286h": 1,
                "1390-1392h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-03-12": 1
              },
              "time_per_day": {
                "2026-03-09": 1285.1162191666667,
                "2026-03-12": 1390.879412222222
              },
              "time_count_per_day": {
                "2026-03-09": 1,
                "2026-03-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_814": {
      "overall": {
        "avg_time_hours": 1.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 1.1193666666666666
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 1.1193666666666666
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 1.1193666666666666
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 1.1193666666666666
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_815": {
      "overall": {
        "avg_time_hours": 4.31,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 4.308753888888889
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 4.31,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 4.308753888888889
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.31,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 4.308753888888889
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 4.31,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 4.308753888888889
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_816": {
      "overall": {
        "avg_time_hours": 0.43,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-13": 1
        },
        "time_per_day": {
          "2026-01-13": 0.43337833333333337
        },
        "time_count_per_day": {
          "2026-01-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.43,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-13": 1
          },
          "time_per_day": {
            "2026-01-13": 0.43337833333333337
          },
          "time_count_per_day": {
            "2026-01-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.43,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-13": 1
            },
            "time_per_day": {
              "2026-01-13": 0.43337833333333337
            },
            "time_count_per_day": {
              "2026-01-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.43,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-13": 1
              },
              "time_per_day": {
                "2026-01-13": 0.43337833333333337
              },
              "time_count_per_day": {
                "2026-01-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_817": {
      "overall": {
        "avg_time_hours": 103.67,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 2,
          "8-10h": 1,
          "498-500h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-01-15": 1,
          "2026-01-27": 2,
          "2026-02-03": 1,
          "2026-06-01": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-01-15": 8.721878333333333,
          "2026-01-27": 8.825951666666667,
          "2026-02-03": 498.2432944444445,
          "2026-06-06": 2.5737916666666667
        },
        "time_count_per_day": {
          "2026-01-15": 1,
          "2026-01-27": 2,
          "2026-02-03": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.57,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-06-06": 2.5737916666666667
          },
          "time_count_per_day": {
            "2026-06-06": 1
          }
        },
        "P3": {
          "avg_time_hours": 498.24,
          "mode_time_hours": 499.0,
          "mode_frequency": 1,
          "time_distribution": {
            "498-500h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 498.2432944444445
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 5.85,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "8-10h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-01-27": 2,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-01-15": 8.721878333333333,
            "2026-01-27": 8.825951666666667
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-01-27": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 103.67,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 2,
              "8-10h": 1,
              "498-500h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-15": 1,
              "2026-01-27": 2,
              "2026-02-03": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2026-01-15": 8.721878333333333,
              "2026-01-27": 8.825951666666667,
              "2026-02-03": 498.2432944444445,
              "2026-06-06": 2.5737916666666667
            },
            "time_count_per_day": {
              "2026-01-15": 1,
              "2026-01-27": 2,
              "2026-02-03": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.57,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {
                "2026-06-06": 2.5737916666666667
              },
              "time_count_per_day": {
                "2026-06-06": 1
              }
            },
            "P3": {
              "avg_time_hours": 498.24,
              "mode_time_hours": 499.0,
              "mode_frequency": 1,
              "time_distribution": {
                "498-500h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 498.2432944444445
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 5.85,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "8-10h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-01-27": 2
              },
              "time_per_day": {
                "2026-01-15": 8.721878333333333,
                "2026-01-27": 8.825951666666667
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-01-27": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_818": {
      "overall": {
        "avg_time_hours": 45.78,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 45.78328333333334
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 45.78,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 45.78328333333334
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 45.78,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 45.78328333333334
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 45.78,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 45.78328333333334
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_658": {
      "overall": {
        "avg_time_hours": 262.76,
        "mode_time_hours": 35.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "6-8h": 1,
          "24-26h": 2,
          "34-36h": 2,
          "104-106h": 1,
          "170-172h": 1,
          "256-258h": 1,
          "312-314h": 1,
          "488-490h": 1,
          "524-526h": 1,
          "578-580h": 1,
          "794-796h": 1,
          "836-838h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-24": 1,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-16": 2,
          "2026-03-18": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-18": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-25": 1,
          "2026-05-26": 2,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-02-03": 489.67239861111113,
          "2026-02-18": 171.99343472222222,
          "2026-02-24": 837.5221661111111,
          "2026-03-06": 4.963459166666667,
          "2026-03-07": 34.9717575,
          "2026-03-16": 312.56891,
          "2026-03-18": 6.678976111111111,
          "2026-03-30": 579.4504794444445,
          "2026-03-31": 104.0289061111111,
          "2026-04-18": 794.6462933333333,
          "2026-05-05": 256.63103666666666,
          "2026-05-06": 524.3805944444445,
          "2026-05-26": 51.293163888888884,
          "2026-05-30": 35.43394611111111
        },
        "time_count_per_day": {
          "2026-02-03": 1,
          "2026-02-18": 1,
          "2026-02-24": 1,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-16": 2,
          "2026-03-18": 1,
          "2026-03-30": 1,
          "2026-03-31": 1,
          "2026-04-18": 1,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-26": 2,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 312.29,
          "mode_time_hours": 313.0,
          "mode_frequency": 1,
          "time_distribution": {
            "312-314h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-03-16": 312.29470333333336
          },
          "time_count_per_day": {
            "2026-03-16": 1
          }
        },
        "P2": {
          "avg_time_hours": 241.58,
          "mode_time_hours": 35.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1,
            "6-8h": 1,
            "24-26h": 2,
            "34-36h": 2,
            "104-106h": 1,
            "256-258h": 1,
            "488-490h": 1,
            "524-526h": 1,
            "794-796h": 1,
            "836-838h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-24": 1,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-31": 1,
            "2026-04-18": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-02-03": 489.67239861111113,
            "2026-02-24": 837.5221661111111,
            "2026-03-06": 4.963459166666667,
            "2026-03-07": 34.9717575,
            "2026-03-16": 0.27420666666666665,
            "2026-03-18": 6.678976111111111,
            "2026-03-31": 104.0289061111111,
            "2026-04-18": 794.6462933333333,
            "2026-05-05": 256.63103666666666,
            "2026-05-06": 524.3805944444445,
            "2026-05-26": 51.293163888888884,
            "2026-05-30": 35.43394611111111
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-24": 1,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-31": 1,
            "2026-04-18": 1,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-26": 2,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 375.72,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "170-172h": 1,
            "578-580h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-03-30": 1
          },
          "time_per_day": {
            "2026-02-18": 171.99343472222222,
            "2026-03-30": 579.4504794444445
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 262.76,
            "mode_time_hours": 35.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "6-8h": 1,
              "24-26h": 2,
              "34-36h": 2,
              "104-106h": 1,
              "170-172h": 1,
              "256-258h": 1,
              "312-314h": 1,
              "488-490h": 1,
              "524-526h": 1,
              "578-580h": 1,
              "794-796h": 1,
              "836-838h": 1
            },
            "tickets_count": 16,
            "tickets_per_day": {
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-24": 1,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-16": 2,
              "2026-03-18": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-18": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-26": 2,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-02-03": 489.67239861111113,
              "2026-02-18": 171.99343472222222,
              "2026-02-24": 837.5221661111111,
              "2026-03-06": 4.963459166666667,
              "2026-03-07": 34.9717575,
              "2026-03-16": 312.56891,
              "2026-03-18": 6.678976111111111,
              "2026-03-30": 579.4504794444445,
              "2026-03-31": 104.0289061111111,
              "2026-04-18": 794.6462933333333,
              "2026-05-05": 256.63103666666666,
              "2026-05-06": 524.3805944444445,
              "2026-05-26": 51.293163888888884,
              "2026-05-30": 35.43394611111111
            },
            "time_count_per_day": {
              "2026-02-03": 1,
              "2026-02-18": 1,
              "2026-02-24": 1,
              "2026-03-06": 1,
              "2026-03-07": 1,
              "2026-03-16": 2,
              "2026-03-18": 1,
              "2026-03-30": 1,
              "2026-03-31": 1,
              "2026-04-18": 1,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-26": 2,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 312.29,
              "mode_time_hours": 313.0,
              "mode_frequency": 1,
              "time_distribution": {
                "312-314h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-03-16": 312.29470333333336
              },
              "time_count_per_day": {
                "2026-03-16": 1
              }
            },
            "P2": {
              "avg_time_hours": 241.58,
              "mode_time_hours": 35.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1,
                "6-8h": 1,
                "24-26h": 2,
                "34-36h": 2,
                "104-106h": 1,
                "256-258h": 1,
                "488-490h": 1,
                "524-526h": 1,
                "794-796h": 1,
                "836-838h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-24": 1,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-16": 1,
                "2026-03-18": 1,
                "2026-03-31": 1,
                "2026-04-18": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-26": 2,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-02-03": 489.67239861111113,
                "2026-02-24": 837.5221661111111,
                "2026-03-06": 4.963459166666667,
                "2026-03-07": 34.9717575,
                "2026-03-16": 0.27420666666666665,
                "2026-03-18": 6.678976111111111,
                "2026-03-31": 104.0289061111111,
                "2026-04-18": 794.6462933333333,
                "2026-05-05": 256.63103666666666,
                "2026-05-06": 524.3805944444445,
                "2026-05-26": 51.293163888888884,
                "2026-05-30": 35.43394611111111
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-24": 1,
                "2026-03-06": 1,
                "2026-03-07": 1,
                "2026-03-16": 1,
                "2026-03-18": 1,
                "2026-03-31": 1,
                "2026-04-18": 1,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-26": 2,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 375.72,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "170-172h": 1,
                "578-580h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-02-18": 171.99343472222222,
                "2026-03-30": 579.4504794444445
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-03-30": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_821": {
      "overall": {
        "avg_time_hours": 821.29,
        "mode_time_hours": 821.0,
        "mode_frequency": 1,
        "time_distribution": {
          "820-822h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-17": 1
        },
        "time_per_day": {
          "2026-02-17": 821.2945186111111
        },
        "time_count_per_day": {
          "2026-02-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 821.29,
          "mode_time_hours": 821.0,
          "mode_frequency": 1,
          "time_distribution": {
            "820-822h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-17": 1
          },
          "time_per_day": {
            "2026-02-17": 821.2945186111111
          },
          "time_count_per_day": {
            "2026-02-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 821.29,
            "mode_time_hours": 821.0,
            "mode_frequency": 1,
            "time_distribution": {
              "820-822h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-17": 1
            },
            "time_per_day": {
              "2026-02-17": 821.2945186111111
            },
            "time_count_per_day": {
              "2026-02-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 821.29,
              "mode_time_hours": 821.0,
              "mode_frequency": 1,
              "time_distribution": {
                "820-822h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-17": 1
              },
              "time_per_day": {
                "2026-02-17": 821.2945186111111
              },
              "time_count_per_day": {
                "2026-02-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_276": {
      "overall": {
        "avg_time_hours": 240.65,
        "mode_time_hours": 489.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "118-120h": 1,
          "350-352h": 1,
          "488-490h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-19": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-01-19": 119.84840916666667,
          "2026-01-29": 2.628753611111111,
          "2026-02-03": 489.4686369444445,
          "2026-02-13": 350.6357575
        },
        "time_count_per_day": {
          "2026-01-19": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 246.05,
          "mode_time_hours": 489.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "488-490h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-29": 1,
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-01-29": 2.628753611111111,
            "2026-02-03": 489.4686369444445
          },
          "time_count_per_day": {
            "2026-01-29": 1,
            "2026-02-03": 1
          }
        },
        "P3": {
          "avg_time_hours": 235.24,
          "mode_time_hours": 119.0,
          "mode_frequency": 1,
          "time_distribution": {
            "118-120h": 1,
            "350-352h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-19": 1,
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-01-19": 119.84840916666667,
            "2026-02-13": 350.6357575
          },
          "time_count_per_day": {
            "2026-01-19": 1,
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 240.65,
            "mode_time_hours": 489.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "118-120h": 1,
              "350-352h": 1,
              "488-490h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-19": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-01-19": 119.84840916666667,
              "2026-01-29": 2.628753611111111,
              "2026-02-03": 489.4686369444445,
              "2026-02-13": 350.6357575
            },
            "time_count_per_day": {
              "2026-01-19": 1,
              "2026-01-29": 1,
              "2026-02-03": 1,
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 246.05,
              "mode_time_hours": 489.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "488-490h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-29": 1,
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-01-29": 2.628753611111111,
                "2026-02-03": 489.4686369444445
              },
              "time_count_per_day": {
                "2026-01-29": 1,
                "2026-02-03": 1
              }
            },
            "P3": {
              "avg_time_hours": 235.24,
              "mode_time_hours": 119.0,
              "mode_frequency": 1,
              "time_distribution": {
                "118-120h": 1,
                "350-352h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-01-19": 119.84840916666667,
                "2026-02-13": 350.6357575
              },
              "time_count_per_day": {
                "2026-01-19": 1,
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_823": {
      "overall": {
        "avg_time_hours": 194.41,
        "mode_time_hours": 389.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "388-390h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-14": 1,
          "2026-01-30": 1
        },
        "time_per_day": {
          "2026-01-14": 0.5217994444444445,
          "2026-01-30": 388.29059916666665
        },
        "time_count_per_day": {
          "2026-01-14": 1,
          "2026-01-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-14": 1
          },
          "time_per_day": {
            "2026-01-14": 0.5217994444444445
          },
          "time_count_per_day": {
            "2026-01-14": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 388.29,
          "mode_time_hours": 389.0,
          "mode_frequency": 1,
          "time_distribution": {
            "388-390h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-30": 1
          },
          "time_per_day": {
            "2026-01-30": 388.29059916666665
          },
          "time_count_per_day": {
            "2026-01-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 194.41,
            "mode_time_hours": 389.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "388-390h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-14": 1,
              "2026-01-30": 1
            },
            "time_per_day": {
              "2026-01-14": 0.5217994444444445,
              "2026-01-30": 388.29059916666665
            },
            "time_count_per_day": {
              "2026-01-14": 1,
              "2026-01-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-14": 1
              },
              "time_per_day": {
                "2026-01-14": 0.5217994444444445
              },
              "time_count_per_day": {
                "2026-01-14": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 388.29,
              "mode_time_hours": 389.0,
              "mode_frequency": 1,
              "time_distribution": {
                "388-390h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-30": 1
              },
              "time_per_day": {
                "2026-01-30": 388.29059916666665
              },
              "time_count_per_day": {
                "2026-01-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_825": {
      "overall": {
        "avg_time_hours": 24.23,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 24.22561361111111
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 24.23,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 24.22561361111111
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.23,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 24.22561361111111
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 24.23,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 24.22561361111111
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_826": {
      "overall": {
        "avg_time_hours": 1.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-14": 1,
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-14": 0.5537391666666667,
          "2026-01-15": 1.5062944444444444
        },
        "time_count_per_day": {
          "2026-01-14": 1,
          "2026-01-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-14": 0.5537391666666667,
            "2026-01-15": 1.5062944444444444
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-14": 1,
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-14": 0.5537391666666667,
              "2026-01-15": 1.5062944444444444
            },
            "time_count_per_day": {
              "2026-01-14": 1,
              "2026-01-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-14": 0.5537391666666667,
                "2026-01-15": 1.5062944444444444
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "Margarida Janeiro": {
      "overall": {
        "avg_time_hours": 89.27,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "4-6h": 1,
          "20-22h": 1,
          "24-26h": 1,
          "48-50h": 2,
          "114-116h": 1,
          "122-124h": 1,
          "210-212h": 1,
          "216-218h": 2,
          "304-306h": 1
        },
        "tickets_count": 16,
        "tickets_per_day": {
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-20": 1,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-05-11": 2,
          "2026-05-20": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-01-14": 0.6189269444444445,
          "2026-01-15": 29.08797138888889,
          "2026-01-20": 21.879440555555558,
          "2026-02-23": 0.1014386111111111,
          "2026-03-02": 122.89936416666667,
          "2026-03-04": 0.030525555555555556,
          "2026-03-05": 305.85186250000004,
          "2026-03-13": 211.96694416666665,
          "2026-03-17": 114.2160175,
          "2026-03-18": 433.58321777777775,
          "2026-05-11": 98.7890113888889,
          "2026-05-29": 0.022860000000000002
        },
        "time_count_per_day": {
          "2026-01-14": 1,
          "2026-01-15": 2,
          "2026-01-20": 1,
          "2026-02-23": 1,
          "2026-03-02": 1,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-18": 2,
          "2026-05-11": 2,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 36.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "4-6h": 1,
            "20-22h": 1,
            "48-50h": 2,
            "114-116h": 1,
            "122-124h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-20": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-17": 1,
            "2026-05-11": 2,
            "2026-05-20": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-01-14": 0.6189269444444445,
            "2026-01-15": 4.3302525,
            "2026-01-20": 21.879440555555558,
            "2026-02-23": 0.1014386111111111,
            "2026-03-02": 122.89936416666667,
            "2026-03-04": 0.030525555555555556,
            "2026-03-17": 114.2160175,
            "2026-05-11": 98.7890113888889,
            "2026-05-29": 0.022860000000000002
          },
          "time_count_per_day": {
            "2026-01-14": 1,
            "2026-01-15": 1,
            "2026-01-20": 1,
            "2026-02-23": 1,
            "2026-03-02": 1,
            "2026-03-04": 1,
            "2026-03-17": 1,
            "2026-05-11": 2,
            "2026-05-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 180.86,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "210-212h": 1,
            "304-306h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-03-05": 1,
            "2026-03-13": 1
          },
          "time_per_day": {
            "2026-01-15": 24.75771888888889,
            "2026-03-05": 305.85186250000004,
            "2026-03-13": 211.96694416666665
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-03-05": 1,
            "2026-03-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 216.79,
          "mode_time_hours": 217.0,
          "mode_frequency": 2,
          "time_distribution": {
            "216-218h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 433.58321777777775
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 89.27,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "4-6h": 1,
              "20-22h": 1,
              "24-26h": 1,
              "48-50h": 2,
              "114-116h": 1,
              "122-124h": 1,
              "210-212h": 1,
              "216-218h": 2,
              "304-306h": 1
            },
            "tickets_count": 15,
            "tickets_per_day": {
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-20": 1,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-05-11": 2,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-01-14": 0.6189269444444445,
              "2026-01-15": 29.08797138888889,
              "2026-01-20": 21.879440555555558,
              "2026-02-23": 0.1014386111111111,
              "2026-03-02": 122.89936416666667,
              "2026-03-04": 0.030525555555555556,
              "2026-03-05": 305.85186250000004,
              "2026-03-13": 211.96694416666665,
              "2026-03-17": 114.2160175,
              "2026-03-18": 433.58321777777775,
              "2026-05-11": 98.7890113888889,
              "2026-05-29": 0.022860000000000002
            },
            "time_count_per_day": {
              "2026-01-14": 1,
              "2026-01-15": 2,
              "2026-01-20": 1,
              "2026-02-23": 1,
              "2026-03-02": 1,
              "2026-03-04": 1,
              "2026-03-05": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-18": 2,
              "2026-05-11": 2,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 36.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "4-6h": 1,
                "20-22h": 1,
                "48-50h": 2,
                "114-116h": 1,
                "122-124h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-20": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-17": 1,
                "2026-05-11": 2,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-01-14": 0.6189269444444445,
                "2026-01-15": 4.3302525,
                "2026-01-20": 21.879440555555558,
                "2026-02-23": 0.1014386111111111,
                "2026-03-02": 122.89936416666667,
                "2026-03-04": 0.030525555555555556,
                "2026-03-17": 114.2160175,
                "2026-05-11": 98.7890113888889,
                "2026-05-29": 0.022860000000000002
              },
              "time_count_per_day": {
                "2026-01-14": 1,
                "2026-01-15": 1,
                "2026-01-20": 1,
                "2026-02-23": 1,
                "2026-03-02": 1,
                "2026-03-04": 1,
                "2026-03-17": 1,
                "2026-05-11": 2,
                "2026-05-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 180.86,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "210-212h": 1,
                "304-306h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-03-05": 1,
                "2026-03-13": 1
              },
              "time_per_day": {
                "2026-01-15": 24.75771888888889,
                "2026-03-05": 305.85186250000004,
                "2026-03-13": 211.96694416666665
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-03-05": 1,
                "2026-03-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 216.79,
              "mode_time_hours": 217.0,
              "mode_frequency": 2,
              "time_distribution": {
                "216-218h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 433.58321777777775
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_828": {
      "overall": {
        "avg_time_hours": 4.35,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 4.3516216666666665
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.35,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 4.3516216666666665
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.35,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 4.3516216666666665
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.35,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 4.3516216666666665
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_490": {
      "overall": {
        "avg_time_hours": 1.41,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-15": 1,
          "2026-01-26": 1,
          "2026-04-06": 1
        },
        "time_per_day": {
          "2026-01-15": 2.4967586111111113,
          "2026-01-26": 1.5125147222222222,
          "2026-04-06": 0.22759166666666666
        },
        "time_count_per_day": {
          "2026-01-15": 1,
          "2026-01-26": 1,
          "2026-04-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.41,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-04-06": 1
          },
          "time_per_day": {
            "2026-01-15": 2.4967586111111113,
            "2026-01-26": 1.5125147222222222,
            "2026-04-06": 0.22759166666666666
          },
          "time_count_per_day": {
            "2026-01-15": 1,
            "2026-01-26": 1,
            "2026-04-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.41,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-15": 1,
              "2026-01-26": 1,
              "2026-04-06": 1
            },
            "time_per_day": {
              "2026-01-15": 2.4967586111111113,
              "2026-01-26": 1.5125147222222222,
              "2026-04-06": 0.22759166666666666
            },
            "time_count_per_day": {
              "2026-01-15": 1,
              "2026-01-26": 1,
              "2026-04-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.41,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-04-06": 1
              },
              "time_per_day": {
                "2026-01-15": 2.4967586111111113,
                "2026-01-26": 1.5125147222222222,
                "2026-04-06": 0.22759166666666666
              },
              "time_count_per_day": {
                "2026-01-15": 1,
                "2026-01-26": 1,
                "2026-04-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_829": {
      "overall": {
        "avg_time_hours": 4.36,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-15": 1
        },
        "time_per_day": {
          "2026-01-15": 4.362892777777778
        },
        "time_count_per_day": {
          "2026-01-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.36,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-15": 1
          },
          "time_per_day": {
            "2026-01-15": 4.362892777777778
          },
          "time_count_per_day": {
            "2026-01-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.36,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-15": 1
            },
            "time_per_day": {
              "2026-01-15": 4.362892777777778
            },
            "time_count_per_day": {
              "2026-01-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.36,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-15": 1
              },
              "time_per_day": {
                "2026-01-15": 4.362892777777778
              },
              "time_count_per_day": {
                "2026-01-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_830": {
      "overall": {
        "avg_time_hours": 817.88,
        "mode_time_hours": 815.0,
        "mode_frequency": 1,
        "time_distribution": {
          "814-816h": 1,
          "820-822h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-18": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-18": 815.6705302777777,
          "2026-02-19": 820.0885227777778
        },
        "time_count_per_day": {
          "2026-02-18": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 817.88,
          "mode_time_hours": 815.0,
          "mode_frequency": 1,
          "time_distribution": {
            "814-816h": 1,
            "820-822h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-18": 815.6705302777777,
            "2026-02-19": 820.0885227777778
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 817.88,
            "mode_time_hours": 815.0,
            "mode_frequency": 1,
            "time_distribution": {
              "814-816h": 1,
              "820-822h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-18": 815.6705302777777,
              "2026-02-19": 820.0885227777778
            },
            "time_count_per_day": {
              "2026-02-18": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 817.88,
              "mode_time_hours": 815.0,
              "mode_frequency": 1,
              "time_distribution": {
                "814-816h": 1,
                "820-822h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-18": 815.6705302777777,
                "2026-02-19": 820.0885227777778
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_831": {
      "overall": {
        "avg_time_hours": 4.1,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "4-6h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-15": 2
        },
        "time_per_day": {
          "2026-01-15": 8.204365833333334
        },
        "time_count_per_day": {
          "2026-01-15": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.1,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "4-6h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-15": 2
          },
          "time_per_day": {
            "2026-01-15": 8.204365833333334
          },
          "time_count_per_day": {
            "2026-01-15": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.1,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "4-6h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-15": 2
            },
            "time_per_day": {
              "2026-01-15": 8.204365833333334
            },
            "time_count_per_day": {
              "2026-01-15": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.1,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "4-6h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-15": 2
              },
              "time_per_day": {
                "2026-01-15": 8.204365833333334
              },
              "time_count_per_day": {
                "2026-01-15": 2
              }
            }
          }
        }
      }
    },
    "cliente_832": {
      "overall": {
        "avg_time_hours": 28.81,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-16": 1
        },
        "time_per_day": {
          "2026-01-16": 28.81416861111111
        },
        "time_count_per_day": {
          "2026-01-16": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 28.81,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 28.81416861111111
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.81,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-16": 1
            },
            "time_per_day": {
              "2026-01-16": 28.81416861111111
            },
            "time_count_per_day": {
              "2026-01-16": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 28.81,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 28.81416861111111
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_833": {
      "overall": {
        "avg_time_hours": 14.83,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-16": 1
        },
        "time_per_day": {
          "2026-01-16": 14.828039444444444
        },
        "time_count_per_day": {
          "2026-01-16": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 14.83,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 14.828039444444444
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.83,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-16": 1
            },
            "time_per_day": {
              "2026-01-16": 14.828039444444444
            },
            "time_count_per_day": {
              "2026-01-16": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 14.83,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 14.828039444444444
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_834": {
      "overall": {
        "avg_time_hours": 828.17,
        "mode_time_hours": 829.0,
        "mode_frequency": 1,
        "time_distribution": {
          "828-830h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 828.1684975000001
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 828.17,
          "mode_time_hours": 829.0,
          "mode_frequency": 1,
          "time_distribution": {
            "828-830h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 828.1684975000001
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 828.17,
            "mode_time_hours": 829.0,
            "mode_frequency": 1,
            "time_distribution": {
              "828-830h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 828.1684975000001
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 828.17,
              "mode_time_hours": 829.0,
              "mode_frequency": 1,
              "time_distribution": {
                "828-830h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 828.1684975000001
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_188": {
      "overall": {
        "avg_time_hours": 469.28,
        "mode_time_hours": 789.0,
        "mode_frequency": 2,
        "time_distribution": {
          "48-50h": 1,
          "72-74h": 1,
          "288-290h": 2,
          "322-324h": 1,
          "788-790h": 2,
          "790-792h": 1,
          "826-828h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2026-01-18": 1,
          "2026-02-19": 6,
          "2026-02-23": 2,
          "2026-03-06": 1,
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-01-18": 49.25654222222222,
          "2026-02-19": 3596.721072222222,
          "2026-03-18": 577.5241913888889
        },
        "time_count_per_day": {
          "2026-01-18": 1,
          "2026-02-19": 6,
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 208.93,
          "mode_time_hours": 289.0,
          "mode_frequency": 2,
          "time_distribution": {
            "48-50h": 1,
            "288-290h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-18": 1,
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-01-18": 49.25654222222222,
            "2026-03-18": 577.5241913888889
          },
          "time_count_per_day": {
            "2026-01-18": 1,
            "2026-03-18": 2
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 599.45,
          "mode_time_hours": 789.0,
          "mode_frequency": 2,
          "time_distribution": {
            "72-74h": 1,
            "322-324h": 1,
            "788-790h": 2,
            "790-792h": 1,
            "826-828h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2026-02-19": 6,
            "2026-02-23": 2,
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-02-19": 3596.721072222222
          },
          "time_count_per_day": {
            "2026-02-19": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 469.28,
            "mode_time_hours": 789.0,
            "mode_frequency": 2,
            "time_distribution": {
              "48-50h": 1,
              "72-74h": 1,
              "288-290h": 2,
              "322-324h": 1,
              "788-790h": 2,
              "790-792h": 1,
              "826-828h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-01-18": 1,
              "2026-02-19": 6,
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-01-18": 49.25654222222222,
              "2026-02-19": 3596.721072222222,
              "2026-03-18": 577.5241913888889
            },
            "time_count_per_day": {
              "2026-01-18": 1,
              "2026-02-19": 6,
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 208.93,
              "mode_time_hours": 289.0,
              "mode_frequency": 2,
              "time_distribution": {
                "48-50h": 1,
                "288-290h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-18": 1,
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-01-18": 49.25654222222222,
                "2026-03-18": 577.5241913888889
              },
              "time_count_per_day": {
                "2026-01-18": 1,
                "2026-03-18": 2
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 599.45,
              "mode_time_hours": 789.0,
              "mode_frequency": 2,
              "time_distribution": {
                "72-74h": 1,
                "322-324h": 1,
                "788-790h": 2,
                "790-792h": 1,
                "826-828h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-19": 6
              },
              "time_per_day": {
                "2026-02-19": 3596.721072222222
              },
              "time_count_per_day": {
                "2026-02-19": 6
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-23": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-23": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_836": {
      "overall": {
        "avg_time_hours": 85.06,
        "mode_time_hours": 85.0,
        "mode_frequency": 1,
        "time_distribution": {
          "84-86h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-19": 1
        },
        "time_per_day": {
          "2026-01-19": 85.064075
        },
        "time_count_per_day": {
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 85.06,
          "mode_time_hours": 85.0,
          "mode_frequency": 1,
          "time_distribution": {
            "84-86h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 85.064075
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 85.06,
            "mode_time_hours": 85.0,
            "mode_frequency": 1,
            "time_distribution": {
              "84-86h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-19": 85.064075
            },
            "time_count_per_day": {
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 85.06,
              "mode_time_hours": 85.0,
              "mode_frequency": 1,
              "time_distribution": {
                "84-86h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 85.064075
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_837": {
      "overall": {
        "avg_time_hours": 4.66,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-16": 1
        },
        "time_per_day": {
          "2026-01-16": 4.662446666666667
        },
        "time_count_per_day": {
          "2026-01-16": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.66,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {
            "2026-01-16": 4.662446666666667
          },
          "time_count_per_day": {
            "2026-01-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.66,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-16": 1
            },
            "time_per_day": {
              "2026-01-16": 4.662446666666667
            },
            "time_count_per_day": {
              "2026-01-16": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.66,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {
                "2026-01-16": 4.662446666666667
              },
              "time_count_per_day": {
                "2026-01-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_142": {
      "overall": {
        "avg_time_hours": 809.15,
        "mode_time_hours": 809.0,
        "mode_frequency": 1,
        "time_distribution": {
          "808-810h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 809.1483783333333
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 809.15,
          "mode_time_hours": 809.0,
          "mode_frequency": 1,
          "time_distribution": {
            "808-810h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 809.1483783333333
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 809.15,
            "mode_time_hours": 809.0,
            "mode_frequency": 1,
            "time_distribution": {
              "808-810h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 809.1483783333333
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 809.15,
              "mode_time_hours": 809.0,
              "mode_frequency": 1,
              "time_distribution": {
                "808-810h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 809.1483783333333
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_838": {
      "overall": {
        "avg_time_hours": 70.79,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-19": 1
        },
        "time_per_day": {
          "2026-01-19": 70.79269083333334
        },
        "time_count_per_day": {
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 70.79,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 70.79269083333334
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.79,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-19": 70.79269083333334
            },
            "time_count_per_day": {
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 70.79,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 70.79269083333334
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_839": {
      "overall": {
        "avg_time_hours": 47.95,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1,
          "74-76h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-17": 1,
          "2026-01-19": 1,
          "2026-04-28": 1
        },
        "time_per_day": {
          "2026-01-17": 20.77502555555556,
          "2026-01-19": 75.13223138888888
        },
        "time_count_per_day": {
          "2026-01-17": 1,
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": 75.13,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 75.13223138888888
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 20.78,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-17": 1
          },
          "time_per_day": {
            "2026-01-17": 20.77502555555556
          },
          "time_count_per_day": {
            "2026-01-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 47.95,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1,
              "74-76h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-17": 1,
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-17": 20.77502555555556,
              "2026-01-19": 75.13223138888888
            },
            "time_count_per_day": {
              "2026-01-17": 1,
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 75.13,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 75.13223138888888
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 20.78,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-17": 1
              },
              "time_per_day": {
                "2026-01-17": 20.77502555555556
              },
              "time_count_per_day": {
                "2026-01-17": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_840": {
      "overall": {
        "avg_time_hours": 339.11,
        "mode_time_hours": 675.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "674-676h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-13": 1,
          "2026-02-20": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-02-13": 675.0436308333333,
          "2026-02-20": 3.1784380555555556
        },
        "time_count_per_day": {
          "2026-02-13": 1,
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 339.11,
          "mode_time_hours": 675.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "674-676h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-13": 1,
            "2026-02-20": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-02-13": 675.0436308333333,
            "2026-02-20": 3.1784380555555556
          },
          "time_count_per_day": {
            "2026-02-13": 1,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 339.11,
            "mode_time_hours": 675.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "674-676h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-13": 1,
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-13": 675.0436308333333,
              "2026-02-20": 3.1784380555555556
            },
            "time_count_per_day": {
              "2026-02-13": 1,
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 339.11,
              "mode_time_hours": 675.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "674-676h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-13": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-13": 675.0436308333333,
                "2026-02-20": 3.1784380555555556
              },
              "time_count_per_day": {
                "2026-02-13": 1,
                "2026-02-20": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_841": {
      "overall": {
        "avg_time_hours": 4.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "12-14h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-16": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-04-15": 1
        },
        "time_per_day": {
          "2026-01-16": 1.9954494444444446,
          "2026-02-19": 13.638155277777777,
          "2026-02-23": 0.09129499999999999,
          "2026-04-15": 0.7046019444444445
        },
        "time_count_per_day": {
          "2026-01-16": 1,
          "2026-02-19": 1,
          "2026-02-23": 1,
          "2026-04-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-16": 1,
            "2026-02-23": 1,
            "2026-04-15": 1
          },
          "time_per_day": {
            "2026-01-16": 1.9954494444444446,
            "2026-02-23": 0.09129499999999999,
            "2026-04-15": 0.7046019444444445
          },
          "time_count_per_day": {
            "2026-01-16": 1,
            "2026-02-23": 1,
            "2026-04-15": 1
          }
        },
        "P3": {
          "avg_time_hours": 13.64,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 13.638155277777777
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "12-14h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-16": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-04-15": 1
            },
            "time_per_day": {
              "2026-01-16": 1.9954494444444446,
              "2026-02-19": 13.638155277777777,
              "2026-02-23": 0.09129499999999999,
              "2026-04-15": 0.7046019444444445
            },
            "time_count_per_day": {
              "2026-01-16": 1,
              "2026-02-19": 1,
              "2026-02-23": 1,
              "2026-04-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-16": 1,
                "2026-02-23": 1,
                "2026-04-15": 1
              },
              "time_per_day": {
                "2026-01-16": 1.9954494444444446,
                "2026-02-23": 0.09129499999999999,
                "2026-04-15": 0.7046019444444445
              },
              "time_count_per_day": {
                "2026-01-16": 1,
                "2026-02-23": 1,
                "2026-04-15": 1
              }
            },
            "P3": {
              "avg_time_hours": 13.64,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 13.638155277777777
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_842": {
      "overall": {
        "avg_time_hours": 592.05,
        "mode_time_hours": 593.0,
        "mode_frequency": 1,
        "time_distribution": {
          "592-594h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 592.049461388889
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 592.05,
          "mode_time_hours": 593.0,
          "mode_frequency": 1,
          "time_distribution": {
            "592-594h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 592.049461388889
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 592.05,
            "mode_time_hours": 593.0,
            "mode_frequency": 1,
            "time_distribution": {
              "592-594h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 592.049461388889
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 592.05,
              "mode_time_hours": 593.0,
              "mode_frequency": 1,
              "time_distribution": {
                "592-594h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 592.049461388889
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_843": {
      "overall": {
        "avg_time_hours": 62.94,
        "mode_time_hours": 63.0,
        "mode_frequency": 1,
        "time_distribution": {
          "62-64h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-19": 1
        },
        "time_per_day": {
          "2026-01-19": 62.941518888888886
        },
        "time_count_per_day": {
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 62.94,
          "mode_time_hours": 63.0,
          "mode_frequency": 1,
          "time_distribution": {
            "62-64h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 62.941518888888886
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 62.94,
            "mode_time_hours": 63.0,
            "mode_frequency": 1,
            "time_distribution": {
              "62-64h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-19": 62.941518888888886
            },
            "time_count_per_day": {
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 62.94,
              "mode_time_hours": 63.0,
              "mode_frequency": 1,
              "time_distribution": {
                "62-64h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 62.941518888888886
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_844": {
      "overall": {
        "avg_time_hours": 182.79,
        "mode_time_hours": 183.0,
        "mode_frequency": 1,
        "time_distribution": {
          "182-184h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-24": 1
        },
        "time_per_day": {
          "2026-01-24": 182.791115
        },
        "time_count_per_day": {
          "2026-01-24": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 182.79,
          "mode_time_hours": 183.0,
          "mode_frequency": 1,
          "time_distribution": {
            "182-184h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-24": 1
          },
          "time_per_day": {
            "2026-01-24": 182.791115
          },
          "time_count_per_day": {
            "2026-01-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 182.79,
            "mode_time_hours": 183.0,
            "mode_frequency": 1,
            "time_distribution": {
              "182-184h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-24": 1
            },
            "time_per_day": {
              "2026-01-24": 182.791115
            },
            "time_count_per_day": {
              "2026-01-24": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 182.79,
              "mode_time_hours": 183.0,
              "mode_frequency": 1,
              "time_distribution": {
                "182-184h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-24": 1
              },
              "time_per_day": {
                "2026-01-24": 182.791115
              },
              "time_count_per_day": {
                "2026-01-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_845": {
      "overall": {
        "avg_time_hours": 3263.1,
        "mode_time_hours": 3263.0,
        "mode_frequency": 1,
        "time_distribution": {
          "3262-3264h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-02": 3263.0954405555553
        },
        "time_count_per_day": {
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3263.1,
          "mode_time_hours": 3263.0,
          "mode_frequency": 1,
          "time_distribution": {
            "3262-3264h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 3263.0954405555553
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3263.1,
            "mode_time_hours": 3263.0,
            "mode_frequency": 1,
            "time_distribution": {
              "3262-3264h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-02": 3263.0954405555553
            },
            "time_count_per_day": {
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3263.1,
              "mode_time_hours": 3263.0,
              "mode_frequency": 1,
              "time_distribution": {
                "3262-3264h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 3263.0954405555553
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_847": {
      "overall": {
        "avg_time_hours": 78.47,
        "mode_time_hours": 79.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-21": 1
        },
        "time_per_day": {
          "2026-01-21": 78.47496361111111
        },
        "time_count_per_day": {
          "2026-01-21": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 78.47,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 78.47496361111111
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 78.47,
            "mode_time_hours": 79.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {
              "2026-01-21": 78.47496361111111
            },
            "time_count_per_day": {
              "2026-01-21": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 78.47,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 78.47496361111111
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_848": {
      "overall": {
        "avg_time_hours": 20.97,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-19": 1
        },
        "time_per_day": {
          "2026-01-19": 20.969840555555557
        },
        "time_count_per_day": {
          "2026-01-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 20.97,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 20.969840555555557
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.97,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-19": 1
            },
            "time_per_day": {
              "2026-01-19": 20.969840555555557
            },
            "time_count_per_day": {
              "2026-01-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 20.97,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 20.969840555555557
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_849": {
      "overall": {
        "avg_time_hours": 20.36,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "76-78h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-01-21": 1,
          "2026-02-25": 1,
          "2026-04-06": 2,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-01-21": 77.54148805555556,
          "2026-04-06": 3.6209216666666664,
          "2026-05-26": 0.2789702777777778
        },
        "time_count_per_day": {
          "2026-01-21": 1,
          "2026-04-06": 2,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-06": 2,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-04-06": 3.6209216666666664,
            "2026-05-26": 0.2789702777777778
          },
          "time_count_per_day": {
            "2026-04-06": 2,
            "2026-05-26": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 77.54,
          "mode_time_hours": 77.0,
          "mode_frequency": 1,
          "time_distribution": {
            "76-78h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 77.54148805555556
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.36,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "76-78h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-21": 1,
              "2026-04-06": 2,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-01-21": 77.54148805555556,
              "2026-04-06": 3.6209216666666664,
              "2026-05-26": 0.2789702777777778
            },
            "time_count_per_day": {
              "2026-01-21": 1,
              "2026-04-06": 2,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-06": 2,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-04-06": 3.6209216666666664,
                "2026-05-26": 0.2789702777777778
              },
              "time_count_per_day": {
                "2026-04-06": 2,
                "2026-05-26": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 77.54,
              "mode_time_hours": 77.0,
              "mode_frequency": 1,
              "time_distribution": {
                "76-78h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 77.54148805555556
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_851": {
      "overall": {
        "avg_time_hours": 185.81,
        "mode_time_hours": 529.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "26-28h": 1,
          "528-530h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-10": 1,
          "2026-03-19": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-02-10": 529.6985044444444,
          "2026-03-19": 0.3775325,
          "2026-03-20": 27.344085277777776
        },
        "time_count_per_day": {
          "2026-02-10": 1,
          "2026-03-19": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.38,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-03-19": 0.3775325
          },
          "time_count_per_day": {
            "2026-03-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 529.7,
          "mode_time_hours": 529.0,
          "mode_frequency": 1,
          "time_distribution": {
            "528-530h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 529.6985044444444
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 27.34,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 27.344085277777776
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 185.81,
            "mode_time_hours": 529.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "26-28h": 1,
              "528-530h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-10": 1,
              "2026-03-19": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-02-10": 529.6985044444444,
              "2026-03-19": 0.3775325,
              "2026-03-20": 27.344085277777776
            },
            "time_count_per_day": {
              "2026-02-10": 1,
              "2026-03-19": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.38,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-03-19": 0.3775325
              },
              "time_count_per_day": {
                "2026-03-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 529.7,
              "mode_time_hours": 529.0,
              "mode_frequency": 1,
              "time_distribution": {
                "528-530h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 529.6985044444444
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 27.34,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 27.344085277777776
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_852": {
      "overall": {
        "avg_time_hours": 2.57,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-19": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-01-19": 2.9201119444444443,
          "2026-03-20": 2.218755277777778
        },
        "time_count_per_day": {
          "2026-01-19": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.57,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-19": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-01-19": 2.9201119444444443,
            "2026-03-20": 2.218755277777778
          },
          "time_count_per_day": {
            "2026-01-19": 1,
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.57,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-19": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-01-19": 2.9201119444444443,
              "2026-03-20": 2.218755277777778
            },
            "time_count_per_day": {
              "2026-01-19": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.57,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-01-19": 2.9201119444444443,
                "2026-03-20": 2.218755277777778
              },
              "time_count_per_day": {
                "2026-01-19": 1,
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_853": {
      "overall": {
        "avg_time_hours": 135.05,
        "mode_time_hours": 13.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "12-14h": 2,
          "138-140h": 1,
          "140-142h": 1,
          "182-184h": 1,
          "336-338h": 1,
          "384-386h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2026-01-19": 1,
          "2026-02-03": 1,
          "2026-02-06": 2,
          "2026-02-19": 2,
          "2026-04-22": 1,
          "2026-06-03": 2
        },
        "time_per_day": {
          "2026-01-19": 4.8076961111111105,
          "2026-02-03": 141.9442838888889,
          "2026-02-06": 384.6071852777778,
          "2026-02-19": 477.04799055555554,
          "2026-04-22": 182.36483472222224,
          "2026-06-03": 24.716923055555554
        },
        "time_count_per_day": {
          "2026-01-19": 1,
          "2026-02-03": 1,
          "2026-02-06": 2,
          "2026-02-19": 2,
          "2026-04-22": 1,
          "2026-06-03": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.29,
          "mode_time_hours": 13.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "12-14h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-06": 1,
            "2026-06-03": 2
          },
          "time_per_day": {
            "2026-02-06": 0.1474888888888889,
            "2026-06-03": 24.716923055555554
          },
          "time_count_per_day": {
            "2026-02-06": 1,
            "2026-06-03": 2
          }
        },
        "P3": {
          "avg_time_hours": 4.81,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-19": 1
          },
          "time_per_day": {
            "2026-01-19": 4.8076961111111105
          },
          "time_count_per_day": {
            "2026-01-19": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 236.26,
          "mode_time_hours": 385.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1,
            "182-184h": 1,
            "384-386h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-02-03": 141.9442838888889,
            "2026-02-06": 384.45969638888886,
            "2026-04-22": 182.36483472222224
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-06": 1,
            "2026-04-22": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 238.52,
          "mode_time_hours": 337.0,
          "mode_frequency": 1,
          "time_distribution": {
            "138-140h": 1,
            "336-338h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 477.04799055555554
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 135.05,
            "mode_time_hours": 13.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "12-14h": 2,
              "138-140h": 1,
              "140-142h": 1,
              "182-184h": 1,
              "336-338h": 1,
              "384-386h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-01-19": 1,
              "2026-02-03": 1,
              "2026-02-06": 2,
              "2026-02-19": 2,
              "2026-04-22": 1,
              "2026-06-03": 2
            },
            "time_per_day": {
              "2026-01-19": 4.8076961111111105,
              "2026-02-03": 141.9442838888889,
              "2026-02-06": 384.6071852777778,
              "2026-02-19": 477.04799055555554,
              "2026-04-22": 182.36483472222224,
              "2026-06-03": 24.716923055555554
            },
            "time_count_per_day": {
              "2026-01-19": 1,
              "2026-02-03": 1,
              "2026-02-06": 2,
              "2026-02-19": 2,
              "2026-04-22": 1,
              "2026-06-03": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.29,
              "mode_time_hours": 13.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "12-14h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-06": 1,
                "2026-06-03": 2
              },
              "time_per_day": {
                "2026-02-06": 0.1474888888888889,
                "2026-06-03": 24.716923055555554
              },
              "time_count_per_day": {
                "2026-02-06": 1,
                "2026-06-03": 2
              }
            },
            "P3": {
              "avg_time_hours": 4.81,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-19": 1
              },
              "time_per_day": {
                "2026-01-19": 4.8076961111111105
              },
              "time_count_per_day": {
                "2026-01-19": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 236.26,
              "mode_time_hours": 385.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1,
                "182-184h": 1,
                "384-386h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-02-03": 141.9442838888889,
                "2026-02-06": 384.45969638888886,
                "2026-04-22": 182.36483472222224
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-06": 1,
                "2026-04-22": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 238.52,
              "mode_time_hours": 337.0,
              "mode_frequency": 1,
              "time_distribution": {
                "138-140h": 1,
                "336-338h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 477.04799055555554
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_855": {
      "overall": {
        "avg_time_hours": 58.12,
        "mode_time_hours": 59.0,
        "mode_frequency": 1,
        "time_distribution": {
          "58-60h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-21": 1
        },
        "time_per_day": {
          "2026-01-21": 58.12255583333334
        },
        "time_count_per_day": {
          "2026-01-21": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 58.12,
          "mode_time_hours": 59.0,
          "mode_frequency": 1,
          "time_distribution": {
            "58-60h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 58.12255583333334
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 58.12,
            "mode_time_hours": 59.0,
            "mode_frequency": 1,
            "time_distribution": {
              "58-60h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {
              "2026-01-21": 58.12255583333334
            },
            "time_count_per_day": {
              "2026-01-21": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 58.12,
              "mode_time_hours": 59.0,
              "mode_frequency": 1,
              "time_distribution": {
                "58-60h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 58.12255583333334
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_856": {
      "overall": {
        "avg_time_hours": 55.14,
        "mode_time_hours": 55.0,
        "mode_frequency": 2,
        "time_distribution": {
          "54-56h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-21": 2
        },
        "time_per_day": {
          "2026-01-21": 110.28945361111111
        },
        "time_count_per_day": {
          "2026-01-21": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 55.14,
          "mode_time_hours": 55.0,
          "mode_frequency": 2,
          "time_distribution": {
            "54-56h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-21": 2
          },
          "time_per_day": {
            "2026-01-21": 110.28945361111111
          },
          "time_count_per_day": {
            "2026-01-21": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 55.14,
            "mode_time_hours": 55.0,
            "mode_frequency": 2,
            "time_distribution": {
              "54-56h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-21": 2
            },
            "time_per_day": {
              "2026-01-21": 110.28945361111111
            },
            "time_count_per_day": {
              "2026-01-21": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 55.14,
              "mode_time_hours": 55.0,
              "mode_frequency": 2,
              "time_distribution": {
                "54-56h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-21": 2
              },
              "time_per_day": {
                "2026-01-21": 110.28945361111111
              },
              "time_count_per_day": {
                "2026-01-21": 2
              }
            }
          }
        }
      }
    },
    "cliente_408": {
      "overall": {
        "avg_time_hours": 106.57,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "58-60h": 1,
          "88-90h": 1,
          "338-340h": 1,
          "576-578h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2026-01-19": 1,
          "2026-02-25": 3,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-20": 1,
          "2026-04-08": 1,
          "2026-05-06": 1,
          "2026-05-14": 1
        },
        "time_per_day": {
          "2026-01-19": 0.004416111111111111,
          "2026-02-25": 0.056341388888888885,
          "2026-03-06": 0.01213611111111111,
          "2026-03-10": 89.95421666666667,
          "2026-03-20": 339.03836916666666,
          "2026-04-08": 58.788372777777774,
          "2026-05-06": 0.32845916666666664,
          "2026-05-14": 577.5629530555556
        },
        "time_count_per_day": {
          "2026-01-19": 1,
          "2026-02-25": 3,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-20": 1,
          "2026-04-08": 1,
          "2026-05-06": 1,
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 106.57,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "58-60h": 1,
            "88-90h": 1,
            "338-340h": 1,
            "576-578h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-01-19": 1,
            "2026-02-25": 3,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-08": 1,
            "2026-05-06": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-01-19": 0.004416111111111111,
            "2026-02-25": 0.056341388888888885,
            "2026-03-06": 0.01213611111111111,
            "2026-03-10": 89.95421666666667,
            "2026-03-20": 339.03836916666666,
            "2026-04-08": 58.788372777777774,
            "2026-05-06": 0.32845916666666664,
            "2026-05-14": 577.5629530555556
          },
          "time_count_per_day": {
            "2026-01-19": 1,
            "2026-02-25": 3,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-08": 1,
            "2026-05-06": 1,
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 106.57,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "58-60h": 1,
              "88-90h": 1,
              "338-340h": 1,
              "576-578h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-01-19": 1,
              "2026-02-25": 3,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-20": 1,
              "2026-04-08": 1,
              "2026-05-06": 1,
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-01-19": 0.004416111111111111,
              "2026-02-25": 0.056341388888888885,
              "2026-03-06": 0.01213611111111111,
              "2026-03-10": 89.95421666666667,
              "2026-03-20": 339.03836916666666,
              "2026-04-08": 58.788372777777774,
              "2026-05-06": 0.32845916666666664,
              "2026-05-14": 577.5629530555556
            },
            "time_count_per_day": {
              "2026-01-19": 1,
              "2026-02-25": 3,
              "2026-03-06": 1,
              "2026-03-10": 1,
              "2026-03-20": 1,
              "2026-04-08": 1,
              "2026-05-06": 1,
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 106.57,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "58-60h": 1,
                "88-90h": 1,
                "338-340h": 1,
                "576-578h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-01-19": 1,
                "2026-02-25": 3,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-08": 1,
                "2026-05-06": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-01-19": 0.004416111111111111,
                "2026-02-25": 0.056341388888888885,
                "2026-03-06": 0.01213611111111111,
                "2026-03-10": 89.95421666666667,
                "2026-03-20": 339.03836916666666,
                "2026-04-08": 58.788372777777774,
                "2026-05-06": 0.32845916666666664,
                "2026-05-14": 577.5629530555556
              },
              "time_count_per_day": {
                "2026-01-19": 1,
                "2026-02-25": 3,
                "2026-03-06": 1,
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-08": 1,
                "2026-05-06": 1,
                "2026-05-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_857": {
      "overall": {
        "avg_time_hours": 348.98,
        "mode_time_hours": 697.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "696-698h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-18": 2
        },
        "time_per_day": {
          "2026-02-18": 697.9575463888889
        },
        "time_count_per_day": {
          "2026-02-18": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.11,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 0.10645750000000001
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        },
        "P3": {
          "avg_time_hours": 697.85,
          "mode_time_hours": 697.0,
          "mode_frequency": 1,
          "time_distribution": {
            "696-698h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 697.8510888888889
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 348.98,
            "mode_time_hours": 697.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "696-698h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-18": 2
            },
            "time_per_day": {
              "2026-02-18": 697.9575463888889
            },
            "time_count_per_day": {
              "2026-02-18": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.11,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 0.10645750000000001
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            },
            "P3": {
              "avg_time_hours": 697.85,
              "mode_time_hours": 697.0,
              "mode_frequency": 1,
              "time_distribution": {
                "696-698h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 697.8510888888889
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_859": {
      "overall": {
        "avg_time_hours": 18.23,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "4-6h": 2,
          "6-8h": 1,
          "50-52h": 1,
          "72-74h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-01-20": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-27": 1,
          "2026-05-12": 1,
          "2026-05-22": 1,
          "2026-05-28": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-01-20": 1.340295277777778,
          "2026-04-08": 7.549686111111111,
          "2026-04-09": 0.5147494444444445,
          "2026-04-27": 1.8577544444444445,
          "2026-05-12": 73.60356333333333,
          "2026-05-22": 50.27289972222223,
          "2026-05-28": 5.335620555555556,
          "2026-06-05": 5.378496111111111
        },
        "time_count_per_day": {
          "2026-01-20": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-27": 1,
          "2026-05-12": 1,
          "2026-05-22": 1,
          "2026-05-28": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 28.84,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "72-74h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-08": 1,
            "2026-05-12": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-04-08": 7.549686111111111,
            "2026-05-12": 73.60356333333333,
            "2026-06-05": 5.378496111111111
          },
          "time_count_per_day": {
            "2026-04-08": 1,
            "2026-05-12": 1,
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 11.86,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "4-6h": 1,
            "50-52h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-01-20": 1,
            "2026-04-09": 1,
            "2026-04-27": 1,
            "2026-05-22": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-01-20": 1.340295277777778,
            "2026-04-09": 0.5147494444444445,
            "2026-04-27": 1.8577544444444445,
            "2026-05-22": 50.27289972222223,
            "2026-05-28": 5.335620555555556
          },
          "time_count_per_day": {
            "2026-01-20": 1,
            "2026-04-09": 1,
            "2026-04-27": 1,
            "2026-05-22": 1,
            "2026-05-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 18.23,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "4-6h": 2,
              "6-8h": 1,
              "50-52h": 1,
              "72-74h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-01-20": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-27": 1,
              "2026-05-12": 1,
              "2026-05-22": 1,
              "2026-05-28": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-01-20": 1.340295277777778,
              "2026-04-08": 7.549686111111111,
              "2026-04-09": 0.5147494444444445,
              "2026-04-27": 1.8577544444444445,
              "2026-05-12": 73.60356333333333,
              "2026-05-22": 50.27289972222223,
              "2026-05-28": 5.335620555555556,
              "2026-06-05": 5.378496111111111
            },
            "time_count_per_day": {
              "2026-01-20": 1,
              "2026-04-08": 1,
              "2026-04-09": 1,
              "2026-04-27": 1,
              "2026-05-12": 1,
              "2026-05-22": 1,
              "2026-05-28": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 28.84,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "72-74h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-08": 1,
                "2026-05-12": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-04-08": 7.549686111111111,
                "2026-05-12": 73.60356333333333,
                "2026-06-05": 5.378496111111111
              },
              "time_count_per_day": {
                "2026-04-08": 1,
                "2026-05-12": 1,
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 11.86,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "4-6h": 1,
                "50-52h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-01-20": 1,
                "2026-04-09": 1,
                "2026-04-27": 1,
                "2026-05-22": 1,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-01-20": 1.340295277777778,
                "2026-04-09": 0.5147494444444445,
                "2026-04-27": 1.8577544444444445,
                "2026-05-22": 50.27289972222223,
                "2026-05-28": 5.335620555555556
              },
              "time_count_per_day": {
                "2026-01-20": 1,
                "2026-04-09": 1,
                "2026-04-27": 1,
                "2026-05-22": 1,
                "2026-05-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_860": {
      "overall": {
        "avg_time_hours": 1.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-20": 1
        },
        "time_per_day": {
          "2026-01-20": 1.0091380555555556
        },
        "time_count_per_day": {
          "2026-01-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-20": 1
          },
          "time_per_day": {
            "2026-01-20": 1.0091380555555556
          },
          "time_count_per_day": {
            "2026-01-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-20": 1
            },
            "time_per_day": {
              "2026-01-20": 1.0091380555555556
            },
            "time_count_per_day": {
              "2026-01-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-20": 1
              },
              "time_per_day": {
                "2026-01-20": 1.0091380555555556
              },
              "time_count_per_day": {
                "2026-01-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_863": {
      "overall": {
        "avg_time_hours": 1.14,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-20": 1
        },
        "time_per_day": {
          "2026-01-20": 1.1359677777777777
        },
        "time_count_per_day": {
          "2026-01-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-20": 1
          },
          "time_per_day": {
            "2026-01-20": 1.1359677777777777
          },
          "time_count_per_day": {
            "2026-01-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.14,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-20": 1
            },
            "time_per_day": {
              "2026-01-20": 1.1359677777777777
            },
            "time_count_per_day": {
              "2026-01-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-20": 1
              },
              "time_per_day": {
                "2026-01-20": 1.1359677777777777
              },
              "time_count_per_day": {
                "2026-01-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_865": {
      "overall": {
        "avg_time_hours": 414.53,
        "mode_time_hours": 415.0,
        "mode_frequency": 2,
        "time_distribution": {
          "414-416h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-06": 2
        },
        "time_per_day": {
          "2026-02-06": 829.0506488888889
        },
        "time_count_per_day": {
          "2026-02-06": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 414.53,
          "mode_time_hours": 415.0,
          "mode_frequency": 2,
          "time_distribution": {
            "414-416h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-06": 2
          },
          "time_per_day": {
            "2026-02-06": 829.0506488888889
          },
          "time_count_per_day": {
            "2026-02-06": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 414.53,
            "mode_time_hours": 415.0,
            "mode_frequency": 2,
            "time_distribution": {
              "414-416h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-06": 2
            },
            "time_per_day": {
              "2026-02-06": 829.0506488888889
            },
            "time_count_per_day": {
              "2026-02-06": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 414.53,
              "mode_time_hours": 415.0,
              "mode_frequency": 2,
              "time_distribution": {
                "414-416h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-06": 2
              },
              "time_per_day": {
                "2026-02-06": 829.0506488888889
              },
              "time_count_per_day": {
                "2026-02-06": 2
              }
            }
          }
        }
      }
    },
    "cliente_256": {
      "overall": {
        "avg_time_hours": 361.81,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "30-32h": 1,
          "174-176h": 1,
          "368-370h": 1,
          "1584-1586h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-12": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-01-20": 5.7382925,
          "2026-01-22": 4.160966111111111,
          "2026-01-30": 31.66134361111111,
          "2026-02-09": 175.6976725,
          "2026-02-12": 368.8594013888889,
          "2026-04-23": 1584.727355
        },
        "time_count_per_day": {
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-30": 1,
          "2026-02-09": 1,
          "2026-02-12": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 497.75,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "30-32h": 1,
            "368-370h": 1,
            "1584-1586h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-20": 1,
            "2026-01-30": 1,
            "2026-02-12": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-01-20": 5.7382925,
            "2026-01-30": 31.66134361111111,
            "2026-02-12": 368.8594013888889,
            "2026-04-23": 1584.727355
          },
          "time_count_per_day": {
            "2026-01-20": 1,
            "2026-01-30": 1,
            "2026-02-12": 1,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 89.93,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "174-176h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-22": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-01-22": 4.160966111111111,
            "2026-02-09": 175.6976725
          },
          "time_count_per_day": {
            "2026-01-22": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 361.81,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "30-32h": 1,
              "174-176h": 1,
              "368-370h": 1,
              "1584-1586h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-12": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-01-20": 5.7382925,
              "2026-01-22": 4.160966111111111,
              "2026-01-30": 31.66134361111111,
              "2026-02-09": 175.6976725,
              "2026-02-12": 368.8594013888889,
              "2026-04-23": 1584.727355
            },
            "time_count_per_day": {
              "2026-01-20": 1,
              "2026-01-22": 1,
              "2026-01-30": 1,
              "2026-02-09": 1,
              "2026-02-12": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 497.75,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "30-32h": 1,
                "368-370h": 1,
                "1584-1586h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-20": 1,
                "2026-01-30": 1,
                "2026-02-12": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-01-20": 5.7382925,
                "2026-01-30": 31.66134361111111,
                "2026-02-12": 368.8594013888889,
                "2026-04-23": 1584.727355
              },
              "time_count_per_day": {
                "2026-01-20": 1,
                "2026-01-30": 1,
                "2026-02-12": 1,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 89.93,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "174-176h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-22": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-01-22": 4.160966111111111,
                "2026-02-09": 175.6976725
              },
              "time_count_per_day": {
                "2026-01-22": 1,
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_866": {
      "overall": {
        "avg_time_hours": 1.86,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-20": 1
        },
        "time_per_day": {
          "2026-01-20": 1.8563372222222223
        },
        "time_count_per_day": {
          "2026-01-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.86,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-20": 1
          },
          "time_per_day": {
            "2026-01-20": 1.8563372222222223
          },
          "time_count_per_day": {
            "2026-01-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.86,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-20": 1
            },
            "time_per_day": {
              "2026-01-20": 1.8563372222222223
            },
            "time_count_per_day": {
              "2026-01-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.86,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-20": 1
              },
              "time_per_day": {
                "2026-01-20": 1.8563372222222223
              },
              "time_count_per_day": {
                "2026-01-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_867": {
      "overall": {
        "avg_time_hours": 44.42,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-22": 1
        },
        "time_per_day": {
          "2026-01-22": 44.42486527777778
        },
        "time_count_per_day": {
          "2026-01-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 44.42,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-22": 1
          },
          "time_per_day": {
            "2026-01-22": 44.42486527777778
          },
          "time_count_per_day": {
            "2026-01-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 44.42,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-22": 1
            },
            "time_per_day": {
              "2026-01-22": 44.42486527777778
            },
            "time_count_per_day": {
              "2026-01-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 44.42,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-22": 1
              },
              "time_per_day": {
                "2026-01-22": 44.42486527777778
              },
              "time_count_per_day": {
                "2026-01-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_868": {
      "overall": {
        "avg_time_hours": 701.32,
        "mode_time_hours": 711.0,
        "mode_frequency": 1,
        "time_distribution": {
          "690-692h": 1,
          "710-712h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-19": 2
        },
        "time_per_day": {
          "2026-02-19": 1402.6395408333333
        },
        "time_count_per_day": {
          "2026-02-19": 2
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 701.32,
          "mode_time_hours": 711.0,
          "mode_frequency": 1,
          "time_distribution": {
            "690-692h": 1,
            "710-712h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 1402.6395408333333
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 701.32,
            "mode_time_hours": 711.0,
            "mode_frequency": 1,
            "time_distribution": {
              "690-692h": 1,
              "710-712h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 2
            },
            "time_per_day": {
              "2026-02-19": 1402.6395408333333
            },
            "time_count_per_day": {
              "2026-02-19": 2
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 701.32,
              "mode_time_hours": 711.0,
              "mode_frequency": 1,
              "time_distribution": {
                "690-692h": 1,
                "710-712h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 1402.6395408333333
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_870": {
      "overall": {
        "avg_time_hours": 63.65,
        "mode_time_hours": 63.0,
        "mode_frequency": 1,
        "time_distribution": {
          "62-64h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-23": 1
        },
        "time_per_day": {
          "2026-01-23": 63.652277222222224
        },
        "time_count_per_day": {
          "2026-01-23": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 63.65,
          "mode_time_hours": 63.0,
          "mode_frequency": 1,
          "time_distribution": {
            "62-64h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-23": 1
          },
          "time_per_day": {
            "2026-01-23": 63.652277222222224
          },
          "time_count_per_day": {
            "2026-01-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 63.65,
            "mode_time_hours": 63.0,
            "mode_frequency": 1,
            "time_distribution": {
              "62-64h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-23": 1
            },
            "time_per_day": {
              "2026-01-23": 63.652277222222224
            },
            "time_count_per_day": {
              "2026-01-23": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 63.65,
              "mode_time_hours": 63.0,
              "mode_frequency": 1,
              "time_distribution": {
                "62-64h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-23": 1
              },
              "time_per_day": {
                "2026-01-23": 63.652277222222224
              },
              "time_count_per_day": {
                "2026-01-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_871": {
      "overall": {
        "avg_time_hours": 492.5,
        "mode_time_hours": 493.0,
        "mode_frequency": 1,
        "time_distribution": {
          "492-494h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 492.4992758333333
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 492.5,
          "mode_time_hours": 493.0,
          "mode_frequency": 1,
          "time_distribution": {
            "492-494h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 492.4992758333333
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 492.5,
            "mode_time_hours": 493.0,
            "mode_frequency": 1,
            "time_distribution": {
              "492-494h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 492.4992758333333
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 492.5,
              "mode_time_hours": 493.0,
              "mode_frequency": 1,
              "time_distribution": {
                "492-494h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 492.4992758333333
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_873": {
      "overall": {
        "avg_time_hours": 693.97,
        "mode_time_hours": 693.0,
        "mode_frequency": 1,
        "time_distribution": {
          "692-694h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 693.9708544444444
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 693.97,
          "mode_time_hours": 693.0,
          "mode_frequency": 1,
          "time_distribution": {
            "692-694h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 693.9708544444444
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 693.97,
            "mode_time_hours": 693.0,
            "mode_frequency": 1,
            "time_distribution": {
              "692-694h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 693.9708544444444
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 693.97,
              "mode_time_hours": 693.0,
              "mode_frequency": 1,
              "time_distribution": {
                "692-694h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 693.9708544444444
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_874": {
      "overall": {
        "avg_time_hours": 108.98,
        "mode_time_hours": 193.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1,
          "192-194h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-28": 1,
          "2026-01-29": 1
        },
        "time_per_day": {
          "2026-01-28": 24.27848472222222,
          "2026-01-29": 193.68715500000002
        },
        "time_count_per_day": {
          "2026-01-28": 1,
          "2026-01-29": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 193.69,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "192-194h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-29": 1
          },
          "time_per_day": {
            "2026-01-29": 193.68715500000002
          },
          "time_count_per_day": {
            "2026-01-29": 1
          }
        },
        "P2": {
          "avg_time_hours": 24.28,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 24.27848472222222
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 108.98,
            "mode_time_hours": 193.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1,
              "192-194h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-28": 1,
              "2026-01-29": 1
            },
            "time_per_day": {
              "2026-01-28": 24.27848472222222,
              "2026-01-29": 193.68715500000002
            },
            "time_count_per_day": {
              "2026-01-28": 1,
              "2026-01-29": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 193.69,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "192-194h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-29": 1
              },
              "time_per_day": {
                "2026-01-29": 193.68715500000002
              },
              "time_count_per_day": {
                "2026-01-29": 1
              }
            },
            "P2": {
              "avg_time_hours": 24.28,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 24.27848472222222
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_879": {
      "overall": {
        "avg_time_hours": 1.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-21": 1,
          "2026-01-23": 1
        },
        "time_per_day": {
          "2026-01-21": 1.4658047222222221,
          "2026-01-23": 0.5920525
        },
        "time_count_per_day": {
          "2026-01-21": 1,
          "2026-01-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-21": 1,
            "2026-01-23": 1
          },
          "time_per_day": {
            "2026-01-21": 1.4658047222222221,
            "2026-01-23": 0.5920525
          },
          "time_count_per_day": {
            "2026-01-21": 1,
            "2026-01-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-21": 1,
              "2026-01-23": 1
            },
            "time_per_day": {
              "2026-01-21": 1.4658047222222221,
              "2026-01-23": 0.5920525
            },
            "time_count_per_day": {
              "2026-01-21": 1,
              "2026-01-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-21": 1,
                "2026-01-23": 1
              },
              "time_per_day": {
                "2026-01-21": 1.4658047222222221,
                "2026-01-23": 0.5920525
              },
              "time_count_per_day": {
                "2026-01-21": 1,
                "2026-01-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_880": {
      "overall": {
        "avg_time_hours": 690.55,
        "mode_time_hours": 691.0,
        "mode_frequency": 1,
        "time_distribution": {
          "690-692h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-19": 1,
          "2026-03-07": 1
        },
        "time_per_day": {
          "2026-02-19": 690.5496011111111
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-07": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 690.55,
          "mode_time_hours": 691.0,
          "mode_frequency": 1,
          "time_distribution": {
            "690-692h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 690.5496011111111
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 690.55,
            "mode_time_hours": 691.0,
            "mode_frequency": 1,
            "time_distribution": {
              "690-692h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 690.5496011111111
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 690.55,
              "mode_time_hours": 691.0,
              "mode_frequency": 1,
              "time_distribution": {
                "690-692h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 690.5496011111111
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_881": {
      "overall": {
        "avg_time_hours": 1.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-21": 1
        },
        "time_per_day": {
          "2026-01-21": 1.1503802777777776
        },
        "time_count_per_day": {
          "2026-01-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-21": 1
          },
          "time_per_day": {
            "2026-01-21": 1.1503802777777776
          },
          "time_count_per_day": {
            "2026-01-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-21": 1
            },
            "time_per_day": {
              "2026-01-21": 1.1503802777777776
            },
            "time_count_per_day": {
              "2026-01-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-21": 1
              },
              "time_per_day": {
                "2026-01-21": 1.1503802777777776
              },
              "time_count_per_day": {
                "2026-01-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_882": {
      "overall": {
        "avg_time_hours": 614.13,
        "mode_time_hours": 683.0,
        "mode_frequency": 1,
        "time_distribution": {
          "544-546h": 1,
          "682-684h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-19": 2,
          "2026-04-30": 1
        },
        "time_per_day": {
          "2026-02-19": 1228.2647897222223
        },
        "time_count_per_day": {
          "2026-02-19": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-30": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 614.13,
          "mode_time_hours": 683.0,
          "mode_frequency": 1,
          "time_distribution": {
            "544-546h": 1,
            "682-684h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 1228.2647897222223
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 614.13,
            "mode_time_hours": 683.0,
            "mode_frequency": 1,
            "time_distribution": {
              "544-546h": 1,
              "682-684h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 2
            },
            "time_per_day": {
              "2026-02-19": 1228.2647897222223
            },
            "time_count_per_day": {
              "2026-02-19": 2
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 614.13,
              "mode_time_hours": 683.0,
              "mode_frequency": 1,
              "time_distribution": {
                "544-546h": 1,
                "682-684h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 1228.2647897222223
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_883": {
      "overall": {
        "avg_time_hours": 2.01,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-22": 2
        },
        "time_per_day": {
          "2026-01-22": 4.017635833333333
        },
        "time_count_per_day": {
          "2026-01-22": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.01,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-22": 2
          },
          "time_per_day": {
            "2026-01-22": 4.017635833333333
          },
          "time_count_per_day": {
            "2026-01-22": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.01,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-22": 2
            },
            "time_per_day": {
              "2026-01-22": 4.017635833333333
            },
            "time_count_per_day": {
              "2026-01-22": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.01,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-22": 2
              },
              "time_per_day": {
                "2026-01-22": 4.017635833333333
              },
              "time_count_per_day": {
                "2026-01-22": 2
              }
            }
          }
        }
      }
    },
    "cliente_885": {
      "overall": {
        "avg_time_hours": 3.68,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-22": 1
        },
        "time_per_day": {
          "2026-01-22": 3.680655277777778
        },
        "time_count_per_day": {
          "2026-01-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.68,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-22": 1
          },
          "time_per_day": {
            "2026-01-22": 3.680655277777778
          },
          "time_count_per_day": {
            "2026-01-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.68,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-22": 1
            },
            "time_per_day": {
              "2026-01-22": 3.680655277777778
            },
            "time_count_per_day": {
              "2026-01-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.68,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-22": 1
              },
              "time_per_day": {
                "2026-01-22": 3.680655277777778
              },
              "time_count_per_day": {
                "2026-01-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_886": {
      "overall": {
        "avg_time_hours": 299.32,
        "mode_time_hours": 299.0,
        "mode_frequency": 1,
        "time_distribution": {
          "298-300h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-03-04": 1
        },
        "time_per_day": {
          "2026-02-03": 299.32131416666664
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 299.32,
          "mode_time_hours": 299.0,
          "mode_frequency": 1,
          "time_distribution": {
            "298-300h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 299.32131416666664
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 299.32,
            "mode_time_hours": 299.0,
            "mode_frequency": 1,
            "time_distribution": {
              "298-300h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 299.32131416666664
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 299.32,
              "mode_time_hours": 299.0,
              "mode_frequency": 1,
              "time_distribution": {
                "298-300h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 299.32131416666664
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_887": {
      "overall": {
        "avg_time_hours": 386.98,
        "mode_time_hours": 455.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "454-456h": 1,
          "544-546h": 1,
          "548-550h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-02-10": 454.83006138888885,
          "2026-02-19": 1092.5909652777777,
          "2026-03-20": 0.5153341666666666
        },
        "time_count_per_day": {
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 0.5153341666666666
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 454.83,
          "mode_time_hours": 455.0,
          "mode_frequency": 1,
          "time_distribution": {
            "454-456h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 454.83006138888885
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 546.3,
          "mode_time_hours": 549.0,
          "mode_frequency": 1,
          "time_distribution": {
            "544-546h": 1,
            "548-550h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 1092.5909652777777
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 386.98,
            "mode_time_hours": 455.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "454-456h": 1,
              "544-546h": 1,
              "548-550h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-02-10": 454.83006138888885,
              "2026-02-19": 1092.5909652777777,
              "2026-03-20": 0.5153341666666666
            },
            "time_count_per_day": {
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 0.5153341666666666
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 454.83,
              "mode_time_hours": 455.0,
              "mode_frequency": 1,
              "time_distribution": {
                "454-456h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 454.83006138888885
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 546.3,
              "mode_time_hours": 549.0,
              "mode_frequency": 1,
              "time_distribution": {
                "544-546h": 1,
                "548-550h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 1092.5909652777777
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_891": {
      "overall": {
        "avg_time_hours": 157.31,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "16-18h": 1,
          "354-356h": 1,
          "410-412h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-01-23": 1,
          "2026-02-25": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-04-14": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-01-23": 17.540969722222222,
          "2026-03-20": 411.2055241666667,
          "2026-03-27": 2.8440841666666667,
          "2026-04-14": 354.1969316666666,
          "2026-04-23": 0.7499852777777778
        },
        "time_count_per_day": {
          "2026-01-23": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-04-14": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 192.25,
          "mode_time_hours": 411.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "354-356h": 1,
            "410-412h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-03-30": 1,
            "2026-04-14": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-03-20": 411.2055241666667,
            "2026-03-27": 2.8440841666666667,
            "2026-04-14": 354.1969316666666,
            "2026-04-23": 0.7499852777777778
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-04-14": 1,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 17.54,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-23": 1
          },
          "time_per_day": {
            "2026-01-23": 17.540969722222222
          },
          "time_count_per_day": {
            "2026-01-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.31,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "16-18h": 1,
              "354-356h": 1,
              "410-412h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-23": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-14": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-01-23": 17.540969722222222,
              "2026-03-20": 411.2055241666667,
              "2026-03-27": 2.8440841666666667,
              "2026-04-14": 354.1969316666666,
              "2026-04-23": 0.7499852777777778
            },
            "time_count_per_day": {
              "2026-01-23": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-04-14": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 192.25,
              "mode_time_hours": 411.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "354-356h": 1,
                "410-412h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-14": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-03-20": 411.2055241666667,
                "2026-03-27": 2.8440841666666667,
                "2026-04-14": 354.1969316666666,
                "2026-04-23": 0.7499852777777778
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-04-14": 1,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 17.54,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-23": 1
              },
              "time_per_day": {
                "2026-01-23": 17.540969722222222
              },
              "time_count_per_day": {
                "2026-01-23": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-25": 1,
              "2026-03-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-25": 1,
                "2026-03-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_892": {
      "overall": {
        "avg_time_hours": 125.94,
        "mode_time_hours": 127.0,
        "mode_frequency": 1,
        "time_distribution": {
          "124-126h": 1,
          "126-128h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 2
        },
        "time_per_day": {
          "2026-01-27": 251.88763666666665
        },
        "time_count_per_day": {
          "2026-01-27": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 125.94,
          "mode_time_hours": 127.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1,
            "126-128h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 2
          },
          "time_per_day": {
            "2026-01-27": 251.88763666666665
          },
          "time_count_per_day": {
            "2026-01-27": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 125.94,
            "mode_time_hours": 127.0,
            "mode_frequency": 1,
            "time_distribution": {
              "124-126h": 1,
              "126-128h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 2
            },
            "time_per_day": {
              "2026-01-27": 251.88763666666665
            },
            "time_count_per_day": {
              "2026-01-27": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 125.94,
              "mode_time_hours": 127.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1,
                "126-128h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-27": 2
              },
              "time_per_day": {
                "2026-01-27": 251.88763666666665
              },
              "time_count_per_day": {
                "2026-01-27": 2
              }
            }
          }
        }
      }
    },
    "cliente_893": {
      "overall": {
        "avg_time_hours": 307.16,
        "mode_time_hours": 307.0,
        "mode_frequency": 1,
        "time_distribution": {
          "306-308h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-04": 1
        },
        "time_per_day": {
          "2026-02-04": 307.161915
        },
        "time_count_per_day": {
          "2026-02-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 307.16,
          "mode_time_hours": 307.0,
          "mode_frequency": 1,
          "time_distribution": {
            "306-308h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 307.161915
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 307.16,
            "mode_time_hours": 307.0,
            "mode_frequency": 1,
            "time_distribution": {
              "306-308h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-04": 1
            },
            "time_per_day": {
              "2026-02-04": 307.161915
            },
            "time_count_per_day": {
              "2026-02-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 307.16,
              "mode_time_hours": 307.0,
              "mode_frequency": 1,
              "time_distribution": {
                "306-308h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 307.161915
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_894": {
      "overall": {
        "avg_time_hours": 184.05,
        "mode_time_hours": 119.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "6-8h": 1,
          "118-120h": 2,
          "138-140h": 1,
          "308-310h": 1,
          "344-346h": 1,
          "616-618h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2026-01-28": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-21": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-17": 1,
          "2026-03-23": 1,
          "2026-06-06": 2
        },
        "time_per_day": {
          "2026-01-28": 138.72682166666667,
          "2026-02-12": 344.68310972222224,
          "2026-02-18": 6.884706944444444,
          "2026-02-21": 1.49455,
          "2026-02-24": 2.0498919444444446,
          "2026-02-25": 237.07660416666667,
          "2026-03-17": 309.1072105555556,
          "2026-03-23": 616.4679508333334
        },
        "time_count_per_day": {
          "2026-01-28": 1,
          "2026-02-12": 1,
          "2026-02-18": 1,
          "2026-02-21": 1,
          "2026-02-24": 1,
          "2026-02-25": 2,
          "2026-03-17": 1,
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 189.72,
          "mode_time_hours": 119.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "6-8h": 1,
            "118-120h": 2,
            "308-310h": 1,
            "344-346h": 1,
            "616-618h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-17": 1,
            "2026-03-23": 1,
            "2026-06-06": 2
          },
          "time_per_day": {
            "2026-02-12": 344.68310972222224,
            "2026-02-18": 6.884706944444444,
            "2026-02-21": 1.49455,
            "2026-02-24": 2.0498919444444446,
            "2026-02-25": 237.07660416666667,
            "2026-03-17": 309.1072105555556,
            "2026-03-23": 616.4679508333334
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-02-18": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-02-25": 2,
            "2026-03-17": 1,
            "2026-03-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 138.73,
          "mode_time_hours": 139.0,
          "mode_frequency": 1,
          "time_distribution": {
            "138-140h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 138.72682166666667
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 184.05,
            "mode_time_hours": 119.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "6-8h": 1,
              "118-120h": 2,
              "138-140h": 1,
              "308-310h": 1,
              "344-346h": 1,
              "616-618h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-01-28": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-21": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-17": 1,
              "2026-03-23": 1
            },
            "time_per_day": {
              "2026-01-28": 138.72682166666667,
              "2026-02-12": 344.68310972222224,
              "2026-02-18": 6.884706944444444,
              "2026-02-21": 1.49455,
              "2026-02-24": 2.0498919444444446,
              "2026-02-25": 237.07660416666667,
              "2026-03-17": 309.1072105555556,
              "2026-03-23": 616.4679508333334
            },
            "time_count_per_day": {
              "2026-01-28": 1,
              "2026-02-12": 1,
              "2026-02-18": 1,
              "2026-02-21": 1,
              "2026-02-24": 1,
              "2026-02-25": 2,
              "2026-03-17": 1,
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 189.72,
              "mode_time_hours": 119.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "6-8h": 1,
                "118-120h": 2,
                "308-310h": 1,
                "344-346h": 1,
                "616-618h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-17": 1,
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-02-12": 344.68310972222224,
                "2026-02-18": 6.884706944444444,
                "2026-02-21": 1.49455,
                "2026-02-24": 2.0498919444444446,
                "2026-02-25": 237.07660416666667,
                "2026-03-17": 309.1072105555556,
                "2026-03-23": 616.4679508333334
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-02-18": 1,
                "2026-02-21": 1,
                "2026-02-24": 1,
                "2026-02-25": 2,
                "2026-03-17": 1,
                "2026-03-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 138.73,
              "mode_time_hours": 139.0,
              "mode_frequency": 1,
              "time_distribution": {
                "138-140h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 138.72682166666667
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_895": {
      "overall": {
        "avg_time_hours": 119.46,
        "mode_time_hours": 119.0,
        "mode_frequency": 1,
        "time_distribution": {
          "118-120h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2026-01-27": 119.46002833333334
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 119.46,
          "mode_time_hours": 119.0,
          "mode_frequency": 1,
          "time_distribution": {
            "118-120h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-05-15": 1
          },
          "time_per_day": {
            "2026-01-27": 119.46002833333334
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 119.46,
            "mode_time_hours": 119.0,
            "mode_frequency": 1,
            "time_distribution": {
              "118-120h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 119.46002833333334
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 119.46,
              "mode_time_hours": 119.0,
              "mode_frequency": 1,
              "time_distribution": {
                "118-120h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 119.46002833333334
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-15": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_899": {
      "overall": {
        "avg_time_hours": 0.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-23": 2
        },
        "time_per_day": {
          "2026-01-23": 0.1533525
        },
        "time_count_per_day": {
          "2026-01-23": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-23": 2
          },
          "time_per_day": {
            "2026-01-23": 0.1533525
          },
          "time_count_per_day": {
            "2026-01-23": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-23": 2
            },
            "time_per_day": {
              "2026-01-23": 0.1533525
            },
            "time_count_per_day": {
              "2026-01-23": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-23": 2
              },
              "time_per_day": {
                "2026-01-23": 0.1533525
              },
              "time_count_per_day": {
                "2026-01-23": 2
              }
            }
          }
        }
      }
    },
    "cliente_900": {
      "overall": {
        "avg_time_hours": 642.17,
        "mode_time_hours": 643.0,
        "mode_frequency": 1,
        "time_distribution": {
          "642-644h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 642.1698827777778
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 642.17,
          "mode_time_hours": 643.0,
          "mode_frequency": 1,
          "time_distribution": {
            "642-644h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 642.1698827777778
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 642.17,
            "mode_time_hours": 643.0,
            "mode_frequency": 1,
            "time_distribution": {
              "642-644h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 642.1698827777778
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 642.17,
              "mode_time_hours": 643.0,
              "mode_frequency": 1,
              "time_distribution": {
                "642-644h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 642.1698827777778
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_901": {
      "overall": {
        "avg_time_hours": 339.29,
        "mode_time_hours": 601.0,
        "mode_frequency": 1,
        "time_distribution": {
          "76-78h": 1,
          "600-602h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-26": 1,
          "2026-02-17": 1
        },
        "time_per_day": {
          "2026-01-26": 77.13830166666666,
          "2026-02-17": 601.4474633333333
        },
        "time_count_per_day": {
          "2026-01-26": 1,
          "2026-02-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 339.29,
          "mode_time_hours": 601.0,
          "mode_frequency": 1,
          "time_distribution": {
            "76-78h": 1,
            "600-602h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-02-17": 1
          },
          "time_per_day": {
            "2026-01-26": 77.13830166666666,
            "2026-02-17": 601.4474633333333
          },
          "time_count_per_day": {
            "2026-01-26": 1,
            "2026-02-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 339.29,
            "mode_time_hours": 601.0,
            "mode_frequency": 1,
            "time_distribution": {
              "76-78h": 1,
              "600-602h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-26": 1,
              "2026-02-17": 1
            },
            "time_per_day": {
              "2026-01-26": 77.13830166666666,
              "2026-02-17": 601.4474633333333
            },
            "time_count_per_day": {
              "2026-01-26": 1,
              "2026-02-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 339.29,
              "mode_time_hours": 601.0,
              "mode_frequency": 1,
              "time_distribution": {
                "76-78h": 1,
                "600-602h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-26": 1,
                "2026-02-17": 1
              },
              "time_per_day": {
                "2026-01-26": 77.13830166666666,
                "2026-02-17": 601.4474633333333
              },
              "time_count_per_day": {
                "2026-01-26": 1,
                "2026-02-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_902": {
      "overall": {
        "avg_time_hours": 272.35,
        "mode_time_hours": 1085.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "8-10h": 1,
          "42-44h": 1,
          "220-222h": 1,
          "1084-1086h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-01-26": 1,
          "2026-02-09": 1,
          "2026-02-18": 1,
          "2026-03-09": 1,
          "2026-04-17": 1
        },
        "time_per_day": {
          "2026-01-26": 4.229728888888888,
          "2026-02-09": 8.328354166666667,
          "2026-02-18": 220.8054561111111,
          "2026-03-09": 1085.856243611111,
          "2026-04-17": 42.5196725
        },
        "time_count_per_day": {
          "2026-01-26": 1,
          "2026-02-09": 1,
          "2026-02-18": 1,
          "2026-03-09": 1,
          "2026-04-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 285.23,
          "mode_time_hours": 1085.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "8-10h": 1,
            "42-44h": 1,
            "1084-1086h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-02-09": 1,
            "2026-03-09": 1,
            "2026-04-17": 1
          },
          "time_per_day": {
            "2026-01-26": 4.229728888888888,
            "2026-02-09": 8.328354166666667,
            "2026-03-09": 1085.856243611111,
            "2026-04-17": 42.5196725
          },
          "time_count_per_day": {
            "2026-01-26": 1,
            "2026-02-09": 1,
            "2026-03-09": 1,
            "2026-04-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 220.81,
          "mode_time_hours": 221.0,
          "mode_frequency": 1,
          "time_distribution": {
            "220-222h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 220.8054561111111
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 272.35,
            "mode_time_hours": 1085.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "8-10h": 1,
              "42-44h": 1,
              "220-222h": 1,
              "1084-1086h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-26": 1,
              "2026-02-09": 1,
              "2026-02-18": 1,
              "2026-03-09": 1,
              "2026-04-17": 1
            },
            "time_per_day": {
              "2026-01-26": 4.229728888888888,
              "2026-02-09": 8.328354166666667,
              "2026-02-18": 220.8054561111111,
              "2026-03-09": 1085.856243611111,
              "2026-04-17": 42.5196725
            },
            "time_count_per_day": {
              "2026-01-26": 1,
              "2026-02-09": 1,
              "2026-02-18": 1,
              "2026-03-09": 1,
              "2026-04-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 285.23,
              "mode_time_hours": 1085.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "8-10h": 1,
                "42-44h": 1,
                "1084-1086h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-26": 1,
                "2026-02-09": 1,
                "2026-03-09": 1,
                "2026-04-17": 1
              },
              "time_per_day": {
                "2026-01-26": 4.229728888888888,
                "2026-02-09": 8.328354166666667,
                "2026-03-09": 1085.856243611111,
                "2026-04-17": 42.5196725
              },
              "time_count_per_day": {
                "2026-01-26": 1,
                "2026-02-09": 1,
                "2026-03-09": 1,
                "2026-04-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 220.81,
              "mode_time_hours": 221.0,
              "mode_frequency": 1,
              "time_distribution": {
                "220-222h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 220.8054561111111
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_903": {
      "overall": {
        "avg_time_hours": 1.78,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-23": 1,
          "2026-03-31": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-01-23": 1.0704027777777778,
          "2026-05-29": 2.4955652777777777
        },
        "time_count_per_day": {
          "2026-01-23": 1,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-23": 1,
            "2026-03-31": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-01-23": 1.0704027777777778,
            "2026-05-29": 2.4955652777777777
          },
          "time_count_per_day": {
            "2026-01-23": 1,
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.78,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-23": 1,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-01-23": 1.0704027777777778,
              "2026-05-29": 2.4955652777777777
            },
            "time_count_per_day": {
              "2026-01-23": 1,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-23": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-01-23": 1.0704027777777778,
                "2026-05-29": 2.4955652777777777
              },
              "time_count_per_day": {
                "2026-01-23": 1,
                "2026-05-29": 1
              }
            }
          }
        },
        "Cuba Remarcado": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-31": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_904": {
      "overall": {
        "avg_time_hours": 101.21,
        "mode_time_hours": 101.0,
        "mode_frequency": 1,
        "time_distribution": {
          "100-102h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-27": 1
        },
        "time_per_day": {
          "2026-01-27": 101.2053125
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 101.21,
          "mode_time_hours": 101.0,
          "mode_frequency": 1,
          "time_distribution": {
            "100-102h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 101.2053125
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 101.21,
            "mode_time_hours": 101.0,
            "mode_frequency": 1,
            "time_distribution": {
              "100-102h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 101.2053125
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 101.21,
              "mode_time_hours": 101.0,
              "mode_frequency": 1,
              "time_distribution": {
                "100-102h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 101.2053125
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_905": {
      "overall": {
        "avg_time_hours": 99.68,
        "mode_time_hours": 99.0,
        "mode_frequency": 2,
        "time_distribution": {
          "98-100h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 2
        },
        "time_per_day": {
          "2026-01-27": 199.36939055555558
        },
        "time_count_per_day": {
          "2026-01-27": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 99.68,
          "mode_time_hours": 99.0,
          "mode_frequency": 2,
          "time_distribution": {
            "98-100h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 2
          },
          "time_per_day": {
            "2026-01-27": 199.36939055555558
          },
          "time_count_per_day": {
            "2026-01-27": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 99.68,
            "mode_time_hours": 99.0,
            "mode_frequency": 2,
            "time_distribution": {
              "98-100h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 2
            },
            "time_per_day": {
              "2026-01-27": 199.36939055555558
            },
            "time_count_per_day": {
              "2026-01-27": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 99.68,
              "mode_time_hours": 99.0,
              "mode_frequency": 2,
              "time_distribution": {
                "98-100h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-27": 2
              },
              "time_per_day": {
                "2026-01-27": 199.36939055555558
              },
              "time_count_per_day": {
                "2026-01-27": 2
              }
            }
          }
        }
      }
    },
    "cliente_906": {
      "overall": {
        "avg_time_hours": 637.25,
        "mode_time_hours": 637.0,
        "mode_frequency": 1,
        "time_distribution": {
          "636-638h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 637.25266
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 637.25,
          "mode_time_hours": 637.0,
          "mode_frequency": 1,
          "time_distribution": {
            "636-638h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 637.25266
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 637.25,
            "mode_time_hours": 637.0,
            "mode_frequency": 1,
            "time_distribution": {
              "636-638h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 637.25266
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 637.25,
              "mode_time_hours": 637.0,
              "mode_frequency": 1,
              "time_distribution": {
                "636-638h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 637.25266
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_907": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-23": 1
        },
        "time_per_day": {
          "2026-01-23": 0.012109444444444445
        },
        "time_count_per_day": {
          "2026-01-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-23": 1
          },
          "time_per_day": {
            "2026-01-23": 0.012109444444444445
          },
          "time_count_per_day": {
            "2026-01-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-23": 1
            },
            "time_per_day": {
              "2026-01-23": 0.012109444444444445
            },
            "time_count_per_day": {
              "2026-01-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-23": 1
              },
              "time_per_day": {
                "2026-01-23": 0.012109444444444445
              },
              "time_count_per_day": {
                "2026-01-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_908": {
      "overall": {
        "avg_time_hours": 0.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-24": 1
        },
        "time_per_day": {
          "2026-01-24": 0.09553694444444444
        },
        "time_count_per_day": {
          "2026-01-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.1,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-24": 1
          },
          "time_per_day": {
            "2026-01-24": 0.09553694444444444
          },
          "time_count_per_day": {
            "2026-01-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-24": 1
            },
            "time_per_day": {
              "2026-01-24": 0.09553694444444444
            },
            "time_count_per_day": {
              "2026-01-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.1,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-24": 1
              },
              "time_per_day": {
                "2026-01-24": 0.09553694444444444
              },
              "time_count_per_day": {
                "2026-01-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_909": {
      "overall": {
        "avg_time_hours": 0.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-26": 2
        },
        "time_per_day": {
          "2026-01-26": 1.8711291666666665
        },
        "time_count_per_day": {
          "2026-01-26": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-26": 2
          },
          "time_per_day": {
            "2026-01-26": 1.8711291666666665
          },
          "time_count_per_day": {
            "2026-01-26": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-26": 2
            },
            "time_per_day": {
              "2026-01-26": 1.8711291666666665
            },
            "time_count_per_day": {
              "2026-01-26": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-26": 2
              },
              "time_per_day": {
                "2026-01-26": 1.8711291666666665
              },
              "time_count_per_day": {
                "2026-01-26": 2
              }
            }
          }
        }
      }
    },
    "cliente_910": {
      "overall": {
        "avg_time_hours": 162.84,
        "mode_time_hours": 37.0,
        "mode_frequency": 1,
        "time_distribution": {
          "36-38h": 1,
          "288-290h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 1,
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-01-27": 36.26905,
          "2026-02-09": 289.4204075
        },
        "time_count_per_day": {
          "2026-01-27": 1,
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 162.84,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1,
            "288-290h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-01-27": 36.26905,
            "2026-02-09": 289.4204075
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 162.84,
            "mode_time_hours": 37.0,
            "mode_frequency": 1,
            "time_distribution": {
              "36-38h": 1,
              "288-290h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 1,
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-01-27": 36.26905,
              "2026-02-09": 289.4204075
            },
            "time_count_per_day": {
              "2026-01-27": 1,
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 162.84,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1,
                "288-290h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-01-27": 36.26905,
                "2026-02-09": 289.4204075
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_911": {
      "overall": {
        "avg_time_hours": 276.3,
        "mode_time_hours": 277.0,
        "mode_frequency": 1,
        "time_distribution": {
          "276-278h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-06": 1
        },
        "time_per_day": {
          "2026-02-06": 276.2963819444444
        },
        "time_count_per_day": {
          "2026-02-06": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 276.3,
          "mode_time_hours": 277.0,
          "mode_frequency": 1,
          "time_distribution": {
            "276-278h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 276.2963819444444
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 276.3,
            "mode_time_hours": 277.0,
            "mode_frequency": 1,
            "time_distribution": {
              "276-278h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-06": 1
            },
            "time_per_day": {
              "2026-02-06": 276.2963819444444
            },
            "time_count_per_day": {
              "2026-02-06": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 276.3,
              "mode_time_hours": 277.0,
              "mode_frequency": 1,
              "time_distribution": {
                "276-278h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 276.2963819444444
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_912": {
      "overall": {
        "avg_time_hours": 365.21,
        "mode_time_hours": 419.0,
        "mode_frequency": 1,
        "time_distribution": {
          "310-312h": 1,
          "418-420h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-05-13": 1
        },
        "time_per_day": {
          "2026-02-12": 419.6022111111111,
          "2026-05-13": 310.8126613888889
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 365.21,
          "mode_time_hours": 419.0,
          "mode_frequency": 1,
          "time_distribution": {
            "310-312h": 1,
            "418-420h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-02-12": 419.6022111111111,
            "2026-05-13": 310.8126613888889
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 365.21,
            "mode_time_hours": 419.0,
            "mode_frequency": 1,
            "time_distribution": {
              "310-312h": 1,
              "418-420h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-02-12": 419.6022111111111,
              "2026-05-13": 310.8126613888889
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 365.21,
              "mode_time_hours": 419.0,
              "mode_frequency": 1,
              "time_distribution": {
                "310-312h": 1,
                "418-420h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-02-12": 419.6022111111111,
                "2026-05-13": 310.8126613888889
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_913": {
      "overall": {
        "avg_time_hours": 4.59,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-26": 1
        },
        "time_per_day": {
          "2026-01-26": 4.594113055555556
        },
        "time_count_per_day": {
          "2026-01-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.59,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-26": 1
          },
          "time_per_day": {
            "2026-01-26": 4.594113055555556
          },
          "time_count_per_day": {
            "2026-01-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.59,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-26": 1
            },
            "time_per_day": {
              "2026-01-26": 4.594113055555556
            },
            "time_count_per_day": {
              "2026-01-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.59,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-26": 1
              },
              "time_per_day": {
                "2026-01-26": 4.594113055555556
              },
              "time_count_per_day": {
                "2026-01-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_209": {
      "overall": {
        "avg_time_hours": 552.46,
        "mode_time_hours": 553.0,
        "mode_frequency": 1,
        "time_distribution": {
          "552-554h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 552.4631633333333
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 552.46,
          "mode_time_hours": 553.0,
          "mode_frequency": 1,
          "time_distribution": {
            "552-554h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 552.4631633333333
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 552.46,
            "mode_time_hours": 553.0,
            "mode_frequency": 1,
            "time_distribution": {
              "552-554h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 552.4631633333333
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 552.46,
              "mode_time_hours": 553.0,
              "mode_frequency": 1,
              "time_distribution": {
                "552-554h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 552.4631633333333
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_920": {
      "overall": {
        "avg_time_hours": 411.25,
        "mode_time_hours": 411.0,
        "mode_frequency": 1,
        "time_distribution": {
          "410-412h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 411.24832805555553
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 411.25,
          "mode_time_hours": 411.0,
          "mode_frequency": 1,
          "time_distribution": {
            "410-412h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 411.24832805555553
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 411.25,
            "mode_time_hours": 411.0,
            "mode_frequency": 1,
            "time_distribution": {
              "410-412h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 411.24832805555553
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 411.25,
              "mode_time_hours": 411.0,
              "mode_frequency": 1,
              "time_distribution": {
                "410-412h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 411.24832805555553
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_921": {
      "overall": {
        "avg_time_hours": 0.73,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "2-4h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-01-26": 1,
          "2026-02-02": 1,
          "2026-02-25": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-01-26": 2.632969166666667,
          "2026-02-02": 0.011660555555555556,
          "2026-02-25": 0.006525555555555556,
          "2026-03-02": 0.01348638888888889,
          "2026-03-06": 0.018699999999999998,
          "2026-04-23": 1.6785833333333333
        },
        "time_count_per_day": {
          "2026-01-26": 1,
          "2026-02-02": 1,
          "2026-02-25": 1,
          "2026-03-02": 1,
          "2026-03-06": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-02-02": 1,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-01-26": 2.632969166666667,
            "2026-02-02": 0.011660555555555556,
            "2026-02-25": 0.006525555555555556,
            "2026-03-02": 0.01348638888888889,
            "2026-03-06": 0.018699999999999998,
            "2026-04-23": 1.6785833333333333
          },
          "time_count_per_day": {
            "2026-01-26": 1,
            "2026-02-02": 1,
            "2026-02-25": 1,
            "2026-03-02": 1,
            "2026-03-06": 1,
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.73,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "2-4h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-01-26": 1,
              "2026-02-02": 1,
              "2026-02-25": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-01-26": 2.632969166666667,
              "2026-02-02": 0.011660555555555556,
              "2026-02-25": 0.006525555555555556,
              "2026-03-02": 0.01348638888888889,
              "2026-03-06": 0.018699999999999998,
              "2026-04-23": 1.6785833333333333
            },
            "time_count_per_day": {
              "2026-01-26": 1,
              "2026-02-02": 1,
              "2026-02-25": 1,
              "2026-03-02": 1,
              "2026-03-06": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "2-4h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-01-26": 1,
                "2026-02-02": 1,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-01-26": 2.632969166666667,
                "2026-02-02": 0.011660555555555556,
                "2026-02-25": 0.006525555555555556,
                "2026-03-02": 0.01348638888888889,
                "2026-03-06": 0.018699999999999998,
                "2026-04-23": 1.6785833333333333
              },
              "time_count_per_day": {
                "2026-01-26": 1,
                "2026-02-02": 1,
                "2026-02-25": 1,
                "2026-03-02": 1,
                "2026-03-06": 1,
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_922": {
      "overall": {
        "avg_time_hours": 119.34,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "22-24h": 1,
          "48-50h": 1,
          "54-56h": 1,
          "162-164h": 1,
          "542-544h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-01-26": 1,
          "2026-01-29": 1,
          "2026-02-05": 1,
          "2026-02-19": 1,
          "2026-02-24": 1,
          "2026-02-27": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-01-26": 3.111515277777778,
          "2026-01-29": 49.30772527777778,
          "2026-02-05": 54.63424944444445,
          "2026-02-19": 542.7914763888889,
          "2026-02-24": 0.17148611111111112,
          "2026-02-27": 22.607594722222224,
          "2026-05-26": 162.76183749999998
        },
        "time_count_per_day": {
          "2026-01-26": 1,
          "2026-01-29": 1,
          "2026-02-05": 1,
          "2026-02-19": 1,
          "2026-02-24": 1,
          "2026-02-27": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 162.76,
          "mode_time_hours": 163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "162-164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 162.76183749999998
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 8.63,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "22-24h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-26": 1,
            "2026-02-24": 1,
            "2026-02-27": 1
          },
          "time_per_day": {
            "2026-01-26": 3.111515277777778,
            "2026-02-24": 0.17148611111111112,
            "2026-02-27": 22.607594722222224
          },
          "time_count_per_day": {
            "2026-01-26": 1,
            "2026-02-24": 1,
            "2026-02-27": 1
          }
        },
        "P3": {
          "avg_time_hours": 51.97,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1,
            "54-56h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-29": 1,
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-01-29": 49.30772527777778,
            "2026-02-05": 54.63424944444445
          },
          "time_count_per_day": {
            "2026-01-29": 1,
            "2026-02-05": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 542.79,
          "mode_time_hours": 543.0,
          "mode_frequency": 1,
          "time_distribution": {
            "542-544h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 542.7914763888889
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 119.34,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "22-24h": 1,
              "48-50h": 1,
              "54-56h": 1,
              "162-164h": 1,
              "542-544h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-01-26": 1,
              "2026-01-29": 1,
              "2026-02-05": 1,
              "2026-02-19": 1,
              "2026-02-24": 1,
              "2026-02-27": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-01-26": 3.111515277777778,
              "2026-01-29": 49.30772527777778,
              "2026-02-05": 54.63424944444445,
              "2026-02-19": 542.7914763888889,
              "2026-02-24": 0.17148611111111112,
              "2026-02-27": 22.607594722222224,
              "2026-05-26": 162.76183749999998
            },
            "time_count_per_day": {
              "2026-01-26": 1,
              "2026-01-29": 1,
              "2026-02-05": 1,
              "2026-02-19": 1,
              "2026-02-24": 1,
              "2026-02-27": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 162.76,
              "mode_time_hours": 163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "162-164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 162.76183749999998
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 8.63,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "22-24h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-26": 1,
                "2026-02-24": 1,
                "2026-02-27": 1
              },
              "time_per_day": {
                "2026-01-26": 3.111515277777778,
                "2026-02-24": 0.17148611111111112,
                "2026-02-27": 22.607594722222224
              },
              "time_count_per_day": {
                "2026-01-26": 1,
                "2026-02-24": 1,
                "2026-02-27": 1
              }
            },
            "P3": {
              "avg_time_hours": 51.97,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1,
                "54-56h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-29": 1,
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-01-29": 49.30772527777778,
                "2026-02-05": 54.63424944444445
              },
              "time_count_per_day": {
                "2026-01-29": 1,
                "2026-02-05": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 542.79,
              "mode_time_hours": 543.0,
              "mode_frequency": 1,
              "time_distribution": {
                "542-544h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 542.7914763888889
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_923": {
      "overall": {
        "avg_time_hours": 352.23,
        "mode_time_hours": 567.0,
        "mode_frequency": 1,
        "time_distribution": {
          "138-140h": 1,
          "566-568h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-03": 138.41717416666665,
          "2026-02-19": 566.0470658333334
        },
        "time_count_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 138.42,
          "mode_time_hours": 139.0,
          "mode_frequency": 1,
          "time_distribution": {
            "138-140h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 138.41717416666665
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 566.05,
          "mode_time_hours": 567.0,
          "mode_frequency": 1,
          "time_distribution": {
            "566-568h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 566.0470658333334
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 352.23,
            "mode_time_hours": 567.0,
            "mode_frequency": 1,
            "time_distribution": {
              "138-140h": 1,
              "566-568h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-03": 138.41717416666665,
              "2026-02-19": 566.0470658333334
            },
            "time_count_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 138.42,
              "mode_time_hours": 139.0,
              "mode_frequency": 1,
              "time_distribution": {
                "138-140h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 138.41717416666665
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 566.05,
              "mode_time_hours": 567.0,
              "mode_frequency": 1,
              "time_distribution": {
                "566-568h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 566.0470658333334
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_924": {
      "overall": {
        "avg_time_hours": 13.47,
        "mode_time_hours": 13.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-27": 1
        },
        "time_per_day": {
          "2026-01-27": 13.472807222222222
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 13.47,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 13.472807222222222
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.47,
            "mode_time_hours": 13.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 13.472807222222222
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 13.47,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 13.472807222222222
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_925": {
      "overall": {
        "avg_time_hours": 293.9,
        "mode_time_hours": 23.0,
        "mode_frequency": 1,
        "time_distribution": {
          "22-24h": 1,
          "564-566h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-01-27": 23.23428111111111,
          "2026-02-19": 564.5624308333333
        },
        "time_count_per_day": {
          "2026-01-27": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 23.23,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 23.23428111111111
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 564.56,
          "mode_time_hours": 565.0,
          "mode_frequency": 1,
          "time_distribution": {
            "564-566h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 564.5624308333333
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 293.9,
            "mode_time_hours": 23.0,
            "mode_frequency": 1,
            "time_distribution": {
              "22-24h": 1,
              "564-566h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-01-27": 23.23428111111111,
              "2026-02-19": 564.5624308333333
            },
            "time_count_per_day": {
              "2026-01-27": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 23.23,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 23.23428111111111
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 564.56,
              "mode_time_hours": 565.0,
              "mode_frequency": 1,
              "time_distribution": {
                "564-566h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 564.5624308333333
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_928": {
      "overall": {
        "avg_time_hours": 1.6,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-01-27": 3.175294722222222,
          "2026-05-30": 0.016709444444444447
        },
        "time_count_per_day": {
          "2026-01-27": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.6,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-01-27": 3.175294722222222,
            "2026-05-30": 0.016709444444444447
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.6,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-01-27": 3.175294722222222,
              "2026-05-30": 0.016709444444444447
            },
            "time_count_per_day": {
              "2026-01-27": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.6,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-01-27": 3.175294722222222,
                "2026-05-30": 0.016709444444444447
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_929": {
      "overall": {
        "avg_time_hours": 8.98,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-27": 1
        },
        "time_per_day": {
          "2026-01-27": 8.983445277777777
        },
        "time_count_per_day": {
          "2026-01-27": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 8.98,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {
            "2026-01-27": 8.983445277777777
          },
          "time_count_per_day": {
            "2026-01-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.98,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-27": 1
            },
            "time_per_day": {
              "2026-01-27": 8.983445277777777
            },
            "time_count_per_day": {
              "2026-01-27": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.98,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-27": 1
              },
              "time_per_day": {
                "2026-01-27": 8.983445277777777
              },
              "time_count_per_day": {
                "2026-01-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_931": {
      "overall": {
        "avg_time_hours": 1026.51,
        "mode_time_hours": 1027.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1026-1028h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-11": 1
        },
        "time_per_day": {
          "2026-03-11": 1026.5141986111112
        },
        "time_count_per_day": {
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1026.51,
          "mode_time_hours": 1027.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1026-1028h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-03-11": 1026.5141986111112
          },
          "time_count_per_day": {
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1026.51,
            "mode_time_hours": 1027.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1026-1028h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-11": 1
            },
            "time_per_day": {
              "2026-03-11": 1026.5141986111112
            },
            "time_count_per_day": {
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1026.51,
              "mode_time_hours": 1027.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1026-1028h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-03-11": 1026.5141986111112
              },
              "time_count_per_day": {
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_932": {
      "overall": {
        "avg_time_hours": 24.26,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-28": 1
        },
        "time_per_day": {
          "2026-01-28": 24.25604305555556
        },
        "time_count_per_day": {
          "2026-01-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.26,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 24.25604305555556
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.26,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-28": 1
            },
            "time_per_day": {
              "2026-01-28": 24.25604305555556
            },
            "time_count_per_day": {
              "2026-01-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.26,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 24.25604305555556
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_933": {
      "overall": {
        "avg_time_hours": 240.13,
        "mode_time_hours": 241.0,
        "mode_frequency": 1,
        "time_distribution": {
          "240-242h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-06": 1
        },
        "time_per_day": {
          "2026-02-06": 240.13262805555556
        },
        "time_count_per_day": {
          "2026-02-06": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 240.13,
          "mode_time_hours": 241.0,
          "mode_frequency": 1,
          "time_distribution": {
            "240-242h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 240.13262805555556
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 240.13,
            "mode_time_hours": 241.0,
            "mode_frequency": 1,
            "time_distribution": {
              "240-242h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-06": 1
            },
            "time_per_day": {
              "2026-02-06": 240.13262805555556
            },
            "time_count_per_day": {
              "2026-02-06": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 240.13,
              "mode_time_hours": 241.0,
              "mode_frequency": 1,
              "time_distribution": {
                "240-242h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 240.13262805555556
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_934": {
      "overall": {
        "avg_time_hours": 58.89,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "116-118h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-27": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-01-27": 0.1878963888888889,
          "2026-05-04": 117.58971694444445
        },
        "time_count_per_day": {
          "2026-01-27": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 58.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "116-118h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-27": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-01-27": 0.1878963888888889,
            "2026-05-04": 117.58971694444445
          },
          "time_count_per_day": {
            "2026-01-27": 1,
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 58.89,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "116-118h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-27": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-01-27": 0.1878963888888889,
              "2026-05-04": 117.58971694444445
            },
            "time_count_per_day": {
              "2026-01-27": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 58.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "116-118h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-27": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-01-27": 0.1878963888888889,
                "2026-05-04": 117.58971694444445
              },
              "time_count_per_day": {
                "2026-01-27": 1,
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_936": {
      "overall": {
        "avg_time_hours": 13.68,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "20-22h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-28": 1,
          "2026-04-30": 1
        },
        "time_per_day": {
          "2026-01-28": 21.209949166666664,
          "2026-04-30": 6.145572777777779
        },
        "time_count_per_day": {
          "2026-01-28": 1,
          "2026-04-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.15,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-30": 1
          },
          "time_per_day": {
            "2026-04-30": 6.145572777777779
          },
          "time_count_per_day": {
            "2026-04-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 21.21,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 21.209949166666664
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.68,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "20-22h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-28": 1,
              "2026-04-30": 1
            },
            "time_per_day": {
              "2026-01-28": 21.209949166666664,
              "2026-04-30": 6.145572777777779
            },
            "time_count_per_day": {
              "2026-01-28": 1,
              "2026-04-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.15,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {
                "2026-04-30": 6.145572777777779
              },
              "time_count_per_day": {
                "2026-04-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 21.21,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 21.209949166666664
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_937": {
      "overall": {
        "avg_time_hours": 15.31,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "16-18h": 1,
          "20-22h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-28": 2,
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-01-28": 29.392553055555556,
          "2026-03-24": 16.548994444444443
        },
        "time_count_per_day": {
          "2026-01-28": 2,
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.55,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 16.548994444444443
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        },
        "P3": {
          "avg_time_hours": 14.7,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "20-22h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-28": 2
          },
          "time_per_day": {
            "2026-01-28": 29.392553055555556
          },
          "time_count_per_day": {
            "2026-01-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.31,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "16-18h": 1,
              "20-22h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-28": 2,
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-01-28": 29.392553055555556,
              "2026-03-24": 16.548994444444443
            },
            "time_count_per_day": {
              "2026-01-28": 2,
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.55,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 16.548994444444443
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            },
            "P3": {
              "avg_time_hours": 14.7,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "20-22h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-28": 2
              },
              "time_per_day": {
                "2026-01-28": 29.392553055555556
              },
              "time_count_per_day": {
                "2026-01-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_938": {
      "overall": {
        "avg_time_hours": 121.19,
        "mode_time_hours": 241.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "240-242h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-06": 1,
          "2026-04-17": 1
        },
        "time_per_day": {
          "2026-02-06": 240.7747938888889,
          "2026-04-17": 1.6125108333333333
        },
        "time_count_per_day": {
          "2026-02-06": 1,
          "2026-04-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-17": 1
          },
          "time_per_day": {
            "2026-04-17": 1.6125108333333333
          },
          "time_count_per_day": {
            "2026-04-17": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 240.77,
          "mode_time_hours": 241.0,
          "mode_frequency": 1,
          "time_distribution": {
            "240-242h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 240.7747938888889
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 121.19,
            "mode_time_hours": 241.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "240-242h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-06": 1,
              "2026-04-17": 1
            },
            "time_per_day": {
              "2026-02-06": 240.7747938888889,
              "2026-04-17": 1.6125108333333333
            },
            "time_count_per_day": {
              "2026-02-06": 1,
              "2026-04-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {
                "2026-04-17": 1.6125108333333333
              },
              "time_count_per_day": {
                "2026-04-17": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 240.77,
              "mode_time_hours": 241.0,
              "mode_frequency": 1,
              "time_distribution": {
                "240-242h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 240.7747938888889
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_939": {
      "overall": {
        "avg_time_hours": 227.81,
        "mode_time_hours": 239.0,
        "mode_frequency": 1,
        "time_distribution": {
          "214-216h": 1,
          "238-240h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-05": 1,
          "2026-02-06": 1
        },
        "time_per_day": {
          "2026-02-05": 215.63134472222222,
          "2026-02-06": 239.98008277777777
        },
        "time_count_per_day": {
          "2026-02-05": 1,
          "2026-02-06": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 227.81,
          "mode_time_hours": 239.0,
          "mode_frequency": 1,
          "time_distribution": {
            "214-216h": 1,
            "238-240h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-05": 1,
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-05": 215.63134472222222,
            "2026-02-06": 239.98008277777777
          },
          "time_count_per_day": {
            "2026-02-05": 1,
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 227.81,
            "mode_time_hours": 239.0,
            "mode_frequency": 1,
            "time_distribution": {
              "214-216h": 1,
              "238-240h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-05": 1,
              "2026-02-06": 1
            },
            "time_per_day": {
              "2026-02-05": 215.63134472222222,
              "2026-02-06": 239.98008277777777
            },
            "time_count_per_day": {
              "2026-02-05": 1,
              "2026-02-06": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 227.81,
              "mode_time_hours": 239.0,
              "mode_frequency": 1,
              "time_distribution": {
                "214-216h": 1,
                "238-240h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-05": 1,
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-05": 215.63134472222222,
                "2026-02-06": 239.98008277777777
              },
              "time_count_per_day": {
                "2026-02-05": 1,
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_940": {
      "overall": {
        "avg_time_hours": 214.33,
        "mode_time_hours": 215.0,
        "mode_frequency": 1,
        "time_distribution": {
          "214-216h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-05": 1
        },
        "time_per_day": {
          "2026-02-05": 214.3308536111111
        },
        "time_count_per_day": {
          "2026-02-05": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 214.33,
          "mode_time_hours": 215.0,
          "mode_frequency": 1,
          "time_distribution": {
            "214-216h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 214.3308536111111
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 214.33,
            "mode_time_hours": 215.0,
            "mode_frequency": 1,
            "time_distribution": {
              "214-216h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-05": 1
            },
            "time_per_day": {
              "2026-02-05": 214.3308536111111
            },
            "time_count_per_day": {
              "2026-02-05": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 214.33,
              "mode_time_hours": 215.0,
              "mode_frequency": 1,
              "time_distribution": {
                "214-216h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 214.3308536111111
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_875": {
      "overall": {
        "avg_time_hours": 8.67,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-28": 1
        },
        "time_per_day": {
          "2026-01-28": 8.673403333333333
        },
        "time_count_per_day": {
          "2026-01-28": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 8.67,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 8.673403333333333
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.67,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-28": 1
            },
            "time_per_day": {
              "2026-01-28": 8.673403333333333
            },
            "time_count_per_day": {
              "2026-01-28": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.67,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 8.673403333333333
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_941": {
      "overall": {
        "avg_time_hours": 8.15,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-28": 1
        },
        "time_per_day": {
          "2026-01-28": 8.154997777777778
        },
        "time_count_per_day": {
          "2026-01-28": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 8.15,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-28": 1
          },
          "time_per_day": {
            "2026-01-28": 8.154997777777778
          },
          "time_count_per_day": {
            "2026-01-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.15,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-28": 1
            },
            "time_per_day": {
              "2026-01-28": 8.154997777777778
            },
            "time_count_per_day": {
              "2026-01-28": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.15,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-28": 1
              },
              "time_per_day": {
                "2026-01-28": 8.154997777777778
              },
              "time_count_per_day": {
                "2026-01-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_854": {
      "overall": {
        "avg_time_hours": 369.44,
        "mode_time_hours": 369.0,
        "mode_frequency": 1,
        "time_distribution": {
          "368-370h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-02-13": 369.4398869444445
        },
        "time_count_per_day": {
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 369.44,
          "mode_time_hours": 369.0,
          "mode_frequency": 1,
          "time_distribution": {
            "368-370h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 369.4398869444445
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 369.44,
            "mode_time_hours": 369.0,
            "mode_frequency": 1,
            "time_distribution": {
              "368-370h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-02-13": 369.4398869444445
            },
            "time_count_per_day": {
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 369.44,
              "mode_time_hours": 369.0,
              "mode_frequency": 1,
              "time_distribution": {
                "368-370h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 369.4398869444445
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_675": {
      "overall": {
        "avg_time_hours": 124.02,
        "mode_time_hours": 125.0,
        "mode_frequency": 1,
        "time_distribution": {
          "124-126h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-02": 1
        },
        "time_per_day": {
          "2026-02-02": 124.02165277777777
        },
        "time_count_per_day": {
          "2026-02-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 124.02,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 124.02165277777777
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 124.02,
            "mode_time_hours": 125.0,
            "mode_frequency": 1,
            "time_distribution": {
              "124-126h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-02": 1
            },
            "time_per_day": {
              "2026-02-02": 124.02165277777777
            },
            "time_count_per_day": {
              "2026-02-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 124.02,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 124.02165277777777
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_483": {
      "overall": {
        "avg_time_hours": 240.31,
        "mode_time_hours": 399.0,
        "mode_frequency": 3,
        "time_distribution": {
          "2-4h": 2,
          "398-400h": 3
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-01-29": 2,
          "2026-03-18": 3
        },
        "time_per_day": {
          "2026-01-29": 5.456418055555556,
          "2026-03-18": 1196.088276388889
        },
        "time_count_per_day": {
          "2026-01-29": 2,
          "2026-03-18": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.73,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-29": 2
          },
          "time_per_day": {
            "2026-01-29": 5.456418055555556
          },
          "time_count_per_day": {
            "2026-01-29": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 398.7,
          "mode_time_hours": 399.0,
          "mode_frequency": 3,
          "time_distribution": {
            "398-400h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-18": 3
          },
          "time_per_day": {
            "2026-03-18": 1196.088276388889
          },
          "time_count_per_day": {
            "2026-03-18": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 240.31,
            "mode_time_hours": 399.0,
            "mode_frequency": 3,
            "time_distribution": {
              "2-4h": 2,
              "398-400h": 3
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-01-29": 2,
              "2026-03-18": 3
            },
            "time_per_day": {
              "2026-01-29": 5.456418055555556,
              "2026-03-18": 1196.088276388889
            },
            "time_count_per_day": {
              "2026-01-29": 2,
              "2026-03-18": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.73,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-29": 2
              },
              "time_per_day": {
                "2026-01-29": 5.456418055555556
              },
              "time_count_per_day": {
                "2026-01-29": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 398.7,
              "mode_time_hours": 399.0,
              "mode_frequency": 3,
              "time_distribution": {
                "398-400h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-18": 3
              },
              "time_per_day": {
                "2026-03-18": 1196.088276388889
              },
              "time_count_per_day": {
                "2026-03-18": 3
              }
            }
          }
        }
      }
    },
    "cliente_943": {
      "overall": {
        "avg_time_hours": 274.97,
        "mode_time_hours": 275.0,
        "mode_frequency": 1,
        "time_distribution": {
          "274-276h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 274.9679361111111
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 274.97,
          "mode_time_hours": 275.0,
          "mode_frequency": 1,
          "time_distribution": {
            "274-276h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 274.9679361111111
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 274.97,
            "mode_time_hours": 275.0,
            "mode_frequency": 1,
            "time_distribution": {
              "274-276h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 274.9679361111111
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 274.97,
              "mode_time_hours": 275.0,
              "mode_frequency": 1,
              "time_distribution": {
                "274-276h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 274.9679361111111
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_944": {
      "overall": {
        "avg_time_hours": 47.87,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "46-48h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-31": 1
        },
        "time_per_day": {
          "2026-01-31": 47.87244722222222
        },
        "time_count_per_day": {
          "2026-01-31": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 47.87,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-31": 1
          },
          "time_per_day": {
            "2026-01-31": 47.87244722222222
          },
          "time_count_per_day": {
            "2026-01-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 47.87,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "46-48h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-31": 1
            },
            "time_per_day": {
              "2026-01-31": 47.87244722222222
            },
            "time_count_per_day": {
              "2026-01-31": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 47.87,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-31": 1
              },
              "time_per_day": {
                "2026-01-31": 47.87244722222222
              },
              "time_count_per_day": {
                "2026-01-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_945": {
      "overall": {
        "avg_time_hours": 505.29,
        "mode_time_hours": 505.0,
        "mode_frequency": 1,
        "time_distribution": {
          "504-506h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 505.28728333333333
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 505.29,
          "mode_time_hours": 505.0,
          "mode_frequency": 1,
          "time_distribution": {
            "504-506h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 505.28728333333333
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 505.29,
            "mode_time_hours": 505.0,
            "mode_frequency": 1,
            "time_distribution": {
              "504-506h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 505.28728333333333
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 505.29,
              "mode_time_hours": 505.0,
              "mode_frequency": 1,
              "time_distribution": {
                "504-506h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 505.28728333333333
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_947": {
      "overall": {
        "avg_time_hours": 1.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-29": 1,
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-01-29": 1.897515,
          "2026-02-12": 0.7846419444444444
        },
        "time_count_per_day": {
          "2026-01-29": 1,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-29": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-01-29": 1.897515,
            "2026-02-12": 0.7846419444444444
          },
          "time_count_per_day": {
            "2026-01-29": 1,
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-29": 1,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-01-29": 1.897515,
              "2026-02-12": 0.7846419444444444
            },
            "time_count_per_day": {
              "2026-01-29": 1,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-29": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-01-29": 1.897515,
                "2026-02-12": 0.7846419444444444
              },
              "time_count_per_day": {
                "2026-01-29": 1,
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_948": {
      "overall": {
        "avg_time_hours": 6.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "16-18h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-30": 1,
          "2026-02-26": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-01-30": 17.237531666666666,
          "2026-02-26": 0.9201766666666666,
          "2026-05-30": 0.009233333333333335
        },
        "time_count_per_day": {
          "2026-01-30": 1,
          "2026-02-26": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.06,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "16-18h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-02-26": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-01-30": 17.237531666666666,
            "2026-02-26": 0.9201766666666666,
            "2026-05-30": 0.009233333333333335
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-02-26": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "16-18h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-01-30": 1,
              "2026-02-26": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-01-30": 17.237531666666666,
              "2026-02-26": 0.9201766666666666,
              "2026-05-30": 0.009233333333333335
            },
            "time_count_per_day": {
              "2026-01-30": 1,
              "2026-02-26": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.06,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "16-18h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-02-26": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-01-30": 17.237531666666666,
                "2026-02-26": 0.9201766666666666,
                "2026-05-30": 0.009233333333333335
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-02-26": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_949": {
      "overall": {
        "avg_time_hours": 24.35,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-31": 1
        },
        "time_per_day": {
          "2026-01-31": 24.352065
        },
        "time_count_per_day": {
          "2026-01-31": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 24.35,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-31": 1
          },
          "time_per_day": {
            "2026-01-31": 24.352065
          },
          "time_count_per_day": {
            "2026-01-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.35,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-31": 1
            },
            "time_per_day": {
              "2026-01-31": 24.352065
            },
            "time_count_per_day": {
              "2026-01-31": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 24.35,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-31": 1
              },
              "time_per_day": {
                "2026-01-31": 24.352065
              },
              "time_count_per_day": {
                "2026-01-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_950": {
      "overall": {
        "avg_time_hours": 133.06,
        "mode_time_hours": 133.0,
        "mode_frequency": 1,
        "time_distribution": {
          "132-134h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-04": 1
        },
        "time_per_day": {
          "2026-02-04": 133.05582388888888
        },
        "time_count_per_day": {
          "2026-02-04": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 133.06,
          "mode_time_hours": 133.0,
          "mode_frequency": 1,
          "time_distribution": {
            "132-134h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 133.05582388888888
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 133.06,
            "mode_time_hours": 133.0,
            "mode_frequency": 1,
            "time_distribution": {
              "132-134h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-04": 1
            },
            "time_per_day": {
              "2026-02-04": 133.05582388888888
            },
            "time_count_per_day": {
              "2026-02-04": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 133.06,
              "mode_time_hours": 133.0,
              "mode_frequency": 1,
              "time_distribution": {
                "132-134h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 133.05582388888888
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_951": {
      "overall": {
        "avg_time_hours": 27.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "78-80h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-02": 1,
          "2026-02-12": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-02-02": 79.85148944444445,
          "2026-02-12": 1.1727975,
          "2026-05-30": 0.016358611111111112
        },
        "time_count_per_day": {
          "2026-02-02": 1,
          "2026-02-12": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "78-80h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-02": 1,
            "2026-02-12": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-02-02": 79.85148944444445,
            "2026-02-12": 1.1727975,
            "2026-05-30": 0.016358611111111112
          },
          "time_count_per_day": {
            "2026-02-02": 1,
            "2026-02-12": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 27.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "78-80h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-02": 1,
              "2026-02-12": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-02-02": 79.85148944444445,
              "2026-02-12": 1.1727975,
              "2026-05-30": 0.016358611111111112
            },
            "time_count_per_day": {
              "2026-02-02": 1,
              "2026-02-12": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "78-80h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-02": 1,
                "2026-02-12": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-02-02": 79.85148944444445,
                "2026-02-12": 1.1727975,
                "2026-05-30": 0.016358611111111112
              },
              "time_count_per_day": {
                "2026-02-02": 1,
                "2026-02-12": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_953": {
      "overall": {
        "avg_time_hours": 0.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-30": 1,
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-01-30": 0.10047,
          "2026-05-05": 0.4589425
        },
        "time_count_per_day": {
          "2026-01-30": 1,
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.28,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-01-30": 0.10047,
            "2026-05-05": 0.4589425
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-05-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-30": 1,
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-01-30": 0.10047,
              "2026-05-05": 0.4589425
            },
            "time_count_per_day": {
              "2026-01-30": 1,
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.28,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-01-30": 0.10047,
                "2026-05-05": 0.4589425
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-05-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_954": {
      "overall": {
        "avg_time_hours": 181.14,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "156-158h": 1,
          "266-268h": 1,
          "350-352h": 1,
          "384-386h": 1,
          "646-648h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2026-02-02": 2,
          "2026-02-10": 1,
          "2026-02-18": 1,
          "2026-02-19": 2,
          "2026-03-02": 2,
          "2026-03-03": 1,
          "2026-03-09": 1,
          "2026-03-11": 1,
          "2026-03-26": 1,
          "2026-03-31": 1
        },
        "time_per_day": {
          "2026-02-02": 0.8700175000000001,
          "2026-02-10": 267.6131972222222,
          "2026-02-19": 736.6572316666666,
          "2026-03-02": 1.3763447222222223,
          "2026-03-09": 0.9936572222222223,
          "2026-03-26": 647.8604022222222,
          "2026-03-31": 156.02757305555556
        },
        "time_count_per_day": {
          "2026-02-02": 2,
          "2026-02-10": 1,
          "2026-02-19": 2,
          "2026-03-02": 2,
          "2026-03-09": 1,
          "2026-03-26": 1,
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 26.54,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "156-158h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-02": 2,
            "2026-03-02": 2,
            "2026-03-09": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-02-02": 0.8700175000000001,
            "2026-03-02": 1.3763447222222223,
            "2026-03-09": 0.9936572222222223,
            "2026-03-31": 156.02757305555556
          },
          "time_count_per_day": {
            "2026-02-02": 2,
            "2026-03-02": 2,
            "2026-03-09": 1,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 647.86,
          "mode_time_hours": 647.0,
          "mode_frequency": 1,
          "time_distribution": {
            "646-648h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 647.8604022222222
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 334.76,
          "mode_time_hours": 267.0,
          "mode_frequency": 1,
          "time_distribution": {
            "266-268h": 1,
            "350-352h": 1,
            "384-386h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-02-19": 2,
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-02-10": 267.6131972222222,
            "2026-02-19": 736.6572316666666
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 181.14,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "156-158h": 1,
              "266-268h": 1,
              "350-352h": 1,
              "384-386h": 1,
              "646-648h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-02-02": 2,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-02": 2,
              "2026-03-09": 1,
              "2026-03-26": 1,
              "2026-03-31": 1
            },
            "time_per_day": {
              "2026-02-02": 0.8700175000000001,
              "2026-02-10": 267.6131972222222,
              "2026-02-19": 736.6572316666666,
              "2026-03-02": 1.3763447222222223,
              "2026-03-09": 0.9936572222222223,
              "2026-03-26": 647.8604022222222,
              "2026-03-31": 156.02757305555556
            },
            "time_count_per_day": {
              "2026-02-02": 2,
              "2026-02-10": 1,
              "2026-02-19": 2,
              "2026-03-02": 2,
              "2026-03-09": 1,
              "2026-03-26": 1,
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 26.54,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "156-158h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-02": 2,
                "2026-03-02": 2,
                "2026-03-09": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-02-02": 0.8700175000000001,
                "2026-03-02": 1.3763447222222223,
                "2026-03-09": 0.9936572222222223,
                "2026-03-31": 156.02757305555556
              },
              "time_count_per_day": {
                "2026-02-02": 2,
                "2026-03-02": 2,
                "2026-03-09": 1,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 647.86,
              "mode_time_hours": 647.0,
              "mode_frequency": 1,
              "time_distribution": {
                "646-648h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 647.8604022222222
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 334.76,
              "mode_time_hours": 267.0,
              "mode_frequency": 1,
              "time_distribution": {
                "266-268h": 1,
                "350-352h": 1,
                "384-386h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-10": 267.6131972222222,
                "2026-02-19": 736.6572316666666
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-02-19": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-03-03": 1,
              "2026-03-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-03-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_955": {
      "overall": {
        "avg_time_hours": 104.14,
        "mode_time_hours": 105.0,
        "mode_frequency": 1,
        "time_distribution": {
          "104-106h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 104.13822694444445
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 104.14,
          "mode_time_hours": 105.0,
          "mode_frequency": 1,
          "time_distribution": {
            "104-106h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 104.13822694444445
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 104.14,
            "mode_time_hours": 105.0,
            "mode_frequency": 1,
            "time_distribution": {
              "104-106h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 104.13822694444445
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 104.14,
              "mode_time_hours": 105.0,
              "mode_frequency": 1,
              "time_distribution": {
                "104-106h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 104.13822694444445
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_956": {
      "overall": {
        "avg_time_hours": 128.94,
        "mode_time_hours": 129.0,
        "mode_frequency": 2,
        "time_distribution": {
          "126-128h": 1,
          "128-130h": 2
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-04": 3
        },
        "time_per_day": {
          "2026-02-04": 386.8127083333334
        },
        "time_count_per_day": {
          "2026-02-04": 3
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 128.94,
          "mode_time_hours": 129.0,
          "mode_frequency": 2,
          "time_distribution": {
            "126-128h": 1,
            "128-130h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-04": 3
          },
          "time_per_day": {
            "2026-02-04": 386.8127083333334
          },
          "time_count_per_day": {
            "2026-02-04": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 128.94,
            "mode_time_hours": 129.0,
            "mode_frequency": 2,
            "time_distribution": {
              "126-128h": 1,
              "128-130h": 2
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-04": 3
            },
            "time_per_day": {
              "2026-02-04": 386.8127083333334
            },
            "time_count_per_day": {
              "2026-02-04": 3
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 128.94,
              "mode_time_hours": 129.0,
              "mode_frequency": 2,
              "time_distribution": {
                "126-128h": 1,
                "128-130h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-04": 3
              },
              "time_per_day": {
                "2026-02-04": 386.8127083333334
              },
              "time_count_per_day": {
                "2026-02-04": 3
              }
            }
          }
        }
      }
    },
    "cliente_958": {
      "overall": {
        "avg_time_hours": 5.63,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-30": 1
        },
        "time_per_day": {
          "2026-01-30": 5.625943888888889
        },
        "time_count_per_day": {
          "2026-01-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.63,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-30": 1
          },
          "time_per_day": {
            "2026-01-30": 5.625943888888889
          },
          "time_count_per_day": {
            "2026-01-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.63,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-01-30": 1
            },
            "time_per_day": {
              "2026-01-30": 5.625943888888889
            },
            "time_count_per_day": {
              "2026-01-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.63,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-30": 1
              },
              "time_per_day": {
                "2026-01-30": 5.625943888888889
              },
              "time_count_per_day": {
                "2026-01-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_959": {
      "overall": {
        "avg_time_hours": 0.74,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-30": 1,
          "2026-02-24": 1,
          "2026-03-23": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-01-30": 1.2552411111111113,
          "2026-02-24": 0.1982575,
          "2026-03-23": 1.493091111111111,
          "2026-05-30": 0.010605555555555556
        },
        "time_count_per_day": {
          "2026-01-30": 1,
          "2026-02-24": 1,
          "2026-03-23": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.74,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-02-24": 1,
            "2026-03-23": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-01-30": 1.2552411111111113,
            "2026-02-24": 0.1982575,
            "2026-03-23": 1.493091111111111,
            "2026-05-30": 0.010605555555555556
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-02-24": 1,
            "2026-03-23": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.74,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-30": 1,
              "2026-02-24": 1,
              "2026-03-23": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-01-30": 1.2552411111111113,
              "2026-02-24": 0.1982575,
              "2026-03-23": 1.493091111111111,
              "2026-05-30": 0.010605555555555556
            },
            "time_count_per_day": {
              "2026-01-30": 1,
              "2026-02-24": 1,
              "2026-03-23": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.74,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-02-24": 1,
                "2026-03-23": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-01-30": 1.2552411111111113,
                "2026-02-24": 0.1982575,
                "2026-03-23": 1.493091111111111,
                "2026-05-30": 0.010605555555555556
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-02-24": 1,
                "2026-03-23": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_960": {
      "overall": {
        "avg_time_hours": 237.87,
        "mode_time_hours": 475.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "474-476h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-19": 1,
          "2026-05-16": 1
        },
        "time_per_day": {
          "2026-02-19": 475.52426444444444,
          "2026-05-16": 0.2139025
        },
        "time_count_per_day": {
          "2026-02-19": 1,
          "2026-05-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-16": 1
          },
          "time_per_day": {
            "2026-05-16": 0.2139025
          },
          "time_count_per_day": {
            "2026-05-16": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 475.52,
          "mode_time_hours": 475.0,
          "mode_frequency": 1,
          "time_distribution": {
            "474-476h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 475.52426444444444
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 237.87,
            "mode_time_hours": 475.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "474-476h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 1,
              "2026-05-16": 1
            },
            "time_per_day": {
              "2026-02-19": 475.52426444444444,
              "2026-05-16": 0.2139025
            },
            "time_count_per_day": {
              "2026-02-19": 1,
              "2026-05-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-16": 1
              },
              "time_per_day": {
                "2026-05-16": 0.2139025
              },
              "time_count_per_day": {
                "2026-05-16": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 475.52,
              "mode_time_hours": 475.0,
              "mode_frequency": 1,
              "time_distribution": {
                "474-476h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 475.52426444444444
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_957": {
      "overall": {
        "avg_time_hours": 451.22,
        "mode_time_hours": 451.0,
        "mode_frequency": 1,
        "time_distribution": {
          "450-452h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 451.2215152777778
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 451.22,
          "mode_time_hours": 451.0,
          "mode_frequency": 1,
          "time_distribution": {
            "450-452h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 451.2215152777778
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 451.22,
            "mode_time_hours": 451.0,
            "mode_frequency": 1,
            "time_distribution": {
              "450-452h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 451.2215152777778
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 451.22,
              "mode_time_hours": 451.0,
              "mode_frequency": 1,
              "time_distribution": {
                "450-452h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 451.2215152777778
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_961": {
      "overall": {
        "avg_time_hours": 792.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "422-424h": 1,
          "1086-1088h": 1,
          "1660-1662h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-01-30": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-01-30": 0.0097725,
          "2026-03-17": 1086.4239061111111,
          "2026-03-18": 423.44962444444445,
          "2026-04-10": 1661.892758888889
        },
        "time_count_per_day": {
          "2026-01-30": 1,
          "2026-03-17": 1,
          "2026-03-18": 1,
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 916.11,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "1086-1088h": 1,
            "1660-1662h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-01-30": 1,
            "2026-03-17": 1,
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-01-30": 0.0097725,
            "2026-03-17": 1086.4239061111111,
            "2026-04-10": 1661.892758888889
          },
          "time_count_per_day": {
            "2026-01-30": 1,
            "2026-03-17": 1,
            "2026-04-10": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 423.45,
          "mode_time_hours": 423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "422-424h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 423.44962444444445
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 792.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "422-424h": 1,
              "1086-1088h": 1,
              "1660-1662h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-01-30": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-01-30": 0.0097725,
              "2026-03-17": 1086.4239061111111,
              "2026-03-18": 423.44962444444445,
              "2026-04-10": 1661.892758888889
            },
            "time_count_per_day": {
              "2026-01-30": 1,
              "2026-03-17": 1,
              "2026-03-18": 1,
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 916.11,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "1086-1088h": 1,
                "1660-1662h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-01-30": 1,
                "2026-03-17": 1,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-01-30": 0.0097725,
                "2026-03-17": 1086.4239061111111,
                "2026-04-10": 1661.892758888889
              },
              "time_count_per_day": {
                "2026-01-30": 1,
                "2026-03-17": 1,
                "2026-04-10": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 423.45,
              "mode_time_hours": 423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "422-424h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 423.44962444444445
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_962": {
      "overall": {
        "avg_time_hours": 191.96,
        "mode_time_hours": 77.0,
        "mode_frequency": 2,
        "time_distribution": {
          "8-10h": 1,
          "60-62h": 1,
          "68-70h": 1,
          "76-78h": 2,
          "140-142h": 1,
          "290-292h": 1,
          "406-408h": 1,
          "592-594h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2026-02-03": 2,
          "2026-02-07": 1,
          "2026-02-28": 1,
          "2026-03-06": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-02-03": 155.9442511111111,
          "2026-02-07": 60.61333055555555,
          "2026-02-28": 593.1907219444445,
          "2026-03-06": 141.78462555555555,
          "2026-03-12": 9.349118055555556,
          "2026-03-13": 68.78093527777777,
          "2026-03-17": 291.52984583333335,
          "2026-03-18": 406.48514916666664
        },
        "time_count_per_day": {
          "2026-02-03": 2,
          "2026-02-07": 1,
          "2026-02-28": 1,
          "2026-03-06": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-18": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 406.49,
          "mode_time_hours": 407.0,
          "mode_frequency": 1,
          "time_distribution": {
            "406-408h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 406.48514916666664
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        },
        "P2": {
          "avg_time_hours": 220.93,
          "mode_time_hours": 593.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "68-70h": 1,
            "140-142h": 1,
            "290-292h": 1,
            "592-594h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-28": 1,
            "2026-03-06": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-02-28": 593.1907219444445,
            "2026-03-06": 141.78462555555555,
            "2026-03-12": 9.349118055555556,
            "2026-03-13": 68.78093527777777,
            "2026-03-17": 291.52984583333335
          },
          "time_count_per_day": {
            "2026-02-28": 1,
            "2026-03-06": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 72.19,
          "mode_time_hours": 77.0,
          "mode_frequency": 2,
          "time_distribution": {
            "60-62h": 1,
            "76-78h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-03": 2,
            "2026-02-07": 1
          },
          "time_per_day": {
            "2026-02-03": 155.9442511111111,
            "2026-02-07": 60.61333055555555
          },
          "time_count_per_day": {
            "2026-02-03": 2,
            "2026-02-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 191.96,
            "mode_time_hours": 77.0,
            "mode_frequency": 2,
            "time_distribution": {
              "8-10h": 1,
              "60-62h": 1,
              "68-70h": 1,
              "76-78h": 2,
              "140-142h": 1,
              "290-292h": 1,
              "406-408h": 1,
              "592-594h": 1
            },
            "tickets_count": 9,
            "tickets_per_day": {
              "2026-02-03": 2,
              "2026-02-07": 1,
              "2026-02-28": 1,
              "2026-03-06": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-02-03": 155.9442511111111,
              "2026-02-07": 60.61333055555555,
              "2026-02-28": 593.1907219444445,
              "2026-03-06": 141.78462555555555,
              "2026-03-12": 9.349118055555556,
              "2026-03-13": 68.78093527777777,
              "2026-03-17": 291.52984583333335,
              "2026-03-18": 406.48514916666664
            },
            "time_count_per_day": {
              "2026-02-03": 2,
              "2026-02-07": 1,
              "2026-02-28": 1,
              "2026-03-06": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-18": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 406.49,
              "mode_time_hours": 407.0,
              "mode_frequency": 1,
              "time_distribution": {
                "406-408h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 406.48514916666664
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            },
            "P2": {
              "avg_time_hours": 220.93,
              "mode_time_hours": 593.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "68-70h": 1,
                "140-142h": 1,
                "290-292h": 1,
                "592-594h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-28": 1,
                "2026-03-06": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-02-28": 593.1907219444445,
                "2026-03-06": 141.78462555555555,
                "2026-03-12": 9.349118055555556,
                "2026-03-13": 68.78093527777777,
                "2026-03-17": 291.52984583333335
              },
              "time_count_per_day": {
                "2026-02-28": 1,
                "2026-03-06": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 72.19,
              "mode_time_hours": 77.0,
              "mode_frequency": 2,
              "time_distribution": {
                "60-62h": 1,
                "76-78h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-03": 2,
                "2026-02-07": 1
              },
              "time_per_day": {
                "2026-02-03": 155.9442511111111,
                "2026-02-07": 60.61333055555555
              },
              "time_count_per_day": {
                "2026-02-03": 2,
                "2026-02-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_963": {
      "overall": {
        "avg_time_hours": 165.74,
        "mode_time_hours": 165.0,
        "mode_frequency": 1,
        "time_distribution": {
          "164-166h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-06": 1
        },
        "time_per_day": {
          "2026-02-06": 165.73520861111112
        },
        "time_count_per_day": {
          "2026-02-06": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 165.74,
          "mode_time_hours": 165.0,
          "mode_frequency": 1,
          "time_distribution": {
            "164-166h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 165.73520861111112
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.74,
            "mode_time_hours": 165.0,
            "mode_frequency": 1,
            "time_distribution": {
              "164-166h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-06": 1
            },
            "time_per_day": {
              "2026-02-06": 165.73520861111112
            },
            "time_count_per_day": {
              "2026-02-06": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 165.74,
              "mode_time_hours": 165.0,
              "mode_frequency": 1,
              "time_distribution": {
                "164-166h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 165.73520861111112
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_964": {
      "overall": {
        "avg_time_hours": 912.73,
        "mode_time_hours": 913.0,
        "mode_frequency": 1,
        "time_distribution": {
          "912-914h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 912.7333680555555
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 912.73,
          "mode_time_hours": 913.0,
          "mode_frequency": 1,
          "time_distribution": {
            "912-914h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 912.7333680555555
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 912.73,
            "mode_time_hours": 913.0,
            "mode_frequency": 1,
            "time_distribution": {
              "912-914h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 912.7333680555555
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 912.73,
              "mode_time_hours": 913.0,
              "mode_frequency": 1,
              "time_distribution": {
                "912-914h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 912.7333680555555
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_965": {
      "overall": {
        "avg_time_hours": 73.63,
        "mode_time_hours": 73.0,
        "mode_frequency": 2,
        "time_distribution": {
          "72-74h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-03": 2
        },
        "time_per_day": {
          "2026-02-03": 147.26525416666667
        },
        "time_count_per_day": {
          "2026-02-03": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 73.63,
          "mode_time_hours": 73.0,
          "mode_frequency": 2,
          "time_distribution": {
            "72-74h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-03": 2
          },
          "time_per_day": {
            "2026-02-03": 147.26525416666667
          },
          "time_count_per_day": {
            "2026-02-03": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 73.63,
            "mode_time_hours": 73.0,
            "mode_frequency": 2,
            "time_distribution": {
              "72-74h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-03": 2
            },
            "time_per_day": {
              "2026-02-03": 147.26525416666667
            },
            "time_count_per_day": {
              "2026-02-03": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 73.63,
              "mode_time_hours": 73.0,
              "mode_frequency": 2,
              "time_distribution": {
                "72-74h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-03": 2
              },
              "time_per_day": {
                "2026-02-03": 147.26525416666667
              },
              "time_count_per_day": {
                "2026-02-03": 2
              }
            }
          }
        }
      }
    },
    "cliente_966": {
      "overall": {
        "avg_time_hours": 187.12,
        "mode_time_hours": 57.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "8-10h": 1,
          "14-16h": 1,
          "18-20h": 1,
          "56-58h": 1,
          "428-430h": 1,
          "964-966h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-03-03": 1,
          "2026-04-18": 1,
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-02-03": 56.45062027777778,
          "2026-02-19": 18.309503055555556,
          "2026-02-20": 3.0368094444444442,
          "2026-02-24": 16.54754638888889,
          "2026-03-03": 9.339121944444445,
          "2026-04-18": 964.5005186111111,
          "2026-05-05": 428.75039416666664
        },
        "time_count_per_day": {
          "2026-02-03": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 2,
          "2026-03-03": 1,
          "2026-04-18": 1,
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 91.53,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "8-10h": 1,
            "14-16h": 1,
            "428-430h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-03-03": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-02-20": 3.0368094444444442,
            "2026-02-24": 16.54754638888889,
            "2026-03-03": 9.339121944444445,
            "2026-05-05": 428.75039416666664
          },
          "time_count_per_day": {
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-03-03": 1,
            "2026-05-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 346.42,
          "mode_time_hours": 57.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1,
            "56-58h": 1,
            "964-966h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-04-18": 1
          },
          "time_per_day": {
            "2026-02-03": 56.45062027777778,
            "2026-02-19": 18.309503055555556,
            "2026-04-18": 964.5005186111111
          },
          "time_count_per_day": {
            "2026-02-03": 1,
            "2026-02-19": 1,
            "2026-04-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 187.12,
            "mode_time_hours": 57.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "8-10h": 1,
              "14-16h": 1,
              "18-20h": 1,
              "56-58h": 1,
              "428-430h": 1,
              "964-966h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-03-03": 1,
              "2026-04-18": 1,
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-02-03": 56.45062027777778,
              "2026-02-19": 18.309503055555556,
              "2026-02-20": 3.0368094444444442,
              "2026-02-24": 16.54754638888889,
              "2026-03-03": 9.339121944444445,
              "2026-04-18": 964.5005186111111,
              "2026-05-05": 428.75039416666664
            },
            "time_count_per_day": {
              "2026-02-03": 1,
              "2026-02-19": 1,
              "2026-02-20": 1,
              "2026-02-24": 2,
              "2026-03-03": 1,
              "2026-04-18": 1,
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 91.53,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "8-10h": 1,
                "14-16h": 1,
                "428-430h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-03-03": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-02-20": 3.0368094444444442,
                "2026-02-24": 16.54754638888889,
                "2026-03-03": 9.339121944444445,
                "2026-05-05": 428.75039416666664
              },
              "time_count_per_day": {
                "2026-02-20": 1,
                "2026-02-24": 2,
                "2026-03-03": 1,
                "2026-05-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 346.42,
              "mode_time_hours": 57.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1,
                "56-58h": 1,
                "964-966h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-04-18": 1
              },
              "time_per_day": {
                "2026-02-03": 56.45062027777778,
                "2026-02-19": 18.309503055555556,
                "2026-04-18": 964.5005186111111
              },
              "time_count_per_day": {
                "2026-02-03": 1,
                "2026-02-19": 1,
                "2026-04-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_968": {
      "overall": {
        "avg_time_hours": 15.9,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 15.897963333333333
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 15.9,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 15.897963333333333
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.9,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 15.897963333333333
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 15.9,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 15.897963333333333
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_969": {
      "overall": {
        "avg_time_hours": 265.53,
        "mode_time_hours": 265.0,
        "mode_frequency": 1,
        "time_distribution": {
          "264-266h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-02-13": 265.5274111111111
        },
        "time_count_per_day": {
          "2026-02-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 265.53,
          "mode_time_hours": 265.0,
          "mode_frequency": 1,
          "time_distribution": {
            "264-266h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 265.5274111111111
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 265.53,
            "mode_time_hours": 265.0,
            "mode_frequency": 1,
            "time_distribution": {
              "264-266h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-02-13": 265.5274111111111
            },
            "time_count_per_day": {
              "2026-02-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 265.53,
              "mode_time_hours": 265.0,
              "mode_frequency": 1,
              "time_distribution": {
                "264-266h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 265.5274111111111
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_970": {
      "overall": {
        "avg_time_hours": 4.67,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-02": 1
        },
        "time_per_day": {
          "2026-02-02": 4.674955277777777
        },
        "time_count_per_day": {
          "2026-02-02": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.67,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 4.674955277777777
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.67,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-02": 1
            },
            "time_per_day": {
              "2026-02-02": 4.674955277777777
            },
            "time_count_per_day": {
              "2026-02-02": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.67,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 4.674955277777777
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_971": {
      "overall": {
        "avg_time_hours": 4.75,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-02": 1
        },
        "time_per_day": {
          "2026-02-02": 4.749867777777778
        },
        "time_count_per_day": {
          "2026-02-02": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 4.75,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {
            "2026-02-02": 4.749867777777778
          },
          "time_count_per_day": {
            "2026-02-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.75,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-02": 1
            },
            "time_per_day": {
              "2026-02-02": 4.749867777777778
            },
            "time_count_per_day": {
              "2026-02-02": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 4.75,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {
                "2026-02-02": 4.749867777777778
              },
              "time_count_per_day": {
                "2026-02-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_926": {
      "overall": {
        "avg_time_hours": 368.56,
        "mode_time_hours": 369.0,
        "mode_frequency": 1,
        "time_distribution": {
          "368-370h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-17": 1
        },
        "time_per_day": {
          "2026-02-17": 368.5618133333333
        },
        "time_count_per_day": {
          "2026-02-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 368.56,
          "mode_time_hours": 369.0,
          "mode_frequency": 1,
          "time_distribution": {
            "368-370h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-17": 1
          },
          "time_per_day": {
            "2026-02-17": 368.5618133333333
          },
          "time_count_per_day": {
            "2026-02-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 368.56,
            "mode_time_hours": 369.0,
            "mode_frequency": 1,
            "time_distribution": {
              "368-370h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-17": 1
            },
            "time_per_day": {
              "2026-02-17": 368.5618133333333
            },
            "time_count_per_day": {
              "2026-02-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 368.56,
              "mode_time_hours": 369.0,
              "mode_frequency": 1,
              "time_distribution": {
                "368-370h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-17": 1
              },
              "time_per_day": {
                "2026-02-17": 368.5618133333333
              },
              "time_count_per_day": {
                "2026-02-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_745": {
      "overall": {
        "avg_time_hours": 143.53,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "154-156h": 1,
          "228-230h": 1,
          "324-326h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2025-12-29": 1,
          "2026-02-11": 1,
          "2026-02-16": 1,
          "2026-03-18": 1,
          "2026-05-18": 3
        },
        "time_per_day": {
          "2026-02-11": 228.0502938888889,
          "2026-02-16": 324.99703805555555,
          "2026-03-18": 155.89570694444447,
          "2026-05-18": 8.721096944444444
        },
        "time_count_per_day": {
          "2026-02-11": 1,
          "2026-02-16": 1,
          "2026-03-18": 1,
          "2026-05-18": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 111.24,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "324-326h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-16": 1,
            "2026-05-18": 2
          },
          "time_per_day": {
            "2026-02-16": 324.99703805555555,
            "2026-05-18": 8.721096944444444
          },
          "time_count_per_day": {
            "2026-02-16": 1,
            "2026-05-18": 2
          }
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-29": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 191.97,
          "mode_time_hours": 229.0,
          "mode_frequency": 1,
          "time_distribution": {
            "154-156h": 1,
            "228-230h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-11": 1,
            "2026-03-18": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-02-11": 228.0502938888889,
            "2026-03-18": 155.89570694444447
          },
          "time_count_per_day": {
            "2026-02-11": 1,
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 143.53,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "154-156h": 1,
              "228-230h": 1,
              "324-326h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-02-11": 1,
              "2026-02-16": 1,
              "2026-03-18": 1,
              "2026-05-18": 2
            },
            "time_per_day": {
              "2026-02-11": 228.0502938888889,
              "2026-02-16": 324.99703805555555,
              "2026-03-18": 155.89570694444447,
              "2026-05-18": 8.721096944444444
            },
            "time_count_per_day": {
              "2026-02-11": 1,
              "2026-02-16": 1,
              "2026-03-18": 1,
              "2026-05-18": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 111.24,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "324-326h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-16": 1,
                "2026-05-18": 2
              },
              "time_per_day": {
                "2026-02-16": 324.99703805555555,
                "2026-05-18": 8.721096944444444
              },
              "time_count_per_day": {
                "2026-02-16": 1,
                "2026-05-18": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 191.97,
              "mode_time_hours": 229.0,
              "mode_frequency": 1,
              "time_distribution": {
                "154-156h": 1,
                "228-230h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-11": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-02-11": 228.0502938888889,
                "2026-03-18": 155.89570694444447
              },
              "time_count_per_day": {
                "2026-02-11": 1,
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-12-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-12-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_973": {
      "overall": {
        "avg_time_hours": 174.72,
        "mode_time_hours": 175.0,
        "mode_frequency": 1,
        "time_distribution": {
          "174-176h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 174.72236388888888
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 174.72,
          "mode_time_hours": 175.0,
          "mode_frequency": 1,
          "time_distribution": {
            "174-176h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 174.72236388888888
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 174.72,
            "mode_time_hours": 175.0,
            "mode_frequency": 1,
            "time_distribution": {
              "174-176h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 174.72236388888888
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 174.72,
              "mode_time_hours": 175.0,
              "mode_frequency": 1,
              "time_distribution": {
                "174-176h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 174.72236388888888
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_974": {
      "overall": {
        "avg_time_hours": 193.61,
        "mode_time_hours": 193.0,
        "mode_frequency": 1,
        "time_distribution": {
          "192-194h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 193.61447555555554
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 193.61,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "192-194h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 193.61447555555554
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 193.61,
            "mode_time_hours": 193.0,
            "mode_frequency": 1,
            "time_distribution": {
              "192-194h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 193.61447555555554
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 193.61,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "192-194h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 193.61447555555554
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_976": {
      "overall": {
        "avg_time_hours": 0.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {
          "2026-02-03": 0.1229
        },
        "time_count_per_day": {
          "2026-02-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {
            "2026-02-03": 0.1229
          },
          "time_count_per_day": {
            "2026-02-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {
              "2026-02-03": 0.1229
            },
            "time_count_per_day": {
              "2026-02-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {
                "2026-02-03": 0.1229
              },
              "time_count_per_day": {
                "2026-02-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_986": {
      "overall": {
        "avg_time_hours": 176.05,
        "mode_time_hours": 177.0,
        "mode_frequency": 1,
        "time_distribution": {
          "176-178h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 176.04659305555555
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 176.05,
          "mode_time_hours": 177.0,
          "mode_frequency": 1,
          "time_distribution": {
            "176-178h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 176.04659305555555
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 176.05,
            "mode_time_hours": 177.0,
            "mode_frequency": 1,
            "time_distribution": {
              "176-178h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 176.04659305555555
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 176.05,
              "mode_time_hours": 177.0,
              "mode_frequency": 1,
              "time_distribution": {
                "176-178h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 176.04659305555555
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_987": {
      "overall": {
        "avg_time_hours": 141.21,
        "mode_time_hours": 141.0,
        "mode_frequency": 1,
        "time_distribution": {
          "140-142h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 141.2115963888889
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 141.21,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 141.2115963888889
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.21,
            "mode_time_hours": 141.0,
            "mode_frequency": 1,
            "time_distribution": {
              "140-142h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 141.2115963888889
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 141.21,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 141.2115963888889
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_990": {
      "overall": {
        "avg_time_hours": 372.1,
        "mode_time_hours": 373.0,
        "mode_frequency": 1,
        "time_distribution": {
          "372-374h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 372.0985113888889
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 372.1,
          "mode_time_hours": 373.0,
          "mode_frequency": 1,
          "time_distribution": {
            "372-374h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 372.0985113888889
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 372.1,
            "mode_time_hours": 373.0,
            "mode_frequency": 1,
            "time_distribution": {
              "372-374h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 372.0985113888889
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 372.1,
              "mode_time_hours": 373.0,
              "mode_frequency": 1,
              "time_distribution": {
                "372-374h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 372.0985113888889
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_991": {
      "overall": {
        "avg_time_hours": 162.41,
        "mode_time_hours": 163.0,
        "mode_frequency": 1,
        "time_distribution": {
          "162-164h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 162.40711444444443
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 162.41,
          "mode_time_hours": 163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "162-164h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 162.40711444444443
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 162.41,
            "mode_time_hours": 163.0,
            "mode_frequency": 1,
            "time_distribution": {
              "162-164h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 162.40711444444443
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 162.41,
              "mode_time_hours": 163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "162-164h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 162.40711444444443
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_992": {
      "overall": {
        "avg_time_hours": 13.24,
        "mode_time_hours": 13.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-04": 1
        },
        "time_per_day": {
          "2026-02-04": 13.239726388888888
        },
        "time_count_per_day": {
          "2026-02-04": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 13.24,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 13.239726388888888
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.24,
            "mode_time_hours": 13.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-04": 1
            },
            "time_per_day": {
              "2026-02-04": 13.239726388888888
            },
            "time_count_per_day": {
              "2026-02-04": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 13.24,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 13.239726388888888
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_994": {
      "overall": {
        "avg_time_hours": 17.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 15,
        "time_distribution": {
          "0-2h": 15,
          "2-4h": 9,
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 4,
          "48-50h": 1,
          "120-122h": 1,
          "126-128h": 1,
          "216-218h": 1
        },
        "tickets_count": 36,
        "tickets_per_day": {
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-02-24": 1,
          "2026-02-28": 1,
          "2026-03-05": 4,
          "2026-03-07": 1,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-26": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-15": 1,
          "2026-04-24": 4,
          "2026-04-27": 1,
          "2026-04-28": 1,
          "2026-05-04": 2,
          "2026-05-11": 1,
          "2026-05-27": 1,
          "2026-05-30": 2,
          "2026-06-02": 3
        },
        "time_per_day": {
          "2026-02-04": 0.04184722222222222,
          "2026-02-10": 7.6165730555555555,
          "2026-02-12": 49.17926555555555,
          "2026-02-19": 217.524655,
          "2026-02-24": 2.3129647222222225,
          "2026-03-05": 152.37183583333334,
          "2026-03-07": 1.839653888888889,
          "2026-03-09": 1.4902669444444445,
          "2026-03-12": 4.586716666666667,
          "2026-03-13": 0.7513044444444444,
          "2026-03-16": 8.101870555555555,
          "2026-03-18": 120.7625675,
          "2026-03-26": 1.4287958333333333,
          "2026-03-31": 1.6921072222222222,
          "2026-04-08": 1.2247361111111112,
          "2026-04-15": 2.119053055555556,
          "2026-04-24": 2.789969166666667,
          "2026-04-27": 0.4590513888888889,
          "2026-04-28": 2.9420633333333335,
          "2026-05-04": 4.833153611111111,
          "2026-05-11": 1.5246694444444446,
          "2026-05-27": 3.564511111111111,
          "2026-05-30": 0.666603888888889,
          "2026-06-02": 8.720445833333333
        },
        "time_count_per_day": {
          "2026-02-04": 1,
          "2026-02-10": 1,
          "2026-02-12": 1,
          "2026-02-19": 1,
          "2026-02-24": 1,
          "2026-03-05": 4,
          "2026-03-07": 1,
          "2026-03-09": 1,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-26": 1,
          "2026-03-31": 1,
          "2026-04-08": 1,
          "2026-04-15": 1,
          "2026-04-24": 4,
          "2026-04-27": 1,
          "2026-04-28": 1,
          "2026-05-04": 2,
          "2026-05-11": 1,
          "2026-05-27": 1,
          "2026-05-30": 2,
          "2026-06-02": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 15,
          "time_distribution": {
            "0-2h": 15,
            "2-4h": 9,
            "4-6h": 1,
            "8-10h": 4,
            "126-128h": 1
          },
          "tickets_count": 30,
          "tickets_per_day": {
            "2026-02-04": 1,
            "2026-02-24": 1,
            "2026-03-05": 4,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-26": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-15": 1,
            "2026-04-24": 4,
            "2026-04-27": 1,
            "2026-04-28": 1,
            "2026-05-04": 2,
            "2026-05-11": 1,
            "2026-05-27": 1,
            "2026-05-30": 2,
            "2026-06-02": 3
          },
          "time_per_day": {
            "2026-02-04": 0.04184722222222222,
            "2026-02-24": 2.3129647222222225,
            "2026-03-05": 152.37183583333334,
            "2026-03-07": 1.839653888888889,
            "2026-03-09": 1.4902669444444445,
            "2026-03-12": 4.586716666666667,
            "2026-03-13": 0.7513044444444444,
            "2026-03-16": 8.101870555555555,
            "2026-03-26": 1.4287958333333333,
            "2026-03-31": 1.6921072222222222,
            "2026-04-08": 1.2247361111111112,
            "2026-04-15": 2.119053055555556,
            "2026-04-24": 2.789969166666667,
            "2026-04-27": 0.4590513888888889,
            "2026-04-28": 2.9420633333333335,
            "2026-05-04": 4.833153611111111,
            "2026-05-11": 1.5246694444444446,
            "2026-05-27": 3.564511111111111,
            "2026-05-30": 0.666603888888889,
            "2026-06-02": 8.720445833333333
          },
          "time_count_per_day": {
            "2026-02-04": 1,
            "2026-02-24": 1,
            "2026-03-05": 4,
            "2026-03-07": 1,
            "2026-03-09": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-26": 1,
            "2026-03-31": 1,
            "2026-04-08": 1,
            "2026-04-15": 1,
            "2026-04-24": 4,
            "2026-04-27": 1,
            "2026-04-28": 1,
            "2026-05-04": 2,
            "2026-05-11": 1,
            "2026-05-27": 1,
            "2026-05-30": 2,
            "2026-06-02": 3
          }
        },
        "P3": {
          "avg_time_hours": 28.4,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "48-50h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-10": 7.6165730555555555,
            "2026-02-12": 49.17926555555555
          },
          "time_count_per_day": {
            "2026-02-10": 1,
            "2026-02-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 120.76,
          "mode_time_hours": 121.0,
          "mode_frequency": 1,
          "time_distribution": {
            "120-122h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 1,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 120.7625675
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 217.52,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "216-218h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-19": 217.524655
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 15,
            "time_distribution": {
              "0-2h": 15,
              "2-4h": 9,
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 4,
              "48-50h": 1,
              "120-122h": 1,
              "126-128h": 1,
              "216-218h": 1
            },
            "tickets_count": 34,
            "tickets_per_day": {
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-19": 1,
              "2026-02-24": 1,
              "2026-03-05": 4,
              "2026-03-07": 1,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-18": 1,
              "2026-03-26": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-15": 1,
              "2026-04-24": 4,
              "2026-04-27": 1,
              "2026-04-28": 1,
              "2026-05-04": 2,
              "2026-05-11": 1,
              "2026-05-27": 1,
              "2026-05-30": 2,
              "2026-06-02": 3
            },
            "time_per_day": {
              "2026-02-04": 0.04184722222222222,
              "2026-02-10": 7.6165730555555555,
              "2026-02-12": 49.17926555555555,
              "2026-02-19": 217.524655,
              "2026-02-24": 2.3129647222222225,
              "2026-03-05": 152.37183583333334,
              "2026-03-07": 1.839653888888889,
              "2026-03-09": 1.4902669444444445,
              "2026-03-12": 4.586716666666667,
              "2026-03-13": 0.7513044444444444,
              "2026-03-16": 8.101870555555555,
              "2026-03-18": 120.7625675,
              "2026-03-26": 1.4287958333333333,
              "2026-03-31": 1.6921072222222222,
              "2026-04-08": 1.2247361111111112,
              "2026-04-15": 2.119053055555556,
              "2026-04-24": 2.789969166666667,
              "2026-04-27": 0.4590513888888889,
              "2026-04-28": 2.9420633333333335,
              "2026-05-04": 4.833153611111111,
              "2026-05-11": 1.5246694444444446,
              "2026-05-27": 3.564511111111111,
              "2026-05-30": 0.666603888888889,
              "2026-06-02": 8.720445833333333
            },
            "time_count_per_day": {
              "2026-02-04": 1,
              "2026-02-10": 1,
              "2026-02-12": 1,
              "2026-02-19": 1,
              "2026-02-24": 1,
              "2026-03-05": 4,
              "2026-03-07": 1,
              "2026-03-09": 1,
              "2026-03-12": 1,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-18": 1,
              "2026-03-26": 1,
              "2026-03-31": 1,
              "2026-04-08": 1,
              "2026-04-15": 1,
              "2026-04-24": 4,
              "2026-04-27": 1,
              "2026-04-28": 1,
              "2026-05-04": 2,
              "2026-05-11": 1,
              "2026-05-27": 1,
              "2026-05-30": 2,
              "2026-06-02": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 15,
              "time_distribution": {
                "0-2h": 15,
                "2-4h": 9,
                "4-6h": 1,
                "8-10h": 4,
                "126-128h": 1
              },
              "tickets_count": 30,
              "tickets_per_day": {
                "2026-02-04": 1,
                "2026-02-24": 1,
                "2026-03-05": 4,
                "2026-03-07": 1,
                "2026-03-09": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-26": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-15": 1,
                "2026-04-24": 4,
                "2026-04-27": 1,
                "2026-04-28": 1,
                "2026-05-04": 2,
                "2026-05-11": 1,
                "2026-05-27": 1,
                "2026-05-30": 2,
                "2026-06-02": 3
              },
              "time_per_day": {
                "2026-02-04": 0.04184722222222222,
                "2026-02-24": 2.3129647222222225,
                "2026-03-05": 152.37183583333334,
                "2026-03-07": 1.839653888888889,
                "2026-03-09": 1.4902669444444445,
                "2026-03-12": 4.586716666666667,
                "2026-03-13": 0.7513044444444444,
                "2026-03-16": 8.101870555555555,
                "2026-03-26": 1.4287958333333333,
                "2026-03-31": 1.6921072222222222,
                "2026-04-08": 1.2247361111111112,
                "2026-04-15": 2.119053055555556,
                "2026-04-24": 2.789969166666667,
                "2026-04-27": 0.4590513888888889,
                "2026-04-28": 2.9420633333333335,
                "2026-05-04": 4.833153611111111,
                "2026-05-11": 1.5246694444444446,
                "2026-05-27": 3.564511111111111,
                "2026-05-30": 0.666603888888889,
                "2026-06-02": 8.720445833333333
              },
              "time_count_per_day": {
                "2026-02-04": 1,
                "2026-02-24": 1,
                "2026-03-05": 4,
                "2026-03-07": 1,
                "2026-03-09": 1,
                "2026-03-12": 1,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-26": 1,
                "2026-03-31": 1,
                "2026-04-08": 1,
                "2026-04-15": 1,
                "2026-04-24": 4,
                "2026-04-27": 1,
                "2026-04-28": 1,
                "2026-05-04": 2,
                "2026-05-11": 1,
                "2026-05-27": 1,
                "2026-05-30": 2,
                "2026-06-02": 3
              }
            },
            "P3": {
              "avg_time_hours": 28.4,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "48-50h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-10": 1,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-10": 7.6165730555555555,
                "2026-02-12": 49.17926555555555
              },
              "time_count_per_day": {
                "2026-02-10": 1,
                "2026-02-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 120.76,
              "mode_time_hours": 121.0,
              "mode_frequency": 1,
              "time_distribution": {
                "120-122h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 120.7625675
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 217.52,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "216-218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 217.524655
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-20": 1,
              "2026-02-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_995": {
      "overall": {
        "avg_time_hours": 0.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-04": 2
        },
        "time_per_day": {
          "2026-02-04": 0.0625125
        },
        "time_count_per_day": {
          "2026-02-04": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-04": 2
          },
          "time_per_day": {
            "2026-02-04": 0.0625125
          },
          "time_count_per_day": {
            "2026-02-04": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-04": 2
            },
            "time_per_day": {
              "2026-02-04": 0.0625125
            },
            "time_count_per_day": {
              "2026-02-04": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-04": 2
              },
              "time_per_day": {
                "2026-02-04": 0.0625125
              },
              "time_count_per_day": {
                "2026-02-04": 2
              }
            }
          }
        }
      }
    },
    "cliente_997": {
      "overall": {
        "avg_time_hours": 141.59,
        "mode_time_hours": 141.0,
        "mode_frequency": 1,
        "time_distribution": {
          "140-142h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 141.58673416666667
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 141.59,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 141.58673416666667
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.59,
            "mode_time_hours": 141.0,
            "mode_frequency": 1,
            "time_distribution": {
              "140-142h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 141.58673416666667
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 141.59,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 141.58673416666667
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_125": {
      "overall": {
        "avg_time_hours": 0.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-04": 1
        },
        "time_per_day": {
          "2026-02-04": 0.14612027777777778
        },
        "time_count_per_day": {
          "2026-02-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-04": 1
          },
          "time_per_day": {
            "2026-02-04": 0.14612027777777778
          },
          "time_count_per_day": {
            "2026-02-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-04": 1
            },
            "time_per_day": {
              "2026-02-04": 0.14612027777777778
            },
            "time_count_per_day": {
              "2026-02-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-04": 1
              },
              "time_per_day": {
                "2026-02-04": 0.14612027777777778
              },
              "time_count_per_day": {
                "2026-02-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_999": {
      "overall": {
        "avg_time_hours": 2373.25,
        "mode_time_hours": 2373.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2372-2374h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-14": 1
        },
        "time_per_day": {
          "2026-05-14": 2373.254568055556
        },
        "time_count_per_day": {
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 2373.25,
          "mode_time_hours": 2373.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2372-2374h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-05-14": 2373.254568055556
          },
          "time_count_per_day": {
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2373.25,
            "mode_time_hours": 2373.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2372-2374h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-05-14": 2373.254568055556
            },
            "time_count_per_day": {
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 2373.25,
              "mode_time_hours": 2373.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2372-2374h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-05-14": 2373.254568055556
              },
              "time_count_per_day": {
                "2026-05-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_618": {
      "overall": {
        "avg_time_hours": 16.97,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "32-34h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-05": 1,
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-05": 0.8933538888888889,
          "2026-02-10": 33.053245833333335
        },
        "time_count_per_day": {
          "2026-02-05": 1,
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 33.05,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 33.053245833333335
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        },
        "P3": {
          "avg_time_hours": 0.89,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 0.8933538888888889
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.97,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "32-34h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-05": 1,
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-05": 0.8933538888888889,
              "2026-02-10": 33.053245833333335
            },
            "time_count_per_day": {
              "2026-02-05": 1,
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 33.05,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 33.053245833333335
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            },
            "P3": {
              "avg_time_hours": 0.89,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 0.8933538888888889
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1001": {
      "overall": {
        "avg_time_hours": 0.93,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-05": 1,
          "2026-04-01": 1
        },
        "time_per_day": {
          "2026-02-05": 0.9278908333333333
        },
        "time_count_per_day": {
          "2026-02-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 0.9278908333333333
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-01": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.93,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-05": 1
            },
            "time_per_day": {
              "2026-02-05": 0.9278908333333333
            },
            "time_count_per_day": {
              "2026-02-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 0.9278908333333333
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1002": {
      "overall": {
        "avg_time_hours": 0.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-05": 1
        },
        "time_per_day": {
          "2026-02-05": 0.6034380555555555
        },
        "time_count_per_day": {
          "2026-02-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.6,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 0.6034380555555555
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-05": 1
            },
            "time_per_day": {
              "2026-02-05": 0.6034380555555555
            },
            "time_count_per_day": {
              "2026-02-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.6,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 0.6034380555555555
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1003": {
      "overall": {
        "avg_time_hours": 173.43,
        "mode_time_hours": 173.0,
        "mode_frequency": 1,
        "time_distribution": {
          "172-174h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 173.4266552777778
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 173.43,
          "mode_time_hours": 173.0,
          "mode_frequency": 1,
          "time_distribution": {
            "172-174h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 173.4266552777778
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 173.43,
            "mode_time_hours": 173.0,
            "mode_frequency": 1,
            "time_distribution": {
              "172-174h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 173.4266552777778
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 173.43,
              "mode_time_hours": 173.0,
              "mode_frequency": 1,
              "time_distribution": {
                "172-174h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 173.4266552777778
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1004": {
      "overall": {
        "avg_time_hours": 2.49,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-05": 1
        },
        "time_per_day": {
          "2026-02-05": 2.486108333333333
        },
        "time_count_per_day": {
          "2026-02-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.49,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 2.486108333333333
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.49,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-05": 1
            },
            "time_per_day": {
              "2026-02-05": 2.486108333333333
            },
            "time_count_per_day": {
              "2026-02-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.49,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 2.486108333333333
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1005": {
      "overall": {
        "avg_time_hours": 1.55,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-05": 1
        },
        "time_per_day": {
          "2026-02-05": 1.5483627777777778
        },
        "time_count_per_day": {
          "2026-02-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-05": 1
          },
          "time_per_day": {
            "2026-02-05": 1.5483627777777778
          },
          "time_count_per_day": {
            "2026-02-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.55,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-05": 1
            },
            "time_per_day": {
              "2026-02-05": 1.5483627777777778
            },
            "time_count_per_day": {
              "2026-02-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-05": 1
              },
              "time_per_day": {
                "2026-02-05": 1.5483627777777778
              },
              "time_count_per_day": {
                "2026-02-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1006": {
      "overall": {
        "avg_time_hours": 328.74,
        "mode_time_hours": 329.0,
        "mode_frequency": 1,
        "time_distribution": {
          "328-330h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 328.7431752777778
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 328.74,
          "mode_time_hours": 329.0,
          "mode_frequency": 1,
          "time_distribution": {
            "328-330h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 328.7431752777778
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 328.74,
            "mode_time_hours": 329.0,
            "mode_frequency": 1,
            "time_distribution": {
              "328-330h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 328.7431752777778
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 328.74,
              "mode_time_hours": 329.0,
              "mode_frequency": 1,
              "time_distribution": {
                "328-330h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 328.7431752777778
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1007": {
      "overall": {
        "avg_time_hours": 328.62,
        "mode_time_hours": 329.0,
        "mode_frequency": 1,
        "time_distribution": {
          "328-330h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 328.61836583333337
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 328.62,
          "mode_time_hours": 329.0,
          "mode_frequency": 1,
          "time_distribution": {
            "328-330h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 328.61836583333337
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 328.62,
            "mode_time_hours": 329.0,
            "mode_frequency": 1,
            "time_distribution": {
              "328-330h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 328.61836583333337
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 328.62,
              "mode_time_hours": 329.0,
              "mode_frequency": 1,
              "time_distribution": {
                "328-330h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 328.61836583333337
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1010": {
      "overall": {
        "avg_time_hours": 162.06,
        "mode_time_hours": 323.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "322-324h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-06": 1,
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-06": 0.6548488888888889,
          "2026-02-19": 323.4562780555556
        },
        "time_count_per_day": {
          "2026-02-06": 1,
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 0.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 0.6548488888888889
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 323.46,
          "mode_time_hours": 323.0,
          "mode_frequency": 1,
          "time_distribution": {
            "322-324h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 323.4562780555556
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 162.06,
            "mode_time_hours": 323.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "322-324h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-06": 1,
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-06": 0.6548488888888889,
              "2026-02-19": 323.4562780555556
            },
            "time_count_per_day": {
              "2026-02-06": 1,
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 0.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 0.6548488888888889
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            },
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 323.46,
              "mode_time_hours": 323.0,
              "mode_frequency": 1,
              "time_distribution": {
                "322-324h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 323.4562780555556
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1012": {
      "overall": {
        "avg_time_hours": 75.9,
        "mode_time_hours": 75.0,
        "mode_frequency": 1,
        "time_distribution": {
          "74-76h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 75.89560777777778
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 75.9,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 75.89560777777778
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 75.9,
            "mode_time_hours": 75.0,
            "mode_frequency": 1,
            "time_distribution": {
              "74-76h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 75.89560777777778
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 75.9,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 75.89560777777778
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1013": {
      "overall": {
        "avg_time_hours": 64.49,
        "mode_time_hours": 9.0,
        "mode_frequency": 2,
        "time_distribution": {
          "8-10h": 2,
          "66-68h": 1,
          "68-70h": 1,
          "74-76h": 1,
          "158-160h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2026-02-09": 5,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-03-16": 1,
          "2026-04-21": 1
        },
        "time_per_day": {
          "2026-02-09": 228.25711750000002,
          "2026-02-12": 158.70321583333336
        },
        "time_count_per_day": {
          "2026-02-09": 5,
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 58.44,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 2,
            "158-160h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-09": 2,
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-09": 16.604679166666667,
            "2026-02-12": 158.70321583333336
          },
          "time_count_per_day": {
            "2026-02-09": 2,
            "2026-02-12": 1
          }
        },
        "P3": {
          "avg_time_hours": 70.55,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1,
            "68-70h": 1,
            "74-76h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-09": 3
          },
          "time_per_day": {
            "2026-02-09": 211.65243833333335
          },
          "time_count_per_day": {
            "2026-02-09": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-14": 1,
            "2026-03-16": 1,
            "2026-04-21": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 64.49,
            "mode_time_hours": 9.0,
            "mode_frequency": 2,
            "time_distribution": {
              "8-10h": 2,
              "66-68h": 1,
              "68-70h": 1,
              "74-76h": 1,
              "158-160h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-02-09": 5,
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-09": 228.25711750000002,
              "2026-02-12": 158.70321583333336
            },
            "time_count_per_day": {
              "2026-02-09": 5,
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 58.44,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 2,
                "158-160h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-09": 2,
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-09": 16.604679166666667,
                "2026-02-12": 158.70321583333336
              },
              "time_count_per_day": {
                "2026-02-09": 2,
                "2026-02-12": 1
              }
            },
            "P3": {
              "avg_time_hours": 70.55,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1,
                "68-70h": 1,
                "74-76h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-09": 3
              },
              "time_per_day": {
                "2026-02-09": 211.65243833333335
              },
              "time_count_per_day": {
                "2026-02-09": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-14": 1,
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-14": 1,
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-21": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1014": {
      "overall": {
        "avg_time_hours": 19.38,
        "mode_time_hours": 5.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "4-6h": 3,
          "8-10h": 2,
          "32-34h": 2,
          "34-36h": 1,
          "80-82h": 1
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-18": 3,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-19": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-02-09": 80.77022444444445,
          "2026-02-10": 32.06006361111111,
          "2026-02-18": 49.190275277777786,
          "2026-03-09": 1.3864400000000001,
          "2026-03-10": 34.533409722222224,
          "2026-05-12": 5.017888611111111,
          "2026-05-14": 4.816278888888888,
          "2026-05-18": 4.339046388888889,
          "2026-05-19": 1.0719783333333333
        },
        "time_count_per_day": {
          "2026-02-09": 1,
          "2026-02-10": 1,
          "2026-02-18": 3,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-05-12": 1,
          "2026-05-14": 1,
          "2026-05-18": 1,
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.15,
          "mode_time_hours": 5.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 3,
            "8-10h": 2,
            "32-34h": 1,
            "34-36h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-02-18": 3,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-02-18": 49.190275277777786,
            "2026-03-09": 1.3864400000000001,
            "2026-03-10": 34.533409722222224,
            "2026-05-12": 5.017888611111111,
            "2026-05-14": 4.816278888888888,
            "2026-05-18": 4.339046388888889,
            "2026-05-19": 1.0719783333333333
          },
          "time_count_per_day": {
            "2026-02-18": 3,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-05-12": 1,
            "2026-05-14": 1,
            "2026-05-18": 1,
            "2026-05-19": 1
          }
        },
        "P3": {
          "avg_time_hours": 56.42,
          "mode_time_hours": 81.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1,
            "80-82h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-09": 1,
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-09": 80.77022444444445,
            "2026-02-10": 32.06006361111111
          },
          "time_count_per_day": {
            "2026-02-09": 1,
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.38,
            "mode_time_hours": 5.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "4-6h": 3,
              "8-10h": 2,
              "32-34h": 2,
              "34-36h": 1,
              "80-82h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-18": 3,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-19": 1
            },
            "time_per_day": {
              "2026-02-09": 80.77022444444445,
              "2026-02-10": 32.06006361111111,
              "2026-02-18": 49.190275277777786,
              "2026-03-09": 1.3864400000000001,
              "2026-03-10": 34.533409722222224,
              "2026-05-12": 5.017888611111111,
              "2026-05-14": 4.816278888888888,
              "2026-05-18": 4.339046388888889,
              "2026-05-19": 1.0719783333333333
            },
            "time_count_per_day": {
              "2026-02-09": 1,
              "2026-02-10": 1,
              "2026-02-18": 3,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-05-12": 1,
              "2026-05-14": 1,
              "2026-05-18": 1,
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.15,
              "mode_time_hours": 5.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 3,
                "8-10h": 2,
                "32-34h": 1,
                "34-36h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-02-18": 3,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-02-18": 49.190275277777786,
                "2026-03-09": 1.3864400000000001,
                "2026-03-10": 34.533409722222224,
                "2026-05-12": 5.017888611111111,
                "2026-05-14": 4.816278888888888,
                "2026-05-18": 4.339046388888889,
                "2026-05-19": 1.0719783333333333
              },
              "time_count_per_day": {
                "2026-02-18": 3,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-05-12": 1,
                "2026-05-14": 1,
                "2026-05-18": 1,
                "2026-05-19": 1
              }
            },
            "P3": {
              "avg_time_hours": 56.42,
              "mode_time_hours": 81.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1,
                "80-82h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-09": 1,
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-09": 80.77022444444445,
                "2026-02-10": 32.06006361111111
              },
              "time_count_per_day": {
                "2026-02-09": 1,
                "2026-02-10": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1015": {
      "overall": {
        "avg_time_hours": 0.71,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-06": 1
        },
        "time_per_day": {
          "2026-02-06": 0.7096441666666666
        },
        "time_count_per_day": {
          "2026-02-06": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 0.71,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-06": 1
          },
          "time_per_day": {
            "2026-02-06": 0.7096441666666666
          },
          "time_count_per_day": {
            "2026-02-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.71,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-06": 1
            },
            "time_per_day": {
              "2026-02-06": 0.7096441666666666
            },
            "time_count_per_day": {
              "2026-02-06": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 0.71,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-06": 1
              },
              "time_per_day": {
                "2026-02-06": 0.7096441666666666
              },
              "time_count_per_day": {
                "2026-02-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_94": {
      "overall": {
        "avg_time_hours": 503.9,
        "mode_time_hours": 503.0,
        "mode_frequency": 1,
        "time_distribution": {
          "502-504h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-27": 1
        },
        "time_per_day": {
          "2026-02-27": 503.90358944444444
        },
        "time_count_per_day": {
          "2026-02-27": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 503.9,
          "mode_time_hours": 503.0,
          "mode_frequency": 1,
          "time_distribution": {
            "502-504h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-27": 1
          },
          "time_per_day": {
            "2026-02-27": 503.90358944444444
          },
          "time_count_per_day": {
            "2026-02-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 503.9,
            "mode_time_hours": 503.0,
            "mode_frequency": 1,
            "time_distribution": {
              "502-504h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-27": 1
            },
            "time_per_day": {
              "2026-02-27": 503.90358944444444
            },
            "time_count_per_day": {
              "2026-02-27": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 503.9,
              "mode_time_hours": 503.0,
              "mode_frequency": 1,
              "time_distribution": {
                "502-504h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-27": 1
              },
              "time_per_day": {
                "2026-02-27": 503.90358944444444
              },
              "time_count_per_day": {
                "2026-02-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1017": {
      "overall": {
        "avg_time_hours": 79.3,
        "mode_time_hours": 79.0,
        "mode_frequency": 1,
        "time_distribution": {
          "78-80h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 79.30431083333333
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 79.3,
          "mode_time_hours": 79.0,
          "mode_frequency": 1,
          "time_distribution": {
            "78-80h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 79.30431083333333
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 79.3,
            "mode_time_hours": 79.0,
            "mode_frequency": 1,
            "time_distribution": {
              "78-80h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 79.30431083333333
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 79.3,
              "mode_time_hours": 79.0,
              "mode_frequency": 1,
              "time_distribution": {
                "78-80h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 79.30431083333333
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1018": {
      "overall": {
        "avg_time_hours": 552.73,
        "mode_time_hours": 1105.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "1104-1106h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-24": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-03-24": 1105.2503619444444,
          "2026-05-30": 0.2098211111111111
        },
        "time_count_per_day": {
          "2026-03-24": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.2098211111111111
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 1105.25,
          "mode_time_hours": 1105.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1104-1106h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 1105.2503619444444
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 552.73,
            "mode_time_hours": 1105.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "1104-1106h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-24": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-03-24": 1105.2503619444444,
              "2026-05-30": 0.2098211111111111
            },
            "time_count_per_day": {
              "2026-03-24": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.2098211111111111
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 1105.25,
              "mode_time_hours": 1105.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1104-1106h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 1105.2503619444444
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1019": {
      "overall": {
        "avg_time_hours": 268.15,
        "mode_time_hours": 269.0,
        "mode_frequency": 1,
        "time_distribution": {
          "268-270h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-17": 1
        },
        "time_per_day": {
          "2026-02-17": 268.15038111111113
        },
        "time_count_per_day": {
          "2026-02-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 268.15,
          "mode_time_hours": 269.0,
          "mode_frequency": 1,
          "time_distribution": {
            "268-270h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-17": 1
          },
          "time_per_day": {
            "2026-02-17": 268.15038111111113
          },
          "time_count_per_day": {
            "2026-02-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 268.15,
            "mode_time_hours": 269.0,
            "mode_frequency": 1,
            "time_distribution": {
              "268-270h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-17": 1
            },
            "time_per_day": {
              "2026-02-17": 268.15038111111113
            },
            "time_count_per_day": {
              "2026-02-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 268.15,
              "mode_time_hours": 269.0,
              "mode_frequency": 1,
              "time_distribution": {
                "268-270h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-17": 1
              },
              "time_per_day": {
                "2026-02-17": 268.15038111111113
              },
              "time_count_per_day": {
                "2026-02-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1021": {
      "overall": {
        "avg_time_hours": 300.27,
        "mode_time_hours": 301.0,
        "mode_frequency": 2,
        "time_distribution": {
          "300-302h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-19": 2
        },
        "time_per_day": {
          "2026-02-19": 600.5474069444444
        },
        "time_count_per_day": {
          "2026-02-19": 2
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 300.27,
          "mode_time_hours": 301.0,
          "mode_frequency": 2,
          "time_distribution": {
            "300-302h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 600.5474069444444
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 300.27,
            "mode_time_hours": 301.0,
            "mode_frequency": 2,
            "time_distribution": {
              "300-302h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 2
            },
            "time_per_day": {
              "2026-02-19": 600.5474069444444
            },
            "time_count_per_day": {
              "2026-02-19": 2
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 300.27,
              "mode_time_hours": 301.0,
              "mode_frequency": 2,
              "time_distribution": {
                "300-302h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 600.5474069444444
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_1022": {
      "overall": {
        "avg_time_hours": 206.59,
        "mode_time_hours": 1.0,
        "mode_frequency": 10,
        "time_distribution": {
          "0-2h": 10,
          "2-4h": 1,
          "14-16h": 1,
          "18-20h": 2,
          "20-22h": 1,
          "28-30h": 1,
          "34-36h": 1,
          "48-50h": 1,
          "58-60h": 1,
          "66-68h": 1,
          "414-416h": 1,
          "542-544h": 1,
          "582-584h": 1,
          "584-586h": 1,
          "614-616h": 1,
          "616-618h": 1,
          "916-918h": 1,
          "1180-1182h": 1
        },
        "tickets_count": 28,
        "tickets_per_day": {
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-03-11": 1,
          "2026-03-12": 2,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-04-04": 1,
          "2026-04-15": 1,
          "2026-04-23": 5,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-28": 2,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-02-09": 59.04768722222222,
          "2026-02-19": 15.4078125,
          "2026-03-11": 1.413718611111111,
          "2026-03-12": 3.0279194444444446,
          "2026-03-13": 66.96038805555555,
          "2026-03-16": 0.6666991666666667,
          "2026-03-17": 34.478102222222226,
          "2026-03-19": 1.5215341666666666,
          "2026-03-20": 20.338539722222222,
          "2026-03-27": 29.54877638888889,
          "2026-03-30": 0.19105194444444445,
          "2026-04-04": 0.7063947222222223,
          "2026-04-15": 48.140790833333334,
          "2026-04-23": 2091.7369305555553,
          "2026-05-06": 1231.9624913888888,
          "2026-05-08": 543.2992800000001,
          "2026-05-14": 415.9370744444445,
          "2026-05-19": 0.7907236111111111,
          "2026-05-20": 0.2505102777777778,
          "2026-05-28": 38.51036888888889,
          "2026-05-30": 1180.723075277778
        },
        "time_count_per_day": {
          "2026-02-09": 1,
          "2026-02-19": 1,
          "2026-03-11": 1,
          "2026-03-12": 2,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-03-17": 1,
          "2026-03-19": 1,
          "2026-03-20": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-04-04": 1,
          "2026-04-15": 1,
          "2026-04-23": 5,
          "2026-05-06": 2,
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-05-19": 1,
          "2026-05-20": 1,
          "2026-05-28": 2,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1180.72,
          "mode_time_hours": 1181.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1180-1182h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 1180.723075277778
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        },
        "P2": {
          "avg_time_hours": 131.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 10,
          "time_distribution": {
            "0-2h": 10,
            "2-4h": 1,
            "18-20h": 2,
            "20-22h": 1,
            "28-30h": 1,
            "48-50h": 1,
            "58-60h": 1,
            "66-68h": 1,
            "414-416h": 1,
            "542-544h": 1,
            "582-584h": 1,
            "584-586h": 1,
            "614-616h": 1
          },
          "tickets_count": 23,
          "tickets_per_day": {
            "2026-02-09": 1,
            "2026-03-11": 1,
            "2026-03-12": 2,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-03-30": 1,
            "2026-04-04": 1,
            "2026-04-15": 1,
            "2026-04-23": 4,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-28": 2
          },
          "time_per_day": {
            "2026-02-09": 59.04768722222222,
            "2026-03-11": 1.413718611111111,
            "2026-03-12": 3.0279194444444446,
            "2026-03-13": 66.96038805555555,
            "2026-03-16": 0.6666991666666667,
            "2026-03-19": 1.5215341666666666,
            "2026-03-20": 20.338539722222222,
            "2026-03-27": 29.54877638888889,
            "2026-03-30": 0.19105194444444445,
            "2026-04-04": 0.7063947222222223,
            "2026-04-15": 48.140790833333334,
            "2026-04-23": 1174.2493625,
            "2026-05-06": 614.1635172222223,
            "2026-05-08": 543.2992800000001,
            "2026-05-14": 415.9370744444445,
            "2026-05-19": 0.7907236111111111,
            "2026-05-20": 0.2505102777777778,
            "2026-05-28": 38.51036888888889
          },
          "time_count_per_day": {
            "2026-02-09": 1,
            "2026-03-11": 1,
            "2026-03-12": 2,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-03-19": 1,
            "2026-03-20": 1,
            "2026-03-27": 1,
            "2026-03-30": 1,
            "2026-04-04": 1,
            "2026-04-15": 1,
            "2026-04-23": 4,
            "2026-05-06": 1,
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-28": 2
          }
        },
        "P3": {
          "avg_time_hours": 516.9,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "616-618h": 1,
            "916-918h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-04-23": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-02-19": 15.4078125,
            "2026-04-23": 917.4875680555556,
            "2026-05-06": 617.7989741666667
          },
          "time_count_per_day": {
            "2026-02-19": 1,
            "2026-04-23": 1,
            "2026-05-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 34.48,
          "mode_time_hours": 35.0,
          "mode_frequency": 1,
          "time_distribution": {
            "34-36h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 34.478102222222226
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 206.59,
            "mode_time_hours": 1.0,
            "mode_frequency": 10,
            "time_distribution": {
              "0-2h": 10,
              "2-4h": 1,
              "14-16h": 1,
              "18-20h": 2,
              "20-22h": 1,
              "28-30h": 1,
              "34-36h": 1,
              "48-50h": 1,
              "58-60h": 1,
              "66-68h": 1,
              "414-416h": 1,
              "542-544h": 1,
              "582-584h": 1,
              "584-586h": 1,
              "614-616h": 1,
              "616-618h": 1,
              "916-918h": 1,
              "1180-1182h": 1
            },
            "tickets_count": 28,
            "tickets_per_day": {
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-03-11": 1,
              "2026-03-12": 2,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-04": 1,
              "2026-04-15": 1,
              "2026-04-23": 5,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-28": 2,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-02-09": 59.04768722222222,
              "2026-02-19": 15.4078125,
              "2026-03-11": 1.413718611111111,
              "2026-03-12": 3.0279194444444446,
              "2026-03-13": 66.96038805555555,
              "2026-03-16": 0.6666991666666667,
              "2026-03-17": 34.478102222222226,
              "2026-03-19": 1.5215341666666666,
              "2026-03-20": 20.338539722222222,
              "2026-03-27": 29.54877638888889,
              "2026-03-30": 0.19105194444444445,
              "2026-04-04": 0.7063947222222223,
              "2026-04-15": 48.140790833333334,
              "2026-04-23": 2091.7369305555553,
              "2026-05-06": 1231.9624913888888,
              "2026-05-08": 543.2992800000001,
              "2026-05-14": 415.9370744444445,
              "2026-05-19": 0.7907236111111111,
              "2026-05-20": 0.2505102777777778,
              "2026-05-28": 38.51036888888889,
              "2026-05-30": 1180.723075277778
            },
            "time_count_per_day": {
              "2026-02-09": 1,
              "2026-02-19": 1,
              "2026-03-11": 1,
              "2026-03-12": 2,
              "2026-03-13": 1,
              "2026-03-16": 1,
              "2026-03-17": 1,
              "2026-03-19": 1,
              "2026-03-20": 1,
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-04-04": 1,
              "2026-04-15": 1,
              "2026-04-23": 5,
              "2026-05-06": 2,
              "2026-05-08": 1,
              "2026-05-14": 1,
              "2026-05-19": 1,
              "2026-05-20": 1,
              "2026-05-28": 2,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1180.72,
              "mode_time_hours": 1181.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1180-1182h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 1180.723075277778
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            },
            "P2": {
              "avg_time_hours": 131.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 10,
              "time_distribution": {
                "0-2h": 10,
                "2-4h": 1,
                "18-20h": 2,
                "20-22h": 1,
                "28-30h": 1,
                "48-50h": 1,
                "58-60h": 1,
                "66-68h": 1,
                "414-416h": 1,
                "542-544h": 1,
                "582-584h": 1,
                "584-586h": 1,
                "614-616h": 1
              },
              "tickets_count": 23,
              "tickets_per_day": {
                "2026-02-09": 1,
                "2026-03-11": 1,
                "2026-03-12": 2,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-03-30": 1,
                "2026-04-04": 1,
                "2026-04-15": 1,
                "2026-04-23": 4,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-28": 2
              },
              "time_per_day": {
                "2026-02-09": 59.04768722222222,
                "2026-03-11": 1.413718611111111,
                "2026-03-12": 3.0279194444444446,
                "2026-03-13": 66.96038805555555,
                "2026-03-16": 0.6666991666666667,
                "2026-03-19": 1.5215341666666666,
                "2026-03-20": 20.338539722222222,
                "2026-03-27": 29.54877638888889,
                "2026-03-30": 0.19105194444444445,
                "2026-04-04": 0.7063947222222223,
                "2026-04-15": 48.140790833333334,
                "2026-04-23": 1174.2493625,
                "2026-05-06": 614.1635172222223,
                "2026-05-08": 543.2992800000001,
                "2026-05-14": 415.9370744444445,
                "2026-05-19": 0.7907236111111111,
                "2026-05-20": 0.2505102777777778,
                "2026-05-28": 38.51036888888889
              },
              "time_count_per_day": {
                "2026-02-09": 1,
                "2026-03-11": 1,
                "2026-03-12": 2,
                "2026-03-13": 1,
                "2026-03-16": 1,
                "2026-03-19": 1,
                "2026-03-20": 1,
                "2026-03-27": 1,
                "2026-03-30": 1,
                "2026-04-04": 1,
                "2026-04-15": 1,
                "2026-04-23": 4,
                "2026-05-06": 1,
                "2026-05-08": 1,
                "2026-05-14": 1,
                "2026-05-19": 1,
                "2026-05-20": 1,
                "2026-05-28": 2
              }
            },
            "P3": {
              "avg_time_hours": 516.9,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "616-618h": 1,
                "916-918h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-19": 1,
                "2026-04-23": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-02-19": 15.4078125,
                "2026-04-23": 917.4875680555556,
                "2026-05-06": 617.7989741666667
              },
              "time_count_per_day": {
                "2026-02-19": 1,
                "2026-04-23": 1,
                "2026-05-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 34.48,
              "mode_time_hours": 35.0,
              "mode_frequency": 1,
              "time_distribution": {
                "34-36h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 34.478102222222226
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1023": {
      "overall": {
        "avg_time_hours": 872.59,
        "mode_time_hours": 873.0,
        "mode_frequency": 1,
        "time_distribution": {
          "872-874h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-17": 872.5859886111111
        },
        "time_count_per_day": {
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 872.59,
          "mode_time_hours": 873.0,
          "mode_frequency": 1,
          "time_distribution": {
            "872-874h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 872.5859886111111
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 872.59,
            "mode_time_hours": 873.0,
            "mode_frequency": 1,
            "time_distribution": {
              "872-874h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-17": 872.5859886111111
            },
            "time_count_per_day": {
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 872.59,
              "mode_time_hours": 873.0,
              "mode_frequency": 1,
              "time_distribution": {
                "872-874h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 872.5859886111111
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1024": {
      "overall": {
        "avg_time_hours": 1.95,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 1.949233611111111
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.95,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 1.949233611111111
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.95,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 1.949233611111111
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.95,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 1.949233611111111
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1025": {
      "overall": {
        "avg_time_hours": 30.71,
        "mode_time_hours": 31.0,
        "mode_frequency": 1,
        "time_distribution": {
          "30-32h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 30.71145
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 30.71,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 30.71145
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 30.71,
            "mode_time_hours": 31.0,
            "mode_frequency": 1,
            "time_distribution": {
              "30-32h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 30.71145
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 30.71,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 30.71145
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1026": {
      "overall": {
        "avg_time_hours": 8.28,
        "mode_time_hours": 9.0,
        "mode_frequency": 2,
        "time_distribution": {
          "8-10h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-09": 2
        },
        "time_per_day": {
          "2026-02-09": 16.55616138888889
        },
        "time_count_per_day": {
          "2026-02-09": 2
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 8.28,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-09": 2
          },
          "time_per_day": {
            "2026-02-09": 16.55616138888889
          },
          "time_count_per_day": {
            "2026-02-09": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.28,
            "mode_time_hours": 9.0,
            "mode_frequency": 2,
            "time_distribution": {
              "8-10h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-09": 2
            },
            "time_per_day": {
              "2026-02-09": 16.55616138888889
            },
            "time_count_per_day": {
              "2026-02-09": 2
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 8.28,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-09": 2
              },
              "time_per_day": {
                "2026-02-09": 16.55616138888889
              },
              "time_count_per_day": {
                "2026-02-09": 2
              }
            }
          }
        }
      }
    },
    "cliente_1027": {
      "overall": {
        "avg_time_hours": 221.9,
        "mode_time_hours": 221.0,
        "mode_frequency": 1,
        "time_distribution": {
          "220-222h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 221.8967186111111
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 221.9,
          "mode_time_hours": 221.0,
          "mode_frequency": 1,
          "time_distribution": {
            "220-222h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 221.8967186111111
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 221.9,
            "mode_time_hours": 221.0,
            "mode_frequency": 1,
            "time_distribution": {
              "220-222h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 221.8967186111111
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 221.9,
              "mode_time_hours": 221.0,
              "mode_frequency": 1,
              "time_distribution": {
                "220-222h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 221.8967186111111
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1028": {
      "overall": {
        "avg_time_hours": 15.77,
        "mode_time_hours": 31.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "30-32h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-10": 1,
          "2026-04-07": 1
        },
        "time_per_day": {
          "2026-02-10": 31.40515305555556,
          "2026-04-07": 0.14199722222222222
        },
        "time_count_per_day": {
          "2026-02-10": 1,
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-07": 1
          },
          "time_per_day": {
            "2026-04-07": 0.14199722222222222
          },
          "time_count_per_day": {
            "2026-04-07": 1
          }
        },
        "P3": {
          "avg_time_hours": 31.41,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 31.40515305555556
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.77,
            "mode_time_hours": 31.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "30-32h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-10": 1,
              "2026-04-07": 1
            },
            "time_per_day": {
              "2026-02-10": 31.40515305555556,
              "2026-04-07": 0.14199722222222222
            },
            "time_count_per_day": {
              "2026-02-10": 1,
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.14,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {
                "2026-04-07": 0.14199722222222222
              },
              "time_count_per_day": {
                "2026-04-07": 1
              }
            },
            "P3": {
              "avg_time_hours": 31.41,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 31.40515305555556
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1029": {
      "overall": {
        "avg_time_hours": 741.37,
        "mode_time_hours": 873.0,
        "mode_frequency": 1,
        "time_distribution": {
          "582-584h": 1,
          "768-770h": 1,
          "872-874h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-17": 3
        },
        "time_per_day": {
          "2026-03-17": 2224.11756
        },
        "time_count_per_day": {
          "2026-03-17": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 582.57,
          "mode_time_hours": 583.0,
          "mode_frequency": 1,
          "time_distribution": {
            "582-584h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 582.5708830555556
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        },
        "P3": {
          "avg_time_hours": 820.77,
          "mode_time_hours": 873.0,
          "mode_frequency": 1,
          "time_distribution": {
            "768-770h": 1,
            "872-874h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-17": 2
          },
          "time_per_day": {
            "2026-03-17": 1641.5466769444445
          },
          "time_count_per_day": {
            "2026-03-17": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 741.37,
            "mode_time_hours": 873.0,
            "mode_frequency": 1,
            "time_distribution": {
              "582-584h": 1,
              "768-770h": 1,
              "872-874h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-17": 3
            },
            "time_per_day": {
              "2026-03-17": 2224.11756
            },
            "time_count_per_day": {
              "2026-03-17": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 582.57,
              "mode_time_hours": 583.0,
              "mode_frequency": 1,
              "time_distribution": {
                "582-584h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 582.5708830555556
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            },
            "P3": {
              "avg_time_hours": 820.77,
              "mode_time_hours": 873.0,
              "mode_frequency": 1,
              "time_distribution": {
                "768-770h": 1,
                "872-874h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-17": 2
              },
              "time_per_day": {
                "2026-03-17": 1641.5466769444445
              },
              "time_count_per_day": {
                "2026-03-17": 2
              }
            }
          }
        }
      }
    },
    "cliente_1032": {
      "overall": {
        "avg_time_hours": 0.7,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 0.6966836111111111
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 0.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 0.6966836111111111
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.7,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 0.6966836111111111
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 0.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 0.6966836111111111
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1033": {
      "overall": {
        "avg_time_hours": 654.75,
        "mode_time_hours": 937.0,
        "mode_frequency": 1,
        "time_distribution": {
          "372-374h": 1,
          "936-938h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-10": 372.84578166666665,
          "2026-03-20": 936.6609602777778
        },
        "time_count_per_day": {
          "2026-03-10": 1,
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 654.75,
          "mode_time_hours": 937.0,
          "mode_frequency": 1,
          "time_distribution": {
            "372-374h": 1,
            "936-938h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-10": 372.84578166666665,
            "2026-03-20": 936.6609602777778
          },
          "time_count_per_day": {
            "2026-03-10": 1,
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 654.75,
            "mode_time_hours": 937.0,
            "mode_frequency": 1,
            "time_distribution": {
              "372-374h": 1,
              "936-938h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-10": 372.84578166666665,
              "2026-03-20": 936.6609602777778
            },
            "time_count_per_day": {
              "2026-03-10": 1,
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 654.75,
              "mode_time_hours": 937.0,
              "mode_frequency": 1,
              "time_distribution": {
                "372-374h": 1,
                "936-938h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-10": 372.84578166666665,
                "2026-03-20": 936.6609602777778
              },
              "time_count_per_day": {
                "2026-03-10": 1,
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1034": {
      "overall": {
        "avg_time_hours": 3.55,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 3.5529797222222226
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.55,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 3.5529797222222226
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.55,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 3.5529797222222226
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.55,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 3.5529797222222226
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1036": {
      "overall": {
        "avg_time_hours": 232.92,
        "mode_time_hours": 233.0,
        "mode_frequency": 1,
        "time_distribution": {
          "232-234h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 232.92295444444446
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 232.92,
          "mode_time_hours": 233.0,
          "mode_frequency": 1,
          "time_distribution": {
            "232-234h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 232.92295444444446
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 232.92,
            "mode_time_hours": 233.0,
            "mode_frequency": 1,
            "time_distribution": {
              "232-234h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 232.92295444444446
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 232.92,
              "mode_time_hours": 233.0,
              "mode_frequency": 1,
              "time_distribution": {
                "232-234h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 232.92295444444446
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1037": {
      "overall": {
        "avg_time_hours": 0.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-09": 1,
          "2026-04-13": 3
        },
        "time_per_day": {
          "2026-02-09": 0.3477719444444445,
          "2026-04-13": 1.7302405555555558
        },
        "time_count_per_day": {
          "2026-02-09": 1,
          "2026-04-13": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-09": 1,
            "2026-04-13": 3
          },
          "time_per_day": {
            "2026-02-09": 0.3477719444444445,
            "2026-04-13": 1.7302405555555558
          },
          "time_count_per_day": {
            "2026-02-09": 1,
            "2026-04-13": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-09": 1,
              "2026-04-13": 3
            },
            "time_per_day": {
              "2026-02-09": 0.3477719444444445,
              "2026-04-13": 1.7302405555555558
            },
            "time_count_per_day": {
              "2026-02-09": 1,
              "2026-04-13": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-09": 1,
                "2026-04-13": 3
              },
              "time_per_day": {
                "2026-02-09": 0.3477719444444445,
                "2026-04-13": 1.7302405555555558
              },
              "time_count_per_day": {
                "2026-02-09": 1,
                "2026-04-13": 3
              }
            }
          }
        }
      }
    },
    "cliente_1038": {
      "overall": {
        "avg_time_hours": 0.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-09": 1
        },
        "time_per_day": {
          "2026-02-09": 0.02501527777777778
        },
        "time_count_per_day": {
          "2026-02-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-09": 1
          },
          "time_per_day": {
            "2026-02-09": 0.02501527777777778
          },
          "time_count_per_day": {
            "2026-02-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-09": 1
            },
            "time_per_day": {
              "2026-02-09": 0.02501527777777778
            },
            "time_count_per_day": {
              "2026-02-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-09": 1
              },
              "time_per_day": {
                "2026-02-09": 0.02501527777777778
              },
              "time_count_per_day": {
                "2026-02-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1039": {
      "overall": {
        "avg_time_hours": 256.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "512-514h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-09": 1,
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-02-09": 0.0486575,
          "2026-03-17": 513.2434533333334
        },
        "time_count_per_day": {
          "2026-02-09": 1,
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 256.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "512-514h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-09": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-02-09": 0.0486575,
            "2026-03-17": 513.2434533333334
          },
          "time_count_per_day": {
            "2026-02-09": 1,
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 256.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "512-514h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-09": 1,
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-02-09": 0.0486575,
              "2026-03-17": 513.2434533333334
            },
            "time_count_per_day": {
              "2026-02-09": 1,
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 256.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "512-514h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-09": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-02-09": 0.0486575,
                "2026-03-17": 513.2434533333334
              },
              "time_count_per_day": {
                "2026-02-09": 1,
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1040": {
      "overall": {
        "avg_time_hours": 19.46,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-10": 1
        },
        "time_per_day": {
          "2026-02-10": 19.45931277777778
        },
        "time_count_per_day": {
          "2026-02-10": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 19.46,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-10": 1
          },
          "time_per_day": {
            "2026-02-10": 19.45931277777778
          },
          "time_count_per_day": {
            "2026-02-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.46,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-10": 1
            },
            "time_per_day": {
              "2026-02-10": 19.45931277777778
            },
            "time_count_per_day": {
              "2026-02-10": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 19.46,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-10": 1
              },
              "time_per_day": {
                "2026-02-10": 19.45931277777778
              },
              "time_count_per_day": {
                "2026-02-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1041": {
      "overall": {
        "avg_time_hours": 216.17,
        "mode_time_hours": 217.0,
        "mode_frequency": 1,
        "time_distribution": {
          "216-218h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 216.17090944444445
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 216.17,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "216-218h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 216.17090944444445
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 216.17,
            "mode_time_hours": 217.0,
            "mode_frequency": 1,
            "time_distribution": {
              "216-218h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 216.17090944444445
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 216.17,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "216-218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 216.17090944444445
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1042": {
      "overall": {
        "avg_time_hours": 659.91,
        "mode_time_hours": 659.0,
        "mode_frequency": 1,
        "time_distribution": {
          "658-660h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 659.9123480555556
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 659.91,
          "mode_time_hours": 659.0,
          "mode_frequency": 1,
          "time_distribution": {
            "658-660h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 659.9123480555556
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 659.91,
            "mode_time_hours": 659.0,
            "mode_frequency": 1,
            "time_distribution": {
              "658-660h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 659.9123480555556
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 659.91,
              "mode_time_hours": 659.0,
              "mode_frequency": 1,
              "time_distribution": {
                "658-660h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 659.9123480555556
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1043": {
      "overall": {
        "avg_time_hours": 54.55,
        "mode_time_hours": 55.0,
        "mode_frequency": 1,
        "time_distribution": {
          "54-56h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 54.54674277777778
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 54.55,
          "mode_time_hours": 55.0,
          "mode_frequency": 1,
          "time_distribution": {
            "54-56h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 54.54674277777778
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 54.55,
            "mode_time_hours": 55.0,
            "mode_frequency": 1,
            "time_distribution": {
              "54-56h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 54.54674277777778
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 54.55,
              "mode_time_hours": 55.0,
              "mode_frequency": 1,
              "time_distribution": {
                "54-56h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 54.54674277777778
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1044": {
      "overall": {
        "avg_time_hours": 143.02,
        "mode_time_hours": 143.0,
        "mode_frequency": 1,
        "time_distribution": {
          "142-144h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-16": 1
        },
        "time_per_day": {
          "2026-02-16": 143.02300555555556
        },
        "time_count_per_day": {
          "2026-02-16": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 143.02,
          "mode_time_hours": 143.0,
          "mode_frequency": 1,
          "time_distribution": {
            "142-144h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-16": 1
          },
          "time_per_day": {
            "2026-02-16": 143.02300555555556
          },
          "time_count_per_day": {
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 143.02,
            "mode_time_hours": 143.0,
            "mode_frequency": 1,
            "time_distribution": {
              "142-144h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-16": 1
            },
            "time_per_day": {
              "2026-02-16": 143.02300555555556
            },
            "time_count_per_day": {
              "2026-02-16": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 143.02,
              "mode_time_hours": 143.0,
              "mode_frequency": 1,
              "time_distribution": {
                "142-144h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {
                "2026-02-16": 143.02300555555556
              },
              "time_count_per_day": {
                "2026-02-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_1045": {
      "overall": {
        "avg_time_hours": 85.43,
        "mode_time_hours": 85.0,
        "mode_frequency": 1,
        "time_distribution": {
          "84-86h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-14": 1
        },
        "time_per_day": {
          "2026-02-14": 85.42542083333333
        },
        "time_count_per_day": {
          "2026-02-14": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 85.43,
          "mode_time_hours": 85.0,
          "mode_frequency": 1,
          "time_distribution": {
            "84-86h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-14": 1
          },
          "time_per_day": {
            "2026-02-14": 85.42542083333333
          },
          "time_count_per_day": {
            "2026-02-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 85.43,
            "mode_time_hours": 85.0,
            "mode_frequency": 1,
            "time_distribution": {
              "84-86h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-14": 1
            },
            "time_per_day": {
              "2026-02-14": 85.42542083333333
            },
            "time_count_per_day": {
              "2026-02-14": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 85.43,
              "mode_time_hours": 85.0,
              "mode_frequency": 1,
              "time_distribution": {
                "84-86h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-14": 1
              },
              "time_per_day": {
                "2026-02-14": 85.42542083333333
              },
              "time_count_per_day": {
                "2026-02-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_508": {
      "overall": {
        "avg_time_hours": 24.87,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "46-48h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-02-12": 47.76815416666667,
          "2026-06-01": 1.9807625
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 1.9807625
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        },
        "P2": {
          "avg_time_hours": 47.77,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 47.76815416666667
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.87,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "46-48h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-02-12": 47.76815416666667,
              "2026-06-01": 1.9807625
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 1.9807625
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            },
            "P2": {
              "avg_time_hours": 47.77,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 47.76815416666667
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1047": {
      "overall": {
        "avg_time_hours": 698.55,
        "mode_time_hours": 699.0,
        "mode_frequency": 1,
        "time_distribution": {
          "698-700h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-12": 1
        },
        "time_per_day": {
          "2026-03-12": 698.5490530555555
        },
        "time_count_per_day": {
          "2026-03-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 698.55,
          "mode_time_hours": 699.0,
          "mode_frequency": 1,
          "time_distribution": {
            "698-700h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-12": 1
          },
          "time_per_day": {
            "2026-03-12": 698.5490530555555
          },
          "time_count_per_day": {
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 698.55,
            "mode_time_hours": 699.0,
            "mode_frequency": 1,
            "time_distribution": {
              "698-700h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-12": 1
            },
            "time_per_day": {
              "2026-03-12": 698.5490530555555
            },
            "time_count_per_day": {
              "2026-03-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 698.55,
              "mode_time_hours": 699.0,
              "mode_frequency": 1,
              "time_distribution": {
                "698-700h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-12": 1
              },
              "time_per_day": {
                "2026-03-12": 698.5490530555555
              },
              "time_count_per_day": {
                "2026-03-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_400": {
      "overall": {
        "avg_time_hours": 12.94,
        "mode_time_hours": 31.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "4-6h": 1,
          "30-32h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-02-12": 31.50252083333333,
          "2026-04-10": 1.4720302777777778,
          "2026-06-01": 5.847291111111111
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.66,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "4-6h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-10": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-04-10": 1.4720302777777778,
            "2026-06-01": 5.847291111111111
          },
          "time_count_per_day": {
            "2026-04-10": 1,
            "2026-06-01": 1
          }
        },
        "P2": {
          "avg_time_hours": 31.5,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 31.50252083333333
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 12.94,
            "mode_time_hours": 31.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "4-6h": 1,
              "30-32h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-02-12": 31.50252083333333,
              "2026-04-10": 1.4720302777777778,
              "2026-06-01": 5.847291111111111
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.66,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "4-6h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-10": 1,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-04-10": 1.4720302777777778,
                "2026-06-01": 5.847291111111111
              },
              "time_count_per_day": {
                "2026-04-10": 1,
                "2026-06-01": 1
              }
            },
            "P2": {
              "avg_time_hours": 31.5,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 31.50252083333333
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1049": {
      "overall": {
        "avg_time_hours": 187.45,
        "mode_time_hours": 187.0,
        "mode_frequency": 1,
        "time_distribution": {
          "186-188h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 187.45157583333332
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 187.45,
          "mode_time_hours": 187.0,
          "mode_frequency": 1,
          "time_distribution": {
            "186-188h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 187.45157583333332
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 187.45,
            "mode_time_hours": 187.0,
            "mode_frequency": 1,
            "time_distribution": {
              "186-188h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 187.45157583333332
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 187.45,
              "mode_time_hours": 187.0,
              "mode_frequency": 1,
              "time_distribution": {
                "186-188h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 187.45157583333332
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1050": {
      "overall": {
        "avg_time_hours": 43.79,
        "mode_time_hours": 43.0,
        "mode_frequency": 1,
        "time_distribution": {
          "42-44h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-02-13": 43.78583111111111
        },
        "time_count_per_day": {
          "2026-02-13": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 43.79,
          "mode_time_hours": 43.0,
          "mode_frequency": 1,
          "time_distribution": {
            "42-44h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 43.78583111111111
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 43.79,
            "mode_time_hours": 43.0,
            "mode_frequency": 1,
            "time_distribution": {
              "42-44h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-02-13": 43.78583111111111
            },
            "time_count_per_day": {
              "2026-02-13": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 43.79,
              "mode_time_hours": 43.0,
              "mode_frequency": 1,
              "time_distribution": {
                "42-44h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 43.78583111111111
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1051": {
      "overall": {
        "avg_time_hours": 1463.92,
        "mode_time_hours": 1463.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1462-1464h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-13": 1
        },
        "time_per_day": {
          "2026-04-13": 1463.9208494444445
        },
        "time_count_per_day": {
          "2026-04-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1463.92,
          "mode_time_hours": 1463.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1462-1464h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-13": 1
          },
          "time_per_day": {
            "2026-04-13": 1463.9208494444445
          },
          "time_count_per_day": {
            "2026-04-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1463.92,
            "mode_time_hours": 1463.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1462-1464h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-13": 1
            },
            "time_per_day": {
              "2026-04-13": 1463.9208494444445
            },
            "time_count_per_day": {
              "2026-04-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1463.92,
              "mode_time_hours": 1463.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1462-1464h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-04-13": 1463.9208494444445
              },
              "time_count_per_day": {
                "2026-04-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1052": {
      "overall": {
        "avg_time_hours": 169.55,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "8-10h": 1,
          "22-24h": 1,
          "144-146h": 1,
          "840-842h": 2
        },
        "tickets_count": 12,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-22": 2,
          "2026-04-27": 1,
          "2026-05-04": 1,
          "2026-05-18": 2,
          "2026-05-25": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-03-10": 22.752316944444445,
          "2026-03-16": 145.2463275,
          "2026-03-18": 840.3933016666666,
          "2026-03-20": 0.28735666666666665,
          "2026-04-22": 841.5263463888889,
          "2026-04-27": 1.4451716666666667,
          "2026-05-18": 2.967950833333333,
          "2026-05-25": 8.791773888888889,
          "2026-06-08": 1.6074238888888888
        },
        "time_count_per_day": {
          "2026-03-10": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-04-22": 2,
          "2026-04-27": 1,
          "2026-05-18": 2,
          "2026-05-25": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 492.82,
          "mode_time_hours": 841.0,
          "mode_frequency": 1,
          "time_distribution": {
            "144-146h": 1,
            "840-842h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-16": 1,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-16": 145.2463275,
            "2026-03-18": 840.3933016666666
          },
          "time_count_per_day": {
            "2026-03-16": 1,
            "2026-03-18": 1
          }
        },
        "P2": {
          "avg_time_hours": 97.71,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "8-10h": 1,
            "22-24h": 1,
            "840-842h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-05-04": 1,
            "2026-05-18": 2,
            "2026-05-25": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-03-10": 22.752316944444445,
            "2026-03-20": 0.28735666666666665,
            "2026-04-22": 841.5263463888889,
            "2026-04-27": 1.4451716666666667,
            "2026-05-18": 2.967950833333333,
            "2026-05-25": 8.791773888888889,
            "2026-06-08": 1.6074238888888888
          },
          "time_count_per_day": {
            "2026-03-10": 1,
            "2026-03-20": 1,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-05-18": 2,
            "2026-05-25": 1,
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 169.55,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "8-10h": 1,
              "22-24h": 1,
              "144-146h": 1,
              "840-842h": 2
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-22": 2,
              "2026-04-27": 1,
              "2026-05-18": 2,
              "2026-05-25": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-03-10": 22.752316944444445,
              "2026-03-16": 145.2463275,
              "2026-03-18": 840.3933016666666,
              "2026-03-20": 0.28735666666666665,
              "2026-04-22": 841.5263463888889,
              "2026-04-27": 1.4451716666666667,
              "2026-05-18": 2.967950833333333,
              "2026-05-25": 8.791773888888889,
              "2026-06-08": 1.6074238888888888
            },
            "time_count_per_day": {
              "2026-03-10": 1,
              "2026-03-16": 1,
              "2026-03-18": 1,
              "2026-03-20": 1,
              "2026-04-22": 2,
              "2026-04-27": 1,
              "2026-05-18": 2,
              "2026-05-25": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 492.82,
              "mode_time_hours": 841.0,
              "mode_frequency": 1,
              "time_distribution": {
                "144-146h": 1,
                "840-842h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-16": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-16": 145.2463275,
                "2026-03-18": 840.3933016666666
              },
              "time_count_per_day": {
                "2026-03-16": 1,
                "2026-03-18": 1
              }
            },
            "P2": {
              "avg_time_hours": 97.71,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "8-10h": 1,
                "22-24h": 1,
                "840-842h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-22": 2,
                "2026-04-27": 1,
                "2026-05-18": 2,
                "2026-05-25": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-03-10": 22.752316944444445,
                "2026-03-20": 0.28735666666666665,
                "2026-04-22": 841.5263463888889,
                "2026-04-27": 1.4451716666666667,
                "2026-05-18": 2.967950833333333,
                "2026-05-25": 8.791773888888889,
                "2026-06-08": 1.6074238888888888
              },
              "time_count_per_day": {
                "2026-03-10": 1,
                "2026-03-20": 1,
                "2026-04-22": 2,
                "2026-04-27": 1,
                "2026-05-18": 2,
                "2026-05-25": 1,
                "2026-06-08": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1053": {
      "overall": {
        "avg_time_hours": 817.21,
        "mode_time_hours": 817.0,
        "mode_frequency": 1,
        "time_distribution": {
          "816-818h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-17": 817.2080133333334
        },
        "time_count_per_day": {
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 817.21,
          "mode_time_hours": 817.0,
          "mode_frequency": 1,
          "time_distribution": {
            "816-818h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 817.2080133333334
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 817.21,
            "mode_time_hours": 817.0,
            "mode_frequency": 1,
            "time_distribution": {
              "816-818h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-17": 817.2080133333334
            },
            "time_count_per_day": {
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 817.21,
              "mode_time_hours": 817.0,
              "mode_frequency": 1,
              "time_distribution": {
                "816-818h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 817.2080133333334
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1054": {
      "overall": {
        "avg_time_hours": 25.77,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 25.771444166666665
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 25.77,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 25.771444166666665
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 25.77,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 25.771444166666665
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 25.77,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 25.771444166666665
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1057": {
      "overall": {
        "avg_time_hours": 165.04,
        "mode_time_hours": 165.0,
        "mode_frequency": 1,
        "time_distribution": {
          "164-166h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 165.03585194444446
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 165.04,
          "mode_time_hours": 165.0,
          "mode_frequency": 1,
          "time_distribution": {
            "164-166h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 165.03585194444446
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 165.04,
            "mode_time_hours": 165.0,
            "mode_frequency": 1,
            "time_distribution": {
              "164-166h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 165.03585194444446
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 165.04,
              "mode_time_hours": 165.0,
              "mode_frequency": 1,
              "time_distribution": {
                "164-166h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 165.03585194444446
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1058": {
      "overall": {
        "avg_time_hours": 180.0,
        "mode_time_hours": 181.0,
        "mode_frequency": 1,
        "time_distribution": {
          "180-182h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 180.00213666666667
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 180.0,
          "mode_time_hours": 181.0,
          "mode_frequency": 1,
          "time_distribution": {
            "180-182h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 180.00213666666667
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 180.0,
            "mode_time_hours": 181.0,
            "mode_frequency": 1,
            "time_distribution": {
              "180-182h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 180.00213666666667
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 180.0,
              "mode_time_hours": 181.0,
              "mode_frequency": 1,
              "time_distribution": {
                "180-182h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 180.00213666666667
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1059": {
      "overall": {
        "avg_time_hours": 1.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 1.0491494444444445
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 1.0491494444444445
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 1.0491494444444445
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 1.0491494444444445
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1061": {
      "overall": {
        "avg_time_hours": 2.51,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 2.510693055555556
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.51,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 2.510693055555556
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.51,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 2.510693055555556
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.51,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 2.510693055555556
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1062": {
      "overall": {
        "avg_time_hours": 2.47,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {
          "2026-02-12": 2.470839722222222
        },
        "time_count_per_day": {
          "2026-02-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.47,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {
            "2026-02-12": 2.470839722222222
          },
          "time_count_per_day": {
            "2026-02-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.47,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {
              "2026-02-12": 2.470839722222222
            },
            "time_count_per_day": {
              "2026-02-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.47,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {
                "2026-02-12": 2.470839722222222
              },
              "time_count_per_day": {
                "2026-02-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_437": {
      "overall": {
        "avg_time_hours": 1.63,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-04-02": 1
        },
        "time_per_day": {
          "2026-02-12": 2.472531111111111,
          "2026-04-02": 0.7829647222222221
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.63,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-02-12": 2.472531111111111,
            "2026-04-02": 0.7829647222222221
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-04-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.63,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-04-02": 1
            },
            "time_per_day": {
              "2026-02-12": 2.472531111111111,
              "2026-04-02": 0.7829647222222221
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.63,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-02-12": 2.472531111111111,
                "2026-04-02": 0.7829647222222221
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-04-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1063": {
      "overall": {
        "avg_time_hours": 247.49,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "492-494h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-02-12": 1.6995711111111111,
          "2026-04-10": 493.2789266666667
        },
        "time_count_per_day": {
          "2026-02-12": 1,
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 247.49,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "492-494h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-02-12": 1.6995711111111111,
            "2026-04-10": 493.2789266666667
          },
          "time_count_per_day": {
            "2026-02-12": 1,
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 247.49,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "492-494h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-02-12": 1.6995711111111111,
              "2026-04-10": 493.2789266666667
            },
            "time_count_per_day": {
              "2026-02-12": 1,
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 247.49,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "492-494h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-12": 1,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-02-12": 1.6995711111111111,
                "2026-04-10": 493.2789266666667
              },
              "time_count_per_day": {
                "2026-02-12": 1,
                "2026-04-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_503": {
      "overall": {
        "avg_time_hours": 489.28,
        "mode_time_hours": 847.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "48-50h": 1,
          "846-848h": 1,
          "1032-1034h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-18": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-31": 1
        },
        "time_per_day": {
          "2026-02-18": 49.166804722222224,
          "2026-03-20": 847.25326,
          "2026-03-24": 28.595264166666666,
          "2026-03-31": 1032.10048
        },
        "time_count_per_day": {
          "2026-02-18": 1,
          "2026-03-20": 1,
          "2026-03-24": 1,
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 642.84,
          "mode_time_hours": 847.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1,
            "846-848h": 1,
            "1032-1034h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-03-20": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-02-18": 49.166804722222224,
            "2026-03-20": 847.25326,
            "2026-03-31": 1032.10048
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-03-20": 1,
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 28.6,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 28.595264166666666
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 489.28,
            "mode_time_hours": 847.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "48-50h": 1,
              "846-848h": 1,
              "1032-1034h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-31": 1
            },
            "time_per_day": {
              "2026-02-18": 49.166804722222224,
              "2026-03-20": 847.25326,
              "2026-03-24": 28.595264166666666,
              "2026-03-31": 1032.10048
            },
            "time_count_per_day": {
              "2026-02-18": 1,
              "2026-03-20": 1,
              "2026-03-24": 1,
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 642.84,
              "mode_time_hours": 847.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1,
                "846-848h": 1,
                "1032-1034h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-03-20": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-02-18": 49.166804722222224,
                "2026-03-20": 847.25326,
                "2026-03-31": 1032.10048
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-03-20": 1,
                "2026-03-31": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 28.6,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 28.595264166666666
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1067": {
      "overall": {
        "avg_time_hours": 174.96,
        "mode_time_hours": 125.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1,
          "124-126h": 1,
          "354-356h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-18": 2,
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-02-18": 169.23377833333333,
          "2026-03-05": 355.6350047222222
        },
        "time_count_per_day": {
          "2026-02-18": 2,
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 200.33,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1,
            "354-356h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-02-18": 45.02180527777778,
            "2026-03-05": 355.6350047222222
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-03-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 124.21,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 124.21197305555556
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 174.96,
            "mode_time_hours": 125.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1,
              "124-126h": 1,
              "354-356h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-18": 2,
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-02-18": 169.23377833333333,
              "2026-03-05": 355.6350047222222
            },
            "time_count_per_day": {
              "2026-02-18": 2,
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 200.33,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1,
                "354-356h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-02-18": 45.02180527777778,
                "2026-03-05": 355.6350047222222
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-03-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 124.21,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 124.21197305555556
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_525": {
      "overall": {
        "avg_time_hours": 866.93,
        "mode_time_hours": 1157.0,
        "mode_frequency": 1,
        "time_distribution": {
          "576-578h": 1,
          "1156-1158h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-17": 1,
          "2026-04-02": 1,
          "2026-04-09": 1
        },
        "time_per_day": {
          "2026-04-02": 1157.0796033333334,
          "2026-04-09": 576.7827691666666
        },
        "time_count_per_day": {
          "2026-04-02": 1,
          "2026-04-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 866.93,
          "mode_time_hours": 1157.0,
          "mode_frequency": 1,
          "time_distribution": {
            "576-578h": 1,
            "1156-1158h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-04-02": 1,
            "2026-04-09": 1
          },
          "time_per_day": {
            "2026-04-02": 1157.0796033333334,
            "2026-04-09": 576.7827691666666
          },
          "time_count_per_day": {
            "2026-04-02": 1,
            "2026-04-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 866.93,
            "mode_time_hours": 1157.0,
            "mode_frequency": 1,
            "time_distribution": {
              "576-578h": 1,
              "1156-1158h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-02": 1,
              "2026-04-09": 1
            },
            "time_per_day": {
              "2026-04-02": 1157.0796033333334,
              "2026-04-09": 576.7827691666666
            },
            "time_count_per_day": {
              "2026-04-02": 1,
              "2026-04-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 866.93,
              "mode_time_hours": 1157.0,
              "mode_frequency": 1,
              "time_distribution": {
                "576-578h": 1,
                "1156-1158h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-02": 1,
                "2026-04-09": 1
              },
              "time_per_day": {
                "2026-04-02": 1157.0796033333334,
                "2026-04-09": 576.7827691666666
              },
              "time_count_per_day": {
                "2026-04-02": 1,
                "2026-04-09": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_519": {
      "overall": {
        "avg_time_hours": 1.86,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-13": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-02-13": 3.608338333333333,
          "2026-05-06": 0.10278583333333333
        },
        "time_count_per_day": {
          "2026-02-13": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.86,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-13": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-02-13": 3.608338333333333,
            "2026-05-06": 0.10278583333333333
          },
          "time_count_per_day": {
            "2026-02-13": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.86,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-13": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-02-13": 3.608338333333333,
              "2026-05-06": 0.10278583333333333
            },
            "time_count_per_day": {
              "2026-02-13": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.86,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-13": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-02-13": 3.608338333333333,
                "2026-05-06": 0.10278583333333333
              },
              "time_count_per_day": {
                "2026-02-13": 1,
                "2026-05-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1068": {
      "overall": {
        "avg_time_hours": 186.93,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1,
          "70-72h": 1,
          "96-98h": 1,
          "342-344h": 1,
          "408-410h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-03-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 1,
          "2026-06-07": 1
        },
        "time_per_day": {
          "2026-02-14": 15.59817888888889,
          "2026-02-16": 70.36141472222222,
          "2026-03-20": 96.7109525,
          "2026-04-22": 342.93674694444445,
          "2026-04-23": 409.06360333333333
        },
        "time_count_per_day": {
          "2026-02-14": 1,
          "2026-02-16": 1,
          "2026-03-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 282.9,
          "mode_time_hours": 97.0,
          "mode_frequency": 1,
          "time_distribution": {
            "96-98h": 1,
            "342-344h": 1,
            "408-410h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1,
            "2026-06-07": 1
          },
          "time_per_day": {
            "2026-03-20": 96.7109525,
            "2026-04-22": 342.93674694444445,
            "2026-04-23": 409.06360333333333
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 1
          }
        },
        "P3": {
          "avg_time_hours": 42.98,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "70-72h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-14": 1,
            "2026-02-16": 1
          },
          "time_per_day": {
            "2026-02-14": 15.59817888888889,
            "2026-02-16": 70.36141472222222
          },
          "time_count_per_day": {
            "2026-02-14": 1,
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 186.93,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1,
              "70-72h": 1,
              "96-98h": 1,
              "342-344h": 1,
              "408-410h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-03-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-02-14": 15.59817888888889,
              "2026-02-16": 70.36141472222222,
              "2026-03-20": 96.7109525,
              "2026-04-22": 342.93674694444445,
              "2026-04-23": 409.06360333333333
            },
            "time_count_per_day": {
              "2026-02-14": 1,
              "2026-02-16": 1,
              "2026-03-20": 1,
              "2026-04-22": 1,
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 282.9,
              "mode_time_hours": 97.0,
              "mode_frequency": 1,
              "time_distribution": {
                "96-98h": 1,
                "342-344h": 1,
                "408-410h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-03-20": 96.7109525,
                "2026-04-22": 342.93674694444445,
                "2026-04-23": 409.06360333333333
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-04-22": 1,
                "2026-04-23": 1
              }
            },
            "P3": {
              "avg_time_hours": 42.98,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "70-72h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-14": 1,
                "2026-02-16": 1
              },
              "time_per_day": {
                "2026-02-14": 15.59817888888889,
                "2026-02-16": 70.36141472222222
              },
              "time_count_per_day": {
                "2026-02-14": 1,
                "2026-02-16": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1069": {
      "overall": {
        "avg_time_hours": 0.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-13": 1
        },
        "time_per_day": {
          "2026-02-13": 0.1769725
        },
        "time_count_per_day": {
          "2026-02-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-13": 1
          },
          "time_per_day": {
            "2026-02-13": 0.1769725
          },
          "time_count_per_day": {
            "2026-02-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-13": 1
            },
            "time_per_day": {
              "2026-02-13": 0.1769725
            },
            "time_count_per_day": {
              "2026-02-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-13": 1
              },
              "time_per_day": {
                "2026-02-13": 0.1769725
              },
              "time_count_per_day": {
                "2026-02-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1070": {
      "overall": {
        "avg_time_hours": 68.36,
        "mode_time_hours": 69.0,
        "mode_frequency": 1,
        "time_distribution": {
          "68-70h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-16": 1
        },
        "time_per_day": {
          "2026-02-16": 68.36267666666667
        },
        "time_count_per_day": {
          "2026-02-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 68.36,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-16": 1
          },
          "time_per_day": {
            "2026-02-16": 68.36267666666667
          },
          "time_count_per_day": {
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 68.36,
            "mode_time_hours": 69.0,
            "mode_frequency": 1,
            "time_distribution": {
              "68-70h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-16": 1
            },
            "time_per_day": {
              "2026-02-16": 68.36267666666667
            },
            "time_count_per_day": {
              "2026-02-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 68.36,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {
                "2026-02-16": 68.36267666666667
              },
              "time_count_per_day": {
                "2026-02-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_1074": {
      "overall": {
        "avg_time_hours": 132.26,
        "mode_time_hours": 133.0,
        "mode_frequency": 2,
        "time_distribution": {
          "132-134h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-19": 2
        },
        "time_per_day": {
          "2026-02-19": 264.52931416666667
        },
        "time_count_per_day": {
          "2026-02-19": 2
        }
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 132.26,
          "mode_time_hours": 133.0,
          "mode_frequency": 2,
          "time_distribution": {
            "132-134h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 2
          },
          "time_per_day": {
            "2026-02-19": 264.52931416666667
          },
          "time_count_per_day": {
            "2026-02-19": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 132.26,
            "mode_time_hours": 133.0,
            "mode_frequency": 2,
            "time_distribution": {
              "132-134h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 2
            },
            "time_per_day": {
              "2026-02-19": 264.52931416666667
            },
            "time_count_per_day": {
              "2026-02-19": 2
            }
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": 132.26,
              "mode_time_hours": 133.0,
              "mode_frequency": 2,
              "time_distribution": {
                "132-134h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 2
              },
              "time_per_day": {
                "2026-02-19": 264.52931416666667
              },
              "time_count_per_day": {
                "2026-02-19": 2
              }
            }
          }
        }
      }
    },
    "cliente_404": {
      "overall": {
        "avg_time_hours": 166.24,
        "mode_time_hours": 823.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "14-16h": 1,
          "74-76h": 1,
          "76-78h": 1,
          "822-824h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-02-24": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-05-20": 1,
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-02-24": 14.837577222222222,
          "2026-03-13": 6.2594924999999995,
          "2026-03-17": 75.00964944444445,
          "2026-03-20": 823.4970133333334,
          "2026-05-20": 1.7308633333333334,
          "2026-05-25": 76.09619500000001
        },
        "time_count_per_day": {
          "2026-02-24": 1,
          "2026-03-13": 1,
          "2026-03-17": 1,
          "2026-03-20": 1,
          "2026-05-20": 1,
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 166.24,
          "mode_time_hours": 823.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "6-8h": 1,
            "14-16h": 1,
            "74-76h": 1,
            "76-78h": 1,
            "822-824h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-24": 1,
            "2026-03-13": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-05-20": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-02-24": 14.837577222222222,
            "2026-03-13": 6.2594924999999995,
            "2026-03-17": 75.00964944444445,
            "2026-03-20": 823.4970133333334,
            "2026-05-20": 1.7308633333333334,
            "2026-05-25": 76.09619500000001
          },
          "time_count_per_day": {
            "2026-02-24": 1,
            "2026-03-13": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-05-20": 1,
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 166.24,
            "mode_time_hours": 823.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "14-16h": 1,
              "74-76h": 1,
              "76-78h": 1,
              "822-824h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-05-20": 1,
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-02-24": 14.837577222222222,
              "2026-03-13": 6.2594924999999995,
              "2026-03-17": 75.00964944444445,
              "2026-03-20": 823.4970133333334,
              "2026-05-20": 1.7308633333333334,
              "2026-05-25": 76.09619500000001
            },
            "time_count_per_day": {
              "2026-02-24": 1,
              "2026-03-13": 1,
              "2026-03-17": 1,
              "2026-03-20": 1,
              "2026-05-20": 1,
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 166.24,
              "mode_time_hours": 823.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "6-8h": 1,
                "14-16h": 1,
                "74-76h": 1,
                "76-78h": 1,
                "822-824h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-24": 1,
                "2026-03-13": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-20": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-02-24": 14.837577222222222,
                "2026-03-13": 6.2594924999999995,
                "2026-03-17": 75.00964944444445,
                "2026-03-20": 823.4970133333334,
                "2026-05-20": 1.7308633333333334,
                "2026-05-25": 76.09619500000001
              },
              "time_count_per_day": {
                "2026-02-24": 1,
                "2026-03-13": 1,
                "2026-03-17": 1,
                "2026-03-20": 1,
                "2026-05-20": 1,
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1076": {
      "overall": {
        "avg_time_hours": 76.85,
        "mode_time_hours": 105.0,
        "mode_frequency": 1,
        "time_distribution": {
          "48-50h": 1,
          "104-106h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-18": 1,
          "2026-02-20": 1
        },
        "time_per_day": {
          "2026-02-18": 104.97606861111112,
          "2026-02-20": 48.73099833333334
        },
        "time_count_per_day": {
          "2026-02-18": 1,
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 76.85,
          "mode_time_hours": 105.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1,
            "104-106h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-18": 104.97606861111112,
            "2026-02-20": 48.73099833333334
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 76.85,
            "mode_time_hours": 105.0,
            "mode_frequency": 1,
            "time_distribution": {
              "48-50h": 1,
              "104-106h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-18": 104.97606861111112,
              "2026-02-20": 48.73099833333334
            },
            "time_count_per_day": {
              "2026-02-18": 1,
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 76.85,
              "mode_time_hours": 105.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1,
                "104-106h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-18": 104.97606861111112,
                "2026-02-20": 48.73099833333334
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1078": {
      "overall": {
        "avg_time_hours": 0.56,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-16": 1
        },
        "time_per_day": {
          "2026-02-16": 0.5612805555555556
        },
        "time_count_per_day": {
          "2026-02-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-16": 1
          },
          "time_per_day": {
            "2026-02-16": 0.5612805555555556
          },
          "time_count_per_day": {
            "2026-02-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.56,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-16": 1
            },
            "time_per_day": {
              "2026-02-16": 0.5612805555555556
            },
            "time_count_per_day": {
              "2026-02-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-16": 1
              },
              "time_per_day": {
                "2026-02-16": 0.5612805555555556
              },
              "time_count_per_day": {
                "2026-02-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_1080": {
      "overall": {
        "avg_time_hours": 627.87,
        "mode_time_hours": 627.0,
        "mode_frequency": 1,
        "time_distribution": {
          "626-628h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-14": 1
        },
        "time_per_day": {
          "2026-03-14": 627.8703091666666
        },
        "time_count_per_day": {
          "2026-03-14": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 627.87,
          "mode_time_hours": 627.0,
          "mode_frequency": 1,
          "time_distribution": {
            "626-628h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-14": 1
          },
          "time_per_day": {
            "2026-03-14": 627.8703091666666
          },
          "time_count_per_day": {
            "2026-03-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 627.87,
            "mode_time_hours": 627.0,
            "mode_frequency": 1,
            "time_distribution": {
              "626-628h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-14": 1
            },
            "time_per_day": {
              "2026-03-14": 627.8703091666666
            },
            "time_count_per_day": {
              "2026-03-14": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 627.87,
              "mode_time_hours": 627.0,
              "mode_frequency": 1,
              "time_distribution": {
                "626-628h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-14": 1
              },
              "time_per_day": {
                "2026-03-14": 627.8703091666666
              },
              "time_count_per_day": {
                "2026-03-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1083": {
      "overall": {
        "avg_time_hours": 1257.25,
        "mode_time_hours": 1257.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1256-1258h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-04-10": 1257.2463605555556
        },
        "time_count_per_day": {
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1257.25,
          "mode_time_hours": 1257.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1256-1258h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 1257.2463605555556
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1257.25,
            "mode_time_hours": 1257.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1256-1258h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-04-10": 1257.2463605555556
            },
            "time_count_per_day": {
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1257.25,
              "mode_time_hours": 1257.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1256-1258h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 1257.2463605555556
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1084": {
      "overall": {
        "avg_time_hours": 1080.79,
        "mode_time_hours": 1081.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1080-1082h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-02": 1
        },
        "time_per_day": {
          "2026-04-02": 1080.7911830555556
        },
        "time_count_per_day": {
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1080.79,
          "mode_time_hours": 1081.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1080-1082h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-04-02": 1080.7911830555556
          },
          "time_count_per_day": {
            "2026-04-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1080.79,
            "mode_time_hours": 1081.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1080-1082h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {
              "2026-04-02": 1080.7911830555556
            },
            "time_count_per_day": {
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1080.79,
              "mode_time_hours": 1081.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1080-1082h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-04-02": 1080.7911830555556
              },
              "time_count_per_day": {
                "2026-04-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1085": {
      "overall": {
        "avg_time_hours": 1075.36,
        "mode_time_hours": 1075.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1074-1076h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-02": 1
        },
        "time_per_day": {
          "2026-04-02": 1075.3565188888888
        },
        "time_count_per_day": {
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1075.36,
          "mode_time_hours": 1075.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1074-1076h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-04-02": 1075.3565188888888
          },
          "time_count_per_day": {
            "2026-04-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1075.36,
            "mode_time_hours": 1075.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1074-1076h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {
              "2026-04-02": 1075.3565188888888
            },
            "time_count_per_day": {
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1075.36,
              "mode_time_hours": 1075.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1074-1076h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-04-02": 1075.3565188888888
              },
              "time_count_per_day": {
                "2026-04-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1088": {
      "overall": {
        "avg_time_hours": 70.11,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "206-208h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-17": 1,
          "2026-03-18": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-02-17": 0.9205236111111111,
          "2026-03-18": 207.82211138888889,
          "2026-06-05": 1.5890980555555554
        },
        "time_count_per_day": {
          "2026-02-17": 1,
          "2026-03-18": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-17": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-02-17": 0.9205236111111111,
            "2026-06-05": 1.5890980555555554
          },
          "time_count_per_day": {
            "2026-02-17": 1,
            "2026-06-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 207.82,
          "mode_time_hours": 207.0,
          "mode_frequency": 1,
          "time_distribution": {
            "206-208h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 207.82211138888889
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.11,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "206-208h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-17": 1,
              "2026-03-18": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-02-17": 0.9205236111111111,
              "2026-03-18": 207.82211138888889,
              "2026-06-05": 1.5890980555555554
            },
            "time_count_per_day": {
              "2026-02-17": 1,
              "2026-03-18": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-02-17": 0.9205236111111111,
                "2026-06-05": 1.5890980555555554
              },
              "time_count_per_day": {
                "2026-02-17": 1,
                "2026-06-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 207.82,
              "mode_time_hours": 207.0,
              "mode_frequency": 1,
              "time_distribution": {
                "206-208h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 207.82211138888889
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1090": {
      "overall": {
        "avg_time_hours": 20.91,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "6-8h": 1,
          "50-52h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-17": 2,
          "2026-05-22": 1
        },
        "time_per_day": {
          "2026-02-17": 11.674089166666668,
          "2026-05-22": 51.06784666666667
        },
        "time_count_per_day": {
          "2026-02-17": 2,
          "2026-05-22": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 6.43,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-17": 1
          },
          "time_per_day": {
            "2026-02-17": 6.425129722222223
          },
          "time_count_per_day": {
            "2026-02-17": 1
          }
        },
        "P2": {
          "avg_time_hours": 28.16,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "50-52h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-17": 1,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2026-02-17": 5.248959444444445,
            "2026-05-22": 51.06784666666667
          },
          "time_count_per_day": {
            "2026-02-17": 1,
            "2026-05-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.91,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "6-8h": 1,
              "50-52h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-17": 2,
              "2026-05-22": 1
            },
            "time_per_day": {
              "2026-02-17": 11.674089166666668,
              "2026-05-22": 51.06784666666667
            },
            "time_count_per_day": {
              "2026-02-17": 2,
              "2026-05-22": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 6.43,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-17": 1
              },
              "time_per_day": {
                "2026-02-17": 6.425129722222223
              },
              "time_count_per_day": {
                "2026-02-17": 1
              }
            },
            "P2": {
              "avg_time_hours": 28.16,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "50-52h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-17": 1,
                "2026-05-22": 1
              },
              "time_per_day": {
                "2026-02-17": 5.248959444444445,
                "2026-05-22": 51.06784666666667
              },
              "time_count_per_day": {
                "2026-02-17": 1,
                "2026-05-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_489": {
      "overall": {
        "avg_time_hours": 76.84,
        "mode_time_hours": 77.0,
        "mode_frequency": 1,
        "time_distribution": {
          "76-78h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-20": 1
        },
        "time_per_day": {
          "2026-02-20": 76.83599638888889
        },
        "time_count_per_day": {
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 76.84,
          "mode_time_hours": 77.0,
          "mode_frequency": 1,
          "time_distribution": {
            "76-78h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-20": 76.83599638888889
          },
          "time_count_per_day": {
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 76.84,
            "mode_time_hours": 77.0,
            "mode_frequency": 1,
            "time_distribution": {
              "76-78h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-20": 76.83599638888889
            },
            "time_count_per_day": {
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 76.84,
              "mode_time_hours": 77.0,
              "mode_frequency": 1,
              "time_distribution": {
                "76-78h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-20": 76.83599638888889
              },
              "time_count_per_day": {
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1091": {
      "overall": {
        "avg_time_hours": 21.88,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 21.87979361111111
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 21.88,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 21.87979361111111
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 21.88,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 21.87979361111111
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 21.88,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 21.87979361111111
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1094": {
      "overall": {
        "avg_time_hours": 5.74,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "10-12h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-18": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-02-18": 11.347511944444443,
          "2026-05-18": 0.12901138888888888
        },
        "time_count_per_day": {
          "2026-02-18": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.74,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "10-12h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-02-18": 11.347511944444443,
            "2026-05-18": 0.12901138888888888
          },
          "time_count_per_day": {
            "2026-02-18": 1,
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.74,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "10-12h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-18": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-02-18": 11.347511944444443,
              "2026-05-18": 0.12901138888888888
            },
            "time_count_per_day": {
              "2026-02-18": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.74,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "10-12h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-18": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-02-18": 11.347511944444443,
                "2026-05-18": 0.12901138888888888
              },
              "time_count_per_day": {
                "2026-02-18": 1,
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1096": {
      "overall": {
        "avg_time_hours": 5.4,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 5.396261944444445
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.4,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 5.396261944444445
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.4,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 5.396261944444445
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.4,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 5.396261944444445
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1097": {
      "overall": {
        "avg_time_hours": 70.24,
        "mode_time_hours": 1.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 5,
          "4-6h": 2,
          "10-12h": 1,
          "22-24h": 1,
          "24-26h": 1,
          "124-126h": 1,
          "164-166h": 1,
          "194-196h": 1,
          "430-432h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-18": 2,
          "2026-03-30": 1,
          "2026-04-04": 1,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-05-04": 1,
          "2026-05-26": 1,
          "2026-05-27": 2,
          "2026-06-01": 2
        },
        "time_per_day": {
          "2026-02-23": 124.37765527777778,
          "2026-02-28": 195.05465972222223,
          "2026-03-18": 595.5814238888889,
          "2026-03-30": 0.13223277777777778,
          "2026-04-21": 0.8665308333333334,
          "2026-04-22": 47.99771777777778,
          "2026-05-04": 0.1335125,
          "2026-05-26": 10.6285075,
          "2026-05-27": 4.462039166666667,
          "2026-06-01": 4.156673888888888
        },
        "time_count_per_day": {
          "2026-02-23": 1,
          "2026-02-28": 1,
          "2026-03-18": 2,
          "2026-03-30": 1,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-05-04": 1,
          "2026-05-26": 1,
          "2026-05-27": 2,
          "2026-06-01": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 5,
            "4-6h": 2,
            "10-12h": 1,
            "124-126h": 1
          },
          "tickets_count": 9,
          "tickets_per_day": {
            "2026-02-23": 1,
            "2026-03-30": 1,
            "2026-04-21": 1,
            "2026-05-04": 1,
            "2026-05-26": 1,
            "2026-05-27": 2,
            "2026-06-01": 2
          },
          "time_per_day": {
            "2026-02-23": 124.37765527777778,
            "2026-03-30": 0.13223277777777778,
            "2026-04-21": 0.8665308333333334,
            "2026-05-04": 0.1335125,
            "2026-05-26": 10.6285075,
            "2026-05-27": 4.462039166666667,
            "2026-06-01": 4.156673888888888
          },
          "time_count_per_day": {
            "2026-02-23": 1,
            "2026-03-30": 1,
            "2026-04-21": 1,
            "2026-05-04": 1,
            "2026-05-26": 1,
            "2026-05-27": 2,
            "2026-06-01": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 167.73,
          "mode_time_hours": 195.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1,
            "24-26h": 1,
            "164-166h": 1,
            "194-196h": 1,
            "430-432h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-28": 1,
            "2026-03-18": 2,
            "2026-04-04": 1,
            "2026-04-22": 2
          },
          "time_per_day": {
            "2026-02-28": 195.05465972222223,
            "2026-03-18": 595.5814238888889,
            "2026-04-22": 47.99771777777778
          },
          "time_count_per_day": {
            "2026-02-28": 1,
            "2026-03-18": 2,
            "2026-04-22": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.24,
            "mode_time_hours": 1.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 5,
              "4-6h": 2,
              "10-12h": 1,
              "22-24h": 1,
              "24-26h": 1,
              "124-126h": 1,
              "164-166h": 1,
              "194-196h": 1,
              "430-432h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-18": 2,
              "2026-03-30": 1,
              "2026-04-21": 1,
              "2026-04-22": 2,
              "2026-05-04": 1,
              "2026-05-26": 1,
              "2026-05-27": 2,
              "2026-06-01": 2
            },
            "time_per_day": {
              "2026-02-23": 124.37765527777778,
              "2026-02-28": 195.05465972222223,
              "2026-03-18": 595.5814238888889,
              "2026-03-30": 0.13223277777777778,
              "2026-04-21": 0.8665308333333334,
              "2026-04-22": 47.99771777777778,
              "2026-05-04": 0.1335125,
              "2026-05-26": 10.6285075,
              "2026-05-27": 4.462039166666667,
              "2026-06-01": 4.156673888888888
            },
            "time_count_per_day": {
              "2026-02-23": 1,
              "2026-02-28": 1,
              "2026-03-18": 2,
              "2026-03-30": 1,
              "2026-04-21": 1,
              "2026-04-22": 2,
              "2026-05-04": 1,
              "2026-05-26": 1,
              "2026-05-27": 2,
              "2026-06-01": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 5,
                "4-6h": 2,
                "10-12h": 1,
                "124-126h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-02-23": 1,
                "2026-03-30": 1,
                "2026-04-21": 1,
                "2026-05-04": 1,
                "2026-05-26": 1,
                "2026-05-27": 2,
                "2026-06-01": 2
              },
              "time_per_day": {
                "2026-02-23": 124.37765527777778,
                "2026-03-30": 0.13223277777777778,
                "2026-04-21": 0.8665308333333334,
                "2026-05-04": 0.1335125,
                "2026-05-26": 10.6285075,
                "2026-05-27": 4.462039166666667,
                "2026-06-01": 4.156673888888888
              },
              "time_count_per_day": {
                "2026-02-23": 1,
                "2026-03-30": 1,
                "2026-04-21": 1,
                "2026-05-04": 1,
                "2026-05-26": 1,
                "2026-05-27": 2,
                "2026-06-01": 2
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 167.73,
              "mode_time_hours": 195.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1,
                "24-26h": 1,
                "164-166h": 1,
                "194-196h": 1,
                "430-432h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-02-28": 1,
                "2026-03-18": 2,
                "2026-04-22": 2
              },
              "time_per_day": {
                "2026-02-28": 195.05465972222223,
                "2026-03-18": 595.5814238888889,
                "2026-04-22": 47.99771777777778
              },
              "time_count_per_day": {
                "2026-02-28": 1,
                "2026-03-18": 2,
                "2026-04-22": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1098": {
      "overall": {
        "avg_time_hours": 1.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 1.0745283333333333
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 1.0745283333333333
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 1.0745283333333333
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 1.0745283333333333
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1099": {
      "overall": {
        "avg_time_hours": 354.42,
        "mode_time_hours": 355.0,
        "mode_frequency": 1,
        "time_distribution": {
          "354-356h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-03-05": 354.4166719444445
        },
        "time_count_per_day": {
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 354.42,
          "mode_time_hours": 355.0,
          "mode_frequency": 1,
          "time_distribution": {
            "354-356h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-03-05": 354.4166719444445
          },
          "time_count_per_day": {
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 354.42,
            "mode_time_hours": 355.0,
            "mode_frequency": 1,
            "time_distribution": {
              "354-356h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-03-05": 354.4166719444445
            },
            "time_count_per_day": {
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 354.42,
              "mode_time_hours": 355.0,
              "mode_frequency": 1,
              "time_distribution": {
                "354-356h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-03-05": 354.4166719444445
              },
              "time_count_per_day": {
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1101": {
      "overall": {
        "avg_time_hours": 2.6,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-18": 1
        },
        "time_per_day": {
          "2026-02-18": 2.597885277777778
        },
        "time_count_per_day": {
          "2026-02-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.6,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-18": 1
          },
          "time_per_day": {
            "2026-02-18": 2.597885277777778
          },
          "time_count_per_day": {
            "2026-02-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.6,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-18": 1
            },
            "time_per_day": {
              "2026-02-18": 2.597885277777778
            },
            "time_count_per_day": {
              "2026-02-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.6,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-18": 1
              },
              "time_per_day": {
                "2026-02-18": 2.597885277777778
              },
              "time_count_per_day": {
                "2026-02-18": 1
              }
            }
          }
        }
      }
    },
    "Sandra Reis": {
      "overall": {
        "avg_time_hours": 176.28,
        "mode_time_hours": 23.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 1,
          "22-24h": 2,
          "140-142h": 1,
          "280-282h": 1,
          "400-402h": 1,
          "524-526h": 1
        },
        "tickets_count": 9,
        "tickets_per_day": {
          "2026-02-19": 1,
          "2026-02-20": 1,
          "2026-03-09": 1,
          "2026-03-19": 2,
          "2026-04-21": 2,
          "2026-04-28": 1,
          "2026-04-29": 1
        },
        "time_per_day": {
          "2026-02-19": 18.03203361111111,
          "2026-03-09": 281.1598011111111,
          "2026-03-19": 400.88115972222226,
          "2026-04-21": 44.08401472222222,
          "2026-04-28": 524.8198225,
          "2026-04-29": 141.27042111111112
        },
        "time_count_per_day": {
          "2026-02-19": 1,
          "2026-03-09": 1,
          "2026-03-19": 2,
          "2026-04-21": 2,
          "2026-04-28": 1,
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 198.89,
          "mode_time_hours": 23.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 2,
            "140-142h": 1,
            "280-282h": 1,
            "400-402h": 1,
            "524-526h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-03-19": 2,
            "2026-04-21": 2,
            "2026-04-28": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-03-09": 281.1598011111111,
            "2026-03-19": 400.88115972222226,
            "2026-04-21": 44.08401472222222,
            "2026-04-28": 524.8198225,
            "2026-04-29": 141.27042111111112
          },
          "time_count_per_day": {
            "2026-03-09": 1,
            "2026-03-19": 2,
            "2026-04-21": 2,
            "2026-04-28": 1,
            "2026-04-29": 1
          }
        },
        "P3": {
          "avg_time_hours": 18.03,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-19": 18.03203361111111
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 176.28,
            "mode_time_hours": 23.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 1,
              "22-24h": 2,
              "140-142h": 1,
              "280-282h": 1,
              "400-402h": 1,
              "524-526h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-02-19": 1,
              "2026-03-09": 1,
              "2026-03-19": 2,
              "2026-04-21": 2,
              "2026-04-28": 1,
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-02-19": 18.03203361111111,
              "2026-03-09": 281.1598011111111,
              "2026-03-19": 400.88115972222226,
              "2026-04-21": 44.08401472222222,
              "2026-04-28": 524.8198225,
              "2026-04-29": 141.27042111111112
            },
            "time_count_per_day": {
              "2026-02-19": 1,
              "2026-03-09": 1,
              "2026-03-19": 2,
              "2026-04-21": 2,
              "2026-04-28": 1,
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 198.89,
              "mode_time_hours": 23.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 2,
                "140-142h": 1,
                "280-282h": 1,
                "400-402h": 1,
                "524-526h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-03-19": 2,
                "2026-04-21": 2,
                "2026-04-28": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-03-09": 281.1598011111111,
                "2026-03-19": 400.88115972222226,
                "2026-04-21": 44.08401472222222,
                "2026-04-28": 524.8198225,
                "2026-04-29": 141.27042111111112
              },
              "time_count_per_day": {
                "2026-03-09": 1,
                "2026-03-19": 2,
                "2026-04-21": 2,
                "2026-04-28": 1,
                "2026-04-29": 1
              }
            },
            "P3": {
              "avg_time_hours": 18.03,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 18.03203361111111
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1103": {
      "overall": {
        "avg_time_hours": 2.85,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {
          "2026-02-19": 2.846206388888889
        },
        "time_count_per_day": {
          "2026-02-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.85,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {
            "2026-02-19": 2.846206388888889
          },
          "time_count_per_day": {
            "2026-02-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.85,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {
              "2026-02-19": 2.846206388888889
            },
            "time_count_per_day": {
              "2026-02-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.85,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {
                "2026-02-19": 2.846206388888889
              },
              "time_count_per_day": {
                "2026-02-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1109": {
      "overall": {
        "avg_time_hours": 41.35,
        "mode_time_hours": 41.0,
        "mode_frequency": 1,
        "time_distribution": {
          "40-42h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-21": 1
        },
        "time_per_day": {
          "2026-02-21": 41.35382277777777
        },
        "time_count_per_day": {
          "2026-02-21": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 41.35,
          "mode_time_hours": 41.0,
          "mode_frequency": 1,
          "time_distribution": {
            "40-42h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-21": 1
          },
          "time_per_day": {
            "2026-02-21": 41.35382277777777
          },
          "time_count_per_day": {
            "2026-02-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 41.35,
            "mode_time_hours": 41.0,
            "mode_frequency": 1,
            "time_distribution": {
              "40-42h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-21": 1
            },
            "time_per_day": {
              "2026-02-21": 41.35382277777777
            },
            "time_count_per_day": {
              "2026-02-21": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 41.35,
              "mode_time_hours": 41.0,
              "mode_frequency": 1,
              "time_distribution": {
                "40-42h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-21": 1
              },
              "time_per_day": {
                "2026-02-21": 41.35382277777777
              },
              "time_count_per_day": {
                "2026-02-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1110": {
      "overall": {
        "avg_time_hours": 121.98,
        "mode_time_hours": 121.0,
        "mode_frequency": 1,
        "time_distribution": {
          "120-122h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-24": 1
        },
        "time_per_day": {
          "2026-02-24": 121.97832
        },
        "time_count_per_day": {
          "2026-02-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 121.98,
          "mode_time_hours": 121.0,
          "mode_frequency": 1,
          "time_distribution": {
            "120-122h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-24": 1
          },
          "time_per_day": {
            "2026-02-24": 121.97832
          },
          "time_count_per_day": {
            "2026-02-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 121.98,
            "mode_time_hours": 121.0,
            "mode_frequency": 1,
            "time_distribution": {
              "120-122h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-24": 1
            },
            "time_per_day": {
              "2026-02-24": 121.97832
            },
            "time_count_per_day": {
              "2026-02-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 121.98,
              "mode_time_hours": 121.0,
              "mode_frequency": 1,
              "time_distribution": {
                "120-122h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-24": 1
              },
              "time_per_day": {
                "2026-02-24": 121.97832
              },
              "time_count_per_day": {
                "2026-02-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1066": {
      "overall": {
        "avg_time_hours": 0.86,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-20": 1
        },
        "time_per_day": {
          "2026-02-20": 0.86444
        },
        "time_count_per_day": {
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.86,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-20": 0.86444
          },
          "time_count_per_day": {
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.86,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-20": 0.86444
            },
            "time_count_per_day": {
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.86,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-20": 0.86444
              },
              "time_count_per_day": {
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_652": {
      "overall": {
        "avg_time_hours": 2.65,
        "mode_time_hours": 3.0,
        "mode_frequency": 5,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 5,
          "4-6h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2026-02-20": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-20": 1,
          "2026-05-06": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-23": 2,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-02-20": 3.7578252777777776,
          "2026-04-09": 1.9956375,
          "2026-04-10": 5.156764444444444,
          "2026-04-20": 2.6704722222222226,
          "2026-05-06": 3.7788158333333333,
          "2026-05-12": 0.7684644444444445,
          "2026-05-18": 1.5399219444444445,
          "2026-05-23": 5.141799166666667,
          "2026-05-26": 1.6836555555555555
        },
        "time_count_per_day": {
          "2026-02-20": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-20": 1,
          "2026-05-06": 1,
          "2026-05-12": 1,
          "2026-05-18": 1,
          "2026-05-23": 2,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.65,
          "mode_time_hours": 3.0,
          "mode_frequency": 5,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 5,
            "4-6h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-02-20": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-20": 1,
            "2026-05-06": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-23": 2,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-20": 3.7578252777777776,
            "2026-04-09": 1.9956375,
            "2026-04-10": 5.156764444444444,
            "2026-04-20": 2.6704722222222226,
            "2026-05-06": 3.7788158333333333,
            "2026-05-12": 0.7684644444444445,
            "2026-05-18": 1.5399219444444445,
            "2026-05-23": 5.141799166666667,
            "2026-05-26": 1.6836555555555555
          },
          "time_count_per_day": {
            "2026-02-20": 1,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-20": 1,
            "2026-05-06": 1,
            "2026-05-12": 1,
            "2026-05-18": 1,
            "2026-05-23": 2,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.65,
            "mode_time_hours": 3.0,
            "mode_frequency": 5,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 5,
              "4-6h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-02-20": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-20": 1,
              "2026-05-06": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-23": 2,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-02-20": 3.7578252777777776,
              "2026-04-09": 1.9956375,
              "2026-04-10": 5.156764444444444,
              "2026-04-20": 2.6704722222222226,
              "2026-05-06": 3.7788158333333333,
              "2026-05-12": 0.7684644444444445,
              "2026-05-18": 1.5399219444444445,
              "2026-05-23": 5.141799166666667,
              "2026-05-26": 1.6836555555555555
            },
            "time_count_per_day": {
              "2026-02-20": 1,
              "2026-04-09": 1,
              "2026-04-10": 1,
              "2026-04-20": 1,
              "2026-05-06": 1,
              "2026-05-12": 1,
              "2026-05-18": 1,
              "2026-05-23": 2,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.65,
              "mode_time_hours": 3.0,
              "mode_frequency": 5,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 5,
                "4-6h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-02-20": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-05-06": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-23": 2,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-02-20": 3.7578252777777776,
                "2026-04-09": 1.9956375,
                "2026-04-10": 5.156764444444444,
                "2026-04-20": 2.6704722222222226,
                "2026-05-06": 3.7788158333333333,
                "2026-05-12": 0.7684644444444445,
                "2026-05-18": 1.5399219444444445,
                "2026-05-23": 5.141799166666667,
                "2026-05-26": 1.6836555555555555
              },
              "time_count_per_day": {
                "2026-02-20": 1,
                "2026-04-09": 1,
                "2026-04-10": 1,
                "2026-04-20": 1,
                "2026-05-06": 1,
                "2026-05-12": 1,
                "2026-05-18": 1,
                "2026-05-23": 2,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1114": {
      "overall": {
        "avg_time_hours": 2.5,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-20": 1
        },
        "time_per_day": {
          "2026-02-20": 2.502128888888889
        },
        "time_count_per_day": {
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.5,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-20": 2.502128888888889
          },
          "time_count_per_day": {
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.5,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-20": 2.502128888888889
            },
            "time_count_per_day": {
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.5,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-20": 2.502128888888889
              },
              "time_count_per_day": {
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1115": {
      "overall": {
        "avg_time_hours": 197.83,
        "mode_time_hours": 199.0,
        "mode_frequency": 1,
        "time_distribution": {
          "196-198h": 1,
          "198-200h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 2
        },
        "time_per_day": {
          "2026-02-28": 395.66339555555555
        },
        "time_count_per_day": {
          "2026-02-28": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 197.83,
          "mode_time_hours": 199.0,
          "mode_frequency": 1,
          "time_distribution": {
            "196-198h": 1,
            "198-200h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 2
          },
          "time_per_day": {
            "2026-02-28": 395.66339555555555
          },
          "time_count_per_day": {
            "2026-02-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 197.83,
            "mode_time_hours": 199.0,
            "mode_frequency": 1,
            "time_distribution": {
              "196-198h": 1,
              "198-200h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 2
            },
            "time_per_day": {
              "2026-02-28": 395.66339555555555
            },
            "time_count_per_day": {
              "2026-02-28": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 197.83,
              "mode_time_hours": 199.0,
              "mode_frequency": 1,
              "time_distribution": {
                "196-198h": 1,
                "198-200h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-28": 2
              },
              "time_per_day": {
                "2026-02-28": 395.66339555555555
              },
              "time_count_per_day": {
                "2026-02-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_1116": {
      "overall": {
        "avg_time_hours": 2.61,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 1,
          "10-12h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-02-20": 1,
          "2026-03-01": 1,
          "2026-03-05": 1,
          "2026-03-24": 1,
          "2026-04-23": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-02-20": 0.18647444444444444,
          "2026-03-01": 2.1830722222222225,
          "2026-03-05": 0.0235175,
          "2026-03-24": 11.565394166666668,
          "2026-04-23": 0.06313833333333334,
          "2026-06-08": 1.6310991666666668
        },
        "time_count_per_day": {
          "2026-02-20": 1,
          "2026-03-01": 1,
          "2026-03-05": 1,
          "2026-03-24": 1,
          "2026-04-23": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 1,
            "10-12h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-02-20": 1,
            "2026-03-01": 1,
            "2026-03-05": 1,
            "2026-03-24": 1,
            "2026-04-23": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-02-20": 0.18647444444444444,
            "2026-03-01": 2.1830722222222225,
            "2026-03-05": 0.0235175,
            "2026-03-24": 11.565394166666668,
            "2026-04-23": 0.06313833333333334,
            "2026-06-08": 1.6310991666666668
          },
          "time_count_per_day": {
            "2026-02-20": 1,
            "2026-03-01": 1,
            "2026-03-05": 1,
            "2026-03-24": 1,
            "2026-04-23": 1,
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.61,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 1,
              "10-12h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-02-20": 1,
              "2026-03-01": 1,
              "2026-03-05": 1,
              "2026-03-24": 1,
              "2026-04-23": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-02-20": 0.18647444444444444,
              "2026-03-01": 2.1830722222222225,
              "2026-03-05": 0.0235175,
              "2026-03-24": 11.565394166666668,
              "2026-04-23": 0.06313833333333334,
              "2026-06-08": 1.6310991666666668
            },
            "time_count_per_day": {
              "2026-02-20": 1,
              "2026-03-01": 1,
              "2026-03-05": 1,
              "2026-03-24": 1,
              "2026-04-23": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 1,
                "10-12h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-02-20": 1,
                "2026-03-01": 1,
                "2026-03-05": 1,
                "2026-03-24": 1,
                "2026-04-23": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-02-20": 0.18647444444444444,
                "2026-03-01": 2.1830722222222225,
                "2026-03-05": 0.0235175,
                "2026-03-24": 11.565394166666668,
                "2026-04-23": 0.06313833333333334,
                "2026-06-08": 1.6310991666666668
              },
              "time_count_per_day": {
                "2026-02-20": 1,
                "2026-03-01": 1,
                "2026-03-05": 1,
                "2026-03-24": 1,
                "2026-04-23": 1,
                "2026-06-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1117": {
      "overall": {
        "avg_time_hours": 70.15,
        "mode_time_hours": 73.0,
        "mode_frequency": 1,
        "time_distribution": {
          "66-68h": 1,
          "72-74h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-23": 2
        },
        "time_per_day": {
          "2026-02-23": 140.30977694444442
        },
        "time_count_per_day": {
          "2026-02-23": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 70.15,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1,
            "72-74h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-23": 2
          },
          "time_per_day": {
            "2026-02-23": 140.30977694444442
          },
          "time_count_per_day": {
            "2026-02-23": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 70.15,
            "mode_time_hours": 73.0,
            "mode_frequency": 1,
            "time_distribution": {
              "66-68h": 1,
              "72-74h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-23": 2
            },
            "time_per_day": {
              "2026-02-23": 140.30977694444442
            },
            "time_count_per_day": {
              "2026-02-23": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 70.15,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1,
                "72-74h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-23": 2
              },
              "time_per_day": {
                "2026-02-23": 140.30977694444442
              },
              "time_count_per_day": {
                "2026-02-23": 2
              }
            }
          }
        }
      }
    },
    "cliente_1118": {
      "overall": {
        "avg_time_hours": 193.79,
        "mode_time_hours": 195.0,
        "mode_frequency": 2,
        "time_distribution": {
          "192-194h": 1,
          "194-196h": 2
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-28": 3
        },
        "time_per_day": {
          "2026-02-28": 581.3620958333333
        },
        "time_count_per_day": {
          "2026-02-28": 3
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 193.79,
          "mode_time_hours": 195.0,
          "mode_frequency": 2,
          "time_distribution": {
            "192-194h": 1,
            "194-196h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-28": 3
          },
          "time_per_day": {
            "2026-02-28": 581.3620958333333
          },
          "time_count_per_day": {
            "2026-02-28": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 193.79,
            "mode_time_hours": 195.0,
            "mode_frequency": 2,
            "time_distribution": {
              "192-194h": 1,
              "194-196h": 2
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-28": 3
            },
            "time_per_day": {
              "2026-02-28": 581.3620958333333
            },
            "time_count_per_day": {
              "2026-02-28": 3
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 193.79,
              "mode_time_hours": 195.0,
              "mode_frequency": 2,
              "time_distribution": {
                "192-194h": 1,
                "194-196h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-28": 3
              },
              "time_per_day": {
                "2026-02-28": 581.3620958333333
              },
              "time_count_per_day": {
                "2026-02-28": 3
              }
            }
          }
        }
      }
    },
    "cliente_1119": {
      "overall": {
        "avg_time_hours": 0.16,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-20": 1
        },
        "time_per_day": {
          "2026-02-20": 0.16224555555555553
        },
        "time_count_per_day": {
          "2026-02-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.16,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {
            "2026-02-20": 0.16224555555555553
          },
          "time_count_per_day": {
            "2026-02-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.16,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {
              "2026-02-20": 0.16224555555555553
            },
            "time_count_per_day": {
              "2026-02-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.16,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {
                "2026-02-20": 0.16224555555555553
              },
              "time_count_per_day": {
                "2026-02-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1120": {
      "overall": {
        "avg_time_hours": 1098.15,
        "mode_time_hours": 1099.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1098-1100h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-07": 1
        },
        "time_per_day": {
          "2026-04-07": 1098.149781111111
        },
        "time_count_per_day": {
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1098.15,
          "mode_time_hours": 1099.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1098-1100h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-07": 1
          },
          "time_per_day": {
            "2026-04-07": 1098.149781111111
          },
          "time_count_per_day": {
            "2026-04-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1098.15,
            "mode_time_hours": 1099.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1098-1100h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-07": 1
            },
            "time_per_day": {
              "2026-04-07": 1098.149781111111
            },
            "time_count_per_day": {
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1098.15,
              "mode_time_hours": 1099.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1098-1100h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {
                "2026-04-07": 1098.149781111111
              },
              "time_count_per_day": {
                "2026-04-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1121": {
      "overall": {
        "avg_time_hours": 159.81,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 2,
          "14-16h": 1,
          "42-44h": 1,
          "488-490h": 1,
          "512-514h": 1,
          "582-584h": 2
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2026-02-25": 1,
          "2026-03-01": 2,
          "2026-03-07": 1,
          "2026-03-17": 4,
          "2026-03-25": 1,
          "2026-03-30": 1,
          "2026-05-11": 1,
          "2026-05-16": 2,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-02-25": 15.433358333333333,
          "2026-03-01": 3.777989444444444,
          "2026-03-07": 1.9771397222222225,
          "2026-03-17": 2167.4610830555557,
          "2026-03-25": 0.07405666666666666,
          "2026-03-30": 43.467599166666666,
          "2026-05-11": 1.1777433333333334,
          "2026-05-16": 1.9336258333333332,
          "2026-06-02": 2.0750516666666665
        },
        "time_count_per_day": {
          "2026-02-25": 1,
          "2026-03-01": 2,
          "2026-03-07": 1,
          "2026-03-17": 4,
          "2026-03-25": 1,
          "2026-03-30": 1,
          "2026-05-11": 1,
          "2026-05-16": 2,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 159.81,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 2,
            "14-16h": 1,
            "42-44h": 1,
            "488-490h": 1,
            "512-514h": 1,
            "582-584h": 2
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-03-01": 2,
            "2026-03-07": 1,
            "2026-03-17": 4,
            "2026-03-25": 1,
            "2026-03-30": 1,
            "2026-05-11": 1,
            "2026-05-16": 2,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-02-25": 15.433358333333333,
            "2026-03-01": 3.777989444444444,
            "2026-03-07": 1.9771397222222225,
            "2026-03-17": 2167.4610830555557,
            "2026-03-25": 0.07405666666666666,
            "2026-03-30": 43.467599166666666,
            "2026-05-11": 1.1777433333333334,
            "2026-05-16": 1.9336258333333332,
            "2026-06-02": 2.0750516666666665
          },
          "time_count_per_day": {
            "2026-02-25": 1,
            "2026-03-01": 2,
            "2026-03-07": 1,
            "2026-03-17": 4,
            "2026-03-25": 1,
            "2026-03-30": 1,
            "2026-05-11": 1,
            "2026-05-16": 2,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 159.81,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 2,
              "14-16h": 1,
              "42-44h": 1,
              "488-490h": 1,
              "512-514h": 1,
              "582-584h": 2
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2026-02-25": 1,
              "2026-03-01": 2,
              "2026-03-07": 1,
              "2026-03-17": 4,
              "2026-03-25": 1,
              "2026-03-30": 1,
              "2026-05-11": 1,
              "2026-05-16": 2,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-02-25": 15.433358333333333,
              "2026-03-01": 3.777989444444444,
              "2026-03-07": 1.9771397222222225,
              "2026-03-17": 2167.4610830555557,
              "2026-03-25": 0.07405666666666666,
              "2026-03-30": 43.467599166666666,
              "2026-05-11": 1.1777433333333334,
              "2026-05-16": 1.9336258333333332,
              "2026-06-02": 2.0750516666666665
            },
            "time_count_per_day": {
              "2026-02-25": 1,
              "2026-03-01": 2,
              "2026-03-07": 1,
              "2026-03-17": 4,
              "2026-03-25": 1,
              "2026-03-30": 1,
              "2026-05-11": 1,
              "2026-05-16": 2,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 159.81,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 2,
                "14-16h": 1,
                "42-44h": 1,
                "488-490h": 1,
                "512-514h": 1,
                "582-584h": 2
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-02-25": 1,
                "2026-03-01": 2,
                "2026-03-07": 1,
                "2026-03-17": 4,
                "2026-03-25": 1,
                "2026-03-30": 1,
                "2026-05-11": 1,
                "2026-05-16": 2,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-02-25": 15.433358333333333,
                "2026-03-01": 3.777989444444444,
                "2026-03-07": 1.9771397222222225,
                "2026-03-17": 2167.4610830555557,
                "2026-03-25": 0.07405666666666666,
                "2026-03-30": 43.467599166666666,
                "2026-05-11": 1.1777433333333334,
                "2026-05-16": 1.9336258333333332,
                "2026-06-02": 2.0750516666666665
              },
              "time_count_per_day": {
                "2026-02-25": 1,
                "2026-03-01": 2,
                "2026-03-07": 1,
                "2026-03-17": 4,
                "2026-03-25": 1,
                "2026-03-30": 1,
                "2026-05-11": 1,
                "2026-05-16": 2,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1122": {
      "overall": {
        "avg_time_hours": 0.36,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-21": 1
        },
        "time_per_day": {
          "2026-02-21": 0.3622736111111111
        },
        "time_count_per_day": {
          "2026-02-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-21": 1
          },
          "time_per_day": {
            "2026-02-21": 0.3622736111111111
          },
          "time_count_per_day": {
            "2026-02-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.36,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-21": 1
            },
            "time_per_day": {
              "2026-02-21": 0.3622736111111111
            },
            "time_count_per_day": {
              "2026-02-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-21": 1
              },
              "time_per_day": {
                "2026-02-21": 0.3622736111111111
              },
              "time_count_per_day": {
                "2026-02-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1123": {
      "overall": {
        "avg_time_hours": 12.11,
        "mode_time_hours": 13.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-23": 1
        },
        "time_per_day": {
          "2026-02-23": 12.109019444444444
        },
        "time_count_per_day": {
          "2026-02-23": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 12.11,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-23": 1
          },
          "time_per_day": {
            "2026-02-23": 12.109019444444444
          },
          "time_count_per_day": {
            "2026-02-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 12.11,
            "mode_time_hours": 13.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-23": 1
            },
            "time_per_day": {
              "2026-02-23": 12.109019444444444
            },
            "time_count_per_day": {
              "2026-02-23": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 12.11,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {
                "2026-02-23": 12.109019444444444
              },
              "time_count_per_day": {
                "2026-02-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_989": {
      "overall": {
        "avg_time_hours": 597.4,
        "mode_time_hours": 1295.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "66-68h": 1,
          "1024-1026h": 1,
          "1294-1296h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-09": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-05-25": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-03-09": 66.02141472222222,
          "2026-04-17": 1024.8075602777778,
          "2026-04-18": 1295.642413888889,
          "2026-05-25": 3.116398333333333
        },
        "time_count_per_day": {
          "2026-03-09": 1,
          "2026-04-17": 1,
          "2026-04-18": 1,
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 66.02,
          "mode_time_hours": 67.0,
          "mode_frequency": 1,
          "time_distribution": {
            "66-68h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-03-09": 66.02141472222222
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        },
        "P2": {
          "avg_time_hours": 774.52,
          "mode_time_hours": 1295.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "1024-1026h": 1,
            "1294-1296h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-04-17": 1024.8075602777778,
            "2026-04-18": 1295.642413888889,
            "2026-05-25": 3.116398333333333
          },
          "time_count_per_day": {
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 597.4,
            "mode_time_hours": 1295.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "66-68h": 1,
              "1024-1026h": 1,
              "1294-1296h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-09": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-03-09": 66.02141472222222,
              "2026-04-17": 1024.8075602777778,
              "2026-04-18": 1295.642413888889,
              "2026-05-25": 3.116398333333333
            },
            "time_count_per_day": {
              "2026-03-09": 1,
              "2026-04-17": 1,
              "2026-04-18": 1,
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 66.02,
              "mode_time_hours": 67.0,
              "mode_frequency": 1,
              "time_distribution": {
                "66-68h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 66.02141472222222
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            },
            "P2": {
              "avg_time_hours": 774.52,
              "mode_time_hours": 1295.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "1024-1026h": 1,
                "1294-1296h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-04-17": 1024.8075602777778,
                "2026-04-18": 1295.642413888889,
                "2026-05-25": 3.116398333333333
              },
              "time_count_per_day": {
                "2026-04-17": 1,
                "2026-04-18": 1,
                "2026-05-25": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1124": {
      "overall": {
        "avg_time_hours": 0.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-23": 1
        },
        "time_per_day": {
          "2026-02-23": 0.06165888888888889
        },
        "time_count_per_day": {
          "2026-02-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.06,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-23": 1
          },
          "time_per_day": {
            "2026-02-23": 0.06165888888888889
          },
          "time_count_per_day": {
            "2026-02-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-23": 1
            },
            "time_per_day": {
              "2026-02-23": 0.06165888888888889
            },
            "time_count_per_day": {
              "2026-02-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.06,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {
                "2026-02-23": 0.06165888888888889
              },
              "time_count_per_day": {
                "2026-02-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1128": {
      "overall": {
        "avg_time_hours": 244.99,
        "mode_time_hours": 245.0,
        "mode_frequency": 1,
        "time_distribution": {
          "244-246h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-06": 1
        },
        "time_per_day": {
          "2026-03-06": 244.98789555555555
        },
        "time_count_per_day": {
          "2026-03-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 244.99,
          "mode_time_hours": 245.0,
          "mode_frequency": 1,
          "time_distribution": {
            "244-246h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-03-06": 244.98789555555555
          },
          "time_count_per_day": {
            "2026-03-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 244.99,
            "mode_time_hours": 245.0,
            "mode_frequency": 1,
            "time_distribution": {
              "244-246h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-06": 1
            },
            "time_per_day": {
              "2026-03-06": 244.98789555555555
            },
            "time_count_per_day": {
              "2026-03-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 244.99,
              "mode_time_hours": 245.0,
              "mode_frequency": 1,
              "time_distribution": {
                "244-246h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {
                "2026-03-06": 244.98789555555555
              },
              "time_count_per_day": {
                "2026-03-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1130": {
      "overall": {
        "avg_time_hours": 314.63,
        "mode_time_hours": 575.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "366-368h": 1,
          "574-576h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-25": 1,
          "2026-03-20": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-02-25": 1.1436641666666667,
          "2026-03-20": 575.7142755555556,
          "2026-05-26": 367.0403944444444
        },
        "time_count_per_day": {
          "2026-02-25": 1,
          "2026-03-20": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 184.09,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "366-368h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-25": 1.1436641666666667,
            "2026-05-26": 367.0403944444444
          },
          "time_count_per_day": {
            "2026-02-25": 1,
            "2026-05-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 575.71,
          "mode_time_hours": 575.0,
          "mode_frequency": 1,
          "time_distribution": {
            "574-576h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 575.7142755555556
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 314.63,
            "mode_time_hours": 575.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "366-368h": 1,
              "574-576h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-25": 1,
              "2026-03-20": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-02-25": 1.1436641666666667,
              "2026-03-20": 575.7142755555556,
              "2026-05-26": 367.0403944444444
            },
            "time_count_per_day": {
              "2026-02-25": 1,
              "2026-03-20": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 184.09,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "366-368h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-25": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-02-25": 1.1436641666666667,
                "2026-05-26": 367.0403944444444
              },
              "time_count_per_day": {
                "2026-02-25": 1,
                "2026-05-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 575.71,
              "mode_time_hours": 575.0,
              "mode_frequency": 1,
              "time_distribution": {
                "574-576h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 575.7142755555556
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1131": {
      "overall": {
        "avg_time_hours": 1.39,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-24": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-02-24": 0.4033305555555556,
          "2026-05-26": 2.380421666666667
        },
        "time_count_per_day": {
          "2026-02-24": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.39,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-24": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-02-24": 0.4033305555555556,
            "2026-05-26": 2.380421666666667
          },
          "time_count_per_day": {
            "2026-02-24": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.39,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-02-24": 0.4033305555555556,
              "2026-05-26": 2.380421666666667
            },
            "time_count_per_day": {
              "2026-02-24": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.39,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-24": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-02-24": 0.4033305555555556,
                "2026-05-26": 2.380421666666667
              },
              "time_count_per_day": {
                "2026-02-24": 1,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1132": {
      "overall": {
        "avg_time_hours": 1266.23,
        "mode_time_hours": 1267.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1266-1268h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-18": 1
        },
        "time_per_day": {
          "2026-04-18": 1266.2250230555555
        },
        "time_count_per_day": {
          "2026-04-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1266.23,
          "mode_time_hours": 1267.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1266-1268h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-18": 1
          },
          "time_per_day": {
            "2026-04-18": 1266.2250230555555
          },
          "time_count_per_day": {
            "2026-04-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1266.23,
            "mode_time_hours": 1267.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1266-1268h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-18": 1
            },
            "time_per_day": {
              "2026-04-18": 1266.2250230555555
            },
            "time_count_per_day": {
              "2026-04-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1266.23,
              "mode_time_hours": 1267.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1266-1268h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-18": 1
              },
              "time_per_day": {
                "2026-04-18": 1266.2250230555555
              },
              "time_count_per_day": {
                "2026-04-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1133": {
      "overall": {
        "avg_time_hours": 3.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "12-14h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-24": 1,
          "2026-03-11": 1,
          "2026-03-24": 1,
          "2026-04-13": 1
        },
        "time_per_day": {
          "2026-02-24": 0.32282972222222217,
          "2026-03-11": 0.3400238888888889,
          "2026-03-24": 12.333308055555555,
          "2026-04-13": 0.2218008333333333
        },
        "time_count_per_day": {
          "2026-02-24": 1,
          "2026-03-11": 1,
          "2026-03-24": 1,
          "2026-04-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "12-14h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-02-24": 1,
            "2026-03-11": 1,
            "2026-03-24": 1,
            "2026-04-13": 1
          },
          "time_per_day": {
            "2026-02-24": 0.32282972222222217,
            "2026-03-11": 0.3400238888888889,
            "2026-03-24": 12.333308055555555,
            "2026-04-13": 0.2218008333333333
          },
          "time_count_per_day": {
            "2026-02-24": 1,
            "2026-03-11": 1,
            "2026-03-24": 1,
            "2026-04-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "12-14h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-02-24": 1,
              "2026-03-11": 1,
              "2026-03-24": 1,
              "2026-04-13": 1
            },
            "time_per_day": {
              "2026-02-24": 0.32282972222222217,
              "2026-03-11": 0.3400238888888889,
              "2026-03-24": 12.333308055555555,
              "2026-04-13": 0.2218008333333333
            },
            "time_count_per_day": {
              "2026-02-24": 1,
              "2026-03-11": 1,
              "2026-03-24": 1,
              "2026-04-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "12-14h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-02-24": 1,
                "2026-03-11": 1,
                "2026-03-24": 1,
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-02-24": 0.32282972222222217,
                "2026-03-11": 0.3400238888888889,
                "2026-03-24": 12.333308055555555,
                "2026-04-13": 0.2218008333333333
              },
              "time_count_per_day": {
                "2026-02-24": 1,
                "2026-03-11": 1,
                "2026-03-24": 1,
                "2026-04-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1134": {
      "overall": {
        "avg_time_hours": 46.11,
        "mode_time_hours": 91.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "90-92h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2026-02-28": 91.53079583333333,
          "2026-05-15": 0.6855388888888889
        },
        "time_count_per_day": {
          "2026-02-28": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.69,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-15": 1
          },
          "time_per_day": {
            "2026-05-15": 0.6855388888888889
          },
          "time_count_per_day": {
            "2026-05-15": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 91.53,
          "mode_time_hours": 91.0,
          "mode_frequency": 1,
          "time_distribution": {
            "90-92h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 91.53079583333333
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 46.11,
            "mode_time_hours": 91.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "90-92h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2026-02-28": 91.53079583333333,
              "2026-05-15": 0.6855388888888889
            },
            "time_count_per_day": {
              "2026-02-28": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.69,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {
                "2026-05-15": 0.6855388888888889
              },
              "time_count_per_day": {
                "2026-05-15": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 91.53,
              "mode_time_hours": 91.0,
              "mode_frequency": 1,
              "time_distribution": {
                "90-92h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 91.53079583333333
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1135": {
      "overall": {
        "avg_time_hours": 0.73,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-25": 1
        },
        "time_per_day": {
          "2026-02-25": 0.7302575
        },
        "time_count_per_day": {
          "2026-02-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-25": 1
          },
          "time_per_day": {
            "2026-02-25": 0.7302575
          },
          "time_count_per_day": {
            "2026-02-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.73,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-25": 1
            },
            "time_per_day": {
              "2026-02-25": 0.7302575
            },
            "time_count_per_day": {
              "2026-02-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-25": 1
              },
              "time_per_day": {
                "2026-02-25": 0.7302575
              },
              "time_count_per_day": {
                "2026-02-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1136": {
      "overall": {
        "avg_time_hours": 0.75,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-25": 1
        },
        "time_per_day": {
          "2026-02-25": 0.7514066666666667
        },
        "time_count_per_day": {
          "2026-02-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.75,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-25": 1
          },
          "time_per_day": {
            "2026-02-25": 0.7514066666666667
          },
          "time_count_per_day": {
            "2026-02-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.75,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-25": 1
            },
            "time_per_day": {
              "2026-02-25": 0.7514066666666667
            },
            "time_count_per_day": {
              "2026-02-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.75,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-25": 1
              },
              "time_per_day": {
                "2026-02-25": 0.7514066666666667
              },
              "time_count_per_day": {
                "2026-02-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1139": {
      "overall": {
        "avg_time_hours": 508.26,
        "mode_time_hours": 509.0,
        "mode_frequency": 1,
        "time_distribution": {
          "508-510h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 508.26013111111115
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 508.26,
          "mode_time_hours": 509.0,
          "mode_frequency": 1,
          "time_distribution": {
            "508-510h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 508.26013111111115
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 508.26,
            "mode_time_hours": 509.0,
            "mode_frequency": 1,
            "time_distribution": {
              "508-510h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 508.26013111111115
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 508.26,
              "mode_time_hours": 509.0,
              "mode_frequency": 1,
              "time_distribution": {
                "508-510h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 508.26013111111115
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1140": {
      "overall": {
        "avg_time_hours": 503.3,
        "mode_time_hours": 503.0,
        "mode_frequency": 1,
        "time_distribution": {
          "502-504h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 503.3049541666667
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 503.3,
          "mode_time_hours": 503.0,
          "mode_frequency": 1,
          "time_distribution": {
            "502-504h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 503.3049541666667
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 503.3,
            "mode_time_hours": 503.0,
            "mode_frequency": 1,
            "time_distribution": {
              "502-504h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 503.3049541666667
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 503.3,
              "mode_time_hours": 503.0,
              "mode_frequency": 1,
              "time_distribution": {
                "502-504h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 503.3049541666667
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1141": {
      "overall": {
        "avg_time_hours": 251.5,
        "mode_time_hours": 503.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "502-504h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 1,
          "2026-04-21": 1
        },
        "time_per_day": {
          "2026-03-18": 502.47938972222227,
          "2026-04-21": 0.5145725
        },
        "time_count_per_day": {
          "2026-03-18": 1,
          "2026-04-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-21": 1
          },
          "time_per_day": {
            "2026-04-21": 0.5145725
          },
          "time_count_per_day": {
            "2026-04-21": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 502.48,
          "mode_time_hours": 503.0,
          "mode_frequency": 1,
          "time_distribution": {
            "502-504h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 502.47938972222227
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 251.5,
            "mode_time_hours": 503.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "502-504h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 1,
              "2026-04-21": 1
            },
            "time_per_day": {
              "2026-03-18": 502.47938972222227,
              "2026-04-21": 0.5145725
            },
            "time_count_per_day": {
              "2026-03-18": 1,
              "2026-04-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {
                "2026-04-21": 0.5145725
              },
              "time_count_per_day": {
                "2026-04-21": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 502.48,
              "mode_time_hours": 503.0,
              "mode_frequency": 1,
              "time_distribution": {
                "502-504h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 502.47938972222227
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1143": {
      "overall": {
        "avg_time_hours": 103.62,
        "mode_time_hours": 1.0,
        "mode_frequency": 7,
        "time_distribution": {
          "0-2h": 7,
          "2-4h": 3,
          "4-6h": 1,
          "8-10h": 1,
          "16-18h": 1,
          "18-20h": 3,
          "22-24h": 3,
          "26-28h": 1,
          "44-46h": 1,
          "46-48h": 1,
          "48-50h": 1,
          "56-58h": 1,
          "72-74h": 1,
          "148-150h": 1,
          "342-344h": 1,
          "496-498h": 1,
          "748-750h": 1,
          "896-898h": 1
        },
        "tickets_count": 32,
        "tickets_per_day": {
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-07": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-19": 1,
          "2026-03-31": 1,
          "2026-04-01": 2,
          "2026-04-02": 1,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 3,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-05-04": 2,
          "2026-05-06": 1,
          "2026-05-13": 1,
          "2026-05-27": 2,
          "2026-05-30": 1,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-02-25": 2.429491111111111,
          "2026-02-26": 1.8364683333333334,
          "2026-03-02": 8.790734722222222,
          "2026-03-05": 0.6697136111111112,
          "2026-03-06": 3.0886233333333335,
          "2026-03-07": 105.94499472222222,
          "2026-03-09": 5.234153611111111,
          "2026-03-10": 23.168853055555555,
          "2026-03-11": 343.7151077777778,
          "2026-03-19": 1.592973888888889,
          "2026-03-31": 19.930277222222223,
          "2026-04-01": 23.99723555555556,
          "2026-04-02": 73.94911916666668,
          "2026-04-07": 49.87945166666667,
          "2026-04-08": 148.3970688888889,
          "2026-04-10": 93.44061694444444,
          "2026-04-21": 16.983233055555555,
          "2026-04-23": 1645.3106475,
          "2026-05-04": 498.97037222222224,
          "2026-05-06": 19.28138472222222,
          "2026-05-27": 3.8252788888888887,
          "2026-05-30": 18.16279388888889
        },
        "time_count_per_day": {
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-03-02": 1,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-07": 2,
          "2026-03-09": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-19": 1,
          "2026-03-31": 1,
          "2026-04-01": 2,
          "2026-04-02": 1,
          "2026-04-07": 2,
          "2026-04-08": 1,
          "2026-04-10": 3,
          "2026-04-21": 1,
          "2026-04-23": 2,
          "2026-05-04": 2,
          "2026-05-06": 1,
          "2026-05-27": 2,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 96.23,
          "mode_time_hours": 1.0,
          "mode_frequency": 7,
          "time_distribution": {
            "0-2h": 7,
            "2-4h": 3,
            "4-6h": 1,
            "8-10h": 1,
            "18-20h": 3,
            "22-24h": 3,
            "26-28h": 1,
            "48-50h": 1,
            "56-58h": 1,
            "72-74h": 1,
            "148-150h": 1,
            "342-344h": 1,
            "748-750h": 1,
            "896-898h": 1
          },
          "tickets_count": 28,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-07": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-19": 1,
            "2026-03-31": 1,
            "2026-04-01": 2,
            "2026-04-02": 1,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-23": 2,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-13": 1,
            "2026-05-27": 2,
            "2026-05-30": 1,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-02-25": 2.429491111111111,
            "2026-02-26": 1.8364683333333334,
            "2026-03-02": 8.790734722222222,
            "2026-03-05": 0.6697136111111112,
            "2026-03-06": 3.0886233333333335,
            "2026-03-07": 105.94499472222222,
            "2026-03-09": 5.234153611111111,
            "2026-03-10": 23.168853055555555,
            "2026-03-11": 343.7151077777778,
            "2026-03-19": 1.592973888888889,
            "2026-03-31": 19.930277222222223,
            "2026-04-01": 23.99723555555556,
            "2026-04-02": 73.94911916666668,
            "2026-04-07": 49.87945166666667,
            "2026-04-08": 148.3970688888889,
            "2026-04-10": 1.7646805555555556,
            "2026-04-23": 1645.3106475,
            "2026-05-04": 1.1224775,
            "2026-05-06": 19.28138472222222,
            "2026-05-27": 3.8252788888888887,
            "2026-05-30": 18.16279388888889
          },
          "time_count_per_day": {
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-07": 2,
            "2026-03-09": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-19": 1,
            "2026-03-31": 1,
            "2026-04-01": 2,
            "2026-04-02": 1,
            "2026-04-07": 2,
            "2026-04-08": 1,
            "2026-04-10": 1,
            "2026-04-23": 2,
            "2026-05-04": 1,
            "2026-05-06": 1,
            "2026-05-27": 2,
            "2026-05-30": 1
          }
        },
        "P3": {
          "avg_time_hours": 151.63,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "44-46h": 1,
            "46-48h": 1,
            "496-498h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-10": 2,
            "2026-04-21": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-04-10": 91.67593638888889,
            "2026-04-21": 16.983233055555555,
            "2026-05-04": 497.84789472222224
          },
          "time_count_per_day": {
            "2026-04-10": 2,
            "2026-04-21": 1,
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 103.62,
            "mode_time_hours": 1.0,
            "mode_frequency": 7,
            "time_distribution": {
              "0-2h": 7,
              "2-4h": 3,
              "4-6h": 1,
              "8-10h": 1,
              "16-18h": 1,
              "18-20h": 3,
              "22-24h": 3,
              "26-28h": 1,
              "44-46h": 1,
              "46-48h": 1,
              "48-50h": 1,
              "56-58h": 1,
              "72-74h": 1,
              "148-150h": 1,
              "342-344h": 1,
              "496-498h": 1,
              "748-750h": 1,
              "896-898h": 1
            },
            "tickets_count": 30,
            "tickets_per_day": {
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-07": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-19": 1,
              "2026-03-31": 1,
              "2026-04-01": 2,
              "2026-04-02": 1,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 3,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-05-04": 2,
              "2026-05-06": 1,
              "2026-05-27": 2,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-02-25": 2.429491111111111,
              "2026-02-26": 1.8364683333333334,
              "2026-03-02": 8.790734722222222,
              "2026-03-05": 0.6697136111111112,
              "2026-03-06": 3.0886233333333335,
              "2026-03-07": 105.94499472222222,
              "2026-03-09": 5.234153611111111,
              "2026-03-10": 23.168853055555555,
              "2026-03-11": 343.7151077777778,
              "2026-03-19": 1.592973888888889,
              "2026-03-31": 19.930277222222223,
              "2026-04-01": 23.99723555555556,
              "2026-04-02": 73.94911916666668,
              "2026-04-07": 49.87945166666667,
              "2026-04-08": 148.3970688888889,
              "2026-04-10": 93.44061694444444,
              "2026-04-21": 16.983233055555555,
              "2026-04-23": 1645.3106475,
              "2026-05-04": 498.97037222222224,
              "2026-05-06": 19.28138472222222,
              "2026-05-27": 3.8252788888888887,
              "2026-05-30": 18.16279388888889
            },
            "time_count_per_day": {
              "2026-02-25": 1,
              "2026-02-26": 1,
              "2026-03-02": 1,
              "2026-03-05": 1,
              "2026-03-06": 1,
              "2026-03-07": 2,
              "2026-03-09": 1,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-19": 1,
              "2026-03-31": 1,
              "2026-04-01": 2,
              "2026-04-02": 1,
              "2026-04-07": 2,
              "2026-04-08": 1,
              "2026-04-10": 3,
              "2026-04-21": 1,
              "2026-04-23": 2,
              "2026-05-04": 2,
              "2026-05-06": 1,
              "2026-05-27": 2,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 96.23,
              "mode_time_hours": 1.0,
              "mode_frequency": 7,
              "time_distribution": {
                "0-2h": 7,
                "2-4h": 3,
                "4-6h": 1,
                "8-10h": 1,
                "18-20h": 3,
                "22-24h": 3,
                "26-28h": 1,
                "48-50h": 1,
                "56-58h": 1,
                "72-74h": 1,
                "148-150h": 1,
                "342-344h": 1,
                "748-750h": 1,
                "896-898h": 1
              },
              "tickets_count": 26,
              "tickets_per_day": {
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-07": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-19": 1,
                "2026-03-31": 1,
                "2026-04-01": 2,
                "2026-04-02": 1,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-23": 2,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-27": 2,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-02-25": 2.429491111111111,
                "2026-02-26": 1.8364683333333334,
                "2026-03-02": 8.790734722222222,
                "2026-03-05": 0.6697136111111112,
                "2026-03-06": 3.0886233333333335,
                "2026-03-07": 105.94499472222222,
                "2026-03-09": 5.234153611111111,
                "2026-03-10": 23.168853055555555,
                "2026-03-11": 343.7151077777778,
                "2026-03-19": 1.592973888888889,
                "2026-03-31": 19.930277222222223,
                "2026-04-01": 23.99723555555556,
                "2026-04-02": 73.94911916666668,
                "2026-04-07": 49.87945166666667,
                "2026-04-08": 148.3970688888889,
                "2026-04-10": 1.7646805555555556,
                "2026-04-23": 1645.3106475,
                "2026-05-04": 1.1224775,
                "2026-05-06": 19.28138472222222,
                "2026-05-27": 3.8252788888888887,
                "2026-05-30": 18.16279388888889
              },
              "time_count_per_day": {
                "2026-02-25": 1,
                "2026-02-26": 1,
                "2026-03-02": 1,
                "2026-03-05": 1,
                "2026-03-06": 1,
                "2026-03-07": 2,
                "2026-03-09": 1,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-19": 1,
                "2026-03-31": 1,
                "2026-04-01": 2,
                "2026-04-02": 1,
                "2026-04-07": 2,
                "2026-04-08": 1,
                "2026-04-10": 1,
                "2026-04-23": 2,
                "2026-05-04": 1,
                "2026-05-06": 1,
                "2026-05-27": 2,
                "2026-05-30": 1
              }
            },
            "P3": {
              "avg_time_hours": 151.63,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "44-46h": 1,
                "46-48h": 1,
                "496-498h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-10": 2,
                "2026-04-21": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-04-10": 91.67593638888889,
                "2026-04-21": 16.983233055555555,
                "2026-05-04": 497.84789472222224
              },
              "time_count_per_day": {
                "2026-04-10": 2,
                "2026-04-21": 1,
                "2026-05-04": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1144": {
      "overall": {
        "avg_time_hours": 893.44,
        "mode_time_hours": 1341.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "1338-1340h": 1,
          "1340-1342h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-25": 1,
          "2026-04-22": 2
        },
        "time_per_day": {
          "2026-02-25": 0.09424194444444445,
          "2026-04-22": 2680.2232933333335
        },
        "time_count_per_day": {
          "2026-02-25": 1,
          "2026-04-22": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 893.44,
          "mode_time_hours": 1341.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "1338-1340h": 1,
            "1340-1342h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-04-22": 2
          },
          "time_per_day": {
            "2026-02-25": 0.09424194444444445,
            "2026-04-22": 2680.2232933333335
          },
          "time_count_per_day": {
            "2026-02-25": 1,
            "2026-04-22": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 893.44,
            "mode_time_hours": 1341.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "1338-1340h": 1,
              "1340-1342h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-25": 1,
              "2026-04-22": 2
            },
            "time_per_day": {
              "2026-02-25": 0.09424194444444445,
              "2026-04-22": 2680.2232933333335
            },
            "time_count_per_day": {
              "2026-02-25": 1,
              "2026-04-22": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 893.44,
              "mode_time_hours": 1341.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "1338-1340h": 1,
                "1340-1342h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-25": 1,
                "2026-04-22": 2
              },
              "time_per_day": {
                "2026-02-25": 0.09424194444444445,
                "2026-04-22": 2680.2232933333335
              },
              "time_count_per_day": {
                "2026-02-25": 1,
                "2026-04-22": 2
              }
            }
          }
        }
      }
    },
    "cliente_1145": {
      "overall": {
        "avg_time_hours": 497.01,
        "mode_time_hours": 497.0,
        "mode_frequency": 1,
        "time_distribution": {
          "496-498h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-03-18": 497.0128880555556
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 497.01,
          "mode_time_hours": 497.0,
          "mode_frequency": 1,
          "time_distribution": {
            "496-498h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-03-18": 497.0128880555556
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 497.01,
            "mode_time_hours": 497.0,
            "mode_frequency": 1,
            "time_distribution": {
              "496-498h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 497.0128880555556
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 497.01,
              "mode_time_hours": 497.0,
              "mode_frequency": 1,
              "time_distribution": {
                "496-498h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 497.0128880555556
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1146": {
      "overall": {
        "avg_time_hours": 69.67,
        "mode_time_hours": 69.0,
        "mode_frequency": 1,
        "time_distribution": {
          "68-70h": 1,
          "70-72h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 2
        },
        "time_per_day": {
          "2026-02-28": 139.34505027777777
        },
        "time_count_per_day": {
          "2026-02-28": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 69.67,
          "mode_time_hours": 69.0,
          "mode_frequency": 1,
          "time_distribution": {
            "68-70h": 1,
            "70-72h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 2
          },
          "time_per_day": {
            "2026-02-28": 139.34505027777777
          },
          "time_count_per_day": {
            "2026-02-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 69.67,
            "mode_time_hours": 69.0,
            "mode_frequency": 1,
            "time_distribution": {
              "68-70h": 1,
              "70-72h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 2
            },
            "time_per_day": {
              "2026-02-28": 139.34505027777777
            },
            "time_count_per_day": {
              "2026-02-28": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 69.67,
              "mode_time_hours": 69.0,
              "mode_frequency": 1,
              "time_distribution": {
                "68-70h": 1,
                "70-72h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-28": 2
              },
              "time_per_day": {
                "2026-02-28": 139.34505027777777
              },
              "time_count_per_day": {
                "2026-02-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_1148": {
      "overall": {
        "avg_time_hours": 56.2,
        "mode_time_hours": 57.0,
        "mode_frequency": 1,
        "time_distribution": {
          "56-58h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 56.203357777777775
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 56.2,
          "mode_time_hours": 57.0,
          "mode_frequency": 1,
          "time_distribution": {
            "56-58h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 56.203357777777775
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 56.2,
            "mode_time_hours": 57.0,
            "mode_frequency": 1,
            "time_distribution": {
              "56-58h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 56.203357777777775
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 56.2,
              "mode_time_hours": 57.0,
              "mode_frequency": 1,
              "time_distribution": {
                "56-58h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 56.203357777777775
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1149": {
      "overall": {
        "avg_time_hours": 51.16,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "50-52h": 1,
          "52-54h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 2
        },
        "time_per_day": {
          "2026-02-28": 102.3174925
        },
        "time_count_per_day": {
          "2026-02-28": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 51.16,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1,
            "52-54h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 2
          },
          "time_per_day": {
            "2026-02-28": 102.3174925
          },
          "time_count_per_day": {
            "2026-02-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 51.16,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "50-52h": 1,
              "52-54h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 2
            },
            "time_per_day": {
              "2026-02-28": 102.3174925
            },
            "time_count_per_day": {
              "2026-02-28": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 51.16,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1,
                "52-54h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-28": 2
              },
              "time_per_day": {
                "2026-02-28": 102.3174925
              },
              "time_count_per_day": {
                "2026-02-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_1150": {
      "overall": {
        "avg_time_hours": 0.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-26": 1
        },
        "time_per_day": {
          "2026-02-26": 0.2181336111111111
        },
        "time_count_per_day": {
          "2026-02-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-26": 1
          },
          "time_per_day": {
            "2026-02-26": 0.2181336111111111
          },
          "time_count_per_day": {
            "2026-02-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-26": 1
            },
            "time_per_day": {
              "2026-02-26": 0.2181336111111111
            },
            "time_count_per_day": {
              "2026-02-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-26": 1
              },
              "time_per_day": {
                "2026-02-26": 0.2181336111111111
              },
              "time_count_per_day": {
                "2026-02-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1154": {
      "overall": {
        "avg_time_hours": 44.69,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 44.69250416666667
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 44.69,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 44.69250416666667
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 44.69,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 44.69250416666667
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 44.69,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 44.69250416666667
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1155": {
      "overall": {
        "avg_time_hours": 11.82,
        "mode_time_hours": 11.0,
        "mode_frequency": 3,
        "time_distribution": {
          "10-12h": 3
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-27": 3,
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-27": 35.45248472222222
        },
        "time_count_per_day": {
          "2026-02-27": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.82,
          "mode_time_hours": 11.0,
          "mode_frequency": 3,
          "time_distribution": {
            "10-12h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-27": 3
          },
          "time_per_day": {
            "2026-02-27": 35.45248472222222
          },
          "time_count_per_day": {
            "2026-02-27": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.82,
            "mode_time_hours": 11.0,
            "mode_frequency": 3,
            "time_distribution": {
              "10-12h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-02-27": 3
            },
            "time_per_day": {
              "2026-02-27": 35.45248472222222
            },
            "time_count_per_day": {
              "2026-02-27": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.82,
              "mode_time_hours": 11.0,
              "mode_frequency": 3,
              "time_distribution": {
                "10-12h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-02-27": 3
              },
              "time_per_day": {
                "2026-02-27": 35.45248472222222
              },
              "time_count_per_day": {
                "2026-02-27": 3
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1156": {
      "overall": {
        "avg_time_hours": 0.04,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-26": 1
        },
        "time_per_day": {
          "2026-02-26": 0.038824444444444446
        },
        "time_count_per_day": {
          "2026-02-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.04,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-26": 1
          },
          "time_per_day": {
            "2026-02-26": 0.038824444444444446
          },
          "time_count_per_day": {
            "2026-02-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.04,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-26": 1
            },
            "time_per_day": {
              "2026-02-26": 0.038824444444444446
            },
            "time_count_per_day": {
              "2026-02-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.04,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-26": 1
              },
              "time_per_day": {
                "2026-02-26": 0.038824444444444446
              },
              "time_count_per_day": {
                "2026-02-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1157": {
      "overall": {
        "avg_time_hours": 467.83,
        "mode_time_hours": 467.0,
        "mode_frequency": 1,
        "time_distribution": {
          "466-468h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 467.8324902777778
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 467.83,
          "mode_time_hours": 467.0,
          "mode_frequency": 1,
          "time_distribution": {
            "466-468h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 467.8324902777778
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 467.83,
            "mode_time_hours": 467.0,
            "mode_frequency": 1,
            "time_distribution": {
              "466-468h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 467.8324902777778
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 467.83,
              "mode_time_hours": 467.0,
              "mode_frequency": 1,
              "time_distribution": {
                "466-468h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 467.8324902777778
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1158": {
      "overall": {
        "avg_time_hours": 44.79,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 44.791557222222224
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 44.79,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 44.791557222222224
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 44.79,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 44.791557222222224
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 44.79,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 44.791557222222224
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1159": {
      "overall": {
        "avg_time_hours": 44.79,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 44.787021111111116
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 44.79,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 44.787021111111116
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 44.79,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 44.787021111111116
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 44.79,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 44.787021111111116
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_915": {
      "overall": {
        "avg_time_hours": 456.92,
        "mode_time_hours": 457.0,
        "mode_frequency": 1,
        "time_distribution": {
          "456-458h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 456.9204016666667
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 456.92,
          "mode_time_hours": 457.0,
          "mode_frequency": 1,
          "time_distribution": {
            "456-458h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 456.9204016666667
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 456.92,
            "mode_time_hours": 457.0,
            "mode_frequency": 1,
            "time_distribution": {
              "456-458h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 456.9204016666667
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 456.92,
              "mode_time_hours": 457.0,
              "mode_frequency": 1,
              "time_distribution": {
                "456-458h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 456.9204016666667
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1160": {
      "overall": {
        "avg_time_hours": 459.0,
        "mode_time_hours": 459.0,
        "mode_frequency": 2,
        "time_distribution": {
          "458-460h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-03-18": 918.0027266666667
        },
        "time_count_per_day": {
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 459.0,
          "mode_time_hours": 459.0,
          "mode_frequency": 2,
          "time_distribution": {
            "458-460h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 918.0027266666667
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 459.0,
            "mode_time_hours": 459.0,
            "mode_frequency": 2,
            "time_distribution": {
              "458-460h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-03-18": 918.0027266666667
            },
            "time_count_per_day": {
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 459.0,
              "mode_time_hours": 459.0,
              "mode_frequency": 2,
              "time_distribution": {
                "458-460h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 918.0027266666667
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_1161": {
      "overall": {
        "avg_time_hours": 454.13,
        "mode_time_hours": 455.0,
        "mode_frequency": 1,
        "time_distribution": {
          "454-456h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 454.1289852777778
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 454.13,
          "mode_time_hours": 455.0,
          "mode_frequency": 1,
          "time_distribution": {
            "454-456h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 454.1289852777778
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 454.13,
            "mode_time_hours": 455.0,
            "mode_frequency": 1,
            "time_distribution": {
              "454-456h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 454.1289852777778
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 454.13,
              "mode_time_hours": 455.0,
              "mode_frequency": 1,
              "time_distribution": {
                "454-456h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 454.1289852777778
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_917": {
      "overall": {
        "avg_time_hours": 171.46,
        "mode_time_hours": 171.0,
        "mode_frequency": 1,
        "time_distribution": {
          "170-172h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-06": 1
        },
        "time_per_day": {
          "2026-03-06": 171.45999750000001
        },
        "time_count_per_day": {
          "2026-03-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 171.46,
          "mode_time_hours": 171.0,
          "mode_frequency": 1,
          "time_distribution": {
            "170-172h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-03-06": 171.45999750000001
          },
          "time_count_per_day": {
            "2026-03-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 171.46,
            "mode_time_hours": 171.0,
            "mode_frequency": 1,
            "time_distribution": {
              "170-172h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-06": 1
            },
            "time_per_day": {
              "2026-03-06": 171.45999750000001
            },
            "time_count_per_day": {
              "2026-03-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 171.46,
              "mode_time_hours": 171.0,
              "mode_frequency": 1,
              "time_distribution": {
                "170-172h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {
                "2026-03-06": 171.45999750000001
              },
              "time_count_per_day": {
                "2026-03-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1162": {
      "overall": {
        "avg_time_hours": 28.54,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 28.5442675
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 28.54,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 28.5442675
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 28.54,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 28.5442675
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 28.54,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 28.5442675
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1152": {
      "overall": {
        "avg_time_hours": 17.83,
        "mode_time_hours": 23.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1,
          "22-24h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 2
        },
        "time_per_day": {
          "2026-02-28": 35.65164111111111
        },
        "time_count_per_day": {
          "2026-02-28": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 22.6,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 22.598300833333333
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        },
        "P2": {
          "avg_time_hours": 13.05,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 13.053340277777778
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.83,
            "mode_time_hours": 23.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1,
              "22-24h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 2
            },
            "time_per_day": {
              "2026-02-28": 35.65164111111111
            },
            "time_count_per_day": {
              "2026-02-28": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 22.6,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 22.598300833333333
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            },
            "P2": {
              "avg_time_hours": 13.05,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 13.053340277777778
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1165": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-27": 1
        },
        "time_per_day": {
          "2026-02-27": 0.013048333333333332
        },
        "time_count_per_day": {
          "2026-02-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-27": 1
          },
          "time_per_day": {
            "2026-02-27": 0.013048333333333332
          },
          "time_count_per_day": {
            "2026-02-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-27": 1
            },
            "time_per_day": {
              "2026-02-27": 0.013048333333333332
            },
            "time_count_per_day": {
              "2026-02-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-27": 1
              },
              "time_per_day": {
                "2026-02-27": 0.013048333333333332
              },
              "time_count_per_day": {
                "2026-02-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1166": {
      "overall": {
        "avg_time_hours": 26.33,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1,
          "26-28h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 2
        },
        "time_per_day": {
          "2026-02-28": 52.663320277777785
        },
        "time_count_per_day": {
          "2026-02-28": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 26.33,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "26-28h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 2
          },
          "time_per_day": {
            "2026-02-28": 52.663320277777785
          },
          "time_count_per_day": {
            "2026-02-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.33,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1,
              "26-28h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 2
            },
            "time_per_day": {
              "2026-02-28": 52.663320277777785
            },
            "time_count_per_day": {
              "2026-02-28": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 26.33,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "26-28h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-28": 2
              },
              "time_per_day": {
                "2026-02-28": 52.663320277777785
              },
              "time_count_per_day": {
                "2026-02-28": 2
              }
            }
          }
        }
      }
    },
    "cliente_1167": {
      "overall": {
        "avg_time_hours": 14.22,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 14.215294444444444
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 14.22,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 14.215294444444444
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.22,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 14.215294444444444
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 14.22,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 14.215294444444444
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1168": {
      "overall": {
        "avg_time_hours": 232.43,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1,
          "444-446h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-02-28": 1,
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-02-28": 20.71734638888889,
          "2026-03-18": 444.1343561111111
        },
        "time_count_per_day": {
          "2026-02-28": 1,
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 232.43,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "444-446h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-28": 1,
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-02-28": 20.71734638888889,
            "2026-03-18": 444.1343561111111
          },
          "time_count_per_day": {
            "2026-02-28": 1,
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 232.43,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1,
              "444-446h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-28": 1,
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-02-28": 20.71734638888889,
              "2026-03-18": 444.1343561111111
            },
            "time_count_per_day": {
              "2026-02-28": 1,
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 232.43,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "444-446h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-28": 1,
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-02-28": 20.71734638888889,
                "2026-03-18": 444.1343561111111
              },
              "time_count_per_day": {
                "2026-02-28": 1,
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1169": {
      "overall": {
        "avg_time_hours": 20.26,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 20.258221944444443
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 20.26,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 20.258221944444443
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.26,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 20.258221944444443
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 20.26,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 20.258221944444443
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1173": {
      "overall": {
        "avg_time_hours": 422.73,
        "mode_time_hours": 423.0,
        "mode_frequency": 1,
        "time_distribution": {
          "422-424h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 422.7302661111111
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 422.73,
          "mode_time_hours": 423.0,
          "mode_frequency": 1,
          "time_distribution": {
            "422-424h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 422.7302661111111
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 422.73,
            "mode_time_hours": 423.0,
            "mode_frequency": 1,
            "time_distribution": {
              "422-424h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 422.7302661111111
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 422.73,
              "mode_time_hours": 423.0,
              "mode_frequency": 1,
              "time_distribution": {
                "422-424h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 422.7302661111111
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1174": {
      "overall": {
        "avg_time_hours": 2.23,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 2.2335102777777776
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.23,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 2.2335102777777776
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.23,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 2.2335102777777776
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.23,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 2.2335102777777776
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1175": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-28": 1
        },
        "time_per_day": {
          "2026-02-28": 0.009900277777777777
        },
        "time_count_per_day": {
          "2026-02-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-28": 1
          },
          "time_per_day": {
            "2026-02-28": 0.009900277777777777
          },
          "time_count_per_day": {
            "2026-02-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-28": 1
            },
            "time_per_day": {
              "2026-02-28": 0.009900277777777777
            },
            "time_count_per_day": {
              "2026-02-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-28": 1
              },
              "time_per_day": {
                "2026-02-28": 0.009900277777777777
              },
              "time_count_per_day": {
                "2026-02-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1176": {
      "overall": {
        "avg_time_hours": 34.24,
        "mode_time_hours": 9.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 1,
          "6-8h": 1,
          "8-10h": 2,
          "52-54h": 1,
          "54-56h": 1,
          "102-104h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-03-03": 1,
          "2026-03-24": 1,
          "2026-05-27": 2,
          "2026-06-01": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-03-03": 54.24486722222222,
          "2026-03-24": 102.67333527777777,
          "2026-05-27": 16.595649722222223,
          "2026-06-01": 53.84976833333333,
          "2026-06-03": 6.890420555555555,
          "2026-06-05": 5.432123333333333
        },
        "time_count_per_day": {
          "2026-03-03": 1,
          "2026-03-24": 1,
          "2026-05-27": 2,
          "2026-06-01": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 34.24,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 1,
            "6-8h": 1,
            "8-10h": 2,
            "52-54h": 1,
            "54-56h": 1,
            "102-104h": 1
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-03-24": 1,
            "2026-05-27": 2,
            "2026-06-01": 1,
            "2026-06-03": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-03-03": 54.24486722222222,
            "2026-03-24": 102.67333527777777,
            "2026-05-27": 16.595649722222223,
            "2026-06-01": 53.84976833333333,
            "2026-06-03": 6.890420555555555,
            "2026-06-05": 5.432123333333333
          },
          "time_count_per_day": {
            "2026-03-03": 1,
            "2026-03-24": 1,
            "2026-05-27": 2,
            "2026-06-01": 1,
            "2026-06-03": 1,
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 34.24,
            "mode_time_hours": 9.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 1,
              "6-8h": 1,
              "8-10h": 2,
              "52-54h": 1,
              "54-56h": 1,
              "102-104h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-03-24": 1,
              "2026-05-27": 2,
              "2026-06-01": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-03-03": 54.24486722222222,
              "2026-03-24": 102.67333527777777,
              "2026-05-27": 16.595649722222223,
              "2026-06-01": 53.84976833333333,
              "2026-06-03": 6.890420555555555,
              "2026-06-05": 5.432123333333333
            },
            "time_count_per_day": {
              "2026-03-03": 1,
              "2026-03-24": 1,
              "2026-05-27": 2,
              "2026-06-01": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 34.24,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 1,
                "6-8h": 1,
                "8-10h": 2,
                "52-54h": 1,
                "54-56h": 1,
                "102-104h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-03-24": 1,
                "2026-05-27": 2,
                "2026-06-01": 1,
                "2026-06-03": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-03-03": 54.24486722222222,
                "2026-03-24": 102.67333527777777,
                "2026-05-27": 16.595649722222223,
                "2026-06-01": 53.84976833333333,
                "2026-06-03": 6.890420555555555,
                "2026-06-05": 5.432123333333333
              },
              "time_count_per_day": {
                "2026-03-03": 1,
                "2026-03-24": 1,
                "2026-05-27": 2,
                "2026-06-01": 1,
                "2026-06-03": 1,
                "2026-06-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1177": {
      "overall": {
        "avg_time_hours": 6.99,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-01": 1
        },
        "time_per_day": {
          "2026-03-01": 6.988301944444444
        },
        "time_count_per_day": {
          "2026-03-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.99,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-01": 1
          },
          "time_per_day": {
            "2026-03-01": 6.988301944444444
          },
          "time_count_per_day": {
            "2026-03-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.99,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-01": 1
            },
            "time_per_day": {
              "2026-03-01": 6.988301944444444
            },
            "time_count_per_day": {
              "2026-03-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.99,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-01": 1
              },
              "time_per_day": {
                "2026-03-01": 6.988301944444444
              },
              "time_count_per_day": {
                "2026-03-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1178": {
      "overall": {
        "avg_time_hours": 408.96,
        "mode_time_hours": 409.0,
        "mode_frequency": 3,
        "time_distribution": {
          "408-410h": 3
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-18": 3,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-03-18": 1226.8853608333334
        },
        "time_count_per_day": {
          "2026-03-18": 3
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 408.96,
          "mode_time_hours": 409.0,
          "mode_frequency": 3,
          "time_distribution": {
            "408-410h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-18": 3
          },
          "time_per_day": {
            "2026-03-18": 1226.8853608333334
          },
          "time_count_per_day": {
            "2026-03-18": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 408.96,
            "mode_time_hours": 409.0,
            "mode_frequency": 3,
            "time_distribution": {
              "408-410h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-18": 3
            },
            "time_per_day": {
              "2026-03-18": 1226.8853608333334
            },
            "time_count_per_day": {
              "2026-03-18": 3
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 408.96,
              "mode_time_hours": 409.0,
              "mode_frequency": 3,
              "time_distribution": {
                "408-410h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-18": 3
              },
              "time_per_day": {
                "2026-03-18": 1226.8853608333334
              },
              "time_count_per_day": {
                "2026-03-18": 3
              }
            }
          }
        },
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1179": {
      "overall": {
        "avg_time_hours": 405.91,
        "mode_time_hours": 405.0,
        "mode_frequency": 1,
        "time_distribution": {
          "404-406h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 405.90937194444444
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 405.91,
          "mode_time_hours": 405.0,
          "mode_frequency": 1,
          "time_distribution": {
            "404-406h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 405.90937194444444
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 405.91,
            "mode_time_hours": 405.0,
            "mode_frequency": 1,
            "time_distribution": {
              "404-406h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 405.90937194444444
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 405.91,
              "mode_time_hours": 405.0,
              "mode_frequency": 1,
              "time_distribution": {
                "404-406h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 405.90937194444444
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1180": {
      "overall": {
        "avg_time_hours": 400.29,
        "mode_time_hours": 401.0,
        "mode_frequency": 1,
        "time_distribution": {
          "400-402h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 400.2912813888889
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 400.29,
          "mode_time_hours": 401.0,
          "mode_frequency": 1,
          "time_distribution": {
            "400-402h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 400.2912813888889
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 400.29,
            "mode_time_hours": 401.0,
            "mode_frequency": 1,
            "time_distribution": {
              "400-402h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 400.2912813888889
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 400.29,
              "mode_time_hours": 401.0,
              "mode_frequency": 1,
              "time_distribution": {
                "400-402h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 400.2912813888889
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1164": {
      "overall": {
        "avg_time_hours": 0.91,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-02": 1,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-03-02": 1.1137930555555555,
          "2026-04-22": 0.7046569444444444
        },
        "time_count_per_day": {
          "2026-03-02": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 0.7,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-04-22": 0.7046569444444444
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        },
        "P2": {
          "avg_time_hours": 1.11,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-02": 1
          },
          "time_per_day": {
            "2026-03-02": 1.1137930555555555
          },
          "time_count_per_day": {
            "2026-03-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.91,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-02": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-03-02": 1.1137930555555555,
              "2026-04-22": 0.7046569444444444
            },
            "time_count_per_day": {
              "2026-03-02": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 0.7,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 0.7046569444444444
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            },
            "P2": {
              "avg_time_hours": 1.11,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-02": 1
              },
              "time_per_day": {
                "2026-03-02": 1.1137930555555555
              },
              "time_count_per_day": {
                "2026-03-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_942": {
      "overall": {
        "avg_time_hours": 131.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "194-196h": 1,
          "196-198h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-02": 1,
          "2026-05-01": 2
        },
        "time_per_day": {
          "2026-03-02": 0.6251644444444445,
          "2026-05-01": 392.60974166666665
        },
        "time_count_per_day": {
          "2026-03-02": 1,
          "2026-05-01": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-02": 1
          },
          "time_per_day": {
            "2026-03-02": 0.6251644444444445
          },
          "time_count_per_day": {
            "2026-03-02": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 196.3,
          "mode_time_hours": 197.0,
          "mode_frequency": 1,
          "time_distribution": {
            "194-196h": 1,
            "196-198h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-01": 2
          },
          "time_per_day": {
            "2026-05-01": 392.60974166666665
          },
          "time_count_per_day": {
            "2026-05-01": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 131.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "194-196h": 1,
              "196-198h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-02": 1,
              "2026-05-01": 2
            },
            "time_per_day": {
              "2026-03-02": 0.6251644444444445,
              "2026-05-01": 392.60974166666665
            },
            "time_count_per_day": {
              "2026-03-02": 1,
              "2026-05-01": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-02": 1
              },
              "time_per_day": {
                "2026-03-02": 0.6251644444444445
              },
              "time_count_per_day": {
                "2026-03-02": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 196.3,
              "mode_time_hours": 197.0,
              "mode_frequency": 1,
              "time_distribution": {
                "194-196h": 1,
                "196-198h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-01": 2
              },
              "time_per_day": {
                "2026-05-01": 392.60974166666665
              },
              "time_count_per_day": {
                "2026-05-01": 2
              }
            }
          }
        }
      }
    },
    "cliente_1183": {
      "overall": {
        "avg_time_hours": 1248.08,
        "mode_time_hours": 1249.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1248-1250h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 1248.0773419444445
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1248.08,
          "mode_time_hours": 1249.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1248-1250h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 1248.0773419444445
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1248.08,
            "mode_time_hours": 1249.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1248-1250h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 1248.0773419444445
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1248.08,
              "mode_time_hours": 1249.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1248-1250h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 1248.0773419444445
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1184": {
      "overall": {
        "avg_time_hours": 1579.9,
        "mode_time_hours": 1579.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1578-1580h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-05-07": 1579.9021972222222
        },
        "time_count_per_day": {
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1579.9,
          "mode_time_hours": 1579.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1578-1580h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-05-07": 1579.9021972222222
          },
          "time_count_per_day": {
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1579.9,
            "mode_time_hours": 1579.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1578-1580h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-05-07": 1579.9021972222222
            },
            "time_count_per_day": {
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1579.9,
              "mode_time_hours": 1579.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1578-1580h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-05-07": 1579.9021972222222
              },
              "time_count_per_day": {
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1182": {
      "overall": {
        "avg_time_hours": 93.27,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "10-12h": 1,
          "18-20h": 1,
          "48-50h": 1,
          "202-204h": 1,
          "358-360h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-03-02": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-18": 1,
          "2026-03-24": 1,
          "2026-03-26": 1,
          "2026-05-12": 1
        },
        "time_per_day": {
          "2026-03-02": 11.511759999999999,
          "2026-03-10": 10.315337499999998,
          "2026-03-11": 203.73850444444446,
          "2026-03-18": 19.327701666666666,
          "2026-03-24": 359.6246044444444,
          "2026-03-26": 48.39234638888888
        },
        "time_count_per_day": {
          "2026-03-02": 2,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-18": 1,
          "2026-03-24": 1,
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 93.27,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "10-12h": 1,
            "18-20h": 1,
            "48-50h": 1,
            "202-204h": 1,
            "358-360h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-02": 2,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-18": 1,
            "2026-03-24": 1,
            "2026-03-26": 1,
            "2026-05-12": 1
          },
          "time_per_day": {
            "2026-03-02": 11.511759999999999,
            "2026-03-10": 10.315337499999998,
            "2026-03-11": 203.73850444444446,
            "2026-03-18": 19.327701666666666,
            "2026-03-24": 359.6246044444444,
            "2026-03-26": 48.39234638888888
          },
          "time_count_per_day": {
            "2026-03-02": 2,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-18": 1,
            "2026-03-24": 1,
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 93.27,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "10-12h": 1,
              "18-20h": 1,
              "48-50h": 1,
              "202-204h": 1,
              "358-360h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-02": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-18": 1,
              "2026-03-24": 1,
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-02": 11.511759999999999,
              "2026-03-10": 10.315337499999998,
              "2026-03-11": 203.73850444444446,
              "2026-03-18": 19.327701666666666,
              "2026-03-24": 359.6246044444444,
              "2026-03-26": 48.39234638888888
            },
            "time_count_per_day": {
              "2026-03-02": 2,
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-18": 1,
              "2026-03-24": 1,
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 93.27,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "10-12h": 1,
                "18-20h": 1,
                "48-50h": 1,
                "202-204h": 1,
                "358-360h": 1
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-02": 2,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-18": 1,
                "2026-03-24": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-02": 11.511759999999999,
                "2026-03-10": 10.315337499999998,
                "2026-03-11": 203.73850444444446,
                "2026-03-18": 19.327701666666666,
                "2026-03-24": 359.6246044444444,
                "2026-03-26": 48.39234638888888
              },
              "time_count_per_day": {
                "2026-03-02": 2,
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-18": 1,
                "2026-03-24": 1,
                "2026-03-26": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1185": {
      "overall": {
        "avg_time_hours": 382.34,
        "mode_time_hours": 383.0,
        "mode_frequency": 1,
        "time_distribution": {
          "382-384h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 382.3356288888889
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 382.34,
          "mode_time_hours": 383.0,
          "mode_frequency": 1,
          "time_distribution": {
            "382-384h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 382.3356288888889
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 382.34,
            "mode_time_hours": 383.0,
            "mode_frequency": 1,
            "time_distribution": {
              "382-384h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 382.3356288888889
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 382.34,
              "mode_time_hours": 383.0,
              "mode_frequency": 1,
              "time_distribution": {
                "382-384h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 382.3356288888889
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1186": {
      "overall": {
        "avg_time_hours": 0.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-02": 1,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-03-02": 0.015727222222222222,
          "2026-05-18": 0.8834266666666666
        },
        "time_count_per_day": {
          "2026-03-02": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-02": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-03-02": 0.015727222222222222,
            "2026-05-18": 0.8834266666666666
          },
          "time_count_per_day": {
            "2026-03-02": 1,
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-02": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-03-02": 0.015727222222222222,
              "2026-05-18": 0.8834266666666666
            },
            "time_count_per_day": {
              "2026-03-02": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-02": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-03-02": 0.015727222222222222,
                "2026-05-18": 0.8834266666666666
              },
              "time_count_per_day": {
                "2026-03-02": 1,
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1189": {
      "overall": {
        "avg_time_hours": 19.19,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-03": 1
        },
        "time_per_day": {
          "2026-03-03": 19.190954444444444
        },
        "time_count_per_day": {
          "2026-03-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 19.19,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {
            "2026-03-03": 19.190954444444444
          },
          "time_count_per_day": {
            "2026-03-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 19.19,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {
              "2026-03-03": 19.190954444444444
            },
            "time_count_per_day": {
              "2026-03-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 19.19,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {
                "2026-03-03": 19.190954444444444
              },
              "time_count_per_day": {
                "2026-03-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1191": {
      "overall": {
        "avg_time_hours": 0.92,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-03": 1
        },
        "time_per_day": {
          "2026-03-03": 0.9155086111111111
        },
        "time_count_per_day": {
          "2026-03-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.92,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {
            "2026-03-03": 0.9155086111111111
          },
          "time_count_per_day": {
            "2026-03-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.92,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {
              "2026-03-03": 0.9155086111111111
            },
            "time_count_per_day": {
              "2026-03-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.92,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {
                "2026-03-03": 0.9155086111111111
              },
              "time_count_per_day": {
                "2026-03-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1192": {
      "overall": {
        "avg_time_hours": 359.09,
        "mode_time_hours": 359.0,
        "mode_frequency": 1,
        "time_distribution": {
          "358-360h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 359.0905586111111
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 359.09,
          "mode_time_hours": 359.0,
          "mode_frequency": 1,
          "time_distribution": {
            "358-360h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 359.0905586111111
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 359.09,
            "mode_time_hours": 359.0,
            "mode_frequency": 1,
            "time_distribution": {
              "358-360h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 359.0905586111111
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 359.09,
              "mode_time_hours": 359.0,
              "mode_frequency": 1,
              "time_distribution": {
                "358-360h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 359.0905586111111
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1193": {
      "overall": {
        "avg_time_hours": 358.38,
        "mode_time_hours": 359.0,
        "mode_frequency": 2,
        "time_distribution": {
          "358-360h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-03-18": 716.7663947222222
        },
        "time_count_per_day": {
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 358.38,
          "mode_time_hours": 359.0,
          "mode_frequency": 2,
          "time_distribution": {
            "358-360h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 716.7663947222222
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 358.38,
            "mode_time_hours": 359.0,
            "mode_frequency": 2,
            "time_distribution": {
              "358-360h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-03-18": 716.7663947222222
            },
            "time_count_per_day": {
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 358.38,
              "mode_time_hours": 359.0,
              "mode_frequency": 2,
              "time_distribution": {
                "358-360h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 716.7663947222222
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_723": {
      "overall": {
        "avg_time_hours": 388.8,
        "mode_time_hours": 453.0,
        "mode_frequency": 4,
        "time_distribution": {
          "122-124h": 1,
          "310-312h": 1,
          "356-358h": 1,
          "452-454h": 4,
          "504-506h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2026-03-11": 3,
          "2026-03-18": 2,
          "2026-03-26": 1,
          "2026-03-30": 4,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-03-18": 667.6997116666666,
          "2026-03-26": 505.6485813888889,
          "2026-03-30": 1814.146023611111,
          "2026-04-22": 122.90892833333334
        },
        "time_count_per_day": {
          "2026-03-18": 2,
          "2026-03-26": 1,
          "2026-03-30": 4,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 388.8,
          "mode_time_hours": 453.0,
          "mode_frequency": 4,
          "time_distribution": {
            "122-124h": 1,
            "310-312h": 1,
            "356-358h": 1,
            "452-454h": 4,
            "504-506h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-03-11": 3,
            "2026-03-18": 2,
            "2026-03-26": 1,
            "2026-03-30": 4,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-03-18": 667.6997116666666,
            "2026-03-26": 505.6485813888889,
            "2026-03-30": 1814.146023611111,
            "2026-04-22": 122.90892833333334
          },
          "time_count_per_day": {
            "2026-03-18": 2,
            "2026-03-26": 1,
            "2026-03-30": 4,
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 388.8,
            "mode_time_hours": 453.0,
            "mode_frequency": 4,
            "time_distribution": {
              "122-124h": 1,
              "310-312h": 1,
              "356-358h": 1,
              "452-454h": 4,
              "504-506h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-03-18": 2,
              "2026-03-26": 1,
              "2026-03-30": 4,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-03-18": 667.6997116666666,
              "2026-03-26": 505.6485813888889,
              "2026-03-30": 1814.146023611111,
              "2026-04-22": 122.90892833333334
            },
            "time_count_per_day": {
              "2026-03-18": 2,
              "2026-03-26": 1,
              "2026-03-30": 4,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 388.8,
              "mode_time_hours": 453.0,
              "mode_frequency": 4,
              "time_distribution": {
                "122-124h": 1,
                "310-312h": 1,
                "356-358h": 1,
                "452-454h": 4,
                "504-506h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-03-18": 2,
                "2026-03-26": 1,
                "2026-03-30": 4,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-03-18": 667.6997116666666,
                "2026-03-26": 505.6485813888889,
                "2026-03-30": 1814.146023611111,
                "2026-04-22": 122.90892833333334
              },
              "time_count_per_day": {
                "2026-03-18": 2,
                "2026-03-26": 1,
                "2026-03-30": 4,
                "2026-04-22": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-11": 3
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-11": 3
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1194": {
      "overall": {
        "avg_time_hours": 4.61,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "8-10h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-03": 1,
          "2026-05-12": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-03-03": 9.06158111111111,
          "2026-05-12": 0.15766444444444444
        },
        "time_count_per_day": {
          "2026-03-03": 1,
          "2026-05-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.61,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "8-10h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-05-12": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-03-03": 9.06158111111111,
            "2026-05-12": 0.15766444444444444
          },
          "time_count_per_day": {
            "2026-03-03": 1,
            "2026-05-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.61,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "8-10h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-03": 1,
              "2026-05-12": 1
            },
            "time_per_day": {
              "2026-03-03": 9.06158111111111,
              "2026-05-12": 0.15766444444444444
            },
            "time_count_per_day": {
              "2026-03-03": 1,
              "2026-05-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.61,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "8-10h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-03": 1,
                "2026-05-12": 1
              },
              "time_per_day": {
                "2026-03-03": 9.06158111111111,
                "2026-05-12": 0.15766444444444444
              },
              "time_count_per_day": {
                "2026-03-03": 1,
                "2026-05-12": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1196": {
      "overall": {
        "avg_time_hours": 16.76,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-04": 1
        },
        "time_per_day": {
          "2026-03-04": 16.76181083333333
        },
        "time_count_per_day": {
          "2026-03-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.76,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-04": 1
          },
          "time_per_day": {
            "2026-03-04": 16.76181083333333
          },
          "time_count_per_day": {
            "2026-03-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.76,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-04": 1
            },
            "time_per_day": {
              "2026-03-04": 16.76181083333333
            },
            "time_count_per_day": {
              "2026-03-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.76,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-04": 1
              },
              "time_per_day": {
                "2026-03-04": 16.76181083333333
              },
              "time_count_per_day": {
                "2026-03-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1197": {
      "overall": {
        "avg_time_hours": 350.19,
        "mode_time_hours": 351.0,
        "mode_frequency": 2,
        "time_distribution": {
          "350-352h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-03-18": 700.3749086111111
        },
        "time_count_per_day": {
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 350.19,
          "mode_time_hours": 351.0,
          "mode_frequency": 2,
          "time_distribution": {
            "350-352h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 700.3749086111111
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 350.19,
            "mode_time_hours": 351.0,
            "mode_frequency": 2,
            "time_distribution": {
              "350-352h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-03-18": 700.3749086111111
            },
            "time_count_per_day": {
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 350.19,
              "mode_time_hours": 351.0,
              "mode_frequency": 2,
              "time_distribution": {
                "350-352h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 700.3749086111111
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_1199": {
      "overall": {
        "avg_time_hours": 0.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-03": 1
        },
        "time_per_day": {
          "2026-03-03": 0.29760194444444443
        },
        "time_count_per_day": {
          "2026-03-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {
            "2026-03-03": 0.29760194444444443
          },
          "time_count_per_day": {
            "2026-03-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {
              "2026-03-03": 0.29760194444444443
            },
            "time_count_per_day": {
              "2026-03-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {
                "2026-03-03": 0.29760194444444443
              },
              "time_count_per_day": {
                "2026-03-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1200": {
      "overall": {
        "avg_time_hours": 136.8,
        "mode_time_hours": 819.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "6-8h": 1,
          "24-26h": 1,
          "28-30h": 1,
          "30-32h": 1,
          "46-48h": 1,
          "818-820h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-04-07": 1,
          "2026-04-28": 1,
          "2026-05-13": 1,
          "2026-05-19": 1,
          "2026-05-21": 2,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-04-07": 818.0298172222223,
          "2026-04-28": 6.091823333333333,
          "2026-05-13": 1.4888297222222222,
          "2026-05-19": 30.224573333333336,
          "2026-05-21": 72.31961749999999,
          "2026-05-26": 29.436006944444443
        },
        "time_count_per_day": {
          "2026-04-07": 1,
          "2026-04-28": 1,
          "2026-05-13": 1,
          "2026-05-19": 1,
          "2026-05-21": 2,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 27.03,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "46-48h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-28": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-04-28": 6.091823333333333,
            "2026-05-21": 47.964800277777776
          },
          "time_count_per_day": {
            "2026-04-28": 1,
            "2026-05-21": 1
          }
        },
        "P2": {
          "avg_time_hours": 180.71,
          "mode_time_hours": 819.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "24-26h": 1,
            "28-30h": 1,
            "30-32h": 1,
            "818-820h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-04-07": 1,
            "2026-05-13": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-04-07": 818.0298172222223,
            "2026-05-13": 1.4888297222222222,
            "2026-05-19": 30.224573333333336,
            "2026-05-21": 24.354817222222223,
            "2026-05-26": 29.436006944444443
          },
          "time_count_per_day": {
            "2026-04-07": 1,
            "2026-05-13": 1,
            "2026-05-19": 1,
            "2026-05-21": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 136.8,
            "mode_time_hours": 819.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "6-8h": 1,
              "24-26h": 1,
              "28-30h": 1,
              "30-32h": 1,
              "46-48h": 1,
              "818-820h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-04-28": 1,
              "2026-05-13": 1,
              "2026-05-19": 1,
              "2026-05-21": 2,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-04-07": 818.0298172222223,
              "2026-04-28": 6.091823333333333,
              "2026-05-13": 1.4888297222222222,
              "2026-05-19": 30.224573333333336,
              "2026-05-21": 72.31961749999999,
              "2026-05-26": 29.436006944444443
            },
            "time_count_per_day": {
              "2026-04-07": 1,
              "2026-04-28": 1,
              "2026-05-13": 1,
              "2026-05-19": 1,
              "2026-05-21": 2,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 27.03,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "46-48h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-28": 1,
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-04-28": 6.091823333333333,
                "2026-05-21": 47.964800277777776
              },
              "time_count_per_day": {
                "2026-04-28": 1,
                "2026-05-21": 1
              }
            },
            "P2": {
              "avg_time_hours": 180.71,
              "mode_time_hours": 819.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "24-26h": 1,
                "28-30h": 1,
                "30-32h": 1,
                "818-820h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-05-13": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-04-07": 818.0298172222223,
                "2026-05-13": 1.4888297222222222,
                "2026-05-19": 30.224573333333336,
                "2026-05-21": 24.354817222222223,
                "2026-05-26": 29.436006944444443
              },
              "time_count_per_day": {
                "2026-04-07": 1,
                "2026-05-13": 1,
                "2026-05-19": 1,
                "2026-05-21": 1,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1202": {
      "overall": {
        "avg_time_hours": 188.69,
        "mode_time_hours": 389.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1,
          "148-150h": 1,
          "388-390h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-20": 1,
          "2026-03-31": 2
        },
        "time_per_day": {
          "2026-03-20": 388.3980280555556,
          "2026-03-31": 177.67454833333335
        },
        "time_count_per_day": {
          "2026-03-20": 1,
          "2026-03-31": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 188.69,
          "mode_time_hours": 389.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1,
            "148-150h": 1,
            "388-390h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-03-31": 2
          },
          "time_per_day": {
            "2026-03-20": 388.3980280555556,
            "2026-03-31": 177.67454833333335
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-03-31": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 188.69,
            "mode_time_hours": 389.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1,
              "148-150h": 1,
              "388-390h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-20": 1,
              "2026-03-31": 2
            },
            "time_per_day": {
              "2026-03-20": 388.3980280555556,
              "2026-03-31": 177.67454833333335
            },
            "time_count_per_day": {
              "2026-03-20": 1,
              "2026-03-31": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 188.69,
              "mode_time_hours": 389.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1,
                "148-150h": 1,
                "388-390h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-03-31": 2
              },
              "time_per_day": {
                "2026-03-20": 388.3980280555556,
                "2026-03-31": 177.67454833333335
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-03-31": 2
              }
            }
          }
        }
      }
    },
    "cliente_1198": {
      "overall": {
        "avg_time_hours": 221.76,
        "mode_time_hours": 319.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "46-48h": 1,
          "318-320h": 1,
          "514-516h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-03": 1,
          "2026-03-04": 1,
          "2026-03-17": 1,
          "2026-03-25": 1,
          "2026-03-26": 1
        },
        "time_per_day": {
          "2026-03-04": 8.478042222222223,
          "2026-03-17": 318.1743822222222,
          "2026-03-25": 46.367597499999995,
          "2026-03-26": 514.0286280555556
        },
        "time_count_per_day": {
          "2026-03-04": 1,
          "2026-03-17": 1,
          "2026-03-25": 1,
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 46.37,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-25": 46.367597499999995
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        },
        "P2": {
          "avg_time_hours": 261.25,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "514-516h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-03": 1,
            "2026-03-04": 1,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-04": 8.478042222222223,
            "2026-03-26": 514.0286280555556
          },
          "time_count_per_day": {
            "2026-03-04": 1,
            "2026-03-26": 1
          }
        },
        "P3": {
          "avg_time_hours": 318.17,
          "mode_time_hours": 319.0,
          "mode_frequency": 1,
          "time_distribution": {
            "318-320h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 318.1743822222222
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 221.76,
            "mode_time_hours": 319.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "46-48h": 1,
              "318-320h": 1,
              "514-516h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-04": 1,
              "2026-03-17": 1,
              "2026-03-25": 1,
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-04": 8.478042222222223,
              "2026-03-17": 318.1743822222222,
              "2026-03-25": 46.367597499999995,
              "2026-03-26": 514.0286280555556
            },
            "time_count_per_day": {
              "2026-03-04": 1,
              "2026-03-17": 1,
              "2026-03-25": 1,
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 46.37,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 46.367597499999995
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            },
            "P2": {
              "avg_time_hours": 261.25,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "514-516h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-04": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-04": 8.478042222222223,
                "2026-03-26": 514.0286280555556
              },
              "time_count_per_day": {
                "2026-03-04": 1,
                "2026-03-26": 1
              }
            },
            "P3": {
              "avg_time_hours": 318.17,
              "mode_time_hours": 319.0,
              "mode_frequency": 1,
              "time_distribution": {
                "318-320h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 318.1743822222222
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1208": {
      "overall": {
        "avg_time_hours": 324.24,
        "mode_time_hours": 325.0,
        "mode_frequency": 1,
        "time_distribution": {
          "324-326h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 324.2376083333333
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 324.24,
          "mode_time_hours": 325.0,
          "mode_frequency": 1,
          "time_distribution": {
            "324-326h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 324.2376083333333
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 324.24,
            "mode_time_hours": 325.0,
            "mode_frequency": 1,
            "time_distribution": {
              "324-326h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 324.2376083333333
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 324.24,
              "mode_time_hours": 325.0,
              "mode_frequency": 1,
              "time_distribution": {
                "324-326h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 324.2376083333333
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1209": {
      "overall": {
        "avg_time_hours": 22.57,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "36-38h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-05": 1,
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-05": 7.64246361111111,
          "2026-03-17": 37.49942083333334
        },
        "time_count_per_day": {
          "2026-03-05": 1,
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.64,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-03-05": 7.64246361111111
          },
          "time_count_per_day": {
            "2026-03-05": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 37.5,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 37.49942083333334
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 22.57,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "36-38h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-05": 1,
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-05": 7.64246361111111,
              "2026-03-17": 37.49942083333334
            },
            "time_count_per_day": {
              "2026-03-05": 1,
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.64,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-03-05": 7.64246361111111
              },
              "time_count_per_day": {
                "2026-03-05": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 37.5,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 37.49942083333334
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1211": {
      "overall": {
        "avg_time_hours": 1.51,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-03-05": 1.5143297222222223
        },
        "time_count_per_day": {
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-03-05": 1.5143297222222223
          },
          "time_count_per_day": {
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.51,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-03-05": 1.5143297222222223
            },
            "time_count_per_day": {
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-03-05": 1.5143297222222223
              },
              "time_count_per_day": {
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1212": {
      "overall": {
        "avg_time_hours": 0.23,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-03-05": 0.22576583333333333
        },
        "time_count_per_day": {
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.23,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-03-05": 0.22576583333333333
          },
          "time_count_per_day": {
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.23,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-03-05": 0.22576583333333333
            },
            "time_count_per_day": {
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.23,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-03-05": 0.22576583333333333
              },
              "time_count_per_day": {
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1213": {
      "overall": {
        "avg_time_hours": 304.04,
        "mode_time_hours": 305.0,
        "mode_frequency": 1,
        "time_distribution": {
          "304-306h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 304.0393513888889
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 304.04,
          "mode_time_hours": 305.0,
          "mode_frequency": 1,
          "time_distribution": {
            "304-306h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 304.0393513888889
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 304.04,
            "mode_time_hours": 305.0,
            "mode_frequency": 1,
            "time_distribution": {
              "304-306h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 304.0393513888889
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 304.04,
              "mode_time_hours": 305.0,
              "mode_frequency": 1,
              "time_distribution": {
                "304-306h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 304.0393513888889
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1214": {
      "overall": {
        "avg_time_hours": 0.2,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-05": 3
        },
        "time_per_day": {
          "2026-03-05": 0.6034194444444445
        },
        "time_count_per_day": {
          "2026-03-05": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.2,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-05": 3
          },
          "time_per_day": {
            "2026-03-05": 0.6034194444444445
          },
          "time_count_per_day": {
            "2026-03-05": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.2,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-05": 3
            },
            "time_per_day": {
              "2026-03-05": 0.6034194444444445
            },
            "time_count_per_day": {
              "2026-03-05": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.2,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-05": 3
              },
              "time_per_day": {
                "2026-03-05": 0.6034194444444445
              },
              "time_count_per_day": {
                "2026-03-05": 3
              }
            }
          }
        }
      }
    },
    "cliente_1216": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-05": 1
        },
        "time_per_day": {
          "2026-03-05": 0.010264444444444444
        },
        "time_count_per_day": {
          "2026-03-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-05": 1
          },
          "time_per_day": {
            "2026-03-05": 0.010264444444444444
          },
          "time_count_per_day": {
            "2026-03-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-05": 1
            },
            "time_per_day": {
              "2026-03-05": 0.010264444444444444
            },
            "time_count_per_day": {
              "2026-03-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-05": 1
              },
              "time_per_day": {
                "2026-03-05": 0.010264444444444444
              },
              "time_count_per_day": {
                "2026-03-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1217": {
      "overall": {
        "avg_time_hours": 286.04,
        "mode_time_hours": 287.0,
        "mode_frequency": 1,
        "time_distribution": {
          "284-286h": 1,
          "286-288h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-03-18": 572.0729611111111
        },
        "time_count_per_day": {
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 286.04,
          "mode_time_hours": 287.0,
          "mode_frequency": 1,
          "time_distribution": {
            "284-286h": 1,
            "286-288h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 572.0729611111111
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 286.04,
            "mode_time_hours": 287.0,
            "mode_frequency": 1,
            "time_distribution": {
              "284-286h": 1,
              "286-288h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-03-18": 572.0729611111111
            },
            "time_count_per_day": {
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 286.04,
              "mode_time_hours": 287.0,
              "mode_frequency": 1,
              "time_distribution": {
                "284-286h": 1,
                "286-288h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 572.0729611111111
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_1218": {
      "overall": {
        "avg_time_hours": 75.0,
        "mode_time_hours": 75.0,
        "mode_frequency": 1,
        "time_distribution": {
          "74-76h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 75.00128027777778
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 75.0,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 75.00128027777778
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 75.0,
            "mode_time_hours": 75.0,
            "mode_frequency": 1,
            "time_distribution": {
              "74-76h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 75.00128027777778
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 75.0,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 75.00128027777778
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1087": {
      "overall": {
        "avg_time_hours": 1.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-06": 1
        },
        "time_per_day": {
          "2026-03-06": 1.5234205555555556
        },
        "time_count_per_day": {
          "2026-03-06": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-06": 1
          },
          "time_per_day": {
            "2026-03-06": 1.5234205555555556
          },
          "time_count_per_day": {
            "2026-03-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-06": 1
            },
            "time_per_day": {
              "2026-03-06": 1.5234205555555556
            },
            "time_count_per_day": {
              "2026-03-06": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-06": 1
              },
              "time_per_day": {
                "2026-03-06": 1.5234205555555556
              },
              "time_count_per_day": {
                "2026-03-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1221": {
      "overall": {
        "avg_time_hours": 412.09,
        "mode_time_hours": 335.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "334-336h": 1,
          "1310-1312h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-20": 1,
          "2026-05-04": 1,
          "2026-05-18": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-03-20": 334.68092861111114,
          "2026-05-04": 1310.6825505555555,
          "2026-05-18": 2.613858333333333,
          "2026-06-02": 0.39008666666666664
        },
        "time_count_per_day": {
          "2026-03-20": 1,
          "2026-05-04": 1,
          "2026-05-18": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1310.68,
          "mode_time_hours": 1311.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1310-1312h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 1310.6825505555555
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        },
        "P2": {
          "avg_time_hours": 112.56,
          "mode_time_hours": 335.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "334-336h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-05-18": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-03-20": 334.68092861111114,
            "2026-05-18": 2.613858333333333,
            "2026-06-02": 0.39008666666666664
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-05-18": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 412.09,
            "mode_time_hours": 335.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "334-336h": 1,
              "1310-1312h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-20": 1,
              "2026-05-04": 1,
              "2026-05-18": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-03-20": 334.68092861111114,
              "2026-05-04": 1310.6825505555555,
              "2026-05-18": 2.613858333333333,
              "2026-06-02": 0.39008666666666664
            },
            "time_count_per_day": {
              "2026-03-20": 1,
              "2026-05-04": 1,
              "2026-05-18": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1310.68,
              "mode_time_hours": 1311.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1310-1312h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 1310.6825505555555
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            },
            "P2": {
              "avg_time_hours": 112.56,
              "mode_time_hours": 335.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "334-336h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-05-18": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-03-20": 334.68092861111114,
                "2026-05-18": 2.613858333333333,
                "2026-06-02": 0.39008666666666664
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-05-18": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1222": {
      "overall": {
        "avg_time_hours": 373.26,
        "mode_time_hours": 747.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "746-748h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-07": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-04-07": 746.4993405555556,
          "2026-05-29": 0.01690388888888889
        },
        "time_count_per_day": {
          "2026-04-07": 1,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 373.26,
          "mode_time_hours": 747.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "746-748h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-07": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-04-07": 746.4993405555556,
            "2026-05-29": 0.01690388888888889
          },
          "time_count_per_day": {
            "2026-04-07": 1,
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 373.26,
            "mode_time_hours": 747.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "746-748h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-04-07": 746.4993405555556,
              "2026-05-29": 0.01690388888888889
            },
            "time_count_per_day": {
              "2026-04-07": 1,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 373.26,
              "mode_time_hours": 747.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "746-748h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-04-07": 746.4993405555556,
                "2026-05-29": 0.01690388888888889
              },
              "time_count_per_day": {
                "2026-04-07": 1,
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1226": {
      "overall": {
        "avg_time_hours": 259.47,
        "mode_time_hours": 259.0,
        "mode_frequency": 1,
        "time_distribution": {
          "258-260h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 259.466885
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 259.47,
          "mode_time_hours": 259.0,
          "mode_frequency": 1,
          "time_distribution": {
            "258-260h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 259.466885
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 259.47,
            "mode_time_hours": 259.0,
            "mode_frequency": 1,
            "time_distribution": {
              "258-260h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 259.466885
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 259.47,
              "mode_time_hours": 259.0,
              "mode_frequency": 1,
              "time_distribution": {
                "258-260h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 259.466885
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1227": {
      "overall": {
        "avg_time_hours": 116.47,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1,
          "20-22h": 1,
          "22-24h": 1,
          "50-52h": 1,
          "468-470h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-09": 1,
          "2026-03-13": 1,
          "2026-03-14": 1,
          "2026-03-31": 1,
          "2026-04-09": 1
        },
        "time_per_day": {
          "2026-03-09": 51.820793055555555,
          "2026-03-13": 21.87806611111111,
          "2026-03-14": 15.701375833333334,
          "2026-03-31": 23.36182916666667,
          "2026-04-09": 469.5782858333333
        },
        "time_count_per_day": {
          "2026-03-09": 1,
          "2026-03-13": 1,
          "2026-03-14": 1,
          "2026-03-31": 1,
          "2026-04-09": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 469.58,
          "mode_time_hours": 469.0,
          "mode_frequency": 1,
          "time_distribution": {
            "468-470h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-09": 1
          },
          "time_per_day": {
            "2026-04-09": 469.5782858333333
          },
          "time_count_per_day": {
            "2026-04-09": 1
          }
        },
        "P2": {
          "avg_time_hours": 28.19,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "20-22h": 1,
            "22-24h": 1,
            "50-52h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-14": 1,
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-03-09": 51.820793055555555,
            "2026-03-13": 21.87806611111111,
            "2026-03-14": 15.701375833333334,
            "2026-03-31": 23.36182916666667
          },
          "time_count_per_day": {
            "2026-03-09": 1,
            "2026-03-13": 1,
            "2026-03-14": 1,
            "2026-03-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 116.47,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1,
              "20-22h": 1,
              "22-24h": 1,
              "50-52h": 1,
              "468-470h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-09": 1,
              "2026-03-13": 1,
              "2026-03-14": 1,
              "2026-03-31": 1,
              "2026-04-09": 1
            },
            "time_per_day": {
              "2026-03-09": 51.820793055555555,
              "2026-03-13": 21.87806611111111,
              "2026-03-14": 15.701375833333334,
              "2026-03-31": 23.36182916666667,
              "2026-04-09": 469.5782858333333
            },
            "time_count_per_day": {
              "2026-03-09": 1,
              "2026-03-13": 1,
              "2026-03-14": 1,
              "2026-03-31": 1,
              "2026-04-09": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 469.58,
              "mode_time_hours": 469.0,
              "mode_frequency": 1,
              "time_distribution": {
                "468-470h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-09": 1
              },
              "time_per_day": {
                "2026-04-09": 469.5782858333333
              },
              "time_count_per_day": {
                "2026-04-09": 1
              }
            },
            "P2": {
              "avg_time_hours": 28.19,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "20-22h": 1,
                "22-24h": 1,
                "50-52h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-14": 1,
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-03-09": 51.820793055555555,
                "2026-03-13": 21.87806611111111,
                "2026-03-14": 15.701375833333334,
                "2026-03-31": 23.36182916666667
              },
              "time_count_per_day": {
                "2026-03-09": 1,
                "2026-03-13": 1,
                "2026-03-14": 1,
                "2026-03-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_1229": {
      "overall": {
        "avg_time_hours": 15.79,
        "mode_time_hours": 7.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "6-8h": 2,
          "10-12h": 1,
          "14-16h": 1,
          "30-32h": 1,
          "50-52h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-23": 1,
          "2026-04-07": 1,
          "2026-04-24": 1,
          "2026-04-28": 1,
          "2026-05-04": 2
        },
        "time_per_day": {
          "2026-03-10": 51.7410075,
          "2026-03-11": 6.055723055555555,
          "2026-03-23": 10.483672499999999,
          "2026-04-07": 15.660643333333333,
          "2026-04-24": 31.617850833333335,
          "2026-04-28": 6.8321925,
          "2026-05-04": 3.9352422222222225
        },
        "time_count_per_day": {
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-23": 1,
          "2026-04-07": 1,
          "2026-04-24": 1,
          "2026-04-28": 1,
          "2026-05-04": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 15.79,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "6-8h": 2,
            "10-12h": 1,
            "14-16h": 1,
            "30-32h": 1,
            "50-52h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-23": 1,
            "2026-04-07": 1,
            "2026-04-24": 1,
            "2026-04-28": 1,
            "2026-05-04": 2
          },
          "time_per_day": {
            "2026-03-10": 51.7410075,
            "2026-03-11": 6.055723055555555,
            "2026-03-23": 10.483672499999999,
            "2026-04-07": 15.660643333333333,
            "2026-04-24": 31.617850833333335,
            "2026-04-28": 6.8321925,
            "2026-05-04": 3.9352422222222225
          },
          "time_count_per_day": {
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-23": 1,
            "2026-04-07": 1,
            "2026-04-24": 1,
            "2026-04-28": 1,
            "2026-05-04": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.79,
            "mode_time_hours": 7.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "6-8h": 2,
              "10-12h": 1,
              "14-16h": 1,
              "30-32h": 1,
              "50-52h": 1
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-23": 1,
              "2026-04-07": 1,
              "2026-04-24": 1,
              "2026-04-28": 1,
              "2026-05-04": 2
            },
            "time_per_day": {
              "2026-03-10": 51.7410075,
              "2026-03-11": 6.055723055555555,
              "2026-03-23": 10.483672499999999,
              "2026-04-07": 15.660643333333333,
              "2026-04-24": 31.617850833333335,
              "2026-04-28": 6.8321925,
              "2026-05-04": 3.9352422222222225
            },
            "time_count_per_day": {
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-03-23": 1,
              "2026-04-07": 1,
              "2026-04-24": 1,
              "2026-04-28": 1,
              "2026-05-04": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 15.79,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "6-8h": 2,
                "10-12h": 1,
                "14-16h": 1,
                "30-32h": 1,
                "50-52h": 1
              },
              "tickets_count": 8,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-23": 1,
                "2026-04-07": 1,
                "2026-04-24": 1,
                "2026-04-28": 1,
                "2026-05-04": 2
              },
              "time_per_day": {
                "2026-03-10": 51.7410075,
                "2026-03-11": 6.055723055555555,
                "2026-03-23": 10.483672499999999,
                "2026-04-07": 15.660643333333333,
                "2026-04-24": 31.617850833333335,
                "2026-04-28": 6.8321925,
                "2026-05-04": 3.9352422222222225
              },
              "time_count_per_day": {
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-03-23": 1,
                "2026-04-07": 1,
                "2026-04-24": 1,
                "2026-04-28": 1,
                "2026-05-04": 2
              }
            }
          }
        }
      }
    },
    "cliente_1231": {
      "overall": {
        "avg_time_hours": 216.84,
        "mode_time_hours": 217.0,
        "mode_frequency": 1,
        "time_distribution": {
          "216-218h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 216.83537777777778
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 216.84,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "216-218h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 216.83537777777778
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 216.84,
            "mode_time_hours": 217.0,
            "mode_frequency": 1,
            "time_distribution": {
              "216-218h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 216.83537777777778
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 216.84,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "216-218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 216.83537777777778
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1232": {
      "overall": {
        "avg_time_hours": 216.82,
        "mode_time_hours": 217.0,
        "mode_frequency": 1,
        "time_distribution": {
          "216-218h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 216.81643611111113
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 216.82,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "216-218h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 216.81643611111113
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 216.82,
            "mode_time_hours": 217.0,
            "mode_frequency": 1,
            "time_distribution": {
              "216-218h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 216.81643611111113
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 216.82,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "216-218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 216.81643611111113
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1233": {
      "overall": {
        "avg_time_hours": 216.79,
        "mode_time_hours": 217.0,
        "mode_frequency": 1,
        "time_distribution": {
          "216-218h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 216.7865322222222
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 216.79,
          "mode_time_hours": 217.0,
          "mode_frequency": 1,
          "time_distribution": {
            "216-218h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 216.7865322222222
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 216.79,
            "mode_time_hours": 217.0,
            "mode_frequency": 1,
            "time_distribution": {
              "216-218h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 216.7865322222222
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 216.79,
              "mode_time_hours": 217.0,
              "mode_frequency": 1,
              "time_distribution": {
                "216-218h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 216.7865322222222
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1234": {
      "overall": {
        "avg_time_hours": 8.0,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 8.000280833333333
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.0,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 8.000280833333333
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.0,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 8.000280833333333
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.0,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 8.000280833333333
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1201": {
      "overall": {
        "avg_time_hours": 7.8,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 7.801148055555556
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.8,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 7.801148055555556
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 7.8,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 7.801148055555556
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.8,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 7.801148055555556
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1238": {
      "overall": {
        "avg_time_hours": 211.29,
        "mode_time_hours": 211.0,
        "mode_frequency": 1,
        "time_distribution": {
          "210-212h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 211.28805194444445
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 211.29,
          "mode_time_hours": 211.0,
          "mode_frequency": 1,
          "time_distribution": {
            "210-212h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 211.28805194444445
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 211.29,
            "mode_time_hours": 211.0,
            "mode_frequency": 1,
            "time_distribution": {
              "210-212h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 211.28805194444445
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 211.29,
              "mode_time_hours": 211.0,
              "mode_frequency": 1,
              "time_distribution": {
                "210-212h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 211.28805194444445
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_475": {
      "overall": {
        "avg_time_hours": 0.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {
          "2026-03-09": 0.03464083333333333
        },
        "time_count_per_day": {
          "2026-03-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {
            "2026-03-09": 0.03464083333333333
          },
          "time_count_per_day": {
            "2026-03-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {
              "2026-03-09": 0.03464083333333333
            },
            "time_count_per_day": {
              "2026-03-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {
                "2026-03-09": 0.03464083333333333
              },
              "time_count_per_day": {
                "2026-03-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1239": {
      "overall": {
        "avg_time_hours": 207.83,
        "mode_time_hours": 207.0,
        "mode_frequency": 1,
        "time_distribution": {
          "206-208h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-18": 1,
          "2026-04-24": 1
        },
        "time_per_day": {
          "2026-03-18": 207.82547499999998
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 207.83,
          "mode_time_hours": 207.0,
          "mode_frequency": 1,
          "time_distribution": {
            "206-208h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-18": 1,
            "2026-04-24": 1
          },
          "time_per_day": {
            "2026-03-18": 207.82547499999998
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 207.83,
            "mode_time_hours": 207.0,
            "mode_frequency": 1,
            "time_distribution": {
              "206-208h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 207.82547499999998
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 207.83,
              "mode_time_hours": 207.0,
              "mode_frequency": 1,
              "time_distribution": {
                "206-208h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 207.82547499999998
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-04-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-04-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1240": {
      "overall": {
        "avg_time_hours": 25.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "74-76h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-09": 1,
          "2026-03-14": 1,
          "2026-05-12": 1
        },
        "time_per_day": {
          "2026-03-09": 0.024389444444444446,
          "2026-03-14": 74.42715916666667,
          "2026-05-12": 0.7839652777777778
        },
        "time_count_per_day": {
          "2026-03-09": 1,
          "2026-03-14": 1,
          "2026-05-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.4,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-09": 1,
            "2026-05-12": 1
          },
          "time_per_day": {
            "2026-03-09": 0.024389444444444446,
            "2026-05-12": 0.7839652777777778
          },
          "time_count_per_day": {
            "2026-03-09": 1,
            "2026-05-12": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 74.43,
          "mode_time_hours": 75.0,
          "mode_frequency": 1,
          "time_distribution": {
            "74-76h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-14": 1
          },
          "time_per_day": {
            "2026-03-14": 74.42715916666667
          },
          "time_count_per_day": {
            "2026-03-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 25.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "74-76h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-09": 1,
              "2026-03-14": 1,
              "2026-05-12": 1
            },
            "time_per_day": {
              "2026-03-09": 0.024389444444444446,
              "2026-03-14": 74.42715916666667,
              "2026-05-12": 0.7839652777777778
            },
            "time_count_per_day": {
              "2026-03-09": 1,
              "2026-03-14": 1,
              "2026-05-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.4,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-09": 1,
                "2026-05-12": 1
              },
              "time_per_day": {
                "2026-03-09": 0.024389444444444446,
                "2026-05-12": 0.7839652777777778
              },
              "time_count_per_day": {
                "2026-03-09": 1,
                "2026-05-12": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 74.43,
              "mode_time_hours": 75.0,
              "mode_frequency": 1,
              "time_distribution": {
                "74-76h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-14": 1
              },
              "time_per_day": {
                "2026-03-14": 74.42715916666667
              },
              "time_count_per_day": {
                "2026-03-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_927": {
      "overall": {
        "avg_time_hours": 247.29,
        "mode_time_hours": 247.0,
        "mode_frequency": 1,
        "time_distribution": {
          "246-248h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-20": 247.29085333333336
        },
        "time_count_per_day": {
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 247.29,
          "mode_time_hours": 247.0,
          "mode_frequency": 1,
          "time_distribution": {
            "246-248h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 247.29085333333336
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 247.29,
            "mode_time_hours": 247.0,
            "mode_frequency": 1,
            "time_distribution": {
              "246-248h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-20": 247.29085333333336
            },
            "time_count_per_day": {
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 247.29,
              "mode_time_hours": 247.0,
              "mode_frequency": 1,
              "time_distribution": {
                "246-248h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 247.29085333333336
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1244": {
      "overall": {
        "avg_time_hours": 3.04,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-10": 1
        },
        "time_per_day": {
          "2026-03-10": 3.036150277777778
        },
        "time_count_per_day": {
          "2026-03-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.04,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-10": 1
          },
          "time_per_day": {
            "2026-03-10": 3.036150277777778
          },
          "time_count_per_day": {
            "2026-03-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.04,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-10": 1
            },
            "time_per_day": {
              "2026-03-10": 3.036150277777778
            },
            "time_count_per_day": {
              "2026-03-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.04,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-10": 1
              },
              "time_per_day": {
                "2026-03-10": 3.036150277777778
              },
              "time_count_per_day": {
                "2026-03-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1247": {
      "overall": {
        "avg_time_hours": 1.93,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-10": 1
        },
        "time_per_day": {
          "2026-03-10": 1.925451111111111
        },
        "time_count_per_day": {
          "2026-03-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-10": 1
          },
          "time_per_day": {
            "2026-03-10": 1.925451111111111
          },
          "time_count_per_day": {
            "2026-03-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.93,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-10": 1
            },
            "time_per_day": {
              "2026-03-10": 1.925451111111111
            },
            "time_count_per_day": {
              "2026-03-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-10": 1
              },
              "time_per_day": {
                "2026-03-10": 1.925451111111111
              },
              "time_count_per_day": {
                "2026-03-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1248": {
      "overall": {
        "avg_time_hours": 223.06,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "4-6h": 1,
          "54-56h": 1,
          "76-78h": 1,
          "142-144h": 1,
          "292-294h": 1,
          "432-434h": 1,
          "452-454h": 1,
          "766-768h": 1
        },
        "tickets_count": 11,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-24": 1,
          "2026-04-17": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-05-02": 4,
          "2026-05-06": 1,
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-03-10": 3.794102777777778,
          "2026-03-24": 0.6177911111111111,
          "2026-04-17": 766.2113452777777,
          "2026-04-23": 76.82280583333333,
          "2026-04-28": 453.7165988888889,
          "2026-05-02": 786.3743322222223,
          "2026-05-06": 143.05010166666665
        },
        "time_count_per_day": {
          "2026-03-10": 1,
          "2026-03-24": 1,
          "2026-04-17": 1,
          "2026-04-23": 1,
          "2026-04-28": 1,
          "2026-05-02": 4,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 223.06,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "4-6h": 1,
            "54-56h": 1,
            "76-78h": 1,
            "142-144h": 1,
            "292-294h": 1,
            "432-434h": 1,
            "452-454h": 1,
            "766-768h": 1
          },
          "tickets_count": 11,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-24": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-05-02": 4,
            "2026-05-06": 1,
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-03-10": 3.794102777777778,
            "2026-03-24": 0.6177911111111111,
            "2026-04-17": 766.2113452777777,
            "2026-04-23": 76.82280583333333,
            "2026-04-28": 453.7165988888889,
            "2026-05-02": 786.3743322222223,
            "2026-05-06": 143.05010166666665
          },
          "time_count_per_day": {
            "2026-03-10": 1,
            "2026-03-24": 1,
            "2026-04-17": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-05-02": 4,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 223.06,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "4-6h": 1,
              "54-56h": 1,
              "76-78h": 1,
              "142-144h": 1,
              "292-294h": 1,
              "432-434h": 1,
              "452-454h": 1,
              "766-768h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-24": 1,
              "2026-04-17": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-05-02": 4,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-03-10": 3.794102777777778,
              "2026-03-24": 0.6177911111111111,
              "2026-04-17": 766.2113452777777,
              "2026-04-23": 76.82280583333333,
              "2026-04-28": 453.7165988888889,
              "2026-05-02": 786.3743322222223,
              "2026-05-06": 143.05010166666665
            },
            "time_count_per_day": {
              "2026-03-10": 1,
              "2026-03-24": 1,
              "2026-04-17": 1,
              "2026-04-23": 1,
              "2026-04-28": 1,
              "2026-05-02": 4,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 223.06,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "4-6h": 1,
                "54-56h": 1,
                "76-78h": 1,
                "142-144h": 1,
                "292-294h": 1,
                "432-434h": 1,
                "452-454h": 1,
                "766-768h": 1
              },
              "tickets_count": 10,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-24": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-05-02": 4,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-03-10": 3.794102777777778,
                "2026-03-24": 0.6177911111111111,
                "2026-04-17": 766.2113452777777,
                "2026-04-23": 76.82280583333333,
                "2026-04-28": 453.7165988888889,
                "2026-05-02": 786.3743322222223,
                "2026-05-06": 143.05010166666665
              },
              "time_count_per_day": {
                "2026-03-10": 1,
                "2026-03-24": 1,
                "2026-04-17": 1,
                "2026-04-23": 1,
                "2026-04-28": 1,
                "2026-05-02": 4,
                "2026-05-06": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1251": {
      "overall": {
        "avg_time_hours": 22.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "20-22h": 1,
          "44-46h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-05-21": 1
        },
        "time_per_day": {
          "2026-03-10": 1.630823888888889,
          "2026-03-11": 20.180527777777776,
          "2026-05-21": 44.85344666666666
        },
        "time_count_per_day": {
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 22.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "20-22h": 1,
            "44-46h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-03-10": 1.630823888888889,
            "2026-03-11": 20.180527777777776,
            "2026-05-21": 44.85344666666666
          },
          "time_count_per_day": {
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-05-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 22.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "20-22h": 1,
              "44-46h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-05-21": 1
            },
            "time_per_day": {
              "2026-03-10": 1.630823888888889,
              "2026-03-11": 20.180527777777776,
              "2026-05-21": 44.85344666666666
            },
            "time_count_per_day": {
              "2026-03-10": 1,
              "2026-03-11": 1,
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 22.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "20-22h": 1,
                "44-46h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-03-10": 1.630823888888889,
                "2026-03-11": 20.180527777777776,
                "2026-05-21": 44.85344666666666
              },
              "time_count_per_day": {
                "2026-03-10": 1,
                "2026-03-11": 1,
                "2026-05-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1204": {
      "overall": {
        "avg_time_hours": 141.8,
        "mode_time_hours": 141.0,
        "mode_frequency": 1,
        "time_distribution": {
          "140-142h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-16": 2
        },
        "time_per_day": {
          "2026-03-16": 141.8041575
        },
        "time_count_per_day": {
          "2026-03-16": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 141.8,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-03-16": 141.8041575
          },
          "time_count_per_day": {
            "2026-03-16": 1
          }
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.8,
            "mode_time_hours": 141.0,
            "mode_frequency": 1,
            "time_distribution": {
              "140-142h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {
              "2026-03-16": 141.8041575
            },
            "time_count_per_day": {
              "2026-03-16": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 141.8,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-03-16": 141.8041575
              },
              "time_count_per_day": {
                "2026-03-16": 1
              }
            }
          }
        },
        "Pendente Gestão": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1237": {
      "overall": {
        "avg_time_hours": 71.26,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-13": 1
        },
        "time_per_day": {
          "2026-03-13": 71.25820166666666
        },
        "time_count_per_day": {
          "2026-03-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 71.26,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-13": 1
          },
          "time_per_day": {
            "2026-03-13": 71.25820166666666
          },
          "time_count_per_day": {
            "2026-03-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 71.26,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-13": 1
            },
            "time_per_day": {
              "2026-03-13": 71.25820166666666
            },
            "time_count_per_day": {
              "2026-03-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 71.26,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-13": 1
              },
              "time_per_day": {
                "2026-03-13": 71.25820166666666
              },
              "time_count_per_day": {
                "2026-03-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1255": {
      "overall": {
        "avg_time_hours": 181.04,
        "mode_time_hours": 181.0,
        "mode_frequency": 1,
        "time_distribution": {
          "180-182h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 181.03609277777778
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 181.04,
          "mode_time_hours": 181.0,
          "mode_frequency": 1,
          "time_distribution": {
            "180-182h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 181.03609277777778
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 181.04,
            "mode_time_hours": 181.0,
            "mode_frequency": 1,
            "time_distribution": {
              "180-182h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 181.03609277777778
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 181.04,
              "mode_time_hours": 181.0,
              "mode_frequency": 1,
              "time_distribution": {
                "180-182h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 181.03609277777778
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1258": {
      "overall": {
        "avg_time_hours": 38.85,
        "mode_time_hours": 7.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "6-8h": 2,
          "214-216h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-03-11": 1,
          "2026-03-16": 1,
          "2026-03-20": 1,
          "2026-04-27": 2,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-03-11": 6.8070075,
          "2026-03-16": 6.553296111111112,
          "2026-03-20": 215.93387833333335,
          "2026-04-27": 0.5562544444444444,
          "2026-06-02": 3.2374616666666665
        },
        "time_count_per_day": {
          "2026-03-11": 1,
          "2026-03-16": 1,
          "2026-03-20": 1,
          "2026-04-27": 2,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 38.85,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "6-8h": 2,
            "214-216h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-20": 1,
            "2026-04-27": 2,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-03-11": 6.8070075,
            "2026-03-16": 6.553296111111112,
            "2026-03-20": 215.93387833333335,
            "2026-04-27": 0.5562544444444444,
            "2026-06-02": 3.2374616666666665
          },
          "time_count_per_day": {
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-20": 1,
            "2026-04-27": 2,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 38.85,
            "mode_time_hours": 7.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "6-8h": 2,
              "214-216h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-03-11": 1,
              "2026-03-16": 1,
              "2026-03-20": 1,
              "2026-04-27": 2,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-03-11": 6.8070075,
              "2026-03-16": 6.553296111111112,
              "2026-03-20": 215.93387833333335,
              "2026-04-27": 0.5562544444444444,
              "2026-06-02": 3.2374616666666665
            },
            "time_count_per_day": {
              "2026-03-11": 1,
              "2026-03-16": 1,
              "2026-03-20": 1,
              "2026-04-27": 2,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 38.85,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "6-8h": 2,
                "214-216h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-20": 1,
                "2026-04-27": 2,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-03-11": 6.8070075,
                "2026-03-16": 6.553296111111112,
                "2026-03-20": 215.93387833333335,
                "2026-04-27": 0.5562544444444444,
                "2026-06-02": 3.2374616666666665
              },
              "time_count_per_day": {
                "2026-03-11": 1,
                "2026-03-16": 1,
                "2026-03-20": 1,
                "2026-04-27": 2,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1260": {
      "overall": {
        "avg_time_hours": 166.62,
        "mode_time_hours": 167.0,
        "mode_frequency": 1,
        "time_distribution": {
          "166-168h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 166.61646416666665
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 166.62,
          "mode_time_hours": 167.0,
          "mode_frequency": 1,
          "time_distribution": {
            "166-168h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 166.61646416666665
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 166.62,
            "mode_time_hours": 167.0,
            "mode_frequency": 1,
            "time_distribution": {
              "166-168h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 166.61646416666665
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 166.62,
              "mode_time_hours": 167.0,
              "mode_frequency": 1,
              "time_distribution": {
                "166-168h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 166.61646416666665
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1262": {
      "overall": {
        "avg_time_hours": 87.13,
        "mode_time_hours": 165.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 1,
          "24-26h": 2,
          "74-76h": 2,
          "164-166h": 3
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-03-14": 2,
          "2026-03-17": 2,
          "2026-03-18": 3,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-03-14": 150.39847111111112,
          "2026-03-17": 51.43315777777778,
          "2026-03-18": 494.60932972222224,
          "2026-05-04": 0.6337072222222222
        },
        "time_count_per_day": {
          "2026-03-14": 2,
          "2026-03-17": 2,
          "2026-03-18": 3,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 0.6337072222222222
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 99.49,
          "mode_time_hours": 165.0,
          "mode_frequency": 3,
          "time_distribution": {
            "24-26h": 2,
            "74-76h": 2,
            "164-166h": 3
          },
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-03-14": 2,
            "2026-03-17": 2,
            "2026-03-18": 3
          },
          "time_per_day": {
            "2026-03-14": 150.39847111111112,
            "2026-03-17": 51.43315777777778,
            "2026-03-18": 494.60932972222224
          },
          "time_count_per_day": {
            "2026-03-14": 2,
            "2026-03-17": 2,
            "2026-03-18": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 87.13,
            "mode_time_hours": 165.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 1,
              "24-26h": 2,
              "74-76h": 2,
              "164-166h": 3
            },
            "tickets_count": 8,
            "tickets_per_day": {
              "2026-03-14": 2,
              "2026-03-17": 2,
              "2026-03-18": 3,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-03-14": 150.39847111111112,
              "2026-03-17": 51.43315777777778,
              "2026-03-18": 494.60932972222224,
              "2026-05-04": 0.6337072222222222
            },
            "time_count_per_day": {
              "2026-03-14": 2,
              "2026-03-17": 2,
              "2026-03-18": 3,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 0.6337072222222222
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 99.49,
              "mode_time_hours": 165.0,
              "mode_frequency": 3,
              "time_distribution": {
                "24-26h": 2,
                "74-76h": 2,
                "164-166h": 3
              },
              "tickets_count": 7,
              "tickets_per_day": {
                "2026-03-14": 2,
                "2026-03-17": 2,
                "2026-03-18": 3
              },
              "time_per_day": {
                "2026-03-14": 150.39847111111112,
                "2026-03-17": 51.43315777777778,
                "2026-03-18": 494.60932972222224
              },
              "time_count_per_day": {
                "2026-03-14": 2,
                "2026-03-17": 2,
                "2026-03-18": 3
              }
            }
          }
        }
      }
    },
    "cliente_1265": {
      "overall": {
        "avg_time_hours": 0.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-11": 1
        },
        "time_per_day": {
          "2026-03-11": 0.06284722222222222
        },
        "time_count_per_day": {
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.06,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-03-11": 0.06284722222222222
          },
          "time_count_per_day": {
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-11": 1
            },
            "time_per_day": {
              "2026-03-11": 0.06284722222222222
            },
            "time_count_per_day": {
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.06,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-03-11": 0.06284722222222222
              },
              "time_count_per_day": {
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_1266": {
      "overall": {
        "avg_time_hours": 159.64,
        "mode_time_hours": 163.0,
        "mode_frequency": 1,
        "time_distribution": {
          "156-158h": 1,
          "162-164h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-18": 2
        },
        "time_per_day": {
          "2026-03-18": 319.2782727777778
        },
        "time_count_per_day": {
          "2026-03-18": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 159.64,
          "mode_time_hours": 163.0,
          "mode_frequency": 1,
          "time_distribution": {
            "156-158h": 1,
            "162-164h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-18": 2
          },
          "time_per_day": {
            "2026-03-18": 319.2782727777778
          },
          "time_count_per_day": {
            "2026-03-18": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 159.64,
            "mode_time_hours": 163.0,
            "mode_frequency": 1,
            "time_distribution": {
              "156-158h": 1,
              "162-164h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-18": 2
            },
            "time_per_day": {
              "2026-03-18": 319.2782727777778
            },
            "time_count_per_day": {
              "2026-03-18": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 159.64,
              "mode_time_hours": 163.0,
              "mode_frequency": 1,
              "time_distribution": {
                "156-158h": 1,
                "162-164h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-18": 2
              },
              "time_per_day": {
                "2026-03-18": 319.2782727777778
              },
              "time_count_per_day": {
                "2026-03-18": 2
              }
            }
          }
        }
      }
    },
    "cliente_1102": {
      "overall": {
        "avg_time_hours": 99.5,
        "mode_time_hours": 193.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "192-194h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-19": 1,
          "2026-05-20": 2,
          "2026-05-22": 1
        },
        "time_per_day": {
          "2026-03-19": 193.19012722222223,
          "2026-05-20": 5.804926666666667
        },
        "time_count_per_day": {
          "2026-03-19": 1,
          "2026-05-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 99.5,
          "mode_time_hours": 193.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "192-194h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-19": 1,
            "2026-05-20": 2,
            "2026-05-22": 1
          },
          "time_per_day": {
            "2026-03-19": 193.19012722222223,
            "2026-05-20": 5.804926666666667
          },
          "time_count_per_day": {
            "2026-03-19": 1,
            "2026-05-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 99.5,
            "mode_time_hours": 193.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "192-194h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-19": 1,
              "2026-05-20": 1
            },
            "time_per_day": {
              "2026-03-19": 193.19012722222223,
              "2026-05-20": 5.804926666666667
            },
            "time_count_per_day": {
              "2026-03-19": 1,
              "2026-05-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 99.5,
              "mode_time_hours": 193.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "192-194h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-19": 1,
                "2026-05-20": 1
              },
              "time_per_day": {
                "2026-03-19": 193.19012722222223,
                "2026-05-20": 5.804926666666667
              },
              "time_count_per_day": {
                "2026-03-19": 1,
                "2026-05-20": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-20": 1,
              "2026-05-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-20": 1,
                "2026-05-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1267": {
      "overall": {
        "avg_time_hours": 0.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-11": 1
        },
        "time_per_day": {
          "2026-03-11": 0.2837341666666667
        },
        "time_count_per_day": {
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.28,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-03-11": 0.2837341666666667
          },
          "time_count_per_day": {
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-11": 1
            },
            "time_per_day": {
              "2026-03-11": 0.2837341666666667
            },
            "time_count_per_day": {
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.28,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-03-11": 0.2837341666666667
              },
              "time_count_per_day": {
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_1268": {
      "overall": {
        "avg_time_hours": 24.81,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-12": 1
        },
        "time_per_day": {
          "2026-03-12": 24.813801666666667
        },
        "time_count_per_day": {
          "2026-03-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.81,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-12": 1
          },
          "time_per_day": {
            "2026-03-12": 24.813801666666667
          },
          "time_count_per_day": {
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.81,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-12": 1
            },
            "time_per_day": {
              "2026-03-12": 24.813801666666667
            },
            "time_count_per_day": {
              "2026-03-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.81,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-12": 1
              },
              "time_per_day": {
                "2026-03-12": 24.813801666666667
              },
              "time_count_per_day": {
                "2026-03-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1269": {
      "overall": {
        "avg_time_hours": 48.33,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1,
          "74-76h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-12": 1,
          "2026-03-16": 1
        },
        "time_per_day": {
          "2026-03-12": 20.9539425,
          "2026-03-16": 75.71280999999999
        },
        "time_count_per_day": {
          "2026-03-12": 1,
          "2026-03-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.33,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1,
            "74-76h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-12": 1,
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-03-12": 20.9539425,
            "2026-03-16": 75.71280999999999
          },
          "time_count_per_day": {
            "2026-03-12": 1,
            "2026-03-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.33,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1,
              "74-76h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-12": 1,
              "2026-03-16": 1
            },
            "time_per_day": {
              "2026-03-12": 20.9539425,
              "2026-03-16": 75.71280999999999
            },
            "time_count_per_day": {
              "2026-03-12": 1,
              "2026-03-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.33,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1,
                "74-76h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-12": 1,
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-03-12": 20.9539425,
                "2026-03-16": 75.71280999999999
              },
              "time_count_per_day": {
                "2026-03-12": 1,
                "2026-03-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_227": {
      "overall": {
        "avg_time_hours": 0.67,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-11": 1,
          "2026-03-19": 1
        },
        "time_per_day": {
          "2026-03-11": 1.3292233333333332,
          "2026-03-19": 0.010819722222222222
        },
        "time_count_per_day": {
          "2026-03-11": 1,
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.67,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-11": 1,
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-03-11": 1.3292233333333332,
            "2026-03-19": 0.010819722222222222
          },
          "time_count_per_day": {
            "2026-03-11": 1,
            "2026-03-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.67,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-11": 1,
              "2026-03-19": 1
            },
            "time_per_day": {
              "2026-03-11": 1.3292233333333332,
              "2026-03-19": 0.010819722222222222
            },
            "time_count_per_day": {
              "2026-03-11": 1,
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.67,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-11": 1,
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-03-11": 1.3292233333333332,
                "2026-03-19": 0.010819722222222222
              },
              "time_count_per_day": {
                "2026-03-11": 1,
                "2026-03-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1271": {
      "overall": {
        "avg_time_hours": 157.05,
        "mode_time_hours": 157.0,
        "mode_frequency": 1,
        "time_distribution": {
          "156-158h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 157.05440194444444
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 157.05,
          "mode_time_hours": 157.0,
          "mode_frequency": 1,
          "time_distribution": {
            "156-158h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 157.05440194444444
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.05,
            "mode_time_hours": 157.0,
            "mode_frequency": 1,
            "time_distribution": {
              "156-158h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 157.05440194444444
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 157.05,
              "mode_time_hours": 157.0,
              "mode_frequency": 1,
              "time_distribution": {
                "156-158h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 157.05440194444444
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1272": {
      "overall": {
        "avg_time_hours": 157.05,
        "mode_time_hours": 157.0,
        "mode_frequency": 1,
        "time_distribution": {
          "156-158h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-18": 1,
          "2026-05-29": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-03-18": 157.05047916666666
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 157.05,
          "mode_time_hours": 157.0,
          "mode_frequency": 1,
          "time_distribution": {
            "156-158h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-18": 1,
            "2026-05-29": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-03-18": 157.05047916666666
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.05,
            "mode_time_hours": 157.0,
            "mode_frequency": 1,
            "time_distribution": {
              "156-158h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 157.05047916666666
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 157.05,
              "mode_time_hours": 157.0,
              "mode_frequency": 1,
              "time_distribution": {
                "156-158h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 157.05047916666666
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-29": 1,
              "2026-05-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-29": 1,
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1273": {
      "overall": {
        "avg_time_hours": 157.05,
        "mode_time_hours": 157.0,
        "mode_frequency": 1,
        "time_distribution": {
          "156-158h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 157.0470408333333
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 157.05,
          "mode_time_hours": 157.0,
          "mode_frequency": 1,
          "time_distribution": {
            "156-158h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 157.0470408333333
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 157.05,
            "mode_time_hours": 157.0,
            "mode_frequency": 1,
            "time_distribution": {
              "156-158h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 157.0470408333333
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 157.05,
              "mode_time_hours": 157.0,
              "mode_frequency": 1,
              "time_distribution": {
                "156-158h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 157.0470408333333
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1274": {
      "overall": {
        "avg_time_hours": 29.35,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "16-18h": 2,
          "70-72h": 1,
          "96-98h": 1
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 2,
          "2026-03-14": 1,
          "2026-03-17": 2
        },
        "time_per_day": {
          "2026-03-11": 0.721468611111111,
          "2026-03-12": 17.203765,
          "2026-03-13": 2.239797777777778,
          "2026-03-14": 17.628150277777777,
          "2026-03-17": 167.66474305555556
        },
        "time_count_per_day": {
          "2026-03-11": 1,
          "2026-03-12": 1,
          "2026-03-13": 2,
          "2026-03-14": 1,
          "2026-03-17": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 18.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "16-18h": 1,
            "70-72h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-11": 0.721468611111111,
            "2026-03-12": 17.203765,
            "2026-03-13": 2.239797777777778,
            "2026-03-17": 71.49243777777778
          },
          "time_count_per_day": {
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-17": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 56.9,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1,
            "96-98h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-14": 1,
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-14": 17.628150277777777,
            "2026-03-17": 96.17230527777778
          },
          "time_count_per_day": {
            "2026-03-14": 1,
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.35,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "16-18h": 2,
              "70-72h": 1,
              "96-98h": 1
            },
            "tickets_count": 7,
            "tickets_per_day": {
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 2,
              "2026-03-14": 1,
              "2026-03-17": 2
            },
            "time_per_day": {
              "2026-03-11": 0.721468611111111,
              "2026-03-12": 17.203765,
              "2026-03-13": 2.239797777777778,
              "2026-03-14": 17.628150277777777,
              "2026-03-17": 167.66474305555556
            },
            "time_count_per_day": {
              "2026-03-11": 1,
              "2026-03-12": 1,
              "2026-03-13": 2,
              "2026-03-14": 1,
              "2026-03-17": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 18.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "16-18h": 1,
                "70-72h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-11": 0.721468611111111,
                "2026-03-12": 17.203765,
                "2026-03-13": 2.239797777777778,
                "2026-03-17": 71.49243777777778
              },
              "time_count_per_day": {
                "2026-03-11": 1,
                "2026-03-12": 1,
                "2026-03-13": 2,
                "2026-03-17": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 56.9,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1,
                "96-98h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-14": 1,
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-14": 17.628150277777777,
                "2026-03-17": 96.17230527777778
              },
              "time_count_per_day": {
                "2026-03-14": 1,
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1275": {
      "overall": {
        "avg_time_hours": 2.05,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-11": 1
        },
        "time_per_day": {
          "2026-03-11": 2.0500475000000002
        },
        "time_count_per_day": {
          "2026-03-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.05,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-11": 1
          },
          "time_per_day": {
            "2026-03-11": 2.0500475000000002
          },
          "time_count_per_day": {
            "2026-03-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.05,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-11": 1
            },
            "time_per_day": {
              "2026-03-11": 2.0500475000000002
            },
            "time_count_per_day": {
              "2026-03-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.05,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-11": 1
              },
              "time_per_day": {
                "2026-03-11": 2.0500475000000002
              },
              "time_count_per_day": {
                "2026-03-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_1277": {
      "overall": {
        "avg_time_hours": 0.98,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-12": 1
        },
        "time_per_day": {
          "2026-03-12": 0.97589
        },
        "time_count_per_day": {
          "2026-03-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-12": 1
          },
          "time_per_day": {
            "2026-03-12": 0.97589
          },
          "time_count_per_day": {
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.98,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-12": 1
            },
            "time_per_day": {
              "2026-03-12": 0.97589
            },
            "time_count_per_day": {
              "2026-03-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-12": 1
              },
              "time_per_day": {
                "2026-03-12": 0.97589
              },
              "time_count_per_day": {
                "2026-03-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1278": {
      "overall": {
        "avg_time_hours": 25.94,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-13": 1
        },
        "time_per_day": {
          "2026-03-13": 25.943515277777777
        },
        "time_count_per_day": {
          "2026-03-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 25.94,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-13": 1
          },
          "time_per_day": {
            "2026-03-13": 25.943515277777777
          },
          "time_count_per_day": {
            "2026-03-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 25.94,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-13": 1
            },
            "time_per_day": {
              "2026-03-13": 25.943515277777777
            },
            "time_count_per_day": {
              "2026-03-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 25.94,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-13": 1
              },
              "time_per_day": {
                "2026-03-13": 25.943515277777777
              },
              "time_count_per_day": {
                "2026-03-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1279": {
      "overall": {
        "avg_time_hours": 1000.63,
        "mode_time_hours": 1001.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1000-1002h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 1000.6283744444445
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1000.63,
          "mode_time_hours": 1001.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1000-1002h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 1000.6283744444445
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1000.63,
            "mode_time_hours": 1001.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1000-1002h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 1000.6283744444445
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1000.63,
              "mode_time_hours": 1001.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1000-1002h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 1000.6283744444445
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1280": {
      "overall": {
        "avg_time_hours": 1000.3,
        "mode_time_hours": 1001.0,
        "mode_frequency": 1,
        "time_distribution": {
          "1000-1002h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 1000.3037919444445
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1000.3,
          "mode_time_hours": 1001.0,
          "mode_frequency": 1,
          "time_distribution": {
            "1000-1002h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 1000.3037919444445
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1000.3,
            "mode_time_hours": 1001.0,
            "mode_frequency": 1,
            "time_distribution": {
              "1000-1002h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 1000.3037919444445
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1000.3,
              "mode_time_hours": 1001.0,
              "mode_frequency": 1,
              "time_distribution": {
                "1000-1002h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 1000.3037919444445
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1281": {
      "overall": {
        "avg_time_hours": 3.37,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-12": 1,
          "2026-04-04": 1
        },
        "time_per_day": {
          "2026-03-12": 3.366522222222222
        },
        "time_count_per_day": {
          "2026-03-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.37,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-12": 1,
            "2026-04-04": 1
          },
          "time_per_day": {
            "2026-03-12": 3.366522222222222
          },
          "time_count_per_day": {
            "2026-03-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.37,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-12": 1
            },
            "time_per_day": {
              "2026-03-12": 3.366522222222222
            },
            "time_count_per_day": {
              "2026-03-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.37,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-12": 1
              },
              "time_per_day": {
                "2026-03-12": 3.366522222222222
              },
              "time_count_per_day": {
                "2026-03-12": 1
              }
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_449": {
      "overall": {
        "avg_time_hours": 811.48,
        "mode_time_hours": 1621.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "1620-1622h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-19": 1,
          "2026-05-19": 1
        },
        "time_per_day": {
          "2026-03-19": 1.2494463888888887,
          "2026-05-19": 1621.711244722222
        },
        "time_count_per_day": {
          "2026-03-19": 1,
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 811.48,
          "mode_time_hours": 1621.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "1620-1622h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-19": 1,
            "2026-05-19": 1
          },
          "time_per_day": {
            "2026-03-19": 1.2494463888888887,
            "2026-05-19": 1621.711244722222
          },
          "time_count_per_day": {
            "2026-03-19": 1,
            "2026-05-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 811.48,
            "mode_time_hours": 1621.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "1620-1622h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-19": 1,
              "2026-05-19": 1
            },
            "time_per_day": {
              "2026-03-19": 1.2494463888888887,
              "2026-05-19": 1621.711244722222
            },
            "time_count_per_day": {
              "2026-03-19": 1,
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 811.48,
              "mode_time_hours": 1621.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "1620-1622h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-19": 1,
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-03-19": 1.2494463888888887,
                "2026-05-19": 1621.711244722222
              },
              "time_count_per_day": {
                "2026-03-19": 1,
                "2026-05-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1282": {
      "overall": {
        "avg_time_hours": 26.34,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-14": 1
        },
        "time_per_day": {
          "2026-03-14": 26.33772388888889
        },
        "time_count_per_day": {
          "2026-03-14": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 26.34,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-14": 1
          },
          "time_per_day": {
            "2026-03-14": 26.33772388888889
          },
          "time_count_per_day": {
            "2026-03-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.34,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-14": 1
            },
            "time_per_day": {
              "2026-03-14": 26.33772388888889
            },
            "time_count_per_day": {
              "2026-03-14": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 26.34,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-14": 1
              },
              "time_per_day": {
                "2026-03-14": 26.33772388888889
              },
              "time_count_per_day": {
                "2026-03-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1283": {
      "overall": {
        "avg_time_hours": 26.12,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-14": 1
        },
        "time_per_day": {
          "2026-03-14": 26.11638611111111
        },
        "time_count_per_day": {
          "2026-03-14": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 26.12,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-14": 1
          },
          "time_per_day": {
            "2026-03-14": 26.11638611111111
          },
          "time_count_per_day": {
            "2026-03-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.12,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-14": 1
            },
            "time_per_day": {
              "2026-03-14": 26.11638611111111
            },
            "time_count_per_day": {
              "2026-03-14": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 26.12,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-14": 1
              },
              "time_per_day": {
                "2026-03-14": 26.11638611111111
              },
              "time_count_per_day": {
                "2026-03-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1285": {
      "overall": {
        "avg_time_hours": 989.52,
        "mode_time_hours": 989.0,
        "mode_frequency": 1,
        "time_distribution": {
          "988-990h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 989.5216433333334
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 989.52,
          "mode_time_hours": 989.0,
          "mode_frequency": 1,
          "time_distribution": {
            "988-990h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 989.5216433333334
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 989.52,
            "mode_time_hours": 989.0,
            "mode_frequency": 1,
            "time_distribution": {
              "988-990h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 989.5216433333334
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 989.52,
              "mode_time_hours": 989.0,
              "mode_frequency": 1,
              "time_distribution": {
                "988-990h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 989.5216433333334
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1286": {
      "overall": {
        "avg_time_hours": 0.6,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-14": 1
        },
        "time_per_day": {
          "2026-03-14": 0.5962025000000001
        },
        "time_count_per_day": {
          "2026-03-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.6,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-14": 1
          },
          "time_per_day": {
            "2026-03-14": 0.5962025000000001
          },
          "time_count_per_day": {
            "2026-03-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.6,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-14": 1
            },
            "time_per_day": {
              "2026-03-14": 0.5962025000000001
            },
            "time_count_per_day": {
              "2026-03-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.6,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-14": 1
              },
              "time_per_day": {
                "2026-03-14": 0.5962025000000001
              },
              "time_count_per_day": {
                "2026-03-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1287": {
      "overall": {
        "avg_time_hours": 374.63,
        "mode_time_hours": 83.0,
        "mode_frequency": 1,
        "time_distribution": {
          "82-84h": 1,
          "196-198h": 1,
          "842-844h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-03-17": 1,
          "2026-03-27": 1,
          "2026-03-30": 1,
          "2026-05-04": 1,
          "2026-05-13": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-03-17": 82.65040916666666,
          "2026-05-04": 843.4432725,
          "2026-06-06": 197.79477
        },
        "time_count_per_day": {
          "2026-03-17": 1,
          "2026-05-04": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 374.63,
          "mode_time_hours": 83.0,
          "mode_frequency": 1,
          "time_distribution": {
            "82-84h": 1,
            "196-198h": 1,
            "842-844h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-03-27": 1,
            "2026-03-30": 1,
            "2026-05-04": 1,
            "2026-05-13": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-03-17": 82.65040916666666,
            "2026-05-04": 843.4432725,
            "2026-06-06": 197.79477
          },
          "time_count_per_day": {
            "2026-03-17": 1,
            "2026-05-04": 1,
            "2026-06-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 374.63,
            "mode_time_hours": 83.0,
            "mode_frequency": 1,
            "time_distribution": {
              "82-84h": 1,
              "196-198h": 1,
              "842-844h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-17": 1,
              "2026-05-04": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2026-03-17": 82.65040916666666,
              "2026-05-04": 843.4432725,
              "2026-06-06": 197.79477
            },
            "time_count_per_day": {
              "2026-03-17": 1,
              "2026-05-04": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 374.63,
              "mode_time_hours": 83.0,
              "mode_frequency": 1,
              "time_distribution": {
                "82-84h": 1,
                "196-198h": 1,
                "842-844h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-17": 1,
                "2026-05-04": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2026-03-17": 82.65040916666666,
                "2026-05-04": 843.4432725,
                "2026-06-06": 197.79477
              },
              "time_count_per_day": {
                "2026-03-17": 1,
                "2026-05-04": 1,
                "2026-06-06": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-27": 1,
              "2026-03-30": 1,
              "2026-05-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-27": 1,
                "2026-03-30": 1,
                "2026-05-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1288": {
      "overall": {
        "avg_time_hours": 47.24,
        "mode_time_hours": 47.0,
        "mode_frequency": 1,
        "time_distribution": {
          "46-48h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-16": 1
        },
        "time_per_day": {
          "2026-03-16": 47.244190555555555
        },
        "time_count_per_day": {
          "2026-03-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 47.24,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-03-16": 47.244190555555555
          },
          "time_count_per_day": {
            "2026-03-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 47.24,
            "mode_time_hours": 47.0,
            "mode_frequency": 1,
            "time_distribution": {
              "46-48h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {
              "2026-03-16": 47.244190555555555
            },
            "time_count_per_day": {
              "2026-03-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 47.24,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-03-16": 47.244190555555555
              },
              "time_count_per_day": {
                "2026-03-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_1289": {
      "overall": {
        "avg_time_hours": 76.61,
        "mode_time_hours": 77.0,
        "mode_frequency": 2,
        "time_distribution": {
          "76-78h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-17": 2
        },
        "time_per_day": {
          "2026-03-17": 153.2248641666667
        },
        "time_count_per_day": {
          "2026-03-17": 2
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 76.61,
          "mode_time_hours": 77.0,
          "mode_frequency": 2,
          "time_distribution": {
            "76-78h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-17": 2
          },
          "time_per_day": {
            "2026-03-17": 153.2248641666667
          },
          "time_count_per_day": {
            "2026-03-17": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 76.61,
            "mode_time_hours": 77.0,
            "mode_frequency": 2,
            "time_distribution": {
              "76-78h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-17": 2
            },
            "time_per_day": {
              "2026-03-17": 153.2248641666667
            },
            "time_count_per_day": {
              "2026-03-17": 2
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 76.61,
              "mode_time_hours": 77.0,
              "mode_frequency": 2,
              "time_distribution": {
                "76-78h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-17": 2
              },
              "time_per_day": {
                "2026-03-17": 153.2248641666667
              },
              "time_count_per_day": {
                "2026-03-17": 2
              }
            }
          }
        }
      }
    },
    "cliente_1292": {
      "overall": {
        "avg_time_hours": 37.44,
        "mode_time_hours": 37.0,
        "mode_frequency": 1,
        "time_distribution": {
          "36-38h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-17": 37.440714166666666
        },
        "time_count_per_day": {
          "2026-03-17": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 37.44,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 37.440714166666666
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 37.44,
            "mode_time_hours": 37.0,
            "mode_frequency": 1,
            "time_distribution": {
              "36-38h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-17": 37.440714166666666
            },
            "time_count_per_day": {
              "2026-03-17": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 37.44,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 37.440714166666666
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1293": {
      "overall": {
        "avg_time_hours": 18.84,
        "mode_time_hours": 37.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "36-38h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-17": 1,
          "2026-04-06": 1
        },
        "time_per_day": {
          "2026-03-17": 37.43953388888888,
          "2026-04-06": 0.23888583333333335
        },
        "time_count_per_day": {
          "2026-03-17": 1,
          "2026-04-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.24,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-06": 1
          },
          "time_per_day": {
            "2026-04-06": 0.23888583333333335
          },
          "time_count_per_day": {
            "2026-04-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 37.44,
          "mode_time_hours": 37.0,
          "mode_frequency": 1,
          "time_distribution": {
            "36-38h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 37.43953388888888
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 18.84,
            "mode_time_hours": 37.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "36-38h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-17": 1,
              "2026-04-06": 1
            },
            "time_per_day": {
              "2026-03-17": 37.43953388888888,
              "2026-04-06": 0.23888583333333335
            },
            "time_count_per_day": {
              "2026-03-17": 1,
              "2026-04-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.24,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {
                "2026-04-06": 0.23888583333333335
              },
              "time_count_per_day": {
                "2026-04-06": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 37.44,
              "mode_time_hours": 37.0,
              "mode_frequency": 1,
              "time_distribution": {
                "36-38h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 37.43953388888888
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1294": {
      "overall": {
        "avg_time_hours": 9.09,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-16": 1
        },
        "time_per_day": {
          "2026-03-16": 9.091244444444444
        },
        "time_count_per_day": {
          "2026-03-16": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 9.09,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {
            "2026-03-16": 9.091244444444444
          },
          "time_count_per_day": {
            "2026-03-16": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.09,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {
              "2026-03-16": 9.091244444444444
            },
            "time_count_per_day": {
              "2026-03-16": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.09,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {
                "2026-03-16": 9.091244444444444
              },
              "time_count_per_day": {
                "2026-03-16": 1
              }
            }
          }
        }
      }
    },
    "cliente_1296": {
      "overall": {
        "avg_time_hours": 48.26,
        "mode_time_hours": 5.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 2,
          "12-14h": 1,
          "72-74h": 1,
          "92-94h": 1,
          "100-102h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-03-16": 2,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-04-17": 1,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-03-16": 10.13019888888889,
          "2026-03-23": 72.67121833333333,
          "2026-03-24": 92.56838388888887,
          "2026-04-17": 13.456977499999999,
          "2026-04-22": 100.76019611111111
        },
        "time_count_per_day": {
          "2026-03-16": 2,
          "2026-03-23": 1,
          "2026-03-24": 1,
          "2026-04-17": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.26,
          "mode_time_hours": 5.0,
          "mode_frequency": 2,
          "time_distribution": {
            "4-6h": 2,
            "12-14h": 1,
            "72-74h": 1,
            "92-94h": 1,
            "100-102h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-03-16": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-04-17": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-03-16": 10.13019888888889,
            "2026-03-23": 72.67121833333333,
            "2026-03-24": 92.56838388888887,
            "2026-04-17": 13.456977499999999,
            "2026-04-22": 100.76019611111111
          },
          "time_count_per_day": {
            "2026-03-16": 2,
            "2026-03-23": 1,
            "2026-03-24": 1,
            "2026-04-17": 1,
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.26,
            "mode_time_hours": 5.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 2,
              "12-14h": 1,
              "72-74h": 1,
              "92-94h": 1,
              "100-102h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-03-16": 2,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-04-17": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-03-16": 10.13019888888889,
              "2026-03-23": 72.67121833333333,
              "2026-03-24": 92.56838388888887,
              "2026-04-17": 13.456977499999999,
              "2026-04-22": 100.76019611111111
            },
            "time_count_per_day": {
              "2026-03-16": 2,
              "2026-03-23": 1,
              "2026-03-24": 1,
              "2026-04-17": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.26,
              "mode_time_hours": 5.0,
              "mode_frequency": 2,
              "time_distribution": {
                "4-6h": 2,
                "12-14h": 1,
                "72-74h": 1,
                "92-94h": 1,
                "100-102h": 1
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-03-16": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-04-17": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-03-16": 10.13019888888889,
                "2026-03-23": 72.67121833333333,
                "2026-03-24": 92.56838388888887,
                "2026-04-17": 13.456977499999999,
                "2026-04-22": 100.76019611111111
              },
              "time_count_per_day": {
                "2026-03-16": 2,
                "2026-03-23": 1,
                "2026-03-24": 1,
                "2026-04-17": 1,
                "2026-04-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_1298": {
      "overall": {
        "avg_time_hours": 17.17,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-17": 17.173425555555557
        },
        "time_count_per_day": {
          "2026-03-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 17.17,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 17.173425555555557
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.17,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-17": 17.173425555555557
            },
            "time_count_per_day": {
              "2026-03-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 17.17,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 17.173425555555557
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1299": {
      "overall": {
        "avg_time_hours": 1.31,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-04-29": 1
        },
        "time_per_day": {
          "2026-03-16": 0.4651869444444445,
          "2026-04-29": 2.161425
        },
        "time_count_per_day": {
          "2026-03-16": 1,
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.31,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-16": 1,
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-03-16": 0.4651869444444445,
            "2026-04-29": 2.161425
          },
          "time_count_per_day": {
            "2026-03-16": 1,
            "2026-04-29": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.31,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-16": 1,
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-03-16": 0.4651869444444445,
              "2026-04-29": 2.161425
            },
            "time_count_per_day": {
              "2026-03-16": 1,
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.31,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-16": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-03-16": 0.4651869444444445,
                "2026-04-29": 2.161425
              },
              "time_count_per_day": {
                "2026-03-16": 1,
                "2026-04-29": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1301": {
      "overall": {
        "avg_time_hours": 187.74,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "64-66h": 1,
          "68-70h": 1,
          "616-618h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-16": 1,
          "2026-03-23": 1,
          "2026-03-30": 1,
          "2026-04-13": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-03-16": 0.05604083333333334,
          "2026-03-30": 65.85448111111111,
          "2026-04-13": 68.80085833333334,
          "2026-05-06": 616.2533891666666
        },
        "time_count_per_day": {
          "2026-03-16": 1,
          "2026-03-30": 1,
          "2026-04-13": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 44.9,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "64-66h": 1,
            "68-70h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-16": 1,
            "2026-03-23": 1,
            "2026-03-30": 1,
            "2026-04-13": 1
          },
          "time_per_day": {
            "2026-03-16": 0.05604083333333334,
            "2026-03-30": 65.85448111111111,
            "2026-04-13": 68.80085833333334
          },
          "time_count_per_day": {
            "2026-03-16": 1,
            "2026-03-30": 1,
            "2026-04-13": 1
          }
        },
        "P3": {
          "avg_time_hours": 616.25,
          "mode_time_hours": 617.0,
          "mode_frequency": 1,
          "time_distribution": {
            "616-618h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-05-06": 616.2533891666666
          },
          "time_count_per_day": {
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 187.74,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "64-66h": 1,
              "68-70h": 1,
              "616-618h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-16": 1,
              "2026-03-30": 1,
              "2026-04-13": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-03-16": 0.05604083333333334,
              "2026-03-30": 65.85448111111111,
              "2026-04-13": 68.80085833333334,
              "2026-05-06": 616.2533891666666
            },
            "time_count_per_day": {
              "2026-03-16": 1,
              "2026-03-30": 1,
              "2026-04-13": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 44.9,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "64-66h": 1,
                "68-70h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-16": 1,
                "2026-03-30": 1,
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-03-16": 0.05604083333333334,
                "2026-03-30": 65.85448111111111,
                "2026-04-13": 68.80085833333334
              },
              "time_count_per_day": {
                "2026-03-16": 1,
                "2026-03-30": 1,
                "2026-04-13": 1
              }
            },
            "P3": {
              "avg_time_hours": 616.25,
              "mode_time_hours": 617.0,
              "mode_frequency": 1,
              "time_distribution": {
                "616-618h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-05-06": 616.2533891666666
              },
              "time_count_per_day": {
                "2026-05-06": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1302": {
      "overall": {
        "avg_time_hours": 23.85,
        "mode_time_hours": 23.0,
        "mode_frequency": 1,
        "time_distribution": {
          "22-24h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-17": 1
        },
        "time_per_day": {
          "2026-03-17": 23.847448611111112
        },
        "time_count_per_day": {
          "2026-03-17": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 23.85,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-17": 1
          },
          "time_per_day": {
            "2026-03-17": 23.847448611111112
          },
          "time_count_per_day": {
            "2026-03-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 23.85,
            "mode_time_hours": 23.0,
            "mode_frequency": 1,
            "time_distribution": {
              "22-24h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-17": 1
            },
            "time_per_day": {
              "2026-03-17": 23.847448611111112
            },
            "time_count_per_day": {
              "2026-03-17": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 23.85,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-17": 1
              },
              "time_per_day": {
                "2026-03-17": 23.847448611111112
              },
              "time_count_per_day": {
                "2026-03-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1303": {
      "overall": {
        "avg_time_hours": 164.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "98-100h": 1,
          "102-104h": 1,
          "618-620h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-17": 1,
          "2026-03-24": 2,
          "2026-05-06": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-03-17": 0.7076119444444444,
          "2026-03-24": 203.37720722222224,
          "2026-05-06": 619.0829538888889,
          "2026-05-30": 0.09872555555555555
        },
        "time_count_per_day": {
          "2026-03-17": 1,
          "2026-03-24": 2,
          "2026-05-06": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 164.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "98-100h": 1,
            "102-104h": 1,
            "618-620h": 1
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-03-17": 1,
            "2026-03-24": 2,
            "2026-05-06": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-03-17": 0.7076119444444444,
            "2026-03-24": 203.37720722222224,
            "2026-05-06": 619.0829538888889,
            "2026-05-30": 0.09872555555555555
          },
          "time_count_per_day": {
            "2026-03-17": 1,
            "2026-03-24": 2,
            "2026-05-06": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 164.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "98-100h": 1,
              "102-104h": 1,
              "618-620h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-17": 1,
              "2026-03-24": 2,
              "2026-05-06": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-03-17": 0.7076119444444444,
              "2026-03-24": 203.37720722222224,
              "2026-05-06": 619.0829538888889,
              "2026-05-30": 0.09872555555555555
            },
            "time_count_per_day": {
              "2026-03-17": 1,
              "2026-03-24": 2,
              "2026-05-06": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 164.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "98-100h": 1,
                "102-104h": 1,
                "618-620h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-17": 1,
                "2026-03-24": 2,
                "2026-05-06": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-03-17": 0.7076119444444444,
                "2026-03-24": 203.37720722222224,
                "2026-05-06": 619.0829538888889,
                "2026-05-30": 0.09872555555555555
              },
              "time_count_per_day": {
                "2026-03-17": 1,
                "2026-03-24": 2,
                "2026-05-06": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1306": {
      "overall": {
        "avg_time_hours": 21.46,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 21.461419999999997
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 21.46,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 21.461419999999997
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 21.46,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 21.461419999999997
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 21.46,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 21.461419999999997
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1308": {
      "overall": {
        "avg_time_hours": 2.88,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 2.8836072222222224
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.88,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 2.8836072222222224
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.88,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 2.8836072222222224
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.88,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 2.8836072222222224
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1309": {
      "overall": {
        "avg_time_hours": 421.8,
        "mode_time_hours": 841.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "840-842h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-19": 1,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-03-19": 2.6708077777777777,
          "2026-04-22": 840.9198661111111
        },
        "time_count_per_day": {
          "2026-03-19": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 421.8,
          "mode_time_hours": 841.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "840-842h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-19": 1,
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-03-19": 2.6708077777777777,
            "2026-04-22": 840.9198661111111
          },
          "time_count_per_day": {
            "2026-03-19": 1,
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 421.8,
            "mode_time_hours": 841.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "840-842h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-19": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-03-19": 2.6708077777777777,
              "2026-04-22": 840.9198661111111
            },
            "time_count_per_day": {
              "2026-03-19": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 421.8,
              "mode_time_hours": 841.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "840-842h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-19": 1,
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-03-19": 2.6708077777777777,
                "2026-04-22": 840.9198661111111
              },
              "time_count_per_day": {
                "2026-03-19": 1,
                "2026-04-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_1312": {
      "overall": {
        "avg_time_hours": 45.44,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "44-46h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-20": 45.435815833333336
        },
        "time_count_per_day": {
          "2026-03-20": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 45.44,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 45.435815833333336
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 45.44,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "44-46h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-20": 45.435815833333336
            },
            "time_count_per_day": {
              "2026-03-20": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 45.44,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 45.435815833333336
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1313": {
      "overall": {
        "avg_time_hours": 26.73,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "44-46h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-20": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2026-03-20": 45.42289361111111,
          "2026-05-15": 8.039876666666666
        },
        "time_count_per_day": {
          "2026-03-20": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.04,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-15": 1
          },
          "time_per_day": {
            "2026-05-15": 8.039876666666666
          },
          "time_count_per_day": {
            "2026-05-15": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 45.42,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "44-46h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 45.42289361111111
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.73,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "44-46h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-20": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2026-03-20": 45.42289361111111,
              "2026-05-15": 8.039876666666666
            },
            "time_count_per_day": {
              "2026-03-20": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.04,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {
                "2026-05-15": 8.039876666666666
              },
              "time_count_per_day": {
                "2026-05-15": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 45.42,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "44-46h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 45.42289361111111
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1314": {
      "overall": {
        "avg_time_hours": 15.35,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-19": 1
        },
        "time_per_day": {
          "2026-03-19": 15.3466625
        },
        "time_count_per_day": {
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 15.35,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-03-19": 15.3466625
          },
          "time_count_per_day": {
            "2026-03-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.35,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-19": 1
            },
            "time_per_day": {
              "2026-03-19": 15.3466625
            },
            "time_count_per_day": {
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 15.35,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-03-19": 15.3466625
              },
              "time_count_per_day": {
                "2026-03-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1315": {
      "overall": {
        "avg_time_hours": 0.08,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-18": 1
        },
        "time_per_day": {
          "2026-03-18": 0.08409638888888889
        },
        "time_count_per_day": {
          "2026-03-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.08,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-18": 1
          },
          "time_per_day": {
            "2026-03-18": 0.08409638888888889
          },
          "time_count_per_day": {
            "2026-03-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.08,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-18": 1
            },
            "time_per_day": {
              "2026-03-18": 0.08409638888888889
            },
            "time_count_per_day": {
              "2026-03-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.08,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-18": 1
              },
              "time_per_day": {
                "2026-03-18": 0.08409638888888889
              },
              "time_count_per_day": {
                "2026-03-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1104": {
      "overall": {
        "avg_time_hours": 472.2,
        "mode_time_hours": 473.0,
        "mode_frequency": 1,
        "time_distribution": {
          "472-474h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-02-19": 1,
          "2026-03-04": 1,
          "2026-04-07": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-04-07": 472.2034513888889
        },
        "time_count_per_day": {
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 472.2,
          "mode_time_hours": 473.0,
          "mode_frequency": 1,
          "time_distribution": {
            "472-474h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-07": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-04-07": 472.2034513888889
          },
          "time_count_per_day": {
            "2026-04-07": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-02-19": 1,
            "2026-03-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 472.2,
            "mode_time_hours": 473.0,
            "mode_frequency": 1,
            "time_distribution": {
              "472-474h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-07": 1
            },
            "time_per_day": {
              "2026-04-07": 472.2034513888889
            },
            "time_count_per_day": {
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 472.2,
              "mode_time_hours": 473.0,
              "mode_frequency": 1,
              "time_distribution": {
                "472-474h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {
                "2026-04-07": 472.2034513888889
              },
              "time_count_per_day": {
                "2026-04-07": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-02-19": 1,
              "2026-03-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-02-19": 1,
                "2026-03-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "Cátia Leal": {
      "overall": {
        "avg_time_hours": 1.58,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-19": 1
        },
        "time_per_day": {
          "2026-03-19": 1.5788291666666667
        },
        "time_count_per_day": {
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-03-19": 1.5788291666666667
          },
          "time_count_per_day": {
            "2026-03-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.58,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-19": 1
            },
            "time_per_day": {
              "2026-03-19": 1.5788291666666667
            },
            "time_count_per_day": {
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-03-19": 1.5788291666666667
              },
              "time_count_per_day": {
                "2026-03-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1321": {
      "overall": {
        "avg_time_hours": 1.29,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "2-4h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-19": 2,
          "2026-05-04": 1,
          "2026-05-06": 1
        },
        "time_per_day": {
          "2026-03-19": 3.3796830555555557,
          "2026-05-04": 1.510332777777778,
          "2026-05-06": 0.26174166666666665
        },
        "time_count_per_day": {
          "2026-03-19": 2,
          "2026-05-04": 1,
          "2026-05-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "2-4h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-03-19": 2,
            "2026-05-04": 1,
            "2026-05-06": 1
          },
          "time_per_day": {
            "2026-03-19": 3.3796830555555557,
            "2026-05-04": 1.510332777777778,
            "2026-05-06": 0.26174166666666665
          },
          "time_count_per_day": {
            "2026-03-19": 2,
            "2026-05-04": 1,
            "2026-05-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.29,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "2-4h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-19": 2,
              "2026-05-04": 1,
              "2026-05-06": 1
            },
            "time_per_day": {
              "2026-03-19": 3.3796830555555557,
              "2026-05-04": 1.510332777777778,
              "2026-05-06": 0.26174166666666665
            },
            "time_count_per_day": {
              "2026-03-19": 2,
              "2026-05-04": 1,
              "2026-05-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "2-4h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-03-19": 2,
                "2026-05-04": 1,
                "2026-05-06": 1
              },
              "time_per_day": {
                "2026-03-19": 3.3796830555555557,
                "2026-05-04": 1.510332777777778,
                "2026-05-06": 0.26174166666666665
              },
              "time_count_per_day": {
                "2026-03-19": 2,
                "2026-05-04": 1,
                "2026-05-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1322": {
      "overall": {
        "avg_time_hours": 0.63,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-19": 1
        },
        "time_per_day": {
          "2026-03-19": 0.6327858333333334
        },
        "time_count_per_day": {
          "2026-03-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-19": 1
          },
          "time_per_day": {
            "2026-03-19": 0.6327858333333334
          },
          "time_count_per_day": {
            "2026-03-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.63,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-19": 1
            },
            "time_per_day": {
              "2026-03-19": 0.6327858333333334
            },
            "time_count_per_day": {
              "2026-03-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-19": 1
              },
              "time_per_day": {
                "2026-03-19": 0.6327858333333334
              },
              "time_count_per_day": {
                "2026-03-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1324": {
      "overall": {
        "avg_time_hours": 15.56,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-20": 15.558486111111112
        },
        "time_count_per_day": {
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 15.56,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 15.558486111111112
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 15.56,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-20": 15.558486111111112
            },
            "time_count_per_day": {
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 15.56,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 15.558486111111112
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1328": {
      "overall": {
        "avg_time_hours": 0.21,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-20": 0.21185305555555556
        },
        "time_count_per_day": {
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 0.21185305555555556
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.21,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-20": 0.21185305555555556
            },
            "time_count_per_day": {
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 0.21185305555555556
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1329": {
      "overall": {
        "avg_time_hours": 71.21,
        "mode_time_hours": 71.0,
        "mode_frequency": 1,
        "time_distribution": {
          "70-72h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-23": 1
        },
        "time_per_day": {
          "2026-03-23": 71.20793583333332
        },
        "time_count_per_day": {
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 71.21,
          "mode_time_hours": 71.0,
          "mode_frequency": 1,
          "time_distribution": {
            "70-72h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 71.20793583333332
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 71.21,
            "mode_time_hours": 71.0,
            "mode_frequency": 1,
            "time_distribution": {
              "70-72h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {
              "2026-03-23": 71.20793583333332
            },
            "time_count_per_day": {
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 71.21,
              "mode_time_hours": 71.0,
              "mode_frequency": 1,
              "time_distribution": {
                "70-72h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 71.20793583333332
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1330": {
      "overall": {
        "avg_time_hours": 1.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-20": 1
        },
        "time_per_day": {
          "2026-03-20": 1.245681388888889
        },
        "time_count_per_day": {
          "2026-03-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {
            "2026-03-20": 1.245681388888889
          },
          "time_count_per_day": {
            "2026-03-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-20": 1
            },
            "time_per_day": {
              "2026-03-20": 1.245681388888889
            },
            "time_count_per_day": {
              "2026-03-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-20": 1
              },
              "time_per_day": {
                "2026-03-20": 1.245681388888889
              },
              "time_count_per_day": {
                "2026-03-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1256": {
      "overall": {
        "avg_time_hours": 180.69,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "124-126h": 1,
          "594-596h": 1
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-03-20": 1,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-03-20": 1.327138611111111,
          "2026-05-13": 124.98083999999999,
          "2026-05-14": 1.024591111111111,
          "2026-06-06": 595.4249055555556
        },
        "time_count_per_day": {
          "2026-03-20": 1,
          "2026-05-13": 1,
          "2026-05-14": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-20": 1,
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-03-20": 1.327138611111111,
            "2026-05-14": 1.024591111111111
          },
          "time_count_per_day": {
            "2026-03-20": 1,
            "2026-05-14": 1
          }
        },
        "P3": {
          "avg_time_hours": 360.2,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "124-126h": 1,
            "594-596h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-13": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-05-13": 124.98083999999999,
            "2026-06-06": 595.4249055555556
          },
          "time_count_per_day": {
            "2026-05-13": 1,
            "2026-06-06": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-12": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 180.69,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "124-126h": 1,
              "594-596h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-20": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2026-03-20": 1.327138611111111,
              "2026-05-13": 124.98083999999999,
              "2026-05-14": 1.024591111111111,
              "2026-06-06": 595.4249055555556
            },
            "time_count_per_day": {
              "2026-03-20": 1,
              "2026-05-13": 1,
              "2026-05-14": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-20": 1,
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-03-20": 1.327138611111111,
                "2026-05-14": 1.024591111111111
              },
              "time_count_per_day": {
                "2026-03-20": 1,
                "2026-05-14": 1
              }
            },
            "P3": {
              "avg_time_hours": 360.2,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "124-126h": 1,
                "594-596h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-13": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2026-05-13": 124.98083999999999,
                "2026-06-06": 595.4249055555556
              },
              "time_count_per_day": {
                "2026-05-13": 1,
                "2026-06-06": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1332": {
      "overall": {
        "avg_time_hours": 16.56,
        "mode_time_hours": 33.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "32-34h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-23": 1,
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-23": 0.7196175,
          "2026-03-24": 32.40158888888889
        },
        "time_count_per_day": {
          "2026-03-23": 1,
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.72,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 0.7196175
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 32.4,
          "mode_time_hours": 33.0,
          "mode_frequency": 1,
          "time_distribution": {
            "32-34h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 32.40158888888889
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.56,
            "mode_time_hours": 33.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "32-34h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-23": 1,
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-23": 0.7196175,
              "2026-03-24": 32.40158888888889
            },
            "time_count_per_day": {
              "2026-03-23": 1,
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.72,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 0.7196175
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 32.4,
              "mode_time_hours": 33.0,
              "mode_frequency": 1,
              "time_distribution": {
                "32-34h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 32.40158888888889
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1333": {
      "overall": {
        "avg_time_hours": 0.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-23": 1
        },
        "time_per_day": {
          "2026-03-23": 0.7150466666666667
        },
        "time_count_per_day": {
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.72,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 0.7150466666666667
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {
              "2026-03-23": 0.7150466666666667
            },
            "time_count_per_day": {
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.72,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 0.7150466666666667
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1334": {
      "overall": {
        "avg_time_hours": 112.19,
        "mode_time_hours": 167.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "166-168h": 2
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-28": 1,
          "2026-03-30": 2
        },
        "time_per_day": {
          "2026-03-28": 1.0186133333333334,
          "2026-03-30": 335.5471780555556
        },
        "time_count_per_day": {
          "2026-03-28": 1,
          "2026-03-30": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 112.19,
          "mode_time_hours": 167.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "166-168h": 2
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-28": 1,
            "2026-03-30": 2
          },
          "time_per_day": {
            "2026-03-28": 1.0186133333333334,
            "2026-03-30": 335.5471780555556
          },
          "time_count_per_day": {
            "2026-03-28": 1,
            "2026-03-30": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 112.19,
            "mode_time_hours": 167.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "166-168h": 2
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-28": 1,
              "2026-03-30": 2
            },
            "time_per_day": {
              "2026-03-28": 1.0186133333333334,
              "2026-03-30": 335.5471780555556
            },
            "time_count_per_day": {
              "2026-03-28": 1,
              "2026-03-30": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 112.19,
              "mode_time_hours": 167.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "166-168h": 2
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-28": 1,
                "2026-03-30": 2
              },
              "time_per_day": {
                "2026-03-28": 1.0186133333333334,
                "2026-03-30": 335.5471780555556
              },
              "time_count_per_day": {
                "2026-03-28": 1,
                "2026-03-30": 2
              }
            }
          }
        }
      }
    },
    "cliente_1336": {
      "overall": {
        "avg_time_hours": 10.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "18-20h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-23": 1,
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-23": 0.775331388888889,
          "2026-03-24": 19.433947777777778
        },
        "time_count_per_day": {
          "2026-03-23": 1,
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.78,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 0.775331388888889
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 19.43,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 19.433947777777778
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "18-20h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-23": 1,
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-23": 0.775331388888889,
              "2026-03-24": 19.433947777777778
            },
            "time_count_per_day": {
              "2026-03-23": 1,
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.78,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 0.775331388888889
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 19.43,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 19.433947777777778
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1337": {
      "overall": {
        "avg_time_hours": 1.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-23": 1
        },
        "time_per_day": {
          "2026-03-23": 1.1771133333333335
        },
        "time_count_per_day": {
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 1.1771133333333335
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {
              "2026-03-23": 1.1771133333333335
            },
            "time_count_per_day": {
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 1.1771133333333335
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1338": {
      "overall": {
        "avg_time_hours": 31.97,
        "mode_time_hours": 31.0,
        "mode_frequency": 1,
        "time_distribution": {
          "30-32h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-24": 31.969155833333332
        },
        "time_count_per_day": {
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 31.97,
          "mode_time_hours": 31.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 31.969155833333332
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 31.97,
            "mode_time_hours": 31.0,
            "mode_frequency": 1,
            "time_distribution": {
              "30-32h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-24": 31.969155833333332
            },
            "time_count_per_day": {
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 31.97,
              "mode_time_hours": 31.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 31.969155833333332
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1343": {
      "overall": {
        "avg_time_hours": 11.79,
        "mode_time_hours": 7.0,
        "mode_frequency": 2,
        "time_distribution": {
          "4-6h": 1,
          "6-8h": 2,
          "28-30h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-24": 1,
          "2026-05-26": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-03-24": 28.99088888888889,
          "2026-05-26": 7.643913333333333,
          "2026-06-03": 6.099365833333334,
          "2026-06-05": 4.421083888888889
        },
        "time_count_per_day": {
          "2026-03-24": 1,
          "2026-05-26": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 4.42,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-06-05": 4.421083888888889
          },
          "time_count_per_day": {
            "2026-06-05": 1
          }
        },
        "P2": {
          "avg_time_hours": 14.24,
          "mode_time_hours": 7.0,
          "mode_frequency": 2,
          "time_distribution": {
            "6-8h": 2,
            "28-30h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-24": 1,
            "2026-05-26": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-03-24": 28.99088888888889,
            "2026-05-26": 7.643913333333333,
            "2026-06-03": 6.099365833333334
          },
          "time_count_per_day": {
            "2026-03-24": 1,
            "2026-05-26": 1,
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.79,
            "mode_time_hours": 7.0,
            "mode_frequency": 2,
            "time_distribution": {
              "4-6h": 1,
              "6-8h": 2,
              "28-30h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-03-24": 1,
              "2026-05-26": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-03-24": 28.99088888888889,
              "2026-05-26": 7.643913333333333,
              "2026-06-03": 6.099365833333334,
              "2026-06-05": 4.421083888888889
            },
            "time_count_per_day": {
              "2026-03-24": 1,
              "2026-05-26": 1,
              "2026-06-03": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 4.42,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-06-05": 4.421083888888889
              },
              "time_count_per_day": {
                "2026-06-05": 1
              }
            },
            "P2": {
              "avg_time_hours": 14.24,
              "mode_time_hours": 7.0,
              "mode_frequency": 2,
              "time_distribution": {
                "6-8h": 2,
                "28-30h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-24": 1,
                "2026-05-26": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-03-24": 28.99088888888889,
                "2026-05-26": 7.643913333333333,
                "2026-06-03": 6.099365833333334
              },
              "time_count_per_day": {
                "2026-03-24": 1,
                "2026-05-26": 1,
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1344": {
      "overall": {
        "avg_time_hours": 0.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-23": 1
        },
        "time_per_day": {
          "2026-03-23": 0.6463016666666667
        },
        "time_count_per_day": {
          "2026-03-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-23": 1
          },
          "time_per_day": {
            "2026-03-23": 0.6463016666666667
          },
          "time_count_per_day": {
            "2026-03-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-23": 1
            },
            "time_per_day": {
              "2026-03-23": 0.6463016666666667
            },
            "time_count_per_day": {
              "2026-03-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-23": 1
              },
              "time_per_day": {
                "2026-03-23": 0.6463016666666667
              },
              "time_count_per_day": {
                "2026-03-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1345": {
      "overall": {
        "avg_time_hours": 0.83,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-23": 1,
          "2026-03-26": 1
        },
        "time_per_day": {
          "2026-03-23": 1.501991111111111,
          "2026-03-26": 0.14865777777777778
        },
        "time_count_per_day": {
          "2026-03-23": 1,
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-23": 1,
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-23": 1.501991111111111,
            "2026-03-26": 0.14865777777777778
          },
          "time_count_per_day": {
            "2026-03-23": 1,
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.83,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-23": 1,
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-23": 1.501991111111111,
              "2026-03-26": 0.14865777777777778
            },
            "time_count_per_day": {
              "2026-03-23": 1,
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-23": 1,
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-23": 1.501991111111111,
                "2026-03-26": 0.14865777777777778
              },
              "time_count_per_day": {
                "2026-03-23": 1,
                "2026-03-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1348": {
      "overall": {
        "avg_time_hours": 8.43,
        "mode_time_hours": 9.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-24": 8.425044166666666
        },
        "time_count_per_day": {
          "2026-03-24": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 8.43,
          "mode_time_hours": 9.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 8.425044166666666
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.43,
            "mode_time_hours": 9.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-24": 8.425044166666666
            },
            "time_count_per_day": {
              "2026-03-24": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 8.43,
              "mode_time_hours": 9.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 8.425044166666666
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1349": {
      "overall": {
        "avg_time_hours": 0.58,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-24": 0.578066388888889
        },
        "time_count_per_day": {
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.58,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 0.578066388888889
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.58,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-24": 0.578066388888889
            },
            "time_count_per_day": {
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.58,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 0.578066388888889
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1352": {
      "overall": {
        "avg_time_hours": 0.48,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-24": 0.4838744444444445
        },
        "time_count_per_day": {
          "2026-03-24": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 0.48,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 0.4838744444444445
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.48,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-24": 0.4838744444444445
            },
            "time_count_per_day": {
              "2026-03-24": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 0.48,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 0.4838744444444445
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1353": {
      "overall": {
        "avg_time_hours": 1.46,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-24": 1
        },
        "time_per_day": {
          "2026-03-24": 1.4577266666666666
        },
        "time_count_per_day": {
          "2026-03-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-24": 1
          },
          "time_per_day": {
            "2026-03-24": 1.4577266666666666
          },
          "time_count_per_day": {
            "2026-03-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.46,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-24": 1
            },
            "time_per_day": {
              "2026-03-24": 1.4577266666666666
            },
            "time_count_per_day": {
              "2026-03-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-24": 1
              },
              "time_per_day": {
                "2026-03-24": 1.4577266666666666
              },
              "time_count_per_day": {
                "2026-03-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1354": {
      "overall": {
        "avg_time_hours": 16.98,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-25": 1
        },
        "time_per_day": {
          "2026-03-25": 16.975569166666666
        },
        "time_count_per_day": {
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.98,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-25": 16.975569166666666
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.98,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {
              "2026-03-25": 16.975569166666666
            },
            "time_count_per_day": {
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.98,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 16.975569166666666
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1355": {
      "overall": {
        "avg_time_hours": 1.59,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-25": 1
        },
        "time_per_day": {
          "2026-03-25": 1.591758888888889
        },
        "time_count_per_day": {
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.59,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-25": 1.591758888888889
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.59,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {
              "2026-03-25": 1.591758888888889
            },
            "time_count_per_day": {
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.59,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 1.591758888888889
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1347": {
      "overall": {
        "avg_time_hours": 1.59,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-25": 1
        },
        "time_per_day": {
          "2026-03-25": 1.594553888888889
        },
        "time_count_per_day": {
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.59,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-25": 1.594553888888889
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.59,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {
              "2026-03-25": 1.594553888888889
            },
            "time_count_per_day": {
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.59,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 1.594553888888889
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1356": {
      "overall": {
        "avg_time_hours": 10.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3,
          "18-20h": 1,
          "28-30h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-03-25": 1,
          "2026-04-10": 1,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-29": 1,
          "2026-05-28": 2,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-03-25": 1.3167680555555554,
          "2026-04-10": 19.203788055555556,
          "2026-04-16": 29.11146861111111,
          "2026-04-22": 0.17189583333333336,
          "2026-04-29": 0.3328452777777778
        },
        "time_count_per_day": {
          "2026-03-25": 1,
          "2026-04-10": 1,
          "2026-04-16": 1,
          "2026-04-22": 1,
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3,
            "18-20h": 1,
            "28-30h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-03-25": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-04-29": 1,
            "2026-05-28": 2,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-03-25": 1.3167680555555554,
            "2026-04-10": 19.203788055555556,
            "2026-04-16": 29.11146861111111,
            "2026-04-22": 0.17189583333333336,
            "2026-04-29": 0.3328452777777778
          },
          "time_count_per_day": {
            "2026-03-25": 1,
            "2026-04-10": 1,
            "2026-04-16": 1,
            "2026-04-22": 1,
            "2026-04-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3,
              "18-20h": 1,
              "28-30h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-03-25": 1,
              "2026-04-10": 1,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-03-25": 1.3167680555555554,
              "2026-04-10": 19.203788055555556,
              "2026-04-16": 29.11146861111111,
              "2026-04-22": 0.17189583333333336,
              "2026-04-29": 0.3328452777777778
            },
            "time_count_per_day": {
              "2026-03-25": 1,
              "2026-04-10": 1,
              "2026-04-16": 1,
              "2026-04-22": 1,
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3,
                "18-20h": 1,
                "28-30h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-03-25": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-03-25": 1.3167680555555554,
                "2026-04-10": 19.203788055555556,
                "2026-04-16": 29.11146861111111,
                "2026-04-22": 0.17189583333333336,
                "2026-04-29": 0.3328452777777778
              },
              "time_count_per_day": {
                "2026-03-25": 1,
                "2026-04-10": 1,
                "2026-04-16": 1,
                "2026-04-22": 1,
                "2026-04-29": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-28": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-28": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1357": {
      "overall": {
        "avg_time_hours": 1.47,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-25": 2
        },
        "time_per_day": {
          "2026-03-25": 1.4659622222222222
        },
        "time_count_per_day": {
          "2026-03-25": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 1.47,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-25": 2
          },
          "time_per_day": {
            "2026-03-25": 1.4659622222222222
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.47,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {
              "2026-03-25": 1.4659622222222222
            },
            "time_count_per_day": {
              "2026-03-25": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 1.47,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 1.4659622222222222
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1358": {
      "overall": {
        "avg_time_hours": 0.46,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-25": 1
        },
        "time_per_day": {
          "2026-03-25": 0.46455722222222223
        },
        "time_count_per_day": {
          "2026-03-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {
            "2026-03-25": 0.46455722222222223
          },
          "time_count_per_day": {
            "2026-03-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.46,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {
              "2026-03-25": 0.46455722222222223
            },
            "time_count_per_day": {
              "2026-03-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {
                "2026-03-25": 0.46455722222222223
              },
              "time_count_per_day": {
                "2026-03-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1245": {
      "overall": {
        "avg_time_hours": 205.17,
        "mode_time_hours": 401.0,
        "mode_frequency": 1,
        "time_distribution": {
          "8-10h": 1,
          "400-402h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-11": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-04-11": 400.4879761111111,
          "2026-06-05": 9.846257777777778
        },
        "time_count_per_day": {
          "2026-04-11": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 205.17,
          "mode_time_hours": 401.0,
          "mode_frequency": 1,
          "time_distribution": {
            "8-10h": 1,
            "400-402h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-11": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-04-11": 400.4879761111111,
            "2026-06-05": 9.846257777777778
          },
          "time_count_per_day": {
            "2026-04-11": 1,
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 205.17,
            "mode_time_hours": 401.0,
            "mode_frequency": 1,
            "time_distribution": {
              "8-10h": 1,
              "400-402h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-11": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-04-11": 400.4879761111111,
              "2026-06-05": 9.846257777777778
            },
            "time_count_per_day": {
              "2026-04-11": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 205.17,
              "mode_time_hours": 401.0,
              "mode_frequency": 1,
              "time_distribution": {
                "8-10h": 1,
                "400-402h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-11": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-04-11": 400.4879761111111,
                "2026-06-05": 9.846257777777778
              },
              "time_count_per_day": {
                "2026-04-11": 1,
                "2026-06-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1364": {
      "overall": {
        "avg_time_hours": 16.41,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-26": 1
        },
        "time_per_day": {
          "2026-03-26": 16.411907222222222
        },
        "time_count_per_day": {
          "2026-03-26": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 16.41,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 16.411907222222222
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.41,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-26": 16.411907222222222
            },
            "time_count_per_day": {
              "2026-03-26": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 16.41,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 16.411907222222222
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1365": {
      "overall": {
        "avg_time_hours": 14.6,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-26": 1
        },
        "time_per_day": {
          "2026-03-26": 14.601168055555556
        },
        "time_count_per_day": {
          "2026-03-26": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 14.6,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 14.601168055555556
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.6,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-26": 14.601168055555556
            },
            "time_count_per_day": {
              "2026-03-26": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 14.6,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 14.601168055555556
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1366": {
      "overall": {
        "avg_time_hours": 684.44,
        "mode_time_hours": 685.0,
        "mode_frequency": 1,
        "time_distribution": {
          "684-686h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 684.4372652777777
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 684.44,
          "mode_time_hours": 685.0,
          "mode_frequency": 1,
          "time_distribution": {
            "684-686h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 684.4372652777777
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 684.44,
            "mode_time_hours": 685.0,
            "mode_frequency": 1,
            "time_distribution": {
              "684-686h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 684.4372652777777
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 684.44,
              "mode_time_hours": 685.0,
              "mode_frequency": 1,
              "time_distribution": {
                "684-686h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 684.4372652777777
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_97": {
      "overall": {
        "avg_time_hours": 0.46,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-26": 1
        },
        "time_per_day": {
          "2026-03-26": 0.4638947222222222
        },
        "time_count_per_day": {
          "2026-03-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-26": 1
          },
          "time_per_day": {
            "2026-03-26": 0.4638947222222222
          },
          "time_count_per_day": {
            "2026-03-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.46,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-26": 1
            },
            "time_per_day": {
              "2026-03-26": 0.4638947222222222
            },
            "time_count_per_day": {
              "2026-03-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-26": 1
              },
              "time_per_day": {
                "2026-03-26": 0.4638947222222222
              },
              "time_count_per_day": {
                "2026-03-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1374": {
      "overall": {
        "avg_time_hours": 0.63,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-27": 1,
          "2026-05-07": 1,
          "2026-05-09": 1
        },
        "time_per_day": {
          "2026-03-27": 0.24417583333333334,
          "2026-05-07": 1.6206283333333333,
          "2026-05-09": 0.024285
        },
        "time_count_per_day": {
          "2026-03-27": 1,
          "2026-05-07": 1,
          "2026-05-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.63,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-27": 1,
            "2026-05-07": 1,
            "2026-05-09": 1
          },
          "time_per_day": {
            "2026-03-27": 0.24417583333333334,
            "2026-05-07": 1.6206283333333333,
            "2026-05-09": 0.024285
          },
          "time_count_per_day": {
            "2026-03-27": 1,
            "2026-05-07": 1,
            "2026-05-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.63,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-03-27": 1,
              "2026-05-07": 1,
              "2026-05-09": 1
            },
            "time_per_day": {
              "2026-03-27": 0.24417583333333334,
              "2026-05-07": 1.6206283333333333,
              "2026-05-09": 0.024285
            },
            "time_count_per_day": {
              "2026-03-27": 1,
              "2026-05-07": 1,
              "2026-05-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.63,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-03-27": 1,
                "2026-05-07": 1,
                "2026-05-09": 1
              },
              "time_per_day": {
                "2026-03-27": 0.24417583333333334,
                "2026-05-07": 1.6206283333333333,
                "2026-05-09": 0.024285
              },
              "time_count_per_day": {
                "2026-03-27": 1,
                "2026-05-07": 1,
                "2026-05-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1375": {
      "overall": {
        "avg_time_hours": 4.06,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-27": 1
        },
        "time_per_day": {
          "2026-03-27": 4.0583905555555555
        },
        "time_count_per_day": {
          "2026-03-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.06,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-27": 1
          },
          "time_per_day": {
            "2026-03-27": 4.0583905555555555
          },
          "time_count_per_day": {
            "2026-03-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.06,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-27": 1
            },
            "time_per_day": {
              "2026-03-27": 4.0583905555555555
            },
            "time_count_per_day": {
              "2026-03-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.06,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-27": 1
              },
              "time_per_day": {
                "2026-03-27": 4.0583905555555555
              },
              "time_count_per_day": {
                "2026-03-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1378": {
      "overall": {
        "avg_time_hours": 442.22,
        "mode_time_hours": 655.0,
        "mode_frequency": 1,
        "time_distribution": {
          "328-330h": 1,
          "342-344h": 1,
          "654-656h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-23": 1,
          "2026-05-20": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-04-23": 654.1966641666667,
          "2026-05-20": 329.84872472222224,
          "2026-06-03": 342.61654416666664
        },
        "time_count_per_day": {
          "2026-04-23": 1,
          "2026-05-20": 1,
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 442.22,
          "mode_time_hours": 655.0,
          "mode_frequency": 1,
          "time_distribution": {
            "328-330h": 1,
            "342-344h": 1,
            "654-656h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-23": 1,
            "2026-05-20": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-04-23": 654.1966641666667,
            "2026-05-20": 329.84872472222224,
            "2026-06-03": 342.61654416666664
          },
          "time_count_per_day": {
            "2026-04-23": 1,
            "2026-05-20": 1,
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 442.22,
            "mode_time_hours": 655.0,
            "mode_frequency": 1,
            "time_distribution": {
              "328-330h": 1,
              "342-344h": 1,
              "654-656h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-23": 1,
              "2026-05-20": 1,
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-04-23": 654.1966641666667,
              "2026-05-20": 329.84872472222224,
              "2026-06-03": 342.61654416666664
            },
            "time_count_per_day": {
              "2026-04-23": 1,
              "2026-05-20": 1,
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 442.22,
              "mode_time_hours": 655.0,
              "mode_frequency": 1,
              "time_distribution": {
                "328-330h": 1,
                "342-344h": 1,
                "654-656h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-05-20": 1,
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-04-23": 654.1966641666667,
                "2026-05-20": 329.84872472222224,
                "2026-06-03": 342.61654416666664
              },
              "time_count_per_day": {
                "2026-04-23": 1,
                "2026-05-20": 1,
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1379": {
      "overall": {
        "avg_time_hours": 32.81,
        "mode_time_hours": 65.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "64-66h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-28": 1,
          "2026-03-30": 1
        },
        "time_per_day": {
          "2026-03-28": 1.009388888888889,
          "2026-03-30": 64.61810861111111
        },
        "time_count_per_day": {
          "2026-03-28": 1,
          "2026-03-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-28": 1
          },
          "time_per_day": {
            "2026-03-28": 1.009388888888889
          },
          "time_count_per_day": {
            "2026-03-28": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 64.62,
          "mode_time_hours": 65.0,
          "mode_frequency": 1,
          "time_distribution": {
            "64-66h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-30": 1
          },
          "time_per_day": {
            "2026-03-30": 64.61810861111111
          },
          "time_count_per_day": {
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 32.81,
            "mode_time_hours": 65.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "64-66h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-28": 1,
              "2026-03-30": 1
            },
            "time_per_day": {
              "2026-03-28": 1.009388888888889,
              "2026-03-30": 64.61810861111111
            },
            "time_count_per_day": {
              "2026-03-28": 1,
              "2026-03-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-28": 1
              },
              "time_per_day": {
                "2026-03-28": 1.009388888888889
              },
              "time_count_per_day": {
                "2026-03-28": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 64.62,
              "mode_time_hours": 65.0,
              "mode_frequency": 1,
              "time_distribution": {
                "64-66h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-03-30": 64.61810861111111
              },
              "time_count_per_day": {
                "2026-03-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1369": {
      "overall": {
        "avg_time_hours": 60.62,
        "mode_time_hours": 61.0,
        "mode_frequency": 1,
        "time_distribution": {
          "60-62h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-03-26": 1,
          "2026-03-31": 1,
          "2026-04-20": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-03-31": 60.62449388888889
        },
        "time_count_per_day": {
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 60.62,
          "mode_time_hours": 61.0,
          "mode_frequency": 1,
          "time_distribution": {
            "60-62h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-31": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-03-31": 60.62449388888889
          },
          "time_count_per_day": {
            "2026-03-31": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-26": 1,
            "2026-05-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 60.62,
            "mode_time_hours": 61.0,
            "mode_frequency": 1,
            "time_distribution": {
              "60-62h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-31": 1
            },
            "time_per_day": {
              "2026-03-31": 60.62449388888889
            },
            "time_count_per_day": {
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 60.62,
              "mode_time_hours": 61.0,
              "mode_frequency": 1,
              "time_distribution": {
                "60-62h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-03-31": 60.62449388888889
              },
              "time_count_per_day": {
                "2026-03-31": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-26": 1,
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-26": 1,
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1383": {
      "overall": {
        "avg_time_hours": 4.76,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-30": 1
        },
        "time_per_day": {
          "2026-03-30": 4.764713055555556
        },
        "time_count_per_day": {
          "2026-03-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.76,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-30": 1
          },
          "time_per_day": {
            "2026-03-30": 4.764713055555556
          },
          "time_count_per_day": {
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.76,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-30": 1
            },
            "time_per_day": {
              "2026-03-30": 4.764713055555556
            },
            "time_count_per_day": {
              "2026-03-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.76,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-03-30": 4.764713055555556
              },
              "time_count_per_day": {
                "2026-03-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1385": {
      "overall": {
        "avg_time_hours": 8.66,
        "mode_time_hours": 9.0,
        "mode_frequency": 2,
        "time_distribution": {
          "8-10h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-03-30": 2
        },
        "time_per_day": {
          "2026-03-30": 17.32219472222222
        },
        "time_count_per_day": {
          "2026-03-30": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.66,
          "mode_time_hours": 9.0,
          "mode_frequency": 2,
          "time_distribution": {
            "8-10h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-03-30": 2
          },
          "time_per_day": {
            "2026-03-30": 17.32219472222222
          },
          "time_count_per_day": {
            "2026-03-30": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.66,
            "mode_time_hours": 9.0,
            "mode_frequency": 2,
            "time_distribution": {
              "8-10h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-30": 2
            },
            "time_per_day": {
              "2026-03-30": 17.32219472222222
            },
            "time_count_per_day": {
              "2026-03-30": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.66,
              "mode_time_hours": 9.0,
              "mode_frequency": 2,
              "time_distribution": {
                "8-10h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-30": 2
              },
              "time_per_day": {
                "2026-03-30": 17.32219472222222
              },
              "time_count_per_day": {
                "2026-03-30": 2
              }
            }
          }
        }
      }
    },
    "cliente_1386": {
      "overall": {
        "avg_time_hours": 7.22,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-30": 1
        },
        "time_per_day": {
          "2026-03-30": 7.2237986111111105
        },
        "time_count_per_day": {
          "2026-03-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 7.22,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-30": 1
          },
          "time_per_day": {
            "2026-03-30": 7.2237986111111105
          },
          "time_count_per_day": {
            "2026-03-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 7.22,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-30": 1
            },
            "time_per_day": {
              "2026-03-30": 7.2237986111111105
            },
            "time_count_per_day": {
              "2026-03-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 7.22,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-30": 1
              },
              "time_per_day": {
                "2026-03-30": 7.2237986111111105
              },
              "time_count_per_day": {
                "2026-03-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1389": {
      "overall": {
        "avg_time_hours": 22.65,
        "mode_time_hours": 45.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "44-46h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-01": 2
        },
        "time_per_day": {
          "2026-04-01": 45.297820833333326
        },
        "time_count_per_day": {
          "2026-04-01": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 22.65,
          "mode_time_hours": 45.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "44-46h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-01": 2
          },
          "time_per_day": {
            "2026-04-01": 45.297820833333326
          },
          "time_count_per_day": {
            "2026-04-01": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 22.65,
            "mode_time_hours": 45.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "44-46h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-01": 2
            },
            "time_per_day": {
              "2026-04-01": 45.297820833333326
            },
            "time_count_per_day": {
              "2026-04-01": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 22.65,
              "mode_time_hours": 45.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "44-46h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-01": 2
              },
              "time_per_day": {
                "2026-04-01": 45.297820833333326
              },
              "time_count_per_day": {
                "2026-04-01": 2
              }
            }
          }
        }
      }
    },
    "cliente_754": {
      "overall": {
        "avg_time_hours": 2.37,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-31": 1
        },
        "time_per_day": {
          "2026-03-31": 2.3679005555555555
        },
        "time_count_per_day": {
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.37,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-03-31": 2.3679005555555555
          },
          "time_count_per_day": {
            "2026-03-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.37,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-31": 1
            },
            "time_per_day": {
              "2026-03-31": 2.3679005555555555
            },
            "time_count_per_day": {
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.37,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-03-31": 2.3679005555555555
              },
              "time_count_per_day": {
                "2026-03-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_1392": {
      "overall": {
        "avg_time_hours": 1.98,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-31": 1
        },
        "time_per_day": {
          "2026-03-31": 1.9779886111111111
        },
        "time_count_per_day": {
          "2026-03-31": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 1.98,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-31": 1
          },
          "time_per_day": {
            "2026-03-31": 1.9779886111111111
          },
          "time_count_per_day": {
            "2026-03-31": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.98,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-31": 1
            },
            "time_per_day": {
              "2026-03-31": 1.9779886111111111
            },
            "time_count_per_day": {
              "2026-03-31": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 1.98,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-31": 1
              },
              "time_per_day": {
                "2026-03-31": 1.9779886111111111
              },
              "time_count_per_day": {
                "2026-03-31": 1
              }
            }
          }
        }
      }
    },
    "cliente_1394": {
      "overall": {
        "avg_time_hours": 1.37,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-01": 1
        },
        "time_per_day": {
          "2026-04-01": 1.3715172222222223
        },
        "time_count_per_day": {
          "2026-04-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.37,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-01": 1
          },
          "time_per_day": {
            "2026-04-01": 1.3715172222222223
          },
          "time_count_per_day": {
            "2026-04-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.37,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-01": 1
            },
            "time_per_day": {
              "2026-04-01": 1.3715172222222223
            },
            "time_count_per_day": {
              "2026-04-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.37,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-01": 1
              },
              "time_per_day": {
                "2026-04-01": 1.3715172222222223
              },
              "time_count_per_day": {
                "2026-04-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1396": {
      "overall": {
        "avg_time_hours": 9.59,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "14-16h": 1,
          "20-22h": 1
        },
        "tickets_count": 8,
        "tickets_per_day": {
          "2026-04-02": 1,
          "2026-05-18": 2,
          "2026-05-27": 1,
          "2026-05-29": 2,
          "2026-06-03": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-04-02": 14.101495,
          "2026-05-18": 20.22263361111111,
          "2026-05-29": 4.0555441666666665
        },
        "time_count_per_day": {
          "2026-04-02": 1,
          "2026-05-18": 1,
          "2026-05-29": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 9.59,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1,
            "20-22h": 1
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-04-02": 1,
            "2026-05-18": 2,
            "2026-05-29": 2,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-04-02": 14.101495,
            "2026-05-18": 20.22263361111111,
            "2026-05-29": 4.0555441666666665
          },
          "time_count_per_day": {
            "2026-04-02": 1,
            "2026-05-18": 1,
            "2026-05-29": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-27": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 9.59,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "14-16h": 1,
              "20-22h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-02": 1,
              "2026-05-18": 1,
              "2026-05-29": 2
            },
            "time_per_day": {
              "2026-04-02": 14.101495,
              "2026-05-18": 20.22263361111111,
              "2026-05-29": 4.0555441666666665
            },
            "time_count_per_day": {
              "2026-04-02": 1,
              "2026-05-18": 1,
              "2026-05-29": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 9.59,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1,
                "20-22h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-02": 1,
                "2026-05-18": 1,
                "2026-05-29": 2
              },
              "time_per_day": {
                "2026-04-02": 14.101495,
                "2026-05-18": 20.22263361111111,
                "2026-05-29": 4.0555441666666665
              },
              "time_count_per_day": {
                "2026-04-02": 1,
                "2026-05-18": 1,
                "2026-05-29": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-18": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1398": {
      "overall": {
        "avg_time_hours": 0.56,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-01": 1
        },
        "time_per_day": {
          "2026-04-01": 0.5582277777777778
        },
        "time_count_per_day": {
          "2026-04-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.56,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-01": 1
          },
          "time_per_day": {
            "2026-04-01": 0.5582277777777778
          },
          "time_count_per_day": {
            "2026-04-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.56,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-01": 1
            },
            "time_per_day": {
              "2026-04-01": 0.5582277777777778
            },
            "time_count_per_day": {
              "2026-04-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.56,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-01": 1
              },
              "time_per_day": {
                "2026-04-01": 0.5582277777777778
              },
              "time_count_per_day": {
                "2026-04-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1401": {
      "overall": {
        "avg_time_hours": 0.12,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-02": 1
        },
        "time_per_day": {
          "2026-04-02": 0.11821777777777778
        },
        "time_count_per_day": {
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.12,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-04-02": 0.11821777777777778
          },
          "time_count_per_day": {
            "2026-04-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.12,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {
              "2026-04-02": 0.11821777777777778
            },
            "time_count_per_day": {
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.12,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-04-02": 0.11821777777777778
              },
              "time_count_per_day": {
                "2026-04-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1402": {
      "overall": {
        "avg_time_hours": 0.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-02": 1
        },
        "time_per_day": {
          "2026-04-02": 0.12661
        },
        "time_count_per_day": {
          "2026-04-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-02": 1
          },
          "time_per_day": {
            "2026-04-02": 0.12661
          },
          "time_count_per_day": {
            "2026-04-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {
              "2026-04-02": 0.12661
            },
            "time_count_per_day": {
              "2026-04-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {
                "2026-04-02": 0.12661
              },
              "time_count_per_day": {
                "2026-04-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1403": {
      "overall": {
        "avg_time_hours": 3.5,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-04": 1
        },
        "time_per_day": {
          "2026-04-04": 3.5049966666666665
        },
        "time_count_per_day": {
          "2026-04-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.5,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-04": 1
          },
          "time_per_day": {
            "2026-04-04": 3.5049966666666665
          },
          "time_count_per_day": {
            "2026-04-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.5,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-04": 1
            },
            "time_per_day": {
              "2026-04-04": 3.5049966666666665
            },
            "time_count_per_day": {
              "2026-04-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.5,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-04": 1
              },
              "time_per_day": {
                "2026-04-04": 3.5049966666666665
              },
              "time_count_per_day": {
                "2026-04-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1405": {
      "overall": {
        "avg_time_hours": 381.82,
        "mode_time_hours": 381.0,
        "mode_frequency": 1,
        "time_distribution": {
          "380-382h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-20": 1
        },
        "time_per_day": {
          "2026-04-20": 381.8180936111111
        },
        "time_count_per_day": {
          "2026-04-20": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 381.82,
          "mode_time_hours": 381.0,
          "mode_frequency": 1,
          "time_distribution": {
            "380-382h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-20": 381.8180936111111
          },
          "time_count_per_day": {
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 381.82,
            "mode_time_hours": 381.0,
            "mode_frequency": 1,
            "time_distribution": {
              "380-382h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {
              "2026-04-20": 381.8180936111111
            },
            "time_count_per_day": {
              "2026-04-20": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 381.82,
              "mode_time_hours": 381.0,
              "mode_frequency": 1,
              "time_distribution": {
                "380-382h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-20": 381.8180936111111
              },
              "time_count_per_day": {
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1406": {
      "overall": {
        "avg_time_hours": 6.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "14-16h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-04": 1,
          "2026-05-09": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-04-04": 0.015506111111111111,
          "2026-05-09": 14.831625833333334,
          "2026-06-05": 3.254223611111111
        },
        "time_count_per_day": {
          "2026-04-04": 1,
          "2026-05-09": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "14-16h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-04": 1,
            "2026-05-09": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-04-04": 0.015506111111111111,
            "2026-05-09": 14.831625833333334,
            "2026-06-05": 3.254223611111111
          },
          "time_count_per_day": {
            "2026-04-04": 1,
            "2026-05-09": 1,
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "14-16h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-04": 1,
              "2026-05-09": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-04-04": 0.015506111111111111,
              "2026-05-09": 14.831625833333334,
              "2026-06-05": 3.254223611111111
            },
            "time_count_per_day": {
              "2026-04-04": 1,
              "2026-05-09": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "14-16h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-04": 1,
                "2026-05-09": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-04-04": 0.015506111111111111,
                "2026-05-09": 14.831625833333334,
                "2026-06-05": 3.254223611111111
              },
              "time_count_per_day": {
                "2026-04-04": 1,
                "2026-05-09": 1,
                "2026-06-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1408": {
      "overall": {
        "avg_time_hours": 1.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-06": 1
        },
        "time_per_day": {
          "2026-04-06": 1.1295913888888889
        },
        "time_count_per_day": {
          "2026-04-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-06": 1
          },
          "time_per_day": {
            "2026-04-06": 1.1295913888888889
          },
          "time_count_per_day": {
            "2026-04-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-06": 1
            },
            "time_per_day": {
              "2026-04-06": 1.1295913888888889
            },
            "time_count_per_day": {
              "2026-04-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {
                "2026-04-06": 1.1295913888888889
              },
              "time_count_per_day": {
                "2026-04-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1410": {
      "overall": {
        "avg_time_hours": 142.07,
        "mode_time_hours": 41.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "14-16h": 1,
          "16-18h": 1,
          "18-20h": 1,
          "40-42h": 2,
          "58-60h": 1,
          "142-144h": 1,
          "256-258h": 1,
          "358-360h": 1,
          "414-416h": 1,
          "616-618h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2026-04-23": 2,
          "2026-04-27": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-07": 2,
          "2026-05-08": 2,
          "2026-05-09": 2,
          "2026-05-21": 1,
          "2026-06-05": 2
        },
        "time_per_day": {
          "2026-04-23": 774.4603255555555,
          "2026-04-27": 82.23810555555556,
          "2026-05-05": 617.3823344444445,
          "2026-05-06": 257.9225536111111,
          "2026-05-07": 1.2677975,
          "2026-05-08": 157.7172336111111,
          "2026-05-09": 76.56117499999999,
          "2026-05-21": 18.680736666666668,
          "2026-06-05": 2.7195855555555557
        },
        "time_count_per_day": {
          "2026-04-23": 2,
          "2026-04-27": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-07": 2,
          "2026-05-08": 2,
          "2026-05-09": 2,
          "2026-05-21": 1,
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 125.34,
          "mode_time_hours": 41.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "14-16h": 1,
            "16-18h": 1,
            "18-20h": 1,
            "40-42h": 2,
            "58-60h": 1,
            "142-144h": 1,
            "256-258h": 1,
            "414-416h": 1,
            "616-618h": 1
          },
          "tickets_count": 14,
          "tickets_per_day": {
            "2026-04-23": 1,
            "2026-04-27": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-07": 2,
            "2026-05-08": 2,
            "2026-05-09": 2,
            "2026-05-21": 1,
            "2026-06-05": 2
          },
          "time_per_day": {
            "2026-04-23": 414.9591708333333,
            "2026-04-27": 82.23810555555556,
            "2026-05-05": 617.3823344444445,
            "2026-05-06": 257.9225536111111,
            "2026-05-07": 1.2677975,
            "2026-05-08": 157.7172336111111,
            "2026-05-09": 76.56117499999999,
            "2026-05-21": 18.680736666666668,
            "2026-06-05": 2.7195855555555557
          },
          "time_count_per_day": {
            "2026-04-23": 1,
            "2026-04-27": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-07": 2,
            "2026-05-08": 2,
            "2026-05-09": 2,
            "2026-05-21": 1,
            "2026-06-05": 1
          }
        },
        "P3": {
          "avg_time_hours": 359.5,
          "mode_time_hours": 359.0,
          "mode_frequency": 1,
          "time_distribution": {
            "358-360h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 359.50115472222217
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 142.07,
            "mode_time_hours": 41.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "14-16h": 1,
              "16-18h": 1,
              "18-20h": 1,
              "40-42h": 2,
              "58-60h": 1,
              "142-144h": 1,
              "256-258h": 1,
              "358-360h": 1,
              "414-416h": 1,
              "616-618h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2026-04-23": 2,
              "2026-04-27": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 2,
              "2026-05-08": 2,
              "2026-05-09": 2,
              "2026-05-21": 1,
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-04-23": 774.4603255555555,
              "2026-04-27": 82.23810555555556,
              "2026-05-05": 617.3823344444445,
              "2026-05-06": 257.9225536111111,
              "2026-05-07": 1.2677975,
              "2026-05-08": 157.7172336111111,
              "2026-05-09": 76.56117499999999,
              "2026-05-21": 18.680736666666668,
              "2026-06-05": 2.7195855555555557
            },
            "time_count_per_day": {
              "2026-04-23": 2,
              "2026-04-27": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-07": 2,
              "2026-05-08": 2,
              "2026-05-09": 2,
              "2026-05-21": 1,
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 125.34,
              "mode_time_hours": 41.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "14-16h": 1,
                "16-18h": 1,
                "18-20h": 1,
                "40-42h": 2,
                "58-60h": 1,
                "142-144h": 1,
                "256-258h": 1,
                "414-416h": 1,
                "616-618h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-04-27": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-08": 2,
                "2026-05-09": 2,
                "2026-05-21": 1,
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-04-23": 414.9591708333333,
                "2026-04-27": 82.23810555555556,
                "2026-05-05": 617.3823344444445,
                "2026-05-06": 257.9225536111111,
                "2026-05-07": 1.2677975,
                "2026-05-08": 157.7172336111111,
                "2026-05-09": 76.56117499999999,
                "2026-05-21": 18.680736666666668,
                "2026-06-05": 2.7195855555555557
              },
              "time_count_per_day": {
                "2026-04-23": 1,
                "2026-04-27": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-07": 2,
                "2026-05-08": 2,
                "2026-05-09": 2,
                "2026-05-21": 1,
                "2026-06-05": 1
              }
            },
            "P3": {
              "avg_time_hours": 359.5,
              "mode_time_hours": 359.0,
              "mode_frequency": 1,
              "time_distribution": {
                "358-360h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 359.50115472222217
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1413": {
      "overall": {
        "avg_time_hours": 0.0,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-07": 1
        },
        "time_per_day": {
          "2026-04-07": 2.7777777777777776e-07
        },
        "time_count_per_day": {
          "2026-04-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.0,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-07": 1
          },
          "time_per_day": {
            "2026-04-07": 2.7777777777777776e-07
          },
          "time_count_per_day": {
            "2026-04-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.0,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-07": 1
            },
            "time_per_day": {
              "2026-04-07": 2.7777777777777776e-07
            },
            "time_count_per_day": {
              "2026-04-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.0,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {
                "2026-04-07": 2.7777777777777776e-07
              },
              "time_count_per_day": {
                "2026-04-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1414": {
      "overall": {
        "avg_time_hours": 126.6,
        "mode_time_hours": 361.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1,
          "48-50h": 1,
          "72-74h": 1,
          "360-362h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-10": 1,
          "2026-04-13": 1,
          "2026-04-20": 1,
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-04-10": 24.153291944444444,
          "2026-04-13": 72.16941777777778,
          "2026-04-20": 49.120599722222224,
          "2026-04-22": 360.95290388888884
        },
        "time_count_per_day": {
          "2026-04-10": 1,
          "2026-04-13": 1,
          "2026-04-20": 1,
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.48,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1,
            "48-50h": 1,
            "72-74h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-10": 1,
            "2026-04-13": 1,
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-10": 24.153291944444444,
            "2026-04-13": 72.16941777777778,
            "2026-04-20": 49.120599722222224
          },
          "time_count_per_day": {
            "2026-04-10": 1,
            "2026-04-13": 1,
            "2026-04-20": 1
          }
        },
        "P3": {
          "avg_time_hours": 360.95,
          "mode_time_hours": 361.0,
          "mode_frequency": 1,
          "time_distribution": {
            "360-362h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-04-22": 360.95290388888884
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 126.6,
            "mode_time_hours": 361.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1,
              "48-50h": 1,
              "72-74h": 1,
              "360-362h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-10": 1,
              "2026-04-13": 1,
              "2026-04-20": 1,
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-04-10": 24.153291944444444,
              "2026-04-13": 72.16941777777778,
              "2026-04-20": 49.120599722222224,
              "2026-04-22": 360.95290388888884
            },
            "time_count_per_day": {
              "2026-04-10": 1,
              "2026-04-13": 1,
              "2026-04-20": 1,
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.48,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1,
                "48-50h": 1,
                "72-74h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-10": 1,
                "2026-04-13": 1,
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-10": 24.153291944444444,
                "2026-04-13": 72.16941777777778,
                "2026-04-20": 49.120599722222224
              },
              "time_count_per_day": {
                "2026-04-10": 1,
                "2026-04-13": 1,
                "2026-04-20": 1
              }
            },
            "P3": {
              "avg_time_hours": 360.95,
              "mode_time_hours": 361.0,
              "mode_frequency": 1,
              "time_distribution": {
                "360-362h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 360.95290388888884
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_1415": {
      "overall": {
        "avg_time_hours": 29.77,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1,
          "6-8h": 1,
          "10-12h": 1,
          "12-14h": 1,
          "16-18h": 1,
          "38-40h": 1,
          "90-92h": 1,
          "116-118h": 1
        },
        "tickets_count": 14,
        "tickets_per_day": {
          "2026-04-07": 2,
          "2026-04-10": 3,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-04-29": 1,
          "2026-05-09": 1,
          "2026-05-15": 2,
          "2026-05-21": 1
        },
        "time_per_day": {
          "2026-04-07": 1.3218244444444445,
          "2026-04-10": 40.973242777777784,
          "2026-04-14": 91.00943333333332,
          "2026-04-15": 2.28597,
          "2026-04-20": 6.856035277777777,
          "2026-04-29": 117.27878972222221,
          "2026-05-21": 38.00423222222222
        },
        "time_count_per_day": {
          "2026-04-07": 1,
          "2026-04-10": 3,
          "2026-04-14": 2,
          "2026-04-15": 1,
          "2026-04-20": 1,
          "2026-04-29": 1,
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 117.28,
          "mode_time_hours": 117.0,
          "mode_frequency": 1,
          "time_distribution": {
            "116-118h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-04-29": 117.27878972222221
          },
          "time_count_per_day": {
            "2026-04-29": 1
          }
        },
        "P2": {
          "avg_time_hours": 20.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1,
            "6-8h": 1,
            "10-12h": 1,
            "12-14h": 1,
            "16-18h": 1,
            "38-40h": 1,
            "90-92h": 1
          },
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-04-07": 1,
            "2026-04-10": 3,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-05-09": 1,
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-04-07": 1.3218244444444445,
            "2026-04-10": 40.973242777777784,
            "2026-04-14": 91.00943333333332,
            "2026-04-15": 2.28597,
            "2026-04-20": 6.856035277777777,
            "2026-05-21": 38.00423222222222
          },
          "time_count_per_day": {
            "2026-04-07": 1,
            "2026-04-10": 3,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-20": 1,
            "2026-05-21": 1
          }
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-07": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-15": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.77,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1,
              "6-8h": 1,
              "10-12h": 1,
              "12-14h": 1,
              "16-18h": 1,
              "38-40h": 1,
              "90-92h": 1,
              "116-118h": 1
            },
            "tickets_count": 10,
            "tickets_per_day": {
              "2026-04-07": 1,
              "2026-04-10": 3,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-04-29": 1,
              "2026-05-21": 1
            },
            "time_per_day": {
              "2026-04-07": 1.3218244444444445,
              "2026-04-10": 40.973242777777784,
              "2026-04-14": 91.00943333333332,
              "2026-04-15": 2.28597,
              "2026-04-20": 6.856035277777777,
              "2026-04-29": 117.27878972222221,
              "2026-05-21": 38.00423222222222
            },
            "time_count_per_day": {
              "2026-04-07": 1,
              "2026-04-10": 3,
              "2026-04-14": 2,
              "2026-04-15": 1,
              "2026-04-20": 1,
              "2026-04-29": 1,
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 117.28,
              "mode_time_hours": 117.0,
              "mode_frequency": 1,
              "time_distribution": {
                "116-118h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-04-29": 117.27878972222221
              },
              "time_count_per_day": {
                "2026-04-29": 1
              }
            },
            "P2": {
              "avg_time_hours": 20.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1,
                "6-8h": 1,
                "10-12h": 1,
                "12-14h": 1,
                "16-18h": 1,
                "38-40h": 1,
                "90-92h": 1
              },
              "tickets_count": 9,
              "tickets_per_day": {
                "2026-04-07": 1,
                "2026-04-10": 3,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-04-07": 1.3218244444444445,
                "2026-04-10": 40.973242777777784,
                "2026-04-14": 91.00943333333332,
                "2026-04-15": 2.28597,
                "2026-04-20": 6.856035277777777,
                "2026-05-21": 38.00423222222222
              },
              "time_count_per_day": {
                "2026-04-07": 1,
                "2026-04-10": 3,
                "2026-04-14": 2,
                "2026-04-15": 1,
                "2026-04-20": 1,
                "2026-05-21": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-15": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-15": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1416": {
      "overall": {
        "avg_time_hours": 141.77,
        "mode_time_hours": 141.0,
        "mode_frequency": 1,
        "time_distribution": {
          "140-142h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-14": 1
        },
        "time_per_day": {
          "2026-04-14": 141.76847388888888
        },
        "time_count_per_day": {
          "2026-04-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 141.77,
          "mode_time_hours": 141.0,
          "mode_frequency": 1,
          "time_distribution": {
            "140-142h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-14": 1
          },
          "time_per_day": {
            "2026-04-14": 141.76847388888888
          },
          "time_count_per_day": {
            "2026-04-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 141.77,
            "mode_time_hours": 141.0,
            "mode_frequency": 1,
            "time_distribution": {
              "140-142h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-14": 1
            },
            "time_per_day": {
              "2026-04-14": 141.76847388888888
            },
            "time_count_per_day": {
              "2026-04-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 141.77,
              "mode_time_hours": 141.0,
              "mode_frequency": 1,
              "time_distribution": {
                "140-142h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {
                "2026-04-14": 141.76847388888888
              },
              "time_count_per_day": {
                "2026-04-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1203": {
      "overall": {
        "avg_time_hours": 1.21,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-09": 1,
          "2026-05-15": 1
        },
        "time_per_day": {
          "2026-04-09": 1.8100652777777777,
          "2026-05-15": 0.6068319444444444
        },
        "time_count_per_day": {
          "2026-04-09": 1,
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-09": 1,
            "2026-05-15": 1
          },
          "time_per_day": {
            "2026-04-09": 1.8100652777777777,
            "2026-05-15": 0.6068319444444444
          },
          "time_count_per_day": {
            "2026-04-09": 1,
            "2026-05-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.21,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-09": 1,
              "2026-05-15": 1
            },
            "time_per_day": {
              "2026-04-09": 1.8100652777777777,
              "2026-05-15": 0.6068319444444444
            },
            "time_count_per_day": {
              "2026-04-09": 1,
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-09": 1,
                "2026-05-15": 1
              },
              "time_per_day": {
                "2026-04-09": 1.8100652777777777,
                "2026-05-15": 0.6068319444444444
              },
              "time_count_per_day": {
                "2026-04-09": 1,
                "2026-05-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_1418": {
      "overall": {
        "avg_time_hours": 1.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-09": 2,
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-04-09": 3.617407222222222,
          "2026-04-10": 1.3213963888888889
        },
        "time_count_per_day": {
          "2026-04-09": 2,
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-09": 2,
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-09": 3.617407222222222,
            "2026-04-10": 1.3213963888888889
          },
          "time_count_per_day": {
            "2026-04-09": 2,
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-09": 2,
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-04-09": 3.617407222222222,
              "2026-04-10": 1.3213963888888889
            },
            "time_count_per_day": {
              "2026-04-09": 2,
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-09": 2,
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-09": 3.617407222222222,
                "2026-04-10": 1.3213963888888889
              },
              "time_count_per_day": {
                "2026-04-09": 2,
                "2026-04-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1350": {
      "overall": {
        "avg_time_hours": 0.45,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-09": 1
        },
        "time_per_day": {
          "2026-04-09": 0.45410472222222226
        },
        "time_count_per_day": {
          "2026-04-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.45,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-09": 1
          },
          "time_per_day": {
            "2026-04-09": 0.45410472222222226
          },
          "time_count_per_day": {
            "2026-04-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.45,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-09": 1
            },
            "time_per_day": {
              "2026-04-09": 0.45410472222222226
            },
            "time_count_per_day": {
              "2026-04-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.45,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-09": 1
              },
              "time_per_day": {
                "2026-04-09": 0.45410472222222226
              },
              "time_count_per_day": {
                "2026-04-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1422": {
      "overall": {
        "avg_time_hours": 3.26,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-04-10": 3.2614652777777775
        },
        "time_count_per_day": {
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.26,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 3.2614652777777775
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.26,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-04-10": 3.2614652777777775
            },
            "time_count_per_day": {
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.26,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 3.2614652777777775
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1424": {
      "overall": {
        "avg_time_hours": 0.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-10": 1
        },
        "time_per_day": {
          "2026-04-10": 0.3038263888888889
        },
        "time_count_per_day": {
          "2026-04-10": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-10": 1
          },
          "time_per_day": {
            "2026-04-10": 0.3038263888888889
          },
          "time_count_per_day": {
            "2026-04-10": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-10": 1
            },
            "time_per_day": {
              "2026-04-10": 0.3038263888888889
            },
            "time_count_per_day": {
              "2026-04-10": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-10": 1
              },
              "time_per_day": {
                "2026-04-10": 0.3038263888888889
              },
              "time_count_per_day": {
                "2026-04-10": 1
              }
            }
          }
        }
      }
    },
    "cliente_1388": {
      "overall": {
        "avg_time_hours": 402.16,
        "mode_time_hours": 403.0,
        "mode_frequency": 1,
        "time_distribution": {
          "402-404h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-27": 1
        },
        "time_per_day": {
          "2026-04-27": 402.1628333333333
        },
        "time_count_per_day": {
          "2026-04-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 402.16,
          "mode_time_hours": 403.0,
          "mode_frequency": 1,
          "time_distribution": {
            "402-404h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {
            "2026-04-27": 402.1628333333333
          },
          "time_count_per_day": {
            "2026-04-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 402.16,
            "mode_time_hours": 403.0,
            "mode_frequency": 1,
            "time_distribution": {
              "402-404h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {
              "2026-04-27": 402.1628333333333
            },
            "time_count_per_day": {
              "2026-04-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 402.16,
              "mode_time_hours": 403.0,
              "mode_frequency": 1,
              "time_distribution": {
                "402-404h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {
                "2026-04-27": 402.1628333333333
              },
              "time_count_per_day": {
                "2026-04-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1425": {
      "overall": {
        "avg_time_hours": 16.46,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-11": 1
        },
        "time_per_day": {
          "2026-04-11": 16.46459138888889
        },
        "time_count_per_day": {
          "2026-04-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.46,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-11": 1
          },
          "time_per_day": {
            "2026-04-11": 16.46459138888889
          },
          "time_count_per_day": {
            "2026-04-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.46,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-11": 1
            },
            "time_per_day": {
              "2026-04-11": 16.46459138888889
            },
            "time_count_per_day": {
              "2026-04-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.46,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-11": 1
              },
              "time_per_day": {
                "2026-04-11": 16.46459138888889
              },
              "time_count_per_day": {
                "2026-04-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_1426": {
      "overall": {
        "avg_time_hours": 24.1,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "44-46h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-11": 1,
          "2026-04-13": 1
        },
        "time_per_day": {
          "2026-04-11": 4.096798055555555,
          "2026-04-13": 44.1074875
        },
        "time_count_per_day": {
          "2026-04-11": 1,
          "2026-04-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.1,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "44-46h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-11": 1,
            "2026-04-13": 1
          },
          "time_per_day": {
            "2026-04-11": 4.096798055555555,
            "2026-04-13": 44.1074875
          },
          "time_count_per_day": {
            "2026-04-11": 1,
            "2026-04-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.1,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "44-46h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-11": 1,
              "2026-04-13": 1
            },
            "time_per_day": {
              "2026-04-11": 4.096798055555555,
              "2026-04-13": 44.1074875
            },
            "time_count_per_day": {
              "2026-04-11": 1,
              "2026-04-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.1,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "44-46h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-11": 1,
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-04-11": 4.096798055555555,
                "2026-04-13": 44.1074875
              },
              "time_count_per_day": {
                "2026-04-11": 1,
                "2026-04-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1427": {
      "overall": {
        "avg_time_hours": 51.22,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "50-52h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-13": 1,
          "2026-04-27": 1,
          "2026-05-20": 1
        },
        "time_per_day": {
          "2026-04-13": 51.21852583333333
        },
        "time_count_per_day": {
          "2026-04-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 51.22,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "50-52h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-13": 1,
            "2026-04-27": 1,
            "2026-05-20": 1
          },
          "time_per_day": {
            "2026-04-13": 51.21852583333333
          },
          "time_count_per_day": {
            "2026-04-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 51.22,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "50-52h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-13": 1
            },
            "time_per_day": {
              "2026-04-13": 51.21852583333333
            },
            "time_count_per_day": {
              "2026-04-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 51.22,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "50-52h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-04-13": 51.21852583333333
              },
              "time_count_per_day": {
                "2026-04-13": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1429": {
      "overall": {
        "avg_time_hours": 92.38,
        "mode_time_hours": 95.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "94-96h": 1,
          "122-124h": 1,
          "150-152h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-15": 1,
          "2026-04-24": 1,
          "2026-05-04": 1,
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-04-15": 95.37514833333333,
          "2026-04-24": 150.41236166666667,
          "2026-05-04": 1.0997852777777777,
          "2026-05-05": 122.63626305555556
        },
        "time_count_per_day": {
          "2026-04-15": 1,
          "2026-04-24": 1,
          "2026-05-04": 1,
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 92.38,
          "mode_time_hours": 95.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "94-96h": 1,
            "122-124h": 1,
            "150-152h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-15": 1,
            "2026-04-24": 1,
            "2026-05-04": 1,
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-04-15": 95.37514833333333,
            "2026-04-24": 150.41236166666667,
            "2026-05-04": 1.0997852777777777,
            "2026-05-05": 122.63626305555556
          },
          "time_count_per_day": {
            "2026-04-15": 1,
            "2026-04-24": 1,
            "2026-05-04": 1,
            "2026-05-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 92.38,
            "mode_time_hours": 95.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "94-96h": 1,
              "122-124h": 1,
              "150-152h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-15": 1,
              "2026-04-24": 1,
              "2026-05-04": 1,
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-04-15": 95.37514833333333,
              "2026-04-24": 150.41236166666667,
              "2026-05-04": 1.0997852777777777,
              "2026-05-05": 122.63626305555556
            },
            "time_count_per_day": {
              "2026-04-15": 1,
              "2026-04-24": 1,
              "2026-05-04": 1,
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 92.38,
              "mode_time_hours": 95.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "94-96h": 1,
                "122-124h": 1,
                "150-152h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-15": 1,
                "2026-04-24": 1,
                "2026-05-04": 1,
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-04-15": 95.37514833333333,
                "2026-04-24": 150.41236166666667,
                "2026-05-04": 1.0997852777777777,
                "2026-05-05": 122.63626305555556
              },
              "time_count_per_day": {
                "2026-04-15": 1,
                "2026-04-24": 1,
                "2026-05-04": 1,
                "2026-05-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1431": {
      "overall": {
        "avg_time_hours": 0.18,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-13": 2
        },
        "time_per_day": {
          "2026-04-13": 0.3672708333333333
        },
        "time_count_per_day": {
          "2026-04-13": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.18,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-13": 2
          },
          "time_per_day": {
            "2026-04-13": 0.3672708333333333
          },
          "time_count_per_day": {
            "2026-04-13": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.18,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-13": 2
            },
            "time_per_day": {
              "2026-04-13": 0.3672708333333333
            },
            "time_count_per_day": {
              "2026-04-13": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.18,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-13": 2
              },
              "time_per_day": {
                "2026-04-13": 0.3672708333333333
              },
              "time_count_per_day": {
                "2026-04-13": 2
              }
            }
          }
        }
      }
    },
    "cliente_1433": {
      "overall": {
        "avg_time_hours": 0.39,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-13": 2
        },
        "time_per_day": {
          "2026-04-13": 0.7813091666666666
        },
        "time_count_per_day": {
          "2026-04-13": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.39,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-13": 2
          },
          "time_per_day": {
            "2026-04-13": 0.7813091666666666
          },
          "time_count_per_day": {
            "2026-04-13": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.39,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-13": 2
            },
            "time_per_day": {
              "2026-04-13": 0.7813091666666666
            },
            "time_count_per_day": {
              "2026-04-13": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.39,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-13": 2
              },
              "time_per_day": {
                "2026-04-13": 0.7813091666666666
              },
              "time_count_per_day": {
                "2026-04-13": 2
              }
            }
          }
        }
      }
    },
    "cliente_1435": {
      "overall": {
        "avg_time_hours": 4.78,
        "mode_time_hours": 3.0,
        "mode_frequency": 8,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 8,
          "38-40h": 1
        },
        "tickets_count": 15,
        "tickets_per_day": {
          "2026-04-13": 1,
          "2026-04-24": 3,
          "2026-04-30": 5,
          "2026-05-02": 1,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-28": 2
        },
        "time_per_day": {
          "2026-04-13": 2.5314852777777777,
          "2026-04-24": 0.042513333333333334,
          "2026-04-30": 13.340145555555555,
          "2026-05-02": 38.194672777777775,
          "2026-05-09": 0.02833972222222222,
          "2026-05-11": 3.463108055555556,
          "2026-05-28": 4.583808333333334
        },
        "time_count_per_day": {
          "2026-04-13": 1,
          "2026-04-24": 1,
          "2026-04-30": 5,
          "2026-05-02": 1,
          "2026-05-09": 1,
          "2026-05-11": 2,
          "2026-05-28": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.78,
          "mode_time_hours": 3.0,
          "mode_frequency": 8,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 8,
            "38-40h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2026-04-13": 1,
            "2026-04-24": 1,
            "2026-04-30": 5,
            "2026-05-02": 1,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-28": 2
          },
          "time_per_day": {
            "2026-04-13": 2.5314852777777777,
            "2026-04-24": 0.042513333333333334,
            "2026-04-30": 13.340145555555555,
            "2026-05-02": 38.194672777777775,
            "2026-05-09": 0.02833972222222222,
            "2026-05-11": 3.463108055555556,
            "2026-05-28": 4.583808333333334
          },
          "time_count_per_day": {
            "2026-04-13": 1,
            "2026-04-24": 1,
            "2026-04-30": 5,
            "2026-05-02": 1,
            "2026-05-09": 1,
            "2026-05-11": 2,
            "2026-05-28": 2
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-24": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.78,
            "mode_time_hours": 3.0,
            "mode_frequency": 8,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 8,
              "38-40h": 1
            },
            "tickets_count": 13,
            "tickets_per_day": {
              "2026-04-13": 1,
              "2026-04-24": 1,
              "2026-04-30": 5,
              "2026-05-02": 1,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-28": 2
            },
            "time_per_day": {
              "2026-04-13": 2.5314852777777777,
              "2026-04-24": 0.042513333333333334,
              "2026-04-30": 13.340145555555555,
              "2026-05-02": 38.194672777777775,
              "2026-05-09": 0.02833972222222222,
              "2026-05-11": 3.463108055555556,
              "2026-05-28": 4.583808333333334
            },
            "time_count_per_day": {
              "2026-04-13": 1,
              "2026-04-24": 1,
              "2026-04-30": 5,
              "2026-05-02": 1,
              "2026-05-09": 1,
              "2026-05-11": 2,
              "2026-05-28": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.78,
              "mode_time_hours": 3.0,
              "mode_frequency": 8,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 8,
                "38-40h": 1
              },
              "tickets_count": 13,
              "tickets_per_day": {
                "2026-04-13": 1,
                "2026-04-24": 1,
                "2026-04-30": 5,
                "2026-05-02": 1,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-28": 2
              },
              "time_per_day": {
                "2026-04-13": 2.5314852777777777,
                "2026-04-24": 0.042513333333333334,
                "2026-04-30": 13.340145555555555,
                "2026-05-02": 38.194672777777775,
                "2026-05-09": 0.02833972222222222,
                "2026-05-11": 3.463108055555556,
                "2026-05-28": 4.583808333333334
              },
              "time_count_per_day": {
                "2026-04-13": 1,
                "2026-04-24": 1,
                "2026-04-30": 5,
                "2026-05-02": 1,
                "2026-05-09": 1,
                "2026-05-11": 2,
                "2026-05-28": 2
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-24": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-24": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1436": {
      "overall": {
        "avg_time_hours": 221.27,
        "mode_time_hours": 221.0,
        "mode_frequency": 1,
        "time_distribution": {
          "220-222h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-04-22": 221.271285
        },
        "time_count_per_day": {
          "2026-04-22": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 221.27,
          "mode_time_hours": 221.0,
          "mode_frequency": 1,
          "time_distribution": {
            "220-222h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-04-22": 221.271285
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 221.27,
            "mode_time_hours": 221.0,
            "mode_frequency": 1,
            "time_distribution": {
              "220-222h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-04-22": 221.271285
            },
            "time_count_per_day": {
              "2026-04-22": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 221.27,
              "mode_time_hours": 221.0,
              "mode_frequency": 1,
              "time_distribution": {
                "220-222h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 221.271285
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_1437": {
      "overall": {
        "avg_time_hours": 34.34,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6,
          "2-4h": 2,
          "6-8h": 1,
          "20-22h": 1,
          "86-88h": 1,
          "90-92h": 1,
          "100-102h": 1,
          "164-166h": 1
        },
        "tickets_count": 17,
        "tickets_per_day": {
          "2026-04-13": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-27": 4,
          "2026-05-29": 1,
          "2026-06-01": 1,
          "2026-06-02": 1,
          "2026-06-03": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-04-13": 3.050663888888889,
          "2026-05-04": 178.51380555555556,
          "2026-05-05": 0.8480866666666667,
          "2026-05-06": 165.18528833333332,
          "2026-05-25": 1.9077844444444443,
          "2026-05-26": 6.387348055555556,
          "2026-05-27": 22.647602222222222,
          "2026-05-29": 2.2473125,
          "2026-06-02": 100.00802333333334
        },
        "time_count_per_day": {
          "2026-04-13": 1,
          "2026-05-04": 2,
          "2026-05-05": 1,
          "2026-05-06": 1,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-27": 4,
          "2026-05-29": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-03": 1,
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": 34.34,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6,
            "2-4h": 2,
            "6-8h": 1,
            "20-22h": 1,
            "86-88h": 1,
            "90-92h": 1,
            "100-102h": 1,
            "164-166h": 1
          },
          "tickets_count": 15,
          "tickets_per_day": {
            "2026-04-13": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-27": 4,
            "2026-05-29": 1,
            "2026-06-01": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-04-13": 3.050663888888889,
            "2026-05-04": 178.51380555555556,
            "2026-05-05": 0.8480866666666667,
            "2026-05-06": 165.18528833333332,
            "2026-05-25": 1.9077844444444443,
            "2026-05-26": 6.387348055555556,
            "2026-05-27": 22.647602222222222,
            "2026-05-29": 2.2473125,
            "2026-06-02": 100.00802333333334
          },
          "time_count_per_day": {
            "2026-04-13": 1,
            "2026-05-04": 2,
            "2026-05-05": 1,
            "2026-05-06": 1,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-27": 4,
            "2026-05-29": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 34.34,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6,
              "2-4h": 2,
              "6-8h": 1,
              "20-22h": 1,
              "86-88h": 1,
              "90-92h": 1,
              "100-102h": 1,
              "164-166h": 1
            },
            "tickets_count": 14,
            "tickets_per_day": {
              "2026-04-13": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-27": 4,
              "2026-05-29": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-04-13": 3.050663888888889,
              "2026-05-04": 178.51380555555556,
              "2026-05-05": 0.8480866666666667,
              "2026-05-06": 165.18528833333332,
              "2026-05-25": 1.9077844444444443,
              "2026-05-26": 6.387348055555556,
              "2026-05-27": 22.647602222222222,
              "2026-05-29": 2.2473125,
              "2026-06-02": 100.00802333333334
            },
            "time_count_per_day": {
              "2026-04-13": 1,
              "2026-05-04": 2,
              "2026-05-05": 1,
              "2026-05-06": 1,
              "2026-05-25": 2,
              "2026-05-26": 1,
              "2026-05-27": 4,
              "2026-05-29": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 34.34,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6,
                "2-4h": 2,
                "6-8h": 1,
                "20-22h": 1,
                "86-88h": 1,
                "90-92h": 1,
                "100-102h": 1,
                "164-166h": 1
              },
              "tickets_count": 14,
              "tickets_per_day": {
                "2026-04-13": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-27": 4,
                "2026-05-29": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-04-13": 3.050663888888889,
                "2026-05-04": 178.51380555555556,
                "2026-05-05": 0.8480866666666667,
                "2026-05-06": 165.18528833333332,
                "2026-05-25": 1.9077844444444443,
                "2026-05-26": 6.387348055555556,
                "2026-05-27": 22.647602222222222,
                "2026-05-29": 2.2473125,
                "2026-06-02": 100.00802333333334
              },
              "time_count_per_day": {
                "2026-04-13": 1,
                "2026-05-04": 2,
                "2026-05-05": 1,
                "2026-05-06": 1,
                "2026-05-25": 2,
                "2026-05-26": 1,
                "2026-05-27": 4,
                "2026-05-29": 1,
                "2026-06-02": 1
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-03": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-03": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1438": {
      "overall": {
        "avg_time_hours": 533.62,
        "mode_time_hours": 533.0,
        "mode_frequency": 1,
        "time_distribution": {
          "532-534h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-05-05": 533.6158897222222
        },
        "time_count_per_day": {
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 533.62,
          "mode_time_hours": 533.0,
          "mode_frequency": 1,
          "time_distribution": {
            "532-534h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-05-05": 533.6158897222222
          },
          "time_count_per_day": {
            "2026-05-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 533.62,
            "mode_time_hours": 533.0,
            "mode_frequency": 1,
            "time_distribution": {
              "532-534h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-05-05": 533.6158897222222
            },
            "time_count_per_day": {
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 533.62,
              "mode_time_hours": 533.0,
              "mode_frequency": 1,
              "time_distribution": {
                "532-534h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-05-05": 533.6158897222222
              },
              "time_count_per_day": {
                "2026-05-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1440": {
      "overall": {
        "avg_time_hours": 0.31,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-13": 1
        },
        "time_per_day": {
          "2026-04-13": 0.31221861111111116
        },
        "time_count_per_day": {
          "2026-04-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.31,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-13": 1
          },
          "time_per_day": {
            "2026-04-13": 0.31221861111111116
          },
          "time_count_per_day": {
            "2026-04-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.31,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-13": 1
            },
            "time_per_day": {
              "2026-04-13": 0.31221861111111116
            },
            "time_count_per_day": {
              "2026-04-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.31,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-13": 1
              },
              "time_per_day": {
                "2026-04-13": 0.31221861111111116
              },
              "time_count_per_day": {
                "2026-04-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1442": {
      "overall": {
        "avg_time_hours": 1.33,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-14": 1,
          "2026-04-15": 1
        },
        "time_per_day": {
          "2026-04-14": 0.810536111111111,
          "2026-04-15": 1.8413955555555557
        },
        "time_count_per_day": {
          "2026-04-14": 1,
          "2026-04-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-14": 1,
            "2026-04-15": 1
          },
          "time_per_day": {
            "2026-04-14": 0.810536111111111,
            "2026-04-15": 1.8413955555555557
          },
          "time_count_per_day": {
            "2026-04-14": 1,
            "2026-04-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.33,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-14": 1,
              "2026-04-15": 1
            },
            "time_per_day": {
              "2026-04-14": 0.810536111111111,
              "2026-04-15": 1.8413955555555557
            },
            "time_count_per_day": {
              "2026-04-14": 1,
              "2026-04-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-14": 1,
                "2026-04-15": 1
              },
              "time_per_day": {
                "2026-04-14": 0.810536111111111,
                "2026-04-15": 1.8413955555555557
              },
              "time_count_per_day": {
                "2026-04-14": 1,
                "2026-04-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_1443": {
      "overall": {
        "avg_time_hours": 0.27,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-14": 1
        },
        "time_per_day": {
          "2026-04-14": 0.27470944444444445
        },
        "time_count_per_day": {
          "2026-04-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.27,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-14": 1
          },
          "time_per_day": {
            "2026-04-14": 0.27470944444444445
          },
          "time_count_per_day": {
            "2026-04-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.27,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-14": 1
            },
            "time_per_day": {
              "2026-04-14": 0.27470944444444445
            },
            "time_count_per_day": {
              "2026-04-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.27,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-14": 1
              },
              "time_per_day": {
                "2026-04-14": 0.27470944444444445
              },
              "time_count_per_day": {
                "2026-04-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1445": {
      "overall": {
        "avg_time_hours": 0.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-15": 1,
          "2026-05-28": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-04-15": 0.0887936111111111,
          "2026-05-28": 0.2804475,
          "2026-05-30": 0.00993888888888889
        },
        "time_count_per_day": {
          "2026-04-15": 1,
          "2026-05-28": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-15": 1,
            "2026-05-28": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-04-15": 0.0887936111111111,
            "2026-05-28": 0.2804475,
            "2026-05-30": 0.00993888888888889
          },
          "time_count_per_day": {
            "2026-04-15": 1,
            "2026-05-28": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-15": 1,
              "2026-05-28": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-04-15": 0.0887936111111111,
              "2026-05-28": 0.2804475,
              "2026-05-30": 0.00993888888888889
            },
            "time_count_per_day": {
              "2026-04-15": 1,
              "2026-05-28": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-15": 1,
                "2026-05-28": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-04-15": 0.0887936111111111,
                "2026-05-28": 0.2804475,
                "2026-05-30": 0.00993888888888889
              },
              "time_count_per_day": {
                "2026-04-15": 1,
                "2026-05-28": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1446": {
      "overall": {
        "avg_time_hours": 16.79,
        "mode_time_hours": 17.0,
        "mode_frequency": 4,
        "time_distribution": {
          "16-18h": 4
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-16": 4
        },
        "time_per_day": {
          "2026-04-16": 67.14211777777777
        },
        "time_count_per_day": {
          "2026-04-16": 4
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 16.79,
          "mode_time_hours": 17.0,
          "mode_frequency": 4,
          "time_distribution": {
            "16-18h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-16": 4
          },
          "time_per_day": {
            "2026-04-16": 67.14211777777777
          },
          "time_count_per_day": {
            "2026-04-16": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.79,
            "mode_time_hours": 17.0,
            "mode_frequency": 4,
            "time_distribution": {
              "16-18h": 4
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-16": 4
            },
            "time_per_day": {
              "2026-04-16": 67.14211777777777
            },
            "time_count_per_day": {
              "2026-04-16": 4
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 16.79,
              "mode_time_hours": 17.0,
              "mode_frequency": 4,
              "time_distribution": {
                "16-18h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-16": 4
              },
              "time_per_day": {
                "2026-04-16": 67.14211777777777
              },
              "time_count_per_day": {
                "2026-04-16": 4
              }
            }
          }
        }
      }
    },
    "cliente_1448": {
      "overall": {
        "avg_time_hours": 65.62,
        "mode_time_hours": 65.0,
        "mode_frequency": 1,
        "time_distribution": {
          "64-66h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-18": 1
        },
        "time_per_day": {
          "2026-04-18": 65.62343555555555
        },
        "time_count_per_day": {
          "2026-04-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 65.62,
          "mode_time_hours": 65.0,
          "mode_frequency": 1,
          "time_distribution": {
            "64-66h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-18": 1
          },
          "time_per_day": {
            "2026-04-18": 65.62343555555555
          },
          "time_count_per_day": {
            "2026-04-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 65.62,
            "mode_time_hours": 65.0,
            "mode_frequency": 1,
            "time_distribution": {
              "64-66h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-18": 1
            },
            "time_per_day": {
              "2026-04-18": 65.62343555555555
            },
            "time_count_per_day": {
              "2026-04-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 65.62,
              "mode_time_hours": 65.0,
              "mode_frequency": 1,
              "time_distribution": {
                "64-66h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-18": 1
              },
              "time_per_day": {
                "2026-04-18": 65.62343555555555
              },
              "time_count_per_day": {
                "2026-04-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1449": {
      "overall": {
        "avg_time_hours": 158.26,
        "mode_time_hours": 159.0,
        "mode_frequency": 1,
        "time_distribution": {
          "158-160h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-22": 1
        },
        "time_per_day": {
          "2026-04-22": 158.25922527777777
        },
        "time_count_per_day": {
          "2026-04-22": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 158.26,
          "mode_time_hours": 159.0,
          "mode_frequency": 1,
          "time_distribution": {
            "158-160h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-04-22": 158.25922527777777
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 158.26,
            "mode_time_hours": 159.0,
            "mode_frequency": 1,
            "time_distribution": {
              "158-160h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-04-22": 158.25922527777777
            },
            "time_count_per_day": {
              "2026-04-22": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 158.26,
              "mode_time_hours": 159.0,
              "mode_frequency": 1,
              "time_distribution": {
                "158-160h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 158.25922527777777
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            }
          }
        }
      }
    },
    "cliente_1452": {
      "overall": {
        "avg_time_hours": 21.41,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-17": 1
        },
        "time_per_day": {
          "2026-04-17": 21.410827222222224
        },
        "time_count_per_day": {
          "2026-04-17": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 21.41,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-17": 1
          },
          "time_per_day": {
            "2026-04-17": 21.410827222222224
          },
          "time_count_per_day": {
            "2026-04-17": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 21.41,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-17": 1
            },
            "time_per_day": {
              "2026-04-17": 21.410827222222224
            },
            "time_count_per_day": {
              "2026-04-17": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 21.41,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-17": 1
              },
              "time_per_day": {
                "2026-04-17": 21.410827222222224
              },
              "time_count_per_day": {
                "2026-04-17": 1
              }
            }
          }
        }
      }
    },
    "cliente_1453": {
      "overall": {
        "avg_time_hours": 0.33,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-05-26": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-04-17": 0.7359127777777777,
          "2026-04-22": 0.02922472222222222,
          "2026-05-26": 0.29643111111111115,
          "2026-06-02": 0.2770302777777778
        },
        "time_count_per_day": {
          "2026-04-17": 1,
          "2026-04-22": 1,
          "2026-05-26": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.33,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-05-26": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-04-17": 0.7359127777777777,
            "2026-04-22": 0.02922472222222222,
            "2026-05-26": 0.29643111111111115,
            "2026-06-02": 0.2770302777777778
          },
          "time_count_per_day": {
            "2026-04-17": 1,
            "2026-04-22": 1,
            "2026-05-26": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.33,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-05-26": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-04-17": 0.7359127777777777,
              "2026-04-22": 0.02922472222222222,
              "2026-05-26": 0.29643111111111115,
              "2026-06-02": 0.2770302777777778
            },
            "time_count_per_day": {
              "2026-04-17": 1,
              "2026-04-22": 1,
              "2026-05-26": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.33,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-05-26": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-04-17": 0.7359127777777777,
                "2026-04-22": 0.02922472222222222,
                "2026-05-26": 0.29643111111111115,
                "2026-06-02": 0.2770302777777778
              },
              "time_count_per_day": {
                "2026-04-17": 1,
                "2026-04-22": 1,
                "2026-05-26": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1455": {
      "overall": {
        "avg_time_hours": 985.7,
        "mode_time_hours": 985.0,
        "mode_frequency": 1,
        "time_distribution": {
          "984-986h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-28": 1
        },
        "time_per_day": {
          "2026-05-28": 985.6981488888889
        },
        "time_count_per_day": {
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 985.7,
          "mode_time_hours": 985.0,
          "mode_frequency": 1,
          "time_distribution": {
            "984-986h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-05-28": 985.6981488888889
          },
          "time_count_per_day": {
            "2026-05-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 985.7,
            "mode_time_hours": 985.0,
            "mode_frequency": 1,
            "time_distribution": {
              "984-986h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {
              "2026-05-28": 985.6981488888889
            },
            "time_count_per_day": {
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 985.7,
              "mode_time_hours": 985.0,
              "mode_frequency": 1,
              "time_distribution": {
                "984-986h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-05-28": 985.6981488888889
              },
              "time_count_per_day": {
                "2026-05-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1457": {
      "overall": {
        "avg_time_hours": 0.35,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-20": 1
        },
        "time_per_day": {
          "2026-04-20": 0.34716222222222226
        },
        "time_count_per_day": {
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.35,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-20": 0.34716222222222226
          },
          "time_count_per_day": {
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.35,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {
              "2026-04-20": 0.34716222222222226
            },
            "time_count_per_day": {
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.35,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-20": 0.34716222222222226
              },
              "time_count_per_day": {
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1458": {
      "overall": {
        "avg_time_hours": 52.38,
        "mode_time_hours": 73.0,
        "mode_frequency": 1,
        "time_distribution": {
          "30-32h": 1,
          "72-74h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-23": 1,
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-04-23": 73.30324888888889,
          "2026-05-07": 31.45327611111111
        },
        "time_count_per_day": {
          "2026-04-23": 1,
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 52.38,
          "mode_time_hours": 73.0,
          "mode_frequency": 1,
          "time_distribution": {
            "30-32h": 1,
            "72-74h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-23": 1,
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-04-23": 73.30324888888889,
            "2026-05-07": 31.45327611111111
          },
          "time_count_per_day": {
            "2026-04-23": 1,
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 52.38,
            "mode_time_hours": 73.0,
            "mode_frequency": 1,
            "time_distribution": {
              "30-32h": 1,
              "72-74h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-23": 1,
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-04-23": 73.30324888888889,
              "2026-05-07": 31.45327611111111
            },
            "time_count_per_day": {
              "2026-04-23": 1,
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 52.38,
              "mode_time_hours": 73.0,
              "mode_frequency": 1,
              "time_distribution": {
                "30-32h": 1,
                "72-74h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 1,
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-04-23": 73.30324888888889,
                "2026-05-07": 31.45327611111111
              },
              "time_count_per_day": {
                "2026-04-23": 1,
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1459": {
      "overall": {
        "avg_time_hours": 3.1,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-20": 1
        },
        "time_per_day": {
          "2026-04-20": 3.095571944444444
        },
        "time_count_per_day": {
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.1,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-20": 3.095571944444444
          },
          "time_count_per_day": {
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.1,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {
              "2026-04-20": 3.095571944444444
            },
            "time_count_per_day": {
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.1,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-20": 3.095571944444444
              },
              "time_count_per_day": {
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1460": {
      "overall": {
        "avg_time_hours": 10.0,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "46-48h": 1
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-04-22": 1,
          "2026-04-24": 2,
          "2026-04-27": 1,
          "2026-05-13": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-04-22": 47.655225277777774,
          "2026-04-24": 0.12034777777777778,
          "2026-04-27": 0.9371352777777777,
          "2026-05-13": 1.3099283333333334
        },
        "time_count_per_day": {
          "2026-04-22": 1,
          "2026-04-24": 2,
          "2026-04-27": 1,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.59,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-04-24": 2,
            "2026-04-27": 1,
            "2026-05-13": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-04-24": 0.12034777777777778,
            "2026-04-27": 0.9371352777777777,
            "2026-05-13": 1.3099283333333334
          },
          "time_count_per_day": {
            "2026-04-24": 2,
            "2026-04-27": 1,
            "2026-05-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 47.66,
          "mode_time_hours": 47.0,
          "mode_frequency": 1,
          "time_distribution": {
            "46-48h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {
            "2026-04-22": 47.655225277777774
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.0,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "46-48h": 1
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-04-22": 1,
              "2026-04-24": 2,
              "2026-04-27": 1,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-04-22": 47.655225277777774,
              "2026-04-24": 0.12034777777777778,
              "2026-04-27": 0.9371352777777777,
              "2026-05-13": 1.3099283333333334
            },
            "time_count_per_day": {
              "2026-04-22": 1,
              "2026-04-24": 2,
              "2026-04-27": 1,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.59,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-24": 2,
                "2026-04-27": 1,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-04-24": 0.12034777777777778,
                "2026-04-27": 0.9371352777777777,
                "2026-05-13": 1.3099283333333334
              },
              "time_count_per_day": {
                "2026-04-24": 2,
                "2026-04-27": 1,
                "2026-05-13": 1
              }
            },
            "Reservas sem Formulário": {
              "avg_time_hours": 47.66,
              "mode_time_hours": 47.0,
              "mode_frequency": 1,
              "time_distribution": {
                "46-48h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 47.655225277777774
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1461": {
      "overall": {
        "avg_time_hours": 1.41,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-20": 1
        },
        "time_per_day": {
          "2026-04-20": 1.408455277777778
        },
        "time_count_per_day": {
          "2026-04-20": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.41,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-20": 1
          },
          "time_per_day": {
            "2026-04-20": 1.408455277777778
          },
          "time_count_per_day": {
            "2026-04-20": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.41,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-20": 1
            },
            "time_per_day": {
              "2026-04-20": 1.408455277777778
            },
            "time_count_per_day": {
              "2026-04-20": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.41,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-20": 1
              },
              "time_per_day": {
                "2026-04-20": 1.408455277777778
              },
              "time_count_per_day": {
                "2026-04-20": 1
              }
            }
          }
        }
      }
    },
    "cliente_1462": {
      "overall": {
        "avg_time_hours": 577.65,
        "mode_time_hours": 577.0,
        "mode_frequency": 1,
        "time_distribution": {
          "576-578h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-08": 1,
          "2026-05-14": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-05-14": 577.6493230555556
        },
        "time_count_per_day": {
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 577.65,
          "mode_time_hours": 577.0,
          "mode_frequency": 1,
          "time_distribution": {
            "576-578h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-08": 1,
            "2026-05-14": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-05-14": 577.6493230555556
          },
          "time_count_per_day": {
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 577.65,
            "mode_time_hours": 577.0,
            "mode_frequency": 1,
            "time_distribution": {
              "576-578h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-05-14": 577.6493230555556
            },
            "time_count_per_day": {
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 577.65,
              "mode_time_hours": 577.0,
              "mode_frequency": 1,
              "time_distribution": {
                "576-578h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-05-14": 577.6493230555556
              },
              "time_count_per_day": {
                "2026-05-14": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-08": 1,
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-08": 1,
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1138": {
      "overall": {
        "avg_time_hours": 0.41,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 7,
        "tickets_per_day": {
          "2026-02-25": 1,
          "2026-04-02": 1,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-04-20": 2,
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-04-20": 0.4257991666666667,
          "2026-05-18": 0.39583555555555555
        },
        "time_count_per_day": {
          "2026-04-20": 1,
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.41,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-20": 1,
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-04-20": 0.4257991666666667,
            "2026-05-18": 0.39583555555555555
          },
          "time_count_per_day": {
            "2026-04-20": 1,
            "2026-05-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-02-25": 1,
            "2026-04-02": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.41,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-20": 1,
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-04-20": 0.4257991666666667,
              "2026-05-18": 0.39583555555555555
            },
            "time_count_per_day": {
              "2026-04-20": 1,
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.41,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-20": 1,
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-04-20": 0.4257991666666667,
                "2026-05-18": 0.39583555555555555
              },
              "time_count_per_day": {
                "2026-04-20": 1,
                "2026-05-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-02": 1,
              "2026-04-08": 1,
              "2026-04-14": 1,
              "2026-04-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-02": 1,
                "2026-04-08": 1,
                "2026-04-14": 1,
                "2026-04-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1465": {
      "overall": {
        "avg_time_hours": 0.2,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-21": 1
        },
        "time_per_day": {
          "2026-04-21": 0.19605916666666667
        },
        "time_count_per_day": {
          "2026-04-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.2,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-21": 1
          },
          "time_per_day": {
            "2026-04-21": 0.19605916666666667
          },
          "time_count_per_day": {
            "2026-04-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.2,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-21": 1
            },
            "time_per_day": {
              "2026-04-21": 0.19605916666666667
            },
            "time_count_per_day": {
              "2026-04-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.2,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-21": 1
              },
              "time_per_day": {
                "2026-04-21": 0.19605916666666667
              },
              "time_count_per_day": {
                "2026-04-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1351": {
      "overall": {
        "avg_time_hours": 22.92,
        "mode_time_hours": 23.0,
        "mode_frequency": 1,
        "time_distribution": {
          "22-24h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-03-24": 1,
          "2026-04-22": 1,
          "2026-04-28": 1
        },
        "time_per_day": {
          "2026-04-22": 22.915666666666667
        },
        "time_count_per_day": {
          "2026-04-22": 1
        }
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": 22.92,
          "mode_time_hours": 23.0,
          "mode_frequency": 1,
          "time_distribution": {
            "22-24h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-03-24": 1,
            "2026-04-22": 1,
            "2026-04-28": 1
          },
          "time_per_day": {
            "2026-04-22": 22.915666666666667
          },
          "time_count_per_day": {
            "2026-04-22": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 22.92,
            "mode_time_hours": 23.0,
            "mode_frequency": 1,
            "time_distribution": {
              "22-24h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {
              "2026-04-22": 22.915666666666667
            },
            "time_count_per_day": {
              "2026-04-22": 1
            }
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": 22.92,
              "mode_time_hours": 23.0,
              "mode_frequency": 1,
              "time_distribution": {
                "22-24h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {
                "2026-04-22": 22.915666666666667
              },
              "time_count_per_day": {
                "2026-04-22": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-03-24": 1,
              "2026-04-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-03-24": 1,
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1472": {
      "overall": {
        "avg_time_hours": 0.83,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-23": 2
        },
        "time_per_day": {
          "2026-04-23": 1.6590872222222224
        },
        "time_count_per_day": {
          "2026-04-23": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.83,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-23": 2
          },
          "time_per_day": {
            "2026-04-23": 1.6590872222222224
          },
          "time_count_per_day": {
            "2026-04-23": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.83,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-23": 2
            },
            "time_per_day": {
              "2026-04-23": 1.6590872222222224
            },
            "time_count_per_day": {
              "2026-04-23": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.83,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 2
              },
              "time_per_day": {
                "2026-04-23": 1.6590872222222224
              },
              "time_count_per_day": {
                "2026-04-23": 2
              }
            }
          }
        }
      }
    },
    "cliente_1475": {
      "overall": {
        "avg_time_hours": 0.39,
        "mode_time_hours": 1.0,
        "mode_frequency": 6,
        "time_distribution": {
          "0-2h": 6
        },
        "tickets_count": 6,
        "tickets_per_day": {
          "2026-04-23": 6
        },
        "time_per_day": {
          "2026-04-23": 2.3125283333333333
        },
        "time_count_per_day": {
          "2026-04-23": 6
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.39,
          "mode_time_hours": 1.0,
          "mode_frequency": 6,
          "time_distribution": {
            "0-2h": 6
          },
          "tickets_count": 6,
          "tickets_per_day": {
            "2026-04-23": 6
          },
          "time_per_day": {
            "2026-04-23": 2.3125283333333333
          },
          "time_count_per_day": {
            "2026-04-23": 6
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.39,
            "mode_time_hours": 1.0,
            "mode_frequency": 6,
            "time_distribution": {
              "0-2h": 6
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-04-23": 6
            },
            "time_per_day": {
              "2026-04-23": 2.3125283333333333
            },
            "time_count_per_day": {
              "2026-04-23": 6
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.39,
              "mode_time_hours": 1.0,
              "mode_frequency": 6,
              "time_distribution": {
                "0-2h": 6
              },
              "tickets_count": 6,
              "tickets_per_day": {
                "2026-04-23": 6
              },
              "time_per_day": {
                "2026-04-23": 2.3125283333333333
              },
              "time_count_per_day": {
                "2026-04-23": 6
              }
            }
          }
        }
      }
    },
    "cliente_1476": {
      "overall": {
        "avg_time_hours": 0.29,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-23": 2
        },
        "time_per_day": {
          "2026-04-23": 0.5728130555555555
        },
        "time_count_per_day": {
          "2026-04-23": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.29,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-23": 2
          },
          "time_per_day": {
            "2026-04-23": 0.5728130555555555
          },
          "time_count_per_day": {
            "2026-04-23": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.29,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-23": 2
            },
            "time_per_day": {
              "2026-04-23": 0.5728130555555555
            },
            "time_count_per_day": {
              "2026-04-23": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.29,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 2
              },
              "time_per_day": {
                "2026-04-23": 0.5728130555555555
              },
              "time_count_per_day": {
                "2026-04-23": 2
              }
            }
          }
        }
      }
    },
    "cliente_1478": {
      "overall": {
        "avg_time_hours": 0.36,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-23": 1
        },
        "time_per_day": {
          "2026-04-23": 0.3611638888888889
        },
        "time_count_per_day": {
          "2026-04-23": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.36,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-23": 1
          },
          "time_per_day": {
            "2026-04-23": 0.3611638888888889
          },
          "time_count_per_day": {
            "2026-04-23": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.36,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-23": 1
            },
            "time_per_day": {
              "2026-04-23": 0.3611638888888889
            },
            "time_count_per_day": {
              "2026-04-23": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.36,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-23": 1
              },
              "time_per_day": {
                "2026-04-23": 0.3611638888888889
              },
              "time_count_per_day": {
                "2026-04-23": 1
              }
            }
          }
        }
      }
    },
    "cliente_1479": {
      "overall": {
        "avg_time_hours": 0.06,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-23": 2
        },
        "time_per_day": {
          "2026-04-23": 0.1215563888888889
        },
        "time_count_per_day": {
          "2026-04-23": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.06,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-23": 2
          },
          "time_per_day": {
            "2026-04-23": 0.1215563888888889
          },
          "time_count_per_day": {
            "2026-04-23": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.06,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-23": 2
            },
            "time_per_day": {
              "2026-04-23": 0.1215563888888889
            },
            "time_count_per_day": {
              "2026-04-23": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.06,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-23": 2
              },
              "time_per_day": {
                "2026-04-23": 0.1215563888888889
              },
              "time_count_per_day": {
                "2026-04-23": 2
              }
            }
          }
        }
      }
    },
    "cliente_1480": {
      "overall": {
        "avg_time_hours": 59.62,
        "mode_time_hours": 51.0,
        "mode_frequency": 2,
        "time_distribution": {
          "50-52h": 2,
          "74-76h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-27": 1,
          "2026-04-29": 2
        },
        "time_per_day": {
          "2026-04-27": 74.96991194444445,
          "2026-04-29": 103.88670416666666
        },
        "time_count_per_day": {
          "2026-04-27": 1,
          "2026-04-29": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 59.62,
          "mode_time_hours": 51.0,
          "mode_frequency": 2,
          "time_distribution": {
            "50-52h": 2,
            "74-76h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-04-27": 1,
            "2026-04-29": 2
          },
          "time_per_day": {
            "2026-04-27": 74.96991194444445,
            "2026-04-29": 103.88670416666666
          },
          "time_count_per_day": {
            "2026-04-27": 1,
            "2026-04-29": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 59.62,
            "mode_time_hours": 51.0,
            "mode_frequency": 2,
            "time_distribution": {
              "50-52h": 2,
              "74-76h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-04-29": 2
            },
            "time_per_day": {
              "2026-04-27": 74.96991194444445,
              "2026-04-29": 103.88670416666666
            },
            "time_count_per_day": {
              "2026-04-27": 1,
              "2026-04-29": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 59.62,
              "mode_time_hours": 51.0,
              "mode_frequency": 2,
              "time_distribution": {
                "50-52h": 2,
                "74-76h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-04-29": 2
              },
              "time_per_day": {
                "2026-04-27": 74.96991194444445,
                "2026-04-29": 103.88670416666666
              },
              "time_count_per_day": {
                "2026-04-27": 1,
                "2026-04-29": 2
              }
            }
          }
        }
      }
    },
    "cliente_1482": {
      "overall": {
        "avg_time_hours": 0.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-24": 1,
          "2026-04-27": 1
        },
        "time_per_day": {
          "2026-04-24": 0.13160972222222223,
          "2026-04-27": 0.36705944444444444
        },
        "time_count_per_day": {
          "2026-04-24": 1,
          "2026-04-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-24": 1,
            "2026-04-27": 1
          },
          "time_per_day": {
            "2026-04-24": 0.13160972222222223,
            "2026-04-27": 0.36705944444444444
          },
          "time_count_per_day": {
            "2026-04-24": 1,
            "2026-04-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-24": 1,
              "2026-04-27": 1
            },
            "time_per_day": {
              "2026-04-24": 0.13160972222222223,
              "2026-04-27": 0.36705944444444444
            },
            "time_count_per_day": {
              "2026-04-24": 1,
              "2026-04-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-24": 1,
                "2026-04-27": 1
              },
              "time_per_day": {
                "2026-04-24": 0.13160972222222223,
                "2026-04-27": 0.36705944444444444
              },
              "time_count_per_day": {
                "2026-04-24": 1,
                "2026-04-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1484": {
      "overall": {
        "avg_time_hours": 0.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-24": 1
        },
        "time_per_day": {
          "2026-04-24": 0.06658750000000001
        },
        "time_count_per_day": {
          "2026-04-24": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-24": 1
          },
          "time_per_day": {
            "2026-04-24": 0.06658750000000001
          },
          "time_count_per_day": {
            "2026-04-24": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-24": 1
            },
            "time_per_day": {
              "2026-04-24": 0.06658750000000001
            },
            "time_count_per_day": {
              "2026-04-24": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-24": 1
              },
              "time_per_day": {
                "2026-04-24": 0.06658750000000001
              },
              "time_count_per_day": {
                "2026-04-24": 1
              }
            }
          }
        }
      }
    },
    "cliente_1486": {
      "overall": {
        "avg_time_hours": 46.28,
        "mode_time_hours": 23.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "22-24h": 2,
          "42-44h": 1,
          "70-72h": 1,
          "114-116h": 1
        },
        "tickets_count": 10,
        "tickets_per_day": {
          "2026-04-27": 1,
          "2026-04-29": 2,
          "2026-05-21": 1,
          "2026-05-26": 1,
          "2026-05-27": 1,
          "2026-05-29": 2,
          "2026-06-08": 2
        },
        "time_per_day": {
          "2026-04-27": 43.98815805555556,
          "2026-04-29": 0.013710277777777778,
          "2026-05-26": 114.67152999999999,
          "2026-05-29": 47.69708194444444,
          "2026-06-08": 71.27991361111111
        },
        "time_count_per_day": {
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-05-26": 1,
          "2026-05-29": 2,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 114.67,
          "mode_time_hours": 115.0,
          "mode_frequency": 1,
          "time_distribution": {
            "114-116h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-29": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 114.67152999999999
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        },
        "P2": {
          "avg_time_hours": 32.6,
          "mode_time_hours": 23.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 2,
            "42-44h": 1,
            "70-72h": 1
          },
          "tickets_count": 8,
          "tickets_per_day": {
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-21": 1,
            "2026-05-27": 1,
            "2026-05-29": 2,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2026-04-27": 43.98815805555556,
            "2026-04-29": 0.013710277777777778,
            "2026-05-29": 47.69708194444444,
            "2026-06-08": 71.27991361111111
          },
          "time_count_per_day": {
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-05-29": 2,
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 46.28,
            "mode_time_hours": 23.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "22-24h": 2,
              "42-44h": 1,
              "70-72h": 1,
              "114-116h": 1
            },
            "tickets_count": 6,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-04-27": 43.98815805555556,
              "2026-04-29": 0.013710277777777778,
              "2026-05-26": 114.67152999999999,
              "2026-05-29": 47.69708194444444,
              "2026-06-08": 71.27991361111111
            },
            "time_count_per_day": {
              "2026-04-27": 1,
              "2026-04-29": 1,
              "2026-05-26": 1,
              "2026-05-29": 2,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 114.67,
              "mode_time_hours": 115.0,
              "mode_frequency": 1,
              "time_distribution": {
                "114-116h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 114.67152999999999
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            },
            "P2": {
              "avg_time_hours": 32.6,
              "mode_time_hours": 23.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 2,
                "42-44h": 1,
                "70-72h": 1
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-29": 2,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-04-27": 43.98815805555556,
                "2026-04-29": 0.013710277777777778,
                "2026-05-29": 47.69708194444444,
                "2026-06-08": 71.27991361111111
              },
              "time_count_per_day": {
                "2026-04-27": 1,
                "2026-04-29": 1,
                "2026-05-29": 2,
                "2026-06-08": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-21": 1,
              "2026-05-27": 1,
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-21": 1,
                "2026-05-27": 1,
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1487": {
      "overall": {
        "avg_time_hours": 0.3,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-27": 1
        },
        "time_per_day": {
          "2026-04-27": 0.2958969444444445
        },
        "time_count_per_day": {
          "2026-04-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.3,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {
            "2026-04-27": 0.2958969444444445
          },
          "time_count_per_day": {
            "2026-04-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.3,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {
              "2026-04-27": 0.2958969444444445
            },
            "time_count_per_day": {
              "2026-04-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.3,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {
                "2026-04-27": 0.2958969444444445
              },
              "time_count_per_day": {
                "2026-04-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1489": {
      "overall": {
        "avg_time_hours": 161.22,
        "mode_time_hours": 161.0,
        "mode_frequency": 1,
        "time_distribution": {
          "160-162h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 161.21705694444447
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 161.22,
          "mode_time_hours": 161.0,
          "mode_frequency": 1,
          "time_distribution": {
            "160-162h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 161.21705694444447
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 161.22,
            "mode_time_hours": 161.0,
            "mode_frequency": 1,
            "time_distribution": {
              "160-162h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 161.21705694444447
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 161.22,
              "mode_time_hours": 161.0,
              "mode_frequency": 1,
              "time_distribution": {
                "160-162h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 161.21705694444447
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1492": {
      "overall": {
        "avg_time_hours": 0.61,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-27": 2
        },
        "time_per_day": {
          "2026-04-27": 1.2216238888888888
        },
        "time_count_per_day": {
          "2026-04-27": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.61,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-27": 2
          },
          "time_per_day": {
            "2026-04-27": 1.2216238888888888
          },
          "time_count_per_day": {
            "2026-04-27": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.61,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-27": 2
            },
            "time_per_day": {
              "2026-04-27": 1.2216238888888888
            },
            "time_count_per_day": {
              "2026-04-27": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.61,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-27": 2
              },
              "time_per_day": {
                "2026-04-27": 1.2216238888888888
              },
              "time_count_per_day": {
                "2026-04-27": 2
              }
            }
          }
        }
      }
    },
    "cliente_1493": {
      "overall": {
        "avg_time_hours": 0.2,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-27": 1
        },
        "time_per_day": {
          "2026-04-27": 0.20239277777777778
        },
        "time_count_per_day": {
          "2026-04-27": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.2,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {
            "2026-04-27": 0.20239277777777778
          },
          "time_count_per_day": {
            "2026-04-27": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.2,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {
              "2026-04-27": 0.20239277777777778
            },
            "time_count_per_day": {
              "2026-04-27": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.2,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {
                "2026-04-27": 0.20239277777777778
              },
              "time_count_per_day": {
                "2026-04-27": 1
              }
            }
          }
        }
      }
    },
    "cliente_1257": {
      "overall": {
        "avg_time_hours": 373.53,
        "mode_time_hours": 743.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "742-744h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-28": 1,
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-28": 743.8173119444444,
          "2026-05-29": 3.2410375
        },
        "time_count_per_day": {
          "2026-05-28": 1,
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 373.53,
          "mode_time_hours": 743.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "742-744h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-28": 1,
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-28": 743.8173119444444,
            "2026-05-29": 3.2410375
          },
          "time_count_per_day": {
            "2026-05-28": 1,
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 373.53,
            "mode_time_hours": 743.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "742-744h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-28": 1,
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-28": 743.8173119444444,
              "2026-05-29": 3.2410375
            },
            "time_count_per_day": {
              "2026-05-28": 1,
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 373.53,
              "mode_time_hours": 743.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "742-744h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-28": 1,
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-28": 743.8173119444444,
                "2026-05-29": 3.2410375
              },
              "time_count_per_day": {
                "2026-05-28": 1,
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1494": {
      "overall": {
        "avg_time_hours": 0.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-28": 1
        },
        "time_per_day": {
          "2026-04-28": 0.1495688888888889
        },
        "time_count_per_day": {
          "2026-04-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-28": 1
          },
          "time_per_day": {
            "2026-04-28": 0.1495688888888889
          },
          "time_count_per_day": {
            "2026-04-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-28": 1
            },
            "time_per_day": {
              "2026-04-28": 0.1495688888888889
            },
            "time_count_per_day": {
              "2026-04-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-28": 1
              },
              "time_per_day": {
                "2026-04-28": 0.1495688888888889
              },
              "time_count_per_day": {
                "2026-04-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1495": {
      "overall": {
        "avg_time_hours": 0.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-29": 1
        },
        "time_per_day": {
          "2026-04-29": 0.22201333333333334
        },
        "time_count_per_day": {
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-04-29": 0.22201333333333334
          },
          "time_count_per_day": {
            "2026-04-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-04-29": 0.22201333333333334
            },
            "time_count_per_day": {
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-04-29": 0.22201333333333334
              },
              "time_count_per_day": {
                "2026-04-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1496": {
      "overall": {
        "avg_time_hours": 0.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-29": 1,
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-04-29": 0.08794305555555557,
          "2026-05-30": 0.017308333333333335
        },
        "time_count_per_day": {
          "2026-04-29": 1,
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-29": 1,
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-04-29": 0.08794305555555557,
            "2026-05-30": 0.017308333333333335
          },
          "time_count_per_day": {
            "2026-04-29": 1,
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-29": 1,
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-04-29": 0.08794305555555557,
              "2026-05-30": 0.017308333333333335
            },
            "time_count_per_day": {
              "2026-04-29": 1,
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-29": 1,
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-04-29": 0.08794305555555557,
                "2026-05-30": 0.017308333333333335
              },
              "time_count_per_day": {
                "2026-04-29": 1,
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1497": {
      "overall": {
        "avg_time_hours": 7.49,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 2,
          "22-24h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-29": 1,
          "2026-05-28": 1,
          "2026-06-03": 2
        },
        "time_per_day": {
          "2026-04-29": 0.00988,
          "2026-05-28": 23.781747222222222,
          "2026-06-03": 6.1547777777777775
        },
        "time_count_per_day": {
          "2026-04-29": 1,
          "2026-05-28": 1,
          "2026-06-03": 2
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 3.08,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-03": 2
          },
          "time_per_day": {
            "2026-06-03": 6.1547777777777775
          },
          "time_count_per_day": {
            "2026-06-03": 2
          }
        },
        "P2": {
          "avg_time_hours": 11.9,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "22-24h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-29": 1,
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-04-29": 0.00988,
            "2026-05-28": 23.781747222222222
          },
          "time_count_per_day": {
            "2026-04-29": 1,
            "2026-05-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 7.49,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 2,
              "22-24h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-29": 1,
              "2026-05-28": 1,
              "2026-06-03": 2
            },
            "time_per_day": {
              "2026-04-29": 0.00988,
              "2026-05-28": 23.781747222222222,
              "2026-06-03": 6.1547777777777775
            },
            "time_count_per_day": {
              "2026-04-29": 1,
              "2026-05-28": 1,
              "2026-06-03": 2
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 3.08,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-03": 2
              },
              "time_per_day": {
                "2026-06-03": 6.1547777777777775
              },
              "time_count_per_day": {
                "2026-06-03": 2
              }
            },
            "P2": {
              "avg_time_hours": 11.9,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "22-24h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-29": 1,
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-04-29": 0.00988,
                "2026-05-28": 23.781747222222222
              },
              "time_count_per_day": {
                "2026-04-29": 1,
                "2026-05-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1498": {
      "overall": {
        "avg_time_hours": 20.92,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-30": 1
        },
        "time_per_day": {
          "2026-04-30": 20.92007472222222
        },
        "time_count_per_day": {
          "2026-04-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 20.92,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-30": 1
          },
          "time_per_day": {
            "2026-04-30": 20.92007472222222
          },
          "time_count_per_day": {
            "2026-04-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.92,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-30": 1
            },
            "time_per_day": {
              "2026-04-30": 20.92007472222222
            },
            "time_count_per_day": {
              "2026-04-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 20.92,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-30": 1
              },
              "time_per_day": {
                "2026-04-30": 20.92007472222222
              },
              "time_count_per_day": {
                "2026-04-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1500": {
      "overall": {
        "avg_time_hours": 0.32,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-29": 1
        },
        "time_per_day": {
          "2026-04-29": 0.3166552777777778
        },
        "time_count_per_day": {
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-04-29": 0.3166552777777778
          },
          "time_count_per_day": {
            "2026-04-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.32,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-04-29": 0.3166552777777778
            },
            "time_count_per_day": {
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-04-29": 0.3166552777777778
              },
              "time_count_per_day": {
                "2026-04-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1501": {
      "overall": {
        "avg_time_hours": 0.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-29": 1
        },
        "time_per_day": {
          "2026-04-29": 0.031751666666666664
        },
        "time_count_per_day": {
          "2026-04-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {
            "2026-04-29": 0.031751666666666664
          },
          "time_count_per_day": {
            "2026-04-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {
              "2026-04-29": 0.031751666666666664
            },
            "time_count_per_day": {
              "2026-04-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {
                "2026-04-29": 0.031751666666666664
              },
              "time_count_per_day": {
                "2026-04-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1503": {
      "overall": {
        "avg_time_hours": 0.37,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-04-30": 4
        },
        "time_per_day": {
          "2026-04-30": 1.4652325
        },
        "time_count_per_day": {
          "2026-04-30": 4
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.37,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-04-30": 4
          },
          "time_per_day": {
            "2026-04-30": 1.4652325
          },
          "time_count_per_day": {
            "2026-04-30": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.37,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-04-30": 4
            },
            "time_per_day": {
              "2026-04-30": 1.4652325
            },
            "time_count_per_day": {
              "2026-04-30": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.37,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-04-30": 4
              },
              "time_per_day": {
                "2026-04-30": 1.4652325
              },
              "time_count_per_day": {
                "2026-04-30": 4
              }
            }
          }
        }
      }
    },
    "cliente_1504": {
      "overall": {
        "avg_time_hours": 41.46,
        "mode_time_hours": 39.0,
        "mode_frequency": 1,
        "time_distribution": {
          "38-40h": 1,
          "42-44h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-02": 1,
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-02": 39.08699083333333,
          "2026-05-04": 43.82823361111111
        },
        "time_count_per_day": {
          "2026-05-02": 1,
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 41.46,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1,
            "42-44h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-02": 1,
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-02": 39.08699083333333,
            "2026-05-04": 43.82823361111111
          },
          "time_count_per_day": {
            "2026-05-02": 1,
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 41.46,
            "mode_time_hours": 39.0,
            "mode_frequency": 1,
            "time_distribution": {
              "38-40h": 1,
              "42-44h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-02": 1,
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-02": 39.08699083333333,
              "2026-05-04": 43.82823361111111
            },
            "time_count_per_day": {
              "2026-05-02": 1,
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 41.46,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1,
                "42-44h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-02": 1,
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-02": 39.08699083333333,
                "2026-05-04": 43.82823361111111
              },
              "time_count_per_day": {
                "2026-05-02": 1,
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1506": {
      "overall": {
        "avg_time_hours": 337.43,
        "mode_time_hours": 337.0,
        "mode_frequency": 1,
        "time_distribution": {
          "336-338h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-14": 1
        },
        "time_per_day": {
          "2026-05-14": 337.42748222222224
        },
        "time_count_per_day": {
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 337.43,
          "mode_time_hours": 337.0,
          "mode_frequency": 1,
          "time_distribution": {
            "336-338h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-05-14": 337.42748222222224
          },
          "time_count_per_day": {
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 337.43,
            "mode_time_hours": 337.0,
            "mode_frequency": 1,
            "time_distribution": {
              "336-338h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-05-14": 337.42748222222224
            },
            "time_count_per_day": {
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 337.43,
              "mode_time_hours": 337.0,
              "mode_frequency": 1,
              "time_distribution": {
                "336-338h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-05-14": 337.42748222222224
              },
              "time_count_per_day": {
                "2026-05-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1510": {
      "overall": {
        "avg_time_hours": 0.28,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-02": 1
        },
        "time_per_day": {
          "2026-05-02": 0.2756263888888889
        },
        "time_count_per_day": {
          "2026-05-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.28,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-02": 1
          },
          "time_per_day": {
            "2026-05-02": 0.2756263888888889
          },
          "time_count_per_day": {
            "2026-05-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.28,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {
              "2026-05-02": 0.2756263888888889
            },
            "time_count_per_day": {
              "2026-05-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.28,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {
                "2026-05-02": 0.2756263888888889
              },
              "time_count_per_day": {
                "2026-05-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1516": {
      "overall": {
        "avg_time_hours": 48.91,
        "mode_time_hours": 49.0,
        "mode_frequency": 1,
        "time_distribution": {
          "48-50h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 48.912507500000004
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.91,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 48.912507500000004
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.91,
            "mode_time_hours": 49.0,
            "mode_frequency": 1,
            "time_distribution": {
              "48-50h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 48.912507500000004
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.91,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 48.912507500000004
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1517": {
      "overall": {
        "avg_time_hours": 48.66,
        "mode_time_hours": 49.0,
        "mode_frequency": 1,
        "time_distribution": {
          "48-50h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 48.6551325
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 48.66,
          "mode_time_hours": 49.0,
          "mode_frequency": 1,
          "time_distribution": {
            "48-50h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 48.6551325
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 48.66,
            "mode_time_hours": 49.0,
            "mode_frequency": 1,
            "time_distribution": {
              "48-50h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 48.6551325
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 48.66,
              "mode_time_hours": 49.0,
              "mode_frequency": 1,
              "time_distribution": {
                "48-50h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 48.6551325
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1519": {
      "overall": {
        "avg_time_hours": 3.19,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "4-6h": 1,
          "6-8h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-07": 1,
          "2026-05-11": 1
        },
        "time_per_day": {
          "2026-05-02": 0.5386261111111111,
          "2026-05-04": 6.4070761111111105,
          "2026-05-07": 0.10143277777777779,
          "2026-05-11": 5.701971388888889
        },
        "time_count_per_day": {
          "2026-05-02": 1,
          "2026-05-04": 1,
          "2026-05-07": 1,
          "2026-05-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.19,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "4-6h": 1,
            "6-8h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-07": 1,
            "2026-05-11": 1
          },
          "time_per_day": {
            "2026-05-02": 0.5386261111111111,
            "2026-05-04": 6.4070761111111105,
            "2026-05-07": 0.10143277777777779,
            "2026-05-11": 5.701971388888889
          },
          "time_count_per_day": {
            "2026-05-02": 1,
            "2026-05-04": 1,
            "2026-05-07": 1,
            "2026-05-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.19,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "4-6h": 1,
              "6-8h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-07": 1,
              "2026-05-11": 1
            },
            "time_per_day": {
              "2026-05-02": 0.5386261111111111,
              "2026-05-04": 6.4070761111111105,
              "2026-05-07": 0.10143277777777779,
              "2026-05-11": 5.701971388888889
            },
            "time_count_per_day": {
              "2026-05-02": 1,
              "2026-05-04": 1,
              "2026-05-07": 1,
              "2026-05-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.19,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "4-6h": 1,
                "6-8h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-07": 1,
                "2026-05-11": 1
              },
              "time_per_day": {
                "2026-05-02": 0.5386261111111111,
                "2026-05-04": 6.4070761111111105,
                "2026-05-07": 0.10143277777777779,
                "2026-05-11": 5.701971388888889
              },
              "time_count_per_day": {
                "2026-05-02": 1,
                "2026-05-04": 1,
                "2026-05-07": 1,
                "2026-05-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_1520": {
      "overall": {
        "avg_time_hours": 1.42,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-02": 1
        },
        "time_per_day": {
          "2026-05-02": 1.4241430555555556
        },
        "time_count_per_day": {
          "2026-05-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.42,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-02": 1
          },
          "time_per_day": {
            "2026-05-02": 1.4241430555555556
          },
          "time_count_per_day": {
            "2026-05-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.42,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {
              "2026-05-02": 1.4241430555555556
            },
            "time_count_per_day": {
              "2026-05-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.42,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {
                "2026-05-02": 1.4241430555555556
              },
              "time_count_per_day": {
                "2026-05-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1521": {
      "overall": {
        "avg_time_hours": 0.85,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 0.8496033333333334
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 0.8496033333333334
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.85,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 0.8496033333333334
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 0.8496033333333334
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1522": {
      "overall": {
        "avg_time_hours": 0.85,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 0.8534127777777778
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.85,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 0.8534127777777778
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.85,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 0.8534127777777778
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.85,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 0.8534127777777778
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1524": {
      "overall": {
        "avg_time_hours": 0.93,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 0.9306761111111111
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.93,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 0.9306761111111111
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.93,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 0.9306761111111111
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.93,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 0.9306761111111111
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1526": {
      "overall": {
        "avg_time_hours": 0.5,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 0.5012591666666666
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 0.5012591666666666
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.5,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 0.5012591666666666
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 0.5012591666666666
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1528": {
      "overall": {
        "avg_time_hours": 2.99,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {
          "2026-05-04": 2.9896938888888887
        },
        "time_count_per_day": {
          "2026-05-04": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.99,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {
            "2026-05-04": 2.9896938888888887
          },
          "time_count_per_day": {
            "2026-05-04": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.99,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {
              "2026-05-04": 2.9896938888888887
            },
            "time_count_per_day": {
              "2026-05-04": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.99,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {
                "2026-05-04": 2.9896938888888887
              },
              "time_count_per_day": {
                "2026-05-04": 1
              }
            }
          }
        }
      }
    },
    "cliente_1420": {
      "overall": {
        "avg_time_hours": 16.42,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-05": 1
        },
        "time_per_day": {
          "2026-05-05": 16.417175277777776
        },
        "time_count_per_day": {
          "2026-05-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 16.42,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-05": 1
          },
          "time_per_day": {
            "2026-05-05": 16.417175277777776
          },
          "time_count_per_day": {
            "2026-05-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 16.42,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-05": 1
            },
            "time_per_day": {
              "2026-05-05": 16.417175277777776
            },
            "time_count_per_day": {
              "2026-05-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 16.42,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-05": 1
              },
              "time_per_day": {
                "2026-05-05": 16.417175277777776
              },
              "time_count_per_day": {
                "2026-05-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1533": {
      "overall": {
        "avg_time_hours": 0.67,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-05": 1,
          "2026-06-01": 1,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-05-05": 0.025774444444444444,
          "2026-06-01": 1.617058888888889,
          "2026-06-08": 0.37459583333333335
        },
        "time_count_per_day": {
          "2026-05-05": 1,
          "2026-06-01": 1,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.67,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-05": 1,
            "2026-06-01": 1,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-05-05": 0.025774444444444444,
            "2026-06-01": 1.617058888888889,
            "2026-06-08": 0.37459583333333335
          },
          "time_count_per_day": {
            "2026-05-05": 1,
            "2026-06-01": 1,
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.67,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-05": 1,
              "2026-06-01": 1,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-05-05": 0.025774444444444444,
              "2026-06-01": 1.617058888888889,
              "2026-06-08": 0.37459583333333335
            },
            "time_count_per_day": {
              "2026-05-05": 1,
              "2026-06-01": 1,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.67,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-05": 1,
                "2026-06-01": 1,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-05-05": 0.025774444444444444,
                "2026-06-01": 1.617058888888889,
                "2026-06-08": 0.37459583333333335
              },
              "time_count_per_day": {
                "2026-05-05": 1,
                "2026-06-01": 1,
                "2026-06-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1534": {
      "overall": {
        "avg_time_hours": 41.87,
        "mode_time_hours": 41.0,
        "mode_frequency": 1,
        "time_distribution": {
          "40-42h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-05-07": 41.868231944444446
        },
        "time_count_per_day": {
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 41.87,
          "mode_time_hours": 41.0,
          "mode_frequency": 1,
          "time_distribution": {
            "40-42h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-05-07": 41.868231944444446
          },
          "time_count_per_day": {
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 41.87,
            "mode_time_hours": 41.0,
            "mode_frequency": 1,
            "time_distribution": {
              "40-42h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-05-07": 41.868231944444446
            },
            "time_count_per_day": {
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 41.87,
              "mode_time_hours": 41.0,
              "mode_frequency": 1,
              "time_distribution": {
                "40-42h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-05-07": 41.868231944444446
              },
              "time_count_per_day": {
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1536": {
      "overall": {
        "avg_time_hours": 29.81,
        "mode_time_hours": 29.0,
        "mode_frequency": 1,
        "time_distribution": {
          "28-30h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-05-07": 29.8069
        },
        "time_count_per_day": {
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 29.81,
          "mode_time_hours": 29.0,
          "mode_frequency": 1,
          "time_distribution": {
            "28-30h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-05-07": 29.8069
          },
          "time_count_per_day": {
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 29.81,
            "mode_time_hours": 29.0,
            "mode_frequency": 1,
            "time_distribution": {
              "28-30h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-05-07": 29.8069
            },
            "time_count_per_day": {
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 29.81,
              "mode_time_hours": 29.0,
              "mode_frequency": 1,
              "time_distribution": {
                "28-30h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-05-07": 29.8069
              },
              "time_count_per_day": {
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1537": {
      "overall": {
        "avg_time_hours": 0.65,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-06": 1,
          "2026-05-08": 1
        },
        "time_per_day": {
          "2026-05-06": 0.7752816666666666,
          "2026-05-08": 0.5322538888888889
        },
        "time_count_per_day": {
          "2026-05-06": 1,
          "2026-05-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.65,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-06": 1,
            "2026-05-08": 1
          },
          "time_per_day": {
            "2026-05-06": 0.7752816666666666,
            "2026-05-08": 0.5322538888888889
          },
          "time_count_per_day": {
            "2026-05-06": 1,
            "2026-05-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.65,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-06": 1,
              "2026-05-08": 1
            },
            "time_per_day": {
              "2026-05-06": 0.7752816666666666,
              "2026-05-08": 0.5322538888888889
            },
            "time_count_per_day": {
              "2026-05-06": 1,
              "2026-05-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.65,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-06": 1,
                "2026-05-08": 1
              },
              "time_per_day": {
                "2026-05-06": 0.7752816666666666,
                "2026-05-08": 0.5322538888888889
              },
              "time_count_per_day": {
                "2026-05-06": 1,
                "2026-05-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1539": {
      "overall": {
        "avg_time_hours": 38.81,
        "mode_time_hours": 39.0,
        "mode_frequency": 1,
        "time_distribution": {
          "38-40h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-08": 1
        },
        "time_per_day": {
          "2026-05-08": 38.814481388888886
        },
        "time_count_per_day": {
          "2026-05-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 38.81,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-08": 1
          },
          "time_per_day": {
            "2026-05-08": 38.814481388888886
          },
          "time_count_per_day": {
            "2026-05-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 38.81,
            "mode_time_hours": 39.0,
            "mode_frequency": 1,
            "time_distribution": {
              "38-40h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-08": 1
            },
            "time_per_day": {
              "2026-05-08": 38.814481388888886
            },
            "time_count_per_day": {
              "2026-05-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 38.81,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-08": 1
              },
              "time_per_day": {
                "2026-05-08": 38.814481388888886
              },
              "time_count_per_day": {
                "2026-05-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1543": {
      "overall": {
        "avg_time_hours": 0.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-07": 2,
          "2026-05-13": 1
        },
        "time_per_day": {
          "2026-05-07": 0.9434402777777777,
          "2026-05-13": 1.4399672222222222
        },
        "time_count_per_day": {
          "2026-05-07": 2,
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.79,
          "mode_time_hours": 1.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-07": 2,
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-05-07": 0.9434402777777777,
            "2026-05-13": 1.4399672222222222
          },
          "time_count_per_day": {
            "2026-05-07": 2,
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-07": 2,
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-05-07": 0.9434402777777777,
              "2026-05-13": 1.4399672222222222
            },
            "time_count_per_day": {
              "2026-05-07": 2,
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.79,
              "mode_time_hours": 1.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-07": 2,
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-05-07": 0.9434402777777777,
                "2026-05-13": 1.4399672222222222
              },
              "time_count_per_day": {
                "2026-05-07": 2,
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1544": {
      "overall": {
        "avg_time_hours": 0.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-05-07": 0.10031833333333334
        },
        "time_count_per_day": {
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.1,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-05-07": 0.10031833333333334
          },
          "time_count_per_day": {
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-05-07": 0.10031833333333334
            },
            "time_count_per_day": {
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.1,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-05-07": 0.10031833333333334
              },
              "time_count_per_day": {
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1545": {
      "overall": {
        "avg_time_hours": 0.1,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {
          "2026-05-07": 0.10296583333333334
        },
        "time_count_per_day": {
          "2026-05-07": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.1,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {
            "2026-05-07": 0.10296583333333334
          },
          "time_count_per_day": {
            "2026-05-07": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.1,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {
              "2026-05-07": 0.10296583333333334
            },
            "time_count_per_day": {
              "2026-05-07": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.1,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {
                "2026-05-07": 0.10296583333333334
              },
              "time_count_per_day": {
                "2026-05-07": 1
              }
            }
          }
        }
      }
    },
    "cliente_1547": {
      "overall": {
        "avg_time_hours": 0.55,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-09": 1
        },
        "time_per_day": {
          "2026-05-09": 0.5483769444444444
        },
        "time_count_per_day": {
          "2026-05-09": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.55,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-09": 1
          },
          "time_per_day": {
            "2026-05-09": 0.5483769444444444
          },
          "time_count_per_day": {
            "2026-05-09": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.55,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-09": 1
            },
            "time_per_day": {
              "2026-05-09": 0.5483769444444444
            },
            "time_count_per_day": {
              "2026-05-09": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.55,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-09": 1
              },
              "time_per_day": {
                "2026-05-09": 0.5483769444444444
              },
              "time_count_per_day": {
                "2026-05-09": 1
              }
            }
          }
        }
      }
    },
    "cliente_1550": {
      "overall": {
        "avg_time_hours": 14.5,
        "mode_time_hours": 41.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "2-4h": 1,
          "40-42h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-11": 2,
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-05-11": 41.149968055555554,
          "2026-06-01": 2.3592258333333334
        },
        "time_count_per_day": {
          "2026-05-11": 2,
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 14.5,
          "mode_time_hours": 41.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1,
            "2-4h": 1,
            "40-42h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-11": 2,
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-05-11": 41.149968055555554,
            "2026-06-01": 2.3592258333333334
          },
          "time_count_per_day": {
            "2026-05-11": 2,
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.5,
            "mode_time_hours": 41.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "2-4h": 1,
              "40-42h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-11": 2,
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-05-11": 41.149968055555554,
              "2026-06-01": 2.3592258333333334
            },
            "time_count_per_day": {
              "2026-05-11": 2,
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 14.5,
              "mode_time_hours": 41.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1,
                "2-4h": 1,
                "40-42h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-11": 2,
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-05-11": 41.149968055555554,
                "2026-06-01": 2.3592258333333334
              },
              "time_count_per_day": {
                "2026-05-11": 2,
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1535": {
      "overall": {
        "avg_time_hours": 99.69,
        "mode_time_hours": 125.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1,
          "124-126h": 1,
          "158-160h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-05-06": 1,
          "2026-05-14": 1,
          "2026-05-28": 2
        },
        "time_per_day": {
          "2026-05-14": 124.03818472222223,
          "2026-05-28": 175.03547500000002
        },
        "time_count_per_day": {
          "2026-05-14": 1,
          "2026-05-28": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 99.69,
          "mode_time_hours": 125.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1,
            "124-126h": 1,
            "158-160h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-28": 2
          },
          "time_per_day": {
            "2026-05-14": 124.03818472222223,
            "2026-05-28": 175.03547500000002
          },
          "time_count_per_day": {
            "2026-05-14": 1,
            "2026-05-28": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 99.69,
            "mode_time_hours": 125.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1,
              "124-126h": 1,
              "158-160h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-14": 1,
              "2026-05-28": 2
            },
            "time_per_day": {
              "2026-05-14": 124.03818472222223,
              "2026-05-28": 175.03547500000002
            },
            "time_count_per_day": {
              "2026-05-14": 1,
              "2026-05-28": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 99.69,
              "mode_time_hours": 125.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1,
                "124-126h": 1,
                "158-160h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-14": 1,
                "2026-05-28": 2
              },
              "time_per_day": {
                "2026-05-14": 124.03818472222223,
                "2026-05-28": 175.03547500000002
              },
              "time_count_per_day": {
                "2026-05-14": 1,
                "2026-05-28": 2
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1552": {
      "overall": {
        "avg_time_hours": 3.52,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-11": 1
        },
        "time_per_day": {
          "2026-05-11": 3.5212505555555556
        },
        "time_count_per_day": {
          "2026-05-11": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.52,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-11": 1
          },
          "time_per_day": {
            "2026-05-11": 3.5212505555555556
          },
          "time_count_per_day": {
            "2026-05-11": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.52,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {
              "2026-05-11": 3.5212505555555556
            },
            "time_count_per_day": {
              "2026-05-11": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.52,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {
                "2026-05-11": 3.5212505555555556
              },
              "time_count_per_day": {
                "2026-05-11": 1
              }
            }
          }
        }
      }
    },
    "cliente_820": {
      "overall": {
        "avg_time_hours": 2.39,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 2,
          "2-4h": 3
        },
        "tickets_count": 5,
        "tickets_per_day": {
          "2026-05-11": 5
        },
        "time_per_day": {
          "2026-05-11": 11.971691944444444
        },
        "time_count_per_day": {
          "2026-05-11": 5
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.39,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 2,
            "2-4h": 3
          },
          "tickets_count": 5,
          "tickets_per_day": {
            "2026-05-11": 5
          },
          "time_per_day": {
            "2026-05-11": 11.971691944444444
          },
          "time_count_per_day": {
            "2026-05-11": 5
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.39,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 2,
              "2-4h": 3
            },
            "tickets_count": 5,
            "tickets_per_day": {
              "2026-05-11": 5
            },
            "time_per_day": {
              "2026-05-11": 11.971691944444444
            },
            "time_count_per_day": {
              "2026-05-11": 5
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.39,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 2,
                "2-4h": 3
              },
              "tickets_count": 5,
              "tickets_per_day": {
                "2026-05-11": 5
              },
              "time_per_day": {
                "2026-05-11": 11.971691944444444
              },
              "time_count_per_day": {
                "2026-05-11": 5
              }
            }
          }
        }
      }
    },
    "cliente_1555": {
      "overall": {
        "avg_time_hours": 26.9,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-12": 1
        },
        "time_per_day": {
          "2026-05-12": 26.895488333333333
        },
        "time_count_per_day": {
          "2026-05-12": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 26.9,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-12": 1
          },
          "time_per_day": {
            "2026-05-12": 26.895488333333333
          },
          "time_count_per_day": {
            "2026-05-12": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.9,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-12": 1
            },
            "time_per_day": {
              "2026-05-12": 26.895488333333333
            },
            "time_count_per_day": {
              "2026-05-12": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 26.9,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-12": 1
              },
              "time_per_day": {
                "2026-05-12": 26.895488333333333
              },
              "time_count_per_day": {
                "2026-05-12": 1
              }
            }
          }
        }
      }
    },
    "cliente_1556": {
      "overall": {
        "avg_time_hours": 2.33,
        "mode_time_hours": 3.0,
        "mode_frequency": 2,
        "time_distribution": {
          "2-4h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-11": 2
        },
        "time_per_day": {
          "2026-05-11": 4.667090833333333
        },
        "time_count_per_day": {
          "2026-05-11": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.33,
          "mode_time_hours": 3.0,
          "mode_frequency": 2,
          "time_distribution": {
            "2-4h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-11": 2
          },
          "time_per_day": {
            "2026-05-11": 4.667090833333333
          },
          "time_count_per_day": {
            "2026-05-11": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.33,
            "mode_time_hours": 3.0,
            "mode_frequency": 2,
            "time_distribution": {
              "2-4h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 2
            },
            "time_per_day": {
              "2026-05-11": 4.667090833333333
            },
            "time_count_per_day": {
              "2026-05-11": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.33,
              "mode_time_hours": 3.0,
              "mode_frequency": 2,
              "time_distribution": {
                "2-4h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 2
              },
              "time_per_day": {
                "2026-05-11": 4.667090833333333
              },
              "time_count_per_day": {
                "2026-05-11": 2
              }
            }
          }
        }
      }
    },
    "cliente_1557": {
      "overall": {
        "avg_time_hours": 6.8,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1,
          "8-10h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-11": 1,
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-05-11": 4.463198888888889,
          "2026-05-26": 9.135051666666667
        },
        "time_count_per_day": {
          "2026-05-11": 1,
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.8,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1,
            "8-10h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-11": 1,
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-11": 4.463198888888889,
            "2026-05-26": 9.135051666666667
          },
          "time_count_per_day": {
            "2026-05-11": 1,
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.8,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1,
              "8-10h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-11": 1,
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-05-11": 4.463198888888889,
              "2026-05-26": 9.135051666666667
            },
            "time_count_per_day": {
              "2026-05-11": 1,
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.8,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1,
                "8-10h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-11": 1,
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-11": 4.463198888888889,
                "2026-05-26": 9.135051666666667
              },
              "time_count_per_day": {
                "2026-05-11": 1,
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1419": {
      "overall": {
        "avg_time_hours": 20.59,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-04-09": 1,
          "2026-05-13": 2
        },
        "time_per_day": {
          "2026-05-13": 20.58639416666667
        },
        "time_count_per_day": {
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 20.59,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-13": 2
          },
          "time_per_day": {
            "2026-05-13": 20.58639416666667
          },
          "time_count_per_day": {
            "2026-05-13": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.59,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-05-13": 20.58639416666667
            },
            "time_count_per_day": {
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 20.59,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-05-13": 20.58639416666667
              },
              "time_count_per_day": {
                "2026-05-13": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1562": {
      "overall": {
        "avg_time_hours": 1.15,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-13": 1
        },
        "time_per_day": {
          "2026-05-13": 1.145986388888889
        },
        "time_count_per_day": {
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.15,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-05-13": 1.145986388888889
          },
          "time_count_per_day": {
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.15,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-05-13": 1.145986388888889
            },
            "time_count_per_day": {
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.15,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-05-13": 1.145986388888889
              },
              "time_count_per_day": {
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1564": {
      "overall": {
        "avg_time_hours": 0.05,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-13": 1
        },
        "time_per_day": {
          "2026-05-13": 0.0522225
        },
        "time_count_per_day": {
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P3": {
          "avg_time_hours": 0.05,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-05-13": 0.0522225
          },
          "time_count_per_day": {
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.05,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-05-13": 0.0522225
            },
            "time_count_per_day": {
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P3": {
              "avg_time_hours": 0.05,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-05-13": 0.0522225
              },
              "time_count_per_day": {
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1565": {
      "overall": {
        "avg_time_hours": 0.23,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-13": 1
        },
        "time_per_day": {
          "2026-05-13": 0.2336661111111111
        },
        "time_count_per_day": {
          "2026-05-13": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.23,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-13": 1
          },
          "time_per_day": {
            "2026-05-13": 0.2336661111111111
          },
          "time_count_per_day": {
            "2026-05-13": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.23,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-13": 1
            },
            "time_per_day": {
              "2026-05-13": 0.2336661111111111
            },
            "time_count_per_day": {
              "2026-05-13": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.23,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-13": 1
              },
              "time_per_day": {
                "2026-05-13": 0.2336661111111111
              },
              "time_count_per_day": {
                "2026-05-13": 1
              }
            }
          }
        }
      }
    },
    "cliente_1566": {
      "overall": {
        "avg_time_hours": 11.74,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-14": 1
        },
        "time_per_day": {
          "2026-05-14": 11.742878611111111
        },
        "time_count_per_day": {
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.74,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-05-14": 11.742878611111111
          },
          "time_count_per_day": {
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.74,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-05-14": 11.742878611111111
            },
            "time_count_per_day": {
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.74,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-05-14": 11.742878611111111
              },
              "time_count_per_day": {
                "2026-05-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1568": {
      "overall": {
        "avg_time_hours": 0.46,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-14": 1
        },
        "time_per_day": {
          "2026-05-14": 0.46209361111111114
        },
        "time_count_per_day": {
          "2026-05-14": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.46,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-14": 1
          },
          "time_per_day": {
            "2026-05-14": 0.46209361111111114
          },
          "time_count_per_day": {
            "2026-05-14": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.46,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-14": 1
            },
            "time_per_day": {
              "2026-05-14": 0.46209361111111114
            },
            "time_count_per_day": {
              "2026-05-14": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.46,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-14": 1
              },
              "time_per_day": {
                "2026-05-14": 0.46209361111111114
              },
              "time_count_per_day": {
                "2026-05-14": 1
              }
            }
          }
        }
      }
    },
    "cliente_1569": {
      "overall": {
        "avg_time_hours": 14.57,
        "mode_time_hours": 15.0,
        "mode_frequency": 1,
        "time_distribution": {
          "14-16h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-15": 1
        },
        "time_per_day": {
          "2026-05-15": 14.574139166666667
        },
        "time_count_per_day": {
          "2026-05-15": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 14.57,
          "mode_time_hours": 15.0,
          "mode_frequency": 1,
          "time_distribution": {
            "14-16h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-15": 1
          },
          "time_per_day": {
            "2026-05-15": 14.574139166666667
          },
          "time_count_per_day": {
            "2026-05-15": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 14.57,
            "mode_time_hours": 15.0,
            "mode_frequency": 1,
            "time_distribution": {
              "14-16h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-15": 1
            },
            "time_per_day": {
              "2026-05-15": 14.574139166666667
            },
            "time_count_per_day": {
              "2026-05-15": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 14.57,
              "mode_time_hours": 15.0,
              "mode_frequency": 1,
              "time_distribution": {
                "14-16h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-15": 1
              },
              "time_per_day": {
                "2026-05-15": 14.574139166666667
              },
              "time_count_per_day": {
                "2026-05-15": 1
              }
            }
          }
        }
      }
    },
    "cliente_1573": {
      "overall": {
        "avg_time_hours": 86.68,
        "mode_time_hours": 173.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1,
          "172-174h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-18": 1,
          "2026-05-23": 1
        },
        "time_per_day": {
          "2026-05-18": 0.869775,
          "2026-05-23": 172.49276055555555
        },
        "time_count_per_day": {
          "2026-05-18": 1,
          "2026-05-23": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 172.49,
          "mode_time_hours": 173.0,
          "mode_frequency": 1,
          "time_distribution": {
            "172-174h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-23": 1
          },
          "time_per_day": {
            "2026-05-23": 172.49276055555555
          },
          "time_count_per_day": {
            "2026-05-23": 1
          }
        },
        "P2": {
          "avg_time_hours": 0.87,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-05-18": 0.869775
          },
          "time_count_per_day": {
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 86.68,
            "mode_time_hours": 173.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1,
              "172-174h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-18": 1,
              "2026-05-23": 1
            },
            "time_per_day": {
              "2026-05-18": 0.869775,
              "2026-05-23": 172.49276055555555
            },
            "time_count_per_day": {
              "2026-05-18": 1,
              "2026-05-23": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 172.49,
              "mode_time_hours": 173.0,
              "mode_frequency": 1,
              "time_distribution": {
                "172-174h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-23": 1
              },
              "time_per_day": {
                "2026-05-23": 172.49276055555555
              },
              "time_count_per_day": {
                "2026-05-23": 1
              }
            },
            "P2": {
              "avg_time_hours": 0.87,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-05-18": 0.869775
              },
              "time_count_per_day": {
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1574": {
      "overall": {
        "avg_time_hours": 0.31,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-16": 2
        },
        "time_per_day": {
          "2026-05-16": 0.622
        },
        "time_count_per_day": {
          "2026-05-16": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.31,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-16": 2
          },
          "time_per_day": {
            "2026-05-16": 0.622
          },
          "time_count_per_day": {
            "2026-05-16": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.31,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-16": 2
            },
            "time_per_day": {
              "2026-05-16": 0.622
            },
            "time_count_per_day": {
              "2026-05-16": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.31,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-16": 2
              },
              "time_per_day": {
                "2026-05-16": 0.622
              },
              "time_count_per_day": {
                "2026-05-16": 2
              }
            }
          }
        }
      }
    },
    "cliente_1576": {
      "overall": {
        "avg_time_hours": 0.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-05-18": 0.1327963888888889
        },
        "time_count_per_day": {
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-05-18": 0.1327963888888889
          },
          "time_count_per_day": {
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-05-18": 0.1327963888888889
            },
            "time_count_per_day": {
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-05-18": 0.1327963888888889
              },
              "time_count_per_day": {
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1578": {
      "overall": {
        "avg_time_hours": 0.22,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-18": 1
        },
        "time_per_day": {
          "2026-05-18": 0.21662361111111111
        },
        "time_count_per_day": {
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.22,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-05-18": 0.21662361111111111
          },
          "time_count_per_day": {
            "2026-05-18": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.22,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-05-18": 0.21662361111111111
            },
            "time_count_per_day": {
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.22,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-05-18": 0.21662361111111111
              },
              "time_count_per_day": {
                "2026-05-18": 1
              }
            }
          }
        }
      }
    },
    "cliente_1591": {
      "overall": {
        "avg_time_hours": 0.72,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-18": 2
        },
        "time_per_day": {
          "2026-05-18": 0.7221311111111112
        },
        "time_count_per_day": {
          "2026-05-18": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.72,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {
            "2026-05-18": 0.7221311111111112
          },
          "time_count_per_day": {
            "2026-05-18": 1
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.72,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {
              "2026-05-18": 0.7221311111111112
            },
            "time_count_per_day": {
              "2026-05-18": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.72,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {
                "2026-05-18": 0.7221311111111112
              },
              "time_count_per_day": {
                "2026-05-18": 1
              }
            }
          }
        },
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1594": {
      "overall": {
        "avg_time_hours": 0.03,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-19": 1
        },
        "time_per_day": {
          "2026-05-19": 0.025403333333333333
        },
        "time_count_per_day": {
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.03,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-19": 1
          },
          "time_per_day": {
            "2026-05-19": 0.025403333333333333
          },
          "time_count_per_day": {
            "2026-05-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.03,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-19": 1
            },
            "time_per_day": {
              "2026-05-19": 0.025403333333333333
            },
            "time_count_per_day": {
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.03,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-05-19": 0.025403333333333333
              },
              "time_count_per_day": {
                "2026-05-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1596": {
      "overall": {
        "avg_time_hours": 3.33,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-19": 1
        },
        "time_per_day": {
          "2026-05-19": 3.3259680555555557
        },
        "time_count_per_day": {
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.33,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-19": 1
          },
          "time_per_day": {
            "2026-05-19": 3.3259680555555557
          },
          "time_count_per_day": {
            "2026-05-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.33,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-19": 1
            },
            "time_per_day": {
              "2026-05-19": 3.3259680555555557
            },
            "time_count_per_day": {
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.33,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-05-19": 3.3259680555555557
              },
              "time_count_per_day": {
                "2026-05-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1031": {
      "overall": {
        "avg_time_hours": 1.8,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-19": 1
        },
        "time_per_day": {
          "2026-05-19": 1.796677222222222
        },
        "time_count_per_day": {
          "2026-05-19": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.8,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-19": 1
          },
          "time_per_day": {
            "2026-05-19": 1.796677222222222
          },
          "time_count_per_day": {
            "2026-05-19": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.8,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-19": 1
            },
            "time_per_day": {
              "2026-05-19": 1.796677222222222
            },
            "time_count_per_day": {
              "2026-05-19": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.8,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-19": 1
              },
              "time_per_day": {
                "2026-05-19": 1.796677222222222
              },
              "time_count_per_day": {
                "2026-05-19": 1
              }
            }
          }
        }
      }
    },
    "cliente_1599": {
      "overall": {
        "avg_time_hours": 24.18,
        "mode_time_hours": 25.0,
        "mode_frequency": 1,
        "time_distribution": {
          "24-26h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-21": 1
        },
        "time_per_day": {
          "2026-05-21": 24.176060000000003
        },
        "time_count_per_day": {
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 24.18,
          "mode_time_hours": 25.0,
          "mode_frequency": 1,
          "time_distribution": {
            "24-26h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-05-21": 24.176060000000003
          },
          "time_count_per_day": {
            "2026-05-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 24.18,
            "mode_time_hours": 25.0,
            "mode_frequency": 1,
            "time_distribution": {
              "24-26h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {
              "2026-05-21": 24.176060000000003
            },
            "time_count_per_day": {
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 24.18,
              "mode_time_hours": 25.0,
              "mode_frequency": 1,
              "time_distribution": {
                "24-26h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-05-21": 24.176060000000003
              },
              "time_count_per_day": {
                "2026-05-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1604": {
      "overall": {
        "avg_time_hours": 0.25,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-21": 1
        },
        "time_per_day": {
          "2026-05-21": 0.24590916666666668
        },
        "time_count_per_day": {
          "2026-05-21": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.25,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-21": 1
          },
          "time_per_day": {
            "2026-05-21": 0.24590916666666668
          },
          "time_count_per_day": {
            "2026-05-21": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.25,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-21": 1
            },
            "time_per_day": {
              "2026-05-21": 0.24590916666666668
            },
            "time_count_per_day": {
              "2026-05-21": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.25,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-21": 1
              },
              "time_per_day": {
                "2026-05-21": 0.24590916666666668
              },
              "time_count_per_day": {
                "2026-05-21": 1
              }
            }
          }
        }
      }
    },
    "cliente_1612": {
      "overall": {
        "avg_time_hours": 88.39,
        "mode_time_hours": 89.0,
        "mode_frequency": 1,
        "time_distribution": {
          "88-90h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-05-26": 88.391335
        },
        "time_count_per_day": {
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 88.39,
          "mode_time_hours": 89.0,
          "mode_frequency": 1,
          "time_distribution": {
            "88-90h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 88.391335
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 88.39,
            "mode_time_hours": 89.0,
            "mode_frequency": 1,
            "time_distribution": {
              "88-90h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-05-26": 88.391335
            },
            "time_count_per_day": {
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 88.39,
              "mode_time_hours": 89.0,
              "mode_frequency": 1,
              "time_distribution": {
                "88-90h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 88.391335
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1613": {
      "overall": {
        "avg_time_hours": 39.62,
        "mode_time_hours": 39.0,
        "mode_frequency": 1,
        "time_distribution": {
          "38-40h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-05-25": 39.62366472222222
        },
        "time_count_per_day": {
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 39.62,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-05-25": 39.62366472222222
          },
          "time_count_per_day": {
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 39.62,
            "mode_time_hours": 39.0,
            "mode_frequency": 1,
            "time_distribution": {
              "38-40h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-05-25": 39.62366472222222
            },
            "time_count_per_day": {
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 39.62,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-05-25": 39.62366472222222
              },
              "time_count_per_day": {
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1616": {
      "overall": {
        "avg_time_hours": 1.79,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-05-25": 1.793307777777778
        },
        "time_count_per_day": {
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.79,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-05-25": 1.793307777777778
          },
          "time_count_per_day": {
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.79,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-05-25": 1.793307777777778
            },
            "time_count_per_day": {
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.79,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-05-25": 1.793307777777778
              },
              "time_count_per_day": {
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1617": {
      "overall": {
        "avg_time_hours": 0.52,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-05-25": 0.5159069444444445
        },
        "time_count_per_day": {
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.52,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-05-25": 0.5159069444444445
          },
          "time_count_per_day": {
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.52,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-05-25": 0.5159069444444445
            },
            "time_count_per_day": {
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.52,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-05-25": 0.5159069444444445
              },
              "time_count_per_day": {
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1618": {
      "overall": {
        "avg_time_hours": 1.44,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-05-25": 1.4380530555555555
        },
        "time_count_per_day": {
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.44,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-05-25": 1.4380530555555555
          },
          "time_count_per_day": {
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.44,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-05-25": 1.4380530555555555
            },
            "time_count_per_day": {
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.44,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-05-25": 1.4380530555555555
              },
              "time_count_per_day": {
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1622": {
      "overall": {
        "avg_time_hours": 0.48,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-25": 1
        },
        "time_per_day": {
          "2026-05-25": 0.4833513888888889
        },
        "time_count_per_day": {
          "2026-05-25": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.48,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-25": 1
          },
          "time_per_day": {
            "2026-05-25": 0.4833513888888889
          },
          "time_count_per_day": {
            "2026-05-25": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.48,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-25": 1
            },
            "time_per_day": {
              "2026-05-25": 0.4833513888888889
            },
            "time_count_per_day": {
              "2026-05-25": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.48,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-25": 1
              },
              "time_per_day": {
                "2026-05-25": 0.4833513888888889
              },
              "time_count_per_day": {
                "2026-05-25": 1
              }
            }
          }
        }
      }
    },
    "cliente_1624": {
      "overall": {
        "avg_time_hours": 0.32,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-26": 2
        },
        "time_per_day": {
          "2026-05-26": 0.6399827777777778
        },
        "time_count_per_day": {
          "2026-05-26": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.32,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-26": 2
          },
          "time_per_day": {
            "2026-05-26": 0.6399827777777778
          },
          "time_count_per_day": {
            "2026-05-26": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.32,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-26": 2
            },
            "time_per_day": {
              "2026-05-26": 0.6399827777777778
            },
            "time_count_per_day": {
              "2026-05-26": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.32,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-26": 2
              },
              "time_per_day": {
                "2026-05-26": 0.6399827777777778
              },
              "time_count_per_day": {
                "2026-05-26": 2
              }
            }
          }
        }
      }
    },
    "cliente_1625": {
      "overall": {
        "avg_time_hours": 4.51,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-05-26": 4.514956111111111
        },
        "time_count_per_day": {
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.51,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 4.514956111111111
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.51,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-05-26": 4.514956111111111
            },
            "time_count_per_day": {
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.51,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 4.514956111111111
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1626": {
      "overall": {
        "avg_time_hours": 0.48,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-26": 1
        },
        "time_per_day": {
          "2026-05-26": 0.4753102777777778
        },
        "time_count_per_day": {
          "2026-05-26": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.48,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-26": 1
          },
          "time_per_day": {
            "2026-05-26": 0.4753102777777778
          },
          "time_count_per_day": {
            "2026-05-26": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.48,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {
              "2026-05-26": 0.4753102777777778
            },
            "time_count_per_day": {
              "2026-05-26": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.48,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {
                "2026-05-26": 0.4753102777777778
              },
              "time_count_per_day": {
                "2026-05-26": 1
              }
            }
          }
        }
      }
    },
    "cliente_1630": {
      "overall": {
        "avg_time_hours": 280.91,
        "mode_time_hours": 281.0,
        "mode_frequency": 1,
        "time_distribution": {
          "280-282h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-06-08": 280.9142258333333
        },
        "time_count_per_day": {
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 280.91,
          "mode_time_hours": 281.0,
          "mode_frequency": 1,
          "time_distribution": {
            "280-282h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-06-08": 280.9142258333333
          },
          "time_count_per_day": {
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 280.91,
            "mode_time_hours": 281.0,
            "mode_frequency": 1,
            "time_distribution": {
              "280-282h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-06-08": 280.9142258333333
            },
            "time_count_per_day": {
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 280.91,
              "mode_time_hours": 281.0,
              "mode_frequency": 1,
              "time_distribution": {
                "280-282h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-06-08": 280.9142258333333
              },
              "time_count_per_day": {
                "2026-06-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1632": {
      "overall": {
        "avg_time_hours": 4.19,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-28": 1
        },
        "time_per_day": {
          "2026-05-28": 4.1920375
        },
        "time_count_per_day": {
          "2026-05-28": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.19,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-28": 1
          },
          "time_per_day": {
            "2026-05-28": 4.1920375
          },
          "time_count_per_day": {
            "2026-05-28": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.19,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-28": 1
            },
            "time_per_day": {
              "2026-05-28": 4.1920375
            },
            "time_count_per_day": {
              "2026-05-28": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.19,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-28": 1
              },
              "time_per_day": {
                "2026-05-28": 4.1920375
              },
              "time_count_per_day": {
                "2026-05-28": 1
              }
            }
          }
        }
      }
    },
    "cliente_1468": {
      "overall": {
        "avg_time_hours": 26.44,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-29": 26.442643333333333
        },
        "time_count_per_day": {
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 26.44,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-29": 26.442643333333333
          },
          "time_count_per_day": {
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 26.44,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-29": 26.442643333333333
            },
            "time_count_per_day": {
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 26.44,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-29": 26.442643333333333
              },
              "time_count_per_day": {
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1639": {
      "overall": {
        "avg_time_hours": 17.22,
        "mode_time_hours": 17.0,
        "mode_frequency": 1,
        "time_distribution": {
          "16-18h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-29": 17.221521944444444
        },
        "time_count_per_day": {
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 17.22,
          "mode_time_hours": 17.0,
          "mode_frequency": 1,
          "time_distribution": {
            "16-18h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-29": 17.221521944444444
          },
          "time_count_per_day": {
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.22,
            "mode_time_hours": 17.0,
            "mode_frequency": 1,
            "time_distribution": {
              "16-18h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-29": 17.221521944444444
            },
            "time_count_per_day": {
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 17.22,
              "mode_time_hours": 17.0,
              "mode_frequency": 1,
              "time_distribution": {
                "16-18h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-29": 17.221521944444444
              },
              "time_count_per_day": {
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1643": {
      "overall": {
        "avg_time_hours": 2.92,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2,
          "8-10h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-29": 1,
          "2026-05-30": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-05-29": 8.698577222222223,
          "2026-05-30": 0.02386527777777778,
          "2026-06-02": 0.04289194444444445
        },
        "time_count_per_day": {
          "2026-05-29": 1,
          "2026-05-30": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.92,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2,
            "8-10h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-05-29": 8.698577222222223,
            "2026-05-30": 0.02386527777777778,
            "2026-06-02": 0.04289194444444445
          },
          "time_count_per_day": {
            "2026-05-29": 1,
            "2026-05-30": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.92,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2,
              "8-10h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-29": 1,
              "2026-05-30": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-05-29": 8.698577222222223,
              "2026-05-30": 0.02386527777777778,
              "2026-06-02": 0.04289194444444445
            },
            "time_count_per_day": {
              "2026-05-29": 1,
              "2026-05-30": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.92,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2,
                "8-10h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-05-29": 8.698577222222223,
                "2026-05-30": 0.02386527777777778,
                "2026-06-02": 0.04289194444444445
              },
              "time_count_per_day": {
                "2026-05-29": 1,
                "2026-05-30": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1645": {
      "overall": {
        "avg_time_hours": 10.08,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-29": 10.084104166666666
        },
        "time_count_per_day": {
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 10.08,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-29": 10.084104166666666
          },
          "time_count_per_day": {
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 10.08,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-29": 10.084104166666666
            },
            "time_count_per_day": {
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 10.08,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-29": 10.084104166666666
              },
              "time_count_per_day": {
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1270": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-29": 0.012205277777777778
        },
        "time_count_per_day": {
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-29": 0.012205277777777778
          },
          "time_count_per_day": {
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-29": 0.012205277777777778
            },
            "time_count_per_day": {
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-29": 0.012205277777777778
              },
              "time_count_per_day": {
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1646": {
      "overall": {
        "avg_time_hours": 1.21,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-29": 1
        },
        "time_per_day": {
          "2026-05-29": 1.2140441666666668
        },
        "time_count_per_day": {
          "2026-05-29": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.21,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-29": 1
          },
          "time_per_day": {
            "2026-05-29": 1.2140441666666668
          },
          "time_count_per_day": {
            "2026-05-29": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.21,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {
              "2026-05-29": 1.2140441666666668
            },
            "time_count_per_day": {
              "2026-05-29": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.21,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {
                "2026-05-29": 1.2140441666666668
              },
              "time_count_per_day": {
                "2026-05-29": 1
              }
            }
          }
        }
      }
    },
    "cliente_1647": {
      "overall": {
        "avg_time_hours": 0.02,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.01861111111111111
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.01861111111111111
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.02,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.01861111111111111
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.01861111111111111
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1648": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.011151666666666667
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.011151666666666667
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.011151666666666667
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.011151666666666667
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1649": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.012268333333333332
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.012268333333333332
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.012268333333333332
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.012268333333333332
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1650": {
      "overall": {
        "avg_time_hours": 0.02,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.015222222222222222
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.02,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.015222222222222222
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.02,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.015222222222222222
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.02,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.015222222222222222
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1651": {
      "overall": {
        "avg_time_hours": 0.51,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-30": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-05-30": 0.014769166666666667,
          "2026-06-02": 1.010383611111111
        },
        "time_count_per_day": {
          "2026-05-30": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-30": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-05-30": 0.014769166666666667,
            "2026-06-02": 1.010383611111111
          },
          "time_count_per_day": {
            "2026-05-30": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.51,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-30": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-05-30": 0.014769166666666667,
              "2026-06-02": 1.010383611111111
            },
            "time_count_per_day": {
              "2026-05-30": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.51,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-30": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-05-30": 0.014769166666666667,
                "2026-06-02": 1.010383611111111
              },
              "time_count_per_day": {
                "2026-05-30": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1652": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.014230833333333333
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.014230833333333333
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.014230833333333333
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.014230833333333333
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1653": {
      "overall": {
        "avg_time_hours": 0.01,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.013521111111111112
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.01,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.013521111111111112
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.01,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.013521111111111112
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.01,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.013521111111111112
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1654": {
      "overall": {
        "avg_time_hours": 0.73,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-30": 1
        },
        "time_per_day": {
          "2026-05-30": 0.7325627777777778
        },
        "time_count_per_day": {
          "2026-05-30": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.73,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-30": 1
          },
          "time_per_day": {
            "2026-05-30": 0.7325627777777778
          },
          "time_count_per_day": {
            "2026-05-30": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.73,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-30": 1
            },
            "time_per_day": {
              "2026-05-30": 0.7325627777777778
            },
            "time_count_per_day": {
              "2026-05-30": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.73,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-30": 1
              },
              "time_per_day": {
                "2026-05-30": 0.7325627777777778
              },
              "time_count_per_day": {
                "2026-05-30": 1
              }
            }
          }
        }
      }
    },
    "cliente_1656": {
      "overall": {
        "avg_time_hours": 0.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-06-01": 0.13294055555555556
        },
        "time_count_per_day": {
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 0.13294055555555556
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-06-01": 0.13294055555555556
            },
            "time_count_per_day": {
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 0.13294055555555556
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1593": {
      "overall": {
        "avg_time_hours": 20.14,
        "mode_time_hours": 51.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1,
          "6-8h": 1,
          "50-52h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-06-02": 1,
          "2026-06-03": 1,
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-06-02": 3.1643675,
          "2026-06-03": 50.16712638888889,
          "2026-06-06": 7.0819447222222225
        },
        "time_count_per_day": {
          "2026-06-02": 1,
          "2026-06-03": 1,
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 20.14,
          "mode_time_hours": 51.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1,
            "6-8h": 1,
            "50-52h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-06-02": 1,
            "2026-06-03": 1,
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-06-02": 3.1643675,
            "2026-06-03": 50.16712638888889,
            "2026-06-06": 7.0819447222222225
          },
          "time_count_per_day": {
            "2026-06-02": 1,
            "2026-06-03": 1,
            "2026-06-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.14,
            "mode_time_hours": 51.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1,
              "6-8h": 1,
              "50-52h": 1
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-06-02": 1,
              "2026-06-03": 1,
              "2026-06-06": 1
            },
            "time_per_day": {
              "2026-06-02": 3.1643675,
              "2026-06-03": 50.16712638888889,
              "2026-06-06": 7.0819447222222225
            },
            "time_count_per_day": {
              "2026-06-02": 1,
              "2026-06-03": 1,
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 20.14,
              "mode_time_hours": 51.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1,
                "6-8h": 1,
                "50-52h": 1
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-06-02": 1,
                "2026-06-03": 1,
                "2026-06-06": 1
              },
              "time_per_day": {
                "2026-06-02": 3.1643675,
                "2026-06-03": 50.16712638888889,
                "2026-06-06": 7.0819447222222225
              },
              "time_count_per_day": {
                "2026-06-02": 1,
                "2026-06-03": 1,
                "2026-06-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1657": {
      "overall": {
        "avg_time_hours": 17.29,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1,
          "28-30h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-06-01": 1,
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-01": 6.557301944444444,
          "2026-06-02": 28.032694166666666
        },
        "time_count_per_day": {
          "2026-06-01": 1,
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 17.29,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1,
            "28-30h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-01": 1,
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-01": 6.557301944444444,
            "2026-06-02": 28.032694166666666
          },
          "time_count_per_day": {
            "2026-06-01": 1,
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 17.29,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1,
              "28-30h": 1
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-01": 1,
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-01": 6.557301944444444,
              "2026-06-02": 28.032694166666666
            },
            "time_count_per_day": {
              "2026-06-01": 1,
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 17.29,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1,
                "28-30h": 1
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-01": 1,
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-01": 6.557301944444444,
                "2026-06-02": 28.032694166666666
              },
              "time_count_per_day": {
                "2026-06-01": 1,
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1658": {
      "overall": {
        "avg_time_hours": 5.8,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-06-01": 5.802160555555555
        },
        "time_count_per_day": {
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.8,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 5.802160555555555
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.8,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-06-01": 5.802160555555555
            },
            "time_count_per_day": {
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.8,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 5.802160555555555
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1659": {
      "overall": {
        "avg_time_hours": 5.27,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-06-01": 5.273011944444445
        },
        "time_count_per_day": {
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 5.27,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 5.273011944444445
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 5.27,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-06-01": 5.273011944444445
            },
            "time_count_per_day": {
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 5.27,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 5.273011944444445
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1660": {
      "overall": {
        "avg_time_hours": 4.01,
        "mode_time_hours": 5.0,
        "mode_frequency": 1,
        "time_distribution": {
          "4-6h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-06-01": 4.007263611111111
        },
        "time_count_per_day": {
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.01,
          "mode_time_hours": 5.0,
          "mode_frequency": 1,
          "time_distribution": {
            "4-6h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 4.007263611111111
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.01,
            "mode_time_hours": 5.0,
            "mode_frequency": 1,
            "time_distribution": {
              "4-6h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-06-01": 4.007263611111111
            },
            "time_count_per_day": {
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.01,
              "mode_time_hours": 5.0,
              "mode_frequency": 1,
              "time_distribution": {
                "4-6h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 4.007263611111111
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1661": {
      "overall": {
        "avg_time_hours": 20.65,
        "mode_time_hours": 21.0,
        "mode_frequency": 1,
        "time_distribution": {
          "20-22h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-02": 20.650565
        },
        "time_count_per_day": {
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 20.65,
          "mode_time_hours": 21.0,
          "mode_frequency": 1,
          "time_distribution": {
            "20-22h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 20.650565
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 20.65,
            "mode_time_hours": 21.0,
            "mode_frequency": 1,
            "time_distribution": {
              "20-22h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-02": 20.650565
            },
            "time_count_per_day": {
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 20.65,
              "mode_time_hours": 21.0,
              "mode_frequency": 1,
              "time_distribution": {
                "20-22h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 20.650565
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1662": {
      "overall": {
        "avg_time_hours": 2.35,
        "mode_time_hours": 3.0,
        "mode_frequency": 1,
        "time_distribution": {
          "2-4h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {
          "2026-06-01": 2.3487441666666666
        },
        "time_count_per_day": {
          "2026-06-01": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 2.35,
          "mode_time_hours": 3.0,
          "mode_frequency": 1,
          "time_distribution": {
            "2-4h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {
            "2026-06-01": 2.3487441666666666
          },
          "time_count_per_day": {
            "2026-06-01": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 2.35,
            "mode_time_hours": 3.0,
            "mode_frequency": 1,
            "time_distribution": {
              "2-4h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {
              "2026-06-01": 2.3487441666666666
            },
            "time_count_per_day": {
              "2026-06-01": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 2.35,
              "mode_time_hours": 3.0,
              "mode_frequency": 1,
              "time_distribution": {
                "2-4h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {
                "2026-06-01": 2.3487441666666666
              },
              "time_count_per_day": {
                "2026-06-01": 1
              }
            }
          }
        }
      }
    },
    "cliente_1665": {
      "overall": {
        "avg_time_hours": 18.15,
        "mode_time_hours": 19.0,
        "mode_frequency": 1,
        "time_distribution": {
          "18-20h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-02": 18.153018333333335
        },
        "time_count_per_day": {
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 18.15,
          "mode_time_hours": 19.0,
          "mode_frequency": 1,
          "time_distribution": {
            "18-20h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 18.153018333333335
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 18.15,
            "mode_time_hours": 19.0,
            "mode_frequency": 1,
            "time_distribution": {
              "18-20h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-02": 18.153018333333335
            },
            "time_count_per_day": {
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 18.15,
              "mode_time_hours": 19.0,
              "mode_frequency": 1,
              "time_distribution": {
                "18-20h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 18.153018333333335
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1342": {
      "overall": {
        "avg_time_hours": 6.06,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-02": 6.061465833333333
        },
        "time_count_per_day": {
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.06,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 6.061465833333333
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.06,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-02": 6.061465833333333
            },
            "time_count_per_day": {
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.06,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 6.061465833333333
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1668": {
      "overall": {
        "avg_time_hours": 39.21,
        "mode_time_hours": 25.0,
        "mode_frequency": 2,
        "time_distribution": {
          "24-26h": 2,
          "28-30h": 1,
          "74-76h": 1
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-06-03": 3,
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-06-03": 81.07310083333333,
          "2026-06-08": 75.76341666666666
        },
        "time_count_per_day": {
          "2026-06-03": 3,
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 39.21,
          "mode_time_hours": 25.0,
          "mode_frequency": 2,
          "time_distribution": {
            "24-26h": 2,
            "28-30h": 1,
            "74-76h": 1
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-06-03": 3,
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-06-03": 81.07310083333333,
            "2026-06-08": 75.76341666666666
          },
          "time_count_per_day": {
            "2026-06-03": 3,
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 39.21,
            "mode_time_hours": 25.0,
            "mode_frequency": 2,
            "time_distribution": {
              "24-26h": 2,
              "28-30h": 1,
              "74-76h": 1
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-06-03": 3,
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-06-03": 81.07310083333333,
              "2026-06-08": 75.76341666666666
            },
            "time_count_per_day": {
              "2026-06-03": 3,
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 39.21,
              "mode_time_hours": 25.0,
              "mode_frequency": 2,
              "time_distribution": {
                "24-26h": 2,
                "28-30h": 1,
                "74-76h": 1
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-06-03": 3,
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-06-03": 81.07310083333333,
                "2026-06-08": 75.76341666666666
              },
              "time_count_per_day": {
                "2026-06-03": 3,
                "2026-06-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_1669": {
      "overall": {
        "avg_time_hours": 4.86,
        "mode_time_hours": 5.0,
        "mode_frequency": 3,
        "time_distribution": {
          "4-6h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-06-02": 3
        },
        "time_per_day": {
          "2026-06-02": 14.567869444444444
        },
        "time_count_per_day": {
          "2026-06-02": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 4.86,
          "mode_time_hours": 5.0,
          "mode_frequency": 3,
          "time_distribution": {
            "4-6h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-06-02": 3
          },
          "time_per_day": {
            "2026-06-02": 14.567869444444444
          },
          "time_count_per_day": {
            "2026-06-02": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 4.86,
            "mode_time_hours": 5.0,
            "mode_frequency": 3,
            "time_distribution": {
              "4-6h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-06-02": 3
            },
            "time_per_day": {
              "2026-06-02": 14.567869444444444
            },
            "time_count_per_day": {
              "2026-06-02": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 4.86,
              "mode_time_hours": 5.0,
              "mode_frequency": 3,
              "time_distribution": {
                "4-6h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-06-02": 3
              },
              "time_per_day": {
                "2026-06-02": 14.567869444444444
              },
              "time_count_per_day": {
                "2026-06-02": 3
              }
            }
          }
        }
      }
    },
    "cliente_200": {
      "overall": {
        "avg_time_hours": 0.07,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {
          "2026-06-02": 0.0688388888888889
        },
        "time_count_per_day": {
          "2026-06-02": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.07,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {
            "2026-06-02": 0.0688388888888889
          },
          "time_count_per_day": {
            "2026-06-02": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.07,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {
              "2026-06-02": 0.0688388888888889
            },
            "time_count_per_day": {
              "2026-06-02": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.07,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {
                "2026-06-02": 0.0688388888888889
              },
              "time_count_per_day": {
                "2026-06-02": 1
              }
            }
          }
        }
      }
    },
    "cliente_1623": {
      "overall": {
        "avg_time_hours": 13.16,
        "mode_time_hours": 13.0,
        "mode_frequency": 1,
        "time_distribution": {
          "12-14h": 1
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-26": 1,
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-06-03": 13.159292777777777
        },
        "time_count_per_day": {
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 13.16,
          "mode_time_hours": 13.0,
          "mode_frequency": 1,
          "time_distribution": {
            "12-14h": 1
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-26": 1,
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 13.159292777777777
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 13.16,
            "mode_time_hours": 13.0,
            "mode_frequency": 1,
            "time_distribution": {
              "12-14h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-06-03": 13.159292777777777
            },
            "time_count_per_day": {
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P1": {
              "avg_time_hours": 13.16,
              "mode_time_hours": 13.0,
              "mode_frequency": 1,
              "time_distribution": {
                "12-14h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 13.159292777777777
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-26": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-26": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1673": {
      "overall": {
        "avg_time_hours": 11.31,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-06-03": 11.311291111111112
        },
        "time_count_per_day": {
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.31,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 11.311291111111112
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.31,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-06-03": 11.311291111111112
            },
            "time_count_per_day": {
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.31,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 11.311291111111112
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1367": {
      "overall": {
        "avg_time_hours": 11.71,
        "mode_time_hours": 11.0,
        "mode_frequency": 2,
        "time_distribution": {
          "10-12h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-06-03": 2
        },
        "time_per_day": {
          "2026-06-03": 23.426938888888888
        },
        "time_count_per_day": {
          "2026-06-03": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.71,
          "mode_time_hours": 11.0,
          "mode_frequency": 2,
          "time_distribution": {
            "10-12h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-03": 2
          },
          "time_per_day": {
            "2026-06-03": 23.426938888888888
          },
          "time_count_per_day": {
            "2026-06-03": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.71,
            "mode_time_hours": 11.0,
            "mode_frequency": 2,
            "time_distribution": {
              "10-12h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-03": 2
            },
            "time_per_day": {
              "2026-06-03": 23.426938888888888
            },
            "time_count_per_day": {
              "2026-06-03": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.71,
              "mode_time_hours": 11.0,
              "mode_frequency": 2,
              "time_distribution": {
                "10-12h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-03": 2
              },
              "time_per_day": {
                "2026-06-03": 23.426938888888888
              },
              "time_count_per_day": {
                "2026-06-03": 2
              }
            }
          }
        }
      }
    },
    "cliente_1079": {
      "overall": {
        "avg_time_hours": 8.36,
        "mode_time_hours": 11.0,
        "mode_frequency": 3,
        "time_distribution": {
          "0-2h": 1,
          "10-12h": 3
        },
        "tickets_count": 4,
        "tickets_per_day": {
          "2026-06-03": 4
        },
        "time_per_day": {
          "2026-06-03": 33.42950611111112
        },
        "time_count_per_day": {
          "2026-06-03": 4
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 8.36,
          "mode_time_hours": 11.0,
          "mode_frequency": 3,
          "time_distribution": {
            "0-2h": 1,
            "10-12h": 3
          },
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-06-03": 4
          },
          "time_per_day": {
            "2026-06-03": 33.42950611111112
          },
          "time_count_per_day": {
            "2026-06-03": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 8.36,
            "mode_time_hours": 11.0,
            "mode_frequency": 3,
            "time_distribution": {
              "0-2h": 1,
              "10-12h": 3
            },
            "tickets_count": 4,
            "tickets_per_day": {
              "2026-06-03": 4
            },
            "time_per_day": {
              "2026-06-03": 33.42950611111112
            },
            "time_count_per_day": {
              "2026-06-03": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 8.36,
              "mode_time_hours": 11.0,
              "mode_frequency": 3,
              "time_distribution": {
                "0-2h": 1,
                "10-12h": 3
              },
              "tickets_count": 4,
              "tickets_per_day": {
                "2026-06-03": 4
              },
              "time_per_day": {
                "2026-06-03": 33.42950611111112
              },
              "time_count_per_day": {
                "2026-06-03": 4
              }
            }
          }
        }
      }
    },
    "cliente_1674": {
      "overall": {
        "avg_time_hours": 1.13,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-06-03": 1.1252633333333333
        },
        "time_count_per_day": {
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 1.13,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 1.1252633333333333
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 1.13,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-06-03": 1.1252633333333333
            },
            "time_count_per_day": {
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 1.13,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 1.1252633333333333
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1677": {
      "overall": {
        "avg_time_hours": 6.93,
        "mode_time_hours": 7.0,
        "mode_frequency": 1,
        "time_distribution": {
          "6-8h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-06-03": 6.9346825
        },
        "time_count_per_day": {
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 6.93,
          "mode_time_hours": 7.0,
          "mode_frequency": 1,
          "time_distribution": {
            "6-8h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 6.9346825
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 6.93,
            "mode_time_hours": 7.0,
            "mode_frequency": 1,
            "time_distribution": {
              "6-8h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-06-03": 6.9346825
            },
            "time_count_per_day": {
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 6.93,
              "mode_time_hours": 7.0,
              "mode_frequency": 1,
              "time_distribution": {
                "6-8h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 6.9346825
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_1679": {
      "overall": {
        "avg_time_hours": 0.5,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {
          "2026-06-03": 0.49747833333333336
        },
        "time_count_per_day": {
          "2026-06-03": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {
            "2026-06-03": 0.49747833333333336
          },
          "time_count_per_day": {
            "2026-06-03": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.5,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {
              "2026-06-03": 0.49747833333333336
            },
            "time_count_per_day": {
              "2026-06-03": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.5,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {
                "2026-06-03": 0.49747833333333336
              },
              "time_count_per_day": {
                "2026-06-03": 1
              }
            }
          }
        }
      }
    },
    "cliente_199": {
      "overall": {
        "avg_time_hours": 39.17,
        "mode_time_hours": 39.0,
        "mode_frequency": 1,
        "time_distribution": {
          "38-40h": 1
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-29": 1,
          "2026-06-03": 1,
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-06-05": 39.16920083333333
        },
        "time_count_per_day": {
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 39.17,
          "mode_time_hours": 39.0,
          "mode_frequency": 1,
          "time_distribution": {
            "38-40h": 1
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-29": 1,
            "2026-06-03": 1,
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-06-05": 39.16920083333333
          },
          "time_count_per_day": {
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 39.17,
            "mode_time_hours": 39.0,
            "mode_frequency": 1,
            "time_distribution": {
              "38-40h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-06-05": 39.16920083333333
            },
            "time_count_per_day": {
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 39.17,
              "mode_time_hours": 39.0,
              "mode_frequency": 1,
              "time_distribution": {
                "38-40h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-06-05": 39.16920083333333
              },
              "time_count_per_day": {
                "2026-06-05": 1
              }
            }
          }
        },
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1680": {
      "overall": {
        "avg_time_hours": 11.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 4,
        "time_distribution": {
          "0-2h": 4,
          "2-4h": 2,
          "4-6h": 2,
          "34-36h": 1,
          "36-38h": 1,
          "44-46h": 1
        },
        "tickets_count": 13,
        "tickets_per_day": {
          "2026-06-05": 6,
          "2026-06-06": 1,
          "2026-06-08": 6
        },
        "time_per_day": {
          "2026-06-05": 120.28456916666669,
          "2026-06-06": 2.4078075,
          "2026-06-08": 8.6835325
        },
        "time_count_per_day": {
          "2026-06-05": 6,
          "2026-06-06": 1,
          "2026-06-08": 4
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 4,
          "time_distribution": {
            "0-2h": 4,
            "2-4h": 2,
            "4-6h": 2,
            "34-36h": 1,
            "36-38h": 1,
            "44-46h": 1
          },
          "tickets_count": 13,
          "tickets_per_day": {
            "2026-06-05": 6,
            "2026-06-06": 1,
            "2026-06-08": 6
          },
          "time_per_day": {
            "2026-06-05": 120.28456916666669,
            "2026-06-06": 2.4078075,
            "2026-06-08": 8.6835325
          },
          "time_count_per_day": {
            "2026-06-05": 6,
            "2026-06-06": 1,
            "2026-06-08": 4
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 4,
            "time_distribution": {
              "0-2h": 4,
              "2-4h": 2,
              "4-6h": 2,
              "34-36h": 1,
              "36-38h": 1,
              "44-46h": 1
            },
            "tickets_count": 11,
            "tickets_per_day": {
              "2026-06-05": 6,
              "2026-06-06": 1,
              "2026-06-08": 4
            },
            "time_per_day": {
              "2026-06-05": 120.28456916666669,
              "2026-06-06": 2.4078075,
              "2026-06-08": 8.6835325
            },
            "time_count_per_day": {
              "2026-06-05": 6,
              "2026-06-06": 1,
              "2026-06-08": 4
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 4,
              "time_distribution": {
                "0-2h": 4,
                "2-4h": 2,
                "4-6h": 2,
                "34-36h": 1,
                "36-38h": 1,
                "44-46h": 1
              },
              "tickets_count": 11,
              "tickets_per_day": {
                "2026-06-05": 6,
                "2026-06-06": 1,
                "2026-06-08": 4
              },
              "time_per_day": {
                "2026-06-05": 120.28456916666669,
                "2026-06-06": 2.4078075,
                "2026-06-08": 8.6835325
              },
              "time_count_per_day": {
                "2026-06-05": 6,
                "2026-06-06": 1,
                "2026-06-08": 4
              }
            }
          }
        },
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-08": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-08": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1686": {
      "overall": {
        "avg_time_hours": 27.71,
        "mode_time_hours": 27.0,
        "mode_frequency": 1,
        "time_distribution": {
          "26-28h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-06": 1
        },
        "time_per_day": {
          "2026-06-06": 27.705766666666666
        },
        "time_count_per_day": {
          "2026-06-06": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 27.71,
          "mode_time_hours": 27.0,
          "mode_frequency": 1,
          "time_distribution": {
            "26-28h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-06": 1
          },
          "time_per_day": {
            "2026-06-06": 27.705766666666666
          },
          "time_count_per_day": {
            "2026-06-06": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 27.71,
            "mode_time_hours": 27.0,
            "mode_frequency": 1,
            "time_distribution": {
              "26-28h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {
              "2026-06-06": 27.705766666666666
            },
            "time_count_per_day": {
              "2026-06-06": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 27.71,
              "mode_time_hours": 27.0,
              "mode_frequency": 1,
              "time_distribution": {
                "26-28h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {
                "2026-06-06": 27.705766666666666
              },
              "time_count_per_day": {
                "2026-06-06": 1
              }
            }
          }
        }
      }
    },
    "cliente_1687": {
      "overall": {
        "avg_time_hours": 11.11,
        "mode_time_hours": 11.0,
        "mode_frequency": 1,
        "time_distribution": {
          "10-12h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-05": 1
        },
        "time_per_day": {
          "2026-06-05": 11.114726111111112
        },
        "time_count_per_day": {
          "2026-06-05": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 11.11,
          "mode_time_hours": 11.0,
          "mode_frequency": 1,
          "time_distribution": {
            "10-12h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-05": 1
          },
          "time_per_day": {
            "2026-06-05": 11.114726111111112
          },
          "time_count_per_day": {
            "2026-06-05": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 11.11,
            "mode_time_hours": 11.0,
            "mode_frequency": 1,
            "time_distribution": {
              "10-12h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {
              "2026-06-05": 11.114726111111112
            },
            "time_count_per_day": {
              "2026-06-05": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 11.11,
              "mode_time_hours": 11.0,
              "mode_frequency": 1,
              "time_distribution": {
                "10-12h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {
                "2026-06-05": 11.114726111111112
              },
              "time_count_per_day": {
                "2026-06-05": 1
              }
            }
          }
        }
      }
    },
    "cliente_1688": {
      "overall": {
        "avg_time_hours": 0.94,
        "mode_time_hours": 1.0,
        "mode_frequency": 2,
        "time_distribution": {
          "0-2h": 2
        },
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-06-05": 2
        },
        "time_per_day": {
          "2026-06-05": 1.8821347222222222
        },
        "time_count_per_day": {
          "2026-06-05": 2
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.94,
          "mode_time_hours": 1.0,
          "mode_frequency": 2,
          "time_distribution": {
            "0-2h": 2
          },
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-05": 2
          },
          "time_per_day": {
            "2026-06-05": 1.8821347222222222
          },
          "time_count_per_day": {
            "2026-06-05": 2
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.94,
            "mode_time_hours": 1.0,
            "mode_frequency": 2,
            "time_distribution": {
              "0-2h": 2
            },
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-05": 2
            },
            "time_per_day": {
              "2026-06-05": 1.8821347222222222
            },
            "time_count_per_day": {
              "2026-06-05": 2
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.94,
              "mode_time_hours": 1.0,
              "mode_frequency": 2,
              "time_distribution": {
                "0-2h": 2
              },
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-05": 2
              },
              "time_per_day": {
                "2026-06-05": 1.8821347222222222
              },
              "time_count_per_day": {
                "2026-06-05": 2
              }
            }
          }
        }
      }
    },
    "cliente_1689": {
      "overall": {
        "avg_time_hours": 3.71,
        "mode_time_hours": 3.0,
        "mode_frequency": 3,
        "time_distribution": {
          "2-4h": 3
        },
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-06-05": 3
        },
        "time_per_day": {
          "2026-06-05": 11.133460277777777
        },
        "time_count_per_day": {
          "2026-06-05": 3
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 3.71,
          "mode_time_hours": 3.0,
          "mode_frequency": 3,
          "time_distribution": {
            "2-4h": 3
          },
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-06-05": 3
          },
          "time_per_day": {
            "2026-06-05": 11.133460277777777
          },
          "time_count_per_day": {
            "2026-06-05": 3
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 3.71,
            "mode_time_hours": 3.0,
            "mode_frequency": 3,
            "time_distribution": {
              "2-4h": 3
            },
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-06-05": 3
            },
            "time_per_day": {
              "2026-06-05": 11.133460277777777
            },
            "time_count_per_day": {
              "2026-06-05": 3
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 3.71,
              "mode_time_hours": 3.0,
              "mode_frequency": 3,
              "time_distribution": {
                "2-4h": 3
              },
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-06-05": 3
              },
              "time_per_day": {
                "2026-06-05": 11.133460277777777
              },
              "time_count_per_day": {
                "2026-06-05": 3
              }
            }
          }
        }
      }
    },
    "cliente_1701": {
      "overall": {
        "avg_time_hours": 0.26,
        "mode_time_hours": 1.0,
        "mode_frequency": 1,
        "time_distribution": {
          "0-2h": 1
        },
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-08": 1
        },
        "time_per_day": {
          "2026-06-08": 0.2622211111111111
        },
        "time_count_per_day": {
          "2026-06-08": 1
        }
      },
      "priorities": {
        "P2": {
          "avg_time_hours": 0.26,
          "mode_time_hours": 1.0,
          "mode_frequency": 1,
          "time_distribution": {
            "0-2h": 1
          },
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-08": 1
          },
          "time_per_day": {
            "2026-06-08": 0.2622211111111111
          },
          "time_count_per_day": {
            "2026-06-08": 1
          }
        }
      },
      "states": {
        "Closed": {
          "overall": {
            "avg_time_hours": 0.26,
            "mode_time_hours": 1.0,
            "mode_frequency": 1,
            "time_distribution": {
              "0-2h": 1
            },
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {
              "2026-06-08": 0.2622211111111111
            },
            "time_count_per_day": {
              "2026-06-08": 1
            }
          },
          "priorities": {
            "P2": {
              "avg_time_hours": 0.26,
              "mode_time_hours": 1.0,
              "mode_frequency": 1,
              "time_distribution": {
                "0-2h": 1
              },
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {
                "2026-06-08": 0.2622211111111111
              },
              "time_count_per_day": {
                "2026-06-08": 1
              }
            }
          }
        }
      }
    },
    "cliente_500": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2025-11-14": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-14": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2025-11-14": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2025-11-14": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_486": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-01-16": 1,
          "2026-05-07": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-16": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-01-16": 1,
              "2026-05-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            },
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-01-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_967": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-02": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P3": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_975": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-03": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1065": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-12": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-12": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-12": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-12": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1105": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-19": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-19": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-19": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-19": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1113": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-20": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1126": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-23": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-23": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-23": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-23": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1147": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-02-25": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-02-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-02-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-02-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1190": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-03": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1225": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-07": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-07": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1241": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-09": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem pedido RGPD e CVO": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1243": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-10": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-10": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-10": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-10": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1297": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-16": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-16": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-16": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-16": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1360": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-25": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-25": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-25": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1380": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-03-28": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-03-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-03-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1397": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-01": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-01": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1399": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-02": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1411": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-06": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1470": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-22": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-22": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-22": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-22": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1485": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-24": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-24": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-24": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-24": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1488": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-04-27": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-27": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-27": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-27": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1491": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-27": 1,
          "2026-04-28": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-04-27": 1,
            "2026-04-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-04-27": 1,
              "2026-04-28": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-04-27": 1,
                "2026-04-28": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1428": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-04-29": 1,
          "2026-06-03": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-04-29": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        },
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-04-29": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-04-29": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1511": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-02": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-02": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-02": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-02": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1512": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-02": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1518": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-05-02": 2,
          "2026-05-09": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-05-02": 2,
            "2026-05-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 3,
            "tickets_per_day": {
              "2026-05-02": 2,
              "2026-05-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 3,
              "tickets_per_day": {
                "2026-05-02": 2,
                "2026-05-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1523": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-04": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-04": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-04": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1525": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-04": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-04": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-04": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-04": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1541": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-07": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-07": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-07": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-07": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1546": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-08": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1548": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-09": 1,
          "2026-05-18": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-09": 1,
            "2026-05-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-09": 1,
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-09": 1,
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1549": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-09": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-09": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-09": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1553": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-11": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-11": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1558": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-11": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-11": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-11": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-11": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1577": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-18": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-18": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-18": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1595": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-19": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-19": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-19": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-19": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1598": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-19": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-19": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-19": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-19": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1602": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-05-20": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-05-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-05-20": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-05-20": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1628": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-05-27": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-05-27": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-05-27": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-05-27": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1655": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-01": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-01": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-01": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-01": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1670": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-02": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Operador": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-02": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-02": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1672": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 2,
        "tickets_per_day": {
          "2026-06-02": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-06-02": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 2,
            "tickets_per_day": {
              "2026-06-02": 2
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 2,
              "tickets_per_day": {
                "2026-06-02": 2
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1675": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1676": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-03": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-03": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-03": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1690": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-05": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Legal": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-05": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-05": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1572": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-06": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P1": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1696": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-06": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Pendente Consultor": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1614": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-06": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-06": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-06": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-06": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1699": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-08": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "Open": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "P2": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    },
    "cliente_1700": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-06-08": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      },
      "states": {
        "New": {
          "overall": {
            "avg_time_hours": null,
            "mode_time_hours": null,
            "mode_frequency": null,
            "time_distribution": {},
            "tickets_count": 1,
            "tickets_per_day": {
              "2026-06-08": 1
            },
            "time_per_day": {},
            "time_count_per_day": {}
          },
          "priorities": {
            "Reservas sem Formulário": {
              "avg_time_hours": null,
              "mode_time_hours": null,
              "mode_frequency": null,
              "time_distribution": {},
              "tickets_count": 1,
              "tickets_per_day": {
                "2026-06-08": 1
              },
              "time_per_day": {},
              "time_count_per_day": {}
            }
          }
        }
      }
    }
  },
  "daily_summary": {
    "2025-09-30": {
      "closed": 32,
      "open": 0
    },
    "2025-10-01": {
      "closed": 15,
      "open": 0
    },
    "2025-10-02": {
      "closed": 6,
      "open": 0
    },
    "2025-10-03": {
      "closed": 10,
      "open": 0
    },
    "2025-10-06": {
      "closed": 19,
      "open": 1
    },
    "2025-10-07": {
      "closed": 65,
      "open": 2
    },
    "2025-10-08": {
      "closed": 26,
      "open": 1
    },
    "2025-10-09": {
      "closed": 37,
      "open": 0
    },
    "2025-10-10": {
      "closed": 45,
      "open": 0
    },
    "2025-10-11": {
      "closed": 2,
      "open": 0
    },
    "2025-10-12": {
      "closed": 1,
      "open": 0
    },
    "2025-10-13": {
      "closed": 52,
      "open": 0
    },
    "2025-10-14": {
      "closed": 69,
      "open": 0
    },
    "2025-10-15": {
      "closed": 76,
      "open": 0
    },
    "2025-10-16": {
      "closed": 16,
      "open": 0
    },
    "2025-10-17": {
      "closed": 36,
      "open": 0
    },
    "2025-10-18": {
      "closed": 4,
      "open": 0
    },
    "2025-10-19": {
      "closed": 0,
      "open": 1
    },
    "2025-10-20": {
      "closed": 26,
      "open": 1
    },
    "2025-10-21": {
      "closed": 37,
      "open": 0
    },
    "2025-10-22": {
      "closed": 36,
      "open": 0
    },
    "2025-10-23": {
      "closed": 83,
      "open": 0
    },
    "2025-10-24": {
      "closed": 32,
      "open": 0
    },
    "2025-10-25": {
      "closed": 14,
      "open": 0
    },
    "2025-10-26": {
      "closed": 1,
      "open": 0
    },
    "2025-10-27": {
      "closed": 70,
      "open": 0
    },
    "2025-10-28": {
      "closed": 51,
      "open": 0
    },
    "2025-10-29": {
      "closed": 55,
      "open": 2
    },
    "2025-10-30": {
      "closed": 64,
      "open": 0
    },
    "2025-10-31": {
      "closed": 64,
      "open": 0
    },
    "2025-11-02": {
      "closed": 1,
      "open": 0
    },
    "2025-11-03": {
      "closed": 66,
      "open": 0
    },
    "2025-11-04": {
      "closed": 49,
      "open": 1
    },
    "2025-11-05": {
      "closed": 59,
      "open": 0
    },
    "2025-11-06": {
      "closed": 73,
      "open": 0
    },
    "2025-11-07": {
      "closed": 45,
      "open": 0
    },
    "2025-11-08": {
      "closed": 4,
      "open": 0
    },
    "2025-11-09": {
      "closed": 1,
      "open": 0
    },
    "2025-11-10": {
      "closed": 65,
      "open": 0
    },
    "2025-11-11": {
      "closed": 55,
      "open": 0
    },
    "2025-11-12": {
      "closed": 70,
      "open": 0
    },
    "2025-11-13": {
      "closed": 81,
      "open": 0
    },
    "2025-11-14": {
      "closed": 70,
      "open": 2
    },
    "2025-11-15": {
      "closed": 1,
      "open": 0
    },
    "2025-11-16": {
      "closed": 3,
      "open": 0
    },
    "2025-11-17": {
      "closed": 93,
      "open": 1
    },
    "2025-11-18": {
      "closed": 37,
      "open": 0
    },
    "2025-11-19": {
      "closed": 86,
      "open": 1
    },
    "2025-11-20": {
      "closed": 67,
      "open": 0
    },
    "2025-11-21": {
      "closed": 85,
      "open": 1
    },
    "2025-11-22": {
      "closed": 31,
      "open": 0
    },
    "2025-11-23": {
      "closed": 19,
      "open": 0
    },
    "2025-11-24": {
      "closed": 103,
      "open": 1
    },
    "2025-11-25": {
      "closed": 49,
      "open": 1
    },
    "2025-11-26": {
      "closed": 47,
      "open": 1
    },
    "2025-11-27": {
      "closed": 65,
      "open": 1
    },
    "2025-11-28": {
      "closed": 53,
      "open": 1
    },
    "2025-11-29": {
      "closed": 45,
      "open": 0
    },
    "2025-11-30": {
      "closed": 7,
      "open": 0
    },
    "2025-12-01": {
      "closed": 3,
      "open": 1
    },
    "2025-12-02": {
      "closed": 134,
      "open": 0
    },
    "2025-12-03": {
      "closed": 87,
      "open": 0
    },
    "2025-12-04": {
      "closed": 86,
      "open": 0
    },
    "2025-12-05": {
      "closed": 71,
      "open": 0
    },
    "2025-12-06": {
      "closed": 3,
      "open": 0
    },
    "2025-12-07": {
      "closed": 1,
      "open": 0
    },
    "2025-12-08": {
      "closed": 4,
      "open": 0
    },
    "2025-12-09": {
      "closed": 45,
      "open": 2
    },
    "2025-12-10": {
      "closed": 73,
      "open": 1
    },
    "2025-12-11": {
      "closed": 94,
      "open": 0
    },
    "2025-12-12": {
      "closed": 63,
      "open": 1
    },
    "2025-12-13": {
      "closed": 15,
      "open": 0
    },
    "2025-12-14": {
      "closed": 15,
      "open": 0
    },
    "2025-12-15": {
      "closed": 163,
      "open": 0
    },
    "2025-12-16": {
      "closed": 31,
      "open": 0
    },
    "2025-12-17": {
      "closed": 49,
      "open": 0
    },
    "2025-12-18": {
      "closed": 48,
      "open": 0
    },
    "2025-12-19": {
      "closed": 58,
      "open": 0
    },
    "2025-12-20": {
      "closed": 2,
      "open": 0
    },
    "2025-12-21": {
      "closed": 1,
      "open": 0
    },
    "2025-12-22": {
      "closed": 62,
      "open": 1
    },
    "2025-12-23": {
      "closed": 36,
      "open": 0
    },
    "2025-12-24": {
      "closed": 7,
      "open": 0
    },
    "2025-12-25": {
      "closed": 1,
      "open": 0
    },
    "2025-12-26": {
      "closed": 59,
      "open": 1
    },
    "2025-12-28": {
      "closed": 6,
      "open": 1
    },
    "2025-12-29": {
      "closed": 52,
      "open": 2
    },
    "2025-12-30": {
      "closed": 27,
      "open": 0
    },
    "2025-12-31": {
      "closed": 10,
      "open": 0
    },
    "2026-01-02": {
      "closed": 35,
      "open": 2
    },
    "2026-01-03": {
      "closed": 2,
      "open": 1
    },
    "2026-01-04": {
      "closed": 2,
      "open": 0
    },
    "2026-01-05": {
      "closed": 46,
      "open": 1
    },
    "2026-01-06": {
      "closed": 44,
      "open": 0
    },
    "2026-01-07": {
      "closed": 60,
      "open": 0
    },
    "2026-01-08": {
      "closed": 99,
      "open": 1
    },
    "2026-01-09": {
      "closed": 54,
      "open": 0
    },
    "2026-01-10": {
      "closed": 8,
      "open": 1
    },
    "2026-01-11": {
      "closed": 4,
      "open": 0
    },
    "2026-01-12": {
      "closed": 49,
      "open": 0
    },
    "2026-01-13": {
      "closed": 149,
      "open": 0
    },
    "2026-01-14": {
      "closed": 101,
      "open": 1
    },
    "2026-01-15": {
      "closed": 151,
      "open": 0
    },
    "2026-01-16": {
      "closed": 97,
      "open": 4
    },
    "2026-01-17": {
      "closed": 46,
      "open": 0
    },
    "2026-01-18": {
      "closed": 12,
      "open": 2
    },
    "2026-01-19": {
      "closed": 88,
      "open": 1
    },
    "2026-01-20": {
      "closed": 86,
      "open": 1
    },
    "2026-01-21": {
      "closed": 72,
      "open": 2
    },
    "2026-01-22": {
      "closed": 69,
      "open": 0
    },
    "2026-01-23": {
      "closed": 125,
      "open": 0
    },
    "2026-01-24": {
      "closed": 34,
      "open": 0
    },
    "2026-01-26": {
      "closed": 96,
      "open": 0
    },
    "2026-01-27": {
      "closed": 184,
      "open": 0
    },
    "2026-01-28": {
      "closed": 61,
      "open": 0
    },
    "2026-01-29": {
      "closed": 50,
      "open": 1
    },
    "2026-01-30": {
      "closed": 85,
      "open": 1
    },
    "2026-01-31": {
      "closed": 26,
      "open": 0
    },
    "2026-02-02": {
      "closed": 58,
      "open": 1
    },
    "2026-02-03": {
      "closed": 228,
      "open": 1
    },
    "2026-02-04": {
      "closed": 84,
      "open": 1
    },
    "2026-02-05": {
      "closed": 80,
      "open": 0
    },
    "2026-02-06": {
      "closed": 143,
      "open": 0
    },
    "2026-02-07": {
      "closed": 37,
      "open": 0
    },
    "2026-02-09": {
      "closed": 125,
      "open": 0
    },
    "2026-02-10": {
      "closed": 244,
      "open": 0
    },
    "2026-02-11": {
      "closed": 48,
      "open": 3
    },
    "2026-02-12": {
      "closed": 135,
      "open": 3
    },
    "2026-02-13": {
      "closed": 151,
      "open": 0
    },
    "2026-02-14": {
      "closed": 84,
      "open": 2
    },
    "2026-02-16": {
      "closed": 67,
      "open": 29
    },
    "2026-02-17": {
      "closed": 44,
      "open": 13
    },
    "2026-02-18": {
      "closed": 189,
      "open": 6
    },
    "2026-02-19": {
      "closed": 503,
      "open": 10
    },
    "2026-02-20": {
      "closed": 89,
      "open": 11
    },
    "2026-02-21": {
      "closed": 69,
      "open": 2
    },
    "2026-02-22": {
      "closed": 4,
      "open": 0
    },
    "2026-02-23": {
      "closed": 115,
      "open": 17
    },
    "2026-02-24": {
      "closed": 72,
      "open": 5
    },
    "2026-02-25": {
      "closed": 66,
      "open": 6
    },
    "2026-02-26": {
      "closed": 38,
      "open": 1
    },
    "2026-02-27": {
      "closed": 37,
      "open": 1
    },
    "2026-02-28": {
      "closed": 154,
      "open": 4
    },
    "2026-03-01": {
      "closed": 21,
      "open": 1
    },
    "2026-03-02": {
      "closed": 131,
      "open": 11
    },
    "2026-03-03": {
      "closed": 68,
      "open": 25
    },
    "2026-03-04": {
      "closed": 100,
      "open": 10
    },
    "2026-03-05": {
      "closed": 96,
      "open": 5
    },
    "2026-03-06": {
      "closed": 89,
      "open": 9
    },
    "2026-03-07": {
      "closed": 43,
      "open": 3
    },
    "2026-03-08": {
      "closed": 2,
      "open": 0
    },
    "2026-03-09": {
      "closed": 131,
      "open": 9
    },
    "2026-03-10": {
      "closed": 94,
      "open": 11
    },
    "2026-03-11": {
      "closed": 97,
      "open": 13
    },
    "2026-03-12": {
      "closed": 76,
      "open": 2
    },
    "2026-03-13": {
      "closed": 63,
      "open": 3
    },
    "2026-03-14": {
      "closed": 50,
      "open": 1
    },
    "2026-03-15": {
      "closed": 2,
      "open": 0
    },
    "2026-03-16": {
      "closed": 106,
      "open": 6
    },
    "2026-03-17": {
      "closed": 223,
      "open": 2
    },
    "2026-03-18": {
      "closed": 605,
      "open": 7
    },
    "2026-03-19": {
      "closed": 89,
      "open": 5
    },
    "2026-03-20": {
      "closed": 196,
      "open": 4
    },
    "2026-03-21": {
      "closed": 10,
      "open": 2
    },
    "2026-03-22": {
      "closed": 1,
      "open": 0
    },
    "2026-03-23": {
      "closed": 118,
      "open": 6
    },
    "2026-03-24": {
      "closed": 135,
      "open": 3
    },
    "2026-03-25": {
      "closed": 95,
      "open": 7
    },
    "2026-03-26": {
      "closed": 113,
      "open": 5
    },
    "2026-03-27": {
      "closed": 59,
      "open": 7
    },
    "2026-03-28": {
      "closed": 14,
      "open": 4
    },
    "2026-03-29": {
      "closed": 1,
      "open": 0
    },
    "2026-03-30": {
      "closed": 117,
      "open": 16
    },
    "2026-03-31": {
      "closed": 98,
      "open": 12
    },
    "2026-04-01": {
      "closed": 60,
      "open": 8
    },
    "2026-04-02": {
      "closed": 77,
      "open": 8
    },
    "2026-04-04": {
      "closed": 18,
      "open": 6
    },
    "2026-04-06": {
      "closed": 113,
      "open": 10
    },
    "2026-04-07": {
      "closed": 90,
      "open": 8
    },
    "2026-04-08": {
      "closed": 85,
      "open": 10
    },
    "2026-04-09": {
      "closed": 84,
      "open": 11
    },
    "2026-04-10": {
      "closed": 128,
      "open": 7
    },
    "2026-04-11": {
      "closed": 34,
      "open": 1
    },
    "2026-04-13": {
      "closed": 114,
      "open": 3
    },
    "2026-04-14": {
      "closed": 86,
      "open": 9
    },
    "2026-04-15": {
      "closed": 67,
      "open": 10
    },
    "2026-04-16": {
      "closed": 109,
      "open": 4
    },
    "2026-04-17": {
      "closed": 97,
      "open": 10
    },
    "2026-04-18": {
      "closed": 29,
      "open": 3
    },
    "2026-04-20": {
      "closed": 103,
      "open": 17
    },
    "2026-04-21": {
      "closed": 55,
      "open": 8
    },
    "2026-04-22": {
      "closed": 178,
      "open": 13
    },
    "2026-04-23": {
      "closed": 178,
      "open": 11
    },
    "2026-04-24": {
      "closed": 66,
      "open": 22
    },
    "2026-04-26": {
      "closed": 2,
      "open": 0
    },
    "2026-04-27": {
      "closed": 139,
      "open": 28
    },
    "2026-04-28": {
      "closed": 66,
      "open": 15
    },
    "2026-04-29": {
      "closed": 94,
      "open": 25
    },
    "2026-04-30": {
      "closed": 92,
      "open": 19
    },
    "2026-05-01": {
      "closed": 2,
      "open": 0
    },
    "2026-05-02": {
      "closed": 64,
      "open": 17
    },
    "2026-05-03": {
      "closed": 0,
      "open": 1
    },
    "2026-05-04": {
      "closed": 176,
      "open": 31
    },
    "2026-05-05": {
      "closed": 101,
      "open": 17
    },
    "2026-05-06": {
      "closed": 158,
      "open": 37
    },
    "2026-05-07": {
      "closed": 86,
      "open": 29
    },
    "2026-05-08": {
      "closed": 75,
      "open": 20
    },
    "2026-05-09": {
      "closed": 37,
      "open": 17
    },
    "2026-05-10": {
      "closed": 4,
      "open": 0
    },
    "2026-05-11": {
      "closed": 131,
      "open": 25
    },
    "2026-05-12": {
      "closed": 85,
      "open": 52
    },
    "2026-05-13": {
      "closed": 93,
      "open": 24
    },
    "2026-05-14": {
      "closed": 136,
      "open": 17
    },
    "2026-05-15": {
      "closed": 72,
      "open": 16
    },
    "2026-05-16": {
      "closed": 23,
      "open": 2
    },
    "2026-05-17": {
      "closed": 2,
      "open": 0
    },
    "2026-05-18": {
      "closed": 140,
      "open": 28
    },
    "2026-05-19": {
      "closed": 98,
      "open": 16
    },
    "2026-05-20": {
      "closed": 96,
      "open": 32
    },
    "2026-05-21": {
      "closed": 118,
      "open": 27
    },
    "2026-05-22": {
      "closed": 106,
      "open": 15
    },
    "2026-05-23": {
      "closed": 26,
      "open": 6
    },
    "2026-05-25": {
      "closed": 130,
      "open": 23
    },
    "2026-05-26": {
      "closed": 175,
      "open": 23
    },
    "2026-05-27": {
      "closed": 122,
      "open": 23
    },
    "2026-05-28": {
      "closed": 110,
      "open": 25
    },
    "2026-05-29": {
      "closed": 119,
      "open": 32
    },
    "2026-05-30": {
      "closed": 79,
      "open": 9
    },
    "2026-05-31": {
      "closed": 0,
      "open": 1
    },
    "2026-06-01": {
      "closed": 120,
      "open": 25
    },
    "2026-06-02": {
      "closed": 134,
      "open": 21
    },
    "2026-06-03": {
      "closed": 132,
      "open": 27
    },
    "2026-06-04": {
      "closed": 1,
      "open": 1
    },
    "2026-06-05": {
      "closed": 166,
      "open": 43
    },
    "2026-06-06": {
      "closed": 29,
      "open": 22
    },
    "2026-06-07": {
      "closed": 0,
      "open": 2
    },
    "2026-06-08": {
      "closed": 81,
      "open": 36
    }
  },
  "states": {
    "Closed": {
      "overall": {
        "avg_time_hours": 132.96,
        "mode_time_hours": 1.0,
        "mode_frequency": 4932,
        "time_distribution": {
          "0-2h": 4932,
          "2-4h": 1405,
          "4-6h": 734,
          "6-8h": 556,
          "8-10h": 316,
          "10-12h": 179,
          "12-14h": 173,
          "14-16h": 165,
          "16-18h": 211,
          "18-20h": 239,
          "20-22h": 227,
          "22-24h": 242,
          "24-26h": 258,
          "26-28h": 171,
          "28-30h": 171,
          "30-32h": 172,
          "32-34h": 120,
          "34-36h": 65,
          "36-38h": 89,
          "38-40h": 57,
          "40-42h": 97,
          "42-44h": 92,
          "44-46h": 112,
          "46-48h": 91,
          "48-50h": 111,
          "50-52h": 115,
          "52-54h": 86,
          "54-56h": 85,
          "56-58h": 62,
          "58-60h": 32,
          "60-62h": 34,
          "62-64h": 35,
          "64-66h": 47,
          "66-68h": 74,
          "68-70h": 60,
          "70-72h": 76,
          "72-74h": 117,
          "74-76h": 79,
          "76-78h": 68,
          "78-80h": 78,
          "80-82h": 47,
          "82-84h": 35,
          "84-86h": 33,
          "86-88h": 23,
          "88-90h": 26,
          "90-92h": 23,
          "92-94h": 42,
          "94-96h": 65,
          "96-98h": 66,
          "98-100h": 48,
          "100-102h": 55,
          "102-104h": 39,
          "104-106h": 36,
          "106-108h": 11,
          "108-110h": 8,
          "110-112h": 9,
          "112-114h": 17,
          "114-116h": 37,
          "116-118h": 34,
          "118-120h": 47,
          "120-122h": 45,
          "122-124h": 53,
          "124-126h": 39,
          "126-128h": 40,
          "128-130h": 25,
          "130-132h": 11,
          "132-134h": 18,
          "134-136h": 21,
          "136-138h": 21,
          "138-140h": 32,
          "140-142h": 50,
          "142-144h": 40,
          "144-146h": 51,
          "146-148h": 35,
          "148-150h": 38,
          "150-152h": 31,
          "152-154h": 12,
          "154-156h": 12,
          "156-158h": 18,
          "158-160h": 20,
          "160-162h": 30,
          "162-164h": 41,
          "164-166h": 48,
          "166-168h": 37,
          "168-170h": 28,
          "170-172h": 23,
          "172-174h": 27,
          "174-176h": 21,
          "176-178h": 18,
          "178-180h": 17,
          "180-182h": 25,
          "182-184h": 14,
          "184-186h": 16,
          "186-188h": 17,
          "188-190h": 15,
          "190-192h": 24,
          "192-194h": 35,
          "194-196h": 29,
          "196-198h": 19,
          "198-200h": 20,
          "200-202h": 19,
          "202-204h": 12,
          "204-206h": 18,
          "206-208h": 13,
          "208-210h": 15,
          "210-212h": 14,
          "212-214h": 13,
          "214-216h": 15,
          "216-218h": 47,
          "218-220h": 34,
          "220-222h": 11,
          "222-224h": 12,
          "224-226h": 3,
          "226-228h": 13,
          "228-230h": 14,
          "230-232h": 7,
          "232-234h": 8,
          "234-236h": 15,
          "236-238h": 10,
          "238-240h": 13,
          "240-242h": 29,
          "242-244h": 16,
          "244-246h": 8,
          "246-248h": 11,
          "248-250h": 9,
          "250-252h": 4,
          "252-254h": 5,
          "254-256h": 5,
          "256-258h": 13,
          "258-260h": 7,
          "260-262h": 11,
          "262-264h": 13,
          "264-266h": 10,
          "266-268h": 16,
          "268-270h": 22,
          "270-272h": 11,
          "272-274h": 12,
          "274-276h": 7,
          "276-278h": 15,
          "278-280h": 10,
          "280-282h": 7,
          "282-284h": 13,
          "284-286h": 10,
          "286-288h": 14,
          "288-290h": 22,
          "290-292h": 9,
          "292-294h": 12,
          "294-296h": 7,
          "296-298h": 1,
          "298-300h": 7,
          "300-302h": 12,
          "302-304h": 10,
          "304-306h": 12,
          "306-308h": 19,
          "308-310h": 13,
          "310-312h": 20,
          "312-314h": 21,
          "314-316h": 8,
          "316-318h": 16,
          "318-320h": 15,
          "320-322h": 9,
          "322-324h": 6,
          "324-326h": 11,
          "326-328h": 6,
          "328-330h": 10,
          "330-332h": 15,
          "332-334h": 20,
          "334-336h": 28,
          "336-338h": 34,
          "338-340h": 19,
          "340-342h": 17,
          "342-344h": 12,
          "344-346h": 10,
          "346-348h": 2,
          "348-350h": 19,
          "350-352h": 11,
          "352-354h": 9,
          "354-356h": 13,
          "356-358h": 17,
          "358-360h": 17,
          "360-362h": 15,
          "362-364h": 16,
          "364-366h": 11,
          "366-368h": 17,
          "368-370h": 11,
          "370-372h": 10,
          "372-374h": 24,
          "374-376h": 5,
          "376-378h": 8,
          "378-380h": 6,
          "380-382h": 13,
          "382-384h": 20,
          "384-386h": 31,
          "386-388h": 14,
          "388-390h": 19,
          "390-392h": 7,
          "392-394h": 6,
          "394-396h": 2,
          "396-398h": 4,
          "398-400h": 16,
          "400-402h": 14,
          "402-404h": 7,
          "404-406h": 19,
          "406-408h": 13,
          "408-410h": 23,
          "410-412h": 12,
          "412-414h": 9,
          "414-416h": 18,
          "416-418h": 12,
          "418-420h": 4,
          "420-422h": 10,
          "422-424h": 10,
          "424-426h": 13,
          "426-428h": 7,
          "428-430h": 12,
          "430-432h": 11,
          "432-434h": 11,
          "434-436h": 5,
          "436-438h": 3,
          "438-440h": 6,
          "440-442h": 1,
          "442-444h": 3,
          "444-446h": 7,
          "446-448h": 6,
          "448-450h": 4,
          "450-452h": 6,
          "452-454h": 11,
          "454-456h": 17,
          "456-458h": 17,
          "458-460h": 4,
          "460-462h": 4,
          "462-464h": 5,
          "464-466h": 3,
          "466-468h": 8,
          "468-470h": 4,
          "470-472h": 4,
          "472-474h": 13,
          "474-476h": 4,
          "476-478h": 6,
          "478-480h": 21,
          "480-482h": 6,
          "482-484h": 8,
          "486-488h": 3,
          "488-490h": 5,
          "490-492h": 7,
          "492-494h": 12,
          "494-496h": 5,
          "496-498h": 16,
          "498-500h": 9,
          "500-502h": 13,
          "502-504h": 18,
          "504-506h": 19,
          "506-508h": 8,
          "508-510h": 13,
          "510-512h": 5,
          "512-514h": 7,
          "514-516h": 7,
          "516-518h": 6,
          "518-520h": 3,
          "520-522h": 3,
          "522-524h": 7,
          "524-526h": 15,
          "526-528h": 14,
          "528-530h": 14,
          "530-532h": 9,
          "532-534h": 12,
          "534-536h": 5,
          "536-538h": 6,
          "538-540h": 7,
          "540-542h": 8,
          "542-544h": 5,
          "544-546h": 9,
          "546-548h": 6,
          "548-550h": 13,
          "550-552h": 5,
          "552-554h": 9,
          "554-556h": 3,
          "556-558h": 5,
          "558-560h": 6,
          "560-562h": 5,
          "562-564h": 2,
          "564-566h": 6,
          "566-568h": 4,
          "568-570h": 2,
          "570-572h": 5,
          "572-574h": 7,
          "574-576h": 8,
          "576-578h": 26,
          "578-580h": 8,
          "580-582h": 5,
          "582-584h": 13,
          "584-586h": 3,
          "586-588h": 1,
          "588-590h": 1,
          "590-592h": 1,
          "592-594h": 5,
          "594-596h": 5,
          "596-598h": 5,
          "598-600h": 4,
          "600-602h": 2,
          "602-604h": 2,
          "604-606h": 3,
          "606-608h": 1,
          "610-612h": 1,
          "612-614h": 3,
          "614-616h": 6,
          "616-618h": 11,
          "618-620h": 3,
          "620-622h": 2,
          "622-624h": 6,
          "624-626h": 7,
          "626-628h": 4,
          "628-630h": 7,
          "630-632h": 2,
          "634-636h": 5,
          "636-638h": 1,
          "638-640h": 5,
          "640-642h": 1,
          "642-644h": 8,
          "644-646h": 3,
          "646-648h": 4,
          "648-650h": 5,
          "650-652h": 8,
          "652-654h": 8,
          "654-656h": 7,
          "656-658h": 2,
          "658-660h": 5,
          "660-662h": 2,
          "662-664h": 3,
          "664-666h": 7,
          "666-668h": 4,
          "668-670h": 6,
          "670-672h": 10,
          "672-674h": 11,
          "674-676h": 4,
          "676-678h": 2,
          "678-680h": 8,
          "680-682h": 2,
          "682-684h": 9,
          "684-686h": 3,
          "688-690h": 1,
          "690-692h": 5,
          "692-694h": 6,
          "694-696h": 2,
          "696-698h": 7,
          "698-700h": 5,
          "700-702h": 7,
          "702-704h": 4,
          "704-706h": 3,
          "706-708h": 1,
          "708-710h": 1,
          "710-712h": 3,
          "714-716h": 4,
          "716-718h": 1,
          "718-720h": 3,
          "720-722h": 6,
          "722-724h": 7,
          "724-726h": 8,
          "726-728h": 2,
          "728-730h": 1,
          "730-732h": 2,
          "732-734h": 1,
          "734-736h": 7,
          "736-738h": 4,
          "738-740h": 5,
          "740-742h": 2,
          "742-744h": 4,
          "744-746h": 7,
          "746-748h": 6,
          "748-750h": 3,
          "750-752h": 3,
          "752-754h": 1,
          "754-756h": 1,
          "756-758h": 3,
          "758-760h": 3,
          "760-762h": 1,
          "762-764h": 2,
          "764-766h": 2,
          "766-768h": 5,
          "768-770h": 7,
          "772-774h": 4,
          "780-782h": 2,
          "782-784h": 1,
          "784-786h": 1,
          "786-788h": 3,
          "788-790h": 4,
          "790-792h": 5,
          "792-794h": 4,
          "794-796h": 4,
          "796-798h": 2,
          "798-800h": 2,
          "800-802h": 4,
          "804-806h": 5,
          "806-808h": 1,
          "808-810h": 5,
          "810-812h": 3,
          "812-814h": 1,
          "814-816h": 7,
          "816-818h": 7,
          "818-820h": 5,
          "820-822h": 5,
          "822-824h": 3,
          "824-826h": 6,
          "826-828h": 4,
          "828-830h": 1,
          "830-832h": 1,
          "834-836h": 3,
          "836-838h": 3,
          "838-840h": 3,
          "840-842h": 7,
          "842-844h": 8,
          "844-846h": 7,
          "846-848h": 4,
          "848-850h": 3,
          "850-852h": 2,
          "852-854h": 3,
          "854-856h": 2,
          "858-860h": 1,
          "860-862h": 4,
          "862-864h": 2,
          "864-866h": 3,
          "866-868h": 5,
          "870-872h": 2,
          "872-874h": 5,
          "876-878h": 4,
          "878-880h": 1,
          "882-884h": 2,
          "884-886h": 1,
          "886-888h": 4,
          "888-890h": 3,
          "890-892h": 5,
          "892-894h": 6,
          "894-896h": 2,
          "896-898h": 4,
          "898-900h": 4,
          "900-902h": 1,
          "902-904h": 4,
          "904-906h": 1,
          "906-908h": 2,
          "908-910h": 2,
          "910-912h": 3,
          "912-914h": 3,
          "914-916h": 1,
          "916-918h": 4,
          "918-920h": 1,
          "922-924h": 2,
          "924-926h": 2,
          "934-936h": 1,
          "936-938h": 2,
          "938-940h": 2,
          "940-942h": 2,
          "942-944h": 1,
          "944-946h": 2,
          "952-954h": 1,
          "954-956h": 1,
          "956-958h": 1,
          "960-962h": 3,
          "964-966h": 1,
          "966-968h": 2,
          "968-970h": 1,
          "970-972h": 1,
          "972-974h": 2,
          "974-976h": 1,
          "976-978h": 2,
          "978-980h": 2,
          "980-982h": 1,
          "982-984h": 4,
          "984-986h": 7,
          "986-988h": 5,
          "988-990h": 3,
          "990-992h": 2,
          "992-994h": 1,
          "994-996h": 2,
          "1000-1002h": 4,
          "1002-1004h": 4,
          "1006-1008h": 1,
          "1008-1010h": 6,
          "1010-1012h": 1,
          "1012-1014h": 4,
          "1018-1020h": 3,
          "1020-1022h": 3,
          "1024-1026h": 1,
          "1026-1028h": 3,
          "1028-1030h": 3,
          "1030-1032h": 3,
          "1032-1034h": 2,
          "1034-1036h": 2,
          "1036-1038h": 2,
          "1038-1040h": 3,
          "1044-1046h": 1,
          "1046-1048h": 2,
          "1050-1052h": 3,
          "1052-1054h": 2,
          "1054-1056h": 6,
          "1056-1058h": 4,
          "1058-1060h": 2,
          "1060-1062h": 2,
          "1066-1068h": 1,
          "1068-1070h": 2,
          "1070-1072h": 1,
          "1072-1074h": 3,
          "1074-1076h": 1,
          "1076-1078h": 3,
          "1078-1080h": 4,
          "1080-1082h": 6,
          "1084-1086h": 1,
          "1086-1088h": 4,
          "1092-1094h": 1,
          "1096-1098h": 2,
          "1098-1100h": 1,
          "1100-1102h": 2,
          "1102-1104h": 2,
          "1104-1106h": 4,
          "1106-1108h": 1,
          "1112-1114h": 1,
          "1114-1116h": 1,
          "1122-1124h": 1,
          "1124-1126h": 9,
          "1128-1130h": 1,
          "1134-1136h": 1,
          "1138-1140h": 2,
          "1140-1142h": 1,
          "1142-1144h": 3,
          "1144-1146h": 1,
          "1146-1148h": 1,
          "1150-1152h": 1,
          "1152-1154h": 5,
          "1156-1158h": 1,
          "1158-1160h": 1,
          "1162-1164h": 3,
          "1166-1168h": 1,
          "1170-1172h": 2,
          "1174-1176h": 1,
          "1176-1178h": 3,
          "1178-1180h": 3,
          "1180-1182h": 2,
          "1188-1190h": 1,
          "1190-1192h": 1,
          "1194-1196h": 1,
          "1196-1198h": 2,
          "1198-1200h": 5,
          "1200-1202h": 4,
          "1202-1204h": 1,
          "1208-1210h": 1,
          "1212-1214h": 1,
          "1214-1216h": 1,
          "1216-1218h": 2,
          "1218-1220h": 1,
          "1222-1224h": 5,
          "1224-1226h": 1,
          "1228-1230h": 2,
          "1230-1232h": 1,
          "1234-1236h": 1,
          "1236-1238h": 4,
          "1238-1240h": 2,
          "1240-1242h": 1,
          "1242-1244h": 2,
          "1244-1246h": 2,
          "1248-1250h": 4,
          "1250-1252h": 1,
          "1252-1254h": 2,
          "1256-1258h": 1,
          "1258-1260h": 1,
          "1264-1266h": 1,
          "1266-1268h": 1,
          "1268-1270h": 1,
          "1270-1272h": 3,
          "1272-1274h": 1,
          "1276-1278h": 1,
          "1278-1280h": 1,
          "1282-1284h": 2,
          "1284-1286h": 3,
          "1294-1296h": 1,
          "1298-1300h": 1,
          "1300-1302h": 1,
          "1306-1308h": 1,
          "1310-1312h": 1,
          "1314-1316h": 1,
          "1316-1318h": 2,
          "1320-1322h": 1,
          "1322-1324h": 1,
          "1324-1326h": 1,
          "1326-1328h": 1,
          "1336-1338h": 2,
          "1338-1340h": 4,
          "1340-1342h": 2,
          "1342-1344h": 1,
          "1344-1346h": 1,
          "1348-1350h": 1,
          "1360-1362h": 2,
          "1362-1364h": 2,
          "1366-1368h": 1,
          "1368-1370h": 2,
          "1376-1378h": 3,
          "1380-1382h": 1,
          "1388-1390h": 1,
          "1390-1392h": 3,
          "1392-1394h": 1,
          "1404-1406h": 2,
          "1406-1408h": 1,
          "1408-1410h": 1,
          "1410-1412h": 1,
          "1412-1414h": 1,
          "1414-1416h": 1,
          "1416-1418h": 6,
          "1422-1424h": 1,
          "1424-1426h": 1,
          "1426-1428h": 1,
          "1440-1442h": 1,
          "1454-1456h": 1,
          "1460-1462h": 3,
          "1462-1464h": 3,
          "1468-1470h": 1,
          "1476-1478h": 2,
          "1480-1482h": 1,
          "1482-1484h": 1,
          "1486-1488h": 1,
          "1488-1490h": 1,
          "1498-1500h": 1,
          "1500-1502h": 1,
          "1502-1504h": 1,
          "1506-1508h": 3,
          "1508-1510h": 1,
          "1514-1516h": 3,
          "1518-1520h": 1,
          "1532-1534h": 2,
          "1546-1548h": 2,
          "1548-1550h": 1,
          "1556-1558h": 1,
          "1560-1562h": 1,
          "1562-1564h": 1,
          "1570-1572h": 1,
          "1578-1580h": 1,
          "1582-1584h": 1,
          "1584-1586h": 1,
          "1620-1622h": 1,
          "1622-1624h": 1,
          "1632-1634h": 1,
          "1634-1636h": 3,
          "1636-1638h": 1,
          "1658-1660h": 1,
          "1660-1662h": 1,
          "1670-1672h": 1,
          "1684-1686h": 2,
          "1686-1688h": 1,
          "1698-1700h": 2,
          "1704-1706h": 2,
          "1712-1714h": 1,
          "1718-1720h": 2,
          "1728-1730h": 2,
          "1732-1734h": 3,
          "1752-1754h": 2,
          "1756-1758h": 1,
          "1762-1764h": 1,
          "1770-1772h": 1,
          "1778-1780h": 1,
          "1786-1788h": 1,
          "1796-1798h": 1,
          "1830-1832h": 1,
          "1838-1840h": 2,
          "1842-1844h": 1,
          "1844-1846h": 1,
          "1846-1848h": 1,
          "1852-1854h": 1,
          "1856-1858h": 1,
          "1862-1864h": 1,
          "1872-1874h": 1,
          "1896-1898h": 2,
          "1906-1908h": 1,
          "1916-1918h": 1,
          "1942-1944h": 1,
          "1944-1946h": 1,
          "1962-1964h": 2,
          "1964-1966h": 2,
          "2008-2010h": 1,
          "2016-2018h": 1,
          "2032-2034h": 1,
          "2036-2038h": 1,
          "2040-2042h": 1,
          "2044-2046h": 2,
          "2048-2050h": 1,
          "2054-2056h": 1,
          "2060-2062h": 1,
          "2108-2110h": 1,
          "2124-2126h": 1,
          "2132-2134h": 1,
          "2138-2140h": 1,
          "2152-2154h": 1,
          "2158-2160h": 1,
          "2160-2162h": 1,
          "2182-2184h": 1,
          "2208-2210h": 1,
          "2212-2214h": 1,
          "2250-2252h": 1,
          "2272-2274h": 1,
          "2280-2282h": 1,
          "2304-2306h": 1,
          "2344-2346h": 1,
          "2350-2352h": 1,
          "2372-2374h": 1,
          "2374-2376h": 1,
          "2390-2392h": 1,
          "2392-2394h": 1,
          "2510-2512h": 1,
          "2524-2526h": 2,
          "2534-2536h": 1,
          "2560-2562h": 1,
          "2696-2698h": 1,
          "2734-2736h": 1,
          "2886-2888h": 1,
          "2902-2904h": 1,
          "3002-3004h": 3,
          "3186-3188h": 1,
          "3246-3248h": 1,
          "3262-3264h": 1,
          "3550-3552h": 1,
          "3554-3556h": 1,
          "4036-4038h": 1
        },
        "tickets_count": 17013,
        "tickets_per_day": {
          "2025-09-30": 32,
          "2025-10-01": 15,
          "2025-10-02": 6,
          "2025-10-03": 10,
          "2025-10-06": 19,
          "2025-10-07": 65,
          "2025-10-08": 26,
          "2025-10-09": 37,
          "2025-10-10": 45,
          "2025-10-11": 2,
          "2025-10-12": 1,
          "2025-10-13": 52,
          "2025-10-14": 69,
          "2025-10-15": 76,
          "2025-10-16": 16,
          "2025-10-17": 36,
          "2025-10-18": 4,
          "2025-10-20": 26,
          "2025-10-21": 37,
          "2025-10-22": 36,
          "2025-10-23": 83,
          "2025-10-24": 32,
          "2025-10-25": 14,
          "2025-10-26": 1,
          "2025-10-27": 70,
          "2025-10-28": 51,
          "2025-10-29": 55,
          "2025-10-30": 64,
          "2025-10-31": 64,
          "2025-11-02": 1,
          "2025-11-03": 66,
          "2025-11-04": 49,
          "2025-11-05": 59,
          "2025-11-06": 73,
          "2025-11-07": 45,
          "2025-11-08": 4,
          "2025-11-09": 1,
          "2025-11-10": 65,
          "2025-11-11": 55,
          "2025-11-12": 70,
          "2025-11-13": 81,
          "2025-11-14": 70,
          "2025-11-15": 1,
          "2025-11-16": 3,
          "2025-11-17": 93,
          "2025-11-18": 37,
          "2025-11-19": 86,
          "2025-11-20": 67,
          "2025-11-21": 85,
          "2025-11-22": 31,
          "2025-11-23": 19,
          "2025-11-24": 103,
          "2025-11-25": 49,
          "2025-11-26": 47,
          "2025-11-27": 65,
          "2025-11-28": 53,
          "2025-11-29": 45,
          "2025-11-30": 7,
          "2025-12-01": 3,
          "2025-12-02": 134,
          "2025-12-03": 87,
          "2025-12-04": 86,
          "2025-12-05": 71,
          "2025-12-06": 3,
          "2025-12-07": 1,
          "2025-12-08": 4,
          "2025-12-09": 45,
          "2025-12-10": 73,
          "2025-12-11": 94,
          "2025-12-12": 63,
          "2025-12-13": 15,
          "2025-12-14": 15,
          "2025-12-15": 163,
          "2025-12-16": 31,
          "2025-12-17": 49,
          "2025-12-18": 48,
          "2025-12-19": 58,
          "2025-12-20": 2,
          "2025-12-21": 1,
          "2025-12-22": 62,
          "2025-12-23": 36,
          "2025-12-24": 7,
          "2025-12-25": 1,
          "2025-12-26": 59,
          "2025-12-28": 6,
          "2025-12-29": 52,
          "2025-12-30": 27,
          "2025-12-31": 10,
          "2026-01-02": 35,
          "2026-01-03": 2,
          "2026-01-04": 2,
          "2026-01-05": 46,
          "2026-01-06": 44,
          "2026-01-07": 60,
          "2026-01-08": 99,
          "2026-01-09": 54,
          "2026-01-10": 8,
          "2026-01-11": 4,
          "2026-01-12": 49,
          "2026-01-13": 149,
          "2026-01-14": 101,
          "2026-01-15": 151,
          "2026-01-16": 97,
          "2026-01-17": 46,
          "2026-01-18": 12,
          "2026-01-19": 88,
          "2026-01-20": 86,
          "2026-01-21": 72,
          "2026-01-22": 69,
          "2026-01-23": 125,
          "2026-01-24": 34,
          "2026-01-26": 96,
          "2026-01-27": 184,
          "2026-01-28": 61,
          "2026-01-29": 50,
          "2026-01-30": 85,
          "2026-01-31": 26,
          "2026-02-02": 58,
          "2026-02-03": 228,
          "2026-02-04": 84,
          "2026-02-05": 80,
          "2026-02-06": 143,
          "2026-02-07": 37,
          "2026-02-09": 125,
          "2026-02-10": 244,
          "2026-02-11": 48,
          "2026-02-12": 135,
          "2026-02-13": 151,
          "2026-02-14": 84,
          "2026-02-16": 67,
          "2026-02-17": 44,
          "2026-02-18": 189,
          "2026-02-19": 503,
          "2026-02-20": 89,
          "2026-02-21": 69,
          "2026-02-22": 4,
          "2026-02-23": 115,
          "2026-02-24": 72,
          "2026-02-25": 66,
          "2026-02-26": 38,
          "2026-02-27": 37,
          "2026-02-28": 154,
          "2026-03-01": 21,
          "2026-03-02": 131,
          "2026-03-03": 68,
          "2026-03-04": 100,
          "2026-03-05": 96,
          "2026-03-06": 89,
          "2026-03-07": 43,
          "2026-03-08": 2,
          "2026-03-09": 131,
          "2026-03-10": 94,
          "2026-03-11": 97,
          "2026-03-12": 76,
          "2026-03-13": 63,
          "2026-03-14": 50,
          "2026-03-15": 2,
          "2026-03-16": 106,
          "2026-03-17": 223,
          "2026-03-18": 605,
          "2026-03-19": 89,
          "2026-03-20": 196,
          "2026-03-21": 10,
          "2026-03-22": 1,
          "2026-03-23": 118,
          "2026-03-24": 135,
          "2026-03-25": 95,
          "2026-03-26": 113,
          "2026-03-27": 59,
          "2026-03-28": 14,
          "2026-03-29": 1,
          "2026-03-30": 117,
          "2026-03-31": 98,
          "2026-04-01": 60,
          "2026-04-02": 77,
          "2026-04-04": 18,
          "2026-04-06": 113,
          "2026-04-07": 90,
          "2026-04-08": 85,
          "2026-04-09": 84,
          "2026-04-10": 128,
          "2026-04-11": 34,
          "2026-04-13": 114,
          "2026-04-14": 86,
          "2026-04-15": 67,
          "2026-04-16": 109,
          "2026-04-17": 97,
          "2026-04-18": 29,
          "2026-04-20": 103,
          "2026-04-21": 55,
          "2026-04-22": 178,
          "2026-04-23": 178,
          "2026-04-24": 66,
          "2026-04-26": 2,
          "2026-04-27": 139,
          "2026-04-28": 66,
          "2026-04-29": 94,
          "2026-04-30": 92,
          "2026-05-01": 2,
          "2026-05-02": 64,
          "2026-05-04": 176,
          "2026-05-05": 101,
          "2026-05-06": 158,
          "2026-05-07": 86,
          "2026-05-08": 75,
          "2026-05-09": 37,
          "2026-05-10": 4,
          "2026-05-11": 131,
          "2026-05-12": 85,
          "2026-05-13": 93,
          "2026-05-14": 136,
          "2026-05-15": 72,
          "2026-05-16": 23,
          "2026-05-17": 2,
          "2026-05-18": 140,
          "2026-05-19": 98,
          "2026-05-20": 96,
          "2026-05-21": 118,
          "2026-05-22": 106,
          "2026-05-23": 26,
          "2026-05-25": 130,
          "2026-05-26": 175,
          "2026-05-27": 122,
          "2026-05-28": 110,
          "2026-05-29": 119,
          "2026-05-30": 79,
          "2026-06-01": 120,
          "2026-06-02": 134,
          "2026-06-03": 132,
          "2026-06-04": 1,
          "2026-06-05": 166,
          "2026-06-06": 29,
          "2026-06-08": 81
        },
        "time_per_day": {
          "2025-09-30": 61.596623055555554,
          "2025-10-01": 196.9393516666667,
          "2025-10-02": 68.82497972222222,
          "2025-10-03": 278.10397083333334,
          "2025-10-06": 980.9109608333335,
          "2025-10-07": 3176.1000538888893,
          "2025-10-08": 520.4982275,
          "2025-10-09": 2354.2408527777775,
          "2025-10-10": 2969.360829722223,
          "2025-10-11": 82.95310138888888,
          "2025-10-12": 209.2571233333333,
          "2025-10-13": 4070.9128352777766,
          "2025-10-14": 4838.656646666667,
          "2025-10-15": 3769.4640152777756,
          "2025-10-16": 686.5888763888887,
          "2025-10-17": 987.2313408333331,
          "2025-10-18": 254.13021972222222,
          "2025-10-20": 1522.1279552777776,
          "2025-10-21": 1778.1337725,
          "2025-10-22": 2763.703766944444,
          "2025-10-23": 6692.763665833332,
          "2025-10-24": 2272.0272075,
          "2025-10-25": 1150.460113611111,
          "2025-10-26": 0.5912069444444444,
          "2025-10-27": 4032.1111841666657,
          "2025-10-28": 3529.423317777777,
          "2025-10-29": 3516.871922222221,
          "2025-10-30": 5738.370724444447,
          "2025-10-31": 3989.094218055556,
          "2025-11-02": 6.409595277777778,
          "2025-11-03": 7377.717454444442,
          "2025-11-04": 7144.637040277776,
          "2025-11-05": 6452.715123888891,
          "2025-11-06": 7833.494525,
          "2025-11-07": 2473.572481944442,
          "2025-11-08": 377.22756611111106,
          "2025-11-09": 41.51824638888889,
          "2025-11-10": 4385.906189999999,
          "2025-11-11": 2676.2529769444436,
          "2025-11-12": 5723.552211111111,
          "2025-11-13": 8162.121387222224,
          "2025-11-14": 9193.56103388889,
          "2025-11-15": 0.20001194444444445,
          "2025-11-16": 254.96224861111108,
          "2025-11-17": 6821.806228055553,
          "2025-11-18": 4696.607037500001,
          "2025-11-19": 10085.755151111114,
          "2025-11-20": 6592.177482777778,
          "2025-11-21": 7328.813995833334,
          "2025-11-22": 2119.7146083333337,
          "2025-11-23": 1237.1638888888892,
          "2025-11-24": 10559.41269444444,
          "2025-11-25": 3688.9517680555564,
          "2025-11-26": 3184.0449055555555,
          "2025-11-27": 6886.121121388892,
          "2025-11-28": 3015.607518055555,
          "2025-11-29": 8978.376542777778,
          "2025-11-30": 181.7347913888889,
          "2025-12-01": 13.940388888888888,
          "2025-12-02": 16812.67966166668,
          "2025-12-03": 7275.251154722219,
          "2025-12-04": 12757.499290833333,
          "2025-12-05": 5546.25465888889,
          "2025-12-06": 123.77260305555556,
          "2025-12-07": 0.18633083333333333,
          "2025-12-08": 315.08094166666666,
          "2025-12-09": 4086.9430838888893,
          "2025-12-10": 8656.478651944448,
          "2025-12-11": 16376.588444166659,
          "2025-12-12": 8705.988250555563,
          "2025-12-13": 2703.276666666666,
          "2025-12-14": 685.2369952777777,
          "2025-12-15": 30925.605159444443,
          "2025-12-16": 3780.0738175000006,
          "2025-12-17": 5336.026821944442,
          "2025-12-18": 3674.693290555555,
          "2025-12-19": 12376.523200833337,
          "2025-12-20": 423.2800086111111,
          "2025-12-21": 89.8079611111111,
          "2025-12-22": 6150.036196388889,
          "2025-12-23": 1583.2492358333332,
          "2025-12-24": 912.5583411111112,
          "2025-12-25": 56.22132055555555,
          "2025-12-26": 8840.521043333334,
          "2025-12-28": 151.51704444444445,
          "2025-12-29": 11165.618726944442,
          "2025-12-30": 1431.4333705555555,
          "2025-12-31": 3863.6394030555557,
          "2026-01-02": 6868.73892361111,
          "2026-01-03": 0.9715977777777778,
          "2026-01-04": 0.23874944444444446,
          "2026-01-05": 8736.747419166668,
          "2026-01-06": 2522.113503333334,
          "2026-01-07": 12450.814106944445,
          "2026-01-08": 5037.604289999999,
          "2026-01-09": 10182.374179444443,
          "2026-01-10": 78.79100722222223,
          "2026-01-11": 3729.0510155555553,
          "2026-01-12": 1435.6347202777788,
          "2026-01-13": 6557.731326666666,
          "2026-01-14": 3750.173473055556,
          "2026-01-15": 10481.81418472222,
          "2026-01-16": 5215.87991611111,
          "2026-01-17": 3895.905014722223,
          "2026-01-18": 160.9764772222222,
          "2026-01-19": 4248.947453055555,
          "2026-01-20": 5296.979418888891,
          "2026-01-21": 7178.766619166663,
          "2026-01-22": 2928.811829444445,
          "2026-01-23": 18259.032686666662,
          "2026-01-24": 5395.097718055556,
          "2026-01-26": 3055.9585050000014,
          "2026-01-27": 11272.891050833341,
          "2026-01-28": 1092.7924902777775,
          "2026-01-29": 1474.7963669444437,
          "2026-01-30": 6866.979738055559,
          "2026-01-31": 1208.9614163888893,
          "2026-02-02": 1625.0978091666668,
          "2026-02-03": 52594.569777777746,
          "2026-02-04": 8648.809463055557,
          "2026-02-05": 6062.370363333332,
          "2026-02-06": 24127.82026166669,
          "2026-02-07": 2924.4941602777776,
          "2026-02-09": 9882.658973611104,
          "2026-02-10": 64861.01205555554,
          "2026-02-11": 5220.143958055559,
          "2026-02-12": 65746.37670944439,
          "2026-02-13": 27958.326322500005,
          "2026-02-14": 6946.310749999996,
          "2026-02-16": 16735.951128055553,
          "2026-02-17": 11264.954725833339,
          "2026-02-18": 79174.6525083333,
          "2026-02-19": 257925.11891472235,
          "2026-02-20": 6614.906318333335,
          "2026-02-21": 1967.3637072222225,
          "2026-02-22": 110.75504972222221,
          "2026-02-23": 6608.208586388887,
          "2026-02-24": 2205.2130186111117,
          "2026-02-25": 4484.1733461111135,
          "2026-02-26": 206.56495527777778,
          "2026-02-27": 998.1800433333334,
          "2026-02-28": 9373.519005833332,
          "2026-03-01": 500.97941805555564,
          "2026-03-02": 6034.075889722222,
          "2026-03-03": 4946.732228888888,
          "2026-03-04": 1652.2000175000007,
          "2026-03-05": 11185.16706055556,
          "2026-03-06": 11566.902918055559,
          "2026-03-07": 859.796134722222,
          "2026-03-08": 0.020296944444444444,
          "2026-03-09": 28020.714580000003,
          "2026-03-10": 10589.992739166668,
          "2026-03-11": 21713.44398416667,
          "2026-03-12": 8323.776030277775,
          "2026-03-13": 4868.406361944443,
          "2026-03-14": 2855.869133055555,
          "2026-03-15": 64.48122388888889,
          "2026-03-16": 3351.442632222224,
          "2026-03-17": 36982.90728805549,
          "2026-03-18": 168726.25674416698,
          "2026-03-19": 6604.999400277777,
          "2026-03-20": 70433.57385750003,
          "2026-03-21": 70.54546388888889,
          "2026-03-22": 196.89580444444442,
          "2026-03-23": 8328.190113611114,
          "2026-03-24": 19235.77871944445,
          "2026-03-25": 12688.541584166669,
          "2026-03-26": 35258.75860444442,
          "2026-03-27": 6297.118684166668,
          "2026-03-28": 71.58218444444444,
          "2026-03-29": 17.501973055555556,
          "2026-03-30": 10393.18594472222,
          "2026-03-31": 10184.581514444446,
          "2026-04-01": 4102.024853611114,
          "2026-04-02": 13726.475806111099,
          "2026-04-04": 110.63407027777777,
          "2026-04-06": 2543.02861388889,
          "2026-04-07": 13247.14407083334,
          "2026-04-08": 2763.581576111111,
          "2026-04-09": 11834.029059444436,
          "2026-04-10": 38671.75033972225,
          "2026-04-11": 725.0048705555555,
          "2026-04-13": 10490.437902222222,
          "2026-04-14": 6921.950294444445,
          "2026-04-15": 3439.8913883333344,
          "2026-04-16": 30770.00889055557,
          "2026-04-17": 11557.60417194445,
          "2026-04-18": 13754.497792499998,
          "2026-04-20": 6323.734686388886,
          "2026-04-21": 1026.9557083333339,
          "2026-04-22": 51257.42476111109,
          "2026-04-23": 91826.51790277772,
          "2026-04-24": 1090.5577544444443,
          "2026-04-26": 1153.7789744444444,
          "2026-04-27": 4103.785668333337,
          "2026-04-28": 6714.105232499997,
          "2026-04-29": 8934.300328333335,
          "2026-04-30": 5260.577818055557,
          "2026-05-01": 392.60974166666665,
          "2026-05-02": 1726.0781477777778,
          "2026-05-04": 21170.657318611098,
          "2026-05-05": 15514.441543611109,
          "2026-05-06": 40266.5540452778,
          "2026-05-07": 8369.17597972222,
          "2026-05-08": 11352.927791111111,
          "2026-05-09": 819.9395277777779,
          "2026-05-10": 245.4068125,
          "2026-05-11": 729.7412805555552,
          "2026-05-12": 3345.0196886111103,
          "2026-05-13": 4100.181715833332,
          "2026-05-14": 27593.240353611116,
          "2026-05-15": 561.9836505555558,
          "2026-05-16": 180.63948555555552,
          "2026-05-17": 192.6073972222222,
          "2026-05-18": 4269.251901666668,
          "2026-05-19": 3698.766550833334,
          "2026-05-20": 973.4412572222221,
          "2026-05-21": 4171.182458888889,
          "2026-05-22": 6114.412836944444,
          "2026-05-23": 257.73066444444447,
          "2026-05-25": 3254.617029722219,
          "2026-05-26": 10757.702339722213,
          "2026-05-27": 8349.799861388887,
          "2026-05-28": 5001.750936666668,
          "2026-05-29": 3553.961519166667,
          "2026-05-30": 8963.331301111106,
          "2026-06-01": 4482.306656388887,
          "2026-06-02": 5064.602337499998,
          "2026-06-03": 4604.907478611111,
          "2026-06-04": 888.8700166666666,
          "2026-06-05": 2024.503944444445,
          "2026-06-06": 5075.259952222224,
          "2026-06-08": 1241.1713141666667
        },
        "time_count_per_day": {
          "2025-09-30": 32,
          "2025-10-01": 15,
          "2025-10-02": 6,
          "2025-10-03": 10,
          "2025-10-06": 19,
          "2025-10-07": 65,
          "2025-10-08": 26,
          "2025-10-09": 37,
          "2025-10-10": 45,
          "2025-10-11": 2,
          "2025-10-12": 1,
          "2025-10-13": 52,
          "2025-10-14": 69,
          "2025-10-15": 76,
          "2025-10-16": 16,
          "2025-10-17": 36,
          "2025-10-18": 4,
          "2025-10-20": 26,
          "2025-10-21": 37,
          "2025-10-22": 36,
          "2025-10-23": 83,
          "2025-10-24": 32,
          "2025-10-25": 14,
          "2025-10-26": 1,
          "2025-10-27": 70,
          "2025-10-28": 51,
          "2025-10-29": 55,
          "2025-10-30": 64,
          "2025-10-31": 64,
          "2025-11-02": 1,
          "2025-11-03": 66,
          "2025-11-04": 49,
          "2025-11-05": 59,
          "2025-11-06": 73,
          "2025-11-07": 45,
          "2025-11-08": 4,
          "2025-11-09": 1,
          "2025-11-10": 65,
          "2025-11-11": 55,
          "2025-11-12": 70,
          "2025-11-13": 81,
          "2025-11-14": 70,
          "2025-11-15": 1,
          "2025-11-16": 3,
          "2025-11-17": 93,
          "2025-11-18": 37,
          "2025-11-19": 86,
          "2025-11-20": 67,
          "2025-11-21": 85,
          "2025-11-22": 31,
          "2025-11-23": 19,
          "2025-11-24": 103,
          "2025-11-25": 49,
          "2025-11-26": 47,
          "2025-11-27": 65,
          "2025-11-28": 53,
          "2025-11-29": 45,
          "2025-11-30": 7,
          "2025-12-01": 3,
          "2025-12-02": 134,
          "2025-12-03": 87,
          "2025-12-04": 86,
          "2025-12-05": 71,
          "2025-12-06": 3,
          "2025-12-07": 1,
          "2025-12-08": 4,
          "2025-12-09": 45,
          "2025-12-10": 73,
          "2025-12-11": 94,
          "2025-12-12": 63,
          "2025-12-13": 15,
          "2025-12-14": 15,
          "2025-12-15": 163,
          "2025-12-16": 31,
          "2025-12-17": 49,
          "2025-12-18": 48,
          "2025-12-19": 58,
          "2025-12-20": 2,
          "2025-12-21": 1,
          "2025-12-22": 62,
          "2025-12-23": 36,
          "2025-12-24": 7,
          "2025-12-25": 1,
          "2025-12-26": 59,
          "2025-12-28": 6,
          "2025-12-29": 52,
          "2025-12-30": 27,
          "2025-12-31": 10,
          "2026-01-02": 35,
          "2026-01-03": 2,
          "2026-01-04": 2,
          "2026-01-05": 46,
          "2026-01-06": 44,
          "2026-01-07": 60,
          "2026-01-08": 99,
          "2026-01-09": 54,
          "2026-01-10": 8,
          "2026-01-11": 4,
          "2026-01-12": 49,
          "2026-01-13": 149,
          "2026-01-14": 101,
          "2026-01-15": 151,
          "2026-01-16": 97,
          "2026-01-17": 46,
          "2026-01-18": 12,
          "2026-01-19": 88,
          "2026-01-20": 86,
          "2026-01-21": 72,
          "2026-01-22": 69,
          "2026-01-23": 125,
          "2026-01-24": 34,
          "2026-01-26": 96,
          "2026-01-27": 184,
          "2026-01-28": 61,
          "2026-01-29": 50,
          "2026-01-30": 85,
          "2026-01-31": 26,
          "2026-02-02": 58,
          "2026-02-03": 228,
          "2026-02-04": 84,
          "2026-02-05": 80,
          "2026-02-06": 143,
          "2026-02-07": 37,
          "2026-02-09": 125,
          "2026-02-10": 244,
          "2026-02-11": 48,
          "2026-02-12": 135,
          "2026-02-13": 151,
          "2026-02-14": 84,
          "2026-02-16": 67,
          "2026-02-17": 44,
          "2026-02-18": 189,
          "2026-02-19": 503,
          "2026-02-20": 89,
          "2026-02-21": 69,
          "2026-02-22": 4,
          "2026-02-23": 115,
          "2026-02-24": 72,
          "2026-02-25": 66,
          "2026-02-26": 38,
          "2026-02-27": 37,
          "2026-02-28": 154,
          "2026-03-01": 21,
          "2026-03-02": 131,
          "2026-03-03": 68,
          "2026-03-04": 100,
          "2026-03-05": 96,
          "2026-03-06": 89,
          "2026-03-07": 43,
          "2026-03-08": 2,
          "2026-03-09": 131,
          "2026-03-10": 94,
          "2026-03-11": 97,
          "2026-03-12": 76,
          "2026-03-13": 63,
          "2026-03-14": 50,
          "2026-03-15": 2,
          "2026-03-16": 106,
          "2026-03-17": 223,
          "2026-03-18": 605,
          "2026-03-19": 89,
          "2026-03-20": 196,
          "2026-03-21": 10,
          "2026-03-22": 1,
          "2026-03-23": 118,
          "2026-03-24": 135,
          "2026-03-25": 95,
          "2026-03-26": 113,
          "2026-03-27": 59,
          "2026-03-28": 14,
          "2026-03-29": 1,
          "2026-03-30": 117,
          "2026-03-31": 98,
          "2026-04-01": 60,
          "2026-04-02": 77,
          "2026-04-04": 18,
          "2026-04-06": 113,
          "2026-04-07": 90,
          "2026-04-08": 85,
          "2026-04-09": 84,
          "2026-04-10": 128,
          "2026-04-11": 34,
          "2026-04-13": 114,
          "2026-04-14": 86,
          "2026-04-15": 67,
          "2026-04-16": 109,
          "2026-04-17": 97,
          "2026-04-18": 29,
          "2026-04-20": 103,
          "2026-04-21": 55,
          "2026-04-22": 178,
          "2026-04-23": 178,
          "2026-04-24": 66,
          "2026-04-26": 2,
          "2026-04-27": 139,
          "2026-04-28": 66,
          "2026-04-29": 94,
          "2026-04-30": 92,
          "2026-05-01": 2,
          "2026-05-02": 64,
          "2026-05-04": 176,
          "2026-05-05": 101,
          "2026-05-06": 158,
          "2026-05-07": 86,
          "2026-05-08": 75,
          "2026-05-09": 37,
          "2026-05-10": 4,
          "2026-05-11": 131,
          "2026-05-12": 85,
          "2026-05-13": 93,
          "2026-05-14": 136,
          "2026-05-15": 72,
          "2026-05-16": 23,
          "2026-05-17": 2,
          "2026-05-18": 140,
          "2026-05-19": 98,
          "2026-05-20": 96,
          "2026-05-21": 118,
          "2026-05-22": 106,
          "2026-05-23": 26,
          "2026-05-25": 130,
          "2026-05-26": 175,
          "2026-05-27": 122,
          "2026-05-28": 110,
          "2026-05-29": 119,
          "2026-05-30": 79,
          "2026-06-01": 120,
          "2026-06-02": 134,
          "2026-06-03": 132,
          "2026-06-04": 1,
          "2026-06-05": 166,
          "2026-06-06": 29,
          "2026-06-08": 81
        }
      },
      "priorities": {
        "P1": {
          "avg_time_hours": 68.5,
          "mode_time_hours": 1.0,
          "mode_frequency": 132,
          "time_distribution": {
            "0-2h": 132,
            "2-4h": 121,
            "4-6h": 50,
            "6-8h": 73,
            "8-10h": 30,
            "10-12h": 10,
            "12-14h": 8,
            "14-16h": 11,
            "16-18h": 12,
            "18-20h": 12,
            "20-22h": 10,
            "22-24h": 17,
            "24-26h": 20,
            "26-28h": 10,
            "28-30h": 7,
            "30-32h": 7,
            "32-34h": 8,
            "34-36h": 2,
            "36-38h": 3,
            "38-40h": 2,
            "40-42h": 3,
            "42-44h": 3,
            "44-46h": 2,
            "46-48h": 4,
            "48-50h": 6,
            "50-52h": 3,
            "52-54h": 7,
            "54-56h": 19,
            "56-58h": 3,
            "58-60h": 3,
            "62-64h": 2,
            "64-66h": 2,
            "66-68h": 5,
            "68-70h": 1,
            "70-72h": 3,
            "72-74h": 5,
            "74-76h": 1,
            "76-78h": 1,
            "78-80h": 5,
            "80-82h": 2,
            "82-84h": 1,
            "84-86h": 3,
            "86-88h": 3,
            "88-90h": 1,
            "92-94h": 2,
            "94-96h": 3,
            "96-98h": 2,
            "98-100h": 1,
            "100-102h": 2,
            "102-104h": 1,
            "112-114h": 2,
            "114-116h": 1,
            "116-118h": 2,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 4,
            "126-128h": 1,
            "132-134h": 2,
            "138-140h": 2,
            "140-142h": 1,
            "144-146h": 2,
            "146-148h": 1,
            "148-150h": 1,
            "156-158h": 1,
            "160-162h": 1,
            "162-164h": 2,
            "166-168h": 1,
            "170-172h": 2,
            "172-174h": 2,
            "174-176h": 1,
            "186-188h": 1,
            "192-194h": 3,
            "194-196h": 3,
            "212-214h": 1,
            "222-224h": 1,
            "234-236h": 1,
            "240-242h": 1,
            "250-252h": 1,
            "262-264h": 1,
            "280-282h": 1,
            "286-288h": 1,
            "290-292h": 1,
            "304-306h": 1,
            "306-308h": 2,
            "308-310h": 1,
            "310-312h": 1,
            "312-314h": 1,
            "330-332h": 1,
            "334-336h": 1,
            "336-338h": 1,
            "342-344h": 1,
            "344-346h": 1,
            "348-350h": 1,
            "350-352h": 2,
            "372-374h": 1,
            "380-382h": 1,
            "386-388h": 1,
            "402-404h": 1,
            "406-408h": 1,
            "410-412h": 2,
            "424-426h": 1,
            "434-436h": 1,
            "468-470h": 2,
            "566-568h": 1,
            "580-582h": 1,
            "604-606h": 1,
            "638-640h": 1,
            "650-652h": 1,
            "662-664h": 1,
            "670-672h": 2,
            "682-684h": 1,
            "744-746h": 1,
            "760-762h": 1,
            "780-782h": 1,
            "840-842h": 1,
            "844-846h": 1,
            "854-856h": 1,
            "890-892h": 1,
            "896-898h": 1,
            "940-942h": 1,
            "1086-1088h": 1,
            "1180-1182h": 1,
            "1190-1192h": 1,
            "1200-1202h": 1,
            "1242-1244h": 1,
            "1310-1312h": 1,
            "2040-2042h": 1
          },
          "tickets_count": 741,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 1,
            "2025-10-06": 2,
            "2025-10-07": 8,
            "2025-10-08": 1,
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-15": 2,
            "2025-10-16": 1,
            "2025-10-22": 3,
            "2025-10-23": 3,
            "2025-10-27": 2,
            "2025-10-28": 2,
            "2025-10-29": 1,
            "2025-10-30": 3,
            "2025-10-31": 2,
            "2025-11-03": 5,
            "2025-11-04": 4,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-07": 2,
            "2025-11-08": 1,
            "2025-11-10": 2,
            "2025-11-11": 6,
            "2025-11-13": 3,
            "2025-11-14": 3,
            "2025-11-18": 2,
            "2025-11-19": 2,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 5,
            "2025-11-26": 4,
            "2025-11-27": 3,
            "2025-11-28": 3,
            "2025-11-30": 2,
            "2025-12-02": 3,
            "2025-12-03": 9,
            "2025-12-04": 4,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-12": 2,
            "2025-12-15": 2,
            "2025-12-22": 4,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-08": 3,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 8,
            "2026-01-15": 1,
            "2026-01-16": 5,
            "2026-01-20": 4,
            "2026-01-21": 1,
            "2026-01-22": 4,
            "2026-01-23": 6,
            "2026-01-26": 4,
            "2026-01-27": 7,
            "2026-01-28": 2,
            "2026-01-29": 5,
            "2026-01-30": 12,
            "2026-02-02": 5,
            "2026-02-03": 4,
            "2026-02-04": 3,
            "2026-02-05": 5,
            "2026-02-06": 2,
            "2026-02-07": 1,
            "2026-02-09": 7,
            "2026-02-10": 8,
            "2026-02-11": 2,
            "2026-02-12": 3,
            "2026-02-13": 4,
            "2026-02-16": 1,
            "2026-02-17": 3,
            "2026-02-18": 5,
            "2026-02-19": 3,
            "2026-02-20": 4,
            "2026-02-23": 3,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-02-26": 5,
            "2026-02-27": 6,
            "2026-02-28": 4,
            "2026-03-02": 19,
            "2026-03-03": 6,
            "2026-03-04": 12,
            "2026-03-05": 3,
            "2026-03-06": 4,
            "2026-03-07": 3,
            "2026-03-09": 24,
            "2026-03-10": 8,
            "2026-03-11": 3,
            "2026-03-12": 2,
            "2026-03-13": 11,
            "2026-03-14": 1,
            "2026-03-16": 21,
            "2026-03-17": 6,
            "2026-03-18": 13,
            "2026-03-19": 5,
            "2026-03-20": 13,
            "2026-03-21": 1,
            "2026-03-23": 8,
            "2026-03-24": 5,
            "2026-03-25": 5,
            "2026-03-26": 3,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 7,
            "2026-04-01": 5,
            "2026-04-02": 1,
            "2026-04-06": 13,
            "2026-04-07": 5,
            "2026-04-08": 2,
            "2026-04-09": 3,
            "2026-04-10": 5,
            "2026-04-11": 2,
            "2026-04-13": 2,
            "2026-04-14": 9,
            "2026-04-15": 10,
            "2026-04-16": 2,
            "2026-04-17": 16,
            "2026-04-18": 1,
            "2026-04-20": 7,
            "2026-04-21": 1,
            "2026-04-22": 4,
            "2026-04-23": 3,
            "2026-04-24": 1,
            "2026-04-27": 5,
            "2026-04-28": 6,
            "2026-04-29": 5,
            "2026-04-30": 3,
            "2026-05-04": 15,
            "2026-05-05": 8,
            "2026-05-06": 9,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-10": 2,
            "2026-05-11": 2,
            "2026-05-12": 6,
            "2026-05-13": 7,
            "2026-05-14": 3,
            "2026-05-15": 1,
            "2026-05-18": 3,
            "2026-05-19": 5,
            "2026-05-20": 3,
            "2026-05-21": 6,
            "2026-05-22": 6,
            "2026-05-23": 1,
            "2026-05-25": 12,
            "2026-05-26": 12,
            "2026-05-27": 6,
            "2026-05-28": 4,
            "2026-05-29": 3,
            "2026-05-30": 4,
            "2026-06-01": 13,
            "2026-06-02": 14,
            "2026-06-03": 7,
            "2026-06-05": 7,
            "2026-06-08": 2
          },
          "time_per_day": {
            "2025-09-30": 9.050675833333333,
            "2025-10-01": 28.325220555555553,
            "2025-10-03": 0.2522908333333333,
            "2025-10-06": 124.62626388888889,
            "2025-10-07": 138.4758125,
            "2025-10-08": 14.909877222222221,
            "2025-10-10": 116.93766361111112,
            "2025-10-13": 124.63933222222221,
            "2025-10-15": 56.15561916666666,
            "2025-10-16": 0.7195861111111111,
            "2025-10-22": 187.1280436111111,
            "2025-10-23": 162.3482572222222,
            "2025-10-27": 7.261590555555556,
            "2025-10-28": 21.115524999999998,
            "2025-10-29": 1.4751697222222222,
            "2025-10-30": 45.37463916666667,
            "2025-10-31": 64.40059277777777,
            "2025-11-03": 21.490775833333334,
            "2025-11-04": 234.09447111111112,
            "2025-11-05": 25.560861111111112,
            "2025-11-06": 27.529957777777778,
            "2025-11-07": 9.758895833333334,
            "2025-11-08": 15.103649444444445,
            "2025-11-10": 86.79111083333333,
            "2025-11-11": 227.35522000000003,
            "2025-11-13": 508.6575647222222,
            "2025-11-14": 4.6515563888888884,
            "2025-11-18": 295.22818722222223,
            "2025-11-19": 6.509518333333333,
            "2025-11-20": 3.1897516666666665,
            "2025-11-21": 9.812267222222221,
            "2025-11-24": 33.22694861111111,
            "2025-11-26": 24.804433055555556,
            "2025-11-27": 38.275064722222226,
            "2025-11-28": 16.07932361111111,
            "2025-11-30": 4.148313611111111,
            "2025-12-02": 63.815025,
            "2025-12-03": 29.4169725,
            "2025-12-04": 362.67326055555554,
            "2025-12-05": 23.87092722222222,
            "2025-12-09": 6.758991944444444,
            "2025-12-10": 25.263721944444445,
            "2025-12-11": 42.29987,
            "2025-12-12": 27.641376666666666,
            "2025-12-15": 199.00114583333334,
            "2025-12-22": 61.553256111111104,
            "2025-12-23": 0.6058288888888889,
            "2025-12-26": 1.3623505555555557,
            "2026-01-05": 44.82703305555555,
            "2026-01-06": 8.139582222222222,
            "2026-01-07": 8.134878055555555,
            "2026-01-08": 944.8704558333334,
            "2026-01-09": 10.136113333333332,
            "2026-01-12": 14.080266666666667,
            "2026-01-13": 33.00572416666667,
            "2026-01-14": 100.48103,
            "2026-01-15": 9.21332,
            "2026-01-16": 24.544510555555554,
            "2026-01-20": 172.68408194444447,
            "2026-01-21": 56.02625,
            "2026-01-22": 40.4718225,
            "2026-01-23": 859.1030386111111,
            "2026-01-26": 92.13622666666666,
            "2026-01-27": 147.77962694444446,
            "2026-01-28": 10.294375833333334,
            "2026-01-29": 232.57931722222224,
            "2026-01-30": 1163.4079547222223,
            "2026-02-02": 234.83004972222224,
            "2026-02-03": 718.1143180555555,
            "2026-02-04": 72.61455277777777,
            "2026-02-05": 44.42697166666666,
            "2026-02-06": 16.81598972222222,
            "2026-02-07": 3.7770802777777774,
            "2026-02-09": 42.160938888888886,
            "2026-02-10": 293.6799963888889,
            "2026-02-11": 9.418916388888888,
            "2026-02-12": 389.42757416666666,
            "2026-02-13": 769.5286738888889,
            "2026-02-16": 100.73119527777779,
            "2026-02-17": 40.58201277777778,
            "2026-02-18": 453.82210333333336,
            "2026-02-19": 105.04489305555556,
            "2026-02-20": 696.3338436111111,
            "2026-02-23": 20.873534166666666,
            "2026-02-24": 20.912975000000003,
            "2026-02-25": 10.08637388888889,
            "2026-02-26": 22.102605555555556,
            "2026-02-27": 43.09254222222223,
            "2026-02-28": 28.41403916666667,
            "2026-03-02": 703.2436302777777,
            "2026-03-03": 129.80290416666668,
            "2026-03-04": 38.1836513888889,
            "2026-03-05": 29.155119166666665,
            "2026-03-06": 129.8747827777778,
            "2026-03-07": 6.08331388888889,
            "2026-03-09": 428.3971977777777,
            "2026-03-10": 837.1511038888888,
            "2026-03-11": 43.14777055555555,
            "2026-03-12": 23.174715277777782,
            "2026-03-13": 814.5377175,
            "2026-03-14": 1.4962497222222222,
            "2026-03-16": 993.5446394444444,
            "2026-03-17": 604.9796030555556,
            "2026-03-18": 1747.102431111111,
            "2026-03-19": 31.149634722222224,
            "2026-03-20": 1774.2563647222223,
            "2026-03-21": 28.306140833333334,
            "2026-03-23": 309.70316055555554,
            "2026-03-24": 1877.8129,
            "2026-03-25": 225.46151666666665,
            "2026-03-26": 25.5680725,
            "2026-03-27": 5.423542777777778,
            "2026-03-30": 4.803260833333333,
            "2026-03-31": 1398.765861388889,
            "2026-04-01": 53.732076111111105,
            "2026-04-02": 1086.5316547222221,
            "2026-04-06": 276.71182583333336,
            "2026-04-07": 178.9169475,
            "2026-04-08": 178.5917658333333,
            "2026-04-09": 496.91004194444446,
            "2026-04-10": 1256.9043975,
            "2026-04-11": 27.189146666666666,
            "2026-04-13": 2.2019641666666665,
            "2026-04-14": 218.43775166666666,
            "2026-04-15": 189.57173749999998,
            "2026-04-16": 898.3303980555555,
            "2026-04-17": 85.03941805555556,
            "2026-04-18": 2.6868855555555555,
            "2026-04-20": 209.27094833333334,
            "2026-04-21": 566.1962222222222,
            "2026-04-22": 62.16802722222223,
            "2026-04-23": 2879.9626469444447,
            "2026-04-24": 3.464617777777778,
            "2026-04-27": 83.95161861111113,
            "2026-04-28": 812.0874377777777,
            "2026-04-29": 457.4093175,
            "2026-04-30": 33.27716916666667,
            "2026-05-04": 2164.0172455555553,
            "2026-05-05": 1097.1318638888888,
            "2026-05-06": 2832.261380833333,
            "2026-05-07": 304.9134616666667,
            "2026-05-08": 581.8848891666667,
            "2026-05-10": 99.32111305555556,
            "2026-05-11": 55.94242361111111,
            "2026-05-12": 180.60453861111114,
            "2026-05-13": 100.49021416666669,
            "2026-05-14": 812.6482888888888,
            "2026-05-15": 0.5954644444444445,
            "2026-05-18": 513.4493155555556,
            "2026-05-19": 1120.4493319444446,
            "2026-05-20": 42.16851,
            "2026-05-21": 190.40878805555556,
            "2026-05-22": 526.6887341666667,
            "2026-05-23": 172.49276055555555,
            "2026-05-25": 1694.2411994444442,
            "2026-05-26": 512.4338741666667,
            "2026-05-27": 392.55150111111107,
            "2026-05-28": 201.99666527777774,
            "2026-05-29": 56.409889166666666,
            "2026-05-30": 1816.6736647222224,
            "2026-06-01": 112.19654805555554,
            "2026-06-02": 432.6659033333333,
            "2026-06-03": 97.4785288888889,
            "2026-06-05": 727.9459691666666,
            "2026-06-08": 0.9049816666666667
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 1,
            "2025-10-06": 2,
            "2025-10-07": 8,
            "2025-10-08": 1,
            "2025-10-10": 2,
            "2025-10-13": 2,
            "2025-10-15": 2,
            "2025-10-16": 1,
            "2025-10-22": 3,
            "2025-10-23": 3,
            "2025-10-27": 2,
            "2025-10-28": 2,
            "2025-10-29": 1,
            "2025-10-30": 3,
            "2025-10-31": 2,
            "2025-11-03": 5,
            "2025-11-04": 4,
            "2025-11-05": 1,
            "2025-11-06": 1,
            "2025-11-07": 2,
            "2025-11-08": 1,
            "2025-11-10": 2,
            "2025-11-11": 6,
            "2025-11-13": 3,
            "2025-11-14": 3,
            "2025-11-18": 2,
            "2025-11-19": 2,
            "2025-11-20": 2,
            "2025-11-21": 1,
            "2025-11-24": 5,
            "2025-11-26": 4,
            "2025-11-27": 3,
            "2025-11-28": 3,
            "2025-11-30": 2,
            "2025-12-02": 3,
            "2025-12-03": 9,
            "2025-12-04": 4,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 2,
            "2025-12-12": 2,
            "2025-12-15": 2,
            "2025-12-22": 4,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2026-01-05": 1,
            "2026-01-06": 1,
            "2026-01-07": 1,
            "2026-01-08": 3,
            "2026-01-09": 2,
            "2026-01-12": 3,
            "2026-01-13": 3,
            "2026-01-14": 8,
            "2026-01-15": 1,
            "2026-01-16": 5,
            "2026-01-20": 4,
            "2026-01-21": 1,
            "2026-01-22": 4,
            "2026-01-23": 6,
            "2026-01-26": 4,
            "2026-01-27": 7,
            "2026-01-28": 2,
            "2026-01-29": 5,
            "2026-01-30": 12,
            "2026-02-02": 5,
            "2026-02-03": 4,
            "2026-02-04": 3,
            "2026-02-05": 5,
            "2026-02-06": 2,
            "2026-02-07": 1,
            "2026-02-09": 7,
            "2026-02-10": 8,
            "2026-02-11": 2,
            "2026-02-12": 3,
            "2026-02-13": 4,
            "2026-02-16": 1,
            "2026-02-17": 3,
            "2026-02-18": 5,
            "2026-02-19": 3,
            "2026-02-20": 4,
            "2026-02-23": 3,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-02-26": 5,
            "2026-02-27": 6,
            "2026-02-28": 4,
            "2026-03-02": 19,
            "2026-03-03": 6,
            "2026-03-04": 12,
            "2026-03-05": 3,
            "2026-03-06": 4,
            "2026-03-07": 3,
            "2026-03-09": 24,
            "2026-03-10": 8,
            "2026-03-11": 3,
            "2026-03-12": 2,
            "2026-03-13": 11,
            "2026-03-14": 1,
            "2026-03-16": 21,
            "2026-03-17": 6,
            "2026-03-18": 13,
            "2026-03-19": 5,
            "2026-03-20": 13,
            "2026-03-21": 1,
            "2026-03-23": 8,
            "2026-03-24": 5,
            "2026-03-25": 5,
            "2026-03-26": 3,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 7,
            "2026-04-01": 5,
            "2026-04-02": 1,
            "2026-04-06": 13,
            "2026-04-07": 5,
            "2026-04-08": 2,
            "2026-04-09": 3,
            "2026-04-10": 5,
            "2026-04-11": 2,
            "2026-04-13": 2,
            "2026-04-14": 9,
            "2026-04-15": 10,
            "2026-04-16": 2,
            "2026-04-17": 16,
            "2026-04-18": 1,
            "2026-04-20": 7,
            "2026-04-21": 1,
            "2026-04-22": 4,
            "2026-04-23": 3,
            "2026-04-24": 1,
            "2026-04-27": 5,
            "2026-04-28": 6,
            "2026-04-29": 5,
            "2026-04-30": 3,
            "2026-05-04": 15,
            "2026-05-05": 8,
            "2026-05-06": 9,
            "2026-05-07": 1,
            "2026-05-08": 1,
            "2026-05-10": 2,
            "2026-05-11": 2,
            "2026-05-12": 6,
            "2026-05-13": 7,
            "2026-05-14": 3,
            "2026-05-15": 1,
            "2026-05-18": 3,
            "2026-05-19": 5,
            "2026-05-20": 3,
            "2026-05-21": 6,
            "2026-05-22": 6,
            "2026-05-23": 1,
            "2026-05-25": 12,
            "2026-05-26": 12,
            "2026-05-27": 6,
            "2026-05-28": 4,
            "2026-05-29": 3,
            "2026-05-30": 4,
            "2026-06-01": 13,
            "2026-06-02": 14,
            "2026-06-03": 7,
            "2026-06-05": 7,
            "2026-06-08": 2
          }
        },
        "P2": {
          "avg_time_hours": 94.51,
          "mode_time_hours": 1.0,
          "mode_frequency": 4533,
          "time_distribution": {
            "0-2h": 4533,
            "2-4h": 1100,
            "4-6h": 526,
            "6-8h": 351,
            "8-10h": 176,
            "10-12h": 126,
            "12-14h": 115,
            "14-16h": 103,
            "16-18h": 136,
            "18-20h": 134,
            "20-22h": 118,
            "22-24h": 116,
            "24-26h": 116,
            "26-28h": 70,
            "28-30h": 94,
            "30-32h": 60,
            "32-34h": 47,
            "34-36h": 32,
            "36-38h": 26,
            "38-40h": 39,
            "40-42h": 58,
            "42-44h": 47,
            "44-46h": 53,
            "46-48h": 37,
            "48-50h": 57,
            "50-52h": 45,
            "52-54h": 40,
            "54-56h": 40,
            "56-58h": 18,
            "58-60h": 10,
            "60-62h": 7,
            "62-64h": 14,
            "64-66h": 33,
            "66-68h": 41,
            "68-70h": 37,
            "70-72h": 34,
            "72-74h": 64,
            "74-76h": 39,
            "76-78h": 31,
            "78-80h": 23,
            "80-82h": 14,
            "82-84h": 3,
            "84-86h": 12,
            "86-88h": 10,
            "88-90h": 15,
            "90-92h": 11,
            "92-94h": 16,
            "94-96h": 21,
            "96-98h": 22,
            "98-100h": 12,
            "100-102h": 15,
            "102-104h": 12,
            "104-106h": 9,
            "106-108h": 7,
            "108-110h": 3,
            "110-112h": 1,
            "112-114h": 5,
            "114-116h": 14,
            "116-118h": 15,
            "118-120h": 15,
            "120-122h": 17,
            "122-124h": 17,
            "124-126h": 11,
            "126-128h": 12,
            "128-130h": 6,
            "130-132h": 3,
            "132-134h": 4,
            "134-136h": 9,
            "136-138h": 6,
            "138-140h": 18,
            "140-142h": 14,
            "142-144h": 17,
            "144-146h": 21,
            "146-148h": 18,
            "148-150h": 12,
            "150-152h": 5,
            "152-154h": 2,
            "154-156h": 4,
            "156-158h": 5,
            "158-160h": 5,
            "160-162h": 13,
            "162-164h": 22,
            "164-166h": 17,
            "166-168h": 17,
            "168-170h": 11,
            "170-172h": 12,
            "172-174h": 10,
            "174-176h": 3,
            "176-178h": 6,
            "178-180h": 4,
            "180-182h": 8,
            "182-184h": 4,
            "184-186h": 5,
            "186-188h": 6,
            "188-190h": 8,
            "190-192h": 13,
            "192-194h": 9,
            "194-196h": 9,
            "196-198h": 4,
            "198-200h": 6,
            "200-202h": 6,
            "202-204h": 5,
            "204-206h": 8,
            "206-208h": 1,
            "208-210h": 5,
            "210-212h": 5,
            "212-214h": 6,
            "214-216h": 9,
            "216-218h": 7,
            "218-220h": 20,
            "220-222h": 3,
            "222-224h": 5,
            "226-228h": 10,
            "228-230h": 3,
            "230-232h": 2,
            "232-234h": 3,
            "234-236h": 4,
            "236-238h": 5,
            "238-240h": 9,
            "240-242h": 9,
            "242-244h": 4,
            "244-246h": 3,
            "246-248h": 8,
            "248-250h": 4,
            "250-252h": 1,
            "252-254h": 3,
            "254-256h": 4,
            "256-258h": 7,
            "258-260h": 1,
            "260-262h": 7,
            "262-264h": 7,
            "264-266h": 4,
            "266-268h": 6,
            "268-270h": 11,
            "270-272h": 6,
            "272-274h": 1,
            "274-276h": 2,
            "276-278h": 4,
            "278-280h": 5,
            "280-282h": 4,
            "282-284h": 6,
            "284-286h": 6,
            "286-288h": 6,
            "288-290h": 5,
            "290-292h": 3,
            "292-294h": 8,
            "294-296h": 3,
            "296-298h": 1,
            "298-300h": 3,
            "300-302h": 4,
            "302-304h": 2,
            "304-306h": 4,
            "306-308h": 9,
            "308-310h": 8,
            "310-312h": 6,
            "312-314h": 9,
            "314-316h": 5,
            "316-318h": 8,
            "318-320h": 7,
            "320-322h": 5,
            "324-326h": 6,
            "326-328h": 4,
            "328-330h": 3,
            "330-332h": 5,
            "332-334h": 13,
            "334-336h": 7,
            "336-338h": 16,
            "338-340h": 11,
            "340-342h": 14,
            "342-344h": 8,
            "344-346h": 5,
            "346-348h": 1,
            "348-350h": 10,
            "350-352h": 3,
            "352-354h": 3,
            "354-356h": 5,
            "356-358h": 5,
            "358-360h": 4,
            "360-362h": 7,
            "362-364h": 7,
            "364-366h": 4,
            "366-368h": 11,
            "368-370h": 6,
            "370-372h": 1,
            "372-374h": 7,
            "374-376h": 2,
            "376-378h": 4,
            "378-380h": 1,
            "380-382h": 6,
            "382-384h": 5,
            "384-386h": 4,
            "386-388h": 8,
            "388-390h": 11,
            "390-392h": 5,
            "392-394h": 3,
            "394-396h": 1,
            "396-398h": 2,
            "398-400h": 3,
            "400-402h": 5,
            "402-404h": 2,
            "404-406h": 6,
            "406-408h": 5,
            "408-410h": 13,
            "410-412h": 5,
            "412-414h": 7,
            "414-416h": 12,
            "416-418h": 5,
            "418-420h": 3,
            "420-422h": 1,
            "422-424h": 2,
            "424-426h": 5,
            "426-428h": 3,
            "428-430h": 4,
            "430-432h": 5,
            "432-434h": 4,
            "434-436h": 3,
            "436-438h": 2,
            "438-440h": 3,
            "440-442h": 1,
            "444-446h": 2,
            "446-448h": 1,
            "448-450h": 1,
            "450-452h": 2,
            "452-454h": 2,
            "454-456h": 5,
            "456-458h": 6,
            "460-462h": 3,
            "462-464h": 2,
            "464-466h": 1,
            "470-472h": 1,
            "472-474h": 2,
            "474-476h": 1,
            "476-478h": 1,
            "478-480h": 4,
            "480-482h": 3,
            "482-484h": 3,
            "486-488h": 1,
            "488-490h": 4,
            "490-492h": 5,
            "492-494h": 5,
            "494-496h": 1,
            "496-498h": 5,
            "498-500h": 2,
            "500-502h": 1,
            "502-504h": 3,
            "504-506h": 4,
            "506-508h": 6,
            "508-510h": 8,
            "510-512h": 1,
            "512-514h": 6,
            "514-516h": 3,
            "516-518h": 1,
            "518-520h": 3,
            "520-522h": 2,
            "522-524h": 3,
            "524-526h": 12,
            "526-528h": 9,
            "528-530h": 8,
            "530-532h": 6,
            "532-534h": 9,
            "534-536h": 1,
            "536-538h": 3,
            "538-540h": 2,
            "540-542h": 6,
            "542-544h": 3,
            "544-546h": 3,
            "546-548h": 1,
            "548-550h": 4,
            "550-552h": 2,
            "552-554h": 2,
            "554-556h": 2,
            "556-558h": 2,
            "558-560h": 3,
            "560-562h": 3,
            "562-564h": 2,
            "564-566h": 1,
            "566-568h": 1,
            "568-570h": 1,
            "570-572h": 2,
            "572-574h": 4,
            "574-576h": 1,
            "576-578h": 9,
            "578-580h": 5,
            "580-582h": 2,
            "582-584h": 10,
            "584-586h": 2,
            "592-594h": 3,
            "594-596h": 2,
            "596-598h": 3,
            "598-600h": 1,
            "600-602h": 1,
            "602-604h": 1,
            "604-606h": 1,
            "610-612h": 1,
            "612-614h": 2,
            "614-616h": 2,
            "616-618h": 5,
            "618-620h": 1,
            "622-624h": 3,
            "624-626h": 1,
            "626-628h": 1,
            "628-630h": 3,
            "630-632h": 1,
            "634-636h": 2,
            "640-642h": 1,
            "642-644h": 5,
            "644-646h": 2,
            "646-648h": 1,
            "648-650h": 4,
            "650-652h": 4,
            "652-654h": 5,
            "654-656h": 6,
            "656-658h": 1,
            "658-660h": 2,
            "660-662h": 2,
            "662-664h": 1,
            "664-666h": 2,
            "666-668h": 2,
            "668-670h": 4,
            "670-672h": 3,
            "672-674h": 7,
            "674-676h": 3,
            "676-678h": 2,
            "678-680h": 4,
            "682-684h": 1,
            "684-686h": 2,
            "692-694h": 1,
            "696-698h": 5,
            "698-700h": 4,
            "700-702h": 3,
            "702-704h": 3,
            "704-706h": 2,
            "706-708h": 1,
            "714-716h": 1,
            "718-720h": 2,
            "722-724h": 4,
            "724-726h": 5,
            "726-728h": 1,
            "730-732h": 2,
            "734-736h": 1,
            "738-740h": 2,
            "742-744h": 3,
            "744-746h": 4,
            "746-748h": 6,
            "748-750h": 3,
            "750-752h": 3,
            "754-756h": 1,
            "756-758h": 3,
            "758-760h": 2,
            "762-764h": 1,
            "764-766h": 2,
            "766-768h": 4,
            "768-770h": 1,
            "772-774h": 4,
            "780-782h": 1,
            "786-788h": 2,
            "788-790h": 1,
            "790-792h": 1,
            "792-794h": 3,
            "794-796h": 2,
            "796-798h": 2,
            "798-800h": 2,
            "800-802h": 4,
            "806-808h": 1,
            "808-810h": 3,
            "810-812h": 3,
            "812-814h": 1,
            "814-816h": 2,
            "816-818h": 4,
            "818-820h": 5,
            "820-822h": 2,
            "822-824h": 3,
            "824-826h": 2,
            "826-828h": 2,
            "834-836h": 2,
            "836-838h": 2,
            "838-840h": 1,
            "840-842h": 3,
            "842-844h": 6,
            "844-846h": 3,
            "846-848h": 2,
            "848-850h": 1,
            "850-852h": 1,
            "860-862h": 2,
            "862-864h": 2,
            "864-866h": 3,
            "866-868h": 3,
            "870-872h": 1,
            "872-874h": 3,
            "876-878h": 1,
            "884-886h": 1,
            "886-888h": 2,
            "888-890h": 2,
            "890-892h": 3,
            "892-894h": 6,
            "894-896h": 1,
            "896-898h": 2,
            "898-900h": 1,
            "902-904h": 2,
            "904-906h": 1,
            "906-908h": 1,
            "908-910h": 1,
            "910-912h": 2,
            "914-916h": 1,
            "916-918h": 2,
            "918-920h": 1,
            "922-924h": 2,
            "924-926h": 1,
            "934-936h": 1,
            "936-938h": 2,
            "938-940h": 2,
            "940-942h": 1,
            "942-944h": 1,
            "944-946h": 1,
            "954-956h": 1,
            "956-958h": 1,
            "968-970h": 1,
            "970-972h": 1,
            "972-974h": 1,
            "974-976h": 1,
            "980-982h": 1,
            "984-986h": 5,
            "986-988h": 4,
            "988-990h": 1,
            "990-992h": 2,
            "992-994h": 1,
            "994-996h": 1,
            "1000-1002h": 4,
            "1002-1004h": 3,
            "1008-1010h": 2,
            "1010-1012h": 1,
            "1012-1014h": 2,
            "1018-1020h": 2,
            "1024-1026h": 1,
            "1026-1028h": 1,
            "1028-1030h": 3,
            "1030-1032h": 2,
            "1032-1034h": 1,
            "1034-1036h": 1,
            "1036-1038h": 2,
            "1038-1040h": 2,
            "1050-1052h": 1,
            "1052-1054h": 2,
            "1054-1056h": 5,
            "1056-1058h": 3,
            "1058-1060h": 2,
            "1068-1070h": 1,
            "1070-1072h": 1,
            "1072-1074h": 1,
            "1074-1076h": 1,
            "1076-1078h": 3,
            "1078-1080h": 2,
            "1080-1082h": 3,
            "1084-1086h": 1,
            "1086-1088h": 3,
            "1092-1094h": 1,
            "1096-1098h": 1,
            "1098-1100h": 1,
            "1100-1102h": 1,
            "1102-1104h": 1,
            "1104-1106h": 2,
            "1112-1114h": 1,
            "1114-1116h": 1,
            "1122-1124h": 1,
            "1124-1126h": 1,
            "1128-1130h": 1,
            "1134-1136h": 1,
            "1142-1144h": 2,
            "1144-1146h": 1,
            "1146-1148h": 1,
            "1152-1154h": 3,
            "1156-1158h": 1,
            "1158-1160h": 1,
            "1162-1164h": 1,
            "1166-1168h": 1,
            "1170-1172h": 1,
            "1174-1176h": 1,
            "1176-1178h": 2,
            "1178-1180h": 1,
            "1180-1182h": 1,
            "1194-1196h": 1,
            "1196-1198h": 2,
            "1198-1200h": 2,
            "1200-1202h": 3,
            "1208-1210h": 1,
            "1216-1218h": 1,
            "1218-1220h": 1,
            "1222-1224h": 3,
            "1224-1226h": 1,
            "1228-1230h": 2,
            "1234-1236h": 1,
            "1236-1238h": 2,
            "1242-1244h": 1,
            "1244-1246h": 2,
            "1248-1250h": 3,
            "1252-1254h": 2,
            "1256-1258h": 1,
            "1258-1260h": 1,
            "1264-1266h": 1,
            "1266-1268h": 1,
            "1268-1270h": 1,
            "1272-1274h": 1,
            "1276-1278h": 1,
            "1284-1286h": 1,
            "1294-1296h": 1,
            "1298-1300h": 1,
            "1300-1302h": 1,
            "1314-1316h": 1,
            "1316-1318h": 2,
            "1320-1322h": 1,
            "1322-1324h": 1,
            "1336-1338h": 2,
            "1338-1340h": 3,
            "1340-1342h": 2,
            "1342-1344h": 1,
            "1360-1362h": 1,
            "1362-1364h": 1,
            "1366-1368h": 1,
            "1390-1392h": 1,
            "1392-1394h": 1,
            "1404-1406h": 1,
            "1410-1412h": 1,
            "1414-1416h": 1,
            "1416-1418h": 1,
            "1424-1426h": 1,
            "1440-1442h": 1,
            "1454-1456h": 1,
            "1460-1462h": 2,
            "1462-1464h": 2,
            "1480-1482h": 1,
            "1482-1484h": 1,
            "1486-1488h": 1,
            "1502-1504h": 1,
            "1506-1508h": 1,
            "1514-1516h": 2,
            "1532-1534h": 2,
            "1546-1548h": 1,
            "1548-1550h": 1,
            "1556-1558h": 1,
            "1560-1562h": 1,
            "1562-1564h": 1,
            "1578-1580h": 1,
            "1582-1584h": 1,
            "1584-1586h": 1,
            "1620-1622h": 1,
            "1622-1624h": 1,
            "1632-1634h": 1,
            "1634-1636h": 3,
            "1636-1638h": 1,
            "1660-1662h": 1,
            "1670-1672h": 1,
            "1686-1688h": 1,
            "1712-1714h": 1,
            "1728-1730h": 1,
            "1756-1758h": 1,
            "1762-1764h": 1,
            "1770-1772h": 1,
            "1842-1844h": 1,
            "1852-1854h": 1,
            "1896-1898h": 2,
            "1906-1908h": 1,
            "1942-1944h": 1,
            "2044-2046h": 1,
            "2060-2062h": 1,
            "2108-2110h": 1,
            "2138-2140h": 1,
            "2158-2160h": 1,
            "2250-2252h": 1,
            "2280-2282h": 1,
            "2510-2512h": 1,
            "2560-2562h": 1,
            "2734-2736h": 1,
            "2886-2888h": 1,
            "3002-3004h": 3,
            "3262-3264h": 1,
            "3554-3556h": 1
          },
          "tickets_count": 10761,
          "tickets_per_day": {
            "2025-09-30": 13,
            "2025-10-01": 4,
            "2025-10-02": 4,
            "2025-10-03": 3,
            "2025-10-06": 11,
            "2025-10-07": 18,
            "2025-10-08": 13,
            "2025-10-09": 11,
            "2025-10-10": 25,
            "2025-10-11": 2,
            "2025-10-13": 12,
            "2025-10-14": 43,
            "2025-10-15": 34,
            "2025-10-16": 8,
            "2025-10-17": 11,
            "2025-10-18": 3,
            "2025-10-20": 17,
            "2025-10-21": 22,
            "2025-10-22": 19,
            "2025-10-23": 41,
            "2025-10-24": 21,
            "2025-10-25": 3,
            "2025-10-26": 1,
            "2025-10-27": 39,
            "2025-10-28": 39,
            "2025-10-29": 33,
            "2025-10-30": 26,
            "2025-10-31": 44,
            "2025-11-02": 1,
            "2025-11-03": 37,
            "2025-11-04": 36,
            "2025-11-05": 21,
            "2025-11-06": 40,
            "2025-11-07": 17,
            "2025-11-08": 2,
            "2025-11-09": 1,
            "2025-11-10": 38,
            "2025-11-11": 31,
            "2025-11-12": 30,
            "2025-11-13": 39,
            "2025-11-14": 28,
            "2025-11-15": 1,
            "2025-11-16": 2,
            "2025-11-17": 55,
            "2025-11-18": 11,
            "2025-11-19": 31,
            "2025-11-20": 16,
            "2025-11-21": 31,
            "2025-11-22": 7,
            "2025-11-23": 7,
            "2025-11-24": 47,
            "2025-11-25": 18,
            "2025-11-26": 29,
            "2025-11-27": 36,
            "2025-11-28": 33,
            "2025-11-29": 4,
            "2025-11-30": 3,
            "2025-12-01": 2,
            "2025-12-02": 43,
            "2025-12-03": 22,
            "2025-12-04": 35,
            "2025-12-05": 31,
            "2025-12-06": 2,
            "2025-12-07": 1,
            "2025-12-08": 3,
            "2025-12-09": 27,
            "2025-12-10": 27,
            "2025-12-11": 39,
            "2025-12-12": 31,
            "2025-12-13": 9,
            "2025-12-14": 7,
            "2025-12-15": 66,
            "2025-12-16": 12,
            "2025-12-17": 32,
            "2025-12-18": 23,
            "2025-12-19": 26,
            "2025-12-20": 1,
            "2025-12-21": 1,
            "2025-12-22": 21,
            "2025-12-23": 19,
            "2025-12-24": 4,
            "2025-12-26": 30,
            "2025-12-28": 5,
            "2025-12-29": 32,
            "2025-12-30": 18,
            "2025-12-31": 8,
            "2026-01-02": 22,
            "2026-01-03": 2,
            "2026-01-04": 2,
            "2026-01-05": 29,
            "2026-01-06": 37,
            "2026-01-07": 36,
            "2026-01-08": 53,
            "2026-01-09": 27,
            "2026-01-10": 8,
            "2026-01-11": 2,
            "2026-01-12": 32,
            "2026-01-13": 56,
            "2026-01-14": 53,
            "2026-01-15": 59,
            "2026-01-16": 60,
            "2026-01-17": 10,
            "2026-01-18": 3,
            "2026-01-19": 62,
            "2026-01-20": 70,
            "2026-01-21": 42,
            "2026-01-22": 37,
            "2026-01-23": 60,
            "2026-01-24": 1,
            "2026-01-26": 68,
            "2026-01-27": 44,
            "2026-01-28": 14,
            "2026-01-29": 27,
            "2026-01-30": 59,
            "2026-01-31": 9,
            "2026-02-02": 23,
            "2026-02-03": 95,
            "2026-02-04": 35,
            "2026-02-05": 29,
            "2026-02-06": 31,
            "2026-02-07": 1,
            "2026-02-09": 53,
            "2026-02-10": 78,
            "2026-02-11": 21,
            "2026-02-12": 71,
            "2026-02-13": 73,
            "2026-02-14": 23,
            "2026-02-16": 45,
            "2026-02-17": 24,
            "2026-02-18": 94,
            "2026-02-19": 46,
            "2026-02-20": 65,
            "2026-02-21": 34,
            "2026-02-22": 3,
            "2026-02-23": 71,
            "2026-02-24": 66,
            "2026-02-25": 60,
            "2026-02-26": 31,
            "2026-02-27": 29,
            "2026-02-28": 48,
            "2026-03-01": 21,
            "2026-03-02": 105,
            "2026-03-03": 62,
            "2026-03-04": 80,
            "2026-03-05": 78,
            "2026-03-06": 75,
            "2026-03-07": 38,
            "2026-03-08": 2,
            "2026-03-09": 100,
            "2026-03-10": 83,
            "2026-03-11": 88,
            "2026-03-12": 72,
            "2026-03-13": 50,
            "2026-03-14": 11,
            "2026-03-15": 2,
            "2026-03-16": 82,
            "2026-03-17": 98,
            "2026-03-18": 88,
            "2026-03-19": 81,
            "2026-03-20": 141,
            "2026-03-21": 9,
            "2026-03-22": 1,
            "2026-03-23": 108,
            "2026-03-24": 76,
            "2026-03-25": 76,
            "2026-03-26": 50,
            "2026-03-27": 53,
            "2026-03-28": 14,
            "2026-03-29": 1,
            "2026-03-30": 87,
            "2026-03-31": 82,
            "2026-04-01": 52,
            "2026-04-02": 76,
            "2026-04-04": 18,
            "2026-04-06": 97,
            "2026-04-07": 83,
            "2026-04-08": 81,
            "2026-04-09": 78,
            "2026-04-10": 117,
            "2026-04-11": 31,
            "2026-04-13": 110,
            "2026-04-14": 76,
            "2026-04-15": 57,
            "2026-04-16": 100,
            "2026-04-17": 80,
            "2026-04-18": 27,
            "2026-04-20": 93,
            "2026-04-21": 53,
            "2026-04-22": 117,
            "2026-04-23": 165,
            "2026-04-24": 65,
            "2026-04-26": 2,
            "2026-04-27": 133,
            "2026-04-28": 60,
            "2026-04-29": 86,
            "2026-04-30": 89,
            "2026-05-02": 64,
            "2026-05-04": 158,
            "2026-05-05": 92,
            "2026-05-06": 143,
            "2026-05-07": 83,
            "2026-05-08": 74,
            "2026-05-09": 37,
            "2026-05-10": 1,
            "2026-05-11": 129,
            "2026-05-12": 79,
            "2026-05-13": 83,
            "2026-05-14": 128,
            "2026-05-15": 71,
            "2026-05-16": 23,
            "2026-05-17": 2,
            "2026-05-18": 136,
            "2026-05-19": 93,
            "2026-05-20": 93,
            "2026-05-21": 112,
            "2026-05-22": 99,
            "2026-05-23": 25,
            "2026-05-25": 116,
            "2026-05-26": 163,
            "2026-05-27": 116,
            "2026-05-28": 106,
            "2026-05-29": 114,
            "2026-05-30": 75,
            "2026-06-01": 104,
            "2026-06-02": 120,
            "2026-06-03": 123,
            "2026-06-04": 1,
            "2026-06-05": 159,
            "2026-06-06": 18,
            "2026-06-08": 79
          },
          "time_per_day": {
            "2025-09-30": 15.837857777777778,
            "2025-10-01": 36.28973333333333,
            "2025-10-02": 4.365010555555555,
            "2025-10-03": 44.81456666666667,
            "2025-10-06": 477.12615527777774,
            "2025-10-07": 776.2589405555557,
            "2025-10-08": 96.86559138888887,
            "2025-10-09": 559.9308991666668,
            "2025-10-10": 975.1897008333335,
            "2025-10-11": 82.95310138888888,
            "2025-10-13": 658.6801272222223,
            "2025-10-14": 2510.8393902777784,
            "2025-10-15": 1201.422584444445,
            "2025-10-16": 364.84949555555556,
            "2025-10-17": 71.90767861111111,
            "2025-10-18": 165.31194305555556,
            "2025-10-20": 822.8384386111109,
            "2025-10-21": 159.35969555555556,
            "2025-10-22": 1276.3199180555553,
            "2025-10-23": 3745.0200652777767,
            "2025-10-24": 1032.064367222222,
            "2025-10-25": 1.510706111111111,
            "2025-10-26": 0.5912069444444444,
            "2025-10-27": 1479.8425505555558,
            "2025-10-28": 2125.856798888889,
            "2025-10-29": 2222.5457024999982,
            "2025-10-30": 826.4673850000001,
            "2025-10-31": 2227.1717488888885,
            "2025-11-02": 6.409595277777778,
            "2025-11-03": 4246.549003888888,
            "2025-11-04": 3657.996733333333,
            "2025-11-05": 3203.2713825,
            "2025-11-06": 2282.8927413888887,
            "2025-11-07": 995.490326388889,
            "2025-11-08": 3.2821672222222222,
            "2025-11-09": 41.51824638888889,
            "2025-11-10": 1167.8584216666666,
            "2025-11-11": 1448.4994549999994,
            "2025-11-12": 1722.6196269444447,
            "2025-11-13": 3584.144538611111,
            "2025-11-14": 4034.223798333332,
            "2025-11-15": 0.20001194444444445,
            "2025-11-16": 1.5785355555555556,
            "2025-11-17": 3664.6711741666663,
            "2025-11-18": 1027.17874,
            "2025-11-19": 3669.490192500001,
            "2025-11-20": 2601.2981730555553,
            "2025-11-21": 2937.3714330555554,
            "2025-11-22": 779.7015194444444,
            "2025-11-23": 628.6312019444443,
            "2025-11-24": 3825.5326691666673,
            "2025-11-25": 929.646159722222,
            "2025-11-26": 554.5180033333332,
            "2025-11-27": 2105.7083311111114,
            "2025-11-28": 1610.4495405555556,
            "2025-11-29": 121.57738027777778,
            "2025-11-30": 89.2003025,
            "2025-12-01": 12.505493055555554,
            "2025-12-02": 4682.9279938888885,
            "2025-12-03": 563.1237858333333,
            "2025-12-04": 6264.56499861111,
            "2025-12-05": 1485.397115833333,
            "2025-12-06": 70.16250138888888,
            "2025-12-07": 0.18633083333333333,
            "2025-12-08": 190.97788916666667,
            "2025-12-09": 2418.6899794444453,
            "2025-12-10": 3272.5008080555554,
            "2025-12-11": 7312.615930555557,
            "2025-12-12": 4249.256524166667,
            "2025-12-13": 759.906976111111,
            "2025-12-14": 286.0499811111111,
            "2025-12-15": 11012.725254166664,
            "2025-12-16": 1175.9870461111113,
            "2025-12-17": 4310.765960555554,
            "2025-12-18": 2230.511268611111,
            "2025-12-19": 5590.863687777775,
            "2025-12-20": 164.55994805555554,
            "2025-12-21": 89.8079611111111,
            "2025-12-22": 2049.097790277778,
            "2025-12-23": 841.5460919444445,
            "2025-12-24": 44.553845833333334,
            "2025-12-26": 1986.6593716666669,
            "2025-12-28": 52.471337500000004,
            "2025-12-29": 6088.544582777779,
            "2025-12-30": 463.6606827777778,
            "2025-12-31": 2014.306655833333,
            "2026-01-02": 2038.929573333333,
            "2026-01-03": 0.9715977777777778,
            "2026-01-04": 0.23874944444444446,
            "2026-01-05": 3906.0066374999997,
            "2026-01-06": 2273.7431050000005,
            "2026-01-07": 4307.046334166667,
            "2026-01-08": 855.1692091666664,
            "2026-01-09": 5039.487497222224,
            "2026-01-10": 78.79100722222223,
            "2026-01-11": 1570.273516111111,
            "2026-01-12": 614.5815005555556,
            "2026-01-13": 2925.317064166666,
            "2026-01-14": 937.3963616666667,
            "2026-01-15": 2301.678925000001,
            "2026-01-16": 2778.110827500003,
            "2026-01-17": 770.4592133333333,
            "2026-01-18": 3.9855472222222224,
            "2026-01-19": 3083.4942658333343,
            "2026-01-20": 2157.9297780555557,
            "2026-01-21": 2970.5574880555564,
            "2026-01-22": 1166.54019,
            "2026-01-23": 7498.346654444445,
            "2026-01-24": 0.09553694444444444,
            "2026-01-26": 1498.4358644444444,
            "2026-01-27": 1590.9732422222226,
            "2026-01-28": 102.17902444444447,
            "2026-01-29": 910.7646022222222,
            "2026-01-30": 1096.4044863888892,
            "2026-01-31": 134.79931277777777,
            "2026-02-02": 543.9214505555557,
            "2026-02-03": 20186.94400138889,
            "2026-02-04": 2852.3228330555553,
            "2026-02-05": 577.5642583333332,
            "2026-02-06": 2530.8394486111106,
            "2026-02-07": 532.1782808333334,
            "2026-02-09": 4243.570695000001,
            "2026-02-10": 21347.840369444457,
            "2026-02-11": 1624.2028194444442,
            "2026-02-12": 32841.9734825,
            "2026-02-13": 12885.488950277782,
            "2026-02-14": 2030.9476563888884,
            "2026-02-16": 7866.065953055556,
            "2026-02-17": 3812.6018750000007,
            "2026-02-18": 24448.091964166655,
            "2026-02-19": 1290.3409186111107,
            "2026-02-20": 2086.651537222221,
            "2026-02-21": 1086.8567094444438,
            "2026-02-22": 80.92334444444444,
            "2026-02-23": 3940.290795833334,
            "2026-02-24": 2177.348699722223,
            "2026-02-25": 4104.149063888889,
            "2026-02-26": 160.35081222222226,
            "2026-02-27": 450.98587388888893,
            "2026-02-28": 1243.287125833334,
            "2026-03-01": 500.97941805555564,
            "2026-03-02": 3496.1962327777765,
            "2026-03-03": 4816.929324722222,
            "2026-03-04": 1595.8151886111114,
            "2026-03-05": 4118.740750833333,
            "2026-03-06": 6512.828410555554,
            "2026-03-07": 803.8495155555552,
            "2026-03-08": 0.020296944444444444,
            "2026-03-09": 22117.612110833332,
            "2026-03-10": 6404.074384444446,
            "2026-03-11": 17255.823562500005,
            "2026-03-12": 6164.737428888891,
            "2026-03-13": 2452.025390277777,
            "2026-03-14": 53.60562361111112,
            "2026-03-15": 64.48122388888889,
            "2026-03-16": 1991.5973336111117,
            "2026-03-17": 23570.903232777768,
            "2026-03-18": 2996.036801388889,
            "2026-03-19": 5440.582792777777,
            "2026-03-20": 56910.72600444444,
            "2026-03-21": 42.23932305555555,
            "2026-03-22": 196.89580444444442,
            "2026-03-23": 6672.625735555553,
            "2026-03-24": 8320.541039166668,
            "2026-03-25": 6456.868371111107,
            "2026-03-26": 5182.564405833336,
            "2026-03-27": 3576.3947327777782,
            "2026-03-28": 71.58218444444444,
            "2026-03-29": 17.501973055555556,
            "2026-03-30": 4154.477712222223,
            "2026-03-31": 5028.76844361111,
            "2026-04-01": 2664.287048333335,
            "2026-04-02": 12639.944151388878,
            "2026-04-04": 110.63407027777777,
            "2026-04-06": 1538.1244122222229,
            "2026-04-07": 11051.321528611117,
            "2026-04-08": 2240.267836944445,
            "2026-04-09": 8580.798320833328,
            "2026-04-10": 30994.070265555547,
            "2026-04-11": 484.42309749999987,
            "2026-04-13": 10476.69796861111,
            "2026-04-14": 6552.84647138889,
            "2026-04-15": 3250.319650833334,
            "2026-04-16": 29178.26640694445,
            "2026-04-17": 11471.547895833339,
            "2026-04-18": 12787.310388333333,
            "2026-04-20": 4689.190758888886,
            "2026-04-21": 443.7762530555556,
            "2026-04-22": 39154.32675361112,
            "2026-04-23": 78666.37417666662,
            "2026-04-24": 1087.0931366666666,
            "2026-04-26": 1153.7789744444444,
            "2026-04-27": 3924.676474166668,
            "2026-04-28": 5902.017794722219,
            "2026-04-29": 5268.037058888887,
            "2026-04-30": 5227.3006488888905,
            "2026-05-02": 1726.0781477777778,
            "2026-05-04": 17091.79943666666,
            "2026-05-05": 13999.89000333333,
            "2026-05-06": 29090.79348333334,
            "2026-05-07": 7712.049331388886,
            "2026-05-08": 10771.042901944444,
            "2026-05-09": 819.9395277777779,
            "2026-05-10": 72.01353027777778,
            "2026-05-11": 673.7988569444442,
            "2026-05-12": 3164.4151500000003,
            "2026-05-13": 3828.274053888888,
            "2026-05-14": 13934.85217888888,
            "2026-05-15": 561.3881861111113,
            "2026-05-16": 180.63948555555552,
            "2026-05-17": 192.6073972222222,
            "2026-05-18": 3493.5468177777793,
            "2026-05-19": 2578.31721888889,
            "2026-05-20": 931.272747222222,
            "2026-05-21": 3980.773670833331,
            "2026-05-22": 5061.341263055557,
            "2026-05-23": 85.23790388888888,
            "2026-05-25": 1455.0392363888893,
            "2026-05-26": 10245.268465555548,
            "2026-05-27": 7957.248360277777,
            "2026-05-28": 4799.754271388891,
            "2026-05-29": 1050.519723888889,
            "2026-05-30": 7146.657636388893,
            "2026-06-01": 1382.870795277777,
            "2026-06-02": 4631.936434166663,
            "2026-06-03": 4320.909207777779,
            "2026-06-04": 888.8700166666666,
            "2026-06-05": 1296.5579752777778,
            "2026-06-06": 1999.5024544444448,
            "2026-06-08": 1240.2663324999999
          },
          "time_count_per_day": {
            "2025-09-30": 13,
            "2025-10-01": 4,
            "2025-10-02": 4,
            "2025-10-03": 3,
            "2025-10-06": 11,
            "2025-10-07": 18,
            "2025-10-08": 13,
            "2025-10-09": 11,
            "2025-10-10": 25,
            "2025-10-11": 2,
            "2025-10-13": 12,
            "2025-10-14": 43,
            "2025-10-15": 34,
            "2025-10-16": 8,
            "2025-10-17": 11,
            "2025-10-18": 3,
            "2025-10-20": 17,
            "2025-10-21": 22,
            "2025-10-22": 19,
            "2025-10-23": 41,
            "2025-10-24": 21,
            "2025-10-25": 3,
            "2025-10-26": 1,
            "2025-10-27": 39,
            "2025-10-28": 39,
            "2025-10-29": 33,
            "2025-10-30": 26,
            "2025-10-31": 44,
            "2025-11-02": 1,
            "2025-11-03": 37,
            "2025-11-04": 36,
            "2025-11-05": 21,
            "2025-11-06": 40,
            "2025-11-07": 17,
            "2025-11-08": 2,
            "2025-11-09": 1,
            "2025-11-10": 38,
            "2025-11-11": 31,
            "2025-11-12": 30,
            "2025-11-13": 39,
            "2025-11-14": 28,
            "2025-11-15": 1,
            "2025-11-16": 2,
            "2025-11-17": 55,
            "2025-11-18": 11,
            "2025-11-19": 31,
            "2025-11-20": 16,
            "2025-11-21": 31,
            "2025-11-22": 7,
            "2025-11-23": 7,
            "2025-11-24": 47,
            "2025-11-25": 18,
            "2025-11-26": 29,
            "2025-11-27": 36,
            "2025-11-28": 33,
            "2025-11-29": 4,
            "2025-11-30": 3,
            "2025-12-01": 2,
            "2025-12-02": 43,
            "2025-12-03": 22,
            "2025-12-04": 35,
            "2025-12-05": 31,
            "2025-12-06": 2,
            "2025-12-07": 1,
            "2025-12-08": 3,
            "2025-12-09": 27,
            "2025-12-10": 27,
            "2025-12-11": 39,
            "2025-12-12": 31,
            "2025-12-13": 9,
            "2025-12-14": 7,
            "2025-12-15": 66,
            "2025-12-16": 12,
            "2025-12-17": 32,
            "2025-12-18": 23,
            "2025-12-19": 26,
            "2025-12-20": 1,
            "2025-12-21": 1,
            "2025-12-22": 21,
            "2025-12-23": 19,
            "2025-12-24": 4,
            "2025-12-26": 30,
            "2025-12-28": 5,
            "2025-12-29": 32,
            "2025-12-30": 18,
            "2025-12-31": 8,
            "2026-01-02": 22,
            "2026-01-03": 2,
            "2026-01-04": 2,
            "2026-01-05": 29,
            "2026-01-06": 37,
            "2026-01-07": 36,
            "2026-01-08": 53,
            "2026-01-09": 27,
            "2026-01-10": 8,
            "2026-01-11": 2,
            "2026-01-12": 32,
            "2026-01-13": 56,
            "2026-01-14": 53,
            "2026-01-15": 59,
            "2026-01-16": 60,
            "2026-01-17": 10,
            "2026-01-18": 3,
            "2026-01-19": 62,
            "2026-01-20": 70,
            "2026-01-21": 42,
            "2026-01-22": 37,
            "2026-01-23": 60,
            "2026-01-24": 1,
            "2026-01-26": 68,
            "2026-01-27": 44,
            "2026-01-28": 14,
            "2026-01-29": 27,
            "2026-01-30": 59,
            "2026-01-31": 9,
            "2026-02-02": 23,
            "2026-02-03": 95,
            "2026-02-04": 35,
            "2026-02-05": 29,
            "2026-02-06": 31,
            "2026-02-07": 1,
            "2026-02-09": 53,
            "2026-02-10": 78,
            "2026-02-11": 21,
            "2026-02-12": 71,
            "2026-02-13": 73,
            "2026-02-14": 23,
            "2026-02-16": 45,
            "2026-02-17": 24,
            "2026-02-18": 94,
            "2026-02-19": 46,
            "2026-02-20": 65,
            "2026-02-21": 34,
            "2026-02-22": 3,
            "2026-02-23": 71,
            "2026-02-24": 66,
            "2026-02-25": 60,
            "2026-02-26": 31,
            "2026-02-27": 29,
            "2026-02-28": 48,
            "2026-03-01": 21,
            "2026-03-02": 105,
            "2026-03-03": 62,
            "2026-03-04": 80,
            "2026-03-05": 78,
            "2026-03-06": 75,
            "2026-03-07": 38,
            "2026-03-08": 2,
            "2026-03-09": 100,
            "2026-03-10": 83,
            "2026-03-11": 88,
            "2026-03-12": 72,
            "2026-03-13": 50,
            "2026-03-14": 11,
            "2026-03-15": 2,
            "2026-03-16": 82,
            "2026-03-17": 98,
            "2026-03-18": 88,
            "2026-03-19": 81,
            "2026-03-20": 141,
            "2026-03-21": 9,
            "2026-03-22": 1,
            "2026-03-23": 108,
            "2026-03-24": 76,
            "2026-03-25": 76,
            "2026-03-26": 50,
            "2026-03-27": 53,
            "2026-03-28": 14,
            "2026-03-29": 1,
            "2026-03-30": 87,
            "2026-03-31": 82,
            "2026-04-01": 52,
            "2026-04-02": 76,
            "2026-04-04": 18,
            "2026-04-06": 97,
            "2026-04-07": 83,
            "2026-04-08": 81,
            "2026-04-09": 78,
            "2026-04-10": 117,
            "2026-04-11": 31,
            "2026-04-13": 110,
            "2026-04-14": 76,
            "2026-04-15": 57,
            "2026-04-16": 100,
            "2026-04-17": 80,
            "2026-04-18": 27,
            "2026-04-20": 93,
            "2026-04-21": 53,
            "2026-04-22": 117,
            "2026-04-23": 165,
            "2026-04-24": 65,
            "2026-04-26": 2,
            "2026-04-27": 133,
            "2026-04-28": 60,
            "2026-04-29": 86,
            "2026-04-30": 89,
            "2026-05-02": 64,
            "2026-05-04": 158,
            "2026-05-05": 92,
            "2026-05-06": 143,
            "2026-05-07": 83,
            "2026-05-08": 74,
            "2026-05-09": 37,
            "2026-05-10": 1,
            "2026-05-11": 129,
            "2026-05-12": 79,
            "2026-05-13": 83,
            "2026-05-14": 128,
            "2026-05-15": 71,
            "2026-05-16": 23,
            "2026-05-17": 2,
            "2026-05-18": 136,
            "2026-05-19": 93,
            "2026-05-20": 93,
            "2026-05-21": 112,
            "2026-05-22": 99,
            "2026-05-23": 25,
            "2026-05-25": 116,
            "2026-05-26": 163,
            "2026-05-27": 116,
            "2026-05-28": 106,
            "2026-05-29": 114,
            "2026-05-30": 75,
            "2026-06-01": 104,
            "2026-06-02": 120,
            "2026-06-03": 123,
            "2026-06-04": 1,
            "2026-06-05": 159,
            "2026-06-06": 18,
            "2026-06-08": 79
          }
        },
        "P3": {
          "avg_time_hours": 197.14,
          "mode_time_hours": 1.0,
          "mode_frequency": 192,
          "time_distribution": {
            "0-2h": 192,
            "2-4h": 130,
            "4-6h": 103,
            "6-8h": 84,
            "8-10h": 76,
            "10-12h": 9,
            "12-14h": 35,
            "14-16h": 40,
            "16-18h": 33,
            "18-20h": 57,
            "20-22h": 46,
            "22-24h": 54,
            "24-26h": 57,
            "26-28h": 46,
            "28-30h": 25,
            "30-32h": 51,
            "32-34h": 40,
            "34-36h": 11,
            "36-38h": 7,
            "38-40h": 10,
            "40-42h": 6,
            "42-44h": 23,
            "44-46h": 20,
            "46-48h": 23,
            "48-50h": 23,
            "50-52h": 21,
            "52-54h": 10,
            "54-56h": 15,
            "56-58h": 18,
            "58-60h": 6,
            "60-62h": 15,
            "62-64h": 15,
            "64-66h": 8,
            "66-68h": 15,
            "68-70h": 9,
            "70-72h": 17,
            "72-74h": 19,
            "74-76h": 17,
            "76-78h": 12,
            "78-80h": 20,
            "80-82h": 11,
            "82-84h": 7,
            "84-86h": 10,
            "86-88h": 7,
            "88-90h": 4,
            "90-92h": 2,
            "92-94h": 9,
            "94-96h": 12,
            "96-98h": 14,
            "98-100h": 13,
            "100-102h": 24,
            "102-104h": 7,
            "104-106h": 6,
            "106-108h": 1,
            "108-110h": 2,
            "110-112h": 3,
            "112-114h": 1,
            "114-116h": 8,
            "116-118h": 8,
            "118-120h": 12,
            "120-122h": 6,
            "122-124h": 7,
            "124-126h": 13,
            "126-128h": 11,
            "128-130h": 10,
            "132-134h": 1,
            "134-136h": 1,
            "136-138h": 6,
            "138-140h": 4,
            "140-142h": 6,
            "142-144h": 8,
            "144-146h": 9,
            "146-148h": 3,
            "148-150h": 17,
            "150-152h": 11,
            "152-154h": 5,
            "154-156h": 1,
            "158-160h": 3,
            "160-162h": 3,
            "162-164h": 4,
            "164-166h": 10,
            "166-168h": 5,
            "168-170h": 7,
            "170-172h": 7,
            "172-174h": 5,
            "174-176h": 8,
            "176-178h": 4,
            "178-180h": 1,
            "182-184h": 3,
            "184-186h": 4,
            "186-188h": 2,
            "188-190h": 4,
            "190-192h": 8,
            "192-194h": 6,
            "194-196h": 5,
            "196-198h": 4,
            "198-200h": 4,
            "200-202h": 6,
            "204-206h": 1,
            "206-208h": 1,
            "208-210h": 3,
            "210-212h": 3,
            "214-216h": 1,
            "216-218h": 3,
            "218-220h": 5,
            "220-222h": 3,
            "222-224h": 2,
            "224-226h": 1,
            "226-228h": 3,
            "228-230h": 1,
            "230-232h": 1,
            "232-234h": 1,
            "234-236h": 2,
            "236-238h": 3,
            "240-242h": 4,
            "242-244h": 10,
            "244-246h": 4,
            "246-248h": 1,
            "248-250h": 1,
            "250-252h": 1,
            "252-254h": 1,
            "254-256h": 1,
            "256-258h": 2,
            "258-260h": 1,
            "260-262h": 2,
            "262-264h": 4,
            "266-268h": 1,
            "268-270h": 8,
            "270-272h": 2,
            "272-274h": 5,
            "276-278h": 2,
            "280-282h": 1,
            "282-284h": 2,
            "284-286h": 1,
            "288-290h": 2,
            "290-292h": 1,
            "292-294h": 1,
            "294-296h": 1,
            "298-300h": 1,
            "304-306h": 3,
            "306-308h": 1,
            "308-310h": 3,
            "310-312h": 2,
            "312-314h": 3,
            "314-316h": 2,
            "316-318h": 6,
            "318-320h": 3,
            "320-322h": 3,
            "322-324h": 1,
            "326-328h": 1,
            "328-330h": 1,
            "332-334h": 1,
            "334-336h": 2,
            "336-338h": 5,
            "338-340h": 6,
            "340-342h": 1,
            "342-344h": 2,
            "344-346h": 3,
            "348-350h": 3,
            "350-352h": 2,
            "354-356h": 2,
            "356-358h": 3,
            "358-360h": 4,
            "360-362h": 3,
            "362-364h": 1,
            "364-366h": 1,
            "366-368h": 1,
            "368-370h": 3,
            "370-372h": 1,
            "372-374h": 3,
            "376-378h": 2,
            "378-380h": 2,
            "380-382h": 1,
            "382-384h": 1,
            "386-388h": 4,
            "388-390h": 1,
            "390-392h": 1,
            "404-406h": 1,
            "406-408h": 3,
            "410-412h": 3,
            "414-416h": 2,
            "416-418h": 3,
            "418-420h": 1,
            "422-424h": 2,
            "424-426h": 3,
            "428-430h": 1,
            "430-432h": 2,
            "432-434h": 3,
            "434-436h": 1,
            "436-438h": 1,
            "446-448h": 1,
            "448-450h": 2,
            "450-452h": 1,
            "452-454h": 2,
            "454-456h": 3,
            "458-460h": 1,
            "460-462h": 1,
            "462-464h": 2,
            "470-472h": 1,
            "472-474h": 2,
            "478-480h": 10,
            "482-484h": 3,
            "488-490h": 1,
            "490-492h": 1,
            "492-494h": 3,
            "494-496h": 1,
            "496-498h": 2,
            "498-500h": 3,
            "500-502h": 4,
            "502-504h": 2,
            "504-506h": 7,
            "506-508h": 2,
            "510-512h": 3,
            "512-514h": 1,
            "514-516h": 2,
            "516-518h": 5,
            "522-524h": 1,
            "524-526h": 1,
            "526-528h": 4,
            "528-530h": 5,
            "530-532h": 1,
            "532-534h": 1,
            "534-536h": 4,
            "536-538h": 1,
            "538-540h": 4,
            "546-548h": 1,
            "548-550h": 2,
            "558-560h": 1,
            "560-562h": 2,
            "570-572h": 1,
            "572-574h": 2,
            "574-576h": 3,
            "576-578h": 7,
            "578-580h": 3,
            "580-582h": 1,
            "582-584h": 1,
            "584-586h": 1,
            "586-588h": 1,
            "588-590h": 1,
            "590-592h": 1,
            "592-594h": 2,
            "594-596h": 2,
            "596-598h": 2,
            "598-600h": 1,
            "600-602h": 1,
            "606-608h": 1,
            "612-614h": 1,
            "614-616h": 1,
            "616-618h": 2,
            "618-620h": 1,
            "624-626h": 1,
            "626-628h": 2,
            "628-630h": 2,
            "642-644h": 2,
            "646-648h": 1,
            "648-650h": 1,
            "658-660h": 1,
            "670-672h": 3,
            "678-680h": 3,
            "680-682h": 2,
            "682-684h": 1,
            "690-692h": 1,
            "694-696h": 1,
            "696-698h": 2,
            "698-700h": 1,
            "700-702h": 2,
            "704-706h": 1,
            "714-716h": 2,
            "720-722h": 1,
            "722-724h": 3,
            "724-726h": 1,
            "736-738h": 1,
            "742-744h": 1,
            "744-746h": 1,
            "758-760h": 1,
            "768-770h": 1,
            "782-784h": 1,
            "788-790h": 1,
            "790-792h": 1,
            "794-796h": 2,
            "814-816h": 2,
            "816-818h": 1,
            "820-822h": 3,
            "824-826h": 1,
            "834-836h": 1,
            "838-840h": 1,
            "840-842h": 2,
            "842-844h": 1,
            "844-846h": 2,
            "846-848h": 2,
            "848-850h": 1,
            "850-852h": 1,
            "860-862h": 1,
            "866-868h": 2,
            "870-872h": 1,
            "872-874h": 2,
            "876-878h": 1,
            "882-884h": 2,
            "886-888h": 2,
            "890-892h": 1,
            "894-896h": 1,
            "896-898h": 1,
            "898-900h": 3,
            "906-908h": 1,
            "910-912h": 1,
            "912-914h": 1,
            "916-918h": 1,
            "924-926h": 1,
            "944-946h": 1,
            "952-954h": 1,
            "960-962h": 2,
            "964-966h": 1,
            "976-978h": 1,
            "984-986h": 2,
            "986-988h": 1,
            "988-990h": 2,
            "1006-1008h": 1,
            "1012-1014h": 2,
            "1018-1020h": 1,
            "1030-1032h": 1,
            "1032-1034h": 1,
            "1034-1036h": 1,
            "1038-1040h": 1,
            "1046-1048h": 2,
            "1050-1052h": 1,
            "1054-1056h": 1,
            "1060-1062h": 2,
            "1080-1082h": 1,
            "1096-1098h": 1,
            "1102-1104h": 1,
            "1104-1106h": 2,
            "1106-1108h": 1,
            "1140-1142h": 1,
            "1152-1154h": 1,
            "1162-1164h": 2,
            "1176-1178h": 1,
            "1178-1180h": 2,
            "1188-1190h": 1,
            "1198-1200h": 2,
            "1202-1204h": 1,
            "1212-1214h": 1,
            "1238-1240h": 1,
            "1250-1252h": 1,
            "1278-1280h": 1,
            "1282-1284h": 2,
            "1284-1286h": 2,
            "1306-1308h": 1,
            "1324-1326h": 1,
            "1326-1328h": 1,
            "1338-1340h": 1,
            "1348-1350h": 1,
            "1360-1362h": 1,
            "1362-1364h": 1,
            "1376-1378h": 3,
            "1380-1382h": 1,
            "1388-1390h": 1,
            "1390-1392h": 2,
            "1404-1406h": 1,
            "1416-1418h": 1,
            "1422-1424h": 1,
            "1426-1428h": 1,
            "1468-1470h": 1,
            "1476-1478h": 2,
            "1498-1500h": 1,
            "1500-1502h": 1,
            "1506-1508h": 1,
            "1508-1510h": 1,
            "1514-1516h": 1,
            "1518-1520h": 1,
            "1570-1572h": 1,
            "1658-1660h": 1,
            "1684-1686h": 2,
            "1718-1720h": 1,
            "1728-1730h": 1,
            "1732-1734h": 3,
            "1752-1754h": 2,
            "1778-1780h": 1,
            "1786-1788h": 1,
            "1830-1832h": 1,
            "1844-1846h": 1,
            "1856-1858h": 1,
            "1872-1874h": 1,
            "1944-1946h": 1,
            "1962-1964h": 1,
            "2008-2010h": 1,
            "2016-2018h": 1,
            "2032-2034h": 1,
            "2044-2046h": 1,
            "2048-2050h": 1,
            "2152-2154h": 1,
            "2160-2162h": 1,
            "2182-2184h": 1,
            "2212-2214h": 1,
            "2304-2306h": 1,
            "2350-2352h": 1,
            "2372-2374h": 1,
            "2392-2394h": 1,
            "2524-2526h": 2,
            "2534-2536h": 1,
            "2696-2698h": 1,
            "2902-2904h": 1,
            "3246-3248h": 1,
            "3550-3552h": 1,
            "4036-4038h": 1
          },
          "tickets_count": 2340,
          "tickets_per_day": {
            "2025-09-30": 11,
            "2025-10-01": 7,
            "2025-10-02": 2,
            "2025-10-03": 4,
            "2025-10-06": 5,
            "2025-10-07": 8,
            "2025-10-08": 9,
            "2025-10-09": 6,
            "2025-10-10": 6,
            "2025-10-12": 1,
            "2025-10-13": 7,
            "2025-10-14": 7,
            "2025-10-15": 13,
            "2025-10-16": 3,
            "2025-10-17": 3,
            "2025-10-18": 1,
            "2025-10-21": 4,
            "2025-10-22": 1,
            "2025-10-23": 7,
            "2025-10-24": 9,
            "2025-10-27": 4,
            "2025-10-28": 5,
            "2025-10-30": 9,
            "2025-11-03": 13,
            "2025-11-04": 9,
            "2025-11-05": 10,
            "2025-11-06": 19,
            "2025-11-07": 18,
            "2025-11-08": 1,
            "2025-11-10": 3,
            "2025-11-11": 4,
            "2025-11-12": 18,
            "2025-11-13": 28,
            "2025-11-14": 17,
            "2025-11-16": 1,
            "2025-11-17": 34,
            "2025-11-18": 23,
            "2025-11-19": 30,
            "2025-11-20": 17,
            "2025-11-21": 17,
            "2025-11-22": 16,
            "2025-11-23": 1,
            "2025-11-24": 29,
            "2025-11-25": 16,
            "2025-11-26": 14,
            "2025-11-27": 22,
            "2025-11-28": 16,
            "2025-11-29": 3,
            "2025-11-30": 1,
            "2025-12-01": 1,
            "2025-12-02": 52,
            "2025-12-03": 13,
            "2025-12-04": 27,
            "2025-12-05": 17,
            "2025-12-09": 12,
            "2025-12-10": 21,
            "2025-12-11": 22,
            "2025-12-12": 21,
            "2025-12-13": 6,
            "2025-12-14": 8,
            "2025-12-15": 49,
            "2025-12-16": 6,
            "2025-12-17": 12,
            "2025-12-18": 21,
            "2025-12-19": 22,
            "2025-12-22": 14,
            "2025-12-23": 13,
            "2025-12-24": 3,
            "2025-12-25": 1,
            "2025-12-26": 13,
            "2025-12-28": 1,
            "2025-12-29": 6,
            "2025-12-30": 5,
            "2025-12-31": 1,
            "2026-01-02": 2,
            "2026-01-05": 11,
            "2026-01-06": 6,
            "2026-01-07": 22,
            "2026-01-08": 8,
            "2026-01-09": 6,
            "2026-01-11": 2,
            "2026-01-12": 12,
            "2026-01-13": 53,
            "2026-01-14": 33,
            "2026-01-15": 72,
            "2026-01-16": 25,
            "2026-01-17": 11,
            "2026-01-18": 8,
            "2026-01-19": 25,
            "2026-01-20": 12,
            "2026-01-21": 11,
            "2026-01-22": 27,
            "2026-01-23": 33,
            "2026-01-24": 2,
            "2026-01-26": 20,
            "2026-01-27": 77,
            "2026-01-28": 45,
            "2026-01-29": 18,
            "2026-01-30": 4,
            "2026-01-31": 12,
            "2026-02-02": 25,
            "2026-02-03": 109,
            "2026-02-04": 30,
            "2026-02-05": 17,
            "2026-02-06": 22,
            "2026-02-07": 35,
            "2026-02-09": 48,
            "2026-02-10": 127,
            "2026-02-11": 6,
            "2026-02-12": 45,
            "2026-02-13": 55,
            "2026-02-14": 53,
            "2026-02-16": 20,
            "2026-02-17": 8,
            "2026-02-18": 58,
            "2026-02-19": 21,
            "2026-02-20": 19,
            "2026-02-22": 1,
            "2026-02-23": 3,
            "2026-02-24": 5,
            "2026-02-25": 4,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 1,
            "2026-03-02": 2,
            "2026-03-04": 8,
            "2026-03-05": 15,
            "2026-03-06": 9,
            "2026-03-07": 1,
            "2026-03-09": 7,
            "2026-03-10": 3,
            "2026-03-11": 6,
            "2026-03-12": 2,
            "2026-03-13": 2,
            "2026-03-16": 3,
            "2026-03-17": 17,
            "2026-03-18": 4,
            "2026-03-19": 3,
            "2026-03-20": 12,
            "2026-03-23": 2,
            "2026-03-24": 3,
            "2026-03-25": 6,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 9,
            "2026-04-01": 3,
            "2026-04-06": 3,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 3,
            "2026-04-10": 6,
            "2026-04-13": 2,
            "2026-04-14": 1,
            "2026-04-16": 7,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-04-20": 2,
            "2026-04-21": 1,
            "2026-04-22": 3,
            "2026-04-23": 10,
            "2026-04-29": 3,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 5,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-13": 3,
            "2026-05-14": 4,
            "2026-05-18": 1,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-06-01": 1,
            "2026-06-06": 3
          },
          "time_per_day": {
            "2025-09-30": 27.977766388888885,
            "2025-10-01": 106.26325638888888,
            "2025-10-02": 64.45996916666667,
            "2025-10-03": 156.03321416666665,
            "2025-10-06": 378.93240194444445,
            "2025-10-07": 566.7793661111111,
            "2025-10-08": 222.04546194444447,
            "2025-10-09": 603.6497036111111,
            "2025-10-10": 892.5221100000001,
            "2025-10-12": 209.2571233333333,
            "2025-10-13": 692.5035483333334,
            "2025-10-14": 1279.9784780555556,
            "2025-10-15": 817.5831088888889,
            "2025-10-16": 108.14720194444445,
            "2025-10-17": 266.111235,
            "2025-10-18": 88.81827666666666,
            "2025-10-21": 617.0900416666667,
            "2025-10-22": 337.6833766666667,
            "2025-10-23": 1006.9679586111112,
            "2025-10-24": 1024.5430083333333,
            "2025-10-27": 817.8390030555556,
            "2025-10-28": 572.8336455555556,
            "2025-10-30": 1131.392261944444,
            "2025-11-03": 1532.1930938888884,
            "2025-11-04": 3252.5458358333335,
            "2025-11-05": 632.5019219444446,
            "2025-11-06": 3384.3193791666667,
            "2025-11-07": 723.6397072222222,
            "2025-11-08": 358.8417494444444,
            "2025-11-10": 615.7760208333333,
            "2025-11-11": 55.22893527777777,
            "2025-11-12": 1922.9812602777777,
            "2025-11-13": 1700.213756111111,
            "2025-11-14": 2792.0907347222233,
            "2025-11-16": 253.38371305555555,
            "2025-11-17": 2913.365906666666,
            "2025-11-18": 3042.8875219444444,
            "2025-11-19": 3649.9972513888893,
            "2025-11-20": 1603.0491944444448,
            "2025-11-21": 1491.6808736111116,
            "2025-11-22": 1088.3397575,
            "2025-11-23": 72.40252111111111,
            "2025-11-24": 3305.535334166668,
            "2025-11-25": 789.5100880555556,
            "2025-11-26": 2604.7224691666665,
            "2025-11-27": 3986.4771861111117,
            "2025-11-28": 1377.9380294444445,
            "2025-11-29": 556.4254791666667,
            "2025-11-30": 43.668389166666664,
            "2025-12-01": 1.4348958333333333,
            "2025-12-02": 8082.025964166671,
            "2025-12-03": 1347.785131388889,
            "2025-12-04": 3428.9117469444445,
            "2025-12-05": 1103.3481780555555,
            "2025-12-09": 918.0585591666667,
            "2025-12-10": 3020.492714722222,
            "2025-12-11": 3643.838073888889,
            "2025-12-12": 2736.781161111112,
            "2025-12-13": 1943.3696905555557,
            "2025-12-14": 399.1870141666667,
            "2025-12-15": 15003.350805000002,
            "2025-12-16": 609.9533772222222,
            "2025-12-17": 357.84544222222223,
            "2025-12-18": 904.3817186111113,
            "2025-12-19": 3742.858556666666,
            "2025-12-22": 2559.4679030555562,
            "2025-12-23": 698.8498116666666,
            "2025-12-24": 868.0044952777778,
            "2025-12-25": 56.22132055555555,
            "2025-12-26": 2304.9627608333335,
            "2025-12-28": 99.04570694444443,
            "2025-12-29": 417.91848472222216,
            "2025-12-30": 525.1930822222222,
            "2025-12-31": 52.349401944444445,
            "2026-01-02": 1033.0062691666667,
            "2026-01-05": 3048.5030702777776,
            "2026-01-06": 240.2308161111111,
            "2026-01-07": 7846.386869722223,
            "2026-01-08": 194.04646055555554,
            "2026-01-09": 2980.7532444444446,
            "2026-01-11": 2158.7774994444444,
            "2026-01-12": 219.95980138888888,
            "2026-01-13": 1157.8354299999999,
            "2026-01-14": 2659.255403888889,
            "2026-01-15": 3722.849103055556,
            "2026-01-16": 2166.7706925,
            "2026-01-17": 245.48245416666666,
            "2026-01-18": 107.7343877777778,
            "2026-01-19": 1111.013510555555,
            "2026-01-20": 2966.3655588888887,
            "2026-01-21": 2999.422995277778,
            "2026-01-22": 1697.4764991666668,
            "2026-01-23": 6739.396950277776,
            "2026-01-24": 656.7112477777778,
            "2026-01-26": 1306.3808647222224,
            "2026-01-27": 5533.631539722221,
            "2026-01-28": 980.3190900000002,
            "2026-01-29": 331.45244750000006,
            "2026-01-30": 387.7291122222222,
            "2026-01-31": 341.60423333333335,
            "2026-02-02": 419.5944186111111,
            "2026-02-03": 25322.585599722235,
            "2026-02-04": 3607.136253333332,
            "2026-02-05": 886.7108797222224,
            "2026-02-06": 1238.7590925000004,
            "2026-02-07": 2388.5387991666666,
            "2026-02-09": 3890.96898,
            "2026-02-10": 34110.94238138889,
            "2026-02-11": 36.609114999999996,
            "2026-02-12": 30379.380680833336,
            "2026-02-13": 11594.533216944448,
            "2026-02-14": 4162.077094722223,
            "2026-02-16": 8677.582722222223,
            "2026-02-17": 4884.676973055557,
            "2026-02-18": 31326.62573499999,
            "2026-02-19": 4350.992880277777,
            "2026-02-20": 3829.628050277778,
            "2026-02-22": 29.831705277777775,
            "2026-02-23": 1259.661416388889,
            "2026-02-24": 6.951343888888889,
            "2026-02-25": 369.76978361111105,
            "2026-02-26": 3.644743611111111,
            "2026-02-27": 503.90358944444444,
            "2026-02-28": 43.23732277777778,
            "2026-03-02": 1507.2330680555556,
            "2026-03-04": 18.201177500000004,
            "2026-03-05": 7037.271190555556,
            "2026-03-06": 4922.916240555555,
            "2026-03-07": 49.85104638888889,
            "2026-03-09": 5474.705271388889,
            "2026-03-10": 3348.767250833333,
            "2026-03-11": 4414.472651111111,
            "2026-03-12": 2135.8638861111112,
            "2026-03-13": 1601.8432541666668,
            "2026-03-16": 366.30065916666666,
            "2026-03-17": 8843.658211666667,
            "2026-03-18": 353.9277166666667,
            "2026-03-19": 1133.2669727777777,
            "2026-03-20": 7865.026842777778,
            "2026-03-23": 1345.8612175,
            "2026-03-24": 3635.96933,
            "2026-03-25": 5867.991943333333,
            "2026-03-27": 2715.3004086111114,
            "2026-03-30": 1052.2361569444445,
            "2026-03-31": 3757.047209444444,
            "2026-04-01": 1384.0057291666667,
            "2026-04-06": 728.1923758333334,
            "2026-04-07": 2016.1087336111111,
            "2026-04-08": 199.64447777777778,
            "2026-04-09": 2756.3206966666667,
            "2026-04-10": 6420.775676666667,
            "2026-04-13": 11.537969444444444,
            "2026-04-14": 150.66607138888887,
            "2026-04-16": 693.4120855555556,
            "2026-04-17": 1.0168580555555555,
            "2026-04-18": 964.5005186111111,
            "2026-04-20": 1043.4548855555556,
            "2026-04-21": 16.983233055555555,
            "2026-04-22": 4078.947684999999,
            "2026-04-23": 10280.181079166667,
            "2026-04-29": 3208.853951944445,
            "2026-05-04": 497.84789472222224,
            "2026-05-05": 417.4196763888889,
            "2026-05-06": 6496.493926388889,
            "2026-05-07": 2.6027802777777778,
            "2026-05-10": 74.07216916666667,
            "2026-05-13": 171.41744777777777,
            "2026-05-14": 11432.203654166666,
            "2026-05-18": 262.2557683333333,
            "2026-05-22": 526.3828397222222,
            "2026-05-25": 5.3107033333333336,
            "2026-06-01": 1732.6893233333335,
            "2026-06-06": 1556.4501066666667
          },
          "time_count_per_day": {
            "2025-09-30": 11,
            "2025-10-01": 7,
            "2025-10-02": 2,
            "2025-10-03": 4,
            "2025-10-06": 5,
            "2025-10-07": 8,
            "2025-10-08": 9,
            "2025-10-09": 6,
            "2025-10-10": 6,
            "2025-10-12": 1,
            "2025-10-13": 7,
            "2025-10-14": 7,
            "2025-10-15": 13,
            "2025-10-16": 3,
            "2025-10-17": 3,
            "2025-10-18": 1,
            "2025-10-21": 4,
            "2025-10-22": 1,
            "2025-10-23": 7,
            "2025-10-24": 9,
            "2025-10-27": 4,
            "2025-10-28": 5,
            "2025-10-30": 9,
            "2025-11-03": 13,
            "2025-11-04": 9,
            "2025-11-05": 10,
            "2025-11-06": 19,
            "2025-11-07": 18,
            "2025-11-08": 1,
            "2025-11-10": 3,
            "2025-11-11": 4,
            "2025-11-12": 18,
            "2025-11-13": 28,
            "2025-11-14": 17,
            "2025-11-16": 1,
            "2025-11-17": 34,
            "2025-11-18": 23,
            "2025-11-19": 30,
            "2025-11-20": 17,
            "2025-11-21": 17,
            "2025-11-22": 16,
            "2025-11-23": 1,
            "2025-11-24": 29,
            "2025-11-25": 16,
            "2025-11-26": 14,
            "2025-11-27": 22,
            "2025-11-28": 16,
            "2025-11-29": 3,
            "2025-11-30": 1,
            "2025-12-01": 1,
            "2025-12-02": 52,
            "2025-12-03": 13,
            "2025-12-04": 27,
            "2025-12-05": 17,
            "2025-12-09": 12,
            "2025-12-10": 21,
            "2025-12-11": 22,
            "2025-12-12": 21,
            "2025-12-13": 6,
            "2025-12-14": 8,
            "2025-12-15": 49,
            "2025-12-16": 6,
            "2025-12-17": 12,
            "2025-12-18": 21,
            "2025-12-19": 22,
            "2025-12-22": 14,
            "2025-12-23": 13,
            "2025-12-24": 3,
            "2025-12-25": 1,
            "2025-12-26": 13,
            "2025-12-28": 1,
            "2025-12-29": 6,
            "2025-12-30": 5,
            "2025-12-31": 1,
            "2026-01-02": 2,
            "2026-01-05": 11,
            "2026-01-06": 6,
            "2026-01-07": 22,
            "2026-01-08": 8,
            "2026-01-09": 6,
            "2026-01-11": 2,
            "2026-01-12": 12,
            "2026-01-13": 53,
            "2026-01-14": 33,
            "2026-01-15": 72,
            "2026-01-16": 25,
            "2026-01-17": 11,
            "2026-01-18": 8,
            "2026-01-19": 25,
            "2026-01-20": 12,
            "2026-01-21": 11,
            "2026-01-22": 27,
            "2026-01-23": 33,
            "2026-01-24": 2,
            "2026-01-26": 20,
            "2026-01-27": 77,
            "2026-01-28": 45,
            "2026-01-29": 18,
            "2026-01-30": 4,
            "2026-01-31": 12,
            "2026-02-02": 25,
            "2026-02-03": 109,
            "2026-02-04": 30,
            "2026-02-05": 17,
            "2026-02-06": 22,
            "2026-02-07": 35,
            "2026-02-09": 48,
            "2026-02-10": 127,
            "2026-02-11": 6,
            "2026-02-12": 45,
            "2026-02-13": 55,
            "2026-02-14": 53,
            "2026-02-16": 20,
            "2026-02-17": 8,
            "2026-02-18": 58,
            "2026-02-19": 21,
            "2026-02-20": 19,
            "2026-02-22": 1,
            "2026-02-23": 3,
            "2026-02-24": 5,
            "2026-02-25": 4,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 1,
            "2026-03-02": 2,
            "2026-03-04": 8,
            "2026-03-05": 15,
            "2026-03-06": 9,
            "2026-03-07": 1,
            "2026-03-09": 7,
            "2026-03-10": 3,
            "2026-03-11": 6,
            "2026-03-12": 2,
            "2026-03-13": 2,
            "2026-03-16": 3,
            "2026-03-17": 17,
            "2026-03-18": 4,
            "2026-03-19": 3,
            "2026-03-20": 12,
            "2026-03-23": 2,
            "2026-03-24": 3,
            "2026-03-25": 6,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 9,
            "2026-04-01": 3,
            "2026-04-06": 3,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-09": 3,
            "2026-04-10": 6,
            "2026-04-13": 2,
            "2026-04-14": 1,
            "2026-04-16": 7,
            "2026-04-17": 1,
            "2026-04-18": 1,
            "2026-04-20": 2,
            "2026-04-21": 1,
            "2026-04-22": 3,
            "2026-04-23": 10,
            "2026-04-29": 3,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-06": 5,
            "2026-05-07": 1,
            "2026-05-10": 1,
            "2026-05-13": 3,
            "2026-05-14": 4,
            "2026-05-18": 1,
            "2026-05-22": 1,
            "2026-05-25": 1,
            "2026-06-01": 1,
            "2026-06-06": 3
          }
        },
        "Reservas sem Formulário": {
          "avg_time_hours": 159.81,
          "mode_time_hours": 1.0,
          "mode_frequency": 70,
          "time_distribution": {
            "0-2h": 70,
            "2-4h": 51,
            "4-6h": 50,
            "6-8h": 45,
            "8-10h": 31,
            "10-12h": 32,
            "12-14h": 15,
            "14-16h": 9,
            "16-18h": 30,
            "18-20h": 35,
            "20-22h": 49,
            "22-24h": 53,
            "24-26h": 64,
            "26-28h": 43,
            "28-30h": 43,
            "30-32h": 53,
            "32-34h": 24,
            "34-36h": 20,
            "36-38h": 52,
            "38-40h": 6,
            "40-42h": 29,
            "42-44h": 18,
            "44-46h": 34,
            "46-48h": 24,
            "48-50h": 25,
            "50-52h": 45,
            "52-54h": 24,
            "54-56h": 11,
            "56-58h": 21,
            "58-60h": 13,
            "60-62h": 12,
            "62-64h": 3,
            "64-66h": 4,
            "66-68h": 13,
            "68-70h": 13,
            "70-72h": 22,
            "72-74h": 20,
            "74-76h": 21,
            "76-78h": 22,
            "78-80h": 28,
            "80-82h": 20,
            "82-84h": 23,
            "84-86h": 8,
            "86-88h": 3,
            "88-90h": 6,
            "90-92h": 9,
            "92-94h": 14,
            "94-96h": 28,
            "96-98h": 28,
            "98-100h": 19,
            "100-102h": 11,
            "102-104h": 18,
            "104-106h": 20,
            "106-108h": 3,
            "108-110h": 3,
            "110-112h": 4,
            "112-114h": 9,
            "114-116h": 12,
            "116-118h": 8,
            "118-120h": 18,
            "120-122h": 20,
            "122-124h": 22,
            "124-126h": 14,
            "126-128h": 14,
            "128-130h": 9,
            "130-132h": 7,
            "132-134h": 8,
            "134-136h": 9,
            "136-138h": 2,
            "138-140h": 7,
            "140-142h": 29,
            "142-144h": 12,
            "144-146h": 18,
            "146-148h": 12,
            "148-150h": 8,
            "150-152h": 15,
            "152-154h": 5,
            "154-156h": 7,
            "156-158h": 12,
            "158-160h": 10,
            "160-162h": 10,
            "162-164h": 12,
            "164-166h": 20,
            "166-168h": 13,
            "168-170h": 8,
            "170-172h": 1,
            "172-174h": 10,
            "174-176h": 9,
            "176-178h": 8,
            "178-180h": 11,
            "180-182h": 14,
            "182-184h": 5,
            "184-186h": 5,
            "186-188h": 6,
            "188-190h": 3,
            "190-192h": 2,
            "192-194h": 14,
            "194-196h": 12,
            "196-198h": 9,
            "198-200h": 9,
            "200-202h": 7,
            "202-204h": 5,
            "204-206h": 3,
            "206-208h": 9,
            "208-210h": 4,
            "210-212h": 6,
            "212-214h": 5,
            "214-216h": 5,
            "216-218h": 29,
            "218-220h": 8,
            "220-222h": 5,
            "222-224h": 4,
            "224-226h": 2,
            "228-230h": 9,
            "230-232h": 1,
            "232-234h": 1,
            "234-236h": 3,
            "238-240h": 3,
            "240-242h": 6,
            "242-244h": 2,
            "244-246h": 1,
            "246-248h": 2,
            "248-250h": 4,
            "252-254h": 1,
            "256-258h": 4,
            "258-260h": 3,
            "260-262h": 2,
            "262-264h": 1,
            "264-266h": 4,
            "266-268h": 8,
            "268-270h": 3,
            "270-272h": 2,
            "272-274h": 6,
            "274-276h": 5,
            "276-278h": 7,
            "278-280h": 5,
            "280-282h": 1,
            "282-284h": 5,
            "284-286h": 2,
            "286-288h": 7,
            "288-290h": 11,
            "290-292h": 3,
            "292-294h": 3,
            "294-296h": 2,
            "298-300h": 1,
            "300-302h": 1,
            "302-304h": 1,
            "304-306h": 3,
            "306-308h": 3,
            "308-310h": 1,
            "310-312h": 10,
            "312-314h": 6,
            "314-316h": 1,
            "316-318h": 2,
            "318-320h": 1,
            "320-322h": 1,
            "322-324h": 1,
            "324-326h": 4,
            "328-330h": 3,
            "330-332h": 6,
            "332-334h": 5,
            "334-336h": 14,
            "336-338h": 8,
            "338-340h": 2,
            "340-342h": 2,
            "342-344h": 1,
            "346-348h": 1,
            "348-350h": 5,
            "350-352h": 2,
            "352-354h": 6,
            "354-356h": 5,
            "356-358h": 9,
            "358-360h": 8,
            "360-362h": 4,
            "362-364h": 6,
            "364-366h": 3,
            "366-368h": 4,
            "368-370h": 1,
            "370-372h": 8,
            "372-374h": 11,
            "376-378h": 2,
            "378-380h": 2,
            "380-382h": 5,
            "382-384h": 13,
            "384-386h": 22,
            "386-388h": 1,
            "388-390h": 7,
            "390-392h": 1,
            "392-394h": 3,
            "396-398h": 1,
            "398-400h": 13,
            "400-402h": 8,
            "402-404h": 2,
            "404-406h": 10,
            "406-408h": 3,
            "408-410h": 4,
            "410-412h": 1,
            "412-414h": 2,
            "414-416h": 4,
            "416-418h": 4,
            "420-422h": 9,
            "422-424h": 6,
            "424-426h": 4,
            "426-428h": 4,
            "428-430h": 6,
            "430-432h": 3,
            "432-434h": 4,
            "438-440h": 2,
            "442-444h": 1,
            "444-446h": 5,
            "446-448h": 4,
            "448-450h": 1,
            "450-452h": 2,
            "452-454h": 7,
            "454-456h": 9,
            "456-458h": 11,
            "458-460h": 3,
            "462-464h": 1,
            "464-466h": 2,
            "466-468h": 7,
            "468-470h": 1,
            "470-472h": 1,
            "472-474h": 2,
            "474-476h": 1,
            "476-478h": 1,
            "478-480h": 3,
            "480-482h": 1,
            "482-484h": 1,
            "490-492h": 1,
            "492-494h": 3,
            "494-496h": 2,
            "496-498h": 7,
            "498-500h": 3,
            "500-502h": 6,
            "502-504h": 12,
            "504-506h": 4,
            "508-510h": 5,
            "510-512h": 1,
            "514-516h": 1,
            "522-524h": 2,
            "524-526h": 2,
            "526-528h": 1,
            "530-532h": 2,
            "532-534h": 1,
            "536-538h": 2,
            "538-540h": 1,
            "540-542h": 1,
            "546-548h": 3,
            "548-550h": 3,
            "552-554h": 1,
            "554-556h": 1,
            "556-558h": 3,
            "558-560h": 1,
            "570-572h": 1,
            "572-574h": 1,
            "574-576h": 2,
            "576-578h": 1,
            "582-584h": 2,
            "594-596h": 1,
            "598-600h": 2,
            "602-604h": 1,
            "604-606h": 1,
            "614-616h": 3,
            "620-622h": 2,
            "622-624h": 1,
            "624-626h": 3,
            "626-628h": 1,
            "628-630h": 2,
            "630-632h": 1,
            "634-636h": 1,
            "644-646h": 1,
            "646-648h": 2,
            "650-652h": 2,
            "652-654h": 2,
            "654-656h": 1,
            "656-658h": 1,
            "664-666h": 2,
            "674-676h": 1,
            "678-680h": 1,
            "690-692h": 1,
            "700-702h": 2,
            "702-704h": 1,
            "724-726h": 2,
            "726-728h": 1,
            "740-742h": 1,
            "752-754h": 1,
            "816-818h": 1,
            "824-826h": 3,
            "836-838h": 1,
            "838-840h": 1,
            "842-844h": 1,
            "848-850h": 1,
            "858-860h": 1,
            "916-918h": 1,
            "966-968h": 1,
            "982-984h": 2,
            "1152-1154h": 1,
            "1222-1224h": 2,
            "1412-1414h": 1,
            "1506-1508h": 1,
            "1846-1848h": 1,
            "2344-2346h": 1,
            "2374-2376h": 1
          },
          "tickets_count": 2569,
          "tickets_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 31,
            "2025-10-08": 3,
            "2025-10-09": 20,
            "2025-10-10": 12,
            "2025-10-13": 31,
            "2025-10-14": 19,
            "2025-10-15": 27,
            "2025-10-16": 4,
            "2025-10-17": 22,
            "2025-10-20": 9,
            "2025-10-21": 11,
            "2025-10-22": 13,
            "2025-10-23": 32,
            "2025-10-24": 2,
            "2025-10-25": 11,
            "2025-10-27": 25,
            "2025-10-28": 5,
            "2025-10-29": 21,
            "2025-10-30": 26,
            "2025-10-31": 18,
            "2025-11-03": 11,
            "2025-11-05": 27,
            "2025-11-06": 13,
            "2025-11-07": 8,
            "2025-11-10": 22,
            "2025-11-11": 14,
            "2025-11-12": 22,
            "2025-11-13": 11,
            "2025-11-14": 22,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-19": 23,
            "2025-11-20": 32,
            "2025-11-21": 36,
            "2025-11-22": 8,
            "2025-11-23": 11,
            "2025-11-24": 22,
            "2025-11-25": 15,
            "2025-11-27": 4,
            "2025-11-28": 1,
            "2025-11-29": 38,
            "2025-11-30": 1,
            "2025-12-02": 31,
            "2025-12-03": 29,
            "2025-12-04": 16,
            "2025-12-05": 10,
            "2025-12-09": 4,
            "2025-12-10": 16,
            "2025-12-11": 7,
            "2025-12-15": 33,
            "2025-12-16": 5,
            "2025-12-18": 2,
            "2025-12-19": 4,
            "2025-12-22": 19,
            "2025-12-23": 2,
            "2025-12-26": 8,
            "2025-12-29": 9,
            "2025-12-30": 4,
            "2026-01-02": 2,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-08": 35,
            "2026-01-09": 18,
            "2026-01-12": 2,
            "2026-01-13": 35,
            "2026-01-14": 5,
            "2026-01-15": 15,
            "2026-01-16": 6,
            "2026-01-17": 7,
            "2026-01-18": 1,
            "2026-01-19": 1,
            "2026-01-21": 18,
            "2026-01-22": 1,
            "2026-01-23": 24,
            "2026-01-24": 31,
            "2026-01-26": 2,
            "2026-01-27": 53,
            "2026-01-30": 10,
            "2026-01-31": 5,
            "2026-02-02": 5,
            "2026-02-03": 13,
            "2026-02-04": 15,
            "2026-02-05": 28,
            "2026-02-06": 88,
            "2026-02-09": 17,
            "2026-02-10": 30,
            "2026-02-11": 19,
            "2026-02-12": 16,
            "2026-02-13": 17,
            "2026-02-14": 8,
            "2026-02-16": 1,
            "2026-02-17": 7,
            "2026-02-18": 21,
            "2026-02-19": 34,
            "2026-02-20": 1,
            "2026-02-21": 35,
            "2026-02-23": 38,
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 101,
            "2026-03-02": 5,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-14": 38,
            "2026-03-17": 102,
            "2026-03-18": 500,
            "2026-03-20": 30,
            "2026-03-24": 51,
            "2026-03-25": 8,
            "2026-03-26": 60,
            "2026-03-30": 26,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-11": 1,
            "2026-04-20": 1,
            "2026-04-22": 54,
            "2026-04-27": 1,
            "2026-05-01": 2,
            "2026-05-04": 2,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-14": 1,
            "2026-05-25": 1,
            "2026-05-29": 2,
            "2026-06-01": 2,
            "2026-06-03": 2,
            "2026-06-06": 8
          },
          "time_per_day": {
            "2025-09-30": 8.730323055555555,
            "2025-10-01": 26.06114138888889,
            "2025-10-03": 77.00389916666666,
            "2025-10-06": 0.2261397222222222,
            "2025-10-07": 1694.5859347222222,
            "2025-10-08": 186.67729694444446,
            "2025-10-09": 1190.6602500000001,
            "2025-10-10": 984.7113552777779,
            "2025-10-13": 2595.0898274999995,
            "2025-10-14": 1047.8387783333333,
            "2025-10-15": 1694.3027027777778,
            "2025-10-16": 212.8725927777778,
            "2025-10-17": 649.2124272222222,
            "2025-10-20": 699.2895166666667,
            "2025-10-21": 1001.6840352777778,
            "2025-10-22": 962.5724286111111,
            "2025-10-23": 1778.4273847222225,
            "2025-10-24": 215.41983194444444,
            "2025-10-25": 1148.9494074999998,
            "2025-10-27": 1727.1680400000002,
            "2025-10-28": 809.6173483333332,
            "2025-10-29": 1292.85105,
            "2025-10-30": 3735.1364383333334,
            "2025-10-31": 1697.5218763888886,
            "2025-11-03": 1577.4845808333334,
            "2025-11-05": 2591.3809583333327,
            "2025-11-06": 2138.752446666667,
            "2025-11-07": 744.6835525,
            "2025-11-10": 2515.480636666666,
            "2025-11-11": 945.1693666666666,
            "2025-11-12": 2077.9513238888885,
            "2025-11-13": 2369.1055277777773,
            "2025-11-14": 2362.5949444444445,
            "2025-11-17": 243.76914722222222,
            "2025-11-18": 331.31258833333334,
            "2025-11-19": 2759.758188888889,
            "2025-11-20": 2384.640363611111,
            "2025-11-21": 2889.949421944445,
            "2025-11-22": 251.67333138888887,
            "2025-11-23": 536.1301658333333,
            "2025-11-24": 3395.1177425,
            "2025-11-25": 1969.7955202777778,
            "2025-11-27": 755.6605394444445,
            "2025-11-28": 11.140624444444445,
            "2025-11-29": 8300.373683333331,
            "2025-11-30": 44.71778611111111,
            "2025-12-02": 3463.191393888889,
            "2025-12-03": 3239.1607808333324,
            "2025-12-04": 2173.517992222222,
            "2025-12-05": 747.3406386111111,
            "2025-12-09": 606.4912130555555,
            "2025-12-10": 748.6635916666668,
            "2025-12-11": 573.9404686111111,
            "2025-12-15": 2363.849196666667,
            "2025-12-16": 54.46674277777778,
            "2025-12-18": 101.54243861111112,
            "2025-12-19": 122.7490525,
            "2025-12-22": 383.99791027777775,
            "2025-12-23": 41.38577444444445,
            "2025-12-26": 995.3571502777778,
            "2025-12-29": 1528.792973611111,
            "2025-12-30": 442.5796055555556,
            "2026-01-02": 83.53357944444444,
            "2026-01-05": 72.12259361111111,
            "2026-01-07": 289.246025,
            "2026-01-08": 3043.5181644444447,
            "2026-01-09": 980.0882650000001,
            "2026-01-12": 587.0131516666667,
            "2026-01-13": 2389.4751683333334,
            "2026-01-14": 43.27879,
            "2026-01-15": 1226.5994075,
            "2026-01-16": 236.43232833333334,
            "2026-01-17": 250.6112383333333,
            "2026-01-18": 49.25654222222222,
            "2026-01-19": 54.43967666666667,
            "2026-01-21": 1152.7598858333333,
            "2026-01-22": 24.323317777777778,
            "2026-01-23": 2809.507503055556,
            "2026-01-24": 4738.290933333334,
            "2026-01-26": 148.49865916666667,
            "2026-01-27": 3934.573707777779,
            "2026-01-30": 4219.438184722222,
            "2026-01-31": 732.5578702777779,
            "2026-02-02": 426.75189027777776,
            "2026-02-03": 2074.8523741666663,
            "2026-02-04": 1983.6464580555555,
            "2026-02-05": 4374.593896111111,
            "2026-02-06": 20341.405730833347,
            "2026-02-09": 1705.9583597222222,
            "2026-02-10": 8840.93611111111,
            "2026-02-11": 3549.9131072222226,
            "2026-02-12": 2135.5949719444443,
            "2026-02-13": 2042.8707430555555,
            "2026-02-14": 753.2859988888889,
            "2026-02-16": 91.5712575,
            "2026-02-17": 1646.6670869444445,
            "2026-02-18": 2056.0249566666666,
            "2026-02-19": 1777.2444761111108,
            "2026-02-20": 2.2928872222222223,
            "2026-02-21": 880.5069977777778,
            "2026-02-23": 1387.3828400000004,
            "2026-02-25": 0.16812472222222222,
            "2026-02-26": 20.466793888888887,
            "2026-02-27": 0.19803777777777778,
            "2026-02-28": 8058.580518055558,
            "2026-03-02": 327.4029586111111,
            "2026-03-06": 1.2834841666666665,
            "2026-03-07": 0.012258888888888889,
            "2026-03-14": 2800.7672597222213,
            "2026-03-17": 3963.3662405555556,
            "2026-03-18": 163629.1897950002,
            "2026-03-20": 3883.564645555556,
            "2026-03-24": 5401.455450277779,
            "2026-03-25": 138.21975305555557,
            "2026-03-26": 30050.62612611111,
            "2026-03-30": 5181.668814722223,
            "2026-04-07": 0.796861111111111,
            "2026-04-08": 145.07749555555554,
            "2026-04-11": 213.39262638888889,
            "2026-04-20": 381.8180936111111,
            "2026-04-22": 7961.982295277776,
            "2026-04-27": 95.15757555555555,
            "2026-05-01": 392.60974166666665,
            "2026-05-04": 1416.9927416666667,
            "2026-05-06": 1847.0052547222224,
            "2026-05-07": 349.61040638888886,
            "2026-05-14": 1413.5362316666667,
            "2026-05-25": 100.02589055555556,
            "2026-05-29": 2447.031906111111,
            "2026-06-01": 1254.5499897222223,
            "2026-06-03": 186.51974194444446,
            "2026-06-06": 1519.3073911111112
          },
          "time_count_per_day": {
            "2025-09-30": 4,
            "2025-10-01": 2,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 31,
            "2025-10-08": 3,
            "2025-10-09": 20,
            "2025-10-10": 12,
            "2025-10-13": 31,
            "2025-10-14": 19,
            "2025-10-15": 27,
            "2025-10-16": 4,
            "2025-10-17": 22,
            "2025-10-20": 9,
            "2025-10-21": 11,
            "2025-10-22": 13,
            "2025-10-23": 32,
            "2025-10-24": 2,
            "2025-10-25": 11,
            "2025-10-27": 25,
            "2025-10-28": 5,
            "2025-10-29": 21,
            "2025-10-30": 26,
            "2025-10-31": 18,
            "2025-11-03": 11,
            "2025-11-05": 27,
            "2025-11-06": 13,
            "2025-11-07": 8,
            "2025-11-10": 22,
            "2025-11-11": 14,
            "2025-11-12": 22,
            "2025-11-13": 11,
            "2025-11-14": 22,
            "2025-11-17": 4,
            "2025-11-18": 1,
            "2025-11-19": 23,
            "2025-11-20": 32,
            "2025-11-21": 36,
            "2025-11-22": 8,
            "2025-11-23": 11,
            "2025-11-24": 22,
            "2025-11-25": 15,
            "2025-11-27": 4,
            "2025-11-28": 1,
            "2025-11-29": 38,
            "2025-11-30": 1,
            "2025-12-02": 31,
            "2025-12-03": 29,
            "2025-12-04": 16,
            "2025-12-05": 10,
            "2025-12-09": 4,
            "2025-12-10": 16,
            "2025-12-11": 7,
            "2025-12-15": 33,
            "2025-12-16": 5,
            "2025-12-18": 2,
            "2025-12-19": 4,
            "2025-12-22": 19,
            "2025-12-23": 2,
            "2025-12-26": 8,
            "2025-12-29": 9,
            "2025-12-30": 4,
            "2026-01-02": 2,
            "2026-01-05": 1,
            "2026-01-07": 1,
            "2026-01-08": 35,
            "2026-01-09": 18,
            "2026-01-12": 2,
            "2026-01-13": 35,
            "2026-01-14": 5,
            "2026-01-15": 15,
            "2026-01-16": 6,
            "2026-01-17": 7,
            "2026-01-18": 1,
            "2026-01-19": 1,
            "2026-01-21": 18,
            "2026-01-22": 1,
            "2026-01-23": 24,
            "2026-01-24": 31,
            "2026-01-26": 2,
            "2026-01-27": 53,
            "2026-01-30": 10,
            "2026-01-31": 5,
            "2026-02-02": 5,
            "2026-02-03": 13,
            "2026-02-04": 15,
            "2026-02-05": 28,
            "2026-02-06": 88,
            "2026-02-09": 17,
            "2026-02-10": 30,
            "2026-02-11": 19,
            "2026-02-12": 16,
            "2026-02-13": 17,
            "2026-02-14": 8,
            "2026-02-16": 1,
            "2026-02-17": 7,
            "2026-02-18": 21,
            "2026-02-19": 34,
            "2026-02-20": 1,
            "2026-02-21": 35,
            "2026-02-23": 38,
            "2026-02-25": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 101,
            "2026-03-02": 5,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-14": 38,
            "2026-03-17": 102,
            "2026-03-18": 500,
            "2026-03-20": 30,
            "2026-03-24": 51,
            "2026-03-25": 8,
            "2026-03-26": 60,
            "2026-03-30": 26,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-04-11": 1,
            "2026-04-20": 1,
            "2026-04-22": 54,
            "2026-04-27": 1,
            "2026-05-01": 2,
            "2026-05-04": 2,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-14": 1,
            "2026-05-25": 1,
            "2026-05-29": 2,
            "2026-06-01": 2,
            "2026-06-03": 2,
            "2026-06-06": 8
          }
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": 535.7,
          "mode_time_hours": 73.0,
          "mode_frequency": 9,
          "time_distribution": {
            "0-2h": 5,
            "2-4h": 3,
            "4-6h": 5,
            "6-8h": 3,
            "8-10h": 3,
            "10-12h": 2,
            "14-16h": 2,
            "18-20h": 1,
            "20-22h": 4,
            "22-24h": 2,
            "24-26h": 1,
            "26-28h": 2,
            "28-30h": 2,
            "30-32h": 1,
            "32-34h": 1,
            "36-38h": 1,
            "40-42h": 1,
            "42-44h": 1,
            "44-46h": 3,
            "46-48h": 3,
            "50-52h": 1,
            "52-54h": 5,
            "56-58h": 2,
            "62-64h": 1,
            "72-74h": 9,
            "74-76h": 1,
            "76-78h": 2,
            "78-80h": 2,
            "82-84h": 1,
            "90-92h": 1,
            "92-94h": 1,
            "94-96h": 1,
            "98-100h": 3,
            "100-102h": 3,
            "102-104h": 1,
            "104-106h": 1,
            "110-112h": 1,
            "114-116h": 2,
            "116-118h": 1,
            "118-120h": 1,
            "120-122h": 1,
            "122-124h": 3,
            "124-126h": 1,
            "126-128h": 2,
            "130-132h": 1,
            "132-134h": 3,
            "134-136h": 2,
            "136-138h": 7,
            "138-140h": 1,
            "142-144h": 3,
            "144-146h": 1,
            "146-148h": 1,
            "158-160h": 2,
            "160-162h": 3,
            "162-164h": 1,
            "164-166h": 1,
            "166-168h": 1,
            "168-170h": 2,
            "170-172h": 1,
            "178-180h": 1,
            "180-182h": 3,
            "182-184h": 2,
            "184-186h": 2,
            "186-188h": 2,
            "190-192h": 1,
            "192-194h": 3,
            "196-198h": 2,
            "198-200h": 1,
            "202-204h": 2,
            "204-206h": 6,
            "206-208h": 2,
            "208-210h": 3,
            "212-214h": 1,
            "216-218h": 8,
            "218-220h": 1,
            "228-230h": 1,
            "230-232h": 3,
            "232-234h": 3,
            "234-236h": 5,
            "236-238h": 2,
            "238-240h": 1,
            "240-242h": 9,
            "250-252h": 1,
            "258-260h": 2,
            "264-266h": 2,
            "266-268h": 1,
            "270-272h": 1,
            "276-278h": 2,
            "284-286h": 1,
            "288-290h": 4,
            "290-292h": 1,
            "294-296h": 1,
            "298-300h": 2,
            "300-302h": 7,
            "302-304h": 7,
            "304-306h": 1,
            "306-308h": 4,
            "310-312h": 1,
            "312-314h": 2,
            "318-320h": 4,
            "322-324h": 4,
            "324-326h": 1,
            "326-328h": 1,
            "328-330h": 3,
            "330-332h": 3,
            "332-334h": 1,
            "334-336h": 4,
            "336-338h": 4,
            "344-346h": 1,
            "350-352h": 2,
            "354-356h": 1,
            "358-360h": 1,
            "360-362h": 1,
            "362-364h": 2,
            "364-366h": 3,
            "366-368h": 1,
            "368-370h": 1,
            "372-374h": 2,
            "374-376h": 3,
            "378-380h": 1,
            "382-384h": 1,
            "384-386h": 5,
            "394-396h": 1,
            "396-398h": 1,
            "400-402h": 1,
            "402-404h": 2,
            "404-406h": 2,
            "406-408h": 1,
            "408-410h": 6,
            "410-412h": 1,
            "428-430h": 1,
            "430-432h": 1,
            "438-440h": 1,
            "442-444h": 2,
            "450-452h": 1,
            "466-468h": 1,
            "468-470h": 1,
            "470-472h": 1,
            "472-474h": 7,
            "474-476h": 2,
            "476-478h": 4,
            "478-480h": 4,
            "480-482h": 2,
            "482-484h": 1,
            "486-488h": 2,
            "492-494h": 1,
            "494-496h": 1,
            "496-498h": 2,
            "498-500h": 1,
            "500-502h": 2,
            "502-504h": 1,
            "504-506h": 4,
            "514-516h": 1,
            "520-522h": 1,
            "522-524h": 1,
            "528-530h": 1,
            "532-534h": 1,
            "540-542h": 1,
            "542-544h": 2,
            "544-546h": 6,
            "546-548h": 1,
            "548-550h": 4,
            "550-552h": 3,
            "552-554h": 6,
            "558-560h": 1,
            "564-566h": 5,
            "566-568h": 2,
            "568-570h": 1,
            "570-572h": 1,
            "574-576h": 2,
            "576-578h": 9,
            "580-582h": 1,
            "616-618h": 4,
            "618-620h": 1,
            "622-624h": 2,
            "624-626h": 2,
            "634-636h": 2,
            "636-638h": 1,
            "638-640h": 4,
            "642-644h": 1,
            "650-652h": 1,
            "652-654h": 1,
            "658-660h": 2,
            "662-664h": 1,
            "664-666h": 3,
            "666-668h": 2,
            "668-670h": 2,
            "670-672h": 2,
            "672-674h": 4,
            "682-684h": 6,
            "684-686h": 1,
            "688-690h": 1,
            "690-692h": 3,
            "692-694h": 5,
            "694-696h": 1,
            "708-710h": 1,
            "710-712h": 3,
            "714-716h": 1,
            "716-718h": 1,
            "718-720h": 1,
            "720-722h": 5,
            "728-730h": 1,
            "732-734h": 1,
            "734-736h": 6,
            "736-738h": 3,
            "738-740h": 3,
            "740-742h": 1,
            "744-746h": 1,
            "762-764h": 1,
            "766-768h": 1,
            "768-770h": 5,
            "784-786h": 1,
            "786-788h": 1,
            "788-790h": 2,
            "790-792h": 3,
            "792-794h": 1,
            "804-806h": 5,
            "808-810h": 2,
            "814-816h": 3,
            "816-818h": 1,
            "826-828h": 2,
            "828-830h": 1,
            "830-832h": 1,
            "840-842h": 1,
            "844-846h": 1,
            "852-854h": 3,
            "854-856h": 1,
            "860-862h": 1,
            "876-878h": 2,
            "878-880h": 1,
            "888-890h": 1,
            "900-902h": 1,
            "902-904h": 2,
            "908-910h": 1,
            "912-914h": 2,
            "960-962h": 1,
            "966-968h": 1,
            "972-974h": 1,
            "976-978h": 1,
            "978-980h": 2,
            "982-984h": 2,
            "994-996h": 1,
            "1002-1004h": 1,
            "1008-1010h": 4,
            "1020-1022h": 3,
            "1026-1028h": 2,
            "1044-1046h": 1,
            "1050-1052h": 1,
            "1056-1058h": 1,
            "1066-1068h": 1,
            "1068-1070h": 1,
            "1072-1074h": 2,
            "1078-1080h": 2,
            "1080-1082h": 2,
            "1100-1102h": 1,
            "1124-1126h": 8,
            "1138-1140h": 2,
            "1142-1144h": 1,
            "1150-1152h": 1,
            "1170-1172h": 1,
            "1198-1200h": 1,
            "1214-1216h": 1,
            "1216-1218h": 1,
            "1230-1232h": 1,
            "1236-1238h": 2,
            "1238-1240h": 1,
            "1240-1242h": 1,
            "1248-1250h": 1,
            "1270-1272h": 3,
            "1344-1346h": 1,
            "1368-1370h": 2,
            "1406-1408h": 1,
            "1408-1410h": 1,
            "1416-1418h": 4,
            "1460-1462h": 1,
            "1462-1464h": 1,
            "1488-1490h": 1,
            "1546-1548h": 1,
            "1698-1700h": 2,
            "1704-1706h": 2,
            "1718-1720h": 1,
            "1796-1798h": 1,
            "1838-1840h": 2,
            "1862-1864h": 1,
            "1916-1918h": 1,
            "1962-1964h": 1,
            "1964-1966h": 2,
            "2036-2038h": 1,
            "2054-2056h": 1,
            "2124-2126h": 1,
            "2132-2134h": 1,
            "2208-2210h": 1,
            "2272-2274h": 1,
            "2390-2392h": 1,
            "3186-3188h": 1
          },
          "tickets_count": 602,
          "tickets_per_day": {
            "2025-12-02": 5,
            "2025-12-03": 14,
            "2025-12-04": 4,
            "2025-12-05": 11,
            "2025-12-06": 1,
            "2025-12-08": 1,
            "2025-12-09": 1,
            "2025-12-10": 7,
            "2025-12-11": 24,
            "2025-12-12": 9,
            "2025-12-15": 13,
            "2025-12-16": 8,
            "2025-12-17": 5,
            "2025-12-18": 2,
            "2025-12-19": 6,
            "2025-12-20": 1,
            "2025-12-22": 4,
            "2025-12-23": 1,
            "2025-12-26": 7,
            "2025-12-29": 5,
            "2025-12-31": 1,
            "2026-01-02": 9,
            "2026-01-05": 4,
            "2026-01-09": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-17": 18,
            "2026-01-23": 2,
            "2026-01-26": 2,
            "2026-01-27": 3,
            "2026-02-03": 7,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-13": 2,
            "2026-02-17": 2,
            "2026-02-18": 11,
            "2026-02-19": 399
          },
          "time_per_day": {
            "2025-12-02": 520.7192847222223,
            "2025-12-03": 2095.764484166666,
            "2025-12-04": 527.8312925,
            "2025-12-05": 2186.297799166667,
            "2025-12-06": 53.61010166666667,
            "2025-12-08": 124.1030525,
            "2025-12-09": 136.94434027777777,
            "2025-12-10": 1589.5578155555552,
            "2025-12-11": 4803.894101111113,
            "2025-12-12": 1692.3091886111113,
            "2025-12-15": 2346.678757777778,
            "2025-12-16": 1939.6666513888886,
            "2025-12-17": 667.4154191666667,
            "2025-12-18": 438.25786472222217,
            "2025-12-19": 2920.0519038888892,
            "2025-12-20": 258.72006055555556,
            "2025-12-22": 1095.9193366666666,
            "2025-12-23": 0.861728888888889,
            "2025-12-26": 3552.17941,
            "2025-12-29": 3130.3626858333328,
            "2025-12-31": 1796.9833452777777,
            "2026-01-02": 3713.269501666666,
            "2026-01-05": 1665.2880847222223,
            "2026-01-09": 1171.9090594444444,
            "2026-01-13": 52.09794,
            "2026-01-14": 9.7618875,
            "2026-01-15": 3221.4734291666664,
            "2026-01-16": 10.021557222222222,
            "2026-01-17": 2629.352108888889,
            "2026-01-23": 352.6785402777778,
            "2026-01-26": 10.50689,
            "2026-01-27": 65.93293416666667,
            "2026-02-03": 4292.073484444444,
            "2026-02-04": 133.08936583333335,
            "2026-02-05": 179.07435750000002,
            "2026-02-10": 267.6131972222222,
            "2026-02-13": 665.9047383333333,
            "2026-02-17": 880.4267780555555,
            "2026-02-18": 20890.08774916666,
            "2026-02-19": 250401.49574666677
          },
          "time_count_per_day": {
            "2025-12-02": 5,
            "2025-12-03": 14,
            "2025-12-04": 4,
            "2025-12-05": 11,
            "2025-12-06": 1,
            "2025-12-08": 1,
            "2025-12-09": 1,
            "2025-12-10": 7,
            "2025-12-11": 24,
            "2025-12-12": 9,
            "2025-12-15": 13,
            "2025-12-16": 8,
            "2025-12-17": 5,
            "2025-12-18": 2,
            "2025-12-19": 6,
            "2025-12-20": 1,
            "2025-12-22": 4,
            "2025-12-23": 1,
            "2025-12-26": 7,
            "2025-12-29": 5,
            "2025-12-31": 1,
            "2026-01-02": 9,
            "2026-01-05": 4,
            "2026-01-09": 1,
            "2026-01-13": 2,
            "2026-01-14": 2,
            "2026-01-15": 4,
            "2026-01-16": 1,
            "2026-01-17": 18,
            "2026-01-23": 2,
            "2026-01-26": 2,
            "2026-01-27": 3,
            "2026-02-03": 7,
            "2026-02-04": 1,
            "2026-02-05": 1,
            "2026-02-10": 1,
            "2026-02-13": 2,
            "2026-02-17": 2,
            "2026-02-18": 11,
            "2026-02-19": 399
          }
        }
      }
    },
    "Pendente Legal": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-10-06": 1,
          "2025-10-07": 2,
          "2025-10-08": 1,
          "2025-10-19": 1,
          "2025-10-20": 1,
          "2025-10-29": 1,
          "2025-11-04": 1,
          "2026-03-03": 1,
          "2026-03-06": 1,
          "2026-03-11": 1,
          "2026-03-13": 1,
          "2026-03-16": 1,
          "2026-06-02": 1,
          "2026-06-05": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2026-03-06": 1,
            "2026-06-02": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-07": 1,
            "2025-10-19": 1,
            "2025-10-20": 1,
            "2026-03-03": 1,
            "2026-03-11": 1,
            "2026-03-13": 1,
            "2026-03-16": 1,
            "2026-06-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-10-07": 1,
            "2025-10-08": 1,
            "2025-11-04": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Pendente Consultor": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 338,
        "tickets_per_day": {
          "2025-10-29": 1,
          "2025-11-14": 1,
          "2025-11-25": 1,
          "2025-12-09": 1,
          "2025-12-26": 1,
          "2025-12-28": 1,
          "2025-12-29": 1,
          "2026-01-02": 1,
          "2026-01-14": 1,
          "2026-02-12": 1,
          "2026-02-16": 6,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-23": 13,
          "2026-03-02": 4,
          "2026-03-03": 1,
          "2026-03-05": 1,
          "2026-03-06": 1,
          "2026-03-07": 1,
          "2026-03-10": 1,
          "2026-03-11": 1,
          "2026-03-16": 1,
          "2026-03-17": 2,
          "2026-03-18": 1,
          "2026-03-20": 1,
          "2026-03-23": 4,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 2,
          "2026-03-28": 1,
          "2026-03-30": 1,
          "2026-03-31": 2,
          "2026-04-01": 1,
          "2026-04-06": 1,
          "2026-04-07": 1,
          "2026-04-08": 3,
          "2026-04-10": 2,
          "2026-04-13": 1,
          "2026-04-14": 3,
          "2026-04-15": 1,
          "2026-04-16": 2,
          "2026-04-17": 3,
          "2026-04-20": 9,
          "2026-04-21": 3,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-24": 2,
          "2026-04-27": 2,
          "2026-04-28": 4,
          "2026-04-29": 8,
          "2026-04-30": 5,
          "2026-05-04": 9,
          "2026-05-05": 4,
          "2026-05-06": 12,
          "2026-05-07": 10,
          "2026-05-08": 5,
          "2026-05-09": 5,
          "2026-05-11": 4,
          "2026-05-12": 38,
          "2026-05-13": 10,
          "2026-05-14": 9,
          "2026-05-15": 6,
          "2026-05-16": 2,
          "2026-05-18": 10,
          "2026-05-19": 5,
          "2026-05-20": 12,
          "2026-05-21": 7,
          "2026-05-22": 3,
          "2026-05-23": 1,
          "2026-05-25": 6,
          "2026-05-26": 7,
          "2026-05-27": 4,
          "2026-05-28": 6,
          "2026-05-29": 9,
          "2026-05-30": 1,
          "2026-06-01": 7,
          "2026-06-02": 5,
          "2026-06-03": 10,
          "2026-06-05": 10,
          "2026-06-06": 5,
          "2026-06-08": 3
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 27,
          "tickets_per_day": {
            "2026-03-02": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-16": 1,
            "2026-04-20": 2,
            "2026-05-04": 1,
            "2026-05-05": 1,
            "2026-05-09": 1,
            "2026-05-11": 1,
            "2026-05-15": 1,
            "2026-05-25": 1,
            "2026-05-26": 2,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-06-03": 7,
            "2026-06-05": 2,
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 288,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2025-12-26": 1,
            "2025-12-28": 1,
            "2026-01-02": 1,
            "2026-02-12": 1,
            "2026-02-16": 6,
            "2026-02-17": 1,
            "2026-03-02": 3,
            "2026-03-03": 1,
            "2026-03-05": 1,
            "2026-03-06": 1,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-11": 1,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 1,
            "2026-03-20": 1,
            "2026-03-23": 4,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 2,
            "2026-03-28": 1,
            "2026-03-30": 1,
            "2026-03-31": 2,
            "2026-04-01": 1,
            "2026-04-08": 1,
            "2026-04-10": 2,
            "2026-04-13": 1,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-16": 1,
            "2026-04-17": 3,
            "2026-04-20": 7,
            "2026-04-21": 3,
            "2026-04-22": 1,
            "2026-04-23": 3,
            "2026-04-24": 2,
            "2026-04-27": 2,
            "2026-04-28": 4,
            "2026-04-29": 8,
            "2026-04-30": 5,
            "2026-05-04": 8,
            "2026-05-05": 3,
            "2026-05-06": 12,
            "2026-05-07": 10,
            "2026-05-08": 5,
            "2026-05-09": 4,
            "2026-05-11": 3,
            "2026-05-12": 38,
            "2026-05-13": 10,
            "2026-05-14": 9,
            "2026-05-15": 5,
            "2026-05-16": 2,
            "2026-05-18": 10,
            "2026-05-19": 5,
            "2026-05-20": 12,
            "2026-05-21": 7,
            "2026-05-22": 3,
            "2026-05-23": 1,
            "2026-05-25": 5,
            "2026-05-26": 5,
            "2026-05-27": 4,
            "2026-05-28": 5,
            "2026-05-29": 7,
            "2026-05-30": 1,
            "2026-06-01": 6,
            "2026-06-02": 5,
            "2026-06-03": 3,
            "2026-06-05": 8,
            "2026-06-06": 5,
            "2026-06-08": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-10-29": 1,
            "2025-11-14": 1,
            "2025-12-29": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-08": 1,
            "2026-06-01": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-11-25": 1,
            "2026-01-14": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 14,
          "tickets_per_day": {
            "2026-02-18": 1,
            "2026-02-23": 13
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Open": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 154,
        "tickets_per_day": {
          "2025-11-14": 1,
          "2025-11-24": 1,
          "2025-11-28": 1,
          "2026-01-03": 1,
          "2026-01-16": 3,
          "2026-01-21": 2,
          "2026-02-02": 1,
          "2026-02-04": 1,
          "2026-02-11": 1,
          "2026-02-14": 1,
          "2026-02-17": 1,
          "2026-02-18": 1,
          "2026-02-20": 2,
          "2026-02-25": 1,
          "2026-03-03": 1,
          "2026-03-06": 1,
          "2026-03-10": 1,
          "2026-03-24": 1,
          "2026-03-25": 1,
          "2026-03-26": 1,
          "2026-04-04": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-08": 1,
          "2026-04-09": 1,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-21": 1,
          "2026-04-22": 1,
          "2026-04-23": 3,
          "2026-04-24": 1,
          "2026-04-27": 3,
          "2026-04-28": 3,
          "2026-04-30": 2,
          "2026-05-02": 1,
          "2026-05-03": 1,
          "2026-05-04": 5,
          "2026-05-06": 4,
          "2026-05-07": 2,
          "2026-05-09": 1,
          "2026-05-11": 9,
          "2026-05-13": 2,
          "2026-05-14": 2,
          "2026-05-15": 1,
          "2026-05-18": 2,
          "2026-05-19": 2,
          "2026-05-20": 1,
          "2026-05-21": 2,
          "2026-05-22": 3,
          "2026-05-23": 1,
          "2026-05-25": 2,
          "2026-05-26": 7,
          "2026-05-27": 3,
          "2026-05-28": 6,
          "2026-05-29": 3,
          "2026-05-30": 1,
          "2026-05-31": 1,
          "2026-06-01": 5,
          "2026-06-02": 2,
          "2026-06-03": 4,
          "2026-06-04": 1,
          "2026-06-05": 11,
          "2026-06-06": 9,
          "2026-06-07": 1,
          "2026-06-08": 13
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 19,
          "tickets_per_day": {
            "2025-11-28": 1,
            "2026-03-03": 1,
            "2026-04-09": 1,
            "2026-04-23": 1,
            "2026-04-28": 1,
            "2026-04-30": 1,
            "2026-05-06": 1,
            "2026-05-07": 1,
            "2026-05-11": 1,
            "2026-05-18": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-31": 1,
            "2026-06-03": 1,
            "2026-06-04": 1,
            "2026-06-06": 2,
            "2026-06-08": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 104,
          "tickets_per_day": {
            "2026-01-16": 2,
            "2026-03-06": 1,
            "2026-03-10": 1,
            "2026-03-24": 1,
            "2026-03-25": 1,
            "2026-03-26": 1,
            "2026-04-04": 1,
            "2026-04-06": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-22": 1,
            "2026-04-23": 2,
            "2026-04-27": 3,
            "2026-05-02": 1,
            "2026-05-03": 1,
            "2026-05-04": 5,
            "2026-05-06": 3,
            "2026-05-07": 1,
            "2026-05-09": 1,
            "2026-05-11": 6,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-18": 1,
            "2026-05-19": 1,
            "2026-05-20": 1,
            "2026-05-21": 2,
            "2026-05-22": 3,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-26": 7,
            "2026-05-27": 2,
            "2026-05-28": 4,
            "2026-05-29": 3,
            "2026-05-30": 1,
            "2026-06-01": 4,
            "2026-06-02": 2,
            "2026-06-03": 3,
            "2026-06-05": 11,
            "2026-06-06": 7,
            "2026-06-07": 1,
            "2026-06-08": 11
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-11-14": 1,
            "2025-11-24": 1,
            "2026-01-16": 1,
            "2026-01-21": 1,
            "2026-02-02": 1,
            "2026-02-20": 2,
            "2026-04-13": 1,
            "2026-04-28": 1,
            "2026-05-11": 1,
            "2026-06-01": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 16,
          "tickets_per_day": {
            "2026-01-03": 1,
            "2026-02-04": 1,
            "2026-02-18": 1,
            "2026-02-25": 1,
            "2026-04-06": 1,
            "2026-04-07": 1,
            "2026-04-21": 1,
            "2026-04-24": 1,
            "2026-04-28": 1,
            "2026-04-30": 1,
            "2026-05-11": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-19": 1,
            "2026-05-25": 1,
            "2026-05-28": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 4,
          "tickets_per_day": {
            "2026-01-21": 1,
            "2026-02-11": 1,
            "2026-02-14": 1,
            "2026-02-17": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Pending Close": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 8,
        "tickets_per_day": {
          "2025-11-17": 1,
          "2025-11-21": 1,
          "2025-11-26": 1,
          "2026-03-10": 1,
          "2026-03-12": 1,
          "2026-04-17": 1,
          "2026-05-07": 1,
          "2026-05-20": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 7,
          "tickets_per_day": {
            "2025-11-17": 1,
            "2025-11-26": 1,
            "2026-03-10": 1,
            "2026-03-12": 1,
            "2026-04-17": 1,
            "2026-05-07": 1,
            "2026-05-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-21": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Pendente Operador": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 259,
        "tickets_per_day": {
          "2025-11-19": 1,
          "2025-12-09": 1,
          "2025-12-10": 1,
          "2025-12-12": 1,
          "2025-12-29": 1,
          "2026-01-02": 1,
          "2026-01-05": 1,
          "2026-01-16": 1,
          "2026-01-20": 1,
          "2026-01-29": 1,
          "2026-02-03": 1,
          "2026-02-11": 1,
          "2026-02-16": 16,
          "2026-02-17": 6,
          "2026-02-24": 2,
          "2026-02-25": 2,
          "2026-02-27": 1,
          "2026-03-03": 2,
          "2026-03-04": 2,
          "2026-03-07": 1,
          "2026-03-12": 1,
          "2026-03-13": 2,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-19": 4,
          "2026-03-20": 1,
          "2026-03-25": 3,
          "2026-03-26": 1,
          "2026-03-27": 1,
          "2026-03-30": 3,
          "2026-04-01": 1,
          "2026-04-02": 2,
          "2026-04-04": 1,
          "2026-04-06": 2,
          "2026-04-07": 1,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-11": 1,
          "2026-04-14": 1,
          "2026-04-15": 2,
          "2026-04-17": 4,
          "2026-04-18": 1,
          "2026-04-20": 5,
          "2026-04-21": 3,
          "2026-04-22": 1,
          "2026-04-24": 6,
          "2026-04-27": 2,
          "2026-04-28": 1,
          "2026-04-29": 5,
          "2026-04-30": 3,
          "2026-05-02": 2,
          "2026-05-04": 3,
          "2026-05-05": 4,
          "2026-05-06": 6,
          "2026-05-07": 9,
          "2026-05-08": 1,
          "2026-05-09": 1,
          "2026-05-11": 5,
          "2026-05-12": 5,
          "2026-05-13": 6,
          "2026-05-14": 2,
          "2026-05-15": 3,
          "2026-05-18": 4,
          "2026-05-19": 2,
          "2026-05-20": 3,
          "2026-05-21": 6,
          "2026-05-22": 3,
          "2026-05-23": 3,
          "2026-05-25": 5,
          "2026-05-26": 5,
          "2026-05-27": 5,
          "2026-05-28": 7,
          "2026-05-29": 12,
          "2026-05-30": 3,
          "2026-06-01": 11,
          "2026-06-02": 8,
          "2026-06-03": 8,
          "2026-06-05": 16,
          "2026-06-06": 3,
          "2026-06-08": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 32,
          "tickets_per_day": {
            "2026-01-05": 1,
            "2026-03-19": 1,
            "2026-04-20": 2,
            "2026-04-29": 3,
            "2026-04-30": 1,
            "2026-05-07": 1,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-14": 1,
            "2026-05-15": 1,
            "2026-05-23": 1,
            "2026-05-25": 3,
            "2026-05-26": 1,
            "2026-05-27": 1,
            "2026-05-28": 1,
            "2026-05-29": 2,
            "2026-05-30": 1,
            "2026-06-03": 1,
            "2026-06-05": 5,
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 221,
          "tickets_per_day": {
            "2025-12-09": 1,
            "2025-12-12": 1,
            "2026-01-02": 1,
            "2026-01-16": 1,
            "2026-01-20": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-11": 1,
            "2026-02-16": 16,
            "2026-02-17": 6,
            "2026-02-24": 2,
            "2026-02-25": 2,
            "2026-02-27": 1,
            "2026-03-03": 2,
            "2026-03-04": 2,
            "2026-03-07": 1,
            "2026-03-12": 1,
            "2026-03-13": 2,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-19": 3,
            "2026-03-20": 1,
            "2026-03-25": 3,
            "2026-03-26": 1,
            "2026-03-27": 1,
            "2026-03-30": 3,
            "2026-04-01": 1,
            "2026-04-02": 2,
            "2026-04-04": 1,
            "2026-04-06": 2,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-14": 1,
            "2026-04-15": 2,
            "2026-04-17": 4,
            "2026-04-18": 1,
            "2026-04-20": 3,
            "2026-04-21": 3,
            "2026-04-22": 1,
            "2026-04-24": 6,
            "2026-04-27": 2,
            "2026-04-28": 1,
            "2026-04-29": 2,
            "2026-04-30": 2,
            "2026-05-02": 2,
            "2026-05-04": 3,
            "2026-05-05": 3,
            "2026-05-06": 6,
            "2026-05-07": 8,
            "2026-05-08": 1,
            "2026-05-09": 1,
            "2026-05-11": 3,
            "2026-05-12": 4,
            "2026-05-13": 5,
            "2026-05-14": 1,
            "2026-05-15": 2,
            "2026-05-18": 4,
            "2026-05-19": 2,
            "2026-05-20": 3,
            "2026-05-21": 6,
            "2026-05-22": 3,
            "2026-05-23": 2,
            "2026-05-25": 2,
            "2026-05-26": 4,
            "2026-05-27": 4,
            "2026-05-28": 6,
            "2026-05-29": 10,
            "2026-05-30": 2,
            "2026-06-01": 11,
            "2026-06-02": 8,
            "2026-06-03": 7,
            "2026-06-05": 11,
            "2026-06-06": 3,
            "2026-06-08": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 6,
          "tickets_per_day": {
            "2025-11-19": 1,
            "2025-12-10": 1,
            "2025-12-29": 1,
            "2026-04-07": 1,
            "2026-04-11": 1,
            "2026-05-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Pendente Gestão": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 15,
        "tickets_per_day": {
          "2025-11-27": 1,
          "2025-12-01": 1,
          "2025-12-22": 1,
          "2026-01-08": 1,
          "2026-01-19": 1,
          "2026-03-16": 1,
          "2026-03-18": 1,
          "2026-03-30": 1,
          "2026-04-08": 1,
          "2026-04-14": 1,
          "2026-04-17": 1,
          "2026-05-13": 1,
          "2026-05-21": 1,
          "2026-05-27": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 14,
          "tickets_per_day": {
            "2025-12-01": 1,
            "2025-12-22": 1,
            "2026-01-08": 1,
            "2026-01-19": 1,
            "2026-03-16": 1,
            "2026-03-18": 1,
            "2026-03-30": 1,
            "2026-04-08": 1,
            "2026-04-14": 1,
            "2026-04-17": 1,
            "2026-05-13": 1,
            "2026-05-21": 1,
            "2026-05-27": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-11-27": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Aguarda Assinatura (rgpd Cvo)": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-01-10": 1,
          "2026-01-18": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2026-01-10": 1,
            "2026-01-18": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Pending Reminder": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1,
        "tickets_per_day": {
          "2026-01-30": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-30": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "New": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 550,
        "tickets_per_day": {
          "2026-02-11": 1,
          "2026-02-12": 1,
          "2026-02-14": 1,
          "2026-02-16": 5,
          "2026-02-17": 5,
          "2026-02-18": 4,
          "2026-02-19": 10,
          "2026-02-20": 9,
          "2026-02-21": 2,
          "2026-02-23": 4,
          "2026-02-24": 3,
          "2026-02-25": 3,
          "2026-02-26": 1,
          "2026-02-28": 4,
          "2026-03-01": 1,
          "2026-03-02": 7,
          "2026-03-03": 7,
          "2026-03-04": 8,
          "2026-03-05": 4,
          "2026-03-06": 6,
          "2026-03-07": 1,
          "2026-03-09": 9,
          "2026-03-10": 8,
          "2026-03-11": 11,
          "2026-03-14": 1,
          "2026-03-16": 2,
          "2026-03-18": 4,
          "2026-03-19": 1,
          "2026-03-20": 2,
          "2026-03-21": 2,
          "2026-03-23": 2,
          "2026-03-24": 1,
          "2026-03-25": 2,
          "2026-03-26": 1,
          "2026-03-27": 6,
          "2026-03-28": 3,
          "2026-03-30": 11,
          "2026-03-31": 9,
          "2026-04-01": 6,
          "2026-04-02": 6,
          "2026-04-04": 4,
          "2026-04-06": 5,
          "2026-04-07": 5,
          "2026-04-08": 5,
          "2026-04-09": 9,
          "2026-04-10": 4,
          "2026-04-13": 1,
          "2026-04-14": 3,
          "2026-04-15": 7,
          "2026-04-16": 2,
          "2026-04-17": 1,
          "2026-04-18": 2,
          "2026-04-20": 3,
          "2026-04-21": 1,
          "2026-04-22": 9,
          "2026-04-23": 5,
          "2026-04-24": 13,
          "2026-04-27": 21,
          "2026-04-28": 7,
          "2026-04-29": 12,
          "2026-04-30": 9,
          "2026-05-02": 14,
          "2026-05-04": 14,
          "2026-05-05": 9,
          "2026-05-06": 15,
          "2026-05-07": 7,
          "2026-05-08": 14,
          "2026-05-09": 10,
          "2026-05-11": 7,
          "2026-05-12": 9,
          "2026-05-13": 5,
          "2026-05-14": 4,
          "2026-05-15": 6,
          "2026-05-18": 12,
          "2026-05-19": 7,
          "2026-05-20": 15,
          "2026-05-21": 11,
          "2026-05-22": 6,
          "2026-05-23": 1,
          "2026-05-25": 10,
          "2026-05-26": 4,
          "2026-05-27": 9,
          "2026-05-28": 6,
          "2026-05-29": 8,
          "2026-05-30": 4,
          "2026-06-01": 2,
          "2026-06-02": 5,
          "2026-06-03": 5,
          "2026-06-05": 5,
          "2026-06-06": 5,
          "2026-06-07": 1,
          "2026-06-08": 18
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-06-07": 1,
            "2026-06-08": 6
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 482,
          "tickets_per_day": {
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-14": 1,
            "2026-02-18": 1,
            "2026-02-19": 1,
            "2026-02-20": 1,
            "2026-02-24": 2,
            "2026-02-25": 2,
            "2026-02-26": 1,
            "2026-02-28": 4,
            "2026-03-01": 1,
            "2026-03-02": 3,
            "2026-03-03": 5,
            "2026-03-04": 7,
            "2026-03-05": 3,
            "2026-03-06": 2,
            "2026-03-07": 1,
            "2026-03-09": 5,
            "2026-03-10": 8,
            "2026-03-11": 6,
            "2026-03-14": 1,
            "2026-03-16": 2,
            "2026-03-18": 4,
            "2026-03-19": 1,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 1,
            "2026-03-25": 2,
            "2026-03-26": 1,
            "2026-03-27": 6,
            "2026-03-28": 3,
            "2026-03-30": 11,
            "2026-03-31": 9,
            "2026-04-01": 6,
            "2026-04-02": 6,
            "2026-04-04": 4,
            "2026-04-06": 5,
            "2026-04-07": 5,
            "2026-04-08": 5,
            "2026-04-09": 9,
            "2026-04-10": 4,
            "2026-04-13": 1,
            "2026-04-14": 3,
            "2026-04-15": 7,
            "2026-04-16": 2,
            "2026-04-17": 1,
            "2026-04-18": 2,
            "2026-04-20": 3,
            "2026-04-21": 1,
            "2026-04-22": 9,
            "2026-04-23": 5,
            "2026-04-24": 13,
            "2026-04-27": 21,
            "2026-04-28": 7,
            "2026-04-29": 12,
            "2026-04-30": 9,
            "2026-05-02": 14,
            "2026-05-04": 14,
            "2026-05-05": 9,
            "2026-05-06": 15,
            "2026-05-07": 7,
            "2026-05-08": 14,
            "2026-05-09": 10,
            "2026-05-11": 7,
            "2026-05-12": 9,
            "2026-05-13": 5,
            "2026-05-14": 4,
            "2026-05-15": 6,
            "2026-05-18": 12,
            "2026-05-19": 7,
            "2026-05-20": 15,
            "2026-05-21": 11,
            "2026-05-22": 6,
            "2026-05-23": 1,
            "2026-05-25": 10,
            "2026-05-26": 4,
            "2026-05-27": 9,
            "2026-05-28": 6,
            "2026-05-29": 8,
            "2026-05-30": 4,
            "2026-06-01": 2,
            "2026-06-02": 5,
            "2026-06-03": 5,
            "2026-06-05": 5,
            "2026-06-06": 5,
            "2026-06-08": 12
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 61,
          "tickets_per_day": {
            "2026-02-16": 5,
            "2026-02-17": 5,
            "2026-02-18": 3,
            "2026-02-19": 9,
            "2026-02-20": 8,
            "2026-02-21": 2,
            "2026-02-23": 4,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-03-02": 4,
            "2026-03-03": 2,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-06": 4,
            "2026-03-09": 4,
            "2026-03-11": 5,
            "2026-03-21": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Cuba Cancelado": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 15,
        "tickets_per_day": {
          "2026-02-12": 1,
          "2026-02-16": 1,
          "2026-03-03": 13
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 15,
          "tickets_per_day": {
            "2026-02-12": 1,
            "2026-02-16": 1,
            "2026-03-03": 13
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Cuba Remarcado": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 3,
        "tickets_per_day": {
          "2026-02-16": 1,
          "2026-03-31": 1,
          "2026-04-22": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-16": 1,
            "2026-03-31": 1,
            "2026-04-22": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    }
  },
  "workload_analysis": {
    "created": {
      "by_weekday": {
        "Segunda": 4350,
        "Terça": 3344,
        "Quarta": 3303,
        "Quinta": 2764,
        "Sexta": 3018,
        "Sábado": 1192,
        "Domingo": 403
      },
      "by_hour": {
        "00h": 155,
        "01h": 20,
        "02h": 1,
        "03h": 1,
        "04h": 0,
        "05h": 0,
        "06h": 1,
        "07h": 3,
        "08h": 32,
        "09h": 1633,
        "10h": 3269,
        "11h": 1248,
        "12h": 1205,
        "13h": 1176,
        "14h": 893,
        "15h": 1200,
        "16h": 1403,
        "17h": 1203,
        "18h": 1131,
        "19h": 986,
        "20h": 597,
        "21h": 766,
        "22h": 792,
        "23h": 659
      },
      "heatmap": [
        {
          "weekday": "Segunda",
          "hour": "00h",
          "tickets": 4
        },
        {
          "weekday": "Segunda",
          "hour": "01h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "07h",
          "tickets": 1
        },
        {
          "weekday": "Segunda",
          "hour": "08h",
          "tickets": 3
        },
        {
          "weekday": "Segunda",
          "hour": "09h",
          "tickets": 741
        },
        {
          "weekday": "Segunda",
          "hour": "10h",
          "tickets": 1045
        },
        {
          "weekday": "Segunda",
          "hour": "11h",
          "tickets": 279
        },
        {
          "weekday": "Segunda",
          "hour": "12h",
          "tickets": 208
        },
        {
          "weekday": "Segunda",
          "hour": "13h",
          "tickets": 241
        },
        {
          "weekday": "Segunda",
          "hour": "14h",
          "tickets": 147
        },
        {
          "weekday": "Segunda",
          "hour": "15h",
          "tickets": 266
        },
        {
          "weekday": "Segunda",
          "hour": "16h",
          "tickets": 235
        },
        {
          "weekday": "Segunda",
          "hour": "17h",
          "tickets": 209
        },
        {
          "weekday": "Segunda",
          "hour": "18h",
          "tickets": 209
        },
        {
          "weekday": "Segunda",
          "hour": "19h",
          "tickets": 179
        },
        {
          "weekday": "Segunda",
          "hour": "20h",
          "tickets": 127
        },
        {
          "weekday": "Segunda",
          "hour": "21h",
          "tickets": 168
        },
        {
          "weekday": "Segunda",
          "hour": "22h",
          "tickets": 167
        },
        {
          "weekday": "Segunda",
          "hour": "23h",
          "tickets": 121
        },
        {
          "weekday": "Terça",
          "hour": "00h",
          "tickets": 32
        },
        {
          "weekday": "Terça",
          "hour": "01h",
          "tickets": 3
        },
        {
          "weekday": "Terça",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "06h",
          "tickets": 1
        },
        {
          "weekday": "Terça",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "08h",
          "tickets": 8
        },
        {
          "weekday": "Terça",
          "hour": "09h",
          "tickets": 216
        },
        {
          "weekday": "Terça",
          "hour": "10h",
          "tickets": 510
        },
        {
          "weekday": "Terça",
          "hour": "11h",
          "tickets": 228
        },
        {
          "weekday": "Terça",
          "hour": "12h",
          "tickets": 250
        },
        {
          "weekday": "Terça",
          "hour": "13h",
          "tickets": 175
        },
        {
          "weekday": "Terça",
          "hour": "14h",
          "tickets": 200
        },
        {
          "weekday": "Terça",
          "hour": "15h",
          "tickets": 226
        },
        {
          "weekday": "Terça",
          "hour": "16h",
          "tickets": 247
        },
        {
          "weekday": "Terça",
          "hour": "17h",
          "tickets": 259
        },
        {
          "weekday": "Terça",
          "hour": "18h",
          "tickets": 237
        },
        {
          "weekday": "Terça",
          "hour": "19h",
          "tickets": 147
        },
        {
          "weekday": "Terça",
          "hour": "20h",
          "tickets": 125
        },
        {
          "weekday": "Terça",
          "hour": "21h",
          "tickets": 150
        },
        {
          "weekday": "Terça",
          "hour": "22h",
          "tickets": 211
        },
        {
          "weekday": "Terça",
          "hour": "23h",
          "tickets": 119
        },
        {
          "weekday": "Quarta",
          "hour": "00h",
          "tickets": 32
        },
        {
          "weekday": "Quarta",
          "hour": "01h",
          "tickets": 2
        },
        {
          "weekday": "Quarta",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "08h",
          "tickets": 1
        },
        {
          "weekday": "Quarta",
          "hour": "09h",
          "tickets": 209
        },
        {
          "weekday": "Quarta",
          "hour": "10h",
          "tickets": 488
        },
        {
          "weekday": "Quarta",
          "hour": "11h",
          "tickets": 197
        },
        {
          "weekday": "Quarta",
          "hour": "12h",
          "tickets": 228
        },
        {
          "weekday": "Quarta",
          "hour": "13h",
          "tickets": 263
        },
        {
          "weekday": "Quarta",
          "hour": "14h",
          "tickets": 166
        },
        {
          "weekday": "Quarta",
          "hour": "15h",
          "tickets": 221
        },
        {
          "weekday": "Quarta",
          "hour": "16h",
          "tickets": 260
        },
        {
          "weekday": "Quarta",
          "hour": "17h",
          "tickets": 253
        },
        {
          "weekday": "Quarta",
          "hour": "18h",
          "tickets": 204
        },
        {
          "weekday": "Quarta",
          "hour": "19h",
          "tickets": 190
        },
        {
          "weekday": "Quarta",
          "hour": "20h",
          "tickets": 92
        },
        {
          "weekday": "Quarta",
          "hour": "21h",
          "tickets": 155
        },
        {
          "weekday": "Quarta",
          "hour": "22h",
          "tickets": 177
        },
        {
          "weekday": "Quarta",
          "hour": "23h",
          "tickets": 165
        },
        {
          "weekday": "Quinta",
          "hour": "00h",
          "tickets": 13
        },
        {
          "weekday": "Quinta",
          "hour": "01h",
          "tickets": 6
        },
        {
          "weekday": "Quinta",
          "hour": "02h",
          "tickets": 1
        },
        {
          "weekday": "Quinta",
          "hour": "03h",
          "tickets": 1
        },
        {
          "weekday": "Quinta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "07h",
          "tickets": 1
        },
        {
          "weekday": "Quinta",
          "hour": "08h",
          "tickets": 1
        },
        {
          "weekday": "Quinta",
          "hour": "09h",
          "tickets": 137
        },
        {
          "weekday": "Quinta",
          "hour": "10h",
          "tickets": 487
        },
        {
          "weekday": "Quinta",
          "hour": "11h",
          "tickets": 223
        },
        {
          "weekday": "Quinta",
          "hour": "12h",
          "tickets": 211
        },
        {
          "weekday": "Quinta",
          "hour": "13h",
          "tickets": 160
        },
        {
          "weekday": "Quinta",
          "hour": "14h",
          "tickets": 127
        },
        {
          "weekday": "Quinta",
          "hour": "15h",
          "tickets": 159
        },
        {
          "weekday": "Quinta",
          "hour": "16h",
          "tickets": 247
        },
        {
          "weekday": "Quinta",
          "hour": "17h",
          "tickets": 170
        },
        {
          "weekday": "Quinta",
          "hour": "18h",
          "tickets": 220
        },
        {
          "weekday": "Quinta",
          "hour": "19h",
          "tickets": 185
        },
        {
          "weekday": "Quinta",
          "hour": "20h",
          "tickets": 78
        },
        {
          "weekday": "Quinta",
          "hour": "21h",
          "tickets": 138
        },
        {
          "weekday": "Quinta",
          "hour": "22h",
          "tickets": 90
        },
        {
          "weekday": "Quinta",
          "hour": "23h",
          "tickets": 109
        },
        {
          "weekday": "Sexta",
          "hour": "00h",
          "tickets": 27
        },
        {
          "weekday": "Sexta",
          "hour": "01h",
          "tickets": 7
        },
        {
          "weekday": "Sexta",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "07h",
          "tickets": 1
        },
        {
          "weekday": "Sexta",
          "hour": "08h",
          "tickets": 4
        },
        {
          "weekday": "Sexta",
          "hour": "09h",
          "tickets": 172
        },
        {
          "weekday": "Sexta",
          "hour": "10h",
          "tickets": 490
        },
        {
          "weekday": "Sexta",
          "hour": "11h",
          "tickets": 204
        },
        {
          "weekday": "Sexta",
          "hour": "12h",
          "tickets": 178
        },
        {
          "weekday": "Sexta",
          "hour": "13h",
          "tickets": 199
        },
        {
          "weekday": "Sexta",
          "hour": "14h",
          "tickets": 163
        },
        {
          "weekday": "Sexta",
          "hour": "15h",
          "tickets": 205
        },
        {
          "weekday": "Sexta",
          "hour": "16h",
          "tickets": 280
        },
        {
          "weekday": "Sexta",
          "hour": "17h",
          "tickets": 182
        },
        {
          "weekday": "Sexta",
          "hour": "18h",
          "tickets": 154
        },
        {
          "weekday": "Sexta",
          "hour": "19h",
          "tickets": 237
        },
        {
          "weekday": "Sexta",
          "hour": "20h",
          "tickets": 134
        },
        {
          "weekday": "Sexta",
          "hour": "21h",
          "tickets": 132
        },
        {
          "weekday": "Sexta",
          "hour": "22h",
          "tickets": 116
        },
        {
          "weekday": "Sexta",
          "hour": "23h",
          "tickets": 133
        },
        {
          "weekday": "Sábado",
          "hour": "00h",
          "tickets": 39
        },
        {
          "weekday": "Sábado",
          "hour": "01h",
          "tickets": 1
        },
        {
          "weekday": "Sábado",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "08h",
          "tickets": 15
        },
        {
          "weekday": "Sábado",
          "hour": "09h",
          "tickets": 120
        },
        {
          "weekday": "Sábado",
          "hour": "10h",
          "tickets": 188
        },
        {
          "weekday": "Sábado",
          "hour": "11h",
          "tickets": 81
        },
        {
          "weekday": "Sábado",
          "hour": "12h",
          "tickets": 95
        },
        {
          "weekday": "Sábado",
          "hour": "13h",
          "tickets": 123
        },
        {
          "weekday": "Sábado",
          "hour": "14h",
          "tickets": 65
        },
        {
          "weekday": "Sábado",
          "hour": "15h",
          "tickets": 110
        },
        {
          "weekday": "Sábado",
          "hour": "16h",
          "tickets": 107
        },
        {
          "weekday": "Sábado",
          "hour": "17h",
          "tickets": 86
        },
        {
          "weekday": "Sábado",
          "hour": "18h",
          "tickets": 79
        },
        {
          "weekday": "Sábado",
          "hour": "19h",
          "tickets": 23
        },
        {
          "weekday": "Sábado",
          "hour": "20h",
          "tickets": 16
        },
        {
          "weekday": "Sábado",
          "hour": "21h",
          "tickets": 13
        },
        {
          "weekday": "Sábado",
          "hour": "22h",
          "tickets": 26
        },
        {
          "weekday": "Sábado",
          "hour": "23h",
          "tickets": 5
        },
        {
          "weekday": "Domingo",
          "hour": "00h",
          "tickets": 8
        },
        {
          "weekday": "Domingo",
          "hour": "01h",
          "tickets": 1
        },
        {
          "weekday": "Domingo",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "08h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "09h",
          "tickets": 38
        },
        {
          "weekday": "Domingo",
          "hour": "10h",
          "tickets": 61
        },
        {
          "weekday": "Domingo",
          "hour": "11h",
          "tickets": 36
        },
        {
          "weekday": "Domingo",
          "hour": "12h",
          "tickets": 35
        },
        {
          "weekday": "Domingo",
          "hour": "13h",
          "tickets": 15
        },
        {
          "weekday": "Domingo",
          "hour": "14h",
          "tickets": 25
        },
        {
          "weekday": "Domingo",
          "hour": "15h",
          "tickets": 13
        },
        {
          "weekday": "Domingo",
          "hour": "16h",
          "tickets": 27
        },
        {
          "weekday": "Domingo",
          "hour": "17h",
          "tickets": 44
        },
        {
          "weekday": "Domingo",
          "hour": "18h",
          "tickets": 28
        },
        {
          "weekday": "Domingo",
          "hour": "19h",
          "tickets": 25
        },
        {
          "weekday": "Domingo",
          "hour": "20h",
          "tickets": 25
        },
        {
          "weekday": "Domingo",
          "hour": "21h",
          "tickets": 10
        },
        {
          "weekday": "Domingo",
          "hour": "22h",
          "tickets": 5
        },
        {
          "weekday": "Domingo",
          "hour": "23h",
          "tickets": 7
        }
      ],
      "total_tickets": 18374,
      "period_info": {
        "from_date": "2025-09-30",
        "days_in_period": 237
      }
    },
    "closed": {
      "by_weekday": {
        "Segunda": 3229,
        "Terça": 3315,
        "Quarta": 3337,
        "Quinta": 3175,
        "Sexta": 2792,
        "Sábado": 1061,
        "Domingo": 104
      },
      "by_hour": {
        "00h": 260,
        "01h": 106,
        "02h": 47,
        "03h": 2,
        "04h": 0,
        "05h": 0,
        "06h": 0,
        "07h": 7,
        "08h": 44,
        "09h": 726,
        "10h": 1570,
        "11h": 1495,
        "12h": 1229,
        "13h": 1035,
        "14h": 785,
        "15h": 1115,
        "16h": 1500,
        "17h": 1749,
        "18h": 1541,
        "19h": 1063,
        "20h": 571,
        "21h": 616,
        "22h": 732,
        "23h": 820
      },
      "heatmap": [
        {
          "weekday": "Segunda",
          "hour": "00h",
          "tickets": 17
        },
        {
          "weekday": "Segunda",
          "hour": "01h",
          "tickets": 1
        },
        {
          "weekday": "Segunda",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "08h",
          "tickets": 0
        },
        {
          "weekday": "Segunda",
          "hour": "09h",
          "tickets": 266
        },
        {
          "weekday": "Segunda",
          "hour": "10h",
          "tickets": 279
        },
        {
          "weekday": "Segunda",
          "hour": "11h",
          "tickets": 226
        },
        {
          "weekday": "Segunda",
          "hour": "12h",
          "tickets": 237
        },
        {
          "weekday": "Segunda",
          "hour": "13h",
          "tickets": 218
        },
        {
          "weekday": "Segunda",
          "hour": "14h",
          "tickets": 151
        },
        {
          "weekday": "Segunda",
          "hour": "15h",
          "tickets": 233
        },
        {
          "weekday": "Segunda",
          "hour": "16h",
          "tickets": 335
        },
        {
          "weekday": "Segunda",
          "hour": "17h",
          "tickets": 335
        },
        {
          "weekday": "Segunda",
          "hour": "18h",
          "tickets": 302
        },
        {
          "weekday": "Segunda",
          "hour": "19h",
          "tickets": 177
        },
        {
          "weekday": "Segunda",
          "hour": "20h",
          "tickets": 83
        },
        {
          "weekday": "Segunda",
          "hour": "21h",
          "tickets": 104
        },
        {
          "weekday": "Segunda",
          "hour": "22h",
          "tickets": 119
        },
        {
          "weekday": "Segunda",
          "hour": "23h",
          "tickets": 146
        },
        {
          "weekday": "Terça",
          "hour": "00h",
          "tickets": 60
        },
        {
          "weekday": "Terça",
          "hour": "01h",
          "tickets": 43
        },
        {
          "weekday": "Terça",
          "hour": "02h",
          "tickets": 27
        },
        {
          "weekday": "Terça",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Terça",
          "hour": "08h",
          "tickets": 4
        },
        {
          "weekday": "Terça",
          "hour": "09h",
          "tickets": 118
        },
        {
          "weekday": "Terça",
          "hour": "10h",
          "tickets": 196
        },
        {
          "weekday": "Terça",
          "hour": "11h",
          "tickets": 208
        },
        {
          "weekday": "Terça",
          "hour": "12h",
          "tickets": 236
        },
        {
          "weekday": "Terça",
          "hour": "13h",
          "tickets": 186
        },
        {
          "weekday": "Terça",
          "hour": "14h",
          "tickets": 181
        },
        {
          "weekday": "Terça",
          "hour": "15h",
          "tickets": 167
        },
        {
          "weekday": "Terça",
          "hour": "16h",
          "tickets": 252
        },
        {
          "weekday": "Terça",
          "hour": "17h",
          "tickets": 413
        },
        {
          "weekday": "Terça",
          "hour": "18h",
          "tickets": 366
        },
        {
          "weekday": "Terça",
          "hour": "19h",
          "tickets": 233
        },
        {
          "weekday": "Terça",
          "hour": "20h",
          "tickets": 116
        },
        {
          "weekday": "Terça",
          "hour": "21h",
          "tickets": 75
        },
        {
          "weekday": "Terça",
          "hour": "22h",
          "tickets": 145
        },
        {
          "weekday": "Terça",
          "hour": "23h",
          "tickets": 289
        },
        {
          "weekday": "Quarta",
          "hour": "00h",
          "tickets": 21
        },
        {
          "weekday": "Quarta",
          "hour": "01h",
          "tickets": 1
        },
        {
          "weekday": "Quarta",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "07h",
          "tickets": 1
        },
        {
          "weekday": "Quarta",
          "hour": "08h",
          "tickets": 0
        },
        {
          "weekday": "Quarta",
          "hour": "09h",
          "tickets": 119
        },
        {
          "weekday": "Quarta",
          "hour": "10h",
          "tickets": 636
        },
        {
          "weekday": "Quarta",
          "hour": "11h",
          "tickets": 235
        },
        {
          "weekday": "Quarta",
          "hour": "12h",
          "tickets": 300
        },
        {
          "weekday": "Quarta",
          "hour": "13h",
          "tickets": 174
        },
        {
          "weekday": "Quarta",
          "hour": "14h",
          "tickets": 131
        },
        {
          "weekday": "Quarta",
          "hour": "15h",
          "tickets": 230
        },
        {
          "weekday": "Quarta",
          "hour": "16h",
          "tickets": 270
        },
        {
          "weekday": "Quarta",
          "hour": "17h",
          "tickets": 262
        },
        {
          "weekday": "Quarta",
          "hour": "18h",
          "tickets": 260
        },
        {
          "weekday": "Quarta",
          "hour": "19h",
          "tickets": 232
        },
        {
          "weekday": "Quarta",
          "hour": "20h",
          "tickets": 108
        },
        {
          "weekday": "Quarta",
          "hour": "21h",
          "tickets": 112
        },
        {
          "weekday": "Quarta",
          "hour": "22h",
          "tickets": 118
        },
        {
          "weekday": "Quarta",
          "hour": "23h",
          "tickets": 127
        },
        {
          "weekday": "Quinta",
          "hour": "00h",
          "tickets": 43
        },
        {
          "weekday": "Quinta",
          "hour": "01h",
          "tickets": 3
        },
        {
          "weekday": "Quinta",
          "hour": "02h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "08h",
          "tickets": 0
        },
        {
          "weekday": "Quinta",
          "hour": "09h",
          "tickets": 65
        },
        {
          "weekday": "Quinta",
          "hour": "10h",
          "tickets": 192
        },
        {
          "weekday": "Quinta",
          "hour": "11h",
          "tickets": 575
        },
        {
          "weekday": "Quinta",
          "hour": "12h",
          "tickets": 212
        },
        {
          "weekday": "Quinta",
          "hour": "13h",
          "tickets": 222
        },
        {
          "weekday": "Quinta",
          "hour": "14h",
          "tickets": 140
        },
        {
          "weekday": "Quinta",
          "hour": "15h",
          "tickets": 204
        },
        {
          "weekday": "Quinta",
          "hour": "16h",
          "tickets": 258
        },
        {
          "weekday": "Quinta",
          "hour": "17h",
          "tickets": 252
        },
        {
          "weekday": "Quinta",
          "hour": "18h",
          "tickets": 219
        },
        {
          "weekday": "Quinta",
          "hour": "19h",
          "tickets": 184
        },
        {
          "weekday": "Quinta",
          "hour": "20h",
          "tickets": 108
        },
        {
          "weekday": "Quinta",
          "hour": "21h",
          "tickets": 185
        },
        {
          "weekday": "Quinta",
          "hour": "22h",
          "tickets": 204
        },
        {
          "weekday": "Quinta",
          "hour": "23h",
          "tickets": 109
        },
        {
          "weekday": "Sexta",
          "hour": "00h",
          "tickets": 79
        },
        {
          "weekday": "Sexta",
          "hour": "01h",
          "tickets": 57
        },
        {
          "weekday": "Sexta",
          "hour": "02h",
          "tickets": 17
        },
        {
          "weekday": "Sexta",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Sexta",
          "hour": "08h",
          "tickets": 2
        },
        {
          "weekday": "Sexta",
          "hour": "09h",
          "tickets": 58
        },
        {
          "weekday": "Sexta",
          "hour": "10h",
          "tickets": 169
        },
        {
          "weekday": "Sexta",
          "hour": "11h",
          "tickets": 186
        },
        {
          "weekday": "Sexta",
          "hour": "12h",
          "tickets": 160
        },
        {
          "weekday": "Sexta",
          "hour": "13h",
          "tickets": 159
        },
        {
          "weekday": "Sexta",
          "hour": "14h",
          "tickets": 120
        },
        {
          "weekday": "Sexta",
          "hour": "15h",
          "tickets": 215
        },
        {
          "weekday": "Sexta",
          "hour": "16h",
          "tickets": 264
        },
        {
          "weekday": "Sexta",
          "hour": "17h",
          "tickets": 321
        },
        {
          "weekday": "Sexta",
          "hour": "18h",
          "tickets": 324
        },
        {
          "weekday": "Sexta",
          "hour": "19h",
          "tickets": 170
        },
        {
          "weekday": "Sexta",
          "hour": "20h",
          "tickets": 106
        },
        {
          "weekday": "Sexta",
          "hour": "21h",
          "tickets": 128
        },
        {
          "weekday": "Sexta",
          "hour": "22h",
          "tickets": 127
        },
        {
          "weekday": "Sexta",
          "hour": "23h",
          "tickets": 130
        },
        {
          "weekday": "Sábado",
          "hour": "00h",
          "tickets": 32
        },
        {
          "weekday": "Sábado",
          "hour": "01h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "02h",
          "tickets": 1
        },
        {
          "weekday": "Sábado",
          "hour": "03h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Sábado",
          "hour": "07h",
          "tickets": 6
        },
        {
          "weekday": "Sábado",
          "hour": "08h",
          "tickets": 38
        },
        {
          "weekday": "Sábado",
          "hour": "09h",
          "tickets": 99
        },
        {
          "weekday": "Sábado",
          "hour": "10h",
          "tickets": 92
        },
        {
          "weekday": "Sábado",
          "hour": "11h",
          "tickets": 57
        },
        {
          "weekday": "Sábado",
          "hour": "12h",
          "tickets": 72
        },
        {
          "weekday": "Sábado",
          "hour": "13h",
          "tickets": 65
        },
        {
          "weekday": "Sábado",
          "hour": "14h",
          "tickets": 55
        },
        {
          "weekday": "Sábado",
          "hour": "15h",
          "tickets": 65
        },
        {
          "weekday": "Sábado",
          "hour": "16h",
          "tickets": 103
        },
        {
          "weekday": "Sábado",
          "hour": "17h",
          "tickets": 157
        },
        {
          "weekday": "Sábado",
          "hour": "18h",
          "tickets": 69
        },
        {
          "weekday": "Sábado",
          "hour": "19h",
          "tickets": 67
        },
        {
          "weekday": "Sábado",
          "hour": "20h",
          "tickets": 47
        },
        {
          "weekday": "Sábado",
          "hour": "21h",
          "tickets": 3
        },
        {
          "weekday": "Sábado",
          "hour": "22h",
          "tickets": 19
        },
        {
          "weekday": "Sábado",
          "hour": "23h",
          "tickets": 14
        },
        {
          "weekday": "Domingo",
          "hour": "00h",
          "tickets": 8
        },
        {
          "weekday": "Domingo",
          "hour": "01h",
          "tickets": 1
        },
        {
          "weekday": "Domingo",
          "hour": "02h",
          "tickets": 2
        },
        {
          "weekday": "Domingo",
          "hour": "03h",
          "tickets": 2
        },
        {
          "weekday": "Domingo",
          "hour": "04h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "05h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "06h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "07h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "08h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "09h",
          "tickets": 1
        },
        {
          "weekday": "Domingo",
          "hour": "10h",
          "tickets": 6
        },
        {
          "weekday": "Domingo",
          "hour": "11h",
          "tickets": 8
        },
        {
          "weekday": "Domingo",
          "hour": "12h",
          "tickets": 12
        },
        {
          "weekday": "Domingo",
          "hour": "13h",
          "tickets": 11
        },
        {
          "weekday": "Domingo",
          "hour": "14h",
          "tickets": 7
        },
        {
          "weekday": "Domingo",
          "hour": "15h",
          "tickets": 1
        },
        {
          "weekday": "Domingo",
          "hour": "16h",
          "tickets": 18
        },
        {
          "weekday": "Domingo",
          "hour": "17h",
          "tickets": 9
        },
        {
          "weekday": "Domingo",
          "hour": "18h",
          "tickets": 1
        },
        {
          "weekday": "Domingo",
          "hour": "19h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "20h",
          "tickets": 3
        },
        {
          "weekday": "Domingo",
          "hour": "21h",
          "tickets": 9
        },
        {
          "weekday": "Domingo",
          "hour": "22h",
          "tickets": 0
        },
        {
          "weekday": "Domingo",
          "hour": "23h",
          "tickets": 5
        }
      ],
      "total_tickets": 17013,
      "period_info": {
        "from_date": "2025-09-30",
        "days_in_period": 237
      }
    }
  },
  "agent_responses": {
    "Não Atribuído": 13545,
    "Inês Martinho": 8249,
    "Cátia Leal": 6909,
    "Magali Morim": 6891,
    "Débora Pinto": 6658,
    "Sandra Reis": 4848,
    "Margarida Janeiro": 3385,
    "Carolina Ferreirinha": 3173,
    "Catarina França": 1669,
    "Paula Candeias": 1628,
    "Marta Oliveira": 373,
    "Rafaela Lapa": 205
  },
  "agent_efficiency": {
    "Não Atribuído": {
      "avg_interactions_per_ticket": 2.14,
      "total_interactions": 13545,
      "tickets_closed": 6344
    },
    "Cátia Leal": {
      "avg_interactions_per_ticket": 2.9,
      "total_interactions": 6909,
      "tickets_closed": 2386
    },
    "Rafaela Lapa": {
      "avg_interactions_per_ticket": 3.15,
      "total_interactions": 205,
      "tickets_closed": 65
    },
    "Magali Morim": {
      "avg_interactions_per_ticket": 3.26,
      "total_interactions": 6891,
      "tickets_closed": 2114
    },
    "Carolina Ferreirinha": {
      "avg_interactions_per_ticket": 3.61,
      "total_interactions": 3173,
      "tickets_closed": 879
    },
    "Inês Martinho": {
      "avg_interactions_per_ticket": 3.86,
      "total_interactions": 8249,
      "tickets_closed": 2135
    },
    "Sandra Reis": {
      "avg_interactions_per_ticket": 4.36,
      "total_interactions": 4848,
      "tickets_closed": 1112
    },
    "Catarina França": {
      "avg_interactions_per_ticket": 4.84,
      "total_interactions": 1669,
      "tickets_closed": 345
    },
    "Paula Candeias": {
      "avg_interactions_per_ticket": 5.2,
      "total_interactions": 1628,
      "tickets_closed": 313
    },
    "Margarida Janeiro": {
      "avg_interactions_per_ticket": 6.72,
      "total_interactions": 3385,
      "tickets_closed": 504
    },
    "Débora Pinto": {
      "avg_interactions_per_ticket": 8.27,
      "total_interactions": 6658,
      "tickets_closed": 805
    },
    "Marta Oliveira": {
      "avg_interactions_per_ticket": 33.91,
      "total_interactions": 373,
      "tickets_closed": 11
    }
  },
  "agent_state_changes": {
    "Inês Martinho": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 994,
        "tickets_per_day": {
          "2025-09-30": 32,
          "2025-10-01": 7,
          "2025-10-02": 2,
          "2025-10-03": 3,
          "2025-10-06": 6,
          "2025-10-07": 22,
          "2025-10-08": 15,
          "2025-10-09": 45,
          "2025-10-10": 48,
          "2025-10-13": 8,
          "2025-10-14": 24,
          "2025-10-15": 24,
          "2025-10-17": 14,
          "2025-10-20": 8,
          "2025-10-21": 23,
          "2025-10-22": 25,
          "2025-10-23": 13,
          "2025-10-24": 34,
          "2025-10-25": 6,
          "2025-10-27": 21,
          "2025-10-28": 49,
          "2025-10-29": 6,
          "2025-10-30": 5,
          "2025-10-31": 11,
          "2025-11-03": 44,
          "2025-11-04": 3,
          "2025-11-05": 28,
          "2025-11-06": 32,
          "2025-11-07": 9,
          "2025-11-10": 1,
          "2025-11-13": 12,
          "2025-11-14": 3,
          "2025-11-16": 3,
          "2025-11-18": 29,
          "2025-11-19": 9,
          "2025-11-20": 1,
          "2025-11-21": 2,
          "2025-11-24": 3,
          "2025-11-26": 21,
          "2025-11-27": 5,
          "2025-11-28": 8,
          "2025-11-29": 1,
          "2025-12-02": 8,
          "2025-12-03": 1,
          "2025-12-04": 6,
          "2025-12-05": 12,
          "2025-12-09": 6,
          "2025-12-10": 11,
          "2025-12-11": 1,
          "2025-12-12": 16,
          "2025-12-15": 3,
          "2025-12-16": 3,
          "2026-01-02": 6,
          "2026-01-07": 5,
          "2026-01-08": 2,
          "2026-01-13": 2,
          "2026-01-14": 2,
          "2026-01-15": 8,
          "2026-01-16": 2,
          "2026-01-17": 2,
          "2026-01-19": 3,
          "2026-01-20": 1,
          "2026-01-22": 1,
          "2026-01-23": 1,
          "2026-01-26": 1,
          "2026-01-28": 1,
          "2026-01-29": 2,
          "2026-01-30": 3,
          "2026-02-03": 11,
          "2026-02-04": 1,
          "2026-02-10": 4,
          "2026-02-13": 2,
          "2026-02-16": 5,
          "2026-02-17": 7,
          "2026-02-18": 7,
          "2026-02-19": 3,
          "2026-02-20": 1,
          "2026-02-23": 5,
          "2026-02-24": 3,
          "2026-02-25": 3,
          "2026-02-26": 1,
          "2026-02-27": 1,
          "2026-02-28": 5,
          "2026-03-02": 3,
          "2026-03-04": 1,
          "2026-03-05": 1,
          "2026-03-06": 5,
          "2026-03-07": 1,
          "2026-03-10": 5,
          "2026-03-12": 1,
          "2026-03-13": 1,
          "2026-03-15": 2,
          "2026-03-16": 1,
          "2026-03-17": 3,
          "2026-03-18": 9,
          "2026-03-19": 3,
          "2026-03-20": 16,
          "2026-03-24": 1,
          "2026-03-26": 3,
          "2026-03-30": 3,
          "2026-04-01": 1,
          "2026-04-07": 3,
          "2026-04-08": 5,
          "2026-04-09": 1,
          "2026-04-10": 1,
          "2026-04-13": 6,
          "2026-04-14": 8,
          "2026-04-15": 4,
          "2026-04-16": 2,
          "2026-04-20": 2,
          "2026-04-22": 18,
          "2026-04-23": 7,
          "2026-04-24": 1,
          "2026-04-28": 1,
          "2026-04-29": 3,
          "2026-04-30": 2,
          "2026-05-02": 1,
          "2026-05-04": 5,
          "2026-05-06": 4,
          "2026-05-14": 2,
          "2026-05-17": 1,
          "2026-05-18": 1,
          "2026-05-19": 2,
          "2026-05-22": 6,
          "2026-05-26": 7,
          "2026-05-27": 4,
          "2026-06-02": 2,
          "2026-06-03": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 120,
          "tickets_per_day": {
            "2025-09-30": 12,
            "2025-10-08": 5,
            "2025-10-10": 17,
            "2025-10-13": 8,
            "2025-10-22": 15,
            "2025-10-27": 3,
            "2025-10-28": 4,
            "2025-11-05": 13,
            "2025-11-07": 1,
            "2025-11-13": 6,
            "2025-11-24": 1,
            "2025-12-03": 1,
            "2025-12-04": 1,
            "2025-12-10": 2,
            "2026-01-08": 2,
            "2026-03-06": 2,
            "2026-03-18": 3,
            "2026-03-20": 1,
            "2026-04-07": 1,
            "2026-04-08": 2,
            "2026-04-13": 1,
            "2026-04-14": 4,
            "2026-04-15": 1,
            "2026-04-30": 1,
            "2026-05-06": 3,
            "2026-05-14": 1,
            "2026-05-22": 6,
            "2026-05-26": 1,
            "2026-05-27": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 420,
          "tickets_per_day": {
            "2025-09-30": 3,
            "2025-10-01": 7,
            "2025-10-02": 2,
            "2025-10-06": 4,
            "2025-10-07": 15,
            "2025-10-08": 1,
            "2025-10-09": 4,
            "2025-10-10": 12,
            "2025-10-15": 11,
            "2025-10-20": 8,
            "2025-10-21": 8,
            "2025-10-22": 10,
            "2025-10-23": 4,
            "2025-10-24": 14,
            "2025-10-27": 10,
            "2025-10-28": 41,
            "2025-10-29": 6,
            "2025-10-30": 5,
            "2025-10-31": 11,
            "2025-11-03": 8,
            "2025-11-04": 2,
            "2025-11-05": 11,
            "2025-11-06": 6,
            "2025-11-10": 1,
            "2025-11-13": 5,
            "2025-11-18": 3,
            "2025-11-19": 1,
            "2025-11-28": 3,
            "2025-12-02": 2,
            "2025-12-04": 1,
            "2025-12-05": 11,
            "2025-12-09": 4,
            "2025-12-12": 2,
            "2025-12-15": 1,
            "2026-01-07": 5,
            "2026-01-13": 1,
            "2026-01-14": 2,
            "2026-01-15": 5,
            "2026-01-16": 2,
            "2026-01-19": 3,
            "2026-01-20": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-03": 2,
            "2026-02-04": 1,
            "2026-02-10": 2,
            "2026-02-16": 5,
            "2026-02-17": 4,
            "2026-02-18": 2,
            "2026-02-23": 5,
            "2026-02-24": 3,
            "2026-02-25": 3,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 4,
            "2026-03-02": 2,
            "2026-03-04": 1,
            "2026-03-05": 1,
            "2026-03-06": 3,
            "2026-03-10": 5,
            "2026-03-13": 1,
            "2026-03-15": 2,
            "2026-03-16": 1,
            "2026-03-17": 2,
            "2026-03-18": 6,
            "2026-03-19": 3,
            "2026-03-20": 15,
            "2026-03-24": 1,
            "2026-03-26": 3,
            "2026-03-30": 3,
            "2026-04-01": 1,
            "2026-04-07": 2,
            "2026-04-08": 3,
            "2026-04-09": 1,
            "2026-04-10": 1,
            "2026-04-13": 5,
            "2026-04-14": 4,
            "2026-04-15": 3,
            "2026-04-16": 2,
            "2026-04-20": 2,
            "2026-04-22": 18,
            "2026-04-23": 7,
            "2026-04-24": 1,
            "2026-04-28": 1,
            "2026-04-29": 3,
            "2026-04-30": 1,
            "2026-05-02": 1,
            "2026-05-04": 5,
            "2026-05-06": 1,
            "2026-05-14": 1,
            "2026-05-17": 1,
            "2026-05-18": 1,
            "2026-05-19": 2,
            "2026-05-26": 6,
            "2026-05-27": 2,
            "2026-06-02": 2,
            "2026-06-03": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 397,
          "tickets_per_day": {
            "2025-09-30": 17,
            "2025-10-03": 3,
            "2025-10-06": 2,
            "2025-10-07": 7,
            "2025-10-08": 9,
            "2025-10-09": 41,
            "2025-10-10": 19,
            "2025-10-14": 24,
            "2025-10-15": 13,
            "2025-10-17": 14,
            "2025-10-21": 13,
            "2025-10-23": 7,
            "2025-10-24": 20,
            "2025-10-27": 8,
            "2025-10-28": 4,
            "2025-11-03": 36,
            "2025-11-04": 1,
            "2025-11-05": 2,
            "2025-11-06": 24,
            "2025-11-07": 6,
            "2025-11-13": 1,
            "2025-11-16": 3,
            "2025-11-18": 14,
            "2025-11-19": 8,
            "2025-11-20": 1,
            "2025-11-21": 2,
            "2025-11-24": 2,
            "2025-11-26": 21,
            "2025-11-27": 5,
            "2025-11-28": 5,
            "2025-12-02": 5,
            "2025-12-04": 1,
            "2025-12-09": 2,
            "2025-12-10": 9,
            "2025-12-12": 14,
            "2025-12-15": 2,
            "2025-12-16": 1,
            "2026-01-02": 1,
            "2026-01-13": 1,
            "2026-01-15": 3,
            "2026-01-22": 1,
            "2026-01-26": 1,
            "2026-01-28": 1,
            "2026-01-29": 1,
            "2026-02-03": 3,
            "2026-02-10": 2,
            "2026-02-13": 2,
            "2026-02-17": 1,
            "2026-02-18": 5,
            "2026-02-19": 3,
            "2026-02-20": 1,
            "2026-02-28": 1,
            "2026-03-02": 1,
            "2026-03-07": 1,
            "2026-03-12": 1,
            "2026-03-17": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 45,
          "tickets_per_day": {
            "2025-10-21": 2,
            "2025-10-23": 2,
            "2025-10-25": 6,
            "2025-11-05": 2,
            "2025-11-06": 2,
            "2025-11-07": 2,
            "2025-11-14": 3,
            "2025-11-18": 12,
            "2025-11-29": 1,
            "2025-12-04": 3,
            "2026-01-17": 1,
            "2026-01-30": 2,
            "2026-02-03": 5,
            "2026-02-17": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-11": 1,
            "2025-12-16": 2,
            "2026-01-02": 5,
            "2026-01-17": 1,
            "2026-02-03": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Não Atribuído": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1052,
        "tickets_per_day": {
          "2025-09-30": 14,
          "2025-10-01": 4,
          "2025-10-03": 7,
          "2025-10-06": 3,
          "2025-10-07": 41,
          "2025-10-08": 13,
          "2025-10-09": 20,
          "2025-10-10": 13,
          "2025-10-13": 30,
          "2025-10-14": 32,
          "2025-10-15": 33,
          "2025-10-16": 7,
          "2025-10-17": 28,
          "2025-10-20": 17,
          "2025-10-21": 15,
          "2025-10-22": 7,
          "2025-10-23": 35,
          "2025-10-24": 5,
          "2025-10-25": 16,
          "2025-10-26": 1,
          "2025-10-27": 28,
          "2025-10-28": 11,
          "2025-10-29": 36,
          "2025-10-30": 14,
          "2025-10-31": 21,
          "2025-11-02": 2,
          "2025-11-03": 6,
          "2025-11-04": 1,
          "2025-11-05": 63,
          "2025-11-06": 8,
          "2025-11-11": 1,
          "2025-11-13": 2,
          "2025-11-14": 10,
          "2025-11-17": 1,
          "2025-11-21": 8,
          "2025-11-22": 1,
          "2025-11-26": 1,
          "2025-11-28": 3,
          "2025-11-29": 10,
          "2025-12-02": 19,
          "2025-12-03": 7,
          "2025-12-04": 3,
          "2025-12-05": 2,
          "2025-12-06": 1,
          "2025-12-09": 1,
          "2025-12-10": 4,
          "2025-12-15": 7,
          "2025-12-16": 5,
          "2025-12-17": 11,
          "2025-12-18": 3,
          "2025-12-19": 4,
          "2025-12-21": 1,
          "2025-12-22": 4,
          "2025-12-25": 1,
          "2025-12-26": 7,
          "2025-12-29": 29,
          "2025-12-31": 1,
          "2026-01-02": 4,
          "2026-01-03": 2,
          "2026-01-05": 40,
          "2026-01-06": 4,
          "2026-01-08": 3,
          "2026-01-09": 4,
          "2026-01-10": 2,
          "2026-01-12": 3,
          "2026-01-13": 2,
          "2026-01-14": 3,
          "2026-01-15": 5,
          "2026-01-16": 1,
          "2026-01-18": 1,
          "2026-01-20": 2,
          "2026-01-21": 2,
          "2026-01-23": 1,
          "2026-01-24": 2,
          "2026-01-26": 2,
          "2026-01-27": 2,
          "2026-01-30": 9,
          "2026-02-02": 2,
          "2026-02-03": 1,
          "2026-02-04": 1,
          "2026-02-06": 3,
          "2026-02-09": 1,
          "2026-02-10": 45,
          "2026-02-11": 2,
          "2026-02-12": 3,
          "2026-02-13": 4,
          "2026-02-14": 1,
          "2026-02-16": 4,
          "2026-02-18": 37,
          "2026-02-19": 37,
          "2026-02-20": 1,
          "2026-02-23": 2,
          "2026-02-25": 1,
          "2026-02-26": 1,
          "2026-02-27": 1,
          "2026-02-28": 5,
          "2026-03-02": 4,
          "2026-03-06": 2,
          "2026-03-07": 5,
          "2026-03-09": 6,
          "2026-03-10": 1,
          "2026-03-11": 11,
          "2026-03-12": 2,
          "2026-03-13": 2,
          "2026-03-16": 1,
          "2026-03-17": 1,
          "2026-03-18": 12,
          "2026-03-23": 1,
          "2026-03-24": 6,
          "2026-03-25": 1,
          "2026-03-26": 19,
          "2026-03-30": 8,
          "2026-04-02": 2,
          "2026-04-06": 2,
          "2026-04-07": 2,
          "2026-04-08": 3,
          "2026-04-10": 2,
          "2026-04-11": 3,
          "2026-04-13": 1,
          "2026-04-14": 1,
          "2026-04-15": 2,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-04-27": 1,
          "2026-04-28": 1,
          "2026-04-30": 1,
          "2026-05-02": 3,
          "2026-05-09": 2,
          "2026-05-25": 3,
          "2026-05-26": 5,
          "2026-05-27": 1,
          "2026-05-29": 4,
          "2026-05-30": 1,
          "2026-06-01": 1,
          "2026-06-02": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-10-15": 1,
            "2026-05-26": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 456,
          "tickets_per_day": {
            "2025-09-30": 7,
            "2025-10-03": 1,
            "2025-10-06": 2,
            "2025-10-07": 6,
            "2025-10-08": 11,
            "2025-10-09": 4,
            "2025-10-10": 9,
            "2025-10-13": 4,
            "2025-10-14": 16,
            "2025-10-15": 12,
            "2025-10-17": 5,
            "2025-10-20": 2,
            "2025-10-21": 7,
            "2025-10-23": 4,
            "2025-10-24": 5,
            "2025-10-25": 5,
            "2025-10-26": 1,
            "2025-10-27": 7,
            "2025-10-28": 9,
            "2025-10-29": 16,
            "2025-10-30": 2,
            "2025-10-31": 9,
            "2025-11-02": 2,
            "2025-11-03": 4,
            "2025-11-05": 46,
            "2025-11-06": 3,
            "2025-11-11": 1,
            "2025-11-14": 9,
            "2025-11-17": 1,
            "2025-11-26": 1,
            "2025-12-02": 1,
            "2025-12-06": 1,
            "2025-12-17": 4,
            "2025-12-21": 1,
            "2025-12-22": 1,
            "2025-12-26": 3,
            "2025-12-29": 26,
            "2025-12-31": 1,
            "2026-01-02": 2,
            "2026-01-03": 2,
            "2026-01-05": 40,
            "2026-01-06": 4,
            "2026-01-09": 2,
            "2026-01-10": 2,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-14": 3,
            "2026-01-15": 3,
            "2026-01-20": 2,
            "2026-01-21": 2,
            "2026-01-23": 1,
            "2026-01-26": 2,
            "2026-01-27": 2,
            "2026-01-30": 2,
            "2026-02-02": 2,
            "2026-02-06": 2,
            "2026-02-10": 39,
            "2026-02-11": 1,
            "2026-02-12": 1,
            "2026-02-13": 1,
            "2026-02-14": 1,
            "2026-02-16": 1,
            "2026-02-18": 9,
            "2026-02-20": 1,
            "2026-02-23": 1,
            "2026-02-26": 1,
            "2026-02-27": 1,
            "2026-02-28": 1,
            "2026-03-02": 4,
            "2026-03-06": 2,
            "2026-03-07": 5,
            "2026-03-09": 6,
            "2026-03-10": 1,
            "2026-03-11": 9,
            "2026-03-12": 2,
            "2026-03-13": 2,
            "2026-03-16": 1,
            "2026-03-23": 1,
            "2026-03-30": 1,
            "2026-04-02": 2,
            "2026-04-06": 2,
            "2026-04-07": 2,
            "2026-04-08": 3,
            "2026-04-10": 2,
            "2026-04-11": 3,
            "2026-04-13": 1,
            "2026-04-14": 1,
            "2026-04-15": 2,
            "2026-04-21": 1,
            "2026-04-27": 1,
            "2026-04-28": 1,
            "2026-04-30": 1,
            "2026-05-02": 3,
            "2026-05-09": 2,
            "2026-05-25": 2,
            "2026-05-26": 2,
            "2026-05-27": 1,
            "2026-05-29": 4,
            "2026-05-30": 1,
            "2026-06-01": 1,
            "2026-06-02": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 42,
          "tickets_per_day": {
            "2025-10-03": 4,
            "2025-10-09": 1,
            "2025-10-13": 1,
            "2025-10-15": 1,
            "2025-11-04": 1,
            "2025-11-28": 3,
            "2025-12-17": 2,
            "2025-12-19": 1,
            "2025-12-25": 1,
            "2026-01-16": 1,
            "2026-02-09": 1,
            "2026-02-10": 6,
            "2026-02-13": 3,
            "2026-02-16": 1,
            "2026-02-18": 4,
            "2026-02-19": 8,
            "2026-02-23": 1,
            "2026-03-11": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 471,
          "tickets_per_day": {
            "2025-09-30": 7,
            "2025-10-01": 4,
            "2025-10-03": 2,
            "2025-10-06": 1,
            "2025-10-07": 35,
            "2025-10-08": 2,
            "2025-10-09": 15,
            "2025-10-10": 4,
            "2025-10-13": 25,
            "2025-10-14": 16,
            "2025-10-15": 19,
            "2025-10-16": 7,
            "2025-10-17": 23,
            "2025-10-20": 15,
            "2025-10-21": 8,
            "2025-10-22": 7,
            "2025-10-23": 31,
            "2025-10-25": 11,
            "2025-10-27": 21,
            "2025-10-28": 2,
            "2025-10-29": 20,
            "2025-10-30": 12,
            "2025-10-31": 12,
            "2025-11-03": 2,
            "2025-11-05": 17,
            "2025-11-06": 5,
            "2025-11-13": 2,
            "2025-11-14": 1,
            "2025-11-21": 8,
            "2025-11-22": 1,
            "2025-11-29": 10,
            "2025-12-02": 18,
            "2025-12-03": 5,
            "2025-12-04": 3,
            "2025-12-05": 2,
            "2025-12-09": 1,
            "2025-12-10": 4,
            "2025-12-15": 3,
            "2025-12-16": 1,
            "2025-12-18": 2,
            "2025-12-19": 2,
            "2025-12-26": 2,
            "2026-01-08": 3,
            "2026-01-09": 2,
            "2026-01-12": 2,
            "2026-01-13": 1,
            "2026-01-18": 1,
            "2026-01-24": 2,
            "2026-01-30": 7,
            "2026-02-04": 1,
            "2026-02-06": 1,
            "2026-02-11": 1,
            "2026-02-12": 2,
            "2026-02-16": 2,
            "2026-02-18": 2,
            "2026-02-19": 2,
            "2026-02-25": 1,
            "2026-02-28": 4,
            "2026-03-17": 1,
            "2026-03-18": 12,
            "2026-03-24": 6,
            "2026-03-25": 1,
            "2026-03-26": 19,
            "2026-03-30": 7,
            "2026-04-22": 2,
            "2026-05-25": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 79,
          "tickets_per_day": {
            "2025-12-03": 2,
            "2025-12-15": 4,
            "2025-12-16": 4,
            "2025-12-17": 5,
            "2025-12-18": 1,
            "2025-12-19": 1,
            "2025-12-22": 3,
            "2025-12-26": 2,
            "2025-12-29": 3,
            "2026-01-02": 2,
            "2026-01-15": 2,
            "2026-02-03": 1,
            "2026-02-18": 22,
            "2026-02-19": 27
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Catarina França": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 819,
        "tickets_per_day": {
          "2025-09-30": 3,
          "2025-10-01": 2,
          "2025-10-02": 3,
          "2025-10-03": 3,
          "2025-10-07": 14,
          "2025-10-10": 41,
          "2025-10-13": 3,
          "2025-10-14": 64,
          "2025-10-15": 38,
          "2025-10-16": 10,
          "2025-10-17": 1,
          "2025-10-22": 25,
          "2025-10-23": 42,
          "2025-10-24": 44,
          "2025-10-27": 31,
          "2025-10-28": 3,
          "2025-10-29": 32,
          "2025-10-30": 43,
          "2025-10-31": 18,
          "2025-11-03": 84,
          "2025-11-04": 5,
          "2025-11-05": 25,
          "2025-11-06": 68,
          "2025-11-07": 1,
          "2025-11-10": 4,
          "2025-11-11": 3,
          "2025-11-12": 24,
          "2025-11-13": 21,
          "2025-11-14": 30,
          "2025-11-19": 5,
          "2025-11-21": 11,
          "2025-11-22": 1,
          "2025-11-23": 1,
          "2025-11-24": 8,
          "2025-11-25": 2,
          "2025-11-27": 1,
          "2025-11-29": 19,
          "2025-12-02": 9,
          "2025-12-03": 2,
          "2025-12-04": 11,
          "2025-12-05": 3,
          "2025-12-09": 3,
          "2025-12-10": 5,
          "2025-12-11": 11,
          "2025-12-12": 14,
          "2025-12-15": 2,
          "2025-12-16": 2,
          "2025-12-17": 3,
          "2025-12-19": 21
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 11,
          "tickets_per_day": {
            "2025-10-01": 2,
            "2025-10-10": 3,
            "2025-10-16": 2,
            "2025-11-06": 3,
            "2025-12-15": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 451,
          "tickets_per_day": {
            "2025-10-02": 3,
            "2025-10-07": 6,
            "2025-10-10": 27,
            "2025-10-14": 44,
            "2025-10-15": 28,
            "2025-10-16": 8,
            "2025-10-22": 9,
            "2025-10-23": 37,
            "2025-10-24": 34,
            "2025-10-27": 21,
            "2025-10-28": 3,
            "2025-10-29": 31,
            "2025-10-30": 2,
            "2025-11-03": 73,
            "2025-11-04": 5,
            "2025-11-05": 12,
            "2025-11-06": 21,
            "2025-11-10": 1,
            "2025-11-14": 24,
            "2025-11-19": 5,
            "2025-11-21": 5,
            "2025-11-24": 2,
            "2025-11-25": 1,
            "2025-11-27": 1,
            "2025-11-29": 1,
            "2025-12-02": 5,
            "2025-12-04": 9,
            "2025-12-10": 1,
            "2025-12-11": 8,
            "2025-12-12": 14,
            "2025-12-15": 1,
            "2025-12-17": 3,
            "2025-12-19": 6
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 109,
          "tickets_per_day": {
            "2025-09-30": 3,
            "2025-10-03": 3,
            "2025-10-07": 8,
            "2025-10-13": 1,
            "2025-10-14": 18,
            "2025-10-15": 9,
            "2025-10-22": 5,
            "2025-10-24": 7,
            "2025-10-27": 3,
            "2025-10-30": 9,
            "2025-11-06": 6,
            "2025-11-14": 6,
            "2025-11-21": 4,
            "2025-11-22": 1,
            "2025-11-24": 6,
            "2025-11-29": 1,
            "2025-12-02": 4,
            "2025-12-04": 1,
            "2025-12-09": 2,
            "2025-12-10": 1,
            "2025-12-11": 1,
            "2025-12-19": 10
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 231,
          "tickets_per_day": {
            "2025-10-10": 11,
            "2025-10-13": 2,
            "2025-10-14": 2,
            "2025-10-15": 1,
            "2025-10-17": 1,
            "2025-10-22": 11,
            "2025-10-23": 5,
            "2025-10-24": 3,
            "2025-10-27": 7,
            "2025-10-29": 1,
            "2025-10-30": 32,
            "2025-10-31": 18,
            "2025-11-03": 11,
            "2025-11-05": 13,
            "2025-11-06": 38,
            "2025-11-07": 1,
            "2025-11-10": 3,
            "2025-11-11": 3,
            "2025-11-12": 24,
            "2025-11-13": 21,
            "2025-11-21": 2,
            "2025-11-23": 1,
            "2025-11-25": 1,
            "2025-11-29": 17,
            "2025-12-04": 1,
            "2025-12-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 17,
          "tickets_per_day": {
            "2025-12-03": 2,
            "2025-12-05": 3,
            "2025-12-10": 3,
            "2025-12-11": 2,
            "2025-12-16": 2,
            "2025-12-19": 5
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Paula Candeias": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 855,
        "tickets_per_day": {
          "2025-09-30": 18,
          "2025-10-02": 7,
          "2025-10-06": 8,
          "2025-10-07": 16,
          "2025-10-08": 1,
          "2025-10-09": 14,
          "2025-10-10": 13,
          "2025-10-13": 4,
          "2025-10-14": 26,
          "2025-10-15": 104,
          "2025-10-16": 17,
          "2025-10-17": 19,
          "2025-10-20": 12,
          "2025-10-21": 2,
          "2025-10-22": 23,
          "2025-10-23": 67,
          "2025-10-25": 4,
          "2025-10-27": 6,
          "2025-10-28": 25,
          "2025-10-29": 10,
          "2025-10-30": 51,
          "2025-10-31": 11,
          "2025-11-03": 21,
          "2025-11-04": 9,
          "2025-11-05": 9,
          "2025-11-06": 16,
          "2025-11-07": 5,
          "2025-11-10": 4,
          "2025-11-11": 5,
          "2025-11-13": 6,
          "2025-11-14": 5,
          "2025-11-17": 15,
          "2025-11-19": 118,
          "2025-11-20": 22,
          "2025-11-21": 7,
          "2025-11-22": 17,
          "2025-11-24": 39,
          "2025-11-25": 3,
          "2025-11-26": 1,
          "2025-11-27": 7,
          "2025-11-28": 2,
          "2025-11-29": 6,
          "2025-12-02": 1,
          "2025-12-03": 4,
          "2025-12-04": 57,
          "2025-12-05": 4,
          "2025-12-06": 2,
          "2025-12-09": 1,
          "2025-12-10": 3,
          "2025-12-11": 6,
          "2025-12-12": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 16,
          "tickets_per_day": {
            "2025-10-07": 16
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 619,
          "tickets_per_day": {
            "2025-09-30": 18,
            "2025-10-02": 7,
            "2025-10-06": 8,
            "2025-10-08": 1,
            "2025-10-09": 6,
            "2025-10-10": 13,
            "2025-10-14": 22,
            "2025-10-15": 88,
            "2025-10-17": 19,
            "2025-10-20": 10,
            "2025-10-22": 14,
            "2025-10-23": 55,
            "2025-10-25": 1,
            "2025-10-28": 4,
            "2025-10-29": 7,
            "2025-10-30": 23,
            "2025-10-31": 2,
            "2025-11-03": 12,
            "2025-11-04": 9,
            "2025-11-05": 9,
            "2025-11-06": 13,
            "2025-11-11": 2,
            "2025-11-13": 6,
            "2025-11-14": 5,
            "2025-11-17": 12,
            "2025-11-19": 118,
            "2025-11-20": 21,
            "2025-11-22": 17,
            "2025-11-24": 36,
            "2025-11-26": 1,
            "2025-11-28": 2,
            "2025-12-04": 56,
            "2025-12-10": 1,
            "2025-12-11": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 36,
          "tickets_per_day": {
            "2025-10-15": 7,
            "2025-10-16": 13,
            "2025-10-30": 4,
            "2025-11-17": 3,
            "2025-11-21": 2,
            "2025-11-27": 7
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 164,
          "tickets_per_day": {
            "2025-10-09": 8,
            "2025-10-13": 4,
            "2025-10-14": 4,
            "2025-10-15": 9,
            "2025-10-16": 4,
            "2025-10-20": 2,
            "2025-10-21": 2,
            "2025-10-22": 9,
            "2025-10-23": 12,
            "2025-10-25": 3,
            "2025-10-27": 6,
            "2025-10-28": 21,
            "2025-10-29": 3,
            "2025-10-30": 24,
            "2025-10-31": 9,
            "2025-11-03": 9,
            "2025-11-06": 3,
            "2025-11-07": 5,
            "2025-11-10": 4,
            "2025-11-11": 3,
            "2025-11-20": 1,
            "2025-11-21": 5,
            "2025-11-24": 3,
            "2025-11-25": 3,
            "2025-11-29": 6,
            "2025-12-02": 1,
            "2025-12-05": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-12-03": 4,
            "2025-12-04": 1,
            "2025-12-05": 3,
            "2025-12-06": 2,
            "2025-12-09": 1,
            "2025-12-10": 2,
            "2025-12-11": 5,
            "2025-12-12": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Magali Morim": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 486,
        "tickets_per_day": {
          "2025-10-01": 2,
          "2025-10-03": 1,
          "2025-10-06": 9,
          "2025-10-14": 4,
          "2025-10-18": 5,
          "2025-11-04": 7,
          "2025-11-06": 1,
          "2025-11-08": 4,
          "2025-11-12": 9,
          "2025-11-13": 1,
          "2025-11-20": 4,
          "2025-11-30": 2,
          "2025-12-02": 4,
          "2025-12-03": 4,
          "2025-12-05": 1,
          "2025-12-08": 1,
          "2025-12-09": 1,
          "2025-12-11": 3,
          "2025-12-19": 2,
          "2025-12-20": 1,
          "2025-12-22": 3,
          "2025-12-28": 2,
          "2025-12-29": 22,
          "2026-01-13": 3,
          "2026-01-16": 2,
          "2026-01-19": 1,
          "2026-01-21": 1,
          "2026-01-22": 1,
          "2026-01-26": 3,
          "2026-01-27": 1,
          "2026-02-04": 3,
          "2026-02-05": 4,
          "2026-02-06": 2,
          "2026-02-09": 5,
          "2026-02-10": 1,
          "2026-02-11": 2,
          "2026-02-12": 1,
          "2026-02-16": 5,
          "2026-02-17": 2,
          "2026-02-18": 11,
          "2026-02-19": 24,
          "2026-02-20": 7,
          "2026-02-24": 6,
          "2026-02-26": 2,
          "2026-03-02": 4,
          "2026-03-03": 1,
          "2026-03-04": 5,
          "2026-03-05": 3,
          "2026-03-06": 2,
          "2026-03-10": 3,
          "2026-03-11": 6,
          "2026-03-12": 1,
          "2026-03-13": 9,
          "2026-03-16": 6,
          "2026-03-17": 8,
          "2026-03-19": 2,
          "2026-03-20": 35,
          "2026-03-21": 4,
          "2026-03-23": 1,
          "2026-03-24": 4,
          "2026-03-25": 5,
          "2026-03-27": 7,
          "2026-03-30": 2,
          "2026-03-31": 7,
          "2026-04-02": 21,
          "2026-04-08": 8,
          "2026-04-09": 4,
          "2026-04-10": 6,
          "2026-04-13": 8,
          "2026-04-14": 1,
          "2026-04-15": 4,
          "2026-04-17": 1,
          "2026-04-18": 16,
          "2026-04-20": 1,
          "2026-04-22": 1,
          "2026-04-23": 17,
          "2026-04-27": 4,
          "2026-04-28": 4,
          "2026-04-29": 5,
          "2026-04-30": 3,
          "2026-05-04": 2,
          "2026-05-06": 2,
          "2026-05-07": 8,
          "2026-05-08": 1,
          "2026-05-11": 6,
          "2026-05-12": 4,
          "2026-05-13": 9,
          "2026-05-14": 15,
          "2026-05-15": 2,
          "2026-05-16": 2,
          "2026-05-20": 7,
          "2026-05-21": 2,
          "2026-05-22": 5,
          "2026-05-25": 2,
          "2026-06-03": 7,
          "2026-06-05": 9,
          "2026-06-06": 4
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-10-01": 2,
            "2025-10-03": 1,
            "2025-10-06": 8,
            "2026-03-06": 2,
            "2026-03-10": 1,
            "2026-03-17": 1,
            "2026-03-20": 1,
            "2026-04-02": 2,
            "2026-04-09": 2,
            "2026-04-18": 2,
            "2026-05-07": 1,
            "2026-05-14": 3,
            "2026-05-20": 3,
            "2026-06-05": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 400,
          "tickets_per_day": {
            "2025-10-06": 1,
            "2025-10-14": 4,
            "2025-10-18": 4,
            "2025-11-04": 5,
            "2025-11-06": 1,
            "2025-11-12": 8,
            "2025-11-20": 4,
            "2025-11-30": 2,
            "2025-12-02": 2,
            "2025-12-03": 1,
            "2025-12-08": 1,
            "2025-12-09": 1,
            "2025-12-11": 1,
            "2025-12-19": 1,
            "2025-12-20": 1,
            "2025-12-22": 3,
            "2025-12-28": 2,
            "2025-12-29": 22,
            "2026-01-13": 1,
            "2026-01-16": 2,
            "2026-01-19": 1,
            "2026-01-21": 1,
            "2026-01-22": 1,
            "2026-01-26": 2,
            "2026-01-27": 1,
            "2026-02-04": 3,
            "2026-02-05": 4,
            "2026-02-06": 2,
            "2026-02-09": 4,
            "2026-02-10": 1,
            "2026-02-11": 2,
            "2026-02-12": 1,
            "2026-02-16": 4,
            "2026-02-17": 2,
            "2026-02-18": 6,
            "2026-02-19": 22,
            "2026-02-20": 7,
            "2026-02-24": 6,
            "2026-02-26": 2,
            "2026-03-02": 4,
            "2026-03-03": 1,
            "2026-03-04": 5,
            "2026-03-05": 3,
            "2026-03-10": 2,
            "2026-03-11": 6,
            "2026-03-12": 1,
            "2026-03-13": 9,
            "2026-03-16": 6,
            "2026-03-17": 7,
            "2026-03-19": 2,
            "2026-03-20": 28,
            "2026-03-21": 4,
            "2026-03-23": 1,
            "2026-03-24": 4,
            "2026-03-25": 5,
            "2026-03-27": 3,
            "2026-03-30": 2,
            "2026-03-31": 7,
            "2026-04-02": 19,
            "2026-04-08": 8,
            "2026-04-09": 2,
            "2026-04-10": 6,
            "2026-04-13": 7,
            "2026-04-14": 1,
            "2026-04-15": 4,
            "2026-04-17": 1,
            "2026-04-18": 14,
            "2026-04-20": 1,
            "2026-04-22": 1,
            "2026-04-23": 12,
            "2026-04-27": 4,
            "2026-04-28": 4,
            "2026-04-29": 5,
            "2026-04-30": 3,
            "2026-05-04": 2,
            "2026-05-06": 2,
            "2026-05-07": 7,
            "2026-05-08": 1,
            "2026-05-11": 6,
            "2026-05-12": 4,
            "2026-05-13": 9,
            "2026-05-14": 3,
            "2026-05-15": 2,
            "2026-05-16": 2,
            "2026-05-20": 4,
            "2026-05-21": 2,
            "2026-05-22": 5,
            "2026-05-25": 2,
            "2026-06-03": 7,
            "2026-06-05": 7,
            "2026-06-06": 4
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 48,
          "tickets_per_day": {
            "2025-10-18": 1,
            "2025-11-04": 2,
            "2025-11-08": 4,
            "2025-11-12": 1,
            "2025-11-13": 1,
            "2025-12-02": 1,
            "2025-12-19": 1,
            "2026-01-13": 2,
            "2026-01-26": 1,
            "2026-02-09": 1,
            "2026-02-16": 1,
            "2026-02-18": 5,
            "2026-02-19": 2,
            "2026-03-20": 6,
            "2026-03-27": 4,
            "2026-04-13": 1,
            "2026-04-23": 5,
            "2026-05-14": 9
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2025-12-03": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 4,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-05": 1,
            "2025-12-11": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Sandra Reis": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 1032,
        "tickets_per_day": {
          "2025-09-30": 15,
          "2025-10-01": 17,
          "2025-10-02": 3,
          "2025-10-03": 4,
          "2025-10-06": 30,
          "2025-10-07": 41,
          "2025-10-08": 22,
          "2025-10-09": 24,
          "2025-10-10": 37,
          "2025-10-13": 32,
          "2025-10-14": 34,
          "2025-10-15": 56,
          "2025-10-16": 12,
          "2025-10-20": 12,
          "2025-10-21": 13,
          "2025-10-22": 5,
          "2025-10-23": 67,
          "2025-10-24": 8,
          "2025-10-27": 19,
          "2025-10-28": 60,
          "2025-10-29": 40,
          "2025-10-30": 31,
          "2025-10-31": 12,
          "2025-11-03": 48,
          "2025-11-04": 9,
          "2025-11-05": 26,
          "2025-11-06": 20,
          "2025-11-07": 25,
          "2025-11-10": 7,
          "2025-11-11": 21,
          "2025-11-12": 6,
          "2025-11-13": 25,
          "2025-11-14": 30,
          "2025-11-17": 17,
          "2025-11-19": 19,
          "2025-11-20": 4,
          "2025-11-21": 10,
          "2025-11-22": 1,
          "2025-11-24": 2,
          "2025-11-27": 8,
          "2025-12-02": 31,
          "2025-12-03": 4,
          "2025-12-04": 6,
          "2025-12-05": 1,
          "2025-12-11": 9,
          "2025-12-12": 3,
          "2025-12-15": 32,
          "2025-12-17": 1,
          "2025-12-22": 3,
          "2025-12-23": 2,
          "2025-12-24": 3,
          "2025-12-26": 2,
          "2026-01-05": 1,
          "2026-01-06": 4,
          "2026-01-07": 1,
          "2026-01-08": 7,
          "2026-01-09": 8,
          "2026-01-13": 1,
          "2026-01-14": 2,
          "2026-01-16": 1,
          "2026-01-22": 2,
          "2026-01-23": 2,
          "2026-01-27": 1,
          "2026-01-29": 2,
          "2026-01-30": 1,
          "2026-02-03": 3,
          "2026-02-04": 1,
          "2026-02-05": 2,
          "2026-02-06": 1,
          "2026-02-09": 3,
          "2026-02-12": 16,
          "2026-02-13": 3,
          "2026-02-16": 1
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 26,
          "tickets_per_day": {
            "2025-10-06": 5,
            "2025-11-03": 9,
            "2025-11-04": 2,
            "2025-11-24": 2,
            "2026-01-08": 1,
            "2026-01-14": 2,
            "2026-01-22": 2,
            "2026-01-29": 1,
            "2026-01-30": 1,
            "2026-02-16": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 461,
          "tickets_per_day": {
            "2025-09-30": 1,
            "2025-10-01": 1,
            "2025-10-02": 2,
            "2025-10-03": 4,
            "2025-10-06": 4,
            "2025-10-07": 14,
            "2025-10-08": 18,
            "2025-10-09": 4,
            "2025-10-10": 21,
            "2025-10-13": 20,
            "2025-10-14": 26,
            "2025-10-15": 24,
            "2025-10-16": 8,
            "2025-10-20": 12,
            "2025-10-21": 10,
            "2025-10-22": 4,
            "2025-10-23": 29,
            "2025-10-24": 6,
            "2025-10-27": 5,
            "2025-10-28": 20,
            "2025-10-29": 39,
            "2025-10-30": 20,
            "2025-10-31": 12,
            "2025-11-03": 20,
            "2025-11-04": 5,
            "2025-11-05": 2,
            "2025-11-06": 6,
            "2025-11-07": 10,
            "2025-11-11": 21,
            "2025-11-12": 1,
            "2025-11-13": 16,
            "2025-11-14": 4,
            "2025-11-17": 10,
            "2025-11-19": 2,
            "2025-11-21": 9,
            "2025-11-27": 5,
            "2025-12-02": 1,
            "2025-12-04": 1,
            "2025-12-11": 9,
            "2025-12-15": 4,
            "2025-12-22": 3,
            "2025-12-24": 3,
            "2026-01-06": 2,
            "2026-01-08": 6,
            "2026-01-09": 4,
            "2026-01-27": 1,
            "2026-02-03": 2,
            "2026-02-05": 2,
            "2026-02-06": 1,
            "2026-02-12": 5,
            "2026-02-13": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 425,
          "tickets_per_day": {
            "2025-09-30": 14,
            "2025-10-01": 16,
            "2025-10-02": 1,
            "2025-10-06": 21,
            "2025-10-07": 19,
            "2025-10-08": 1,
            "2025-10-10": 7,
            "2025-10-13": 5,
            "2025-10-15": 25,
            "2025-10-16": 4,
            "2025-10-21": 1,
            "2025-10-23": 11,
            "2025-10-24": 2,
            "2025-10-27": 14,
            "2025-10-28": 39,
            "2025-10-30": 11,
            "2025-11-03": 19,
            "2025-11-04": 2,
            "2025-11-05": 21,
            "2025-11-06": 14,
            "2025-11-07": 15,
            "2025-11-12": 5,
            "2025-11-13": 9,
            "2025-11-14": 24,
            "2025-11-17": 7,
            "2025-11-19": 17,
            "2025-11-20": 4,
            "2025-11-21": 1,
            "2025-11-22": 1,
            "2025-11-27": 3,
            "2025-12-02": 29,
            "2025-12-03": 4,
            "2025-12-05": 1,
            "2025-12-15": 26,
            "2025-12-17": 1,
            "2025-12-23": 2,
            "2026-01-05": 1,
            "2026-01-06": 2,
            "2026-01-07": 1,
            "2026-01-09": 4,
            "2026-01-13": 1,
            "2026-01-16": 1,
            "2026-01-23": 1,
            "2026-01-29": 1,
            "2026-02-03": 1,
            "2026-02-04": 1,
            "2026-02-09": 3,
            "2026-02-12": 11,
            "2026-02-13": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 111,
          "tickets_per_day": {
            "2025-10-07": 8,
            "2025-10-08": 3,
            "2025-10-09": 20,
            "2025-10-10": 9,
            "2025-10-13": 7,
            "2025-10-14": 8,
            "2025-10-15": 7,
            "2025-10-21": 2,
            "2025-10-22": 1,
            "2025-10-23": 27,
            "2025-10-28": 1,
            "2025-10-29": 1,
            "2025-11-05": 3,
            "2025-11-10": 7,
            "2025-11-14": 2,
            "2025-12-04": 5
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 9,
          "tickets_per_day": {
            "2025-12-02": 1,
            "2025-12-12": 3,
            "2025-12-15": 2,
            "2025-12-26": 2,
            "2026-01-23": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Cátia Leal": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 843,
        "tickets_per_day": {
          "2025-10-08": 3,
          "2025-10-09": 15,
          "2025-10-13": 3,
          "2025-10-22": 5,
          "2025-10-23": 61,
          "2025-10-24": 1,
          "2025-10-27": 26,
          "2025-10-28": 10,
          "2025-10-29": 4,
          "2025-10-30": 35,
          "2025-10-31": 43,
          "2025-11-03": 29,
          "2025-11-04": 31,
          "2025-11-05": 11,
          "2025-11-06": 3,
          "2025-11-07": 9,
          "2025-11-10": 21,
          "2025-11-11": 6,
          "2025-11-12": 2,
          "2025-11-13": 4,
          "2025-11-14": 6,
          "2025-11-17": 3,
          "2025-11-18": 2,
          "2025-11-19": 3,
          "2025-11-20": 3,
          "2025-11-22": 2,
          "2025-11-24": 6,
          "2025-11-25": 3,
          "2025-11-26": 4,
          "2025-11-27": 4,
          "2025-11-28": 6,
          "2025-12-02": 11,
          "2025-12-03": 3,
          "2025-12-04": 13,
          "2025-12-05": 2,
          "2025-12-09": 1,
          "2025-12-10": 2,
          "2025-12-11": 16,
          "2025-12-12": 7,
          "2025-12-13": 1,
          "2025-12-17": 7,
          "2025-12-18": 3,
          "2025-12-19": 1,
          "2025-12-22": 3,
          "2025-12-23": 2,
          "2025-12-24": 4,
          "2025-12-26": 3,
          "2025-12-29": 10,
          "2025-12-30": 3,
          "2026-01-05": 5,
          "2026-01-06": 1,
          "2026-01-08": 1,
          "2026-01-12": 1,
          "2026-01-13": 10,
          "2026-01-14": 12,
          "2026-01-15": 1,
          "2026-01-16": 8,
          "2026-01-19": 1,
          "2026-01-20": 3,
          "2026-01-21": 4,
          "2026-01-23": 4,
          "2026-01-27": 7,
          "2026-01-29": 4,
          "2026-01-30": 6,
          "2026-02-02": 6,
          "2026-02-03": 6,
          "2026-02-04": 4,
          "2026-02-05": 2,
          "2026-02-09": 1,
          "2026-02-11": 1,
          "2026-02-12": 7,
          "2026-02-13": 2,
          "2026-02-18": 2,
          "2026-02-19": 7,
          "2026-02-20": 9,
          "2026-02-23": 2,
          "2026-02-25": 1,
          "2026-03-02": 1,
          "2026-03-03": 2,
          "2026-03-05": 5,
          "2026-03-06": 20,
          "2026-03-09": 5,
          "2026-03-10": 2,
          "2026-03-11": 14,
          "2026-03-12": 5,
          "2026-03-13": 5,
          "2026-03-16": 19,
          "2026-03-17": 20,
          "2026-03-19": 4,
          "2026-03-20": 44,
          "2026-03-23": 1,
          "2026-03-24": 7,
          "2026-03-25": 3,
          "2026-03-26": 1,
          "2026-03-27": 2,
          "2026-03-31": 1,
          "2026-04-01": 4,
          "2026-04-02": 3,
          "2026-04-07": 11,
          "2026-04-09": 6,
          "2026-04-10": 19,
          "2026-04-14": 2,
          "2026-04-15": 3,
          "2026-04-16": 5,
          "2026-04-17": 3,
          "2026-04-22": 2,
          "2026-04-27": 1,
          "2026-04-29": 1,
          "2026-04-30": 1,
          "2026-05-05": 3,
          "2026-05-06": 13,
          "2026-05-10": 2,
          "2026-05-11": 2,
          "2026-05-12": 3,
          "2026-05-13": 1,
          "2026-05-14": 2,
          "2026-05-18": 2,
          "2026-05-19": 3,
          "2026-05-21": 7,
          "2026-05-22": 3,
          "2026-05-25": 2,
          "2026-05-26": 1,
          "2026-05-28": 1,
          "2026-06-03": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 178,
          "tickets_per_day": {
            "2025-10-27": 2,
            "2025-10-29": 2,
            "2025-10-30": 7,
            "2025-10-31": 4,
            "2025-11-03": 14,
            "2025-11-04": 22,
            "2025-11-11": 5,
            "2025-11-13": 1,
            "2025-11-14": 1,
            "2025-11-18": 1,
            "2025-11-19": 2,
            "2025-11-20": 2,
            "2025-11-24": 2,
            "2025-11-26": 1,
            "2025-11-27": 1,
            "2025-11-28": 2,
            "2025-12-03": 2,
            "2025-12-04": 1,
            "2025-12-05": 1,
            "2025-12-10": 1,
            "2025-12-11": 2,
            "2025-12-22": 1,
            "2026-01-12": 1,
            "2026-01-13": 1,
            "2026-01-23": 3,
            "2026-01-27": 1,
            "2026-01-30": 4,
            "2026-02-02": 6,
            "2026-02-03": 4,
            "2026-02-05": 2,
            "2026-02-18": 1,
            "2026-02-20": 8,
            "2026-03-02": 1,
            "2026-03-05": 1,
            "2026-03-09": 4,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-03-16": 19,
            "2026-03-17": 3,
            "2026-03-20": 2,
            "2026-03-24": 3,
            "2026-03-26": 1,
            "2026-03-27": 2,
            "2026-04-09": 2,
            "2026-04-14": 2,
            "2026-04-15": 1,
            "2026-04-17": 3,
            "2026-04-22": 2,
            "2026-04-27": 1,
            "2026-04-29": 1,
            "2026-04-30": 1,
            "2026-05-05": 1,
            "2026-05-06": 3,
            "2026-05-11": 2,
            "2026-05-14": 2,
            "2026-05-19": 3,
            "2026-05-21": 2,
            "2026-05-25": 2,
            "2026-05-26": 1,
            "2026-05-28": 1,
            "2026-06-03": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 467,
          "tickets_per_day": {
            "2025-10-08": 3,
            "2025-10-09": 15,
            "2025-10-22": 5,
            "2025-10-23": 7,
            "2025-10-24": 1,
            "2025-10-27": 24,
            "2025-10-28": 10,
            "2025-10-29": 2,
            "2025-10-30": 28,
            "2025-10-31": 39,
            "2025-11-03": 15,
            "2025-11-04": 4,
            "2025-11-05": 10,
            "2025-11-06": 3,
            "2025-11-07": 9,
            "2025-11-10": 9,
            "2025-11-11": 1,
            "2025-11-13": 1,
            "2025-11-14": 3,
            "2025-11-17": 1,
            "2025-11-18": 1,
            "2025-11-19": 1,
            "2025-11-22": 1,
            "2025-11-24": 3,
            "2025-11-27": 1,
            "2025-11-28": 1,
            "2025-12-02": 8,
            "2025-12-04": 4,
            "2025-12-05": 1,
            "2025-12-12": 5,
            "2025-12-17": 7,
            "2025-12-18": 1,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-26": 1,
            "2025-12-29": 6,
            "2025-12-30": 2,
            "2026-01-05": 5,
            "2026-01-06": 1,
            "2026-01-13": 7,
            "2026-01-14": 3,
            "2026-01-15": 1,
            "2026-01-20": 3,
            "2026-01-21": 4,
            "2026-01-23": 1,
            "2026-01-27": 1,
            "2026-01-29": 3,
            "2026-02-03": 2,
            "2026-02-04": 3,
            "2026-02-09": 1,
            "2026-02-12": 7,
            "2026-02-13": 2,
            "2026-02-19": 7,
            "2026-02-20": 1,
            "2026-02-23": 2,
            "2026-02-25": 1,
            "2026-03-03": 2,
            "2026-03-05": 4,
            "2026-03-06": 12,
            "2026-03-09": 1,
            "2026-03-10": 2,
            "2026-03-11": 13,
            "2026-03-12": 4,
            "2026-03-13": 4,
            "2026-03-17": 15,
            "2026-03-19": 4,
            "2026-03-20": 40,
            "2026-03-23": 1,
            "2026-03-24": 4,
            "2026-03-25": 2,
            "2026-03-31": 1,
            "2026-04-01": 4,
            "2026-04-02": 3,
            "2026-04-07": 11,
            "2026-04-09": 4,
            "2026-04-10": 16,
            "2026-04-15": 2,
            "2026-04-16": 5,
            "2026-05-05": 2,
            "2026-05-06": 7,
            "2026-05-12": 3,
            "2026-05-13": 1,
            "2026-05-18": 2,
            "2026-05-21": 5,
            "2026-05-22": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 197,
          "tickets_per_day": {
            "2025-10-13": 3,
            "2025-10-23": 54,
            "2025-11-04": 5,
            "2025-11-05": 1,
            "2025-11-10": 12,
            "2025-11-12": 2,
            "2025-11-13": 2,
            "2025-11-14": 2,
            "2025-11-17": 2,
            "2025-11-20": 1,
            "2025-11-22": 1,
            "2025-11-24": 1,
            "2025-11-25": 3,
            "2025-11-26": 3,
            "2025-11-27": 2,
            "2025-11-28": 3,
            "2025-12-02": 3,
            "2025-12-03": 1,
            "2025-12-04": 8,
            "2025-12-09": 1,
            "2025-12-10": 1,
            "2025-12-11": 14,
            "2025-12-12": 2,
            "2025-12-13": 1,
            "2025-12-18": 2,
            "2025-12-19": 1,
            "2025-12-22": 1,
            "2025-12-23": 1,
            "2025-12-24": 4,
            "2025-12-26": 2,
            "2025-12-29": 4,
            "2025-12-30": 1,
            "2026-01-08": 1,
            "2026-01-13": 2,
            "2026-01-14": 9,
            "2026-01-16": 8,
            "2026-01-19": 1,
            "2026-01-27": 4,
            "2026-01-29": 1,
            "2026-01-30": 2,
            "2026-02-04": 1,
            "2026-02-11": 1,
            "2026-02-18": 1,
            "2026-03-06": 8,
            "2026-03-11": 1,
            "2026-03-17": 2,
            "2026-03-20": 2,
            "2026-03-25": 1,
            "2026-04-10": 3,
            "2026-05-06": 3,
            "2026-05-10": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-01-27": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Carolina Ferreirinha": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 154,
        "tickets_per_day": {
          "2025-11-04": 1,
          "2025-11-06": 1,
          "2025-11-14": 4,
          "2025-12-10": 1,
          "2026-01-07": 4,
          "2026-01-08": 4,
          "2026-01-09": 3,
          "2026-01-11": 3,
          "2026-01-13": 3,
          "2026-01-14": 1,
          "2026-01-15": 31,
          "2026-01-19": 5,
          "2026-01-22": 7,
          "2026-01-27": 3,
          "2026-01-28": 1,
          "2026-02-03": 1,
          "2026-02-09": 3,
          "2026-02-10": 3,
          "2026-02-17": 3,
          "2026-02-18": 1,
          "2026-02-21": 1,
          "2026-02-24": 1,
          "2026-03-05": 5,
          "2026-03-06": 6,
          "2026-03-07": 1,
          "2026-03-10": 1,
          "2026-03-11": 5,
          "2026-03-23": 6,
          "2026-03-24": 2,
          "2026-03-30": 1,
          "2026-03-31": 9,
          "2026-04-01": 1,
          "2026-04-16": 10,
          "2026-04-20": 4,
          "2026-04-22": 1,
          "2026-04-29": 6,
          "2026-05-04": 4,
          "2026-05-07": 2,
          "2026-05-14": 2,
          "2026-05-22": 3
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 9,
          "tickets_per_day": {
            "2026-02-10": 1,
            "2026-02-18": 1,
            "2026-03-23": 1,
            "2026-04-29": 2,
            "2026-05-04": 4
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 55,
          "tickets_per_day": {
            "2025-11-04": 1,
            "2025-11-14": 4,
            "2026-01-07": 1,
            "2026-01-09": 3,
            "2026-01-11": 2,
            "2026-01-14": 1,
            "2026-01-22": 2,
            "2026-02-09": 2,
            "2026-02-10": 1,
            "2026-02-17": 1,
            "2026-02-21": 1,
            "2026-02-24": 1,
            "2026-03-05": 4,
            "2026-03-06": 6,
            "2026-03-07": 1,
            "2026-03-10": 1,
            "2026-03-11": 5,
            "2026-03-24": 2,
            "2026-03-31": 5,
            "2026-04-01": 1,
            "2026-04-20": 2,
            "2026-04-29": 1,
            "2026-05-07": 2,
            "2026-05-14": 2,
            "2026-05-22": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 90,
          "tickets_per_day": {
            "2025-11-06": 1,
            "2025-12-10": 1,
            "2026-01-07": 3,
            "2026-01-08": 4,
            "2026-01-11": 1,
            "2026-01-13": 3,
            "2026-01-15": 31,
            "2026-01-19": 5,
            "2026-01-22": 5,
            "2026-01-27": 3,
            "2026-01-28": 1,
            "2026-02-03": 1,
            "2026-02-09": 1,
            "2026-02-10": 1,
            "2026-02-17": 2,
            "2026-03-05": 1,
            "2026-03-23": 5,
            "2026-03-30": 1,
            "2026-03-31": 4,
            "2026-04-16": 10,
            "2026-04-20": 2,
            "2026-04-22": 1,
            "2026-04-29": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Rafaela Lapa": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 63,
        "tickets_per_day": {
          "2025-10-06": 3,
          "2025-10-12": 2,
          "2025-10-13": 25,
          "2025-10-20": 2,
          "2025-10-21": 6,
          "2025-10-22": 1,
          "2025-10-24": 1,
          "2025-10-27": 1,
          "2025-10-28": 6,
          "2025-11-03": 2,
          "2025-11-17": 3,
          "2025-11-24": 5,
          "2025-12-08": 1,
          "2025-12-09": 1,
          "2025-12-12": 4
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 20,
          "tickets_per_day": {
            "2025-10-13": 18,
            "2025-10-28": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 31,
          "tickets_per_day": {
            "2025-10-06": 3,
            "2025-10-13": 7,
            "2025-10-20": 2,
            "2025-10-21": 6,
            "2025-10-22": 1,
            "2025-10-24": 1,
            "2025-10-27": 1,
            "2025-10-28": 4,
            "2025-11-03": 2,
            "2025-11-17": 2,
            "2025-12-08": 1,
            "2025-12-09": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 12,
          "tickets_per_day": {
            "2025-10-12": 2,
            "2025-11-17": 1,
            "2025-11-24": 5,
            "2025-12-12": 4
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Débora Pinto": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 373,
        "tickets_per_day": {
          "2025-12-04": 23,
          "2026-01-14": 4,
          "2026-02-11": 1,
          "2026-02-12": 2,
          "2026-02-13": 8,
          "2026-02-18": 30,
          "2026-02-19": 9,
          "2026-02-21": 6,
          "2026-02-24": 1,
          "2026-02-25": 1,
          "2026-02-27": 4,
          "2026-02-28": 9,
          "2026-03-03": 2,
          "2026-03-04": 3,
          "2026-03-05": 3,
          "2026-03-06": 3,
          "2026-03-07": 1,
          "2026-03-08": 1,
          "2026-03-09": 1,
          "2026-03-10": 4,
          "2026-03-11": 2,
          "2026-03-12": 9,
          "2026-03-13": 4,
          "2026-03-14": 3,
          "2026-03-16": 1,
          "2026-03-17": 5,
          "2026-03-19": 4,
          "2026-03-20": 20,
          "2026-03-24": 6,
          "2026-03-25": 1,
          "2026-03-26": 5,
          "2026-03-27": 1,
          "2026-03-28": 3,
          "2026-03-31": 2,
          "2026-04-01": 3,
          "2026-04-04": 1,
          "2026-04-07": 4,
          "2026-04-10": 13,
          "2026-04-11": 6,
          "2026-04-14": 6,
          "2026-04-15": 10,
          "2026-04-16": 29,
          "2026-04-17": 19,
          "2026-04-20": 5,
          "2026-04-21": 5,
          "2026-04-22": 10,
          "2026-04-23": 3,
          "2026-04-24": 4,
          "2026-04-27": 3,
          "2026-04-28": 1,
          "2026-04-29": 4,
          "2026-04-30": 1,
          "2026-05-04": 3,
          "2026-05-05": 4,
          "2026-05-06": 7,
          "2026-05-07": 6,
          "2026-05-09": 1,
          "2026-05-21": 1,
          "2026-05-22": 14,
          "2026-05-23": 5,
          "2026-05-25": 5,
          "2026-05-26": 4,
          "2026-05-27": 2,
          "2026-05-29": 1,
          "2026-06-02": 3,
          "2026-06-03": 6,
          "2026-06-08": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 68,
          "tickets_per_day": {
            "2026-01-14": 4,
            "2026-02-13": 6,
            "2026-02-28": 4,
            "2026-03-03": 1,
            "2026-03-14": 1,
            "2026-03-20": 9,
            "2026-03-24": 4,
            "2026-04-07": 2,
            "2026-04-10": 6,
            "2026-04-11": 2,
            "2026-04-15": 5,
            "2026-04-17": 10,
            "2026-04-21": 4,
            "2026-05-04": 1,
            "2026-05-23": 4,
            "2026-05-25": 4,
            "2026-05-26": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 273,
          "tickets_per_day": {
            "2025-12-04": 23,
            "2026-02-11": 1,
            "2026-02-18": 11,
            "2026-02-19": 3,
            "2026-02-21": 6,
            "2026-02-24": 1,
            "2026-02-25": 1,
            "2026-02-27": 4,
            "2026-02-28": 5,
            "2026-03-03": 1,
            "2026-03-04": 3,
            "2026-03-05": 3,
            "2026-03-06": 3,
            "2026-03-07": 1,
            "2026-03-08": 1,
            "2026-03-09": 1,
            "2026-03-10": 4,
            "2026-03-11": 2,
            "2026-03-12": 9,
            "2026-03-13": 4,
            "2026-03-14": 2,
            "2026-03-16": 1,
            "2026-03-17": 5,
            "2026-03-19": 4,
            "2026-03-20": 10,
            "2026-03-24": 2,
            "2026-03-25": 1,
            "2026-03-26": 5,
            "2026-03-28": 3,
            "2026-03-31": 2,
            "2026-04-01": 3,
            "2026-04-04": 1,
            "2026-04-07": 2,
            "2026-04-10": 7,
            "2026-04-11": 4,
            "2026-04-14": 6,
            "2026-04-15": 5,
            "2026-04-16": 29,
            "2026-04-17": 9,
            "2026-04-20": 4,
            "2026-04-21": 1,
            "2026-04-22": 10,
            "2026-04-23": 3,
            "2026-04-24": 4,
            "2026-04-27": 3,
            "2026-04-28": 1,
            "2026-04-29": 4,
            "2026-04-30": 1,
            "2026-05-04": 2,
            "2026-05-05": 4,
            "2026-05-06": 7,
            "2026-05-07": 6,
            "2026-05-09": 1,
            "2026-05-21": 1,
            "2026-05-22": 14,
            "2026-05-23": 1,
            "2026-05-25": 1,
            "2026-05-26": 3,
            "2026-05-27": 2,
            "2026-05-29": 1,
            "2026-06-02": 3,
            "2026-06-03": 6,
            "2026-06-08": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 28,
          "tickets_per_day": {
            "2026-02-12": 2,
            "2026-02-13": 2,
            "2026-02-18": 19,
            "2026-02-19": 3,
            "2026-03-27": 1,
            "2026-04-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2026-03-20": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 3,
          "tickets_per_day": {
            "2026-02-19": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Marta Oliveira": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 21,
        "tickets_per_day": {
          "2025-12-22": 3,
          "2025-12-26": 5,
          "2025-12-31": 11,
          "2026-01-09": 2
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-22": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 1,
          "tickets_per_day": {
            "2025-12-22": 1
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem Formulário": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 2,
          "tickets_per_day": {
            "2025-12-26": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "Reservas sem pedido RGPD e CVO": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 16,
          "tickets_per_day": {
            "2025-12-26": 3,
            "2025-12-31": 11,
            "2026-01-09": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    },
    "Margarida Janeiro": {
      "overall": {
        "avg_time_hours": null,
        "mode_time_hours": null,
        "mode_frequency": null,
        "time_distribution": {},
        "tickets_count": 109,
        "tickets_per_day": {
          "2026-01-23": 1,
          "2026-03-10": 2,
          "2026-03-11": 1,
          "2026-03-12": 2,
          "2026-03-13": 1,
          "2026-03-16": 2,
          "2026-03-19": 3,
          "2026-03-20": 2,
          "2026-03-23": 2,
          "2026-03-24": 3,
          "2026-03-25": 1,
          "2026-03-26": 6,
          "2026-03-31": 4,
          "2026-04-01": 1,
          "2026-04-10": 1,
          "2026-04-13": 4,
          "2026-04-14": 3,
          "2026-04-15": 1,
          "2026-04-18": 4,
          "2026-04-21": 1,
          "2026-04-22": 2,
          "2026-04-23": 13,
          "2026-04-29": 1,
          "2026-04-30": 4,
          "2026-05-06": 2,
          "2026-05-07": 3,
          "2026-05-08": 2,
          "2026-05-11": 2,
          "2026-05-12": 1,
          "2026-05-13": 1,
          "2026-05-18": 1,
          "2026-05-19": 2,
          "2026-05-20": 1,
          "2026-05-25": 3,
          "2026-05-27": 10,
          "2026-05-30": 5,
          "2026-06-01": 3,
          "2026-06-02": 4,
          "2026-06-03": 1,
          "2026-06-04": 3
        },
        "time_per_day": {},
        "time_count_per_day": {}
      },
      "priorities": {
        "P1": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 10,
          "tickets_per_day": {
            "2026-05-06": 1,
            "2026-05-19": 2,
            "2026-05-27": 1,
            "2026-05-30": 2,
            "2026-06-01": 2,
            "2026-06-02": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P2": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 92,
          "tickets_per_day": {
            "2026-01-23": 1,
            "2026-03-12": 1,
            "2026-03-16": 2,
            "2026-03-19": 3,
            "2026-03-20": 2,
            "2026-03-23": 2,
            "2026-03-24": 3,
            "2026-03-25": 1,
            "2026-03-26": 6,
            "2026-03-31": 4,
            "2026-04-01": 1,
            "2026-04-10": 1,
            "2026-04-13": 4,
            "2026-04-14": 3,
            "2026-04-15": 1,
            "2026-04-18": 4,
            "2026-04-21": 1,
            "2026-04-22": 2,
            "2026-04-23": 11,
            "2026-04-29": 1,
            "2026-04-30": 4,
            "2026-05-06": 1,
            "2026-05-07": 3,
            "2026-05-08": 2,
            "2026-05-11": 2,
            "2026-05-12": 1,
            "2026-05-13": 1,
            "2026-05-18": 1,
            "2026-05-20": 1,
            "2026-05-25": 3,
            "2026-05-27": 9,
            "2026-05-30": 3,
            "2026-06-01": 1,
            "2026-06-02": 2,
            "2026-06-03": 1,
            "2026-06-04": 3
          },
          "time_per_day": {},
          "time_count_per_day": {}
        },
        "P3": {
          "avg_time_hours": null,
          "mode_time_hours": null,
          "mode_frequency": null,
          "time_distribution": {},
          "tickets_count": 7,
          "tickets_per_day": {
            "2026-03-10": 2,
            "2026-03-11": 1,
            "2026-03-12": 1,
            "2026-03-13": 1,
            "2026-04-23": 2
          },
          "time_per_day": {},
          "time_count_per_day": {}
        }
      }
    }
  },
  "agent_active_time": {},
  "sla_analysis": {
    "sla_targets": {
      "1": {
        "name": "SLA P1",
        "first_response_time_minutes": 15,
        "update_time_minutes": null,
        "solution_time_minutes": null,
        "first_response_time_hours": 0.25,
        "update_time_hours": null,
        "solution_time_hours": null
      },
      "2": {
        "name": "SLA P2",
        "first_response_time_minutes": 240,
        "update_time_minutes": null,
        "solution_time_minutes": null,
        "first_response_time_hours": 4.0,
        "update_time_hours": null,
        "solution_time_hours": null
      },
      "3": {
        "name": "SLA P3",
        "first_response_time_minutes": 1440,
        "update_time_minutes": null,
        "solution_time_minutes": null,
        "first_response_time_hours": 24.0,
        "update_time_hours": null,
        "solution_time_hours": null
      },
      "5": {
        "name": "Reservas sem formulário",
        "first_response_time_minutes": 1440,
        "update_time_minutes": null,
        "solution_time_minutes": null,
        "first_response_time_hours": 24.0,
        "update_time_hours": null,
        "solution_time_hours": null
      }
    },
    "agent_sla_compliance": {
      "Inês Martinho": {
        "total_tickets": 2135,
        "sla_met": 1866,
        "sla_missed": 269,
        "sla_compliance_rate": 87.4,
        "tickets": [
          {
            "ticket_id": 30,
            "ticket_number": "35030",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P1",
            "created_at": "30/09/2025 09:06:25",
            "close_date": "2025-09-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.2,
            "sla_met": false,
            "sla_breach_hours": 0.95,
            "sla_name": "SLA P1",
            "first_response_at": "30/09/2025 10:18:52"
          },
          {
            "ticket_id": 31,
            "ticket_number": "35031",
            "title": "Re: booking for Mr JOSE DIOGO ALVES BARREIRA COELH",
            "priority": "P3",
            "created_at": "30/09/2025 09:06:29",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 09:25:46"
          },
          {
            "ticket_id": 35,
            "ticket_number": "35035",
            "title": "Dúvida urgente para Insure Broker",
            "priority": "P1",
            "created_at": "30/09/2025 09:06:44",
            "close_date": "2025-09-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "30/09/2025 09:06:44"
          },
          {
            "ticket_id": 37,
            "ticket_number": "35037",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P1",
            "created_at": "30/09/2025 09:06:47",
            "close_date": "2025-09-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.23,
            "sla_met": false,
            "sla_breach_hours": 0.98,
            "sla_name": "SLA P1",
            "first_response_at": "30/09/2025 10:21:02"
          },
          {
            "ticket_id": 47,
            "ticket_number": "35047",
            "title": "CARVALHO MACIEL/DIOGO MIGUEL MR 28JAN2026 OPO ORY",
            "priority": "P3",
            "created_at": "30/09/2025 09:26:52",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 10:40:07"
          },
          {
            "ticket_id": 58,
            "ticket_number": "35058",
            "title": "GBN-67038 - Esclarecimento",
            "priority": "P2",
            "created_at": "30/09/2025 11:50:07",
            "close_date": "2025-10-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 11:50:07"
          },
          {
            "ticket_id": 59,
            "ticket_number": "35059",
            "title": "YRQ924 – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "30/09/2025 12:19:48",
            "close_date": "2025-09-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "30/09/2025 12:24:17"
          },
          {
            "ticket_id": 60,
            "ticket_number": "35060",
            "title": "Reserva Aérea YRQ924",
            "priority": "P3",
            "created_at": "30/09/2025 12:19:50",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 12:24:45"
          },
          {
            "ticket_id": 64,
            "ticket_number": "35064",
            "title": "Re: reclamaçao localizador 1197609791",
            "priority": "P3",
            "created_at": "30/09/2025 13:55:04",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 19.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 09:07:16"
          },
          {
            "ticket_id": 68,
            "ticket_number": "35067",
            "title": "Re: Fwd: Documentação recebida corretamente TTN-11",
            "priority": "P3",
            "created_at": "30/09/2025 14:49:01",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 14:49:01"
          },
          {
            "ticket_id": 78,
            "ticket_number": "35077",
            "title": "Smy - Voo cancelado ryanair",
            "priority": "P3",
            "created_at": "30/09/2025 16:01:09",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 16:01:10"
          },
          {
            "ticket_id": 84,
            "ticket_number": "35083",
            "title": "Aéreo - Confirmação de Emissão (GARCIA DA SILVA\\AN",
            "priority": "P2",
            "created_at": "30/09/2025 17:15:59",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 17:21:17"
          },
          {
            "ticket_id": 85,
            "ticket_number": "35084",
            "title": "Aéreo - Confirmação de Emissão (ALVES BARREIRA COE",
            "priority": "P2",
            "created_at": "30/09/2025 17:16:01",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 17:22:08"
          },
          {
            "ticket_id": 94,
            "ticket_number": "35093",
            "title": "Esclarecimento - seguro",
            "priority": "P2",
            "created_at": "30/09/2025 21:30:05",
            "close_date": "2025-10-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 21:30:05"
          },
          {
            "ticket_id": 103,
            "ticket_number": "35102",
            "title": "CCP-71279 Reserva SPT002501543712",
            "priority": "P2",
            "created_at": "01/10/2025 11:35:56",
            "close_date": "2025-10-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 11:37:38"
          },
          {
            "ticket_id": 108,
            "ticket_number": "35107",
            "title": "ENC: Grupo GR-E350FBF43F",
            "priority": "P2",
            "created_at": "01/10/2025 12:40:56",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 12:40:56"
          },
          {
            "ticket_id": 109,
            "ticket_number": "35108",
            "title": "Re:[## 19431 ##] GBN-49195 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "01/10/2025 13:24:23",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 123.47,
            "sla_met": false,
            "sla_breach_hours": 99.47,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 16:52:44"
          },
          {
            "ticket_id": 117,
            "ticket_number": "35116",
            "title": "Urgente - Excursão GBN",
            "priority": "P3",
            "created_at": "01/10/2025 15:13:10",
            "close_date": "2025-10-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 15:13:10"
          },
          {
            "ticket_id": 118,
            "ticket_number": "35117",
            "title": "RESERVA REALIZADA PENDENTE DE CONFIRMAÇÃO: 3925065",
            "priority": "P3",
            "created_at": "01/10/2025 15:29:09",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 26.47,
            "sla_met": false,
            "sla_breach_hours": 2.47,
            "sla_name": "SLA P3",
            "first_response_at": "02/10/2025 17:57:28"
          },
          {
            "ticket_id": 135,
            "ticket_number": "35134",
            "title": "RE: [OUTSIDE EMAIL] esclarecimento idade crianças",
            "priority": "P2",
            "created_at": "02/10/2025 09:44:14",
            "close_date": "2025-10-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 09:52:49"
          },
          {
            "ticket_id": 153,
            "ticket_number": "35152",
            "title": "Cotação RimainTours",
            "priority": "P3",
            "created_at": "02/10/2025 14:36:05",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/10/2025 14:36:05"
          },
          {
            "ticket_id": 158,
            "ticket_number": "35157",
            "title": "Reserva Aérea ZCLZPN",
            "priority": "P2",
            "created_at": "02/10/2025 17:20:43",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 17:20:43"
          },
          {
            "ticket_id": 165,
            "ticket_number": "35164",
            "title": "Orçamento disneyland - leplan",
            "priority": "P3",
            "created_at": "03/10/2025 09:22:54",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 09:22:54"
          },
          {
            "ticket_id": 178,
            "ticket_number": "35177",
            "title": "Mensagem sobre a reserva 34347903 - Civitatis",
            "priority": "P3",
            "created_at": "03/10/2025 11:13:55",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 70.67,
            "sla_met": false,
            "sla_breach_hours": 46.67,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 09:54:30"
          },
          {
            "ticket_id": 182,
            "ticket_number": "35181",
            "title": "pacote dubai",
            "priority": "P3",
            "created_at": "03/10/2025 12:24:20",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 12:24:20"
          },
          {
            "ticket_id": 199,
            "ticket_number": "35198",
            "title": "Confirmation of booking with locatorG0Y20UGS",
            "priority": "P3",
            "created_at": "06/10/2025 09:10:29",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 25.08,
            "sla_met": false,
            "sla_breach_hours": 1.08,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 10:15:50"
          },
          {
            "ticket_id": 217,
            "ticket_number": "35216",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P3",
            "created_at": "06/10/2025 09:57:14",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 11:45:17"
          },
          {
            "ticket_id": 224,
            "ticket_number": "35223",
            "title": "Reserva 6114915 - NEW BLUE",
            "priority": "P3",
            "created_at": "06/10/2025 10:08:14",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 10:08:14"
          },
          {
            "ticket_id": 225,
            "ticket_number": "35224",
            "title": "Re: Fwd: [## 17460 ##] GBN-75892 - Seu pedido foi ",
            "priority": "P2",
            "created_at": "06/10/2025 10:09:19",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 10:09:19"
          },
          {
            "ticket_id": 226,
            "ticket_number": "35225",
            "title": "Fwd: Italo Informa: notifica indennizzo",
            "priority": "P3",
            "created_at": "06/10/2025 10:09:52",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 10:09:53"
          },
          {
            "ticket_id": 242,
            "ticket_number": "35241",
            "title": "Fwd: Confirmação do serviço de transporte//1125356",
            "priority": "P3",
            "created_at": "06/10/2025 11:52:02",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 11:52:02"
          },
          {
            "ticket_id": 248,
            "ticket_number": "35247",
            "title": "\"GBN-81115 - Your request has been received\"",
            "priority": "P1",
            "created_at": "06/10/2025 14:31:04",
            "close_date": "2025-10-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/10/2025 10:04:20"
          },
          {
            "ticket_id": 277,
            "ticket_number": "35276",
            "title": "Envio de documentação - FILE 395745",
            "priority": "P2",
            "created_at": "06/10/2025 22:55:09",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 11.3,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 10:13:57"
          },
          {
            "ticket_id": 281,
            "ticket_number": "35280",
            "title": "Fwd: Nova Viagem #251000039 - Sónia Susano - GBN-8",
            "priority": "P3",
            "created_at": "07/10/2025 09:06:24",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 09:06:24"
          },
          {
            "ticket_id": 286,
            "ticket_number": "35285",
            "title": "Envio dos nomes para o Grupo GR-0CE002ABEB_GRUPO_A",
            "priority": "P3",
            "created_at": "07/10/2025 09:09:45",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 11:22:02"
          },
          {
            "ticket_id": 289,
            "ticket_number": "35288",
            "title": "VJT: Documentação de Viagem  201833 (Voo Regular)",
            "priority": "P2",
            "created_at": "07/10/2025 10:31:17",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 11:27:59"
          },
          {
            "ticket_id": 306,
            "ticket_number": "35305",
            "title": "GBN-84913 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/10/2025 13:16:33",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 15:45:38"
          },
          {
            "ticket_id": 307,
            "ticket_number": "35306",
            "title": "Re:[## 22427 ##] GBN-84913 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "07/10/2025 13:38:23",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 45.83,
            "sla_met": false,
            "sla_breach_hours": 41.83,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 11:29:04"
          },
          {
            "ticket_id": 308,
            "ticket_number": "35307",
            "title": "Re:[## 22427 ##] GBN-84913 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "07/10/2025 13:38:57",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 13:39:28"
          },
          {
            "ticket_id": 316,
            "ticket_number": "35315",
            "title": "Re: Envio documentos - (Factura-238003284) n. 8004",
            "priority": "P2",
            "created_at": "07/10/2025 17:02:55",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 17:04:32"
          },
          {
            "ticket_id": 319,
            "ticket_number": "35318",
            "title": "Loc: 1208029207 - solicitação cliente",
            "priority": "P3",
            "created_at": "07/10/2025 17:20:53",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 17:20:53"
          },
          {
            "ticket_id": 337,
            "ticket_number": "35336",
            "title": "Mudança seguro",
            "priority": "P3",
            "created_at": "07/10/2025 22:42:40",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 22:42:40"
          },
          {
            "ticket_id": 340,
            "ticket_number": "35339",
            "title": "GBN-85045 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "07/10/2025 23:13:22",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 23:13:22"
          },
          {
            "ticket_id": 341,
            "ticket_number": "35340",
            "title": "Número de informação da reserva: 6119302",
            "priority": "P1",
            "created_at": "07/10/2025 23:13:24",
            "close_date": "2025-10-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.38,
            "sla_met": false,
            "sla_breach_hours": 0.13,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 23:37:10"
          },
          {
            "ticket_id": 346,
            "ticket_number": "35345",
            "title": "Cancelamento de trechos de voo na reserva YCQ94G /",
            "priority": "P2",
            "created_at": "08/10/2025 09:11:16",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:13:01"
          },
          {
            "ticket_id": 348,
            "ticket_number": "35347",
            "title": "Informação sobre reserva Flexible PP661699",
            "priority": "P3",
            "created_at": "08/10/2025 09:25:18",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 09:25:19"
          },
          {
            "ticket_id": 352,
            "ticket_number": "35351",
            "title": "Fwd: TUI Portugal: Confirmação de reserva - TCP-51",
            "priority": "P3",
            "created_at": "08/10/2025 09:31:00",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 09:31:03"
          },
          {
            "ticket_id": 354,
            "ticket_number": "35353",
            "title": "Informação importante sobre a tua reserva 1743831",
            "priority": "P3",
            "created_at": "08/10/2025 09:50:40",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 11:18:15"
          },
          {
            "ticket_id": 368,
            "ticket_number": "35367",
            "title": "Flexible Autos - Automatic response",
            "priority": "P3",
            "created_at": "08/10/2025 10:44:00",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 11:15:02"
          },
          {
            "ticket_id": 369,
            "ticket_number": "35368",
            "title": "Flexible Autos - Automatic response",
            "priority": "P3",
            "created_at": "08/10/2025 10:44:02",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 11:15:15"
          },
          {
            "ticket_id": 386,
            "ticket_number": "35385",
            "title": "GBN-85056 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "08/10/2025 14:12:18",
            "close_date": "2025-10-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.22,
            "sla_met": false,
            "sla_breach_hours": 4.97,
            "sla_name": "SLA P1",
            "first_response_at": "08/10/2025 19:25:54"
          },
          {
            "ticket_id": 389,
            "ticket_number": "35388",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "08/10/2025 14:12:24",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 14:19:18"
          },
          {
            "ticket_id": 394,
            "ticket_number": "35393",
            "title": "Re: FW: Opti 249100031-Eduardo Pereira",
            "priority": "P3",
            "created_at": "08/10/2025 14:46:47",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 14:46:47"
          },
          {
            "ticket_id": 427,
            "ticket_number": "35426",
            "title": "GBN-84719 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "09/10/2025 09:07:35",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 4.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 14:07:11"
          },
          {
            "ticket_id": 452,
            "ticket_number": "35451",
            "title": "Fwd: Informações da reserva TTN-1208029207#8335137",
            "priority": "P2",
            "created_at": "09/10/2025 16:05:25",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 16:05:26"
          },
          {
            "ticket_id": 472,
            "ticket_number": "35471",
            "title": "Orçamento para Bayahibe Jan/26",
            "priority": "P3",
            "created_at": "10/10/2025 09:06:55",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 09:06:55"
          },
          {
            "ticket_id": 484,
            "ticket_number": "35483",
            "title": "RE: GBN - 66538",
            "priority": "P2",
            "created_at": "10/10/2025 10:49:04",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 11:09:25"
          },
          {
            "ticket_id": 490,
            "ticket_number": "35489",
            "title": "GBN-85381 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 13:34:21",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 4.08,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 17:39:51"
          },
          {
            "ticket_id": 533,
            "ticket_number": "35532",
            "title": "Cotação para Excursão Ilha Saona",
            "priority": "P3",
            "created_at": "11/10/2025 13:54:53",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/10/2025 13:54:53"
          },
          {
            "ticket_id": 572,
            "ticket_number": "35571",
            "title": "Smy  1208975897",
            "priority": "P2",
            "created_at": "13/10/2025 11:04:48",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 11:04:48"
          },
          {
            "ticket_id": 592,
            "ticket_number": "35591",
            "title": "Reserva - GBN-81115",
            "priority": "P3",
            "created_at": "13/10/2025 14:25:54",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 14:25:55"
          },
          {
            "ticket_id": 601,
            "ticket_number": "35600",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P3",
            "created_at": "13/10/2025 16:16:24",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 10:29:27"
          },
          {
            "ticket_id": 621,
            "ticket_number": "35620",
            "title": "| Urgente: reserva Solférias 408524 - emissão de d",
            "priority": "P3",
            "created_at": "13/10/2025 18:32:52",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 18:32:52"
          },
          {
            "ticket_id": 636,
            "ticket_number": "35635",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-85",
            "priority": "P2",
            "created_at": "13/10/2025 22:15:25",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 14.77,
            "sla_met": false,
            "sla_breach_hours": 10.77,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 13:02:10"
          },
          {
            "ticket_id": 699,
            "ticket_number": "35698",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-85",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 17:58:51",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 22:17:08"
          },
          {
            "ticket_id": 708,
            "ticket_number": "35707",
            "title": "Cancelamento de reserva",
            "priority": "P3",
            "created_at": "14/10/2025 21:47:31",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/10/2025 21:47:31"
          },
          {
            "ticket_id": 714,
            "ticket_number": "35713",
            "title": "Información de reserva número: 1756167",
            "priority": "P3",
            "created_at": "15/10/2025 09:10:15",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 10:34:15"
          },
          {
            "ticket_id": 730,
            "ticket_number": "35729",
            "title": "Fwd: Re: Documentação Sinistro Processo nº OAP2504",
            "priority": "P3",
            "created_at": "15/10/2025 10:13:37",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 10:13:37"
          },
          {
            "ticket_id": 737,
            "ticket_number": "35736",
            "title": "YD3TTV – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "15/10/2025 12:12:41",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 12:12:43"
          },
          {
            "ticket_id": 787,
            "ticket_number": "35786",
            "title": "Reclamação sobre voo atrasado",
            "priority": "P3",
            "created_at": "15/10/2025 19:00:07",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 19:00:07"
          },
          {
            "ticket_id": 798,
            "ticket_number": "35797",
            "title": "Reserva GBN-85830 - Solicitação de alteração da re",
            "priority": "P1",
            "created_at": "15/10/2025 23:10:10",
            "close_date": "2025-10-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "15/10/2025 23:10:10"
          },
          {
            "ticket_id": 810,
            "ticket_number": "35809",
            "title": "GBN-85634 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "16/10/2025 13:59:05",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 23.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/10/2025 13:07:29"
          },
          {
            "ticket_id": 858,
            "ticket_number": "35857",
            "title": "Reserva Aérea ZBALQE",
            "priority": "P3",
            "created_at": "17/10/2025 10:00:10",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/10/2025 10:00:03"
          },
          {
            "ticket_id": 860,
            "ticket_number": "35859",
            "title": "GBN-75309 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "17/10/2025 10:30:17",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 74.88,
            "sla_met": false,
            "sla_breach_hours": 50.88,
            "sla_name": "SLA P3",
            "first_response_at": "20/10/2025 13:23:24"
          },
          {
            "ticket_id": 862,
            "ticket_number": "35861",
            "title": "GBN-83955 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "17/10/2025 12:22:46",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/10/2025 12:20:38"
          },
          {
            "ticket_id": 871,
            "ticket_number": "35870",
            "title": "Comprovativo Iban do Cancelamento GBN-83955",
            "priority": "P2",
            "created_at": "17/10/2025 14:24:54",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 14:24:54"
          },
          {
            "ticket_id": 906,
            "ticket_number": "35905",
            "title": "Icárion - Belek (Antalya) - 27/07/2026 - 6084125 -",
            "priority": "P2",
            "created_at": "19/10/2025 14:42:03",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 19.08,
            "sla_met": false,
            "sla_breach_hours": 15.08,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:47:45"
          },
          {
            "ticket_id": 910,
            "ticket_number": "35909",
            "title": "Fwd: Viagify informa sobre a sua reserva 121146327",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 17:45:47",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/10/2025 17:45:48"
          },
          {
            "ticket_id": 918,
            "ticket_number": "35917",
            "title": "GBN-84757 & GBN-84342",
            "priority": "P2",
            "created_at": "20/10/2025 09:11:08",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:11:08"
          },
          {
            "ticket_id": 919,
            "ticket_number": "35918",
            "title": "GBN-86637 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 09:21:14",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 77.83,
            "sla_met": false,
            "sla_breach_hours": 53.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 15:11:34"
          },
          {
            "ticket_id": 925,
            "ticket_number": "35924",
            "title": "Fwd: Localizador 1204392277 - Smytravel lhe inform",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:25",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:25"
          },
          {
            "ticket_id": 934,
            "ticket_number": "35933",
            "title": "Pedido Orçamento Grupo Disney",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:42",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:42"
          },
          {
            "ticket_id": 939,
            "ticket_number": "35938",
            "title": "Voucher transfer",
            "priority": "P2",
            "created_at": "20/10/2025 10:53:50",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 10:53:50"
          },
          {
            "ticket_id": 947,
            "ticket_number": "35946",
            "title": "Fwd: Acompanhamento do procedimento TTN-1191602245",
            "priority": "P2",
            "created_at": "20/10/2025 15:06:02",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/10/2025 09:12:06"
          },
          {
            "ticket_id": 959,
            "ticket_number": "35958",
            "title": "GBN-82484 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/10/2025 16:08:38",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 26.1,
            "sla_met": false,
            "sla_breach_hours": 22.1,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:15:11"
          },
          {
            "ticket_id": 969,
            "ticket_number": "35968",
            "title": "Re:[## 23285 ##] GBN-82484 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "20/10/2025 18:09:28",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 18:17:10"
          },
          {
            "ticket_id": 980,
            "ticket_number": "35979",
            "title": "Solicitação SOLFERIAS",
            "priority": "P3",
            "created_at": "20/10/2025 20:48:30",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/10/2025 20:48:30"
          },
          {
            "ticket_id": 988,
            "ticket_number": "35987",
            "title": "Devolução de dinheiro ",
            "priority": "P1",
            "created_at": "21/10/2025 09:03:56",
            "close_date": "2025-10-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/10/2025 09:03:56"
          },
          {
            "ticket_id": 1027,
            "ticket_number": "351025",
            "title": "Pedido Contratação Direta rent-a-car",
            "priority": "P2",
            "created_at": "21/10/2025 14:22:03",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 14:22:04"
          },
          {
            "ticket_id": 1056,
            "ticket_number": "351054",
            "title": "GBN-84342 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "21/10/2025 23:19:00",
            "close_date": "2025-10-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 12.65,
            "sla_met": false,
            "sla_breach_hours": 12.4,
            "sla_name": "SLA P1",
            "first_response_at": "22/10/2025 11:58:30"
          },
          {
            "ticket_id": 1057,
            "ticket_number": "351055",
            "title": "GBN-84757 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "21/10/2025 23:19:01",
            "close_date": "2025-10-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 11.77,
            "sla_met": false,
            "sla_breach_hours": 11.52,
            "sla_name": "SLA P1",
            "first_response_at": "22/10/2025 11:05:43"
          },
          {
            "ticket_id": 1070,
            "ticket_number": "351068",
            "title": "GBN-84757 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/10/2025 09:27:23",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 10:56:02"
          },
          {
            "ticket_id": 1072,
            "ticket_number": "351070",
            "title": "GBN-84342 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/10/2025 09:28:30",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 10:53:33"
          },
          {
            "ticket_id": 1073,
            "ticket_number": "351071",
            "title": "Re:[## 23441 ##] GBN-84342 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "22/10/2025 10:29:12",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 10:48:31"
          },
          {
            "ticket_id": 1086,
            "ticket_number": "351084",
            "title": "70 Years Flying to Portugal: Celebrate This Histor",
            "priority": "P3",
            "created_at": "22/10/2025 13:06:04",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 144.35,
            "sla_met": false,
            "sla_breach_hours": 120.35,
            "sla_name": "SLA P3",
            "first_response_at": "28/10/2025 13:27:56"
          },
          {
            "ticket_id": 1087,
            "ticket_number": "351085",
            "title": "Atualização: Atribuição de comissões às agências d",
            "priority": "P3",
            "created_at": "22/10/2025 13:06:06",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/10/2025 14:00:05"
          },
          {
            "ticket_id": 1111,
            "ticket_number": "351109",
            "title": "Fwd: Pedido de Estorno - LOC: GBN-67038 + 11452046",
            "priority": "P2",
            "created_at": "22/10/2025 20:04:23",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 20:04:23"
          },
          {
            "ticket_id": 1112,
            "ticket_number": "351110",
            "title": "GBN-84526 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "22/10/2025 20:04:25",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 339.47,
            "sla_met": false,
            "sla_breach_hours": 315.47,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 23:33:17"
          },
          {
            "ticket_id": 1119,
            "ticket_number": "351117",
            "title": "Fwd: Consulta sobre Localizador: 1204392277 TTN-12",
            "priority": "P2",
            "created_at": "22/10/2025 20:04:39",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 20:04:40"
          },
          {
            "ticket_id": 1130,
            "ticket_number": "351128",
            "title": "Discover how to book your NDC content without any ",
            "priority": "P3",
            "created_at": "23/10/2025 09:14:51",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 128.43,
            "sla_met": false,
            "sla_breach_hours": 104.43,
            "sla_name": "SLA P3",
            "first_response_at": "28/10/2025 17:41:38"
          },
          {
            "ticket_id": 1133,
            "ticket_number": "351131",
            "title": "🌍 Comunicação oficial - Ethiopian Airlines anuncia",
            "priority": "P2",
            "created_at": "23/10/2025 09:30:02",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 128.18,
            "sla_met": false,
            "sla_breach_hours": 124.18,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:42:02"
          },
          {
            "ticket_id": 1155,
            "ticket_number": "351153",
            "title": "Reserva smy 1180706605",
            "priority": "P2",
            "created_at": "23/10/2025 14:47:37",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 17:35:11"
          },
          {
            "ticket_id": 1185,
            "ticket_number": "351182",
            "title": "Fwd: Caso 04765539 recibido",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:18",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:03:18"
          },
          {
            "ticket_id": 1198,
            "ticket_number": "351195",
            "title": "Fwd: Incidente de transfer TTN-1204392277#84152671",
            "priority": "P2",
            "created_at": "24/10/2025 09:26:38",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:26:39"
          },
          {
            "ticket_id": 1213,
            "ticket_number": "351210",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "P3",
            "created_at": "24/10/2025 11:44:40",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 11:44:42"
          },
          {
            "ticket_id": 1219,
            "ticket_number": "351216",
            "title": "MR20260616BCNBCN - BKG 67529122 - CONFIRMAÇÃO DE R",
            "priority": "P3",
            "created_at": "24/10/2025 12:17:31",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 12:17:35"
          },
          {
            "ticket_id": 1223,
            "ticket_number": "351220",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P3",
            "created_at": "24/10/2025 12:18:11",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 4.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 16:22:13"
          },
          {
            "ticket_id": 1228,
            "ticket_number": "351225",
            "title": "Fwd: Caso 04765540 recibido",
            "priority": "P2",
            "created_at": "24/10/2025 12:58:38",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 12:58:38"
          },
          {
            "ticket_id": 1236,
            "ticket_number": "351233",
            "title": "NDC-X Amdeus",
            "priority": "P2",
            "created_at": "24/10/2025 14:09:39",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 94.77,
            "sla_met": false,
            "sla_breach_hours": 90.77,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 12:56:33"
          },
          {
            "ticket_id": 1256,
            "ticket_number": "351253",
            "title": "Fwd: Encerramento do caso TTN-1191602245#84179883#",
            "priority": "P2",
            "created_at": "24/10/2025 18:15:24",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 18:15:25"
          },
          {
            "ticket_id": 1259,
            "ticket_number": "351256",
            "title": "Orçamento de grupo Boa Vista - urgente",
            "priority": "P3",
            "created_at": "24/10/2025 18:45:15",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 18:45:15"
          },
          {
            "ticket_id": 1261,
            "ticket_number": "351258",
            "title": "Referencia para pagamento | File:414136/2025",
            "priority": "P2",
            "created_at": "24/10/2025 21:59:09",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 87.3,
            "sla_met": false,
            "sla_breach_hours": 83.3,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 13:17:53"
          },
          {
            "ticket_id": 1262,
            "ticket_number": "351259",
            "title": "GBN-81748 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "24/10/2025 22:16:47",
            "close_date": "2025-11-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 139.68,
            "sla_met": false,
            "sla_breach_hours": 139.43,
            "sla_name": "SLA P1",
            "first_response_at": "30/10/2025 17:58:21"
          },
          {
            "ticket_id": 1263,
            "ticket_number": "351260",
            "title": "New Blue",
            "priority": "P2",
            "created_at": "24/10/2025 22:17:19",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 22:20:44"
          },
          {
            "ticket_id": 1298,
            "ticket_number": "351295",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "27/10/2025 10:06:50",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 27.1,
            "sla_met": false,
            "sla_breach_hours": 23.1,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 13:13:01"
          },
          {
            "ticket_id": 1305,
            "ticket_number": "351302",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P1",
            "created_at": "27/10/2025 10:07:08",
            "close_date": "2025-10-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/10/2025 10:07:08"
          },
          {
            "ticket_id": 1315,
            "ticket_number": "351312",
            "title": "Confirmação de Reserva * File 414136",
            "priority": "P2",
            "created_at": "27/10/2025 10:46:55",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 11:05:11"
          },
          {
            "ticket_id": 1321,
            "ticket_number": "351318",
            "title": "Reservation Request",
            "priority": "P2",
            "created_at": "27/10/2025 12:06:00",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:33:30"
          },
          {
            "ticket_id": 1330,
            "ticket_number": "351327",
            "title": "Pedido de cotação",
            "priority": "P2",
            "created_at": "27/10/2025 13:04:05",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 13:04:05"
          },
          {
            "ticket_id": 1334,
            "ticket_number": "351331",
            "title": "Fwd: Pedido de revisão devido a alteração de itine",
            "priority": "P2",
            "created_at": "27/10/2025 13:51:17",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 13:51:17"
          },
          {
            "ticket_id": 1347,
            "ticket_number": "351344",
            "title": "Fwd: Caso 04765540 rechazado",
            "priority": "P1",
            "created_at": "27/10/2025 17:23:47",
            "close_date": "2025-10-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/10/2025 17:23:45"
          },
          {
            "ticket_id": 1358,
            "ticket_number": "351355",
            "title": "Fwd: Já faz parte de Vueling Partners",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:01",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:01:01"
          },
          {
            "ticket_id": 1360,
            "ticket_number": "351357",
            "title": "Fwd: Confirmación de reserva — 06122928292 IATA",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:04",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:01:04"
          },
          {
            "ticket_id": 1363,
            "ticket_number": "351360",
            "title": "Fwd: Conclua o seu registo em Vueling Partners",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:08",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:01:08"
          },
          {
            "ticket_id": 1364,
            "ticket_number": "351361",
            "title": "Fwd: B2B RESERV@S - Plataforma de Serviços Online",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:09",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:01:10"
          },
          {
            "ticket_id": 1367,
            "ticket_number": "351364",
            "title": "Fwd: Request received for Miguel Cena",
            "priority": "P2",
            "created_at": "27/10/2025 19:20:25",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:20:25"
          },
          {
            "ticket_id": 1373,
            "ticket_number": "351370",
            "title": "Confirmação da reserva nº 588202864",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:14:23",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 97.23,
            "sla_met": false,
            "sla_breach_hours": 73.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 22:29:07"
          },
          {
            "ticket_id": 1416,
            "ticket_number": "351413",
            "title": "Novidades sobre atribuição de comissões às agência",
            "priority": "P2",
            "created_at": "28/10/2025 12:50:07",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 13:01:28"
          },
          {
            "ticket_id": 1423,
            "ticket_number": "351420",
            "title": "Reserva 712107",
            "priority": "P3",
            "created_at": "28/10/2025 13:59:21",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/10/2025 14:24:21"
          },
          {
            "ticket_id": 1425,
            "ticket_number": "351422",
            "title": "Fwd: Incidente hotel (Hotel fechado) TTN-120566059",
            "priority": "P2",
            "created_at": "28/10/2025 14:06:50",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 14:06:51"
          },
          {
            "ticket_id": 1431,
            "ticket_number": "351428",
            "title": "GBN-81748 - Questão cliente",
            "priority": "P2",
            "created_at": "28/10/2025 15:28:41",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 15:28:41"
          },
          {
            "ticket_id": 1463,
            "ticket_number": "351460",
            "title": "Confirmação da reserva nº 561574276",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 23:33:56",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 71.1,
            "sla_met": false,
            "sla_breach_hours": 47.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 22:40:36"
          },
          {
            "ticket_id": 1481,
            "ticket_number": "351478",
            "title": "Pedido abertura  conta fornecedor  DMC - Asia - Zu",
            "priority": "P3",
            "created_at": "29/10/2025 10:37:14",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/10/2025 10:37:15"
          },
          {
            "ticket_id": 1483,
            "ticket_number": "351480",
            "title": "Re: Viagem grupo 2026",
            "priority": "P2",
            "created_at": "29/10/2025 10:59:20",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 28.53,
            "sla_met": false,
            "sla_breach_hours": 24.53,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 15:31:34"
          },
          {
            "ticket_id": 1486,
            "ticket_number": "351483",
            "title": "Fwd: Viagify informa-te do teu orçamento 121437404",
            "priority": "P2",
            "created_at": "29/10/2025 13:01:23",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 13:01:24"
          },
          {
            "ticket_id": 1496,
            "ticket_number": "351493",
            "title": "Confirmação de reserva 333002####### TIME LIMIT PA",
            "priority": "P2",
            "created_at": "29/10/2025 15:31:43",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 16:57:10"
          },
          {
            "ticket_id": 1527,
            "ticket_number": "351524",
            "title": "GBN-81442 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/10/2025 22:41:34",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 48.8,
            "sla_met": false,
            "sla_breach_hours": 44.8,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 23:30:03"
          },
          {
            "ticket_id": 1531,
            "ticket_number": "351528",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 23:56:59",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 46.83,
            "sla_met": false,
            "sla_breach_hours": 22.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 22:47:29"
          },
          {
            "ticket_id": 1532,
            "ticket_number": "351529",
            "title": "Información de reservas que entran en gastos próxi",
            "priority": "P2",
            "created_at": "30/10/2025 10:09:40",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 11:20:53"
          },
          {
            "ticket_id": 1542,
            "ticket_number": "351539",
            "title": "Cotação - Viagem de Grupo Ilha do Sal",
            "priority": "P3",
            "created_at": "30/10/2025 11:28:59",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 11:28:59"
          },
          {
            "ticket_id": 1544,
            "ticket_number": "351541",
            "title": "GBN-88024 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 12:03:23",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 367.45,
            "sla_met": false,
            "sla_breach_hours": 343.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:30:35"
          },
          {
            "ticket_id": 1545,
            "ticket_number": "351542",
            "title": "GBN-77918 - Cancelamento",
            "priority": "P2",
            "created_at": "30/10/2025 12:03:25",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 12:03:26"
          },
          {
            "ticket_id": 1547,
            "ticket_number": "351544",
            "title": "GBN-88023 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 12:03:31",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 367.45,
            "sla_met": false,
            "sla_breach_hours": 343.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:31:04"
          },
          {
            "ticket_id": 1548,
            "ticket_number": "351545",
            "title": "GBN-88028 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 12:11:37",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 367.32,
            "sla_met": false,
            "sla_breach_hours": 343.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:31:33"
          },
          {
            "ticket_id": 1561,
            "ticket_number": "351558",
            "title": "Fwd: Reservation Confirmation - Gocar-Armanda",
            "priority": "P2",
            "created_at": "30/10/2025 13:46:47",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 13:46:47"
          },
          {
            "ticket_id": 1565,
            "ticket_number": "351562",
            "title": "Ajuda para compra de bagagem",
            "priority": "P2",
            "created_at": "30/10/2025 15:23:18",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 15:23:18"
          },
          {
            "ticket_id": 1618,
            "ticket_number": "351615",
            "title": "Grupo: GR-FB8370A576",
            "priority": "P3",
            "created_at": "31/10/2025 12:59:43",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/10/2025 12:59:43"
          },
          {
            "ticket_id": 1684,
            "ticket_number": "351681",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "02/11/2025 17:04:33",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/11/2025 18:32:55"
          },
          {
            "ticket_id": 1690,
            "ticket_number": "351687",
            "title": "Pedido de Cotação voos ",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:35",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:34:35"
          },
          {
            "ticket_id": 1700,
            "ticket_number": "351697",
            "title": "Icarion - condições de pagamento ",
            "priority": "P3",
            "created_at": "03/11/2025 10:35:04",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 10:35:04"
          },
          {
            "ticket_id": 1702,
            "ticket_number": "351699",
            "title": "Pedido Tour 10",
            "priority": "P2",
            "created_at": "03/11/2025 10:35:43",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:35:43"
          },
          {
            "ticket_id": 1703,
            "ticket_number": "351700",
            "title": "Africa do Sul / Zanzibar",
            "priority": "P3",
            "created_at": "03/11/2025 10:36:17",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 10:36:18"
          },
          {
            "ticket_id": 1709,
            "ticket_number": "351706",
            "title": "Reserva Aérea YX8XZM",
            "priority": "P3",
            "created_at": "03/11/2025 11:26:48",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:39"
          },
          {
            "ticket_id": 1710,
            "ticket_number": "351707",
            "title": "Cancelamento de reserva * File 414810",
            "priority": "P2",
            "created_at": "03/11/2025 11:26:51",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 14:14:52"
          },
          {
            "ticket_id": 1712,
            "ticket_number": "351709",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (YX8",
            "priority": "P3",
            "created_at": "03/11/2025 11:26:55",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:39"
          },
          {
            "ticket_id": 1715,
            "ticket_number": "351712",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\SONIACRIST",
            "priority": "P3",
            "created_at": "03/11/2025 11:46:47",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:39"
          },
          {
            "ticket_id": 1716,
            "ticket_number": "351713",
            "title": "Aéreo - Confirmação de Emissão (VILARINHO\\SOFIA) -",
            "priority": "P3",
            "created_at": "03/11/2025 11:46:49",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:39"
          },
          {
            "ticket_id": 1718,
            "ticket_number": "351715",
            "title": "Aéreo - Confirmação de Emissão (MACHADO\\JOSECARLOS",
            "priority": "P3",
            "created_at": "03/11/2025 11:46:52",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:40"
          },
          {
            "ticket_id": 1719,
            "ticket_number": "351716",
            "title": "Aéreo - Confirmação de Emissão (MACHADO\\JOSECARLOS",
            "priority": "P3",
            "created_at": "03/11/2025 11:46:54",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:40"
          },
          {
            "ticket_id": 1720,
            "ticket_number": "351717",
            "title": "Aéreo - Confirmação de Emissão (VILARINHO\\SOFIA) -",
            "priority": "P3",
            "created_at": "03/11/2025 11:46:57",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:40"
          },
          {
            "ticket_id": 1721,
            "ticket_number": "351718",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\SONIACRIST",
            "priority": "P3",
            "created_at": "03/11/2025 11:47:00",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 12:04:40"
          },
          {
            "ticket_id": 1756,
            "ticket_number": "351753",
            "title": "Cancelamento de reserva * File 414810",
            "priority": "P2",
            "created_at": "03/11/2025 17:09:59",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 44.9,
            "sla_met": false,
            "sla_breach_hours": 40.9,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 14:04:25"
          },
          {
            "ticket_id": 1762,
            "ticket_number": "351759",
            "title": "Re: Upgrade Orçamento em anexo",
            "priority": "P3",
            "created_at": "03/11/2025 18:33:18",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 19:06:17"
          },
          {
            "ticket_id": 1765,
            "ticket_number": "351762",
            "title": "Voos Easyjet - Inês - IATA",
            "priority": "P3",
            "created_at": "03/11/2025 18:51:02",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 18:51:02"
          },
          {
            "ticket_id": 1771,
            "ticket_number": "351768",
            "title": "Por favor anular reserva",
            "priority": "P2",
            "created_at": "03/11/2025 19:41:12",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:41:12"
          },
          {
            "ticket_id": 1804,
            "ticket_number": "351801",
            "title": "GBN-85525 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/11/2025 10:28:08",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 13:06:56"
          },
          {
            "ticket_id": 1821,
            "ticket_number": "351818",
            "title": "Voos Easy Jet - Inês - IATA",
            "priority": "P1",
            "created_at": "04/11/2025 14:43:54",
            "close_date": "2025-11-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/11/2025 14:43:54"
          },
          {
            "ticket_id": 1822,
            "ticket_number": "351819",
            "title": "4KHS6VPV99",
            "priority": "P1",
            "created_at": "04/11/2025 14:43:55",
            "close_date": "2025-11-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.4,
            "sla_met": false,
            "sla_breach_hours": 4.15,
            "sla_name": "SLA P1",
            "first_response_at": "04/11/2025 19:08:26"
          },
          {
            "ticket_id": 1833,
            "ticket_number": "351830",
            "title": "YD3TTV – Alteração de horario/nº de voo",
            "priority": "P3",
            "created_at": "04/11/2025 18:16:58",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 19:24:58"
          },
          {
            "ticket_id": 1838,
            "ticket_number": "351835",
            "title": "Fwd: easyJet número de referência da reserva: KBHZ",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 19:52:07",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/11/2025 18:56:01"
          },
          {
            "ticket_id": 1841,
            "ticket_number": "351838",
            "title": "Fwd: easyJet número de referência da reserva: KBHZ",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 19:52:19",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 264.43,
            "sla_met": false,
            "sla_breach_hours": 240.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/11/2025 20:18:36"
          },
          {
            "ticket_id": 1854,
            "ticket_number": "351851",
            "title": "Dúvidas Campanha Soltropico ",
            "priority": "P3",
            "created_at": "05/11/2025 10:05:01",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 10:05:01"
          },
          {
            "ticket_id": 1872,
            "ticket_number": "351869",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P3",
            "created_at": "05/11/2025 12:22:59",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 12:15:13"
          },
          {
            "ticket_id": 1876,
            "ticket_number": "351873",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P2",
            "created_at": "05/11/2025 12:58:30",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 12:58:30"
          },
          {
            "ticket_id": 1878,
            "ticket_number": "351875",
            "title": "Re: cotação voo TAP Lisboa/Viena/Lisboa",
            "priority": "P3",
            "created_at": "05/11/2025 13:32:10",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 13:32:10"
          },
          {
            "ticket_id": 1890,
            "ticket_number": "351887",
            "title": "Fwd: Request received for Miguel Cena",
            "priority": "P2",
            "created_at": "05/11/2025 19:53:04",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 19:53:04"
          },
          {
            "ticket_id": 1915,
            "ticket_number": "351912",
            "title": "Pedido de cotação - Soltour",
            "priority": "P3",
            "created_at": "06/11/2025 10:20:16",
            "close_date": "2025-11-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:20:16"
          },
          {
            "ticket_id": 1916,
            "ticket_number": "351913",
            "title": "Re: Cotação voos Easyjet",
            "priority": "P3",
            "created_at": "06/11/2025 10:22:59",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:22:59"
          },
          {
            "ticket_id": 1917,
            "ticket_number": "351914",
            "title": "Re: Cotação voos Easyjet",
            "priority": "P3",
            "created_at": "06/11/2025 10:23:00",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:23:00"
          },
          {
            "ticket_id": 1920,
            "ticket_number": "351917",
            "title": "Fwd: Your flight to Palma de Mallorca: Upgrade ava",
            "priority": "P3",
            "created_at": "06/11/2025 10:23:38",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:23:38"
          },
          {
            "ticket_id": 1924,
            "ticket_number": "351921",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "06/11/2025 10:45:38",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 12:33:07"
          },
          {
            "ticket_id": 1926,
            "ticket_number": "351923",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "06/11/2025 10:48:37",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 12:22:41"
          },
          {
            "ticket_id": 1928,
            "ticket_number": "351925",
            "title": "Viagem Egito",
            "priority": "P3",
            "created_at": "06/11/2025 10:48:58",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:49:00"
          },
          {
            "ticket_id": 1930,
            "ticket_number": "351927",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "06/11/2025 10:50:22",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 12:42:16"
          },
          {
            "ticket_id": 1934,
            "ticket_number": "351931",
            "title": "Documentação Disponível - Reserva 333002",
            "priority": "P2",
            "created_at": "06/11/2025 11:52:28",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 12:15:13"
          },
          {
            "ticket_id": 1966,
            "ticket_number": "351962",
            "title": "Pedido Orçamento Grupo Disney 2",
            "priority": "P3",
            "created_at": "06/11/2025 19:52:15",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 19:52:15"
          },
          {
            "ticket_id": 1968,
            "ticket_number": "351964",
            "title": "| Urgente: assistência em viagem após regresso da ",
            "priority": "P3",
            "created_at": "06/11/2025 23:10:51",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 23:10:51"
          },
          {
            "ticket_id": 1974,
            "ticket_number": "351970",
            "title": "Re: Cotação de voos",
            "priority": "P3",
            "created_at": "07/11/2025 10:48:24",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 10:48:24"
          },
          {
            "ticket_id": 1991,
            "ticket_number": "351987",
            "title": "Pedido disponibilidade leplan 9-10 nov",
            "priority": "P1",
            "created_at": "07/11/2025 11:23:37",
            "close_date": "2025-11-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/11/2025 11:23:37"
          },
          {
            "ticket_id": 2016,
            "ticket_number": "352012",
            "title": "YD3TTV – Alteração de horario/nº de voo - ALERTA",
            "priority": "P3",
            "created_at": "07/11/2025 18:23:29",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 18:49:18"
          },
          {
            "ticket_id": 2027,
            "ticket_number": "352023",
            "title": "Re: Cotação Voos Lisboa /Paris",
            "priority": "P3",
            "created_at": "07/11/2025 20:16:24",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 16:50:44"
          },
          {
            "ticket_id": 2033,
            "ticket_number": "352029",
            "title": "URGENTE: Engano no nome do voo | 1212212049",
            "priority": "P2",
            "created_at": "08/11/2025 00:07:01",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 00:07:02"
          },
          {
            "ticket_id": 2034,
            "ticket_number": "352030",
            "title": "Reserva Aérea DZGZMS",
            "priority": "P2",
            "created_at": "08/11/2025 00:07:04",
            "close_date": "2025-11-09",
            "sla_target_hours": 4,
            "actual_time_hours": 41.52,
            "sla_met": false,
            "sla_breach_hours": 37.52,
            "sla_name": "SLA P2",
            "first_response_at": "09/11/2025 17:38:10"
          },
          {
            "ticket_id": 2035,
            "ticket_number": "352031",
            "title": "DZGZMS – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "08/11/2025 00:07:38",
            "close_date": "2025-11-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 15.1,
            "sla_met": false,
            "sla_breach_hours": 14.85,
            "sla_name": "SLA P1",
            "first_response_at": "08/11/2025 15:13:51"
          },
          {
            "ticket_id": 2041,
            "ticket_number": "352037",
            "title": "DZGZMS – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "08/11/2025 12:27:10",
            "close_date": "2025-11-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 15:13:56"
          },
          {
            "ticket_id": 2050,
            "ticket_number": "352046",
            "title": "Aéreo - Confirmação de Emissão (DA LOURA MARTINS\\A",
            "priority": "P3",
            "created_at": "08/11/2025 17:49:07",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 40.53,
            "sla_met": false,
            "sla_breach_hours": 16.53,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 10:21:59"
          },
          {
            "ticket_id": 2062,
            "ticket_number": "352058",
            "title": "Engano no nome do voo - Importante - voo 13/11",
            "priority": "P2",
            "created_at": "09/11/2025 16:00:16",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/11/2025 16:00:16"
          },
          {
            "ticket_id": 2066,
            "ticket_number": "352062",
            "title": "Fwd: Consulta sobre o seu pedido 1212212049 TTN-12",
            "priority": "P2",
            "created_at": "09/11/2025 17:56:59",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/11/2025 17:56:59"
          },
          {
            "ticket_id": 2096,
            "ticket_number": "352092",
            "title": "Fwd: Quote reminder 69921218",
            "priority": "P2",
            "created_at": "10/11/2025 10:42:01",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:42:01"
          },
          {
            "ticket_id": 2098,
            "ticket_number": "352094",
            "title": "Fwd: Vueling flight to Palma de Mallorca – What to",
            "priority": "P2",
            "created_at": "10/11/2025 10:42:10",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:42:10"
          },
          {
            "ticket_id": 2099,
            "ticket_number": "352095",
            "title": "Fwd: easyJet Group Quotation Information : 2025-11",
            "priority": "P3",
            "created_at": "10/11/2025 10:42:13",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 10:42:13"
          },
          {
            "ticket_id": 2103,
            "ticket_number": "352099",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P3",
            "created_at": "10/11/2025 11:07:37",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 11:07:28"
          },
          {
            "ticket_id": 2108,
            "ticket_number": "352104",
            "title": "GBN-82375 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "10/11/2025 11:38:33",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 10:11:30"
          },
          {
            "ticket_id": 2122,
            "ticket_number": "352118",
            "title": "Criação de processo File 415469/25",
            "priority": "P3",
            "created_at": "10/11/2025 13:37:06",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 336.73,
            "sla_met": false,
            "sla_breach_hours": 312.73,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:21:33"
          },
          {
            "ticket_id": 2125,
            "ticket_number": "352121",
            "title": "Informação de reserva - SPT002501549976",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 13:57:51",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 17:04:56"
          },
          {
            "ticket_id": 2131,
            "ticket_number": "352127",
            "title": "Pedido le plan",
            "priority": "P3",
            "created_at": "10/11/2025 15:19:21",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 15:19:22"
          },
          {
            "ticket_id": 2133,
            "ticket_number": "352129",
            "title": "Re: Cotacao voos Porto/Boavista/Porto",
            "priority": "P2",
            "created_at": "10/11/2025 16:30:15",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:30:15"
          },
          {
            "ticket_id": 2145,
            "ticket_number": "352141",
            "title": "Re: Pedido de informação - reserva",
            "priority": "P2",
            "created_at": "10/11/2025 17:44:06",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 18:06:32"
          },
          {
            "ticket_id": 2159,
            "ticket_number": "352155",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "10/11/2025 21:08:11",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 15.17,
            "sla_met": false,
            "sla_breach_hours": 11.17,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 12:18:12"
          },
          {
            "ticket_id": 2173,
            "ticket_number": "352169",
            "title": "Pedido de cotação para grupo",
            "priority": "P3",
            "created_at": "11/11/2025 10:10:14",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 10:10:14"
          },
          {
            "ticket_id": 2179,
            "ticket_number": "352175",
            "title": "RE: Cotação voos Lisboa/Cancun/Lisboa",
            "priority": "P3",
            "created_at": "11/11/2025 10:18:33",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 10:18:33"
          },
          {
            "ticket_id": 2182,
            "ticket_number": "352178",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "11/11/2025 10:19:13",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:19:13"
          },
          {
            "ticket_id": 2197,
            "ticket_number": "352193",
            "title": "Re: Re: PEDIDO DE ORÇAMENTO DE GRUPO - Uma Família",
            "priority": "P3",
            "created_at": "11/11/2025 15:57:16",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 15:57:19"
          },
          {
            "ticket_id": 2215,
            "ticket_number": "352211",
            "title": "Fwd: Informações sobre orçamento para grupos easyJ",
            "priority": "P3",
            "created_at": "11/11/2025 17:43:41",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 17:45:13"
          },
          {
            "ticket_id": 2222,
            "ticket_number": "352218",
            "title": "Fwd: Informações sobre orçamento para grupos easyJ",
            "priority": "P3",
            "created_at": "11/11/2025 18:56:12",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 18:56:12"
          },
          {
            "ticket_id": 2223,
            "ticket_number": "352219",
            "title": "Fwd: [[ Ref:200258452 ]] Reservas de Grupo [pt]",
            "priority": "P3",
            "created_at": "11/11/2025 18:56:14",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 18:56:11"
          },
          {
            "ticket_id": 2224,
            "ticket_number": "352220",
            "title": "AMARAL/KELLY MRS 05JUN2026 OPO ORY",
            "priority": "P2",
            "created_at": "11/11/2025 19:12:19",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:12:19"
          },
          {
            "ticket_id": 2228,
            "ticket_number": "352224",
            "title": "RE: Cotaçaão voos Lisboa/Palma/Lisboa",
            "priority": "P3",
            "created_at": "11/11/2025 19:56:43",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 19:56:43"
          },
          {
            "ticket_id": 2230,
            "ticket_number": "352226",
            "title": "Re: Cotação voos easyjet",
            "priority": "P3",
            "created_at": "11/11/2025 19:57:17",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 19:57:17"
          },
          {
            "ticket_id": 2244,
            "ticket_number": "352240",
            "title": "Fwd: Ryanair 70068334/Ana Vasconcelos/Ana Vasconce",
            "priority": "P2",
            "created_at": "11/11/2025 23:17:10",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 23:17:11"
          },
          {
            "ticket_id": 2264,
            "ticket_number": "352260",
            "title": "Fwd: Your new Iberiagencias password",
            "priority": "P2",
            "created_at": "12/11/2025 11:47:06",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 11:47:06"
          },
          {
            "ticket_id": 2285,
            "ticket_number": "352281",
            "title": "Duvidas sobre condições cancelamento - Solferias",
            "priority": "P3",
            "created_at": "12/11/2025 13:04:18",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 13:04:18"
          },
          {
            "ticket_id": 2290,
            "ticket_number": "352286",
            "title": "Re: Cotaçao voos Faro/Londres",
            "priority": "P3",
            "created_at": "12/11/2025 14:57:03",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 14:57:03"
          },
          {
            "ticket_id": 2295,
            "ticket_number": "352291",
            "title": "Grupo: GR-781CC12BA7",
            "priority": "P3",
            "created_at": "12/11/2025 15:32:32",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 22.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:32:43"
          },
          {
            "ticket_id": 2316,
            "ticket_number": "352311",
            "title": "YD3TTV – Alteração de Horário - Aceite",
            "priority": "P2",
            "created_at": "12/11/2025 18:20:49",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:21:38"
          },
          {
            "ticket_id": 2325,
            "ticket_number": "352320",
            "title": "Consulta sobre o seu pedido 1212212049 TTN-1212212",
            "priority": "P3",
            "created_at": "12/11/2025 21:34:55",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 21:34:57"
          },
          {
            "ticket_id": 2334,
            "ticket_number": "352329",
            "title": "Re: cotaçao voos Lisboa/Londres",
            "priority": "P3",
            "created_at": "12/11/2025 23:14:15",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 23:14:16"
          },
          {
            "ticket_id": 2347,
            "ticket_number": "352342",
            "title": "Re: Comissões e Tarifas Aéreas",
            "priority": "P3",
            "created_at": "13/11/2025 10:25:27",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:25:27"
          },
          {
            "ticket_id": 2349,
            "ticket_number": "352344",
            "title": "GBN-89869 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/11/2025 10:46:07",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 11:41:26"
          },
          {
            "ticket_id": 2354,
            "ticket_number": "352349",
            "title": "GBN-89854 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 11:06:53",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 148.17,
            "sla_met": false,
            "sla_breach_hours": 124.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:17:23"
          },
          {
            "ticket_id": 2389,
            "ticket_number": "352384",
            "title": "GR-0B4FC0B5D4",
            "priority": "P3",
            "created_at": "13/11/2025 15:35:41",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 15:36:10"
          },
          {
            "ticket_id": 2395,
            "ticket_number": "352390",
            "title": "Re: Cotaçao VOO TAP",
            "priority": "P3",
            "created_at": "13/11/2025 16:23:27",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 16:23:27"
          },
          {
            "ticket_id": 2407,
            "ticket_number": "352402",
            "title": "Reserva Aérea Y5E3GG",
            "priority": "P3",
            "created_at": "13/11/2025 16:55:28",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 16:55:28"
          },
          {
            "ticket_id": 2410,
            "ticket_number": "352405",
            "title": "Reserva Aérea Y62CPI",
            "priority": "P2",
            "created_at": "13/11/2025 17:37:02",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 17:49:58"
          },
          {
            "ticket_id": 2417,
            "ticket_number": "352412",
            "title": "Fwd: Viagify informa sobre a sua reserva 121869451",
            "priority": "P3",
            "created_at": "13/11/2025 18:40:06",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 18:40:07"
          },
          {
            "ticket_id": 2418,
            "ticket_number": "352413",
            "title": "Fwd: Incidente de voo TTN-  1212212049  #85981443#",
            "priority": "P3",
            "created_at": "13/11/2025 18:40:10",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 18:40:10"
          },
          {
            "ticket_id": 2427,
            "ticket_number": "352422",
            "title": "Y6TVFM – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "13/11/2025 19:03:34",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 19:03:34"
          },
          {
            "ticket_id": 2437,
            "ticket_number": "352432",
            "title": "RE: Cotação voos Frankfurt/Lisboa",
            "priority": "P2",
            "created_at": "13/11/2025 19:20:34",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 19:20:35"
          },
          {
            "ticket_id": 2444,
            "ticket_number": "352439",
            "title": "Voos diretos Riviera Maya | Julho 2026",
            "priority": "P3",
            "created_at": "13/11/2025 21:14:31",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 21:14:31"
          },
          {
            "ticket_id": 2463,
            "ticket_number": "352458",
            "title": "Fwd: Incidente de voo TTN-1212212049#85981443#T156",
            "priority": "P3",
            "created_at": "14/11/2025 11:03:32",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:03:33"
          },
          {
            "ticket_id": 2466,
            "ticket_number": "352461",
            "title": "Aeropuerto errado",
            "priority": "P1",
            "created_at": "14/11/2025 11:27:02",
            "close_date": "2025-11-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/11/2025 11:32:23"
          },
          {
            "ticket_id": 2467,
            "ticket_number": "352462",
            "title": "GBN-89221 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "14/11/2025 11:27:04",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:51:32"
          },
          {
            "ticket_id": 2469,
            "ticket_number": "352464",
            "title": "Re:[## 25017 ##] GBN-89221 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "14/11/2025 11:27:08",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:51:25"
          },
          {
            "ticket_id": 2471,
            "ticket_number": "352466",
            "title": "Reserva Cancelada loc 98F212DEC4",
            "priority": "P2",
            "created_at": "14/11/2025 11:52:19",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 13:15:07"
          },
          {
            "ticket_id": 2472,
            "ticket_number": "352467",
            "title": "Aeropuerto errado",
            "priority": "P2",
            "created_at": "14/11/2025 11:52:20",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 13:14:13"
          },
          {
            "ticket_id": 2473,
            "ticket_number": "352468",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 0",
            "priority": "P3",
            "created_at": "14/11/2025 11:52:22",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:52:22"
          },
          {
            "ticket_id": 2475,
            "ticket_number": "352470",
            "title": "Aeropuerto errado",
            "priority": "P2",
            "created_at": "14/11/2025 12:01:26",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 13:13:00"
          },
          {
            "ticket_id": 2482,
            "ticket_number": "352477",
            "title": "Aéreo - Confirmação de Emissão (ROMAO\\JORGE) - Y6T",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 14:01:36",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 121.18,
            "sla_met": false,
            "sla_breach_hours": 97.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:12:49"
          },
          {
            "ticket_id": 2500,
            "ticket_number": "352495",
            "title": "Aéreo - Confirmação de Emissão (ARAUJO\\JOSE) - Y5E",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 17:42:28",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 117.5,
            "sla_met": false,
            "sla_breach_hours": 93.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:12:43"
          },
          {
            "ticket_id": 2556,
            "ticket_number": "352551",
            "title": "Fwd: easyJet Group Quotation Information : 2025-11",
            "priority": "P3",
            "created_at": "16/11/2025 14:04:01",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/11/2025 14:04:01"
          },
          {
            "ticket_id": 2561,
            "ticket_number": "352556",
            "title": "pedido de orçamento rent a car na Madeira",
            "priority": "P3",
            "created_at": "16/11/2025 17:35:03",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/11/2025 17:35:03"
          },
          {
            "ticket_id": 2604,
            "ticket_number": "352599",
            "title": "Alteração numero voo",
            "priority": "P2",
            "created_at": "17/11/2025 13:30:32",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 8.48,
            "sla_met": false,
            "sla_breach_hours": 4.48,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 21:59:42"
          },
          {
            "ticket_id": 2646,
            "ticket_number": "352641",
            "title": "Comissões e Tarifas Aéreas",
            "priority": "P3",
            "created_at": "17/11/2025 21:59:28",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 21:59:28"
          },
          {
            "ticket_id": 2683,
            "ticket_number": "352678",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P3",
            "created_at": "18/11/2025 12:04:35",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:04:36"
          },
          {
            "ticket_id": 2684,
            "ticket_number": "352679",
            "title": "Fwd: easyJet número de referência da reserva: KBL5",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 12:04:38",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 12:04:38"
          },
          {
            "ticket_id": 2685,
            "ticket_number": "352680",
            "title": "Fwd: Reminder : Get ready for your flight AT981 fr",
            "priority": "P3",
            "created_at": "18/11/2025 12:04:41",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:04:41"
          },
          {
            "ticket_id": 2713,
            "ticket_number": "352708",
            "title": "Alteração numero voo",
            "priority": "P2",
            "created_at": "18/11/2025 16:56:24",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 17:42:40"
          },
          {
            "ticket_id": 2714,
            "ticket_number": "352709",
            "title": "Número de informação da reserva: 6121053",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 17:44:40",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 21.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:12:04"
          },
          {
            "ticket_id": 2718,
            "ticket_number": "352713",
            "title": "\"GBN-77919 - Your request has been received\"",
            "priority": "P2",
            "created_at": "18/11/2025 18:15:27",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 21:45:52"
          },
          {
            "ticket_id": 2720,
            "ticket_number": "352715",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "18/11/2025 19:16:03",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 21:52:35"
          },
          {
            "ticket_id": 2723,
            "ticket_number": "352718",
            "title": "Orçamento de grupo para alojamento em Cabo Verde",
            "priority": "P3",
            "created_at": "18/11/2025 19:52:00",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 19:52:00"
          },
          {
            "ticket_id": 2739,
            "ticket_number": "352734",
            "title": "Pedido Orçamento Grupo 0Djerba Março 2026 - Soltro",
            "priority": "P3",
            "created_at": "18/11/2025 22:25:29",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 22:25:30"
          },
          {
            "ticket_id": 2740,
            "ticket_number": "352735",
            "title": "Pedido de orçamento Nortravel para 25 pessoas Feve",
            "priority": "P3",
            "created_at": "18/11/2025 22:25:32",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 22:25:32"
          },
          {
            "ticket_id": 2744,
            "ticket_number": "352739",
            "title": "Fwd: easyJet número de referência da reserva: KBL8",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 00:03:57",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 00:16:16"
          },
          {
            "ticket_id": 2745,
            "ticket_number": "352740",
            "title": "Fwd: easyJet número de referência da reserva: KBL8",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 00:03:58",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 00:15:36"
          },
          {
            "ticket_id": 2768,
            "ticket_number": "352763",
            "title": "GBN-90206 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "19/11/2025 10:21:42",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 4.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 14:21:57"
          },
          {
            "ticket_id": 2780,
            "ticket_number": "352775",
            "title": "Fwd: PNR information: Y7MVNP",
            "priority": "P3",
            "created_at": "19/11/2025 10:40:56",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 11:29:30"
          },
          {
            "ticket_id": 2782,
            "ticket_number": "352777",
            "title": "Cotação Lua de Mel TUI - Informações",
            "priority": "P2",
            "created_at": "19/11/2025 11:56:26",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 11:56:26"
          },
          {
            "ticket_id": 2787,
            "ticket_number": "352782",
            "title": "GBN-90653 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/11/2025 12:19:47",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 14:22:40"
          },
          {
            "ticket_id": 2788,
            "ticket_number": "352783",
            "title": "Fwd: Informações da reserva TTN-1220289635#8635649",
            "priority": "P2",
            "created_at": "19/11/2025 12:27:37",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 12:27:38"
          },
          {
            "ticket_id": 2789,
            "ticket_number": "352784",
            "title": "Fwd: Proteja sua viagem por apenas 175.78 EUR",
            "priority": "P2",
            "created_at": "19/11/2025 12:27:40",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 12:27:41"
          },
          {
            "ticket_id": 2792,
            "ticket_number": "352787",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "19/11/2025 12:53:44",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 14:31:59"
          },
          {
            "ticket_id": 2807,
            "ticket_number": "352802",
            "title": "Fwd: Ocidental Seguros e Ocidental Vida",
            "priority": "P3",
            "created_at": "19/11/2025 15:50:28",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 15:50:28"
          },
          {
            "ticket_id": 2815,
            "ticket_number": "352810",
            "title": "Fwd: easyJet número de referência da reserva: KBLC",
            "priority": "P2",
            "created_at": "19/11/2025 18:18:01",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 18:33:30"
          },
          {
            "ticket_id": 2837,
            "ticket_number": "352832",
            "title": "cancelamento newblue - localizador 1761128",
            "priority": "P3",
            "created_at": "19/11/2025 23:38:42",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 23:38:42"
          },
          {
            "ticket_id": 2839,
            "ticket_number": "352834",
            "title": "Informação",
            "priority": "P2",
            "created_at": "19/11/2025 23:46:52",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 10.35,
            "sla_met": false,
            "sla_breach_hours": 6.35,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 10:08:35"
          },
          {
            "ticket_id": 2876,
            "ticket_number": "352871",
            "title": "Dúvida para reserva Disney",
            "priority": "P3",
            "created_at": "20/11/2025 13:24:57",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 13:24:57"
          },
          {
            "ticket_id": 2915,
            "ticket_number": "352910",
            "title": "Fwd: easyJet número de referência da reserva: KBLK",
            "priority": "P2",
            "created_at": "20/11/2025 23:02:05",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 23:03:39"
          },
          {
            "ticket_id": 2939,
            "ticket_number": "352934",
            "title": "GBN-75293 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "21/11/2025 11:58:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 14:34:11"
          },
          {
            "ticket_id": 2940,
            "ticket_number": "352935",
            "title": "GBN-91034 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "21/11/2025 11:58:17",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 4.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 16:27:45"
          },
          {
            "ticket_id": 2943,
            "ticket_number": "352938",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "21/11/2025 12:27:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 12:27:11"
          },
          {
            "ticket_id": 2947,
            "ticket_number": "352942",
            "title": "Pedido de orçamento",
            "priority": "P2",
            "created_at": "21/11/2025 14:20:45",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 14:20:45"
          },
          {
            "ticket_id": 2948,
            "ticket_number": "352943",
            "title": "urgente pedido de informação",
            "priority": "P3",
            "created_at": "21/11/2025 14:20:48",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 14:20:49"
          },
          {
            "ticket_id": 2949,
            "ticket_number": "352944",
            "title": "Dificuldades Soltour",
            "priority": "P2",
            "created_at": "21/11/2025 14:20:51",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 14:20:51"
          },
          {
            "ticket_id": 2951,
            "ticket_number": "352946",
            "title": "Re: cotaçao voos Porto/Funchal",
            "priority": "P2",
            "created_at": "21/11/2025 15:49:31",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 15:49:31"
          },
          {
            "ticket_id": 2960,
            "ticket_number": "352955",
            "title": "Orçamento GBN",
            "priority": "P2",
            "created_at": "21/11/2025 17:01:25",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 17:01:25"
          },
          {
            "ticket_id": 2980,
            "ticket_number": "352975",
            "title": "Codigos acesso para Check in",
            "priority": "P2",
            "created_at": "21/11/2025 18:19:31",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 18:19:31"
          },
          {
            "ticket_id": 2981,
            "ticket_number": "352976",
            "title": "Cancelamento motivo força maior",
            "priority": "P2",
            "created_at": "21/11/2025 18:41:05",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 65.82,
            "sla_met": false,
            "sla_breach_hours": 61.82,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 12:30:54"
          },
          {
            "ticket_id": 2985,
            "ticket_number": "352980",
            "title": "Cancelamento motivo força maior",
            "priority": "P3",
            "created_at": "21/11/2025 18:41:19",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 65.83,
            "sla_met": false,
            "sla_breach_hours": 41.83,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 12:31:52"
          },
          {
            "ticket_id": 2986,
            "ticket_number": "352981",
            "title": "Cancelamento motivo força maior",
            "priority": "P3",
            "created_at": "21/11/2025 18:41:21",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 65.83,
            "sla_met": false,
            "sla_breach_hours": 41.83,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 12:31:36"
          },
          {
            "ticket_id": 3009,
            "ticket_number": "353004",
            "title": "Cancelamento motivo força maior",
            "priority": "P2",
            "created_at": "22/11/2025 10:01:28",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 8.4,
            "sla_met": false,
            "sla_breach_hours": 4.4,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 18:25:45"
          },
          {
            "ticket_id": 3027,
            "ticket_number": "353022",
            "title": "Fw: Agradecemos o preenchimento deste formulário: ",
            "priority": "P3",
            "created_at": "22/11/2025 20:25:22",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/11/2025 20:25:22"
          },
          {
            "ticket_id": 3054,
            "ticket_number": "353047",
            "title": "GBN-83123 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "23/11/2025 20:57:29",
            "close_date": "2025-11-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/11/2025 21:12:58"
          },
          {
            "ticket_id": 3061,
            "ticket_number": "353054",
            "title": "Custos de gestão SMY",
            "priority": "P2",
            "created_at": "23/11/2025 23:58:40",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 23:58:40"
          },
          {
            "ticket_id": 3073,
            "ticket_number": "353066",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 10:39:21",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 10:39:22"
          },
          {
            "ticket_id": 3076,
            "ticket_number": "353069",
            "title": "Fwd: easyJet número de referência da reserva: KBLZ",
            "priority": "P2",
            "created_at": "24/11/2025 10:59:26",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:59:28"
          },
          {
            "ticket_id": 3077,
            "ticket_number": "353070",
            "title": "Fwd: easyJet número de referência da reserva: KBLZ",
            "priority": "P2",
            "created_at": "24/11/2025 10:59:30",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:59:31"
          },
          {
            "ticket_id": 3078,
            "ticket_number": "353071",
            "title": "Fwd: easyJet número de referência da reserva: KBLZ",
            "priority": "P2",
            "created_at": "24/11/2025 10:59:34",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:59:35"
          },
          {
            "ticket_id": 3079,
            "ticket_number": "353072",
            "title": "Fwd: easyJet número de referência da reserva: KBLZ",
            "priority": "P2",
            "created_at": "24/11/2025 10:59:37",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:59:38"
          },
          {
            "ticket_id": 3080,
            "ticket_number": "353073",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P3",
            "created_at": "24/11/2025 11:28:28",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 11:28:29"
          },
          {
            "ticket_id": 3081,
            "ticket_number": "353074",
            "title": "Fwd: easyJet número de referência da reserva: KBM1",
            "priority": "P2",
            "created_at": "24/11/2025 11:28:31",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:28:32"
          },
          {
            "ticket_id": 3082,
            "ticket_number": "353075",
            "title": "Fwd: easyJet número de referência da reserva: KBM1",
            "priority": "P2",
            "created_at": "24/11/2025 11:28:34",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:28:35"
          },
          {
            "ticket_id": 3083,
            "ticket_number": "353076",
            "title": "Fwd: easyJet número de referência da reserva: KBM1",
            "priority": "P2",
            "created_at": "24/11/2025 11:28:37",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:28:38"
          },
          {
            "ticket_id": 3087,
            "ticket_number": "353080",
            "title": "Fwd: NOVO INCIDENTE: Amadeus Central Ticketing: Fo",
            "priority": "P2",
            "created_at": "24/11/2025 12:16:20",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 12:16:20"
          },
          {
            "ticket_id": 3088,
            "ticket_number": "353081",
            "title": "Fwd: RECUPERADO: Amadeus Central Ticketing: Forma ",
            "priority": "P2",
            "created_at": "24/11/2025 12:16:22",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 12:16:22"
          },
          {
            "ticket_id": 3092,
            "ticket_number": "353085",
            "title": "Loc 1204060360 reserva smy",
            "priority": "P3",
            "created_at": "24/11/2025 13:22:25",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 13:52:44"
          },
          {
            "ticket_id": 3096,
            "ticket_number": "353089",
            "title": "Envio de documentação - FILE 402834",
            "priority": "P3",
            "created_at": "24/11/2025 13:53:53",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:14:08"
          },
          {
            "ticket_id": 3110,
            "ticket_number": "353103",
            "title": "Re:[## 25606 ##] GBN-83123 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "24/11/2025 16:34:34",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 16:37:19"
          },
          {
            "ticket_id": 3145,
            "ticket_number": "353138",
            "title": "Pedido de Orçamento para viagem de grupo 27 pessoa",
            "priority": "P3",
            "created_at": "25/11/2025 11:07:24",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 11:07:25"
          },
          {
            "ticket_id": 3159,
            "ticket_number": "353152",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6120511",
            "priority": "P2",
            "created_at": "25/11/2025 12:40:53",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:37:38"
          },
          {
            "ticket_id": 3160,
            "ticket_number": "353153",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6120100",
            "priority": "P2",
            "created_at": "25/11/2025 12:40:55",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:36:01"
          },
          {
            "ticket_id": 3161,
            "ticket_number": "353154",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6120164",
            "priority": "P2",
            "created_at": "25/11/2025 12:40:56",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:34:49"
          },
          {
            "ticket_id": 3163,
            "ticket_number": "353156",
            "title": "Re: Cotação voos Porto-Barcelona",
            "priority": "P3",
            "created_at": "25/11/2025 12:40:59",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 12:40:59"
          },
          {
            "ticket_id": 3165,
            "ticket_number": "353158",
            "title": "GRUP-19437 Cotización GRUP-19418 - DJERBA - 25/11/",
            "priority": "P2",
            "created_at": "25/11/2025 13:09:35",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 17:02:52"
          },
          {
            "ticket_id": 3169,
            "ticket_number": "353162",
            "title": "Re: Cotação voos Lisboa/Barcelona",
            "priority": "P3",
            "created_at": "25/11/2025 13:14:39",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:14:39"
          },
          {
            "ticket_id": 3170,
            "ticket_number": "353163",
            "title": "SILVA GONCALVES/INES CARINA MRS 26NOV2025 MAD LIS",
            "priority": "P2",
            "created_at": "25/11/2025 13:16:50",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:26:14"
          },
          {
            "ticket_id": 3171,
            "ticket_number": "353164",
            "title": "HENRIQUES FALCAO/AFONSO MIGUEL MR 26NOV2025 MAD LI",
            "priority": "P3",
            "created_at": "25/11/2025 13:16:51",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:26:49"
          },
          {
            "ticket_id": 3175,
            "ticket_number": "353168",
            "title": "RE: Cotaçao de voos Lisboa Paris",
            "priority": "P3",
            "created_at": "25/11/2025 13:41:14",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:41:15"
          },
          {
            "ticket_id": 3176,
            "ticket_number": "353169",
            "title": "Fwd: Check in online for your flight to Lisbon on ",
            "priority": "P2",
            "created_at": "25/11/2025 13:41:17",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:41:18"
          },
          {
            "ticket_id": 3177,
            "ticket_number": "353170",
            "title": "Fwd: Check in online for your flight to Lisbon on ",
            "priority": "P2",
            "created_at": "25/11/2025 13:41:21",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:41:22"
          },
          {
            "ticket_id": 3184,
            "ticket_number": "353177",
            "title": "localizador NEWBLUE 6122762",
            "priority": "P3",
            "created_at": "25/11/2025 15:06:06",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 15:06:06"
          },
          {
            "ticket_id": 3186,
            "ticket_number": "353179",
            "title": "Re: Cotação voos Porto/Rio",
            "priority": "P3",
            "created_at": "25/11/2025 15:28:30",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 15:28:31"
          },
          {
            "ticket_id": 3197,
            "ticket_number": "353190",
            "title": "cotação de grupo Turkish",
            "priority": "P3",
            "created_at": "25/11/2025 17:31:02",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 18:19:24"
          },
          {
            "ticket_id": 3198,
            "ticket_number": "353191",
            "title": "OVER COMISSION NEW BLUE",
            "priority": "P3",
            "created_at": "25/11/2025 17:31:04",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 17:31:04"
          },
          {
            "ticket_id": 3245,
            "ticket_number": "353238",
            "title": "Re: Cotação voos Lisboa/Porto Santo",
            "priority": "P2",
            "created_at": "26/11/2025 10:24:57",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:24:58"
          },
          {
            "ticket_id": 3257,
            "ticket_number": "353250",
            "title": "Confirmação de reserva com localizador: 3932193",
            "priority": "P2",
            "created_at": "26/11/2025 11:04:23",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 21:01:53"
          },
          {
            "ticket_id": 3266,
            "ticket_number": "353259",
            "title": "Confirmação de reserva com localizador: 3986767",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 12:37:32",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 334.4,
            "sla_met": false,
            "sla_breach_hours": 310.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 11:02:09"
          },
          {
            "ticket_id": 3269,
            "ticket_number": "353262",
            "title": "Confirmação de reserva com localizador: 3986753",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 12:37:36",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 368.38,
            "sla_met": false,
            "sla_breach_hours": 344.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 21:00:48"
          },
          {
            "ticket_id": 3271,
            "ticket_number": "353264",
            "title": "Check-in On-line TAP * File 400707",
            "priority": "P2",
            "created_at": "26/11/2025 13:10:50",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 15:29:51"
          },
          {
            "ticket_id": 3273,
            "ticket_number": "353266",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 13:34:34",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 3.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/11/2025 17:00:11"
          },
          {
            "ticket_id": 3299,
            "ticket_number": "353292",
            "title": "Grupo: GR-B54F0D45D6",
            "priority": "P2",
            "created_at": "26/11/2025 17:00:47",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 19:31:36"
          },
          {
            "ticket_id": 3300,
            "ticket_number": "353293",
            "title": "Grupo: GR-E8B7CC8E5F",
            "priority": "P2",
            "created_at": "26/11/2025 17:00:49",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 19:06:49"
          },
          {
            "ticket_id": 3309,
            "ticket_number": "353302",
            "title": "GBN-91958 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "26/11/2025 19:05:12",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 15:02:52"
          },
          {
            "ticket_id": 3317,
            "ticket_number": "353310",
            "title": "Grupo: GR-CBDEFFE5D8",
            "priority": "P3",
            "created_at": "26/11/2025 19:06:51",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 19:31:38"
          },
          {
            "ticket_id": 3324,
            "ticket_number": "353317",
            "title": "[[ Ref:200418388 ]] Reservas de Grupo [pt]",
            "priority": "P2",
            "created_at": "26/11/2025 21:07:04",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 22:52:30"
          },
          {
            "ticket_id": 3337,
            "ticket_number": "353330",
            "title": "Re: Cotação voos Gig/Orly/Porto/Gig",
            "priority": "P2",
            "created_at": "26/11/2025 23:47:47",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:47:47"
          },
          {
            "ticket_id": 3341,
            "ticket_number": "353334",
            "title": "Reserva Travelplan - Felícia Fernandes",
            "priority": "P3",
            "created_at": "27/11/2025 00:36:49",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 00:39:26"
          },
          {
            "ticket_id": 3357,
            "ticket_number": "353350",
            "title": "cancelamento travelplan loc604500728",
            "priority": "P1",
            "created_at": "27/11/2025 10:55:14",
            "close_date": "2025-11-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.43,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P1",
            "first_response_at": "27/11/2025 11:21:27"
          },
          {
            "ticket_id": 3360,
            "ticket_number": "353353",
            "title": "Duvida rent a car Madeira SMY",
            "priority": "P2",
            "created_at": "27/11/2025 10:55:21",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 10:55:22"
          },
          {
            "ticket_id": 3363,
            "ticket_number": "353356",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60450072",
            "priority": "P2",
            "created_at": "27/11/2025 12:12:59",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 12:36:38"
          },
          {
            "ticket_id": 3364,
            "ticket_number": "353357",
            "title": "Orçamento Grupo",
            "priority": "P2",
            "created_at": "27/11/2025 12:13:01",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 12:13:01"
          },
          {
            "ticket_id": 3375,
            "ticket_number": "353368",
            "title": "Booking Id 6111313, Categoria: Incidência Pós Vend",
            "priority": "P3",
            "created_at": "27/11/2025 16:51:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 13:08:37"
          },
          {
            "ticket_id": 3382,
            "ticket_number": "353375",
            "title": "Excursões rimain tours ",
            "priority": "P3",
            "created_at": "27/11/2025 16:51:58",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 16:51:59"
          },
          {
            "ticket_id": 3383,
            "ticket_number": "353376",
            "title": "Informações sobre orçamento para grupos easyJet : ",
            "priority": "P2",
            "created_at": "27/11/2025 16:52:01",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 21:14:30"
          },
          {
            "ticket_id": 3392,
            "ticket_number": "353385",
            "title": "Fwd: Documentação da reserva TTN-1223216620#870710",
            "priority": "P2",
            "created_at": "27/11/2025 17:16:36",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 17:40:13"
          },
          {
            "ticket_id": 3426,
            "ticket_number": "353419",
            "title": "Fwd: Welcome to the Qatar Airways Trade Portal",
            "priority": "P3",
            "created_at": "28/11/2025 10:04:57",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 10:04:58"
          },
          {
            "ticket_id": 3428,
            "ticket_number": "353421",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "28/11/2025 10:05:01",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:05:02"
          },
          {
            "ticket_id": 3431,
            "ticket_number": "353424",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:06:16",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:30:18"
          },
          {
            "ticket_id": 3432,
            "ticket_number": "353425",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:06:17",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:44:35"
          },
          {
            "ticket_id": 3433,
            "ticket_number": "353426",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:06:19",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:45:48"
          },
          {
            "ticket_id": 3437,
            "ticket_number": "353430",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:07:01",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:48:16"
          },
          {
            "ticket_id": 3438,
            "ticket_number": "353431",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:07:02",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:50:04"
          },
          {
            "ticket_id": 3439,
            "ticket_number": "353432",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:07:03",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:51:37"
          },
          {
            "ticket_id": 3440,
            "ticket_number": "353433",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:07:05",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:53:00"
          },
          {
            "ticket_id": 3441,
            "ticket_number": "353434",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "28/11/2025 10:07:06",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:56:47"
          },
          {
            "ticket_id": 3450,
            "ticket_number": "353443",
            "title": "Fwd: NDC-2414 Agencia recem IATA a trabalhar com A",
            "priority": "P2",
            "created_at": "28/11/2025 11:52:41",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:52:41"
          },
          {
            "ticket_id": 3453,
            "ticket_number": "353446",
            "title": "Fwd: Confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 13:28:51",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 13:28:51"
          },
          {
            "ticket_id": 3461,
            "ticket_number": "353454",
            "title": "Pedido lePlan - 604477059",
            "priority": "P3",
            "created_at": "28/11/2025 13:29:16",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 13:29:17"
          },
          {
            "ticket_id": 3472,
            "ticket_number": "353465",
            "title": "Reserva localzador nr: 87493 documentação",
            "priority": "P2",
            "created_at": "28/11/2025 16:13:58",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 16:13:58"
          },
          {
            "ticket_id": 3491,
            "ticket_number": "353484",
            "title": "Confirmation of booking with locatorST4YDR0N",
            "priority": "P3",
            "created_at": "28/11/2025 19:14:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 91.87,
            "sla_met": false,
            "sla_breach_hours": 67.87,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 15:06:44"
          },
          {
            "ticket_id": 3493,
            "ticket_number": "353486",
            "title": "Confirmation of booking with locatorEY0BG2QP",
            "priority": "P3",
            "created_at": "28/11/2025 19:14:13",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 91.88,
            "sla_met": false,
            "sla_breach_hours": 67.88,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 15:07:27"
          },
          {
            "ticket_id": 3547,
            "ticket_number": "353540",
            "title": "Número de informação da reserva: 6124154",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 22:04:44",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 23:23:28"
          },
          {
            "ticket_id": 3594,
            "ticket_number": "353587",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "01/12/2025 11:32:42",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 11:32:42"
          },
          {
            "ticket_id": 3658,
            "ticket_number": "353651",
            "title": "Details about your upcoming flight",
            "priority": "P3",
            "created_at": "02/12/2025 10:24:55",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 4.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 15:23:00"
          },
          {
            "ticket_id": 3680,
            "ticket_number": "353672",
            "title": "CCP-74404 Fwd: Soltour.es - Localizador SPT0025015",
            "priority": "P2",
            "created_at": "02/12/2025 13:24:39",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 13:24:39"
          },
          {
            "ticket_id": 3689,
            "ticket_number": "353681",
            "title": "Orçamento grupo voos",
            "priority": "P2",
            "created_at": "02/12/2025 14:27:05",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:27:05"
          },
          {
            "ticket_id": 3696,
            "ticket_number": "353688",
            "title": "GBN-87712 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "02/12/2025 15:56:11",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:50:40"
          },
          {
            "ticket_id": 3697,
            "ticket_number": "353689",
            "title": "GBN-83808 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "02/12/2025 15:56:13",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:50:13"
          },
          {
            "ticket_id": 3698,
            "ticket_number": "353690",
            "title": "GBN-92865 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 15:56:15",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:48:46"
          },
          {
            "ticket_id": 3700,
            "ticket_number": "353692",
            "title": "Pedido de cancelamento Localizador GBN- 85951",
            "priority": "P2",
            "created_at": "02/12/2025 16:10:52",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 16:10:52"
          },
          {
            "ticket_id": 3711,
            "ticket_number": "353703",
            "title": "Re:[## 26330 ##] GBN-85951 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "02/12/2025 18:21:14",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:43:33"
          },
          {
            "ticket_id": 3713,
            "ticket_number": "353705",
            "title": "GBN-85951 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "02/12/2025 18:21:20",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:43:49"
          },
          {
            "ticket_id": 3714,
            "ticket_number": "353706",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 19:01:31",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 19:01:31"
          },
          {
            "ticket_id": 3715,
            "ticket_number": "353707",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "02/12/2025 19:01:36",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:01:36"
          },
          {
            "ticket_id": 3716,
            "ticket_number": "353708",
            "title": "LOCALIZADOR 409435 E 408831",
            "priority": "P3",
            "created_at": "02/12/2025 19:02:12",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:02:13"
          },
          {
            "ticket_id": 3720,
            "ticket_number": "353712",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604507045",
            "priority": "P2",
            "created_at": "02/12/2025 21:27:18",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 00:21:42"
          },
          {
            "ticket_id": 3722,
            "ticket_number": "353714",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 21:27:27",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 21:27:17"
          },
          {
            "ticket_id": 3728,
            "ticket_number": "353720",
            "title": "Criação de processo File 420365/25",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 23:24:08",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 43.33,
            "sla_met": false,
            "sla_breach_hours": 19.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 18:44:10"
          },
          {
            "ticket_id": 3735,
            "ticket_number": "353727",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 23:50:13",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 23:51:26"
          },
          {
            "ticket_id": 3736,
            "ticket_number": "353728",
            "title": "Fwd: Viagify informa sobre a sua reserva 122501470",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 00:02:01",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 00:02:02"
          },
          {
            "ticket_id": 3750,
            "ticket_number": "353742",
            "title": "Your personal travel information for Lisbon – Muni",
            "priority": "P3",
            "created_at": "03/12/2025 10:06:18",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 12:04:58"
          },
          {
            "ticket_id": 3757,
            "ticket_number": "353749",
            "title": "Fwd: Informações da reserva TTN-1204060360#8674102",
            "priority": "P2",
            "created_at": "03/12/2025 11:09:08",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 11:09:08"
          },
          {
            "ticket_id": 3758,
            "ticket_number": "353750",
            "title": "Fwd: Informações da reserva TTN-1204060360#8674102",
            "priority": "P2",
            "created_at": "03/12/2025 11:09:10",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 11:09:10"
          },
          {
            "ticket_id": 3759,
            "ticket_number": "353751",
            "title": "Fwd: Informações da reserva TTN-1222531875#8713162",
            "priority": "P2",
            "created_at": "03/12/2025 11:09:12",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 11:09:12"
          },
          {
            "ticket_id": 3760,
            "ticket_number": "353752",
            "title": "Fwd: Informações da reserva TTN-1204060360#8674102",
            "priority": "P2",
            "created_at": "03/12/2025 11:09:14",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 11:09:15"
          },
          {
            "ticket_id": 3772,
            "ticket_number": "353764",
            "title": "Fwd: Viagify informa sobre a sua reserva 122511244",
            "priority": "P1",
            "created_at": "03/12/2025 13:20:33",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 13:20:34"
          },
          {
            "ticket_id": 3773,
            "ticket_number": "353765",
            "title": "Fwd: Confirmação de reserva: a sua viajem para Par",
            "priority": "P3",
            "created_at": "03/12/2025 13:21:41",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 13:21:41"
          },
          {
            "ticket_id": 3780,
            "ticket_number": "353772",
            "title": "Fwd: Informações da reserva TTN-1222531875#8713162",
            "priority": "P3",
            "created_at": "03/12/2025 14:23:33",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 14:23:35"
          },
          {
            "ticket_id": 3797,
            "ticket_number": "353789",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1225112440#87",
            "priority": "P1",
            "created_at": "03/12/2025 16:35:19",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 16:35:19"
          },
          {
            "ticket_id": 3855,
            "ticket_number": "353847",
            "title": "Grupo: GR-3B309801B3",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:34",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:43:51"
          },
          {
            "ticket_id": 3858,
            "ticket_number": "353850",
            "title": "Grupo: GR-A227C04511",
            "priority": "P3",
            "created_at": "04/12/2025 10:09:32",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 13:41:01"
          },
          {
            "ticket_id": 3859,
            "ticket_number": "353851",
            "title": "Pedido de hotel/cotação",
            "priority": "P3",
            "created_at": "04/12/2025 11:18:38",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 11:18:38"
          },
          {
            "ticket_id": 3861,
            "ticket_number": "353853",
            "title": "Fwd: Informações da reserva TTN-1225273071#8762317",
            "priority": "P1",
            "created_at": "04/12/2025 11:18:43",
            "close_date": "2025-12-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/12/2025 11:18:44"
          },
          {
            "ticket_id": 3868,
            "ticket_number": "353860",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P3",
            "created_at": "04/12/2025 11:48:26",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 11:48:26"
          },
          {
            "ticket_id": 3881,
            "ticket_number": "353873",
            "title": "Fwd: Confirmacion de la reserva Transavia: E9NQSS",
            "priority": "P3",
            "created_at": "04/12/2025 15:02:27",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 15:02:27"
          },
          {
            "ticket_id": 3883,
            "ticket_number": "353875",
            "title": "New ticket comment: Booking Reference 6KVF3QAMGG",
            "priority": "P3",
            "created_at": "04/12/2025 15:15:09",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 16:46:20"
          },
          {
            "ticket_id": 3900,
            "ticket_number": "353892",
            "title": "ZS53YG – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "04/12/2025 19:06:52",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 19:06:52"
          },
          {
            "ticket_id": 3909,
            "ticket_number": "353901",
            "title": "Fwd: Ryanair 70710203/Katia Rodrigues/Katia Rodrig",
            "priority": "P3",
            "created_at": "04/12/2025 21:42:17",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 21:42:18"
          },
          {
            "ticket_id": 3914,
            "ticket_number": "353906",
            "title": "Re: [External]:Re: Group Quotation Request",
            "priority": "P3",
            "created_at": "04/12/2025 22:15:52",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 11.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:12:08"
          },
          {
            "ticket_id": 3923,
            "ticket_number": "353915",
            "title": "Pedido de cotação Consolidador",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:35",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:53:10"
          },
          {
            "ticket_id": 3925,
            "ticket_number": "353917",
            "title": "Your flight is ready for check-in | From Lisbon to",
            "priority": "P3",
            "created_at": "05/12/2025 10:10:11",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:34:55"
          },
          {
            "ticket_id": 3926,
            "ticket_number": "353918",
            "title": "Your flight is ready for check-in | From Lisbon to",
            "priority": "P3",
            "created_at": "05/12/2025 10:10:14",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:35:01"
          },
          {
            "ticket_id": 3927,
            "ticket_number": "353919",
            "title": "Your flight is ready for check-in | From Lisbon to",
            "priority": "P3",
            "created_at": "05/12/2025 10:10:16",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:35:16"
          },
          {
            "ticket_id": 3928,
            "ticket_number": "353920",
            "title": "Your flight is ready for check-in | From Lisbon to",
            "priority": "P3",
            "created_at": "05/12/2025 10:10:19",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:35:27"
          },
          {
            "ticket_id": 3932,
            "ticket_number": "353924",
            "title": "RV: Foi feito o seguinte pedido de reserva de grup",
            "priority": "P3",
            "created_at": "05/12/2025 11:08:00",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 12:54:48"
          },
          {
            "ticket_id": 3934,
            "ticket_number": "353926",
            "title": "Check in carry-on baggage free of charge for your ",
            "priority": "P3",
            "created_at": "05/12/2025 11:32:11",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 13:01:04"
          },
          {
            "ticket_id": 3935,
            "ticket_number": "353927",
            "title": "Check in carry-on baggage free of charge for your ",
            "priority": "P3",
            "created_at": "05/12/2025 11:32:14",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 13:00:24"
          },
          {
            "ticket_id": 3952,
            "ticket_number": "353944",
            "title": "Fwd: Viagify informa sobre a sua reserva 122565889",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/12/2025 13:52:28",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 13:52:28"
          },
          {
            "ticket_id": 3974,
            "ticket_number": "353966",
            "title": "RES: reserva duplicada Mr Jorge dos Santos e Mrs M",
            "priority": "P3",
            "created_at": "05/12/2025 18:50:30",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 89.4,
            "sla_met": false,
            "sla_breach_hours": 65.4,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 12:14:47"
          },
          {
            "ticket_id": 3978,
            "ticket_number": "353970",
            "title": "reserva duplicada Mr Jorge dos Santos e Mrs Maria ",
            "priority": "P3",
            "created_at": "05/12/2025 19:22:23",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 85.48,
            "sla_met": false,
            "sla_breach_hours": 61.48,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 08:52:08"
          },
          {
            "ticket_id": 4015,
            "ticket_number": "354007",
            "title": "Pedido de Reserva de Voos IATA - Faro e Porto para",
            "priority": "P3",
            "created_at": "07/12/2025 10:14:09",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/12/2025 10:14:10"
          },
          {
            "ticket_id": 4035,
            "ticket_number": "354027",
            "title": "Fwd: Quote reminder 70710203",
            "priority": "P3",
            "created_at": "08/12/2025 13:22:04",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/12/2025 13:22:05"
          },
          {
            "ticket_id": 4047,
            "ticket_number": "354039",
            "title": "ZS53YG – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "09/12/2025 10:25:56",
            "close_date": "2025-12-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.58,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA P1",
            "first_response_at": "09/12/2025 11:01:10"
          },
          {
            "ticket_id": 4051,
            "ticket_number": "354043",
            "title": "Localizador: 1210276553 - smy",
            "priority": "P2",
            "created_at": "09/12/2025 10:26:06",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 10:26:07"
          },
          {
            "ticket_id": 4058,
            "ticket_number": "354050",
            "title": "FW: Multibanco - File   420075  /25",
            "priority": "P3",
            "created_at": "09/12/2025 10:55:16",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 12:02:55"
          },
          {
            "ticket_id": 4109,
            "ticket_number": "354101",
            "title": "Re: Cotação voos",
            "priority": "P2",
            "created_at": "09/12/2025 19:41:40",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 19:41:41"
          },
          {
            "ticket_id": 4131,
            "ticket_number": "354123",
            "title": "Fwd: easyJet número de referência da reserva: KBPJ",
            "priority": "P2",
            "created_at": "10/12/2025 10:28:27",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 10:28:27"
          },
          {
            "ticket_id": 4133,
            "ticket_number": "354125",
            "title": "Fwd: easyJet número de referência da reserva: KBPJ",
            "priority": "P3",
            "created_at": "10/12/2025 10:28:37",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 10:28:37"
          },
          {
            "ticket_id": 4169,
            "ticket_number": "354161",
            "title": "Fwd: URRWXV | Atualização importante para todos os",
            "priority": "P3",
            "created_at": "10/12/2025 16:13:54",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 16:13:56"
          },
          {
            "ticket_id": 4198,
            "ticket_number": "354190",
            "title": "Re: Cotaçao voos Porto-Ponta Delgada-Porto",
            "priority": "P2",
            "created_at": "10/12/2025 19:28:55",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 19:28:55"
          },
          {
            "ticket_id": 4213,
            "ticket_number": "354205",
            "title": "Cancelamento excursão - URGENTE",
            "priority": "P1",
            "created_at": "11/12/2025 10:09:52",
            "close_date": "2025-12-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/12/2025 10:09:52"
          },
          {
            "ticket_id": 4217,
            "ticket_number": "354209",
            "title": "ENVIO DE COTAÇÃO - GRP ESTUDANTES - MAD - ID 10208",
            "priority": "P2",
            "created_at": "11/12/2025 11:04:44",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 22:01:37"
          },
          {
            "ticket_id": 4235,
            "ticket_number": "354227",
            "title": "Aéreo - Confirmação de Emissão (CABRAL DOS SANTOS\\",
            "priority": "P3",
            "created_at": "11/12/2025 17:37:28",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 17:37:45"
          },
          {
            "ticket_id": 4263,
            "ticket_number": "354255",
            "title": "Fwd: Alteraçao de horarios TTN-1165822742#81169139",
            "priority": "P3",
            "created_at": "12/12/2025 10:24:32",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:24:32"
          },
          {
            "ticket_id": 4269,
            "ticket_number": "354261",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "12/12/2025 10:28:39",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 12:09:38"
          },
          {
            "ticket_id": 4270,
            "ticket_number": "354262",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "12/12/2025 10:28:41",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 12:09:52"
          },
          {
            "ticket_id": 4272,
            "ticket_number": "354264",
            "title": "GBN-85535 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "12/12/2025 11:28:16",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 7.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 18:48:39"
          },
          {
            "ticket_id": 4284,
            "ticket_number": "354276",
            "title": "RESERVA LEPLAN 604492196 8/1",
            "priority": "P2",
            "created_at": "12/12/2025 12:19:09",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:58:27"
          },
          {
            "ticket_id": 4294,
            "ticket_number": "354286",
            "title": "RESERVA LEPLAN 604467115 28/1",
            "priority": "P2",
            "created_at": "12/12/2025 14:11:19",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:57:31"
          },
          {
            "ticket_id": 4299,
            "ticket_number": "354291",
            "title": "Fwd: Localizador 1205948457 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "12/12/2025 14:11:29",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:11:29"
          },
          {
            "ticket_id": 2078,
            "ticket_number": "352074",
            "title": "Re: Pedido cotação de voo Iberia",
            "priority": "P3",
            "created_at": "10/11/2025 10:11:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 10:11:01"
          },
          {
            "ticket_id": 2126,
            "ticket_number": "352122",
            "title": "Re: 387305 - // Uma Familia em Viagem - Viagem par",
            "priority": "P2",
            "created_at": "10/11/2025 13:59:03",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 14:06:50"
          },
          {
            "ticket_id": 3213,
            "ticket_number": "353206",
            "title": "Número de informação da reserva: 6122906",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 21:17:35",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 163.27,
            "sla_met": false,
            "sla_breach_hours": 139.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 16:33:49"
          },
          {
            "ticket_id": 3218,
            "ticket_number": "353211",
            "title": "Número de informação da reserva: 6122921",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 22:44:17",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 18:41:38"
          },
          {
            "ticket_id": 3346,
            "ticket_number": "353339",
            "title": "GBN-92041 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "27/11/2025 10:54:33",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 20:43:25"
          },
          {
            "ticket_id": 3543,
            "ticket_number": "353536",
            "title": "GBN-83789 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "29/11/2025 19:50:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 16:58:54"
          },
          {
            "ticket_id": 3544,
            "ticket_number": "353537",
            "title": "Fwd: Viagify informa sobre a sua reserva 122398339",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 19:51:29",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 19:51:29"
          },
          {
            "ticket_id": 3549,
            "ticket_number": "353542",
            "title": "GBN-92628 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 23:16:50",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 306.77,
            "sla_met": false,
            "sla_breach_hours": 282.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 18:02:52"
          },
          {
            "ticket_id": 3706,
            "ticket_number": "353698",
            "title": "pedido de orçamento de grupo",
            "priority": "P3",
            "created_at": "02/12/2025 17:51:08",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:51:08"
          },
          {
            "ticket_id": 3761,
            "ticket_number": "353753",
            "title": "Informação Reserva WL - File 335177",
            "priority": "P2",
            "created_at": "03/12/2025 12:27:54",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 14:43:43"
          },
          {
            "ticket_id": 3784,
            "ticket_number": "353776",
            "title": "viagem grupo 2026",
            "priority": "P3",
            "created_at": "03/12/2025 14:23:45",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 14:23:46"
          },
          {
            "ticket_id": 3863,
            "ticket_number": "353855",
            "title": "Fwd: Incidente voo TTN-1219922927#87583318#T161233",
            "priority": "P3",
            "created_at": "04/12/2025 11:18:48",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 11:18:49"
          },
          {
            "ticket_id": 3895,
            "ticket_number": "353887",
            "title": "Fwd: Request received for Katia Rodrigues",
            "priority": "P3",
            "created_at": "04/12/2025 18:17:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 18:17:46"
          },
          {
            "ticket_id": 3905,
            "ticket_number": "353897",
            "title": "Re: Cotação voos Lisboa/Barcelona",
            "priority": "P2",
            "created_at": "04/12/2025 21:23:09",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:23:10"
          },
          {
            "ticket_id": 3907,
            "ticket_number": "353899",
            "title": "Re: Cotação voos Lisboa /Barcelona/Lisboa",
            "priority": "P2",
            "created_at": "04/12/2025 21:23:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:23:15"
          },
          {
            "ticket_id": 3924,
            "ticket_number": "353916",
            "title": "Grupo: GR-D291A3ACF7",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:37",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:09:35"
          },
          {
            "ticket_id": 3953,
            "ticket_number": "353945",
            "title": "Re:[## 26580 ##] GBN-86003 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "05/12/2025 13:52:32",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 14:28:49"
          },
          {
            "ticket_id": 3966,
            "ticket_number": "353958",
            "title": "GBN-85066 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "05/12/2025 17:50:31",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 15:08:15"
          },
          {
            "ticket_id": 3988,
            "ticket_number": "353980",
            "title": "Fwd: Incidência do voo localizador 1219922927 TTN-",
            "priority": "P2",
            "created_at": "05/12/2025 23:06:20",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 23:06:21"
          },
          {
            "ticket_id": 4105,
            "ticket_number": "354097",
            "title": "ZBTGAY – Novo prazo de emissão",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 18:48:20",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 18:48:55"
          },
          {
            "ticket_id": 4172,
            "ticket_number": "354164",
            "title": "Fwd: Uma familia em viagem - Seller Ui",
            "priority": "P2",
            "created_at": "10/12/2025 16:21:54",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 16:21:54"
          },
          {
            "ticket_id": 4175,
            "ticket_number": "354167",
            "title": "Fwd: Ryanair 70856648/Liliana Santos-Viaja mais /L",
            "priority": "P3",
            "created_at": "10/12/2025 17:28:42",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 17:28:42"
          },
          {
            "ticket_id": 4227,
            "ticket_number": "354219",
            "title": "Re:[## 27026 ##] GBN-65670 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/12/2025 13:59:00",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 22:59:12"
          },
          {
            "ticket_id": 4242,
            "ticket_number": "354234",
            "title": "Cotización DINIS - cntravel -Ref 17015571 -Uma Fam",
            "priority": "P2",
            "created_at": "11/12/2025 18:33:27",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 18:40:44"
          },
          {
            "ticket_id": 4249,
            "ticket_number": "354241",
            "title": "GBN-91958 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/12/2025 20:18:49",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 426.45,
            "sla_met": false,
            "sla_breach_hours": 422.45,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 14:46:39"
          },
          {
            "ticket_id": 4256,
            "ticket_number": "354248",
            "title": "Alteração de horário de voo 14-12",
            "priority": "P2",
            "created_at": "12/12/2025 10:06:25",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 10:06:26"
          },
          {
            "ticket_id": 4289,
            "ticket_number": "354281",
            "title": "Fwd: Cancelamento de voo TTN-1199788755#88185599#T",
            "priority": "P2",
            "created_at": "12/12/2025 13:06:26",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 13:06:27"
          },
          {
            "ticket_id": 4305,
            "ticket_number": "354297",
            "title": "Fwd: Informações da reserva TTN-1199788755#8821343",
            "priority": "P1",
            "created_at": "12/12/2025 15:33:15",
            "close_date": "2026-01-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/12/2025 15:33:16"
          },
          {
            "ticket_id": 4308,
            "ticket_number": "354300",
            "title": "RE: Goup Cotation",
            "priority": "P3",
            "created_at": "12/12/2025 16:13:59",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 18:44:04"
          },
          {
            "ticket_id": 4383,
            "ticket_number": "354375",
            "title": "Erro na data do bilhete?",
            "priority": "P2",
            "created_at": "15/12/2025 10:08:55",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:08:55"
          },
          {
            "ticket_id": 4384,
            "ticket_number": "354376",
            "title": "RE: Goup Cotation",
            "priority": "P2",
            "created_at": "15/12/2025 10:09:56",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:24:55"
          },
          {
            "ticket_id": 4401,
            "ticket_number": "354393",
            "title": "Fwd: Reservas de Grupos pendentes de aceitação",
            "priority": "P2",
            "created_at": "15/12/2025 10:55:55",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:55:55"
          },
          {
            "ticket_id": 4404,
            "ticket_number": "354396",
            "title": "Fwd: MODIFICACION *** TTN-1221160476#87714735#T161",
            "priority": "P2",
            "created_at": "15/12/2025 10:56:01",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:56:02"
          },
          {
            "ticket_id": 4405,
            "ticket_number": "354397",
            "title": "Fwd: Viagify informa sobre a sua reserva 122752786",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/12/2025 10:56:05",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 10:56:05"
          },
          {
            "ticket_id": 4414,
            "ticket_number": "354406",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "15/12/2025 12:40:51",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 12:42:39"
          },
          {
            "ticket_id": 4417,
            "ticket_number": "354409",
            "title": "Subject. Soltour: Modificação de Voos: SPT00250154",
            "priority": "P2",
            "created_at": "15/12/2025 12:45:15",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:09:57"
          },
          {
            "ticket_id": 4420,
            "ticket_number": "354412",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P2",
            "created_at": "15/12/2025 12:59:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 12:59:59"
          },
          {
            "ticket_id": 4428,
            "ticket_number": "354420",
            "title": "Re:[## 27026 ##] GBN-65670 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "15/12/2025 13:50:59",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 16:21:30"
          },
          {
            "ticket_id": 4432,
            "ticket_number": "354424",
            "title": "Fwd: RE: [EXTERNAL] pedido cotação de grupo",
            "priority": "P2",
            "created_at": "15/12/2025 13:51:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 10:19:08"
          },
          {
            "ticket_id": 4442,
            "ticket_number": "354434",
            "title": "RE: Criação de processo File 407089/25",
            "priority": "P2",
            "created_at": "15/12/2025 16:02:12",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 16:15:04"
          },
          {
            "ticket_id": 4447,
            "ticket_number": "354439",
            "title": "Alteração de nome",
            "priority": "P2",
            "created_at": "15/12/2025 18:09:42",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:09:42"
          },
          {
            "ticket_id": 4457,
            "ticket_number": "354449",
            "title": "Fwd: Informações da reserva TTN-1185483527#8837141",
            "priority": "P2",
            "created_at": "15/12/2025 18:25:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:25:59"
          },
          {
            "ticket_id": 4463,
            "ticket_number": "354455",
            "title": "RE: Cotação voos Lisboa-Ponta Delgada",
            "priority": "P3",
            "created_at": "15/12/2025 19:58:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 19:58:14"
          },
          {
            "ticket_id": 4478,
            "ticket_number": "354470",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "16/12/2025 10:13:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 10:19:54"
          },
          {
            "ticket_id": 4489,
            "ticket_number": "354481",
            "title": "File 39520 - Ribeiro/JoaoRicardoMagalhaesMR - Paco",
            "priority": "P2",
            "created_at": "16/12/2025 11:27:51",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 12:19:45"
          },
          {
            "ticket_id": 4490,
            "ticket_number": "354482",
            "title": "Localizador 604511198 - Leplan - Pedido especial",
            "priority": "P3",
            "created_at": "16/12/2025 11:27:53",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 11:27:53"
          },
          {
            "ticket_id": 4497,
            "ticket_number": "354489",
            "title": "Fwd: Proteja sua viagem por apenas 34.44 EUR",
            "priority": "P2",
            "created_at": "16/12/2025 13:18:07",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 13:18:08"
          },
          {
            "ticket_id": 4500,
            "ticket_number": "354492",
            "title": "Horário Transfer - 1210276553 SMY",
            "priority": "P2",
            "created_at": "16/12/2025 15:41:48",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 15:41:49"
          },
          {
            "ticket_id": 4594,
            "ticket_number": "354586",
            "title": "PERDIGAO/CAROLINA 09JUN LIS PDL",
            "priority": "P2",
            "created_at": "18/12/2025 16:42:29",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 17:01:20"
          },
          {
            "ticket_id": 4595,
            "ticket_number": "354587",
            "title": "PERDIGAO/JOSE MR 09JUN LIS PDL",
            "priority": "P2",
            "created_at": "18/12/2025 16:42:30",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 17:01:55"
          },
          {
            "ticket_id": 4596,
            "ticket_number": "354588",
            "title": "PERDIGAO/CAROLINA 09JUN LIS PDL",
            "priority": "P3",
            "created_at": "18/12/2025 16:42:32",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 5.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 22:07:51"
          },
          {
            "ticket_id": 4597,
            "ticket_number": "354589",
            "title": "FONSECA/SOFIA MRS 09JUN LIS PDL",
            "priority": "P3",
            "created_at": "18/12/2025 16:42:33",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 5.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 22:07:28"
          },
          {
            "ticket_id": 4598,
            "ticket_number": "354590",
            "title": "FONSECA/SOFIA MRS 09JUN LIS PDL",
            "priority": "P2",
            "created_at": "18/12/2025 16:42:35",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 17:02:25"
          },
          {
            "ticket_id": 4616,
            "ticket_number": "354608",
            "title": "AEGEAN Hub | Request status update",
            "priority": "P3",
            "created_at": "19/12/2025 10:16:23",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 14:02:09"
          },
          {
            "ticket_id": 4670,
            "ticket_number": "354662",
            "title": "Reserva Aérea YV7JUQ",
            "priority": "P2",
            "created_at": "20/12/2025 18:45:33",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 47.63,
            "sla_met": false,
            "sla_breach_hours": 43.63,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:23:57"
          },
          {
            "ticket_id": 4722,
            "ticket_number": "354714",
            "title": "Re: Cotaçao voos Porto/stansteed",
            "priority": "P2",
            "created_at": "22/12/2025 16:25:54",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 16:25:54"
          },
          {
            "ticket_id": 4724,
            "ticket_number": "354716",
            "title": "Aéreo - Confirmação de Emissão (MATA\\CARLA) - YV7J",
            "priority": "P3",
            "created_at": "22/12/2025 16:50:18",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 19:10:33"
          },
          {
            "ticket_id": 4725,
            "ticket_number": "354717",
            "title": "Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "22/12/2025 16:50:21",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 19:12:16"
          },
          {
            "ticket_id": 4726,
            "ticket_number": "354718",
            "title": "Aéreo - Confirmação de Emissão (MATA\\HENRIQUE) - Y",
            "priority": "P3",
            "created_at": "22/12/2025 16:50:23",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 19:11:28"
          },
          {
            "ticket_id": 4727,
            "ticket_number": "354719",
            "title": "Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "22/12/2025 16:50:27",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 19:12:47"
          },
          {
            "ticket_id": 4732,
            "ticket_number": "354724",
            "title": "A/c Catia Leal - DEvolução GBN-56702",
            "priority": "P3",
            "created_at": "22/12/2025 17:41:00",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 16.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 10:05:00"
          },
          {
            "ticket_id": 4741,
            "ticket_number": "354733",
            "title": "Fwd: DCPTFTGZ01 Group Request Confirmation",
            "priority": "P2",
            "created_at": "22/12/2025 19:17:20",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 19:17:21"
          },
          {
            "ticket_id": 4754,
            "ticket_number": "354746",
            "title": "Reserva Aérea ZWRAGB",
            "priority": "P2",
            "created_at": "22/12/2025 21:09:31",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 11:01:27"
          },
          {
            "ticket_id": 4756,
            "ticket_number": "354748",
            "title": "DQ2S9K – Alteração de Horário – Aceite",
            "priority": "P2",
            "created_at": "22/12/2025 21:10:06",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 23:39:01"
          },
          {
            "ticket_id": 4763,
            "ticket_number": "354755",
            "title": "Fwd: Your request DCPTFTGZ01 has been changed",
            "priority": "P3",
            "created_at": "23/12/2025 10:25:38",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 10:25:38"
          },
          {
            "ticket_id": 4829,
            "ticket_number": "354821",
            "title": "Compra viagens IATA - Sofia +Sandra",
            "priority": "P1",
            "created_at": "26/12/2025 10:54:21",
            "close_date": "2025-12-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/12/2025 10:54:22"
          },
          {
            "ticket_id": 4843,
            "ticket_number": "354835",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "26/12/2025 13:28:59",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 13:29:01"
          },
          {
            "ticket_id": 4845,
            "ticket_number": "354837",
            "title": "Fwd: easyJet número de referência da reserva: KBRH",
            "priority": "P3",
            "created_at": "26/12/2025 13:29:28",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 13:29:29"
          },
          {
            "ticket_id": 4846,
            "ticket_number": "354838",
            "title": "Fwd: easyJet número de referência da reserva: KBRH",
            "priority": "P3",
            "created_at": "26/12/2025 13:29:31",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 13:29:32"
          },
          {
            "ticket_id": 4851,
            "ticket_number": "354843",
            "title": "Re: Cotação grupo voos Iberia",
            "priority": "P3",
            "created_at": "26/12/2025 15:03:13",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 15:03:13"
          },
          {
            "ticket_id": 4865,
            "ticket_number": "354857",
            "title": "Fwd: DCPTFTSD01 Group Request Confirmation",
            "priority": "P2",
            "created_at": "26/12/2025 17:58:46",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:58:47"
          },
          {
            "ticket_id": 4906,
            "ticket_number": "354898",
            "title": "Fwd: Informações da reserva TTN-1223385210#8905586",
            "priority": "P2",
            "created_at": "29/12/2025 10:11:53",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:11:55"
          },
          {
            "ticket_id": 4913,
            "ticket_number": "354905",
            "title": "File 39720 - Simoes/LuisManuelLopesMR - Pacote (S.",
            "priority": "P1",
            "created_at": "29/12/2025 10:12:15",
            "close_date": "2026-01-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.32,
            "sla_met": false,
            "sla_breach_hours": 2.07,
            "sla_name": "SLA P1",
            "first_response_at": "29/12/2025 12:32:08"
          },
          {
            "ticket_id": 4942,
            "ticket_number": "354934",
            "title": "Fwd: Viagify informa sobre a sua reserva 123011089",
            "priority": "P3",
            "created_at": "29/12/2025 16:26:33",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/12/2025 16:26:34"
          },
          {
            "ticket_id": 4966,
            "ticket_number": "354958",
            "title": "Re: Cotação voo Lisboa/Fortaleza",
            "priority": "P3",
            "created_at": "30/12/2025 10:10:38",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 10:10:38"
          },
          {
            "ticket_id": 4982,
            "ticket_number": "354974",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "30/12/2025 15:59:42",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 17:08:55"
          },
          {
            "ticket_id": 4989,
            "ticket_number": "354981",
            "title": "NOVO INCIDENTE: Amadeus Web Services: Tempo de res",
            "priority": "P2",
            "created_at": "30/12/2025 18:42:31",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 18:56:02"
          },
          {
            "ticket_id": 5009,
            "ticket_number": "355001",
            "title": "Erro do email da cliente",
            "priority": "P2",
            "created_at": "30/12/2025 23:52:18",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 23:52:18"
          },
          {
            "ticket_id": 5011,
            "ticket_number": "355003",
            "title": "GBN-92201 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "31/12/2025 10:01:56",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 51.0,
            "sla_met": false,
            "sla_breach_hours": 47.0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 13:02:12"
          },
          {
            "ticket_id": 5020,
            "ticket_number": "355012",
            "title": "Fwd: NDC Registrations Status Update to REJECTED L",
            "priority": "P2",
            "created_at": "31/12/2025 11:48:38",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 11:48:39"
          },
          {
            "ticket_id": 5021,
            "ticket_number": "355013",
            "title": "Fwd: NDC Registrations Status Update to REJECTED L",
            "priority": "P2",
            "created_at": "31/12/2025 11:48:40",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 11:48:40"
          },
          {
            "ticket_id": 5039,
            "ticket_number": "355031",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604456534",
            "priority": "P2",
            "created_at": "02/01/2026 10:39:35",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 7.8,
            "sla_met": false,
            "sla_breach_hours": 3.8,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 18:28:23"
          },
          {
            "ticket_id": 5042,
            "ticket_number": "355034",
            "title": "Fwd: Documentación Reserva: 6125427",
            "priority": "P2",
            "created_at": "02/01/2026 11:58:58",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:44:44"
          },
          {
            "ticket_id": 5046,
            "ticket_number": "355038",
            "title": "Fwd: Flygroups – Reserva guardada",
            "priority": "P2",
            "created_at": "02/01/2026 12:37:47",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:37:48"
          },
          {
            "ticket_id": 5054,
            "ticket_number": "355046",
            "title": "Re: Cotação voos Lisboa/Florença Bolonha/Lisboa",
            "priority": "P2",
            "created_at": "02/01/2026 13:37:04",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 13:37:05"
          },
          {
            "ticket_id": 5057,
            "ticket_number": "355049",
            "title": "Cancelamento de viagem",
            "priority": "P2",
            "created_at": "02/01/2026 16:45:56",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 16:45:57"
          },
          {
            "ticket_id": 5061,
            "ticket_number": "355053",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "P2",
            "created_at": "02/01/2026 16:53:56",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 147.23,
            "sla_met": false,
            "sla_breach_hours": 143.23,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 20:08:10"
          },
          {
            "ticket_id": 5062,
            "ticket_number": "355054",
            "title": "ZGACID – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "02/01/2026 18:43:05",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 306.93,
            "sla_met": false,
            "sla_breach_hours": 302.93,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:39:35"
          },
          {
            "ticket_id": 5063,
            "ticket_number": "355055",
            "title": "Reserva Aérea ZGACID",
            "priority": "P2",
            "created_at": "02/01/2026 18:43:10",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 22:43:07"
          },
          {
            "ticket_id": 5078,
            "ticket_number": "355070",
            "title": "Re: Cotação voo Porto /Salvador/Porto",
            "priority": "P2",
            "created_at": "02/01/2026 20:11:43",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 20:11:43"
          },
          {
            "ticket_id": 5079,
            "ticket_number": "355071",
            "title": "Re: Cotaçao voo GIG/ORY/OPO/GIG",
            "priority": "P2",
            "created_at": "02/01/2026 20:14:21",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 20:14:22"
          },
          {
            "ticket_id": 5153,
            "ticket_number": "355145",
            "title": "pedido de esclarecimento",
            "priority": "P2",
            "created_at": "05/01/2026 11:30:51",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 11:30:51"
          },
          {
            "ticket_id": 5155,
            "ticket_number": "355147",
            "title": "CAMBIO EN REFERENCIA , LOC 4018504",
            "priority": "P2",
            "created_at": "05/01/2026 12:02:30",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 12:02:30"
          },
          {
            "ticket_id": 5159,
            "ticket_number": "355151",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P3",
            "created_at": "05/01/2026 12:57:32",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 12:57:33"
          },
          {
            "ticket_id": 5189,
            "ticket_number": "355181",
            "title": "Pedido de faturas easyjet - Hurghada",
            "priority": "P2",
            "created_at": "05/01/2026 21:31:42",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 21:31:42"
          },
          {
            "ticket_id": 5192,
            "ticket_number": "355184",
            "title": "Re: Cotacao Voos Porto Praga/Viena",
            "priority": "P3",
            "created_at": "06/01/2026 00:44:12",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 00:44:12"
          },
          {
            "ticket_id": 5226,
            "ticket_number": "355218",
            "title": "Fwd: Fly Groups - PT25123112701041 - Agent says:",
            "priority": "P2",
            "created_at": "06/01/2026 15:16:09",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:16:09"
          },
          {
            "ticket_id": 5235,
            "ticket_number": "355227",
            "title": "Re: Cotaçao voos",
            "priority": "P2",
            "created_at": "06/01/2026 15:50:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:50:07"
          },
          {
            "ticket_id": 5239,
            "ticket_number": "355231",
            "title": "Fwd: Fly Groups - PT25123112701041 - Agent says:",
            "priority": "P2",
            "created_at": "06/01/2026 16:56:43",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 16:56:44"
          },
          {
            "ticket_id": 5240,
            "ticket_number": "355232",
            "title": "Fwd: Your request DCPTFTSD01 has been changed",
            "priority": "P2",
            "created_at": "06/01/2026 16:57:17",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 16:57:17"
          },
          {
            "ticket_id": 5245,
            "ticket_number": "355237",
            "title": "Reserva Leplan 604420884",
            "priority": "P3",
            "created_at": "06/01/2026 17:34:23",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 17:34:23"
          },
          {
            "ticket_id": 5247,
            "ticket_number": "355239",
            "title": "Fwd: Fly Groups - PT25123112701041 - TAP says:",
            "priority": "P2",
            "created_at": "06/01/2026 17:34:32",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 17:34:32"
          },
          {
            "ticket_id": 5250,
            "ticket_number": "355242",
            "title": "CONTROLO RESERVAS... - 881.60 - 04/09/2025 400 - 0",
            "priority": "P2",
            "created_at": "06/01/2026 18:22:50",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 22:22:38"
          },
          {
            "ticket_id": 5256,
            "ticket_number": "355248",
            "title": "Fwd: Important information: Pedro Cabral, your TAP",
            "priority": "P2",
            "created_at": "06/01/2026 19:36:35",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 19:36:36"
          },
          {
            "ticket_id": 5266,
            "ticket_number": "355258",
            "title": "Pedido voos",
            "priority": "P2",
            "created_at": "06/01/2026 23:05:25",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 23:05:25"
          },
          {
            "ticket_id": 5280,
            "ticket_number": "355272",
            "title": "Fwd: Incidente de voo TTN-1210961262#89461044#T166",
            "priority": "P2",
            "created_at": "07/01/2026 12:50:29",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 12:50:29"
          },
          {
            "ticket_id": 5298,
            "ticket_number": "355290",
            "title": "RE: Cotação voos Lisboa-Tunes - air europa",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:04",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 16:56:05"
          },
          {
            "ticket_id": 5310,
            "ticket_number": "355302",
            "title": "Reserva",
            "priority": "P3",
            "created_at": "07/01/2026 18:31:23",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 18:31:23"
          },
          {
            "ticket_id": 5329,
            "ticket_number": "355321",
            "title": "Confirmação reforço de pagamento com informação er",
            "priority": "P2",
            "created_at": "07/01/2026 22:37:44",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 22:37:44"
          },
          {
            "ticket_id": 5335,
            "ticket_number": "355327",
            "title": "Z3XI74 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "07/01/2026 23:55:00",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 23:55:00"
          },
          {
            "ticket_id": 5336,
            "ticket_number": "355328",
            "title": "Detalhes da seleção de lugar",
            "priority": "P2",
            "created_at": "07/01/2026 23:55:02",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 11.58,
            "sla_met": false,
            "sla_breach_hours": 7.58,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 11:31:02"
          },
          {
            "ticket_id": 5350,
            "ticket_number": "355342",
            "title": "Saídas de 07/02/2026 para 14/03/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "08/01/2026 10:08:10",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 11:55:08"
          },
          {
            "ticket_id": 5391,
            "ticket_number": "355383",
            "title": "Re: Cotação voos",
            "priority": "P2",
            "created_at": "08/01/2026 12:22:32",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:22:33"
          },
          {
            "ticket_id": 5405,
            "ticket_number": "355397",
            "title": "Re:[## 27823 ##] GBN-88141 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "08/01/2026 18:34:06",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 18:47:10"
          },
          {
            "ticket_id": 5407,
            "ticket_number": "355399",
            "title": "OJO1S5 - Novo prazo de emissão",
            "priority": "P2",
            "created_at": "08/01/2026 18:39:23",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 18:39:25"
          },
          {
            "ticket_id": 5409,
            "ticket_number": "355401",
            "title": "Emissao Dos Voos - Consolidador",
            "priority": "P2",
            "created_at": "08/01/2026 18:59:02",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 18:59:03"
          },
          {
            "ticket_id": 5426,
            "ticket_number": "355418",
            "title": "Re: cotacao de voos",
            "priority": "P2",
            "created_at": "08/01/2026 21:31:02",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 21:31:02"
          },
          {
            "ticket_id": 5427,
            "ticket_number": "355419",
            "title": "RES: pedido cotação de grupo",
            "priority": "P3",
            "created_at": "08/01/2026 22:40:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 23:51:18"
          },
          {
            "ticket_id": 5437,
            "ticket_number": "355429",
            "title": "Re: Formulário pedido de cotação IATA",
            "priority": "P2",
            "created_at": "09/01/2026 10:11:32",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 10:11:33"
          },
          {
            "ticket_id": 5441,
            "ticket_number": "355433",
            "title": "FW: Nova Viagem #260100064 - Ferias à Porta",
            "priority": "P3",
            "created_at": "09/01/2026 10:11:43",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 10:11:44"
          },
          {
            "ticket_id": 5446,
            "ticket_number": "355438",
            "title": "Cotação grupo Nov/Dez 26",
            "priority": "P2",
            "created_at": "09/01/2026 12:18:27",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 20:09:36"
          },
          {
            "ticket_id": 5452,
            "ticket_number": "355444",
            "title": "Fwd: Paris (Orly) - ZBDUPS",
            "priority": "P2",
            "created_at": "09/01/2026 13:00:43",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 13:00:44"
          },
          {
            "ticket_id": 5453,
            "ticket_number": "355445",
            "title": "Fwd: Paris (Orly) - XDZB4Z",
            "priority": "P2",
            "created_at": "09/01/2026 13:00:46",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 13:00:46"
          },
          {
            "ticket_id": 5468,
            "ticket_number": "355460",
            "title": "Aéreo - Confirmação de Emissão (AFONSO MARTINS\\CAT",
            "priority": "P2",
            "created_at": "09/01/2026 17:20:28",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 17:39:44"
          },
          {
            "ticket_id": 5469,
            "ticket_number": "355461",
            "title": "Aéreo - Confirmação de Emissão (LOPES FELIX OLAS\\R",
            "priority": "P2",
            "created_at": "09/01/2026 17:20:30",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 17:40:21"
          },
          {
            "ticket_id": 5477,
            "ticket_number": "355469",
            "title": "Re: Cotação voo Porto Malta",
            "priority": "P2",
            "created_at": "09/01/2026 19:36:31",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 19:36:31"
          },
          {
            "ticket_id": 5571,
            "ticket_number": "355563",
            "title": "Cotação voos",
            "priority": "P3",
            "created_at": "12/01/2026 10:16:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:16:13"
          },
          {
            "ticket_id": 5574,
            "ticket_number": "355566",
            "title": "Atualização Reserva GBN-96408",
            "priority": "P3",
            "created_at": "12/01/2026 10:16:20",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:16:21"
          },
          {
            "ticket_id": 5600,
            "ticket_number": "355592",
            "title": "Loc: 423503/2026 SOLFERIAS  - ofertas",
            "priority": "P3",
            "created_at": "12/01/2026 10:52:59",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:52:59"
          },
          {
            "ticket_id": 5620,
            "ticket_number": "355612",
            "title": "Fwd: [[ Ref:200993597 ]] Group Bookings [en]",
            "priority": "P3",
            "created_at": "12/01/2026 15:39:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:51:05"
          },
          {
            "ticket_id": 5656,
            "ticket_number": "355648",
            "title": "Fwd: Important: Your TAP Air Portugal flight refer",
            "priority": "P2",
            "created_at": "12/01/2026 18:57:58",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:57:58"
          },
          {
            "ticket_id": 5665,
            "ticket_number": "355657",
            "title": "Re: Cotação voos Lisboa - Sao Salvador",
            "priority": "P2",
            "created_at": "12/01/2026 21:10:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 21:10:06"
          },
          {
            "ticket_id": 5668,
            "ticket_number": "355660",
            "title": "Fwd: Q3NGXQ | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "12/01/2026 21:10:14",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 21:10:14"
          },
          {
            "ticket_id": 5670,
            "ticket_number": "355662",
            "title": "Pedido dados acesso",
            "priority": "P3",
            "created_at": "12/01/2026 21:12:57",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 21:12:58"
          },
          {
            "ticket_id": 5700,
            "ticket_number": "355692",
            "title": "Re: PEDIDO DE ORÇAMENTO DE GRUPO - Uma Família em ",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 11:44:18"
          },
          {
            "ticket_id": 5710,
            "ticket_number": "355702",
            "title": "Re: Nova Viagem #260100112 - Go Travel",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:56",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:56"
          },
          {
            "ticket_id": 5717,
            "ticket_number": "355709",
            "title": "easyJet número de referência da reserva: KBVPQXV",
            "priority": "P3",
            "created_at": "13/01/2026 10:26:20",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:26:20"
          },
          {
            "ticket_id": 5722,
            "ticket_number": "355714",
            "title": "FLFCGN – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "13/01/2026 11:05:53",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 11:05:53"
          },
          {
            "ticket_id": 5728,
            "ticket_number": "355720",
            "title": "Booking Id 6122762, Categoria: Incidência Pós Vend",
            "priority": "P3",
            "created_at": "13/01/2026 12:00:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 15:58:44"
          },
          {
            "ticket_id": 5729,
            "ticket_number": "355721",
            "title": "IMPACTADO: Sistemas de Teste Amadeus (PDT/UAT) : P",
            "priority": "P3",
            "created_at": "13/01/2026 12:00:21",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:18:56"
          },
          {
            "ticket_id": 5731,
            "ticket_number": "355723",
            "title": "RECUPERADO: Sistemas de Teste Amadeus (PDT/UAT) : ",
            "priority": "P3",
            "created_at": "13/01/2026 12:00:25",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:19:08"
          },
          {
            "ticket_id": 5732,
            "ticket_number": "355724",
            "title": "IMPACTADO: Sistemas de Teste Amadeus (PDT/UAT) : P",
            "priority": "P3",
            "created_at": "13/01/2026 12:00:27",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:19:16"
          },
          {
            "ticket_id": 5733,
            "ticket_number": "355725",
            "title": "RECUPERADO: Sistemas de Teste Amadeus (PDT/UAT) : ",
            "priority": "P3",
            "created_at": "13/01/2026 12:00:29",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:19:35"
          },
          {
            "ticket_id": 5751,
            "ticket_number": "355743",
            "title": "Aéreo - Confirmação de Emissão (LIMA\\ANA RITA) - F",
            "priority": "P2",
            "created_at": "13/01/2026 13:49:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 14:15:51"
          },
          {
            "ticket_id": 5759,
            "ticket_number": "355751",
            "title": "Pedido de orçamento de grupo",
            "priority": "P3",
            "created_at": "13/01/2026 14:56:30",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 14:56:31"
          },
          {
            "ticket_id": 5760,
            "ticket_number": "355752",
            "title": "Envio de documentação File 422534/25",
            "priority": "P3",
            "created_at": "13/01/2026 14:56:44",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:00:44"
          },
          {
            "ticket_id": 5763,
            "ticket_number": "355755",
            "title": "-UFEV#354625",
            "priority": "P3",
            "created_at": "13/01/2026 14:56:49",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 14:56:49"
          },
          {
            "ticket_id": 5764,
            "ticket_number": "355756",
            "title": "Fwd: easyJet número de referência da reserva: KBVS",
            "priority": "P3",
            "created_at": "13/01/2026 14:59:59",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:29:35"
          },
          {
            "ticket_id": 5765,
            "ticket_number": "355757",
            "title": "reserva new blue  1761445",
            "priority": "P3",
            "created_at": "13/01/2026 15:25:11",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 15:25:11"
          },
          {
            "ticket_id": 5767,
            "ticket_number": "355759",
            "title": "\"GBN-93920 - Your request has been received\"",
            "priority": "P3",
            "created_at": "13/01/2026 15:25:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 11:20:16"
          },
          {
            "ticket_id": 5768,
            "ticket_number": "355760",
            "title": "Confirmação de reserva – Ref PP242138, Sra. Ana Pa",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 15:25:17",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 16:55:20"
          },
          {
            "ticket_id": 5769,
            "ticket_number": "355761",
            "title": "[Reserva a pagar] Reserva [Terrace Vila Ii By An I",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 15:59:35",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 15:59:39"
          },
          {
            "ticket_id": 5770,
            "ticket_number": "355762",
            "title": "****URGENTE PASAPORTES - 99122811",
            "priority": "P3",
            "created_at": "13/01/2026 15:59:37",
            "close_date": "2026-03-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:06:43"
          },
          {
            "ticket_id": 5773,
            "ticket_number": "355765",
            "title": "GBN-90822",
            "priority": "P3",
            "created_at": "13/01/2026 16:31:40",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:31:40"
          },
          {
            "ticket_id": 5775,
            "ticket_number": "355767",
            "title": "Bahia príncipe - upgrade",
            "priority": "P3",
            "created_at": "13/01/2026 16:31:43",
            "close_date": "2026-04-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:31:44"
          },
          {
            "ticket_id": 5776,
            "ticket_number": "355768",
            "title": "Re:[## 28983 ##] GBN-96408 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "13/01/2026 16:31:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:31:46"
          },
          {
            "ticket_id": 5777,
            "ticket_number": "355769",
            "title": "Pedido informação - Soltropico",
            "priority": "P3",
            "created_at": "13/01/2026 17:05:46",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:05:46"
          },
          {
            "ticket_id": 5780,
            "ticket_number": "355772",
            "title": "Informação de reserva - SPT002601568223",
            "priority": "P2",
            "created_at": "13/01/2026 17:06:00",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 17:26:00"
          },
          {
            "ticket_id": 5782,
            "ticket_number": "355774",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604521393",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 17:06:05",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 13:00:34"
          },
          {
            "ticket_id": 5790,
            "ticket_number": "355782",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 18:15:42",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 18:15:42"
          },
          {
            "ticket_id": 5792,
            "ticket_number": "355784",
            "title": "GBN-88141 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/01/2026 18:15:49",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 22:02:32"
          },
          {
            "ticket_id": 5794,
            "ticket_number": "355786",
            "title": "File 39520 - Ribeiro/JoaoRicardoMagalhaesMR - Paco",
            "priority": "P2",
            "created_at": "13/01/2026 18:16:00",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:42:00"
          },
          {
            "ticket_id": 5798,
            "ticket_number": "355790",
            "title": "GBN-98545 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "13/01/2026 18:40:40",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 18:40:40"
          },
          {
            "ticket_id": 5820,
            "ticket_number": "355812",
            "title": "Reserva Aérea Z3U3VA",
            "priority": "P2",
            "created_at": "13/01/2026 21:52:56",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 21:54:49"
          },
          {
            "ticket_id": 5890,
            "ticket_number": "355882",
            "title": "Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:08",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 4.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:42:24"
          },
          {
            "ticket_id": 5893,
            "ticket_number": "355885",
            "title": "Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:19",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 5.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:46:02"
          },
          {
            "ticket_id": 5897,
            "ticket_number": "355889",
            "title": "Aéreo - Confirmação de Emissão (CLARO\\JOAO) - Z3U3",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:39",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 5.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:45:13"
          },
          {
            "ticket_id": 5898,
            "ticket_number": "355890",
            "title": "Aéreo - Confirmação de Emissão (SEQUEIRA\\MARIANA) ",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:41",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 5.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:44:37"
          },
          {
            "ticket_id": 5901,
            "ticket_number": "355893",
            "title": "Re: Group direct contracting #504784965",
            "priority": "P3",
            "created_at": "14/01/2026 13:44:20",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 5.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:54:35"
          },
          {
            "ticket_id": 5914,
            "ticket_number": "355906",
            "title": "FLYF6X – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "14/01/2026 15:21:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 15:21:47"
          },
          {
            "ticket_id": 5945,
            "ticket_number": "355937",
            "title": "GBN-98882 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "14/01/2026 19:55:27",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 14.38,
            "sla_met": false,
            "sla_breach_hours": 10.38,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:19:08"
          },
          {
            "ticket_id": 5949,
            "ticket_number": "355941",
            "title": "correção de dados",
            "priority": "P2",
            "created_at": "14/01/2026 20:27:38",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 20:27:38"
          },
          {
            "ticket_id": 5967,
            "ticket_number": "355959",
            "title": "RECUPERADO: Amadeus Central Reservation: Filas PNR",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:28",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 11.27,
            "sla_met": false,
            "sla_breach_hours": 7.27,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:07:32"
          },
          {
            "ticket_id": 5968,
            "ticket_number": "355960",
            "title": "RECUPERADO: Amadeus Central Reservation: Filas PNR",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:32",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 11.27,
            "sla_met": false,
            "sla_breach_hours": 7.27,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:07:42"
          },
          {
            "ticket_id": 5991,
            "ticket_number": "355983",
            "title": "FLYF6X – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:40",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:41:40"
          },
          {
            "ticket_id": 6003,
            "ticket_number": "355995",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\CARLOS) - ",
            "priority": "P2",
            "created_at": "15/01/2026 10:31:43",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:32:41"
          },
          {
            "ticket_id": 6004,
            "ticket_number": "355996",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\AFONSO) - ",
            "priority": "P2",
            "created_at": "15/01/2026 10:31:45",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:33:27"
          },
          {
            "ticket_id": 6005,
            "ticket_number": "355997",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\MARIA) - F",
            "priority": "P2",
            "created_at": "15/01/2026 10:31:48",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:34:00"
          },
          {
            "ticket_id": 6006,
            "ticket_number": "355998",
            "title": "Aéreo - Confirmação de Emissão (MARQUES\\HELENA) - ",
            "priority": "P2",
            "created_at": "15/01/2026 10:31:51",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:34:36"
          },
          {
            "ticket_id": 6010,
            "ticket_number": "356002",
            "title": "Fwd: Viagify informa sobre a sua reserva 123521422",
            "priority": "P2",
            "created_at": "15/01/2026 10:46:10",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:46:11"
          },
          {
            "ticket_id": 6014,
            "ticket_number": "356006",
            "title": "Fwd: Informações da reserva TTN-1231111139#9015491",
            "priority": "P2",
            "created_at": "15/01/2026 10:46:27",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:46:28"
          },
          {
            "ticket_id": 6015,
            "ticket_number": "356007",
            "title": "Fwd: Documentação da reserva TTN-1235214221#901366",
            "priority": "P2",
            "created_at": "15/01/2026 10:46:36",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:46:36"
          },
          {
            "ticket_id": 6029,
            "ticket_number": "356021",
            "title": "URGENTE Confirmação de reserva 336748 ### TIME LIM",
            "priority": "P2",
            "created_at": "15/01/2026 11:36:39",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:27:48"
          },
          {
            "ticket_id": 6032,
            "ticket_number": "356024",
            "title": "VOUCHER DA RESERVA 604476805",
            "priority": "P3",
            "created_at": "15/01/2026 11:37:22",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 12:20:43"
          },
          {
            "ticket_id": 6033,
            "ticket_number": "356025",
            "title": "GBN-98984 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 11:45:19",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 11:45:19"
          },
          {
            "ticket_id": 6034,
            "ticket_number": "356026",
            "title": "VOUCHER DA RESERVA 604516386",
            "priority": "P3",
            "created_at": "15/01/2026 11:55:54",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 12:18:08"
          },
          {
            "ticket_id": 6035,
            "ticket_number": "356027",
            "title": "RE: Group direct contracting",
            "priority": "P3",
            "created_at": "15/01/2026 12:39:30",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 12:49:25"
          },
          {
            "ticket_id": 6039,
            "ticket_number": "356031",
            "title": "Fwd: Notification of changes to your booking PGF8K",
            "priority": "P3",
            "created_at": "15/01/2026 13:15:29",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 13:15:29"
          },
          {
            "ticket_id": 6040,
            "ticket_number": "356032",
            "title": "Fwd: Informações sobre a sua reserva TTN-120980011",
            "priority": "P3",
            "created_at": "15/01/2026 13:17:04",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 13:17:05"
          },
          {
            "ticket_id": 6041,
            "ticket_number": "356033",
            "title": "Fwd: Recebeu uma nova mensagem TTN-1235013010#9013",
            "priority": "P2",
            "created_at": "15/01/2026 13:17:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:17:07"
          },
          {
            "ticket_id": 6042,
            "ticket_number": "356034",
            "title": "Fwd: 1225312520 TTN-1225312520#90136554#T16828326¬",
            "priority": "P3",
            "created_at": "15/01/2026 13:17:09",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 13:17:09"
          },
          {
            "ticket_id": 6049,
            "ticket_number": "356041",
            "title": "Documentação Disponível - Reserva 333871",
            "priority": "P3",
            "created_at": "15/01/2026 13:54:51",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 13:58:51"
          },
          {
            "ticket_id": 6050,
            "ticket_number": "356042",
            "title": "Re: pedido cotação Aegean e Skyexpress",
            "priority": "P2",
            "created_at": "15/01/2026 13:54:52",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:54:53"
          },
          {
            "ticket_id": 6053,
            "ticket_number": "356045",
            "title": "Reserva 1198620745 smytravel",
            "priority": "P2",
            "created_at": "15/01/2026 14:46:58",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:46:58"
          },
          {
            "ticket_id": 6065,
            "ticket_number": "356057",
            "title": "Datos de la selección de asientos",
            "priority": "P2",
            "created_at": "15/01/2026 16:40:17",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:01:20"
          },
          {
            "ticket_id": 6072,
            "ticket_number": "356064",
            "title": "Re: Novo Reforço de Pagamento - Viagem #2424200012",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:14",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:18:15"
          },
          {
            "ticket_id": 6083,
            "ticket_number": "356075",
            "title": "Fwd: Ryanair 71934223/Tania Seixas/500milcoisas",
            "priority": "P2",
            "created_at": "15/01/2026 18:23:09",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 17:49:29"
          },
          {
            "ticket_id": 6097,
            "ticket_number": "356089",
            "title": "Cancelamento Reserva",
            "priority": "P2",
            "created_at": "15/01/2026 21:18:11",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 21:18:11"
          },
          {
            "ticket_id": 6103,
            "ticket_number": "356095",
            "title": "Reserva Aérea FMGGL9",
            "priority": "P3",
            "created_at": "15/01/2026 22:34:35",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 22:38:56"
          },
          {
            "ticket_id": 6104,
            "ticket_number": "356096",
            "title": "FMGGL9 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "15/01/2026 22:37:49",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 12.38,
            "sla_met": false,
            "sla_breach_hours": 8.38,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:01:13"
          },
          {
            "ticket_id": 6110,
            "ticket_number": "356102",
            "title": "Reserva Aérea OPO3L5",
            "priority": "P2",
            "created_at": "15/01/2026 23:40:16",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 10.6,
            "sla_met": false,
            "sla_breach_hours": 6.6,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:16:47"
          },
          {
            "ticket_id": 6111,
            "ticket_number": "356103",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (OPO",
            "priority": "P2",
            "created_at": "15/01/2026 23:40:18",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 10.6,
            "sla_met": false,
            "sla_breach_hours": 6.6,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:16:57"
          },
          {
            "ticket_id": 6127,
            "ticket_number": "356119",
            "title": "NOVO INCIDENTE: Amadeus Central Reservation: Filas",
            "priority": "P3",
            "created_at": "16/01/2026 10:13:12",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:47:40"
          },
          {
            "ticket_id": 6130,
            "ticket_number": "356122",
            "title": "Fwd: Quote reminder 71803648",
            "priority": "P2",
            "created_at": "16/01/2026 10:13:26",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:13:26"
          },
          {
            "ticket_id": 6156,
            "ticket_number": "356148",
            "title": "Aéreo - Confirmação de Emissão (LEITE\\MARCELO) - F",
            "priority": "P2",
            "created_at": "16/01/2026 10:53:40",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:05:15"
          },
          {
            "ticket_id": 6157,
            "ticket_number": "356149",
            "title": "Aéreo - Confirmação de Emissão (LEITE\\MATEUS) - FM",
            "priority": "P2",
            "created_at": "16/01/2026 10:53:42",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:05:48"
          },
          {
            "ticket_id": 6159,
            "ticket_number": "356151",
            "title": "Aéreo - Confirmação de Emissão (MALTA\\SONIA) - FMG",
            "priority": "P2",
            "created_at": "16/01/2026 10:54:50",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:06:21"
          },
          {
            "ticket_id": 6180,
            "ticket_number": "356172",
            "title": "The Hotel Brussels - UMA FAMILIA EM VIAGEM 220926",
            "priority": "P3",
            "created_at": "16/01/2026 12:44:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 8.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 21:13:57"
          },
          {
            "ticket_id": 6185,
            "ticket_number": "356177",
            "title": "RECUPERADO: Amadeus Central Reservation: Filas PNR",
            "priority": "P3",
            "created_at": "16/01/2026 13:03:00",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 16:17:56"
          },
          {
            "ticket_id": 6193,
            "ticket_number": "356185",
            "title": "Reserva Aérea XG2KGY",
            "priority": "P2",
            "created_at": "16/01/2026 14:00:28",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:17:50"
          },
          {
            "ticket_id": 6195,
            "ticket_number": "356187",
            "title": "XG2KGY – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "16/01/2026 14:32:27",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:17:44"
          },
          {
            "ticket_id": 6196,
            "ticket_number": "356188",
            "title": "Reserva Aérea ONPLK5",
            "priority": "P2",
            "created_at": "16/01/2026 14:32:30",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:17:37"
          },
          {
            "ticket_id": 6197,
            "ticket_number": "356189",
            "title": "ONPLK5 - Novo prazo de emissão",
            "priority": "P2",
            "created_at": "16/01/2026 14:32:32",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:17:24"
          },
          {
            "ticket_id": 6202,
            "ticket_number": "356194",
            "title": "Aéreo - Confirmação de Emissão (PINHO\\CARLA) - ONP",
            "priority": "P2",
            "created_at": "16/01/2026 16:21:28",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:25:24"
          },
          {
            "ticket_id": 6203,
            "ticket_number": "356195",
            "title": "Aéreo - Confirmação de Emissão (FERREIRA\\NUNO) - O",
            "priority": "P2",
            "created_at": "16/01/2026 16:21:30",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:25:59"
          },
          {
            "ticket_id": 6204,
            "ticket_number": "356196",
            "title": "Aéreo - Confirmação de Emissão (CORREIA SIMOES\\VIC",
            "priority": "P2",
            "created_at": "16/01/2026 16:21:33",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:26:36"
          },
          {
            "ticket_id": 6205,
            "ticket_number": "356197",
            "title": "Aéreo - Confirmação de Emissão (FERREIRA\\MARIA) - ",
            "priority": "P2",
            "created_at": "16/01/2026 16:21:36",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:27:04"
          },
          {
            "ticket_id": 6206,
            "ticket_number": "356198",
            "title": "Aéreo - Confirmação de Emissão (CORREIA BUGIA SIMO",
            "priority": "P2",
            "created_at": "16/01/2026 16:21:38",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 16:28:04"
          },
          {
            "ticket_id": 6213,
            "ticket_number": "356205",
            "title": "Re: Cotação voos TAP",
            "priority": "P2",
            "created_at": "16/01/2026 17:06:43",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 17:06:43"
          },
          {
            "ticket_id": 6223,
            "ticket_number": "356215",
            "title": "REEMBOLSO 6126894 W2MCS:015730002240",
            "priority": "P2",
            "created_at": "16/01/2026 19:35:58",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 00:01:19"
          },
          {
            "ticket_id": 6310,
            "ticket_number": "356302",
            "title": "Notificação de Manutenção Programada AMADEUS - MMW",
            "priority": "P3",
            "created_at": "18/01/2026 09:52:45",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 14.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 00:04:11"
          },
          {
            "ticket_id": 6316,
            "ticket_number": "356308",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempo de re",
            "priority": "P3",
            "created_at": "18/01/2026 09:53:00",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 14.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 00:04:11"
          },
          {
            "ticket_id": 6317,
            "ticket_number": "356309",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempo de re",
            "priority": "P3",
            "created_at": "18/01/2026 09:53:02",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 14.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 00:04:11"
          },
          {
            "ticket_id": 6318,
            "ticket_number": "356310",
            "title": "NOVO INCIDENTE: Amadeus Shopping Services: Tempo d",
            "priority": "P3",
            "created_at": "18/01/2026 09:53:03",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 14.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 00:04:11"
          },
          {
            "ticket_id": 6319,
            "ticket_number": "356311",
            "title": "NOVO INCIDENTE: Amadeus Shopping Services: Tempo d",
            "priority": "P3",
            "created_at": "18/01/2026 09:53:05",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 14.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 00:04:11"
          },
          {
            "ticket_id": 6334,
            "ticket_number": "356326",
            "title": "Fwd: Notificação de Manutenção Programada AMADEUS ",
            "priority": "P3",
            "created_at": "18/01/2026 11:48:22",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 11:48:22"
          },
          {
            "ticket_id": 6336,
            "ticket_number": "356328",
            "title": "Fwd: Notificação de Manutenção Programada AMADEUS ",
            "priority": "P3",
            "created_at": "18/01/2026 11:48:27",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 11:48:27"
          },
          {
            "ticket_id": 6338,
            "ticket_number": "356330",
            "title": "Fwd: Vueling flight to Paris (Orly) – What to expe",
            "priority": "P3",
            "created_at": "18/01/2026 11:48:32",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 11:48:34"
          },
          {
            "ticket_id": 6339,
            "ticket_number": "356331",
            "title": "Fwd: RECUPERADO: Amadeus Shopping Services: Tempo ",
            "priority": "P3",
            "created_at": "18/01/2026 11:48:35",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 11:48:35"
          },
          {
            "ticket_id": 6340,
            "ticket_number": "356332",
            "title": "Fwd: NOVO INCIDENTE: Amadeus Shopping Services: Te",
            "priority": "P3",
            "created_at": "18/01/2026 11:48:38",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 11:48:38"
          },
          {
            "ticket_id": 6375,
            "ticket_number": "356367",
            "title": "Fwd: Quote reminder 71934223",
            "priority": "P3",
            "created_at": "19/01/2026 10:09:23",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:09:23"
          },
          {
            "ticket_id": 6377,
            "ticket_number": "356369",
            "title": "Fwd: Localizador 1236708924 - SmyTravel informa TT",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 10:09:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 10:09:27"
          },
          {
            "ticket_id": 6381,
            "ticket_number": "356373",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P2",
            "created_at": "19/01/2026 10:09:44",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:09:45"
          },
          {
            "ticket_id": 6386,
            "ticket_number": "356378",
            "title": "Fwd: Viagify informa sobre a sua reserva 123668970",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 10:10:01",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 10:10:02"
          },
          {
            "ticket_id": 6388,
            "ticket_number": "356380",
            "title": "Fwd: Viagify informa sobre a sua reserva 123685433",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:08",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:09"
          },
          {
            "ticket_id": 6389,
            "ticket_number": "356381",
            "title": "Re: Cotação voos Porto-Gran Canaria",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:11",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:11"
          },
          {
            "ticket_id": 6390,
            "ticket_number": "356382",
            "title": "Re: Cotação voos Lisboa -Lyon",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:14",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:14"
          },
          {
            "ticket_id": 6399,
            "ticket_number": "356391",
            "title": "Info de transferes privados | GBN-88138 - Sara Pau",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:34"
          },
          {
            "ticket_id": 6419,
            "ticket_number": "356411",
            "title": "Reserva Leplan - 604525587",
            "priority": "P3",
            "created_at": "19/01/2026 10:14:32",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:14:32"
          },
          {
            "ticket_id": 6424,
            "ticket_number": "356416",
            "title": "Re: Fwd: Importante - RGPD",
            "priority": "P2",
            "created_at": "19/01/2026 11:12:00",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 11:12:00"
          },
          {
            "ticket_id": 6428,
            "ticket_number": "356420",
            "title": "Fwd: Viagify informa sobre a sua reserva 123697929",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 11:41:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 11:41:37"
          },
          {
            "ticket_id": 6441,
            "ticket_number": "356433",
            "title": "Re: Cotação voo Lisboa-Barcelona",
            "priority": "P2",
            "created_at": "19/01/2026 12:32:52",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 12:32:53"
          },
          {
            "ticket_id": 6457,
            "ticket_number": "356449",
            "title": "Re: Orçamento Porto Seguro",
            "priority": "P2",
            "created_at": "19/01/2026 15:30:25",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:30:27"
          },
          {
            "ticket_id": 6478,
            "ticket_number": "356470",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KB",
            "priority": "P2",
            "created_at": "19/01/2026 17:05:40",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 17:08:55"
          },
          {
            "ticket_id": 6515,
            "ticket_number": "356507",
            "title": "Fwd: Os seus cartões de embarque estão prontos!🎉",
            "priority": "P3",
            "created_at": "20/01/2026 10:07:42",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:07:43"
          },
          {
            "ticket_id": 6518,
            "ticket_number": "356510",
            "title": "Fwd: Confirmação da sua reserva HLWQ6A - LIS-ORY 2",
            "priority": "P3",
            "created_at": "20/01/2026 10:07:53",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:07:53"
          },
          {
            "ticket_id": 6551,
            "ticket_number": "356543",
            "title": "Reservas",
            "priority": "P2",
            "created_at": "20/01/2026 10:14:16",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:14:16"
          },
          {
            "ticket_id": 6555,
            "ticket_number": "356547",
            "title": "NOVO INCIDENTE: Amadeus Ticketing and Document Ser",
            "priority": "P3",
            "created_at": "20/01/2026 10:19:39",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 4.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 14:54:44"
          },
          {
            "ticket_id": 6559,
            "ticket_number": "356551",
            "title": "Reserva Aérea FNSQ3F",
            "priority": "P2",
            "created_at": "20/01/2026 10:49:11",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 14:42:56"
          },
          {
            "ticket_id": 6568,
            "ticket_number": "356560",
            "title": "FNSQ3F – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "20/01/2026 11:02:09",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 5.87,
            "sla_met": false,
            "sla_breach_hours": 1.87,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 16:54:14"
          },
          {
            "ticket_id": 6582,
            "ticket_number": "356574",
            "title": "Aéreo - Confirmação de Emissão (ANTUNES\\PEDRO) - F",
            "priority": "P2",
            "created_at": "20/01/2026 12:23:11",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 16:23:08"
          },
          {
            "ticket_id": 6585,
            "ticket_number": "356577",
            "title": "proposta voo smy",
            "priority": "P2",
            "created_at": "20/01/2026 12:58:31",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:58:32"
          },
          {
            "ticket_id": 6648,
            "ticket_number": "356640",
            "title": "Fwd: easyJet Group Quotation Information : 2026-01",
            "priority": "P2",
            "created_at": "20/01/2026 18:45:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 18:45:53"
          },
          {
            "ticket_id": 6674,
            "ticket_number": "356666",
            "title": "Fwd: Agradecemos o preenchimento deste formulário:",
            "priority": "P2",
            "created_at": "20/01/2026 22:18:17",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 22:18:17"
          },
          {
            "ticket_id": 6678,
            "ticket_number": "356670",
            "title": "Grupo: GR-59B5B6E934",
            "priority": "P2",
            "created_at": "20/01/2026 23:31:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 13.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 13:24:57"
          },
          {
            "ticket_id": 6687,
            "ticket_number": "356679",
            "title": "Informação de reserva - SPT002601571772",
            "priority": "P2",
            "created_at": "21/01/2026 10:15:13",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 12.27,
            "sla_met": false,
            "sla_breach_hours": 8.27,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 22:31:20"
          },
          {
            "ticket_id": 6737,
            "ticket_number": "356729",
            "title": "A/C INÊS RE: Cotação voos Lisboa -Lyon",
            "priority": "P2",
            "created_at": "21/01/2026 14:18:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 14:18:17"
          },
          {
            "ticket_id": 6751,
            "ticket_number": "356743",
            "title": "Fwd: easyJet número de referência da reserva: KBXJ",
            "priority": "P2",
            "created_at": "21/01/2026 16:24:14",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 16:25:27"
          },
          {
            "ticket_id": 6759,
            "ticket_number": "356751",
            "title": "Re:[## 29528 ##] GBN-88138 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/01/2026 16:43:12",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 20:41:21"
          },
          {
            "ticket_id": 6781,
            "ticket_number": "356773",
            "title": "Fwd: Viagify informa sobre a sua reserva 123836890",
            "priority": "P1",
            "created_at": "21/01/2026 18:21:58",
            "close_date": "2026-02-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/01/2026 18:22:00"
          },
          {
            "ticket_id": 6784,
            "ticket_number": "356776",
            "title": "Fwd: [ATLAS] - Reserva de Voos para um Grupo Estud",
            "priority": "P3",
            "created_at": "21/01/2026 18:28:04",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 18:28:04"
          },
          {
            "ticket_id": 6884,
            "ticket_number": "356876",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "22/01/2026 15:08:25",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 15:08:26"
          },
          {
            "ticket_id": 6935,
            "ticket_number": "356927",
            "title": "Fwd: Vueling flight to Lisbon – What to expect",
            "priority": "P2",
            "created_at": "22/01/2026 22:17:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 22:17:55"
          },
          {
            "ticket_id": 6949,
            "ticket_number": "356941",
            "title": "Fwd: Your Booking request 1848453",
            "priority": "P3",
            "created_at": "23/01/2026 10:05:33",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:05:34"
          },
          {
            "ticket_id": 6952,
            "ticket_number": "356944",
            "title": "Fwd: Your Booking request 1848452",
            "priority": "P3",
            "created_at": "23/01/2026 10:05:45",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:05:46"
          },
          {
            "ticket_id": 6973,
            "ticket_number": "356965",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "23/01/2026 12:23:40",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6975,
            "ticket_number": "356967",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "23/01/2026 12:23:44",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6977,
            "ticket_number": "356969",
            "title": "Aéreo - Confirmação de Emissão (NEVES GASPAR\\CONST",
            "priority": "P3",
            "created_at": "23/01/2026 12:23:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 4.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 17:12:28"
          },
          {
            "ticket_id": 6978,
            "ticket_number": "356970",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "23/01/2026 12:24:00",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6979,
            "ticket_number": "356971",
            "title": "Aéreo - Confirmação de Emissão (FONSECA DAS NEVES\\",
            "priority": "P2",
            "created_at": "23/01/2026 12:24:03",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6980,
            "ticket_number": "356972",
            "title": "Aéreo - Confirmação de Emissão (NOBRE GASPAR\\LUIS ",
            "priority": "P2",
            "created_at": "23/01/2026 12:24:06",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6981,
            "ticket_number": "356973",
            "title": "Reserva Aérea XX3TO2",
            "priority": "P2",
            "created_at": "23/01/2026 12:24:40",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:20:30"
          },
          {
            "ticket_id": 6998,
            "ticket_number": "356990",
            "title": "Fwd: R22VNT | Atualização importante para todos os",
            "priority": "P3",
            "created_at": "23/01/2026 15:23:28",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 15:23:29"
          },
          {
            "ticket_id": 7012,
            "ticket_number": "357004",
            "title": "envio do RGPD localizador SMY 1236979294",
            "priority": "P3",
            "created_at": "23/01/2026 17:23:32",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 17:23:33"
          },
          {
            "ticket_id": 7016,
            "ticket_number": "357008",
            "title": "Empfangsbestätigung [~4024450]",
            "priority": "P3",
            "created_at": "23/01/2026 17:35:36",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 601.43,
            "sla_met": false,
            "sla_breach_hours": 577.43,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 19:02:27"
          },
          {
            "ticket_id": 7017,
            "ticket_number": "357009",
            "title": "Empfangsbestätigung [~4024451]",
            "priority": "P3",
            "created_at": "23/01/2026 17:35:38",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 77.13,
            "sla_met": false,
            "sla_breach_hours": 53.13,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 22:43:56"
          },
          {
            "ticket_id": 7129,
            "ticket_number": "357121",
            "title": "Fwd: Confirmação da sua reserva HLWQ6A - LIS-ORY 2",
            "priority": "P3",
            "created_at": "26/01/2026 10:12:51",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:12:52"
          },
          {
            "ticket_id": 7134,
            "ticket_number": "357126",
            "title": "Fwd: Os seus cartões de embarque estão prontos!🎉",
            "priority": "P3",
            "created_at": "26/01/2026 10:13:12",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:13:13"
          },
          {
            "ticket_id": 7137,
            "ticket_number": "357129",
            "title": "Fwd: Your Booking request 1848454",
            "priority": "P3",
            "created_at": "26/01/2026 10:13:20",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:13:21"
          },
          {
            "ticket_id": 7169,
            "ticket_number": "357161",
            "title": "comissao cruzeiros",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:03",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 368.93,
            "sla_met": false,
            "sla_breach_hours": 364.93,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:16:32"
          },
          {
            "ticket_id": 7191,
            "ticket_number": "357183",
            "title": "New Lufthansa Group Agency Support and Group Suppo",
            "priority": "P3",
            "created_at": "26/01/2026 11:32:48",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7192,
            "ticket_number": "357184",
            "title": "FLFCGN – Alteração de Horário – Aceite",
            "priority": "P3",
            "created_at": "26/01/2026 11:32:50",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7201,
            "ticket_number": "357193",
            "title": "RE: group cotation - Radisson Collection Grand Pla",
            "priority": "P2",
            "created_at": "26/01/2026 11:33:09",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7202,
            "ticket_number": "357194",
            "title": "Re: Cotaçao voo Porto -Porto seguro",
            "priority": "P2",
            "created_at": "26/01/2026 11:33:11",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 11:33:11"
          },
          {
            "ticket_id": 7204,
            "ticket_number": "357196",
            "title": "Re: Cotação voos",
            "priority": "P2",
            "created_at": "26/01/2026 12:00:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 12:00:16"
          },
          {
            "ticket_id": 7229,
            "ticket_number": "357221",
            "title": "FW: Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "26/01/2026 14:41:55",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 14:41:56"
          },
          {
            "ticket_id": 7238,
            "ticket_number": "357230",
            "title": "Re: Cotação voos Lisboa/Florença",
            "priority": "P2",
            "created_at": "26/01/2026 15:10:04",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:10:04"
          },
          {
            "ticket_id": 7319,
            "ticket_number": "357311",
            "title": "ZQ7TVI – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:51",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:04:11"
          },
          {
            "ticket_id": 7320,
            "ticket_number": "357312",
            "title": "Reserva Aérea FR12VZ",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:53",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:04:12"
          },
          {
            "ticket_id": 7321,
            "ticket_number": "357313",
            "title": "FR12VZ – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:56",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:04:12"
          },
          {
            "ticket_id": 7322,
            "ticket_number": "357314",
            "title": "Reserva Aérea ZQ7TVI",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:04:12"
          },
          {
            "ticket_id": 7342,
            "ticket_number": "357334",
            "title": "Fwd: Your Booking request 1848453",
            "priority": "P3",
            "created_at": "27/01/2026 12:36:37",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 12:36:38"
          },
          {
            "ticket_id": 7357,
            "ticket_number": "357349",
            "title": "Re: Nova Viagem #260100426 - Genial Brigade",
            "priority": "P2",
            "created_at": "27/01/2026 14:50:29",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:50:29"
          },
          {
            "ticket_id": 7375,
            "ticket_number": "357367",
            "title": "Aéreo - Confirmação de Emissão (PEQUENO DE OLIVEIR",
            "priority": "P2",
            "created_at": "27/01/2026 16:33:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:39:19"
          },
          {
            "ticket_id": 7376,
            "ticket_number": "357368",
            "title": "Aéreo - Confirmação de Emissão (PEQUENO DE OLIVEIR",
            "priority": "P2",
            "created_at": "27/01/2026 16:34:01",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:40:17"
          },
          {
            "ticket_id": 7378,
            "ticket_number": "357370",
            "title": "Aéreo - Confirmação de Emissão (PEQUENO DE OLIVEIR",
            "priority": "P2",
            "created_at": "27/01/2026 16:35:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:40:43"
          },
          {
            "ticket_id": 7380,
            "ticket_number": "357372",
            "title": "Aéreo - Confirmação de Emissão (PEQUENO DE OLIVEIR",
            "priority": "P2",
            "created_at": "27/01/2026 16:35:49",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:41:15"
          },
          {
            "ticket_id": 7386,
            "ticket_number": "357378",
            "title": "Fwd: RE: Re: [EXTERNAL] Cotação grupo Nov/Dez 26",
            "priority": "P3",
            "created_at": "27/01/2026 17:02:08",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 17:18:21"
          },
          {
            "ticket_id": 7483,
            "ticket_number": "357475",
            "title": "Re: Cotaçao voos Porto/Bruxelas",
            "priority": "P2",
            "created_at": "28/01/2026 10:29:04",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7484,
            "ticket_number": "357476",
            "title": "Queda muy poco para tu vuelo!",
            "priority": "P3",
            "created_at": "28/01/2026 10:29:09",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7486,
            "ticket_number": "357478",
            "title": "RE: Envio RGPD e CVO 2416400024",
            "priority": "P3",
            "created_at": "28/01/2026 10:29:20",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 8.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:35:39"
          },
          {
            "ticket_id": 7491,
            "ticket_number": "357483",
            "title": "Pedido de orçamento - grupo",
            "priority": "P3",
            "created_at": "28/01/2026 10:30:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:30:14"
          },
          {
            "ticket_id": 7513,
            "ticket_number": "357505",
            "title": "Fwd: Reserva NPJS4. Información para tu próximo vi",
            "priority": "P3",
            "created_at": "28/01/2026 15:45:47",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:45:48"
          },
          {
            "ticket_id": 7519,
            "ticket_number": "357511",
            "title": "Fwd: Viagify informa sobre a sua reserva 124132355",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 15:46:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 15:46:04"
          },
          {
            "ticket_id": 7520,
            "ticket_number": "357512",
            "title": "Confirmacao 338341",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 15:46:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 11:44:28"
          },
          {
            "ticket_id": 7522,
            "ticket_number": "357514",
            "title": "RESERVA WL FILE- 338299",
            "priority": "P2",
            "created_at": "28/01/2026 15:46:11",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:31:43"
          },
          {
            "ticket_id": 7523,
            "ticket_number": "357515",
            "title": "Cancelamento de Reserva",
            "priority": "P2",
            "created_at": "28/01/2026 15:46:13",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 15:46:13"
          },
          {
            "ticket_id": 7529,
            "ticket_number": "357521",
            "title": "Confirmación del Loc 9103814",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 15:46:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 11:44:28"
          },
          {
            "ticket_id": 7532,
            "ticket_number": "357524",
            "title": "GBN-102058 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 15:51:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 16:13:54"
          },
          {
            "ticket_id": 7535,
            "ticket_number": "357527",
            "title": "Pedido de cotação - Grupo 11 pessoas | Fuerteventu",
            "priority": "P3",
            "created_at": "28/01/2026 16:14:06",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 16:14:08"
          },
          {
            "ticket_id": 7540,
            "ticket_number": "357532",
            "title": "Confirmation of booking with locator0QXHCAF7",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 17:16:51",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:04:32"
          },
          {
            "ticket_id": 7543,
            "ticket_number": "357535",
            "title": "Re: Cotação dos voos Barcelona/Lisboa",
            "priority": "P2",
            "created_at": "28/01/2026 18:06:13",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:06:13"
          },
          {
            "ticket_id": 7544,
            "ticket_number": "357536",
            "title": "Fwd: Notification of changes to your booking PGF8K",
            "priority": "P2",
            "created_at": "28/01/2026 18:06:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:06:16"
          },
          {
            "ticket_id": 7545,
            "ticket_number": "357537",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604523178",
            "priority": "P3",
            "created_at": "28/01/2026 18:06:18",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:45:32"
          },
          {
            "ticket_id": 7548,
            "ticket_number": "357540",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604536596",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 18:06:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 14:04:41"
          },
          {
            "ticket_id": 7549,
            "ticket_number": "357541",
            "title": "0QXHCAF7 - UFEV",
            "priority": "P2",
            "created_at": "28/01/2026 18:06:26",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:33:58"
          },
          {
            "ticket_id": 7550,
            "ticket_number": "357542",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "28/01/2026 18:08:03",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:46:01"
          },
          {
            "ticket_id": 7553,
            "ticket_number": "357545",
            "title": "GBN-101623 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 19:20:18",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 138.42,
            "sla_met": false,
            "sla_breach_hours": 114.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 13:45:20"
          },
          {
            "ticket_id": 7555,
            "ticket_number": "357547",
            "title": "GBN-102156 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 19:20:30",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 19:20:30"
          },
          {
            "ticket_id": 7556,
            "ticket_number": "357548",
            "title": "GBN-98984 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "28/01/2026 19:20:33",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 19:20:37"
          },
          {
            "ticket_id": 7558,
            "ticket_number": "357550",
            "title": "Confirmação de Reserva * File 427403",
            "priority": "P1",
            "created_at": "28/01/2026 19:20:44",
            "close_date": "2026-01-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 21.62,
            "sla_met": false,
            "sla_breach_hours": 21.37,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 16:57:50"
          },
          {
            "ticket_id": 7560,
            "ticket_number": "357552",
            "title": "GBN-102137 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 19:20:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 19:20:52"
          },
          {
            "ticket_id": 7562,
            "ticket_number": "357554",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802348327",
            "priority": "P2",
            "created_at": "29/01/2026 10:22:46",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 13:07:18"
          },
          {
            "ticket_id": 7564,
            "ticket_number": "357556",
            "title": "Fwd: Informações da sua reserva TTN-1241445191#914",
            "priority": "P3",
            "created_at": "29/01/2026 10:22:52",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:22:53"
          },
          {
            "ticket_id": 7567,
            "ticket_number": "357559",
            "title": "GBN-101259 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/01/2026 10:23:03",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 13:03:43"
          },
          {
            "ticket_id": 7568,
            "ticket_number": "357560",
            "title": "GBN-102190 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 10:23:10",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 10:23:10"
          },
          {
            "ticket_id": 7578,
            "ticket_number": "357570",
            "title": "Confirmacao 338415",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 10:24:46",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7580,
            "ticket_number": "357572",
            "title": "RE: Cotação voos Lisboa/Ibiza",
            "priority": "P3",
            "created_at": "29/01/2026 10:26:57",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:26:58"
          },
          {
            "ticket_id": 7589,
            "ticket_number": "357581",
            "title": "Pedido de reserva - GBN 102156",
            "priority": "P2",
            "created_at": "29/01/2026 10:27:18",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:27:19"
          },
          {
            "ticket_id": 7590,
            "ticket_number": "357582",
            "title": "Pedido cotação alojamento RF Duomo Suites-Florença",
            "priority": "P2",
            "created_at": "29/01/2026 10:27:20",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:27:21"
          },
          {
            "ticket_id": 7602,
            "ticket_number": "357594",
            "title": "Pedido nr reserva voos",
            "priority": "P2",
            "created_at": "29/01/2026 10:28:02",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:28:02"
          },
          {
            "ticket_id": 7613,
            "ticket_number": "357605",
            "title": "Alerta: pedido à Soltrópico - nova reserva | 33841",
            "priority": "P2",
            "created_at": "29/01/2026 10:31:40",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:31:41"
          },
          {
            "ticket_id": 7616,
            "ticket_number": "357608",
            "title": "Fwd: Você fez o check-in para seu voo para Paris (",
            "priority": "P3",
            "created_at": "29/01/2026 10:32:20",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:32:21"
          },
          {
            "ticket_id": 7633,
            "ticket_number": "357625",
            "title": "Fwd: Laura, su reserva KBXB2CN: la hora de su vuel",
            "priority": "P2",
            "created_at": "29/01/2026 12:43:04",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 12:43:04"
          },
          {
            "ticket_id": 7642,
            "ticket_number": "357634",
            "title": "RE: Nova Viagem #260100491 - Vai na Volta",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:25",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:14:26"
          },
          {
            "ticket_id": 7644,
            "ticket_number": "357636",
            "title": "Número de informação da reserva: 6130386",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 15:14:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 292.75,
            "sla_met": false,
            "sla_breach_hours": 268.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 20:00:21"
          },
          {
            "ticket_id": 7645,
            "ticket_number": "357637",
            "title": "Reserva Menorca",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:39",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:14:39"
          },
          {
            "ticket_id": 7648,
            "ticket_number": "357640",
            "title": "Esclarecimento de duvida relativo a viagem SMY 122",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:57",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:14:57"
          },
          {
            "ticket_id": 7652,
            "ticket_number": "357644",
            "title": "Re: Cotação voos Porto/Roma",
            "priority": "P2",
            "created_at": "29/01/2026 15:54:32",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:54:32"
          },
          {
            "ticket_id": 7668,
            "ticket_number": "357660",
            "title": "Fwd: O itinerário da sua viagem: STIMRE",
            "priority": "P2",
            "created_at": "29/01/2026 17:59:04",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 17:59:05"
          },
          {
            "ticket_id": 7671,
            "ticket_number": "357663",
            "title": "GBN-91048 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/01/2026 17:59:14",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 284.93,
            "sla_met": false,
            "sla_breach_hours": 280.93,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 14:56:02"
          },
          {
            "ticket_id": 7685,
            "ticket_number": "357677",
            "title": "Re: Cotação voos Lisboa/Florença",
            "priority": "P2",
            "created_at": "30/01/2026 10:08:07",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:08:07"
          },
          {
            "ticket_id": 7699,
            "ticket_number": "357691",
            "title": "Confirmacao 338534",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:08:45",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 14:04:41"
          },
          {
            "ticket_id": 7701,
            "ticket_number": "357693",
            "title": "Confirmação de reserva com localizador: 4054602",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:08:50",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 14:04:41"
          },
          {
            "ticket_id": 7702,
            "ticket_number": "357694",
            "title": "RE: Cotação voos Turkish e RoyalAir Marrocos",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:54",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:54"
          },
          {
            "ticket_id": 7705,
            "ticket_number": "357697",
            "title": "pedido cama casal no alojamento viagem 1234693735",
            "priority": "P2",
            "created_at": "30/01/2026 10:09:03",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:09:03"
          },
          {
            "ticket_id": 7707,
            "ticket_number": "357699",
            "title": "GBN-102512 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:09:12",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 10:09:12"
          },
          {
            "ticket_id": 7708,
            "ticket_number": "357700",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:09:19",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 10:09:19"
          },
          {
            "ticket_id": 7709,
            "ticket_number": "357701",
            "title": "GBN-102509 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 10:09:25",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 10:09:25"
          },
          {
            "ticket_id": 7716,
            "ticket_number": "357708",
            "title": "GBN-102484 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:10:47",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 10:10:47"
          },
          {
            "ticket_id": 7719,
            "ticket_number": "357711",
            "title": "GBN-102498 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "30/01/2026 10:11:03",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:11:11"
          },
          {
            "ticket_id": 7722,
            "ticket_number": "357714",
            "title": "RE: Alteração de nome reserva - 6122920 W2MCS:0149",
            "priority": "P2",
            "created_at": "30/01/2026 10:11:54",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:04:42"
          },
          {
            "ticket_id": 7730,
            "ticket_number": "357722",
            "title": "GBN-102450 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 10:12:21",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 10:12:21"
          },
          {
            "ticket_id": 7731,
            "ticket_number": "357723",
            "title": "Mensagem sobre a reserva 36690333 - Civitatis",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 10:12:25",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 14:04:43"
          },
          {
            "ticket_id": 7732,
            "ticket_number": "357724",
            "title": "Informação de reserva - SPT002601575704",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 10:12:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 14:04:43"
          },
          {
            "ticket_id": 7737,
            "ticket_number": "357729",
            "title": "Fwd: Pedido de alteração - 6124862",
            "priority": "P2",
            "created_at": "30/01/2026 10:12:43",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:12:43"
          },
          {
            "ticket_id": 7742,
            "ticket_number": "357734",
            "title": "CONFIRMACION: Liliana Alves / HOTEL OHTELS MAZAGON",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 11:31:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 15:24:50"
          },
          {
            "ticket_id": 7744,
            "ticket_number": "357736",
            "title": "GBN-102530 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/01/2026 11:32:37",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 8.55,
            "sla_met": false,
            "sla_breach_hours": 4.55,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:06:22"
          },
          {
            "ticket_id": 7745,
            "ticket_number": "357737",
            "title": "RE: Pedido de cotação - 6299468",
            "priority": "P2",
            "created_at": "30/01/2026 11:32:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 15:24:50"
          },
          {
            "ticket_id": 7747,
            "ticket_number": "357739",
            "title": "Fwd: Viagify informa sobre a sua reserva 124219293",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:15:35",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:15:36"
          },
          {
            "ticket_id": 7748,
            "ticket_number": "357740",
            "title": "FSFJQQ – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "30/01/2026 13:15:38",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 6.95,
            "sla_met": false,
            "sla_breach_hours": 2.95,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:13:35"
          },
          {
            "ticket_id": 7749,
            "ticket_number": "357741",
            "title": "Re: Cotação voos Toquio",
            "priority": "P2",
            "created_at": "30/01/2026 13:15:40",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:15:41"
          },
          {
            "ticket_id": 7750,
            "ticket_number": "357742",
            "title": "Número de informação da reserva: 6130673",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:15:44",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 438.98,
            "sla_met": false,
            "sla_breach_hours": 414.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 20:14:58"
          },
          {
            "ticket_id": 7751,
            "ticket_number": "357743",
            "title": "Número de informação da reserva: 6130667",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:15:47",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 438.95,
            "sla_met": false,
            "sla_breach_hours": 414.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 20:13:06"
          },
          {
            "ticket_id": 7756,
            "ticket_number": "357748",
            "title": "GBN-102574 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:16:08",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:16:08"
          },
          {
            "ticket_id": 7758,
            "ticket_number": "357750",
            "title": "Reserva Aérea FSFJQQ",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:14",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 5.17,
            "sla_met": false,
            "sla_breach_hours": 1.17,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:27:10"
          },
          {
            "ticket_id": 7768,
            "ticket_number": "357760",
            "title": "Documentação Disponível - Reserva 332766",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:53",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 5.63,
            "sla_met": false,
            "sla_breach_hours": 1.63,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:55:22"
          },
          {
            "ticket_id": 7770,
            "ticket_number": "357762",
            "title": "Informação de reserva - SPT002601568300",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:17:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 478.45,
            "sla_met": false,
            "sla_breach_hours": 454.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7772,
            "ticket_number": "357764",
            "title": "Informação de reserva - SPT002601575704",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:17:12",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 237.73,
            "sla_met": false,
            "sla_breach_hours": 213.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 11:01:23"
          },
          {
            "ticket_id": 7773,
            "ticket_number": "357765",
            "title": "Informação de reserva - SPT002601568995",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:17:19",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 129.88,
            "sla_met": false,
            "sla_breach_hours": 105.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 23:10:27"
          },
          {
            "ticket_id": 7778,
            "ticket_number": "357770",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604523178",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:25:25",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 17:20:03"
          },
          {
            "ticket_id": 7779,
            "ticket_number": "357771",
            "title": "Fwd: Reserva - 338525 quarto em WL",
            "priority": "P2",
            "created_at": "30/01/2026 13:38:04",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:26:01"
          },
          {
            "ticket_id": 7783,
            "ticket_number": "357775",
            "title": "Pedido de cotação para Djerba",
            "priority": "P2",
            "created_at": "30/01/2026 13:47:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:47:42"
          },
          {
            "ticket_id": 7790,
            "ticket_number": "357782",
            "title": "Pedido de cotação – Porto | 4 julho 2026 | Marhaba",
            "priority": "P2",
            "created_at": "30/01/2026 14:15:43",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:15:44"
          },
          {
            "ticket_id": 7792,
            "ticket_number": "357784",
            "title": "Reserva Aérea YIJB53",
            "priority": "P2",
            "created_at": "30/01/2026 14:15:49",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 4.18,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:27:19"
          },
          {
            "ticket_id": 7793,
            "ticket_number": "357785",
            "title": "INFORMAÇÃO",
            "priority": "P2",
            "created_at": "30/01/2026 14:15:53",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:15:54"
          },
          {
            "ticket_id": 7795,
            "ticket_number": "357787",
            "title": "YIJB53 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "30/01/2026 14:39:17",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:26:59"
          },
          {
            "ticket_id": 7796,
            "ticket_number": "357788",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KC",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 15:33:51",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 15:34:53"
          },
          {
            "ticket_id": 7809,
            "ticket_number": "357801",
            "title": "Fwd: PAULACRISTINA / GAIOZINHOMACHADO 31JAN2026 OP",
            "priority": "P2",
            "created_at": "30/01/2026 16:13:15",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 16:13:17"
          },
          {
            "ticket_id": 7811,
            "ticket_number": "357803",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO DE CARVALH",
            "priority": "P2",
            "created_at": "30/01/2026 16:53:53",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:12:29"
          },
          {
            "ticket_id": 7812,
            "ticket_number": "357804",
            "title": "Aéreo - Confirmação de Emissão (DOS SANTOS\\MARTA S",
            "priority": "P2",
            "created_at": "30/01/2026 16:53:56",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:30:21"
          },
          {
            "ticket_id": 7815,
            "ticket_number": "357807",
            "title": "Aéreo - Confirmação de Emissão (DOS SANTOS\\ANA RIT",
            "priority": "P2",
            "created_at": "30/01/2026 16:54:05",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:29:40"
          },
          {
            "ticket_id": 7816,
            "ticket_number": "357808",
            "title": "Aéreo - Confirmação de Emissão (DA COSTA PEREIRA\\I",
            "priority": "P2",
            "created_at": "30/01/2026 16:54:09",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:13:17"
          },
          {
            "ticket_id": 7817,
            "ticket_number": "357809",
            "title": "Aéreo - Confirmação de Emissão (GAMEIRO VICARIO\\SA",
            "priority": "P2",
            "created_at": "30/01/2026 16:54:12",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:11:53"
          },
          {
            "ticket_id": 7824,
            "ticket_number": "357816",
            "title": "MUITO URGENTE Confirmação de reserva 338525### TIM",
            "priority": "P2",
            "created_at": "30/01/2026 17:43:27",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:48:54"
          },
          {
            "ticket_id": 7853,
            "ticket_number": "357845",
            "title": "Id.Reserva SPT002601580797",
            "priority": "P2",
            "created_at": "30/01/2026 19:37:04",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:37:05"
          },
          {
            "ticket_id": 7855,
            "ticket_number": "357847",
            "title": "Fwd: Pedido de cotação para grupo",
            "priority": "P2",
            "created_at": "30/01/2026 19:37:09",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:37:09"
          },
          {
            "ticket_id": 7860,
            "ticket_number": "357852",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 20:56:00",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 12:43:39"
          },
          {
            "ticket_id": 7880,
            "ticket_number": "357872",
            "title": "Cancelamento Reserva - OpenTours - 9103814",
            "priority": "P2",
            "created_at": "30/01/2026 23:17:12",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:17:13"
          },
          {
            "ticket_id": 7889,
            "ticket_number": "357881",
            "title": "Fwd: Viagify informa sobre a sua reserva 124248828",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 00:09:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/01/2026 00:09:40"
          },
          {
            "ticket_id": 7903,
            "ticket_number": "357895",
            "title": "YXKNXO – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "31/01/2026 11:32:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 11:32:08"
          },
          {
            "ticket_id": 7945,
            "ticket_number": "357937",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:29"
          },
          {
            "ticket_id": 7949,
            "ticket_number": "357941",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:41",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:42"
          },
          {
            "ticket_id": 7966,
            "ticket_number": "357958",
            "title": "pedido orçamento grupo consolidador",
            "priority": "P3",
            "created_at": "02/02/2026 10:14:45",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:14:46"
          },
          {
            "ticket_id": 7969,
            "ticket_number": "357961",
            "title": "Grupo: GR-00F92ADAB0",
            "priority": "P3",
            "created_at": "02/02/2026 10:15:08",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 4.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:45:42"
          },
          {
            "ticket_id": 7990,
            "ticket_number": "357982",
            "title": "Grupo: GR-54FCFFFB46",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:41",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:05:02"
          },
          {
            "ticket_id": 8002,
            "ticket_number": "357994",
            "title": "Your request [~4024451]",
            "priority": "P2",
            "created_at": "02/02/2026 10:18:58",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 25.92,
            "sla_met": false,
            "sla_breach_hours": 21.92,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 12:14:47"
          },
          {
            "ticket_id": 8037,
            "ticket_number": "358029",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "P3",
            "created_at": "02/02/2026 10:48:00",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:48:01"
          },
          {
            "ticket_id": 8038,
            "ticket_number": "358030",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "P3",
            "created_at": "02/02/2026 10:48:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:48:04"
          },
          {
            "ticket_id": 8041,
            "ticket_number": "358033",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "P3",
            "created_at": "02/02/2026 10:48:11",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:48:12"
          },
          {
            "ticket_id": 8042,
            "ticket_number": "358034",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "P3",
            "created_at": "02/02/2026 10:48:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:48:16"
          },
          {
            "ticket_id": 8047,
            "ticket_number": "358039",
            "title": "YLMHFG --- Envio  Itinerário / Número bilhetes emi",
            "priority": "P3",
            "created_at": "02/02/2026 10:54:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 25.43,
            "sla_met": false,
            "sla_breach_hours": 1.43,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 12:20:41"
          },
          {
            "ticket_id": 8060,
            "ticket_number": "358052",
            "title": "RE: Nova Viagem #260200021 - Marta Tavares",
            "priority": "P2",
            "created_at": "02/02/2026 12:49:18",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:22:26"
          },
          {
            "ticket_id": 8092,
            "ticket_number": "358084",
            "title": "Re:[## 30623 ##] GBN-91048 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/02/2026 16:39:23",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:24:52"
          },
          {
            "ticket_id": 8096,
            "ticket_number": "358088",
            "title": "Re: Nova Viagem #260200004 - MM Xplor The World",
            "priority": "P2",
            "created_at": "02/02/2026 16:41:12",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 16:41:12"
          },
          {
            "ticket_id": 8126,
            "ticket_number": "358118",
            "title": "Fwd: Confirmación de reserva",
            "priority": "P2",
            "created_at": "02/02/2026 21:35:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 21:35:16"
          },
          {
            "ticket_id": 8241,
            "ticket_number": "358233",
            "title": "Grupo: GR-03516D5139",
            "priority": "P2",
            "created_at": "03/02/2026 21:27:27",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 11:23:43"
          },
          {
            "ticket_id": 8251,
            "ticket_number": "358243",
            "title": "Fwd: easyJet número de referência da reserva: KC28",
            "priority": "P2",
            "created_at": "03/02/2026 23:37:25",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 16.7,
            "sla_met": false,
            "sla_breach_hours": 12.7,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 16:19:30"
          },
          {
            "ticket_id": 8271,
            "ticket_number": "358263",
            "title": "Fwd: Proposta de Voos - ATLAS Project | Air Cargo ",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:37",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:21:37"
          },
          {
            "ticket_id": 8276,
            "ticket_number": "358268",
            "title": "Re: Nova Viagem #260100497 - Benice Travel",
            "priority": "P2",
            "created_at": "04/02/2026 10:37:41",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 10:37:41"
          },
          {
            "ticket_id": 8297,
            "ticket_number": "358289",
            "title": "Grupo: GR-339C7BE15F",
            "priority": "P3",
            "created_at": "04/02/2026 15:00:40",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:50:31"
          },
          {
            "ticket_id": 8298,
            "ticket_number": "358290",
            "title": "Grupo: GR-275F36AD88",
            "priority": "P2",
            "created_at": "04/02/2026 15:00:43",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 16:51:15"
          },
          {
            "ticket_id": 8312,
            "ticket_number": "358304",
            "title": "Reserva Aérea Y4WUL2",
            "priority": "P2",
            "created_at": "04/02/2026 17:16:23",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:33:55"
          },
          {
            "ticket_id": 8313,
            "ticket_number": "358305",
            "title": "Y4WUL2 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "04/02/2026 17:17:29",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:33:36"
          },
          {
            "ticket_id": 8315,
            "ticket_number": "358307",
            "title": "Aéreo - Confirmação de Emissão (BATISTA JERONIMO\\J",
            "priority": "P2",
            "created_at": "04/02/2026 17:35:29",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:46:38"
          },
          {
            "ticket_id": 8316,
            "ticket_number": "358308",
            "title": "Aéreo - Confirmação de Emissão (MALHEIRO MATIAS\\MA",
            "priority": "P2",
            "created_at": "04/02/2026 17:35:32",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:47:28"
          },
          {
            "ticket_id": 8317,
            "ticket_number": "358309",
            "title": "Aéreo - Confirmação de Emissão (VALENTIM FIRMINO\\L",
            "priority": "P2",
            "created_at": "04/02/2026 17:35:35",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:48:01"
          },
          {
            "ticket_id": 8319,
            "ticket_number": "358311",
            "title": "Aéreo - Confirmação de Emissão (DE SA\\ANA MARIA) -",
            "priority": "P2",
            "created_at": "04/02/2026 17:35:42",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:48:37"
          },
          {
            "ticket_id": 8320,
            "ticket_number": "358312",
            "title": "Aéreo - Confirmação de Emissão (DOS REIS\\LUCILIA M",
            "priority": "P2",
            "created_at": "04/02/2026 17:35:46",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:49:14"
          },
          {
            "ticket_id": 8325,
            "ticket_number": "358317",
            "title": "RE: Cotação voos Lisboa/Budapeste",
            "priority": "P2",
            "created_at": "04/02/2026 19:01:10",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 19:01:10"
          },
          {
            "ticket_id": 8382,
            "ticket_number": "358374",
            "title": "Fwd: Confirmación de reserva",
            "priority": "P3",
            "created_at": "05/02/2026 10:03:12",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:03:13"
          },
          {
            "ticket_id": 8392,
            "ticket_number": "358384",
            "title": "[Solicitação Recebida / Request Received]",
            "priority": "P3",
            "created_at": "05/02/2026 10:51:55",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 14:40:48"
          },
          {
            "ticket_id": 8448,
            "ticket_number": "358440",
            "title": "Aéreo - Confirmação de Emissão (PINHEIRO\\CATIA) - ",
            "priority": "P3",
            "created_at": "05/02/2026 17:55:39",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 592.33,
            "sla_met": false,
            "sla_breach_hours": 568.33,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 10:15:57"
          },
          {
            "ticket_id": 8449,
            "ticket_number": "358441",
            "title": "Aéreo - Confirmação de Emissão (ESTEVES\\TOMAS) - Y",
            "priority": "P3",
            "created_at": "05/02/2026 17:55:41",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 592.32,
            "sla_met": false,
            "sla_breach_hours": 568.32,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 10:15:26"
          },
          {
            "ticket_id": 8450,
            "ticket_number": "358442",
            "title": "Aéreo - Confirmação de Emissão (ESTEVES\\MARCIO) - ",
            "priority": "P3",
            "created_at": "05/02/2026 17:55:44",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 592.32,
            "sla_met": false,
            "sla_breach_hours": 568.32,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 10:14:49"
          },
          {
            "ticket_id": 8463,
            "ticket_number": "358455",
            "title": "NOVO INCIDENTE: Amadeus Shopping Services: Tempo d",
            "priority": "P2",
            "created_at": "05/02/2026 19:28:25",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 23:21:44"
          },
          {
            "ticket_id": 8464,
            "ticket_number": "358456",
            "title": "NOVO INCIDENTE: Amadeus Shopping Services: Tempo d",
            "priority": "P2",
            "created_at": "05/02/2026 19:28:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 23:21:44"
          },
          {
            "ticket_id": 8465,
            "ticket_number": "358457",
            "title": "Confirmação de reserva com localizador: 4064546",
            "priority": "P1",
            "created_at": "05/02/2026 19:45:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 119.57,
            "sla_met": false,
            "sla_breach_hours": 119.32,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 19:19:20"
          },
          {
            "ticket_id": 8469,
            "ticket_number": "358461",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempo de re",
            "priority": "P2",
            "created_at": "05/02/2026 20:13:25",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 19.55,
            "sla_met": false,
            "sla_breach_hours": 15.55,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 15:47:04"
          },
          {
            "ticket_id": 8470,
            "ticket_number": "358462",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempo de re",
            "priority": "P2",
            "created_at": "05/02/2026 20:13:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 19.55,
            "sla_met": false,
            "sla_breach_hours": 15.55,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 15:47:03"
          },
          {
            "ticket_id": 8479,
            "ticket_number": "358471",
            "title": "RE: Cotação voos Lisboa/Budapeste",
            "priority": "P2",
            "created_at": "05/02/2026 23:53:31",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 23:53:31"
          },
          {
            "ticket_id": 8638,
            "ticket_number": "358630",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P3",
            "created_at": "09/02/2026 10:02:17",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:02:17"
          },
          {
            "ticket_id": 8641,
            "ticket_number": "358633",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P3",
            "created_at": "09/02/2026 10:02:26",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:02:27"
          },
          {
            "ticket_id": 8643,
            "ticket_number": "358635",
            "title": "Fwd: easyJet booking reference: KC36ZR2",
            "priority": "P3",
            "created_at": "09/02/2026 10:02:34",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:02:34"
          },
          {
            "ticket_id": 8646,
            "ticket_number": "358638",
            "title": "Fwd: ECPTBMFK01 Group Request Confirmation",
            "priority": "P3",
            "created_at": "09/02/2026 10:21:29",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:21:30"
          },
          {
            "ticket_id": 8683,
            "ticket_number": "358675",
            "title": "Ethiopian Trip reminder: Check in online for your ",
            "priority": "P3",
            "created_at": "09/02/2026 10:39:47",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:03:03"
          },
          {
            "ticket_id": 8688,
            "ticket_number": "358680",
            "title": "Re: Nova Viagem #250700285 - Euforia Glam",
            "priority": "P3",
            "created_at": "09/02/2026 10:44:52",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:44:52"
          },
          {
            "ticket_id": 8691,
            "ticket_number": "358683",
            "title": "Re: Cotação voos Porto-Funchal-Porto",
            "priority": "P2",
            "created_at": "09/02/2026 10:46:03",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:46:04"
          },
          {
            "ticket_id": 8697,
            "ticket_number": "358689",
            "title": "Re: Cotação voos Austrian e Lufthansa",
            "priority": "P2",
            "created_at": "09/02/2026 10:46:24",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:46:25"
          },
          {
            "ticket_id": 8706,
            "ticket_number": "358698",
            "title": "RE: Cotação grupo Porto-Orly-Porto",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:54",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:46:55"
          },
          {
            "ticket_id": 8731,
            "ticket_number": "358723",
            "title": "Upgrade options remain for your upcoming flight",
            "priority": "P3",
            "created_at": "09/02/2026 10:52:30",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:04:10"
          },
          {
            "ticket_id": 8732,
            "ticket_number": "358724",
            "title": "Ethiopian Trip reminder: Check in online for your ",
            "priority": "P3",
            "created_at": "09/02/2026 10:53:03",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:03:10"
          },
          {
            "ticket_id": 8740,
            "ticket_number": "358732",
            "title": "Re: Cotação voo Lisboa -Mexico - Iberia",
            "priority": "P2",
            "created_at": "09/02/2026 11:51:43",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 11:51:44"
          },
          {
            "ticket_id": 8769,
            "ticket_number": "358761",
            "title": "RES: Cotação voos Porto/Miami",
            "priority": "P3",
            "created_at": "09/02/2026 16:42:29",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:42:29"
          },
          {
            "ticket_id": 8784,
            "ticket_number": "358776",
            "title": "Fwd: Incidente de voo TTN-1240917792#92540378#T175",
            "priority": "P2",
            "created_at": "09/02/2026 18:05:30",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:05:31"
          },
          {
            "ticket_id": 8785,
            "ticket_number": "358777",
            "title": "Fwd: Incidente de voo TTN-1240916209#92540329#T175",
            "priority": "P2",
            "created_at": "09/02/2026 18:05:36",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:05:37"
          },
          {
            "ticket_id": 8882,
            "ticket_number": "358874",
            "title": "Reserva Aérea FX5KDG",
            "priority": "P3",
            "created_at": "10/02/2026 16:57:02",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 2.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 19:11:24"
          },
          {
            "ticket_id": 8884,
            "ticket_number": "358876",
            "title": "FX5KDG – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "10/02/2026 17:04:38",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:10:05"
          },
          {
            "ticket_id": 8885,
            "ticket_number": "358877",
            "title": "Passaportes da reserva GBN-75942",
            "priority": "P2",
            "created_at": "10/02/2026 17:17:29",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 17:17:30"
          },
          {
            "ticket_id": 8886,
            "ticket_number": "358878",
            "title": "Aéreo - Confirmação de Emissão (SA\\FILIPE) - FX5KD",
            "priority": "P3",
            "created_at": "10/02/2026 17:17:32",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:11:02"
          },
          {
            "ticket_id": 8907,
            "ticket_number": "358899",
            "title": "Fwd: easyJet número de referência da reserva: KC3J",
            "priority": "P3",
            "created_at": "10/02/2026 18:51:49",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 19:29:02"
          },
          {
            "ticket_id": 8957,
            "ticket_number": "358949",
            "title": "Fwd: Incidente de voo TTN-1229097044#92674011#T175",
            "priority": "P2",
            "created_at": "11/02/2026 10:51:13",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 10:51:14"
          },
          {
            "ticket_id": 8958,
            "ticket_number": "358950",
            "title": "Adicao de passageiro reserva com o localizador :61",
            "priority": "P2",
            "created_at": "11/02/2026 10:51:16",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 10:51:16"
          },
          {
            "ticket_id": 8975,
            "ticket_number": "358967",
            "title": "Re: Nova Viagem #260200134 - Benice Travel",
            "priority": "P3",
            "created_at": "11/02/2026 12:32:04",
            "close_date": "2026-03-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 12:32:05"
          },
          {
            "ticket_id": 9046,
            "ticket_number": "359038",
            "title": "FMGGL9 – Alteração de Horário – Aceite",
            "priority": "P2",
            "created_at": "11/02/2026 20:47:21",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 00:13:21"
          },
          {
            "ticket_id": 9085,
            "ticket_number": "359077",
            "title": "Nova Viagem #260200134 - Benice Travel",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:29",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 10:11:29"
          },
          {
            "ticket_id": 9160,
            "ticket_number": "359152",
            "title": "Dúvida GBN",
            "priority": "P2",
            "created_at": "12/02/2026 21:14:21",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 21:14:22"
          },
          {
            "ticket_id": 9175,
            "ticket_number": "359167",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:44:03"
          },
          {
            "ticket_id": 9236,
            "ticket_number": "359228",
            "title": "FW: Pedido de orçamento grupo 17 pax | 27-28 fev. ",
            "priority": "P2",
            "created_at": "13/02/2026 16:00:20",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 16:00:22"
          },
          {
            "ticket_id": 9290,
            "ticket_number": "359282",
            "title": "Re: The Yeatman | Pedido de Orçamento | 15-16 fev.",
            "priority": "P2",
            "created_at": "13/02/2026 20:14:16",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 20:14:17"
          },
          {
            "ticket_id": 9349,
            "ticket_number": "359341",
            "title": "Fwd: UZVUTZ | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "16/02/2026 10:09:33",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:09:34"
          },
          {
            "ticket_id": 9351,
            "ticket_number": "359343",
            "title": "Re:[## 32216 ##] GBN-87698 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "16/02/2026 10:09:39",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:36:08"
          },
          {
            "ticket_id": 9363,
            "ticket_number": "359355",
            "title": "GBN-87698 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/02/2026 10:10:18",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:25:57"
          },
          {
            "ticket_id": 9375,
            "ticket_number": "359367",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P2",
            "created_at": "16/02/2026 10:12:34",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:12:34"
          },
          {
            "ticket_id": 9376,
            "ticket_number": "359368",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P2",
            "created_at": "16/02/2026 10:12:37",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:12:37"
          },
          {
            "ticket_id": 9377,
            "ticket_number": "359369",
            "title": "Fwd: Paris (Orly) - ZBDUPS",
            "priority": "P2",
            "created_at": "16/02/2026 10:12:41",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:12:42"
          },
          {
            "ticket_id": 9378,
            "ticket_number": "359370",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "16/02/2026 10:13:18",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:13:20"
          },
          {
            "ticket_id": 9379,
            "ticket_number": "359371",
            "title": "YKGIRF – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "16/02/2026 10:13:53",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 14:00:51"
          },
          {
            "ticket_id": 9382,
            "ticket_number": "359374",
            "title": "Fw: Novo Reforço de Pagamento - Viagem #260200018",
            "priority": "P2",
            "created_at": "16/02/2026 10:15:34",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:15:35"
          },
          {
            "ticket_id": 9383,
            "ticket_number": "359375",
            "title": "Cotización MALLORCA - cntravel -Ref 50005916 -Uma ",
            "priority": "P2",
            "created_at": "16/02/2026 10:17:43",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:24"
          },
          {
            "ticket_id": 9525,
            "ticket_number": "359517",
            "title": "Reserva Aérea YLAOLV",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:34",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 6.12,
            "sla_met": false,
            "sla_breach_hours": 2.12,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:36:04"
          },
          {
            "ticket_id": 9545,
            "ticket_number": "359537",
            "title": "YLAOLV – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "17/02/2026 15:47:03",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:49:18"
          },
          {
            "ticket_id": 9548,
            "ticket_number": "359540",
            "title": "Reserva Aérea YLAOLV",
            "priority": "P2",
            "created_at": "17/02/2026 16:31:10",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:49:34"
          },
          {
            "ticket_id": 9573,
            "ticket_number": "359565",
            "title": "Aéreo - Confirmação de Emissão (BRITO\\MANUEL) - YL",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:24",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:48:13"
          },
          {
            "ticket_id": 9574,
            "ticket_number": "359566",
            "title": "Aéreo - Confirmação de Emissão (BRITO\\MANUEL MARIA",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:27",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:48:13"
          },
          {
            "ticket_id": 9575,
            "ticket_number": "359567",
            "title": "Aéreo - Confirmação de Emissão (BRITO\\RITA) - YLAO",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:30",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:48:13"
          },
          {
            "ticket_id": 9576,
            "ticket_number": "359568",
            "title": "Aéreo - Confirmação de Emissão (BRITO\\MARIA) - YLA",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:34",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:48:13"
          },
          {
            "ticket_id": 9584,
            "ticket_number": "359576",
            "title": "Fwd: Alteração de Voo // 1240916209 TTN-1240916209",
            "priority": "P2",
            "created_at": "17/02/2026 19:48:45",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 19:48:45"
          },
          {
            "ticket_id": 9586,
            "ticket_number": "359578",
            "title": "SMYTRAVEL - RYANAIR BAGAGEM",
            "priority": "P2",
            "created_at": "17/02/2026 22:55:09",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:55:09"
          },
          {
            "ticket_id": 9589,
            "ticket_number": "359581",
            "title": "Fwd: GBN Travel: Reenvio de confirmação de reserva",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:21",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 22:55:22"
          },
          {
            "ticket_id": 9604,
            "ticket_number": "359596",
            "title": "Cancelamento GBN: GBN-106327 Leplan: 604554558",
            "priority": "P2",
            "created_at": "17/02/2026 22:56:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:56:06"
          },
          {
            "ticket_id": 9606,
            "ticket_number": "359598",
            "title": "Pedido de cancelamento - 2416400003",
            "priority": "P2",
            "created_at": "17/02/2026 22:56:48",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:56:48"
          },
          {
            "ticket_id": 9608,
            "ticket_number": "359600",
            "title": "GBN-106327 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/02/2026 00:00:10",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1547.07,
            "sla_met": false,
            "sla_breach_hours": 1543.07,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 11:04:49"
          },
          {
            "ticket_id": 9610,
            "ticket_number": "359602",
            "title": "Urgente – Falta de disponibilidade Excursão à Ilha",
            "priority": "P2",
            "created_at": "18/02/2026 10:13:53",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 10:13:53"
          },
          {
            "ticket_id": 9611,
            "ticket_number": "359603",
            "title": "Informação importante sobre a tua reserva 1770371",
            "priority": "P2",
            "created_at": "18/02/2026 10:13:56",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 12:08:57"
          },
          {
            "ticket_id": 9612,
            "ticket_number": "359604",
            "title": "GBN-105373 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:28",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 12:15:49"
          },
          {
            "ticket_id": 9613,
            "ticket_number": "359605",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:30",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 12:16:03"
          },
          {
            "ticket_id": 9619,
            "ticket_number": "359611",
            "title": "Re:[## 32358 ##] GBN-106327 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "18/02/2026 10:15:18",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:00:30"
          },
          {
            "ticket_id": 9620,
            "ticket_number": "359612",
            "title": "Cotação IATA - Voos para início de Abril",
            "priority": "P2",
            "created_at": "18/02/2026 11:45:33",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:45:34"
          },
          {
            "ticket_id": 9623,
            "ticket_number": "359615",
            "title": "Fwd: Viagify informa sobre a sua reserva 125004412",
            "priority": "P2",
            "created_at": "18/02/2026 11:45:44",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:45:45"
          },
          {
            "ticket_id": 9624,
            "ticket_number": "359616",
            "title": "Fwd: Viagify informa sobre a sua reserva 125004412",
            "priority": "P2",
            "created_at": "18/02/2026 11:45:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:45:50"
          },
          {
            "ticket_id": 9627,
            "ticket_number": "359619",
            "title": "1242488288 TTN-1242488288#93435308#T17783557¬10620",
            "priority": "P2",
            "created_at": "18/02/2026 12:47:36",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 16:12:34"
          },
          {
            "ticket_id": 9630,
            "ticket_number": "359622",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60455455",
            "priority": "P3",
            "created_at": "18/02/2026 14:06:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 18:01:22"
          },
          {
            "ticket_id": 9632,
            "ticket_number": "359624",
            "title": "Z4R6OF – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:18",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:01:22"
          },
          {
            "ticket_id": 9633,
            "ticket_number": "359625",
            "title": "Fwd: Informações sobre a sua reserva TTN-124987337",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:20",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:08:20"
          },
          {
            "ticket_id": 9635,
            "ticket_number": "359627",
            "title": "Fwd: Informações sobre a sua reserva TTN-124987337",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:36",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:08:37"
          },
          {
            "ticket_id": 9636,
            "ticket_number": "359628",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1250044124#93",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:08:40"
          },
          {
            "ticket_id": 9640,
            "ticket_number": "359632",
            "title": "Reserva Aérea Z4R6OF",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:54",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:01:22"
          },
          {
            "ticket_id": 9641,
            "ticket_number": "359633",
            "title": "Re:[## 32377 ##] FW: \"GBN-91302 - Your request has",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:58",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:58:39"
          },
          {
            "ticket_id": 9645,
            "ticket_number": "359637",
            "title": "\"GBN-91302 - Your request has been received\"",
            "priority": "P2",
            "created_at": "18/02/2026 14:09:09",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:01:22"
          },
          {
            "ticket_id": 9653,
            "ticket_number": "359645",
            "title": "Lufthansa Group: Taxa de realização para reservas ",
            "priority": "P2",
            "created_at": "18/02/2026 17:29:54",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:34:22"
          },
          {
            "ticket_id": 9668,
            "ticket_number": "359660",
            "title": "Fwd: easyJet número de referência da reserva: KBXJ",
            "priority": "P2",
            "created_at": "18/02/2026 17:31:31",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:31:31"
          },
          {
            "ticket_id": 9669,
            "ticket_number": "359661",
            "title": "Fwd: easyJet número de referência da reserva: KBXJ",
            "priority": "P2",
            "created_at": "18/02/2026 17:31:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:31:32"
          },
          {
            "ticket_id": 9670,
            "ticket_number": "359662",
            "title": "Fwd: easyJet número de referência da reserva: KBXJ",
            "priority": "P2",
            "created_at": "18/02/2026 17:31:33",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:31:33"
          },
          {
            "ticket_id": 9675,
            "ticket_number": "359667",
            "title": "Aéreo - Confirmação de Emissão (DA SILVA\\JULIANO) ",
            "priority": "P2",
            "created_at": "18/02/2026 18:23:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:27:56"
          },
          {
            "ticket_id": 9677,
            "ticket_number": "359669",
            "title": "Aéreo - Confirmação de Emissão (CARVALHO LAMEIRINH",
            "priority": "P2",
            "created_at": "18/02/2026 18:23:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:27:08"
          },
          {
            "ticket_id": 9679,
            "ticket_number": "359671",
            "title": "Aéreo - Confirmação de Emissão (DELGADO APERTA\\ANA",
            "priority": "P2",
            "created_at": "18/02/2026 18:23:52",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:30:06"
          },
          {
            "ticket_id": 9681,
            "ticket_number": "359673",
            "title": "Aéreo - Confirmação de Emissão (APERTA DA SILVA\\JU",
            "priority": "P2",
            "created_at": "18/02/2026 18:23:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:29:09"
          },
          {
            "ticket_id": 9682,
            "ticket_number": "359674",
            "title": "Aéreo - Confirmação de Emissão (SOBRAL LAMEIRINHAS",
            "priority": "P2",
            "created_at": "18/02/2026 18:24:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:26:19"
          },
          {
            "ticket_id": 9689,
            "ticket_number": "359681",
            "title": "Aéreo - Confirmação de Emissão (DELGADO APERTA\\ANA",
            "priority": "P2",
            "created_at": "18/02/2026 18:43:53",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 19:27:38"
          },
          {
            "ticket_id": 9690,
            "ticket_number": "359682",
            "title": "Aéreo - Confirmação de Emissão (DA SILVA\\JULIANO) ",
            "priority": "P2",
            "created_at": "18/02/2026 18:43:56",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 19:27:53"
          },
          {
            "ticket_id": 9691,
            "ticket_number": "359683",
            "title": "Aéreo - Confirmação de Emissão (APERTA DA SILVA\\JU",
            "priority": "P2",
            "created_at": "18/02/2026 18:43:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 19:27:45"
          },
          {
            "ticket_id": 9728,
            "ticket_number": "359720",
            "title": "Opti: 2416700022",
            "priority": "P2",
            "created_at": "19/02/2026 10:07:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:07:28"
          },
          {
            "ticket_id": 9733,
            "ticket_number": "359725",
            "title": "OJO1S5 - Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "19/02/2026 10:08:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:14:30"
          },
          {
            "ticket_id": 9741,
            "ticket_number": "359733",
            "title": "Fwd: ANWB8L | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "19/02/2026 10:59:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:59:09"
          },
          {
            "ticket_id": 9743,
            "ticket_number": "359735",
            "title": "Fwd: 1240917792 TTN-1240917792#92540378#T17524642¬",
            "priority": "P2",
            "created_at": "19/02/2026 10:59:14",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:59:15"
          },
          {
            "ticket_id": 9773,
            "ticket_number": "359765",
            "title": "YLAOLV – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "19/02/2026 16:10:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:35:07"
          },
          {
            "ticket_id": 9792,
            "ticket_number": "359784",
            "title": "Re: Cotação voos Lisboa Porto lisboa",
            "priority": "P2",
            "created_at": "19/02/2026 19:00:49",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 19:00:50"
          },
          {
            "ticket_id": 9796,
            "ticket_number": "359788",
            "title": "IMPACTADO: Serviços de compras da Amadeus: Tempos ",
            "priority": "P2",
            "created_at": "19/02/2026 19:27:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 20:13:08"
          },
          {
            "ticket_id": 9797,
            "ticket_number": "359789",
            "title": "IMPACTADO: Serviços de compras da Amadeus: Tempos ",
            "priority": "P2",
            "created_at": "19/02/2026 19:27:17",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 20:13:08"
          },
          {
            "ticket_id": 9801,
            "ticket_number": "359793",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempos de r",
            "priority": "P2",
            "created_at": "19/02/2026 20:51:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 22:12:36"
          },
          {
            "ticket_id": 9802,
            "ticket_number": "359794",
            "title": "RECUPERADO: Amadeus Shopping Services: Tempos de r",
            "priority": "P2",
            "created_at": "19/02/2026 20:52:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 22:12:36"
          },
          {
            "ticket_id": 9819,
            "ticket_number": "359811",
            "title": "Re: Cotação Lisboa/Sao Paulo/Lisboa",
            "priority": "P2",
            "created_at": "20/02/2026 00:03:27",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 00:03:28"
          },
          {
            "ticket_id": 9825,
            "ticket_number": "359817",
            "title": "[Pedido IATA] Lisboa (LIS) → bruxelas - 2026-03-02",
            "priority": "P2",
            "created_at": "20/02/2026 09:16:41",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 445.8,
            "sla_met": false,
            "sla_breach_hours": 441.8,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:05:11"
          },
          {
            "ticket_id": 9829,
            "ticket_number": "359821",
            "title": "Fwd: ANWB8L | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "20/02/2026 10:19:06",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:19:07"
          },
          {
            "ticket_id": 9836,
            "ticket_number": "359828",
            "title": "Alteração hora transfer",
            "priority": "P1",
            "created_at": "20/02/2026 10:19:23",
            "close_date": "2026-02-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.37,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P1",
            "first_response_at": "20/02/2026 10:41:42"
          },
          {
            "ticket_id": 9867,
            "ticket_number": "359856",
            "title": "[Pedido IATA] Lisboa → França - 2026-02-24 (1 pax)",
            "priority": "P2",
            "created_at": "20/02/2026 11:16:47",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 11:17:17"
          },
          {
            "ticket_id": 9876,
            "ticket_number": "359864",
            "title": "Re:[## 32605 ##] GBN-105929 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "20/02/2026 12:16:15",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 14:01:40"
          },
          {
            "ticket_id": 9879,
            "ticket_number": "359867",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "20/02/2026 12:30:17",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:14:34"
          },
          {
            "ticket_id": 9890,
            "ticket_number": "359878",
            "title": "[Pedido IATA] Lisboa (LIS) → Boston (BOS) - 2026-0",
            "priority": "P2",
            "created_at": "20/02/2026 13:37:25",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:45:19"
          },
          {
            "ticket_id": 9893,
            "ticket_number": "359881",
            "title": "RUFINO/BELMIRA MRS 26FEB LIS OPO",
            "priority": "P2",
            "created_at": "20/02/2026 14:27:35",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 14:30:01"
          },
          {
            "ticket_id": 9894,
            "ticket_number": "359882",
            "title": "GONCALVES/SANDRA MARGARIDA MRS 26FEB LIS OPO",
            "priority": "P2",
            "created_at": "20/02/2026 14:27:37",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 14:30:34"
          },
          {
            "ticket_id": 9895,
            "ticket_number": "359883",
            "title": "GONCALVES/SANDRA MARGARIDA MRS 26FEB2026 LIS OPO",
            "priority": "P2",
            "created_at": "20/02/2026 14:27:39",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 14:32:21"
          },
          {
            "ticket_id": 9896,
            "ticket_number": "359884",
            "title": "FITAS/RUBEN MR 02MAR LIS BRU",
            "priority": "P2",
            "created_at": "20/02/2026 14:42:16",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 14:43:28"
          },
          {
            "ticket_id": 9899,
            "ticket_number": "359887",
            "title": "GBN-107051 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/02/2026 15:02:55",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1483.93,
            "sla_met": false,
            "sla_breach_hours": 1479.93,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:59:22"
          },
          {
            "ticket_id": 9907,
            "ticket_number": "359895",
            "title": "OJO1S5 - Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "20/02/2026 16:06:42",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:27:44"
          },
          {
            "ticket_id": 9913,
            "ticket_number": "359901",
            "title": "RE: SSR - Case number: 1356493    [ ref:!00D0Y01LB",
            "priority": "P2",
            "created_at": "20/02/2026 16:23:24",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:26:26"
          },
          {
            "ticket_id": 9914,
            "ticket_number": "359902",
            "title": "[Pedido IATA] Lisboa → Funchal - 2026-03-13 (2 pax",
            "priority": "P2",
            "created_at": "20/02/2026 16:27:37",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:57:15"
          },
          {
            "ticket_id": 9916,
            "ticket_number": "359904",
            "title": "SSR - Case number: 1356493    [ ref:!00D0Y01LB0W.!",
            "priority": "P2",
            "created_at": "20/02/2026 16:53:19",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 17:00:03"
          },
          {
            "ticket_id": 9923,
            "ticket_number": "359911",
            "title": "Re: Cotação Lisboa/Funchal/Lisboa",
            "priority": "P2",
            "created_at": "20/02/2026 17:34:19",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 17:34:19"
          },
          {
            "ticket_id": 9928,
            "ticket_number": "359916",
            "title": "Re: Cotação Lisboa/Boston",
            "priority": "P2",
            "created_at": "20/02/2026 18:11:44",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 18:11:44"
          },
          {
            "ticket_id": 9953,
            "ticket_number": "359941",
            "title": "[Pedido IATA] lisboa → cabo verde Sal - 2026-06-10",
            "priority": "P2",
            "created_at": "20/02/2026 20:06:38",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 20:06:38"
          },
          {
            "ticket_id": 9969,
            "ticket_number": "359957",
            "title": "RE: Cotação voo Porto Orly",
            "priority": "P2",
            "created_at": "20/02/2026 21:19:14",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:19:14"
          },
          {
            "ticket_id": 9972,
            "ticket_number": "359960",
            "title": "Re: Cotação voos Lisboa/Budapeste",
            "priority": "P2",
            "created_at": "20/02/2026 22:04:17",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 22:04:18"
          },
          {
            "ticket_id": 9973,
            "ticket_number": "359961",
            "title": "Re: Cotação voo Lisboa Tercera Lisboa",
            "priority": "P2",
            "created_at": "20/02/2026 22:04:19",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 22:04:19"
          },
          {
            "ticket_id": 9977,
            "ticket_number": "359965",
            "title": "Cancelamento reserva Soltropico",
            "priority": "P2",
            "created_at": "20/02/2026 23:06:07",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 23:06:07"
          },
          {
            "ticket_id": 9988,
            "ticket_number": "359976",
            "title": "[Pedido IATA] LIS → BSB - 2026-06-16 (1 pax)",
            "priority": "P2",
            "created_at": "21/02/2026 09:20:36",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 09:20:37"
          },
          {
            "ticket_id": 10031,
            "ticket_number": "3510019",
            "title": "[Pedido IATA] Lisboa → Amesterdão (Schiphol) - 202",
            "priority": "P2",
            "created_at": "21/02/2026 16:29:09",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 16:29:09"
          },
          {
            "ticket_id": 10034,
            "ticket_number": "3510022",
            "title": "[Pedido IATA] Porto → Luxemburgo - 2026-10-03 (33 ",
            "priority": "P2",
            "created_at": "21/02/2026 17:26:07",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 17:26:07"
          },
          {
            "ticket_id": 10038,
            "ticket_number": "3510026",
            "title": "[Pedido IATA] Porto → Aeroporto Orly - 2026-12-26 ",
            "priority": "P2",
            "created_at": "21/02/2026 19:04:26",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 19:04:27"
          },
          {
            "ticket_id": 10044,
            "ticket_number": "3510032",
            "title": "Fwd: Incidente de voo TTN-1221246929#93820772#T178",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:17",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:17"
          },
          {
            "ticket_id": 10047,
            "ticket_number": "3510035",
            "title": "Fwd: Incidência de Voo / 1240917792 TTN-1240917792",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:24",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:25"
          },
          {
            "ticket_id": 10051,
            "ticket_number": "3510039",
            "title": "YCAKYD – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:34",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:47"
          },
          {
            "ticket_id": 10056,
            "ticket_number": "3510044",
            "title": "Possível erro GBN Travel",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:45",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:45"
          },
          {
            "ticket_id": 10063,
            "ticket_number": "3510051",
            "title": "Cancelamento Reserva 339181 Soltropico",
            "priority": "P2",
            "created_at": "23/02/2026 10:26:41",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:26:41"
          },
          {
            "ticket_id": 10077,
            "ticket_number": "3510065",
            "title": "Fwd: Re: Orçamento Barcelona - MUITO URGENTE",
            "priority": "P2",
            "created_at": "23/02/2026 10:41:29",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:41:29"
          },
          {
            "ticket_id": 10095,
            "ticket_number": "3510083",
            "title": "ALTERAÇÃO VOO - SOLFÉRIAS LOCALIZADOR: 426271",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:25",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:40:25"
          },
          {
            "ticket_id": 10102,
            "ticket_number": "3510090",
            "title": "Aéreo - Confirmação de Emissão (PIEDADEALBERTO MOR",
            "priority": "P2",
            "created_at": "23/02/2026 12:35:56",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 12:45:08"
          },
          {
            "ticket_id": 10127,
            "ticket_number": "3510115",
            "title": "Confirmação de Reserva * File 431081*( Time Limit ",
            "priority": "P2",
            "created_at": "23/02/2026 14:29:37",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:31:55"
          },
          {
            "ticket_id": 10128,
            "ticket_number": "3510116",
            "title": "Incidencia de voo / 1240916209 TTN-1240916209#9389",
            "priority": "P2",
            "created_at": "23/02/2026 14:38:00",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:51:03"
          },
          {
            "ticket_id": 10130,
            "ticket_number": "3510118",
            "title": "Incidência de Voo / 1240917792 TTN-1240917792#9390",
            "priority": "P2",
            "created_at": "23/02/2026 14:56:55",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:57:56"
          },
          {
            "ticket_id": 10133,
            "ticket_number": "3510121",
            "title": "[Pedido IATA] Lisboa → Rabil, Ilha da Boavista - 2",
            "priority": "P2",
            "created_at": "23/02/2026 15:29:17",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:29:17"
          },
          {
            "ticket_id": 10134,
            "ticket_number": "3510122",
            "title": "LOC SMY 1234129672",
            "priority": "P2",
            "created_at": "23/02/2026 15:41:26",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:26"
          },
          {
            "ticket_id": 10135,
            "ticket_number": "3510123",
            "title": "DUPLICAÇÃO DE RESERVAS 340135/339181",
            "priority": "P2",
            "created_at": "23/02/2026 16:07:46",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:09:30"
          },
          {
            "ticket_id": 10137,
            "ticket_number": "3510125",
            "title": "YPE4BP – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/02/2026 16:20:07",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 16:20:19"
          },
          {
            "ticket_id": 10150,
            "ticket_number": "3510138",
            "title": "URGENTE - Consolidador Z3XI74, PNR Voo TAP",
            "priority": "P2",
            "created_at": "23/02/2026 16:51:04",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 16:51:05"
          },
          {
            "ticket_id": 10151,
            "ticket_number": "3510139",
            "title": "Fwd: Informações da reserva TTN-1234129672#9392545",
            "priority": "P2",
            "created_at": "23/02/2026 17:21:01",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:21:02"
          },
          {
            "ticket_id": 10160,
            "ticket_number": "3510148",
            "title": "Confirmação de reserva 340262",
            "priority": "P2",
            "created_at": "23/02/2026 17:53:23",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 16.6,
            "sla_met": false,
            "sla_breach_hours": 12.6,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:29:25"
          },
          {
            "ticket_id": 10164,
            "ticket_number": "3510152",
            "title": "Grupo: GR-53449259F7",
            "priority": "P2",
            "created_at": "23/02/2026 18:39:30",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:01:38"
          },
          {
            "ticket_id": 10176,
            "ticket_number": "3510164",
            "title": "[Pedido IATA] Lisboa → Catânia - 2026-10-29 (41 pa",
            "priority": "P2",
            "created_at": "23/02/2026 20:14:37",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 20:14:38"
          },
          {
            "ticket_id": 10180,
            "ticket_number": "3510168",
            "title": "[Pedido IATA] lisboa → chania - 2026-08-24 (5 pax)",
            "priority": "P2",
            "created_at": "23/02/2026 20:55:33",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 20:55:34"
          },
          {
            "ticket_id": 10196,
            "ticket_number": "3510184",
            "title": "[Pedido IATA] Porto (OPO) → Malaga (AGP) - 2026-08",
            "priority": "P2",
            "created_at": "24/02/2026 01:56:19",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 01:56:19"
          },
          {
            "ticket_id": 10198,
            "ticket_number": "3510186",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "24/02/2026 10:07:49",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:33:49"
          },
          {
            "ticket_id": 10211,
            "ticket_number": "3510199",
            "title": "YPE4BP – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:22",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:43:25"
          },
          {
            "ticket_id": 10215,
            "ticket_number": "3510203",
            "title": "Aéreo - Confirmação de Emissão (SERRANO\\OLGA) - YP",
            "priority": "P2",
            "created_at": "24/02/2026 10:39:44",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:44:18"
          },
          {
            "ticket_id": 10216,
            "ticket_number": "3510204",
            "title": "Aéreo - Confirmação de Emissão (MOTA\\SAMUEL) - YPE",
            "priority": "P2",
            "created_at": "24/02/2026 10:39:46",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:44:46"
          },
          {
            "ticket_id": 10217,
            "ticket_number": "3510205",
            "title": "Aéreo - Confirmação de Emissão (SERRANO\\SERAFIM) -",
            "priority": "P2",
            "created_at": "24/02/2026 10:39:49",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:45:10"
          },
          {
            "ticket_id": 10218,
            "ticket_number": "3510206",
            "title": "Aéreo - Confirmação de Emissão (REINALDO\\AMERICO) ",
            "priority": "P2",
            "created_at": "24/02/2026 10:39:52",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:46:13"
          },
          {
            "ticket_id": 10219,
            "ticket_number": "3510207",
            "title": "Aéreo - Confirmação de Emissão (LOURO\\MANUEL) - YP",
            "priority": "P2",
            "created_at": "24/02/2026 10:39:55",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:46:39"
          },
          {
            "ticket_id": 10220,
            "ticket_number": "3510208",
            "title": "Aéreo - Confirmação de Emissão (BOAVIDA\\DAVID) - Y",
            "priority": "P2",
            "created_at": "24/02/2026 10:40:30",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:47:08"
          },
          {
            "ticket_id": 10222,
            "ticket_number": "3510210",
            "title": "Aéreo - Confirmação de Emissão (TAVARES\\LUIS) - YP",
            "priority": "P2",
            "created_at": "24/02/2026 11:07:00",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 13:17:56"
          },
          {
            "ticket_id": 10242,
            "ticket_number": "3510230",
            "title": "[Pedido IATA] Lisboa  → Madrid - 2026-04-05 (1 pax",
            "priority": "P2",
            "created_at": "24/02/2026 12:35:05",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 12:35:05"
          },
          {
            "ticket_id": 10243,
            "ticket_number": "3510231",
            "title": "[Pedido IATA] Porto (OPO) → Rio de Janeiro (GIG) -",
            "priority": "P2",
            "created_at": "24/02/2026 12:45:30",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 12:45:31"
          },
          {
            "ticket_id": 10244,
            "ticket_number": "3510232",
            "title": "Fwd: easyJet número de referência da reserva: KBJ3",
            "priority": "P3",
            "created_at": "24/02/2026 12:49:53",
            "close_date": "2026-02-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 12:49:54"
          },
          {
            "ticket_id": 10245,
            "ticket_number": "3510233",
            "title": "Fwd: easyJet número de referência da reserva: KBJ3",
            "priority": "P3",
            "created_at": "24/02/2026 12:49:56",
            "close_date": "2026-02-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 12:49:57"
          },
          {
            "ticket_id": 10246,
            "ticket_number": "3510234",
            "title": "Fwd: easyJet número de referência da reserva: KBJ3",
            "priority": "P3",
            "created_at": "24/02/2026 12:50:00",
            "close_date": "2026-02-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 12:50:01"
          },
          {
            "ticket_id": 10247,
            "ticket_number": "3510235",
            "title": "Fwd: easyJet número de referência da reserva: KBJ3",
            "priority": "P3",
            "created_at": "24/02/2026 12:50:04",
            "close_date": "2026-02-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 12:50:05"
          },
          {
            "ticket_id": 10248,
            "ticket_number": "3510236",
            "title": "Fwd: easyJet número de referência da reserva: KBJ3",
            "priority": "P3",
            "created_at": "24/02/2026 12:50:08",
            "close_date": "2026-02-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 12:50:10"
          },
          {
            "ticket_id": 10250,
            "ticket_number": "3510238",
            "title": "Confirmacao 340393",
            "priority": "P2",
            "created_at": "24/02/2026 13:14:00",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 13:25:21"
          },
          {
            "ticket_id": 10252,
            "ticket_number": "3510240",
            "title": "Confirmação de reserva 340393 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "24/02/2026 13:20:54",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:54:12"
          },
          {
            "ticket_id": 10253,
            "ticket_number": "3510241",
            "title": "[Pedido IATA] Lisboa → Catânia - 2026-10-29 (41 pa",
            "priority": "P2",
            "created_at": "24/02/2026 13:52:53",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 13:52:54"
          },
          {
            "ticket_id": 10256,
            "ticket_number": "3510244",
            "title": "[Pedido IATA] Lisboa (LIS) → bogota - 2026-03-08 (",
            "priority": "P2",
            "created_at": "24/02/2026 14:09:05",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:09:05"
          },
          {
            "ticket_id": 10258,
            "ticket_number": "3510246",
            "title": "[Pedido IATA] medellin → guayaquil - 2026-03-13 (2",
            "priority": "P2",
            "created_at": "24/02/2026 14:22:57",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:22:57"
          },
          {
            "ticket_id": 10259,
            "ticket_number": "3510247",
            "title": "[Pedido IATA] Lisboa → Salvador - 2026-05-04 (3 pa",
            "priority": "P3",
            "created_at": "24/02/2026 15:11:18",
            "close_date": "2026-02-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 15:11:19"
          },
          {
            "ticket_id": 10260,
            "ticket_number": "3510248",
            "title": "[Pedido IATA] Lisboa → Salvador - 2026-05-04 (3 pa",
            "priority": "P3",
            "created_at": "24/02/2026 15:15:12",
            "close_date": "2026-02-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 15:15:12"
          },
          {
            "ticket_id": 10261,
            "ticket_number": "3510249",
            "title": "[Pedido IATA] St Barthelemu (SBH) → Porto - 2026-0",
            "priority": "P3",
            "created_at": "24/02/2026 15:22:45",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 15:22:46"
          },
          {
            "ticket_id": 10262,
            "ticket_number": "3510250",
            "title": "[Pedido IATA] Lisboa → Salvador - 2026-05-07 (3 pa",
            "priority": "P3",
            "created_at": "24/02/2026 15:27:40",
            "close_date": "2026-02-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 15:27:41"
          },
          {
            "ticket_id": 10282,
            "ticket_number": "3510270",
            "title": "Cancelamento de reserva 340393",
            "priority": "P2",
            "created_at": "24/02/2026 18:21:13",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 15.95,
            "sla_met": false,
            "sla_breach_hours": 11.95,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:18:16"
          },
          {
            "ticket_id": 10284,
            "ticket_number": "3510272",
            "title": "Reserva Aérea G1L3GX",
            "priority": "P2",
            "created_at": "24/02/2026 18:42:30",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 15.52,
            "sla_met": false,
            "sla_breach_hours": 11.52,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:13:53"
          },
          {
            "ticket_id": 10286,
            "ticket_number": "3510274",
            "title": "G1L3GX – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "24/02/2026 18:48:59",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:43:57"
          },
          {
            "ticket_id": 10325,
            "ticket_number": "3510313",
            "title": "Confirmação de reserva. Localizador: 46G7HWLU44",
            "priority": "P2",
            "created_at": "25/02/2026 10:09:07",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:11:55"
          },
          {
            "ticket_id": 10326,
            "ticket_number": "3510314",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 4",
            "priority": "P2",
            "created_at": "25/02/2026 10:09:42",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:11:33"
          },
          {
            "ticket_id": 10329,
            "ticket_number": "3510317",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:16",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:46:51"
          },
          {
            "ticket_id": 10341,
            "ticket_number": "3510329",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "25/02/2026 10:17:01",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 12:18:42"
          },
          {
            "ticket_id": 10342,
            "ticket_number": "3510330",
            "title": "ZC6DOM – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "25/02/2026 10:17:03",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:00:36"
          },
          {
            "ticket_id": 10348,
            "ticket_number": "3510336",
            "title": "Aéreo - Confirmação de Emissão (RESENDE\\HELENA) - ",
            "priority": "P2",
            "created_at": "25/02/2026 10:55:02",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 12:19:38"
          },
          {
            "ticket_id": 10354,
            "ticket_number": "3510342",
            "title": "Documentos",
            "priority": "P2",
            "created_at": "25/02/2026 11:00:32",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:00:33"
          },
          {
            "ticket_id": 10360,
            "ticket_number": "3510348",
            "title": "Mexico",
            "priority": "P2",
            "created_at": "25/02/2026 11:41:30",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:41:30"
          },
          {
            "ticket_id": 10371,
            "ticket_number": "3510359",
            "title": "Grupo: GR-AB4CE15109",
            "priority": "P2",
            "created_at": "25/02/2026 12:31:10",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:17:29"
          },
          {
            "ticket_id": 10377,
            "ticket_number": "3510365",
            "title": "GBN-108091",
            "priority": "P2",
            "created_at": "25/02/2026 12:43:14",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 12:43:15"
          },
          {
            "ticket_id": 10379,
            "ticket_number": "3510367",
            "title": "Envio (Recibo-2147835648) (Recibo-2147835649) (Rec",
            "priority": "P2",
            "created_at": "25/02/2026 12:45:25",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:18:23"
          },
          {
            "ticket_id": 10380,
            "ticket_number": "3510368",
            "title": "Reserva Aérea ZNJ3IF",
            "priority": "P2",
            "created_at": "25/02/2026 12:48:37",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:18:59"
          },
          {
            "ticket_id": 10384,
            "ticket_number": "3510372",
            "title": "ZNJ3IF – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "25/02/2026 13:45:16",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:18:44"
          },
          {
            "ticket_id": 10387,
            "ticket_number": "3510375",
            "title": "Fwd: Informações da reserva TTN-1253063476#9414968",
            "priority": "P2",
            "created_at": "25/02/2026 14:10:10",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:10:11"
          },
          {
            "ticket_id": 10388,
            "ticket_number": "3510376",
            "title": "Cancelamento Reserva - Amanhã entra em gastos",
            "priority": "P2",
            "created_at": "25/02/2026 14:21:17",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:21:18"
          },
          {
            "ticket_id": 10397,
            "ticket_number": "3510385",
            "title": "[Pedido IATA] Lisboa → Edimburgo - 2026-08-05 (2 p",
            "priority": "P2",
            "created_at": "25/02/2026 15:23:20",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 15:23:20"
          },
          {
            "ticket_id": 10398,
            "ticket_number": "3510386",
            "title": "[Pedido IATA] Lisboa → Barcelona - 2026-09-14 (8 p",
            "priority": "P2",
            "created_at": "25/02/2026 16:10:30",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:10:30"
          },
          {
            "ticket_id": 10404,
            "ticket_number": "3510392",
            "title": "Re:[## 33097 ##] GBN-107545 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "25/02/2026 16:21:17",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:25:12"
          },
          {
            "ticket_id": 10410,
            "ticket_number": "3510398",
            "title": "Voos Iata - KC3J2K4;",
            "priority": "P2",
            "created_at": "25/02/2026 17:03:03",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:03:03"
          },
          {
            "ticket_id": 10415,
            "ticket_number": "3510403",
            "title": "GBN-108209 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/02/2026 17:35:59",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:58:10"
          },
          {
            "ticket_id": 10419,
            "ticket_number": "3510407",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/02/2026 17:58:57",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:04:41"
          },
          {
            "ticket_id": 10421,
            "ticket_number": "3510409",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/02/2026 17:59:14",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:59:14"
          },
          {
            "ticket_id": 10453,
            "ticket_number": "3510441",
            "title": "[Pedido IATA] Lisboa → Madrid - 2026-04-17 (4 pax)",
            "priority": "P2",
            "created_at": "25/02/2026 22:41:38",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 22:41:38"
          },
          {
            "ticket_id": 10454,
            "ticket_number": "3510442",
            "title": "[Pedido IATA] Lisboa → Madrid - 2026-04-24 (4 pax)",
            "priority": "P2",
            "created_at": "25/02/2026 22:52:01",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 22:52:02"
          },
          {
            "ticket_id": 10471,
            "ticket_number": "3510459",
            "title": "ZNJ3IF     – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "26/02/2026 10:04:03",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 11:20:52"
          },
          {
            "ticket_id": 10478,
            "ticket_number": "3510466",
            "title": "Fwd: easyJet número de referência da reserva: KC6B",
            "priority": "P2",
            "created_at": "26/02/2026 11:02:10",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 11:14:01"
          },
          {
            "ticket_id": 10483,
            "ticket_number": "3510471",
            "title": "Aéreo - Confirmação de Emissão (PARENTE\\RAQUEL) - ",
            "priority": "P2",
            "created_at": "26/02/2026 11:46:48",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 11:56:19"
          },
          {
            "ticket_id": 10495,
            "ticket_number": "3510483",
            "title": "Fwd: easyJet booking reference: KC692SM",
            "priority": "P2",
            "created_at": "26/02/2026 12:17:31",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:17:32"
          },
          {
            "ticket_id": 10497,
            "ticket_number": "3510485",
            "title": "[Pedido IATA] Lisboa (LIS) → Terceira (TER) - 2026",
            "priority": "P2",
            "created_at": "26/02/2026 12:22:55",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:22:55"
          },
          {
            "ticket_id": 10500,
            "ticket_number": "3510488",
            "title": "Re:[## 33152 ##] GBN-101445 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "26/02/2026 12:24:44",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:33:06"
          },
          {
            "ticket_id": 10514,
            "ticket_number": "3510502",
            "title": "Faturas Pendentes: FA 2147896313",
            "priority": "P1",
            "created_at": "26/02/2026 14:07:07",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 14:13:30"
          },
          {
            "ticket_id": 10517,
            "ticket_number": "3510505",
            "title": "[Pedido IATA] Porto → Riga - 2026-09-26 (3 pax)",
            "priority": "P2",
            "created_at": "26/02/2026 15:34:10",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 15:34:10"
          },
          {
            "ticket_id": 10519,
            "ticket_number": "3510507",
            "title": "RESERVA WL - ARQUIVO 340788",
            "priority": "P2",
            "created_at": "26/02/2026 16:01:07",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 4.75,
            "sla_met": false,
            "sla_breach_hours": 0.75,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 20:46:18"
          },
          {
            "ticket_id": 10530,
            "ticket_number": "3510518",
            "title": "Confirmação de Reserva * File 432065 - EMISSÃO 27/",
            "priority": "P3",
            "created_at": "26/02/2026 16:28:47",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/02/2026 16:30:16"
          },
          {
            "ticket_id": 10540,
            "ticket_number": "3510528",
            "title": "YLAOLV – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "26/02/2026 18:31:28",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:45:52"
          },
          {
            "ticket_id": 10542,
            "ticket_number": "3510530",
            "title": "Reserva Aérea XAXGZ3",
            "priority": "P2",
            "created_at": "26/02/2026 18:31:35",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:46:21"
          },
          {
            "ticket_id": 10544,
            "ticket_number": "3510532",
            "title": "Reserva Aérea XB4LYF",
            "priority": "P2",
            "created_at": "26/02/2026 18:41:13",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:44:47"
          },
          {
            "ticket_id": 10545,
            "ticket_number": "3510533",
            "title": "Reserva Aérea XB2OK3",
            "priority": "P2",
            "created_at": "26/02/2026 18:41:15",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:44:29"
          },
          {
            "ticket_id": 10546,
            "ticket_number": "3510534",
            "title": "XAXGZ3 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "26/02/2026 18:41:17",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:44:10"
          },
          {
            "ticket_id": 10548,
            "ticket_number": "3510536",
            "title": "XB4LYF – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "26/02/2026 18:53:59",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 22:42:40"
          },
          {
            "ticket_id": 10549,
            "ticket_number": "3510537",
            "title": "XB2OK3 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "26/02/2026 18:54:02",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 22:42:40"
          },
          {
            "ticket_id": 10550,
            "ticket_number": "3510538",
            "title": "THIS IS YOUR EMD RECEIPT",
            "priority": "P2",
            "created_at": "26/02/2026 19:00:20",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 19:01:56"
          },
          {
            "ticket_id": 10553,
            "ticket_number": "3510541",
            "title": "comissoes",
            "priority": "P2",
            "created_at": "26/02/2026 21:06:46",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 21:06:46"
          },
          {
            "ticket_id": 10565,
            "ticket_number": "3510553",
            "title": "Your boarding passes are ready!🎉",
            "priority": "P2",
            "created_at": "26/02/2026 22:35:28",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 11.8,
            "sla_met": false,
            "sla_breach_hours": 7.8,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:24:23"
          },
          {
            "ticket_id": 10566,
            "ticket_number": "3510554",
            "title": "Your booking confirmation CFTT3C -  LIS-BCN 27 Feb",
            "priority": "P2",
            "created_at": "26/02/2026 22:35:31",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 22:35:31"
          },
          {
            "ticket_id": 10567,
            "ticket_number": "3510555",
            "title": "Your boarding passes are ready!🎉",
            "priority": "P2",
            "created_at": "26/02/2026 22:35:35",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 11.82,
            "sla_met": false,
            "sla_breach_hours": 7.82,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:24:43"
          },
          {
            "ticket_id": 10578,
            "ticket_number": "3510566",
            "title": "Fwd: Incidente de voo TTN-1249892858#94250908#T180",
            "priority": "P2",
            "created_at": "26/02/2026 23:49:43",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 23:49:44"
          },
          {
            "ticket_id": 10585,
            "ticket_number": "3510573",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604561368",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:10",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:48:31"
          },
          {
            "ticket_id": 10590,
            "ticket_number": "3510578",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604561368",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:20",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:53:19"
          },
          {
            "ticket_id": 10592,
            "ticket_number": "3510580",
            "title": "XB4LYF – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:24",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:03:36"
          },
          {
            "ticket_id": 10595,
            "ticket_number": "3510583",
            "title": "XB2OK3 – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:32",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:03:36"
          },
          {
            "ticket_id": 10598,
            "ticket_number": "3510586",
            "title": "XAXGZ3 – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:48",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:03:36"
          },
          {
            "ticket_id": 10612,
            "ticket_number": "3510600",
            "title": "Confirmação de Reserva * File 431638 *TIME LIMIT H",
            "priority": "P2",
            "created_at": "27/02/2026 12:24:14",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 12:33:52"
          },
          {
            "ticket_id": 10628,
            "ticket_number": "3510616",
            "title": "Dúvida TravelPlan",
            "priority": "P2",
            "created_at": "27/02/2026 12:55:36",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 12:55:37"
          },
          {
            "ticket_id": 10630,
            "ticket_number": "3510618",
            "title": "Confirmação de Reserva * File 432255 EMISSAO VOOS ",
            "priority": "P2",
            "created_at": "27/02/2026 13:43:45",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:23:50"
          },
          {
            "ticket_id": 10639,
            "ticket_number": "3510627",
            "title": "Fwd: Pedido de Orçamento",
            "priority": "P2",
            "created_at": "27/02/2026 15:02:26",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:02:26"
          },
          {
            "ticket_id": 10650,
            "ticket_number": "3510638",
            "title": "Confirmação de Reserva * File 432225*(Time Limit )",
            "priority": "P2",
            "created_at": "27/02/2026 15:45:34",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:48:06"
          },
          {
            "ticket_id": 10658,
            "ticket_number": "3510646",
            "title": "VERIFICAÇÃO DE NOMES FILE- 340985",
            "priority": "P2",
            "created_at": "27/02/2026 16:30:35",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 19:20:27"
          },
          {
            "ticket_id": 10666,
            "ticket_number": "3510654",
            "title": "[Pedido IATA] MADRID (MAD) → México City (MEX) - 2",
            "priority": "P2",
            "created_at": "27/02/2026 16:46:47",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:46:47"
          },
          {
            "ticket_id": 10667,
            "ticket_number": "3510655",
            "title": "[Pedido de Grupo] Egipto - 2026-04-05 a 2026-04-12",
            "priority": "P2",
            "created_at": "27/02/2026 16:56:04",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:56:05"
          },
          {
            "ticket_id": 10668,
            "ticket_number": "3510656",
            "title": "Grupo: GR-683174E00A",
            "priority": "P2",
            "created_at": "27/02/2026 16:56:37",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:56:41"
          },
          {
            "ticket_id": 10722,
            "ticket_number": "3510710",
            "title": "Cancelamento de reservas pelos operadores SMY e GB",
            "priority": "P2",
            "created_at": "27/02/2026 22:50:55",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 22:50:55"
          },
          {
            "ticket_id": 10731,
            "ticket_number": "3510719",
            "title": "Reserva WL 341105",
            "priority": "P2",
            "created_at": "28/02/2026 00:21:00",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 10.6,
            "sla_met": false,
            "sla_breach_hours": 6.6,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 10:57:39"
          },
          {
            "ticket_id": 10735,
            "ticket_number": "3510723",
            "title": "URGENTE - Cancelamento Viagem",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 10:03:23"
          },
          {
            "ticket_id": 10739,
            "ticket_number": "3510727",
            "title": "XWJWPW – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:31",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 6.4,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:28:01"
          },
          {
            "ticket_id": 10742,
            "ticket_number": "3510730",
            "title": "GBN-102812 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:36",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1563.37,
            "sla_met": false,
            "sla_breach_hours": 1559.37,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:26:11"
          },
          {
            "ticket_id": 10763,
            "ticket_number": "3510751",
            "title": "Fwd: informações sobre a sua reserva TTN-125337317",
            "priority": "P2",
            "created_at": "28/02/2026 13:22:43",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 13:22:43"
          },
          {
            "ticket_id": 10771,
            "ticket_number": "3510759",
            "title": "Y7Y9DE – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "28/02/2026 14:04:09",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:28:09"
          },
          {
            "ticket_id": 10773,
            "ticket_number": "3510761",
            "title": "Reserva Aérea Y7Y9DE",
            "priority": "P2",
            "created_at": "28/02/2026 14:04:12",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:28:59"
          },
          {
            "ticket_id": 10782,
            "ticket_number": "3510770",
            "title": "Aéreo - Confirmação de Emissão (LADEIRAS\\MARINA) -",
            "priority": "P2",
            "created_at": "28/02/2026 15:24:15",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:29:44"
          },
          {
            "ticket_id": 10783,
            "ticket_number": "3510771",
            "title": "Aéreo - Confirmação de Emissão (EVANGELISTA\\JOSE) ",
            "priority": "P2",
            "created_at": "28/02/2026 15:24:17",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:30:12"
          },
          {
            "ticket_id": 10795,
            "ticket_number": "3510783",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (XWJ",
            "priority": "P2",
            "created_at": "28/02/2026 18:20:32",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:29:05"
          },
          {
            "ticket_id": 10797,
            "ticket_number": "3510785",
            "title": "YB4T8X – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "28/02/2026 18:20:36",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:29:29"
          },
          {
            "ticket_id": 10799,
            "ticket_number": "3510787",
            "title": "Reserva Aérea YB4T8X",
            "priority": "P2",
            "created_at": "28/02/2026 18:20:41",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:57:27"
          },
          {
            "ticket_id": 10801,
            "ticket_number": "3510789",
            "title": "Reserva Aérea YBCDGZ",
            "priority": "P2",
            "created_at": "28/02/2026 18:30:43",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:58:03"
          },
          {
            "ticket_id": 10804,
            "ticket_number": "3510792",
            "title": "Aéreo - Confirmação de Emissão (BAPTISTA COELHO AL",
            "priority": "P2",
            "created_at": "28/02/2026 18:43:08",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:58:36"
          },
          {
            "ticket_id": 10805,
            "ticket_number": "3510793",
            "title": "Aéreo - Confirmação de Emissão (ALVES M COELHO ALV",
            "priority": "P2",
            "created_at": "28/02/2026 18:43:10",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:59:06"
          },
          {
            "ticket_id": 10810,
            "ticket_number": "3510798",
            "title": "Número de informação da reserva: 6138424",
            "priority": "P2",
            "created_at": "28/02/2026 19:09:42",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 20:26:04"
          },
          {
            "ticket_id": 10811,
            "ticket_number": "3510799",
            "title": "[Pedido IATA] Lisboa → Atenas - 2026-07-10 (2 pax)",
            "priority": "P2",
            "created_at": "28/02/2026 19:14:39",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 19:14:39"
          },
          {
            "ticket_id": 10862,
            "ticket_number": "3510850",
            "title": "Fwd: easyJet número de referência da reserva: KC6N",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:11",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 34.32,
            "sla_met": false,
            "sla_breach_hours": 30.32,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:25:13"
          },
          {
            "ticket_id": 10882,
            "ticket_number": "3510870",
            "title": "[Pedido IATA] lisboa → Sao Paulo Viracopos - 2026-",
            "priority": "P2",
            "created_at": "01/03/2026 13:38:19",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 13:38:19"
          },
          {
            "ticket_id": 10891,
            "ticket_number": "3510879",
            "title": "[Pedido IATA] lisboa → palmas (PMW) - 2026-07-21 (",
            "priority": "P2",
            "created_at": "01/03/2026 14:17:04",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 14:17:04"
          },
          {
            "ticket_id": 10907,
            "ticket_number": "3510895",
            "title": "GBN-109043_Madeira",
            "priority": "P1",
            "created_at": "01/03/2026 17:22:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/03/2026 17:22:10"
          },
          {
            "ticket_id": 10925,
            "ticket_number": "3510913",
            "title": "[Pedido IATA] Faro → Ponta Delgada - 2026-04-08 (5",
            "priority": "P2",
            "created_at": "01/03/2026 19:40:47",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 19:40:47"
          },
          {
            "ticket_id": 10938,
            "ticket_number": "3510926",
            "title": "Fwd: Ryanair 73441759/Associação de Educação Físic",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:26",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:56:26"
          },
          {
            "ticket_id": 10939,
            "ticket_number": "3510927",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:28",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:56:28"
          },
          {
            "ticket_id": 10940,
            "ticket_number": "3510928",
            "title": "Fwd: Request received for Associação de Educação F",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:30",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:56:30"
          },
          {
            "ticket_id": 10942,
            "ticket_number": "3510930",
            "title": "Fwd: Ryanair 73441717/Associação de Educação Físic",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:56:34"
          },
          {
            "ticket_id": 10965,
            "ticket_number": "3510953",
            "title": "Fwd: Informação importante sobre a documentação da",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:39",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:39"
          },
          {
            "ticket_id": 10970,
            "ticket_number": "3510958",
            "title": "Reserva TUI 10046998",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:56",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:56"
          },
          {
            "ticket_id": 10997,
            "ticket_number": "3510985",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "02/03/2026 11:01:43",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:01:44"
          },
          {
            "ticket_id": 11046,
            "ticket_number": "3511034",
            "title": "Confirmação de Reserva * File 433296 EMISSAO VOOS ",
            "priority": "P2",
            "created_at": "02/03/2026 13:53:11",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:42:44"
          },
          {
            "ticket_id": 11048,
            "ticket_number": "3511036",
            "title": "[Pedido IATA] Lisboa (LIS) → vce - 2026-06-27 (15 ",
            "priority": "P2",
            "created_at": "02/03/2026 14:02:55",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 14:02:55"
          },
          {
            "ticket_id": 11049,
            "ticket_number": "3511037",
            "title": "DQ2S9K – Alteração de Horário – Aceite",
            "priority": "P2",
            "created_at": "02/03/2026 14:17:08",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:02:45"
          },
          {
            "ticket_id": 11051,
            "ticket_number": "3511039",
            "title": "[Pedido IATA] lisboa → Maputo - 2026-10-23 (5 pax)",
            "priority": "P2",
            "created_at": "02/03/2026 14:22:07",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 14:22:08"
          },
          {
            "ticket_id": 11052,
            "ticket_number": "3511040",
            "title": "Ryanair 73441717/Associação de Educação Física e D",
            "priority": "P2",
            "created_at": "02/03/2026 15:34:15",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:34:15"
          },
          {
            "ticket_id": 11059,
            "ticket_number": "3511047",
            "title": "Seguro Insure | Clientes Retidos",
            "priority": "P1",
            "created_at": "02/03/2026 16:01:53",
            "close_date": "2026-04-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 16:01:53"
          },
          {
            "ticket_id": 11067,
            "ticket_number": "3511055",
            "title": "Re:[## 33402 ##] GBN-   108587  - Seu pedido foi r",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:07",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:34:34"
          },
          {
            "ticket_id": 11069,
            "ticket_number": "3511057",
            "title": "Re:[## 33403 ##] GBN-108586 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:12",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:34:49"
          },
          {
            "ticket_id": 11070,
            "ticket_number": "3511058",
            "title": "[Pedido IATA] ORY — Orly → LIS — LISBOA - 2026-08-",
            "priority": "P2",
            "created_at": "02/03/2026 17:18:24",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:18:24"
          },
          {
            "ticket_id": 11078,
            "ticket_number": "3511066",
            "title": "[Pedido IATA] Lis - Lisboa → ORY — Orly - 2026-07-",
            "priority": "P2",
            "created_at": "02/03/2026 17:52:19",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:52:20"
          },
          {
            "ticket_id": 11079,
            "ticket_number": "3511067",
            "title": "GBN-94286 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/03/2026 18:00:35",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:21:28"
          },
          {
            "ticket_id": 11093,
            "ticket_number": "3511081",
            "title": "[Suporte] TRP-2026-00594 / TRL-2026-00971 - Altera",
            "priority": "P2",
            "created_at": "02/03/2026 19:48:00",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:43:35"
          },
          {
            "ticket_id": 11110,
            "ticket_number": "3511098",
            "title": "Confirmação de reserva - Tour 10",
            "priority": "P3",
            "created_at": "02/03/2026 22:23:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 22:23:19"
          },
          {
            "ticket_id": 11113,
            "ticket_number": "3511101",
            "title": "[Pedido IATA] Porto → Luxemburgo - 2026-03-13 (3 p",
            "priority": "P2",
            "created_at": "02/03/2026 22:56:40",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:56:40"
          },
          {
            "ticket_id": 11141,
            "ticket_number": "3511129",
            "title": "Reminder * Reserva File 432870 * Deadline Hoje 15H",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:25",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 10:20:35"
          },
          {
            "ticket_id": 11158,
            "ticket_number": "3511146",
            "title": "RE: Cotação de grupos",
            "priority": "P2",
            "created_at": "03/03/2026 11:51:38",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:46:33"
          },
          {
            "ticket_id": 11173,
            "ticket_number": "3511161",
            "title": "[Pedido IATA] Porto (OPO) → Singapura - 2026-06-06",
            "priority": "P2",
            "created_at": "03/03/2026 12:53:45",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:53:45"
          },
          {
            "ticket_id": 11182,
            "ticket_number": "3511170",
            "title": "[Pedido IATA] Porto → rio de janeiro - 2026-03-23 ",
            "priority": "P2",
            "created_at": "03/03/2026 13:05:34",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:05:34"
          },
          {
            "ticket_id": 11183,
            "ticket_number": "3511171",
            "title": "[Pedido IATA] PORTO  → RIO - 2026-03-23 (2 pax)",
            "priority": "P2",
            "created_at": "03/03/2026 13:09:58",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:09:59"
          },
          {
            "ticket_id": 11189,
            "ticket_number": "3511177",
            "title": "[Pedido IATA] Lisboa(LIS) → Catânia(CTA) - 2026-10",
            "priority": "P2",
            "created_at": "03/03/2026 13:42:13",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:42:13"
          },
          {
            "ticket_id": 11192,
            "ticket_number": "3511180",
            "title": "Cancelamento de voo",
            "priority": "P2",
            "created_at": "03/03/2026 13:46:56",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:46:56"
          },
          {
            "ticket_id": 11196,
            "ticket_number": "3511184",
            "title": "[Pedido IATA] LISBOA → MAPUTO - 2026-12-25 (3 pax)",
            "priority": "P2",
            "created_at": "03/03/2026 14:09:08",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:09:09"
          },
          {
            "ticket_id": 11198,
            "ticket_number": "3511186",
            "title": "[Suporte] TRP-2026-03849 - Apagar esta reserva",
            "priority": "P2",
            "created_at": "03/03/2026 14:13:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:13:16"
          },
          {
            "ticket_id": 11246,
            "ticket_number": "3511234",
            "title": "Assunto: Cancelamento do seu cruzeiro no Msc Eurib",
            "priority": "P2",
            "created_at": "03/03/2026 17:50:35",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 21:40:42"
          },
          {
            "ticket_id": 11252,
            "ticket_number": "3511240",
            "title": "Fwd: easyJet número de referência da reserva: KC7C",
            "priority": "P2",
            "created_at": "03/03/2026 18:26:47",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:26:47"
          },
          {
            "ticket_id": 11268,
            "ticket_number": "3511256",
            "title": "[Pedido IATA] Lisboa → Brasil Florianopolis - 2026",
            "priority": "P2",
            "created_at": "03/03/2026 19:52:04",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 19:52:04"
          },
          {
            "ticket_id": 11284,
            "ticket_number": "3511272",
            "title": "ZVBTFS – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "03/03/2026 22:20:17",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 13.47,
            "sla_met": false,
            "sla_breach_hours": 13.22,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 11:48:23"
          },
          {
            "ticket_id": 11297,
            "ticket_number": "3511285",
            "title": "Devolução GBN-108681",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:45",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:17:45"
          },
          {
            "ticket_id": 11305,
            "ticket_number": "3511293",
            "title": "ZVBTFS – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:05",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:15:37"
          },
          {
            "ticket_id": 11332,
            "ticket_number": "3511320",
            "title": "Aéreo - Confirmação de Emissão (DA COSTA\\FREDERICO",
            "priority": "P2",
            "created_at": "04/03/2026 11:53:53",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:15:49"
          },
          {
            "ticket_id": 11333,
            "ticket_number": "3511321",
            "title": "Reserva Aérea X7NZLG",
            "priority": "P2",
            "created_at": "04/03/2026 11:53:56",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:42:21"
          },
          {
            "ticket_id": 11334,
            "ticket_number": "3511322",
            "title": "Aéreo - Confirmação de Emissão (DA COSTA\\FABIOLA) ",
            "priority": "P2",
            "created_at": "04/03/2026 11:54:00",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:16:43"
          },
          {
            "ticket_id": 11335,
            "ticket_number": "3511323",
            "title": "Aéreo - Confirmação de Emissão (DA COSTA\\FRANCISCA",
            "priority": "P2",
            "created_at": "04/03/2026 11:54:02",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:17:28"
          },
          {
            "ticket_id": 11336,
            "ticket_number": "3511324",
            "title": "Aéreo - Confirmação de Emissão (CARLETTIS\\LUCILIA)",
            "priority": "P2",
            "created_at": "04/03/2026 11:54:05",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:42:21"
          },
          {
            "ticket_id": 11339,
            "ticket_number": "3511327",
            "title": "[Pedido IATA] Porto (OPO) → Newark Liberty Intl (E",
            "priority": "P2",
            "created_at": "04/03/2026 12:04:02",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:04:02"
          },
          {
            "ticket_id": 11342,
            "ticket_number": "3511330",
            "title": "Fwd: Quote reminder 73441759",
            "priority": "P2",
            "created_at": "04/03/2026 12:04:15",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:04:15"
          },
          {
            "ticket_id": 11344,
            "ticket_number": "3511332",
            "title": "X7NZLG – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "04/03/2026 12:04:26",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.55,
            "sla_met": false,
            "sla_breach_hours": 5.3,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 17:38:24"
          },
          {
            "ticket_id": 11348,
            "ticket_number": "3511336",
            "title": "Fwd: Recibo 74470-2026/PTR da reserva CSB6RV",
            "priority": "P2",
            "created_at": "04/03/2026 12:04:59",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:04:59"
          },
          {
            "ticket_id": 11349,
            "ticket_number": "3511337",
            "title": "Quote reminder 73441717",
            "priority": "P2",
            "created_at": "04/03/2026 12:05:01",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:05:01"
          },
          {
            "ticket_id": 11350,
            "ticket_number": "3511338",
            "title": "[Pedido IATA] Porto (OPO) → Newark Liberty Intl (E",
            "priority": "P2",
            "created_at": "04/03/2026 12:06:05",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:06:06"
          },
          {
            "ticket_id": 11371,
            "ticket_number": "3511359",
            "title": "NOVA Confirmação de reserva 340262",
            "priority": "P3",
            "created_at": "04/03/2026 13:20:50",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/02/2026 10:07:56"
          },
          {
            "ticket_id": 11378,
            "ticket_number": "3511366",
            "title": "Reserva Aérea G471G8",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:11",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:21:43"
          },
          {
            "ticket_id": 11391,
            "ticket_number": "3511379",
            "title": "Grupo: GR-B26D566617",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:32",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 29.0,
            "sla_met": false,
            "sla_breach_hours": 25.0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:42:37"
          },
          {
            "ticket_id": 11395,
            "ticket_number": "3511383",
            "title": "Grupo: GR-938EC1E6DF",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:41",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1196.22,
            "sla_met": false,
            "sla_breach_hours": 1192.22,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:56:26"
          },
          {
            "ticket_id": 11400,
            "ticket_number": "3511388",
            "title": "G471G8 – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "04/03/2026 14:42:52",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.65,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 17:22:25"
          },
          {
            "ticket_id": 11402,
            "ticket_number": "3511390",
            "title": "[Pedido IATA] lisboa  → maceio ou recife - 2026-10",
            "priority": "P2",
            "created_at": "04/03/2026 15:29:18",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:29:18"
          },
          {
            "ticket_id": 11413,
            "ticket_number": "3511401",
            "title": "[Pedido IATA] Lisboa → Orly  - 2026-06-08 (4 pax)",
            "priority": "P2",
            "created_at": "04/03/2026 16:35:44",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:35:44"
          },
          {
            "ticket_id": 11416,
            "ticket_number": "3511404",
            "title": "Reserva Aérea XB99IY",
            "priority": "P3",
            "created_at": "04/03/2026 16:59:48",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 6.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 23:23:54"
          },
          {
            "ticket_id": 11417,
            "ticket_number": "3511405",
            "title": "Aéreo - Confirmação de Emissão (BASTOS\\LILIA) - G4",
            "priority": "P3",
            "created_at": "04/03/2026 17:04:43",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 17:31:02"
          },
          {
            "ticket_id": 11418,
            "ticket_number": "3511406",
            "title": "Aéreo - Confirmação de Emissão (BASTOS\\FLAVIO) - G",
            "priority": "P3",
            "created_at": "04/03/2026 17:04:47",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 17:31:48"
          },
          {
            "ticket_id": 11419,
            "ticket_number": "3511407",
            "title": "Aéreo - Confirmação de Emissão (BASTOS\\ANGELA) - G",
            "priority": "P3",
            "created_at": "04/03/2026 17:04:50",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 17:36:33"
          },
          {
            "ticket_id": 11420,
            "ticket_number": "3511408",
            "title": "XB99IY – Novo prazo de emissão",
            "priority": "P3",
            "created_at": "04/03/2026 17:04:53",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 17:38:54"
          },
          {
            "ticket_id": 11421,
            "ticket_number": "3511409",
            "title": "Aéreo - Confirmação de Emissão (BASTOS\\JOANA) - G4",
            "priority": "P3",
            "created_at": "04/03/2026 17:04:56",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 17:33:08"
          },
          {
            "ticket_id": 11422,
            "ticket_number": "3511410",
            "title": "Aéreo - Confirmação de Emissão (BASTOS\\GABRIEL) - ",
            "priority": "P2",
            "created_at": "04/03/2026 17:15:14",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:34:02"
          },
          {
            "ticket_id": 11423,
            "ticket_number": "3511411",
            "title": "Aéreo - Confirmação de Emissão (DE SOUSA BOAVISTA\\",
            "priority": "P2",
            "created_at": "04/03/2026 17:19:18",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:35:46"
          },
          {
            "ticket_id": 11424,
            "ticket_number": "3511412",
            "title": "Aéreo - Confirmação de Emissão (FERNANDES ROSARIO\\",
            "priority": "P2",
            "created_at": "04/03/2026 17:19:21",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:37:19"
          },
          {
            "ticket_id": 11426,
            "ticket_number": "3511414",
            "title": "Aéreo - Confirmação de Emissão (ROSARIO BOAVISTA\\L",
            "priority": "P2",
            "created_at": "04/03/2026 17:25:49",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:38:11"
          },
          {
            "ticket_id": 11464,
            "ticket_number": "3511452",
            "title": "XB99IY – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "04/03/2026 23:06:58",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 13.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 13:00:01"
          },
          {
            "ticket_id": 11469,
            "ticket_number": "3511457",
            "title": "YPE4BP – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:04",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:46:05"
          },
          {
            "ticket_id": 11503,
            "ticket_number": "3511491",
            "title": "REPORTAR SITUAÇÃO Á SOLFÉRIAS SOBRE TRANSFER EM HU",
            "priority": "P2",
            "created_at": "05/03/2026 11:46:10",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 11:46:10"
          },
          {
            "ticket_id": 11507,
            "ticket_number": "3511495",
            "title": "[Suporte] TRP-2026-03251 / TRL-2026-05020 - Dados ",
            "priority": "P2",
            "created_at": "05/03/2026 12:08:25",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:08:25"
          },
          {
            "ticket_id": 11516,
            "ticket_number": "3511504",
            "title": "425327 ** recebemos UN voo paar 03MAR  // proteção",
            "priority": "P2",
            "created_at": "05/03/2026 12:43:55",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 13:53:39"
          },
          {
            "ticket_id": 11520,
            "ticket_number": "3511508",
            "title": "[Pedido IATA] Lisboa → Belgica - 2026-08-03 (3 pax",
            "priority": "P2",
            "created_at": "05/03/2026 13:43:40",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 13:43:41"
          },
          {
            "ticket_id": 11543,
            "ticket_number": "3511531",
            "title": "Cotización Estudiantes  - cntravel -Ref* 17015545 ",
            "priority": "P2",
            "created_at": "05/03/2026 16:36:28",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:02:49"
          },
          {
            "ticket_id": 11546,
            "ticket_number": "3511534",
            "title": "Confirmação de reserva 341653 ### TIME LIMIT EMISS",
            "priority": "P1",
            "created_at": "05/03/2026 16:52:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 811.28,
            "sla_met": false,
            "sla_breach_hours": 811.03,
            "sla_name": "SLA P1",
            "first_response_at": "08/04/2026 12:09:46"
          },
          {
            "ticket_id": 11548,
            "ticket_number": "3511536",
            "title": "Tailândia Incrível - 7004298",
            "priority": "P2",
            "created_at": "05/03/2026 17:54:08",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 17:56:50"
          },
          {
            "ticket_id": 11553,
            "ticket_number": "3511541",
            "title": "[Pedido IATA] porto → ibiza - 2026-04-04 (3 pax)",
            "priority": "P2",
            "created_at": "05/03/2026 18:51:54",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:51:54"
          },
          {
            "ticket_id": 11567,
            "ticket_number": "3511555",
            "title": "[Pedido IATA] porto → MENORCA - 2026-05-13 (2 pax)",
            "priority": "P2",
            "created_at": "05/03/2026 18:57:43",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:57:43"
          },
          {
            "ticket_id": 11574,
            "ticket_number": "3511562",
            "title": "[Pedido IATA] Madrid → Madellin - 2026-05-15 (1 pa",
            "priority": "P2",
            "created_at": "05/03/2026 19:28:59",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:28:59"
          },
          {
            "ticket_id": 11584,
            "ticket_number": "3511572",
            "title": "[Pedido IATA] lisboa → Syros e depois Atenas lisbo",
            "priority": "P3",
            "created_at": "05/03/2026 21:26:15",
            "close_date": "2026-03-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/03/2026 21:26:15"
          },
          {
            "ticket_id": 11585,
            "ticket_number": "3511573",
            "title": "Carrinho - Confirmação de Cancelamento (GR-A0406FF",
            "priority": "P2",
            "created_at": "05/03/2026 21:40:17",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 00:03:52"
          },
          {
            "ticket_id": 11586,
            "ticket_number": "3511574",
            "title": "Grupo: GR-A0406FFFE8",
            "priority": "P2",
            "created_at": "05/03/2026 21:40:18",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 15.7,
            "sla_met": false,
            "sla_breach_hours": 11.7,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:22:26"
          },
          {
            "ticket_id": 11587,
            "ticket_number": "3511575",
            "title": "[Pedido IATA] Lisboa → Belgica - Charleroi - 2026-",
            "priority": "P2",
            "created_at": "05/03/2026 23:02:08",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:02:09"
          },
          {
            "ticket_id": 11597,
            "ticket_number": "3511585",
            "title": "Grupo: GR-E0FDC47A5C",
            "priority": "P2",
            "created_at": "05/03/2026 23:14:01",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:02:42"
          },
          {
            "ticket_id": 11601,
            "ticket_number": "3511589",
            "title": "[Suporte] TRP-2026-03282 - reserva canceladd",
            "priority": "P2",
            "created_at": "06/03/2026 00:28:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 00:28:36"
          },
          {
            "ticket_id": 11604,
            "ticket_number": "3511592",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "06/03/2026 10:08:53",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:08:54"
          },
          {
            "ticket_id": 11607,
            "ticket_number": "3511595",
            "title": "Fwd: Incidência de voo 1240916209 TTN-1240916209#9",
            "priority": "P1",
            "created_at": "06/03/2026 10:09:00",
            "close_date": "2026-03-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 10:09:00"
          },
          {
            "ticket_id": 11619,
            "ticket_number": "3511607",
            "title": "Confirmação de Reserva * File 434053 EMISSAO VOOS ",
            "priority": "P2",
            "created_at": "06/03/2026 10:26:01",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 11:43:42"
          },
          {
            "ticket_id": 11625,
            "ticket_number": "3511613",
            "title": "Fwd: Incidência de voo 1240917792 TTN-1240917792#9",
            "priority": "P2",
            "created_at": "06/03/2026 11:09:09",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 11:09:09"
          },
          {
            "ticket_id": 11628,
            "ticket_number": "3511616",
            "title": "[Pedido IATA] Porto (OPO) → Genebra (GVA) - 2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 12:15:30",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 12:15:30"
          },
          {
            "ticket_id": 11640,
            "ticket_number": "3511628",
            "title": "Fwd: easyJet número de referência da reserva: KC7V",
            "priority": "P2",
            "created_at": "06/03/2026 13:05:26",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:20:59"
          },
          {
            "ticket_id": 11642,
            "ticket_number": "3511630",
            "title": "[Pedido IATA] lisboa → Bali indonesia - 2026-05-28",
            "priority": "P2",
            "created_at": "06/03/2026 13:08:33",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:08:33"
          },
          {
            "ticket_id": 11649,
            "ticket_number": "3511637",
            "title": "[Pedido IATA] Lisboa → Hurghada - 2026-03-14 (1 pa",
            "priority": "P2",
            "created_at": "06/03/2026 13:25:33",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:25:34"
          },
          {
            "ticket_id": 11652,
            "ticket_number": "3511640",
            "title": "[Pedido de Grupo] Porto - Senegal  - 2026-06-01 a ",
            "priority": "P2",
            "created_at": "06/03/2026 13:58:58",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:58:59"
          },
          {
            "ticket_id": 11654,
            "ticket_number": "3511642",
            "title": "Y9ITTF – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "06/03/2026 14:08:38",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 16:17:04"
          },
          {
            "ticket_id": 11655,
            "ticket_number": "3511643",
            "title": "Y9NUQZ – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "06/03/2026 14:08:41",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 16:17:35"
          },
          {
            "ticket_id": 11657,
            "ticket_number": "3511645",
            "title": "Reserva Aérea Y9NUQZ",
            "priority": "P2",
            "created_at": "06/03/2026 14:08:47",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:03:25"
          },
          {
            "ticket_id": 11658,
            "ticket_number": "3511646",
            "title": "Reserva Aérea Y9ITTF",
            "priority": "P2",
            "created_at": "06/03/2026 14:08:50",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:03:25"
          },
          {
            "ticket_id": 11662,
            "ticket_number": "3511650",
            "title": "[Pedido IATA] Porto → Alicante - 2026-08-05 (2 pax",
            "priority": "P2",
            "created_at": "06/03/2026 15:24:30",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:24:30"
          },
          {
            "ticket_id": 11665,
            "ticket_number": "3511653",
            "title": "GBN-74743 e 74744",
            "priority": "P1",
            "created_at": "06/03/2026 15:47:23",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.85,
            "sla_met": false,
            "sla_breach_hours": 2.6,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 18:38:54"
          },
          {
            "ticket_id": 11671,
            "ticket_number": "3511659",
            "title": "Reserva Aérea LA0450775PQYQ",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:38",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:59:10"
          },
          {
            "ticket_id": 11694,
            "ticket_number": "3511682",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "P2",
            "created_at": "06/03/2026 18:36:36",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:36:37"
          },
          {
            "ticket_id": 11696,
            "ticket_number": "3511684",
            "title": "Fwd: easyJet número de referência da reserva: KC7X",
            "priority": "P2",
            "created_at": "06/03/2026 18:42:48",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:42:49"
          },
          {
            "ticket_id": 11697,
            "ticket_number": "3511685",
            "title": "Fwd: easyJet número de referência da reserva: KC7X",
            "priority": "P2",
            "created_at": "06/03/2026 18:42:50",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:42:51"
          },
          {
            "ticket_id": 11698,
            "ticket_number": "3511686",
            "title": "Fwd: easyJet número de referência da reserva: KC7X",
            "priority": "P2",
            "created_at": "06/03/2026 18:42:54",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:42:55"
          },
          {
            "ticket_id": 11699,
            "ticket_number": "3511687",
            "title": "Fwd: easyJet número de referência da reserva: KC7X",
            "priority": "P2",
            "created_at": "06/03/2026 18:42:58",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:42:58"
          },
          {
            "ticket_id": 11700,
            "ticket_number": "3511688",
            "title": "[Pedido de Grupo] Zanzibar - RIU JAMBO TI - 2026-1",
            "priority": "P2",
            "created_at": "06/03/2026 18:59:14",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:59:14"
          },
          {
            "ticket_id": 11707,
            "ticket_number": "3511695",
            "title": "ATT Inês Martinho - Pedido Grupo",
            "priority": "P2",
            "created_at": "06/03/2026 19:02:54",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:02:55"
          },
          {
            "ticket_id": 11732,
            "ticket_number": "3511720",
            "title": "[Cancelamento Viagem] TRP-2026-03286 - RUTE MAIA -",
            "priority": "P2",
            "created_at": "06/03/2026 21:20:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:20:01"
          },
          {
            "ticket_id": 11733,
            "ticket_number": "3511721",
            "title": "[Cancelamento Viagem] TRP-2026-03285 - JORGE MOGO ",
            "priority": "P3",
            "created_at": "06/03/2026 21:21:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 21:21:34"
          },
          {
            "ticket_id": 11752,
            "ticket_number": "3511740",
            "title": "Reserva Aérea Y9ITTF",
            "priority": "P2",
            "created_at": "06/03/2026 23:30:55",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 23:54:43"
          },
          {
            "ticket_id": 11755,
            "ticket_number": "3511743",
            "title": "YGOZWA – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "06/03/2026 23:50:32",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 23.15,
            "sla_met": false,
            "sla_breach_hours": 19.15,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 23:00:13"
          },
          {
            "ticket_id": 11756,
            "ticket_number": "3511744",
            "title": "Reserva Aérea YGOZWA",
            "priority": "P2",
            "created_at": "06/03/2026 23:50:35",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 23.17,
            "sla_met": false,
            "sla_breach_hours": 19.17,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 23:00:36"
          },
          {
            "ticket_id": 11758,
            "ticket_number": "3511746",
            "title": "Reserva Aérea YGOZWA",
            "priority": "P2",
            "created_at": "06/03/2026 23:50:41",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 23.15,
            "sla_met": false,
            "sla_breach_hours": 19.15,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 23:00:01"
          },
          {
            "ticket_id": 11776,
            "ticket_number": "3511764",
            "title": "[Pedido IATA] Lisboa → Ibiza - 2026-07-27 (28 pax)",
            "priority": "P2",
            "created_at": "07/03/2026 11:47:02",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 11:47:02"
          },
          {
            "ticket_id": 11778,
            "ticket_number": "3511766",
            "title": "[Pedido IATA] Lisboa → Tenerife - 2026-07-28 (25 p",
            "priority": "P2",
            "created_at": "07/03/2026 12:02:33",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:02:33"
          },
          {
            "ticket_id": 11823,
            "ticket_number": "3511811",
            "title": "[Pedido IATA] porto → milao - 2026-04-03 (2 pax)",
            "priority": "P2",
            "created_at": "08/03/2026 18:28:19",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 18:28:19"
          },
          {
            "ticket_id": 11824,
            "ticket_number": "3511812",
            "title": "[Pedido IATA] Lisboa → Porto Santo - 2026-06-17 (3",
            "priority": "P2",
            "created_at": "08/03/2026 19:40:39",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 19:40:39"
          },
          {
            "ticket_id": 11826,
            "ticket_number": "3511814",
            "title": "[Pedido IATA] Lisboa → Amesterdão - 2026-05-11 (2 ",
            "priority": "P2",
            "created_at": "08/03/2026 20:33:09",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 20:33:09"
          },
          {
            "ticket_id": 11829,
            "ticket_number": "3511817",
            "title": "[Pedido IATA] Lisboa → Porto Alegre - 2026-04-28 (",
            "priority": "P2",
            "created_at": "09/03/2026 09:33:14",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 09:33:14"
          },
          {
            "ticket_id": 11830,
            "ticket_number": "3511818",
            "title": "[Pedido IATA] Porto Alegre → Lisboa - 2026-04-08 (",
            "priority": "P2",
            "created_at": "09/03/2026 09:35:39",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 09:35:40"
          },
          {
            "ticket_id": 11844,
            "ticket_number": "3511832",
            "title": "Urgente _ Hotel aparece como cancelado",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:44",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:04:44"
          },
          {
            "ticket_id": 11845,
            "ticket_number": "3511833",
            "title": "ZFRV36 – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:46",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:51:51"
          },
          {
            "ticket_id": 11862,
            "ticket_number": "3511850",
            "title": "ZFRV36 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:34",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:26:00"
          },
          {
            "ticket_id": 11863,
            "ticket_number": "3511851",
            "title": "Reserva Aérea ZFRV36",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:37",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:25:50"
          },
          {
            "ticket_id": 11865,
            "ticket_number": "3511853",
            "title": "G5JJCQ – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:41",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:47:35"
          },
          {
            "ticket_id": 11867,
            "ticket_number": "3511855",
            "title": "Reserva Aérea G5JJCQ",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:46",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:25:37"
          },
          {
            "ticket_id": 11874,
            "ticket_number": "3511862",
            "title": "Re:[## 30231 ##] GBN-99759 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "09/03/2026 10:06:57",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11888,
            "ticket_number": "3511876",
            "title": "RECLAMAÇÃO - GBN - 94228",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:45",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:07:45"
          },
          {
            "ticket_id": 11908,
            "ticket_number": "3511896",
            "title": "[Pedido IATA] PORTO → ESTUGARDA - REGREASSO POR BE",
            "priority": "P2",
            "created_at": "09/03/2026 10:59:12",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:59:12"
          },
          {
            "ticket_id": 11910,
            "ticket_number": "3511898",
            "title": "Plano de Pagamento Vencido",
            "priority": "P2",
            "created_at": "09/03/2026 11:32:13",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:33:56"
          },
          {
            "ticket_id": 11913,
            "ticket_number": "3511901",
            "title": "ALTERAÇÃO DE HORÁRIO DO VOO DE IDA 27APR 6117515 W",
            "priority": "P2",
            "created_at": "09/03/2026 11:57:20",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 12:10:47"
          },
          {
            "ticket_id": 11938,
            "ticket_number": "3511926",
            "title": "[Pedido IATA] Lisboa → Marraquexe - 2026-03-23 (5 ",
            "priority": "P2",
            "created_at": "09/03/2026 13:03:27",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:03:28"
          },
          {
            "ticket_id": 11940,
            "ticket_number": "3511928",
            "title": "Proforma CnTravel 17015545",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:00",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 17:44:23"
          },
          {
            "ticket_id": 11942,
            "ticket_number": "3511930",
            "title": "Aéreo - Confirmação de Emissão (RODRIGUES LABRECA\\",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:10",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:41:49"
          },
          {
            "ticket_id": 11944,
            "ticket_number": "3511932",
            "title": "Aéreo - Confirmação de Emissão (FREITAS RATO\\CAROL",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:15",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 17:25:13"
          },
          {
            "ticket_id": 11949,
            "ticket_number": "3511937",
            "title": "Reserva GBN-109138 - Alteração valores",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:26",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:54:27"
          },
          {
            "ticket_id": 11951,
            "ticket_number": "3511939",
            "title": "Fwd: Incidente de voo TTN-1223362854#95397200#T183",
            "priority": "P2",
            "created_at": "09/03/2026 13:55:02",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:55:04"
          },
          {
            "ticket_id": 11957,
            "ticket_number": "3511945",
            "title": "[Suporte] TRP-2026-03559 / TRL-2026-05415 - nome p",
            "priority": "P2",
            "created_at": "09/03/2026 15:23:15",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 15:23:15"
          },
          {
            "ticket_id": 11963,
            "ticket_number": "3511951",
            "title": "1240917792 TTN-1240917792#93902059#T17916688¬10698",
            "priority": "P2",
            "created_at": "09/03/2026 15:36:55",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:26:17"
          },
          {
            "ticket_id": 11965,
            "ticket_number": "3511953",
            "title": "1240916209 TTN-1240916209#93898832#T17915939¬10697",
            "priority": "P2",
            "created_at": "09/03/2026 15:37:06",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:27:03"
          },
          {
            "ticket_id": 11968,
            "ticket_number": "3511956",
            "title": "[Pedido IATA] Lisboa (LIS) → Palmas (PMW) - 2026-0",
            "priority": "P2",
            "created_at": "09/03/2026 15:39:25",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 15:39:25"
          },
          {
            "ticket_id": 11969,
            "ticket_number": "3511957",
            "title": "[Pedido IATA] Lisboa (LIS) → Palmas (PMW) - 2026-0",
            "priority": "P2",
            "created_at": "09/03/2026 15:41:10",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 15:41:10"
          },
          {
            "ticket_id": 11977,
            "ticket_number": "3511965",
            "title": "RE: Cotação saida de Zurick",
            "priority": "P2",
            "created_at": "09/03/2026 16:41:49",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:29:18"
          },
          {
            "ticket_id": 11978,
            "ticket_number": "3511966",
            "title": "Confirmação de Reserva * File 434428 EMISSAO VOOS ",
            "priority": "P1",
            "created_at": "09/03/2026 16:41:56",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.03,
            "sla_met": false,
            "sla_breach_hours": 1.78,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 18:44:01"
          },
          {
            "ticket_id": 11980,
            "ticket_number": "3511968",
            "title": "[Pedido IATA] Lisboa  → Djerba - 2026-04-27 (2 pax",
            "priority": "P2",
            "created_at": "09/03/2026 18:13:06",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:13:06"
          },
          {
            "ticket_id": 12000,
            "ticket_number": "3511988",
            "title": "Cancelamento viagem Cuba - SEM RESPOSTA",
            "priority": "P2",
            "created_at": "09/03/2026 20:26:07",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 20:26:08"
          },
          {
            "ticket_id": 12003,
            "ticket_number": "3511991",
            "title": "YPE4BP – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "09/03/2026 20:26:15",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 22:09:22"
          },
          {
            "ticket_id": 12008,
            "ticket_number": "3511996",
            "title": "[Pedido de Grupo] Barcelona / Ibis Barcelona Santa",
            "priority": "P2",
            "created_at": "09/03/2026 22:17:40",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 22:17:40"
          },
          {
            "ticket_id": 12009,
            "ticket_number": "3511997",
            "title": "[Pedido IATA] Porto → Barcelona - 2026-07-06 (21 p",
            "priority": "P2",
            "created_at": "09/03/2026 22:27:04",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 22:27:04"
          },
          {
            "ticket_id": 12025,
            "ticket_number": "3512013",
            "title": "Inserção de reservas no cockpit",
            "priority": "P2",
            "created_at": "10/03/2026 10:08:04",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:08:04"
          },
          {
            "ticket_id": 12037,
            "ticket_number": "3512025",
            "title": "Aéreo - Confirmação de Emissão (ALBERTO MOREIRA\\JO",
            "priority": "P2",
            "created_at": "10/03/2026 10:21:22",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:31:17"
          },
          {
            "ticket_id": 12038,
            "ticket_number": "3512026",
            "title": "Aéreo - Confirmação de Emissão (HENRIQUES COSTA\\MA",
            "priority": "P2",
            "created_at": "10/03/2026 10:21:50",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:31:27"
          },
          {
            "ticket_id": 12041,
            "ticket_number": "3512029",
            "title": "Aéreo - Confirmação de Emissão (HENRIQUES COSTA\\MA",
            "priority": "P2",
            "created_at": "10/03/2026 10:23:54",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:29:36"
          },
          {
            "ticket_id": 12042,
            "ticket_number": "3512030",
            "title": "Aéreo - Confirmação de Emissão (ALBERTO MOREIRA\\JO",
            "priority": "P2",
            "created_at": "10/03/2026 10:23:57",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:30:44"
          },
          {
            "ticket_id": 12048,
            "ticket_number": "3512036",
            "title": "Pedido de esclarecimento – Cancelamento de apólice",
            "priority": "P2",
            "created_at": "10/03/2026 11:53:39",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 11:53:39"
          },
          {
            "ticket_id": 12055,
            "ticket_number": "3512043",
            "title": "[Pedido IATA] Lis - Lisboa → ORY — Orly - 2026-08-",
            "priority": "P2",
            "created_at": "10/03/2026 12:31:25",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 12:31:25"
          },
          {
            "ticket_id": 12061,
            "ticket_number": "3512049",
            "title": "[Pedido IATA] Lisboa → Boston - 2026-10-23 (2 pax)",
            "priority": "P2",
            "created_at": "10/03/2026 14:12:44",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 14:12:44"
          },
          {
            "ticket_id": 12093,
            "ticket_number": "3512081",
            "title": "Fwd: Contactos Turkish Airlines - Portugal | Uma F",
            "priority": "P2",
            "created_at": "10/03/2026 17:16:53",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:16:54"
          },
          {
            "ticket_id": 12152,
            "ticket_number": "3512140",
            "title": "Fwd: Ryanair 73824523/Daniela Rosa /Daniela Rosa",
            "priority": "P2",
            "created_at": "11/03/2026 10:09:31",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:09:32"
          },
          {
            "ticket_id": 12155,
            "ticket_number": "3512143",
            "title": "Fwd: Wizz Air electronic invoice DWAM-45974141 / D",
            "priority": "P2",
            "created_at": "11/03/2026 10:10:57",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:10:58"
          },
          {
            "ticket_id": 12157,
            "ticket_number": "3512145",
            "title": "Fwd: Request received for Daniela Rosa",
            "priority": "P2",
            "created_at": "11/03/2026 10:12:54",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:12:54"
          },
          {
            "ticket_id": 12171,
            "ticket_number": "3512159",
            "title": "[Pedido IATA] Lisboa → Manchester - 2026-04-03 (4 ",
            "priority": "P2",
            "created_at": "11/03/2026 11:53:52",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 11:53:53"
          },
          {
            "ticket_id": 12176,
            "ticket_number": "3512164",
            "title": "Fwd: Informações sobre a sua reserva TTN-124464376",
            "priority": "P2",
            "created_at": "11/03/2026 12:40:24",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 12:48:17"
          },
          {
            "ticket_id": 12232,
            "ticket_number": "3512220",
            "title": "cancelamento de voo GBN-107954",
            "priority": "P2",
            "created_at": "11/03/2026 17:23:27",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:40:16"
          },
          {
            "ticket_id": 12234,
            "ticket_number": "3512222",
            "title": "1240917792 TTN-1240917792#93902059#T17916688¬10698",
            "priority": "P2",
            "created_at": "11/03/2026 17:25:33",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:21:23"
          },
          {
            "ticket_id": 12271,
            "ticket_number": "3512259",
            "title": "[Pedido IATA] Lisboa (LIS) → Funchal (FNC) - 2026-",
            "priority": "P2",
            "created_at": "11/03/2026 19:37:09",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 19:37:10"
          },
          {
            "ticket_id": 12312,
            "ticket_number": "3512300",
            "title": "Fwd: easyJet número de referência da reserva: KBJS",
            "priority": "P2",
            "created_at": "11/03/2026 23:36:21",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:36:22"
          },
          {
            "ticket_id": 12313,
            "ticket_number": "3512301",
            "title": "Fwd: easyJet número de referência da reserva: KBJS",
            "priority": "P2",
            "created_at": "11/03/2026 23:36:24",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:36:25"
          },
          {
            "ticket_id": 12314,
            "ticket_number": "3512302",
            "title": "Fwd: easyJet número de referência da reserva: KBJS",
            "priority": "P2",
            "created_at": "11/03/2026 23:36:27",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:36:27"
          },
          {
            "ticket_id": 12315,
            "ticket_number": "3512303",
            "title": "Pedido reserva excursão MSC  com loc 70796907 - ur",
            "priority": "P2",
            "created_at": "11/03/2026 23:36:29",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:36:30"
          },
          {
            "ticket_id": 12316,
            "ticket_number": "3512304",
            "title": "Fwd: easyJet número de referência da reserva: KBJS",
            "priority": "P2",
            "created_at": "11/03/2026 23:36:32",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:36:33"
          },
          {
            "ticket_id": 12322,
            "ticket_number": "3512310",
            "title": "CORRIGIR NOME PASSAGEIRA, MARIA FATIMA NEVES - LOC",
            "priority": "P1",
            "created_at": "11/03/2026 23:55:33",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 23:55:33"
          },
          {
            "ticket_id": 12359,
            "ticket_number": "3512347",
            "title": "GBN-99937 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/03/2026 13:38:11",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 17:23:24"
          },
          {
            "ticket_id": 12377,
            "ticket_number": "3512365",
            "title": "Fwd: Ryanair 73874423/Daniela Rosa /Daniela Rosa",
            "priority": "P2",
            "created_at": "12/03/2026 15:49:34",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:49:34"
          },
          {
            "ticket_id": 12384,
            "ticket_number": "3512372",
            "title": "[Pedido de Grupo] Sernancelhe - 2026-06-19 a 2026-",
            "priority": "P2",
            "created_at": "12/03/2026 17:20:30",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 17:20:30"
          },
          {
            "ticket_id": 12385,
            "ticket_number": "3512373",
            "title": "[Pedido IATA] Faro → Porto - 2026-06-19 (30 pax)",
            "priority": "P2",
            "created_at": "12/03/2026 17:25:32",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 17:25:32"
          },
          {
            "ticket_id": 12391,
            "ticket_number": "3512379",
            "title": "atulizaçao de informçao das minhas viagems no cokp",
            "priority": "P2",
            "created_at": "12/03/2026 17:42:07",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 17:42:07"
          },
          {
            "ticket_id": 12392,
            "ticket_number": "3512380",
            "title": "Urgente – vouchers cliente São Tomé (partida 21/03",
            "priority": "P2",
            "created_at": "12/03/2026 18:15:30",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 18:35:07"
          },
          {
            "ticket_id": 12393,
            "ticket_number": "3512381",
            "title": "Fwd: Informações da reserva TTN-1211528598#9588489",
            "priority": "P2",
            "created_at": "12/03/2026 18:15:32",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 18:15:33"
          },
          {
            "ticket_id": 12401,
            "ticket_number": "3512389",
            "title": "Informação Reserva 213426",
            "priority": "P2",
            "created_at": "12/03/2026 18:33:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 18:42:42"
          },
          {
            "ticket_id": 12403,
            "ticket_number": "3512391",
            "title": "Euribia | Valores em Crédito",
            "priority": "P2",
            "created_at": "12/03/2026 18:51:44",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12429,
            "ticket_number": "3512417",
            "title": "Re: Reserva Aérea FR12VZ (#2759434)",
            "priority": "P2",
            "created_at": "12/03/2026 20:31:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 16.3,
            "sla_met": false,
            "sla_breach_hours": 12.3,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 12:50:20"
          },
          {
            "ticket_id": 12462,
            "ticket_number": "3512450",
            "title": "Devolução de Reserva",
            "priority": "P1",
            "created_at": "13/03/2026 10:06:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 10:06:19"
          },
          {
            "ticket_id": 12475,
            "ticket_number": "3512463",
            "title": "Confirmação de Reserva 213426",
            "priority": "P2",
            "created_at": "13/03/2026 11:12:45",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 12:30:59"
          },
          {
            "ticket_id": 12476,
            "ticket_number": "3512464",
            "title": "Reserva Aéreo [ERROR_AIR-8EB9BB94D6] - Erro Técnic",
            "priority": "P2",
            "created_at": "13/03/2026 11:22:15",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 12:02:47"
          },
          {
            "ticket_id": 12477,
            "ticket_number": "3512465",
            "title": "Fwd: Informações da reserva TTN-1258724070#9590994",
            "priority": "P2",
            "created_at": "13/03/2026 11:34:59",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 11:35:00"
          },
          {
            "ticket_id": 12494,
            "ticket_number": "3512482",
            "title": "X7NZLG – Alteração de horario/nº de voo",
            "priority": "P2",
            "created_at": "13/03/2026 15:18:25",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:13:45"
          },
          {
            "ticket_id": 12495,
            "ticket_number": "3512483",
            "title": "X7NZLG – Alteração de horario/nº de voo",
            "priority": "P2",
            "created_at": "13/03/2026 15:18:27",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:13:55"
          },
          {
            "ticket_id": 12501,
            "ticket_number": "3512489",
            "title": "GBN-109804 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/03/2026 16:15:36",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 742.6,
            "sla_met": false,
            "sla_breach_hours": 738.6,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 14:52:00"
          },
          {
            "ticket_id": 12526,
            "ticket_number": "3512514",
            "title": "[Cancelamento Serviço] TRP-2026-03825 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/03/2026 17:49:14",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 17:49:14"
          },
          {
            "ticket_id": 12532,
            "ticket_number": "3512520",
            "title": "GBN - 112218 - pedido de alteração de voo",
            "priority": "P2",
            "created_at": "13/03/2026 19:22:22",
            "close_date": "2026-03-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 19:22:22"
          },
          {
            "ticket_id": 12537,
            "ticket_number": "3512525",
            "title": "Fwd: Ryanair 73929623/Isadora Resende /Isadora Res",
            "priority": "P2",
            "created_at": "13/03/2026 19:24:58",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 19:24:58"
          },
          {
            "ticket_id": 12566,
            "ticket_number": "3512554",
            "title": "Substituição de hotel:   GBN-112233",
            "priority": "P2",
            "created_at": "13/03/2026 23:57:07",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 21:12:09"
          },
          {
            "ticket_id": 12568,
            "ticket_number": "3512556",
            "title": "[Pedido IATA] porto → milão - 2026-08-22 (9 pax)",
            "priority": "P2",
            "created_at": "14/03/2026 00:07:40",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 00:07:40"
          },
          {
            "ticket_id": 12569,
            "ticket_number": "3512557",
            "title": "[Pedido IATA] milao → tirana  - 2026-08-22 (9 pax)",
            "priority": "P2",
            "created_at": "14/03/2026 00:10:36",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 00:10:36"
          },
          {
            "ticket_id": 12570,
            "ticket_number": "3512558",
            "title": "[Pedido IATA] porto → rio de janeiro - 2026-12-15 ",
            "priority": "P2",
            "created_at": "14/03/2026 00:18:47",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 00:18:47"
          },
          {
            "ticket_id": 12595,
            "ticket_number": "3512583",
            "title": "[Pedido IATA] Dusseldorf → Lisboa - 2026-03-25 (1 ",
            "priority": "P2",
            "created_at": "14/03/2026 14:14:55",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 14:14:55"
          },
          {
            "ticket_id": 12596,
            "ticket_number": "3512584",
            "title": "[Pedido IATA] Colónia → Lisboa - 2026-03-25 (1 pax",
            "priority": "P2",
            "created_at": "14/03/2026 14:29:17",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 14:29:17"
          },
          {
            "ticket_id": 12617,
            "ticket_number": "3512605",
            "title": "[Cancelamento Viagem] TRP-2026-04306 - Hélder Giro",
            "priority": "P2",
            "created_at": "15/03/2026 11:15:50",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 11:15:50"
          },
          {
            "ticket_id": 12618,
            "ticket_number": "3512606",
            "title": "[Pedido IATA] Lisboa → Funchal - 2026-12-28 (5 pax",
            "priority": "P2",
            "created_at": "15/03/2026 13:13:31",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 13:13:31"
          },
          {
            "ticket_id": 12619,
            "ticket_number": "3512607",
            "title": "[Pedido IATA] Porto → Madrid - 2026-10-19 (17 pax)",
            "priority": "P2",
            "created_at": "15/03/2026 19:41:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 19:41:09"
          },
          {
            "ticket_id": 12620,
            "ticket_number": "3512608",
            "title": "[Pedido IATA] MADRID (MAD) → México City (MEX) - 2",
            "priority": "P2",
            "created_at": "15/03/2026 19:42:21",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 19:42:21"
          },
          {
            "ticket_id": 12640,
            "ticket_number": "3512628",
            "title": "Fwd: Booking Reference KBHZN4T : Uma atualização s",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:04",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:04"
          },
          {
            "ticket_id": 12641,
            "ticket_number": "3512629",
            "title": "Fwd: Update: Flight Schedule Adjustments",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:06",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:06"
          },
          {
            "ticket_id": 12657,
            "ticket_number": "3512645",
            "title": "Número de informação da reserva: 6142187",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:56",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12664,
            "ticket_number": "3512652",
            "title": "Grupo: GR-280A5ADE87",
            "priority": "P2",
            "created_at": "16/03/2026 10:08:27",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 13:15:56"
          },
          {
            "ticket_id": 12678,
            "ticket_number": "3512666",
            "title": "Contatos de Cliente em falta - n/File 432870",
            "priority": "P2",
            "created_at": "16/03/2026 10:09:40",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12704,
            "ticket_number": "3512692",
            "title": "URGENTE Confirmação de reserva 342637 ### TIME LIM",
            "priority": "P2",
            "created_at": "16/03/2026 12:33:15",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 12:35:03"
          },
          {
            "ticket_id": 12707,
            "ticket_number": "3512695",
            "title": "Pagamento Final de Reserva - 339794",
            "priority": "P1",
            "created_at": "16/03/2026 13:05:36",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 172.52,
            "sla_met": false,
            "sla_breach_hours": 172.27,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 17:36:40"
          },
          {
            "ticket_id": 12712,
            "ticket_number": "3512700",
            "title": "Re: Reserva TUI (10047189) - UMA FAMILIA EM VIAGEM",
            "priority": "P2",
            "created_at": "16/03/2026 13:05:54",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:26:43"
          },
          {
            "ticket_id": 12714,
            "ticket_number": "3512702",
            "title": "GBN-81725 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 13:06:01",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:00:07"
          },
          {
            "ticket_id": 12716,
            "ticket_number": "3512704",
            "title": "Reserva Aérea XACBMH",
            "priority": "P2",
            "created_at": "16/03/2026 13:06:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:00:07"
          },
          {
            "ticket_id": 12726,
            "ticket_number": "3512714",
            "title": "Número de informação da reserva: 6140620",
            "priority": "P2",
            "created_at": "16/03/2026 13:23:00",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 13:53:30"
          },
          {
            "ticket_id": 12728,
            "ticket_number": "3512716",
            "title": "GBN-112233 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 13:34:10",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:20:13"
          },
          {
            "ticket_id": 12733,
            "ticket_number": "3512721",
            "title": "Reserva em WL 213624",
            "priority": "P2",
            "created_at": "16/03/2026 14:07:07",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 18:00:18"
          },
          {
            "ticket_id": 12748,
            "ticket_number": "3512736",
            "title": "[Suporte] TRP-2026-04304 / TRL-2026-06513 - Correç",
            "priority": "P2",
            "created_at": "16/03/2026 15:32:12",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 15:32:13"
          },
          {
            "ticket_id": 12750,
            "ticket_number": "3512738",
            "title": "Fwd: Reclamação Formal – Reserva [415384/25] – Mel",
            "priority": "P2",
            "created_at": "16/03/2026 15:37:16",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 15:37:17"
          },
          {
            "ticket_id": 12754,
            "ticket_number": "3512742",
            "title": "[Cancelamento Viagem] TRP-2026-04088 - SUSANA JANA",
            "priority": "P2",
            "created_at": "16/03/2026 16:04:35",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 17:12:07"
          },
          {
            "ticket_id": 12776,
            "ticket_number": "3512764",
            "title": "Reserva Aérea XACBMH",
            "priority": "P2",
            "created_at": "16/03/2026 18:50:14",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:43:01"
          },
          {
            "ticket_id": 12784,
            "ticket_number": "3512772",
            "title": "[Pedido IATA] Senegal - Dakar (Aeroporto Internaci",
            "priority": "P2",
            "created_at": "16/03/2026 19:43:58",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:43:58"
          },
          {
            "ticket_id": 12794,
            "ticket_number": "3512782",
            "title": "[Pedido IATA] Porto → Madrid - 2026-10-19 (17 pax)",
            "priority": "P2",
            "created_at": "16/03/2026 20:12:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 20:12:12"
          },
          {
            "ticket_id": 12837,
            "ticket_number": "3512825",
            "title": "Cierre Grupo Barcelona Localizador 17015545",
            "priority": "P2",
            "created_at": "17/03/2026 10:13:16",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:45:12"
          },
          {
            "ticket_id": 12838,
            "ticket_number": "3512826",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "17/03/2026 10:15:10",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 11:40:15"
          },
          {
            "ticket_id": 12839,
            "ticket_number": "3512827",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "17/03/2026 10:15:13",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 11:40:24"
          },
          {
            "ticket_id": 12840,
            "ticket_number": "3512828",
            "title": "Aéreo - Confirmação de Emissão (CAMPOS\\SANDRA) - X",
            "priority": "P2",
            "created_at": "17/03/2026 10:15:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 11:38:26"
          },
          {
            "ticket_id": 12841,
            "ticket_number": "3512829",
            "title": "Aéreo - Confirmação de Emissão (SANTOS\\PEDRO) - XA",
            "priority": "P2",
            "created_at": "17/03/2026 10:15:18",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 11:39:00"
          },
          {
            "ticket_id": 12842,
            "ticket_number": "3512830",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "17/03/2026 10:25:10",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:25:10"
          },
          {
            "ticket_id": 12844,
            "ticket_number": "3512832",
            "title": "FW: Documentação da reserva TTN-1258148060#9558853",
            "priority": "P2",
            "created_at": "17/03/2026 10:50:19",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:50:20"
          },
          {
            "ticket_id": 12866,
            "ticket_number": "3512854",
            "title": "URGENTE: PEDIDO IATA viagem Porto / Tirana e Tiran",
            "priority": "P2",
            "created_at": "17/03/2026 13:27:24",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 13:27:24"
          },
          {
            "ticket_id": 12875,
            "ticket_number": "3512863",
            "title": "[Pedido IATA] Lis - Lisboa → AGA Agadir - 2026-05-",
            "priority": "P2",
            "created_at": "17/03/2026 15:32:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 15:32:05"
          },
          {
            "ticket_id": 12876,
            "ticket_number": "3512864",
            "title": "PEDIDO reforço reservas newblue - 6142188 e 614218",
            "priority": "P2",
            "created_at": "17/03/2026 16:13:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 16:13:46"
          },
          {
            "ticket_id": 12877,
            "ticket_number": "3512865",
            "title": "RESERVAS DUPLICADAS 6142188 Y 6142187 W2MCS:011810",
            "priority": "P2",
            "created_at": "17/03/2026 16:13:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:18:42"
          },
          {
            "ticket_id": 12878,
            "ticket_number": "3512866",
            "title": "RESERVA VIAJAR TOURS 213397",
            "priority": "P2",
            "created_at": "17/03/2026 16:13:49",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 16:03:38"
          },
          {
            "ticket_id": 12894,
            "ticket_number": "3512882",
            "title": "[Pedido IATA] Porto → Palma Maiorca PMI - 2026-06-",
            "priority": "P2",
            "created_at": "17/03/2026 17:41:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 17:41:42"
          },
          {
            "ticket_id": 12909,
            "ticket_number": "3512897",
            "title": "[Pedido IATA] pORTO → Londres Gatwick - 2026-05-01",
            "priority": "P2",
            "created_at": "17/03/2026 18:27:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:27:35"
          },
          {
            "ticket_id": 12912,
            "ticket_number": "3512900",
            "title": "Reserva Aérea XWDB2B",
            "priority": "P1",
            "created_at": "17/03/2026 18:28:52",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/03/2026 18:42:24"
          },
          {
            "ticket_id": 12915,
            "ticket_number": "3512903",
            "title": "XWDB2B – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "17/03/2026 18:36:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/03/2026 18:43:23"
          },
          {
            "ticket_id": 12922,
            "ticket_number": "3512910",
            "title": "Acesso à reserva Ryanair",
            "priority": "P2",
            "created_at": "17/03/2026 22:04:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:00:27"
          },
          {
            "ticket_id": 12926,
            "ticket_number": "3512914",
            "title": "[Suporte] TRP-2026-03094 - Pagamento",
            "priority": "P2",
            "created_at": "17/03/2026 22:42:52",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 22:42:53"
          },
          {
            "ticket_id": 12933,
            "ticket_number": "3512921",
            "title": "Reserva Aéreo [ERROR_AIR-D83928DD70] - Erro Técnic",
            "priority": "P2",
            "created_at": "18/03/2026 09:21:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.88,
            "sla_met": false,
            "sla_breach_hours": 0.88,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 14:14:19"
          },
          {
            "ticket_id": 12953,
            "ticket_number": "3512941",
            "title": "Aéreo - Confirmação de Emissão (ROCHA\\MARIA) - XWD",
            "priority": "P2",
            "created_at": "18/03/2026 10:11:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:32:28"
          },
          {
            "ticket_id": 12954,
            "ticket_number": "3512942",
            "title": "Aéreo - Confirmação de Emissão (GONCALVES\\MARIA) -",
            "priority": "P2",
            "created_at": "18/03/2026 10:11:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:32:51"
          },
          {
            "ticket_id": 12955,
            "ticket_number": "3512943",
            "title": "Aéreo - Confirmação de Emissão (ROCHA\\PAULO) - XWD",
            "priority": "P2",
            "created_at": "18/03/2026 10:11:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:33:42"
          },
          {
            "ticket_id": 12960,
            "ticket_number": "3512948",
            "title": "Aéreo - Confirmação de Emissão (ROCHA\\DIANA) - XWD",
            "priority": "P2",
            "created_at": "18/03/2026 10:11:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:34:07"
          },
          {
            "ticket_id": 12975,
            "ticket_number": "3512963",
            "title": "[Pedido IATA] Porto  → Buenos Aires - 2026-04-10 (",
            "priority": "P2",
            "created_at": "18/03/2026 10:57:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:57:06"
          },
          {
            "ticket_id": 12977,
            "ticket_number": "3512965",
            "title": "Eticket - 70796907 - EU  20/03/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "18/03/2026 11:24:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 15:20:49"
          },
          {
            "ticket_id": 12978,
            "ticket_number": "3512966",
            "title": "Grupo: GR-BB131C5C0C",
            "priority": "P2",
            "created_at": "18/03/2026 11:25:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:42:04"
          },
          {
            "ticket_id": 12980,
            "ticket_number": "3512968",
            "title": "[Pedido IATA] PORTO → palermo - 2026-07-25 (2 pax)",
            "priority": "P2",
            "created_at": "18/03/2026 11:42:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 11:42:47"
          },
          {
            "ticket_id": 12986,
            "ticket_number": "3512974",
            "title": "[Pedido IATA] Porto (OPO) → Miami (MIA) - 2026-05-",
            "priority": "P2",
            "created_at": "18/03/2026 12:34:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:34:36"
          },
          {
            "ticket_id": 12988,
            "ticket_number": "3512976",
            "title": "Viagem cancelada - COCKPIT",
            "priority": "P2",
            "created_at": "18/03/2026 13:04:40",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:04:40"
          },
          {
            "ticket_id": 12994,
            "ticket_number": "3512982",
            "title": "[Pedido IATA] MADRID (MAD) → México City (MEX) - 2",
            "priority": "P2",
            "created_at": "18/03/2026 14:05:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 14:05:54"
          },
          {
            "ticket_id": 13011,
            "ticket_number": "3512999",
            "title": "RE: a/ c Claudia - reserva Erro W2MCS:015030002938",
            "priority": "P2",
            "created_at": "18/03/2026 15:40:58",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 842.33,
            "sla_met": false,
            "sla_breach_hours": 838.33,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:01:19"
          },
          {
            "ticket_id": 13015,
            "ticket_number": "3513003",
            "title": "RV: Reserva não feita e paga - 030748",
            "priority": "P2",
            "created_at": "18/03/2026 16:37:48",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 16:41:08"
          },
          {
            "ticket_id": 13017,
            "ticket_number": "3513005",
            "title": "Re: Fwd: Reserva Aéreo [ERROR_AIR-9303056A44] - Er",
            "priority": "P2",
            "created_at": "18/03/2026 17:04:53",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 17:12:25"
          },
          {
            "ticket_id": 13018,
            "ticket_number": "3513006",
            "title": "Fwd: Incidente de voo TTN-1240917792#93902059#T179",
            "priority": "P2",
            "created_at": "18/03/2026 17:04:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 17:04:57"
          },
          {
            "ticket_id": 13019,
            "ticket_number": "3513007",
            "title": "Fwd: Incidente de voo TTN-1240916209#93898832#T179",
            "priority": "P2",
            "created_at": "18/03/2026 17:05:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 17:05:01"
          },
          {
            "ticket_id": 13023,
            "ticket_number": "3513011",
            "title": "[Cancelamento Viagem] TRP-2026-04088 - SUSANA JANA",
            "priority": "P2",
            "created_at": "18/03/2026 18:44:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:44:02"
          },
          {
            "ticket_id": 13055,
            "ticket_number": "3513043",
            "title": "YGTDFM – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "18/03/2026 20:49:08",
            "close_date": "2026-03-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 21:01:37"
          },
          {
            "ticket_id": 13058,
            "ticket_number": "3513046",
            "title": "YGTDFM – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "18/03/2026 21:22:41",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.22,
            "sla_met": false,
            "sla_breach_hours": 1.97,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 23:36:34"
          },
          {
            "ticket_id": 13070,
            "ticket_number": "3513058",
            "title": "Grupo: GR-2295D0A708",
            "priority": "P2",
            "created_at": "18/03/2026 22:56:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 18.18,
            "sla_met": false,
            "sla_breach_hours": 14.18,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:07:44"
          },
          {
            "ticket_id": 13071,
            "ticket_number": "3513059",
            "title": "Grupo: GR-C886D89DB9",
            "priority": "P2",
            "created_at": "18/03/2026 22:56:33",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 13.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:51:10"
          },
          {
            "ticket_id": 13072,
            "ticket_number": "3513060",
            "title": "Grupo GR-C886D89DB9",
            "priority": "P2",
            "created_at": "18/03/2026 22:56:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 23:38:38"
          },
          {
            "ticket_id": 13080,
            "ticket_number": "3513068",
            "title": "Reserva Aéreo [ERROR_AIR-2BFCEF0869] - Erro Técnic",
            "priority": "P1",
            "created_at": "18/03/2026 23:39:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 23:50:39"
          },
          {
            "ticket_id": 13081,
            "ticket_number": "3513069",
            "title": "Reserva Aéreo [ERROR_AIR-3BB508C506] - Erro Técnic",
            "priority": "P1",
            "created_at": "18/03/2026 23:45:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 23:51:09"
          },
          {
            "ticket_id": 13082,
            "ticket_number": "3513070",
            "title": "Reserva Aéreo [ERROR_AIR-3AE7A39F65] - Erro Técnic",
            "priority": "P2",
            "created_at": "18/03/2026 23:49:58",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 12.35,
            "sla_met": false,
            "sla_breach_hours": 8.35,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:11:38"
          },
          {
            "ticket_id": 13088,
            "ticket_number": "3513076",
            "title": "Reserva Aéreo [ERROR_AIR-42B7902BDF] - Erro Técnic",
            "priority": "P2",
            "created_at": "19/03/2026 10:06:53",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:18:21"
          },
          {
            "ticket_id": 13109,
            "ticket_number": "3513097",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "19/03/2026 12:37:14",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:37:15"
          },
          {
            "ticket_id": 13110,
            "ticket_number": "3513098",
            "title": "Re: Presupuesto - Nissan Micra",
            "priority": "P2",
            "created_at": "19/03/2026 12:51:12",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:51:12"
          },
          {
            "ticket_id": 13115,
            "ticket_number": "3513103",
            "title": "Re: reserva YJ8GBL (#2862910)",
            "priority": "P2",
            "created_at": "19/03/2026 13:21:19",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:42:11"
          },
          {
            "ticket_id": 13119,
            "ticket_number": "3513107",
            "title": "[Pedido IATA] Porto → Ponta Delgada - 2026-06-10 (",
            "priority": "P2",
            "created_at": "19/03/2026 14:13:01",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:47:44"
          },
          {
            "ticket_id": 13129,
            "ticket_number": "3513117",
            "title": "Aéreo - Confirmação de Emissão (ANTUNES LOPES MEND",
            "priority": "P2",
            "created_at": "19/03/2026 16:00:41",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:09:43"
          },
          {
            "ticket_id": 13130,
            "ticket_number": "3513118",
            "title": "Aéreo - Confirmação de Emissão (DOS SANTOS BAPTIST",
            "priority": "P2",
            "created_at": "19/03/2026 16:00:44",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:10:23"
          },
          {
            "ticket_id": 13131,
            "ticket_number": "3513119",
            "title": "Aéreo - Confirmação de Emissão (SILVA PINTO\\ANABEL",
            "priority": "P2",
            "created_at": "19/03/2026 16:00:46",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:12:05"
          },
          {
            "ticket_id": 13132,
            "ticket_number": "3513120",
            "title": "Aéreo - Confirmação de Emissão (ANTUNES LOPES MEND",
            "priority": "P2",
            "created_at": "19/03/2026 16:03:16",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:12:44"
          },
          {
            "ticket_id": 13136,
            "ticket_number": "3513124",
            "title": "Rsv. cruzeiro - Confirmação Procº 1050305/2026",
            "priority": "P2",
            "created_at": "19/03/2026 16:14:47",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:21:58"
          },
          {
            "ticket_id": 13139,
            "ticket_number": "3513127",
            "title": "Re: OO17TD - New Issue Deadline (#2862990)",
            "priority": "P2",
            "created_at": "19/03/2026 16:53:26",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:13:53"
          },
          {
            "ticket_id": 13141,
            "ticket_number": "3513129",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:28",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:07:57"
          },
          {
            "ticket_id": 13144,
            "ticket_number": "3513132",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:38",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:00:32"
          },
          {
            "ticket_id": 13148,
            "ticket_number": "3513136",
            "title": "Aéreo - Confirmação de Emissão (LIMA\\ALEXANDRA) - ",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:37",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:45:51"
          },
          {
            "ticket_id": 13149,
            "ticket_number": "3513137",
            "title": "Aéreo - Confirmação de Emissão (CASTRO\\FERNANDO) -",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:40",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:46:17"
          },
          {
            "ticket_id": 13150,
            "ticket_number": "3513138",
            "title": "Aéreo - Confirmação de Emissão (CASTRO\\DIOGO) - OO",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:42",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:46:47"
          },
          {
            "ticket_id": 13151,
            "ticket_number": "3513139",
            "title": "Aéreo - Confirmação de Emissão (LEAL\\MAGALI) - OO1",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:44",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:47:27"
          },
          {
            "ticket_id": 13152,
            "ticket_number": "3513140",
            "title": "Aéreo - Confirmação de Emissão (COELHO\\SANTIAGO) -",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:47",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:48:02"
          },
          {
            "ticket_id": 13153,
            "ticket_number": "3513141",
            "title": "Aéreo - Confirmação de Emissão (SILVA\\MARLENE) - O",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:50",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:48:26"
          },
          {
            "ticket_id": 13154,
            "ticket_number": "3513142",
            "title": "Aéreo - Confirmação de Emissão (CASTRO\\MATILDE) - ",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:52",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:48:55"
          },
          {
            "ticket_id": 13155,
            "ticket_number": "3513143",
            "title": "Aéreo - Confirmação de Emissão (COELHO\\ANTONIO) - ",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:55",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:49:17"
          },
          {
            "ticket_id": 13156,
            "ticket_number": "3513144",
            "title": "Aéreo - Confirmação de Emissão (LIMA\\MARIA) - OO17",
            "priority": "P2",
            "created_at": "19/03/2026 17:28:57",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:49:49"
          },
          {
            "ticket_id": 13157,
            "ticket_number": "3513145",
            "title": "[Pedido IATA] Lisboa → São Paulo - 2026-07-06 (2 p",
            "priority": "P2",
            "created_at": "19/03/2026 17:29:18",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:29:18"
          },
          {
            "ticket_id": 13176,
            "ticket_number": "3513164",
            "title": "Grupo: GR-3BE29B43BB",
            "priority": "P2",
            "created_at": "19/03/2026 19:43:13",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 22:44:24"
          },
          {
            "ticket_id": 13184,
            "ticket_number": "3513172",
            "title": "[Suporte] TRP-2026-04102 - Devolução e comissão",
            "priority": "P2",
            "created_at": "19/03/2026 23:02:27",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 23:02:27"
          },
          {
            "ticket_id": 13185,
            "ticket_number": "3513173",
            "title": "Fwd: Reclamação Formal – Reserva [415384/25] – Mel",
            "priority": "P1",
            "created_at": "19/03/2026 23:12:01",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 15.55,
            "sla_met": false,
            "sla_breach_hours": 15.3,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 14:45:31"
          },
          {
            "ticket_id": 13221,
            "ticket_number": "3513209",
            "title": "Confirmação e Sinalização de Reserva   213950",
            "priority": "P2",
            "created_at": "20/03/2026 12:23:17",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 16:20:27"
          },
          {
            "ticket_id": 13224,
            "ticket_number": "3513212",
            "title": "Grupo GR-9A90FA2F49",
            "priority": "P2",
            "created_at": "20/03/2026 12:43:52",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:04:22"
          },
          {
            "ticket_id": 13225,
            "ticket_number": "3513213",
            "title": "Grupo: GR-9A90FA2F49",
            "priority": "P2",
            "created_at": "20/03/2026 12:43:54",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 12:45:10"
          },
          {
            "ticket_id": 13231,
            "ticket_number": "3513219",
            "title": "Reserva Consolidador",
            "priority": "P2",
            "created_at": "20/03/2026 14:08:59",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 14:08:59"
          },
          {
            "ticket_id": 13245,
            "ticket_number": "3513233",
            "title": "Notificação formal – reembolso em atraso há mais d",
            "priority": "P2",
            "created_at": "20/03/2026 17:38:27",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:40:52"
          },
          {
            "ticket_id": 13248,
            "ticket_number": "3513236",
            "title": "Aéreo - Confirmação de Emissão (GOMES\\LUANA) - OT4",
            "priority": "P2",
            "created_at": "20/03/2026 18:31:34",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:57:06"
          },
          {
            "ticket_id": 13249,
            "ticket_number": "3513237",
            "title": "Aéreo - Confirmação de Emissão (FILHO\\CLAUDIA) - O",
            "priority": "P2",
            "created_at": "20/03/2026 18:31:36",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:57:31"
          },
          {
            "ticket_id": 13250,
            "ticket_number": "3513238",
            "title": "Aéreo - Confirmação de Emissão (GOMES\\LUANA) - OT4",
            "priority": "P2",
            "created_at": "20/03/2026 18:31:39",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:58:00"
          },
          {
            "ticket_id": 13251,
            "ticket_number": "3513239",
            "title": "Aéreo - Confirmação de Emissão (FILHO\\CLAUDIA) - O",
            "priority": "P2",
            "created_at": "20/03/2026 18:32:03",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:58:27"
          },
          {
            "ticket_id": 13254,
            "ticket_number": "3513242",
            "title": "[Pedido IATA] porto → addis abeba - 2026-08-16 (5 ",
            "priority": "P2",
            "created_at": "20/03/2026 19:04:24",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 19:04:24"
          },
          {
            "ticket_id": 13275,
            "ticket_number": "3513263",
            "title": "[Pedido IATA] Lisboa (LIS) → Vancouver (YVR) - 202",
            "priority": "P2",
            "created_at": "20/03/2026 21:25:29",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:25:30"
          },
          {
            "ticket_id": 13276,
            "ticket_number": "3513264",
            "title": "[Pedido IATA] GYN → LIS - 2026-06-22 (4 pax)",
            "priority": "P2",
            "created_at": "20/03/2026 21:40:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:40:36"
          },
          {
            "ticket_id": 13285,
            "ticket_number": "3513273",
            "title": "[Pedido IATA] Lisboa (LIS) → Vancouver (YVR) - 202",
            "priority": "P2",
            "created_at": "20/03/2026 23:29:16",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:29:16"
          },
          {
            "ticket_id": 13295,
            "ticket_number": "3513283",
            "title": "[Pedido IATA] lisboa → malta - 2026-08-23 (6 pax)",
            "priority": "P2",
            "created_at": "21/03/2026 10:05:42",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 10:05:43"
          },
          {
            "ticket_id": 13296,
            "ticket_number": "3513284",
            "title": "[Pedido IATA] Lisboa → Atenas - 2026-06-22 (3 pax)",
            "priority": "P2",
            "created_at": "21/03/2026 10:35:27",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 10:35:28"
          },
          {
            "ticket_id": 13297,
            "ticket_number": "3513285",
            "title": "[Pedido IATA] Atenas → Corfu - 2026-03-23 (3 pax)",
            "priority": "P2",
            "created_at": "21/03/2026 10:36:59",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 10:37:00"
          },
          {
            "ticket_id": 13314,
            "ticket_number": "3513302",
            "title": "[Pedido IATA] Porto → Ilha do Sal - 2026-08-16 (5 ",
            "priority": "P2",
            "created_at": "22/03/2026 20:45:16",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/03/2026 20:45:16"
          },
          {
            "ticket_id": 13317,
            "ticket_number": "3513305",
            "title": "[Pedido IATA] porto → rio de janeiro - 2026-12-15 ",
            "priority": "P2",
            "created_at": "22/03/2026 22:55:35",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/03/2026 22:55:35"
          },
          {
            "ticket_id": 13318,
            "ticket_number": "3513306",
            "title": "[Pedido IATA] Lisboa → Málaga - 2026-07-10 (9 pax)",
            "priority": "P2",
            "created_at": "23/03/2026 00:21:11",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 00:21:12"
          },
          {
            "ticket_id": 13342,
            "ticket_number": "3513330",
            "title": "Urgent: Risk of Missing Connection – Request for G",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:25",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:11:26"
          },
          {
            "ticket_id": 13354,
            "ticket_number": "3513342",
            "title": "YGOZWA – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:10",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:54:28"
          },
          {
            "ticket_id": 13355,
            "ticket_number": "3513343",
            "title": "Y9ITTF – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:12",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:53:27"
          },
          {
            "ticket_id": 13371,
            "ticket_number": "3513359",
            "title": "G5JJCQ – Alteração de horario/nº de voo",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:41",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:24:06"
          },
          {
            "ticket_id": 13395,
            "ticket_number": "3513383",
            "title": "[Pedido IATA] lisboa → cuiaba - 2026-08-13 (1 pax)",
            "priority": "P2",
            "created_at": "23/03/2026 12:55:54",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 12:55:54"
          },
          {
            "ticket_id": 13400,
            "ticket_number": "3513388",
            "title": "Fwd: Bem-vindo ao SATA 4 AGENTS",
            "priority": "P2",
            "created_at": "23/03/2026 13:49:27",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:49:27"
          },
          {
            "ticket_id": 13403,
            "ticket_number": "3513391",
            "title": "** 2A VIA** FW: RESERVA LEPLAN LOCALIZADOR 6044973",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:01",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:44:53"
          },
          {
            "ticket_id": 13425,
            "ticket_number": "3513413",
            "title": "Fw: Envio de comprovativo Caixadirecta",
            "priority": "P2",
            "created_at": "23/03/2026 13:56:30",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:35:17"
          },
          {
            "ticket_id": 13426,
            "ticket_number": "3513414",
            "title": "TRP-2026-03754",
            "priority": "P2",
            "created_at": "23/03/2026 15:04:40",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:04:41"
          },
          {
            "ticket_id": 13448,
            "ticket_number": "3513436",
            "title": "Alteração de Reserva 213950",
            "priority": "P2",
            "created_at": "23/03/2026 19:41:15",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:40:37"
          },
          {
            "ticket_id": 13452,
            "ticket_number": "3513440",
            "title": "[Pedido IATA] Lisboa → Rio de janeiro - 2026-12-04",
            "priority": "P2",
            "created_at": "23/03/2026 20:50:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:50:35"
          },
          {
            "ticket_id": 13455,
            "ticket_number": "3513443",
            "title": "[Pedido IATA] Porto → Cagliari - 2026-07-07 (3 pax",
            "priority": "P2",
            "created_at": "23/03/2026 21:17:19",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 21:17:20"
          },
          {
            "ticket_id": 13459,
            "ticket_number": "3513447",
            "title": "[Suporte] TRP-2026-04247 / TRL-2026-06433 - Altera",
            "priority": "P2",
            "created_at": "23/03/2026 22:26:05",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 22:26:05"
          },
          {
            "ticket_id": 13467,
            "ticket_number": "3513455",
            "title": "Y352KK – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:27",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 13:41:29"
          },
          {
            "ticket_id": 13489,
            "ticket_number": "3513477",
            "title": "Reserva Aérea M3WEC",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:46",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 12:01:42"
          },
          {
            "ticket_id": 13497,
            "ticket_number": "3513485",
            "title": "Grupo GR-AD22625FAC",
            "priority": "P2",
            "created_at": "24/03/2026 11:44:07",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 15:41:44"
          },
          {
            "ticket_id": 13498,
            "ticket_number": "3513486",
            "title": "Grupo: GR-AD22625FAC",
            "priority": "P2",
            "created_at": "24/03/2026 11:44:10",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 13:29:51"
          },
          {
            "ticket_id": 13499,
            "ticket_number": "3513487",
            "title": "Aéreo - Confirmação de Emissão (NOGUEIRA DE MORAIS",
            "priority": "P2",
            "created_at": "24/03/2026 11:44:15",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 12:02:46"
          },
          {
            "ticket_id": 13501,
            "ticket_number": "3513489",
            "title": "Grupo GR-AD22625FAC",
            "priority": "P2",
            "created_at": "24/03/2026 11:44:21",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 12:14:19"
          },
          {
            "ticket_id": 13517,
            "ticket_number": "3513505",
            "title": "[Suporte] TRP-2026-03264 / TRL-2026-05035 - Reembo",
            "priority": "P2",
            "created_at": "24/03/2026 14:03:39",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:03:39"
          },
          {
            "ticket_id": 13530,
            "ticket_number": "3513518",
            "title": "SANTOS RUAS/VITOR MANUEL MR 12MAY LIS RAI",
            "priority": "P2",
            "created_at": "24/03/2026 17:08:26",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:09:24"
          },
          {
            "ticket_id": 13531,
            "ticket_number": "3513519",
            "title": "YFYGTL – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "24/03/2026 17:10:30",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:23:20"
          },
          {
            "ticket_id": 13532,
            "ticket_number": "3513520",
            "title": "Reserva Aérea YFYGTL",
            "priority": "P2",
            "created_at": "24/03/2026 17:10:33",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:15:31"
          },
          {
            "ticket_id": 13533,
            "ticket_number": "3513521",
            "title": "SANTOS RUAS/VITOR MANUEL MR 12MAY2026 LIS RAI",
            "priority": "P2",
            "created_at": "24/03/2026 17:12:27",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:14:24"
          },
          {
            "ticket_id": 13539,
            "ticket_number": "3513527",
            "title": "Aéreo - Confirmação de Emissão (FARINHA\\TIAGO) - Y",
            "priority": "P2",
            "created_at": "24/03/2026 17:25:34",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:43:52"
          },
          {
            "ticket_id": 13569,
            "ticket_number": "3513557",
            "title": "[Suporte] TRP-2026-03635 / TRL-2026-05536 - Pagame",
            "priority": "P2",
            "created_at": "24/03/2026 23:28:45",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 23:28:46"
          },
          {
            "ticket_id": 13576,
            "ticket_number": "3513564",
            "title": "Aéreo - Confirmação de Emissão (PALMA\\CARLA) - Y35",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:34",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:15:35"
          },
          {
            "ticket_id": 13577,
            "ticket_number": "3513565",
            "title": "G5JJCQ – Alteração de Horário - Aceite",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:36",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:15:04"
          },
          {
            "ticket_id": 13579,
            "ticket_number": "3513567",
            "title": "Aéreo - Confirmação de Emissão (FIGUEIREDO\\SERGIO)",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:41",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:15:57"
          },
          {
            "ticket_id": 13596,
            "ticket_number": "3513584",
            "title": "[Pedido IATA] LISBOA → SÃO PAULO - 2026-05-27 (1 p",
            "priority": "P2",
            "created_at": "25/03/2026 12:17:01",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:17:01"
          },
          {
            "ticket_id": 13597,
            "ticket_number": "3513585",
            "title": "[Pedido IATA] Madrid (MAD) → ida: Curação (CUR) / ",
            "priority": "P2",
            "created_at": "25/03/2026 12:31:53",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:31:53"
          },
          {
            "ticket_id": 13598,
            "ticket_number": "3513586",
            "title": "SANTOS RUAS/VITOR MANUEL MR 12MAY LIS RAI",
            "priority": "P2",
            "created_at": "25/03/2026 12:34:55",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:37:33"
          },
          {
            "ticket_id": 13599,
            "ticket_number": "3513587",
            "title": "SANTOS RUAS/VITOR MANUEL MR 12MAY2026 LIS RAI",
            "priority": "P2",
            "created_at": "25/03/2026 12:35:26",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:38:34"
          },
          {
            "ticket_id": 13600,
            "ticket_number": "3513588",
            "title": "[Pedido IATA] Aeroporto Humberto Delgado,Lisboa → ",
            "priority": "P2",
            "created_at": "25/03/2026 12:45:50",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:45:50"
          },
          {
            "ticket_id": 13610,
            "ticket_number": "3513598",
            "title": "Envio de Documentação * File 432870",
            "priority": "P2",
            "created_at": "25/03/2026 14:29:56",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 14:32:58"
          },
          {
            "ticket_id": 13631,
            "ticket_number": "3513619",
            "title": "Reserva Aérea YXALXP",
            "priority": "P2",
            "created_at": "25/03/2026 17:19:25",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:09:18"
          },
          {
            "ticket_id": 13632,
            "ticket_number": "3513620",
            "title": "YXALXP – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "25/03/2026 17:19:27",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:09:06"
          },
          {
            "ticket_id": 13636,
            "ticket_number": "3513624",
            "title": "Monitor de Reservas  - Aereo - LA0452120CFBG",
            "priority": "P2",
            "created_at": "25/03/2026 17:55:04",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:25:40"
          },
          {
            "ticket_id": 13640,
            "ticket_number": "3513628",
            "title": "[Pedido IATA] lisboa → cuiaba - 2026-08-20 (1 pax)",
            "priority": "P2",
            "created_at": "25/03/2026 18:03:44",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:03:44"
          },
          {
            "ticket_id": 13651,
            "ticket_number": "3513639",
            "title": "[Suporte] TRP-2026-04144 / TRL-2026-06272 - Equipa",
            "priority": "P2",
            "created_at": "25/03/2026 19:39:27",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 19:39:27"
          },
          {
            "ticket_id": 13668,
            "ticket_number": "3513656",
            "title": "Reserva Aérea Z388V2",
            "priority": "P2",
            "created_at": "25/03/2026 22:44:23",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 12:41:01"
          },
          {
            "ticket_id": 13669,
            "ticket_number": "3513657",
            "title": "Z388V2 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "25/03/2026 22:55:54",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 11.52,
            "sla_met": false,
            "sla_breach_hours": 7.52,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:26:54"
          },
          {
            "ticket_id": 13684,
            "ticket_number": "3513672",
            "title": "Z388V2 – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "26/03/2026 10:04:10",
            "close_date": "2026-03-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.62,
            "sla_met": false,
            "sla_breach_hours": 7.37,
            "sla_name": "SLA P1",
            "first_response_at": "26/03/2026 17:41:48"
          },
          {
            "ticket_id": 13694,
            "ticket_number": "3513682",
            "title": "Fwd: URRWXV | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "26/03/2026 11:14:14",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 11:14:14"
          },
          {
            "ticket_id": 13717,
            "ticket_number": "3513705",
            "title": "Fwd: ***INFORMAÇÕES IMPORTANTES SOBRE SEU VOO URRW",
            "priority": "P2",
            "created_at": "26/03/2026 15:53:13",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:53:14"
          },
          {
            "ticket_id": 13723,
            "ticket_number": "3513711",
            "title": "XB4LYF – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "26/03/2026 17:03:41",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:01:47"
          },
          {
            "ticket_id": 13724,
            "ticket_number": "3513712",
            "title": "Re:[## 33076 ##] GBN-107954 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "26/03/2026 17:23:49",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:05:09"
          },
          {
            "ticket_id": 13740,
            "ticket_number": "3513728",
            "title": "Reserva Aérea ZJM85H",
            "priority": "P2",
            "created_at": "26/03/2026 21:42:22",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.62,
            "sla_met": false,
            "sla_breach_hours": 8.62,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:19:33"
          },
          {
            "ticket_id": 13741,
            "ticket_number": "3513729",
            "title": "ZJM85H – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "26/03/2026 21:42:24",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.6,
            "sla_met": false,
            "sla_breach_hours": 8.6,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:18:28"
          },
          {
            "ticket_id": 13742,
            "ticket_number": "3513730",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZJM",
            "priority": "P2",
            "created_at": "26/03/2026 21:42:27",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.6,
            "sla_met": false,
            "sla_breach_hours": 8.6,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:19:04"
          },
          {
            "ticket_id": 13743,
            "ticket_number": "3513731",
            "title": "Reserva Aérea LA0452209OUTL",
            "priority": "P2",
            "created_at": "26/03/2026 21:42:29",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.6,
            "sla_met": false,
            "sla_breach_hours": 8.6,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:18:48"
          },
          {
            "ticket_id": 13744,
            "ticket_number": "3513732",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (LA0",
            "priority": "P2",
            "created_at": "26/03/2026 21:52:55",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.35,
            "sla_met": false,
            "sla_breach_hours": 8.35,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:14:01"
          },
          {
            "ticket_id": 13766,
            "ticket_number": "3513754",
            "title": "ZM5FCJ – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:10",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:03:11"
          },
          {
            "ticket_id": 13769,
            "ticket_number": "3513757",
            "title": "Reserva Aérea ZM5FCJ",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:17",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 13:17:56"
          },
          {
            "ticket_id": 13811,
            "ticket_number": "3513799",
            "title": "Aéreo - Confirmação de Emissão (CAPITO\\ANDREIA) - ",
            "priority": "P2",
            "created_at": "27/03/2026 17:37:28",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:46:48"
          },
          {
            "ticket_id": 13812,
            "ticket_number": "3513800",
            "title": "Aéreo - Confirmação de Emissão (CAPITO\\PATRICIA) -",
            "priority": "P2",
            "created_at": "27/03/2026 17:37:30",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:47:13"
          },
          {
            "ticket_id": 13817,
            "ticket_number": "3513805",
            "title": "[Pedido IATA] Funchal → Ponta Delgada - 2026-07-23",
            "priority": "P2",
            "created_at": "27/03/2026 18:08:16",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 18:08:16"
          },
          {
            "ticket_id": 13842,
            "ticket_number": "3513830",
            "title": "Pagamento -  (Recibo-2147842096)",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:37",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 58.62,
            "sla_met": false,
            "sla_breach_hours": 54.62,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:21:00"
          },
          {
            "ticket_id": 13857,
            "ticket_number": "3513845",
            "title": "[Pedido IATA] lisboa → Açores São Miguel - 2026-09",
            "priority": "P2",
            "created_at": "28/03/2026 11:39:16",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:39:16"
          },
          {
            "ticket_id": 13860,
            "ticket_number": "3513848",
            "title": "[Pedido IATA] lisboa → Açores São Miguel - 2026-09",
            "priority": "P2",
            "created_at": "28/03/2026 11:45:56",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:45:56"
          },
          {
            "ticket_id": 13861,
            "ticket_number": "3513849",
            "title": "[Pedido IATA] lisboa → Açores São Miguel - 2026-09",
            "priority": "P2",
            "created_at": "28/03/2026 11:50:35",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:50:35"
          },
          {
            "ticket_id": 13862,
            "ticket_number": "3513850",
            "title": "[Pedido IATA] lisboa → Açores São Miguel - 2026-09",
            "priority": "P2",
            "created_at": "28/03/2026 11:52:53",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:52:53"
          },
          {
            "ticket_id": 13863,
            "ticket_number": "3513851",
            "title": "[Pedido IATA] lisboa → Açores São Miguel - 2026-09",
            "priority": "P2",
            "created_at": "28/03/2026 11:54:02",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:54:02"
          },
          {
            "ticket_id": 13893,
            "ticket_number": "3513881",
            "title": "[Pedido IATA] Lisboa → Palma de Maiorca - 2026-06-",
            "priority": "P2",
            "created_at": "28/03/2026 22:48:42",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 22:48:42"
          },
          {
            "ticket_id": 13897,
            "ticket_number": "3513885",
            "title": "[Pedido IATA] lisboa → Terceira - 2026-09-30 (9 pa",
            "priority": "P2",
            "created_at": "30/03/2026 09:46:48",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:46:48"
          },
          {
            "ticket_id": 13903,
            "ticket_number": "3513891",
            "title": "REMINDER: Dados de Passaporte - nosso File 424615",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:23",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13906,
            "ticket_number": "3513894",
            "title": "[Pedido IATA] lisboa → Terceira - 2026-09-29 (8 pa",
            "priority": "P2",
            "created_at": "30/03/2026 09:49:04",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:49:04"
          },
          {
            "ticket_id": 13916,
            "ticket_number": "3513904",
            "title": "GBN-115701 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/03/2026 09:50:43",
            "close_date": "2026-05-04",
            "sla_target_hours": 24,
            "actual_time_hours": 432.05,
            "sla_met": false,
            "sla_breach_hours": 408.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/04/2026 09:54:06"
          },
          {
            "ticket_id": 13926,
            "ticket_number": "3513914",
            "title": "Fwd: Incidente de voo TTN-1253865428#97298919#T188",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:18",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:19"
          },
          {
            "ticket_id": 13932,
            "ticket_number": "3513920",
            "title": "Fwd: [[ Ref:201755869 ]] easyJet Questão geral - E",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:34",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:34"
          },
          {
            "ticket_id": 13955,
            "ticket_number": "3513943",
            "title": "Informação de reserva - SPT002601600279",
            "priority": "P2",
            "created_at": "30/03/2026 09:53:58",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 13:05:33"
          },
          {
            "ticket_id": 13963,
            "ticket_number": "3513951",
            "title": "Reserva Aérea LA0452798VGXR",
            "priority": "P2",
            "created_at": "30/03/2026 10:40:57",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:43:51"
          },
          {
            "ticket_id": 13974,
            "ticket_number": "3513962",
            "title": "Fwd: [[ Ref:201755869 ]] Re: easyJet Questão geral",
            "priority": "P2",
            "created_at": "30/03/2026 13:08:55",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:08:55"
          },
          {
            "ticket_id": 13985,
            "ticket_number": "3513973",
            "title": "Importante - FILE 341925",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:20",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:11:03"
          },
          {
            "ticket_id": 13993,
            "ticket_number": "3513981",
            "title": "GBN-115705 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/03/2026 13:57:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:42:46"
          },
          {
            "ticket_id": 14000,
            "ticket_number": "3513988",
            "title": "[Pedido IATA] lisboa → turim - 2026-09-25 (4 pax)",
            "priority": "P2",
            "created_at": "30/03/2026 15:46:50",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:46:51"
          },
          {
            "ticket_id": 14022,
            "ticket_number": "3514010",
            "title": "viagem cancelada GBN-115705",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:39",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 19:40:39"
          },
          {
            "ticket_id": 14024,
            "ticket_number": "3514012",
            "title": "[LATAM Airlines]Informações importantes sobre o se",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:48",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 45.15,
            "sla_met": false,
            "sla_breach_hours": 41.15,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 16:50:03"
          },
          {
            "ticket_id": 14065,
            "ticket_number": "3514053",
            "title": "Reserva Aérea LA0457952USNT",
            "priority": "P2",
            "created_at": "31/03/2026 09:14:20",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 09:16:45"
          },
          {
            "ticket_id": 14069,
            "ticket_number": "3514057",
            "title": "Fwd: Informações sobre a sua reserva TTN-126417127",
            "priority": "P2",
            "created_at": "31/03/2026 10:10:52",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:35:05"
          },
          {
            "ticket_id": 14081,
            "ticket_number": "3514069",
            "title": "[Pedido IATA] porto → malaga - 2026-08-23 (6 pax)",
            "priority": "P2",
            "created_at": "31/03/2026 11:55:24",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:55:24"
          },
          {
            "ticket_id": 14082,
            "ticket_number": "3514070",
            "title": "Reserva Aérea MV5TV",
            "priority": "P2",
            "created_at": "31/03/2026 12:41:17",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 15:16:06"
          },
          {
            "ticket_id": 14103,
            "ticket_number": "3514091",
            "title": "Aéreo - Confirmação de Emissão (OLIVEIRA RODRIGUES",
            "priority": "P2",
            "created_at": "31/03/2026 15:30:22",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:00:30"
          },
          {
            "ticket_id": 14104,
            "ticket_number": "3514092",
            "title": "Aéreo - Confirmação de Emissão (PINHO PEREIRINHA\\A",
            "priority": "P2",
            "created_at": "31/03/2026 15:30:24",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:00:59"
          },
          {
            "ticket_id": 14106,
            "ticket_number": "3514094",
            "title": "Aéreo - Confirmação de Emissão (VALENTE MONTEIRO\\P",
            "priority": "P2",
            "created_at": "31/03/2026 15:30:29",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:01:26"
          },
          {
            "ticket_id": 14107,
            "ticket_number": "3514095",
            "title": "Aéreo - Confirmação de Emissão (LOPES MARQUES\\SILV",
            "priority": "P2",
            "created_at": "31/03/2026 15:30:32",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:01:52"
          },
          {
            "ticket_id": 14126,
            "ticket_number": "3514114",
            "title": "[Pedido IATA] lisboa → Marraquexe - 2026-08-01 (2 ",
            "priority": "P2",
            "created_at": "31/03/2026 16:33:06",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:33:06"
          },
          {
            "ticket_id": 14130,
            "ticket_number": "3514118",
            "title": "[Pedido IATA] Lisboa → Tours, França  - 2026-04-29",
            "priority": "P2",
            "created_at": "31/03/2026 17:05:39",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 17:05:40"
          },
          {
            "ticket_id": 14137,
            "ticket_number": "3514125",
            "title": "Reserva Aérea Z2369Z",
            "priority": "P1",
            "created_at": "31/03/2026 19:49:55",
            "close_date": "2026-04-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 14.25,
            "sla_met": false,
            "sla_breach_hours": 14.0,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 10:05:16"
          },
          {
            "ticket_id": 14138,
            "ticket_number": "3514126",
            "title": "Z2369Z – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "31/03/2026 19:49:57",
            "close_date": "2026-04-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 14.25,
            "sla_met": false,
            "sla_breach_hours": 14.0,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 10:05:32"
          },
          {
            "ticket_id": 14142,
            "ticket_number": "3514130",
            "title": "File 437290/26  | Situação atual no médio oriente ",
            "priority": "P2",
            "created_at": "31/03/2026 19:55:24",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 14.32,
            "sla_met": false,
            "sla_breach_hours": 10.32,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 10:14:37"
          },
          {
            "ticket_id": 14145,
            "ticket_number": "3514133",
            "title": "[Cancelamento Viagem] TRP-2026-03327 - CATARINA PI",
            "priority": "P2",
            "created_at": "31/03/2026 20:57:45",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:22:17"
          },
          {
            "ticket_id": 14156,
            "ticket_number": "3514144",
            "title": "[Pedido IATA] Porto → Bordéus - 2026-05-13 (2 pax)",
            "priority": "P2",
            "created_at": "01/04/2026 09:07:24",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 09:07:24"
          },
          {
            "ticket_id": 14157,
            "ticket_number": "3514145",
            "title": "Aéreo - Confirmação de Emissão (APARECIDO DE LIMA\\",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:36",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 13:02:27"
          },
          {
            "ticket_id": 14162,
            "ticket_number": "3514150",
            "title": "Z2369Z – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:47",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 12:22:26"
          },
          {
            "ticket_id": 14172,
            "ticket_number": "3514160",
            "title": "Aéreo - Confirmação de Emissão (MADEIRA\\MARTA) - Z",
            "priority": "P2",
            "created_at": "01/04/2026 12:13:45",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:29:11"
          },
          {
            "ticket_id": 14174,
            "ticket_number": "3514162",
            "title": "Aéreo - Confirmação de Emissão (BOTAS\\JOSE) - Z236",
            "priority": "P2",
            "created_at": "01/04/2026 12:13:49",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:29:36"
          },
          {
            "ticket_id": 14175,
            "ticket_number": "3514163",
            "title": "Aéreo - Confirmação de Emissão (CRUZ\\RICARDO) - Z2",
            "priority": "P2",
            "created_at": "01/04/2026 12:13:52",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:30:02"
          },
          {
            "ticket_id": 14185,
            "ticket_number": "3514173",
            "title": "Fwd: Informações da reserva TTN-1240916209#9784218",
            "priority": "P2",
            "created_at": "01/04/2026 14:28:28",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 17:09:57"
          },
          {
            "ticket_id": 14186,
            "ticket_number": "3514174",
            "title": "Fwd: Informações da reserva TTN-1240917792#9784160",
            "priority": "P2",
            "created_at": "01/04/2026 14:28:31",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:28:31"
          },
          {
            "ticket_id": 14190,
            "ticket_number": "3514178",
            "title": "1ª VIA - Confirmação de Reserva n. 10047364 - UMA ",
            "priority": "P1",
            "created_at": "01/04/2026 15:10:29",
            "close_date": "2026-04-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.5,
            "sla_met": false,
            "sla_breach_hours": 7.25,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 22:41:27"
          },
          {
            "ticket_id": 14197,
            "ticket_number": "3514185",
            "title": "[LATAM Airlines] Important information about your ",
            "priority": "P2",
            "created_at": "01/04/2026 16:45:45",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 16:54:23"
          },
          {
            "ticket_id": 14220,
            "ticket_number": "3514208",
            "title": "[Pedido IATA] Lisboa → Marselha - 2026-07-02 (1 pa",
            "priority": "P2",
            "created_at": "01/04/2026 21:27:31",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 21:27:32"
          },
          {
            "ticket_id": 14227,
            "ticket_number": "3514215",
            "title": "[Pedido IATA] Lisboa → Terceira - 2026-04-15 (1 pa",
            "priority": "P2",
            "created_at": "01/04/2026 22:18:20",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:18:20"
          },
          {
            "ticket_id": 14228,
            "ticket_number": "3514216",
            "title": "| Urgente: pagamento comissões pendentes |",
            "priority": "P2",
            "created_at": "01/04/2026 22:27:01",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:27:01"
          },
          {
            "ticket_id": 14234,
            "ticket_number": "3514222",
            "title": "[Pedido IATA] Porto  → Ibiza - 2026-07-15 (2 pax)",
            "priority": "P2",
            "created_at": "01/04/2026 23:29:56",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 23:29:56"
          },
          {
            "ticket_id": 14273,
            "ticket_number": "3514261",
            "title": "PEDRENO FERREIRA/CRISTINA MRS 09JUL LIS YYZ",
            "priority": "P2",
            "created_at": "02/04/2026 16:24:04",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:31:21"
          },
          {
            "ticket_id": 14274,
            "ticket_number": "3514262",
            "title": "RIBEIRO PEREIRA/ANTONIO MR 09JUL LIS YYZ",
            "priority": "P2",
            "created_at": "02/04/2026 16:24:06",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:31:45"
          },
          {
            "ticket_id": 14275,
            "ticket_number": "3514263",
            "title": "PEDRENO FERREIRA/CRISTINA MRS 09JUL2026 LIS YYZ",
            "priority": "P2",
            "created_at": "02/04/2026 16:27:06",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:30:05"
          },
          {
            "ticket_id": 14289,
            "ticket_number": "3514277",
            "title": "[Pedido IATA] Lisboa → Malta - 2026-06-04 (2 pax)",
            "priority": "P2",
            "created_at": "02/04/2026 18:35:16",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:35:16"
          },
          {
            "ticket_id": 14290,
            "ticket_number": "3514278",
            "title": "[Pedido IATA] Lisboa → Malta - 2026-06-04 (2 pax)",
            "priority": "P2",
            "created_at": "02/04/2026 18:36:55",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:36:55"
          },
          {
            "ticket_id": 14307,
            "ticket_number": "3514295",
            "title": "[Suporte] TRP-2026-04583 / TRL-2026-06961 - Correç",
            "priority": "P2",
            "created_at": "02/04/2026 20:47:02",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:47:02"
          },
          {
            "ticket_id": 14313,
            "ticket_number": "3514301",
            "title": "[Pedido IATA] Lisboa → Londres - 2026-10-02 (3 pax",
            "priority": "P2",
            "created_at": "03/04/2026 16:48:52",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/04/2026 16:48:52"
          },
          {
            "ticket_id": 14320,
            "ticket_number": "3514308",
            "title": "XLG4HD – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "04/04/2026 10:05:36",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 47.27,
            "sla_met": false,
            "sla_breach_hours": 47.02,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 09:21:54"
          },
          {
            "ticket_id": 14323,
            "ticket_number": "3514311",
            "title": "XLGIBM – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "04/04/2026 10:05:41",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 47.3,
            "sla_met": false,
            "sla_breach_hours": 47.05,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 09:24:12"
          },
          {
            "ticket_id": 14336,
            "ticket_number": "3514324",
            "title": "XG8RNC – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:06",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 76.48,
            "sla_met": false,
            "sla_breach_hours": 72.48,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 14:35:54"
          },
          {
            "ticket_id": 14339,
            "ticket_number": "3514327",
            "title": "Fwd: Informações da reserva TTN-1240916209#9784218",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:12",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 10:06:12"
          },
          {
            "ticket_id": 14340,
            "ticket_number": "3514328",
            "title": "Fwd: Informações da reserva TTN-1240917792#9784160",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:16",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 10:06:17"
          },
          {
            "ticket_id": 14349,
            "ticket_number": "3514337",
            "title": "[Pedido IATA] Porto → Funchal - 2026-08-31 (4 pax)",
            "priority": "P2",
            "created_at": "04/04/2026 15:37:13",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 15:37:13"
          },
          {
            "ticket_id": 14354,
            "ticket_number": "3514342",
            "title": "GBN-116784 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/04/2026 18:04:19",
            "close_date": "2026-04-20",
            "sla_target_hours": 24,
            "actual_time_hours": 303.63,
            "sla_met": false,
            "sla_breach_hours": 279.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/04/2026 09:42:58"
          },
          {
            "ticket_id": 14356,
            "ticket_number": "3514344",
            "title": "[Pedido IATA] lisboa → madrid - 2026-09-07 (3 pax)",
            "priority": "P2",
            "created_at": "04/04/2026 21:11:58",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 21:11:58"
          },
          {
            "ticket_id": 14358,
            "ticket_number": "3514346",
            "title": "[Suporte] TRP-2026-03134 - transferes reserva lepl",
            "priority": "P2",
            "created_at": "05/04/2026 12:20:17",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/04/2026 12:20:17"
          },
          {
            "ticket_id": 14367,
            "ticket_number": "3514355",
            "title": "XLGIBM – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "06/04/2026 09:09:45",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 09:19:22"
          },
          {
            "ticket_id": 14368,
            "ticket_number": "3514356",
            "title": "XLG4HD – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "06/04/2026 09:09:47",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 09:19:31"
          },
          {
            "ticket_id": 14405,
            "ticket_number": "3514393",
            "title": "Aéreo - Confirmação de Emissão (GOMES\\ALDINA) - XL",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:27",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 14:03:35"
          },
          {
            "ticket_id": 14406,
            "ticket_number": "3514394",
            "title": "Confirmação de reserva 343800 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:29",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 14:03:35"
          },
          {
            "ticket_id": 14407,
            "ticket_number": "3514395",
            "title": "Aéreo - Confirmação de Emissão (GOMES\\JOAO) - XLG4",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:31",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 14:03:35"
          },
          {
            "ticket_id": 14411,
            "ticket_number": "3514399",
            "title": "[Pedido IATA] Lisboa → Paris - 2026-07-23 (2 pax)",
            "priority": "P2",
            "created_at": "06/04/2026 11:17:38",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 11:17:38"
          },
          {
            "ticket_id": 14414,
            "ticket_number": "3514402",
            "title": "RE: Pedido de orçamento (Magali) W2MCS:01574000281",
            "priority": "P2",
            "created_at": "06/04/2026 11:29:41",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:23:43"
          },
          {
            "ticket_id": 14421,
            "ticket_number": "3514409",
            "title": "429171 - Aviso chegada a ZNZ um pouco + tarde",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:38",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:22:31"
          },
          {
            "ticket_id": 14422,
            "ticket_number": "3514410",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:39",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:41:39"
          },
          {
            "ticket_id": 14438,
            "ticket_number": "3514426",
            "title": "[Pedido IATA] LISBOA → Athens, Eleftherios Venizel",
            "priority": "P2",
            "created_at": "06/04/2026 15:52:12",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:52:12"
          },
          {
            "ticket_id": 14445,
            "ticket_number": "3514433",
            "title": "GBN-99626",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:25",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 16:58:51"
          },
          {
            "ticket_id": 14452,
            "ticket_number": "3514440",
            "title": "Fwd: Informações da reserva TTN-1240916209#9812371",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:39",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:01:39"
          },
          {
            "ticket_id": 14454,
            "ticket_number": "3514442",
            "title": "Fwd: Informações da reserva TTN-1240917792#9812155",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:46",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:01:46"
          },
          {
            "ticket_id": 14455,
            "ticket_number": "3514443",
            "title": "RESERVA LEPLAN LOCALIZADOR 604524385 - CONTACTO CL",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:49",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:08:18"
          },
          {
            "ticket_id": 14463,
            "ticket_number": "3514451",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KC",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:34",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:34"
          },
          {
            "ticket_id": 14496,
            "ticket_number": "3514484",
            "title": "Fwd: Lua de mel maldivas e Dubai - LOC:414136 Solf",
            "priority": "P2",
            "created_at": "06/04/2026 22:30:58",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:30:59"
          },
          {
            "ticket_id": 14497,
            "ticket_number": "3514485",
            "title": "[Pedido IATA] Porto  → Roma (FCO) - 2026-09-10 (2 ",
            "priority": "P2",
            "created_at": "06/04/2026 22:46:39",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:46:39"
          },
          {
            "ticket_id": 14507,
            "ticket_number": "3514495",
            "title": "Reserva Cláudio Cunha - Newblue - Loc: 6119956",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:29",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 09:08:29"
          },
          {
            "ticket_id": 14518,
            "ticket_number": "3514506",
            "title": "Discrepância de valores - TRP-2026-01987",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:24",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:38:24"
          },
          {
            "ticket_id": 14525,
            "ticket_number": "3514513",
            "title": "Fwd: Incidente de voo TTN-1261990228#98135549#T190",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:39",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:38:40"
          },
          {
            "ticket_id": 14535,
            "ticket_number": "3514523",
            "title": "mala nao recebida no destino",
            "priority": "P2",
            "created_at": "07/04/2026 12:00:06",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:00:06"
          },
          {
            "ticket_id": 14538,
            "ticket_number": "3514526",
            "title": "Pedido de fatura para pagamento",
            "priority": "P2",
            "created_at": "07/04/2026 12:15:52",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:15:53"
          },
          {
            "ticket_id": 14541,
            "ticket_number": "3514529",
            "title": "[Suporte] TRP-2026-03173 - CC viagem leplan 604524",
            "priority": "P2",
            "created_at": "07/04/2026 12:28:40",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:28:41"
          },
          {
            "ticket_id": 14547,
            "ticket_number": "3514535",
            "title": "Reserva Aérea NZYTR",
            "priority": "P1",
            "created_at": "07/04/2026 13:50:07",
            "close_date": "2026-04-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/04/2026 14:00:24"
          },
          {
            "ticket_id": 14548,
            "ticket_number": "3514536",
            "title": "Aéreo - Confirmação de Emissão (DELGADO TAVARES\\MA",
            "priority": "P2",
            "created_at": "07/04/2026 15:10:51",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:36:01"
          },
          {
            "ticket_id": 14549,
            "ticket_number": "3514537",
            "title": "Aéreo - Confirmação de Emissão (FILIPE MANTA\\LOURE",
            "priority": "P2",
            "created_at": "07/04/2026 15:10:53",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:31:14"
          },
          {
            "ticket_id": 14551,
            "ticket_number": "3514539",
            "title": "Esclarecimento comissões",
            "priority": "P2",
            "created_at": "07/04/2026 15:10:57",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:10:57"
          },
          {
            "ticket_id": 14552,
            "ticket_number": "3514540",
            "title": "Aéreo - Confirmação de Emissão (ABREU FILIPE\\CATIA",
            "priority": "P2",
            "created_at": "07/04/2026 15:10:59",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:30:47"
          },
          {
            "ticket_id": 14556,
            "ticket_number": "3514544",
            "title": "[Suporte] TRP-2026-04566 - Precisamos de adicionar",
            "priority": "P2",
            "created_at": "07/04/2026 17:53:53",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 17:53:53"
          },
          {
            "ticket_id": 14558,
            "ticket_number": "3514546",
            "title": "[Pedido IATA] Porto → Quito - 2026-12-17 (3 pax)",
            "priority": "P3",
            "created_at": "07/04/2026 18:07:24",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/04/2026 18:07:25"
          },
          {
            "ticket_id": 14570,
            "ticket_number": "3514558",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:51",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:52"
          },
          {
            "ticket_id": 14588,
            "ticket_number": "3514576",
            "title": "[Cancelamento Serviço] TRP-2026-04144 / TRL-2026-0",
            "priority": "P2",
            "created_at": "07/04/2026 19:03:52",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 19:03:52"
          },
          {
            "ticket_id": 14589,
            "ticket_number": "3514577",
            "title": "[Suporte] TRP-2026-02579 - Pedido de correção do V",
            "priority": "P2",
            "created_at": "07/04/2026 19:37:14",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 19:37:14"
          },
          {
            "ticket_id": 14600,
            "ticket_number": "3514588",
            "title": "[Cancelamento Viagem] TRP-2026-031Desculpa Rui mas",
            "priority": "P2",
            "created_at": "07/04/2026 22:02:01",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:02:01"
          },
          {
            "ticket_id": 14609,
            "ticket_number": "3514597",
            "title": "Fwd: Incidente de voo TTN-1261990228#98275403#T191",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:20",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:07:21"
          },
          {
            "ticket_id": 14624,
            "ticket_number": "3514612",
            "title": "[Pedido IATA] LISBOA → ponta delgada - 2026-06-03 ",
            "priority": "P2",
            "created_at": "08/04/2026 10:38:43",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:38:43"
          },
          {
            "ticket_id": 14640,
            "ticket_number": "3514628",
            "title": "Plataforma",
            "priority": "P2",
            "created_at": "08/04/2026 12:10:13",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 12:10:13"
          },
          {
            "ticket_id": 14641,
            "ticket_number": "3514629",
            "title": "[Cancelamento Serviço] TRP-2026-03324 / TRL-2026-0",
            "priority": "P2",
            "created_at": "08/04/2026 12:22:50",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 12:22:50"
          },
          {
            "ticket_id": 14645,
            "ticket_number": "3514633",
            "title": "Pedido reserva lusanova",
            "priority": "P1",
            "created_at": "08/04/2026 13:32:59",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "08/04/2026 13:32:59"
          },
          {
            "ticket_id": 14655,
            "ticket_number": "3514643",
            "title": "Fwd: Informações da reserva TTN-1240917792#9812155",
            "priority": "P2",
            "created_at": "08/04/2026 16:01:50",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:01:52"
          },
          {
            "ticket_id": 14664,
            "ticket_number": "3514652",
            "title": "[Pedido IATA] Lisboa → Budapeste - 2026-12-05 (18 ",
            "priority": "P3",
            "created_at": "08/04/2026 16:03:55",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/04/2026 16:03:56"
          },
          {
            "ticket_id": 14677,
            "ticket_number": "3514665",
            "title": "[Pedido IATA] Lisboa → Bollonha (BLQ) - 2026-05-08",
            "priority": "P2",
            "created_at": "08/04/2026 19:37:06",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 19:37:06"
          },
          {
            "ticket_id": 14699,
            "ticket_number": "3514687",
            "title": "[Suporte] TRP-2026-04412 / TRL-2026-06677 - Valore",
            "priority": "P2",
            "created_at": "08/04/2026 23:16:50",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:04:55"
          },
          {
            "ticket_id": 14701,
            "ticket_number": "3514689",
            "title": "[Suporte] TRP-2026-04607 - fatura por favor",
            "priority": "P2",
            "created_at": "08/04/2026 23:50:59",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 23:51:00"
          },
          {
            "ticket_id": 14705,
            "ticket_number": "3514693",
            "title": "GBN-113415 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "09/04/2026 11:18:08",
            "close_date": "2026-04-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.75,
            "sla_met": false,
            "sla_breach_hours": 1.5,
            "sla_name": "SLA P1",
            "first_response_at": "09/04/2026 13:03:51"
          },
          {
            "ticket_id": 14726,
            "ticket_number": "3514714",
            "title": "[Suporte] TRP-2026-04542 / TRL-2026-06885 - Preço ",
            "priority": "P2",
            "created_at": "09/04/2026 13:10:05",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:10:05"
          },
          {
            "ticket_id": 14732,
            "ticket_number": "3514720",
            "title": "[Pedido IATA] Porto → SID - Cabo Verde , Ilha do S",
            "priority": "P3",
            "created_at": "09/04/2026 14:47:39",
            "close_date": "2026-04-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/04/2026 14:47:39"
          },
          {
            "ticket_id": 14748,
            "ticket_number": "3514736",
            "title": "actualização dos cálculos da viagem TRP-2026-02730",
            "priority": "P2",
            "created_at": "09/04/2026 16:25:46",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 16:25:46"
          },
          {
            "ticket_id": 14766,
            "ticket_number": "3514754",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:11",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:11"
          },
          {
            "ticket_id": 14798,
            "ticket_number": "3514786",
            "title": "[Suporte] TRP-2026-03690 / TRL-2026-05610 - Altera",
            "priority": "P2",
            "created_at": "09/04/2026 21:19:02",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 21:19:02"
          },
          {
            "ticket_id": 14800,
            "ticket_number": "3514788",
            "title": "[Pedido de Grupo] Ilha Terceira- AÇORES - 2026-09-",
            "priority": "P2",
            "created_at": "09/04/2026 22:51:24",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 22:51:25"
          },
          {
            "ticket_id": 14819,
            "ticket_number": "3514807",
            "title": "Grupo: GR-5B7AD3E8D5",
            "priority": "P2",
            "created_at": "10/04/2026 10:31:17",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:18:27"
          },
          {
            "ticket_id": 14820,
            "ticket_number": "3514808",
            "title": "Pedido de documentação",
            "priority": "P2",
            "created_at": "10/04/2026 10:34:47",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 10:34:47"
          },
          {
            "ticket_id": 14824,
            "ticket_number": "3514812",
            "title": "[Suporte] TRP-2026-04144 / TRL-2026-06272 - Adicio",
            "priority": "P2",
            "created_at": "10/04/2026 11:49:12",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:49:13"
          },
          {
            "ticket_id": 14833,
            "ticket_number": "3514821",
            "title": "Reserva Aérea XX6CI3",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:33",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:24:09"
          },
          {
            "ticket_id": 14836,
            "ticket_number": "3514824",
            "title": "[Pedido IATA] porto → Treviso - 2026-05-03 (4 pax)",
            "priority": "P2",
            "created_at": "10/04/2026 13:38:13",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:38:13"
          },
          {
            "ticket_id": 14841,
            "ticket_number": "3514829",
            "title": "TRP-2026-04679",
            "priority": "P2",
            "created_at": "10/04/2026 14:57:31",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 14:57:31"
          },
          {
            "ticket_id": 14842,
            "ticket_number": "3514830",
            "title": "CARDOSO/NUNO MR 25APR LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 15:11:33",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:13:57"
          },
          {
            "ticket_id": 14843,
            "ticket_number": "3514831",
            "title": "CARDOSO/NUNO MR 25APR2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 15:11:34",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:12:39"
          },
          {
            "ticket_id": 14844,
            "ticket_number": "3514832",
            "title": "VINAGRE/BRUNO MR 25APR2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 15:11:35",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:13:10"
          },
          {
            "ticket_id": 14845,
            "ticket_number": "3514833",
            "title": "VINAGRE/BRUNO MR 25APR LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 15:11:37",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:14:25"
          },
          {
            "ticket_id": 14851,
            "ticket_number": "3514839",
            "title": "Fwd: Viagify informa sobre a sua reserva 126832594",
            "priority": "Reservas sem Formulário",
            "created_at": "10/04/2026 15:48:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/04/2026 15:48:44"
          },
          {
            "ticket_id": 14858,
            "ticket_number": "3514846",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "10/04/2026 15:55:56",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:55:57"
          },
          {
            "ticket_id": 14861,
            "ticket_number": "3514849",
            "title": "[Pedido IATA]  FOR Fortaleza →  VCP São Paulo Vira",
            "priority": "P2",
            "created_at": "10/04/2026 16:38:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:38:34"
          },
          {
            "ticket_id": 14862,
            "ticket_number": "3514850",
            "title": "CARMO/ALEXANDRINA MRS 20MAY LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:40:21",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:47:28"
          },
          {
            "ticket_id": 14863,
            "ticket_number": "3514851",
            "title": "ROMAO/JORGE MR 20MAY2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:41:21",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:42:47"
          },
          {
            "ticket_id": 14864,
            "ticket_number": "3514852",
            "title": "ROMAO/JORGE MR 20MAY LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:41:23",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:47:58"
          },
          {
            "ticket_id": 14878,
            "ticket_number": "3514866",
            "title": "Re:[## 34128 ##] FW: GBN-94228 - Um cliente enviou",
            "priority": "P2",
            "created_at": "10/04/2026 17:48:40",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 16:37:00"
          },
          {
            "ticket_id": 14896,
            "ticket_number": "3514884",
            "title": "[Pedido IATA] Porto → Barcelona - 2026-09-01 (10 p",
            "priority": "P2",
            "created_at": "10/04/2026 20:06:01",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 20:06:01"
          },
          {
            "ticket_id": 14901,
            "ticket_number": "3514889",
            "title": "[Suporte] TRP-2026-04154 / TRL-2026-06286 - Pagame",
            "priority": "P2",
            "created_at": "10/04/2026 21:47:08",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:47:08"
          },
          {
            "ticket_id": 14930,
            "ticket_number": "3514918",
            "title": "Ausência de duas Viagens na Solférias",
            "priority": "P2",
            "created_at": "11/04/2026 15:51:53",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 15:51:53"
          },
          {
            "ticket_id": 14949,
            "ticket_number": "3514937",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:03",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 40.95,
            "sla_met": false,
            "sla_breach_hours": 36.95,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:25:26"
          },
          {
            "ticket_id": 14956,
            "ticket_number": "3514944",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:16",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 41.23,
            "sla_met": false,
            "sla_breach_hours": 37.23,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:42:53"
          },
          {
            "ticket_id": 14975,
            "ticket_number": "3514963",
            "title": "[Pedido IATA] Lisboa (LIS) → Viena (VIE) - 2026-06",
            "priority": "P2",
            "created_at": "12/04/2026 20:06:04",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:06:04"
          },
          {
            "ticket_id": 15001,
            "ticket_number": "3514989",
            "title": "Fwd: Important: Flight change",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:16",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:21:17"
          },
          {
            "ticket_id": 15002,
            "ticket_number": "3514990",
            "title": "Z657RF – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "13/04/2026 09:21:19",
            "close_date": "2026-04-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.15,
            "sla_met": false,
            "sla_breach_hours": 0.9,
            "sla_name": "SLA P1",
            "first_response_at": "13/04/2026 10:30:57"
          },
          {
            "ticket_id": 15004,
            "ticket_number": "3514992",
            "title": "Z89IT2 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:25",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:21:19"
          },
          {
            "ticket_id": 15006,
            "ticket_number": "3514994",
            "title": "Reserva Aérea Z89IT2",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:30",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:42:42"
          },
          {
            "ticket_id": 15012,
            "ticket_number": "3515000",
            "title": "Z657RF – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "13/04/2026 09:21:42",
            "close_date": "2026-04-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.03,
            "sla_met": false,
            "sla_breach_hours": 0.78,
            "sla_name": "SLA P1",
            "first_response_at": "13/04/2026 10:24:08"
          },
          {
            "ticket_id": 15025,
            "ticket_number": "3515013",
            "title": "[## 36474 ##] GBN-115418 - Um cliente enviou uma n",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:02",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:43:20"
          },
          {
            "ticket_id": 15030,
            "ticket_number": "3515018",
            "title": "Fwd: easyJet número de referência da reserva: KBZG",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:17",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:11:17"
          },
          {
            "ticket_id": 15031,
            "ticket_number": "3515019",
            "title": "Fwd: easyJet número de referência da reserva: KCG4",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:19",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:11:19"
          },
          {
            "ticket_id": 15034,
            "ticket_number": "3515022",
            "title": "Aéreo - Confirmação de Emissão (BARROSO MARQUES\\NO",
            "priority": "P2",
            "created_at": "13/04/2026 10:40:58",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:01:16"
          },
          {
            "ticket_id": 15035,
            "ticket_number": "3515023",
            "title": "Aéreo - Confirmação de Emissão (BELINHO ARAUJO\\NAT",
            "priority": "P2",
            "created_at": "13/04/2026 10:41:01",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:01:38"
          },
          {
            "ticket_id": 15036,
            "ticket_number": "3515024",
            "title": "Aéreo - Confirmação de Emissão (FERREIRA LOUREIRO\\",
            "priority": "P2",
            "created_at": "13/04/2026 10:41:03",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:02:04"
          },
          {
            "ticket_id": 15037,
            "ticket_number": "3515025",
            "title": "Aéreo - Confirmação de Emissão (AMORIM GARRIDO\\MAR",
            "priority": "P2",
            "created_at": "13/04/2026 10:41:05",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:02:26"
          },
          {
            "ticket_id": 15038,
            "ticket_number": "3515026",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA ESTEVES\\AN",
            "priority": "P2",
            "created_at": "13/04/2026 10:41:07",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:02:59"
          },
          {
            "ticket_id": 15042,
            "ticket_number": "3515030",
            "title": "Comprovativo Transação  - CONSOLIDADOR BOOK SOFT L",
            "priority": "P2",
            "created_at": "13/04/2026 11:23:42",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 11:56:34"
          },
          {
            "ticket_id": 15043,
            "ticket_number": "3515031",
            "title": "Comprovativo Transação  - CONSOLIDADOR BOOK SOFT L",
            "priority": "P2",
            "created_at": "13/04/2026 11:23:44",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 12:00:17"
          },
          {
            "ticket_id": 15044,
            "ticket_number": "3515032",
            "title": "Comprovativo Transação  - CONSOLIDADOR BOOK SOFT L",
            "priority": "P2",
            "created_at": "13/04/2026 11:23:45",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 11:58:08"
          },
          {
            "ticket_id": 15048,
            "ticket_number": "3515036",
            "title": "Soltropico malta",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:34",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:48:34"
          },
          {
            "ticket_id": 15050,
            "ticket_number": "3515038",
            "title": "Re: [Cockpit] Plano de Pagamento Ajustado - Viagem",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:40",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:48:40"
          },
          {
            "ticket_id": 15051,
            "ticket_number": "3515039",
            "title": "RESERVA E CUSTOS DE ANIMAIS A VÔO EM QUESTÃO",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:43",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:17:02"
          },
          {
            "ticket_id": 15058,
            "ticket_number": "3515046",
            "title": "GBN-115277 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:13",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1077.07,
            "sla_met": false,
            "sla_breach_hours": 1073.07,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:04:43"
          },
          {
            "ticket_id": 15063,
            "ticket_number": "3515051",
            "title": "Fwd: Incidente de voo TTN-1259316145#96435136#T186",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:29",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:00:29"
          },
          {
            "ticket_id": 15100,
            "ticket_number": "3515088",
            "title": "ZNDX8I – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "13/04/2026 22:21:24",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 15.87,
            "sla_met": false,
            "sla_breach_hours": 15.62,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 14:14:09"
          },
          {
            "ticket_id": 15101,
            "ticket_number": "3515089",
            "title": "Reserva Aéreo [ERROR_AIR-D76F7C4FF2] - Erro Técnic",
            "priority": "P1",
            "created_at": "13/04/2026 22:21:26",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 10.63,
            "sla_met": false,
            "sla_breach_hours": 10.38,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 08:59:26"
          },
          {
            "ticket_id": 15104,
            "ticket_number": "3515092",
            "title": "Reserva Aérea ZNDX8I",
            "priority": "P1",
            "created_at": "13/04/2026 22:21:32",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 11.25,
            "sla_met": false,
            "sla_breach_hours": 11.0,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 09:36:37"
          },
          {
            "ticket_id": 15106,
            "ticket_number": "3515094",
            "title": "Reserva Aéreo [ERROR_AIR-BAE0D20804] - Erro Técnic",
            "priority": "P2",
            "created_at": "13/04/2026 22:21:40",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 11.23,
            "sla_met": false,
            "sla_breach_hours": 7.23,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:36:25"
          },
          {
            "ticket_id": 15124,
            "ticket_number": "3515112",
            "title": "ZNDX8I – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "14/04/2026 09:09:20",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.98,
            "sla_met": false,
            "sla_breach_hours": 4.73,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 14:08:33"
          },
          {
            "ticket_id": 15153,
            "ticket_number": "3515141",
            "title": "[Pedido IATA] Lisboa  → Bordeus - 2026-09-11 (20 p",
            "priority": "P2",
            "created_at": "14/04/2026 14:10:45",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 14:10:45"
          },
          {
            "ticket_id": 15154,
            "ticket_number": "3515142",
            "title": "Aéreo - Confirmação de Emissão (AMORIM GARRIDO\\CEL",
            "priority": "P2",
            "created_at": "14/04/2026 14:19:56",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:17:14"
          },
          {
            "ticket_id": 15155,
            "ticket_number": "3515143",
            "title": "Aéreo - Confirmação de Emissão (KRIVORUK MAEBARA\\A",
            "priority": "P2",
            "created_at": "14/04/2026 14:19:59",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:18:20"
          },
          {
            "ticket_id": 15156,
            "ticket_number": "3515144",
            "title": "Aéreo - Confirmação de Emissão (MAEBARA\\ANDRE KENJ",
            "priority": "P2",
            "created_at": "14/04/2026 14:20:02",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:18:42"
          },
          {
            "ticket_id": 15157,
            "ticket_number": "3515145",
            "title": "Aéreo - Confirmação de Emissão (KRIVORUK MAEBARA\\O",
            "priority": "P2",
            "created_at": "14/04/2026 14:20:05",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:19:08"
          },
          {
            "ticket_id": 15165,
            "ticket_number": "3515153",
            "title": "[Cancelamento Viagem] TRP-2026-02219 - Ana Rita Af",
            "priority": "P2",
            "created_at": "14/04/2026 15:49:24",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:49:24"
          },
          {
            "ticket_id": 15178,
            "ticket_number": "3515166",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "14/04/2026 16:32:50",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:51:28"
          },
          {
            "ticket_id": 15181,
            "ticket_number": "3515169",
            "title": "[Suporte] TRP-2026-04629 / TRL-2026-07117 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 16:55:27",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:55:28"
          },
          {
            "ticket_id": 15183,
            "ticket_number": "3515171",
            "title": "[Suporte] TRP-2026-03928 / TRL-2026-05960 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 17:10:07",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:10:07"
          },
          {
            "ticket_id": 15184,
            "ticket_number": "3515172",
            "title": "[Suporte] TRP-2026-03532 / TRL-2026-05378 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 17:11:11",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:11:12"
          },
          {
            "ticket_id": 15185,
            "ticket_number": "3515173",
            "title": "[Suporte] TRP-2026-03928 / TRL-2026-05960 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 17:20:34",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:20:34"
          },
          {
            "ticket_id": 15194,
            "ticket_number": "3515182",
            "title": "GBN-86600 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/04/2026 19:09:20",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 40.88,
            "sla_met": false,
            "sla_breach_hours": 36.88,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:03:10"
          },
          {
            "ticket_id": 15199,
            "ticket_number": "3515187",
            "title": "[Suporte] TRP-2026-03136 / TRL-2026-04827 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 19:10:03",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 19:10:04"
          },
          {
            "ticket_id": 15200,
            "ticket_number": "3515188",
            "title": "[Suporte] TRP-2026-03117 / TRL-2026-04799 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 19:10:50",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 19:10:50"
          },
          {
            "ticket_id": 15201,
            "ticket_number": "3515189",
            "title": "[Suporte] TRP-2026-03116 / TRL-2026-04797 - Altera",
            "priority": "P2",
            "created_at": "14/04/2026 19:11:23",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 19:11:24"
          },
          {
            "ticket_id": 15218,
            "ticket_number": "3515206",
            "title": "[Pedido IATA] Lisboa → Maiorca - 2026-05-09 (2 pax",
            "priority": "P2",
            "created_at": "14/04/2026 21:23:26",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:23:26"
          },
          {
            "ticket_id": 15221,
            "ticket_number": "3515209",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "14/04/2026 21:55:33",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:55:34"
          },
          {
            "ticket_id": 15224,
            "ticket_number": "3515212",
            "title": "[Suporte] TRP-2026-04590 / TRL-2026-07005 - Correc",
            "priority": "P2",
            "created_at": "14/04/2026 22:11:49",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 22:11:49"
          },
          {
            "ticket_id": 15230,
            "ticket_number": "3515218",
            "title": "[Pedido IATA] Porto  → Genebra - 2026-04-21 (1 pax",
            "priority": "P2",
            "created_at": "14/04/2026 22:50:36",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 22:50:37"
          },
          {
            "ticket_id": 15232,
            "ticket_number": "3515220",
            "title": "Reserva Aérea X7UMID",
            "priority": "P1",
            "created_at": "14/04/2026 22:56:43",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 10.83,
            "sla_met": false,
            "sla_breach_hours": 10.58,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 09:47:32"
          },
          {
            "ticket_id": 15233,
            "ticket_number": "3515221",
            "title": "Reserva Aérea X7UMID",
            "priority": "P1",
            "created_at": "14/04/2026 22:59:42",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 11.2,
            "sla_met": false,
            "sla_breach_hours": 10.95,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 10:12:36"
          },
          {
            "ticket_id": 15240,
            "ticket_number": "3515228",
            "title": "X7UMID – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "15/04/2026 10:08:30",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.33,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 10:28:49"
          },
          {
            "ticket_id": 15241,
            "ticket_number": "3515229",
            "title": "X7UMID – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "15/04/2026 10:08:32",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.65,
            "sla_met": false,
            "sla_breach_hours": 0.4,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 10:47:49"
          },
          {
            "ticket_id": 15249,
            "ticket_number": "3515237",
            "title": "Aéreo - Confirmação de Emissão (BARRETO GOMES DA C",
            "priority": "P1",
            "created_at": "15/04/2026 10:20:23",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.95,
            "sla_met": false,
            "sla_breach_hours": 0.7,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 11:18:05"
          },
          {
            "ticket_id": 15265,
            "ticket_number": "3515253",
            "title": "Reserva Aérea LA0457230SHYF",
            "priority": "P2",
            "created_at": "15/04/2026 12:04:46",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:04:40"
          },
          {
            "ticket_id": 15266,
            "ticket_number": "3515254",
            "title": "Fwd: Flight Time Change Notification-Ειδοποίηση Αλ",
            "priority": "P2",
            "created_at": "15/04/2026 12:04:47",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:04:47"
          },
          {
            "ticket_id": 15281,
            "ticket_number": "3515269",
            "title": "[Pedido IATA] porto → madrid, Acores e madeira (1 ",
            "priority": "P2",
            "created_at": "15/04/2026 15:48:49",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 15:48:50"
          },
          {
            "ticket_id": 15292,
            "ticket_number": "3515280",
            "title": "XKVT8A – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "15/04/2026 17:03:18",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 21:01:25"
          },
          {
            "ticket_id": 15294,
            "ticket_number": "3515282",
            "title": "Reserva Aérea XKVT8A",
            "priority": "P2",
            "created_at": "15/04/2026 17:03:22",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:54:18"
          },
          {
            "ticket_id": 15296,
            "ticket_number": "3515284",
            "title": "[Pedido IATA] Lisboa → Maputo - 2026-09-11 (1 pax)",
            "priority": "P2",
            "created_at": "15/04/2026 17:15:02",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:15:02"
          },
          {
            "ticket_id": 15307,
            "ticket_number": "3515295",
            "title": "[Pedido IATA] porto → Gran Canaria - 2026-07-15 (2",
            "priority": "P2",
            "created_at": "15/04/2026 19:12:21",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 19:12:21"
          },
          {
            "ticket_id": 15325,
            "ticket_number": "3515313",
            "title": "XKVT8A – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "16/04/2026 09:12:34",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:08:24"
          },
          {
            "ticket_id": 15335,
            "ticket_number": "3515323",
            "title": "Fwd: ***INFORMAÇÕES IMPORTANTES SOBRE SEU VOO A74S",
            "priority": "P2",
            "created_at": "16/04/2026 09:47:03",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:47:03"
          },
          {
            "ticket_id": 15337,
            "ticket_number": "3515325",
            "title": "Aéreo - Confirmação de Emissão (ZADILSKYY\\RUSLAN) ",
            "priority": "P2",
            "created_at": "16/04/2026 10:03:08",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:10:40"
          },
          {
            "ticket_id": 15345,
            "ticket_number": "3515333",
            "title": "Reserva Aérea XYAC2P",
            "priority": "P1",
            "created_at": "16/04/2026 11:52:57",
            "close_date": "2026-04-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "16/04/2026 12:02:21"
          },
          {
            "ticket_id": 15363,
            "ticket_number": "3515351",
            "title": "X7UMID – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "16/04/2026 14:26:51",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 17:58:17"
          },
          {
            "ticket_id": 15374,
            "ticket_number": "3515362",
            "title": "[Suporte] TRP-2026-03428 - Alteração da data de vi",
            "priority": "P2",
            "created_at": "16/04/2026 18:05:58",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 18:05:59"
          },
          {
            "ticket_id": 15382,
            "ticket_number": "3515370",
            "title": "[Pedido IATA] Lisboa → Fortaleza - 2026-08-04 (3 p",
            "priority": "P2",
            "created_at": "16/04/2026 20:02:42",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 20:02:42"
          },
          {
            "ticket_id": 15384,
            "ticket_number": "3515372",
            "title": "[Suporte] TRP-2026-03273 - adição de hóspedes",
            "priority": "P2",
            "created_at": "16/04/2026 21:18:12",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 21:18:13"
          },
          {
            "ticket_id": 15387,
            "ticket_number": "3515375",
            "title": "[Pedido IATA] BRU → BSB - 2026-12-19 (3 pax)",
            "priority": "P2",
            "created_at": "16/04/2026 21:36:22",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 21:36:22"
          },
          {
            "ticket_id": 15400,
            "ticket_number": "3515388",
            "title": "[Suporte] TRP-2026- 03264 / TRL-2026-05035 - Pagam",
            "priority": "P2",
            "created_at": "17/04/2026 08:40:51",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 08:40:51"
          },
          {
            "ticket_id": 15404,
            "ticket_number": "3515392",
            "title": "Fwd: UTI43S | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:34",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:34"
          },
          {
            "ticket_id": 15427,
            "ticket_number": "3515415",
            "title": "Fwd: UTI43S | Importante: Alterações ao controlo d",
            "priority": "P2",
            "created_at": "17/04/2026 10:14:47",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:14:47"
          },
          {
            "ticket_id": 15428,
            "ticket_number": "3515416",
            "title": "Cotação grupo",
            "priority": "P2",
            "created_at": "17/04/2026 10:22:11",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 01:20:02"
          },
          {
            "ticket_id": 15438,
            "ticket_number": "3515426",
            "title": "Reserva Aérea YH2T3P",
            "priority": "P2",
            "created_at": "17/04/2026 10:59:26",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:19:10"
          },
          {
            "ticket_id": 15440,
            "ticket_number": "3515428",
            "title": "YH2T3P – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "17/04/2026 11:06:27",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:59:03"
          },
          {
            "ticket_id": 15443,
            "ticket_number": "3515431",
            "title": "YH2T3P – Reconfirmação de Contactos",
            "priority": "P2",
            "created_at": "17/04/2026 11:16:32",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:58:52"
          },
          {
            "ticket_id": 15447,
            "ticket_number": "3515435",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (YH2",
            "priority": "P2",
            "created_at": "17/04/2026 12:01:39",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 12:20:26"
          },
          {
            "ticket_id": 15453,
            "ticket_number": "3515441",
            "title": "Reserva Aérea YIHCW6",
            "priority": "P2",
            "created_at": "17/04/2026 13:03:54",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 13:04:52"
          },
          {
            "ticket_id": 15457,
            "ticket_number": "3515445",
            "title": "RE: [Cockpit] Viagem TRP-2026-04757 - Excursões Dj",
            "priority": "P2",
            "created_at": "17/04/2026 13:49:57",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 13:49:57"
          },
          {
            "ticket_id": 15464,
            "ticket_number": "3515452",
            "title": "Re:[## 37639 ##] GBN-115676 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:27",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:40:36"
          },
          {
            "ticket_id": 15482,
            "ticket_number": "3515470",
            "title": "X7UMID – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "17/04/2026 16:18:31",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 19:17:02"
          },
          {
            "ticket_id": 15483,
            "ticket_number": "3515471",
            "title": "ZNDX8I – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "17/04/2026 16:18:33",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 19:17:42"
          },
          {
            "ticket_id": 15484,
            "ticket_number": "3515472",
            "title": "Z657RF – Alteração de Horário – Aceite – Bilhete R",
            "priority": "P2",
            "created_at": "17/04/2026 16:26:03",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 19:18:47"
          },
          {
            "ticket_id": 15486,
            "ticket_number": "3515474",
            "title": "[Suporte] TRP-2026-03134 - passageiro perdeu Carta",
            "priority": "P2",
            "created_at": "17/04/2026 17:16:12",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 17:16:12"
          },
          {
            "ticket_id": 15490,
            "ticket_number": "3515478",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "17/04/2026 18:11:18",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:11:19"
          },
          {
            "ticket_id": 15494,
            "ticket_number": "3515482",
            "title": "GBN-115717 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/04/2026 20:27:39",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 14:58:04"
          },
          {
            "ticket_id": 15498,
            "ticket_number": "3515486",
            "title": "[Pedido IATA] Porto → ilha Boa Vista, Cabo Verde -",
            "priority": "P2",
            "created_at": "17/04/2026 21:22:43",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 21:22:44"
          },
          {
            "ticket_id": 15507,
            "ticket_number": "3515495",
            "title": "Alteração horários aviação - Urgente",
            "priority": "P2",
            "created_at": "17/04/2026 22:20:41",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:20:41"
          },
          {
            "ticket_id": 15517,
            "ticket_number": "3515505",
            "title": "GBN-114877 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/04/2026 10:52:42",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 46.4,
            "sla_met": false,
            "sla_breach_hours": 42.4,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:16:52"
          },
          {
            "ticket_id": 15529,
            "ticket_number": "3515517",
            "title": "[Pedido IATA] LIS → SID - 2026-07-30 (8 pax)",
            "priority": "P2",
            "created_at": "18/04/2026 14:21:40",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 14:21:40"
          },
          {
            "ticket_id": 15531,
            "ticket_number": "3515519",
            "title": "Reserva Aérea Z36MPL",
            "priority": "P1",
            "created_at": "18/04/2026 15:06:38",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 41.97,
            "sla_met": false,
            "sla_breach_hours": 41.72,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 09:05:02"
          },
          {
            "ticket_id": 15539,
            "ticket_number": "3515527",
            "title": "[Pedido IATA] Porto (OPO) → Olbia (OLB) e Cagliari",
            "priority": "P2",
            "created_at": "18/04/2026 18:09:38",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 18:09:38"
          },
          {
            "ticket_id": 15546,
            "ticket_number": "3515534",
            "title": "ZG6DL4 – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "20/04/2026 09:06:31",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.72,
            "sla_met": false,
            "sla_breach_hours": 0.47,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 09:49:41"
          },
          {
            "ticket_id": 15557,
            "ticket_number": "3515545",
            "title": "GMQ78G – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:58",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:04:45"
          },
          {
            "ticket_id": 15558,
            "ticket_number": "3515546",
            "title": "ZKHVHD – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:00",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:04:45"
          },
          {
            "ticket_id": 15560,
            "ticket_number": "3515548",
            "title": "Reserva Aérea GMQ78G",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:04",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:07:32"
          },
          {
            "ticket_id": 15562,
            "ticket_number": "3515550",
            "title": "FMGGL9 – Alteração de horario/nº de voo",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:08",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:55:33"
          },
          {
            "ticket_id": 15563,
            "ticket_number": "3515551",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZKE",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:10",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:06:21"
          },
          {
            "ticket_id": 15566,
            "ticket_number": "3515554",
            "title": "Reserva Aérea ZKEH6Z",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:15",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:05:03"
          },
          {
            "ticket_id": 15567,
            "ticket_number": "3515555",
            "title": "Reserva Aérea ZKHVHD",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:17",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:06:37"
          },
          {
            "ticket_id": 15572,
            "ticket_number": "3515560",
            "title": "ZG6DL4 – Reconfirmação de Contactos",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:31",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:49:07"
          },
          {
            "ticket_id": 15576,
            "ticket_number": "3515564",
            "title": "ZG6DL4 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:56",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:49:25"
          },
          {
            "ticket_id": 15578,
            "ticket_number": "3515566",
            "title": "Consolidador - reserva ZG6DL4",
            "priority": "P1",
            "created_at": "20/04/2026 09:08:00",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 12:31:59"
          },
          {
            "ticket_id": 15582,
            "ticket_number": "3515570",
            "title": "Reserva Aérea ZG6DL4",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:07",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:50:04"
          },
          {
            "ticket_id": 15593,
            "ticket_number": "3515581",
            "title": "Aéreo - Confirmação de Emissão (SOARES DOS SANTOS\\",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:26",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:52:13"
          },
          {
            "ticket_id": 15594,
            "ticket_number": "3515582",
            "title": "ZG6DL4 – Reserva com segmentos inativos por falta ",
            "priority": "P2",
            "created_at": "20/04/2026 09:12:25",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:47:08"
          },
          {
            "ticket_id": 15608,
            "ticket_number": "3515596",
            "title": "Carregamento Carteira Digital - RI 258005306",
            "priority": "P2",
            "created_at": "20/04/2026 10:32:18",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:32:18"
          },
          {
            "ticket_id": 15624,
            "ticket_number": "3515612",
            "title": "[Pedido IATA] Lisboa → Marselha - 2026-09-02 (12 p",
            "priority": "P2",
            "created_at": "20/04/2026 11:59:09",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:59:09"
          },
          {
            "ticket_id": 15625,
            "ticket_number": "3515613",
            "title": "[Pedido IATA] Lisboa → Marselha - 2026-09-02 (12 p",
            "priority": "P2",
            "created_at": "20/04/2026 12:01:48",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:01:49"
          },
          {
            "ticket_id": 15642,
            "ticket_number": "3515630",
            "title": "Aéreo - Confirmação de Emissão (DOS REIS MADEIRA\\B",
            "priority": "P2",
            "created_at": "20/04/2026 13:41:37",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:49:25"
          },
          {
            "ticket_id": 15643,
            "ticket_number": "3515631",
            "title": "Reserva Aérea LA0451343UIVM",
            "priority": "P2",
            "created_at": "20/04/2026 13:41:40",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:49:34"
          },
          {
            "ticket_id": 15665,
            "ticket_number": "3515653",
            "title": "GBN-96785 - vouchers",
            "priority": "P2",
            "created_at": "20/04/2026 15:43:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 18:45:38"
          },
          {
            "ticket_id": 15675,
            "ticket_number": "3515663",
            "title": "[Pedido IATA] lisboa → Marraquexe - 2026-09-04 (2 ",
            "priority": "P3",
            "created_at": "20/04/2026 17:07:50",
            "close_date": "2026-04-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/04/2026 17:07:50"
          },
          {
            "ticket_id": 15678,
            "ticket_number": "3515666",
            "title": "\"GBN-92792 - Your request has been received\"",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:26",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 14:49:23"
          },
          {
            "ticket_id": 15694,
            "ticket_number": "3515682",
            "title": "Re: [Cockpit] Viagem TRP-2026-04062 - Aventura Fam",
            "priority": "P2",
            "created_at": "20/04/2026 20:12:29",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 20:12:29"
          },
          {
            "ticket_id": 15721,
            "ticket_number": "3515709",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "21/04/2026 11:09:31",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 11:09:31"
          },
          {
            "ticket_id": 15741,
            "ticket_number": "3515729",
            "title": "[Pedido IATA] lisboa → SGN - 2026-11-06 (5 pax)",
            "priority": "P2",
            "created_at": "21/04/2026 12:41:28",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:41:28"
          },
          {
            "ticket_id": 15780,
            "ticket_number": "3515768",
            "title": "XNZDD7 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "21/04/2026 19:36:24",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 15.97,
            "sla_met": false,
            "sla_breach_hours": 11.97,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:35:04"
          },
          {
            "ticket_id": 15781,
            "ticket_number": "3515769",
            "title": "Reserva Aérea XNZDD7",
            "priority": "P2",
            "created_at": "21/04/2026 19:36:26",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 18.18,
            "sla_met": false,
            "sla_breach_hours": 14.18,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 13:47:58"
          },
          {
            "ticket_id": 15789,
            "ticket_number": "3515777",
            "title": "[Pedido IATA] Lisboa → Maputo - 2026-09-11 (1 pax)",
            "priority": "P2",
            "created_at": "21/04/2026 21:55:00",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 21:55:00"
          },
          {
            "ticket_id": 15841,
            "ticket_number": "3515829",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "22/04/2026 14:14:11",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 14:14:12"
          },
          {
            "ticket_id": 15845,
            "ticket_number": "3515833",
            "title": "Fwd: Reserva 1269433845 TTN-1269433845#99702163#T1",
            "priority": "P2",
            "created_at": "22/04/2026 14:48:43",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:02:39"
          },
          {
            "ticket_id": 15906,
            "ticket_number": "3515894",
            "title": "FMGGL9 – Alteração de horario/nº de voo - ALERTA",
            "priority": "P1",
            "created_at": "22/04/2026 22:43:22",
            "close_date": "2026-04-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 10.32,
            "sla_met": false,
            "sla_breach_hours": 10.07,
            "sla_name": "SLA P1",
            "first_response_at": "23/04/2026 09:03:15"
          },
          {
            "ticket_id": 15911,
            "ticket_number": "3515899",
            "title": "[Pedido IATA] Porto  → Roma (FCO) - 2026-10-26 (2 ",
            "priority": "P2",
            "created_at": "23/04/2026 01:56:27",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 01:56:27"
          },
          {
            "ticket_id": 15912,
            "ticket_number": "3515900",
            "title": "[Suporte] TRP-2026-04572 / TRL-2026-06939 - Checki",
            "priority": "P2",
            "created_at": "23/04/2026 07:51:29",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:32:12"
          },
          {
            "ticket_id": 15915,
            "ticket_number": "3515903",
            "title": "YA8E69 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:21",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:00:27"
          },
          {
            "ticket_id": 15917,
            "ticket_number": "3515905",
            "title": "YA8E69 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:28",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 13:02:23"
          },
          {
            "ticket_id": 15918,
            "ticket_number": "3515906",
            "title": "YA8E69 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:30",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:00:46"
          },
          {
            "ticket_id": 15921,
            "ticket_number": "3515909",
            "title": "Reserva Aérea YA8E69",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:37",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:00:54"
          },
          {
            "ticket_id": 15922,
            "ticket_number": "3515910",
            "title": "Your World Cup season starts with one simple step",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:40",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:58:15"
          },
          {
            "ticket_id": 15923,
            "ticket_number": "3515911",
            "title": "Your World Cup season starts with one simple step",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:43",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:58:41"
          },
          {
            "ticket_id": 15925,
            "ticket_number": "3515913",
            "title": "NOVO INCIDENTE: Amadeus Ticketing & Document Serve",
            "priority": "P2",
            "created_at": "23/04/2026 10:02:18",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:24:30"
          },
          {
            "ticket_id": 15943,
            "ticket_number": "3515931",
            "title": "Re: [Cockpit] Viagem TRP-2026-00594 - MPB • Sandra",
            "priority": "P2",
            "created_at": "23/04/2026 12:39:58",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:39:58"
          },
          {
            "ticket_id": 15951,
            "ticket_number": "3515939",
            "title": "Fwd: Informações da reserva TTN-1269433845#9970216",
            "priority": "P2",
            "created_at": "23/04/2026 14:20:41",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 14:20:42"
          },
          {
            "ticket_id": 15952,
            "ticket_number": "3515940",
            "title": "[Pedido IATA] Lisboa → São Tomé - 2026-09-29 (1 pa",
            "priority": "P2",
            "created_at": "23/04/2026 14:44:21",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 14:44:21"
          },
          {
            "ticket_id": 15991,
            "ticket_number": "3515979",
            "title": "Fwd: Important: Flight change",
            "priority": "P2",
            "created_at": "23/04/2026 19:02:17",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 19:02:18"
          },
          {
            "ticket_id": 15992,
            "ticket_number": "3515980",
            "title": "NOVO INCIDENTE: Aplicações múltiplas Amadeus: Temp",
            "priority": "P2",
            "created_at": "23/04/2026 19:07:45",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:07:32"
          },
          {
            "ticket_id": 15995,
            "ticket_number": "3515983",
            "title": "RECUPERADO: Aplicações múltiplas Amadeus: Tempos l",
            "priority": "P2",
            "created_at": "23/04/2026 20:38:22",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 12.48,
            "sla_met": false,
            "sla_breach_hours": 8.48,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:07:40"
          },
          {
            "ticket_id": 16004,
            "ticket_number": "3515992",
            "title": "[Suporte] TRP-2026-04286 - Estado da reserva",
            "priority": "P2",
            "created_at": "23/04/2026 22:19:40",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 22:19:40"
          },
          {
            "ticket_id": 16027,
            "ticket_number": "3516015",
            "title": "[Pedido IATA] Lisboa → Funchal - 2026-04-24 (1 pax",
            "priority": "P2",
            "created_at": "24/04/2026 09:52:44",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:52:44"
          },
          {
            "ticket_id": 16038,
            "ticket_number": "3516026",
            "title": "[Pedido IATA] Madrid → Lisboa - 2026-06-27 (2 pax)",
            "priority": "P2",
            "created_at": "24/04/2026 12:01:47",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:01:48"
          },
          {
            "ticket_id": 16048,
            "ticket_number": "3516036",
            "title": "Confirmação de reserva – Ref PP147197, Sra. RUTE I",
            "priority": "P1",
            "created_at": "24/04/2026 13:26:13",
            "close_date": "2026-04-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.45,
            "sla_met": false,
            "sla_breach_hours": 3.2,
            "sla_name": "SLA P1",
            "first_response_at": "24/04/2026 16:54:06"
          },
          {
            "ticket_id": 16066,
            "ticket_number": "3516054",
            "title": "[Pedido IATA] São Tomé (TMS) → Lisboa - 2026-08-05",
            "priority": "P2",
            "created_at": "24/04/2026 17:11:05",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:11:05"
          },
          {
            "ticket_id": 16070,
            "ticket_number": "3516058",
            "title": "CLEMENTE ALEXANDRE DE ALMEIDA/CARLA SUSANA MRS 29S",
            "priority": "P2",
            "created_at": "24/04/2026 17:49:23",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:40:17"
          },
          {
            "ticket_id": 16087,
            "ticket_number": "3516075",
            "title": "Reserva Aérea Z8HWUH",
            "priority": "P2",
            "created_at": "24/04/2026 20:28:16",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:18:08"
          },
          {
            "ticket_id": 16090,
            "ticket_number": "3516078",
            "title": "Z8HWUH – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "24/04/2026 20:43:12",
            "close_date": "2026-04-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 62.45,
            "sla_met": false,
            "sla_breach_hours": 62.2,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 11:10:42"
          },
          {
            "ticket_id": 16092,
            "ticket_number": "3516080",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (YA8",
            "priority": "P2",
            "created_at": "24/04/2026 20:43:17",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:17:45"
          },
          {
            "ticket_id": 16109,
            "ticket_number": "3516097",
            "title": "[Pedido IATA] Lisboa → Bogota - 2026-08-14 (2 pax)",
            "priority": "P2",
            "created_at": "25/04/2026 17:01:28",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/04/2026 17:01:28"
          },
          {
            "ticket_id": 16117,
            "ticket_number": "3516105",
            "title": "Z8HWUH – Reserva com prazo de emissão expirado",
            "priority": "P1",
            "created_at": "27/04/2026 09:08:43",
            "close_date": "2026-04-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.03,
            "sla_met": false,
            "sla_breach_hours": 1.78,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 11:11:00"
          },
          {
            "ticket_id": 16144,
            "ticket_number": "3516132",
            "title": "Fwd: Vueling flight to Barcelona – What to expect",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:22",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:11:22"
          },
          {
            "ticket_id": 16166,
            "ticket_number": "3516154",
            "title": "Z8HWUH – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "27/04/2026 09:13:52",
            "close_date": "2026-04-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.93,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 11:10:52"
          },
          {
            "ticket_id": 16176,
            "ticket_number": "3516164",
            "title": "SOUSA BRAGA/PATRICIA CARLA MRS 29SEP LIS TMS",
            "priority": "P2",
            "created_at": "27/04/2026 09:17:16",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:29:55"
          },
          {
            "ticket_id": 16177,
            "ticket_number": "3516165",
            "title": "CLEMENTE ALEXANDRE DE ALMEIDA/CARLA SUSANA MRS 29S",
            "priority": "P2",
            "created_at": "27/04/2026 09:17:18",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:30:09"
          },
          {
            "ticket_id": 16178,
            "ticket_number": "3516166",
            "title": "CLEMENTE ALEXANDRE DE ALMEIDA/CARLA SUSANA MRS 29S",
            "priority": "P2",
            "created_at": "27/04/2026 09:17:19",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:31:42"
          },
          {
            "ticket_id": 16180,
            "ticket_number": "3516168",
            "title": "[Pedido IATA] Lisboa → Rio de Janeiro  - 2026-11-2",
            "priority": "P2",
            "created_at": "27/04/2026 10:02:23",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:02:24"
          },
          {
            "ticket_id": 16181,
            "ticket_number": "3516169",
            "title": "[Pedido IATA] Lisboa → Rio de Janeiro  - 2026-11-2",
            "priority": "P2",
            "created_at": "27/04/2026 10:03:15",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:03:15"
          },
          {
            "ticket_id": 16208,
            "ticket_number": "3516196",
            "title": "Aéreo - Confirmação de Emissão (DANIEL DE CARVALHO",
            "priority": "P2",
            "created_at": "27/04/2026 11:44:52",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:20:39"
          },
          {
            "ticket_id": 16211,
            "ticket_number": "3516199",
            "title": "RE: Pagamento compensatório loc 604620765",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:02",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:27:49"
          },
          {
            "ticket_id": 16213,
            "ticket_number": "3516201",
            "title": "Aéreo - Confirmação de Emissão (FIGUEIREDO CENTENO",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:06",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:20:11"
          },
          {
            "ticket_id": 16214,
            "ticket_number": "3516202",
            "title": "Aéreo - Confirmação de Emissão (CAVALCANTI\\ANDRE) ",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:09",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:22:52"
          },
          {
            "ticket_id": 16215,
            "ticket_number": "3516203",
            "title": "Aéreo - Confirmação de Emissão (DANIEL DE CARVALHO",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:11",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:24:37"
          },
          {
            "ticket_id": 16216,
            "ticket_number": "3516204",
            "title": "Aéreo - Confirmação de Emissão (BAPTISTA AFONSO\\JO",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:14",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:19:46"
          },
          {
            "ticket_id": 16218,
            "ticket_number": "3516206",
            "title": "Fwd: easyJet número de referência da reserva: KCJG",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:57",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:45:57"
          },
          {
            "ticket_id": 16219,
            "ticket_number": "3516207",
            "title": "Fwd: easyJet número de referência da reserva: KCJJ",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:58",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:45:58"
          },
          {
            "ticket_id": 16228,
            "ticket_number": "3516216",
            "title": "Fwd: Important: Flight change",
            "priority": "P2",
            "created_at": "27/04/2026 13:04:09",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:04:10"
          },
          {
            "ticket_id": 16240,
            "ticket_number": "3516228",
            "title": "XMXZRL – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "27/04/2026 16:05:32",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 20:04:45"
          },
          {
            "ticket_id": 16241,
            "ticket_number": "3516229",
            "title": "Reserva Aérea XMXZRL",
            "priority": "P2",
            "created_at": "27/04/2026 16:05:34",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 17:46:09"
          },
          {
            "ticket_id": 16242,
            "ticket_number": "3516230",
            "title": "[Pedido IATA] OSAKA (ITAMI) → ISHIGAKI - 2026-08-0",
            "priority": "P2",
            "created_at": "27/04/2026 16:29:28",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 16:29:28"
          },
          {
            "ticket_id": 16243,
            "ticket_number": "3516231",
            "title": "[Pedido IATA] ISHIGAKI → OKINAWA (NAHA) - 2026-08-",
            "priority": "P2",
            "created_at": "27/04/2026 16:30:49",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 16:30:49"
          },
          {
            "ticket_id": 16249,
            "ticket_number": "3516237",
            "title": "TRP-2026-04897 - Comissão a negativo",
            "priority": "P2",
            "created_at": "27/04/2026 17:22:56",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 17:22:56"
          },
          {
            "ticket_id": 16261,
            "ticket_number": "3516249",
            "title": "Fwd: easyJet número de referência da reserva: KCJV",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:32",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:05:32"
          },
          {
            "ticket_id": 16304,
            "ticket_number": "3516292",
            "title": "Fwd: Important: Flight change",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:11",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:12"
          },
          {
            "ticket_id": 16311,
            "ticket_number": "3516299",
            "title": "RE: [Cockpit] Plano de Pagamento Ajustado - Viagem",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:34",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:34"
          },
          {
            "ticket_id": 16338,
            "ticket_number": "3516326",
            "title": "[Pedido IATA] Viena → Porto - 2026-05-08 (1 pax)",
            "priority": "P2",
            "created_at": "28/04/2026 12:14:58",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:14:58"
          },
          {
            "ticket_id": 16339,
            "ticket_number": "3516327",
            "title": "[Pedido IATA] Viena → Porto - 2026-05-10 (1 pax)",
            "priority": "P2",
            "created_at": "28/04/2026 12:23:39",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:23:39"
          },
          {
            "ticket_id": 16345,
            "ticket_number": "3516333",
            "title": "Re: [Cockpit] Viagem TRP-2026-03618 - PRT • Joana ",
            "priority": "P2",
            "created_at": "28/04/2026 13:21:00",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:21:00"
          },
          {
            "ticket_id": 16346,
            "ticket_number": "3516334",
            "title": "Viagens _Cokpit",
            "priority": "P2",
            "created_at": "28/04/2026 13:21:02",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:21:02"
          },
          {
            "ticket_id": 16362,
            "ticket_number": "3516350",
            "title": "[Suporte] TRP-2026-04495 - tem um valor devolvido ",
            "priority": "P2",
            "created_at": "28/04/2026 15:36:37",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 15:36:38"
          },
          {
            "ticket_id": 16382,
            "ticket_number": "3516370",
            "title": "Fwd: Flight AC1884 to Cancún has a new departure t",
            "priority": "P2",
            "created_at": "28/04/2026 19:01:56",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 19:01:57"
          },
          {
            "ticket_id": 16387,
            "ticket_number": "3516375",
            "title": "[Pedido IATA] lisboa  → olbia - 2026-07-25 (3 pax)",
            "priority": "P2",
            "created_at": "28/04/2026 20:31:38",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:31:39"
          },
          {
            "ticket_id": 16388,
            "ticket_number": "3516376",
            "title": "[Pedido IATA] Porto → Suíça  - 2026-06-19 (1 pax)",
            "priority": "P2",
            "created_at": "28/04/2026 20:47:42",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:47:43"
          },
          {
            "ticket_id": 16396,
            "ticket_number": "3516384",
            "title": "Re: [Cockpit] Viagem TRP-2026-04903 - viagem de ca",
            "priority": "P2",
            "created_at": "28/04/2026 21:45:19",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 21:45:19"
          },
          {
            "ticket_id": 16399,
            "ticket_number": "3516387",
            "title": "[Pedido IATA] Porto → Funchal - 2026-07-13 (2 pax)",
            "priority": "P2",
            "created_at": "28/04/2026 22:22:19",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 22:22:19"
          },
          {
            "ticket_id": 16436,
            "ticket_number": "3516424",
            "title": "[Pedido IATA] lisboa → PDL- TER - 2026-05-31 (2 pa",
            "priority": "P2",
            "created_at": "29/04/2026 10:55:25",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:55:25"
          },
          {
            "ticket_id": 16459,
            "ticket_number": "3516447",
            "title": "Re: Alteração de voo XXOW2Y",
            "priority": "P2",
            "created_at": "29/04/2026 13:22:44",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 13:22:45"
          },
          {
            "ticket_id": 16462,
            "ticket_number": "3516450",
            "title": "[Pedido IATA] Barcelona → Lisboa - 2026-06-10 (1 p",
            "priority": "P2",
            "created_at": "29/04/2026 13:38:16",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 13:38:16"
          },
          {
            "ticket_id": 16497,
            "ticket_number": "3516485",
            "title": "CARMO/ALEXANDRINA MRS 23MAY LIS TMS",
            "priority": "P2",
            "created_at": "29/04/2026 16:25:52",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:28:05"
          },
          {
            "ticket_id": 16498,
            "ticket_number": "3516486",
            "title": "ROMAO/JORGE MR 23MAY LIS TMS",
            "priority": "P2",
            "created_at": "29/04/2026 16:25:54",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:28:12"
          },
          {
            "ticket_id": 16499,
            "ticket_number": "3516487",
            "title": "CARMO/ALEXANDRINA MRS 23MAY2026 LIS TMS",
            "priority": "P2",
            "created_at": "29/04/2026 16:25:55",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:27:36"
          },
          {
            "ticket_id": 16502,
            "ticket_number": "3516490",
            "title": "RECUPERADO: NDC-X: Interrupção não programada: Air",
            "priority": "P2",
            "created_at": "29/04/2026 16:37:33",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 18:27:21"
          },
          {
            "ticket_id": 16503,
            "ticket_number": "3516491",
            "title": "Fwd: Verifique os dados do seu voo para Amsterdao",
            "priority": "P2",
            "created_at": "29/04/2026 16:37:34",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:37:35"
          },
          {
            "ticket_id": 16523,
            "ticket_number": "3516511",
            "title": "Reserva Aérea YQITVB",
            "priority": "P2",
            "created_at": "29/04/2026 21:24:23",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 12.83,
            "sla_met": false,
            "sla_breach_hours": 8.83,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 10:14:31"
          },
          {
            "ticket_id": 16539,
            "ticket_number": "3516527",
            "title": "XMXZRL – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "30/04/2026 09:14:14",
            "close_date": "2026-04-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "30/04/2026 09:26:31"
          },
          {
            "ticket_id": 16540,
            "ticket_number": "3516528",
            "title": "Grupo: GR-25835B178F",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:16",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 4.02,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:16:14"
          },
          {
            "ticket_id": 16541,
            "ticket_number": "3516529",
            "title": "Grupo: GR-ADCAA56D7C",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:18",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 4.03,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:16:19"
          },
          {
            "ticket_id": 16542,
            "ticket_number": "3516530",
            "title": "Grupo GR-25835B178F",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:20",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 09:24:05"
          },
          {
            "ticket_id": 16545,
            "ticket_number": "3516533",
            "title": "Grupo GR-ADCAA56D7C",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:30",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 09:24:46"
          },
          {
            "ticket_id": 16567,
            "ticket_number": "3516555",
            "title": "[Pedido IATA] Zanzibar (znz) → Lisboa  - 2027-02-0",
            "priority": "P2",
            "created_at": "30/04/2026 12:44:11",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 12:42:07"
          },
          {
            "ticket_id": 16568,
            "ticket_number": "3516556",
            "title": "Aéreo - Confirmação de Emissão (MACHADO RODRIGUES ",
            "priority": "P2",
            "created_at": "30/04/2026 13:15:51",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:35:15"
          },
          {
            "ticket_id": 16572,
            "ticket_number": "3516560",
            "title": "Aéreo - Confirmação de Emissão (CUSTODIO CALDINHAS",
            "priority": "P2",
            "created_at": "30/04/2026 13:16:03",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:35:37"
          },
          {
            "ticket_id": 16587,
            "ticket_number": "3516575",
            "title": "Fwd: Recibo 148544-2026/PTR da reserva OZG4VP",
            "priority": "P2",
            "created_at": "30/04/2026 14:19:06",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 14:19:06"
          },
          {
            "ticket_id": 16589,
            "ticket_number": "3516577",
            "title": "Reserva Aérea Z5GPWQ",
            "priority": "P1",
            "created_at": "30/04/2026 14:19:19",
            "close_date": "2026-05-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 435.87,
            "sla_met": false,
            "sla_breach_hours": 435.62,
            "sla_name": "SLA P1",
            "first_response_at": "18/05/2026 18:11:32"
          },
          {
            "ticket_id": 16648,
            "ticket_number": "3516636",
            "title": "Aéreo - Confirmação de Emissão (RODRIGUES DOS SANT",
            "priority": "P2",
            "created_at": "30/04/2026 19:02:05",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 38.98,
            "sla_met": false,
            "sla_breach_hours": 34.98,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:01:54"
          },
          {
            "ticket_id": 16657,
            "ticket_number": "3516645",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "30/04/2026 19:05:56",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 87.52,
            "sla_met": false,
            "sla_breach_hours": 83.52,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:37:10"
          },
          {
            "ticket_id": 16672,
            "ticket_number": "3516660",
            "title": "[Pedido IATA] Lisboa → Manchester - 2026-05-15 (1 ",
            "priority": "P2",
            "created_at": "30/04/2026 22:20:06",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 22:20:06"
          },
          {
            "ticket_id": 16753,
            "ticket_number": "3516741",
            "title": "Aéreo - Confirmação de Emissão (LOPES DE ARAUJO\\JO",
            "priority": "P2",
            "created_at": "02/05/2026 15:16:51",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 39.8,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:05:29"
          },
          {
            "ticket_id": 16755,
            "ticket_number": "3516743",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (YQI",
            "priority": "P2",
            "created_at": "02/05/2026 15:16:56",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 39.83,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:07:15"
          },
          {
            "ticket_id": 16758,
            "ticket_number": "3516746",
            "title": "Bom dia Joao Manuel Lopes De Araujo: Bilhete e inf",
            "priority": "P2",
            "created_at": "02/05/2026 15:17:08",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:06:50"
          },
          {
            "ticket_id": 16773,
            "ticket_number": "3516761",
            "title": "[Suporte] TRP-2026-04122 / TRL-2026-06233 - Pedido",
            "priority": "P2",
            "created_at": "03/05/2026 09:48:05",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 15:22:50"
          },
          {
            "ticket_id": 16826,
            "ticket_number": "3516814",
            "title": "FUSWXC | Alerta de viagem para o Reino Unido",
            "priority": "P2",
            "created_at": "04/05/2026 09:13:53",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:01:59"
          },
          {
            "ticket_id": 16828,
            "ticket_number": "3516816",
            "title": "Reserva Aérea X9DWQA",
            "priority": "P1",
            "created_at": "04/05/2026 09:13:57",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 49.18,
            "sla_met": false,
            "sla_breach_hours": 48.93,
            "sla_name": "SLA P1",
            "first_response_at": "06/05/2026 10:25:27"
          },
          {
            "ticket_id": 16837,
            "ticket_number": "3516825",
            "title": "Enc: Sua franquia de bagagem de mão, Reserva: VQ66",
            "priority": "P2",
            "created_at": "04/05/2026 09:31:18",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:31:18"
          },
          {
            "ticket_id": 16871,
            "ticket_number": "3516859",
            "title": "[Pedido IATA] lisboa → Ilha do sal  - 2026-08-01 (",
            "priority": "P2",
            "created_at": "04/05/2026 11:41:42",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:41:42"
          },
          {
            "ticket_id": 16876,
            "ticket_number": "3516864",
            "title": "Viagens pendentes de validação",
            "priority": "P2",
            "created_at": "04/05/2026 12:07:29",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:07:30"
          },
          {
            "ticket_id": 16907,
            "ticket_number": "3516895",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "04/05/2026 15:41:07",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:41:08"
          },
          {
            "ticket_id": 16983,
            "ticket_number": "3516971",
            "title": "Fwd: ECPTCGQG01 Group Request Confirmation",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:19",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:26:20"
          },
          {
            "ticket_id": 16984,
            "ticket_number": "3516972",
            "title": "Fwd: Booking Confirmation VQ66GH",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:22",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:26:23"
          },
          {
            "ticket_id": 16986,
            "ticket_number": "3516974",
            "title": "Fwd: Your departure time for your flight EW602 has",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:27",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:26:28"
          },
          {
            "ticket_id": 16999,
            "ticket_number": "3516987",
            "title": "TORRES ANTUNES/PAULA CRISTINA MRS 08MAY LIS GVA",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:26",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:07:08"
          },
          {
            "ticket_id": 17000,
            "ticket_number": "3516988",
            "title": "SIMAO TOME/ANTONIO MR 08MAY LIS GVA",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:28",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:06:21"
          },
          {
            "ticket_id": 17004,
            "ticket_number": "3516992",
            "title": "SIMAO TOME/ANTONIO MR 08MAY LIS GVA",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:36",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:06:53"
          },
          {
            "ticket_id": 17005,
            "ticket_number": "3516993",
            "title": "TORRES ANTUNES/PAULA CRISTINA MRS 08MAY2026 LIS GV",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:38",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:07:35"
          },
          {
            "ticket_id": 17006,
            "ticket_number": "3516994",
            "title": "SIMAO TOME/ANTONIO MR 08MAY2026 LIS GVA",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:08:06"
          },
          {
            "ticket_id": 17024,
            "ticket_number": "3517012",
            "title": "Reserva Aérea YNRYIJ",
            "priority": "P1",
            "created_at": "05/05/2026 15:01:02",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 22:22:59"
          },
          {
            "ticket_id": 17025,
            "ticket_number": "3517013",
            "title": "YNQERI - Reserva cancelada pela companhia aérea",
            "priority": "P1",
            "created_at": "05/05/2026 15:01:04",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 22:22:32"
          },
          {
            "ticket_id": 17026,
            "ticket_number": "3517014",
            "title": "YNRYIJ - Reserva cancelada pela companhia aérea",
            "priority": "P1",
            "created_at": "05/05/2026 15:01:06",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 22:22:42"
          },
          {
            "ticket_id": 17027,
            "ticket_number": "3517015",
            "title": "YNGZXX – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "05/05/2026 15:01:09",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 19.38,
            "sla_met": false,
            "sla_breach_hours": 15.38,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:24:19"
          },
          {
            "ticket_id": 17030,
            "ticket_number": "3517018",
            "title": "Reserva Aérea YNQERI",
            "priority": "P1",
            "created_at": "05/05/2026 15:01:24",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 19.37,
            "sla_met": false,
            "sla_breach_hours": 19.12,
            "sla_name": "SLA P1",
            "first_response_at": "06/05/2026 10:23:43"
          },
          {
            "ticket_id": 17031,
            "ticket_number": "3517019",
            "title": "Reserva Aérea YNGZXX",
            "priority": "P1",
            "created_at": "05/05/2026 15:01:27",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.28,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 15:18:35"
          },
          {
            "ticket_id": 17036,
            "ticket_number": "3517024",
            "title": "FMGGL9 – Alteração de Horário - Aceite",
            "priority": "P2",
            "created_at": "05/05/2026 15:24:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 19:20:33"
          },
          {
            "ticket_id": 17037,
            "ticket_number": "3517025",
            "title": "Re: [Cockpit] Viagem TRP-2026-04989 - Rafaela Ferr",
            "priority": "P2",
            "created_at": "05/05/2026 15:24:06",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 15:24:06"
          },
          {
            "ticket_id": 17044,
            "ticket_number": "3517032",
            "title": "Aéreo - Confirmação de Emissão (DA SILVA ARAUJO\\NE",
            "priority": "P2",
            "created_at": "05/05/2026 16:38:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 17.78,
            "sla_met": false,
            "sla_breach_hours": 13.78,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:26:24"
          },
          {
            "ticket_id": 17064,
            "ticket_number": "3517052",
            "title": "[Pedido IATA] Lisboa → São Paulo - 2026-06-26 (1 p",
            "priority": "P2",
            "created_at": "05/05/2026 21:43:42",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 21:43:42"
          },
          {
            "ticket_id": 17066,
            "ticket_number": "3517054",
            "title": "[Pedido IATA] Lisboa → São Paulo - 2026-06-26 (1 p",
            "priority": "P2",
            "created_at": "05/05/2026 21:49:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 21:49:59"
          },
          {
            "ticket_id": 17111,
            "ticket_number": "3517099",
            "title": "Aéreo - Confirmação de Emissão (RODRIGUES LEAO\\ANA",
            "priority": "P2",
            "created_at": "06/05/2026 11:12:53",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:19:11"
          },
          {
            "ticket_id": 17112,
            "ticket_number": "3517100",
            "title": "Aéreo - Confirmação de Emissão (MORETO COBRADO\\MIG",
            "priority": "P2",
            "created_at": "06/05/2026 11:12:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:22:42"
          },
          {
            "ticket_id": 17113,
            "ticket_number": "3517101",
            "title": "Aéreo - Confirmação de Emissão (DUARTE R COBRADO\\L",
            "priority": "P2",
            "created_at": "06/05/2026 11:12:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:19:37"
          },
          {
            "ticket_id": 17114,
            "ticket_number": "3517102",
            "title": "Aéreo - Confirmação de Emissão (LEAO A G TEIXEIRA\\",
            "priority": "P2",
            "created_at": "06/05/2026 11:13:02",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:20:05"
          },
          {
            "ticket_id": 17115,
            "ticket_number": "3517103",
            "title": "Aéreo - Confirmação de Emissão (MORETO COBRADO\\CAR",
            "priority": "P2",
            "created_at": "06/05/2026 11:13:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:23:13"
          },
          {
            "ticket_id": 17126,
            "ticket_number": "3517114",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "06/05/2026 12:42:40",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:29:24"
          },
          {
            "ticket_id": 17132,
            "ticket_number": "3517120",
            "title": "Fwd: easyJet número de referência da reserva: KCLG",
            "priority": "P2",
            "created_at": "06/05/2026 13:44:21",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 13:44:21"
          },
          {
            "ticket_id": 17145,
            "ticket_number": "3517133",
            "title": "[Pedido IATA] Lisboa (LIS) → loret del mar - 2026-",
            "priority": "P2",
            "created_at": "06/05/2026 15:12:35",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 15:12:36"
          },
          {
            "ticket_id": 17146,
            "ticket_number": "3517134",
            "title": "[Pedido IATA] Lisboa (LIS) → barcelona - 2026-06-1",
            "priority": "P2",
            "created_at": "06/05/2026 15:57:28",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 15:57:29"
          },
          {
            "ticket_id": 17153,
            "ticket_number": "3517141",
            "title": "Reserva Aérea Z7JCC2",
            "priority": "P1",
            "created_at": "06/05/2026 16:06:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/05/2026 16:20:34"
          },
          {
            "ticket_id": 17154,
            "ticket_number": "3517142",
            "title": "[Pedido IATA] porto → ilha do sal - 2026-07-02 (6 ",
            "priority": "P2",
            "created_at": "06/05/2026 16:06:54",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:06:55"
          },
          {
            "ticket_id": 17158,
            "ticket_number": "3517146",
            "title": "[Pedido IATA] Lisboa (LIS) → madrid - 2026-06-19 (",
            "priority": "P2",
            "created_at": "06/05/2026 16:48:31",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:48:31"
          },
          {
            "ticket_id": 17160,
            "ticket_number": "3517148",
            "title": "Z8GFAW - Reserva cancelada pela companhia aérea",
            "priority": "P2",
            "created_at": "06/05/2026 16:52:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 17:56:01"
          },
          {
            "ticket_id": 17164,
            "ticket_number": "3517152",
            "title": "Reserva Aérea Z8GFAW",
            "priority": "P2",
            "created_at": "06/05/2026 16:53:15",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 17:56:37"
          },
          {
            "ticket_id": 17180,
            "ticket_number": "3517168",
            "title": "[Pedido IATA] Lisboa (LIS) → Maiorca - 2026-07-22 ",
            "priority": "P2",
            "created_at": "06/05/2026 19:24:28",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 19:24:28"
          },
          {
            "ticket_id": 17181,
            "ticket_number": "3517169",
            "title": "[Pedido IATA] lisboa → ilha do sal - 2026-11-01 (3",
            "priority": "P2",
            "created_at": "06/05/2026 19:59:38",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 19:59:38"
          },
          {
            "ticket_id": 17186,
            "ticket_number": "3517174",
            "title": "[Suporte] TRP-2026-04146 / TRL-2026-06277 - Pagame",
            "priority": "P2",
            "created_at": "06/05/2026 21:26:26",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 21:26:27"
          },
          {
            "ticket_id": 17200,
            "ticket_number": "3517188",
            "title": "Fwd: easyJet número de referência da reserva: KCLJ",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:42",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 21:43:42"
          },
          {
            "ticket_id": 17201,
            "ticket_number": "3517189",
            "title": "GBN-117699 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:44",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 518.02,
            "sla_met": false,
            "sla_breach_hours": 514.02,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:45:38"
          },
          {
            "ticket_id": 17206,
            "ticket_number": "3517194",
            "title": "Grupo: GR-56E6E47D2F",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 44.07,
            "sla_met": false,
            "sla_breach_hours": 40.07,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 19:07:20"
          },
          {
            "ticket_id": 17237,
            "ticket_number": "3517225",
            "title": "Fwd: Wizz Air Important Message",
            "priority": "P2",
            "created_at": "07/05/2026 09:54:18",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:54:18"
          },
          {
            "ticket_id": 17243,
            "ticket_number": "3517231",
            "title": "Fwd: Your request ECPTCGQG01 has been changed",
            "priority": "P2",
            "created_at": "07/05/2026 09:54:37",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:54:38"
          },
          {
            "ticket_id": 17247,
            "ticket_number": "3517235",
            "title": "[Pedido IATA] Lisboa (LIS) → windhoek - 2026-11-07",
            "priority": "P2",
            "created_at": "07/05/2026 10:34:16",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:34:17"
          },
          {
            "ticket_id": 17248,
            "ticket_number": "3517236",
            "title": "Grupo: GR-3E2BEFB8EB",
            "priority": "P2",
            "created_at": "07/05/2026 10:56:30",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:44:55"
          },
          {
            "ticket_id": 17262,
            "ticket_number": "3517250",
            "title": "Fwd: Your request ECPTCGQG01 has been changed",
            "priority": "P2",
            "created_at": "07/05/2026 11:30:42",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:30:42"
          },
          {
            "ticket_id": 17264,
            "ticket_number": "3517252",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "07/05/2026 11:51:18",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:51:19"
          },
          {
            "ticket_id": 17280,
            "ticket_number": "3517268",
            "title": "Fwd: Y77NHK | Extras para a tua viagem para Malta",
            "priority": "P2",
            "created_at": "07/05/2026 14:49:22",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:49:23"
          },
          {
            "ticket_id": 17295,
            "ticket_number": "3517283",
            "title": "Informações da reserva TTN-1235214221#101145500#T1",
            "priority": "P2",
            "created_at": "07/05/2026 16:01:33",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:21:56"
          },
          {
            "ticket_id": 17297,
            "ticket_number": "3517285",
            "title": "FUSWXC | Alterações à sua reserva?",
            "priority": "P2",
            "created_at": "07/05/2026 16:01:39",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 16:07:44"
          },
          {
            "ticket_id": 17312,
            "ticket_number": "3517300",
            "title": "[Pedido IATA] Lisboa → Fortaleza - 2026-07-11 (2 p",
            "priority": "P2",
            "created_at": "07/05/2026 19:15:47",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 19:15:48"
          },
          {
            "ticket_id": 17316,
            "ticket_number": "3517304",
            "title": "Grupo: GR-18A6C80DEE",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:09",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 18.77,
            "sla_met": false,
            "sla_breach_hours": 14.77,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 14:19:02"
          },
          {
            "ticket_id": 17322,
            "ticket_number": "3517310",
            "title": "Grupo: GR-BCFC77A9EC",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:23",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 18.77,
            "sla_met": false,
            "sla_breach_hours": 14.77,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 14:19:04"
          },
          {
            "ticket_id": 17376,
            "ticket_number": "3517364",
            "title": "RECUPERADO: Amadeus Electronic Ticketing: IR 38436",
            "priority": "P2",
            "created_at": "08/05/2026 09:03:22",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:34:04"
          },
          {
            "ticket_id": 17377,
            "ticket_number": "3517365",
            "title": "NOVO INCIDENTE: Amadeus Electronic Ticketing: IR 3",
            "priority": "P2",
            "created_at": "08/05/2026 09:03:26",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:34:10"
          },
          {
            "ticket_id": 17384,
            "ticket_number": "3517372",
            "title": "DAS NEVES MOREIRA/MARIA LEONOR MRS 11JUL2026 LIS F",
            "priority": "P2",
            "created_at": "08/05/2026 13:43:32",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:41:15"
          },
          {
            "ticket_id": 17385,
            "ticket_number": "3517373",
            "title": "ALMEIDA BRAS/ANDREIA FILIPA MRS 11JUL2026 LIS FOR",
            "priority": "P2",
            "created_at": "08/05/2026 13:43:35",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:41:35"
          },
          {
            "ticket_id": 17386,
            "ticket_number": "3517374",
            "title": "DAS NEVES MOREIRA/MARIA LEONOR MRS 11JUL LIS FOR",
            "priority": "P2",
            "created_at": "08/05/2026 13:43:38",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:42:02"
          },
          {
            "ticket_id": 17387,
            "ticket_number": "3517375",
            "title": "ALMEIDA BRAS/ANDREIA FILIPA MRS 11JUL LIS FOR",
            "priority": "P2",
            "created_at": "08/05/2026 13:43:41",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:42:12"
          },
          {
            "ticket_id": 17413,
            "ticket_number": "3517401",
            "title": "Re:[## 40430 ##] GBN-117699 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:48",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:37:49"
          },
          {
            "ticket_id": 17488,
            "ticket_number": "3517476",
            "title": "Grupo: GR-36ACD38FF2",
            "priority": "P2",
            "created_at": "09/05/2026 12:58:51",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 44.53,
            "sla_met": false,
            "sla_breach_hours": 40.53,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:31:50"
          },
          {
            "ticket_id": 17494,
            "ticket_number": "3517482",
            "title": "troca de nomes na Sololé",
            "priority": "P2",
            "created_at": "09/05/2026 15:35:45",
            "close_date": "2026-05-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:35:45"
          },
          {
            "ticket_id": 17504,
            "ticket_number": "3517492",
            "title": "[Pedido IATA] zurique → luxemburgo - 2026-07-02 (1",
            "priority": "P2",
            "created_at": "09/05/2026 18:12:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 18:12:20"
          },
          {
            "ticket_id": 17525,
            "ticket_number": "3517513",
            "title": "factura Numero 241001117",
            "priority": "P2",
            "created_at": "11/05/2026 09:06:14",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:06:14"
          },
          {
            "ticket_id": 17528,
            "ticket_number": "3517516",
            "title": "F3TY5A | Atualização importante para todos os pass",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:04",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:02:46"
          },
          {
            "ticket_id": 17567,
            "ticket_number": "3517555",
            "title": "Reserva Aéreo [ERROR_AIR-F50D5E3251] - Erro Técnic",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:28",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:30:07"
          },
          {
            "ticket_id": 17568,
            "ticket_number": "3517556",
            "title": "Reserva Aéreo [ERROR_AIR-3037F91790] - Erro Técnic",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:29",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:30:16"
          },
          {
            "ticket_id": 17571,
            "ticket_number": "3517559",
            "title": "Reserva Aéreo [ERROR_AIR-6DBC45E183] - Erro Técnic",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:39",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:30:26"
          },
          {
            "ticket_id": 17593,
            "ticket_number": "3517581",
            "title": "DGI GBN-101091",
            "priority": "P2",
            "created_at": "11/05/2026 10:51:58",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 15:33:22"
          },
          {
            "ticket_id": 17598,
            "ticket_number": "3517586",
            "title": "SANTOS RUAS/VITOR MANUEL MR 13MAY2026 LIS RAI",
            "priority": "P2",
            "created_at": "11/05/2026 11:16:56",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:51:04"
          },
          {
            "ticket_id": 17602,
            "ticket_number": "3517590",
            "title": "SANTOS RUAS/VITOR MANUEL MR 13MAY2026 LIS RAI",
            "priority": "P2",
            "created_at": "11/05/2026 11:28:32",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:52:22"
          },
          {
            "ticket_id": 17675,
            "ticket_number": "3517663",
            "title": "Grupo: GR-605111B0E2",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:56",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 44.2,
            "sla_met": false,
            "sla_breach_hours": 40.2,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:30:37"
          },
          {
            "ticket_id": 17682,
            "ticket_number": "3517670",
            "title": "Reserva cancelada com localizador: 4198644",
            "priority": "P2",
            "created_at": "11/05/2026 21:18:00",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:53:20"
          },
          {
            "ticket_id": 17733,
            "ticket_number": "3517721",
            "title": "Fwd: easyJet número de referência da reserva: KCLJ",
            "priority": "P2",
            "created_at": "12/05/2026 12:54:51",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:54:51"
          },
          {
            "ticket_id": 17787,
            "ticket_number": "3517775",
            "title": "Fwd: RE: [Cockpit] Viagem TRP-2026-04032 - Senegal",
            "priority": "P1",
            "created_at": "12/05/2026 16:04:36",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 16:01:05"
          },
          {
            "ticket_id": 17803,
            "ticket_number": "3517791",
            "title": "Re: [Cockpit] Viagem TRP-2026-03346 - SSA • Silvia",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:31",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:31"
          },
          {
            "ticket_id": 17807,
            "ticket_number": "3517795",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:58",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:59"
          },
          {
            "ticket_id": 17816,
            "ticket_number": "3517804",
            "title": "ZAMT6Y – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "12/05/2026 17:54:24",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:41:05"
          },
          {
            "ticket_id": 17817,
            "ticket_number": "3517805",
            "title": "GVVY0N – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "12/05/2026 17:54:26",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:41:05"
          },
          {
            "ticket_id": 17818,
            "ticket_number": "3517806",
            "title": "Reserva Aérea ZAMT6Y",
            "priority": "P2",
            "created_at": "12/05/2026 17:54:28",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:41:05"
          },
          {
            "ticket_id": 17819,
            "ticket_number": "3517807",
            "title": "Reserva Aérea GVVY0N",
            "priority": "P2",
            "created_at": "12/05/2026 17:54:38",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:41:05"
          },
          {
            "ticket_id": 17851,
            "ticket_number": "3517839",
            "title": "13/05/2026 TRF CRED SEPA+ DE Uma Fam lia em Viagem",
            "priority": "P2",
            "created_at": "13/05/2026 09:24:50",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 10:54:10"
          },
          {
            "ticket_id": 17858,
            "ticket_number": "3517846",
            "title": "RE: [Cockpit] Viagem TRP-2026-02926 - DJE • Ana Ma",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:11",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 09:25:11"
          },
          {
            "ticket_id": 17865,
            "ticket_number": "3517853",
            "title": "GVVY0N – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:22:08"
          },
          {
            "ticket_id": 17866,
            "ticket_number": "3517854",
            "title": "ZAMT6Y – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:53",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:22:09"
          },
          {
            "ticket_id": 17879,
            "ticket_number": "3517867",
            "title": "ZMUBTE – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/05/2026 10:48:37",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 14:42:16"
          },
          {
            "ticket_id": 17882,
            "ticket_number": "3517870",
            "title": "Reserva Aérea ZN98UR",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:11",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.08,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:23:16"
          },
          {
            "ticket_id": 17884,
            "ticket_number": "3517872",
            "title": "GW30M9 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:14",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.08,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:23:23"
          },
          {
            "ticket_id": 17886,
            "ticket_number": "3517874",
            "title": "ZN98UR – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:18",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.08,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:23:32"
          },
          {
            "ticket_id": 17889,
            "ticket_number": "3517877",
            "title": "TRP-2026-03335 e TRP-2026-03336",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:23",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 11:18:23"
          },
          {
            "ticket_id": 17891,
            "ticket_number": "3517879",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZMU",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:27",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.1,
            "sla_met": false,
            "sla_breach_hours": 0.1,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:24:43"
          },
          {
            "ticket_id": 17892,
            "ticket_number": "3517880",
            "title": "Reserva Aérea GW30M9",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:29",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.07,
            "sla_met": false,
            "sla_breach_hours": 0.07,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:23:01"
          },
          {
            "ticket_id": 17894,
            "ticket_number": "3517882",
            "title": "Reserva Aérea ZMUBTE",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:34",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.1,
            "sla_met": false,
            "sla_breach_hours": 0.1,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:24:53"
          },
          {
            "ticket_id": 17898,
            "ticket_number": "3517886",
            "title": "Informação de reserva - SPT002601614835",
            "priority": "P2",
            "created_at": "13/05/2026 12:39:06",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 33.72,
            "sla_met": false,
            "sla_breach_hours": 29.72,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:22:36"
          },
          {
            "ticket_id": 17903,
            "ticket_number": "3517891",
            "title": "Aéreo - Confirmação de Emissão (CARDOSO\\NUNO) - ZN",
            "priority": "P2",
            "created_at": "13/05/2026 12:48:08",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:42:30"
          },
          {
            "ticket_id": 17904,
            "ticket_number": "3517892",
            "title": "Aéreo - Confirmação de Emissão (MELLO\\PEDRO) - ZN9",
            "priority": "P2",
            "created_at": "13/05/2026 12:48:11",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:42:30"
          },
          {
            "ticket_id": 17906,
            "ticket_number": "3517894",
            "title": "Aéreo - Confirmação de Emissão (ROMAO\\JORGE) - ZAM",
            "priority": "P2",
            "created_at": "13/05/2026 13:08:09",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:02:34"
          },
          {
            "ticket_id": 17907,
            "ticket_number": "3517895",
            "title": "Aéreo - Confirmação de Emissão (SILVA\\DANILO) - ZA",
            "priority": "P2",
            "created_at": "13/05/2026 13:08:11",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:02:34"
          },
          {
            "ticket_id": 17908,
            "ticket_number": "3517896",
            "title": "entrou ontem a noite um pagamento na reservav para",
            "priority": "P2",
            "created_at": "13/05/2026 13:08:15",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:08:16"
          },
          {
            "ticket_id": 17911,
            "ticket_number": "3517899",
            "title": "Documentos em falta",
            "priority": "P2",
            "created_at": "13/05/2026 13:49:43",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:49:43"
          },
          {
            "ticket_id": 17913,
            "ticket_number": "3517901",
            "title": "ZOQJ9K – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/05/2026 13:49:52",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:23:48"
          },
          {
            "ticket_id": 17914,
            "ticket_number": "3517902",
            "title": "Reserva Aérea ZOQJ9K",
            "priority": "P2",
            "created_at": "13/05/2026 13:49:55",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:24:23"
          },
          {
            "ticket_id": 17927,
            "ticket_number": "3517915",
            "title": "Reserva Aérea ZOQJ9K",
            "priority": "P2",
            "created_at": "13/05/2026 15:07:23",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:22:45"
          },
          {
            "ticket_id": 17930,
            "ticket_number": "3517918",
            "title": "Aéreo - Confirmação de Emissão (GONCALVES\\RICARDO)",
            "priority": "P2",
            "created_at": "13/05/2026 15:07:35",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:49:10"
          },
          {
            "ticket_id": 17958,
            "ticket_number": "3517946",
            "title": "Voos AC/Inês",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:03",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 18:38:03"
          },
          {
            "ticket_id": 17974,
            "ticket_number": "3517962",
            "title": "Faturas Pendentes: FA 2147912827",
            "priority": "P1",
            "created_at": "13/05/2026 20:11:04",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.72,
            "sla_met": false,
            "sla_breach_hours": 2.47,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 22:54:49"
          },
          {
            "ticket_id": 17986,
            "ticket_number": "3517974",
            "title": "[Pedido IATA] lisboa → VCE - 2026-05-30 (2 pax)",
            "priority": "P2",
            "created_at": "13/05/2026 22:35:13",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 22:35:13"
          },
          {
            "ticket_id": 17992,
            "ticket_number": "3517980",
            "title": "ZVH5N4 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "13/05/2026 23:00:05",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 302.98,
            "sla_met": false,
            "sla_breach_hours": 298.98,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 13:59:43"
          },
          {
            "ticket_id": 17994,
            "ticket_number": "3517982",
            "title": "Reserva Aérea ZVH5N4",
            "priority": "P2",
            "created_at": "13/05/2026 23:00:15",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 16.33,
            "sla_met": false,
            "sla_breach_hours": 12.33,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:20:23"
          },
          {
            "ticket_id": 18005,
            "ticket_number": "3517993",
            "title": "Fwd: Your request ECPTCGQG01 has been changed",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:18",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:18"
          },
          {
            "ticket_id": 18020,
            "ticket_number": "3518008",
            "title": "GVVY0N – Reserva com prazo de emissão expirado",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:36",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:21:27"
          },
          {
            "ticket_id": 18028,
            "ticket_number": "3518016",
            "title": "GW30M9 – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:24",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18035,
            "ticket_number": "3518023",
            "title": "Re: TRP-2026-03795 - Viagem de grupo VIETNAM LAOS ",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:22",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:54:22"
          },
          {
            "ticket_id": 18048,
            "ticket_number": "3518036",
            "title": "X7MVLL – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "14/05/2026 13:32:10",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:24:33"
          },
          {
            "ticket_id": 18053,
            "ticket_number": "3518041",
            "title": "Reserva Aérea X7MVLL",
            "priority": "P2",
            "created_at": "14/05/2026 13:32:24",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:20:57"
          },
          {
            "ticket_id": 18058,
            "ticket_number": "3518046",
            "title": "[Pedido IATA] Porto  → Lisboa - 2026-06-28 (9 pax)",
            "priority": "P2",
            "created_at": "14/05/2026 14:32:10",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:32:11"
          },
          {
            "ticket_id": 18059,
            "ticket_number": "3518047",
            "title": "Re: [Cockpit] Viagem TRP-2026-02579 - NRT • Bruno ",
            "priority": "P2",
            "created_at": "14/05/2026 15:04:52",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:04:52"
          },
          {
            "ticket_id": 18061,
            "ticket_number": "3518049",
            "title": "Fwd: Devolução - INÊS MARTINHO",
            "priority": "P2",
            "created_at": "14/05/2026 15:04:56",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:04:57"
          },
          {
            "ticket_id": 18078,
            "ticket_number": "3518066",
            "title": "[Cancelamento Serviço] TRP-2026-02752 / TRL-2026-0",
            "priority": "P1",
            "created_at": "14/05/2026 16:52:37",
            "close_date": "2026-05-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/05/2026 16:52:37"
          },
          {
            "ticket_id": 18092,
            "ticket_number": "3518080",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (GW3",
            "priority": "P2",
            "created_at": "14/05/2026 18:13:18",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:04:45"
          },
          {
            "ticket_id": 18114,
            "ticket_number": "3518102",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "15/05/2026 09:07:49",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 09:07:49"
          },
          {
            "ticket_id": 18117,
            "ticket_number": "3518105",
            "title": "XF7IQX – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "15/05/2026 09:07:54",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:01:05"
          },
          {
            "ticket_id": 18118,
            "ticket_number": "3518106",
            "title": "ZVH5N4 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "15/05/2026 09:07:56",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:01:05"
          },
          {
            "ticket_id": 18120,
            "ticket_number": "3518108",
            "title": "Reserva Aérea XF7IQX",
            "priority": "P2",
            "created_at": "15/05/2026 09:08:00",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:01:05"
          },
          {
            "ticket_id": 18155,
            "ticket_number": "3518143",
            "title": "XQWBIJ – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "15/05/2026 16:08:56",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:55"
          },
          {
            "ticket_id": 18156,
            "ticket_number": "3518144",
            "title": "XR52VX – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "15/05/2026 16:08:58",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:59"
          },
          {
            "ticket_id": 18159,
            "ticket_number": "3518147",
            "title": "Reserva Aérea XQWBIJ",
            "priority": "P2",
            "created_at": "15/05/2026 16:09:03",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:00:51"
          },
          {
            "ticket_id": 18160,
            "ticket_number": "3518148",
            "title": "Reserva Aérea XR52VX",
            "priority": "P2",
            "created_at": "15/05/2026 16:09:06",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:59"
          },
          {
            "ticket_id": 18161,
            "ticket_number": "3518149",
            "title": "Aéreo - Confirmação de Emissão (ESTEVES\\TOMAS) - X",
            "priority": "P2",
            "created_at": "15/05/2026 16:09:08",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:59"
          },
          {
            "ticket_id": 18162,
            "ticket_number": "3518150",
            "title": "Aéreo - Confirmação de Emissão (PINHEIRO\\CATIA) - ",
            "priority": "P2",
            "created_at": "15/05/2026 16:09:11",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:59"
          },
          {
            "ticket_id": 18163,
            "ticket_number": "3518151",
            "title": "Aéreo - Confirmação de Emissão (ESTEVES\\MARCIO) - ",
            "priority": "P2",
            "created_at": "15/05/2026 16:09:14",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:01:59"
          },
          {
            "ticket_id": 18172,
            "ticket_number": "3518160",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZVH",
            "priority": "P2",
            "created_at": "15/05/2026 16:35:06",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:05:14"
          },
          {
            "ticket_id": 18173,
            "ticket_number": "3518161",
            "title": "Aéreo - Confirmação de Emissão (FITAS\\RUBEN) - XR5",
            "priority": "P2",
            "created_at": "15/05/2026 16:45:09",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:05:43"
          },
          {
            "ticket_id": 18175,
            "ticket_number": "3518163",
            "title": "Aéreo - Confirmação de Emissão (DECARVALHOPALETA\\M",
            "priority": "P2",
            "created_at": "15/05/2026 16:45:18",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:08:10"
          },
          {
            "ticket_id": 18192,
            "ticket_number": "3518180",
            "title": "Recebeu uma nova mensagem TTN-1249892858#101971997",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:15",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:30:47"
          },
          {
            "ticket_id": 18246,
            "ticket_number": "3518234",
            "title": "[Pedido IATA] lisboa → Natal - 2026-06-18 (2 pax)",
            "priority": "P2",
            "created_at": "17/05/2026 16:54:07",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/05/2026 16:54:07"
          },
          {
            "ticket_id": 18250,
            "ticket_number": "3518238",
            "title": "[Pedido IATA] lisboa → Malta - 2026-08-23 (5 pax)",
            "priority": "P2",
            "created_at": "18/05/2026 07:15:24",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 07:15:25"
          },
          {
            "ticket_id": 18251,
            "ticket_number": "3518239",
            "title": "[Suporte] TRP-2026-03321 - Faturação errada",
            "priority": "P2",
            "created_at": "18/05/2026 08:45:37",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 08:45:37"
          },
          {
            "ticket_id": 18331,
            "ticket_number": "3518319",
            "title": "TRP-2026-03795 - Viagem de grupo VIETNAM LAOS E CA",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:32",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:15:33"
          },
          {
            "ticket_id": 18335,
            "ticket_number": "3518323",
            "title": "[Pedido IATA] porto → Gran Canaria - 2026-07-16 (2",
            "priority": "P2",
            "created_at": "18/05/2026 10:29:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:29:44"
          },
          {
            "ticket_id": 18355,
            "ticket_number": "3518343",
            "title": "RE: [Cockpit] Viagem TRP-2026-05153 - RENATA REIS ",
            "priority": "P2",
            "created_at": "18/05/2026 12:57:19",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:57:20"
          },
          {
            "ticket_id": 18360,
            "ticket_number": "3518348",
            "title": "Re: [Cockpit] Plano de Pagamento Ajustado - Viagem",
            "priority": "P2",
            "created_at": "18/05/2026 15:57:46",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 15:57:47"
          },
          {
            "ticket_id": 18369,
            "ticket_number": "3518357",
            "title": "Informações sobre a sua reserva TTN-1249892858#102",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:15",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 18:15:49"
          },
          {
            "ticket_id": 18396,
            "ticket_number": "3518384",
            "title": "RE: [Cockpit] Viagem TRP-2026-03580 - BVC • Olga M",
            "priority": "P2",
            "created_at": "18/05/2026 17:56:51",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:56:51"
          },
          {
            "ticket_id": 18397,
            "ticket_number": "3518385",
            "title": "RE: [Cockpit] Viagem TRP-2026-05157 - Ferias Famil",
            "priority": "P2",
            "created_at": "18/05/2026 17:56:53",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:56:53"
          },
          {
            "ticket_id": 18398,
            "ticket_number": "3518386",
            "title": "RE: [Cockpit] Viagem TRP-2026-05158 - Viagem Famil",
            "priority": "P2",
            "created_at": "18/05/2026 17:56:55",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:56:55"
          },
          {
            "ticket_id": 18504,
            "ticket_number": "3518492",
            "title": "[Pedido IATA] OPO → VCP - 2026-09-07 (1 pax)",
            "priority": "P1",
            "created_at": "19/05/2026 17:35:03",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 17:35:03"
          },
          {
            "ticket_id": 18515,
            "ticket_number": "3518503",
            "title": "Faturacao",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:43",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:43"
          },
          {
            "ticket_id": 18524,
            "ticket_number": "3518512",
            "title": "Re: [Cockpit] Viagem TRP-2026-03346 - SSA • Silvia",
            "priority": "P2",
            "created_at": "19/05/2026 19:38:05",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:38:06"
          },
          {
            "ticket_id": 18536,
            "ticket_number": "3518524",
            "title": "GY34GJ – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "19/05/2026 22:46:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 35.05,
            "sla_met": false,
            "sla_breach_hours": 34.8,
            "sla_name": "SLA P1",
            "first_response_at": "21/05/2026 09:49:42"
          },
          {
            "ticket_id": 18538,
            "ticket_number": "3518526",
            "title": "Re: [Cockpit] Viagem TRP-2026-05141 - Disneyland P",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:14",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:14"
          },
          {
            "ticket_id": 18542,
            "ticket_number": "3518530",
            "title": "Reserva Aérea GY34GJ",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:25",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:41:28"
          },
          {
            "ticket_id": 18559,
            "ticket_number": "3518547",
            "title": "GY34GJ – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "20/05/2026 09:02:49",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18602,
            "ticket_number": "3518590",
            "title": "Fwd: PNR information: XO4OCB",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:27",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:28"
          },
          {
            "ticket_id": 18682,
            "ticket_number": "3518670",
            "title": "Fwd: Condicionantes operacionais na SATA Air Açore",
            "priority": "P2",
            "created_at": "20/05/2026 22:29:56",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 22:29:57"
          },
          {
            "ticket_id": 18701,
            "ticket_number": "3518689",
            "title": "GY34GJ – Reserva com prazo de emissão expirado",
            "priority": "P2",
            "created_at": "21/05/2026 09:46:24",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 12:40:10"
          },
          {
            "ticket_id": 18708,
            "ticket_number": "3518696",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (GY3",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:03",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 12:40:32"
          },
          {
            "ticket_id": 18723,
            "ticket_number": "3518711",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "21/05/2026 11:38:15",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 11:38:16"
          },
          {
            "ticket_id": 18724,
            "ticket_number": "3518712",
            "title": "[Suporte] TRP-2026-04269 / TRL-2026-06463 - Pedido",
            "priority": "P2",
            "created_at": "21/05/2026 12:42:53",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 12:42:53"
          },
          {
            "ticket_id": 18727,
            "ticket_number": "3518715",
            "title": "XQ5VSI – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "21/05/2026 13:11:52",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/05/2026 13:21:02"
          },
          {
            "ticket_id": 18752,
            "ticket_number": "3518740",
            "title": "Re: [Cockpit] Viagem TRP-2026-05201 - Agadir - 3_F",
            "priority": "P2",
            "created_at": "21/05/2026 14:42:48",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:42:48"
          },
          {
            "ticket_id": 18766,
            "ticket_number": "3518754",
            "title": "XS3ZIP – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:02",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:13:25"
          },
          {
            "ticket_id": 18768,
            "ticket_number": "3518756",
            "title": "Reserva Aérea XS3ZIP",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:08",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:13:43"
          },
          {
            "ticket_id": 18774,
            "ticket_number": "3518762",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (XS3",
            "priority": "P2",
            "created_at": "21/05/2026 16:54:13",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:14:05"
          },
          {
            "ticket_id": 18812,
            "ticket_number": "3518800",
            "title": "Re: [Cockpit] Viagem TRP-2026-04996 - Milao",
            "priority": "P2",
            "created_at": "21/05/2026 20:36:44",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 20:36:44"
          },
          {
            "ticket_id": 18848,
            "ticket_number": "3518836",
            "title": "XQ5VSI – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "22/05/2026 09:08:04",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 73.18,
            "sla_met": false,
            "sla_breach_hours": 72.93,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 10:19:39"
          },
          {
            "ticket_id": 18878,
            "ticket_number": "3518866",
            "title": "viagem",
            "priority": "P2",
            "created_at": "22/05/2026 12:55:51",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 12:55:51"
          },
          {
            "ticket_id": 18879,
            "ticket_number": "3518867",
            "title": "viagem",
            "priority": "P2",
            "created_at": "22/05/2026 12:55:53",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 12:55:53"
          },
          {
            "ticket_id": 18929,
            "ticket_number": "3518917",
            "title": "[Pedido IATA] Lisboa → Ponta Delgada - 2026-09-10 ",
            "priority": "P2",
            "created_at": "22/05/2026 20:03:19",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 20:03:20"
          },
          {
            "ticket_id": 19002,
            "ticket_number": "3518990",
            "title": "Re: [Cockpit] Viagem TRP-2026-05041 - ferias famil",
            "priority": "P1",
            "created_at": "25/05/2026 09:04:11",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 09:04:11"
          },
          {
            "ticket_id": 19042,
            "ticket_number": "3519030",
            "title": "[Pedido IATA] Lisboa (LIS) → Assuncion (ASU) - 202",
            "priority": "P2",
            "created_at": "25/05/2026 10:48:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:48:37"
          },
          {
            "ticket_id": 19043,
            "ticket_number": "3519031",
            "title": "[Pedido IATA] Lisboa (LIS) → Assuncion (ASU) - 202",
            "priority": "P2",
            "created_at": "25/05/2026 10:49:21",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:49:21"
          },
          {
            "ticket_id": 19046,
            "ticket_number": "3519034",
            "title": "Faturação TRP-2026-02332​,",
            "priority": "P2",
            "created_at": "25/05/2026 11:10:28",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:10:28"
          },
          {
            "ticket_id": 19067,
            "ticket_number": "3519055",
            "title": "TRP-2026-02579 | Pagamentos serviços",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:11",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 14:44:11"
          },
          {
            "ticket_id": 19078,
            "ticket_number": "3519066",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:46",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 14:44:46"
          },
          {
            "ticket_id": 19102,
            "ticket_number": "3519090",
            "title": "[Suporte] TRP-2026-02472 - Suporte — Viagem TRP-20",
            "priority": "P2",
            "created_at": "25/05/2026 15:49:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:49:44"
          },
          {
            "ticket_id": 19104,
            "ticket_number": "3519092",
            "title": "[Suporte] TRP-2026-03555 - Pedido de fatura",
            "priority": "P2",
            "created_at": "25/05/2026 15:54:35",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:54:35"
          },
          {
            "ticket_id": 19105,
            "ticket_number": "3519093",
            "title": "[Suporte] TRP-2026-04765 - Pedido de fatura",
            "priority": "P2",
            "created_at": "25/05/2026 15:56:52",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:56:52"
          },
          {
            "ticket_id": 19108,
            "ticket_number": "3519096",
            "title": "Pedido de fatura TRP-2026-04964.",
            "priority": "P2",
            "created_at": "25/05/2026 16:01:56",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:01:56"
          },
          {
            "ticket_id": 19112,
            "ticket_number": "3519100",
            "title": "Re: [Cockpit] Viagem TRP-2026-05184 - Palma de Mai",
            "priority": "P2",
            "created_at": "25/05/2026 16:02:05",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:02:05"
          },
          {
            "ticket_id": 19134,
            "ticket_number": "3519122",
            "title": "JIVAN/PRIYAL JAIANDRA MRS 30MAY2026 LIS VCE",
            "priority": "P2",
            "created_at": "25/05/2026 18:15:12",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:16:12"
          },
          {
            "ticket_id": 19135,
            "ticket_number": "3519123",
            "title": "JIVAN/PRIYAL JAIANDRA MRS 30MAY LIS VCE",
            "priority": "P2",
            "created_at": "25/05/2026 18:15:13",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:16:47"
          },
          {
            "ticket_id": 19136,
            "ticket_number": "3519124",
            "title": "NEIVA MATOS/RICARDO JORGE MR 30MAY LIS VCE",
            "priority": "P2",
            "created_at": "25/05/2026 18:15:15",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:17:08"
          },
          {
            "ticket_id": 19142,
            "ticket_number": "3519130",
            "title": "ZWH75A – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "25/05/2026 20:12:34",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 14.82,
            "sla_met": false,
            "sla_breach_hours": 14.57,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 11:02:27"
          },
          {
            "ticket_id": 19143,
            "ticket_number": "3519131",
            "title": "Reserva Aérea ZWH75A",
            "priority": "P1",
            "created_at": "25/05/2026 20:12:36",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 14.48,
            "sla_met": false,
            "sla_breach_hours": 14.23,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 10:41:57"
          },
          {
            "ticket_id": 19144,
            "ticket_number": "3519132",
            "title": "[Suporte] TRP-2026-03991 - Validação Viagem",
            "priority": "P2",
            "created_at": "25/05/2026 20:21:36",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 20:21:36"
          },
          {
            "ticket_id": 19152,
            "ticket_number": "3519140",
            "title": "ZY6SGT – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "25/05/2026 22:55:24",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 12.3,
            "sla_met": false,
            "sla_breach_hours": 12.05,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 11:13:38"
          },
          {
            "ticket_id": 19158,
            "ticket_number": "3519146",
            "title": "Reserva Aérea ZY6SGT",
            "priority": "P1",
            "created_at": "25/05/2026 22:55:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 11.77,
            "sla_met": false,
            "sla_breach_hours": 11.52,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 10:42:11"
          },
          {
            "ticket_id": 19159,
            "ticket_number": "3519147",
            "title": "Reserva Aérea LA0454198SFVL",
            "priority": "P1",
            "created_at": "25/05/2026 22:55:47",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 12.12,
            "sla_met": false,
            "sla_breach_hours": 11.87,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 11:03:23"
          },
          {
            "ticket_id": 19168,
            "ticket_number": "3519156",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:18",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:41:19"
          },
          {
            "ticket_id": 19178,
            "ticket_number": "3519166",
            "title": "alterações por validar",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:49",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:00:49"
          },
          {
            "ticket_id": 19179,
            "ticket_number": "3519167",
            "title": "ZY6SGT – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "26/05/2026 09:00:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.68,
            "sla_met": false,
            "sla_breach_hours": 1.43,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 10:42:25"
          },
          {
            "ticket_id": 19194,
            "ticket_number": "3519182",
            "title": "[Suporte] TRP-2026-05193 - Pedido de validação da ",
            "priority": "P2",
            "created_at": "26/05/2026 10:50:53",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:50:53"
          },
          {
            "ticket_id": 19204,
            "ticket_number": "3519192",
            "title": "TRP-2026-04481",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:30",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:32:31"
          },
          {
            "ticket_id": 19225,
            "ticket_number": "3519213",
            "title": "TRP-2026-02584- Reserva Leplan 604490259",
            "priority": "P2",
            "created_at": "26/05/2026 12:32:47",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:32:47"
          },
          {
            "ticket_id": 19227,
            "ticket_number": "3519215",
            "title": "Grupo: GR-9F3087C9C2",
            "priority": "P2",
            "created_at": "26/05/2026 12:51:48",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:31:58"
          },
          {
            "ticket_id": 19269,
            "ticket_number": "3519257",
            "title": "Travelplan 604531280",
            "priority": "P2",
            "created_at": "26/05/2026 15:31:49",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:31:49"
          },
          {
            "ticket_id": 19280,
            "ticket_number": "3519268",
            "title": "Fwd: [Thai Lion Air] - Trip reminder (in 12 hours)",
            "priority": "P2",
            "created_at": "26/05/2026 15:49:56",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:49:57"
          },
          {
            "ticket_id": 19294,
            "ticket_number": "3519282",
            "title": "[Cancelamento Viagem] TRP-2026-04489 - JOAO RICARD",
            "priority": "P2",
            "created_at": "26/05/2026 17:59:58",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:59:58"
          },
          {
            "ticket_id": 19295,
            "ticket_number": "3519283",
            "title": "[Cancelamento Viagem] TRP-2026-05157 - Juliana Roc",
            "priority": "P2",
            "created_at": "26/05/2026 18:00:40",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:00:41"
          },
          {
            "ticket_id": 19319,
            "ticket_number": "3519307",
            "title": "Informações sobre a sua reserva TTN-1249892858#103",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:39",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:29:23"
          },
          {
            "ticket_id": 19332,
            "ticket_number": "3519320",
            "title": "[Pedido IATA] Lisboa → Rio de Janeiro - 2026-11-03",
            "priority": "P2",
            "created_at": "27/05/2026 01:00:24",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 01:00:24"
          },
          {
            "ticket_id": 19333,
            "ticket_number": "3519321",
            "title": "[Pedido IATA] Lisboa → Florianópolis - 2026-11-03 ",
            "priority": "P2",
            "created_at": "27/05/2026 01:08:06",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 01:08:06"
          },
          {
            "ticket_id": 19335,
            "ticket_number": "3519323",
            "title": "ZWH75A – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "27/05/2026 09:11:32",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.65,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P1",
            "first_response_at": "27/05/2026 11:51:02"
          },
          {
            "ticket_id": 19359,
            "ticket_number": "3519347",
            "title": "Aéreo - Confirmação de Emissão (MENON\\KARLA VILELA",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:17",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:13:58"
          },
          {
            "ticket_id": 19361,
            "ticket_number": "3519349",
            "title": "Aéreo - Confirmação de Emissão (DA SILVA\\LINDACY V",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:20",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:14:25"
          },
          {
            "ticket_id": 19363,
            "ticket_number": "3519351",
            "title": "Aéreo - Confirmação de Emissão (MENON\\ANA KAROLINA",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:24",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:14:50"
          },
          {
            "ticket_id": 19364,
            "ticket_number": "3519352",
            "title": "Aéreo - Confirmação de Emissão (MENON\\BRUNO) - ZWH",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:26",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:15:15"
          },
          {
            "ticket_id": 19368,
            "ticket_number": "3519356",
            "title": "Informações da reserva TTN-1249892858#103088014#T2",
            "priority": "P2",
            "created_at": "27/05/2026 10:50:52",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:41:28"
          },
          {
            "ticket_id": 19371,
            "ticket_number": "3519359",
            "title": "ZWH75A – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "27/05/2026 11:22:29",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:18:47"
          },
          {
            "ticket_id": 19378,
            "ticket_number": "3519366",
            "title": "Reserva Aérea XQY84H",
            "priority": "P2",
            "created_at": "27/05/2026 11:49:05",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:12:41"
          },
          {
            "ticket_id": 19380,
            "ticket_number": "3519368",
            "title": "XQY84H – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "27/05/2026 11:49:11",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.15,
            "sla_met": false,
            "sla_breach_hours": 0.9,
            "sla_name": "SLA P1",
            "first_response_at": "27/05/2026 12:58:24"
          },
          {
            "ticket_id": 19385,
            "ticket_number": "3519373",
            "title": "XQY84H – Reconfirmação de Contactos",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:54",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:16:53"
          },
          {
            "ticket_id": 19386,
            "ticket_number": "3519374",
            "title": "Aéreo - Confirmação de Emissão (FERREIRA\\CARLOS) -",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:57",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:15:50"
          },
          {
            "ticket_id": 19413,
            "ticket_number": "3519401",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "27/05/2026 14:57:14",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:57:14"
          },
          {
            "ticket_id": 19419,
            "ticket_number": "3519407",
            "title": "Reserva Aérea XTIZVH",
            "priority": "P2",
            "created_at": "27/05/2026 15:16:44",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:21:22"
          },
          {
            "ticket_id": 19421,
            "ticket_number": "3519409",
            "title": "XTIZVH – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "27/05/2026 15:17:15",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 115.87,
            "sla_met": false,
            "sla_breach_hours": 111.87,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:10:14"
          },
          {
            "ticket_id": 19422,
            "ticket_number": "3519410",
            "title": "Reserva Aérea XTIZVH",
            "priority": "P2",
            "created_at": "27/05/2026 15:17:16",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:21:29"
          },
          {
            "ticket_id": 19425,
            "ticket_number": "3519413",
            "title": "[Suporte] TRP-2026-05172 - atualização de pagament",
            "priority": "P2",
            "created_at": "27/05/2026 15:34:54",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:34:54"
          },
          {
            "ticket_id": 19428,
            "ticket_number": "3519416",
            "title": "XQY84H – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:33",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 20:42:14"
          },
          {
            "ticket_id": 19440,
            "ticket_number": "3519428",
            "title": "fatura TRP-2026-04973",
            "priority": "P2",
            "created_at": "27/05/2026 16:49:18",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:49:19"
          },
          {
            "ticket_id": 19442,
            "ticket_number": "3519430",
            "title": "RESERVA EM NOME DE CLIENTE DANIELA PARADA",
            "priority": "P2",
            "created_at": "27/05/2026 16:50:01",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:50:02"
          },
          {
            "ticket_id": 19451,
            "ticket_number": "3519439",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZTE",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:12",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 15.45,
            "sla_met": false,
            "sla_breach_hours": 11.45,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:30:10"
          },
          {
            "ticket_id": 19460,
            "ticket_number": "3519448",
            "title": "[Pedido IATA] Sao Paulo Guarulhos → Zurique - 2026",
            "priority": "P2",
            "created_at": "27/05/2026 19:24:04",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 19:24:04"
          },
          {
            "ticket_id": 19472,
            "ticket_number": "3519460",
            "title": "[Pedido IATA] Lisboa → Porto Santo  - 2027-04-01 (",
            "priority": "P2",
            "created_at": "28/05/2026 01:55:31",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 01:55:31"
          },
          {
            "ticket_id": 19483,
            "ticket_number": "3519471",
            "title": "XTIZVH – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "28/05/2026 09:08:40",
            "close_date": "2026-05-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.18,
            "sla_met": false,
            "sla_breach_hours": 6.93,
            "sla_name": "SLA P1",
            "first_response_at": "28/05/2026 16:20:24"
          },
          {
            "ticket_id": 19565,
            "ticket_number": "3519553",
            "title": "[Pedido IATA] Lisboa → Valência - 2026-10-16 (10 p",
            "priority": "P2",
            "created_at": "28/05/2026 14:05:05",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 14:05:05"
          },
          {
            "ticket_id": 19620,
            "ticket_number": "3519608",
            "title": "[Pedido IATA] Lisboa → Madrid - 2026-08-14 (6 pax)",
            "priority": "P2",
            "created_at": "28/05/2026 21:54:50",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 21:54:50"
          },
          {
            "ticket_id": 19725,
            "ticket_number": "3519713",
            "title": "[Cancelamento Serviço] TRP-2026-05193 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 16:48:38",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:48:38"
          },
          {
            "ticket_id": 19877,
            "ticket_number": "3519865",
            "title": "VCH-BWX8FFW6 Pendente",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:34",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:06:34"
          },
          {
            "ticket_id": 19902,
            "ticket_number": "3519890",
            "title": "H1FZF2 – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "01/06/2026 10:08:51",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.87,
            "sla_met": false,
            "sla_breach_hours": 3.62,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 14:01:23"
          },
          {
            "ticket_id": 19908,
            "ticket_number": "3519896",
            "title": "GBN-109031 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "01/06/2026 10:44:28",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:04:11"
          },
          {
            "ticket_id": 19922,
            "ticket_number": "3519910",
            "title": "Confirmação de Reserva * File 442679 EMISSAO VOOS ",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:26",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:48"
          },
          {
            "ticket_id": 19927,
            "ticket_number": "3519915",
            "title": "Reserva Aérea H1FZF2",
            "priority": "P1",
            "created_at": "01/06/2026 11:46:17",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.92,
            "sla_met": false,
            "sla_breach_hours": 3.67,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 15:41:49"
          },
          {
            "ticket_id": 19958,
            "ticket_number": "3519946",
            "title": "Aéreo - Confirmação de Emissão (CRUZ\\NAIR ALEXANDR",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19959,
            "ticket_number": "3519947",
            "title": "Aéreo - Confirmação de Emissão (MINHOTO\\VALERIANO ",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:31",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19960,
            "ticket_number": "3519948",
            "title": "Aéreo - Confirmação de Emissão (MINHOTO\\LETICIA) -",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:33",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19990,
            "ticket_number": "3519978",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60450073",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:04",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 15.97,
            "sla_met": false,
            "sla_breach_hours": 11.97,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:20:27"
          },
          {
            "ticket_id": 20014,
            "ticket_number": "3520002",
            "title": "H1FZF2 – Alteração de horario/nº de voo",
            "priority": "P1",
            "created_at": "01/06/2026 19:04:39",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 14.6,
            "sla_met": false,
            "sla_breach_hours": 14.35,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 09:40:40"
          },
          {
            "ticket_id": 20028,
            "ticket_number": "3520016",
            "title": "Fwd: Solicitud de ampliación de contrato",
            "priority": "P1",
            "created_at": "01/06/2026 23:22:53",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 23:22:53"
          },
          {
            "ticket_id": 20029,
            "ticket_number": "3520017",
            "title": "[Pedido IATA] Lisboa → Sydney - 2026-07-19 (5 pax)",
            "priority": "P2",
            "created_at": "01/06/2026 23:25:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 23:25:43"
          },
          {
            "ticket_id": 20030,
            "ticket_number": "3520018",
            "title": "[Pedido IATA] Lisboa → Rio de Janeiro - 2026-11-06",
            "priority": "P2",
            "created_at": "02/06/2026 01:17:44",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 01:17:44"
          },
          {
            "ticket_id": 20035,
            "ticket_number": "3520023",
            "title": "Newblue - 6122601",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:07:42"
          },
          {
            "ticket_id": 20039,
            "ticket_number": "3520027",
            "title": "Cancelamento voo ida GBN 126491",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:56",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:07:57"
          },
          {
            "ticket_id": 20041,
            "ticket_number": "3520029",
            "title": "TRP2026-05150",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:02",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:08:02"
          },
          {
            "ticket_id": 20057,
            "ticket_number": "3520045",
            "title": "Número de informação da reserva: 6144534",
            "priority": "P2",
            "created_at": "02/06/2026 09:57:47",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:11:00"
          },
          {
            "ticket_id": 20066,
            "ticket_number": "3520054",
            "title": "Aviso de entrada tardia e pedido de jantar no quar",
            "priority": "P2",
            "created_at": "02/06/2026 10:18:50",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:18:51"
          },
          {
            "ticket_id": 20072,
            "ticket_number": "3520060",
            "title": "Reserva 432293",
            "priority": "P2",
            "created_at": "02/06/2026 10:51:23",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:51:23"
          },
          {
            "ticket_id": 20075,
            "ticket_number": "3520063",
            "title": "GBN-118066 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/06/2026 11:08:06",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:14:07"
          },
          {
            "ticket_id": 20080,
            "ticket_number": "3520068",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 11:34:40",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:53:07"
          },
          {
            "ticket_id": 20091,
            "ticket_number": "3520079",
            "title": "Solicitud de ampliación de contrato",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:23",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:27:25"
          },
          {
            "ticket_id": 20121,
            "ticket_number": "3520109",
            "title": "Solicitud de ampliación de contrato",
            "priority": "P2",
            "created_at": "02/06/2026 16:23:34",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 20:20:21"
          },
          {
            "ticket_id": 20133,
            "ticket_number": "3520121",
            "title": "TRP-2026-02472 - Maiorca",
            "priority": "P2",
            "created_at": "02/06/2026 16:33:15",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:33:15"
          },
          {
            "ticket_id": 20140,
            "ticket_number": "3520128",
            "title": "Solicitud de ampliación contrato completada",
            "priority": "P2",
            "created_at": "02/06/2026 16:54:02",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:20:46"
          },
          {
            "ticket_id": 20143,
            "ticket_number": "3520131",
            "title": "ANA RITA COUTINHO RODRIGUES RD JUNHO 2DA VIA",
            "priority": "P2",
            "created_at": "02/06/2026 16:54:44",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:57:51"
          },
          {
            "ticket_id": 20149,
            "ticket_number": "3520137",
            "title": "Soltour: Modificação de reserva:  SPT002601636679",
            "priority": "P1",
            "created_at": "02/06/2026 17:53:25",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 17:56:17"
          },
          {
            "ticket_id": 20154,
            "ticket_number": "3520142",
            "title": "Cancelamento de reserva 340126",
            "priority": "P2",
            "created_at": "02/06/2026 18:04:25",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:34:55"
          },
          {
            "ticket_id": 20159,
            "ticket_number": "3520147",
            "title": "[Suporte] TRP-2026-02695 - Validação de alteração ",
            "priority": "P2",
            "created_at": "02/06/2026 21:18:45",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 21:18:45"
          },
          {
            "ticket_id": 20165,
            "ticket_number": "3520153",
            "title": "XYJAD2 – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:35",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 12.03,
            "sla_met": false,
            "sla_breach_hours": 8.03,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:55:09"
          },
          {
            "ticket_id": 20171,
            "ticket_number": "3520159",
            "title": "Reserva Aéreo [ERROR_AIR-1D5757B251] - Erro Técnic",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:48",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.72,
            "sla_met": false,
            "sla_breach_hours": 7.72,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:36:04"
          },
          {
            "ticket_id": 20173,
            "ticket_number": "3520161",
            "title": "XYJAD2 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:54",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.9,
            "sla_met": false,
            "sla_breach_hours": 7.9,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:47:22"
          },
          {
            "ticket_id": 20175,
            "ticket_number": "3520163",
            "title": "Reserva Aéreo [ERROR_AIR-31E652CF45] - Erro Técnic",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:58",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.72,
            "sla_met": false,
            "sla_breach_hours": 7.72,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:36:16"
          },
          {
            "ticket_id": 20179,
            "ticket_number": "3520167",
            "title": "Reserva Aérea XYJAD2",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:08",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.85,
            "sla_met": false,
            "sla_breach_hours": 7.85,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:44:44"
          },
          {
            "ticket_id": 20201,
            "ticket_number": "3520189",
            "title": "XMXZRL – Alteração de Horário - Aceite",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:33",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:56:13"
          },
          {
            "ticket_id": 20204,
            "ticket_number": "3520192",
            "title": "XYJAD2 – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:41",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:56:22"
          },
          {
            "ticket_id": 20205,
            "ticket_number": "3520193",
            "title": "XYJAD2 – Reserva com segmentos inativos por falta ",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:56:33"
          },
          {
            "ticket_id": 20207,
            "ticket_number": "3520195",
            "title": "RE: opti 24101195",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:47",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:37:51"
          },
          {
            "ticket_id": 20213,
            "ticket_number": "3520201",
            "title": "[Pedido IATA] Lisboa → Malaga - 2026-06-20 (3 pax)",
            "priority": "P2",
            "created_at": "03/06/2026 09:40:35",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:40:35"
          },
          {
            "ticket_id": 20222,
            "ticket_number": "3520210",
            "title": "Aéreo - Confirmação de Emissão (SOARES GUERRA\\PAUL",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:30",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:52:35"
          },
          {
            "ticket_id": 20223,
            "ticket_number": "3520211",
            "title": "Reserva Aérea YALNMD",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:33",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:25:40"
          },
          {
            "ticket_id": 20224,
            "ticket_number": "3520212",
            "title": "Aéreo - Confirmação de Emissão (GUERRA\\TIAGO) - YA",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:36",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:51:51"
          },
          {
            "ticket_id": 20225,
            "ticket_number": "3520213",
            "title": "Aéreo - Confirmação de Emissão (DUARTE PINTO GUERR",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:38",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:50:42"
          },
          {
            "ticket_id": 20228,
            "ticket_number": "3520216",
            "title": "YALNMD – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "03/06/2026 10:24:02",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:29:53"
          },
          {
            "ticket_id": 20234,
            "ticket_number": "3520222",
            "title": "[Pedido IATA] Porto → Madrid  - 2026-06-30 (1 pax)",
            "priority": "P2",
            "created_at": "03/06/2026 11:16:08",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:02:17"
          },
          {
            "ticket_id": 20244,
            "ticket_number": "3520232",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "03/06/2026 12:11:33",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 10:07:28"
          },
          {
            "ticket_id": 20275,
            "ticket_number": "3520263",
            "title": "Reserva TRP-2026-03750",
            "priority": "P2",
            "created_at": "03/06/2026 15:42:11",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:42:11"
          },
          {
            "ticket_id": 20281,
            "ticket_number": "3520269",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "03/06/2026 16:32:15",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:27:19"
          },
          {
            "ticket_id": 20284,
            "ticket_number": "3520272",
            "title": "XQY84H – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "03/06/2026 16:45:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:26:54"
          },
          {
            "ticket_id": 20307,
            "ticket_number": "3520295",
            "title": "reserva PP219523",
            "priority": "P2",
            "created_at": "03/06/2026 18:19:23",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 39.17,
            "sla_met": false,
            "sla_breach_hours": 35.17,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:29:32"
          },
          {
            "ticket_id": 20313,
            "ticket_number": "3520301",
            "title": "GBN-126496 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/06/2026 19:55:01",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 38.38,
            "sla_met": false,
            "sla_breach_hours": 34.38,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:18:09"
          },
          {
            "ticket_id": 20335,
            "ticket_number": "3520323",
            "title": "[Pedido IATA] Cracóvia → Porto - 2026-07-29 (3 pax",
            "priority": "P2",
            "created_at": "04/06/2026 19:51:58",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/06/2026 19:51:58"
          },
          {
            "ticket_id": 20336,
            "ticket_number": "3520324",
            "title": "[Cancelamento Viagem] TRP-2026-05366 - Rui Pinto -",
            "priority": "P2",
            "created_at": "04/06/2026 22:36:00",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/06/2026 22:36:00"
          },
          {
            "ticket_id": 20357,
            "ticket_number": "3520345",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604607269",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:17",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:40:05"
          },
          {
            "ticket_id": 20360,
            "ticket_number": "3520348",
            "title": "Grupo: GR-D3C0C2FBB0",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:23",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:27:21"
          },
          {
            "ticket_id": 20388,
            "ticket_number": "3520376",
            "title": "Cierre del contrato de alquiler",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:32",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:35"
          },
          {
            "ticket_id": 20390,
            "ticket_number": "3520378",
            "title": "H1FZF2 – Alteração de horario/nº de voo - ALERTA",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:36",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:44:00"
          },
          {
            "ticket_id": 20391,
            "ticket_number": "3520379",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:38",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:36"
          },
          {
            "ticket_id": 20396,
            "ticket_number": "3520384",
            "title": "Cancelamento de Reservas 491-2083020 Bedsonline",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:52",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:25:33"
          },
          {
            "ticket_id": 20422,
            "ticket_number": "3520410",
            "title": "[Pedido IATA] Lisboa → ho chi minh - 2026-08-14 (2",
            "priority": "P2",
            "created_at": "05/06/2026 11:44:18",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:44:18"
          },
          {
            "ticket_id": 20436,
            "ticket_number": "3520424",
            "title": "Reserva 604638533",
            "priority": "P2",
            "created_at": "05/06/2026 14:15:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 14:15:32"
          },
          {
            "ticket_id": 20442,
            "ticket_number": "3520430",
            "title": "Reserva Aérea P5BK8",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:36",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:58:44"
          },
          {
            "ticket_id": 20443,
            "ticket_number": "3520431",
            "title": "Newblue 6149283 - Correção de nomes",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:38",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:40:38"
          },
          {
            "ticket_id": 20451,
            "ticket_number": "3520439",
            "title": "URGENTE Newblue - localizador 6149283",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:56",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:40:56"
          },
          {
            "ticket_id": 20461,
            "ticket_number": "3520449",
            "title": "GBN-111630 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:08:17"
          },
          {
            "ticket_id": 20467,
            "ticket_number": "3520455",
            "title": "Familia em Viagem informa sobre a sua reserva 1288",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:26",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 65.05,
            "sla_met": false,
            "sla_breach_hours": 61.05,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:22:04"
          },
          {
            "ticket_id": 20472,
            "ticket_number": "3520460",
            "title": "ZF6HJ6 – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:36",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:58:56"
          },
          {
            "ticket_id": 20473,
            "ticket_number": "3520461",
            "title": "Reserva Aérea ZF6HJ6",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:38",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:59:03"
          },
          {
            "ticket_id": 20482,
            "ticket_number": "3520470",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604591378",
            "priority": "P2",
            "created_at": "05/06/2026 16:55:28",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:54:36"
          },
          {
            "ticket_id": 20483,
            "ticket_number": "3520471",
            "title": "Aéreo - Confirmação de Emissão (PARENTE\\RAQUEL) - ",
            "priority": "P2",
            "created_at": "05/06/2026 16:56:28",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:07:41"
          },
          {
            "ticket_id": 20484,
            "ticket_number": "3520472",
            "title": "Aéreo - Confirmação de Emissão (LACERDA E MELLO\\PE",
            "priority": "P2",
            "created_at": "05/06/2026 16:56:30",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:08:25"
          },
          {
            "ticket_id": 20485,
            "ticket_number": "3520473",
            "title": "Aéreo - Confirmação de Emissão (CARDOSO\\JOSE) - P5",
            "priority": "P2",
            "created_at": "05/06/2026 17:05:30",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:08:52"
          },
          {
            "ticket_id": 20489,
            "ticket_number": "3520477",
            "title": "Aéreo - Confirmação de Emissão (PARENTE\\RAQUEL) - ",
            "priority": "P2",
            "created_at": "05/06/2026 17:05:37",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:09:18"
          },
          {
            "ticket_id": 20490,
            "ticket_number": "3520478",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZF6",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:59:27"
          },
          {
            "ticket_id": 20506,
            "ticket_number": "3520494",
            "title": "Aéreo - Confirmação de Emissão (PARENTE\\RAQUEL) - ",
            "priority": "P2",
            "created_at": "05/06/2026 17:46:42",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:59:50"
          },
          {
            "ticket_id": 20516,
            "ticket_number": "3520504",
            "title": "[Suporte] TRP-2026-03795 - pedido de emissao da fa",
            "priority": "P2",
            "created_at": "05/06/2026 18:03:41",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:03:41"
          },
          {
            "ticket_id": 20585,
            "ticket_number": "3520573",
            "title": "Reserva Aérea XRFGHS",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:18",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:57:39"
          },
          {
            "ticket_id": 20632,
            "ticket_number": "3520620",
            "title": "Grupo: GR-D528A63F98",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:53",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:32:05"
          }
        ]
      },
      "Não Atribuído": {
        "total_tickets": 6344,
        "sla_met": 4653,
        "sla_missed": 1691,
        "sla_compliance_rate": 73.34,
        "tickets": [
          {
            "ticket_id": 32,
            "ticket_number": "35032",
            "title": "GBN-83985 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 09:06:35",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 13.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/09/2025 22:25:00"
          },
          {
            "ticket_id": 53,
            "ticket_number": "35053",
            "title": "Re: Pedido de reunião - Parceria com um GDS",
            "priority": "P2",
            "created_at": "30/09/2025 11:11:26",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 11:11:26"
          },
          {
            "ticket_id": 54,
            "ticket_number": "35054",
            "title": "Informação de reserva - SPT002501543712",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 11:11:30",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 4.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/09/2025 15:37:33"
          },
          {
            "ticket_id": 63,
            "ticket_number": "35063",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 13:47:34",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/09/2025 16:45:31"
          },
          {
            "ticket_id": 67,
            "ticket_number": "35066",
            "title": "Fwd: Novo evento: Sofia Costa - 16:00 Seg, 6 de Ou",
            "priority": "P2",
            "created_at": "30/09/2025 14:49:00",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 14:49:00"
          },
          {
            "ticket_id": 69,
            "ticket_number": "35068",
            "title": "Fwd: Aceito: Alexandra ribeiro and Magali & Alexan",
            "priority": "P2",
            "created_at": "30/09/2025 14:49:02",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 14:49:02"
          },
          {
            "ticket_id": 87,
            "ticket_number": "35086",
            "title": "Re: Cotação excursões México outubro",
            "priority": "P2",
            "created_at": "30/09/2025 18:14:39",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 18:15:28"
          },
          {
            "ticket_id": 92,
            "ticket_number": "35091",
            "title": "GBN-84160 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 21:06:35",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/09/2025 21:17:00"
          },
          {
            "ticket_id": 93,
            "ticket_number": "35092",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 21:11:23",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/09/2025 21:16:02"
          },
          {
            "ticket_id": 107,
            "ticket_number": "35106",
            "title": "Confirmação de reserva com localizador: 3924809",
            "priority": "Reservas sem Formulário",
            "created_at": "01/10/2025 12:18:26",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 1.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/10/2025 14:18:03"
          },
          {
            "ticket_id": 123,
            "ticket_number": "35122",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604468591",
            "priority": "P3",
            "created_at": "01/10/2025 18:13:39",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 39.78,
            "sla_met": false,
            "sla_breach_hours": 15.78,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 10:01:30"
          },
          {
            "ticket_id": 125,
            "ticket_number": "35124",
            "title": "GBN-84331 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/10/2025 18:46:20",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 39.7,
            "sla_met": false,
            "sla_breach_hours": 15.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/10/2025 10:29:00"
          },
          {
            "ticket_id": 127,
            "ticket_number": "35126",
            "title": "Número de informação da reserva: 6119161",
            "priority": "P3",
            "created_at": "01/10/2025 20:10:56",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 38.0,
            "sla_met": false,
            "sla_breach_hours": 14.0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 10:11:33"
          },
          {
            "ticket_id": 131,
            "ticket_number": "35130",
            "title": "GBN-84342 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/10/2025 21:12:09",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 37.28,
            "sla_met": false,
            "sla_breach_hours": 13.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/10/2025 10:29:42"
          },
          {
            "ticket_id": 147,
            "ticket_number": "35146",
            "title": "Confirmation of booking with locatorNVMSBL4L",
            "priority": "Reservas sem Formulário",
            "created_at": "02/10/2025 12:32:06",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 117.05,
            "sla_met": false,
            "sla_breach_hours": 93.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:35:22"
          },
          {
            "ticket_id": 148,
            "ticket_number": "35147",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "02/10/2025 12:32:11",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 117.07,
            "sla_met": false,
            "sla_breach_hours": 93.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:36:47"
          },
          {
            "ticket_id": 156,
            "ticket_number": "35155",
            "title": "Número de informação da reserva: 6119179",
            "priority": "Reservas sem Formulário",
            "created_at": "02/10/2025 16:37:30",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 113.05,
            "sla_met": false,
            "sla_breach_hours": 89.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:40:54"
          },
          {
            "ticket_id": 164,
            "ticket_number": "35163",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604469451",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 09:22:51",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/10/2025 09:40:03"
          },
          {
            "ticket_id": 166,
            "ticket_number": "35165",
            "title": "Fwd: Confirmacion de la reserva Transavia: TBHIFP",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 09:40:03",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 96.02,
            "sla_met": false,
            "sla_breach_hours": 72.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:41:39"
          },
          {
            "ticket_id": 172,
            "ticket_number": "35171",
            "title": "Número de informação da reserva: 6119184",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:13:06",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 95.73,
            "sla_met": false,
            "sla_breach_hours": 71.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:57:12"
          },
          {
            "ticket_id": 173,
            "ticket_number": "35172",
            "title": "GBN-84499 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:13:10",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 95.73,
            "sla_met": false,
            "sla_breach_hours": 71.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:57:41"
          },
          {
            "ticket_id": 174,
            "ticket_number": "35173",
            "title": "Reserva confirmada: Cruzeiro de 3 noites pelo Nilo",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:57:48",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 95.0,
            "sla_met": false,
            "sla_breach_hours": 71.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:58:09"
          },
          {
            "ticket_id": 176,
            "ticket_number": "35175",
            "title": "GBN-84526 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:57:56",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 95.0,
            "sla_met": false,
            "sla_breach_hours": 71.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:58:40"
          },
          {
            "ticket_id": 177,
            "ticket_number": "35176",
            "title": "Reserva confirmada: Cruzeiro de 3 noites pelo Nilo",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:57:59",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 95.02,
            "sla_met": false,
            "sla_breach_hours": 71.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:59:13"
          },
          {
            "ticket_id": 180,
            "ticket_number": "35179",
            "title": "Maldivas / Melhores Ofertas 1 a 8 de Dez",
            "priority": "P2",
            "created_at": "03/10/2025 11:13:58",
            "close_date": "2025-10-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/10/2025 11:15:15"
          },
          {
            "ticket_id": 181,
            "ticket_number": "35180",
            "title": "GBN-84522 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 11:14:04",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 94.87,
            "sla_met": false,
            "sla_breach_hours": 70.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:06:43"
          },
          {
            "ticket_id": 198,
            "ticket_number": "35197",
            "title": "Confirmação de reserva. Localizador:",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:10:27",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 24.98,
            "sla_met": false,
            "sla_breach_hours": 0.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:09:56"
          },
          {
            "ticket_id": 205,
            "ticket_number": "35204",
            "title": "GBN-84745 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/10/2025 09:10:50",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 09:34:43"
          },
          {
            "ticket_id": 206,
            "ticket_number": "35205",
            "title": "GBN-84757 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:10:53",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 25.4,
            "sla_met": false,
            "sla_breach_hours": 1.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:35:32"
          },
          {
            "ticket_id": 207,
            "ticket_number": "35206",
            "title": "A sua reserva n.º 63316063: mantenha-se ligado enq",
            "priority": "P2",
            "created_at": "06/10/2025 09:10:57",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 09:32:45"
          },
          {
            "ticket_id": 209,
            "ticket_number": "35208",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:09",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/10/2025 09:11:09"
          },
          {
            "ticket_id": 213,
            "ticket_number": "35212",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:21",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 25.57,
            "sla_met": false,
            "sla_breach_hours": 1.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:46:09"
          },
          {
            "ticket_id": 215,
            "ticket_number": "35214",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:25",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 25.57,
            "sla_met": false,
            "sla_breach_hours": 1.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:46:17"
          },
          {
            "ticket_id": 216,
            "ticket_number": "35215",
            "title": "GBN-84669 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:57:08",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 24.83,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:47:25"
          },
          {
            "ticket_id": 218,
            "ticket_number": "35217",
            "title": "GBN-84669 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:57:21",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 24.83,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:47:35"
          },
          {
            "ticket_id": 219,
            "ticket_number": "35218",
            "title": "GBN-84675 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:57:28",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 24.83,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:48:08"
          },
          {
            "ticket_id": 231,
            "ticket_number": "35230",
            "title": "GBN-84767 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 10:24:53",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 24.43,
            "sla_met": false,
            "sla_breach_hours": 0.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:51:36"
          },
          {
            "ticket_id": 240,
            "ticket_number": "35239",
            "title": "Pedido de informação- Alexandra",
            "priority": "P3",
            "created_at": "06/10/2025 11:30:48",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 11:30:48"
          },
          {
            "ticket_id": 256,
            "ticket_number": "35255",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 18:06:24",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 16.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 257,
            "ticket_number": "35256",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 18:06:58",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 16.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 261,
            "ticket_number": "35260",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 19:09:17",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 262,
            "ticket_number": "35261",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 19:09:20",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 264,
            "ticket_number": "35263",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 19:09:37",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 274,
            "ticket_number": "35273",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:06:39",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 12.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:52"
          },
          {
            "ticket_id": 275,
            "ticket_number": "35274",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:06:48",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 14.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 12:31:10"
          },
          {
            "ticket_id": 276,
            "ticket_number": "35275",
            "title": "Reserva confirmada: Excursão a Santo Domingo - Civ",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:55:03",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 16.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 15:18:03"
          },
          {
            "ticket_id": 278,
            "ticket_number": "35277",
            "title": "Reserva confirmada: Excursão a Santo Domingo - Civ",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:55:11",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 16.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 15:18:44"
          },
          {
            "ticket_id": 282,
            "ticket_number": "35281",
            "title": "GBN-84890 - RGPD",
            "priority": "P2",
            "created_at": "07/10/2025 09:06:26",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 09:06:26"
          },
          {
            "ticket_id": 284,
            "ticket_number": "35283",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "07/10/2025 09:06:29",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 09:14:10"
          },
          {
            "ticket_id": 290,
            "ticket_number": "35289",
            "title": "Confirmação de reserva com localizador: 3931518",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 10:33:59",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 82.87,
            "sla_met": false,
            "sla_breach_hours": 58.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 21:26:37"
          },
          {
            "ticket_id": 304,
            "ticket_number": "35303",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "07/10/2025 12:45:37",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 14:36:13"
          },
          {
            "ticket_id": 310,
            "ticket_number": "35309",
            "title": "Viajar Tours - Balanço Janeiro Setembro",
            "priority": "P3",
            "created_at": "07/10/2025 14:28:25",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 671.32,
            "sla_met": false,
            "sla_breach_hours": 647.32,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 13:48:12"
          },
          {
            "ticket_id": 323,
            "ticket_number": "35322",
            "title": "Confirmação de reserva com localizador: 3932193",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 17:21:31",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 23.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 16:58:54"
          },
          {
            "ticket_id": 326,
            "ticket_number": "35325",
            "title": "GBN-85029 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 19:08:41",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 45.53,
            "sla_met": false,
            "sla_breach_hours": 21.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 16:40:54"
          },
          {
            "ticket_id": 335,
            "ticket_number": "35334",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "07/10/2025 22:11:00",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 22:18:02"
          },
          {
            "ticket_id": 344,
            "ticket_number": "35343",
            "title": "Reserva confirmada: Free tour por Sevilha - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 23:42:41",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 41.02,
            "sla_met": false,
            "sla_breach_hours": 17.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 16:44:26"
          },
          {
            "ticket_id": 350,
            "ticket_number": "35349",
            "title": "Ana Martins- OPTI nº 2412000015",
            "priority": "P2",
            "created_at": "08/10/2025 09:25:23",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:25:23"
          },
          {
            "ticket_id": 358,
            "ticket_number": "35357",
            "title": "Fwd: Viagify informa sobre a sua reserva 120802920",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:58:55",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 09:58:55"
          },
          {
            "ticket_id": 360,
            "ticket_number": "35359",
            "title": "Fwd: Viagify informa sobre a sua reserva 120802920",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:59:00",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 09:59:01"
          },
          {
            "ticket_id": 362,
            "ticket_number": "35361",
            "title": "Fwd: Confirmacion de la reserva Transavia: REY5TW",
            "priority": "P2",
            "created_at": "08/10/2025 09:59:04",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:59:05"
          },
          {
            "ticket_id": 363,
            "ticket_number": "35362",
            "title": "Fwd: Confirmación de reserva",
            "priority": "P2",
            "created_at": "08/10/2025 09:59:07",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:59:08"
          },
          {
            "ticket_id": 366,
            "ticket_number": "35365",
            "title": "Fwd: EN846Y | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "08/10/2025 09:59:14",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:59:15"
          },
          {
            "ticket_id": 370,
            "ticket_number": "35369",
            "title": "GBN-85066 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 10:51:07",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 33.63,
            "sla_met": false,
            "sla_breach_hours": 9.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 20:29:47"
          },
          {
            "ticket_id": 375,
            "ticket_number": "35374",
            "title": "Reserva confirmada: Excursão às Minas de Sal de Wi",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 11:56:53",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 11:57:06"
          },
          {
            "ticket_id": 377,
            "ticket_number": "35376",
            "title": "Reserva confirmada: Excursão às Minas de Sal de Wi",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 11:57:06",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 32.55,
            "sla_met": false,
            "sla_breach_hours": 8.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 20:30:58"
          },
          {
            "ticket_id": 379,
            "ticket_number": "35378",
            "title": "Fwd: Confirmacion de la reserva Transavia: KFCJSD",
            "priority": "P2",
            "created_at": "08/10/2025 12:08:59",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 12:08:59"
          },
          {
            "ticket_id": 380,
            "ticket_number": "35379",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604472470",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 12:09:00",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 32.37,
            "sla_met": false,
            "sla_breach_hours": 8.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 20:31:35"
          },
          {
            "ticket_id": 381,
            "ticket_number": "35380",
            "title": "Fwd: Viagify informa sobre a sua reserva 120832427",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 14:12:05",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 14:12:05"
          },
          {
            "ticket_id": 392,
            "ticket_number": "35391",
            "title": "Criação de processo File 412541/25",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 14:30:04",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 120.98,
            "sla_met": false,
            "sla_breach_hours": 96.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:29:52"
          },
          {
            "ticket_id": 396,
            "ticket_number": "35395",
            "title": "Re: Fwd: 💛 Obrigada por fazeres parte da nossa his",
            "priority": "P3",
            "created_at": "08/10/2025 15:14:51",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 15:14:52"
          },
          {
            "ticket_id": 397,
            "ticket_number": "35396",
            "title": "Re: Fwd: 💛 Obrigada por fazeres parte da nossa his",
            "priority": "P3",
            "created_at": "08/10/2025 15:14:53",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 15:14:53"
          },
          {
            "ticket_id": 402,
            "ticket_number": "35401",
            "title": "Información sobre su reserva: 97Y839GTCE",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 16:17:29",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 531.2,
            "sla_met": false,
            "sla_breach_hours": 507.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 19:30:06"
          },
          {
            "ticket_id": 407,
            "ticket_number": "35406",
            "title": "Reserva confirmada: Passeio de barco pelo Danúbio ",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 17:14:34",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 120.55,
            "sla_met": false,
            "sla_breach_hours": 96.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 17:47:37"
          },
          {
            "ticket_id": 408,
            "ticket_number": "35407",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 17:14:36",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 120.52,
            "sla_met": false,
            "sla_breach_hours": 96.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 17:46:14"
          },
          {
            "ticket_id": 410,
            "ticket_number": "35409",
            "title": "Re: Resposta reclamação SPT002501520476",
            "priority": "P2",
            "created_at": "08/10/2025 17:15:11",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 17:41:25"
          },
          {
            "ticket_id": 421,
            "ticket_number": "35420",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 20:01:16",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 115.4,
            "sla_met": false,
            "sla_breach_hours": 91.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:25:56"
          },
          {
            "ticket_id": 423,
            "ticket_number": "35422",
            "title": "GBN-85201 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 22:12:27",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 22:47:32"
          },
          {
            "ticket_id": 424,
            "ticket_number": "35423",
            "title": "GBN-85201 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 22:58:31",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 112.57,
            "sla_met": false,
            "sla_breach_hours": 88.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:33:08"
          },
          {
            "ticket_id": 426,
            "ticket_number": "35425",
            "title": "Re: Fwd: 💛 Obrigada por fazeres parte da nossa his",
            "priority": "P3",
            "created_at": "09/10/2025 09:07:34",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 09:07:34"
          },
          {
            "ticket_id": 430,
            "ticket_number": "35429",
            "title": "Adicione novas experiências para sua viagem GBN-70",
            "priority": "P2",
            "created_at": "09/10/2025 09:07:40",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 09:37:54"
          },
          {
            "ticket_id": 431,
            "ticket_number": "35430",
            "title": "Reserva confirmada: Espectáculo flamenco na Casa d",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 09:07:42",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 102.28,
            "sla_met": false,
            "sla_breach_hours": 78.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:25:10"
          },
          {
            "ticket_id": 432,
            "ticket_number": "35431",
            "title": "Confirmación de la reserva con localizador: 393446",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 09:07:43",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 105.17,
            "sla_met": false,
            "sla_breach_hours": 81.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:18:28"
          },
          {
            "ticket_id": 434,
            "ticket_number": "35433",
            "title": "Reserva - 412548",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 09:08:28",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 105.77,
            "sla_met": false,
            "sla_breach_hours": 81.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:54:37"
          },
          {
            "ticket_id": 435,
            "ticket_number": "35434",
            "title": "Confirmação de Reserva * File 412541",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 09:40:33",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 101.75,
            "sla_met": false,
            "sla_breach_hours": 77.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:26:13"
          },
          {
            "ticket_id": 437,
            "ticket_number": "35436",
            "title": "RE: Multibanco - File 411467/25",
            "priority": "P3",
            "created_at": "09/10/2025 09:43:48",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 09:57:34"
          },
          {
            "ticket_id": 439,
            "ticket_number": "35438",
            "title": "Número de informação da reserva: 6119326",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 09:50:17",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 10.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 20:34:27"
          },
          {
            "ticket_id": 440,
            "ticket_number": "35439",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "09/10/2025 10:54:53",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 10:54:53"
          },
          {
            "ticket_id": 454,
            "ticket_number": "35453",
            "title": "GBN-85329 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 17:03:22",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 94.53,
            "sla_met": false,
            "sla_breach_hours": 70.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:35:51"
          },
          {
            "ticket_id": 460,
            "ticket_number": "35459",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 18:24:05",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 18:24:05"
          },
          {
            "ticket_id": 461,
            "ticket_number": "35460",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 18:24:08",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 18:24:08"
          },
          {
            "ticket_id": 462,
            "ticket_number": "35461",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/10/2025 18:24:11",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 18:24:11"
          },
          {
            "ticket_id": 468,
            "ticket_number": "35467",
            "title": "GBN-85381 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/10/2025 23:15:36",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 10.05,
            "sla_met": false,
            "sla_breach_hours": 6.05,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 09:19:07"
          },
          {
            "ticket_id": 469,
            "ticket_number": "35468",
            "title": "Fwd: Viagify informa sobre a sua reserva 120882881",
            "priority": "P2",
            "created_at": "10/10/2025 09:06:46",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 09:06:46"
          },
          {
            "ticket_id": 471,
            "ticket_number": "35470",
            "title": "Fwd: Viagify informa sobre a sua reserva 120882881",
            "priority": "P2",
            "created_at": "10/10/2025 09:06:52",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 09:06:53"
          },
          {
            "ticket_id": 473,
            "ticket_number": "35472",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 09:06:58",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 09:33:12"
          },
          {
            "ticket_id": 475,
            "ticket_number": "35474",
            "title": "Resposta automática W2M:010510266314",
            "priority": "P2",
            "created_at": "10/10/2025 09:15:33",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 09:34:48"
          },
          {
            "ticket_id": 485,
            "ticket_number": "35484",
            "title": "Envio de documentos de File 412540/25 * VOOS EMITI",
            "priority": "P2",
            "created_at": "10/10/2025 10:50:10",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 10:59:20"
          },
          {
            "ticket_id": 496,
            "ticket_number": "35495",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 14:47:28",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 78.62,
            "sla_met": false,
            "sla_breach_hours": 54.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 21:24:33"
          },
          {
            "ticket_id": 498,
            "ticket_number": "35497",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 14:47:32",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 78.72,
            "sla_met": false,
            "sla_breach_hours": 54.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 21:30:48"
          },
          {
            "ticket_id": 499,
            "ticket_number": "35498",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 14:48:13",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 72.63,
            "sla_met": false,
            "sla_breach_hours": 48.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:26:36"
          },
          {
            "ticket_id": 505,
            "ticket_number": "35504",
            "title": "GBN-85079 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 16:31:35",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 70.9,
            "sla_met": false,
            "sla_breach_hours": 46.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:26:30"
          },
          {
            "ticket_id": 515,
            "ticket_number": "35514",
            "title": "GBN-84048 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 18:29:06",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 20:24:42"
          },
          {
            "ticket_id": 517,
            "ticket_number": "35516",
            "title": "GBN-84940 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 18:58:10",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 91.17,
            "sla_met": false,
            "sla_breach_hours": 87.17,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 14:08:29"
          },
          {
            "ticket_id": 524,
            "ticket_number": "35523",
            "title": "Re:[##   22649   ##] GBN-85079 - Seu pedido foi re",
            "priority": "P2",
            "created_at": "10/10/2025 20:48:20",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 20:55:57"
          },
          {
            "ticket_id": 529,
            "ticket_number": "35528",
            "title": "GBN-85533 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 22:17:05",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 346.57,
            "sla_met": false,
            "sla_breach_hours": 322.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 08:51:30"
          },
          {
            "ticket_id": 530,
            "ticket_number": "35529",
            "title": "GBN-85535 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 22:17:08",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 111.53,
            "sla_met": false,
            "sla_breach_hours": 87.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 13:49:12"
          },
          {
            "ticket_id": 535,
            "ticket_number": "35534",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "13/10/2025 09:06:00",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:22:20"
          },
          {
            "ticket_id": 551,
            "ticket_number": "35550",
            "title": "GBN-85634 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:06:57",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 34.45,
            "sla_met": false,
            "sla_breach_hours": 10.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:34:30"
          },
          {
            "ticket_id": 553,
            "ticket_number": "35552",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:07:03",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:07:03"
          },
          {
            "ticket_id": 556,
            "ticket_number": "35555",
            "title": "Fwd: Viagify informa sobre a sua reserva 120928028",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:10:53",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:10:53"
          },
          {
            "ticket_id": 559,
            "ticket_number": "35558",
            "title": "Fwd: Viagify informa sobre a sua reserva 120934273",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:11:00",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:11:01"
          },
          {
            "ticket_id": 560,
            "ticket_number": "35559",
            "title": "Fwd: Viagify informa sobre a sua reserva 120920990",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:13:43",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 6.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:40:14"
          },
          {
            "ticket_id": 563,
            "ticket_number": "35562",
            "title": "Voucher prémio empresa",
            "priority": "P2",
            "created_at": "13/10/2025 09:14:55",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:14:55"
          },
          {
            "ticket_id": 568,
            "ticket_number": "35567",
            "title": "Envio documentos - (Recibo-231005804)  n. 10043481",
            "priority": "P2",
            "created_at": "13/10/2025 10:49:12",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 11:08:39"
          },
          {
            "ticket_id": 585,
            "ticket_number": "35584",
            "title": "GBN-85723 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 12:37:48",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 30.98,
            "sla_met": false,
            "sla_breach_hours": 6.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:37:27"
          },
          {
            "ticket_id": 590,
            "ticket_number": "35589",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 12:38:05",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:38:45"
          },
          {
            "ticket_id": 594,
            "ticket_number": "35593",
            "title": "confirmaao de reserva / fsffvb sdfsav",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 14:33:01",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 32.47,
            "sla_met": false,
            "sla_breach_hours": 8.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 23:01:49"
          },
          {
            "ticket_id": 599,
            "ticket_number": "35598",
            "title": "GBN-84940 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/10/2025 15:58:20",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 22.15,
            "sla_met": false,
            "sla_breach_hours": 18.15,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 14:08:13"
          },
          {
            "ticket_id": 600,
            "ticket_number": "35599",
            "title": "Confirmacao 332333",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 16:02:08",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 27.62,
            "sla_met": false,
            "sla_breach_hours": 3.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:39:57"
          },
          {
            "ticket_id": 604,
            "ticket_number": "35603",
            "title": "GBN-85762 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 16:37:57",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 46.18,
            "sla_met": false,
            "sla_breach_hours": 22.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:49:48"
          },
          {
            "ticket_id": 613,
            "ticket_number": "35612",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:00:32",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:00:32"
          },
          {
            "ticket_id": 614,
            "ticket_number": "35613",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:00:34",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:00:34"
          },
          {
            "ticket_id": 616,
            "ticket_number": "35615",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:08:16",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:08:16"
          },
          {
            "ticket_id": 617,
            "ticket_number": "35616",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:32:45",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 25.35,
            "sla_met": false,
            "sla_breach_hours": 1.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:54:30"
          },
          {
            "ticket_id": 618,
            "ticket_number": "35617",
            "title": "Reserva confirmada: Passeio de barco ao anoitecer ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:32:47",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:32:50"
          },
          {
            "ticket_id": 620,
            "ticket_number": "35619",
            "title": "Reserva confirmada: Passeio de barco ao anoitecer ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:32:50",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 25.4,
            "sla_met": false,
            "sla_breach_hours": 1.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:57:24"
          },
          {
            "ticket_id": 622,
            "ticket_number": "35621",
            "title": "Reserva confirmada: Ingresso da Basílica de Santo ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:32:55",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 25.38,
            "sla_met": false,
            "sla_breach_hours": 1.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:56:42"
          },
          {
            "ticket_id": 623,
            "ticket_number": "35622",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:32:57",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 44.1,
            "sla_met": false,
            "sla_breach_hours": 20.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:39:38"
          },
          {
            "ticket_id": 627,
            "ticket_number": "35626",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 20:28:03",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 23.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:52:16"
          },
          {
            "ticket_id": 631,
            "ticket_number": "35630",
            "title": "GBN-81440 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 20:48:18",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 22:54:41"
          },
          {
            "ticket_id": 632,
            "ticket_number": "35631",
            "title": "GBN-84172 e GBN-81440 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "13/10/2025 20:48:19",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 21:26:00"
          },
          {
            "ticket_id": 634,
            "ticket_number": "35633",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 21:32:15",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 22.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 19:50:05"
          },
          {
            "ticket_id": 637,
            "ticket_number": "35636",
            "title": "Confirmacao 332357",
            "priority": "P2",
            "created_at": "13/10/2025 23:01:17",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 10.37,
            "sla_met": false,
            "sla_breach_hours": 6.37,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 09:23:49"
          },
          {
            "ticket_id": 639,
            "ticket_number": "35638",
            "title": "Fwd: Viagify informa sobre a sua reserva 120980011",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:13:52",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 09:13:53"
          },
          {
            "ticket_id": 644,
            "ticket_number": "35643",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:45",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:17:27"
          },
          {
            "ticket_id": 645,
            "ticket_number": "35644",
            "title": "Adicione novas experiências para sua viagem GBN-66",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:47",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:20:17"
          },
          {
            "ticket_id": 646,
            "ticket_number": "35645",
            "title": "Reserva Aérea DQ2S9K",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:48",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:27:34"
          },
          {
            "ticket_id": 647,
            "ticket_number": "35646",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:51",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:29:05"
          },
          {
            "ticket_id": 649,
            "ticket_number": "35648",
            "title": "GBN-85830 - Su confirmación de reserva",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:58",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:52:03"
          },
          {
            "ticket_id": 650,
            "ticket_number": "35649",
            "title": "GBN-85834 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:18:02",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 29.5,
            "sla_met": false,
            "sla_breach_hours": 5.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:48:09"
          },
          {
            "ticket_id": 651,
            "ticket_number": "35650",
            "title": "Reserva Aérea DQ2S9K",
            "priority": "P2",
            "created_at": "14/10/2025 09:18:04",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:57:28"
          },
          {
            "ticket_id": 652,
            "ticket_number": "35651",
            "title": "Confirmation of booking with locatorRSO3OXSG",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:42:17",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 29.08,
            "sla_met": false,
            "sla_breach_hours": 5.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:47:42"
          },
          {
            "ticket_id": 653,
            "ticket_number": "35652",
            "title": "GBN-85838 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:42:20",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 29.07,
            "sla_met": false,
            "sla_breach_hours": 5.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:46:55"
          },
          {
            "ticket_id": 654,
            "ticket_number": "35653",
            "title": "GBN-85844 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 10:30:56",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 28.27,
            "sla_met": false,
            "sla_breach_hours": 4.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:47:10"
          },
          {
            "ticket_id": 669,
            "ticket_number": "35668",
            "title": "GBN-85874 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 12:49:40",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 14:12:41"
          },
          {
            "ticket_id": 682,
            "ticket_number": "35681",
            "title": "Reserva confirmada: Excursão a Cozumel - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 15:27:23",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 15:27:23"
          },
          {
            "ticket_id": 683,
            "ticket_number": "35682",
            "title": "GBN-85896 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 15:27:29",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 23.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:44:04"
          },
          {
            "ticket_id": 687,
            "ticket_number": "35686",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "14/10/2025 15:43:43",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 17:12:08"
          },
          {
            "ticket_id": 693,
            "ticket_number": "35692",
            "title": "GBN-85908 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/10/2025 16:57:05",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 17:35:11"
          },
          {
            "ticket_id": 697,
            "ticket_number": "35696",
            "title": "GBN-85959 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 17:58:43",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 20.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:43:21"
          },
          {
            "ticket_id": 706,
            "ticket_number": "35705",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/10/2025 19:10:14",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 19:10:14"
          },
          {
            "ticket_id": 707,
            "ticket_number": "35706",
            "title": "GBN-86001 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 21:00:49",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 17.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:41:47"
          },
          {
            "ticket_id": 709,
            "ticket_number": "35708",
            "title": "Reserva cancelada – Ref PP621324, Sr. Pedro Perdig",
            "priority": "P2",
            "created_at": "14/10/2025 22:01:38",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 23:04:43"
          },
          {
            "ticket_id": 710,
            "ticket_number": "35709",
            "title": "ALTERAÇÃO DA RESERVA  - REF PP621324-1, Sr. Jose P",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 22:01:40",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 16.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 14:59:21"
          },
          {
            "ticket_id": 712,
            "ticket_number": "35711",
            "title": "anulaao de reserva / fsffvb sdfsav",
            "priority": "P2",
            "created_at": "14/10/2025 23:03:26",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 23:05:59"
          },
          {
            "ticket_id": 720,
            "ticket_number": "35719",
            "title": "Reserva confirmada: Visita guiada por Pompeia - Ci",
            "priority": "P2",
            "created_at": "15/10/2025 09:29:34",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:38:24"
          },
          {
            "ticket_id": 721,
            "ticket_number": "35720",
            "title": "Reserva confirmada: Visita guiada por Pompeia - Ci",
            "priority": "P2",
            "created_at": "15/10/2025 09:29:36",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:38:51"
          },
          {
            "ticket_id": 727,
            "ticket_number": "35726",
            "title": "Orçamento 19520/25/27/45657 Rui Simões_Brasil",
            "priority": "P2",
            "created_at": "15/10/2025 10:13:33",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 5.82,
            "sla_met": false,
            "sla_breach_hours": 1.82,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 16:02:55"
          },
          {
            "ticket_id": 735,
            "ticket_number": "35734",
            "title": "GBN-86003 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/10/2025 11:15:35",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 11:47:28"
          },
          {
            "ticket_id": 743,
            "ticket_number": "35742",
            "title": "Fwd: Informações da sua reserva TTN-1210276553#838",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 13:10:09",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 13:10:10"
          },
          {
            "ticket_id": 745,
            "ticket_number": "35744",
            "title": "Fwd: Viagify informa sobre a sua reserva 121027655",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 13:10:14",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 16:12:52"
          },
          {
            "ticket_id": 746,
            "ticket_number": "35745",
            "title": "Fwd: Viagify informa sobre a sua reserva 121027655",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 13:10:17",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 3.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 16:13:31"
          },
          {
            "ticket_id": 747,
            "ticket_number": "35746",
            "title": "Re:[## 22832 ##] GBN-84172 - Seu pedido foi recebi",
            "priority": "P1",
            "created_at": "15/10/2025 13:45:43",
            "close_date": "2025-10-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.82,
            "sla_met": false,
            "sla_breach_hours": 1.57,
            "sla_name": "SLA P1",
            "first_response_at": "15/10/2025 15:35:24"
          },
          {
            "ticket_id": 748,
            "ticket_number": "35747",
            "title": "Re:[## 22832 ##] GBN-84172 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "15/10/2025 13:46:48",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 15:35:29"
          },
          {
            "ticket_id": 749,
            "ticket_number": "35748",
            "title": "Confirmacao 332419",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 14:53:16",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 7.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:11:01"
          },
          {
            "ticket_id": 751,
            "ticket_number": "35750",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604476805",
            "priority": "P2",
            "created_at": "15/10/2025 15:28:43",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:13:23"
          },
          {
            "ticket_id": 752,
            "ticket_number": "35751",
            "title": "RV: Confirmacion de la reserva Transavia: PJ6LSH",
            "priority": "P2",
            "created_at": "15/10/2025 15:56:34",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:27:32"
          },
          {
            "ticket_id": 755,
            "ticket_number": "35754",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604474717",
            "priority": "P2",
            "created_at": "15/10/2025 15:56:40",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:26:55"
          },
          {
            "ticket_id": 759,
            "ticket_number": "35758",
            "title": "Reserva alterada: Visita guiada por Pompeia",
            "priority": "P2",
            "created_at": "15/10/2025 16:29:53",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:32:47"
          },
          {
            "ticket_id": 763,
            "ticket_number": "35762",
            "title": "Envio de Documentação Financeira",
            "priority": "P2",
            "created_at": "15/10/2025 17:08:08",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:48:46"
          },
          {
            "ticket_id": 774,
            "ticket_number": "35773",
            "title": "Grupo: GR-439B4FBAE0",
            "priority": "P2",
            "created_at": "15/10/2025 18:49:13",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 19:31:14"
          },
          {
            "ticket_id": 786,
            "ticket_number": "35785",
            "title": "Confirmacao 332433",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 19:00:05",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 23.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/10/2025 18:05:08"
          },
          {
            "ticket_id": 788,
            "ticket_number": "35787",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604477059",
            "priority": "P2",
            "created_at": "15/10/2025 19:05:59",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 20:46:07"
          },
          {
            "ticket_id": 789,
            "ticket_number": "35788",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 21:47:51",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 117.02,
            "sla_met": false,
            "sla_breach_hours": 93.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 18:48:59"
          },
          {
            "ticket_id": 793,
            "ticket_number": "35792",
            "title": "Reserva confirmada: Cruzeiro noturno com jantar e ",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:24:05",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:42:08"
          },
          {
            "ticket_id": 794,
            "ticket_number": "35793",
            "title": "Dúvida sobre EXECUTIVE na Solférias",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:25:10",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:34:07"
          },
          {
            "ticket_id": 795,
            "ticket_number": "35794",
            "title": "Fwd: Viagify informa sobre a sua reserva 121051590",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:34:13",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:34:13"
          },
          {
            "ticket_id": 796,
            "ticket_number": "35795",
            "title": "Fwd: Viagify informa sobre a sua reserva 121051593",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:34:47",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:34:48"
          },
          {
            "ticket_id": 797,
            "ticket_number": "35796",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:40:17",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 42.58,
            "sla_met": false,
            "sla_breach_hours": 18.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:15:47"
          },
          {
            "ticket_id": 800,
            "ticket_number": "35799",
            "title": "GBN-86198 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 09:30:29",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 31.75,
            "sla_met": false,
            "sla_breach_hours": 7.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:16:28"
          },
          {
            "ticket_id": 801,
            "ticket_number": "35800",
            "title": "Reserva confirmada: Tour de 7 dias pelo melhor da ",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 09:30:31",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/10/2025 09:30:32"
          },
          {
            "ticket_id": 807,
            "ticket_number": "35806",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 12:23:13",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 34.1,
            "sla_met": false,
            "sla_breach_hours": 10.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:29:19"
          },
          {
            "ticket_id": 808,
            "ticket_number": "35807",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 12:23:19",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 34.32,
            "sla_met": false,
            "sla_breach_hours": 10.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:42:20"
          },
          {
            "ticket_id": 809,
            "ticket_number": "35808",
            "title": "GBN-86193 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 12:24:03",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 29.18,
            "sla_met": false,
            "sla_breach_hours": 5.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:35:04"
          },
          {
            "ticket_id": 815,
            "ticket_number": "35814",
            "title": "GBN-86252 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 14:02:31",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 32.45,
            "sla_met": false,
            "sla_breach_hours": 8.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:29:49"
          },
          {
            "ticket_id": 816,
            "ticket_number": "35815",
            "title": "RV: Confirmacion de la reserva Transavia: R9QMTV",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 14:02:34",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 124.0,
            "sla_met": false,
            "sla_breach_hours": 100.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:03:30"
          },
          {
            "ticket_id": 822,
            "ticket_number": "35821",
            "title": "Fwd: Informações sobre a sua reserva TTN-117129156",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 15:06:20",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 26.53,
            "sla_met": false,
            "sla_breach_hours": 2.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:38:54"
          },
          {
            "ticket_id": 823,
            "ticket_number": "35822",
            "title": "Fwd: easyJet booking reference: K8V2S44",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 15:10:37",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 173.05,
            "sla_met": false,
            "sla_breach_hours": 149.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 20:14:19"
          },
          {
            "ticket_id": 826,
            "ticket_number": "35825",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 16:00:16",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.5,
            "sla_met": false,
            "sla_breach_hours": 6.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:30:54"
          },
          {
            "ticket_id": 827,
            "ticket_number": "35826",
            "title": "GBN-86299 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 16:02:31",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.52,
            "sla_met": false,
            "sla_breach_hours": 1.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:33:32"
          },
          {
            "ticket_id": 829,
            "ticket_number": "35828",
            "title": "GBN-86304 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 16:32:26",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.1,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:38:42"
          },
          {
            "ticket_id": 833,
            "ticket_number": "35832",
            "title": "Reserva Aérea DRF22W",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:11:38",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/10/2025 18:25:10"
          },
          {
            "ticket_id": 837,
            "ticket_number": "35836",
            "title": "Reserva Aérea YYP7N6",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:18:10",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 23.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:45:09"
          },
          {
            "ticket_id": 839,
            "ticket_number": "35838",
            "title": "DRF22W – Novo prazo de emissão",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:25:10",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 23.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:50:34"
          },
          {
            "ticket_id": 841,
            "ticket_number": "35840",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (YYP",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:50:06",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 22.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:50:05"
          },
          {
            "ticket_id": 842,
            "ticket_number": "35841",
            "title": "DRF891 – Novo prazo de emissão",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:50:08",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/10/2025 18:50:09"
          },
          {
            "ticket_id": 843,
            "ticket_number": "35842",
            "title": "Reserva Aérea DRF891",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:50:09",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 22.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 17:49:22"
          },
          {
            "ticket_id": 846,
            "ticket_number": "35845",
            "title": "Confirmação de reserva com localizador: 3943296",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 21:50:36",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 24.68,
            "sla_met": false,
            "sla_breach_hours": 0.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:31:52"
          },
          {
            "ticket_id": 847,
            "ticket_number": "35846",
            "title": "Referencia para pagamento | File:413248/2025",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 21:59:10",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 24.58,
            "sla_met": false,
            "sla_breach_hours": 0.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:34:53"
          },
          {
            "ticket_id": 850,
            "ticket_number": "35849",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 22:12:12",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 92.65,
            "sla_met": false,
            "sla_breach_hours": 68.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 18:51:58"
          },
          {
            "ticket_id": 851,
            "ticket_number": "35850",
            "title": "GBN-86362 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 22:47:26",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 15.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 14:28:28"
          },
          {
            "ticket_id": 867,
            "ticket_number": "35866",
            "title": "Confirmación Transfer Agência: Uma Família Em Viag",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 14:24:14",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 99.88,
            "sla_met": false,
            "sla_breach_hours": 75.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:17:29"
          },
          {
            "ticket_id": 869,
            "ticket_number": "35868",
            "title": "GBN-86359 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 14:24:51",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 76.45,
            "sla_met": false,
            "sla_breach_hours": 52.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 18:52:44"
          },
          {
            "ticket_id": 870,
            "ticket_number": "35869",
            "title": "CONTROLO RESERVAS... - 300.00€ - 08/07/2025 300.00",
            "priority": "P2",
            "created_at": "17/10/2025 14:24:52",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 14:39:38"
          },
          {
            "ticket_id": 873,
            "ticket_number": "35872",
            "title": "CONTROLO RESERVAS - PAGAMENTOS - UMA FAMILIA EM VI",
            "priority": "P2",
            "created_at": "17/10/2025 14:25:30",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 14:40:12"
          },
          {
            "ticket_id": 877,
            "ticket_number": "35876",
            "title": "Re: autorização para emissão de bilhetes",
            "priority": "P2",
            "created_at": "17/10/2025 14:26:09",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 14:26:10"
          },
          {
            "ticket_id": 881,
            "ticket_number": "35880",
            "title": "GBN-86440 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 15:45:47",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 75.12,
            "sla_met": false,
            "sla_breach_hours": 51.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 18:53:13"
          },
          {
            "ticket_id": 890,
            "ticket_number": "35889",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 20:25:32",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 20:25:34"
          },
          {
            "ticket_id": 891,
            "ticket_number": "35890",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 20:25:34",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:50:20"
          },
          {
            "ticket_id": 902,
            "ticket_number": "35901",
            "title": "Confirmacao 332542",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 09:51:35",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 56.25,
            "sla_met": false,
            "sla_breach_hours": 32.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:06:57"
          },
          {
            "ticket_id": 907,
            "ticket_number": "35906",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 14:47:59",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 51.32,
            "sla_met": false,
            "sla_breach_hours": 27.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:07:49"
          },
          {
            "ticket_id": 908,
            "ticket_number": "35907",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 15:09:56",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 28.62,
            "sla_met": false,
            "sla_breach_hours": 4.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 19:47:50"
          },
          {
            "ticket_id": 913,
            "ticket_number": "35912",
            "title": "Informação de reserva - SPT002501546703",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 17:45:55",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 77.7,
            "sla_met": false,
            "sla_breach_hours": 53.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:28:37"
          },
          {
            "ticket_id": 914,
            "ticket_number": "35913",
            "title": "Fwd: Viagify informa sobre a sua reserva 121142146",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 17:45:57",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/10/2025 17:45:52"
          },
          {
            "ticket_id": 929,
            "ticket_number": "35928",
            "title": "Informação de reserva - SPT002501546715",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 09:21:34",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 60.58,
            "sla_met": false,
            "sla_breach_hours": 36.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 21:56:47"
          },
          {
            "ticket_id": 938,
            "ticket_number": "35937",
            "title": "Fwd: Incidente de voo TTN-1171291568#84139594#T151",
            "priority": "P2",
            "created_at": "20/10/2025 10:53:48",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 4.08,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 14:59:41"
          },
          {
            "ticket_id": 949,
            "ticket_number": "35948",
            "title": "Fwd: Viagify informa sobre a sua reserva 121169080",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 15:06:05",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 15:06:06"
          },
          {
            "ticket_id": 954,
            "ticket_number": "35953",
            "title": "Condições de Sinalização - Alteração",
            "priority": "P2",
            "created_at": "20/10/2025 15:10:01",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 16:16:36"
          },
          {
            "ticket_id": 979,
            "ticket_number": "35978",
            "title": "💛 Obrigada por fazeres parte da nossa história — R",
            "priority": "P2",
            "created_at": "20/10/2025 20:26:09",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 20:26:10"
          },
          {
            "ticket_id": 986,
            "ticket_number": "35985",
            "title": "GBN-86812 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 22:51:48",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 19.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:11:39"
          },
          {
            "ticket_id": 991,
            "ticket_number": "35990",
            "title": "Confirmacao 332628",
            "priority": "P2",
            "created_at": "21/10/2025 09:12:30",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:15:31"
          },
          {
            "ticket_id": 1010,
            "ticket_number": "351009",
            "title": "CONTROLO RESERVAS... - 150 - 17/06/2025 150 - 16/0",
            "priority": "P2",
            "created_at": "21/10/2025 11:04:28",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 13:29:21"
          },
          {
            "ticket_id": 1013,
            "ticket_number": "351012",
            "title": "Fwd: Confirmacion de la reserva Transavia: XBRJQC",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 12:28:15",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 150.22,
            "sla_met": false,
            "sla_breach_hours": 126.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 18:41:41"
          },
          {
            "ticket_id": 1025,
            "ticket_number": "351024",
            "title": "GBN-86897 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 14:10:55",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 16:26:08"
          },
          {
            "ticket_id": 1028,
            "ticket_number": "351026",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604477059",
            "priority": "P2",
            "created_at": "21/10/2025 14:52:08",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 17:44:56"
          },
          {
            "ticket_id": 1029,
            "ticket_number": "351027",
            "title": "GBN-86897 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/10/2025 14:52:09",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 16:26:16"
          },
          {
            "ticket_id": 1034,
            "ticket_number": "351032",
            "title": "RV: Confirmacion de la reserva Transavia: FDIR5T",
            "priority": "P2",
            "created_at": "21/10/2025 15:51:10",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:13:27"
          },
          {
            "ticket_id": 1039,
            "ticket_number": "351037",
            "title": "Re:[## 23383 ##] GBN-86897 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/10/2025 16:29:05",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:25:44"
          },
          {
            "ticket_id": 1059,
            "ticket_number": "351057",
            "title": "Traslado | Confirmação da reserva #431935701",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:11",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 28.72,
            "sla_met": false,
            "sla_breach_hours": 4.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 13:49:26"
          },
          {
            "ticket_id": 1068,
            "ticket_number": "351066",
            "title": "Fwd: Viagify informa sobre a sua reserva 121221204",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:18:48",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 09:18:49"
          },
          {
            "ticket_id": 1077,
            "ticket_number": "351075",
            "title": "GBN-87050 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 12:15:09",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 26.28,
            "sla_met": false,
            "sla_breach_hours": 2.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:32:25"
          },
          {
            "ticket_id": 1082,
            "ticket_number": "351080",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 12:15:20",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 26.3,
            "sla_met": false,
            "sla_breach_hours": 2.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:34:00"
          },
          {
            "ticket_id": 1091,
            "ticket_number": "351089",
            "title": "Fwd: Viagify informa sobre a sua reserva 121239310",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 14:51:41",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 14:51:42"
          },
          {
            "ticket_id": 1098,
            "ticket_number": "351096",
            "title": "1756159 W2M:013330007571",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:08:27",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 23.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:52:41"
          },
          {
            "ticket_id": 1101,
            "ticket_number": "351099",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:08:44",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 21.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:42:27"
          },
          {
            "ticket_id": 1108,
            "ticket_number": "351106",
            "title": "GBN-87094 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 18:20:51",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 18:20:52"
          },
          {
            "ticket_id": 1109,
            "ticket_number": "351107",
            "title": "GBN-87094 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 18:20:52",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 20.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:50:11"
          },
          {
            "ticket_id": 1110,
            "ticket_number": "351108",
            "title": "Fwd: Viagify informa sobre a sua reserva 121244679",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:04:21",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 17.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 13:46:51"
          },
          {
            "ticket_id": 1114,
            "ticket_number": "351112",
            "title": "Fwd: Información reserva. TTN-1212446796#84384311#",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:04:28",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 17.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 13:46:40"
          },
          {
            "ticket_id": 1117,
            "ticket_number": "351115",
            "title": "Faça o download da sua fatura - Civitatis.com",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:04:35",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 62.82,
            "sla_met": false,
            "sla_breach_hours": 38.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 10:54:03"
          },
          {
            "ticket_id": 1118,
            "ticket_number": "351116",
            "title": "GBN-87150 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:04:37",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 18.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:55:38"
          },
          {
            "ticket_id": 1123,
            "ticket_number": "351121",
            "title": "Reserva confirmada: Free tour por Florença - Civit",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:55:15",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 18.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:56:31"
          },
          {
            "ticket_id": 1124,
            "ticket_number": "351122",
            "title": "Número de informação da reserva: 6119956",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:55:50",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:06:24"
          },
          {
            "ticket_id": 1127,
            "ticket_number": "351125",
            "title": "GBN-87175 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 09:02:24",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 7.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:09:00"
          },
          {
            "ticket_id": 1128,
            "ticket_number": "351126",
            "title": "Adicione novas experiências para sua viagem GBN-85",
            "priority": "P2",
            "created_at": "23/10/2025 09:02:26",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 09:44:46"
          },
          {
            "ticket_id": 1132,
            "ticket_number": "351130",
            "title": "Fwd: Documentação da reserva TTN-1212212049#843483",
            "priority": "P2",
            "created_at": "23/10/2025 09:28:54",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 09:28:55"
          },
          {
            "ticket_id": 1143,
            "ticket_number": "351141",
            "title": "Confirmação de reserva 332768 ### TIME LIMIT EMISS",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 12:16:06",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 199.67,
            "sla_met": false,
            "sla_breach_hours": 175.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 19:56:25"
          },
          {
            "ticket_id": 1144,
            "ticket_number": "351142",
            "title": "Confirmação de reserva 332766  ####### TIME LIMIT ",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 12:16:07",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 199.67,
            "sla_met": false,
            "sla_breach_hours": 175.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 19:56:34"
          },
          {
            "ticket_id": 1146,
            "ticket_number": "351144",
            "title": "Confirmação de reserva 332769 ####### TIME LIMIT P",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 12:16:10",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 199.67,
            "sla_met": false,
            "sla_breach_hours": 175.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 19:56:14"
          },
          {
            "ticket_id": 1160,
            "ticket_number": "351158",
            "title": "Fwd: Viagify informa sobre a sua reserva 121269996",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 15:00:00",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 17:02:30"
          },
          {
            "ticket_id": 1163,
            "ticket_number": "351161",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:36:13",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:36:13"
          },
          {
            "ticket_id": 1164,
            "ticket_number": "351162",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:36:16",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:36:16"
          },
          {
            "ticket_id": 1165,
            "ticket_number": "351163",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:36:20",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:36:20"
          },
          {
            "ticket_id": 1166,
            "ticket_number": "351164",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:36:27",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 41.07,
            "sla_met": false,
            "sla_breach_hours": 17.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:40:46"
          },
          {
            "ticket_id": 1167,
            "ticket_number": "351165",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:44:32",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:44:32"
          },
          {
            "ticket_id": 1168,
            "ticket_number": "351166",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 16:48:21",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 40.92,
            "sla_met": false,
            "sla_breach_hours": 16.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:43:36"
          },
          {
            "ticket_id": 1171,
            "ticket_number": "351169",
            "title": "| Nova reserva GBN-86805 - envio de doc |",
            "priority": "P2",
            "created_at": "23/10/2025 18:06:09",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 18:06:09"
          },
          {
            "ticket_id": 1172,
            "ticket_number": "351170",
            "title": "GBN-87281 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 18:28:21",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 39.28,
            "sla_met": false,
            "sla_breach_hours": 15.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:45:24"
          },
          {
            "ticket_id": 1173,
            "ticket_number": "351171",
            "title": "Fwd: Pedro, your flight to Seychelles will be oper",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 18:44:21",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 18:44:21"
          },
          {
            "ticket_id": 1187,
            "ticket_number": "351184",
            "title": "GBN-87288 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:25",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:57:20"
          },
          {
            "ticket_id": 1194,
            "ticket_number": "351191",
            "title": "Contacto - Serviço para grupos",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:37",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:14:35"
          },
          {
            "ticket_id": 1196,
            "ticket_number": "351193",
            "title": "RV: Confirmacion de la reserva Transavia: UC53RP",
            "priority": "P2",
            "created_at": "24/10/2025 09:04:13",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:19:21"
          },
          {
            "ticket_id": 1232,
            "ticket_number": "351229",
            "title": "Reserva modificada: Excursão a Santo Domingo",
            "priority": "P2",
            "created_at": "24/10/2025 13:27:03",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 14:20:58"
          },
          {
            "ticket_id": 1239,
            "ticket_number": "351236",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "24/10/2025 14:47:32",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 14:50:30"
          },
          {
            "ticket_id": 1241,
            "ticket_number": "351238",
            "title": "GBN-87408 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 15:37:44",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 74.25,
            "sla_met": false,
            "sla_breach_hours": 50.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 17:52:57"
          },
          {
            "ticket_id": 1246,
            "ticket_number": "351243",
            "title": "GBN-87424 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 16:41:33",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 287.67,
            "sla_met": false,
            "sla_breach_hours": 263.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:22:28"
          },
          {
            "ticket_id": 1247,
            "ticket_number": "351244",
            "title": "GBN-87429 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 16:41:37",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 288.07,
            "sla_met": false,
            "sla_breach_hours": 264.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:45:46"
          },
          {
            "ticket_id": 1250,
            "ticket_number": "351247",
            "title": "Información de reserva número: 1757952",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 17:15:33",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 16.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:57:40"
          },
          {
            "ticket_id": 1252,
            "ticket_number": "351249",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 17:51:50",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/10/2025 17:51:50"
          },
          {
            "ticket_id": 1253,
            "ticket_number": "351250",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 17:51:53",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/10/2025 17:51:53"
          },
          {
            "ticket_id": 1254,
            "ticket_number": "351251",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 17:51:58",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/10/2025 17:51:58"
          },
          {
            "ticket_id": 1267,
            "ticket_number": "351264",
            "title": "Eticket - 66890519 - EU  14/11/2025  Barcelona, Es",
            "priority": "P2",
            "created_at": "25/10/2025 08:54:14",
            "close_date": "2025-10-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/10/2025 08:54:19"
          },
          {
            "ticket_id": 1274,
            "ticket_number": "351271",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "25/10/2025 13:11:02",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 50.38,
            "sla_met": false,
            "sla_breach_hours": 26.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 15:34:51"
          },
          {
            "ticket_id": 1279,
            "ticket_number": "351276",
            "title": "GBN-87503 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/10/2025 17:42:29",
            "close_date": "2025-10-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/10/2025 18:20:53"
          },
          {
            "ticket_id": 1284,
            "ticket_number": "351281",
            "title": "Confirmação de reserva para For PT004157 67570291",
            "priority": "Reservas sem Formulário",
            "created_at": "26/10/2025 10:15:14",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 29.33,
            "sla_met": false,
            "sla_breach_hours": 5.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 15:35:36"
          },
          {
            "ticket_id": 1288,
            "ticket_number": "351285",
            "title": "Fwd: Confirmação de reserva para For AMILCAR MIRAN",
            "priority": "P2",
            "created_at": "26/10/2025 12:21:27",
            "close_date": "2025-10-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 12:56:56"
          },
          {
            "ticket_id": 1293,
            "ticket_number": "351290",
            "title": "GBN-87493 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:26",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 5.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 15:36:09"
          },
          {
            "ticket_id": 1294,
            "ticket_number": "351291",
            "title": "GBN-87500 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:34",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 5.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 15:36:50"
          },
          {
            "ticket_id": 1300,
            "ticket_number": "351297",
            "title": "Reserva confirmada: Free tour por Bratislava - Civ",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:57",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 5.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 15:37:53"
          },
          {
            "ticket_id": 1301,
            "ticket_number": "351298",
            "title": "Fwd: Informações importantes sobre o seu voo para ",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:59",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:07:00"
          },
          {
            "ticket_id": 1306,
            "ticket_number": "351303",
            "title": "Fwd: Confirmacion de la reserva Transavia: CYWMXP",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:07:09",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:07:10"
          },
          {
            "ticket_id": 1309,
            "ticket_number": "351306",
            "title": "Reserva confirmada: Free tour por Viena - Civitati",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:07:16",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 18:09:50"
          },
          {
            "ticket_id": 1313,
            "ticket_number": "351310",
            "title": "Nova Viagem #251000275 - Rota dos Sonhos",
            "priority": "P2",
            "created_at": "27/10/2025 10:11:39",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:11:39"
          },
          {
            "ticket_id": 1322,
            "ticket_number": "351319",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "27/10/2025 12:06:02",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:26:06"
          },
          {
            "ticket_id": 1323,
            "ticket_number": "351320",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "27/10/2025 12:06:03",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:27:11"
          },
          {
            "ticket_id": 1324,
            "ticket_number": "351321",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "27/10/2025 12:06:05",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:25:27"
          },
          {
            "ticket_id": 1335,
            "ticket_number": "351332",
            "title": "GBN-87605 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 13:57:42",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 53.1,
            "sla_met": false,
            "sla_breach_hours": 29.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:04:17"
          },
          {
            "ticket_id": 1336,
            "ticket_number": "351333",
            "title": "Número de informação da reserva: 6120100",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 14:23:46",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 52.68,
            "sla_met": false,
            "sla_breach_hours": 28.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:05:01"
          },
          {
            "ticket_id": 1337,
            "ticket_number": "351334",
            "title": "Fwd: Viagify informa sobre a sua reserva 121372990",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 14:35:37",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 14:35:38"
          },
          {
            "ticket_id": 1350,
            "ticket_number": "351347",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 17:40:25",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 17:40:25"
          },
          {
            "ticket_id": 1351,
            "ticket_number": "351348",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/10/2025 17:40:30",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 18:31:37"
          },
          {
            "ticket_id": 1352,
            "ticket_number": "351349",
            "title": "Número de informação da reserva: 6120114",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 17:40:34",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 49.45,
            "sla_met": false,
            "sla_breach_hours": 25.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:07:58"
          },
          {
            "ticket_id": 1368,
            "ticket_number": "351365",
            "title": "Fwd: Acompanhamento do procedimento TTN-1210584648",
            "priority": "P2",
            "created_at": "27/10/2025 19:35:56",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:35:56"
          },
          {
            "ticket_id": 1369,
            "ticket_number": "351366",
            "title": "GBN-87613 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 19:43:54",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 47.47,
            "sla_met": false,
            "sla_breach_hours": 23.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:12:51"
          },
          {
            "ticket_id": 1370,
            "ticket_number": "351367",
            "title": "GBN-87613 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 19:44:00",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 20:27:03"
          },
          {
            "ticket_id": 1372,
            "ticket_number": "351369",
            "title": "GBN-87682 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 20:24:27",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 46.73,
            "sla_met": false,
            "sla_breach_hours": 22.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:09:24"
          },
          {
            "ticket_id": 1375,
            "ticket_number": "351372",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:30:11",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 22:13:58"
          },
          {
            "ticket_id": 1376,
            "ticket_number": "351373",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:39:35",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 22:14:30"
          },
          {
            "ticket_id": 1377,
            "ticket_number": "351374",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:41:17",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 22:14:37"
          },
          {
            "ticket_id": 1378,
            "ticket_number": "351375",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:47:13",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 22:12:36"
          },
          {
            "ticket_id": 1379,
            "ticket_number": "351376",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:47:16",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 22:12:43"
          },
          {
            "ticket_id": 1383,
            "ticket_number": "351380",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 22:22:42",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 44.82,
            "sla_met": false,
            "sla_breach_hours": 20.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:11:46"
          },
          {
            "ticket_id": 1384,
            "ticket_number": "351381",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 22:22:44",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 44.82,
            "sla_met": false,
            "sla_breach_hours": 20.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:12:34"
          },
          {
            "ticket_id": 1385,
            "ticket_number": "351382",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 22:22:46",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 44.82,
            "sla_met": false,
            "sla_breach_hours": 20.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:12:40"
          },
          {
            "ticket_id": 1386,
            "ticket_number": "351383",
            "title": "Fwd: Ryanair 69664256/Miguel Cena/Miguel Cena",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 22:22:47",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 45.12,
            "sla_met": false,
            "sla_breach_hours": 21.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:30:11"
          },
          {
            "ticket_id": 1387,
            "ticket_number": "351384",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 22:22:49",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 45.02,
            "sla_met": false,
            "sla_breach_hours": 21.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:24:34"
          },
          {
            "ticket_id": 1400,
            "ticket_number": "351397",
            "title": "Fwd: Portão de embarque atribuído para o seu voo",
            "priority": "P2",
            "created_at": "28/10/2025 10:40:52",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:40:52"
          },
          {
            "ticket_id": 1401,
            "ticket_number": "351398",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 10:41:30",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 32.5,
            "sla_met": false,
            "sla_breach_hours": 8.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:11:37"
          },
          {
            "ticket_id": 1403,
            "ticket_number": "351400",
            "title": "GBN-87711 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 11:09:54",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 36.72,
            "sla_met": false,
            "sla_breach_hours": 12.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:52:57"
          },
          {
            "ticket_id": 1404,
            "ticket_number": "351401",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-87",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 11:20:02",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/10/2025 14:30:23"
          },
          {
            "ticket_id": 1419,
            "ticket_number": "351416",
            "title": "\"GBN-87699 - Your request has been received\"",
            "priority": "P2",
            "created_at": "28/10/2025 12:58:13",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 12:59:05"
          },
          {
            "ticket_id": 1428,
            "ticket_number": "351425",
            "title": "GBN-87712 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 14:30:25",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 28.88,
            "sla_met": false,
            "sla_breach_hours": 4.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:23:39"
          },
          {
            "ticket_id": 1433,
            "ticket_number": "351430",
            "title": "Aproveite o Stopover em Angola com a TAAG! ✈️",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:09",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:17:08"
          },
          {
            "ticket_id": 1435,
            "ticket_number": "351432",
            "title": " Novidades sobre atribuição de comissões às agênci",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:12",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:17:49"
          },
          {
            "ticket_id": 1437,
            "ticket_number": "351434",
            "title": "Fwd: Novidades sobre atribuição de comissões às ag",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:16",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:04:16"
          },
          {
            "ticket_id": 1439,
            "ticket_number": "351436",
            "title": "GBN-87774 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:22",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:23:46"
          },
          {
            "ticket_id": 1440,
            "ticket_number": "351437",
            "title": "Fwd: Viagify informa sobre a sua reserva 121414729",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 17:04:26",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/10/2025 17:04:26"
          },
          {
            "ticket_id": 1441,
            "ticket_number": "351438",
            "title": "GBN-87769 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:31",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:25:28"
          },
          {
            "ticket_id": 1448,
            "ticket_number": "351445",
            "title": "Número de informação da reserva: 6120164",
            "priority": "P2",
            "created_at": "28/10/2025 21:28:01",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 13.68,
            "sla_met": false,
            "sla_breach_hours": 9.68,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 11:09:01"
          },
          {
            "ticket_id": 1452,
            "ticket_number": "351449",
            "title": "Fwd: Verification code",
            "priority": "P2",
            "created_at": "28/10/2025 21:29:19",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 21:29:19"
          },
          {
            "ticket_id": 1456,
            "ticket_number": "351453",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "28/10/2025 22:59:36",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 12.43,
            "sla_met": false,
            "sla_breach_hours": 8.43,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 11:25:59"
          },
          {
            "ticket_id": 1457,
            "ticket_number": "351454",
            "title": "Nova Viagem #251000296 - Maria Moreira",
            "priority": "P2",
            "created_at": "28/10/2025 22:59:37",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 22:59:37"
          },
          {
            "ticket_id": 1458,
            "ticket_number": "351455",
            "title": "RE:  Formação Certificada | Lei das Agências de Vi",
            "priority": "P2",
            "created_at": "28/10/2025 22:59:40",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 12.5,
            "sla_met": false,
            "sla_breach_hours": 8.5,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 11:29:53"
          },
          {
            "ticket_id": 1466,
            "ticket_number": "351463",
            "title": "GBN-87859 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/10/2025 23:48:40",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 11.72,
            "sla_met": false,
            "sla_breach_hours": 7.72,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 11:32:28"
          },
          {
            "ticket_id": 1474,
            "ticket_number": "351471",
            "title": "Fwd: Viagify informa sobre a sua reserva 121420858",
            "priority": "P2",
            "created_at": "29/10/2025 10:25:18",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 21:28:04"
          },
          {
            "ticket_id": 1476,
            "ticket_number": "351473",
            "title": "Confirmação reserva Bedsonline 58-4654758",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 10:25:23",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 8.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:14:29"
          },
          {
            "ticket_id": 1478,
            "ticket_number": "351475",
            "title": "Fwd: Viagify informa sobre a sua reserva 121420151",
            "priority": "P2",
            "created_at": "29/10/2025 10:25:27",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 10:25:28"
          },
          {
            "ticket_id": 1479,
            "ticket_number": "351476",
            "title": "Icárion - Istambul, Capadócia & Maurícia - 01/07/2",
            "priority": "P2",
            "created_at": "29/10/2025 10:25:29",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 13:12:48"
          },
          {
            "ticket_id": 1490,
            "ticket_number": "351487",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802049929",
            "priority": "P2",
            "created_at": "29/10/2025 13:02:08",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 13:37:07"
          },
          {
            "ticket_id": 1497,
            "ticket_number": "351494",
            "title": "Confirmação reserva Bedsonline 58-4654853",
            "priority": "P2",
            "created_at": "29/10/2025 15:33:24",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 16:41:43"
          },
          {
            "ticket_id": 1502,
            "ticket_number": "351499",
            "title": "Informação de reserva - SPT002501548337",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 16:04:02",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 3.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:15:59"
          },
          {
            "ticket_id": 1512,
            "ticket_number": "351509",
            "title": "Fwd: Viagify informa sobre a sua reserva 121448547",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 18:13:43",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 18:13:44"
          },
          {
            "ticket_id": 1513,
            "ticket_number": "351510",
            "title": "Fwd: Confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 18:13:45",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 18:13:46"
          },
          {
            "ticket_id": 1514,
            "ticket_number": "351511",
            "title": "Fwd: Viagify informa sobre a sua reserva 121448611",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 18:13:48",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 18:13:49"
          },
          {
            "ticket_id": 1526,
            "ticket_number": "351523",
            "title": "Referencia para pagamento | File:c/2025",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 22:25:22",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 47.18,
            "sla_met": false,
            "sla_breach_hours": 23.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 21:37:02"
          },
          {
            "ticket_id": 1563,
            "ticket_number": "351560",
            "title": "Viagify informa sobre a sua reserva 1214208580 Neu",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 15:10:57",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 15:10:57"
          },
          {
            "ticket_id": 1574,
            "ticket_number": "351571",
            "title": "RE: FW: Soltropico 332519 RGPD CVO",
            "priority": "P2",
            "created_at": "30/10/2025 16:44:56",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:44:56"
          },
          {
            "ticket_id": 1575,
            "ticket_number": "351572",
            "title": "Ana Rita Silva | Contrato + RGPD",
            "priority": "P2",
            "created_at": "30/10/2025 16:45:00",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:45:00"
          },
          {
            "ticket_id": 1577,
            "ticket_number": "351574",
            "title": "Fwd: Localizador 1214275701 - SmyTravel informa TT",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 17:26:20",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 19:52:17"
          },
          {
            "ticket_id": 1580,
            "ticket_number": "351577",
            "title": "Informação de reserva - SPT002501548337",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 17:40:30",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 17:57:54"
          },
          {
            "ticket_id": 1581,
            "ticket_number": "351578",
            "title": "Fwd: Localizador 1214277898 - SmyTravel informa TT",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 17:40:34",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 2.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 19:52:23"
          },
          {
            "ticket_id": 1592,
            "ticket_number": "351589",
            "title": "Fwd: Viagify informa sobre a sua reserva 121490730",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 23:27:38",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 23:27:38"
          },
          {
            "ticket_id": 1594,
            "ticket_number": "351591",
            "title": "GBN-88141 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 23:43:15",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 20.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 20:00:09"
          },
          {
            "ticket_id": 1597,
            "ticket_number": "351594",
            "title": "GBN-88146 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "31/10/2025 10:11:19",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:19:44"
          },
          {
            "ticket_id": 1605,
            "ticket_number": "351602",
            "title": "Envio de documentos de File 414136 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "31/10/2025 10:36:46",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:38:36"
          },
          {
            "ticket_id": 1610,
            "ticket_number": "351607",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 11:59:35",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 9.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 21:31:13"
          },
          {
            "ticket_id": 1612,
            "ticket_number": "351609",
            "title": "GBN-88138 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/10/2025 12:08:45",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 12:19:36"
          },
          {
            "ticket_id": 1622,
            "ticket_number": "351619",
            "title": "Voo + Hotel | Marraquexe",
            "priority": "P2",
            "created_at": "31/10/2025 13:46:22",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:48:11"
          },
          {
            "ticket_id": 1626,
            "ticket_number": "351623",
            "title": "GBN-88165 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/10/2025 15:02:45",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 15:04:22"
          },
          {
            "ticket_id": 1629,
            "ticket_number": "351626",
            "title": "Fwd: Viagify informa sobre a sua reserva 121505138",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 15:02:51",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 15:02:51"
          },
          {
            "ticket_id": 1630,
            "ticket_number": "351627",
            "title": "Fwd: Confirmacion de la reserva Transavia: YH5H3N",
            "priority": "P2",
            "created_at": "31/10/2025 15:02:53",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 15:02:53"
          },
          {
            "ticket_id": 1631,
            "ticket_number": "351628",
            "title": "GBN-88165 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "31/10/2025 15:02:59",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 15:11:36"
          },
          {
            "ticket_id": 1660,
            "ticket_number": "351657",
            "title": "Criação de processo File 414810/25",
            "priority": "Reservas sem Formulário",
            "created_at": "01/11/2025 13:27:10",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 98.82,
            "sla_met": false,
            "sla_breach_hours": 74.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:16:21"
          },
          {
            "ticket_id": 1661,
            "ticket_number": "351658",
            "title": "Criação de processo File 414811/25",
            "priority": "Reservas sem Formulário",
            "created_at": "01/11/2025 13:27:17",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 98.82,
            "sla_met": false,
            "sla_breach_hours": 74.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:16:56"
          },
          {
            "ticket_id": 1676,
            "ticket_number": "351673",
            "title": "Fwd: Important information about wifi on board on ",
            "priority": "P2",
            "created_at": "02/11/2025 10:47:36",
            "close_date": "2025-11-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/11/2025 10:47:37"
          },
          {
            "ticket_id": 1683,
            "ticket_number": "351680",
            "title": "GBN-88372 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/11/2025 16:39:38",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 25.93,
            "sla_met": false,
            "sla_breach_hours": 1.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 18:36:11"
          },
          {
            "ticket_id": 1687,
            "ticket_number": "351684",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604485939",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:30",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:49:02"
          },
          {
            "ticket_id": 1692,
            "ticket_number": "351689",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604485940",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:39",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:53:28"
          },
          {
            "ticket_id": 1705,
            "ticket_number": "351702",
            "title": "Anulação de processo File 395146/25",
            "priority": "P2",
            "created_at": "03/11/2025 10:37:25",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 11:10:32"
          },
          {
            "ticket_id": 1706,
            "ticket_number": "351703",
            "title": "Anulação de processo File 395143/25",
            "priority": "P2",
            "created_at": "03/11/2025 10:37:27",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 11:11:02"
          },
          {
            "ticket_id": 1729,
            "ticket_number": "351726",
            "title": "Reserva confirmada: Ingressos da Galeria Uffizi se",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:11",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 18:34:57"
          },
          {
            "ticket_id": 1730,
            "ticket_number": "351727",
            "title": "Reserva confirmada: Ingresso dos Jardins de Boboli",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:14",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 13:20:14"
          },
          {
            "ticket_id": 1731,
            "ticket_number": "351728",
            "title": "Reserva confirmada: Excursão a Pisa, San Gimignano",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:17",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 13:20:17"
          },
          {
            "ticket_id": 1732,
            "ticket_number": "351729",
            "title": "Reserva confirmada: Ingresso do Palácio Pitti e da",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:19",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 51.08,
            "sla_met": false,
            "sla_breach_hours": 27.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:25:21"
          },
          {
            "ticket_id": 1733,
            "ticket_number": "351730",
            "title": "Reserva confirmada: Ingressos da Galeria Uffizi se",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:22",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 13:20:22"
          },
          {
            "ticket_id": 1734,
            "ticket_number": "351731",
            "title": "Reserva confirmada: Ingressos da Galeria da Academ",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:24",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 13:20:24"
          },
          {
            "ticket_id": 1735,
            "ticket_number": "351732",
            "title": "Reserva confirmada: Ingresso da Catedral de Floren",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 13:20:28",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 18:35:07"
          },
          {
            "ticket_id": 1754,
            "ticket_number": "351751",
            "title": "Fwd: Viagify informa sobre a sua reserva 121576535",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 16:59:02",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/11/2025 16:59:02"
          },
          {
            "ticket_id": 1757,
            "ticket_number": "351754",
            "title": "Réveillon Inesquecível na Capadócia – Reserve Já c",
            "priority": "P2",
            "created_at": "03/11/2025 18:08:19",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:51:27"
          },
          {
            "ticket_id": 1776,
            "ticket_number": "351773",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 20:00:58",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 44.02,
            "sla_met": false,
            "sla_breach_hours": 20.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:02:39"
          },
          {
            "ticket_id": 1778,
            "ticket_number": "351775",
            "title": "Fwd: Viagify informa sobre a sua reserva 121586419",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 20:22:04",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 45.35,
            "sla_met": false,
            "sla_breach_hours": 21.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 17:43:48"
          },
          {
            "ticket_id": 1780,
            "ticket_number": "351777",
            "title": "Fwd: Viagify informa sobre a sua reserva 121586419",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 21:07:33",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 43.37,
            "sla_met": false,
            "sla_breach_hours": 19.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:29:53"
          },
          {
            "ticket_id": 1783,
            "ticket_number": "351780",
            "title": "Informação de reserva - SPT002501549170",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 21:40:01",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 42.83,
            "sla_met": false,
            "sla_breach_hours": 18.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:30:28"
          },
          {
            "ticket_id": 1784,
            "ticket_number": "351781",
            "title": "GBN-88561 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 21:40:03",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 43.27,
            "sla_met": false,
            "sla_breach_hours": 19.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:56:43"
          },
          {
            "ticket_id": 1802,
            "ticket_number": "351799",
            "title": "Confirmation of booking with locatorLJ3H1LIP",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 10:10:47",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 30.37,
            "sla_met": false,
            "sla_breach_hours": 6.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:33:45"
          },
          {
            "ticket_id": 1831,
            "ticket_number": "351828",
            "title": "GBN-88705 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 17:34:28",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 23.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:38:35"
          },
          {
            "ticket_id": 1844,
            "ticket_number": "351841",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 21:32:12",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/11/2025 21:32:12"
          },
          {
            "ticket_id": 1845,
            "ticket_number": "351842",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 21:32:21",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/11/2025 21:32:21"
          },
          {
            "ticket_id": 1846,
            "ticket_number": "351843",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 21:33:04",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/11/2025 21:33:05"
          },
          {
            "ticket_id": 1848,
            "ticket_number": "351845",
            "title": "Reserva confirmada: Ingresso da Basílica de São Ma",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 22:26:25",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 18.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:44:41"
          },
          {
            "ticket_id": 1849,
            "ticket_number": "351846",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 22:26:32",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 18.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:42:13"
          },
          {
            "ticket_id": 1860,
            "ticket_number": "351857",
            "title": "GBN-88755 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/11/2025 10:48:18",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 5.88,
            "sla_met": false,
            "sla_breach_hours": 1.88,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 16:42:00"
          },
          {
            "ticket_id": 1891,
            "ticket_number": "351888",
            "title": "Confirmação de reserva com localizador: 3964493",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 20:46:48",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 18.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 15:46:07"
          },
          {
            "ticket_id": 1897,
            "ticket_number": "351894",
            "title": "Criação de processo File 415145/25",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 22:23:30",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 17.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 15:46:49"
          },
          {
            "ticket_id": 1898,
            "ticket_number": "351895",
            "title": "Criação de processo File 415146/25",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 22:26:49",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 17.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 15:47:14"
          },
          {
            "ticket_id": 1902,
            "ticket_number": "351899",
            "title": "Confirmacao 333282",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 23:15:58",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 16.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 15:47:59"
          },
          {
            "ticket_id": 1905,
            "ticket_number": "351902",
            "title": "Confirmação de reserva com localizador: 3964563",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 23:43:14",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 16.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 15:48:52"
          },
          {
            "ticket_id": 1922,
            "ticket_number": "351919",
            "title": "Fwd: ⏰ Oferta Exclusiva Flagworld +23 Hoteís com 8",
            "priority": "P2",
            "created_at": "06/11/2025 10:39:08",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:39:08"
          },
          {
            "ticket_id": 1938,
            "ticket_number": "351935",
            "title": "Envio de documentos de File 415117/25",
            "priority": "P2",
            "created_at": "06/11/2025 13:37:32",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 14:04:42"
          },
          {
            "ticket_id": 1950,
            "ticket_number": "351946",
            "title": "Confirmação de Reserva * File 415146",
            "priority": "P2",
            "created_at": "06/11/2025 17:31:38",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:58:37"
          },
          {
            "ticket_id": 1965,
            "ticket_number": "351961",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/11/2025 19:30:23",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:25:05"
          },
          {
            "ticket_id": 1972,
            "ticket_number": "351968",
            "title": "Fwd: Viagify informa sobre a sua reserva 121683314",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 10:14:47",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 10:14:47"
          },
          {
            "ticket_id": 1985,
            "ticket_number": "351981",
            "title": "GBN-88499 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/11/2025 11:07:01",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 11:28:11"
          },
          {
            "ticket_id": 1986,
            "ticket_number": "351982",
            "title": "GBN-88444 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/11/2025 11:07:08",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 11:29:09"
          },
          {
            "ticket_id": 1989,
            "ticket_number": "351985",
            "title": "GBN-89077 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 11:07:57",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 4.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 15:29:20"
          },
          {
            "ticket_id": 2026,
            "ticket_number": "352022",
            "title": "Criação de processo File 415384/25",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 20:06:13",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 67.9,
            "sla_met": false,
            "sla_breach_hours": 43.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:00:18"
          },
          {
            "ticket_id": 2046,
            "ticket_number": "352042",
            "title": "Solole. Booking G0Y20UGS is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "08/11/2025 14:03:35",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 49.97,
            "sla_met": false,
            "sla_breach_hours": 25.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:02:10"
          },
          {
            "ticket_id": 2053,
            "ticket_number": "352049",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:48:59",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 127.45,
            "sla_met": false,
            "sla_breach_hours": 103.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:16:57"
          },
          {
            "ticket_id": 2055,
            "ticket_number": "352051",
            "title": "Criação de processo File 415420/25",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:49:10",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:07:33"
          },
          {
            "ticket_id": 2056,
            "ticket_number": "352052",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:49:14",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:08:07"
          },
          {
            "ticket_id": 2057,
            "ticket_number": "352053",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604489162",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:49:18",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 80.23,
            "sla_met": false,
            "sla_breach_hours": 56.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 20:03:54"
          },
          {
            "ticket_id": 2058,
            "ticket_number": "352054",
            "title": "GBN-89280 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:49:21",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.32,
            "sla_met": false,
            "sla_breach_hours": 4.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:08:53"
          },
          {
            "ticket_id": 2064,
            "ticket_number": "352060",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:04:43",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 23.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:10:42"
          },
          {
            "ticket_id": 2069,
            "ticket_number": "352065",
            "title": "Fwd: Viagify informa sobre a sua reserva 121731566",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:44",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/11/2025 17:58:45"
          },
          {
            "ticket_id": 2071,
            "ticket_number": "352067",
            "title": "Fwd: Viagify informa sobre a sua reserva 121744955",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:51",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 22.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:12:39"
          },
          {
            "ticket_id": 2089,
            "ticket_number": "352085",
            "title": "GBN-89294 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:43",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:30:59"
          },
          {
            "ticket_id": 2116,
            "ticket_number": "352112",
            "title": "Criação de processo File 415457/25",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 12:29:14",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 13:46:32"
          },
          {
            "ticket_id": 2136,
            "ticket_number": "352132",
            "title": "RE: Formulário para pedido de cotaçãoIATA",
            "priority": "P2",
            "created_at": "10/11/2025 16:59:18",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:59:18"
          },
          {
            "ticket_id": 2137,
            "ticket_number": "352133",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "10/11/2025 17:08:18",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 17:08:18"
          },
          {
            "ticket_id": 2138,
            "ticket_number": "352134",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 17:08:57",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 17:08:57"
          },
          {
            "ticket_id": 2139,
            "ticket_number": "352135",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "10/11/2025 17:09:01",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 17:09:01"
          },
          {
            "ticket_id": 2141,
            "ticket_number": "352137",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "10/11/2025 17:17:44",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 17:17:44"
          },
          {
            "ticket_id": 2142,
            "ticket_number": "352138",
            "title": "Confirmation of booking with locatorPW43D8FK",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 17:26:37",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 30.3,
            "sla_met": false,
            "sla_breach_hours": 6.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 23:45:16"
          },
          {
            "ticket_id": 2148,
            "ticket_number": "352144",
            "title": "GBN-89425 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 17:44:25",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 30.02,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 23:45:49"
          },
          {
            "ticket_id": 2161,
            "ticket_number": "352157",
            "title": "Fwd: Viagify informa sobre a sua reserva 121779316",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 21:37:43",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 21:37:44"
          },
          {
            "ticket_id": 2163,
            "ticket_number": "352159",
            "title": "Referencia para pagamento | File:415469/2025",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 22:24:04",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 44.57,
            "sla_met": false,
            "sla_breach_hours": 20.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 18:58:56"
          },
          {
            "ticket_id": 2164,
            "ticket_number": "352160",
            "title": "Referencia para pagamento | File:415457/2025",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 22:24:05",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 44.57,
            "sla_met": false,
            "sla_breach_hours": 20.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 18:58:47"
          },
          {
            "ticket_id": 2187,
            "ticket_number": "352183",
            "title": "Fwd: Formação | Conheça as novas funcionalidades P",
            "priority": "P2",
            "created_at": "11/11/2025 11:22:05",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 11:22:06"
          },
          {
            "ticket_id": 2201,
            "ticket_number": "352197",
            "title": "Grupo: GR-38AE8645D4",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 15:57:24",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 27.92,
            "sla_met": false,
            "sla_breach_hours": 3.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:53:16"
          },
          {
            "ticket_id": 2205,
            "ticket_number": "352201",
            "title": "Reserva confirmada: Excursão a Ouarzazate - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 16:27:39",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 26.63,
            "sla_met": false,
            "sla_breach_hours": 2.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:05:40"
          },
          {
            "ticket_id": 2206,
            "ticket_number": "352202",
            "title": "Reserva confirmada: Passeio de camelo pelo deserto",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 16:27:41",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 26.63,
            "sla_met": false,
            "sla_breach_hours": 2.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:06:03"
          },
          {
            "ticket_id": 2207,
            "ticket_number": "352203",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 16:27:44",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 26.62,
            "sla_met": false,
            "sla_breach_hours": 2.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:04:58"
          },
          {
            "ticket_id": 2210,
            "ticket_number": "352206",
            "title": "Envio de documentação - FILE 396561",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 16:55:17",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 6.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 23:49:19"
          },
          {
            "ticket_id": 2211,
            "ticket_number": "352207",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604490259",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 16:55:50",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 6.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 23:49:32"
          },
          {
            "ticket_id": 2214,
            "ticket_number": "352210",
            "title": "Envio de documentos de File 415457/25",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 17:18:26",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 25.83,
            "sla_met": false,
            "sla_breach_hours": 1.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:09:22"
          },
          {
            "ticket_id": 2217,
            "ticket_number": "352213",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P2",
            "created_at": "11/11/2025 18:29:21",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:05:17"
          },
          {
            "ticket_id": 2220,
            "ticket_number": "352216",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P2",
            "created_at": "11/11/2025 18:29:27",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:20:40"
          },
          {
            "ticket_id": 2225,
            "ticket_number": "352221",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 19:12:58",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 19:12:59"
          },
          {
            "ticket_id": 2226,
            "ticket_number": "352222",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 19:13:03",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 19:13:03"
          },
          {
            "ticket_id": 2227,
            "ticket_number": "352223",
            "title": "Fwd: Request received for Ana Vasconcelos",
            "priority": "P2",
            "created_at": "11/11/2025 19:13:08",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:13:08"
          },
          {
            "ticket_id": 2231,
            "ticket_number": "352227",
            "title": "Criação de processo File 415693/25",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 20:46:09",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 51.5,
            "sla_met": false,
            "sla_breach_hours": 27.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 00:17:03"
          },
          {
            "ticket_id": 2232,
            "ticket_number": "352228",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-89",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 21:51:33",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/11/2025 23:49:41"
          },
          {
            "ticket_id": 2236,
            "ticket_number": "352232",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 22:23:03",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 20.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:13:45"
          },
          {
            "ticket_id": 2242,
            "ticket_number": "352238",
            "title": "GBN-89696 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 22:47:22",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 21.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:53:54"
          },
          {
            "ticket_id": 2247,
            "ticket_number": "352243",
            "title": "Fwd: GBN-89694 - opti242100150",
            "priority": "P2",
            "created_at": "11/11/2025 23:38:30",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 23:40:21"
          },
          {
            "ticket_id": 2248,
            "ticket_number": "352244",
            "title": "GBN-89702 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 23:54:26",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 20.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:55:48"
          },
          {
            "ticket_id": 2259,
            "ticket_number": "352255",
            "title": "GBN-89706 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "12/11/2025 10:40:00",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 9.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:56:12"
          },
          {
            "ticket_id": 2267,
            "ticket_number": "352263",
            "title": "Aceite: Reunião Geral Suporte @ qui. 13 Nov. 2025 ",
            "priority": "P2",
            "created_at": "12/11/2025 11:47:11",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 13:24:44"
          },
          {
            "ticket_id": 2307,
            "ticket_number": "352302",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "12/11/2025 17:27:29",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:35:39"
          },
          {
            "ticket_id": 2308,
            "ticket_number": "352303",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "12/11/2025 17:27:31",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:32:53"
          },
          {
            "ticket_id": 2309,
            "ticket_number": "352304",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "12/11/2025 17:27:33",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:31:59"
          },
          {
            "ticket_id": 2315,
            "ticket_number": "352310",
            "title": "Confirmação de Reserva * File 415693",
            "priority": "Reservas sem Formulário",
            "created_at": "12/11/2025 18:18:08",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 29.97,
            "sla_met": false,
            "sla_breach_hours": 5.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 00:17:08"
          },
          {
            "ticket_id": 2324,
            "ticket_number": "352319",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "12/11/2025 21:30:02",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 19.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 17:01:41"
          },
          {
            "ticket_id": 2342,
            "ticket_number": "352337",
            "title": "Fwd: Vueling flight to Lisbon – What to expect",
            "priority": "P2",
            "created_at": "13/11/2025 10:14:11",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 10:14:12"
          },
          {
            "ticket_id": 2371,
            "ticket_number": "352366",
            "title": "VIAGEM DE ESQUI EM GRUPO!",
            "priority": "P2",
            "created_at": "13/11/2025 12:53:47",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 13:21:41"
          },
          {
            "ticket_id": 2373,
            "ticket_number": "352368",
            "title": "Signed: CVO_GBN-75892.pdf",
            "priority": "P2",
            "created_at": "13/11/2025 12:53:51",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 13:22:38"
          },
          {
            "ticket_id": 2378,
            "ticket_number": "352373",
            "title": "Confirmação de Reserva * File 415469 com o tour co",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 13:32:58",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 148.15,
            "sla_met": false,
            "sla_breach_hours": 124.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 17:42:22"
          },
          {
            "ticket_id": 2379,
            "ticket_number": "352374",
            "title": "Opti 249100000 Maria Lurdes Silva",
            "priority": "P2",
            "created_at": "13/11/2025 13:34:07",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 13:34:07"
          },
          {
            "ticket_id": 2387,
            "ticket_number": "352382",
            "title": "Fwd: Viagify informa sobre a sua reserva 121864238",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 15:21:36",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 15:21:36"
          },
          {
            "ticket_id": 2388,
            "ticket_number": "352383",
            "title": "Fwd: Viagify informa sobre a sua reserva 121864238",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 15:21:38",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 15:21:39"
          },
          {
            "ticket_id": 2396,
            "ticket_number": "352391",
            "title": "Confirmação de Reserva * File 415790*( Time Limit ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:23:42",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 145.37,
            "sla_met": false,
            "sla_breach_hours": 121.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 17:46:06"
          },
          {
            "ticket_id": 2401,
            "ticket_number": "352396",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604469673",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:35:00",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 148.67,
            "sla_met": false,
            "sla_breach_hours": 124.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:15:29"
          },
          {
            "ticket_id": 2402,
            "ticket_number": "352397",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604485932",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:35:02",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 26.55,
            "sla_met": false,
            "sla_breach_hours": 2.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:08:59"
          },
          {
            "ticket_id": 2403,
            "ticket_number": "352398",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604472470",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:35:03",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 26.55,
            "sla_met": false,
            "sla_breach_hours": 2.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:08:23"
          },
          {
            "ticket_id": 2413,
            "ticket_number": "352408",
            "title": "Confirmação de reserva. Localizador: 27FQX4T3WG",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 17:58:05",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 25.15,
            "sla_met": false,
            "sla_breach_hours": 1.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:07:13"
          },
          {
            "ticket_id": 2415,
            "ticket_number": "352410",
            "title": "Reserva loc 52642557 - URGENTE (Ref: 7H24YNOPQB)",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 18:20:09",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.77,
            "sla_met": false,
            "sla_breach_hours": 0.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:06:21"
          },
          {
            "ticket_id": 2422,
            "ticket_number": "352417",
            "title": "Fwd: Your New Flight Details/Information",
            "priority": "P2",
            "created_at": "13/11/2025 18:54:47",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 18:54:48"
          },
          {
            "ticket_id": 2424,
            "ticket_number": "352419",
            "title": "Fwd: Informações da reserva TTN-1125356410#8599172",
            "priority": "P2",
            "created_at": "13/11/2025 18:54:50",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 18:54:51"
          },
          {
            "ticket_id": 2428,
            "ticket_number": "352423",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:06:56",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:06:56"
          },
          {
            "ticket_id": 2430,
            "ticket_number": "352425",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:10:16",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:10:16"
          },
          {
            "ticket_id": 2431,
            "ticket_number": "352426",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:10:19",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:10:19"
          },
          {
            "ticket_id": 2432,
            "ticket_number": "352427",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:13:42",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:13:42"
          },
          {
            "ticket_id": 2434,
            "ticket_number": "352429",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:13:53",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:13:53"
          },
          {
            "ticket_id": 2435,
            "ticket_number": "352430",
            "title": "GBN Travel: Reenvio de confirmação de reserva -   ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:20:27",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:20:27"
          },
          {
            "ticket_id": 2438,
            "ticket_number": "352433",
            "title": "Fwd: SMYTRAVEL 1125356410 // CONFIRMACION TTN-1125",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:22:14",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 19:22:14"
          },
          {
            "ticket_id": 2440,
            "ticket_number": "352435",
            "title": "GBN-90039 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/11/2025 20:25:08",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 20:47:17"
          },
          {
            "ticket_id": 2441,
            "ticket_number": "352436",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604491711",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 20:42:56",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 13.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 10:04:25"
          },
          {
            "ticket_id": 2445,
            "ticket_number": "352440",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 21:14:41",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 15.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 12:19:37"
          },
          {
            "ticket_id": 2452,
            "ticket_number": "352447",
            "title": "GBN-90064 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 23:27:30",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 19.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 18:59:04"
          },
          {
            "ticket_id": 2462,
            "ticket_number": "352457",
            "title": "Recordatorio sorteo NCL",
            "priority": "P2",
            "created_at": "14/11/2025 10:48:57",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 11:22:49"
          },
          {
            "ticket_id": 2470,
            "ticket_number": "352465",
            "title": "Confirmación Transfer Agência: Uma Família Em Viag",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 11:52:17",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 7.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 18:56:02"
          },
          {
            "ticket_id": 2477,
            "ticket_number": "352472",
            "title": "GBN-90051 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 12:19:37",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 6.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:01:10"
          },
          {
            "ticket_id": 2479,
            "ticket_number": "352474",
            "title": "Confirmation of booking with locator8GCF64MO",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 12:40:29",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 128.67,
            "sla_met": false,
            "sla_breach_hours": 104.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:20:34"
          },
          {
            "ticket_id": 2480,
            "ticket_number": "352475",
            "title": "GBN-90095 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 12:40:32",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 128.67,
            "sla_met": false,
            "sla_breach_hours": 104.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:20:57"
          },
          {
            "ticket_id": 2484,
            "ticket_number": "352479",
            "title": "Solole. Booking LJ3H1LIP is close to entering expe",
            "priority": "P2",
            "created_at": "14/11/2025 14:01:41",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 15:52:10"
          },
          {
            "ticket_id": 2485,
            "ticket_number": "352480",
            "title": "GBN-90116 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 14:01:44",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 4.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 18:57:46"
          },
          {
            "ticket_id": 2503,
            "ticket_number": "352498",
            "title": "GBN-90171 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 18:00:13",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 119.75,
            "sla_met": false,
            "sla_breach_hours": 95.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 17:45:30"
          },
          {
            "ticket_id": 2508,
            "ticket_number": "352503",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604492196",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 19:08:07",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 19:27:18"
          },
          {
            "ticket_id": 2511,
            "ticket_number": "352506",
            "title": "Confirmation of booking with locatorKAX9U53U",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 19:46:35",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 121.58,
            "sla_met": false,
            "sla_breach_hours": 97.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:22:09"
          },
          {
            "ticket_id": 2515,
            "ticket_number": "352510",
            "title": "GBN-90200 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 21:06:27",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 120.27,
            "sla_met": false,
            "sla_breach_hours": 96.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:22:35"
          },
          {
            "ticket_id": 2516,
            "ticket_number": "352511",
            "title": "Número de informação da reserva: 6120599",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 21:50:33",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 119.53,
            "sla_met": false,
            "sla_breach_hours": 95.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:23:26"
          },
          {
            "ticket_id": 2517,
            "ticket_number": "352512",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 22:18:50",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 112.02,
            "sla_met": false,
            "sla_breach_hours": 88.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 14:20:43"
          },
          {
            "ticket_id": 2521,
            "ticket_number": "352516",
            "title": "GBN-90211 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 23:25:01",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 118.02,
            "sla_met": false,
            "sla_breach_hours": 94.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:26:18"
          },
          {
            "ticket_id": 2522,
            "ticket_number": "352517",
            "title": "GBN-90212 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 23:34:06",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 136.12,
            "sla_met": false,
            "sla_breach_hours": 112.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:41:54"
          },
          {
            "ticket_id": 2531,
            "ticket_number": "352526",
            "title": "Reserva confirmada: Cruzeiro pelo Tâmisa de Westmi",
            "priority": "Reservas sem Formulário",
            "created_at": "15/11/2025 12:51:49",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 104.62,
            "sla_met": false,
            "sla_breach_hours": 80.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:29:06"
          },
          {
            "ticket_id": 2539,
            "ticket_number": "352534",
            "title": "GBN-90206 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/11/2025 15:47:12",
            "close_date": "2025-11-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 15:59:04"
          },
          {
            "ticket_id": 2543,
            "ticket_number": "352538",
            "title": "Reserva GBN-82375 - URGENTE",
            "priority": "P2",
            "created_at": "15/11/2025 16:55:21",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 42.68,
            "sla_met": false,
            "sla_breach_hours": 38.68,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 11:36:45"
          },
          {
            "ticket_id": 2549,
            "ticket_number": "352544",
            "title": "Contatos de Cliente em falta - n/File 402834",
            "priority": "P2",
            "created_at": "16/11/2025 10:54:56",
            "close_date": "2025-11-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 11:00:44"
          },
          {
            "ticket_id": 2551,
            "ticket_number": "352546",
            "title": "GBN-90264 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/11/2025 10:55:07",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 82.63,
            "sla_met": false,
            "sla_breach_hours": 58.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:33:10"
          },
          {
            "ticket_id": 2555,
            "ticket_number": "352550",
            "title": "Fwd: Documentação da reserva TTN-1212042405#861288",
            "priority": "P2",
            "created_at": "16/11/2025 14:03:58",
            "close_date": "2025-11-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 14:03:59"
          },
          {
            "ticket_id": 2564,
            "ticket_number": "352559",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:16:01",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 177.48,
            "sla_met": false,
            "sla_breach_hours": 153.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 19:45:23"
          },
          {
            "ticket_id": 2567,
            "ticket_number": "352562",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:16:10",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 102.67,
            "sla_met": false,
            "sla_breach_hours": 78.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:56:55"
          },
          {
            "ticket_id": 2568,
            "ticket_number": "352563",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:16:16",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 59.48,
            "sla_met": false,
            "sla_breach_hours": 35.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:45:27"
          },
          {
            "ticket_id": 2569,
            "ticket_number": "352564",
            "title": "GBN-90313 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:16:26",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 59.48,
            "sla_met": false,
            "sla_breach_hours": 35.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:45:56"
          },
          {
            "ticket_id": 2578,
            "ticket_number": "352573",
            "title": "RE: Pagamento 6117291",
            "priority": "P2",
            "created_at": "17/11/2025 10:19:21",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 10:37:02"
          },
          {
            "ticket_id": 2581,
            "ticket_number": "352576",
            "title": "Información de reserva número: 1760548",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:42:17",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 77.1,
            "sla_met": false,
            "sla_breach_hours": 53.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:48:32"
          },
          {
            "ticket_id": 2583,
            "ticket_number": "352578",
            "title": "Información de reserva número: 1760552",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 10:52:29",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 76.93,
            "sla_met": false,
            "sla_breach_hours": 52.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:49:01"
          },
          {
            "ticket_id": 2586,
            "ticket_number": "352581",
            "title": "Re:[## 24485 ##] GBN-87708 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "17/11/2025 11:22:29",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 11:24:54"
          },
          {
            "ticket_id": 2587,
            "ticket_number": "352582",
            "title": "GBN-90308 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/11/2025 11:22:30",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 11:26:52"
          },
          {
            "ticket_id": 2589,
            "ticket_number": "352584",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604485932",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 11:31:44",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 76.32,
            "sla_met": false,
            "sla_breach_hours": 52.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:51:29"
          },
          {
            "ticket_id": 2590,
            "ticket_number": "352585",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604492514",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 11:53:37",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 75.97,
            "sla_met": false,
            "sla_breach_hours": 51.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:51:55"
          },
          {
            "ticket_id": 2591,
            "ticket_number": "352586",
            "title": "Re:[## 25122 ##] GBN-85625 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "17/11/2025 11:53:39",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 11:54:35"
          },
          {
            "ticket_id": 2597,
            "ticket_number": "352592",
            "title": "Re:[## 25108 ##] GBN-82375 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "17/11/2025 12:39:47",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:41:43"
          },
          {
            "ticket_id": 2603,
            "ticket_number": "352598",
            "title": "Pedido de envio de RGPD e CVO - Sara Antunes- GBN-",
            "priority": "P2",
            "created_at": "17/11/2025 13:30:30",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 13:30:31"
          },
          {
            "ticket_id": 2632,
            "ticket_number": "352627",
            "title": "Fwd: Viagify informa sobre a sua reserva 121969076",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 18:42:47",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 18:42:47"
          },
          {
            "ticket_id": 2634,
            "ticket_number": "352629",
            "title": "Número de informação da reserva: 6120833",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 19:13:44",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 19.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:03:44"
          },
          {
            "ticket_id": 2641,
            "ticket_number": "352636",
            "title": "GBN-90437 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 19:40:23",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 68.27,
            "sla_met": false,
            "sla_breach_hours": 44.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:56:25"
          },
          {
            "ticket_id": 2642,
            "ticket_number": "352637",
            "title": "GBN-90444 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 19:40:29",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 68.27,
            "sla_met": false,
            "sla_breach_hours": 44.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:56:56"
          },
          {
            "ticket_id": 2643,
            "ticket_number": "352638",
            "title": "Confirmation of booking with locatorVGBP2GGO",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 20:05:14",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 20:05:15"
          },
          {
            "ticket_id": 2645,
            "ticket_number": "352640",
            "title": "Fwd: Viagify informa sobre a sua reserva 121992292",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 21:28:30",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 21:28:31"
          },
          {
            "ticket_id": 2656,
            "ticket_number": "352651",
            "title": "Icárion - Balcãs Completo - 17/04/2026 - 6128531 -",
            "priority": "P2",
            "created_at": "17/11/2025 23:16:21",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 23:54:12"
          },
          {
            "ticket_id": 2657,
            "ticket_number": "352652",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604493261",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 23:16:23",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:04:20"
          },
          {
            "ticket_id": 2660,
            "ticket_number": "352655",
            "title": "Confirmação de reserva com localizador: 3976915",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 00:20:59",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 63.65,
            "sla_met": false,
            "sla_breach_hours": 39.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:00:53"
          },
          {
            "ticket_id": 2666,
            "ticket_number": "352661",
            "title": "Número de informação da reserva: 6120897",
            "priority": "P2",
            "created_at": "18/11/2025 10:22:33",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 11:21:06"
          },
          {
            "ticket_id": 2668,
            "ticket_number": "352663",
            "title": "Número de informação da reserva: 6120899",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 10:25:52",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 20:24:30"
          },
          {
            "ticket_id": 2695,
            "ticket_number": "352690",
            "title": "Fwd: Important : Gate change for your flight AT981",
            "priority": "P3",
            "created_at": "18/11/2025 12:55:56",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:55:56"
          },
          {
            "ticket_id": 2701,
            "ticket_number": "352696",
            "title": "Fwd: Viagify informa sobre a sua reserva 122011524",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 13:51:37",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 13:51:38"
          },
          {
            "ticket_id": 2704,
            "ticket_number": "352699",
            "title": "Fwd: Informações da sua reserva TTN-1220115244#863",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 14:21:10",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 14:21:11"
          },
          {
            "ticket_id": 2705,
            "ticket_number": "352700",
            "title": "Petición CnTravel P/15002486",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 14:21:12",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 74.85,
            "sla_met": false,
            "sla_breach_hours": 50.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:12:22"
          },
          {
            "ticket_id": 2706,
            "ticket_number": "352701",
            "title": "Reserva confirmada: Passeio de barco pelo Sena - C",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 14:49:36",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 49.27,
            "sla_met": false,
            "sla_breach_hours": 25.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:06:01"
          },
          {
            "ticket_id": 2707,
            "ticket_number": "352702",
            "title": "Reserva confirmada: Passeio de barco pelo Sena - C",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 14:49:39",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 49.25,
            "sla_met": false,
            "sla_breach_hours": 25.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:05:31"
          },
          {
            "ticket_id": 2722,
            "ticket_number": "352717",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 19:16:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 19:16:11"
          },
          {
            "ticket_id": 2726,
            "ticket_number": "352721",
            "title": "Fwd: ALMEIDA FERNANDES/FELICIA MRS 28DEC2025 AMS O",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 21:31:09",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 21:31:09"
          },
          {
            "ticket_id": 2727,
            "ticket_number": "352722",
            "title": "Fwd: Confirmacion de la reserva Transavia: YH5H3N",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 21:31:12",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 21:31:12"
          },
          {
            "ticket_id": 2735,
            "ticket_number": "352730",
            "title": "GBN-90628 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 21:32:18",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 42.58,
            "sla_met": false,
            "sla_breach_hours": 18.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:07:44"
          },
          {
            "ticket_id": 2737,
            "ticket_number": "352732",
            "title": "Número de informação da reserva: 6121113",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 21:32:59",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 42.58,
            "sla_met": false,
            "sla_breach_hours": 18.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:08:21"
          },
          {
            "ticket_id": 2738,
            "ticket_number": "352733",
            "title": "Confirmação de reserva com localizador: 3978071",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 22:25:28",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 41.72,
            "sla_met": false,
            "sla_breach_hours": 17.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:08:45"
          },
          {
            "ticket_id": 2741,
            "ticket_number": "352736",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "18/11/2025 22:25:37",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 41.72,
            "sla_met": false,
            "sla_breach_hours": 17.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:09:16"
          },
          {
            "ticket_id": 2749,
            "ticket_number": "352744",
            "title": "GBN-90637 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 00:04:06",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 40.1,
            "sla_met": false,
            "sla_breach_hours": 16.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:10:39"
          },
          {
            "ticket_id": 2750,
            "ticket_number": "352745",
            "title": "Confirmação de reserva com localizador: 3978079",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 00:04:09",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 40.12,
            "sla_met": false,
            "sla_breach_hours": 16.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:11:26"
          },
          {
            "ticket_id": 2751,
            "ticket_number": "352746",
            "title": "Número de informação da reserva: 6121143",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 00:04:43",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 40.08,
            "sla_met": false,
            "sla_breach_hours": 16.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:10:07"
          },
          {
            "ticket_id": 2770,
            "ticket_number": "352765",
            "title": "Reserva confirmada: Visita guiada por Budapeste + ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:21:47",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 30.58,
            "sla_met": false,
            "sla_breach_hours": 6.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 16:57:09"
          },
          {
            "ticket_id": 2771,
            "ticket_number": "352766",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:21:49",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 315.18,
            "sla_met": false,
            "sla_breach_hours": 291.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 13:33:04"
          },
          {
            "ticket_id": 2773,
            "ticket_number": "352768",
            "title": "Reserva confirmada: Passeio de barco ao anoitecer ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:21:55",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 55.23,
            "sla_met": false,
            "sla_breach_hours": 31.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:36:13"
          },
          {
            "ticket_id": 2775,
            "ticket_number": "352770",
            "title": "Reserva confirmada: Ingresso da Basílica de Santo ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:22:01",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 343.37,
            "sla_met": false,
            "sla_breach_hours": 319.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:44:13"
          },
          {
            "ticket_id": 2785,
            "ticket_number": "352780",
            "title": "GBN-90633 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/11/2025 12:19:39",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 12:22:46"
          },
          {
            "ticket_id": 2786,
            "ticket_number": "352781",
            "title": "GBN-90633 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "19/11/2025 12:19:40",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 12:21:58"
          },
          {
            "ticket_id": 2804,
            "ticket_number": "352799",
            "title": "GBN-90730 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 15:35:45",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 11:21:57"
          },
          {
            "ticket_id": 2808,
            "ticket_number": "352803",
            "title": "Fwd: Confirmacion de la reserva Transavia: YEN76G",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 15:50:30",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:50:30"
          },
          {
            "ticket_id": 2810,
            "ticket_number": "352805",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 16:14:15",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 12:02:01"
          },
          {
            "ticket_id": 2812,
            "ticket_number": "352807",
            "title": "Comunicado: Dep. Financeiro GBN Travel",
            "priority": "P3",
            "created_at": "19/11/2025 16:21:53",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 17:53:35"
          },
          {
            "ticket_id": 2817,
            "ticket_number": "352812",
            "title": "Número de informação da reserva: 6121385",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 18:56:16",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 14:42:12"
          },
          {
            "ticket_id": 2819,
            "ticket_number": "352814",
            "title": "Fwd: Confirmacion de la reserva Transavia: DHPDPX",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:01:43",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:01:44"
          },
          {
            "ticket_id": 2821,
            "ticket_number": "352816",
            "title": "GBN-90804 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:14",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 15:42:15"
          },
          {
            "ticket_id": 2823,
            "ticket_number": "352818",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:33",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:50:33"
          },
          {
            "ticket_id": 2824,
            "ticket_number": "352819",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:41",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:50:42"
          },
          {
            "ticket_id": 2826,
            "ticket_number": "352821",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:55",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 44.77,
            "sla_met": false,
            "sla_breach_hours": 20.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:37:48"
          },
          {
            "ticket_id": 2828,
            "ticket_number": "352823",
            "title": "Confirmação de reserva 333905### TIME LIMIT EMISSÃ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 20:23:56",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:22:26"
          },
          {
            "ticket_id": 2832,
            "ticket_number": "352827",
            "title": "Confirmación de la reserva con localizador: 397954",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 23:38:24",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 42.83,
            "sla_met": false,
            "sla_breach_hours": 18.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 18:29:03"
          },
          {
            "ticket_id": 2835,
            "ticket_number": "352830",
            "title": "GBN-90822 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 23:38:35",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 41.0,
            "sla_met": false,
            "sla_breach_hours": 17.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:38:50"
          },
          {
            "ticket_id": 2838,
            "ticket_number": "352833",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P2",
            "created_at": "19/11/2025 23:46:50",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 00:46:51"
          },
          {
            "ticket_id": 2844,
            "ticket_number": "352839",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 10:19:15",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 10:45:10"
          },
          {
            "ticket_id": 2855,
            "ticket_number": "352850",
            "title": "Fwd: Viagify informa sobre a sua reserva 122068539",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 10:33:47",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 48.57,
            "sla_met": false,
            "sla_breach_hours": 24.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:08:34"
          },
          {
            "ticket_id": 2857,
            "ticket_number": "352852",
            "title": "Fwd: Viagify informa sobre a sua reserva 122065858",
            "priority": "P2",
            "created_at": "20/11/2025 10:33:54",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 10:33:55"
          },
          {
            "ticket_id": 2858,
            "ticket_number": "352853",
            "title": "Fwd: Viagify informa sobre a sua reserva 122065858",
            "priority": "P2",
            "created_at": "20/11/2025 10:33:59",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 10:34:00"
          },
          {
            "ticket_id": 2859,
            "ticket_number": "352854",
            "title": "GBN-90811 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/11/2025 10:35:42",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 10:59:27"
          },
          {
            "ticket_id": 2867,
            "ticket_number": "352862",
            "title": "GBN-90740 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 12:17:04",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.25,
            "sla_met": false,
            "sla_breach_hours": 6.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 18:32:49"
          },
          {
            "ticket_id": 2868,
            "ticket_number": "352863",
            "title": "Número de informação da reserva: 6121533",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 12:17:07",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 22:03:04"
          },
          {
            "ticket_id": 2869,
            "ticket_number": "352864",
            "title": "Número de informação da reserva: 6121537",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 12:17:11",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 22:03:04"
          },
          {
            "ticket_id": 2871,
            "ticket_number": "352866",
            "title": "Confirmação reserva Bedsonline 59-5636778",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 12:17:16",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 22:03:04"
          },
          {
            "ticket_id": 2880,
            "ticket_number": "352875",
            "title": "Reserva confirmada: Noite no deserto de Agafay - C",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 15:17:41",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:17:41"
          },
          {
            "ticket_id": 2881,
            "ticket_number": "352876",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 15:17:44",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:17:44"
          },
          {
            "ticket_id": 2882,
            "ticket_number": "352877",
            "title": "GBN-90906 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 15:18:20",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 32.2,
            "sla_met": false,
            "sla_breach_hours": 8.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 23:30:24"
          },
          {
            "ticket_id": 2893,
            "ticket_number": "352888",
            "title": "RE: URGENTE - orçamento Boavista ou SAL",
            "priority": "P2",
            "created_at": "20/11/2025 17:07:59",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 17:12:39"
          },
          {
            "ticket_id": 2898,
            "ticket_number": "352893",
            "title": "Informação de reserva - SPT002501553355",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 18:00:05",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 19:18:58"
          },
          {
            "ticket_id": 2899,
            "ticket_number": "352894",
            "title": "Fwd: Reminder : Get ready for your flight AT982 fr",
            "priority": "P2",
            "created_at": "20/11/2025 18:02:14",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 18:02:15"
          },
          {
            "ticket_id": 2905,
            "ticket_number": "352900",
            "title": "GBN-90740 Atividades",
            "priority": "P2",
            "created_at": "20/11/2025 19:29:48",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 19:29:48"
          },
          {
            "ticket_id": 2908,
            "ticket_number": "352903",
            "title": "GBN-90972 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 19:29:58",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 20.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:28:08"
          },
          {
            "ticket_id": 2913,
            "ticket_number": "352908",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 22:49:44",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 22:49:44"
          },
          {
            "ticket_id": 2941,
            "ticket_number": "352936",
            "title": "VOUCHER DA RESERVA 604466293",
            "priority": "P3",
            "created_at": "21/11/2025 12:26:57",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 14:35:34"
          },
          {
            "ticket_id": 2942,
            "ticket_number": "352937",
            "title": "VOUCHER DA RESERVA 604469451",
            "priority": "P3",
            "created_at": "21/11/2025 12:27:09",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 14:38:05"
          },
          {
            "ticket_id": 2955,
            "ticket_number": "352950",
            "title": "Localizador 6120803 - preço de criança vs adulto",
            "priority": "P2",
            "created_at": "21/11/2025 15:51:24",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 15:51:24"
          },
          {
            "ticket_id": 2957,
            "ticket_number": "352952",
            "title": "Informação de reserva - SPT002501553935",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 16:03:56",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 19.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:25:52"
          },
          {
            "ticket_id": 2961,
            "ticket_number": "352956",
            "title": "Informação de reserva - SPT002501553355",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:20:30",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 18.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:30:50"
          },
          {
            "ticket_id": 2962,
            "ticket_number": "352957",
            "title": "Informação de reserva - SPT002501553935",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:20:37",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 18.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:31:18"
          },
          {
            "ticket_id": 2964,
            "ticket_number": "352959",
            "title": "Confirmacao 334202",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:21:12",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 18.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:31:40"
          },
          {
            "ticket_id": 2974,
            "ticket_number": "352969",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "21/11/2025 17:53:05",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 17:53:07"
          },
          {
            "ticket_id": 2977,
            "ticket_number": "352972",
            "title": "GBN-91007 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 18:18:45",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 7.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:34:31"
          },
          {
            "ticket_id": 2979,
            "ticket_number": "352974",
            "title": "Informação de reserva - SPT002501553935",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 18:18:56",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 5.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 23:32:03"
          },
          {
            "ticket_id": 2987,
            "ticket_number": "352982",
            "title": "Fwd: Viagify informa sobre a sua reserva 122124692",
            "priority": "P2",
            "created_at": "21/11/2025 19:22:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 19:22:12"
          },
          {
            "ticket_id": 2989,
            "ticket_number": "352984",
            "title": "Confirmação de reserva * File 416895",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 19:22:21",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 72.37,
            "sla_met": false,
            "sla_breach_hours": 48.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 19:45:15"
          },
          {
            "ticket_id": 2992,
            "ticket_number": "352987",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497276",
            "priority": "P2",
            "created_at": "21/11/2025 20:42:12",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 21:04:30"
          },
          {
            "ticket_id": 2994,
            "ticket_number": "352989",
            "title": "Pedido de RGPD e CVO - 604497276",
            "priority": "P2",
            "created_at": "21/11/2025 20:42:18",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 20:42:19"
          },
          {
            "ticket_id": 2998,
            "ticket_number": "352993",
            "title": "Reserva confirmada: Calçada do Gigante, Titanic Ex",
            "priority": "P2",
            "created_at": "21/11/2025 22:08:48",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 23:15:48"
          },
          {
            "ticket_id": 2999,
            "ticket_number": "352994",
            "title": "Reserva confirmada: Calçada do Gigante, Titanic Ex",
            "priority": "P2",
            "created_at": "21/11/2025 22:08:50",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 23:14:36"
          },
          {
            "ticket_id": 3016,
            "ticket_number": "353011",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "22/11/2025 14:55:45",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 15:02:15"
          },
          {
            "ticket_id": 3040,
            "ticket_number": "353035",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "23/11/2025 16:38:00",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 16:38:01"
          },
          {
            "ticket_id": 3055,
            "ticket_number": "353048",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497855",
            "priority": "Reservas sem Formulário",
            "created_at": "23/11/2025 21:23:11",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 20.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 18:03:29"
          },
          {
            "ticket_id": 3063,
            "ticket_number": "353056",
            "title": "FW: Reserva NewBlue 1760552",
            "priority": "P2",
            "created_at": "24/11/2025 10:07:36",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:07:36"
          },
          {
            "ticket_id": 3068,
            "ticket_number": "353061",
            "title": "GBN-91364 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 10:07:52",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 7.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 18:02:52"
          },
          {
            "ticket_id": 3113,
            "ticket_number": "353106",
            "title": "GBN Travel: Resend booking confirmation - GBN-8475",
            "priority": "P2",
            "created_at": "24/11/2025 17:13:15",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:13:15"
          },
          {
            "ticket_id": 3114,
            "ticket_number": "353107",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/11/2025 17:13:26",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:13:26"
          },
          {
            "ticket_id": 3116,
            "ticket_number": "353109",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/11/2025 17:13:41",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:13:42"
          },
          {
            "ticket_id": 3117,
            "ticket_number": "353110",
            "title": "Pagamento da reserva – Ref PP621324-1, Sr. Jose Pi",
            "priority": "P2",
            "created_at": "24/11/2025 17:14:17",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:18:35"
          },
          {
            "ticket_id": 3118,
            "ticket_number": "353111",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/11/2025 17:19:17",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:19:17"
          },
          {
            "ticket_id": 3119,
            "ticket_number": "353112",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/11/2025 17:19:21",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:19:21"
          },
          {
            "ticket_id": 3120,
            "ticket_number": "353113",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604485932",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 17:28:00",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 5.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 23:02:30"
          },
          {
            "ticket_id": 3123,
            "ticket_number": "353116",
            "title": "Documentos preenchidos",
            "priority": "P2",
            "created_at": "24/11/2025 18:28:11",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 18:32:38"
          },
          {
            "ticket_id": 3133,
            "ticket_number": "353126",
            "title": "GBN-91557 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 22:35:57",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 20.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:30:35"
          },
          {
            "ticket_id": 3134,
            "ticket_number": "353127",
            "title": "GBN-91558 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 22:37:37",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 20.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:31:00"
          },
          {
            "ticket_id": 3135,
            "ticket_number": "353128",
            "title": "GBN-91559 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 22:41:34",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 23:04:19"
          },
          {
            "ticket_id": 3137,
            "ticket_number": "353130",
            "title": "GBN-91568 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 23:21:15",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 20.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:31:44"
          },
          {
            "ticket_id": 3138,
            "ticket_number": "353131",
            "title": "Confirmação de reserva com localizador: 3984665",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 23:21:53",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 20.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:32:15"
          },
          {
            "ticket_id": 3140,
            "ticket_number": "353133",
            "title": "GBN-91573 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 23:39:24",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 19.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:32:48"
          },
          {
            "ticket_id": 3153,
            "ticket_number": "353146",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "25/11/2025 12:23:58",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 12:49:02"
          },
          {
            "ticket_id": 3167,
            "ticket_number": "353160",
            "title": "Hotelston - Madeira / Melhores preços feriado 5 a ",
            "priority": "P2",
            "created_at": "25/11/2025 13:09:39",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:20:19"
          },
          {
            "ticket_id": 3182,
            "ticket_number": "353175",
            "title": "Número de informação da reserva: 6122762",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 15:03:18",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 17:11:32"
          },
          {
            "ticket_id": 3209,
            "ticket_number": "353202",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 18:52:21",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 18:52:21"
          },
          {
            "ticket_id": 3217,
            "ticket_number": "353210",
            "title": "Número de informação da reserva: 6122920",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 22:44:14",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 18:41:38"
          },
          {
            "ticket_id": 3225,
            "ticket_number": "353218",
            "title": "GBN-91782 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 23:32:42",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 185.63,
            "sla_met": false,
            "sla_breach_hours": 161.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:10:54"
          },
          {
            "ticket_id": 3228,
            "ticket_number": "353221",
            "title": "GBN-91790 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 00:05:08",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 158.02,
            "sla_met": false,
            "sla_breach_hours": 134.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:07:07"
          },
          {
            "ticket_id": 3237,
            "ticket_number": "353230",
            "title": "Fwd: Viagify informa sobre a sua reserva 122258536",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:24:02",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 147.73,
            "sla_met": false,
            "sla_breach_hours": 123.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:08:26"
          },
          {
            "ticket_id": 3240,
            "ticket_number": "353233",
            "title": "Fwd: Viagify informa sobre a sua reserva 122258536",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:24:12",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 147.73,
            "sla_met": false,
            "sla_breach_hours": 123.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:08:35"
          },
          {
            "ticket_id": 3241,
            "ticket_number": "353234",
            "title": "Fwd: Viagify informa sobre a sua reserva 122258536",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:24:16",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 147.73,
            "sla_met": false,
            "sla_breach_hours": 123.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:08:47"
          },
          {
            "ticket_id": 3248,
            "ticket_number": "353241",
            "title": "GBN-91784 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:25:35",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 20:21:52"
          },
          {
            "ticket_id": 3282,
            "ticket_number": "353275",
            "title": "Número de informação da reserva: 6123057",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 14:56:57",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 81.28,
            "sla_met": false,
            "sla_breach_hours": 57.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 00:14:28"
          },
          {
            "ticket_id": 3283,
            "ticket_number": "353276",
            "title": "Confirmacao 334667",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 14:56:58",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 81.18,
            "sla_met": false,
            "sla_breach_hours": 57.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 00:08:41"
          },
          {
            "ticket_id": 3284,
            "ticket_number": "353277",
            "title": "GBN-91226 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:09",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:50:25"
          },
          {
            "ticket_id": 3287,
            "ticket_number": "353280",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:15",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:18:15"
          },
          {
            "ticket_id": 3291,
            "ticket_number": "353284",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604500738",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 16:18:23",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 79.87,
            "sla_met": false,
            "sla_breach_hours": 55.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 00:11:11"
          },
          {
            "ticket_id": 3292,
            "ticket_number": "353285",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604500728",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 16:18:25",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 79.88,
            "sla_met": false,
            "sla_breach_hours": 55.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 00:11:52"
          },
          {
            "ticket_id": 3297,
            "ticket_number": "353290",
            "title": "GBN-91876 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 17:00:11",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 141.35,
            "sla_met": false,
            "sla_breach_hours": 117.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:21:15"
          },
          {
            "ticket_id": 3298,
            "ticket_number": "353291",
            "title": "Confirmacao 334681",
            "priority": "P2",
            "created_at": "26/11/2025 17:00:13",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 21:00:07"
          },
          {
            "ticket_id": 3303,
            "ticket_number": "353296",
            "title": "GBN-91877 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/11/2025 18:09:46",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 21:19:38"
          },
          {
            "ticket_id": 3306,
            "ticket_number": "353299",
            "title": "GBN-91907 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 18:10:34",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 140.18,
            "sla_met": false,
            "sla_breach_hours": 116.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:22:15"
          },
          {
            "ticket_id": 3314,
            "ticket_number": "353307",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 19:06:03",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:02:52"
          },
          {
            "ticket_id": 3315,
            "ticket_number": "353308",
            "title": "Confirmação de reserva com localizador: 3987407",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 19:06:05",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:02:52"
          },
          {
            "ticket_id": 3316,
            "ticket_number": "353309",
            "title": "GBN-91989 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 19:06:12",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:02:52"
          },
          {
            "ticket_id": 3318,
            "ticket_number": "353311",
            "title": "GBN-91982 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 19:31:34",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:22:55"
          },
          {
            "ticket_id": 3319,
            "ticket_number": "353312",
            "title": "GBN Travel: Resend booking confirmation - GBN-9198",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 19:31:47",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:22:55"
          },
          {
            "ticket_id": 3325,
            "ticket_number": "353318",
            "title": "Confirmação de reserva para For PT004157 68299122",
            "priority": "P2",
            "created_at": "26/11/2025 21:07:06",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 21:07:43"
          },
          {
            "ticket_id": 3328,
            "ticket_number": "353321",
            "title": "Confirmação de reserva. Localizador: 191DL2A5AP",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 23:44:51",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 19:43:19"
          },
          {
            "ticket_id": 3338,
            "ticket_number": "353331",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 23:47:49",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 19:43:19"
          },
          {
            "ticket_id": 3359,
            "ticket_number": "353352",
            "title": "Invoice 640125013389.pdf",
            "priority": "P2",
            "created_at": "27/11/2025 10:55:19",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 11:20:22"
          },
          {
            "ticket_id": 3376,
            "ticket_number": "353369",
            "title": "GBN-92139 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 16:51:41",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 117.6,
            "sla_met": false,
            "sla_breach_hours": 93.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:28:13"
          },
          {
            "ticket_id": 3378,
            "ticket_number": "353371",
            "title": "Envio documentos - (Factura-231005009)  n. 1004557",
            "priority": "P2",
            "created_at": "27/11/2025 16:51:47",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 17:21:42"
          },
          {
            "ticket_id": 3380,
            "ticket_number": "353373",
            "title": "Reserva confirmada: Passeio de balão pela Capadóci",
            "priority": "P2",
            "created_at": "27/11/2025 16:51:54",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 16:51:54"
          },
          {
            "ticket_id": 3386,
            "ticket_number": "353379",
            "title": ":: MALTA - VOOS ESPECIAIS DE LISBOA DE 1 DE JULHO ",
            "priority": "P2",
            "created_at": "27/11/2025 16:52:07",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 17:24:55"
          },
          {
            "ticket_id": 3390,
            "ticket_number": "353383",
            "title": "Fwd: Viagify informa sobre a sua reserva 122321662",
            "priority": "P2",
            "created_at": "27/11/2025 16:54:01",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 16:54:02"
          },
          {
            "ticket_id": 3393,
            "ticket_number": "353386",
            "title": "GBN-92167 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 17:51:32",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 116.62,
            "sla_met": false,
            "sla_breach_hours": 92.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:29:03"
          },
          {
            "ticket_id": 3394,
            "ticket_number": "353387",
            "title": "Reserva confirmada: Safári pelo Parque Nacional Ny",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 19:21:26",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 19:21:33"
          },
          {
            "ticket_id": 3395,
            "ticket_number": "353388",
            "title": "GBN-92201 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 19:21:29",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 115.13,
            "sla_met": false,
            "sla_breach_hours": 91.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:30:12"
          },
          {
            "ticket_id": 3396,
            "ticket_number": "353389",
            "title": "Reserva confirmada: Safári pelo Parque Nacional Ny",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 19:21:33",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 144.05,
            "sla_met": false,
            "sla_breach_hours": 120.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:24:39"
          },
          {
            "ticket_id": 3398,
            "ticket_number": "353391",
            "title": "Mensagem sobre a reserva 35565345 - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 19:21:43",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 144.05,
            "sla_met": false,
            "sla_breach_hours": 120.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:24:43"
          },
          {
            "ticket_id": 3403,
            "ticket_number": "353396",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 21:23:12",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 21:23:20"
          },
          {
            "ticket_id": 3405,
            "ticket_number": "353398",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 21:23:20",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 142.03,
            "sla_met": false,
            "sla_breach_hours": 118.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:25:48"
          },
          {
            "ticket_id": 3407,
            "ticket_number": "353400",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 21:23:31",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 113.23,
            "sla_met": false,
            "sla_breach_hours": 89.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:38:16"
          },
          {
            "ticket_id": 3408,
            "ticket_number": "353401",
            "title": "Número de informação da reserva: 6123488",
            "priority": "Reservas sem Formulário",
            "created_at": "27/11/2025 21:24:09",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 113.25,
            "sla_met": false,
            "sla_breach_hours": 89.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:39:33"
          },
          {
            "ticket_id": 3414,
            "ticket_number": "353407",
            "title": "GBN-92262 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 00:11:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 110.5,
            "sla_met": false,
            "sla_breach_hours": 86.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:41:22"
          },
          {
            "ticket_id": 3419,
            "ticket_number": "353412",
            "title": "Adicione novas experiências para sua viagem GBN-65",
            "priority": "P2",
            "created_at": "28/11/2025 10:03:04",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:36:20"
          },
          {
            "ticket_id": 3423,
            "ticket_number": "353416",
            "title": "Confirmacao 334866",
            "priority": "P2",
            "created_at": "28/11/2025 10:03:12",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:43:10"
          },
          {
            "ticket_id": 3435,
            "ticket_number": "353428",
            "title": "Fwd: Viagify informa sobre a sua reserva 122336285",
            "priority": "P2",
            "created_at": "28/11/2025 10:06:24",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:06:25"
          },
          {
            "ticket_id": 3449,
            "ticket_number": "353442",
            "title": "Fwd: Viagify informa sobre a sua reserva 122343719",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 11:52:39",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 11:52:40"
          },
          {
            "ticket_id": 3495,
            "ticket_number": "353488",
            "title": "MACHADO/PATRICIA ALEXANDRA MRS 08MAY2026 LIS SID",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 19:14:49",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 122.73,
            "sla_met": false,
            "sla_breach_hours": 98.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:58:56"
          },
          {
            "ticket_id": 3497,
            "ticket_number": "353490",
            "title": "MENDES/NELSON JOSE MR 08MAY2026 LIS SID",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 19:14:57",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 122.75,
            "sla_met": false,
            "sla_breach_hours": 98.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:00:36"
          },
          {
            "ticket_id": 3500,
            "ticket_number": "353493",
            "title": "GBN-92436 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 21:02:06",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 162.78,
            "sla_met": false,
            "sla_breach_hours": 138.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 15:49:49"
          },
          {
            "ticket_id": 3503,
            "ticket_number": "353496",
            "title": "Informação de reserva - SPT002501558547",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 22:24:09",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 305.67,
            "sla_met": false,
            "sla_breach_hours": 281.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:04:22"
          },
          {
            "ticket_id": 3508,
            "ticket_number": "353501",
            "title": "Número de informação da reserva: 6123918",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 22:51:33",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 87.83,
            "sla_met": false,
            "sla_breach_hours": 63.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:42:22"
          },
          {
            "ticket_id": 3510,
            "ticket_number": "353503",
            "title": "Reserva confirmada: Visita da Sagrada Família com ",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:18:28",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 10:18:30"
          },
          {
            "ticket_id": 3511,
            "ticket_number": "353504",
            "title": "Reserva confirmada: Visita da Sagrada Família com ",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:18:30",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 105.25,
            "sla_met": false,
            "sla_breach_hours": 81.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:34:20"
          },
          {
            "ticket_id": 3514,
            "ticket_number": "353507",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:18:41",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 7.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 17:59:49"
          },
          {
            "ticket_id": 3515,
            "ticket_number": "353508",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:18:50",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 105.33,
            "sla_met": false,
            "sla_breach_hours": 81.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:38:53"
          },
          {
            "ticket_id": 3518,
            "ticket_number": "353511",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "29/11/2025 10:19:01",
            "close_date": "2025-11-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 13:21:06"
          },
          {
            "ticket_id": 3520,
            "ticket_number": "353513",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "29/11/2025 10:40:06",
            "close_date": "2025-11-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 10:40:06"
          },
          {
            "ticket_id": 3521,
            "ticket_number": "353514",
            "title": "GBN-92539 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:40:09",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 104.97,
            "sla_met": false,
            "sla_breach_hours": 80.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:38:20"
          },
          {
            "ticket_id": 3523,
            "ticket_number": "353516",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 10:40:15",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 10:40:15"
          },
          {
            "ticket_id": 3524,
            "ticket_number": "353517",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 12:03:26",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 12:03:26"
          },
          {
            "ticket_id": 3527,
            "ticket_number": "353520",
            "title": "Confirmacao 335024",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 13:03:10",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 10.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 23:43:32"
          },
          {
            "ticket_id": 3533,
            "ticket_number": "353526",
            "title": "Información de reserva número: 1764234",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 16:34:43",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 77.8,
            "sla_met": false,
            "sla_breach_hours": 53.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 22:23:12"
          },
          {
            "ticket_id": 3534,
            "ticket_number": "353527",
            "title": "GBN-91292 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 16:34:45",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 77.8,
            "sla_met": false,
            "sla_breach_hours": 53.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 22:23:12"
          },
          {
            "ticket_id": 3536,
            "ticket_number": "353529",
            "title": "Fwd: Viagify informa sobre a sua reserva 122395116",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 16:49:50",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 101.43,
            "sla_met": false,
            "sla_breach_hours": 77.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:16:50"
          },
          {
            "ticket_id": 3539,
            "ticket_number": "353532",
            "title": "Número de informação da reserva: 6124097",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 18:43:45",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 96.98,
            "sla_met": false,
            "sla_breach_hours": 72.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:43:31"
          },
          {
            "ticket_id": 3541,
            "ticket_number": "353534",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 18:43:53",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 96.95,
            "sla_met": false,
            "sla_breach_hours": 72.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:41:25"
          },
          {
            "ticket_id": 3542,
            "ticket_number": "353535",
            "title": "GBN-92594 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/11/2025 18:43:59",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 96.95,
            "sla_met": false,
            "sla_breach_hours": 72.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:41:57"
          },
          {
            "ticket_id": 3545,
            "ticket_number": "353538",
            "title": "VA17DLLF - UFEV",
            "priority": "P2",
            "created_at": "29/11/2025 22:04:07",
            "close_date": "2025-11-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 22:04:08"
          },
          {
            "ticket_id": 3554,
            "ticket_number": "353547",
            "title": "Criação de processo File 419626/25",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 10:44:56",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 72.97,
            "sla_met": false,
            "sla_breach_hours": 48.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 11:43:56"
          },
          {
            "ticket_id": 3556,
            "ticket_number": "353549",
            "title": "Número de informação da reserva: 6124187",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 11:42:55",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 52.95,
            "sla_met": false,
            "sla_breach_hours": 28.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 16:40:51"
          },
          {
            "ticket_id": 3557,
            "ticket_number": "353550",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 11:42:56",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 11:42:58"
          },
          {
            "ticket_id": 3558,
            "ticket_number": "353551",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 11:42:58",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 82.03,
            "sla_met": false,
            "sla_breach_hours": 58.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:45:30"
          },
          {
            "ticket_id": 3562,
            "ticket_number": "353555",
            "title": "RE: 6124097 - Dados passaporte W2MCS:014990005087",
            "priority": "P2",
            "created_at": "30/11/2025 12:35:21",
            "close_date": "2025-11-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 10:53:17"
          },
          {
            "ticket_id": 3564,
            "ticket_number": "353557",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 15:09:34",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 49.6,
            "sla_met": false,
            "sla_breach_hours": 25.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 16:45:54"
          },
          {
            "ticket_id": 3567,
            "ticket_number": "353560",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 16:17:07",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 72.93,
            "sla_met": false,
            "sla_breach_hours": 48.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:13:23"
          },
          {
            "ticket_id": 3568,
            "ticket_number": "353561",
            "title": "GBN-92657 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 16:17:15",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 72.93,
            "sla_met": false,
            "sla_breach_hours": 48.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:13:50"
          },
          {
            "ticket_id": 3569,
            "ticket_number": "353562",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 16:27:28",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 72.77,
            "sla_met": false,
            "sla_breach_hours": 48.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:14:18"
          },
          {
            "ticket_id": 3572,
            "ticket_number": "353565",
            "title": "Número de informação da reserva: 6124269",
            "priority": "Reservas sem Formulário",
            "created_at": "30/11/2025 19:52:50",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 44.93,
            "sla_met": false,
            "sla_breach_hours": 20.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 16:49:21"
          },
          {
            "ticket_id": 3578,
            "ticket_number": "353571",
            "title": "GBN-92705 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "01/12/2025 00:03:19",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 40.78,
            "sla_met": false,
            "sla_breach_hours": 16.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 16:50:49"
          },
          {
            "ticket_id": 3586,
            "ticket_number": "353579",
            "title": "GBN-92710 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/12/2025 10:28:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 30.52,
            "sla_met": false,
            "sla_breach_hours": 6.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:00:03"
          },
          {
            "ticket_id": 3590,
            "ticket_number": "353583",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "01/12/2025 10:35:08",
            "close_date": "2025-12-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 11:28:49"
          },
          {
            "ticket_id": 3598,
            "ticket_number": "353591",
            "title": "GBN-92728 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 12:10:56",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 28.85,
            "sla_met": false,
            "sla_breach_hours": 4.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:02:28"
          },
          {
            "ticket_id": 3603,
            "ticket_number": "353596",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505099",
            "priority": "Reservas sem Formulário",
            "created_at": "01/12/2025 12:54:05",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 28.2,
            "sla_met": false,
            "sla_breach_hours": 4.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:06:21"
          },
          {
            "ticket_id": 3604,
            "ticket_number": "353597",
            "title": "AMARAL/MILTON MR 15MAR2026 OPO ORY",
            "priority": "Reservas sem Formulário",
            "created_at": "01/12/2025 12:54:39",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 57.13,
            "sla_met": false,
            "sla_breach_hours": 33.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:03:35"
          },
          {
            "ticket_id": 3606,
            "ticket_number": "353599",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 13:01:56",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 52.23,
            "sla_met": false,
            "sla_breach_hours": 28.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:16:39"
          },
          {
            "ticket_id": 3616,
            "ticket_number": "353609",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:16:50",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 6.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:04:44"
          },
          {
            "ticket_id": 3617,
            "ticket_number": "353610",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:16:57",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 6.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:05:04"
          },
          {
            "ticket_id": 3618,
            "ticket_number": "353611",
            "title": "GBN-92757 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:17:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 6.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:05:23"
          },
          {
            "ticket_id": 3619,
            "ticket_number": "353612",
            "title": "Número de informação da reserva: 6124490",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 10:21:24",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 6.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:06:56"
          },
          {
            "ticket_id": 3620,
            "ticket_number": "353613",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:21:26",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3626,
            "ticket_number": "353619",
            "title": "Reserva confirmada: Free tour por Marrakech - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:21:40",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3634,
            "ticket_number": "353627",
            "title": "GBN-92792 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:23:07",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3635,
            "ticket_number": "353628",
            "title": "Fwd: Viagify informa sobre a sua reserva 122456779",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:09",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:23:10"
          },
          {
            "ticket_id": 3637,
            "ticket_number": "353630",
            "title": "Fwd: Localizador 1224567794 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:15",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:23:15"
          },
          {
            "ticket_id": 3646,
            "ticket_number": "353639",
            "title": "Número de informação da reserva: 6124525",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:23:39",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3649,
            "ticket_number": "353642",
            "title": "Número de informação da reserva: 6124526",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:23:47",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3651,
            "ticket_number": "353644",
            "title": "GBN-92788 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:23:52",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3657,
            "ticket_number": "353650",
            "title": "GBN-92777 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:24:17",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 6.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:10:51"
          },
          {
            "ticket_id": 3663,
            "ticket_number": "353656",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "02/12/2025 11:13:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 11:37:03"
          },
          {
            "ticket_id": 3701,
            "ticket_number": "353693",
            "title": "GBN-92882 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 16:41:55",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 12:41:09"
          },
          {
            "ticket_id": 3712,
            "ticket_number": "353704",
            "title": "pedido envio rgpdreserva voo Ryanair",
            "priority": "P2",
            "created_at": "02/12/2025 18:21:17",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 18:21:17"
          },
          {
            "ticket_id": 3731,
            "ticket_number": "353723",
            "title": "Confirmação de reserva com localizador: 3994964",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 23:24:13",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 39.85,
            "sla_met": false,
            "sla_breach_hours": 15.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:16:05"
          },
          {
            "ticket_id": 3732,
            "ticket_number": "353724",
            "title": "Número de informação da reserva: 6124862",
            "priority": "P2",
            "created_at": "02/12/2025 23:24:15",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 00:18:04"
          },
          {
            "ticket_id": 3733,
            "ticket_number": "353725",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 23:24:21",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 22.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:52:17"
          },
          {
            "ticket_id": 3743,
            "ticket_number": "353735",
            "title": "Fwd: Informações da sua reserva TTN-1225026286#875",
            "priority": "P2",
            "created_at": "03/12/2025 10:05:19",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 10:27:16"
          },
          {
            "ticket_id": 3762,
            "ticket_number": "353754",
            "title": "GBN-92975 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/12/2025 12:27:56",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 12:33:40"
          },
          {
            "ticket_id": 3763,
            "ticket_number": "353755",
            "title": "GBN-92975 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/12/2025 12:28:02",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 12:34:17"
          },
          {
            "ticket_id": 3774,
            "ticket_number": "353766",
            "title": "Fwd: Viagify informa sobre a sua reserva 122509472",
            "priority": "P2",
            "created_at": "03/12/2025 13:21:44",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:21:45"
          },
          {
            "ticket_id": 3775,
            "ticket_number": "353767",
            "title": "Fwd: A sua conta foi criada",
            "priority": "P2",
            "created_at": "03/12/2025 13:21:46",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:21:47"
          },
          {
            "ticket_id": 3781,
            "ticket_number": "353773",
            "title": "Confirmação de reserva. Localizador: 2D6UKEID9B",
            "priority": "P2",
            "created_at": "03/12/2025 14:23:36",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:48:59"
          },
          {
            "ticket_id": 3798,
            "ticket_number": "353790",
            "title": "Confirmación de la reserva con localizador: 399572",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 16:41:48",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:54:05"
          },
          {
            "ticket_id": 3799,
            "ticket_number": "353791",
            "title": "Criação de processo File 420474/25",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 16:41:54",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 16:54:37"
          },
          {
            "ticket_id": 3801,
            "ticket_number": "353793",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 17:15:30",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:36:29"
          },
          {
            "ticket_id": 3808,
            "ticket_number": "353800",
            "title": "Confirmação de Reserva * File 420365",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 17:42:25",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 4.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:19:31"
          },
          {
            "ticket_id": 3813,
            "ticket_number": "353805",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604507550",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 18:16:32",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:05:08"
          },
          {
            "ticket_id": 3814,
            "ticket_number": "353806",
            "title": "Confirmação de reserva com localizador: 3995882",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 18:16:34",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 18:37:31"
          },
          {
            "ticket_id": 3829,
            "ticket_number": "353821",
            "title": "Fwd: Proteja sua viagem por apenas 46.4 EUR",
            "priority": "P2",
            "created_at": "03/12/2025 21:04:05",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 21:04:05"
          },
          {
            "ticket_id": 3831,
            "ticket_number": "353823",
            "title": "TUI Portugal B2B: Confirmação de reserva - TCP-740",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 21:04:20",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:16:21"
          },
          {
            "ticket_id": 3846,
            "ticket_number": "353838",
            "title": "GBN-93262 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 23:36:19",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 15.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:27:46"
          },
          {
            "ticket_id": 3856,
            "ticket_number": "353848",
            "title": "RGPD - Soraia Santos Pereira - 2415700055",
            "priority": "P2",
            "created_at": "04/12/2025 10:04:36",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 10:04:36"
          },
          {
            "ticket_id": 3865,
            "ticket_number": "353857",
            "title": "Fwd: Viagify informa sobre a sua reserva 122530712",
            "priority": "P2",
            "created_at": "04/12/2025 11:18:56",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 11:18:57"
          },
          {
            "ticket_id": 3866,
            "ticket_number": "353858",
            "title": "Confirmaciones a Agencia. Agencia UMA FAMILIA EM V",
            "priority": "P2",
            "created_at": "04/12/2025 11:26:27",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 11:33:30"
          },
          {
            "ticket_id": 3875,
            "ticket_number": "353867",
            "title": "Envio de Fatura 209286",
            "priority": "P2",
            "created_at": "04/12/2025 13:40:59",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 15:16:51"
          },
          {
            "ticket_id": 3877,
            "ticket_number": "353869",
            "title": "Confirmação de Reserva * File 420319",
            "priority": "P2",
            "created_at": "04/12/2025 13:41:11",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 15:21:40"
          },
          {
            "ticket_id": 3901,
            "ticket_number": "353893",
            "title": "Webinar Corfu PDF e Video",
            "priority": "P2",
            "created_at": "04/12/2025 19:06:54",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 19:09:09"
          },
          {
            "ticket_id": 3903,
            "ticket_number": "353895",
            "title": "Confirmação de reserva com localizador: 3997225",
            "priority": "P2",
            "created_at": "04/12/2025 19:49:26",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:57:07"
          },
          {
            "ticket_id": 3933,
            "ticket_number": "353925",
            "title": "Envio de documentos de File 419153 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "05/12/2025 11:32:09",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 12:27:33"
          },
          {
            "ticket_id": 3942,
            "ticket_number": "353934",
            "title": "PARTIDAS DE LISBOA 2026 - TUDO INCLUÍDO!",
            "priority": "P2",
            "created_at": "05/12/2025 13:18:56",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 13:35:38"
          },
          {
            "ticket_id": 3945,
            "ticket_number": "353937",
            "title": "[clientesgeral] FERIADO 8 DEZEMBRO 2025",
            "priority": "P2",
            "created_at": "05/12/2025 13:19:07",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 13:37:02"
          },
          {
            "ticket_id": 3955,
            "ticket_number": "353947",
            "title": "Informação de reserva - SPT002501549170",
            "priority": "P2",
            "created_at": "05/12/2025 15:08:08",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 15:41:02"
          },
          {
            "ticket_id": 3956,
            "ticket_number": "353948",
            "title": "Fwd: Viagify informa sobre a sua reserva 122565889",
            "priority": "P2",
            "created_at": "05/12/2025 15:08:11",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 15:08:13"
          },
          {
            "ticket_id": 3965,
            "ticket_number": "353957",
            "title": "Fwd: A3JCKH | Belmira, os planos de viagem mudam –",
            "priority": "P2",
            "created_at": "05/12/2025 17:50:28",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 17:50:29"
          },
          {
            "ticket_id": 3970,
            "ticket_number": "353962",
            "title": "Fwd: Uma Familia Em Viagem - Uma Familia Em Viagem",
            "priority": "P2",
            "created_at": "05/12/2025 18:31:01",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 19:10:03"
          },
          {
            "ticket_id": 3971,
            "ticket_number": "353963",
            "title": "RE: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P2",
            "created_at": "05/12/2025 18:31:04",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 19:18:16"
          },
          {
            "ticket_id": 3973,
            "ticket_number": "353965",
            "title": "Ampliámos a Cyber Monday até 09/12 com mais descon",
            "priority": "P2",
            "created_at": "05/12/2025 18:32:48",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 19:17:40"
          },
          {
            "ticket_id": 3981,
            "ticket_number": "353973",
            "title": "GBN-93725 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/12/2025 20:35:17",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 20:42:57"
          },
          {
            "ticket_id": 3986,
            "ticket_number": "353978",
            "title": "GBN-93743 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/12/2025 22:39:01",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 90.1,
            "sla_met": false,
            "sla_breach_hours": 66.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 16:45:36"
          },
          {
            "ticket_id": 3989,
            "ticket_number": "353981",
            "title": "Fwd: Viagify informa sobre a sua reserva 122579021",
            "priority": "Reservas sem Formulário",
            "created_at": "05/12/2025 23:06:24",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 23:06:25"
          },
          {
            "ticket_id": 3990,
            "ticket_number": "353982",
            "title": "Confirmação de reserva com localizador: 3998550",
            "priority": "Reservas sem Formulário",
            "created_at": "05/12/2025 23:10:45",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/12/2025 00:27:04"
          },
          {
            "ticket_id": 3991,
            "ticket_number": "353983",
            "title": "GBN-93746 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/12/2025 23:29:28",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/12/2025 00:26:31"
          },
          {
            "ticket_id": 3999,
            "ticket_number": "353991",
            "title": "Alteração voo GBN-91982",
            "priority": "P2",
            "created_at": "06/12/2025 13:59:55",
            "close_date": "2025-12-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 13:59:55"
          },
          {
            "ticket_id": 4002,
            "ticket_number": "353994",
            "title": "Fwd: Confirmación de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/12/2025 14:05:31",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 122.02,
            "sla_met": false,
            "sla_breach_hours": 98.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:07:15"
          },
          {
            "ticket_id": 4019,
            "ticket_number": "354011",
            "title": "Documentação da reserva TTN-1191066580#87840602",
            "priority": "P2",
            "created_at": "07/12/2025 10:14:32",
            "close_date": "2025-12-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/12/2025 10:25:38"
          },
          {
            "ticket_id": 4020,
            "ticket_number": "354012",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-93",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/12/2025 10:14:38",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 101.93,
            "sla_met": false,
            "sla_breach_hours": 77.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:11:19"
          },
          {
            "ticket_id": 4027,
            "ticket_number": "354019",
            "title": "GBN-93850 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/12/2025 18:43:56",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 70.22,
            "sla_met": false,
            "sla_breach_hours": 46.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:57:45"
          },
          {
            "ticket_id": 4038,
            "ticket_number": "354030",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-93",
            "priority": "Reservas sem Formulário",
            "created_at": "08/12/2025 16:43:25",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 49.75,
            "sla_met": false,
            "sla_breach_hours": 25.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:28:28"
          },
          {
            "ticket_id": 4040,
            "ticket_number": "354032",
            "title": "GBN Travel: Resend booking confirmation - GBN-9389",
            "priority": "Reservas sem Formulário",
            "created_at": "08/12/2025 17:14:06",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/12/2025 17:14:12"
          },
          {
            "ticket_id": 4041,
            "ticket_number": "354033",
            "title": "GBN-93895 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "08/12/2025 17:14:12",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 49.32,
            "sla_met": false,
            "sla_breach_hours": 25.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:33:43"
          },
          {
            "ticket_id": 4055,
            "ticket_number": "354047",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-93",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 10:34:17",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 53.67,
            "sla_met": false,
            "sla_breach_hours": 29.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:15:16"
          },
          {
            "ticket_id": 4061,
            "ticket_number": "354053",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:24:11",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 31.08,
            "sla_met": false,
            "sla_breach_hours": 7.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:29:29"
          },
          {
            "ticket_id": 4062,
            "ticket_number": "354054",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:24:18",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 31.08,
            "sla_met": false,
            "sla_breach_hours": 7.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:29:53"
          },
          {
            "ticket_id": 4063,
            "ticket_number": "354055",
            "title": "GBN-93916 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:24:26",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 29.5,
            "sla_met": false,
            "sla_breach_hours": 5.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:55:26"
          },
          {
            "ticket_id": 4067,
            "ticket_number": "354059",
            "title": "GBN-93916 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:25:15",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 29.55,
            "sla_met": false,
            "sla_breach_hours": 5.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:58:22"
          },
          {
            "ticket_id": 4075,
            "ticket_number": "354067",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 12:37:00",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 51.37,
            "sla_met": false,
            "sla_breach_hours": 27.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 15:59:12"
          },
          {
            "ticket_id": 4092,
            "ticket_number": "354084",
            "title": "Confirmação de reserva com localizador: 4000286",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 16:30:49",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 47.78,
            "sla_met": false,
            "sla_breach_hours": 23.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:18:26"
          },
          {
            "ticket_id": 4094,
            "ticket_number": "354086",
            "title": "GBN-93891 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 16:30:54",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 26.0,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:31:32"
          },
          {
            "ticket_id": 4095,
            "ticket_number": "354087",
            "title": "GBN-94014 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 16:30:58",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 26.0,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 18:31:53"
          },
          {
            "ticket_id": 4096,
            "ticket_number": "354088",
            "title": "Fwd: Viagify informa sobre a sua reserva 122639201",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 16:31:01",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 47.8,
            "sla_met": false,
            "sla_breach_hours": 23.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:19:16"
          },
          {
            "ticket_id": 4098,
            "ticket_number": "354090",
            "title": "Fwd: Importante: O seu cartão de embarque da Ryana",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 16:54:47",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 16:54:47"
          },
          {
            "ticket_id": 4100,
            "ticket_number": "354092",
            "title": "Confirmation of booking with locatorO167EQ7T",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 17:42:01",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 46.73,
            "sla_met": false,
            "sla_breach_hours": 22.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:26:17"
          },
          {
            "ticket_id": 4104,
            "ticket_number": "354096",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (ZS5",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 18:48:18",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 26.68,
            "sla_met": false,
            "sla_breach_hours": 2.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 21:29:24"
          },
          {
            "ticket_id": 4106,
            "ticket_number": "354098",
            "title": "Reserva Aérea ZBTGAY",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 18:48:55",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 19:26:11"
          },
          {
            "ticket_id": 4108,
            "ticket_number": "354100",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 19:17:05",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 19:17:05"
          },
          {
            "ticket_id": 4110,
            "ticket_number": "354102",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/12/2025 20:14:07",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 20:14:08"
          },
          {
            "ticket_id": 4111,
            "ticket_number": "354103",
            "title": "GBN Travel: Resend booking confirmation - GBN-8636",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 20:14:12",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 20:14:12"
          },
          {
            "ticket_id": 4139,
            "ticket_number": "354131",
            "title": "Confirmação de reserva 335503 ### TIME LIMIT EMISS",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 10:52:00",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 29.72,
            "sla_met": false,
            "sla_breach_hours": 5.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:35:50"
          },
          {
            "ticket_id": 4156,
            "ticket_number": "354148",
            "title": "Envio de Fatura - File 420983/25",
            "priority": "P2",
            "created_at": "10/12/2025 13:07:55",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 13:11:57"
          },
          {
            "ticket_id": 4167,
            "ticket_number": "354159",
            "title": "Faça o download da sua fatura - Civitatis.com",
            "priority": "P2",
            "created_at": "10/12/2025 15:18:27",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:14:14"
          },
          {
            "ticket_id": 4170,
            "ticket_number": "354162",
            "title": "Fwd: Viagify informa sobre a sua reserva 122666168",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 16:13:58",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 5.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 22:00:56"
          },
          {
            "ticket_id": 4182,
            "ticket_number": "354174",
            "title": "A/c Cátia Leal - Envio de IBAN",
            "priority": "P2",
            "created_at": "10/12/2025 17:29:41",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:29:42"
          },
          {
            "ticket_id": 4187,
            "ticket_number": "354179",
            "title": "GBN-94228 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 18:10:09",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 22:03:57"
          },
          {
            "ticket_id": 4188,
            "ticket_number": "354180",
            "title": "Re:[## 27004 ##] GBN-86003 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/12/2025 18:34:43",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 18:36:48"
          },
          {
            "ticket_id": 4190,
            "ticket_number": "354182",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 19:11:31",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 20.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 15:43:18"
          },
          {
            "ticket_id": 4193,
            "ticket_number": "354185",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 19:11:44",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 20.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:00:29"
          },
          {
            "ticket_id": 4194,
            "ticket_number": "354186",
            "title": "GBN-94229 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 19:11:51",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 20.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 15:41:46"
          },
          {
            "ticket_id": 4214,
            "ticket_number": "354206",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/12/2025 10:10:02",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 5.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:04:41"
          },
          {
            "ticket_id": 4222,
            "ticket_number": "354214",
            "title": "GBN-94286 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/12/2025 11:47:38",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 11:47:33"
          },
          {
            "ticket_id": 4229,
            "ticket_number": "354221",
            "title": "Solole. Booking QNYP52TM is close to entering expe",
            "priority": "P2",
            "created_at": "11/12/2025 14:03:27",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 15:39:12"
          },
          {
            "ticket_id": 4230,
            "ticket_number": "354222",
            "title": "Fwd: URRWXV | Extras para a tua viagem para Marrak",
            "priority": "P2",
            "created_at": "11/12/2025 15:23:52",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 15:23:52"
          },
          {
            "ticket_id": 4246,
            "ticket_number": "354238",
            "title": "GBN Travel: Resend booking confirmation - GBN-9325",
            "priority": "P2",
            "created_at": "11/12/2025 18:59:56",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 18:59:56"
          },
          {
            "ticket_id": 4250,
            "ticket_number": "354242",
            "title": "Confirmacao 335599",
            "priority": "P2",
            "created_at": "11/12/2025 20:52:45",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 21:24:33"
          },
          {
            "ticket_id": 4312,
            "ticket_number": "354304",
            "title": "Agradecemos o preenchimento deste formulário: Form",
            "priority": "P2",
            "created_at": "12/12/2025 17:27:01",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 17:41:59"
          },
          {
            "ticket_id": 4314,
            "ticket_number": "354306",
            "title": "Fwd: Informações da sua reserva TTN-1226661686#880",
            "priority": "P2",
            "created_at": "12/12/2025 18:09:34",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:09:35"
          },
          {
            "ticket_id": 4320,
            "ticket_number": "354312",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/12/2025 18:35:16",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:35:16"
          },
          {
            "ticket_id": 4321,
            "ticket_number": "354313",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/12/2025 18:35:21",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:35:22"
          },
          {
            "ticket_id": 4323,
            "ticket_number": "354315",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/12/2025 18:36:07",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:36:07"
          },
          {
            "ticket_id": 4324,
            "ticket_number": "354316",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/12/2025 18:36:42",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:36:42"
          },
          {
            "ticket_id": 4326,
            "ticket_number": "354318",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "P2",
            "created_at": "12/12/2025 18:52:38",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 18:52:38"
          },
          {
            "ticket_id": 4332,
            "ticket_number": "354324",
            "title": "RGPD - GBN - 94614",
            "priority": "P2",
            "created_at": "12/12/2025 23:33:09",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 23:33:10"
          },
          {
            "ticket_id": 4359,
            "ticket_number": "354351",
            "title": "Fwd: Lamentamos que o teu voo tenha sido cancelado",
            "priority": "P2",
            "created_at": "14/12/2025 10:01:30",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/12/2025 10:01:31"
          },
          {
            "ticket_id": 4360,
            "ticket_number": "354352",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "14/12/2025 10:01:34",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/12/2025 10:01:35"
          },
          {
            "ticket_id": 4398,
            "ticket_number": "354390",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "15/12/2025 10:41:21",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:45:26"
          },
          {
            "ticket_id": 4399,
            "ticket_number": "354391",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "15/12/2025 10:41:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:44:33"
          },
          {
            "ticket_id": 4400,
            "ticket_number": "354392",
            "title": "Falta de assinaturas nas optis",
            "priority": "P2",
            "created_at": "15/12/2025 10:41:24",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:41:24"
          },
          {
            "ticket_id": 294,
            "ticket_number": "35293",
            "title": "Viagem de Grupo - 15 pessoas - Filipa Costa",
            "priority": "P2",
            "created_at": "07/10/2025 11:57:58",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 11:57:58"
          },
          {
            "ticket_id": 413,
            "ticket_number": "35412",
            "title": "Confirmação da Reserva - Budapeste | 97Y839GTCE",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/10/2025 17:15:16",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:15:13"
          },
          {
            "ticket_id": 595,
            "ticket_number": "35594",
            "title": "Pedido de Orçamento de grupo ",
            "priority": "P2",
            "created_at": "13/10/2025 15:03:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 15:03:59"
          },
          {
            "ticket_id": 681,
            "ticket_number": "35680",
            "title": "Orçamento de Grupo",
            "priority": "P2",
            "created_at": "14/10/2025 15:27:21",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 15:27:21"
          },
          {
            "ticket_id": 941,
            "ticket_number": "35940",
            "title": "Pedido cotação de grupo para Madeira",
            "priority": "P2",
            "created_at": "20/10/2025 11:11:54",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 11:11:55"
          },
          {
            "ticket_id": 1331,
            "ticket_number": "351328",
            "title": "Pedido de cotação em Grupo - Viagem Escuteiros | K",
            "priority": "P2",
            "created_at": "27/10/2025 13:49:31",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 13:49:31"
          },
          {
            "ticket_id": 1781,
            "ticket_number": "351778",
            "title": "GBN-77919 - Sua reserva foi atualizada com serviço",
            "priority": "P2",
            "created_at": "03/11/2025 21:07:45",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 21:18:30"
          },
          {
            "ticket_id": 1895,
            "ticket_number": "351892",
            "title": "Pedido de orçamento",
            "priority": "P2",
            "created_at": "05/11/2025 22:14:19",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 22:14:19"
          },
          {
            "ticket_id": 2191,
            "ticket_number": "352187",
            "title": "Pedido de orçamento de Escola de Ballet - Amsterdã",
            "priority": "P2",
            "created_at": "11/11/2025 12:13:54",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 15:02:00"
          },
          {
            "ticket_id": 2562,
            "ticket_number": "352557",
            "title": "GBN-90289  - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/11/2025 17:55:47",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 137.65,
            "sla_met": false,
            "sla_breach_hours": 113.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:35:46"
          },
          {
            "ticket_id": 2599,
            "ticket_number": "352594",
            "title": "RE: Pedido de cotação - contratação direta",
            "priority": "P3",
            "created_at": "17/11/2025 12:39:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 13:45:22"
          },
          {
            "ticket_id": 2624,
            "ticket_number": "352619",
            "title": "Número de informação da reserva: 6120795",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/11/2025 17:49:26",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 17:58:39"
          },
          {
            "ticket_id": 2769,
            "ticket_number": "352764",
            "title": "Reserva confirmada: Visita guiada por Budapeste + ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 10:21:44",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 10:21:47"
          },
          {
            "ticket_id": 2779,
            "ticket_number": "352774",
            "title": "Fwd: Viagify informa sobre a sua reserva 122033530",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 10:40:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 10:40:55"
          },
          {
            "ticket_id": 2820,
            "ticket_number": "352815",
            "title": "Pedido de informação - Meliã Hotels | Vanessa",
            "priority": "P3",
            "created_at": "19/11/2025 19:02:08",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 19:02:09"
          },
          {
            "ticket_id": 2945,
            "ticket_number": "352940",
            "title": "Confirmacao 334142",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 12:59:20",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 22.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:23:04"
          },
          {
            "ticket_id": 2956,
            "ticket_number": "352951",
            "title": "GBN-91053 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/11/2025 15:57:52",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 55.92,
            "sla_met": false,
            "sla_breach_hours": 31.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/11/2025 23:53:35"
          },
          {
            "ticket_id": 3070,
            "ticket_number": "353063",
            "title": "GBN-90972",
            "priority": "P3",
            "created_at": "24/11/2025 10:19:26",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 10:19:26"
          },
          {
            "ticket_id": 3106,
            "ticket_number": "353099",
            "title": "Paulo Deny - 16 pessoas mexico",
            "priority": "P2",
            "created_at": "24/11/2025 15:27:33",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 15:27:33"
          },
          {
            "ticket_id": 3180,
            "ticket_number": "353173",
            "title": "Confirmação e Sinalização de Reserva 208653 // SUP",
            "priority": "P2",
            "created_at": "25/11/2025 13:59:20",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 14:04:44"
          },
          {
            "ticket_id": 3192,
            "ticket_number": "353185",
            "title": "Número de informação da reserva: 6122762",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 16:17:38",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:48:10"
          },
          {
            "ticket_id": 3214,
            "ticket_number": "353207",
            "title": "Número de informação da reserva: 6122902",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 21:17:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 99.03,
            "sla_met": false,
            "sla_breach_hours": 75.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 00:20:10"
          },
          {
            "ticket_id": 3227,
            "ticket_number": "353220",
            "title": "GBN-91784",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 23:38:06",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 235.13,
            "sla_met": false,
            "sla_breach_hours": 211.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 18:46:28"
          },
          {
            "ticket_id": 3429,
            "ticket_number": "353422",
            "title": "Fwd: Viagify informa sobre a sua reserva 122337874",
            "priority": "P3",
            "created_at": "28/11/2025 10:05:38",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 10:05:39"
          },
          {
            "ticket_id": 3483,
            "ticket_number": "353476",
            "title": "GBN-92397 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 17:01:27",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 93.9,
            "sla_met": false,
            "sla_breach_hours": 69.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:56:23"
          },
          {
            "ticket_id": 3505,
            "ticket_number": "353498",
            "title": "GBN-92509 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 22:24:17",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 19.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 17:58:32"
          },
          {
            "ticket_id": 3506,
            "ticket_number": "353499",
            "title": "Informação de reserva - SPT002501558557",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 22:28:55",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 87.88,
            "sla_met": false,
            "sla_breach_hours": 63.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:22:17"
          },
          {
            "ticket_id": 3509,
            "ticket_number": "353502",
            "title": "GBN-92520 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 22:55:28",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 87.77,
            "sla_met": false,
            "sla_breach_hours": 63.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:42:22"
          },
          {
            "ticket_id": 3530,
            "ticket_number": "353523",
            "title": "Fwd: easyJet número de referência da reserva: KBMT",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 15:32:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 16:39:34"
          },
          {
            "ticket_id": 3531,
            "ticket_number": "353524",
            "title": "Fwd: easyJet número de referência da reserva: KBMT",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 15:32:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 16:39:46"
          },
          {
            "ticket_id": 3566,
            "ticket_number": "353559",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 16:16:26",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 16:16:26"
          },
          {
            "ticket_id": 3575,
            "ticket_number": "353568",
            "title": "Número de informação da reserva: 6124315",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 23:09:37",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 694.33,
            "sla_met": false,
            "sla_breach_hours": 670.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 21:29:42"
          },
          {
            "ticket_id": 3580,
            "ticket_number": "353573",
            "title": "Número de informação da reserva: 6124340",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:33",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 76.55,
            "sla_met": false,
            "sla_breach_hours": 52.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:01:50"
          },
          {
            "ticket_id": 3581,
            "ticket_number": "353574",
            "title": "Número de informação da reserva: 6124341",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:35",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 76.55,
            "sla_met": false,
            "sla_breach_hours": 52.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:02:00"
          },
          {
            "ticket_id": 3582,
            "ticket_number": "353575",
            "title": "Número de informação da reserva: 6124337",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:38",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 76.57,
            "sla_met": false,
            "sla_breach_hours": 52.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:02:44"
          },
          {
            "ticket_id": 3585,
            "ticket_number": "353578",
            "title": "Número de informação da reserva: 6124336",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:48",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 76.57,
            "sla_met": false,
            "sla_breach_hours": 52.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:03:12"
          },
          {
            "ticket_id": 3632,
            "ticket_number": "353625",
            "title": "GBN-92759 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 10:21:58",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 6.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:08:44"
          },
          {
            "ticket_id": 3672,
            "ticket_number": "353665",
            "title": "Confirmación de la reserva con localizador: 399400",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 12:28:41",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 22:20:25"
          },
          {
            "ticket_id": 3747,
            "ticket_number": "353739",
            "title": "GBN Travel: Information about your booking -     G",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 10:05:33",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 10:05:42"
          },
          {
            "ticket_id": 3812,
            "ticket_number": "353804",
            "title": "Confirmaciones a Agencia. Agencia UMA FAMILIA EM V",
            "priority": "P2",
            "created_at": "03/12/2025 18:15:58",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 18:37:25"
          },
          {
            "ticket_id": 3836,
            "ticket_number": "353828",
            "title": "Reserva confirmada: Visita guiada pela Alhambra e ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 21:15:55",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:15:55"
          },
          {
            "ticket_id": 3837,
            "ticket_number": "353829",
            "title": "Reserva confirmada: Cruzeiro por Sevilha - Civitat",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 21:15:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:15:58"
          },
          {
            "ticket_id": 3838,
            "ticket_number": "353830",
            "title": "Reserva confirmada: Espetáculo no Museu do Baile F",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 21:16:01",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:16:01"
          },
          {
            "ticket_id": 3890,
            "ticket_number": "353882",
            "title": "Thank you for contacting Celestyal",
            "priority": "P3",
            "created_at": "04/12/2025 17:22:21",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 16:22:38"
          },
          {
            "ticket_id": 3891,
            "ticket_number": "353883",
            "title": "GBN-93428 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "04/12/2025 17:34:39",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 166.28,
            "sla_met": false,
            "sla_breach_hours": 142.28,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 15:51:49"
          },
          {
            "ticket_id": 3922,
            "ticket_number": "353914",
            "title": "Confirmação de reserva com localizador: 3997424",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/12/2025 10:09:33",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 126.82,
            "sla_met": false,
            "sla_breach_hours": 102.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:59:13"
          },
          {
            "ticket_id": 3994,
            "ticket_number": "353986",
            "title": "Fwd: Consulta sobre o seu pedido / LOC 1222039695 ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/12/2025 13:02:47",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/12/2025 13:10:52"
          },
          {
            "ticket_id": 4008,
            "ticket_number": "354000",
            "title": "GBN-93791 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/12/2025 17:03:56",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 77.95,
            "sla_met": false,
            "sla_breach_hours": 53.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 23:01:43"
          },
          {
            "ticket_id": 4014,
            "ticket_number": "354006",
            "title": "GBN-93812 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/12/2025 19:18:37",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 93.55,
            "sla_met": false,
            "sla_breach_hours": 69.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:51:38"
          },
          {
            "ticket_id": 4018,
            "ticket_number": "354010",
            "title": "GBN-93824 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/12/2025 10:14:25",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/12/2025 10:14:38"
          },
          {
            "ticket_id": 4054,
            "ticket_number": "354046",
            "title": "GBN-93920 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 10:34:10",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.67,
            "sla_met": false,
            "sla_breach_hours": 29.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:14:45"
          },
          {
            "ticket_id": 4060,
            "ticket_number": "354052",
            "title": "Fwd: Sua viagem para Hurghada está confirmada – Re",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:24:05",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 11:24:05"
          },
          {
            "ticket_id": 4066,
            "ticket_number": "354058",
            "title": "Fwd: easyJet número de referência da reserva: KBPF",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:25:12",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 11:25:13"
          },
          {
            "ticket_id": 4068,
            "ticket_number": "354060",
            "title": "Fwd: easyJet número de referência da reserva: KBPF",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:25:17",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 11:25:18"
          },
          {
            "ticket_id": 4069,
            "ticket_number": "354061",
            "title": "Fwd: easyJet número de referência da reserva: KBPF",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:25:20",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 11:25:21"
          },
          {
            "ticket_id": 4070,
            "ticket_number": "354062",
            "title": "Fwd: easyJet número de referência da reserva: KBPF",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 11:25:23",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 11:25:24"
          },
          {
            "ticket_id": 4078,
            "ticket_number": "354070",
            "title": "Documentação Disponível - Reserva 332064",
            "priority": "P2",
            "created_at": "09/12/2025 13:08:44",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 13:20:09"
          },
          {
            "ticket_id": 4091,
            "ticket_number": "354083",
            "title": "Fwd: Viagify informa sobre a sua reserva 122639201",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 16:30:46",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 16:30:47"
          },
          {
            "ticket_id": 4112,
            "ticket_number": "354104",
            "title": "Fwd: Viagify informa sobre a sua reserva 122645795",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 20:59:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 20:59:59"
          },
          {
            "ticket_id": 4128,
            "ticket_number": "354120",
            "title": "GBN-94124 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 10:01:54",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 54.55,
            "sla_met": false,
            "sla_breach_hours": 30.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:34:55"
          },
          {
            "ticket_id": 4129,
            "ticket_number": "354121",
            "title": "Fwd: Viagify informa sobre a sua reserva 122645223",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 10:12:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 10:12:09"
          },
          {
            "ticket_id": 4157,
            "ticket_number": "354149",
            "title": "Proposta Solférias  17682/2025",
            "priority": "P2",
            "created_at": "10/12/2025 13:08:01",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 19:12:59"
          },
          {
            "ticket_id": 4168,
            "ticket_number": "354160",
            "title": "Fwd: Viagify informa sobre a sua reserva 122666168",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 16:13:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 16:13:53"
          },
          {
            "ticket_id": 4180,
            "ticket_number": "354172",
            "title": "Proposta Solférias  18221/2025",
            "priority": "P3",
            "created_at": "10/12/2025 17:29:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 17.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:58:33"
          },
          {
            "ticket_id": 4183,
            "ticket_number": "354175",
            "title": "Confirmacion de venta Renfe",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 17:29:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 24.33,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 17:50:35"
          },
          {
            "ticket_id": 4200,
            "ticket_number": "354192",
            "title": "Pedido orçamento : Grupo 10 pessoas : DXB/ CMB / M",
            "priority": "P2",
            "created_at": "10/12/2025 20:14:58",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 20:14:58"
          },
          {
            "ticket_id": 4202,
            "ticket_number": "354194",
            "title": "GBN-94260 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 20:48:40",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:45:14"
          },
          {
            "ticket_id": 4204,
            "ticket_number": "354196",
            "title": "GBN-94265 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 21:11:01",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 43.58,
            "sla_met": false,
            "sla_breach_hours": 19.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:46:34"
          },
          {
            "ticket_id": 4205,
            "ticket_number": "354197",
            "title": "GBN-94269   - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/12/2025 22:39:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 17.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 15:40:50"
          },
          {
            "ticket_id": 4245,
            "ticket_number": "354237",
            "title": "GBN-94424 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/12/2025 18:59:51",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 21.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:32:05"
          },
          {
            "ticket_id": 4253,
            "ticket_number": "354245",
            "title": "GBN-94474 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/12/2025 23:06:05",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 17.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:41:11"
          },
          {
            "ticket_id": 4268,
            "ticket_number": "354260",
            "title": "GBN-94483 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/12/2025 10:28:37",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 130.93,
            "sla_met": false,
            "sla_breach_hours": 106.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 21:25:04"
          },
          {
            "ticket_id": 4276,
            "ticket_number": "354268",
            "title": "GBN-94485 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/12/2025 11:28:27",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 147.88,
            "sla_met": false,
            "sla_breach_hours": 123.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/12/2025 15:22:16"
          },
          {
            "ticket_id": 4287,
            "ticket_number": "354279",
            "title": "Orçamento para inclusão de pessoa na reserva - 960",
            "priority": "P3",
            "created_at": "12/12/2025 12:29:20",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:08:02"
          },
          {
            "ticket_id": 4301,
            "ticket_number": "354293",
            "title": "Solicitação de  cotação - Ribeira Collection - Fim",
            "priority": "P3",
            "created_at": "12/12/2025 14:41:51",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 14:41:52"
          },
          {
            "ticket_id": 4303,
            "ticket_number": "354295",
            "title": "Solicitação de orçamento - Fim de Ano Vale da Lapa",
            "priority": "P2",
            "created_at": "12/12/2025 14:47:33",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:47:33"
          },
          {
            "ticket_id": 4327,
            "ticket_number": "354319",
            "title": "Fatura - Recibo - Comissões Juliana Costa - Ferias",
            "priority": "P3",
            "created_at": "12/12/2025 19:32:11",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 19:32:11"
          },
          {
            "ticket_id": 4328,
            "ticket_number": "354320",
            "title": "File 411467 ** alteração horário DOH/ZNZ/DOH",
            "priority": "P2",
            "created_at": "12/12/2025 19:50:13",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 19:54:05"
          },
          {
            "ticket_id": 4336,
            "ticket_number": "354328",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 11:14:06",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 49.75,
            "sla_met": false,
            "sla_breach_hours": 25.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 12:59:20"
          },
          {
            "ticket_id": 4338,
            "ticket_number": "354330",
            "title": "GBN-94614 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 11:14:14",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/12/2025 11:14:14"
          },
          {
            "ticket_id": 4341,
            "ticket_number": "354333",
            "title": "GBN-94614 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 11:14:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 50.15,
            "sla_met": false,
            "sla_breach_hours": 26.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 13:23:36"
          },
          {
            "ticket_id": 4343,
            "ticket_number": "354335",
            "title": "Criação de processo File 421441/25",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 11:14:29",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 50.13,
            "sla_met": false,
            "sla_breach_hours": 26.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 13:23:10"
          },
          {
            "ticket_id": 4346,
            "ticket_number": "354338",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 12:16:21",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 51.03,
            "sla_met": false,
            "sla_breach_hours": 27.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:49"
          },
          {
            "ticket_id": 4347,
            "ticket_number": "354339",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 12:16:24",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 51.03,
            "sla_met": false,
            "sla_breach_hours": 27.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:35"
          },
          {
            "ticket_id": 4349,
            "ticket_number": "354341",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 12:21:59",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 50.93,
            "sla_met": false,
            "sla_breach_hours": 26.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:29"
          },
          {
            "ticket_id": 4350,
            "ticket_number": "354342",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 12:23:02",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 50.92,
            "sla_met": false,
            "sla_breach_hours": 26.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:16"
          },
          {
            "ticket_id": 4351,
            "ticket_number": "354343",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 12:23:05",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 50.92,
            "sla_met": false,
            "sla_breach_hours": 26.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:10"
          },
          {
            "ticket_id": 4354,
            "ticket_number": "354346",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 17:07:25",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 44.68,
            "sla_met": false,
            "sla_breach_hours": 20.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 13:49:23"
          },
          {
            "ticket_id": 4356,
            "ticket_number": "354348",
            "title": "GBN-94695 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/12/2025 18:48:48",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/12/2025 18:48:48"
          },
          {
            "ticket_id": 4361,
            "ticket_number": "354353",
            "title": "GBN-94696 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 10:01:37",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 27.93,
            "sla_met": false,
            "sla_breach_hours": 3.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 13:58:34"
          },
          {
            "ticket_id": 4362,
            "ticket_number": "354354",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 10:01:43",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 10:01:44"
          },
          {
            "ticket_id": 4368,
            "ticket_number": "354360",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 14:53:00",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 14:53:00"
          },
          {
            "ticket_id": 4369,
            "ticket_number": "354361",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 14:53:08",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 14:53:08"
          },
          {
            "ticket_id": 4370,
            "ticket_number": "354362",
            "title": "GBN-94716 - Reenviar informações sobre sua reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 14:58:38",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 14:58:38"
          },
          {
            "ticket_id": 4371,
            "ticket_number": "354363",
            "title": "GBN-94716 - Reenviar informações sobre sua reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 15:03:38",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 15:03:38"
          },
          {
            "ticket_id": 4374,
            "ticket_number": "354366",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/12/2025 16:26:04",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 23.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:48:25"
          },
          {
            "ticket_id": 4375,
            "ticket_number": "354367",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/12/2025 16:29:27",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 23.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:49:50"
          },
          {
            "ticket_id": 4376,
            "ticket_number": "354368",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 17:07:51",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 22.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:18:05"
          },
          {
            "ticket_id": 4378,
            "ticket_number": "354370",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/12/2025 18:39:23",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 18:39:32"
          },
          {
            "ticket_id": 4379,
            "ticket_number": "354371",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 18:39:29",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 18:39:38"
          },
          {
            "ticket_id": 4380,
            "ticket_number": "354372",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/12/2025 18:39:32",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 21.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:48:31"
          },
          {
            "ticket_id": 4381,
            "ticket_number": "354373",
            "title": "GBN-94729 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/12/2025 18:39:38",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 18:39:38"
          },
          {
            "ticket_id": 4385,
            "ticket_number": "354377",
            "title": "GBN-94716 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 10:11:15",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 5.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 15:39:03"
          },
          {
            "ticket_id": 4392,
            "ticket_number": "354384",
            "title": "GBN-94746 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 10:11:32",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 10:11:32"
          },
          {
            "ticket_id": 4393,
            "ticket_number": "354385",
            "title": "Fwd: Viagify informa sobre a sua reserva 122751350",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/12/2025 10:11:36",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 10:11:36"
          },
          {
            "ticket_id": 4397,
            "ticket_number": "354389",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604511198",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 10:11:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 11:55:33"
          },
          {
            "ticket_id": 4406,
            "ticket_number": "354398",
            "title": "Convite para o jogo da Liga de Portugal | SL Benfi",
            "priority": "P2",
            "created_at": "15/12/2025 11:25:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 11:28:41"
          },
          {
            "ticket_id": 4407,
            "ticket_number": "354399",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-94",
            "priority": "P2",
            "created_at": "15/12/2025 11:36:01",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 271.62,
            "sla_met": false,
            "sla_breach_hours": 267.62,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 19:13:54"
          },
          {
            "ticket_id": 4410,
            "ticket_number": "354402",
            "title": "GBN-94773 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 12:07:33",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 12:07:33"
          },
          {
            "ticket_id": 4412,
            "ticket_number": "354404",
            "title": "Envio de Documentação Disney File 410790",
            "priority": "P2",
            "created_at": "15/12/2025 12:40:42",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:07:39"
          },
          {
            "ticket_id": 4413,
            "ticket_number": "354405",
            "title": "Envio de Documentação Disney File 410791",
            "priority": "P2",
            "created_at": "15/12/2025 12:40:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:06:46"
          },
          {
            "ticket_id": 4418,
            "ticket_number": "354410",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 12:59:46",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 145.48,
            "sla_met": false,
            "sla_breach_hours": 121.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 10:29:21"
          },
          {
            "ticket_id": 4419,
            "ticket_number": "354411",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 12:59:49",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 336.38,
            "sla_met": false,
            "sla_breach_hours": 312.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 13:23:34"
          },
          {
            "ticket_id": 4421,
            "ticket_number": "354413",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 13:00:02",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 336.38,
            "sla_met": false,
            "sla_breach_hours": 312.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 13:23:23"
          },
          {
            "ticket_id": 4422,
            "ticket_number": "354414",
            "title": "Fwd: easyJet número de referência da reserva: KBQ7",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 13:00:06",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 12:59:47"
          },
          {
            "ticket_id": 4424,
            "ticket_number": "354416",
            "title": "GBN-94763 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/12/2025 13:10:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:53:46"
          },
          {
            "ticket_id": 4434,
            "ticket_number": "354426",
            "title": "\"GBN-93257 - Your request has been received\"",
            "priority": "P2",
            "created_at": "15/12/2025 15:13:55",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 16:13:44"
          },
          {
            "ticket_id": 4443,
            "ticket_number": "354435",
            "title": "GBN-88144 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/12/2025 16:35:12",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 17:16:29"
          },
          {
            "ticket_id": 4445,
            "ticket_number": "354437",
            "title": "Envio de Fatura 436706/25",
            "priority": "P2",
            "created_at": "15/12/2025 17:18:59",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:10:06"
          },
          {
            "ticket_id": 4448,
            "ticket_number": "354440",
            "title": "GBN-94881 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/12/2025 18:09:48",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 18:09:48"
          },
          {
            "ticket_id": 4449,
            "ticket_number": "354441",
            "title": "Confirmação de Compra nº 26081974",
            "priority": "P3",
            "created_at": "15/12/2025 18:09:54",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 14:04:14"
          },
          {
            "ticket_id": 4451,
            "ticket_number": "354443",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:20:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:20:35"
          },
          {
            "ticket_id": 4452,
            "ticket_number": "354444",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:20:39",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:20:39"
          },
          {
            "ticket_id": 4453,
            "ticket_number": "354445",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:20:42",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:20:43"
          },
          {
            "ticket_id": 4454,
            "ticket_number": "354446",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:20:49",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:20:49"
          },
          {
            "ticket_id": 4455,
            "ticket_number": "354447",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:20:56",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:20:56"
          },
          {
            "ticket_id": 4456,
            "ticket_number": "354448",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/12/2025 18:25:52",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:25:52"
          },
          {
            "ticket_id": 4464,
            "ticket_number": "354456",
            "title": "Confirmação de reserva com localizador: 4005672",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/12/2025 20:33:08",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 21:43:19"
          },
          {
            "ticket_id": 4465,
            "ticket_number": "354457",
            "title": "Ajuda com verificação de documentos assinados",
            "priority": "P3",
            "created_at": "15/12/2025 21:01:34",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 21:01:35"
          },
          {
            "ticket_id": 4468,
            "ticket_number": "354460",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:18",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:48:00"
          },
          {
            "ticket_id": 4469,
            "ticket_number": "354461",
            "title": "Fwd: Viagify informa sobre a sua reserva 122775048",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:21",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:39:21"
          },
          {
            "ticket_id": 4470,
            "ticket_number": "354462",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:23",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:46:33"
          },
          {
            "ticket_id": 4471,
            "ticket_number": "354463",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:25",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:46:04"
          },
          {
            "ticket_id": 4472,
            "ticket_number": "354464",
            "title": "Fwd: Confirmacion de la reserva Transavia: MG4FTQ",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 22:39:28",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 22:39:29"
          },
          {
            "ticket_id": 4473,
            "ticket_number": "354465",
            "title": "Fwd: Viagify informa sobre a sua reserva 122774682",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 22:39:32",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/12/2025 22:39:33"
          },
          {
            "ticket_id": 4474,
            "ticket_number": "354466",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:44:05"
          },
          {
            "ticket_id": 4476,
            "ticket_number": "354468",
            "title": "GBN-94773 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "15/12/2025 23:54:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/12/2025 00:15:24"
          },
          {
            "ticket_id": 4477,
            "ticket_number": "354469",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "16/12/2025 10:13:04",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/12/2025 10:19:05"
          },
          {
            "ticket_id": 4480,
            "ticket_number": "354472",
            "title": "Fwd: Viagify informa sobre a sua reserva 122777021",
            "priority": "Reservas sem Formulário",
            "created_at": "16/12/2025 10:16:57",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/12/2025 10:16:58"
          },
          {
            "ticket_id": 4488,
            "ticket_number": "354480",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "16/12/2025 10:23:09",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 12:09:16"
          },
          {
            "ticket_id": 4491,
            "ticket_number": "354483",
            "title": "Re:[## 27346 ##] GBN-94773 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "16/12/2025 11:27:56",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 12:49:31"
          },
          {
            "ticket_id": 4493,
            "ticket_number": "354485",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "16/12/2025 11:33:20",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/12/2025 15:02:01"
          },
          {
            "ticket_id": 4496,
            "ticket_number": "354488",
            "title": "Fwd: Última Chamada | 17 DEZ | NIS2 Ready Domine a",
            "priority": "P2",
            "created_at": "16/12/2025 13:18:03",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 13:18:04"
          },
          {
            "ticket_id": 4499,
            "ticket_number": "354491",
            "title": "Apoio para obras em casa; o negócio é destruir a E",
            "priority": "P2",
            "created_at": "16/12/2025 15:10:06",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 15:10:34"
          },
          {
            "ticket_id": 4503,
            "ticket_number": "354495",
            "title": "Ajuda",
            "priority": "P2",
            "created_at": "16/12/2025 16:08:42",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 16:08:43"
          },
          {
            "ticket_id": 4507,
            "ticket_number": "354499",
            "title": "Alteração horários voos OPO-PXO HAT // 333752",
            "priority": "P2",
            "created_at": "16/12/2025 17:36:24",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 18:04:57"
          },
          {
            "ticket_id": 4508,
            "ticket_number": "354500",
            "title": "Confirmação reserva Bedsonline 131-2643653",
            "priority": "Reservas sem Formulário",
            "created_at": "16/12/2025 17:36:26",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 21.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 15:21:35"
          },
          {
            "ticket_id": 4510,
            "ticket_number": "354502",
            "title": "Pedido de alteração de hora de transfere regresso ",
            "priority": "P2",
            "created_at": "16/12/2025 17:44:26",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 17:44:26"
          },
          {
            "ticket_id": 4513,
            "ticket_number": "354505",
            "title": "Cotización DINIS - cntravel -Ref 17015571 -Uma Fam",
            "priority": "P3",
            "created_at": "16/12/2025 18:01:33",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 12:03:32"
          },
          {
            "ticket_id": 4514,
            "ticket_number": "354506",
            "title": "Fwd: Viagify informa sobre a sua reserva 122790444",
            "priority": "Reservas sem Formulário",
            "created_at": "16/12/2025 19:04:48",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/12/2025 19:04:48"
          },
          {
            "ticket_id": 4516,
            "ticket_number": "354508",
            "title": "Reserva GBN-94881",
            "priority": "P2",
            "created_at": "16/12/2025 21:12:10",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 21:12:10"
          },
          {
            "ticket_id": 4519,
            "ticket_number": "354511",
            "title": "Confirmação de Compra nº 26095531",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 00:10:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 18.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 18:17:48"
          },
          {
            "ticket_id": 4522,
            "ticket_number": "354514",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "17/12/2025 10:07:42",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 10:19:58"
          },
          {
            "ticket_id": 4526,
            "ticket_number": "354518",
            "title": "GBN-95130 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 10:07:50",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 10:07:50"
          },
          {
            "ticket_id": 4532,
            "ticket_number": "354524",
            "title": "GBN-95135 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 11:07:15",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 7.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 18:14:28"
          },
          {
            "ticket_id": 4533,
            "ticket_number": "354525",
            "title": "Re: Purchase partner hit contact",
            "priority": "P2",
            "created_at": "17/12/2025 11:53:26",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 11:56:51"
          },
          {
            "ticket_id": 4535,
            "ticket_number": "354527",
            "title": "Re: Purchase partner hit contact",
            "priority": "P2",
            "created_at": "17/12/2025 11:53:30",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 11:56:18"
          },
          {
            "ticket_id": 4551,
            "ticket_number": "354543",
            "title": "GBN-95196 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 15:26:10",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 15:26:10"
          },
          {
            "ticket_id": 4553,
            "ticket_number": "354545",
            "title": "Confirmação de reserva – Ref PP991832, Sr. Jose Af",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 15:44:01",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/12/2025 11:42:03"
          },
          {
            "ticket_id": 4554,
            "ticket_number": "354546",
            "title": "Envio de Cert. Seguro * File 412548",
            "priority": "P2",
            "created_at": "17/12/2025 16:08:18",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 16:10:26"
          },
          {
            "ticket_id": 4557,
            "ticket_number": "354549",
            "title": "GBN-73323 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/12/2025 16:57:12",
            "close_date": "2025-12-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 17:23:46"
          },
          {
            "ticket_id": 4559,
            "ticket_number": "354551",
            "title": "SOLFÉRIAS |  Campanha Exponoivos | 9 a 26 de janei",
            "priority": "P2",
            "created_at": "17/12/2025 18:27:01",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 18:35:17"
          },
          {
            "ticket_id": 4561,
            "ticket_number": "354553",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "17/12/2025 19:04:37",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 19:04:37"
          },
          {
            "ticket_id": 4563,
            "ticket_number": "354555",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "17/12/2025 19:06:53",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 19:21:42"
          },
          {
            "ticket_id": 4564,
            "ticket_number": "354556",
            "title": "Esclarecimento sobre transferências internacionais",
            "priority": "P2",
            "created_at": "17/12/2025 21:03:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 21:03:58"
          },
          {
            "ticket_id": 4566,
            "ticket_number": "354558",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-95",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/12/2025 22:48:36",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/12/2025 22:48:36"
          },
          {
            "ticket_id": 4568,
            "ticket_number": "354560",
            "title": "Confirmacao 335785",
            "priority": "Reservas sem Formulário",
            "created_at": "17/12/2025 23:48:48",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 15.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/12/2025 15:29:23"
          },
          {
            "ticket_id": 4570,
            "ticket_number": "354562",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "18/12/2025 10:06:04",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 10:20:20"
          },
          {
            "ticket_id": 4578,
            "ticket_number": "354570",
            "title": "Produto Próprio Panorama Viagens | Paris Essencial",
            "priority": "P2",
            "created_at": "18/12/2025 12:02:10",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 13:28:46"
          },
          {
            "ticket_id": 4579,
            "ticket_number": "354571",
            "title": "Envio de documentos de faturação",
            "priority": "P2",
            "created_at": "18/12/2025 12:02:13",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 13:35:35"
          },
          {
            "ticket_id": 4588,
            "ticket_number": "354580",
            "title": "Alteração reserva GBN-91093",
            "priority": "P2",
            "created_at": "18/12/2025 15:03:51",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 15:03:52"
          },
          {
            "ticket_id": 4589,
            "ticket_number": "354581",
            "title": "Fwd: Viagify informa sobre a sua reserva 122832694",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 15:39:34",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/12/2025 15:39:34"
          },
          {
            "ticket_id": 4600,
            "ticket_number": "354592",
            "title": "Confirmação de Reserva * File 421441",
            "priority": "P2",
            "created_at": "18/12/2025 19:07:37",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 19:27:54"
          },
          {
            "ticket_id": 4602,
            "ticket_number": "354594",
            "title": "GBN-95439 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 21:14:35",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/12/2025 21:14:35"
          },
          {
            "ticket_id": 4606,
            "ticket_number": "354598",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604513230",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 23:41:39",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 192.18,
            "sla_met": false,
            "sla_breach_hours": 168.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 23:52:48"
          },
          {
            "ticket_id": 4607,
            "ticket_number": "354599",
            "title": "GBN-95451 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 23:46:30",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/12/2025 23:46:30"
          },
          {
            "ticket_id": 4609,
            "ticket_number": "354601",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604513232",
            "priority": "Reservas sem Formulário",
            "created_at": "19/12/2025 00:09:32",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 191.7,
            "sla_met": false,
            "sla_breach_hours": 167.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 23:52:18"
          },
          {
            "ticket_id": 4611,
            "ticket_number": "354603",
            "title": "Adicione novas experiências para sua viagem GBN-65",
            "priority": "P2",
            "created_at": "19/12/2025 10:11:39",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 10:29:43"
          },
          {
            "ticket_id": 4612,
            "ticket_number": "354604",
            "title": "Confirmação de Compra nº 26118049",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/12/2025 10:11:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1489.55,
            "sla_met": false,
            "sla_breach_hours": 1465.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:10"
          },
          {
            "ticket_id": 4618,
            "ticket_number": "354610",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "19/12/2025 11:09:24",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:49:49"
          },
          {
            "ticket_id": 4619,
            "ticket_number": "354611",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "19/12/2025 11:09:25",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:51:08"
          },
          {
            "ticket_id": 4620,
            "ticket_number": "354612",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "19/12/2025 11:09:27",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:54:23"
          },
          {
            "ticket_id": 4621,
            "ticket_number": "354613",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "19/12/2025 11:09:28",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:55:14"
          },
          {
            "ticket_id": 4632,
            "ticket_number": "354624",
            "title": "Fwd: Informações da reserva TTN-1226039914#8868320",
            "priority": "P3",
            "created_at": "19/12/2025 16:09:26",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 16:09:27"
          },
          {
            "ticket_id": 4633,
            "ticket_number": "354625",
            "title": "Pedido cotação grupo",
            "priority": "P2",
            "created_at": "19/12/2025 16:09:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 16:09:29"
          },
          {
            "ticket_id": 4634,
            "ticket_number": "354626",
            "title": "GBN-95521 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "19/12/2025 16:09:31",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 16:10:00"
          },
          {
            "ticket_id": 4635,
            "ticket_number": "354627",
            "title": "GBN-95529 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/12/2025 16:09:34",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 506.8,
            "sla_met": false,
            "sla_breach_hours": 482.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 18:57:43"
          },
          {
            "ticket_id": 4636,
            "ticket_number": "354628",
            "title": "GBN-95135 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "19/12/2025 16:09:37",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:42:43"
          },
          {
            "ticket_id": 4642,
            "ticket_number": "354634",
            "title": "Petición CnTravel 36010966",
            "priority": "P2",
            "created_at": "19/12/2025 16:10:04",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 17:07:41"
          },
          {
            "ticket_id": 4645,
            "ticket_number": "354637",
            "title": "Fwd: Viagify informa sobre a sua reserva 122856069",
            "priority": "P2",
            "created_at": "19/12/2025 16:14:26",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 16:14:26"
          },
          {
            "ticket_id": 4653,
            "ticket_number": "354645",
            "title": "GBN-95589 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/12/2025 19:45:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 236.07,
            "sla_met": false,
            "sla_breach_hours": 212.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 15:49:48"
          },
          {
            "ticket_id": 4654,
            "ticket_number": "354646",
            "title": "GBN-95601 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/12/2025 21:43:08",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 161.93,
            "sla_met": false,
            "sla_breach_hours": 137.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:39:36"
          },
          {
            "ticket_id": 4657,
            "ticket_number": "354649",
            "title": "Fwd: Viagify informa sobre a sua reserva 122864896",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 11:58:37",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/12/2025 11:58:38"
          },
          {
            "ticket_id": 4659,
            "ticket_number": "354651",
            "title": "Solole. Booking HNDB5JNJ is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 14:14:27",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 50.35,
            "sla_met": false,
            "sla_breach_hours": 26.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:35:48"
          },
          {
            "ticket_id": 4660,
            "ticket_number": "354652",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 14:14:29",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 50.47,
            "sla_met": false,
            "sla_breach_hours": 26.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:43:28"
          },
          {
            "ticket_id": 4661,
            "ticket_number": "354653",
            "title": "Solole. Booking OJEV6T13 is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 14:14:32",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 50.35,
            "sla_met": false,
            "sla_breach_hours": 26.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:36:27"
          },
          {
            "ticket_id": 4662,
            "ticket_number": "354654",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 14:14:35",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 50.48,
            "sla_met": false,
            "sla_breach_hours": 26.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:43:57"
          },
          {
            "ticket_id": 4666,
            "ticket_number": "354658",
            "title": "Número de informação da reserva: 6125263",
            "priority": "Reservas sem Formulário",
            "created_at": "20/12/2025 17:14:15",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 47.37,
            "sla_met": false,
            "sla_breach_hours": 23.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:36:59"
          },
          {
            "ticket_id": 4675,
            "ticket_number": "354667",
            "title": "GBN-95664 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/12/2025 10:40:45",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/12/2025 10:40:45"
          },
          {
            "ticket_id": 4685,
            "ticket_number": "354677",
            "title": "GBN-95679 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/12/2025 16:35:56",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 119.0,
            "sla_met": false,
            "sla_breach_hours": 95.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:36:10"
          },
          {
            "ticket_id": 4686,
            "ticket_number": "354678",
            "title": "GBN-91790 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "21/12/2025 16:38:07",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/12/2025 16:45:52"
          },
          {
            "ticket_id": 4692,
            "ticket_number": "354684",
            "title": "Alteração nome de rservas",
            "priority": "P2",
            "created_at": "22/12/2025 10:10:19",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 10:10:19"
          },
          {
            "ticket_id": 4693,
            "ticket_number": "354685",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:10:22",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:10:22"
          },
          {
            "ticket_id": 4694,
            "ticket_number": "354686",
            "title": "GBN-95690 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:10:24",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:10:33"
          },
          {
            "ticket_id": 4695,
            "ticket_number": "354687",
            "title": "GBN-95693 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:10:26",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:10:26"
          },
          {
            "ticket_id": 4696,
            "ticket_number": "354688",
            "title": "GBN-95689 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:10:30",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:10:30"
          },
          {
            "ticket_id": 4697,
            "ticket_number": "354689",
            "title": "GBN-95690 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:10:33",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:10:33"
          },
          {
            "ticket_id": 4698,
            "ticket_number": "354690",
            "title": "GBN-95694 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 10:10:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 101.38,
            "sla_met": false,
            "sla_breach_hours": 77.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:33:49"
          },
          {
            "ticket_id": 4702,
            "ticket_number": "354694",
            "title": "Información de reserva número: 6125237",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 10:34:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1417.17,
            "sla_met": false,
            "sla_breach_hours": 1393.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:10"
          },
          {
            "ticket_id": 4704,
            "ticket_number": "354696",
            "title": "Fwd: Viagify informa sobre a sua reserva 122888362",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 10:35:29",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:35:29"
          },
          {
            "ticket_id": 4705,
            "ticket_number": "354697",
            "title": "Fwd: Viagify informa sobre a sua reserva 122888362",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 10:35:32",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:35:33"
          },
          {
            "ticket_id": 4706,
            "ticket_number": "354698",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 10:35:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:35:37"
          },
          {
            "ticket_id": 4707,
            "ticket_number": "354699",
            "title": "Fwd: Viagify informa sobre a sua reserva 122890258",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 10:35:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 10:35:40"
          },
          {
            "ticket_id": 4708,
            "ticket_number": "354700",
            "title": "Confirmação de reserva 335849",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 11:41:21",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 4.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:09:22"
          },
          {
            "ticket_id": 4709,
            "ticket_number": "354701",
            "title": "Re:[## 27740 ##] GBN-95690 - Seu pedido foi recebi",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 11:58:19",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 4.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 16:41:55"
          },
          {
            "ticket_id": 4715,
            "ticket_number": "354707",
            "title": "VOUCHER DA RESERVA 604477832",
            "priority": "P2",
            "created_at": "22/12/2025 12:43:09",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 12:58:44"
          },
          {
            "ticket_id": 4716,
            "ticket_number": "354708",
            "title": "Re:[## 27733 ##] GBN-95130 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "22/12/2025 12:49:44",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 16:25:56"
          },
          {
            "ticket_id": 4717,
            "ticket_number": "354709",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "22/12/2025 12:50:22",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 13:53:37"
          },
          {
            "ticket_id": 4718,
            "ticket_number": "354710",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "22/12/2025 12:50:25",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 13:53:54"
          },
          {
            "ticket_id": 4733,
            "ticket_number": "354725",
            "title": "Option confirmation letter for Group C/O UmaFAEMVi",
            "priority": "P3",
            "created_at": "22/12/2025 17:48:57",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 18:39:39"
          },
          {
            "ticket_id": 4737,
            "ticket_number": "354729",
            "title": "Fwd: Confirmação da sua reserva HLWQ6A - LIS-ORY 2",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 18:34:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 18:34:54"
          },
          {
            "ticket_id": 4738,
            "ticket_number": "354730",
            "title": "Reserva alterada: Free tour por Marrakech",
            "priority": "P2",
            "created_at": "22/12/2025 18:43:49",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 20:27:07"
          },
          {
            "ticket_id": 4739,
            "ticket_number": "354731",
            "title": "GBN-95844 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 18:43:56",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 92.5,
            "sla_met": false,
            "sla_breach_hours": 68.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:13:58"
          },
          {
            "ticket_id": 4744,
            "ticket_number": "354736",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 19:40:46",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 19:40:46"
          },
          {
            "ticket_id": 4745,
            "ticket_number": "354737",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 19:40:55",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 19:40:55"
          },
          {
            "ticket_id": 4746,
            "ticket_number": "354738",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 19:41:07",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 19:41:07"
          },
          {
            "ticket_id": 4747,
            "ticket_number": "354739",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 19:46:32",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 19:46:32"
          },
          {
            "ticket_id": 4748,
            "ticket_number": "354740",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 19:46:35",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 19:46:35"
          },
          {
            "ticket_id": 4749,
            "ticket_number": "354741",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 20:22:18",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 20:22:18"
          },
          {
            "ticket_id": 4750,
            "ticket_number": "354742",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 20:22:26",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 20:22:27"
          },
          {
            "ticket_id": 4751,
            "ticket_number": "354743",
            "title": "Fwd: Viagify informa sobre a sua reserva 122909704",
            "priority": "Reservas sem Formulário",
            "created_at": "22/12/2025 20:27:44",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/12/2025 20:27:45"
          },
          {
            "ticket_id": 4757,
            "ticket_number": "354749",
            "title": "Número de informação da reserva: 6125288",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/12/2025 21:10:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 162.6,
            "sla_met": false,
            "sla_breach_hours": 138.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 15:47:25"
          },
          {
            "ticket_id": 4761,
            "ticket_number": "354753",
            "title": "Fwd: Localizador 1229097044 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "22/12/2025 23:40:51",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 23:40:51"
          },
          {
            "ticket_id": 4767,
            "ticket_number": "354759",
            "title": "Envio (Recibo-2147824521)",
            "priority": "P2",
            "created_at": "23/12/2025 10:25:49",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 10:43:48"
          },
          {
            "ticket_id": 4777,
            "ticket_number": "354769",
            "title": "GBN-95880 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "23/12/2025 13:18:55",
            "close_date": "2025-12-25",
            "sla_target_hours": 24,
            "actual_time_hours": 4.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 17:54:29"
          },
          {
            "ticket_id": 4778,
            "ticket_number": "354770",
            "title": "GBN-95880 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/12/2025 13:18:57",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 76.12,
            "sla_met": false,
            "sla_breach_hours": 72.12,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:26:33"
          },
          {
            "ticket_id": 4785,
            "ticket_number": "354777",
            "title": "Fwd: Informações da reserva TTN-1165822742#8888829",
            "priority": "P2",
            "created_at": "23/12/2025 16:49:33",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 16:49:34"
          },
          {
            "ticket_id": 4791,
            "ticket_number": "354783",
            "title": "Re:[## 27736 ##] GBN-90206 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "23/12/2025 17:23:26",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 21:22:20"
          },
          {
            "ticket_id": 4793,
            "ticket_number": "354785",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "23/12/2025 17:57:48",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 17:57:50"
          },
          {
            "ticket_id": 4797,
            "ticket_number": "354789",
            "title": "Fwd: UFEV TTN-1165822742#88897521#T16475272¬985134",
            "priority": "P2",
            "created_at": "23/12/2025 18:18:46",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 18:18:46"
          },
          {
            "ticket_id": 4798,
            "ticket_number": "354790",
            "title": "Número de informação da reserva: 6125315",
            "priority": "P3",
            "created_at": "23/12/2025 21:06:00",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 21:06:02"
          },
          {
            "ticket_id": 4800,
            "ticket_number": "354792",
            "title": "Dados Passaporte - GBN 88827 - saída a 26/12",
            "priority": "P2",
            "created_at": "23/12/2025 21:06:04",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 21:06:04"
          },
          {
            "ticket_id": 4802,
            "ticket_number": "354794",
            "title": "Reserva confirmada: Free tour por Roma - Civitatis",
            "priority": "P3",
            "created_at": "24/12/2025 10:23:08",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/12/2025 10:23:25"
          },
          {
            "ticket_id": 4804,
            "ticket_number": "354796",
            "title": "GBN-96083 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/12/2025 10:23:13",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 53.12,
            "sla_met": false,
            "sla_breach_hours": 29.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:30:59"
          },
          {
            "ticket_id": 4805,
            "ticket_number": "354797",
            "title": "Confirmação de reserva com localizador: 4012375",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/12/2025 10:23:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 125.38,
            "sla_met": false,
            "sla_breach_hours": 101.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 15:46:33"
          },
          {
            "ticket_id": 4807,
            "ticket_number": "354799",
            "title": "GBN-96081 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/12/2025 10:23:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 125.37,
            "sla_met": false,
            "sla_breach_hours": 101.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 15:45:25"
          },
          {
            "ticket_id": 4809,
            "ticket_number": "354801",
            "title": "Reserva confirmada: Free tour por Roma - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "24/12/2025 10:23:25",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 61.55,
            "sla_met": false,
            "sla_breach_hours": 37.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 23:56:42"
          },
          {
            "ticket_id": 4812,
            "ticket_number": "354804",
            "title": "Reserva confirmada: Tour privado de tuk tuk por Ma",
            "priority": "Reservas sem Formulário",
            "created_at": "24/12/2025 11:10:41",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 51.98,
            "sla_met": false,
            "sla_breach_hours": 27.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 15:10:36"
          },
          {
            "ticket_id": 4814,
            "ticket_number": "354806",
            "title": "Reserva confirmada: Tour privado de tuk tuk por Ma",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/12/2025 11:10:45",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 124.55,
            "sla_met": false,
            "sla_breach_hours": 100.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 15:44:04"
          },
          {
            "ticket_id": 4817,
            "ticket_number": "354809",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604514888",
            "priority": "Reservas sem Formulário",
            "created_at": "24/12/2025 13:21:27",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 58.57,
            "sla_met": false,
            "sla_breach_hours": 34.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 23:55:43"
          },
          {
            "ticket_id": 4818,
            "ticket_number": "354810",
            "title": "GBN-96100 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/12/2025 13:21:31",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 50.73,
            "sla_met": false,
            "sla_breach_hours": 26.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 16:05:33"
          },
          {
            "ticket_id": 4820,
            "ticket_number": "354812",
            "title": "GBN-96105 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/12/2025 10:15:27",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 10:15:27"
          },
          {
            "ticket_id": 4821,
            "ticket_number": "354813",
            "title": "GBN-96107 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/12/2025 10:15:30",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 5.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 16:03:58"
          },
          {
            "ticket_id": 4834,
            "ticket_number": "354826",
            "title": "Confirmação de Compra nº 26211843",
            "priority": "P2",
            "created_at": "26/12/2025 11:11:27",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:32:37"
          },
          {
            "ticket_id": 4841,
            "ticket_number": "354833",
            "title": "Fwd: easyJet número de referência da reserva: KBRH",
            "priority": "Reservas sem Formulário",
            "created_at": "26/12/2025 13:28:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 13:28:50"
          },
          {
            "ticket_id": 4842,
            "ticket_number": "354834",
            "title": "Fwd: easyJet número de referência da reserva: KBRH",
            "priority": "Reservas sem Formulário",
            "created_at": "26/12/2025 13:28:52",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 13:28:53"
          },
          {
            "ticket_id": 4844,
            "ticket_number": "354836",
            "title": "RE: Opti 249100039_Andreia Monteiro",
            "priority": "P2",
            "created_at": "26/12/2025 13:29:25",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 13:29:26"
          },
          {
            "ticket_id": 4854,
            "ticket_number": "354846",
            "title": "Envio de Documentação * File 415145",
            "priority": "P2",
            "created_at": "26/12/2025 15:59:03",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 16:12:19"
          },
          {
            "ticket_id": 4855,
            "ticket_number": "354847",
            "title": "Envio de Documentação * File 415117",
            "priority": "P2",
            "created_at": "26/12/2025 15:59:07",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 16:11:02"
          },
          {
            "ticket_id": 4858,
            "ticket_number": "354850",
            "title": "GBN-96160 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/12/2025 16:24:02",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 17:57:45"
          },
          {
            "ticket_id": 4861,
            "ticket_number": "354853",
            "title": "Documentação Disponível - Reserva 335785",
            "priority": "P2",
            "created_at": "26/12/2025 17:21:16",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:23:48"
          },
          {
            "ticket_id": 4862,
            "ticket_number": "354854",
            "title": "Soltropico 332519",
            "priority": "P2",
            "created_at": "26/12/2025 17:27:04",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:27:04"
          },
          {
            "ticket_id": 4864,
            "ticket_number": "354856",
            "title": "Informação Importante Occidental Boa Vista Beach -",
            "priority": "P2",
            "created_at": "26/12/2025 17:46:38",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:48:31"
          },
          {
            "ticket_id": 4867,
            "ticket_number": "354859",
            "title": "civitatis  A31507504",
            "priority": "P2",
            "created_at": "26/12/2025 18:15:15",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 18:15:15"
          },
          {
            "ticket_id": 4869,
            "ticket_number": "354861",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/12/2025 19:49:16",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 19:49:16"
          },
          {
            "ticket_id": 4870,
            "ticket_number": "354862",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/12/2025 19:55:36",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 19:55:36"
          },
          {
            "ticket_id": 4873,
            "ticket_number": "354865",
            "title": "Reserva Reveillon 31245 e 31246",
            "priority": "P3",
            "created_at": "26/12/2025 22:43:43",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 22:51:53"
          },
          {
            "ticket_id": 4876,
            "ticket_number": "354868",
            "title": "GBN-96196 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/12/2025 09:54:07",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/12/2025 09:54:07"
          },
          {
            "ticket_id": 4885,
            "ticket_number": "354877",
            "title": "GBN-96231 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/12/2025 12:06:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/12/2025 12:06:55"
          },
          {
            "ticket_id": 4886,
            "ticket_number": "354878",
            "title": "GBN-96233 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/12/2025 12:06:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 802.03,
            "sla_met": false,
            "sla_breach_hours": 778.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 22:09:20"
          },
          {
            "ticket_id": 4887,
            "ticket_number": "354879",
            "title": "GBN-96232 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/12/2025 12:07:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/12/2025 12:07:01"
          },
          {
            "ticket_id": 4892,
            "ticket_number": "354884",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem Formulário",
            "created_at": "28/12/2025 12:07:47",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/12/2025 12:20:33"
          },
          {
            "ticket_id": 4895,
            "ticket_number": "354887",
            "title": "GBN-96239 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "28/12/2025 12:20:33",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 34.4,
            "sla_met": false,
            "sla_breach_hours": 10.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 22:45:05"
          },
          {
            "ticket_id": 4898,
            "ticket_number": "354890",
            "title": "GBN-96248 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/12/2025 15:50:29",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 266.6,
            "sla_met": false,
            "sla_breach_hours": 242.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 18:26:46"
          },
          {
            "ticket_id": 4900,
            "ticket_number": "354892",
            "title": "GBN-96249 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/12/2025 15:55:19",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/12/2025 15:55:19"
          },
          {
            "ticket_id": 4905,
            "ticket_number": "354897",
            "title": "Fwd: ***INFORMAÇÕES IMPORTANTES SOBRE SEU VOO A3JC",
            "priority": "P2",
            "created_at": "29/12/2025 10:11:49",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:11:50"
          },
          {
            "ticket_id": 4910,
            "ticket_number": "354902",
            "title": "Fwd: A3JCKH | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "29/12/2025 10:12:06",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:12:07"
          },
          {
            "ticket_id": 4911,
            "ticket_number": "354903",
            "title": "Fwd: Viagify informa sobre a sua reserva 122998467",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 10:12:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 10:12:10"
          },
          {
            "ticket_id": 4912,
            "ticket_number": "354904",
            "title": "Fwd: A3JCKH | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "29/12/2025 10:12:12",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:12:13"
          },
          {
            "ticket_id": 4925,
            "ticket_number": "354917",
            "title": "Mensagem sobre a reserva 35222961 - Civitatis",
            "priority": "P2",
            "created_at": "29/12/2025 12:04:06",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 12:15:30"
          },
          {
            "ticket_id": 4929,
            "ticket_number": "354921",
            "title": "Pedido de informações - New blue 6124315",
            "priority": "P2",
            "created_at": "29/12/2025 13:16:18",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 16:49:54"
          },
          {
            "ticket_id": 4931,
            "ticket_number": "354923",
            "title": "Re:[## 28047 ##] GBN-96248 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "29/12/2025 13:19:02",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:12:21"
          },
          {
            "ticket_id": 4933,
            "ticket_number": "354925",
            "title": "OPTI - 243300059 - LOC SMY - 1223362854",
            "priority": "P2",
            "created_at": "29/12/2025 13:39:16",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 13:39:16"
          },
          {
            "ticket_id": 4935,
            "ticket_number": "354927",
            "title": "Importante - Checkin Online Voos TAP - FILE 335371",
            "priority": "P2",
            "created_at": "29/12/2025 13:41:58",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 13:49:49"
          },
          {
            "ticket_id": 4936,
            "ticket_number": "354928",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "29/12/2025 14:21:25",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 16:03:12"
          },
          {
            "ticket_id": 4937,
            "ticket_number": "354929",
            "title": "Travelplan - Preços especiais NET para Grupos VOO ",
            "priority": "P2",
            "created_at": "29/12/2025 14:21:34",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 17:11:00"
          },
          {
            "ticket_id": 4943,
            "ticket_number": "354935",
            "title": "PEDIDO COTAÇÃO GRUPO",
            "priority": "P2",
            "created_at": "29/12/2025 17:30:08",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 17:30:08"
          },
          {
            "ticket_id": 4949,
            "ticket_number": "354941",
            "title": "Confirmação de reserva – Ref PP956063, Sr. LUCIANO",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 18:42:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 91.98,
            "sla_met": false,
            "sla_breach_hours": 67.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 14:42:33"
          },
          {
            "ticket_id": 4954,
            "ticket_number": "354946",
            "title": "Nova Viagem #251100370 - Catarina Faco",
            "priority": "P2",
            "created_at": "29/12/2025 20:29:58",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 20:29:58"
          },
          {
            "ticket_id": 4955,
            "ticket_number": "354947",
            "title": "Fwd: Viagify informa sobre a sua reserva 123027338",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 20:35:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 20:35:17"
          },
          {
            "ticket_id": 4957,
            "ticket_number": "354949",
            "title": "GBN-96400 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 22:00:32",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 22:00:32"
          },
          {
            "ticket_id": 4958,
            "ticket_number": "354950",
            "title": "GBN-96401 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 22:19:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 22:19:59"
          },
          {
            "ticket_id": 4959,
            "ticket_number": "354951",
            "title": "Fwd: Informações da reserva TTN-1230273387#8913128",
            "priority": "P2",
            "created_at": "29/12/2025 22:27:24",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 22:27:25"
          },
          {
            "ticket_id": 4961,
            "ticket_number": "354953",
            "title": "Orçamento Grupo",
            "priority": "P2",
            "created_at": "29/12/2025 22:45:46",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 22:45:47"
          },
          {
            "ticket_id": 4962,
            "ticket_number": "354954",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 22:45:49",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 22:45:49"
          },
          {
            "ticket_id": 4963,
            "ticket_number": "354955",
            "title": "Reserva Aérea XJCUZD",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/12/2025 23:39:14",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 23:49:11"
          },
          {
            "ticket_id": 4968,
            "ticket_number": "354960",
            "title": "Fw: SignRequest email bounced: rgpd 200719.docx",
            "priority": "P2",
            "created_at": "30/12/2025 10:10:42",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 10:10:42"
          },
          {
            "ticket_id": 4971,
            "ticket_number": "354963",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "30/12/2025 12:19:11",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/12/2025 12:19:12"
          },
          {
            "ticket_id": 4977,
            "ticket_number": "354969",
            "title": "Localizador  335371 da Soltrópico",
            "priority": "P2",
            "created_at": "30/12/2025 15:01:34",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 15:01:35"
          },
          {
            "ticket_id": 4981,
            "ticket_number": "354973",
            "title": "Aéreo - Confirmação de Emissão (ABRANCHES BELO\\CAT",
            "priority": "P2",
            "created_at": "30/12/2025 15:42:05",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 15:42:06"
          },
          {
            "ticket_id": 4983,
            "ticket_number": "354975",
            "title": "Petición CnTravel 66008418",
            "priority": "P2",
            "created_at": "30/12/2025 15:59:44",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 16:14:19"
          },
          {
            "ticket_id": 4993,
            "ticket_number": "354985",
            "title": "Criação de processo File 422534/25",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/12/2025 19:39:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/12/2025 21:07:09"
          },
          {
            "ticket_id": 4994,
            "ticket_number": "354986",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "30/12/2025 21:06:00",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/12/2025 21:06:11"
          },
          {
            "ticket_id": 4995,
            "ticket_number": "354987",
            "title": "Reserva GBN-96408 - Ajuste transfer e contactar Ho",
            "priority": "P2",
            "created_at": "30/12/2025 21:06:01",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 21:06:02"
          },
          {
            "ticket_id": 4996,
            "ticket_number": "354988",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/12/2025 21:06:05",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 21:06:05"
          },
          {
            "ticket_id": 4997,
            "ticket_number": "354989",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/12/2025 21:06:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/12/2025 21:06:08"
          },
          {
            "ticket_id": 4998,
            "ticket_number": "354990",
            "title": "w2m.travel: Confirmation of Payment received for t",
            "priority": "Reservas sem Formulário",
            "created_at": "30/12/2025 21:06:11",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/12/2025 22:00:39"
          },
          {
            "ticket_id": 5004,
            "ticket_number": "354996",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "P2",
            "created_at": "30/12/2025 23:04:09",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 23:04:09"
          },
          {
            "ticket_id": 5007,
            "ticket_number": "354999",
            "title": "pedir lugar especifico",
            "priority": "P2",
            "created_at": "30/12/2025 23:52:12",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 23:52:13"
          },
          {
            "ticket_id": 5012,
            "ticket_number": "355004",
            "title": "GBN-96569 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "31/12/2025 10:01:58",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/12/2025 10:01:58"
          },
          {
            "ticket_id": 5013,
            "ticket_number": "355005",
            "title": "Informação importante sobre a tua reserva 1761445",
            "priority": "P2",
            "created_at": "31/12/2025 10:02:01",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 10:25:11"
          },
          {
            "ticket_id": 5015,
            "ticket_number": "355007",
            "title": "Pedido cancelamento",
            "priority": "P2",
            "created_at": "31/12/2025 10:02:06",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 10:02:07"
          },
          {
            "ticket_id": 5016,
            "ticket_number": "355008",
            "title": "Loc 13DSJ9 (W2M) + Opti 2413000001",
            "priority": "P2",
            "created_at": "31/12/2025 10:02:08",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 10:02:08"
          },
          {
            "ticket_id": 5019,
            "ticket_number": "355011",
            "title": "GBN-96558 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/12/2025 11:01:27",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 11:02:19"
          },
          {
            "ticket_id": 5023,
            "ticket_number": "355015",
            "title": "GBN-96581 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "31/12/2025 13:16:04",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/12/2025 13:16:04"
          },
          {
            "ticket_id": 5024,
            "ticket_number": "355016",
            "title": "GBN-96582 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "31/12/2025 13:16:07",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/12/2025 13:16:07"
          },
          {
            "ticket_id": 5025,
            "ticket_number": "355017",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604516386",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "31/12/2025 13:16:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 47.4,
            "sla_met": false,
            "sla_breach_hours": 23.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 12:40:31"
          },
          {
            "ticket_id": 5032,
            "ticket_number": "355024",
            "title": "Criação de processo File 422592/26",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 10:38:28",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 11.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 21:38:41"
          },
          {
            "ticket_id": 5035,
            "ticket_number": "355027",
            "title": "GBN-96618 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 10:38:41",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 10:38:41"
          },
          {
            "ticket_id": 5037,
            "ticket_number": "355029",
            "title": "Pedido cotação | Apartamento Cadiz 12 pessoas",
            "priority": "P2",
            "created_at": "02/01/2026 10:38:52",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 10:38:52"
          },
          {
            "ticket_id": 5040,
            "ticket_number": "355032",
            "title": "Respuesta automática: Pagamento 604491711",
            "priority": "P2",
            "created_at": "02/01/2026 10:39:36",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 8.95,
            "sla_met": false,
            "sla_breach_hours": 4.95,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 19:36:45"
          },
          {
            "ticket_id": 5043,
            "ticket_number": "355035",
            "title": "Fwd: A3JCKH | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "02/01/2026 12:37:40",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:37:41"
          },
          {
            "ticket_id": 5044,
            "ticket_number": "355036",
            "title": "Entradas Disney Leplan",
            "priority": "P2",
            "created_at": "02/01/2026 12:37:42",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:37:43"
          },
          {
            "ticket_id": 5045,
            "ticket_number": "355037",
            "title": "Fwd: Your request DCPTFTSD01 has been changed",
            "priority": "P2",
            "created_at": "02/01/2026 12:37:44",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:37:45"
          },
          {
            "ticket_id": 5047,
            "ticket_number": "355039",
            "title": "Fwd: JV4K5Q | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "02/01/2026 12:37:50",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 12:37:50"
          },
          {
            "ticket_id": 5050,
            "ticket_number": "355042",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/01/2026 13:36:27",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 14:14:32"
          },
          {
            "ticket_id": 5051,
            "ticket_number": "355043",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/01/2026 13:36:28",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 14:15:34"
          },
          {
            "ticket_id": 5052,
            "ticket_number": "355044",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/01/2026 13:36:30",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 14:13:41"
          },
          {
            "ticket_id": 5053,
            "ticket_number": "355045",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/01/2026 13:36:31",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 14:12:44"
          },
          {
            "ticket_id": 5055,
            "ticket_number": "355047",
            "title": "Cancelamento de reserva * File 419626",
            "priority": "P2",
            "created_at": "02/01/2026 14:32:25",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 18:22:43"
          },
          {
            "ticket_id": 5056,
            "ticket_number": "355048",
            "title": "Cancelamento de viagem",
            "priority": "P2",
            "created_at": "02/01/2026 16:44:21",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 16:44:21"
          },
          {
            "ticket_id": 5067,
            "ticket_number": "355059",
            "title": "Fwd: Important information: Pedro Cabral, your TAP",
            "priority": "P2",
            "created_at": "02/01/2026 19:29:56",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 19:29:56"
          },
          {
            "ticket_id": 5068,
            "ticket_number": "355060",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/01/2026 19:29:59",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 19:29:59"
          },
          {
            "ticket_id": 5070,
            "ticket_number": "355062",
            "title": "[REL] Reserva W2M nº 13DSJ9 // OPERA SUITES (06/02",
            "priority": "P2",
            "created_at": "02/01/2026 19:30:05",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 20:18:44"
          },
          {
            "ticket_id": 5071,
            "ticket_number": "355063",
            "title": "GBN-92201 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/01/2026 19:30:38",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 19:35:28"
          },
          {
            "ticket_id": 5072,
            "ticket_number": "355064",
            "title": "Confirmación de la reserva con localizador: 401769",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 19:31:42",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 11:24:56"
          },
          {
            "ticket_id": 5073,
            "ticket_number": "355065",
            "title": "GBN-96691 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 19:41:39",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 19:41:39"
          },
          {
            "ticket_id": 5075,
            "ticket_number": "355067",
            "title": "GBN-96693 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/01/2026 19:51:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 19:51:41"
          },
          {
            "ticket_id": 5080,
            "ticket_number": "355072",
            "title": "Confirmação de reserva com localizador: 4017881",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/01/2026 22:29:02",
            "close_date": "2026-01-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 23:18:20"
          },
          {
            "ticket_id": 5081,
            "ticket_number": "355073",
            "title": "GBN-96701 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/01/2026 23:10:18",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 23:10:18"
          },
          {
            "ticket_id": 5083,
            "ticket_number": "355075",
            "title": "Reserva pagada",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 23:58:24",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 00:16:59"
          },
          {
            "ticket_id": 5084,
            "ticket_number": "355076",
            "title": "GBN-96705 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/01/2026 23:58:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 23:58:29"
          },
          {
            "ticket_id": 5086,
            "ticket_number": "355078",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/01/2026 23:58:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 23:58:34"
          },
          {
            "ticket_id": 5089,
            "ticket_number": "355081",
            "title": "Fwd: Viagify informa sobre a sua reserva 123111113",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 13:42:07",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 13:42:08"
          },
          {
            "ticket_id": 5092,
            "ticket_number": "355084",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 13:44:24",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 127.63,
            "sla_met": false,
            "sla_breach_hours": 103.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:23:16"
          },
          {
            "ticket_id": 5093,
            "ticket_number": "355085",
            "title": "Mensagem sobre a reserva 35568688 - Civitatis",
            "priority": "P2",
            "created_at": "03/01/2026 13:44:57",
            "close_date": "2026-01-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/01/2026 14:09:00"
          },
          {
            "ticket_id": 5094,
            "ticket_number": "355086",
            "title": "Confirmação de reserva com localizador: 4018156",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:02:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1125.7,
            "sla_met": false,
            "sla_breach_hours": 1101.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:09"
          },
          {
            "ticket_id": 5096,
            "ticket_number": "355088",
            "title": "GBN-96727 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:08:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 14:08:43"
          },
          {
            "ticket_id": 5097,
            "ticket_number": "355089",
            "title": "Fwd: Confirmacion de la reserva Transavia: RDWEFJ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:23:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 14:23:27"
          },
          {
            "ticket_id": 5098,
            "ticket_number": "355090",
            "title": "Fwd: JV4K5Q | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "03/01/2026 14:23:29",
            "close_date": "2026-01-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/01/2026 14:23:29"
          },
          {
            "ticket_id": 5099,
            "ticket_number": "355091",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:23:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 20:20:53"
          },
          {
            "ticket_id": 5100,
            "ticket_number": "355092",
            "title": "Fwd: Viagify informa sobre a sua reserva 123119408",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:23:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 14:23:35"
          },
          {
            "ticket_id": 5101,
            "ticket_number": "355093",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:23:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 20:20:53"
          },
          {
            "ticket_id": 5102,
            "ticket_number": "355094",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 14:23:39",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 20:20:53"
          },
          {
            "ticket_id": 5103,
            "ticket_number": "355095",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:23:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 20:20:53"
          },
          {
            "ticket_id": 5104,
            "ticket_number": "355096",
            "title": "GBN-96728 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/01/2026 14:24:17",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 14:24:17"
          },
          {
            "ticket_id": 5105,
            "ticket_number": "355097",
            "title": "Quotes",
            "priority": "P3",
            "created_at": "03/01/2026 16:19:53",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/01/2026 13:42:05"
          },
          {
            "ticket_id": 5107,
            "ticket_number": "355099",
            "title": "GBN-96741 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 17:25:01",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 17:25:01"
          },
          {
            "ticket_id": 5109,
            "ticket_number": "355101",
            "title": "Grupo para Andorra",
            "priority": "P3",
            "created_at": "03/01/2026 17:49:06",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/01/2026 17:49:06"
          },
          {
            "ticket_id": 5110,
            "ticket_number": "355102",
            "title": "GBN Travel: Informações sobre sua reserva - c",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 18:28:40",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 18:28:40"
          },
          {
            "ticket_id": 5111,
            "ticket_number": "355103",
            "title": "GBN-96755 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/01/2026 18:29:15",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/01/2026 18:29:15"
          },
          {
            "ticket_id": 5112,
            "ticket_number": "355104",
            "title": "Informação importante sobre a tua reserva 1760548",
            "priority": "P2",
            "created_at": "04/01/2026 09:55:23",
            "close_date": "2026-01-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/01/2026 10:01:54"
          },
          {
            "ticket_id": 5114,
            "ticket_number": "355106",
            "title": "Informação importante sobre a tua reserva 1760552",
            "priority": "P2",
            "created_at": "04/01/2026 09:55:27",
            "close_date": "2026-01-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/01/2026 10:03:01"
          },
          {
            "ticket_id": 5115,
            "ticket_number": "355107",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 09:55:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/01/2026 09:55:32"
          },
          {
            "ticket_id": 5117,
            "ticket_number": "355109",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 09:55:41",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/01/2026 09:55:41"
          },
          {
            "ticket_id": 5120,
            "ticket_number": "355112",
            "title": "GBN-96779 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 12:24:57",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/01/2026 12:24:57"
          },
          {
            "ticket_id": 5123,
            "ticket_number": "355115",
            "title": "Confirmación de la reserva con localizador: 401850",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 12:29:48",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 48.85,
            "sla_met": false,
            "sla_breach_hours": 24.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 13:21:46"
          },
          {
            "ticket_id": 5125,
            "ticket_number": "355117",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 13:45:11",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/01/2026 13:45:11"
          },
          {
            "ticket_id": 5126,
            "ticket_number": "355118",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/01/2026 14:55:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 15:41:54"
          },
          {
            "ticket_id": 5127,
            "ticket_number": "355119",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/01/2026 14:55:19",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 19.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 09:57:56"
          },
          {
            "ticket_id": 5128,
            "ticket_number": "355120",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 18:15:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 19:02:09"
          },
          {
            "ticket_id": 5129,
            "ticket_number": "355121",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 18:15:45",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 19:02:09"
          },
          {
            "ticket_id": 5130,
            "ticket_number": "355122",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "04/01/2026 18:15:47",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 19:02:09"
          },
          {
            "ticket_id": 5134,
            "ticket_number": "355126",
            "title": "Fwd: Viagify informa sobre a sua reserva 123153690",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 09:57:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 09:57:37"
          },
          {
            "ticket_id": 5140,
            "ticket_number": "355132",
            "title": "Fwd: Incidente de voo TTN-1210276553#89357640#T166",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:54",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 09:57:54"
          },
          {
            "ticket_id": 5143,
            "ticket_number": "355135",
            "title": "Fwd: Viagify informa sobre a sua reserva 123137701",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 09:58:02",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 09:58:03"
          },
          {
            "ticket_id": 5144,
            "ticket_number": "355136",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 09:58:10",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 09:58:10"
          },
          {
            "ticket_id": 5147,
            "ticket_number": "355139",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/01/2026 10:38:32",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 11:48:12"
          },
          {
            "ticket_id": 5148,
            "ticket_number": "355140",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 10:59:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1080.75,
            "sla_met": false,
            "sla_breach_hours": 1056.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:09"
          },
          {
            "ticket_id": 5150,
            "ticket_number": "355142",
            "title": "Confirmação de reserva para For PT004157 68952807",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 11:30:44",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 11:30:46"
          },
          {
            "ticket_id": 5151,
            "ticket_number": "355143",
            "title": "Confirmação de reserva para For PT004157 68952807",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 11:30:46",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 82.62,
            "sla_met": false,
            "sla_breach_hours": 58.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 22:08:39"
          },
          {
            "ticket_id": 5156,
            "ticket_number": "355148",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-96",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 12:09:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 12:09:52"
          },
          {
            "ticket_id": 5157,
            "ticket_number": "355149",
            "title": "GBN-96558 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/01/2026 12:14:39",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 12:20:51"
          },
          {
            "ticket_id": 5164,
            "ticket_number": "355156",
            "title": "GBN-96849 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 13:24:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 13:24:18"
          },
          {
            "ticket_id": 5165,
            "ticket_number": "355157",
            "title": "Orçamentos para grupo - 3 famílias",
            "priority": "P3",
            "created_at": "05/01/2026 13:51:34",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 13:51:34"
          },
          {
            "ticket_id": 5166,
            "ticket_number": "355158",
            "title": "Pedido de Orçamento de GRUPO – Viagem para Sal (Ca",
            "priority": "P3",
            "created_at": "05/01/2026 13:55:26",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 13:55:26"
          },
          {
            "ticket_id": 5176,
            "ticket_number": "355168",
            "title": "Pedido de orçamento - Circuito privado Ilhas Lofot",
            "priority": "P3",
            "created_at": "05/01/2026 17:38:56",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 17:38:56"
          },
          {
            "ticket_id": 5177,
            "ticket_number": "355169",
            "title": "Fwd: Viagify informa sobre a sua reserva 123172241",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 17:57:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 17:57:16"
          },
          {
            "ticket_id": 5178,
            "ticket_number": "355170",
            "title": "Fwd: Viagify informa sobre a sua reserva 123172612",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 18:10:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:10:56"
          },
          {
            "ticket_id": 5179,
            "ticket_number": "355171",
            "title": "Fwd: easyJet booking reference: KBT3MJR",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 18:10:58",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:10:58"
          },
          {
            "ticket_id": 5180,
            "ticket_number": "355172",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/01/2026 18:59:00",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 19:42:02"
          },
          {
            "ticket_id": 5181,
            "ticket_number": "355173",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 18:59:08",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:59:08"
          },
          {
            "ticket_id": 5182,
            "ticket_number": "355174",
            "title": "Fwd: Viagify informa sobre a sua reserva 123172612",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 18:59:12",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:59:14"
          },
          {
            "ticket_id": 5183,
            "ticket_number": "355175",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 18:59:20",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:59:20"
          },
          {
            "ticket_id": 5184,
            "ticket_number": "355176",
            "title": "Fwd: Important: Your TAP Air Portugal flight refer",
            "priority": "Reservas sem Formulário",
            "created_at": "05/01/2026 18:59:23",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 18:59:23"
          },
          {
            "ticket_id": 5188,
            "ticket_number": "355180",
            "title": "Grupo para a Madeira",
            "priority": "P3",
            "created_at": "05/01/2026 20:53:16",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 20:53:16"
          },
          {
            "ticket_id": 5190,
            "ticket_number": "355182",
            "title": "Cotação de grupo -   5630GRP - Sílvia Malheiro",
            "priority": "P3",
            "created_at": "05/01/2026 22:33:45",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 22:33:45"
          },
          {
            "ticket_id": 5191,
            "ticket_number": "355183",
            "title": "GBN-96959 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 22:35:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 451.22,
            "sla_met": false,
            "sla_breach_hours": 427.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 17:49:33"
          },
          {
            "ticket_id": 5194,
            "ticket_number": "355186",
            "title": "GBN-96972 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 00:45:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 00:45:01"
          },
          {
            "ticket_id": 5201,
            "ticket_number": "355193",
            "title": "Fwd: Viagify informa sobre a sua reserva 123181762",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 10:12:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 10:12:44"
          },
          {
            "ticket_id": 5237,
            "ticket_number": "355229",
            "title": "Número de informação da reserva: 6125544",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 16:56:38",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 20:42:30"
          },
          {
            "ticket_id": 5238,
            "ticket_number": "355230",
            "title": "Fwd: Documentación Reserva: 6125544",
            "priority": "P2",
            "created_at": "06/01/2026 16:56:41",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 20:42:30"
          },
          {
            "ticket_id": 5241,
            "ticket_number": "355233",
            "title": "​Pedido de Dados de Passaporte – Reserva 335849",
            "priority": "P2",
            "created_at": "06/01/2026 17:06:48",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 19:29:09"
          },
          {
            "ticket_id": 5242,
            "ticket_number": "355234",
            "title": "GBN-97077 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 17:34:09",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 17:34:10"
          },
          {
            "ticket_id": 5243,
            "ticket_number": "355235",
            "title": "GBN-97074 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 17:34:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 17:34:13"
          },
          {
            "ticket_id": 5244,
            "ticket_number": "355236",
            "title": "Fwd: Viagify informa sobre a sua reserva 123193145",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 17:34:18",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 17:34:19"
          },
          {
            "ticket_id": 5246,
            "ticket_number": "355238",
            "title": "TTN-1231931453#89458688 - opti242100181",
            "priority": "P2",
            "created_at": "06/01/2026 17:34:29",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 20:55:08"
          },
          {
            "ticket_id": 5248,
            "ticket_number": "355240",
            "title": "Nova Viagem #260100032 - Joana Aires",
            "priority": "P2",
            "created_at": "06/01/2026 17:52:55",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 17:52:55"
          },
          {
            "ticket_id": 5249,
            "ticket_number": "355241",
            "title": "Nova Viagem #260100031 - André Pinho",
            "priority": "P2",
            "created_at": "06/01/2026 17:52:57",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 17:52:57"
          },
          {
            "ticket_id": 5255,
            "ticket_number": "355247",
            "title": "Fwd: Incidente de voo TTN-1210276553#89357640#T166",
            "priority": "P2",
            "created_at": "06/01/2026 19:36:33",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 19:36:33"
          },
          {
            "ticket_id": 5257,
            "ticket_number": "355249",
            "title": "GBN-97121 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 19:36:39",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 19:36:39"
          },
          {
            "ticket_id": 5262,
            "ticket_number": "355254",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 21:50:38",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 21:50:38"
          },
          {
            "ticket_id": 5263,
            "ticket_number": "355255",
            "title": "GBN-97136 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 21:50:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 22:28:39"
          },
          {
            "ticket_id": 5264,
            "ticket_number": "355256",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 22:28:39",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 22:28:39"
          },
          {
            "ticket_id": 5267,
            "ticket_number": "355259",
            "title": "Disponibilidade de pacotes para Samaná em novembro",
            "priority": "P2",
            "created_at": "06/01/2026 23:35:52",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 23:35:52"
          },
          {
            "ticket_id": 5268,
            "ticket_number": "355260",
            "title": "Número de informação da reserva: 6125558",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 23:41:42",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 19:40:41"
          },
          {
            "ticket_id": 5273,
            "ticket_number": "355265",
            "title": "GBN-97147 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/01/2026 10:07:55",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 10:07:55"
          },
          {
            "ticket_id": 5274,
            "ticket_number": "355266",
            "title": "Fwd: Viagify informa sobre a sua reserva 123198739",
            "priority": "P2",
            "created_at": "07/01/2026 10:25:47",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 10:25:48"
          },
          {
            "ticket_id": 5276,
            "ticket_number": "355268",
            "title": "Fwd: FW: Novos utilizadores",
            "priority": "P2",
            "created_at": "07/01/2026 10:51:27",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 10:51:27"
          },
          {
            "ticket_id": 5291,
            "ticket_number": "355283",
            "title": "Alteração da reserva n.º 334066 Soltrópico",
            "priority": "P2",
            "created_at": "07/01/2026 13:59:58",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 13:59:58"
          },
          {
            "ticket_id": 5293,
            "ticket_number": "355285",
            "title": "Número de informação da reserva: 6125577",
            "priority": "Reservas sem Formulário",
            "created_at": "07/01/2026 14:40:14",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 31.22,
            "sla_met": false,
            "sla_breach_hours": 7.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:53:18"
          },
          {
            "ticket_id": 5297,
            "ticket_number": "355289",
            "title": "Fwd: Viagify informa sobre a sua reserva 123220596",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 16:56:01",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 16:56:02"
          },
          {
            "ticket_id": 5299,
            "ticket_number": "355291",
            "title": "GBN-97265 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 16:56:07",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 16:56:07"
          },
          {
            "ticket_id": 5301,
            "ticket_number": "355293",
            "title": "GBN-97247 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 16:56:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 16:56:16"
          },
          {
            "ticket_id": 5302,
            "ticket_number": "355294",
            "title": "-",
            "priority": "P3",
            "created_at": "07/01/2026 16:56:21",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 16:56:22"
          },
          {
            "ticket_id": 5303,
            "ticket_number": "355295",
            "title": "GBN-97245 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 16:56:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 16:56:26"
          },
          {
            "ticket_id": 5304,
            "ticket_number": "355296",
            "title": "Fwd: Fly Groups - PT25123112701041 - Request Chang",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:29",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 16:56:30"
          },
          {
            "ticket_id": 5309,
            "ticket_number": "355301",
            "title": "Solicitação de acessos e pedido de orçamento de gr",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:44",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 16:56:45"
          },
          {
            "ticket_id": 5311,
            "ticket_number": "355303",
            "title": "Pedido de orçamento de grupo leplan",
            "priority": "P2",
            "created_at": "07/01/2026 18:31:27",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 18:31:27"
          },
          {
            "ticket_id": 5314,
            "ticket_number": "355306",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-97",
            "priority": "Reservas sem Formulário",
            "created_at": "07/01/2026 18:31:38",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 18:31:38"
          },
          {
            "ticket_id": 5318,
            "ticket_number": "355310",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/01/2026 19:27:35",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:27:35"
          },
          {
            "ticket_id": 5320,
            "ticket_number": "355312",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/01/2026 19:44:02",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:44:02"
          },
          {
            "ticket_id": 5321,
            "ticket_number": "355313",
            "title": "GBN Travel: Resend booking confirmation - GBN-8504",
            "priority": "P2",
            "created_at": "07/01/2026 19:44:06",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:44:06"
          },
          {
            "ticket_id": 5322,
            "ticket_number": "355314",
            "title": "GBN Travel: Resend booking confirmation - GBN-8504",
            "priority": "P2",
            "created_at": "07/01/2026 19:44:10",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:44:11"
          },
          {
            "ticket_id": 5323,
            "ticket_number": "355315",
            "title": "GBN-97312 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "07/01/2026 19:44:46",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 26.08,
            "sla_met": false,
            "sla_breach_hours": 2.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:50:31"
          },
          {
            "ticket_id": 5324,
            "ticket_number": "355316",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/01/2026 19:44:49",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:44:49"
          },
          {
            "ticket_id": 5326,
            "ticket_number": "355318",
            "title": "GBN-97393 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 22:29:46",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 22:29:46"
          },
          {
            "ticket_id": 5328,
            "ticket_number": "355320",
            "title": "GBN-97397 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 22:37:42",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 22:37:42"
          },
          {
            "ticket_id": 5330,
            "ticket_number": "355322",
            "title": "Confirmación de la reserva con localizador: 402202",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 23:04:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 19:02:01"
          },
          {
            "ticket_id": 5331,
            "ticket_number": "355323",
            "title": "Reserva confirmada: Desert Safari com jantar e esp",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/01/2026 23:07:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/01/2026 23:07:17"
          },
          {
            "ticket_id": 5332,
            "ticket_number": "355324",
            "title": "Reserva confirmada: Desert Safari com jantar e esp",
            "priority": "Reservas sem Formulário",
            "created_at": "07/01/2026 23:07:17",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 22.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:48:42"
          },
          {
            "ticket_id": 5333,
            "ticket_number": "355325",
            "title": "Pedido de orçamento carro funchal (RL)",
            "priority": "P3",
            "created_at": "07/01/2026 23:10:28",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 23:11:30"
          },
          {
            "ticket_id": 5343,
            "ticket_number": "355335",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/01/2026 10:07:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1009.62,
            "sla_met": false,
            "sla_breach_hours": 985.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:08"
          },
          {
            "ticket_id": 5344,
            "ticket_number": "355336",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604517844",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 10:07:28",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 10:06:09"
          },
          {
            "ticket_id": 5345,
            "ticket_number": "355337",
            "title": "Confirmação de reserva. Localizador: 1RJZH4I8H0",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/01/2026 10:07:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1009.62,
            "sla_met": false,
            "sla_breach_hours": 985.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:08"
          },
          {
            "ticket_id": 5348,
            "ticket_number": "355340",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/01/2026 10:07:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1009.62,
            "sla_met": false,
            "sla_breach_hours": 985.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:08"
          },
          {
            "ticket_id": 5376,
            "ticket_number": "355368",
            "title": "GBN-96768 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 11:12:03",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 10.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:43:31"
          },
          {
            "ticket_id": 5379,
            "ticket_number": "355371",
            "title": "Confirmação de reserva com localizador: 4022301",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 11:21:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 131.52,
            "sla_met": false,
            "sla_breach_hours": 107.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:53:27"
          },
          {
            "ticket_id": 5380,
            "ticket_number": "355372",
            "title": "Confirmação de reserva com localizador: 4022305",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 11:21:41",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 131.52,
            "sla_met": false,
            "sla_breach_hours": 107.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:52:56"
          },
          {
            "ticket_id": 5381,
            "ticket_number": "355373",
            "title": "Confirmação de reserva com localizador: 4022290",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 11:21:43",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 131.5,
            "sla_met": false,
            "sla_breach_hours": 107.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:52:28"
          },
          {
            "ticket_id": 5382,
            "ticket_number": "355374",
            "title": "GBN-97425 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/01/2026 11:21:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 11:21:46"
          },
          {
            "ticket_id": 5392,
            "ticket_number": "355384",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 12:29:28",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 9.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 21:42:21"
          },
          {
            "ticket_id": 5394,
            "ticket_number": "355386",
            "title": "GBN-97448 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 12:29:35",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 12:29:35"
          },
          {
            "ticket_id": 5399,
            "ticket_number": "355391",
            "title": "GBN-97486 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 14:24:41",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 14:24:41"
          },
          {
            "ticket_id": 5400,
            "ticket_number": "355392",
            "title": "GBN-97496 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 16:05:14",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 16:05:15"
          },
          {
            "ticket_id": 5401,
            "ticket_number": "355393",
            "title": "GBN-97497 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/01/2026 16:05:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 16:05:19"
          },
          {
            "ticket_id": 5402,
            "ticket_number": "355394",
            "title": "GBN-97502 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 16:05:25",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 16:05:25"
          },
          {
            "ticket_id": 5410,
            "ticket_number": "355402",
            "title": "GBN-97615 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 19:34:30",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 19:34:35"
          },
          {
            "ticket_id": 5411,
            "ticket_number": "355403",
            "title": "GBN-97615 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 19:34:35",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 19:34:35"
          },
          {
            "ticket_id": 5412,
            "ticket_number": "355404",
            "title": "Fwd: Viagify informa sobre a sua reserva 123268980",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 19:34:39",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 19:34:40"
          },
          {
            "ticket_id": 5413,
            "ticket_number": "355405",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-97",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 19:34:45",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 19:34:45"
          },
          {
            "ticket_id": 5414,
            "ticket_number": "355406",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "08/01/2026 19:34:54",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 19:34:55"
          },
          {
            "ticket_id": 5415,
            "ticket_number": "355407",
            "title": "Reserva confirmada: Calçada do Gigante, Titanic Ex",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 20:07:54",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 20:08:07"
          },
          {
            "ticket_id": 5417,
            "ticket_number": "355409",
            "title": "Fwd: Confirmacion de la reserva Transavia: T7NU6L",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 20:08:00",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 20:08:01"
          },
          {
            "ticket_id": 5418,
            "ticket_number": "355410",
            "title": "Viaje mais em 2026: descontos até 15%!",
            "priority": "P2",
            "created_at": "08/01/2026 20:08:04",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 21:08:36"
          },
          {
            "ticket_id": 5419,
            "ticket_number": "355411",
            "title": "Reserva confirmada: Calçada do Gigante, Titanic Ex",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 20:08:07",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 00:00:46"
          },
          {
            "ticket_id": 5421,
            "ticket_number": "355413",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "08/01/2026 20:08:12",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 21:07:47"
          },
          {
            "ticket_id": 5423,
            "ticket_number": "355415",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604518491",
            "priority": "P2",
            "created_at": "08/01/2026 20:34:25",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 23:47:00"
          },
          {
            "ticket_id": 5428,
            "ticket_number": "355420",
            "title": "Pedido de orçamento de grupo",
            "priority": "P2",
            "created_at": "08/01/2026 23:37:31",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 23:37:31"
          },
          {
            "ticket_id": 5429,
            "ticket_number": "355421",
            "title": "GBN-97649 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 23:37:34",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 23:37:35"
          },
          {
            "ticket_id": 5430,
            "ticket_number": "355422",
            "title": "GBN-97648 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 23:37:38",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 23:37:38"
          },
          {
            "ticket_id": 5431,
            "ticket_number": "355423",
            "title": "GBN-97650 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/01/2026 23:41:52",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/01/2026 23:41:52"
          },
          {
            "ticket_id": 5434,
            "ticket_number": "355426",
            "title": "Fwd: Viagify informa sobre a sua reserva 123275908",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 10:09:20",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 10:09:21"
          },
          {
            "ticket_id": 5439,
            "ticket_number": "355431",
            "title": "GBN-97654 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 10:11:39",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 19:10:45"
          },
          {
            "ticket_id": 5444,
            "ticket_number": "355436",
            "title": "Número de informação da reserva: 6125669",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 11:55:51",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 11.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 23:24:21"
          },
          {
            "ticket_id": 5445,
            "ticket_number": "355437",
            "title": "Confirmação de Reserva * File 422534",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 11:55:56",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 10.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 22:08:59"
          },
          {
            "ticket_id": 5448,
            "ticket_number": "355440",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-97",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 12:29:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 4.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 16:43:33"
          },
          {
            "ticket_id": 5449,
            "ticket_number": "355441",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-97",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 12:29:09",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 12:29:09"
          },
          {
            "ticket_id": 5450,
            "ticket_number": "355442",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "09/01/2026 12:29:44",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 12:52:06"
          },
          {
            "ticket_id": 5451,
            "ticket_number": "355443",
            "title": "Re: Cotação GIG-Londres-Lisboa-Opo-Gig",
            "priority": "P2",
            "created_at": "09/01/2026 12:37:37",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 12:37:37"
          },
          {
            "ticket_id": 5454,
            "ticket_number": "355446",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604518835",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 13:07:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 982.63,
            "sla_met": false,
            "sla_breach_hours": 958.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:08"
          },
          {
            "ticket_id": 5456,
            "ticket_number": "355448",
            "title": "Informação de reserva - SPT002601566676",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 13:49:13",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 22:07:03"
          },
          {
            "ticket_id": 5457,
            "ticket_number": "355449",
            "title": "Informação de reserva - SPT002601566676",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 14:07:04",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 5.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 19:08:45"
          },
          {
            "ticket_id": 5462,
            "ticket_number": "355454",
            "title": "GBN-97747 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 16:20:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 19:07:25"
          },
          {
            "ticket_id": 5465,
            "ticket_number": "355457",
            "title": "GBN-97700 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 16:43:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 16:43:21"
          },
          {
            "ticket_id": 5467,
            "ticket_number": "355459",
            "title": "GBN-97703 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 16:43:33",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 192.95,
            "sla_met": false,
            "sla_breach_hours": 168.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 17:41:09"
          },
          {
            "ticket_id": 5470,
            "ticket_number": "355462",
            "title": "Fwd: Reserva 1211421469 TTN-1211421469#88852195#T1",
            "priority": "P2",
            "created_at": "09/01/2026 17:21:04",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 17:21:05"
          },
          {
            "ticket_id": 5471,
            "ticket_number": "355463",
            "title": "Fwd: Incidente de voo TTN-1211421469#88852195#T164",
            "priority": "P2",
            "created_at": "09/01/2026 17:21:06",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 17:21:07"
          },
          {
            "ticket_id": 5473,
            "ticket_number": "355465",
            "title": "GBN-97821 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 18:32:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 18:32:35"
          },
          {
            "ticket_id": 5478,
            "ticket_number": "355470",
            "title": "Faturas Pendentes: FA 2147885350",
            "priority": "P2",
            "created_at": "09/01/2026 19:36:33",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 23:01:25"
          },
          {
            "ticket_id": 5479,
            "ticket_number": "355471",
            "title": "Re: Nova Viagem #260100055 - Patrícia Trabulo Viag",
            "priority": "P2",
            "created_at": "09/01/2026 19:37:54",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 19:37:56"
          },
          {
            "ticket_id": 5480,
            "ticket_number": "355472",
            "title": "Viagem Brasil",
            "priority": "P2",
            "created_at": "09/01/2026 19:54:38",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 19:54:38"
          },
          {
            "ticket_id": 5481,
            "ticket_number": "355473",
            "title": "Faturas Pendentes: FA 2147885442",
            "priority": "P2",
            "created_at": "09/01/2026 20:53:12",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 23:01:29"
          },
          {
            "ticket_id": 5485,
            "ticket_number": "355477",
            "title": "Fwd: Viagify informa sobre a sua reserva 123313526",
            "priority": "P2",
            "created_at": "09/01/2026 21:17:07",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 21:17:07"
          },
          {
            "ticket_id": 5487,
            "ticket_number": "355479",
            "title": "Fwd: Viagify informa sobre a sua reserva 123315533",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 21:17:18",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 21:17:18"
          },
          {
            "ticket_id": 5488,
            "ticket_number": "355480",
            "title": "Fwd: Viagify informa sobre a sua reserva 123315227",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 21:17:21",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 21:17:22"
          },
          {
            "ticket_id": 5489,
            "ticket_number": "355481",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604519306",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 22:26:35",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 23:23:21"
          },
          {
            "ticket_id": 5490,
            "ticket_number": "355482",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604519309",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/01/2026 23:00:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 972.73,
            "sla_met": false,
            "sla_breach_hours": 948.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:08"
          },
          {
            "ticket_id": 5491,
            "ticket_number": "355483",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604519316",
            "priority": "P2",
            "created_at": "09/01/2026 23:20:24",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 23:42:49"
          },
          {
            "ticket_id": 5496,
            "ticket_number": "355488",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "Reservas sem Formulário",
            "created_at": "09/01/2026 23:39:56",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/01/2026 23:39:56"
          },
          {
            "ticket_id": 5501,
            "ticket_number": "355493",
            "title": "Confirmação de reserva com localizador: 4025262",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/01/2026 11:09:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.9,
            "sla_met": false,
            "sla_breach_hours": 29.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:04:36"
          },
          {
            "ticket_id": 5503,
            "ticket_number": "355495",
            "title": "81087 - Reservas com chegada prevista para os próx",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 11:09:41",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 53.9,
            "sla_met": false,
            "sla_breach_hours": 29.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:04:36"
          },
          {
            "ticket_id": 5505,
            "ticket_number": "355497",
            "title": "Fwd: Informações do passaporte TTN-1209800114#8973",
            "priority": "P2",
            "created_at": "10/01/2026 11:10:49",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 11:10:49"
          },
          {
            "ticket_id": 5507,
            "ticket_number": "355499",
            "title": "Fwd: Viagify informa sobre a sua reserva 123329380",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 13:56:52",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 13:56:53"
          },
          {
            "ticket_id": 5509,
            "ticket_number": "355501",
            "title": "GBN-97931 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/01/2026 13:56:58",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 13:56:58"
          },
          {
            "ticket_id": 5510,
            "ticket_number": "355502",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 13:57:00",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 13:57:05"
          },
          {
            "ticket_id": 5512,
            "ticket_number": "355504",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 13:57:05",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 80.78,
            "sla_met": false,
            "sla_breach_hours": 56.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:45:04"
          },
          {
            "ticket_id": 5514,
            "ticket_number": "355506",
            "title": "Fwd: Viagify informa sobre a sua reserva 123329380",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 13:57:10",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 13:57:10"
          },
          {
            "ticket_id": 5518,
            "ticket_number": "355510",
            "title": "GBN-97940 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 15:46:30",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 15:46:31"
          },
          {
            "ticket_id": 5519,
            "ticket_number": "355511",
            "title": "Fwd: Viagify informa sobre a sua reserva 123334454",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 15:46:33",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 15:46:34"
          },
          {
            "ticket_id": 5520,
            "ticket_number": "355512",
            "title": "Confirmação reserva Bedsonline 266-2909360",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 15:46:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 53.88,
            "sla_met": false,
            "sla_breach_hours": 29.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 21:40:11"
          },
          {
            "ticket_id": 5526,
            "ticket_number": "355518",
            "title": "GBN-97947 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 16:34:24",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 16:34:24"
          },
          {
            "ticket_id": 5531,
            "ticket_number": "355523",
            "title": "URGENTE - Alteração horário pick-up transfer GBN-9",
            "priority": "P2",
            "created_at": "10/01/2026 17:49:38",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 17:49:39"
          },
          {
            "ticket_id": 5533,
            "ticket_number": "355525",
            "title": "GBN-97965 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/01/2026 18:20:06",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/01/2026 18:20:06"
          },
          {
            "ticket_id": 5543,
            "ticket_number": "355535",
            "title": "RV: Confirmacion de la reserva Transavia: GCF3KZ",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:05",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 14:04:24"
          },
          {
            "ticket_id": 5548,
            "ticket_number": "355540",
            "title": "Fwd: Viagify informa sobre a sua reserva 123363709",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:08:17",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 10:08:18"
          },
          {
            "ticket_id": 5550,
            "ticket_number": "355542",
            "title": "Fwd: Última chamada: A tua viagem para Seville",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:24",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:08:24"
          },
          {
            "ticket_id": 5552,
            "ticket_number": "355544",
            "title": "Fwd: Você fez o check-in para seu voo para Lisboa ",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:30",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:08:30"
          },
          {
            "ticket_id": 5553,
            "ticket_number": "355545",
            "title": "GBN-98037 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:32",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 14:04:25"
          },
          {
            "ticket_id": 5554,
            "ticket_number": "355546",
            "title": "Fwd: Viagify informa sobre a sua reserva 123369862",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:35",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:08:36"
          },
          {
            "ticket_id": 5557,
            "ticket_number": "355549",
            "title": "Confirmation of booking with locatorMJTI1Y8V",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:08:43",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 36.55,
            "sla_met": false,
            "sla_breach_hours": 12.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:42:26"
          },
          {
            "ticket_id": 5561,
            "ticket_number": "355553",
            "title": "Confirmation of booking with locatorD4RU6ZG3",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:12:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 913.55,
            "sla_met": false,
            "sla_breach_hours": 889.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5562,
            "ticket_number": "355554",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "P2",
            "created_at": "12/01/2026 10:12:08",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:12:08"
          },
          {
            "ticket_id": 5563,
            "ticket_number": "355555",
            "title": "Fwd: Ya puede facturar online para su vuelo a Lisb",
            "priority": "P2",
            "created_at": "12/01/2026 10:12:42",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:12:42"
          },
          {
            "ticket_id": 5564,
            "ticket_number": "355556",
            "title": "Fwd: Viagify informa sobre a sua reserva 123348931",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:12:45",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 36.47,
            "sla_met": false,
            "sla_breach_hours": 12.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:41:40"
          },
          {
            "ticket_id": 5566,
            "ticket_number": "355558",
            "title": "Fwd: Viagify informa sobre a sua reserva 123348931",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:12:52",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 36.47,
            "sla_met": false,
            "sla_breach_hours": 12.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:41:33"
          },
          {
            "ticket_id": 5568,
            "ticket_number": "355560",
            "title": "Fwd: Informações da sua reserva TTN-1233489310#897",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:12:59",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 36.47,
            "sla_met": false,
            "sla_breach_hours": 12.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:41:26"
          },
          {
            "ticket_id": 5578,
            "ticket_number": "355570",
            "title": "Reserva confirmada: Tour noturno por Paris - Civit",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:16:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5591,
            "ticket_number": "355583",
            "title": "Confirmation of booking with locator94Q95W81",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:21:30",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 36.32,
            "sla_met": false,
            "sla_breach_hours": 12.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:41:01"
          },
          {
            "ticket_id": 5594,
            "ticket_number": "355586",
            "title": "Confirmation of booking with locator7N1URF03",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:22:12",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 444.35,
            "sla_met": false,
            "sla_breach_hours": 420.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 22:43:39"
          },
          {
            "ticket_id": 5616,
            "ticket_number": "355608",
            "title": "GBN-95529 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/01/2026 13:02:39",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.45,
            "sla_met": false,
            "sla_breach_hours": 0.45,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 17:30:21"
          },
          {
            "ticket_id": 5619,
            "ticket_number": "355611",
            "title": "Petición CnTravel 36011006",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:47",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 6.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 19:03:46"
          },
          {
            "ticket_id": 5630,
            "ticket_number": "355622",
            "title": "Confirmação da reserva nº 21363927",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 15:40:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 908.07,
            "sla_met": false,
            "sla_breach_hours": 884.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5633,
            "ticket_number": "355625",
            "title": "Re:[## 28871 ##] GBN-95529 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/01/2026 15:40:31",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 17:30:06"
          },
          {
            "ticket_id": 5645,
            "ticket_number": "355637",
            "title": "Confirmation of booking with locatorWVQD5ZRX",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 17:49:27",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 28.83,
            "sla_met": false,
            "sla_breach_hours": 4.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:40:02"
          },
          {
            "ticket_id": 5667,
            "ticket_number": "355659",
            "title": "orçamento disney",
            "priority": "P2",
            "created_at": "12/01/2026 21:10:11",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 21:10:12"
          },
          {
            "ticket_id": 5669,
            "ticket_number": "355661",
            "title": "Número de informação da reserva: 6126022",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 21:10:49",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 25.47,
            "sla_met": false,
            "sla_breach_hours": 1.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:39:26"
          },
          {
            "ticket_id": 5671,
            "ticket_number": "355663",
            "title": "Dados Acesso para Check in",
            "priority": "P2",
            "created_at": "12/01/2026 21:13:00",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 21:13:00"
          },
          {
            "ticket_id": 5673,
            "ticket_number": "355665",
            "title": "Número de informação da reserva: 6126040",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 21:47:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 901.97,
            "sla_met": false,
            "sla_breach_hours": 877.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5674,
            "ticket_number": "355666",
            "title": "Informação de reserva - SPT002601567778",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 21:47:09",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 24.85,
            "sla_met": false,
            "sla_breach_hours": 0.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:38:30"
          },
          {
            "ticket_id": 5675,
            "ticket_number": "355667",
            "title": "GBN-98313 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 21:51:27",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 21:51:27"
          },
          {
            "ticket_id": 5677,
            "ticket_number": "355669",
            "title": "Newblue - loc: 6126040",
            "priority": "P2",
            "created_at": "12/01/2026 22:05:10",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 22:05:10"
          },
          {
            "ticket_id": 5678,
            "ticket_number": "355670",
            "title": "Comprovativo Transação ",
            "priority": "P2",
            "created_at": "12/01/2026 22:39:44",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:25:58"
          },
          {
            "ticket_id": 5681,
            "ticket_number": "355673",
            "title": "Orçamento 20061/26/27/45657 Rute Santos",
            "priority": "P2",
            "created_at": "12/01/2026 22:57:04",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 23:06:14"
          },
          {
            "ticket_id": 5682,
            "ticket_number": "355674",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 23:04:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 23:04:32"
          },
          {
            "ticket_id": 5743,
            "ticket_number": "355735",
            "title": "Nova Viagem #260100128 - Joana Caneira",
            "priority": "P2",
            "created_at": "13/01/2026 12:58:12",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 12:58:13"
          },
          {
            "ticket_id": 5757,
            "ticket_number": "355749",
            "title": "SEMANA DE CABO VERDE 🏖️ SAL E BOA VISTA - RESERVAS",
            "priority": "P2",
            "created_at": "13/01/2026 14:56:25",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 15:53:48"
          },
          {
            "ticket_id": 5766,
            "ticket_number": "355758",
            "title": "Pedido de partilha de \"iwj-yqeg-urk (2026-01-12 21",
            "priority": "P2",
            "created_at": "13/01/2026 15:25:13",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 15:53:15"
          },
          {
            "ticket_id": 5783,
            "ticket_number": "355775",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 17:06:07",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 5.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:34:52"
          },
          {
            "ticket_id": 5787,
            "ticket_number": "355779",
            "title": "Solicitação de agendamento de reunião",
            "priority": "P2",
            "created_at": "13/01/2026 17:26:02",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:33:12"
          },
          {
            "ticket_id": 5788,
            "ticket_number": "355780",
            "title": "Fwd: Reserva 1211690808 TTN-1211690808#89220135#T1",
            "priority": "P2",
            "created_at": "13/01/2026 17:26:04",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 17:26:05"
          },
          {
            "ticket_id": 5795,
            "ticket_number": "355787",
            "title": "Informação de reserva - SPT002601568300",
            "priority": "P2",
            "created_at": "13/01/2026 18:27:13",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:40:37"
          },
          {
            "ticket_id": 5797,
            "ticket_number": "355789",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "13/01/2026 18:40:29",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:56:07"
          },
          {
            "ticket_id": 5799,
            "ticket_number": "355791",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/01/2026 18:57:01",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:57:02"
          },
          {
            "ticket_id": 5800,
            "ticket_number": "355792",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/01/2026 18:57:12",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:57:12"
          },
          {
            "ticket_id": 5801,
            "ticket_number": "355793",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/01/2026 18:57:23",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:57:24"
          },
          {
            "ticket_id": 5802,
            "ticket_number": "355794",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/01/2026 18:58:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:58:37"
          },
          {
            "ticket_id": 5804,
            "ticket_number": "355796",
            "title": "Fwd: Informações da reserva TTN-1211690808#9001077",
            "priority": "P2",
            "created_at": "13/01/2026 19:37:49",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 19:37:50"
          },
          {
            "ticket_id": 5805,
            "ticket_number": "355797",
            "title": "Fwd: Informações da reserva TTN-1227770215#9000947",
            "priority": "P2",
            "created_at": "13/01/2026 19:37:52",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 21:31:00"
          },
          {
            "ticket_id": 5806,
            "ticket_number": "355798",
            "title": "GBN-89425 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 20:06:15",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:33:33"
          },
          {
            "ticket_id": 5810,
            "ticket_number": "355802",
            "title": "Cancelamento reservas",
            "priority": "P2",
            "created_at": "13/01/2026 20:20:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 20:20:38"
          },
          {
            "ticket_id": 5811,
            "ticket_number": "355803",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 20:30:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 20:30:35"
          },
          {
            "ticket_id": 5812,
            "ticket_number": "355804",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 20:30:38",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 20:30:38"
          },
          {
            "ticket_id": 5813,
            "ticket_number": "355805",
            "title": "Confirmacao 336634",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 20:46:50",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:29:36"
          },
          {
            "ticket_id": 5814,
            "ticket_number": "355806",
            "title": "Confirmacao 336636",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 21:05:38",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:29:11"
          },
          {
            "ticket_id": 5817,
            "ticket_number": "355809",
            "title": "Confirmação de reserva com localizador: 4029801",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 21:15:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 17:00:57"
          },
          {
            "ticket_id": 5819,
            "ticket_number": "355811",
            "title": "GBN-98535 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 21:33:06",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 92.0,
            "sla_met": false,
            "sla_breach_hours": 68.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 17:33:59"
          },
          {
            "ticket_id": 5821,
            "ticket_number": "355813",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 22:00:52",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 22:00:52"
          },
          {
            "ticket_id": 5822,
            "ticket_number": "355814",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604521877",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 22:05:08",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 18:01:03"
          },
          {
            "ticket_id": 5829,
            "ticket_number": "355821",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "13/01/2026 22:54:26",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:12:16"
          },
          {
            "ticket_id": 5830,
            "ticket_number": "355822",
            "title": "localizador new blue 1761445",
            "priority": "P2",
            "created_at": "13/01/2026 22:54:28",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 22:54:28"
          },
          {
            "ticket_id": 5831,
            "ticket_number": "355823",
            "title": "Confirmation of booking with locatorYHDT77JG",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 22:54:30",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 18:41:07"
          },
          {
            "ticket_id": 5835,
            "ticket_number": "355827",
            "title": "GBN-98614 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 23:05:13",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 23:05:13"
          },
          {
            "ticket_id": 5837,
            "ticket_number": "355829",
            "title": "Número de informação da reserva: 6126359",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 23:05:52",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 19:01:13"
          },
          {
            "ticket_id": 5838,
            "ticket_number": "355830",
            "title": "Número de informação da reserva: 6126361",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 23:20:06",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 45.52,
            "sla_met": false,
            "sla_breach_hours": 21.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 20:51:33"
          },
          {
            "ticket_id": 5839,
            "ticket_number": "355831",
            "title": "Cancelamento reserva Newblue 6126359",
            "priority": "P2",
            "created_at": "13/01/2026 23:25:54",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:25:54"
          },
          {
            "ticket_id": 5840,
            "ticket_number": "355832",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802284637",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 23:26:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 19:21:16"
          },
          {
            "ticket_id": 5841,
            "ticket_number": "355833",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802284642",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 23:26:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 19:21:16"
          },
          {
            "ticket_id": 5842,
            "ticket_number": "355834",
            "title": "Fwd: Viagify informa sobre a sua reserva 123469373",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 23:31:16",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 23:31:16"
          },
          {
            "ticket_id": 5843,
            "ticket_number": "355835",
            "title": "Pedido reserva - Rate Hawk 21363927",
            "priority": "P2",
            "created_at": "13/01/2026 23:37:03",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:37:04"
          },
          {
            "ticket_id": 5845,
            "ticket_number": "355837",
            "title": "GBN-98618 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 23:48:37",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 140.3,
            "sla_met": false,
            "sla_breach_hours": 116.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 20:06:58"
          },
          {
            "ticket_id": 5850,
            "ticket_number": "355842",
            "title": "webnar smy",
            "priority": "P2",
            "created_at": "14/01/2026 00:05:14",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 00:05:14"
          },
          {
            "ticket_id": 5851,
            "ticket_number": "355843",
            "title": "Webinar Smytravel",
            "priority": "P2",
            "created_at": "14/01/2026 00:06:50",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 00:06:50"
          },
          {
            "ticket_id": 5852,
            "ticket_number": "355844",
            "title": "Inscrição Webinar smy",
            "priority": "P2",
            "created_at": "14/01/2026 00:08:26",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 00:08:27"
          },
          {
            "ticket_id": 5857,
            "ticket_number": "355849",
            "title": "Félicitations! Vous avez augmenté votre solde.",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:11",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:33:11"
          },
          {
            "ticket_id": 5859,
            "ticket_number": "355851",
            "title": "Fwd: JV4K5Q | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:16",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:08:17"
          },
          {
            "ticket_id": 5861,
            "ticket_number": "355853",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:22",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:28:13"
          },
          {
            "ticket_id": 5864,
            "ticket_number": "355856",
            "title": "Confirmação de reserva – Ref PP148127, Sr. Nuno Mi",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 10:08:30",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 14:03:43"
          },
          {
            "ticket_id": 5873,
            "ticket_number": "355865",
            "title": "Comprovativo de Iban",
            "priority": "P2",
            "created_at": "14/01/2026 11:21:08",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:21:08"
          },
          {
            "ticket_id": 5881,
            "ticket_number": "355873",
            "title": "Webinar smytravel",
            "priority": "P2",
            "created_at": "14/01/2026 12:19:08",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 12:19:08"
          },
          {
            "ticket_id": 5884,
            "ticket_number": "355876",
            "title": "GBN-98602 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 12:19:12",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 70.88,
            "sla_met": false,
            "sla_breach_hours": 46.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 11:12:14"
          },
          {
            "ticket_id": 5900,
            "ticket_number": "355892",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 13:43:46",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 30.95,
            "sla_met": false,
            "sla_breach_hours": 6.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 20:40:50"
          },
          {
            "ticket_id": 5903,
            "ticket_number": "355895",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604522552",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 15:04:49",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 860.67,
            "sla_met": false,
            "sla_breach_hours": 836.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5927,
            "ticket_number": "355919",
            "title": "GBN-98777 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 16:18:12",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 16:18:12"
          },
          {
            "ticket_id": 5929,
            "ticket_number": "355921",
            "title": "GBN-88146 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "14/01/2026 17:28:41",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 5.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 22:58:29"
          },
          {
            "ticket_id": 5934,
            "ticket_number": "355926",
            "title": "Informação de reserva - SPT002601568995",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 17:29:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 27.12,
            "sla_met": false,
            "sla_breach_hours": 3.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 20:37:20"
          },
          {
            "ticket_id": 5935,
            "ticket_number": "355927",
            "title": "Fwd: Viagify informa sobre a sua reserva 123501301",
            "priority": "P2",
            "created_at": "14/01/2026 17:29:46",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 17:29:25"
          },
          {
            "ticket_id": 5937,
            "ticket_number": "355929",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604511198",
            "priority": "P2",
            "created_at": "14/01/2026 17:29:53",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 20:21:42"
          },
          {
            "ticket_id": 5938,
            "ticket_number": "355930",
            "title": "Detalhe preço",
            "priority": "P2",
            "created_at": "14/01/2026 18:42:18",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 18:42:19"
          },
          {
            "ticket_id": 5939,
            "ticket_number": "355931",
            "title": "GBN-98836 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "14/01/2026 18:42:20",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.47,
            "sla_met": false,
            "sla_breach_hours": 1.22,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 20:11:05"
          },
          {
            "ticket_id": 5940,
            "ticket_number": "355932",
            "title": "Esclarecimento - Ajuda",
            "priority": "P3",
            "created_at": "14/01/2026 18:42:23",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:42:23"
          },
          {
            "ticket_id": 5941,
            "ticket_number": "355933",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 18:42:26",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 388.28,
            "sla_met": false,
            "sla_breach_hours": 364.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 22:59:52"
          },
          {
            "ticket_id": 5943,
            "ticket_number": "355935",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/01/2026 19:55:20",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 19:55:20"
          },
          {
            "ticket_id": 5947,
            "ticket_number": "355939",
            "title": "GBN-98902 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 20:20:42",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 20:20:42"
          },
          {
            "ticket_id": 5950,
            "ticket_number": "355942",
            "title": "Información de reserva número: 1768993",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 20:39:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 855.08,
            "sla_met": false,
            "sla_breach_hours": 831.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5953,
            "ticket_number": "355945",
            "title": "GBN-98037 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/01/2026 20:57:37",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 21:17:13"
          },
          {
            "ticket_id": 5954,
            "ticket_number": "355946",
            "title": "Vila Galé | Confirmação da Reserva Nº8909809",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 21:09:39",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 23.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 20:31:38"
          },
          {
            "ticket_id": 5955,
            "ticket_number": "355947",
            "title": "GBN-98913 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 21:27:58",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 21:27:58"
          },
          {
            "ticket_id": 5957,
            "ticket_number": "355949",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "P2",
            "created_at": "14/01/2026 22:50:47",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 22:50:47"
          },
          {
            "ticket_id": 5960,
            "ticket_number": "355952",
            "title": "Tour Japão - GBN-97393 (send help)",
            "priority": "P2",
            "created_at": "14/01/2026 22:50:57",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:37:02"
          },
          {
            "ticket_id": 5961,
            "ticket_number": "355953",
            "title": "Número de informação da reserva: 6126614",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:00",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:29:59"
          },
          {
            "ticket_id": 5965,
            "ticket_number": "355957",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:20",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 22:51:20"
          },
          {
            "ticket_id": 5966,
            "ticket_number": "355958",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604523178",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:23",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:29:01"
          },
          {
            "ticket_id": 5969,
            "ticket_number": "355961",
            "title": "Confirmacao 336748",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 22:52:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 852.88,
            "sla_met": false,
            "sla_breach_hours": 828.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5970,
            "ticket_number": "355962",
            "title": "Número de informação da reserva: 6126623",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 23:04:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 852.67,
            "sla_met": false,
            "sla_breach_hours": 828.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:07"
          },
          {
            "ticket_id": 5974,
            "ticket_number": "355966",
            "title": "Pedido de Informação - Excursões Rimain Tours",
            "priority": "P2",
            "created_at": "14/01/2026 23:13:42",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:13:42"
          },
          {
            "ticket_id": 5976,
            "ticket_number": "355968",
            "title": "Webinar da SMYTRAVEL",
            "priority": "P2",
            "created_at": "14/01/2026 23:43:36",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:43:37"
          },
          {
            "ticket_id": 5977,
            "ticket_number": "355969",
            "title": "Webinar SmyTravel - Hotel Wine & Books by The Sea ",
            "priority": "P2",
            "created_at": "14/01/2026 23:43:38",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:43:38"
          },
          {
            "ticket_id": 5978,
            "ticket_number": "355970",
            "title": "Webinar da smytravel 22/101",
            "priority": "P2",
            "created_at": "14/01/2026 23:43:40",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:43:41"
          },
          {
            "ticket_id": 5979,
            "ticket_number": "355971",
            "title": "RE: FW: SignRequest sent: rgpd GBN-95689.docx",
            "priority": "P2",
            "created_at": "14/01/2026 23:50:01",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:50:02"
          },
          {
            "ticket_id": 5981,
            "ticket_number": "355973",
            "title": "Número de informação da reserva: 6126635",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 23:56:54",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 19:43:17"
          },
          {
            "ticket_id": 5982,
            "ticket_number": "355974",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:19",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 9.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:21:10"
          },
          {
            "ticket_id": 5983,
            "ticket_number": "355975",
            "title": "GBN-98942 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/01/2026 10:13:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 10:13:22"
          },
          {
            "ticket_id": 5984,
            "ticket_number": "355976",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:25",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 9.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:21:37"
          },
          {
            "ticket_id": 5995,
            "ticket_number": "355987",
            "title": "GBN-98939 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:53",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:34:59"
          },
          {
            "ticket_id": 5997,
            "ticket_number": "355989",
            "title": "GBN-98918 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/01/2026 10:14:02",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.32,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:33:51"
          },
          {
            "ticket_id": 5999,
            "ticket_number": "355991",
            "title": "PRODUTO EXCLUSIVO MSC YACHT CLUB - DISPONIVEL EM 1",
            "priority": "P2",
            "created_at": "15/01/2026 10:14:13",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:44:01"
          },
          {
            "ticket_id": 6001,
            "ticket_number": "355993",
            "title": "GBN-98936 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/01/2026 10:14:18",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:36:04"
          },
          {
            "ticket_id": 6018,
            "ticket_number": "356010",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 10:59:52",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:47:50"
          },
          {
            "ticket_id": 6019,
            "ticket_number": "356011",
            "title": "2 envio ****URGENTE PASAPORTES - 99122811",
            "priority": "P3",
            "created_at": "15/01/2026 10:59:54",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 11:50:54"
          },
          {
            "ticket_id": 6021,
            "ticket_number": "356013",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:02:39",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:47:55"
          },
          {
            "ticket_id": 6022,
            "ticket_number": "356014",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:02:41",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:49:04"
          },
          {
            "ticket_id": 6023,
            "ticket_number": "356015",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:02:43",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:18"
          },
          {
            "ticket_id": 6024,
            "ticket_number": "356016",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:02:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:42"
          },
          {
            "ticket_id": 6026,
            "ticket_number": "356018",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:18:15",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:24"
          },
          {
            "ticket_id": 6027,
            "ticket_number": "356019",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:18:17",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:02"
          },
          {
            "ticket_id": 6028,
            "ticket_number": "356020",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:18:19",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:36"
          },
          {
            "ticket_id": 6030,
            "ticket_number": "356022",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:36:41",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:07"
          },
          {
            "ticket_id": 6031,
            "ticket_number": "356023",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "15/01/2026 11:36:43",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 8.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:48:51"
          },
          {
            "ticket_id": 6036,
            "ticket_number": "356028",
            "title": "***URGENTE PAGO HOY***LOC.604511198 (LEPLAN)---Uma",
            "priority": "P2",
            "created_at": "15/01/2026 12:40:03",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:42:36"
          },
          {
            "ticket_id": 6037,
            "ticket_number": "356029",
            "title": "GBN-98922 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/01/2026 12:40:05",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 5.2,
            "sla_met": false,
            "sla_breach_hours": 1.2,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:52:08"
          },
          {
            "ticket_id": 6038,
            "ticket_number": "356030",
            "title": "GBN-98922 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/01/2026 12:40:11",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:40:11"
          },
          {
            "ticket_id": 6043,
            "ticket_number": "356035",
            "title": "Orcamento grupo Hotel Vita malta",
            "priority": "P3",
            "created_at": "15/01/2026 13:33:28",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 13:33:28"
          },
          {
            "ticket_id": 6044,
            "ticket_number": "356036",
            "title": "Re:[## 29163 ##] GBN-88146 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "15/01/2026 13:33:30",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 17:21:00"
          },
          {
            "ticket_id": 6046,
            "ticket_number": "356038",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/01/2026 13:33:42",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:33:42"
          },
          {
            "ticket_id": 6047,
            "ticket_number": "356039",
            "title": "Faturas Pendentes: FA 2147886784",
            "priority": "P2",
            "created_at": "15/01/2026 13:33:45",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:51:25"
          },
          {
            "ticket_id": 6048,
            "ticket_number": "356040",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "15/01/2026 13:33:48",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 17:21:00"
          },
          {
            "ticket_id": 6055,
            "ticket_number": "356047",
            "title": "Fwd: Informações da reserva TTN-1198620745#9019903",
            "priority": "P2",
            "created_at": "15/01/2026 15:35:12",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 15:35:12"
          },
          {
            "ticket_id": 6056,
            "ticket_number": "356048",
            "title": "Fwd: Informações sobre a sua reserva TTN-123111113",
            "priority": "P2",
            "created_at": "15/01/2026 15:35:14",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 15:35:15"
          },
          {
            "ticket_id": 6057,
            "ticket_number": "356049",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "P2",
            "created_at": "15/01/2026 15:35:20",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 15:35:20"
          },
          {
            "ticket_id": 6058,
            "ticket_number": "356050",
            "title": "Fwd: Ya puede facturar online para su vuelo a Amst",
            "priority": "P2",
            "created_at": "15/01/2026 15:35:24",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 15:35:25"
          },
          {
            "ticket_id": 6060,
            "ticket_number": "356052",
            "title": "Catai - Orçamento / Viagem_CBR_TAilandia",
            "priority": "P3",
            "created_at": "15/01/2026 16:23:14",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 28.8,
            "sla_met": false,
            "sla_breach_hours": 4.8,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 21:12:05"
          },
          {
            "ticket_id": 6062,
            "ticket_number": "356054",
            "title": "Re:[## 29284 ##] GBN-98037 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "15/01/2026 16:23:19",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:13:49"
          },
          {
            "ticket_id": 6066,
            "ticket_number": "356058",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "P2",
            "created_at": "15/01/2026 16:40:24",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 16:40:24"
          },
          {
            "ticket_id": 6070,
            "ticket_number": "356062",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:07",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:23:02"
          },
          {
            "ticket_id": 6071,
            "ticket_number": "356063",
            "title": "GBN-99098 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:10",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:15:23"
          },
          {
            "ticket_id": 6073,
            "ticket_number": "356065",
            "title": "GBN-99069 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:17",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:15:49"
          },
          {
            "ticket_id": 6076,
            "ticket_number": "356068",
            "title": "Re:[## 29057 ##] GBN-88141 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "15/01/2026 17:54:15",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 21:23:38"
          },
          {
            "ticket_id": 6080,
            "ticket_number": "356072",
            "title": "Fwd: Request received for Tania Seixas/500milcoisa",
            "priority": "P2",
            "created_at": "15/01/2026 18:23:00",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:23:00"
          },
          {
            "ticket_id": 6086,
            "ticket_number": "356078",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "15/01/2026 18:39:51",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:16:32"
          },
          {
            "ticket_id": 6087,
            "ticket_number": "356079",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "15/01/2026 18:39:53",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:16:36"
          },
          {
            "ticket_id": 6089,
            "ticket_number": "356081",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/01/2026 19:51:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 19:51:26"
          },
          {
            "ticket_id": 6090,
            "ticket_number": "356082",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/01/2026 19:51:31",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 19:51:31"
          },
          {
            "ticket_id": 6091,
            "ticket_number": "356083",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/01/2026 19:51:41",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 19:51:41"
          },
          {
            "ticket_id": 6092,
            "ticket_number": "356084",
            "title": "Envio de Documentação * File 412548",
            "priority": "P2",
            "created_at": "15/01/2026 19:51:47",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 21:19:53"
          },
          {
            "ticket_id": 6096,
            "ticket_number": "356088",
            "title": "Número de informação da reserva: 6126871",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 21:18:09",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 22:41:07"
          },
          {
            "ticket_id": 6101,
            "ticket_number": "356093",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 22:33:54",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 22:33:54"
          },
          {
            "ticket_id": 6102,
            "ticket_number": "356094",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 22:34:32",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 22:34:32"
          },
          {
            "ticket_id": 6107,
            "ticket_number": "356099",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604524385",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 23:18:11",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 16.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 16:07:24"
          },
          {
            "ticket_id": 6108,
            "ticket_number": "356100",
            "title": "Número de informação da reserva: 6126890",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 23:28:07",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 180.68,
            "sla_met": false,
            "sla_breach_hours": 156.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 12:09:12"
          },
          {
            "ticket_id": 6109,
            "ticket_number": "356101",
            "title": "GBN-99221 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/01/2026 23:35:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 23:35:00"
          },
          {
            "ticket_id": 6112,
            "ticket_number": "356104",
            "title": "Correção erro ortografico apelido - GBN 99221",
            "priority": "P2",
            "created_at": "15/01/2026 23:40:21",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 23:40:21"
          },
          {
            "ticket_id": 6113,
            "ticket_number": "356105",
            "title": "GBN-99221 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/01/2026 23:44:03",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 20.52,
            "sla_met": false,
            "sla_breach_hours": 16.52,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:15:58"
          },
          {
            "ticket_id": 6114,
            "ticket_number": "356106",
            "title": "GBN-99223 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 23:44:06",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 23:44:06"
          },
          {
            "ticket_id": 6117,
            "ticket_number": "356109",
            "title": "GBN-99224 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "15/01/2026 23:52:04",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 23:52:04"
          },
          {
            "ticket_id": 6118,
            "ticket_number": "356110",
            "title": "GBN-99226 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/01/2026 23:52:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/01/2026 23:52:07"
          },
          {
            "ticket_id": 6122,
            "ticket_number": "356114",
            "title": "Número de informação da reserva: 6126895",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/01/2026 23:57:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 827.78,
            "sla_met": false,
            "sla_breach_hours": 803.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:06"
          },
          {
            "ticket_id": 6126,
            "ticket_number": "356118",
            "title": "Fwd: Viagify informa sobre a sua reserva 123572492",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 10:13:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 10:13:10"
          },
          {
            "ticket_id": 6129,
            "ticket_number": "356121",
            "title": "Fwd: MELIA PRO | Procedimento de Registo",
            "priority": "P2",
            "created_at": "16/01/2026 10:13:23",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:13:24"
          },
          {
            "ticket_id": 6145,
            "ticket_number": "356137",
            "title": "Reserva pagada",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 10:14:20",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 8.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 19:08:51"
          },
          {
            "ticket_id": 6147,
            "ticket_number": "356139",
            "title": "GBN-99229 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 10:14:57",
            "close_date": "2026-01-18",
            "sla_target_hours": 24,
            "actual_time_hours": 27.72,
            "sla_met": false,
            "sla_breach_hours": 3.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 13:58:25"
          },
          {
            "ticket_id": 6149,
            "ticket_number": "356141",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "P2",
            "created_at": "16/01/2026 10:20:14",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 5.6,
            "sla_met": false,
            "sla_breach_hours": 1.6,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 15:56:27"
          },
          {
            "ticket_id": 6150,
            "ticket_number": "356142",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "16/01/2026 10:20:16",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 12:46:06"
          },
          {
            "ticket_id": 6152,
            "ticket_number": "356144",
            "title": "Confirmação de reserva com localizador: 4033781",
            "priority": "P2",
            "created_at": "16/01/2026 10:20:19",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:20:19"
          },
          {
            "ticket_id": 6162,
            "ticket_number": "356154",
            "title": "Cotação soltropico Albina",
            "priority": "P2",
            "created_at": "16/01/2026 11:23:51",
            "close_date": "2026-02-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:23:51"
          },
          {
            "ticket_id": 6164,
            "ticket_number": "356156",
            "title": "URGENTE | Viajartours | Cotação Grupo | Confirmaçã",
            "priority": "P2",
            "created_at": "16/01/2026 11:23:56",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 11:23:56"
          },
          {
            "ticket_id": 6165,
            "ticket_number": "356157",
            "title": "Confirmation of booking with locator2TUEPWDH",
            "priority": "P2",
            "created_at": "16/01/2026 11:29:45",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 15:22:53"
          },
          {
            "ticket_id": 6167,
            "ticket_number": "356159",
            "title": "GBN-99213 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 11:40:17",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 11:40:23"
          },
          {
            "ticket_id": 6168,
            "ticket_number": "356160",
            "title": "GBN-99213 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 11:40:23",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 11:40:23"
          },
          {
            "ticket_id": 6169,
            "ticket_number": "356161",
            "title": "Duvida | Costa Norte Egito | Utilização de piscina",
            "priority": "P2",
            "created_at": "16/01/2026 12:39:25",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 12:39:26"
          },
          {
            "ticket_id": 6170,
            "ticket_number": "356162",
            "title": "Fwd: Viagify informa sobre a sua reserva 123582275",
            "priority": "P2",
            "created_at": "16/01/2026 12:39:28",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 12:39:29"
          },
          {
            "ticket_id": 6176,
            "ticket_number": "356168",
            "title": "Confirmação de reserva – Ref PP229197, Sra. Soraia",
            "priority": "P2",
            "created_at": "16/01/2026 12:39:51",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 6.05,
            "sla_met": false,
            "sla_breach_hours": 2.05,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 18:43:39"
          },
          {
            "ticket_id": 6186,
            "ticket_number": "356178",
            "title": "Confirmacao 336898",
            "priority": "P2",
            "created_at": "16/01/2026 13:38:39",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 5.1,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 18:45:04"
          },
          {
            "ticket_id": 6187,
            "ticket_number": "356179",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604524870",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 13:38:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 814.1,
            "sla_met": false,
            "sla_breach_hours": 790.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:06"
          },
          {
            "ticket_id": 6188,
            "ticket_number": "356180",
            "title": "Criação de processo File 424453/26",
            "priority": "P2",
            "created_at": "16/01/2026 13:38:47",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 5.12,
            "sla_met": false,
            "sla_breach_hours": 1.12,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 18:46:19"
          },
          {
            "ticket_id": 6189,
            "ticket_number": "356181",
            "title": "Envio de Fatura 209286",
            "priority": "P2",
            "created_at": "16/01/2026 13:38:48",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 5.77,
            "sla_met": false,
            "sla_breach_hours": 1.77,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:25:28"
          },
          {
            "ticket_id": 6190,
            "ticket_number": "356182",
            "title": "Número de informação da reserva: 6126963",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 13:38:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 814.1,
            "sla_met": false,
            "sla_breach_hours": 790.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:45:06"
          },
          {
            "ticket_id": 6194,
            "ticket_number": "356186",
            "title": "Confirmação de reserva. Localizador: 26ZEO6TZRL",
            "priority": "P2",
            "created_at": "16/01/2026 14:32:26",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 18:23:06"
          },
          {
            "ticket_id": 6201,
            "ticket_number": "356193",
            "title": "Confirmação de Reserva * File 424156 *TL 16/01/202",
            "priority": "P2",
            "created_at": "16/01/2026 15:08:15",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:03:10"
          },
          {
            "ticket_id": 6212,
            "ticket_number": "356204",
            "title": "Reserva para o fim de semana ( 17 e 18 de Janeiro)",
            "priority": "P2",
            "created_at": "16/01/2026 17:06:41",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 17:06:41"
          },
          {
            "ticket_id": 6215,
            "ticket_number": "356207",
            "title": "GBN-99414 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 18:36:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 163.62,
            "sla_met": false,
            "sla_breach_hours": 139.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 14:13:31"
          },
          {
            "ticket_id": 6216,
            "ticket_number": "356208",
            "title": "[Solicitação Recebida / Request Received]",
            "priority": "P2",
            "created_at": "16/01/2026 18:36:14",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:27:01"
          },
          {
            "ticket_id": 6217,
            "ticket_number": "356209",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/01/2026 19:12:15",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:12:15"
          },
          {
            "ticket_id": 6218,
            "ticket_number": "356210",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/01/2026 19:12:24",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:12:24"
          },
          {
            "ticket_id": 6219,
            "ticket_number": "356211",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 19:12:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 19:12:29"
          },
          {
            "ticket_id": 6220,
            "ticket_number": "356212",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/01/2026 19:12:40",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:12:40"
          },
          {
            "ticket_id": 6222,
            "ticket_number": "356214",
            "title": "URGENTE RESERVA 336884",
            "priority": "P2",
            "created_at": "16/01/2026 19:31:45",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 19:34:51"
          },
          {
            "ticket_id": 6226,
            "ticket_number": "356218",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1236075654#90",
            "priority": "P2",
            "created_at": "16/01/2026 20:19:35",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:19:35"
          },
          {
            "ticket_id": 6227,
            "ticket_number": "356219",
            "title": "Confirmacao 336985",
            "priority": "P3",
            "created_at": "16/01/2026 20:19:37",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 596.53,
            "sla_met": false,
            "sla_breach_hours": 572.53,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 16:52:15"
          },
          {
            "ticket_id": 6228,
            "ticket_number": "356220",
            "title": "Fwd: Viagify informa sobre a sua reserva 123612404",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 20:19:39",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 20:19:40"
          },
          {
            "ticket_id": 6229,
            "ticket_number": "356221",
            "title": "GBN-99443 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 20:19:46",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 20:19:46"
          },
          {
            "ticket_id": 6230,
            "ticket_number": "356222",
            "title": "Orçamento 1236088284 Smy ",
            "priority": "P2",
            "created_at": "16/01/2026 20:19:51",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:19:52"
          },
          {
            "ticket_id": 6232,
            "ticket_number": "356224",
            "title": "Confirmacao 336983",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 20:19:56",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 20.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 17:05:55"
          },
          {
            "ticket_id": 6234,
            "ticket_number": "356226",
            "title": "inscrição webinar Smy Travel",
            "priority": "P2",
            "created_at": "16/01/2026 20:20:09",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:20:09"
          },
          {
            "ticket_id": 6235,
            "ticket_number": "356227",
            "title": "Inscrição webinar",
            "priority": "P2",
            "created_at": "16/01/2026 20:20:11",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:20:12"
          },
          {
            "ticket_id": 6236,
            "ticket_number": "356228",
            "title": "Información de reserva número: 6126894",
            "priority": "P3",
            "created_at": "16/01/2026 20:20:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 596.58,
            "sla_met": false,
            "sla_breach_hours": 572.58,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 16:56:27"
          },
          {
            "ticket_id": 6237,
            "ticket_number": "356229",
            "title": "CANCELAMENTO RESERVA TRAVELPLAN LOC 604521393",
            "priority": "P2",
            "created_at": "16/01/2026 20:28:39",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 20:28:39"
          },
          {
            "ticket_id": 6239,
            "ticket_number": "356231",
            "title": "Jupiter Algarve Hotel - Beach & Spa (Praia da Roch",
            "priority": "P3",
            "created_at": "16/01/2026 20:35:31",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 63.75,
            "sla_met": false,
            "sla_breach_hours": 39.75,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 12:20:50"
          },
          {
            "ticket_id": 6240,
            "ticket_number": "356232",
            "title": "Reserva NB 6126895",
            "priority": "P3",
            "created_at": "16/01/2026 22:47:02",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 22:47:02"
          },
          {
            "ticket_id": 6243,
            "ticket_number": "356235",
            "title": "Confirmacao 337003",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 22:47:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:41:03"
          },
          {
            "ticket_id": 6244,
            "ticket_number": "356236",
            "title": "Confirmacao 337002",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 22:47:10",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:41:03"
          },
          {
            "ticket_id": 6245,
            "ticket_number": "356237",
            "title": "Confirmacao 337005",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 22:47:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:41:03"
          },
          {
            "ticket_id": 6246,
            "ticket_number": "356238",
            "title": "Criação de processo File 424615/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 22:47:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:41:03"
          },
          {
            "ticket_id": 6247,
            "ticket_number": "356239",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604525587",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 23:30:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 58.65,
            "sla_met": false,
            "sla_breach_hours": 34.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 10:09:30"
          },
          {
            "ticket_id": 6249,
            "ticket_number": "356241",
            "title": "GBN-99476 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/01/2026 23:38:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 23:38:35"
          },
          {
            "ticket_id": 6252,
            "ticket_number": "356244",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 23:38:35",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 23:38:35"
          },
          {
            "ticket_id": 6254,
            "ticket_number": "356246",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "16/01/2026 23:43:34",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/01/2026 23:43:35"
          },
          {
            "ticket_id": 6255,
            "ticket_number": "356247",
            "title": "Barcadouro - Reserva",
            "priority": "P2",
            "created_at": "16/01/2026 23:56:21",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 23:56:21"
          },
          {
            "ticket_id": 6256,
            "ticket_number": "356248",
            "title": "upgrade de seguro e reserva soltrópico 337005",
            "priority": "P2",
            "created_at": "17/01/2026 00:10:03",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 00:10:04"
          },
          {
            "ticket_id": 6257,
            "ticket_number": "356249",
            "title": "GBN-99478 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 00:10:07",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 157.92,
            "sla_met": false,
            "sla_breach_hours": 133.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 14:05:14"
          },
          {
            "ticket_id": 6258,
            "ticket_number": "356250",
            "title": "Fwd: Viagify informa sobre a sua reserva 123623228",
            "priority": "P3",
            "created_at": "17/01/2026 10:08:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 10:08:02"
          },
          {
            "ticket_id": 6262,
            "ticket_number": "356254",
            "title": "Fwd: Viagify informa sobre a sua reserva 123621872",
            "priority": "P2",
            "created_at": "17/01/2026 10:08:16",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 10:08:16"
          },
          {
            "ticket_id": 6264,
            "ticket_number": "356256",
            "title": "GBN-99486 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 10:08:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 10:08:22"
          },
          {
            "ticket_id": 6265,
            "ticket_number": "356257",
            "title": "GBN-99487 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 10:08:25",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 10:08:25"
          },
          {
            "ticket_id": 6267,
            "ticket_number": "356259",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604525598",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 10:08:32",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 53.87,
            "sla_met": false,
            "sla_breach_hours": 29.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:01:13"
          },
          {
            "ticket_id": 6268,
            "ticket_number": "356260",
            "title": "Número de informação da reserva: 6127128",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 10:08:36",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 53.87,
            "sla_met": false,
            "sla_breach_hours": 29.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:01:13"
          },
          {
            "ticket_id": 6269,
            "ticket_number": "356261",
            "title": "Número de informação da reserva: 6127127",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 10:08:40",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 53.87,
            "sla_met": false,
            "sla_breach_hours": 29.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:01:13"
          },
          {
            "ticket_id": 6274,
            "ticket_number": "356266",
            "title": "Esclarecimento sobre check-out e serviços no dia d",
            "priority": "P2",
            "created_at": "17/01/2026 10:31:13",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 10:31:13"
          },
          {
            "ticket_id": 6275,
            "ticket_number": "356267",
            "title": "Esclarecimento sobre check-out e serviços no dia d",
            "priority": "P2",
            "created_at": "17/01/2026 10:46:53",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 10:46:53"
          },
          {
            "ticket_id": 6276,
            "ticket_number": "356268",
            "title": "Criação de processo File 424637/26",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 11:35:12",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 4.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 16:00:59"
          },
          {
            "ticket_id": 6277,
            "ticket_number": "356269",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802301476",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 11:52:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.82,
            "sla_met": false,
            "sla_breach_hours": 29.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 17:41:29"
          },
          {
            "ticket_id": 6278,
            "ticket_number": "356270",
            "title": "GBN-99490 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 11:52:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 11:52:29"
          },
          {
            "ticket_id": 6279,
            "ticket_number": "356271",
            "title": "GBN-99494 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 12:01:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 791.72,
            "sla_met": false,
            "sla_breach_hours": 767.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:37"
          },
          {
            "ticket_id": 6281,
            "ticket_number": "356273",
            "title": "Here's your booking summary",
            "priority": "P2",
            "created_at": "17/01/2026 12:26:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 13:00:27"
          },
          {
            "ticket_id": 6282,
            "ticket_number": "356274",
            "title": "- Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 13:58:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 789.77,
            "sla_met": false,
            "sla_breach_hours": 765.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:37"
          },
          {
            "ticket_id": 6283,
            "ticket_number": "356275",
            "title": "GBN-99517 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 13:58:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 789.77,
            "sla_met": false,
            "sla_breach_hours": 765.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:37"
          },
          {
            "ticket_id": 6284,
            "ticket_number": "356276",
            "title": "GBN-99229 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 13:58:25",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 15:59:26"
          },
          {
            "ticket_id": 6285,
            "ticket_number": "356277",
            "title": "Reserva Aérea XXZNS7",
            "priority": "P2",
            "created_at": "17/01/2026 15:12:27",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 15:26:38"
          },
          {
            "ticket_id": 6287,
            "ticket_number": "356279",
            "title": "Número de informação da reserva: 6127188",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 15:43:23",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 21:41:51"
          },
          {
            "ticket_id": 6288,
            "ticket_number": "356280",
            "title": "Confirmação reserva Bedsonline 164-10520866",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 16:32:55",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 53.8,
            "sla_met": false,
            "sla_breach_hours": 29.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 22:21:53"
          },
          {
            "ticket_id": 6289,
            "ticket_number": "356281",
            "title": "Fwd: Documentação da reserva TTN-1236218726#903744",
            "priority": "P2",
            "created_at": "17/01/2026 16:33:01",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 16:33:02"
          },
          {
            "ticket_id": 6290,
            "ticket_number": "356282",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "17/01/2026 16:33:04",
            "close_date": "2026-01-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 16:50:28"
          },
          {
            "ticket_id": 6292,
            "ticket_number": "356284",
            "title": "Confirmacao 337068",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 16:33:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.8,
            "sla_met": false,
            "sla_breach_hours": 29.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 22:21:53"
          },
          {
            "ticket_id": 6301,
            "ticket_number": "356293",
            "title": "Pedido LePlan (Loc: 604516386) | Hotel Cheyenne | ",
            "priority": "P2",
            "created_at": "17/01/2026 18:21:50",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 18:21:50"
          },
          {
            "ticket_id": 6302,
            "ticket_number": "356294",
            "title": "Fwd: Informações da reserva TTN-1236075654#9035359",
            "priority": "P2",
            "created_at": "17/01/2026 18:59:41",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 18:59:41"
          },
          {
            "ticket_id": 6303,
            "ticket_number": "356295",
            "title": "Fwd: Informações da reserva TTN-1236075654#9035359",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 18:59:43",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 18:59:44"
          },
          {
            "ticket_id": 6304,
            "ticket_number": "356296",
            "title": "Fwd: Informações da sua reserva TTN-1236218726#903",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/01/2026 19:00:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/01/2026 19:00:49"
          },
          {
            "ticket_id": 6307,
            "ticket_number": "356299",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 09:52:37",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 127.63,
            "sla_met": false,
            "sla_breach_hours": 103.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 17:30:37"
          },
          {
            "ticket_id": 6308,
            "ticket_number": "356300",
            "title": "GBN-99579 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/01/2026 09:52:40",
            "close_date": "2026-01-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 11:12:02"
          },
          {
            "ticket_id": 6313,
            "ticket_number": "356305",
            "title": "GBN-99584 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "18/01/2026 09:52:53",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/12/2025 16:40:43"
          },
          {
            "ticket_id": 6314,
            "ticket_number": "356306",
            "title": "Confirmação de reserva – Ref PP892402, Sra. Carla ",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 09:52:56",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 554.02,
            "sla_met": false,
            "sla_breach_hours": 530.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 11:53:59"
          },
          {
            "ticket_id": 6322,
            "ticket_number": "356314",
            "title": "Confirmação de reserva com localizador: 4036185",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 09:53:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 769.85,
            "sla_met": false,
            "sla_breach_hours": 745.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6323,
            "ticket_number": "356315",
            "title": "Confirmação de reserva com localizador: 4036187",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 09:53:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 769.85,
            "sla_met": false,
            "sla_breach_hours": 745.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6324,
            "ticket_number": "356316",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "18/01/2026 09:53:13",
            "close_date": "2026-01-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 11:16:11"
          },
          {
            "ticket_id": 6325,
            "ticket_number": "356317",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 09:53:16",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 127.27,
            "sla_met": false,
            "sla_breach_hours": 103.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 17:09:24"
          },
          {
            "ticket_id": 6326,
            "ticket_number": "356318",
            "title": "Número de informação da reserva: 6127246",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 09:53:19",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 85.52,
            "sla_met": false,
            "sla_breach_hours": 61.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 23:24:41"
          },
          {
            "ticket_id": 6327,
            "ticket_number": "356319",
            "title": "Número de informação da reserva: 6127231",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 09:53:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 769.85,
            "sla_met": false,
            "sla_breach_hours": 745.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6328,
            "ticket_number": "356320",
            "title": "Número de informação da reserva: 6127232",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 09:53:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 769.85,
            "sla_met": false,
            "sla_breach_hours": 745.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6329,
            "ticket_number": "356321",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/01/2026 09:53:32",
            "close_date": "2026-01-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 11:09:49"
          },
          {
            "ticket_id": 6330,
            "ticket_number": "356322",
            "title": "Número de informação da reserva: 6127240",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 09:53:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 769.85,
            "sla_met": false,
            "sla_breach_hours": 745.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6337,
            "ticket_number": "356329",
            "title": "Fwd: Viagify informa sobre a sua reserva 123657600",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 11:48:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/01/2026 11:48:25"
          },
          {
            "ticket_id": 6354,
            "ticket_number": "356346",
            "title": "Reserva de transfer em Marrakech (Aeroporto Marrak",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:36:23",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:23:22"
          },
          {
            "ticket_id": 6355,
            "ticket_number": "356347",
            "title": "GBN-99600 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:36:28",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/01/2026 17:36:28"
          },
          {
            "ticket_id": 6356,
            "ticket_number": "356348",
            "title": "Reserva de transfer em Marrakech (Marrakech Medina",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:36:32",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:23:22"
          },
          {
            "ticket_id": 6357,
            "ticket_number": "356349",
            "title": "Reserva de transfer em Marraquexe (Aeroporto Marra",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 17:36:36",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:23:22"
          },
          {
            "ticket_id": 6359,
            "ticket_number": "356351",
            "title": "Reserva de transfer em Marraquexe (Marrakech Medin",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:36:41",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:23:22"
          },
          {
            "ticket_id": 6361,
            "ticket_number": "356353",
            "title": "GBN-99607 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/01/2026 17:36:46",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 762.12,
            "sla_met": false,
            "sla_breach_hours": 738.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6364,
            "ticket_number": "356356",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604525945",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:52:29",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 48.83,
            "sla_met": false,
            "sla_breach_hours": 24.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:43:24"
          },
          {
            "ticket_id": 6365,
            "ticket_number": "356357",
            "title": "Reserva pagada",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 17:53:02",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 48.83,
            "sla_met": false,
            "sla_breach_hours": 24.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:43:24"
          },
          {
            "ticket_id": 6366,
            "ticket_number": "356358",
            "title": "Confirmação de reserva com localizador: 4036558",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 18:31:02",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 48.87,
            "sla_met": false,
            "sla_breach_hours": 24.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 19:23:35"
          },
          {
            "ticket_id": 6367,
            "ticket_number": "356359",
            "title": "Confirmación del Loc 9100678",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 18:31:03",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 48.87,
            "sla_met": false,
            "sla_breach_hours": 24.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 19:23:35"
          },
          {
            "ticket_id": 6369,
            "ticket_number": "356361",
            "title": "Criação de processo File 424766/26",
            "priority": "Reservas sem Formulário",
            "created_at": "18/01/2026 18:37:27",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 48.77,
            "sla_met": false,
            "sla_breach_hours": 24.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 19:23:35"
          },
          {
            "ticket_id": 6379,
            "ticket_number": "356371",
            "title": "Eticket - 66056946 - AM  07/02/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "19/01/2026 10:09:35",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 13:21:59"
          },
          {
            "ticket_id": 6380,
            "ticket_number": "356372",
            "title": "Eticket - 68952807 - AM  07/02/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "19/01/2026 10:09:41",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 13:22:19"
          },
          {
            "ticket_id": 6384,
            "ticket_number": "356376",
            "title": "Fwd: Viagify informa-te do teu orçamento 123689408",
            "priority": "P2",
            "created_at": "19/01/2026 10:09:54",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:09:55"
          },
          {
            "ticket_id": 6387,
            "ticket_number": "356379",
            "title": "Fwd: O seu voo para Washington é em breve | Faça u",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:04",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:05"
          },
          {
            "ticket_id": 6391,
            "ticket_number": "356383",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:16",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 13:22:35"
          },
          {
            "ticket_id": 6392,
            "ticket_number": "356384",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604525993",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 10:10:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 20:03:40"
          },
          {
            "ticket_id": 6400,
            "ticket_number": "356392",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:36",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:58"
          },
          {
            "ticket_id": 6401,
            "ticket_number": "356393",
            "title": "Confirmação de reserva para For PT004157 68952807",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:39",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:58"
          },
          {
            "ticket_id": 6404,
            "ticket_number": "356396",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:45",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:59"
          },
          {
            "ticket_id": 6405,
            "ticket_number": "356397",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:19",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 13:47:40"
          },
          {
            "ticket_id": 6408,
            "ticket_number": "356400",
            "title": "GBN-99626 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "19/01/2026 10:11:26",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:11:26"
          },
          {
            "ticket_id": 6410,
            "ticket_number": "356402",
            "title": "Confirmação de reserva. Localizador: 6NFTMCQI9G",
            "priority": "P3",
            "created_at": "19/01/2026 10:11:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:11:32"
          },
          {
            "ticket_id": 6411,
            "ticket_number": "356403",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "P3",
            "created_at": "19/01/2026 10:11:32",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 529.7,
            "sla_met": false,
            "sla_breach_hours": 505.7,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 11:54:23"
          },
          {
            "ticket_id": 6415,
            "ticket_number": "356407",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604525966",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 10:11:43",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:00:59"
          },
          {
            "ticket_id": 6420,
            "ticket_number": "356412",
            "title": "GBN-99632 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 10:14:38",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 10:14:38"
          },
          {
            "ticket_id": 6426,
            "ticket_number": "356418",
            "title": "Park Hotel Villa Grazioli: uma villa histórica par",
            "priority": "P2",
            "created_at": "19/01/2026 11:12:04",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:07:16"
          },
          {
            "ticket_id": 6442,
            "ticket_number": "356434",
            "title": "GBN-99689 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 12:32:55",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 95.72,
            "sla_met": false,
            "sla_breach_hours": 71.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 12:16:52"
          },
          {
            "ticket_id": 6446,
            "ticket_number": "356438",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 14:00:18",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:00:18"
          },
          {
            "ticket_id": 6447,
            "ticket_number": "356439",
            "title": "Fwd: Viagify informa sobre a sua reserva 123708830",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 14:00:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:00:22"
          },
          {
            "ticket_id": 6449,
            "ticket_number": "356441",
            "title": "GBN-88138 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 14:00:35",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 94.23,
            "sla_met": false,
            "sla_breach_hours": 70.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 12:15:04"
          },
          {
            "ticket_id": 6451,
            "ticket_number": "356443",
            "title": "GBN-99720 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/01/2026 14:00:39",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 17:43:16"
          },
          {
            "ticket_id": 6452,
            "ticket_number": "356444",
            "title": "Fwd: Viagify informa sobre a sua reserva 123709718",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 14:15:23",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 14:15:24"
          },
          {
            "ticket_id": 6454,
            "ticket_number": "356446",
            "title": "Número de informação da reserva: 6127515",
            "priority": "P3",
            "created_at": "19/01/2026 15:30:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 11:24:43"
          },
          {
            "ticket_id": 6456,
            "ticket_number": "356448",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:30:22",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:30:22"
          },
          {
            "ticket_id": 6458,
            "ticket_number": "356450",
            "title": "PUNTA CANA · POUPE hoje DESFRUTE amanhã",
            "priority": "P2",
            "created_at": "19/01/2026 15:30:29",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 16:41:09"
          },
          {
            "ticket_id": 6459,
            "ticket_number": "356451",
            "title": "GBN-99759 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:30:35",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:30:36"
          },
          {
            "ticket_id": 6461,
            "ticket_number": "356453",
            "title": "Criação de processo File 424887/26",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:30:46",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 11:24:43"
          },
          {
            "ticket_id": 6463,
            "ticket_number": "356455",
            "title": "Número de informação da reserva: 6127520",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:44:37",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 97.78,
            "sla_met": false,
            "sla_breach_hours": 73.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 17:31:57"
          },
          {
            "ticket_id": 6464,
            "ticket_number": "356456",
            "title": "Fwd: Viagify informa sobre a sua reserva 123708830",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 15:56:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:56:11"
          },
          {
            "ticket_id": 6465,
            "ticket_number": "356457",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:56:14",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:56:15"
          },
          {
            "ticket_id": 6466,
            "ticket_number": "356458",
            "title": "Fwd: Viagify informa sobre a sua reserva 123708830",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 15:56:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:56:20"
          },
          {
            "ticket_id": 6467,
            "ticket_number": "356459",
            "title": "Número de informação da reserva: 6127527",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 15:56:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 11:44:46"
          },
          {
            "ticket_id": 6468,
            "ticket_number": "356460",
            "title": "Fwd: Informações da sua reserva TTN-1237088309#904",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:56:27",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:56:28"
          },
          {
            "ticket_id": 6469,
            "ticket_number": "356461",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:56:31",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 15:56:32"
          },
          {
            "ticket_id": 6470,
            "ticket_number": "356462",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 15:57:42",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 11:44:46"
          },
          {
            "ticket_id": 6471,
            "ticket_number": "356463",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 16:51:30",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:51:30"
          },
          {
            "ticket_id": 6472,
            "ticket_number": "356464",
            "title": "Fwd: Viagify informa sobre a sua reserva 123717009",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 16:51:33",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:51:34"
          },
          {
            "ticket_id": 6474,
            "ticket_number": "356466",
            "title": "Fwd: Viagify informa sobre a sua reserva 123717009",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 16:51:41",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:51:43"
          },
          {
            "ticket_id": 6475,
            "ticket_number": "356467",
            "title": "GBN-99777 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 16:51:50",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:51:50"
          },
          {
            "ticket_id": 6483,
            "ticket_number": "356475",
            "title": "Criação de processo File 425012/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 19:16:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 736.45,
            "sla_met": false,
            "sla_breach_hours": 712.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6484,
            "ticket_number": "356476",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 19:16:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 736.45,
            "sla_met": false,
            "sla_breach_hours": 712.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:36"
          },
          {
            "ticket_id": 6485,
            "ticket_number": "356477",
            "title": "Confirmação de Reserva * File 424887",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 19:24:04",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 15:20:15"
          },
          {
            "ticket_id": 6486,
            "ticket_number": "356478",
            "title": "Criação de processo File 425020/26",
            "priority": "P3",
            "created_at": "19/01/2026 19:28:53",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 15:20:15"
          },
          {
            "ticket_id": 6487,
            "ticket_number": "356479",
            "title": "GBN-99745 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 19:28:55",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 15:20:15"
          },
          {
            "ticket_id": 6489,
            "ticket_number": "356481",
            "title": "Informação de reserva - SPT002601572357",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 20:27:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:20:23"
          },
          {
            "ticket_id": 6490,
            "ticket_number": "356482",
            "title": "Pedido de correçao",
            "priority": "P2",
            "created_at": "19/01/2026 20:27:07",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 20:27:07"
          },
          {
            "ticket_id": 6491,
            "ticket_number": "356483",
            "title": "Informação de reserva - SPT002601572369",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 20:36:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 735.13,
            "sla_met": false,
            "sla_breach_hours": 711.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6493,
            "ticket_number": "356485",
            "title": "Informação de reserva - SPT002601572371",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 20:41:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:40:24"
          },
          {
            "ticket_id": 6494,
            "ticket_number": "356486",
            "title": "Pedido de alteração de nr de telefone na reserva S",
            "priority": "P2",
            "created_at": "19/01/2026 20:59:10",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 20:59:10"
          },
          {
            "ticket_id": 6495,
            "ticket_number": "356487",
            "title": "Fwd: Nova Viagem #260100249 - Euforia Glam - Cance",
            "priority": "P2",
            "created_at": "19/01/2026 21:04:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 21:04:56"
          },
          {
            "ticket_id": 6497,
            "ticket_number": "356489",
            "title": "Fwd: Nova Viagem #260100250 - Euforia Glam- cancel",
            "priority": "P2",
            "created_at": "19/01/2026 21:19:04",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 21:19:04"
          },
          {
            "ticket_id": 6500,
            "ticket_number": "356492",
            "title": "Reserva Disney Solférias",
            "priority": "P2",
            "created_at": "19/01/2026 21:26:58",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 21:26:58"
          },
          {
            "ticket_id": 6501,
            "ticket_number": "356493",
            "title": "Número de informação da reserva: 6127693",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 21:31:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 17:20:30"
          },
          {
            "ticket_id": 6502,
            "ticket_number": "356494",
            "title": "Número de informação da reserva: 6127694",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 21:33:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 17:20:30"
          },
          {
            "ticket_id": 6508,
            "ticket_number": "356500",
            "title": "Criação de processo File   425056  /26",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 22:36:18",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 112.28,
            "sla_met": false,
            "sla_breach_hours": 88.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 14:53:37"
          },
          {
            "ticket_id": 6509,
            "ticket_number": "356501",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/01/2026 22:49:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 732.92,
            "sla_met": false,
            "sla_breach_hours": 708.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6510,
            "ticket_number": "356502",
            "title": "GBN-99921 - Reenviar informações sobre sua reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/01/2026 22:51:38",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 22:51:38"
          },
          {
            "ticket_id": 6511,
            "ticket_number": "356503",
            "title": "Pedido de esclarecimento - Capacidade de quarto | ",
            "priority": "P2",
            "created_at": "19/01/2026 22:58:26",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 22:58:26"
          },
          {
            "ticket_id": 6513,
            "ticket_number": "356505",
            "title": "Teste ticket",
            "priority": "P2",
            "created_at": "19/01/2026 23:56:25",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 23:56:26"
          },
          {
            "ticket_id": 6514,
            "ticket_number": "356506",
            "title": "Pedido de orçamento- Ajuda",
            "priority": "P2",
            "created_at": "19/01/2026 23:56:27",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 23:56:28"
          },
          {
            "ticket_id": 6516,
            "ticket_number": "356508",
            "title": "Fwd: Viagify informa sobre a sua reserva 123747504",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:07:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 10:07:47"
          },
          {
            "ticket_id": 6522,
            "ticket_number": "356514",
            "title": "A reserva A35307747 foi paga e confirmada",
            "priority": "P2",
            "created_at": "20/01/2026 10:09:38",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:45:48"
          },
          {
            "ticket_id": 6524,
            "ticket_number": "356516",
            "title": "Reserva Aérea Z6XVAU",
            "priority": "P2",
            "created_at": "20/01/2026 10:09:42",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:30:50"
          },
          {
            "ticket_id": 6527,
            "ticket_number": "356519",
            "title": "GBN-99935 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:10:56",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 10:12:09"
          },
          {
            "ticket_id": 6531,
            "ticket_number": "356523",
            "title": "Número de informação da reserva: 6127745",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:12:17",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 510.6,
            "sla_met": false,
            "sla_breach_hours": 486.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 16:49:06"
          },
          {
            "ticket_id": 6536,
            "ticket_number": "356528",
            "title": "Número de informação da reserva: 6127744",
            "priority": "P3",
            "created_at": "20/01/2026 10:12:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 510.33,
            "sla_met": false,
            "sla_breach_hours": 486.33,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 16:33:15"
          },
          {
            "ticket_id": 6537,
            "ticket_number": "356529",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604527341",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:12:31",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 721.53,
            "sla_met": false,
            "sla_breach_hours": 697.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6538,
            "ticket_number": "356530",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-99",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:12:37",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 10:12:37"
          },
          {
            "ticket_id": 6540,
            "ticket_number": "356532",
            "title": "Z6XVAU – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "20/01/2026 10:12:44",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:30:38"
          },
          {
            "ticket_id": 6541,
            "ticket_number": "356533",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:12:50",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 10:12:50"
          },
          {
            "ticket_id": 6544,
            "ticket_number": "356536",
            "title": "Confirmacao 337317",
            "priority": "P3",
            "created_at": "20/01/2026 10:14:00",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 540.08,
            "sla_met": false,
            "sla_breach_hours": 516.08,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 22:19:01"
          },
          {
            "ticket_id": 6545,
            "ticket_number": "356537",
            "title": "Z6XVAU – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "20/01/2026 10:14:02",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:30:08"
          },
          {
            "ticket_id": 6547,
            "ticket_number": "356539",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:14:06",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 102.15,
            "sla_met": false,
            "sla_breach_hours": 78.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 16:23:55"
          },
          {
            "ticket_id": 6548,
            "ticket_number": "356540",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (Z6X",
            "priority": "P2",
            "created_at": "20/01/2026 10:14:08",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:30:23"
          },
          {
            "ticket_id": 6549,
            "ticket_number": "356541",
            "title": "GBN-99942 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:14:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 721.5,
            "sla_met": false,
            "sla_breach_hours": 697.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6552,
            "ticket_number": "356544",
            "title": "Confirmação de reserva com localizador: 4038683",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:14:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 721.5,
            "sla_met": false,
            "sla_breach_hours": 697.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6553,
            "ticket_number": "356545",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "20/01/2026 10:18:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 510.0,
            "sla_met": false,
            "sla_breach_hours": 486.0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 16:18:50"
          },
          {
            "ticket_id": 6554,
            "ticket_number": "356546",
            "title": "Información de reserva número:",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:19:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 721.42,
            "sla_met": false,
            "sla_breach_hours": 697.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6556,
            "ticket_number": "356548",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:23:25",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 20:21:19"
          },
          {
            "ticket_id": 6560,
            "ticket_number": "356552",
            "title": "GBN-100203   - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 10:59:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 720.73,
            "sla_met": false,
            "sla_breach_hours": 696.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6561,
            "ticket_number": "356553",
            "title": "Reserva confirmada: Free tour por Havana - Civitat",
            "priority": "P3",
            "created_at": "20/01/2026 10:59:46",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 504.97,
            "sla_met": false,
            "sla_breach_hours": 480.97,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 11:57:55"
          },
          {
            "ticket_id": 6564,
            "ticket_number": "356556",
            "title": "Reserva confirmada: Free tour por Havana - Civitat",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:59:53",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 505.6,
            "sla_met": false,
            "sla_breach_hours": 481.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 12:35:59"
          },
          {
            "ticket_id": 6565,
            "ticket_number": "356557",
            "title": "Reserva confirmada: Free tour por Havana - Civitat",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:59:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 509.28,
            "sla_met": false,
            "sla_breach_hours": 485.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 16:17:54"
          },
          {
            "ticket_id": 6566,
            "ticket_number": "356558",
            "title": "Reserva confirmada: Free tour por Havana - Civitat",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 10:59:58",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 509.28,
            "sla_met": false,
            "sla_breach_hours": 485.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 16:17:39"
          },
          {
            "ticket_id": 6569,
            "ticket_number": "356561",
            "title": "Confirmação de reserva 337304 ### TIME LIMIT EMISS",
            "priority": "P3",
            "created_at": "20/01/2026 11:10:03",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 21:01:24"
          },
          {
            "ticket_id": 6570,
            "ticket_number": "356562",
            "title": "Reserva confirmada: Excursão a Saint Moritz + Bern",
            "priority": "P3",
            "created_at": "20/01/2026 11:22:42",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 21:21:28"
          },
          {
            "ticket_id": 6571,
            "ticket_number": "356563",
            "title": "Reserva confirmada: Excursão a Saint Moritz + Bern",
            "priority": "P3",
            "created_at": "20/01/2026 11:22:45",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 21:21:28"
          },
          {
            "ticket_id": 6572,
            "ticket_number": "356564",
            "title": "Reserva em WL 210452",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 11:31:15",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 21:21:28"
          },
          {
            "ticket_id": 6573,
            "ticket_number": "356565",
            "title": "GBN-99937 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 11:31:17",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 21:21:28"
          },
          {
            "ticket_id": 6575,
            "ticket_number": "356567",
            "title": "Re:[## 29151 ##] GBN-88570 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "20/01/2026 11:31:22",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:31:27"
          },
          {
            "ticket_id": 6580,
            "ticket_number": "356572",
            "title": "Confirmacao 337345",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 12:16:44",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 416.9,
            "sla_met": false,
            "sla_breach_hours": 392.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 21:11:09"
          },
          {
            "ticket_id": 6583,
            "ticket_number": "356575",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604527735",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 12:39:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 719.08,
            "sla_met": false,
            "sla_breach_hours": 695.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:35"
          },
          {
            "ticket_id": 6587,
            "ticket_number": "356579",
            "title": "Informação de reserva - SPT002601572357",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 14:29:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 414.7,
            "sla_met": false,
            "sla_breach_hours": 390.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 21:11:54"
          },
          {
            "ticket_id": 6594,
            "ticket_number": "356586",
            "title": "Información de reserva número: 1770234",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 14:41:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 559.67,
            "sla_met": false,
            "sla_breach_hours": 535.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 22:21:46"
          },
          {
            "ticket_id": 6595,
            "ticket_number": "356587",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 14:41:23",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 14:41:23"
          },
          {
            "ticket_id": 6597,
            "ticket_number": "356589",
            "title": "Fwd: Informações da sua reserva TTN-1236979294#904",
            "priority": "P2",
            "created_at": "20/01/2026 14:41:31",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 14:41:33"
          },
          {
            "ticket_id": 6598,
            "ticket_number": "356590",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 14:41:39",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 14:41:39"
          },
          {
            "ticket_id": 6599,
            "ticket_number": "356591",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "P3",
            "created_at": "20/01/2026 14:49:35",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 501.23,
            "sla_met": false,
            "sla_breach_hours": 477.23,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 12:03:45"
          },
          {
            "ticket_id": 6600,
            "ticket_number": "356592",
            "title": "Confirmação de reserva. Localizador: 1Q9OE255CI",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 14:49:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 716.9,
            "sla_met": false,
            "sla_breach_hours": 692.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6609,
            "ticket_number": "356601",
            "title": "GBN-100053 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 15:57:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 505.27,
            "sla_met": false,
            "sla_breach_hours": 481.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 17:13:32"
          },
          {
            "ticket_id": 6610,
            "ticket_number": "356602",
            "title": "GBN-100051 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 15:57:15",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 500.05,
            "sla_met": false,
            "sla_breach_hours": 476.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 12:00:22"
          },
          {
            "ticket_id": 6618,
            "ticket_number": "356610",
            "title": "Número de informação da reserva: 6127888",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 16:15:58",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 12:02:28"
          },
          {
            "ticket_id": 6620,
            "ticket_number": "356612",
            "title": "Número de informação da reserva: 6127890",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 16:32:33",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 12:22:30"
          },
          {
            "ticket_id": 6622,
            "ticket_number": "356614",
            "title": "Informação de reserva - SPT002601571772",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 17:03:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 13:02:38"
          },
          {
            "ticket_id": 6623,
            "ticket_number": "356615",
            "title": "Fwd: Preparado para partir para Paris - Orly?",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:16",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:03:17"
          },
          {
            "ticket_id": 6625,
            "ticket_number": "356617",
            "title": "FLEXIBLEAUTOS | Ofertas Especiais – 3ª Semana de J",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:22",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 18:59:31"
          },
          {
            "ticket_id": 6626,
            "ticket_number": "356618",
            "title": "Reserva pendente - Abreu",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:25",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:03:26"
          },
          {
            "ticket_id": 6627,
            "ticket_number": "356619",
            "title": "Fwd: RP9DPB | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:28",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:03:28"
          },
          {
            "ticket_id": 6628,
            "ticket_number": "356620",
            "title": "Re:[## 29660 ##] GBN-100053 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:32",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:03:32"
          },
          {
            "ticket_id": 6629,
            "ticket_number": "356621",
            "title": "Fwd: easyJet booking reference: KBXB2CN",
            "priority": "P3",
            "created_at": "20/01/2026 17:03:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:03:35"
          },
          {
            "ticket_id": 6631,
            "ticket_number": "356623",
            "title": "Fwd: Viagify informa sobre a sua reserva 123774150",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 17:03:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 17:03:43"
          },
          {
            "ticket_id": 6636,
            "ticket_number": "356628",
            "title": "Confirmação de reserva com localizador: 4039845",
            "priority": "P3",
            "created_at": "20/01/2026 17:13:26",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 13:02:38"
          },
          {
            "ticket_id": 6637,
            "ticket_number": "356629",
            "title": "Informação da bagagem",
            "priority": "P2",
            "created_at": "20/01/2026 17:37:47",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:37:47"
          },
          {
            "ticket_id": 6640,
            "ticket_number": "356632",
            "title": "Re:[## 29657 ##] GBN-99935 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "20/01/2026 17:37:57",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:50:59"
          },
          {
            "ticket_id": 6646,
            "ticket_number": "356638",
            "title": "Envio de documentos de File 424887 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "20/01/2026 18:05:35",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:28:01"
          },
          {
            "ticket_id": 6647,
            "ticket_number": "356639",
            "title": "Envio de Fatura 210360",
            "priority": "P2",
            "created_at": "20/01/2026 18:45:48",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:06:20"
          },
          {
            "ticket_id": 6649,
            "ticket_number": "356641",
            "title": "Fwd: Viagify informa sobre a sua reserva 123778850",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 18:45:56",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 18:45:56"
          },
          {
            "ticket_id": 6656,
            "ticket_number": "356648",
            "title": "Informação de reserva - SPT002601573103",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 19:59:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 711.75,
            "sla_met": false,
            "sla_breach_hours": 687.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6658,
            "ticket_number": "356650",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 19:59:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 711.75,
            "sla_met": false,
            "sla_breach_hours": 687.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6659,
            "ticket_number": "356651",
            "title": "Orcamento Soltropico Ilha do Sal",
            "priority": "P2",
            "created_at": "20/01/2026 20:20:40",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:20:40"
          },
          {
            "ticket_id": 6660,
            "ticket_number": "356652",
            "title": "Información de reserva número: 1770371",
            "priority": "P3",
            "created_at": "20/01/2026 20:24:26",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 16:23:03"
          },
          {
            "ticket_id": 6661,
            "ticket_number": "356653",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/01/2026 20:51:55",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:51:55"
          },
          {
            "ticket_id": 6662,
            "ticket_number": "356654",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 20:51:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 710.87,
            "sla_met": false,
            "sla_breach_hours": 686.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6663,
            "ticket_number": "356655",
            "title": "Fwd: Informações da reserva TTN-1220685395#9064208",
            "priority": "P2",
            "created_at": "20/01/2026 20:52:04",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:52:04"
          },
          {
            "ticket_id": 6664,
            "ticket_number": "356656",
            "title": "Fwd: Incidente de voo TTN-1220289635#90607512#T169",
            "priority": "P2",
            "created_at": "20/01/2026 20:52:08",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:52:10"
          },
          {
            "ticket_id": 6665,
            "ticket_number": "356657",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/01/2026 20:52:19",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:52:19"
          },
          {
            "ticket_id": 6666,
            "ticket_number": "356658",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/01/2026 20:53:00",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 20:53:00"
          },
          {
            "ticket_id": 6668,
            "ticket_number": "356660",
            "title": "PNR 334681",
            "priority": "P2",
            "created_at": "20/01/2026 21:38:37",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 21:38:38"
          },
          {
            "ticket_id": 6670,
            "ticket_number": "356662",
            "title": "Ofertas dias dos namorados",
            "priority": "P2",
            "created_at": "20/01/2026 22:06:24",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 22:06:24"
          },
          {
            "ticket_id": 6673,
            "ticket_number": "356665",
            "title": "GBN-100203 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 22:17:42",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 22:17:42"
          },
          {
            "ticket_id": 6675,
            "ticket_number": "356667",
            "title": "Confirmação de Reserva * File 424453",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/01/2026 22:34:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 709.17,
            "sla_met": false,
            "sla_breach_hours": 685.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6676,
            "ticket_number": "356668",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 22:35:00",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 22:35:01"
          },
          {
            "ticket_id": 6679,
            "ticket_number": "356671",
            "title": "GBN-100217 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "20/01/2026 23:31:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 23:31:55"
          },
          {
            "ticket_id": 6681,
            "ticket_number": "356673",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 23:48:10",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 23:48:10"
          },
          {
            "ticket_id": 6682,
            "ticket_number": "356674",
            "title": "Fwd: Viagify informa sobre a sua reserva 123803433",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 23:48:13",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 23:48:13"
          },
          {
            "ticket_id": 6683,
            "ticket_number": "356675",
            "title": "Fwd: Viagify informa sobre a sua reserva 123803433",
            "priority": "Reservas sem Formulário",
            "created_at": "20/01/2026 23:48:16",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/01/2026 23:48:16"
          },
          {
            "ticket_id": 6684,
            "ticket_number": "356676",
            "title": "Fwd: Viagify informa sobre a sua reserva 123803433",
            "priority": "P3",
            "created_at": "20/01/2026 23:48:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 23:48:20"
          },
          {
            "ticket_id": 6689,
            "ticket_number": "356681",
            "title": "Fwd: Viagify informa sobre a sua reserva 123804609",
            "priority": "P3",
            "created_at": "21/01/2026 13:45:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:45:59"
          },
          {
            "ticket_id": 6693,
            "ticket_number": "356685",
            "title": "Fwd: Informações da sua reserva TTN-1238034333#906",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:46:11",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 13:46:11"
          },
          {
            "ticket_id": 6694,
            "ticket_number": "356686",
            "title": "PROLONGAMENTO SEMANA DE CABO VERDE 🏖️ SAL E BOA VI",
            "priority": "P2",
            "created_at": "21/01/2026 13:46:13",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 13:54:22"
          },
          {
            "ticket_id": 6698,
            "ticket_number": "356690",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "21/01/2026 13:46:24",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 13:56:08"
          },
          {
            "ticket_id": 6699,
            "ticket_number": "356691",
            "title": "asunto",
            "priority": "P2",
            "created_at": "21/01/2026 13:46:26",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 13:56:53"
          },
          {
            "ticket_id": 6700,
            "ticket_number": "356692",
            "title": "GBN-100231 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 13:46:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 693.97,
            "sla_met": false,
            "sla_breach_hours": 669.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6701,
            "ticket_number": "356693",
            "title": "GBN-100229 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:46:32",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 478.37,
            "sla_met": false,
            "sla_breach_hours": 454.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 12:08:51"
          },
          {
            "ticket_id": 6702,
            "ticket_number": "356694",
            "title": "Número de informação da reserva: 6128032",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:46:35",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 23:44:03"
          },
          {
            "ticket_id": 6705,
            "ticket_number": "356697",
            "title": "Información de reserva número: 1770387",
            "priority": "P2",
            "created_at": "21/01/2026 13:46:45",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 14:01:05"
          },
          {
            "ticket_id": 6709,
            "ticket_number": "356701",
            "title": "Criação de processo File 425327/26",
            "priority": "P2",
            "created_at": "21/01/2026 13:47:00",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 14:04:13"
          },
          {
            "ticket_id": 6719,
            "ticket_number": "356711",
            "title": "Reserva confirmada: Tour de vinhedos e adegas pelo",
            "priority": "P3",
            "created_at": "21/01/2026 13:49:00",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 23:44:03"
          },
          {
            "ticket_id": 6721,
            "ticket_number": "356713",
            "title": "Reserva confirmada: Excursão a Aveiro e Costa Nova",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:49:04",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 393.52,
            "sla_met": false,
            "sla_breach_hours": 369.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:21:03"
          },
          {
            "ticket_id": 6723,
            "ticket_number": "356715",
            "title": "Reserva confirmada: Excursão a Aveiro e Costa Nova",
            "priority": "P3",
            "created_at": "21/01/2026 13:49:09",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:49:09"
          },
          {
            "ticket_id": 6724,
            "ticket_number": "356716",
            "title": "Reserva confirmada: Visita à vinícola Fonseca com ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 13:49:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 23:44:04"
          },
          {
            "ticket_id": 6726,
            "ticket_number": "356718",
            "title": "Reserva confirmada: Passeio de barco tradicional p",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:49:16",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 393.53,
            "sla_met": false,
            "sla_breach_hours": 369.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:21:29"
          },
          {
            "ticket_id": 6727,
            "ticket_number": "356719",
            "title": "Reserva confirmada: Visita à vinícola Fonseca com ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 13:49:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 23:44:04"
          },
          {
            "ticket_id": 6728,
            "ticket_number": "356720",
            "title": "Reserva confirmada: Passeio de barco tradicional p",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:49:21",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 13:49:21"
          },
          {
            "ticket_id": 6729,
            "ticket_number": "356721",
            "title": "Reserva confirmada: Tour de vinhedos e adegas pelo",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 13:49:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 23:44:04"
          },
          {
            "ticket_id": 6730,
            "ticket_number": "356722",
            "title": "GBN-100236 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:49:31",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 13:49:35"
          },
          {
            "ticket_id": 6731,
            "ticket_number": "356723",
            "title": "GBN-100236 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 13:49:35",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 10.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 23:59:04"
          },
          {
            "ticket_id": 6733,
            "ticket_number": "356725",
            "title": "Criação de processo File 425456/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 14:14:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 693.48,
            "sla_met": false,
            "sla_breach_hours": 669.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6734,
            "ticket_number": "356726",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 14:14:48",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 483.68,
            "sla_met": false,
            "sla_breach_hours": 459.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 17:56:05"
          },
          {
            "ticket_id": 6736,
            "ticket_number": "356728",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "21/01/2026 14:15:04",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 483.68,
            "sla_met": false,
            "sla_breach_hours": 459.68,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:56:29"
          },
          {
            "ticket_id": 6741,
            "ticket_number": "356733",
            "title": "Envio de Documentação Financeira",
            "priority": "P2",
            "created_at": "21/01/2026 15:21:45",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:20:55"
          },
          {
            "ticket_id": 6742,
            "ticket_number": "356734",
            "title": "Fwd: Viagify informa sobre a sua reserva 123825446",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 15:21:47",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 15:21:48"
          },
          {
            "ticket_id": 6743,
            "ticket_number": "356735",
            "title": "Fwd: Incidente de voo TTN-1233475025#90732264#T170",
            "priority": "P2",
            "created_at": "21/01/2026 15:21:51",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:21:52"
          },
          {
            "ticket_id": 6744,
            "ticket_number": "356736",
            "title": "Fwd: V6WPXH | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "21/01/2026 15:21:55",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:21:56"
          },
          {
            "ticket_id": 6745,
            "ticket_number": "356737",
            "title": "Fwd: Informações da reserva TTN-1220685395#9064208",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 15:21:59",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 15:22:00"
          },
          {
            "ticket_id": 6746,
            "ticket_number": "356738",
            "title": "Fwd: PNR information: XO4OCB",
            "priority": "P2",
            "created_at": "21/01/2026 15:22:03",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:22:03"
          },
          {
            "ticket_id": 6748,
            "ticket_number": "356740",
            "title": "Fwd: Confirmacion de la reserva Transavia: NEJ49T",
            "priority": "P2",
            "created_at": "21/01/2026 15:22:08",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:22:08"
          },
          {
            "ticket_id": 6749,
            "ticket_number": "356741",
            "title": "Fwd: Informações da reserva TTN-1220685395#9073209",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 15:22:12",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 15:22:14"
          },
          {
            "ticket_id": 6750,
            "ticket_number": "356742",
            "title": "Pedido de acessos Veturis",
            "priority": "P2",
            "created_at": "21/01/2026 15:22:16",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:22:16"
          },
          {
            "ticket_id": 6753,
            "ticket_number": "356745",
            "title": "Fwd: Informações da sua reserva TTN-1238170411#907",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 16:42:49",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:42:50"
          },
          {
            "ticket_id": 6754,
            "ticket_number": "356746",
            "title": "Cancelação da reserva com localizador 7YDWMG2R89",
            "priority": "P3",
            "created_at": "21/01/2026 16:42:51",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 12:40:02"
          },
          {
            "ticket_id": 6757,
            "ticket_number": "356749",
            "title": "Blue Monday- IBEROSTAR PRO - Extensão 24 Horas",
            "priority": "P2",
            "created_at": "21/01/2026 16:43:05",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:11:02"
          },
          {
            "ticket_id": 6760,
            "ticket_number": "356752",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604491711",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 16:43:13",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 12:40:02"
          },
          {
            "ticket_id": 6761,
            "ticket_number": "356753",
            "title": "Fwd: Informações da reserva TTN-1218445868#9062096",
            "priority": "P2",
            "created_at": "21/01/2026 16:43:17",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 16:43:18"
          },
          {
            "ticket_id": 6762,
            "ticket_number": "356754",
            "title": ":: CONTRASTES DO JAPÃO - PARTIDAS DE LISBOA OU POR",
            "priority": "P2",
            "created_at": "21/01/2026 16:43:21",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:12:19"
          },
          {
            "ticket_id": 6763,
            "ticket_number": "356755",
            "title": "Informação de reserva - SPT002601573655",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 16:43:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 20:41:21"
          },
          {
            "ticket_id": 6764,
            "ticket_number": "356756",
            "title": "Fwd: Viagify informa sobre a sua reserva 123828259",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 16:43:30",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:43:31"
          },
          {
            "ticket_id": 6765,
            "ticket_number": "356757",
            "title": "Fwd: Viagify informa sobre a sua reserva 123828259",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 16:43:34",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:43:35"
          },
          {
            "ticket_id": 6767,
            "ticket_number": "356759",
            "title": "GBN-100182 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 16:51:32",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 7.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 23:58:56"
          },
          {
            "ticket_id": 6768,
            "ticket_number": "356760",
            "title": "GBN-100182 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 16:51:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 16:51:35"
          },
          {
            "ticket_id": 6771,
            "ticket_number": "356763",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 17:11:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 690.53,
            "sla_met": false,
            "sla_breach_hours": 666.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:34"
          },
          {
            "ticket_id": 6772,
            "ticket_number": "356764",
            "title": "Nova Viagem #260100295 - Paula Sousa",
            "priority": "P2",
            "created_at": "21/01/2026 18:01:09",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:01:09"
          },
          {
            "ticket_id": 6773,
            "ticket_number": "356765",
            "title": "Nova Viagem #260100297 - Rosa dos Ventos",
            "priority": "P2",
            "created_at": "21/01/2026 18:01:11",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:01:11"
          },
          {
            "ticket_id": 6774,
            "ticket_number": "356766",
            "title": "Nova Viagem #260100296 - Rosa dos Ventos",
            "priority": "P2",
            "created_at": "21/01/2026 18:01:14",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:01:15"
          },
          {
            "ticket_id": 6776,
            "ticket_number": "356768",
            "title": "GBN-100416 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 18:03:58",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 18:03:58"
          },
          {
            "ticket_id": 6779,
            "ticket_number": "356771",
            "title": "Fwd: Viagify informa-te do teu or??amento 12383501",
            "priority": "P2",
            "created_at": "21/01/2026 18:14:58",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:14:59"
          },
          {
            "ticket_id": 6782,
            "ticket_number": "356774",
            "title": "Fwd: Viagify informa sobre a sua reserva 123833165",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 18:22:03",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 18:22:05"
          },
          {
            "ticket_id": 6783,
            "ticket_number": "356775",
            "title": "Fwd: Viagify informa sobre a sua reserva 123837213",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 18:22:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 18:22:08"
          },
          {
            "ticket_id": 6786,
            "ticket_number": "356778",
            "title": "GBN-100416",
            "priority": "P2",
            "created_at": "21/01/2026 18:28:08",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:28:08"
          },
          {
            "ticket_id": 6788,
            "ticket_number": "356780",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/01/2026 19:13:46",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:13:46"
          },
          {
            "ticket_id": 6789,
            "ticket_number": "356781",
            "title": "Cancelamento Reserva - Tour10 - 4030172",
            "priority": "P2",
            "created_at": "21/01/2026 19:13:49",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:13:51"
          },
          {
            "ticket_id": 6790,
            "ticket_number": "356782",
            "title": "Cancelamento Reserva - Tour10 - 3995882",
            "priority": "P2",
            "created_at": "21/01/2026 19:13:54",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:13:54"
          },
          {
            "ticket_id": 6792,
            "ticket_number": "356784",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 20:01:01",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 20:01:01"
          },
          {
            "ticket_id": 6794,
            "ticket_number": "356786",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 21:32:21",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 21:32:21"
          },
          {
            "ticket_id": 6795,
            "ticket_number": "356787",
            "title": "Reserva de lugares - GBN- 94424",
            "priority": "P2",
            "created_at": "21/01/2026 21:32:23",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 21:32:24"
          },
          {
            "ticket_id": 6796,
            "ticket_number": "356788",
            "title": "GBN-100499 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 21:32:32",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 21:32:32"
          },
          {
            "ticket_id": 6799,
            "ticket_number": "356791",
            "title": "Número de informação da reserva: 6128337",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 22:37:05",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 384.47,
            "sla_met": false,
            "sla_breach_hours": 360.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:05:23"
          },
          {
            "ticket_id": 6802,
            "ticket_number": "356794",
            "title": "Confirmación del Loc 9101898",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 22:37:09",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 384.45,
            "sla_met": false,
            "sla_breach_hours": 360.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:04:44"
          },
          {
            "ticket_id": 6806,
            "ticket_number": "356798",
            "title": "Criação de processo File 425629/26",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 22:57:48",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 66.77,
            "sla_met": false,
            "sla_breach_hours": 42.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 17:43:55"
          },
          {
            "ticket_id": 6808,
            "ticket_number": "356800",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 22:58:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 684.77,
            "sla_met": false,
            "sla_breach_hours": 660.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6809,
            "ticket_number": "356801",
            "title": "GBN-100480 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 23:10:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 19.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 19:00:51"
          },
          {
            "ticket_id": 6812,
            "ticket_number": "356804",
            "title": "Reserva confirmada: Noite no deserto de Agafay - C",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 23:54:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 19:40:56"
          },
          {
            "ticket_id": 6815,
            "ticket_number": "356807",
            "title": "GBN-100521 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 23:55:01",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 23:55:01"
          },
          {
            "ticket_id": 6816,
            "ticket_number": "356808",
            "title": "Reserva confirmada: Noite no deserto de Agafay - C",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 23:55:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 19:40:56"
          },
          {
            "ticket_id": 6819,
            "ticket_number": "356811",
            "title": "GBN-100528 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 23:55:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 683.82,
            "sla_met": false,
            "sla_breach_hours": 659.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6820,
            "ticket_number": "356812",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 23:55:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/01/2026 23:55:15"
          },
          {
            "ticket_id": 6821,
            "ticket_number": "356813",
            "title": "GBN-100529 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/01/2026 23:57:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 683.77,
            "sla_met": false,
            "sla_breach_hours": 659.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6823,
            "ticket_number": "356815",
            "title": "GBN-100531 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "22/01/2026 00:14:16",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 00:14:16"
          },
          {
            "ticket_id": 6824,
            "ticket_number": "356816",
            "title": "GBN-100530 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 00:14:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 683.5,
            "sla_met": false,
            "sla_breach_hours": 659.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6825,
            "ticket_number": "356817",
            "title": "Reminder * Reserva File 425077 * Deadline Hoje 13H",
            "priority": "P2",
            "created_at": "22/01/2026 10:15:16",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:29:49"
          },
          {
            "ticket_id": 6826,
            "ticket_number": "356818",
            "title": "FW: TARIFAS INDICATIVAS GRUPOS 2026 PORTUGAL E ESP",
            "priority": "P2",
            "created_at": "22/01/2026 10:15:35",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:30:12"
          },
          {
            "ticket_id": 6829,
            "ticket_number": "356821",
            "title": "PROLONGAMENTO SEMANA DE CABO VERDE 🏖️ SAL E BOA VI",
            "priority": "P2",
            "created_at": "22/01/2026 10:15:44",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:39:40"
          },
          {
            "ticket_id": 6832,
            "ticket_number": "356824",
            "title": "GBN-100539 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 10:15:57",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 673.47,
            "sla_met": false,
            "sla_breach_hours": 649.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6834,
            "ticket_number": "356826",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "22/01/2026 10:16:02",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:51:38"
          },
          {
            "ticket_id": 6839,
            "ticket_number": "356831",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "22/01/2026 10:16:18",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:57:02"
          },
          {
            "ticket_id": 6840,
            "ticket_number": "356832",
            "title": "Reserva confirmada: Excursão a Bruges - Civitatis.",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 10:16:21",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 372.75,
            "sla_met": false,
            "sla_breach_hours": 348.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:02:06"
          },
          {
            "ticket_id": 6841,
            "ticket_number": "356833",
            "title": "Reserva confirmada: Heineken Experience + Passeio ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 10:16:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 10:16:26"
          },
          {
            "ticket_id": 6842,
            "ticket_number": "356834",
            "title": "Reserva confirmada: Heineken Experience + Passeio ",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 10:16:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 372.43,
            "sla_met": false,
            "sla_breach_hours": 348.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:42:58"
          },
          {
            "ticket_id": 6843,
            "ticket_number": "356835",
            "title": "Confirmação de reserva – Ref PP294815, Sr. Luis Mi",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 10:16:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 673.47,
            "sla_met": false,
            "sla_breach_hours": 649.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6844,
            "ticket_number": "356836",
            "title": "Reserva confirmada: Visita guiada pelo Vaticano e ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 10:16:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 10:16:39"
          },
          {
            "ticket_id": 6846,
            "ticket_number": "356838",
            "title": "Reserva confirmada: Visita guiada pelo Vaticano e ",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 10:16:39",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 372.33,
            "sla_met": false,
            "sla_breach_hours": 348.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:37:38"
          },
          {
            "ticket_id": 6848,
            "ticket_number": "356840",
            "title": "Reserva confirmada: Excursão a Bruges - Civitatis.",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:16:44"
          },
          {
            "ticket_id": 6850,
            "ticket_number": "356842",
            "title": "Registos de reuniões: 21/01/2026 à(s) 2:44 PM WET",
            "priority": "P2",
            "created_at": "22/01/2026 10:16:49",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:57:39"
          },
          {
            "ticket_id": 6853,
            "ticket_number": "356845",
            "title": "GBN-100545 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 12:15:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 671.48,
            "sla_met": false,
            "sla_breach_hours": 647.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6858,
            "ticket_number": "356850",
            "title": "Confirmação de reserva. Localizador: 2ZHSEINCJN",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 12:26:35",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 131.35,
            "sla_met": false,
            "sla_breach_hours": 107.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:48:13"
          },
          {
            "ticket_id": 6863,
            "ticket_number": "356855",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 12:26:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 671.28,
            "sla_met": false,
            "sla_breach_hours": 647.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:33"
          },
          {
            "ticket_id": 6871,
            "ticket_number": "356863",
            "title": "GBN-100517 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 13:06:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 23:01:21"
          },
          {
            "ticket_id": 6873,
            "ticket_number": "356865",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "P3",
            "created_at": "22/01/2026 13:38:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 454.82,
            "sla_met": false,
            "sla_breach_hours": 430.82,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 12:28:28"
          },
          {
            "ticket_id": 6874,
            "ticket_number": "356866",
            "title": "FW: TARIFAS INDICATIVAS GRUPOS 2026 PORTUGAL E ESP",
            "priority": "P2",
            "created_at": "22/01/2026 13:55:41",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 14:42:07"
          },
          {
            "ticket_id": 6876,
            "ticket_number": "356868",
            "title": "Informação de reserva - SPT002601573103",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 13:55:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 23:41:23"
          },
          {
            "ticket_id": 6880,
            "ticket_number": "356872",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604530359",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 14:55:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 668.82,
            "sla_met": false,
            "sla_breach_hours": 644.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6881,
            "ticket_number": "356873",
            "title": "Reserva pagada",
            "priority": "P2",
            "created_at": "22/01/2026 14:55:20",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 16:32:18"
          },
          {
            "ticket_id": 6883,
            "ticket_number": "356875",
            "title": "Envio de documentos de File 425077 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "22/01/2026 15:03:56",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 16:24:41"
          },
          {
            "ticket_id": 6885,
            "ticket_number": "356877",
            "title": "Icárion - Singapura, Ubud & Bali - Feira Noivos - ",
            "priority": "P2",
            "created_at": "22/01/2026 15:19:27",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 17:33:09"
          },
          {
            "ticket_id": 6887,
            "ticket_number": "356879",
            "title": "Petición CnTravel 50005848",
            "priority": "P3",
            "created_at": "22/01/2026 15:19:32",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 4.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 19:29:12"
          },
          {
            "ticket_id": 6889,
            "ticket_number": "356881",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 16:20:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 16:20:59"
          },
          {
            "ticket_id": 6890,
            "ticket_number": "356882",
            "title": "Mensagem sobre a reserva 36578206 - Civitatis",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 16:55:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 666.82,
            "sla_met": false,
            "sla_breach_hours": 642.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6891,
            "ticket_number": "356883",
            "title": "GBN-100687 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 16:55:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 16:55:12"
          },
          {
            "ticket_id": 6893,
            "ticket_number": "356885",
            "title": "Icárion - condições de cancelamento/ pagamento",
            "priority": "P2",
            "created_at": "22/01/2026 16:55:20",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 16:55:20"
          },
          {
            "ticket_id": 6894,
            "ticket_number": "356886",
            "title": "Confirmação de reserva * File 425456",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 16:55:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 365.6,
            "sla_met": false,
            "sla_breach_hours": 341.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:32:01"
          },
          {
            "ticket_id": 6897,
            "ticket_number": "356889",
            "title": "Informação de reserva - SPT002601574519",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 17:06:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 666.62,
            "sla_met": false,
            "sla_breach_hours": 642.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6898,
            "ticket_number": "356890",
            "title": "Confirmação de Reserva * File 425327",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 17:35:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 126.08,
            "sla_met": false,
            "sla_breach_hours": 102.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:40:22"
          },
          {
            "ticket_id": 6899,
            "ticket_number": "356891",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 17:36:50",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 17:36:50"
          },
          {
            "ticket_id": 6902,
            "ticket_number": "356894",
            "title": "GBN-100710 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 17:49:31",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 17:49:31"
          },
          {
            "ticket_id": 6905,
            "ticket_number": "356897",
            "title": "GBN-100710",
            "priority": "P2",
            "created_at": "22/01/2026 18:36:11",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 18:36:12"
          },
          {
            "ticket_id": 6906,
            "ticket_number": "356898",
            "title": "Criação de processo File 425894/26",
            "priority": "P2",
            "created_at": "22/01/2026 18:36:20",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 2.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:51:13"
          },
          {
            "ticket_id": 6908,
            "ticket_number": "356900",
            "title": "Número de informação da reserva: 6128553",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 18:40:47",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 363.88,
            "sla_met": false,
            "sla_breach_hours": 339.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:33:54"
          },
          {
            "ticket_id": 6910,
            "ticket_number": "356902",
            "title": "Fwd: Viagify informa sobre a sua reserva 123889071",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 19:20:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 19:20:28"
          },
          {
            "ticket_id": 6911,
            "ticket_number": "356903",
            "title": "Boas escolhas começam com bons preços!",
            "priority": "P2",
            "created_at": "22/01/2026 19:20:32",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:52:19"
          },
          {
            "ticket_id": 6913,
            "ticket_number": "356905",
            "title": "Número de informação da reserva: 6128565",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 19:20:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 664.38,
            "sla_met": false,
            "sla_breach_hours": 640.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6914,
            "ticket_number": "356906",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "22/01/2026 19:20:48",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:52:58"
          },
          {
            "ticket_id": 6915,
            "ticket_number": "356907",
            "title": "Condições de cancelamento ICARION",
            "priority": "P2",
            "created_at": "22/01/2026 19:20:52",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 19:20:53"
          },
          {
            "ticket_id": 6916,
            "ticket_number": "356908",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 19:21:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 664.38,
            "sla_met": false,
            "sla_breach_hours": 640.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6917,
            "ticket_number": "356909",
            "title": "Pagamento da reserva – Ref PP189225, Sr. Joao Ribe",
            "priority": "P2",
            "created_at": "22/01/2026 19:21:10",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 4.98,
            "sla_met": false,
            "sla_breach_hours": 0.98,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 00:20:49"
          },
          {
            "ticket_id": 6918,
            "ticket_number": "356910",
            "title": "Condições de cancelamento ICARION",
            "priority": "P2",
            "created_at": "22/01/2026 19:21:15",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 19:21:15"
          },
          {
            "ticket_id": 6919,
            "ticket_number": "356911",
            "title": "GBN-100480 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/01/2026 19:21:21",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 19:21:25"
          },
          {
            "ticket_id": 6921,
            "ticket_number": "356913",
            "title": "Número de informação da reserva: 6128558",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 19:21:30",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 124.28,
            "sla_met": false,
            "sla_breach_hours": 100.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:38:38"
          },
          {
            "ticket_id": 6922,
            "ticket_number": "356914",
            "title": "Número de informação da reserva: 6128555",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 19:21:36",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 124.27,
            "sla_met": false,
            "sla_breach_hours": 100.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:38:13"
          },
          {
            "ticket_id": 6926,
            "ticket_number": "356918",
            "title": "Reserva confirmada: Ingresso do Parque Warner - Ci",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 20:47:07",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 20:47:29"
          },
          {
            "ticket_id": 6928,
            "ticket_number": "356920",
            "title": "Reserva na Newblue",
            "priority": "P2",
            "created_at": "22/01/2026 20:47:13",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:47:13"
          },
          {
            "ticket_id": 6930,
            "ticket_number": "356922",
            "title": "alteração datas de viagem - LOV: 6127693 e 6127694",
            "priority": "P2",
            "created_at": "22/01/2026 20:47:22",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:47:23"
          },
          {
            "ticket_id": 6931,
            "ticket_number": "356923",
            "title": "Reserva confirmada: Ingresso do Parque Warner - Ci",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 20:47:29",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 122.82,
            "sla_met": false,
            "sla_breach_hours": 98.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:37:19"
          },
          {
            "ticket_id": 6932,
            "ticket_number": "356924",
            "title": "GBN-100680 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 21:00:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 662.73,
            "sla_met": false,
            "sla_breach_hours": 638.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6933,
            "ticket_number": "356925",
            "title": "Número de informação da reserva: 6128601",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 21:11:51",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 122.42,
            "sla_met": false,
            "sla_breach_hours": 98.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:36:57"
          },
          {
            "ticket_id": 6936,
            "ticket_number": "356928",
            "title": "Número de informação da reserva: 6128608",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 22:17:58",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 121.3,
            "sla_met": false,
            "sla_breach_hours": 97.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:36:31"
          },
          {
            "ticket_id": 6940,
            "ticket_number": "356932",
            "title": "Confirmação de reserva com localizador: 4044186",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 00:06:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 659.62,
            "sla_met": false,
            "sla_breach_hours": 635.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 6941,
            "ticket_number": "356933",
            "title": "GBN-100809 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 00:06:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 16.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 16:07:26"
          },
          {
            "ticket_id": 6944,
            "ticket_number": "356936",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 00:07:48",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 00:07:48"
          },
          {
            "ticket_id": 6946,
            "ticket_number": "356938",
            "title": "Reserva confirmada: Free tour por Havana - Civitat",
            "priority": "P3",
            "created_at": "23/01/2026 00:07:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 00:07:55"
          },
          {
            "ticket_id": 6959,
            "ticket_number": "356951",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "23/01/2026 10:06:03",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 11:02:42"
          },
          {
            "ticket_id": 6976,
            "ticket_number": "356968",
            "title": "Novos tours na Civitatis.com",
            "priority": "P2",
            "created_at": "23/01/2026 12:23:50",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 12:45:18"
          },
          {
            "ticket_id": 6988,
            "ticket_number": "356980",
            "title": "Número de informação da reserva: 6128736",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 13:35:13",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 105.97,
            "sla_met": false,
            "sla_breach_hours": 81.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:33:41"
          },
          {
            "ticket_id": 6992,
            "ticket_number": "356984",
            "title": "Referencia para pagamento | File:425983/2026",
            "priority": "P2",
            "created_at": "23/01/2026 14:56:06",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 15:27:54"
          },
          {
            "ticket_id": 7002,
            "ticket_number": "356994",
            "title": "GBN-100953 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 15:53:10",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 15:53:10"
          },
          {
            "ticket_id": 7003,
            "ticket_number": "356995",
            "title": "Signer signed: RGPD 2431800009.docx",
            "priority": "P2",
            "created_at": "23/01/2026 15:53:13",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 15:53:47"
          },
          {
            "ticket_id": 7004,
            "ticket_number": "356996",
            "title": "Envio de Fatura - File 425983/26",
            "priority": "P2",
            "created_at": "23/01/2026 16:03:58",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:39:42"
          },
          {
            "ticket_id": 7008,
            "ticket_number": "357000",
            "title": "Número de informação da reserva: 6128814",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 17:16:25",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 341.23,
            "sla_met": false,
            "sla_breach_hours": 317.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:31:14"
          },
          {
            "ticket_id": 7010,
            "ticket_number": "357002",
            "title": "Faça o download da sua fatura - Civitatis.com",
            "priority": "P2",
            "created_at": "23/01/2026 17:23:21",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 17:27:12"
          },
          {
            "ticket_id": 7011,
            "ticket_number": "357003",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "23/01/2026 17:23:28",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 17:23:28"
          },
          {
            "ticket_id": 7013,
            "ticket_number": "357005",
            "title": "Re:[## 29340 ##] GBN-98037 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "23/01/2026 17:23:37",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 23:40:18"
          },
          {
            "ticket_id": 7014,
            "ticket_number": "357006",
            "title": "GBN-99798 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/01/2026 17:23:43",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 17:23:43"
          },
          {
            "ticket_id": 7015,
            "ticket_number": "357007",
            "title": "GBN-101025 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 17:34:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 642.17,
            "sla_met": false,
            "sla_breach_hours": 618.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 7020,
            "ticket_number": "357012",
            "title": "Pedido orçamento",
            "priority": "P2",
            "created_at": "23/01/2026 18:06:53",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 18:06:53"
          },
          {
            "ticket_id": 7022,
            "ticket_number": "357014",
            "title": "A Tarifa Azul chegou às partidas do Funchal para a",
            "priority": "P2",
            "created_at": "23/01/2026 18:22:16",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 19:26:29"
          },
          {
            "ticket_id": 7023,
            "ticket_number": "357015",
            "title": "Nova Viagem #260100357 - Marta Tavares | LOCALIZAD",
            "priority": "P2",
            "created_at": "23/01/2026 18:22:20",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 18:22:20"
          },
          {
            "ticket_id": 7025,
            "ticket_number": "357017",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 18:22:35",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 18:22:35"
          },
          {
            "ticket_id": 7027,
            "ticket_number": "357019",
            "title": "IBEROSTAR CUBA",
            "priority": "P2",
            "created_at": "23/01/2026 18:57:18",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 19:32:50"
          },
          {
            "ticket_id": 7028,
            "ticket_number": "357020",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "23/01/2026 18:57:20",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 22:10:02"
          },
          {
            "ticket_id": 7029,
            "ticket_number": "357021",
            "title": "Acesso - Veturis",
            "priority": "P2",
            "created_at": "23/01/2026 19:19:34",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 19:19:35"
          },
          {
            "ticket_id": 7030,
            "ticket_number": "357022",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 19:43:29",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 19:43:29"
          },
          {
            "ticket_id": 7031,
            "ticket_number": "357023",
            "title": "Pagamento da reserva – Ref PP148127, Sr. Nuno Migu",
            "priority": "P2",
            "created_at": "23/01/2026 20:02:44",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 20:04:10"
          },
          {
            "ticket_id": 7033,
            "ticket_number": "357025",
            "title": "GBN-101091 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 20:02:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 20:02:59"
          },
          {
            "ticket_id": 7034,
            "ticket_number": "357026",
            "title": "Criação de processo File 426271/26",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 20:20:42",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 338.15,
            "sla_met": false,
            "sla_breach_hours": 314.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:30:16"
          },
          {
            "ticket_id": 7035,
            "ticket_number": "357027",
            "title": "GBN-101105 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 20:26:30",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 20:26:30"
          },
          {
            "ticket_id": 7036,
            "ticket_number": "357028",
            "title": "Número de informação da reserva: 6128946",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 21:08:11",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 13:02:07"
          },
          {
            "ticket_id": 7037,
            "ticket_number": "357029",
            "title": "Número de informação da reserva: 6128947",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 21:08:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 13:02:07"
          },
          {
            "ticket_id": 7038,
            "ticket_number": "357030",
            "title": "NB LOC 6128946 - Cancelamento",
            "priority": "P2",
            "created_at": "23/01/2026 21:08:15",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 21:08:16"
          },
          {
            "ticket_id": 7039,
            "ticket_number": "357031",
            "title": "Número de informação da reserva: 6128960",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 21:08:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 13:02:07"
          },
          {
            "ticket_id": 7041,
            "ticket_number": "357033",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 21:39:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 638.08,
            "sla_met": false,
            "sla_breach_hours": 614.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 7042,
            "ticket_number": "357034",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 21:39:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 638.08,
            "sla_met": false,
            "sla_breach_hours": 614.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:32"
          },
          {
            "ticket_id": 7043,
            "ticket_number": "357035",
            "title": "cancelamento de reserva  GBN 92646",
            "priority": "P2",
            "created_at": "23/01/2026 21:46:46",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 21:46:46"
          },
          {
            "ticket_id": 7048,
            "ticket_number": "357040",
            "title": "GBN-101127 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 22:29:32",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 637.23,
            "sla_met": false,
            "sla_breach_hours": 613.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7050,
            "ticket_number": "357042",
            "title": "Número de informação da reserva: 6128988",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 22:53:50",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 63.8,
            "sla_met": false,
            "sla_breach_hours": 39.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 14:42:19"
          },
          {
            "ticket_id": 7051,
            "ticket_number": "357043",
            "title": "Confirmation of booking with locatorI0LT4T9B",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 23:01:11",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 336.25,
            "sla_met": false,
            "sla_breach_hours": 312.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:16:18"
          },
          {
            "ticket_id": 7052,
            "ticket_number": "357044",
            "title": "Nova Viagem #260100366 - Sílvia Amaral Milheiro",
            "priority": "P2",
            "created_at": "23/01/2026 23:19:59",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 23:19:59"
          },
          {
            "ticket_id": 7054,
            "ticket_number": "357046",
            "title": "GBN-101135 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 23:22:10",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 23:22:10"
          },
          {
            "ticket_id": 7055,
            "ticket_number": "357047",
            "title": "[Pedido de Grupo] França - 2026-01-23 a 2026-01-28",
            "priority": "P2",
            "created_at": "23/01/2026 23:40:45",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 23:41:29"
          },
          {
            "ticket_id": 7056,
            "ticket_number": "357048",
            "title": "Fwd: Viagify informa sobre a sua reserva 123944141",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 00:01:35",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 00:01:36"
          },
          {
            "ticket_id": 7057,
            "ticket_number": "357049",
            "title": "Documentos para anexar em reserva",
            "priority": "P2",
            "created_at": "24/01/2026 00:01:38",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/01/2026 00:01:39"
          },
          {
            "ticket_id": 7060,
            "ticket_number": "357052",
            "title": "Meliá Braga Hotel & Spa",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 00:01:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 00:01:53"
          },
          {
            "ticket_id": 7062,
            "ticket_number": "357054",
            "title": "Fwd: Viagify informa sobre a sua reserva 123941381",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 00:02:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 00:02:02"
          },
          {
            "ticket_id": 7064,
            "ticket_number": "357056",
            "title": "[Pedido de Grupo] França - 2026-01-24 a 2026-01-27",
            "priority": "P2",
            "created_at": "24/01/2026 09:52:05",
            "close_date": "2026-01-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/01/2026 09:57:49"
          },
          {
            "ticket_id": 7067,
            "ticket_number": "357059",
            "title": "GBN-101091 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 09:59:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 625.75,
            "sla_met": false,
            "sla_breach_hours": 601.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7068,
            "ticket_number": "357060",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 09:59:27",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 6.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 16:26:46"
          },
          {
            "ticket_id": 7069,
            "ticket_number": "357061",
            "title": "GBN-101148 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 09:59:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 625.73,
            "sla_met": false,
            "sla_breach_hours": 601.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7073,
            "ticket_number": "357065",
            "title": "Confirmação de reserva. Localizador: 5B33S7CNM4",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 12:46:47",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 53.92,
            "sla_met": false,
            "sla_breach_hours": 29.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 18:42:46"
          },
          {
            "ticket_id": 7074,
            "ticket_number": "357066",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 5",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 12:46:50",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 53.92,
            "sla_met": false,
            "sla_breach_hours": 29.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 18:42:46"
          },
          {
            "ticket_id": 7075,
            "ticket_number": "357067",
            "title": "Número de informação da reserva: 6129033",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 12:46:54",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 53.92,
            "sla_met": false,
            "sla_breach_hours": 29.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 18:42:46"
          },
          {
            "ticket_id": 7076,
            "ticket_number": "357068",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 12:47:02",
            "close_date": "2026-01-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 12:47:02"
          },
          {
            "ticket_id": 7077,
            "ticket_number": "357069",
            "title": "Confirmacao 337907",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 12:47:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 622.95,
            "sla_met": false,
            "sla_breach_hours": 598.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7080,
            "ticket_number": "357072",
            "title": "Número de informação da reserva: 6129064",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 14:23:57",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 20:23:00"
          },
          {
            "ticket_id": 7083,
            "ticket_number": "357075",
            "title": "Confirmacao 337933",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 16:01:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 79.17,
            "sla_met": false,
            "sla_breach_hours": 55.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:12:03"
          },
          {
            "ticket_id": 7085,
            "ticket_number": "357077",
            "title": "GBN-101161 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 16:32:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 53.83,
            "sla_met": false,
            "sla_breach_hours": 29.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 22:23:14"
          },
          {
            "ticket_id": 7086,
            "ticket_number": "357078",
            "title": "Número de informação da reserva: 6129118",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 17:40:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 618.05,
            "sla_met": false,
            "sla_breach_hours": 594.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7087,
            "ticket_number": "357079",
            "title": "Confirmação de reserva para For PT004157 66593177",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 18:51:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 616.87,
            "sla_met": false,
            "sla_breach_hours": 592.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7088,
            "ticket_number": "357080",
            "title": "A36546197 - IMPORTANTE - Civitatis - Excursão a Sa",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 18:51:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 76.32,
            "sla_met": false,
            "sla_breach_hours": 52.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:10:51"
          },
          {
            "ticket_id": 7089,
            "ticket_number": "357081",
            "title": "Confirmação reserva Bedsonline 59-5712365",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 18:51:42",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 76.23,
            "sla_met": false,
            "sla_breach_hours": 52.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:05:50"
          },
          {
            "ticket_id": 7090,
            "ticket_number": "357082",
            "title": "Confirmação de reserva para For PT004157 66593177",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 18:51:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 616.87,
            "sla_met": false,
            "sla_breach_hours": 592.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7091,
            "ticket_number": "357083",
            "title": "GBN-101215 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 18:51:51",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 18:51:51"
          },
          {
            "ticket_id": 7092,
            "ticket_number": "357084",
            "title": "Confirmação de reserva para For PT004157 66593177",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/01/2026 18:51:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 616.87,
            "sla_met": false,
            "sla_breach_hours": 592.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7093,
            "ticket_number": "357085",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "24/01/2026 18:52:01",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/01/2026 18:52:01"
          },
          {
            "ticket_id": 7097,
            "ticket_number": "357089",
            "title": "Número de informação da reserva: 6129184",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:06:09",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.93,
            "sla_met": false,
            "sla_breach_hours": 12.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:02:44"
          },
          {
            "ticket_id": 7098,
            "ticket_number": "357090",
            "title": "Número de informação da reserva: 6129187",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:06:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.93,
            "sla_met": false,
            "sla_breach_hours": 12.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:02:18"
          },
          {
            "ticket_id": 7099,
            "ticket_number": "357091",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532631",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:06:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.63,
            "sla_met": false,
            "sla_breach_hours": 553.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7100,
            "ticket_number": "357092",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532626",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:06:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.63,
            "sla_met": false,
            "sla_breach_hours": 553.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7101,
            "ticket_number": "357093",
            "title": "Número de informação da reserva: 6129191",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:06:19",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.9,
            "sla_met": false,
            "sla_breach_hours": 12.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:01:07"
          },
          {
            "ticket_id": 7103,
            "ticket_number": "357095",
            "title": "Número de informação da reserva: 6129181",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:06:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.9,
            "sla_met": false,
            "sla_breach_hours": 12.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:00:41"
          },
          {
            "ticket_id": 7104,
            "ticket_number": "357096",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532618",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:06:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.63,
            "sla_met": false,
            "sla_breach_hours": 553.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7105,
            "ticket_number": "357097",
            "title": "GBN-101234 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:06:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.62,
            "sla_met": false,
            "sla_breach_hours": 553.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:31"
          },
          {
            "ticket_id": 7113,
            "ticket_number": "357105",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532653",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:08:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 11:02:50"
          },
          {
            "ticket_id": 7117,
            "ticket_number": "357109",
            "title": "GBN-101259 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "26/01/2026 10:08:56",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:08:56"
          },
          {
            "ticket_id": 7123,
            "ticket_number": "357115",
            "title": "Número de informação da reserva: 6129227",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:11:54",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.8,
            "sla_met": false,
            "sla_breach_hours": 12.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:00:18"
          },
          {
            "ticket_id": 7127,
            "ticket_number": "357119",
            "title": "Fwd: PRSTFS | Traz a mala certa",
            "priority": "P2",
            "created_at": "26/01/2026 10:12:44",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:12:45"
          },
          {
            "ticket_id": 7130,
            "ticket_number": "357122",
            "title": "Fwd: Viagify informa sobre a sua reserva 123959792",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:12:54",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 577.52,
            "sla_met": false,
            "sla_breach_hours": 553.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7131,
            "ticket_number": "357123",
            "title": "Fwd: Viagify informa sobre a sua reserva 123979669",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:12:58",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 10:12:59"
          },
          {
            "ticket_id": 7133,
            "ticket_number": "357125",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:13:09",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 27.75,
            "sla_met": false,
            "sla_breach_hours": 3.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:58:29"
          },
          {
            "ticket_id": 7135,
            "ticket_number": "357127",
            "title": "Fwd: Documentação da reserva TTN-1239597920#910360",
            "priority": "P2",
            "created_at": "26/01/2026 10:13:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:12:55"
          },
          {
            "ticket_id": 7136,
            "ticket_number": "357128",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "26/01/2026 10:13:18",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:13:18"
          },
          {
            "ticket_id": 7139,
            "ticket_number": "357131",
            "title": "Fwd: Viagify informa sobre a sua reserva 123946592",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:13:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 10:13:28"
          },
          {
            "ticket_id": 7141,
            "ticket_number": "357133",
            "title": "Número de informação da reserva: 6129242",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:14:05",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 277.05,
            "sla_met": false,
            "sla_breach_hours": 253.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:17:36"
          },
          {
            "ticket_id": 7143,
            "ticket_number": "357135",
            "title": "Número de informação da reserva: 6129257",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:14:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.48,
            "sla_met": false,
            "sla_breach_hours": 553.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7145,
            "ticket_number": "357137",
            "title": "Fwd: Online check-in here",
            "priority": "P2",
            "created_at": "26/01/2026 10:14:47",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:14:47"
          },
          {
            "ticket_id": 7146,
            "ticket_number": "357138",
            "title": "Fwd: Informações importantes antes da partida",
            "priority": "P2",
            "created_at": "26/01/2026 10:14:49",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:14:49"
          },
          {
            "ticket_id": 7147,
            "ticket_number": "357139",
            "title": "GBN-101276 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:15:22",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.68,
            "sla_met": false,
            "sla_breach_hours": 12.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:56:27"
          },
          {
            "ticket_id": 7148,
            "ticket_number": "357140",
            "title": "GBN-101276 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:15:28",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 10:15:28"
          },
          {
            "ticket_id": 7149,
            "ticket_number": "357141",
            "title": "Número de informação da reserva: 6129317",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:16:02",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 14:02:14"
          },
          {
            "ticket_id": 7155,
            "ticket_number": "357147",
            "title": "Confirmacao 337985",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:16:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 14:02:14"
          },
          {
            "ticket_id": 7156,
            "ticket_number": "357148",
            "title": "GBN-101294 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:16:55",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 10:16:55"
          },
          {
            "ticket_id": 7157,
            "ticket_number": "357149",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532920",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:17:29",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 27.62,
            "sla_met": false,
            "sla_breach_hours": 3.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:55:07"
          },
          {
            "ticket_id": 7158,
            "ticket_number": "357150",
            "title": "GBN-101298 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:17:32",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 577.43,
            "sla_met": false,
            "sla_breach_hours": 553.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7164,
            "ticket_number": "357156",
            "title": "GBN-101215 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:19:19",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 276.2,
            "sla_met": false,
            "sla_breach_hours": 252.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:31:21"
          },
          {
            "ticket_id": 7174,
            "ticket_number": "357166",
            "title": "RE: Pagamento 6027128",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:44",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:28:27"
          },
          {
            "ticket_id": 7175,
            "ticket_number": "357167",
            "title": "RE: Pagamento 6127129",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:46",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:28:53"
          },
          {
            "ticket_id": 7176,
            "ticket_number": "357168",
            "title": "RE: Pagamento 6127231",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:48",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:29:01"
          },
          {
            "ticket_id": 7178,
            "ticket_number": "357170",
            "title": "RE: Pagamento 6127127",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:53",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:27:40"
          },
          {
            "ticket_id": 7179,
            "ticket_number": "357171",
            "title": "ÚLTIMA OPORTUNIDADE - SEMANA DE CABO VERDE 🏖️ SAL ",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:26",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 5.73,
            "sla_met": false,
            "sla_breach_hours": 1.73,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:06:04"
          },
          {
            "ticket_id": 7181,
            "ticket_number": "357173",
            "title": "RE: Pagamento 6127232",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:30",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:26:32"
          },
          {
            "ticket_id": 7183,
            "ticket_number": "357175",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:33",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.23,
            "sla_met": false,
            "sla_breach_hours": 2.23,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:36:16"
          },
          {
            "ticket_id": 7184,
            "ticket_number": "357176",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:35",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.25,
            "sla_met": false,
            "sla_breach_hours": 2.25,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:36:37"
          },
          {
            "ticket_id": 7185,
            "ticket_number": "357177",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:36",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.25,
            "sla_met": false,
            "sla_breach_hours": 2.25,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:36:53"
          },
          {
            "ticket_id": 7186,
            "ticket_number": "357178",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "26/01/2026 10:21:38",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.25,
            "sla_met": false,
            "sla_breach_hours": 2.25,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:37:06"
          },
          {
            "ticket_id": 7193,
            "ticket_number": "357185",
            "title": "BAYAHIBE · POUPE hoje DESFRUTE amanhã",
            "priority": "P2",
            "created_at": "26/01/2026 11:32:52",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7196,
            "ticket_number": "357188",
            "title": "Confirmação de reserva 337870 ### TIME LIMIT PARA ",
            "priority": "P2",
            "created_at": "26/01/2026 11:32:58",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7206,
            "ticket_number": "357198",
            "title": "Información de reserva número:",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 12:25:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:20:24"
          },
          {
            "ticket_id": 7207,
            "ticket_number": "357199",
            "title": "Confirmação de reserva. Localizador: 81UTWBQCA6",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 12:25:05",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:20:24"
          },
          {
            "ticket_id": 7208,
            "ticket_number": "357200",
            "title": "Envio de Documentação * File 425894",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 12:25:13",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:20:24"
          },
          {
            "ticket_id": 7209,
            "ticket_number": "357201",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 12:25:15",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:20:24"
          },
          {
            "ticket_id": 7210,
            "ticket_number": "357202",
            "title": "Tarifa Azul tem partidas do Funchal para as Canári",
            "priority": "P2",
            "created_at": "26/01/2026 12:25:18",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:56:03"
          },
          {
            "ticket_id": 7217,
            "ticket_number": "357209",
            "title": "Confirmação de Reserva * File 426654*C/ SUPLEMENTO",
            "priority": "P2",
            "created_at": "26/01/2026 12:41:25",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 12:25:01"
          },
          {
            "ticket_id": 7221,
            "ticket_number": "357213",
            "title": "Fwd: Informação importante sobre o seu voo TP231",
            "priority": "P2",
            "created_at": "26/01/2026 13:32:00",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:32:00"
          },
          {
            "ticket_id": 7230,
            "ticket_number": "357222",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "26/01/2026 14:41:57",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:08:37"
          },
          {
            "ticket_id": 7235,
            "ticket_number": "357227",
            "title": "Aproveita os últimos dias do Blue Monday com até 5",
            "priority": "P2",
            "created_at": "26/01/2026 14:42:12",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:05:31"
          },
          {
            "ticket_id": 7247,
            "ticket_number": "357239",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 16:19:33",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 16:19:33"
          },
          {
            "ticket_id": 7248,
            "ticket_number": "357240",
            "title": "PEDIDO DE COTAÇAO DE HOTEL ",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:36",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:19:37"
          },
          {
            "ticket_id": 7250,
            "ticket_number": "357242",
            "title": "✨🎸 Rock in Rio Lisboa: viva a experiência com opçõ",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:44",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:49:55"
          },
          {
            "ticket_id": 7251,
            "ticket_number": "357243",
            "title": "Fwd: Viagify informa sobre a sua reserva 124032953",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:48",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:19:49"
          },
          {
            "ticket_id": 7254,
            "ticket_number": "357246",
            "title": "[Pedido de Grupo] França - 2026-01-27 a 2026-01-29",
            "priority": "P2",
            "created_at": "26/01/2026 16:27:35",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:05:33"
          },
          {
            "ticket_id": 7256,
            "ticket_number": "357248",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 17:08:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 570.6,
            "sla_met": false,
            "sla_breach_hours": 546.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7260,
            "ticket_number": "357252",
            "title": "Acesso ao fornecedor Veturis",
            "priority": "P2",
            "created_at": "26/01/2026 17:24:50",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:24:51"
          },
          {
            "ticket_id": 7263,
            "ticket_number": "357255",
            "title": "Reserva Veturis",
            "priority": "P2",
            "created_at": "26/01/2026 17:25:00",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:25:00"
          },
          {
            "ticket_id": 7265,
            "ticket_number": "357257",
            "title": "Orçamento de grupo",
            "priority": "P3",
            "created_at": "26/01/2026 18:03:47",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 18:03:48"
          },
          {
            "ticket_id": 7266,
            "ticket_number": "357258",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 18:45:35",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 19.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:53:17"
          },
          {
            "ticket_id": 7267,
            "ticket_number": "357259",
            "title": "Re:[## 30235 ##] GBN-101462 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "26/01/2026 18:45:38",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:45:38"
          },
          {
            "ticket_id": 7268,
            "ticket_number": "357260",
            "title": "Confirmação de reserva. Localizador: 2CQUYV9R8N",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 18:45:42",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 28.1,
            "sla_met": false,
            "sla_breach_hours": 4.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:52:34"
          },
          {
            "ticket_id": 7269,
            "ticket_number": "357261",
            "title": "GBN-101462 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 18:45:50",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 18:45:50"
          },
          {
            "ticket_id": 7270,
            "ticket_number": "357262",
            "title": "Documentação Disponível - Reserva 337291",
            "priority": "P2",
            "created_at": "26/01/2026 18:45:53",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:18:33"
          },
          {
            "ticket_id": 7271,
            "ticket_number": "357263",
            "title": "Documentação Disponível - Reserva 332769",
            "priority": "P2",
            "created_at": "26/01/2026 18:45:55",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:17:57"
          },
          {
            "ticket_id": 7272,
            "ticket_number": "357264",
            "title": "Documentação Disponível - Reserva 332773",
            "priority": "P2",
            "created_at": "26/01/2026 18:45:59",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:17:10"
          },
          {
            "ticket_id": 7274,
            "ticket_number": "357266",
            "title": "Documentação Disponível - Reserva 332768",
            "priority": "P2",
            "created_at": "26/01/2026 18:46:05",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:44:21"
          },
          {
            "ticket_id": 7275,
            "ticket_number": "357267",
            "title": "Fwd: Pedido de alteração de nome.",
            "priority": "P2",
            "created_at": "26/01/2026 18:46:07",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:46:07"
          },
          {
            "ticket_id": 7276,
            "ticket_number": "357268",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604534165",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 18:46:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 568.95,
            "sla_met": false,
            "sla_breach_hours": 544.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7277,
            "ticket_number": "357269",
            "title": "Plataforma Suporte",
            "priority": "P2",
            "created_at": "26/01/2026 18:57:39",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:57:39"
          },
          {
            "ticket_id": 7279,
            "ticket_number": "357271",
            "title": "GBN-101053 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/01/2026 20:04:44",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:17:37"
          },
          {
            "ticket_id": 7280,
            "ticket_number": "357272",
            "title": "Confirmacao 338126",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 20:04:47",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 17.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:52:09"
          },
          {
            "ticket_id": 7281,
            "ticket_number": "357273",
            "title": "Número de informação da reserva: 6129707",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 21:14:20",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 17:01:30"
          },
          {
            "ticket_id": 7282,
            "ticket_number": "357274",
            "title": "GBN-101620 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 21:35:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 566.15,
            "sla_met": false,
            "sla_breach_hours": 542.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7283,
            "ticket_number": "357275",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 21:41:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 566.03,
            "sla_met": false,
            "sla_breach_hours": 542.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7285,
            "ticket_number": "357277",
            "title": "Fwd: Documentação da reserva TTN-1231817620#912034",
            "priority": "P2",
            "created_at": "26/01/2026 22:16:44",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 22:16:44"
          },
          {
            "ticket_id": 7286,
            "ticket_number": "357278",
            "title": "Número de informação da reserva: 6129723",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 22:29:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 18:21:38"
          },
          {
            "ticket_id": 7289,
            "ticket_number": "357281",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 23:10:49",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 23:10:49"
          },
          {
            "ticket_id": 7290,
            "ticket_number": "357282",
            "title": "GBN-101631 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 23:10:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 564.55,
            "sla_met": false,
            "sla_breach_hours": 540.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7291,
            "ticket_number": "357283",
            "title": "-   GBN-101634  Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 23:26:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 564.28,
            "sla_met": false,
            "sla_breach_hours": 540.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7292,
            "ticket_number": "357284",
            "title": "Informação de reserva - SPT002601577518",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 23:27:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 19:21:49"
          },
          {
            "ticket_id": 7294,
            "ticket_number": "357286",
            "title": "Erro Reservas",
            "priority": "P2",
            "created_at": "26/01/2026 23:29:49",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 23:29:49"
          },
          {
            "ticket_id": 7295,
            "ticket_number": "357287",
            "title": "Reserva WL LOC 338138",
            "priority": "P3",
            "created_at": "26/01/2026 23:35:13",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 12.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 12:35:00"
          },
          {
            "ticket_id": 7297,
            "ticket_number": "357289",
            "title": "Número de informação da reserva: 6129737",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 23:35:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 564.13,
            "sla_met": false,
            "sla_breach_hours": 540.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:30"
          },
          {
            "ticket_id": 7298,
            "ticket_number": "357290",
            "title": "GBN-101634 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/01/2026 23:35:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 13:24:08"
          },
          {
            "ticket_id": 7300,
            "ticket_number": "357292",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604534484",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 23:46:36",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 14.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:50:38"
          },
          {
            "ticket_id": 7301,
            "ticket_number": "357293",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604534483",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 23:46:37",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 14.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 13:50:15"
          },
          {
            "ticket_id": 7303,
            "ticket_number": "357295",
            "title": "Envio de comprovativo",
            "priority": "P2",
            "created_at": "26/01/2026 23:46:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 23:46:42"
          },
          {
            "ticket_id": 7305,
            "ticket_number": "357297",
            "title": "pedido de orçamento Benidorm - 13 pessoas",
            "priority": "P2",
            "created_at": "27/01/2026 00:04:43",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 00:04:44"
          },
          {
            "ticket_id": 7316,
            "ticket_number": "357308",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:40",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 11:36:54"
          },
          {
            "ticket_id": 7317,
            "ticket_number": "357309",
            "title": "GBN-101643 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 10:10:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 11:13:28"
          },
          {
            "ticket_id": 7323,
            "ticket_number": "357315",
            "title": "Número de informação da reserva: 6129746",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 10:11:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 553.55,
            "sla_met": false,
            "sla_breach_hours": 529.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7334,
            "ticket_number": "357326",
            "title": "Confirmação de reserva com localizador: 4049227",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 11:01:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 552.72,
            "sla_met": false,
            "sla_breach_hours": 528.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7336,
            "ticket_number": "357328",
            "title": "Número de informação da reserva: 6129746",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 11:13:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 11.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:22:53"
          },
          {
            "ticket_id": 7337,
            "ticket_number": "357329",
            "title": "GBN-101683 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 11:58:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 551.77,
            "sla_met": false,
            "sla_breach_hours": 527.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7338,
            "ticket_number": "357330",
            "title": "Reserva confirmada: Excursão a Como e Bellagio + P",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 12:21:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 551.38,
            "sla_met": false,
            "sla_breach_hours": 527.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7339,
            "ticket_number": "357331",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 12:21:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 551.37,
            "sla_met": false,
            "sla_breach_hours": 527.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7340,
            "ticket_number": "357332",
            "title": "Reserva confirmada: Excursão a Como e Bellagio + P",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 12:21:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 9.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:21:31"
          },
          {
            "ticket_id": 7350,
            "ticket_number": "357342",
            "title": "Solole. Booking I0LT4T9B is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 14:17:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:22:08"
          },
          {
            "ticket_id": 7358,
            "ticket_number": "357350",
            "title": "Número de informação da reserva: 6128947",
            "priority": "P2",
            "created_at": "27/01/2026 14:50:32",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 18:44:48"
          },
          {
            "ticket_id": 7361,
            "ticket_number": "357353",
            "title": "Re:[## 30338 ##] GBN-100539 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "27/01/2026 15:08:22",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 19:04:53"
          },
          {
            "ticket_id": 7362,
            "ticket_number": "357354",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 15:38:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 548.08,
            "sla_met": false,
            "sla_breach_hours": 524.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7364,
            "ticket_number": "357356",
            "title": "Confirmation of booking with locatorX3X77HWL",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 15:39:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 548.08,
            "sla_met": false,
            "sla_breach_hours": 524.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7368,
            "ticket_number": "357360",
            "title": "Reserva confirmada: Visita da Sagrada Família com ",
            "priority": "P3",
            "created_at": "27/01/2026 16:22:32",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 337.58,
            "sla_met": false,
            "sla_breach_hours": 313.58,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:58:27"
          },
          {
            "ticket_id": 7369,
            "ticket_number": "357361",
            "title": "Reserva confirmada: Free tour de Gaudí e pela Barc",
            "priority": "P3",
            "created_at": "27/01/2026 16:22:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 16:22:37"
          },
          {
            "ticket_id": 7370,
            "ticket_number": "357362",
            "title": "Reserva confirmada: Free tour de Gaudí e pela Barc",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 16:22:37",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 6.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:48:21"
          },
          {
            "ticket_id": 7371,
            "ticket_number": "357363",
            "title": "Reserva confirmada: Visita da Sagrada Família com ",
            "priority": "P3",
            "created_at": "27/01/2026 16:22:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 336.95,
            "sla_met": false,
            "sla_breach_hours": 312.95,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:19:48"
          },
          {
            "ticket_id": 7379,
            "ticket_number": "357371",
            "title": "Soltour reserva - SPT002601573655 - Pedido referên",
            "priority": "P2",
            "created_at": "27/01/2026 16:35:46",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:35:47"
          },
          {
            "ticket_id": 7392,
            "ticket_number": "357384",
            "title": "Fwd: SaphetyDoc: EDENRED PORTUGAL, LDA enviou Fatu",
            "priority": "P2",
            "created_at": "27/01/2026 17:35:02",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 17:35:03"
          },
          {
            "ticket_id": 7395,
            "ticket_number": "357387",
            "title": "Fwd: Viagify informa sobre a sua reserva 124091620",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 17:35:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 17:35:15"
          },
          {
            "ticket_id": 7397,
            "ticket_number": "357389",
            "title": "Confirmação de reserva * File 423503",
            "priority": "P2",
            "created_at": "27/01/2026 17:35:36",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 19:06:41"
          },
          {
            "ticket_id": 7398,
            "ticket_number": "357390",
            "title": "Fwd: Viagify informa sobre a sua reserva 124091779",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:12:02",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 18:12:03"
          },
          {
            "ticket_id": 7399,
            "ticket_number": "357391",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:12:13",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 18:12:13"
          },
          {
            "ticket_id": 7400,
            "ticket_number": "357392",
            "title": "GBN-101841 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:12:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 18:12:17"
          },
          {
            "ticket_id": 7402,
            "ticket_number": "357394",
            "title": "GBN-101634 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "27/01/2026 18:12:27",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 4.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:37:48"
          },
          {
            "ticket_id": 7403,
            "ticket_number": "357395",
            "title": "GBN-101836 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:12:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 18:12:38"
          },
          {
            "ticket_id": 7404,
            "ticket_number": "357396",
            "title": "Confirmação de reserva. Localizador: 7TEMF8FHZ5",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:12:58",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 4.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:32:47"
          },
          {
            "ticket_id": 7405,
            "ticket_number": "357397",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:13:01",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 4.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:32:02"
          },
          {
            "ticket_id": 7406,
            "ticket_number": "357398",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:13:43",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 18:13:43"
          },
          {
            "ticket_id": 7407,
            "ticket_number": "357399",
            "title": "Confirmação de Reserva * File 426525 - EMISSÃO HOJ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 18:24:47",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 545.32,
            "sla_met": false,
            "sla_breach_hours": 521.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7408,
            "ticket_number": "357400",
            "title": "GBN-101842 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:24:49",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 14:23:02"
          },
          {
            "ticket_id": 7410,
            "ticket_number": "357402",
            "title": "Nelson Soares",
            "priority": "P2",
            "created_at": "27/01/2026 18:24:55",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 18:36:12"
          },
          {
            "ticket_id": 7411,
            "ticket_number": "357403",
            "title": "Fwd: PRSTFS | Alterações à sua reserva?",
            "priority": "P2",
            "created_at": "27/01/2026 18:24:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 18:25:00"
          },
          {
            "ticket_id": 7413,
            "ticket_number": "357405",
            "title": "Confirmação de reserva 338138",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 18:28:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 4.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:30:42"
          },
          {
            "ticket_id": 7420,
            "ticket_number": "357412",
            "title": "GBN-101864 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 18:59:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 544.75,
            "sla_met": false,
            "sla_breach_hours": 520.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7422,
            "ticket_number": "357414",
            "title": "Fwd: Viagify informa sobre a sua reserva 124098221",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 19:14:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 19:14:46"
          },
          {
            "ticket_id": 7423,
            "ticket_number": "357415",
            "title": "Fwd: Viagify informa sobre a sua reserva 124098221",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 19:14:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 19:14:51"
          },
          {
            "ticket_id": 7424,
            "ticket_number": "357416",
            "title": "w2m.travel: Cancelamento da Reserva com Ref. Nr.: ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 19:14:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 544.48,
            "sla_met": false,
            "sla_breach_hours": 520.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7427,
            "ticket_number": "357419",
            "title": "GBN Travel: Resend booking confirmation - GBN-8673",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 19:31:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 544.22,
            "sla_met": false,
            "sla_breach_hours": 520.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7430,
            "ticket_number": "357422",
            "title": "Confirmação de Compra nº 26370069",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 19:53:02",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 19.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 15:43:07"
          },
          {
            "ticket_id": 7432,
            "ticket_number": "357424",
            "title": "GBN-101852 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 19:53:08",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 15:43:07"
          },
          {
            "ticket_id": 7435,
            "ticket_number": "357427",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 19:54:22",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 19:54:22"
          },
          {
            "ticket_id": 7437,
            "ticket_number": "357429",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "27/01/2026 19:54:28",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 19:54:28"
          },
          {
            "ticket_id": 7438,
            "ticket_number": "357430",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 19:54:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 543.82,
            "sla_met": false,
            "sla_breach_hours": 519.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:29"
          },
          {
            "ticket_id": 7439,
            "ticket_number": "357431",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604535645",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 20:13:20",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 16:03:11"
          },
          {
            "ticket_id": 7441,
            "ticket_number": "357433",
            "title": "Reserva confirmada: Excursão ao Parque Guanayara d",
            "priority": "P3",
            "created_at": "27/01/2026 20:57:00",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 20:57:05"
          },
          {
            "ticket_id": 7442,
            "ticket_number": "357434",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604535689",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 20:57:03",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 16:43:14"
          },
          {
            "ticket_id": 7443,
            "ticket_number": "357435",
            "title": "Reserva confirmada: Excursão ao Parque Guanayara d",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 20:57:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:25:55"
          },
          {
            "ticket_id": 7444,
            "ticket_number": "357436",
            "title": "GBN-101901 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/01/2026 20:57:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 542.78,
            "sla_met": false,
            "sla_breach_hours": 518.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7445,
            "ticket_number": "357437",
            "title": "cancelamento",
            "priority": "P2",
            "created_at": "27/01/2026 21:19:06",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 21:19:07"
          },
          {
            "ticket_id": 7452,
            "ticket_number": "357444",
            "title": "GBN-101909 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 21:44:11",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 21:44:11"
          },
          {
            "ticket_id": 7455,
            "ticket_number": "357447",
            "title": "Número de informação da reserva: 6130007",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 22:02:36",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 235.7,
            "sla_met": false,
            "sla_breach_hours": 211.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 17:45:30"
          },
          {
            "ticket_id": 7457,
            "ticket_number": "357449",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 22:03:00",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 22:03:00"
          },
          {
            "ticket_id": 7463,
            "ticket_number": "357455",
            "title": "DUVIDA SOLFERIAS",
            "priority": "P2",
            "created_at": "27/01/2026 23:20:13",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 23:28:55"
          },
          {
            "ticket_id": 7464,
            "ticket_number": "357456",
            "title": "GBN-101926 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 23:20:21",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:20:21"
          },
          {
            "ticket_id": 7467,
            "ticket_number": "357459",
            "title": "Confirmação de reserva – Ref PP205146, Sr. RICARDO",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 23:49:10",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 19:43:32"
          },
          {
            "ticket_id": 7468,
            "ticket_number": "357460",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/01/2026 23:49:16",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/01/2026 23:49:17"
          },
          {
            "ticket_id": 7471,
            "ticket_number": "357463",
            "title": "Fwd: Viagify informa sobre a sua reserva 124110970",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/01/2026 10:24:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/01/2026 10:24:25"
          },
          {
            "ticket_id": 7476,
            "ticket_number": "357468",
            "title": "Confirmação de reserva – Ref PP762271, Sra. Silvia",
            "priority": "Reservas sem Formulário",
            "created_at": "28/01/2026 10:28:02",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 203.15,
            "sla_met": false,
            "sla_breach_hours": 179.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:37:34"
          },
          {
            "ticket_id": 7485,
            "ticket_number": "357477",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "28/01/2026 10:29:13",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7487,
            "ticket_number": "357479",
            "title": "Informação importante sobre a tua reserva 1757952",
            "priority": "P2",
            "created_at": "28/01/2026 10:29:23",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:17"
          },
          {
            "ticket_id": 7490,
            "ticket_number": "357482",
            "title": "Fwd: Viagify informa sobre a sua reserva 124111954",
            "priority": "P2",
            "created_at": "28/01/2026 10:29:59",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 10:30:00"
          },
          {
            "ticket_id": 7492,
            "ticket_number": "357484",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "28/01/2026 10:30:20",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:17"
          },
          {
            "ticket_id": 7495,
            "ticket_number": "357487",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "28/01/2026 10:31:21",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 10:31:21"
          },
          {
            "ticket_id": 7503,
            "ticket_number": "357495",
            "title": "CN Travel | Campanha de Venda Antecipada – Flight ",
            "priority": "P2",
            "created_at": "28/01/2026 12:27:01",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 16:21:27"
          },
          {
            "ticket_id": 7509,
            "ticket_number": "357501",
            "title": "Re: Nova Viagem #260100473 - Viagens Sem Fim",
            "priority": "P2",
            "created_at": "28/01/2026 15:45:34",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 15:45:34"
          },
          {
            "ticket_id": 7517,
            "ticket_number": "357509",
            "title": "Re:[## 30419 ##] GBN-97245 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "28/01/2026 15:45:57",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:23:07"
          },
          {
            "ticket_id": 7521,
            "ticket_number": "357513",
            "title": "CONTROLO RESERVAS... - 1645 - 15/09/2025 1000 - 26",
            "priority": "P2",
            "created_at": "28/01/2026 15:46:09",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:24:09"
          },
          {
            "ticket_id": 7539,
            "ticket_number": "357531",
            "title": "Criação de processo File 427403/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/01/2026 17:16:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:04:32"
          },
          {
            "ticket_id": 7551,
            "ticket_number": "357543",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "28/01/2026 19:19:59",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 19:19:59"
          },
          {
            "ticket_id": 7554,
            "ticket_number": "357546",
            "title": "GBN-101623 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/01/2026 19:20:22",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 16.72,
            "sla_met": false,
            "sla_breach_hours": 12.72,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 12:03:49"
          },
          {
            "ticket_id": 7559,
            "ticket_number": "357551",
            "title": "GBN-102151 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/01/2026 19:20:47",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 520.38,
            "sla_met": false,
            "sla_breach_hours": 496.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7563,
            "ticket_number": "357555",
            "title": "Sem ideias para o Dia de São Valentim? Temos MAIS ",
            "priority": "P2",
            "created_at": "29/01/2026 10:22:49",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:40:49"
          },
          {
            "ticket_id": 7565,
            "ticket_number": "357557",
            "title": "CCTGTI-32014 Pedido de cotação",
            "priority": "P2",
            "created_at": "29/01/2026 10:22:56",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 13:00:39"
          },
          {
            "ticket_id": 7566,
            "ticket_number": "357558",
            "title": "Fwd: Viagify informa sobre a sua reserva 124144519",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 10:22:58",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 179.17,
            "sla_met": false,
            "sla_breach_hours": 155.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:33:27"
          },
          {
            "ticket_id": 7569,
            "ticket_number": "357561",
            "title": "GBN-102186 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 10:23:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 505.35,
            "sla_met": false,
            "sla_breach_hours": 481.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7570,
            "ticket_number": "357562",
            "title": "GBN-102183 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 10:23:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 505.35,
            "sla_met": false,
            "sla_breach_hours": 481.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7577,
            "ticket_number": "357569",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 80234832",
            "priority": "P2",
            "created_at": "29/01/2026 10:24:44",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 13:07:34"
          },
          {
            "ticket_id": 7586,
            "ticket_number": "357578",
            "title": "Cotización MARBELLA  /  PUERTO BANUS - cntravel -R",
            "priority": "P2",
            "created_at": "29/01/2026 10:27:11",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 14:23:02"
          },
          {
            "ticket_id": 7591,
            "ticket_number": "357583",
            "title": "GBN-102212 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 10:27:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 505.28,
            "sla_met": false,
            "sla_breach_hours": 481.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7594,
            "ticket_number": "357586",
            "title": "Número de informação da reserva: 6130279",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 10:27:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 20:20:38"
          },
          {
            "ticket_id": 7598,
            "ticket_number": "357590",
            "title": "Número de informação da reserva: 6130276",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 10:27:50",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 20:20:38"
          },
          {
            "ticket_id": 7604,
            "ticket_number": "357596",
            "title": "Opti 24100747 comprovativos de pagamento GBN-85400",
            "priority": "P2",
            "created_at": "29/01/2026 10:28:08",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:28:09"
          },
          {
            "ticket_id": 7605,
            "ticket_number": "357597",
            "title": "GBN-102207 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 10:28:12",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 10:28:12"
          },
          {
            "ticket_id": 7608,
            "ticket_number": "357600",
            "title": "Número de informação da reserva: 6130260",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 10:28:21",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 20:20:38"
          },
          {
            "ticket_id": 7610,
            "ticket_number": "357602",
            "title": "ALTERAÇÃO DA RESERVA  - REF PP762271-1, Sr. Jose A",
            "priority": "P2",
            "created_at": "29/01/2026 10:28:57",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7615,
            "ticket_number": "357607",
            "title": "Fwd: Pode agora efetuar o check-in online para o s",
            "priority": "P2",
            "created_at": "29/01/2026 10:32:17",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:32:18"
          },
          {
            "ticket_id": 7620,
            "ticket_number": "357612",
            "title": "2 days left: earn 1% on new routes available on W2",
            "priority": "P2",
            "created_at": "29/01/2026 11:19:38",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 13:13:29"
          },
          {
            "ticket_id": 7624,
            "ticket_number": "357616",
            "title": "GBN-91876 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 11:19:49",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 177.9,
            "sla_met": false,
            "sla_breach_hours": 153.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:13:51"
          },
          {
            "ticket_id": 7625,
            "ticket_number": "357617",
            "title": "Signer signed: RGPD 2415700064.pdf",
            "priority": "P2",
            "created_at": "29/01/2026 11:19:51",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 12:06:11"
          },
          {
            "ticket_id": 7626,
            "ticket_number": "357618",
            "title": "Fwd: Viagify informa sobre a sua reserva 124158616",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 11:19:54",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 11:19:54"
          },
          {
            "ticket_id": 7628,
            "ticket_number": "357620",
            "title": "Fwd: Viagify informa sobre a sua reserva 124158616",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 11:20:02",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 11:20:03"
          },
          {
            "ticket_id": 7629,
            "ticket_number": "357621",
            "title": "Fwd: Informações da sua reserva TTN-1241586163#914",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 11:20:07",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 11:20:08"
          },
          {
            "ticket_id": 7631,
            "ticket_number": "357623",
            "title": "Confirmação da reserva nº 679419043",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 12:42:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 22:40:47"
          },
          {
            "ticket_id": 7634,
            "ticket_number": "357626",
            "title": "Confirmacao 338457",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 12:43:08",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 176.48,
            "sla_met": false,
            "sla_breach_hours": 152.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:12:20"
          },
          {
            "ticket_id": 7637,
            "ticket_number": "357629",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 12:43:26",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 12:43:26"
          },
          {
            "ticket_id": 7646,
            "ticket_number": "357638",
            "title": "Criação de processo File 427576/26",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:49",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:40:52"
          },
          {
            "ticket_id": 7647,
            "ticket_number": "357639",
            "title": "Criação de processo File 427577/26",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:56",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:50:32"
          },
          {
            "ticket_id": 7650,
            "ticket_number": "357642",
            "title": "Número de informação da reserva: 6130379",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 15:15:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 19:03:28"
          },
          {
            "ticket_id": 7651,
            "ticket_number": "357643",
            "title": "Reminder * Reserva File 427403 * Deadline Hoje 17H",
            "priority": "P2",
            "created_at": "29/01/2026 15:54:30",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:42:33"
          },
          {
            "ticket_id": 7655,
            "ticket_number": "357647",
            "title": "Cotización GRUPO RANCHO  - cntravel -Ref* 36011069",
            "priority": "P2",
            "created_at": "29/01/2026 15:54:43",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 19:43:32"
          },
          {
            "ticket_id": 7661,
            "ticket_number": "357653",
            "title": "GBN-102255 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 16:31:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/01/2026 20:23:44"
          },
          {
            "ticket_id": 7665,
            "ticket_number": "357657",
            "title": "Webinar Airalo | 5 de fevereiro | 11 horas",
            "priority": "P2",
            "created_at": "29/01/2026 17:58:53",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 16.77,
            "sla_met": false,
            "sla_breach_hours": 12.77,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:45:34"
          },
          {
            "ticket_id": 7667,
            "ticket_number": "357659",
            "title": "Última chamada Blue Monday: até 500 € de desconto",
            "priority": "P2",
            "created_at": "29/01/2026 17:58:57",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 17.23,
            "sla_met": false,
            "sla_breach_hours": 13.23,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 11:13:12"
          },
          {
            "ticket_id": 7669,
            "ticket_number": "357661",
            "title": "Confirmation of booking with locatorVR27QHCI",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 17:59:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 497.75,
            "sla_met": false,
            "sla_breach_hours": 473.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7670,
            "ticket_number": "357662",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "P3",
            "created_at": "29/01/2026 17:59:11",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 17:59:25"
          },
          {
            "ticket_id": 7676,
            "ticket_number": "357668",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "P3",
            "created_at": "29/01/2026 17:59:31",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 192.32,
            "sla_met": false,
            "sla_breach_hours": 168.32,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:18:44"
          },
          {
            "ticket_id": 7677,
            "ticket_number": "357669",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "P3",
            "created_at": "29/01/2026 17:59:37",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 17:59:37"
          },
          {
            "ticket_id": 7678,
            "ticket_number": "357670",
            "title": "Re: Pedido cotação grupo SOLTOUR - Maiorca",
            "priority": "P2",
            "created_at": "29/01/2026 17:59:39",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 17:59:40"
          },
          {
            "ticket_id": 7679,
            "ticket_number": "357671",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "Reservas sem Formulário",
            "created_at": "29/01/2026 17:59:42",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 192.3,
            "sla_met": false,
            "sla_breach_hours": 168.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:18:27"
          },
          {
            "ticket_id": 7680,
            "ticket_number": "357672",
            "title": "Confirmação de reserva 338488",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/01/2026 17:59:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 17.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 11:30:38"
          },
          {
            "ticket_id": 7682,
            "ticket_number": "357674",
            "title": "Signer signed: CVO 248000036.pdf",
            "priority": "P2",
            "created_at": "30/01/2026 10:05:08",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:15:05"
          },
          {
            "ticket_id": 7683,
            "ticket_number": "357675",
            "title": "Signed: CVO 248000036.pdf",
            "priority": "P2",
            "created_at": "30/01/2026 10:05:49",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:15:24"
          },
          {
            "ticket_id": 7684,
            "ticket_number": "357676",
            "title": "Signed: RGPD 248000036.pdf",
            "priority": "P2",
            "created_at": "30/01/2026 10:05:59",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:16:04"
          },
          {
            "ticket_id": 7688,
            "ticket_number": "357680",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "30/01/2026 10:08:16",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 11:45:48"
          },
          {
            "ticket_id": 7691,
            "ticket_number": "357683",
            "title": "Confirmação de reserva com localizador: 4054617",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 10:08:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 481.6,
            "sla_met": false,
            "sla_breach_hours": 457.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:28"
          },
          {
            "ticket_id": 7700,
            "ticket_number": "357692",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "30/01/2026 10:08:48",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:16:11"
          },
          {
            "ticket_id": 7711,
            "ticket_number": "357703",
            "title": "Envio de Documentação Disney File 427577",
            "priority": "P2",
            "created_at": "30/01/2026 10:10:03",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:04:41"
          },
          {
            "ticket_id": 7715,
            "ticket_number": "357707",
            "title": "Envio de Documentação Disney File 427576",
            "priority": "P2",
            "created_at": "30/01/2026 10:10:12",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:04:41"
          },
          {
            "ticket_id": 7724,
            "ticket_number": "357716",
            "title": "Duplique os seus ONES em fevereiro",
            "priority": "P2",
            "created_at": "30/01/2026 10:12:01",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:18:03"
          },
          {
            "ticket_id": 7735,
            "ticket_number": "357727",
            "title": "Envio de documentos de File 427403/26",
            "priority": "P2",
            "created_at": "30/01/2026 10:12:40",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:04:45"
          },
          {
            "ticket_id": 7736,
            "ticket_number": "357728",
            "title": "Fwd: Alteração de nome reserva - 6122920",
            "priority": "P2",
            "created_at": "30/01/2026 10:12:41",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:12:41"
          },
          {
            "ticket_id": 7746,
            "ticket_number": "357738",
            "title": "Cancelamento de reserva 338457",
            "priority": "P2",
            "created_at": "30/01/2026 11:36:24",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 15:24:50"
          },
          {
            "ticket_id": 7753,
            "ticket_number": "357745",
            "title": "Informação de reserva - SPT002601574519",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:15:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 478.47,
            "sla_met": false,
            "sla_breach_hours": 454.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7754,
            "ticket_number": "357746",
            "title": "Número de informação da reserva: 6130671",
            "priority": "P2",
            "created_at": "30/01/2026 13:15:57",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:02:34"
          },
          {
            "ticket_id": 7755,
            "ticket_number": "357747",
            "title": "Número de informação da reserva: 6130659",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:16:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 478.47,
            "sla_met": false,
            "sla_breach_hours": 454.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7759,
            "ticket_number": "357751",
            "title": "Número de informação da reserva: 6130651",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:16:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 478.47,
            "sla_met": false,
            "sla_breach_hours": 454.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7762,
            "ticket_number": "357754",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:16:32",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:16:32"
          },
          {
            "ticket_id": 7766,
            "ticket_number": "357758",
            "title": "Número de informação da reserva: 6130642",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:16:48",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 129.85,
            "sla_met": false,
            "sla_breach_hours": 105.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 23:08:27"
          },
          {
            "ticket_id": 7767,
            "ticket_number": "357759",
            "title": "Transferências mais rápidas: atualização no proces",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:51",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 5.62,
            "sla_met": false,
            "sla_breach_hours": 1.62,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:54:24"
          },
          {
            "ticket_id": 7775,
            "ticket_number": "357767",
            "title": "RE: Pagamento 6129242",
            "priority": "P2",
            "created_at": "30/01/2026 13:17:23",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 4.1,
            "sla_met": false,
            "sla_breach_hours": 0.1,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:24:12"
          },
          {
            "ticket_id": 7777,
            "ticket_number": "357769",
            "title": "RE: Pagamento 1751036",
            "priority": "P2",
            "created_at": "30/01/2026 13:17:28",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 5.45,
            "sla_met": false,
            "sla_breach_hours": 1.45,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:44:57"
          },
          {
            "ticket_id": 7780,
            "ticket_number": "357772",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:38:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 269.2,
            "sla_met": false,
            "sla_breach_hours": 245.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 18:50:51"
          },
          {
            "ticket_id": 7782,
            "ticket_number": "357774",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 13:38:12",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 172.65,
            "sla_met": false,
            "sla_breach_hours": 148.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:17:55"
          },
          {
            "ticket_id": 7785,
            "ticket_number": "357777",
            "title": "Fwd: Viagify informa sobre a sua reserva 124222921",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:51:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 13:51:37"
          },
          {
            "ticket_id": 7786,
            "ticket_number": "357778",
            "title": "GBN-102597 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 13:51:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 477.87,
            "sla_met": false,
            "sla_breach_hours": 453.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7787,
            "ticket_number": "357779",
            "title": "RESERVAS DUPLICADAS 6130671 & 130642",
            "priority": "P2",
            "created_at": "30/01/2026 13:51:45",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:02:11"
          },
          {
            "ticket_id": 7788,
            "ticket_number": "357780",
            "title": "Número de informação da reserva: 6130690",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 14:15:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 477.47,
            "sla_met": false,
            "sla_breach_hours": 453.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7789,
            "ticket_number": "357781",
            "title": "Número de informação da reserva: 6130691",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 14:15:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 477.47,
            "sla_met": false,
            "sla_breach_hours": 453.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7794,
            "ticket_number": "357786",
            "title": "Número de informação da reserva: 6130704",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 14:39:15",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 8.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 23:26:27"
          },
          {
            "ticket_id": 7797,
            "ticket_number": "357789",
            "title": "GBN-102574 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 16:12:20",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 16:12:20"
          },
          {
            "ticket_id": 7798,
            "ticket_number": "357790",
            "title": "GBN-102574 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 16:12:23",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 16:12:23"
          },
          {
            "ticket_id": 7799,
            "ticket_number": "357791",
            "title": "Informação de reserva - SPT002501548337",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 16:12:30",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 127.1,
            "sla_met": false,
            "sla_breach_hours": 103.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 23:18:51"
          },
          {
            "ticket_id": 7800,
            "ticket_number": "357792",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 16:12:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 475.52,
            "sla_met": false,
            "sla_breach_hours": 451.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7803,
            "ticket_number": "357795",
            "title": "Informação de reserva - SPT002601575704",
            "priority": "P2",
            "created_at": "30/01/2026 16:12:49",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:07:32"
          },
          {
            "ticket_id": 7805,
            "ticket_number": "357797",
            "title": "A Virgin Voyages traz NOVAS promoções! Reserve já ",
            "priority": "P2",
            "created_at": "30/01/2026 16:12:56",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:28:14"
          },
          {
            "ticket_id": 7806,
            "ticket_number": "357798",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/01/2026 16:12:58",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:10:47"
          },
          {
            "ticket_id": 7808,
            "ticket_number": "357800",
            "title": "GBN-102610 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 16:13:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 475.52,
            "sla_met": false,
            "sla_breach_hours": 451.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7810,
            "ticket_number": "357802",
            "title": "Criação de processo File 427856/26",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 16:53:49",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 147.98,
            "sla_met": false,
            "sla_breach_hours": 123.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 20:53:02"
          },
          {
            "ticket_id": 7821,
            "ticket_number": "357813",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604539069",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 17:26:00",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 147.45,
            "sla_met": false,
            "sla_breach_hours": 123.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 20:53:37"
          },
          {
            "ticket_id": 7823,
            "ticket_number": "357815",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604539047",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 17:26:03",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 147.47,
            "sla_met": false,
            "sla_breach_hours": 123.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 20:54:05"
          },
          {
            "ticket_id": 7825,
            "ticket_number": "357817",
            "title": "GBN-102629 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 18:55:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.8,
            "sla_met": false,
            "sla_breach_hours": 448.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7833,
            "ticket_number": "357825",
            "title": "Informação de reserva - SPT002601568223",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 18:56:53",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 18:59:38"
          },
          {
            "ticket_id": 7835,
            "ticket_number": "357827",
            "title": "Soltour.es - Localizador SPT002601580797: pago efe",
            "priority": "P2",
            "created_at": "30/01/2026 18:57:00",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:57:35"
          },
          {
            "ticket_id": 7837,
            "ticket_number": "357829",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:09:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.57,
            "sla_met": false,
            "sla_breach_hours": 448.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:44:27"
          },
          {
            "ticket_id": 7839,
            "ticket_number": "357831",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:09:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.53,
            "sla_met": false,
            "sla_breach_hours": 448.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7840,
            "ticket_number": "357832",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:10:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.53,
            "sla_met": false,
            "sla_breach_hours": 448.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7841,
            "ticket_number": "357833",
            "title": "Número de informação da reserva: 6130877",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 19:10:05",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 145.87,
            "sla_met": false,
            "sla_breach_hours": 121.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:02:33"
          },
          {
            "ticket_id": 7842,
            "ticket_number": "357834",
            "title": "Pagamento da reserva – Ref PP592284, Sr. Agostinho",
            "priority": "P2",
            "created_at": "30/01/2026 19:28:35",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:30:07"
          },
          {
            "ticket_id": 7845,
            "ticket_number": "357837",
            "title": "Pagamento da reserva – Ref PP956063, Sr. LUCIANO F",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:28:46",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.22,
            "sla_met": false,
            "sla_breach_hours": 448.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7849,
            "ticket_number": "357841",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:28:57",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.22,
            "sla_met": false,
            "sla_breach_hours": 448.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7850,
            "ticket_number": "357842",
            "title": "Pagamento da reserva – Ref PP122216, Sr. Rui Gomes",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 19:28:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 472.22,
            "sla_met": false,
            "sla_breach_hours": 448.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7861,
            "ticket_number": "357853",
            "title": "Confirmação de reserva com localizador: 4056194",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 20:56:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 12:43:39"
          },
          {
            "ticket_id": 7863,
            "ticket_number": "357855",
            "title": "Confirmation of booking with locatorFV62D1L4",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:10:29",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 15:04:00"
          },
          {
            "ticket_id": 7864,
            "ticket_number": "357856",
            "title": "GBN-102796 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:10:35",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 23:10:35"
          },
          {
            "ticket_id": 7865,
            "ticket_number": "357857",
            "title": "GBN-102812 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:10:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/01/2026 23:10:41"
          },
          {
            "ticket_id": 7866,
            "ticket_number": "357858",
            "title": "Informação de reserva - SPT002601580797",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:10:47",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 60.08,
            "sla_met": false,
            "sla_breach_hours": 36.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 11:16:29"
          },
          {
            "ticket_id": 7870,
            "ticket_number": "357862",
            "title": "Confirmação de reserva com localizador: 4056308",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:10:59",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 15:04:00"
          },
          {
            "ticket_id": 7876,
            "ticket_number": "357868",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/01/2026 23:11:17",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 468.52,
            "sla_met": false,
            "sla_breach_hours": 444.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7877,
            "ticket_number": "357869",
            "title": "RE: Pedido de cotação - reserva",
            "priority": "P3",
            "created_at": "30/01/2026 23:11:20",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 63.87,
            "sla_met": false,
            "sla_breach_hours": 39.87,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 15:04:00"
          },
          {
            "ticket_id": 7878,
            "ticket_number": "357870",
            "title": "Número de informação da reserva: 6130946",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:11:22",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 63.87,
            "sla_met": false,
            "sla_breach_hours": 39.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 15:04:00"
          },
          {
            "ticket_id": 7881,
            "ticket_number": "357873",
            "title": "Nova Viagem #260100528 - Rui Pinto",
            "priority": "P2",
            "created_at": "30/01/2026 23:17:14",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:17:15"
          },
          {
            "ticket_id": 7882,
            "ticket_number": "357874",
            "title": "Reserva pagada",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 23:17:18",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/01/2026 00:06:53"
          },
          {
            "ticket_id": 7883,
            "ticket_number": "357875",
            "title": "Nova Viagem #260100529 - Amor e Viagens",
            "priority": "P2",
            "created_at": "30/01/2026 23:17:20",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:17:22"
          },
          {
            "ticket_id": 7887,
            "ticket_number": "357879",
            "title": "Fwd: Viagify informa sobre a sua reserva 124248578",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 00:09:34",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/01/2026 00:09:35"
          },
          {
            "ticket_id": 7890,
            "ticket_number": "357882",
            "title": "Confirmation of booking with locatorHJMAQN86",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 00:09:41",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 140.88,
            "sla_met": false,
            "sla_breach_hours": 116.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:03:05"
          },
          {
            "ticket_id": 7891,
            "ticket_number": "357883",
            "title": "Nova Viagem #260100532 - Marta Barbosa",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:43",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:44"
          },
          {
            "ticket_id": 7892,
            "ticket_number": "357884",
            "title": "Nova Viagem #260100531 - Viagens Sem Fim",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:46",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:46"
          },
          {
            "ticket_id": 7893,
            "ticket_number": "357885",
            "title": "Nova Viagem #260100533 - Viagens Sem Fim",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:48",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:48"
          },
          {
            "ticket_id": 7894,
            "ticket_number": "357886",
            "title": "Nova Viagem #260100534 - Amor e Viagens",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:50",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:51"
          },
          {
            "ticket_id": 7896,
            "ticket_number": "357888",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "31/01/2026 10:46:10",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 12:09:47"
          },
          {
            "ticket_id": 7899,
            "ticket_number": "357891",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 10:46:16",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 16:44:08"
          },
          {
            "ticket_id": 7900,
            "ticket_number": "357892",
            "title": "HJMAQN86//UFEV",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 10:46:18",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 16:44:08"
          },
          {
            "ticket_id": 7904,
            "ticket_number": "357896",
            "title": "Número de informação da reserva: 6131022",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 11:45:55",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 17:44:21"
          },
          {
            "ticket_id": 7905,
            "ticket_number": "357897",
            "title": "Número de informação da reserva: 6131019",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 11:46:01",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 17:44:21"
          },
          {
            "ticket_id": 7906,
            "ticket_number": "357898",
            "title": "⏰🌎 Último dia | Descontos de Janeiro em todos os p",
            "priority": "P2",
            "created_at": "31/01/2026 11:46:04",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 12:13:35"
          },
          {
            "ticket_id": 7907,
            "ticket_number": "357899",
            "title": "Número de informação da reserva: 6131017",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 11:46:07",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 17:44:21"
          },
          {
            "ticket_id": 7910,
            "ticket_number": "357902",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 5",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 14:19:10",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 272.07,
            "sla_met": false,
            "sla_breach_hours": 248.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:23:33"
          },
          {
            "ticket_id": 7911,
            "ticket_number": "357903",
            "title": "Confirmação de reserva. Localizador: 5VPZKDERQH",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 14:19:12",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 151.97,
            "sla_met": false,
            "sla_breach_hours": 127.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:18:10"
          },
          {
            "ticket_id": 7914,
            "ticket_number": "357906",
            "title": "Confirmação de reserva. Localizador: 5VPZKDERQH",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 14:19:23",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 151.98,
            "sla_met": false,
            "sla_breach_hours": 127.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:18:34"
          },
          {
            "ticket_id": 7916,
            "ticket_number": "357908",
            "title": "Número de informação da reserva: 6131102",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 15:24:34",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 150.93,
            "sla_met": false,
            "sla_breach_hours": 126.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:20:47"
          },
          {
            "ticket_id": 7917,
            "ticket_number": "357909",
            "title": "Dúvidas Reserva Leplan 604517844",
            "priority": "P2",
            "created_at": "31/01/2026 15:24:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 15:24:38"
          },
          {
            "ticket_id": 7918,
            "ticket_number": "357910",
            "title": "Número de informação da reserva: 6131098",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 15:24:41",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 150.9,
            "sla_met": false,
            "sla_breach_hours": 126.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:19:06"
          },
          {
            "ticket_id": 7919,
            "ticket_number": "357911",
            "title": "Número de informação da reserva: 6131111",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 15:24:43",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 150.92,
            "sla_met": false,
            "sla_breach_hours": 126.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:20:20"
          },
          {
            "ticket_id": 7920,
            "ticket_number": "357912",
            "title": "Número de informação da reserva: 6131099",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 15:24:45",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 125.67,
            "sla_met": false,
            "sla_breach_hours": 101.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:05:32"
          },
          {
            "ticket_id": 7922,
            "ticket_number": "357914",
            "title": "Número de informação da reserva: 6131115",
            "priority": "Reservas sem Formulário",
            "created_at": "31/01/2026 15:40:13",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 21:40:02"
          },
          {
            "ticket_id": 7923,
            "ticket_number": "357915",
            "title": "Icárion - Praslin & Mahé - Feira Noivos - 2026-09-",
            "priority": "P3",
            "created_at": "31/01/2026 15:45:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 47.0,
            "sla_met": false,
            "sla_breach_hours": 23.0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:45:37"
          },
          {
            "ticket_id": 7925,
            "ticket_number": "357917",
            "title": "Confirmation of booking with locatorPP0UY0RV",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "31/01/2026 16:38:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 451.07,
            "sla_met": false,
            "sla_breach_hours": 427.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7946,
            "ticket_number": "357938",
            "title": "Fwd: Viagify informa sobre a sua reserva 124316423",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:08:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 10:08:32"
          },
          {
            "ticket_id": 7957,
            "ticket_number": "357949",
            "title": "Referencia para pagamento | File:420365/2025",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:09:37",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 228.23,
            "sla_met": false,
            "sla_breach_hours": 204.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:24:20"
          },
          {
            "ticket_id": 7958,
            "ticket_number": "357950",
            "title": "Número de informação da reserva: 6131346",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:09:42",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 108.17,
            "sla_met": false,
            "sla_breach_hours": 84.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:19:55"
          },
          {
            "ticket_id": 7959,
            "ticket_number": "357951",
            "title": "Fwd: Viagify informa sobre a sua reserva 124312307",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:09:47",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 10:09:48"
          },
          {
            "ticket_id": 7963,
            "ticket_number": "357955",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:14:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 14:03:54"
          },
          {
            "ticket_id": 7965,
            "ticket_number": "357957",
            "title": "Número de informação da reserva: 6131196",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:14:42",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 82.93,
            "sla_met": false,
            "sla_breach_hours": 58.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 21:10:50"
          },
          {
            "ticket_id": 7968,
            "ticket_number": "357960",
            "title": "Icárion - Mahé - 17/02/2026 - 6236823 - AF21SC002-",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:15:04",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 228.15,
            "sla_met": false,
            "sla_breach_hours": 204.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:24:32"
          },
          {
            "ticket_id": 7972,
            "ticket_number": "357964",
            "title": "Criação de processo File 428139/26",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:15:19",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 13:00:48"
          },
          {
            "ticket_id": 7974,
            "ticket_number": "357966",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:16:33",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 14:03:54"
          },
          {
            "ticket_id": 7976,
            "ticket_number": "357968",
            "title": "GBN-102937 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:16:44",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 201.35,
            "sla_met": false,
            "sla_breach_hours": 177.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:37:46"
          },
          {
            "ticket_id": 7980,
            "ticket_number": "357972",
            "title": "Número de informação da reserva: 6131286",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:16:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 4.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 14:56:09"
          },
          {
            "ticket_id": 7982,
            "ticket_number": "357974",
            "title": "Número de informação da reserva: 6131284",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:17:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 4.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 14:56:40"
          },
          {
            "ticket_id": 7983,
            "ticket_number": "357975",
            "title": "Información de reserva número: 1773401",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:17:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 409.42,
            "sla_met": false,
            "sla_breach_hours": 385.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:40"
          },
          {
            "ticket_id": 7989,
            "ticket_number": "357981",
            "title": "Número de informação da reserva: 6131281",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:39",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 4.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:59:49"
          },
          {
            "ticket_id": 7991,
            "ticket_number": "357983",
            "title": "Número de informação da reserva: 6131228",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:17:45",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 104.58,
            "sla_met": false,
            "sla_breach_hours": 80.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:53:38"
          },
          {
            "ticket_id": 7995,
            "ticket_number": "357987",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604539967",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:17:58",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 104.6,
            "sla_met": false,
            "sla_breach_hours": 80.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:54:49"
          },
          {
            "ticket_id": 7996,
            "ticket_number": "357988",
            "title": "Icárion - Mahé - 24/02/2026 - 6236837 - AF21SC002-",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:18:00",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 228.12,
            "sla_met": false,
            "sla_breach_hours": 204.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:25:30"
          },
          {
            "ticket_id": 7999,
            "ticket_number": "357991",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "02/02/2026 10:18:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:18:40"
          },
          {
            "ticket_id": 8000,
            "ticket_number": "357992",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P3",
            "created_at": "02/02/2026 10:18:48",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 200.67,
            "sla_met": false,
            "sla_breach_hours": 176.67,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:58:57"
          },
          {
            "ticket_id": 8008,
            "ticket_number": "358000",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604540064",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:20:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 104.52,
            "sla_met": false,
            "sla_breach_hours": 80.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:51:34"
          },
          {
            "ticket_id": 8009,
            "ticket_number": "358001",
            "title": "Referencia para pagamento | File:428193/2026",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:22:03",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 104.5,
            "sla_met": false,
            "sla_breach_hours": 80.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:53:01"
          },
          {
            "ticket_id": 8015,
            "ticket_number": "358007",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:22:20",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 252.17,
            "sla_met": false,
            "sla_breach_hours": 228.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 22:32:48"
          },
          {
            "ticket_id": 8020,
            "ticket_number": "358012",
            "title": "GBN-102972 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:35"
          },
          {
            "ticket_id": 8025,
            "ticket_number": "358017",
            "title": "Número de informação da reserva: 6131347",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:22:53",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:22:24"
          },
          {
            "ticket_id": 8026,
            "ticket_number": "358018",
            "title": "Fwd: Viagify informa sobre a sua reserva 124308732",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 10:22:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 10:22:57"
          },
          {
            "ticket_id": 8029,
            "ticket_number": "358021",
            "title": "Vila Galé | Confirmação da Reserva Nº8968623",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:23:40",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:22:24"
          },
          {
            "ticket_id": 8030,
            "ticket_number": "358022",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604540123",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:23:43",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:22:24"
          },
          {
            "ticket_id": 8031,
            "ticket_number": "358023",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604540121",
            "priority": "P3",
            "created_at": "02/02/2026 10:23:46",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 20:22:24"
          },
          {
            "ticket_id": 8032,
            "ticket_number": "358024",
            "title": "Confirmação de reserva com localizador: 4057645",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:23:48",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:22:24"
          },
          {
            "ticket_id": 8035,
            "ticket_number": "358027",
            "title": "GBN-102994 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:23:57",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 10:23:57"
          },
          {
            "ticket_id": 8036,
            "ticket_number": "358028",
            "title": "Fwd: PRSTFS | Efetua o check-in online para o teu ",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 10:24:35",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 10:24:35"
          },
          {
            "ticket_id": 8046,
            "ticket_number": "358038",
            "title": "[Pedido IATA] Lisboa → Barcelona - 2026-02-04 (5 p",
            "priority": "P2",
            "created_at": "02/02/2026 10:51:31",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:52:13"
          },
          {
            "ticket_id": 8051,
            "ticket_number": "358043",
            "title": "Cotización HUELVA - cntravel -Ref 50005863 -Uma Fa",
            "priority": "P3",
            "created_at": "02/02/2026 12:48:53",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:57:27"
          },
          {
            "ticket_id": 8063,
            "ticket_number": "358055",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/02/2026 12:49:30",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 12:49:30"
          },
          {
            "ticket_id": 8064,
            "ticket_number": "358056",
            "title": "GBN-103016 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/02/2026 12:49:34",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 12:49:34"
          },
          {
            "ticket_id": 8068,
            "ticket_number": "358060",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604535645",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 13:16:37",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.77,
            "sla_met": false,
            "sla_breach_hours": 9.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 23:02:45"
          },
          {
            "ticket_id": 8072,
            "ticket_number": "358064",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "02/02/2026 13:49:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 13:49:50"
          },
          {
            "ticket_id": 8073,
            "ticket_number": "358065",
            "title": "GBN-103085 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 13:49:57",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 13:49:57"
          },
          {
            "ticket_id": 8074,
            "ticket_number": "358066",
            "title": "Confirmation of booking with locatorKXQITOI4",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 13:50:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 23:42:58"
          },
          {
            "ticket_id": 8077,
            "ticket_number": "358069",
            "title": "Informação de reserva - SPT002601580797",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 14:05:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 405.62,
            "sla_met": false,
            "sla_breach_hours": 381.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:39"
          },
          {
            "ticket_id": 8085,
            "ticket_number": "358077",
            "title": "GBN-102950 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 16:37:41",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 174.72,
            "sla_met": false,
            "sla_breach_hours": 150.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:20:42"
          },
          {
            "ticket_id": 8086,
            "ticket_number": "358078",
            "title": "GBN-102950 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 16:37:50",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 16:37:50"
          },
          {
            "ticket_id": 8087,
            "ticket_number": "358079",
            "title": "Informação de reserva - SPT002601575704",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 16:37:57",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 12:23:46"
          },
          {
            "ticket_id": 8101,
            "ticket_number": "358093",
            "title": "GBN-103159 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 17:26:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 17:26:19"
          },
          {
            "ticket_id": 8102,
            "ticket_number": "358094",
            "title": "Fwd: Incidente de voo TTN-1234448066#91816946#T173",
            "priority": "P2",
            "created_at": "02/02/2026 17:26:23",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 17:26:24"
          },
          {
            "ticket_id": 8103,
            "ticket_number": "358095",
            "title": "Informação de reserva - SPT002601567778",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 17:26:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 197.93,
            "sla_met": false,
            "sla_breach_hours": 173.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:23:05"
          },
          {
            "ticket_id": 8104,
            "ticket_number": "358096",
            "title": "Fwd: A74SGR | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "02/02/2026 17:26:33",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 17:26:34"
          },
          {
            "ticket_id": 8105,
            "ticket_number": "358097",
            "title": "Fwd: Incidente de voo TTN-1229984670#91839901#T173",
            "priority": "P2",
            "created_at": "02/02/2026 17:26:36",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 17:26:37"
          },
          {
            "ticket_id": 8106,
            "ticket_number": "358098",
            "title": "Reserva cancelada com localizador: 4006982",
            "priority": "P3",
            "created_at": "02/02/2026 17:38:50",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 18:22:36"
          },
          {
            "ticket_id": 8107,
            "ticket_number": "358099",
            "title": "Informação de reserva - SPT002601573655",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 17:38:55",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 197.72,
            "sla_met": false,
            "sla_breach_hours": 173.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:22:52"
          },
          {
            "ticket_id": 8109,
            "ticket_number": "358101",
            "title": "PEDIDO ORÇAMENTO GRUPO LEPLAN E SOLFERIAS",
            "priority": "P2",
            "created_at": "02/02/2026 18:11:45",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 18:11:45"
          },
          {
            "ticket_id": 8112,
            "ticket_number": "358104",
            "title": "Confirmação reserva Bedsonline 59-5726226",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 18:20:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 401.37,
            "sla_met": false,
            "sla_breach_hours": 377.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:39"
          },
          {
            "ticket_id": 8114,
            "ticket_number": "358106",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/02/2026 20:09:51",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:09:51"
          },
          {
            "ticket_id": 8115,
            "ticket_number": "358107",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/02/2026 20:09:56",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:09:56"
          },
          {
            "ticket_id": 8116,
            "ticket_number": "358108",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/02/2026 20:10:03",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:10:03"
          },
          {
            "ticket_id": 8118,
            "ticket_number": "358110",
            "title": "Pagamento da reserva – Ref PP891908, Sra. Marcia L",
            "priority": "P2",
            "created_at": "02/02/2026 20:10:12",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:38:17"
          },
          {
            "ticket_id": 8119,
            "ticket_number": "358111",
            "title": "Fwd: Viagify informa sobre a sua reserva 124355221",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 20:10:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 20:10:16"
          },
          {
            "ticket_id": 8120,
            "ticket_number": "358112",
            "title": "Confirmação de Reserva * File 427582",
            "priority": "P2",
            "created_at": "02/02/2026 20:10:25",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 21:02:55"
          },
          {
            "ticket_id": 8121,
            "ticket_number": "358113",
            "title": "Fwd: Viagify informa sobre a sua reserva 124355190",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 20:10:28",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 20:10:30"
          },
          {
            "ticket_id": 8122,
            "ticket_number": "358114",
            "title": "GBN-98535 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/02/2026 20:23:06",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:19:01"
          },
          {
            "ticket_id": 8125,
            "ticket_number": "358117",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "02/02/2026 20:36:21",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:40:32"
          },
          {
            "ticket_id": 8128,
            "ticket_number": "358120",
            "title": "Confirmação de reserva. Localizador: 3UEPIGYRMQ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/02/2026 22:19:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 397.38,
            "sla_met": false,
            "sla_breach_hours": 373.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:39"
          },
          {
            "ticket_id": 8131,
            "ticket_number": "358123",
            "title": "GBN-103269 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 22:48:20",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 22:48:20"
          },
          {
            "ticket_id": 8132,
            "ticket_number": "358124",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604541477",
            "priority": "P3",
            "created_at": "02/02/2026 23:03:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 188.0,
            "sla_met": false,
            "sla_breach_hours": 164.0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 19:04:36"
          },
          {
            "ticket_id": 8133,
            "ticket_number": "358125",
            "title": "NewBlue 6130379",
            "priority": "P2",
            "created_at": "02/02/2026 23:03:51",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 23:03:52"
          },
          {
            "ticket_id": 8134,
            "ticket_number": "358126",
            "title": "CONFIRMACION: Patr???cia  Lopes / OHTELS ISLANTILL",
            "priority": "P2",
            "created_at": "02/02/2026 23:24:05",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 00:04:19"
          },
          {
            "ticket_id": 8137,
            "ticket_number": "358129",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 23:51:07",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 19:44:24"
          },
          {
            "ticket_id": 8142,
            "ticket_number": "358134",
            "title": "CANCELACION: SRES. Patr???cia  Lopes / OHTELS ISLA",
            "priority": "P2",
            "created_at": "02/02/2026 23:51:24",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 00:03:18"
          },
          {
            "ticket_id": 8144,
            "ticket_number": "358136",
            "title": "Fwd: Viagify informa sobre a sua reserva 124366336",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 10:00:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 10:00:49"
          },
          {
            "ticket_id": 8146,
            "ticket_number": "358138",
            "title": "Fwd: Viagify informa sobre a sua reserva 124367806",
            "priority": "P2",
            "created_at": "03/02/2026 10:00:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 10:00:55"
          },
          {
            "ticket_id": 8149,
            "ticket_number": "358141",
            "title": "Fwd: Viagify informa sobre a sua reserva 124368606",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 10:02:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 10:02:39"
          },
          {
            "ticket_id": 8150,
            "ticket_number": "358142",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 10:02:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 10:02:41"
          },
          {
            "ticket_id": 8151,
            "ticket_number": "358143",
            "title": "Fwd: Q3NGXQ | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "03/02/2026 10:02:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 10:02:44"
          },
          {
            "ticket_id": 8152,
            "ticket_number": "358144",
            "title": "RV: Bom dia Filipe Cardoso: Bilhete e informações ",
            "priority": "P2",
            "created_at": "03/02/2026 10:02:47",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 10:02:52"
          },
          {
            "ticket_id": 8155,
            "ticket_number": "358147",
            "title": "Confirmação de reserva – Ref PP179160, Sr. Luis Ma",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 10:03:01",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 204.43,
            "sla_met": false,
            "sla_breach_hours": 180.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:29:29"
          },
          {
            "ticket_id": 8157,
            "ticket_number": "358149",
            "title": "GBN-103276 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 10:03:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 10:03:13"
          },
          {
            "ticket_id": 8160,
            "ticket_number": "358152",
            "title": "CONFIRMACION: Alda Maria Nunes / OHTELS ISLANTILLA",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 10:03:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 13:20:19"
          },
          {
            "ticket_id": 8162,
            "ticket_number": "358154",
            "title": "Vila Galé | Confirmação da Reserva Nº8968623",
            "priority": "P2",
            "created_at": "03/02/2026 10:03:31",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:15:54"
          },
          {
            "ticket_id": 8166,
            "ticket_number": "358158",
            "title": "Pagamento da reserva – Ref PP188133, Sr. Sergio Jo",
            "priority": "P2",
            "created_at": "03/02/2026 10:13:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:20:14"
          },
          {
            "ticket_id": 8168,
            "ticket_number": "358160",
            "title": "Confirmação de reserva – Ref PP188133, Sr. Sergio ",
            "priority": "P2",
            "created_at": "03/02/2026 10:13:57",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:30:39"
          },
          {
            "ticket_id": 8169,
            "ticket_number": "358161",
            "title": "Fwd: Viagify informa sobre a sua reserva 124368129",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 10:14:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 10:14:01"
          },
          {
            "ticket_id": 8170,
            "ticket_number": "358162",
            "title": "FW: Multibanco - File 428193/26",
            "priority": "P2",
            "created_at": "03/02/2026 11:16:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:31:31"
          },
          {
            "ticket_id": 8171,
            "ticket_number": "358163",
            "title": "URGENTE - VIAGEM 9 FEVEREIRO - PEDIDO INFORMAÇÃO -",
            "priority": "P2",
            "created_at": "03/02/2026 11:16:19",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:16:19"
          },
          {
            "ticket_id": 8173,
            "ticket_number": "358165",
            "title": "⏳ Campanha BLUE MONDAY 2026 prolongada — NEW BLUE ",
            "priority": "P2",
            "created_at": "03/02/2026 11:16:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:17:36"
          },
          {
            "ticket_id": 8174,
            "ticket_number": "358166",
            "title": "URGENTE | PNR SPT002601567778",
            "priority": "P2",
            "created_at": "03/02/2026 11:16:25",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:16:25"
          },
          {
            "ticket_id": 8176,
            "ticket_number": "358168",
            "title": "Signed: CVO 248800031.pdf",
            "priority": "P2",
            "created_at": "03/02/2026 11:34:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:34:46"
          },
          {
            "ticket_id": 8177,
            "ticket_number": "358169",
            "title": "Signed: RGPD 248800031.docx",
            "priority": "P2",
            "created_at": "03/02/2026 11:34:05",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:34:57"
          },
          {
            "ticket_id": 8178,
            "ticket_number": "358170",
            "title": "Signer signed: CVO 248800031.pdf",
            "priority": "P2",
            "created_at": "03/02/2026 11:34:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 11:35:35"
          },
          {
            "ticket_id": 8180,
            "ticket_number": "358172",
            "title": "RESERVA WL 338772",
            "priority": "P2",
            "created_at": "03/02/2026 12:01:20",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:17:38"
          },
          {
            "ticket_id": 8182,
            "ticket_number": "358174",
            "title": "URGENTE | Checck in voos",
            "priority": "P2",
            "created_at": "03/02/2026 12:40:10",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 12:40:10"
          },
          {
            "ticket_id": 8183,
            "ticket_number": "358175",
            "title": "Envio de Documentação * File 415693",
            "priority": "P2",
            "created_at": "03/02/2026 12:40:16",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:02:10"
          },
          {
            "ticket_id": 8184,
            "ticket_number": "358176",
            "title": "Fwd: Informações da reserva TTN-1231111139#9189955",
            "priority": "P2",
            "created_at": "03/02/2026 12:40:22",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 12:40:22"
          },
          {
            "ticket_id": 8185,
            "ticket_number": "358177",
            "title": "Fwd: Viagify informa sobre a sua reserva 124380533",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 12:40:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 12:40:27"
          },
          {
            "ticket_id": 8188,
            "ticket_number": "358180",
            "title": "Attendee List of Better Tourism Lisbon Travel Mark",
            "priority": "P2",
            "created_at": "03/02/2026 13:13:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:20:59"
          },
          {
            "ticket_id": 8189,
            "ticket_number": "358181",
            "title": "Pedido de informação",
            "priority": "P2",
            "created_at": "03/02/2026 13:21:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:21:44"
          },
          {
            "ticket_id": 8191,
            "ticket_number": "358183",
            "title": "📷🐭 Opções Mágicas na Disneyland Paris: adicione-as",
            "priority": "P2",
            "created_at": "03/02/2026 13:40:39",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:58:12"
          },
          {
            "ticket_id": 8195,
            "ticket_number": "358187",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/02/2026 14:17:14",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 14:17:14"
          },
          {
            "ticket_id": 8199,
            "ticket_number": "358191",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "03/02/2026 15:06:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 15:06:08"
          },
          {
            "ticket_id": 8201,
            "ticket_number": "358193",
            "title": "GBN-103390 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 15:15:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 15:15:19"
          },
          {
            "ticket_id": 8202,
            "ticket_number": "358194",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "03/02/2026 15:15:21",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 19:01:57"
          },
          {
            "ticket_id": 8209,
            "ticket_number": "358201",
            "title": "Fwd: Viagify informa sobre a sua reserva 124390698",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 16:14:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 16:14:35"
          },
          {
            "ticket_id": 8210,
            "ticket_number": "358202",
            "title": "loc 6125427 -nb",
            "priority": "P2",
            "created_at": "03/02/2026 16:40:44",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 5.47,
            "sla_met": false,
            "sla_breach_hours": 1.47,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 22:09:24"
          },
          {
            "ticket_id": 8211,
            "ticket_number": "358203",
            "title": "Confirmação reserva Bedsonline 217-2171396",
            "priority": "P2",
            "created_at": "03/02/2026 17:18:00",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 19:24:07"
          },
          {
            "ticket_id": 8213,
            "ticket_number": "358205",
            "title": "Re:[## 30996 ##] GBN-96257 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/02/2026 17:18:04",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 13:16:39"
          },
          {
            "ticket_id": 8214,
            "ticket_number": "358206",
            "title": "GBN-103272 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/02/2026 17:18:06",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 148.75,
            "sla_met": false,
            "sla_breach_hours": 144.75,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 22:03:40"
          },
          {
            "ticket_id": 8218,
            "ticket_number": "358210",
            "title": "Confirmação de reserva com localizador: 4060902",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 18:18:21",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 173.02,
            "sla_met": false,
            "sla_breach_hours": 149.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:19:22"
          },
          {
            "ticket_id": 8220,
            "ticket_number": "358212",
            "title": "Cotação Viagem de Grupo Madeira_Junho",
            "priority": "P2",
            "created_at": "03/02/2026 18:18:25",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 18:18:25"
          },
          {
            "ticket_id": 8221,
            "ticket_number": "358213",
            "title": "GBN-103474 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/02/2026 18:18:32",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 18:18:32"
          },
          {
            "ticket_id": 8223,
            "ticket_number": "358215",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604542341",
            "priority": "P3",
            "created_at": "03/02/2026 18:47:32",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 14:40:48"
          },
          {
            "ticket_id": 8224,
            "ticket_number": "358216",
            "title": "cotação W2M Grupo Funchal _ Albina Silva",
            "priority": "P2",
            "created_at": "03/02/2026 18:47:33",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 18:47:33"
          },
          {
            "ticket_id": 8225,
            "ticket_number": "358217",
            "title": "Fwd: We’ve improved our Group Booking Terms",
            "priority": "P2",
            "created_at": "03/02/2026 18:47:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 18:47:36"
          },
          {
            "ticket_id": 8226,
            "ticket_number": "358218",
            "title": "Re: Nova Viagem #260200045 - Passos Largos",
            "priority": "P2",
            "created_at": "03/02/2026 18:47:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 18:47:38"
          },
          {
            "ticket_id": 8227,
            "ticket_number": "358219",
            "title": "Subject. Soltour: Modificação de Voos: SPT00250154",
            "priority": "P2",
            "created_at": "03/02/2026 19:05:31",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 19:17:30"
          },
          {
            "ticket_id": 8229,
            "ticket_number": "358221",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "03/02/2026 20:47:41",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 20:47:42"
          },
          {
            "ticket_id": 8231,
            "ticket_number": "358223",
            "title": "Nova Viagem #260200063 - Liliana Pinho",
            "priority": "P2",
            "created_at": "03/02/2026 20:47:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 20:47:47"
          },
          {
            "ticket_id": 8232,
            "ticket_number": "358224",
            "title": "Número de informação da reserva: 6131618",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 20:47:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 16:40:59"
          },
          {
            "ticket_id": 8233,
            "ticket_number": "358225",
            "title": "GBN-103159 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/02/2026 20:47:53",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 21:36:50"
          },
          {
            "ticket_id": 8234,
            "ticket_number": "358226",
            "title": "Desconto por filho com autismo severo",
            "priority": "P2",
            "created_at": "03/02/2026 20:47:57",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 20:47:59"
          },
          {
            "ticket_id": 8236,
            "ticket_number": "358228",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 20:48:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:48:06"
          },
          {
            "ticket_id": 8237,
            "ticket_number": "358229",
            "title": "Reserva confirmada: Chip eSIM Civitatis Marrocos -",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 20:48:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/02/2026 20:48:08"
          },
          {
            "ticket_id": 8238,
            "ticket_number": "358230",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/02/2026 20:48:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 20:48:21"
          },
          {
            "ticket_id": 8240,
            "ticket_number": "358232",
            "title": "Confirmação de reserva – Ref PP583324, Sr. Jorge P",
            "priority": "P3",
            "created_at": "03/02/2026 21:27:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 17:21:03"
          },
          {
            "ticket_id": 8245,
            "ticket_number": "358237",
            "title": "Confirmacao 338942",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 22:25:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 18:21:10"
          },
          {
            "ticket_id": 8246,
            "ticket_number": "358238",
            "title": "Booking confirmation #ABK14833",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/02/2026 23:36:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 372.08,
            "sla_met": false,
            "sla_breach_hours": 348.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:39"
          },
          {
            "ticket_id": 8247,
            "ticket_number": "358239",
            "title": "Booking confirmation #ABK14844",
            "priority": "P3",
            "created_at": "03/02/2026 23:36:46",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 162.4,
            "sla_met": false,
            "sla_breach_hours": 138.4,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:01:11"
          },
          {
            "ticket_id": 8252,
            "ticket_number": "358244",
            "title": "GBN-103544 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "03/02/2026 23:41:41",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 23:41:41"
          },
          {
            "ticket_id": 8255,
            "ticket_number": "358247",
            "title": "LOC 338543 e 338541",
            "priority": "P2",
            "created_at": "03/02/2026 23:54:38",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 13.48,
            "sla_met": false,
            "sla_breach_hours": 9.48,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 13:24:28"
          },
          {
            "ticket_id": 8258,
            "ticket_number": "358250",
            "title": "Fwd: Viagify informa sobre a sua reserva 124410949",
            "priority": "P3",
            "created_at": "04/02/2026 10:18:27",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:18:28"
          },
          {
            "ticket_id": 8262,
            "ticket_number": "358254",
            "title": "Reserva de transfer em Sharm el Sheikh (Sharm el-S",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 10:21:14",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 60.12,
            "sla_met": false,
            "sla_breach_hours": 36.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:28:24"
          },
          {
            "ticket_id": 8263,
            "ticket_number": "358255",
            "title": "Reserva de transfer em Sharm el Sheikh (Aeroporto ",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:16",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:21:16"
          },
          {
            "ticket_id": 8264,
            "ticket_number": "358256",
            "title": "Mensagem sobre a reserva 2853867 - Civitatis",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 151.68,
            "sla_met": false,
            "sla_breach_hours": 127.68,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:02:39"
          },
          {
            "ticket_id": 8265,
            "ticket_number": "358257",
            "title": "Mensagem sobre a reserva 2853867 - Civitatis",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/02/2026 10:21:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 361.35,
            "sla_met": false,
            "sla_breach_hours": 337.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8266,
            "ticket_number": "358258",
            "title": "Mensagem sobre a reserva 2853866 - Civitatis",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:21:26"
          },
          {
            "ticket_id": 8267,
            "ticket_number": "358259",
            "title": "Mensagem sobre a reserva 2853866 - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 10:21:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 60.1,
            "sla_met": false,
            "sla_breach_hours": 36.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:27:48"
          },
          {
            "ticket_id": 8268,
            "ticket_number": "358260",
            "title": "Reserva de transfer em Sharm el-Sheij (Aeroporto d",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:29",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 151.78,
            "sla_met": false,
            "sla_breach_hours": 127.78,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:09:16"
          },
          {
            "ticket_id": 8272,
            "ticket_number": "358264",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 10:21:39",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 20:21:32"
          },
          {
            "ticket_id": 8275,
            "ticket_number": "358267",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 10:36:02",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 20:21:32"
          },
          {
            "ticket_id": 8277,
            "ticket_number": "358269",
            "title": "Confirmação de reserva 338942 ### TIME LIMIT EMISS",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 11:19:10",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 179.2,
            "sla_met": false,
            "sla_breach_hours": 155.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:31:55"
          },
          {
            "ticket_id": 8281,
            "ticket_number": "358273",
            "title": "[Pedido de Grupo] Brasil - Salvador - 2026-03-01 a",
            "priority": "P2",
            "created_at": "04/02/2026 12:03:12",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 12:06:06"
          },
          {
            "ticket_id": 8282,
            "ticket_number": "358274",
            "title": "[Pedido IATA] Lisboa → Dubai - 2026-02-26 (5 pax)",
            "priority": "P2",
            "created_at": "04/02/2026 12:09:08",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 12:09:58"
          },
          {
            "ticket_id": 8283,
            "ticket_number": "358275",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604496770",
            "priority": "P3",
            "created_at": "04/02/2026 12:18:39",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 151.33,
            "sla_met": false,
            "sla_breach_hours": 127.33,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 19:39:18"
          },
          {
            "ticket_id": 8296,
            "ticket_number": "358288",
            "title": "Confirmação de reserva com localizador: 4062279",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 15:00:37",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 55.42,
            "sla_met": false,
            "sla_breach_hours": 31.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:26:35"
          },
          {
            "ticket_id": 8301,
            "ticket_number": "358293",
            "title": "Confirmação de reserva com localizador: 4062392",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 15:53:21",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 11:42:30"
          },
          {
            "ticket_id": 8310,
            "ticket_number": "358302",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/02/2026 17:14:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 17:14:14"
          },
          {
            "ticket_id": 8311,
            "ticket_number": "358303",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 17:14:14",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 53.18,
            "sla_met": false,
            "sla_breach_hours": 29.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 22:25:26"
          },
          {
            "ticket_id": 8330,
            "ticket_number": "358322",
            "title": "Acessos Veturis",
            "priority": "P2",
            "created_at": "04/02/2026 19:26:26",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 19:26:27"
          },
          {
            "ticket_id": 8331,
            "ticket_number": "358323",
            "title": "Fwd: Viagify informa sobre a sua reserva 123501301",
            "priority": "P2",
            "created_at": "04/02/2026 20:02:52",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 20:02:52"
          },
          {
            "ticket_id": 8334,
            "ticket_number": "358326",
            "title": "GBN-103806 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 20:20:57",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 20:20:57"
          },
          {
            "ticket_id": 8336,
            "ticket_number": "358328",
            "title": "CONFIRMACION: Helena Isabel Lopes Silva Coutinho /",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/02/2026 20:42:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 351.0,
            "sla_met": false,
            "sla_breach_hours": 327.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8339,
            "ticket_number": "358331",
            "title": "Confirmação de reserva com localizador: 4062978",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 20:56:13",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 16:43:01"
          },
          {
            "ticket_id": 8342,
            "ticket_number": "358334",
            "title": "Confirmação de reserva com localizador: 4062981",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 20:56:20",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 16:43:01"
          },
          {
            "ticket_id": 8343,
            "ticket_number": "358335",
            "title": "Confirmação de reserva com localizador: 4062971",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 20:56:22",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 16:43:01"
          },
          {
            "ticket_id": 8344,
            "ticket_number": "358336",
            "title": "GBN-103815 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/02/2026 21:09:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 350.55,
            "sla_met": false,
            "sla_breach_hours": 326.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8346,
            "ticket_number": "358338",
            "title": "Confirmação de reserva com localizador: 4063019",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 21:31:37",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 17:23:07"
          },
          {
            "ticket_id": 8347,
            "ticket_number": "358339",
            "title": "Fwd: Viagify informa sobre a sua reserva 124457548",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 21:54:42",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/02/2026 21:54:44"
          },
          {
            "ticket_id": 8350,
            "ticket_number": "358342",
            "title": "Reserva confirmada: Free tour por Roma - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 23:33:33",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 167.0,
            "sla_met": false,
            "sla_breach_hours": 143.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:34:27"
          },
          {
            "ticket_id": 8351,
            "ticket_number": "358343",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 23:33:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 37.35,
            "sla_met": false,
            "sla_breach_hours": 13.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 12:55:05"
          },
          {
            "ticket_id": 8353,
            "ticket_number": "358345",
            "title": "Confirmação de reserva com localizador: 4063117",
            "priority": "Reservas sem Formulário",
            "created_at": "04/02/2026 23:33:50",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 19:23:17"
          },
          {
            "ticket_id": 8365,
            "ticket_number": "358357",
            "title": "TUI fly booking confirmation for your trip to Shar",
            "priority": "P2",
            "created_at": "05/02/2026 10:02:25",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:58:05"
          },
          {
            "ticket_id": 8367,
            "ticket_number": "358359",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "05/02/2026 10:02:30",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:58:15"
          },
          {
            "ticket_id": 8371,
            "ticket_number": "358363",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604543771",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 10:02:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 337.65,
            "sla_met": false,
            "sla_breach_hours": 313.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8375,
            "ticket_number": "358367",
            "title": "Confirmación del Loc 9106255",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 10:02:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 337.65,
            "sla_met": false,
            "sla_breach_hours": 313.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8378,
            "ticket_number": "358370",
            "title": "Fwd: Viagify informa sobre a sua reserva 124463460",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 10:03:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 10:03:01"
          },
          {
            "ticket_id": 8385,
            "ticket_number": "358377",
            "title": "Confirmação de reserva 338541",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 10:22:19",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 14:20:46"
          },
          {
            "ticket_id": 8387,
            "ticket_number": "358379",
            "title": "Fwd: V6WPXH | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "05/02/2026 10:43:50",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:43:50"
          },
          {
            "ticket_id": 8388,
            "ticket_number": "358380",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "05/02/2026 10:43:52",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:02:49"
          },
          {
            "ticket_id": 8389,
            "ticket_number": "358381",
            "title": "Fwd: Viagify informa sobre a sua reserva 124466760",
            "priority": "P2",
            "created_at": "05/02/2026 10:43:55",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:43:49"
          },
          {
            "ticket_id": 8391,
            "ticket_number": "358383",
            "title": "New updates for your Addis Ababa flight",
            "priority": "P2",
            "created_at": "05/02/2026 10:45:04",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 14:40:48"
          },
          {
            "ticket_id": 8393,
            "ticket_number": "358385",
            "title": "RE: Pagamento 6130659",
            "priority": "P2",
            "created_at": "05/02/2026 10:51:57",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 14:40:48"
          },
          {
            "ticket_id": 8397,
            "ticket_number": "358389",
            "title": "Fwd: Confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 11:46:41",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 11:46:42"
          },
          {
            "ticket_id": 8401,
            "ticket_number": "358393",
            "title": "Confirmación de la reserva con localizador: 406335",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 11:46:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/02/2026 15:40:54"
          },
          {
            "ticket_id": 8408,
            "ticket_number": "358400",
            "title": "Confirmação de reserva 339011 ### TIME LIMIT EMISS",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 13:08:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:04:00"
          },
          {
            "ticket_id": 8409,
            "ticket_number": "358401",
            "title": "Re:[## 30897 ##] GBN-98535 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "05/02/2026 13:08:10",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 15:31:05"
          },
          {
            "ticket_id": 8411,
            "ticket_number": "358403",
            "title": "Confirmacao 339011",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 13:08:17",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 29.68,
            "sla_met": false,
            "sla_breach_hours": 5.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 18:50:11"
          },
          {
            "ticket_id": 8424,
            "ticket_number": "358416",
            "title": "Booking payment confirmation by POS",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 15:10:59",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 151.4,
            "sla_met": false,
            "sla_breach_hours": 127.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:35:02"
          },
          {
            "ticket_id": 8425,
            "ticket_number": "358417",
            "title": "Confirmation of booking with locatorBN2QPE6Z",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 15:11:00",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 151.4,
            "sla_met": false,
            "sla_breach_hours": 127.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:35:21"
          },
          {
            "ticket_id": 8426,
            "ticket_number": "358418",
            "title": "Reserva Aérea YKGIRF",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 15:11:03",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 151.4,
            "sla_met": false,
            "sla_breach_hours": 127.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:35:50"
          },
          {
            "ticket_id": 8430,
            "ticket_number": "358422",
            "title": "Confirmación de la reserva con localizador: 406394",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 15:11:14",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 175.38,
            "sla_met": false,
            "sla_breach_hours": 151.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 22:35:12"
          },
          {
            "ticket_id": 8440,
            "ticket_number": "358432",
            "title": "Informação de reserva - SPT002601575704",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 16:30:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 331.2,
            "sla_met": false,
            "sla_breach_hours": 307.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8441,
            "ticket_number": "358433",
            "title": "Confirmação de reserva 339026### TIME LIMIT EMISSÃ",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 16:37:55",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 173.97,
            "sla_met": false,
            "sla_breach_hours": 149.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 22:36:08"
          },
          {
            "ticket_id": 8442,
            "ticket_number": "358434",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 4",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 16:37:57",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 331.07,
            "sla_met": false,
            "sla_breach_hours": 307.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8443,
            "ticket_number": "358435",
            "title": "Confirmação de reserva. Localizador: 4XP3U3EUAV",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 16:37:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 331.07,
            "sla_met": false,
            "sla_breach_hours": 307.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8444,
            "ticket_number": "358436",
            "title": "Confirmação reserva Bedsonline 207-15601754",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 16:59:09",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 30.87,
            "sla_met": false,
            "sla_breach_hours": 6.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:51:21"
          },
          {
            "ticket_id": 8446,
            "ticket_number": "358438",
            "title": "gbn ID de referência: 45365706",
            "priority": "P2",
            "created_at": "05/02/2026 17:24:58",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 21:21:38"
          },
          {
            "ticket_id": 8453,
            "ticket_number": "358445",
            "title": "RE: Pedido de cotação para Albânia W2MCS:015740002",
            "priority": "P2",
            "created_at": "05/02/2026 18:17:53",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 18:50:58"
          },
          {
            "ticket_id": 8454,
            "ticket_number": "358446",
            "title": "Pagamento da reserva – Ref PP892402, Sra. Carla Li",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 18:27:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 329.23,
            "sla_met": false,
            "sla_breach_hours": 305.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8456,
            "ticket_number": "358448",
            "title": "Veturis - credenciais",
            "priority": "P2",
            "created_at": "05/02/2026 18:41:38",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 18:41:39"
          },
          {
            "ticket_id": 8458,
            "ticket_number": "358450",
            "title": "GBN-104057 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 18:58:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 328.73,
            "sla_met": false,
            "sla_breach_hours": 304.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8459,
            "ticket_number": "358451",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "05/02/2026 18:58:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 20:10:13"
          },
          {
            "ticket_id": 8461,
            "ticket_number": "358453",
            "title": "GBN-104064 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 19:05:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 328.62,
            "sla_met": false,
            "sla_breach_hours": 304.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8466,
            "ticket_number": "358458",
            "title": "Informação de reserva - SPT002601583979",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 19:56:51",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 27.85,
            "sla_met": false,
            "sla_breach_hours": 3.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:47:59"
          },
          {
            "ticket_id": 8467,
            "ticket_number": "358459",
            "title": "Informação de reserva - SPT002601583979",
            "priority": "Reservas sem Formulário",
            "created_at": "05/02/2026 19:56:58",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 27.85,
            "sla_met": false,
            "sla_breach_hours": 3.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:48:28"
          },
          {
            "ticket_id": 8471,
            "ticket_number": "358463",
            "title": "Envio de documentação - FILE 427904",
            "priority": "P2",
            "created_at": "05/02/2026 20:34:30",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 20:38:36"
          },
          {
            "ticket_id": 8472,
            "ticket_number": "358464",
            "title": "URGENTE - MUDANÇA DE último nome EM RESERVA - solt",
            "priority": "P2",
            "created_at": "05/02/2026 20:37:40",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 20:37:41"
          },
          {
            "ticket_id": 8473,
            "ticket_number": "358465",
            "title": "Confirmacao 339057",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 20:41:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 327.0,
            "sla_met": false,
            "sla_breach_hours": 303.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8475,
            "ticket_number": "358467",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604544796",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 22:03:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 325.65,
            "sla_met": false,
            "sla_breach_hours": 301.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:38"
          },
          {
            "ticket_id": 8477,
            "ticket_number": "358469",
            "title": "Reserva confirmada: Excursão ao PortAventura Park ",
            "priority": "P3",
            "created_at": "05/02/2026 22:18:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 168.32,
            "sla_met": false,
            "sla_breach_hours": 144.32,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 22:37:51"
          },
          {
            "ticket_id": 8480,
            "ticket_number": "358472",
            "title": "GBN-104117 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/02/2026 23:53:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 323.82,
            "sla_met": false,
            "sla_breach_hours": 299.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8482,
            "ticket_number": "358474",
            "title": "Código TELDAR",
            "priority": "P2",
            "created_at": "05/02/2026 23:54:11",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 23:54:11"
          },
          {
            "ticket_id": 8483,
            "ticket_number": "358475",
            "title": "Confirmación de reserva. Aparthotel Playa Garden S",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 00:15:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 323.45,
            "sla_met": false,
            "sla_breach_hours": 299.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8490,
            "ticket_number": "358482",
            "title": "GBN-99921 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 10:08:46",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 13.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:45:47"
          },
          {
            "ticket_id": 8491,
            "ticket_number": "358483",
            "title": "GBN-104131 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 10:08:52",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 7.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 17:29:26"
          },
          {
            "ticket_id": 8493,
            "ticket_number": "358485",
            "title": "GBN-104129 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 10:08:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 105.0,
            "sla_met": false,
            "sla_breach_hours": 81.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:09:53"
          },
          {
            "ticket_id": 8494,
            "ticket_number": "358486",
            "title": "GBN-104128 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 10:09:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 313.55,
            "sla_met": false,
            "sla_breach_hours": 289.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8501,
            "ticket_number": "358493",
            "title": "Convite Exclusivo: Jantar \"Isto é PARANÁ\" em Lisbo",
            "priority": "P2",
            "created_at": "06/02/2026 11:21:08",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:42:24"
          },
          {
            "ticket_id": 8502,
            "ticket_number": "358494",
            "title": "Reserva Aéreo [ERROR_AIR-3DE22D7E6E] - Erro Técnic",
            "priority": "P2",
            "created_at": "06/02/2026 11:21:10",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:26:17"
          },
          {
            "ticket_id": 8504,
            "ticket_number": "358496",
            "title": "Reserva Aéreo [ERROR_AIR-B2B31A2B94] - Erro Técnic",
            "priority": "P2",
            "created_at": "06/02/2026 11:21:16",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:26:17"
          },
          {
            "ticket_id": 8513,
            "ticket_number": "358505",
            "title": "Fwd: Viagify informa sobre a sua reserva 124508343",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 11:47:20",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 11:47:21"
          },
          {
            "ticket_id": 8517,
            "ticket_number": "358509",
            "title": "Criação de processo File 428883/26",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 12:08:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 81.77,
            "sla_met": false,
            "sla_breach_hours": 57.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 21:55:04"
          },
          {
            "ticket_id": 8519,
            "ticket_number": "358511",
            "title": "Fwd: Pedido de cotação mala extra - 339011  e 3390",
            "priority": "P3",
            "created_at": "06/02/2026 12:39:12",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 174.07,
            "sla_met": false,
            "sla_breach_hours": 150.07,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:44:01"
          },
          {
            "ticket_id": 8521,
            "ticket_number": "358513",
            "title": "Información de reserva número: 1774427",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 13:21:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 165.8,
            "sla_met": false,
            "sla_breach_hours": 141.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:09:54"
          },
          {
            "ticket_id": 8523,
            "ticket_number": "358515",
            "title": "Re: Nova Viagem #260200118 - Benice Travel",
            "priority": "P2",
            "created_at": "06/02/2026 13:22:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 13:22:40"
          },
          {
            "ticket_id": 8531,
            "ticket_number": "358523",
            "title": "Informação de reserva - SPT002601583979",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 14:48:03",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 80.88,
            "sla_met": false,
            "sla_breach_hours": 56.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:41:44"
          },
          {
            "ticket_id": 8534,
            "ticket_number": "358526",
            "title": "Acesso ao Veturis",
            "priority": "P2",
            "created_at": "06/02/2026 15:06:52",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 15:06:52"
          },
          {
            "ticket_id": 8537,
            "ticket_number": "358529",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604545460",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 16:22:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 307.33,
            "sla_met": false,
            "sla_breach_hours": 283.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8538,
            "ticket_number": "358530",
            "title": "GBN-104228 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 16:22:09",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 16:22:09"
          },
          {
            "ticket_id": 8539,
            "ticket_number": "358531",
            "title": "Fwd: Viagify informa sobre a sua reserva 124530725",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 16:22:11",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 16:22:13"
          },
          {
            "ticket_id": 8541,
            "ticket_number": "358533",
            "title": "Criação de processo File 428927/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 16:22:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 307.33,
            "sla_met": false,
            "sla_breach_hours": 283.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8544,
            "ticket_number": "358536",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 17:24:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 17:24:54"
          },
          {
            "ticket_id": 8545,
            "ticket_number": "358537",
            "title": "GBN-104281 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 17:24:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 161.72,
            "sla_met": false,
            "sla_breach_hours": 137.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:07:51"
          },
          {
            "ticket_id": 8548,
            "ticket_number": "358540",
            "title": "GBN-104290 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 17:29:33",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 97.7,
            "sla_met": false,
            "sla_breach_hours": 73.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:12:11"
          },
          {
            "ticket_id": 8554,
            "ticket_number": "358546",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "06/02/2026 18:23:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 18:40:46"
          },
          {
            "ticket_id": 8555,
            "ticket_number": "358547",
            "title": "Especial GRUPOS BENIDORM",
            "priority": "P2",
            "created_at": "06/02/2026 18:23:31",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 19:55:06"
          },
          {
            "ticket_id": 8557,
            "ticket_number": "358549",
            "title": "Re:[## 31434 ##] GBN-104131 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "06/02/2026 18:59:35",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 19:06:52"
          },
          {
            "ticket_id": 8559,
            "ticket_number": "358551",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 19:52:14",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 63.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 11:41:32"
          },
          {
            "ticket_id": 8560,
            "ticket_number": "358552",
            "title": "Información de reserva número: 1774543",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 19:52:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 11:41:32"
          },
          {
            "ticket_id": 8561,
            "ticket_number": "358553",
            "title": "GBN Travel: Resend booking confirmation - GBN-9130",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 19:52:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 303.83,
            "sla_met": false,
            "sla_breach_hours": 279.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8562,
            "ticket_number": "358554",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/02/2026 19:52:41",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 19:52:41"
          },
          {
            "ticket_id": 8563,
            "ticket_number": "358555",
            "title": "asunto",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 19:52:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.8,
            "sla_met": false,
            "sla_breach_hours": 39.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 11:41:32"
          },
          {
            "ticket_id": 8564,
            "ticket_number": "358556",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/02/2026 19:52:52",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 19:52:52"
          },
          {
            "ticket_id": 8565,
            "ticket_number": "358557",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 19:56:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 303.77,
            "sla_met": false,
            "sla_breach_hours": 279.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8566,
            "ticket_number": "358558",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/02/2026 19:56:23",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 19:56:23"
          },
          {
            "ticket_id": 8568,
            "ticket_number": "358560",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 20:13:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 303.48,
            "sla_met": false,
            "sla_breach_hours": 279.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8569,
            "ticket_number": "358561",
            "title": "Civitatis - Re: Tour noturno por Paris - París",
            "priority": "P2",
            "created_at": "06/02/2026 20:13:09",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 20.62,
            "sla_met": false,
            "sla_breach_hours": 16.62,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 16:50:22"
          },
          {
            "ticket_id": 8570,
            "ticket_number": "358562",
            "title": "Esclarecimento - GBN-91302",
            "priority": "P2",
            "created_at": "06/02/2026 20:13:14",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 20:13:14"
          },
          {
            "ticket_id": 8571,
            "ticket_number": "358563",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/02/2026 20:13:24",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 20:13:24"
          },
          {
            "ticket_id": 8572,
            "ticket_number": "358564",
            "title": "GBN-104355 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 20:13:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.8,
            "sla_met": false,
            "sla_breach_hours": 39.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 12:01:34"
          },
          {
            "ticket_id": 8573,
            "ticket_number": "358565",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/02/2026 20:13:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 20:13:41"
          },
          {
            "ticket_id": 8574,
            "ticket_number": "358566",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/02/2026 20:13:46",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 20:13:46"
          },
          {
            "ticket_id": 8576,
            "ticket_number": "358568",
            "title": "Icárion - Balcãs Completo - 18/09/2026 - 6250889 -",
            "priority": "P2",
            "created_at": "06/02/2026 20:25:31",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 20:36:22"
          },
          {
            "ticket_id": 8578,
            "ticket_number": "358570",
            "title": "Fwd: Viagify informa sobre a sua reserva 124544606",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 21:04:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 21:04:08"
          },
          {
            "ticket_id": 8579,
            "ticket_number": "358571",
            "title": "Fwd: Confirmación de reserva",
            "priority": "P3",
            "created_at": "06/02/2026 21:04:11",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 21:04:12"
          },
          {
            "ticket_id": 8581,
            "ticket_number": "358573",
            "title": "Confirmação de reserva com localizador: 4066440",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 21:53:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 63.8,
            "sla_met": false,
            "sla_breach_hours": 39.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 13:41:47"
          },
          {
            "ticket_id": 8583,
            "ticket_number": "358575",
            "title": "Confirmación del Loc 9106927",
            "priority": "P2",
            "created_at": "06/02/2026 22:44:29",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 22:53:20"
          },
          {
            "ticket_id": 8586,
            "ticket_number": "358578",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:00:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 300.7,
            "sla_met": false,
            "sla_breach_hours": 276.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:37"
          },
          {
            "ticket_id": 8588,
            "ticket_number": "358580",
            "title": "Esclarecimento Programa Safari de 2 dias/1 noite e",
            "priority": "P2",
            "created_at": "06/02/2026 23:04:30",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 23:04:31"
          },
          {
            "ticket_id": 8589,
            "ticket_number": "358581",
            "title": "Fwd: Viagify informa sobre a sua reserva 124549660",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:13:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:13:06"
          },
          {
            "ticket_id": 8590,
            "ticket_number": "358582",
            "title": "Fwd: Viagify informa sobre a sua reserva 124549393",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:13:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:13:09"
          },
          {
            "ticket_id": 8592,
            "ticket_number": "358584",
            "title": "Fwd: Viagify informa sobre a sua reserva 124548042",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:13:15",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/02/2026 23:13:16"
          },
          {
            "ticket_id": 8596,
            "ticket_number": "358588",
            "title": "Confirmação de reserva – Ref PP541834, Sr. Antonio",
            "priority": "P3",
            "created_at": "06/02/2026 23:16:06",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 63.75,
            "sla_met": false,
            "sla_breach_hours": 39.75,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 15:01:56"
          },
          {
            "ticket_id": 8598,
            "ticket_number": "358590",
            "title": "GBN-104390 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:22:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 300.33,
            "sla_met": false,
            "sla_breach_hours": 276.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8599,
            "ticket_number": "358591",
            "title": "GBN-104392 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/02/2026 23:30:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 300.2,
            "sla_met": false,
            "sla_breach_hours": 276.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8601,
            "ticket_number": "358593",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/02/2026 23:42:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 23:42:51"
          },
          {
            "ticket_id": 8602,
            "ticket_number": "358594",
            "title": "Confirmação de reserva com localizador: 4066512",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 00:02:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 299.67,
            "sla_met": false,
            "sla_breach_hours": 275.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8603,
            "ticket_number": "358595",
            "title": "Confirmação reserva de actividade localizador A4B7",
            "priority": "P3",
            "created_at": "07/02/2026 10:03:28",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:02:00"
          },
          {
            "ticket_id": 8608,
            "ticket_number": "358600",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "07/02/2026 10:03:49",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 10:03:49"
          },
          {
            "ticket_id": 8610,
            "ticket_number": "358602",
            "title": "GBN-104400 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 10:04:00",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 289.63,
            "sla_met": false,
            "sla_breach_hours": 265.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8611,
            "ticket_number": "358603",
            "title": "Reserva confirmada: Visita guiada pelo Vaticano e ",
            "priority": "Reservas sem Formulário",
            "created_at": "07/02/2026 10:04:04",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 61.67,
            "sla_met": false,
            "sla_breach_hours": 37.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:44:13"
          },
          {
            "ticket_id": 8612,
            "ticket_number": "358604",
            "title": "Reserva confirmada: Visita guiada pelo Vaticano e ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 10:04:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/02/2026 10:04:08"
          },
          {
            "ticket_id": 8613,
            "ticket_number": "358605",
            "title": "Voucher reserva actividade localizador A4B72E3689",
            "priority": "P3",
            "created_at": "07/02/2026 10:04:11",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:02:01"
          },
          {
            "ticket_id": 8614,
            "ticket_number": "358606",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 10:04:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 16:02:01"
          },
          {
            "ticket_id": 8615,
            "ticket_number": "358607",
            "title": "Confirmação de reserva. Localizador: 71IUCHY6CL",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 10:04:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 16:02:01"
          },
          {
            "ticket_id": 8618,
            "ticket_number": "358610",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546033",
            "priority": "Reservas sem Formulário",
            "created_at": "07/02/2026 11:20:54",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 60.37,
            "sla_met": false,
            "sla_breach_hours": 36.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:43:25"
          },
          {
            "ticket_id": 8620,
            "ticket_number": "358612",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546148",
            "priority": "P3",
            "created_at": "07/02/2026 13:05:57",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 53.93,
            "sla_met": false,
            "sla_breach_hours": 29.93,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:02:30"
          },
          {
            "ticket_id": 8627,
            "ticket_number": "358619",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546188",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/02/2026 14:08:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 285.55,
            "sla_met": false,
            "sla_breach_hours": 261.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8639,
            "ticket_number": "358631",
            "title": "Fwd: Viagify informa sobre a sua reserva 124613257",
            "priority": "P2",
            "created_at": "09/02/2026 10:02:20",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:02:21"
          },
          {
            "ticket_id": 8640,
            "ticket_number": "358632",
            "title": "Fwd: Viagify informa sobre a sua reserva 124596795",
            "priority": "P2",
            "created_at": "09/02/2026 10:02:23",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:02:24"
          },
          {
            "ticket_id": 8642,
            "ticket_number": "358634",
            "title": "Fwd: Your request ECPTBMFK01 has been changed",
            "priority": "P2",
            "created_at": "09/02/2026 10:02:30",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:02:30"
          },
          {
            "ticket_id": 8644,
            "ticket_number": "358636",
            "title": "Fwd: PRSTFS | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "09/02/2026 10:02:37",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:02:37"
          },
          {
            "ticket_id": 8645,
            "ticket_number": "358637",
            "title": "Nova reserva para Marraquexe",
            "priority": "P2",
            "created_at": "09/02/2026 10:21:27",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 8.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:39:38"
          },
          {
            "ticket_id": 8647,
            "ticket_number": "358639",
            "title": "Nova reserva para Marraquexe",
            "priority": "P2",
            "created_at": "09/02/2026 10:21:32",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 8.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:39:38"
          },
          {
            "ticket_id": 8649,
            "ticket_number": "358641",
            "title": "Fwd: O seu voo para Madrid é em breve | Faça um Up",
            "priority": "P2",
            "created_at": "09/02/2026 10:21:37",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:21:38"
          },
          {
            "ticket_id": 8650,
            "ticket_number": "358642",
            "title": "RV: Confirmacion de la reserva Transavia: L98PWI",
            "priority": "P2",
            "created_at": "09/02/2026 10:21:41",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 8.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:40:23"
          },
          {
            "ticket_id": 8660,
            "ticket_number": "358652",
            "title": "Este mês, a Bulgária surpreende e recompensa.",
            "priority": "P2",
            "created_at": "09/02/2026 10:35:20",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 12:32:17"
          },
          {
            "ticket_id": 8663,
            "ticket_number": "358655",
            "title": "Confirmação de reserva – Ref PP129239, Sr. Marcio ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:35:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 12:11:30"
          },
          {
            "ticket_id": 8666,
            "ticket_number": "358658",
            "title": "Confirmacao 339181",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 10:35:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 13.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:49:10"
          },
          {
            "ticket_id": 8677,
            "ticket_number": "358669",
            "title": "Número de informação da reserva: 6132327",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 30.72,
            "sla_met": false,
            "sla_breach_hours": 6.72,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:20:53"
          },
          {
            "ticket_id": 8678,
            "ticket_number": "358670",
            "title": "Icárion - Balcãs Completo - 18/09/2026 - 6252130 -",
            "priority": "P2",
            "created_at": "09/02/2026 10:38:57",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 8.82,
            "sla_met": false,
            "sla_breach_hours": 4.82,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 19:28:42"
          },
          {
            "ticket_id": 8680,
            "ticket_number": "358672",
            "title": "GBN-104539 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "09/02/2026 10:39:03",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:39:03"
          },
          {
            "ticket_id": 8682,
            "ticket_number": "358674",
            "title": "Criação de processo File 429171/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:39:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 241.05,
            "sla_met": false,
            "sla_breach_hours": 217.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:36"
          },
          {
            "ticket_id": 8686,
            "ticket_number": "358678",
            "title": "Número de informação da reserva: 6132310",
            "priority": "P3",
            "created_at": "09/02/2026 10:44:42",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 14:41:52"
          },
          {
            "ticket_id": 8689,
            "ticket_number": "358681",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "09/02/2026 10:44:55",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 14:41:52"
          },
          {
            "ticket_id": 8690,
            "ticket_number": "358682",
            "title": "loc 339158 soltropico - cancelamento",
            "priority": "P2",
            "created_at": "09/02/2026 10:46:01",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:46:02"
          },
          {
            "ticket_id": 8692,
            "ticket_number": "358684",
            "title": "Informação de reserva - SPT002601584842",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 14:41:52"
          },
          {
            "ticket_id": 8705,
            "ticket_number": "358697",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546362",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 10:46:52",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 14:41:53"
          },
          {
            "ticket_id": 8709,
            "ticket_number": "358701",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546339",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:47:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 14:41:53"
          },
          {
            "ticket_id": 8710,
            "ticket_number": "358702",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546349",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:47:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 14:41:53"
          },
          {
            "ticket_id": 8711,
            "ticket_number": "358703",
            "title": "Confirmação de reserva com localizador: 4067147",
            "priority": "P2",
            "created_at": "09/02/2026 10:47:08",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 12:12:43"
          },
          {
            "ticket_id": 8713,
            "ticket_number": "358705",
            "title": "GBN-104514 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "09/02/2026 10:47:16",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:47:16"
          },
          {
            "ticket_id": 8715,
            "ticket_number": "358707",
            "title": "GBN-104519 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 10:47:23",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 10:47:23"
          },
          {
            "ticket_id": 8716,
            "ticket_number": "358708",
            "title": "Confirmação de reserva com localizador: 4067102",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:47:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 12:09:47"
          },
          {
            "ticket_id": 8717,
            "ticket_number": "358709",
            "title": "Confirmação de reserva. Localizador: 4OEITD7ON5",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 10:47:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 240.92,
            "sla_met": false,
            "sla_breach_hours": 216.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8721,
            "ticket_number": "358713",
            "title": "Fwd: ANWB8L | Protege a tua viagem a Ponta Delgada",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:09",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:10"
          },
          {
            "ticket_id": 8722,
            "ticket_number": "358714",
            "title": "cotação grupo Albina",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:12",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:12"
          },
          {
            "ticket_id": 8728,
            "ticket_number": "358720",
            "title": "Fwd: V6WPXH | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:33",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:33"
          },
          {
            "ticket_id": 8729,
            "ticket_number": "358721",
            "title": "GBN-104486 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:39",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:39"
          },
          {
            "ticket_id": 8736,
            "ticket_number": "358728",
            "title": "GBN-104531 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 11:17:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 240.4,
            "sla_met": false,
            "sla_breach_hours": 216.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8739,
            "ticket_number": "358731",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "09/02/2026 11:51:41",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 15:41:58"
          },
          {
            "ticket_id": 8743,
            "ticket_number": "358735",
            "title": "INFORMACION CLIENTE 71IUCHY6CL Maria João Mendeiro",
            "priority": "P2",
            "created_at": "09/02/2026 12:21:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 8.3,
            "sla_met": false,
            "sla_breach_hours": 4.3,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 20:39:49"
          },
          {
            "ticket_id": 8755,
            "ticket_number": "358747",
            "title": "Confirmação de reserva para For PT004157 70075958",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 14:32:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 237.15,
            "sla_met": false,
            "sla_breach_hours": 213.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8756,
            "ticket_number": "358748",
            "title": "Re:[## 31506 ##] GBN-103016 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "09/02/2026 14:32:47",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:22:21"
          },
          {
            "ticket_id": 8757,
            "ticket_number": "358749",
            "title": "Confirmação de reserva para For PT004157 70075958",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 14:32:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 237.15,
            "sla_met": false,
            "sla_breach_hours": 213.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8761,
            "ticket_number": "358753",
            "title": "Loc 604545460 travelplan",
            "priority": "P2",
            "created_at": "09/02/2026 15:43:10",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 15:43:11"
          },
          {
            "ticket_id": 8762,
            "ticket_number": "358754",
            "title": "Confirmação de reserva para For PT004157 70075958",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 15:43:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 14:32:50"
          },
          {
            "ticket_id": 8763,
            "ticket_number": "358755",
            "title": "Informação de reserva - SPT002601584842",
            "priority": "P2",
            "created_at": "09/02/2026 15:43:53",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:55:43"
          },
          {
            "ticket_id": 8770,
            "ticket_number": "358762",
            "title": "Confirmación de reserva 93128420",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 16:42:32",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 235.0,
            "sla_met": false,
            "sla_breach_hours": 211.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8771,
            "ticket_number": "358763",
            "title": "Informação de reserva - SPT002601577518",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 16:42:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 234.98,
            "sla_met": false,
            "sla_breach_hours": 210.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8773,
            "ticket_number": "358765",
            "title": "Cancelamento de reserva 339158",
            "priority": "P2",
            "created_at": "09/02/2026 16:42:45",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:26:43"
          },
          {
            "ticket_id": 8777,
            "ticket_number": "358769",
            "title": "Credenciais veturis",
            "priority": "P2",
            "created_at": "09/02/2026 17:14:25",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 17:14:25"
          },
          {
            "ticket_id": 8778,
            "ticket_number": "358770",
            "title": "Re: Acesso ao Veturis",
            "priority": "P2",
            "created_at": "09/02/2026 17:14:27",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 17:14:27"
          },
          {
            "ticket_id": 8786,
            "ticket_number": "358778",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 18:05:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.52,
            "sla_met": false,
            "sla_breach_hours": 4.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 22:36:47"
          },
          {
            "ticket_id": 8787,
            "ticket_number": "358779",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 18:47:09",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 5.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/02/2026 23:51:05"
          },
          {
            "ticket_id": 8788,
            "ticket_number": "358780",
            "title": "GBN-104740 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 18:47:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 232.92,
            "sla_met": false,
            "sla_breach_hours": 208.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8790,
            "ticket_number": "358782",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 18:47:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 232.92,
            "sla_met": false,
            "sla_breach_hours": 208.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8791,
            "ticket_number": "358783",
            "title": "Comprovativo Transação  - Pagamento de Serviços",
            "priority": "P2",
            "created_at": "09/02/2026 18:48:32",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 19:09:24"
          },
          {
            "ticket_id": 8793,
            "ticket_number": "358785",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 19:12:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 232.5,
            "sla_met": false,
            "sla_breach_hours": 208.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8795,
            "ticket_number": "358787",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 20:10:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 231.52,
            "sla_met": false,
            "sla_breach_hours": 207.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8796,
            "ticket_number": "358788",
            "title": "Atlânticoline - BTL 2026  // 2026 BTL Trade – Atân",
            "priority": "P2",
            "created_at": "09/02/2026 20:10:45",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 20:12:12"
          },
          {
            "ticket_id": 8797,
            "ticket_number": "358789",
            "title": "Informacoes easypay",
            "priority": "P2",
            "created_at": "09/02/2026 20:10:49",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 20:13:40"
          },
          {
            "ticket_id": 8800,
            "ticket_number": "358792",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "P3",
            "created_at": "09/02/2026 20:10:58",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 21.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:46:19"
          },
          {
            "ticket_id": 8802,
            "ticket_number": "358794",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 20:11:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 231.52,
            "sla_met": false,
            "sla_breach_hours": 207.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8803,
            "ticket_number": "358795",
            "title": "Reserva soltropico em WL",
            "priority": "P2",
            "created_at": "09/02/2026 20:11:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 20:11:40"
          },
          {
            "ticket_id": 8810,
            "ticket_number": "358802",
            "title": "GBN-104777 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 21:29:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 230.22,
            "sla_met": false,
            "sla_breach_hours": 206.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8811,
            "ticket_number": "358803",
            "title": "Ethiopian flight change Advice",
            "priority": "P2",
            "created_at": "09/02/2026 21:33:29",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 21:43:20"
          },
          {
            "ticket_id": 8813,
            "ticket_number": "358805",
            "title": "GBN-104792 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "09/02/2026 22:18:20",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 22:18:20"
          },
          {
            "ticket_id": 8815,
            "ticket_number": "358807",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/02/2026 22:26:46",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 229.25,
            "sla_met": false,
            "sla_breach_hours": 205.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:35"
          },
          {
            "ticket_id": 8816,
            "ticket_number": "358808",
            "title": "Informação de reserva - SPT002601585681",
            "priority": "P3",
            "created_at": "09/02/2026 22:59:28",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 19.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:13:57"
          },
          {
            "ticket_id": 8817,
            "ticket_number": "358809",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "09/02/2026 23:23:38",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 23.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:17:36"
          },
          {
            "ticket_id": 8818,
            "ticket_number": "358810",
            "title": "Icárion - Balcãs Completo - 18/09/2026 - 6255071 -",
            "priority": "P2",
            "created_at": "09/02/2026 23:45:54",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 23:46:36"
          },
          {
            "ticket_id": 8822,
            "ticket_number": "358814",
            "title": "Fwd: Viagify informa sobre a sua reserva 124663881",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 10:10:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 10:10:24"
          },
          {
            "ticket_id": 8824,
            "ticket_number": "358816",
            "title": "Signer signed: RGPD 245700030.docx",
            "priority": "P2",
            "created_at": "10/02/2026 10:10:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:22:07"
          },
          {
            "ticket_id": 8827,
            "ticket_number": "358819",
            "title": "GBN-104810 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 10:10:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 217.52,
            "sla_met": false,
            "sla_breach_hours": 193.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8828,
            "ticket_number": "358820",
            "title": "GBN-104812 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 10:10:46",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 217.52,
            "sla_met": false,
            "sla_breach_hours": 193.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8830,
            "ticket_number": "358822",
            "title": "MSC Cruises Document - 2600101001012291",
            "priority": "P3",
            "created_at": "10/02/2026 10:10:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 7.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:47:59"
          },
          {
            "ticket_id": 8831,
            "ticket_number": "358823",
            "title": "MSC Cruises Document - 2600101001012290",
            "priority": "P3",
            "created_at": "10/02/2026 10:11:02",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 49.17,
            "sla_met": false,
            "sla_breach_hours": 25.17,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 11:21:47"
          },
          {
            "ticket_id": 8832,
            "ticket_number": "358824",
            "title": "MSC Cruises Document - 2600101001012292",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 10:11:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 217.52,
            "sla_met": false,
            "sla_breach_hours": 193.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8834,
            "ticket_number": "358826",
            "title": "GBN-104809 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 10:11:13",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 217.52,
            "sla_met": false,
            "sla_breach_hours": 193.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8835,
            "ticket_number": "358827",
            "title": "Signer signed: RGPD 24100903.docx",
            "priority": "P2",
            "created_at": "10/02/2026 10:11:17",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:20:05"
          },
          {
            "ticket_id": 8836,
            "ticket_number": "358828",
            "title": "Signed: CVO 24100903.pdf",
            "priority": "P2",
            "created_at": "10/02/2026 10:11:21",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:20:05"
          },
          {
            "ticket_id": 8837,
            "ticket_number": "358829",
            "title": "Signed: RGPD 24100903.docx",
            "priority": "P2",
            "created_at": "10/02/2026 10:11:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:20:05"
          },
          {
            "ticket_id": 8838,
            "ticket_number": "358830",
            "title": "Confirmacao 339241",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 10:11:27",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 60.82,
            "sla_met": false,
            "sla_breach_hours": 36.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 23:01:07"
          },
          {
            "ticket_id": 8840,
            "ticket_number": "358832",
            "title": "Confirmação de reserva 339241 ### TIME LIMIT EMISS",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 10:43:21",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 20:42:35"
          },
          {
            "ticket_id": 8842,
            "ticket_number": "358834",
            "title": "Informação de reserva - SPT002601585681",
            "priority": "P3",
            "created_at": "10/02/2026 10:52:11",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 6.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:50:50"
          },
          {
            "ticket_id": 8844,
            "ticket_number": "358836",
            "title": "Confirmação de reserva com localizador: 4069807",
            "priority": "P3",
            "created_at": "10/02/2026 10:52:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 20:42:35"
          },
          {
            "ticket_id": 8846,
            "ticket_number": "358838",
            "title": "Nova Confirmação de reserva 339011### TIME LIMIT E",
            "priority": "P3",
            "created_at": "10/02/2026 11:25:11",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 6.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:51:19"
          },
          {
            "ticket_id": 8848,
            "ticket_number": "358840",
            "title": "GBN-104833 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 11:32:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 216.17,
            "sla_met": false,
            "sla_breach_hours": 192.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8849,
            "ticket_number": "358841",
            "title": "Nova Confirmação de reserva 339026### TIME LIMIT E",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 11:32:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 216.17,
            "sla_met": false,
            "sla_breach_hours": 192.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8852,
            "ticket_number": "358844",
            "title": "GBN-104804 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/02/2026 11:56:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 11:56:34"
          },
          {
            "ticket_id": 8854,
            "ticket_number": "358846",
            "title": "COTIZACION GRUPO 100362 // Solicitud cotización gr",
            "priority": "P2",
            "created_at": "10/02/2026 11:56:41",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 15:44:36"
          },
          {
            "ticket_id": 8855,
            "ticket_number": "358847",
            "title": "GBN-104841 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 11:56:47",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 11:56:47"
          },
          {
            "ticket_id": 8856,
            "ticket_number": "358848",
            "title": "Fwd: Informações importantes antes da partida",
            "priority": "P2",
            "created_at": "10/02/2026 12:07:39",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 12:07:40"
          },
          {
            "ticket_id": 8860,
            "ticket_number": "358852",
            "title": "Fwd: Descubra o lado cultural do Dubai!",
            "priority": "P2",
            "created_at": "10/02/2026 12:55:10",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 12:55:10"
          },
          {
            "ticket_id": 8861,
            "ticket_number": "358853",
            "title": "⚠️ Aviso importante de segurança | Email Airmet ⚠️",
            "priority": "P2",
            "created_at": "10/02/2026 12:55:12",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 13:22:33"
          },
          {
            "ticket_id": 8863,
            "ticket_number": "358855",
            "title": "GBN-104742 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 12:55:19",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 33.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 22:42:46"
          },
          {
            "ticket_id": 8864,
            "ticket_number": "358856",
            "title": "Envio de Documentação * File 428883",
            "priority": "P3",
            "created_at": "10/02/2026 12:56:00",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 4.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:52:38"
          },
          {
            "ticket_id": 8865,
            "ticket_number": "358857",
            "title": "GBN-104872 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/02/2026 13:16:22",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 13:16:22"
          },
          {
            "ticket_id": 8866,
            "ticket_number": "358858",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "10/02/2026 13:41:25",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 13:41:25"
          },
          {
            "ticket_id": 8870,
            "ticket_number": "358862",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 15:22:14",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 15:22:14"
          },
          {
            "ticket_id": 8871,
            "ticket_number": "358863",
            "title": "GBN-104903 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 15:22:21",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 15:22:21"
          },
          {
            "ticket_id": 8872,
            "ticket_number": "358864",
            "title": "Reserva 604525966",
            "priority": "P2",
            "created_at": "10/02/2026 15:33:35",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 15:57:58"
          },
          {
            "ticket_id": 8887,
            "ticket_number": "358879",
            "title": "GBN-104969 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 17:17:38",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 17:17:38"
          },
          {
            "ticket_id": 8889,
            "ticket_number": "358881",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802397323",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 18:13:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 209.48,
            "sla_met": false,
            "sla_breach_hours": 185.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8890,
            "ticket_number": "358882",
            "title": "Importante - Checkin Online Voos TAP - FILE 333871",
            "priority": "P2",
            "created_at": "10/02/2026 18:13:35",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 18:59:24"
          },
          {
            "ticket_id": 8891,
            "ticket_number": "358883",
            "title": "GBN-104992 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 18:13:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 209.47,
            "sla_met": false,
            "sla_breach_hours": 185.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8893,
            "ticket_number": "358885",
            "title": "Re:[## 31495 ##] GBN-83958 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/02/2026 18:13:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:12:54"
          },
          {
            "ticket_id": 8896,
            "ticket_number": "358888",
            "title": "GBN-104978 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 18:13:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 209.47,
            "sla_met": false,
            "sla_breach_hours": 185.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8909,
            "ticket_number": "358901",
            "title": "Fwd: Localizador 1214275701 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "10/02/2026 19:58:27",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:58:28"
          },
          {
            "ticket_id": 8910,
            "ticket_number": "358902",
            "title": "Fwd: Localizador 1214277898 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "10/02/2026 19:58:30",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:58:31"
          },
          {
            "ticket_id": 8911,
            "ticket_number": "358903",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "10/02/2026 19:58:40",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:58:40"
          },
          {
            "ticket_id": 8913,
            "ticket_number": "358905",
            "title": "Mensagem sobre a reserva 36960176 - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 19:58:52",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:58:52"
          },
          {
            "ticket_id": 8914,
            "ticket_number": "358906",
            "title": "Reserva confirmada: Excursão ao parque Xcaret - Ci",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 19:58:56",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:59:20"
          },
          {
            "ticket_id": 8915,
            "ticket_number": "358907",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 19:59:05",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:59:05"
          },
          {
            "ticket_id": 8916,
            "ticket_number": "358908",
            "title": "Reserva confirmada: Excursão à ilha Holbox - Civit",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 19:59:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:59:16"
          },
          {
            "ticket_id": 8917,
            "ticket_number": "358909",
            "title": "Fwd: Localizador 1214278970 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "10/02/2026 19:59:13",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:59:14"
          },
          {
            "ticket_id": 8921,
            "ticket_number": "358913",
            "title": "Pedido de cotação — Tenerife | 22/08/2026 | 1 sema",
            "priority": "P2",
            "created_at": "10/02/2026 19:59:28",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:59:28"
          },
          {
            "ticket_id": 8922,
            "ticket_number": "358914",
            "title": "Sheraton Maldives Full Moon Resort & Spa T10",
            "priority": "P2",
            "created_at": "10/02/2026 19:59:30",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:59:31"
          },
          {
            "ticket_id": 8923,
            "ticket_number": "358915",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 19:59:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 19:59:34"
          },
          {
            "ticket_id": 8927,
            "ticket_number": "358919",
            "title": "urgente, Sao valentim",
            "priority": "P2",
            "created_at": "10/02/2026 20:52:31",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 20:52:32"
          },
          {
            "ticket_id": 8930,
            "ticket_number": "358922",
            "title": "Promoção Dia dos Namorados",
            "priority": "P2",
            "created_at": "10/02/2026 21:42:58",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 19.53,
            "sla_met": false,
            "sla_breach_hours": 15.53,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 17:15:30"
          },
          {
            "ticket_id": 8931,
            "ticket_number": "358923",
            "title": "Mensagem sobre a reserva 36960175 - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 21:43:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 49.75,
            "sla_met": false,
            "sla_breach_hours": 25.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 23:28:51"
          },
          {
            "ticket_id": 8934,
            "ticket_number": "358926",
            "title": "reservaGBN-104841",
            "priority": "P2",
            "created_at": "10/02/2026 22:30:47",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 22:30:48"
          },
          {
            "ticket_id": 8935,
            "ticket_number": "358927",
            "title": "Pedido de cotação Dia dos Namorados | Hotel Axis P",
            "priority": "P2",
            "created_at": "10/02/2026 22:53:08",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 22:53:08"
          },
          {
            "ticket_id": 8936,
            "ticket_number": "358928",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/02/2026 22:53:14",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 22:53:14"
          },
          {
            "ticket_id": 8937,
            "ticket_number": "358929",
            "title": "GBN-105055 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 22:53:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 204.82,
            "sla_met": false,
            "sla_breach_hours": 180.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8938,
            "ticket_number": "358930",
            "title": "GBN-105054 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 22:53:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 204.82,
            "sla_met": false,
            "sla_breach_hours": 180.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:34"
          },
          {
            "ticket_id": 8939,
            "ticket_number": "358931",
            "title": "Fwd: Viagify informa sobre a sua reserva 124709304",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:00:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:00:30"
          },
          {
            "ticket_id": 8940,
            "ticket_number": "358932",
            "title": "Fwd: Viagify informa sobre a sua reserva 124709304",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:00:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/02/2026 23:00:34"
          },
          {
            "ticket_id": 8942,
            "ticket_number": "358934",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:28:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 19:23:53"
          },
          {
            "ticket_id": 8943,
            "ticket_number": "358935",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:28:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 19:23:53"
          },
          {
            "ticket_id": 8945,
            "ticket_number": "358937",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:50:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 11.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 11:36:54"
          },
          {
            "ticket_id": 8946,
            "ticket_number": "358938",
            "title": "GBN-105061 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/02/2026 23:50:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 19:43:58"
          },
          {
            "ticket_id": 8947,
            "ticket_number": "358939",
            "title": "GBN-105067 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 00:32:02",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 00:32:02"
          },
          {
            "ticket_id": 8951,
            "ticket_number": "358943",
            "title": "GBN-105074 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 10:14:50",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 193.45,
            "sla_met": false,
            "sla_breach_hours": 169.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 8954,
            "ticket_number": "358946",
            "title": "Número de informação da reserva: 6132660",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 10:15:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 193.45,
            "sla_met": false,
            "sla_breach_hours": 169.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 8959,
            "ticket_number": "358951",
            "title": "Fwd: ANWB8L | Traz a mala certa",
            "priority": "P2",
            "created_at": "11/02/2026 10:51:18",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 10:51:19"
          },
          {
            "ticket_id": 8962,
            "ticket_number": "358954",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "11/02/2026 10:51:27",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 10:51:29"
          },
          {
            "ticket_id": 8969,
            "ticket_number": "358961",
            "title": "GBN-99935 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "11/02/2026 12:13:06",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 11:42:27"
          },
          {
            "ticket_id": 8972,
            "ticket_number": "358964",
            "title": "GBN-105099 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 12:13:14",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 191.48,
            "sla_met": false,
            "sla_breach_hours": 167.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 8974,
            "ticket_number": "358966",
            "title": "GBN-87698 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/02/2026 12:13:21",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 16:01:50"
          },
          {
            "ticket_id": 8987,
            "ticket_number": "358979",
            "title": "GBN-104968 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 13:40:00",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 52.57,
            "sla_met": false,
            "sla_breach_hours": 28.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 18:14:56"
          },
          {
            "ticket_id": 8990,
            "ticket_number": "358982",
            "title": "GBN-105140 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 13:40:09",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 13:40:09"
          },
          {
            "ticket_id": 8998,
            "ticket_number": "358990",
            "title": "Re:[## 31864 ##] GBN-104968 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "11/02/2026 13:58:28",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 14:07:09"
          },
          {
            "ticket_id": 9001,
            "ticket_number": "358993",
            "title": "Fwd: ⚠️MUITO IMPORTANTE | CANCELAMENTO das primeir",
            "priority": "P2",
            "created_at": "11/02/2026 15:31:46",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 15:31:46"
          },
          {
            "ticket_id": 9002,
            "ticket_number": "358994",
            "title": "Confirmação reserva Bedsonline 197-13823654",
            "priority": "P3",
            "created_at": "11/02/2026 15:31:49",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:20:18"
          },
          {
            "ticket_id": 9003,
            "ticket_number": "358995",
            "title": "⚠️MUITO IMPORTANTE | CANCELAMENTO das primeiras tr",
            "priority": "P2",
            "created_at": "11/02/2026 15:31:51",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 15:43:45"
          },
          {
            "ticket_id": 9005,
            "ticket_number": "358997",
            "title": "Confirmação reserva Bedsonline 197-13823588",
            "priority": "P3",
            "created_at": "11/02/2026 15:31:57",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:20:18"
          },
          {
            "ticket_id": 9006,
            "ticket_number": "358998",
            "title": "Fwd: Informações da reserva TTN-1208828815#9276887",
            "priority": "P2",
            "created_at": "11/02/2026 16:02:04",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 12:11:49"
          },
          {
            "ticket_id": 9007,
            "ticket_number": "358999",
            "title": "GBN-105200    - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 16:15:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 187.45,
            "sla_met": false,
            "sla_breach_hours": 163.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9008,
            "ticket_number": "359000",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604545460",
            "priority": "P2",
            "created_at": "11/02/2026 16:15:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.88,
            "sla_met": false,
            "sla_breach_hours": 0.88,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 21:08:57"
          },
          {
            "ticket_id": 9009,
            "ticket_number": "359001",
            "title": "GBN-105208 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 16:27:50",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 16:27:50"
          },
          {
            "ticket_id": 9012,
            "ticket_number": "359004",
            "title": "Uma Família em Viagem - Confirmação Reserva Progra",
            "priority": "P2",
            "created_at": "11/02/2026 17:18:50",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 19:32:57"
          },
          {
            "ticket_id": 9013,
            "ticket_number": "359005",
            "title": "Confirmação de reserva com localizador: 4072692",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 17:33:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 186.13,
            "sla_met": false,
            "sla_breach_hours": 162.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9015,
            "ticket_number": "359007",
            "title": "Confirmação de reserva com localizador: 4072710",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 17:58:06",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 41.9,
            "sla_met": false,
            "sla_breach_hours": 17.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:52:29"
          },
          {
            "ticket_id": 9017,
            "ticket_number": "359009",
            "title": "Confirmação de reserva com localizador: 4072733",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 17:58:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 185.73,
            "sla_met": false,
            "sla_breach_hours": 161.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9018,
            "ticket_number": "359010",
            "title": "Confirmação de reserva com localizador: 4072719",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 17:58:18",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 41.63,
            "sla_met": false,
            "sla_breach_hours": 17.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:37:00"
          },
          {
            "ticket_id": 9020,
            "ticket_number": "359012",
            "title": "Información de reserva número:",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 18:12:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 185.48,
            "sla_met": false,
            "sla_breach_hours": 161.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9021,
            "ticket_number": "359013",
            "title": "Convite para o jogo da Liga de Portugal | SL Benfi",
            "priority": "P2",
            "created_at": "11/02/2026 18:53:10",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 20:02:09"
          },
          {
            "ticket_id": 9022,
            "ticket_number": "359014",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/02/2026 18:53:13",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 18:53:13"
          },
          {
            "ticket_id": 9025,
            "ticket_number": "359017",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 18:53:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 18:53:25"
          },
          {
            "ticket_id": 9026,
            "ticket_number": "359018",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "11/02/2026 18:53:28",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 18:53:28"
          },
          {
            "ticket_id": 9029,
            "ticket_number": "359021",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 18:53:37",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 41.57,
            "sla_met": false,
            "sla_breach_hours": 17.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:28:26"
          },
          {
            "ticket_id": 9031,
            "ticket_number": "359023",
            "title": "Confirmação de reserva com localizador: 4072835",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 18:53:42",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 41.47,
            "sla_met": false,
            "sla_breach_hours": 17.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:22:31"
          },
          {
            "ticket_id": 9033,
            "ticket_number": "359025",
            "title": "Informação Travelplan",
            "priority": "P3",
            "created_at": "11/02/2026 19:04:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 19:04:05"
          },
          {
            "ticket_id": 9034,
            "ticket_number": "359026",
            "title": "Fwd: Informações da reserva TTN-1208828815#9276887",
            "priority": "P2",
            "created_at": "11/02/2026 19:04:09",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 19:04:09"
          },
          {
            "ticket_id": 9035,
            "ticket_number": "359027",
            "title": "Cancelamento reservas Tour10",
            "priority": "P2",
            "created_at": "11/02/2026 19:35:02",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 19:35:02"
          },
          {
            "ticket_id": 9036,
            "ticket_number": "359028",
            "title": "Pedido de cotação - Pack Carnaval Hotel Golf Mar (",
            "priority": "P2",
            "created_at": "11/02/2026 19:35:04",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 19:35:05"
          },
          {
            "ticket_id": 9037,
            "ticket_number": "359029",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 19:35:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 40.9,
            "sla_met": false,
            "sla_breach_hours": 16.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:29:56"
          },
          {
            "ticket_id": 9038,
            "ticket_number": "359030",
            "title": "Recolha Excursão à ilha Holbox",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 19:38:55",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 40.57,
            "sla_met": false,
            "sla_breach_hours": 16.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:13:16"
          },
          {
            "ticket_id": 9040,
            "ticket_number": "359032",
            "title": "GBN-105314 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 20:18:59",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 40.55,
            "sla_met": false,
            "sla_breach_hours": 16.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:52:28"
          },
          {
            "ticket_id": 9042,
            "ticket_number": "359034",
            "title": "GBN-95291 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/02/2026 20:19:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 21:18:40"
          },
          {
            "ticket_id": 9045,
            "ticket_number": "359037",
            "title": "Número de informação da reserva:       6132816",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 20:42:04",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 39.8,
            "sla_met": false,
            "sla_breach_hours": 15.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 12:30:24"
          },
          {
            "ticket_id": 9052,
            "ticket_number": "359044",
            "title": "GBN-105342 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 21:26:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 182.27,
            "sla_met": false,
            "sla_breach_hours": 158.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9053,
            "ticket_number": "359045",
            "title": "Confirmação de reserva com localizador: 4073235",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 21:26:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 182.27,
            "sla_met": false,
            "sla_breach_hours": 158.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9056,
            "ticket_number": "359048",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 22:03:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 181.63,
            "sla_met": false,
            "sla_breach_hours": 157.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:33"
          },
          {
            "ticket_id": 9058,
            "ticket_number": "359050",
            "title": "Fwd: O2L27A | Oportunidade de ganhar um cartão de ",
            "priority": "P2",
            "created_at": "11/02/2026 22:37:40",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 22:37:40"
          },
          {
            "ticket_id": 9061,
            "ticket_number": "359053",
            "title": "Anulação de reserva",
            "priority": "P2",
            "created_at": "11/02/2026 23:17:40",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 23:17:41"
          },
          {
            "ticket_id": 9062,
            "ticket_number": "359054",
            "title": "GBN-105356 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "11/02/2026 23:17:48",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 23:17:48"
          },
          {
            "ticket_id": 9064,
            "ticket_number": "359056",
            "title": "GBN-105366 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 23:41:22",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 23:41:22"
          },
          {
            "ticket_id": 9065,
            "ticket_number": "359057",
            "title": "Condições de cancelamento ICARION",
            "priority": "P2",
            "created_at": "11/02/2026 23:41:26",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 23:41:26"
          },
          {
            "ticket_id": 9066,
            "ticket_number": "359058",
            "title": "GBN-105369 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 23:41:29",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 43.07,
            "sla_met": false,
            "sla_breach_hours": 19.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 18:45:54"
          },
          {
            "ticket_id": 9067,
            "ticket_number": "359059",
            "title": "GBN-105364  - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 23:41:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 23:41:33"
          },
          {
            "ticket_id": 9068,
            "ticket_number": "359060",
            "title": "GBN-105362 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/02/2026 23:41:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 42.53,
            "sla_met": false,
            "sla_breach_hours": 18.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 18:13:42"
          },
          {
            "ticket_id": 9070,
            "ticket_number": "359062",
            "title": "GBN-105349 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "11/02/2026 23:49:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 23:49:16"
          },
          {
            "ticket_id": 9071,
            "ticket_number": "359063",
            "title": "GBN-105349 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "11/02/2026 23:49:20",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 39.07,
            "sla_met": false,
            "sla_breach_hours": 15.07,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:54:11"
          },
          {
            "ticket_id": 9072,
            "ticket_number": "359064",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 00:08:44",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 60.02,
            "sla_met": false,
            "sla_breach_hours": 36.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 12:10:33"
          },
          {
            "ticket_id": 9076,
            "ticket_number": "359068",
            "title": "Re: Uma Familia Em Viagem e o idioma inglês",
            "priority": "P2",
            "created_at": "12/02/2026 10:08:22",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 11:11:19"
          },
          {
            "ticket_id": 9077,
            "ticket_number": "359069",
            "title": "Confirmacao 339382",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 10:08:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 9.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 19:40:06"
          },
          {
            "ticket_id": 9080,
            "ticket_number": "359072",
            "title": "Confirmação de reserva – Ref PP301801, Sra. CATIA ",
            "priority": "P3",
            "created_at": "12/02/2026 10:10:10",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 32.62,
            "sla_met": false,
            "sla_breach_hours": 8.62,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:47:55"
          },
          {
            "ticket_id": 9083,
            "ticket_number": "359075",
            "title": "Número de informação da reserva: 6132838",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:21",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 28.75,
            "sla_met": false,
            "sla_breach_hours": 4.75,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:57:21"
          },
          {
            "ticket_id": 9084,
            "ticket_number": "359076",
            "title": "Número de informação da reserva: 6132837",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 28.77,
            "sla_met": false,
            "sla_breach_hours": 4.77,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:57:35"
          },
          {
            "ticket_id": 9086,
            "ticket_number": "359078",
            "title": "FXPBBB – Novo prazo de emissão (#2791365)",
            "priority": "P2",
            "created_at": "12/02/2026 10:11:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:42:10"
          },
          {
            "ticket_id": 9087,
            "ticket_number": "359079",
            "title": "Reserva Aéreo [ERROR_AIR-18F31AE0C3] - Erro Técnic",
            "priority": "P2",
            "created_at": "12/02/2026 10:11:34",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:42:40"
          },
          {
            "ticket_id": 9088,
            "ticket_number": "359080",
            "title": "Número de informação da reserva: 6132839",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:39",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 32.32,
            "sla_met": false,
            "sla_breach_hours": 8.32,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:31:24"
          },
          {
            "ticket_id": 9091,
            "ticket_number": "359083",
            "title": "Reserva Aérea FXPBBB",
            "priority": "P2",
            "created_at": "12/02/2026 10:11:46",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:43:07"
          },
          {
            "ticket_id": 9092,
            "ticket_number": "359084",
            "title": "Confirmação de reserva – Ref PP457698, Sr. Jose Ti",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 10:11:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 154.53,
            "sla_met": false,
            "sla_breach_hours": 130.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 20:44:06"
          },
          {
            "ticket_id": 9093,
            "ticket_number": "359085",
            "title": "Número de informação da reserva: 6132836",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:52",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 32.17,
            "sla_met": false,
            "sla_breach_hours": 8.17,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:22:06"
          },
          {
            "ticket_id": 9094,
            "ticket_number": "359086",
            "title": "Número de informação da reserva: 6132835",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 10:11:55",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 48.72,
            "sla_met": false,
            "sla_breach_hours": 24.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 10:55:26"
          },
          {
            "ticket_id": 9098,
            "ticket_number": "359090",
            "title": "Fall in love with travel❤️ Up to 50% OFF",
            "priority": "P2",
            "created_at": "12/02/2026 10:21:09",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:49:24"
          },
          {
            "ticket_id": 9099,
            "ticket_number": "359091",
            "title": "Madeira | Últimos lugares! 😱",
            "priority": "P2",
            "created_at": "12/02/2026 10:21:10",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:49:31"
          },
          {
            "ticket_id": 9104,
            "ticket_number": "359096",
            "title": "Referencia para pagamento | File:429171/2026",
            "priority": "P2",
            "created_at": "12/02/2026 12:06:13",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:51:59"
          },
          {
            "ticket_id": 9106,
            "ticket_number": "359098",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604550257",
            "priority": "P3",
            "created_at": "12/02/2026 12:06:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 26.53,
            "sla_met": false,
            "sla_breach_hours": 2.53,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:38:45"
          },
          {
            "ticket_id": 9107,
            "ticket_number": "359099",
            "title": "We know trust takes time — so we extended the offe",
            "priority": "P2",
            "created_at": "12/02/2026 12:06:19",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:53:23"
          },
          {
            "ticket_id": 9111,
            "ticket_number": "359103",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604550151",
            "priority": "P3",
            "created_at": "12/02/2026 12:06:27",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 26.4,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:30:57"
          },
          {
            "ticket_id": 9113,
            "ticket_number": "359105",
            "title": "Fwd: Viagify informa sobre a sua reserva 124773566",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/02/2026 13:17:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 13:17:45"
          },
          {
            "ticket_id": 9116,
            "ticket_number": "359108",
            "title": "Fwd: easyJet booking reference: KC3V2JN",
            "priority": "P2",
            "created_at": "12/02/2026 13:17:53",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 13:17:53"
          },
          {
            "ticket_id": 9121,
            "ticket_number": "359113",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P3",
            "created_at": "12/02/2026 13:18:13",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 13:18:13"
          },
          {
            "ticket_id": 9123,
            "ticket_number": "359115",
            "title": "[agencias1] BTL 2026 - VISITE-NOS DE 25 A 27 FEVER",
            "priority": "P2",
            "created_at": "12/02/2026 13:42:34",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 14:52:56"
          },
          {
            "ticket_id": 9124,
            "ticket_number": "359116",
            "title": "GBN-105472 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "12/02/2026 13:42:37",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 13:42:37"
          },
          {
            "ticket_id": 9127,
            "ticket_number": "359119",
            "title": "Fwd: Localizador 1247617492 - SmyTravel informa TT",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 14:48:21",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 14:48:22"
          },
          {
            "ticket_id": 9128,
            "ticket_number": "359120",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "P3",
            "created_at": "12/02/2026 14:48:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 23.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:39:09"
          },
          {
            "ticket_id": 9130,
            "ticket_number": "359122",
            "title": "Confirmação de reserva. Localizador: 6DDSAYWXLQ",
            "priority": "P3",
            "created_at": "12/02/2026 14:49:04",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 23.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:36:46"
          },
          {
            "ticket_id": 9131,
            "ticket_number": "359123",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P3",
            "created_at": "12/02/2026 15:14:46",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 19:03:51"
          },
          {
            "ticket_id": 9132,
            "ticket_number": "359124",
            "title": "Re:[## 30200 ##] GBN-100710 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "12/02/2026 15:14:49",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 19:03:51"
          },
          {
            "ticket_id": 9135,
            "ticket_number": "359127",
            "title": "Confirmação de reserva para For PT004157 66829878",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/02/2026 18:05:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 161.62,
            "sla_met": false,
            "sla_breach_hours": 137.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9138,
            "ticket_number": "359130",
            "title": "MADEIRA E AÇORES | CIRCUITOS EXCLUSIVOS 2026",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:22",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 19:13:12"
          },
          {
            "ticket_id": 9140,
            "ticket_number": "359132",
            "title": "Fwd: Pedido de cotação",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 18:05:32"
          },
          {
            "ticket_id": 9147,
            "ticket_number": "359139",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P3",
            "created_at": "12/02/2026 18:20:05",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 23.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:12:36"
          },
          {
            "ticket_id": 9148,
            "ticket_number": "359140",
            "title": "GBN-105492 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/02/2026 18:20:08",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 21:35:17"
          },
          {
            "ticket_id": 9151,
            "ticket_number": "359143",
            "title": "Criação de processo File 429857/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/02/2026 19:41:33",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 160.0,
            "sla_met": false,
            "sla_breach_hours": 136.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9152,
            "ticket_number": "359144",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P3",
            "created_at": "12/02/2026 19:41:42",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:17:03"
          },
          {
            "ticket_id": 9154,
            "ticket_number": "359146",
            "title": "GBN-105616 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "12/02/2026 20:21:30",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 17.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:16:29"
          },
          {
            "ticket_id": 9156,
            "ticket_number": "359148",
            "title": "GBN-105557 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/02/2026 20:21:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 159.33,
            "sla_met": false,
            "sla_breach_hours": 135.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9157,
            "ticket_number": "359149",
            "title": "Criação de processo File 429861/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/02/2026 20:21:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 159.33,
            "sla_met": false,
            "sla_breach_hours": 135.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9159,
            "ticket_number": "359151",
            "title": "Reserva confirmada: Transfer ao Rio de Janeiro sai",
            "priority": "P3",
            "created_at": "12/02/2026 21:14:17",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 21:14:17"
          },
          {
            "ticket_id": 9162,
            "ticket_number": "359154",
            "title": "CVO",
            "priority": "P2",
            "created_at": "12/02/2026 21:22:19",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 21:22:19"
          },
          {
            "ticket_id": 9168,
            "ticket_number": "359160",
            "title": "Reserva Aérea FY0YQM",
            "priority": "Reservas sem Formulário",
            "created_at": "12/02/2026 23:39:51",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/02/2026 23:39:58"
          },
          {
            "ticket_id": 9171,
            "ticket_number": "359163",
            "title": "Loc 4073235 TOUR 10 - Adicionar noites",
            "priority": "P2",
            "created_at": "12/02/2026 23:59:07",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 23:59:07"
          },
          {
            "ticket_id": 9181,
            "ticket_number": "359173",
            "title": "FY0YQM – Reserva com emissão hoje",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 10:07:26",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 108.7,
            "sla_met": false,
            "sla_breach_hours": 84.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 22:50:22"
          },
          {
            "ticket_id": 9182,
            "ticket_number": "359174",
            "title": "Fwd: Viagify informa sobre a sua reserva 124800864",
            "priority": "P2",
            "created_at": "13/02/2026 10:07:28",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 10:07:29"
          },
          {
            "ticket_id": 9185,
            "ticket_number": "359177",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "13/02/2026 10:07:36",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 10:07:37"
          },
          {
            "ticket_id": 9190,
            "ticket_number": "359182",
            "title": "Fwd: Pode agora efetuar o check-in online para o s",
            "priority": "P2",
            "created_at": "13/02/2026 10:16:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 10:16:16"
          },
          {
            "ticket_id": 9192,
            "ticket_number": "359184",
            "title": "Fwd: Pode agora efetuar o check-in online para o s",
            "priority": "P2",
            "created_at": "13/02/2026 10:16:22",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 10:16:22"
          },
          {
            "ticket_id": 9194,
            "ticket_number": "359186",
            "title": "Questão sobre orçamento - Icarion",
            "priority": "P3",
            "created_at": "13/02/2026 11:31:23",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:31:24"
          },
          {
            "ticket_id": 9195,
            "ticket_number": "359187",
            "title": "Confirmação de reserva – Ref PP241517, Sr. Hugo Da",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 11:31:25",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 23.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 10:54:11"
          },
          {
            "ticket_id": 9197,
            "ticket_number": "359189",
            "title": "Confirmação de reserva com localizador: 4075353",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 11:31:30",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 23.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 10:52:46"
          },
          {
            "ticket_id": 9201,
            "ticket_number": "359193",
            "title": "Fwd: Viagify informa sobre a sua reserva 124811393",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 11:42:51",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:42:52"
          },
          {
            "ticket_id": 9202,
            "ticket_number": "359194",
            "title": "Fwd: Viagify informa sobre a sua reserva 124811393",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 11:42:55",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 11:42:56"
          },
          {
            "ticket_id": 9205,
            "ticket_number": "359197",
            "title": "Pedido de Orçamento direto ",
            "priority": "P2",
            "created_at": "13/02/2026 12:09:50",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 12:09:51"
          },
          {
            "ticket_id": 9210,
            "ticket_number": "359202",
            "title": "Criação de processo File 429916/26",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 13:31:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 142.17,
            "sla_met": false,
            "sla_breach_hours": 118.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9217,
            "ticket_number": "359209",
            "title": "Número de informação da reserva: 6133089",
            "priority": "P2",
            "created_at": "13/02/2026 14:22:08",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 18:21:15"
          },
          {
            "ticket_id": 9218,
            "ticket_number": "359210",
            "title": "Fwd: FW: Pedido de orçamento 17-18 fev.",
            "priority": "P2",
            "created_at": "13/02/2026 14:35:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 14:35:16"
          },
          {
            "ticket_id": 9220,
            "ticket_number": "359212",
            "title": "Reserva de transfer em Marrakech (Marrakech Medina",
            "priority": "P2",
            "created_at": "13/02/2026 14:40:39",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:30:01"
          },
          {
            "ticket_id": 9221,
            "ticket_number": "359213",
            "title": "Reserva de transfer em Marrakech (Aeroporto Marrak",
            "priority": "P2",
            "created_at": "13/02/2026 14:40:41",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:30:26"
          },
          {
            "ticket_id": 9222,
            "ticket_number": "359214",
            "title": "Reserva de transfer em Marraquexe (Aeroporto Marra",
            "priority": "P2",
            "created_at": "13/02/2026 14:40:44",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:30:51"
          },
          {
            "ticket_id": 9223,
            "ticket_number": "359215",
            "title": "Reserva de transfer em Marraquexe (Marrakech Medin",
            "priority": "P2",
            "created_at": "13/02/2026 14:40:47",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:31:16"
          },
          {
            "ticket_id": 9227,
            "ticket_number": "359219",
            "title": "Número de informação da reserva: 6133103",
            "priority": "P2",
            "created_at": "13/02/2026 15:44:52",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:39:12"
          },
          {
            "ticket_id": 9228,
            "ticket_number": "359220",
            "title": "Fwd: Informações da sua reserva TTN-1248008641#929",
            "priority": "P2",
            "created_at": "13/02/2026 15:44:54",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 15:44:55"
          },
          {
            "ticket_id": 9229,
            "ticket_number": "359221",
            "title": "Fwd: Informações da sua reserva TTN-1248008641#930",
            "priority": "P2",
            "created_at": "13/02/2026 15:44:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 15:44:59"
          },
          {
            "ticket_id": 9238,
            "ticket_number": "359230",
            "title": "GBN-105789 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 16:00:34",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 20.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 12:27:34"
          },
          {
            "ticket_id": 9239,
            "ticket_number": "359231",
            "title": "Orçamento 2263463 - Tailândia ao Seu Ritmo - 01/10",
            "priority": "P2",
            "created_at": "13/02/2026 16:00:41",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:37:11"
          },
          {
            "ticket_id": 9240,
            "ticket_number": "359232",
            "title": "Confirmación del Loc 9108717",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 16:19:25",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 139.38,
            "sla_met": false,
            "sla_breach_hours": 115.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9241,
            "ticket_number": "359233",
            "title": "GBN Travel: Resend booking confirmation - GBN-1057",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 16:19:30",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 20.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 12:36:40"
          },
          {
            "ticket_id": 9249,
            "ticket_number": "359241",
            "title": "Re: Nova Viagem #260200127 - B Vibes",
            "priority": "P3",
            "created_at": "13/02/2026 16:42:30",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:42:30"
          },
          {
            "ticket_id": 9250,
            "ticket_number": "359242",
            "title": "EXP. 20518 - Cuba",
            "priority": "P2",
            "created_at": "13/02/2026 16:42:32",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:36:09"
          },
          {
            "ticket_id": 9252,
            "ticket_number": "359244",
            "title": "Envio de documentos de File 429171/26",
            "priority": "P2",
            "created_at": "13/02/2026 16:53:41",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 20:42:00"
          },
          {
            "ticket_id": 9256,
            "ticket_number": "359248",
            "title": "Transfer 2827313 cancelado",
            "priority": "P2",
            "created_at": "13/02/2026 17:28:40",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:32:59"
          },
          {
            "ticket_id": 9259,
            "ticket_number": "359251",
            "title": "Pedido de cotaçao para grupo Le Plan e Solferias ",
            "priority": "P2",
            "created_at": "13/02/2026 17:28:46",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:28:47"
          },
          {
            "ticket_id": 9262,
            "ticket_number": "359254",
            "title": "Pedido de Pagamento por Referência MB [3128264 - M",
            "priority": "P2",
            "created_at": "13/02/2026 17:45:43",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:56:20"
          },
          {
            "ticket_id": 9264,
            "ticket_number": "359256",
            "title": "Información de reserva número:",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 17:45:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 137.93,
            "sla_met": false,
            "sla_breach_hours": 113.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9266,
            "ticket_number": "359258",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/02/2026 19:19:43",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:19:43"
          },
          {
            "ticket_id": 9267,
            "ticket_number": "359259",
            "title": "Confirmation of booking with locator1ON6OAH4",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 19:19:46",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 121.42,
            "sla_met": false,
            "sla_breach_hours": 97.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 20:45:35"
          },
          {
            "ticket_id": 9268,
            "ticket_number": "359260",
            "title": "Número de informação da reserva: 6133239",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 19:19:51",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 15.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 10:48:01"
          },
          {
            "ticket_id": 9269,
            "ticket_number": "359261",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 19:19:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 136.37,
            "sla_met": false,
            "sla_breach_hours": 112.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9270,
            "ticket_number": "359262",
            "title": "Pagamento da reserva – Ref PP241517, Sr. Hugo Dani",
            "priority": "P2",
            "created_at": "13/02/2026 19:19:57",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:33:21"
          },
          {
            "ticket_id": 9273,
            "ticket_number": "359265",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 19:20:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 136.37,
            "sla_met": false,
            "sla_breach_hours": 112.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9274,
            "ticket_number": "359266",
            "title": "Informação de reserva - SPT002601588022",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 19:20:18",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 982.97,
            "sla_met": false,
            "sla_breach_hours": 958.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:18:29"
          },
          {
            "ticket_id": 9275,
            "ticket_number": "359267",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/02/2026 19:20:27",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:20:28"
          },
          {
            "ticket_id": 9277,
            "ticket_number": "359269",
            "title": "Fwd: Incidente de voo TTN-1218445868#92941027#T176",
            "priority": "P2",
            "created_at": "13/02/2026 19:20:38",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:20:40"
          },
          {
            "ticket_id": 9278,
            "ticket_number": "359270",
            "title": "Fwd: Viagify informa sobre a sua reserva 124830994",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 19:20:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 19:20:45"
          },
          {
            "ticket_id": 9279,
            "ticket_number": "359271",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/02/2026 19:20:59",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:20:59"
          },
          {
            "ticket_id": 9280,
            "ticket_number": "359272",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/02/2026 19:21:05",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:21:05"
          },
          {
            "ticket_id": 9281,
            "ticket_number": "359273",
            "title": "Número de informação da reserva: 6133180",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 19:21:10",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 124.35,
            "sla_met": false,
            "sla_breach_hours": 100.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:43:09"
          },
          {
            "ticket_id": 9284,
            "ticket_number": "359276",
            "title": "Información de reserva número:",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 19:21:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 136.35,
            "sla_met": false,
            "sla_breach_hours": 112.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9287,
            "ticket_number": "359279",
            "title": "Informação de reserva - SPT002601588048",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 19:41:17",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 982.67,
            "sla_met": false,
            "sla_breach_hours": 958.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:21:59"
          },
          {
            "ticket_id": 9291,
            "ticket_number": "359283",
            "title": "Aéreo - Confirmação de Emissão (BOTAS\\JOSE) - FY0Y",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 20:15:24",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/02/2026 20:15:27"
          },
          {
            "ticket_id": 9296,
            "ticket_number": "359288",
            "title": "Información de reserva número: 1775938",
            "priority": "Reservas sem Formulário",
            "created_at": "13/02/2026 20:43:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 72.97,
            "sla_met": false,
            "sla_breach_hours": 48.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 21:42:01"
          },
          {
            "ticket_id": 9302,
            "ticket_number": "359294",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "13/02/2026 22:28:34",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 22:28:34"
          },
          {
            "ticket_id": 9306,
            "ticket_number": "359298",
            "title": "GBN-105929 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 23:26:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 132.25,
            "sla_met": false,
            "sla_breach_hours": 108.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9307,
            "ticket_number": "359299",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/02/2026 23:26:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 132.25,
            "sla_met": false,
            "sla_breach_hours": 108.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9311,
            "ticket_number": "359303",
            "title": "Informação de reserva - SPT002601588028",
            "priority": "Reservas sem Formulário",
            "created_at": "14/02/2026 11:36:13",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 966.7,
            "sla_met": false,
            "sla_breach_hours": 942.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:18:59"
          },
          {
            "ticket_id": 9312,
            "ticket_number": "359304",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "14/02/2026 13:02:27",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:46:23"
          },
          {
            "ticket_id": 9322,
            "ticket_number": "359314",
            "title": "Fwd: Viagify informa sobre a sua reserva 124844421",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/02/2026 13:41:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 13:41:23"
          },
          {
            "ticket_id": 9325,
            "ticket_number": "359317",
            "title": "Fwd: Informações da sua reserva TTN-1248444210#930",
            "priority": "Reservas sem Formulário",
            "created_at": "14/02/2026 13:43:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 13:43:45"
          },
          {
            "ticket_id": 9326,
            "ticket_number": "359318",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "14/02/2026 13:43:46",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:43:47"
          },
          {
            "ticket_id": 9327,
            "ticket_number": "359319",
            "title": "Fwd: Pode agora efetuar o check-in online para o s",
            "priority": "P2",
            "created_at": "14/02/2026 13:43:49",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:43:50"
          },
          {
            "ticket_id": 9328,
            "ticket_number": "359320",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "14/02/2026 13:43:52",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:43:53"
          },
          {
            "ticket_id": 9329,
            "ticket_number": "359321",
            "title": "Fwd: Informações da sua reserva TTN-1248444210#930",
            "priority": "Reservas sem Formulário",
            "created_at": "14/02/2026 13:43:56",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/02/2026 14:58:07"
          },
          {
            "ticket_id": 9331,
            "ticket_number": "359323",
            "title": "Fwd: Ya puede facturar online para su vuelo a Pari",
            "priority": "P2",
            "created_at": "14/02/2026 13:44:02",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:44:02"
          },
          {
            "ticket_id": 9332,
            "ticket_number": "359324",
            "title": "Solole. Booking KXQITOI4 is close to entering expe",
            "priority": "P2",
            "created_at": "14/02/2026 14:51:03",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 14:55:18"
          },
          {
            "ticket_id": 9334,
            "ticket_number": "359326",
            "title": "Confirmação reserva Bedsonline 59-5744435",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/02/2026 15:01:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 116.68,
            "sla_met": false,
            "sla_breach_hours": 92.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9337,
            "ticket_number": "359329",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "14/02/2026 16:28:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 115.42,
            "sla_met": false,
            "sla_breach_hours": 91.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:53:53"
          },
          {
            "ticket_id": 9347,
            "ticket_number": "359339",
            "title": "GBN-106017 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:06:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.58,
            "sla_met": false,
            "sla_breach_hours": 49.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9350,
            "ticket_number": "359342",
            "title": "w2m.travel: Confirmation of Payment received for t",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:09:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 82.85,
            "sla_met": false,
            "sla_breach_hours": 58.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:00:48"
          },
          {
            "ticket_id": 9354,
            "ticket_number": "359346",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:09:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 61.35,
            "sla_met": false,
            "sla_breach_hours": 37.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:31:47"
          },
          {
            "ticket_id": 9355,
            "ticket_number": "359347",
            "title": "Número de informação da reserva: 6135191",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:09:51",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 82.85,
            "sla_met": false,
            "sla_breach_hours": 58.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:01:15"
          },
          {
            "ticket_id": 9357,
            "ticket_number": "359349",
            "title": "Confirmação de reserva para For PT004157 66829878",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:09:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.53,
            "sla_met": false,
            "sla_breach_hours": 49.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9359,
            "ticket_number": "359351",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:10:05",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 61.35,
            "sla_met": false,
            "sla_breach_hours": 37.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:31:05"
          },
          {
            "ticket_id": 9361,
            "ticket_number": "359353",
            "title": "Confirmação de reserva para For PT004157 66828847",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:10:12",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.53,
            "sla_met": false,
            "sla_breach_hours": 49.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:32"
          },
          {
            "ticket_id": 9364,
            "ticket_number": "359356",
            "title": "Confirmação de reserva para For PT004157 66828847",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:10:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.53,
            "sla_met": false,
            "sla_breach_hours": 49.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:31"
          },
          {
            "ticket_id": 9365,
            "ticket_number": "359357",
            "title": "Confirmação de reserva para For PT004157 66828847",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:10:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.53,
            "sla_met": false,
            "sla_breach_hours": 49.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:31"
          },
          {
            "ticket_id": 9370,
            "ticket_number": "359362",
            "title": "GBN-106061  - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:10:40",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 10:10:40"
          },
          {
            "ticket_id": 9371,
            "ticket_number": "359363",
            "title": "GBN-106059 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:10:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 298.45,
            "sla_met": false,
            "sla_breach_hours": 274.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:38:01"
          },
          {
            "ticket_id": 9374,
            "ticket_number": "359366",
            "title": "GBN-106058 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:10:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 10:10:54"
          },
          {
            "ticket_id": 9381,
            "ticket_number": "359373",
            "title": "Confirmação de reserva – Ref PP190188, Sr. Luis Az",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 10:14:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 73.73,
            "sla_met": false,
            "sla_breach_hours": 49.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:59:18"
          },
          {
            "ticket_id": 9388,
            "ticket_number": "359380",
            "title": "Confirmação reserva Bedsonline 58-4697378",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 10:55:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 57.77,
            "sla_met": false,
            "sla_breach_hours": 33.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 20:42:15"
          },
          {
            "ticket_id": 9395,
            "ticket_number": "359387",
            "title": "GBN-106075 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 12:21:42",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 59.2,
            "sla_met": false,
            "sla_breach_hours": 35.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:33:59"
          },
          {
            "ticket_id": 9399,
            "ticket_number": "359391",
            "title": "Confirmação de reserva para For PT004157 66829878",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 12:52:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 57.83,
            "sla_met": false,
            "sla_breach_hours": 33.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 22:42:35"
          },
          {
            "ticket_id": 9407,
            "ticket_number": "359399",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 13:45:35",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 57.95,
            "sla_met": false,
            "sla_breach_hours": 33.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:42:46"
          },
          {
            "ticket_id": 9410,
            "ticket_number": "359402",
            "title": "Confirmação de reserva – Ref PP669823, Sr. José Ci",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 14:36:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 69.4,
            "sla_met": false,
            "sla_breach_hours": 45.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 12:01:01"
          },
          {
            "ticket_id": 9412,
            "ticket_number": "359404",
            "title": "Solole. Booking KXQITOI4 is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 14:36:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 56.95,
            "sla_met": false,
            "sla_breach_hours": 32.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:34:46"
          },
          {
            "ticket_id": 9416,
            "ticket_number": "359408",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604553839",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 16:00:39",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 294.55,
            "sla_met": false,
            "sla_breach_hours": 270.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 22:34:34"
          },
          {
            "ticket_id": 9431,
            "ticket_number": "359423",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 17:04:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 17:04:16"
          },
          {
            "ticket_id": 9462,
            "ticket_number": "359454",
            "title": "TRAVELPLAN 604525993",
            "priority": "P2",
            "created_at": "16/02/2026 18:43:26",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 18:43:27"
          },
          {
            "ticket_id": 9469,
            "ticket_number": "359461",
            "title": "Re:[## 32274 ##] GBN-95439 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "16/02/2026 19:59:20",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 20:30:38"
          },
          {
            "ticket_id": 9470,
            "ticket_number": "359462",
            "title": "Re:[## 32280 ##] GBN-102944 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "16/02/2026 19:59:29",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 20:18:41"
          },
          {
            "ticket_id": 9471,
            "ticket_number": "359463",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "16/02/2026 19:59:31",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 20:17:41"
          },
          {
            "ticket_id": 9473,
            "ticket_number": "359465",
            "title": "Criação de processo File 430511/26",
            "priority": "P2",
            "created_at": "16/02/2026 20:37:19",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 20:55:13"
          },
          {
            "ticket_id": 9480,
            "ticket_number": "359472",
            "title": "GBN-106301 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 21:18:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 21:18:38"
          },
          {
            "ticket_id": 9481,
            "ticket_number": "359473",
            "title": "Confirmação de reserva com localizador: 4079484",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "16/02/2026 21:26:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 62.25,
            "sla_met": false,
            "sla_breach_hours": 38.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:31"
          },
          {
            "ticket_id": 9482,
            "ticket_number": "359474",
            "title": "Urgência -  Soltrópico - 332076",
            "priority": "P2",
            "created_at": "16/02/2026 21:46:16",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 21:46:16"
          },
          {
            "ticket_id": 9485,
            "ticket_number": "359477",
            "title": "Reserva confirmada: Excursão à ilha Saona de catam",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 22:03:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/02/2026 22:03:36"
          },
          {
            "ticket_id": 9486,
            "ticket_number": "359478",
            "title": "Cotaçao Malas GBN",
            "priority": "P2",
            "created_at": "16/02/2026 22:15:06",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:15:06"
          },
          {
            "ticket_id": 9494,
            "ticket_number": "359486",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 22:59:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 70.08,
            "sla_met": false,
            "sla_breach_hours": 46.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:05:17"
          },
          {
            "ticket_id": 9495,
            "ticket_number": "359487",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P3",
            "created_at": "16/02/2026 23:15:47",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 68.47,
            "sla_met": false,
            "sla_breach_hours": 44.47,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 19:44:26"
          },
          {
            "ticket_id": 9497,
            "ticket_number": "359489",
            "title": "ALTERAÇÃO DE VOO POR UN *File 427856/26",
            "priority": "P2",
            "created_at": "16/02/2026 23:22:41",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 23:28:05"
          },
          {
            "ticket_id": 9500,
            "ticket_number": "359492",
            "title": "Cancelamento Cuba",
            "priority": "P2",
            "created_at": "16/02/2026 23:47:50",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 23:47:51"
          },
          {
            "ticket_id": 9502,
            "ticket_number": "359494",
            "title": "GBN-106327 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/02/2026 23:59:23",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 284.6,
            "sla_met": false,
            "sla_breach_hours": 260.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:36:21"
          },
          {
            "ticket_id": 9506,
            "ticket_number": "359498",
            "title": "GBN-106323 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "17/02/2026 10:07:50",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 34.85,
            "sla_met": false,
            "sla_breach_hours": 10.85,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 20:59:32"
          },
          {
            "ticket_id": 9508,
            "ticket_number": "359500",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 10:07:54",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 58.97,
            "sla_met": false,
            "sla_breach_hours": 34.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:06:22"
          },
          {
            "ticket_id": 9511,
            "ticket_number": "359503",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604554558",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 10:08:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 48.12,
            "sla_met": false,
            "sla_breach_hours": 24.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 10:15:46"
          },
          {
            "ticket_id": 9512,
            "ticket_number": "359504",
            "title": "Fwd: Viagify informa sobre a sua reserva 124944838",
            "priority": "P3",
            "created_at": "17/02/2026 10:21:47",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 10:21:48"
          },
          {
            "ticket_id": 9513,
            "ticket_number": "359505",
            "title": "w2m.travel: Confirmación reserva 'Y1BR48'",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 10:46:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 275.78,
            "sla_met": false,
            "sla_breach_hours": 251.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 22:33:39"
          },
          {
            "ticket_id": 9549,
            "ticket_number": "359541",
            "title": "Fwd: Informações da reserva TTN-1199230549#9309915",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 16:31:46",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 16:31:47"
          },
          {
            "ticket_id": 9552,
            "ticket_number": "359544",
            "title": "GBN-106244 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "17/02/2026 16:33:37",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 16:33:37"
          },
          {
            "ticket_id": 9559,
            "ticket_number": "359551",
            "title": "GBN-106373 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "17/02/2026 17:13:04",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 17:13:04"
          },
          {
            "ticket_id": 9582,
            "ticket_number": "359574",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 19:48:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 19:48:40"
          },
          {
            "ticket_id": 9583,
            "ticket_number": "359575",
            "title": "Fwd: Viagify informa sobre a sua reserva 124979812",
            "priority": "P3",
            "created_at": "17/02/2026 19:48:43",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 19:48:44"
          },
          {
            "ticket_id": 9587,
            "ticket_number": "359579",
            "title": "GBN-106400 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 22:55:12",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 22:55:12"
          },
          {
            "ticket_id": 9590,
            "ticket_number": "359582",
            "title": "Fwd: Viagify informa sobre a sua reserva 124987337",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 22:55:25",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 22:55:26"
          },
          {
            "ticket_id": 9591,
            "ticket_number": "359583",
            "title": "Confirmação de reserva com localizador: 4081078",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 21.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 20:50:26"
          },
          {
            "ticket_id": 9592,
            "ticket_number": "359584",
            "title": "GBN-106401 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 22:55:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 22:55:32"
          },
          {
            "ticket_id": 9593,
            "ticket_number": "359585",
            "title": "GBN-106399 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:35",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 22:55:35"
          },
          {
            "ticket_id": 9595,
            "ticket_number": "359587",
            "title": "Reserva de transfer em Tokio (Tóquio - Aeroporto d",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 22:55:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 21.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 20:49:41"
          },
          {
            "ticket_id": 9597,
            "ticket_number": "359589",
            "title": "Orçamento Leplan - solicitação de informação ao op",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:47",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 22:55:48"
          },
          {
            "ticket_id": 9598,
            "ticket_number": "359590",
            "title": "Reserva de transfer em Tóquio (Aeroporto de Narita",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:50",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 21.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 20:50:52"
          },
          {
            "ticket_id": 9600,
            "ticket_number": "359592",
            "title": "Reserva de transfer em Tóquio (Tóquio - Aeroporto ",
            "priority": "P3",
            "created_at": "17/02/2026 22:55:55",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 21.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 20:51:54"
          },
          {
            "ticket_id": 9603,
            "ticket_number": "359595",
            "title": "GBN-106392 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/02/2026 22:56:01",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/02/2026 22:56:01"
          },
          {
            "ticket_id": 9607,
            "ticket_number": "359599",
            "title": "GBN-106391 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "17/02/2026 22:56:50",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 22:56:50"
          },
          {
            "ticket_id": 9628,
            "ticket_number": "359620",
            "title": "GBN-106486 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "18/02/2026 13:55:02",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 13:55:02"
          },
          {
            "ticket_id": 9644,
            "ticket_number": "359636",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 14:09:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 32.33,
            "sla_met": false,
            "sla_breach_hours": 8.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 22:29:50"
          },
          {
            "ticket_id": 9649,
            "ticket_number": "359641",
            "title": "Información de reserva número: 1776719",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/02/2026 14:10:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 21.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:31"
          },
          {
            "ticket_id": 9652,
            "ticket_number": "359644",
            "title": "A/c Paula Candeias - dados cliente e faturaçao",
            "priority": "P2",
            "created_at": "18/02/2026 17:29:52",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 21:22:23"
          },
          {
            "ticket_id": 9664,
            "ticket_number": "359656",
            "title": "Confirmacao 339794",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 17:30:25",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 13:23:08"
          },
          {
            "ticket_id": 9665,
            "ticket_number": "359657",
            "title": "importante GBN",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:33",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:30:35"
          },
          {
            "ticket_id": 9667,
            "ticket_number": "359659",
            "title": "Número de informação da reserva: 6129257",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 17:31:23",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 20:46:19"
          },
          {
            "ticket_id": 9671,
            "ticket_number": "359663",
            "title": "Fwd: Notification of changes to your booking PGF8K",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 17:32:06",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 17:32:06"
          },
          {
            "ticket_id": 9676,
            "ticket_number": "359668",
            "title": "Informação de reserva - SPT002501548337",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 18:23:46",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 5.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 23:37:41"
          },
          {
            "ticket_id": 9678,
            "ticket_number": "359670",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802428609",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 18:23:50",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 14:23:14"
          },
          {
            "ticket_id": 9687,
            "ticket_number": "359679",
            "title": "GBN-106585 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 18:43:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/02/2026 18:43:46"
          },
          {
            "ticket_id": 9688,
            "ticket_number": "359680",
            "title": "Confirmação de reserva com localizador: 4082569",
            "priority": "Reservas sem Formulário",
            "created_at": "18/02/2026 18:43:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 14:43:15"
          },
          {
            "ticket_id": 9697,
            "ticket_number": "359689",
            "title": "WEBINARS NORTRAVEL | ALBÂNIA E MALTA - 23 E 24 DE ",
            "priority": "P3",
            "created_at": "18/02/2026 19:21:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 19:21:35"
          },
          {
            "ticket_id": 9698,
            "ticket_number": "359690",
            "title": "Webinar Nortravel Albania e Malta.",
            "priority": "P3",
            "created_at": "18/02/2026 19:21:37",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 19:21:37"
          },
          {
            "ticket_id": 9699,
            "ticket_number": "359691",
            "title": "Inscrição para webinares",
            "priority": "P3",
            "created_at": "18/02/2026 19:21:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 19:21:40"
          },
          {
            "ticket_id": 9700,
            "ticket_number": "359692",
            "title": "Inscrição para webinars",
            "priority": "P3",
            "created_at": "18/02/2026 19:21:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 19:21:43"
          },
          {
            "ticket_id": 9701,
            "ticket_number": "359693",
            "title": "FORMAÇÃO PROFISSIONAL | A LEI NO TURISMO | CERTIFI",
            "priority": "P2",
            "created_at": "18/02/2026 19:30:15",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 22:06:02"
          },
          {
            "ticket_id": 9702,
            "ticket_number": "359694",
            "title": "Webinar Albânia dia 23/02",
            "priority": "P3",
            "created_at": "18/02/2026 19:39:43",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 22:18:10"
          },
          {
            "ticket_id": 9703,
            "ticket_number": "359695",
            "title": "Webiner",
            "priority": "P3",
            "created_at": "18/02/2026 19:57:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 19:57:09"
          },
          {
            "ticket_id": 9705,
            "ticket_number": "359697",
            "title": "GBN-94696 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/02/2026 19:57:13",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 21:47:03"
          },
          {
            "ticket_id": 9706,
            "ticket_number": "359698",
            "title": "Webinar Nortravel - Albânia e Malta - 23 e 24 de F",
            "priority": "P3",
            "created_at": "18/02/2026 20:02:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 20:02:02"
          },
          {
            "ticket_id": 9707,
            "ticket_number": "359699",
            "title": "GBN-102937 - Paula Susana Viana Bessa",
            "priority": "P2",
            "created_at": "18/02/2026 20:14:09",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 20:14:09"
          },
          {
            "ticket_id": 9709,
            "ticket_number": "359701",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/02/2026 20:21:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 15.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:31"
          },
          {
            "ticket_id": 9712,
            "ticket_number": "359704",
            "title": "Webinar Albania e Malta",
            "priority": "P3",
            "created_at": "18/02/2026 21:57:18",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 21:57:19"
          },
          {
            "ticket_id": 9714,
            "ticket_number": "359706",
            "title": "Webinar Nortravel",
            "priority": "P3",
            "created_at": "18/02/2026 22:09:58",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 22:09:58"
          },
          {
            "ticket_id": 9719,
            "ticket_number": "359711",
            "title": "Inscrição webinar Nortravel",
            "priority": "P3",
            "created_at": "19/02/2026 00:01:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 00:01:20"
          },
          {
            "ticket_id": 9721,
            "ticket_number": "359713",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:06:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 11.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:12:32"
          },
          {
            "ticket_id": 9723,
            "ticket_number": "359715",
            "title": "GBN-106687 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:06:58",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 10:07:18"
          },
          {
            "ticket_id": 9724,
            "ticket_number": "359716",
            "title": "GBN-99486 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:07:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 11.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:13:25"
          },
          {
            "ticket_id": 9725,
            "ticket_number": "359717",
            "title": "GBN-94716 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:07:06",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 11.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:13:52"
          },
          {
            "ticket_id": 9726,
            "ticket_number": "359718",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:07:17",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 11.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:14:26"
          },
          {
            "ticket_id": 9730,
            "ticket_number": "359722",
            "title": "Fwd: Viagify informa sobre a sua reserva 125042296",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:07:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 10:07:37"
          },
          {
            "ticket_id": 9738,
            "ticket_number": "359730",
            "title": "Confirmação de reserva 338772",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 10:58:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 10.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:17:57"
          },
          {
            "ticket_id": 9747,
            "ticket_number": "359739",
            "title": "Fwd: Informações sobre a sua reserva TTN-122172174",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 11:42:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 11:42:06"
          },
          {
            "ticket_id": 9749,
            "ticket_number": "359741",
            "title": "GBN-106687 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 12:00:28",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 9.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:17:20"
          },
          {
            "ticket_id": 9754,
            "ticket_number": "359746",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:04:25",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 13:04:27"
          },
          {
            "ticket_id": 9755,
            "ticket_number": "359747",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:04:27",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 8.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:19:49"
          },
          {
            "ticket_id": 9758,
            "ticket_number": "359750",
            "title": "GBN-106750 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:04:35",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 13:04:35"
          },
          {
            "ticket_id": 9762,
            "ticket_number": "359754",
            "title": "GBN-105208 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:26:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 7.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 20:35:11"
          },
          {
            "ticket_id": 9763,
            "ticket_number": "359755",
            "title": "Nova Confirmação de reserva 339026### TIME LIMIT E",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:26:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 7.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:21:30"
          },
          {
            "ticket_id": 9765,
            "ticket_number": "359757",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 13:33:44",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 23:24:22"
          },
          {
            "ticket_id": 9767,
            "ticket_number": "359759",
            "title": "Fwd: Informações da reserva TTN-1236854333#9319397",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 14:14:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 14:14:39"
          },
          {
            "ticket_id": 9769,
            "ticket_number": "359761",
            "title": "Fwd: Informações sobre a sua reserva TTN-124248828",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 15:31:08",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 15:31:09"
          },
          {
            "ticket_id": 9770,
            "ticket_number": "359762",
            "title": "Fwd: Informações da reserva TTN-1242488288#9358928",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 15:31:11",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 15:31:12"
          },
          {
            "ticket_id": 9772,
            "ticket_number": "359764",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 15:31:16",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 5.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:24:36"
          },
          {
            "ticket_id": 9794,
            "ticket_number": "359786",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "19/02/2026 19:00:56",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 19:25:49"
          },
          {
            "ticket_id": 9798,
            "ticket_number": "359790",
            "title": "Número de informação da reserva: 6135846",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 19:34:40",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 98.57,
            "sla_met": false,
            "sla_breach_hours": 74.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:09:34"
          },
          {
            "ticket_id": 9800,
            "ticket_number": "359792",
            "title": "Número de informação da reserva: 6135857",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 20:30:55",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 838.0,
            "sla_met": false,
            "sla_breach_hours": 814.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:31:13"
          },
          {
            "ticket_id": 9803,
            "ticket_number": "359795",
            "title": "GBN-106940 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:24:12",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:24:12"
          },
          {
            "ticket_id": 9804,
            "ticket_number": "359796",
            "title": "GBN-106943 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:24:15",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:30:44"
          },
          {
            "ticket_id": 9805,
            "ticket_number": "359797",
            "title": "GBN-106942 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:24:18",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:24:18"
          },
          {
            "ticket_id": 9806,
            "ticket_number": "359798",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:30:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:30:44"
          },
          {
            "ticket_id": 9807,
            "ticket_number": "359799",
            "title": "Número de informação da reserva: 6135867",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:30:47",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 837.0,
            "sla_met": false,
            "sla_breach_hours": 813.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:31:38"
          },
          {
            "ticket_id": 9808,
            "ticket_number": "359800",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/02/2026 21:51:17",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/02/2026 21:51:17"
          },
          {
            "ticket_id": 9809,
            "ticket_number": "359801",
            "title": "Pedido de Orçamento Operadoras - Hotel Passion Bou",
            "priority": "P2",
            "created_at": "19/02/2026 22:02:51",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 22:02:52"
          },
          {
            "ticket_id": 9811,
            "ticket_number": "359803",
            "title": "GBN-106943",
            "priority": "P2",
            "created_at": "19/02/2026 22:30:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 22:30:42"
          },
          {
            "ticket_id": 9812,
            "ticket_number": "359804",
            "title": "Webinar TUI dia 24 fev",
            "priority": "P3",
            "created_at": "19/02/2026 22:41:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 22:41:42"
          },
          {
            "ticket_id": 9816,
            "ticket_number": "359808",
            "title": "Webinar TUI",
            "priority": "P2",
            "created_at": "19/02/2026 23:25:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 23:25:11"
          },
          {
            "ticket_id": 9820,
            "ticket_number": "359812",
            "title": "GBN-106957 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 00:03:31",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 00:03:31"
          },
          {
            "ticket_id": 9822,
            "ticket_number": "359814",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 00:03:39",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 00:03:39"
          },
          {
            "ticket_id": 9823,
            "ticket_number": "359815",
            "title": "Criação de processo File 430884/26",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 00:03:46",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 94.12,
            "sla_met": false,
            "sla_breach_hours": 70.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:11:24"
          },
          {
            "ticket_id": 9824,
            "ticket_number": "359816",
            "title": "[Pedido de Grupo] Cabo Verde - Boa Vista - Occiden",
            "priority": "P2",
            "created_at": "20/02/2026 08:21:32",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 15.33,
            "sla_met": false,
            "sla_breach_hours": 11.33,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 23:42:08"
          },
          {
            "ticket_id": 9826,
            "ticket_number": "359818",
            "title": "Confirmacao 339902",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:18:59",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 83.87,
            "sla_met": false,
            "sla_breach_hours": 59.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:11:39"
          },
          {
            "ticket_id": 9828,
            "ticket_number": "359820",
            "title": "Fwd: Viagify informa sobre a sua reserva 125089582",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:03",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:19:04"
          },
          {
            "ticket_id": 9830,
            "ticket_number": "359822",
            "title": "GBN-94229 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:09",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.57,
            "sla_met": false,
            "sla_breach_hours": 6.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:53:27"
          },
          {
            "ticket_id": 9831,
            "ticket_number": "359823",
            "title": "GBN-99486 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:11",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.57,
            "sla_met": false,
            "sla_breach_hours": 6.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:53:40"
          },
          {
            "ticket_id": 9832,
            "ticket_number": "359824",
            "title": "GBN-94716 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:13",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.58,
            "sla_met": false,
            "sla_breach_hours": 6.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:54:17"
          },
          {
            "ticket_id": 9833,
            "ticket_number": "359825",
            "title": "GBN-90308 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:15",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.58,
            "sla_met": false,
            "sla_breach_hours": 6.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:54:31"
          },
          {
            "ticket_id": 9834,
            "ticket_number": "359826",
            "title": "GBN-106059 - Sua reserva está pendente de pagament",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 629.53,
            "sla_met": false,
            "sla_breach_hours": 605.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:18"
          },
          {
            "ticket_id": 9835,
            "ticket_number": "359827",
            "title": "GBN-102937 - Sua reserva está pendente de pagament",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:20",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.58,
            "sla_met": false,
            "sla_breach_hours": 6.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:54:59"
          },
          {
            "ticket_id": 9838,
            "ticket_number": "359830",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:31",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:19:31"
          },
          {
            "ticket_id": 9839,
            "ticket_number": "359831",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:19:48"
          },
          {
            "ticket_id": 9841,
            "ticket_number": "359833",
            "title": "GBN-106965 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:48",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:19:48"
          },
          {
            "ticket_id": 9842,
            "ticket_number": "359834",
            "title": "GBN-106968 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:19:55",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 110.67,
            "sla_met": false,
            "sla_breach_hours": 86.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:03:06"
          },
          {
            "ticket_id": 9844,
            "ticket_number": "359836",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:20:04",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 84.93,
            "sla_met": false,
            "sla_breach_hours": 60.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:16:38"
          },
          {
            "ticket_id": 9846,
            "ticket_number": "359838",
            "title": "GBN-106969 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:20:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:20:13"
          },
          {
            "ticket_id": 9847,
            "ticket_number": "359839",
            "title": "GBN-106963 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:20:48",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:20:48"
          },
          {
            "ticket_id": 9849,
            "ticket_number": "359841",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:20:57",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 824.18,
            "sla_met": false,
            "sla_breach_hours": 800.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:32:36"
          },
          {
            "ticket_id": 9854,
            "ticket_number": "359846",
            "title": "Confirmacao 339899",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:41:43",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.3,
            "sla_met": false,
            "sla_breach_hours": 6.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 16:59:53"
          },
          {
            "ticket_id": 9856,
            "ticket_number": "359848",
            "title": "GBN-106957 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:54:18",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.08,
            "sla_met": false,
            "sla_breach_hours": 6.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:00:15"
          },
          {
            "ticket_id": 9857,
            "ticket_number": "359849",
            "title": "GBN-106958 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:54:21",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:54:24"
          },
          {
            "ticket_id": 9858,
            "ticket_number": "359850",
            "title": "GBN-106958 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:54:24",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 84.35,
            "sla_met": false,
            "sla_breach_hours": 60.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:15:57"
          },
          {
            "ticket_id": 9860,
            "ticket_number": "359852",
            "title": "GBN-106957 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:54:31",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:54:31"
          },
          {
            "ticket_id": 9861,
            "ticket_number": "359853",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 10:55:05",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 30.1,
            "sla_met": false,
            "sla_breach_hours": 6.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:01:32"
          },
          {
            "ticket_id": 9866,
            "ticket_number": "359855",
            "title": "[Pedido IATA] Lisboa → França - 2026-02-25 (1 pax)",
            "priority": "P2",
            "created_at": "20/02/2026 11:10:38",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 11:12:37"
          },
          {
            "ticket_id": 9869,
            "ticket_number": "359857",
            "title": "GBN-106762 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 11:33:30",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 200.42,
            "sla_met": false,
            "sla_breach_hours": 176.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:59:15"
          },
          {
            "ticket_id": 9871,
            "ticket_number": "359859",
            "title": "GBN-106964 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 11:33:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 11:33:34"
          },
          {
            "ticket_id": 9873,
            "ticket_number": "359861",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 12:16:08",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 81.97,
            "sla_met": false,
            "sla_breach_hours": 57.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:14:27"
          },
          {
            "ticket_id": 9881,
            "ticket_number": "359869",
            "title": "Confirmacao 339933",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 12:40:49",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 28.37,
            "sla_met": false,
            "sla_breach_hours": 4.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:03:06"
          },
          {
            "ticket_id": 9885,
            "ticket_number": "359873",
            "title": "GBN-106968 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 13:11:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 10:20:04"
          },
          {
            "ticket_id": 9887,
            "ticket_number": "359875",
            "title": "GBN-107051 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 13:11:41",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 198.75,
            "sla_met": false,
            "sla_breach_hours": 174.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:57:30"
          },
          {
            "ticket_id": 9889,
            "ticket_number": "359877",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 13:22:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 201.17,
            "sla_met": false,
            "sla_breach_hours": 177.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 22:32:38"
          },
          {
            "ticket_id": 9892,
            "ticket_number": "359880",
            "title": "GBN-107079 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 13:57:19",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 13:57:19"
          },
          {
            "ticket_id": 9902,
            "ticket_number": "359890",
            "title": "GBN-107092 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 15:03:03",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 15:03:03"
          },
          {
            "ticket_id": 9908,
            "ticket_number": "359896",
            "title": "GBN-107113 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 16:06:45",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 16:06:45"
          },
          {
            "ticket_id": 9912,
            "ticket_number": "359900",
            "title": "Número de informação da reserva: 6135986",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 16:23:22",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 24.7,
            "sla_met": false,
            "sla_breach_hours": 0.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:06:10"
          },
          {
            "ticket_id": 9917,
            "ticket_number": "359905",
            "title": "GBN-107059 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 16:53:29",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 16:53:43"
          },
          {
            "ticket_id": 9919,
            "ticket_number": "359907",
            "title": "GBN-107059 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 16:53:43",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 77.37,
            "sla_met": false,
            "sla_breach_hours": 53.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:15:45"
          },
          {
            "ticket_id": 9921,
            "ticket_number": "359909",
            "title": "Confirmacao 340001",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 17:33:43",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 23.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:08:44"
          },
          {
            "ticket_id": 9922,
            "ticket_number": "359910",
            "title": "GBN-107154 - Su confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 17:33:45",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 17:33:46"
          },
          {
            "ticket_id": 9925,
            "ticket_number": "359913",
            "title": "GBN-107165 - Su confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 17:48:33",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 17:48:33"
          },
          {
            "ticket_id": 9927,
            "ticket_number": "359915",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 18:04:51",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 18:04:51"
          },
          {
            "ticket_id": 9931,
            "ticket_number": "359919",
            "title": "Orçamento 2265780 - Namíbia Completa e Cataratas V",
            "priority": "P2",
            "created_at": "20/02/2026 19:03:04",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:12:48"
          },
          {
            "ticket_id": 9932,
            "ticket_number": "359920",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/02/2026 19:04:17",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:04:17"
          },
          {
            "ticket_id": 9933,
            "ticket_number": "359921",
            "title": "Inscrição Webinar TUI",
            "priority": "P2",
            "created_at": "20/02/2026 19:04:53",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:04:53"
          },
          {
            "ticket_id": 9934,
            "ticket_number": "359922",
            "title": "GBN-107172 - Su confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 19:04:56",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 19:04:56"
          },
          {
            "ticket_id": 9935,
            "ticket_number": "359923",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/02/2026 19:20:23",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:20:23"
          },
          {
            "ticket_id": 9937,
            "ticket_number": "359925",
            "title": "Fwd: Viagify informa sobre a sua reserva 125121233",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 19:20:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 19:20:29"
          },
          {
            "ticket_id": 9938,
            "ticket_number": "359926",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 19:20:34",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 19:20:34"
          },
          {
            "ticket_id": 9940,
            "ticket_number": "359928",
            "title": "Fwd: Viagify informa sobre a sua reserva 125118987",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 19:20:41",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 19:20:42"
          },
          {
            "ticket_id": 9941,
            "ticket_number": "359929",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 19:20:46",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/02/2026 19:20:46"
          },
          {
            "ticket_id": 9942,
            "ticket_number": "359930",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/02/2026 19:20:55",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:20:55"
          },
          {
            "ticket_id": 9944,
            "ticket_number": "359932",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/02/2026 19:21:07",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:21:07"
          },
          {
            "ticket_id": 9947,
            "ticket_number": "359935",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/02/2026 19:21:24",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:21:24"
          },
          {
            "ticket_id": 9948,
            "ticket_number": "359936",
            "title": "Reserva confirmada: Tour pelo Stamford Bridge, o e",
            "priority": "P2",
            "created_at": "20/02/2026 19:30:37",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:41:26"
          },
          {
            "ticket_id": 9949,
            "ticket_number": "359937",
            "title": "Formação TUI",
            "priority": "P2",
            "created_at": "20/02/2026 19:30:39",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:30:39"
          },
          {
            "ticket_id": 9955,
            "ticket_number": "359943",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:45",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:44:26"
          },
          {
            "ticket_id": 9957,
            "ticket_number": "359945",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:48",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:46:28"
          },
          {
            "ticket_id": 9958,
            "ticket_number": "359946",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:50",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:50:44"
          },
          {
            "ticket_id": 9959,
            "ticket_number": "359947",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:51",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:51:36"
          },
          {
            "ticket_id": 9960,
            "ticket_number": "359948",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:53",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:52:46"
          },
          {
            "ticket_id": 9961,
            "ticket_number": "359949",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:55",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:53:51"
          },
          {
            "ticket_id": 9962,
            "ticket_number": "359950",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:56",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:54:42"
          },
          {
            "ticket_id": 9963,
            "ticket_number": "359951",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 20:40:58",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 20.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:11:41"
          },
          {
            "ticket_id": 9964,
            "ticket_number": "359952",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:40:59",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:55:54"
          },
          {
            "ticket_id": 9965,
            "ticket_number": "359953",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/02/2026 20:41:01",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:45:38"
          },
          {
            "ticket_id": 9966,
            "ticket_number": "359954",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "20/02/2026 21:11:51",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 21:43:07"
          },
          {
            "ticket_id": 9967,
            "ticket_number": "359955",
            "title": "GBN-94229 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/02/2026 21:11:53",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 239.83,
            "sla_met": false,
            "sla_breach_hours": 235.83,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:02:03"
          },
          {
            "ticket_id": 9968,
            "ticket_number": "359956",
            "title": "Confirmação de reserva com localizador: 4086572",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 21:11:55",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 63.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 13:01:15"
          },
          {
            "ticket_id": 9971,
            "ticket_number": "359959",
            "title": "Dúvida Tour 10 - Reserva 4086572",
            "priority": "P2",
            "created_at": "20/02/2026 22:04:16",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 22:04:16"
          },
          {
            "ticket_id": 9981,
            "ticket_number": "359969",
            "title": "Criação de processo File 431079/26",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 23:49:34",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 17.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:14:09"
          },
          {
            "ticket_id": 9982,
            "ticket_number": "359970",
            "title": "Criação de processo File 431081/26",
            "priority": "Reservas sem Formulário",
            "created_at": "20/02/2026 23:49:40",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 17.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:14:24"
          },
          {
            "ticket_id": 9983,
            "ticket_number": "359971",
            "title": "Faça o download da sua fatura - Civitatis.com",
            "priority": "P2",
            "created_at": "21/02/2026 00:03:52",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 00:06:26"
          },
          {
            "ticket_id": 9984,
            "ticket_number": "359972",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 00:03:59",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 00:03:59"
          },
          {
            "ticket_id": 9985,
            "ticket_number": "359973",
            "title": "GBN-107260 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 00:04:08",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 00:04:08"
          },
          {
            "ticket_id": 9986,
            "ticket_number": "359974",
            "title": "GBN-107259 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 00:04:12",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 00:04:12"
          },
          {
            "ticket_id": 9987,
            "ticket_number": "359975",
            "title": "Cotação",
            "priority": "P2",
            "created_at": "21/02/2026 00:15:52",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 00:21:41"
          },
          {
            "ticket_id": 10003,
            "ticket_number": "359991",
            "title": "Fwd: CONFIRMACION RESERVA TTN-1251310178#93763071#",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 12:47:39",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 12:47:39"
          },
          {
            "ticket_id": 10009,
            "ticket_number": "359997",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:53",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 4.87,
            "sla_met": false,
            "sla_breach_hours": 0.87,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 17:41:03"
          },
          {
            "ticket_id": 10011,
            "ticket_number": "359999",
            "title": "Reserva confirmada: Passeio de barco pelas ilhas d",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:36",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:19:19"
          },
          {
            "ticket_id": 10012,
            "ticket_number": "3510000",
            "title": "Reserva confirmada: Excursão a Arraial do Cabo + P",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:38",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:21:12"
          },
          {
            "ticket_id": 10013,
            "ticket_number": "3510001",
            "title": "Reserva confirmada: Excursão a Arraial do Cabo + P",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:40",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:21:19"
          },
          {
            "ticket_id": 10014,
            "ticket_number": "3510002",
            "title": "Reserva confirmada: Transfer a Paraty - Civitatis.",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:43",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:20:42"
          },
          {
            "ticket_id": 10015,
            "ticket_number": "3510003",
            "title": "Reserva confirmada: Transfer a Paraty - Civitatis.",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:45",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:20:35"
          },
          {
            "ticket_id": 10017,
            "ticket_number": "3510005",
            "title": "Reserva confirmada: Passeio de barco pelas ilhas d",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:52:50",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:20:19"
          },
          {
            "ticket_id": 10024,
            "ticket_number": "3510012",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604558490",
            "priority": "Reservas sem Formulário",
            "created_at": "21/02/2026 13:53:08",
            "close_date": "2026-02-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/02/2026 17:21:34"
          },
          {
            "ticket_id": 10030,
            "ticket_number": "3510018",
            "title": "GBN-83958 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/02/2026 16:24:14",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 17:27:13"
          },
          {
            "ticket_id": 10039,
            "ticket_number": "3510027",
            "title": "Fwd: ANWB8L | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:06",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:07"
          },
          {
            "ticket_id": 10040,
            "ticket_number": "3510028",
            "title": "Fwd: ANWB8L | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:08",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:09"
          },
          {
            "ticket_id": 10045,
            "ticket_number": "3510033",
            "title": "Fwd: Viagify informa sobre a sua reserva 125168590",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:20",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 10:14:21"
          },
          {
            "ticket_id": 10049,
            "ticket_number": "3510037",
            "title": "Número de informação da reserva: 6136240",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:29",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 12.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:20:05"
          },
          {
            "ticket_id": 10050,
            "ticket_number": "3510038",
            "title": "GBN-107408 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:31",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 12.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:20:22"
          },
          {
            "ticket_id": 10052,
            "ticket_number": "3510040",
            "title": "Viagem Senegal",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:36",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:36"
          },
          {
            "ticket_id": 10054,
            "ticket_number": "3510042",
            "title": "Confirmação de reserva com localizador: 4087614",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:40",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 12.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:20:44"
          },
          {
            "ticket_id": 10055,
            "ticket_number": "3510043",
            "title": "GBN-107408 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:43",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 10:14:43"
          },
          {
            "ticket_id": 10058,
            "ticket_number": "3510046",
            "title": "GBN-107418 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:54",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 10:14:54"
          },
          {
            "ticket_id": 10059,
            "ticket_number": "3510047",
            "title": "Número de informação da reserva: 6136213",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:14:58",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 12.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:21:56"
          },
          {
            "ticket_id": 10060,
            "ticket_number": "3510048",
            "title": "GBN-107378 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:25:30",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 10:26:54"
          },
          {
            "ticket_id": 10061,
            "ticket_number": "3510049",
            "title": "Confirmacao 340136",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:25:31",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 11.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:22:41"
          },
          {
            "ticket_id": 10064,
            "ticket_number": "3510052",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:26:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:23:48"
          },
          {
            "ticket_id": 10065,
            "ticket_number": "3510053",
            "title": "Confirmacao 340138",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:26:48",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 11.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:23:18"
          },
          {
            "ticket_id": 10067,
            "ticket_number": "3510055",
            "title": "Número de informação da reserva: 6136183",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:26:58",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 12.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:28:27"
          },
          {
            "ticket_id": 10068,
            "ticket_number": "3510056",
            "title": "Criação de processo File 431151/26",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:27:35",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 11.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:27:21"
          },
          {
            "ticket_id": 10075,
            "ticket_number": "3510063",
            "title": "Confirmação de reserva 339901",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 10:34:05",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 11.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:23:51"
          },
          {
            "ticket_id": 10087,
            "ticket_number": "3510075",
            "title": "Pedido de Sinalização De Reserva 340056",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:12",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10088,
            "ticket_number": "3510076",
            "title": "Pedido de Sinalização De Reserva 340001",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:13",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10089,
            "ticket_number": "3510077",
            "title": "Pedido de Sinalização De Reserva 339901",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:15",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10090,
            "ticket_number": "3510078",
            "title": "Pedido de Sinalização De Reserva 339794",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:16",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10091,
            "ticket_number": "3510079",
            "title": "Pedido de Sinalização De Reserva 339933",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:17",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10092,
            "ticket_number": "3510080",
            "title": "Pedido de Sinalização De Reserva 339902",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:19",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:53:21"
          },
          {
            "ticket_id": 10094,
            "ticket_number": "3510082",
            "title": "Fwd: Recebeu uma nova mensagem TTN-1245307256#9377",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:23",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:40:23"
          },
          {
            "ticket_id": 10104,
            "ticket_number": "3510092",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 12:56:06",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 9.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:27:39"
          },
          {
            "ticket_id": 10108,
            "ticket_number": "3510096",
            "title": "Fwd: Informações da reserva TTN-1145204664#9379125",
            "priority": "P2",
            "created_at": "23/02/2026 13:38:27",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 13:38:27"
          },
          {
            "ticket_id": 10112,
            "ticket_number": "3510100",
            "title": "Comprovativo",
            "priority": "P2",
            "created_at": "23/02/2026 13:38:38",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 13:42:20"
          },
          {
            "ticket_id": 10113,
            "ticket_number": "3510101",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 13:38:45",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 8.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:29:13"
          },
          {
            "ticket_id": 10120,
            "ticket_number": "3510108",
            "title": "Número de informação da reserva: 6136355",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 14:28:41",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 548.52,
            "sla_met": false,
            "sla_breach_hours": 524.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 11:00:25"
          },
          {
            "ticket_id": 10122,
            "ticket_number": "3510110",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 14:28:46",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:31:05"
          },
          {
            "ticket_id": 10123,
            "ticket_number": "3510111",
            "title": "Número de informação da reserva: 6136352",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 14:28:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 548.52,
            "sla_met": false,
            "sla_breach_hours": 524.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 11:00:24"
          },
          {
            "ticket_id": 10125,
            "ticket_number": "3510113",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 14:28:53",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:31:24"
          },
          {
            "ticket_id": 10126,
            "ticket_number": "3510114",
            "title": "GBN-107523 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 14:28:56",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 14:28:56"
          },
          {
            "ticket_id": 10129,
            "ticket_number": "3510117",
            "title": "Incidencia de Voo / 1240917792 TTN-1240917792#9254",
            "priority": "P2",
            "created_at": "23/02/2026 14:45:22",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:51:31"
          },
          {
            "ticket_id": 10132,
            "ticket_number": "3510120",
            "title": "GBN-107545 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 15:09:32",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 15:09:32"
          },
          {
            "ticket_id": 10136,
            "ticket_number": "3510124",
            "title": "Confirmação de reserva. Localizador: 2E7X6H7864",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:20:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 16:20:11"
          },
          {
            "ticket_id": 10139,
            "ticket_number": "3510127",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:20:11",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 6.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:08:01"
          },
          {
            "ticket_id": 10140,
            "ticket_number": "3510128",
            "title": "Confirmação de reserva. Localizador: 67Q5H8V3AH",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:20:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 16:20:16"
          },
          {
            "ticket_id": 10141,
            "ticket_number": "3510129",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:20:15",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 6.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:34:53"
          },
          {
            "ticket_id": 10143,
            "ticket_number": "3510131",
            "title": "Informação de reserva - SPT002601593417",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:24:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 546.58,
            "sla_met": false,
            "sla_breach_hours": 522.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:51"
          },
          {
            "ticket_id": 10144,
            "ticket_number": "3510132",
            "title": "Reserva Aéreo [ERROR_AIR-53417C8785] - Erro Técnic",
            "priority": "P2",
            "created_at": "23/02/2026 16:24:05",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:18:06"
          },
          {
            "ticket_id": 10146,
            "ticket_number": "3510134",
            "title": "Número de informação da reserva: 6136382",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 16:24:11",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 6.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 22:35:53"
          },
          {
            "ticket_id": 10152,
            "ticket_number": "3510140",
            "title": "Fwd: Informações da reserva TTN-1234129672#9392545",
            "priority": "P2",
            "created_at": "23/02/2026 17:21:04",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:21:04"
          },
          {
            "ticket_id": 10156,
            "ticket_number": "3510144",
            "title": "FW: Cancelamento reserva loc 604550151da travelpla",
            "priority": "P2",
            "created_at": "23/02/2026 17:21:15",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:21:16"
          },
          {
            "ticket_id": 10159,
            "ticket_number": "3510147",
            "title": "Confirmação de reserva 340259",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 17:53:21",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 13:45:00"
          },
          {
            "ticket_id": 10161,
            "ticket_number": "3510149",
            "title": "Fwd: Viagify informa sobre a sua reserva 125221855",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 18:19:59",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 18:20:00"
          },
          {
            "ticket_id": 10165,
            "ticket_number": "3510153",
            "title": "Viajar Tours - BTL Criança Grátis",
            "priority": "P2",
            "created_at": "23/02/2026 19:08:28",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:10:18"
          },
          {
            "ticket_id": 10169,
            "ticket_number": "3510157",
            "title": "doc em falta Mariana Almeida",
            "priority": "P2",
            "created_at": "23/02/2026 19:08:40",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:08:40"
          },
          {
            "ticket_id": 10170,
            "ticket_number": "3510158",
            "title": "Inscrição no webinar TUI",
            "priority": "P2",
            "created_at": "23/02/2026 19:09:45",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:09:45"
          },
          {
            "ticket_id": 10171,
            "ticket_number": "3510159",
            "title": "PEDIDO DE CODIGOS DE ACESSO AO MELIA",
            "priority": "P2",
            "created_at": "23/02/2026 19:09:47",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:09:47"
          },
          {
            "ticket_id": 10173,
            "ticket_number": "3510161",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 19:40:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 19:40:23"
          },
          {
            "ticket_id": 10178,
            "ticket_number": "3510166",
            "title": "GBN-107498 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/02/2026 20:29:33",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 20:29:33"
          },
          {
            "ticket_id": 10181,
            "ticket_number": "3510169",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604559699",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 21:22:22",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 17:20:20"
          },
          {
            "ticket_id": 10182,
            "ticket_number": "3510170",
            "title": "GBN-107692 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/02/2026 21:22:24",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 21:22:24"
          },
          {
            "ticket_id": 10183,
            "ticket_number": "3510171",
            "title": "dados acesso beds online",
            "priority": "P2",
            "created_at": "23/02/2026 21:22:57",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 21:22:58"
          },
          {
            "ticket_id": 10184,
            "ticket_number": "3510172",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 22:26:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 18:20:41"
          },
          {
            "ticket_id": 10185,
            "ticket_number": "3510173",
            "title": "TRP-2026-03648_Cristiana Nobre",
            "priority": "P2",
            "created_at": "23/02/2026 22:40:07",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 22:40:08"
          },
          {
            "ticket_id": 10186,
            "ticket_number": "3510174",
            "title": "Mensagem sobre a reserva 37202099 - Civitatis",
            "priority": "P2",
            "created_at": "23/02/2026 22:43:22",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 11.8,
            "sla_met": false,
            "sla_breach_hours": 7.8,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:32:08"
          },
          {
            "ticket_id": 10187,
            "ticket_number": "3510175",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 23:04:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:04:29"
          },
          {
            "ticket_id": 10189,
            "ticket_number": "3510177",
            "title": "GBN-107712 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 23:04:29",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:04:29"
          },
          {
            "ticket_id": 10190,
            "ticket_number": "3510178",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "23/02/2026 23:13:05",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/02/2026 23:13:05"
          },
          {
            "ticket_id": 10191,
            "ticket_number": "3510179",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "23/02/2026 23:22:11",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 23:25:38"
          },
          {
            "ticket_id": 10193,
            "ticket_number": "3510181",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "23/02/2026 23:22:17",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 23:24:35"
          },
          {
            "ticket_id": 10194,
            "ticket_number": "3510182",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "23/02/2026 23:33:58",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 23:35:44"
          },
          {
            "ticket_id": 10207,
            "ticket_number": "3510195",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:14",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:21:21"
          },
          {
            "ticket_id": 10209,
            "ticket_number": "3510197",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:18",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:24:11"
          },
          {
            "ticket_id": 10210,
            "ticket_number": "3510198",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:21",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:24:11"
          },
          {
            "ticket_id": 10226,
            "ticket_number": "3510214",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 11:09:46",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:00:57"
          },
          {
            "ticket_id": 10228,
            "ticket_number": "3510216",
            "title": "Envio de documentos de File 430884 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "24/02/2026 11:09:51",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:23:45"
          },
          {
            "ticket_id": 10229,
            "ticket_number": "3510217",
            "title": "Envio de documentos de File 431079 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "24/02/2026 11:09:52",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:24:13"
          },
          {
            "ticket_id": 10231,
            "ticket_number": "3510219",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "24/02/2026 11:19:01",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:22:38"
          },
          {
            "ticket_id": 10232,
            "ticket_number": "3510220",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "24/02/2026 11:19:04",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:23:25"
          },
          {
            "ticket_id": 10233,
            "ticket_number": "3510221",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 11:28:47",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:20:58"
          },
          {
            "ticket_id": 10235,
            "ticket_number": "3510223",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 11:44:42",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:41:00"
          },
          {
            "ticket_id": 10236,
            "ticket_number": "3510224",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 11:44:45",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:41:00"
          },
          {
            "ticket_id": 10237,
            "ticket_number": "3510225",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 11:44:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:41:00"
          },
          {
            "ticket_id": 10238,
            "ticket_number": "3510226",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 12:01:12",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 22:01:01"
          },
          {
            "ticket_id": 10239,
            "ticket_number": "3510227",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 12:11:45",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 22:01:01"
          },
          {
            "ticket_id": 10240,
            "ticket_number": "3510228",
            "title": "Informação importante para reserva 6132660",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 12:17:40",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 103.5,
            "sla_met": false,
            "sla_breach_hours": 79.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:48:05"
          },
          {
            "ticket_id": 10241,
            "ticket_number": "3510229",
            "title": "Informação importante para reserva 6126361",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 12:17:43",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 103.47,
            "sla_met": false,
            "sla_breach_hours": 79.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:46:11"
          },
          {
            "ticket_id": 10254,
            "ticket_number": "3510242",
            "title": "GBN-107813 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 13:53:10",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 13:53:10"
          },
          {
            "ticket_id": 10279,
            "ticket_number": "3510267",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604560494",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 18:21:07",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 98.05,
            "sla_met": false,
            "sla_breach_hours": 74.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:24:33"
          },
          {
            "ticket_id": 10290,
            "ticket_number": "3510278",
            "title": "G1L905 – Novo prazo de emissão",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 19:09:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 19:09:14"
          },
          {
            "ticket_id": 10291,
            "ticket_number": "3510279",
            "title": "Informação de reserva - SPT002601594377",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 19:12:00",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 15:02:00"
          },
          {
            "ticket_id": 10292,
            "ticket_number": "3510280",
            "title": "Mediterrâneo 2026: a elegância de navegar com a Cu",
            "priority": "P2",
            "created_at": "24/02/2026 19:20:30",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 19:32:23"
          },
          {
            "ticket_id": 10293,
            "ticket_number": "3510281",
            "title": "Reserva confirmada: Trilha pelo glaciar Vatnajökul",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 19:20:32",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 97.07,
            "sla_met": false,
            "sla_breach_hours": 73.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:25:17"
          },
          {
            "ticket_id": 10294,
            "ticket_number": "3510282",
            "title": "Monitor de Reservas  - Aereo - LA0455202EOAH",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 19:20:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 19:20:36"
          },
          {
            "ticket_id": 10295,
            "ticket_number": "3510283",
            "title": "Reserva confirmada: Trilha pelo glaciar Vatnajökul",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 19:20:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 524.17,
            "sla_met": false,
            "sla_breach_hours": 500.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:31:00"
          },
          {
            "ticket_id": 10297,
            "ticket_number": "3510285",
            "title": "GBN-107967 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 20:08:42",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:08:42"
          },
          {
            "ticket_id": 10298,
            "ticket_number": "3510286",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 20:08:45",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:08:45"
          },
          {
            "ticket_id": 10299,
            "ticket_number": "3510287",
            "title": "Confirmação de reserva com localizador: 4091751",
            "priority": "P2",
            "created_at": "24/02/2026 20:08:49",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 20:29:27"
          },
          {
            "ticket_id": 10300,
            "ticket_number": "3510288",
            "title": "GBN-107954 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 20:08:53",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:08:53"
          },
          {
            "ticket_id": 10301,
            "ticket_number": "3510289",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "24/02/2026 20:08:56",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:35:23"
          },
          {
            "ticket_id": 10302,
            "ticket_number": "3510290",
            "title": "GBN-107971 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 20:14:47",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:14:47"
          },
          {
            "ticket_id": 10303,
            "ticket_number": "3510291",
            "title": "GBN-107977 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 20:21:39",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 20:21:39"
          },
          {
            "ticket_id": 10305,
            "ticket_number": "3510293",
            "title": "Reserva Aérea ZC6DOM",
            "priority": "P2",
            "created_at": "24/02/2026 20:59:14",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:36:33"
          },
          {
            "ticket_id": 10308,
            "ticket_number": "3510296",
            "title": "Cobrança Diária - 24/02/2026 - UMA FAMILIA EM VIAG",
            "priority": "P2",
            "created_at": "24/02/2026 22:27:33",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:35:30"
          },
          {
            "ticket_id": 10309,
            "ticket_number": "3510297",
            "title": "ZC6DOM – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "24/02/2026 22:27:36",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:27:36"
          },
          {
            "ticket_id": 10310,
            "ticket_number": "3510298",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 22:27:46",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 22:27:46"
          },
          {
            "ticket_id": 10311,
            "ticket_number": "3510299",
            "title": "Travelplan 604532920 + INSURE 2018997 - CUBA",
            "priority": "P2",
            "created_at": "24/02/2026 22:27:49",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:27:51"
          },
          {
            "ticket_id": 10312,
            "ticket_number": "3510300",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 22:28:00",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 18:22:15"
          },
          {
            "ticket_id": 10313,
            "ticket_number": "3510301",
            "title": "GBN-107993 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 22:28:12",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/02/2026 22:28:12"
          },
          {
            "ticket_id": 10314,
            "ticket_number": "3510302",
            "title": "RUFINO/BELMIRA MRS 26FEB LIS OPO",
            "priority": "P2",
            "created_at": "24/02/2026 23:13:38",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:14:17"
          },
          {
            "ticket_id": 10315,
            "ticket_number": "3510303",
            "title": "Informação de reserva - SPT002601594496",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 23:31:06",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 19:22:21"
          },
          {
            "ticket_id": 10316,
            "ticket_number": "3510304",
            "title": "Número de informação da reserva: 6136713",
            "priority": "Reservas sem Formulário",
            "created_at": "24/02/2026 23:31:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 19:22:21"
          },
          {
            "ticket_id": 10317,
            "ticket_number": "3510305",
            "title": "cancelamento",
            "priority": "P2",
            "created_at": "24/02/2026 23:31:13",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:31:14"
          },
          {
            "ticket_id": 10319,
            "ticket_number": "3510307",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "24/02/2026 23:32:54",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:32:54"
          },
          {
            "ticket_id": 10320,
            "ticket_number": "3510308",
            "title": "Acesso ao fornecedor Bedsonline",
            "priority": "P2",
            "created_at": "24/02/2026 23:32:58",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:32:58"
          },
          {
            "ticket_id": 10324,
            "ticket_number": "3510312",
            "title": "GBN-108016 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 00:07:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 00:07:23"
          },
          {
            "ticket_id": 10330,
            "ticket_number": "3510318",
            "title": "Fwd: Informações da reserva TTN-1252868896#9409538",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 10:16:19",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 10:16:20"
          },
          {
            "ticket_id": 10332,
            "ticket_number": "3510320",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 10:16:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 10:16:31"
          },
          {
            "ticket_id": 10336,
            "ticket_number": "3510324",
            "title": "Fwd: Viagify informa sobre a sua reserva 125286889",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 10:16:46",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 10:16:46"
          },
          {
            "ticket_id": 10337,
            "ticket_number": "3510325",
            "title": "Reunimos na BTL para potenciar a rentabilidade da ",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:48",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:00:37"
          },
          {
            "ticket_id": 10338,
            "ticket_number": "3510326",
            "title": "COSTA CRUZEIROS - Promoção Especial para Agentes d",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:51",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:00:43"
          },
          {
            "ticket_id": 10343,
            "ticket_number": "3510331",
            "title": "TARIFAS NET_TOURS_2026",
            "priority": "P2",
            "created_at": "25/02/2026 10:17:06",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:02:11"
          },
          {
            "ticket_id": 10344,
            "ticket_number": "3510332",
            "title": "CAMPANHA BTL | EXOTICOONLINE e DESTINOS",
            "priority": "P2",
            "created_at": "25/02/2026 10:17:16",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:57:28"
          },
          {
            "ticket_id": 10350,
            "ticket_number": "3510338",
            "title": "Confirmação n. 221473",
            "priority": "P2",
            "created_at": "25/02/2026 10:57:43",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 7.47,
            "sla_met": false,
            "sla_breach_hours": 3.47,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:26:35"
          },
          {
            "ticket_id": 10355,
            "ticket_number": "3510343",
            "title": "Criação de processo File 431638/26",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:00:38",
            "close_date": "2026-02-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 11:10:44"
          },
          {
            "ticket_id": 10359,
            "ticket_number": "3510347",
            "title": "GBN-108038 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:18:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 508.25,
            "sla_met": false,
            "sla_breach_hours": 484.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:33:52"
          },
          {
            "ticket_id": 10361,
            "ticket_number": "3510349",
            "title": "GBN-108051 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:41:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 11:41:32"
          },
          {
            "ticket_id": 10362,
            "ticket_number": "3510350",
            "title": "Reserva  TRP-2026-03107",
            "priority": "P2",
            "created_at": "25/02/2026 11:41:34",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:41:35"
          },
          {
            "ticket_id": 10364,
            "ticket_number": "3510352",
            "title": "GBN-108053 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:41:41",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 11:41:41"
          },
          {
            "ticket_id": 10365,
            "ticket_number": "3510353",
            "title": "Confirmação de Reserva * File 431638",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:41:47",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 80.45,
            "sla_met": false,
            "sla_breach_hours": 56.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:09:14"
          },
          {
            "ticket_id": 10366,
            "ticket_number": "3510354",
            "title": "Fwd: Viagify informa sobre a sua reserva 125302583",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:51:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 11:51:25"
          },
          {
            "ticket_id": 10367,
            "ticket_number": "3510355",
            "title": "GBN-108058 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 11:51:27",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 11:51:27"
          },
          {
            "ticket_id": 10368,
            "ticket_number": "3510356",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:01",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 22:22:37"
          },
          {
            "ticket_id": 10369,
            "ticket_number": "3510357",
            "title": "GBN-108091 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 79.62,
            "sla_met": false,
            "sla_breach_hours": 55.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:08:31"
          },
          {
            "ticket_id": 10370,
            "ticket_number": "3510358",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:07",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 22:22:37"
          },
          {
            "ticket_id": 10372,
            "ticket_number": "3510360",
            "title": "Fwd: Viagify informa sobre a sua reserva 125304065",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:13",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 12:31:14"
          },
          {
            "ticket_id": 10373,
            "ticket_number": "3510361",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 12:31:21"
          },
          {
            "ticket_id": 10374,
            "ticket_number": "3510362",
            "title": "GBN-108072 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:31:28",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 12:31:28"
          },
          {
            "ticket_id": 10376,
            "ticket_number": "3510364",
            "title": "GBN-108096 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 12:43:12",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 12:43:12"
          },
          {
            "ticket_id": 10381,
            "ticket_number": "3510369",
            "title": "Fwd: Viagify informa sobre a sua reserva 125306347",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 13:01:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 13:01:19"
          },
          {
            "ticket_id": 10382,
            "ticket_number": "3510370",
            "title": "Pedido de reserva – Ref PP924615, Sr. Joaquim Duar",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 13:01:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 501.97,
            "sla_met": false,
            "sla_breach_hours": 477.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:49"
          },
          {
            "ticket_id": 10383,
            "ticket_number": "3510371",
            "title": "Fwd: Informações da reserva TTN-1218445868#9392097",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 13:45:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 13:45:14"
          },
          {
            "ticket_id": 10385,
            "ticket_number": "3510373",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 13:45:18",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:42:43"
          },
          {
            "ticket_id": 10386,
            "ticket_number": "3510374",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 13:45:22",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:42:43"
          },
          {
            "ticket_id": 10390,
            "ticket_number": "3510378",
            "title": "GBN-107545 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 14:28:44",
            "close_date": "2026-02-26",
            "sla_target_hours": 24,
            "actual_time_hours": 20.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 10:56:45"
          },
          {
            "ticket_id": 10391,
            "ticket_number": "3510379",
            "title": "GBN-108134 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 14:54:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 500.08,
            "sla_met": false,
            "sla_breach_hours": 476.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:49"
          },
          {
            "ticket_id": 10392,
            "ticket_number": "3510380",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604561368",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 14:54:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 500.08,
            "sla_met": false,
            "sla_breach_hours": 476.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:49"
          },
          {
            "ticket_id": 10393,
            "ticket_number": "3510381",
            "title": "Confirmação de reserva para For PT004157 70075958",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 14:54:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 500.08,
            "sla_met": false,
            "sla_breach_hours": 476.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:49"
          },
          {
            "ticket_id": 10395,
            "ticket_number": "3510383",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 14:54:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 500.08,
            "sla_met": false,
            "sla_breach_hours": 476.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:48"
          },
          {
            "ticket_id": 10396,
            "ticket_number": "3510384",
            "title": "Confirmação de reserva com localizador: 4073235",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 15:06:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 499.88,
            "sla_met": false,
            "sla_breach_hours": 475.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:48"
          },
          {
            "ticket_id": 10401,
            "ticket_number": "3510389",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:19:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 503.27,
            "sla_met": false,
            "sla_breach_hours": 479.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:35:14"
          },
          {
            "ticket_id": 10402,
            "ticket_number": "3510390",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:19:06",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 75.3,
            "sla_met": false,
            "sla_breach_hours": 51.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:38:00"
          },
          {
            "ticket_id": 10405,
            "ticket_number": "3510393",
            "title": "Informação de reserva - SPT002601594974",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:21:26",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 650.9,
            "sla_met": false,
            "sla_breach_hours": 626.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 19:15:31"
          },
          {
            "ticket_id": 10406,
            "ticket_number": "3510394",
            "title": "Número de informação da reserva: 6136829",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:21:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 498.63,
            "sla_met": false,
            "sla_breach_hours": 474.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:48"
          },
          {
            "ticket_id": 10407,
            "ticket_number": "3510395",
            "title": "Informação de reserva - SPT002601594496",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:22:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 498.62,
            "sla_met": false,
            "sla_breach_hours": 474.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:48"
          },
          {
            "ticket_id": 10409,
            "ticket_number": "3510397",
            "title": "Reserva confirmada: Passeio de barco pelo Sena - C",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 16:40:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 502.92,
            "sla_met": false,
            "sla_breach_hours": 478.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:35:40"
          },
          {
            "ticket_id": 10411,
            "ticket_number": "3510399",
            "title": "Fwd: Informações da sua reserva TTN-1253063476#941",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 17:20:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 17:20:48"
          },
          {
            "ticket_id": 10412,
            "ticket_number": "3510400",
            "title": "Reserva confirmada: Passeio de barco pelo Sena - C",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 17:20:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 502.25,
            "sla_met": false,
            "sla_breach_hours": 478.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:36:21"
          },
          {
            "ticket_id": 10414,
            "ticket_number": "3510402",
            "title": "Mensagem sobre a reserva 37167461 - Civitatis",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 17:21:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 502.25,
            "sla_met": false,
            "sla_breach_hours": 478.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:36:35"
          },
          {
            "ticket_id": 10417,
            "ticket_number": "3510405",
            "title": "Informação de reserva - SPT002601594377",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 17:58:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 497.02,
            "sla_met": false,
            "sla_breach_hours": 473.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:48"
          },
          {
            "ticket_id": 10420,
            "ticket_number": "3510408",
            "title": "GBN-108215 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 17:59:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 17:59:01"
          },
          {
            "ticket_id": 10424,
            "ticket_number": "3510412",
            "title": "[Suporte] TRP-2026-00104 - teste",
            "priority": "P2",
            "created_at": "25/02/2026 18:06:29",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:06:53"
          },
          {
            "ticket_id": 10425,
            "ticket_number": "3510413",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 18:16:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 14:03:36"
          },
          {
            "ticket_id": 10426,
            "ticket_number": "3510414",
            "title": "Pedido de orçamento à Soltrópico",
            "priority": "P2",
            "created_at": "25/02/2026 18:16:41",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.17,
            "sla_met": false,
            "sla_breach_hours": 2.17,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 00:27:26"
          },
          {
            "ticket_id": 10427,
            "ticket_number": "3510415",
            "title": "Número de informação da reserva: 6136921",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 18:25:37",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 14:23:39"
          },
          {
            "ticket_id": 10428,
            "ticket_number": "3510416",
            "title": "GBN-108091 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 18:36:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 14:23:39"
          },
          {
            "ticket_id": 10433,
            "ticket_number": "3510421",
            "title": "GBN-101445 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 20:34:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 16:23:48"
          },
          {
            "ticket_id": 10435,
            "ticket_number": "3510423",
            "title": "GBN-108276 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/02/2026 20:34:38",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 20:34:38"
          },
          {
            "ticket_id": 10438,
            "ticket_number": "3510426",
            "title": "NB6136829 - alteração do género",
            "priority": "P2",
            "created_at": "25/02/2026 21:19:17",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:19:17"
          },
          {
            "ticket_id": 10439,
            "ticket_number": "3510427",
            "title": "Criação de processo File 431913/26",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 21:25:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 17:23:53"
          },
          {
            "ticket_id": 10440,
            "ticket_number": "3510428",
            "title": "Fwd: Informações sobre a sua reserva TTN-125304065",
            "priority": "P2",
            "created_at": "25/02/2026 21:27:52",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:27:53"
          },
          {
            "ticket_id": 10441,
            "ticket_number": "3510429",
            "title": "Fwd: Viagify informa sobre a sua reserva 125334684",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 21:28:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:28:26"
          },
          {
            "ticket_id": 10442,
            "ticket_number": "3510430",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 21:39:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:39:04"
          },
          {
            "ticket_id": 10446,
            "ticket_number": "3510434",
            "title": "GBN-108303 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 21:53:54",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 21:53:54"
          },
          {
            "ticket_id": 10447,
            "ticket_number": "3510435",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 22:24:37",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 22:24:45"
          },
          {
            "ticket_id": 10451,
            "ticket_number": "3510439",
            "title": "GBN-108305 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 22:24:48",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 22:24:48"
          },
          {
            "ticket_id": 10456,
            "ticket_number": "3510444",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604562072",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 23:00:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 38.33,
            "sla_met": false,
            "sla_breach_hours": 14.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 13:20:31"
          },
          {
            "ticket_id": 10457,
            "ticket_number": "3510445",
            "title": "Confirmação de reserva – Ref PP127864, Sr. Nelson ",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 23:21:38",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 69.1,
            "sla_met": false,
            "sla_breach_hours": 45.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:28:11"
          },
          {
            "ticket_id": 10458,
            "ticket_number": "3510446",
            "title": "GBN-108320 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 23:34:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:24:03"
          },
          {
            "ticket_id": 10459,
            "ticket_number": "3510447",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 23:34:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:24:03"
          },
          {
            "ticket_id": 10461,
            "ticket_number": "3510449",
            "title": "Reserva confirmada: Passeio de barco com avistamen",
            "priority": "Reservas sem Formulário",
            "created_at": "25/02/2026 23:47:08",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/02/2026 23:47:08"
          },
          {
            "ticket_id": 10464,
            "ticket_number": "3510452",
            "title": "[Pedido IATA] Lisboa → Sharm El sheik - 2026-04-01",
            "priority": "P2",
            "created_at": "26/02/2026 03:51:03",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 03:51:03"
          },
          {
            "ticket_id": 10465,
            "ticket_number": "3510453",
            "title": "GBN-96083 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 10:03:44",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 57.1,
            "sla_met": false,
            "sla_breach_hours": 33.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:10:34"
          },
          {
            "ticket_id": 10468,
            "ticket_number": "3510456",
            "title": "GBN-105314 - Sua reserva está pendente de pagament",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 10:03:56",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 58.38,
            "sla_met": false,
            "sla_breach_hours": 34.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:27:10"
          },
          {
            "ticket_id": 10470,
            "ticket_number": "3510458",
            "title": "Confirmación de la reserva con localizador: 409417",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 10:04:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 480.92,
            "sla_met": false,
            "sla_breach_hours": 456.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:46"
          },
          {
            "ticket_id": 10479,
            "ticket_number": "3510467",
            "title": "GBN-108337 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 11:18:06",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 11:18:06"
          },
          {
            "ticket_id": 10484,
            "ticket_number": "3510472",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 11:46:50",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 21:44:17"
          },
          {
            "ticket_id": 10485,
            "ticket_number": "3510473",
            "title": "Confirmação de reserva com localizador: 4073235",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 11:46:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 21:44:17"
          },
          {
            "ticket_id": 10487,
            "ticket_number": "3510475",
            "title": "Localizador SPT002601595601: Recebemos o pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:15:25",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:04:18"
          },
          {
            "ticket_id": 10489,
            "ticket_number": "3510477",
            "title": "Informação de reserva - SPT002601595478",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:15:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:04:18"
          },
          {
            "ticket_id": 10490,
            "ticket_number": "3510478",
            "title": "Fwd: Viagify informa sobre a sua reserva 125336758",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:17:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 12:17:14"
          },
          {
            "ticket_id": 10492,
            "ticket_number": "3510480",
            "title": "Fwd: Viagify informa sobre a sua reserva 125336758",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:17:20",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 12:17:21"
          },
          {
            "ticket_id": 10493,
            "ticket_number": "3510481",
            "title": "Fwd: Viagify informa sobre a sua reserva 125337317",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:17:24",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 12:17:25"
          },
          {
            "ticket_id": 10494,
            "ticket_number": "3510482",
            "title": "Fwd: Viagify informa sobre a sua reserva 125331325",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:17:28",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 12:17:28"
          },
          {
            "ticket_id": 10496,
            "ticket_number": "3510484",
            "title": "Fwd: Informações da sua reserva TTN-1253367581#942",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:17:35",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 12:17:36"
          },
          {
            "ticket_id": 10499,
            "ticket_number": "3510487",
            "title": "Informação de reserva - SPT002601595601",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 12:24:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:24:20"
          },
          {
            "ticket_id": 10508,
            "ticket_number": "3510496",
            "title": "Reserva WL 340676",
            "priority": "P2",
            "created_at": "26/02/2026 13:07:38",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 319.75,
            "sla_met": false,
            "sla_breach_hours": 315.75,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 20:52:57"
          },
          {
            "ticket_id": 10511,
            "ticket_number": "3510499",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 13:18:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 23:04:24"
          },
          {
            "ticket_id": 10516,
            "ticket_number": "3510504",
            "title": "Confirmacao 340779",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 14:42:50",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 52.75,
            "sla_met": false,
            "sla_breach_hours": 28.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:28:33"
          },
          {
            "ticket_id": 10520,
            "ticket_number": "3510508",
            "title": "GBN-108448 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:01:13",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 16:01:13"
          },
          {
            "ticket_id": 10521,
            "ticket_number": "3510509",
            "title": "GBN-108447 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:01:21",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 16:01:21"
          },
          {
            "ticket_id": 10523,
            "ticket_number": "3510511",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:18:05",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 16:18:05"
          },
          {
            "ticket_id": 10526,
            "ticket_number": "3510514",
            "title": "Criação de processo File 432065/26",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:18:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 474.68,
            "sla_met": false,
            "sla_breach_hours": 450.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:45"
          },
          {
            "ticket_id": 10528,
            "ticket_number": "3510516",
            "title": "Confirmação de reserva com localizador: 4095216",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:24:54",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 51.93,
            "sla_met": false,
            "sla_breach_hours": 27.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:21:12"
          },
          {
            "ticket_id": 10529,
            "ticket_number": "3510517",
            "title": "Número de informação da reserva: 6137215",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 16:28:40",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 50.87,
            "sla_met": false,
            "sla_breach_hours": 26.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:20:58"
          },
          {
            "ticket_id": 10532,
            "ticket_number": "3510520",
            "title": "Cancelamento de reserva 340685",
            "priority": "P2",
            "created_at": "26/02/2026 16:42:49",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 16:46:48"
          },
          {
            "ticket_id": 10536,
            "ticket_number": "3510524",
            "title": "Número de informação da reserva: 6137228",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 17:44:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 473.23,
            "sla_met": false,
            "sla_breach_hours": 449.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:45"
          },
          {
            "ticket_id": 10537,
            "ticket_number": "3510525",
            "title": "Cancelamento de reserva 340676",
            "priority": "P2",
            "created_at": "26/02/2026 17:45:01",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 19:00:11"
          },
          {
            "ticket_id": 10538,
            "ticket_number": "3510526",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604563025",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 18:31:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 49.82,
            "sla_met": false,
            "sla_breach_hours": 25.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:20:24"
          },
          {
            "ticket_id": 10541,
            "ticket_number": "3510529",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 18:31:32",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 49.8,
            "sla_met": false,
            "sla_breach_hours": 25.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:20:09"
          },
          {
            "ticket_id": 10554,
            "ticket_number": "3510542",
            "title": "DUVIDA REFERENTE A TARIFAS",
            "priority": "P2",
            "created_at": "26/02/2026 21:16:46",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 21:16:46"
          },
          {
            "ticket_id": 10556,
            "ticket_number": "3510544",
            "title": "Criação de processo File 432192/26",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 22:06:15",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 45.1,
            "sla_met": false,
            "sla_breach_hours": 21.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:13:10"
          },
          {
            "ticket_id": 10561,
            "ticket_number": "3510549",
            "title": "GBN-108577 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 22:30:01",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 22:30:01"
          },
          {
            "ticket_id": 10563,
            "ticket_number": "3510551",
            "title": "Tarifa Empaquetada",
            "priority": "P2",
            "created_at": "26/02/2026 22:30:09",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 22:30:09"
          },
          {
            "ticket_id": 10568,
            "ticket_number": "3510556",
            "title": "[Pedido de Grupo] Andorra-La vella - 2026-04-01 a ",
            "priority": "P2",
            "created_at": "26/02/2026 22:39:29",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 22:41:49"
          },
          {
            "ticket_id": 10569,
            "ticket_number": "3510557",
            "title": "Confirmacao 340876",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:04:24",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 44.12,
            "sla_met": false,
            "sla_breach_hours": 20.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:12:15"
          },
          {
            "ticket_id": 10570,
            "ticket_number": "3510558",
            "title": "Informação de reserva - SPT002601596418",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:06:06",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 44.1,
            "sla_met": false,
            "sla_breach_hours": 20.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:12:38"
          },
          {
            "ticket_id": 10571,
            "ticket_number": "3510559",
            "title": "GBN-108582 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:09:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:09:48"
          },
          {
            "ticket_id": 10572,
            "ticket_number": "3510560",
            "title": "GBN-108586 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:31:55",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:31:55"
          },
          {
            "ticket_id": 10573,
            "ticket_number": "3510561",
            "title": "GBN-108587 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:31:57",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:31:57"
          },
          {
            "ticket_id": 10575,
            "ticket_number": "3510563",
            "title": "GBN-108588 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:49:34",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:49:34"
          },
          {
            "ticket_id": 10576,
            "ticket_number": "3510564",
            "title": "Fwd: Viagify informa sobre a sua reserva 125365070",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:49:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:49:36"
          },
          {
            "ticket_id": 10577,
            "ticket_number": "3510565",
            "title": "Fwd: Viagify informa sobre a sua reserva 125386542",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:49:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:49:40"
          },
          {
            "ticket_id": 10579,
            "ticket_number": "3510567",
            "title": "Fwd: Viagify informa sobre a sua reserva 125386582",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:49:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:49:47"
          },
          {
            "ticket_id": 10580,
            "ticket_number": "3510568",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "26/02/2026 23:49:50",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 23:49:51"
          },
          {
            "ticket_id": 10581,
            "ticket_number": "3510569",
            "title": "Fwd: Viagify informa sobre a sua reserva 125386776",
            "priority": "Reservas sem Formulário",
            "created_at": "26/02/2026 23:49:53",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/02/2026 23:49:53"
          },
          {
            "ticket_id": 10582,
            "ticket_number": "3510570",
            "title": "Información de reserva número: 1778299",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 00:10:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 466.82,
            "sla_met": false,
            "sla_breach_hours": 442.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:44"
          },
          {
            "ticket_id": 10583,
            "ticket_number": "3510571",
            "title": "Confirmação de reserva com localizador: 4096171",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 00:10:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 466.82,
            "sla_met": false,
            "sla_breach_hours": 442.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:44"
          },
          {
            "ticket_id": 10584,
            "ticket_number": "3510572",
            "title": "Número de informação da reserva: 6137428",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 00:10:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 466.82,
            "sla_met": false,
            "sla_breach_hours": 442.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:44"
          },
          {
            "ticket_id": 10588,
            "ticket_number": "3510576",
            "title": "REMINDER: Dados de Passaporte - nosso File 425077",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:17",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:46:42"
          },
          {
            "ticket_id": 10591,
            "ticket_number": "3510579",
            "title": "Confirmacao 340887",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:04:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.92,
            "sla_met": false,
            "sla_breach_hours": 432.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:43"
          },
          {
            "ticket_id": 10593,
            "ticket_number": "3510581",
            "title": "Confirmacao 340888",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:04:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.92,
            "sla_met": false,
            "sla_breach_hours": 432.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:43"
          },
          {
            "ticket_id": 10594,
            "ticket_number": "3510582",
            "title": "GBN-108599 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:04:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 10:04:30"
          },
          {
            "ticket_id": 10596,
            "ticket_number": "3510584",
            "title": "GBN-108594 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:04:41",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.92,
            "sla_met": false,
            "sla_breach_hours": 432.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:43"
          },
          {
            "ticket_id": 10597,
            "ticket_number": "3510585",
            "title": "Fwd: Viagify informa sobre a sua reserva 125388213",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:04:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 10:04:45"
          },
          {
            "ticket_id": 10599,
            "ticket_number": "3510587",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:05:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.9,
            "sla_met": false,
            "sla_breach_hours": 432.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:43"
          },
          {
            "ticket_id": 10600,
            "ticket_number": "3510588",
            "title": "Fwd: Viagify informa sobre a sua reserva 125388213",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:05:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 10:05:04"
          },
          {
            "ticket_id": 10601,
            "ticket_number": "3510589",
            "title": "Criação de processo File 432225/26",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:05:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.9,
            "sla_met": false,
            "sla_breach_hours": 432.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:42"
          },
          {
            "ticket_id": 10602,
            "ticket_number": "3510590",
            "title": "Confirmation of booking with locatorJHBEXP8W",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:05:14",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 656.77,
            "sla_met": false,
            "sla_breach_hours": 632.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:51:40"
          },
          {
            "ticket_id": 10603,
            "ticket_number": "3510591",
            "title": "Confirmacao 340885",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:05:17",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.9,
            "sla_met": false,
            "sla_breach_hours": 432.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:42"
          },
          {
            "ticket_id": 10605,
            "ticket_number": "3510593",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 10:26:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 456.53,
            "sla_met": false,
            "sla_breach_hours": 432.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:15"
          },
          {
            "ticket_id": 10606,
            "ticket_number": "3510594",
            "title": "Correção nome GBN-108599",
            "priority": "P2",
            "created_at": "27/02/2026 10:26:48",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:26:48"
          },
          {
            "ticket_id": 10610,
            "ticket_number": "3510598",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:24:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 12:24:04"
          },
          {
            "ticket_id": 10614,
            "ticket_number": "3510602",
            "title": "Criação de processo File 432255/26",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:24:22",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 654.43,
            "sla_met": false,
            "sla_breach_hours": 630.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:50:51"
          },
          {
            "ticket_id": 10618,
            "ticket_number": "3510606",
            "title": "Confirmação de Reserva * File 432293",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:50:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 454.13,
            "sla_met": false,
            "sla_breach_hours": 430.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:14"
          },
          {
            "ticket_id": 10619,
            "ticket_number": "3510607",
            "title": "Envio de Fatura 212274",
            "priority": "P2",
            "created_at": "27/02/2026 12:50:35",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 13:16:00"
          },
          {
            "ticket_id": 10620,
            "ticket_number": "3510608",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 12:51:06"
          },
          {
            "ticket_id": 10621,
            "ticket_number": "3510609",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 454.13,
            "sla_met": false,
            "sla_breach_hours": 430.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:14"
          },
          {
            "ticket_id": 10622,
            "ticket_number": "3510610",
            "title": "GBN-108609 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 12:51:19"
          },
          {
            "ticket_id": 10623,
            "ticket_number": "3510611",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 454.12,
            "sla_met": false,
            "sla_breach_hours": 430.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:14"
          },
          {
            "ticket_id": 10624,
            "ticket_number": "3510612",
            "title": "GBN-108595 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 12:51:30"
          },
          {
            "ticket_id": 10625,
            "ticket_number": "3510613",
            "title": "Criação de processo File 432232/26",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 12:51:37",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 653.98,
            "sla_met": false,
            "sla_breach_hours": 629.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:51:04"
          },
          {
            "ticket_id": 10631,
            "ticket_number": "3510619",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 13:43:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 453.25,
            "sla_met": false,
            "sla_breach_hours": 429.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:14"
          },
          {
            "ticket_id": 10632,
            "ticket_number": "3510620",
            "title": "-",
            "priority": "P2",
            "created_at": "27/02/2026 13:43:49",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:24:22"
          },
          {
            "ticket_id": 10633,
            "ticket_number": "3510621",
            "title": "Confirmation of booking with locator8X2JGFJ6",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 13:43:51",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 653.13,
            "sla_met": false,
            "sla_breach_hours": 629.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:52:02"
          },
          {
            "ticket_id": 10636,
            "ticket_number": "3510624",
            "title": "Envio de Documentação * File 426271",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 14:13:54",
            "close_date": "2026-02-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 14:25:47"
          },
          {
            "ticket_id": 10637,
            "ticket_number": "3510625",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604569096",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 14:13:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 452.75,
            "sla_met": false,
            "sla_breach_hours": 428.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:14"
          },
          {
            "ticket_id": 10640,
            "ticket_number": "3510628",
            "title": "Informação de reserva - SPT002601596418",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 15:02:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 451.93,
            "sla_met": false,
            "sla_breach_hours": 427.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:13"
          },
          {
            "ticket_id": 10651,
            "ticket_number": "3510639",
            "title": "Aéreo - Confirmação de Emissão (NASCIMENTO\\ANA CRI",
            "priority": "P2",
            "created_at": "27/02/2026 15:45:36",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:52:24"
          },
          {
            "ticket_id": 10652,
            "ticket_number": "3510640",
            "title": "Aéreo - Confirmação de Emissão (NASCIMENTO\\ANA CRI",
            "priority": "P2",
            "created_at": "27/02/2026 15:45:39",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:52:42"
          },
          {
            "ticket_id": 10653,
            "ticket_number": "3510641",
            "title": "Aéreo - Confirmação de Emissão (ANDRADE\\VERA CRIST",
            "priority": "P2",
            "created_at": "27/02/2026 15:45:41",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:53:23"
          },
          {
            "ticket_id": 10654,
            "ticket_number": "3510642",
            "title": "Aéreo - Confirmação de Emissão (ANDRADE\\VERA CRIST",
            "priority": "P2",
            "created_at": "27/02/2026 15:45:43",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:54:10"
          },
          {
            "ticket_id": 10655,
            "ticket_number": "3510643",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604569266",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 15:45:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 451.22,
            "sla_met": false,
            "sla_breach_hours": 427.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:13"
          },
          {
            "ticket_id": 10656,
            "ticket_number": "3510644",
            "title": "GBN-108707 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 15:45:48",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 15:45:48"
          },
          {
            "ticket_id": 10659,
            "ticket_number": "3510647",
            "title": "Confirmacao 340985",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 16:30:37",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 19.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 11:59:55"
          },
          {
            "ticket_id": 10661,
            "ticket_number": "3510649",
            "title": "GBN-108577 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/02/2026 16:30:41",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 20:21:34"
          },
          {
            "ticket_id": 10671,
            "ticket_number": "3510659",
            "title": "RESERVA | LOCALIZADOR  →  604569381",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 17:07:07",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 17:07:07"
          },
          {
            "ticket_id": 10672,
            "ticket_number": "3510660",
            "title": "GBN-108776 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 17:48:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 17:48:13"
          },
          {
            "ticket_id": 10673,
            "ticket_number": "3510661",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 17:48:20",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 17:48:20"
          },
          {
            "ticket_id": 10674,
            "ticket_number": "3510662",
            "title": "Confirmation of booking with locatorHLBDB40W",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 18:17:42",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 26.0,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:17:56"
          },
          {
            "ticket_id": 10676,
            "ticket_number": "3510664",
            "title": "Criação de processo File 432444/26",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 18:17:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 448.68,
            "sla_met": false,
            "sla_breach_hours": 424.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:13"
          },
          {
            "ticket_id": 10678,
            "ticket_number": "3510666",
            "title": "CONFIRMACION: Paula Catarina  de Figueiredo Marque",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:00:47",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 647.85,
            "sla_met": false,
            "sla_breach_hours": 623.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:52:24"
          },
          {
            "ticket_id": 10679,
            "ticket_number": "3510667",
            "title": "GBN-108807 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:00:53",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:00:53"
          },
          {
            "ticket_id": 10680,
            "ticket_number": "3510668",
            "title": "Changes to passenger information for reservation P",
            "priority": "P2",
            "created_at": "27/02/2026 19:03:49",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 19:04:37"
          },
          {
            "ticket_id": 10681,
            "ticket_number": "3510669",
            "title": "GBN-108835 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:05:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:05:23"
          },
          {
            "ticket_id": 10682,
            "ticket_number": "3510670",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:10:22",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:10:22"
          },
          {
            "ticket_id": 10685,
            "ticket_number": "3510673",
            "title": "GBN-108839 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:16:24",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:16:24"
          },
          {
            "ticket_id": 10686,
            "ticket_number": "3510674",
            "title": "GBN-108608 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:16:51",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 23:04:24"
          },
          {
            "ticket_id": 10687,
            "ticket_number": "3510675",
            "title": "Número de informação da reserva: 6137819",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:32:24",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:21:30"
          },
          {
            "ticket_id": 10688,
            "ticket_number": "3510676",
            "title": "GBN-108610 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:32:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 23:24:26"
          },
          {
            "ticket_id": 10689,
            "ticket_number": "3510677",
            "title": "GBN-108848 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 19:41:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 19:41:54"
          },
          {
            "ticket_id": 10690,
            "ticket_number": "3510678",
            "title": "Confirmacao 341073",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 20:21:32",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 24.15,
            "sla_met": false,
            "sla_breach_hours": 0.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:30:38"
          },
          {
            "ticket_id": 10692,
            "ticket_number": "3510680",
            "title": "Informação de reserva - SPT002601597510",
            "priority": "P2",
            "created_at": "27/02/2026 20:22:05",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 19.57,
            "sla_met": false,
            "sla_breach_hours": 15.57,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 15:56:26"
          },
          {
            "ticket_id": 10695,
            "ticket_number": "3510683",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:06",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 20.8,
            "sla_met": false,
            "sla_breach_hours": 16.8,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 17:25:47"
          },
          {
            "ticket_id": 10698,
            "ticket_number": "3510686",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604570381",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 20:37:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 63.75,
            "sla_met": false,
            "sla_breach_hours": 39.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 12:22:15"
          },
          {
            "ticket_id": 10699,
            "ticket_number": "3510687",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 20.02,
            "sla_met": false,
            "sla_breach_hours": 16.02,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:39:05"
          },
          {
            "ticket_id": 10700,
            "ticket_number": "3510688",
            "title": "SSR - Case number: 1356493 ref:!00D0Y01LB0W.!500QD",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:16",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 14.2,
            "sla_met": false,
            "sla_breach_hours": 10.2,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 10:50:11"
          },
          {
            "ticket_id": 10701,
            "ticket_number": "3510689",
            "title": "SPT002601597510 - pedido de camas separadas",
            "priority": "P2",
            "created_at": "27/02/2026 20:51:03",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 20:51:03"
          },
          {
            "ticket_id": 10709,
            "ticket_number": "3510697",
            "title": "Número de informação da reserva: 6137918",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 21:46:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 63.92,
            "sla_met": false,
            "sla_breach_hours": 39.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 13:42:23"
          },
          {
            "ticket_id": 10710,
            "ticket_number": "3510698",
            "title": "How to arrive at JAM Lisbon",
            "priority": "P2",
            "created_at": "27/02/2026 21:47:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.05,
            "sla_met": false,
            "sla_breach_hours": 9.05,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 10:50:26"
          },
          {
            "ticket_id": 10712,
            "ticket_number": "3510700",
            "title": "GBN-108882 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 21:47:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 21:47:19"
          },
          {
            "ticket_id": 10716,
            "ticket_number": "3510704",
            "title": "Número de informação da reserva: 6137938",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:29:26",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 644.45,
            "sla_met": false,
            "sla_breach_hours": 620.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 18:57:10"
          },
          {
            "ticket_id": 10717,
            "ticket_number": "3510705",
            "title": "GBN-108886 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:29:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:29:32"
          },
          {
            "ticket_id": 10718,
            "ticket_number": "3510706",
            "title": "GBN-108887 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:29:36",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:29:36"
          },
          {
            "ticket_id": 10719,
            "ticket_number": "3510707",
            "title": "GBN-108890 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:29:40",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:29:40"
          },
          {
            "ticket_id": 10720,
            "ticket_number": "3510708",
            "title": "GBN-108888 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:29:43",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:29:43"
          },
          {
            "ticket_id": 10723,
            "ticket_number": "3510711",
            "title": "GBN-108896 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:51:01",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:51:01"
          },
          {
            "ticket_id": 10724,
            "ticket_number": "3510712",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 22:51:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 22:51:08"
          },
          {
            "ticket_id": 10725,
            "ticket_number": "3510713",
            "title": "Ideia partilhada  Combinado Japao+ Taiilandia",
            "priority": "P2",
            "created_at": "27/02/2026 23:00:25",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 15.48,
            "sla_met": false,
            "sla_breach_hours": 11.48,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 14:29:40"
          },
          {
            "ticket_id": 10727,
            "ticket_number": "3510715",
            "title": "Referencia para pagamento | File:432065/2026",
            "priority": "P2",
            "created_at": "27/02/2026 23:19:25",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 12.37,
            "sla_met": false,
            "sla_breach_hours": 8.37,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 11:41:40"
          },
          {
            "ticket_id": 10728,
            "ticket_number": "3510716",
            "title": "Número de informação da reserva: 6137961",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 23:19:28",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 20.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:33:48"
          },
          {
            "ticket_id": 10729,
            "ticket_number": "3510717",
            "title": "GBN-108900 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 23:19:31",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/02/2026 23:19:31"
          },
          {
            "ticket_id": 10730,
            "ticket_number": "3510718",
            "title": "Informação de reserva - SPT002601597683",
            "priority": "Reservas sem Formulário",
            "created_at": "27/02/2026 23:19:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 443.65,
            "sla_met": false,
            "sla_breach_hours": 419.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:11"
          },
          {
            "ticket_id": 10732,
            "ticket_number": "3510720",
            "title": "Criação de processo File 432602/26",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:03:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:02:33"
          },
          {
            "ticket_id": 10736,
            "ticket_number": "3510724",
            "title": "REMINDER: Dados de Passaporte - nosso File 425077",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:26",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 6.62,
            "sla_met": false,
            "sla_breach_hours": 2.62,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:40:46"
          },
          {
            "ticket_id": 10740,
            "ticket_number": "3510728",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604570592",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:03:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:02:33"
          },
          {
            "ticket_id": 10743,
            "ticket_number": "3510731",
            "title": "XWJWPW – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:39",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 11:01:54"
          },
          {
            "ticket_id": 10746,
            "ticket_number": "3510734",
            "title": "RE: Pagamento 432065",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:44",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 11:35:08"
          },
          {
            "ticket_id": 10748,
            "ticket_number": "3510736",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:03:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 10:03:54"
          },
          {
            "ticket_id": 10749,
            "ticket_number": "3510737",
            "title": "Informação de reserva - SPT002601597730",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:04:00",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 10.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:30:03"
          },
          {
            "ticket_id": 10750,
            "ticket_number": "3510738",
            "title": "Reserva Aérea XWJWPW",
            "priority": "P2",
            "created_at": "28/02/2026 10:04:03",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 11:14:14"
          },
          {
            "ticket_id": 10751,
            "ticket_number": "3510739",
            "title": "Criação de processo File 432585/26",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:04:09",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 10.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:29:48"
          },
          {
            "ticket_id": 10753,
            "ticket_number": "3510741",
            "title": "GBN-108902 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 10:04:17",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 10:04:17"
          },
          {
            "ticket_id": 10755,
            "ticket_number": "3510743",
            "title": "Informação de reserva - SPT002601597874",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 11:49:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.88,
            "sla_met": false,
            "sla_breach_hours": 29.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 17:42:44"
          },
          {
            "ticket_id": 10756,
            "ticket_number": "3510744",
            "title": "Confirmação de reserva com localizador: 4098200",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 11:49:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.88,
            "sla_met": false,
            "sla_breach_hours": 29.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 17:42:44"
          },
          {
            "ticket_id": 10757,
            "ticket_number": "3510745",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 11:49:03",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 7.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:33:27"
          },
          {
            "ticket_id": 10758,
            "ticket_number": "3510746",
            "title": "GBN-108921 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 11:49:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 11:49:06"
          },
          {
            "ticket_id": 10759,
            "ticket_number": "3510747",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 11:49:09",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 53.88,
            "sla_met": false,
            "sla_breach_hours": 29.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 17:42:44"
          },
          {
            "ticket_id": 10760,
            "ticket_number": "3510748",
            "title": "Confirmacao 341147",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:22:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 429.6,
            "sla_met": false,
            "sla_breach_hours": 405.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:10"
          },
          {
            "ticket_id": 10761,
            "ticket_number": "3510749",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:22:39",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 13:22:39"
          },
          {
            "ticket_id": 10762,
            "ticket_number": "3510750",
            "title": "Soltour: Modificação de reserva:  SPT002601597874",
            "priority": "P2",
            "created_at": "28/02/2026 13:22:41",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:44:18"
          },
          {
            "ticket_id": 10764,
            "ticket_number": "3510752",
            "title": "Fwd: Viagify informa sobre a sua reserva 125388988",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:22:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 13:22:45"
          },
          {
            "ticket_id": 10765,
            "ticket_number": "3510753",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:22:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 13:22:53"
          },
          {
            "ticket_id": 10766,
            "ticket_number": "3510754",
            "title": "Confirmacao 341132",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:22:57",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 6.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:32:34"
          },
          {
            "ticket_id": 10767,
            "ticket_number": "3510755",
            "title": "Confirmacao 341138",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:23:00",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 6.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:32:19"
          },
          {
            "ticket_id": 10768,
            "ticket_number": "3510756",
            "title": "Confirmacao 341139",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 13:23:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 19:22:58"
          },
          {
            "ticket_id": 10769,
            "ticket_number": "3510757",
            "title": "Cancelamento de reserva 340985",
            "priority": "P2",
            "created_at": "28/02/2026 13:23:34",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 14:21:12"
          },
          {
            "ticket_id": 10770,
            "ticket_number": "3510758",
            "title": "Soltour: Modificação de reserva:  SPT002601597730",
            "priority": "P2",
            "created_at": "28/02/2026 13:39:36",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:44:34"
          },
          {
            "ticket_id": 10772,
            "ticket_number": "3510760",
            "title": "RESERVA REALIZADA PENDENTE DE CONFIRMAÇÃO: 4098375",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 14:04:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 428.9,
            "sla_met": false,
            "sla_breach_hours": 404.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:09"
          },
          {
            "ticket_id": 10774,
            "ticket_number": "3510762",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 14:04:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 14:04:15"
          },
          {
            "ticket_id": 10775,
            "ticket_number": "3510763",
            "title": "Confirmação de reserva 341152",
            "priority": "P2",
            "created_at": "28/02/2026 14:49:12",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 15:57:59"
          },
          {
            "ticket_id": 10776,
            "ticket_number": "3510764",
            "title": "Confirmacao 341154",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 14:49:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 4.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:33:06"
          },
          {
            "ticket_id": 10777,
            "ticket_number": "3510765",
            "title": "GBN-108586 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/02/2026 15:04:43",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:01:32"
          },
          {
            "ticket_id": 10778,
            "ticket_number": "3510766",
            "title": "GBN-108587 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/02/2026 15:04:45",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:01:42"
          },
          {
            "ticket_id": 10779,
            "ticket_number": "3510767",
            "title": "Número de informação da reserva: 6138187",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 15:04:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 21:03:09"
          },
          {
            "ticket_id": 10780,
            "ticket_number": "3510768",
            "title": "Confirmação de reserva com localizador: 4098421",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 15:04:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 21:03:09"
          },
          {
            "ticket_id": 10781,
            "ticket_number": "3510769",
            "title": "Confirmação de reserva com localizador: 4098428",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 15:17:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.75,
            "sla_met": false,
            "sla_breach_hours": 29.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 21:03:09"
          },
          {
            "ticket_id": 10784,
            "ticket_number": "3510772",
            "title": "Número de informação da reserva: 6138221",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 16:03:22",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 4.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:31:01"
          },
          {
            "ticket_id": 10785,
            "ticket_number": "3510773",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 16:03:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 22:03:14"
          },
          {
            "ticket_id": 10788,
            "ticket_number": "3510776",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "28/02/2026 16:51:25",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:02:38"
          },
          {
            "ticket_id": 10790,
            "ticket_number": "3510778",
            "title": "Criação de processo File 432747/26",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 17:20:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 425.63,
            "sla_met": false,
            "sla_breach_hours": 401.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:08"
          },
          {
            "ticket_id": 10791,
            "ticket_number": "3510779",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571207",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 17:49:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 40.28,
            "sla_met": false,
            "sla_breach_hours": 16.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 10:07:05"
          },
          {
            "ticket_id": 10792,
            "ticket_number": "3510780",
            "title": "Informação de reserva - SPT002601598271",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 17:49:36",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 40.8,
            "sla_met": false,
            "sla_breach_hours": 16.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 10:37:55"
          },
          {
            "ticket_id": 10793,
            "ticket_number": "3510781",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571214",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 17:49:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.88,
            "sla_met": false,
            "sla_breach_hours": 29.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 23:43:35"
          },
          {
            "ticket_id": 10798,
            "ticket_number": "3510786",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 18:20:39",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 624.73,
            "sla_met": false,
            "sla_breach_hours": 600.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:04:55"
          },
          {
            "ticket_id": 10800,
            "ticket_number": "3510788",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 18:30:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 424.47,
            "sla_met": false,
            "sla_breach_hours": 400.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:07"
          },
          {
            "ticket_id": 10806,
            "ticket_number": "3510794",
            "title": "Confirmação de reserva com localizador: 4098589",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 18:54:36",
            "close_date": "2026-02-28",
            "sla_target_hours": 24,
            "actual_time_hours": 3.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 22:36:17"
          },
          {
            "ticket_id": 10812,
            "ticket_number": "3510800",
            "title": "Soltour.es - Localizador SPT002601598425: pago efe",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 19:32:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 423.43,
            "sla_met": false,
            "sla_breach_hours": 399.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:07"
          },
          {
            "ticket_id": 10813,
            "ticket_number": "3510801",
            "title": "SPT002601598425---MR FRANCISCO GOIS X 3 PAXS---EMI",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 19:41:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 20:15:28"
          },
          {
            "ticket_id": 10814,
            "ticket_number": "3510802",
            "title": "GBN-109031 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 19:41:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 19:41:54"
          },
          {
            "ticket_id": 10815,
            "ticket_number": "3510803",
            "title": "GBN-109039 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 20:15:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 68.62,
            "sla_met": false,
            "sla_breach_hours": 44.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 16:53:07"
          },
          {
            "ticket_id": 10816,
            "ticket_number": "3510804",
            "title": "Criação de processo File 432847/26",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 20:15:24",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 622.77,
            "sla_met": false,
            "sla_breach_hours": 598.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:01:54"
          },
          {
            "ticket_id": 10818,
            "ticket_number": "3510806",
            "title": "Reserva TUI (10046998) - UMA FAMILIA EM VIAGEM (HO",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 20:15:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 21:26:18"
          },
          {
            "ticket_id": 10821,
            "ticket_number": "3510809",
            "title": "Confirmacao 341226",
            "priority": "P2",
            "created_at": "28/02/2026 20:23:16",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:40:25"
          },
          {
            "ticket_id": 10822,
            "ticket_number": "3510810",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571405",
            "priority": "P2",
            "created_at": "28/02/2026 20:29:50",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:47:44"
          },
          {
            "ticket_id": 10823,
            "ticket_number": "3510811",
            "title": "GBN-109043 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/02/2026 20:29:58",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 20:29:58"
          },
          {
            "ticket_id": 10824,
            "ticket_number": "3510812",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "28/02/2026 20:30:07",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:46:51"
          },
          {
            "ticket_id": 10825,
            "ticket_number": "3510813",
            "title": "Número de informação da reserva: 6138511",
            "priority": "P2",
            "created_at": "28/02/2026 20:31:53",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:44:14"
          },
          {
            "ticket_id": 10827,
            "ticket_number": "3510815",
            "title": "Información de reserva número: 1778654",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 21:25:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 421.55,
            "sla_met": false,
            "sla_breach_hours": 397.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:06"
          },
          {
            "ticket_id": 10828,
            "ticket_number": "3510816",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 21:26:00",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 621.65,
            "sla_met": false,
            "sla_breach_hours": 597.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:05:15"
          },
          {
            "ticket_id": 10830,
            "ticket_number": "3510818",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571444",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 21:26:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 421.53,
            "sla_met": false,
            "sla_breach_hours": 397.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:06"
          },
          {
            "ticket_id": 10831,
            "ticket_number": "3510819",
            "title": "Información de reserva número: 1778656",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 21:26:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 421.53,
            "sla_met": false,
            "sla_breach_hours": 397.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:06"
          },
          {
            "ticket_id": 10834,
            "ticket_number": "3510822",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571432",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 21:26:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 421.53,
            "sla_met": false,
            "sla_breach_hours": 397.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:21"
          },
          {
            "ticket_id": 10835,
            "ticket_number": "3510823",
            "title": "GBN-109015 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 22:29:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 420.47,
            "sla_met": false,
            "sla_breach_hours": 396.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:21"
          },
          {
            "ticket_id": 10836,
            "ticket_number": "3510824",
            "title": "GBN-108984 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 22:30:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 420.47,
            "sla_met": false,
            "sla_breach_hours": 396.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:21"
          },
          {
            "ticket_id": 10837,
            "ticket_number": "3510825",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:03",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:54:06"
          },
          {
            "ticket_id": 10843,
            "ticket_number": "3510831",
            "title": "GBN-109042 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:14",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:42:39"
          },
          {
            "ticket_id": 10845,
            "ticket_number": "3510833",
            "title": "Número de informação da reserva: 6138565",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 22:30:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 420.47,
            "sla_met": false,
            "sla_breach_hours": 396.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:21"
          },
          {
            "ticket_id": 10847,
            "ticket_number": "3510835",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:23",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:54:11"
          },
          {
            "ticket_id": 10848,
            "ticket_number": "3510836",
            "title": "Criação de processo File 432892/26",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:29",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:45:20"
          },
          {
            "ticket_id": 10849,
            "ticket_number": "3510837",
            "title": "GBN-109055 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 22:30:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/02/2026 22:30:36"
          },
          {
            "ticket_id": 10850,
            "ticket_number": "3510838",
            "title": "Número de informação da reserva: 6138555",
            "priority": "Reservas sem Formulário",
            "created_at": "28/02/2026 22:30:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 420.45,
            "sla_met": false,
            "sla_breach_hours": 396.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:21"
          },
          {
            "ticket_id": 10851,
            "ticket_number": "3510839",
            "title": "GBN-108594 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/02/2026 22:34:02",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 22:41:56"
          },
          {
            "ticket_id": 10864,
            "ticket_number": "3510852",
            "title": "GBN-109074 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:16",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 00:06:16"
          },
          {
            "ticket_id": 10872,
            "ticket_number": "3510860",
            "title": "REMINDER: Dados de Passaporte - nosso File 425077",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 11:47:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.95,
            "sla_met": false,
            "sla_breach_hours": 24.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 12:44:30"
          },
          {
            "ticket_id": 10875,
            "ticket_number": "3510863",
            "title": "GBN-92059 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 11:47:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.95,
            "sla_met": false,
            "sla_breach_hours": 24.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 12:44:31"
          },
          {
            "ticket_id": 10876,
            "ticket_number": "3510864",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571564",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 11:47:24",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 22.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 10:44:51"
          },
          {
            "ticket_id": 10877,
            "ticket_number": "3510865",
            "title": "Confirmacao 341255",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 11:47:26",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 23.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:03:08"
          },
          {
            "ticket_id": 10883,
            "ticket_number": "3510871",
            "title": "Cancelamento de Reserva - SPT002601598271",
            "priority": "P2",
            "created_at": "01/03/2026 13:39:51",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 20.53,
            "sla_met": false,
            "sla_breach_hours": 16.53,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:12:05"
          },
          {
            "ticket_id": 10884,
            "ticket_number": "3510872",
            "title": "GBN-109086 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 13:39:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 405.3,
            "sla_met": false,
            "sla_breach_hours": 381.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:20"
          },
          {
            "ticket_id": 10885,
            "ticket_number": "3510873",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 13:39:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 405.3,
            "sla_met": false,
            "sla_breach_hours": 381.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:20"
          },
          {
            "ticket_id": 10886,
            "ticket_number": "3510874",
            "title": "Informação de reserva - SPT002601598765",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 13:40:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 405.3,
            "sla_met": false,
            "sla_breach_hours": 381.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:20"
          },
          {
            "ticket_id": 10887,
            "ticket_number": "3510875",
            "title": "Cancelamento de Reserva - SPT002601598271",
            "priority": "P2",
            "created_at": "01/03/2026 13:40:12",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 20.95,
            "sla_met": false,
            "sla_breach_hours": 16.95,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:38:05"
          },
          {
            "ticket_id": 10888,
            "ticket_number": "3510876",
            "title": "GBN-109086 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 13:40:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 13:40:14"
          },
          {
            "ticket_id": 10890,
            "ticket_number": "3510878",
            "title": "Confirmação de reserva – Ref PP991771, Sr. Carlos ",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 13:40:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 405.28,
            "sla_met": false,
            "sla_breach_hours": 381.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:19"
          },
          {
            "ticket_id": 10892,
            "ticket_number": "3510880",
            "title": "GBN-109091 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 14:53:27"
          },
          {
            "ticket_id": 10893,
            "ticket_number": "3510881",
            "title": "GBN-109091 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 14:53:34"
          },
          {
            "ticket_id": 10894,
            "ticket_number": "3510882",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802470880",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 16:09:53"
          },
          {
            "ticket_id": 10895,
            "ticket_number": "3510883",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 14:53:42"
          },
          {
            "ticket_id": 10898,
            "ticket_number": "3510886",
            "title": "Pagamento da reserva – Ref PP991771, Sr. Carlos Ma",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.85,
            "sla_met": false,
            "sla_breach_hours": 24.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 15:44:50"
          },
          {
            "ticket_id": 10899,
            "ticket_number": "3510887",
            "title": "Criação de processo File 432995/26",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 14:53:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.83,
            "sla_met": false,
            "sla_breach_hours": 24.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 15:44:50"
          },
          {
            "ticket_id": 10900,
            "ticket_number": "3510888",
            "title": "Número de informação da reserva: 6138806",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 16:09:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.92,
            "sla_met": false,
            "sla_breach_hours": 24.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 17:04:59"
          },
          {
            "ticket_id": 10901,
            "ticket_number": "3510889",
            "title": "Confirmação de reserva 341217",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 16:17:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.78,
            "sla_met": false,
            "sla_breach_hours": 24.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 17:04:59"
          },
          {
            "ticket_id": 10902,
            "ticket_number": "3510890",
            "title": "Informação de reserva - SPT002601598895",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 16:22:37",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 48.95,
            "sla_met": false,
            "sla_breach_hours": 24.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 17:20:01"
          },
          {
            "ticket_id": 10903,
            "ticket_number": "3510891",
            "title": "Número de informação da reserva: 6138852",
            "priority": "P2",
            "created_at": "01/03/2026 17:11:08",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 48.82,
            "sla_met": false,
            "sla_breach_hours": 44.82,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:00:09"
          },
          {
            "ticket_id": 10904,
            "ticket_number": "3510892",
            "title": "Confirmacao 341296",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 17:11:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.8,
            "sla_met": false,
            "sla_breach_hours": 24.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 18:00:09"
          },
          {
            "ticket_id": 10905,
            "ticket_number": "3510893",
            "title": "Confirmação de reserva 341105",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 17:22:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.97,
            "sla_met": false,
            "sla_breach_hours": 24.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 18:20:12"
          },
          {
            "ticket_id": 10906,
            "ticket_number": "3510894",
            "title": "Confirmação de reserva com localizador: 4099100",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 17:22:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.97,
            "sla_met": false,
            "sla_breach_hours": 24.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 18:20:12"
          },
          {
            "ticket_id": 10909,
            "ticket_number": "3510897",
            "title": "GBN-109104 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 17:56:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 17:56:42"
          },
          {
            "ticket_id": 10910,
            "ticket_number": "3510898",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 17:56:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 401.02,
            "sla_met": false,
            "sla_breach_hours": 377.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:18"
          },
          {
            "ticket_id": 10911,
            "ticket_number": "3510899",
            "title": "Número de informação da reserva: 6138926",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 18:40:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.98,
            "sla_met": false,
            "sla_breach_hours": 24.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 19:40:24"
          },
          {
            "ticket_id": 10912,
            "ticket_number": "3510900",
            "title": "GBN-109111 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 18:40:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/03/2026 18:40:49"
          },
          {
            "ticket_id": 10913,
            "ticket_number": "3510901",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571889",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 18:46:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.88,
            "sla_met": false,
            "sla_breach_hours": 24.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 19:40:24"
          },
          {
            "ticket_id": 10914,
            "ticket_number": "3510902",
            "title": "Informação de reserva - SPT002601599065",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 18:46:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 48.88,
            "sla_met": false,
            "sla_breach_hours": 24.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 19:40:24"
          },
          {
            "ticket_id": 10915,
            "ticket_number": "3510903",
            "title": "w2m.travel: Confirmación reserva 'LQGL21'",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:03:17",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 399.9,
            "sla_met": false,
            "sla_breach_hours": 375.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:17"
          },
          {
            "ticket_id": 10916,
            "ticket_number": "3510904",
            "title": "Número de informação da reserva: 6138964",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:03:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 399.9,
            "sla_met": false,
            "sla_breach_hours": 375.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:17"
          },
          {
            "ticket_id": 10917,
            "ticket_number": "3510905",
            "title": "Número de informação da reserva: 6138962",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:03:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 399.9,
            "sla_met": false,
            "sla_breach_hours": 375.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:16"
          },
          {
            "ticket_id": 10921,
            "ticket_number": "3510909",
            "title": "Criação de processo File 433137/26",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:23:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 399.57,
            "sla_met": false,
            "sla_breach_hours": 375.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:16"
          },
          {
            "ticket_id": 10926,
            "ticket_number": "3510914",
            "title": "Informação de reserva - SPT002601599125",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:42:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 399.27,
            "sla_met": false,
            "sla_breach_hours": 375.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:59:06"
          },
          {
            "ticket_id": 10927,
            "ticket_number": "3510915",
            "title": "Reserva confirmada: Barco às ilhas Cíes - Civitati",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:42:28",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 599.32,
            "sla_met": false,
            "sla_breach_hours": 575.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:02:27"
          },
          {
            "ticket_id": 10929,
            "ticket_number": "3510917",
            "title": "Reserva confirmada: Barco às ilhas Cíes - Civitati",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 19:42:33",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 599.33,
            "sla_met": false,
            "sla_breach_hours": 575.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:02:42"
          },
          {
            "ticket_id": 10930,
            "ticket_number": "3510918",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802471401",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:03:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.9,
            "sla_met": false,
            "sla_breach_hours": 374.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:16"
          },
          {
            "ticket_id": 10931,
            "ticket_number": "3510919",
            "title": "Informação de reserva - SPT002601599171",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:03:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.9,
            "sla_met": false,
            "sla_breach_hours": 374.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:16"
          },
          {
            "ticket_id": 10932,
            "ticket_number": "3510920",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802471387",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:03:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.9,
            "sla_met": false,
            "sla_breach_hours": 374.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:16"
          },
          {
            "ticket_id": 10933,
            "ticket_number": "3510921",
            "title": "Número de informação da reserva: 6139060",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:42:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.25,
            "sla_met": false,
            "sla_breach_hours": 374.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:15"
          },
          {
            "ticket_id": 10934,
            "ticket_number": "3510922",
            "title": "Número de informação da reserva: 6139064",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:42:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.25,
            "sla_met": false,
            "sla_breach_hours": 374.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:15"
          },
          {
            "ticket_id": 10935,
            "ticket_number": "3510923",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802471416",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:42:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.25,
            "sla_met": false,
            "sla_breach_hours": 374.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:15"
          },
          {
            "ticket_id": 10936,
            "ticket_number": "3510924",
            "title": "Número de informação da reserva: 6139082",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:43:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.23,
            "sla_met": false,
            "sla_breach_hours": 374.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:15"
          },
          {
            "ticket_id": 10937,
            "ticket_number": "3510925",
            "title": "Confirmação de reserva com localizador: 4099287",
            "priority": "Reservas sem Formulário",
            "created_at": "01/03/2026 20:51:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 398.12,
            "sla_met": false,
            "sla_breach_hours": 374.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:15"
          },
          {
            "ticket_id": 10941,
            "ticket_number": "3510929",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60455969",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:32",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:36:23"
          },
          {
            "ticket_id": 10946,
            "ticket_number": "3510934",
            "title": "GBN-92059 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:41",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:26:16"
          },
          {
            "ticket_id": 10947,
            "ticket_number": "3510935",
            "title": "GBN-88469 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:44",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:27:01"
          },
          {
            "ticket_id": 10948,
            "ticket_number": "3510936",
            "title": "GBN-88464 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:46",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:27:01"
          },
          {
            "ticket_id": 10950,
            "ticket_number": "3510938",
            "title": "GBN-86820 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:52",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:27:01"
          },
          {
            "ticket_id": 10951,
            "ticket_number": "3510939",
            "title": "Confirmação de reserva – Ref PP114239, Sr. Daniel ",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:56:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.02,
            "sla_met": false,
            "sla_breach_hours": 361.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:14"
          },
          {
            "ticket_id": 10953,
            "ticket_number": "3510941",
            "title": "GBN-88343 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:59",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:27:01"
          },
          {
            "ticket_id": 10954,
            "ticket_number": "3510942",
            "title": "GBN-91559 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:02",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:27:01"
          },
          {
            "ticket_id": 10957,
            "ticket_number": "3510945",
            "title": "cotação grupo",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:12",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:12"
          },
          {
            "ticket_id": 10958,
            "ticket_number": "3510946",
            "title": "Fwd: Viagify informa sobre a sua reserva 125474675",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 09:57:16"
          },
          {
            "ticket_id": 10959,
            "ticket_number": "3510947",
            "title": "Fwd: Viagify informa sobre a sua reserva 125471975",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 09:57:20"
          },
          {
            "ticket_id": 10960,
            "ticket_number": "3510948",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:22",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:23"
          },
          {
            "ticket_id": 10961,
            "ticket_number": "3510949",
            "title": "Fwd: Viagify informa sobre a sua reserva 125471975",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 09:57:27"
          },
          {
            "ticket_id": 10962,
            "ticket_number": "3510950",
            "title": "Fwd: Informações da reserva TTN-1230110899#9451050",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:30",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:30"
          },
          {
            "ticket_id": 10963,
            "ticket_number": "3510951",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:33",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:33"
          },
          {
            "ticket_id": 10964,
            "ticket_number": "3510952",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.0,
            "sla_met": false,
            "sla_breach_hours": 361.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:14"
          },
          {
            "ticket_id": 10966,
            "ticket_number": "3510954",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:42",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:42"
          },
          {
            "ticket_id": 10967,
            "ticket_number": "3510955",
            "title": "Criação de processo File 433259/26",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 389.88,
            "sla_met": false,
            "sla_breach_hours": 365.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:16"
          },
          {
            "ticket_id": 10969,
            "ticket_number": "3510957",
            "title": "Fwd: Informações da reserva TTN-1253867760#9449214",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:54"
          },
          {
            "ticket_id": 10971,
            "ticket_number": "3510959",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604572171",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:57:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.0,
            "sla_met": false,
            "sla_breach_hours": 361.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10972,
            "ticket_number": "3510960",
            "title": "Confirmacao 341374",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.0,
            "sla_met": false,
            "sla_breach_hours": 361.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10973,
            "ticket_number": "3510961",
            "title": "Número de informação da reserva: 6139181",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.0,
            "sla_met": false,
            "sla_breach_hours": 361.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10974,
            "ticket_number": "3510962",
            "title": "Número de informação da reserva: 6139189",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 385.0,
            "sla_met": false,
            "sla_breach_hours": 361.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10975,
            "ticket_number": "3510963",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:09",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:58:09"
          },
          {
            "ticket_id": 10976,
            "ticket_number": "3510964",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.98,
            "sla_met": false,
            "sla_breach_hours": 360.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10977,
            "ticket_number": "3510965",
            "title": "Confirmação de reserva com localizador: 4099413",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:17",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.98,
            "sla_met": false,
            "sla_breach_hours": 360.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:58:13"
          },
          {
            "ticket_id": 10978,
            "ticket_number": "3510966",
            "title": "Confirmação de reserva com localizador: 4099395",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.98,
            "sla_met": false,
            "sla_breach_hours": 360.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:24"
          },
          {
            "ticket_id": 10979,
            "ticket_number": "3510967",
            "title": "CANCELACION: SRES. Lu???sa  Geraldes / HOTEL OHTEL",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:31",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:39:50"
          },
          {
            "ticket_id": 10980,
            "ticket_number": "3510968",
            "title": "GBN-109108 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.97,
            "sla_met": false,
            "sla_breach_hours": 360.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:23"
          },
          {
            "ticket_id": 10981,
            "ticket_number": "3510969",
            "title": "Número de informação da reserva: 6139140",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.97,
            "sla_met": false,
            "sla_breach_hours": 360.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:23"
          },
          {
            "ticket_id": 10982,
            "ticket_number": "3510970",
            "title": "Confirmation of booking with locatorX3ZUZZQY",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 09:58:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 389.87,
            "sla_met": false,
            "sla_breach_hours": 365.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:15"
          },
          {
            "ticket_id": 10985,
            "ticket_number": "3510973",
            "title": "Cancelamento reserva    GBN-102812",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:43",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:58:43"
          },
          {
            "ticket_id": 10986,
            "ticket_number": "3510974",
            "title": "CONFIRMACION: Lu???sa  Geraldes / HOTEL OHTELS MAZ",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:45",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:40:00"
          },
          {
            "ticket_id": 10987,
            "ticket_number": "3510975",
            "title": "ERRO DE RESERVA",
            "priority": "P2",
            "created_at": "02/03/2026 10:07:03",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:13:52"
          },
          {
            "ticket_id": 10989,
            "ticket_number": "3510977",
            "title": "RE: Cancelamento reserva 604571564",
            "priority": "P2",
            "created_at": "02/03/2026 10:07:08",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:44:38"
          },
          {
            "ticket_id": 10990,
            "ticket_number": "3510978",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60457156",
            "priority": "P2",
            "created_at": "02/03/2026 10:07:10",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:44:28"
          },
          {
            "ticket_id": 10991,
            "ticket_number": "3510979",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604572343",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 10:35:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 384.35,
            "sla_met": false,
            "sla_breach_hours": 360.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:23"
          },
          {
            "ticket_id": 10992,
            "ticket_number": "3510980",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 11:01:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:01:14"
          },
          {
            "ticket_id": 10993,
            "ticket_number": "3510981",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 11:01:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:01:28"
          },
          {
            "ticket_id": 10994,
            "ticket_number": "3510982",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 11:01:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:01:33"
          },
          {
            "ticket_id": 10995,
            "ticket_number": "3510983",
            "title": "Fwd: Informações sobre a sua reserva TTN-125337317",
            "priority": "P2",
            "created_at": "02/03/2026 11:01:36",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:01:36"
          },
          {
            "ticket_id": 10996,
            "ticket_number": "3510984",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 11:01:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 11:01:40"
          },
          {
            "ticket_id": 10998,
            "ticket_number": "3510986",
            "title": "Cancelamento de reserva 341255",
            "priority": "P2",
            "created_at": "02/03/2026 11:01:46",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:03:02"
          },
          {
            "ticket_id": 11002,
            "ticket_number": "3510990",
            "title": "Fwd: Informações sobre a sua reserva TTN-125337317",
            "priority": "P2",
            "created_at": "02/03/2026 11:02:04",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:02:05"
          },
          {
            "ticket_id": 11016,
            "ticket_number": "3511004",
            "title": "Pagamento da reserva – Ref PP669823, Sr. José Cint",
            "priority": "P2",
            "created_at": "02/03/2026 11:27:49",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:08:04"
          },
          {
            "ticket_id": 11030,
            "ticket_number": "3511018",
            "title": "Fwd: Viagify informa sobre a sua reserva 125500904",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:09:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 12:09:50"
          },
          {
            "ticket_id": 11031,
            "ticket_number": "3511019",
            "title": "Reserva confirmada: Passeio de catamarã pela Ilha ",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:09:52",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 22:00:43"
          },
          {
            "ticket_id": 11032,
            "ticket_number": "3511020",
            "title": "Fwd: Viagify informa sobre a sua reserva 125500904",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:09:55",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 12:09:56"
          },
          {
            "ticket_id": 11033,
            "ticket_number": "3511021",
            "title": "Reserva confirmada: Passeio de catamarã pela Ilha ",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:09:58",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 22:00:43"
          },
          {
            "ticket_id": 11034,
            "ticket_number": "3511022",
            "title": "Confirmação de reserva. Localizador: 9BBB28TF0O",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:28:51",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:22:35"
          },
          {
            "ticket_id": 11035,
            "ticket_number": "3511023",
            "title": "Criação de processo File 433296/26",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:28:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:22:35"
          },
          {
            "ticket_id": 11039,
            "ticket_number": "3511027",
            "title": "Número de informação da reserva: 6139278",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:52:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:42:37"
          },
          {
            "ticket_id": 11041,
            "ticket_number": "3511029",
            "title": "Informação de reserva - SPT002601597730",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 12:53:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 16:42:37"
          },
          {
            "ticket_id": 11045,
            "ticket_number": "3511033",
            "title": "[Pedido de Grupo] França - 2026-03-03 a 2026-03-17",
            "priority": "P2",
            "created_at": "02/03/2026 13:32:34",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 13:33:22"
          },
          {
            "ticket_id": 11047,
            "ticket_number": "3511035",
            "title": "w2m.travel: Confirmación reserva 'GM3DH4'",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 13:53:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 23:40:53"
          },
          {
            "ticket_id": 11054,
            "ticket_number": "3511042",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 15:34:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 15:34:24"
          },
          {
            "ticket_id": 11056,
            "ticket_number": "3511044",
            "title": "GBN-109212 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 15:34:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 15:34:35"
          },
          {
            "ticket_id": 11071,
            "ticket_number": "3511059",
            "title": "GBN-109031 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/03/2026 17:31:04",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:23:12"
          },
          {
            "ticket_id": 11072,
            "ticket_number": "3511060",
            "title": "GBN-109282 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 17:31:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 17:31:07"
          },
          {
            "ticket_id": 11080,
            "ticket_number": "3511068",
            "title": "Envio de Fatura 212289",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 18:23:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 14:22:13"
          },
          {
            "ticket_id": 11082,
            "ticket_number": "3511070",
            "title": "Confirmação de Reserva * File 426271 *Atualização*",
            "priority": "P2",
            "created_at": "02/03/2026 18:52:24",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:43:24"
          },
          {
            "ticket_id": 11088,
            "ticket_number": "3511076",
            "title": "Envio de Fatura 212274",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 18:52:51",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 22:43:24"
          },
          {
            "ticket_id": 11089,
            "ticket_number": "3511077",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "02/03/2026 19:07:24",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:03:26"
          },
          {
            "ticket_id": 11090,
            "ticket_number": "3511078",
            "title": "Envio de documentos de File 424887/26",
            "priority": "P2",
            "created_at": "02/03/2026 19:07:27",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:03:26"
          },
          {
            "ticket_id": 11094,
            "ticket_number": "3511082",
            "title": "Urgente: Tour La Romana - março - Contacto com a C",
            "priority": "P2",
            "created_at": "02/03/2026 21:10:06",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:10:07"
          },
          {
            "ticket_id": 11098,
            "ticket_number": "3511086",
            "title": "GBN-109340 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 21:10:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/03/2026 21:10:19"
          },
          {
            "ticket_id": 11099,
            "ticket_number": "3511087",
            "title": "Urgente: dúvida reserva Soltour com saída a 16/03 ",
            "priority": "P2",
            "created_at": "02/03/2026 21:10:22",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:10:22"
          },
          {
            "ticket_id": 11100,
            "ticket_number": "3511088",
            "title": "GBN-109340 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 21:10:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 17:02:33"
          },
          {
            "ticket_id": 11101,
            "ticket_number": "3511089",
            "title": "Confirmacao 341510",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 21:10:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 17:02:33"
          },
          {
            "ticket_id": 11102,
            "ticket_number": "3511090",
            "title": "Número de informação da reserva: 6139460",
            "priority": "P2",
            "created_at": "02/03/2026 21:10:30",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:28:45"
          },
          {
            "ticket_id": 11103,
            "ticket_number": "3511091",
            "title": "Confirmacao 341497",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 21:10:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 17:02:33"
          },
          {
            "ticket_id": 11104,
            "ticket_number": "3511092",
            "title": "Confirmacao 341498",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 21:10:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 17:02:33"
          },
          {
            "ticket_id": 11105,
            "ticket_number": "3511093",
            "title": "Número de informação da reserva: 6139519",
            "priority": "P2",
            "created_at": "02/03/2026 21:53:39",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:27:32"
          },
          {
            "ticket_id": 11108,
            "ticket_number": "3511096",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 22:02:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 18:02:43"
          },
          {
            "ticket_id": 11111,
            "ticket_number": "3511099",
            "title": "Número de informação da reserva: 6139532",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 22:34:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 18:22:46"
          },
          {
            "ticket_id": 11116,
            "ticket_number": "3511104",
            "title": "Informação de reserva - SPT002601600269",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 22:57:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 18:42:49"
          },
          {
            "ticket_id": 11117,
            "ticket_number": "3511105",
            "title": "Informação de reserva - SPT002601600279",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 23:07:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 19:02:53"
          },
          {
            "ticket_id": 11118,
            "ticket_number": "3511106",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 23:07:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 19:02:53"
          },
          {
            "ticket_id": 11119,
            "ticket_number": "3511107",
            "title": "Confirmação de reserva – Ref PP983368, Sr. SERGIO ",
            "priority": "Reservas sem Formulário",
            "created_at": "02/03/2026 23:20:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 371.6,
            "sla_met": false,
            "sla_breach_hours": 347.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:19"
          },
          {
            "ticket_id": 11124,
            "ticket_number": "3511112",
            "title": "Informação de reserva - SPT002601600279",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 00:11:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 370.75,
            "sla_met": false,
            "sla_breach_hours": 346.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:19"
          },
          {
            "ticket_id": 11126,
            "ticket_number": "3511114",
            "title": "CANCELAMENTO LOC 604570592 TRAVELPAN",
            "priority": "P2",
            "created_at": "03/03/2026 00:11:52",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 00:11:53"
          },
          {
            "ticket_id": 11127,
            "ticket_number": "3511115",
            "title": "cancelamento de viagem solferias 433296/2026",
            "priority": "P2",
            "created_at": "03/03/2026 00:11:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 00:11:55"
          },
          {
            "ticket_id": 11128,
            "ticket_number": "3511116",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 00:12:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 370.75,
            "sla_met": false,
            "sla_breach_hours": 346.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:18"
          },
          {
            "ticket_id": 11130,
            "ticket_number": "3511118",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604574189",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 00:12:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 370.75,
            "sla_met": false,
            "sla_breach_hours": 346.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:18"
          },
          {
            "ticket_id": 11132,
            "ticket_number": "3511120",
            "title": "Pagamento da reserva – Ref PP983368, Sr. SERGIO JO",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 00:12:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 370.75,
            "sla_met": false,
            "sla_breach_hours": 346.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:18"
          },
          {
            "ticket_id": 11143,
            "ticket_number": "3511131",
            "title": "Número de informação da reserva: 6139564",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 10:01:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 360.92,
            "sla_met": false,
            "sla_breach_hours": 336.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:18"
          },
          {
            "ticket_id": 11144,
            "ticket_number": "3511132",
            "title": "Cancelamento de Reserva - SPT002601598895",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:36",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 6.73,
            "sla_met": false,
            "sla_breach_hours": 2.73,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:46:15"
          },
          {
            "ticket_id": 11145,
            "ticket_number": "3511133",
            "title": "Cancelamento de Reserva - SPT002601598895",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:42",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 6.73,
            "sla_met": false,
            "sla_breach_hours": 2.73,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:46:33"
          },
          {
            "ticket_id": 11148,
            "ticket_number": "3511136",
            "title": "Número de informação da reserva: 6139558",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 10:01:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 360.92,
            "sla_met": false,
            "sla_breach_hours": 336.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:17"
          },
          {
            "ticket_id": 11150,
            "ticket_number": "3511138",
            "title": "Confirmaciones a Agencia. Agencia UMA FAMILIA EM V",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 10:01:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 360.92,
            "sla_met": false,
            "sla_breach_hours": 336.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:17"
          },
          {
            "ticket_id": 11156,
            "ticket_number": "3511144",
            "title": "Número de informação da reserva: 6138806",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 11:51:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 21:43:26"
          },
          {
            "ticket_id": 11157,
            "ticket_number": "3511145",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571889",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 11:51:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 21:43:26"
          },
          {
            "ticket_id": 11160,
            "ticket_number": "3511148",
            "title": "GBN-109418 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 11:51:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 21:43:26"
          },
          {
            "ticket_id": 11162,
            "ticket_number": "3511150",
            "title": "GBN-109418 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 11:51:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 11:51:50"
          },
          {
            "ticket_id": 11164,
            "ticket_number": "3511152",
            "title": "GBN-100392 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 12:03:11",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 557.37,
            "sla_met": false,
            "sla_breach_hours": 533.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:25:30"
          },
          {
            "ticket_id": 11166,
            "ticket_number": "3511154",
            "title": "GBN-109481 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 12:34:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 12:34:12"
          },
          {
            "ticket_id": 11170,
            "ticket_number": "3511158",
            "title": "GBN-109485 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 12:34:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 12:34:21"
          },
          {
            "ticket_id": 11171,
            "ticket_number": "3511159",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 12:38:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 358.3,
            "sla_met": false,
            "sla_breach_hours": 334.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:16"
          },
          {
            "ticket_id": 11176,
            "ticket_number": "3511164",
            "title": "Confirmação de reserva. Localizador: 16S8JF357O",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 357.9,
            "sla_met": false,
            "sla_breach_hours": 333.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:16"
          },
          {
            "ticket_id": 11177,
            "ticket_number": "3511165",
            "title": "Envio de Fatura 212563",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 357.9,
            "sla_met": false,
            "sla_breach_hours": 333.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:15"
          },
          {
            "ticket_id": 11178,
            "ticket_number": "3511166",
            "title": "Confirmation of booking with locatorZNAF4VSC",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 362.8,
            "sla_met": false,
            "sla_breach_hours": 338.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:15"
          },
          {
            "ticket_id": 11179,
            "ticket_number": "3511167",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 357.9,
            "sla_met": false,
            "sla_breach_hours": 333.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:15"
          },
          {
            "ticket_id": 11180,
            "ticket_number": "3511168",
            "title": "Confirmação de reserva com localizador: 4102023",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 357.9,
            "sla_met": false,
            "sla_breach_hours": 333.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:15"
          },
          {
            "ticket_id": 11181,
            "ticket_number": "3511169",
            "title": "GBN-109505 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:02:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 13:02:47"
          },
          {
            "ticket_id": 11184,
            "ticket_number": "3511172",
            "title": "GBN-109514 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:26:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 13:26:48"
          },
          {
            "ticket_id": 11187,
            "ticket_number": "3511175",
            "title": "Pagamento da Reserva TPR-2026-03107",
            "priority": "P2",
            "created_at": "03/03/2026 13:40:52",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:40:52"
          },
          {
            "ticket_id": 11191,
            "ticket_number": "3511179",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505099",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 13:46:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 23:43:36"
          },
          {
            "ticket_id": 11205,
            "ticket_number": "3511193",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 15:00:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 355.93,
            "sla_met": false,
            "sla_breach_hours": 331.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:57:14"
          },
          {
            "ticket_id": 11228,
            "ticket_number": "3511216",
            "title": "Número de informação da reserva: 6139690",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 16:53:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 12:44:56"
          },
          {
            "ticket_id": 11229,
            "ticket_number": "3511217",
            "title": "GBN-109486 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 16:53:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 12:44:56"
          },
          {
            "ticket_id": 11231,
            "ticket_number": "3511219",
            "title": "GBN-109535 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 17:42:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 21:40:41"
          },
          {
            "ticket_id": 11235,
            "ticket_number": "3511223",
            "title": "GBN-109427 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:14",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 21:40:41"
          },
          {
            "ticket_id": 11237,
            "ticket_number": "3511225",
            "title": "GBN-109419 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 17:42:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 21:40:42"
          },
          {
            "ticket_id": 11243,
            "ticket_number": "3511231",
            "title": "Envio de Fatura 212741",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 17:42:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 13:40:10"
          },
          {
            "ticket_id": 11253,
            "ticket_number": "3511241",
            "title": "Informação de reserva - SPT002601600850",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 18:26:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 14:20:19"
          },
          {
            "ticket_id": 11255,
            "ticket_number": "3511243",
            "title": "Fwd: Confirmação da sua reserva OH9ZQS - LIS-PMI 2",
            "priority": "P2",
            "created_at": "03/03/2026 18:27:13",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:27:14"
          },
          {
            "ticket_id": 11257,
            "ticket_number": "3511245",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "P2",
            "created_at": "03/03/2026 18:38:15",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 5.25,
            "sla_met": false,
            "sla_breach_hours": 1.25,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 23:53:36"
          },
          {
            "ticket_id": 11259,
            "ticket_number": "3511247",
            "title": "Confirmacao 341619",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 18:45:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 14:40:22"
          },
          {
            "ticket_id": 11260,
            "ticket_number": "3511248",
            "title": "Alteração de dia de Operação - OPO/DSS/OPO - Impor",
            "priority": "P2",
            "created_at": "03/03/2026 19:48:53",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 23:26:42"
          },
          {
            "ticket_id": 11261,
            "ticket_number": "3511249",
            "title": "pedido de credenciais",
            "priority": "P2",
            "created_at": "03/03/2026 19:48:54",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 19:48:54"
          },
          {
            "ticket_id": 11263,
            "ticket_number": "3511251",
            "title": "Re:[## 33703 ##] GBN-91048 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/03/2026 19:48:59",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:41:48"
          },
          {
            "ticket_id": 11269,
            "ticket_number": "3511257",
            "title": "Confirmação de reserva com localizador: 4103347",
            "priority": "P2",
            "created_at": "03/03/2026 20:35:31",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:02:09"
          },
          {
            "ticket_id": 11270,
            "ticket_number": "3511258",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "P2",
            "created_at": "03/03/2026 20:35:33",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:01:32"
          },
          {
            "ticket_id": 11273,
            "ticket_number": "3511261",
            "title": "GBN-109701 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 20:37:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 20:37:08"
          },
          {
            "ticket_id": 11274,
            "ticket_number": "3511262",
            "title": "Confirmação de Reserva",
            "priority": "P2",
            "created_at": "03/03/2026 20:52:36",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 20:52:36"
          },
          {
            "ticket_id": 11275,
            "ticket_number": "3511263",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 20:52:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 20:52:43"
          },
          {
            "ticket_id": 11277,
            "ticket_number": "3511265",
            "title": "Reserva confirmada: Passeio de barco pirata por Fl",
            "priority": "P2",
            "created_at": "03/03/2026 20:54:38",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 20:54:38"
          },
          {
            "ticket_id": 11280,
            "ticket_number": "3511268",
            "title": "GBN-109710 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 21:29:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/03/2026 21:29:43"
          },
          {
            "ticket_id": 11281,
            "ticket_number": "3511269",
            "title": "Reserva Aérea ZVBTFS",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 21:35:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 17:20:43"
          },
          {
            "ticket_id": 11285,
            "ticket_number": "3511273",
            "title": "Confirmación de la reserva con localizador: 410354",
            "priority": "Reservas sem Formulário",
            "created_at": "03/03/2026 22:20:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 348.58,
            "sla_met": false,
            "sla_breach_hours": 324.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:10"
          },
          {
            "ticket_id": 11286,
            "ticket_number": "3511274",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "03/03/2026 22:20:21",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:26:15"
          },
          {
            "ticket_id": 11289,
            "ticket_number": "3511277",
            "title": "GBN-109723 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/03/2026 23:35:01",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 23:35:01"
          },
          {
            "ticket_id": 11294,
            "ticket_number": "3511282",
            "title": "Reserva Solférias 432847  Francisco Pereira",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:39",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:17:39"
          },
          {
            "ticket_id": 11301,
            "ticket_number": "3511289",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604576576",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:55",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 5.95,
            "sla_met": false,
            "sla_breach_hours": 1.95,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:15:31"
          },
          {
            "ticket_id": 11306,
            "ticket_number": "3511294",
            "title": "Número de informação da reserva: 6139826",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 10:18:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 336.63,
            "sla_met": false,
            "sla_breach_hours": 312.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:09"
          },
          {
            "ticket_id": 11307,
            "ticket_number": "3511295",
            "title": "Fwd: Viagify informa sobre a sua reserva 125585780",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 10:18:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 10:18:11"
          },
          {
            "ticket_id": 11308,
            "ticket_number": "3511296",
            "title": "Fwd: Viagify informa sobre a sua reserva 125584066",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:13",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:18:14"
          },
          {
            "ticket_id": 11309,
            "ticket_number": "3511297",
            "title": "Fwd: Viagify informa sobre a sua reserva 125585912",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:17",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:18:18"
          },
          {
            "ticket_id": 11311,
            "ticket_number": "3511299",
            "title": "Fwd: Viagify informa sobre a sua reserva 125585912",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:24",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:18:25"
          },
          {
            "ticket_id": 11313,
            "ticket_number": "3511301",
            "title": "Fwd: Viagify informa sobre a sua reserva 125584066",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 10:18:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 10:18:32"
          },
          {
            "ticket_id": 11319,
            "ticket_number": "3511307",
            "title": "Confirmação de reserva. Localizador: 8ELV9ZNXPF",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:33:20",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11322,
            "ticket_number": "3511310",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 8",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:33:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11323,
            "ticket_number": "3511311",
            "title": "Confirmação de reserva. Localizador: 3HRSNS1S8M",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:33:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11324,
            "ticket_number": "3511312",
            "title": "Confirmacao 341655",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:33:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 21:21:19"
          },
          {
            "ticket_id": 11325,
            "ticket_number": "3511313",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 3",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:33:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11337,
            "ticket_number": "3511325",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 11:54:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 15:42:21"
          },
          {
            "ticket_id": 11340,
            "ticket_number": "3511328",
            "title": "GBN-109804 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:04:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:01:22"
          },
          {
            "ticket_id": 11341,
            "ticket_number": "3511329",
            "title": "GBN-109804 - Sua reserva está pendente de pagament",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:04:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:01:22"
          },
          {
            "ticket_id": 11343,
            "ticket_number": "3511331",
            "title": "Informação de reserva - SPT002601601307",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:04:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:01:22"
          },
          {
            "ticket_id": 11345,
            "ticket_number": "3511333",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:04:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 16:02:24"
          },
          {
            "ticket_id": 11346,
            "ticket_number": "3511334",
            "title": "GBN-109804 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:04:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:01:22"
          },
          {
            "ticket_id": 11352,
            "ticket_number": "3511340",
            "title": "Confirmação da reserva nº 84553323",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:35:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:21:24"
          },
          {
            "ticket_id": 11354,
            "ticket_number": "3511342",
            "title": "Confirmação de reserva com localizador: 4099413",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 12:35:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 22:21:25"
          },
          {
            "ticket_id": 11363,
            "ticket_number": "3511351",
            "title": "Número de informação da reserva: 6139879",
            "priority": "P2",
            "created_at": "04/03/2026 12:43:46",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 29.95,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 22:41:26"
          },
          {
            "ticket_id": 11372,
            "ticket_number": "3511360",
            "title": "Informação de reserva - SPT002601598765",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 13:21:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 333.58,
            "sla_met": false,
            "sla_breach_hours": 309.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:06"
          },
          {
            "ticket_id": 11383,
            "ticket_number": "3511371",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 13:42:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 13:42:27"
          },
          {
            "ticket_id": 11390,
            "ticket_number": "3511378",
            "title": "Confirmação de reserva com localizador: 4104595",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 14:42:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 332.22,
            "sla_met": false,
            "sla_breach_hours": 308.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:06"
          },
          {
            "ticket_id": 11393,
            "ticket_number": "3511381",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 14:42:38",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 532.38,
            "sla_met": false,
            "sla_breach_hours": 508.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:06:24"
          },
          {
            "ticket_id": 11394,
            "ticket_number": "3511382",
            "title": "Carrinho - Confirmação de Cancelamento (GR-938EC1E",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:39",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:44:22"
          },
          {
            "ticket_id": 11396,
            "ticket_number": "3511384",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 14:42:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 332.22,
            "sla_met": false,
            "sla_breach_hours": 308.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:06"
          },
          {
            "ticket_id": 11397,
            "ticket_number": "3511385",
            "title": "GBN-109783 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:45",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:22:40"
          },
          {
            "ticket_id": 11398,
            "ticket_number": "3511386",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 14:42:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 332.22,
            "sla_met": false,
            "sla_breach_hours": 308.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:05"
          },
          {
            "ticket_id": 11401,
            "ticket_number": "3511389",
            "title": "[Suporte] TRP-2026-03109 / TRL-2026-04790 - Pedido",
            "priority": "P2",
            "created_at": "04/03/2026 15:12:38",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:12:38"
          },
          {
            "ticket_id": 11404,
            "ticket_number": "3511392",
            "title": "Número de informação da reserva: 6139930",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 16:07:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 12:02:34"
          },
          {
            "ticket_id": 11405,
            "ticket_number": "3511393",
            "title": "Fwd: Viagify informa sobre a sua reserva 125605352",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 16:07:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 16:07:10"
          },
          {
            "ticket_id": 11406,
            "ticket_number": "3511394",
            "title": "GBN-109883 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 16:07:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 16:07:13"
          },
          {
            "ticket_id": 11410,
            "ticket_number": "3511398",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 16:31:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 19.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 12:22:36"
          },
          {
            "ticket_id": 11427,
            "ticket_number": "3511415",
            "title": "Informação de reserva - SPT002601599125",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 17:25:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 13:22:48"
          },
          {
            "ticket_id": 11431,
            "ticket_number": "3511419",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 17:49:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 13:42:51"
          },
          {
            "ticket_id": 11434,
            "ticket_number": "3511422",
            "title": "Confirmação de reserva com localizador: 4105070",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 18:08:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 14:02:54"
          },
          {
            "ticket_id": 11441,
            "ticket_number": "3511429",
            "title": "[Pedido de Grupo] Ilha do Sal -  Melia Dunas Beach",
            "priority": "P2",
            "created_at": "04/03/2026 19:05:05",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:05:05"
          },
          {
            "ticket_id": 11447,
            "ticket_number": "3511435",
            "title": "Número de informação da reserva: 6140024",
            "priority": "P2",
            "created_at": "04/03/2026 19:50:00",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 20:22:59"
          },
          {
            "ticket_id": 11448,
            "ticket_number": "3511436",
            "title": "Fwd: Informações da reserva TTN-1252218555#9429001",
            "priority": "P2",
            "created_at": "04/03/2026 20:50:35",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 20:50:35"
          },
          {
            "ticket_id": 11452,
            "ticket_number": "3511440",
            "title": "Recolha Tour completo pela Madeira em 2 dias",
            "priority": "P2",
            "created_at": "04/03/2026 21:42:12",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 00:14:12"
          },
          {
            "ticket_id": 11455,
            "ticket_number": "3511443",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 22:17:44",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 22:17:44"
          },
          {
            "ticket_id": 11456,
            "ticket_number": "3511444",
            "title": "acessos ao douro acima",
            "priority": "P2",
            "created_at": "04/03/2026 22:25:15",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 22:25:15"
          },
          {
            "ticket_id": 11457,
            "ticket_number": "3511445",
            "title": "Confirmação de reserva com localizador: 4105656",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 22:41:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 324.23,
            "sla_met": false,
            "sla_breach_hours": 300.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:04"
          },
          {
            "ticket_id": 11458,
            "ticket_number": "3511446",
            "title": "GBN-110065 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 22:41:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 22:41:48"
          },
          {
            "ticket_id": 11460,
            "ticket_number": "3511448",
            "title": "Criação de processo File 433867/26",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 22:49:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 18:43:31"
          },
          {
            "ticket_id": 11461,
            "ticket_number": "3511449",
            "title": "pass para auto europe",
            "priority": "P2",
            "created_at": "04/03/2026 23:06:51",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 23:06:51"
          },
          {
            "ticket_id": 11463,
            "ticket_number": "3511451",
            "title": "Fwd: Viagify informa sobre a sua reserva 125600431",
            "priority": "Reservas sem Formulário",
            "created_at": "04/03/2026 23:06:55",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/03/2026 23:06:56"
          },
          {
            "ticket_id": 11468,
            "ticket_number": "3511456",
            "title": "Fwd: Viagify informa sobre a sua reserva 125629394",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 10:06:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 10:06:02"
          },
          {
            "ticket_id": 11470,
            "ticket_number": "3511458",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:06",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11472,
            "ticket_number": "3511460",
            "title": "MSC Cruises Document - 2600101001631158",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:12",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11473,
            "ticket_number": "3511461",
            "title": "MSC Cruises Document - 2600101001631159",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:13",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11474,
            "ticket_number": "3511462",
            "title": "Pedido de orçamento",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:15",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11476,
            "ticket_number": "3511464",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:19",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11478,
            "ticket_number": "3511466",
            "title": "Acesso consolidador",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:23",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 10:06:24"
          },
          {
            "ticket_id": 11480,
            "ticket_number": "3511468",
            "title": "GBN-110078 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:29",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 10:06:29"
          },
          {
            "ticket_id": 11481,
            "ticket_number": "3511469",
            "title": "MSC Cruises Document - 2600101001631160",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:02",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11482,
            "ticket_number": "3511470",
            "title": "GBN-109804 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:39",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11483,
            "ticket_number": "3511471",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604578663",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 10:07:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11484,
            "ticket_number": "3511472",
            "title": "GBN-110022 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:48",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11485,
            "ticket_number": "3511473",
            "title": "GBN-110093 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 10:07:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 10:07:50"
          },
          {
            "ticket_id": 11486,
            "ticket_number": "3511474",
            "title": "RE: Pagamento 1778299",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:53",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11491,
            "ticket_number": "3511479",
            "title": "RE: Pagamento 6139558",
            "priority": "P2",
            "created_at": "05/03/2026 10:08:07",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11492,
            "ticket_number": "3511480",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "05/03/2026 10:08:09",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:43:21"
          },
          {
            "ticket_id": 11493,
            "ticket_number": "3511481",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "05/03/2026 10:08:11",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:43:21"
          },
          {
            "ticket_id": 11494,
            "ticket_number": "3511482",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "05/03/2026 10:08:13",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:43:21"
          },
          {
            "ticket_id": 11495,
            "ticket_number": "3511483",
            "title": "Confirmação de reserva. Localizador: 1QUP2ZZP4G",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 10:08:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11496,
            "ticket_number": "3511484",
            "title": "Fwd: Viagify informa sobre a sua reserva 125634639",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:00:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 11:00:50"
          },
          {
            "ticket_id": 11497,
            "ticket_number": "3511485",
            "title": "Confirmação de reserva para For PT004157 70699224",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:00:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 311.92,
            "sla_met": false,
            "sla_breach_hours": 287.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:56:02"
          },
          {
            "ticket_id": 11498,
            "ticket_number": "3511486",
            "title": "Confirmação de reserva com localizador: 4099413",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:00:55",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 311.9,
            "sla_met": false,
            "sla_breach_hours": 287.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:13"
          },
          {
            "ticket_id": 11499,
            "ticket_number": "3511487",
            "title": "Fwd: Viagify informa sobre a sua reserva 125634639",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:45:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 11:46:00"
          },
          {
            "ticket_id": 11501,
            "ticket_number": "3511489",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:46:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 21:44:14"
          },
          {
            "ticket_id": 11504,
            "ticket_number": "3511492",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571207",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 11:46:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 21:44:14"
          },
          {
            "ticket_id": 11510,
            "ticket_number": "3511498",
            "title": "GBN-110174 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 12:43:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 12:43:40"
          },
          {
            "ticket_id": 11511,
            "ticket_number": "3511499",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 12:43:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 310.18,
            "sla_met": false,
            "sla_breach_hours": 286.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:12"
          },
          {
            "ticket_id": 11513,
            "ticket_number": "3511501",
            "title": "Confirmação de reserva 341311 ### TIME LIMIT EMISS",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 12:43:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 310.18,
            "sla_met": false,
            "sla_breach_hours": 286.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:12"
          },
          {
            "ticket_id": 11515,
            "ticket_number": "3511503",
            "title": "Recapitulativa de billetes | Solicitud 965256 - Fa",
            "priority": "P2",
            "created_at": "05/03/2026 12:43:52",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:56:58"
          },
          {
            "ticket_id": 11523,
            "ticket_number": "3511511",
            "title": "Confirmation of booking with locator0S8Q2KWX",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 14:27:17",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 313.38,
            "sla_met": false,
            "sla_breach_hours": 289.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:15"
          },
          {
            "ticket_id": 11524,
            "ticket_number": "3511512",
            "title": "Informação de reserva - SPT002601600850",
            "priority": "P2",
            "created_at": "05/03/2026 14:27:26",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 17:34:09"
          },
          {
            "ticket_id": 11526,
            "ticket_number": "3511514",
            "title": "GBN-110187 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 14:27:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 14:27:31"
          },
          {
            "ticket_id": 11531,
            "ticket_number": "3511519",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "05/03/2026 15:09:20",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:34:40"
          },
          {
            "ticket_id": 11532,
            "ticket_number": "3511520",
            "title": "Número de informação da reserva: 6140162",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 15:09:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 307.75,
            "sla_met": false,
            "sla_breach_hours": 283.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:12"
          },
          {
            "ticket_id": 11534,
            "ticket_number": "3511522",
            "title": "Re:[## 33453 ##] GBN-101842 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "05/03/2026 15:45:18",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:34:01"
          },
          {
            "ticket_id": 11535,
            "ticket_number": "3511523",
            "title": "GBN-110233 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 15:45:24",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 505.63,
            "sla_met": false,
            "sla_breach_hours": 481.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:24:19"
          },
          {
            "ticket_id": 11536,
            "ticket_number": "3511524",
            "title": "GBN-110233 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 15:45:27",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 505.65,
            "sla_met": false,
            "sla_breach_hours": 481.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:24:37"
          },
          {
            "ticket_id": 11537,
            "ticket_number": "3511525",
            "title": "GBN-110252 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/03/2026 16:02:52",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:02:52"
          },
          {
            "ticket_id": 11539,
            "ticket_number": "3511527",
            "title": "Re:[## 33453 ##] GBN-101842 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "05/03/2026 16:03:02",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:30:14"
          },
          {
            "ticket_id": 11542,
            "ticket_number": "3511530",
            "title": "Número de informação da reserva: 6139930",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 16:19:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 306.58,
            "sla_met": false,
            "sla_breach_hours": 282.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:11"
          },
          {
            "ticket_id": 11544,
            "ticket_number": "3511532",
            "title": "Confirmacao 341817",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 16:36:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 306.3,
            "sla_met": false,
            "sla_breach_hours": 282.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:11"
          },
          {
            "ticket_id": 11545,
            "ticket_number": "3511533",
            "title": "Informação de reserva - SPT002601601806",
            "priority": "P2",
            "created_at": "05/03/2026 16:36:41",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 17:37:20"
          },
          {
            "ticket_id": 11552,
            "ticket_number": "3511540",
            "title": "Confirmacao 341851",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 18:51:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 19:38:52"
          },
          {
            "ticket_id": 11554,
            "ticket_number": "3511542",
            "title": "Confirmación de la reserva con localizador: 410703",
            "priority": "P2",
            "created_at": "05/03/2026 18:51:55",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:38:24"
          },
          {
            "ticket_id": 11555,
            "ticket_number": "3511543",
            "title": "GBN-110315 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/03/2026 18:51:57",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:51:57"
          },
          {
            "ticket_id": 11556,
            "ticket_number": "3511544",
            "title": "Pagamento da reserva – Ref PP227106, Sr. Jose Albe",
            "priority": "P2",
            "created_at": "05/03/2026 18:51:59",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:37:05"
          },
          {
            "ticket_id": 11557,
            "ticket_number": "3511545",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/03/2026 18:52:03",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:52:03"
          },
          {
            "ticket_id": 11558,
            "ticket_number": "3511546",
            "title": "Re: [Cockpit] Viagem TRP-2026-04073 - Joana Rosari",
            "priority": "P2",
            "created_at": "05/03/2026 18:52:05",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:52:06"
          },
          {
            "ticket_id": 11559,
            "ticket_number": "3511547",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/03/2026 18:52:13",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:52:13"
          },
          {
            "ticket_id": 11560,
            "ticket_number": "3511548",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/03/2026 18:52:22",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:52:22"
          },
          {
            "ticket_id": 11561,
            "ticket_number": "3511549",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/03/2026 18:52:32",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:52:33"
          },
          {
            "ticket_id": 11562,
            "ticket_number": "3511550",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 18:52:44",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 18:52:44"
          },
          {
            "ticket_id": 11563,
            "ticket_number": "3511551",
            "title": "GBN-110305 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 18:52:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 18:52:49"
          },
          {
            "ticket_id": 11565,
            "ticket_number": "3511553",
            "title": "Confirmação de Reserva * File 433867*( Time Limit ",
            "priority": "P2",
            "created_at": "05/03/2026 18:53:04",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:25:53"
          },
          {
            "ticket_id": 11571,
            "ticket_number": "3511559",
            "title": "Alteração de horários Lisboa/Tunes/Lisboa",
            "priority": "P2",
            "created_at": "05/03/2026 19:00:03",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:09:32"
          },
          {
            "ticket_id": 11572,
            "ticket_number": "3511560",
            "title": "Alteração de horários Lisboa/Tunes/Lisboa",
            "priority": "P2",
            "created_at": "05/03/2026 19:00:04",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:22:04"
          },
          {
            "ticket_id": 11575,
            "ticket_number": "3511563",
            "title": "Pedido de esclarecimento – Orçamentos Riviera Maya",
            "priority": "P2",
            "created_at": "05/03/2026 19:42:32",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:42:32"
          },
          {
            "ticket_id": 11576,
            "ticket_number": "3511564",
            "title": "Confirmacao 341870",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 19:42:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 303.2,
            "sla_met": false,
            "sla_breach_hours": 279.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:10"
          },
          {
            "ticket_id": 11580,
            "ticket_number": "3511568",
            "title": "Código para cerrar reserva a Best Siroco",
            "priority": "P2",
            "created_at": "05/03/2026 20:19:41",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 20:21:06"
          },
          {
            "ticket_id": 11582,
            "ticket_number": "3511570",
            "title": "GBN-110411 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/03/2026 21:17:21",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 21:17:21"
          },
          {
            "ticket_id": 11592,
            "ticket_number": "3511580",
            "title": "Fwd: Viagify informa sobre a sua reserva 125668074",
            "priority": "Reservas sem Formulário",
            "created_at": "05/03/2026 23:13:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/03/2026 23:13:35"
          },
          {
            "ticket_id": 11595,
            "ticket_number": "3511583",
            "title": "Convite Expo Festas e Casamentos Coimbra",
            "priority": "P2",
            "created_at": "05/03/2026 23:13:56",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:14:33"
          },
          {
            "ticket_id": 11603,
            "ticket_number": "3511591",
            "title": "Fwd: Viagify informa sobre a sua reserva 125670895",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:08:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:08:50"
          },
          {
            "ticket_id": 11605,
            "ticket_number": "3511593",
            "title": "Fwd: Viagify informa sobre a sua reserva 125671155",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:08:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:08:56"
          },
          {
            "ticket_id": 11606,
            "ticket_number": "3511594",
            "title": "Fwd: Viagify informa sobre a sua reserva 125671079",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:08:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:08:59"
          },
          {
            "ticket_id": 11614,
            "ticket_number": "3511602",
            "title": "GBN-110438 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:09:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:09:16"
          },
          {
            "ticket_id": 11615,
            "ticket_number": "3511603",
            "title": "Confirmación de la reserva con localizador: 410771",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:09:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 288.75,
            "sla_met": false,
            "sla_breach_hours": 264.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:09"
          },
          {
            "ticket_id": 11616,
            "ticket_number": "3511604",
            "title": "GBN-110433 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:09:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:09:21"
          },
          {
            "ticket_id": 11617,
            "ticket_number": "3511605",
            "title": "GBN-110437 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:09:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:09:24"
          },
          {
            "ticket_id": 11618,
            "ticket_number": "3511606",
            "title": "GBN-110432 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:09:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 10:09:29"
          },
          {
            "ticket_id": 11622,
            "ticket_number": "3511610",
            "title": "Número para informações de reserva: 1779565",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:58:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 287.95,
            "sla_met": false,
            "sla_breach_hours": 263.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:08"
          },
          {
            "ticket_id": 11623,
            "ticket_number": "3511611",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:58:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 287.95,
            "sla_met": false,
            "sla_breach_hours": 263.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:08"
          },
          {
            "ticket_id": 11624,
            "ticket_number": "3511612",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 10:58:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 287.95,
            "sla_met": false,
            "sla_breach_hours": 263.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:08"
          },
          {
            "ticket_id": 11626,
            "ticket_number": "3511614",
            "title": "Invio biglietti TraghettiGDS FW26CCD3EB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 11:37:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 287.28,
            "sla_met": false,
            "sla_breach_hours": 263.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:08"
          },
          {
            "ticket_id": 11629,
            "ticket_number": "3511617",
            "title": "Reserva em WL 213123",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 12:16:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 16:03:07"
          },
          {
            "ticket_id": 11641,
            "ticket_number": "3511629",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 13:05:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 285.82,
            "sla_met": false,
            "sla_breach_hours": 261.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:08"
          },
          {
            "ticket_id": 11644,
            "ticket_number": "3511632",
            "title": "Re: [Cockpit] Viagem TRP-2026-04048 - PUNTA CANA I",
            "priority": "P2",
            "created_at": "06/03/2026 13:17:24",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:17:25"
          },
          {
            "ticket_id": 11650,
            "ticket_number": "3511638",
            "title": "[Cancelamento Serviço] TRP-2026-03668 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 13:38:10",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:38:10"
          },
          {
            "ticket_id": 11653,
            "ticket_number": "3511641",
            "title": "Pedido de cotação – Dionysis Hotel Milos",
            "priority": "P2",
            "created_at": "06/03/2026 14:08:37",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 14:08:37"
          },
          {
            "ticket_id": 11656,
            "ticket_number": "3511644",
            "title": "Invio biglietti TraghettiGDS FW26C51DF7",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 14:08:44",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 18:03:25"
          },
          {
            "ticket_id": 11659,
            "ticket_number": "3511647",
            "title": "[Suporte] TRP-2026-04075 / TRL-2026-06159 - Pedido",
            "priority": "P2",
            "created_at": "06/03/2026 14:31:01",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 14:32:09"
          },
          {
            "ticket_id": 11668,
            "ticket_number": "3511656",
            "title": "Reserva Cancelada TRP-2026-03872",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:30",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:47:30"
          },
          {
            "ticket_id": 11669,
            "ticket_number": "3511657",
            "title": "Fwd: O itinerário da sua viagem: DKVLMM",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:33",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:47:33"
          },
          {
            "ticket_id": 11673,
            "ticket_number": "3511661",
            "title": "GBN-110564 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 16:39:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 16:39:07"
          },
          {
            "ticket_id": 11675,
            "ticket_number": "3511663",
            "title": "GBN-110570 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 16:39:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 16:39:14"
          },
          {
            "ticket_id": 11676,
            "ticket_number": "3511664",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:16",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:21:46"
          },
          {
            "ticket_id": 11677,
            "ticket_number": "3511665",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:18",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:30:45"
          },
          {
            "ticket_id": 11678,
            "ticket_number": "3511666",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:20",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.02,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:41:06"
          },
          {
            "ticket_id": 11679,
            "ticket_number": "3511667",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:22",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 6.07,
            "sla_met": false,
            "sla_breach_hours": 2.07,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:44:14"
          },
          {
            "ticket_id": 11681,
            "ticket_number": "3511669",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:25",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.83,
            "sla_met": false,
            "sla_breach_hours": 1.83,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:29:32"
          },
          {
            "ticket_id": 11682,
            "ticket_number": "3511670",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:27",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.8,
            "sla_met": false,
            "sla_breach_hours": 1.8,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:28:01"
          },
          {
            "ticket_id": 11683,
            "ticket_number": "3511671",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:29",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.77,
            "sla_met": false,
            "sla_breach_hours": 1.77,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:25:53"
          },
          {
            "ticket_id": 11684,
            "ticket_number": "3511672",
            "title": "Fwd: V1N3UZ | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "06/03/2026 16:44:05",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 16:44:05"
          },
          {
            "ticket_id": 11685,
            "ticket_number": "3511673",
            "title": "Confirmação reserva Bedsonline 59-5773587",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 16:44:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 282.18,
            "sla_met": false,
            "sla_breach_hours": 258.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:07"
          },
          {
            "ticket_id": 11701,
            "ticket_number": "3511689",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/03/2026 19:01:59",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:01:59"
          },
          {
            "ticket_id": 11702,
            "ticket_number": "3511690",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/03/2026 19:02:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:02:14"
          },
          {
            "ticket_id": 11704,
            "ticket_number": "3511692",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 19:02:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 19:02:29"
          },
          {
            "ticket_id": 11705,
            "ticket_number": "3511693",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 19:02:45",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 19:02:46"
          },
          {
            "ticket_id": 11708,
            "ticket_number": "3511696",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/03/2026 19:02:59",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:02:59"
          },
          {
            "ticket_id": 11709,
            "ticket_number": "3511697",
            "title": "GBN-110492 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/03/2026 19:03:02",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:43:56"
          },
          {
            "ticket_id": 11710,
            "ticket_number": "3511698",
            "title": "Confirmacao 341959",
            "priority": "P2",
            "created_at": "06/03/2026 19:03:04",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:20:49"
          },
          {
            "ticket_id": 11711,
            "ticket_number": "3511699",
            "title": "Confirmação reserva Bedsonline 59-5773606",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 19:03:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 279.87,
            "sla_met": false,
            "sla_breach_hours": 255.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:07"
          },
          {
            "ticket_id": 11714,
            "ticket_number": "3511702",
            "title": "[Cancelamento Serviço] TRP-2026-02349 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 19:19:54",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:19:54"
          },
          {
            "ticket_id": 11719,
            "ticket_number": "3511707",
            "title": "Pagamento da reserva – Ref PP127864, Sr. Nelson Fi",
            "priority": "P2",
            "created_at": "06/03/2026 19:46:26",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:47:21"
          },
          {
            "ticket_id": 11727,
            "ticket_number": "3511715",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60457188",
            "priority": "P2",
            "created_at": "06/03/2026 20:29:58",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:39:41"
          },
          {
            "ticket_id": 11730,
            "ticket_number": "3511718",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802496917",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 20:51:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 63.87,
            "sla_met": false,
            "sla_breach_hours": 39.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 12:43:31"
          },
          {
            "ticket_id": 11739,
            "ticket_number": "3511727",
            "title": "pedido de voucher le plan 604541477",
            "priority": "P2",
            "created_at": "06/03/2026 21:41:30",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:41:30"
          },
          {
            "ticket_id": 11740,
            "ticket_number": "3511728",
            "title": "Newblue ES | Viagem Lua Mel",
            "priority": "P2",
            "created_at": "06/03/2026 21:42:02",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:42:02"
          },
          {
            "ticket_id": 11741,
            "ticket_number": "3511729",
            "title": "Fwd: Informações da reserva TTN-1252218555#9429001",
            "priority": "P2",
            "created_at": "06/03/2026 21:59:01",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:59:02"
          },
          {
            "ticket_id": 11744,
            "ticket_number": "3511732",
            "title": "Número de informação da reserva: 6140598",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 22:13:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 63.83,
            "sla_met": false,
            "sla_breach_hours": 39.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11747,
            "ticket_number": "3511735",
            "title": "GBN-110714 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 23:03:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 23:03:00"
          },
          {
            "ticket_id": 11748,
            "ticket_number": "3511736",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/03/2026 23:03:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/03/2026 23:03:11"
          },
          {
            "ticket_id": 11749,
            "ticket_number": "3511737",
            "title": "[Cancelamento Serviço] TRP-2026-03217 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 23:06:01",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 23:06:01"
          },
          {
            "ticket_id": 11753,
            "ticket_number": "3511741",
            "title": "[Suporte] TRP-2026-02393 / TRL-2026-05808 - Valida",
            "priority": "P2",
            "created_at": "06/03/2026 23:34:08",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 23:34:08"
          },
          {
            "ticket_id": 11754,
            "ticket_number": "3511742",
            "title": "[Suporte] TRP-2026-03722 / TRL-2026-05659 - Valida",
            "priority": "P2",
            "created_at": "06/03/2026 23:39:56",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 23:39:56"
          },
          {
            "ticket_id": 11757,
            "ticket_number": "3511745",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (Y9N",
            "priority": "P2",
            "created_at": "06/03/2026 23:50:37",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 00:02:45"
          },
          {
            "ticket_id": 11760,
            "ticket_number": "3511748",
            "title": "Reserva Aérea YGOZWA",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:12",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:47:06"
          },
          {
            "ticket_id": 11761,
            "ticket_number": "3511749",
            "title": "MSC Cruises Document - 2600101001658652",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:14",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 11:57:37"
          },
          {
            "ticket_id": 11762,
            "ticket_number": "3511750",
            "title": "Número de informação da reserva: 6140620",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:17",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:02:59"
          },
          {
            "ticket_id": 11763,
            "ticket_number": "3511751",
            "title": "Número de informação da reserva: 6140625",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:21",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:03:18"
          },
          {
            "ticket_id": 11765,
            "ticket_number": "3511753",
            "title": "Soltour - criança grátis - solicitação de esclarec",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:25",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 10:07:25"
          },
          {
            "ticket_id": 11768,
            "ticket_number": "3511756",
            "title": "Reserva Aérea YGOZWA",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:32",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:48:07"
          },
          {
            "ticket_id": 11771,
            "ticket_number": "3511759",
            "title": "ifthenpay:  Processamento do dia 06-03-2026 da con",
            "priority": "P2",
            "created_at": "07/03/2026 10:13:48",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:12:26"
          },
          {
            "ticket_id": 11777,
            "ticket_number": "3511765",
            "title": "File 39720 - Simoes/LuisManuelLopesMR - Pacote (S.",
            "priority": "P2",
            "created_at": "07/03/2026 11:54:00",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 126.78,
            "sla_met": false,
            "sla_breach_hours": 122.78,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 18:41:35"
          },
          {
            "ticket_id": 11796,
            "ticket_number": "3511784",
            "title": "YGOZWA – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "07/03/2026 13:42:19",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:49:29"
          },
          {
            "ticket_id": 11800,
            "ticket_number": "3511788",
            "title": "Confirmação de reserva com localizador: 4109981",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 14:57:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 53.78,
            "sla_met": false,
            "sla_breach_hours": 29.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 20:44:54"
          },
          {
            "ticket_id": 11803,
            "ticket_number": "3511791",
            "title": "cancelamento  GBN-110780",
            "priority": "P2",
            "created_at": "07/03/2026 15:10:58",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 19:08:55"
          },
          {
            "ticket_id": 11805,
            "ticket_number": "3511793",
            "title": "GBN-110788 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 15:27:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/03/2026 15:27:05"
          },
          {
            "ticket_id": 11807,
            "ticket_number": "3511795",
            "title": "Reserva confirmada: Excursão à ilha Saona de catam",
            "priority": "P2",
            "created_at": "07/03/2026 16:38:39",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 16:38:39"
          },
          {
            "ticket_id": 11809,
            "ticket_number": "3511797",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 18:04:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 256.83,
            "sla_met": false,
            "sla_breach_hours": 232.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:05"
          },
          {
            "ticket_id": 11811,
            "ticket_number": "3511799",
            "title": "Confirmação de reserva – Ref PP187213, Sr. FRANCIS",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 18:09:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 256.75,
            "sla_met": false,
            "sla_breach_hours": 232.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:05"
          },
          {
            "ticket_id": 11813,
            "ticket_number": "3511801",
            "title": "Faturas Pendentes: FA 2147898607",
            "priority": "P2",
            "created_at": "07/03/2026 18:16:49",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 18:43:54"
          },
          {
            "ticket_id": 11815,
            "ticket_number": "3511803",
            "title": "Confirmation of booking with locator3ZGPYGFC",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 18:40:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 261.17,
            "sla_met": false,
            "sla_breach_hours": 237.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:51:14"
          },
          {
            "ticket_id": 11817,
            "ticket_number": "3511805",
            "title": "GBN-110780 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "07/03/2026 18:54:51",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 19:04:58"
          },
          {
            "ticket_id": 11818,
            "ticket_number": "3511806",
            "title": "GBN-108016 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "07/03/2026 19:06:24",
            "close_date": "2026-03-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/03/2026 13:10:09"
          },
          {
            "ticket_id": 11833,
            "ticket_number": "3511821",
            "title": "Confirmação de reserva com localizador: 4110941",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:04:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.83,
            "sla_met": false,
            "sla_breach_hours": 192.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:05"
          },
          {
            "ticket_id": 11834,
            "ticket_number": "3511822",
            "title": "Confirmação de reserva com localizador: 4110934",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:04:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.83,
            "sla_met": false,
            "sla_breach_hours": 192.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:05"
          },
          {
            "ticket_id": 11839,
            "ticket_number": "3511827",
            "title": "Últimos dias para anular sem despesas a reserva 33",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:34",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:52:25"
          },
          {
            "ticket_id": 11846,
            "ticket_number": "3511834",
            "title": "Confirmação de reserva com localizador: 4110842",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:04:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11847,
            "ticket_number": "3511835",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:50",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:28:01"
          },
          {
            "ticket_id": 11849,
            "ticket_number": "3511837",
            "title": "Reclamação cliente - Ilha do Sal - URGENTE",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:54",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:04:54"
          },
          {
            "ticket_id": 11850,
            "ticket_number": "3511838",
            "title": "GBN-110912 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:04:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:04:57"
          },
          {
            "ticket_id": 11851,
            "ticket_number": "3511839",
            "title": "Informação de reserva - SPT002601604008",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.83,
            "sla_met": false,
            "sla_breach_hours": 192.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:55:04"
          },
          {
            "ticket_id": 11852,
            "ticket_number": "3511840",
            "title": "GBN-110877 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11853,
            "ticket_number": "3511841",
            "title": "Reserva confirmada: Free tour por Sevilha - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:08",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 417.03,
            "sla_met": false,
            "sla_breach_hours": 393.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:07:32"
          },
          {
            "ticket_id": 11854,
            "ticket_number": "3511842",
            "title": "Reserva confirmada: Free tour por Sevilha - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:10",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 415.13,
            "sla_met": false,
            "sla_breach_hours": 391.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:13:13"
          },
          {
            "ticket_id": 11855,
            "ticket_number": "3511843",
            "title": "GBN-110905 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:05:14"
          },
          {
            "ticket_id": 11856,
            "ticket_number": "3511844",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604582864",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.82,
            "sla_met": false,
            "sla_breach_hours": 192.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:23"
          },
          {
            "ticket_id": 11859,
            "ticket_number": "3511847",
            "title": "GBN-110904 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:05:24"
          },
          {
            "ticket_id": 11861,
            "ticket_number": "3511849",
            "title": "Número de informação da reserva: 6140824",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:05:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.8,
            "sla_met": false,
            "sla_breach_hours": 192.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:23"
          },
          {
            "ticket_id": 11864,
            "ticket_number": "3511852",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:39",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:50:09"
          },
          {
            "ticket_id": 11866,
            "ticket_number": "3511854",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:44",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:50:09"
          },
          {
            "ticket_id": 11869,
            "ticket_number": "3511857",
            "title": "Confirmação reserva Bedsonline 218-3735447",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:06:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.78,
            "sla_met": false,
            "sla_breach_hours": 192.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:23"
          },
          {
            "ticket_id": 11870,
            "ticket_number": "3511858",
            "title": "Informação de reserva - SPT002601603925",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:06:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.78,
            "sla_met": false,
            "sla_breach_hours": 192.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:22"
          },
          {
            "ticket_id": 11871,
            "ticket_number": "3511859",
            "title": "GBN-110880 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:06:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:06:40"
          },
          {
            "ticket_id": 11872,
            "ticket_number": "3511860",
            "title": "Informação de reserva - SPT002601603914",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:06:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.78,
            "sla_met": false,
            "sla_breach_hours": 192.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:22"
          },
          {
            "ticket_id": 11873,
            "ticket_number": "3511861",
            "title": "GBN-110863 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:06:52",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:06:52"
          },
          {
            "ticket_id": 11875,
            "ticket_number": "3511863",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:07:05"
          },
          {
            "ticket_id": 11876,
            "ticket_number": "3511864",
            "title": "GBN-110861 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:07:10"
          },
          {
            "ticket_id": 11877,
            "ticket_number": "3511865",
            "title": "Confirmacao 342052",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.78,
            "sla_met": false,
            "sla_breach_hours": 192.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:22"
          },
          {
            "ticket_id": 11878,
            "ticket_number": "3511866",
            "title": "Confirmação de reserva para For PT004157 66593177",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.78,
            "sla_met": false,
            "sla_breach_hours": 192.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:21"
          },
          {
            "ticket_id": 11879,
            "ticket_number": "3511867",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.77,
            "sla_met": false,
            "sla_breach_hours": 192.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:21"
          },
          {
            "ticket_id": 11881,
            "ticket_number": "3511869",
            "title": "Re: [URGENT] Booking locator - CMV0086L - Transfer",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:28",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 8.0,
            "sla_met": false,
            "sla_breach_hours": 4.0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:07:29"
          },
          {
            "ticket_id": 11883,
            "ticket_number": "3511871",
            "title": "Número de informação da reserva: 6140755",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11886,
            "ticket_number": "3511874",
            "title": "[URGENT] Booking locator - CMV0086L - Transfer to ",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:40",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11890,
            "ticket_number": "3511878",
            "title": "Número de informação da reserva: 6140745",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:07:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 216.77,
            "sla_met": false,
            "sla_breach_hours": 192.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:21"
          },
          {
            "ticket_id": 11893,
            "ticket_number": "3511881",
            "title": "MSC Cruises Document - 2600101001676687",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:57",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:37:22"
          },
          {
            "ticket_id": 11894,
            "ticket_number": "3511882",
            "title": "GBN-110842 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:08:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:08:03"
          },
          {
            "ticket_id": 11895,
            "ticket_number": "3511883",
            "title": "GBN-110798 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:08:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11897,
            "ticket_number": "3511885",
            "title": "Confirmação de reserva com localizador: 4110142",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:08:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11898,
            "ticket_number": "3511886",
            "title": "Confirmacao 342043",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:08:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11900,
            "ticket_number": "3511888",
            "title": "Fwd: Operations update March 8 2026 - Qatari Airsp",
            "priority": "P2",
            "created_at": "09/03/2026 10:15:59",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:16:00"
          },
          {
            "ticket_id": 11901,
            "ticket_number": "3511889",
            "title": "Fwd: Update to our passenger guidelines",
            "priority": "P2",
            "created_at": "09/03/2026 10:16:04",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:16:05"
          },
          {
            "ticket_id": 11902,
            "ticket_number": "3511890",
            "title": "Fwd: Qatar Airways - Update to our passenger guide",
            "priority": "P2",
            "created_at": "09/03/2026 10:16:07",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:16:08"
          },
          {
            "ticket_id": 11904,
            "ticket_number": "3511892",
            "title": "Fwd: easyJet número de referência da reserva: KC83",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:44:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 10:44:36"
          },
          {
            "ticket_id": 11906,
            "ticket_number": "3511894",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 10:44:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 14:43:51"
          },
          {
            "ticket_id": 11917,
            "ticket_number": "3511905",
            "title": "Confirmação de reserva 342052 ### TIME LIMIT EMISS",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 11:57:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 21:42:59"
          },
          {
            "ticket_id": 11921,
            "ticket_number": "3511909",
            "title": "Fwd: PNR information: ZC95XA",
            "priority": "P2",
            "created_at": "09/03/2026 11:57:34",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:57:34"
          },
          {
            "ticket_id": 11922,
            "ticket_number": "3511910",
            "title": "Subject. Soltour: Modificação de Voos: SPT00250154",
            "priority": "P2",
            "created_at": "09/03/2026 11:57:36",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 12:46:28"
          },
          {
            "ticket_id": 11923,
            "ticket_number": "3511911",
            "title": "Confirmacao 342072",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 11:57:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 21:42:59"
          },
          {
            "ticket_id": 11929,
            "ticket_number": "3511917",
            "title": "Pedido de Sinalização De Reserva 341995",
            "priority": "P2",
            "created_at": "09/03/2026 12:14:58",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:58:19"
          },
          {
            "ticket_id": 11930,
            "ticket_number": "3511918",
            "title": "Pedido de Sinalização De Reserva 341374",
            "priority": "P2",
            "created_at": "09/03/2026 12:15:00",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:58:42"
          },
          {
            "ticket_id": 11931,
            "ticket_number": "3511919",
            "title": "Pedido de Sinalização De Reserva 341870",
            "priority": "P2",
            "created_at": "09/03/2026 12:15:01",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:58:55"
          },
          {
            "ticket_id": 11932,
            "ticket_number": "3511920",
            "title": "Pedido de Sinalização De Reserva 341498",
            "priority": "P2",
            "created_at": "09/03/2026 12:15:03",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:59:15"
          },
          {
            "ticket_id": 11933,
            "ticket_number": "3511921",
            "title": "Pedido de Sinalização De Reserva 341993",
            "priority": "P2",
            "created_at": "09/03/2026 12:15:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:59:27"
          },
          {
            "ticket_id": 11934,
            "ticket_number": "3511922",
            "title": "Pedido de Sinalização De Reserva 341311",
            "priority": "P2",
            "created_at": "09/03/2026 12:15:07",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:59:48"
          },
          {
            "ticket_id": 11939,
            "ticket_number": "3511927",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 13:53:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 23:43:21"
          },
          {
            "ticket_id": 11941,
            "ticket_number": "3511929",
            "title": "Criação de processo File 434428/26",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 13:54:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 23:43:22"
          },
          {
            "ticket_id": 11946,
            "ticket_number": "3511934",
            "title": "Reserva TRP- 2026-03745",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:20",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:54:20"
          },
          {
            "ticket_id": 11955,
            "ticket_number": "3511943",
            "title": "[Cancelamento Serviço] TRP-2026-02986 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/03/2026 14:06:20",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:06:20"
          },
          {
            "ticket_id": 11958,
            "ticket_number": "3511946",
            "title": "GBN-111008 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 15:34:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 11:24:18"
          },
          {
            "ticket_id": 11960,
            "ticket_number": "3511948",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 15:34:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 11:24:18"
          },
          {
            "ticket_id": 11962,
            "ticket_number": "3511950",
            "title": "Fwd: Informações da reserva TTN-1255840666#9527971",
            "priority": "P2",
            "created_at": "09/03/2026 15:35:03",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 15:35:04"
          },
          {
            "ticket_id": 11964,
            "ticket_number": "3511952",
            "title": "GBN-111019 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 15:37:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 15:37:01"
          },
          {
            "ticket_id": 11966,
            "ticket_number": "3511954",
            "title": "GBN-111008 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 15:37:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 11:24:18"
          },
          {
            "ticket_id": 11973,
            "ticket_number": "3511961",
            "title": "Informação de reserva - SPT002601604008",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 15:59:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 11:44:22"
          },
          {
            "ticket_id": 11984,
            "ticket_number": "3511972",
            "title": "Fiordes da Noruega em português",
            "priority": "P2",
            "created_at": "09/03/2026 19:04:38",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 19:06:42"
          },
          {
            "ticket_id": 11986,
            "ticket_number": "3511974",
            "title": "Documentação Disponível - Reserva 341959",
            "priority": "P2",
            "created_at": "09/03/2026 19:04:42",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 19:09:56"
          },
          {
            "ticket_id": 11987,
            "ticket_number": "3511975",
            "title": "GBN-111092 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 19:04:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 19:04:46"
          },
          {
            "ticket_id": 11988,
            "ticket_number": "3511976",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 19:04:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 15:00:02"
          },
          {
            "ticket_id": 11989,
            "ticket_number": "3511977",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604584391",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 19:04:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 15:00:02"
          },
          {
            "ticket_id": 11990,
            "ticket_number": "3511978",
            "title": "Confirmación de reserva 99124736",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 19:04:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 15:00:02"
          },
          {
            "ticket_id": 11991,
            "ticket_number": "3511979",
            "title": "FW: RESERVA | LOCALIZADOR  →  604569381",
            "priority": "P2",
            "created_at": "09/03/2026 19:05:01",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 19:05:02"
          },
          {
            "ticket_id": 11995,
            "ticket_number": "3511983",
            "title": "Reserva efetuada",
            "priority": "P2",
            "created_at": "09/03/2026 20:25:56",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 20:23:27"
          },
          {
            "ticket_id": 11996,
            "ticket_number": "3511984",
            "title": "CONFIRMACION: Ana Fidalgo / HOTEL OHTELS MAZAGON",
            "priority": "P2",
            "created_at": "09/03/2026 20:25:58",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 19.38,
            "sla_met": false,
            "sla_breach_hours": 15.38,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:49:25"
          },
          {
            "ticket_id": 12001,
            "ticket_number": "3511989",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604584830",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 20:26:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:20:15"
          },
          {
            "ticket_id": 12004,
            "ticket_number": "3511992",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "09/03/2026 20:26:18",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 20:26:18"
          },
          {
            "ticket_id": 12005,
            "ticket_number": "3511993",
            "title": "asunto",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 20:49:02",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 21:20:43"
          },
          {
            "ticket_id": 12007,
            "ticket_number": "3511995",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604585043",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 21:17:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 205.62,
            "sla_met": false,
            "sla_breach_hours": 181.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:54:17"
          },
          {
            "ticket_id": 12010,
            "ticket_number": "3511998",
            "title": "Número de informação da reserva: 6141108",
            "priority": "P2",
            "created_at": "09/03/2026 22:28:52",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 23:37:25"
          },
          {
            "ticket_id": 12011,
            "ticket_number": "3511999",
            "title": "TRP -2026-04173 - Smy + Insure",
            "priority": "P2",
            "created_at": "09/03/2026 22:28:54",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 22:28:54"
          },
          {
            "ticket_id": 12013,
            "ticket_number": "3512001",
            "title": "GBN-111174 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 23:33:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 23:33:32"
          },
          {
            "ticket_id": 12014,
            "ticket_number": "3512002",
            "title": "Número de informação da reserva: 6141116",
            "priority": "P2",
            "created_at": "09/03/2026 23:33:35",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 23:35:37"
          },
          {
            "ticket_id": 12015,
            "ticket_number": "3512003",
            "title": "GBN-111176 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/03/2026 23:37:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/03/2026 23:37:35"
          },
          {
            "ticket_id": 12021,
            "ticket_number": "3512009",
            "title": "Fwd: Documentação da reserva TTN-1145204664#682264",
            "priority": "P2",
            "created_at": "10/03/2026 10:07:51",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:07:51"
          },
          {
            "ticket_id": 12028,
            "ticket_number": "3512016",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "10/03/2026 10:08:11",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:08:12"
          },
          {
            "ticket_id": 12031,
            "ticket_number": "3512019",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604585229",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 10:11:51",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 14:01:39"
          },
          {
            "ticket_id": 12047,
            "ticket_number": "3512035",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60458547",
            "priority": "P2",
            "created_at": "10/03/2026 11:53:35",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:41:58"
          },
          {
            "ticket_id": 12049,
            "ticket_number": "3512037",
            "title": "Confirmação de reserva com localizador: 4113405",
            "priority": "P2",
            "created_at": "10/03/2026 11:54:04",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 13:09:02"
          },
          {
            "ticket_id": 12050,
            "ticket_number": "3512038",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604585334",
            "priority": "P2",
            "created_at": "10/03/2026 11:54:06",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:41:58"
          },
          {
            "ticket_id": 12058,
            "ticket_number": "3512046",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604585684",
            "priority": "P2",
            "created_at": "10/03/2026 12:48:14",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 16:42:08"
          },
          {
            "ticket_id": 12060,
            "ticket_number": "3512048",
            "title": "GBN-111260 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 12:48:21",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 12:48:21"
          },
          {
            "ticket_id": 12062,
            "ticket_number": "3512050",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "10/03/2026 15:48:52",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 18:54:33"
          },
          {
            "ticket_id": 12063,
            "ticket_number": "3512051",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "10/03/2026 15:48:54",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:57:16"
          },
          {
            "ticket_id": 12064,
            "ticket_number": "3512052",
            "title": "flores boat tours - parceria",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:14",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 18:51:24"
          },
          {
            "ticket_id": 12065,
            "ticket_number": "3512053",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604586017",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 15:49:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:42:27"
          },
          {
            "ticket_id": 12069,
            "ticket_number": "3512057",
            "title": "Reserva confirmada: Visita guiada pela adega Quint",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:27",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:53:19"
          },
          {
            "ticket_id": 12070,
            "ticket_number": "3512058",
            "title": "Criação de processo File 434645/26",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 15:49:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:42:27"
          },
          {
            "ticket_id": 12072,
            "ticket_number": "3512060",
            "title": "GBN-111286 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:44",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:49:44"
          },
          {
            "ticket_id": 12073,
            "ticket_number": "3512061",
            "title": "Reserva confirmada: Tour pelo Estádio do Benfica -",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:48",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:36:44"
          },
          {
            "ticket_id": 12074,
            "ticket_number": "3512062",
            "title": "Reserva confirmada: Ingresso do World of Discoveri",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:53",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:36:55"
          },
          {
            "ticket_id": 12075,
            "ticket_number": "3512063",
            "title": "Reserva confirmada: Ingresso do World of Discoveri",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:56",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:38:17"
          },
          {
            "ticket_id": 12076,
            "ticket_number": "3512064",
            "title": "Reserva confirmada: Ingresso do teleférico de Lisb",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:59",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:37:05"
          },
          {
            "ticket_id": 12077,
            "ticket_number": "3512065",
            "title": "Reserva confirmada: Visita guiada pela adega Quint",
            "priority": "P2",
            "created_at": "10/03/2026 15:50:02",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:37:26"
          },
          {
            "ticket_id": 12079,
            "ticket_number": "3512067",
            "title": "Reserva confirmada: Tour pelo Estádio do Benfica -",
            "priority": "P2",
            "created_at": "10/03/2026 15:50:08",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:38:07"
          },
          {
            "ticket_id": 12080,
            "ticket_number": "3512068",
            "title": "Reserva confirmada: Ingresso do teleférico de Lisb",
            "priority": "P2",
            "created_at": "10/03/2026 15:50:11",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:38:56"
          },
          {
            "ticket_id": 12084,
            "ticket_number": "3512072",
            "title": "Reserva confirmada: Ingresso do Oceanário de Lisbo",
            "priority": "P2",
            "created_at": "10/03/2026 16:07:58",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:38:37"
          },
          {
            "ticket_id": 12085,
            "ticket_number": "3512073",
            "title": "Reserva confirmada: Ingresso do Oceanário de Lisbo",
            "priority": "P2",
            "created_at": "10/03/2026 16:16:30",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:40:27"
          },
          {
            "ticket_id": 12091,
            "ticket_number": "3512079",
            "title": "Informação de reserva - SPT002601605188",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 17:16:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 13:02:42"
          },
          {
            "ticket_id": 12099,
            "ticket_number": "3512087",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60458515",
            "priority": "P2",
            "created_at": "10/03/2026 18:12:26",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 18:53:35"
          },
          {
            "ticket_id": 12109,
            "ticket_number": "3512097",
            "title": "GBN-111473 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 21:52:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 21:52:05"
          },
          {
            "ticket_id": 12110,
            "ticket_number": "3512098",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 21:52:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 17:43:26"
          },
          {
            "ticket_id": 12111,
            "ticket_number": "3512099",
            "title": "Confirmação de reserva com localizador: 4114963",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 21:52:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 17:43:26"
          },
          {
            "ticket_id": 12112,
            "ticket_number": "3512100",
            "title": "Reserva confirmada: Tour pelas praias da ilha Saon",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 21:52:11",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 17:43:26"
          },
          {
            "ticket_id": 12113,
            "ticket_number": "3512101",
            "title": "Reserva confirmada: Safári por Higüey e plantações",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 21:52:14",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 17:43:27"
          },
          {
            "ticket_id": 12118,
            "ticket_number": "3512106",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:33:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 22:33:12"
          },
          {
            "ticket_id": 12119,
            "ticket_number": "3512107",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604586794",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:33:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 19.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 18:23:32"
          },
          {
            "ticket_id": 12120,
            "ticket_number": "3512108",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:33:24",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 22:33:24"
          },
          {
            "ticket_id": 12121,
            "ticket_number": "3512109",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:33:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 22:33:35"
          },
          {
            "ticket_id": 12122,
            "ticket_number": "3512110",
            "title": "Confirmação de reserva com localizador: 4114990",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:33:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 18:23:32"
          },
          {
            "ticket_id": 12125,
            "ticket_number": "3512113",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:48:20",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 22:48:21"
          },
          {
            "ticket_id": 12127,
            "ticket_number": "3512115",
            "title": "GBN-111482 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 22:48:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 22:48:31"
          },
          {
            "ticket_id": 12128,
            "ticket_number": "3512116",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604586802",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 23:07:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 11.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 10:48:37"
          },
          {
            "ticket_id": 12129,
            "ticket_number": "3512117",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 23:07:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 19:03:44"
          },
          {
            "ticket_id": 12130,
            "ticket_number": "3512118",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 23:08:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/03/2026 23:08:26"
          },
          {
            "ticket_id": 12140,
            "ticket_number": "3512128",
            "title": "Confirmacao 342268",
            "priority": "Reservas sem Formulário",
            "created_at": "10/03/2026 23:45:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 19:43:54"
          },
          {
            "ticket_id": 12146,
            "ticket_number": "3512134",
            "title": "Enviando informações sobre sua reserva com o local",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 10:02:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 168.83,
            "sla_met": false,
            "sla_breach_hours": 144.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:52:27"
          },
          {
            "ticket_id": 12160,
            "ticket_number": "3512148",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 10:48:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 20:44:02"
          },
          {
            "ticket_id": 12167,
            "ticket_number": "3512155",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 11:35:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 12:40:26"
          },
          {
            "ticket_id": 12168,
            "ticket_number": "3512156",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 11:35:55",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 21:24:05"
          },
          {
            "ticket_id": 12172,
            "ticket_number": "3512160",
            "title": "GBN-111530 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:15:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 12:15:28"
          },
          {
            "ticket_id": 12174,
            "ticket_number": "3512162",
            "title": "Reserva confirmada: Ingresso do Palácio da Pena e ",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:40:21",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 366.62,
            "sla_met": false,
            "sla_breach_hours": 342.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 19:17:34"
          },
          {
            "ticket_id": 12178,
            "ticket_number": "3512166",
            "title": "Reserva confirmada: Ingresso do Palácio da Pena e ",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:40:32",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 364.53,
            "sla_met": false,
            "sla_breach_hours": 340.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:12:55"
          },
          {
            "ticket_id": 12179,
            "ticket_number": "3512167",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:53:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12180,
            "ticket_number": "3512168",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:53:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 12:53:09"
          },
          {
            "ticket_id": 12181,
            "ticket_number": "3512169",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:53:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 12:53:15"
          },
          {
            "ticket_id": 12182,
            "ticket_number": "3512170",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:53:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 12:53:20"
          },
          {
            "ticket_id": 12183,
            "ticket_number": "3512171",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 12:53:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12185,
            "ticket_number": "3512173",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:10:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 13:10:04"
          },
          {
            "ticket_id": 12188,
            "ticket_number": "3512176",
            "title": "GBN-111558 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:10:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 23:04:12"
          },
          {
            "ticket_id": 12190,
            "ticket_number": "3512178",
            "title": "Fwd: Viagify informa sobre a sua reserva 125854057",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:34:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 13:34:15"
          },
          {
            "ticket_id": 12191,
            "ticket_number": "3512179",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:34:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 13:34:20"
          },
          {
            "ticket_id": 12193,
            "ticket_number": "3512181",
            "title": "Reserva em WL 213397",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:34:33",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 364.17,
            "sla_met": false,
            "sla_breach_hours": 340.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:44:38"
          },
          {
            "ticket_id": 12198,
            "ticket_number": "3512186",
            "title": "GBN-111580 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:41:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 13:41:14"
          },
          {
            "ticket_id": 12201,
            "ticket_number": "3512189",
            "title": "GBN-111585 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 13:51:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 13:51:46"
          },
          {
            "ticket_id": 12206,
            "ticket_number": "3512194",
            "title": "GBN-111590 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 14:27:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 14:27:35"
          },
          {
            "ticket_id": 12207,
            "ticket_number": "3512195",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 14:27:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 14:27:40"
          },
          {
            "ticket_id": 12209,
            "ticket_number": "3512197",
            "title": "GBN-111589 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 14:27:57",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 14:27:57"
          },
          {
            "ticket_id": 12212,
            "ticket_number": "3512200",
            "title": "Criação de processo File 434808/26",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 15:18:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 163.55,
            "sla_met": false,
            "sla_breach_hours": 139.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:52:24"
          },
          {
            "ticket_id": 12214,
            "ticket_number": "3512202",
            "title": "GBN-111122 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:09",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:02:09"
          },
          {
            "ticket_id": 12215,
            "ticket_number": "3512203",
            "title": "GBN-111613 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:13",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:02:13"
          },
          {
            "ticket_id": 12218,
            "ticket_number": "3512206",
            "title": "GBN-111122 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:22",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 12:00:17"
          },
          {
            "ticket_id": 12219,
            "ticket_number": "3512207",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:02:26"
          },
          {
            "ticket_id": 12221,
            "ticket_number": "3512209",
            "title": "Fwd: Viagify informa sobre a sua reserva 125856751",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:02:38"
          },
          {
            "ticket_id": 12222,
            "ticket_number": "3512210",
            "title": "GBN-111484 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:40",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 12:00:17"
          },
          {
            "ticket_id": 12224,
            "ticket_number": "3512212",
            "title": "Fwd: Viagify informa sobre a sua reserva 125852068",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:02:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:02:48"
          },
          {
            "ticket_id": 12228,
            "ticket_number": "3512216",
            "title": "GBN-111630 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 16:38:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 16:38:47"
          },
          {
            "ticket_id": 12233,
            "ticket_number": "3512221",
            "title": "Fwd: Informações da sua reserva TTN-1258520683#957",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 17:25:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 17:25:30"
          },
          {
            "ticket_id": 12237,
            "ticket_number": "3512225",
            "title": "GBN-111666 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 17:45:07",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 313.25,
            "sla_met": false,
            "sla_breach_hours": 289.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 19:00:18"
          },
          {
            "ticket_id": 12239,
            "ticket_number": "3512227",
            "title": "Número de informação da reserva: 6141425",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 17:59:40",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 160.87,
            "sla_met": false,
            "sla_breach_hours": 136.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:52:23"
          },
          {
            "ticket_id": 12240,
            "ticket_number": "3512228",
            "title": "Confirmação de reserva – Ref PP137203, Sr. FABIO A",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 17:59:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 160.87,
            "sla_met": false,
            "sla_breach_hours": 136.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:52:23"
          },
          {
            "ticket_id": 12242,
            "ticket_number": "3512230",
            "title": "GBN-111008 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:08:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:00:34"
          },
          {
            "ticket_id": 12251,
            "ticket_number": "3512239",
            "title": "GBN-111684 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:19:19",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 312.63,
            "sla_met": false,
            "sla_breach_hours": 288.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:57:27"
          },
          {
            "ticket_id": 12252,
            "ticket_number": "3512240",
            "title": "GBN-111689 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:19:24",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 312.62,
            "sla_met": false,
            "sla_breach_hours": 288.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:56:41"
          },
          {
            "ticket_id": 12255,
            "ticket_number": "3512243",
            "title": "Flexible Autos - Automatic response",
            "priority": "P2",
            "created_at": "11/03/2026 18:25:46",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 19:45:32"
          },
          {
            "ticket_id": 12257,
            "ticket_number": "3512245",
            "title": "GBN-111692 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:25:54",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 312.5,
            "sla_met": false,
            "sla_breach_hours": 288.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:56:46"
          },
          {
            "ticket_id": 12259,
            "ticket_number": "3512247",
            "title": "Informação de reserva - SPT002601601307",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:31:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:20:37"
          },
          {
            "ticket_id": 12260,
            "ticket_number": "3512248",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:31:33",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.82,
            "sla_met": false,
            "sla_breach_hours": 19.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:20:37"
          },
          {
            "ticket_id": 12261,
            "ticket_number": "3512249",
            "title": "Confirmação de reserva – Ref PP148201, Sr. FABIO A",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:52:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:40:38"
          },
          {
            "ticket_id": 12262,
            "ticket_number": "3512250",
            "title": "GBN-111701 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:53:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 18:53:00"
          },
          {
            "ticket_id": 12264,
            "ticket_number": "3512252",
            "title": "Confirmation of booking with locatorEGTTWXWB",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:53:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:40:38"
          },
          {
            "ticket_id": 12265,
            "ticket_number": "3512253",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "11/03/2026 18:53:08",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:32:52"
          },
          {
            "ticket_id": 12266,
            "ticket_number": "3512254",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 18:53:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:40:38"
          },
          {
            "ticket_id": 12269,
            "ticket_number": "3512257",
            "title": "Confirmação de reserva – Ref PP247232, Sr. FABIO A",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 19:04:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 15:00:42"
          },
          {
            "ticket_id": 12274,
            "ticket_number": "3512262",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "11/03/2026 21:48:32",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:48:33"
          },
          {
            "ticket_id": 12276,
            "ticket_number": "3512264",
            "title": "Fwd: Viagify informa sobre a sua reserva 125872407",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:48:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:48:37"
          },
          {
            "ticket_id": 12278,
            "ticket_number": "3512266",
            "title": "Fwd: Viagify informa sobre a sua reserva 125872407",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:48:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:48:42"
          },
          {
            "ticket_id": 12281,
            "ticket_number": "3512269",
            "title": "cancelamento tour10",
            "priority": "P2",
            "created_at": "11/03/2026 21:48:48",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:34:16"
          },
          {
            "ticket_id": 12283,
            "ticket_number": "3512271",
            "title": "GBN-111764 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:00"
          },
          {
            "ticket_id": 12284,
            "ticket_number": "3512272",
            "title": "GBN-111774 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:05"
          },
          {
            "ticket_id": 12285,
            "ticket_number": "3512273",
            "title": "Localizador TRP-2026-03854",
            "priority": "P2",
            "created_at": "11/03/2026 21:49:07",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:49:08"
          },
          {
            "ticket_id": 12286,
            "ticket_number": "3512274",
            "title": "GBN-111769 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/03/2026 21:49:11",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:49:11"
          },
          {
            "ticket_id": 12287,
            "ticket_number": "3512275",
            "title": "GBN-111772 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:15"
          },
          {
            "ticket_id": 12288,
            "ticket_number": "3512276",
            "title": "GBN-111757 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:19"
          },
          {
            "ticket_id": 12289,
            "ticket_number": "3512277",
            "title": "Confirmação de reserva – Ref PP431412, Sr. RUI FER",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 17:41:08"
          },
          {
            "ticket_id": 12290,
            "ticket_number": "3512278",
            "title": "GBN-111765 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:25"
          },
          {
            "ticket_id": 12291,
            "ticket_number": "3512279",
            "title": "GBN-111760 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:30",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:31"
          },
          {
            "ticket_id": 12292,
            "ticket_number": "3512280",
            "title": "Fwd: Informações da reserva TTN-1255840666#9527971",
            "priority": "P2",
            "created_at": "11/03/2026 21:49:34",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:49:34"
          },
          {
            "ticket_id": 12294,
            "ticket_number": "3512282",
            "title": "FW: GRUP-21653 Cotización GRUP-21618 - FAMILIA EM ",
            "priority": "P2",
            "created_at": "11/03/2026 21:49:38",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:37:31"
          },
          {
            "ticket_id": 12295,
            "ticket_number": "3512283",
            "title": "Pedido Operador GBN",
            "priority": "P2",
            "created_at": "11/03/2026 21:49:40",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:49:41"
          },
          {
            "ticket_id": 12296,
            "ticket_number": "3512284",
            "title": "GBN-111725 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 21:49:44",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 21:49:44"
          },
          {
            "ticket_id": 12297,
            "ticket_number": "3512285",
            "title": "-",
            "priority": "P2",
            "created_at": "11/03/2026 22:16:07",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 22:16:07"
          },
          {
            "ticket_id": 12303,
            "ticket_number": "3512291",
            "title": "w2m.travel: Confirmación reserva 'Z6GV9L'",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 22:57:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 155.88,
            "sla_met": false,
            "sla_breach_hours": 131.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:38"
          },
          {
            "ticket_id": 12305,
            "ticket_number": "3512293",
            "title": "Vila Galé | Confirmação da Reserva Nº9095166",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 22:57:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 155.88,
            "sla_met": false,
            "sla_breach_hours": 131.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:38"
          },
          {
            "ticket_id": 12307,
            "ticket_number": "3512295",
            "title": "Dados acesso Veturis",
            "priority": "P2",
            "created_at": "11/03/2026 22:58:44",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 22:58:44"
          },
          {
            "ticket_id": 12319,
            "ticket_number": "3512307",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "11/03/2026 23:55:25",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 00:12:38"
          },
          {
            "ticket_id": 12320,
            "ticket_number": "3512308",
            "title": "GBN-111792 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/03/2026 23:55:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/03/2026 23:55:28"
          },
          {
            "ticket_id": 12321,
            "ticket_number": "3512309",
            "title": "Confirmação de reserva com localizador: 4117134",
            "priority": "P2",
            "created_at": "11/03/2026 23:55:31",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 00:13:21"
          },
          {
            "ticket_id": 12324,
            "ticket_number": "3512312",
            "title": "Booking Quote For PT004157 70882150",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:16",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 5.08,
            "sla_met": false,
            "sla_breach_hours": 1.08,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:01:56"
          },
          {
            "ticket_id": 12327,
            "ticket_number": "3512315",
            "title": "Número de informação da reserva: 6141482",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 09:56:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 144.92,
            "sla_met": false,
            "sla_breach_hours": 120.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:38"
          },
          {
            "ticket_id": 12334,
            "ticket_number": "3512322",
            "title": "GBN-111811 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/03/2026 11:29:36",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 11:29:36"
          },
          {
            "ticket_id": 12336,
            "ticket_number": "3512324",
            "title": "Fwd: Viagify informa sobre a sua reserva 125878097",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 11:29:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:29:44"
          },
          {
            "ticket_id": 12337,
            "ticket_number": "3512325",
            "title": "Fwd: Viagify informa sobre a sua reserva 125878097",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 11:29:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:29:47"
          },
          {
            "ticket_id": 12338,
            "ticket_number": "3512326",
            "title": "Fwd: Viagify informa sobre a sua reserva 125879151",
            "priority": "P2",
            "created_at": "12/03/2026 11:29:50",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 11:29:51"
          },
          {
            "ticket_id": 12340,
            "ticket_number": "3512328",
            "title": "Fwd: easyJet booking reference: KC8Z2NW",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 11:29:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:29:30"
          },
          {
            "ticket_id": 12341,
            "ticket_number": "3512329",
            "title": "Fwd: Viagify informa sobre a sua reserva 125879151",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 11:30:01",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:30:03"
          },
          {
            "ticket_id": 12342,
            "ticket_number": "3512330",
            "title": "Fwd: Viagify informa sobre a sua reserva 125881897",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 11:30:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 11:30:06"
          },
          {
            "ticket_id": 12343,
            "ticket_number": "3512331",
            "title": "Fwd: Request received for Daniela Rosa",
            "priority": "P2",
            "created_at": "12/03/2026 11:30:08",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 11:30:09"
          },
          {
            "ticket_id": 12344,
            "ticket_number": "3512332",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "12/03/2026 11:30:11",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 12:34:06"
          },
          {
            "ticket_id": 12350,
            "ticket_number": "3512338",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "12/03/2026 12:26:49",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 12:27:27"
          },
          {
            "ticket_id": 12355,
            "ticket_number": "3512343",
            "title": "Criação de processo File 434986/26",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 13:00:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 141.83,
            "sla_met": false,
            "sla_breach_hours": 117.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:36"
          },
          {
            "ticket_id": 12357,
            "ticket_number": "3512345",
            "title": "Confirmação de reserva para For PT004157 70882150",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 13:38:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 15:05:37"
          },
          {
            "ticket_id": 12358,
            "ticket_number": "3512346",
            "title": "Número de informação da reserva: 6141528",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 13:38:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 141.22,
            "sla_met": false,
            "sla_breach_hours": 117.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:36"
          },
          {
            "ticket_id": 12360,
            "ticket_number": "3512348",
            "title": "Confirmação de reserva para For PT004157 70882150",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 13:38:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 141.22,
            "sla_met": false,
            "sla_breach_hours": 117.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:36"
          },
          {
            "ticket_id": 12361,
            "ticket_number": "3512349",
            "title": "Criação de processo File 434988/26",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 13:38:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 141.22,
            "sla_met": false,
            "sla_breach_hours": 117.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:35"
          },
          {
            "ticket_id": 12363,
            "ticket_number": "3512351",
            "title": "Cancelamento de reserva 341997",
            "priority": "P2",
            "created_at": "12/03/2026 13:58:41",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 13:59:38"
          },
          {
            "ticket_id": 12364,
            "ticket_number": "3512352",
            "title": "Fwd: 1258520683 TTN-1258520683#95783092#T18450969¬",
            "priority": "P2",
            "created_at": "12/03/2026 14:04:39",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:04:39"
          },
          {
            "ticket_id": 12366,
            "ticket_number": "3512354",
            "title": "Confirmação de reserva – Ref PP136931, Sr. Dinis L",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 14:04:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 140.77,
            "sla_met": false,
            "sla_breach_hours": 116.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:35"
          },
          {
            "ticket_id": 12369,
            "ticket_number": "3512357",
            "title": "Criação de processo File 435009/26",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 14:58:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 139.88,
            "sla_met": false,
            "sla_breach_hours": 115.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:35"
          },
          {
            "ticket_id": 12370,
            "ticket_number": "3512358",
            "title": "Confirmação de reserva – Ref PP215172, Sr. FILIPE ",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 14:58:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 139.88,
            "sla_met": false,
            "sla_breach_hours": 115.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:35"
          },
          {
            "ticket_id": 12371,
            "ticket_number": "3512359",
            "title": "Fwd: Pedro, su reserva KBWRJV2: la hora de su vuel",
            "priority": "P2",
            "created_at": "12/03/2026 14:58:30",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:58:30"
          },
          {
            "ticket_id": 12373,
            "ticket_number": "3512361",
            "title": "Fwd: Reserva 1258780978 TTN-1258780978#95795600#T1",
            "priority": "P2",
            "created_at": "12/03/2026 14:58:35",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:58:35"
          },
          {
            "ticket_id": 12374,
            "ticket_number": "3512362",
            "title": "GBN-111903 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 14:59:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 14:59:25"
          },
          {
            "ticket_id": 12379,
            "ticket_number": "3512367",
            "title": "Informação de reserva - SPT002601595601",
            "priority": "P2",
            "created_at": "12/03/2026 16:05:41",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 16:16:03"
          },
          {
            "ticket_id": 12387,
            "ticket_number": "3512375",
            "title": "Confirmação de reserva com localizador: 4118464",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 17:41:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 137.15,
            "sla_met": false,
            "sla_breach_hours": 113.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12394,
            "ticket_number": "3512382",
            "title": "Envio de Nota de Crédito 27660/26",
            "priority": "P2",
            "created_at": "12/03/2026 18:15:35",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 18:50:47"
          },
          {
            "ticket_id": 12398,
            "ticket_number": "3512386",
            "title": "POZDNIAK HOFFMANN/ALA MRS 30MAR2026 LIS MAD",
            "priority": "P2",
            "created_at": "12/03/2026 18:19:04",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 13:34:45"
          },
          {
            "ticket_id": 12399,
            "ticket_number": "3512387",
            "title": "Documentação Disponível - Reserva 341217",
            "priority": "P2",
            "created_at": "12/03/2026 18:19:05",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:02:49"
          },
          {
            "ticket_id": 12400,
            "ticket_number": "3512388",
            "title": "Documentação Disponível - Reserva 341925",
            "priority": "P2",
            "created_at": "12/03/2026 18:19:07",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:02:53"
          },
          {
            "ticket_id": 12402,
            "ticket_number": "3512390",
            "title": "Documentação Disponível - Reserva 332333",
            "priority": "P2",
            "created_at": "12/03/2026 18:50:43",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:02:38"
          },
          {
            "ticket_id": 12407,
            "ticket_number": "3512395",
            "title": "Confirmacao 342473",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 19:11:51",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 42.82,
            "sla_met": false,
            "sla_breach_hours": 18.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 14:01:21"
          },
          {
            "ticket_id": 12408,
            "ticket_number": "3512396",
            "title": "Confirmacao 342471",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 19:11:52",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 42.82,
            "sla_met": false,
            "sla_breach_hours": 18.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 14:01:01"
          },
          {
            "ticket_id": 12416,
            "ticket_number": "3512404",
            "title": "Confirmation of booking with locatorAGCUWIY2",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 19:47:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 135.07,
            "sla_met": false,
            "sla_breach_hours": 111.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12417,
            "ticket_number": "3512405",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 20:16:02",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 134.58,
            "sla_met": false,
            "sla_breach_hours": 110.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12418,
            "ticket_number": "3512406",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 20:16:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 134.58,
            "sla_met": false,
            "sla_breach_hours": 110.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12419,
            "ticket_number": "3512407",
            "title": "Reserva confirmada: Ingresso da Torre Eiffel + Cru",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 20:16:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 134.58,
            "sla_met": false,
            "sla_breach_hours": 110.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12421,
            "ticket_number": "3512409",
            "title": "Reserva confirmada: Ingresso da Torre Eiffel + Cru",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 20:16:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 134.58,
            "sla_met": false,
            "sla_breach_hours": 110.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:34"
          },
          {
            "ticket_id": 12442,
            "ticket_number": "3512430",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 22:47:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 283.73,
            "sla_met": false,
            "sla_breach_hours": 259.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:02"
          },
          {
            "ticket_id": 12444,
            "ticket_number": "3512432",
            "title": "GBN-112046 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "12/03/2026 23:11:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/03/2026 23:11:57"
          },
          {
            "ticket_id": 12446,
            "ticket_number": "3512434",
            "title": "GBN-112057 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:05:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 10:05:27"
          },
          {
            "ticket_id": 12452,
            "ticket_number": "3512440",
            "title": "MSC Cruises Document - 2600101001904311",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:05:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 120.75,
            "sla_met": false,
            "sla_breach_hours": 96.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:33"
          },
          {
            "ticket_id": 12456,
            "ticket_number": "3512444",
            "title": "GBN-112045 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:05:56",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 272.43,
            "sla_met": false,
            "sla_breach_hours": 248.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:01"
          },
          {
            "ticket_id": 12457,
            "ticket_number": "3512445",
            "title": "GBN-112045 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:06:00",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 10:06:00"
          },
          {
            "ticket_id": 12458,
            "ticket_number": "3512446",
            "title": "Criação de processo File 435117/26",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:06:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 120.75,
            "sla_met": false,
            "sla_breach_hours": 96.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:33"
          },
          {
            "ticket_id": 12463,
            "ticket_number": "3512451",
            "title": "Criação de processo File 435113/26",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:06:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 120.75,
            "sla_met": false,
            "sla_breach_hours": 96.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:33"
          },
          {
            "ticket_id": 12465,
            "ticket_number": "3512453",
            "title": "Fwd: Viagify informa sobre a sua reserva 125723452",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:24:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 10:24:09"
          },
          {
            "ticket_id": 12467,
            "ticket_number": "3512455",
            "title": "Fwd: Viagify informa sobre a sua reserva 125912234",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:24:18",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 10:24:19"
          },
          {
            "ticket_id": 12468,
            "ticket_number": "3512456",
            "title": "Fwd: Viagify informa sobre a sua reserva 125738784",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:24:24",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 10:24:25"
          },
          {
            "ticket_id": 12473,
            "ticket_number": "3512461",
            "title": "Confirmação de reserva para For PT004157 70882150",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 10:38:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 120.2,
            "sla_met": false,
            "sla_breach_hours": 96.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:32"
          },
          {
            "ticket_id": 12483,
            "ticket_number": "3512471",
            "title": "GBN-112122 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 13:35:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 13:35:12"
          },
          {
            "ticket_id": 12484,
            "ticket_number": "3512472",
            "title": "Confirmação de reserva. Localizador: 87C965QZE6",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 13:59:09",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 27.77,
            "sla_met": false,
            "sla_breach_hours": 3.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:45:57"
          },
          {
            "ticket_id": 12485,
            "ticket_number": "3512473",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 8",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 13:59:12",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 27.48,
            "sla_met": false,
            "sla_breach_hours": 3.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:28:42"
          },
          {
            "ticket_id": 12488,
            "ticket_number": "3512476",
            "title": "GBN-112144 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 14:53:53",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 14:53:53"
          },
          {
            "ticket_id": 12490,
            "ticket_number": "3512478",
            "title": "Confirmação de reserva com localizador: 4120105",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 14:58:52",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 26.77,
            "sla_met": false,
            "sla_breach_hours": 2.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:45:45"
          },
          {
            "ticket_id": 12492,
            "ticket_number": "3512480",
            "title": "GBN-112158 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 15:07:26",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 15:07:26"
          },
          {
            "ticket_id": 12493,
            "ticket_number": "3512481",
            "title": "Confirmation of booking with locatorN8PCYG4A",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 15:07:51",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 26.13,
            "sla_met": false,
            "sla_breach_hours": 2.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:15:52"
          },
          {
            "ticket_id": 12497,
            "ticket_number": "3512485",
            "title": "Fwd: Viagify informa sobre a sua reserva 125931614",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 15:32:29",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 15:32:30"
          },
          {
            "ticket_id": 12500,
            "ticket_number": "3512488",
            "title": "Confirmação de reserva com localizador: 4120248",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:15:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 114.58,
            "sla_met": false,
            "sla_breach_hours": 90.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:32"
          },
          {
            "ticket_id": 12502,
            "ticket_number": "3512490",
            "title": "GBN-112172 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:15:40",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 16:15:40"
          },
          {
            "ticket_id": 12503,
            "ticket_number": "3512491",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604590473",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:15:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 114.58,
            "sla_met": false,
            "sla_breach_hours": 90.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:32"
          },
          {
            "ticket_id": 12504,
            "ticket_number": "3512492",
            "title": "Fwd: Viagify informa sobre a sua reserva 125933204",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:15:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 16:15:46"
          },
          {
            "ticket_id": 12505,
            "ticket_number": "3512493",
            "title": "Fwd: Viagify informa sobre a sua reserva 125933205",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:15:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 16:15:51"
          },
          {
            "ticket_id": 12507,
            "ticket_number": "3512495",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604590476",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:30:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 114.35,
            "sla_met": false,
            "sla_breach_hours": 90.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:31"
          },
          {
            "ticket_id": 12508,
            "ticket_number": "3512496",
            "title": "Confirmação da reserva nº 420777248",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:30:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 103.1,
            "sla_met": false,
            "sla_breach_hours": 79.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:45"
          },
          {
            "ticket_id": 12511,
            "ticket_number": "3512499",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:34:07",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.6,
            "sla_met": false,
            "sla_breach_hours": 0.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:10:21"
          },
          {
            "ticket_id": 12512,
            "ticket_number": "3512500",
            "title": "GBN-112199 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:34:11",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 16:34:11"
          },
          {
            "ticket_id": 12513,
            "ticket_number": "3512501",
            "title": "Cancelação da reserva com localizador 87C965QZE6",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:53:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 102.72,
            "sla_met": false,
            "sla_breach_hours": 78.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:45"
          },
          {
            "ticket_id": 12515,
            "ticket_number": "3512503",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:53:51",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:14:59"
          },
          {
            "ticket_id": 12516,
            "ticket_number": "3512504",
            "title": "Confirmação de reserva. Localizador: 7530EU4R7G",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:53:56",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:15:08"
          },
          {
            "ticket_id": 12517,
            "ticket_number": "3512505",
            "title": "Confirmacao 342550",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 16:53:58",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.17,
            "sla_met": false,
            "sla_breach_hours": 0.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:04:51"
          },
          {
            "ticket_id": 12521,
            "ticket_number": "3512509",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 17:24:56",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 23.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:12:43"
          },
          {
            "ticket_id": 12522,
            "ticket_number": "3512510",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 17:25:03",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 102.18,
            "sla_met": false,
            "sla_breach_hours": 78.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:45"
          },
          {
            "ticket_id": 12523,
            "ticket_number": "3512511",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 17:25:10",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 17:25:10"
          },
          {
            "ticket_id": 12530,
            "ticket_number": "3512518",
            "title": "GBN-109804 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/03/2026 18:17:31",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 19:37:29"
          },
          {
            "ticket_id": 12534,
            "ticket_number": "3512522",
            "title": "RE: Pagamento 413248",
            "priority": "P2",
            "created_at": "13/03/2026 19:22:27",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:21:52"
          },
          {
            "ticket_id": 12535,
            "ticket_number": "3512523",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 19:22:34",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 21.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:11:32"
          },
          {
            "ticket_id": 12536,
            "ticket_number": "3512524",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 19:24:27",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 21.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:11:51"
          },
          {
            "ticket_id": 12539,
            "ticket_number": "3512527",
            "title": "-",
            "priority": "P2",
            "created_at": "13/03/2026 20:13:01",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 20:13:02"
          },
          {
            "ticket_id": 12540,
            "ticket_number": "3512528",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 20:13:08",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 21.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 17:13:26"
          },
          {
            "ticket_id": 12545,
            "ticket_number": "3512533",
            "title": "GBN-112332 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:12:16",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:12:16"
          },
          {
            "ticket_id": 12546,
            "ticket_number": "3512534",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:12:24",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:12:24"
          },
          {
            "ticket_id": 12547,
            "ticket_number": "3512535",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:12:33",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:12:33"
          },
          {
            "ticket_id": 12548,
            "ticket_number": "3512536",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:12:40",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:12:41"
          },
          {
            "ticket_id": 12549,
            "ticket_number": "3512537",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:12:48",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:12:49"
          },
          {
            "ticket_id": 12551,
            "ticket_number": "3512539",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 21:13:08",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 21:13:08"
          },
          {
            "ticket_id": 12555,
            "ticket_number": "3512543",
            "title": "Fwd: Informações da reserva TTN-1259316145#9602549",
            "priority": "P2",
            "created_at": "13/03/2026 23:25:58",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:25:59"
          },
          {
            "ticket_id": 12556,
            "ticket_number": "3512544",
            "title": "Fwd: Informações da reserva TTN-1258520683#9585404",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:02",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:26:03"
          },
          {
            "ticket_id": 12558,
            "ticket_number": "3512546",
            "title": "Fwd: Informações da reserva TTN-1258520683#9603448",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:08",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:26:08"
          },
          {
            "ticket_id": 12559,
            "ticket_number": "3512547",
            "title": "GBN-112347 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 23:26:11",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 23:26:11"
          },
          {
            "ticket_id": 12561,
            "ticket_number": "3512549",
            "title": "GBN-112344 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 23:26:21",
            "close_date": "2026-03-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 23:26:21"
          },
          {
            "ticket_id": 12562,
            "ticket_number": "3512550",
            "title": "GBN-112346 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 23:26:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/03/2026 23:26:25"
          },
          {
            "ticket_id": 12567,
            "ticket_number": "3512555",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604591064",
            "priority": "Reservas sem Formulário",
            "created_at": "13/03/2026 23:57:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 15:44:53"
          },
          {
            "ticket_id": 12571,
            "ticket_number": "3512559",
            "title": "GBN-112364 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "14/03/2026 10:10:32",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 10:10:32"
          },
          {
            "ticket_id": 12584,
            "ticket_number": "3512572",
            "title": "Número de informação da reserva: 6141876",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 11:58:38",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 83.63,
            "sla_met": false,
            "sla_breach_hours": 59.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:45"
          },
          {
            "ticket_id": 12589,
            "ticket_number": "3512577",
            "title": "GBN-112383 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 12:57:43",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 12:57:43"
          },
          {
            "ticket_id": 12593,
            "ticket_number": "3512581",
            "title": "GBN-112395 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 13:21:19",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 13:21:19"
          },
          {
            "ticket_id": 12601,
            "ticket_number": "3512589",
            "title": "GBN-112414 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 15:55:37",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 53.75,
            "sla_met": false,
            "sla_breach_hours": 29.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 21:40:54"
          },
          {
            "ticket_id": 12602,
            "ticket_number": "3512590",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604591273",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 15:55:40",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 53.75,
            "sla_met": false,
            "sla_breach_hours": 29.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 21:40:54"
          },
          {
            "ticket_id": 12603,
            "ticket_number": "3512591",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 15:55:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 53.75,
            "sla_met": false,
            "sla_breach_hours": 29.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 21:40:54"
          },
          {
            "ticket_id": 12604,
            "ticket_number": "3512592",
            "title": "Fwd: Viagify informa sobre a sua reserva 125956974",
            "priority": "P2",
            "created_at": "14/03/2026 15:56:02",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 15:56:03"
          },
          {
            "ticket_id": 12605,
            "ticket_number": "3512593",
            "title": "Número de informação da reserva: 6141939",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 16:14:04",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 53.77,
            "sla_met": false,
            "sla_breach_hours": 29.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 22:00:58"
          },
          {
            "ticket_id": 12608,
            "ticket_number": "3512596",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604591308",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 16:37:37",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 78.98,
            "sla_met": false,
            "sla_breach_hours": 54.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:43"
          },
          {
            "ticket_id": 12610,
            "ticket_number": "3512598",
            "title": "Número de informação da reserva: 6141968",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 16:41:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 22:41:01"
          },
          {
            "ticket_id": 12612,
            "ticket_number": "3512600",
            "title": "Confirmação de reserva. Localizador: 1N3J99F4CM",
            "priority": "P2",
            "created_at": "14/03/2026 18:05:45",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 18:24:04"
          },
          {
            "ticket_id": 12613,
            "ticket_number": "3512601",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "14/03/2026 18:05:48",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 18:24:11"
          },
          {
            "ticket_id": 12614,
            "ticket_number": "3512602",
            "title": "GBN-112438 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 18:48:48",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 18:48:48"
          },
          {
            "ticket_id": 12615,
            "ticket_number": "3512603",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 18:59:54",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 18:59:54"
          },
          {
            "ticket_id": 12616,
            "ticket_number": "3512604",
            "title": "GBN-112440 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/03/2026 19:00:01",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/03/2026 19:00:02"
          },
          {
            "ticket_id": 12621,
            "ticket_number": "3512609",
            "title": "[Suporte] TRP-2026-03869 - Pedido emissão fatura",
            "priority": "P2",
            "created_at": "15/03/2026 20:48:16",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 20:48:16"
          },
          {
            "ticket_id": 12622,
            "ticket_number": "3512610",
            "title": "[Suporte] TRP-2026-03592 - Pedido emissão fatura",
            "priority": "P2",
            "created_at": "15/03/2026 20:49:35",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 20:49:35"
          },
          {
            "ticket_id": 12624,
            "ticket_number": "3512612",
            "title": "Número de informação da reserva: 6142254",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:06:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12626,
            "ticket_number": "3512614",
            "title": "Informação importante sobre a tua reserva 6126623",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:31",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 12:23:13"
          },
          {
            "ticket_id": 12632,
            "ticket_number": "3512620",
            "title": "GBN-112547 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:06:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 10:06:44"
          },
          {
            "ticket_id": 12636,
            "ticket_number": "3512624",
            "title": "Amanhã será realizada a cobrança da reserva A37202",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:53",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:31:20"
          },
          {
            "ticket_id": 12642,
            "ticket_number": "3512630",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:09",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:09"
          },
          {
            "ticket_id": 12646,
            "ticket_number": "3512634",
            "title": "Informação de reserva - SPT002601608268",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:24",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12647,
            "ticket_number": "3512635",
            "title": "Confirmação de reserva com localizador: 4122135",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:26",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12648,
            "ticket_number": "3512636",
            "title": "Fwd: Quote reminder 73824523",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:28",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:28"
          },
          {
            "ticket_id": 12649,
            "ticket_number": "3512637",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:30",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:30"
          },
          {
            "ticket_id": 12650,
            "ticket_number": "3512638",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:32",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:32"
          },
          {
            "ticket_id": 12651,
            "ticket_number": "3512639",
            "title": "Número de informação da reserva: 6142210",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:36",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12652,
            "ticket_number": "3512640",
            "title": "Número de informação da reserva: 6142207",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:39",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12653,
            "ticket_number": "3512641",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:42",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:43"
          },
          {
            "ticket_id": 12654,
            "ticket_number": "3512642",
            "title": "Número de informação da reserva: 6142204",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12655,
            "ticket_number": "3512643",
            "title": "Número de informação da reserva: 6142205",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:49",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12656,
            "ticket_number": "3512644",
            "title": "Número de informação da reserva: 6142188",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:07:51",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:41"
          },
          {
            "ticket_id": 12660,
            "ticket_number": "3512648",
            "title": "Número de informação da reserva: 6142153",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:08:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:42"
          },
          {
            "ticket_id": 12661,
            "ticket_number": "3512649",
            "title": "Número de informação da reserva: 6142145",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:08:20",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12662,
            "ticket_number": "3512650",
            "title": "Confirmacao 342641",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:08:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12663,
            "ticket_number": "3512651",
            "title": "Grupo GR-280A5ADE87",
            "priority": "P2",
            "created_at": "16/03/2026 10:08:24",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:02:02"
          },
          {
            "ticket_id": 12665,
            "ticket_number": "3512653",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604591547",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:08:55",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12666,
            "ticket_number": "3512654",
            "title": "Informação de reserva - SPT002601608022",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:03",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12667,
            "ticket_number": "3512655",
            "title": "Número de informação da reserva: 6142129",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:06",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12669,
            "ticket_number": "3512657",
            "title": "Número de informação da reserva: 6142131",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:10",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12670,
            "ticket_number": "3512658",
            "title": "Confirmacao 342637",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:13",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12671,
            "ticket_number": "3512659",
            "title": "Número de informação da reserva: 6142202",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:43"
          },
          {
            "ticket_id": 12672,
            "ticket_number": "3512660",
            "title": "Confirmacao 342635",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:18",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:44"
          },
          {
            "ticket_id": 12673,
            "ticket_number": "3512661",
            "title": "Criação de processo File 435446/26",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:23",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:44"
          },
          {
            "ticket_id": 12676,
            "ticket_number": "3512664",
            "title": "Número de informação da reserva: 6142077",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:29",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:44"
          },
          {
            "ticket_id": 12677,
            "ticket_number": "3512665",
            "title": "Informação de reserva - SPT002601607921",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:38",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12679,
            "ticket_number": "3512667",
            "title": "Información de reserva número: 1780930",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:43",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12680,
            "ticket_number": "3512668",
            "title": "REMINDER: Dados de Passaporte - nosso File 423949",
            "priority": "P2",
            "created_at": "16/03/2026 10:09:44",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12686,
            "ticket_number": "3512674",
            "title": "MSC Cruises Document - 2600101001957266",
            "priority": "P2",
            "created_at": "16/03/2026 10:09:56",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12687,
            "ticket_number": "3512675",
            "title": "GBN-112474 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:09:59",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 10:09:59"
          },
          {
            "ticket_id": 12688,
            "ticket_number": "3512676",
            "title": "GBN-112473 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:03",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 10:10:03"
          },
          {
            "ticket_id": 12689,
            "ticket_number": "3512677",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:06",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:45"
          },
          {
            "ticket_id": 12691,
            "ticket_number": "3512679",
            "title": "GBN-112456 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:11",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 10:10:11"
          },
          {
            "ticket_id": 12692,
            "ticket_number": "3512680",
            "title": "GBN-112453 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 10:10:16"
          },
          {
            "ticket_id": 12693,
            "ticket_number": "3512681",
            "title": "Número de informação da reserva: 6142020",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:45"
          },
          {
            "ticket_id": 12694,
            "ticket_number": "3512682",
            "title": "Confirmação de reserva com localizador: 4121644",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:21",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:45"
          },
          {
            "ticket_id": 12696,
            "ticket_number": "3512684",
            "title": "Número de informação da reserva: 6142012",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:26",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 14:04:37"
          },
          {
            "ticket_id": 12697,
            "ticket_number": "3512685",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604591378",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:28",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:45"
          },
          {
            "ticket_id": 12698,
            "ticket_number": "3512686",
            "title": "Confirmação de reserva com localizador: 4121631",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:29",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 37.43,
            "sla_met": false,
            "sla_breach_hours": 13.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:37"
          },
          {
            "ticket_id": 12699,
            "ticket_number": "3512687",
            "title": "Confirmação de reserva com localizador: 4121638",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:10:31",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 37.43,
            "sla_met": false,
            "sla_breach_hours": 13.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:37"
          },
          {
            "ticket_id": 12700,
            "ticket_number": "3512688",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:11:02",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 37.42,
            "sla_met": false,
            "sla_breach_hours": 13.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:37"
          },
          {
            "ticket_id": 12701,
            "ticket_number": "3512689",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:11:06",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 37.42,
            "sla_met": false,
            "sla_breach_hours": 13.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:37"
          },
          {
            "ticket_id": 12702,
            "ticket_number": "3512690",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 10:11:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 37.42,
            "sla_met": false,
            "sla_breach_hours": 13.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:36:36"
          },
          {
            "ticket_id": 12705,
            "ticket_number": "3512693",
            "title": "Informação de reserva - SPT002601607921",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:05:30",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:04:13"
          },
          {
            "ticket_id": 12711,
            "ticket_number": "3512699",
            "title": "GBN-112576 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:05:51",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 13:05:51"
          },
          {
            "ticket_id": 12715,
            "ticket_number": "3512703",
            "title": "Número de informação da reserva: 6142286",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:06:06",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:04:13"
          },
          {
            "ticket_id": 12719,
            "ticket_number": "3512707",
            "title": "Informação de reserva - SPT002601608268",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:06:59",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:04:13"
          },
          {
            "ticket_id": 12725,
            "ticket_number": "3512713",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604590473",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:22:57",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 34.18,
            "sla_met": false,
            "sla_breach_hours": 10.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:31"
          },
          {
            "ticket_id": 12729,
            "ticket_number": "3512717",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 13:34:20",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:24:16"
          },
          {
            "ticket_id": 12730,
            "ticket_number": "3512718",
            "title": "Informação de reserva - SPT002601600850",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 14:06:40",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.45,
            "sla_met": false,
            "sla_breach_hours": 9.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:31"
          },
          {
            "ticket_id": 12731,
            "ticket_number": "3512719",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 14:06:47",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.45,
            "sla_met": false,
            "sla_breach_hours": 9.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:31"
          },
          {
            "ticket_id": 12736,
            "ticket_number": "3512724",
            "title": "Reserva em WL 213621",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 14:07:14",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.45,
            "sla_met": false,
            "sla_breach_hours": 9.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12741,
            "ticket_number": "3512729",
            "title": "Informação de reserva - SPT002601577518",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 14:34:58",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 32.98,
            "sla_met": false,
            "sla_breach_hours": 8.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12742,
            "ticket_number": "3512730",
            "title": "Informação de reserva - SPT002601598765",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 14:42:50",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 32.85,
            "sla_met": false,
            "sla_breach_hours": 8.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12743,
            "ticket_number": "3512731",
            "title": "Informação de reserva - SPT002601596418",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 15:09:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 32.42,
            "sla_met": false,
            "sla_breach_hours": 8.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12744,
            "ticket_number": "3512732",
            "title": "Informação de reserva - SPT002601571772",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 15:09:33",
            "close_date": "2026-05-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1413.53,
            "sla_met": false,
            "sla_breach_hours": 1389.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/05/2026 12:41:44"
          },
          {
            "ticket_id": 12745,
            "ticket_number": "3512733",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 15:09:40",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 32.4,
            "sla_met": false,
            "sla_breach_hours": 8.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12746,
            "ticket_number": "3512734",
            "title": "pedido no Consolidador",
            "priority": "P2",
            "created_at": "16/03/2026 15:09:49",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 15:09:49"
          },
          {
            "ticket_id": 12749,
            "ticket_number": "3512737",
            "title": "Informação de reserva - SPT002601608022",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 15:37:05",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 31.95,
            "sla_met": false,
            "sla_breach_hours": 7.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:30"
          },
          {
            "ticket_id": 12752,
            "ticket_number": "3512740",
            "title": "X7NZLG – Alteração de horario/nº de voo - ALERTA",
            "priority": "P2",
            "created_at": "16/03/2026 15:37:22",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:20:47"
          },
          {
            "ticket_id": 12753,
            "ticket_number": "3512741",
            "title": "Número de informação da reserva: 6142343",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 15:37:27",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 96.87,
            "sla_met": false,
            "sla_breach_hours": 72.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:01"
          },
          {
            "ticket_id": 12755,
            "ticket_number": "3512743",
            "title": "Informação de reserva - SPT002601599125",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:15:33",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 31.3,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:29"
          },
          {
            "ticket_id": 12756,
            "ticket_number": "3512744",
            "title": "Informação de reserva - SPT002601597683",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:15:39",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 31.3,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:29"
          },
          {
            "ticket_id": 12757,
            "ticket_number": "3512745",
            "title": "Envio de Documentação * File 423949",
            "priority": "P2",
            "created_at": "16/03/2026 16:15:53",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:48:39"
          },
          {
            "ticket_id": 12758,
            "ticket_number": "3512746",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604590473",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:15:56",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 31.3,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:29"
          },
          {
            "ticket_id": 12760,
            "ticket_number": "3512748",
            "title": "Informação de reserva - SPT002601566676",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:38:37",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.92,
            "sla_met": false,
            "sla_breach_hours": 6.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:29"
          },
          {
            "ticket_id": 12761,
            "ticket_number": "3512749",
            "title": "Informação de reserva - SPT002501553355",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:38:43",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.92,
            "sla_met": false,
            "sla_breach_hours": 6.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:29"
          },
          {
            "ticket_id": 12762,
            "ticket_number": "3512750",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "16/03/2026 16:38:45",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 16:38:45"
          },
          {
            "ticket_id": 12763,
            "ticket_number": "3512751",
            "title": "Informação de reserva - SPT002601592868",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:38:50",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.92,
            "sla_met": false,
            "sla_breach_hours": 6.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:28"
          },
          {
            "ticket_id": 12764,
            "ticket_number": "3512752",
            "title": "Informação de reserva - SPT002501553935",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 16:38:57",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.92,
            "sla_met": false,
            "sla_breach_hours": 6.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:28"
          },
          {
            "ticket_id": 12765,
            "ticket_number": "3512753",
            "title": "Informação de reserva - SPT002601605188",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:17",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.47,
            "sla_met": false,
            "sla_breach_hours": 6.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:28"
          },
          {
            "ticket_id": 12766,
            "ticket_number": "3512754",
            "title": "Informação de reserva - SPT002601572369",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:23",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.47,
            "sla_met": false,
            "sla_breach_hours": 6.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:28"
          },
          {
            "ticket_id": 12767,
            "ticket_number": "3512755",
            "title": "RESERVA LEPLAN LOCALIZADOR 604497323 - CONTACTO CL",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.47,
            "sla_met": false,
            "sla_breach_hours": 6.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:28"
          },
          {
            "ticket_id": 12768,
            "ticket_number": "3512756",
            "title": "GBN-112690 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:29",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 17:06:29"
          },
          {
            "ticket_id": 12769,
            "ticket_number": "3512757",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:38",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.45,
            "sla_met": false,
            "sla_breach_hours": 6.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:27"
          },
          {
            "ticket_id": 12770,
            "ticket_number": "3512758",
            "title": "Informação de reserva - SPT002601607921",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 17:06:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 30.45,
            "sla_met": false,
            "sla_breach_hours": 6.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:27"
          },
          {
            "ticket_id": 12771,
            "ticket_number": "3512759",
            "title": "Revista CruisesNews nº76 - Marzo 2026",
            "priority": "P2",
            "created_at": "16/03/2026 17:06:49",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:27:01"
          },
          {
            "ticket_id": 12773,
            "ticket_number": "3512761",
            "title": "Informação de reserva - SPT002601603914",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 18:50:06",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 28.73,
            "sla_met": false,
            "sla_breach_hours": 4.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:27"
          },
          {
            "ticket_id": 12774,
            "ticket_number": "3512762",
            "title": "Fwd: Viagify informa sobre a sua reserva 126026022",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 18:50:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 18:50:09"
          },
          {
            "ticket_id": 12777,
            "ticket_number": "3512765",
            "title": "Informação de reserva - SPT002601572357",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 18:50:21",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 28.73,
            "sla_met": false,
            "sla_breach_hours": 4.73,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:27"
          },
          {
            "ticket_id": 12782,
            "ticket_number": "3512770",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 18:53:12",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 28.68,
            "sla_met": false,
            "sla_breach_hours": 4.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:26"
          },
          {
            "ticket_id": 12795,
            "ticket_number": "3512783",
            "title": "GBN-112795 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 21:51:16"
          },
          {
            "ticket_id": 12796,
            "ticket_number": "3512784",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:20",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.72,
            "sla_met": false,
            "sla_breach_hours": 1.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:26"
          },
          {
            "ticket_id": 12797,
            "ticket_number": "3512785",
            "title": "Confirmação de reserva – Ref PP683825, Sr. FABIO A",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.72,
            "sla_met": false,
            "sla_breach_hours": 1.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:26"
          },
          {
            "ticket_id": 12798,
            "ticket_number": "3512786",
            "title": "Criação de processo File 435715/26",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:28",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.7,
            "sla_met": false,
            "sla_breach_hours": 1.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:26"
          },
          {
            "ticket_id": 12799,
            "ticket_number": "3512787",
            "title": "Confirmação de reserva – Ref PP213166, Sr. FABIO A",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:30",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.7,
            "sla_met": false,
            "sla_breach_hours": 1.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:26"
          },
          {
            "ticket_id": 12800,
            "ticket_number": "3512788",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:34",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.7,
            "sla_met": false,
            "sla_breach_hours": 1.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:25"
          },
          {
            "ticket_id": 12801,
            "ticket_number": "3512789",
            "title": "GBN-112793 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 21:51:36",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 21:51:36"
          },
          {
            "ticket_id": 12804,
            "ticket_number": "3512792",
            "title": "Número de informação da reserva: 6142517",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 22:12:02",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.37,
            "sla_met": false,
            "sla_breach_hours": 1.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:25"
          },
          {
            "ticket_id": 12812,
            "ticket_number": "3512800",
            "title": "GBN-112797 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:25",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:43:25"
          },
          {
            "ticket_id": 12814,
            "ticket_number": "3512802",
            "title": "GBN-112613 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/03/2026 23:43:34",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/03/2026 23:43:34"
          },
          {
            "ticket_id": 12815,
            "ticket_number": "3512803",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604593446",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:37",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:47:55"
          },
          {
            "ticket_id": 12816,
            "ticket_number": "3512804",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604593453",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:40",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:48:01"
          },
          {
            "ticket_id": 12834,
            "ticket_number": "3512822",
            "title": "Criação de processo File 435737/26",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 10:09:41",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 13.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:25"
          },
          {
            "ticket_id": 12851,
            "ticket_number": "3512839",
            "title": "GBN-112845 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 11:53:56",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 11:53:56"
          },
          {
            "ticket_id": 12852,
            "ticket_number": "3512840",
            "title": "GBN-112850 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 11:58:58",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 11:58:58"
          },
          {
            "ticket_id": 12858,
            "ticket_number": "3512846",
            "title": "Número de informação da reserva: 6142572",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 12:35:51",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 10.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:24"
          },
          {
            "ticket_id": 12860,
            "ticket_number": "3512848",
            "title": "Informação de reserva - SPT002601609155",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 12:58:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 10.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:24"
          },
          {
            "ticket_id": 12868,
            "ticket_number": "3512856",
            "title": "Confirmação de reserva com localizador: 4125340",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 13:49:57",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 17:43:00"
          },
          {
            "ticket_id": 12872,
            "ticket_number": "3512860",
            "title": "Reserva cancelada com localizador: 4125340",
            "priority": "P2",
            "created_at": "17/03/2026 14:50:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:08:11"
          },
          {
            "ticket_id": 12873,
            "ticket_number": "3512861",
            "title": "Criação de processo File 435797/26",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 14:50:55",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 8.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:24"
          },
          {
            "ticket_id": 12879,
            "ticket_number": "3512867",
            "title": "Reserva Aéreo [ERROR_AIR-A449853607] - Erro Técnic",
            "priority": "P2",
            "created_at": "17/03/2026 16:13:51",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:11:55"
          },
          {
            "ticket_id": 12881,
            "ticket_number": "3512869",
            "title": "Reserva Aéreo [ERROR_AIR-0FD934A4AC] - Erro Técnic",
            "priority": "P1",
            "created_at": "17/03/2026 16:13:56",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.98,
            "sla_met": false,
            "sla_breach_hours": 0.73,
            "sla_name": "SLA P1",
            "first_response_at": "17/03/2026 17:13:12"
          },
          {
            "ticket_id": 12882,
            "ticket_number": "3512870",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "17/03/2026 16:14:03",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:23:57"
          },
          {
            "ticket_id": 12883,
            "ticket_number": "3512871",
            "title": "Confirmação de reserva 342760",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 16:14:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 18.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:31"
          },
          {
            "ticket_id": 12885,
            "ticket_number": "3512873",
            "title": "Reserva pagada",
            "priority": "P2",
            "created_at": "17/03/2026 16:14:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:06:31"
          },
          {
            "ticket_id": 12886,
            "ticket_number": "3512874",
            "title": "GBN-112936 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 16:14:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 16:14:12"
          },
          {
            "ticket_id": 12889,
            "ticket_number": "3512877",
            "title": "Número de informação da reserva: 6142624",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 16:20:47",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 7.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:24"
          },
          {
            "ticket_id": 12892,
            "ticket_number": "3512880",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "P2",
            "created_at": "17/03/2026 16:45:54",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 17:06:07"
          },
          {
            "ticket_id": 12896,
            "ticket_number": "3512884",
            "title": "Informações da reserva - SPT002601609316",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:03:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 19.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 13:10:40"
          },
          {
            "ticket_id": 12897,
            "ticket_number": "3512885",
            "title": "Fwd: Viagify informa sobre a sua reserva 125786329",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:03:45",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 18:03:45"
          },
          {
            "ticket_id": 12898,
            "ticket_number": "3512886",
            "title": "Informações da reserva - SPT002601609345",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:03:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 19.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 13:10:40"
          },
          {
            "ticket_id": 12899,
            "ticket_number": "3512887",
            "title": "Fwd: Viagify informa sobre a sua reserva 125737401",
            "priority": "P2",
            "created_at": "17/03/2026 18:03:58",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:03:59"
          },
          {
            "ticket_id": 12900,
            "ticket_number": "3512888",
            "title": "Fwd: Viagify informa sobre a sua reserva 125809197",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:04:01",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 18:04:02"
          },
          {
            "ticket_id": 12901,
            "ticket_number": "3512889",
            "title": "Fwd: Viagify informa sobre a sua reserva 125826751",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:04:05",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 18:04:06"
          },
          {
            "ticket_id": 12902,
            "ticket_number": "3512890",
            "title": "Fwd: Viagify informa sobre a sua reserva 125814806",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:04:10",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 18:04:11"
          },
          {
            "ticket_id": 12904,
            "ticket_number": "3512892",
            "title": "Envio de documentos de File 425077/26",
            "priority": "P2",
            "created_at": "17/03/2026 18:04:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 19:08:30"
          },
          {
            "ticket_id": 12905,
            "ticket_number": "3512893",
            "title": "Envio de Fatura 213641",
            "priority": "P2",
            "created_at": "17/03/2026 18:04:18",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:05:04"
          },
          {
            "ticket_id": 12906,
            "ticket_number": "3512894",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:04:27",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 67.92,
            "sla_met": false,
            "sla_breach_hours": 43.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 14:00:09"
          },
          {
            "ticket_id": 12907,
            "ticket_number": "3512895",
            "title": "GBN-112991 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 18:04:37",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 18:04:37"
          },
          {
            "ticket_id": 12911,
            "ticket_number": "3512899",
            "title": "Reservas SPT002601608666 + SPT002601608686 - anula",
            "priority": "P2",
            "created_at": "17/03/2026 18:28:50",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:35:52"
          },
          {
            "ticket_id": 12913,
            "ticket_number": "3512901",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "17/03/2026 18:29:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:42:47"
          },
          {
            "ticket_id": 12917,
            "ticket_number": "3512905",
            "title": "Confirmacao 342804",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 19:35:12",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:34:23"
          },
          {
            "ticket_id": 12918,
            "ticket_number": "3512906",
            "title": "GBN-112955 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/03/2026 20:03:19",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 22:31:46"
          },
          {
            "ticket_id": 12919,
            "ticket_number": "3512907",
            "title": "GBN-113034 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 20:03:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 20:03:22"
          },
          {
            "ticket_id": 12923,
            "ticket_number": "3512911",
            "title": "Confirmação de reserva com localizador: 4126460",
            "priority": "P2",
            "created_at": "17/03/2026 22:04:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 22:05:43"
          },
          {
            "ticket_id": 12928,
            "ticket_number": "3512916",
            "title": "GBN-113062 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/03/2026 23:35:00",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/03/2026 23:35:00"
          },
          {
            "ticket_id": 12935,
            "ticket_number": "3512923",
            "title": "GBN-111725 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/03/2026 10:09:54",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:20:23"
          },
          {
            "ticket_id": 12936,
            "ticket_number": "3512924",
            "title": "Informação importante sobre a tua reserva 1778053",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:09:56",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:30"
          },
          {
            "ticket_id": 12939,
            "ticket_number": "3512927",
            "title": "GBN-93891 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/03/2026 10:10:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:20:23"
          },
          {
            "ticket_id": 12941,
            "ticket_number": "3512929",
            "title": "GBN-104290 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:09",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 198.97,
            "sla_met": false,
            "sla_breach_hours": 174.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:08:45"
          },
          {
            "ticket_id": 12942,
            "ticket_number": "3512930",
            "title": "GBN-111701 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/03/2026 10:10:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:19:37"
          },
          {
            "ticket_id": 12943,
            "ticket_number": "3512931",
            "title": "Confirmação de reserva – Ref PP160145, Sr. Vitor H",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:30"
          },
          {
            "ticket_id": 12944,
            "ticket_number": "3512932",
            "title": "Confirmação de reserva – Ref PP191495, Sr. CARLOS ",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:17",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:51:30"
          },
          {
            "ticket_id": 12945,
            "ticket_number": "3512933",
            "title": "GBN-97993 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/03/2026 10:10:20",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:20:23"
          },
          {
            "ticket_id": 12946,
            "ticket_number": "3512934",
            "title": "GBN-97992 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/03/2026 10:10:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:20:23"
          },
          {
            "ticket_id": 12947,
            "ticket_number": "3512935",
            "title": "Viajar Tours - 17MAR - Disponibilidades Creta Smar",
            "priority": "P2",
            "created_at": "18/03/2026 10:10:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:24:14"
          },
          {
            "ticket_id": 12948,
            "ticket_number": "3512936",
            "title": "Fwd: Viagify informa sobre a sua reserva 126074545",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:10:34"
          },
          {
            "ticket_id": 12949,
            "ticket_number": "3512937",
            "title": "Fwd: Viagify informa sobre a sua reserva 126074545",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:10:37"
          },
          {
            "ticket_id": 12950,
            "ticket_number": "3512938",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:10:42"
          },
          {
            "ticket_id": 12951,
            "ticket_number": "3512939",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:10:48"
          },
          {
            "ticket_id": 12952,
            "ticket_number": "3512940",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:10:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:10:53"
          },
          {
            "ticket_id": 12957,
            "ticket_number": "3512945",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:11:42",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:11:42"
          },
          {
            "ticket_id": 12958,
            "ticket_number": "3512946",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:11:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:11:46"
          },
          {
            "ticket_id": 12959,
            "ticket_number": "3512947",
            "title": "Fwd: Viagify informa sobre a sua reserva 126069981",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:11:49",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 10:11:49"
          },
          {
            "ticket_id": 12972,
            "ticket_number": "3512960",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 10:46:07",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 53.72,
            "sla_met": false,
            "sla_breach_hours": 29.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:01"
          },
          {
            "ticket_id": 12982,
            "ticket_number": "3512970",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604595144",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 12:33:04",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 51.93,
            "sla_met": false,
            "sla_breach_hours": 27.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:01"
          },
          {
            "ticket_id": 12983,
            "ticket_number": "3512971",
            "title": "RESERVAS",
            "priority": "P2",
            "created_at": "18/03/2026 12:33:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:33:05"
          },
          {
            "ticket_id": 12993,
            "ticket_number": "3512981",
            "title": "GBN-113181 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 13:23:41",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 13:23:41"
          },
          {
            "ticket_id": 12995,
            "ticket_number": "3512983",
            "title": "GBN-113224 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 15:02:01",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 15:02:01"
          },
          {
            "ticket_id": 12997,
            "ticket_number": "3512985",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 15:02:09"
          },
          {
            "ticket_id": 13004,
            "ticket_number": "3512992",
            "title": "Informação de reserva - SPT002601609713",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:36",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 16:05:45"
          },
          {
            "ticket_id": 13007,
            "ticket_number": "3512995",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:46",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:32:24"
          },
          {
            "ticket_id": 13009,
            "ticket_number": "3512997",
            "title": "Confirmação de reserva com localizador: 4127443",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 15:02:51",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 194.87,
            "sla_met": false,
            "sla_breach_hours": 170.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:55:08"
          },
          {
            "ticket_id": 13010,
            "ticket_number": "3512998",
            "title": "Informação de reserva - SPT002601609316",
            "priority": "P2",
            "created_at": "18/03/2026 15:22:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 16:07:01"
          },
          {
            "ticket_id": 13012,
            "ticket_number": "3513000",
            "title": "Número de informação da reserva: 6142153",
            "priority": "P2",
            "created_at": "18/03/2026 15:54:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 16:11:42"
          },
          {
            "ticket_id": 13014,
            "ticket_number": "3513002",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 16:37:45",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 47.87,
            "sla_met": false,
            "sla_breach_hours": 23.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:00"
          },
          {
            "ticket_id": 13021,
            "ticket_number": "3513009",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604595633",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 17:57:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 46.53,
            "sla_met": false,
            "sla_breach_hours": 22.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:00"
          },
          {
            "ticket_id": 13022,
            "ticket_number": "3513010",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 17:57:03",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 46.53,
            "sla_met": false,
            "sla_breach_hours": 22.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:30:00"
          },
          {
            "ticket_id": 13024,
            "ticket_number": "3513012",
            "title": "GBN Travel: Resend booking confirmation - GBN-8658",
            "priority": "P2",
            "created_at": "18/03/2026 19:03:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:03:47"
          },
          {
            "ticket_id": 13025,
            "ticket_number": "3513013",
            "title": "GBN-113280 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 19:03:50",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 19:03:50"
          },
          {
            "ticket_id": 13026,
            "ticket_number": "3513014",
            "title": "Pagamento da reserva – Ref PP431412, Sr. RUI FERNA",
            "priority": "P2",
            "created_at": "18/03/2026 19:03:53",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:12:11"
          },
          {
            "ticket_id": 13029,
            "ticket_number": "3513017",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:03",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:03"
          },
          {
            "ticket_id": 13030,
            "ticket_number": "3513018",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:07"
          },
          {
            "ticket_id": 13031,
            "ticket_number": "3513019",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:11"
          },
          {
            "ticket_id": 13032,
            "ticket_number": "3513020",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:21"
          },
          {
            "ticket_id": 13033,
            "ticket_number": "3513021",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:27",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:27"
          },
          {
            "ticket_id": 13034,
            "ticket_number": "3513022",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:32",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:32"
          },
          {
            "ticket_id": 13035,
            "ticket_number": "3513023",
            "title": "GBN-113328 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 19:04:37",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 19:04:37"
          },
          {
            "ticket_id": 13036,
            "ticket_number": "3513024",
            "title": "GBN-113328 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 19:04:41",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 45.42,
            "sla_met": false,
            "sla_breach_hours": 21.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:59"
          },
          {
            "ticket_id": 13037,
            "ticket_number": "3513025",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:19",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 20:04:49"
          },
          {
            "ticket_id": 13039,
            "ticket_number": "3513027",
            "title": "Reserva confirmada: Tour completo pela Madeira em ",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:44:58"
          },
          {
            "ticket_id": 13040,
            "ticket_number": "3513028",
            "title": "RE: INTENTO DE RESERVA INK HOTEL AMSTERDAM",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:11:31"
          },
          {
            "ticket_id": 13043,
            "ticket_number": "3513031",
            "title": "w2m.travel: Confirmación reserva '7GXVN5'",
            "priority": "P2",
            "created_at": "18/03/2026 19:25:55",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 20:47:50"
          },
          {
            "ticket_id": 13045,
            "ticket_number": "3513033",
            "title": "Confirmação de reserva. Localizador: 12YMS3JE4L",
            "priority": "P2",
            "created_at": "18/03/2026 19:25:59",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:25:59"
          },
          {
            "ticket_id": 13046,
            "ticket_number": "3513034",
            "title": "w2m.travel: Payment confirmation '7GXVN5'",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 20:48:20"
          },
          {
            "ticket_id": 13047,
            "ticket_number": "3513035",
            "title": "Fwd: Viagify informa sobre a sua reserva 126100869",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:26:08"
          },
          {
            "ticket_id": 13048,
            "ticket_number": "3513036",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 20:56:25"
          },
          {
            "ticket_id": 13049,
            "ticket_number": "3513037",
            "title": "Fwd: 1257374014 TTN-1257374014#96480718#T18633138¬",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:13",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:26:14"
          },
          {
            "ticket_id": 13050,
            "ticket_number": "3513038",
            "title": "Fwd: Viagify informa sobre a sua reserva 126101237",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:16",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:26:17"
          },
          {
            "ticket_id": 13054,
            "ticket_number": "3513042",
            "title": "Reserva Aérea YGTDFM",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 20:10:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 44.32,
            "sla_met": false,
            "sla_breach_hours": 20.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:59"
          },
          {
            "ticket_id": 13056,
            "ticket_number": "3513044",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 21:02:39",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 21:05:10"
          },
          {
            "ticket_id": 13059,
            "ticket_number": "3513047",
            "title": "GBN-113399 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 21:38:44",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 44.68,
            "sla_met": false,
            "sla_breach_hours": 20.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 18:20:04"
          },
          {
            "ticket_id": 13063,
            "ticket_number": "3513051",
            "title": "Confirmação de reserva – Ref PP107171, Sr. CARLOS ",
            "priority": "P2",
            "created_at": "18/03/2026 22:07:47",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 22:59:45"
          },
          {
            "ticket_id": 13064,
            "ticket_number": "3513052",
            "title": "GBN-113399 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 22:07:50",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 140.42,
            "sla_met": false,
            "sla_breach_hours": 116.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:33:07"
          },
          {
            "ticket_id": 13065,
            "ticket_number": "3513053",
            "title": "Confirmação de reserva com localizador: 4128537",
            "priority": "P2",
            "created_at": "18/03/2026 22:07:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 22:57:36"
          },
          {
            "ticket_id": 13066,
            "ticket_number": "3513054",
            "title": "Fwd: Viagify informa sobre a sua reserva 126111973",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 22:07:55",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 22:07:56"
          },
          {
            "ticket_id": 13068,
            "ticket_number": "3513056",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 22:56:25",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 41.55,
            "sla_met": false,
            "sla_breach_hours": 17.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:59"
          },
          {
            "ticket_id": 13074,
            "ticket_number": "3513062",
            "title": "Fwd: Viagify informa sobre a sua reserva 126113268",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 23:31:57",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 23:31:55"
          },
          {
            "ticket_id": 13077,
            "ticket_number": "3513065",
            "title": "Reserva Aérea YJ8GBL",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 23:32:07",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 40.95,
            "sla_met": false,
            "sla_breach_hours": 16.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:58"
          },
          {
            "ticket_id": 13079,
            "ticket_number": "3513067",
            "title": "GBN-113415 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "18/03/2026 23:39:32",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/03/2026 23:39:32"
          },
          {
            "ticket_id": 13092,
            "ticket_number": "3513080",
            "title": "Fwd: Viagify informa sobre a sua reserva 126114733",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 10:51:32",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/03/2026 10:51:34"
          },
          {
            "ticket_id": 13093,
            "ticket_number": "3513081",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 10:52:57",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 127.65,
            "sla_met": false,
            "sla_breach_hours": 103.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:00"
          },
          {
            "ticket_id": 13095,
            "ticket_number": "3513083",
            "title": "Confirmação de reserva com localizador: 4128895",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 11:26:30",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 29.05,
            "sla_met": false,
            "sla_breach_hours": 5.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:57"
          },
          {
            "ticket_id": 13104,
            "ticket_number": "3513092",
            "title": "Confirmação de reserva – Ref PP232024, Sr. Pedro M",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 12:26:05",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 28.05,
            "sla_met": false,
            "sla_breach_hours": 4.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:57"
          },
          {
            "ticket_id": 13105,
            "ticket_number": "3513093",
            "title": "Informação de reserva - SPT002601608965",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 12:26:14",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 28.05,
            "sla_met": false,
            "sla_breach_hours": 4.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:57"
          },
          {
            "ticket_id": 13106,
            "ticket_number": "3513094",
            "title": "Informação de reserva - SPT002601608965",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 12:26:22",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 28.05,
            "sla_met": false,
            "sla_breach_hours": 4.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:57"
          },
          {
            "ticket_id": 13107,
            "ticket_number": "3513095",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "19/03/2026 12:37:08",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:37:09"
          },
          {
            "ticket_id": 13113,
            "ticket_number": "3513101",
            "title": "GBN-113506 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 13:09:18",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/03/2026 13:09:18"
          },
          {
            "ticket_id": 13114,
            "ticket_number": "3513102",
            "title": "GBN-113502 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/03/2026 13:09:22",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 13:09:22"
          },
          {
            "ticket_id": 13118,
            "ticket_number": "3513106",
            "title": "[Suporte] TRP-2026-04397 - Quadriplicação de reser",
            "priority": "P2",
            "created_at": "19/03/2026 13:44:24",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 13:44:25"
          },
          {
            "ticket_id": 13124,
            "ticket_number": "3513112",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "P2",
            "created_at": "19/03/2026 15:42:09",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:52:13"
          },
          {
            "ticket_id": 13125,
            "ticket_number": "3513113",
            "title": "Confirmação de reserva. Localizador: 2EMS9BDVM3",
            "priority": "P2",
            "created_at": "19/03/2026 15:42:13",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:52:29"
          },
          {
            "ticket_id": 13126,
            "ticket_number": "3513114",
            "title": "Webinar Morabitur DMC | 26 de março | 11 horas",
            "priority": "P2",
            "created_at": "19/03/2026 15:42:15",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 19:35:59"
          },
          {
            "ticket_id": 13128,
            "ticket_number": "3513116",
            "title": "GBN-113564 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/03/2026 15:54:15",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:54:16"
          },
          {
            "ticket_id": 13133,
            "ticket_number": "3513121",
            "title": "Número de informação da reserva: 6142343",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 16:04:51",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 24.42,
            "sla_met": false,
            "sla_breach_hours": 0.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:57"
          },
          {
            "ticket_id": 13138,
            "ticket_number": "3513126",
            "title": "Flexible Autos - Automatic response",
            "priority": "P2",
            "created_at": "19/03/2026 16:53:24",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:54:03"
          },
          {
            "ticket_id": 13142,
            "ticket_number": "3513130",
            "title": "Fwd: Viagify informa sobre a sua reserva 126135110",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:31",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:07:32"
          },
          {
            "ticket_id": 13143,
            "ticket_number": "3513131",
            "title": "Fwd: Viagify informa sobre a sua reserva 126135110",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:35",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:07:36"
          },
          {
            "ticket_id": 13145,
            "ticket_number": "3513133",
            "title": "Fwd: URRWXV | Alterações à sua reserva?",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:41",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:07:42"
          },
          {
            "ticket_id": 13147,
            "ticket_number": "3513135",
            "title": "Envio de Transacção 1 049607/26",
            "priority": "P2",
            "created_at": "19/03/2026 17:15:33",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:51:47"
          },
          {
            "ticket_id": 13159,
            "ticket_number": "3513147",
            "title": "Número de informação da reserva: 6142914",
            "priority": "P2",
            "created_at": "19/03/2026 17:47:43",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:02:14"
          },
          {
            "ticket_id": 13162,
            "ticket_number": "3513150",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604596751",
            "priority": "P2",
            "created_at": "19/03/2026 18:03:18",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:56:20"
          },
          {
            "ticket_id": 13164,
            "ticket_number": "3513152",
            "title": "Fwd: Celebre a Felicidade com 30% de desconto na s",
            "priority": "P2",
            "created_at": "19/03/2026 18:57:56",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:57:56"
          },
          {
            "ticket_id": 13165,
            "ticket_number": "3513153",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/03/2026 18:58:04",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:58:04"
          },
          {
            "ticket_id": 13168,
            "ticket_number": "3513156",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/03/2026 18:58:20",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:58:20"
          },
          {
            "ticket_id": 13171,
            "ticket_number": "3513159",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/03/2026 19:09:12",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 19:09:12"
          },
          {
            "ticket_id": 13172,
            "ticket_number": "3513160",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/03/2026 19:09:21",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 19:09:21"
          },
          {
            "ticket_id": 13175,
            "ticket_number": "3513163",
            "title": "Confirmação de reserva com localizador: 4130302",
            "priority": "P2",
            "created_at": "19/03/2026 19:43:11",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 23:11:04"
          },
          {
            "ticket_id": 13177,
            "ticket_number": "3513165",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 19:43:15",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 20.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:56"
          },
          {
            "ticket_id": 13178,
            "ticket_number": "3513166",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "P2",
            "created_at": "19/03/2026 20:01:41",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 20:52:48"
          },
          {
            "ticket_id": 13179,
            "ticket_number": "3513167",
            "title": "Reserva confirmada: Ônibus turístico de Paris, Big",
            "priority": "P2",
            "created_at": "19/03/2026 20:01:44",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 20:49:10"
          },
          {
            "ticket_id": 13180,
            "ticket_number": "3513168",
            "title": "Número de informação da reserva: 6142937",
            "priority": "P2",
            "created_at": "19/03/2026 21:17:55",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 23:10:11"
          },
          {
            "ticket_id": 13181,
            "ticket_number": "3513169",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/03/2026 22:35:29",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 17.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 16:29:56"
          },
          {
            "ticket_id": 13182,
            "ticket_number": "3513170",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "19/03/2026 22:35:31",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 23:09:01"
          },
          {
            "ticket_id": 13183,
            "ticket_number": "3513171",
            "title": "GBN-113694 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/03/2026 22:35:38",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 22:35:38"
          },
          {
            "ticket_id": 13192,
            "ticket_number": "3513180",
            "title": "Confirmação de reserva com localizador: 4130609",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 10:03:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 104.47,
            "sla_met": false,
            "sla_breach_hours": 80.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:00"
          },
          {
            "ticket_id": 13193,
            "ticket_number": "3513181",
            "title": "Confirmação de reserva com localizador: 4130579",
            "priority": "P2",
            "created_at": "20/03/2026 10:03:37",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:52:18"
          },
          {
            "ticket_id": 13194,
            "ticket_number": "3513182",
            "title": "Confirmação de reserva com localizador: 4130711",
            "priority": "P2",
            "created_at": "20/03/2026 10:03:39",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:55:14"
          },
          {
            "ticket_id": 13217,
            "ticket_number": "3513205",
            "title": "Número de informação da reserva: 6142959",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:56",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:54:42"
          },
          {
            "ticket_id": 13230,
            "ticket_number": "3513218",
            "title": "Confirmação de reserva com localizador: 4131348",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 13:23:00",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 101.15,
            "sla_met": false,
            "sla_breach_hours": 77.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:00"
          },
          {
            "ticket_id": 13236,
            "ticket_number": "3513224",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 16:29:38",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 98.03,
            "sla_met": false,
            "sla_breach_hours": 74.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:00"
          },
          {
            "ticket_id": 13243,
            "ticket_number": "3513231",
            "title": "Confirmação de reserva com localizador: 4131837",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 17:28:50",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 97.05,
            "sla_met": false,
            "sla_breach_hours": 73.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:32:00"
          },
          {
            "ticket_id": 13244,
            "ticket_number": "3513232",
            "title": "Confirmação de reserva com localizador: 4131874",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 17:38:22",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 96.88,
            "sla_met": false,
            "sla_breach_hours": 72.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:59"
          },
          {
            "ticket_id": 13246,
            "ticket_number": "3513234",
            "title": "Información de reserva número: 1781955",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 18:21:28",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 96.17,
            "sla_met": false,
            "sla_breach_hours": 72.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:59"
          },
          {
            "ticket_id": 13256,
            "ticket_number": "3513244",
            "title": "Criação de processo File 436315/26",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:12:47",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 95.32,
            "sla_met": false,
            "sla_breach_hours": 71.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:59"
          },
          {
            "ticket_id": 13259,
            "ticket_number": "3513247",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:27:44",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.93,
            "sla_met": false,
            "sla_breach_hours": 39.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 11:24:08"
          },
          {
            "ticket_id": 13260,
            "ticket_number": "3513248",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:27:47",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 19:27:47"
          },
          {
            "ticket_id": 13261,
            "ticket_number": "3513249",
            "title": "Reserva TUI (10047300) - UMA FAMILIA EM VIAGEM (HO",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:27:49",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 63.93,
            "sla_met": false,
            "sla_breach_hours": 39.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 11:24:08"
          },
          {
            "ticket_id": 13263,
            "ticket_number": "3513251",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:27:58",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 19:27:58"
          },
          {
            "ticket_id": 13264,
            "ticket_number": "3513252",
            "title": "Informação de reserva - SPT002601611072",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:28:06",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 63.93,
            "sla_met": false,
            "sla_breach_hours": 39.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 11:24:08"
          },
          {
            "ticket_id": 13265,
            "ticket_number": "3513253",
            "title": "Informação de reserva - SPT002601611072",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 19:28:13",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 63.92,
            "sla_met": false,
            "sla_breach_hours": 39.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 11:24:08"
          },
          {
            "ticket_id": 13266,
            "ticket_number": "3513254",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604597980",
            "priority": "P2",
            "created_at": "20/03/2026 19:53:52",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 19:58:32"
          },
          {
            "ticket_id": 13268,
            "ticket_number": "3513256",
            "title": "GBN-113950 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/03/2026 20:56:30",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 20:56:30"
          },
          {
            "ticket_id": 13269,
            "ticket_number": "3513257",
            "title": "Reserva confirmada: Tour panorâmico pelo oeste da ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 20:56:32",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 12:44:17"
          },
          {
            "ticket_id": 13270,
            "ticket_number": "3513258",
            "title": "Reserva confirmada: Tour panorâmico pelo leste da ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 20:56:34",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 12:44:17"
          },
          {
            "ticket_id": 13271,
            "ticket_number": "3513259",
            "title": "Reserva confirmada: Tour panorâmico pelo leste da ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 20:56:37",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 12:44:17"
          },
          {
            "ticket_id": 13272,
            "ticket_number": "3513260",
            "title": "Reserva confirmada: Tour panorâmico pelo oeste da ",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 20:56:40",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 63.78,
            "sla_met": false,
            "sla_breach_hours": 39.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 12:44:17"
          },
          {
            "ticket_id": 13277,
            "ticket_number": "3513265",
            "title": "GBN-113958 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/03/2026 21:42:34",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:42:34"
          },
          {
            "ticket_id": 13278,
            "ticket_number": "3513266",
            "title": "Confirmación de la reserva con localizador: 413235",
            "priority": "P2",
            "created_at": "20/03/2026 21:42:36",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:02:41"
          },
          {
            "ticket_id": 13279,
            "ticket_number": "3513267",
            "title": "GBN-113956 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 21:42:39",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 92.92,
            "sla_met": false,
            "sla_breach_hours": 68.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:38:04"
          },
          {
            "ticket_id": 13280,
            "ticket_number": "3513268",
            "title": "Confirmação de reserva – Ref PP148217, Sr. ANTÓNIO",
            "priority": "P2",
            "created_at": "20/03/2026 21:42:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:03:57"
          },
          {
            "ticket_id": 13281,
            "ticket_number": "3513269",
            "title": "[Cancelamento Viagem] TRP-2026-03415 - Tiago Emanu",
            "priority": "P2",
            "created_at": "20/03/2026 21:55:24",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:55:24"
          },
          {
            "ticket_id": 13284,
            "ticket_number": "3513272",
            "title": "GBN-113964 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/03/2026 22:57:44",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/03/2026 22:57:44"
          },
          {
            "ticket_id": 13303,
            "ticket_number": "3513291",
            "title": "Informação de reserva - SPT002601611072",
            "priority": "Reservas sem Formulário",
            "created_at": "21/03/2026 12:14:39",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 53.83,
            "sla_met": false,
            "sla_breach_hours": 29.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 18:04:57"
          },
          {
            "ticket_id": 13311,
            "ticket_number": "3513299",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598208",
            "priority": "Reservas sem Formulário",
            "created_at": "21/03/2026 18:41:06",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 43.23,
            "sla_met": false,
            "sla_breach_hours": 19.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 13:56:04"
          },
          {
            "ticket_id": 13319,
            "ticket_number": "3513307",
            "title": "GBN-114071 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 10:07:52",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 10:07:52"
          },
          {
            "ticket_id": 13320,
            "ticket_number": "3513308",
            "title": "w2m.travel: Payment confirmation '5FCWQ4'",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 10:08:00",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 32.38,
            "sla_met": false,
            "sla_breach_hours": 8.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:58"
          },
          {
            "ticket_id": 13321,
            "ticket_number": "3513309",
            "title": "Número de informação da reserva: 6143156",
            "priority": "P2",
            "created_at": "23/03/2026 10:08:04",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:50:31"
          },
          {
            "ticket_id": 13322,
            "ticket_number": "3513310",
            "title": "w2m.travel: Confirmación reserva '5FCWQ4'",
            "priority": "P2",
            "created_at": "23/03/2026 10:08:07",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:50:50"
          },
          {
            "ticket_id": 13323,
            "ticket_number": "3513311",
            "title": "GBN-114066 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:08:12",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:08:12"
          },
          {
            "ticket_id": 13324,
            "ticket_number": "3513312",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "23/03/2026 10:08:18",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:08:19"
          },
          {
            "ticket_id": 13325,
            "ticket_number": "3513313",
            "title": "Re: [Cockpit] Viagem TRP-2026-03985 - JAMAICA • JO",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:49",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:10:49"
          },
          {
            "ticket_id": 13327,
            "ticket_number": "3513315",
            "title": "RE: Pagamento 6142020",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:53",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:05:40"
          },
          {
            "ticket_id": 13328,
            "ticket_number": "3513316",
            "title": "RE: Pagamento 6126635",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:54",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:01:21"
          },
          {
            "ticket_id": 13329,
            "ticket_number": "3513317",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604571214",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:57",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:52:37"
          },
          {
            "ticket_id": 13330,
            "ticket_number": "3513318",
            "title": "GBN-112233 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:59",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:11"
          },
          {
            "ticket_id": 13332,
            "ticket_number": "3513320",
            "title": "RE: Pagamento 6142343",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:03",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:01:48"
          },
          {
            "ticket_id": 13333,
            "ticket_number": "3513321",
            "title": "RE: Pagamento 6142517",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:05",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:01:12"
          },
          {
            "ticket_id": 13335,
            "ticket_number": "3513323",
            "title": "GBN-91343 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:09",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:11"
          },
          {
            "ticket_id": 13337,
            "ticket_number": "3513325",
            "title": "GBN-104742 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:12",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:11"
          },
          {
            "ticket_id": 13338,
            "ticket_number": "3513326",
            "title": "Your personal travel information for Lisbon – Sofi",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:16",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:06:57"
          },
          {
            "ticket_id": 13339,
            "ticket_number": "3513327",
            "title": "GBN-107154 - Su reserva está pendiente de pago",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:19",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:06:36"
          },
          {
            "ticket_id": 13341,
            "ticket_number": "3513329",
            "title": "GBN-112218 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:23",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:05:59"
          },
          {
            "ticket_id": 13343,
            "ticket_number": "3513331",
            "title": "GBN-98037 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:29",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:07:53"
          },
          {
            "ticket_id": 13344,
            "ticket_number": "3513332",
            "title": "Número de informação da reserva: 6143223",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:32",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:55:53"
          },
          {
            "ticket_id": 13348,
            "ticket_number": "3513336",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:42",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:11:43"
          },
          {
            "ticket_id": 13349,
            "ticket_number": "3513337",
            "title": "Número de informação da reserva: 6143206",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:46",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:57:13"
          },
          {
            "ticket_id": 13350,
            "ticket_number": "3513338",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:57",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:57:34"
          },
          {
            "ticket_id": 13351,
            "ticket_number": "3513339",
            "title": "Número de informação da reserva: 6143212",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:02",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:57:48"
          },
          {
            "ticket_id": 13352,
            "ticket_number": "3513340",
            "title": "Número de informação da reserva: 6143203",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:06",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:58:03"
          },
          {
            "ticket_id": 13353,
            "ticket_number": "3513341",
            "title": "Confirmação de reserva com localizador: 4133464",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:08",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:58:17"
          },
          {
            "ticket_id": 13357,
            "ticket_number": "3513345",
            "title": "GBN-114114 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:17",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:12:17"
          },
          {
            "ticket_id": 13358,
            "ticket_number": "3513346",
            "title": "Confirmation of booking with locatorWJ4VPD21",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:19",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:59:11"
          },
          {
            "ticket_id": 13360,
            "ticket_number": "3513348",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:32",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:59:40"
          },
          {
            "ticket_id": 13361,
            "ticket_number": "3513349",
            "title": "Confirmação de reserva com localizador: 4133269",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 10:12:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13362,
            "ticket_number": "3513350",
            "title": "Informação de reserva - SPT002601611513",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:43",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 12:13:36"
          },
          {
            "ticket_id": 13363,
            "ticket_number": "3513351",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598267",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:45",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:00:11"
          },
          {
            "ticket_id": 13366,
            "ticket_number": "3513354",
            "title": "GBN-114097 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:25",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:25"
          },
          {
            "ticket_id": 13367,
            "ticket_number": "3513355",
            "title": "GBN-114099 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:29",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:29"
          },
          {
            "ticket_id": 13368,
            "ticket_number": "3513356",
            "title": "GBN-114096 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:32",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:33"
          },
          {
            "ticket_id": 13369,
            "ticket_number": "3513357",
            "title": "GBN-114098 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:36",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:36"
          },
          {
            "ticket_id": 13370,
            "ticket_number": "3513358",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598265",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:38",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:01:45"
          },
          {
            "ticket_id": 13372,
            "ticket_number": "3513360",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598268",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:43",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:02"
          },
          {
            "ticket_id": 13374,
            "ticket_number": "3513362",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598266",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:47",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:32"
          },
          {
            "ticket_id": 13376,
            "ticket_number": "3513364",
            "title": "GBN-114090 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:52",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:53"
          },
          {
            "ticket_id": 13377,
            "ticket_number": "3513365",
            "title": "Informação de reserva - SPT002601611438",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:59",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:24:16"
          },
          {
            "ticket_id": 13383,
            "ticket_number": "3513371",
            "title": "GBN-114082 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 10:14:11",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.1,
            "sla_met": false,
            "sla_breach_hours": 9.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 19:20:54"
          },
          {
            "ticket_id": 13384,
            "ticket_number": "3513372",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604598254",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:13",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:22:43"
          },
          {
            "ticket_id": 13387,
            "ticket_number": "3513375",
            "title": "w2m.travel: Confirmación reserva 'J5X91X'",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:21",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:21:58"
          },
          {
            "ticket_id": 13389,
            "ticket_number": "3513377",
            "title": "Envio de documentos de File 433259 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "23/03/2026 10:15:25",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:05:24"
          },
          {
            "ticket_id": 13404,
            "ticket_number": "3513392",
            "title": "Cancelamento de Reserva 213397",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:03",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:02:54"
          },
          {
            "ticket_id": 13407,
            "ticket_number": "3513395",
            "title": "VOUCHER DA RESERVA 604541477",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 13:55:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 17:44:53"
          },
          {
            "ticket_id": 13409,
            "ticket_number": "3513397",
            "title": "PAGO URGENTE CANCELACION",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:29",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:58:27"
          },
          {
            "ticket_id": 13413,
            "ticket_number": "3513401",
            "title": "Confirmation of booking with locatorZKC8POSG",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 13:55:37",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 28.6,
            "sla_met": false,
            "sla_breach_hours": 4.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:57"
          },
          {
            "ticket_id": 13416,
            "ticket_number": "3513404",
            "title": "Confirmation of booking with locator1PVN0DCK",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 13:55:42",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 28.6,
            "sla_met": false,
            "sla_breach_hours": 4.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:57"
          },
          {
            "ticket_id": 13418,
            "ticket_number": "3513406",
            "title": "Informação de reserva - SPT002601611513",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:58",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:58:20"
          },
          {
            "ticket_id": 13422,
            "ticket_number": "3513410",
            "title": "GBN-114143 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 13:56:13",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 13:56:13"
          },
          {
            "ticket_id": 13428,
            "ticket_number": "3513416",
            "title": "Info check-in - 332KRC/1 - Terrace Vila Ii By An I",
            "priority": "P2",
            "created_at": "23/03/2026 15:04:44",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 19:00:07"
          },
          {
            "ticket_id": 13434,
            "ticket_number": "3513422",
            "title": "Fwd: Viagify informa sobre a sua reserva 126248723",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 16:09:19",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 16:09:19"
          },
          {
            "ticket_id": 13435,
            "ticket_number": "3513423",
            "title": "Fwd: Viagify informa sobre a sua reserva 126248723",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 16:09:22",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 16:09:23"
          },
          {
            "ticket_id": 13437,
            "ticket_number": "3513425",
            "title": "GBN-114304 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 17:36:33",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:36:33"
          },
          {
            "ticket_id": 13438,
            "ticket_number": "3513426",
            "title": "Cruzeiros de Barcelona a Istambul e vice-versa por",
            "priority": "P2",
            "created_at": "23/03/2026 17:36:45",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 19:06:20"
          },
          {
            "ticket_id": 13439,
            "ticket_number": "3513427",
            "title": "Confirmação e Sinalização de Reserva 213934",
            "priority": "P2",
            "created_at": "23/03/2026 17:39:58",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 18:40:07"
          },
          {
            "ticket_id": 13444,
            "ticket_number": "3513432",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 19:40:55",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 69.75,
            "sla_met": false,
            "sla_breach_hours": 45.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 17:26:08"
          },
          {
            "ticket_id": 13453,
            "ticket_number": "3513441",
            "title": "[Suporte] TRP-2026-04433 / TRL-2026-06705 - Pagame",
            "priority": "P2",
            "created_at": "23/03/2026 20:52:15",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:52:16"
          },
          {
            "ticket_id": 13456,
            "ticket_number": "3513444",
            "title": "GBN-114388 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/03/2026 21:18:16",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 21:18:16"
          },
          {
            "ticket_id": 13461,
            "ticket_number": "3513449",
            "title": "GBN-114392 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 23:05:54",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 23:05:54"
          },
          {
            "ticket_id": 13462,
            "ticket_number": "3513450",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604599575",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 23:05:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 19.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:56"
          },
          {
            "ticket_id": 13463,
            "ticket_number": "3513451",
            "title": "GBN-113831 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/03/2026 23:05:57",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:08:25"
          },
          {
            "ticket_id": 13464,
            "ticket_number": "3513452",
            "title": "Confirmação de reserva com localizador: 4135935",
            "priority": "P2",
            "created_at": "23/03/2026 23:06:00",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 11.72,
            "sla_met": false,
            "sla_breach_hours": 7.72,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:49:09"
          },
          {
            "ticket_id": 13466,
            "ticket_number": "3513454",
            "title": "Código para fechar a reserva para Vila Galé Isla C",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:25",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 11.55,
            "sla_met": false,
            "sla_breach_hours": 7.55,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 11:24:21"
          },
          {
            "ticket_id": 13468,
            "ticket_number": "3513456",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604599577",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 23:50:29",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 18.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:55"
          },
          {
            "ticket_id": 13470,
            "ticket_number": "3513458",
            "title": "Confirmação de reserva – Ref PP162407, Sr. Samir  ",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:48",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 11.02,
            "sla_met": false,
            "sla_breach_hours": 7.02,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:52:03"
          },
          {
            "ticket_id": 13474,
            "ticket_number": "3513462",
            "title": "Reserva Aérea Y352KK",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 23:50:56",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 36.67,
            "sla_met": false,
            "sla_breach_hours": 12.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 12:31:56"
          },
          {
            "ticket_id": 13475,
            "ticket_number": "3513463",
            "title": "GBN-114396 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/03/2026 23:50:59",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/03/2026 23:50:59"
          },
          {
            "ticket_id": 13480,
            "ticket_number": "3513468",
            "title": "GBN-114410 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 10:06:25",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 10:06:25"
          },
          {
            "ticket_id": 13481,
            "ticket_number": "3513469",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604599582",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 10:06:27",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 8.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:55"
          },
          {
            "ticket_id": 13483,
            "ticket_number": "3513471",
            "title": "Reserva cancelada com localizador: 4130609",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:32",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:58:55"
          },
          {
            "ticket_id": 13484,
            "ticket_number": "3513472",
            "title": "Confirmacao 343170",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:33",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:45:43"
          },
          {
            "ticket_id": 13486,
            "ticket_number": "3513474",
            "title": "GBN-114402 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:39",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:06:39"
          },
          {
            "ticket_id": 13490,
            "ticket_number": "3513478",
            "title": "Confirmation of booking with locator2GSLEM6W",
            "priority": "P2",
            "created_at": "24/03/2026 10:08:25",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 11:30:04"
          },
          {
            "ticket_id": 13493,
            "ticket_number": "3513481",
            "title": "Confirmação de reserva para For PT004157 66593177",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 10:26:30",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 8.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:55"
          },
          {
            "ticket_id": 13494,
            "ticket_number": "3513482",
            "title": "Confirmação de reserva 343170### TIME LIMIT EMISSÃ",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 10:32:29",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 7.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:55"
          },
          {
            "ticket_id": 13495,
            "ticket_number": "3513483",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP205146, Sr/a ",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 11:16:34",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 7.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:54"
          },
          {
            "ticket_id": 13504,
            "ticket_number": "3513492",
            "title": "Confirmação de reserva com localizador: 4136794",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 12:45:17",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 28.67,
            "sla_met": false,
            "sla_breach_hours": 4.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 17:26:06"
          },
          {
            "ticket_id": 13506,
            "ticket_number": "3513494",
            "title": "Confirmação de reserva com localizador: 4136810",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 12:45:21",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 28.67,
            "sla_met": false,
            "sla_breach_hours": 4.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 17:26:06"
          },
          {
            "ticket_id": 13515,
            "ticket_number": "3513503",
            "title": "Comprovativo de pagamento TRP-2026-02849",
            "priority": "P2",
            "created_at": "24/03/2026 13:47:56",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:22:37"
          },
          {
            "ticket_id": 13516,
            "ticket_number": "3513504",
            "title": "[Suporte] TRP-2026-03264 - Alteração Valores Fatur",
            "priority": "P2",
            "created_at": "24/03/2026 14:01:04",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:01:04"
          },
          {
            "ticket_id": 13519,
            "ticket_number": "3513507",
            "title": "[Suporte] TRP-2026-04247 / TRL-2026-06433 - Dados ",
            "priority": "P2",
            "created_at": "24/03/2026 14:12:38",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:12:38"
          },
          {
            "ticket_id": 13527,
            "ticket_number": "3513515",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802563825",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 16:30:37",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:54"
          },
          {
            "ticket_id": 13534,
            "ticket_number": "3513522",
            "title": "SANTOS RUAS/VITOR MANUEL MR 12MAY2026 LIS RAI",
            "priority": "P2",
            "created_at": "24/03/2026 17:12:59",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:15:02"
          },
          {
            "ticket_id": 13536,
            "ticket_number": "3513524",
            "title": "Confirmação da reserva nº 967929154",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 17:18:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 19:20:14"
          },
          {
            "ticket_id": 13538,
            "ticket_number": "3513526",
            "title": "Confirmação da reserva nº 567382835",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 17:25:14",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:31:54"
          },
          {
            "ticket_id": 13542,
            "ticket_number": "3513530",
            "title": "GBN-114600 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 18:02:44",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:02:44"
          },
          {
            "ticket_id": 13543,
            "ticket_number": "3513531",
            "title": "GBN-114599 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 18:02:52",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:02:52"
          },
          {
            "ticket_id": 13545,
            "ticket_number": "3513533",
            "title": "GBN-114595 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/03/2026 18:03:05",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/03/2026 18:03:05"
          },
          {
            "ticket_id": 13546,
            "ticket_number": "3513534",
            "title": "GBN-114611 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/03/2026 18:26:57",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 18:26:57"
          },
          {
            "ticket_id": 13547,
            "ticket_number": "3513535",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 18:43:32",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 18:43:32"
          },
          {
            "ticket_id": 13548,
            "ticket_number": "3513536",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 18:43:36",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 18:43:36"
          },
          {
            "ticket_id": 13549,
            "ticket_number": "3513537",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "24/03/2026 18:43:44",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:56:44"
          },
          {
            "ticket_id": 13550,
            "ticket_number": "3513538",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 18:43:54",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 18:43:54"
          },
          {
            "ticket_id": 13551,
            "ticket_number": "3513539",
            "title": "Informação de reserva - SPT002601611959",
            "priority": "P2",
            "created_at": "24/03/2026 18:44:01",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:54:09"
          },
          {
            "ticket_id": 13553,
            "ticket_number": "3513541",
            "title": "GBN Travel: Reenvío de confirmación de reserva - G",
            "priority": "P2",
            "created_at": "24/03/2026 19:23:06",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:23:06"
          },
          {
            "ticket_id": 13554,
            "ticket_number": "3513542",
            "title": "Pagamento da reserva – Ref PP162407, Sr. Samir  Ha",
            "priority": "P2",
            "created_at": "24/03/2026 19:23:08",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:23:45"
          },
          {
            "ticket_id": 13555,
            "ticket_number": "3513543",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 19:23:12",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:23:12"
          },
          {
            "ticket_id": 13556,
            "ticket_number": "3513544",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 19:23:22",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:23:22"
          },
          {
            "ticket_id": 13557,
            "ticket_number": "3513545",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/03/2026 19:23:32",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:23:32"
          },
          {
            "ticket_id": 13572,
            "ticket_number": "3513560",
            "title": "GBN-114599 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:26",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:57:50"
          },
          {
            "ticket_id": 13573,
            "ticket_number": "3513561",
            "title": "GBN-108594 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:28",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:34:20"
          },
          {
            "ticket_id": 13578,
            "ticket_number": "3513566",
            "title": "Confirmação de reserva com localizador: 4138397",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:33:19"
          },
          {
            "ticket_id": 13582,
            "ticket_number": "3513570",
            "title": "Faturas Pendentes: FA 2147902301",
            "priority": "P2",
            "created_at": "25/03/2026 10:08:32",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:49:05"
          },
          {
            "ticket_id": 13583,
            "ticket_number": "3513571",
            "title": "GBN-114622 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/03/2026 10:36:34",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:52:47"
          },
          {
            "ticket_id": 13584,
            "ticket_number": "3513572",
            "title": "GBN-114622 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/03/2026 10:36:41",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:36:41"
          },
          {
            "ticket_id": 13590,
            "ticket_number": "3513578",
            "title": "Fwd: Viagify informa sobre a sua reserva 126315211",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:22",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:01:23"
          },
          {
            "ticket_id": 13591,
            "ticket_number": "3513579",
            "title": "Fwd: Viagify informa sobre a sua reserva 126315211",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:26",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:01:26"
          },
          {
            "ticket_id": 13604,
            "ticket_number": "3513592",
            "title": "Faturas Pendentes: FA 2147902412",
            "priority": "P2",
            "created_at": "25/03/2026 13:38:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 14:44:43"
          },
          {
            "ticket_id": 13607,
            "ticket_number": "3513595",
            "title": "Atualização de pagamento TRP-2026-02105",
            "priority": "P2",
            "created_at": "25/03/2026 14:20:47",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 14:20:48"
          },
          {
            "ticket_id": 13609,
            "ticket_number": "3513597",
            "title": "Confirmação de reserva com localizador: 4139336",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 14:20:51",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 17:26:06"
          },
          {
            "ticket_id": 13612,
            "ticket_number": "3513600",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604601162",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 15:40:29",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 16:05:37"
          },
          {
            "ticket_id": 13613,
            "ticket_number": "3513601",
            "title": "Fwd: Confirmacion de la reserva Transavia: ZB157C",
            "priority": "P2",
            "created_at": "25/03/2026 15:40:32",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 15:40:32"
          },
          {
            "ticket_id": 13614,
            "ticket_number": "3513602",
            "title": "GBN-114865 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 15:58:08",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 15:58:08"
          },
          {
            "ticket_id": 13615,
            "ticket_number": "3513603",
            "title": "RV: Confirmacion de la reserva Transavia: MJ61KH",
            "priority": "P2",
            "created_at": "25/03/2026 16:05:40",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:06:30"
          },
          {
            "ticket_id": 13618,
            "ticket_number": "3513606",
            "title": "Confirmação reserva Bedsonline 207-15888979",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 16:15:14",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 17:26:05"
          },
          {
            "ticket_id": 13619,
            "ticket_number": "3513607",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 1",
            "priority": "P2",
            "created_at": "25/03/2026 16:27:42",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:55:15"
          },
          {
            "ticket_id": 13621,
            "ticket_number": "3513609",
            "title": "Confirmação de reserva. Localizador: 1XC8HV7IZ3",
            "priority": "P2",
            "created_at": "25/03/2026 16:27:47",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:55:30"
          },
          {
            "ticket_id": 13623,
            "ticket_number": "3513611",
            "title": "Confirmação de reserva. Localizador: 7ER9ZVL9R2",
            "priority": "P2",
            "created_at": "25/03/2026 16:31:43",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:48:50"
          },
          {
            "ticket_id": 13624,
            "ticket_number": "3513612",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "P2",
            "created_at": "25/03/2026 16:37:16",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:55:58"
          },
          {
            "ticket_id": 13625,
            "ticket_number": "3513613",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "25/03/2026 16:56:52",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:21:38"
          },
          {
            "ticket_id": 13626,
            "ticket_number": "3513614",
            "title": "Confirmação de reserva. Localizador: 40F32Q8W9J",
            "priority": "P2",
            "created_at": "25/03/2026 16:57:19",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:58:36"
          },
          {
            "ticket_id": 13627,
            "ticket_number": "3513615",
            "title": "[VIAJES OLYMPIA] Asunto: Re: [VIAJES OLYMPIA] Asun",
            "priority": "P2",
            "created_at": "25/03/2026 17:09:54",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 21:04:46"
          },
          {
            "ticket_id": 13645,
            "ticket_number": "3513633",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "P2",
            "created_at": "25/03/2026 18:50:46",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 22:44:57"
          },
          {
            "ticket_id": 13647,
            "ticket_number": "3513635",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/03/2026 18:50:58",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:50:58"
          },
          {
            "ticket_id": 13648,
            "ticket_number": "3513636",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/03/2026 18:51:13",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:51:14"
          },
          {
            "ticket_id": 13654,
            "ticket_number": "3513642",
            "title": "GBN-114989 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 20:20:39",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 20:20:39"
          },
          {
            "ticket_id": 13661,
            "ticket_number": "3513649",
            "title": "Confirmacao 343338",
            "priority": "P2",
            "created_at": "25/03/2026 21:17:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 21:56:01"
          },
          {
            "ticket_id": 13663,
            "ticket_number": "3513651",
            "title": "GBN-115005 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 21:36:18",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 21:36:18"
          },
          {
            "ticket_id": 13667,
            "ticket_number": "3513655",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "25/03/2026 22:32:23",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 22:37:39"
          },
          {
            "ticket_id": 13670,
            "ticket_number": "3513658",
            "title": "GBN-115020 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 23:24:57",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/03/2026 23:24:57"
          },
          {
            "ticket_id": 13671,
            "ticket_number": "3513659",
            "title": "Número de informação da reserva: 6143614",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 23:24:59",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 14.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 14:01:01"
          },
          {
            "ticket_id": 13672,
            "ticket_number": "3513660",
            "title": "IFTHENPAY - Pagamento Efetuado: ID TRP-2026-04497-",
            "priority": "P2",
            "created_at": "25/03/2026 23:25:02",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 23:29:28"
          },
          {
            "ticket_id": 13673,
            "ticket_number": "3513661",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "25/03/2026 23:25:09",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 23:26:45"
          },
          {
            "ticket_id": 13674,
            "ticket_number": "3513662",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "25/03/2026 23:25:17",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 14.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 14:01:00"
          },
          {
            "ticket_id": 13676,
            "ticket_number": "3513664",
            "title": "GBN-115022 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/03/2026 23:51:03",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 23:52:23"
          },
          {
            "ticket_id": 13680,
            "ticket_number": "3513668",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 8",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 10:04:03",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 10:04:08"
          },
          {
            "ticket_id": 13682,
            "ticket_number": "3513670",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604597980",
            "priority": "P2",
            "created_at": "26/03/2026 10:04:07",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:06:54"
          },
          {
            "ticket_id": 13691,
            "ticket_number": "3513679",
            "title": "Fwd: Viagify informa sobre a sua reserva 126345257",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 10:37:09",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 10:37:10"
          },
          {
            "ticket_id": 13692,
            "ticket_number": "3513680",
            "title": "Fwd: Viagify informa sobre a sua reserva 126345257",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 10:37:12",
            "close_date": "2026-03-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 10:37:13"
          },
          {
            "ticket_id": 13709,
            "ticket_number": "3513697",
            "title": "Fwd: Viagify informa sobre a sua reserva 126361644",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 14:25:49",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 14:25:50"
          },
          {
            "ticket_id": 13725,
            "ticket_number": "3513713",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (Z38",
            "priority": "P2",
            "created_at": "26/03/2026 17:51:54",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 18:10:05"
          },
          {
            "ticket_id": 13728,
            "ticket_number": "3513716",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/03/2026 19:15:11",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:15:11"
          },
          {
            "ticket_id": 13734,
            "ticket_number": "3513722",
            "title": "GBN-115277 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 20:17:47",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 20:17:47"
          },
          {
            "ticket_id": 13737,
            "ticket_number": "3513725",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "26/03/2026 20:57:20",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 22:26:24"
          },
          {
            "ticket_id": 13745,
            "ticket_number": "3513733",
            "title": "Número de informação da reserva: 6143741",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 22:28:34",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 89.27,
            "sla_met": false,
            "sla_breach_hours": 65.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:36"
          },
          {
            "ticket_id": 13747,
            "ticket_number": "3513735",
            "title": "Número de informação da reserva: 6143746",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 22:46:33",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 88.97,
            "sla_met": false,
            "sla_breach_hours": 64.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:36"
          },
          {
            "ticket_id": 13752,
            "ticket_number": "3513740",
            "title": "GBN-115309 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/03/2026 23:45:17",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/03/2026 23:45:17"
          },
          {
            "ticket_id": 13753,
            "ticket_number": "3513741",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "26/03/2026 23:46:11",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:53:33"
          },
          {
            "ticket_id": 13754,
            "ticket_number": "3513742",
            "title": "Número de informação da reserva: 6143749",
            "priority": "P2",
            "created_at": "26/03/2026 23:46:13",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:54:04"
          },
          {
            "ticket_id": 13757,
            "ticket_number": "3513745",
            "title": "GBN-115299 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/03/2026 23:46:20",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:46:20"
          },
          {
            "ticket_id": 13759,
            "ticket_number": "3513747",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "26/03/2026 23:46:24",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:55:28"
          },
          {
            "ticket_id": 13764,
            "ticket_number": "3513752",
            "title": "Fwd: Viagify informa sobre a sua reserva 126381773",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:07:05"
          },
          {
            "ticket_id": 13765,
            "ticket_number": "3513753",
            "title": "Fwd: Viagify informa sobre a sua reserva 126381114",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:08",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:07:08"
          },
          {
            "ticket_id": 13770,
            "ticket_number": "3513758",
            "title": "GBN-115318 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 10:07:24",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/03/2026 10:07:24"
          },
          {
            "ticket_id": 13775,
            "ticket_number": "3513763",
            "title": "GBN-115338 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 11:46:47",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/03/2026 11:46:47"
          },
          {
            "ticket_id": 13780,
            "ticket_number": "3513768",
            "title": "Confirmación de la reserva con localizador: 414326",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 12:26:22",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 75.3,
            "sla_met": false,
            "sla_breach_hours": 51.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:36"
          },
          {
            "ticket_id": 13788,
            "ticket_number": "3513776",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/03/2026 14:06:55",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:06:55"
          },
          {
            "ticket_id": 13789,
            "ticket_number": "3513777",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/03/2026 14:07:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:07:05"
          },
          {
            "ticket_id": 13790,
            "ticket_number": "3513778",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/03/2026 14:07:16",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:07:16"
          },
          {
            "ticket_id": 13793,
            "ticket_number": "3513781",
            "title": "Solole. Booking 9Y8BS7EK is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 14:07:53",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 73.6,
            "sla_met": false,
            "sla_breach_hours": 49.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:35"
          },
          {
            "ticket_id": 13794,
            "ticket_number": "3513782",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604603156",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 14:07:54",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 73.6,
            "sla_met": false,
            "sla_breach_hours": 49.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:35"
          },
          {
            "ticket_id": 13795,
            "ticket_number": "3513783",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604603172",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 14:27:25",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 73.28,
            "sla_met": false,
            "sla_breach_hours": 49.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:35"
          },
          {
            "ticket_id": 13813,
            "ticket_number": "3513801",
            "title": "Informação de reserva - SPT002601614471",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 17:44:06",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 70.0,
            "sla_met": false,
            "sla_breach_hours": 46.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:35"
          },
          {
            "ticket_id": 13818,
            "ticket_number": "3513806",
            "title": "Re: [Cockpit] Viagem TRP-2026-03253 - SSH • Lilian",
            "priority": "P2",
            "created_at": "27/03/2026 18:16:39",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 18:16:39"
          },
          {
            "ticket_id": 13819,
            "ticket_number": "3513807",
            "title": "Confirmação n. 222040",
            "priority": "P2",
            "created_at": "27/03/2026 18:16:41",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 18:32:36"
          },
          {
            "ticket_id": 13821,
            "ticket_number": "3513809",
            "title": "Confirmação n. 222041",
            "priority": "P2",
            "created_at": "27/03/2026 18:18:07",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 18:32:29"
          },
          {
            "ticket_id": 13826,
            "ticket_number": "3513814",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "27/03/2026 20:01:57",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 20:06:16"
          },
          {
            "ticket_id": 13831,
            "ticket_number": "3513819",
            "title": "Re: [Cockpit] Viagem TRP-2026-03326 - DJE • Susana",
            "priority": "P2",
            "created_at": "27/03/2026 21:08:36",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:08:36"
          },
          {
            "ticket_id": 13834,
            "ticket_number": "3513822",
            "title": "Re: [Cockpit] Viagem TRP-2026-04515 - Viagem a Mál",
            "priority": "P2",
            "created_at": "27/03/2026 21:08:44",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:08:44"
          },
          {
            "ticket_id": 13835,
            "ticket_number": "3513823",
            "title": "GBN-115558 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 21:08:47",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/03/2026 21:08:48"
          },
          {
            "ticket_id": 13836,
            "ticket_number": "3513824",
            "title": "GBN-115562 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/03/2026 22:07:53",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 22:07:53"
          },
          {
            "ticket_id": 13837,
            "ticket_number": "3513825",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "27/03/2026 22:07:55",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:11:55"
          },
          {
            "ticket_id": 13838,
            "ticket_number": "3513826",
            "title": "Reserva confirmada: Go City Paris Pass - Civitatis",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:25",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:13:22"
          },
          {
            "ticket_id": 13839,
            "ticket_number": "3513827",
            "title": "Fwd: Viagify informa sobre a sua reserva 126415561",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:28",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 22:43:28"
          },
          {
            "ticket_id": 13840,
            "ticket_number": "3513828",
            "title": "Fwd: Viagify informa sobre a sua reserva 126415561",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:31",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 22:43:32"
          },
          {
            "ticket_id": 13841,
            "ticket_number": "3513829",
            "title": "Reserva confirmada: Go City Paris Pass - Civitatis",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:35",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:15:35"
          },
          {
            "ticket_id": 13845,
            "ticket_number": "3513833",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 23:07:29",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/03/2026 23:07:29"
          },
          {
            "ticket_id": 13846,
            "ticket_number": "3513834",
            "title": "GBN-115567 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/03/2026 23:07:32",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/03/2026 23:07:32"
          },
          {
            "ticket_id": 13849,
            "ticket_number": "3513837",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "27/03/2026 23:29:07",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:56:13"
          },
          {
            "ticket_id": 13850,
            "ticket_number": "3513838",
            "title": "GBN-115564 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/03/2026 23:55:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:58:35"
          },
          {
            "ticket_id": 13851,
            "ticket_number": "3513839",
            "title": "GBN-115564 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/03/2026 23:55:07",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:55:07"
          },
          {
            "ticket_id": 13853,
            "ticket_number": "3513841",
            "title": "Envio de Transacção 1 049679/26",
            "priority": "P2",
            "created_at": "28/03/2026 10:04:58",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:06:05"
          },
          {
            "ticket_id": 13854,
            "ticket_number": "3513842",
            "title": "GBN-115570 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/03/2026 10:05:02",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 10:05:02"
          },
          {
            "ticket_id": 13864,
            "ticket_number": "3513852",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "28/03/2026 12:13:39",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 12:43:42"
          },
          {
            "ticket_id": 13865,
            "ticket_number": "3513853",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "28/03/2026 12:13:40",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 12:43:51"
          },
          {
            "ticket_id": 13872,
            "ticket_number": "3513860",
            "title": "Criação de processo File 437112/26",
            "priority": "Reservas sem Formulário",
            "created_at": "28/03/2026 13:07:52",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 50.6,
            "sla_met": false,
            "sla_breach_hours": 26.6,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:34"
          },
          {
            "ticket_id": 13881,
            "ticket_number": "3513869",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604603898",
            "priority": "Reservas sem Formulário",
            "created_at": "28/03/2026 16:02:31",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 47.7,
            "sla_met": false,
            "sla_breach_hours": 23.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 15:44:34"
          },
          {
            "ticket_id": 13882,
            "ticket_number": "3513870",
            "title": "Número de informação da reserva: 6143902",
            "priority": "P2",
            "created_at": "28/03/2026 16:02:33",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:26:12"
          },
          {
            "ticket_id": 13883,
            "ticket_number": "3513871",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "28/03/2026 16:02:42",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:18:11"
          },
          {
            "ticket_id": 13884,
            "ticket_number": "3513872",
            "title": "GBN-115651 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "28/03/2026 17:13:36",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/03/2026 17:13:36"
          },
          {
            "ticket_id": 13894,
            "ticket_number": "3513882",
            "title": "[Cancelamento Serviço] TRP-2026-04547 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/03/2026 17:33:02",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/03/2026 17:33:02"
          },
          {
            "ticket_id": 13898,
            "ticket_number": "3513886",
            "title": "Fwd: Viagify informa sobre a sua reserva 126454795",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:05",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:48:06"
          },
          {
            "ticket_id": 13899,
            "ticket_number": "3513887",
            "title": "Fwd: Viagify informa sobre a sua reserva 126454795",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:08",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:48:09"
          },
          {
            "ticket_id": 13901,
            "ticket_number": "3513889",
            "title": "RV: Bom dia Manuel Pimentel Santos: Bilhete e info",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:15",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:57:15"
          },
          {
            "ticket_id": 13902,
            "ticket_number": "3513890",
            "title": "RV: Bom dia Mariana Pimentel Santos: Bilhete e inf",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:20",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:56:36"
          },
          {
            "ticket_id": 13904,
            "ticket_number": "3513892",
            "title": "RV: Bom dia Jose Manuel Pimentel Santos: Bilhete e",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:28",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:55:54"
          },
          {
            "ticket_id": 13905,
            "ticket_number": "3513893",
            "title": "RV: Bom dia Filipa Ceppas: Bilhete e informações p",
            "priority": "P2",
            "created_at": "30/03/2026 09:48:32",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:54:37"
          },
          {
            "ticket_id": 13909,
            "ticket_number": "3513897",
            "title": "GBN-115719 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:13",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:50:13"
          },
          {
            "ticket_id": 13910,
            "ticket_number": "3513898",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 7",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:16",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13913,
            "ticket_number": "3513901",
            "title": "Número de informação da reserva: 6143966",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:23",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13914,
            "ticket_number": "3513902",
            "title": "Confirmação de reserva com localizador: 4145657",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:25",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13915,
            "ticket_number": "3513903",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:39",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13917,
            "ticket_number": "3513905",
            "title": "Solole. Booking 9Y8BS7EK is close to entering expe",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:46",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 11:00:16"
          },
          {
            "ticket_id": 13918,
            "ticket_number": "3513906",
            "title": "X7NZLG – Alteração de Horário - Aceite",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:50",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 10:48:02"
          },
          {
            "ticket_id": 13920,
            "ticket_number": "3513908",
            "title": "GBN-115700 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:56",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:50:56"
          },
          {
            "ticket_id": 13921,
            "ticket_number": "3513909",
            "title": "Confirmação de reserva com localizador: 4145655",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:58",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:04"
          },
          {
            "ticket_id": 13924,
            "ticket_number": "3513912",
            "title": "Fwd: Actualización rápida sobre su vuelo ATH.",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:12",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:13"
          },
          {
            "ticket_id": 13925,
            "ticket_number": "3513913",
            "title": "Fwd: K11GPJ | Extras para a tua viagem para Malta",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:15",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:16"
          },
          {
            "ticket_id": 13927,
            "ticket_number": "3513915",
            "title": "Fwd: Your flight TO7678 to Faro has been delayed",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:21",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:22"
          },
          {
            "ticket_id": 13930,
            "ticket_number": "3513918",
            "title": "Fwd: AMADEUS: Your User Account Lock in PRD",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:29",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:29"
          },
          {
            "ticket_id": 13934,
            "ticket_number": "3513922",
            "title": "Fwd: Ya puede facturar online para su vuelo a Faro",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:39",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:40"
          },
          {
            "ticket_id": 13941,
            "ticket_number": "3513929",
            "title": "GBN-115692 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:32",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:52:32"
          },
          {
            "ticket_id": 13943,
            "ticket_number": "3513931",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 3",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:38",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13944,
            "ticket_number": "3513932",
            "title": "GBN-115693 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:45",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:52:45"
          },
          {
            "ticket_id": 13945,
            "ticket_number": "3513933",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:48",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 11:00:50"
          },
          {
            "ticket_id": 13947,
            "ticket_number": "3513935",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 3",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:55",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13949,
            "ticket_number": "3513937",
            "title": "GBN-115683 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:53:03",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:53:03"
          },
          {
            "ticket_id": 13951,
            "ticket_number": "3513939",
            "title": "Informação importante sobre a tua reserva 6129242",
            "priority": "P2",
            "created_at": "30/03/2026 09:53:13",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 11:01:51"
          },
          {
            "ticket_id": 13953,
            "ticket_number": "3513941",
            "title": "Informação importante sobre a tua reserva 6143741",
            "priority": "P2",
            "created_at": "30/03/2026 09:53:46",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 11:01:20"
          },
          {
            "ticket_id": 13959,
            "ticket_number": "3513947",
            "title": "Criação de processo File   437147  /26",
            "priority": "P2",
            "created_at": "30/03/2026 09:54:15",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13970,
            "ticket_number": "3513958",
            "title": "Criação de processo File 437201/26",
            "priority": "P2",
            "created_at": "30/03/2026 11:12:08",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:02:18"
          },
          {
            "ticket_id": 13971,
            "ticket_number": "3513959",
            "title": "Confirmação de reserva com localizador: 4146621",
            "priority": "P2",
            "created_at": "30/03/2026 13:08:46",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:37"
          },
          {
            "ticket_id": 13972,
            "ticket_number": "3513960",
            "title": "Fwd: Contactos Turkish Airlines - Portugal | Uma F",
            "priority": "P2",
            "created_at": "30/03/2026 13:08:48",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:08:49"
          },
          {
            "ticket_id": 13973,
            "ticket_number": "3513961",
            "title": "GBN-115787 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 13:08:52",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:08:52"
          },
          {
            "ticket_id": 13976,
            "ticket_number": "3513964",
            "title": "Fwd: Request received for Isadora Resende",
            "priority": "P2",
            "created_at": "30/03/2026 13:08:59",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:09:00"
          },
          {
            "ticket_id": 13979,
            "ticket_number": "3513967",
            "title": "GBN-115690 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/03/2026 13:09:12",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:37"
          },
          {
            "ticket_id": 13981,
            "ticket_number": "3513969",
            "title": "GBN-115717 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/03/2026 13:09:17",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:37"
          },
          {
            "ticket_id": 13988,
            "ticket_number": "3513976",
            "title": "Fwd: acesso ASA Algarve",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:25",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:15:25"
          },
          {
            "ticket_id": 13990,
            "ticket_number": "3513978",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:30",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:38"
          },
          {
            "ticket_id": 13991,
            "ticket_number": "3513979",
            "title": "Información de reserva número:",
            "priority": "Reservas sem Formulário",
            "created_at": "30/03/2026 13:57:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/03/2026 17:42:46"
          },
          {
            "ticket_id": 14003,
            "ticket_number": "3513991",
            "title": "Fwd: Viagify informa sobre a sua reserva 126486795",
            "priority": "P2",
            "created_at": "30/03/2026 16:00:36",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:00:37"
          },
          {
            "ticket_id": 14004,
            "ticket_number": "3513992",
            "title": "Fwd: Viagify informa sobre a sua reserva 126486795",
            "priority": "P2",
            "created_at": "30/03/2026 16:00:39",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:00:39"
          },
          {
            "ticket_id": 14017,
            "ticket_number": "3514005",
            "title": "Confirmação de reserva com localizador: 4147755",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:27",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 23:03:23"
          },
          {
            "ticket_id": 14018,
            "ticket_number": "3514006",
            "title": "Pagamento da reserva – Ref PP215172, Sr. FILIPE AN",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:29",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 23:03:46"
          },
          {
            "ticket_id": 14021,
            "ticket_number": "3514009",
            "title": "GBN-115905 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:37",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 19:40:37"
          },
          {
            "ticket_id": 14025,
            "ticket_number": "3514013",
            "title": "Confirmação de reserva com localizador: 4147799",
            "priority": "P2",
            "created_at": "30/03/2026 19:53:32",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 20:35:35"
          },
          {
            "ticket_id": 14028,
            "ticket_number": "3514016",
            "title": "Criação de processo File 437290/26",
            "priority": "P2",
            "created_at": "30/03/2026 21:14:15",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 23:06:40"
          },
          {
            "ticket_id": 14078,
            "ticket_number": "3514066",
            "title": "Fwd: Viagify informa sobre a sua reserva 126517065",
            "priority": "P2",
            "created_at": "31/03/2026 11:40:06",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:40:07"
          },
          {
            "ticket_id": 14084,
            "ticket_number": "3514072",
            "title": "Fwd: Informações da reserva TTN-1256711552#9771835",
            "priority": "P2",
            "created_at": "31/03/2026 13:50:59",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 13:51:00"
          },
          {
            "ticket_id": 14086,
            "ticket_number": "3514074",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "31/03/2026 14:52:47",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 18:41:09"
          },
          {
            "ticket_id": 14087,
            "ticket_number": "3514075",
            "title": "GBN-116029 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "31/03/2026 14:52:51",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 14:52:51"
          },
          {
            "ticket_id": 14088,
            "ticket_number": "3514076",
            "title": "Fwd: C13W7G | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "31/03/2026 14:52:56",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 14:52:56"
          },
          {
            "ticket_id": 14091,
            "ticket_number": "3514079",
            "title": "Confirmação de Reserva * FILE 437298/26",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:19",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 5.38,
            "sla_met": false,
            "sla_breach_hours": 1.38,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:20:41"
          },
          {
            "ticket_id": 14109,
            "ticket_number": "3514097",
            "title": "Reserva confirmada: Visita a uma plantação de abac",
            "priority": "P2",
            "created_at": "31/03/2026 15:43:53",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:58:35"
          },
          {
            "ticket_id": 14110,
            "ticket_number": "3514098",
            "title": "Reserva confirmada: Visita a uma plantação de abac",
            "priority": "P2",
            "created_at": "31/03/2026 15:43:55",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:58:48"
          },
          {
            "ticket_id": 14115,
            "ticket_number": "3514103",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "31/03/2026 16:15:09",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:15:09"
          },
          {
            "ticket_id": 14116,
            "ticket_number": "3514104",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "31/03/2026 16:15:13",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:15:13"
          },
          {
            "ticket_id": 14118,
            "ticket_number": "3514106",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "31/03/2026 16:15:18",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:15:19"
          },
          {
            "ticket_id": 14119,
            "ticket_number": "3514107",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "31/03/2026 16:15:27",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:15:27"
          },
          {
            "ticket_id": 14123,
            "ticket_number": "3514111",
            "title": "GBN Travel: Reenvío de confirmación de reserva - G",
            "priority": "P2",
            "created_at": "31/03/2026 16:29:16",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:29:16"
          },
          {
            "ticket_id": 14124,
            "ticket_number": "3514112",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "31/03/2026 16:29:20",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:29:20"
          },
          {
            "ticket_id": 14134,
            "ticket_number": "3514122",
            "title": "GBN-116004 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/03/2026 18:43:10",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:23:17"
          },
          {
            "ticket_id": 14135,
            "ticket_number": "3514123",
            "title": "GBN-116049 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/03/2026 18:43:12",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:23:24"
          },
          {
            "ticket_id": 14139,
            "ticket_number": "3514127",
            "title": "GBN-116033 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/03/2026 19:50:01",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:28:20"
          },
          {
            "ticket_id": 14140,
            "ticket_number": "3514128",
            "title": "Informação de reserva - SPT002601616095",
            "priority": "P2",
            "created_at": "31/03/2026 19:50:10",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:28:44"
          },
          {
            "ticket_id": 14141,
            "ticket_number": "3514129",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "31/03/2026 19:50:12",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:29:34"
          },
          {
            "ticket_id": 14146,
            "ticket_number": "3514134",
            "title": "Reserva confirmada: Tour da Anne Frank pelo bairro",
            "priority": "P2",
            "created_at": "31/03/2026 21:23:36",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 21:54:38"
          },
          {
            "ticket_id": 14147,
            "ticket_number": "3514135",
            "title": "Reserva confirmada: Tour da Anne Frank pelo bairro",
            "priority": "P2",
            "created_at": "31/03/2026 21:23:39",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 21:54:23"
          },
          {
            "ticket_id": 14168,
            "ticket_number": "3514156",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "01/04/2026 10:41:50",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 11:41:15"
          },
          {
            "ticket_id": 14183,
            "ticket_number": "3514171",
            "title": "Fwd: Viagify informa sobre a sua reserva 126559836",
            "priority": "P2",
            "created_at": "01/04/2026 14:28:23",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:28:23"
          },
          {
            "ticket_id": 14193,
            "ticket_number": "3514181",
            "title": "[Cancelamento Serviço] TRP-2026-04583 / TRL-2026-0",
            "priority": "P2",
            "created_at": "01/04/2026 15:56:04",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 15:56:04"
          },
          {
            "ticket_id": 14198,
            "ticket_number": "3514186",
            "title": "Fwd: C13W7G | Alterações à sua reserva?",
            "priority": "P2",
            "created_at": "01/04/2026 17:04:47",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 17:04:47"
          },
          {
            "ticket_id": 14202,
            "ticket_number": "3514190",
            "title": "Reserva confirmada: Passeio de catamarã solar por ",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:39",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:40:17"
          },
          {
            "ticket_id": 14203,
            "ticket_number": "3514191",
            "title": "Reserva confirmada: Passeio de catamarã solar por ",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:42",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:40:33"
          },
          {
            "ticket_id": 14209,
            "ticket_number": "3514197",
            "title": "Confirmation of booking with locator77A9M6AS",
            "priority": "P2",
            "created_at": "01/04/2026 19:09:05",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:43:40"
          },
          {
            "ticket_id": 14212,
            "ticket_number": "3514200",
            "title": "Reserva confirmada: Excursão ao lago de Como, Luga",
            "priority": "P2",
            "created_at": "01/04/2026 20:05:11",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:44:59"
          },
          {
            "ticket_id": 14213,
            "ticket_number": "3514201",
            "title": "Reserva confirmada: Free tour pela Milão desconhec",
            "priority": "P2",
            "created_at": "01/04/2026 20:05:14",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:45:10"
          },
          {
            "ticket_id": 14214,
            "ticket_number": "3514202",
            "title": "Reserva confirmada: Excursão ao lago de Como, Luga",
            "priority": "P2",
            "created_at": "01/04/2026 20:05:16",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:45:18"
          },
          {
            "ticket_id": 14215,
            "ticket_number": "3514203",
            "title": "Reserva confirmada: Free tour pela Milão desconhec",
            "priority": "P2",
            "created_at": "01/04/2026 20:05:19",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:45:23"
          },
          {
            "ticket_id": 14218,
            "ticket_number": "3514206",
            "title": "GBN-116405 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/04/2026 21:14:26",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 21:14:26"
          },
          {
            "ticket_id": 14222,
            "ticket_number": "3514210",
            "title": "Reserva confirmada: Excursão de barco e snorkel na",
            "priority": "P2",
            "created_at": "01/04/2026 22:16:31",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:49:24"
          },
          {
            "ticket_id": 14223,
            "ticket_number": "3514211",
            "title": "Confirmação de reserva com localizador: 4152139",
            "priority": "P2",
            "created_at": "01/04/2026 22:16:33",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:49:32"
          },
          {
            "ticket_id": 14224,
            "ticket_number": "3514212",
            "title": "Mensagem sobre a reserva 38068653 - Civitatis",
            "priority": "P2",
            "created_at": "01/04/2026 22:16:35",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:49:50"
          },
          {
            "ticket_id": 14225,
            "ticket_number": "3514213",
            "title": "Reserva confirmada: Excursão de barco e snorkel na",
            "priority": "P2",
            "created_at": "01/04/2026 22:16:37",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:49:56"
          },
          {
            "ticket_id": 14226,
            "ticket_number": "3514214",
            "title": "GBN-116409 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/04/2026 22:16:42",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:16:42"
          },
          {
            "ticket_id": 14260,
            "ticket_number": "3514248",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "02/04/2026 14:07:11",
            "close_date": "2026-04-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/04/2026 17:49:53"
          },
          {
            "ticket_id": 14280,
            "ticket_number": "3514268",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 17:02:53",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:02:53"
          },
          {
            "ticket_id": 14281,
            "ticket_number": "3514269",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 17:03:00",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:03:00"
          },
          {
            "ticket_id": 14282,
            "ticket_number": "3514270",
            "title": "GBN-116567 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/04/2026 17:03:05",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:03:05"
          },
          {
            "ticket_id": 14283,
            "ticket_number": "3514271",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 17:03:09",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:20:42"
          },
          {
            "ticket_id": 14284,
            "ticket_number": "3514272",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 17:03:13",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:21:03"
          },
          {
            "ticket_id": 14294,
            "ticket_number": "3514282",
            "title": "Reserva confirmada: Ingresso para o Loro Parque - ",
            "priority": "P2",
            "created_at": "02/04/2026 18:40:42",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:40:42"
          },
          {
            "ticket_id": 14296,
            "ticket_number": "3514284",
            "title": "Reserva confirmada: Parasailing em Sharm el-Sheikh",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:13",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:18:33"
          },
          {
            "ticket_id": 14297,
            "ticket_number": "3514285",
            "title": "Reserva confirmada: Excursão ao deserto do Sinai c",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:15",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:52:38"
          },
          {
            "ticket_id": 14298,
            "ticket_number": "3514286",
            "title": "Reserva confirmada: Parasailing em Sharm el-Sheikh",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:17",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:54:56"
          },
          {
            "ticket_id": 14299,
            "ticket_number": "3514287",
            "title": "Reserva confirmada: Snorkel no Parque Nacional Ras",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:20",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:55:01"
          },
          {
            "ticket_id": 14300,
            "ticket_number": "3514288",
            "title": "Reserva confirmada: Snorkel no Parque Nacional Ras",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:23",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:55:06"
          },
          {
            "ticket_id": 14301,
            "ticket_number": "3514289",
            "title": "Reserva confirmada: Excursão ao deserto do Sinai c",
            "priority": "P2",
            "created_at": "02/04/2026 19:20:26",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 20:55:15"
          },
          {
            "ticket_id": 14304,
            "ticket_number": "3514292",
            "title": "Reserva confirmada: Tour de buggy ou quadriciclo p",
            "priority": "P2",
            "created_at": "02/04/2026 20:29:51",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 21:57:55"
          },
          {
            "ticket_id": 14305,
            "ticket_number": "3514293",
            "title": "Reserva confirmada: Tour de buggy ou quadriciclo p",
            "priority": "P2",
            "created_at": "02/04/2026 20:29:54",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 21:58:26"
          },
          {
            "ticket_id": 14306,
            "ticket_number": "3514294",
            "title": "GBN-116627 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/04/2026 20:30:00",
            "close_date": "2026-04-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/04/2026 20:30:00"
          },
          {
            "ticket_id": 14309,
            "ticket_number": "3514297",
            "title": "GBN-116545 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/04/2026 22:30:34",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 22:36:13"
          },
          {
            "ticket_id": 14325,
            "ticket_number": "3514313",
            "title": "Confirmação de reserva com localizador: 4154194",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:44",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 11:20:46"
          },
          {
            "ticket_id": 14326,
            "ticket_number": "3514314",
            "title": "Reserva Aérea XLGIBM",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:46",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 12:56:11"
          },
          {
            "ticket_id": 14328,
            "ticket_number": "3514316",
            "title": "Reserva Aérea XLG4HD",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:50",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 12:53:26"
          },
          {
            "ticket_id": 14334,
            "ticket_number": "3514322",
            "title": "Confirmação de reserva com localizador: 4154056",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:01",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 11:23:57"
          },
          {
            "ticket_id": 14337,
            "ticket_number": "3514325",
            "title": "Número de informação da reserva: 6144480",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:08",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 12:52:44"
          },
          {
            "ticket_id": 14341,
            "ticket_number": "3514329",
            "title": "Reserva Aérea XG8RNC",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:20",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 12:57:46"
          },
          {
            "ticket_id": 14342,
            "ticket_number": "3514330",
            "title": "Criação de processo File 437711/26",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:26",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 11:21:34"
          },
          {
            "ticket_id": 14347,
            "ticket_number": "3514335",
            "title": "GBN-116749 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/04/2026 13:06:00",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 13:06:01"
          },
          {
            "ticket_id": 14348,
            "ticket_number": "3514336",
            "title": "Criação de processo File 437731/26",
            "priority": "P2",
            "created_at": "04/04/2026 13:06:07",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 4.97,
            "sla_met": false,
            "sla_breach_hours": 0.97,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 18:04:24"
          },
          {
            "ticket_id": 14355,
            "ticket_number": "3514343",
            "title": "GBN-116782 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/04/2026 18:04:25",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 18:04:25"
          },
          {
            "ticket_id": 14360,
            "ticket_number": "3514348",
            "title": "Fwd: Última chamada: A tua viagem para Malaga",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:21",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:09:22"
          },
          {
            "ticket_id": 14369,
            "ticket_number": "3514357",
            "title": "Fwd: Viagify informa sobre a sua reserva 126640796",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:49",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:09:49"
          },
          {
            "ticket_id": 14370,
            "ticket_number": "3514358",
            "title": "Fwd: Viagify informa sobre a sua reserva 126640796",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:51",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:09:52"
          },
          {
            "ticket_id": 14371,
            "ticket_number": "3514359",
            "title": "Fwd: Viagify informa sobre a sua reserva 126640804",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:54",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:09:54"
          },
          {
            "ticket_id": 14372,
            "ticket_number": "3514360",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604607269",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:56",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:18:11"
          },
          {
            "ticket_id": 14374,
            "ticket_number": "3514362",
            "title": "Mensagem sobre a reserva 38094626 - Civitatis",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:59",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:19:29"
          },
          {
            "ticket_id": 14378,
            "ticket_number": "3514366",
            "title": "Fwd: Viagify informa sobre a sua reserva 126640804",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:09",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:09"
          },
          {
            "ticket_id": 14380,
            "ticket_number": "3514368",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:16",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14381,
            "ticket_number": "3514369",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:19",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14383,
            "ticket_number": "3514371",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:28",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14385,
            "ticket_number": "3514373",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:33",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:31"
          },
          {
            "ticket_id": 14386,
            "ticket_number": "3514374",
            "title": "Fwd: Nova Viagem #251100189 - O mundo à tua espera",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:34",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:35"
          },
          {
            "ticket_id": 14387,
            "ticket_number": "3514375",
            "title": "Confirmacao 343829",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:37",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 11:19:42"
          },
          {
            "ticket_id": 14388,
            "ticket_number": "3514376",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:40",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:31"
          },
          {
            "ticket_id": 14389,
            "ticket_number": "3514377",
            "title": "Fwd: Nova Viagem #251100189 - O mundo à tua espera",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:42",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:42"
          },
          {
            "ticket_id": 14390,
            "ticket_number": "3514378",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:45",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:31"
          },
          {
            "ticket_id": 14391,
            "ticket_number": "3514379",
            "title": "Confirmacao 343824",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:47",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:58:10"
          },
          {
            "ticket_id": 14392,
            "ticket_number": "3514380",
            "title": "GBN-116791 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:50",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:50"
          },
          {
            "ticket_id": 14393,
            "ticket_number": "3514381",
            "title": "GBN-116792 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:54",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:54"
          },
          {
            "ticket_id": 14397,
            "ticket_number": "3514385",
            "title": "Reserva confirmada: Tour pelo ilhéu de Vila Franca",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:08",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:59:26"
          },
          {
            "ticket_id": 14398,
            "ticket_number": "3514386",
            "title": "Fwd: easyJet nÃºmero de referÃªncia da reserva: KC",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:11",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:12:11"
          },
          {
            "ticket_id": 14402,
            "ticket_number": "3514390",
            "title": "Reserva confirmada: Tour pelo ilhéu de Vila Franca",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:20",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:04:35"
          },
          {
            "ticket_id": 14403,
            "ticket_number": "3514391",
            "title": "GBN-116850 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:23",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:12:23"
          },
          {
            "ticket_id": 14404,
            "ticket_number": "3514392",
            "title": "Fwd: An important message regarding flight TP781",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:25",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:12:25"
          },
          {
            "ticket_id": 14412,
            "ticket_number": "3514400",
            "title": "Confirmação de reserva. Localizador: 9MEVOKWPHO",
            "priority": "P2",
            "created_at": "06/04/2026 11:29:37",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:57:48"
          },
          {
            "ticket_id": 14413,
            "ticket_number": "3514401",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 9",
            "priority": "P2",
            "created_at": "06/04/2026 11:29:39",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:01:43"
          },
          {
            "ticket_id": 14418,
            "ticket_number": "3514406",
            "title": "Webinar - MSC Cruzeiros- Novas Campanhas- Itinerár",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:22",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:55:02"
          },
          {
            "ticket_id": 14419,
            "ticket_number": "3514407",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:32",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:22:59"
          },
          {
            "ticket_id": 14420,
            "ticket_number": "3514408",
            "title": "Mensagem sobre a reserva 35655588 - Civitatis",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:36",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:05:56"
          },
          {
            "ticket_id": 14426,
            "ticket_number": "3514414",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "06/04/2026 13:21:52",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:23:36"
          },
          {
            "ticket_id": 14427,
            "ticket_number": "3514415",
            "title": "Pedido de correção no cockpit - Comissões a recebe",
            "priority": "P2",
            "created_at": "06/04/2026 13:21:53",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:21:53"
          },
          {
            "ticket_id": 14428,
            "ticket_number": "3514416",
            "title": "Re: [Cockpit] Viagem TRP-2026-04606 - Atividades B",
            "priority": "P2",
            "created_at": "06/04/2026 13:39:52",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:39:52"
          },
          {
            "ticket_id": 14429,
            "ticket_number": "3514417",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "06/04/2026 13:39:57",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:33:55"
          },
          {
            "ticket_id": 14432,
            "ticket_number": "3514420",
            "title": "GBN-116905 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 13:40:23",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:40:23"
          },
          {
            "ticket_id": 14434,
            "ticket_number": "3514422",
            "title": "[Cancelamento Serviço] TRP-2026-04631 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 14:36:12",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 14:36:12"
          },
          {
            "ticket_id": 14439,
            "ticket_number": "3514427",
            "title": "GBN-116904 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:07",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 17:16:28"
          },
          {
            "ticket_id": 14440,
            "ticket_number": "3514428",
            "title": "GBN-116902 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:09",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 17:17:06"
          },
          {
            "ticket_id": 14441,
            "ticket_number": "3514429",
            "title": "GBN-116904 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:15",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:15"
          },
          {
            "ticket_id": 14443,
            "ticket_number": "3514431",
            "title": "GBN-116878 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:21",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 17:17:59"
          },
          {
            "ticket_id": 14444,
            "ticket_number": "3514432",
            "title": "GBN-116902 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:23",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:23"
          },
          {
            "ticket_id": 14447,
            "ticket_number": "3514435",
            "title": "GBN-116906 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:32",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:32"
          },
          {
            "ticket_id": 14450,
            "ticket_number": "3514438",
            "title": "Número de informação da reserva: 6144606",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:40",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:47:16"
          },
          {
            "ticket_id": 14453,
            "ticket_number": "3514441",
            "title": "Fwd: Viagify informa sobre a sua reserva 126681747",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:43",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:01:44"
          },
          {
            "ticket_id": 14456,
            "ticket_number": "3514444",
            "title": "Fwd: Flight AC813 to Montréal has a new departure ",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:51",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:01:52"
          },
          {
            "ticket_id": 14457,
            "ticket_number": "3514445",
            "title": "Documentação Disponível - Reserva 339794",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:55",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 17:15:19"
          },
          {
            "ticket_id": 14458,
            "ticket_number": "3514446",
            "title": "Fwd: Informações da reserva TTN-1238254461#9812068",
            "priority": "P2",
            "created_at": "06/04/2026 16:01:57",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:01:57"
          },
          {
            "ticket_id": 14460,
            "ticket_number": "3514448",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "06/04/2026 18:23:01",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:37:56"
          },
          {
            "ticket_id": 14465,
            "ticket_number": "3514453",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:40",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:40"
          },
          {
            "ticket_id": 14466,
            "ticket_number": "3514454",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:46",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:46"
          },
          {
            "ticket_id": 14467,
            "ticket_number": "3514455",
            "title": "Fwd: Viagify informa sobre a sua reserva 126683690",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:51",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:52"
          },
          {
            "ticket_id": 14468,
            "ticket_number": "3514456",
            "title": "Confirmação de reserva. Localizador: 5FB1FXZ0LD",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:54",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:59:52"
          },
          {
            "ticket_id": 14469,
            "ticket_number": "3514457",
            "title": "Fwd: Smytravel B2B Factura 4600207759.pdf- File 24",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:56",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:57"
          },
          {
            "ticket_id": 14470,
            "ticket_number": "3514458",
            "title": "Confirmação de Reserva File 432293/26",
            "priority": "P2",
            "created_at": "06/04/2026 18:42:03",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:25:23"
          },
          {
            "ticket_id": 14473,
            "ticket_number": "3514461",
            "title": "Confirmación del Loc 9123558",
            "priority": "P2",
            "created_at": "06/04/2026 18:42:10",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:29:35"
          },
          {
            "ticket_id": 14475,
            "ticket_number": "3514463",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 5",
            "priority": "P2",
            "created_at": "06/04/2026 18:42:38",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:34:07"
          },
          {
            "ticket_id": 14476,
            "ticket_number": "3514464",
            "title": "Pedido de acessos Vila Galé",
            "priority": "P2",
            "created_at": "06/04/2026 20:22:15",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 20:22:15"
          },
          {
            "ticket_id": 14480,
            "ticket_number": "3514468",
            "title": "Número de informação da reserva: 6144656",
            "priority": "P2",
            "created_at": "06/04/2026 20:48:24",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:37:38"
          },
          {
            "ticket_id": 14481,
            "ticket_number": "3514469",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604608019",
            "priority": "P2",
            "created_at": "06/04/2026 20:48:25",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:37:55"
          },
          {
            "ticket_id": 14486,
            "ticket_number": "3514474",
            "title": "Confirmación del Loc 9123665",
            "priority": "P2",
            "created_at": "06/04/2026 21:12:26",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:02:15"
          },
          {
            "ticket_id": 14488,
            "ticket_number": "3514476",
            "title": "[Cancelamento Serviço] TRP-2026-04606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 21:20:58",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:20:58"
          },
          {
            "ticket_id": 14489,
            "ticket_number": "3514477",
            "title": "[Cancelamento Serviço] TRP-2026-04606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 21:21:10",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:21:10"
          },
          {
            "ticket_id": 14490,
            "ticket_number": "3514478",
            "title": "[Cancelamento Serviço] TRP-2026-04606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 21:21:26",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:21:27"
          },
          {
            "ticket_id": 14491,
            "ticket_number": "3514479",
            "title": "[Cancelamento Serviço] TRP-2026-04606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 21:26:07",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:26:08"
          },
          {
            "ticket_id": 14499,
            "ticket_number": "3514487",
            "title": "Fwd: Viagify informa sobre a sua reserva 126694472",
            "priority": "P2",
            "created_at": "06/04/2026 22:58:02",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:58:03"
          },
          {
            "ticket_id": 14500,
            "ticket_number": "3514488",
            "title": "Fwd: Viagify informa sobre a sua reserva 126694472",
            "priority": "P2",
            "created_at": "06/04/2026 22:58:05",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:58:05"
          },
          {
            "ticket_id": 14501,
            "ticket_number": "3514489",
            "title": "GBN-116968 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/04/2026 23:01:00",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 10.37,
            "sla_met": false,
            "sla_breach_hours": 6.37,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 09:23:28"
          },
          {
            "ticket_id": 14502,
            "ticket_number": "3514490",
            "title": "RE: Pagamento 6125288",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:20",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:00:17"
          },
          {
            "ticket_id": 14504,
            "ticket_number": "3514492",
            "title": "RE: Pagamento 6126963",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:24",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 10:24:51"
          },
          {
            "ticket_id": 14505,
            "ticket_number": "3514493",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:26",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:00:17"
          },
          {
            "ticket_id": 14506,
            "ticket_number": "3514494",
            "title": "RE: Pagamento 6143935",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:27",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:00:17"
          },
          {
            "ticket_id": 14508,
            "ticket_number": "3514496",
            "title": "A reserva A38065198 foi paga e confirmada",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:31",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 09:25:13"
          },
          {
            "ticket_id": 14509,
            "ticket_number": "3514497",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "07/04/2026 09:12:50",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:00:17"
          },
          {
            "ticket_id": 14511,
            "ticket_number": "3514499",
            "title": "Informação importante sobre a tua reserva 6117515",
            "priority": "P2",
            "created_at": "07/04/2026 10:07:31",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 14:00:24"
          },
          {
            "ticket_id": 14513,
            "ticket_number": "3514501",
            "title": "Confirmação de reserva com localizador: 4157186",
            "priority": "P2",
            "created_at": "07/04/2026 10:17:35",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 5.73,
            "sla_met": false,
            "sla_breach_hours": 1.73,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:02:21"
          },
          {
            "ticket_id": 14514,
            "ticket_number": "3514502",
            "title": "Fwd: Informações da reserva TTN-1265170657#9817129",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:14",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:38:15"
          },
          {
            "ticket_id": 14516,
            "ticket_number": "3514504",
            "title": "Cancelamento de reserva 332357",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:19",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 4.63,
            "sla_met": false,
            "sla_breach_hours": 0.63,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:16:27"
          },
          {
            "ticket_id": 14524,
            "ticket_number": "3514512",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:36",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:38:36"
          },
          {
            "ticket_id": 14526,
            "ticket_number": "3514514",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "P2",
            "created_at": "07/04/2026 11:39:16",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 5.28,
            "sla_met": false,
            "sla_breach_hours": 1.28,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:56:42"
          },
          {
            "ticket_id": 14537,
            "ticket_number": "3514525",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "07/04/2026 12:15:50",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:15:51"
          },
          {
            "ticket_id": 14540,
            "ticket_number": "3514528",
            "title": "Fwd: Viagify informa sobre a sua reserva 126709332",
            "priority": "P2",
            "created_at": "07/04/2026 12:25:21",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:25:22"
          },
          {
            "ticket_id": 14542,
            "ticket_number": "3514530",
            "title": "Reserva de transfer em Marraquexe (Marrakech Medin",
            "priority": "P2",
            "created_at": "07/04/2026 13:12:01",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:04:17"
          },
          {
            "ticket_id": 14543,
            "ticket_number": "3514531",
            "title": "Reserva de transfer em Marrakech (Aeroporto Marrak",
            "priority": "P2",
            "created_at": "07/04/2026 13:12:03",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:04:33"
          },
          {
            "ticket_id": 14544,
            "ticket_number": "3514532",
            "title": "Reserva de transfer em Marrakech (Marrakech Medina",
            "priority": "P2",
            "created_at": "07/04/2026 13:12:07",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:10:08"
          },
          {
            "ticket_id": 14545,
            "ticket_number": "3514533",
            "title": "Reserva de transfer em Marraquexe (Aeroporto Marra",
            "priority": "P2",
            "created_at": "07/04/2026 13:12:09",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:10:21"
          },
          {
            "ticket_id": 14546,
            "ticket_number": "3514534",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "07/04/2026 13:12:11",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 17:00:42"
          },
          {
            "ticket_id": 14553,
            "ticket_number": "3514541",
            "title": "Informação de reserva - SPT002601618066",
            "priority": "P2",
            "created_at": "07/04/2026 15:11:06",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:23:48"
          },
          {
            "ticket_id": 14557,
            "ticket_number": "3514545",
            "title": "[Suporte] TRP-2026-04645 - Nome passageiro adulto ",
            "priority": "P2",
            "created_at": "07/04/2026 18:03:37",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:03:37"
          },
          {
            "ticket_id": 14559,
            "ticket_number": "3514547",
            "title": "Confirmation of booking with locatorWDWUCJED",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:17",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:32:39"
          },
          {
            "ticket_id": 14560,
            "ticket_number": "3514548",
            "title": "Cancellation of the booking with locator WDWUCJED",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:19",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:34:45"
          },
          {
            "ticket_id": 14562,
            "ticket_number": "3514550",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:24",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:25"
          },
          {
            "ticket_id": 14563,
            "ticket_number": "3514551",
            "title": "Cancellation of the booking with locator WDWUCJED",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:27",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:32:51"
          },
          {
            "ticket_id": 14564,
            "ticket_number": "3514552",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:37",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:37"
          },
          {
            "ticket_id": 14565,
            "ticket_number": "3514553",
            "title": "Reserva confirmada: Passeio na caravela de Cristóv",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:40",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:43:56"
          },
          {
            "ticket_id": 14566,
            "ticket_number": "3514554",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:44",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:44"
          },
          {
            "ticket_id": 14567,
            "ticket_number": "3514555",
            "title": "Reserva confirmada: Passeio na caravela de Cristóv",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:46",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:46:56"
          },
          {
            "ticket_id": 14568,
            "ticket_number": "3514556",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:48",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:48"
          },
          {
            "ticket_id": 14571,
            "ticket_number": "3514559",
            "title": "Fwd: Sata4Agents - Submissão de pedido de cotação ",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:54",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:17:54"
          },
          {
            "ticket_id": 14573,
            "ticket_number": "3514561",
            "title": "Informação de reserva - SPT002601618066",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:05",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 15.25,
            "sla_met": false,
            "sla_breach_hours": 11.25,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:33:21"
          },
          {
            "ticket_id": 14574,
            "ticket_number": "3514562",
            "title": "Fwd: resposta ao pedido TTN-1199230549#98224518#T1",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:07",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:18:08"
          },
          {
            "ticket_id": 14575,
            "ticket_number": "3514563",
            "title": "Fwd: Viagify informa sobre a sua reserva 126721112",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:11",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:18:11"
          },
          {
            "ticket_id": 14576,
            "ticket_number": "3514564",
            "title": "RESERVA 1784191 W2MCS:016890003005",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:15",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 15.2,
            "sla_met": false,
            "sla_breach_hours": 11.2,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:31:05"
          },
          {
            "ticket_id": 14577,
            "ticket_number": "3514565",
            "title": "RGPD e CVO",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:17",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:18:17"
          },
          {
            "ticket_id": 14578,
            "ticket_number": "3514566",
            "title": "Informação",
            "priority": "P2",
            "created_at": "07/04/2026 18:18:19",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:26:51"
          },
          {
            "ticket_id": 14580,
            "ticket_number": "3514568",
            "title": "Fwd: Viagify informa sobre a sua reserva 126717218",
            "priority": "Reservas sem Formulário",
            "created_at": "07/04/2026 18:22:24",
            "close_date": "2026-04-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/04/2026 18:22:24"
          },
          {
            "ticket_id": 14581,
            "ticket_number": "3514569",
            "title": "Fwd: Viagify informa sobre a sua reserva 126717218",
            "priority": "P2",
            "created_at": "07/04/2026 18:22:28",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:22:29"
          },
          {
            "ticket_id": 14584,
            "ticket_number": "3514572",
            "title": "Fwd: Informações da reserva TTN-1265879373#9823534",
            "priority": "P2",
            "created_at": "07/04/2026 18:57:29",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:57:30"
          },
          {
            "ticket_id": 14585,
            "ticket_number": "3514573",
            "title": "Fwd: Localizador 1265879373 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "07/04/2026 18:57:33",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:57:33"
          },
          {
            "ticket_id": 14587,
            "ticket_number": "3514575",
            "title": "Cvo assinado reserva 95291",
            "priority": "P2",
            "created_at": "07/04/2026 18:57:37",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:57:38"
          },
          {
            "ticket_id": 14592,
            "ticket_number": "3514580",
            "title": "Reserva cancelada com localizador: 4158800",
            "priority": "P2",
            "created_at": "07/04/2026 20:29:36",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 13.03,
            "sla_met": false,
            "sla_breach_hours": 9.03,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:32:02"
          },
          {
            "ticket_id": 14593,
            "ticket_number": "3514581",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604609011",
            "priority": "P2",
            "created_at": "07/04/2026 20:29:38",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 13.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:21:51"
          },
          {
            "ticket_id": 14594,
            "ticket_number": "3514582",
            "title": "Confirmação de reserva – Ref PP352739, Sr. FRANCIS",
            "priority": "P2",
            "created_at": "07/04/2026 20:29:40",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 13.42,
            "sla_met": false,
            "sla_breach_hours": 9.42,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:54:47"
          },
          {
            "ticket_id": 14597,
            "ticket_number": "3514585",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "07/04/2026 21:36:43",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 13.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:21:56"
          },
          {
            "ticket_id": 14598,
            "ticket_number": "3514586",
            "title": "GBN-117257 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/04/2026 21:36:49",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 21:36:49"
          },
          {
            "ticket_id": 14601,
            "ticket_number": "3514589",
            "title": "GBN-117265 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/04/2026 22:06:51",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:06:51"
          },
          {
            "ticket_id": 14602,
            "ticket_number": "3514590",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "07/04/2026 22:07:00",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:07:00"
          },
          {
            "ticket_id": 14603,
            "ticket_number": "3514591",
            "title": "Pedido de acesso Odisseias",
            "priority": "P2",
            "created_at": "07/04/2026 22:07:04",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:07:06"
          },
          {
            "ticket_id": 14605,
            "ticket_number": "3514593",
            "title": "Fwd: Viagify informa sobre a sua reserva 126728972",
            "priority": "P2",
            "created_at": "07/04/2026 22:35:51",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:35:52"
          },
          {
            "ticket_id": 14607,
            "ticket_number": "3514595",
            "title": "Fwd: Viagify informa sobre a sua reserva 126731030",
            "priority": "P2",
            "created_at": "07/04/2026 22:35:58",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:35:58"
          },
          {
            "ticket_id": 14608,
            "ticket_number": "3514596",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:16",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:07:17"
          },
          {
            "ticket_id": 14612,
            "ticket_number": "3514600",
            "title": "Fwd: Flight AC1884 to Cancún has a new departure t",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:28",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:07:29"
          },
          {
            "ticket_id": 14614,
            "ticket_number": "3514602",
            "title": "RE: Pagamento 6119956",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:35",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:24:45"
          },
          {
            "ticket_id": 14615,
            "ticket_number": "3514603",
            "title": "Fwd: Viagify informa sobre a sua reserva 126734552",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:38",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:07:38"
          },
          {
            "ticket_id": 14618,
            "ticket_number": "3514606",
            "title": "MSC Cruises Document - 2600101002510872",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:45",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:21:14"
          },
          {
            "ticket_id": 14619,
            "ticket_number": "3514607",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604609030",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:47",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 12:46:33"
          },
          {
            "ticket_id": 14625,
            "ticket_number": "3514613",
            "title": "***URGENTE PAGO HOY***LOC.604609030 (TRAVELPLAN CA",
            "priority": "P2",
            "created_at": "08/04/2026 10:39:58",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:31:51"
          },
          {
            "ticket_id": 14627,
            "ticket_number": "3514615",
            "title": "Cancelamento de reserva 336678",
            "priority": "P2",
            "created_at": "08/04/2026 10:40:02",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:32:27"
          },
          {
            "ticket_id": 14628,
            "ticket_number": "3514616",
            "title": "NOVA Confirmação de reserva 334667 - Alteração de ",
            "priority": "P2",
            "created_at": "08/04/2026 10:40:04",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:40:18"
          },
          {
            "ticket_id": 14630,
            "ticket_number": "3514618",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "08/04/2026 10:40:09",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:40:10"
          },
          {
            "ticket_id": 14631,
            "ticket_number": "3514619",
            "title": "NOVA Confirmação de reserva 340262",
            "priority": "P2",
            "created_at": "08/04/2026 10:40:11",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:33:02"
          },
          {
            "ticket_id": 14632,
            "ticket_number": "3514620",
            "title": "Re:[## 37404 ##] GBN-115936 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "08/04/2026 10:41:00",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:41:44"
          },
          {
            "ticket_id": 14637,
            "ticket_number": "3514625",
            "title": "Fwd: Informações da reserva TTN-1265879373#9829151",
            "priority": "P2",
            "created_at": "08/04/2026 11:29:37",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:29:38"
          },
          {
            "ticket_id": 14670,
            "ticket_number": "3514658",
            "title": "Orçamento Hotel Jupiter Albufeira",
            "priority": "P3",
            "created_at": "08/04/2026 16:50:25",
            "close_date": "2026-04-14",
            "sla_target_hours": 24,
            "actual_time_hours": 21.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/04/2026 10:27:36"
          },
          {
            "ticket_id": 14673,
            "ticket_number": "3514661",
            "title": "Fwd: Viagify informa sobre a sua reserva 126760970",
            "priority": "Reservas sem Formulário",
            "created_at": "08/04/2026 17:34:32",
            "close_date": "2026-05-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/04/2026 17:34:32"
          },
          {
            "ticket_id": 14674,
            "ticket_number": "3514662",
            "title": "Fwd: Viagify informa sobre a sua reserva 126760970",
            "priority": "Reservas sem Formulário",
            "created_at": "08/04/2026 17:50:08",
            "close_date": "2026-05-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/04/2026 17:50:09"
          },
          {
            "ticket_id": 14676,
            "ticket_number": "3514664",
            "title": "GBN-115418 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/04/2026 18:45:58",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 18:45:58"
          },
          {
            "ticket_id": 14681,
            "ticket_number": "3514669",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:18",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:45:04"
          },
          {
            "ticket_id": 14683,
            "ticket_number": "3514671",
            "title": "Confirmação de reserva com localizador: 4161104",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:22",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:43:47"
          },
          {
            "ticket_id": 14686,
            "ticket_number": "3514674",
            "title": "GBN-117429 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:30",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 21:31:30"
          },
          {
            "ticket_id": 14688,
            "ticket_number": "3514676",
            "title": "Envio de Nota de Crédito 28291/26",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:36",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:43:00"
          },
          {
            "ticket_id": 14689,
            "ticket_number": "3514677",
            "title": "Confirmação de reserva com localizador: 4161024",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:38",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:33:19"
          },
          {
            "ticket_id": 14692,
            "ticket_number": "3514680",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "08/04/2026 22:41:26",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:44:21"
          },
          {
            "ticket_id": 14693,
            "ticket_number": "3514681",
            "title": "Confirmação de reserva com localizador: 4161128",
            "priority": "P2",
            "created_at": "08/04/2026 22:41:28",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:49:09"
          },
          {
            "ticket_id": 14695,
            "ticket_number": "3514683",
            "title": "Confirmation of booking with locatorWA4CXOQH",
            "priority": "P2",
            "created_at": "08/04/2026 22:41:34",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:47:30"
          },
          {
            "ticket_id": 14697,
            "ticket_number": "3514685",
            "title": "Número de informação da reserva: 6144884",
            "priority": "P2",
            "created_at": "08/04/2026 22:42:00",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:50:46"
          },
          {
            "ticket_id": 14706,
            "ticket_number": "3514694",
            "title": "Fwd: Important: Flight change",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:11",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:18:12"
          },
          {
            "ticket_id": 14707,
            "ticket_number": "3514695",
            "title": "Fwd: Informações da reserva TTN-1265879373#9829151",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:18",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:18:19"
          },
          {
            "ticket_id": 14709,
            "ticket_number": "3514697",
            "title": "WA4CXOQH",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:23",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:06:59"
          },
          {
            "ticket_id": 14712,
            "ticket_number": "3514700",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:30",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:13:01"
          },
          {
            "ticket_id": 14713,
            "ticket_number": "3514701",
            "title": "WA4CXOQH",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:57",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 12:24:24"
          },
          {
            "ticket_id": 14715,
            "ticket_number": "3514703",
            "title": "Confirmação de bagagem TAP",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:00",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:19:01"
          },
          {
            "ticket_id": 14720,
            "ticket_number": "3514708",
            "title": "GBN-117438 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:12",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:19:12"
          },
          {
            "ticket_id": 14722,
            "ticket_number": "3514710",
            "title": "MVU: Cambio Vuelo: 4133707 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 12:18:43",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:17:54"
          },
          {
            "ticket_id": 14727,
            "ticket_number": "3514715",
            "title": "Re:[## 37545 ##] GBN-113415 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "09/04/2026 13:57:57",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 14:04:02"
          },
          {
            "ticket_id": 14758,
            "ticket_number": "3514746",
            "title": "GBN-115676 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 17:47:39",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 17:47:39"
          },
          {
            "ticket_id": 14782,
            "ticket_number": "3514770",
            "title": "Fwd: UTI43S | Bruna Filipa, última chamada para po",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:26",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:26"
          },
          {
            "ticket_id": 14785,
            "ticket_number": "3514773",
            "title": "Fwd: O seu comprovativo",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:36",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:36"
          },
          {
            "ticket_id": 14786,
            "ticket_number": "3514774",
            "title": "Fwd: Viagify informa sobre a sua reserva 126804921",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:38",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:39"
          },
          {
            "ticket_id": 14787,
            "ticket_number": "3514775",
            "title": "Fwd: O seu comprovativo",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:42",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:42"
          },
          {
            "ticket_id": 14788,
            "ticket_number": "3514776",
            "title": "Fwd: Viagify informa sobre a sua reserva 126804921",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:45",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:46"
          },
          {
            "ticket_id": 14789,
            "ticket_number": "3514777",
            "title": "Fwd: O seu comprovativo",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:48",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:48"
          },
          {
            "ticket_id": 14790,
            "ticket_number": "3514778",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:51",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:52"
          },
          {
            "ticket_id": 14792,
            "ticket_number": "3514780",
            "title": "GBN-117683 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:59",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:59"
          },
          {
            "ticket_id": 14795,
            "ticket_number": "3514783",
            "title": "Fwd: Viagify informa sobre a sua reserva 126803769",
            "priority": "P2",
            "created_at": "09/04/2026 20:24:07",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:24:08"
          },
          {
            "ticket_id": 14806,
            "ticket_number": "3514794",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:01",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:29:01"
          },
          {
            "ticket_id": 14808,
            "ticket_number": "3514796",
            "title": "Fwd: Viagify informa sobre a sua reserva 126808981",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:11",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:29:12"
          },
          {
            "ticket_id": 14813,
            "ticket_number": "3514801",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:34",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:21:48"
          },
          {
            "ticket_id": 14815,
            "ticket_number": "3514803",
            "title": "Confirmação de reserva com localizador: 4163579",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:39",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:21:48"
          },
          {
            "ticket_id": 14818,
            "ticket_number": "3514806",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:21:48"
          },
          {
            "ticket_id": 14822,
            "ticket_number": "3514810",
            "title": "GBN-117731 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "10/04/2026 10:34:56",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 10:34:56"
          },
          {
            "ticket_id": 14825,
            "ticket_number": "3514813",
            "title": "[Pedido de Grupo] Medos Hotel 3* Budapeste - 2026-",
            "priority": "P2",
            "created_at": "10/04/2026 11:52:52",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:52:53"
          },
          {
            "ticket_id": 14828,
            "ticket_number": "3514816",
            "title": "Fwd: Viagify informa sobre a sua reserva 126825267",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:13",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:15:14"
          },
          {
            "ticket_id": 14831,
            "ticket_number": "3514819",
            "title": "Informação de reserva - SPT002601573103",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:24",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:52:14"
          },
          {
            "ticket_id": 14832,
            "ticket_number": "3514820",
            "title": "Informação de reserva - SPT002601601307",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:30",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:52:37"
          },
          {
            "ticket_id": 14854,
            "ticket_number": "3514842",
            "title": "GBN-115697 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "10/04/2026 15:55:47",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:55:47"
          },
          {
            "ticket_id": 14856,
            "ticket_number": "3514844",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "10/04/2026 15:55:51",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:00:24"
          },
          {
            "ticket_id": 14859,
            "ticket_number": "3514847",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "10/04/2026 16:21:24",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:32:10"
          },
          {
            "ticket_id": 14866,
            "ticket_number": "3514854",
            "title": "CARMO/ALEXANDRINA MRS 20MAY2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:43:53",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:45:16"
          },
          {
            "ticket_id": 14867,
            "ticket_number": "3514855",
            "title": "Update 11 @ 16h00 PT - 10 Abr 26: operações e proc",
            "priority": "P2",
            "created_at": "10/04/2026 16:55:27",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 20:42:50"
          },
          {
            "ticket_id": 14868,
            "ticket_number": "3514856",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (XX6",
            "priority": "P2",
            "created_at": "10/04/2026 16:55:29",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 17:04:59"
          },
          {
            "ticket_id": 14870,
            "ticket_number": "3514858",
            "title": "CARMO/ALEXANDRINA MRS 20MAY2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:55:34",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 17:04:47"
          },
          {
            "ticket_id": 14872,
            "ticket_number": "3514860",
            "title": "CARMO/ALEXANDRINA MRS 20MAY2026 LIS TMS",
            "priority": "P2",
            "created_at": "10/04/2026 16:55:40",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 17:04:47"
          },
          {
            "ticket_id": 14873,
            "ticket_number": "3514861",
            "title": "Fwd: Viagify informa sobre a sua reserva 126834783",
            "priority": "P2",
            "created_at": "10/04/2026 16:55:43",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:55:44"
          },
          {
            "ticket_id": 14880,
            "ticket_number": "3514868",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "10/04/2026 17:49:37",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 17:49:37"
          },
          {
            "ticket_id": 14884,
            "ticket_number": "3514872",
            "title": "Confirmação de reserva – Ref PP108967, Sr. Isidro ",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:27",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:01:57"
          },
          {
            "ticket_id": 14886,
            "ticket_number": "3514874",
            "title": "Reserva de transfer em Osaka (Kyoto cidade - Aerop",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:33",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:04:10"
          },
          {
            "ticket_id": 14887,
            "ticket_number": "3514875",
            "title": "Reserva de transfer em Osaka (Kyoto cidade - Aerop",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:36",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:04:24"
          },
          {
            "ticket_id": 14890,
            "ticket_number": "3514878",
            "title": "GBN-117911 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:45",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 19:45:45"
          },
          {
            "ticket_id": 14892,
            "ticket_number": "3514880",
            "title": "Reserva confirmada: Excursão ao Keukenhof - Civita",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:49",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:05:20"
          },
          {
            "ticket_id": 14893,
            "ticket_number": "3514881",
            "title": "Reserva confirmada: Excursão ao Keukenhof - Civita",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:52",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:05:25"
          },
          {
            "ticket_id": 14894,
            "ticket_number": "3514882",
            "title": "Número de informação da reserva: 6145102",
            "priority": "Reservas sem Formulário",
            "created_at": "10/04/2026 19:45:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 63.92,
            "sla_met": false,
            "sla_breach_hours": 39.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 11:41:10"
          },
          {
            "ticket_id": 14895,
            "ticket_number": "3514883",
            "title": "Pagamento da reserva – Ref PP352739, Sr. FRANCISCO",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:57",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:05:51"
          },
          {
            "ticket_id": 14899,
            "ticket_number": "3514887",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604612021",
            "priority": "P2",
            "created_at": "10/04/2026 21:25:12",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 22:31:22"
          },
          {
            "ticket_id": 14902,
            "ticket_number": "3514890",
            "title": "Modification of booking with locator2Q0ZC2OE",
            "priority": "P2",
            "created_at": "10/04/2026 22:14:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 22:36:45"
          },
          {
            "ticket_id": 14903,
            "ticket_number": "3514891",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "10/04/2026 22:14:50",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 63.77,
            "sla_met": false,
            "sla_breach_hours": 39.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 14:01:23"
          },
          {
            "ticket_id": 14906,
            "ticket_number": "3514894",
            "title": "Confirmação de reserva – Ref PP888247, Sr. RICARDO",
            "priority": "Reservas sem Formulário",
            "created_at": "11/04/2026 09:06:41",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.9,
            "sla_met": false,
            "sla_breach_hours": 29.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 15:01:31"
          },
          {
            "ticket_id": 14909,
            "ticket_number": "3514897",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "11/04/2026 09:06:46",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 11:09:12"
          },
          {
            "ticket_id": 14911,
            "ticket_number": "3514899",
            "title": "GBN-117253 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/04/2026 09:17:10",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 09:19:41"
          },
          {
            "ticket_id": 14913,
            "ticket_number": "3514901",
            "title": "Fwd: Informações sobre a sua reserva TTN-124463460",
            "priority": "P2",
            "created_at": "11/04/2026 11:57:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 11:57:34"
          },
          {
            "ticket_id": 14914,
            "ticket_number": "3514902",
            "title": "Fwd: Viagify informa sobre a sua reserva 126857370",
            "priority": "P2",
            "created_at": "11/04/2026 11:57:36",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 11:57:37"
          },
          {
            "ticket_id": 14924,
            "ticket_number": "3514912",
            "title": "GBN-118010 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/04/2026 13:18:12",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 13:18:12"
          },
          {
            "ticket_id": 14925,
            "ticket_number": "3514913",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/04/2026 13:18:15",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 13:18:15"
          },
          {
            "ticket_id": 14929,
            "ticket_number": "3514917",
            "title": "Confirmação de reserva com localizador: 4166134",
            "priority": "Reservas sem Formulário",
            "created_at": "11/04/2026 15:51:51",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.83,
            "sla_met": false,
            "sla_breach_hours": 29.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 21:42:17"
          },
          {
            "ticket_id": 14931,
            "ticket_number": "3514919",
            "title": "GBN-118026 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/04/2026 15:51:59",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 15:51:59"
          },
          {
            "ticket_id": 14944,
            "ticket_number": "3514932",
            "title": "Informação de reserva - SPT002601620028",
            "priority": "P2",
            "created_at": "11/04/2026 17:00:05",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:54:33"
          },
          {
            "ticket_id": 14946,
            "ticket_number": "3514934",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "11/04/2026 17:00:10",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:00:10"
          },
          {
            "ticket_id": 14947,
            "ticket_number": "3514935",
            "title": "Aéreo - Confirmação de Emissão (CLARIMUNDO\\GONCALO",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:00",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:35:34"
          },
          {
            "ticket_id": 14950,
            "ticket_number": "3514938",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:05",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:42:20"
          },
          {
            "ticket_id": 14951,
            "ticket_number": "3514939",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:07",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:43:26"
          },
          {
            "ticket_id": 14952,
            "ticket_number": "3514940",
            "title": "Aéreo - Confirmação de Emissão (MACHACAZ\\ANGELA) -",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:09",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:31:53"
          },
          {
            "ticket_id": 14954,
            "ticket_number": "3514942",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO\\OLIVIA) - ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:13",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:32:21"
          },
          {
            "ticket_id": 14955,
            "ticket_number": "3514943",
            "title": "Aéreo - Confirmação de Emissão (JACINTO\\MATILDE) -",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:14",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:33:55"
          },
          {
            "ticket_id": 14957,
            "ticket_number": "3514945",
            "title": "Aéreo - Confirmação de Emissão (MESQUITA\\MARLISE) ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:19",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:33:43"
          },
          {
            "ticket_id": 14958,
            "ticket_number": "3514946",
            "title": "Aéreo - Confirmação de Emissão (JACINTO\\JOAO) - GK",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:20",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:36:01"
          },
          {
            "ticket_id": 14959,
            "ticket_number": "3514947",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\INES) - GK",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:22",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:34:57"
          },
          {
            "ticket_id": 14960,
            "ticket_number": "3514948",
            "title": "Aéreo - Confirmação de Emissão (MESQUITA\\MARLISE) ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:24",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:35:48"
          },
          {
            "ticket_id": 14961,
            "ticket_number": "3514949",
            "title": "Aéreo - Confirmação de Emissão (PEREIRA\\INES) - YJ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:26",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:34:23"
          },
          {
            "ticket_id": 14962,
            "ticket_number": "3514950",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO\\OLIVIA) - ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:28",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:33:27"
          },
          {
            "ticket_id": 14963,
            "ticket_number": "3514951",
            "title": "Aéreo - Confirmação de Emissão (JACINTO\\JOAO) - YJ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:30",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:34:09"
          },
          {
            "ticket_id": 14964,
            "ticket_number": "3514952",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO\\DAVIDE) - ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:31",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:33:10"
          },
          {
            "ticket_id": 14965,
            "ticket_number": "3514953",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO\\DAVIDE) - ",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:33",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:34:44"
          },
          {
            "ticket_id": 14966,
            "ticket_number": "3514954",
            "title": "Aéreo - Confirmação de Emissão (JACINTO\\MATILDE) -",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:35",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:32:55"
          },
          {
            "ticket_id": 14967,
            "ticket_number": "3514955",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "11/04/2026 17:45:37",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 39.7,
            "sla_met": false,
            "sla_breach_hours": 35.7,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:27:40"
          },
          {
            "ticket_id": 14968,
            "ticket_number": "3514956",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "11/04/2026 17:45:40",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 39.7,
            "sla_met": false,
            "sla_breach_hours": 35.7,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:27:44"
          },
          {
            "ticket_id": 14969,
            "ticket_number": "3514957",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "11/04/2026 17:45:42",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 39.7,
            "sla_met": false,
            "sla_breach_hours": 35.7,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:27:49"
          },
          {
            "ticket_id": 14982,
            "ticket_number": "3514970",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:38",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:19:38"
          },
          {
            "ticket_id": 14984,
            "ticket_number": "3514972",
            "title": "Número de informação da reserva: 6145199",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:43",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:30:59"
          },
          {
            "ticket_id": 14985,
            "ticket_number": "3514973",
            "title": "GBN-118079 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:50",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:19:50"
          },
          {
            "ticket_id": 14986,
            "ticket_number": "3514974",
            "title": "Reserva confirmada: Ingresso do Siam Park - Civita",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:53",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:31:25"
          },
          {
            "ticket_id": 14987,
            "ticket_number": "3514975",
            "title": "GBN-118066 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:56",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:31:40"
          },
          {
            "ticket_id": 14989,
            "ticket_number": "3514977",
            "title": "Reserva confirmada: Ingresso do Siam Park - Civita",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:01",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:32:17"
          },
          {
            "ticket_id": 14990,
            "ticket_number": "3514978",
            "title": "Confirmação de reserva com localizador: 4166405",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 09:20:03",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 219.48,
            "sla_met": false,
            "sla_breach_hours": 195.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:07"
          },
          {
            "ticket_id": 14991,
            "ticket_number": "3514979",
            "title": "GBN-118082 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:09",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:20:09"
          },
          {
            "ticket_id": 14992,
            "ticket_number": "3514980",
            "title": "Confirmation of booking with locatorIZ4M13XM",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:11",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:33:43"
          },
          {
            "ticket_id": 14993,
            "ticket_number": "3514981",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604612206",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 09:20:12",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 219.47,
            "sla_met": false,
            "sla_breach_hours": 195.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:07"
          },
          {
            "ticket_id": 14994,
            "ticket_number": "3514982",
            "title": "Confirmação de reserva com localizador: 4166345",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:14",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:34:07"
          },
          {
            "ticket_id": 14995,
            "ticket_number": "3514983",
            "title": "Confirmation of booking with locator6VYW1GQQ",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:16",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:34:18"
          },
          {
            "ticket_id": 14996,
            "ticket_number": "3514984",
            "title": "GBN-118067 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:18",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:20:18"
          },
          {
            "ticket_id": 14999,
            "ticket_number": "3514987",
            "title": "Confirmation of booking with locatorTBA6W0D2",
            "priority": "P2",
            "created_at": "13/04/2026 09:20:30",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:34:59"
          },
          {
            "ticket_id": 15003,
            "ticket_number": "3514991",
            "title": "Confirmação de reserva com localizador: 4166983",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:22",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:42:19"
          },
          {
            "ticket_id": 15005,
            "ticket_number": "3514993",
            "title": "Información de reserva número: 1785073",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:28",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:38:53"
          },
          {
            "ticket_id": 15007,
            "ticket_number": "3514995",
            "title": "Confirmação de reserva com localizador: 4166977",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:32",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:39:22"
          },
          {
            "ticket_id": 15008,
            "ticket_number": "3514996",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:39:27"
          },
          {
            "ticket_id": 15009,
            "ticket_number": "3514997",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:36",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:39:32"
          },
          {
            "ticket_id": 15011,
            "ticket_number": "3514999",
            "title": "Reserva Aérea Z657RF",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:40",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:41:30"
          },
          {
            "ticket_id": 15013,
            "ticket_number": "3515001",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:50",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:21:50"
          },
          {
            "ticket_id": 15014,
            "ticket_number": "3515002",
            "title": "Reserva Aérea Z657RF",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:53",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:43:27"
          },
          {
            "ticket_id": 15015,
            "ticket_number": "3515003",
            "title": "Reserva confirmada: Free tour por Atenas - Civitat",
            "priority": "P2",
            "created_at": "13/04/2026 09:21:56",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:43:39"
          },
          {
            "ticket_id": 15016,
            "ticket_number": "3515004",
            "title": "Fwd: Viagify informa sobre a sua reserva 126895829",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 09:22:00",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 09:22:00"
          },
          {
            "ticket_id": 15018,
            "ticket_number": "3515006",
            "title": "GBN-118103 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 09:22:10",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:22:10"
          },
          {
            "ticket_id": 15019,
            "ticket_number": "3515007",
            "title": "Reserva confirmada: Free tour por Atenas - Civitat",
            "priority": "P2",
            "created_at": "13/04/2026 09:22:13",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:47:54"
          },
          {
            "ticket_id": 15020,
            "ticket_number": "3515008",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 09:22:22",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:22:22"
          },
          {
            "ticket_id": 15021,
            "ticket_number": "3515009",
            "title": "GBN-118090 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 09:22:29",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:22:29"
          },
          {
            "ticket_id": 15057,
            "ticket_number": "3515045",
            "title": "[Cancelamento Viagem] TRP-2026-03546 - Ana Rita Ca",
            "priority": "P2",
            "created_at": "13/04/2026 14:00:25",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 14:00:25"
          },
          {
            "ticket_id": 15060,
            "ticket_number": "3515048",
            "title": "GBN-118198 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:19",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:00:19"
          },
          {
            "ticket_id": 15061,
            "ticket_number": "3515049",
            "title": "Fwd: Viagify informa sobre a sua reserva 126917670",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 15:00:23",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 15:00:24"
          },
          {
            "ticket_id": 15064,
            "ticket_number": "3515052",
            "title": "Fwd: Incidente de voo TTN-1259316145#96435136#T186",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:00:35"
          },
          {
            "ticket_id": 15071,
            "ticket_number": "3515059",
            "title": "Envio de documentação - FILE 434428",
            "priority": "P2",
            "created_at": "13/04/2026 16:21:39",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 17:09:46"
          },
          {
            "ticket_id": 15085,
            "ticket_number": "3515073",
            "title": "Fwd: Viagify informa sobre a sua reserva 126935823",
            "priority": "P2",
            "created_at": "13/04/2026 18:44:51",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:44:51"
          },
          {
            "ticket_id": 15088,
            "ticket_number": "3515076",
            "title": "GBN-118311 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 18:50:27",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 18:50:27"
          },
          {
            "ticket_id": 15090,
            "ticket_number": "3515078",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 19:05:36",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 19:05:36"
          },
          {
            "ticket_id": 15095,
            "ticket_number": "3515083",
            "title": "Confirmation of booking with locatorBMQJWYY4",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 20:28:43",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/04/2026 16:20:53"
          },
          {
            "ticket_id": 15099,
            "ticket_number": "3515087",
            "title": "GBN-118322 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 22:21:21",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 22:21:21"
          },
          {
            "ticket_id": 15103,
            "ticket_number": "3515091",
            "title": "Confirmação de reserva – Ref PP133281, Sr. André M",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 22:21:29",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/04/2026 18:21:09"
          },
          {
            "ticket_id": 15105,
            "ticket_number": "3515093",
            "title": "GBN-118323 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/04/2026 22:21:38",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/04/2026 22:21:38"
          },
          {
            "ticket_id": 15107,
            "ticket_number": "3515095",
            "title": "Reserva Aérea ZNDX8I",
            "priority": "P2",
            "created_at": "13/04/2026 22:21:43",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 22:49:47"
          },
          {
            "ticket_id": 15113,
            "ticket_number": "3515101",
            "title": "Fwd: Viagify informa sobre a sua reserva 126943384",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 09:08:51",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 09:08:52"
          },
          {
            "ticket_id": 15114,
            "ticket_number": "3515102",
            "title": "GBN-109015 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "14/04/2026 09:08:54",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:44:51"
          },
          {
            "ticket_id": 15115,
            "ticket_number": "3515103",
            "title": "Fwd: Viagify informa sobre a sua reserva 126944859",
            "priority": "P2",
            "created_at": "14/04/2026 09:08:58",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:08:59"
          },
          {
            "ticket_id": 15116,
            "ticket_number": "3515104",
            "title": "Fwd: Viagify informa sobre a sua reserva 126941562",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:01",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:02"
          },
          {
            "ticket_id": 15118,
            "ticket_number": "3515106",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:06",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:06"
          },
          {
            "ticket_id": 15123,
            "ticket_number": "3515111",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 09:09:18",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 09:09:18"
          },
          {
            "ticket_id": 15126,
            "ticket_number": "3515114",
            "title": "Confirmação de reserva com localizador: 4169244",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:25",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:49:26"
          },
          {
            "ticket_id": 15128,
            "ticket_number": "3515116",
            "title": "Reserva confirmada: Passeio de camelo pelo deserto",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:30",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:51:01"
          },
          {
            "ticket_id": 15129,
            "ticket_number": "3515117",
            "title": "GBN-118329 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 09:09:33",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 09:09:33"
          },
          {
            "ticket_id": 15130,
            "ticket_number": "3515118",
            "title": "Confirmação de reserva com localizador: 4169222",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:36",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:52:32"
          },
          {
            "ticket_id": 15131,
            "ticket_number": "3515119",
            "title": "Reserva confirmada: Passeio de camelo pelo deserto",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:39",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:52:43"
          },
          {
            "ticket_id": 15132,
            "ticket_number": "3515120",
            "title": "GBN-118330 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:43",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:43"
          },
          {
            "ticket_id": 15135,
            "ticket_number": "3515123",
            "title": "Confirmation of booking with locatorDPFYBSMG",
            "priority": "P2",
            "created_at": "14/04/2026 09:10:25",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:53:45"
          },
          {
            "ticket_id": 15139,
            "ticket_number": "3515127",
            "title": "Informação importante sobre a tua reserva 6121517",
            "priority": "P2",
            "created_at": "14/04/2026 10:30:52",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 14:23:44"
          },
          {
            "ticket_id": 15140,
            "ticket_number": "3515128",
            "title": "Informação importante sobre a tua reserva 6119956",
            "priority": "P2",
            "created_at": "14/04/2026 10:30:54",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 14:23:44"
          },
          {
            "ticket_id": 15141,
            "ticket_number": "3515129",
            "title": "Confirmação de reserva com localizador: 4169719",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 10:58:20",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 193.83,
            "sla_met": false,
            "sla_breach_hours": 169.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:05"
          },
          {
            "ticket_id": 15143,
            "ticket_number": "3515131",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "14/04/2026 11:44:28",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:10:10"
          },
          {
            "ticket_id": 15149,
            "ticket_number": "3515137",
            "title": "Re:[## 37970 ##] GBN-115277 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "14/04/2026 13:30:48",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:54:33"
          },
          {
            "ticket_id": 15150,
            "ticket_number": "3515138",
            "title": "Fwd: Informações da sua reserva TTN-1269448599#988",
            "priority": "P2",
            "created_at": "14/04/2026 13:30:51",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:30:52"
          },
          {
            "ticket_id": 15151,
            "ticket_number": "3515139",
            "title": "Fwd: Informações da sua reserva TTN-1269415624#988",
            "priority": "P2",
            "created_at": "14/04/2026 13:30:55",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:30:56"
          },
          {
            "ticket_id": 15152,
            "ticket_number": "3515140",
            "title": "Convite atualizado: Reunião Geral suporte @ qui. 1",
            "priority": "P2",
            "created_at": "14/04/2026 13:30:58",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:30:58"
          },
          {
            "ticket_id": 15158,
            "ticket_number": "3515146",
            "title": "RE: Urgente - Check-in",
            "priority": "P2",
            "created_at": "14/04/2026 15:03:34",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:52:12"
          },
          {
            "ticket_id": 15160,
            "ticket_number": "3515148",
            "title": "Lembrete de pré-pagamento de reserva vencida : 612",
            "priority": "P2",
            "created_at": "14/04/2026 15:03:42",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:38:52"
          },
          {
            "ticket_id": 15166,
            "ticket_number": "3515154",
            "title": "RE: Urgente - Check-in",
            "priority": "P2",
            "created_at": "14/04/2026 15:59:13",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:15:42"
          },
          {
            "ticket_id": 15171,
            "ticket_number": "3515159",
            "title": "Re: [Cockpit] Viagem TRP-2026-04736 - Viagem a Agd",
            "priority": "P2",
            "created_at": "14/04/2026 16:19:50",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:19:50"
          },
          {
            "ticket_id": 15172,
            "ticket_number": "3515160",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "14/04/2026 16:28:17",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:31:01"
          },
          {
            "ticket_id": 15175,
            "ticket_number": "3515163",
            "title": "Fwd: Viagify informa sobre a sua reserva 126959276",
            "priority": "P2",
            "created_at": "14/04/2026 16:31:23",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:31:23"
          },
          {
            "ticket_id": 15176,
            "ticket_number": "3515164",
            "title": "Confirmação de reserva – Ref PP902181, Sr. Jose Le",
            "priority": "P2",
            "created_at": "14/04/2026 16:31:27",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:59:32"
          },
          {
            "ticket_id": 15177,
            "ticket_number": "3515165",
            "title": "Fwd: Viagify informa sobre a sua reserva 126959712",
            "priority": "P2",
            "created_at": "14/04/2026 16:31:33",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:31:34"
          },
          {
            "ticket_id": 15179,
            "ticket_number": "3515167",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "14/04/2026 16:36:21",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:00:06"
          },
          {
            "ticket_id": 15188,
            "ticket_number": "3515176",
            "title": "Alteração preços - combustível - Localizador Soltr",
            "priority": "P2",
            "created_at": "14/04/2026 17:37:04",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:37:05"
          },
          {
            "ticket_id": 15189,
            "ticket_number": "3515177",
            "title": "Cancelamento de Reservas 58-4697378 Bedsonline",
            "priority": "P2",
            "created_at": "14/04/2026 17:57:03",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:57:45"
          },
          {
            "ticket_id": 15195,
            "ticket_number": "3515183",
            "title": "Confirmation of booking with locatorMFQQ2EEX",
            "priority": "P2",
            "created_at": "14/04/2026 19:09:21",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:13:01"
          },
          {
            "ticket_id": 15196,
            "ticket_number": "3515184",
            "title": "GBN-118377 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/04/2026 19:09:23",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:13:18"
          },
          {
            "ticket_id": 15197,
            "ticket_number": "3515185",
            "title": "GBN-118377 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "14/04/2026 19:09:32",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 19:09:32"
          },
          {
            "ticket_id": 15198,
            "ticket_number": "3515186",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "14/04/2026 19:09:35",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:14:00"
          },
          {
            "ticket_id": 15203,
            "ticket_number": "3515191",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "14/04/2026 19:43:27",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:15:16"
          },
          {
            "ticket_id": 15204,
            "ticket_number": "3515192",
            "title": "Reserva de transfer em Agadir (Agadir - Aeroporto ",
            "priority": "P2",
            "created_at": "14/04/2026 19:58:18",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:15:27"
          },
          {
            "ticket_id": 15206,
            "ticket_number": "3515194",
            "title": "Reserva de transfer em Agadir (Agadir - Aeroporto ",
            "priority": "P2",
            "created_at": "14/04/2026 19:58:24",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:16:06"
          },
          {
            "ticket_id": 15207,
            "ticket_number": "3515195",
            "title": "Reserva de transfer em Agadir (Aeroporto de Agadir",
            "priority": "P2",
            "created_at": "14/04/2026 19:58:27",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:16:33"
          },
          {
            "ticket_id": 15208,
            "ticket_number": "3515196",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 20:33:54",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 20:33:54"
          },
          {
            "ticket_id": 15209,
            "ticket_number": "3515197",
            "title": "GBN-118550 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 20:33:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 20:33:57"
          },
          {
            "ticket_id": 15210,
            "ticket_number": "3515198",
            "title": "Fwd: Viagify informa sobre a sua reserva 126986191",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 20:44:25",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/04/2026 20:44:26"
          },
          {
            "ticket_id": 15211,
            "ticket_number": "3515199",
            "title": "Fwd: Viagify informa sobre a sua reserva 126986191",
            "priority": "P2",
            "created_at": "14/04/2026 20:44:28",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:44:28"
          },
          {
            "ticket_id": 15214,
            "ticket_number": "3515202",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604614469",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 21:06:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 19.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/04/2026 17:02:54"
          },
          {
            "ticket_id": 15216,
            "ticket_number": "3515204",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604614471",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 21:18:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 183.5,
            "sla_met": false,
            "sla_breach_hours": 159.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:04"
          },
          {
            "ticket_id": 15222,
            "ticket_number": "3515210",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/04/2026 21:55:41",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:55:41"
          },
          {
            "ticket_id": 15223,
            "ticket_number": "3515211",
            "title": "GBN-118557 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "14/04/2026 21:55:48",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:55:49"
          },
          {
            "ticket_id": 15226,
            "ticket_number": "3515214",
            "title": "Confirmación del Loc 9126231",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 22:27:11",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.92,
            "sla_met": false,
            "sla_breach_hours": 19.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/04/2026 18:23:06"
          },
          {
            "ticket_id": 15229,
            "ticket_number": "3515217",
            "title": "Reserva cancelada com localizador: 4131348",
            "priority": "P2",
            "created_at": "14/04/2026 22:49:41",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 22:50:25"
          },
          {
            "ticket_id": 15231,
            "ticket_number": "3515219",
            "title": "Informação de reserva - SPT002601621377",
            "priority": "Reservas sem Formulário",
            "created_at": "14/04/2026 22:54:47",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/04/2026 18:43:07"
          },
          {
            "ticket_id": 15237,
            "ticket_number": "3515225",
            "title": "MSC Cruises Document - 2600101002777560",
            "priority": "P2",
            "created_at": "15/04/2026 10:08:23",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:15:31"
          },
          {
            "ticket_id": 15244,
            "ticket_number": "3515232",
            "title": "Confirmação de reserva com localizador: 4171609",
            "priority": "P2",
            "created_at": "15/04/2026 10:08:37",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:14:51"
          },
          {
            "ticket_id": 15246,
            "ticket_number": "3515234",
            "title": "AIR EUROPA ✈ Comunicado Importante ✈",
            "priority": "P2",
            "created_at": "15/04/2026 10:20:17",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:10:46"
          },
          {
            "ticket_id": 15250,
            "ticket_number": "3515238",
            "title": "RECUPERADO: Amadeus Central Reservation: Filas PNR",
            "priority": "P2",
            "created_at": "15/04/2026 10:22:18",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 14:20:44"
          },
          {
            "ticket_id": 15251,
            "ticket_number": "3515239",
            "title": "Fwd: Viagify informa sobre a sua reserva 126988680",
            "priority": "P2",
            "created_at": "15/04/2026 10:22:20",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 10:22:21"
          },
          {
            "ticket_id": 15258,
            "ticket_number": "3515246",
            "title": "Confirmação de reserva – Ref PP895519, Sr. Mario A",
            "priority": "P2",
            "created_at": "15/04/2026 11:12:26",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:18:32"
          },
          {
            "ticket_id": 15259,
            "ticket_number": "3515247",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "15/04/2026 11:12:33",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:14:34"
          },
          {
            "ticket_id": 15263,
            "ticket_number": "3515251",
            "title": "URGENTE Confirmação de reserva 344276 ### TIME LIM",
            "priority": "P2",
            "created_at": "15/04/2026 12:04:42",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:09:33"
          },
          {
            "ticket_id": 15264,
            "ticket_number": "3515252",
            "title": "Nova campanha Costa: bebidas GRÁTIS!",
            "priority": "P2",
            "created_at": "15/04/2026 12:04:44",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:10:04"
          },
          {
            "ticket_id": 15272,
            "ticket_number": "3515260",
            "title": "Informação de reserva - SPT002601621377",
            "priority": "P2",
            "created_at": "15/04/2026 13:36:22",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 13:36:47"
          },
          {
            "ticket_id": 15283,
            "ticket_number": "3515271",
            "title": "Aéreo - Confirmação de Emissão (BARRETO GOMES DA C",
            "priority": "P2",
            "created_at": "15/04/2026 16:08:07",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 16:33:11"
          },
          {
            "ticket_id": 15284,
            "ticket_number": "3515272",
            "title": "Reserva Aéreo [ERROR_AIR-58575C2C63] - Erro Técnic",
            "priority": "P2",
            "created_at": "15/04/2026 16:12:39",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 16:15:53"
          },
          {
            "ticket_id": 15318,
            "ticket_number": "3515306",
            "title": "GBN-118785 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "15/04/2026 22:33:31",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/04/2026 22:33:31"
          },
          {
            "ticket_id": 15361,
            "ticket_number": "3515349",
            "title": "Número de informação da reserva: 6145547",
            "priority": "P2",
            "created_at": "16/04/2026 14:13:16",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:21:30"
          },
          {
            "ticket_id": 15368,
            "ticket_number": "3515356",
            "title": "Confirmação de reserva 344365",
            "priority": "Reservas sem Formulário",
            "created_at": "16/04/2026 15:15:28",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 141.55,
            "sla_met": false,
            "sla_breach_hours": 117.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:04"
          },
          {
            "ticket_id": 15369,
            "ticket_number": "3515357",
            "title": "Antecipação do pagamento",
            "priority": "P2",
            "created_at": "16/04/2026 15:50:00",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:50:00"
          },
          {
            "ticket_id": 15376,
            "ticket_number": "3515364",
            "title": "GBN-118998 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:36",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 19:45:36"
          },
          {
            "ticket_id": 15377,
            "ticket_number": "3515365",
            "title": "GBN-115573 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:38",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 20:21:28"
          },
          {
            "ticket_id": 15379,
            "ticket_number": "3515367",
            "title": "GBN-115573 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:49",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 19:45:49"
          },
          {
            "ticket_id": 15380,
            "ticket_number": "3515368",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:52",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 20:18:03"
          },
          {
            "ticket_id": 15385,
            "ticket_number": "3515373",
            "title": "Confirmação de reserva com localizador: 4175850",
            "priority": "P2",
            "created_at": "16/04/2026 21:24:17",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 22:07:31"
          },
          {
            "ticket_id": 15389,
            "ticket_number": "3515377",
            "title": "GBN-119016 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/04/2026 22:08:01",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/04/2026 22:08:01"
          },
          {
            "ticket_id": 15391,
            "ticket_number": "3515379",
            "title": "Informação de reserva - SPT002601622315",
            "priority": "Reservas sem Formulário",
            "created_at": "16/04/2026 22:45:06",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 134.05,
            "sla_met": false,
            "sla_breach_hours": 110.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:03"
          },
          {
            "ticket_id": 15402,
            "ticket_number": "3515390",
            "title": "Fwd: Viagify informa sobre a sua reserva 127069471",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 09:14:29",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/04/2026 09:14:30"
          },
          {
            "ticket_id": 15403,
            "ticket_number": "3515391",
            "title": "Fwd: Viagify informa sobre a sua reserva 127069939",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:32",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:32"
          },
          {
            "ticket_id": 15405,
            "ticket_number": "3515393",
            "title": "Fwd: Viagify informa sobre a sua reserva 127070127",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:36",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:37"
          },
          {
            "ticket_id": 15406,
            "ticket_number": "3515394",
            "title": "Fwd: Viagify informa sobre a sua reserva 127069931",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:40",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:41"
          },
          {
            "ticket_id": 15407,
            "ticket_number": "3515395",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:45",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:00:59"
          },
          {
            "ticket_id": 15423,
            "ticket_number": "3515411",
            "title": "GBN-119036 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 09:54:31",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/04/2026 09:54:31"
          },
          {
            "ticket_id": 15434,
            "ticket_number": "3515422",
            "title": "Fwd: Viagify informa sobre a sua reserva 127078903",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 10:47:21",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/04/2026 10:47:21"
          },
          {
            "ticket_id": 15436,
            "ticket_number": "3515424",
            "title": "Criação de processo File 438860/26",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 10:47:33",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 122.02,
            "sla_met": false,
            "sla_breach_hours": 98.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:03"
          },
          {
            "ticket_id": 15458,
            "ticket_number": "3515446",
            "title": "Confirmação de reserva 344422",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:05",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 15:08:33"
          },
          {
            "ticket_id": 15466,
            "ticket_number": "3515454",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604616950",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:31",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 14:53:56"
          },
          {
            "ticket_id": 15467,
            "ticket_number": "3515455",
            "title": "RECUPERADO: Amadeus Central Reservation: Editora: ",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:33",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 16:28:57"
          },
          {
            "ticket_id": 15477,
            "ticket_number": "3515465",
            "title": "Confirmation of booking with locator1Q0P76W0",
            "priority": "P2",
            "created_at": "17/04/2026 16:02:01",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 20:00:48"
          },
          {
            "ticket_id": 15488,
            "ticket_number": "3515476",
            "title": "MARTINS SILVA/PEDRO MIGUEL MR 28OCT2026 LIS ORY",
            "priority": "P2",
            "created_at": "17/04/2026 17:50:46",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 19:57:23"
          },
          {
            "ticket_id": 15492,
            "ticket_number": "3515480",
            "title": "[Suporte] TRP-2026-04689 - Fatura",
            "priority": "P2",
            "created_at": "17/04/2026 18:17:23",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:17:24"
          },
          {
            "ticket_id": 15495,
            "ticket_number": "3515483",
            "title": "Confirmação reserva Bedsonline 181-2151887",
            "priority": "P2",
            "created_at": "17/04/2026 20:27:41",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 20:30:58"
          },
          {
            "ticket_id": 15496,
            "ticket_number": "3515484",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "17/04/2026 20:27:50",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 20:27:50"
          },
          {
            "ticket_id": 15499,
            "ticket_number": "3515487",
            "title": "Confirmation of booking with locatorV2SWS3C4",
            "priority": "P2",
            "created_at": "17/04/2026 22:12:52",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:17:26"
          },
          {
            "ticket_id": 15501,
            "ticket_number": "3515489",
            "title": "GBN-119251 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "17/04/2026 22:12:57",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:12:57"
          },
          {
            "ticket_id": 15502,
            "ticket_number": "3515490",
            "title": "GBN-119250 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "17/04/2026 22:13:07",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:13:07"
          },
          {
            "ticket_id": 15503,
            "ticket_number": "3515491",
            "title": "Confirmação reserva Bedsonline 59-5831749",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 22:13:09",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 63.85,
            "sla_met": false,
            "sla_breach_hours": 39.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 14:04:56"
          },
          {
            "ticket_id": 15504,
            "ticket_number": "3515492",
            "title": "Confirmation of booking with locatorVKE9F7JH",
            "priority": "P2",
            "created_at": "17/04/2026 22:13:11",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:21:43"
          },
          {
            "ticket_id": 15505,
            "ticket_number": "3515493",
            "title": "Criação de processo File 438952/26",
            "priority": "P2",
            "created_at": "17/04/2026 22:20:28",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:40:56"
          },
          {
            "ticket_id": 15506,
            "ticket_number": "3515494",
            "title": "Cancelamento de Reserva - SPT002601622810",
            "priority": "P2",
            "created_at": "17/04/2026 22:20:37",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:21:07"
          },
          {
            "ticket_id": 15509,
            "ticket_number": "3515497",
            "title": "Informação de reserva - SPT002601622813",
            "priority": "Reservas sem Formulário",
            "created_at": "17/04/2026 22:35:15",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 63.82,
            "sla_met": false,
            "sla_breach_hours": 39.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 14:24:58"
          },
          {
            "ticket_id": 15511,
            "ticket_number": "3515499",
            "title": "Confirmação de reserva com localizador: 4178042",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 09:01:53",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 15:00:06"
          },
          {
            "ticket_id": 15512,
            "ticket_number": "3515500",
            "title": "Confirmação de reserva com localizador: 4178033",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 09:01:55",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 15:00:06"
          },
          {
            "ticket_id": 15518,
            "ticket_number": "3515506",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 11:42:47",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/04/2026 11:42:47"
          },
          {
            "ticket_id": 15520,
            "ticket_number": "3515508",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/04/2026 12:45:55",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:45:55"
          },
          {
            "ticket_id": 15522,
            "ticket_number": "3515510",
            "title": "Fwd: Viagify informa sobre a sua reserva 127107799",
            "priority": "P2",
            "created_at": "18/04/2026 12:52:24",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:52:25"
          },
          {
            "ticket_id": 15523,
            "ticket_number": "3515511",
            "title": "Fwd: Viagify informa sobre a sua reserva 127107799",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 12:52:28",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/04/2026 12:52:29"
          },
          {
            "ticket_id": 15525,
            "ticket_number": "3515513",
            "title": "Fwd: Informações da sua reserva TTN-1271077994#993",
            "priority": "P2",
            "created_at": "18/04/2026 12:52:34",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:52:35"
          },
          {
            "ticket_id": 15530,
            "ticket_number": "3515518",
            "title": "Solole. Booking ZNAF4VSC is close to entering expe",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 15:06:07",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.9,
            "sla_met": false,
            "sla_breach_hours": 29.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 21:00:57"
          },
          {
            "ticket_id": 15537,
            "ticket_number": "3515525",
            "title": "GBN-119314 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "18/04/2026 16:09:50",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/04/2026 16:09:50"
          },
          {
            "ticket_id": 15538,
            "ticket_number": "3515526",
            "title": "GBN-119314 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/04/2026 17:14:26",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 17:59:48"
          },
          {
            "ticket_id": 15547,
            "ticket_number": "3515535",
            "title": "A reserva A38039663 foi paga e confirmada",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:33",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:25:18"
          },
          {
            "ticket_id": 15552,
            "ticket_number": "3515540",
            "title": "Fwd: Viagify informa sobre a sua reserva 127125584",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:44",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:44"
          },
          {
            "ticket_id": 15553,
            "ticket_number": "3515541",
            "title": "Fwd: Informações da sua reserva TTN-1271255847#993",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:47",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:48"
          },
          {
            "ticket_id": 15554,
            "ticket_number": "3515542",
            "title": "Fwd: Viagify informa sobre a sua reserva 127125584",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:50",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:50"
          },
          {
            "ticket_id": 15555,
            "ticket_number": "3515543",
            "title": "Amanhã será realizada a cobrança da reserva A37696",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:52",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:27:24"
          },
          {
            "ticket_id": 15556,
            "ticket_number": "3515544",
            "title": "GBN-119351 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:55",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:55"
          },
          {
            "ticket_id": 15565,
            "ticket_number": "3515553",
            "title": "Confirmação de reserva com localizador: 4178942",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 09:07:13",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 51.68,
            "sla_met": false,
            "sla_breach_hours": 27.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:01"
          },
          {
            "ticket_id": 15568,
            "ticket_number": "3515556",
            "title": "GBN-119333 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 09:07:20",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 09:07:20"
          },
          {
            "ticket_id": 15569,
            "ticket_number": "3515557",
            "title": "GBN-119334 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 09:07:23",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 09:07:23"
          },
          {
            "ticket_id": 15570,
            "ticket_number": "3515558",
            "title": "GBN-119335 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 09:07:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 09:07:26"
          },
          {
            "ticket_id": 15574,
            "ticket_number": "3515562",
            "title": "Fwd: SSHMMY | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:52",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:07:53"
          },
          {
            "ticket_id": 15575,
            "ticket_number": "3515563",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:54",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:34:32"
          },
          {
            "ticket_id": 15584,
            "ticket_number": "3515572",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:11",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:36:57"
          },
          {
            "ticket_id": 15585,
            "ticket_number": "3515573",
            "title": "Amanhã será realizada a cobrança da reserva A38039",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:13",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:37:05"
          },
          {
            "ticket_id": 15586,
            "ticket_number": "3515574",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:14",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:37:10"
          },
          {
            "ticket_id": 15587,
            "ticket_number": "3515575",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:16",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:37:15"
          },
          {
            "ticket_id": 15589,
            "ticket_number": "3515577",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:19",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:40:11"
          },
          {
            "ticket_id": 15590,
            "ticket_number": "3515578",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:21",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:40:15"
          },
          {
            "ticket_id": 15639,
            "ticket_number": "3515627",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 13:09:42",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/04/2026 13:09:42"
          },
          {
            "ticket_id": 15662,
            "ticket_number": "3515650",
            "title": "Confirmação de reserva. Localizador: 80ZYV0A6UK",
            "priority": "P2",
            "created_at": "20/04/2026 15:43:29",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:45:41"
          },
          {
            "ticket_id": 15683,
            "ticket_number": "3515671",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 17:24:51",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 43.4,
            "sla_met": false,
            "sla_breach_hours": 19.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:00"
          },
          {
            "ticket_id": 15690,
            "ticket_number": "3515678",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "20/04/2026 19:28:05",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:35:45"
          },
          {
            "ticket_id": 15691,
            "ticket_number": "3515679",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 19:28:08",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:35:52"
          },
          {
            "ticket_id": 15692,
            "ticket_number": "3515680",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "20/04/2026 19:28:11",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:35:56"
          },
          {
            "ticket_id": 15693,
            "ticket_number": "3515681",
            "title": "Fwd: Viagify informa sobre a sua reserva 127191282",
            "priority": "P2",
            "created_at": "20/04/2026 19:28:56",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:28:57"
          },
          {
            "ticket_id": 15697,
            "ticket_number": "3515685",
            "title": "GBN-119606 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/04/2026 22:12:41",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 22:12:41"
          },
          {
            "ticket_id": 15699,
            "ticket_number": "3515687",
            "title": "Número de informação da reserva: 6145944",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 22:50:49",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 38.53,
            "sla_met": false,
            "sla_breach_hours": 14.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 13:23:35"
          },
          {
            "ticket_id": 15700,
            "ticket_number": "3515688",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604618818",
            "priority": "Reservas sem Formulário",
            "created_at": "20/04/2026 23:01:18",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 37.78,
            "sla_met": false,
            "sla_breach_hours": 13.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:49:00"
          },
          {
            "ticket_id": 15708,
            "ticket_number": "3515696",
            "title": "A reserva A37696134 foi paga e confirmada",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:13",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:14:10"
          },
          {
            "ticket_id": 15710,
            "ticket_number": "3515698",
            "title": "Número de informação da reserva: 6145946",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:18",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:17:18"
          },
          {
            "ticket_id": 15714,
            "ticket_number": "3515702",
            "title": "Número de informação da reserva: 6145948",
            "priority": "P2",
            "created_at": "21/04/2026 09:25:38",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:48:36"
          },
          {
            "ticket_id": 15717,
            "ticket_number": "3515705",
            "title": "Informação importante sobre a tua reserva 6125288",
            "priority": "P2",
            "created_at": "21/04/2026 09:51:10",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:53:11"
          },
          {
            "ticket_id": 15718,
            "ticket_number": "3515706",
            "title": "Informação importante sobre a tua reserva 6124315",
            "priority": "P2",
            "created_at": "21/04/2026 09:51:12",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:53:08"
          },
          {
            "ticket_id": 15719,
            "ticket_number": "3515707",
            "title": "GBN-119646 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/04/2026 10:37:52",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 10:37:52"
          },
          {
            "ticket_id": 15720,
            "ticket_number": "3515708",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "21/04/2026 10:43:53",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:43:26"
          },
          {
            "ticket_id": 15722,
            "ticket_number": "3515710",
            "title": "Documentação Disponível - Reserva 334059",
            "priority": "P2",
            "created_at": "21/04/2026 11:09:33",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:33:57"
          },
          {
            "ticket_id": 15729,
            "ticket_number": "3515717",
            "title": "Aéreo - Confirmação de Emissão (FURTADO CARDOSO\\ME",
            "priority": "P2",
            "created_at": "21/04/2026 11:58:37",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:23:50"
          },
          {
            "ticket_id": 15730,
            "ticket_number": "3515718",
            "title": "Aéreo - Confirmação de Emissão (CARVALHO FURTADO C",
            "priority": "P2",
            "created_at": "21/04/2026 11:58:39",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:24:27"
          },
          {
            "ticket_id": 15731,
            "ticket_number": "3515719",
            "title": "Aéreo - Confirmação de Emissão (FURTADO CARDOSO\\ME",
            "priority": "P2",
            "created_at": "21/04/2026 12:01:12",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:24:02"
          },
          {
            "ticket_id": 15732,
            "ticket_number": "3515720",
            "title": "Aéreo - Confirmação de Emissão (CARVALHO FURTADO C",
            "priority": "P2",
            "created_at": "21/04/2026 12:01:15",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:24:15"
          },
          {
            "ticket_id": 15734,
            "ticket_number": "3515722",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "21/04/2026 12:21:44",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:21:44"
          },
          {
            "ticket_id": 15735,
            "ticket_number": "3515723",
            "title": "Fwd: Informações da reserva TTN-1252218555#9956558",
            "priority": "P2",
            "created_at": "21/04/2026 12:21:47",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:21:48"
          },
          {
            "ticket_id": 15737,
            "ticket_number": "3515725",
            "title": "Fwd: Incidente de voo TTN-1252218555#98671987#T192",
            "priority": "P2",
            "created_at": "21/04/2026 12:21:55",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:21:56"
          },
          {
            "ticket_id": 15743,
            "ticket_number": "3515731",
            "title": "GBN-119698 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/04/2026 12:43:19",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/04/2026 12:43:19"
          },
          {
            "ticket_id": 15744,
            "ticket_number": "3515732",
            "title": "GBN-119700 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/04/2026 12:54:48",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/04/2026 12:54:48"
          },
          {
            "ticket_id": 15748,
            "ticket_number": "3515736",
            "title": "GBN-119706 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/04/2026 13:10:56",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:10:56"
          },
          {
            "ticket_id": 15751,
            "ticket_number": "3515739",
            "title": "GBN-119715 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/04/2026 13:54:03",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/04/2026 13:54:03"
          },
          {
            "ticket_id": 15755,
            "ticket_number": "3515743",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "21/04/2026 16:06:19",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:11:11"
          },
          {
            "ticket_id": 15756,
            "ticket_number": "3515744",
            "title": "Reserva confirmada: Ingresso da Torre Eiffel + Cru",
            "priority": "P2",
            "created_at": "21/04/2026 16:06:24",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:10:33"
          },
          {
            "ticket_id": 15757,
            "ticket_number": "3515745",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "21/04/2026 16:06:28",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:37:05"
          },
          {
            "ticket_id": 15759,
            "ticket_number": "3515747",
            "title": "Reserva confirmada: Ingresso da Torre Eiffel + Cru",
            "priority": "P2",
            "created_at": "21/04/2026 16:06:31",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:10:46"
          },
          {
            "ticket_id": 15763,
            "ticket_number": "3515751",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "21/04/2026 17:00:30",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:32:32"
          },
          {
            "ticket_id": 15764,
            "ticket_number": "3515752",
            "title": "GBN-119525 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/04/2026 17:00:32",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:35:30"
          },
          {
            "ticket_id": 15766,
            "ticket_number": "3515754",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/04/2026 17:07:28",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:07:28"
          },
          {
            "ticket_id": 15767,
            "ticket_number": "3515755",
            "title": "Documentação Disponível - Reserva 334043",
            "priority": "P2",
            "created_at": "21/04/2026 17:43:32",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:49:14"
          },
          {
            "ticket_id": 15768,
            "ticket_number": "3515756",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/04/2026 17:43:40",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:43:40"
          },
          {
            "ticket_id": 15769,
            "ticket_number": "3515757",
            "title": "Informação de reserva - SPT002601624043",
            "priority": "P2",
            "created_at": "21/04/2026 17:43:48",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:46:48"
          },
          {
            "ticket_id": 15771,
            "ticket_number": "3515759",
            "title": "Informação de reserva - SPT002601624043",
            "priority": "P2",
            "created_at": "21/04/2026 17:43:56",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:47:01"
          },
          {
            "ticket_id": 15773,
            "ticket_number": "3515761",
            "title": "Confirmação de reserva com localizador: 4183281",
            "priority": "P2",
            "created_at": "21/04/2026 18:03:38",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 19:31:55"
          },
          {
            "ticket_id": 15778,
            "ticket_number": "3515766",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604619770",
            "priority": "Reservas sem Formulário",
            "created_at": "21/04/2026 19:36:21",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 17.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:48:59"
          },
          {
            "ticket_id": 15782,
            "ticket_number": "3515770",
            "title": "GBN-119767 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/04/2026 20:03:54",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 16.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 12:48:59"
          },
          {
            "ticket_id": 15784,
            "ticket_number": "3515772",
            "title": "GBN-119865 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/04/2026 20:35:56",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 20:35:56"
          },
          {
            "ticket_id": 15794,
            "ticket_number": "3515782",
            "title": "Confirmação reserva Bedsonline 221-5605055",
            "priority": "P2",
            "created_at": "21/04/2026 22:57:45",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 10.58,
            "sla_met": false,
            "sla_breach_hours": 6.58,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:33:34"
          },
          {
            "ticket_id": 15799,
            "ticket_number": "3515787",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604619807",
            "priority": "P2",
            "created_at": "21/04/2026 22:57:57",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 23:05:31"
          },
          {
            "ticket_id": 15801,
            "ticket_number": "3515789",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604619811",
            "priority": "P2",
            "created_at": "21/04/2026 22:58:00",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 10.62,
            "sla_met": false,
            "sla_breach_hours": 6.62,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:35:09"
          },
          {
            "ticket_id": 15804,
            "ticket_number": "3515792",
            "title": "Fwd: Viagify informa sobre a sua reserva 127235416",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:08",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:01:09"
          },
          {
            "ticket_id": 15807,
            "ticket_number": "3515795",
            "title": "Fwd: Viagify informa sobre a sua reserva 127235416",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:15",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:01:16"
          },
          {
            "ticket_id": 15811,
            "ticket_number": "3515799",
            "title": "Informação de reserva - SPT002601624165",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:27",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:37:28"
          },
          {
            "ticket_id": 15818,
            "ticket_number": "3515806",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "22/04/2026 10:34:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:53:36"
          },
          {
            "ticket_id": 15820,
            "ticket_number": "3515808",
            "title": "Cancelación de la reserva con localizador: 4183281",
            "priority": "P2",
            "created_at": "22/04/2026 10:35:04",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:33:17"
          },
          {
            "ticket_id": 15821,
            "ticket_number": "3515809",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "22/04/2026 10:35:06",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:52:34"
          },
          {
            "ticket_id": 15822,
            "ticket_number": "3515810",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "22/04/2026 10:35:08",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:52:46"
          },
          {
            "ticket_id": 15823,
            "ticket_number": "3515811",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "22/04/2026 10:35:10",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:53:25"
          },
          {
            "ticket_id": 15829,
            "ticket_number": "3515817",
            "title": "Fwd: Viagify informa sobre a sua reserva 127252417",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:49",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:57:50"
          },
          {
            "ticket_id": 15830,
            "ticket_number": "3515818",
            "title": "GBN-119781 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/04/2026 11:17:09",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:26:37"
          },
          {
            "ticket_id": 15831,
            "ticket_number": "3515819",
            "title": "GBN-119767 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/04/2026 11:17:15",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:17:15"
          },
          {
            "ticket_id": 15833,
            "ticket_number": "3515821",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "22/04/2026 11:46:14",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 12:39:11"
          },
          {
            "ticket_id": 15834,
            "ticket_number": "3515822",
            "title": "GBN-119939 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/04/2026 11:46:18",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:46:18"
          },
          {
            "ticket_id": 15839,
            "ticket_number": "3515827",
            "title": "Confirmação de reserva com localizador: 4184719",
            "priority": "P2",
            "created_at": "22/04/2026 13:46:33",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 14:36:42"
          },
          {
            "ticket_id": 15843,
            "ticket_number": "3515831",
            "title": "Icárion - Bahamas - 16/06/2026 - 6354045 - AM21BS0",
            "priority": "P2",
            "created_at": "22/04/2026 14:45:11",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 17:42:56"
          },
          {
            "ticket_id": 15878,
            "ticket_number": "3515866",
            "title": "Pagamento -  (Recibo-2147846368)",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:11",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:08:56"
          },
          {
            "ticket_id": 15881,
            "ticket_number": "3515869",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:18",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 19:45:33"
          },
          {
            "ticket_id": 15885,
            "ticket_number": "3515873",
            "title": "Confirmação de reserva – Ref PP168711, Sr. Frederi",
            "priority": "P2",
            "created_at": "22/04/2026 19:03:32",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 19:39:48"
          },
          {
            "ticket_id": 15891,
            "ticket_number": "3515879",
            "title": "Reserva confirmada: Ônibus e ingresso do Keukenhof",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:49",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:25:01"
          },
          {
            "ticket_id": 15892,
            "ticket_number": "3515880",
            "title": "Confirmação de reserva com localizador: 4185760",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:50",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:25:18"
          },
          {
            "ticket_id": 15894,
            "ticket_number": "3515882",
            "title": "A prestação Best Western Dam Square Inn foi reserv",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:54",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:25:55"
          },
          {
            "ticket_id": 15895,
            "ticket_number": "3515883",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604620765",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:26:09"
          },
          {
            "ticket_id": 15897,
            "ticket_number": "3515885",
            "title": "Reserva confirmada: Ônibus e ingresso do Keukenhof",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:59",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:27:15"
          },
          {
            "ticket_id": 15898,
            "ticket_number": "3515886",
            "title": "GBN-120133 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/04/2026 22:20:03",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:20:03"
          },
          {
            "ticket_id": 15899,
            "ticket_number": "3515887",
            "title": "Fwd: Wizz Air electronic invoice DWAM-48568233 / S",
            "priority": "P2",
            "created_at": "22/04/2026 22:36:17",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:36:18"
          },
          {
            "ticket_id": 15900,
            "ticket_number": "3515888",
            "title": "Fwd: Wizz Air electronic invoice DWAM-48568233 / S",
            "priority": "Reservas sem Formulário",
            "created_at": "22/04/2026 22:36:19",
            "close_date": "2026-05-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/04/2026 22:36:20"
          },
          {
            "ticket_id": 15901,
            "ticket_number": "3515889",
            "title": "Fwd: Informações sobre a sua reserva TTN-113302023",
            "priority": "P2",
            "created_at": "22/04/2026 22:36:21",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:36:22"
          },
          {
            "ticket_id": 15907,
            "ticket_number": "3515895",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "22/04/2026 22:43:24",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:47:03"
          },
          {
            "ticket_id": 15920,
            "ticket_number": "3515908",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:33:01"
          },
          {
            "ticket_id": 15926,
            "ticket_number": "3515914",
            "title": "Fwd: Informações da sua reserva TTN-1272813682#997",
            "priority": "P2",
            "created_at": "23/04/2026 10:02:20",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:02:20"
          },
          {
            "ticket_id": 15927,
            "ticket_number": "3515915",
            "title": "Fwd: Viagify informa sobre a sua reserva 127281368",
            "priority": "P2",
            "created_at": "23/04/2026 10:02:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:02:23"
          },
          {
            "ticket_id": 15929,
            "ticket_number": "3515917",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "23/04/2026 10:20:21",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:20:22"
          },
          {
            "ticket_id": 15930,
            "ticket_number": "3515918",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "23/04/2026 10:20:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:20:24"
          },
          {
            "ticket_id": 15933,
            "ticket_number": "3515921",
            "title": "Envio documentos - (Recibo-231006477)  n. 10045779",
            "priority": "P2",
            "created_at": "23/04/2026 10:30:56",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 10:47:39"
          },
          {
            "ticket_id": 15940,
            "ticket_number": "3515928",
            "title": "Solole. Booking ZNAF4VSC is close to entering expe",
            "priority": "P2",
            "created_at": "23/04/2026 12:00:49",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:11:24"
          },
          {
            "ticket_id": 15941,
            "ticket_number": "3515929",
            "title": "VOUCHER DA RESERVA 604518491",
            "priority": "P2",
            "created_at": "23/04/2026 12:11:58",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:27:11"
          },
          {
            "ticket_id": 15949,
            "ticket_number": "3515937",
            "title": "[Cancelamento Viagem] TRP-2026-03844 - Pedro  Amar",
            "priority": "P2",
            "created_at": "23/04/2026 14:01:08",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:03:16"
          },
          {
            "ticket_id": 15950,
            "ticket_number": "3515938",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604621143",
            "priority": "Reservas sem Formulário",
            "created_at": "23/04/2026 14:17:40",
            "close_date": "2026-05-01",
            "sla_target_hours": 24,
            "actual_time_hours": 196.62,
            "sla_met": false,
            "sla_breach_hours": 172.62,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/05/2026 18:54:42"
          },
          {
            "ticket_id": 15953,
            "ticket_number": "3515941",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604621143",
            "priority": "Reservas sem Formulário",
            "created_at": "23/04/2026 14:54:15",
            "close_date": "2026-05-01",
            "sla_target_hours": 24,
            "actual_time_hours": 195.98,
            "sla_met": false,
            "sla_breach_hours": 171.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/05/2026 18:53:49"
          },
          {
            "ticket_id": 15954,
            "ticket_number": "3515942",
            "title": "Envio de Nota de Crédito 28534/26",
            "priority": "P2",
            "created_at": "23/04/2026 15:17:19",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 15:36:12"
          },
          {
            "ticket_id": 15959,
            "ticket_number": "3515947",
            "title": "Alert Contact Info Modification",
            "priority": "P2",
            "created_at": "23/04/2026 16:04:55",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:34:26"
          },
          {
            "ticket_id": 15960,
            "ticket_number": "3515948",
            "title": "Alert Contact Info Modification",
            "priority": "P2",
            "created_at": "23/04/2026 16:04:56",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:36:02"
          },
          {
            "ticket_id": 15962,
            "ticket_number": "3515950",
            "title": "Alert Contact Info Modification",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:30",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:34:18"
          },
          {
            "ticket_id": 15963,
            "ticket_number": "3515951",
            "title": "Agora você tem acesso ao SIS Serviço",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:33",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:36:08"
          },
          {
            "ticket_id": 15964,
            "ticket_number": "3515952",
            "title": "Welcome to IATA Simplified Invoicing and Settlemen",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:35",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:32:44"
          },
          {
            "ticket_id": 15965,
            "ticket_number": "3515953",
            "title": "Welcome to IATA Simplified Invoicing and Settlemen",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:37",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:32:49"
          },
          {
            "ticket_id": 15967,
            "ticket_number": "3515955",
            "title": "Alert Contact Info Modification",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:42",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:35:01"
          },
          {
            "ticket_id": 15968,
            "ticket_number": "3515956",
            "title": "Agora você tem acesso ao SIS Serviço",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:44",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:35:10"
          },
          {
            "ticket_id": 15969,
            "ticket_number": "3515957",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604621213",
            "priority": "Reservas sem Formulário",
            "created_at": "23/04/2026 16:20:25",
            "close_date": "2026-04-27",
            "sla_target_hours": 24,
            "actual_time_hours": 95.15,
            "sla_met": false,
            "sla_breach_hours": 71.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/04/2026 15:29:52"
          },
          {
            "ticket_id": 15974,
            "ticket_number": "3515962",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "23/04/2026 17:11:03",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 19:18:32"
          },
          {
            "ticket_id": 15975,
            "ticket_number": "3515963",
            "title": "Código para cerrar reserva a B&B HOTEL Vila do Con",
            "priority": "P2",
            "created_at": "23/04/2026 17:11:05",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 17:14:52"
          },
          {
            "ticket_id": 15979,
            "ticket_number": "3515967",
            "title": "Reserva confirmada: Ingresso do Oceanário de Lisbo",
            "priority": "P2",
            "created_at": "23/04/2026 17:36:07",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 17:36:07"
          },
          {
            "ticket_id": 15996,
            "ticket_number": "3515984",
            "title": "GBN-120351 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/04/2026 21:06:26",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 21:06:26"
          },
          {
            "ticket_id": 15997,
            "ticket_number": "3515985",
            "title": "GBN-120353 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/04/2026 21:24:01",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 21:24:01"
          },
          {
            "ticket_id": 15998,
            "ticket_number": "3515986",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "23/04/2026 21:24:07",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 21:24:07"
          },
          {
            "ticket_id": 15999,
            "ticket_number": "3515987",
            "title": "Reserva confirmada: Ingresso do teleférico IFS Clo",
            "priority": "P2",
            "created_at": "23/04/2026 21:36:30",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 22:34:06"
          },
          {
            "ticket_id": 16000,
            "ticket_number": "3515988",
            "title": "Reserva confirmada: Ingresso do teleférico IFS Clo",
            "priority": "P2",
            "created_at": "23/04/2026 21:36:32",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 22:34:19"
          },
          {
            "ticket_id": 16001,
            "ticket_number": "3515989",
            "title": "GBN-120358 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/04/2026 21:52:03",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 21:52:03"
          },
          {
            "ticket_id": 16002,
            "ticket_number": "3515990",
            "title": "Reserva confirmada: Barco às ilhas Cíes - Civitati",
            "priority": "P2",
            "created_at": "23/04/2026 22:12:32",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 22:35:06"
          },
          {
            "ticket_id": 16003,
            "ticket_number": "3515991",
            "title": "Reserva confirmada: Barco às ilhas Cíes - Civitati",
            "priority": "P2",
            "created_at": "23/04/2026 22:12:35",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 22:35:11"
          },
          {
            "ticket_id": 16019,
            "ticket_number": "3516007",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "24/04/2026 09:11:02",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:38:51"
          },
          {
            "ticket_id": 16020,
            "ticket_number": "3516008",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "24/04/2026 09:11:03",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:29:45"
          },
          {
            "ticket_id": 16022,
            "ticket_number": "3516010",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "24/04/2026 09:20:05",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:25:41"
          },
          {
            "ticket_id": 16034,
            "ticket_number": "3516022",
            "title": "GBN-120399 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 11:13:26",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 11:13:26"
          },
          {
            "ticket_id": 16045,
            "ticket_number": "3516033",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604621956",
            "priority": "P2",
            "created_at": "24/04/2026 13:26:07",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 16:30:30"
          },
          {
            "ticket_id": 16051,
            "ticket_number": "3516039",
            "title": "GBN-120455 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 14:49:48",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 14:49:48"
          },
          {
            "ticket_id": 16057,
            "ticket_number": "3516045",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/04/2026 15:19:33",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:19:33"
          },
          {
            "ticket_id": 16059,
            "ticket_number": "3516047",
            "title": "Fwd: Viagify informa sobre a sua reserva 127335079",
            "priority": "P2",
            "created_at": "24/04/2026 15:19:39",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:19:40"
          },
          {
            "ticket_id": 16063,
            "ticket_number": "3516051",
            "title": "Pagamento da reserva – Ref PP147197, Sra. RUTE ISA",
            "priority": "P2",
            "created_at": "24/04/2026 16:36:01",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 16:40:29"
          },
          {
            "ticket_id": 16065,
            "ticket_number": "3516053",
            "title": "Documentação Disponível - Reserva 335271",
            "priority": "P2",
            "created_at": "24/04/2026 17:06:10",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:51:32"
          },
          {
            "ticket_id": 16071,
            "ticket_number": "3516059",
            "title": "Envio de Documentação * File 420474",
            "priority": "P2",
            "created_at": "24/04/2026 17:49:33",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:52:36"
          },
          {
            "ticket_id": 16075,
            "ticket_number": "3516063",
            "title": "GBN-120541 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 18:26:58",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 18:26:58"
          },
          {
            "ticket_id": 16082,
            "ticket_number": "3516070",
            "title": "GBN-120588 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 19:50:06",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 19:50:06"
          },
          {
            "ticket_id": 16083,
            "ticket_number": "3516071",
            "title": "GBN-118770 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/04/2026 20:16:08",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 20:41:42"
          },
          {
            "ticket_id": 16084,
            "ticket_number": "3516072",
            "title": "GBN-118770 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "24/04/2026 20:16:09",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 20:41:48"
          },
          {
            "ticket_id": 16086,
            "ticket_number": "3516074",
            "title": "Criação de processo File 439725/26",
            "priority": "P2",
            "created_at": "24/04/2026 20:28:14",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 20:44:04"
          },
          {
            "ticket_id": 16088,
            "ticket_number": "3516076",
            "title": "GBN-120575 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/04/2026 20:28:18",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 20:44:28"
          },
          {
            "ticket_id": 16091,
            "ticket_number": "3516079",
            "title": "GBN-120599 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 20:43:15",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 20:43:15"
          },
          {
            "ticket_id": 16094,
            "ticket_number": "3516082",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "24/04/2026 21:01:46",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:03:05"
          },
          {
            "ticket_id": 16095,
            "ticket_number": "3516083",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "24/04/2026 21:01:48",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:03:10"
          },
          {
            "ticket_id": 16096,
            "ticket_number": "3516084",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604622406",
            "priority": "P2",
            "created_at": "24/04/2026 21:01:49",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:03:20"
          },
          {
            "ticket_id": 16097,
            "ticket_number": "3516085",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "24/04/2026 21:01:51",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:03:24"
          },
          {
            "ticket_id": 16103,
            "ticket_number": "3516091",
            "title": "Confirmação de reserva – Ref PP971723, Sr. Claudio",
            "priority": "P2",
            "created_at": "24/04/2026 23:06:52",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 58.18,
            "sla_met": false,
            "sla_breach_hours": 54.18,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:18:25"
          },
          {
            "ticket_id": 16104,
            "ticket_number": "3516092",
            "title": "GBN-120575 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/04/2026 23:06:54",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:07:35"
          },
          {
            "ticket_id": 16106,
            "ticket_number": "3516094",
            "title": "GBN-120575 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "24/04/2026 23:06:57",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:09:38"
          },
          {
            "ticket_id": 16107,
            "ticket_number": "3516095",
            "title": "GBN-120575 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/04/2026 23:07:10",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:07:10"
          },
          {
            "ticket_id": 16115,
            "ticket_number": "3516103",
            "title": "Fwd: Viagify informa sobre a sua reserva 127392698",
            "priority": "P2",
            "created_at": "27/04/2026 09:08:39",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:08:39"
          },
          {
            "ticket_id": 16116,
            "ticket_number": "3516104",
            "title": "Información de reservas que entran en gastos próxi",
            "priority": "P2",
            "created_at": "27/04/2026 09:08:41",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:20:57"
          },
          {
            "ticket_id": 16121,
            "ticket_number": "3516109",
            "title": "Confirmación de la reserva con localizador: 419047",
            "priority": "P2",
            "created_at": "27/04/2026 09:08:53",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:22:27"
          },
          {
            "ticket_id": 16125,
            "ticket_number": "3516113",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP971723, Sr/a ",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:08",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:23:30"
          },
          {
            "ticket_id": 16128,
            "ticket_number": "3516116",
            "title": "GBN-120717 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/04/2026 09:09:16",
            "close_date": "2026-06-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/04/2026 09:09:16"
          },
          {
            "ticket_id": 16129,
            "ticket_number": "3516117",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:20",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:09:20"
          },
          {
            "ticket_id": 16133,
            "ticket_number": "3516121",
            "title": "GBN-120715 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:30",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:09:30"
          },
          {
            "ticket_id": 16134,
            "ticket_number": "3516122",
            "title": "GBN-120702 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:33",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:09:33"
          },
          {
            "ticket_id": 16135,
            "ticket_number": "3516123",
            "title": "Número de informação da reserva: 6146490",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:37",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:27:43"
          },
          {
            "ticket_id": 16136,
            "ticket_number": "3516124",
            "title": "GBN-120700 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:41",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:09:41"
          },
          {
            "ticket_id": 16137,
            "ticket_number": "3516125",
            "title": "Confirmação de reserva para For PT004157 71912227",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:45",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:28:06"
          },
          {
            "ticket_id": 16138,
            "ticket_number": "3516126",
            "title": "Traslado | Confirmação da reserva #136548917",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:08",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:28:21"
          },
          {
            "ticket_id": 16146,
            "ticket_number": "3516134",
            "title": "GBN-120685 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:27",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:11:27"
          },
          {
            "ticket_id": 16147,
            "ticket_number": "3516135",
            "title": "Fwd: Viagify informa sobre a sua reserva 127367800",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:29",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:11:30"
          },
          {
            "ticket_id": 16149,
            "ticket_number": "3516137",
            "title": "Confirmation of booking with locatorHKCGBYQ9",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:33",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:34:41"
          },
          {
            "ticket_id": 16151,
            "ticket_number": "3516139",
            "title": "Fwd: Viagify informa sobre a sua reserva 127367972",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:39",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:11:39"
          },
          {
            "ticket_id": 16155,
            "ticket_number": "3516143",
            "title": "Fwd: Viagify informa sobre a sua reserva 127069931",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:16",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:16"
          },
          {
            "ticket_id": 16156,
            "ticket_number": "3516144",
            "title": "Fwd: Viagify informa sobre a sua reserva 127348812",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:18",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:19"
          },
          {
            "ticket_id": 16159,
            "ticket_number": "3516147",
            "title": "Fwd: O78IGE | Traz a mala certa",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:25",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:26"
          },
          {
            "ticket_id": 16160,
            "ticket_number": "3516148",
            "title": "Fwd: Viagify informa sobre a sua reserva 127352851",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:29",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:30"
          },
          {
            "ticket_id": 16163,
            "ticket_number": "3516151",
            "title": "Fwd: Confirmação da sua reserva WQ8U3U - LIS-IBZ 2",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:41",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:42"
          },
          {
            "ticket_id": 16164,
            "ticket_number": "3516152",
            "title": "Criação de processo File 439734/26",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:49",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:39:46"
          },
          {
            "ticket_id": 16165,
            "ticket_number": "3516153",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:50",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:39:52"
          },
          {
            "ticket_id": 16167,
            "ticket_number": "3516155",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:53",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:40:11"
          },
          {
            "ticket_id": 16171,
            "ticket_number": "3516159",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 09:14:01",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:41:06"
          },
          {
            "ticket_id": 16172,
            "ticket_number": "3516160",
            "title": "MSC Cruises Document - 2600101003048825",
            "priority": "P2",
            "created_at": "27/04/2026 09:14:03",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:41:35"
          },
          {
            "ticket_id": 16173,
            "ticket_number": "3516161",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 09:14:14",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:41:40"
          },
          {
            "ticket_id": 16174,
            "ticket_number": "3516162",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 09:14:20",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:41:45"
          },
          {
            "ticket_id": 16224,
            "ticket_number": "3516212",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP175182, Sr/a ",
            "priority": "P2",
            "created_at": "27/04/2026 12:55:36",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:29:36"
          },
          {
            "ticket_id": 16239,
            "ticket_number": "3516227",
            "title": "[Cancelamento Viagem] TRP-2026-04896 - RICARDO FIL",
            "priority": "P2",
            "created_at": "27/04/2026 15:46:22",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 15:46:22"
          },
          {
            "ticket_id": 16273,
            "ticket_number": "3516261",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 20:22:22",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:18:27"
          },
          {
            "ticket_id": 16274,
            "ticket_number": "3516262",
            "title": "GBN-120943 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 20:22:25",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 20:22:25"
          },
          {
            "ticket_id": 16275,
            "ticket_number": "3516263",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 20:22:28",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:18:51"
          },
          {
            "ticket_id": 16276,
            "ticket_number": "3516264",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 20:25:24",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:19:03"
          },
          {
            "ticket_id": 16279,
            "ticket_number": "3516267",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "27/04/2026 21:09:27",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:09:27"
          },
          {
            "ticket_id": 16281,
            "ticket_number": "3516269",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 21:09:39",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:09:39"
          },
          {
            "ticket_id": 16282,
            "ticket_number": "3516270",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 21:09:41",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:20:33"
          },
          {
            "ticket_id": 16283,
            "ticket_number": "3516271",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "27/04/2026 21:37:02",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:52:41"
          },
          {
            "ticket_id": 16285,
            "ticket_number": "3516273",
            "title": "Reserva confirmada: Tour pela Catedral de Milão + ",
            "priority": "P2",
            "created_at": "27/04/2026 21:52:33",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:53:10"
          },
          {
            "ticket_id": 16286,
            "ticket_number": "3516274",
            "title": "GBN-120959 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 21:52:35",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:52:35"
          },
          {
            "ticket_id": 16288,
            "ticket_number": "3516276",
            "title": "Reserva confirmada: Tour pela Catedral de Milão + ",
            "priority": "P2",
            "created_at": "27/04/2026 21:52:40",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:55:10"
          },
          {
            "ticket_id": 16295,
            "ticket_number": "3516283",
            "title": "GBN-120964 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 22:46:20",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:46:20"
          },
          {
            "ticket_id": 16297,
            "ticket_number": "3516285",
            "title": "GBN-120962 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 22:46:26",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:46:26"
          },
          {
            "ticket_id": 16300,
            "ticket_number": "3516288",
            "title": "Fwd: Viagify informa sobre a sua reserva 127436675",
            "priority": "P2",
            "created_at": "28/04/2026 09:15:58",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:15:59"
          },
          {
            "ticket_id": 16301,
            "ticket_number": "3516289",
            "title": "Fwd: Os seus cartões de embarque estão prontos!🎉",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:01",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:02"
          },
          {
            "ticket_id": 16302,
            "ticket_number": "3516290",
            "title": "Fwd: Confirmação da sua reserva WQ8U3U - LIS-IBZ 2",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:05",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:06"
          },
          {
            "ticket_id": 16303,
            "ticket_number": "3516291",
            "title": "Importante - Checkin Online Voos TAP - FILE 335271",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:08",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:03:26"
          },
          {
            "ticket_id": 16305,
            "ticket_number": "3516293",
            "title": "Fwd: Viagify informa sobre a sua reserva 127436675",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:15",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:16"
          },
          {
            "ticket_id": 16317,
            "ticket_number": "3516305",
            "title": "Informação importante sobre a tua reserva 6124526",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:17",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:19:50"
          },
          {
            "ticket_id": 16318,
            "ticket_number": "3516306",
            "title": "Informação importante sobre a tua reserva 6139519",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:19",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:19:55"
          },
          {
            "ticket_id": 16353,
            "ticket_number": "3516341",
            "title": "Fwd: Viagify informa sobre a sua reserva 127462211",
            "priority": "P2",
            "created_at": "28/04/2026 14:09:37",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:09:38"
          },
          {
            "ticket_id": 16358,
            "ticket_number": "3516346",
            "title": "Confirmação de reserva 344772",
            "priority": "P2",
            "created_at": "28/04/2026 14:40:38",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 15:40:44"
          },
          {
            "ticket_id": 16367,
            "ticket_number": "3516355",
            "title": "Documentação Disponível - Reserva 335435",
            "priority": "P2",
            "created_at": "28/04/2026 16:47:32",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:05:07"
          },
          {
            "ticket_id": 16368,
            "ticket_number": "3516356",
            "title": "Fwd: Informações da sua reserva TTN-1274622119#100",
            "priority": "P2",
            "created_at": "28/04/2026 17:04:36",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:04:37"
          },
          {
            "ticket_id": 16369,
            "ticket_number": "3516357",
            "title": "Fwd: Viagify informa sobre a sua reserva 127469643",
            "priority": "P2",
            "created_at": "28/04/2026 17:04:39",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:04:39"
          },
          {
            "ticket_id": 16372,
            "ticket_number": "3516360",
            "title": "Criação de processo File 440001/26",
            "priority": "P2",
            "created_at": "28/04/2026 17:29:49",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:53:36"
          },
          {
            "ticket_id": 16377,
            "ticket_number": "3516365",
            "title": "Announcing Microsoft Excel integration",
            "priority": "P2",
            "created_at": "28/04/2026 17:43:19",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:52:17"
          },
          {
            "ticket_id": 16378,
            "ticket_number": "3516366",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "28/04/2026 17:52:48",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:52:48"
          },
          {
            "ticket_id": 16379,
            "ticket_number": "3516367",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "28/04/2026 17:52:55",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:52:55"
          },
          {
            "ticket_id": 16380,
            "ticket_number": "3516368",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "28/04/2026 18:04:23",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 18:04:23"
          },
          {
            "ticket_id": 16383,
            "ticket_number": "3516371",
            "title": "GBN-121257 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/04/2026 20:21:33",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:21:33"
          },
          {
            "ticket_id": 16386,
            "ticket_number": "3516374",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "28/04/2026 20:21:43",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:40:54"
          },
          {
            "ticket_id": 16395,
            "ticket_number": "3516383",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "28/04/2026 21:45:16",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 21:45:17"
          },
          {
            "ticket_id": 16405,
            "ticket_number": "3516393",
            "title": "Fwd: Viagify informa sobre a sua reserva 127476591",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:17",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:14:18"
          },
          {
            "ticket_id": 16421,
            "ticket_number": "3516409",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "29/04/2026 09:35:26",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:50:40"
          },
          {
            "ticket_id": 16426,
            "ticket_number": "3516414",
            "title": "RE: Pagamento 6145946",
            "priority": "P2",
            "created_at": "29/04/2026 10:00:26",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:01:35"
          },
          {
            "ticket_id": 16427,
            "ticket_number": "3516415",
            "title": "RE: Pagamento 6141384",
            "priority": "P2",
            "created_at": "29/04/2026 10:00:28",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:01:46"
          },
          {
            "ticket_id": 16428,
            "ticket_number": "3516416",
            "title": "RE: Pagamento 6146490",
            "priority": "P2",
            "created_at": "29/04/2026 10:00:30",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:01:41"
          },
          {
            "ticket_id": 16430,
            "ticket_number": "3516418",
            "title": "Recebimento de Grupos - (Factura de Adiantamento-2",
            "priority": "P2",
            "created_at": "29/04/2026 10:36:38",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:04:07"
          },
          {
            "ticket_id": 16439,
            "ticket_number": "3516427",
            "title": "Re: [Cockpit] Viagem TRP-2026-04916 - VOO MADEIRA",
            "priority": "P2",
            "created_at": "29/04/2026 11:34:21",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:34:21"
          },
          {
            "ticket_id": 16440,
            "ticket_number": "3516428",
            "title": "Escapadinha nos Fiordes",
            "priority": "P2",
            "created_at": "29/04/2026 11:34:24",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:47:43"
          },
          {
            "ticket_id": 16444,
            "ticket_number": "3516432",
            "title": "¡Exclusivo! Playas de Grecia 😍 Descubre sus maravi",
            "priority": "P2",
            "created_at": "29/04/2026 11:39:56",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:45:12"
          },
          {
            "ticket_id": 16507,
            "ticket_number": "3516495",
            "title": "Confirmação de reserva – Ref PP301166, Sr. Pedro C",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:12",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 19:27:04"
          },
          {
            "ticket_id": 16508,
            "ticket_number": "3516496",
            "title": "Confirmação de reserva – Ref PP209993, Sr. Pedro C",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:13",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:37:37"
          },
          {
            "ticket_id": 16511,
            "ticket_number": "3516499",
            "title": "Fwd: Informações da sua reserva TTN-1274580990#100",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:20",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 18:46:21"
          },
          {
            "ticket_id": 16521,
            "ticket_number": "3516509",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "29/04/2026 21:24:13",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:43:07"
          },
          {
            "ticket_id": 16522,
            "ticket_number": "3516510",
            "title": "GBN-121469 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/04/2026 21:24:20",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:24:20"
          },
          {
            "ticket_id": 16525,
            "ticket_number": "3516513",
            "title": "GBN-121469 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/04/2026 21:44:08",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:46:25"
          },
          {
            "ticket_id": 16526,
            "ticket_number": "3516514",
            "title": "Número de informação da reserva: 6146808",
            "priority": "P2",
            "created_at": "29/04/2026 21:44:40",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:50:23"
          },
          {
            "ticket_id": 16530,
            "ticket_number": "3516518",
            "title": "GBN-121269 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/04/2026 22:47:46",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:48:47"
          },
          {
            "ticket_id": 16532,
            "ticket_number": "3516520",
            "title": "GBN-121269 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/04/2026 22:47:51",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:49:38"
          },
          {
            "ticket_id": 16533,
            "ticket_number": "3516521",
            "title": "GBN-121269 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/04/2026 22:47:57",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:47:57"
          },
          {
            "ticket_id": 16554,
            "ticket_number": "3516542",
            "title": "Envio de Bilhete Bsp 658462/26",
            "priority": "P2",
            "created_at": "30/04/2026 10:37:34",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 12:15:36"
          },
          {
            "ticket_id": 16582,
            "ticket_number": "3516570",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60462121",
            "priority": "P2",
            "created_at": "30/04/2026 13:58:37",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 12:49:59"
          },
          {
            "ticket_id": 16588,
            "ticket_number": "3516576",
            "title": "Confirmação de reserva para For PT004157 71972459",
            "priority": "P2",
            "created_at": "30/04/2026 14:19:11",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 6.1,
            "sla_met": false,
            "sla_breach_hours": 2.1,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:25:37"
          },
          {
            "ticket_id": 16621,
            "ticket_number": "3516609",
            "title": "Confirmacao 344677",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:44",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:29:44"
          },
          {
            "ticket_id": 16622,
            "ticket_number": "3516610",
            "title": "Confirmacao 344422",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:46",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:29:56"
          },
          {
            "ticket_id": 16623,
            "ticket_number": "3516611",
            "title": "Confirmacao 344267",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:51",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:30:00"
          },
          {
            "ticket_id": 16624,
            "ticket_number": "3516612",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:55",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:10:55"
          },
          {
            "ticket_id": 16625,
            "ticket_number": "3516613",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:59",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:10:59"
          },
          {
            "ticket_id": 16626,
            "ticket_number": "3516614",
            "title": "Confirmacao 344365",
            "priority": "P2",
            "created_at": "30/04/2026 18:11:01",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:30:29"
          },
          {
            "ticket_id": 16627,
            "ticket_number": "3516615",
            "title": "Confirmacao 344698",
            "priority": "P2",
            "created_at": "30/04/2026 18:11:04",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:30:34"
          },
          {
            "ticket_id": 16628,
            "ticket_number": "3516616",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 18:11:13",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:11:13"
          },
          {
            "ticket_id": 16629,
            "ticket_number": "3516617",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 18:11:21",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:11:21"
          },
          {
            "ticket_id": 16634,
            "ticket_number": "3516622",
            "title": "GBN-121691 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:01",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:57:01"
          },
          {
            "ticket_id": 16635,
            "ticket_number": "3516623",
            "title": "GBN-121701 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:04",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:57:04"
          },
          {
            "ticket_id": 16636,
            "ticket_number": "3516624",
            "title": "GBN-121696 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:07",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:57:07"
          },
          {
            "ticket_id": 16637,
            "ticket_number": "3516625",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:10",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:57:10"
          },
          {
            "ticket_id": 16638,
            "ticket_number": "3516626",
            "title": "Re:[## 39960 ##] GBN-114599 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:15",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:38:57"
          },
          {
            "ticket_id": 16639,
            "ticket_number": "3516627",
            "title": "GBN-114599 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:17",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:12"
          },
          {
            "ticket_id": 16641,
            "ticket_number": "3516629",
            "title": "Confirmacao 344723",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:23",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:18"
          },
          {
            "ticket_id": 16642,
            "ticket_number": "3516630",
            "title": "Confirmacao 344775",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:25",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:22"
          },
          {
            "ticket_id": 16643,
            "ticket_number": "3516631",
            "title": "Confirmacao 344772",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:26",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:27"
          },
          {
            "ticket_id": 16644,
            "ticket_number": "3516632",
            "title": "Confirmacao 344821",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:28",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:33"
          },
          {
            "ticket_id": 16645,
            "ticket_number": "3516633",
            "title": "Confirmacao 344778",
            "priority": "P2",
            "created_at": "30/04/2026 18:57:30",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:39:37"
          },
          {
            "ticket_id": 16646,
            "ticket_number": "3516634",
            "title": "GBN-121704 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 19:01:57",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 19:01:57"
          },
          {
            "ticket_id": 16647,
            "ticket_number": "3516635",
            "title": "Bom dia Luis Filipe Rodrigues Dos Santos: Bilhete ",
            "priority": "P2",
            "created_at": "30/04/2026 19:02:02",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.08,
            "sla_met": false,
            "sla_breach_hours": 35.08,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:07:15"
          },
          {
            "ticket_id": 16649,
            "ticket_number": "3516637",
            "title": "Civitatis - Re: Contacto - Perguntas frequentes da",
            "priority": "P2",
            "created_at": "30/04/2026 19:02:55",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 22:25:22"
          },
          {
            "ticket_id": 16651,
            "ticket_number": "3516639",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 19:02:59",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.07,
            "sla_met": false,
            "sla_breach_hours": 35.07,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:07:26"
          },
          {
            "ticket_id": 16652,
            "ticket_number": "3516640",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 19:03:01",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.07,
            "sla_met": false,
            "sla_breach_hours": 35.07,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:07:32"
          },
          {
            "ticket_id": 16653,
            "ticket_number": "3516641",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 19:03:04",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.07,
            "sla_met": false,
            "sla_breach_hours": 35.07,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:07:36"
          },
          {
            "ticket_id": 16654,
            "ticket_number": "3516642",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 19:03:07",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.07,
            "sla_met": false,
            "sla_breach_hours": 35.07,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:07:40"
          },
          {
            "ticket_id": 16656,
            "ticket_number": "3516644",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 19:03:12",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 22:26:05"
          },
          {
            "ticket_id": 16658,
            "ticket_number": "3516646",
            "title": "GBN-121710 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 19:56:32",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 19:56:32"
          },
          {
            "ticket_id": 16660,
            "ticket_number": "3516648",
            "title": "Confirmação de reserva com localizador: 4197950",
            "priority": "P2",
            "created_at": "30/04/2026 19:56:37",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 38.2,
            "sla_met": false,
            "sla_breach_hours": 34.2,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:08:45"
          },
          {
            "ticket_id": 16661,
            "ticket_number": "3516649",
            "title": "Informação de reserva - SPT002601627440",
            "priority": "P2",
            "created_at": "30/04/2026 19:56:40",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 39.13,
            "sla_met": false,
            "sla_breach_hours": 35.13,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 11:05:21"
          },
          {
            "ticket_id": 16664,
            "ticket_number": "3516652",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "30/04/2026 21:12:16",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:34:52"
          },
          {
            "ticket_id": 16669,
            "ticket_number": "3516657",
            "title": "Número de informação da reserva: 6146921",
            "priority": "P2",
            "created_at": "30/04/2026 21:34:47",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 36.58,
            "sla_met": false,
            "sla_breach_hours": 32.58,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:10:37"
          },
          {
            "ticket_id": 16671,
            "ticket_number": "3516659",
            "title": "[Suporte] TRP-2026-04947 - Dados faturação + pedid",
            "priority": "P2",
            "created_at": "30/04/2026 21:48:42",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:48:42"
          },
          {
            "ticket_id": 16677,
            "ticket_number": "3516665",
            "title": "Criação de processo File 440264/26",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:11",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 7.82,
            "sla_met": false,
            "sla_breach_hours": 3.82,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 17:44:43"
          },
          {
            "ticket_id": 16678,
            "ticket_number": "3516666",
            "title": "Informações da sua reserva TTN-1275622917#10056791",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:13",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 11:22:52"
          },
          {
            "ticket_id": 16679,
            "ticket_number": "3516667",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604626579",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:32",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:11:47"
          },
          {
            "ticket_id": 16682,
            "ticket_number": "3516670",
            "title": "GBN-121727 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:39",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:55:39"
          },
          {
            "ticket_id": 16688,
            "ticket_number": "3516676",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/05/2026 09:56:37",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:13:08"
          },
          {
            "ticket_id": 16691,
            "ticket_number": "3516679",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "02/05/2026 09:56:46",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:13:42"
          },
          {
            "ticket_id": 16696,
            "ticket_number": "3516684",
            "title": "Re:[## 40025 ##] GBN-105065 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "02/05/2026 09:58:39",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:19:15"
          },
          {
            "ticket_id": 16698,
            "ticket_number": "3516686",
            "title": "Re:[## 40025 ##] GBN-105065 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "02/05/2026 09:58:43",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:58:59"
          },
          {
            "ticket_id": 16702,
            "ticket_number": "3516690",
            "title": "Re:[## 40025 ##] GBN-105065 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:02",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:21:21"
          },
          {
            "ticket_id": 16708,
            "ticket_number": "3516696",
            "title": "Confirmação de reserva para For PT004157 71912227",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:17",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:23:14"
          },
          {
            "ticket_id": 16710,
            "ticket_number": "3516698",
            "title": "GBN-121759 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:27",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:59:27"
          },
          {
            "ticket_id": 16711,
            "ticket_number": "3516699",
            "title": "Informação de reserva - SPT002601627440",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:31",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.33,
            "sla_met": false,
            "sla_breach_hours": 1.33,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:19:48"
          },
          {
            "ticket_id": 16712,
            "ticket_number": "3516700",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:33",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:23:49"
          },
          {
            "ticket_id": 16713,
            "ticket_number": "3516701",
            "title": "GBN-105065 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:35",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:23:59"
          },
          {
            "ticket_id": 16714,
            "ticket_number": "3516702",
            "title": "GBN-105065 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:36",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:24:04"
          },
          {
            "ticket_id": 16715,
            "ticket_number": "3516703",
            "title": "Re:[## 40025 ##] GBN-105065 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:38",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.28,
            "sla_met": false,
            "sla_breach_hours": 1.28,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:17:04"
          },
          {
            "ticket_id": 16716,
            "ticket_number": "3516704",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:40",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:24:23"
          },
          {
            "ticket_id": 16717,
            "ticket_number": "3516705",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:43",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:24:34"
          },
          {
            "ticket_id": 16727,
            "ticket_number": "3516715",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:05",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:26:17"
          },
          {
            "ticket_id": 16728,
            "ticket_number": "3516716",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:08",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 47.17,
            "sla_met": false,
            "sla_breach_hours": 43.17,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:12:03"
          },
          {
            "ticket_id": 16730,
            "ticket_number": "3516718",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:17",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:01:17"
          },
          {
            "ticket_id": 16731,
            "ticket_number": "3516719",
            "title": "Confirmation of booking with locator980NOEE4",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:20",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:26:56"
          },
          {
            "ticket_id": 16734,
            "ticket_number": "3516722",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:25",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:01:26"
          },
          {
            "ticket_id": 16737,
            "ticket_number": "3516725",
            "title": "Confirmação de reserva com localizador: 4198644",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:43",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:27:48"
          },
          {
            "ticket_id": 16739,
            "ticket_number": "3516727",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:47",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.4,
            "sla_met": false,
            "sla_breach_hours": 1.4,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:26:24"
          },
          {
            "ticket_id": 16740,
            "ticket_number": "3516728",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:49",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:01:49"
          },
          {
            "ticket_id": 16742,
            "ticket_number": "3516730",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:58",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.42,
            "sla_met": false,
            "sla_breach_hours": 1.42,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:27:14"
          },
          {
            "ticket_id": 16745,
            "ticket_number": "3516733",
            "title": "GBN-111286 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/05/2026 12:41:32",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.38,
            "sla_met": false,
            "sla_breach_hours": 1.38,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:05:23"
          },
          {
            "ticket_id": 16748,
            "ticket_number": "3516736",
            "title": "URGENTE - Antecipação de retirada de veículo (para",
            "priority": "P2",
            "created_at": "02/05/2026 12:41:39",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 16:49:02"
          },
          {
            "ticket_id": 16749,
            "ticket_number": "3516737",
            "title": "GBN-111286 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/05/2026 12:41:42",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 12:41:40"
          },
          {
            "ticket_id": 16752,
            "ticket_number": "3516740",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "02/05/2026 15:16:49",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:45:03"
          },
          {
            "ticket_id": 16754,
            "ticket_number": "3516742",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 9",
            "priority": "P2",
            "created_at": "02/05/2026 15:16:53",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:45:50"
          },
          {
            "ticket_id": 16756,
            "ticket_number": "3516744",
            "title": "Confirmação de reserva. Localizador: 9UAOAPOB6T",
            "priority": "P2",
            "created_at": "02/05/2026 15:16:58",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:48:56"
          },
          {
            "ticket_id": 16757,
            "ticket_number": "3516745",
            "title": "Z5W59N | Atualização importante para todos os pass",
            "priority": "P2",
            "created_at": "02/05/2026 15:17:01",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:49:20"
          },
          {
            "ticket_id": 16760,
            "ticket_number": "3516748",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "02/05/2026 16:02:20",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:05:44"
          },
          {
            "ticket_id": 16761,
            "ticket_number": "3516749",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "02/05/2026 16:02:23",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:05:55"
          },
          {
            "ticket_id": 16762,
            "ticket_number": "3516750",
            "title": "Cancelamento de Reservas 59-5712365 Bedsonline",
            "priority": "P2",
            "created_at": "02/05/2026 16:40:55",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:06:06"
          },
          {
            "ticket_id": 16763,
            "ticket_number": "3516751",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "02/05/2026 16:40:57",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:06:14"
          },
          {
            "ticket_id": 16764,
            "ticket_number": "3516752",
            "title": "GBN-121841 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/05/2026 16:41:00",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 16:41:00"
          },
          {
            "ticket_id": 16767,
            "ticket_number": "3516755",
            "title": "Confirmacao 345084",
            "priority": "P2",
            "created_at": "02/05/2026 17:21:06",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 40.53,
            "sla_met": false,
            "sla_breach_hours": 36.53,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:53:18"
          },
          {
            "ticket_id": 16768,
            "ticket_number": "3516756",
            "title": "Informação de reserva - SPT002601627784",
            "priority": "P2",
            "created_at": "02/05/2026 17:50:42",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 40.03,
            "sla_met": false,
            "sla_breach_hours": 36.03,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:53:31"
          },
          {
            "ticket_id": 16785,
            "ticket_number": "3516773",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "04/05/2026 09:09:50",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:09:51"
          },
          {
            "ticket_id": 16787,
            "ticket_number": "3516775",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:02",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:10:02"
          },
          {
            "ticket_id": 16791,
            "ticket_number": "3516779",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:21",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:00:24"
          },
          {
            "ticket_id": 16792,
            "ticket_number": "3516780",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:25",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:00:38"
          },
          {
            "ticket_id": 16793,
            "ticket_number": "3516781",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:28",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:00:51"
          },
          {
            "ticket_id": 16795,
            "ticket_number": "3516783",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:34",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:01:29"
          },
          {
            "ticket_id": 16796,
            "ticket_number": "3516784",
            "title": "GBN-121894 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:40",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:10:40"
          },
          {
            "ticket_id": 16797,
            "ticket_number": "3516785",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:42",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:01:52"
          },
          {
            "ticket_id": 16798,
            "ticket_number": "3516786",
            "title": "GBN-121903 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:51",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:10:51"
          },
          {
            "ticket_id": 16799,
            "ticket_number": "3516787",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:57",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:02:12"
          },
          {
            "ticket_id": 16800,
            "ticket_number": "3516788",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:01",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:02:18"
          },
          {
            "ticket_id": 16801,
            "ticket_number": "3516789",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:11",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:03:48"
          },
          {
            "ticket_id": 16803,
            "ticket_number": "3516791",
            "title": "Reserva confirmada: Venice Flex Pass - Civitatis.c",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:17",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:04:45"
          },
          {
            "ticket_id": 16804,
            "ticket_number": "3516792",
            "title": "Reserva confirmada: Venice Flex Pass - Civitatis.c",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:21",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:04:57"
          },
          {
            "ticket_id": 16806,
            "ticket_number": "3516794",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:26",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:05:18"
          },
          {
            "ticket_id": 16807,
            "ticket_number": "3516795",
            "title": "Confirmacao 345098",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:29",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:05:42"
          },
          {
            "ticket_id": 16808,
            "ticket_number": "3516796",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:32",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:05:54"
          },
          {
            "ticket_id": 16810,
            "ticket_number": "3516798",
            "title": "GBN-121787 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:48",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:06:27"
          },
          {
            "ticket_id": 16814,
            "ticket_number": "3516802",
            "title": "GBN-121787 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:56",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:07:15"
          },
          {
            "ticket_id": 16815,
            "ticket_number": "3516803",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:00",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:07:20"
          },
          {
            "ticket_id": 16817,
            "ticket_number": "3516805",
            "title": "GBN-121825 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:12",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:12:12"
          },
          {
            "ticket_id": 16818,
            "ticket_number": "3516806",
            "title": "GBN-121825 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:15",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:08:19"
          },
          {
            "ticket_id": 16819,
            "ticket_number": "3516807",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:17",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:08:25"
          },
          {
            "ticket_id": 16820,
            "ticket_number": "3516808",
            "title": "Confirmação de reserva com localizador: 4199178",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:19",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:08:35"
          },
          {
            "ticket_id": 16821,
            "ticket_number": "3516809",
            "title": "GBN-121825 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:20",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:08:46"
          },
          {
            "ticket_id": 16822,
            "ticket_number": "3516810",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:12:23",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:08:51"
          },
          {
            "ticket_id": 16839,
            "ticket_number": "3516827",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "04/05/2026 09:31:23",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:16:00"
          },
          {
            "ticket_id": 16843,
            "ticket_number": "3516831",
            "title": "GBN-121910 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 09:48:55",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:48:55"
          },
          {
            "ticket_id": 16926,
            "ticket_number": "3516914",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/05/2026 18:14:05",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:14:06"
          },
          {
            "ticket_id": 16944,
            "ticket_number": "3516932",
            "title": "Confirmação de reserva com localizador: 4201513",
            "priority": "P2",
            "created_at": "04/05/2026 21:21:35",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 21:57:26"
          },
          {
            "ticket_id": 16948,
            "ticket_number": "3516936",
            "title": "GBN-122140 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 21:33:15",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 21:33:16"
          },
          {
            "ticket_id": 16950,
            "ticket_number": "3516938",
            "title": "Confirmação de reserva com localizador: 4201523",
            "priority": "P2",
            "created_at": "04/05/2026 22:00:14",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:35:08"
          },
          {
            "ticket_id": 16957,
            "ticket_number": "3516945",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "04/05/2026 22:25:18",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:42:05"
          },
          {
            "ticket_id": 16959,
            "ticket_number": "3516947",
            "title": "Reserva de transfer em París (Paris Centro - Disne",
            "priority": "P2",
            "created_at": "04/05/2026 22:25:23",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:42:34"
          },
          {
            "ticket_id": 16962,
            "ticket_number": "3516950",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "04/05/2026 22:25:32",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:43:28"
          },
          {
            "ticket_id": 16963,
            "ticket_number": "3516951",
            "title": "Reserva cancelada com localizador: 4171609",
            "priority": "P2",
            "created_at": "04/05/2026 22:44:15",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:44:54"
          },
          {
            "ticket_id": 17003,
            "ticket_number": "3516991",
            "title": "GBN-121830 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/05/2026 12:26:34",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 12:29:20"
          },
          {
            "ticket_id": 17017,
            "ticket_number": "3517005",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/05/2026 13:29:26",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:29:26"
          },
          {
            "ticket_id": 17028,
            "ticket_number": "3517016",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/05/2026 15:01:17",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 15:01:17"
          },
          {
            "ticket_id": 17042,
            "ticket_number": "3517030",
            "title": "Mensagem sobre a reserva 37544721 - Civitatis",
            "priority": "P2",
            "created_at": "05/05/2026 16:38:52",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:44:59"
          },
          {
            "ticket_id": 17047,
            "ticket_number": "3517035",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/05/2026 16:49:54",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:49:54"
          },
          {
            "ticket_id": 17055,
            "ticket_number": "3517043",
            "title": "Pagamento da reserva – Ref PP213166, Sr. FABIO ASC",
            "priority": "P2",
            "created_at": "05/05/2026 18:17:12",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 18:17:48"
          },
          {
            "ticket_id": 17057,
            "ticket_number": "3517045",
            "title": "Faturas Pendentes: FA 2147911036",
            "priority": "P2",
            "created_at": "05/05/2026 18:19:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 18:20:22"
          },
          {
            "ticket_id": 17067,
            "ticket_number": "3517055",
            "title": "Confirmação de reserva – Ref PP458177, Sra. Catari",
            "priority": "P2",
            "created_at": "05/05/2026 22:01:41",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:29:07"
          },
          {
            "ticket_id": 17068,
            "ticket_number": "3517056",
            "title": "Reserva Atividade %s alterada: Ingresso da Disneyl",
            "priority": "P2",
            "created_at": "05/05/2026 22:01:43",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:29:27"
          },
          {
            "ticket_id": 17070,
            "ticket_number": "3517058",
            "title": "GBN-122361 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/05/2026 22:01:48",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:01:48"
          },
          {
            "ticket_id": 17078,
            "ticket_number": "3517066",
            "title": "Confirmation of booking with locatorK9SCGJ34",
            "priority": "P2",
            "created_at": "05/05/2026 22:27:17",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 13.35,
            "sla_met": false,
            "sla_breach_hours": 9.35,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:49:12"
          },
          {
            "ticket_id": 17090,
            "ticket_number": "3517078",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "06/05/2026 09:12:34",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 09:12:35"
          },
          {
            "ticket_id": 17133,
            "ticket_number": "3517121",
            "title": "[Suporte] TRP-2026-02854 - Pedido de redução de no",
            "priority": "P2",
            "created_at": "06/05/2026 13:52:07",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 13:52:07"
          },
          {
            "ticket_id": 17136,
            "ticket_number": "3517124",
            "title": "GBN-122364 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/05/2026 14:46:09",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:46:09"
          },
          {
            "ticket_id": 17150,
            "ticket_number": "3517138",
            "title": "Criação de processo File 440688/26",
            "priority": "P2",
            "created_at": "06/05/2026 16:05:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:13:54"
          },
          {
            "ticket_id": 17166,
            "ticket_number": "3517154",
            "title": "Reserva confirmada: Veleiro por La Maddalena, Spar",
            "priority": "P2",
            "created_at": "06/05/2026 17:11:01",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 19:18:03"
          },
          {
            "ticket_id": 17179,
            "ticket_number": "3517167",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "06/05/2026 19:07:02",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:04:38"
          },
          {
            "ticket_id": 17188,
            "ticket_number": "3517176",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:08",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:10:41"
          },
          {
            "ticket_id": 17189,
            "ticket_number": "3517177",
            "title": "Reserva confirmada: Passeio de barco pelas calas d",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:10",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:10:55"
          },
          {
            "ticket_id": 17190,
            "ticket_number": "3517178",
            "title": "Confirmação de reserva com localizador: 4205577",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:13",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:11:07"
          },
          {
            "ticket_id": 17191,
            "ticket_number": "3517179",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:11:14"
          },
          {
            "ticket_id": 17192,
            "ticket_number": "3517180",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:19",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 21:43:30"
          },
          {
            "ticket_id": 17194,
            "ticket_number": "3517182",
            "title": "Reserva confirmada: Passeio de barco pelas calas d",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:24",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:12:46"
          },
          {
            "ticket_id": 17195,
            "ticket_number": "3517183",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:28",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:12:51"
          },
          {
            "ticket_id": 17197,
            "ticket_number": "3517185",
            "title": "Confirmação de reserva – Ref PP563126, Sra. Maria ",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 47.63,
            "sla_met": false,
            "sla_breach_hours": 43.63,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 21:21:44"
          },
          {
            "ticket_id": 17203,
            "ticket_number": "3517191",
            "title": "GBN-117699 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:48",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:18:00"
          },
          {
            "ticket_id": 17216,
            "ticket_number": "3517204",
            "title": "Reserva de transfer em Almeria (Roquetas de Mar - ",
            "priority": "P2",
            "created_at": "06/05/2026 23:03:06",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 21.6,
            "sla_met": false,
            "sla_breach_hours": 17.6,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:39:49"
          },
          {
            "ticket_id": 17272,
            "ticket_number": "3517260",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/05/2026 13:43:06",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:43:06"
          },
          {
            "ticket_id": 17299,
            "ticket_number": "3517287",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "07/05/2026 17:07:14",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:40:33"
          },
          {
            "ticket_id": 17319,
            "ticket_number": "3517307",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:16",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:46:30"
          },
          {
            "ticket_id": 17321,
            "ticket_number": "3517309",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 3",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:21",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:47:59"
          },
          {
            "ticket_id": 17323,
            "ticket_number": "3517311",
            "title": "Confirmação de reserva. Localizador: 6V9F70FF30",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:25",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:48:19"
          },
          {
            "ticket_id": 17325,
            "ticket_number": "3517313",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:34",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:48:49"
          },
          {
            "ticket_id": 17340,
            "ticket_number": "3517328",
            "title": "GBN-122917 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:29",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 21:59:29"
          },
          {
            "ticket_id": 17368,
            "ticket_number": "3517356",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "07/05/2026 22:59:51",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 10.05,
            "sla_met": false,
            "sla_breach_hours": 6.05,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:03:10"
          },
          {
            "ticket_id": 17369,
            "ticket_number": "3517357",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "07/05/2026 22:59:54",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 10.05,
            "sla_met": false,
            "sla_breach_hours": 6.05,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:03:18"
          },
          {
            "ticket_id": 17370,
            "ticket_number": "3517358",
            "title": "Confirmação de reserva – Ref PP246702, Sra. Diana ",
            "priority": "P2",
            "created_at": "07/05/2026 22:59:57",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 10.32,
            "sla_met": false,
            "sla_breach_hours": 6.32,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:19:41"
          },
          {
            "ticket_id": 17381,
            "ticket_number": "3517369",
            "title": "Reserva confirmada: Cerimônia do chá em Tóquio - C",
            "priority": "P2",
            "created_at": "08/05/2026 11:24:21",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:21:55"
          },
          {
            "ticket_id": 17383,
            "ticket_number": "3517371",
            "title": "[Suporte] TRP-2026-04280 - Pagamento",
            "priority": "P2",
            "created_at": "08/05/2026 13:07:12",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 13:07:12"
          },
          {
            "ticket_id": 17389,
            "ticket_number": "3517377",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604630953",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:08",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 4.13,
            "sla_met": false,
            "sla_breach_hours": 0.13,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 18:27:34"
          },
          {
            "ticket_id": 17394,
            "ticket_number": "3517382",
            "title": "Confirmação de reserva – Ref PP158018, Sr. Bruno T",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:21",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 6.98,
            "sla_met": false,
            "sla_breach_hours": 2.98,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 21:19:10"
          },
          {
            "ticket_id": 17396,
            "ticket_number": "3517384",
            "title": "Informação de reserva - SPT002601624165",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:28",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:05:52"
          },
          {
            "ticket_id": 17398,
            "ticket_number": "3517386",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:32",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 14:19:32"
          },
          {
            "ticket_id": 17401,
            "ticket_number": "3517389",
            "title": "VOUCHER DA RESERVA 604519316",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:52",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:04:41"
          },
          {
            "ticket_id": 17402,
            "ticket_number": "3517390",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "08/05/2026 14:19:54",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 14:19:16"
          },
          {
            "ticket_id": 17404,
            "ticket_number": "3517392",
            "title": "Número de informação da reserva: 6147441",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:14",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:02:12"
          },
          {
            "ticket_id": 17405,
            "ticket_number": "3517393",
            "title": "Número de informação da reserva: 6147443",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:17",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:02:26"
          },
          {
            "ticket_id": 17406,
            "ticket_number": "3517394",
            "title": "Número de informação da reserva: 6147437",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:22",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:02:45"
          },
          {
            "ticket_id": 17407,
            "ticket_number": "3517395",
            "title": "Informação de reserva - SPT002501549170",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:26",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:04:21"
          },
          {
            "ticket_id": 17408,
            "ticket_number": "3517396",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:29",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:33:29"
          },
          {
            "ticket_id": 17409,
            "ticket_number": "3517397",
            "title": "Número de informação da reserva: 6147436",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:32",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:07:14"
          },
          {
            "ticket_id": 17410,
            "ticket_number": "3517398",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:40",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:33:40"
          },
          {
            "ticket_id": 17411,
            "ticket_number": "3517399",
            "title": "Confirmacao 345348",
            "priority": "P2",
            "created_at": "08/05/2026 15:33:42",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:00:24"
          },
          {
            "ticket_id": 17419,
            "ticket_number": "3517407",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "08/05/2026 16:26:30",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:37:34"
          },
          {
            "ticket_id": 17420,
            "ticket_number": "3517408",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "08/05/2026 16:26:34",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:06:58"
          },
          {
            "ticket_id": 17421,
            "ticket_number": "3517409",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "08/05/2026 16:26:39",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 16:26:39"
          },
          {
            "ticket_id": 17424,
            "ticket_number": "3517412",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "08/05/2026 17:07:03",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 18:34:44"
          },
          {
            "ticket_id": 17426,
            "ticket_number": "3517414",
            "title": "Pagamento da reserva – Ref PP583324, Sr. Jorge Pin",
            "priority": "P2",
            "created_at": "08/05/2026 17:07:07",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:28:20"
          },
          {
            "ticket_id": 17427,
            "ticket_number": "3517415",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "08/05/2026 17:07:09",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 18:35:09"
          },
          {
            "ticket_id": 17428,
            "ticket_number": "3517416",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "08/05/2026 17:07:15",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:36:35"
          },
          {
            "ticket_id": 17431,
            "ticket_number": "3517419",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "08/05/2026 19:00:46",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 19:00:46"
          },
          {
            "ticket_id": 17432,
            "ticket_number": "3517420",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "08/05/2026 19:00:49",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 19:19:45"
          },
          {
            "ticket_id": 17434,
            "ticket_number": "3517422",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "08/05/2026 19:00:58",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 19:21:03"
          },
          {
            "ticket_id": 17437,
            "ticket_number": "3517425",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "08/05/2026 20:17:32",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 20:49:14"
          },
          {
            "ticket_id": 17438,
            "ticket_number": "3517426",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "08/05/2026 20:17:34",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 20:49:19"
          },
          {
            "ticket_id": 17439,
            "ticket_number": "3517427",
            "title": "GBN-123161 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/05/2026 20:17:38",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 20:17:38"
          },
          {
            "ticket_id": 17440,
            "ticket_number": "3517428",
            "title": "GBN-123156 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/05/2026 20:17:42",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 20:17:42"
          },
          {
            "ticket_id": 17441,
            "ticket_number": "3517429",
            "title": "GBN-123166 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/05/2026 21:02:40",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 21:02:40"
          },
          {
            "ticket_id": 17444,
            "ticket_number": "3517432",
            "title": "GBN-123167 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/05/2026 21:24:43",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 21:24:43"
          },
          {
            "ticket_id": 17446,
            "ticket_number": "3517434",
            "title": "Criação de processo File 440943/26",
            "priority": "P2",
            "created_at": "08/05/2026 21:47:46",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 14.45,
            "sla_met": false,
            "sla_breach_hours": 10.45,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:15:01"
          },
          {
            "ticket_id": 17451,
            "ticket_number": "3517439",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "08/05/2026 22:52:03",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 13.23,
            "sla_met": false,
            "sla_breach_hours": 9.23,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:06:26"
          },
          {
            "ticket_id": 17460,
            "ticket_number": "3517448",
            "title": "Confirmação de reserva para For PT004157 72194695",
            "priority": "P2",
            "created_at": "09/05/2026 09:03:24",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 4.18,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 13:14:32"
          },
          {
            "ticket_id": 17462,
            "ticket_number": "3517450",
            "title": "Criação de processo File 440950/26",
            "priority": "P2",
            "created_at": "09/05/2026 09:03:33",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:12:35"
          },
          {
            "ticket_id": 17463,
            "ticket_number": "3517451",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604631334",
            "priority": "P2",
            "created_at": "09/05/2026 09:03:35",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.48,
            "sla_met": false,
            "sla_breach_hours": 2.48,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:32:48"
          },
          {
            "ticket_id": 17464,
            "ticket_number": "3517452",
            "title": "Criação de processo File 440949/26",
            "priority": "P2",
            "created_at": "09/05/2026 09:03:41",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:21:48"
          },
          {
            "ticket_id": 17465,
            "ticket_number": "3517453",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60463133",
            "priority": "P2",
            "created_at": "09/05/2026 09:03:43",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.48,
            "sla_met": false,
            "sla_breach_hours": 2.48,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:32:52"
          },
          {
            "ticket_id": 17471,
            "ticket_number": "3517459",
            "title": "\"GBN-92788 - A client has submitted a new request\"",
            "priority": "P2",
            "created_at": "09/05/2026 10:03:57",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 10:04:11"
          },
          {
            "ticket_id": 17473,
            "ticket_number": "3517461",
            "title": "Confirmação de reserva. Localizador: 2F925JOSMO",
            "priority": "P2",
            "created_at": "09/05/2026 11:40:06",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:43:28"
          },
          {
            "ticket_id": 17474,
            "ticket_number": "3517462",
            "title": "GBN-123140 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/05/2026 11:40:38",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:11:17"
          },
          {
            "ticket_id": 17475,
            "ticket_number": "3517463",
            "title": "GBN-123140 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/05/2026 11:40:44",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 11:40:44"
          },
          {
            "ticket_id": 17478,
            "ticket_number": "3517466",
            "title": "GBN-123140 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "09/05/2026 11:40:52",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:13:29"
          },
          {
            "ticket_id": 17481,
            "ticket_number": "3517469",
            "title": "GBN-123208 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/05/2026 12:10:43",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:10:43"
          },
          {
            "ticket_id": 17484,
            "ticket_number": "3517472",
            "title": "GBN-123063 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "09/05/2026 12:20:44",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:22:15"
          },
          {
            "ticket_id": 17485,
            "ticket_number": "3517473",
            "title": "GBN-123063 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/05/2026 12:20:47",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:20:47"
          },
          {
            "ticket_id": 17486,
            "ticket_number": "3517474",
            "title": "GBN-123063 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/05/2026 12:20:49",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:22:42"
          },
          {
            "ticket_id": 17493,
            "ticket_number": "3517481",
            "title": "GBN-92436 - Um cliente enviou uma nova solicitação",
            "priority": "P2",
            "created_at": "09/05/2026 15:35:43",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:44:17"
          },
          {
            "ticket_id": 17496,
            "ticket_number": "3517484",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "09/05/2026 15:35:49",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 17:01:49"
          },
          {
            "ticket_id": 17497,
            "ticket_number": "3517485",
            "title": "Cancellation of the booking with locator 24BLL5JP",
            "priority": "P2",
            "created_at": "09/05/2026 15:35:51",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:44:03"
          },
          {
            "ticket_id": 17498,
            "ticket_number": "3517486",
            "title": "Cancellation of the booking with locator 24BLL5JP",
            "priority": "P2",
            "created_at": "09/05/2026 15:35:53",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 15:43:59"
          },
          {
            "ticket_id": 17499,
            "ticket_number": "3517487",
            "title": "Confirmation of booking with locatorDLOL4MBM",
            "priority": "P2",
            "created_at": "09/05/2026 15:36:42",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 17:01:39"
          },
          {
            "ticket_id": 17502,
            "ticket_number": "3517490",
            "title": "w2m.travel: Confirmación reserva 'JMYGPK'",
            "priority": "P2",
            "created_at": "09/05/2026 17:38:24",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 17:56:35"
          },
          {
            "ticket_id": 17594,
            "ticket_number": "3517582",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "11/05/2026 10:52:00",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:42:54"
          },
          {
            "ticket_id": 17624,
            "ticket_number": "3517612",
            "title": "Confirmação de reserva com localizador: 4210935",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:59",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 18:03:18"
          },
          {
            "ticket_id": 17627,
            "ticket_number": "3517615",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "11/05/2026 14:41:00",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 4.65,
            "sla_met": false,
            "sla_breach_hours": 0.65,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:20:37"
          },
          {
            "ticket_id": 17638,
            "ticket_number": "3517626",
            "title": "Réservation confirmée: Vol en montgolfière en Capp",
            "priority": "P2",
            "created_at": "11/05/2026 17:01:53",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:21:47"
          },
          {
            "ticket_id": 17639,
            "ticket_number": "3517627",
            "title": "Reserva confirmada: Excursion au sud de Cappadoce ",
            "priority": "P2",
            "created_at": "11/05/2026 17:01:56",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:21:57"
          },
          {
            "ticket_id": 17640,
            "ticket_number": "3517628",
            "title": "Réservation confirmée: Excursion au sud de Cappado",
            "priority": "P2",
            "created_at": "11/05/2026 17:01:59",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:07"
          },
          {
            "ticket_id": 17641,
            "ticket_number": "3517629",
            "title": "Reserva confirmada: Tour pelo norte da Capadócia -",
            "priority": "P2",
            "created_at": "11/05/2026 17:02:02",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:18"
          },
          {
            "ticket_id": 17642,
            "ticket_number": "3517630",
            "title": "Reserva confirmada: Tour pelo norte da Capadócia -",
            "priority": "P2",
            "created_at": "11/05/2026 17:02:04",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:28"
          },
          {
            "ticket_id": 17644,
            "ticket_number": "3517632",
            "title": "Reserva confirmada: Vol en montgolfière en Cappado",
            "priority": "P2",
            "created_at": "11/05/2026 17:02:13",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:35"
          },
          {
            "ticket_id": 17645,
            "ticket_number": "3517633",
            "title": "Reserva confirmada: Jantar com música e espetáculo",
            "priority": "P2",
            "created_at": "11/05/2026 17:02:16",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:45"
          },
          {
            "ticket_id": 17646,
            "ticket_number": "3517634",
            "title": "Reserva confirmada: Jantar com música e espetáculo",
            "priority": "P2",
            "created_at": "11/05/2026 17:02:18",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:22:57"
          },
          {
            "ticket_id": 17649,
            "ticket_number": "3517637",
            "title": "Fwd: Atualização das operações da Emirates",
            "priority": "P2",
            "created_at": "11/05/2026 17:35:00",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:35:00"
          },
          {
            "ticket_id": 17652,
            "ticket_number": "3517640",
            "title": "Pagamento da reserva – Ref PP158018, Sr. Bruno Tra",
            "priority": "P2",
            "created_at": "11/05/2026 17:47:01",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:24:30"
          },
          {
            "ticket_id": 17653,
            "ticket_number": "3517641",
            "title": "Confirmación de la reserva con localizador: 421149",
            "priority": "P2",
            "created_at": "11/05/2026 17:47:03",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:24:46"
          },
          {
            "ticket_id": 17654,
            "ticket_number": "3517642",
            "title": "GBN-123273 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/05/2026 17:47:05",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:24:57"
          },
          {
            "ticket_id": 17655,
            "ticket_number": "3517643",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/05/2026 17:59:40",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:59:40"
          },
          {
            "ticket_id": 17656,
            "ticket_number": "3517644",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/05/2026 17:59:48",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:59:48"
          },
          {
            "ticket_id": 17657,
            "ticket_number": "3517645",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/05/2026 17:59:56",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:59:56"
          },
          {
            "ticket_id": 17659,
            "ticket_number": "3517647",
            "title": "Confirmação de reserva com localizador: 4211780",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:11",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:25:54"
          },
          {
            "ticket_id": 17660,
            "ticket_number": "3517648",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604632358",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:15",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:48:30"
          },
          {
            "ticket_id": 17661,
            "ticket_number": "3517649",
            "title": "Confirmation of booking with locatorNU5XWTCY",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:17",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:26:33"
          },
          {
            "ticket_id": 17663,
            "ticket_number": "3517651",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:21",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 20:57:00"
          },
          {
            "ticket_id": 17664,
            "ticket_number": "3517652",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:23",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:28:27"
          },
          {
            "ticket_id": 17666,
            "ticket_number": "3517654",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:28",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:17:28"
          },
          {
            "ticket_id": 17667,
            "ticket_number": "3517655",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:35",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:29:11"
          },
          {
            "ticket_id": 17668,
            "ticket_number": "3517656",
            "title": "GBN-108957 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:36",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 22:54:58"
          },
          {
            "ticket_id": 17669,
            "ticket_number": "3517657",
            "title": "GBN-123273 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:39",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:29:33"
          },
          {
            "ticket_id": 17670,
            "ticket_number": "3517658",
            "title": "GBN-108957 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:41",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 22:55:02"
          },
          {
            "ticket_id": 17672,
            "ticket_number": "3517660",
            "title": "GBN-75942 - Um cliente enviou uma nova solicitação",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:45",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:30:06"
          },
          {
            "ticket_id": 17677,
            "ticket_number": "3517665",
            "title": "GBN-115343 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/05/2026 20:57:02",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:51:23"
          },
          {
            "ticket_id": 17678,
            "ticket_number": "3517666",
            "title": "RE: [Cockpit] Plano de Pagamento Ajustado - Viagem",
            "priority": "P2",
            "created_at": "11/05/2026 20:57:04",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 20:57:04"
          },
          {
            "ticket_id": 17680,
            "ticket_number": "3517668",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "11/05/2026 20:57:09",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:51:29"
          },
          {
            "ticket_id": 17683,
            "ticket_number": "3517671",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:33",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:53:27"
          },
          {
            "ticket_id": 17685,
            "ticket_number": "3517673",
            "title": "Informações da reserva TTN-1273926988#101515798#T1",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:37",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:57:05"
          },
          {
            "ticket_id": 17687,
            "ticket_number": "3517675",
            "title": "Reserva cancelada com localizador: 4210935",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:42",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:57:32"
          },
          {
            "ticket_id": 17688,
            "ticket_number": "3517676",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:44",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:57:44"
          },
          {
            "ticket_id": 17691,
            "ticket_number": "3517679",
            "title": "GBN-109015 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:49",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:58:21"
          },
          {
            "ticket_id": 17692,
            "ticket_number": "3517680",
            "title": "GBN-109015 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:51",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:58:27"
          },
          {
            "ticket_id": 17724,
            "ticket_number": "3517712",
            "title": "Confirmação de reserva para For PT004157 72130439",
            "priority": "P2",
            "created_at": "12/05/2026 10:36:37",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 13:20:20"
          },
          {
            "ticket_id": 17726,
            "ticket_number": "3517714",
            "title": "GBN-123291 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "12/05/2026 11:31:07",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 13:20:26"
          },
          {
            "ticket_id": 17727,
            "ticket_number": "3517715",
            "title": "Confirmação de reserva com localizador: 4211494",
            "priority": "P2",
            "created_at": "12/05/2026 11:31:09",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 13:20:49"
          },
          {
            "ticket_id": 17736,
            "ticket_number": "3517724",
            "title": "GBN-123291 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/05/2026 13:19:28",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:12:47"
          },
          {
            "ticket_id": 17796,
            "ticket_number": "3517784",
            "title": "RE: [Cockpit] Viagem TRP-2026-02730 - BAYAHIBE • M",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:06",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:07"
          },
          {
            "ticket_id": 17822,
            "ticket_number": "3517810",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:10",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 20:14:13"
          },
          {
            "ticket_id": 17827,
            "ticket_number": "3517815",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:26",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 20:14:31"
          },
          {
            "ticket_id": 17828,
            "ticket_number": "3517816",
            "title": "GBN-123532 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:29",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:11:41"
          },
          {
            "ticket_id": 17830,
            "ticket_number": "3517818",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:37",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:00:44"
          },
          {
            "ticket_id": 17832,
            "ticket_number": "3517820",
            "title": "GBN-123423 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:44",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:12:14"
          },
          {
            "ticket_id": 17834,
            "ticket_number": "3517822",
            "title": "[Cancelamento Serviço] TRP-2026-04937 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/05/2026 21:28:24",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:28:24"
          },
          {
            "ticket_id": 17838,
            "ticket_number": "3517826",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "12/05/2026 21:52:05",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 22:08:51"
          },
          {
            "ticket_id": 17841,
            "ticket_number": "3517829",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "12/05/2026 22:11:03",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 22:40:04"
          },
          {
            "ticket_id": 17849,
            "ticket_number": "3517837",
            "title": "Cancelação da reserva com localizador 9MEVOKWPHO",
            "priority": "P2",
            "created_at": "12/05/2026 22:53:38",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 22:54:18"
          },
          {
            "ticket_id": 17863,
            "ticket_number": "3517851",
            "title": "Informação de reserva - SPT002601599125",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:24",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:22:08"
          },
          {
            "ticket_id": 17888,
            "ticket_number": "3517876",
            "title": "Confirmação de reserva para For PT004157 72194695",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:21",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 12:38:09"
          },
          {
            "ticket_id": 17909,
            "ticket_number": "3517897",
            "title": "Informação de reserva - SPT002601605188",
            "priority": "P2",
            "created_at": "13/05/2026 13:09:42",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:02:34"
          },
          {
            "ticket_id": 17912,
            "ticket_number": "3517900",
            "title": "Confirmação reserva Bedsonline 491-2083044",
            "priority": "P2",
            "created_at": "13/05/2026 13:49:45",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:42:40"
          },
          {
            "ticket_id": 17954,
            "ticket_number": "3517942",
            "title": "Confirmação reserva Bedsonline 54-3351016",
            "priority": "P2",
            "created_at": "13/05/2026 17:42:52",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 19:01:20"
          },
          {
            "ticket_id": 17960,
            "ticket_number": "3517948",
            "title": "Pagamento da reserva – Ref PP301166, Sr. Pedro Cal",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:07",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 19:02:08"
          },
          {
            "ticket_id": 17962,
            "ticket_number": "3517950",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:13",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 19:02:45"
          },
          {
            "ticket_id": 17964,
            "ticket_number": "3517952",
            "title": "Pagamento da reserva – Ref PP209993, Sr. Pedro Cal",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:17",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 19:03:04"
          },
          {
            "ticket_id": 17966,
            "ticket_number": "3517954",
            "title": "Confirmação de reserva com localizador: 4215719",
            "priority": "P2",
            "created_at": "13/05/2026 20:10:43",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:12:43"
          },
          {
            "ticket_id": 17970,
            "ticket_number": "3517958",
            "title": "Información de reserva número: 1790343",
            "priority": "P2",
            "created_at": "13/05/2026 20:10:53",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:13:57"
          },
          {
            "ticket_id": 17973,
            "ticket_number": "3517961",
            "title": "GBN-123958 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/05/2026 20:11:01",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:11:01"
          },
          {
            "ticket_id": 17978,
            "ticket_number": "3517966",
            "title": "Re: [Cockpit] Viagem TRP-2026-05092 - Joana Silva ",
            "priority": "P2",
            "created_at": "13/05/2026 21:41:55",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 21:41:56"
          },
          {
            "ticket_id": 17983,
            "ticket_number": "3517971",
            "title": "GBN-123973 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/05/2026 22:06:56",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 22:06:57"
          },
          {
            "ticket_id": 17987,
            "ticket_number": "3517975",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 22:36:28",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 22:36:29"
          },
          {
            "ticket_id": 17988,
            "ticket_number": "3517976",
            "title": "Reserva cancelada – Ref PP148217, Sr. ANTÓNIO  COE",
            "priority": "P2",
            "created_at": "13/05/2026 22:36:30",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 13.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:23:59"
          },
          {
            "ticket_id": 18010,
            "ticket_number": "3517998",
            "title": "Informação de reserva - SPT002601630524",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:34",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18080,
            "ticket_number": "3518068",
            "title": "MVU: Cambio Vuelo: 4135517 FAMILIAP 001",
            "priority": "P2",
            "created_at": "14/05/2026 17:01:45",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:24:32"
          },
          {
            "ticket_id": 18083,
            "ticket_number": "3518071",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:17",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:04:58"
          },
          {
            "ticket_id": 18084,
            "ticket_number": "3518072",
            "title": "GBN-107994 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:19",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:04:58"
          },
          {
            "ticket_id": 18087,
            "ticket_number": "3518075",
            "title": "Fwd: Atualização de valores da taxa de combustível",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:26",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:12:27"
          },
          {
            "ticket_id": 18090,
            "ticket_number": "3518078",
            "title": "Re:[## 40992 ##] GBN-104486 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "14/05/2026 17:39:55",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:24:59"
          },
          {
            "ticket_id": 18095,
            "ticket_number": "3518083",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "14/05/2026 18:54:05",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:17:25"
          },
          {
            "ticket_id": 18096,
            "ticket_number": "3518084",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604591308",
            "priority": "P2",
            "created_at": "14/05/2026 18:54:07",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:18:24"
          },
          {
            "ticket_id": 18097,
            "ticket_number": "3518085",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6123918",
            "priority": "P2",
            "created_at": "14/05/2026 18:54:09",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:41:36"
          },
          {
            "ticket_id": 18101,
            "ticket_number": "3518089",
            "title": "GVVY0N – Reserva com segmentos inativos por falta ",
            "priority": "P2",
            "created_at": "14/05/2026 21:36:51",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:18:59"
          },
          {
            "ticket_id": 18102,
            "ticket_number": "3518090",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "14/05/2026 21:36:55",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:36:55"
          },
          {
            "ticket_id": 18104,
            "ticket_number": "3518092",
            "title": "Confirmação reserva Bedsonline 50-3219582",
            "priority": "P2",
            "created_at": "14/05/2026 21:36:59",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:44:26"
          },
          {
            "ticket_id": 18105,
            "ticket_number": "3518093",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "14/05/2026 21:37:02",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:45:00"
          },
          {
            "ticket_id": 18107,
            "ticket_number": "3518095",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 21:37:07",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:37:07"
          },
          {
            "ticket_id": 18108,
            "ticket_number": "3518096",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "14/05/2026 21:37:14",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:46:18"
          },
          {
            "ticket_id": 18110,
            "ticket_number": "3518098",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (X7M",
            "priority": "P2",
            "created_at": "14/05/2026 22:19:27",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:20:17"
          },
          {
            "ticket_id": 18112,
            "ticket_number": "3518100",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (X7M",
            "priority": "P2",
            "created_at": "14/05/2026 22:19:33",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:20:43"
          },
          {
            "ticket_id": 18132,
            "ticket_number": "3518120",
            "title": "GBN-124179 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/05/2026 11:04:43",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 11:04:43"
          },
          {
            "ticket_id": 18164,
            "ticket_number": "3518152",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "Reservas sem Formulário",
            "created_at": "15/05/2026 16:09:20",
            "close_date": "2026-06-01",
            "sla_target_hours": 24,
            "actual_time_hours": 405.88,
            "sla_met": false,
            "sla_breach_hours": 381.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/06/2026 14:03:13"
          },
          {
            "ticket_id": 18183,
            "ticket_number": "3518171",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 17:49:59",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:49:59"
          },
          {
            "ticket_id": 18184,
            "ticket_number": "3518172",
            "title": "GBN-124275 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:30",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:12:13"
          },
          {
            "ticket_id": 18185,
            "ticket_number": "3518173",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:35",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:50:36"
          },
          {
            "ticket_id": 18187,
            "ticket_number": "3518175",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:52",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:50:52"
          },
          {
            "ticket_id": 18189,
            "ticket_number": "3518177",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:59",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:17:13"
          },
          {
            "ticket_id": 18190,
            "ticket_number": "3518178",
            "title": "Confirmation of booking with locatorM2PUGBMR",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:11",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 22:27:38"
          },
          {
            "ticket_id": 18191,
            "ticket_number": "3518179",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:13",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:54:06"
          },
          {
            "ticket_id": 18193,
            "ticket_number": "3518181",
            "title": "GBN-124343 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:19",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:22:19"
          },
          {
            "ticket_id": 18195,
            "ticket_number": "3518183",
            "title": "Pagamento da reserva – Ref PP683825, Sr. FABIO ASC",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:23",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:54:42"
          },
          {
            "ticket_id": 18198,
            "ticket_number": "3518186",
            "title": "GBN-124151 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:29",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 22:29:17"
          },
          {
            "ticket_id": 18199,
            "ticket_number": "3518187",
            "title": "Almoço no dia 10 de junho - Escolha de pratos - Ti",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:31",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:22:32"
          },
          {
            "ticket_id": 18200,
            "ticket_number": "3518188",
            "title": "Reserva confirmada: Free tour por Madrid - Civitat",
            "priority": "P2",
            "created_at": "15/05/2026 19:44:42",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:03:46"
          },
          {
            "ticket_id": 18202,
            "ticket_number": "3518190",
            "title": "Reserva confirmada: Free tour por Madrid - Civitat",
            "priority": "P2",
            "created_at": "15/05/2026 19:44:46",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:04:04"
          },
          {
            "ticket_id": 18203,
            "ticket_number": "3518191",
            "title": "Confirmação de reserva – Ref PP196221, Sra. Rute V",
            "priority": "P2",
            "created_at": "15/05/2026 19:44:48",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 20:04:15"
          },
          {
            "ticket_id": 18209,
            "ticket_number": "3518197",
            "title": "GBN-124376 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/05/2026 22:07:27",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 22:07:27"
          },
          {
            "ticket_id": 18212,
            "ticket_number": "3518200",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "15/05/2026 22:27:32",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 22:33:01"
          },
          {
            "ticket_id": 18247,
            "ticket_number": "3518235",
            "title": "[Suporte] TRP-2026-04714 - Validação Pagamento",
            "priority": "P2",
            "created_at": "17/05/2026 17:04:34",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/05/2026 17:04:34"
          },
          {
            "ticket_id": 18264,
            "ticket_number": "3518252",
            "title": "GBN-124470 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:51",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:19:51"
          },
          {
            "ticket_id": 18265,
            "ticket_number": "3518253",
            "title": "GBN-124483 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:19:55"
          },
          {
            "ticket_id": 18267,
            "ticket_number": "3518255",
            "title": "Confirmação reserva Bedsonline 194-4542290",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:59",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:27:29"
          },
          {
            "ticket_id": 18268,
            "ticket_number": "3518256",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:02",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:27:36"
          },
          {
            "ticket_id": 18269,
            "ticket_number": "3518257",
            "title": "GBN-124485 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:05",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:05"
          },
          {
            "ticket_id": 18270,
            "ticket_number": "3518258",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:07",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:27:59"
          },
          {
            "ticket_id": 18271,
            "ticket_number": "3518259",
            "title": "GBN-124478 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:14",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:14"
          },
          {
            "ticket_id": 18273,
            "ticket_number": "3518261",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:20",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:21"
          },
          {
            "ticket_id": 18274,
            "ticket_number": "3518262",
            "title": "GBN-124451 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:24",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:24"
          },
          {
            "ticket_id": 18276,
            "ticket_number": "3518264",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:31",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:29:55"
          },
          {
            "ticket_id": 18277,
            "ticket_number": "3518265",
            "title": "Número de informação da reserva: 6148037",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:34",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:30:08"
          },
          {
            "ticket_id": 18278,
            "ticket_number": "3518266",
            "title": "Confirmação de reserva. Localizador: 196TZ4L2Z9",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:36",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:30:21"
          },
          {
            "ticket_id": 18286,
            "ticket_number": "3518274",
            "title": "Informação importante sobre a tua reserva 6137918",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:10",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:33:28"
          },
          {
            "ticket_id": 18287,
            "ticket_number": "3518275",
            "title": "Informação importante sobre a tua reserva 6137228",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:12",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:33:33"
          },
          {
            "ticket_id": 18289,
            "ticket_number": "3518277",
            "title": "GBN-124447 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:17",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:21:17"
          },
          {
            "ticket_id": 18291,
            "ticket_number": "3518279",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:35",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:35:34"
          },
          {
            "ticket_id": 18292,
            "ticket_number": "3518280",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:38",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:35:53"
          },
          {
            "ticket_id": 18293,
            "ticket_number": "3518281",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:41",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:36:36"
          },
          {
            "ticket_id": 18295,
            "ticket_number": "3518283",
            "title": "Fwd: easyJet número de referência da reserva: KCN2",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:45",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:21:45"
          },
          {
            "ticket_id": 18296,
            "ticket_number": "3518284",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:49",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:37:29"
          },
          {
            "ticket_id": 18297,
            "ticket_number": "3518285",
            "title": "Confirmacao 345645",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:51",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:37:54"
          },
          {
            "ticket_id": 18300,
            "ticket_number": "3518288",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:59",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:39:51"
          },
          {
            "ticket_id": 18301,
            "ticket_number": "3518289",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:03",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:39:55"
          },
          {
            "ticket_id": 18302,
            "ticket_number": "3518290",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:07",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:01"
          },
          {
            "ticket_id": 18304,
            "ticket_number": "3518292",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:14",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:32"
          },
          {
            "ticket_id": 18305,
            "ticket_number": "3518293",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:18",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:37"
          },
          {
            "ticket_id": 18306,
            "ticket_number": "3518294",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:22",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:42"
          },
          {
            "ticket_id": 18307,
            "ticket_number": "3518295",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:25",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:47"
          },
          {
            "ticket_id": 18308,
            "ticket_number": "3518296",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:29",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:51"
          },
          {
            "ticket_id": 18309,
            "ticket_number": "3518297",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:33",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:40:56"
          },
          {
            "ticket_id": 18310,
            "ticket_number": "3518298",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:38",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:00"
          },
          {
            "ticket_id": 18311,
            "ticket_number": "3518299",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:41",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:04"
          },
          {
            "ticket_id": 18312,
            "ticket_number": "3518300",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:46",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:08"
          },
          {
            "ticket_id": 18313,
            "ticket_number": "3518301",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:49",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:12"
          },
          {
            "ticket_id": 18315,
            "ticket_number": "3518303",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:56",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:35"
          },
          {
            "ticket_id": 18317,
            "ticket_number": "3518305",
            "title": "Confirmation of booking with locatorA1XKW8HA",
            "priority": "P2",
            "created_at": "18/05/2026 09:23:01",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:54"
          },
          {
            "ticket_id": 18318,
            "ticket_number": "3518306",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:23:05",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:41:58"
          },
          {
            "ticket_id": 18319,
            "ticket_number": "3518307",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "18/05/2026 09:23:09",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:42:03"
          },
          {
            "ticket_id": 18326,
            "ticket_number": "3518314",
            "title": "Documentação da reserva TTN-1243122708#102086185#T",
            "priority": "P2",
            "created_at": "18/05/2026 10:12:59",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 19:32:39"
          },
          {
            "ticket_id": 18347,
            "ticket_number": "3518335",
            "title": "Documentação 1269448599 SMY",
            "priority": "P2",
            "created_at": "18/05/2026 11:22:36",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:22:36"
          },
          {
            "ticket_id": 18352,
            "ticket_number": "3518340",
            "title": "GBN-124553 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 12:56:37",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:56:37"
          },
          {
            "ticket_id": 18405,
            "ticket_number": "3518393",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 20:46:26",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 20:46:26"
          },
          {
            "ticket_id": 18406,
            "ticket_number": "3518394",
            "title": "Pagamento da reserva – Ref PP551204, Sra. Ana Rita",
            "priority": "P2",
            "created_at": "18/05/2026 20:46:28",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 21:59:59"
          },
          {
            "ticket_id": 18409,
            "ticket_number": "3518397",
            "title": "Confirmacao 345688",
            "priority": "P2",
            "created_at": "18/05/2026 20:46:35",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 22:08:01"
          },
          {
            "ticket_id": 18413,
            "ticket_number": "3518401",
            "title": "Confirmação de reserva com localizador: 4223037",
            "priority": "P2",
            "created_at": "18/05/2026 21:45:02",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 22:09:09"
          },
          {
            "ticket_id": 18415,
            "ticket_number": "3518403",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "18/05/2026 22:42:09",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 10.28,
            "sla_met": false,
            "sla_breach_hours": 6.28,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 08:59:51"
          },
          {
            "ticket_id": 18416,
            "ticket_number": "3518404",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 22:42:17",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 22:42:17"
          },
          {
            "ticket_id": 18458,
            "ticket_number": "3518446",
            "title": "Informações sobre a sua reserva TTN-1249892858#102",
            "priority": "P2",
            "created_at": "19/05/2026 11:16:55",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 12:09:29"
          },
          {
            "ticket_id": 18482,
            "ticket_number": "3518470",
            "title": "GBN-123765 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "19/05/2026 14:30:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:31:33"
          },
          {
            "ticket_id": 18506,
            "ticket_number": "3518494",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "19/05/2026 17:46:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:08:13"
          },
          {
            "ticket_id": 18511,
            "ticket_number": "3518499",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:18",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:18"
          },
          {
            "ticket_id": 18518,
            "ticket_number": "3518506",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "19/05/2026 18:44:26",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:10:42"
          },
          {
            "ticket_id": 18519,
            "ticket_number": "3518507",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "19/05/2026 18:44:28",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:10:50"
          },
          {
            "ticket_id": 18526,
            "ticket_number": "3518514",
            "title": "Pagamento da reserva – Ref PP116492, Sra. Joana Ma",
            "priority": "P2",
            "created_at": "19/05/2026 19:38:09",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:21:21"
          },
          {
            "ticket_id": 18528,
            "ticket_number": "3518516",
            "title": "Informações da sua reserva TTN-1281949570#10230452",
            "priority": "P2",
            "created_at": "19/05/2026 19:38:15",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 23:05:31"
          },
          {
            "ticket_id": 18529,
            "ticket_number": "3518517",
            "title": "Número de informação da reserva: 6148206",
            "priority": "P2",
            "created_at": "19/05/2026 19:38:19",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:21:53"
          },
          {
            "ticket_id": 18532,
            "ticket_number": "3518520",
            "title": "GBN-124875 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/05/2026 19:47:23",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:47:23"
          },
          {
            "ticket_id": 18533,
            "ticket_number": "3518521",
            "title": "Número de informação da reserva: 6148210",
            "priority": "P2",
            "created_at": "19/05/2026 19:47:26",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:22:47"
          },
          {
            "ticket_id": 18537,
            "ticket_number": "3518525",
            "title": "GBN-124879 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:12",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:12"
          },
          {
            "ticket_id": 18622,
            "ticket_number": "3518610",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 15:57:20",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:57:20"
          },
          {
            "ticket_id": 18632,
            "ticket_number": "3518620",
            "title": "GBN-124553 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/05/2026 17:05:03",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:05:46"
          },
          {
            "ticket_id": 18633,
            "ticket_number": "3518621",
            "title": "GBN-123532 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/05/2026 17:05:05",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:06:42"
          },
          {
            "ticket_id": 18637,
            "ticket_number": "3518625",
            "title": "GBN-123765 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "20/05/2026 17:18:03",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:18:18"
          },
          {
            "ticket_id": 18639,
            "ticket_number": "3518627",
            "title": "Pagamento da reserva – Ref PP140796, Sr. Rui Danie",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:38",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:25:38"
          },
          {
            "ticket_id": 18641,
            "ticket_number": "3518629",
            "title": "Confirmação de reserva com localizador: 4226766",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:42",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:56:30"
          },
          {
            "ticket_id": 18642,
            "ticket_number": "3518630",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:45",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:26:45"
          },
          {
            "ticket_id": 18654,
            "ticket_number": "3518642",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:47",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:59:01"
          },
          {
            "ticket_id": 18658,
            "ticket_number": "3518646",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:59",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:30:41"
          },
          {
            "ticket_id": 18661,
            "ticket_number": "3518649",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 18:25:48",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:30:48"
          },
          {
            "ticket_id": 18662,
            "ticket_number": "3518650",
            "title": "VJT: Documentação de Viagem  213950 (Voo Regular)",
            "priority": "P2",
            "created_at": "20/05/2026 18:25:51",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:56:10"
          },
          {
            "ticket_id": 18663,
            "ticket_number": "3518651",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "20/05/2026 19:16:24",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:23:12"
          },
          {
            "ticket_id": 18664,
            "ticket_number": "3518652",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "20/05/2026 19:16:26",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:23:19"
          },
          {
            "ticket_id": 18665,
            "ticket_number": "3518653",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 19:16:28",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:31:07"
          },
          {
            "ticket_id": 18667,
            "ticket_number": "3518655",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 19:16:36",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:30:57"
          },
          {
            "ticket_id": 18670,
            "ticket_number": "3518658",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604638147",
            "priority": "P2",
            "created_at": "20/05/2026 20:15:04",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:24:07"
          },
          {
            "ticket_id": 18674,
            "ticket_number": "3518662",
            "title": "GBN-124874 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/05/2026 20:19:10",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:21:22"
          },
          {
            "ticket_id": 18675,
            "ticket_number": "3518663",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 21:23:15",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:23:47"
          },
          {
            "ticket_id": 18676,
            "ticket_number": "3518664",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 21:23:17",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:23:41"
          },
          {
            "ticket_id": 18677,
            "ticket_number": "3518665",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 21:35:47",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:39:16"
          },
          {
            "ticket_id": 18678,
            "ticket_number": "3518666",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 21:35:50",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:57:12"
          },
          {
            "ticket_id": 18681,
            "ticket_number": "3518669",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 22:29:54",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 22:54:54"
          },
          {
            "ticket_id": 18685,
            "ticket_number": "3518673",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 22:59:55",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 23:00:19"
          },
          {
            "ticket_id": 18731,
            "ticket_number": "3518719",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "21/05/2026 13:12:02",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:20:42"
          },
          {
            "ticket_id": 18732,
            "ticket_number": "3518720",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604638533",
            "priority": "P2",
            "created_at": "21/05/2026 13:12:04",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:16:16"
          },
          {
            "ticket_id": 18734,
            "ticket_number": "3518722",
            "title": "Reserva Aérea XQ5VSI",
            "priority": "Reservas sem Formulário",
            "created_at": "21/05/2026 13:12:09",
            "close_date": "2026-05-25",
            "sla_target_hours": 24,
            "actual_time_hours": 100.02,
            "sla_met": false,
            "sla_breach_hours": 76.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/05/2026 17:13:43"
          },
          {
            "ticket_id": 18737,
            "ticket_number": "3518725",
            "title": "Reserva confirmada: Barco a Formentera saindo de I",
            "priority": "P2",
            "created_at": "21/05/2026 13:12:41",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:16:02"
          },
          {
            "ticket_id": 18739,
            "ticket_number": "3518727",
            "title": "GBN-124275 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "21/05/2026 13:19:08",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:19:49"
          },
          {
            "ticket_id": 18740,
            "ticket_number": "3518728",
            "title": "Reserva confirmada: Barco a Formentera saindo de I",
            "priority": "P2",
            "created_at": "21/05/2026 13:57:11",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:16:05"
          },
          {
            "ticket_id": 18743,
            "ticket_number": "3518731",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604597980",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:23",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:38:19"
          },
          {
            "ticket_id": 18747,
            "ticket_number": "3518735",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604597980",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:32",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:37:21"
          },
          {
            "ticket_id": 18757,
            "ticket_number": "3518745",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:43",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 5.45,
            "sla_met": false,
            "sla_breach_hours": 1.45,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:46:36"
          },
          {
            "ticket_id": 18778,
            "ticket_number": "3518766",
            "title": "Confirmacao 345820",
            "priority": "P2",
            "created_at": "21/05/2026 17:07:18",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:00:07"
          },
          {
            "ticket_id": 18798,
            "ticket_number": "3518786",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "21/05/2026 18:16:59",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:51:28"
          },
          {
            "ticket_id": 18800,
            "ticket_number": "3518788",
            "title": "Soltour: Cancelamento de reserva: SPT002601632901",
            "priority": "P2",
            "created_at": "21/05/2026 18:17:04",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:59:37"
          },
          {
            "ticket_id": 18807,
            "ticket_number": "3518795",
            "title": "Cancelação da reserva com localizador 8J0HZGDSD8",
            "priority": "P2",
            "created_at": "21/05/2026 19:00:57",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 20:00:00"
          },
          {
            "ticket_id": 18811,
            "ticket_number": "3518799",
            "title": "w2m.travel: Confirmación reserva 'K5D66J'",
            "priority": "P2",
            "created_at": "21/05/2026 19:55:46",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:47:19"
          },
          {
            "ticket_id": 18818,
            "ticket_number": "3518806",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "21/05/2026 21:44:58",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:47:57"
          },
          {
            "ticket_id": 18819,
            "ticket_number": "3518807",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "21/05/2026 21:45:01",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:48:01"
          },
          {
            "ticket_id": 18821,
            "ticket_number": "3518809",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "21/05/2026 21:45:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:49:34"
          },
          {
            "ticket_id": 18824,
            "ticket_number": "3518812",
            "title": "GBN-122230 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "21/05/2026 21:54:29",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 22:38:21"
          },
          {
            "ticket_id": 18830,
            "ticket_number": "3518818",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "21/05/2026 22:53:31",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 22:55:21"
          },
          {
            "ticket_id": 18831,
            "ticket_number": "3518819",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "21/05/2026 22:53:33",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 22:54:50"
          },
          {
            "ticket_id": 18832,
            "ticket_number": "3518820",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "21/05/2026 22:53:36",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 22:55:10"
          },
          {
            "ticket_id": 18844,
            "ticket_number": "3518832",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:55",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:01:22"
          },
          {
            "ticket_id": 18847,
            "ticket_number": "3518835",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "22/05/2026 09:08:02",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:42:56"
          },
          {
            "ticket_id": 18861,
            "ticket_number": "3518849",
            "title": "GBN-124957 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "22/05/2026 10:34:01",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:34:27"
          },
          {
            "ticket_id": 18862,
            "ticket_number": "3518850",
            "title": "Informação de reserva - SPT002601634591",
            "priority": "P2",
            "created_at": "22/05/2026 10:34:05",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:43:09"
          },
          {
            "ticket_id": 18864,
            "ticket_number": "3518852",
            "title": "GBN-113980 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/05/2026 10:34:21",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:36:55"
          },
          {
            "ticket_id": 18871,
            "ticket_number": "3518859",
            "title": "Confirmação de reserva – Ref PP569220, Sr. Bruno F",
            "priority": "P2",
            "created_at": "22/05/2026 12:22:15",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:43:31"
          },
          {
            "ticket_id": 18876,
            "ticket_number": "3518864",
            "title": "GBN-108909 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/05/2026 12:27:17",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 12:27:30"
          },
          {
            "ticket_id": 18880,
            "ticket_number": "3518868",
            "title": "Parceria Rock in Rio | Agências de Viagens AIRMET ",
            "priority": "P2",
            "created_at": "22/05/2026 12:55:55",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:08:22"
          },
          {
            "ticket_id": 18883,
            "ticket_number": "3518871",
            "title": "Confirmação de reserva com localizador: 4230302",
            "priority": "P2",
            "created_at": "22/05/2026 13:03:24",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:47:51"
          },
          {
            "ticket_id": 18894,
            "ticket_number": "3518882",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60463817",
            "priority": "P2",
            "created_at": "22/05/2026 15:32:50",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:33:07"
          },
          {
            "ticket_id": 18916,
            "ticket_number": "3518904",
            "title": "Fwd: ***UPDATE***Procedimentos devido às condições",
            "priority": "P2",
            "created_at": "22/05/2026 16:57:55",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:57:55"
          },
          {
            "ticket_id": 18918,
            "ticket_number": "3518906",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "22/05/2026 18:16:50",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 18:17:54"
          },
          {
            "ticket_id": 18920,
            "ticket_number": "3518908",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 18:17:00",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 18:17:00"
          },
          {
            "ticket_id": 18935,
            "ticket_number": "3518923",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:34",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:51"
          },
          {
            "ticket_id": 18938,
            "ticket_number": "3518926",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:41",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:40"
          },
          {
            "ticket_id": 18940,
            "ticket_number": "3518928",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:45",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:44"
          },
          {
            "ticket_id": 18941,
            "ticket_number": "3518929",
            "title": "Reserva cancelada com localizador: 4178942",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:47",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:00"
          },
          {
            "ticket_id": 18942,
            "ticket_number": "3518930",
            "title": "LUISA / CARVALHO FURTADO CARDOSO 30JUL2026 RAI LIS",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:52",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:09"
          },
          {
            "ticket_id": 18945,
            "ticket_number": "3518933",
            "title": "MELANIE SOFIA / FURTADO CARDOSO 30JUL2026 RAI LIS",
            "priority": "P2",
            "created_at": "23/05/2026 09:07:01",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:41:15"
          },
          {
            "ticket_id": 18946,
            "ticket_number": "3518934",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "23/05/2026 09:38:42",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:57:46"
          },
          {
            "ticket_id": 18949,
            "ticket_number": "3518937",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "23/05/2026 12:07:06",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 16:14:57"
          },
          {
            "ticket_id": 18954,
            "ticket_number": "3518942",
            "title": "GBN-116163 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/05/2026 13:31:00",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 13:35:11"
          },
          {
            "ticket_id": 18957,
            "ticket_number": "3518945",
            "title": "Fwd: Atualização – Condições meteorológicas Açores",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:03",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 15:12:04"
          },
          {
            "ticket_id": 18958,
            "ticket_number": "3518946",
            "title": "Fwd: Atualização – Condições meteorológicas Açores",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:06",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 15:12:06"
          },
          {
            "ticket_id": 18961,
            "ticket_number": "3518949",
            "title": "GBN-125490 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:12",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 15:12:12"
          },
          {
            "ticket_id": 18962,
            "ticket_number": "3518950",
            "title": "GBN-125489 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:15",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 15:12:15"
          },
          {
            "ticket_id": 18964,
            "ticket_number": "3518952",
            "title": "SmartParking - Envio de documento",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:26",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 44.1,
            "sla_met": false,
            "sla_breach_hours": 40.1,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:18:51"
          },
          {
            "ticket_id": 18965,
            "ticket_number": "3518953",
            "title": "Reserva cancelada com localizador: 4225257",
            "priority": "P2",
            "created_at": "23/05/2026 16:10:37",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:33:54"
          },
          {
            "ticket_id": 18966,
            "ticket_number": "3518954",
            "title": "Número de informação da reserva: 6148481",
            "priority": "P2",
            "created_at": "23/05/2026 17:34:51",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:52:37"
          },
          {
            "ticket_id": 18967,
            "ticket_number": "3518955",
            "title": "Confirmação de reserva com localizador: 4231799",
            "priority": "P2",
            "created_at": "23/05/2026 17:34:53",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:56:08"
          },
          {
            "ticket_id": 18968,
            "ticket_number": "3518956",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "23/05/2026 17:34:55",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:40:57"
          },
          {
            "ticket_id": 18970,
            "ticket_number": "3518958",
            "title": "Pedido de cotação para férias",
            "priority": "P2",
            "created_at": "23/05/2026 17:34:58",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 39.62,
            "sla_met": false,
            "sla_breach_hours": 35.62,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:12:24"
          },
          {
            "ticket_id": 18972,
            "ticket_number": "3518960",
            "title": "GBN-109055 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "23/05/2026 17:52:23",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:53:44"
          },
          {
            "ticket_id": 18973,
            "ticket_number": "3518961",
            "title": "Número de informação da reserva: 6148483",
            "priority": "P2",
            "created_at": "23/05/2026 17:52:26",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 39.33,
            "sla_met": false,
            "sla_breach_hours": 35.33,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:13:00"
          },
          {
            "ticket_id": 18974,
            "ticket_number": "3518962",
            "title": "Número de informação da reserva: 6148484",
            "priority": "P2",
            "created_at": "23/05/2026 18:07:54",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 39.08,
            "sla_met": false,
            "sla_breach_hours": 35.08,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:13:11"
          },
          {
            "ticket_id": 18975,
            "ticket_number": "3518963",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "23/05/2026 18:07:56",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 18:08:14"
          },
          {
            "ticket_id": 18981,
            "ticket_number": "3518969",
            "title": "RE: Comp pagamento 6137228",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:04",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:16:06"
          },
          {
            "ticket_id": 18983,
            "ticket_number": "3518971",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:08",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:17:52"
          },
          {
            "ticket_id": 18993,
            "ticket_number": "3518981",
            "title": "Reserva confirmada: Excursão a Ksar Ghilane e Matm",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:37",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:31:22"
          },
          {
            "ticket_id": 18997,
            "ticket_number": "3518985",
            "title": "Reserva confirmada: Passeio de barco pirata por Fl",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:46",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:31:58"
          },
          {
            "ticket_id": 18998,
            "ticket_number": "3518986",
            "title": "Número de informação da reserva: 6148503",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:50",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:32:10"
          },
          {
            "ticket_id": 18999,
            "ticket_number": "3518987",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:02",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:32:25"
          },
          {
            "ticket_id": 19001,
            "ticket_number": "3518989",
            "title": "Número de informação da reserva: 6148501",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:08",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:32:38"
          },
          {
            "ticket_id": 19003,
            "ticket_number": "3518991",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:13",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:33:03"
          },
          {
            "ticket_id": 19004,
            "ticket_number": "3518992",
            "title": "Confirmação de reserva com localizador: 4232314",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:16",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:33:18"
          },
          {
            "ticket_id": 19006,
            "ticket_number": "3518994",
            "title": "Informação de reserva - SPT002601635366",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:24",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:34:06"
          },
          {
            "ticket_id": 19007,
            "ticket_number": "3518995",
            "title": "Confirmação de reserva para For PT004157 71972459",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:26",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:34:26"
          },
          {
            "ticket_id": 19008,
            "ticket_number": "3518996",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:28",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:34:39"
          },
          {
            "ticket_id": 19009,
            "ticket_number": "3518997",
            "title": "Detalhes do seu próximo voo",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:31",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:52:07"
          },
          {
            "ticket_id": 19010,
            "ticket_number": "3518998",
            "title": "Confirmação de reserva para For PT004157 71972459",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:33",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:34:58"
          },
          {
            "ticket_id": 19011,
            "ticket_number": "3518999",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:36",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:35:12"
          },
          {
            "ticket_id": 19013,
            "ticket_number": "3519001",
            "title": "Confirmação de reserva para For PT004157 71972459",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:42",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:35:37"
          },
          {
            "ticket_id": 19015,
            "ticket_number": "3519003",
            "title": "GBN-125525 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 09:04:51",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:04:52"
          },
          {
            "ticket_id": 19016,
            "ticket_number": "3519004",
            "title": "Informação importante sobre a tua reserva 6146607",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:05",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:35:54"
          },
          {
            "ticket_id": 19019,
            "ticket_number": "3519007",
            "title": "REMINDER: Dados de Passaporte - nosso File 431638",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:11",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:37:52"
          },
          {
            "ticket_id": 19022,
            "ticket_number": "3519010",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:21",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:05:21"
          },
          {
            "ticket_id": 19023,
            "ticket_number": "3519011",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:26",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:38:52"
          },
          {
            "ticket_id": 19024,
            "ticket_number": "3519012",
            "title": "A reserva A38385142 foi paga e confirmada",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:28",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:39:03"
          },
          {
            "ticket_id": 19025,
            "ticket_number": "3519013",
            "title": "GBN-125515 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:05:34"
          },
          {
            "ticket_id": 19027,
            "ticket_number": "3519015",
            "title": "Reserva confirmada: Tour de buggy por São Miguel -",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:41",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:39:35"
          },
          {
            "ticket_id": 19028,
            "ticket_number": "3519016",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:45",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:39:54"
          },
          {
            "ticket_id": 19029,
            "ticket_number": "3519017",
            "title": "Reserva confirmada: Tour de buggy por São Miguel -",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:48",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:40:07"
          },
          {
            "ticket_id": 19031,
            "ticket_number": "3519019",
            "title": "Informação importante sobre a tua reserva 6132660",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:53",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:40:42"
          },
          {
            "ticket_id": 19032,
            "ticket_number": "3519020",
            "title": "Informação importante sobre a tua reserva 6142202",
            "priority": "P2",
            "created_at": "25/05/2026 09:51:13",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:52:12"
          },
          {
            "ticket_id": 19033,
            "ticket_number": "3519021",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "25/05/2026 09:51:14",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:52:29"
          },
          {
            "ticket_id": 19044,
            "ticket_number": "3519032",
            "title": "GBN-125539 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/05/2026 11:10:24",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:12:57"
          },
          {
            "ticket_id": 19045,
            "ticket_number": "3519033",
            "title": "GBN-125539 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "25/05/2026 11:10:26",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:13:03"
          },
          {
            "ticket_id": 19047,
            "ticket_number": "3519035",
            "title": "Informação de reserva - SPT002601634591",
            "priority": "P2",
            "created_at": "25/05/2026 11:10:32",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:16:56"
          },
          {
            "ticket_id": 19048,
            "ticket_number": "3519036",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "25/05/2026 11:10:35",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:17:13"
          },
          {
            "ticket_id": 19050,
            "ticket_number": "3519038",
            "title": "Confirmação de reserva – Ref PP106675, Sr. Marco A",
            "priority": "P2",
            "created_at": "25/05/2026 11:19:01",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 8.22,
            "sla_met": false,
            "sla_breach_hours": 4.22,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 19:32:59"
          },
          {
            "ticket_id": 19051,
            "ticket_number": "3519039",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "25/05/2026 11:21:31",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:28:19"
          },
          {
            "ticket_id": 19052,
            "ticket_number": "3519040",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "25/05/2026 11:21:32",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:28:31"
          },
          {
            "ticket_id": 19053,
            "ticket_number": "3519041",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "25/05/2026 11:21:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:28:23"
          },
          {
            "ticket_id": 19058,
            "ticket_number": "3519046",
            "title": "Documentação Disponível - Reserva 336122",
            "priority": "P2",
            "created_at": "25/05/2026 12:20:47",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 12:25:01"
          },
          {
            "ticket_id": 19059,
            "ticket_number": "3519047",
            "title": "Criação de processo File 442135/26",
            "priority": "P2",
            "created_at": "25/05/2026 12:20:53",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 4.58,
            "sla_met": false,
            "sla_breach_hours": 0.58,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:56:28"
          },
          {
            "ticket_id": 19066,
            "ticket_number": "3519054",
            "title": "Solole. Booking DPFYBSMG is close to entering expe",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:09",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:56:15"
          },
          {
            "ticket_id": 19074,
            "ticket_number": "3519062",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:33",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:28:17"
          },
          {
            "ticket_id": 19076,
            "ticket_number": "3519064",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:40",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:47:34"
          },
          {
            "ticket_id": 19080,
            "ticket_number": "3519068",
            "title": "Confirmação de Reserva * File 442135 - EMISSÃO HOJ",
            "priority": "P1",
            "created_at": "25/05/2026 14:44:56",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 14:44:56"
          },
          {
            "ticket_id": 19082,
            "ticket_number": "3519070",
            "title": "GBN-121759 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "25/05/2026 14:45:01",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:24:59"
          },
          {
            "ticket_id": 19083,
            "ticket_number": "3519071",
            "title": "Código de acceso para la intranet",
            "priority": "P2",
            "created_at": "25/05/2026 14:45:11",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:23:34"
          },
          {
            "ticket_id": 19084,
            "ticket_number": "3519072",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "25/05/2026 14:45:15",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:55:09"
          },
          {
            "ticket_id": 19085,
            "ticket_number": "3519073",
            "title": "Notificação de autorização File 440322/26",
            "priority": "P2",
            "created_at": "25/05/2026 14:45:19",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:03:49"
          },
          {
            "ticket_id": 19086,
            "ticket_number": "3519074",
            "title": "GBN-125615 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 14:55:45",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 14:55:45"
          },
          {
            "ticket_id": 19087,
            "ticket_number": "3519075",
            "title": "GBN-  125615   - Um cliente enviou uma nova solici",
            "priority": "P2",
            "created_at": "25/05/2026 14:55:47",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:23:55"
          },
          {
            "ticket_id": 19088,
            "ticket_number": "3519076",
            "title": "GBN-125615 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/05/2026 14:55:49",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:26:09"
          },
          {
            "ticket_id": 19089,
            "ticket_number": "3519077",
            "title": "GBN-125577 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "25/05/2026 15:04:22",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:25:41"
          },
          {
            "ticket_id": 19090,
            "ticket_number": "3519078",
            "title": "GBN-125577 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/05/2026 15:04:30",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:33:04"
          },
          {
            "ticket_id": 19091,
            "ticket_number": "3519079",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "25/05/2026 15:04:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:01:10"
          },
          {
            "ticket_id": 19092,
            "ticket_number": "3519080",
            "title": "Re: [Cockpit] Viagem TRP-2026-05250 - Ilha do Sal ",
            "priority": "P2",
            "created_at": "25/05/2026 15:04:38",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:04:38"
          },
          {
            "ticket_id": 19093,
            "ticket_number": "3519081",
            "title": "GBN-125577 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 15:04:48",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:04:48"
          },
          {
            "ticket_id": 19098,
            "ticket_number": "3519086",
            "title": "Envio de documentos | Fatura-Recibo TA/2537 | 25-0",
            "priority": "P2",
            "created_at": "25/05/2026 15:38:52",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:05:09"
          },
          {
            "ticket_id": 19101,
            "ticket_number": "3519089",
            "title": "Reserva Aérea ZTEP3U",
            "priority": "P2",
            "created_at": "25/05/2026 15:43:24",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:25:03"
          },
          {
            "ticket_id": 19117,
            "ticket_number": "3519105",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 16:49:29",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:49:29"
          },
          {
            "ticket_id": 19119,
            "ticket_number": "3519107",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 16:49:39",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:49:39"
          },
          {
            "ticket_id": 19121,
            "ticket_number": "3519109",
            "title": "Envio de Fatura 216429",
            "priority": "P2",
            "created_at": "25/05/2026 17:05:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:28:07"
          },
          {
            "ticket_id": 19122,
            "ticket_number": "3519110",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 17:05:37",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:05:37"
          },
          {
            "ticket_id": 19123,
            "ticket_number": "3519111",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 17:17:33",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:17:33"
          },
          {
            "ticket_id": 19124,
            "ticket_number": "3519112",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 17:17:38",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:17:38"
          },
          {
            "ticket_id": 19125,
            "ticket_number": "3519113",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "25/05/2026 17:17:42",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:17:42"
          },
          {
            "ticket_id": 19126,
            "ticket_number": "3519114",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "25/05/2026 17:37:35",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:39:01"
          },
          {
            "ticket_id": 19128,
            "ticket_number": "3519116",
            "title": "Re: [Cockpit] Viagem TRP-2026-02579 - NRT • Bruno ",
            "priority": "P2",
            "created_at": "25/05/2026 18:09:43",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:09:43"
          },
          {
            "ticket_id": 19131,
            "ticket_number": "3519119",
            "title": "Reminder * Reserva File 442135 * Deadline Hoje 16h",
            "priority": "P2",
            "created_at": "25/05/2026 18:09:49",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:15:49"
          },
          {
            "ticket_id": 19133,
            "ticket_number": "3519121",
            "title": "Re:[## 41770 ##] GBN-121759 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "25/05/2026 18:14:15",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:14:15"
          },
          {
            "ticket_id": 19138,
            "ticket_number": "3519126",
            "title": "Criação de processo File 442209/26",
            "priority": "P2",
            "created_at": "25/05/2026 19:43:07",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 13.67,
            "sla_met": false,
            "sla_breach_hours": 9.67,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:23:28"
          },
          {
            "ticket_id": 19139,
            "ticket_number": "3519127",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "25/05/2026 19:43:11",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 19:44:11"
          },
          {
            "ticket_id": 19140,
            "ticket_number": "3519128",
            "title": "GBN-125714 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 19:46:03",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 19:46:03"
          },
          {
            "ticket_id": 19145,
            "ticket_number": "3519133",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "25/05/2026 20:32:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 12.88,
            "sla_met": false,
            "sla_breach_hours": 8.88,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:25:50"
          },
          {
            "ticket_id": 19146,
            "ticket_number": "3519134",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "25/05/2026 20:32:40",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 12.88,
            "sla_met": false,
            "sla_breach_hours": 8.88,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:25:54"
          },
          {
            "ticket_id": 19147,
            "ticket_number": "3519135",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "25/05/2026 20:32:43",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 12.88,
            "sla_met": false,
            "sla_breach_hours": 8.88,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:25:58"
          },
          {
            "ticket_id": 19151,
            "ticket_number": "3519139",
            "title": "[Cancelamento Serviço] TRP-2026-05255 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/05/2026 22:27:16",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 22:27:16"
          },
          {
            "ticket_id": 19154,
            "ticket_number": "3519142",
            "title": "Número de informação da reserva: 6148580",
            "priority": "P2",
            "created_at": "25/05/2026 22:55:32",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 10.62,
            "sla_met": false,
            "sla_breach_hours": 6.62,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:32:46"
          },
          {
            "ticket_id": 19155,
            "ticket_number": "3519143",
            "title": "Confirmation of booking with locatorQ7MG4Z5J",
            "priority": "P2",
            "created_at": "25/05/2026 22:55:34",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 10.62,
            "sla_met": false,
            "sla_breach_hours": 6.62,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:33:02"
          },
          {
            "ticket_id": 19157,
            "ticket_number": "3519145",
            "title": "GBN-125731 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "25/05/2026 22:55:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 22:55:41"
          },
          {
            "ticket_id": 19166,
            "ticket_number": "3519154",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:14",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:37:53"
          },
          {
            "ticket_id": 19169,
            "ticket_number": "3519157",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:21",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:39:37"
          },
          {
            "ticket_id": 19170,
            "ticket_number": "3519158",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:23",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:40:17"
          },
          {
            "ticket_id": 19173,
            "ticket_number": "3519161",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:30",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:43:10"
          },
          {
            "ticket_id": 19175,
            "ticket_number": "3519163",
            "title": "Eticket - 67528547 - MR  16/06/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:38",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:44:07"
          },
          {
            "ticket_id": 19176,
            "ticket_number": "3519164",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:44:43"
          },
          {
            "ticket_id": 19177,
            "ticket_number": "3519165",
            "title": "Eticket - 67529346 - MR  16/06/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:46",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:45:22"
          },
          {
            "ticket_id": 19181,
            "ticket_number": "3519169",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604640694",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:56",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:46:12"
          },
          {
            "ticket_id": 19182,
            "ticket_number": "3519170",
            "title": "KOALA TRAVEL LAB ***** MALDIVAS // ECOBOO HOTEL **",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:20",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:25:07"
          },
          {
            "ticket_id": 19184,
            "ticket_number": "3519172",
            "title": "Envio de Documentação Disney File 414491",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:26:17"
          },
          {
            "ticket_id": 19185,
            "ticket_number": "3519173",
            "title": "Reserva pendente à espera de emiss��o",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:35",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:16:26"
          },
          {
            "ticket_id": 19186,
            "ticket_number": "3519174",
            "title": "Informação importante sobre a tua reserva 6142145",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:26:34"
          },
          {
            "ticket_id": 19189,
            "ticket_number": "3519177",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 10:22:52",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:27:02"
          },
          {
            "ticket_id": 19195,
            "ticket_number": "3519183",
            "title": "VOUCHER DA RESERVA 604490259",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:06",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:45:31"
          },
          {
            "ticket_id": 19198,
            "ticket_number": "3519186",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:13",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:48:40"
          },
          {
            "ticket_id": 19202,
            "ticket_number": "3519190",
            "title": "Confirmação de reserva com localizador: 4234868",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:27",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:49:20"
          },
          {
            "ticket_id": 19205,
            "ticket_number": "3519193",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:45:35"
          },
          {
            "ticket_id": 19208,
            "ticket_number": "3519196",
            "title": "Confirmación del Loc 9137767",
            "priority": "P2",
            "created_at": "26/05/2026 11:33:10",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:49:54"
          },
          {
            "ticket_id": 19212,
            "ticket_number": "3519200",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 11:55:06",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:16:34"
          },
          {
            "ticket_id": 19213,
            "ticket_number": "3519201",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 11:55:14",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:55:14"
          },
          {
            "ticket_id": 19214,
            "ticket_number": "3519202",
            "title": "GBN-125775 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 11:55:21",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:55:21"
          },
          {
            "ticket_id": 19220,
            "ticket_number": "3519208",
            "title": "Confirmación de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 12:18:40",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:04:15"
          },
          {
            "ticket_id": 19228,
            "ticket_number": "3519216",
            "title": "GBN-125798 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 12:51:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:51:51"
          },
          {
            "ticket_id": 19229,
            "ticket_number": "3519217",
            "title": "Confirmação de reserva com localizador: 4235229",
            "priority": "P2",
            "created_at": "26/05/2026 12:51:54",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:59:13"
          },
          {
            "ticket_id": 19231,
            "ticket_number": "3519219",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:35",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:29:35"
          },
          {
            "ticket_id": 19232,
            "ticket_number": "3519220",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:38",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:29:39"
          },
          {
            "ticket_id": 19233,
            "ticket_number": "3519221",
            "title": "GBN-125814 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:42",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:29:42"
          },
          {
            "ticket_id": 19234,
            "ticket_number": "3519222",
            "title": "O site da sua agência com 9 operadores com + 4.000",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:46",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:52:36"
          },
          {
            "ticket_id": 19236,
            "ticket_number": "3519224",
            "title": "Solole. Booking DPFYBSMG is close to entering expe",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:35:19"
          },
          {
            "ticket_id": 19237,
            "ticket_number": "3519225",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:55",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:29:55"
          },
          {
            "ticket_id": 19239,
            "ticket_number": "3519227",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:05",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:05"
          },
          {
            "ticket_id": 19240,
            "ticket_number": "3519228",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:10",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:30:44"
          },
          {
            "ticket_id": 19241,
            "ticket_number": "3519229",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:13",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:13"
          },
          {
            "ticket_id": 19242,
            "ticket_number": "3519230",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:16",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:17"
          },
          {
            "ticket_id": 19243,
            "ticket_number": "3519231",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:19",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:20"
          },
          {
            "ticket_id": 19244,
            "ticket_number": "3519232",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:23",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:23"
          },
          {
            "ticket_id": 19245,
            "ticket_number": "3519233",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:27",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:27"
          },
          {
            "ticket_id": 19246,
            "ticket_number": "3519234",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:30",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:30"
          },
          {
            "ticket_id": 19248,
            "ticket_number": "3519236",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:23:56"
          },
          {
            "ticket_id": 19249,
            "ticket_number": "3519237",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:40",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:40"
          },
          {
            "ticket_id": 19250,
            "ticket_number": "3519238",
            "title": "📷🐭 Opções Mágicas na Disneyland Paris: adicione-as",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:43",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:37:44"
          },
          {
            "ticket_id": 19251,
            "ticket_number": "3519239",
            "title": "📷🐭 Opções Mágicas na Disneyland Paris: adicione-as",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:45",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:37:49"
          },
          {
            "ticket_id": 19252,
            "ticket_number": "3519240",
            "title": "Confirmation of booking with locatorUOACCJ5I",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:47",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:52:02"
          },
          {
            "ticket_id": 19253,
            "ticket_number": "3519241",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:50",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:52:22"
          },
          {
            "ticket_id": 19254,
            "ticket_number": "3519242",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:53",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:53"
          },
          {
            "ticket_id": 19255,
            "ticket_number": "3519243",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:57",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:30:57"
          },
          {
            "ticket_id": 19256,
            "ticket_number": "3519244",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:59",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:31:11"
          },
          {
            "ticket_id": 19257,
            "ticket_number": "3519245",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:31:03",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:31:03"
          },
          {
            "ticket_id": 19261,
            "ticket_number": "3519249",
            "title": "Confirmation of booking with locatorRICJ8HVN",
            "priority": "P2",
            "created_at": "26/05/2026 14:32:07",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:30:59"
          },
          {
            "ticket_id": 19264,
            "ticket_number": "3519252",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 14:51:53",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:51:53"
          },
          {
            "ticket_id": 19265,
            "ticket_number": "3519253",
            "title": "GBN-125816 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 14:51:59",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:51:59"
          },
          {
            "ticket_id": 19267,
            "ticket_number": "3519255",
            "title": "Revisión Expediente - posible adelanto fecha límit",
            "priority": "P2",
            "created_at": "26/05/2026 14:52:04",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:57:09"
          },
          {
            "ticket_id": 19268,
            "ticket_number": "3519256",
            "title": "Cancelamento da reserva",
            "priority": "P2",
            "created_at": "26/05/2026 14:52:06",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:44:43"
          },
          {
            "ticket_id": 19271,
            "ticket_number": "3519259",
            "title": "Documentação Disponível - Reserva 345763",
            "priority": "P2",
            "created_at": "26/05/2026 15:31:53",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:49:57"
          },
          {
            "ticket_id": 19272,
            "ticket_number": "3519260",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "26/05/2026 15:31:55",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:31:55"
          },
          {
            "ticket_id": 19273,
            "ticket_number": "3519261",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 15:32:03",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:51:17"
          },
          {
            "ticket_id": 19274,
            "ticket_number": "3519262",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/05/2026 15:32:09",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:32:09"
          },
          {
            "ticket_id": 19275,
            "ticket_number": "3519263",
            "title": "GBN-125825 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 15:32:16",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:32:16"
          },
          {
            "ticket_id": 19276,
            "ticket_number": "3519264",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 15:32:19",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:48:11"
          },
          {
            "ticket_id": 19277,
            "ticket_number": "3519265",
            "title": "NOVA Confirmação de reserva 340885",
            "priority": "P2",
            "created_at": "26/05/2026 15:32:21",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:41:00"
          },
          {
            "ticket_id": 19278,
            "ticket_number": "3519266",
            "title": "GBN-125814 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "26/05/2026 15:35:23",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:35:34"
          },
          {
            "ticket_id": 19285,
            "ticket_number": "3519273",
            "title": "MAGALI MORIN RD MAIO 2DA VIA",
            "priority": "P2",
            "created_at": "26/05/2026 16:35:02",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:38:28"
          },
          {
            "ticket_id": 19286,
            "ticket_number": "3519274",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 17:06:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:50:12"
          },
          {
            "ticket_id": 19287,
            "ticket_number": "3519275",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "26/05/2026 17:06:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:50:50"
          },
          {
            "ticket_id": 19290,
            "ticket_number": "3519278",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604531280",
            "priority": "P2",
            "created_at": "26/05/2026 17:32:15",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:48:42"
          },
          {
            "ticket_id": 19291,
            "ticket_number": "3519279",
            "title": "TIAGO FERREIRA RD MAIO 2DA VIA",
            "priority": "P2",
            "created_at": "26/05/2026 17:32:18",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:32:57"
          },
          {
            "ticket_id": 19297,
            "ticket_number": "3519285",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:45",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:53:25"
          },
          {
            "ticket_id": 19298,
            "ticket_number": "3519286",
            "title": "Reserva cancelada com localizador: 4138397",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:47",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:11:47"
          },
          {
            "ticket_id": 19300,
            "ticket_number": "3519288",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:52",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:51:22"
          },
          {
            "ticket_id": 19302,
            "ticket_number": "3519290",
            "title": "Confirmation of booking with locatorCM96X5U2",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:57",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:11:57"
          },
          {
            "ticket_id": 19303,
            "ticket_number": "3519291",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 18:20:00",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:12:10"
          },
          {
            "ticket_id": 19304,
            "ticket_number": "3519292",
            "title": "GBN-124375 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "26/05/2026 18:23:42",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:41:30"
          },
          {
            "ticket_id": 19306,
            "ticket_number": "3519294",
            "title": "Pagamento da reserva – Ref PP196221, Sra. Rute Val",
            "priority": "P2",
            "created_at": "26/05/2026 18:27:12",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:44:34"
          },
          {
            "ticket_id": 19312,
            "ticket_number": "3519300",
            "title": "Reserva cancelada com localizador: 4211494",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:25",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:12:30"
          },
          {
            "ticket_id": 19315,
            "ticket_number": "3519303",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604641379",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:31",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:13:04"
          },
          {
            "ticket_id": 19316,
            "ticket_number": "3519304",
            "title": "Reserva confirmada: Tour pelas praias de ilha Saon",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:13:20"
          },
          {
            "ticket_id": 19317,
            "ticket_number": "3519305",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:35",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:02:35"
          },
          {
            "ticket_id": 19318,
            "ticket_number": "3519306",
            "title": "Confirmacao 345991",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:37",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:14:15"
          },
          {
            "ticket_id": 19320,
            "ticket_number": "3519308",
            "title": "Reserva confirmada: Tour pelas praias de ilha Saon",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:14:31"
          },
          {
            "ticket_id": 19322,
            "ticket_number": "3519310",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:46",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:14:51"
          },
          {
            "ticket_id": 19327,
            "ticket_number": "3519315",
            "title": "Reserva cancelada com localizador: 4056194",
            "priority": "P2",
            "created_at": "26/05/2026 20:38:14",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:40:25"
          },
          {
            "ticket_id": 19330,
            "ticket_number": "3519318",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "26/05/2026 21:12:06",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 12.13,
            "sla_met": false,
            "sla_breach_hours": 8.13,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:21:00"
          },
          {
            "ticket_id": 19336,
            "ticket_number": "3519324",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:34",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:24:01"
          },
          {
            "ticket_id": 19340,
            "ticket_number": "3519328",
            "title": "MSC Cruises Document - 2600101003716081",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:45",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:45:38"
          },
          {
            "ticket_id": 19343,
            "ticket_number": "3519331",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:51",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:25:06"
          },
          {
            "ticket_id": 19344,
            "ticket_number": "3519332",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:58",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:25:19"
          },
          {
            "ticket_id": 19345,
            "ticket_number": "3519333",
            "title": "Confirmation of booking with locatorC3PNWM1L",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:00",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:25:29"
          },
          {
            "ticket_id": 19348,
            "ticket_number": "3519336",
            "title": "Recepção de Pagamento -  (Recibo-2147852521)",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:06",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:19:47"
          },
          {
            "ticket_id": 19349,
            "ticket_number": "3519337",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:08",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:26:44"
          },
          {
            "ticket_id": 19350,
            "ticket_number": "3519338",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:11",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:26:53"
          },
          {
            "ticket_id": 19351,
            "ticket_number": "3519339",
            "title": "GBN-125909 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:20",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:12:21"
          },
          {
            "ticket_id": 19352,
            "ticket_number": "3519340",
            "title": "Pagamento da reserva – Ref PP911972, Sr. Micael Sa",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:23",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:27:12"
          },
          {
            "ticket_id": 19354,
            "ticket_number": "3519342",
            "title": "Confirmação de reserva – Ref PP911972, Sr. Micael ",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:27",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 09:27:51"
          },
          {
            "ticket_id": 19355,
            "ticket_number": "3519343",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "27/05/2026 09:47:10",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:04:06"
          },
          {
            "ticket_id": 19356,
            "ticket_number": "3519344",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "27/05/2026 09:47:12",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:04:10"
          },
          {
            "ticket_id": 19357,
            "ticket_number": "3519345",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "27/05/2026 09:47:14",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:04:13"
          },
          {
            "ticket_id": 19367,
            "ticket_number": "3519355",
            "title": "[Cancelamento Serviço] TRP-2026-05289 / TRL-2026-0",
            "priority": "P2",
            "created_at": "27/05/2026 10:44:46",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 10:44:46"
          },
          {
            "ticket_id": 19369,
            "ticket_number": "3519357",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "27/05/2026 10:56:52",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:07:11"
          },
          {
            "ticket_id": 19372,
            "ticket_number": "3519360",
            "title": "GBN-125944 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/05/2026 11:22:32",
            "close_date": "2026-06-03",
            "sla_target_hours": 24,
            "actual_time_hours": 174.43,
            "sla_met": false,
            "sla_breach_hours": 150.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/06/2026 17:49:26"
          },
          {
            "ticket_id": 19374,
            "ticket_number": "3519362",
            "title": "GBN-125910 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/05/2026 11:31:01",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:31:02"
          },
          {
            "ticket_id": 19379,
            "ticket_number": "3519367",
            "title": "GBN-125973 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/05/2026 11:49:08",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:49:08"
          },
          {
            "ticket_id": 19382,
            "ticket_number": "3519370",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:42",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:13:42"
          },
          {
            "ticket_id": 19384,
            "ticket_number": "3519372",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:52",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:13:52"
          },
          {
            "ticket_id": 19388,
            "ticket_number": "3519376",
            "title": "Documentação Disponível - Reserva 345949",
            "priority": "P2",
            "created_at": "27/05/2026 12:36:42",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:56:32"
          },
          {
            "ticket_id": 19389,
            "ticket_number": "3519377",
            "title": "[Cancelamento Serviço] TRP-2026-04925 / TRL-2026-0",
            "priority": "P2",
            "created_at": "27/05/2026 12:40:02",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:40:03"
          },
          {
            "ticket_id": 19390,
            "ticket_number": "3519378",
            "title": "Confirmação de reserva – Ref PP219523, Sr. Pedro  ",
            "priority": "P2",
            "created_at": "27/05/2026 12:50:44",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:57:06"
          },
          {
            "ticket_id": 19393,
            "ticket_number": "3519381",
            "title": "Envio de Documentação * File 435734",
            "priority": "P2",
            "created_at": "27/05/2026 12:51:05",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:58:23"
          },
          {
            "ticket_id": 19395,
            "ticket_number": "3519383",
            "title": "Confirmação de reserva 337005 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "27/05/2026 12:51:17",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:41:40"
          },
          {
            "ticket_id": 19398,
            "ticket_number": "3519386",
            "title": "Confirmacao 346018",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:02",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:30:02"
          },
          {
            "ticket_id": 19399,
            "ticket_number": "3519387",
            "title": "Criação de processo File 442342/26",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:08",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:01:53"
          },
          {
            "ticket_id": 19401,
            "ticket_number": "3519389",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:12",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:01:53"
          },
          {
            "ticket_id": 19402,
            "ticket_number": "3519390",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:15",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:01:53"
          },
          {
            "ticket_id": 19404,
            "ticket_number": "3519392",
            "title": "Solole. Booking DPFYBSMG is close to entering expe",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:30",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:57:45"
          },
          {
            "ticket_id": 19405,
            "ticket_number": "3519393",
            "title": "[Suporte] TRP-2026-05291 - Comissão",
            "priority": "P2",
            "created_at": "27/05/2026 14:12:44",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:12:45"
          },
          {
            "ticket_id": 19409,
            "ticket_number": "3519397",
            "title": "Informações da reserva TTN-1267609701#103062471#T2",
            "priority": "P2",
            "created_at": "27/05/2026 14:36:08",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:23:44"
          },
          {
            "ticket_id": 19410,
            "ticket_number": "3519398",
            "title": "Informações da reserva TTN-1267609701#103062471#T2",
            "priority": "P2",
            "created_at": "27/05/2026 14:36:10",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:51:31"
          },
          {
            "ticket_id": 19411,
            "ticket_number": "3519399",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "27/05/2026 14:36:12",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:21:59"
          },
          {
            "ticket_id": 19412,
            "ticket_number": "3519400",
            "title": "Reservas Só Hotel com a cntravel",
            "priority": "P2",
            "created_at": "27/05/2026 14:36:16",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:53:49"
          },
          {
            "ticket_id": 19416,
            "ticket_number": "3519404",
            "title": "Informações da reserva TTN-1267609701#103062471#T2",
            "priority": "P2",
            "created_at": "27/05/2026 14:57:25",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:23:56"
          },
          {
            "ticket_id": 19420,
            "ticket_number": "3519408",
            "title": "GBN-126023 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/05/2026 15:16:47",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:16:47"
          },
          {
            "ticket_id": 19426,
            "ticket_number": "3519414",
            "title": "[Cancelamento Serviço] TRP-2026-05203 / TRL-2026-0",
            "priority": "P2",
            "created_at": "27/05/2026 16:03:54",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:03:54"
          },
          {
            "ticket_id": 19427,
            "ticket_number": "3519415",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:30",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:48:30"
          },
          {
            "ticket_id": 19430,
            "ticket_number": "3519418",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:44",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:48:44"
          },
          {
            "ticket_id": 19433,
            "ticket_number": "3519421",
            "title": "Confirmação de reserva com localizador: 4237800",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:57",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 19:33:09"
          },
          {
            "ticket_id": 19435,
            "ticket_number": "3519423",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/05/2026 16:49:07",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:49:07"
          },
          {
            "ticket_id": 19441,
            "ticket_number": "3519429",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "27/05/2026 16:49:24",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:45:14"
          },
          {
            "ticket_id": 19443,
            "ticket_number": "3519431",
            "title": "Documentação Disponível - Reserva 338138",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:33",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:38:30"
          },
          {
            "ticket_id": 19444,
            "ticket_number": "3519432",
            "title": "Documentação Disponível - Reserva 333882",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:35",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:37:44"
          },
          {
            "ticket_id": 19445,
            "ticket_number": "3519433",
            "title": "Documentação Disponível - Reserva 338772",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:38",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:36:49"
          },
          {
            "ticket_id": 19446,
            "ticket_number": "3519434",
            "title": "ALTERAÇÕES PARA VALIDAR: RESERVA TRAVELPLAN LOC 60",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:40",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:03:40"
          },
          {
            "ticket_id": 19447,
            "ticket_number": "3519435",
            "title": "Pedido de PNR soltropico",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:47",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:03:47"
          },
          {
            "ticket_id": 19448,
            "ticket_number": "3519436",
            "title": "alterações por validar",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:53",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:03:53"
          },
          {
            "ticket_id": 19449,
            "ticket_number": "3519437",
            "title": "Documentação Disponível - Reserva 344677",
            "priority": "P2",
            "created_at": "27/05/2026 17:03:55",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:35:45"
          },
          {
            "ticket_id": 19452,
            "ticket_number": "3519440",
            "title": "Documentação Disponível - Reserva 338138",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:13",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 19:35:14"
          },
          {
            "ticket_id": 19453,
            "ticket_number": "3519441",
            "title": "Re: 26VG001094/001 - Cancelamento Voo",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:15",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:02:15"
          },
          {
            "ticket_id": 19454,
            "ticket_number": "3519442",
            "title": "Re: 26VG001094/001 - Cancelamento Voo",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:17",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:02:17"
          },
          {
            "ticket_id": 19455,
            "ticket_number": "3519443",
            "title": "Documentação Disponível - Reserva 338772",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:20",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:16:53"
          },
          {
            "ticket_id": 19456,
            "ticket_number": "3519444",
            "title": "Documentação Disponível - Reserva 344677",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:22",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:16:57"
          },
          {
            "ticket_id": 19457,
            "ticket_number": "3519445",
            "title": "Documentação Disponível - Reserva 333882",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:24",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:17:01"
          },
          {
            "ticket_id": 19458,
            "ticket_number": "3519446",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "27/05/2026 18:02:25",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:02:26"
          },
          {
            "ticket_id": 19462,
            "ticket_number": "3519450",
            "title": "w2m.travel: Confirmación reserva 'ZP32D8'",
            "priority": "P2",
            "created_at": "27/05/2026 19:45:04",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 21:15:39"
          },
          {
            "ticket_id": 19463,
            "ticket_number": "3519451",
            "title": "Reserva Aérea LA0453535DBGT",
            "priority": "P2",
            "created_at": "27/05/2026 20:02:34",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 22:16:05"
          },
          {
            "ticket_id": 19464,
            "ticket_number": "3519452",
            "title": "Mensagem sobre a reserva 39174933 - Civitatis",
            "priority": "P2",
            "created_at": "27/05/2026 20:26:37",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 21:16:28"
          },
          {
            "ticket_id": 19469,
            "ticket_number": "3519457",
            "title": "[Suporte] TRP-2026-05083 - Descrição na fatura",
            "priority": "P2",
            "created_at": "27/05/2026 23:18:12",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 23:18:12"
          },
          {
            "ticket_id": 19470,
            "ticket_number": "3519458",
            "title": "[Suporte] TRP-2026-03178 - Ausência de fatura",
            "priority": "P2",
            "created_at": "27/05/2026 23:54:29",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 23:54:29"
          },
          {
            "ticket_id": 19476,
            "ticket_number": "3519464",
            "title": "GBN-121787 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:26",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:20:49"
          },
          {
            "ticket_id": 19478,
            "ticket_number": "3519466",
            "title": "Urgente_File 431638",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:30",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:08:30"
          },
          {
            "ticket_id": 19481,
            "ticket_number": "3519469",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604642257",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:36",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:25:47"
          },
          {
            "ticket_id": 19484,
            "ticket_number": "3519472",
            "title": "Mensagem sobre a reserva 37167458 - Civitatis",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:42",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:28:16"
          },
          {
            "ticket_id": 19485,
            "ticket_number": "3519473",
            "title": "GBN-120965 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:44",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:03:25"
          },
          {
            "ticket_id": 19486,
            "ticket_number": "3519474",
            "title": "Mensagem sobre a reserva 37167460 - Civitatis",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:47",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:29:12"
          },
          {
            "ticket_id": 19487,
            "ticket_number": "3519475",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:54",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:29:24"
          },
          {
            "ticket_id": 19489,
            "ticket_number": "3519477",
            "title": "Aéreo - Confirmação de Emissão (VILELA MENON\\ANA K",
            "priority": "P2",
            "created_at": "28/05/2026 09:09:00",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:43:23"
          },
          {
            "ticket_id": 19490,
            "ticket_number": "3519478",
            "title": "Aéreo - Confirmação de Emissão (DA SILVA\\LINDACY V",
            "priority": "P2",
            "created_at": "28/05/2026 09:09:04",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:43:50"
          },
          {
            "ticket_id": 19491,
            "ticket_number": "3519479",
            "title": "Aéreo - Confirmação de Emissão (MENON\\KARLA VILELA",
            "priority": "P2",
            "created_at": "28/05/2026 09:09:06",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:44:34"
          },
          {
            "ticket_id": 19492,
            "ticket_number": "3519480",
            "title": "Aéreo - Confirmação de Emissão (MENON\\BRUNO) - LA0",
            "priority": "P2",
            "created_at": "28/05/2026 09:09:08",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:45:01"
          },
          {
            "ticket_id": 19493,
            "ticket_number": "3519481",
            "title": "Pedido de Contacto Movel - 334615 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:19:20",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:46:01"
          },
          {
            "ticket_id": 19496,
            "ticket_number": "3519484",
            "title": "Pedido de Contacto Movel - 335294 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:30",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:50:27"
          },
          {
            "ticket_id": 19497,
            "ticket_number": "3519485",
            "title": "Pedido de Contacto Movel - 341817 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:32",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:51:23"
          },
          {
            "ticket_id": 19499,
            "ticket_number": "3519487",
            "title": "Pedido de Contacto Movel - 334066 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:36",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:57:07"
          },
          {
            "ticket_id": 19500,
            "ticket_number": "3519488",
            "title": "Pedido de Contacto Movel - 334047 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:37",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:57:46"
          },
          {
            "ticket_id": 19501,
            "ticket_number": "3519489",
            "title": "Pedido de Contacto Movel - 340138 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:39",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:58:21"
          },
          {
            "ticket_id": 19502,
            "ticket_number": "3519490",
            "title": "Confirmacao 346055",
            "priority": "P2",
            "created_at": "28/05/2026 10:21:33",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 29.48,
            "sla_met": false,
            "sla_breach_hours": 25.48,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:51:26"
          },
          {
            "ticket_id": 19504,
            "ticket_number": "3519492",
            "title": "VOUCHER DA RESERVA 604546033",
            "priority": "P2",
            "created_at": "28/05/2026 11:01:43",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:09:36"
          },
          {
            "ticket_id": 19506,
            "ticket_number": "3519494",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "28/05/2026 11:01:47",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:09:45"
          },
          {
            "ticket_id": 19511,
            "ticket_number": "3519499",
            "title": "Ofertas de Última Hora a partir de 499€",
            "priority": "P2",
            "created_at": "28/05/2026 11:21:53",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:38:42"
          },
          {
            "ticket_id": 19516,
            "ticket_number": "3519504",
            "title": "NOTIFICACION RESERVA 6147437",
            "priority": "P2",
            "created_at": "28/05/2026 11:22:03",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:28"
          },
          {
            "ticket_id": 19517,
            "ticket_number": "3519505",
            "title": "Documentação Disponível - Reserva 345820",
            "priority": "P2",
            "created_at": "28/05/2026 11:22:05",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:14:40"
          },
          {
            "ticket_id": 19518,
            "ticket_number": "3519506",
            "title": "NOTIFICACION RESERVA 6137428",
            "priority": "P2",
            "created_at": "28/05/2026 11:25:50",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:51:43"
          },
          {
            "ticket_id": 19532,
            "ticket_number": "3519520",
            "title": "NOTIFICACION RESERVA 6126871",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:32",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:33"
          },
          {
            "ticket_id": 19533,
            "ticket_number": "3519521",
            "title": "NOTIFICACION RESERVA 6141116",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:34",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:40"
          },
          {
            "ticket_id": 19534,
            "ticket_number": "3519522",
            "title": "NOTIFICACION RESERVA 6121143",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:36",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:42"
          },
          {
            "ticket_id": 19535,
            "ticket_number": "3519523",
            "title": "NOTIFICACION RESERVA 6130379",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:38",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:48"
          },
          {
            "ticket_id": 19536,
            "ticket_number": "3519524",
            "title": "NOTIFICACION RESERVA 6136183",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:40",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:52"
          },
          {
            "ticket_id": 19537,
            "ticket_number": "3519525",
            "title": "NOTIFICACION RESERVA 6130877",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:42",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:56"
          },
          {
            "ticket_id": 19538,
            "ticket_number": "3519526",
            "title": "NOTIFICACION RESERVA 6121113",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:44",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:00:59"
          },
          {
            "ticket_id": 19539,
            "ticket_number": "3519527",
            "title": "NOTIFICACION RESERVA 6140162",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:48",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:02"
          },
          {
            "ticket_id": 19540,
            "ticket_number": "3519528",
            "title": "NOTIFICACION RESERVA 6139140",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:51",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:06"
          },
          {
            "ticket_id": 19541,
            "ticket_number": "3519529",
            "title": "NOTIFICACION RESERVA 6120897",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:53",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:09"
          },
          {
            "ticket_id": 19542,
            "ticket_number": "3519530",
            "title": "NOTIFICACION RESERVA 6139278",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:55",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:13"
          },
          {
            "ticket_id": 19543,
            "ticket_number": "3519531",
            "title": "NOTIFICACION RESERVA 6131281",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:57",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:16"
          },
          {
            "ticket_id": 19544,
            "ticket_number": "3519532",
            "title": "NOTIFICACION RESERVA 6131284",
            "priority": "P2",
            "created_at": "28/05/2026 12:19:59",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:19"
          },
          {
            "ticket_id": 19545,
            "ticket_number": "3519533",
            "title": "NOTIFICACION RESERVA 6139690",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:01",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:22"
          },
          {
            "ticket_id": 19546,
            "ticket_number": "3519534",
            "title": "NOTIFICACION RESERVA 6131286",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:03",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:25"
          },
          {
            "ticket_id": 19547,
            "ticket_number": "3519535",
            "title": "NOTIFICACION RESERVA 6139532",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:05",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:30"
          },
          {
            "ticket_id": 19548,
            "ticket_number": "3519536",
            "title": "NOTIFICACION RESERVA 6139181",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:07",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:34"
          },
          {
            "ticket_id": 19549,
            "ticket_number": "3519537",
            "title": "NOTIFICACION RESERVA 6131287",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:10",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:37"
          },
          {
            "ticket_id": 19550,
            "ticket_number": "3519538",
            "title": "NOTIFICACION RESERVA 6129737",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:12",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:41"
          },
          {
            "ticket_id": 19551,
            "ticket_number": "3519539",
            "title": "NOTIFICACION RESERVA 6129118",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:15",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:45"
          },
          {
            "ticket_id": 19552,
            "ticket_number": "3519540",
            "title": "NOTIFICACION RESERVA 6142012",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:17",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:48"
          },
          {
            "ticket_id": 19553,
            "ticket_number": "3519541",
            "title": "NOTIFICACION RESERVA 6136070",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:19",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:52"
          },
          {
            "ticket_id": 19554,
            "ticket_number": "3519542",
            "title": "NOTIFICACION RESERVA 6139082",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:21",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:01:56"
          },
          {
            "ticket_id": 19556,
            "ticket_number": "3519544",
            "title": "NOTIFICACION RESERVA 6139064",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:26",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:02:04"
          },
          {
            "ticket_id": 19557,
            "ticket_number": "3519545",
            "title": "Re: [Cockpit] Viagem TRP-2026-05302 - Viagem Edimb",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:28",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:20:29"
          },
          {
            "ticket_id": 19558,
            "ticket_number": "3519546",
            "title": "NOTIFICACION RESERVA 6136213",
            "priority": "P2",
            "created_at": "28/05/2026 12:20:31",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:02:08"
          },
          {
            "ticket_id": 19559,
            "ticket_number": "3519547",
            "title": "NOTIFICACION RESERVA 6136240",
            "priority": "P2",
            "created_at": "28/05/2026 12:31:37",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:02:11"
          },
          {
            "ticket_id": 19560,
            "ticket_number": "3519548",
            "title": "NOTIFICACION RESERVA 6140755",
            "priority": "P2",
            "created_at": "28/05/2026 12:31:39",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:02:16"
          },
          {
            "ticket_id": 19561,
            "ticket_number": "3519549",
            "title": "RE: Pagamento 6146924",
            "priority": "P2",
            "created_at": "28/05/2026 12:31:41",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 14:44:45"
          },
          {
            "ticket_id": 19562,
            "ticket_number": "3519550",
            "title": "NOTIFICACION RESERVA 6129257",
            "priority": "P2",
            "created_at": "28/05/2026 12:31:43",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:02:25"
          },
          {
            "ticket_id": 19570,
            "ticket_number": "3519558",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "28/05/2026 14:35:35",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 14:45:47"
          },
          {
            "ticket_id": 19572,
            "ticket_number": "3519560",
            "title": "Confirmation of booking with locator9TBCMLMU",
            "priority": "P2",
            "created_at": "28/05/2026 14:35:41",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 14:45:34"
          },
          {
            "ticket_id": 19575,
            "ticket_number": "3519563",
            "title": "GBN-126208 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:40",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:15:40"
          },
          {
            "ticket_id": 19576,
            "ticket_number": "3519564",
            "title": "w2m.travel: Confirmación reserva 'SBB5J1'",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:43",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19578,
            "ticket_number": "3519566",
            "title": "Reserva confirmada: Tour pelas praias da ilha Saon",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:47",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19581,
            "ticket_number": "3519569",
            "title": "Reserva confirmada: Tour pelas praias da ilha Saon",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:54",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19583,
            "ticket_number": "3519571",
            "title": "Pedido de Email do Cliente p/ Confirmação - Fil 42",
            "priority": "P2",
            "created_at": "28/05/2026 16:16:09",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19584,
            "ticket_number": "3519572",
            "title": "DTH TRAVEL ( fornecedor AIRMET) - INSPIRAÇÃO ÁSIA,",
            "priority": "P2",
            "created_at": "28/05/2026 16:16:49",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19585,
            "ticket_number": "3519573",
            "title": "Fwd: Faturas em falta",
            "priority": "P2",
            "created_at": "28/05/2026 16:16:51",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:16:51"
          },
          {
            "ticket_id": 19593,
            "ticket_number": "3519581",
            "title": "GBN-111482 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/05/2026 16:17:28",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:13"
          },
          {
            "ticket_id": 19596,
            "ticket_number": "3519584",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "28/05/2026 17:03:25",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:35:20"
          },
          {
            "ticket_id": 19598,
            "ticket_number": "3519586",
            "title": "GBN-126269 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/05/2026 18:19:39",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 18:19:39"
          },
          {
            "ticket_id": 19599,
            "ticket_number": "3519587",
            "title": "FW: Pedido de faturas",
            "priority": "P2",
            "created_at": "28/05/2026 18:19:44",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 17.22,
            "sla_met": false,
            "sla_breach_hours": 13.22,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:33:02"
          },
          {
            "ticket_id": 19600,
            "ticket_number": "3519588",
            "title": "GBN-126256 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/05/2026 18:19:50",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 18:19:50"
          },
          {
            "ticket_id": 19601,
            "ticket_number": "3519589",
            "title": "GBN-126117 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/05/2026 19:09:11",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 16.3,
            "sla_met": false,
            "sla_breach_hours": 12.3,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:27:37"
          },
          {
            "ticket_id": 19603,
            "ticket_number": "3519591",
            "title": "GBN-126129 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/05/2026 19:09:15",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 16.28,
            "sla_met": false,
            "sla_breach_hours": 12.28,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:26:17"
          },
          {
            "ticket_id": 19604,
            "ticket_number": "3519592",
            "title": "GBN-126117 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/05/2026 19:09:17",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 16.3,
            "sla_met": false,
            "sla_breach_hours": 12.3,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:27:23"
          },
          {
            "ticket_id": 19605,
            "ticket_number": "3519593",
            "title": "GBN-126129 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/05/2026 19:09:20",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 20.08,
            "sla_met": false,
            "sla_breach_hours": 16.08,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:14:31"
          },
          {
            "ticket_id": 19606,
            "ticket_number": "3519594",
            "title": "Saídas de 27/06/2026 para 01/08/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "28/05/2026 19:09:39",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 24.92,
            "sla_met": false,
            "sla_breach_hours": 20.92,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 20:05:07"
          },
          {
            "ticket_id": 19607,
            "ticket_number": "3519595",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "28/05/2026 19:28:13",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 15.95,
            "sla_met": false,
            "sla_breach_hours": 11.95,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:25:15"
          },
          {
            "ticket_id": 19608,
            "ticket_number": "3519596",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "28/05/2026 19:37:12",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 15.8,
            "sla_met": false,
            "sla_breach_hours": 11.8,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:25:36"
          },
          {
            "ticket_id": 19612,
            "ticket_number": "3519600",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604642889",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:30",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:40:03"
          },
          {
            "ticket_id": 19613,
            "ticket_number": "3519601",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:34",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:40:03"
          },
          {
            "ticket_id": 19615,
            "ticket_number": "3519603",
            "title": "Fw: Important: Your TAP Air Portugal flight refere",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:39",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 21:40:39"
          },
          {
            "ticket_id": 19616,
            "ticket_number": "3519604",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:41",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 21:40:42"
          },
          {
            "ticket_id": 19617,
            "ticket_number": "3519605",
            "title": "Criação de processo File 442483/26",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:50",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:40:04"
          },
          {
            "ticket_id": 19618,
            "ticket_number": "3519606",
            "title": "GBN-126306 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 21:40:57"
          },
          {
            "ticket_id": 19622,
            "ticket_number": "3519610",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:51",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19623,
            "ticket_number": "3519611",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:52",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19624,
            "ticket_number": "3519612",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:55",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19625,
            "ticket_number": "3519613",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:56",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19626,
            "ticket_number": "3519614",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:58",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19627,
            "ticket_number": "3519615",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:24:59",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19628,
            "ticket_number": "3519616",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:01",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19631,
            "ticket_number": "3519619",
            "title": "Eticket - 67529122 - MR  16/06/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:13",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19635,
            "ticket_number": "3519623",
            "title": "Eticket - 67529520 - MR  16/06/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:27",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:23"
          },
          {
            "ticket_id": 19636,
            "ticket_number": "3519624",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:30",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:23"
          },
          {
            "ticket_id": 19639,
            "ticket_number": "3519627",
            "title": "Documentação Disponível - Reserva 346018",
            "priority": "P2",
            "created_at": "29/05/2026 10:42:54",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:40:25"
          },
          {
            "ticket_id": 19641,
            "ticket_number": "3519629",
            "title": "File 429861/26 - INFORMAÇÃO PARA CONFIRMAÇÃO E-SIM",
            "priority": "P2",
            "created_at": "29/05/2026 10:45:55",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:40:25"
          },
          {
            "ticket_id": 19642,
            "ticket_number": "3519630",
            "title": "Confirmação de reserva para For PT004157 72580901",
            "priority": "P2",
            "created_at": "29/05/2026 10:45:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:40:25"
          },
          {
            "ticket_id": 19643,
            "ticket_number": "3519631",
            "title": "[Cancelamento Serviço] TRP-2026-05313 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 10:47:14",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 10:47:14"
          },
          {
            "ticket_id": 19644,
            "ticket_number": "3519632",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "29/05/2026 11:00:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:12"
          },
          {
            "ticket_id": 19645,
            "ticket_number": "3519633",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "29/05/2026 11:01:00",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:35"
          },
          {
            "ticket_id": 19646,
            "ticket_number": "3519634",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "29/05/2026 11:01:02",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:18"
          },
          {
            "ticket_id": 19647,
            "ticket_number": "3519635",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "29/05/2026 11:01:05",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:23"
          },
          {
            "ticket_id": 19650,
            "ticket_number": "3519638",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "29/05/2026 11:08:56",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:00:28"
          },
          {
            "ticket_id": 19652,
            "ticket_number": "3519640",
            "title": "Confirmação de reserva para For PT004157 72588955",
            "priority": "P2",
            "created_at": "29/05/2026 11:41:03",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:27:57"
          },
          {
            "ticket_id": 19655,
            "ticket_number": "3519643",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "29/05/2026 11:41:12",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:30:08"
          },
          {
            "ticket_id": 19656,
            "ticket_number": "3519644",
            "title": "Confirmação de reserva para For PT004157 72588955",
            "priority": "P2",
            "created_at": "29/05/2026 11:41:16",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:30:17"
          },
          {
            "ticket_id": 19657,
            "ticket_number": "3519645",
            "title": "Confirmação de reserva para For PT004157 72588955",
            "priority": "P2",
            "created_at": "29/05/2026 11:41:18",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:30:25"
          },
          {
            "ticket_id": 19659,
            "ticket_number": "3519647",
            "title": "Web check-in já disponível para o voo S4121/31MAY",
            "priority": "P2",
            "created_at": "29/05/2026 11:42:04",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:40:37"
          },
          {
            "ticket_id": 19660,
            "ticket_number": "3519648",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "29/05/2026 11:42:08",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:31:22"
          },
          {
            "ticket_id": 19661,
            "ticket_number": "3519649",
            "title": "Electronic ticket receipt, May 28 SAO PAULO GUARUL",
            "priority": "P2",
            "created_at": "29/05/2026 11:52:05",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:40:37"
          },
          {
            "ticket_id": 19662,
            "ticket_number": "3519650",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:07",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:31:29"
          },
          {
            "ticket_id": 19664,
            "ticket_number": "3519652",
            "title": "GBN-126360 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:12",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:12"
          },
          {
            "ticket_id": 19665,
            "ticket_number": "3519653",
            "title": "GBN-126365 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:16",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:16"
          },
          {
            "ticket_id": 19667,
            "ticket_number": "3519655",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:26",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:19:33"
          },
          {
            "ticket_id": 19668,
            "ticket_number": "3519656",
            "title": "GBN-126365 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:29",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 5.5,
            "sla_met": false,
            "sla_breach_hours": 1.5,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:47:30"
          },
          {
            "ticket_id": 19673,
            "ticket_number": "3519661",
            "title": "GBN-101161 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 13:04:20",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:21:22"
          },
          {
            "ticket_id": 19675,
            "ticket_number": "3519663",
            "title": "Promo MAR ABERTO | Cruzeiros desde €413p.p.",
            "priority": "P2",
            "created_at": "29/05/2026 13:04:25",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:34:09"
          },
          {
            "ticket_id": 19676,
            "ticket_number": "3519664",
            "title": "Confirmacao 346116",
            "priority": "P2",
            "created_at": "29/05/2026 13:04:27",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:34:20"
          },
          {
            "ticket_id": 19679,
            "ticket_number": "3519667",
            "title": "Importante - Checkin Online Voos TAP - FILE 345645",
            "priority": "P2",
            "created_at": "29/05/2026 13:05:48",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:00:53"
          },
          {
            "ticket_id": 19686,
            "ticket_number": "3519674",
            "title": "GBN-126393 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/05/2026 14:10:00",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:10:00"
          },
          {
            "ticket_id": 19690,
            "ticket_number": "3519678",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "29/05/2026 14:49:07",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:36:19"
          },
          {
            "ticket_id": 19691,
            "ticket_number": "3519679",
            "title": "Informações da reserva TTN-1267609701#103062471#T2",
            "priority": "P2",
            "created_at": "29/05/2026 14:49:10",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:13:05"
          },
          {
            "ticket_id": 19696,
            "ticket_number": "3519684",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 15:05:17",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:05:17"
          },
          {
            "ticket_id": 19697,
            "ticket_number": "3519685",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 15:05:23",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:05:23"
          },
          {
            "ticket_id": 19699,
            "ticket_number": "3519687",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 15:06:37",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:06:37"
          },
          {
            "ticket_id": 19700,
            "ticket_number": "3519688",
            "title": "GBN-126376 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 15:43:52",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:48:03"
          },
          {
            "ticket_id": 19701,
            "ticket_number": "3519689",
            "title": "Fwd: Your new flight details",
            "priority": "P2",
            "created_at": "29/05/2026 15:43:56",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 4.7,
            "sla_met": false,
            "sla_breach_hours": 0.7,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 20:26:06"
          },
          {
            "ticket_id": 19703,
            "ticket_number": "3519691",
            "title": "GBN-126376 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:09",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:20:04"
          },
          {
            "ticket_id": 19705,
            "ticket_number": "3519693",
            "title": "GBN-126406 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:18",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:47:23"
          },
          {
            "ticket_id": 19708,
            "ticket_number": "3519696",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:43",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:44:43"
          },
          {
            "ticket_id": 19709,
            "ticket_number": "3519697",
            "title": "Fwd: easyJet número de referência da reserva: KCJV",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:52",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:44:52"
          },
          {
            "ticket_id": 19710,
            "ticket_number": "3519698",
            "title": "CAMPANHA | SOLFÉRIAS - DIA DA CRIANÇA",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:59",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:17:52"
          },
          {
            "ticket_id": 19712,
            "ticket_number": "3519700",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "29/05/2026 16:07:51",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:58:43"
          },
          {
            "ticket_id": 19713,
            "ticket_number": "3519701",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 16:07:59",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:07:59"
          },
          {
            "ticket_id": 19715,
            "ticket_number": "3519703",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "29/05/2026 16:08:03",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:30:36"
          },
          {
            "ticket_id": 19716,
            "ticket_number": "3519704",
            "title": "GBN-89009 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 16:17:23",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:18:21"
          },
          {
            "ticket_id": 19720,
            "ticket_number": "3519708",
            "title": "GBN-125731 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 16:30:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:31:19"
          },
          {
            "ticket_id": 19726,
            "ticket_number": "3519714",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "29/05/2026 16:58:34",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:58:34"
          },
          {
            "ticket_id": 19727,
            "ticket_number": "3519715",
            "title": "Re: [Cockpit] Viagem TRP-2026-05318 - RIVIERA MAYA",
            "priority": "P2",
            "created_at": "29/05/2026 16:58:36",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:58:36"
          },
          {
            "ticket_id": 19728,
            "ticket_number": "3519716",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "29/05/2026 16:58:38",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:01:26"
          },
          {
            "ticket_id": 19729,
            "ticket_number": "3519717",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "29/05/2026 16:58:41",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 5.02,
            "sla_met": false,
            "sla_breach_hours": 1.02,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:00:12"
          },
          {
            "ticket_id": 19730,
            "ticket_number": "3519718",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "29/05/2026 16:58:43",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:01:21"
          },
          {
            "ticket_id": 19731,
            "ticket_number": "3519719",
            "title": "DATOS BANCARIOS",
            "priority": "P2",
            "created_at": "29/05/2026 17:00:06",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:01:07"
          },
          {
            "ticket_id": 19740,
            "ticket_number": "3519728",
            "title": "GBN-126233 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 18:10:56",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 18:58:12"
          },
          {
            "ticket_id": 19741,
            "ticket_number": "3519729",
            "title": "GBN-111580 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/05/2026 18:10:58",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 18:51:49"
          },
          {
            "ticket_id": 19745,
            "ticket_number": "3519733",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "29/05/2026 18:47:34",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 18:47:34"
          },
          {
            "ticket_id": 19746,
            "ticket_number": "3519734",
            "title": "GBN-126486 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/05/2026 19:16:40",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 19:16:40"
          },
          {
            "ticket_id": 19747,
            "ticket_number": "3519735",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604643617",
            "priority": "P2",
            "created_at": "29/05/2026 19:16:42",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 20:29:42"
          },
          {
            "ticket_id": 19750,
            "ticket_number": "3519738",
            "title": "Reserva confirmada: Excursão a Murano e Burano + V",
            "priority": "P2",
            "created_at": "29/05/2026 20:46:20",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:04:55"
          },
          {
            "ticket_id": 19753,
            "ticket_number": "3519741",
            "title": "Reserva confirmada: Excursão a Murano e Burano + V",
            "priority": "P2",
            "created_at": "29/05/2026 20:46:26",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:10:40"
          },
          {
            "ticket_id": 19754,
            "ticket_number": "3519742",
            "title": "Reserva confirmada: Passeio de gôndola pela Ponte ",
            "priority": "P2",
            "created_at": "29/05/2026 20:46:29",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:10:52"
          },
          {
            "ticket_id": 19755,
            "ticket_number": "3519743",
            "title": "Reserva confirmada: Passeio de gôndola pela Ponte ",
            "priority": "P2",
            "created_at": "29/05/2026 20:46:31",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:10:59"
          },
          {
            "ticket_id": 19756,
            "ticket_number": "3519744",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "29/05/2026 20:46:37",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:11:10"
          },
          {
            "ticket_id": 19757,
            "ticket_number": "3519745",
            "title": "Viagem TRP-2026-02089",
            "priority": "P2",
            "created_at": "29/05/2026 21:25:54",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 21:25:54"
          },
          {
            "ticket_id": 19758,
            "ticket_number": "3519746",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604643642",
            "priority": "P2",
            "created_at": "29/05/2026 21:25:56",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:12:02"
          },
          {
            "ticket_id": 19759,
            "ticket_number": "3519747",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "29/05/2026 21:44:54",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:12:10"
          },
          {
            "ticket_id": 19764,
            "ticket_number": "3519752",
            "title": "Confirmacao 346152",
            "priority": "P2",
            "created_at": "29/05/2026 22:17:00",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:43:17"
          },
          {
            "ticket_id": 19765,
            "ticket_number": "3519753",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "29/05/2026 22:39:01",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:43:28"
          },
          {
            "ticket_id": 19767,
            "ticket_number": "3519755",
            "title": "[Cancelamento Serviço] TRP-2026-03937 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 23:11:31",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 23:12:53"
          },
          {
            "ticket_id": 19768,
            "ticket_number": "3519756",
            "title": "[Cancelamento Serviço] TRP-2026-05327 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 23:38:27",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 23:38:27"
          },
          {
            "ticket_id": 19770,
            "ticket_number": "3519758",
            "title": "Fwd: [Cockpit] A Tua Semana",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:07",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:02:07"
          },
          {
            "ticket_id": 19771,
            "ticket_number": "3519759",
            "title": "YXQ85H – Reserva com emissão hoje",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:09",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:44:50"
          },
          {
            "ticket_id": 19772,
            "ticket_number": "3519760",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:11",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:20:19"
          },
          {
            "ticket_id": 19773,
            "ticket_number": "3519761",
            "title": "MSC Cruises Document - 2600101003784753",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:14",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:21:17"
          },
          {
            "ticket_id": 19774,
            "ticket_number": "3519762",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:17",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:21:48"
          },
          {
            "ticket_id": 19775,
            "ticket_number": "3519763",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:20",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:22:07"
          },
          {
            "ticket_id": 19777,
            "ticket_number": "3519765",
            "title": "MSC Cruises Document - 2600101003784754",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:24",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:23:21"
          },
          {
            "ticket_id": 19778,
            "ticket_number": "3519766",
            "title": "A reserva A38183489 foi paga e confirmada",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:27",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:23:34"
          },
          {
            "ticket_id": 19779,
            "ticket_number": "3519767",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:28",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:20"
          },
          {
            "ticket_id": 19780,
            "ticket_number": "3519768",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:30",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:24"
          },
          {
            "ticket_id": 19781,
            "ticket_number": "3519769",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:32",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:28"
          },
          {
            "ticket_id": 19782,
            "ticket_number": "3519770",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:34",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:32"
          },
          {
            "ticket_id": 19783,
            "ticket_number": "3519771",
            "title": "GBN-126504 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:37",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:02:37"
          },
          {
            "ticket_id": 19784,
            "ticket_number": "3519772",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:39",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:53"
          },
          {
            "ticket_id": 19785,
            "ticket_number": "3519773",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:41",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:03:56"
          },
          {
            "ticket_id": 19786,
            "ticket_number": "3519774",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:43",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:04:00"
          },
          {
            "ticket_id": 19787,
            "ticket_number": "3519775",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:44",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:04:04"
          },
          {
            "ticket_id": 19790,
            "ticket_number": "3519778",
            "title": "Reserva pendente à espera de emiss��o",
            "priority": "P2",
            "created_at": "30/05/2026 09:24:14",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 4.9,
            "sla_met": false,
            "sla_breach_hours": 0.9,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 14:19:10"
          },
          {
            "ticket_id": 19792,
            "ticket_number": "3519780",
            "title": "easyJet booking reference: KCPS448",
            "priority": "P2",
            "created_at": "30/05/2026 09:49:44",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:00:11"
          },
          {
            "ticket_id": 19793,
            "ticket_number": "3519781",
            "title": "Your new flight details",
            "priority": "P2",
            "created_at": "30/05/2026 09:49:46",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:01:15"
          },
          {
            "ticket_id": 19794,
            "ticket_number": "3519782",
            "title": "Informação importante sobre a tua reserva 6122762",
            "priority": "P2",
            "created_at": "30/05/2026 09:50:46",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:58:39"
          },
          {
            "ticket_id": 19795,
            "ticket_number": "3519783",
            "title": "Informação importante sobre a tua reserva 6120833",
            "priority": "P2",
            "created_at": "30/05/2026 09:50:48",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 09:58:43"
          },
          {
            "ticket_id": 19798,
            "ticket_number": "3519786",
            "title": "Informações sobre a sua reserva TTN-1284685576#103",
            "priority": "P2",
            "created_at": "30/05/2026 10:03:51",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:05:43"
          },
          {
            "ticket_id": 19799,
            "ticket_number": "3519787",
            "title": "[Cancelamento Serviço] TRP-2026-05032 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/05/2026 10:08:06",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:08:06"
          },
          {
            "ticket_id": 19800,
            "ticket_number": "3519788",
            "title": "Cancellation of the booking with locator SA1PFMNK",
            "priority": "P2",
            "created_at": "30/05/2026 10:14:49",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:22:19"
          },
          {
            "ticket_id": 19801,
            "ticket_number": "3519789",
            "title": "Informação sobre voo S4121 flight information",
            "priority": "P2",
            "created_at": "30/05/2026 10:39:50",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 10:41:16"
          },
          {
            "ticket_id": 19804,
            "ticket_number": "3519792",
            "title": "GBN-126496 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:34",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 12:15:40"
          },
          {
            "ticket_id": 19805,
            "ticket_number": "3519793",
            "title": "GBN-126129 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:36",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 12:06:53"
          },
          {
            "ticket_id": 19806,
            "ticket_number": "3519794",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:38",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 11:54:08"
          },
          {
            "ticket_id": 19807,
            "ticket_number": "3519795",
            "title": "GBN-126496 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:41",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 12:07:01"
          },
          {
            "ticket_id": 19809,
            "ticket_number": "3519797",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:45",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 11:54:28"
          },
          {
            "ticket_id": 19813,
            "ticket_number": "3519801",
            "title": "Carregamento Carteira Digital - RI 258006018",
            "priority": "P2",
            "created_at": "30/05/2026 13:03:17",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 14:21:10"
          },
          {
            "ticket_id": 19815,
            "ticket_number": "3519803",
            "title": "Aéreo - Confirmação de Emissão (SILVA\\MIGUEL) - YX",
            "priority": "P2",
            "created_at": "30/05/2026 13:03:21",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 14:21:44"
          },
          {
            "ticket_id": 19818,
            "ticket_number": "3519806",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "30/05/2026 14:08:55",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 14:24:20"
          },
          {
            "ticket_id": 19822,
            "ticket_number": "3519810",
            "title": "Notificação Transferência Nacional Santander",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:38",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:36:13"
          },
          {
            "ticket_id": 19823,
            "ticket_number": "3519811",
            "title": "w2m.travel: Confirmación reserva '6F8WQV'",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:40",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:36:19"
          },
          {
            "ticket_id": 19824,
            "ticket_number": "3519812",
            "title": "w2m.travel: Payment confirmation '6F8WQV'",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:42",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:36:27"
          },
          {
            "ticket_id": 19825,
            "ticket_number": "3519813",
            "title": "Confirmation of booking with locatorA5OQMUO2",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:44",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:36:43"
          },
          {
            "ticket_id": 19826,
            "ticket_number": "3519814",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:46",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:23:46"
          },
          {
            "ticket_id": 19827,
            "ticket_number": "3519815",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604643749",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:48",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:37:24"
          },
          {
            "ticket_id": 19828,
            "ticket_number": "3519816",
            "title": "Confirmação reserva Bedsonline 197-14361508",
            "priority": "P2",
            "created_at": "30/05/2026 16:23:50",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:38:32"
          },
          {
            "ticket_id": 19830,
            "ticket_number": "3519818",
            "title": "Tarifas Especiais com TUDO INCLUÍDO!",
            "priority": "P2",
            "created_at": "30/05/2026 16:48:04",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:49:02"
          },
          {
            "ticket_id": 19831,
            "ticket_number": "3519819",
            "title": "[agencias1] Promoções da Le Passage to India (Tria",
            "priority": "P2",
            "created_at": "30/05/2026 16:48:11",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:49:10"
          },
          {
            "ticket_id": 19832,
            "ticket_number": "3519820",
            "title": "Dynamic Tours - Bem-vindo",
            "priority": "P2",
            "created_at": "30/05/2026 16:48:13",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:49:20"
          },
          {
            "ticket_id": 19833,
            "ticket_number": "3519821",
            "title": "Costa Adeje, Tenerife: PROMOÇÃO ESPECIAL MEIA PENS",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:39",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:12"
          },
          {
            "ticket_id": 19834,
            "ticket_number": "3519822",
            "title": "O melhor do verão A METADE DO PREÇO!",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:40",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:16"
          },
          {
            "ticket_id": 19835,
            "ticket_number": "3519823",
            "title": "Sonha em ir ao Alasca? Cruzeiro + aventura em terr",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:42",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:20"
          },
          {
            "ticket_id": 19836,
            "ticket_number": "3519824",
            "title": "Destinos All You | Ásia Central - Uzbequistão e Qu",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:44",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:24"
          },
          {
            "ticket_id": 19837,
            "ticket_number": "3519825",
            "title": "SICÍLIA - CIRCUITOS EXCLUSIVOS | VOOS ESPECIAIS DO",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:46",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:28"
          },
          {
            "ticket_id": 19838,
            "ticket_number": "3519826",
            "title": "⚡ Nova promoção: até 30% de desconto via GDS",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:49",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:33"
          },
          {
            "ticket_id": 19839,
            "ticket_number": "3519827",
            "title": "🌞 Especial Verano: Llévate 100€ Descuento solo has",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:51",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19840,
            "ticket_number": "3519828",
            "title": "Oferta plaza a plaza 👩‍👩‍👧‍👧 I Consulta todas las ",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:53",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19841,
            "ticket_number": "3519829",
            "title": "WEBINAR NORTRAVEL | ILHA DO SAL by MELIÁ HOTELS - ",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:55",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19842,
            "ticket_number": "3519830",
            "title": "🌍🏨 Só Hotel desde 31€ em destinos de sonho!",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:57",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19843,
            "ticket_number": "3519831",
            "title": "México- Especial dia dos mortos (2027)",
            "priority": "P2",
            "created_at": "30/05/2026 16:57:59",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19844,
            "ticket_number": "3519832",
            "title": "Madeira | Férias em Família no VidaMar Hotel e Res",
            "priority": "P2",
            "created_at": "30/05/2026 16:58:00",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19845,
            "ticket_number": "3519833",
            "title": "Hottest Summer Sale",
            "priority": "P2",
            "created_at": "30/05/2026 16:58:02",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19846,
            "ticket_number": "3519834",
            "title": "Cangooroo Newsletter | Maio 2026",
            "priority": "P2",
            "created_at": "30/05/2026 16:58:05",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19847,
            "ticket_number": "3519835",
            "title": "Preparado para descolar com a Emirates?",
            "priority": "P2",
            "created_at": "30/05/2026 16:58:07",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:53"
          },
          {
            "ticket_id": 19848,
            "ticket_number": "3519836",
            "title": "EXOTICO | REVEILLON EM PERNAMBUCO 🎊",
            "priority": "P2",
            "created_at": "30/05/2026 16:58:09",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:58:54"
          },
          {
            "ticket_id": 19849,
            "ticket_number": "3519837",
            "title": "GBN-126564 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/05/2026 17:09:41",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 17:09:41"
          },
          {
            "ticket_id": 19854,
            "ticket_number": "3519842",
            "title": "Confirmation of booking with locatorR1TSK0C1",
            "priority": "P2",
            "created_at": "01/06/2026 09:04:59",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:10:59"
          },
          {
            "ticket_id": 19856,
            "ticket_number": "3519844",
            "title": "Confirmation of booking with locatorKSYBDYLA",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:02",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:11:17"
          },
          {
            "ticket_id": 19857,
            "ticket_number": "3519845",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:04",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:05:04"
          },
          {
            "ticket_id": 19860,
            "ticket_number": "3519848",
            "title": "Informação importante sobre a tua reserva 1776719",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:11",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:12:03"
          },
          {
            "ticket_id": 19863,
            "ticket_number": "3519851",
            "title": "GBN-126575 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:23",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:05:23"
          },
          {
            "ticket_id": 19864,
            "ticket_number": "3519852",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:27",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:13:40"
          },
          {
            "ticket_id": 19868,
            "ticket_number": "3519856",
            "title": "GBN-120965 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:41",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:05:41"
          },
          {
            "ticket_id": 19869,
            "ticket_number": "3519857",
            "title": "VOUCHER DA RESERVA 604585334",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:52",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:14:36"
          },
          {
            "ticket_id": 19871,
            "ticket_number": "3519859",
            "title": "Confirmation of booking with locatorOKJ8WOJK",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:55",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:14:54"
          },
          {
            "ticket_id": 19872,
            "ticket_number": "3519860",
            "title": "GBN-126581 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:58",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:05:58"
          },
          {
            "ticket_id": 19874,
            "ticket_number": "3519862",
            "title": "Autocarro InterBraga TRP-2026-03603 - Comprovativo",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:28",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:06:28"
          },
          {
            "ticket_id": 19876,
            "ticket_number": "3519864",
            "title": "REMINDER: Dados de Passaporte - nosso File 442679",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:32",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:17:50"
          },
          {
            "ticket_id": 19879,
            "ticket_number": "3519867",
            "title": "Fwd: Check-in online now",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:40",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:06:41"
          },
          {
            "ticket_id": 19880,
            "ticket_number": "3519868",
            "title": "1281702836 TTN-1281702836#103483972#T20458962¬1223",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:43",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 21:44:56"
          },
          {
            "ticket_id": 19881,
            "ticket_number": "3519869",
            "title": "ALEXANDRE/BEATRIZ MRS 07SEP2026 LIS ORY",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:46",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:14"
          },
          {
            "ticket_id": 19882,
            "ticket_number": "3519870",
            "title": "Envio de documentação File 424637/26",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:57",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:19:19"
          },
          {
            "ticket_id": 19883,
            "ticket_number": "3519871",
            "title": "Fwd: Condições meteorológicas Açores | Procediment",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:00",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:00"
          },
          {
            "ticket_id": 19884,
            "ticket_number": "3519872",
            "title": "GBN-126618 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:03",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:03"
          },
          {
            "ticket_id": 19885,
            "ticket_number": "3519873",
            "title": "Verificação de pagamento de comissão",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:06",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:06"
          },
          {
            "ticket_id": 19889,
            "ticket_number": "3519877",
            "title": "GBN-126610 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:19",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:20"
          },
          {
            "ticket_id": 19892,
            "ticket_number": "3519880",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:31",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:31"
          },
          {
            "ticket_id": 19893,
            "ticket_number": "3519881",
            "title": "Criação de processo File 442679/26",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:38",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:21:09"
          },
          {
            "ticket_id": 19897,
            "ticket_number": "3519885",
            "title": "Pedido de Documentação - 414136 / 2025",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:53",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:53"
          },
          {
            "ticket_id": 19899,
            "ticket_number": "3519887",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "01/06/2026 10:08:45",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 14:01:22"
          },
          {
            "ticket_id": 19900,
            "ticket_number": "3519888",
            "title": "Madeira - taxa turística a partir de 01/06/2026",
            "priority": "P2",
            "created_at": "01/06/2026 10:08:47",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 14:01:22"
          },
          {
            "ticket_id": 19901,
            "ticket_number": "3519889",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "01/06/2026 10:08:49",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 14:01:23"
          },
          {
            "ticket_id": 19913,
            "ticket_number": "3519901",
            "title": "GBN-126655 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:03",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:45:03"
          },
          {
            "ticket_id": 19915,
            "ticket_number": "3519903",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:07",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:48"
          },
          {
            "ticket_id": 19918,
            "ticket_number": "3519906",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:14",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:48"
          },
          {
            "ticket_id": 19919,
            "ticket_number": "3519907",
            "title": "GBN-120717 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:16",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:48"
          },
          {
            "ticket_id": 19926,
            "ticket_number": "3519914",
            "title": "Envio de documentação File 440322/26",
            "priority": "P2",
            "created_at": "01/06/2026 11:46:13",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:49"
          },
          {
            "ticket_id": 19930,
            "ticket_number": "3519918",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "01/06/2026 11:51:31",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:49"
          },
          {
            "ticket_id": 19931,
            "ticket_number": "3519919",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "01/06/2026 11:51:34",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:41:50"
          },
          {
            "ticket_id": 19938,
            "ticket_number": "3519926",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:30:22",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:30:22"
          },
          {
            "ticket_id": 19939,
            "ticket_number": "3519927",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:30:25",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:30:25"
          },
          {
            "ticket_id": 19940,
            "ticket_number": "3519928",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:30:36",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:30:36"
          },
          {
            "ticket_id": 19941,
            "ticket_number": "3519929",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:30:47",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:30:47"
          },
          {
            "ticket_id": 19942,
            "ticket_number": "3519930",
            "title": "Fwd: Your flight is now boarding at Gate 14",
            "priority": "P2",
            "created_at": "01/06/2026 15:30:50",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:30:51"
          },
          {
            "ticket_id": 19948,
            "ticket_number": "3519936",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:04",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:02:50"
          },
          {
            "ticket_id": 19951,
            "ticket_number": "3519939",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:12",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:04:00"
          },
          {
            "ticket_id": 19952,
            "ticket_number": "3519940",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:14",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:04:09"
          },
          {
            "ticket_id": 19954,
            "ticket_number": "3519942",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:20",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:31:20"
          },
          {
            "ticket_id": 19957,
            "ticket_number": "3519945",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:26",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:06:33"
          },
          {
            "ticket_id": 19962,
            "ticket_number": "3519950",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:00",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:32:00"
          },
          {
            "ticket_id": 19963,
            "ticket_number": "3519951",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:03",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:08:59"
          },
          {
            "ticket_id": 19965,
            "ticket_number": "3519953",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:17",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:09:08"
          },
          {
            "ticket_id": 19966,
            "ticket_number": "3519954",
            "title": "GBN-126508 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:22",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19967,
            "ticket_number": "3519955",
            "title": "GBN-126508 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:24",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19968,
            "ticket_number": "3519956",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:26",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:09:22"
          },
          {
            "ticket_id": 19969,
            "ticket_number": "3519957",
            "title": "GBN-126679 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:30",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:32:30"
          },
          {
            "ticket_id": 19970,
            "ticket_number": "3519958",
            "title": "Fwd: Your flight TO7680 to Faro has been delayed",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:36",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:32:36"
          },
          {
            "ticket_id": 19972,
            "ticket_number": "3519960",
            "title": "GBN-101161 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:42",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:37"
          },
          {
            "ticket_id": 19973,
            "ticket_number": "3519961",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:47",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:32:47"
          },
          {
            "ticket_id": 19974,
            "ticket_number": "3519962",
            "title": "SOL Príncipe",
            "priority": "P2",
            "created_at": "01/06/2026 15:32:50",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:37"
          },
          {
            "ticket_id": 19979,
            "ticket_number": "3519967",
            "title": "GBN-125343 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "01/06/2026 16:05:05",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 20:02:39"
          },
          {
            "ticket_id": 19980,
            "ticket_number": "3519968",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "01/06/2026 16:05:07",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 16:05:08"
          },
          {
            "ticket_id": 19981,
            "ticket_number": "3519969",
            "title": "NOVA Documentação Disponível - Reserva 333869",
            "priority": "P2",
            "created_at": "01/06/2026 16:05:09",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:11:11"
          },
          {
            "ticket_id": 19983,
            "ticket_number": "3519971",
            "title": "CAS-324848-P0X5B3 SATA0000001082653",
            "priority": "P2",
            "created_at": "01/06/2026 16:05:15",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 20:02:39"
          },
          {
            "ticket_id": 19986,
            "ticket_number": "3519974",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "01/06/2026 16:39:19",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 16:39:19"
          },
          {
            "ticket_id": 19987,
            "ticket_number": "3519975",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "01/06/2026 17:21:56",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:21:48"
          },
          {
            "ticket_id": 19989,
            "ticket_number": "3519977",
            "title": "GBN-126767 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:01",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:22:01"
          },
          {
            "ticket_id": 19992,
            "ticket_number": "3519980",
            "title": "GBN-126769 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:15",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:22:16"
          },
          {
            "ticket_id": 19994,
            "ticket_number": "3519982",
            "title": "Reserva confirmada: Tour privado por Paris + Trans",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:26",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 4.02,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:24:03"
          },
          {
            "ticket_id": 19995,
            "ticket_number": "3519983",
            "title": "Reserva confirmada: Tour privado por Paris + Trans",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:28",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 4.02,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:24:12"
          },
          {
            "ticket_id": 19999,
            "ticket_number": "3519987",
            "title": "GBN-111700 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "01/06/2026 19:03:52",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:24:45"
          },
          {
            "ticket_id": 20000,
            "ticket_number": "3519988",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "01/06/2026 19:03:56",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:24:50"
          },
          {
            "ticket_id": 20001,
            "ticket_number": "3519989",
            "title": "Aceite: Sessão de Acolhimento @ qua. 3 Jun. 2026 1",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:01",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:24:57"
          },
          {
            "ticket_id": 20003,
            "ticket_number": "3519991",
            "title": "Criação de processo File 442770/26",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:12",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:25:28"
          },
          {
            "ticket_id": 20005,
            "ticket_number": "3519993",
            "title": "GBN-126788 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:19",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:04:19"
          },
          {
            "ticket_id": 20010,
            "ticket_number": "3519998",
            "title": "Personalize o seu espaço cntravel",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:30",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 16.47,
            "sla_met": false,
            "sla_breach_hours": 12.47,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:33:01"
          },
          {
            "ticket_id": 20011,
            "ticket_number": "3519999",
            "title": "Pagamento da reserva – Ref PP991832, Sr. Jose Afon",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:32",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:26:31"
          },
          {
            "ticket_id": 20013,
            "ticket_number": "3520001",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:36",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:26:47"
          },
          {
            "ticket_id": 20015,
            "ticket_number": "3520003",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:41",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:27:54"
          },
          {
            "ticket_id": 20017,
            "ticket_number": "3520005",
            "title": "Cancellation of the booking with locator 94Q95W81",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:45",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:28:11"
          },
          {
            "ticket_id": 20019,
            "ticket_number": "3520007",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:49",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:28:30"
          },
          {
            "ticket_id": 20020,
            "ticket_number": "3520008",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:51",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:28:35"
          },
          {
            "ticket_id": 20021,
            "ticket_number": "3520009",
            "title": "Envio de documentação - FILE 442679",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:00",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:29:29"
          },
          {
            "ticket_id": 20022,
            "ticket_number": "3520010",
            "title": "Documentação da reserva TTN-1253040658#103665545#T",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:06",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:23:34"
          },
          {
            "ticket_id": 20023,
            "ticket_number": "3520011",
            "title": "Documentação da reserva TTN-1253040658#103664988#T",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:14",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:30:39"
          },
          {
            "ticket_id": 20024,
            "ticket_number": "3520012",
            "title": "RE: [Cockpit] Viagem TRP-2026-05342 - LUISA",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:16",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:05:16"
          },
          {
            "ticket_id": 20025,
            "ticket_number": "3520013",
            "title": "Credenciais Vila Gale - urgente pff",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:47",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:05:47"
          },
          {
            "ticket_id": 20026,
            "ticket_number": "3520014",
            "title": "Contacto - Perguntas frequentes da atividade (A375",
            "priority": "P2",
            "created_at": "01/06/2026 19:05:48",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 21:31:56"
          },
          {
            "ticket_id": 20031,
            "ticket_number": "3520019",
            "title": "MSC Cruises Document - 2600101003850578",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:35",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:23:29"
          },
          {
            "ticket_id": 20032,
            "ticket_number": "3520020",
            "title": "MSC Cruises Document - 2600101003850579",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:37",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:23:50"
          },
          {
            "ticket_id": 20034,
            "ticket_number": "3520022",
            "title": "Saídas de 02/07/2026 para 06/08/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:40",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:20:36"
          },
          {
            "ticket_id": 20036,
            "ticket_number": "3520024",
            "title": "MSC Cruises Document - 2600101003850577",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:44",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:12:15"
          },
          {
            "ticket_id": 20038,
            "ticket_number": "3520026",
            "title": "IFTHENPAY - Pagamento Efetuado: ID 636f1cd611c047f",
            "priority": "P2",
            "created_at": "02/06/2026 09:07:54",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:12:24"
          },
          {
            "ticket_id": 20040,
            "ticket_number": "3520028",
            "title": "GBN-126836 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:00",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:08:00"
          },
          {
            "ticket_id": 20043,
            "ticket_number": "3520031",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:06",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:14:58"
          },
          {
            "ticket_id": 20046,
            "ticket_number": "3520034",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:16",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:08:16"
          },
          {
            "ticket_id": 20047,
            "ticket_number": "3520035",
            "title": "GBN-126491 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:18",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:22:30"
          },
          {
            "ticket_id": 20048,
            "ticket_number": "3520036",
            "title": "Confirmação de reserva com localizador: 4245951",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:21",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:15:17"
          },
          {
            "ticket_id": 20049,
            "ticket_number": "3520037",
            "title": "GBN-126820 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:26",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:08:26"
          },
          {
            "ticket_id": 20050,
            "ticket_number": "3520038",
            "title": "GBN-126491 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:22:39"
          },
          {
            "ticket_id": 20051,
            "ticket_number": "3520039",
            "title": "Cobrança Diária - 01/06/2026 - UMA FAMILIA EM VIAG",
            "priority": "P2",
            "created_at": "02/06/2026 09:09:04",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:31:15"
          },
          {
            "ticket_id": 20053,
            "ticket_number": "3520041",
            "title": "Confirmação de reserva com localizador: 4245866",
            "priority": "P2",
            "created_at": "02/06/2026 09:09:07",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:15:37"
          },
          {
            "ticket_id": 20054,
            "ticket_number": "3520042",
            "title": "Mensagem sobre a reserva 38385142 - Civitatis",
            "priority": "P2",
            "created_at": "02/06/2026 09:10:03",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:02:17"
          },
          {
            "ticket_id": 20055,
            "ticket_number": "3520043",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "02/06/2026 09:28:10",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:39:50"
          },
          {
            "ticket_id": 20056,
            "ticket_number": "3520044",
            "title": "Cambio de recepción / Front desk change 1275864123",
            "priority": "P2",
            "created_at": "02/06/2026 09:57:45",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:40:27"
          },
          {
            "ticket_id": 20058,
            "ticket_number": "3520046",
            "title": "Cambio de recepción / Front desk change 1235214221",
            "priority": "P2",
            "created_at": "02/06/2026 09:57:49",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:37:47"
          },
          {
            "ticket_id": 20059,
            "ticket_number": "3520047",
            "title": "Cambio de recepción / Front desk change 1238372135",
            "priority": "P2",
            "created_at": "02/06/2026 09:57:51",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:39:33"
          },
          {
            "ticket_id": 20062,
            "ticket_number": "3520050",
            "title": "Madeira | Fim de Ano 2026 🎆",
            "priority": "P2",
            "created_at": "02/06/2026 10:00:15",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:00:53"
          },
          {
            "ticket_id": 20063,
            "ticket_number": "3520051",
            "title": "Confirmação de reserva 341870 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "02/06/2026 10:00:17",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:00:14"
          },
          {
            "ticket_id": 20064,
            "ticket_number": "3520052",
            "title": "Incidente de voo TTN-1223362854#102788199#T2025707",
            "priority": "P2",
            "created_at": "02/06/2026 10:11:49",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:59:56"
          },
          {
            "ticket_id": 20068,
            "ticket_number": "3520056",
            "title": "PaymentCard Uma Família em Viagem-1099776",
            "priority": "P2",
            "created_at": "02/06/2026 10:38:54",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:45:15"
          },
          {
            "ticket_id": 20069,
            "ticket_number": "3520057",
            "title": "Informações da reserva TTN-1223362854#103735730#T2",
            "priority": "P2",
            "created_at": "02/06/2026 10:38:59",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 11:04:30"
          },
          {
            "ticket_id": 20070,
            "ticket_number": "3520058",
            "title": "PaymentCard Uma Família em Viagem-1099774",
            "priority": "P2",
            "created_at": "02/06/2026 10:39:02",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:45:30"
          },
          {
            "ticket_id": 20071,
            "ticket_number": "3520059",
            "title": "[Suporte] TRP-2026-05363 - Mudança de Apelido",
            "priority": "P2",
            "created_at": "02/06/2026 10:44:37",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:44:38"
          },
          {
            "ticket_id": 20073,
            "ticket_number": "3520061",
            "title": "GBN-118066 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/06/2026 11:07:59",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:12:15"
          },
          {
            "ticket_id": 20078,
            "ticket_number": "3520066",
            "title": "Confirmação de reserva com localizador: 4246766",
            "priority": "P2",
            "created_at": "02/06/2026 11:24:36",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:02:54"
          },
          {
            "ticket_id": 20082,
            "ticket_number": "3520070",
            "title": "COMUNICADO – LOCAIS DE EMBARQUE",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:40",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:04:39"
          },
          {
            "ticket_id": 20083,
            "ticket_number": "3520071",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:11:47"
          },
          {
            "ticket_id": 20085,
            "ticket_number": "3520073",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:46",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:33:26"
          },
          {
            "ticket_id": 20086,
            "ticket_number": "3520074",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:49",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:30:39"
          },
          {
            "ticket_id": 20087,
            "ticket_number": "3520075",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:51",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:26:21"
          },
          {
            "ticket_id": 20090,
            "ticket_number": "3520078",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:21",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:39:55"
          },
          {
            "ticket_id": 20092,
            "ticket_number": "3520080",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:25",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:41:24"
          },
          {
            "ticket_id": 20093,
            "ticket_number": "3520081",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:40:10"
          },
          {
            "ticket_id": 20094,
            "ticket_number": "3520082",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:31",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:41:24"
          },
          {
            "ticket_id": 20095,
            "ticket_number": "3520083",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:34",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:41:24"
          },
          {
            "ticket_id": 20096,
            "ticket_number": "3520084",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:38",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:41:24"
          },
          {
            "ticket_id": 20097,
            "ticket_number": "3520085",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:40",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:16:51"
          },
          {
            "ticket_id": 20099,
            "ticket_number": "3520087",
            "title": "Assunto: Comunicação Importante: Bilhete de Identi",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:44",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:44:45"
          },
          {
            "ticket_id": 20100,
            "ticket_number": "3520088",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:46",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:40:34"
          },
          {
            "ticket_id": 20101,
            "ticket_number": "3520089",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:49",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:40:43"
          },
          {
            "ticket_id": 20102,
            "ticket_number": "3520090",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:52",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:40:21"
          },
          {
            "ticket_id": 20103,
            "ticket_number": "3520091",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:54",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:47:13"
          },
          {
            "ticket_id": 20104,
            "ticket_number": "3520092",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:56",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:48:13"
          },
          {
            "ticket_id": 20105,
            "ticket_number": "3520093",
            "title": "Assunto: Comunicação Importante: Bilhete de Identi",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:58",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:44:45"
          },
          {
            "ticket_id": 20106,
            "ticket_number": "3520094",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:50:00",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:48:48"
          },
          {
            "ticket_id": 20109,
            "ticket_number": "3520097",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 13:11:25",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:17:08"
          },
          {
            "ticket_id": 20110,
            "ticket_number": "3520098",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 13:11:30",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:11:30"
          },
          {
            "ticket_id": 20116,
            "ticket_number": "3520104",
            "title": "GBN-126792 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/06/2026 15:39:55",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 15:40:35"
          },
          {
            "ticket_id": 20123,
            "ticket_number": "3520111",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:13",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:32:13"
          },
          {
            "ticket_id": 20124,
            "ticket_number": "3520112",
            "title": "KOALA TRAVEL LAB *** Programação Geral ***",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:15",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:48:53"
          },
          {
            "ticket_id": 20125,
            "ticket_number": "3520113",
            "title": "Fwd: Resultados da Flexible Autos //// Uma família",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:20",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:32:21"
          },
          {
            "ticket_id": 20126,
            "ticket_number": "3520114",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:32:29"
          },
          {
            "ticket_id": 20127,
            "ticket_number": "3520115",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:33",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:57:47"
          },
          {
            "ticket_id": 20128,
            "ticket_number": "3520116",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:37",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:32:37"
          },
          {
            "ticket_id": 20129,
            "ticket_number": "3520117",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:32:43",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:32:43"
          },
          {
            "ticket_id": 20131,
            "ticket_number": "3520119",
            "title": "Documentação Disponível - Reserva 345701",
            "priority": "P2",
            "created_at": "02/06/2026 16:33:09",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:48:30"
          },
          {
            "ticket_id": 20132,
            "ticket_number": "3520120",
            "title": "VOUCHER DA RESERVA 604546339",
            "priority": "P2",
            "created_at": "02/06/2026 16:33:12",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:11:37"
          },
          {
            "ticket_id": 20134,
            "ticket_number": "3520122",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:33:19",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:33:19"
          },
          {
            "ticket_id": 20136,
            "ticket_number": "3520124",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:35:12",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:35:12"
          },
          {
            "ticket_id": 20137,
            "ticket_number": "3520125",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:36:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:36:42"
          },
          {
            "ticket_id": 20138,
            "ticket_number": "3520126",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:48:12",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:48:12"
          },
          {
            "ticket_id": 20139,
            "ticket_number": "3520127",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 16:53:56",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:53:56"
          },
          {
            "ticket_id": 20141,
            "ticket_number": "3520129",
            "title": "Declined: Sessão Flexible Autos",
            "priority": "P2",
            "created_at": "02/06/2026 16:54:08",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:58:15"
          },
          {
            "ticket_id": 20142,
            "ticket_number": "3520130",
            "title": "Notificação de autorização File 432293/26",
            "priority": "P2",
            "created_at": "02/06/2026 16:54:13",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:50:31"
          },
          {
            "ticket_id": 20145,
            "ticket_number": "3520133",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 17:38:55",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 18:02:19"
          },
          {
            "ticket_id": 20146,
            "ticket_number": "3520134",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 17:38:58",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:38:58"
          },
          {
            "ticket_id": 20147,
            "ticket_number": "3520135",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 17:39:07",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:39:07"
          },
          {
            "ticket_id": 20148,
            "ticket_number": "3520136",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 17:39:16",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:39:17"
          },
          {
            "ticket_id": 20151,
            "ticket_number": "3520139",
            "title": "Pagamento da reserva – Ref PP594874, Sr. Claudio S",
            "priority": "P2",
            "created_at": "02/06/2026 18:04:13",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 18:06:10"
          },
          {
            "ticket_id": 20152,
            "ticket_number": "3520140",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "02/06/2026 18:04:21",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 18:29:22"
          },
          {
            "ticket_id": 20155,
            "ticket_number": "3520143",
            "title": "Envio de documentação File 432293/26",
            "priority": "P2",
            "created_at": "02/06/2026 18:23:59",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 18:37:22"
          },
          {
            "ticket_id": 20163,
            "ticket_number": "3520151",
            "title": "Informação sobre voo SP1404 flight information",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:31",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 21:55:05"
          },
          {
            "ticket_id": 20164,
            "ticket_number": "3520152",
            "title": "Pedido de acessos ao Hotel Vila Galé",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:33",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 21:52:33"
          },
          {
            "ticket_id": 20177,
            "ticket_number": "3520165",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:02",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.47,
            "sla_met": false,
            "sla_breach_hours": 7.47,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:21:33"
          },
          {
            "ticket_id": 20186,
            "ticket_number": "3520174",
            "title": "Informações da reserva TTN-1287530622#103851835#T2",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:46",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.48,
            "sla_met": false,
            "sla_breach_hours": 7.48,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:23:06"
          },
          {
            "ticket_id": 20187,
            "ticket_number": "3520175",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:48",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.48,
            "sla_met": false,
            "sla_breach_hours": 7.48,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:23:13"
          },
          {
            "ticket_id": 20191,
            "ticket_number": "3520179",
            "title": "Criação de processo File 442894/26",
            "priority": "Reservas sem Formulário",
            "created_at": "02/06/2026 22:13:31",
            "close_date": "2026-06-03",
            "sla_target_hours": 24,
            "actual_time_hours": 11.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/06/2026 09:48:07"
          },
          {
            "ticket_id": 20253,
            "ticket_number": "3520241",
            "title": "Faturas Pendentes: FA 2147917301",
            "priority": "P2",
            "created_at": "03/06/2026 13:05:07",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:28:49"
          },
          {
            "ticket_id": 20260,
            "ticket_number": "3520248",
            "title": "GBN-101841 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:29",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 14:34:43"
          },
          {
            "ticket_id": 20261,
            "ticket_number": "3520249",
            "title": "NOVO INCIDENTE: Amadeus Central Reservation: Edito",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:32",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 14:40:48"
          },
          {
            "ticket_id": 20264,
            "ticket_number": "3520252",
            "title": "Solole. Booking E307X71Y is close to entering expe",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:40",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:29:03"
          },
          {
            "ticket_id": 20265,
            "ticket_number": "3520253",
            "title": "NOVO INCIDENTE: Amadeus Central Reservation: Edito",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:41",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 14:40:57"
          },
          {
            "ticket_id": 20266,
            "ticket_number": "3520254",
            "title": "Solole. Booking HKCGBYQ9 is close to entering expe",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:44",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:29:11"
          },
          {
            "ticket_id": 20267,
            "ticket_number": "3520255",
            "title": "Informações da reserva TTN-1251310178#103947903#T2",
            "priority": "P2",
            "created_at": "03/06/2026 14:55:28",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:28:16"
          },
          {
            "ticket_id": 20268,
            "ticket_number": "3520256",
            "title": "NOVO INCIDENTE: Amadeus Central Reservation: Edito",
            "priority": "P2",
            "created_at": "03/06/2026 14:55:31",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:26:11"
          },
          {
            "ticket_id": 20270,
            "ticket_number": "3520258",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "03/06/2026 14:55:42",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:32:25"
          },
          {
            "ticket_id": 20271,
            "ticket_number": "3520259",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "03/06/2026 14:55:45",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:33:32"
          },
          {
            "ticket_id": 20273,
            "ticket_number": "3520261",
            "title": "Informações da reserva TTN-1251310178#103916445#T2",
            "priority": "P2",
            "created_at": "03/06/2026 14:57:00",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:28:27"
          },
          {
            "ticket_id": 20276,
            "ticket_number": "3520264",
            "title": "Informações da reserva TTN-1251310178#103949908#T2",
            "priority": "P2",
            "created_at": "03/06/2026 15:42:14",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 16:49:58"
          },
          {
            "ticket_id": 20287,
            "ticket_number": "3520275",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 17:20:54",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:20:54"
          },
          {
            "ticket_id": 20289,
            "ticket_number": "3520277",
            "title": "GBN-122993 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/06/2026 17:39:56",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:40:17"
          },
          {
            "ticket_id": 20291,
            "ticket_number": "3520279",
            "title": "Aumento Fuel OPO DJE - 27JUN26 * File 434925",
            "priority": "P2",
            "created_at": "03/06/2026 17:49:00",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:53:07"
          },
          {
            "ticket_id": 20294,
            "ticket_number": "3520282",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 17:49:15",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:49:15"
          },
          {
            "ticket_id": 20295,
            "ticket_number": "3520283",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "03/06/2026 17:49:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:49:31"
          },
          {
            "ticket_id": 20297,
            "ticket_number": "3520285",
            "title": "Documentação Disponível - Reserva 333975",
            "priority": "P2",
            "created_at": "03/06/2026 17:49:28",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:50:59"
          },
          {
            "ticket_id": 20302,
            "ticket_number": "3520290",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 18:19:10",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 18:19:10"
          },
          {
            "ticket_id": 20304,
            "ticket_number": "3520292",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 18:19:15",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 18:19:15"
          },
          {
            "ticket_id": 20306,
            "ticket_number": "3520294",
            "title": "GBN-127179 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/06/2026 18:19:20",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 18:19:20"
          },
          {
            "ticket_id": 20309,
            "ticket_number": "3520297",
            "title": "CTM-12727 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/06/2026 19:54:52",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 20:57:24"
          },
          {
            "ticket_id": 20310,
            "ticket_number": "3520298",
            "title": "Reserva pagada",
            "priority": "P2",
            "created_at": "03/06/2026 19:54:54",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 39.1,
            "sla_met": false,
            "sla_breach_hours": 35.1,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:01:05"
          },
          {
            "ticket_id": 20311,
            "ticket_number": "3520299",
            "title": "Icárion - Maldivas - Divisão de Estadia (Quartos) ",
            "priority": "P2",
            "created_at": "03/06/2026 19:54:56",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 39.03,
            "sla_met": false,
            "sla_breach_hours": 35.03,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:57:51"
          },
          {
            "ticket_id": 20312,
            "ticket_number": "3520300",
            "title": "Confirmation of booking with locatorMC82E8HW",
            "priority": "P2",
            "created_at": "03/06/2026 19:54:58",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 21:00:51"
          },
          {
            "ticket_id": 20314,
            "ticket_number": "3520302",
            "title": "Confirmation of booking with locatorDPD2GX5Q",
            "priority": "P2",
            "created_at": "03/06/2026 19:55:03",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 21:02:00"
          },
          {
            "ticket_id": 20315,
            "ticket_number": "3520303",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "03/06/2026 19:55:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 39.1,
            "sla_met": false,
            "sla_breach_hours": 35.1,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:01:29"
          },
          {
            "ticket_id": 20318,
            "ticket_number": "3520306",
            "title": "Número de informação da reserva: 6149184",
            "priority": "P2",
            "created_at": "03/06/2026 20:49:27",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 37.83,
            "sla_met": false,
            "sla_breach_hours": 33.83,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:40:10"
          },
          {
            "ticket_id": 20322,
            "ticket_number": "3520310",
            "title": "Cotur Portugal: 1 serviços falharam na reserva CTM",
            "priority": "P2",
            "created_at": "03/06/2026 22:18:37",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 35.33,
            "sla_met": false,
            "sla_breach_hours": 31.33,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:38:48"
          },
          {
            "ticket_id": 20323,
            "ticket_number": "3520311",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "03/06/2026 22:18:40",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 35.33,
            "sla_met": false,
            "sla_breach_hours": 31.33,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:39:03"
          },
          {
            "ticket_id": 20326,
            "ticket_number": "3520314",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "03/06/2026 22:44:12",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 36.28,
            "sla_met": false,
            "sla_breach_hours": 32.28,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:02:11"
          },
          {
            "ticket_id": 20327,
            "ticket_number": "3520315",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "03/06/2026 22:44:15",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 36.3,
            "sla_met": false,
            "sla_breach_hours": 32.3,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:02:44"
          },
          {
            "ticket_id": 20328,
            "ticket_number": "3520316",
            "title": "Cotur Portugal: 1 serviços falharam na reserva CTM",
            "priority": "P2",
            "created_at": "03/06/2026 22:44:18",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 36.32,
            "sla_met": false,
            "sla_breach_hours": 32.32,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:04:04"
          },
          {
            "ticket_id": 20341,
            "ticket_number": "3520329",
            "title": "XMXZRL – Alteração de horario/nº de voo",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:19",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:55:42"
          },
          {
            "ticket_id": 20344,
            "ticket_number": "3520332",
            "title": "Cancelação da reserva com localizador 6V9F70FF30",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:27",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:56:22"
          },
          {
            "ticket_id": 20345,
            "ticket_number": "3520333",
            "title": "Cancelação da reserva com localizador 3AKWTU0P92",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:56:47"
          },
          {
            "ticket_id": 20346,
            "ticket_number": "3520334",
            "title": "A37302036 - IMPORTANTE - Civitatis - Tour pela ilh",
            "priority": "P2",
            "created_at": "05/06/2026 09:03:44",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:19:37"
          },
          {
            "ticket_id": 20353,
            "ticket_number": "3520341",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604595633",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:05",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:59:03"
          },
          {
            "ticket_id": 20355,
            "ticket_number": "3520343",
            "title": "Saídas de 04/07/2026 para 08/08/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:13",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:20:39"
          },
          {
            "ticket_id": 20358,
            "ticket_number": "3520346",
            "title": "Incidente de voo TTN-1239441414#104005837#T2061828",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:19",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:00:01"
          },
          {
            "ticket_id": 20359,
            "ticket_number": "3520347",
            "title": "Cotur Portugal: Fallo en 2 servicios en la reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:21",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:06:38"
          },
          {
            "ticket_id": 20361,
            "ticket_number": "3520349",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Información",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:44:08"
          },
          {
            "ticket_id": 20365,
            "ticket_number": "3520353",
            "title": "Actualización de su reserva / Update to your booki",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:38",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:00:37"
          },
          {
            "ticket_id": 20366,
            "ticket_number": "3520354",
            "title": "Alterações na sua reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:40",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:01:37"
          },
          {
            "ticket_id": 20367,
            "ticket_number": "3520355",
            "title": "Incidente de voo TTN-1284195044#104005839#T2061828",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:43",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:02:04"
          },
          {
            "ticket_id": 20368,
            "ticket_number": "3520356",
            "title": "RECUPERADO: Amadeus Central Reservation: Retorno P",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:37:11"
          },
          {
            "ticket_id": 20369,
            "ticket_number": "3520357",
            "title": "RECUPERADO: Amadeus Central Reservation: Retorno P",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:46",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:37:04"
          },
          {
            "ticket_id": 20376,
            "ticket_number": "3520364",
            "title": "Confirmacao 346315",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:31",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:51:55"
          },
          {
            "ticket_id": 20379,
            "ticket_number": "3520367",
            "title": "Confirmación de reserva 99127749",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:41:06"
          },
          {
            "ticket_id": 20383,
            "ticket_number": "3520371",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:06:14"
          },
          {
            "ticket_id": 20386,
            "ticket_number": "3520374",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:21:42"
          },
          {
            "ticket_id": 20394,
            "ticket_number": "3520382",
            "title": "CTM-12737 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:51:35"
          },
          {
            "ticket_id": 20397,
            "ticket_number": "3520385",
            "title": "Cotur Portugal: 1 serviços falharam na reserva CTM",
            "priority": "P2",
            "created_at": "05/06/2026 09:58:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:23:23"
          },
          {
            "ticket_id": 20401,
            "ticket_number": "3520389",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:04",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:07:45"
          },
          {
            "ticket_id": 20413,
            "ticket_number": "3520401",
            "title": "[Cancelamento Serviço] TRP-2026-05158 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/06/2026 11:00:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:00:49"
          },
          {
            "ticket_id": 20419,
            "ticket_number": "3520407",
            "title": "[Suporte] TRP-2026-03308 / TRL-2026-05093 - Fatura",
            "priority": "P2",
            "created_at": "05/06/2026 11:35:10",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:35:10"
          },
          {
            "ticket_id": 20425,
            "ticket_number": "3520413",
            "title": "[VIAJES OLYMPIA] Asunto: Pagamento A26X005590X01",
            "priority": "P2",
            "created_at": "05/06/2026 11:53:07",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:40:55"
          },
          {
            "ticket_id": 20427,
            "ticket_number": "3520415",
            "title": "* File 435734 * nova  alteração de horário voo CDG",
            "priority": "P2",
            "created_at": "05/06/2026 12:49:09",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:56:56"
          },
          {
            "ticket_id": 20431,
            "ticket_number": "3520419",
            "title": "Cotur Portugal: 1 serviços falharam na reserva CTM",
            "priority": "P2",
            "created_at": "05/06/2026 13:18:58",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 14:18:52"
          },
          {
            "ticket_id": 20435,
            "ticket_number": "3520423",
            "title": "GBN-111630 - Alteração n° de passaporte",
            "priority": "P2",
            "created_at": "05/06/2026 14:15:30",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 14:15:30"
          },
          {
            "ticket_id": 20446,
            "ticket_number": "3520434",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:46",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 6.15,
            "sla_met": false,
            "sla_breach_hours": 2.15,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 21:49:53"
          },
          {
            "ticket_id": 20492,
            "ticket_number": "3520480",
            "title": "Reserva Aérea ZGF8TP",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:10",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:12:14"
          },
          {
            "ticket_id": 20493,
            "ticket_number": "3520481",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:12",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:12:28"
          },
          {
            "ticket_id": 20494,
            "ticket_number": "3520482",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:12:35"
          },
          {
            "ticket_id": 20513,
            "ticket_number": "3520501",
            "title": "Aéreo - Confirmação de Emissão (CARDOSO\\JOSE) - ZG",
            "priority": "P2",
            "created_at": "05/06/2026 18:00:55",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:10:42"
          },
          {
            "ticket_id": 20518,
            "ticket_number": "3520506",
            "title": "[Cancelamento Serviço] TRP-2026-05187 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/06/2026 19:14:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 19:14:15"
          },
          {
            "ticket_id": 20520,
            "ticket_number": "3520508",
            "title": "Re: [Cockpit] Viagem TRP-2026-04515 - Viagem a Mál",
            "priority": "P2",
            "created_at": "05/06/2026 21:02:56",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 21:02:56"
          },
          {
            "ticket_id": 20526,
            "ticket_number": "3520514",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:07:03"
          },
          {
            "ticket_id": 20527,
            "ticket_number": "3520515",
            "title": "Confirmação de reserva com localizador: 4253885",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:10",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:07:11"
          },
          {
            "ticket_id": 20528,
            "ticket_number": "3520516",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:12",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:07:59"
          },
          {
            "ticket_id": 20529,
            "ticket_number": "3520517",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:08:47"
          },
          {
            "ticket_id": 20531,
            "ticket_number": "3520519",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:28",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:10:02"
          },
          {
            "ticket_id": 20535,
            "ticket_number": "3520523",
            "title": "Informações da reserva TTN-1288767551#104260762#T2",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:41",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:12:23"
          },
          {
            "ticket_id": 20539,
            "ticket_number": "3520527",
            "title": "[Cancelamento Serviço] TRP-2026-05379 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/06/2026 22:44:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:44:22"
          },
          {
            "ticket_id": 20582,
            "ticket_number": "3520570",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:12",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:15:48"
          },
          {
            "ticket_id": 20583,
            "ticket_number": "3520571",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604614469",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:14",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:17:14"
          },
          {
            "ticket_id": 20586,
            "ticket_number": "3520574",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604614469",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:23",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:36:22"
          },
          {
            "ticket_id": 20587,
            "ticket_number": "3520575",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604614471",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:24",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:37:53"
          },
          {
            "ticket_id": 20588,
            "ticket_number": "3520576",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604614471",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:26",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:39:11"
          },
          {
            "ticket_id": 20589,
            "ticket_number": "3520577",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:28",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:18:23"
          },
          {
            "ticket_id": 20591,
            "ticket_number": "3520579",
            "title": "Familia em Viagem informa-te do teu orçamento 1289",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:32",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:18:36"
          },
          {
            "ticket_id": 20592,
            "ticket_number": "3520580",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:36",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:18:50"
          },
          {
            "ticket_id": 20594,
            "ticket_number": "3520582",
            "title": "Número de informação da reserva: 6149423",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:42",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:40:34"
          },
          {
            "ticket_id": 20597,
            "ticket_number": "3520585",
            "title": "CTM-12768 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:48",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:20:17"
          },
          {
            "ticket_id": 20600,
            "ticket_number": "3520588",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "08/06/2026 09:05:56",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:20:46"
          },
          {
            "ticket_id": 20602,
            "ticket_number": "3520590",
            "title": "w2m.travel: Payment confirmation '52NNNH'",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:01",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:21:24"
          },
          {
            "ticket_id": 20604,
            "ticket_number": "3520592",
            "title": "Proforma CnTravel 93131612",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:06",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:42:33"
          },
          {
            "ticket_id": 20605,
            "ticket_number": "3520593",
            "title": "Familia em Viagem informa-te do teu orçamento 1289",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:08",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:22:20"
          },
          {
            "ticket_id": 20606,
            "ticket_number": "3520594",
            "title": "w2m.travel: Confirmación reserva '52NNNH'",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:10",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:22:32"
          },
          {
            "ticket_id": 20608,
            "ticket_number": "3520596",
            "title": "Confirmación de reserva 93131612",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:15",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:22:53"
          },
          {
            "ticket_id": 20611,
            "ticket_number": "3520599",
            "title": "Reserva confirmada: Excursão de 2 dias ao deserto ",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:48",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:44:08"
          },
          {
            "ticket_id": 20613,
            "ticket_number": "3520601",
            "title": "Reserva confirmada: Excursão de 2 dias ao deserto ",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:52",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:44:18"
          },
          {
            "ticket_id": 20615,
            "ticket_number": "3520603",
            "title": "Criação de processo File 443246/26",
            "priority": "P2",
            "created_at": "08/06/2026 09:06:59",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:25:47"
          },
          {
            "ticket_id": 20616,
            "ticket_number": "3520604",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/06/2026 09:07:01",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:26:03"
          },
          {
            "ticket_id": 20618,
            "ticket_number": "3520606",
            "title": "Fwd: Confirmação da sua reserva NG2M2F - LIS-PMI 0",
            "priority": "P2",
            "created_at": "08/06/2026 09:07:05",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:07:06"
          },
          {
            "ticket_id": 20620,
            "ticket_number": "3520608",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "08/06/2026 09:07:10",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:26:39"
          },
          {
            "ticket_id": 20621,
            "ticket_number": "3520609",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "08/06/2026 09:07:12",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:26:44"
          },
          {
            "ticket_id": 20623,
            "ticket_number": "3520611",
            "title": "Confirmação de reserva com localizador: 4254706",
            "priority": "P2",
            "created_at": "08/06/2026 09:07:17",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:27:03"
          },
          {
            "ticket_id": 20624,
            "ticket_number": "3520612",
            "title": "Confirmacao 346382",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:18",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:27:19"
          },
          {
            "ticket_id": 20625,
            "ticket_number": "3520613",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:23",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:27:31"
          },
          {
            "ticket_id": 20626,
            "ticket_number": "3520614",
            "title": "CTM-12764 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:30",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:27:42"
          },
          {
            "ticket_id": 20627,
            "ticket_number": "3520615",
            "title": "CTM-12765 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:36",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:27:52"
          },
          {
            "ticket_id": 20628,
            "ticket_number": "3520616",
            "title": "Confirmação de reserva com localizador: 4254696",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:40",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:28:01"
          },
          {
            "ticket_id": 20629,
            "ticket_number": "3520617",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:43",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:28:14"
          },
          {
            "ticket_id": 20630,
            "ticket_number": "3520618",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:49",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:28:26"
          },
          {
            "ticket_id": 20633,
            "ticket_number": "3520621",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:55",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:29:01"
          },
          {
            "ticket_id": 20634,
            "ticket_number": "3520622",
            "title": "Código para cerrar reserva a Mayna",
            "priority": "P2",
            "created_at": "08/06/2026 09:08:58",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:46:50"
          },
          {
            "ticket_id": 20635,
            "ticket_number": "3520623",
            "title": "Recepção de Pagamento -  (Recibo-2147854439)",
            "priority": "P2",
            "created_at": "08/06/2026 09:09:00",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:49:15"
          },
          {
            "ticket_id": 20637,
            "ticket_number": "3520625",
            "title": "CTM-12763 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 09:09:06",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:30:03"
          },
          {
            "ticket_id": 20638,
            "ticket_number": "3520626",
            "title": "CTM-12762 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 09:09:09",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:30:16"
          },
          {
            "ticket_id": 20639,
            "ticket_number": "3520627",
            "title": "Confirmação de reserva com localizador: 4254596",
            "priority": "P2",
            "created_at": "08/06/2026 09:09:12",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:30:26"
          },
          {
            "ticket_id": 20640,
            "ticket_number": "3520628",
            "title": "Número de informação da reserva: 6149368",
            "priority": "P2",
            "created_at": "08/06/2026 09:09:20",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:49:32"
          },
          {
            "ticket_id": 20642,
            "ticket_number": "3520630",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "08/06/2026 09:11:51",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:30:45"
          },
          {
            "ticket_id": 20643,
            "ticket_number": "3520631",
            "title": "CTM-12757 - Um cliente enviou uma nova solicitação",
            "priority": "P2",
            "created_at": "08/06/2026 09:11:53",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:23:34"
          },
          {
            "ticket_id": 20645,
            "ticket_number": "3520633",
            "title": "CTM-12757 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "08/06/2026 09:11:56",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:15:42"
          },
          {
            "ticket_id": 20646,
            "ticket_number": "3520634",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "08/06/2026 09:11:59",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:31:00"
          },
          {
            "ticket_id": 20648,
            "ticket_number": "3520636",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "08/06/2026 09:37:41",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:37:41"
          },
          {
            "ticket_id": 20653,
            "ticket_number": "3520641",
            "title": "Informação importante sobre a tua reserva 6119682",
            "priority": "P2",
            "created_at": "08/06/2026 10:06:14",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:50:55"
          },
          {
            "ticket_id": 20654,
            "ticket_number": "3520642",
            "title": "Informação importante sobre a tua reserva 6120795",
            "priority": "P2",
            "created_at": "08/06/2026 10:06:16",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:51:00"
          },
          {
            "ticket_id": 20656,
            "ticket_number": "3520644",
            "title": "Informação importante sobre a tua reserva 6120803",
            "priority": "P2",
            "created_at": "08/06/2026 10:06:19",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:51:21"
          },
          {
            "ticket_id": 20657,
            "ticket_number": "3520645",
            "title": "Confirmação de reserva para For PT004157 72580901",
            "priority": "P2",
            "created_at": "08/06/2026 10:06:21",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:51:33"
          },
          {
            "ticket_id": 20659,
            "ticket_number": "3520647",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "08/06/2026 10:10:22",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:53:00"
          },
          {
            "ticket_id": 20661,
            "ticket_number": "3520649",
            "title": "Documentação Disponível - Reserva 340138",
            "priority": "P2",
            "created_at": "08/06/2026 10:28:44",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:53:18"
          },
          {
            "ticket_id": 20663,
            "ticket_number": "3520651",
            "title": "Eticket - 70869531 - OX  17/06/2026  Lisboa, Portu",
            "priority": "P2",
            "created_at": "08/06/2026 11:30:32",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:51:13"
          },
          {
            "ticket_id": 20664,
            "ticket_number": "3520652",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "08/06/2026 11:30:34",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:51:27"
          },
          {
            "ticket_id": 20665,
            "ticket_number": "3520653",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "08/06/2026 11:30:38",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:51:42"
          },
          {
            "ticket_id": 20666,
            "ticket_number": "3520654",
            "title": "Envio de documentação - FILE 427582",
            "priority": "P2",
            "created_at": "08/06/2026 11:30:51",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:52:17"
          },
          {
            "ticket_id": 20668,
            "ticket_number": "3520656",
            "title": "Eticket - 70685717 - SX  23/06/2026  Pireu, Grécia",
            "priority": "P2",
            "created_at": "08/06/2026 11:31:02",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:53:24"
          },
          {
            "ticket_id": 20669,
            "ticket_number": "3520657",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "08/06/2026 11:31:05",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:31:05"
          },
          {
            "ticket_id": 20671,
            "ticket_number": "3520659",
            "title": "CTM-12770 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "08/06/2026 11:31:32",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:54:06"
          },
          {
            "ticket_id": 20673,
            "ticket_number": "3520661",
            "title": "GBN-118090 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "08/06/2026 11:31:36",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:54:23"
          },
          {
            "ticket_id": 20677,
            "ticket_number": "3520665",
            "title": "Documentação Disponível - Reserva 341296",
            "priority": "P2",
            "created_at": "08/06/2026 11:37:33",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:56:28"
          }
        ]
      },
      "Sandra Reis": {
        "total_tickets": 1112,
        "sla_met": 993,
        "sla_missed": 119,
        "sla_compliance_rate": 89.3,
        "tickets": [
          {
            "ticket_id": 33,
            "ticket_number": "35033",
            "title": "Fwd: Reclamação Serviços de Estadia e transferes R",
            "priority": "P3",
            "created_at": "30/09/2025 09:06:41",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 09:06:41"
          },
          {
            "ticket_id": 34,
            "ticket_number": "35034",
            "title": "Fwd: Reclamação reserva GBN-68391 (pedido de alter",
            "priority": "P3",
            "created_at": "30/09/2025 09:06:42",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 09:06:43"
          },
          {
            "ticket_id": 44,
            "ticket_number": "35044",
            "title": "GBN-83978 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/09/2025 09:22:59",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 28.98,
            "sla_met": false,
            "sla_breach_hours": 4.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/10/2025 14:22:01"
          },
          {
            "ticket_id": 45,
            "ticket_number": "35045",
            "title": "Mensagem sobre a reserva 34120285 - Civitatis",
            "priority": "P3",
            "created_at": "30/09/2025 09:23:01",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 10:04:58"
          },
          {
            "ticket_id": 46,
            "ticket_number": "35046",
            "title": "Re: GBN-82207 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "30/09/2025 09:26:50",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 10:34:03"
          },
          {
            "ticket_id": 49,
            "ticket_number": "35049",
            "title": "Re:[## 19582 ##] GBN-68391 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "30/09/2025 09:40:57",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 09:44:59"
          },
          {
            "ticket_id": 50,
            "ticket_number": "35050",
            "title": "Informação de reserva - SPT002501543106",
            "priority": "P3",
            "created_at": "30/09/2025 10:07:38",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 11:42:19"
          },
          {
            "ticket_id": 51,
            "ticket_number": "35051",
            "title": "Re: Confirmação de reserva 332077 ### TIME LIMIT E",
            "priority": "P2",
            "created_at": "30/09/2025 11:11:22",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 11:37:21"
          },
          {
            "ticket_id": 52,
            "ticket_number": "35052",
            "title": "Pedido de cotação Funchal",
            "priority": "P3",
            "created_at": "30/09/2025 11:11:23",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 11:11:24"
          },
          {
            "ticket_id": 56,
            "ticket_number": "35056",
            "title": "RE: W2M NEXT - Uma Família em Viagem – Daniela Oli",
            "priority": "P3",
            "created_at": "30/09/2025 11:18:04",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 12:30:37"
          },
          {
            "ticket_id": 57,
            "ticket_number": "35057",
            "title": "RE: Pedido de cotação para grupo de 15 pessoas",
            "priority": "P3",
            "created_at": "30/09/2025 11:50:06",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 12:32:43"
          },
          {
            "ticket_id": 62,
            "ticket_number": "35062",
            "title": "Re:[## 21163 ##] GBN-65520 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "30/09/2025 12:59:24",
            "close_date": "2025-10-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 15:55:44"
          },
          {
            "ticket_id": 70,
            "ticket_number": "35069",
            "title": "Información de su solicitud de Grupos",
            "priority": "P3",
            "created_at": "30/09/2025 14:49:03",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 15:48:39"
          },
          {
            "ticket_id": 73,
            "ticket_number": "35072",
            "title": "RE: Pedido de cotação para grupo de 15 pessoas",
            "priority": "P3",
            "created_at": "30/09/2025 15:04:10",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 16:23:46"
          },
          {
            "ticket_id": 83,
            "ticket_number": "35082",
            "title": "RE: Nueva solicitud de Grupos---851879---ZURIQUE",
            "priority": "P3",
            "created_at": "30/09/2025 17:15:57",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 17:56:44"
          },
          {
            "ticket_id": 89,
            "ticket_number": "35088",
            "title": "Re: Proposta de projeto educativo e lúdico para es",
            "priority": "P3",
            "created_at": "30/09/2025 20:22:09",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 20:22:09"
          },
          {
            "ticket_id": 90,
            "ticket_number": "35089",
            "title": "Re: Fwd: [## 21889 ##] GBN-72699 - Seu pedido foi ",
            "priority": "P3",
            "created_at": "30/09/2025 20:22:11",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 20:22:12"
          },
          {
            "ticket_id": 99,
            "ticket_number": "35098",
            "title": "Número de informação da reserva: 6119135",
            "priority": "P3",
            "created_at": "01/10/2025 09:18:47",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 09:22:43"
          },
          {
            "ticket_id": 100,
            "ticket_number": "35099",
            "title": "RE: Reclamação smy loc. 1115650285 / Acompanhament",
            "priority": "P3",
            "created_at": "01/10/2025 09:52:46",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 09:52:46"
          },
          {
            "ticket_id": 102,
            "ticket_number": "35101",
            "title": "Re: \"GBN-73278 - Your request has been received\"",
            "priority": "P1",
            "created_at": "01/10/2025 10:51:51",
            "close_date": "2025-10-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.27,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P1",
            "first_response_at": "01/10/2025 11:08:20"
          },
          {
            "ticket_id": 104,
            "ticket_number": "35103",
            "title": "Questão seguros - INSURE  - Urgente PF",
            "priority": "P3",
            "created_at": "01/10/2025 11:41:55",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 11:41:55"
          },
          {
            "ticket_id": 106,
            "ticket_number": "35105",
            "title": "W2M NEXT - Uma Família em Viagem – Daniela Oliveir",
            "priority": "P3",
            "created_at": "01/10/2025 12:15:09",
            "close_date": "2025-10-01",
            "sla_target_hours": 24,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 14:05:00"
          },
          {
            "ticket_id": 114,
            "ticket_number": "35113",
            "title": "Re:[## 21136 ##] GBN-78064 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "01/10/2025 14:11:39",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 14:16:19"
          },
          {
            "ticket_id": 115,
            "ticket_number": "35114",
            "title": "Re: Fwd: Re: [## 20898 ##] GBN-80761 - Seu pedido ",
            "priority": "P2",
            "created_at": "01/10/2025 14:36:51",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 14:36:51"
          },
          {
            "ticket_id": 116,
            "ticket_number": "35115",
            "title": "RE: Pedido de cotação para grupo de 15 pessoas",
            "priority": "P2",
            "created_at": "01/10/2025 14:36:53",
            "close_date": "2025-10-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 14:56:18"
          },
          {
            "ticket_id": 119,
            "ticket_number": "35118",
            "title": "Re: Fwd: Pedido de cotação grupo de 15 pessoas",
            "priority": "P3",
            "created_at": "01/10/2025 15:49:12",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 15:49:12"
          },
          {
            "ticket_id": 120,
            "ticket_number": "35119",
            "title": "Dados para reservar Voo de 2 a 15 de novembro -   ",
            "priority": "P3",
            "created_at": "01/10/2025 15:49:13",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 15:49:13"
          },
          {
            "ticket_id": 122,
            "ticket_number": "35121",
            "title": "Fwd: 10587365-Cristina La Salete Santos Ferreira",
            "priority": "P2",
            "created_at": "01/10/2025 16:59:17",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 09:06:52"
          },
          {
            "ticket_id": 124,
            "ticket_number": "35123",
            "title": "Confirmação de reserva com localizador: 3925479",
            "priority": "Reservas sem Formulário",
            "created_at": "01/10/2025 18:16:19",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 135.3,
            "sla_met": false,
            "sla_breach_hours": 111.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:34:22"
          },
          {
            "ticket_id": 141,
            "ticket_number": "35140",
            "title": "Fwd: Localizador SPT002501520476",
            "priority": "P2",
            "created_at": "02/10/2025 11:02:31",
            "close_date": "2025-10-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 14:16:30"
          },
          {
            "ticket_id": 144,
            "ticket_number": "35143",
            "title": "Fwd: FW: Informação importante - Voo OPODJE - 30MA",
            "priority": "P3",
            "created_at": "02/10/2025 11:31:27",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/10/2025 12:16:42"
          },
          {
            "ticket_id": 149,
            "ticket_number": "35148",
            "title": "GBN-84388 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/10/2025 12:32:14",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 117.12,
            "sla_met": false,
            "sla_breach_hours": 93.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:39:40"
          },
          {
            "ticket_id": 150,
            "ticket_number": "35149",
            "title": "RE: 851058",
            "priority": "P2",
            "created_at": "02/10/2025 12:32:18",
            "close_date": "2025-10-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 14:18:57"
          },
          {
            "ticket_id": 152,
            "ticket_number": "35151",
            "title": "Pedido de declaração de causa para cancelamento do",
            "priority": "P2",
            "created_at": "02/10/2025 13:58:03",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 14:00:10"
          },
          {
            "ticket_id": 154,
            "ticket_number": "35153",
            "title": "Re:[## 21594 ##] GBN-83188 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/10/2025 15:58:07",
            "close_date": "2025-10-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 15:59:13"
          },
          {
            "ticket_id": 160,
            "ticket_number": "35159",
            "title": "Re:[## 20192 ##] GBN-75991 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/10/2025 17:30:20",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 22.75,
            "sla_met": false,
            "sla_breach_hours": 18.75,
            "sla_name": "SLA P2",
            "first_response_at": "03/10/2025 16:15:51"
          },
          {
            "ticket_id": 169,
            "ticket_number": "35168",
            "title": "GBN-84514 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:08:10",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 95.72,
            "sla_met": false,
            "sla_breach_hours": 71.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 09:51:50"
          },
          {
            "ticket_id": 170,
            "ticket_number": "35169",
            "title": "Informações sobre o operador do Pedido Nº 27628088",
            "priority": "P3",
            "created_at": "03/10/2025 10:13:01",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 5.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 15:21:35"
          },
          {
            "ticket_id": 171,
            "ticket_number": "35170",
            "title": "Fwd: Viagify informa sobre a sua reserva 120690794",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 10:13:03",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/10/2025 10:13:03"
          },
          {
            "ticket_id": 179,
            "ticket_number": "35178",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604469673",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 11:13:56",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 167.35,
            "sla_met": false,
            "sla_breach_hours": 143.35,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 10:35:09"
          },
          {
            "ticket_id": 185,
            "ticket_number": "35184",
            "title": "Re: URGENTE, Nortravel 604299456",
            "priority": "P2",
            "created_at": "03/10/2025 16:04:07",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/10/2025 16:20:33"
          },
          {
            "ticket_id": 187,
            "ticket_number": "35186",
            "title": "GBN-72699 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/10/2025 16:04:10",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 71.05,
            "sla_met": false,
            "sla_breach_hours": 67.05,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 15:07:58"
          },
          {
            "ticket_id": 188,
            "ticket_number": "35187",
            "title": "joana costa GBN-72699 e GBN-84581",
            "priority": "P3",
            "created_at": "03/10/2025 16:04:12",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 16:04:12"
          },
          {
            "ticket_id": 190,
            "ticket_number": "35189",
            "title": "GBN-84581 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/10/2025 16:04:16",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 90.08,
            "sla_met": false,
            "sla_breach_hours": 66.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:09:29"
          },
          {
            "ticket_id": 192,
            "ticket_number": "35191",
            "title": "Reserva Grupo Cabo Verde",
            "priority": "P3",
            "created_at": "03/10/2025 16:04:18",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 16:04:18"
          },
          {
            "ticket_id": 193,
            "ticket_number": "35192",
            "title": "Re:[## 22231 ##] GBN-72699 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/10/2025 16:12:50",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 70.82,
            "sla_met": false,
            "sla_breach_hours": 66.82,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 15:02:45"
          },
          {
            "ticket_id": 201,
            "ticket_number": "35200",
            "title": "GBN-84764 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:10:35",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 25.13,
            "sla_met": false,
            "sla_breach_hours": 1.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:19:24"
          },
          {
            "ticket_id": 202,
            "ticket_number": "35201",
            "title": "GBN-84763 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:10:39",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 25.2,
            "sla_met": false,
            "sla_breach_hours": 1.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:23:14"
          },
          {
            "ticket_id": 203,
            "ticket_number": "35202",
            "title": "GBN-84762 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:10:44",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 25.27,
            "sla_met": false,
            "sla_breach_hours": 1.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:27:35"
          },
          {
            "ticket_id": 208,
            "ticket_number": "35207",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:05",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 25.43,
            "sla_met": false,
            "sla_breach_hours": 1.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:37:33"
          },
          {
            "ticket_id": 210,
            "ticket_number": "35209",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:12",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/10/2025 09:11:21"
          },
          {
            "ticket_id": 211,
            "ticket_number": "35210",
            "title": "GBN-84719 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 09:11:15",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 25.52,
            "sla_met": false,
            "sla_breach_hours": 1.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:43:00"
          },
          {
            "ticket_id": 220,
            "ticket_number": "35219",
            "title": "Envio (Recibo-2147810575)",
            "priority": "P3",
            "created_at": "06/10/2025 09:59:09",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 15:43:29"
          },
          {
            "ticket_id": 223,
            "ticket_number": "35222",
            "title": "Re: Re: Envio (Factura-2147866156) (#2563022)",
            "priority": "P2",
            "created_at": "06/10/2025 10:00:16",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 11:19:44"
          },
          {
            "ticket_id": 228,
            "ticket_number": "35227",
            "title": "GBN-84750 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 10:12:35",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.63,
            "sla_met": false,
            "sla_breach_hours": 0.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:51:12"
          },
          {
            "ticket_id": 230,
            "ticket_number": "35229",
            "title": "Acompanhamento da gestão do seu dossier com o núme",
            "priority": "P3",
            "created_at": "06/10/2025 10:23:47",
            "close_date": "2025-10-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 11:19:42"
          },
          {
            "ticket_id": 238,
            "ticket_number": "35237",
            "title": "GBN-65990 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/10/2025 11:13:50",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 14:07:41"
          },
          {
            "ticket_id": 239,
            "ticket_number": "35238",
            "title": "Re: Reclamação Transfer GBN-80761",
            "priority": "P2",
            "created_at": "06/10/2025 11:29:12",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 11:29:12"
          },
          {
            "ticket_id": 247,
            "ticket_number": "35246",
            "title": "GBN-83305 - RGPD",
            "priority": "P3",
            "created_at": "06/10/2025 14:08:48",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 14:08:48"
          },
          {
            "ticket_id": 250,
            "ticket_number": "35249",
            "title": "Informação de reserva - SPT002501544719",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 14:39:43",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 20.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:54:15"
          },
          {
            "ticket_id": 255,
            "ticket_number": "35254",
            "title": "Informação de reserva - SPT002501544760",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 17:41:23",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 16.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 263,
            "ticket_number": "35262",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 19:09:30",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 266,
            "ticket_number": "35265",
            "title": "Pagamento da reserva – Ref PP238250, Sra. Carla Li",
            "priority": "P3",
            "created_at": "06/10/2025 19:09:47",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 267,
            "ticket_number": "35266",
            "title": "Re: Fwd: [## 21897 ##] GBN-77744 - Seu pedido foi ",
            "priority": "P2",
            "created_at": "06/10/2025 19:37:59",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 15:57:38"
          },
          {
            "ticket_id": 279,
            "ticket_number": "35278",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:55:18",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 93.38,
            "sla_met": false,
            "sla_breach_hours": 69.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 20:18:36"
          },
          {
            "ticket_id": 297,
            "ticket_number": "35296",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 12:16:05",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 147.15,
            "sla_met": false,
            "sla_breach_hours": 123.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 15:25:46"
          },
          {
            "ticket_id": 298,
            "ticket_number": "35297",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604299456",
            "priority": "P2",
            "created_at": "07/10/2025 12:16:07",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 12:34:22"
          },
          {
            "ticket_id": 300,
            "ticket_number": "35299",
            "title": "Re: GBN-83978 + GBN-82207",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 12:20:27",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/10/2025 09:40:03"
          },
          {
            "ticket_id": 303,
            "ticket_number": "35302",
            "title": "GBN-84892 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 12:45:32",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 12:45:32"
          },
          {
            "ticket_id": 309,
            "ticket_number": "35308",
            "title": "Fw:   330557  /001 - Pedido de elementos",
            "priority": "P3",
            "created_at": "07/10/2025 14:27:50",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 16:49:40"
          },
          {
            "ticket_id": 311,
            "ticket_number": "35310",
            "title": "Loc1192905973 - smy",
            "priority": "P2",
            "created_at": "07/10/2025 14:31:40",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 16:39:17"
          },
          {
            "ticket_id": 330,
            "ticket_number": "35329",
            "title": "Pedido e cotação - Longa duração",
            "priority": "P2",
            "created_at": "07/10/2025 20:35:15",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 18:31:58"
          },
          {
            "ticket_id": 332,
            "ticket_number": "35331",
            "title": "Comprovativo Ana Catarina Silva",
            "priority": "P2",
            "created_at": "07/10/2025 20:48:39",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 15.82,
            "sla_met": false,
            "sla_breach_hours": 11.82,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 12:38:25"
          },
          {
            "ticket_id": 334,
            "ticket_number": "35333",
            "title": "GBN-85037 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 22:10:58",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 19.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:21:01"
          },
          {
            "ticket_id": 365,
            "ticket_number": "35364",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "08/10/2025 09:59:12",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:59:12"
          },
          {
            "ticket_id": 367,
            "ticket_number": "35366",
            "title": "GBN-85056 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:59:20",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 48.97,
            "sla_met": false,
            "sla_breach_hours": 24.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 10:57:50"
          },
          {
            "ticket_id": 385,
            "ticket_number": "35384",
            "title": "Reserva Grupo - Djerba",
            "priority": "P2",
            "created_at": "08/10/2025 14:12:17",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 14:12:17"
          },
          {
            "ticket_id": 393,
            "ticket_number": "35392",
            "title": "Cancelamento da reserva",
            "priority": "P3",
            "created_at": "08/10/2025 14:30:41",
            "close_date": "2025-10-08",
            "sla_target_hours": 24,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 16:26:24"
          },
          {
            "ticket_id": 395,
            "ticket_number": "35394",
            "title": "Confirmação de Reserva * File 412540",
            "priority": "P2",
            "created_at": "08/10/2025 14:46:54",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 16:29:20"
          },
          {
            "ticket_id": 399,
            "ticket_number": "35398",
            "title": "fatura",
            "priority": "P2",
            "created_at": "08/10/2025 15:15:03",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 15:16:31"
          },
          {
            "ticket_id": 404,
            "ticket_number": "35403",
            "title": "Viagem de angariação",
            "priority": "P3",
            "created_at": "08/10/2025 17:14:30",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 17:14:30"
          },
          {
            "ticket_id": 441,
            "ticket_number": "35440",
            "title": "Fwd: Jose carlos, tu reserva K8V2S44: cambios impo",
            "priority": "P2",
            "created_at": "09/10/2025 11:49:23",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 11:49:23"
          },
          {
            "ticket_id": 442,
            "ticket_number": "35441",
            "title": "newblue",
            "priority": "P2",
            "created_at": "09/10/2025 11:49:24",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 11:58:38"
          },
          {
            "ticket_id": 470,
            "ticket_number": "35469",
            "title": "RE: GBN Travel: Information about your booking - G",
            "priority": "P2",
            "created_at": "10/10/2025 09:06:49",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 4.82,
            "sla_met": false,
            "sla_breach_hours": 0.82,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 13:56:15"
          },
          {
            "ticket_id": 477,
            "ticket_number": "35476",
            "title": "Informação de reserva - SPT002501543106",
            "priority": "P2",
            "created_at": "10/10/2025 10:11:43",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 10:30:20"
          },
          {
            "ticket_id": 478,
            "ticket_number": "35477",
            "title": "RE: Viagem Familiarização Gambia 4 a 9 novembro",
            "priority": "P2",
            "created_at": "10/10/2025 10:11:47",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 10:37:06"
          },
          {
            "ticket_id": 479,
            "ticket_number": "35478",
            "title": "Fwd: Reclamação - GBN-66827 - Bilhetes de Osaka",
            "priority": "P3",
            "created_at": "10/10/2025 10:14:33",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 124.92,
            "sla_met": false,
            "sla_breach_hours": 100.92,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 15:09:49"
          },
          {
            "ticket_id": 480,
            "ticket_number": "35479",
            "title": "Envio de Documentação Financeira -  GBN-65520 - UR",
            "priority": "P2",
            "created_at": "10/10/2025 10:27:00",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 11:27:15"
          },
          {
            "ticket_id": 481,
            "ticket_number": "35480",
            "title": "cotação grupo voo_Atenas_Albina",
            "priority": "P2",
            "created_at": "10/10/2025 10:27:01",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 10:27:01"
          },
          {
            "ticket_id": 482,
            "ticket_number": "35481",
            "title": "Envio de Documentação Financeira",
            "priority": "P2",
            "created_at": "10/10/2025 10:27:03",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 11:29:28"
          },
          {
            "ticket_id": 491,
            "ticket_number": "35490",
            "title": "Fwd: Documentação recebida corretamente TTN-113338",
            "priority": "P3",
            "created_at": "10/10/2025 14:02:31",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 11:29:15"
          },
          {
            "ticket_id": 501,
            "ticket_number": "35500",
            "title": "Pedido GBN - urgente -   69230",
            "priority": "P3",
            "created_at": "10/10/2025 15:19:15",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 15:19:15"
          },
          {
            "ticket_id": 502,
            "ticket_number": "35501",
            "title": "Cancelamento de Transfers por parte de operador - ",
            "priority": "P2",
            "created_at": "10/10/2025 15:20:20",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 17:20:55"
          },
          {
            "ticket_id": 521,
            "ticket_number": "35520",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604474579",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 19:37:16",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 74.82,
            "sla_met": false,
            "sla_breach_hours": 50.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 22:26:47"
          },
          {
            "ticket_id": 527,
            "ticket_number": "35526",
            "title": "Re:[## 21062 ##] GBN-82207 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/10/2025 21:11:48",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 62.5,
            "sla_met": false,
            "sla_breach_hours": 58.5,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 11:42:06"
          },
          {
            "ticket_id": 537,
            "ticket_number": "35536",
            "title": "RV: Confirmacion de la reserva Transavia: OFIKRD",
            "priority": "P2",
            "created_at": "13/10/2025 09:06:05",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:29:01"
          },
          {
            "ticket_id": 542,
            "ticket_number": "35541",
            "title": "Urgente troca de hotel",
            "priority": "P1",
            "created_at": "13/10/2025 09:06:21",
            "close_date": "2025-10-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/10/2025 09:06:21"
          },
          {
            "ticket_id": 543,
            "ticket_number": "35542",
            "title": "Grupo: GR-8FB0E357EE",
            "priority": "P3",
            "created_at": "13/10/2025 09:06:24",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 12:41:27"
          },
          {
            "ticket_id": 554,
            "ticket_number": "35553",
            "title": "Confirmação de reserva com localizador: 3937692",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:07:05",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 13:26:52"
          },
          {
            "ticket_id": 555,
            "ticket_number": "35554",
            "title": "Documentação da viagem - Processo 379589",
            "priority": "P3",
            "created_at": "13/10/2025 09:09:46",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 09:09:46"
          },
          {
            "ticket_id": 561,
            "ticket_number": "35560",
            "title": "Fwd: SMYTRAVEL 1125356410 TTN-1125356410#83528832#",
            "priority": "P2",
            "created_at": "13/10/2025 09:13:45",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:13:46"
          },
          {
            "ticket_id": 564,
            "ticket_number": "35563",
            "title": "Re: Pedido de Informação – Alojamento para Trabalh",
            "priority": "P2",
            "created_at": "13/10/2025 09:52:06",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:52:06"
          },
          {
            "ticket_id": 578,
            "ticket_number": "35577",
            "title": "SPT002501544719 -    Toalhas de praia incluídas",
            "priority": "P2",
            "created_at": "13/10/2025 11:46:37",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 11:46:37"
          },
          {
            "ticket_id": 582,
            "ticket_number": "35581",
            "title": "Envio de Documentação Financeira",
            "priority": "P2",
            "created_at": "13/10/2025 12:37:43",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 13:50:09"
          },
          {
            "ticket_id": 583,
            "ticket_number": "35582",
            "title": "Envio de Documentação Financeira",
            "priority": "P3",
            "created_at": "13/10/2025 12:37:44",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 13:54:30"
          },
          {
            "ticket_id": 584,
            "ticket_number": "35583",
            "title": "Envio de Documentação Financeira",
            "priority": "P3",
            "created_at": "13/10/2025 12:37:45",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 13:57:04"
          },
          {
            "ticket_id": 586,
            "ticket_number": "35585",
            "title": "Envio de Documentação Financeira",
            "priority": "P3",
            "created_at": "13/10/2025 12:37:50",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 13:58:16"
          },
          {
            "ticket_id": 642,
            "ticket_number": "35641",
            "title": "CANCELAMENTO RESERVAS",
            "priority": "P2",
            "created_at": "14/10/2025 09:17:43",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 09:13:57"
          },
          {
            "ticket_id": 657,
            "ticket_number": "35656",
            "title": "Grupo: GR-7660C23FCF",
            "priority": "P2",
            "created_at": "14/10/2025 10:47:13",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:22:43"
          },
          {
            "ticket_id": 658,
            "ticket_number": "35657",
            "title": "Grupo: GR-624BFC69FC",
            "priority": "P2",
            "created_at": "14/10/2025 10:59:04",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 13:07:03"
          },
          {
            "ticket_id": 659,
            "ticket_number": "35658",
            "title": "Grupo: GR-17DFF0BC81",
            "priority": "P2",
            "created_at": "14/10/2025 10:59:05",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 13:08:14"
          },
          {
            "ticket_id": 662,
            "ticket_number": "35661",
            "title": "Pedido de cotaçao Disneland Paris",
            "priority": "P2",
            "created_at": "14/10/2025 11:48:26",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 5.65,
            "sla_met": false,
            "sla_breach_hours": 1.65,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 17:28:11"
          },
          {
            "ticket_id": 663,
            "ticket_number": "35662",
            "title": "Fwd: Informações da reserva TTN-1209888480#8375120",
            "priority": "P2",
            "created_at": "14/10/2025 11:48:28",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:48:28"
          },
          {
            "ticket_id": 664,
            "ticket_number": "35663",
            "title": "Fwd: Informações da reserva TTN-1209889678#8375078",
            "priority": "P2",
            "created_at": "14/10/2025 11:48:29",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:48:30"
          },
          {
            "ticket_id": 665,
            "ticket_number": "35664",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "14/10/2025 11:48:31",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:48:32"
          },
          {
            "ticket_id": 666,
            "ticket_number": "35665",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "14/10/2025 11:48:35",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:48:35"
          },
          {
            "ticket_id": 671,
            "ticket_number": "35670",
            "title": "RE: Pedido Declaração de Gastos Irreparáveis-39899",
            "priority": "P3",
            "created_at": "14/10/2025 12:49:48",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 5.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/10/2025 18:23:40"
          },
          {
            "ticket_id": 672,
            "ticket_number": "35671",
            "title": "Re:[## 22844 ##] GBN-81247 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "14/10/2025 12:49:52",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:30:58"
          },
          {
            "ticket_id": 673,
            "ticket_number": "35672",
            "title": "AC Sandra Reis - Tour de 7 dias pelo melhor da Tur",
            "priority": "P2",
            "created_at": "14/10/2025 12:56:18",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 12:56:18"
          },
          {
            "ticket_id": 675,
            "ticket_number": "35674",
            "title": "Fwd: 1125356410 TTN-1125356410#83528832#T14997406¬",
            "priority": "P2",
            "created_at": "14/10/2025 13:11:42",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 13:11:43"
          },
          {
            "ticket_id": 704,
            "ticket_number": "35703",
            "title": "GBN-82727 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/10/2025 18:57:22",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 16.33,
            "sla_met": false,
            "sla_breach_hours": 12.33,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 11:17:45"
          },
          {
            "ticket_id": 715,
            "ticket_number": "35714",
            "title": "Fwd: Informação importante sobre a documentação da",
            "priority": "P2",
            "created_at": "15/10/2025 09:10:16",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:10:16"
          },
          {
            "ticket_id": 718,
            "ticket_number": "35717",
            "title": "Informações sobre o operador do Pedido Nº 27628088",
            "priority": "P2",
            "created_at": "15/10/2025 09:10:37",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:34:50"
          },
          {
            "ticket_id": 719,
            "ticket_number": "35718",
            "title": "Información de reserva número: 1756159",
            "priority": "P2",
            "created_at": "15/10/2025 09:10:47",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 10:22:58"
          },
          {
            "ticket_id": 729,
            "ticket_number": "35728",
            "title": "GBN-72699 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "15/10/2025 10:13:35",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/10/2025 22:45:51"
          },
          {
            "ticket_id": 733,
            "ticket_number": "35732",
            "title": "Fwd: Documentação recebida corretamente TTN-119383",
            "priority": "P2",
            "created_at": "15/10/2025 10:13:42",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 10:13:42"
          },
          {
            "ticket_id": 758,
            "ticket_number": "35757",
            "title": "GBN-69230 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/10/2025 16:29:51",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 116.0,
            "sla_met": false,
            "sla_breach_hours": 112.0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 12:30:47"
          },
          {
            "ticket_id": 760,
            "ticket_number": "35759",
            "title": "Re:[## 22702 ##] GBN-85066 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "15/10/2025 16:29:56",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:44:08"
          },
          {
            "ticket_id": 765,
            "ticket_number": "35764",
            "title": "Re:[## 22992 ##] GBN-69230 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "15/10/2025 17:12:36",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:53:04"
          },
          {
            "ticket_id": 768,
            "ticket_number": "35767",
            "title": "Reserva Newblue ES Localizador 1737212 - André Cri",
            "priority": "P2",
            "created_at": "15/10/2025 17:24:19",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:24:19"
          },
          {
            "ticket_id": 818,
            "ticket_number": "35817",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "16/10/2025 14:24:05",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 94.12,
            "sla_met": false,
            "sla_breach_hours": 90.12,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 12:32:02"
          },
          {
            "ticket_id": 885,
            "ticket_number": "35884",
            "title": "Fwd: Viagify informa sobre a sua reserva 121096126",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 18:14:21",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 18:14:21"
          },
          {
            "ticket_id": 911,
            "ticket_number": "35910",
            "title": "Fwd: Viagify informa sobre a sua reserva 121132807",
            "priority": "P2",
            "created_at": "19/10/2025 17:45:49",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/10/2025 17:45:50"
          },
          {
            "ticket_id": 924,
            "ticket_number": "35923",
            "title": "Fwd: Viagify informa sobre a sua reserva 121152859",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:23",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:23"
          },
          {
            "ticket_id": 940,
            "ticket_number": "35939",
            "title": "Questão LePlan",
            "priority": "P2",
            "created_at": "20/10/2025 10:53:51",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 10:53:51"
          },
          {
            "ticket_id": 945,
            "ticket_number": "35944",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802014098",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 14:31:57",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 25.27,
            "sla_met": false,
            "sla_breach_hours": 1.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 15:48:39"
          },
          {
            "ticket_id": 952,
            "ticket_number": "35951",
            "title": "GBN-86545 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/10/2025 15:06:12",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 15:55:06"
          },
          {
            "ticket_id": 957,
            "ticket_number": "35956",
            "title": "Fwd: Viagify informa sobre a sua reserva 121171209",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 16:04:53",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 16:04:53"
          },
          {
            "ticket_id": 985,
            "ticket_number": "35984",
            "title": "Grupo: GR-4ED7FFDBC6",
            "priority": "P3",
            "created_at": "20/10/2025 22:39:28",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 22.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/10/2025 21:12:41"
          },
          {
            "ticket_id": 990,
            "ticket_number": "35989",
            "title": "Fwd: Incidente de voo TTN-1211463270#84151811#T151",
            "priority": "P2",
            "created_at": "21/10/2025 09:09:49",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 09:09:49"
          },
          {
            "ticket_id": 992,
            "ticket_number": "35991",
            "title": "Re: GBN-74842 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/10/2025 09:12:31",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 09:12:31"
          },
          {
            "ticket_id": 994,
            "ticket_number": "35993",
            "title": "GBN-66538 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/10/2025 09:52:24",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:50:31"
          },
          {
            "ticket_id": 998,
            "ticket_number": "35997",
            "title": "COTAÇÃO SOLFÉRIAS",
            "priority": "P2",
            "created_at": "21/10/2025 10:18:38",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:18:38"
          },
          {
            "ticket_id": 999,
            "ticket_number": "35998",
            "title": "COTAÇÃO SOLTROPICO",
            "priority": "P2",
            "created_at": "21/10/2025 10:18:39",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:18:39"
          },
          {
            "ticket_id": 1000,
            "ticket_number": "35999",
            "title": "Pedido de orçamento de grupo - Djerba Julho 2026",
            "priority": "P2",
            "created_at": "21/10/2025 10:18:40",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:18:40"
          },
          {
            "ticket_id": 1001,
            "ticket_number": "351000",
            "title": "PEDIDO  IMPORTANTE",
            "priority": "P2",
            "created_at": "21/10/2025 10:18:41",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:18:42"
          },
          {
            "ticket_id": 1002,
            "ticket_number": "351001",
            "title": "[PEDIDO DE AJUDA] - Paris – Disney 18 a 21 dezembr",
            "priority": "P3",
            "created_at": "21/10/2025 10:18:45",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/10/2025 10:58:15"
          },
          {
            "ticket_id": 1004,
            "ticket_number": "351003",
            "title": "alteração de voo",
            "priority": "P2",
            "created_at": "21/10/2025 10:23:37",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:23:38"
          },
          {
            "ticket_id": 1005,
            "ticket_number": "351004",
            "title": "Re:[## 23325 ##] GBN-66538 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/10/2025 10:23:39",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:50:13"
          },
          {
            "ticket_id": 1006,
            "ticket_number": "351005",
            "title": "Pedido de cancelamento 1756167 New blue",
            "priority": "P2",
            "created_at": "21/10/2025 10:49:51",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:49:51"
          },
          {
            "ticket_id": 1007,
            "ticket_number": "351006",
            "title": "URGENTE blhetes DisneylanParis",
            "priority": "P1",
            "created_at": "21/10/2025 10:59:29",
            "close_date": "2025-10-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/10/2025 10:59:29"
          },
          {
            "ticket_id": 1008,
            "ticket_number": "351007",
            "title": "Re:[## 22913 ##] GBN-82727 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/10/2025 10:59:30",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 11:07:48"
          },
          {
            "ticket_id": 1009,
            "ticket_number": "351008",
            "title": "EXOTICO | REVEILLON NO BRASIL 🥂",
            "priority": "P2",
            "created_at": "21/10/2025 11:04:27",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 4.73,
            "sla_met": false,
            "sla_breach_hours": 0.73,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 15:49:08"
          },
          {
            "ticket_id": 1016,
            "ticket_number": "351015",
            "title": "URGENTE - TRANSFERE - GBN - 82332",
            "priority": "P1",
            "created_at": "21/10/2025 12:28:20",
            "close_date": "2025-10-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/10/2025 12:28:20"
          },
          {
            "ticket_id": 1023,
            "ticket_number": "351022",
            "title": "Re:[## 23377 ##] GBN-81225 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/10/2025 13:38:56",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 13:38:56"
          },
          {
            "ticket_id": 1033,
            "ticket_number": "351031",
            "title": "Booking Id 6085113, Categoria: Incidência Pós Vend",
            "priority": "P2",
            "created_at": "21/10/2025 15:51:08",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:13:02"
          },
          {
            "ticket_id": 1035,
            "ticket_number": "351033",
            "title": "Urgente - GBN-75309",
            "priority": "P2",
            "created_at": "21/10/2025 15:51:43",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 15:51:44"
          },
          {
            "ticket_id": 1038,
            "ticket_number": "351036",
            "title": "toda adecomentacao",
            "priority": "P2",
            "created_at": "21/10/2025 16:28:32",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 16:28:32"
          },
          {
            "ticket_id": 1040,
            "ticket_number": "351038",
            "title": "Re:[## 22613 ##] Fwd: Reclamação - GBN-66827 - Bil",
            "priority": "P3",
            "created_at": "21/10/2025 17:06:08",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 24.47,
            "sla_met": false,
            "sla_breach_hours": 0.47,
            "sla_name": "SLA P3",
            "first_response_at": "22/10/2025 17:35:06"
          },
          {
            "ticket_id": 1043,
            "ticket_number": "351041",
            "title": "Re:[## 23093 ##] GBN-75309 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/10/2025 17:06:12",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:34:38"
          },
          {
            "ticket_id": 1046,
            "ticket_number": "351044",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 17:46:42",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:36:54"
          },
          {
            "ticket_id": 1047,
            "ticket_number": "351045",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/10/2025 17:46:44",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:38:40"
          },
          {
            "ticket_id": 1048,
            "ticket_number": "351046",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/10/2025 17:46:56",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:40:04"
          },
          {
            "ticket_id": 1049,
            "ticket_number": "351047",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/10/2025 17:47:06",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:41:16"
          },
          {
            "ticket_id": 1050,
            "ticket_number": "351048",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/10/2025 17:48:19",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:42:30"
          },
          {
            "ticket_id": 1061,
            "ticket_number": "351059",
            "title": "GBN-87017 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:17",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 29.33,
            "sla_met": false,
            "sla_breach_hours": 5.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:27:12"
          },
          {
            "ticket_id": 1078,
            "ticket_number": "351076",
            "title": "Re: Comprovativo IBAN - Luana Silvestre",
            "priority": "P2",
            "created_at": "22/10/2025 12:15:12",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 5.47,
            "sla_met": false,
            "sla_breach_hours": 1.47,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 17:43:54"
          },
          {
            "ticket_id": 1095,
            "ticket_number": "351093",
            "title": "Fwd: Viagify informa sobre a sua reserva 121244679",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:08:22",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 17:08:22"
          },
          {
            "ticket_id": 1100,
            "ticket_number": "351098",
            "title": "GBN-87098 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:08:35",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 169.0,
            "sla_met": false,
            "sla_breach_hours": 145.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 18:09:15"
          },
          {
            "ticket_id": 1121,
            "ticket_number": "351119",
            "title": "Re: Grupo: GR-194FF33812 (#2598106)",
            "priority": "P3",
            "created_at": "22/10/2025 20:06:54",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 17:10:55"
          },
          {
            "ticket_id": 1125,
            "ticket_number": "351123",
            "title": "1756159 W2M:013330007572",
            "priority": "P2",
            "created_at": "23/10/2025 09:02:16",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 09:33:25"
          },
          {
            "ticket_id": 1126,
            "ticket_number": "351124",
            "title": "1756159 W2M:013330007573",
            "priority": "P2",
            "created_at": "23/10/2025 09:02:19",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 09:38:30"
          },
          {
            "ticket_id": 1129,
            "ticket_number": "351127",
            "title": "Informações sobre o operador do Pedido Nº 43193570",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 09:02:29",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 09:02:29"
          },
          {
            "ticket_id": 1136,
            "ticket_number": "351134",
            "title": "1756159 W2M:013330007581",
            "priority": "P2",
            "created_at": "23/10/2025 10:01:39",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 10:26:01"
          },
          {
            "ticket_id": 1137,
            "ticket_number": "351135",
            "title": "1756159 W2M:013330007585",
            "priority": "P2",
            "created_at": "23/10/2025 10:34:09",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 10:36:12"
          },
          {
            "ticket_id": 1138,
            "ticket_number": "351136",
            "title": "Acessos nas companhias!",
            "priority": "P2",
            "created_at": "23/10/2025 10:35:46",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 10:56:35"
          },
          {
            "ticket_id": 1139,
            "ticket_number": "351137",
            "title": "GBN-87175 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/10/2025 10:58:06",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 11:52:32"
          },
          {
            "ticket_id": 1140,
            "ticket_number": "351138",
            "title": "Envio de Documentação Cuba * File 408716",
            "priority": "P2",
            "created_at": "23/10/2025 10:58:10",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 11:55:21"
          },
          {
            "ticket_id": 1141,
            "ticket_number": "351139",
            "title": "Confirmacao 332766",
            "priority": "P3",
            "created_at": "23/10/2025 11:56:24",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/10/2025 12:16:07"
          },
          {
            "ticket_id": 1142,
            "ticket_number": "351140",
            "title": "Acesso ao e-mail",
            "priority": "P2",
            "created_at": "23/10/2025 11:56:25",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 11:56:25"
          },
          {
            "ticket_id": 1145,
            "ticket_number": "351143",
            "title": "Confirmacao 332768",
            "priority": "P3",
            "created_at": "23/10/2025 12:16:09",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/10/2025 12:16:09"
          },
          {
            "ticket_id": 1147,
            "ticket_number": "351145",
            "title": "Reserva Civitatis 12 pessoas-URGENTE",
            "priority": "P2",
            "created_at": "23/10/2025 12:16:11",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 12:16:11"
          },
          {
            "ticket_id": 1148,
            "ticket_number": "351146",
            "title": "Confirmacao 332769",
            "priority": "P3",
            "created_at": "23/10/2025 12:16:13",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/10/2025 12:16:13"
          },
          {
            "ticket_id": 1149,
            "ticket_number": "351147",
            "title": "Fwd: Incidente de voo TTN-1211463270#84151811#T151",
            "priority": "P2",
            "created_at": "23/10/2025 12:19:58",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 12:19:58"
          },
          {
            "ticket_id": 1159,
            "ticket_number": "351157",
            "title": "Fwd: Informações sobre a sua reserva TTN-121170886",
            "priority": "P2",
            "created_at": "23/10/2025 14:59:58",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 14:59:59"
          },
          {
            "ticket_id": 1184,
            "ticket_number": "351181",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-87",
            "priority": "P2",
            "created_at": "23/10/2025 23:27:05",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 157.3,
            "sla_met": false,
            "sla_breach_hours": 153.3,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 12:45:36"
          },
          {
            "ticket_id": 1188,
            "ticket_number": "351185",
            "title": "Icárion - Zanzibar, Praia & Vida Selvagem I - 02/0",
            "priority": "P3",
            "created_at": "24/10/2025 09:03:26",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 11:10:40"
          },
          {
            "ticket_id": 1190,
            "ticket_number": "351187",
            "title": "Icárion - Zanzibar & 1 Dia de Safari Mikumi - 02/0",
            "priority": "P3",
            "created_at": "24/10/2025 09:03:32",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 11:10:54"
          },
          {
            "ticket_id": 1191,
            "ticket_number": "351188",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:34",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:06:34"
          },
          {
            "ticket_id": 1192,
            "ticket_number": "351189",
            "title": "Contacto - Serviço para grupos",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:35",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:13:19"
          },
          {
            "ticket_id": 1195,
            "ticket_number": "351192",
            "title": "ROSA PARDAL RD OUTUBRO 4TA VIA",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:40",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:16:46"
          },
          {
            "ticket_id": 1197,
            "ticket_number": "351194",
            "title": "Fwd: Importante: complete su expediente para su vu",
            "priority": "P2",
            "created_at": "24/10/2025 09:26:36",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:26:36"
          },
          {
            "ticket_id": 1200,
            "ticket_number": "351197",
            "title": "Dúvida sobre atividade",
            "priority": "P2",
            "created_at": "24/10/2025 09:36:16",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:36:16"
          },
          {
            "ticket_id": 1201,
            "ticket_number": "351198",
            "title": "Contacto - Atividades",
            "priority": "P2",
            "created_at": "24/10/2025 10:41:02",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 127.48,
            "sla_met": false,
            "sla_breach_hours": 123.48,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 18:10:31"
          },
          {
            "ticket_id": 1202,
            "ticket_number": "351199",
            "title": "GBN-87331 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 10:41:04",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 96.97,
            "sla_met": false,
            "sla_breach_hours": 72.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/10/2025 11:39:35"
          },
          {
            "ticket_id": 1204,
            "ticket_number": "351201",
            "title": "GBN-87331 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "24/10/2025 10:41:08",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 341.97,
            "sla_met": false,
            "sla_breach_hours": 337.97,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 16:39:46"
          },
          {
            "ticket_id": 1206,
            "ticket_number": "351203",
            "title": "Fwd: Encerramento do caso TTN-1154186675#78705123#",
            "priority": "P3",
            "created_at": "24/10/2025 10:57:09",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 11:16:42"
          },
          {
            "ticket_id": 1233,
            "ticket_number": "351230",
            "title": "Sua jornada começará em breve!",
            "priority": "P2",
            "created_at": "24/10/2025 13:27:05",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 5.45,
            "sla_met": false,
            "sla_breach_hours": 1.45,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 18:54:51"
          },
          {
            "ticket_id": 1260,
            "ticket_number": "351257",
            "title": "Contacto - Atividades",
            "priority": "P2",
            "created_at": "24/10/2025 20:35:02",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 62.58,
            "sla_met": false,
            "sla_breach_hours": 58.58,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 11:10:27"
          },
          {
            "ticket_id": 1282,
            "ticket_number": "351279",
            "title": "Pedido de orçamento - Maldivas / Cabo Verde",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:06",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:06"
          },
          {
            "ticket_id": 1299,
            "ticket_number": "351296",
            "title": "Reserva Rimain Tours Localizador 3796558515 - Andr",
            "priority": "P2",
            "created_at": "27/10/2025 10:06:54",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:06:55"
          },
          {
            "ticket_id": 1320,
            "ticket_number": "351317",
            "title": "Re:[## 23706 ##] GBN-67921 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "27/10/2025 11:45:17",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:32:27"
          },
          {
            "ticket_id": 1325,
            "ticket_number": "351322",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "27/10/2025 12:06:06",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:23:13"
          },
          {
            "ticket_id": 1371,
            "ticket_number": "351368",
            "title": "Civitatis - Re: Contacto - Atividades",
            "priority": "P3",
            "created_at": "27/10/2025 20:11:39",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/10/2025 21:19:22"
          },
          {
            "ticket_id": 1380,
            "ticket_number": "351377",
            "title": "Fwd: Ryanair 69664256/Miguel Cena/Miguel Cena",
            "priority": "P3",
            "created_at": "27/10/2025 21:59:12",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/10/2025 21:59:12"
          },
          {
            "ticket_id": 1381,
            "ticket_number": "351378",
            "title": "Fwd: Incidência do voo TTN-1212212049#84698086#T15",
            "priority": "P2",
            "created_at": "27/10/2025 21:59:14",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 18:15:29"
          },
          {
            "ticket_id": 1398,
            "ticket_number": "351395",
            "title": "Confirmação de reserva para For PT004157 67570291",
            "priority": "P2",
            "created_at": "28/10/2025 10:21:59",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 11:02:14"
          },
          {
            "ticket_id": 1405,
            "ticket_number": "351402",
            "title": "Reembolso transfere GBN - LOCALIZADOR GBN-81556",
            "priority": "P2",
            "created_at": "28/10/2025 11:38:20",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 11:38:20"
          },
          {
            "ticket_id": 1410,
            "ticket_number": "351407",
            "title": "Rescisão",
            "priority": "P2",
            "created_at": "28/10/2025 12:02:29",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 13:48:07"
          },
          {
            "ticket_id": 1412,
            "ticket_number": "351409",
            "title": "GBN-87698 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/10/2025 12:19:06",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 13:51:11"
          },
          {
            "ticket_id": 1420,
            "ticket_number": "351417",
            "title": "Grupo: GR-750FF349E6",
            "priority": "P3",
            "created_at": "28/10/2025 13:26:08",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 411.1,
            "sla_met": false,
            "sla_breach_hours": 387.1,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 16:32:13"
          },
          {
            "ticket_id": 1421,
            "ticket_number": "351418",
            "title": "Grupo: GR-B2C3827F9D",
            "priority": "P3",
            "created_at": "28/10/2025 13:26:10",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 8.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/10/2025 21:29:20"
          },
          {
            "ticket_id": 1422,
            "ticket_number": "351419",
            "title": "Grupo: GR-85DFD6861F",
            "priority": "P2",
            "created_at": "28/10/2025 13:26:11",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 8.03,
            "sla_met": false,
            "sla_breach_hours": 4.03,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 21:29:08"
          },
          {
            "ticket_id": 1451,
            "ticket_number": "351448",
            "title": "Solferias - Oferta - LOC: 414136",
            "priority": "P3",
            "created_at": "28/10/2025 21:29:17",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/10/2025 21:29:18"
          },
          {
            "ticket_id": 1460,
            "ticket_number": "351457",
            "title": "Cancelamento de Reservas 321-10262995 Bedsonline",
            "priority": "P2",
            "created_at": "28/10/2025 23:33:48",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 23:33:48"
          },
          {
            "ticket_id": 1467,
            "ticket_number": "351464",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "29/10/2025 10:24:35",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 10:24:35"
          },
          {
            "ticket_id": 1468,
            "ticket_number": "351465",
            "title": "Criação de processo File 414491/25",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 10:24:41",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 6.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 16:49:35"
          },
          {
            "ticket_id": 1471,
            "ticket_number": "351468",
            "title": "Eticket - 66890519 - EU  14/11/2025  Barcelona, Es",
            "priority": "P2",
            "created_at": "29/10/2025 10:24:58",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 23:33:51"
          },
          {
            "ticket_id": 1475,
            "ticket_number": "351472",
            "title": "Fwd: Viagify informa sobre a sua reserva 121427897",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 10:25:21",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 10:25:21"
          },
          {
            "ticket_id": 1477,
            "ticket_number": "351474",
            "title": "Fwd: Viagify informa sobre a sua reserva 121427789",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 10:25:25",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 10:25:26"
          },
          {
            "ticket_id": 1480,
            "ticket_number": "351477",
            "title": "Fwd: Viagify informa sobre a sua reserva 121427570",
            "priority": "P2",
            "created_at": "29/10/2025 10:25:31",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 10:25:31"
          },
          {
            "ticket_id": 1482,
            "ticket_number": "351479",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "29/10/2025 10:45:16",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 7.67,
            "sla_met": false,
            "sla_breach_hours": 3.67,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 18:25:24"
          },
          {
            "ticket_id": 1491,
            "ticket_number": "351488",
            "title": "Rescisão de contrato",
            "priority": "P2",
            "created_at": "29/10/2025 13:02:10",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 13:02:10"
          },
          {
            "ticket_id": 1492,
            "ticket_number": "351489",
            "title": "Flight Change Notification",
            "priority": "P2",
            "created_at": "29/10/2025 13:02:12",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 4.52,
            "sla_met": false,
            "sla_breach_hours": 0.52,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 17:33:33"
          },
          {
            "ticket_id": 1511,
            "ticket_number": "351508",
            "title": "Fwd: Informações da reserva TTN-1214275701#8488453",
            "priority": "P2",
            "created_at": "29/10/2025 17:43:14",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 17:43:15"
          },
          {
            "ticket_id": 1516,
            "ticket_number": "351513",
            "title": "Fwd: Informações da reserva TTN-1214275701#8489389",
            "priority": "P2",
            "created_at": "29/10/2025 18:54:51",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 18:54:52"
          },
          {
            "ticket_id": 1520,
            "ticket_number": "351517",
            "title": "Fwd: Faturas em falta W2M",
            "priority": "P2",
            "created_at": "29/10/2025 19:49:52",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 19:49:52"
          },
          {
            "ticket_id": 1525,
            "ticket_number": "351522",
            "title": "Fwd: Informações da reserva TTN-1214278970#8489340",
            "priority": "P3",
            "created_at": "29/10/2025 21:40:38",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/10/2025 21:40:39"
          },
          {
            "ticket_id": 1535,
            "ticket_number": "351532",
            "title": "Fwd: Localizador 1214277898 - SmyTravel informa TT",
            "priority": "P3",
            "created_at": "30/10/2025 10:38:30",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 10:38:31"
          },
          {
            "ticket_id": 1537,
            "ticket_number": "351534",
            "title": "Fwd: Informação importante sobre a documentação da",
            "priority": "P3",
            "created_at": "30/10/2025 10:38:35",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 10:38:35"
          },
          {
            "ticket_id": 1539,
            "ticket_number": "351536",
            "title": "Fwd: Informações da reserva TTN-1214277898#8493179",
            "priority": "P2",
            "created_at": "30/10/2025 11:07:31",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 11:07:31"
          },
          {
            "ticket_id": 1551,
            "ticket_number": "351548",
            "title": "FBB-99195 RE: Pedido de faturas",
            "priority": "P2",
            "created_at": "30/10/2025 12:51:57",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 340.25,
            "sla_met": false,
            "sla_breach_hours": 336.25,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 17:07:33"
          },
          {
            "ticket_id": 1555,
            "ticket_number": "351552",
            "title": "RE: Pedido de faturas",
            "priority": "P2",
            "created_at": "30/10/2025 12:52:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 12:59:52"
          },
          {
            "ticket_id": 1557,
            "ticket_number": "351554",
            "title": "HENRIQUES FALCAO/AFONSO MIGUEL MR 16NOV2025 LIS MA",
            "priority": "P2",
            "created_at": "30/10/2025 13:01:21",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 13:27:57"
          },
          {
            "ticket_id": 1558,
            "ticket_number": "351555",
            "title": "SILVA GONCALVES/INES CARINA MRS 16NOV2025 LIS MAD",
            "priority": "P2",
            "created_at": "30/10/2025 13:01:22",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 13:28:18"
          },
          {
            "ticket_id": 1559,
            "ticket_number": "351556",
            "title": "SPT002501547595 //// Envio de bilhetes /// RSV liq",
            "priority": "P2",
            "created_at": "30/10/2025 13:07:15",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 13:28:43"
          },
          {
            "ticket_id": 1564,
            "ticket_number": "351561",
            "title": "Fwd: Important information about your trip",
            "priority": "P2",
            "created_at": "30/10/2025 15:11:00",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 15:11:00"
          },
          {
            "ticket_id": 1566,
            "ticket_number": "351563",
            "title": "Proposta Solférias  17642/2025",
            "priority": "P2",
            "created_at": "30/10/2025 16:13:11",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 17:21:28"
          },
          {
            "ticket_id": 1570,
            "ticket_number": "351567",
            "title": "FBB-99195 RE: Pedido de faturas",
            "priority": "P2",
            "created_at": "30/10/2025 16:15:24",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 19:11:02"
          },
          {
            "ticket_id": 1571,
            "ticket_number": "351568",
            "title": "Pedido de faturas",
            "priority": "P2",
            "created_at": "30/10/2025 16:15:29",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 17:10:33"
          },
          {
            "ticket_id": 1589,
            "ticket_number": "351586",
            "title": "Fwd: Important information about your trip",
            "priority": "P2",
            "created_at": "30/10/2025 19:33:43",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 19:33:43"
          },
          {
            "ticket_id": 1600,
            "ticket_number": "351597",
            "title": "Eticket - 63517580 - DI  20/11/2025  Miami, Estado",
            "priority": "P2",
            "created_at": "31/10/2025 10:11:30",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:32:37"
          },
          {
            "ticket_id": 1603,
            "ticket_number": "351600",
            "title": "Fwd: Informações da reserva TTN-1171291568#8499713",
            "priority": "P2",
            "created_at": "31/10/2025 10:11:35",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:11:36"
          },
          {
            "ticket_id": 1606,
            "ticket_number": "351603",
            "title": "Dúvida bagagem após reserva Nortravel",
            "priority": "P2",
            "created_at": "31/10/2025 10:51:12",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:51:12"
          },
          {
            "ticket_id": 1607,
            "ticket_number": "351604",
            "title": "GBN-83538 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/10/2025 11:59:27",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:11:32"
          },
          {
            "ticket_id": 1613,
            "ticket_number": "351610",
            "title": "Civitatis - Re: Civitatis. A34436389 Excursão a Sa",
            "priority": "P3",
            "created_at": "31/10/2025 12:08:47",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/10/2025 12:26:08"
          },
          {
            "ticket_id": 1620,
            "ticket_number": "351617",
            "title": "Fw: Fw: 25VG001390/001 - Pedido de elementos",
            "priority": "P2",
            "created_at": "31/10/2025 13:03:19",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:29:01"
          },
          {
            "ticket_id": 1623,
            "ticket_number": "351620",
            "title": "GBN-78675 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/10/2025 13:46:23",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 10:11:33"
          },
          {
            "ticket_id": 1627,
            "ticket_number": "351624",
            "title": "Grupos - Pedido de Cotação - Isa Rezende",
            "priority": "P2",
            "created_at": "31/10/2025 15:02:46",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 15:08:31"
          },
          {
            "ticket_id": 1628,
            "ticket_number": "351625",
            "title": "Fwd: Realice el check-in para su viaje a Kinshasa ",
            "priority": "P2",
            "created_at": "31/10/2025 15:02:48",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 15:02:49"
          },
          {
            "ticket_id": 1637,
            "ticket_number": "351634",
            "title": "Fwd: Sus documentos de confirmación de facturación",
            "priority": "P2",
            "created_at": "31/10/2025 16:55:57",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 16:55:58"
          },
          {
            "ticket_id": 1650,
            "ticket_number": "351647",
            "title": "Re:[## 21490 ##] GBN-65520 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "31/10/2025 19:53:06",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 64.27,
            "sla_met": false,
            "sla_breach_hours": 60.27,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 12:09:22"
          },
          {
            "ticket_id": 1674,
            "ticket_number": "351671",
            "title": "GBN - viagem de grupo Egito",
            "priority": "P1",
            "created_at": "02/11/2025 10:24:12",
            "close_date": "2025-11-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/11/2025 10:24:12"
          },
          {
            "ticket_id": 1675,
            "ticket_number": "351672",
            "title": "Assistência médica - Localizador - Costa - 3450173",
            "priority": "P3",
            "created_at": "02/11/2025 10:45:58",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/11/2025 10:45:59"
          },
          {
            "ticket_id": 1678,
            "ticket_number": "351675",
            "title": "Soltropico - alteração classe voo + villa",
            "priority": "P3",
            "created_at": "02/11/2025 12:27:18",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/11/2025 12:27:18"
          },
          {
            "ticket_id": 1694,
            "ticket_number": "351691",
            "title": "GBN-88382 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:48",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:57:45"
          },
          {
            "ticket_id": 1698,
            "ticket_number": "351695",
            "title": "Fwd: Viagify informa sobre a sua reserva 121544965",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:58",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:34:58"
          },
          {
            "ticket_id": 1704,
            "ticket_number": "351701",
            "title": "Aéreo - Confirmação - Cancelamento de Reserva (XGO",
            "priority": "P2",
            "created_at": "03/11/2025 10:37:23",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 12:59:41"
          },
          {
            "ticket_id": 1736,
            "ticket_number": "351733",
            "title": "Reserva confirmada: Ingresso da Catedral de Floren",
            "priority": "P2",
            "created_at": "03/11/2025 13:20:31",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 13:20:31"
          },
          {
            "ticket_id": 1737,
            "ticket_number": "351734",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "03/11/2025 13:22:43",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 13:50:08"
          },
          {
            "ticket_id": 1738,
            "ticket_number": "351735",
            "title": "Fwd: Nova Viagem #251100012 - Marisa Duarte MD Tra",
            "priority": "P2",
            "created_at": "03/11/2025 13:25:26",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 13:25:26"
          },
          {
            "ticket_id": 1745,
            "ticket_number": "351742",
            "title": "GBN-88382",
            "priority": "P2",
            "created_at": "03/11/2025 15:28:12",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 15:28:12"
          },
          {
            "ticket_id": 1747,
            "ticket_number": "351744",
            "title": "Re:[## 22833 ##] GBN-81440 - Seu pedido foi recebi",
            "priority": "P1",
            "created_at": "03/11/2025 15:48:48",
            "close_date": "2025-11-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/11/2025 15:54:48"
          },
          {
            "ticket_id": 1750,
            "ticket_number": "351747",
            "title": "Dúvida bolo Disney ",
            "priority": "P3",
            "created_at": "03/11/2025 16:28:52",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 16:28:52"
          },
          {
            "ticket_id": 1751,
            "ticket_number": "351748",
            "title": "FW: Jose carlos, su reserva KB1DPHH: la hora de su",
            "priority": "P2",
            "created_at": "03/11/2025 16:28:54",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 16:28:55"
          },
          {
            "ticket_id": 1752,
            "ticket_number": "351749",
            "title": "Fwd: Informações da reserva TTN-1211528598#8517032",
            "priority": "P3",
            "created_at": "03/11/2025 16:58:57",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 16:58:58"
          },
          {
            "ticket_id": 1755,
            "ticket_number": "351752",
            "title": "Pedido orçamento grupo - Hotel \"Il Timone\" - Porto",
            "priority": "P3",
            "created_at": "03/11/2025 17:01:19",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 17:01:20"
          },
          {
            "ticket_id": 1793,
            "ticket_number": "351790",
            "title": "Medical assistance - Locator - 34501737",
            "priority": "P2",
            "created_at": "04/11/2025 10:02:51",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 10:02:52"
          },
          {
            "ticket_id": 1798,
            "ticket_number": "351795",
            "title": "GBN-82923",
            "priority": "P3",
            "created_at": "04/11/2025 10:04:44",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/10/2025 15:45:15"
          },
          {
            "ticket_id": 1799,
            "ticket_number": "351796",
            "title": "Schedule Change",
            "priority": "P3",
            "created_at": "04/11/2025 10:10:07",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 10:10:09"
          },
          {
            "ticket_id": 1806,
            "ticket_number": "351803",
            "title": "Re:[## 24221 ##] GBN-85834 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "04/11/2025 11:20:43",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 11:20:43"
          },
          {
            "ticket_id": 1807,
            "ticket_number": "351804",
            "title": "RE: Solicitação – Reservas 408831/25 e 409435/2025",
            "priority": "P2",
            "created_at": "04/11/2025 11:20:46",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 11:32:30"
          },
          {
            "ticket_id": 1809,
            "ticket_number": "351806",
            "title": "Voucher soltropico",
            "priority": "P3",
            "created_at": "04/11/2025 13:32:39",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 13:32:39"
          },
          {
            "ticket_id": 1810,
            "ticket_number": "351807",
            "title": "alteração de nome na reserva GBN - 88499",
            "priority": "P2",
            "created_at": "04/11/2025 13:32:40",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 13:32:40"
          },
          {
            "ticket_id": 1811,
            "ticket_number": "351808",
            "title": "cotação para viagem de angariação a namibia",
            "priority": "P3",
            "created_at": "04/11/2025 13:32:41",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 13:32:41"
          },
          {
            "ticket_id": 1825,
            "ticket_number": "351822",
            "title": "Orçamento 17642/25 - MARÇO_V2",
            "priority": "P3",
            "created_at": "04/11/2025 16:41:35",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 19:00:21"
          },
          {
            "ticket_id": 1835,
            "ticket_number": "351832",
            "title": "GBN-88499 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/11/2025 18:55:58",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 164.77,
            "sla_met": false,
            "sla_breach_hours": 160.77,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 15:42:57"
          },
          {
            "ticket_id": 1851,
            "ticket_number": "351848",
            "title": "MSC MUSICA ID 841 - Lisbon (Portugal) Sunday, 9th ",
            "priority": "P3",
            "created_at": "05/11/2025 10:04:56",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 10:48:33"
          },
          {
            "ticket_id": 1855,
            "ticket_number": "351852",
            "title": "MSC MUSICA ID 841 - Lisbon (Portugal) Sunday, 9th ",
            "priority": "P3",
            "created_at": "05/11/2025 10:05:02",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 10:48:33"
          },
          {
            "ticket_id": 1856,
            "ticket_number": "351853",
            "title": "MSC MUSICA ID 841 - Lisbon (Portugal) Sunday, 9th ",
            "priority": "P3",
            "created_at": "05/11/2025 10:05:04",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 10:48:33"
          },
          {
            "ticket_id": 1857,
            "ticket_number": "351854",
            "title": "MSC MUSICA ID 841 - Lisbon (Portugal) Sunday, 9th ",
            "priority": "P3",
            "created_at": "05/11/2025 10:05:05",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 10:48:33"
          },
          {
            "ticket_id": 1866,
            "ticket_number": "351863",
            "title": "Fwd: Localizador 1211528598 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "05/11/2025 12:15:11",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 12:15:11"
          },
          {
            "ticket_id": 1871,
            "ticket_number": "351868",
            "title": "Re:[## 24310 ##] GBN-88499 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "05/11/2025 12:21:17",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 15:41:50"
          },
          {
            "ticket_id": 1875,
            "ticket_number": "351872",
            "title": "Re:[## 24036 ##] GBN-78675 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "05/11/2025 12:57:55",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 15:45:08"
          },
          {
            "ticket_id": 1880,
            "ticket_number": "351877",
            "title": "Fwd: Localizador 1215864192 - SmyTravel informa TT",
            "priority": "P3",
            "created_at": "05/11/2025 15:32:47",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 20:22:05"
          },
          {
            "ticket_id": 1899,
            "ticket_number": "351896",
            "title": "URGENTE - Pedido de orçamento de grupo | Cabo verd",
            "priority": "P3",
            "created_at": "05/11/2025 22:48:41",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 22:48:42"
          },
          {
            "ticket_id": 1911,
            "ticket_number": "351908",
            "title": "[Ticket#2025110685002618] RE: Pedido de orçamento ",
            "priority": "P2",
            "created_at": "06/11/2025 10:20:10",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 845.78,
            "sla_met": false,
            "sla_breach_hours": 841.78,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 16:08:02"
          },
          {
            "ticket_id": 1913,
            "ticket_number": "351910",
            "title": "Información de su solicitud de Grupos",
            "priority": "P2",
            "created_at": "06/11/2025 10:20:13",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 845.8,
            "sla_met": false,
            "sla_breach_hours": 841.8,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 16:08:27"
          },
          {
            "ticket_id": 1918,
            "ticket_number": "351915",
            "title": "Fwd: Ryanair 69921218/Miguel Cena/Miguel Cena",
            "priority": "P3",
            "created_at": "06/11/2025 10:23:33",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:23:34"
          },
          {
            "ticket_id": 1921,
            "ticket_number": "351918",
            "title": "Fwd: Informações da reserva TTN-1215864192#8543790",
            "priority": "P2",
            "created_at": "06/11/2025 10:23:41",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:23:42"
          },
          {
            "ticket_id": 1923,
            "ticket_number": "351920",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/11/2025 10:45:35",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:45:35"
          },
          {
            "ticket_id": 1925,
            "ticket_number": "351922",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "06/11/2025 10:48:32",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:48:32"
          },
          {
            "ticket_id": 1927,
            "ticket_number": "351924",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "06/11/2025 10:48:53",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 10:48:53"
          },
          {
            "ticket_id": 1929,
            "ticket_number": "351926",
            "title": "Fw: Voucher e certificados - IMPORTANTE",
            "priority": "P2",
            "created_at": "06/11/2025 10:49:40",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 13:48:52"
          },
          {
            "ticket_id": 1932,
            "ticket_number": "351929",
            "title": "Re:[## 24211 ##] GBN-81699 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "06/11/2025 11:10:50",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 19:33:00"
          },
          {
            "ticket_id": 1955,
            "ticket_number": "351951",
            "title": "Re:[## 23830 ##] GBN-81556 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "06/11/2025 18:10:51",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 19:03:54"
          },
          {
            "ticket_id": 1969,
            "ticket_number": "351965",
            "title": "Dúvida urgente GBN",
            "priority": "P2",
            "created_at": "07/11/2025 10:02:56",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 10:02:56"
          },
          {
            "ticket_id": 1971,
            "ticket_number": "351967",
            "title": "Fwd: Viagify informa sobre a sua reserva 121683503",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 10:14:45",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 10:14:45"
          },
          {
            "ticket_id": 1984,
            "ticket_number": "351980",
            "title": "GBN-88444 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/11/2025 11:06:58",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 12:38:08"
          },
          {
            "ticket_id": 1990,
            "ticket_number": "351986",
            "title": "Questões urgentes – viagem de grupo a Malta",
            "priority": "P3",
            "created_at": "07/11/2025 11:20:23",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 11:20:23"
          },
          {
            "ticket_id": 2002,
            "ticket_number": "351998",
            "title": "Fwd: Informações da reserva TTN-1211421469#8519262",
            "priority": "P2",
            "created_at": "07/11/2025 15:39:05",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 15:39:05"
          },
          {
            "ticket_id": 2004,
            "ticket_number": "352000",
            "title": "Fwd: Informações da reserva TTN-1215864192#8549768",
            "priority": "P2",
            "created_at": "07/11/2025 16:05:13",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 16:05:14"
          },
          {
            "ticket_id": 2023,
            "ticket_number": "352019",
            "title": "GBN-89197 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 19:12:31",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 166.75,
            "sla_met": false,
            "sla_breach_hours": 142.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 17:58:10"
          },
          {
            "ticket_id": 2067,
            "ticket_number": "352063",
            "title": "Fwd: Viagify informa sobre a sua reserva 121745233",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:37",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/11/2025 17:58:38"
          },
          {
            "ticket_id": 2068,
            "ticket_number": "352064",
            "title": "Fwd: Viagify informa sobre a sua reserva 121729025",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:40",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/11/2025 17:58:40"
          },
          {
            "ticket_id": 2072,
            "ticket_number": "352068",
            "title": "Fwd: Confirmacion de la reserva Transavia: PYD27C",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:54",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/11/2025 17:58:54"
          },
          {
            "ticket_id": 2076,
            "ticket_number": "352072",
            "title": "Fwd: Viagify informa sobre a sua reserva   333975 ",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 10:10:56",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 10:10:57"
          },
          {
            "ticket_id": 2077,
            "ticket_number": "352073",
            "title": "Número de informação da reserva: 6120511",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 10:10:59",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 349.0,
            "sla_met": false,
            "sla_breach_hours": 325.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 23:11:40"
          },
          {
            "ticket_id": 2081,
            "ticket_number": "352077",
            "title": "GBN-89312 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 10:11:08",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 223.5,
            "sla_met": false,
            "sla_breach_hours": 199.5,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 17:42:07"
          },
          {
            "ticket_id": 2087,
            "ticket_number": "352083",
            "title": "asunto",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:36",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:38:54"
          },
          {
            "ticket_id": 2090,
            "ticket_number": "352086",
            "title": "25VG001390/001 - Pedido de IBAN",
            "priority": "P2",
            "created_at": "10/11/2025 10:14:27",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 12:14:14"
          },
          {
            "ticket_id": 2097,
            "ticket_number": "352093",
            "title": "Fwd: Realice el check-in para su viaje a Lisboa de",
            "priority": "P2",
            "created_at": "10/11/2025 10:42:06",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:42:07"
          },
          {
            "ticket_id": 2106,
            "ticket_number": "352102",
            "title": "Confirmação de Reserva PAR * FILE 415420/25",
            "priority": "P2",
            "created_at": "10/11/2025 11:18:04",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 11:44:00"
          },
          {
            "ticket_id": 2118,
            "ticket_number": "352114",
            "title": "URGENTE_ RESERVA SOLFÉRIAS",
            "priority": "P3",
            "created_at": "10/11/2025 13:00:45",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 13:00:45"
          },
          {
            "ticket_id": 2119,
            "ticket_number": "352115",
            "title": "Pedido Orçamento Viagem Grupo 10 adultos Cabo Verd",
            "priority": "P3",
            "created_at": "10/11/2025 13:07:21",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 13:07:21"
          },
          {
            "ticket_id": 2127,
            "ticket_number": "352123",
            "title": "Fwd: Localizador 1133020231 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "10/11/2025 15:06:20",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 15:06:20"
          },
          {
            "ticket_id": 2128,
            "ticket_number": "352124",
            "title": "Fwd: Localizador 1211528598 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "10/11/2025 15:06:22",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 15:06:22"
          },
          {
            "ticket_id": 2146,
            "ticket_number": "352142",
            "title": "Re:[## 24211 ##] GBN-81699 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/11/2025 17:44:10",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 18:38:50"
          },
          {
            "ticket_id": 2157,
            "ticket_number": "352153",
            "title": "Cotação Travelplan Caraibas",
            "priority": "P3",
            "created_at": "10/11/2025 19:55:30",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 19:55:30"
          },
          {
            "ticket_id": 2170,
            "ticket_number": "352166",
            "title": "Vouchers",
            "priority": "P2",
            "created_at": "11/11/2025 10:10:08",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:10:09"
          },
          {
            "ticket_id": 2175,
            "ticket_number": "352171",
            "title": "Envio de documentos de File 415384 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "11/11/2025 10:11:20",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:41:40"
          },
          {
            "ticket_id": 2178,
            "ticket_number": "352174",
            "title": "Pedido de orçamento - Cruzeiros Royal Caribbean e ",
            "priority": "P3",
            "created_at": "11/11/2025 10:18:31",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 10:18:31"
          },
          {
            "ticket_id": 2180,
            "ticket_number": "352176",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "11/11/2025 10:19:07",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:19:08"
          },
          {
            "ticket_id": 2181,
            "ticket_number": "352177",
            "title": "Fwd: Viagify informa sobre a sua reserva 121785737",
            "priority": "P2",
            "created_at": "11/11/2025 10:19:10",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:19:11"
          },
          {
            "ticket_id": 2183,
            "ticket_number": "352179",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "11/11/2025 10:19:16",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:19:17"
          },
          {
            "ticket_id": 2184,
            "ticket_number": "352180",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "11/11/2025 10:19:19",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:19:20"
          },
          {
            "ticket_id": 2195,
            "ticket_number": "352191",
            "title": "Re:[## 24355 ##] GBN-85634 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/11/2025 14:05:19",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 13:44:05"
          },
          {
            "ticket_id": 2216,
            "ticket_number": "352212",
            "title": "GBN-89265 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/11/2025 17:59:07",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:30:16"
          },
          {
            "ticket_id": 2219,
            "ticket_number": "352215",
            "title": "Re:[## 24771 ##] GBN-89265 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/11/2025 18:29:24",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:31:32"
          },
          {
            "ticket_id": 2246,
            "ticket_number": "352242",
            "title": "GBN-89693 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "11/11/2025 23:32:55",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 22:22:52"
          },
          {
            "ticket_id": 2253,
            "ticket_number": "352249",
            "title": "Fwd: Ative a sua Wizz Account🔔",
            "priority": "P2",
            "created_at": "12/11/2025 10:39:14",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 10:39:15"
          },
          {
            "ticket_id": 2258,
            "ticket_number": "352254",
            "title": "Envio de documentos de File 415469/25",
            "priority": "P2",
            "created_at": "12/11/2025 10:39:55",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 11:03:29"
          },
          {
            "ticket_id": 2261,
            "ticket_number": "352257",
            "title": "URGENTE - Dados em falta dos passageiros",
            "priority": "P3",
            "created_at": "12/11/2025 11:39:25",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 11:45:50"
          },
          {
            "ticket_id": 2262,
            "ticket_number": "352258",
            "title": "URGENTE - Dados em falta dos passageiros",
            "priority": "P3",
            "created_at": "12/11/2025 11:39:26",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 11:42:55"
          },
          {
            "ticket_id": 2271,
            "ticket_number": "352267",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P3",
            "created_at": "12/11/2025 12:44:48",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 16:56:48"
          },
          {
            "ticket_id": 2272,
            "ticket_number": "352268",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P3",
            "created_at": "12/11/2025 12:44:50",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 16:57:55"
          },
          {
            "ticket_id": 2274,
            "ticket_number": "352270",
            "title": "URGENTE - Dados em falta dos passageiros",
            "priority": "P3",
            "created_at": "12/11/2025 12:44:54",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:02:47"
          },
          {
            "ticket_id": 2278,
            "ticket_number": "352274",
            "title": "URGENTE - Dados em falta dos passageiros",
            "priority": "P3",
            "created_at": "12/11/2025 12:45:03",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:35:20"
          },
          {
            "ticket_id": 2279,
            "ticket_number": "352275",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P3",
            "created_at": "12/11/2025 12:45:05",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:36:28"
          },
          {
            "ticket_id": 2281,
            "ticket_number": "352277",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P3",
            "created_at": "12/11/2025 12:55:30",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:42:32"
          },
          {
            "ticket_id": 2284,
            "ticket_number": "352280",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P3",
            "created_at": "12/11/2025 12:55:37",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 4.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:49:24"
          },
          {
            "ticket_id": 2296,
            "ticket_number": "352292",
            "title": "Cancelamento de viagem",
            "priority": "P3",
            "created_at": "12/11/2025 15:55:50",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 15:55:50"
          },
          {
            "ticket_id": 2306,
            "ticket_number": "352301",
            "title": "Re:[## 19590 ##] GBN-77446 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/11/2025 17:01:26",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 19:32:01"
          },
          {
            "ticket_id": 2311,
            "ticket_number": "352306",
            "title": "Re: Fwd: GBN-80114 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "12/11/2025 17:56:56",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:56:56"
          },
          {
            "ticket_id": 2318,
            "ticket_number": "352313",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802102412",
            "priority": "Reservas sem Formulário",
            "created_at": "12/11/2025 20:41:29",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 166.3,
            "sla_met": false,
            "sla_breach_hours": 142.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 18:59:42"
          },
          {
            "ticket_id": 2321,
            "ticket_number": "352316",
            "title": "Fwd: Viagify informa sobre a sua reserva 121844586",
            "priority": "Reservas sem Formulário",
            "created_at": "12/11/2025 20:50:48",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 20:50:48"
          },
          {
            "ticket_id": 2331,
            "ticket_number": "352326",
            "title": "Reserva Solferias - pendente",
            "priority": "P3",
            "created_at": "12/11/2025 23:01:27",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 23:01:27"
          },
          {
            "ticket_id": 2336,
            "ticket_number": "352331",
            "title": "Cruzeiro MSC Dubai  - horário de saída",
            "priority": "P3",
            "created_at": "12/11/2025 23:35:19",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 23:35:19"
          },
          {
            "ticket_id": 2337,
            "ticket_number": "352332",
            "title": "GBN-89869 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/11/2025 23:52:54",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 10.47,
            "sla_met": false,
            "sla_breach_hours": 6.47,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 10:21:49"
          },
          {
            "ticket_id": 2346,
            "ticket_number": "352341",
            "title": "GBN-68378 - Sua reserva foi atualizada com serviço",
            "priority": "P2",
            "created_at": "13/11/2025 10:14:32",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 11:42:43"
          },
          {
            "ticket_id": 2363,
            "ticket_number": "352358",
            "title": "Confirmação de reserva para For PT004157 63612384",
            "priority": "P3",
            "created_at": "13/11/2025 11:57:52",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 12:03:33"
          },
          {
            "ticket_id": 2365,
            "ticket_number": "352360",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P3",
            "created_at": "13/11/2025 11:57:56",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 12:52:13"
          },
          {
            "ticket_id": 2372,
            "ticket_number": "352367",
            "title": "Fw: Reserva Susana Gonçalves - GBN 65327",
            "priority": "P2",
            "created_at": "13/11/2025 12:53:49",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 12:53:49"
          },
          {
            "ticket_id": 2374,
            "ticket_number": "352369",
            "title": "Questionário - Fam Trip Gambia ( 04 a 09 Nov) ",
            "priority": "P3",
            "created_at": "13/11/2025 12:53:53",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:30:43"
          },
          {
            "ticket_id": 2468,
            "ticket_number": "352463",
            "title": "Confirmação de Reserva * File 415790*ALTERAÇAO",
            "priority": "P2",
            "created_at": "14/11/2025 11:27:06",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 12:24:43"
          },
          {
            "ticket_id": 2478,
            "ticket_number": "352473",
            "title": "-",
            "priority": "P3",
            "created_at": "14/11/2025 12:40:27",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 12:40:28"
          },
          {
            "ticket_id": 2538,
            "ticket_number": "352533",
            "title": "Fwd: Viagify informa sobre a sua reserva 121922142",
            "priority": "Reservas sem Formulário",
            "created_at": "15/11/2025 15:47:10",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/11/2025 15:47:11"
          },
          {
            "ticket_id": 2554,
            "ticket_number": "352549",
            "title": "Fwd: Viagify informa sobre a sua reserva 121943259",
            "priority": "P2",
            "created_at": "16/11/2025 14:03:52",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 14:03:52"
          },
          {
            "ticket_id": 2565,
            "ticket_number": "352560",
            "title": "Cotação Grupo Hotel Barcelona - janeiro",
            "priority": "P3",
            "created_at": "17/11/2025 10:16:03",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 10:16:03"
          },
          {
            "ticket_id": 2585,
            "ticket_number": "352580",
            "title": "Icárion - New York & Miami - 22/06/2026 - 6125607 ",
            "priority": "P3",
            "created_at": "17/11/2025 11:05:02",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 8.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 19:21:25"
          },
          {
            "ticket_id": 2596,
            "ticket_number": "352591",
            "title": "Número de informação da reserva: 6120663",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 12:28:30",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 16:04:04"
          },
          {
            "ticket_id": 2601,
            "ticket_number": "352596",
            "title": "Cancelamento de reservas New Blue",
            "priority": "P3",
            "created_at": "17/11/2025 12:56:09",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 12:56:09"
          },
          {
            "ticket_id": 2605,
            "ticket_number": "352600",
            "title": "CVO e RGPD - reservas",
            "priority": "P3",
            "created_at": "17/11/2025 13:32:41",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 13:32:41"
          },
          {
            "ticket_id": 2610,
            "ticket_number": "352605",
            "title": "Orçamento soltropico",
            "priority": "P3",
            "created_at": "17/11/2025 15:20:52",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 15:20:52"
          },
          {
            "ticket_id": 2614,
            "ticket_number": "352609",
            "title": "Voucher Actualizado Luis Brito MX Diciembre",
            "priority": "P2",
            "created_at": "17/11/2025 16:46:00",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 17:26:10"
          },
          {
            "ticket_id": 2617,
            "ticket_number": "352612",
            "title": "Fwd: Reserva 1218694510 TTN-1218694510#86078013#T1",
            "priority": "P2",
            "created_at": "17/11/2025 17:11:35",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 16:45:55"
          },
          {
            "ticket_id": 2619,
            "ticket_number": "352614",
            "title": "Confirmação de Reserva * File 415793",
            "priority": "P2",
            "created_at": "17/11/2025 17:11:51",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 17:40:22"
          },
          {
            "ticket_id": 2637,
            "ticket_number": "352632",
            "title": "Información de su solicitud de Grupos",
            "priority": "P3",
            "created_at": "17/11/2025 19:24:03",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 17.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:45:02"
          },
          {
            "ticket_id": 2640,
            "ticket_number": "352635",
            "title": "GBN-90437 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 19:40:17",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 233.33,
            "sla_met": false,
            "sla_breach_hours": 209.33,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 13:00:32"
          },
          {
            "ticket_id": 2667,
            "ticket_number": "352662",
            "title": "Re: Nova Viagem #251100156 - Marta Barbosa",
            "priority": "P3",
            "created_at": "18/11/2025 10:25:49",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:25:49"
          },
          {
            "ticket_id": 2691,
            "ticket_number": "352686",
            "title": "Acesso Veturis",
            "priority": "P3",
            "created_at": "18/11/2025 12:07:08",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:07:08"
          },
          {
            "ticket_id": 2692,
            "ticket_number": "352687",
            "title": "Reclamação GBN 90212",
            "priority": "P3",
            "created_at": "18/11/2025 12:41:42",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:41:43"
          },
          {
            "ticket_id": 2697,
            "ticket_number": "352692",
            "title": "Devolução do valor 752 € ",
            "priority": "P3",
            "created_at": "18/11/2025 13:21:34",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 5.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 18:35:50"
          },
          {
            "ticket_id": 2708,
            "ticket_number": "352703",
            "title": "CANCELAMENTO RESERVA SOLTROPICO - 332230",
            "priority": "P3",
            "created_at": "18/11/2025 16:25:49",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 16:25:49"
          },
          {
            "ticket_id": 2711,
            "ticket_number": "352706",
            "title": "Pedido reserva Odisseias",
            "priority": "P2",
            "created_at": "18/11/2025 16:26:26",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 16:26:26"
          },
          {
            "ticket_id": 2712,
            "ticket_number": "352707",
            "title": "Fwd: Informações sobre a sua reserva TTN-121992292",
            "priority": "P2",
            "created_at": "18/11/2025 16:56:23",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 16:56:23"
          },
          {
            "ticket_id": 2719,
            "ticket_number": "352714",
            "title": "RE: Nueva solicitud de Grupos",
            "priority": "P3",
            "created_at": "18/11/2025 19:15:55",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 19:41:36"
          },
          {
            "ticket_id": 2757,
            "ticket_number": "352752",
            "title": "RV: Bom dia Ana Rita Pereira Lopes: Bilhete e info",
            "priority": "P2",
            "created_at": "19/11/2025 10:05:13",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 10:13:58"
          },
          {
            "ticket_id": 2759,
            "ticket_number": "352754",
            "title": "RV: Bom dia Afonso Pereira Fernandes: Bilhete e in",
            "priority": "P2",
            "created_at": "19/11/2025 10:05:19",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 10:17:18"
          },
          {
            "ticket_id": 2760,
            "ticket_number": "352755",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "19/11/2025 10:05:24",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 10:17:58"
          },
          {
            "ticket_id": 2762,
            "ticket_number": "352757",
            "title": "Contatos de Cliente em falta - n/File 402834",
            "priority": "P2",
            "created_at": "19/11/2025 10:05:29",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 10:49:40"
          },
          {
            "ticket_id": 2767,
            "ticket_number": "352762",
            "title": "FW: Multibanco - File 415790/25",
            "priority": "P2",
            "created_at": "19/11/2025 10:12:36",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 13:47:04"
          },
          {
            "ticket_id": 2777,
            "ticket_number": "352772",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P3",
            "created_at": "19/11/2025 10:40:49",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 10:40:49"
          },
          {
            "ticket_id": 2778,
            "ticket_number": "352773",
            "title": "Fwd: Reminder : Get ready for your flight AT285 fr",
            "priority": "P2",
            "created_at": "19/11/2025 10:40:51",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 10:40:52"
          },
          {
            "ticket_id": 2781,
            "ticket_number": "352776",
            "title": "cancelamento",
            "priority": "P3",
            "created_at": "19/11/2025 11:05:07",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 11:05:07"
          },
          {
            "ticket_id": 2784,
            "ticket_number": "352779",
            "title": "Re:[## 24221 ##] GBN-85834 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "19/11/2025 12:14:42",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 12:46:37"
          },
          {
            "ticket_id": 2791,
            "ticket_number": "352786",
            "title": "Atividade cancelada: Excursão à ilha Saona de cata",
            "priority": "P3",
            "created_at": "19/11/2025 12:52:39",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 13:47:36"
          },
          {
            "ticket_id": 2796,
            "ticket_number": "352791",
            "title": "Re: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P2",
            "created_at": "19/11/2025 13:42:50",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 16:50:53"
          },
          {
            "ticket_id": 2797,
            "ticket_number": "352792",
            "title": "Seguros NewBlue",
            "priority": "P2",
            "created_at": "19/11/2025 13:42:52",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 13:42:53"
          },
          {
            "ticket_id": 2799,
            "ticket_number": "352794",
            "title": "Eticket - 63517580 - DI  20/11/2025  Miami, Estado",
            "priority": "P3",
            "created_at": "19/11/2025 15:29:03",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 16:52:14"
          },
          {
            "ticket_id": 2830,
            "ticket_number": "352825",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604495154",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 21:03:03",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:02:31"
          },
          {
            "ticket_id": 2836,
            "ticket_number": "352831",
            "title": "Referencia para pagamento | File:416525/2025",
            "priority": "P2",
            "created_at": "19/11/2025 23:38:37",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 17.47,
            "sla_met": false,
            "sla_breach_hours": 13.47,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 17:07:32"
          },
          {
            "ticket_id": 2840,
            "ticket_number": "352835",
            "title": "Levantamento comissões",
            "priority": "P3",
            "created_at": "20/11/2025 10:19:05",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:19:05"
          },
          {
            "ticket_id": 2845,
            "ticket_number": "352840",
            "title": "Adicione novas experiências para sua viagem GBN-68",
            "priority": "P3",
            "created_at": "20/11/2025 10:21:25",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 11:03:55"
          },
          {
            "ticket_id": 2847,
            "ticket_number": "352842",
            "title": "Fwd: Confirmacion de la reserva Transavia: S761WB",
            "priority": "P3",
            "created_at": "20/11/2025 10:33:17",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:33:17"
          },
          {
            "ticket_id": 2849,
            "ticket_number": "352844",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "20/11/2025 10:33:24",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:33:25"
          },
          {
            "ticket_id": 2852,
            "ticket_number": "352847",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "20/11/2025 10:33:36",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:33:37"
          },
          {
            "ticket_id": 2853,
            "ticket_number": "352848",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "20/11/2025 10:33:39",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:33:40"
          },
          {
            "ticket_id": 2854,
            "ticket_number": "352849",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "20/11/2025 10:33:43",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:33:44"
          },
          {
            "ticket_id": 2861,
            "ticket_number": "352856",
            "title": "Confirmação de Reserva * File 415793 - ATUALIZADA",
            "priority": "P3",
            "created_at": "20/11/2025 11:34:08",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 00:16:58"
          },
          {
            "ticket_id": 2874,
            "ticket_number": "352869",
            "title": "Reserva SOLTROPICO 333869",
            "priority": "P3",
            "created_at": "20/11/2025 13:24:53",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 13:24:53"
          },
          {
            "ticket_id": 2877,
            "ticket_number": "352872",
            "title": "Re: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P2",
            "created_at": "20/11/2025 13:25:00",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 14:25:16"
          },
          {
            "ticket_id": 2891,
            "ticket_number": "352886",
            "title": "Mensagem sobre a reserva 35417432 - Civitatis",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:55",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 18.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 11:13:45"
          },
          {
            "ticket_id": 2894,
            "ticket_number": "352889",
            "title": "URGENTE - orçamento Boavista ou SAL ",
            "priority": "P1",
            "created_at": "20/11/2025 17:11:13",
            "close_date": "2025-12-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/11/2025 17:12:32"
          },
          {
            "ticket_id": 2922,
            "ticket_number": "352917",
            "title": "Re: Documentación Reserva: 6121053 - OPTI242100157",
            "priority": "P2",
            "created_at": "21/11/2025 10:05:29",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 10:25:46"
          },
          {
            "ticket_id": 2966,
            "ticket_number": "352961",
            "title": "Confirmação de Reserva * File 416525",
            "priority": "P2",
            "created_at": "21/11/2025 17:48:59",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 19:06:35"
          },
          {
            "ticket_id": 2972,
            "ticket_number": "352967",
            "title": "Fwd: Important : Gate change for your flight AT982",
            "priority": "P2",
            "created_at": "21/11/2025 17:53:00",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 17:53:00"
          },
          {
            "ticket_id": 2982,
            "ticket_number": "352977",
            "title": "Re:[## 13421 ##] GBN-68378 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "21/11/2025 18:41:09",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 18:50:45"
          },
          {
            "ticket_id": 3062,
            "ticket_number": "353055",
            "title": "Fwd: Viagify informa sobre a sua reserva  12216975",
            "priority": "P3",
            "created_at": "24/11/2025 10:07:33",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 10:07:34"
          },
          {
            "ticket_id": 3065,
            "ticket_number": "353058",
            "title": "Fwd: Viagify informa sobre a sua reserva 122172174",
            "priority": "P2",
            "created_at": "24/11/2025 10:07:42",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 10:07:43"
          },
          {
            "ticket_id": 3101,
            "ticket_number": "353094",
            "title": "Pedido de Sinalização De Reserva   334202",
            "priority": "P1",
            "created_at": "24/11/2025 14:14:06",
            "close_date": "2025-11-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.48,
            "sla_met": false,
            "sla_breach_hours": 0.23,
            "sla_name": "SLA P1",
            "first_response_at": "24/11/2025 14:43:55"
          },
          {
            "ticket_id": 3102,
            "ticket_number": "353095",
            "title": "Ainda pode fazer o upgrade da cabina para esta res",
            "priority": "P3",
            "created_at": "24/11/2025 14:14:40",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:45:38"
          },
          {
            "ticket_id": 3147,
            "ticket_number": "353140",
            "title": "Saídas de 25/12/2025 para 29/01/2026 - DADOS OBRIG",
            "priority": "P3",
            "created_at": "25/11/2025 11:07:28",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 12:14:38"
          },
          {
            "ticket_id": 3231,
            "ticket_number": "353224",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "26/11/2025 10:23:46",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:23:46"
          },
          {
            "ticket_id": 3234,
            "ticket_number": "353227",
            "title": "Fwd: Informações da reserva TTN-1222585331#8690670",
            "priority": "P2",
            "created_at": "26/11/2025 10:23:53",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:23:54"
          },
          {
            "ticket_id": 3235,
            "ticket_number": "353228",
            "title": "Fwd: Localizador 1222585331 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "26/11/2025 10:23:56",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:23:56"
          },
          {
            "ticket_id": 3236,
            "ticket_number": "353229",
            "title": "Fwd: Check in for your flight to Amsterdam",
            "priority": "P2",
            "created_at": "26/11/2025 10:23:58",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:23:59"
          },
          {
            "ticket_id": 3238,
            "ticket_number": "353231",
            "title": "Fwd: Check in for your flight to Amsterdam",
            "priority": "P2",
            "created_at": "26/11/2025 10:24:05",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:24:06"
          },
          {
            "ticket_id": 3239,
            "ticket_number": "353232",
            "title": "Fwd: Check in for your flight to Amsterdam",
            "priority": "P2",
            "created_at": "26/11/2025 10:24:09",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 10:24:09"
          },
          {
            "ticket_id": 3242,
            "ticket_number": "353235",
            "title": "Fwd: Viagify informa sobre a sua reserva 122258739",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:24:19",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/11/2025 10:23:51"
          },
          {
            "ticket_id": 3249,
            "ticket_number": "353242",
            "title": "Confirmacao 334615",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 10:25:37",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/11/2025 12:27:51"
          },
          {
            "ticket_id": 3250,
            "ticket_number": "353243",
            "title": "Confirmacao 334616",
            "priority": "P2",
            "created_at": "26/11/2025 10:25:39",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 12:46:11"
          },
          {
            "ticket_id": 3270,
            "ticket_number": "353263",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "26/11/2025 12:48:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 22:42:00"
          },
          {
            "ticket_id": 3274,
            "ticket_number": "353267",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P3",
            "created_at": "26/11/2025 13:34:44",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 33.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 23:22:02"
          },
          {
            "ticket_id": 3302,
            "ticket_number": "353295",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P3",
            "created_at": "26/11/2025 18:09:42",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 14:02:49"
          },
          {
            "ticket_id": 3304,
            "ticket_number": "353297",
            "title": "GBN-91958 - Reenviar informações sobre sua reserva",
            "priority": "P3",
            "created_at": "26/11/2025 18:09:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 19.87,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 14:02:49"
          },
          {
            "ticket_id": 3310,
            "ticket_number": "353303",
            "title": "GBN-91958 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 19:05:14",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 15:02:52"
          },
          {
            "ticket_id": 3333,
            "ticket_number": "353326",
            "title": "GBN-85273 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "26/11/2025 23:45:01",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 11.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 10:54:29"
          },
          {
            "ticket_id": 3335,
            "ticket_number": "353328",
            "title": "Cancelamento Reservas GBN",
            "priority": "P2",
            "created_at": "26/11/2025 23:45:04",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:45:04"
          },
          {
            "ticket_id": 3340,
            "ticket_number": "353333",
            "title": "Criação de processo File 418656/25",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/11/2025 00:28:09",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 34.9,
            "sla_met": false,
            "sla_breach_hours": 10.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 11:22:27"
          },
          {
            "ticket_id": 3352,
            "ticket_number": "353345",
            "title": "GBN-92041 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "27/11/2025 10:54:52",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 11:11:12"
          },
          {
            "ticket_id": 3361,
            "ticket_number": "353354",
            "title": "pedido acesso vila gale",
            "priority": "P2",
            "created_at": "27/11/2025 10:57:00",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 10:57:00"
          },
          {
            "ticket_id": 3365,
            "ticket_number": "353358",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P3",
            "created_at": "27/11/2025 12:13:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 33.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 22:03:30"
          },
          {
            "ticket_id": 3367,
            "ticket_number": "353360",
            "title": "Pedido de Esclarecimentos - Costa Cruzeiro (Tarifa",
            "priority": "P3",
            "created_at": "27/11/2025 13:48:34",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 13:48:34"
          },
          {
            "ticket_id": 3374,
            "ticket_number": "353367",
            "title": "Reserva 418537",
            "priority": "P2",
            "created_at": "27/11/2025 16:37:56",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 18:28:43"
          },
          {
            "ticket_id": 3391,
            "ticket_number": "353384",
            "title": "Confirmação de Reserva * File 416013 - Atualização",
            "priority": "P2",
            "created_at": "27/11/2025 17:16:29",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 18:04:30"
          },
          {
            "ticket_id": 3400,
            "ticket_number": "353393",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "27/11/2025 21:23:00",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 113.18,
            "sla_met": false,
            "sla_breach_hours": 89.18,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 14:34:20"
          },
          {
            "ticket_id": 3401,
            "ticket_number": "353394",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "27/11/2025 21:23:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 113.2,
            "sla_met": false,
            "sla_breach_hours": 89.2,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 14:35:06"
          },
          {
            "ticket_id": 3402,
            "ticket_number": "353395",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "27/11/2025 21:23:08",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 113.2,
            "sla_met": false,
            "sla_breach_hours": 89.2,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 14:35:45"
          },
          {
            "ticket_id": 3415,
            "ticket_number": "353408",
            "title": "Informação importante sobre a tua reserva 1714463",
            "priority": "P3",
            "created_at": "28/11/2025 10:02:58",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 12:54:18"
          },
          {
            "ticket_id": 3416,
            "ticket_number": "353409",
            "title": "Confirmação de reserva para For PT004157 68299122",
            "priority": "P2",
            "created_at": "28/11/2025 10:02:59",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:18:43"
          },
          {
            "ticket_id": 3424,
            "ticket_number": "353417",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 10:03:14",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 10:48:18"
          },
          {
            "ticket_id": 3445,
            "ticket_number": "353438",
            "title": "VOUCHER DA RESERVA 604474579",
            "priority": "P2",
            "created_at": "28/11/2025 11:22:22",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 11:37:19"
          },
          {
            "ticket_id": 3476,
            "ticket_number": "353469",
            "title": "AJUSTE HORÁRIO NA SUA RESERVA  6122131",
            "priority": "P3",
            "created_at": "28/11/2025 16:14:17",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 17:53:53"
          },
          {
            "ticket_id": 3486,
            "ticket_number": "353479",
            "title": "Esclarecimento Urgente - orçamento Black Friday Co",
            "priority": "P1",
            "created_at": "28/11/2025 17:50:39",
            "close_date": "2025-11-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "28/11/2025 18:03:12"
          },
          {
            "ticket_id": 3496,
            "ticket_number": "353489",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 19:14:55",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 91.88,
            "sla_met": false,
            "sla_breach_hours": 67.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 15:08:22"
          },
          {
            "ticket_id": 3499,
            "ticket_number": "353492",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "28/11/2025 19:53:54",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 91.27,
            "sla_met": false,
            "sla_breach_hours": 67.27,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 15:09:56"
          },
          {
            "ticket_id": 3501,
            "ticket_number": "353494",
            "title": "GBN-92436 - Seu pedido foi recebido",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 21:02:08",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 21:02:08"
          },
          {
            "ticket_id": 3522,
            "ticket_number": "353515",
            "title": "Fwd: Informações da reserva TTN-1199097783#8716928",
            "priority": "P3",
            "created_at": "29/11/2025 10:40:12",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 10:40:13"
          },
          {
            "ticket_id": 3525,
            "ticket_number": "353518",
            "title": "Emissão documentos |Solferias",
            "priority": "P3",
            "created_at": "29/11/2025 12:25:16",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 12:25:16"
          },
          {
            "ticket_id": 3584,
            "ticket_number": "353577",
            "title": "RE: Pedido de cotação - Contratação direta",
            "priority": "P3",
            "created_at": "01/12/2025 10:28:45",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 56.77,
            "sla_met": false,
            "sla_breach_hours": 32.77,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 19:15:30"
          },
          {
            "ticket_id": 3622,
            "ticket_number": "353615",
            "title": "GBN-92765 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:21:31",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3623,
            "ticket_number": "353616",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505954",
            "priority": "P3",
            "created_at": "02/12/2025 10:21:33",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 10:21:33"
          },
          {
            "ticket_id": 3627,
            "ticket_number": "353620",
            "title": "GBN-92775 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/12/2025 10:21:42",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 13:29:49"
          },
          {
            "ticket_id": 3628,
            "ticket_number": "353621",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505773",
            "priority": "P3",
            "created_at": "02/12/2025 10:21:44",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 13:20:56"
          },
          {
            "ticket_id": 3641,
            "ticket_number": "353634",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 10:23:24",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 10:23:25"
          },
          {
            "ticket_id": 3642,
            "ticket_number": "353635",
            "title": "Fwd: Informações da reserva TTN-1222578960#8734223",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:28",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:23:14"
          },
          {
            "ticket_id": 3644,
            "ticket_number": "353637",
            "title": "DIOGO PATRÍCIO PEREIRA ALVES |LOCALIZADOR 6124525|",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:35",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:23:35"
          },
          {
            "ticket_id": 3726,
            "ticket_number": "353718",
            "title": "Criação de processo File 420319/25",
            "priority": "Reservas sem Formulário",
            "created_at": "02/12/2025 21:27:46",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 15.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 12:41:26"
          },
          {
            "ticket_id": 3741,
            "ticket_number": "353733",
            "title": "Fwd: Viagify informa sobre a sua reserva   1225026",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 10:05:14",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 10:05:15"
          },
          {
            "ticket_id": 3782,
            "ticket_number": "353774",
            "title": "Fwd: Incidente hotel (Erro de Rebooking) TTN-11854",
            "priority": "P2",
            "created_at": "03/12/2025 14:23:39",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 14:23:40"
          },
          {
            "ticket_id": 3853,
            "ticket_number": "353845",
            "title": "Pedido de cotação de grupo | Newblue",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:30",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:30"
          },
          {
            "ticket_id": 3857,
            "ticket_number": "353849",
            "title": "Confirmação de reserva com localizador: 3996242",
            "priority": "P2",
            "created_at": "04/12/2025 10:04:38",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 11:21:08"
          },
          {
            "ticket_id": 3867,
            "ticket_number": "353859",
            "title": "Reserva Smytravel - 1221160476",
            "priority": "P3",
            "created_at": "04/12/2025 11:42:00",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 11:42:01"
          },
          {
            "ticket_id": 3872,
            "ticket_number": "353864",
            "title": "Cancelamento de reserva 335024",
            "priority": "P3",
            "created_at": "04/12/2025 12:58:04",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 6.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 19:17:25"
          },
          {
            "ticket_id": 3874,
            "ticket_number": "353866",
            "title": "Fwd: Cancelamento reserva 335024",
            "priority": "P3",
            "created_at": "04/12/2025 12:58:11",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 12:58:11"
          },
          {
            "ticket_id": 3880,
            "ticket_number": "353872",
            "title": "Fwd: Informações da sua reserva TTN-1225273071#876",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/12/2025 15:02:22",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:02:23"
          },
          {
            "ticket_id": 3882,
            "ticket_number": "353874",
            "title": "Re:[## 26054 ##] GBN-90829 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "04/12/2025 15:03:03",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 4.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 19:22:02"
          },
          {
            "ticket_id": 3897,
            "ticket_number": "353889",
            "title": "MVU: Cambio Vuelo: 4127384 FAMILIAP 001",
            "priority": "P3",
            "created_at": "04/12/2025 18:34:12",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 18:59:27"
          },
          {
            "ticket_id": 3936,
            "ticket_number": "353928",
            "title": "Fwd: Informações da reserva TTN-1223216620#8768581",
            "priority": "P2",
            "created_at": "05/12/2025 12:15:17",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 12:15:18"
          },
          {
            "ticket_id": 3938,
            "ticket_number": "353930",
            "title": "RE: Multibanco - File 420319/25",
            "priority": "P2",
            "created_at": "05/12/2025 12:16:33",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 12:32:57"
          },
          {
            "ticket_id": 3939,
            "ticket_number": "353931",
            "title": "Novos tours na Civitatis.com",
            "priority": "P2",
            "created_at": "05/12/2025 12:16:37",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 12:33:21"
          },
          {
            "ticket_id": 3944,
            "ticket_number": "353936",
            "title": "BeNice Travel | Orçamento Disneyland 5-8 de outubr",
            "priority": "P2",
            "created_at": "05/12/2025 13:19:03",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 13:19:03"
          },
          {
            "ticket_id": 3960,
            "ticket_number": "353952",
            "title": "orçamento newblue",
            "priority": "P2",
            "created_at": "05/12/2025 16:52:08",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 16:52:08"
          },
          {
            "ticket_id": 3963,
            "ticket_number": "353955",
            "title": "Re: Confirmação de reserva 331561 ####### TIME LIM",
            "priority": "P2",
            "created_at": "05/12/2025 17:29:17",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 17:31:06"
          },
          {
            "ticket_id": 4135,
            "ticket_number": "354127",
            "title": "Pedido de Contacto Movel - 335371 // Partida: 2026",
            "priority": "P2",
            "created_at": "10/12/2025 10:28:41",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 12:37:45"
          },
          {
            "ticket_id": 4136,
            "ticket_number": "354128",
            "title": "Re:[## 26691 ##] GBN-85066 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "10/12/2025 10:47:06",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 12:52:07"
          },
          {
            "ticket_id": 4145,
            "ticket_number": "354137",
            "title": "Documentação Disponível - Reserva 331561",
            "priority": "P2",
            "created_at": "10/12/2025 11:20:37",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 11:29:02"
          },
          {
            "ticket_id": 4150,
            "ticket_number": "354142",
            "title": "Mensagem sobre a reserva 35047646 - Civitatis",
            "priority": "P2",
            "created_at": "10/12/2025 12:27:32",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 13:01:51"
          },
          {
            "ticket_id": 4151,
            "ticket_number": "354143",
            "title": "Mensagem sobre a reserva 35047646 - Civitatis",
            "priority": "P2",
            "created_at": "10/12/2025 12:27:35",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 13:03:20"
          },
          {
            "ticket_id": 4159,
            "ticket_number": "354151",
            "title": "Fwd: Reembolso cliente Gisela Carvalho",
            "priority": "P2",
            "created_at": "10/12/2025 13:18:53",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 13:18:53"
          },
          {
            "ticket_id": 4196,
            "ticket_number": "354188",
            "title": "GBN-92765 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/12/2025 19:18:29",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 23:04:01"
          },
          {
            "ticket_id": 4210,
            "ticket_number": "354202",
            "title": "2025-0002203274/",
            "priority": "P2",
            "created_at": "11/12/2025 00:08:14",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 00:48:18"
          },
          {
            "ticket_id": 4218,
            "ticket_number": "354210",
            "title": "Re:[## 27024 ##] GBN-92765 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/12/2025 11:24:48",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 12:04:15"
          },
          {
            "ticket_id": 4224,
            "ticket_number": "354216",
            "title": "Re:[## 26284 ##] GBN-83808 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/12/2025 12:10:51",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 12:16:33"
          },
          {
            "ticket_id": 4238,
            "ticket_number": "354230",
            "title": "Localizador SMY-1214208580 - RECLAMAÇÃO e Pedido d",
            "priority": "P2",
            "created_at": "11/12/2025 17:37:41",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 17:37:42"
          },
          {
            "ticket_id": 4264,
            "ticket_number": "354256",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P3",
            "created_at": "12/12/2025 10:24:34",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 6.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 16:26:37"
          },
          {
            "ticket_id": 4282,
            "ticket_number": "354274",
            "title": "Pagamento GBN-75128",
            "priority": "P2",
            "created_at": "12/12/2025 12:19:04",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:23:31"
          },
          {
            "ticket_id": 4283,
            "ticket_number": "354275",
            "title": "RESERVA LEPLAN 604481833 11/1",
            "priority": "P2",
            "created_at": "12/12/2025 12:19:07",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:25:45"
          },
          {
            "ticket_id": 4309,
            "ticket_number": "354301",
            "title": "FW: Weekend Treasure - Boa Festas em Classe Execut",
            "priority": "P2",
            "created_at": "12/12/2025 17:26:55",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 17:33:28"
          },
          {
            "ticket_id": 4386,
            "ticket_number": "354378",
            "title": "Fwd: Viagify informa sobre a sua reserva 122747105",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:18",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:11:18"
          },
          {
            "ticket_id": 4402,
            "ticket_number": "354394",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "15/12/2025 10:55:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:55:57"
          },
          {
            "ticket_id": 38,
            "ticket_number": "35038",
            "title": "Re: Fwd: Grupo: GR-0CE002ABEB (#2553306)",
            "priority": "P3",
            "created_at": "30/09/2025 09:06:48",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 09:06:48"
          },
          {
            "ticket_id": 75,
            "ticket_number": "35074",
            "title": "GBN-51883 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "30/09/2025 15:27:37",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 12:59:23"
          },
          {
            "ticket_id": 2015,
            "ticket_number": "352011",
            "title": "Re:[## 13421 ##] GBN-68378 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "07/11/2025 18:09:59",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 19:20:54"
          },
          {
            "ticket_id": 2042,
            "ticket_number": "352038",
            "title": "URGENTE - Viagem de Grupo - Pedido de Orçamento",
            "priority": "P2",
            "created_at": "08/11/2025 12:43:09",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 12:43:09"
          },
          {
            "ticket_id": 2176,
            "ticket_number": "352172",
            "title": "URGENTE  cancelamento/ alteração reserva 415469",
            "priority": "P2",
            "created_at": "11/11/2025 10:15:46",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 10:15:47"
          },
          {
            "ticket_id": 2202,
            "ticket_number": "352198",
            "title": "tour? - File 415469/25",
            "priority": "P2",
            "created_at": "11/11/2025 15:57:32",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:24:07"
          },
          {
            "ticket_id": 2218,
            "ticket_number": "352214",
            "title": "GBN-89265 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "11/11/2025 18:29:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/11/2025 11:49:14"
          },
          {
            "ticket_id": 2319,
            "ticket_number": "352314",
            "title": "Criação de processo File 415790/25",
            "priority": "P2",
            "created_at": "12/11/2025 20:43:44",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 20.18,
            "sla_met": false,
            "sla_breach_hours": 16.18,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 16:55:25"
          },
          {
            "ticket_id": 2460,
            "ticket_number": "352455",
            "title": "Emissão bilhetes Disney -   415573",
            "priority": "P2",
            "created_at": "14/11/2025 10:48:54",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 10:48:54"
          },
          {
            "ticket_id": 2518,
            "ticket_number": "352513",
            "title": "Voucher Luis Brito MX Diciembre",
            "priority": "P3",
            "created_at": "14/11/2025 22:41:14",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/11/2025 00:09:58"
          },
          {
            "ticket_id": 2613,
            "ticket_number": "352608",
            "title": "Fwd: Consulta sobre o seu pedido / LOC 1198583451 ",
            "priority": "P2",
            "created_at": "17/11/2025 16:45:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 16:45:57"
          },
          {
            "ticket_id": 2639,
            "ticket_number": "352634",
            "title": "[Ticket#2025111785002311] RE: Solicitud de Presupu",
            "priority": "P3",
            "created_at": "17/11/2025 19:26:20",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 17.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:46:12"
          },
          {
            "ticket_id": 2793,
            "ticket_number": "352788",
            "title": "Dúvida urgente para fechar orçamento - Transfer pr",
            "priority": "P2",
            "created_at": "19/11/2025 13:26:37",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 13:26:37"
          },
          {
            "ticket_id": 2800,
            "ticket_number": "352795",
            "title": "Orçamento NewBlue",
            "priority": "P3",
            "created_at": "19/11/2025 15:29:06",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 15:29:07"
          },
          {
            "ticket_id": 2816,
            "ticket_number": "352811",
            "title": "Fwd: Costa - 34501737 - Patrícia Braga",
            "priority": "P3",
            "created_at": "19/11/2025 18:18:03",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 18:18:03"
          },
          {
            "ticket_id": 2841,
            "ticket_number": "352836",
            "title": "IMPORTANTE GBN-90829",
            "priority": "P3",
            "created_at": "20/11/2025 10:19:07",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 10:19:07"
          },
          {
            "ticket_id": 2902,
            "ticket_number": "352897",
            "title": "GBN-68378 - Sua reserva foi atualizada com serviço",
            "priority": "P2",
            "created_at": "20/11/2025 18:33:18",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 19:28:32"
          },
          {
            "ticket_id": 3001,
            "ticket_number": "352996",
            "title": "Fwd: Viagify informa sobre a sua reserva 122130037",
            "priority": "P2",
            "created_at": "21/11/2025 22:08:56",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 22:08:56"
          },
          {
            "ticket_id": 3008,
            "ticket_number": "353003",
            "title": "Urgente Cliente - Orçamento de GRUPO Á SOLFÉRIAS -",
            "priority": "P2",
            "created_at": "22/11/2025 09:59:50",
            "close_date": "2026-01-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 09:59:50"
          },
          {
            "ticket_id": 3031,
            "ticket_number": "353026",
            "title": "Reserva TUI (10045570) - UMA FAMILIA EM VIAGEM (HO",
            "priority": "P2",
            "created_at": "22/11/2025 20:42:31",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 38.97,
            "sla_met": false,
            "sla_breach_hours": 34.97,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:40:44"
          },
          {
            "ticket_id": 3094,
            "ticket_number": "353087",
            "title": "Fwd: Informações da sua reserva TTN-1221721747#866",
            "priority": "P2",
            "created_at": "24/11/2025 13:23:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 13:23:35"
          },
          {
            "ticket_id": 3100,
            "ticket_number": "353093",
            "title": "Pedido de Sinalização De Reserva 334142",
            "priority": "P3",
            "created_at": "24/11/2025 14:14:04",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:39:05"
          },
          {
            "ticket_id": 3125,
            "ticket_number": "353118",
            "title": "Reserva STP002501547595 - Lugares pagos 45L e 45J",
            "priority": "P2",
            "created_at": "24/11/2025 19:08:07",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 19:08:08"
          },
          {
            "ticket_id": 3164,
            "ticket_number": "353157",
            "title": "REALOJAMENTO - Reserva loc. 3932193 ( Ana Paula Si",
            "priority": "P3",
            "created_at": "25/11/2025 13:09:34",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:22:32"
          },
          {
            "ticket_id": 3172,
            "ticket_number": "353165",
            "title": "Envio de Documentação * File 407385",
            "priority": "P3",
            "created_at": "25/11/2025 13:41:08",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 5.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 19:12:32"
          },
          {
            "ticket_id": 3202,
            "ticket_number": "353195",
            "title": "GBN-91703 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "25/11/2025 17:44:51",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 18:23:05"
          },
          {
            "ticket_id": 3203,
            "ticket_number": "353196",
            "title": "Confirmação de Reserva * File 416013 - Atualização",
            "priority": "P3",
            "created_at": "25/11/2025 17:49:16",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 21:32:34"
          },
          {
            "ticket_id": 3204,
            "ticket_number": "353197",
            "title": "Civibot - Reclamación",
            "priority": "P3",
            "created_at": "25/11/2025 18:10:27",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 16.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 10:41:39"
          },
          {
            "ticket_id": 3210,
            "ticket_number": "353203",
            "title": "Reserva - 6119682",
            "priority": "P3",
            "created_at": "25/11/2025 19:14:56",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 15:01:08"
          },
          {
            "ticket_id": 3211,
            "ticket_number": "353204",
            "title": "Reservas - 6119682 + 6120803 + 6120795",
            "priority": "P2",
            "created_at": "25/11/2025 19:20:45",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 478.48,
            "sla_met": false,
            "sla_breach_hours": 474.48,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 17:50:19"
          },
          {
            "ticket_id": 3224,
            "ticket_number": "353217",
            "title": "Pedido orçamento grupo - Zanzibar - 16 pessoas Jul",
            "priority": "P2",
            "created_at": "25/11/2025 22:49:04",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 12:44:16"
          },
          {
            "ticket_id": 3253,
            "ticket_number": "353246",
            "title": "Erros na plataforma",
            "priority": "P3",
            "created_at": "26/11/2025 11:00:24",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 462.83,
            "sla_met": false,
            "sla_breach_hours": 438.83,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 17:50:56"
          },
          {
            "ticket_id": 3264,
            "ticket_number": "353257",
            "title": "Pedido de informação urgente",
            "priority": "P2",
            "created_at": "26/11/2025 12:20:15",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 12:20:15"
          },
          {
            "ticket_id": 3288,
            "ticket_number": "353281",
            "title": "Reserva em WL 208883",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:17",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 17:34:57"
          },
          {
            "ticket_id": 3329,
            "ticket_number": "353322",
            "title": "Reserva GBN - cancelamento gratuito",
            "priority": "P3",
            "created_at": "26/11/2025 23:44:52",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 23:44:53"
          },
          {
            "ticket_id": 3368,
            "ticket_number": "353361",
            "title": "GBN-92059 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/11/2025 13:48:36",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 17:41:29"
          },
          {
            "ticket_id": 3373,
            "ticket_number": "353366",
            "title": "Fwd: Informações da sua reserva TTN-1222039695#870",
            "priority": "P3",
            "created_at": "27/11/2025 16:13:49",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 11:07:32"
          },
          {
            "ticket_id": 3385,
            "ticket_number": "353378",
            "title": "1ª VIA - Confirmação de Reserva n. 10045570 - UMA ",
            "priority": "P3",
            "created_at": "27/11/2025 16:52:05",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 17:12:11"
          },
          {
            "ticket_id": 3421,
            "ticket_number": "353414",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497469",
            "priority": "P2",
            "created_at": "28/11/2025 10:03:08",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:39:15"
          },
          {
            "ticket_id": 3479,
            "ticket_number": "353472",
            "title": "GBN-83958",
            "priority": "P2",
            "created_at": "28/11/2025 16:54:05",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 16:54:05"
          },
          {
            "ticket_id": 3482,
            "ticket_number": "353475",
            "title": "Fwd: Informações da reserva TTN-1199097783#8716928",
            "priority": "P3",
            "created_at": "28/11/2025 17:01:24",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 16:52:55"
          },
          {
            "ticket_id": 3488,
            "ticket_number": "353481",
            "title": "grupo de angariação namibia",
            "priority": "P3",
            "created_at": "28/11/2025 17:56:13",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 17:56:13"
          },
          {
            "ticket_id": 3559,
            "ticket_number": "353552",
            "title": "GBN-92646 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "30/11/2025 11:43:01",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 124.7,
            "sla_met": false,
            "sla_breach_hours": 100.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 16:25:25"
          },
          {
            "ticket_id": 3625,
            "ticket_number": "353618",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505844",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 10:21:38",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 192.67,
            "sla_met": false,
            "sla_breach_hours": 168.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 11:02:09"
          },
          {
            "ticket_id": 3631,
            "ticket_number": "353624",
            "title": "Criação de processo File   419933/25",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 10:21:56",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 226.78,
            "sla_met": false,
            "sla_breach_hours": 202.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 21:09:19"
          },
          {
            "ticket_id": 3654,
            "ticket_number": "353647",
            "title": "Orçamento Newblue Urgente _suplemento criança 12 a",
            "priority": "P2",
            "created_at": "02/12/2025 10:24:07",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:24:08"
          },
          {
            "ticket_id": 3666,
            "ticket_number": "353659",
            "title": "Confirmação de Reserva * File 419153*( Time Limit ",
            "priority": "P3",
            "created_at": "02/12/2025 12:00:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 5.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:13:48"
          },
          {
            "ticket_id": 3684,
            "ticket_number": "353676",
            "title": "Urgente - Nomes com erros - reservas GBN- para che",
            "priority": "P3",
            "created_at": "02/12/2025 13:50:15",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 13:50:15"
          },
          {
            "ticket_id": 3702,
            "ticket_number": "353694",
            "title": "orçamento para um grupo de angariação Namibia",
            "priority": "P3",
            "created_at": "02/12/2025 17:10:16",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:10:16"
          },
          {
            "ticket_id": 3709,
            "ticket_number": "353701",
            "title": "Confirmação de Reserva * File 419153*( Time Limit ",
            "priority": "P3",
            "created_at": "02/12/2025 18:00:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 18:00:17"
          },
          {
            "ticket_id": 3745,
            "ticket_number": "353737",
            "title": "Re: [Ticket#2025110685002618] Pedido de orçamento ",
            "priority": "P3",
            "created_at": "03/12/2025 10:05:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 7.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 17:17:50"
          },
          {
            "ticket_id": 3746,
            "ticket_number": "353738",
            "title": "Contratação direta com Hotel Scandic Kodbyen - Cop",
            "priority": "P3",
            "created_at": "03/12/2025 10:05:26",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 10:05:27"
          },
          {
            "ticket_id": 3787,
            "ticket_number": "353779",
            "title": "GBN-93102 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 15:06:35",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:08:45"
          },
          {
            "ticket_id": 3852,
            "ticket_number": "353844",
            "title": "Pedido de cotação de grupo | Soltrópico",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:28",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:28"
          },
          {
            "ticket_id": 3854,
            "ticket_number": "353846",
            "title": "Pedido de cotação de grupo | Nortravel",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:32",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:32"
          },
          {
            "ticket_id": 3860,
            "ticket_number": "353852",
            "title": "Fwd: Informações da reserva TTN-1185483527#8757045",
            "priority": "P3",
            "created_at": "04/12/2025 11:18:40",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 11:18:41"
          },
          {
            "ticket_id": 3869,
            "ticket_number": "353861",
            "title": "Confirmação de reserva 335294",
            "priority": "P3",
            "created_at": "04/12/2025 12:21:40",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 13:03:03"
          },
          {
            "ticket_id": 3871,
            "ticket_number": "353863",
            "title": "loc1223216620",
            "priority": "P2",
            "created_at": "04/12/2025 12:25:03",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 15:11:58"
          },
          {
            "ticket_id": 3888,
            "ticket_number": "353880",
            "title": "Informação de reserva - SPT002501558557",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/12/2025 16:41:30",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 17:07:29"
          },
          {
            "ticket_id": 3894,
            "ticket_number": "353886",
            "title": "Fwd: Informações da reserva TTN-1223216620#8768581",
            "priority": "P3",
            "created_at": "04/12/2025 18:17:43",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 18:17:44"
          },
          {
            "ticket_id": 3898,
            "ticket_number": "353890",
            "title": "GBN-86003 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "04/12/2025 18:49:26",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1684.67,
            "sla_met": false,
            "sla_breach_hours": 1660.67,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 23:30:01"
          },
          {
            "ticket_id": 3943,
            "ticket_number": "353935",
            "title": "GBN-57322 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/12/2025 13:18:59",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 13:35:22"
          },
          {
            "ticket_id": 3947,
            "ticket_number": "353939",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "05/12/2025 13:19:16",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 16:06:44"
          },
          {
            "ticket_id": 3948,
            "ticket_number": "353940",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "05/12/2025 13:19:19",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 16:08:38"
          },
          {
            "ticket_id": 3949,
            "ticket_number": "353941",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "05/12/2025 13:19:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 16:09:39"
          },
          {
            "ticket_id": 3950,
            "ticket_number": "353942",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "05/12/2025 13:19:24",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 2.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 16:05:51"
          },
          {
            "ticket_id": 3959,
            "ticket_number": "353951",
            "title": "Pagamento",
            "priority": "P3",
            "created_at": "05/12/2025 16:11:25",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 99.63,
            "sla_met": false,
            "sla_breach_hours": 75.63,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 19:49:28"
          },
          {
            "ticket_id": 3968,
            "ticket_number": "353960",
            "title": "Re:[## 26636 ##] GBN-57322 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "05/12/2025 18:30:54",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 18:32:45"
          },
          {
            "ticket_id": 4048,
            "ticket_number": "354040",
            "title": "Dúvida sobre Reserva",
            "priority": "P3",
            "created_at": "09/12/2025 10:25:58",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 11:04:10"
          },
          {
            "ticket_id": 4125,
            "ticket_number": "354117",
            "title": "FW: Pedido de reembolso recebido e referenciado à ",
            "priority": "P3",
            "created_at": "10/12/2025 10:01:45",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 10:01:45"
          },
          {
            "ticket_id": 4130,
            "ticket_number": "354122",
            "title": "Reserva: A35592006 - Civitatis - Reclamação",
            "priority": "P3",
            "created_at": "10/12/2025 10:12:10",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 11:48:37"
          },
          {
            "ticket_id": 4144,
            "ticket_number": "354136",
            "title": "Ttrsnsferência bancária para viagem futura - clien",
            "priority": "P3",
            "created_at": "10/12/2025 11:20:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 11:20:35"
          },
          {
            "ticket_id": 4153,
            "ticket_number": "354145",
            "title": "Orçamento aluguer de mota",
            "priority": "P3",
            "created_at": "10/12/2025 12:35:08",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 12:35:09"
          },
          {
            "ticket_id": 4161,
            "ticket_number": "354153",
            "title": "Pedido de cotação Grupo newblue",
            "priority": "P3",
            "created_at": "10/12/2025 13:36:47",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 13:46:33"
          },
          {
            "ticket_id": 4177,
            "ticket_number": "354169",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604469451",
            "priority": "P3",
            "created_at": "10/12/2025 17:28:45",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 17:43:50"
          },
          {
            "ticket_id": 4178,
            "ticket_number": "354170",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604466293",
            "priority": "P2",
            "created_at": "10/12/2025 17:28:47",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:50:49"
          },
          {
            "ticket_id": 4179,
            "ticket_number": "354171",
            "title": "RV: Confirmacion de la reserva Transavia: LG9TJA",
            "priority": "P2",
            "created_at": "10/12/2025 17:29:25",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:51:35"
          },
          {
            "ticket_id": 4181,
            "ticket_number": "354173",
            "title": "RV: Confirmacion de la reserva Transavia: TBHIFP",
            "priority": "P2",
            "created_at": "10/12/2025 17:29:37",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:53:30"
          },
          {
            "ticket_id": 4184,
            "ticket_number": "354176",
            "title": "Reserva Newblue 6124269 - Natália e António - pedi",
            "priority": "P2",
            "created_at": "10/12/2025 17:54:58",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 17:54:59"
          },
          {
            "ticket_id": 4221,
            "ticket_number": "354213",
            "title": "Re: GBN-75137",
            "priority": "P3",
            "created_at": "11/12/2025 11:47:36",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 11:47:36"
          },
          {
            "ticket_id": 4236,
            "ticket_number": "354228",
            "title": "Cotización Estudiantes  - cntravel -Ref* 17015545 ",
            "priority": "P3",
            "created_at": "11/12/2025 17:37:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 17:46:45"
          },
          {
            "ticket_id": 4262,
            "ticket_number": "354254",
            "title": "Pedido de informação",
            "priority": "P3",
            "created_at": "12/12/2025 10:08:04",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:08:04"
          },
          {
            "ticket_id": 4265,
            "ticket_number": "354257",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "12/12/2025 10:28:31",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 6.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 16:29:15"
          },
          {
            "ticket_id": 4267,
            "ticket_number": "354259",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "12/12/2025 10:28:35",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 6.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 16:30:42"
          },
          {
            "ticket_id": 4271,
            "ticket_number": "354263",
            "title": "Re: Odisseias",
            "priority": "P3",
            "created_at": "12/12/2025 10:28:44",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:28:45"
          },
          {
            "ticket_id": 4273,
            "ticket_number": "354265",
            "title": "URGENTE URGENTE Confirmação de reserva 335599### T",
            "priority": "P2",
            "created_at": "12/12/2025 11:28:19",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.97,
            "sla_met": false,
            "sla_breach_hours": 0.97,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 16:26:22"
          },
          {
            "ticket_id": 4279,
            "ticket_number": "354271",
            "title": "Cancelamento de voo. Pedido de alteração da reserv",
            "priority": "P3",
            "created_at": "12/12/2025 11:53:20",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 11:53:21"
          },
          {
            "ticket_id": 4302,
            "ticket_number": "354294",
            "title": "Subject. Soltour: Modificação de Voos: SPT00250154",
            "priority": "P2",
            "created_at": "12/12/2025 14:41:53",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:45:14"
          },
          {
            "ticket_id": 4304,
            "ticket_number": "354296",
            "title": "Pedido de cotação",
            "priority": "P3",
            "created_at": "12/12/2025 15:09:39",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 74.8,
            "sla_met": false,
            "sla_breach_hours": 50.8,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 17:58:38"
          },
          {
            "ticket_id": 4307,
            "ticket_number": "354299",
            "title": "GBN-94229 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/12/2025 16:13:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 17:21:20"
          },
          {
            "ticket_id": 4316,
            "ticket_number": "354308",
            "title": "Re:[## 27166 ##] GBN-94229 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/12/2025 18:15:00",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 19:05:39"
          },
          {
            "ticket_id": 4317,
            "ticket_number": "354309",
            "title": "Re:[## 22004 ##] GBN-51883 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/12/2025 18:34:51",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 72.53,
            "sla_met": false,
            "sla_breach_hours": 48.53,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 19:07:16"
          },
          {
            "ticket_id": 4344,
            "ticket_number": "354336",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/12/2025 12:16:17",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 28.15,
            "sla_met": false,
            "sla_breach_hours": 4.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/12/2025 16:26:04"
          },
          {
            "ticket_id": 4345,
            "ticket_number": "354337",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/12/2025 12:16:19",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/12/2025 12:16:24"
          },
          {
            "ticket_id": 4348,
            "ticket_number": "354340",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/12/2025 12:21:57",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 09:07:45"
          },
          {
            "ticket_id": 4372,
            "ticket_number": "354364",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/12/2025 16:22:42",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/12/2025 12:23:05"
          },
          {
            "ticket_id": 4387,
            "ticket_number": "354379",
            "title": "Pedido Orçamento Grupo | Cabo Verde - Tiago Ferrei",
            "priority": "P3",
            "created_at": "15/12/2025 10:11:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 10:11:20"
          },
          {
            "ticket_id": 4416,
            "ticket_number": "354408",
            "title": "Pedido de Reembolso Transfers (Smy 1125356410)",
            "priority": "P3",
            "created_at": "15/12/2025 12:43:55",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 12:43:55"
          },
          {
            "ticket_id": 4435,
            "ticket_number": "354427",
            "title": "Pedido de orçamento – Grupo empresa | Cruzeiro Dou",
            "priority": "P2",
            "created_at": "15/12/2025 15:13:57",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 15:13:57"
          },
          {
            "ticket_id": 4437,
            "ticket_number": "354429",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P3",
            "created_at": "15/12/2025 15:14:05",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 15:31:31"
          },
          {
            "ticket_id": 4438,
            "ticket_number": "354430",
            "title": "Pedido de cotação para grupo",
            "priority": "P2",
            "created_at": "15/12/2025 15:43:53",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 16:35:10"
          },
          {
            "ticket_id": 4441,
            "ticket_number": "354433",
            "title": "Pedido de cotação para grupo - 60 pessoas",
            "priority": "P3",
            "created_at": "15/12/2025 15:51:07",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 15:51:07"
          },
          {
            "ticket_id": 4450,
            "ticket_number": "354442",
            "title": "Re: Opti 249100039_Andreia Monteiro",
            "priority": "P3",
            "created_at": "15/12/2025 18:09:58",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 18:09:59"
          },
          {
            "ticket_id": 4479,
            "ticket_number": "354471",
            "title": "Fwd: Viagify informa sobre a sua reserva 122778027",
            "priority": "P3",
            "created_at": "16/12/2025 10:16:54",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 10:16:54"
          },
          {
            "ticket_id": 4486,
            "ticket_number": "354478",
            "title": "[OUTSIDE EMAIL] Pedido de cotação para grupo - 60 ",
            "priority": "P3",
            "created_at": "16/12/2025 10:19:45",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 12:03:47"
          },
          {
            "ticket_id": 4487,
            "ticket_number": "354479",
            "title": "Quotation Document For Group AJOLV - C/O UmaFAEMVi",
            "priority": "P3",
            "created_at": "16/12/2025 10:19:49",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 12:07:42"
          },
          {
            "ticket_id": 4494,
            "ticket_number": "354486",
            "title": "GBN-94881 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/12/2025 12:13:46",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 12:16:23"
          },
          {
            "ticket_id": 4498,
            "ticket_number": "354490",
            "title": "Fwd: Incidente de voo TTN-1165822742#81169139#T143",
            "priority": "P2",
            "created_at": "16/12/2025 14:44:28",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:55:59"
          },
          {
            "ticket_id": 4502,
            "ticket_number": "354494",
            "title": "Tours - Tailândia e Zanzibar",
            "priority": "P3",
            "created_at": "16/12/2025 15:56:22",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 15:56:22"
          },
          {
            "ticket_id": 4504,
            "ticket_number": "354496",
            "title": "Fwd: Informações da reserva TTN-1185483527#8844650",
            "priority": "P3",
            "created_at": "16/12/2025 16:33:25",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 16:33:26"
          },
          {
            "ticket_id": 4505,
            "ticket_number": "354497",
            "title": "Fwd: Informações da reserva TTN-1185483527#8844622",
            "priority": "P3",
            "created_at": "16/12/2025 16:33:29",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 16:33:31"
          },
          {
            "ticket_id": 4509,
            "ticket_number": "354501",
            "title": "Alteração horários voos OPO-PXO HAT // 334866",
            "priority": "P2",
            "created_at": "16/12/2025 17:36:28",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 19:34:45"
          },
          {
            "ticket_id": 4512,
            "ticket_number": "354504",
            "title": "File 414136/25",
            "priority": "P2",
            "created_at": "16/12/2025 18:01:30",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 19:36:26"
          },
          {
            "ticket_id": 4515,
            "ticket_number": "354507",
            "title": "Cotaçao transfers Cuba",
            "priority": "P2",
            "created_at": "16/12/2025 19:34:22",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 23:23:35"
          },
          {
            "ticket_id": 4520,
            "ticket_number": "354512",
            "title": "Civitatis - Re: Cotaçao transfers Cuba",
            "priority": "P3",
            "created_at": "17/12/2025 10:05:30",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 14:04:14"
          },
          {
            "ticket_id": 4527,
            "ticket_number": "354519",
            "title": "Confirmación de la reserva con localizador: 400698",
            "priority": "P3",
            "created_at": "17/12/2025 10:08:57",
            "close_date": "2025-12-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 20:01:06"
          },
          {
            "ticket_id": 4531,
            "ticket_number": "354523",
            "title": "Fwd: Informações da reserva TTN-1221160476#8771473",
            "priority": "P2",
            "created_at": "17/12/2025 11:07:12",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 11:07:12"
          },
          {
            "ticket_id": 4539,
            "ticket_number": "354531",
            "title": "Hemos recibido tu solicitud",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:35",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:18:51"
          },
          {
            "ticket_id": 4540,
            "ticket_number": "354532",
            "title": "Pedido de cotação alojamento - Deixa-te levar tour",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:37",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:11:37"
          },
          {
            "ticket_id": 4541,
            "ticket_number": "354533",
            "title": "Hemos recibido tu solicitud",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:39",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:18:32"
          },
          {
            "ticket_id": 4543,
            "ticket_number": "354535",
            "title": "Hemos recibido tu solicitud",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:42",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:18:51"
          },
          {
            "ticket_id": 4544,
            "ticket_number": "354536",
            "title": "Hemos recibido tu solicitud",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:44",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:18:51"
          },
          {
            "ticket_id": 4545,
            "ticket_number": "354537",
            "title": "Confirmation of your request from Cuban Travel Age",
            "priority": "P3",
            "created_at": "17/12/2025 13:13:22",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 3.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 16:17:36"
          },
          {
            "ticket_id": 4547,
            "ticket_number": "354539",
            "title": "Envio de Documentação * File 415420",
            "priority": "P3",
            "created_at": "17/12/2025 13:54:03",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 4.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 18:10:47"
          },
          {
            "ticket_id": 4548,
            "ticket_number": "354540",
            "title": "Colaboración agencias cubanas",
            "priority": "P3",
            "created_at": "17/12/2025 13:55:41",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 4.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 18:20:47"
          },
          {
            "ticket_id": 4550,
            "ticket_number": "354542",
            "title": "Re: Agencia TripCuba Uma Família em Viagem - PT",
            "priority": "P3",
            "created_at": "17/12/2025 15:26:07",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 15:37:05"
          },
          {
            "ticket_id": 4555,
            "ticket_number": "354547",
            "title": "Re: Agencia TripCuba Uma Família em Viagem - PT",
            "priority": "P2",
            "created_at": "17/12/2025 16:28:49",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 17:14:50"
          },
          {
            "ticket_id": 4560,
            "ticket_number": "354552",
            "title": "Cancelamento + 14 dias PPT",
            "priority": "P3",
            "created_at": "17/12/2025 18:27:13",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 19:11:47"
          },
          {
            "ticket_id": 4567,
            "ticket_number": "354559",
            "title": "TRANSFER DE PARIS |",
            "priority": "P3",
            "created_at": "17/12/2025 22:56:57",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 22:56:58"
          },
          {
            "ticket_id": 4571,
            "ticket_number": "354563",
            "title": "Orçamento para alteração da reserva GBN 90206",
            "priority": "P3",
            "created_at": "18/12/2025 10:06:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 10:06:38"
          },
          {
            "ticket_id": 4573,
            "ticket_number": "354565",
            "title": "Fwd: Reservas de Grupos pendentes de aceitação",
            "priority": "P3",
            "created_at": "18/12/2025 10:23:18",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 10:23:19"
          },
          {
            "ticket_id": 4575,
            "ticket_number": "354567",
            "title": "Confirmação de reserva 335785 ### TIME LIMIT EMISS",
            "priority": "P3",
            "created_at": "18/12/2025 11:05:04",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 11:06:12"
          },
          {
            "ticket_id": 4576,
            "ticket_number": "354568",
            "title": "URGENTE Confirmação de reserva 335785 ### TIME LIM",
            "priority": "P3",
            "created_at": "18/12/2025 11:06:46",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 11:13:32"
          },
          {
            "ticket_id": 4581,
            "ticket_number": "354573",
            "title": "Informação de reserva - SPT002501546715",
            "priority": "P2",
            "created_at": "18/12/2025 12:35:22",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 14:00:24"
          },
          {
            "ticket_id": 4583,
            "ticket_number": "354575",
            "title": "Re:[## 27535 ##] GBN-92201 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "18/12/2025 13:22:18",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 14:03:16"
          },
          {
            "ticket_id": 4584,
            "ticket_number": "354576",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P3",
            "created_at": "18/12/2025 13:47:38",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 14:04:33"
          },
          {
            "ticket_id": 4585,
            "ticket_number": "354577",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P3",
            "created_at": "18/12/2025 13:47:43",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 14:05:36"
          },
          {
            "ticket_id": 4586,
            "ticket_number": "354578",
            "title": "Orçamento de grupo",
            "priority": "P3",
            "created_at": "18/12/2025 15:03:47",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 15:03:48"
          },
          {
            "ticket_id": 4591,
            "ticket_number": "354583",
            "title": "File 420319 | Bolo e Champagne a bordo EK",
            "priority": "P2",
            "created_at": "18/12/2025 15:47:06",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 18:05:03"
          },
          {
            "ticket_id": 4603,
            "ticket_number": "354595",
            "title": "Re: Agencia TripCuba Uma Família em Viagem - PT",
            "priority": "P3",
            "created_at": "18/12/2025 21:14:37",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 16.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 13:57:03"
          },
          {
            "ticket_id": 4608,
            "ticket_number": "354600",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604513231",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 23:51:53",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 186.72,
            "sla_met": false,
            "sla_breach_hours": 162.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/12/2025 18:35:38"
          },
          {
            "ticket_id": 4613,
            "ticket_number": "354605",
            "title": "DQ2S9K – Alteração de Horário – Aceite",
            "priority": "P3",
            "created_at": "19/12/2025 10:12:48",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 14:02:08"
          },
          {
            "ticket_id": 4614,
            "ticket_number": "354606",
            "title": "FALTA DE PASSAGEIROS NA RESERVA VOO WIZZAIR",
            "priority": "P2",
            "created_at": "19/12/2025 10:15:31",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 10:15:32"
          },
          {
            "ticket_id": 4615,
            "ticket_number": "354607",
            "title": "Número de informação da reserva: 6125237",
            "priority": "P2",
            "created_at": "19/12/2025 10:15:34",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 10:37:23"
          },
          {
            "ticket_id": 4617,
            "ticket_number": "354609",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "19/12/2025 10:39:30",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 10:39:30"
          },
          {
            "ticket_id": 4623,
            "ticket_number": "354615",
            "title": "Documentação da reserva TTN-1223373281#88659066#T1",
            "priority": "P2",
            "created_at": "19/12/2025 11:19:17",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 5.07,
            "sla_met": false,
            "sla_breach_hours": 1.07,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 16:23:24"
          },
          {
            "ticket_id": 4624,
            "ticket_number": "354616",
            "title": "GBN-95466 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "19/12/2025 11:19:20",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 11:19:20"
          },
          {
            "ticket_id": 4625,
            "ticket_number": "354617",
            "title": "Duvida GBN - Ref ID: 41676677",
            "priority": "P3",
            "created_at": "19/12/2025 11:24:09",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 15:22:15"
          },
          {
            "ticket_id": 4627,
            "ticket_number": "354619",
            "title": "Confirmação de reserva com localizador: 4009243",
            "priority": "P2",
            "created_at": "19/12/2025 12:05:50",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 16:02:22"
          },
          {
            "ticket_id": 4631,
            "ticket_number": "354623",
            "title": "leplan - loc 604491711",
            "priority": "P2",
            "created_at": "19/12/2025 13:38:11",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 13:52:51"
          },
          {
            "ticket_id": 4640,
            "ticket_number": "354632",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-95",
            "priority": "P3",
            "created_at": "19/12/2025 16:09:52",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 18:26:12"
          },
          {
            "ticket_id": 4648,
            "ticket_number": "354640",
            "title": "Fwd: Quick update on your Madrid flight",
            "priority": "P3",
            "created_at": "19/12/2025 17:59:50",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:59:51"
          },
          {
            "ticket_id": 4649,
            "ticket_number": "354641",
            "title": "Fwd: A3JCKH | Alterações à sua reserva?",
            "priority": "P2",
            "created_at": "19/12/2025 17:59:53",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 17:59:53"
          },
          {
            "ticket_id": 4664,
            "ticket_number": "354656",
            "title": "Reserva direta hotel - Melia Braga",
            "priority": "P2",
            "created_at": "20/12/2025 15:15:58",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/12/2025 15:15:59"
          },
          {
            "ticket_id": 4669,
            "ticket_number": "354661",
            "title": "Sandra Reis: Deseo ayudarle con la venta de viajes",
            "priority": "P2",
            "created_at": "20/12/2025 18:26:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1301.17,
            "sla_met": false,
            "sla_breach_hours": 1297.17,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 23:36:42"
          },
          {
            "ticket_id": 4671,
            "ticket_number": "354663",
            "title": "Dados de passageiro incorreto",
            "priority": "P2",
            "created_at": "21/12/2025 10:40:37",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/12/2025 10:40:37"
          },
          {
            "ticket_id": 4678,
            "ticket_number": "354670",
            "title": "Informação reserva GBN-95130",
            "priority": "P3",
            "created_at": "21/12/2025 10:44:37",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/12/2025 10:44:38"
          },
          {
            "ticket_id": 4728,
            "ticket_number": "354720",
            "title": "Confirmação de reserva para For PT004157 66829878",
            "priority": "P2",
            "created_at": "22/12/2025 16:58:48",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 17:38:23"
          },
          {
            "ticket_id": 4730,
            "ticket_number": "354722",
            "title": "Confirmação de reserva para For PT004157 66828847",
            "priority": "P3",
            "created_at": "22/12/2025 17:30:54",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 17:39:54"
          },
          {
            "ticket_id": 4760,
            "ticket_number": "354752",
            "title": "GBN-88141 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/12/2025 23:40:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 17.7,
            "sla_met": false,
            "sla_breach_hours": 13.7,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 17:23:24"
          },
          {
            "ticket_id": 4764,
            "ticket_number": "354756",
            "title": "Fwd: Viagify informa sobre a sua reserva 122913927",
            "priority": "P2",
            "created_at": "23/12/2025 10:25:40",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 10:25:41"
          },
          {
            "ticket_id": 4765,
            "ticket_number": "354757",
            "title": "Fwd: Viagify informa sobre a sua reserva 122913927",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/12/2025 10:25:44",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/12/2025 10:25:44"
          },
          {
            "ticket_id": 4766,
            "ticket_number": "354758",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P1",
            "created_at": "23/12/2025 10:25:47",
            "close_date": "2025-12-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/12/2025 10:25:47"
          },
          {
            "ticket_id": 4769,
            "ticket_number": "354761",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "23/12/2025 10:42:07",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 13:26:47"
          },
          {
            "ticket_id": 4770,
            "ticket_number": "354762",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "23/12/2025 10:42:09",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:24:16"
          },
          {
            "ticket_id": 4771,
            "ticket_number": "354763",
            "title": "Envio de documentos de File 415420/25",
            "priority": "P2",
            "created_at": "23/12/2025 10:55:19",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 11:21:26"
          },
          {
            "ticket_id": 4772,
            "ticket_number": "354764",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "23/12/2025 12:06:16",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:06:16"
          },
          {
            "ticket_id": 4773,
            "ticket_number": "354765",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "23/12/2025 12:06:19",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:06:19"
          },
          {
            "ticket_id": 4774,
            "ticket_number": "354766",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "23/12/2025 12:06:22",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:06:23"
          },
          {
            "ticket_id": 4775,
            "ticket_number": "354767",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P3",
            "created_at": "23/12/2025 12:06:26",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:06:27"
          },
          {
            "ticket_id": 4776,
            "ticket_number": "354768",
            "title": "E25T3457531-4XB",
            "priority": "P2",
            "created_at": "23/12/2025 12:57:25",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 14:06:42"
          },
          {
            "ticket_id": 4781,
            "ticket_number": "354773",
            "title": "HOTIHOTEIS || Documento 25MB 28511 || Hotel Meliá ",
            "priority": "P2",
            "created_at": "23/12/2025 14:59:45",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 16:34:24"
          },
          {
            "ticket_id": 4782,
            "ticket_number": "354774",
            "title": "Para:Sandra Reis | DisneyParis + Paris + Voos",
            "priority": "P2",
            "created_at": "23/12/2025 14:59:48",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 14:59:48"
          },
          {
            "ticket_id": 4783,
            "ticket_number": "354775",
            "title": "Mensagem sobre a reserva 35561811 - Civitatis",
            "priority": "P2",
            "created_at": "23/12/2025 16:08:36",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 16:35:42"
          },
          {
            "ticket_id": 4784,
            "ticket_number": "354776",
            "title": "Mensagem sobre a reserva 35561811 - Civitatis",
            "priority": "P2",
            "created_at": "23/12/2025 16:15:59",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 16:36:34"
          },
          {
            "ticket_id": 4795,
            "ticket_number": "354787",
            "title": "Pedido de cotação",
            "priority": "P2",
            "created_at": "23/12/2025 18:02:55",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 22:02:24"
          },
          {
            "ticket_id": 4803,
            "ticket_number": "354795",
            "title": "Comprovativo IBAN",
            "priority": "P2",
            "created_at": "24/12/2025 10:23:10",
            "close_date": "2025-12-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/12/2025 10:23:11"
          },
          {
            "ticket_id": 4806,
            "ticket_number": "354798",
            "title": "Cancelamento - Tour10 4006982",
            "priority": "P2",
            "created_at": "24/12/2025 10:23:17",
            "close_date": "2025-12-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/12/2025 10:23:17"
          },
          {
            "ticket_id": 4813,
            "ticket_number": "354805",
            "title": "Reserva cancelada com localizador: 4012375",
            "priority": "P2",
            "created_at": "24/12/2025 11:10:43",
            "close_date": "2025-12-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/12/2025 12:33:59"
          },
          {
            "ticket_id": 4815,
            "ticket_number": "354807",
            "title": "GBN-85066 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "24/12/2025 11:49:03",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 292.03,
            "sla_met": false,
            "sla_breach_hours": 268.03,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:51:12"
          },
          {
            "ticket_id": 4819,
            "ticket_number": "354811",
            "title": "Fwd: Incidente de voo TTN-1221721747#88838403#T164",
            "priority": "P2",
            "created_at": "26/12/2025 10:14:19",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 10:14:20"
          },
          {
            "ticket_id": 4822,
            "ticket_number": "354814",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/12/2025 10:32:53",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:37:14"
          },
          {
            "ticket_id": 4823,
            "ticket_number": "354815",
            "title": "Fwd: Ya puede facturar online para su vuelo a Amst",
            "priority": "P2",
            "created_at": "26/12/2025 10:32:55",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 10:32:56"
          },
          {
            "ticket_id": 4824,
            "ticket_number": "354816",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/12/2025 10:32:58",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:43:45"
          },
          {
            "ticket_id": 4825,
            "ticket_number": "354817",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/12/2025 10:33:00",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:44:36"
          },
          {
            "ticket_id": 4826,
            "ticket_number": "354818",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/12/2025 10:33:02",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:45:28"
          },
          {
            "ticket_id": 4827,
            "ticket_number": "354819",
            "title": "Pedido de Contacto Movel - 335849 // Partida: 2026",
            "priority": "P2",
            "created_at": "26/12/2025 10:33:04",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:54:52"
          },
          {
            "ticket_id": 4828,
            "ticket_number": "354820",
            "title": "Fwd: Ya puede facturar online para su vuelo a Amst",
            "priority": "P2",
            "created_at": "26/12/2025 10:33:06",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 10:33:06"
          },
          {
            "ticket_id": 4830,
            "ticket_number": "354822",
            "title": "GBN-96131 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "26/12/2025 11:09:08",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 4.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 15:37:29"
          },
          {
            "ticket_id": 4831,
            "ticket_number": "354823",
            "title": "Fwd: Documentação da reserva TTN-1227513504#889660",
            "priority": "P2",
            "created_at": "26/12/2025 11:09:15",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 11:09:16"
          },
          {
            "ticket_id": 4832,
            "ticket_number": "354824",
            "title": "RE: Urgencia localizador 412540",
            "priority": "P2",
            "created_at": "26/12/2025 11:11:23",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 12:00:11"
          },
          {
            "ticket_id": 4835,
            "ticket_number": "354827",
            "title": "Pedido de orçamento Cabo Verde - Tiago Ferreira",
            "priority": "P2",
            "created_at": "26/12/2025 12:05:18",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 16:04:58"
          },
          {
            "ticket_id": 4836,
            "ticket_number": "354828",
            "title": "Pedido de orçamento Cabo Verde - Tiago Ferreira",
            "priority": "P3",
            "created_at": "26/12/2025 12:07:48",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1163.5,
            "sla_met": false,
            "sla_breach_hours": 1139.5,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 23:38:28"
          },
          {
            "ticket_id": 4838,
            "ticket_number": "354830",
            "title": "Documentação Disponível - Reserva 335849",
            "priority": "P3",
            "created_at": "26/12/2025 12:29:48",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 19:29:04"
          },
          {
            "ticket_id": 4857,
            "ticket_number": "354849",
            "title": "Envio de Documentação * File 415146",
            "priority": "P2",
            "created_at": "26/12/2025 15:59:13",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 16:44:54"
          },
          {
            "ticket_id": 4883,
            "ticket_number": "354875",
            "title": "Cancelamento Viagem - A/C Sandra",
            "priority": "P3",
            "created_at": "28/12/2025 12:06:50",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/12/2025 12:06:51"
          },
          {
            "ticket_id": 4890,
            "ticket_number": "354882",
            "title": "GBN-96131 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/12/2025 12:07:39",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 12:37:53"
          },
          {
            "ticket_id": 4909,
            "ticket_number": "354901",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "29/12/2025 10:12:03",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:12:04"
          },
          {
            "ticket_id": 4917,
            "ticket_number": "354909",
            "title": "GBN-96257 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "29/12/2025 10:12:27",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/12/2025 10:12:28"
          },
          {
            "ticket_id": 4918,
            "ticket_number": "354910",
            "title": "GBN-96256 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/12/2025 10:12:32",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 10:12:32"
          },
          {
            "ticket_id": 4919,
            "ticket_number": "354911",
            "title": "Reserva pagada",
            "priority": "P2",
            "created_at": "29/12/2025 10:12:35",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 11:06:10"
          },
          {
            "ticket_id": 4920,
            "ticket_number": "354912",
            "title": "seguros Classic e Classic Plus",
            "priority": "P3",
            "created_at": "29/12/2025 10:12:37",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/12/2025 10:12:37"
          },
          {
            "ticket_id": 4922,
            "ticket_number": "354914",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/12/2025 10:52:08",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 11:36:41"
          },
          {
            "ticket_id": 4930,
            "ticket_number": "354922",
            "title": "Re:[## 27484 ##] GBN-94773 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "29/12/2025 13:16:22",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 13:18:18"
          },
          {
            "ticket_id": 4941,
            "ticket_number": "354933",
            "title": "Urgente | Desconto LePlan subscriçao Disney+",
            "priority": "P2",
            "created_at": "29/12/2025 16:26:31",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 16:26:32"
          },
          {
            "ticket_id": 4952,
            "ticket_number": "354944",
            "title": "Re:[## 28100 ##] FW: in resort GBN-87503 AB",
            "priority": "P2",
            "created_at": "29/12/2025 19:25:36",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 18:14:59"
          },
          {
            "ticket_id": 4956,
            "ticket_number": "354948",
            "title": "reserva cancelada 1230273387",
            "priority": "P2",
            "created_at": "29/12/2025 20:40:35",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 20:40:36"
          },
          {
            "ticket_id": 4967,
            "ticket_number": "354959",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "30/12/2025 10:10:40",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 10:10:40"
          },
          {
            "ticket_id": 4970,
            "ticket_number": "354962",
            "title": "Option confirmation letter for Group C/O UmaFAEMVi",
            "priority": "P3",
            "created_at": "30/12/2025 10:35:04",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 9.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 19:37:28"
          },
          {
            "ticket_id": 5028,
            "ticket_number": "355020",
            "title": "Reclamação transfer localizador 1165822742",
            "priority": "P3",
            "created_at": "31/12/2025 13:53:28",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/12/2025 13:53:28"
          },
          {
            "ticket_id": 5034,
            "ticket_number": "355026",
            "title": "GBN-96591 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/01/2026 10:38:36",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/01/2026 10:38:48"
          },
          {
            "ticket_id": 5136,
            "ticket_number": "355128",
            "title": "Reserva GBN-94424",
            "priority": "P3",
            "created_at": "05/01/2026 09:57:41",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 09:57:41"
          },
          {
            "ticket_id": 5138,
            "ticket_number": "355130",
            "title": "GBN-96750 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "05/01/2026 09:57:45",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 11:32:04"
          },
          {
            "ticket_id": 5139,
            "ticket_number": "355131",
            "title": "GBN-96785 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/01/2026 09:57:51",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/01/2026 11:43:12"
          },
          {
            "ticket_id": 5142,
            "ticket_number": "355134",
            "title": "Fwd: Importante: O seu cartão de embarque da Ryana",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:59",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 09:58:00"
          },
          {
            "ticket_id": 5152,
            "ticket_number": "355144",
            "title": "Fwd: Consulta sobre o seu pedido - Localizador: 12",
            "priority": "P2",
            "created_at": "05/01/2026 11:30:48",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 11:30:49"
          },
          {
            "ticket_id": 5158,
            "ticket_number": "355150",
            "title": "Orçamento de Grupo | Madeira ",
            "priority": "P3",
            "created_at": "05/01/2026 12:16:17",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 12:16:18"
          },
          {
            "ticket_id": 5160,
            "ticket_number": "355152",
            "title": "Reserva – Localizador 2335785 newblue | Declaração",
            "priority": "P2",
            "created_at": "05/01/2026 13:01:14",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 13:01:15"
          },
          {
            "ticket_id": 5163,
            "ticket_number": "355155",
            "title": "INFORMAÇÕES PARA RESERVA NEWBLUE LOC 6122762",
            "priority": "P2",
            "created_at": "05/01/2026 13:22:02",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 13:22:02"
          },
          {
            "ticket_id": 5168,
            "ticket_number": "355160",
            "title": "Fwd: Informações da reserva TTN-1217857373#8937771",
            "priority": "P3",
            "created_at": "05/01/2026 15:50:27",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:50:25"
          },
          {
            "ticket_id": 5169,
            "ticket_number": "355161",
            "title": "Fwd: Reserva 1211421469 TTN-1211421469#88852195#T1",
            "priority": "P3",
            "created_at": "05/01/2026 15:50:30",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:50:31"
          },
          {
            "ticket_id": 5174,
            "ticket_number": "355166",
            "title": "Fwd: Iberia, itinerario e información de su viaje ",
            "priority": "P3",
            "created_at": "05/01/2026 17:09:52",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 11:22:00"
          },
          {
            "ticket_id": 5175,
            "ticket_number": "355167",
            "title": "Re:[## 27121 ##] GBN-91958 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "05/01/2026 17:10:57",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 11:04:42"
          },
          {
            "ticket_id": 5185,
            "ticket_number": "355177",
            "title": "pedido de reclamação voo Ryanair D1I76N",
            "priority": "P3",
            "created_at": "05/01/2026 19:04:09",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 19:04:10"
          },
          {
            "ticket_id": 5187,
            "ticket_number": "355179",
            "title": "le plan",
            "priority": "P2",
            "created_at": "05/01/2026 20:42:08",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 20:42:08"
          },
          {
            "ticket_id": 5193,
            "ticket_number": "355185",
            "title": "cancelamento 2 pax nb 6122762",
            "priority": "P2",
            "created_at": "06/01/2026 00:44:58",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 18:05:24"
          },
          {
            "ticket_id": 5195,
            "ticket_number": "355187",
            "title": "REMINDER: Dados de Passaporte - nosso File 422534",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:30",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:55:07"
          },
          {
            "ticket_id": 5197,
            "ticket_number": "355189",
            "title": "Saídas de 05/02/2026 para 12/03/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:34",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:59:04"
          },
          {
            "ticket_id": 5199,
            "ticket_number": "355191",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P1",
            "created_at": "06/01/2026 10:12:38",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/01/2026 10:12:39"
          },
          {
            "ticket_id": 5200,
            "ticket_number": "355192",
            "title": "Fwd: 1210276553 TTN-1210276553#89357640#T16612450¬",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:40",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:12:41"
          },
          {
            "ticket_id": 5202,
            "ticket_number": "355194",
            "title": "GBN-96975 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:46",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:12:46"
          },
          {
            "ticket_id": 5203,
            "ticket_number": "355195",
            "title": "Fwd: Viagify informa sobre a sua reserva 123172241",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:49",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:12:50"
          },
          {
            "ticket_id": 5204,
            "ticket_number": "355196",
            "title": "Fwd: Informações da reserva TTN-1231722414#8943072",
            "priority": "P1",
            "created_at": "06/01/2026 10:12:52",
            "close_date": "2026-01-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/01/2026 10:12:52"
          },
          {
            "ticket_id": 5205,
            "ticket_number": "355197",
            "title": "Fwd: Fly Groups - PT25123112701041 - Agent says:",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:54",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:12:55"
          },
          {
            "ticket_id": 5206,
            "ticket_number": "355198",
            "title": "Fwd: Localizador 1231722414 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:57",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:12:57"
          },
          {
            "ticket_id": 5207,
            "ticket_number": "355199",
            "title": "Fwd: Fly Groups - PT25123112701041 - TAP says:",
            "priority": "P2",
            "created_at": "06/01/2026 10:12:59",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:13:00"
          },
          {
            "ticket_id": 5208,
            "ticket_number": "355200",
            "title": "Fwd: Documentação da reserva TTN-1211966784#894409",
            "priority": "P2",
            "created_at": "06/01/2026 10:13:03",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:13:03"
          },
          {
            "ticket_id": 5209,
            "ticket_number": "355201",
            "title": "Cancelamento GBN-92775",
            "priority": "P2",
            "created_at": "06/01/2026 10:14:08",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 10:14:08"
          },
          {
            "ticket_id": 5210,
            "ticket_number": "355202",
            "title": "Pedido de código para reserva de restaurante - 604",
            "priority": "P2",
            "created_at": "06/01/2026 11:05:00",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:01:52"
          },
          {
            "ticket_id": 5212,
            "ticket_number": "355204",
            "title": "Fwd: Fly Groups - PT25123112701041 - TAP says:",
            "priority": "P2",
            "created_at": "06/01/2026 11:47:01",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:47:02"
          },
          {
            "ticket_id": 5213,
            "ticket_number": "355205",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604517178",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/01/2026 11:47:03",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 15:41:54"
          },
          {
            "ticket_id": 5214,
            "ticket_number": "355206",
            "title": "Fwd: Fly Groups - PT25123112701041 - TAP says:",
            "priority": "P2",
            "created_at": "06/01/2026 11:47:05",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:47:06"
          },
          {
            "ticket_id": 5215,
            "ticket_number": "355207",
            "title": "Fwd: Fly Groups - PT25123112701041 - Agent says:",
            "priority": "P2",
            "created_at": "06/01/2026 11:47:08",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:47:08"
          },
          {
            "ticket_id": 5216,
            "ticket_number": "355208",
            "title": "GBN-90826",
            "priority": "P2",
            "created_at": "06/01/2026 11:47:42",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:47:43"
          },
          {
            "ticket_id": 5217,
            "ticket_number": "355209",
            "title": "URGENTE Confirmação de reserva 336122 ### TIME LIM",
            "priority": "P1",
            "created_at": "06/01/2026 11:47:45",
            "close_date": "2026-01-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.67,
            "sla_met": false,
            "sla_breach_hours": 4.42,
            "sla_name": "SLA P1",
            "first_response_at": "06/01/2026 16:27:58"
          },
          {
            "ticket_id": 5219,
            "ticket_number": "355211",
            "title": "Fwd: Informações da reserva TTN-1145204664#8945226",
            "priority": "P3",
            "created_at": "06/01/2026 13:30:43",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 13:30:44"
          },
          {
            "ticket_id": 5220,
            "ticket_number": "355212",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604517161",
            "priority": "Reservas sem Formulário",
            "created_at": "06/01/2026 13:30:46",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 5.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/01/2026 19:23:24"
          },
          {
            "ticket_id": 5221,
            "ticket_number": "355213",
            "title": "pendentes",
            "priority": "P3",
            "created_at": "06/01/2026 13:30:48",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 13:30:49"
          },
          {
            "ticket_id": 5222,
            "ticket_number": "355214",
            "title": "Fwd: Informações da reserva TTN-1145204664#8945223",
            "priority": "P3",
            "created_at": "06/01/2026 13:30:53",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/01/2026 19:29:23"
          },
          {
            "ticket_id": 5224,
            "ticket_number": "355216",
            "title": "Importante - Checkin Online Voos TAP - FILE 335849",
            "priority": "P3",
            "created_at": "06/01/2026 13:31:35",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 5.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 19:30:33"
          },
          {
            "ticket_id": 5225,
            "ticket_number": "355217",
            "title": "Fwd: Localizador 1231726122 - SmyTravel informa //",
            "priority": "P3",
            "created_at": "06/01/2026 15:16:07",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 15:16:07"
          },
          {
            "ticket_id": 5227,
            "ticket_number": "355219",
            "title": "Fwd: Localizador 1231722414 - SmyTravel informa UR",
            "priority": "P2",
            "created_at": "06/01/2026 15:16:11",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:16:11"
          },
          {
            "ticket_id": 5229,
            "ticket_number": "355221",
            "title": "Orçamento Travelplan - México",
            "priority": "P3",
            "created_at": "06/01/2026 15:16:16",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 15:16:17"
          },
          {
            "ticket_id": 5231,
            "ticket_number": "355223",
            "title": "Re: Solicitação envio RGPD | 604516386 - NOVO CVO",
            "priority": "P2",
            "created_at": "06/01/2026 15:16:22",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:16:22"
          },
          {
            "ticket_id": 5232,
            "ticket_number": "355224",
            "title": "Fwd: Informações da reserva TTN-1231726122#8945416",
            "priority": "P2",
            "created_at": "06/01/2026 15:16:26",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:16:27"
          },
          {
            "ticket_id": 5233,
            "ticket_number": "355225",
            "title": "Fwd: Informações da sua reserva TTN-1231722414#894",
            "priority": "P2",
            "created_at": "06/01/2026 15:50:01",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 15:50:01"
          },
          {
            "ticket_id": 5236,
            "ticket_number": "355228",
            "title": "Cancelamento reserva Soltropico 332519",
            "priority": "P2",
            "created_at": "06/01/2026 16:11:49",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 16:11:49"
          },
          {
            "ticket_id": 5251,
            "ticket_number": "355243",
            "title": "GBN-94424 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/01/2026 18:37:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 22:22:38"
          },
          {
            "ticket_id": 5252,
            "ticket_number": "355244",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "06/01/2026 18:56:59",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 22:42:40"
          },
          {
            "ticket_id": 5253,
            "ticket_number": "355245",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "06/01/2026 18:57:01",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 22:42:40"
          },
          {
            "ticket_id": 5259,
            "ticket_number": "355251",
            "title": "GBN-92775 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/01/2026 20:03:51",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 17.97,
            "sla_met": false,
            "sla_breach_hours": 13.97,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 14:02:00"
          },
          {
            "ticket_id": 5269,
            "ticket_number": "355261",
            "title": "ANDRADE MENDES/EDUARDO MANUEL MR 04MAY2026 OPO ORY",
            "priority": "P2",
            "created_at": "07/01/2026 10:07:15",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 14:03:29"
          },
          {
            "ticket_id": 5270,
            "ticket_number": "355262",
            "title": "REMINDER: Dados de Passaporte - nosso File 422534",
            "priority": "P2",
            "created_at": "07/01/2026 10:07:17",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 14:03:29"
          },
          {
            "ticket_id": 5275,
            "ticket_number": "355267",
            "title": "Fwd: Informações sobre a sua reserva TTN-121142146",
            "priority": "P2",
            "created_at": "07/01/2026 10:25:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 10:25:50"
          },
          {
            "ticket_id": 5278,
            "ticket_number": "355270",
            "title": "CONFIRMAÇÃO de Reserva - File: 2600024 || MR BRUNO",
            "priority": "P2",
            "created_at": "07/01/2026 12:50:22",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 16:43:43"
          },
          {
            "ticket_id": 5279,
            "ticket_number": "355271",
            "title": "Fwd: Informações da reserva TTN-1145204664#8945223",
            "priority": "P2",
            "created_at": "07/01/2026 12:50:25",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 12:50:26"
          },
          {
            "ticket_id": 5283,
            "ticket_number": "355275",
            "title": "Re:[## 28448 ##] GBN-94424 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "07/01/2026 13:06:16",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 17:03:46"
          },
          {
            "ticket_id": 5286,
            "ticket_number": "355278",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "07/01/2026 13:24:43",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 17:23:48"
          },
          {
            "ticket_id": 5287,
            "ticket_number": "355279",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "07/01/2026 13:24:44",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 17:23:48"
          },
          {
            "ticket_id": 5288,
            "ticket_number": "355280",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "07/01/2026 13:24:46",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 17:23:48"
          },
          {
            "ticket_id": 5289,
            "ticket_number": "355281",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "07/01/2026 13:24:47",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 17:23:48"
          },
          {
            "ticket_id": 5294,
            "ticket_number": "355286",
            "title": "GBN-90826",
            "priority": "P2",
            "created_at": "07/01/2026 14:40:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 14:40:17"
          },
          {
            "ticket_id": 5296,
            "ticket_number": "355288",
            "title": "orçamento para um grupo de angariação Namibia",
            "priority": "P2",
            "created_at": "07/01/2026 14:40:21",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 14:40:22"
          },
          {
            "ticket_id": 5300,
            "ticket_number": "355292",
            "title": "Re:[## 28520 ##] GBN-90826 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:12",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:00:53"
          },
          {
            "ticket_id": 5306,
            "ticket_number": "355298",
            "title": "Re: Lembrete comissões Smy - produto só voos e pro",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:36",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 16:56:37"
          },
          {
            "ticket_id": 5307,
            "ticket_number": "355299",
            "title": "GBN-90826 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:39",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:04:47"
          },
          {
            "ticket_id": 5308,
            "ticket_number": "355300",
            "title": "GBN-96830 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/01/2026 16:56:42",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:05:44"
          },
          {
            "ticket_id": 5313,
            "ticket_number": "355305",
            "title": "Fwd: Reserva 1211421469 TTN-1211421469#88852195#T1",
            "priority": "P2",
            "created_at": "07/01/2026 18:31:31",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 18:31:32"
          },
          {
            "ticket_id": 5315,
            "ticket_number": "355307",
            "title": "Documentação Disponível - Reserva 334681",
            "priority": "P2",
            "created_at": "07/01/2026 18:31:41",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:34:02"
          },
          {
            "ticket_id": 5317,
            "ticket_number": "355309",
            "title": "NOVA Confirmação de reserva 335785#######BILHETE R",
            "priority": "P2",
            "created_at": "07/01/2026 18:44:31",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 19:35:07"
          },
          {
            "ticket_id": 5398,
            "ticket_number": "355390",
            "title": "Fwd: Reserva 1211690808 TTN-1211690808#89220135#T1",
            "priority": "P2",
            "created_at": "08/01/2026 14:24:35",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 14:24:35"
          },
          {
            "ticket_id": 5508,
            "ticket_number": "355500",
            "title": "Pedido de informação",
            "priority": "P2",
            "created_at": "10/01/2026 13:56:54",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 13:56:55"
          },
          {
            "ticket_id": 5538,
            "ticket_number": "355530",
            "title": "CARVALHO NASCIMENTO/LARA FILIPA MRS 29MAY2026 LIS ",
            "priority": "P3",
            "created_at": "12/01/2026 10:07:56",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:30:51"
          },
          {
            "ticket_id": 5540,
            "ticket_number": "355532",
            "title": "ARAUJO FERREIRA/GABRIELA MRS 18JAN2026 OPO ORY",
            "priority": "P3",
            "created_at": "12/01/2026 10:07:59",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:27:35"
          },
          {
            "ticket_id": 5545,
            "ticket_number": "355537",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:10",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 13:14:35"
          },
          {
            "ticket_id": 5547,
            "ticket_number": "355539",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:14",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:08:15"
          },
          {
            "ticket_id": 5549,
            "ticket_number": "355541",
            "title": "Fwd: Viagify informa sobre a sua reserva 123369862",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:08:21",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 10:08:22"
          },
          {
            "ticket_id": 5551,
            "ticket_number": "355543",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "12/01/2026 10:08:27",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:08:28"
          },
          {
            "ticket_id": 5558,
            "ticket_number": "355550",
            "title": "GBN-98037 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/01/2026 10:09:48",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 14:04:25"
          },
          {
            "ticket_id": 5559,
            "ticket_number": "355551",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:11:59",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 7.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:15:53"
          },
          {
            "ticket_id": 5565,
            "ticket_number": "355557",
            "title": "Fwd: Viagify informa sobre a sua reserva 123347502",
            "priority": "P2",
            "created_at": "12/01/2026 10:12:48",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:12:49"
          },
          {
            "ticket_id": 5570,
            "ticket_number": "355562",
            "title": "RE: Nova Viagem #251100351 - Vai na Volta",
            "priority": "P2",
            "created_at": "12/01/2026 10:16:11",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:16:12"
          },
          {
            "ticket_id": 5576,
            "ticket_number": "355568",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "12/01/2026 10:16:27",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 13:14:35"
          },
          {
            "ticket_id": 5577,
            "ticket_number": "355569",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "12/01/2026 10:16:29",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:48:20"
          },
          {
            "ticket_id": 5581,
            "ticket_number": "355573",
            "title": "Reserva confirmada: Tour noturno por Paris - Civit",
            "priority": "P2",
            "created_at": "12/01/2026 10:16:43",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5582,
            "ticket_number": "355574",
            "title": "Duvida Hotel- Kamari Beach Hotel - Operador Smy tr",
            "priority": "P2",
            "created_at": "12/01/2026 10:17:16",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:17:17"
          },
          {
            "ticket_id": 5583,
            "ticket_number": "355575",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604519497",
            "priority": "P2",
            "created_at": "12/01/2026 10:17:18",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5584,
            "ticket_number": "355576",
            "title": "A sua reserva n.º 67390950: mantenha-se ligado enq",
            "priority": "P3",
            "created_at": "12/01/2026 10:17:21",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:24:32"
          },
          {
            "ticket_id": 5586,
            "ticket_number": "355578",
            "title": "GBN-98016 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "12/01/2026 10:17:31",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 7.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:34:32"
          },
          {
            "ticket_id": 5587,
            "ticket_number": "355579",
            "title": "GBN-98025 - Votre confirmation de réservation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:17:35",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 7.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:44:40"
          },
          {
            "ticket_id": 5588,
            "ticket_number": "355580",
            "title": "Confirmação de reserva * File 423503",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:20:51",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 25.7,
            "sla_met": false,
            "sla_breach_hours": 1.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 12:03:45"
          },
          {
            "ticket_id": 5595,
            "ticket_number": "355587",
            "title": "Cancellation of the booking with locator 7N1URF03",
            "priority": "P2",
            "created_at": "12/01/2026 10:22:14",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 13:17:05"
          },
          {
            "ticket_id": 5601,
            "ticket_number": "355593",
            "title": "Pedido de declaração de gastos irrecuperáveis - 61",
            "priority": "P2",
            "created_at": "12/01/2026 12:38:19",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 12:38:19"
          },
          {
            "ticket_id": 5603,
            "ticket_number": "355595",
            "title": "GBN-91876 - ultimo nome",
            "priority": "P3",
            "created_at": "12/01/2026 12:41:33",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 12:41:34"
          },
          {
            "ticket_id": 5606,
            "ticket_number": "355598",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 12:42:51",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 17:17:38"
          },
          {
            "ticket_id": 5609,
            "ticket_number": "355601",
            "title": "Fwd: Informações sobre a sua reserva TTN-120928028",
            "priority": "P3",
            "created_at": "12/01/2026 12:43:00",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 12:43:00"
          },
          {
            "ticket_id": 5610,
            "ticket_number": "355602",
            "title": "TOUR10 LOC. 3905734 Pedido de preço e inserção de ",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:02:27"
          },
          {
            "ticket_id": 5611,
            "ticket_number": "355603",
            "title": "Vila Galé | Confirmação da Reserva Nº8899864",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:29",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:17:43"
          },
          {
            "ticket_id": 5624,
            "ticket_number": "355616",
            "title": "-",
            "priority": "P2",
            "created_at": "12/01/2026 15:40:08",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 15:40:09"
          },
          {
            "ticket_id": 5626,
            "ticket_number": "355618",
            "title": "GBN-98115 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/01/2026 15:40:15",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 15:40:15"
          },
          {
            "ticket_id": 5629,
            "ticket_number": "355621",
            "title": "Loc  604456534 Impressive Punta Cana ANA TERESA, D",
            "priority": "P2",
            "created_at": "12/01/2026 15:40:21",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:52:48"
          },
          {
            "ticket_id": 5639,
            "ticket_number": "355631",
            "title": "OPTI 2460800001",
            "priority": "P1",
            "created_at": "12/01/2026 16:43:03",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/01/2026 16:43:03"
          },
          {
            "ticket_id": 5649,
            "ticket_number": "355641",
            "title": "GBN-98060 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/01/2026 18:00:03",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 19:10:13"
          },
          {
            "ticket_id": 5650,
            "ticket_number": "355642",
            "title": "GBN-98060 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/01/2026 18:00:08",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:00:08"
          },
          {
            "ticket_id": 5652,
            "ticket_number": "355644",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/01/2026 18:57:43",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:57:44"
          },
          {
            "ticket_id": 5653,
            "ticket_number": "355645",
            "title": "RE: Pedido de orçamento para 14 noites - Jamaica W",
            "priority": "P2",
            "created_at": "12/01/2026 18:57:46",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 19:12:44"
          },
          {
            "ticket_id": 5654,
            "ticket_number": "355646",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/01/2026 18:57:51",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:57:51"
          },
          {
            "ticket_id": 5655,
            "ticket_number": "355647",
            "title": "GBN-97747 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/01/2026 18:57:54",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 748.87,
            "sla_met": false,
            "sla_breach_hours": 744.87,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 23:50:19"
          },
          {
            "ticket_id": 5657,
            "ticket_number": "355649",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/01/2026 18:58:02",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:58:02"
          },
          {
            "ticket_id": 5659,
            "ticket_number": "355651",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/01/2026 18:58:10",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:58:10"
          },
          {
            "ticket_id": 5660,
            "ticket_number": "355652",
            "title": "Referencia para pagamento | File:422534/2025",
            "priority": "P3",
            "created_at": "12/01/2026 18:58:12",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 19:24:07"
          },
          {
            "ticket_id": 5683,
            "ticket_number": "355675",
            "title": "Pedido Orçamento Solferias  - Exponoivos",
            "priority": "P2",
            "created_at": "13/01/2026 00:12:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:12:58"
          },
          {
            "ticket_id": 5689,
            "ticket_number": "355681",
            "title": "Signed: 696526eeed05d_reservation_confirmation.pdf",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:31",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:30:37"
          },
          {
            "ticket_id": 5690,
            "ticket_number": "355682",
            "title": "Fwd: JV4K5Q | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:03:33"
          },
          {
            "ticket_id": 5691,
            "ticket_number": "355683",
            "title": "Fwd: Viagify informa sobre a sua reserva 123412967",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:03:36"
          },
          {
            "ticket_id": 5692,
            "ticket_number": "355684",
            "title": "Signed: 696580a4da07e_declaracao.docx",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:30:59"
          },
          {
            "ticket_id": 5693,
            "ticket_number": "355685",
            "title": "Signed: 69658023ca0b2_declaracao.pdf",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:40",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:32:04"
          },
          {
            "ticket_id": 5695,
            "ticket_number": "355687",
            "title": "Signed: 6963d0eb8eeb2_gbn_97649_patricia_frazao.pd",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:44",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:31:21"
          },
          {
            "ticket_id": 5696,
            "ticket_number": "355688",
            "title": "Signer signed: 69658023ca0b2_declaracao.pdf",
            "priority": "P2",
            "created_at": "13/01/2026 10:03:47",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 10:31:44"
          },
          {
            "ticket_id": 5697,
            "ticket_number": "355689",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "13/01/2026 10:06:26",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 11:45:06"
          },
          {
            "ticket_id": 5702,
            "ticket_number": "355694",
            "title": "Saídas de 12/02/2026 para 19/03/2026 - DADOS OBRIG",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:37",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 6.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:52:03"
          },
          {
            "ticket_id": 5705,
            "ticket_number": "355697",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:44",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 8.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 18:27:10"
          },
          {
            "ticket_id": 5707,
            "ticket_number": "355699",
            "title": "Envío de información sobre su reserva con localiza",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:48",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 6.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:45:10"
          },
          {
            "ticket_id": 5711,
            "ticket_number": "355703",
            "title": "Check in for your flight to Amsterdam",
            "priority": "P2",
            "created_at": "13/01/2026 10:06:59",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 11:37:09"
          },
          {
            "ticket_id": 5715,
            "ticket_number": "355707",
            "title": "Proposta Solférias  18595/2026",
            "priority": "P3",
            "created_at": "13/01/2026 10:22:33",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5716,
            "ticket_number": "355708",
            "title": "Proposta Solférias  18593/2026",
            "priority": "P3",
            "created_at": "13/01/2026 10:22:39",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 8.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 18:30:05"
          },
          {
            "ticket_id": 5718,
            "ticket_number": "355710",
            "title": "\"GBN-91982 - Your request has been received\"",
            "priority": "P3",
            "created_at": "13/01/2026 10:34:24",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 8.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 18:46:36"
          },
          {
            "ticket_id": 5723,
            "ticket_number": "355715",
            "title": "Reserva com o Localizador 6124525 New Blue PT",
            "priority": "P3",
            "created_at": "13/01/2026 11:05:57",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 11:05:57"
          },
          {
            "ticket_id": 5726,
            "ticket_number": "355718",
            "title": "Referencia para pagamento | File:415420/2025",
            "priority": "P2",
            "created_at": "13/01/2026 11:10:53",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 11:29:18"
          },
          {
            "ticket_id": 5746,
            "ticket_number": "355738",
            "title": "Silversea - Descubrimiento sin límite - Hasta un 4",
            "priority": "P2",
            "created_at": "13/01/2026 13:33:30",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 17:21:38"
          },
          {
            "ticket_id": 5747,
            "ticket_number": "355739",
            "title": "Fwd: Confira os horários de funcionamento do Milan",
            "priority": "P2",
            "created_at": "13/01/2026 13:33:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 13:33:36"
          },
          {
            "ticket_id": 5748,
            "ticket_number": "355740",
            "title": "Re:[## 23537 ##] GBN-87175 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "13/01/2026 13:33:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 17:21:38"
          },
          {
            "ticket_id": 5750,
            "ticket_number": "355742",
            "title": "Notificação de autorização File 422534/25",
            "priority": "P2",
            "created_at": "13/01/2026 13:49:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 17:41:43"
          },
          {
            "ticket_id": 5754,
            "ticket_number": "355746",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604521275",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "13/01/2026 14:56:17",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 18:41:52"
          },
          {
            "ticket_id": 5755,
            "ticket_number": "355747",
            "title": "Fwd: Viagify informa sobre a sua reserva 123444806",
            "priority": "P2",
            "created_at": "13/01/2026 14:56:20",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 14:56:20"
          },
          {
            "ticket_id": 5756,
            "ticket_number": "355748",
            "title": "Confirmação de reserva – Ref PP592284, Sr. Agostin",
            "priority": "P2",
            "created_at": "13/01/2026 14:56:23",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:41:52"
          },
          {
            "ticket_id": 5758,
            "ticket_number": "355750",
            "title": "RE: Pedido de esclarecimento - 1233489310",
            "priority": "P2",
            "created_at": "13/01/2026 14:56:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:12:45"
          },
          {
            "ticket_id": 5772,
            "ticket_number": "355764",
            "title": "Fwd: 25VG001055/001 - Cancelamento Viagem",
            "priority": "P3",
            "created_at": "13/01/2026 15:59:42",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:21:44"
          },
          {
            "ticket_id": 5791,
            "ticket_number": "355783",
            "title": "Grupo para cabo verde - URGENTE",
            "priority": "P3",
            "created_at": "13/01/2026 18:15:44",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 18:15:45"
          },
          {
            "ticket_id": 5858,
            "ticket_number": "355850",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:14",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 10:08:14"
          },
          {
            "ticket_id": 5862,
            "ticket_number": "355854",
            "title": "Malas incluidas Enter Air",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:26",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:08:26"
          },
          {
            "ticket_id": 5863,
            "ticket_number": "355855",
            "title": "Cotação Comboio",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:08:28"
          },
          {
            "ticket_id": 5866,
            "ticket_number": "355858",
            "title": "Atualização de reserva_passaportes",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:36",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:08:36"
          },
          {
            "ticket_id": 5867,
            "ticket_number": "355859",
            "title": "Fwd: Your flight to Paris (Orly): Upgrade availabl",
            "priority": "P2",
            "created_at": "14/01/2026 10:09:10",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 10:09:10"
          },
          {
            "ticket_id": 5872,
            "ticket_number": "355864",
            "title": "Confirmación de la reserva con localizador: 403017",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 10:58:28",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 14:43:46"
          },
          {
            "ticket_id": 5877,
            "ticket_number": "355869",
            "title": "GBN-98618 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/01/2026 11:37:46",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 15:23:52"
          },
          {
            "ticket_id": 5878,
            "ticket_number": "355870",
            "title": "GBN-96569 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/01/2026 11:37:48",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 15:23:52"
          },
          {
            "ticket_id": 5879,
            "ticket_number": "355871",
            "title": "CANCELAMENTO 2 RESERVAS GBN",
            "priority": "P2",
            "created_at": "14/01/2026 11:44:47",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:44:47"
          },
          {
            "ticket_id": 5888,
            "ticket_number": "355880",
            "title": "Confirmação de reserva * File 423949",
            "priority": "P2",
            "created_at": "14/01/2026 13:43:04",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 13:45:57"
          },
          {
            "ticket_id": 5891,
            "ticket_number": "355883",
            "title": "Re: Pedido de orçamento - Cabo Verde - Rita Mello",
            "priority": "P2",
            "created_at": "14/01/2026 13:43:11",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 5.07,
            "sla_met": false,
            "sla_breach_hours": 1.07,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 18:47:14"
          },
          {
            "ticket_id": 5892,
            "ticket_number": "355884",
            "title": "Pedido Hotel Hilton Molino (Veneza)",
            "priority": "P2",
            "created_at": "14/01/2026 13:43:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 13:43:15"
          },
          {
            "ticket_id": 5902,
            "ticket_number": "355894",
            "title": "CCTGTI-31105 Pedido para colocar nome completo -60",
            "priority": "P2",
            "created_at": "14/01/2026 13:59:41",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 116.15,
            "sla_met": false,
            "sla_breach_hours": 112.15,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:09:25"
          },
          {
            "ticket_id": 5904,
            "ticket_number": "355896",
            "title": "GBN-98753 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "14/01/2026 15:04:52",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 17:31:23"
          },
          {
            "ticket_id": 5906,
            "ticket_number": "355898",
            "title": "Fwd: Alteração para Classe Executiva // 1209280283",
            "priority": "P2",
            "created_at": "14/01/2026 15:04:59",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 15:05:00"
          },
          {
            "ticket_id": 5909,
            "ticket_number": "355901",
            "title": "Re:[## 29099 ##] GBN-98618 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "14/01/2026 15:05:06",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 19:04:16"
          },
          {
            "ticket_id": 5910,
            "ticket_number": "355902",
            "title": "Re:[## 29098 ##] GBN-96569 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "14/01/2026 15:05:09",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 19:04:16"
          },
          {
            "ticket_id": 5917,
            "ticket_number": "355909",
            "title": "Fwd: Adicionar Passageiro // 1231111139 TTN-123111",
            "priority": "P2",
            "created_at": "14/01/2026 15:30:49",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/01/2026 09:55:25"
          },
          {
            "ticket_id": 5918,
            "ticket_number": "355910",
            "title": "GBN-88570 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "14/01/2026 16:17:47",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 69.18,
            "sla_met": false,
            "sla_breach_hours": 68.93,
            "sla_name": "SLA P1",
            "first_response_at": "17/01/2026 13:29:24"
          },
          {
            "ticket_id": 5920,
            "ticket_number": "355912",
            "title": "CARVALHO BARBOSA/SONIA RAQUEL MRS 04MAY2026 OPO OR",
            "priority": "P2",
            "created_at": "14/01/2026 16:17:52",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 19:07:22"
          },
          {
            "ticket_id": 5930,
            "ticket_number": "355922",
            "title": "Documentação da reserva TTN-1210658401#90100841#T1",
            "priority": "P1",
            "created_at": "14/01/2026 17:28:47",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.47,
            "sla_met": false,
            "sla_breach_hours": 0.22,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 17:57:24"
          },
          {
            "ticket_id": 5931,
            "ticket_number": "355923",
            "title": "Fwd: Pedido de emissão de documentos - 604511198",
            "priority": "P3",
            "created_at": "14/01/2026 17:28:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 17:28:50"
          },
          {
            "ticket_id": 5936,
            "ticket_number": "355928",
            "title": "Seguro Insure Silver Plus - dúvida",
            "priority": "P3",
            "created_at": "14/01/2026 17:29:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 17:29:50"
          },
          {
            "ticket_id": 5985,
            "ticket_number": "355977",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:27",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:47:22"
          },
          {
            "ticket_id": 5989,
            "ticket_number": "355981",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:36",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 10:53:35"
          },
          {
            "ticket_id": 5994,
            "ticket_number": "355986",
            "title": "Criação de processo File 424171/26",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:45:39"
          },
          {
            "ticket_id": 6016,
            "ticket_number": "356008",
            "title": "RE: Pedido de emissão de documentos - 604511198",
            "priority": "P2",
            "created_at": "15/01/2026 10:46:38",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 12:36:23"
          },
          {
            "ticket_id": 6051,
            "ticket_number": "356043",
            "title": "RE: Pedido de orçamento - Cabo Verde*6271193",
            "priority": "P2",
            "created_at": "15/01/2026 14:46:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:21:07"
          },
          {
            "ticket_id": 6067,
            "ticket_number": "356059",
            "title": "Fwd: pedido de orçamento Dubai + Maldivas",
            "priority": "P2",
            "created_at": "15/01/2026 17:10:32",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:24:54"
          },
          {
            "ticket_id": 6068,
            "ticket_number": "356060",
            "title": "Fwd: Pedido de orçamento - Dubai + Maldivas",
            "priority": "P2",
            "created_at": "15/01/2026 17:10:33",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:10:33"
          },
          {
            "ticket_id": 6079,
            "ticket_number": "356071",
            "title": "Pedido Reserva Solferias - 220355 - Istambul + Zan",
            "priority": "P2",
            "created_at": "15/01/2026 18:06:06",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:06:07"
          },
          {
            "ticket_id": 6085,
            "ticket_number": "356077",
            "title": "URGENTE -  Pedido de orçamento - Dubai + Maldivas",
            "priority": "P2",
            "created_at": "15/01/2026 18:39:49",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 19:38:35"
          },
          {
            "ticket_id": 6132,
            "ticket_number": "356124",
            "title": "RV: Bom dia Afonso Filipe Henriques Sales: Bilhete",
            "priority": "P3",
            "created_at": "16/01/2026 10:13:35",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:13:35"
          },
          {
            "ticket_id": 6161,
            "ticket_number": "356153",
            "title": "RV: Confirmacion de la reserva Transavia: FB2J2M",
            "priority": "P2",
            "created_at": "16/01/2026 11:23:17",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 15:22:53"
          },
          {
            "ticket_id": 6175,
            "ticket_number": "356167",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:49",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 13:42:22"
          },
          {
            "ticket_id": 6177,
            "ticket_number": "356169",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:54",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 13:42:22"
          },
          {
            "ticket_id": 6178,
            "ticket_number": "356170",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:56",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 13:42:22"
          },
          {
            "ticket_id": 6181,
            "ticket_number": "356173",
            "title": "Fwd: Informações da reserva TTN-1210658401#9026693",
            "priority": "P1",
            "created_at": "16/01/2026 13:02:46",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 13:02:47"
          },
          {
            "ticket_id": 6224,
            "ticket_number": "356216",
            "title": "Número de informação da reserva: 6127077",
            "priority": "P3",
            "created_at": "16/01/2026 19:56:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 86.2,
            "sla_met": false,
            "sla_breach_hours": 62.2,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:09:31"
          },
          {
            "ticket_id": 6333,
            "ticket_number": "356325",
            "title": "Re:[## 29462 ##] GBN-87175 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "18/01/2026 09:53:43",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 09:53:41"
          },
          {
            "ticket_id": 6360,
            "ticket_number": "356352",
            "title": "Confirmação de pequeno-almoço  (3 a 5 de outubro) ",
            "priority": "P3",
            "created_at": "18/01/2026 17:36:43",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 17:36:43"
          },
          {
            "ticket_id": 6368,
            "ticket_number": "356360",
            "title": "pedido de cotaçao para dineyland paris",
            "priority": "P2",
            "created_at": "18/01/2026 18:31:05",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 18:31:05"
          },
          {
            "ticket_id": 6374,
            "ticket_number": "356366",
            "title": "Condições pagamento Icarión",
            "priority": "P3",
            "created_at": "19/01/2026 10:09:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:09:21"
          },
          {
            "ticket_id": 6412,
            "ticket_number": "356404",
            "title": "Orçamento Soltour",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:34",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:11:35"
          },
          {
            "ticket_id": 6413,
            "ticket_number": "356405",
            "title": "Orçamento de grupo",
            "priority": "P3",
            "created_at": "19/01/2026 10:11:37",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:11:37"
          },
          {
            "ticket_id": 6422,
            "ticket_number": "356414",
            "title": "RE: Nome passageira 6126040 W2MCS:014950002619",
            "priority": "P2",
            "created_at": "19/01/2026 10:44:13",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:14:09"
          },
          {
            "ticket_id": 6427,
            "ticket_number": "356419",
            "title": "Confirmação de Reserva * File 424615*ACTUALIZAÇÃO ",
            "priority": "P1",
            "created_at": "19/01/2026 11:12:10",
            "close_date": "2026-01-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 47.43,
            "sla_met": false,
            "sla_breach_hours": 47.18,
            "sla_name": "SLA P1",
            "first_response_at": "21/01/2026 10:38:24"
          },
          {
            "ticket_id": 6430,
            "ticket_number": "356422",
            "title": "Re: RGPD - Paulo Alexandre Gonçalves Oliveira - 24",
            "priority": "P3",
            "created_at": "19/01/2026 11:41:40",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 11:41:40"
          },
          {
            "ticket_id": 6434,
            "ticket_number": "356426",
            "title": "SMY | Teermos e condições de voos",
            "priority": "P3",
            "created_at": "19/01/2026 11:41:47",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 11:41:48"
          },
          {
            "ticket_id": 6443,
            "ticket_number": "356435",
            "title": "Confirmación del Loc 9100828",
            "priority": "P3",
            "created_at": "19/01/2026 12:32:58",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 13:56:46"
          },
          {
            "ticket_id": 6445,
            "ticket_number": "356437",
            "title": "W2MCS:014950002629",
            "priority": "P3",
            "created_at": "19/01/2026 13:57:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 14:05:47"
          },
          {
            "ticket_id": 6450,
            "ticket_number": "356442",
            "title": "Pedido Orçamento Viagem Grupo 7 adultos + 3 crianç",
            "priority": "P3",
            "created_at": "19/01/2026 14:00:36",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 14:00:36"
          },
          {
            "ticket_id": 6479,
            "ticket_number": "356471",
            "title": "Pedido de Clientes: LOC: 6127527 + LOC 6127520 - N",
            "priority": "P3",
            "created_at": "19/01/2026 18:19:31",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 18:19:31"
          },
          {
            "ticket_id": 6481,
            "ticket_number": "356473",
            "title": "PEDIDO DE ESCLARECIMENTO URGENTE",
            "priority": "P2",
            "created_at": "19/01/2026 18:44:11",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 18:44:11"
          },
          {
            "ticket_id": 6503,
            "ticket_number": "356495",
            "title": "Pedido de Orçamento → Grupo 13 Pessoas São Paulo/B",
            "priority": "P1",
            "created_at": "19/01/2026 21:54:18",
            "close_date": "2026-02-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "19/01/2026 21:54:18"
          },
          {
            "ticket_id": 6520,
            "ticket_number": "356512",
            "title": "visto egipto pacote solferias",
            "priority": "P3",
            "created_at": "20/01/2026 10:09:33",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:09:34"
          },
          {
            "ticket_id": 6521,
            "ticket_number": "356513",
            "title": "LOC: 6127520 + 6127527",
            "priority": "P3",
            "created_at": "20/01/2026 10:09:35",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:09:36"
          },
          {
            "ticket_id": 6532,
            "ticket_number": "356524",
            "title": "cotação grupo Djerba Albina _ solferias -   5739GR",
            "priority": "P3",
            "created_at": "20/01/2026 10:12:18",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:12:19"
          },
          {
            "ticket_id": 6579,
            "ticket_number": "356571",
            "title": "Pedido de orçamento - Cabo Verde",
            "priority": "P2",
            "created_at": "20/01/2026 12:16:42",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 16:03:05"
          },
          {
            "ticket_id": 6584,
            "ticket_number": "356576",
            "title": "Fwd: Pedido de orçamento - 52 pessoas 10 Junho",
            "priority": "P2",
            "created_at": "20/01/2026 12:42:42",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:42:42"
          },
          {
            "ticket_id": 6593,
            "ticket_number": "356585",
            "title": "Mensagem sobre a reserva 36546197 - Civitatis",
            "priority": "P2",
            "created_at": "20/01/2026 14:29:41",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:45:29"
          },
          {
            "ticket_id": 6608,
            "ticket_number": "356600",
            "title": "Petición CnTravel 50005836",
            "priority": "P2",
            "created_at": "20/01/2026 15:57:06",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:43:37"
          },
          {
            "ticket_id": 6611,
            "ticket_number": "356603",
            "title": "Pedido de código para utilização na app da Disney ",
            "priority": "P3",
            "created_at": "20/01/2026 15:57:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 15:57:18"
          },
          {
            "ticket_id": 6613,
            "ticket_number": "356605",
            "title": "GBN-87698 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "20/01/2026 15:57:23",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:37:54"
          },
          {
            "ticket_id": 6614,
            "ticket_number": "356606",
            "title": "GBN-100051 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "20/01/2026 15:57:25",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 16:12:44"
          },
          {
            "ticket_id": 6704,
            "ticket_number": "356696",
            "title": "Confirmação de reserva – Ref PP691769, Sr. João Ri",
            "priority": "P1",
            "created_at": "21/01/2026 13:46:41",
            "close_date": "2026-01-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/01/2026 14:00:05"
          },
          {
            "ticket_id": 6706,
            "ticket_number": "356698",
            "title": "Cancelamento Reserva Newblue",
            "priority": "P2",
            "created_at": "21/01/2026 13:46:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 13:46:47"
          },
          {
            "ticket_id": 6712,
            "ticket_number": "356704",
            "title": "informação importante sobre reservas 6127520",
            "priority": "P2",
            "created_at": "21/01/2026 13:48:40",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 17:40:33"
          },
          {
            "ticket_id": 6713,
            "ticket_number": "356705",
            "title": "informação importante sobre reservas 6127527",
            "priority": "P3",
            "created_at": "21/01/2026 13:48:42",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 4.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 18:43:30"
          },
          {
            "ticket_id": 6716,
            "ticket_number": "356708",
            "title": "Booking Id 6091176, Categoria: Incidência Pós Vend",
            "priority": "P3",
            "created_at": "21/01/2026 13:48:52",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 20.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:15:47"
          },
          {
            "ticket_id": 6717,
            "ticket_number": "356709",
            "title": "Mensagem sobre a reserva 36566236 - Civitatis",
            "priority": "P3",
            "created_at": "21/01/2026 13:48:56",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 31.35,
            "sla_met": false,
            "sla_breach_hours": 7.35,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 21:10:51"
          },
          {
            "ticket_id": 6720,
            "ticket_number": "356712",
            "title": "Brazil, 23.02.2026 - 03.03.2026",
            "priority": "P1",
            "created_at": "21/01/2026 13:49:02",
            "close_date": "2026-01-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.9,
            "sla_met": false,
            "sla_breach_hours": 3.65,
            "sla_name": "SLA P1",
            "first_response_at": "21/01/2026 17:43:11"
          },
          {
            "ticket_id": 6722,
            "ticket_number": "356714",
            "title": "Mensagem sobre a reserva 36566235 - Civitatis",
            "priority": "P3",
            "created_at": "21/01/2026 13:49:07",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 31.35,
            "sla_met": false,
            "sla_breach_hours": 7.35,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 21:10:10"
          },
          {
            "ticket_id": 6725,
            "ticket_number": "356717",
            "title": "FW: Multibanco - File 424615/26",
            "priority": "P3",
            "created_at": "21/01/2026 13:49:14",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 18:49:52"
          },
          {
            "ticket_id": 6740,
            "ticket_number": "356732",
            "title": "Pedido de cotação direta",
            "priority": "P3",
            "created_at": "21/01/2026 14:57:52",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 14:57:52"
          },
          {
            "ticket_id": 6766,
            "ticket_number": "356758",
            "title": "Questão late check-out file- 337002",
            "priority": "P2",
            "created_at": "21/01/2026 16:50:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 20:41:21"
          },
          {
            "ticket_id": 6775,
            "ticket_number": "356767",
            "title": "Rate request",
            "priority": "P2",
            "created_at": "21/01/2026 18:02:52",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:11:54"
          },
          {
            "ticket_id": 6787,
            "ticket_number": "356779",
            "title": "Re:[## 29807 ##] GBN-100416 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "21/01/2026 19:13:43",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 19:15:20"
          },
          {
            "ticket_id": 6798,
            "ticket_number": "356790",
            "title": "Dúvida para CIVITATIS sobre compra de cartão esim",
            "priority": "P2",
            "created_at": "21/01/2026 21:58:17",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 21:58:18"
          },
          {
            "ticket_id": 6830,
            "ticket_number": "356822",
            "title": "Orçamento para Riviera Turca",
            "priority": "P2",
            "created_at": "22/01/2026 10:15:51",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 10:15:51"
          },
          {
            "ticket_id": 6836,
            "ticket_number": "356828",
            "title": "N/Ref.:E25T3457531-5UE[<4>]",
            "priority": "P2",
            "created_at": "22/01/2026 10:16:07",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:48:37"
          },
          {
            "ticket_id": 6838,
            "ticket_number": "356830",
            "title": "GBN-100538 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 10:16:14",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 13:56:45"
          },
          {
            "ticket_id": 6854,
            "ticket_number": "356846",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/01/2026 12:26:12",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 14:01:12"
          },
          {
            "ticket_id": 6857,
            "ticket_number": "356849",
            "title": "Alteração reserva",
            "priority": "P3",
            "created_at": "22/01/2026 12:26:32",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 12:26:32"
          },
          {
            "ticket_id": 6859,
            "ticket_number": "356851",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "Reservas sem Formulário",
            "created_at": "22/01/2026 12:26:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 12:26:38"
          },
          {
            "ticket_id": 6870,
            "ticket_number": "356862",
            "title": "Pedido Orçamento 9 adultos + 1 criança Bayahibe",
            "priority": "P2",
            "created_at": "22/01/2026 13:05:53",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:05:53"
          },
          {
            "ticket_id": 6872,
            "ticket_number": "356864",
            "title": "Nova Confirmação de reserva 334066",
            "priority": "P2",
            "created_at": "22/01/2026 13:06:28",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 293.35,
            "sla_met": false,
            "sla_breach_hours": 289.35,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 18:27:52"
          },
          {
            "ticket_id": 6882,
            "ticket_number": "356874",
            "title": "Alteração de uma reserva",
            "priority": "P2",
            "created_at": "22/01/2026 15:03:54",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 15:03:54"
          },
          {
            "ticket_id": 6900,
            "ticket_number": "356892",
            "title": "Fwd: pedido de codigo disney",
            "priority": "P2",
            "created_at": "22/01/2026 17:36:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 17:36:54"
          },
          {
            "ticket_id": 6901,
            "ticket_number": "356893",
            "title": "pedido de codigo disney",
            "priority": "P2",
            "created_at": "22/01/2026 17:36:58",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 17:36:59"
          },
          {
            "ticket_id": 6925,
            "ticket_number": "356917",
            "title": "Fwd: Pedido de troca de ordem dos apelidos",
            "priority": "P2",
            "created_at": "22/01/2026 19:55:26",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 19:55:26"
          },
          {
            "ticket_id": 6929,
            "ticket_number": "356921",
            "title": "Pedido de acesso Auto Europe",
            "priority": "P2",
            "created_at": "22/01/2026 20:47:16",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:47:17"
          },
          {
            "ticket_id": 6942,
            "ticket_number": "356934",
            "title": "loc425629 - Solferias",
            "priority": "P2",
            "created_at": "23/01/2026 00:07:40",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 13.62,
            "sla_met": false,
            "sla_breach_hours": 9.62,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 13:45:26"
          },
          {
            "ticket_id": 6950,
            "ticket_number": "356942",
            "title": "Fwd: Incidente de voo TTN-1231377012#90899920#T170",
            "priority": "P2",
            "created_at": "23/01/2026 10:05:36",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 10:05:36"
          },
          {
            "ticket_id": 6953,
            "ticket_number": "356945",
            "title": "Número de informação da reserva: 6127890",
            "priority": "P2",
            "created_at": "23/01/2026 10:05:49",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 10:54:42"
          },
          {
            "ticket_id": 6954,
            "ticket_number": "356946",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P3",
            "created_at": "23/01/2026 10:05:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:59:49"
          },
          {
            "ticket_id": 6955,
            "ticket_number": "356947",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "23/01/2026 10:05:53",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 11:01:41"
          },
          {
            "ticket_id": 6956,
            "ticket_number": "356948",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "23/01/2026 10:05:55",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:20:46"
          },
          {
            "ticket_id": 6965,
            "ticket_number": "356957",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "23/01/2026 10:33:53",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 13:55:39"
          },
          {
            "ticket_id": 6966,
            "ticket_number": "356958",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "23/01/2026 10:38:10",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 13:56:51"
          },
          {
            "ticket_id": 6967,
            "ticket_number": "356959",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "23/01/2026 10:51:30",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 13:57:17"
          },
          {
            "ticket_id": 6968,
            "ticket_number": "356960",
            "title": "Informação de reserva - SPT002601574519",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "23/01/2026 10:51:35",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 11:32:11"
          },
          {
            "ticket_id": 6969,
            "ticket_number": "356961",
            "title": "Confirmação de Reserva * FILE 425983/26 * TL 23/01",
            "priority": "P3",
            "created_at": "23/01/2026 11:20:52",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 12:46:35"
          },
          {
            "ticket_id": 6984,
            "ticket_number": "356976",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "23/01/2026 12:55:52",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:07:15"
          },
          {
            "ticket_id": 6985,
            "ticket_number": "356977",
            "title": "RE: Pedido de troca de ordem dos apelidos W2MCS:01",
            "priority": "P3",
            "created_at": "23/01/2026 12:55:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:08:22"
          },
          {
            "ticket_id": 6986,
            "ticket_number": "356978",
            "title": "Confirmação de Reserva * File 425894 *TL 23/01/202",
            "priority": "P3",
            "created_at": "23/01/2026 13:09:15",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:11:59"
          },
          {
            "ticket_id": 6989,
            "ticket_number": "356981",
            "title": "GBN-100805 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/01/2026 13:35:15",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 13:47:09"
          },
          {
            "ticket_id": 6990,
            "ticket_number": "356982",
            "title": "Cancelamento de Reserva 210641",
            "priority": "P2",
            "created_at": "23/01/2026 13:35:17",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 13:45:55"
          },
          {
            "ticket_id": 6991,
            "ticket_number": "356983",
            "title": "Pedido de orçamento | Casa Moiano - Oliveira do ho",
            "priority": "P3",
            "created_at": "23/01/2026 14:42:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:42:17"
          },
          {
            "ticket_id": 6996,
            "ticket_number": "356988",
            "title": "Fwd: Informações sobre a sua reserva TTN-123817041",
            "priority": "P2",
            "created_at": "23/01/2026 15:23:20",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 15:23:21"
          },
          {
            "ticket_id": 6997,
            "ticket_number": "356989",
            "title": "Fwd: Incidente de voo TTN-1231377012#90899920#T170",
            "priority": "P2",
            "created_at": "23/01/2026 15:23:25",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 15:23:26"
          },
          {
            "ticket_id": 7107,
            "ticket_number": "357099",
            "title": "GBN-101250 - Sua confirmação de reserva",
            "priority": "P1",
            "created_at": "26/01/2026 10:07:12",
            "close_date": "2026-01-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/01/2026 10:07:12"
          },
          {
            "ticket_id": 7114,
            "ticket_number": "357106",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "26/01/2026 10:08:41",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:08:41"
          },
          {
            "ticket_id": 7116,
            "ticket_number": "357108",
            "title": "Pedido de orçamento Lusanova - 4975",
            "priority": "P3",
            "created_at": "26/01/2026 10:08:47",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:08:48"
          },
          {
            "ticket_id": 7120,
            "ticket_number": "357112",
            "title": "Luxotour",
            "priority": "P3",
            "created_at": "26/01/2026 10:09:08",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:09:08"
          },
          {
            "ticket_id": 7122,
            "ticket_number": "357114",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "26/01/2026 10:11:51",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 11:07:11"
          },
          {
            "ticket_id": 7124,
            "ticket_number": "357116",
            "title": "Fwd: Nova Viagem #260100384 - Euforia Glam | Ilha ",
            "priority": "P2",
            "created_at": "26/01/2026 10:11:56",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:11:57"
          },
          {
            "ticket_id": 7125,
            "ticket_number": "357117",
            "title": "Criação de processo File 426525/26",
            "priority": "P3",
            "created_at": "26/01/2026 10:12:04",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 13:36:02"
          },
          {
            "ticket_id": 7126,
            "ticket_number": "357118",
            "title": "Fwd: Viagify informa sobre a sua reserva 123979214",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/01/2026 10:12:41",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 10:12:42"
          },
          {
            "ticket_id": 7132,
            "ticket_number": "357124",
            "title": "Fwd: R22VNT | Extras para a tua viagem para Palma",
            "priority": "P2",
            "created_at": "26/01/2026 10:13:01",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:13:02"
          },
          {
            "ticket_id": 7150,
            "ticket_number": "357142",
            "title": "Cotação urgente",
            "priority": "P2",
            "created_at": "26/01/2026 10:16:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:16:04"
          },
          {
            "ticket_id": 7154,
            "ticket_number": "357146",
            "title": "Acréscimo/Cotação mais 1 passageiro à reserva Solf",
            "priority": "P3",
            "created_at": "26/01/2026 10:16:49",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:16:49"
          },
          {
            "ticket_id": 7166,
            "ticket_number": "357158",
            "title": "Pedido de Orçamento",
            "priority": "P3",
            "created_at": "26/01/2026 10:19:24",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:19:24"
          },
          {
            "ticket_id": 7168,
            "ticket_number": "357160",
            "title": "Reserva de Grupo - Reserva já",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:01",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:20:01"
          },
          {
            "ticket_id": 7170,
            "ticket_number": "357162",
            "title": "Alteração de reserva para 14/2/2026",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:20:05"
          },
          {
            "ticket_id": 7173,
            "ticket_number": "357165",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:42",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.12,
            "sla_met": false,
            "sla_breach_hours": 2.12,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:28:22"
          },
          {
            "ticket_id": 7177,
            "ticket_number": "357169",
            "title": "Fwd: Informações sobre a sua reserva TTN-123778850",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:50",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:20:51"
          },
          {
            "ticket_id": 7198,
            "ticket_number": "357190",
            "title": "Confirmação de reserva com localizador: 4047290",
            "priority": "P2",
            "created_at": "26/01/2026 11:33:03",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7199,
            "ticket_number": "357191",
            "title": "Confirmação de reserva com localizador: 4047282",
            "priority": "P2",
            "created_at": "26/01/2026 11:33:05",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7200,
            "ticket_number": "357192",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "26/01/2026 11:33:07",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:22:22"
          },
          {
            "ticket_id": 7211,
            "ticket_number": "357203",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 8",
            "priority": "P2",
            "created_at": "26/01/2026 12:25:21",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:22:29"
          },
          {
            "ticket_id": 7214,
            "ticket_number": "357206",
            "title": "Envio de Documentação Disney File 422592",
            "priority": "P2",
            "created_at": "26/01/2026 12:25:30",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:22:29"
          },
          {
            "ticket_id": 7216,
            "ticket_number": "357208",
            "title": "Envio de documentos de File 425327 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "26/01/2026 12:40:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 4.5,
            "sla_met": false,
            "sla_breach_hours": 0.5,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:10:31"
          },
          {
            "ticket_id": 7222,
            "ticket_number": "357214",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "26/01/2026 13:32:03",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:11:04"
          },
          {
            "ticket_id": 7226,
            "ticket_number": "357218",
            "title": "Fwd: Pedido de cotação",
            "priority": "P3",
            "created_at": "26/01/2026 13:49:32",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 16:26:16"
          },
          {
            "ticket_id": 7231,
            "ticket_number": "357223",
            "title": "Informações sobre excursão da reserva 6128736 W2MC",
            "priority": "P2",
            "created_at": "26/01/2026 14:41:59",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:15:14"
          },
          {
            "ticket_id": 7237,
            "ticket_number": "357229",
            "title": "Re:[## 30196 ##] GBN-99494 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "26/01/2026 15:10:01",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 14:42:08"
          },
          {
            "ticket_id": 7243,
            "ticket_number": "357235",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 16:19:13",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 16:19:33"
          },
          {
            "ticket_id": 7244,
            "ticket_number": "357236",
            "title": "RESERVA CIVITATIS LOCALIZADOR: A34700180 - ADICION",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:19:17"
          },
          {
            "ticket_id": 7245,
            "ticket_number": "357237",
            "title": "Reserva alterada: Visita à vinícola Fonseca com ja",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:22",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:44:05"
          },
          {
            "ticket_id": 7253,
            "ticket_number": "357245",
            "title": "GBN-101445 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:55",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:19:55"
          },
          {
            "ticket_id": 7258,
            "ticket_number": "357250",
            "title": "Confirmação e Sinalização de Reserva 210646",
            "priority": "P2",
            "created_at": "26/01/2026 17:08:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:24:54"
          },
          {
            "ticket_id": 7312,
            "ticket_number": "357304",
            "title": "OFERTA ESPECIAL GRUPOS👩‍👩‍👧‍👧 PUY DU FOU🏰",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 13:20:59"
          },
          {
            "ticket_id": 7335,
            "ticket_number": "357327",
            "title": "Dúvida Solferias",
            "priority": "P2",
            "created_at": "27/01/2026 11:01:11",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 11:01:11"
          },
          {
            "ticket_id": 7344,
            "ticket_number": "357336",
            "title": "GBN-101620 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/01/2026 12:47:43",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 13:29:44"
          },
          {
            "ticket_id": 7347,
            "ticket_number": "357339",
            "title": "pedido de cotação urgente",
            "priority": "P2",
            "created_at": "27/01/2026 13:32:02",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:42:40"
          },
          {
            "ticket_id": 7348,
            "ticket_number": "357340",
            "title": "GBN-100539 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/01/2026 14:17:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 15:16:27"
          },
          {
            "ticket_id": 7354,
            "ticket_number": "357346",
            "title": "GBN-100538 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/01/2026 14:41:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 15:21:50"
          },
          {
            "ticket_id": 7356,
            "ticket_number": "357348",
            "title": "Número de informação da reserva: 6128960",
            "priority": "P2",
            "created_at": "27/01/2026 14:50:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:30:48"
          },
          {
            "ticket_id": 7367,
            "ticket_number": "357359",
            "title": "Civitatis",
            "priority": "P2",
            "created_at": "27/01/2026 16:01:23",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:01:24"
          },
          {
            "ticket_id": 7390,
            "ticket_number": "357382",
            "title": "Brazil, 23.02.2026 - 03.03.2026",
            "priority": "P2",
            "created_at": "27/01/2026 17:34:58",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 19:06:07"
          },
          {
            "ticket_id": 7394,
            "ticket_number": "357386",
            "title": "Brazil , Qoya São Paulo Paulista, Curio Collection",
            "priority": "P2",
            "created_at": "27/01/2026 17:35:10",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 21:20:17"
          },
          {
            "ticket_id": 7401,
            "ticket_number": "357393",
            "title": "Grupo: GR-93F44C5F8B",
            "priority": "P3",
            "created_at": "27/01/2026 18:12:22",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 12:28:32"
          },
          {
            "ticket_id": 7418,
            "ticket_number": "357410",
            "title": "RE: Dúvida - orçamento Saídia W2MCS:014960003000",
            "priority": "P2",
            "created_at": "27/01/2026 18:58:55",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 19:20:41"
          },
          {
            "ticket_id": 7496,
            "ticket_number": "357488",
            "title": "Envio de Documentação * File 425456",
            "priority": "P2",
            "created_at": "28/01/2026 10:31:40",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:17"
          },
          {
            "ticket_id": 7499,
            "ticket_number": "357491",
            "title": "RE: Pedido de cotação para Tranferes - reservas 60",
            "priority": "P3",
            "created_at": "28/01/2026 11:46:47",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 5.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 17:35:45"
          },
          {
            "ticket_id": 7500,
            "ticket_number": "357492",
            "title": "URGENTE: SPT002601575704 - RECONFIRMAÇÃO DE NOMES ",
            "priority": "P2",
            "created_at": "28/01/2026 11:54:09",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 12:04:08"
          },
          {
            "ticket_id": 7504,
            "ticket_number": "357496",
            "title": "Pedido de reserva - GBN 101683",
            "priority": "P2",
            "created_at": "28/01/2026 12:27:13",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 12:27:13"
          },
          {
            "ticket_id": 7506,
            "ticket_number": "357498",
            "title": "Reserva solférias 425456 . Pedido de esclareciment",
            "priority": "P2",
            "created_at": "28/01/2026 12:27:33",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 12:27:33"
          },
          {
            "ticket_id": 7507,
            "ticket_number": "357499",
            "title": "Booking Id 6091176, Categoria: Incidência Pós Vend",
            "priority": "P3",
            "created_at": "28/01/2026 12:27:49",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 16:21:27"
          },
          {
            "ticket_id": 7511,
            "ticket_number": "357503",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P2",
            "created_at": "28/01/2026 15:45:39",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 15:45:39"
          },
          {
            "ticket_id": 7516,
            "ticket_number": "357508",
            "title": "RE: Urgente - Pedido de cotação - Grupo São Paulo",
            "priority": "P2",
            "created_at": "28/01/2026 15:45:54",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 16:20:32"
          },
          {
            "ticket_id": 7524,
            "ticket_number": "357516",
            "title": "Cotización HUELVA - cntravel -Ref 50005863 -Uma Fa",
            "priority": "P2",
            "created_at": "28/01/2026 15:46:15",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:57:00"
          },
          {
            "ticket_id": 7534,
            "ticket_number": "357526",
            "title": "Pedido de orçamento",
            "priority": "P2",
            "created_at": "28/01/2026 16:13:57",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 16:13:59"
          },
          {
            "ticket_id": 7538,
            "ticket_number": "357530",
            "title": "GBN-101683 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/01/2026 17:16:41",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 21:02:04"
          },
          {
            "ticket_id": 7552,
            "ticket_number": "357544",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "28/01/2026 19:20:07",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 19:20:07"
          },
          {
            "ticket_id": 7571,
            "ticket_number": "357563",
            "title": "Orçamento Djerba",
            "priority": "P2",
            "created_at": "29/01/2026 10:23:22",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:23:22"
          },
          {
            "ticket_id": 7573,
            "ticket_number": "357565",
            "title": "Pedido de informação Travelplan",
            "priority": "P2",
            "created_at": "29/01/2026 10:24:33",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:24:33"
          },
          {
            "ticket_id": 7576,
            "ticket_number": "357568",
            "title": "Pedido informação opti 2414900019",
            "priority": "P1",
            "created_at": "29/01/2026 10:24:41",
            "close_date": "2026-02-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 10:24:41"
          },
          {
            "ticket_id": 7606,
            "ticket_number": "357598",
            "title": "Pedidos GBN",
            "priority": "P3",
            "created_at": "29/01/2026 10:28:14",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:28:15"
          },
          {
            "ticket_id": 7612,
            "ticket_number": "357604",
            "title": "CCTGTI-32014 Pedido de cotação",
            "priority": "P3",
            "created_at": "29/01/2026 10:29:01",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 9.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 19:48:14"
          },
          {
            "ticket_id": 7636,
            "ticket_number": "357628",
            "title": "RE: Pedido de cotação W2MCS:018010000617",
            "priority": "P2",
            "created_at": "29/01/2026 12:43:20",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 12:57:27"
          },
          {
            "ticket_id": 7654,
            "ticket_number": "357646",
            "title": "Fim de semana para 8 pessoas em Fevereiro ou Março",
            "priority": "P2",
            "created_at": "29/01/2026 15:54:41",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:54:41"
          },
          {
            "ticket_id": 7664,
            "ticket_number": "357656",
            "title": "Pedido de Orçamento de Grupo - Djerba",
            "priority": "P3",
            "created_at": "29/01/2026 16:31:38",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 16:31:38"
          },
          {
            "ticket_id": 7672,
            "ticket_number": "357664",
            "title": "Reserva em WL 210951",
            "priority": "P1",
            "created_at": "29/01/2026 17:59:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 23.43,
            "sla_met": false,
            "sla_breach_hours": 23.18,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 17:25:58"
          },
          {
            "ticket_id": 7673,
            "ticket_number": "357665",
            "title": "URGENTE Confirmação de reserva 338457####### TIME ",
            "priority": "P1",
            "created_at": "29/01/2026 17:59:19",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 15:54:46"
          },
          {
            "ticket_id": 7696,
            "ticket_number": "357688",
            "title": "Confirmação de reserva – Ref PP227106, Sr. Jose Al",
            "priority": "P2",
            "created_at": "30/01/2026 10:08:37",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:27:01"
          },
          {
            "ticket_id": 7713,
            "ticket_number": "357705",
            "title": "E-MAIL PARA ENVIAR À SOLFÉRIAS - 411467",
            "priority": "P2",
            "created_at": "30/01/2026 10:10:08",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:10:08"
          },
          {
            "ticket_id": 7761,
            "ticket_number": "357753",
            "title": "Urgente - reserva Travelplan",
            "priority": "P3",
            "created_at": "30/01/2026 13:16:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 13:16:24"
          },
          {
            "ticket_id": 7828,
            "ticket_number": "357820",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P3",
            "created_at": "30/01/2026 18:55:59",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 90.73,
            "sla_met": false,
            "sla_breach_hours": 66.73,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 13:40:46"
          },
          {
            "ticket_id": 7838,
            "ticket_number": "357830",
            "title": "Informação de reserva - SPT002601580797",
            "priority": "Reservas sem Formulário",
            "created_at": "30/01/2026 19:09:49",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 64.08,
            "sla_met": false,
            "sla_breach_hours": 40.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 11:15:30"
          },
          {
            "ticket_id": 7851,
            "ticket_number": "357843",
            "title": "Fwd: Pedido de cotação - reserva",
            "priority": "P2",
            "created_at": "30/01/2026 19:36:57",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:36:58"
          },
          {
            "ticket_id": 7943,
            "ticket_number": "357935",
            "title": "Fwd: Viagify informa-te do teu orçamento 124315421",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:22",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:23"
          },
          {
            "ticket_id": 7944,
            "ticket_number": "357936",
            "title": "Fwd: Viagify informa sobre a sua reserva 124318811",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:25",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:26"
          },
          {
            "ticket_id": 7947,
            "ticket_number": "357939",
            "title": "Fwd: Viagify informa sobre a sua reserva 124316383",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:34",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:16"
          },
          {
            "ticket_id": 7948,
            "ticket_number": "357940",
            "title": "Fwd: Viagify informa sobre a sua reserva 124318586",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:38",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:20"
          },
          {
            "ticket_id": 7953,
            "ticket_number": "357945",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:55",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:25:32"
          },
          {
            "ticket_id": 7961,
            "ticket_number": "357953",
            "title": "Número de informação da reserva: 6131336",
            "priority": "P3",
            "created_at": "02/02/2026 10:10:01",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 4.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:49:34"
          },
          {
            "ticket_id": 7962,
            "ticket_number": "357954",
            "title": "Fwd: Viagify informa sobre a sua reserva 124312270",
            "priority": "P3",
            "created_at": "02/02/2026 10:10:03",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:10:03"
          },
          {
            "ticket_id": 7975,
            "ticket_number": "357967",
            "title": "Fwd: Incidente de voo TTN-1239441414#91698445#T172",
            "priority": "P3",
            "created_at": "02/02/2026 10:16:38",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:16:40"
          },
          {
            "ticket_id": 7977,
            "ticket_number": "357969",
            "title": "Fwd: Informações da sua reserva TTN-1242192934#916",
            "priority": "P3",
            "created_at": "02/02/2026 10:16:49",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:16:49"
          },
          {
            "ticket_id": 7978,
            "ticket_number": "357970",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P3",
            "created_at": "02/02/2026 10:16:51",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:25:38"
          },
          {
            "ticket_id": 7988,
            "ticket_number": "357980",
            "title": "GBN-102925 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:35",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:35"
          },
          {
            "ticket_id": 7992,
            "ticket_number": "357984",
            "title": "GBN-102930 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:50",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:50"
          },
          {
            "ticket_id": 8004,
            "ticket_number": "357996",
            "title": "GBN-102944 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "02/02/2026 10:19:04",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:19:04"
          },
          {
            "ticket_id": 8012,
            "ticket_number": "358004",
            "title": "Número de informação da reserva: 6131353",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:10",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 4.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 15:08:52"
          },
          {
            "ticket_id": 8013,
            "ticket_number": "358005",
            "title": "Solicitação a operador",
            "priority": "P2",
            "created_at": "02/02/2026 10:22:12",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:22:12"
          },
          {
            "ticket_id": 8014,
            "ticket_number": "358006",
            "title": "Número de informação da reserva: 6131350",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 27.2,
            "sla_met": false,
            "sla_breach_hours": 3.2,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 13:34:44"
          },
          {
            "ticket_id": 8019,
            "ticket_number": "358011",
            "title": "URGENTE - Reservas Smartparking",
            "priority": "P2",
            "created_at": "02/02/2026 10:22:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:22:31"
          },
          {
            "ticket_id": 8024,
            "ticket_number": "358016",
            "title": "Fwd: Viagify informa sobre a sua reserva 124293606",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:48",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:43"
          },
          {
            "ticket_id": 8053,
            "ticket_number": "358045",
            "title": "Confirmação de Reserva * File 428139 *TL 03/02/202",
            "priority": "P2",
            "created_at": "02/02/2026 12:49:02",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 13:02:23"
          },
          {
            "ticket_id": 8065,
            "ticket_number": "358057",
            "title": "Confirmação de Reserva * File 428193 *TL 02/02/202",
            "priority": "P2",
            "created_at": "02/02/2026 12:49:56",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 13:05:00"
          },
          {
            "ticket_id": 8187,
            "ticket_number": "358179",
            "title": "Fwd: Informações da reserva TTN-1231111139#9189955",
            "priority": "P2",
            "created_at": "03/02/2026 13:11:28",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:11:29"
          },
          {
            "ticket_id": 8194,
            "ticket_number": "358186",
            "title": "Acrescimo de mais 1 quarto à reserva soltropico: 3",
            "priority": "P2",
            "created_at": "03/02/2026 14:17:06",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 14:17:06"
          },
          {
            "ticket_id": 8200,
            "ticket_number": "358192",
            "title": "Re:[## 30656 ##] GBN-102207 - Seu pedido foi receb",
            "priority": "P3",
            "created_at": "03/02/2026 15:06:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 7.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 22:07:40"
          },
          {
            "ticket_id": 8204,
            "ticket_number": "358196",
            "title": "RE: Pedido de cotação",
            "priority": "P3",
            "created_at": "03/02/2026 15:15:28",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 7.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 22:16:12"
          },
          {
            "ticket_id": 8292,
            "ticket_number": "358284",
            "title": "RE: Pedido de orçamento *6304993",
            "priority": "P2",
            "created_at": "04/02/2026 13:53:19",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:44:11"
          },
          {
            "ticket_id": 8362,
            "ticket_number": "358354",
            "title": "Urgente: pedido nova reserva | GBN-103806",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:17",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 20:56:15"
          },
          {
            "ticket_id": 8363,
            "ticket_number": "358355",
            "title": "Saídas de 07/03/2026 para 11/04/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "05/02/2026 10:02:19",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:54:37"
          },
          {
            "ticket_id": 8364,
            "ticket_number": "358356",
            "title": "INFORMACIÓN PARA EL CLIENTE El Indio Chocolatería ",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:22",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:55:58"
          },
          {
            "ticket_id": 8376,
            "ticket_number": "358368",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 2",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:55",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 11:12:06"
          },
          {
            "ticket_id": 8377,
            "ticket_number": "358369",
            "title": "Confirmação de reserva. Localizador: 2DHI02BDID",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:57",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 11:13:35"
          },
          {
            "ticket_id": 8380,
            "ticket_number": "358372",
            "title": "Voucher reserva actividade localizador FF6EB53B03",
            "priority": "P2",
            "created_at": "05/02/2026 10:03:06",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 11:15:42"
          },
          {
            "ticket_id": 8381,
            "ticket_number": "358373",
            "title": "Confirmação reserva de actividade localizador FF6E",
            "priority": "P2",
            "created_at": "05/02/2026 10:03:10",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 11:16:49"
          },
          {
            "ticket_id": 8383,
            "ticket_number": "358375",
            "title": "asunto",
            "priority": "P3",
            "created_at": "05/02/2026 10:03:15",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:49:44"
          },
          {
            "ticket_id": 8384,
            "ticket_number": "358376",
            "title": "Dúvida Urgente",
            "priority": "P3",
            "created_at": "05/02/2026 10:10:39",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:10:39"
          },
          {
            "ticket_id": 8394,
            "ticket_number": "358386",
            "title": "-",
            "priority": "P2",
            "created_at": "05/02/2026 10:51:59",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:51:59"
          },
          {
            "ticket_id": 8429,
            "ticket_number": "358421",
            "title": "YKGIRF – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "05/02/2026 15:11:12",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 17:11:09"
          },
          {
            "ticket_id": 8455,
            "ticket_number": "358447",
            "title": "GBN-103806 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/02/2026 18:41:37",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 174.03,
            "sla_met": false,
            "sla_breach_hours": 170.03,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 00:44:07"
          },
          {
            "ticket_id": 8460,
            "ticket_number": "358452",
            "title": "RE: Pedido de cotação - Maldivas + Istambul - 6310",
            "priority": "P3",
            "created_at": "05/02/2026 18:58:08",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 17.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 12:11:28"
          },
          {
            "ticket_id": 8487,
            "ticket_number": "358479",
            "title": "Nova reserva para Multidestinos",
            "priority": "P2",
            "created_at": "06/02/2026 10:08:38",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 14:02:45"
          },
          {
            "ticket_id": 8489,
            "ticket_number": "358481",
            "title": "Nova reserva para Multidestinos",
            "priority": "P3",
            "created_at": "06/02/2026 10:08:44",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 14:02:45"
          },
          {
            "ticket_id": 8499,
            "ticket_number": "358491",
            "title": "Aéreo - Confirmação de Emissão (REINALDO\\SARA) - Y",
            "priority": "P3",
            "created_at": "06/02/2026 11:21:03",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 14:40:56"
          },
          {
            "ticket_id": 8500,
            "ticket_number": "358492",
            "title": "Pedido ao Operador Tour10",
            "priority": "P3",
            "created_at": "06/02/2026 11:21:05",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 11:21:05"
          },
          {
            "ticket_id": 8503,
            "ticket_number": "358495",
            "title": "GBN-98060 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "06/02/2026 11:21:12",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 13:25:05"
          },
          {
            "ticket_id": 8505,
            "ticket_number": "358497",
            "title": "Fwd: Formacao Viajar Tours - REMINDER",
            "priority": "P3",
            "created_at": "06/02/2026 11:21:18",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 11:21:18"
          },
          {
            "ticket_id": 8510,
            "ticket_number": "358502",
            "title": "URGENTE - PEDIDO DE MALA DE PORÃO RESERVAS SOLTROP",
            "priority": "P3",
            "created_at": "06/02/2026 11:47:08",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 11:47:09"
          },
          {
            "ticket_id": 8515,
            "ticket_number": "358507",
            "title": "Te damos la bienvenida",
            "priority": "P3",
            "created_at": "06/02/2026 11:49:04",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 12:31:38"
          },
          {
            "ticket_id": 8516,
            "ticket_number": "358508",
            "title": "          ¿Quieres mejorar tu habitación?         ",
            "priority": "P3",
            "created_at": "06/02/2026 11:50:43",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 12:30:01"
          },
          {
            "ticket_id": 8525,
            "ticket_number": "358517",
            "title": "Re:[## 31212 ##] GBN-103831 - Seu pedido foi receb",
            "priority": "P3",
            "created_at": "06/02/2026 13:24:54",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 13:55:38"
          },
          {
            "ticket_id": 8528,
            "ticket_number": "358520",
            "title": "RE: Pedido de cotação mala extra - 339011 e 339026",
            "priority": "P2",
            "created_at": "06/02/2026 14:03:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 15:30:01"
          },
          {
            "ticket_id": 8533,
            "ticket_number": "358525",
            "title": "RE: Pedido de cotação para Albânia",
            "priority": "P2",
            "created_at": "06/02/2026 15:06:50",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 15:32:51"
          },
          {
            "ticket_id": 8535,
            "ticket_number": "358527",
            "title": "Recover password",
            "priority": "P3",
            "created_at": "06/02/2026 16:21:59",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 19:09:57"
          },
          {
            "ticket_id": 8536,
            "ticket_number": "358528",
            "title": "RE: Pedido de cotação Djerba - ref65005551",
            "priority": "P3",
            "created_at": "06/02/2026 16:22:02",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 16:41:28"
          },
          {
            "ticket_id": 8542,
            "ticket_number": "358534",
            "title": "Pedido cotação - NEWBLUE #6128736",
            "priority": "P2",
            "created_at": "06/02/2026 16:44:28",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 16:44:28"
          },
          {
            "ticket_id": 8543,
            "ticket_number": "358535",
            "title": "Fwd: Informações da reserva TTN-1243663367#9231198",
            "priority": "P2",
            "created_at": "06/02/2026 16:44:31",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 16:44:32"
          },
          {
            "ticket_id": 8553,
            "ticket_number": "358545",
            "title": "Nova reserva para Transporte para Praga",
            "priority": "P3",
            "created_at": "06/02/2026 18:23:24",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 19:11:52"
          },
          {
            "ticket_id": 8681,
            "ticket_number": "358673",
            "title": "Gralha numa simulação de reserva soltrópico - Ilha",
            "priority": "P3",
            "created_at": "09/02/2026 10:39:05",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:39:06"
          },
          {
            "ticket_id": 8693,
            "ticket_number": "358685",
            "title": "4XP3U3EUAV",
            "priority": "P2",
            "created_at": "09/02/2026 10:46:15",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 11:35:51"
          },
          {
            "ticket_id": 8723,
            "ticket_number": "358715",
            "title": "Fwd: Informações da reserva TTN-1241119548#9242813",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:17"
          },
          {
            "ticket_id": 8734,
            "ticket_number": "358726",
            "title": "Cancelamento de Reserva - SPT002601574519",
            "priority": "P3",
            "created_at": "09/02/2026 11:17:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 13:15:54"
          },
          {
            "ticket_id": 8738,
            "ticket_number": "358730",
            "title": "URGENTE!! COBERTURA",
            "priority": "P1",
            "created_at": "09/02/2026 11:36:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 11:36:44"
          },
          {
            "ticket_id": 8741,
            "ticket_number": "358733",
            "title": "Documentação Disponível - Reserva 338525",
            "priority": "P3",
            "created_at": "09/02/2026 12:02:28",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 7.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:26:36"
          },
          {
            "ticket_id": 8772,
            "ticket_number": "358764",
            "title": "Referencia para pagamento | File:428883/2026",
            "priority": "P1",
            "created_at": "09/02/2026 16:42:43",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.25,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:58:40"
          },
          {
            "ticket_id": 8775,
            "ticket_number": "358767",
            "title": "Re:[## 30035 ##] GBN-86193 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "09/02/2026 17:06:22",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 19:40:27"
          },
          {
            "ticket_id": 8776,
            "ticket_number": "358768",
            "title": "AJUSTE HORARIO DE SU RESERVA 1774427",
            "priority": "P3",
            "created_at": "09/02/2026 17:06:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 24.03,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 17:08:27"
          },
          {
            "ticket_id": 8789,
            "ticket_number": "358781",
            "title": "Cuba - NB 6124097",
            "priority": "P2",
            "created_at": "09/02/2026 18:47:16",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:47:17"
          },
          {
            "ticket_id": 8873,
            "ticket_number": "358865",
            "title": "Fwd: Informações da reserva TTN-1236854333#9247729",
            "priority": "P2",
            "created_at": "10/02/2026 15:57:45",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:44:50"
          },
          {
            "ticket_id": 8878,
            "ticket_number": "358870",
            "title": "GRUP-20880 Cotización GRUP-20848 - Albina Silva_Al",
            "priority": "P2",
            "created_at": "10/02/2026 16:56:51",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 18:09:26"
          },
          {
            "ticket_id": 8879,
            "ticket_number": "358871",
            "title": "GRUP-21022 Cotización GRUP-20848 - Albina Silva_Al",
            "priority": "P2",
            "created_at": "10/02/2026 16:56:53",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 18:10:04"
          },
          {
            "ticket_id": 8883,
            "ticket_number": "358875",
            "title": "FW: GRUP-21022 Cotización GRUP-20848 - Albina Silv",
            "priority": "P2",
            "created_at": "10/02/2026 16:57:05",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 18:08:31"
          },
          {
            "ticket_id": 8900,
            "ticket_number": "358892",
            "title": "Confirmação de reserva * File 428927",
            "priority": "P2",
            "created_at": "10/02/2026 18:14:38",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:18:12"
          },
          {
            "ticket_id": 8902,
            "ticket_number": "358894",
            "title": "GRUP-20880 Cotización GRUP-20848 - Albina Silva_Al",
            "priority": "P2",
            "created_at": "10/02/2026 18:34:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:10:28"
          },
          {
            "ticket_id": 8905,
            "ticket_number": "358897",
            "title": "FW: GRUP-20880 Cotización GRUP-20848 - Albina Silv",
            "priority": "P2",
            "created_at": "10/02/2026 18:51:44",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:05:11"
          },
          {
            "ticket_id": 8950,
            "ticket_number": "358942",
            "title": "YKGIRF – Pedido de Inserção de APIS",
            "priority": "P3",
            "created_at": "11/02/2026 10:14:47",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 10:55:59"
          },
          {
            "ticket_id": 8955,
            "ticket_number": "358947",
            "title": "Fwd: Reserva - disponibilidade 14 fev",
            "priority": "P1",
            "created_at": "11/02/2026 10:51:06",
            "close_date": "2026-02-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/02/2026 10:51:07"
          },
          {
            "ticket_id": 8961,
            "ticket_number": "358953",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P3",
            "created_at": "11/02/2026 10:51:25",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 11:24:19"
          },
          {
            "ticket_id": 8967,
            "ticket_number": "358959",
            "title": "Fwd: Pedido de reserva - Dia dos Namorados - 14 Fe",
            "priority": "P1",
            "created_at": "11/02/2026 11:36:58",
            "close_date": "2026-02-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/02/2026 11:36:58"
          },
          {
            "ticket_id": 8970,
            "ticket_number": "358962",
            "title": "[Tour10] Asunto: Pedido de reserva - Dia dos Namor",
            "priority": "P2",
            "created_at": "11/02/2026 12:13:08",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 13:15:05"
          },
          {
            "ticket_id": 8978,
            "ticket_number": "358970",
            "title": "Documentação Disponível - Reserva 332076",
            "priority": "P2",
            "created_at": "11/02/2026 12:32:13",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 14:00:53"
          },
          {
            "ticket_id": 8986,
            "ticket_number": "358978",
            "title": "Número de informação da reserva: 6132701",
            "priority": "Reservas sem Formulário",
            "created_at": "11/02/2026 13:39:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/02/2026 14:06:07"
          },
          {
            "ticket_id": 9010,
            "ticket_number": "359002",
            "title": "Loc 6132660 Newblue da nossa viagem",
            "priority": "P2",
            "created_at": "11/02/2026 16:41:43",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 16:41:43"
          },
          {
            "ticket_id": 9028,
            "ticket_number": "359020",
            "title": "RE: Pedido de cancelamento reserva - 6132701 W2MCS",
            "priority": "P3",
            "created_at": "11/02/2026 18:53:34",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 19:29:02"
          },
          {
            "ticket_id": 9075,
            "ticket_number": "359067",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "12/02/2026 10:08:20",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 10:30:37"
          },
          {
            "ticket_id": 9082,
            "ticket_number": "359074",
            "title": "FXPBBB – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "12/02/2026 10:11:18",
            "close_date": "2026-02-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.53,
            "sla_met": false,
            "sla_breach_hours": 9.28,
            "sla_name": "SLA P1",
            "first_response_at": "12/02/2026 19:43:58"
          },
          {
            "ticket_id": 9090,
            "ticket_number": "359082",
            "title": "Emissão bilhetes",
            "priority": "P1",
            "created_at": "12/02/2026 10:11:43",
            "close_date": "2026-02-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/02/2026 10:11:44"
          },
          {
            "ticket_id": 9100,
            "ticket_number": "359092",
            "title": "604546188",
            "priority": "P2",
            "created_at": "12/02/2026 10:29:43",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:11:41"
          },
          {
            "ticket_id": 9150,
            "ticket_number": "359142",
            "title": "Fwd: Incidente de voo TTN-1218445868#92941027#T176",
            "priority": "P2",
            "created_at": "12/02/2026 18:41:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 18:41:59"
          },
          {
            "ticket_id": 9213,
            "ticket_number": "359205",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-10",
            "priority": "P2",
            "created_at": "13/02/2026 13:59:16",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 13:59:10"
          },
          {
            "ticket_id": 9224,
            "ticket_number": "359216",
            "title": "Mensagem sobre a reserva 2870134 - Civitatis",
            "priority": "P2",
            "created_at": "13/02/2026 14:40:49",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 18:03:12"
          },
          {
            "ticket_id": 9253,
            "ticket_number": "359245",
            "title": "Re:[## 31840 ##] GBN-99935 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "13/02/2026 16:53:44",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:37:30"
          }
        ]
      },
      "Catarina França": {
        "total_tickets": 345,
        "sla_met": 271,
        "sla_missed": 74,
        "sla_compliance_rate": 78.55,
        "tickets": [
          {
            "ticket_id": 36,
            "ticket_number": "35036",
            "title": "Re: Esclarecimento de duvida",
            "priority": "P3",
            "created_at": "30/09/2025 09:06:46",
            "close_date": "2025-09-30",
            "sla_target_hours": 24,
            "actual_time_hours": 5.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/09/2025 14:16:37"
          },
          {
            "ticket_id": 39,
            "ticket_number": "35039",
            "title": "URGENTE: Pedido de Orçamento grupo Ilha do Sal // ",
            "priority": "P2",
            "created_at": "30/09/2025 09:06:50",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 5.82,
            "sla_met": false,
            "sla_breach_hours": 1.82,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 14:56:07"
          },
          {
            "ticket_id": 76,
            "ticket_number": "35075",
            "title": "Viagem México - 2026",
            "priority": "P2",
            "created_at": "30/09/2025 15:27:39",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 15:27:39"
          },
          {
            "ticket_id": 81,
            "ticket_number": "35080",
            "title": "Re: Pedido de Cotação | 17 pessoas - Cabo Verde",
            "priority": "P2",
            "created_at": "30/09/2025 17:15:54",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 17:24:16"
          },
          {
            "ticket_id": 82,
            "ticket_number": "35081",
            "title": "RE: GBN-51887 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/09/2025 17:15:56",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 17:15:56"
          },
          {
            "ticket_id": 97,
            "ticket_number": "35096",
            "title": "Reserva Newblue - 6119135 Confirmação WL",
            "priority": "P3",
            "created_at": "01/10/2025 09:03:57",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 09:03:57"
          },
          {
            "ticket_id": 101,
            "ticket_number": "35100",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P3",
            "created_at": "01/10/2025 10:11:44",
            "close_date": "2025-10-07",
            "sla_target_hours": 24,
            "actual_time_hours": 48.25,
            "sla_met": false,
            "sla_breach_hours": 24.25,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 10:27:27"
          },
          {
            "ticket_id": 112,
            "ticket_number": "35111",
            "title": "Re:[## 20992 ##] GBN-51887 - Seu pedido foi recebi",
            "priority": "P1",
            "created_at": "01/10/2025 14:00:15",
            "close_date": "2025-10-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/10/2025 14:07:12"
          },
          {
            "ticket_id": 113,
            "ticket_number": "35112",
            "title": "Re:[## 21663 ##] GBN-82921 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "01/10/2025 14:11:38",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 14:23:54"
          },
          {
            "ticket_id": 132,
            "ticket_number": "35131",
            "title": "GBN-84348 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "01/10/2025 22:37:22",
            "close_date": "2025-10-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/10/2025 22:40:35"
          },
          {
            "ticket_id": 145,
            "ticket_number": "35144",
            "title": "Re: Pedido de Cotação | 18 pessoas",
            "priority": "P2",
            "created_at": "02/10/2025 11:48:59",
            "close_date": "2025-10-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 12:24:22"
          },
          {
            "ticket_id": 162,
            "ticket_number": "35161",
            "title": "Pedido de cotação Caraíbas - 11 pessoas (Ana Rita ",
            "priority": "P2",
            "created_at": "02/10/2025 17:59:04",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 14:38:07"
          },
          {
            "ticket_id": 175,
            "ticket_number": "35174",
            "title": "Pedido de Orçamento grupo 11 pessoas PUNTA CANA (A",
            "priority": "P2",
            "created_at": "03/10/2025 10:57:50",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 76.17,
            "sla_met": false,
            "sla_breach_hours": 72.17,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 15:08:16"
          },
          {
            "ticket_id": 212,
            "ticket_number": "35211",
            "title": "Pedido de Cotação - grupo entre 10-15 pessoas (Cát",
            "priority": "P2",
            "created_at": "06/10/2025 09:11:18",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 09:11:19"
          },
          {
            "ticket_id": 251,
            "ticket_number": "35250",
            "title": "Pedido de Cotação - grupo 10 pessoas - Mercados de",
            "priority": "P2",
            "created_at": "06/10/2025 15:27:06",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 11:05:54"
          },
          {
            "ticket_id": 296,
            "ticket_number": "35295",
            "title": "Pedido de cotação hotel",
            "priority": "P2",
            "created_at": "07/10/2025 12:15:32",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 12:15:32"
          },
          {
            "ticket_id": 315,
            "ticket_number": "35314",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 16:33:08",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 47.45,
            "sla_met": false,
            "sla_breach_hours": 23.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 16:01:07"
          },
          {
            "ticket_id": 322,
            "ticket_number": "35321",
            "title": "ATUALIZAÇÃO DADOS PASSAPORTE - Localizador SMYTRAV",
            "priority": "P2",
            "created_at": "07/10/2025 17:21:29",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 17:21:30"
          },
          {
            "ticket_id": 325,
            "ticket_number": "35324",
            "title": "GBN-74839 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/10/2025 18:34:33",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 20:57:50"
          },
          {
            "ticket_id": 327,
            "ticket_number": "35326",
            "title": "Nova Viagem #251000049 - Euforia Glam",
            "priority": "P2",
            "created_at": "07/10/2025 19:15:10",
            "close_date": "2025-10-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 19:15:10"
          },
          {
            "ticket_id": 331,
            "ticket_number": "35330",
            "title": "GBN-85029 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/10/2025 20:48:06",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 20:48:06"
          },
          {
            "ticket_id": 343,
            "ticket_number": "35342",
            "title": "Pedido de Cotação - 15 pessoas (12 +3) | DIOGO",
            "priority": "P2",
            "created_at": "07/10/2025 23:42:39",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 23:42:40"
          },
          {
            "ticket_id": 349,
            "ticket_number": "35348",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604472086",
            "priority": "P3",
            "created_at": "08/10/2025 09:25:21",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 36.88,
            "sla_met": false,
            "sla_breach_hours": 12.88,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 22:18:22"
          },
          {
            "ticket_id": 351,
            "ticket_number": "35350",
            "title": "GBN-85048 - Your booking confirmation",
            "priority": "P3",
            "created_at": "08/10/2025 09:25:25",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 36.88,
            "sla_met": false,
            "sla_breach_hours": 12.88,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 22:19:12"
          },
          {
            "ticket_id": 357,
            "ticket_number": "35356",
            "title": "Fwd: Viagify informa sobre a sua reserva 120790442",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:58:52",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 09:58:53"
          },
          {
            "ticket_id": 359,
            "ticket_number": "35358",
            "title": "Fwd: Viagify informa sobre a sua reserva 120799703",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:58:57",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 09:58:58"
          },
          {
            "ticket_id": 373,
            "ticket_number": "35372",
            "title": "GBN-85079 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "08/10/2025 11:56:43",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 12:11:23"
          },
          {
            "ticket_id": 384,
            "ticket_number": "35383",
            "title": "Criação de processo File 412540/25",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 14:12:15",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 56.57,
            "sla_met": false,
            "sla_breach_hours": 32.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 22:47:09"
          },
          {
            "ticket_id": 400,
            "ticket_number": "35399",
            "title": "Reserva confirmada: Ingresso do Oceanário de Lisbo",
            "priority": "P3",
            "created_at": "08/10/2025 15:15:39",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 15:15:42"
          },
          {
            "ticket_id": 412,
            "ticket_number": "35411",
            "title": "Pedido de Cotação - 70 pessoas | Tiago Ferreira",
            "priority": "P2",
            "created_at": "08/10/2025 17:15:15",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 17:15:15"
          },
          {
            "ticket_id": 417,
            "ticket_number": "35416",
            "title": "Criação de processo File 412548/25",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 17:15:28",
            "close_date": "2025-10-10",
            "sla_target_hours": 24,
            "actual_time_hours": 53.43,
            "sla_met": false,
            "sla_breach_hours": 29.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 22:42:02"
          },
          {
            "ticket_id": 419,
            "ticket_number": "35418",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "08/10/2025 17:50:43",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 119.82,
            "sla_met": false,
            "sla_breach_hours": 95.82,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 17:39:49"
          },
          {
            "ticket_id": 429,
            "ticket_number": "35428",
            "title": "Reserva confirmada: Espectáculo flamenco na Casa d",
            "priority": "P3",
            "created_at": "09/10/2025 09:07:39",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 09:07:42"
          },
          {
            "ticket_id": 446,
            "ticket_number": "35445",
            "title": "GBN-85273 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "09/10/2025 14:13:40",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 32.28,
            "sla_met": false,
            "sla_breach_hours": 8.28,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 22:31:06"
          },
          {
            "ticket_id": 447,
            "ticket_number": "35446",
            "title": "\"GBN-78011 - Your request has been received\"",
            "priority": "P2",
            "created_at": "09/10/2025 14:13:42",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 15:13:50"
          },
          {
            "ticket_id": 449,
            "ticket_number": "35448",
            "title": "GBN-67911 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "09/10/2025 14:43:25",
            "close_date": "2025-10-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.6,
            "sla_met": false,
            "sla_breach_hours": 1.35,
            "sla_name": "SLA P1",
            "first_response_at": "09/10/2025 16:20:15"
          },
          {
            "ticket_id": 451,
            "ticket_number": "35450",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P3",
            "created_at": "09/10/2025 15:06:09",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 98.83,
            "sla_met": false,
            "sla_breach_hours": 74.83,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 17:57:02"
          },
          {
            "ticket_id": 457,
            "ticket_number": "35456",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "09/10/2025 17:38:44",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 17:38:44"
          },
          {
            "ticket_id": 467,
            "ticket_number": "35466",
            "title": "Confirmacao 332230",
            "priority": "P3",
            "created_at": "09/10/2025 22:09:10",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 24.32,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 22:28:28"
          },
          {
            "ticket_id": 486,
            "ticket_number": "35485",
            "title": "GBN-85429 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/10/2025 12:37:31",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 77.52,
            "sla_met": false,
            "sla_breach_hours": 53.52,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 18:09:05"
          },
          {
            "ticket_id": 489,
            "ticket_number": "35488",
            "title": "URGENTE GBN Travel: Information about your booking",
            "priority": "P3",
            "created_at": "10/10/2025 12:37:39",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 9.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 22:23:43"
          },
          {
            "ticket_id": 493,
            "ticket_number": "35492",
            "title": "Fwd: 1199695315 TTN-1199695315#83343268#T14948386¬",
            "priority": "P2",
            "created_at": "10/10/2025 14:02:34",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 14:02:34"
          },
          {
            "ticket_id": 495,
            "ticket_number": "35494",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "P3",
            "created_at": "10/10/2025 14:47:26",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 14:47:28"
          },
          {
            "ticket_id": 509,
            "ticket_number": "35508",
            "title": "Re: Pedido de Orçamento | Reserva de grupo - Cabo ",
            "priority": "P2",
            "created_at": "10/10/2025 16:41:52",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 4.85,
            "sla_met": false,
            "sla_breach_hours": 0.85,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 21:33:06"
          },
          {
            "ticket_id": 513,
            "ticket_number": "35512",
            "title": "GBN-85497 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/10/2025 18:09:58",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/10/2025 18:14:32"
          },
          {
            "ticket_id": 514,
            "ticket_number": "35513",
            "title": "PEDIDO DE COTAÇÃO - RODRIGO NEVES",
            "priority": "P2",
            "created_at": "10/10/2025 18:10:31",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 21:46:13"
          },
          {
            "ticket_id": 520,
            "ticket_number": "35519",
            "title": "GBN-85442 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 19:02:37",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 19:02:37"
          },
          {
            "ticket_id": 531,
            "ticket_number": "35530",
            "title": "GBN-78112 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 22:17:11",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 15:07:35"
          },
          {
            "ticket_id": 536,
            "ticket_number": "35535",
            "title": "GBN-85615 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "13/10/2025 09:06:03",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 28.9,
            "sla_met": false,
            "sla_breach_hours": 4.9,
            "sla_name": "SLA P3",
            "first_response_at": "14/10/2025 14:00:57"
          },
          {
            "ticket_id": 548,
            "ticket_number": "35547",
            "title": "GBN-85651 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:06:42",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 37.58,
            "sla_met": false,
            "sla_breach_hours": 13.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 22:42:17"
          },
          {
            "ticket_id": 593,
            "ticket_number": "35592",
            "title": "GBN-85713 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "13/10/2025 14:32:27",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 14:32:27"
          },
          {
            "ticket_id": 615,
            "ticket_number": "35614",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 18:00:37",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 18:00:37"
          },
          {
            "ticket_id": 628,
            "ticket_number": "35627",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "P3",
            "created_at": "13/10/2025 20:28:04",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 18:32:57"
          },
          {
            "ticket_id": 633,
            "ticket_number": "35632",
            "title": "GBN-85816 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 20:58:02",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 23:27:58"
          },
          {
            "ticket_id": 635,
            "ticket_number": "35634",
            "title": "GBN-85819 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/10/2025 21:49:54",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 22:31:45"
          },
          {
            "ticket_id": 638,
            "ticket_number": "35637",
            "title": "Fwd: Viagify informa sobre a sua reserva 120988848",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:13:50",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 09:13:50"
          },
          {
            "ticket_id": 684,
            "ticket_number": "35683",
            "title": "Fwd: Viagify informa sobre a sua reserva 121003449",
            "priority": "P2",
            "created_at": "14/10/2025 15:33:58",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 15:33:59"
          },
          {
            "ticket_id": 686,
            "ticket_number": "35685",
            "title": "Pedido de cotação - 14 pessoas (Rita Arruda)",
            "priority": "P2",
            "created_at": "14/10/2025 15:43:38",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 38.0,
            "sla_met": false,
            "sla_breach_hours": 34.0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 05:43:56"
          },
          {
            "ticket_id": 691,
            "ticket_number": "35690",
            "title": "Proposta Solférias  17369/2025 (6125824)",
            "priority": "P2",
            "created_at": "14/10/2025 16:56:28",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 17:41:09"
          },
          {
            "ticket_id": 698,
            "ticket_number": "35697",
            "title": "GBN-85951 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 17:58:48",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 69.92,
            "sla_met": false,
            "sla_breach_hours": 45.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 15:53:57"
          },
          {
            "ticket_id": 717,
            "ticket_number": "35716",
            "title": "GBN-68378 - Sua reserva foi atualizada com serviço",
            "priority": "P2",
            "created_at": "15/10/2025 09:10:33",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:10:33"
          },
          {
            "ticket_id": 754,
            "ticket_number": "35753",
            "title": "Confirmation of booking with locatorQFSHT5WR",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 15:56:38",
            "close_date": "2025-10-17",
            "sla_target_hours": 24,
            "actual_time_hours": 48.72,
            "sla_met": false,
            "sla_breach_hours": 24.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 16:40:23"
          },
          {
            "ticket_id": 766,
            "ticket_number": "35765",
            "title": "Reserva Jorge Cavaco - NEW BLUE - LOC. 6119161",
            "priority": "P2",
            "created_at": "15/10/2025 17:24:16",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 10:38:59"
          },
          {
            "ticket_id": 770,
            "ticket_number": "35769",
            "title": "Pedido de cotação - 14 pessoas Malta (Rita Arruda)",
            "priority": "P2",
            "created_at": "15/10/2025 17:47:20",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:47:20"
          },
          {
            "ticket_id": 776,
            "ticket_number": "35775",
            "title": "Pedido de cotação - 14 pessoas Malta (Rita Arruda)",
            "priority": "P2",
            "created_at": "15/10/2025 18:50:53",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 18:49:13"
          },
          {
            "ticket_id": 806,
            "ticket_number": "35805",
            "title": "Fwd: Viagify informa sobre a sua reserva 121058464",
            "priority": "P2",
            "created_at": "16/10/2025 12:04:00",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 12:04:01"
          },
          {
            "ticket_id": 811,
            "ticket_number": "35810",
            "title": "cotação Boutique Hotel Castelinho, rio de janeiro",
            "priority": "P2",
            "created_at": "16/10/2025 14:02:18",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 14:02:18"
          },
          {
            "ticket_id": 819,
            "ticket_number": "35818",
            "title": "Reserva GBN-81979 | Catarina Faco",
            "priority": "P2",
            "created_at": "16/10/2025 14:24:07",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 14:59:05"
          },
          {
            "ticket_id": 820,
            "ticket_number": "35819",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P1",
            "created_at": "16/10/2025 14:31:34",
            "close_date": "2025-10-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "16/10/2025 14:31:34"
          },
          {
            "ticket_id": 830,
            "ticket_number": "35829",
            "title": "RV: pacotes neve",
            "priority": "P2",
            "created_at": "16/10/2025 16:32:28",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 17:53:25"
          },
          {
            "ticket_id": 831,
            "ticket_number": "35830",
            "title": "O erro continua | Alteração de dados de reserva | ",
            "priority": "P2",
            "created_at": "16/10/2025 16:58:08",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 5.75,
            "sla_met": false,
            "sla_breach_hours": 1.75,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 22:43:57"
          },
          {
            "ticket_id": 838,
            "ticket_number": "35837",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "P2",
            "created_at": "16/10/2025 18:24:05",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 18:34:08"
          },
          {
            "ticket_id": 840,
            "ticket_number": "35839",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "P2",
            "created_at": "16/10/2025 18:29:58",
            "close_date": "2025-10-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 18:33:05"
          },
          {
            "ticket_id": 848,
            "ticket_number": "35847",
            "title": "Pedido de cotação - Alambique Hotel",
            "priority": "P2",
            "created_at": "16/10/2025 21:59:11",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 21:59:11"
          },
          {
            "ticket_id": 866,
            "ticket_number": "35865",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 14:24:12",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 14:24:14"
          },
          {
            "ticket_id": 893,
            "ticket_number": "35892",
            "title": "GBN-86545 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 21:33:33",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 122.12,
            "sla_met": false,
            "sla_breach_hours": 98.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:40:52"
          },
          {
            "ticket_id": 900,
            "ticket_number": "35899",
            "title": "Número de informação da reserva: 6119682",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 09:51:30",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/10/2025 09:51:24"
          },
          {
            "ticket_id": 901,
            "ticket_number": "35900",
            "title": "Número de informação da reserva: 6119681",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 09:51:33",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 85.83,
            "sla_met": false,
            "sla_breach_hours": 61.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:42:17"
          },
          {
            "ticket_id": 905,
            "ticket_number": "35904",
            "title": "c - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 14:42:02",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 81.02,
            "sla_met": false,
            "sla_breach_hours": 57.02,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:43:14"
          },
          {
            "ticket_id": 928,
            "ticket_number": "35927",
            "title": "GBN-86631 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 09:21:30",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 62.37,
            "sla_met": false,
            "sla_breach_hours": 38.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:43:52"
          },
          {
            "ticket_id": 936,
            "ticket_number": "35935",
            "title": "Confirmação de reserva com localizador: 3945269",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 09:21:45",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 62.37,
            "sla_met": false,
            "sla_breach_hours": 38.37,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:44:30"
          },
          {
            "ticket_id": 946,
            "ticket_number": "35945",
            "title": "GBN-86731 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 15:06:00",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 56.52,
            "sla_met": false,
            "sla_breach_hours": 32.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:37:17"
          },
          {
            "ticket_id": 955,
            "ticket_number": "35954",
            "title": "Fwd: Viagify informa sobre a sua reserva 121170886",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 15:33:57",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 15:33:57"
          },
          {
            "ticket_id": 958,
            "ticket_number": "35957",
            "title": "Pedido de Orçamento | Transfer para San Sebastian ",
            "priority": "P2",
            "created_at": "20/10/2025 16:04:54",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 16:04:54"
          },
          {
            "ticket_id": 963,
            "ticket_number": "35962",
            "title": "Informação de reserva - SPT002501546715",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 17:09:07",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 54.42,
            "sla_met": false,
            "sla_breach_hours": 30.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:34:49"
          },
          {
            "ticket_id": 971,
            "ticket_number": "35970",
            "title": "Confirmacao 332616",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 18:31:22",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 53.03,
            "sla_met": false,
            "sla_breach_hours": 29.03,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:34:09"
          },
          {
            "ticket_id": 973,
            "ticket_number": "35972",
            "title": "Fwd: Buenos días Alexandre Manuel Meira Velez Quen",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 20:22:06",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 20:22:07"
          },
          {
            "ticket_id": 984,
            "ticket_number": "35983",
            "title": "Confirmacao 332627",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 22:39:27",
            "close_date": "2025-10-24",
            "sla_target_hours": 24,
            "actual_time_hours": 48.85,
            "sla_met": false,
            "sla_breach_hours": 24.85,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:31:23"
          },
          {
            "ticket_id": 987,
            "ticket_number": "35986",
            "title": "GBN-86820 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 09:03:54",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 38.68,
            "sla_met": false,
            "sla_breach_hours": 14.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:45:15"
          },
          {
            "ticket_id": 993,
            "ticket_number": "35992",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 09:22:07",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 09:22:07"
          },
          {
            "ticket_id": 1012,
            "ticket_number": "351011",
            "title": "Fwd: Viagify informa sobre a sua reserva 121196678",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 12:28:13",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 12:28:14"
          },
          {
            "ticket_id": 1014,
            "ticket_number": "351013",
            "title": "Check in - Localizadores - Costa - 34501737 / 3451",
            "priority": "P2",
            "created_at": "21/10/2025 12:28:16",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 22:48:44"
          },
          {
            "ticket_id": 1024,
            "ticket_number": "351023",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1211708862#84",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 13:54:54",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 13:54:54"
          },
          {
            "ticket_id": 1031,
            "ticket_number": "351029",
            "title": "Fwd: Viagify informa sobre a sua reserva 121204240",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 15:06:33",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 15:06:32"
          },
          {
            "ticket_id": 1036,
            "ticket_number": "351034",
            "title": "GBN-86945 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 16:07:08",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 31.67,
            "sla_met": false,
            "sla_breach_hours": 7.67,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:47:21"
          },
          {
            "ticket_id": 1037,
            "ticket_number": "351035",
            "title": "GBN-86947 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 16:27:58",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 31.32,
            "sla_met": false,
            "sla_breach_hours": 7.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:47:52"
          },
          {
            "ticket_id": 1041,
            "ticket_number": "351039",
            "title": "Confirmação de reserva – Ref PP122216, Sr. Rui Gom",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 17:06:09",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 30.72,
            "sla_met": false,
            "sla_breach_hours": 6.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:49:44"
          },
          {
            "ticket_id": 1042,
            "ticket_number": "351040",
            "title": "GBN-73323 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/10/2025 17:06:11",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 21.23,
            "sla_met": false,
            "sla_breach_hours": 17.23,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 14:20:27"
          },
          {
            "ticket_id": 1044,
            "ticket_number": "351042",
            "title": "GBN-86959 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/10/2025 17:06:15",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 30.75,
            "sla_met": false,
            "sla_breach_hours": 6.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:51:20"
          },
          {
            "ticket_id": 1051,
            "ticket_number": "351049",
            "title": "Localizador 1207997034 _Eduardo Pereira",
            "priority": "P2",
            "created_at": "21/10/2025 18:24:30",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 18:24:30"
          },
          {
            "ticket_id": 1058,
            "ticket_number": "351056",
            "title": "Confirmação de reserva com localizador: 3948322",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:10",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 31.7,
            "sla_met": false,
            "sla_breach_hours": 7.7,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:49:02"
          },
          {
            "ticket_id": 1062,
            "ticket_number": "351060",
            "title": "Traslado | Confirmação da reserva #461733060",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:19",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 31.72,
            "sla_met": false,
            "sla_breach_hours": 7.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 16:50:03"
          },
          {
            "ticket_id": 1064,
            "ticket_number": "351062",
            "title": "Cancelación de la reserva con localizador: 3931518",
            "priority": "P2",
            "created_at": "22/10/2025 09:06:23",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 17:11:36"
          },
          {
            "ticket_id": 1069,
            "ticket_number": "351067",
            "title": "Envio de documentos de File 412541 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "22/10/2025 09:19:23",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 09:40:33"
          },
          {
            "ticket_id": 1071,
            "ticket_number": "351069",
            "title": "Fwd: Informações da reserva TTN-1207997034#8432591",
            "priority": "P2",
            "created_at": "22/10/2025 09:27:25",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 09:27:25"
          },
          {
            "ticket_id": 1081,
            "ticket_number": "351079",
            "title": "Comprovativo de IBAN",
            "priority": "P2",
            "created_at": "22/10/2025 12:15:19",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 12:15:19"
          },
          {
            "ticket_id": 1093,
            "ticket_number": "351091",
            "title": "GBN-87080 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 15:37:39",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 117.43,
            "sla_met": false,
            "sla_breach_hours": 93.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 13:04:24"
          },
          {
            "ticket_id": 1099,
            "ticket_number": "351097",
            "title": "GBN-87095 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:08:31",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 24.97,
            "sla_met": false,
            "sla_breach_hours": 0.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 18:06:39"
          },
          {
            "ticket_id": 1153,
            "ticket_number": "351151",
            "title": "Re:[## 23531 ##] GBN-73323 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "23/10/2025 14:18:09",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 16:50:21"
          },
          {
            "ticket_id": 1161,
            "ticket_number": "351159",
            "title": "Fwd: Viagify informa sobre a sua reserva 121269996",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 15:00:02",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 15:00:01"
          },
          {
            "ticket_id": 1162,
            "ticket_number": "351160",
            "title": "Acesso Douro Acima",
            "priority": "P2",
            "created_at": "23/10/2025 16:21:46",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 16:21:46"
          },
          {
            "ticket_id": 1176,
            "ticket_number": "351174",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "23/10/2025 20:51:51",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 22:44:21"
          },
          {
            "ticket_id": 1178,
            "ticket_number": "351176",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "23/10/2025 20:51:59",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 22:45:37"
          },
          {
            "ticket_id": 1179,
            "ticket_number": "351177",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "23/10/2025 20:52:34",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 22:45:06"
          },
          {
            "ticket_id": 1180,
            "ticket_number": "351178",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "23/10/2025 21:14:28",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 22:43:51"
          },
          {
            "ticket_id": 1183,
            "ticket_number": "351180",
            "title": "Informação de reserva - SPT002501547595",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 22:46:54",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 145.17,
            "sla_met": false,
            "sla_breach_hours": 121.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:57:29"
          },
          {
            "ticket_id": 1186,
            "ticket_number": "351183",
            "title": "Pedido de Cotação - Cntravel (Maria)",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:19",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:03:19"
          },
          {
            "ticket_id": 1205,
            "ticket_number": "351202",
            "title": "Confirmação de reserva para For PT004157 67528547",
            "priority": "P2",
            "created_at": "24/10/2025 10:46:30",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 10.08,
            "sla_met": false,
            "sla_breach_hours": 6.08,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 20:52:04"
          },
          {
            "ticket_id": 1226,
            "ticket_number": "351223",
            "title": "Fwd: Viagify informa sobre a sua reserva 121300753",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 12:58:35",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/10/2025 12:58:35"
          },
          {
            "ticket_id": 1229,
            "ticket_number": "351226",
            "title": "pedido de cotação chalé villa nature - campos do j",
            "priority": "P2",
            "created_at": "24/10/2025 12:58:39",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 12:58:40"
          },
          {
            "ticket_id": 1234,
            "ticket_number": "351231",
            "title": "Pedido de cotação",
            "priority": "P2",
            "created_at": "24/10/2025 14:04:49",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 14:04:49"
          },
          {
            "ticket_id": 1243,
            "ticket_number": "351240",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "24/10/2025 16:41:27",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 17:33:01"
          },
          {
            "ticket_id": 1248,
            "ticket_number": "351245",
            "title": "GBN-87427 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 16:41:41",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/10/2025 16:41:37"
          },
          {
            "ticket_id": 1255,
            "ticket_number": "351252",
            "title": "Re:[## 22545 ##] GBN-85201 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "24/10/2025 18:15:22",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 19:09:41"
          },
          {
            "ticket_id": 1258,
            "ticket_number": "351255",
            "title": "Re:[## 20472 ##] GBN-81261 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "24/10/2025 18:34:36",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 19:08:31"
          },
          {
            "ticket_id": 1295,
            "ticket_number": "351292",
            "title": "Reserva confirmada: Free tour por Bratislava - Civ",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:38",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:06:57"
          },
          {
            "ticket_id": 1296,
            "ticket_number": "351293",
            "title": "Reserva confirmada: Free tour por Viena - Civitati",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:06:43",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:07:16"
          },
          {
            "ticket_id": 1307,
            "ticket_number": "351304",
            "title": "Fwd: Informações da reserva TTN-1210584648#8439469",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:12",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:07:12"
          },
          {
            "ticket_id": 1310,
            "ticket_number": "351307",
            "title": "Reserva confirmada: Free tour por Praga - Civitati",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 10:07:18",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:07:18"
          },
          {
            "ticket_id": 1319,
            "ticket_number": "351316",
            "title": "GBN-87565 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 11:45:15",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 120.95,
            "sla_met": false,
            "sla_breach_hours": 96.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/11/2025 12:42:18"
          },
          {
            "ticket_id": 1333,
            "ticket_number": "351330",
            "title": "Re: Pedido de cotação | 17 pessoas - Brasil",
            "priority": "P2",
            "created_at": "27/10/2025 13:49:39",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 15:57:28"
          },
          {
            "ticket_id": 1339,
            "ticket_number": "351336",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 15:31:46",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 4.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 19:43:54"
          },
          {
            "ticket_id": 1342,
            "ticket_number": "351339",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802042076",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 16:15:29",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 55.72,
            "sla_met": false,
            "sla_breach_hours": 31.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:59:02"
          },
          {
            "ticket_id": 1395,
            "ticket_number": "351392",
            "title": "Pedido Orçamento Leplan - Eunice",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:43",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:04:43"
          },
          {
            "ticket_id": 1408,
            "ticket_number": "351405",
            "title": "FW: Pedido de Cotação | 14 pessoas - México // 03.",
            "priority": "P2",
            "created_at": "28/10/2025 12:02:26",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 27.17,
            "sla_met": false,
            "sla_breach_hours": 23.17,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 15:13:06"
          },
          {
            "ticket_id": 1465,
            "ticket_number": "351462",
            "title": "Icárion - Belezas de Madagáscar em Privado - 01/07",
            "priority": "P2",
            "created_at": "28/10/2025 23:42:08",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 23:49:04"
          },
          {
            "ticket_id": 1484,
            "ticket_number": "351481",
            "title": "Fwd: Viagify informa sobre a sua reserva 121437708",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 12:47:56",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 12:47:56"
          },
          {
            "ticket_id": 1485,
            "ticket_number": "351482",
            "title": "Fwd: Confirmacion de la reserva Transavia: DFBLPQ",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 12:47:58",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 12:47:58"
          },
          {
            "ticket_id": 1504,
            "ticket_number": "351501",
            "title": "Criação de processo File 414549/25",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 16:32:53",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 6.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:30:27"
          },
          {
            "ticket_id": 1530,
            "ticket_number": "351527",
            "title": "Confirmação de reserva. Localizador: 4L2R37T39P",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 23:33:53",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:55:53"
          },
          {
            "ticket_id": 1586,
            "ticket_number": "351583",
            "title": "Fwd: Localizador 1189851160 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "30/10/2025 19:21:52",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 14:12:27"
          },
          {
            "ticket_id": 1590,
            "ticket_number": "351587",
            "title": "GBN-88137 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/10/2025 22:06:35",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 22:25:57"
          },
          {
            "ticket_id": 1591,
            "ticket_number": "351588",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 22:42:22",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/10/2025 23:30:06"
          },
          {
            "ticket_id": 1593,
            "ticket_number": "351590",
            "title": "Fwd: Incidente de voo TTN-1199230549#85004027#T153",
            "priority": "P2",
            "created_at": "30/10/2025 23:27:41",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 19:24:34"
          },
          {
            "ticket_id": 1621,
            "ticket_number": "351618",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 13:14:56",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 18:16:17"
          },
          {
            "ticket_id": 1640,
            "ticket_number": "351637",
            "title": "GBN-88260 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 18:16:19",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 19.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/11/2025 13:49:45"
          },
          {
            "ticket_id": 1645,
            "ticket_number": "351642",
            "title": "Re:[## 23410 ##] GBN-84940 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "31/10/2025 18:16:34",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 17:21:28"
          },
          {
            "ticket_id": 1646,
            "ticket_number": "351643",
            "title": "soltour promo 2 novembro",
            "priority": "P2",
            "created_at": "31/10/2025 18:16:38",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 18:16:38"
          },
          {
            "ticket_id": 1649,
            "ticket_number": "351646",
            "title": "FW: GRUP-18757 Cotización GRUP-17964 - Dança - Pat",
            "priority": "P2",
            "created_at": "31/10/2025 18:40:15",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 18:40:15"
          },
          {
            "ticket_id": 1662,
            "ticket_number": "351659",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "01/11/2025 15:05:57",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 99.2,
            "sla_met": false,
            "sla_breach_hours": 75.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 18:18:51"
          },
          {
            "ticket_id": 1665,
            "ticket_number": "351662",
            "title": "GBN-88343 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "01/11/2025 16:46:44",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/11/2025 17:57:49"
          },
          {
            "ticket_id": 1739,
            "ticket_number": "351736",
            "title": "Orçamento de grupo - 10 pessoas | Beatriz -TVP 326",
            "priority": "P2",
            "created_at": "03/11/2025 14:09:09",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 22:38:21"
          },
          {
            "ticket_id": 1748,
            "ticket_number": "351745",
            "title": "GBN-88469 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 16:22:16",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 49.32,
            "sla_met": false,
            "sla_breach_hours": 25.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 17:41:58"
          },
          {
            "ticket_id": 1749,
            "ticket_number": "351746",
            "title": "GBN-88464 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/11/2025 16:22:19",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 49.28,
            "sla_met": false,
            "sla_breach_hours": 25.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 17:39:52"
          },
          {
            "ticket_id": 1812,
            "ticket_number": "351809",
            "title": "Disney Paris - Maio",
            "priority": "P3",
            "created_at": "04/11/2025 13:32:42",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 13:32:42"
          },
          {
            "ticket_id": 1824,
            "ticket_number": "351821",
            "title": "GBN-88550 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/11/2025 16:07:53",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 16:07:53"
          },
          {
            "ticket_id": 1830,
            "ticket_number": "351827",
            "title": "Re:[## 24279 ##] GBN-86637 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "04/11/2025 17:33:53",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 17:33:53"
          },
          {
            "ticket_id": 1847,
            "ticket_number": "351844",
            "title": "Reserva confirmada: Ingresso da Basílica de São Ma",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 22:26:23",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/11/2025 22:26:25"
          },
          {
            "ticket_id": 1850,
            "ticket_number": "351847",
            "title": "GBN-88757 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/11/2025 22:26:36",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 22:27:34"
          },
          {
            "ticket_id": 1861,
            "ticket_number": "351858",
            "title": "GBN-88755 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 10:48:24",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 10:48:18"
          },
          {
            "ticket_id": 1874,
            "ticket_number": "351871",
            "title": "GBN-85634 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/11/2025 12:57:53",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 15:18:19"
          },
          {
            "ticket_id": 1879,
            "ticket_number": "351876",
            "title": "GBN-88822 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 15:04:43",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:28:28"
          },
          {
            "ticket_id": 1882,
            "ticket_number": "351879",
            "title": "GBN-88827 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 16:43:29",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 18:19:58"
          },
          {
            "ticket_id": 1886,
            "ticket_number": "351883",
            "title": "Alteração de horário de voo 4125929 e   4125927 | ",
            "priority": "P2",
            "created_at": "05/11/2025 18:50:51",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 18:50:51"
          },
          {
            "ticket_id": 1888,
            "ticket_number": "351885",
            "title": "Criação de processo File 415117/25",
            "priority": "P1",
            "created_at": "05/11/2025 19:13:00",
            "close_date": "2025-11-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/11/2025 19:13:00"
          },
          {
            "ticket_id": 1893,
            "ticket_number": "351890",
            "title": "GBN-88912   - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 20:54:20",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 20.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 17:09:36"
          },
          {
            "ticket_id": 1906,
            "ticket_number": "351903",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604487840",
            "priority": "Reservas sem Formulário",
            "created_at": "06/11/2025 00:05:37",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 40.17,
            "sla_met": false,
            "sla_breach_hours": 16.17,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 16:16:00"
          },
          {
            "ticket_id": 1943,
            "ticket_number": "351940",
            "title": "GBN-88971 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "06/11/2025 14:49:38",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 15:50:01"
          },
          {
            "ticket_id": 1944,
            "ticket_number": "351941",
            "title": "Urgente: Pedido de informação | Hotel - Ana",
            "priority": "P1",
            "created_at": "06/11/2025 15:32:21",
            "close_date": "2025-11-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/11/2025 15:32:21"
          },
          {
            "ticket_id": 1947,
            "ticket_number": "351943",
            "title": "Pedido de cotação - Nordictour | Armanda",
            "priority": "P2",
            "created_at": "06/11/2025 16:24:55",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 16:25:38"
          },
          {
            "ticket_id": 1951,
            "ticket_number": "351947",
            "title": "Confirmação de Reserva * File 415145",
            "priority": "P2",
            "created_at": "06/11/2025 17:31:44",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 17:50:05"
          },
          {
            "ticket_id": 1987,
            "ticket_number": "351983",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 11:07:15",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 5.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 16:40:17"
          },
          {
            "ticket_id": 1993,
            "ticket_number": "351989",
            "title": "GBN-89113 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 14:00:21",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 16:37:14"
          },
          {
            "ticket_id": 1996,
            "ticket_number": "351992",
            "title": "GBN-89118 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 15:02:06",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 16:35:50"
          },
          {
            "ticket_id": 2039,
            "ticket_number": "352035",
            "title": "Reserva Leplan 604485932 - adicionar bolo",
            "priority": "P2",
            "created_at": "08/11/2025 12:09:04",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 12:09:04"
          },
          {
            "ticket_id": 2075,
            "ticket_number": "352071",
            "title": "Reserva 604469673 - 21 a 23 nov - troca transfer",
            "priority": "P2",
            "created_at": "10/11/2025 10:10:55",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:10:55"
          },
          {
            "ticket_id": 2088,
            "ticket_number": "352084",
            "title": "Re: 404563 - Solférias",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:38",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:11:38"
          },
          {
            "ticket_id": 2111,
            "ticket_number": "352107",
            "title": "Sincronização APP Disney",
            "priority": "P2",
            "created_at": "10/11/2025 12:07:55",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 12:07:56"
          },
          {
            "ticket_id": 2117,
            "ticket_number": "352113",
            "title": "Pedido Orçamento | Grupo 7 adultos 8 crianças | Ca",
            "priority": "P2",
            "created_at": "10/11/2025 13:00:38",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 13:00:38"
          },
          {
            "ticket_id": 2144,
            "ticket_number": "352140",
            "title": "Confirmação de Reserva * File 415457 * EMISSAO VOO",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 17:37:03",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 13:46:32"
          },
          {
            "ticket_id": 2147,
            "ticket_number": "352143",
            "title": "Confirmação de Reserva * File 415469 * EMISSAO VOO",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 17:44:18",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 4.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 22:24:04"
          },
          {
            "ticket_id": 2150,
            "ticket_number": "352146",
            "title": "Re:[## 24579 ##] GBN-68378 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/11/2025 19:16:21",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 4.77,
            "sla_met": false,
            "sla_breach_hours": 0.77,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 00:03:16"
          },
          {
            "ticket_id": 2153,
            "ticket_number": "352149",
            "title": "Inquiry – Aparthotel Adagio Dubai Deira | Joana",
            "priority": "P2",
            "created_at": "10/11/2025 19:26:15",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 19:26:15"
          },
          {
            "ticket_id": 2155,
            "ticket_number": "352151",
            "title": "Pedido de cotação - Estância de neve | Inês",
            "priority": "P2",
            "created_at": "10/11/2025 19:30:33",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 19:30:33"
          },
          {
            "ticket_id": 2162,
            "ticket_number": "352158",
            "title": "Promoção da Disney | Filipa",
            "priority": "P2",
            "created_at": "10/11/2025 22:19:29",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 22:19:29"
          },
          {
            "ticket_id": 2166,
            "ticket_number": "352162",
            "title": "Pedido de cotação - Planesqui | Sónia",
            "priority": "P2",
            "created_at": "10/11/2025 22:44:26",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 22:44:26"
          },
          {
            "ticket_id": 2204,
            "ticket_number": "352200",
            "title": "Pedido de valores para festa passagem de ano - Vér",
            "priority": "P2",
            "created_at": "11/11/2025 15:58:15",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 15:58:15"
          },
          {
            "ticket_id": 2208,
            "ticket_number": "352204",
            "title": "Pedido de Orçamento – Açores (São Miguel) – Hotel ",
            "priority": "P2",
            "created_at": "11/11/2025 16:49:08",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 16:49:08"
          },
          {
            "ticket_id": 2209,
            "ticket_number": "352205",
            "title": "Fwd: Incidente de voo TTN-1210961262#85290020#T154",
            "priority": "P3",
            "created_at": "11/11/2025 16:53:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 16:53:04"
          },
          {
            "ticket_id": 2213,
            "ticket_number": "352209",
            "title": "Envio de documentação - FILE 404563",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 17:14:36",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 151.42,
            "sla_met": false,
            "sla_breach_hours": 127.42,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 00:40:25"
          },
          {
            "ticket_id": 2241,
            "ticket_number": "352237",
            "title": "GBN-89700 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 22:47:18",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 49.92,
            "sla_met": false,
            "sla_breach_hours": 25.92,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 00:42:39"
          },
          {
            "ticket_id": 2243,
            "ticket_number": "352239",
            "title": "Criação de processo File 415694/25",
            "priority": "Reservas sem Formulário",
            "created_at": "11/11/2025 22:48:04",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 00:08:41"
          },
          {
            "ticket_id": 2277,
            "ticket_number": "352273",
            "title": "Orçamento de grupo | Senegal ou Jamaica Setembro 2",
            "priority": "P3",
            "created_at": "12/11/2025 12:45:01",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 12:45:01"
          },
          {
            "ticket_id": 2289,
            "ticket_number": "352285",
            "title": "SOLICITAÇÃO PARA MSC CRUZEIROS ",
            "priority": "P2",
            "created_at": "12/11/2025 13:55:33",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 13:55:33"
          },
          {
            "ticket_id": 2293,
            "ticket_number": "352289",
            "title": "Pedido de orçamento Grupo Ilha do Sal - Agosto | C",
            "priority": "P3",
            "created_at": "12/11/2025 15:20:35",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 15:20:36"
          },
          {
            "ticket_id": 2304,
            "ticket_number": "352299",
            "title": "URGENTE | INFORMAÇÃO DE VOOS | CATARINA",
            "priority": "P2",
            "created_at": "12/11/2025 16:43:22",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 16:51:57"
          },
          {
            "ticket_id": 2332,
            "ticket_number": "352327",
            "title": "Confirmação de Reserva * File 415693 *TKT'S EMITID",
            "priority": "P2",
            "created_at": "12/11/2025 23:01:29",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 18:18:08"
          },
          {
            "ticket_id": 2333,
            "ticket_number": "352328",
            "title": "Pedido de informação | Smart Parking",
            "priority": "P3",
            "created_at": "12/11/2025 23:10:58",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 23:10:58"
          },
          {
            "ticket_id": 2367,
            "ticket_number": "352362",
            "title": "Fwd: Confirmación de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 12:17:40",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 12:17:40"
          },
          {
            "ticket_id": 2381,
            "ticket_number": "352376",
            "title": "Reserva Vera Ferreira",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 14:09:45",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 14:09:45"
          },
          {
            "ticket_id": 2409,
            "ticket_number": "352404",
            "title": "GBN-89968 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 17:09:25",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 148.08,
            "sla_met": false,
            "sla_breach_hours": 124.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:14:37"
          },
          {
            "ticket_id": 2429,
            "ticket_number": "352424",
            "title": "GBN-87699 pedido actualização pagamento",
            "priority": "P2",
            "created_at": "13/11/2025 19:06:58",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 18:54:58"
          },
          {
            "ticket_id": 2447,
            "ticket_number": "352442",
            "title": "Orçamento Nepal com subida à base Evereste",
            "priority": "P3",
            "created_at": "13/11/2025 22:25:01",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 22:25:02"
          },
          {
            "ticket_id": 2501,
            "ticket_number": "352496",
            "title": "Informação sobre Pacote Djerba | Nair",
            "priority": "P2",
            "created_at": "14/11/2025 17:50:40",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 17:50:40"
          },
          {
            "ticket_id": 2505,
            "ticket_number": "352500",
            "title": "Att Catia Leal_RV _ 1136700526",
            "priority": "P2",
            "created_at": "14/11/2025 18:06:41",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:06:41"
          },
          {
            "ticket_id": 2532,
            "ticket_number": "352527",
            "title": "GBN-90238 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "15/11/2025 13:22:45",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 147.27,
            "sla_met": false,
            "sla_breach_hours": 123.27,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:39:23"
          },
          {
            "ticket_id": 2537,
            "ticket_number": "352532",
            "title": "Fwd: Confirmacion de la reserva Transavia: BGF15K",
            "priority": "Reservas sem Formulário",
            "created_at": "15/11/2025 15:47:08",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/11/2025 15:47:08"
          },
          {
            "ticket_id": 2566,
            "ticket_number": "352561",
            "title": "Actualização Passaporte - GBN-89294",
            "priority": "P2",
            "created_at": "17/11/2025 10:16:05",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 10:16:05"
          },
          {
            "ticket_id": 2571,
            "ticket_number": "352566",
            "title": "Pedido de orçamento - grupo",
            "priority": "P3",
            "created_at": "17/11/2025 10:18:08",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 10:18:08"
          },
          {
            "ticket_id": 2579,
            "ticket_number": "352574",
            "title": "\"GBN-90171 - Your request has been received\"",
            "priority": "P2",
            "created_at": "17/11/2025 10:28:26",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:52:05"
          },
          {
            "ticket_id": 2580,
            "ticket_number": "352575",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "17/11/2025 10:28:27",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 5.48,
            "sla_met": false,
            "sla_breach_hours": 1.48,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 15:57:29"
          },
          {
            "ticket_id": 2588,
            "ticket_number": "352583",
            "title": "Confirmação de reserva para For PT004157 63517580",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 11:22:34",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 101.68,
            "sla_met": false,
            "sla_breach_hours": 77.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:04:14"
          },
          {
            "ticket_id": 2609,
            "ticket_number": "352604",
            "title": "Pedido de orçamento de grupo - Ilha do Sal | Ana S",
            "priority": "P3",
            "created_at": "17/11/2025 14:46:22",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 14:46:22"
          },
          {
            "ticket_id": 2620,
            "ticket_number": "352615",
            "title": "Re:[## 25183 ##] GBN-89294 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "17/11/2025 17:11:54",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 17:12:30"
          },
          {
            "ticket_id": 2622,
            "ticket_number": "352617",
            "title": "Número de informação da reserva: 6120803",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/11/2025 17:49:22",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 18:00:03"
          },
          {
            "ticket_id": 2623,
            "ticket_number": "352618",
            "title": "circuito tunisia",
            "priority": "P3",
            "created_at": "17/11/2025 17:49:23",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 17:49:23"
          },
          {
            "ticket_id": 2638,
            "ticket_number": "352633",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 19:24:09",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 19:40:23"
          },
          {
            "ticket_id": 2647,
            "ticket_number": "352642",
            "title": "Fwd: Reminder : Get ready for your flight AT285 fr",
            "priority": "P2",
            "created_at": "17/11/2025 21:59:32",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 21:59:33"
          },
          {
            "ticket_id": 2648,
            "ticket_number": "352643",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 21:59:39",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 21:59:40"
          },
          {
            "ticket_id": 2650,
            "ticket_number": "352645",
            "title": "GBN Travel: Resend booking confirmation - GBN-8769",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 21:59:55",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/11/2025 21:59:55"
          },
          {
            "ticket_id": 2651,
            "ticket_number": "352646",
            "title": "Confirmação reserva Bedsonline 164-10355556",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 22:00:01",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 91.08,
            "sla_met": false,
            "sla_breach_hours": 67.08,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:05:10"
          },
          {
            "ticket_id": 2659,
            "ticket_number": "352654",
            "title": "Pedido de informação | Catarina Dinis",
            "priority": "P2",
            "created_at": "17/11/2025 23:40:03",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 23:40:03"
          },
          {
            "ticket_id": 2661,
            "ticket_number": "352656",
            "title": "Marraquexe 6 a 11 de Abril 2026",
            "priority": "P3",
            "created_at": "18/11/2025 00:21:00",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 19.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 19:25:59"
          },
          {
            "ticket_id": 2693,
            "ticket_number": "352688",
            "title": "Fwd: Viagify informa sobre a sua reserva 122009298",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "18/11/2025 12:55:50",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 12:55:51"
          },
          {
            "ticket_id": 2702,
            "ticket_number": "352697",
            "title": "Recibo verde",
            "priority": "P3",
            "created_at": "18/11/2025 13:52:12",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 13:52:12"
          },
          {
            "ticket_id": 2725,
            "ticket_number": "352720",
            "title": "Fwd: Viagify informa sobre a sua reserva 122028963",
            "priority": "P3",
            "created_at": "18/11/2025 21:14:28",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 21:14:29"
          },
          {
            "ticket_id": 2736,
            "ticket_number": "352731",
            "title": "duvida Smy - Norwegian Dawn",
            "priority": "P3",
            "created_at": "18/11/2025 21:32:56",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 00:25:44"
          },
          {
            "ticket_id": 2742,
            "ticket_number": "352737",
            "title": "Pedido de informação | Insure Broker",
            "priority": "P2",
            "created_at": "18/11/2025 23:48:18",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 23:48:18"
          },
          {
            "ticket_id": 2743,
            "ticket_number": "352738",
            "title": "Información de reserva número: 1761128",
            "priority": "P3",
            "created_at": "19/11/2025 00:03:55",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 65.23,
            "sla_met": false,
            "sla_breach_hours": 41.23,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 17:18:29"
          },
          {
            "ticket_id": 2746,
            "ticket_number": "352741",
            "title": "Pedido Orçamento Grupo Alambique - Hotel Resort & ",
            "priority": "P2",
            "created_at": "19/11/2025 00:03:59",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 00:04:00"
          },
          {
            "ticket_id": 2748,
            "ticket_number": "352743",
            "title": "Pedido Orçamento Grupo 25 Pessoas Solférias - Açor",
            "priority": "P2",
            "created_at": "19/11/2025 00:04:03",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 00:04:03"
          },
          {
            "ticket_id": 2752,
            "ticket_number": "352747",
            "title": "Pedido de Informação | New Blue - 1761128",
            "priority": "P2",
            "created_at": "19/11/2025 00:29:52",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 00:29:52"
          },
          {
            "ticket_id": 2783,
            "ticket_number": "352778",
            "title": "Fwd: Bom dia Silvia Monica Cunha Costa: Bilhete e ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 11:58:05",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 11:58:05"
          },
          {
            "ticket_id": 2802,
            "ticket_number": "352797",
            "title": "Fwd: Informações da reserva TTN-1198583451#8638986",
            "priority": "P3",
            "created_at": "19/11/2025 15:31:53",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 15:31:54"
          },
          {
            "ticket_id": 2813,
            "ticket_number": "352808",
            "title": "\"GBN-77920 - Your request has been received\"",
            "priority": "P2",
            "created_at": "19/11/2025 16:41:49",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 18:29:03"
          },
          {
            "ticket_id": 2829,
            "ticket_number": "352824",
            "title": "Meia pensão no hotel parceiro da Disney",
            "priority": "P3",
            "created_at": "19/11/2025 21:03:00",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 21:03:01"
          },
          {
            "ticket_id": 2831,
            "ticket_number": "352826",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P2",
            "created_at": "19/11/2025 21:30:06",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 21:59:21"
          },
          {
            "ticket_id": 2870,
            "ticket_number": "352865",
            "title": "Número de informação da reserva: 6121540",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 12:17:14",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 22:03:04"
          },
          {
            "ticket_id": 2885,
            "ticket_number": "352880",
            "title": "Pedido de cotação SOLTOUR - URGENTE",
            "priority": "P2",
            "created_at": "20/11/2025 15:56:09",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 15:56:09"
          },
          {
            "ticket_id": 2903,
            "ticket_number": "352898",
            "title": "Pedido de verificação – Jantar de Passagem de Ano ",
            "priority": "P3",
            "created_at": "20/11/2025 18:39:37",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 18:39:37"
          },
          {
            "ticket_id": 2906,
            "ticket_number": "352901",
            "title": "Reserva em WL file- 333882",
            "priority": "P2",
            "created_at": "20/11/2025 19:29:51",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 19:41:33"
          },
          {
            "ticket_id": 2920,
            "ticket_number": "352915",
            "title": "GBN-91007 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 23:51:02",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 17.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:00:43"
          },
          {
            "ticket_id": 2926,
            "ticket_number": "352921",
            "title": "Número de informação da reserva: 6121773",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/11/2025 10:05:39",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 5.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 15:06:48"
          },
          {
            "ticket_id": 2933,
            "ticket_number": "352928",
            "title": "Confirmacao 334068",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 11:25:52",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 5.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:09:49"
          },
          {
            "ticket_id": 2944,
            "ticket_number": "352939",
            "title": "GBN-91048 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 12:59:17",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 3.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:29:55"
          },
          {
            "ticket_id": 2952,
            "ticket_number": "352947",
            "title": "GBN-91093 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 15:49:38",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 16:22:52"
          },
          {
            "ticket_id": 2959,
            "ticket_number": "352954",
            "title": "SOLICTAMOS ORÇAMENTO GRUPO Á SOLFÉRIAS - HURGHADA+",
            "priority": "P3",
            "created_at": "21/11/2025 16:25:12",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 16:25:12"
          },
          {
            "ticket_id": 2965,
            "ticket_number": "352960",
            "title": "Orçamento Djerba - 1 a 8 Agosto - 2026",
            "priority": "P3",
            "created_at": "21/11/2025 17:48:52",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 17:48:52"
          },
          {
            "ticket_id": 2970,
            "ticket_number": "352965",
            "title": "Fwd: Viagify informa sobre a sua reserva 122116047",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:52:22",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:52:23"
          },
          {
            "ticket_id": 2971,
            "ticket_number": "352966",
            "title": "Fwd: Viagify informa sobre a sua reserva 122116265",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:52:25",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:52:26"
          },
          {
            "ticket_id": 2973,
            "ticket_number": "352968",
            "title": "Fwd: Viagify informa sobre a sua reserva 122108668",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:53:02",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:53:03"
          },
          {
            "ticket_id": 2975,
            "ticket_number": "352970",
            "title": "Fwd: Viagify informa sobre a sua reserva 122107276",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:54:14",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:54:15"
          },
          {
            "ticket_id": 2976,
            "ticket_number": "352971",
            "title": "Fwd: Viagify informa sobre a sua reserva 122107277",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 17:54:17",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 17:54:17"
          },
          {
            "ticket_id": 2990,
            "ticket_number": "352985",
            "title": "Contacto - Atividades",
            "priority": "P3",
            "created_at": "21/11/2025 20:05:12",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 22:22:26"
          },
          {
            "ticket_id": 2997,
            "ticket_number": "352992",
            "title": "GBN Travel: Resend booking confirmation - GBN-8547",
            "priority": "P2",
            "created_at": "21/11/2025 21:49:32",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 21:35:30"
          },
          {
            "ticket_id": 3005,
            "ticket_number": "353000",
            "title": "Re: Envio de Documentação * File 407089 - URGENTE",
            "priority": "P2",
            "created_at": "21/11/2025 22:51:14",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 22:51:14"
          },
          {
            "ticket_id": 3007,
            "ticket_number": "353002",
            "title": "GBN-91233 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 09:58:11",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 38.13,
            "sla_met": false,
            "sla_breach_hours": 14.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:07:04"
          },
          {
            "ticket_id": 3011,
            "ticket_number": "353006",
            "title": "- Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "22/11/2025 11:45:20",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 36.38,
            "sla_met": false,
            "sla_breach_hours": 12.38,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 00:08:46"
          },
          {
            "ticket_id": 3012,
            "ticket_number": "353007",
            "title": "Número de informação da reserva: 6122131",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 12:42:33",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 35.45,
            "sla_met": false,
            "sla_breach_hours": 11.45,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:10:02"
          },
          {
            "ticket_id": 3013,
            "ticket_number": "353008",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497469",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 13:02:47",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 35.12,
            "sla_met": false,
            "sla_breach_hours": 11.12,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:10:22"
          },
          {
            "ticket_id": 3018,
            "ticket_number": "353013",
            "title": "GBN-91275 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 16:37:05",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 31.55,
            "sla_met": false,
            "sla_breach_hours": 7.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:11:05"
          },
          {
            "ticket_id": 3019,
            "ticket_number": "353014",
            "title": "GBN-91274 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 16:37:13",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 31.58,
            "sla_met": false,
            "sla_breach_hours": 7.58,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:12:28"
          },
          {
            "ticket_id": 3020,
            "ticket_number": "353015",
            "title": "GBN-91284 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 17:20:01",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 30.87,
            "sla_met": false,
            "sla_breach_hours": 6.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:12:02"
          },
          {
            "ticket_id": 3021,
            "ticket_number": "353016",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 18:04:14",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 30.1,
            "sla_met": false,
            "sla_breach_hours": 6.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:10:43"
          },
          {
            "ticket_id": 3024,
            "ticket_number": "353019",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497621",
            "priority": "P3",
            "created_at": "22/11/2025 20:02:50",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.17,
            "sla_met": false,
            "sla_breach_hours": 4.17,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 00:12:52"
          },
          {
            "ticket_id": 3033,
            "ticket_number": "353028",
            "title": "Reserva confirmada: Cruzeiro com almoço e música a",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 22:21:40",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 25.9,
            "sla_met": false,
            "sla_breach_hours": 1.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:16:04"
          },
          {
            "ticket_id": 3034,
            "ticket_number": "353029",
            "title": "Reserva confirmada: Cruzeiro com almoço e música a",
            "priority": "Reservas sem Formulário",
            "created_at": "22/11/2025 22:21:42",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 25.9,
            "sla_met": false,
            "sla_breach_hours": 1.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:16:28"
          },
          {
            "ticket_id": 3037,
            "ticket_number": "353032",
            "title": "Civitatis - Re: Contacto - Atividades",
            "priority": "P2",
            "created_at": "23/11/2025 11:07:01",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 5.0,
            "sla_met": false,
            "sla_breach_hours": 1.0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 16:08:01"
          },
          {
            "ticket_id": 3041,
            "ticket_number": "353036",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "23/11/2025 16:38:02",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 16:38:02"
          },
          {
            "ticket_id": 3042,
            "ticket_number": "353037",
            "title": "ORÇAMENTO URGENTE ✈️FAMÍLIA DE 5 Pessoas 🌍consulto",
            "priority": "P2",
            "created_at": "23/11/2025 17:33:26",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 17:33:26"
          },
          {
            "ticket_id": 3044,
            "ticket_number": "353039",
            "title": "Confirmacao 334347",
            "priority": "P2",
            "created_at": "23/11/2025 18:18:43",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 21:11:36"
          },
          {
            "ticket_id": 3045,
            "ticket_number": "353040",
            "title": "GBN-91292 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/11/2025 18:46:36",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 4.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/11/2025 23:10:53"
          },
          {
            "ticket_id": 3048,
            "ticket_number": "353041",
            "title": "Bilhetes - LePlan",
            "priority": "P2",
            "created_at": "23/11/2025 18:52:13",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 18:52:13"
          },
          {
            "ticket_id": 3050,
            "ticket_number": "353043",
            "title": "Pedido urgente grupo ilha do sal",
            "priority": "P2",
            "created_at": "23/11/2025 19:55:17",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 19:55:18"
          },
          {
            "ticket_id": 3057,
            "ticket_number": "353050",
            "title": "Reserva Eduardo Pereira Smytravel Loc: 1207997034",
            "priority": "P3",
            "created_at": "23/11/2025 21:48:19",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 21:48:19"
          },
          {
            "ticket_id": 3058,
            "ticket_number": "353051",
            "title": "ESCLARECIMENTO TRAVELPLAN",
            "priority": "P2",
            "created_at": "23/11/2025 22:38:53",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 22:38:54"
          },
          {
            "ticket_id": 3059,
            "ticket_number": "353052",
            "title": "GBN-91357 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/11/2025 22:51:10",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 23:26:39"
          },
          {
            "ticket_id": 3091,
            "ticket_number": "353084",
            "title": "Reserva em WL 208653",
            "priority": "P2",
            "created_at": "24/11/2025 12:52:08",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 13:00:25"
          },
          {
            "ticket_id": 3095,
            "ticket_number": "353088",
            "title": "Notificação de autorização File 400707/25",
            "priority": "P3",
            "created_at": "24/11/2025 13:48:27",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 15:20:55"
          },
          {
            "ticket_id": 3105,
            "ticket_number": "353098",
            "title": "Emissão RV - pagamento comissões 2025",
            "priority": "P2",
            "created_at": "24/11/2025 15:27:31",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 15:27:31"
          },
          {
            "ticket_id": 3128,
            "ticket_number": "353121",
            "title": "GBN-83129 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/11/2025 20:13:24",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 405.07,
            "sla_met": false,
            "sla_breach_hours": 401.07,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 17:17:28"
          },
          {
            "ticket_id": 3141,
            "ticket_number": "353134",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 23:47:43",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 16.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 16:17:25"
          },
          {
            "ticket_id": 3142,
            "ticket_number": "353135",
            "title": "Pedido orçamento à Smytravel",
            "priority": "P2",
            "created_at": "24/11/2025 23:51:30",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 23:51:31"
          },
          {
            "ticket_id": 3143,
            "ticket_number": "353136",
            "title": "Criação de processo File 417998/25",
            "priority": "P2",
            "created_at": "24/11/2025 23:53:54",
            "close_date": "2025-11-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 00:06:19"
          },
          {
            "ticket_id": 3173,
            "ticket_number": "353166",
            "title": "Re:[## 25714 ##] GBN-83129 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "25/11/2025 13:41:10",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 16:43:00"
          },
          {
            "ticket_id": 3206,
            "ticket_number": "353199",
            "title": "Re:[## 25777 ##] GBN-91576 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "25/11/2025 18:22:40",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 18:38:31"
          },
          {
            "ticket_id": 3208,
            "ticket_number": "353201",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 18:52:14",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 18:52:14"
          },
          {
            "ticket_id": 3277,
            "ticket_number": "353270",
            "title": "Fwd: Viagify informa sobre a sua reserva 122274047",
            "priority": "P2",
            "created_at": "26/11/2025 13:49:49",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 13:49:50"
          },
          {
            "ticket_id": 3278,
            "ticket_number": "353271",
            "title": "Fwd: Viagify informa sobre a sua reserva 122273047",
            "priority": "P2",
            "created_at": "26/11/2025 13:49:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 13:49:55"
          },
          {
            "ticket_id": 3279,
            "ticket_number": "353272",
            "title": "Fwd: Viagify informa sobre a sua reserva 122274047",
            "priority": "P2",
            "created_at": "26/11/2025 13:49:57",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 13:49:59"
          },
          {
            "ticket_id": 3348,
            "ticket_number": "353341",
            "title": "Fwd: Viagify informa sobre a sua reserva 122299365",
            "priority": "P2",
            "created_at": "27/11/2025 10:54:40",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 10:54:31"
          },
          {
            "ticket_id": 3409,
            "ticket_number": "353402",
            "title": "Fw: Orçamentos TURQUIA",
            "priority": "P2",
            "created_at": "27/11/2025 21:24:10",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 00:26:23"
          },
          {
            "ticket_id": 3430,
            "ticket_number": "353423",
            "title": "Fwd: Viagify informa sobre a sua reserva 122338521",
            "priority": "P2",
            "created_at": "28/11/2025 10:05:40",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 10:05:41"
          },
          {
            "ticket_id": 3434,
            "ticket_number": "353427",
            "title": "Fwd: Viagify informa sobre a sua reserva 122337523",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 10:06:21",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 10:06:21"
          },
          {
            "ticket_id": 3492,
            "ticket_number": "353485",
            "title": "Re:[## 25947 ##] GBN-92041 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "28/11/2025 19:14:12",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 20:15:09"
          },
          {
            "ticket_id": 3517,
            "ticket_number": "353510",
            "title": "PEDIDO DE ORÇAMENTO 10 ADULTOS 1 BEBE ( 1 ANO )",
            "priority": "P3",
            "created_at": "29/11/2025 10:18:57",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 10:18:58"
          },
          {
            "ticket_id": 3609,
            "ticket_number": "353602",
            "title": "Emissão de documentação localizador  409435/2025 e",
            "priority": "P2",
            "created_at": "01/12/2025 14:41:48",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 14:41:49"
          },
          {
            "ticket_id": 3703,
            "ticket_number": "353695",
            "title": "Envio de Documentação * File 409435",
            "priority": "P2",
            "created_at": "02/12/2025 17:10:22",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:13:07"
          },
          {
            "ticket_id": 3718,
            "ticket_number": "353710",
            "title": "Pedido de informação | Leplan",
            "priority": "P2",
            "created_at": "02/12/2025 20:38:31",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 20:38:32"
          },
          {
            "ticket_id": 3802,
            "ticket_number": "353794",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 17:15:32",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 17:15:32"
          },
          {
            "ticket_id": 3803,
            "ticket_number": "353795",
            "title": "GBN-93147 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 17:15:38",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 18:23:00"
          },
          {
            "ticket_id": 3806,
            "ticket_number": "353798",
            "title": "Reserva pagada",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 17:42:14",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 18:34:01"
          },
          {
            "ticket_id": 3815,
            "ticket_number": "353807",
            "title": "Fwd: Localizador 1225112440 - SmyTravel informa TT",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 18:39:36",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 18:39:36"
          },
          {
            "ticket_id": 3824,
            "ticket_number": "353816",
            "title": "GBN-78564 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/12/2025 19:57:12",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 22:15:03"
          },
          {
            "ticket_id": 3830,
            "ticket_number": "353822",
            "title": "TCP-7403 - Confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/12/2025 21:04:12",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:06:21"
          },
          {
            "ticket_id": 3964,
            "ticket_number": "353956",
            "title": "Fwd: Informações da reserva TTN-1209800114#8759716",
            "priority": "P3",
            "created_at": "05/12/2025 17:50:24",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 16:17:23"
          },
          {
            "ticket_id": 3992,
            "ticket_number": "353984",
            "title": "Reserva 731977",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/12/2025 23:29:30",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 23:52:33"
          },
          {
            "ticket_id": 4226,
            "ticket_number": "354218",
            "title": "LOC 334068 - Soltrópico",
            "priority": "P2",
            "created_at": "11/12/2025 13:58:58",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 13:58:58"
          },
          {
            "ticket_id": 4228,
            "ticket_number": "354220",
            "title": "Fwd: Informações da reserva TTN-1199695315#8807846",
            "priority": "P2",
            "created_at": "11/12/2025 14:00:40",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 14:00:41"
          },
          {
            "ticket_id": 3200,
            "ticket_number": "353193",
            "title": "Pedido de Cotação à Solférias",
            "priority": "P3",
            "created_at": "25/11/2025 17:35:03",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 17:35:03"
          },
          {
            "ticket_id": 3205,
            "ticket_number": "353198",
            "title": "Pedido de Cotação à Soltrópico",
            "priority": "P2",
            "created_at": "25/11/2025 18:14:54",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 18:14:54"
          },
          {
            "ticket_id": 3220,
            "ticket_number": "353213",
            "title": "asunto",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "25/11/2025 22:44:21",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 23:29:10"
          },
          {
            "ticket_id": 3252,
            "ticket_number": "353245",
            "title": "leplan",
            "priority": "P2",
            "created_at": "26/11/2025 10:48:43",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 14:05:22"
          },
          {
            "ticket_id": 3272,
            "ticket_number": "353265",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604500561",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "26/11/2025 13:23:43",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/11/2025 23:22:02"
          },
          {
            "ticket_id": 3397,
            "ticket_number": "353390",
            "title": "Fwd: Viagify informa sobre a sua reserva 122323624",
            "priority": "P3",
            "created_at": "27/11/2025 19:21:38",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 19:21:40"
          },
          {
            "ticket_id": 3451,
            "ticket_number": "353444",
            "title": "GBN-85819 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/11/2025 12:16:50",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 16:02:58"
          },
          {
            "ticket_id": 3459,
            "ticket_number": "353452",
            "title": "Fwd: Viagify informa sobre a sua reserva 122351384",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 13:29:09",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 13:29:06"
          },
          {
            "ticket_id": 3498,
            "ticket_number": "353491",
            "title": "Fwd: Viagify informa sobre a sua reserva 122366121",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 19:15:00",
            "close_date": "2025-12-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 19:15:01"
          },
          {
            "ticket_id": 3512,
            "ticket_number": "353505",
            "title": "asunto",
            "priority": "P2",
            "created_at": "29/11/2025 10:18:32",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 12:58:10"
          },
          {
            "ticket_id": 3513,
            "ticket_number": "353506",
            "title": "PEDIDO DE ORÇAMENTO 9 ADULTOS 1 CRIANÇA ( 5 ANOS )",
            "priority": "P3",
            "created_at": "29/11/2025 10:18:34",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 10:18:34"
          },
          {
            "ticket_id": 3516,
            "ticket_number": "353509",
            "title": "asunto",
            "priority": "P2",
            "created_at": "29/11/2025 10:18:53",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 12:57:58"
          },
          {
            "ticket_id": 3526,
            "ticket_number": "353519",
            "title": "GBN-85933 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/11/2025 12:39:03",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 10:19:03"
          },
          {
            "ticket_id": 3529,
            "ticket_number": "353522",
            "title": "Pedido de informação | Voo de Regresso - 402834",
            "priority": "P2",
            "created_at": "29/11/2025 14:34:50",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/11/2025 14:34:50"
          },
          {
            "ticket_id": 3565,
            "ticket_number": "353558",
            "title": "localizador: 191DL2A5AP  Veturis",
            "priority": "P2",
            "created_at": "30/11/2025 15:09:37",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 15:09:38"
          },
          {
            "ticket_id": 3597,
            "ticket_number": "353590",
            "title": "Fwd: Envio de Orçamento",
            "priority": "P2",
            "created_at": "01/12/2025 12:05:18",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 12:05:18"
          },
          {
            "ticket_id": 3613,
            "ticket_number": "353606",
            "title": "reserva tui 10045715",
            "priority": "P2",
            "created_at": "01/12/2025 16:44:30",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 16:44:30"
          },
          {
            "ticket_id": 3687,
            "ticket_number": "353679",
            "title": "1ª VIA - Confirmação de Reserva n. 10045715 - UMA ",
            "priority": "P2",
            "created_at": "02/12/2025 14:27:01",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:03:12"
          },
          {
            "ticket_id": 3688,
            "ticket_number": "353680",
            "title": "Pedido cotação | Fim de semana Alojamento Portugal",
            "priority": "P3",
            "created_at": "02/12/2025 14:27:03",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 14:27:03"
          },
          {
            "ticket_id": 3692,
            "ticket_number": "353684",
            "title": "Envio de Documentação Disney File 415790",
            "priority": "P2",
            "created_at": "02/12/2025 14:27:18",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:30:13"
          },
          {
            "ticket_id": 3693,
            "ticket_number": "353685",
            "title": "Acrescimo malas operador CN Travel",
            "priority": "P2",
            "created_at": "02/12/2025 14:27:44",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:27:45"
          },
          {
            "ticket_id": 3704,
            "ticket_number": "353696",
            "title": "Envio de Documentação * File 408831",
            "priority": "P2",
            "created_at": "02/12/2025 17:10:30",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:14:30"
          },
          {
            "ticket_id": 3790,
            "ticket_number": "353782",
            "title": "Pedido de informação | Soltrópico - Nair",
            "priority": "P2",
            "created_at": "03/12/2025 15:33:41",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 15:33:42"
          },
          {
            "ticket_id": 3810,
            "ticket_number": "353802",
            "title": "Re:[## 26049 ##] GBN-85819 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "03/12/2025 17:54:24",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 18:40:07"
          },
          {
            "ticket_id": 3820,
            "ticket_number": "353812",
            "title": "Re:[## 26461 ##] GBN-79420 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/12/2025 19:57:04",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 19:57:08"
          },
          {
            "ticket_id": 3847,
            "ticket_number": "353839",
            "title": "Seguro reserva / Booking ref. 6KVF3QAMGG - Cátia",
            "priority": "P2",
            "created_at": "03/12/2025 23:42:22",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 23:42:22"
          },
          {
            "ticket_id": 3876,
            "ticket_number": "353868",
            "title": "Re:[## 26459 ##] GBN-78564 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "04/12/2025 13:41:03",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 15:31:05"
          },
          {
            "ticket_id": 3889,
            "ticket_number": "353881",
            "title": "Informação de reserva - SPT002501558547",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/12/2025 17:21:46",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 14:22:17"
          },
          {
            "ticket_id": 4116,
            "ticket_number": "354108",
            "title": "GBN-94107 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/12/2025 22:12:45",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 22:14:49"
          },
          {
            "ticket_id": 4132,
            "ticket_number": "354124",
            "title": "Confirmação de Reserva * File 421030 *TL 10/12/202",
            "priority": "P1",
            "created_at": "10/12/2025 10:28:35",
            "close_date": "2025-12-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.3,
            "sla_met": false,
            "sla_breach_hours": 8.05,
            "sla_name": "SLA P1",
            "first_response_at": "10/12/2025 18:47:13"
          },
          {
            "ticket_id": 4149,
            "ticket_number": "354141",
            "title": "Re:[## 26155 ##] GBN-91292 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/12/2025 12:07:08",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 15:27:46"
          },
          {
            "ticket_id": 4154,
            "ticket_number": "354146",
            "title": "opti",
            "priority": "P3",
            "created_at": "10/12/2025 12:37:18",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 12:37:19"
          },
          {
            "ticket_id": 4206,
            "ticket_number": "354198",
            "title": "Re:[## 27036 ##] GBN-68378 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/12/2025 22:58:01",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 20:46:10"
          },
          {
            "ticket_id": 4240,
            "ticket_number": "354232",
            "title": "Pedido de declaração",
            "priority": "P3",
            "created_at": "11/12/2025 17:43:53",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 17:43:54"
          },
          {
            "ticket_id": 4277,
            "ticket_number": "354269",
            "title": "Re:[## 26735 ##] GBN-85908 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/12/2025 11:33:45",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 23:06:19"
          },
          {
            "ticket_id": 4331,
            "ticket_number": "354323",
            "title": "Confirmação de reserva com localizador: 4004007",
            "priority": "P2",
            "created_at": "12/12/2025 22:30:18",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 22:31:10"
          }
        ]
      },
      "Paula Candeias": {
        "total_tickets": 313,
        "sla_met": 231,
        "sla_missed": 82,
        "sla_compliance_rate": 73.8,
        "tickets": [
          {
            "ticket_id": 41,
            "ticket_number": "35041",
            "title": "Re: Fwd: Fwd: Cotação excursões México outubro",
            "priority": "P2",
            "created_at": "30/09/2025 09:18:06",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 09:18:06"
          },
          {
            "ticket_id": 42,
            "ticket_number": "35042",
            "title": "Re: Fwd: Cotação excursões México outubro",
            "priority": "P2",
            "created_at": "30/09/2025 09:18:07",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 09:18:07"
          },
          {
            "ticket_id": 71,
            "ticket_number": "35070",
            "title": "Re: Pedido de cotação – Transporte 12 pessoas (11 ",
            "priority": "P2",
            "created_at": "30/09/2025 15:04:06",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 15:16:30"
          },
          {
            "ticket_id": 74,
            "ticket_number": "35073",
            "title": "Fwd: Informações sobre a sua reserva TTN-112535641",
            "priority": "P2",
            "created_at": "30/09/2025 15:27:36",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 15:27:36"
          },
          {
            "ticket_id": 79,
            "ticket_number": "35078",
            "title": "Re: GBN-78571 - Atualização dados passaporte",
            "priority": "P2",
            "created_at": "30/09/2025 16:08:14",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 16:08:14"
          },
          {
            "ticket_id": 80,
            "ticket_number": "35079",
            "title": "GBN-78571 - Atualização dados passaporte",
            "priority": "P2",
            "created_at": "30/09/2025 16:21:37",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 16:21:38"
          },
          {
            "ticket_id": 86,
            "ticket_number": "35085",
            "title": "RE: Pedido de Orçamento – Grupo de Angariação Disn",
            "priority": "P2",
            "created_at": "30/09/2025 17:17:07",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 17:21:21"
          },
          {
            "ticket_id": 91,
            "ticket_number": "35090",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "30/09/2025 20:48:55",
            "close_date": "2025-09-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 21:05:21"
          },
          {
            "ticket_id": 95,
            "ticket_number": "35094",
            "title": "Re: Fwd: Envio de Proposta - Circuito Barcelona - ",
            "priority": "P2",
            "created_at": "30/09/2025 22:07:54",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 22:07:55"
          },
          {
            "ticket_id": 121,
            "ticket_number": "35120",
            "title": "Pedido de esclarecimento",
            "priority": "P2",
            "created_at": "01/10/2025 16:55:23",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 16:55:23"
          },
          {
            "ticket_id": 130,
            "ticket_number": "35129",
            "title": "Loc.: 1206578285 - alteração de email",
            "priority": "P2",
            "created_at": "01/10/2025 21:05:07",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 21:05:08"
          },
          {
            "ticket_id": 136,
            "ticket_number": "35135",
            "title": "Pedido de cancelamento - LOC.   5WZBRAP4",
            "priority": "P2",
            "created_at": "02/10/2025 09:50:11",
            "close_date": "2025-10-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 09:50:11"
          },
          {
            "ticket_id": 168,
            "ticket_number": "35167",
            "title": "Re: Orçamento Viagem de grupo - viagem de estudo t",
            "priority": "P2",
            "created_at": "03/10/2025 09:50:18",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/09/2025 14:18:07"
          },
          {
            "ticket_id": 195,
            "ticket_number": "35194",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604299456",
            "priority": "P2",
            "created_at": "03/10/2025 17:15:29",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/10/2025 17:15:30"
          },
          {
            "ticket_id": 249,
            "ticket_number": "35248",
            "title": "Pedido de contacto à CIVITATIS – Atividade de obse",
            "priority": "P2",
            "created_at": "06/10/2025 14:38:02",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 14:38:03"
          },
          {
            "ticket_id": 259,
            "ticket_number": "35258",
            "title": "Reserva Aérea XDSLD5",
            "priority": "P1",
            "created_at": "06/10/2025 19:07:38",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 19.18,
            "sla_met": false,
            "sla_breach_hours": 18.93,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 260,
            "ticket_number": "35259",
            "title": "XDSLD5 – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "06/10/2025 19:08:43",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 19.17,
            "sla_met": false,
            "sla_breach_hours": 18.92,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 265,
            "ticket_number": "35264",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 19:09:44",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 15.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 10:33:53"
          },
          {
            "ticket_id": 268,
            "ticket_number": "35267",
            "title": "Eticket 1475511049901",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:29",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.68,
            "sla_met": false,
            "sla_breach_hours": 16.43,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 269,
            "ticket_number": "35268",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:30",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.68,
            "sla_met": false,
            "sla_breach_hours": 16.43,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 270,
            "ticket_number": "35269",
            "title": "Aéreo - Confirmação de Emissão (LOPES GOMES\\SARA) ",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:33",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.67,
            "sla_met": false,
            "sla_breach_hours": 16.42,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 271,
            "ticket_number": "35270",
            "title": "Aéreo - Confirmação de Emissão (DATCHANGUE\\CARLOS)",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:35",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.67,
            "sla_met": false,
            "sla_breach_hours": 16.42,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 272,
            "ticket_number": "35271",
            "title": "Eticket 1475511049900",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:37",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.67,
            "sla_met": false,
            "sla_breach_hours": 16.42,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 273,
            "ticket_number": "35272",
            "title": "Carregamento Carteira Digital - RI 258001675",
            "priority": "P1",
            "created_at": "06/10/2025 21:38:39",
            "close_date": "2025-10-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.67,
            "sla_met": false,
            "sla_breach_hours": 16.42,
            "sla_name": "SLA P1",
            "first_response_at": "07/10/2025 14:19:32"
          },
          {
            "ticket_id": 280,
            "ticket_number": "35279",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "06/10/2025 22:55:23",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 16.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 15:23:20"
          },
          {
            "ticket_id": 288,
            "ticket_number": "35287",
            "title": "Confirmação de reserva com localizador: 3931427",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 10:30:44",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 53.3,
            "sla_met": false,
            "sla_breach_hours": 29.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 15:48:56"
          },
          {
            "ticket_id": 301,
            "ticket_number": "35300",
            "title": "GBN-84913 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 12:20:31",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 12:20:31"
          },
          {
            "ticket_id": 313,
            "ticket_number": "35312",
            "title": "Urgência - Aluguer de carro para clientes que vão ",
            "priority": "P2",
            "created_at": "07/10/2025 14:48:47",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/10/2025 14:48:47"
          },
          {
            "ticket_id": 328,
            "ticket_number": "35327",
            "title": "Informação de reserva - SPT002501544975",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 19:27:31",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 21.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:01:15"
          },
          {
            "ticket_id": 333,
            "ticket_number": "35332",
            "title": "Confirmação de reserva – Ref PP661699, Sr. MANUEL ",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 22:10:55",
            "close_date": "2025-10-09",
            "sla_target_hours": 24,
            "actual_time_hours": 18.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:05:05"
          },
          {
            "ticket_id": 336,
            "ticket_number": "35335",
            "title": "GBN-85040 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 22:11:03",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 19.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:24:04"
          },
          {
            "ticket_id": 342,
            "ticket_number": "35341",
            "title": "Reserva confirmada: Free tour por Sevilha - Civita",
            "priority": "Reservas sem Formulário",
            "created_at": "07/10/2025 23:42:38",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/10/2025 23:42:41"
          },
          {
            "ticket_id": 347,
            "ticket_number": "35346",
            "title": "Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 09:25:17",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 31.13,
            "sla_met": false,
            "sla_breach_hours": 7.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/10/2025 16:33:46"
          },
          {
            "ticket_id": 382,
            "ticket_number": "35381",
            "title": "PNR's localizador: SPT002501544760",
            "priority": "P2",
            "created_at": "08/10/2025 14:12:07",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 14:12:07"
          },
          {
            "ticket_id": 405,
            "ticket_number": "35404",
            "title": "Reserva confirmada: Passeio de barco pelo Danúbio ",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 17:14:31",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:14:34"
          },
          {
            "ticket_id": 406,
            "ticket_number": "35405",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 17:14:32",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "08/10/2025 17:14:36"
          },
          {
            "ticket_id": 422,
            "ticket_number": "35421",
            "title": "GBN-85200 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/10/2025 21:27:58",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 118.57,
            "sla_met": false,
            "sla_breach_hours": 94.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 20:02:01"
          },
          {
            "ticket_id": 448,
            "ticket_number": "35447",
            "title": "RE: Cotação de Grupo Mercados de Natal (Isa Rezend",
            "priority": "P2",
            "created_at": "09/10/2025 14:27:47",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 14:27:47"
          },
          {
            "ticket_id": 450,
            "ticket_number": "35449",
            "title": "Informação Greve Menzies - Voos Charter SATA // 33",
            "priority": "P2",
            "created_at": "09/10/2025 14:52:36",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 15:36:44"
          },
          {
            "ticket_id": 455,
            "ticket_number": "35454",
            "title": "GBN-85284: voos Ryanair \"Pendente de ser confirmad",
            "priority": "P2",
            "created_at": "09/10/2025 17:32:46",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 17:32:46"
          },
          {
            "ticket_id": 458,
            "ticket_number": "35457",
            "title": "Pedido de Cotação viagem de grupo",
            "priority": "P2",
            "created_at": "09/10/2025 17:41:57",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 17:41:58"
          },
          {
            "ticket_id": 459,
            "ticket_number": "35458",
            "title": "ROSA PARDAL RD OUTUBRO",
            "priority": "P2",
            "created_at": "09/10/2025 18:23:26",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 18:39:11"
          },
          {
            "ticket_id": 464,
            "ticket_number": "35463",
            "title": "Cancelamento - GBN-81955",
            "priority": "P2",
            "created_at": "09/10/2025 20:04:16",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/10/2025 20:04:16"
          },
          {
            "ticket_id": 474,
            "ticket_number": "35473",
            "title": "GBN-85381 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 09:07:00",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 12.38,
            "sla_met": false,
            "sla_breach_hours": 8.38,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 21:30:35"
          },
          {
            "ticket_id": 497,
            "ticket_number": "35496",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "Reservas sem Formulário",
            "created_at": "10/10/2025 14:47:29",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 14:47:32"
          },
          {
            "ticket_id": 500,
            "ticket_number": "35499",
            "title": "Re: Cotação Cabo Verde - Ilha do Sal 2026 (Sara Az",
            "priority": "P2",
            "created_at": "10/10/2025 14:49:52",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 6.5,
            "sla_met": false,
            "sla_breach_hours": 2.5,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 21:20:37"
          },
          {
            "ticket_id": 522,
            "ticket_number": "35521",
            "title": "GBN-84892 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/10/2025 20:13:36",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/10/2025 20:48:22"
          },
          {
            "ticket_id": 523,
            "ticket_number": "35522",
            "title": "GBN-85525 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/10/2025 20:13:39",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 68.3,
            "sla_met": false,
            "sla_breach_hours": 44.3,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 16:32:35"
          },
          {
            "ticket_id": 540,
            "ticket_number": "35539",
            "title": "GBN-85654 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:06:18",
            "close_date": "2025-10-14",
            "sla_target_hours": 24,
            "actual_time_hours": 29.87,
            "sla_met": false,
            "sla_breach_hours": 5.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/10/2025 14:58:46"
          },
          {
            "ticket_id": 545,
            "ticket_number": "35544",
            "title": "localizador 1200415052",
            "priority": "P2",
            "created_at": "13/10/2025 09:06:29",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 09:06:29"
          },
          {
            "ticket_id": 547,
            "ticket_number": "35546",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:06:38",
            "close_date": "2025-10-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:06:57"
          },
          {
            "ticket_id": 557,
            "ticket_number": "35556",
            "title": "Fwd: Viagify informa sobre a sua reserva 120933976",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:10:54",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:10:55"
          },
          {
            "ticket_id": 558,
            "ticket_number": "35557",
            "title": "Fwd: Viagify informa sobre a sua reserva 120933892",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:10:57",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:10:58"
          },
          {
            "ticket_id": 562,
            "ticket_number": "35561",
            "title": "Fwd: Viagify informa sobre a sua reserva 120920990",
            "priority": "Reservas sem Formulário",
            "created_at": "13/10/2025 09:13:47",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/10/2025 09:13:44"
          },
          {
            "ticket_id": 579,
            "ticket_number": "35578",
            "title": "Agregar reservas 63316063 + 63612384",
            "priority": "P2",
            "created_at": "13/10/2025 11:46:38",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 11:46:38"
          },
          {
            "ticket_id": 591,
            "ticket_number": "35590",
            "title": "SOLICITAMOS ORÇAMENTO DE GRUPO 15+2CRIANÇAS",
            "priority": "P2",
            "created_at": "13/10/2025 13:18:07",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 13:18:07"
          },
          {
            "ticket_id": 596,
            "ticket_number": "35595",
            "title": "reserva 405743 e 405744  - DOCUMENTACAO",
            "priority": "P2",
            "created_at": "13/10/2025 15:05:36",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 15:05:36"
          },
          {
            "ticket_id": 619,
            "ticket_number": "35618",
            "title": "Reservas A34603691 e A34603694",
            "priority": "P2",
            "created_at": "13/10/2025 18:32:49",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 18:32:55"
          },
          {
            "ticket_id": 626,
            "ticket_number": "35625",
            "title": "pedido de alteraçao civitatis A34603688",
            "priority": "P2",
            "created_at": "13/10/2025 19:09:37",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 19:09:37"
          },
          {
            "ticket_id": 648,
            "ticket_number": "35647",
            "title": "GBN-85829 - Your booking confirmation",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 09:17:53",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 32.05,
            "sla_met": false,
            "sla_breach_hours": 8.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 17:21:11"
          },
          {
            "ticket_id": 667,
            "ticket_number": "35666",
            "title": "GBN-85872 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 12:40:34",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 28.68,
            "sla_met": false,
            "sla_breach_hours": 4.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 17:22:23"
          },
          {
            "ticket_id": 670,
            "ticket_number": "35669",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 12:49:44",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 26.3,
            "sla_met": false,
            "sla_breach_hours": 2.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 15:08:11"
          },
          {
            "ticket_id": 677,
            "ticket_number": "35676",
            "title": "GBN-85883 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 14:18:54",
            "close_date": "2025-10-15",
            "sla_target_hours": 24,
            "actual_time_hours": 24.93,
            "sla_met": false,
            "sla_breach_hours": 0.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 15:15:18"
          },
          {
            "ticket_id": 690,
            "ticket_number": "35689",
            "title": "GBN-85933 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "14/10/2025 16:55:15",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 24.47,
            "sla_met": false,
            "sla_breach_hours": 0.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 17:24:02"
          },
          {
            "ticket_id": 694,
            "ticket_number": "35693",
            "title": "Confirmação de reserva – Ref PP621324, Sr. Pedro P",
            "priority": "P2",
            "created_at": "14/10/2025 16:58:10",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 17:39:38"
          },
          {
            "ticket_id": 703,
            "ticket_number": "35702",
            "title": "Viagem de angariação Cabo Verde",
            "priority": "P2",
            "created_at": "14/10/2025 18:51:58",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 18:51:59"
          },
          {
            "ticket_id": 705,
            "ticket_number": "35704",
            "title": "Cabo Verde - Hotel Belorizonte",
            "priority": "P2",
            "created_at": "14/10/2025 19:05:52",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 15.12,
            "sla_met": false,
            "sla_breach_hours": 11.12,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 10:13:38"
          },
          {
            "ticket_id": 716,
            "ticket_number": "35715",
            "title": "Reserva GBN-85829 & GBN-85883",
            "priority": "P2",
            "created_at": "15/10/2025 09:10:18",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 09:10:18"
          },
          {
            "ticket_id": 723,
            "ticket_number": "35722",
            "title": "Orçamento 19521/25/27/45657 Rui Simões_Brasil",
            "priority": "P2",
            "created_at": "15/10/2025 10:13:28",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 5.8,
            "sla_met": false,
            "sla_breach_hours": 1.8,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 16:02:21"
          },
          {
            "ticket_id": 739,
            "ticket_number": "35738",
            "title": "Confirmação de reserva para For PT004157 63517580",
            "priority": "P2",
            "created_at": "15/10/2025 12:12:46",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 12:38:17"
          },
          {
            "ticket_id": 744,
            "ticket_number": "35743",
            "title": "PNR´s do localizador: SPT002501544719",
            "priority": "P2",
            "created_at": "15/10/2025 13:10:11",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 13:10:11"
          },
          {
            "ticket_id": 756,
            "ticket_number": "35755",
            "title": "XDSLD5 – Alteração de Horário – Aceite",
            "priority": "P2",
            "created_at": "15/10/2025 15:56:42",
            "close_date": "2025-10-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 17:34:12"
          },
          {
            "ticket_id": 790,
            "ticket_number": "35789",
            "title": "Criação de processo File 413248/25",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 21:47:58",
            "close_date": "2025-10-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:25:10"
          },
          {
            "ticket_id": 792,
            "ticket_number": "35791",
            "title": "Reserva confirmada: Cruzeiro noturno com jantar e ",
            "priority": "Reservas sem Formulário",
            "created_at": "15/10/2025 22:24:04",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/10/2025 22:24:05"
          },
          {
            "ticket_id": 821,
            "ticket_number": "35820",
            "title": "Fwd: Viagify informa sobre a sua reserva 121065840",
            "priority": "P3",
            "created_at": "16/10/2025 15:06:18",
            "close_date": "2025-10-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/10/2025 15:06:18"
          },
          {
            "ticket_id": 832,
            "ticket_number": "35831",
            "title": "Reserva 332434 WL",
            "priority": "P2",
            "created_at": "16/10/2025 16:58:09",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 25.22,
            "sla_met": false,
            "sla_breach_hours": 21.22,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 18:11:46"
          },
          {
            "ticket_id": 836,
            "ticket_number": "35835",
            "title": "YYP7N6 – Novo prazo de emissão",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 18:18:08",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "16/10/2025 18:18:10"
          },
          {
            "ticket_id": 845,
            "ticket_number": "35844",
            "title": "GBN-86352 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "16/10/2025 19:57:21",
            "close_date": "2025-10-21",
            "sla_target_hours": 24,
            "actual_time_hours": 26.8,
            "sla_met": false,
            "sla_breach_hours": 2.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "17/10/2025 22:45:51"
          },
          {
            "ticket_id": 849,
            "ticket_number": "35848",
            "title": "RESERVA LOCALIZADOR 604477832",
            "priority": "P2",
            "created_at": "16/10/2025 21:59:12",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/10/2025 23:05:46"
          },
          {
            "ticket_id": 865,
            "ticket_number": "35864",
            "title": "Mensagem sobre a reserva 34659217 - Civitatis",
            "priority": "P2",
            "created_at": "17/10/2025 14:24:11",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 15:49:45"
          },
          {
            "ticket_id": 874,
            "ticket_number": "35873",
            "title": "RV: easyJet booking reference: KBF2SVQ",
            "priority": "P2",
            "created_at": "17/10/2025 14:26:04",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 17:04:16"
          },
          {
            "ticket_id": 875,
            "ticket_number": "35874",
            "title": "reserva smy",
            "priority": "P2",
            "created_at": "17/10/2025 14:26:07",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 15:00:40"
          },
          {
            "ticket_id": 876,
            "ticket_number": "35875",
            "title": "newblue loc 6114820",
            "priority": "P2",
            "created_at": "17/10/2025 14:26:08",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 16:34:49"
          },
          {
            "ticket_id": 879,
            "ticket_number": "35878",
            "title": "File 407385",
            "priority": "P2",
            "created_at": "17/10/2025 15:17:03",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 16:54:52"
          },
          {
            "ticket_id": 886,
            "ticket_number": "35885",
            "title": "pedido para grupo familia - Djerba",
            "priority": "P2",
            "created_at": "17/10/2025 18:37:52",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 18:37:52"
          },
          {
            "ticket_id": 888,
            "ticket_number": "35887",
            "title": "pedido cotação El horno Albergue Manzanos",
            "priority": "P2",
            "created_at": "17/10/2025 20:19:01",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 20:19:01"
          },
          {
            "ticket_id": 892,
            "ticket_number": "35891",
            "title": "Confirmacao 332519",
            "priority": "Reservas sem Formulário",
            "created_at": "17/10/2025 20:41:33",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 94.0,
            "sla_met": false,
            "sla_breach_hours": 70.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/10/2025 18:41:51"
          },
          {
            "ticket_id": 894,
            "ticket_number": "35893",
            "title": "loc 331198 e loc 326340",
            "priority": "P2",
            "created_at": "17/10/2025 21:35:45",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 22:21:23"
          },
          {
            "ticket_id": 895,
            "ticket_number": "35894",
            "title": "Código Odisseias",
            "priority": "P2",
            "created_at": "17/10/2025 22:23:13",
            "close_date": "2025-10-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/10/2025 22:23:14"
          },
          {
            "ticket_id": 899,
            "ticket_number": "35898",
            "title": "Número de informação da reserva: 6119684",
            "priority": "Reservas sem Formulário",
            "created_at": "19/10/2025 09:51:26",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 85.83,
            "sla_met": false,
            "sla_breach_hours": 61.83,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 23:41:30"
          },
          {
            "ticket_id": 926,
            "ticket_number": "35925",
            "title": "Pedido de cotação Saona - Urgente",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:26",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:26"
          },
          {
            "ticket_id": 927,
            "ticket_number": "35926",
            "title": "Valor das taxas da Norwegian Cruises /SMY",
            "priority": "Reservas sem Formulário",
            "created_at": "20/10/2025 09:21:27",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/10/2025 09:21:27"
          },
          {
            "ticket_id": 937,
            "ticket_number": "35936",
            "title": "Re: Pedido de Cotação | 17 pessoas - Tunísia",
            "priority": "P2",
            "created_at": "20/10/2025 10:09:05",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 8.97,
            "sla_met": false,
            "sla_breach_hours": 4.97,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 19:07:56"
          },
          {
            "ticket_id": 956,
            "ticket_number": "35955",
            "title": "Pedido de alteração ou cancelamento – Reserva GBN-",
            "priority": "P2",
            "created_at": "20/10/2025 15:51:05",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 15:51:05"
          },
          {
            "ticket_id": 975,
            "ticket_number": "35974",
            "title": "pedido de cotação para o hotel ledger plaza bangui",
            "priority": "P2",
            "created_at": "20/10/2025 20:22:15",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 20:22:15"
          },
          {
            "ticket_id": 978,
            "ticket_number": "35977",
            "title": "| Urgente - dúvida nova reserva - GBN-86805 |",
            "priority": "P2",
            "created_at": "20/10/2025 20:26:08",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 20:22:22"
          },
          {
            "ticket_id": 1015,
            "ticket_number": "351014",
            "title": "Localizador QFSHT5WR",
            "priority": "P2",
            "created_at": "21/10/2025 12:28:18",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 12:28:18"
          },
          {
            "ticket_id": 1021,
            "ticket_number": "351020",
            "title": "Noite de Passagem de Ano - DoubleTree by Hilton Is",
            "priority": "P2",
            "created_at": "21/10/2025 12:43:58",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 12:43:58"
          },
          {
            "ticket_id": 1063,
            "ticket_number": "351061",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:21",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 29.38,
            "sla_met": false,
            "sla_breach_hours": 5.38,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:29:53"
          },
          {
            "ticket_id": 1065,
            "ticket_number": "351063",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604480449",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 09:06:24",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 10:29:14"
          },
          {
            "ticket_id": 1066,
            "ticket_number": "351064",
            "title": "REMINDER: Dados de Passaporte - nosso File 408716",
            "priority": "P2",
            "created_at": "22/10/2025 09:08:01",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 10:58:45"
          },
          {
            "ticket_id": 1067,
            "ticket_number": "351065",
            "title": "GBN-85654 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/10/2025 09:08:02",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 12:15:17"
          },
          {
            "ticket_id": 1083,
            "ticket_number": "351081",
            "title": "Fwd: Viagify informa sobre a sua reserva 121058464",
            "priority": "P2",
            "created_at": "22/10/2025 12:15:22",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 12:15:23"
          },
          {
            "ticket_id": 1085,
            "ticket_number": "351083",
            "title": "GBN-87057 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 12:32:32",
            "close_date": "2025-10-25",
            "sla_target_hours": 24,
            "actual_time_hours": 26.05,
            "sla_met": false,
            "sla_breach_hours": 2.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:35:41"
          },
          {
            "ticket_id": 1104,
            "ticket_number": "351102",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 17:30:29",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 21.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:59:20"
          },
          {
            "ticket_id": 1115,
            "ticket_number": "351113",
            "title": "Reserva Rimain Tours Localizador 3796558515 - Andr",
            "priority": "P2",
            "created_at": "22/10/2025 20:04:31",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 20:04:31"
          },
          {
            "ticket_id": 1116,
            "ticket_number": "351114",
            "title": "GBN-87157 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:04:33",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 18.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/10/2025 14:54:17"
          },
          {
            "ticket_id": 1122,
            "ticket_number": "351120",
            "title": "Reserva confirmada: Free tour por Florença - Civit",
            "priority": "Reservas sem Formulário",
            "created_at": "22/10/2025 20:55:13",
            "close_date": "2025-10-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/10/2025 20:55:15"
          },
          {
            "ticket_id": 1156,
            "ticket_number": "351154",
            "title": "Confirmação de reserva com localizador: 3950541",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 14:47:38",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 102.1,
            "sla_met": false,
            "sla_breach_hours": 78.1,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 20:54:03"
          },
          {
            "ticket_id": 1157,
            "ticket_number": "351155",
            "title": "Confirmação de reserva 332773 ####### TIME LIMIT P",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 14:48:11",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 43.98,
            "sla_met": false,
            "sla_breach_hours": 19.98,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 10:47:16"
          },
          {
            "ticket_id": 1174,
            "ticket_number": "351172",
            "title": "Re:[## 20302 ##] GBN-75942 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "23/10/2025 19:00:19",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 14.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 09:53:04"
          },
          {
            "ticket_id": 1175,
            "ticket_number": "351173",
            "title": "GBN-87317 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 19:00:22",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 38.88,
            "sla_met": false,
            "sla_breach_hours": 14.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:53:52"
          },
          {
            "ticket_id": 1177,
            "ticket_number": "351175",
            "title": "GBN-87324 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "23/10/2025 20:51:56",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 37.97,
            "sla_met": false,
            "sla_breach_hours": 13.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 10:50:28"
          },
          {
            "ticket_id": 1193,
            "ticket_number": "351190",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604481833",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 09:03:36",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 24.87,
            "sla_met": false,
            "sla_breach_hours": 0.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 09:55:38"
          },
          {
            "ticket_id": 1207,
            "ticket_number": "351204",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 10:57:42",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 28.87,
            "sla_met": false,
            "sla_breach_hours": 4.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 15:49:45"
          },
          {
            "ticket_id": 1210,
            "ticket_number": "351207",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 10:57:47",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 28.87,
            "sla_met": false,
            "sla_breach_hours": 4.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 15:50:39"
          },
          {
            "ticket_id": 1211,
            "ticket_number": "351208",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "Reservas sem Formulário",
            "created_at": "24/10/2025 10:57:49",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 28.88,
            "sla_met": false,
            "sla_breach_hours": 4.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 15:51:12"
          },
          {
            "ticket_id": 1265,
            "ticket_number": "351262",
            "title": "Confirmação de reserva. Localizador: 7POKJUYQ33",
            "priority": "Reservas sem Formulário",
            "created_at": "25/10/2025 08:48:17",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 08:48:19"
          },
          {
            "ticket_id": 1273,
            "ticket_number": "351270",
            "title": "Reserva confirmada: Excursão à ilha Saona de catam",
            "priority": "Reservas sem Formulário",
            "created_at": "25/10/2025 10:48:12",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/10/2025 10:48:12"
          },
          {
            "ticket_id": 1276,
            "ticket_number": "351273",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "25/10/2025 14:38:18",
            "close_date": "2025-10-27",
            "sla_target_hours": 24,
            "actual_time_hours": 43.47,
            "sla_met": false,
            "sla_breach_hours": 19.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 10:06:34"
          },
          {
            "ticket_id": 1277,
            "ticket_number": "351274",
            "title": "Orçamento de grupo",
            "priority": "P2",
            "created_at": "25/10/2025 15:53:19",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/10/2025 15:53:19"
          },
          {
            "ticket_id": 1278,
            "ticket_number": "351275",
            "title": "pedido de cotação",
            "priority": "P2",
            "created_at": "25/10/2025 16:26:51",
            "close_date": "2025-10-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/10/2025 16:26:51"
          },
          {
            "ticket_id": 1283,
            "ticket_number": "351280",
            "title": "Reserva de grupo LePlan",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:11",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:11"
          },
          {
            "ticket_id": 1287,
            "ticket_number": "351284",
            "title": "Soltropico hurghada",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:19",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:19"
          },
          {
            "ticket_id": 1348,
            "ticket_number": "351345",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 17:34:27",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 50.0,
            "sla_met": false,
            "sla_breach_hours": 26.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:34:47"
          },
          {
            "ticket_id": 1349,
            "ticket_number": "351346",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 17:40:21",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 49.88,
            "sla_met": false,
            "sla_breach_hours": 25.88,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:33:51"
          },
          {
            "ticket_id": 1374,
            "ticket_number": "351371",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 21:27:26",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "27/10/2025 21:30:11"
          },
          {
            "ticket_id": 1389,
            "ticket_number": "351386",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "27/10/2025 23:41:01",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 19:27:49"
          },
          {
            "ticket_id": 1390,
            "ticket_number": "351387",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "P2",
            "created_at": "27/10/2025 23:58:07",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 00:00:47"
          },
          {
            "ticket_id": 1402,
            "ticket_number": "351399",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "28/10/2025 10:43:13",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/10/2025 10:43:13"
          },
          {
            "ticket_id": 1444,
            "ticket_number": "351441",
            "title": "Atestado multiusos - voos e Disney",
            "priority": "P2",
            "created_at": "28/10/2025 17:52:11",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:52:11"
          },
          {
            "ticket_id": 1500,
            "ticket_number": "351497",
            "title": "Pedido especial - SPT002501548337 - Soltour",
            "priority": "P2",
            "created_at": "29/10/2025 15:49:08",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 15:49:08"
          },
          {
            "ticket_id": 1510,
            "ticket_number": "351507",
            "title": "Fwd: Viagify informa sobre a sua reserva 121444365",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 17:43:12",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 17:43:12"
          },
          {
            "ticket_id": 1517,
            "ticket_number": "351514",
            "title": "| Pedido de orçamento urgente - 30 pessoas |",
            "priority": "P2",
            "created_at": "29/10/2025 19:36:32",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 19:36:33"
          },
          {
            "ticket_id": 1519,
            "ticket_number": "351516",
            "title": "GBN-65990 - Tour 10 3931518 - GBN-66418 - Cancelam",
            "priority": "P2",
            "created_at": "29/10/2025 19:41:54",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 09:10:30"
          },
          {
            "ticket_id": 1528,
            "ticket_number": "351525",
            "title": "Confirmacao 333035",
            "priority": "Reservas sem Formulário",
            "created_at": "29/10/2025 22:58:19",
            "close_date": "2025-10-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/10/2025 23:01:46"
          },
          {
            "ticket_id": 1538,
            "ticket_number": "351535",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P3",
            "created_at": "30/10/2025 10:38:36",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 10:38:37"
          },
          {
            "ticket_id": 1549,
            "ticket_number": "351546",
            "title": "Re:[## 23945 ##] GBN-66418 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "30/10/2025 12:51:54",
            "close_date": "2025-10-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 13:25:29"
          },
          {
            "ticket_id": 1553,
            "ticket_number": "351550",
            "title": "GBN-88033 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 12:52:05",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.63,
            "sla_met": false,
            "sla_breach_hours": 9.63,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 22:30:51"
          },
          {
            "ticket_id": 1567,
            "ticket_number": "351564",
            "title": "Confirmação de reserva. Localizador: 1DBANPDP14",
            "priority": "Reservas sem Formulário",
            "created_at": "30/10/2025 16:13:12",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 30.22,
            "sla_met": false,
            "sla_breach_hours": 6.22,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 22:27:11"
          },
          {
            "ticket_id": 1576,
            "ticket_number": "351573",
            "title": "Capa / modelo - Envio de cotação Pacote de Viagem",
            "priority": "P2",
            "created_at": "30/10/2025 16:53:01",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:53:01"
          },
          {
            "ticket_id": 1596,
            "ticket_number": "351593",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 00:09:43",
            "close_date": "2025-10-31",
            "sla_target_hours": 24,
            "actual_time_hours": 18.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 18:16:26"
          },
          {
            "ticket_id": 1625,
            "ticket_number": "351622",
            "title": "GBN-86003 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/10/2025 14:39:14",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 18:16:24"
          },
          {
            "ticket_id": 1633,
            "ticket_number": "351630",
            "title": "Re:[## 21086 ##] GBN-82273 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "31/10/2025 16:55:50",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 4.83,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 21:46:31"
          },
          {
            "ticket_id": 1636,
            "ticket_number": "351633",
            "title": "Confirmação de reserva – Ref PP152546, Sr. Nuno Jo",
            "priority": "Reservas sem Formulário",
            "created_at": "31/10/2025 16:55:56",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "31/10/2025 17:36:29"
          },
          {
            "ticket_id": 1651,
            "ticket_number": "351648",
            "title": "Fwd: Referência: UFEV TTN-1214486116#84983722#T153",
            "priority": "P2",
            "created_at": "31/10/2025 19:55:46",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 19:55:47"
          },
          {
            "ticket_id": 1679,
            "ticket_number": "351676",
            "title": "Re: Pedido cotação | Grupo 12 pessoas | Jamaica ou",
            "priority": "P2",
            "created_at": "02/11/2025 15:20:03",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/11/2025 15:20:03"
          },
          {
            "ticket_id": 1685,
            "ticket_number": "351682",
            "title": "GBN-88375 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "02/11/2025 17:50:06",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 70.52,
            "sla_met": false,
            "sla_breach_hours": 46.52,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:22:04"
          },
          {
            "ticket_id": 1764,
            "ticket_number": "351761",
            "title": "Re:[## 24066 ##] GBN-88144 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/11/2025 18:49:56",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 21:33:26"
          },
          {
            "ticket_id": 1813,
            "ticket_number": "351810",
            "title": "Confirmação de reserva com localizador: 3962331",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 13:32:44",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 27.05,
            "sla_met": false,
            "sla_breach_hours": 3.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:35:58"
          },
          {
            "ticket_id": 1814,
            "ticket_number": "351811",
            "title": "Orçamento de grupo para Cabo Verde",
            "priority": "P2",
            "created_at": "04/11/2025 13:38:09",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/10/2025 15:20:05"
          },
          {
            "ticket_id": 1817,
            "ticket_number": "351814",
            "title": "Re:[## 22692 ##] GBN-84892 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "04/11/2025 13:45:40",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 21:16:03"
          },
          {
            "ticket_id": 1828,
            "ticket_number": "351825",
            "title": "GBN-88704 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 17:25:44",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 23.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:38:03"
          },
          {
            "ticket_id": 1832,
            "ticket_number": "351829",
            "title": "GBN-88711 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 17:55:35",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 22.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:39:57"
          },
          {
            "ticket_id": 1842,
            "ticket_number": "351839",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "04/11/2025 21:32:07",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 19.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/11/2025 16:41:30"
          },
          {
            "ticket_id": 1889,
            "ticket_number": "351886",
            "title": "\"GBN-77161 - Your request has been received\"",
            "priority": "P2",
            "created_at": "05/11/2025 19:45:35",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 21:38:16"
          },
          {
            "ticket_id": 1900,
            "ticket_number": "351897",
            "title": "GBN-88918 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "05/11/2025 23:07:57",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 40.48,
            "sla_met": false,
            "sla_breach_hours": 16.48,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 15:37:21"
          },
          {
            "ticket_id": 1919,
            "ticket_number": "351916",
            "title": "Fwd: Viagify informa sobre a sua reserva 121654859",
            "priority": "Reservas sem Formulário",
            "created_at": "06/11/2025 10:23:35",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 10:23:36"
          },
          {
            "ticket_id": 1936,
            "ticket_number": "351933",
            "title": "Dúvidas Magical Shuttle",
            "priority": "P2",
            "created_at": "06/11/2025 12:50:29",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 12:50:29"
          },
          {
            "ticket_id": 1939,
            "ticket_number": "351936",
            "title": "RE: Envio de comprovativo de pagamento de reserva ",
            "priority": "P2",
            "created_at": "06/11/2025 13:37:34",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 15:42:54"
          },
          {
            "ticket_id": 1952,
            "ticket_number": "351948",
            "title": "ORÇAMENTO 6105066 // SAFARI EXPRESS & ZANZIBAR ",
            "priority": "P2",
            "created_at": "06/11/2025 18:07:24",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:10:08"
          },
          {
            "ticket_id": 1953,
            "ticket_number": "351949",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "06/11/2025 18:10:41",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/11/2025 18:43:27"
          },
          {
            "ticket_id": 1960,
            "ticket_number": "351956",
            "title": "Alteração de Horário - File 333002",
            "priority": "P2",
            "created_at": "06/11/2025 18:19:01",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:31:26"
          },
          {
            "ticket_id": 1962,
            "ticket_number": "351958",
            "title": "Fwd: Documentação da reserva TTN-1125356410#644522",
            "priority": "P2",
            "created_at": "06/11/2025 18:42:54",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:42:54"
          },
          {
            "ticket_id": 2021,
            "ticket_number": "352017",
            "title": "Reserva confirmada: Free tour por Barcelona - Civi",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 19:12:22",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 19:12:22"
          },
          {
            "ticket_id": 2024,
            "ticket_number": "352020",
            "title": "Reserva confirmada: Free tour de Gaudí e pela Barc",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 19:12:34",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 19:12:34"
          },
          {
            "ticket_id": 2025,
            "ticket_number": "352021",
            "title": "Reserva confirmada: Free tour pelo Parque Güell - ",
            "priority": "Reservas sem Formulário",
            "created_at": "07/11/2025 19:12:38",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "07/11/2025 19:12:38"
          },
          {
            "ticket_id": 2029,
            "ticket_number": "352025",
            "title": "GBN-85713 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/11/2025 21:03:11",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 163.05,
            "sla_met": false,
            "sla_breach_hours": 159.05,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 16:06:13"
          },
          {
            "ticket_id": 2032,
            "ticket_number": "352028",
            "title": "GBN-89221 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "08/11/2025 00:06:59",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 63.9,
            "sla_met": false,
            "sla_breach_hours": 39.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:01:30"
          },
          {
            "ticket_id": 2037,
            "ticket_number": "352033",
            "title": "Solicitação de confirmação e envio de valores de c",
            "priority": "P2",
            "created_at": "08/11/2025 11:51:57",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 11:51:57"
          },
          {
            "ticket_id": 2052,
            "ticket_number": "352048",
            "title": "GBN-78675 - Sua reserva está pendente de pagamento",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 11:48:55",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 28.25,
            "sla_met": false,
            "sla_breach_hours": 4.25,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:03:55"
          },
          {
            "ticket_id": 2060,
            "ticket_number": "352056",
            "title": "GBN-89290 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 15:43:30",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 24.43,
            "sla_met": false,
            "sla_breach_hours": 0.43,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:10:07"
          },
          {
            "ticket_id": 2065,
            "ticket_number": "352061",
            "title": "GBN-89293   - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:04:46",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 23.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:18:52"
          },
          {
            "ticket_id": 2070,
            "ticket_number": "352066",
            "title": "Fwd: Viagify informa sobre a sua reserva 121744955",
            "priority": "Reservas sem Formulário",
            "created_at": "09/11/2025 17:58:47",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/11/2025 17:58:48"
          },
          {
            "ticket_id": 2129,
            "ticket_number": "352125",
            "title": "Informações importantes sobre a sua reserva 611812",
            "priority": "P2",
            "created_at": "10/11/2025 15:06:24",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 15:37:37"
          },
          {
            "ticket_id": 2156,
            "ticket_number": "352152",
            "title": "Fwd: Orçamento",
            "priority": "P2",
            "created_at": "10/11/2025 19:48:00",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 19:48:01"
          },
          {
            "ticket_id": 2160,
            "ticket_number": "352156",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604489871",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 21:08:14",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 45.8,
            "sla_met": false,
            "sla_breach_hours": 21.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 18:57:04"
          },
          {
            "ticket_id": 2167,
            "ticket_number": "352163",
            "title": "Criação de processo File 415573/25",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 23:59:57",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 43.0,
            "sla_met": false,
            "sla_breach_hours": 19.0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/11/2025 19:00:47"
          },
          {
            "ticket_id": 2238,
            "ticket_number": "352234",
            "title": "Fwd: Excursões Samaná / Punta Cana",
            "priority": "P2",
            "created_at": "11/11/2025 22:28:46",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 23:27:50"
          },
          {
            "ticket_id": 2239,
            "ticket_number": "352235",
            "title": "Fwd: Pacote Cuba - Varadero",
            "priority": "P2",
            "created_at": "11/11/2025 22:34:20",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 22:35:35"
          },
          {
            "ticket_id": 2297,
            "ticket_number": "352293",
            "title": "Reserva WL FILE 333347",
            "priority": "P2",
            "created_at": "12/11/2025 16:13:31",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 12:55:35"
          },
          {
            "ticket_id": 2339,
            "ticket_number": "352334",
            "title": "Comissões 2025",
            "priority": "P3",
            "created_at": "13/11/2025 10:14:05",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:14:05"
          },
          {
            "ticket_id": 2364,
            "ticket_number": "352359",
            "title": "Esclarecimento Orçamento Zanzibar+Safari",
            "priority": "P2",
            "created_at": "13/11/2025 11:57:54",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 11:57:54"
          },
          {
            "ticket_id": 2399,
            "ticket_number": "352394",
            "title": "Fwd: Viagify informa sobre a sua reserva 121866644",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:24:52",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 16:24:52"
          },
          {
            "ticket_id": 2404,
            "ticket_number": "352399",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604424917",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 16:35:05",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 148.68,
            "sla_met": false,
            "sla_breach_hours": 124.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:16:32"
          },
          {
            "ticket_id": 2414,
            "ticket_number": "352409",
            "title": "Reserva loc 27FQX4T3WG - URGENTE",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 18:08:21",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 4.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/11/2025 22:22:14"
          },
          {
            "ticket_id": 2416,
            "ticket_number": "352411",
            "title": "Orçamento combinado Cuba",
            "priority": "P2",
            "created_at": "13/11/2025 18:40:04",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 18:40:04"
          },
          {
            "ticket_id": 2426,
            "ticket_number": "352421",
            "title": "Re:[## 24990 ##] GBN-87855 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "13/11/2025 19:00:49",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 19:00:49"
          },
          {
            "ticket_id": 2433,
            "ticket_number": "352428",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:13:47",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 146.05,
            "sla_met": false,
            "sla_breach_hours": 122.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:17:36"
          },
          {
            "ticket_id": 2436,
            "ticket_number": "352431",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "13/11/2025 19:20:30",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 145.97,
            "sla_met": false,
            "sla_breach_hours": 121.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:18:37"
          },
          {
            "ticket_id": 2488,
            "ticket_number": "352483",
            "title": "GBN-74842",
            "priority": "P2",
            "created_at": "14/11/2025 15:49:50",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 15:49:50"
          },
          {
            "ticket_id": 2489,
            "ticket_number": "352484",
            "title": "Re: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P2",
            "created_at": "14/11/2025 16:21:16",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 16:45:19"
          },
          {
            "ticket_id": 2495,
            "ticket_number": "352490",
            "title": "AÇORES_SÃO MIGUEL",
            "priority": "P2",
            "created_at": "14/11/2025 17:00:57",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 17:00:58"
          },
          {
            "ticket_id": 2499,
            "ticket_number": "352494",
            "title": "604264244_RV_ Cátia",
            "priority": "P2",
            "created_at": "14/11/2025 17:42:26",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 17:42:27"
          },
          {
            "ticket_id": 2504,
            "ticket_number": "352499",
            "title": "Pedido de acesso",
            "priority": "P2",
            "created_at": "14/11/2025 18:03:27",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:03:27"
          },
          {
            "ticket_id": 2510,
            "ticket_number": "352505",
            "title": "Leplan 604492196 - adicionar transfer",
            "priority": "P2",
            "created_at": "14/11/2025 19:36:27",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 19:36:27"
          },
          {
            "ticket_id": 2519,
            "ticket_number": "352514",
            "title": "Fwd: Viagify informa sobre a sua reserva 121903576",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 23:15:46",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 23:15:46"
          },
          {
            "ticket_id": 2520,
            "ticket_number": "352515",
            "title": "Fwd: Viagify informa sobre a sua reserva 121903361",
            "priority": "Reservas sem Formulário",
            "created_at": "14/11/2025 23:15:48",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 23:15:48"
          },
          {
            "ticket_id": 2526,
            "ticket_number": "352521",
            "title": "Confirmação de reserva com localizador: 3974823",
            "priority": "Reservas sem Formulário",
            "created_at": "15/11/2025 10:37:44",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 106.82,
            "sla_met": false,
            "sla_breach_hours": 82.82,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 21:27:31"
          },
          {
            "ticket_id": 2529,
            "ticket_number": "352524",
            "title": "fatura Recibo comissões",
            "priority": "P2",
            "created_at": "15/11/2025 11:42:26",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 11:42:26"
          },
          {
            "ticket_id": 2530,
            "ticket_number": "352525",
            "title": "Reserva confirmada: Cruzeiro pelo Tâmisa de Westmi",
            "priority": "Reservas sem Formulário",
            "created_at": "15/11/2025 12:51:47",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "15/11/2025 12:51:49"
          },
          {
            "ticket_id": 2535,
            "ticket_number": "352530",
            "title": "SOLICTAMOS ORÇAMENTO GRUPO Á SOLTRÓPICO - DJERBA(R",
            "priority": "P2",
            "created_at": "15/11/2025 15:47:02",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 15:47:02"
          },
          {
            "ticket_id": 2553,
            "ticket_number": "352548",
            "title": "\"GBN-77919 - Your request has been received\"",
            "priority": "P2",
            "created_at": "16/11/2025 12:27:27",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 124.08,
            "sla_met": false,
            "sla_breach_hours": 120.08,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 16:32:43"
          },
          {
            "ticket_id": 2558,
            "ticket_number": "352553",
            "title": "Confirmação de reserva. Localizador: 7DVUDRHEF1",
            "priority": "Reservas sem Formulário",
            "created_at": "16/11/2025 15:22:17",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 96.4,
            "sla_met": false,
            "sla_breach_hours": 72.4,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 15:46:46"
          },
          {
            "ticket_id": 2573,
            "ticket_number": "352568",
            "title": "Icárion - Balcãs Completo - 17/04/2026 - 6125906 -",
            "priority": "P3",
            "created_at": "17/11/2025 10:18:42",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 6.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 16:58:10"
          },
          {
            "ticket_id": 2574,
            "ticket_number": "352569",
            "title": "Icárion - Balcãs Completo - 17/04/2026 - 6125904 -",
            "priority": "P3",
            "created_at": "17/11/2025 10:18:44",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 6.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 16:57:32"
          },
          {
            "ticket_id": 2611,
            "ticket_number": "352606",
            "title": "Esclarecimento",
            "priority": "P2",
            "created_at": "17/11/2025 15:53:54",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 15:53:55"
          },
          {
            "ticket_id": 2615,
            "ticket_number": "352610",
            "title": "GBN-90314 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 16:46:01",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 43.95,
            "sla_met": false,
            "sla_breach_hours": 19.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 12:43:34"
          },
          {
            "ticket_id": 2616,
            "ticket_number": "352611",
            "title": "Envio de Documentação Entradas Disney * Fil 415573",
            "priority": "P2",
            "created_at": "17/11/2025 16:48:52",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 17:49:42"
          },
          {
            "ticket_id": 2618,
            "ticket_number": "352613",
            "title": "GBN-90406 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 17:11:42",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 26.07,
            "sla_met": false,
            "sla_breach_hours": 2.07,
            "sla_name": "SLA Padrão",
            "first_response_at": "18/11/2025 19:16:11"
          },
          {
            "ticket_id": 2630,
            "ticket_number": "352625",
            "title": "Reserva Soltropico",
            "priority": "P2",
            "created_at": "17/11/2025 18:34:39",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:34:39"
          },
          {
            "ticket_id": 2631,
            "ticket_number": "352626",
            "title": "Soltrópico -  Efetuar reserva Débora",
            "priority": "P2",
            "created_at": "17/11/2025 18:35:13",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:35:13"
          },
          {
            "ticket_id": 2654,
            "ticket_number": "352649",
            "title": "Número de informação da reserva: 6120881",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 23:15:45",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:04:20"
          },
          {
            "ticket_id": 2655,
            "ticket_number": "352650",
            "title": "Número de informação da reserva: 6120880",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 23:15:47",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:04:20"
          },
          {
            "ticket_id": 2658,
            "ticket_number": "352653",
            "title": "Número de informação da reserva: 6120878",
            "priority": "Reservas sem Formulário",
            "created_at": "17/11/2025 23:16:25",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 43.78,
            "sla_met": false,
            "sla_breach_hours": 19.78,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:04:20"
          },
          {
            "ticket_id": 2764,
            "ticket_number": "352759",
            "title": "GBN-90642 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 10:07:10",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 20:01:12"
          },
          {
            "ticket_id": 2772,
            "ticket_number": "352767",
            "title": "Reserva confirmada: Passeio de barco ao anoitecer ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:21:52",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 10:21:55"
          },
          {
            "ticket_id": 2774,
            "ticket_number": "352769",
            "title": "Reserva confirmada: Ingresso da Basílica de Santo ",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:21:58",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 10:22:01"
          },
          {
            "ticket_id": 2776,
            "ticket_number": "352771",
            "title": "Reserva confirmada: Ingresso do Balneário Szécheny",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 10:22:03",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 10:22:03"
          },
          {
            "ticket_id": 2805,
            "ticket_number": "352800",
            "title": "Reserva confirmada: Tour Bernabéu: ingresso oficia",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 15:35:49",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 11:21:57"
          },
          {
            "ticket_id": 2806,
            "ticket_number": "352801",
            "title": "Fwd: Viagify informa sobre a sua reserva 122051463",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 15:50:25",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 15:50:26"
          },
          {
            "ticket_id": 2818,
            "ticket_number": "352813",
            "title": "Fwd: Viagify informa sobre a sua reserva 122057591",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 19:01:41",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 19:01:42"
          },
          {
            "ticket_id": 2822,
            "ticket_number": "352817",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:20",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 63.13,
            "sla_met": false,
            "sla_breach_hours": 39.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 10:58:47"
          },
          {
            "ticket_id": 2825,
            "ticket_number": "352820",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "19/11/2025 19:50:50",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 63.15,
            "sla_met": false,
            "sla_breach_hours": 39.15,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 10:59:52"
          },
          {
            "ticket_id": 2833,
            "ticket_number": "352828",
            "title": "Información de reserva número: 1761445",
            "priority": "P2",
            "created_at": "19/11/2025 23:38:27",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 00:34:25"
          },
          {
            "ticket_id": 2843,
            "ticket_number": "352838",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604495210",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/11/2025 10:19:10",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 49.3,
            "sla_met": false,
            "sla_breach_hours": 25.3,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:38:00"
          },
          {
            "ticket_id": 2848,
            "ticket_number": "352843",
            "title": "Fwd: Viagify informa sobre a sua reserva 122066571",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 10:33:20",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 10:33:21"
          },
          {
            "ticket_id": 2850,
            "ticket_number": "352845",
            "title": "Fwd: Viagify informa sobre a sua reserva 122068182",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/11/2025 10:33:27",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 10:33:29"
          },
          {
            "ticket_id": 2851,
            "ticket_number": "352846",
            "title": "Fwd: Viagify informa sobre a sua reserva 122068539",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "20/11/2025 10:33:32",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/11/2025 10:33:33"
          },
          {
            "ticket_id": 2860,
            "ticket_number": "352855",
            "title": "Número de informação da reserva: 6121517",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 11:34:01",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 21:23:00"
          },
          {
            "ticket_id": 2886,
            "ticket_number": "352881",
            "title": "A34546776 - IMPORTANTE - Civitatis - Tour Bernabéu",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:42",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 6.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 22:46:20"
          },
          {
            "ticket_id": 2887,
            "ticket_number": "352882",
            "title": "A35397146 - IMPORTANTE - Civitatis - Tour Bernabéu",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:43",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 5.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 22:29:49"
          },
          {
            "ticket_id": 2888,
            "ticket_number": "352883",
            "title": "Booking modified: Tour Bernabéu: ingresso oficial ",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:46",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 5.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 22:26:00"
          },
          {
            "ticket_id": 2889,
            "ticket_number": "352884",
            "title": "Booking modified: Tour Bernabéu: ingresso oficial ",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:49",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 5.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 22:28:05"
          },
          {
            "ticket_id": 2909,
            "ticket_number": "352904",
            "title": "Zanzibar - Sonhos & Viagens (Paulo Sampaio) GBN-75",
            "priority": "P2",
            "created_at": "20/11/2025 19:40:31",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 19:40:31"
          },
          {
            "ticket_id": 2914,
            "ticket_number": "352909",
            "title": "Confirmacao 333993",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 22:49:47",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 36.47,
            "sla_met": false,
            "sla_breach_hours": 12.47,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:17:48"
          },
          {
            "ticket_id": 2916,
            "ticket_number": "352911",
            "title": "Orçamento Soltour",
            "priority": "P3",
            "created_at": "20/11/2025 23:24:38",
            "close_date": "2025-11-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 23:24:39"
          },
          {
            "ticket_id": 2917,
            "ticket_number": "352912",
            "title": "GBN-91004 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "20/11/2025 23:24:41",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 35.9,
            "sla_met": false,
            "sla_breach_hours": 11.9,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:19:21"
          },
          {
            "ticket_id": 2918,
            "ticket_number": "352913",
            "title": "Orçamento Grupo",
            "priority": "P3",
            "created_at": "20/11/2025 23:24:44",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 23:24:44"
          },
          {
            "ticket_id": 2919,
            "ticket_number": "352914",
            "title": "orçamento TUI",
            "priority": "P3",
            "created_at": "20/11/2025 23:50:58",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 13.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 13:42:07"
          },
          {
            "ticket_id": 2921,
            "ticket_number": "352916",
            "title": "Criação de processo File 416895/25",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/11/2025 00:47:02",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 18.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 19:22:21"
          },
          {
            "ticket_id": 2932,
            "ticket_number": "352927",
            "title": "Confirmacao 334066",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 11:25:50",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 12.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 23:47:16"
          },
          {
            "ticket_id": 2953,
            "ticket_number": "352948",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604496770",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 15:49:41",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 19.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/11/2025 11:24:38"
          },
          {
            "ticket_id": 2978,
            "ticket_number": "352973",
            "title": "Re:[## 25536 ##] GBN-91007 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "21/11/2025 18:18:49",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 19:01:11"
          },
          {
            "ticket_id": 2983,
            "ticket_number": "352978",
            "title": "Dúvida sobre Reserva",
            "priority": "P2",
            "created_at": "21/11/2025 18:41:11",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 18:41:12"
          },
          {
            "ticket_id": 2993,
            "ticket_number": "352988",
            "title": "GBN-82710 - pedido PNR",
            "priority": "P2",
            "created_at": "21/11/2025 20:42:14",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 20:42:14"
          },
          {
            "ticket_id": 2996,
            "ticket_number": "352991",
            "title": "Cancelamento de reservas Newblue",
            "priority": "P2",
            "created_at": "21/11/2025 21:49:24",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 21:49:24"
          },
          {
            "ticket_id": 3043,
            "ticket_number": "353038",
            "title": "Orçamento GBN",
            "priority": "P2",
            "created_at": "23/11/2025 17:33:28",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 17:33:29"
          },
          {
            "ticket_id": 3067,
            "ticket_number": "353060",
            "title": "Número de informação da reserva: 6122325",
            "priority": "P3",
            "created_at": "24/11/2025 10:07:48",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 11.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 22:04:34"
          },
          {
            "ticket_id": 3108,
            "ticket_number": "353101",
            "title": "Voos Ryaner GBN _ orçamentos ajuda",
            "priority": "P2",
            "created_at": "24/11/2025 15:44:20",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 15:44:20"
          },
          {
            "ticket_id": 3115,
            "ticket_number": "353108",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 17:13:32",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 26.65,
            "sla_met": false,
            "sla_breach_hours": 2.65,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:52:38"
          },
          {
            "ticket_id": 3124,
            "ticket_number": "353117",
            "title": "GBN-91511 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 18:56:02",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 43.8,
            "sla_met": false,
            "sla_breach_hours": 19.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/11/2025 14:44:27"
          },
          {
            "ticket_id": 3126,
            "ticket_number": "353119",
            "title": "Re: Um pedido muito importante para as vossas rese",
            "priority": "P2",
            "created_at": "24/11/2025 19:17:42",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 19:17:42"
          },
          {
            "ticket_id": 3127,
            "ticket_number": "353120",
            "title": "Pedido de cancelamento 2 reservas NewBlue",
            "priority": "P2",
            "created_at": "24/11/2025 19:22:34",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 19:22:34"
          },
          {
            "ticket_id": 3131,
            "ticket_number": "353124",
            "title": "Número de informação da reserva: 6122601",
            "priority": "Reservas sem Formulário",
            "created_at": "24/11/2025 21:57:10",
            "close_date": "2025-11-29",
            "sla_target_hours": 24,
            "actual_time_hours": 21.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 19:50:53"
          },
          {
            "ticket_id": 3136,
            "ticket_number": "353129",
            "title": "GBN-91562 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "24/11/2025 22:45:59",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 24.97,
            "sla_met": false,
            "sla_breach_hours": 0.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 23:44:23"
          },
          {
            "ticket_id": 3139,
            "ticket_number": "353132",
            "title": "Adicionar Transfer a reserva - urgente",
            "priority": "P2",
            "created_at": "24/11/2025 23:31:13",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 23:31:13"
          },
          {
            "ticket_id": 3158,
            "ticket_number": "353151",
            "title": "Criação de processo File 418054/25",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 12:25:14",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 16:17:34"
          },
          {
            "ticket_id": 3212,
            "ticket_number": "353205",
            "title": "Fwd: Viagify informa sobre a sua reserva 122244051",
            "priority": "Reservas sem Formulário",
            "created_at": "25/11/2025 21:17:31",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "25/11/2025 21:17:32"
          },
          {
            "ticket_id": 3221,
            "ticket_number": "353214",
            "title": "Referencia para pagamento | File:418054/2025",
            "priority": "P2",
            "created_at": "25/11/2025 22:44:22",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 13.02,
            "sla_met": false,
            "sla_breach_hours": 9.02,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 11:45:36"
          },
          {
            "ticket_id": 3226,
            "ticket_number": "353219",
            "title": "Re: RGPD + CPO",
            "priority": "P3",
            "created_at": "25/11/2025 23:33:48",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 23:33:48"
          },
          {
            "ticket_id": 3261,
            "ticket_number": "353254",
            "title": "Troca de data de Nascimento",
            "priority": "P2",
            "created_at": "26/11/2025 11:37:35",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 11:37:36"
          },
          {
            "ticket_id": 3289,
            "ticket_number": "353282",
            "title": "Cancelamento hoje",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:19",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:18:19"
          },
          {
            "ticket_id": 3290,
            "ticket_number": "353283",
            "title": "Re: Pedido e cotação ferias em familia",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:21",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:18:21"
          },
          {
            "ticket_id": 3293,
            "ticket_number": "353286",
            "title": "GBN-91907 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "26/11/2025 16:18:27",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/11/2025 18:10:34"
          },
          {
            "ticket_id": 3295,
            "ticket_number": "353288",
            "title": "duvida malas",
            "priority": "P2",
            "created_at": "26/11/2025 16:30:34",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:30:35"
          },
          {
            "ticket_id": 3296,
            "ticket_number": "353289",
            "title": "Pedido de esclarecimento para fecho de viagem - ur",
            "priority": "P2",
            "created_at": "26/11/2025 16:30:36",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:30:37"
          },
          {
            "ticket_id": 3311,
            "ticket_number": "353304",
            "title": "Urgente pedido de grupo",
            "priority": "P2",
            "created_at": "26/11/2025 19:05:18",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 19:05:18"
          },
          {
            "ticket_id": 3326,
            "ticket_number": "353319",
            "title": "Pedido Newblue",
            "priority": "P2",
            "created_at": "26/11/2025 21:44:15",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 21:44:15"
          },
          {
            "ticket_id": 3406,
            "ticket_number": "353399",
            "title": "Pedido de informação sobre alteração do voo de reg",
            "priority": "P2",
            "created_at": "27/11/2025 21:23:23",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 21:23:23"
          },
          {
            "ticket_id": 3436,
            "ticket_number": "353429",
            "title": "Fwd: Viagify informa sobre a sua reserva 122337328",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 10:06:27",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 10:06:27"
          },
          {
            "ticket_id": 3448,
            "ticket_number": "353441",
            "title": "Número de informação da reserva: 6123556",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 11:22:34",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 128.13,
            "sla_met": false,
            "sla_breach_hours": 104.13,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 19:31:16"
          },
          {
            "ticket_id": 3454,
            "ticket_number": "353447",
            "title": "GBN-82710 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/11/2025 13:28:53",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 17:00:09"
          },
          {
            "ticket_id": 3466,
            "ticket_number": "353459",
            "title": "Cabo Verde partida de Madrid  - GRUPOS",
            "priority": "P2",
            "created_at": "28/11/2025 13:29:51",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 17:01:17"
          },
          {
            "ticket_id": 3535,
            "ticket_number": "353528",
            "title": "Fwd: Viagify informa sobre a sua reserva 122395116",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "29/11/2025 16:49:48",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/11/2025 16:49:49"
          },
          {
            "ticket_id": 3583,
            "ticket_number": "353576",
            "title": "Número de informação da reserva: 6124339",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:41",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 76.57,
            "sla_met": false,
            "sla_breach_hours": 52.57,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:02:59"
          },
          {
            "ticket_id": 3589,
            "ticket_number": "353582",
            "title": "Confirmation of booking with locatorHNDB5JNJ",
            "priority": "Reservas sem Formulário",
            "created_at": "01/12/2025 10:35:06",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 120.28,
            "sla_met": false,
            "sla_breach_hours": 96.28,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/12/2025 10:52:53"
          },
          {
            "ticket_id": 3605,
            "ticket_number": "353598",
            "title": "GBN-92731 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 13:01:49",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "01/12/2025 13:01:56"
          },
          {
            "ticket_id": 3638,
            "ticket_number": "353631",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497276",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:17",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:22:17"
          },
          {
            "ticket_id": 3717,
            "ticket_number": "353709",
            "title": "Número de informação da reserva: 6124774",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "02/12/2025 19:34:49",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 23:23:19"
          },
          {
            "ticket_id": 3764,
            "ticket_number": "353756",
            "title": "Reserva confirmada: Excursão ao povoado de Nungwi ",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:43",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:52:09"
          },
          {
            "ticket_id": 3769,
            "ticket_number": "353761",
            "title": "Reserva confirmada: Excursão ao povoado de Nungwi ",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:55",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:52:35"
          },
          {
            "ticket_id": 3771,
            "ticket_number": "353763",
            "title": "Dúvida - SOLTROPICO 333282",
            "priority": "P2",
            "created_at": "03/12/2025 13:20:31",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:20:31"
          },
          {
            "ticket_id": 3778,
            "ticket_number": "353770",
            "title": "Informações de reserva 6118128",
            "priority": "P2",
            "created_at": "03/12/2025 13:41:05",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 17:36:46"
          },
          {
            "ticket_id": 3796,
            "ticket_number": "353788",
            "title": "Confirmación de la reserva con localizador: 399570",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 16:27:18",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 23.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:58:51"
          },
          {
            "ticket_id": 3800,
            "ticket_number": "353792",
            "title": "Alteração Nome de Reserva - Tour10 - 3995706",
            "priority": "P2",
            "created_at": "03/12/2025 16:53:12",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:53:13"
          },
          {
            "ticket_id": 3816,
            "ticket_number": "353808",
            "title": "SMY Alteração de voo (Air Canada) 1219922927",
            "priority": "P2",
            "created_at": "03/12/2025 18:47:31",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 18:47:31"
          },
          {
            "ticket_id": 3827,
            "ticket_number": "353819",
            "title": "Fwd: Viagify informa sobre a sua reserva 122527307",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 21:03:59",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "03/12/2025 21:04:00"
          },
          {
            "ticket_id": 3842,
            "ticket_number": "353834",
            "title": "GBN-93257 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 22:25:14",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 17.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 15:58:16"
          },
          {
            "ticket_id": 3845,
            "ticket_number": "353837",
            "title": "File 416895** informação adicional transfers Maldi",
            "priority": "P2",
            "created_at": "03/12/2025 23:29:44",
            "close_date": "2025-12-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 23:53:19"
          },
          {
            "ticket_id": 3864,
            "ticket_number": "353856",
            "title": "Fwd: Viagify informa sobre a sua reserva 122531252",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "04/12/2025 11:18:53",
            "close_date": "2025-12-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 11:18:53"
          },
          {
            "ticket_id": 3904,
            "ticket_number": "353896",
            "title": "Nova Reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "04/12/2025 21:23:07",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "04/12/2025 21:56:07"
          },
          {
            "ticket_id": 3906,
            "ticket_number": "353898",
            "title": "Cancelamento Reserva - Tour10 - 3995728",
            "priority": "P2",
            "created_at": "04/12/2025 21:23:12",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:23:13"
          },
          {
            "ticket_id": 3908,
            "ticket_number": "353900",
            "title": "Alteração de dados GBN-91982",
            "priority": "P2",
            "created_at": "04/12/2025 21:23:17",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:23:18"
          },
          {
            "ticket_id": 3969,
            "ticket_number": "353961",
            "title": "URGENTE URGENTE Confirmação de reserva 335435### T",
            "priority": "P2",
            "created_at": "05/12/2025 18:30:57",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 18:50:39"
          },
          {
            "ticket_id": 3975,
            "ticket_number": "353967",
            "title": "GBN-93711 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "05/12/2025 19:07:43",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 141.2,
            "sla_met": false,
            "sla_breach_hours": 117.2,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:20:41"
          },
          {
            "ticket_id": 3977,
            "ticket_number": "353969",
            "title": "Documentação Disponível - Reserva 335371",
            "priority": "P2",
            "created_at": "05/12/2025 19:22:21",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 21:04:21"
          },
          {
            "ticket_id": 3996,
            "ticket_number": "353988",
            "title": "Alteração da viagem GBN 86299 devido à greve geral",
            "priority": "P2",
            "created_at": "06/12/2025 13:03:54",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 13:03:55"
          },
          {
            "ticket_id": 4000,
            "ticket_number": "353992",
            "title": "Alteração voo GBN-91982",
            "priority": "P2",
            "created_at": "06/12/2025 13:59:56",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 13:59:57"
          },
          {
            "ticket_id": 4003,
            "ticket_number": "353995",
            "title": "reserva 6124774",
            "priority": "P2",
            "created_at": "06/12/2025 14:14:03",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 14:14:04"
          },
          {
            "ticket_id": 4010,
            "ticket_number": "354002",
            "title": "Pedido de orçamento de grupo",
            "priority": "P2",
            "created_at": "06/12/2025 17:15:18",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 17:15:18"
          },
          {
            "ticket_id": 4023,
            "ticket_number": "354015",
            "title": "GBN-93840 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "07/12/2025 12:34:19",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 72.8,
            "sla_met": false,
            "sla_breach_hours": 48.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 13:22:26"
          },
          {
            "ticket_id": 4031,
            "ticket_number": "354023",
            "title": "Número de informação da reserva: 6125043",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "08/12/2025 10:10:08",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 78.05,
            "sla_met": false,
            "sla_breach_hours": 54.05,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 16:13:43"
          },
          {
            "ticket_id": 4076,
            "ticket_number": "354068",
            "title": "Fwd: Confirmação de reserva: a sua viajem para Par",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 12:47:42",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 12:47:43"
          },
          {
            "ticket_id": 4082,
            "ticket_number": "354074",
            "title": "Fwd: Confirmação de reserva: a sua viajem para Par",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 13:33:48",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "09/12/2025 13:33:48"
          },
          {
            "ticket_id": 4093,
            "ticket_number": "354085",
            "title": "Fwd: 1219922927 TTN-1219922927#87811299#T16184001¬",
            "priority": "P2",
            "created_at": "09/12/2025 16:30:51",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 16:30:52"
          },
          {
            "ticket_id": 4113,
            "ticket_number": "354105",
            "title": "Informação sobre Comissão Catai",
            "priority": "P2",
            "created_at": "09/12/2025 21:00:08",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 21:00:09"
          },
          {
            "ticket_id": 4134,
            "ticket_number": "354126",
            "title": "Confirmacao 335503",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "10/12/2025 10:28:39",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/12/2025 10:52:00"
          },
          {
            "ticket_id": 4174,
            "ticket_number": "354166",
            "title": "GBN-86003 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "10/12/2025 17:23:15",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 17:25:58"
          },
          {
            "ticket_id": 4186,
            "ticket_number": "354178",
            "title": "Fwd: Informações da reserva TTN-1226661686#8804753",
            "priority": "P2",
            "created_at": "10/12/2025 18:10:01",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 18:10:02"
          },
          {
            "ticket_id": 4191,
            "ticket_number": "354183",
            "title": "Reservas 88141 e SPT002501553355 - confirmação de ",
            "priority": "P2",
            "created_at": "10/12/2025 19:11:33",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 19:11:33"
          },
          {
            "ticket_id": 4231,
            "ticket_number": "354223",
            "title": "Envio de Documentação * File 421030",
            "priority": "P3",
            "created_at": "11/12/2025 15:59:36",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 5.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 21:32:35"
          },
          {
            "ticket_id": 4319,
            "ticket_number": "354311",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "12/12/2025 18:35:02",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 18:35:02"
          }
        ]
      },
      "Magali Morim": {
        "total_tickets": 2114,
        "sla_met": 1883,
        "sla_missed": 231,
        "sla_compliance_rate": 89.07,
        "tickets": [
          {
            "ticket_id": 43,
            "ticket_number": "35043",
            "title": "Cancelamento",
            "priority": "P1",
            "created_at": "30/09/2025 09:18:08",
            "close_date": "2025-10-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 28.13,
            "sla_met": false,
            "sla_breach_hours": 27.88,
            "sla_name": "SLA P1",
            "first_response_at": "01/10/2025 13:26:53"
          },
          {
            "ticket_id": 138,
            "ticket_number": "35137",
            "title": "Lucia Duarte - saída da ufev",
            "priority": "P2",
            "created_at": "02/10/2025 10:25:05",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 98.27,
            "sla_met": false,
            "sla_breach_hours": 94.27,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 12:41:35"
          },
          {
            "ticket_id": 184,
            "ticket_number": "35183",
            "title": "Reencaminhar: Lucia Duarte - saída da ufev",
            "priority": "P1",
            "created_at": "03/10/2025 16:04:06",
            "close_date": "2025-10-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/10/2025 16:19:14"
          },
          {
            "ticket_id": 233,
            "ticket_number": "35232",
            "title": "Re: Cancelamento de subscrição",
            "priority": "P1",
            "created_at": "06/10/2025 10:28:39",
            "close_date": "2025-10-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/10/2025 11:02:33"
          },
          {
            "ticket_id": 252,
            "ticket_number": "35251",
            "title": "Inclusão de colaborador",
            "priority": "P3",
            "created_at": "06/10/2025 15:28:11",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/10/2025 15:28:12"
          },
          {
            "ticket_id": 355,
            "ticket_number": "35354",
            "title": "Rescisão de subscrição",
            "priority": "P2",
            "created_at": "08/10/2025 09:51:14",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:51:14"
          },
          {
            "ticket_id": 356,
            "ticket_number": "35355",
            "title": "Cancelamento subscrição",
            "priority": "P2",
            "created_at": "08/10/2025 09:51:15",
            "close_date": "2025-10-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 09:51:15"
          },
          {
            "ticket_id": 374,
            "ticket_number": "35373",
            "title": "LISTA DE E-MAILS CONSULTORES",
            "priority": "P3",
            "created_at": "08/10/2025 11:56:48",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 11:56:49"
          },
          {
            "ticket_id": 418,
            "ticket_number": "35417",
            "title": "Minutas _Declaração consentimento e compromisso",
            "priority": "P3",
            "created_at": "08/10/2025 17:50:41",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 17:50:41"
          },
          {
            "ticket_id": 512,
            "ticket_number": "35511",
            "title": "Re: Pedido de cotação",
            "priority": "P2",
            "created_at": "10/10/2025 18:08:49",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 16.92,
            "sla_met": false,
            "sla_breach_hours": 12.92,
            "sla_name": "SLA P2",
            "first_response_at": "11/10/2025 11:03:55"
          },
          {
            "ticket_id": 532,
            "ticket_number": "35531",
            "title": "reserva 405743 e 405744",
            "priority": "P2",
            "created_at": "11/10/2025 11:07:34",
            "close_date": "2025-10-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/10/2025 11:07:34"
          },
          {
            "ticket_id": 606,
            "ticket_number": "35605",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "13/10/2025 16:56:34",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 17.73,
            "sla_met": false,
            "sla_breach_hours": 13.73,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:41:07"
          },
          {
            "ticket_id": 607,
            "ticket_number": "35606",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "13/10/2025 16:56:35",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 17.73,
            "sla_met": false,
            "sla_breach_hours": 13.73,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:40:57"
          },
          {
            "ticket_id": 608,
            "ticket_number": "35607",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "13/10/2025 16:56:36",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 17.73,
            "sla_met": false,
            "sla_breach_hours": 13.73,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:40:49"
          },
          {
            "ticket_id": 610,
            "ticket_number": "35609",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "13/10/2025 17:12:35",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 17.47,
            "sla_met": false,
            "sla_breach_hours": 13.47,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 10:40:37"
          },
          {
            "ticket_id": 688,
            "ticket_number": "35687",
            "title": "Re: Pedido de cotação",
            "priority": "P3",
            "created_at": "14/10/2025 15:43:46",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 699.57,
            "sla_met": false,
            "sla_breach_hours": 675.57,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 19:18:44"
          },
          {
            "ticket_id": 700,
            "ticket_number": "35699",
            "title": "Obrigado por estarem connosco no TNews On The Road",
            "priority": "P3",
            "created_at": "14/10/2025 18:01:02",
            "close_date": "2025-10-18",
            "sla_target_hours": 24,
            "actual_time_hours": 88.82,
            "sla_met": false,
            "sla_breach_hours": 64.82,
            "sla_name": "SLA P3",
            "first_response_at": "18/10/2025 10:50:08"
          },
          {
            "ticket_id": 722,
            "ticket_number": "35721",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "15/10/2025 09:48:13",
            "close_date": "2025-10-18",
            "sla_target_hours": 4,
            "actual_time_hours": 72.97,
            "sla_met": false,
            "sla_breach_hours": 68.97,
            "sla_name": "SLA P2",
            "first_response_at": "18/10/2025 10:46:28"
          },
          {
            "ticket_id": 750,
            "ticket_number": "35749",
            "title": "Pedido de partilha de \"CABO VERDE.mp4\"",
            "priority": "P2",
            "created_at": "15/10/2025 14:53:18",
            "close_date": "2025-10-18",
            "sla_target_hours": 4,
            "actual_time_hours": 67.87,
            "sla_met": false,
            "sla_breach_hours": 63.87,
            "sla_name": "SLA P2",
            "first_response_at": "18/10/2025 10:46:16"
          },
          {
            "ticket_id": 859,
            "ticket_number": "35858",
            "title": "Screenshot 2025-10-17 at 08.21.41",
            "priority": "P2",
            "created_at": "17/10/2025 10:22:14",
            "close_date": "2025-10-18",
            "sla_target_hours": 4,
            "actual_time_hours": 24.43,
            "sla_met": false,
            "sla_breach_hours": 20.43,
            "sla_name": "SLA P2",
            "first_response_at": "18/10/2025 10:48:14"
          },
          {
            "ticket_id": 896,
            "ticket_number": "35895",
            "title": "Pedido de cessação de contrato de prestação de ser",
            "priority": "P2",
            "created_at": "19/10/2025 09:49:13",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 53.75,
            "sla_met": false,
            "sla_breach_hours": 49.75,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 15:34:55"
          },
          {
            "ticket_id": 1230,
            "ticket_number": "351227",
            "title": "Re: Rescisão de contrato / Orlando silva",
            "priority": "P3",
            "created_at": "24/10/2025 12:58:41",
            "close_date": "2025-11-08",
            "sla_target_hours": 24,
            "actual_time_hours": 6.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 19:08:10"
          },
          {
            "ticket_id": 1578,
            "ticket_number": "351575",
            "title": "TVP 32531 - CSM - 8SEP - 100PAX",
            "priority": "P2",
            "created_at": "30/10/2025 17:26:22",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 313.87,
            "sla_met": false,
            "sla_breach_hours": 309.87,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 19:18:25"
          },
          {
            "ticket_id": 1681,
            "ticket_number": "351678",
            "title": "Olá",
            "priority": "P2",
            "created_at": "02/11/2025 16:39:34",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 94.85,
            "sla_met": false,
            "sla_breach_hours": 90.85,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 15:31:03"
          },
          {
            "ticket_id": 1682,
            "ticket_number": "351679",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "02/11/2025 16:39:36",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/11/2025 16:39:38"
          },
          {
            "ticket_id": 1826,
            "ticket_number": "351823",
            "title": "Mudança de débito direto",
            "priority": "P3",
            "created_at": "04/11/2025 16:42:08",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 16:42:08"
          },
          {
            "ticket_id": 1862,
            "ticket_number": "351859",
            "title": "Pedido de suspensão e cancelamento de assinatura m",
            "priority": "P2",
            "created_at": "05/11/2025 11:01:11",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 28.52,
            "sla_met": false,
            "sla_breach_hours": 24.52,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 15:32:16"
          },
          {
            "ticket_id": 1976,
            "ticket_number": "351972",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 10:48:59",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 6.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:43:01"
          },
          {
            "ticket_id": 1978,
            "ticket_number": "351974",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:03",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 6.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:43:07"
          },
          {
            "ticket_id": 1979,
            "ticket_number": "351975",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:04",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 6.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:43:26"
          },
          {
            "ticket_id": 1980,
            "ticket_number": "351976",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:06",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 4.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 15:20:43"
          },
          {
            "ticket_id": 1981,
            "ticket_number": "351977",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:08",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 7.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 18:39:28"
          },
          {
            "ticket_id": 1982,
            "ticket_number": "351978",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:09",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 4.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 15:20:27"
          },
          {
            "ticket_id": 1983,
            "ticket_number": "351979",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 10:49:10",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 4.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 15:20:11"
          },
          {
            "ticket_id": 1998,
            "ticket_number": "351994",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 15:38:55",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:45:01"
          },
          {
            "ticket_id": 1999,
            "ticket_number": "351995",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "07/11/2025 15:38:59",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:41:59"
          },
          {
            "ticket_id": 2000,
            "ticket_number": "351996",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 15:39:00",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:42:42"
          },
          {
            "ticket_id": 2001,
            "ticket_number": "351997",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 15:39:02",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:42:25"
          },
          {
            "ticket_id": 2003,
            "ticket_number": "351999",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "07/11/2025 15:39:07",
            "close_date": "2025-11-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/11/2025 17:41:18"
          },
          {
            "ticket_id": 2040,
            "ticket_number": "352036",
            "title": "URGENTE - Pedido de orçamento de grupo",
            "priority": "P2",
            "created_at": "08/11/2025 12:10:09",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 12:10:10"
          },
          {
            "ticket_id": 2047,
            "ticket_number": "352043",
            "title": "ATENÇÃO: ALTERAÇÃO NO ITINERÁRIO DO MSC MUSICA",
            "priority": "P2",
            "created_at": "08/11/2025 14:04:09",
            "close_date": "2025-11-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 14:34:19"
          },
          {
            "ticket_id": 2049,
            "ticket_number": "352045",
            "title": "604485940 NORTRAVEL",
            "priority": "P2",
            "created_at": "08/11/2025 16:46:51",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 16:46:51"
          },
          {
            "ticket_id": 2059,
            "ticket_number": "352055",
            "title": "GBN-68378 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/11/2025 11:54:46",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 79.43,
            "sla_met": false,
            "sla_breach_hours": 75.43,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 19:21:29"
          },
          {
            "ticket_id": 2112,
            "ticket_number": "352108",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "10/11/2025 12:16:05",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 29.57,
            "sla_met": false,
            "sla_breach_hours": 5.57,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 17:50:10"
          },
          {
            "ticket_id": 2132,
            "ticket_number": "352128",
            "title": "Cancelamento",
            "priority": "P3",
            "created_at": "10/11/2025 16:06:14",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 73.67,
            "sla_met": false,
            "sla_breach_hours": 49.67,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 17:46:21"
          },
          {
            "ticket_id": 2193,
            "ticket_number": "352189",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "11/11/2025 14:05:14",
            "close_date": "2025-11-11",
            "sla_target_hours": 24,
            "actual_time_hours": 3.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 17:49:39"
          },
          {
            "ticket_id": 2237,
            "ticket_number": "352233",
            "title": "Re: Cancelamento Subscrição UFEV",
            "priority": "P3",
            "created_at": "11/11/2025 22:23:07",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 22:23:08"
          },
          {
            "ticket_id": 2275,
            "ticket_number": "352271",
            "title": "FW: Alteração NIB",
            "priority": "P2",
            "created_at": "12/11/2025 12:44:56",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 12:44:57"
          },
          {
            "ticket_id": 2343,
            "ticket_number": "352338",
            "title": "Nadine Appointment",
            "priority": "P2",
            "created_at": "13/11/2025 10:14:13",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 7.7,
            "sla_met": false,
            "sla_breach_hours": 3.7,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 17:57:09"
          },
          {
            "ticket_id": 2375,
            "ticket_number": "352370",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "13/11/2025 13:32:47",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 17:38:13"
          },
          {
            "ticket_id": 2377,
            "ticket_number": "352372",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "13/11/2025 13:32:49",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 17:38:18"
          },
          {
            "ticket_id": 2405,
            "ticket_number": "352400",
            "title": "Pedido de Rescisão de Contrato",
            "priority": "P3",
            "created_at": "13/11/2025 16:36:42",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 16:36:42"
          },
          {
            "ticket_id": 2483,
            "ticket_number": "352478",
            "title": "Rescisão",
            "priority": "P3",
            "created_at": "14/11/2025 14:01:39",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 70.25,
            "sla_met": false,
            "sla_breach_hours": 46.25,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 12:16:41"
          },
          {
            "ticket_id": 2486,
            "ticket_number": "352481",
            "title": "IMPORTANTE - RESCISÃO",
            "priority": "P3",
            "created_at": "14/11/2025 14:01:47",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 14:01:47"
          },
          {
            "ticket_id": 2497,
            "ticket_number": "352492",
            "title": "Pedido de Rescisão de Contrato",
            "priority": "P3",
            "created_at": "14/11/2025 17:32:05",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 66.83,
            "sla_met": false,
            "sla_breach_hours": 42.83,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 12:22:52"
          },
          {
            "ticket_id": 2584,
            "ticket_number": "352579",
            "title": "Fast Track – Overbooking ou Cancelamento de Voos",
            "priority": "P3",
            "created_at": "17/11/2025 11:01:11",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 12:00:42"
          },
          {
            "ticket_id": 2653,
            "ticket_number": "352648",
            "title": "Cessação do Contrato- Adriana Moreira",
            "priority": "P3",
            "created_at": "17/11/2025 22:17:12",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 22:17:12"
          },
          {
            "ticket_id": 2678,
            "ticket_number": "352673",
            "title": "Pedido de informaçãpo",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:53"
          },
          {
            "ticket_id": 2717,
            "ticket_number": "352712",
            "title": "Re: Pedido de contratação direta",
            "priority": "P3",
            "created_at": "18/11/2025 18:15:25",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 14:00:29"
          },
          {
            "ticket_id": 2900,
            "ticket_number": "352895",
            "title": "Colaboração - Agende independente",
            "priority": "P2",
            "created_at": "20/11/2025 18:02:17",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 22:01:22"
          },
          {
            "ticket_id": 2935,
            "ticket_number": "352930",
            "title": "ÁVORIS TRAINING | Meliá Cuba by Travelplan | Obrig",
            "priority": "P2",
            "created_at": "21/11/2025 11:25:57",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 15:22:14"
          },
          {
            "ticket_id": 3014,
            "ticket_number": "353009",
            "title": "Cancelamento Subscrição",
            "priority": "P3",
            "created_at": "22/11/2025 13:12:23",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/11/2025 13:12:23"
          },
          {
            "ticket_id": 3036,
            "ticket_number": "353031",
            "title": "GBN-76203 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/11/2025 23:05:06",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 36.87,
            "sla_met": false,
            "sla_breach_hours": 32.87,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:57:43"
          },
          {
            "ticket_id": 3039,
            "ticket_number": "353034",
            "title": "Saída empresa",
            "priority": "P3",
            "created_at": "23/11/2025 13:26:15",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 46.48,
            "sla_met": false,
            "sla_breach_hours": 22.48,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 11:55:56"
          },
          {
            "ticket_id": 3109,
            "ticket_number": "353102",
            "title": "Cancelamento",
            "priority": "P3",
            "created_at": "24/11/2025 15:57:33",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 18:26:53"
          },
          {
            "ticket_id": 3111,
            "ticket_number": "353104",
            "title": "MUITO URGENTE Confirmação de reserva 334421 ### TI",
            "priority": "P1",
            "created_at": "24/11/2025 16:47:30",
            "close_date": "2025-11-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.07,
            "sla_met": false,
            "sla_breach_hours": 1.82,
            "sla_name": "SLA P1",
            "first_response_at": "24/11/2025 18:52:10"
          },
          {
            "ticket_id": 3129,
            "ticket_number": "353122",
            "title": "Suspender Subscrição",
            "priority": "P3",
            "created_at": "24/11/2025 20:13:25",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 16.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 12:29:14"
          },
          {
            "ticket_id": 3168,
            "ticket_number": "353161",
            "title": "Desligamento da empresa",
            "priority": "P3",
            "created_at": "25/11/2025 13:14:35",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:14:35"
          },
          {
            "ticket_id": 3216,
            "ticket_number": "353209",
            "title": "Alteração de IBAN",
            "priority": "P2",
            "created_at": "25/11/2025 21:40:37",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 21:40:38"
          },
          {
            "ticket_id": 3411,
            "ticket_number": "353404",
            "title": "Información de reserva número: 1763586",
            "priority": "P2",
            "created_at": "27/11/2025 22:19:12",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 112.35,
            "sla_met": false,
            "sla_breach_hours": 108.35,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:40:19"
          },
          {
            "ticket_id": 3442,
            "ticket_number": "353435",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "28/11/2025 10:07:08",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "28/11/2025 10:03:03"
          },
          {
            "ticket_id": 3561,
            "ticket_number": "353554",
            "title": "Pedido cotação Hotel - 11 quartos - Torremolinos O",
            "priority": "P2",
            "created_at": "30/11/2025 12:07:36",
            "close_date": "2025-11-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 12:07:36"
          },
          {
            "ticket_id": 3563,
            "ticket_number": "353556",
            "title": "-",
            "priority": "P2",
            "created_at": "30/11/2025 13:12:28",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 13:12:28"
          },
          {
            "ticket_id": 3570,
            "ticket_number": "353563",
            "title": "Débora Gois - 1211463270 - 8 pax",
            "priority": "P2",
            "created_at": "30/11/2025 18:32:51",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 18:32:51"
          },
          {
            "ticket_id": 3571,
            "ticket_number": "353564",
            "title": "Fwd: Nova Viagem #251100357 - Ana Figueiredo",
            "priority": "P2",
            "created_at": "30/11/2025 19:00:35",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/11/2025 19:00:36"
          },
          {
            "ticket_id": 3573,
            "ticket_number": "353566",
            "title": "Cancelamento de contrato",
            "priority": "P3",
            "created_at": "30/11/2025 21:00:18",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/11/2025 21:00:18"
          },
          {
            "ticket_id": 3587,
            "ticket_number": "353580",
            "title": "Información de reserva número: 1764401",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "01/12/2025 10:28:57",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 30.53,
            "sla_met": false,
            "sla_breach_hours": 6.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/12/2025 17:01:38"
          },
          {
            "ticket_id": 3595,
            "ticket_number": "353588",
            "title": "voucher ID 1211463270 da Smy",
            "priority": "P3",
            "created_at": "01/12/2025 11:33:16",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/12/2025 11:33:16"
          },
          {
            "ticket_id": 3607,
            "ticket_number": "353600",
            "title": "GBN-92737 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/12/2025 13:56:31",
            "close_date": "2025-12-08",
            "sla_target_hours": 4,
            "actual_time_hours": 27.12,
            "sla_met": false,
            "sla_breach_hours": 23.12,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:04:12"
          },
          {
            "ticket_id": 3611,
            "ticket_number": "353604",
            "title": "Adiantamento de pagamento reserva Smytravel  nº 12",
            "priority": "P3",
            "created_at": "01/12/2025 16:44:26",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/12/2025 16:44:26"
          },
          {
            "ticket_id": 3624,
            "ticket_number": "353617",
            "title": "Pedido de partilha de \"AVORIS VS HYATT.pdf\"",
            "priority": "P3",
            "created_at": "02/12/2025 10:21:36",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 7.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:38:37"
          },
          {
            "ticket_id": 3629,
            "ticket_number": "353622",
            "title": "Pedido de partilha de \"Apresentacao Travelplan.pdf",
            "priority": "P3",
            "created_at": "02/12/2025 10:21:47",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 7.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:38:09"
          },
          {
            "ticket_id": 3655,
            "ticket_number": "353648",
            "title": "Cancelar Parceria",
            "priority": "P3",
            "created_at": "02/12/2025 10:24:09",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 10:24:09"
          },
          {
            "ticket_id": 3694,
            "ticket_number": "353686",
            "title": "Anulação de contrato UFEV",
            "priority": "P3",
            "created_at": "02/12/2025 15:14:32",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 24.85,
            "sla_met": false,
            "sla_breach_hours": 0.85,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 16:06:15"
          },
          {
            "ticket_id": 3705,
            "ticket_number": "353697",
            "title": "-",
            "priority": "P1",
            "created_at": "02/12/2025 17:37:45",
            "close_date": "2025-12-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/12/2025 17:37:45"
          },
          {
            "ticket_id": 3724,
            "ticket_number": "353716",
            "title": "Formalização pedido: saída UEFV ",
            "priority": "P3",
            "created_at": "02/12/2025 21:27:32",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 21:27:33"
          },
          {
            "ticket_id": 3767,
            "ticket_number": "353759",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:50",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:19:50"
          },
          {
            "ticket_id": 3825,
            "ticket_number": "353817",
            "title": "Confirmação de reserva * File 420075",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "03/12/2025 20:21:35",
            "close_date": "2025-12-08",
            "sla_target_hours": 24,
            "actual_time_hours": 43.32,
            "sla_met": false,
            "sla_breach_hours": 19.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "05/12/2025 15:41:28"
          },
          {
            "ticket_id": 3892,
            "ticket_number": "353884",
            "title": "Rescisão de contrato",
            "priority": "P2",
            "created_at": "04/12/2025 18:17:39",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 18:17:39"
          },
          {
            "ticket_id": 3941,
            "ticket_number": "353933",
            "title": "Despedida",
            "priority": "P2",
            "created_at": "05/12/2025 13:18:53",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 146.92,
            "sla_met": false,
            "sla_breach_hours": 142.92,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 16:13:57"
          },
          {
            "ticket_id": 4001,
            "ticket_number": "353993",
            "title": "Fwd: Viagify informa sobre a sua reserva 122586613",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "06/12/2025 14:05:28",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/12/2025 14:05:29"
          },
          {
            "ticket_id": 4004,
            "ticket_number": "353996",
            "title": "RE: 1765140 W2MCS:013450003799",
            "priority": "P2",
            "created_at": "06/12/2025 14:18:53",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 58.13,
            "sla_met": false,
            "sla_breach_hours": 54.13,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 00:27:10"
          },
          {
            "ticket_id": 4021,
            "ticket_number": "354013",
            "title": "consultor de viagens",
            "priority": "P3",
            "created_at": "07/12/2025 10:22:19",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 72.98,
            "sla_met": false,
            "sla_breach_hours": 48.98,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 11:22:15"
          },
          {
            "ticket_id": 4024,
            "ticket_number": "354016",
            "title": "Pedido de Cancelamento da Mensalidade",
            "priority": "P3",
            "created_at": "07/12/2025 13:36:27",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/12/2025 13:36:28"
          },
          {
            "ticket_id": 4117,
            "ticket_number": "354109",
            "title": "GBN-94109 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/12/2025 22:15:34",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 22:17:56"
          },
          {
            "ticket_id": 4120,
            "ticket_number": "354112",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 22:33:30",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 25.95,
            "sla_met": false,
            "sla_breach_hours": 1.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 00:31:27"
          },
          {
            "ticket_id": 4121,
            "ticket_number": "354113",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "Reservas sem Formulário",
            "created_at": "09/12/2025 22:33:33",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 25.95,
            "sla_met": false,
            "sla_breach_hours": 1.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "11/12/2025 00:31:20"
          },
          {
            "ticket_id": 4166,
            "ticket_number": "354158",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P3",
            "created_at": "10/12/2025 15:18:25",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 9.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 00:31:14"
          },
          {
            "ticket_id": 4286,
            "ticket_number": "354278",
            "title": "MUITO URGENTE Confirmação de reserva 335601 ### TI",
            "priority": "P1",
            "created_at": "12/12/2025 12:19:14",
            "close_date": "2025-12-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.28,
            "sla_met": false,
            "sla_breach_hours": 3.03,
            "sla_name": "SLA P1",
            "first_response_at": "12/12/2025 15:36:21"
          },
          {
            "ticket_id": 4300,
            "ticket_number": "354292",
            "title": "Fwd: Informações da reserva TTN-1205948457#8807832",
            "priority": "P2",
            "created_at": "12/12/2025 14:11:32",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 14:11:33"
          },
          {
            "ticket_id": 4352,
            "ticket_number": "354344",
            "title": "pedido de orçamento Reveillon",
            "priority": "P2",
            "created_at": "13/12/2025 15:29:55",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 15:29:55"
          },
          {
            "ticket_id": 1089,
            "ticket_number": "351087",
            "title": "Pedido de Orçamento para Grupo 29 pax",
            "priority": "P2",
            "created_at": "22/10/2025 14:36:00",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 14:36:00"
          },
          {
            "ticket_id": 3349,
            "ticket_number": "353342",
            "title": "Fwd: Informações da sua reserva TTN-1222585367#868",
            "priority": "P3",
            "created_at": "27/11/2025 10:54:43",
            "close_date": "2026-05-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 10:23:48"
          },
          {
            "ticket_id": 3468,
            "ticket_number": "353461",
            "title": "Cotação para viagem de grupo Namibia",
            "priority": "P3",
            "created_at": "28/11/2025 16:13:50",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 16:13:51"
          },
          {
            "ticket_id": 3540,
            "ticket_number": "353533",
            "title": "Número de informação da reserva: 6124108",
            "priority": "P3",
            "created_at": "29/11/2025 18:43:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 99.28,
            "sla_met": false,
            "sla_breach_hours": 75.28,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 22:01:33"
          },
          {
            "ticket_id": 3633,
            "ticket_number": "353626",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604505959",
            "priority": "P3",
            "created_at": "02/12/2025 10:22:32",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 33.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 20:20:13"
          },
          {
            "ticket_id": 3785,
            "ticket_number": "353777",
            "title": "📢  INFORMAÇÃO IMPORTANTE  📢  VISTO ELETRÓNICO DE E",
            "priority": "P3",
            "created_at": "03/12/2025 14:25:57",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 843.8,
            "sla_met": false,
            "sla_breach_hours": 819.8,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 18:14:26"
          },
          {
            "ticket_id": 3958,
            "ticket_number": "353950",
            "title": "Fw: Contrato de aluguer de carro - GBN- Claudio Ma",
            "priority": "P2",
            "created_at": "05/12/2025 15:35:50",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 19:23:57"
          },
          {
            "ticket_id": 4119,
            "ticket_number": "354111",
            "title": "A reserva A31479366 foi paga e confirmada",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "09/12/2025 22:33:28",
            "close_date": "2025-12-20",
            "sla_target_hours": 24,
            "actual_time_hours": 258.72,
            "sla_met": false,
            "sla_breach_hours": 234.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "20/12/2025 17:16:40"
          },
          {
            "ticket_id": 4155,
            "ticket_number": "354147",
            "title": "Proposta Solférias  18213/2025",
            "priority": "P2",
            "created_at": "10/12/2025 12:49:44",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/11/2025 16:00:32"
          },
          {
            "ticket_id": 4335,
            "ticket_number": "354327",
            "title": "GBN-94651 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/12/2025 00:00:59",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 00:00:59"
          },
          {
            "ticket_id": 4340,
            "ticket_number": "354332",
            "title": "Perda das pastas dos documentos das viagens",
            "priority": "P2",
            "created_at": "13/12/2025 11:14:20",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 11:14:20"
          },
          {
            "ticket_id": 4353,
            "ticket_number": "354345",
            "title": "Adição de um passageiro a uma reserva já feita",
            "priority": "P2",
            "created_at": "13/12/2025 15:29:57",
            "close_date": "2025-12-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 15:29:57"
          },
          {
            "ticket_id": 4355,
            "ticket_number": "354347",
            "title": "Dúvida sobre número de camas",
            "priority": "P2",
            "created_at": "13/12/2025 17:40:57",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 17:40:58"
          },
          {
            "ticket_id": 4423,
            "ticket_number": "354415",
            "title": "Cancelamento subscrição",
            "priority": "P3",
            "created_at": "15/12/2025 13:04:56",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 13:04:57"
          },
          {
            "ticket_id": 4446,
            "ticket_number": "354438",
            "title": "Nova Confirmação de reserva 335601**Nome Corrigido",
            "priority": "P3",
            "created_at": "15/12/2025 17:19:01",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 43.75,
            "sla_met": false,
            "sla_breach_hours": 19.75,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:04:09"
          },
          {
            "ticket_id": 4460,
            "ticket_number": "354452",
            "title": "Rescisão de contrato",
            "priority": "P3",
            "created_at": "15/12/2025 19:37:48",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 19:37:48"
          },
          {
            "ticket_id": 4481,
            "ticket_number": "354473",
            "title": "Cessar vinculo",
            "priority": "P2",
            "created_at": "16/12/2025 10:17:01",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 14:02:57"
          },
          {
            "ticket_id": 4537,
            "ticket_number": "354529",
            "title": "Pedido de suspensão de inscrição em UFEV",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:31",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:11:32"
          },
          {
            "ticket_id": 4538,
            "ticket_number": "354530",
            "title": "Exclusividade UFEV",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:33",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:11:33"
          },
          {
            "ticket_id": 4549,
            "ticket_number": "354541",
            "title": "Rescicao plano",
            "priority": "P3",
            "created_at": "17/12/2025 15:26:05",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 25.68,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 17:07:28"
          },
          {
            "ticket_id": 4552,
            "ticket_number": "354544",
            "title": "Sandra Reis: Solicitud de colaboración con la agen",
            "priority": "P3",
            "created_at": "17/12/2025 15:44:00",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 18:22:53"
          },
          {
            "ticket_id": 4556,
            "ticket_number": "354548",
            "title": "GBN-94773 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "17/12/2025 16:28:51",
            "close_date": "2026-05-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:11:30"
          },
          {
            "ticket_id": 4582,
            "ticket_number": "354574",
            "title": "Revista CruisesNews nº75 - Diciembre 2025",
            "priority": "P3",
            "created_at": "18/12/2025 13:22:16",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 14:01:48"
          },
          {
            "ticket_id": 4665,
            "ticket_number": "354657",
            "title": "Pedido de informação - Adição de excursões  - Rese",
            "priority": "P2",
            "created_at": "20/12/2025 16:21:34",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/12/2025 16:21:34"
          },
          {
            "ticket_id": 4667,
            "ticket_number": "354659",
            "title": "Cancelamento reserva",
            "priority": "P2",
            "created_at": "20/12/2025 17:15:52",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/12/2025 17:15:53"
          },
          {
            "ticket_id": 4681,
            "ticket_number": "354673",
            "title": "Juntar-me como consultora",
            "priority": "P3",
            "created_at": "21/12/2025 13:31:04",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 47.75,
            "sla_met": false,
            "sla_breach_hours": 23.75,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 13:16:06"
          },
          {
            "ticket_id": 4703,
            "ticket_number": "354695",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/12/2025 10:34:54",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 10:38:18"
          },
          {
            "ticket_id": 4731,
            "ticket_number": "354723",
            "title": "RES: Novo Reforço de Pagamento - Viagem #GBN-93102",
            "priority": "P2",
            "created_at": "22/12/2025 17:40:58",
            "close_date": "2025-12-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 17:40:58"
          },
          {
            "ticket_id": 4752,
            "ticket_number": "354744",
            "title": "RE: Optigest",
            "priority": "P3",
            "created_at": "22/12/2025 20:40:01",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 20:40:02"
          },
          {
            "ticket_id": 4792,
            "ticket_number": "354784",
            "title": "Cotação grupo Ilha do Sal (Alexandra)",
            "priority": "P2",
            "created_at": "23/12/2025 17:34:31",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 17:39:49"
          },
          {
            "ticket_id": 4810,
            "ticket_number": "354802",
            "title": "Comunicação de saída ",
            "priority": "P3",
            "created_at": "24/12/2025 10:27:41",
            "close_date": "2025-12-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/12/2025 10:27:41"
          },
          {
            "ticket_id": 4837,
            "ticket_number": "354829",
            "title": "Documentação Disponível - Reserva 335601",
            "priority": "P2",
            "created_at": "26/12/2025 12:29:47",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 15:35:39"
          },
          {
            "ticket_id": 4852,
            "ticket_number": "354844",
            "title": "Rescisão de contrato - Sandra Cardoso",
            "priority": "P3",
            "created_at": "26/12/2025 15:20:04",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 15:20:04"
          },
          {
            "ticket_id": 4878,
            "ticket_number": "354870",
            "title": "GBN-96160 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/12/2025 13:57:07",
            "close_date": "2025-12-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/12/2025 14:05:55"
          },
          {
            "ticket_id": 4881,
            "ticket_number": "354873",
            "title": "cancelamento de subscrição",
            "priority": "P2",
            "created_at": "27/12/2025 17:22:39",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/12/2025 17:22:40"
          },
          {
            "ticket_id": 4882,
            "ticket_number": "354874",
            "title": "Fwd: Aluguer de viatura",
            "priority": "P2",
            "created_at": "27/12/2025 17:36:26",
            "close_date": "2025-12-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/12/2025 17:36:26"
          },
          {
            "ticket_id": 4884,
            "ticket_number": "354876",
            "title": "Re:[## 28002 ##] GBN-96160 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "28/12/2025 12:06:53",
            "close_date": "2025-12-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 12:40:36"
          },
          {
            "ticket_id": 4897,
            "ticket_number": "354889",
            "title": "GBN-89280 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/12/2025 15:10:25",
            "close_date": "2025-12-28",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 16:32:04"
          },
          {
            "ticket_id": 4899,
            "ticket_number": "354891",
            "title": "Envio de documentos de File 415420/25",
            "priority": "P2",
            "created_at": "28/12/2025 15:50:31",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 15:54:07"
          },
          {
            "ticket_id": 4903,
            "ticket_number": "354895",
            "title": "Re:[## 28022 ##] GBN-89280 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "28/12/2025 16:31:40",
            "close_date": "2025-12-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 16:40:43"
          },
          {
            "ticket_id": 4921,
            "ticket_number": "354913",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/12/2025 10:52:07",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 12:07:24"
          },
          {
            "ticket_id": 4939,
            "ticket_number": "354931",
            "title": "RE: Reserva 66056946 [SR Number: 2-26834549747]",
            "priority": "P2",
            "created_at": "29/12/2025 15:34:57",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 15:53:52"
          },
          {
            "ticket_id": 4946,
            "ticket_number": "354938",
            "title": "Re:[## 28069 ##] GBN-92737 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "29/12/2025 18:09:40",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 19:26:31"
          },
          {
            "ticket_id": 4951,
            "ticket_number": "354943",
            "title": "Retorno de Suporte de Agências - Civitatis",
            "priority": "P3",
            "created_at": "29/12/2025 19:00:24",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 17.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 12:21:21"
          },
          {
            "ticket_id": 4973,
            "ticket_number": "354965",
            "title": "Inscrição ",
            "priority": "P2",
            "created_at": "30/12/2025 13:20:24",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 4.73,
            "sla_met": false,
            "sla_breach_hours": 0.73,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 18:05:15"
          },
          {
            "ticket_id": 4987,
            "ticket_number": "354979",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "30/12/2025 18:23:32",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 143.95,
            "sla_met": false,
            "sla_breach_hours": 139.95,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 18:21:28"
          },
          {
            "ticket_id": 4988,
            "ticket_number": "354980",
            "title": "Fwd: Pedido de informações",
            "priority": "P2",
            "created_at": "30/12/2025 18:40:24",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 18:43:15"
          },
          {
            "ticket_id": 5005,
            "ticket_number": "354997",
            "title": "GBN-94651 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/12/2025 23:07:19",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 61.92,
            "sla_met": false,
            "sla_breach_hours": 57.92,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 13:02:29"
          },
          {
            "ticket_id": 5027,
            "ticket_number": "355019",
            "title": "Re:[## 28199 ##] GBN-94651 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "31/12/2025 13:47:11",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 172.67,
            "sla_met": false,
            "sla_breach_hours": 168.67,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 18:27:45"
          },
          {
            "ticket_id": 5031,
            "ticket_number": "355023",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "02/01/2026 10:38:22",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 10:38:22"
          },
          {
            "ticket_id": 5082,
            "ticket_number": "355074",
            "title": "Cessação de Funções",
            "priority": "P2",
            "created_at": "02/01/2026 23:42:41",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 66.53,
            "sla_met": false,
            "sla_breach_hours": 62.53,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 18:14:42"
          },
          {
            "ticket_id": 5116,
            "ticket_number": "355108",
            "title": "Cancelamento de Subscrição",
            "priority": "P3",
            "created_at": "04/01/2026 09:55:34",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/01/2026 09:55:34"
          },
          {
            "ticket_id": 5186,
            "ticket_number": "355178",
            "title": "Re: Bem vindaaaaa 🩷",
            "priority": "P3",
            "created_at": "05/01/2026 19:45:14",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 43.97,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 15:43:37"
          },
          {
            "ticket_id": 5228,
            "ticket_number": "355220",
            "title": "Cancelamento de contrato",
            "priority": "P3",
            "created_at": "06/01/2026 15:16:14",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 15:16:14"
          },
          {
            "ticket_id": 5312,
            "ticket_number": "355304",
            "title": "orçamento Egito",
            "priority": "P2",
            "created_at": "07/01/2026 18:31:29",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 18:31:29"
          },
          {
            "ticket_id": 5374,
            "ticket_number": "355366",
            "title": "Viagem Grupo",
            "priority": "P2",
            "created_at": "08/01/2026 10:26:12",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:26:12"
          },
          {
            "ticket_id": 5375,
            "ticket_number": "355367",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "08/01/2026 11:02:30",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 11:02:31"
          },
          {
            "ticket_id": 5385,
            "ticket_number": "355377",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604485939",
            "priority": "P2",
            "created_at": "08/01/2026 12:21:47",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:43:26"
          },
          {
            "ticket_id": 5386,
            "ticket_number": "355378",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604485939",
            "priority": "P2",
            "created_at": "08/01/2026 12:21:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:47:41"
          },
          {
            "ticket_id": 5387,
            "ticket_number": "355379",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604485940",
            "priority": "P2",
            "created_at": "08/01/2026 12:21:51",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:50:45"
          },
          {
            "ticket_id": 5388,
            "ticket_number": "355380",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604485940",
            "priority": "P2",
            "created_at": "08/01/2026 12:21:55",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:49:23"
          },
          {
            "ticket_id": 5389,
            "ticket_number": "355381",
            "title": "Assinatura Disney+ com desconto para consultores",
            "priority": "P3",
            "created_at": "08/01/2026 12:21:57",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 12:21:57"
          },
          {
            "ticket_id": 5390,
            "ticket_number": "355382",
            "title": "Re:[## 28605 ##] GBN-96691 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "08/01/2026 12:22:30",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 16:20:25"
          },
          {
            "ticket_id": 5393,
            "ticket_number": "355385",
            "title": "Re:[## 28604 ##] GBN-96081 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "08/01/2026 12:29:30",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 16:20:25"
          },
          {
            "ticket_id": 5395,
            "ticket_number": "355387",
            "title": "Codigos Disney - Leplan 604472086",
            "priority": "P2",
            "created_at": "08/01/2026 12:33:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:33:50"
          },
          {
            "ticket_id": 5436,
            "ticket_number": "355428",
            "title": "Acréscimo de mais um quarto à reserva n.º  334066 ",
            "priority": "P2",
            "created_at": "09/01/2026 10:09:25",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 10:09:25"
          },
          {
            "ticket_id": 5438,
            "ticket_number": "355430",
            "title": "Dúvida marcação viagem ",
            "priority": "P2",
            "created_at": "09/01/2026 10:11:36",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 10:11:36"
          },
          {
            "ticket_id": 5440,
            "ticket_number": "355432",
            "title": "Alteração voo GBN- 75942",
            "priority": "P2",
            "created_at": "09/01/2026 10:11:41",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 10:11:41"
          },
          {
            "ticket_id": 5458,
            "ticket_number": "355450",
            "title": "pedido de orçamento",
            "priority": "P2",
            "created_at": "09/01/2026 14:19:37",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 14:19:37"
          },
          {
            "ticket_id": 5461,
            "ticket_number": "355453",
            "title": "Cancelamento - GBN-97147",
            "priority": "P2",
            "created_at": "09/01/2026 16:17:02",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 17:28:58"
          },
          {
            "ticket_id": 5474,
            "ticket_number": "355466",
            "title": "RE: Pedido de cotação - Contratação direta (Alexan",
            "priority": "P2",
            "created_at": "09/01/2026 18:35:47",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 22:22:23"
          },
          {
            "ticket_id": 5476,
            "ticket_number": "355468",
            "title": "Re:[## 28765 ##] GBN-97147 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "09/01/2026 19:36:29",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 23:22:27"
          },
          {
            "ticket_id": 5483,
            "ticket_number": "355475",
            "title": "Fwd: Informações da reserva TTN-1233135263#8973583",
            "priority": "P2",
            "created_at": "09/01/2026 21:17:02",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 21:17:02"
          },
          {
            "ticket_id": 5484,
            "ticket_number": "355476",
            "title": "Fwd: Viagify informa sobre a sua reserva 123315009",
            "priority": "P2",
            "created_at": "09/01/2026 21:17:04",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 21:17:05"
          },
          {
            "ticket_id": 5502,
            "ticket_number": "355494",
            "title": "REMINDER: Dados de Passaporte - nosso File 422534",
            "priority": "P2",
            "created_at": "10/01/2026 11:09:40",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 4.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 15:31:29"
          },
          {
            "ticket_id": 5504,
            "ticket_number": "355496",
            "title": "Fwd: Viagify informa sobre a sua reserva 123318208",
            "priority": "P2",
            "created_at": "10/01/2026 11:09:44",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 11:09:44"
          },
          {
            "ticket_id": 5506,
            "ticket_number": "355498",
            "title": "RE: Comissões e Tarifas Aéreas",
            "priority": "P2",
            "created_at": "10/01/2026 12:55:50",
            "close_date": "2026-01-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 12:55:50"
          },
          {
            "ticket_id": 5511,
            "ticket_number": "355503",
            "title": "Viagem Brasil",
            "priority": "P2",
            "created_at": "10/01/2026 13:57:02",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 20:07:39"
          },
          {
            "ticket_id": 5522,
            "ticket_number": "355514",
            "title": "Novo pedido GBN-91958",
            "priority": "P2",
            "created_at": "10/01/2026 15:47:11",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 15:47:12"
          },
          {
            "ticket_id": 5527,
            "ticket_number": "355519",
            "title": "Orçamento 18590/26 - Cairo + Cruzeiro 4 noites - E",
            "priority": "P2",
            "created_at": "10/01/2026 16:35:33",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 16:36:01"
          },
          {
            "ticket_id": 5529,
            "ticket_number": "355521",
            "title": "Pedido Actividade",
            "priority": "P2",
            "created_at": "10/01/2026 17:49:03",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 17:49:03"
          },
          {
            "ticket_id": 5530,
            "ticket_number": "355522",
            "title": "pedido fortait",
            "priority": "P2",
            "created_at": "10/01/2026 17:49:05",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 17:49:05"
          },
          {
            "ticket_id": 5532,
            "ticket_number": "355524",
            "title": "Orçamento - Safari Quénia Clássico + Zanzibar",
            "priority": "P2",
            "created_at": "10/01/2026 18:09:01",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 18:10:04"
          },
          {
            "ticket_id": 5534,
            "ticket_number": "355526",
            "title": "Orçamento - Safari Quénia Rift Valley + Zanzibar  ",
            "priority": "P2",
            "created_at": "10/01/2026 18:20:08",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 18:20:45"
          },
          {
            "ticket_id": 5535,
            "ticket_number": "355527",
            "title": "Orçamento 18592/26 - Orçamento Santorini + Mykonos",
            "priority": "P2",
            "created_at": "10/01/2026 18:36:58",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 18:37:19"
          },
          {
            "ticket_id": 5537,
            "ticket_number": "355529",
            "title": "Orçamento - Indonésia: Bali  Istambul, Capadócia",
            "priority": "P2",
            "created_at": "10/01/2026 19:11:30",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/01/2026 19:11:46"
          },
          {
            "ticket_id": 5556,
            "ticket_number": "355548",
            "title": "Confirmacao 336458",
            "priority": "P2",
            "created_at": "12/01/2026 10:08:40",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 25.48,
            "sla_met": false,
            "sla_breach_hours": 21.48,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 11:38:16"
          },
          {
            "ticket_id": 5567,
            "ticket_number": "355559",
            "title": "Fwd: Viagify informa sobre a sua reserva 123351094",
            "priority": "P3",
            "created_at": "12/01/2026 10:12:55",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:12:56"
          },
          {
            "ticket_id": 5573,
            "ticket_number": "355565",
            "title": "GBN-97993 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "12/01/2026 10:16:18",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/01/2026 10:16:18"
          },
          {
            "ticket_id": 5575,
            "ticket_number": "355567",
            "title": "GBN-97992 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/01/2026 10:16:23",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 10:16:23"
          },
          {
            "ticket_id": 5589,
            "ticket_number": "355581",
            "title": "GBN-98046 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "12/01/2026 10:21:26",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:21:26"
          },
          {
            "ticket_id": 5592,
            "ticket_number": "355584",
            "title": "GBN-98046 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "12/01/2026 10:21:33",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 31.07,
            "sla_met": false,
            "sla_breach_hours": 7.07,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:25:52"
          },
          {
            "ticket_id": 5641,
            "ticket_number": "355633",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P3",
            "created_at": "12/01/2026 16:43:08",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 19.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 11:49:58"
          },
          {
            "ticket_id": 5672,
            "ticket_number": "355664",
            "title": "Formação Turkish / Soltropico",
            "priority": "P2",
            "created_at": "12/01/2026 21:13:33",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 39.55,
            "sla_met": false,
            "sla_breach_hours": 35.55,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 12:47:20"
          },
          {
            "ticket_id": 5720,
            "ticket_number": "355712",
            "title": "Cancelamento inscrição ",
            "priority": "P3",
            "created_at": "13/01/2026 11:05:49",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 8.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 19:13:24"
          },
          {
            "ticket_id": 5730,
            "ticket_number": "355722",
            "title": "GBN-83273 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/01/2026 12:00:23",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 6.57,
            "sla_met": false,
            "sla_breach_hours": 2.57,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:35:05"
          },
          {
            "ticket_id": 5734,
            "ticket_number": "355726",
            "title": "Envio de documentos de File 423503 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "13/01/2026 12:00:33",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 3.35,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 19:22:26"
          },
          {
            "ticket_id": 5735,
            "ticket_number": "355727",
            "title": "GBN-98330 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/01/2026 12:16:27",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 146.15,
            "sla_met": false,
            "sla_breach_hours": 142.15,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:26:05"
          },
          {
            "ticket_id": 5736,
            "ticket_number": "355728",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "Reservas sem Formulário",
            "created_at": "13/01/2026 12:16:33",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "13/01/2026 12:16:33"
          },
          {
            "ticket_id": 5737,
            "ticket_number": "355729",
            "title": "Inquiry Regarding Half Board Meal Plan – Travel Ag",
            "priority": "P2",
            "created_at": "13/01/2026 12:22:52",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 5.92,
            "sla_met": false,
            "sla_breach_hours": 1.92,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 18:18:48"
          },
          {
            "ticket_id": 5738,
            "ticket_number": "355730",
            "title": "Pedido de documentação → Viagem Solférias | Sábdo ",
            "priority": "P2",
            "created_at": "13/01/2026 12:39:12",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 12:39:13"
          },
          {
            "ticket_id": 5739,
            "ticket_number": "355731",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "P2",
            "created_at": "13/01/2026 12:56:00",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 16:41:27"
          },
          {
            "ticket_id": 5741,
            "ticket_number": "355733",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "P3",
            "created_at": "13/01/2026 12:56:03",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:41:28"
          },
          {
            "ticket_id": 5744,
            "ticket_number": "355736",
            "title": "Fwd: Pedido de informação - 604497621",
            "priority": "P2",
            "created_at": "13/01/2026 12:58:14",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 12:58:14"
          },
          {
            "ticket_id": 5762,
            "ticket_number": "355754",
            "title": "CAMPANHA SOLTRÓPICO | SoLovers | 16 a 30 JAN",
            "priority": "P3",
            "created_at": "13/01/2026 14:56:47",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 19:19:41"
          },
          {
            "ticket_id": 5781,
            "ticket_number": "355773",
            "title": "Encaminhar:FW: \"GBN-87699 - Your request has been ",
            "priority": "P3",
            "created_at": "13/01/2026 17:06:02",
            "close_date": "2026-03-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 17:23:09"
          },
          {
            "ticket_id": 5828,
            "ticket_number": "355820",
            "title": "Pedido de alteração de dados pessoais",
            "priority": "P2",
            "created_at": "13/01/2026 22:26:13",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 22:26:13"
          },
          {
            "ticket_id": 5834,
            "ticket_number": "355826",
            "title": "Fwd: NOVO NIB LOJA ESTÉTICA .pdf",
            "priority": "P2",
            "created_at": "13/01/2026 23:05:06",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:05:07"
          },
          {
            "ticket_id": 5869,
            "ticket_number": "355861",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 10:57:51",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 14:43:46"
          },
          {
            "ticket_id": 5870,
            "ticket_number": "355862",
            "title": "Document from Costa Crociere",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 10:57:53",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 14:43:46"
          },
          {
            "ticket_id": 5871,
            "ticket_number": "355863",
            "title": "Pedido de Contacto Movel - 333871 // Partida: 2026",
            "priority": "P2",
            "created_at": "14/01/2026 10:58:27",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 12:14:55"
          },
          {
            "ticket_id": 5875,
            "ticket_number": "355867",
            "title": "Reserva Solferias: 423949 / 2026",
            "priority": "P2",
            "created_at": "14/01/2026 11:21:14",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:21:15"
          },
          {
            "ticket_id": 5876,
            "ticket_number": "355868",
            "title": "pedido para mudar de email",
            "priority": "P2",
            "created_at": "14/01/2026 11:21:17",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:21:17"
          },
          {
            "ticket_id": 5880,
            "ticket_number": "355872",
            "title": "Pedido de Documentação -412548 - Solferias",
            "priority": "P2",
            "created_at": "14/01/2026 11:46:55",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:46:56"
          },
          {
            "ticket_id": 5882,
            "ticket_number": "355874",
            "title": "Fwd: Pedido de orçamento - Cabo Verde",
            "priority": "P2",
            "created_at": "14/01/2026 12:19:09",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 12:19:11"
          },
          {
            "ticket_id": 5886,
            "ticket_number": "355878",
            "title": "Documentação Disponível - Reserva 332077",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 13:42:56",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 14:01:29"
          },
          {
            "ticket_id": 5889,
            "ticket_number": "355881",
            "title": "Confirmacao 336678",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 13:43:05",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 6.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 20:33:22"
          },
          {
            "ticket_id": 5894,
            "ticket_number": "355886",
            "title": "VOUCHER DA RESERVA 604517161",
            "priority": "P2",
            "created_at": "14/01/2026 13:43:27",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 13:52:19"
          },
          {
            "ticket_id": 5899,
            "ticket_number": "355891",
            "title": "NEW CostaClick: Confirmação de UMA FAMILIA EM VIAG",
            "priority": "Reservas sem Formulário",
            "created_at": "14/01/2026 13:43:45",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/01/2026 13:43:47"
          },
          {
            "ticket_id": 6088,
            "ticket_number": "356080",
            "title": "Solicitude de anulação de subscrição",
            "priority": "P3",
            "created_at": "15/01/2026 19:50:51",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 14.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:28:37"
          },
          {
            "ticket_id": 6115,
            "ticket_number": "356107",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "15/01/2026 23:44:09",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 10.55,
            "sla_met": false,
            "sla_breach_hours": 6.55,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:17:54"
          },
          {
            "ticket_id": 6119,
            "ticket_number": "356111",
            "title": "Confirmação de reserva para For PT004157 66056946",
            "priority": "P2",
            "created_at": "15/01/2026 23:52:11",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 10.42,
            "sla_met": false,
            "sla_breach_hours": 6.42,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:18:00"
          },
          {
            "ticket_id": 6121,
            "ticket_number": "356113",
            "title": "Confirmação de reserva para For PT004157 68952807",
            "priority": "P2",
            "created_at": "15/01/2026 23:54:21",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 10.37,
            "sla_met": false,
            "sla_breach_hours": 6.37,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:17:19"
          },
          {
            "ticket_id": 6166,
            "ticket_number": "356158",
            "title": "Não conseguiu assistir ao vivo ao Webinar - Descub",
            "priority": "P3",
            "created_at": "16/01/2026 11:29:47",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 15:22:53"
          },
          {
            "ticket_id": 6179,
            "ticket_number": "356171",
            "title": "Cancelamento da subscrição - Flávio Verissimo",
            "priority": "P2",
            "created_at": "16/01/2026 12:40:31",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 73.78,
            "sla_met": false,
            "sla_breach_hours": 69.78,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:27:49"
          },
          {
            "ticket_id": 6200,
            "ticket_number": "356192",
            "title": "pedido cotação grupo",
            "priority": "P2",
            "created_at": "16/01/2026 15:07:38",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 15:07:38"
          },
          {
            "ticket_id": 6225,
            "ticket_number": "356217",
            "title": "Cancelamento do Contrato",
            "priority": "P3",
            "created_at": "16/01/2026 19:56:54",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 70.7,
            "sla_met": false,
            "sla_breach_hours": 46.7,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 18:39:03"
          },
          {
            "ticket_id": 6248,
            "ticket_number": "356240",
            "title": "Re: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P3",
            "created_at": "16/01/2026 23:30:21",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 62.22,
            "sla_met": false,
            "sla_breach_hours": 38.22,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 13:44:18"
          },
          {
            "ticket_id": 6266,
            "ticket_number": "356258",
            "title": "Número de informação da reserva: 6127129",
            "priority": "Reservas sem Formulário",
            "created_at": "17/01/2026 10:08:29",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 53.87,
            "sla_met": false,
            "sla_breach_hours": 29.87,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/01/2026 16:01:13"
          },
          {
            "ticket_id": 6272,
            "ticket_number": "356264",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "17/01/2026 10:09:23",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 10:21:49"
          },
          {
            "ticket_id": 6358,
            "ticket_number": "356350",
            "title": "Re: 🎉 Bem-vinda à Uma Família em Viagem! 🌍✨",
            "priority": "P3",
            "created_at": "18/01/2026 17:36:38",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 20.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 14:31:44"
          },
          {
            "ticket_id": 6373,
            "ticket_number": "356365",
            "title": "Informação importante sobre a tua reserva 1768993",
            "priority": "P3",
            "created_at": "19/01/2026 10:09:19",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 13:37:22"
          },
          {
            "ticket_id": 6414,
            "ticket_number": "356406",
            "title": "Re:[## 29478 ##] GBN-99609 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:41",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:59"
          },
          {
            "ticket_id": 6421,
            "ticket_number": "356413",
            "title": "RE: Localizador: 6127129 W2MCS:016110002636",
            "priority": "P2",
            "created_at": "19/01/2026 10:23:44",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:21:02"
          },
          {
            "ticket_id": 6423,
            "ticket_number": "356415",
            "title": "Cancelamento Subscrição - Bruna Ribeiro",
            "priority": "P3",
            "created_at": "19/01/2026 10:44:14",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 14:39:31"
          },
          {
            "ticket_id": 6453,
            "ticket_number": "356445",
            "title": "GBN _HOTEL erro",
            "priority": "P2",
            "created_at": "19/01/2026 14:22:46",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:22:47"
          },
          {
            "ticket_id": 6460,
            "ticket_number": "356452",
            "title": "Fwd: Informações da reserva TTN-1236979294#9046970",
            "priority": "P2",
            "created_at": "19/01/2026 15:30:38",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:30:39"
          },
          {
            "ticket_id": 6473,
            "ticket_number": "356465",
            "title": "pedido de orçamento de grupo - Benidorm",
            "priority": "P2",
            "created_at": "19/01/2026 16:51:38",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 16:51:38"
          },
          {
            "ticket_id": 6476,
            "ticket_number": "356468",
            "title": "Número de informação da reserva: 6127129",
            "priority": "P2",
            "created_at": "19/01/2026 16:51:53",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 17:12:24"
          },
          {
            "ticket_id": 6477,
            "ticket_number": "356469",
            "title": "RE: Pedido de cancelamento- 6127515 W2MCS:01574000",
            "priority": "P2",
            "created_at": "19/01/2026 16:51:55",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 413.43,
            "sla_met": false,
            "sla_breach_hours": 409.43,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 22:18:26"
          },
          {
            "ticket_id": 6498,
            "ticket_number": "356490",
            "title": "Cancelamento 3 reservas newblue",
            "priority": "P2",
            "created_at": "19/01/2026 21:19:37",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 21:19:38"
          },
          {
            "ticket_id": 6526,
            "ticket_number": "356518",
            "title": "Estou a partilhar o ficheiro DOC-20260119-WA0032. ",
            "priority": "P3",
            "created_at": "20/01/2026 10:10:50",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 9.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 19:17:26"
          },
          {
            "ticket_id": 6539,
            "ticket_number": "356531",
            "title": "solferias reserva 425020 e 425068",
            "priority": "P2",
            "created_at": "20/01/2026 10:12:40",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 11:30:22"
          },
          {
            "ticket_id": 6543,
            "ticket_number": "356535",
            "title": "Informação importante sobre a tua reserva 1763586",
            "priority": "P2",
            "created_at": "20/01/2026 10:13:58",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:26:04"
          },
          {
            "ticket_id": 6546,
            "ticket_number": "356538",
            "title": "Premios Excellence de Cruceros 2026 - Madrid 12 de",
            "priority": "P2",
            "created_at": "20/01/2026 10:14:04",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:25:28"
          },
          {
            "ticket_id": 6557,
            "ticket_number": "356549",
            "title": "Respuesta automática: Pagamento 604524870",
            "priority": "P2",
            "created_at": "20/01/2026 10:41:45",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:02:10"
          },
          {
            "ticket_id": 6562,
            "ticket_number": "356554",
            "title": "CAMPANHAS QUADRANTE | Lua de Mel, Turkish Airlines",
            "priority": "P2",
            "created_at": "20/01/2026 10:59:49",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:46:54"
          },
          {
            "ticket_id": 6563,
            "ticket_number": "356555",
            "title": "IMG_20260120_094232.pdf",
            "priority": "P2",
            "created_at": "20/01/2026 10:59:51",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:59:05"
          },
          {
            "ticket_id": 6567,
            "ticket_number": "356559",
            "title": "RIVIERA MAYA · POUPE hoje DESFRUTE amanhã",
            "priority": "P2",
            "created_at": "20/01/2026 11:02:07",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 11:22:13"
          },
          {
            "ticket_id": 6576,
            "ticket_number": "356568",
            "title": "URGENTE URGENTE Confirmação de reserva 337291### T",
            "priority": "P1",
            "created_at": "20/01/2026 11:31:24",
            "close_date": "2026-01-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/01/2026 11:42:35"
          },
          {
            "ticket_id": 6588,
            "ticket_number": "356580",
            "title": "🔵❤️OFERTA ESPECIAL DE DIA DOS NAMORADOS!❤️🔵",
            "priority": "P2",
            "created_at": "20/01/2026 14:29:29",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:37:39"
          },
          {
            "ticket_id": 6604,
            "ticket_number": "356596",
            "title": "Cancelamento Plano Consultor",
            "priority": "P2",
            "created_at": "20/01/2026 15:05:26",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:05:26"
          },
          {
            "ticket_id": 6605,
            "ticket_number": "356597",
            "title": "Barcelo Punta Umbria - Orçamento Grupo",
            "priority": "P2",
            "created_at": "20/01/2026 15:56:51",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:56:51"
          },
          {
            "ticket_id": 6606,
            "ticket_number": "356598",
            "title": "Cancelamento de reserva NEWBLEU 1770234",
            "priority": "P2",
            "created_at": "20/01/2026 15:56:53",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:56:53"
          },
          {
            "ticket_id": 6619,
            "ticket_number": "356611",
            "title": "MUITO URGENTE Confirmação de reserva 337322 ### TI",
            "priority": "P2",
            "created_at": "20/01/2026 16:18:41",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:03:30"
          },
          {
            "ticket_id": 6624,
            "ticket_number": "356616",
            "title": "Explora Journeys - Reserve a sua suite e veja o Fo",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:20",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 18:54:43"
          },
          {
            "ticket_id": 6632,
            "ticket_number": "356624",
            "title": "Re:[## 28842 ##] GBN-98046 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "20/01/2026 17:03:46",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 17.0,
            "sla_met": false,
            "sla_breach_hours": 13.0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 10:03:57"
          },
          {
            "ticket_id": 6643,
            "ticket_number": "356635",
            "title": "CONFIRMAÇÃO CIRCUITO VIETNAM SOLFÉRIAS",
            "priority": "P2",
            "created_at": "20/01/2026 17:38:07",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:38:07"
          },
          {
            "ticket_id": 6711,
            "ticket_number": "356703",
            "title": "Re:[## 28814 ##] GBN-91958 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "21/01/2026 13:48:38",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 17:40:33"
          },
          {
            "ticket_id": 6714,
            "ticket_number": "356706",
            "title": "Inscrição Webinar smy",
            "priority": "P3",
            "created_at": "21/01/2026 13:48:44",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:48:44"
          },
          {
            "ticket_id": 6780,
            "ticket_number": "356772",
            "title": "Viagify informa-te do teu or??amento 1238350103 Fi",
            "priority": "P2",
            "created_at": "21/01/2026 18:21:55",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:21:56"
          },
          {
            "ticket_id": 6835,
            "ticket_number": "356827",
            "title": "Pedido de Email",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:04",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:16:05"
          },
          {
            "ticket_id": 6856,
            "ticket_number": "356848",
            "title": "Suspensão Atividade ",
            "priority": "P2",
            "created_at": "22/01/2026 12:26:27",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 12:26:28"
          },
          {
            "ticket_id": 6868,
            "ticket_number": "356860",
            "title": "GBN-100587 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/01/2026 12:52:00",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 12:52:00"
          },
          {
            "ticket_id": 6875,
            "ticket_number": "356867",
            "title": "Orçamento Icarión",
            "priority": "P2",
            "created_at": "22/01/2026 13:55:43",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 13:55:44"
          },
          {
            "ticket_id": 6879,
            "ticket_number": "356871",
            "title": "Pedido orçamento grupo Djerba",
            "priority": "P2",
            "created_at": "22/01/2026 14:20:37",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 14:20:38"
          },
          {
            "ticket_id": 6892,
            "ticket_number": "356884",
            "title": "GBN-91876 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/01/2026 16:55:16",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 17:21:52"
          },
          {
            "ticket_id": 6970,
            "ticket_number": "356962",
            "title": "Confirmação de reserva 337743",
            "priority": "P2",
            "created_at": "23/01/2026 11:35:45",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 175.83,
            "sla_met": false,
            "sla_breach_hours": 171.83,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:26:09"
          },
          {
            "ticket_id": 6971,
            "ticket_number": "356963",
            "title": "Re:[## 29913 ##] GBN-95679 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "23/01/2026 11:35:47",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 5.03,
            "sla_met": false,
            "sla_breach_hours": 1.03,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 16:37:59"
          },
          {
            "ticket_id": 7032,
            "ticket_number": "357024",
            "title": "Confirmacao 337870",
            "priority": "P2",
            "created_at": "23/01/2026 20:02:46",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 88.53,
            "sla_met": false,
            "sla_breach_hours": 84.53,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 12:35:31"
          },
          {
            "ticket_id": 7058,
            "ticket_number": "357050",
            "title": "Pedido orçamento MSC",
            "priority": "P2",
            "created_at": "24/01/2026 00:01:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/01/2026 00:01:41"
          },
          {
            "ticket_id": 7084,
            "ticket_number": "357076",
            "title": "CANCELAMENTO DE RESERVA CIVITATIS LOCALIZADOR A363",
            "priority": "P2",
            "created_at": "24/01/2026 16:01:40",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/01/2026 16:01:40"
          },
          {
            "ticket_id": 7096,
            "ticket_number": "357088",
            "title": "Webinar Wine & Books by the Sea - Gravação Webinar",
            "priority": "P3",
            "created_at": "26/01/2026 10:05:35",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 27.42,
            "sla_met": false,
            "sla_breach_hours": 3.42,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 13:30:38"
          },
          {
            "ticket_id": 7108,
            "ticket_number": "357100",
            "title": "Confirmacao 337965",
            "priority": "P3",
            "created_at": "26/01/2026 10:07:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 13:08:35"
          },
          {
            "ticket_id": 7109,
            "ticket_number": "357101",
            "title": "Confirmacao 337967",
            "priority": "P3",
            "created_at": "26/01/2026 10:07:19",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 13:08:30"
          },
          {
            "ticket_id": 7110,
            "ticket_number": "357102",
            "title": "Confirmacao 337968",
            "priority": "P3",
            "created_at": "26/01/2026 10:07:21",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 13:08:21"
          },
          {
            "ticket_id": 7144,
            "ticket_number": "357136",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604532786",
            "priority": "Reservas sem Formulário",
            "created_at": "26/01/2026 10:14:44",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "26/01/2026 14:02:14"
          },
          {
            "ticket_id": 7153,
            "ticket_number": "357145",
            "title": "Descarregar voucher Soltrópico",
            "priority": "P2",
            "created_at": "26/01/2026 10:16:47",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:16:47"
          },
          {
            "ticket_id": 7161,
            "ticket_number": "357153",
            "title": "Referencia para pagamento | File:426525/2026",
            "priority": "P2",
            "created_at": "26/01/2026 10:17:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.92,
            "sla_met": false,
            "sla_breach_hours": 0.92,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:13:06"
          },
          {
            "ticket_id": 7162,
            "ticket_number": "357154",
            "title": "Iban - mensalidade - p/Magali",
            "priority": "P2",
            "created_at": "26/01/2026 10:17:41",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 419.6,
            "sla_met": false,
            "sla_breach_hours": 415.6,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 21:53:49"
          },
          {
            "ticket_id": 7218,
            "ticket_number": "357210",
            "title": "Re:[## 29462 ##] GBN-87175 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "26/01/2026 12:54:03",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:37:21"
          },
          {
            "ticket_id": 7220,
            "ticket_number": "357212",
            "title": "Dados passaportes passageiros -Localizador GBN-100",
            "priority": "P2",
            "created_at": "26/01/2026 13:08:55",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 13:08:55"
          },
          {
            "ticket_id": 7223,
            "ticket_number": "357215",
            "title": "GBN-87175 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/01/2026 13:43:08",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 14:16:00"
          },
          {
            "ticket_id": 7227,
            "ticket_number": "357219",
            "title": "Re:[## 30191 ##] GBN-87175 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "26/01/2026 14:10:06",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:08:54"
          },
          {
            "ticket_id": 7246,
            "ticket_number": "357238",
            "title": "FORMAÇÃO TUI & UMA FAMILIA EM VIAGEM ",
            "priority": "P3",
            "created_at": "26/01/2026 16:19:25",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 411.23,
            "sla_met": false,
            "sla_breach_hours": 387.23,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 19:34:19"
          },
          {
            "ticket_id": 7252,
            "ticket_number": "357244",
            "title": "Fwd: Dados de data de nascimento TTN-1218445868#91",
            "priority": "P2",
            "created_at": "26/01/2026 16:19:51",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:19:51"
          },
          {
            "ticket_id": 7288,
            "ticket_number": "357280",
            "title": "Cancelamento de Subscrição ",
            "priority": "P3",
            "created_at": "26/01/2026 22:37:03",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 13.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 12:01:41"
          },
          {
            "ticket_id": 7296,
            "ticket_number": "357288",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60453278",
            "priority": "P2",
            "created_at": "26/01/2026 23:35:48",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 23:55:03"
          },
          {
            "ticket_id": 7308,
            "ticket_number": "357300",
            "title": "Detalhes do passageiro para a reserva no arquivo S",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:20",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 11:50:54"
          },
          {
            "ticket_id": 7310,
            "ticket_number": "357302",
            "title": "REMINDER: Dados de Passaporte - nosso File 412548",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:24",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 11:47:38"
          },
          {
            "ticket_id": 7343,
            "ticket_number": "357335",
            "title": "Confirmação de reserva 338156 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "27/01/2026 12:46:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 12:49:51"
          },
          {
            "ticket_id": 7349,
            "ticket_number": "357341",
            "title": "Pedido de disponibilidade e cotação Soltropico",
            "priority": "P2",
            "created_at": "27/01/2026 14:17:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:17:40"
          },
          {
            "ticket_id": 7377,
            "ticket_number": "357369",
            "title": "Re:[## 30339 ##] GBN-100538 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "27/01/2026 16:34:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 18:16:56"
          },
          {
            "ticket_id": 7381,
            "ticket_number": "357373",
            "title": "Interesse em ser consultora",
            "priority": "P2",
            "created_at": "27/01/2026 16:36:54",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 16:43:12"
          },
          {
            "ticket_id": 7382,
            "ticket_number": "357374",
            "title": "Fwd: Informações sobre a sua reserva TTN-122203969",
            "priority": "P2",
            "created_at": "27/01/2026 16:41:12",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 19:08:34"
          },
          {
            "ticket_id": 7426,
            "ticket_number": "357418",
            "title": "\"GBN-86248 - Your request has been received\"",
            "priority": "P2",
            "created_at": "27/01/2026 19:20:19",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 20:08:43"
          },
          {
            "ticket_id": 7428,
            "ticket_number": "357420",
            "title": "Re:[## 30283 ##] GBN-101634 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "27/01/2026 19:32:08",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 20:06:50"
          },
          {
            "ticket_id": 7475,
            "ticket_number": "357467",
            "title": "GBN-92737 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/01/2026 10:27:59",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7635,
            "ticket_number": "357627",
            "title": "Cotización PORTUGAL BENIDORM - cntravel -Ref 50005",
            "priority": "P2",
            "created_at": "29/01/2026 12:43:17",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:43:14"
          },
          {
            "ticket_id": 7703,
            "ticket_number": "357695",
            "title": "Pedido de cotação – Grupo 11 pessoas |Tenerife | A",
            "priority": "P2",
            "created_at": "30/01/2026 10:08:56",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:08:57"
          },
          {
            "ticket_id": 7763,
            "ticket_number": "357755",
            "title": "RE: Utilização voucher 500€",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:39",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:16:40"
          },
          {
            "ticket_id": 7784,
            "ticket_number": "357776",
            "title": "Informação de reserva - SPT002601573103",
            "priority": "P2",
            "created_at": "30/01/2026 13:47:22",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 17:40:05"
          },
          {
            "ticket_id": 7814,
            "ticket_number": "357806",
            "title": "Utilização voucher 500€",
            "priority": "P2",
            "created_at": "30/01/2026 16:54:03",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:56:58"
          },
          {
            "ticket_id": 7829,
            "ticket_number": "357821",
            "title": "Re:[## 30500 ##] GBN-101683 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "30/01/2026 18:56:02",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:01:24"
          },
          {
            "ticket_id": 7836,
            "ticket_number": "357828",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/01/2026 19:09:40",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:09:40"
          },
          {
            "ticket_id": 7843,
            "ticket_number": "357835",
            "title": "GBN-81725 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/01/2026 19:28:37",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:20:53"
          },
          {
            "ticket_id": 7856,
            "ticket_number": "357848",
            "title": "Fwd: Pedido de cotação",
            "priority": "P2",
            "created_at": "30/01/2026 19:49:22",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:49:22"
          },
          {
            "ticket_id": 7871,
            "ticket_number": "357863",
            "title": "Reserva #260100523",
            "priority": "P3",
            "created_at": "30/01/2026 23:11:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 23:11:01"
          },
          {
            "ticket_id": 7902,
            "ticket_number": "357894",
            "title": "Fwd: Informações importantes sobre o seu voo",
            "priority": "P2",
            "created_at": "31/01/2026 11:12:35",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 11:12:35"
          },
          {
            "ticket_id": 7921,
            "ticket_number": "357913",
            "title": "Ac Magali Fwd: Participação de Sinistro – Garantia",
            "priority": "P2",
            "created_at": "31/01/2026 15:24:48",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 15:24:49"
          },
          {
            "ticket_id": 7930,
            "ticket_number": "357922",
            "title": "Viagem ao Egipto com Cairo + Cruzeiro Nilo + Alexa",
            "priority": "P2",
            "created_at": "31/01/2026 18:42:24",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 18:42:24"
          },
          {
            "ticket_id": 7954,
            "ticket_number": "357946",
            "title": "Contatos de Cliente em falta - n/File 425456",
            "priority": "P2",
            "created_at": "02/02/2026 10:08:57",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:48:18"
          },
          {
            "ticket_id": 7967,
            "ticket_number": "357959",
            "title": "Pedido de orçamento",
            "priority": "P3",
            "created_at": "02/02/2026 10:15:00",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 896.97,
            "sla_met": false,
            "sla_breach_hours": 872.97,
            "sla_name": "SLA P3",
            "first_response_at": "11/03/2026 19:13:28"
          },
          {
            "ticket_id": 7997,
            "ticket_number": "357989",
            "title": "Acesso a operadores",
            "priority": "P3",
            "created_at": "02/02/2026 10:18:03",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:18:03"
          },
          {
            "ticket_id": 8028,
            "ticket_number": "358020",
            "title": "Orçamento Grupo - Miami",
            "priority": "P3",
            "created_at": "02/02/2026 10:23:04",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:23:04"
          },
          {
            "ticket_id": 8040,
            "ticket_number": "358032",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "02/02/2026 10:48:08",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 11:16:30"
          },
          {
            "ticket_id": 8043,
            "ticket_number": "358035",
            "title": "Reserva GBN 102989",
            "priority": "P2",
            "created_at": "02/02/2026 10:48:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 10:48:25"
          },
          {
            "ticket_id": 8048,
            "ticket_number": "358040",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "02/02/2026 10:54:26",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 11:14:55"
          },
          {
            "ticket_id": 8067,
            "ticket_number": "358059",
            "title": "Formação Viajar Tours em Braga ",
            "priority": "P3",
            "created_at": "02/02/2026 12:50:01",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:50:01"
          },
          {
            "ticket_id": 8075,
            "ticket_number": "358067",
            "title": "Re:[## 30817 ##] GBN-92737 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/02/2026 13:50:05",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 16:39:19"
          },
          {
            "ticket_id": 8079,
            "ticket_number": "358071",
            "title": "Riviera Maya- Iberostar Paraiso Lindo",
            "priority": "P2",
            "created_at": "02/02/2026 14:45:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 14:45:39"
          },
          {
            "ticket_id": 8083,
            "ticket_number": "358075",
            "title": "Duplicação de reservas 6130642 - 6130671 W2MCS:013",
            "priority": "P2",
            "created_at": "02/02/2026 14:45:51",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 12:49:21"
          },
          {
            "ticket_id": 8084,
            "ticket_number": "358076",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/02/2026 16:37:39",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 16:44:59"
          },
          {
            "ticket_id": 8091,
            "ticket_number": "358083",
            "title": "Re:[## 30697 ##] GBN-102509 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "02/02/2026 16:39:16",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 10:08:32"
          },
          {
            "ticket_id": 8095,
            "ticket_number": "358087",
            "title": "Cancelamento subscrição/relacao - The travel theor",
            "priority": "P2",
            "created_at": "02/02/2026 16:40:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 16:40:06"
          },
          {
            "ticket_id": 8108,
            "ticket_number": "358100",
            "title": "Pagamento da reserva Solférias 424171/2026",
            "priority": "P2",
            "created_at": "02/02/2026 17:43:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 17:43:55"
          },
          {
            "ticket_id": 8145,
            "ticket_number": "358137",
            "title": "Fwd: Pedido de desvinculação da atividade de Consu",
            "priority": "P3",
            "created_at": "03/02/2026 10:00:51",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:00:51"
          },
          {
            "ticket_id": 8179,
            "ticket_number": "358171",
            "title": "GBN-103016 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/02/2026 11:58:10",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1008.22,
            "sla_met": false,
            "sla_breach_hours": 1004.22,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 12:12:00"
          },
          {
            "ticket_id": 8205,
            "ticket_number": "358197",
            "title": "Confirmação de Reserva * FILE 427856/26",
            "priority": "P2",
            "created_at": "03/02/2026 15:36:10",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 19:21:58"
          },
          {
            "ticket_id": 8249,
            "ticket_number": "358241",
            "title": "Confirmacao 338944",
            "priority": "P2",
            "created_at": "03/02/2026 23:37:21",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 11.07,
            "sla_met": false,
            "sla_breach_hours": 7.07,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 10:41:58"
          },
          {
            "ticket_id": 8253,
            "ticket_number": "358245",
            "title": "Cancelamento subscrição",
            "priority": "P3",
            "created_at": "03/02/2026 23:53:49",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 13.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 13:05:38"
          },
          {
            "ticket_id": 8254,
            "ticket_number": "358246",
            "title": "Reserva TOUR10 4060902",
            "priority": "P2",
            "created_at": "03/02/2026 23:54:04",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 23:54:05"
          },
          {
            "ticket_id": 8270,
            "ticket_number": "358262",
            "title": "MSC Cruises Document - 2600101000819536",
            "priority": "P2",
            "created_at": "04/02/2026 10:21:35",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 10:24:05"
          },
          {
            "ticket_id": 8278,
            "ticket_number": "358270",
            "title": "Fwd: Incidente de voo TTN-1243906987#92057970#T173",
            "priority": "P2",
            "created_at": "04/02/2026 11:22:56",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 11:22:57"
          },
          {
            "ticket_id": 8279,
            "ticket_number": "358271",
            "title": "Fwd: Incidente de voo TTN-1241119548#92057993#T173",
            "priority": "P2",
            "created_at": "04/02/2026 11:23:00",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 11:23:01"
          },
          {
            "ticket_id": 8285,
            "ticket_number": "358277",
            "title": "RE: localizador 1773401 W2MCS:017890001659",
            "priority": "P2",
            "created_at": "04/02/2026 12:29:55",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 12:52:45"
          },
          {
            "ticket_id": 8287,
            "ticket_number": "358279",
            "title": "Aviso de Transferência - restante montante seguro ",
            "priority": "P2",
            "created_at": "04/02/2026 12:58:46",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 12:58:46"
          },
          {
            "ticket_id": 8289,
            "ticket_number": "358281",
            "title": "Fwd: Informações sobre a sua reserva TTN-123941381",
            "priority": "P2",
            "created_at": "04/02/2026 13:24:25",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 13:24:26"
          },
          {
            "ticket_id": 8290,
            "ticket_number": "358282",
            "title": "Fwd: Informações da reserva TTN-1239413819#9203202",
            "priority": "P2",
            "created_at": "04/02/2026 13:24:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 13:24:31"
          },
          {
            "ticket_id": 8294,
            "ticket_number": "358286",
            "title": "Orçamento para 14 fevereiro",
            "priority": "P2",
            "created_at": "04/02/2026 15:00:31",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 15:00:31"
          },
          {
            "ticket_id": 8299,
            "ticket_number": "358291",
            "title": "GBN-94763 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/02/2026 15:13:25",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 15:00:28"
          },
          {
            "ticket_id": 8300,
            "ticket_number": "358292",
            "title": "Fwd: Localizador 1244109499 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "04/02/2026 15:13:27",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 15:13:27"
          },
          {
            "ticket_id": 8302,
            "ticket_number": "358294",
            "title": "NOMBRE DE PAX COMPLETO 1773401 W2MCS:016550002132",
            "priority": "P2",
            "created_at": "04/02/2026 16:13:56",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 21.0,
            "sla_met": false,
            "sla_breach_hours": 17.0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 13:14:12"
          },
          {
            "ticket_id": 8304,
            "ticket_number": "358296",
            "title": "GBN-102597 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/02/2026 16:40:10",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 16:43:42"
          },
          {
            "ticket_id": 8305,
            "ticket_number": "358297",
            "title": "FerryGDS agora disponível também em português",
            "priority": "P2",
            "created_at": "04/02/2026 16:40:12",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 16:48:58"
          },
          {
            "ticket_id": 8306,
            "ticket_number": "358298",
            "title": "GRUP-20880 Cotización GRUP-20848 - Albina Silva_Al",
            "priority": "P2",
            "created_at": "04/02/2026 16:40:14",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:37:05"
          },
          {
            "ticket_id": 8308,
            "ticket_number": "358300",
            "title": "FW: GRUP-20880 Cotización GRUP-20848 - Albina Silv",
            "priority": "P2",
            "created_at": "04/02/2026 16:41:53",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:37:37"
          },
          {
            "ticket_id": 8321,
            "ticket_number": "358313",
            "title": "RE: Localizador: 6126895 W2MCS:014920003104",
            "priority": "P2",
            "created_at": "04/02/2026 17:50:03",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 21:44:45"
          },
          {
            "ticket_id": 8324,
            "ticket_number": "358316",
            "title": "Re: Localizador: 6126895 W2MCS:014920003104",
            "priority": "P2",
            "created_at": "04/02/2026 18:22:16",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 19.17,
            "sla_met": false,
            "sla_breach_hours": 15.17,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 13:33:12"
          },
          {
            "ticket_id": 8326,
            "ticket_number": "358318",
            "title": "Rescisão de contrato",
            "priority": "P3",
            "created_at": "04/02/2026 19:01:12",
            "close_date": "2026-05-14",
            "sla_target_hours": 24,
            "actual_time_hours": 23.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 18:38:35"
          },
          {
            "ticket_id": 8390,
            "ticket_number": "358382",
            "title": "Pedido Cotação Travelplan",
            "priority": "P2",
            "created_at": "05/02/2026 10:44:30",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 10:44:31"
          },
          {
            "ticket_id": 8395,
            "ticket_number": "358387",
            "title": "Fwd: localizador 428193",
            "priority": "P3",
            "created_at": "05/02/2026 11:44:23",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 11:44:23"
          },
          {
            "ticket_id": 8396,
            "ticket_number": "358388",
            "title": "urgente - smy loc 1236124045",
            "priority": "P2",
            "created_at": "05/02/2026 11:46:38",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:38:57"
          },
          {
            "ticket_id": 8399,
            "ticket_number": "358391",
            "title": "RESERVA WL FILE- 338543",
            "priority": "P2",
            "created_at": "05/02/2026 11:46:46",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:40:54"
          },
          {
            "ticket_id": 8405,
            "ticket_number": "358397",
            "title": "\"GBN-80001 - Your request has been received\"",
            "priority": "P2",
            "created_at": "05/02/2026 13:08:00",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 17:01:01"
          },
          {
            "ticket_id": 8407,
            "ticket_number": "358399",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604496770",
            "priority": "P2",
            "created_at": "05/02/2026 13:08:06",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:46:03"
          },
          {
            "ticket_id": 8413,
            "ticket_number": "358405",
            "title": "Fwd: Nova Viagem #260100278 - Vanessa Pires",
            "priority": "P2",
            "created_at": "05/02/2026 13:14:13",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 13:14:14"
          },
          {
            "ticket_id": 8416,
            "ticket_number": "358408",
            "title": "Documentos Solferias - 415384 / 2025",
            "priority": "P2",
            "created_at": "05/02/2026 14:13:32",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 14:13:32"
          },
          {
            "ticket_id": 8423,
            "ticket_number": "358415",
            "title": "GBN-98060 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/02/2026 14:41:02",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 17:10:17"
          },
          {
            "ticket_id": 8431,
            "ticket_number": "358423",
            "title": "AIRLINK  - Aumenta voos para Ndola, Zambia",
            "priority": "P2",
            "created_at": "05/02/2026 15:11:19",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:47:32"
          },
          {
            "ticket_id": 8432,
            "ticket_number": "358424",
            "title": "SOLTROPIC URGENTE 339026",
            "priority": "P2",
            "created_at": "05/02/2026 15:39:43",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:39:44"
          },
          {
            "ticket_id": 8433,
            "ticket_number": "358425",
            "title": "Viceroy Ombria Algarve | Novidade na Smybeds com N",
            "priority": "P2",
            "created_at": "05/02/2026 15:39:45",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:47:14"
          },
          {
            "ticket_id": 8434,
            "ticket_number": "358426",
            "title": "GBN-102938 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/02/2026 15:39:47",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 956.53,
            "sla_met": false,
            "sla_breach_hours": 952.53,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 12:12:10"
          },
          {
            "ticket_id": 8436,
            "ticket_number": "358428",
            "title": "NOVO IBAN",
            "priority": "P3",
            "created_at": "05/02/2026 16:05:09",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 16:05:09"
          },
          {
            "ticket_id": 8437,
            "ticket_number": "358429",
            "title": "Rescisão do Contrato",
            "priority": "P2",
            "created_at": "05/02/2026 16:05:11",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 18:03:13"
          },
          {
            "ticket_id": 8438,
            "ticket_number": "358430",
            "title": "reserva de Hotel",
            "priority": "P2",
            "created_at": "05/02/2026 16:05:13",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 16:05:14"
          },
          {
            "ticket_id": 8439,
            "ticket_number": "358431",
            "title": "GBN-100236 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/02/2026 16:30:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 13:08:02"
          },
          {
            "ticket_id": 8445,
            "ticket_number": "358437",
            "title": "Cancelamento da subscrição",
            "priority": "P2",
            "created_at": "05/02/2026 16:59:11",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 18:28:55"
          },
          {
            "ticket_id": 8447,
            "ticket_number": "358439",
            "title": "URGENTE - MUDANÇA DE DATAS DE NASCIMENRO EM RESERV",
            "priority": "P2",
            "created_at": "05/02/2026 17:55:37",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 17:55:37"
          },
          {
            "ticket_id": 8484,
            "ticket_number": "358476",
            "title": "RE: Localizador: 1763586 W2MCS:018400000510",
            "priority": "P2",
            "created_at": "06/02/2026 10:08:27",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 14:02:45"
          },
          {
            "ticket_id": 8486,
            "ticket_number": "358478",
            "title": "Re: Envio de CVO e RGPD 247600088",
            "priority": "P3",
            "created_at": "06/02/2026 10:08:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 23.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 09:44:24"
          },
          {
            "ticket_id": 8509,
            "ticket_number": "358501",
            "title": "Fwd: informação sobre o seu pedido TTN-1244667605#",
            "priority": "P1",
            "created_at": "06/02/2026 11:47:05",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/02/2026 11:47:05"
          },
          {
            "ticket_id": 8511,
            "ticket_number": "358503",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/02/2026 11:47:15",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:07:07"
          },
          {
            "ticket_id": 8512,
            "ticket_number": "358504",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/02/2026 11:47:17",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:06:10"
          },
          {
            "ticket_id": 8526,
            "ticket_number": "358518",
            "title": "Reserva Travelplan- Urgente",
            "priority": "P2",
            "created_at": "06/02/2026 13:28:48",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 13:28:49"
          },
          {
            "ticket_id": 8530,
            "ticket_number": "358522",
            "title": "RE: Pedido de cotação para grupo",
            "priority": "P3",
            "created_at": "06/02/2026 14:03:17",
            "close_date": "2026-02-27",
            "sla_target_hours": 24,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 15:31:11"
          },
          {
            "ticket_id": 8532,
            "ticket_number": "358524",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1243663367#92",
            "priority": "P2",
            "created_at": "06/02/2026 14:48:06",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 14:48:07"
          },
          {
            "ticket_id": 8607,
            "ticket_number": "358599",
            "title": "REMINDER: Dados de Passaporte - nosso File 428883",
            "priority": "P2",
            "created_at": "07/02/2026 10:03:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 12:13:08"
          },
          {
            "ticket_id": 8619,
            "ticket_number": "358611",
            "title": "Acesso veturis",
            "priority": "P2",
            "created_at": "07/02/2026 11:20:56",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 11:20:56"
          },
          {
            "ticket_id": 8622,
            "ticket_number": "358614",
            "title": "GBN-83958 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/02/2026 13:55:24",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 16:00:35"
          },
          {
            "ticket_id": 8625,
            "ticket_number": "358617",
            "title": "GBN-99937 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "07/02/2026 14:08:38",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 16:52:46"
          },
          {
            "ticket_id": 8628,
            "ticket_number": "358620",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60454614",
            "priority": "P3",
            "created_at": "07/02/2026 14:08:46",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 16:56:11"
          },
          {
            "ticket_id": 8629,
            "ticket_number": "358621",
            "title": "Reserva NewBlue - 96000438",
            "priority": "P2",
            "created_at": "07/02/2026 14:08:48",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 14:08:48"
          },
          {
            "ticket_id": 8636,
            "ticket_number": "358628",
            "title": "Pedido de orçamento para grupo",
            "priority": "P2",
            "created_at": "07/02/2026 16:50:59",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 16:51:00"
          },
          {
            "ticket_id": 8637,
            "ticket_number": "358629",
            "title": "GBN-103016 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/02/2026 16:51:02",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/02/2026 16:54:27"
          },
          {
            "ticket_id": 8651,
            "ticket_number": "358643",
            "title": "Informação reserva GBN-101631",
            "priority": "P2",
            "created_at": "09/02/2026 10:21:43",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:21:43"
          },
          {
            "ticket_id": 8665,
            "ticket_number": "358657",
            "title": "Desvinculação do contrato",
            "priority": "P2",
            "created_at": "09/02/2026 10:35:34",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 14:21:50"
          },
          {
            "ticket_id": 8679,
            "ticket_number": "358671",
            "title": "Solferias - 428927",
            "priority": "P2",
            "created_at": "09/02/2026 10:38:59",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:38:59"
          },
          {
            "ticket_id": 8695,
            "ticket_number": "358687",
            "title": "LOCALIZADOR 6124525 NEW BLUE PT",
            "priority": "P2",
            "created_at": "09/02/2026 10:46:19",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 265.68,
            "sla_met": false,
            "sla_breach_hours": 261.68,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:27:38"
          },
          {
            "ticket_id": 8720,
            "ticket_number": "358712",
            "title": "Fwd: Cessação Contrato",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:07"
          },
          {
            "ticket_id": 8752,
            "ticket_number": "358744",
            "title": "RESERVA WL 339158",
            "priority": "P2",
            "created_at": "09/02/2026 13:31:07",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 15:33:08"
          },
          {
            "ticket_id": 8759,
            "ticket_number": "358751",
            "title": "Re: Novo Reforço de Pagamento - Viagem #260100419",
            "priority": "P2",
            "created_at": "09/02/2026 14:36:05",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 14:36:05"
          },
          {
            "ticket_id": 8774,
            "ticket_number": "358766",
            "title": "Novo IBAN e Pagamento de Mensalidade em Atraso",
            "priority": "P2",
            "created_at": "09/02/2026 16:42:47",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 16:42:47"
          },
          {
            "ticket_id": 8783,
            "ticket_number": "358775",
            "title": "Feel Mexico Week!🌴Descontos exclusivos para as pró",
            "priority": "P2",
            "created_at": "09/02/2026 17:27:49",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 17:32:26"
          },
          {
            "ticket_id": 8794,
            "ticket_number": "358786",
            "title": "GBN-101631 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/02/2026 20:10:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 214.95,
            "sla_met": false,
            "sla_breach_hours": 210.95,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 19:08:05"
          },
          {
            "ticket_id": 8820,
            "ticket_number": "358812",
            "title": "Fwd: informação sobre o seu pedido TTN-1244667605#",
            "priority": "P2",
            "created_at": "10/02/2026 10:10:11",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:10:12"
          },
          {
            "ticket_id": 8826,
            "ticket_number": "358818",
            "title": "Vistos/Passaportes",
            "priority": "P2",
            "created_at": "10/02/2026 10:10:36",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:10:36"
          },
          {
            "ticket_id": 8833,
            "ticket_number": "358825",
            "title": "GBN-104804 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/02/2026 10:11:09",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 14:04:27"
          },
          {
            "ticket_id": 8847,
            "ticket_number": "358839",
            "title": "SOLICITAMOS DOCUMENTAÇÃO LOCALIZADOR SOLFÉRIAS: 42",
            "priority": "P2",
            "created_at": "10/02/2026 11:25:13",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 13:33:05"
          },
          {
            "ticket_id": 8850,
            "ticket_number": "358842",
            "title": "Re:[## 31035 ##] GBN-103272 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "10/02/2026 11:56:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 13:52:05"
          },
          {
            "ticket_id": 8858,
            "ticket_number": "358850",
            "title": "Re:[## 31470 ##] GBN-104228 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "10/02/2026 12:08:17",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 13:49:26"
          },
          {
            "ticket_id": 8867,
            "ticket_number": "358859",
            "title": "Rescisão de Contrato – Direito de Arrependimento (",
            "priority": "P2",
            "created_at": "10/02/2026 15:04:23",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:00:05"
          },
          {
            "ticket_id": 8880,
            "ticket_number": "358872",
            "title": "Odisseias | Acesso e duvidas",
            "priority": "P3",
            "created_at": "10/02/2026 16:56:55",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 16:56:56"
          },
          {
            "ticket_id": 8953,
            "ticket_number": "358945",
            "title": "Re: Reserva Excursão (Magali)",
            "priority": "P2",
            "created_at": "11/02/2026 10:14:55",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 12:16:38"
          },
          {
            "ticket_id": 8964,
            "ticket_number": "358956",
            "title": "Confirmação de reserva 339183 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "11/02/2026 10:51:34",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 11:16:57"
          },
          {
            "ticket_id": 9023,
            "ticket_number": "359015",
            "title": "Re:[## 31917 ##] GBN-101631 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "11/02/2026 18:53:17",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 22:42:46"
          },
          {
            "ticket_id": 9027,
            "ticket_number": "359019",
            "title": "GBN-101631 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/02/2026 18:53:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 22:42:46"
          },
          {
            "ticket_id": 9039,
            "ticket_number": "359031",
            "title": "Rescisão - devido a Tempestade Kristin",
            "priority": "P3",
            "created_at": "11/02/2026 19:56:59",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 25.77,
            "sla_met": false,
            "sla_breach_hours": 1.77,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 21:43:06"
          },
          {
            "ticket_id": 9054,
            "ticket_number": "359046",
            "title": "Monica Carvalho - Voucher Mx - Fevereiro 2026",
            "priority": "P2",
            "created_at": "11/02/2026 21:47:02",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 11:43:21"
          },
          {
            "ticket_id": 9079,
            "ticket_number": "359071",
            "title": "Eticket - 70075958 - SE  02/03/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "12/02/2026 10:10:07",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 11:20:35"
          },
          {
            "ticket_id": 9117,
            "ticket_number": "359109",
            "title": "Fwd: informação sobre o seu pedido TTN-1244667605#",
            "priority": "P2",
            "created_at": "12/02/2026 13:17:55",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 13:17:56"
          },
          {
            "ticket_id": 9118,
            "ticket_number": "359110",
            "title": "VOUCHER DA RESERVA 604480449",
            "priority": "P2",
            "created_at": "12/02/2026 13:18:05",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 13:22:14"
          },
          {
            "ticket_id": 9137,
            "ticket_number": "359129",
            "title": "Re:[## 30276 ##] GBN-101053 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:16",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 19:38:18"
          },
          {
            "ticket_id": 9139,
            "ticket_number": "359131",
            "title": "Fwd: Pedido de cotação",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:27",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 18:05:28"
          },
          {
            "ticket_id": 9141,
            "ticket_number": "359133",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:37",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:16"
          },
          {
            "ticket_id": 9142,
            "ticket_number": "359134",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:39",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:45"
          },
          {
            "ticket_id": 9143,
            "ticket_number": "359135",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:42",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:39"
          },
          {
            "ticket_id": 9144,
            "ticket_number": "359136",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:43",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:29"
          },
          {
            "ticket_id": 9145,
            "ticket_number": "359137",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:45",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:50"
          },
          {
            "ticket_id": 9146,
            "ticket_number": "359138",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P3",
            "created_at": "12/02/2026 18:15:47",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 18.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:01:34"
          },
          {
            "ticket_id": 9183,
            "ticket_number": "359175",
            "title": "Fim‑de‑semana em grupo",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:30",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:31"
          },
          {
            "ticket_id": 9207,
            "ticket_number": "359199",
            "title": "ORÇAMENTO GRUPO TAILÂNDIA - Rafaela Lapa [T-UFEV#3",
            "priority": "P2",
            "created_at": "13/02/2026 12:49:15",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 13:28:38"
          },
          {
            "ticket_id": 9209,
            "ticket_number": "359201",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "13/02/2026 13:31:53",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 13:41:32"
          },
          {
            "ticket_id": 9211,
            "ticket_number": "359203",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "13/02/2026 13:32:01",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 13:33:05"
          },
          {
            "ticket_id": 9216,
            "ticket_number": "359208",
            "title": "Re:[## 31295 ##] GBN-100236 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "13/02/2026 14:18:53",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 14:20:31"
          },
          {
            "ticket_id": 9230,
            "ticket_number": "359222",
            "title": "Re:[## 32017 ##] GBN-105492 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "13/02/2026 15:45:00",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 18:51:49"
          },
          {
            "ticket_id": 9369,
            "ticket_number": "359361",
            "title": "Comprovativo de pagamento de mensalidade  em atras",
            "priority": "P2",
            "created_at": "16/02/2026 10:10:37",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:10:37"
          },
          {
            "ticket_id": 9373,
            "ticket_number": "359365",
            "title": "Re:[## 32017 ##] GBN-105492 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "16/02/2026 10:10:51",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 11:09:56"
          },
          {
            "ticket_id": 9380,
            "ticket_number": "359372",
            "title": "Pedido | Troca de email e nome",
            "priority": "P3",
            "created_at": "16/02/2026 10:14:26",
            "close_date": "2026-03-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:14:27"
          },
          {
            "ticket_id": 9385,
            "ticket_number": "359377",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604532920",
            "priority": "P2",
            "created_at": "16/02/2026 10:55:34",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 11:01:08"
          },
          {
            "ticket_id": 9387,
            "ticket_number": "359379",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604539069",
            "priority": "P2",
            "created_at": "16/02/2026 10:55:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:58:34"
          },
          {
            "ticket_id": 9390,
            "ticket_number": "359382",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604521275",
            "priority": "P1",
            "created_at": "16/02/2026 11:20:22",
            "close_date": "2026-04-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.3,
            "sla_met": false,
            "sla_breach_hours": 0.05,
            "sla_name": "SLA P1",
            "first_response_at": "16/02/2026 11:39:09"
          },
          {
            "ticket_id": 9394,
            "ticket_number": "359386",
            "title": "Reservas newblue - pedido de camas casal + duas ca",
            "priority": "P2",
            "created_at": "16/02/2026 11:47:27",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 11:47:27"
          },
          {
            "ticket_id": 9402,
            "ticket_number": "359394",
            "title": "Procedimentos de visto – Reservas Ilha do Sal",
            "priority": "P2",
            "created_at": "16/02/2026 13:02:29",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:02:29"
          },
          {
            "ticket_id": 9404,
            "ticket_number": "359396",
            "title": "Envio de Documentação * File 416895",
            "priority": "P2",
            "created_at": "16/02/2026 13:17:17",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:19:09"
          },
          {
            "ticket_id": 9405,
            "ticket_number": "359397",
            "title": "PROGRAMAÇÃO AÉREA 2026",
            "priority": "P2",
            "created_at": "16/02/2026 13:17:19",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:55:46"
          },
          {
            "ticket_id": 9406,
            "ticket_number": "359398",
            "title": "Envio de Documentação * File 425327",
            "priority": "P2",
            "created_at": "16/02/2026 13:17:29",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:20:28"
          },
          {
            "ticket_id": 9408,
            "ticket_number": "359400",
            "title": "NB - pedido de 14 dias",
            "priority": "P2",
            "created_at": "16/02/2026 13:56:39",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:56:39"
          },
          {
            "ticket_id": 9414,
            "ticket_number": "359406",
            "title": "Fwd: Você fez o check-in para seu voo para Lisboa ",
            "priority": "P2",
            "created_at": "16/02/2026 14:51:49",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 14:51:49"
          },
          {
            "ticket_id": 9415,
            "ticket_number": "359407",
            "title": "Re:[## 31498 ##] GBN-99937 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "16/02/2026 14:51:51",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 14:57:35"
          },
          {
            "ticket_id": 9419,
            "ticket_number": "359411",
            "title": "Orçamento de grupo Soltropico",
            "priority": "P2",
            "created_at": "16/02/2026 16:00:45",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:00:45"
          },
          {
            "ticket_id": 9421,
            "ticket_number": "359413",
            "title": "Re:[## 31317 ##] GBN-103806 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "16/02/2026 16:16:06",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:31:47"
          },
          {
            "ticket_id": 9423,
            "ticket_number": "359415",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60450704",
            "priority": "P2",
            "created_at": "16/02/2026 16:32:52",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:36:32"
          },
          {
            "ticket_id": 9424,
            "ticket_number": "359416",
            "title": "DATA NASCIMENTO INCORRETA NORTRAVEL 604553839",
            "priority": "P2",
            "created_at": "16/02/2026 16:32:53",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:32:54"
          },
          {
            "ticket_id": 9426,
            "ticket_number": "359418",
            "title": "Pedido de acréscimo de mala de porão – Reservas 33",
            "priority": "P2",
            "created_at": "16/02/2026 16:46:04",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:46:04"
          },
          {
            "ticket_id": 9435,
            "ticket_number": "359427",
            "title": "Interesse",
            "priority": "P2",
            "created_at": "16/02/2026 17:04:28",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 17:08:04"
          },
          {
            "ticket_id": 9436,
            "ticket_number": "359428",
            "title": "Re:[## 31295 ##] GBN-100236 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "16/02/2026 17:04:31",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 17:09:29"
          },
          {
            "ticket_id": 9439,
            "ticket_number": "359431",
            "title": "URGENTE! NOTIFICAÇÃO DE RESERVA 6131353",
            "priority": "P2",
            "created_at": "16/02/2026 18:31:14",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:22:03"
          },
          {
            "ticket_id": 9441,
            "ticket_number": "359433",
            "title": "URGENTE! NOTIFICAÇÃO DE RESERVA 6127520",
            "priority": "P2",
            "created_at": "16/02/2026 18:31:18",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:22:03"
          },
          {
            "ticket_id": 9456,
            "ticket_number": "359448",
            "title": "URGENTE! NOTIFICAÇÃO DE RESERVA 6128814",
            "priority": "P2",
            "created_at": "16/02/2026 18:31:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:22:05"
          },
          {
            "ticket_id": 9460,
            "ticket_number": "359452",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604553839",
            "priority": "P2",
            "created_at": "16/02/2026 18:32:23",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 18:36:30"
          },
          {
            "ticket_id": 9465,
            "ticket_number": "359457",
            "title": "GBN-105492 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/02/2026 19:19:54",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 19:19:54"
          },
          {
            "ticket_id": 9472,
            "ticket_number": "359464",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60454618",
            "priority": "P2",
            "created_at": "16/02/2026 20:37:14",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 11:00:23"
          },
          {
            "ticket_id": 9490,
            "ticket_number": "359482",
            "title": "Pedido de informações sobre viagem para Zanzibar",
            "priority": "P2",
            "created_at": "16/02/2026 22:36:06",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 23:50:51"
          },
          {
            "ticket_id": 9520,
            "ticket_number": "359512",
            "title": "Número de informação da reserva: 6130659",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:24",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.43,
            "sla_met": false,
            "sla_breach_hours": 49.43,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:55:14"
          },
          {
            "ticket_id": 9522,
            "ticket_number": "359514",
            "title": "Número de informação da reserva: 6130651",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.35,
            "sla_met": false,
            "sla_breach_hours": 49.35,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:50:04"
          },
          {
            "ticket_id": 9526,
            "ticket_number": "359518",
            "title": "Número de informação da reserva: 6128608",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.33,
            "sla_met": false,
            "sla_breach_hours": 49.33,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:48:47"
          },
          {
            "ticket_id": 9527,
            "ticket_number": "359519",
            "title": "IMPORTANTE - WEBINAR - Explore o Mundo a Bordo - N",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:40",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 76.83,
            "sla_met": false,
            "sla_breach_hours": 72.83,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 17:18:50"
          },
          {
            "ticket_id": 9529,
            "ticket_number": "359521",
            "title": "Número de informação da reserva: 6131618",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:45",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.28,
            "sla_met": false,
            "sla_breach_hours": 49.28,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:46:39"
          },
          {
            "ticket_id": 9530,
            "ticket_number": "359522",
            "title": "Número de informação da reserva: 6130690",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:48",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.3,
            "sla_met": false,
            "sla_breach_hours": 49.3,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:47:47"
          },
          {
            "ticket_id": 9531,
            "ticket_number": "359523",
            "title": "Número de informação da reserva: 6128601",
            "priority": "P2",
            "created_at": "17/02/2026 12:31:59",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.22,
            "sla_met": false,
            "sla_breach_hours": 49.22,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:45:03"
          },
          {
            "ticket_id": 9532,
            "ticket_number": "359524",
            "title": "Número de informação da reserva: 6128565",
            "priority": "P2",
            "created_at": "17/02/2026 12:32:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.17,
            "sla_met": false,
            "sla_breach_hours": 49.17,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:42:40"
          },
          {
            "ticket_id": 9535,
            "ticket_number": "359527",
            "title": "Número de informação da reserva: 6128555",
            "priority": "P3",
            "created_at": "17/02/2026 13:07:09",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 52.47,
            "sla_met": false,
            "sla_breach_hours": 28.47,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 17:35:21"
          },
          {
            "ticket_id": 9538,
            "ticket_number": "359530",
            "title": "Número de informação da reserva: 6122706",
            "priority": "P2",
            "created_at": "17/02/2026 13:07:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 52.28,
            "sla_met": false,
            "sla_breach_hours": 48.28,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 17:24:49"
          },
          {
            "ticket_id": 9554,
            "ticket_number": "359546",
            "title": "acessos veturis",
            "priority": "P2",
            "created_at": "17/02/2026 16:35:47",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 16:50:42"
          },
          {
            "ticket_id": 9572,
            "ticket_number": "359564",
            "title": "Fwd: ANWB8L | Reserva já e consegue o melhor preço",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:21",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 17:42:22"
          },
          {
            "ticket_id": 9631,
            "ticket_number": "359623",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "18/02/2026 14:06:42",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 15:15:34"
          },
          {
            "ticket_id": 9642,
            "ticket_number": "359634",
            "title": "Rescindir contrato",
            "priority": "P2",
            "created_at": "18/02/2026 14:09:01",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:01:22"
          },
          {
            "ticket_id": 9660,
            "ticket_number": "359652",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:13",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:52:44"
          },
          {
            "ticket_id": 9666,
            "ticket_number": "359658",
            "title": "Informação de reserva - SPT002601585681",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:44",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:42:26"
          },
          {
            "ticket_id": 9685,
            "ticket_number": "359677",
            "title": "Letícia Carvalho.",
            "priority": "P2",
            "created_at": "18/02/2026 18:43:35",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:49:58"
          },
          {
            "ticket_id": 9686,
            "ticket_number": "359678",
            "title": "Re:[## 30589 ##] GBN-102156 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "18/02/2026 18:43:40",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:54:36"
          },
          {
            "ticket_id": 9693,
            "ticket_number": "359685",
            "title": "Cancelamento de Reserva 211730",
            "priority": "P2",
            "created_at": "18/02/2026 18:56:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:57:18"
          },
          {
            "ticket_id": 9720,
            "ticket_number": "359712",
            "title": "LOC orçamento: 1250415710",
            "priority": "P2",
            "created_at": "19/02/2026 00:01:21",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 00:01:21"
          },
          {
            "ticket_id": 9727,
            "ticket_number": "359719",
            "title": "Reserva #260200309",
            "priority": "P2",
            "created_at": "19/02/2026 10:07:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:07:23"
          },
          {
            "ticket_id": 9729,
            "ticket_number": "359721",
            "title": "webinar nortravel",
            "priority": "P2",
            "created_at": "19/02/2026 10:07:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:07:32"
          },
          {
            "ticket_id": 9731,
            "ticket_number": "359723",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "19/02/2026 10:07:42",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:15:54"
          },
          {
            "ticket_id": 9739,
            "ticket_number": "359731",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "19/02/2026 10:59:02",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:59:02"
          },
          {
            "ticket_id": 9740,
            "ticket_number": "359732",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "19/02/2026 10:59:05",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:59:05"
          },
          {
            "ticket_id": 9742,
            "ticket_number": "359734",
            "title": "Fwd: 1240916209 TTN-1240916209#92540329#T17524622¬",
            "priority": "P2",
            "created_at": "19/02/2026 10:59:12",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:59:12"
          },
          {
            "ticket_id": 9746,
            "ticket_number": "359738",
            "title": "A/C - Magali Morim ( inscrição p/ Webinars Nortrav",
            "priority": "P2",
            "created_at": "19/02/2026 11:42:03",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 11:42:03"
          },
          {
            "ticket_id": 9748,
            "ticket_number": "359740",
            "title": "Webinars Nortravel",
            "priority": "P2",
            "created_at": "19/02/2026 11:58:52",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 11:58:52"
          },
          {
            "ticket_id": 9756,
            "ticket_number": "359748",
            "title": "Signed: rgpd GBN-93102.docx",
            "priority": "P2",
            "created_at": "19/02/2026 13:04:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 14:10:36"
          },
          {
            "ticket_id": 9761,
            "ticket_number": "359753",
            "title": "Petición CnTravel 52004510",
            "priority": "P2",
            "created_at": "19/02/2026 13:26:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:17:21"
          },
          {
            "ticket_id": 9766,
            "ticket_number": "359758",
            "title": "Reserva MSC 70358738",
            "priority": "P2",
            "created_at": "19/02/2026 14:05:09",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 14:05:09"
          },
          {
            "ticket_id": 9837,
            "ticket_number": "359829",
            "title": "Inscriçao Webinar- Nortravel e TUI",
            "priority": "P2",
            "created_at": "20/02/2026 10:19:25",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:19:25"
          },
          {
            "ticket_id": 9859,
            "ticket_number": "359851",
            "title": "Questão Reserva Tour10 4072692",
            "priority": "P2",
            "created_at": "20/02/2026 10:54:26",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:54:27"
          },
          {
            "ticket_id": 9872,
            "ticket_number": "359860",
            "title": "Inscrição Webinar ",
            "priority": "P2",
            "created_at": "20/02/2026 12:16:04",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:16:05"
          },
          {
            "ticket_id": 9874,
            "ticket_number": "359862",
            "title": "Webinar Tui",
            "priority": "P2",
            "created_at": "20/02/2026 12:16:10",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:16:11"
          },
          {
            "ticket_id": 9875,
            "ticket_number": "359863",
            "title": "inscrição webinar TUI",
            "priority": "P2",
            "created_at": "20/02/2026 12:16:13",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:16:13"
          },
          {
            "ticket_id": 9878,
            "ticket_number": "359866",
            "title": "Envio de documentação - FILE",
            "priority": "P2",
            "created_at": "20/02/2026 12:30:15",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 13:45:38"
          },
          {
            "ticket_id": 9880,
            "ticket_number": "359868",
            "title": "Formação Cokpit",
            "priority": "P2",
            "created_at": "20/02/2026 12:40:47",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:40:47"
          },
          {
            "ticket_id": 9886,
            "ticket_number": "359874",
            "title": "Em 2026 Vamos Viajar em Nosso Companhia !",
            "priority": "P2",
            "created_at": "20/02/2026 13:11:37",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 15:41:44"
          },
          {
            "ticket_id": 9888,
            "ticket_number": "359876",
            "title": "Código para cerrar reserva a Holiday Inn Brussels ",
            "priority": "P2",
            "created_at": "20/02/2026 13:11:44",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 13:22:55"
          },
          {
            "ticket_id": 9904,
            "ticket_number": "359892",
            "title": "Pedido de fatura e recibo - mensalidade de Janeiro",
            "priority": "P2",
            "created_at": "20/02/2026 15:37:26",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 15:37:26"
          },
          {
            "ticket_id": 9906,
            "ticket_number": "359894",
            "title": "Inscrição Webinares",
            "priority": "P2",
            "created_at": "20/02/2026 16:06:41",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:06:41"
          },
          {
            "ticket_id": 9910,
            "ticket_number": "359898",
            "title": "Webinar TUI",
            "priority": "P2",
            "created_at": "20/02/2026 16:08:54",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:08:55"
          },
          {
            "ticket_id": 9911,
            "ticket_number": "359899",
            "title": "Webinar Nortravel Albânia e Malta",
            "priority": "P2",
            "created_at": "20/02/2026 16:08:56",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:08:56"
          },
          {
            "ticket_id": 9924,
            "ticket_number": "359912",
            "title": "Webinar TUI - ofertas exclusivas BTL - 24 de Fever",
            "priority": "P2",
            "created_at": "20/02/2026 17:36:58",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 17:36:58"
          },
          {
            "ticket_id": 10107,
            "ticket_number": "3510095",
            "title": "Icárion - Praslin & Mahé - Feira Noivos - 2026-09-",
            "priority": "P2",
            "created_at": "23/02/2026 12:57:50",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:07:49"
          },
          {
            "ticket_id": 10115,
            "ticket_number": "3510103",
            "title": "GBN-67038 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/02/2026 13:38:52",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:09:59"
          },
          {
            "ticket_id": 10167,
            "ticket_number": "3510155",
            "title": "Loc. Cuba/Punta Cana",
            "priority": "P2",
            "created_at": "23/02/2026 19:08:33",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:08:34"
          },
          {
            "ticket_id": 10179,
            "ticket_number": "3510167",
            "title": "Orçamentos",
            "priority": "P2",
            "created_at": "23/02/2026 20:43:44",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 20:43:44"
          },
          {
            "ticket_id": 10208,
            "ticket_number": "3510196",
            "title": "MSC Cruises Document - 2600101001397476",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:16",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 12:26:57"
          },
          {
            "ticket_id": 10224,
            "ticket_number": "3510212",
            "title": "RE: Pagamento 1776719",
            "priority": "P2",
            "created_at": "24/02/2026 11:09:41",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 12:26:05"
          },
          {
            "ticket_id": 10234,
            "ticket_number": "3510222",
            "title": "Pagamento Civitatis",
            "priority": "P2",
            "created_at": "24/02/2026 11:44:38",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:44:38"
          },
          {
            "ticket_id": 10267,
            "ticket_number": "3510255",
            "title": "Fwd: Informações da reserva TTN-1234129672#9403601",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:14",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:15"
          },
          {
            "ticket_id": 10269,
            "ticket_number": "3510257",
            "title": "TRP-2026-03247",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:20",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:21"
          },
          {
            "ticket_id": 10270,
            "ticket_number": "3510258",
            "title": "Fwd: Informações da reserva TTN-1234129672#9392545",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:24",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:25"
          },
          {
            "ticket_id": 10271,
            "ticket_number": "3510259",
            "title": "Desconto até 30% BTL para agências de viagens",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:28",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 16:19:40"
          },
          {
            "ticket_id": 10273,
            "ticket_number": "3510261",
            "title": "Fwd: TSJPMI | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "24/02/2026 16:10:49",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 16:10:50"
          },
          {
            "ticket_id": 10275,
            "ticket_number": "3510263",
            "title": "Fwd: Informações da reserva TTN-1125356410#8834881",
            "priority": "P2",
            "created_at": "24/02/2026 16:54:18",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 16:54:19"
          },
          {
            "ticket_id": 10276,
            "ticket_number": "3510264",
            "title": "cancelamento",
            "priority": "P2",
            "created_at": "24/02/2026 17:24:39",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 17:24:39"
          },
          {
            "ticket_id": 10278,
            "ticket_number": "3510266",
            "title": "GBN-101053 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/02/2026 17:24:44",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:11"
          },
          {
            "ticket_id": 10280,
            "ticket_number": "3510268",
            "title": "EXOTICOONLINE e DESTINOS < Campanha de BTL! Campan",
            "priority": "P2",
            "created_at": "24/02/2026 18:21:09",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1266.22,
            "sla_met": false,
            "sla_breach_hours": 1262.22,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:34:39"
          },
          {
            "ticket_id": 10281,
            "ticket_number": "3510269",
            "title": "Soltour: Cancelamento de reserva: SPT002601593417",
            "priority": "P2",
            "created_at": "24/02/2026 18:21:11",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 18:22:17"
          },
          {
            "ticket_id": 10283,
            "ticket_number": "3510271",
            "title": "Soltour: Cancelamento de reserva: SPT002601593417",
            "priority": "P2",
            "created_at": "24/02/2026 18:21:16",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 18:41:04"
          },
          {
            "ticket_id": 10318,
            "ticket_number": "3510306",
            "title": "Cuba/Punta Cana",
            "priority": "P2",
            "created_at": "24/02/2026 23:31:16",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:31:16"
          },
          {
            "ticket_id": 10321,
            "ticket_number": "3510309",
            "title": "Webinar Newblue - Cartagena das Indias",
            "priority": "P2",
            "created_at": "24/02/2026 23:33:04",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 23:33:04"
          },
          {
            "ticket_id": 10327,
            "ticket_number": "3510315",
            "title": "Informação importante sobre a tua reserva 1774543",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:09",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 12:29:40"
          },
          {
            "ticket_id": 10351,
            "ticket_number": "3510339",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "25/02/2026 10:57:44",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:04:31"
          },
          {
            "ticket_id": 10394,
            "ticket_number": "3510382",
            "title": "Download de fatura",
            "priority": "P2",
            "created_at": "25/02/2026 14:54:41",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:54:41"
          },
          {
            "ticket_id": 10399,
            "ticket_number": "3510387",
            "title": "Fwd: Informações da reserva TTN-1234129672#9416647",
            "priority": "P2",
            "created_at": "25/02/2026 16:18:56",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:18:57"
          },
          {
            "ticket_id": 10400,
            "ticket_number": "3510388",
            "title": "veturis",
            "priority": "P2",
            "created_at": "25/02/2026 16:18:59",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:18:59"
          },
          {
            "ticket_id": 10403,
            "ticket_number": "3510391",
            "title": "Credenciais Vila Galé",
            "priority": "P2",
            "created_at": "25/02/2026 16:19:10",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:19:10"
          },
          {
            "ticket_id": 10413,
            "ticket_number": "3510401",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "25/02/2026 17:21:00",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:22:42"
          },
          {
            "ticket_id": 10466,
            "ticket_number": "3510454",
            "title": "Eticket - 70075958 - SE  02/03/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "26/02/2026 10:03:50",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:26:53"
          },
          {
            "ticket_id": 10469,
            "ticket_number": "3510457",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "26/02/2026 10:03:58",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:25:30"
          },
          {
            "ticket_id": 10472,
            "ticket_number": "3510460",
            "title": "Información de reserva número: 1778053",
            "priority": "P2",
            "created_at": "26/02/2026 10:04:07",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:41:50"
          },
          {
            "ticket_id": 10473,
            "ticket_number": "3510461",
            "title": "Informação de reserva - SPT002601595478",
            "priority": "P2",
            "created_at": "26/02/2026 10:04:17",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:22:44"
          },
          {
            "ticket_id": 10475,
            "ticket_number": "3510463",
            "title": "Esclarecimento valores do débito direto- Dezembro",
            "priority": "P2",
            "created_at": "26/02/2026 10:04:23",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:04:23"
          },
          {
            "ticket_id": 10480,
            "ticket_number": "3510468",
            "title": "Documentação Disponível - Reserva 340594",
            "priority": "P2",
            "created_at": "26/02/2026 11:46:11",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:17:31"
          },
          {
            "ticket_id": 10481,
            "ticket_number": "3510469",
            "title": "RESERVA WL 340676",
            "priority": "P3",
            "created_at": "26/02/2026 11:46:44",
            "close_date": "2026-02-26",
            "sla_target_hours": 24,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/02/2026 13:53:13"
          },
          {
            "ticket_id": 10482,
            "ticket_number": "3510470",
            "title": "RESERVA EM WL FILE- 340685",
            "priority": "P2",
            "created_at": "26/02/2026 11:46:46",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:18:52"
          },
          {
            "ticket_id": 10498,
            "ticket_number": "3510486",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "26/02/2026 12:24:36",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:24:36"
          },
          {
            "ticket_id": 10509,
            "ticket_number": "3510497",
            "title": "BTL começou: o Caribe mais fácil de vender esta se",
            "priority": "P2",
            "created_at": "26/02/2026 13:18:44",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 14:13:56"
          },
          {
            "ticket_id": 10512,
            "ticket_number": "3510500",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6126614",
            "priority": "P2",
            "created_at": "26/02/2026 14:07:04",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 14:12:43"
          },
          {
            "ticket_id": 10513,
            "ticket_number": "3510501",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6126614",
            "priority": "P2",
            "created_at": "26/02/2026 14:07:05",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 14:10:46"
          },
          {
            "ticket_id": 10515,
            "ticket_number": "3510503",
            "title": "AJUSTE DE HORÁRIO DA SUA RESERVA 6129257",
            "priority": "P2",
            "created_at": "26/02/2026 14:07:10",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 14:09:05"
          },
          {
            "ticket_id": 10518,
            "ticket_number": "3510506",
            "title": "Hotel Blue Pearl Beach",
            "priority": "P2",
            "created_at": "26/02/2026 15:47:52",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 15:47:52"
          },
          {
            "ticket_id": 10522,
            "ticket_number": "3510510",
            "title": "1778053 W2MCS:011860002925",
            "priority": "P2",
            "created_at": "26/02/2026 16:17:58",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 530.22,
            "sla_met": false,
            "sla_breach_hours": 526.22,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:31:44"
          },
          {
            "ticket_id": 10525,
            "ticket_number": "3510513",
            "title": "Updates to Distribution Agreement",
            "priority": "P2",
            "created_at": "26/02/2026 16:18:12",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 16:31:17"
          },
          {
            "ticket_id": 10539,
            "ticket_number": "3510527",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "26/02/2026 18:31:25",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:57:31"
          },
          {
            "ticket_id": 10684,
            "ticket_number": "3510672",
            "title": "Re: loc 340594",
            "priority": "P2",
            "created_at": "27/02/2026 19:14:53",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 23:04:24"
          },
          {
            "ticket_id": 10694,
            "ticket_number": "3510682",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:04",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 15.68,
            "sla_met": false,
            "sla_breach_hours": 11.68,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 12:18:51"
          },
          {
            "ticket_id": 10696,
            "ticket_number": "3510684",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:08",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 41.35,
            "sla_met": false,
            "sla_breach_hours": 37.35,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 13:59:08"
          },
          {
            "ticket_id": 10697,
            "ticket_number": "3510685",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/02/2026 20:37:10",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 20.02,
            "sla_met": false,
            "sla_breach_hours": 16.02,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:38:11"
          },
          {
            "ticket_id": 10702,
            "ticket_number": "3510690",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 20:51:05",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 41.13,
            "sla_met": false,
            "sla_breach_hours": 37.13,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 14:00:03"
          },
          {
            "ticket_id": 10703,
            "ticket_number": "3510691",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 20:51:07",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 41.15,
            "sla_met": false,
            "sla_breach_hours": 37.15,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 14:00:36"
          },
          {
            "ticket_id": 10704,
            "ticket_number": "3510692",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:02:02",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 40.98,
            "sla_met": false,
            "sla_breach_hours": 36.98,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 14:01:37"
          },
          {
            "ticket_id": 10705,
            "ticket_number": "3510693",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:27:44",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 43.28,
            "sla_met": false,
            "sla_breach_hours": 39.28,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:44:51"
          },
          {
            "ticket_id": 10706,
            "ticket_number": "3510694",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:27:46",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 43.3,
            "sla_met": false,
            "sla_breach_hours": 39.3,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:45:48"
          },
          {
            "ticket_id": 10707,
            "ticket_number": "3510695",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:27:48",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 43.32,
            "sla_met": false,
            "sla_breach_hours": 39.32,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:46:49"
          },
          {
            "ticket_id": 10708,
            "ticket_number": "3510696",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:27:50",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 43.33,
            "sla_met": false,
            "sla_breach_hours": 39.33,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:48:04"
          },
          {
            "ticket_id": 10711,
            "ticket_number": "3510699",
            "title": "Alteração de Preço - Visto Egito",
            "priority": "P2",
            "created_at": "27/02/2026 21:47:16",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 43.02,
            "sla_met": false,
            "sla_breach_hours": 39.02,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:48:41"
          },
          {
            "ticket_id": 10819,
            "ticket_number": "3510807",
            "title": "RAMALHO GOIS/FRANCISCO ANTONIO MR 02MAR2026 LIS MA",
            "priority": "P2",
            "created_at": "28/02/2026 20:15:32",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 20:15:32"
          },
          {
            "ticket_id": 10861,
            "ticket_number": "3510849",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:10",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.75,
            "sla_met": false,
            "sla_breach_hours": 12.75,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:52:07"
          },
          {
            "ticket_id": 10863,
            "ticket_number": "3510851",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:12",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.72,
            "sla_met": false,
            "sla_breach_hours": 12.72,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:49:59"
          },
          {
            "ticket_id": 10865,
            "ticket_number": "3510853",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:17",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.72,
            "sla_met": false,
            "sla_breach_hours": 12.72,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:50:07"
          },
          {
            "ticket_id": 10866,
            "ticket_number": "3510854",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:19",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.73,
            "sla_met": false,
            "sla_breach_hours": 12.73,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:50:35"
          },
          {
            "ticket_id": 10867,
            "ticket_number": "3510855",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:21",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.73,
            "sla_met": false,
            "sla_breach_hours": 12.73,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:50:42"
          },
          {
            "ticket_id": 10868,
            "ticket_number": "3510856",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "01/03/2026 00:06:22",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 16.73,
            "sla_met": false,
            "sla_breach_hours": 12.73,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 16:50:53"
          },
          {
            "ticket_id": 10874,
            "ticket_number": "3510862",
            "title": "Verifique os dados do seu voo para Amsterdao",
            "priority": "P2",
            "created_at": "01/03/2026 11:47:21",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 6.98,
            "sla_met": false,
            "sla_breach_hours": 2.98,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 18:46:39"
          },
          {
            "ticket_id": 10878,
            "ticket_number": "3510866",
            "title": "Grupo Caraibas",
            "priority": "P2",
            "created_at": "01/03/2026 11:47:27",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 11:47:28"
          },
          {
            "ticket_id": 10880,
            "ticket_number": "3510868",
            "title": "GBN-101842 - Seu pedido foi recebido",
            "priority": "P1",
            "created_at": "01/03/2026 12:16:43",
            "close_date": "2026-03-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 23.42,
            "sla_met": false,
            "sla_breach_hours": 23.17,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 11:42:20"
          },
          {
            "ticket_id": 10881,
            "ticket_number": "3510869",
            "title": "GBN-100577 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/03/2026 12:16:44",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 23.4,
            "sla_met": false,
            "sla_breach_hours": 19.4,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:41:36"
          },
          {
            "ticket_id": 10896,
            "ticket_number": "3510884",
            "title": "IFTHENPAY - Pagamento Efetuado: ID 1458f46659d44e8",
            "priority": "P2",
            "created_at": "01/03/2026 14:53:44",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 17:09:23"
          },
          {
            "ticket_id": 10897,
            "ticket_number": "3510885",
            "title": "Código para cerrar reserva a Viva Porto de Galinha",
            "priority": "P2",
            "created_at": "01/03/2026 14:53:46",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 17:04:45"
          },
          {
            "ticket_id": 10908,
            "ticket_number": "3510896",
            "title": "Alteração nomes - Solferias - 432995 / 2026",
            "priority": "P2",
            "created_at": "01/03/2026 17:56:39",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 17:56:40"
          },
          {
            "ticket_id": 10918,
            "ticket_number": "3510906",
            "title": "[Pedido de Grupo] Zanzibar - 2026-08-20 a 2026-08-",
            "priority": "P2",
            "created_at": "01/03/2026 19:16:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 19:16:23"
          },
          {
            "ticket_id": 10919,
            "ticket_number": "3510907",
            "title": "[Pedido de Grupo] Maldivas - 2026-08-19 a 2026-08-",
            "priority": "P2",
            "created_at": "01/03/2026 19:19:55",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 19:19:56"
          },
          {
            "ticket_id": 10920,
            "ticket_number": "3510908",
            "title": "IFTHENPAY - Pagamento Efetuado: ID 8ba2638f42d64a3",
            "priority": "P2",
            "created_at": "01/03/2026 19:23:51",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 20:54:53"
          },
          {
            "ticket_id": 10922,
            "ticket_number": "3510910",
            "title": "Cancelamento de reserva Soltrópico",
            "priority": "P2",
            "created_at": "01/03/2026 19:24:00",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 19:24:00"
          },
          {
            "ticket_id": 10923,
            "ticket_number": "3510911",
            "title": "Ideia partilhada  China BTL",
            "priority": "P2",
            "created_at": "01/03/2026 19:24:02",
            "close_date": "2026-03-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 20:52:19"
          },
          {
            "ticket_id": 10944,
            "ticket_number": "3510932",
            "title": "REMINDER: Dados de Passaporte - nosso File 425077",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:37",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.65,
            "sla_met": false,
            "sla_breach_hours": 1.65,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:36:23"
          },
          {
            "ticket_id": 10949,
            "ticket_number": "3510937",
            "title": "Pedido de orçamento grupo - travelplan",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:50",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:56:50"
          },
          {
            "ticket_id": 10952,
            "ticket_number": "3510940",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:56",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.95,
            "sla_met": false,
            "sla_breach_hours": 1.95,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:54:06"
          },
          {
            "ticket_id": 10955,
            "ticket_number": "3510943",
            "title": "Pedido de orçamento grupo - soltropico",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:06",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:06"
          },
          {
            "ticket_id": 10956,
            "ticket_number": "3510944",
            "title": "Reserva LePLan 604505099 - adicionar suplemento",
            "priority": "P2",
            "created_at": "02/03/2026 09:57:09",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:57:10"
          },
          {
            "ticket_id": 11000,
            "ticket_number": "3510988",
            "title": "Confirmação de Reserva * File 432585",
            "priority": "P2",
            "created_at": "02/03/2026 11:01:59",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:34:15"
          },
          {
            "ticket_id": 11001,
            "ticket_number": "3510989",
            "title": "Fwd: Prolongamento Campanha Especial BTL com até 2",
            "priority": "P2",
            "created_at": "02/03/2026 11:02:02",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:02:02"
          },
          {
            "ticket_id": 11013,
            "ticket_number": "3511001",
            "title": "TRP-2026-03997 - apagar please",
            "priority": "P2",
            "created_at": "02/03/2026 11:27:44",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:27:44"
          },
          {
            "ticket_id": 11014,
            "ticket_number": "3511002",
            "title": "TRP-2026-03998",
            "priority": "P2",
            "created_at": "02/03/2026 11:27:46",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:27:46"
          },
          {
            "ticket_id": 11017,
            "ticket_number": "3511005",
            "title": "[Pedido de Grupo] RIVIERA MAYA- Catalonia Playa Ma",
            "priority": "P2",
            "created_at": "02/03/2026 11:44:55",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:44:55"
          },
          {
            "ticket_id": 11019,
            "ticket_number": "3511007",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "02/03/2026 12:00:49",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:16:07"
          },
          {
            "ticket_id": 11036,
            "ticket_number": "3511024",
            "title": "Orçamento Djerba",
            "priority": "P2",
            "created_at": "02/03/2026 12:28:59",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 16:06:26"
          },
          {
            "ticket_id": 11037,
            "ticket_number": "3511025",
            "title": "CORREÇÃO NOME PASSAGEIRO - LOCALIZADOR NEWBLUE: 61",
            "priority": "P2",
            "created_at": "02/03/2026 12:29:00",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:29:00"
          },
          {
            "ticket_id": 11042,
            "ticket_number": "3511030",
            "title": "GBN-91559 - Falta pagamento ao Operador",
            "priority": "P2",
            "created_at": "02/03/2026 12:53:08",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:53:09"
          },
          {
            "ticket_id": 11043,
            "ticket_number": "3511031",
            "title": "Confirmação de Reserva * File 433259",
            "priority": "P2",
            "created_at": "02/03/2026 13:14:07",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:02:39"
          },
          {
            "ticket_id": 11050,
            "ticket_number": "3511038",
            "title": "Informação de reserva - SPT002601597874",
            "priority": "P2",
            "created_at": "02/03/2026 14:17:13",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:25:31"
          },
          {
            "ticket_id": 11055,
            "ticket_number": "3511043",
            "title": "Tempo - Islândia – Terra das Luzes do Norte",
            "priority": "P2",
            "created_at": "02/03/2026 15:34:28",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:34:28"
          },
          {
            "ticket_id": 11062,
            "ticket_number": "3511050",
            "title": "Re: 2024-202-00000245 (Francisco Góis)",
            "priority": "P2",
            "created_at": "02/03/2026 16:45:57",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 20:43:08"
          },
          {
            "ticket_id": 11073,
            "ticket_number": "3511061",
            "title": "Canadá - Desconto 65€ - Reservas até 25 Março",
            "priority": "P2",
            "created_at": "02/03/2026 17:47:33",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:48:30"
          },
          {
            "ticket_id": 11075,
            "ticket_number": "3511063",
            "title": "EMISSÃO URGENTE com a TP para SID ----- SPT0026015",
            "priority": "P2",
            "created_at": "02/03/2026 17:47:37",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:57:34"
          },
          {
            "ticket_id": 11077,
            "ticket_number": "3511065",
            "title": "[Cancelamento Viagem] TRP-2026-02871 - Alexandra M",
            "priority": "P2",
            "created_at": "02/03/2026 17:51:26",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:51:26"
          },
          {
            "ticket_id": 11086,
            "ticket_number": "3511074",
            "title": "Almuerzos+Flamenco en Sevilla",
            "priority": "P2",
            "created_at": "02/03/2026 18:52:41",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:43:24"
          },
          {
            "ticket_id": 11087,
            "ticket_number": "3511075",
            "title": "CORAZUL - Férias ideais para Familias e Amigos!",
            "priority": "P2",
            "created_at": "02/03/2026 18:52:49",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:59:54"
          },
          {
            "ticket_id": 11096,
            "ticket_number": "3511084",
            "title": "Re:[## 33556 ##] GBN-109138 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "02/03/2026 21:10:11",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:01:18"
          },
          {
            "ticket_id": 11106,
            "ticket_number": "3511094",
            "title": "Re:[## 32177 ##] GBN-98313 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/03/2026 21:53:41",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 13.52,
            "sla_met": false,
            "sla_breach_hours": 9.52,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 11:24:58"
          },
          {
            "ticket_id": 11136,
            "ticket_number": "3511124",
            "title": "Informação importante sobre a tua reserva 1775938",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:15",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 4.38,
            "sla_met": false,
            "sla_breach_hours": 0.38,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:24:15"
          },
          {
            "ticket_id": 11137,
            "ticket_number": "3511125",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:18",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 4.42,
            "sla_met": false,
            "sla_breach_hours": 0.42,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:26:57"
          },
          {
            "ticket_id": 11138,
            "ticket_number": "3511126",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60457059",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:19",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 8.58,
            "sla_met": false,
            "sla_breach_hours": 4.58,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:36:52"
          },
          {
            "ticket_id": 11142,
            "ticket_number": "3511130",
            "title": "604497855****************MUY URGENTE**************",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:27",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:39:48"
          },
          {
            "ticket_id": 11152,
            "ticket_number": "3511140",
            "title": "URGENTE Confirmação de reserva 340915 ### TIME LIM",
            "priority": "P1",
            "created_at": "03/03/2026 11:11:56",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 11:24:19"
          },
          {
            "ticket_id": 11153,
            "ticket_number": "3511141",
            "title": "Fwd: J23E4D | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "03/03/2026 11:11:59",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 11:12:00"
          },
          {
            "ticket_id": 11154,
            "ticket_number": "3511142",
            "title": "Confirmação de reserva 341510### TIME LIMIT EMISSÃ",
            "priority": "P1",
            "created_at": "03/03/2026 11:12:02",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 11:24:19"
          },
          {
            "ticket_id": 11161,
            "ticket_number": "3511149",
            "title": "Envio de documentos de File 432585 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "03/03/2026 11:51:44",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 11:58:48"
          },
          {
            "ticket_id": 11163,
            "ticket_number": "3511151",
            "title": "RE: 425327 ** recebemos UN voo paar 03MAR",
            "priority": "P2",
            "created_at": "03/03/2026 12:03:07",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:26:38"
          },
          {
            "ticket_id": 11172,
            "ticket_number": "3511160",
            "title": "[Pedido de Grupo] Malta - 2026-08-19 a 2026-08-26 ",
            "priority": "P2",
            "created_at": "03/03/2026 12:48:49",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:48:50"
          },
          {
            "ticket_id": 11174,
            "ticket_number": "3511162",
            "title": "Fwd: Informações da reserva TTN-1245083433#9421975",
            "priority": "P2",
            "created_at": "03/03/2026 13:02:16",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:02:17"
          },
          {
            "ticket_id": 11175,
            "ticket_number": "3511163",
            "title": "Cancelar reserva",
            "priority": "P2",
            "created_at": "03/03/2026 13:02:19",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:02:19"
          },
          {
            "ticket_id": 11186,
            "ticket_number": "3511174",
            "title": "ALTERAÇÃO DE HORÁRIO DE VOO - FILE   604570592",
            "priority": "P2",
            "created_at": "03/03/2026 13:40:50",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 79.23,
            "sla_met": false,
            "sla_breach_hours": 75.23,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:55:36"
          },
          {
            "ticket_id": 11188,
            "ticket_number": "3511176",
            "title": "Envio de documentos de File 432870 - VOOS EMITIDOS",
            "priority": "P2",
            "created_at": "03/03/2026 13:40:54",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:31:09"
          },
          {
            "ticket_id": 11193,
            "ticket_number": "3511181",
            "title": "[Suporte] TRP-2026-03441 - Alteração de hotel no t",
            "priority": "P2",
            "created_at": "03/03/2026 13:50:08",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:50:08"
          },
          {
            "ticket_id": 11200,
            "ticket_number": "3511188",
            "title": "GBN-101852 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:04",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 411.53,
            "sla_met": false,
            "sla_breach_hours": 407.53,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:32:43"
          },
          {
            "ticket_id": 11201,
            "ticket_number": "3511189",
            "title": "GBN-101842 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:06",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1038.12,
            "sla_met": false,
            "sla_breach_hours": 1034.12,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 21:08:02"
          },
          {
            "ticket_id": 11203,
            "ticket_number": "3511191",
            "title": "Pagamentos Cuba/Punta Cana",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:10",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:00:10"
          },
          {
            "ticket_id": 11204,
            "ticket_number": "3511192",
            "title": "Cancelamento de reserva/ seguro",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:12",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:00:12"
          },
          {
            "ticket_id": 11221,
            "ticket_number": "3511209",
            "title": "Confirmação de Reserva File 432870/26 c/mala porao",
            "priority": "P2",
            "created_at": "03/03/2026 16:52:56",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:02:45"
          },
          {
            "ticket_id": 11222,
            "ticket_number": "3511210",
            "title": "GBN-91048 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 16:52:58",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 20:40:35"
          },
          {
            "ticket_id": 11224,
            "ticket_number": "3511212",
            "title": "GBN-108902 - Dados passageiros",
            "priority": "P2",
            "created_at": "03/03/2026 16:53:03",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:53:04"
          },
          {
            "ticket_id": 11226,
            "ticket_number": "3511214",
            "title": "Envio de documentação - FILE 415384",
            "priority": "P2",
            "created_at": "03/03/2026 16:53:16",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:29:18"
          },
          {
            "ticket_id": 11227,
            "ticket_number": "3511215",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "03/03/2026 16:53:18",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:53:19"
          },
          {
            "ticket_id": 11232,
            "ticket_number": "3511220",
            "title": "Fwd: Informações da reserva TTN-1237097189#9478717",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:06",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:42:07"
          },
          {
            "ticket_id": 11233,
            "ticket_number": "3511221",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:09",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:42:10"
          },
          {
            "ticket_id": 11234,
            "ticket_number": "3511222",
            "title": "GBN-108902 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:12",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 21:40:41"
          },
          {
            "ticket_id": 11236,
            "ticket_number": "3511224",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:17",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:42:18"
          },
          {
            "ticket_id": 11254,
            "ticket_number": "3511242",
            "title": "Icarion - localizador 7003721 - Safari Express & Z",
            "priority": "P2",
            "created_at": "03/03/2026 18:27:00",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:27:00"
          },
          {
            "ticket_id": 11256,
            "ticket_number": "3511244",
            "title": "RE: Verificação de comissões",
            "priority": "P2",
            "created_at": "03/03/2026 18:38:13",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 16.75,
            "sla_met": false,
            "sla_breach_hours": 12.75,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:23:29"
          },
          {
            "ticket_id": 11287,
            "ticket_number": "3511275",
            "title": "Re: Pedido de cotação (Magali)",
            "priority": "P2",
            "created_at": "03/03/2026 23:34:52",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 11.78,
            "sla_met": false,
            "sla_breach_hours": 7.78,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:22:40"
          },
          {
            "ticket_id": 11288,
            "ticket_number": "3511276",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "03/03/2026 23:34:58",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 12.57,
            "sla_met": false,
            "sla_breach_hours": 8.57,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:09:28"
          },
          {
            "ticket_id": 11291,
            "ticket_number": "3511279",
            "title": "Reserva Soltrópico 341217 Francisco Pereira.",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:32",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:17:32"
          },
          {
            "ticket_id": 11292,
            "ticket_number": "3511280",
            "title": "Documentação GBN 108984 Sara Justino",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:34",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:17:34"
          },
          {
            "ticket_id": 11296,
            "ticket_number": "3511284",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:43",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:11:22"
          },
          {
            "ticket_id": 11298,
            "ticket_number": "3511286",
            "title": "GBN-109723 - Sua reserva está pendente de pagament",
            "priority": "P3",
            "created_at": "04/03/2026 10:17:47",
            "close_date": "2026-03-04",
            "sla_target_hours": 24,
            "actual_time_hours": 8.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 19:06:54"
          },
          {
            "ticket_id": 11304,
            "ticket_number": "3511292",
            "title": "Dados Passaporte - Nortravel nº reserva 604569096",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:02",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:18:02"
          },
          {
            "ticket_id": 11310,
            "ticket_number": "3511298",
            "title": "Confirmação de reserva para For PT004157 70699224",
            "priority": "P2",
            "created_at": "04/03/2026 10:18:21",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 8.78,
            "sla_met": false,
            "sla_breach_hours": 4.78,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:05:31"
          },
          {
            "ticket_id": 11317,
            "ticket_number": "3511305",
            "title": "[Cancelamento Serviço] TRP-2026-02821 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/03/2026 11:07:02",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:07:02"
          },
          {
            "ticket_id": 11320,
            "ticket_number": "3511308",
            "title": "Reserva Anulada loc 3FC7375824",
            "priority": "P2",
            "created_at": "04/03/2026 11:33:22",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11321,
            "ticket_number": "3511309",
            "title": "Cancelação da reserva com localizador 67Q5H8V3AH",
            "priority": "P2",
            "created_at": "04/03/2026 11:33:25",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:49:31"
          },
          {
            "ticket_id": 11326,
            "ticket_number": "3511314",
            "title": "Cancelação da reserva com localizador 2E7X6H7864",
            "priority": "P2",
            "created_at": "04/03/2026 11:33:39",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:51:36"
          },
          {
            "ticket_id": 11327,
            "ticket_number": "3511315",
            "title": "Confirmação de reserva 341268",
            "priority": "P2",
            "created_at": "04/03/2026 11:33:41",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 15:22:18"
          },
          {
            "ticket_id": 11338,
            "ticket_number": "3511326",
            "title": "[Cancelamento Serviço] TRP-2026-03821 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/03/2026 11:59:39",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:59:39"
          },
          {
            "ticket_id": 11353,
            "ticket_number": "3511341",
            "title": "RE: Pagamento 6137961",
            "priority": "P2",
            "created_at": "04/03/2026 12:35:38",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:52:00"
          },
          {
            "ticket_id": 11356,
            "ticket_number": "3511344",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "04/03/2026 12:35:44",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:22:28"
          },
          {
            "ticket_id": 11357,
            "ticket_number": "3511345",
            "title": "RE: Grupo - Djerba (Ana Rodrigues)*6340978",
            "priority": "P2",
            "created_at": "04/03/2026 12:35:46",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:22:28"
          },
          {
            "ticket_id": 11362,
            "ticket_number": "3511350",
            "title": "viagem em falta no cockpit",
            "priority": "P3",
            "created_at": "04/03/2026 12:43:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 12:43:39"
          },
          {
            "ticket_id": 11369,
            "ticket_number": "3511357",
            "title": "CORREÇÃO NOM3E PASSAGEIRO NEWBLUE: RESERVA: 613953",
            "priority": "P2",
            "created_at": "04/03/2026 13:20:45",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:20:45"
          },
          {
            "ticket_id": 11375,
            "ticket_number": "3511363",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:41:59",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:41:59"
          },
          {
            "ticket_id": 11376,
            "ticket_number": "3511364",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:04",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:04"
          },
          {
            "ticket_id": 11377,
            "ticket_number": "3511365",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:08",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:08"
          },
          {
            "ticket_id": 11379,
            "ticket_number": "3511367",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:14",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:14"
          },
          {
            "ticket_id": 11380,
            "ticket_number": "3511368",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:17",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:17"
          },
          {
            "ticket_id": 11381,
            "ticket_number": "3511369",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:20",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:20"
          },
          {
            "ticket_id": 11382,
            "ticket_number": "3511370",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:23",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:47:04"
          },
          {
            "ticket_id": 11384,
            "ticket_number": "3511372",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/03/2026 13:42:31",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:42:31"
          },
          {
            "ticket_id": 11386,
            "ticket_number": "3511374",
            "title": "Reserva cancelada com localizador: 4104552",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:21",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 4.65,
            "sla_met": false,
            "sla_breach_hours": 0.65,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:21:24"
          },
          {
            "ticket_id": 11411,
            "ticket_number": "3511399",
            "title": "RESERVA WL 341295",
            "priority": "P2",
            "created_at": "04/03/2026 16:31:40",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:56:37"
          },
          {
            "ticket_id": 11414,
            "ticket_number": "3511402",
            "title": "Reserva GBN-109427 | confirmação de voos",
            "priority": "P2",
            "created_at": "04/03/2026 16:59:42",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:59:42"
          },
          {
            "ticket_id": 11415,
            "ticket_number": "3511403",
            "title": "Usuários e código Veturis e Restel",
            "priority": "P2",
            "created_at": "04/03/2026 16:59:44",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:59:44"
          },
          {
            "ticket_id": 11430,
            "ticket_number": "3511418",
            "title": "Envio de Nota de Crédito   27426  /26",
            "priority": "P2",
            "created_at": "04/03/2026 17:39:24",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 18:22:18"
          },
          {
            "ticket_id": 11432,
            "ticket_number": "3511420",
            "title": "Fwd: Incidente de voo TTN-1223362854#94966152#T182",
            "priority": "P2",
            "created_at": "04/03/2026 17:55:59",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:55:59"
          },
          {
            "ticket_id": 11433,
            "ticket_number": "3511421",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "04/03/2026 18:08:25",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 18:11:13"
          },
          {
            "ticket_id": 11435,
            "ticket_number": "3511423",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "04/03/2026 18:08:30",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 18:12:30"
          },
          {
            "ticket_id": 11437,
            "ticket_number": "3511425",
            "title": "Débito direto",
            "priority": "P2",
            "created_at": "04/03/2026 18:35:02",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 18:35:02"
          },
          {
            "ticket_id": 11438,
            "ticket_number": "3511426",
            "title": "Confirmação de Reserva * File 432995 *Nomes Retifi",
            "priority": "P2",
            "created_at": "04/03/2026 18:35:09",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 18:41:46"
          },
          {
            "ticket_id": 11443,
            "ticket_number": "3511431",
            "title": "Alteração de horários Ilha do Sal TAP 338488 Porto",
            "priority": "P2",
            "created_at": "04/03/2026 19:15:39",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:17:57"
          },
          {
            "ticket_id": 11599,
            "ticket_number": "3511587",
            "title": "Confirmação de reserva com localizador: 4107695",
            "priority": "P2",
            "created_at": "05/03/2026 23:59:32",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 10.5,
            "sla_met": false,
            "sla_breach_hours": 6.5,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:30:08"
          },
          {
            "ticket_id": 11600,
            "ticket_number": "3511588",
            "title": "Criação de processo File 434053/26",
            "priority": "P2",
            "created_at": "05/03/2026 23:59:39",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 10.88,
            "sla_met": false,
            "sla_breach_hours": 6.88,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:53:06"
          },
          {
            "ticket_id": 11630,
            "ticket_number": "3511618",
            "title": "Documentação Disponível - Reserva 339057",
            "priority": "P2",
            "created_at": "06/03/2026 12:16:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:10:52"
          },
          {
            "ticket_id": 11632,
            "ticket_number": "3511620",
            "title": "Informações para cadastro como consultor de viagen",
            "priority": "P3",
            "created_at": "06/03/2026 12:26:51",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 13:06:54"
          },
          {
            "ticket_id": 11634,
            "ticket_number": "3511622",
            "title": "GBN-101091 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/03/2026 12:40:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 10:01:47"
          },
          {
            "ticket_id": 11636,
            "ticket_number": "3511624",
            "title": "File 39720 - Simoes/LuisManuelLopesMR - Pacote (S.",
            "priority": "P2",
            "created_at": "06/03/2026 12:48:24",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:12:24"
          },
          {
            "ticket_id": 11680,
            "ticket_number": "3511668",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:23",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.88,
            "sla_met": false,
            "sla_breach_hours": 1.88,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:32:36"
          },
          {
            "ticket_id": 11721,
            "ticket_number": "3511709",
            "title": "Re: Pedido de cotação",
            "priority": "P2",
            "created_at": "06/03/2026 19:46:31",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:05:34"
          },
          {
            "ticket_id": 11821,
            "ticket_number": "3511809",
            "title": "[Suporte] TRP-2026-04021 - Cancelamento",
            "priority": "P2",
            "created_at": "07/03/2026 22:06:40",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 22:06:40"
          },
          {
            "ticket_id": 11836,
            "ticket_number": "3511824",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:27",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11953,
            "ticket_number": "3511941",
            "title": "Informação de reserva - SPT002601601307",
            "priority": "P2",
            "created_at": "09/03/2026 14:02:37",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 17:25:24"
          },
          {
            "ticket_id": 11972,
            "ticket_number": "3511960",
            "title": "URGENTE Confirmação de reserva 342069 ### TIME LIM",
            "priority": "P2",
            "created_at": "09/03/2026 15:59:01",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:24:49"
          },
          {
            "ticket_id": 11974,
            "ticket_number": "3511962",
            "title": "Informação de reserva - SPT002601604008",
            "priority": "P2",
            "created_at": "09/03/2026 15:59:13",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:11:50"
          },
          {
            "ticket_id": 11975,
            "ticket_number": "3511963",
            "title": "hotel por confirmar",
            "priority": "P2",
            "created_at": "09/03/2026 16:16:48",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:16:48"
          },
          {
            "ticket_id": 12071,
            "ticket_number": "3512059",
            "title": "GBN-94286 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:36",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 12:56:00"
          },
          {
            "ticket_id": 12083,
            "ticket_number": "3512071",
            "title": "Login / Senha para aquisição de Atividades na Odis",
            "priority": "P2",
            "created_at": "10/03/2026 15:51:00",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:51:01"
          },
          {
            "ticket_id": 12097,
            "ticket_number": "3512085",
            "title": "Acessos Veturis",
            "priority": "P2",
            "created_at": "10/03/2026 17:59:20",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:59:21"
          },
          {
            "ticket_id": 12117,
            "ticket_number": "3512105",
            "title": "Reserva cancelada com localizador: 4107209",
            "priority": "P2",
            "created_at": "10/03/2026 21:52:24",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 12.75,
            "sla_met": false,
            "sla_breach_hours": 8.75,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:38:15"
          },
          {
            "ticket_id": 12142,
            "ticket_number": "3512130",
            "title": "CANCELAMENTO DE RESERVA - Viagify informa sobre a ",
            "priority": "P2",
            "created_at": "11/03/2026 10:01:49",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:24:10"
          },
          {
            "ticket_id": 12144,
            "ticket_number": "3512132",
            "title": "veturis",
            "priority": "P2",
            "created_at": "11/03/2026 10:01:55",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:01:55"
          },
          {
            "ticket_id": 12150,
            "ticket_number": "3512138",
            "title": "Fwd: Viagify informa sobre a sua reserva 125843942",
            "priority": "P2",
            "created_at": "11/03/2026 10:09:24",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:09:25"
          },
          {
            "ticket_id": 12153,
            "ticket_number": "3512141",
            "title": "Fwd: Viagify informa sobre a sua reserva 125839317",
            "priority": "P2",
            "created_at": "11/03/2026 10:09:49",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:09:50"
          },
          {
            "ticket_id": 12154,
            "ticket_number": "3512142",
            "title": "Fwd: Viagify informa sobre a sua reserva 125839317",
            "priority": "P2",
            "created_at": "11/03/2026 10:10:54",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:10:55"
          },
          {
            "ticket_id": 12156,
            "ticket_number": "3512144",
            "title": "Fwd: Viagify informa sobre a sua reserva 125838753",
            "priority": "P2",
            "created_at": "11/03/2026 10:11:01",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:09:29"
          },
          {
            "ticket_id": 12158,
            "ticket_number": "3512146",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "11/03/2026 10:48:26",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 11:19:50"
          },
          {
            "ticket_id": 12169,
            "ticket_number": "3512157",
            "title": "Re:[## 32597 ##] GBN-106687 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "11/03/2026 11:35:58",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 13:13:03"
          },
          {
            "ticket_id": 12175,
            "ticket_number": "3512163",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "11/03/2026 12:40:22",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 12:40:23"
          },
          {
            "ticket_id": 12177,
            "ticket_number": "3512165",
            "title": "Fwd: Informações da reserva TTN-1256044365#9567447",
            "priority": "P2",
            "created_at": "11/03/2026 12:40:29",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 12:40:29"
          },
          {
            "ticket_id": 12189,
            "ticket_number": "3512177",
            "title": "Incidente de voo TTN-1252218555#95440000#T18362417",
            "priority": "P2",
            "created_at": "11/03/2026 13:34:05",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 13:34:09"
          },
          {
            "ticket_id": 12192,
            "ticket_number": "3512180",
            "title": "Informação de reserva - SPT002601600279",
            "priority": "P2",
            "created_at": "11/03/2026 13:34:30",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 14:10:30"
          },
          {
            "ticket_id": 12199,
            "ticket_number": "3512187",
            "title": "Urgente: reserva Soltour SPT002601585681 a 16/03 a",
            "priority": "P2",
            "created_at": "11/03/2026 13:41:17",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 13:41:18"
          },
          {
            "ticket_id": 12208,
            "ticket_number": "3512196",
            "title": "GBN-109723 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/03/2026 14:27:43",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 11:49:15"
          },
          {
            "ticket_id": 12210,
            "ticket_number": "3512198",
            "title": "New Blue - 6131115 SAL",
            "priority": "P3",
            "created_at": "11/03/2026 14:30:52",
            "close_date": "2026-03-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/03/2026 14:30:52"
          },
          {
            "ticket_id": 12217,
            "ticket_number": "3512205",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "11/03/2026 16:02:20",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 16:44:07"
          },
          {
            "ticket_id": 12220,
            "ticket_number": "3512208",
            "title": "Eticket -  - MU  04/04/2026  Funchal, Portugal Cab",
            "priority": "P2",
            "created_at": "11/03/2026 16:02:33",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 10:26:53"
          },
          {
            "ticket_id": 12223,
            "ticket_number": "3512211",
            "title": "Número de informação da reserva: 6141384",
            "priority": "P2",
            "created_at": "11/03/2026 16:02:44",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 16:46:25"
          },
          {
            "ticket_id": 12226,
            "ticket_number": "3512214",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "11/03/2026 16:04:15",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 17:12:01"
          },
          {
            "ticket_id": 12241,
            "ticket_number": "3512229",
            "title": "Anulacao da subscrição",
            "priority": "P2",
            "created_at": "11/03/2026 17:59:44",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 17:59:44"
          },
          {
            "ticket_id": 12243,
            "ticket_number": "3512231",
            "title": "URGENTE URGENTE: SPT002601592868 - RECONFIRMAÇÃO D",
            "priority": "P2",
            "created_at": "11/03/2026 18:08:11",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 18:36:12"
          },
          {
            "ticket_id": 12244,
            "ticket_number": "3512232",
            "title": "EMISSÃO URGENTE para SDQ com a UX ----- SPT0026016",
            "priority": "P2",
            "created_at": "11/03/2026 18:08:13",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 18:21:10"
          },
          {
            "ticket_id": 12249,
            "ticket_number": "3512237",
            "title": "Pedido acessos ao Airmet",
            "priority": "P2",
            "created_at": "11/03/2026 18:18:10",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 18:18:11"
          },
          {
            "ticket_id": 12254,
            "ticket_number": "3512242",
            "title": "Acessos Consolidador",
            "priority": "P2",
            "created_at": "11/03/2026 18:19:43",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 18:19:43"
          },
          {
            "ticket_id": 12270,
            "ticket_number": "3512258",
            "title": "Eticket - 66829878 - MU  04/04/2026  Funchal, Port",
            "priority": "P2",
            "created_at": "11/03/2026 19:15:35",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 19:16:21"
          },
          {
            "ticket_id": 12311,
            "ticket_number": "3512299",
            "title": "[Cancelamento Viagem] TRP-2026-03177 - Miguel Lope",
            "priority": "P2",
            "created_at": "11/03/2026 23:16:38",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:16:39"
          },
          {
            "ticket_id": 12347,
            "ticket_number": "3512335",
            "title": "Desligamento/cancelamento",
            "priority": "P2",
            "created_at": "12/03/2026 11:30:18",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:23:05"
          },
          {
            "ticket_id": 12405,
            "ticket_number": "3512393",
            "title": "Cancelamento de reserva 337068",
            "priority": "P2",
            "created_at": "12/03/2026 19:11:48",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:26:18"
          },
          {
            "ticket_id": 12406,
            "ticket_number": "3512394",
            "title": "Cancelamento de reserva 341995",
            "priority": "P2",
            "created_at": "12/03/2026 19:11:49",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:26:34"
          },
          {
            "ticket_id": 12410,
            "ticket_number": "3512398",
            "title": "Fwd: Informações sobre a sua reserva TTN-113302023",
            "priority": "P2",
            "created_at": "12/03/2026 19:21:26",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 19:21:27"
          },
          {
            "ticket_id": 12415,
            "ticket_number": "3512403",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "12/03/2026 19:47:31",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 20:04:24"
          },
          {
            "ticket_id": 12420,
            "ticket_number": "3512408",
            "title": "Important update on your flight",
            "priority": "P2",
            "created_at": "12/03/2026 20:16:12",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 23:38:11"
          },
          {
            "ticket_id": 12430,
            "ticket_number": "3512418",
            "title": "[Suporte] TRP-2026-04135 / TRL-2026-06261 - Inform",
            "priority": "P2",
            "created_at": "12/03/2026 21:16:55",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 21:16:55"
          },
          {
            "ticket_id": 12431,
            "ticket_number": "3512419",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "12/03/2026 22:03:19",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 23:48:15"
          },
          {
            "ticket_id": 12432,
            "ticket_number": "3512420",
            "title": "| Urgente: reserva Soltour SPT002601585681 |",
            "priority": "P2",
            "created_at": "12/03/2026 22:03:23",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 22:03:24"
          },
          {
            "ticket_id": 12433,
            "ticket_number": "3512421",
            "title": "GBN-111613 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/03/2026 22:03:44",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 20:28:41"
          },
          {
            "ticket_id": 12448,
            "ticket_number": "3512436",
            "title": "Confirmação de Reserva * File 435113 - EMISSÃO HOJ",
            "priority": "P2",
            "created_at": "13/03/2026 10:05:37",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:27:11"
          },
          {
            "ticket_id": 12449,
            "ticket_number": "3512437",
            "title": "MSC Cruises Document - 2600101001904312",
            "priority": "P2",
            "created_at": "13/03/2026 10:05:40",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:50:25"
          },
          {
            "ticket_id": 12460,
            "ticket_number": "3512448",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "13/03/2026 10:06:13",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:32:15"
          },
          {
            "ticket_id": 12464,
            "ticket_number": "3512452",
            "title": "Fwd: Tudo o que você precisa saber antes de voar p",
            "priority": "P2",
            "created_at": "13/03/2026 10:24:05",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:24:05"
          },
          {
            "ticket_id": 12466,
            "ticket_number": "3512454",
            "title": "Fwd: Tudo o que você precisa saber antes de voar p",
            "priority": "P2",
            "created_at": "13/03/2026 10:24:13",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:24:14"
          },
          {
            "ticket_id": 12469,
            "ticket_number": "3512457",
            "title": "Fwd: Tudo o que você precisa saber antes de voar p",
            "priority": "P2",
            "created_at": "13/03/2026 10:24:27",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:24:28"
          },
          {
            "ticket_id": 12470,
            "ticket_number": "3512458",
            "title": "Fwd: Tudo o que você precisa saber antes de voar p",
            "priority": "P2",
            "created_at": "13/03/2026 10:24:31",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:24:31"
          },
          {
            "ticket_id": 12471,
            "ticket_number": "3512459",
            "title": "Fwd: Viagify informa sobre a sua reserva 125743831",
            "priority": "P2",
            "created_at": "13/03/2026 10:24:34",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:24:35"
          },
          {
            "ticket_id": 12480,
            "ticket_number": "3512468",
            "title": "Icárion - Maldivas - Divisão de Estadia (Quartos) ",
            "priority": "P2",
            "created_at": "13/03/2026 12:48:02",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 13:03:30"
          },
          {
            "ticket_id": 12486,
            "ticket_number": "3512474",
            "title": "[Cancelamento Serviço] TRP-2026-03881 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/03/2026 14:48:33",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 14:48:33"
          },
          {
            "ticket_id": 12487,
            "ticket_number": "3512475",
            "title": "[Cancelamento Serviço] TRP-2026-03881 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/03/2026 14:49:12",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 14:49:13"
          },
          {
            "ticket_id": 12496,
            "ticket_number": "3512484",
            "title": "TRP-2026-03917 | Revisão de valor NET - Loc 604571",
            "priority": "P2",
            "created_at": "13/03/2026 15:18:29",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 15:18:29"
          },
          {
            "ticket_id": 12498,
            "ticket_number": "3512486",
            "title": "Envio de Fatura - File 435113/26",
            "priority": "P2",
            "created_at": "13/03/2026 15:41:30",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:41:53"
          },
          {
            "ticket_id": 12499,
            "ticket_number": "3512487",
            "title": "Envio de Fatura 213426",
            "priority": "P2",
            "created_at": "13/03/2026 16:15:32",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 17:23:50"
          },
          {
            "ticket_id": 12518,
            "ticket_number": "3512506",
            "title": "[Cancelamento Viagem] TRP-2026-04268 - LUISA LEAO ",
            "priority": "P2",
            "created_at": "13/03/2026 16:58:46",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:58:47"
          },
          {
            "ticket_id": 12519,
            "ticket_number": "3512507",
            "title": "MUITO URGENTE Confirmação de reserva 342550 ### TI",
            "priority": "P2",
            "created_at": "13/03/2026 17:09:14",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 17:15:54"
          },
          {
            "ticket_id": 12581,
            "ticket_number": "3512569",
            "title": "Alteração iban",
            "priority": "P3",
            "created_at": "14/03/2026 10:21:31",
            "close_date": "2026-05-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/03/2026 10:21:32"
          },
          {
            "ticket_id": 12582,
            "ticket_number": "3512570",
            "title": "Iban comissões",
            "priority": "P1",
            "created_at": "14/03/2026 10:21:59",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/03/2026 10:21:59"
          },
          {
            "ticket_id": 12591,
            "ticket_number": "3512579",
            "title": "RE: Overcomission 6141876 W2MCS:015740002620",
            "priority": "P2",
            "created_at": "14/03/2026 12:57:49",
            "close_date": "2026-03-15",
            "sla_target_hours": 4,
            "actual_time_hours": 24.8,
            "sla_met": false,
            "sla_breach_hours": 20.8,
            "sla_name": "SLA P2",
            "first_response_at": "15/03/2026 13:46:45"
          },
          {
            "ticket_id": 12609,
            "ticket_number": "3512597",
            "title": "Agendar reunião",
            "priority": "P2",
            "created_at": "14/03/2026 16:40:36",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 47.23,
            "sla_met": false,
            "sla_breach_hours": 43.23,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 15:55:08"
          },
          {
            "ticket_id": 12658,
            "ticket_number": "3512646",
            "title": "Acesso operador",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:58",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:58"
          },
          {
            "ticket_id": 12668,
            "ticket_number": "3512656",
            "title": "GBN-100480 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 10:09:08",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12695,
            "ticket_number": "3512683",
            "title": "Rescisão de Contrato de Prestação de Serviços",
            "priority": "P2",
            "created_at": "16/03/2026 10:10:23",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:36"
          },
          {
            "ticket_id": 12708,
            "ticket_number": "3512696",
            "title": "IBEROSTAR | Caça Aos Ovos",
            "priority": "P2",
            "created_at": "16/03/2026 13:05:39",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:00:06"
          },
          {
            "ticket_id": 12734,
            "ticket_number": "3512722",
            "title": "Acesso ao consolidador",
            "priority": "P2",
            "created_at": "16/03/2026 14:07:09",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:07:10"
          },
          {
            "ticket_id": 12738,
            "ticket_number": "3512726",
            "title": "Credenciais consolidador",
            "priority": "P2",
            "created_at": "16/03/2026 14:07:19",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:07:19"
          },
          {
            "ticket_id": 12739,
            "ticket_number": "3512727",
            "title": "Informação de reserva - SPT002601608022",
            "priority": "P2",
            "created_at": "16/03/2026 14:08:17",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:15:46"
          },
          {
            "ticket_id": 12740,
            "ticket_number": "3512728",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "16/03/2026 14:34:43",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:34:44"
          },
          {
            "ticket_id": 12747,
            "ticket_number": "3512735",
            "title": "[Cancelamento Viagem] TRP-2026-03966 - Ana Duarte ",
            "priority": "P2",
            "created_at": "16/03/2026 15:13:06",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 15:13:07"
          },
          {
            "ticket_id": 12775,
            "ticket_number": "3512763",
            "title": "Cancelamento da subscrição",
            "priority": "P2",
            "created_at": "16/03/2026 18:50:11",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 22:41:01"
          },
          {
            "ticket_id": 12778,
            "ticket_number": "3512766",
            "title": "Alteração de Data - Voucher Civitatis A37565444",
            "priority": "P2",
            "created_at": "16/03/2026 18:52:30",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 18:52:30"
          },
          {
            "ticket_id": 12779,
            "ticket_number": "3512767",
            "title": "FW: Acesso BusWay",
            "priority": "P2",
            "created_at": "16/03/2026 18:52:35",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 18:52:36"
          },
          {
            "ticket_id": 12780,
            "ticket_number": "3512768",
            "title": "Acesso BusWay",
            "priority": "P2",
            "created_at": "16/03/2026 18:52:39",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 18:52:39"
          },
          {
            "ticket_id": 12781,
            "ticket_number": "3512769",
            "title": "consolidador dados acesso",
            "priority": "P2",
            "created_at": "16/03/2026 18:53:04",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 18:53:04"
          },
          {
            "ticket_id": 12783,
            "ticket_number": "3512771",
            "title": "[Suporte] TRP-2026-04161 - Morada da fatura deform",
            "priority": "P2",
            "created_at": "16/03/2026 19:20:22",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:20:22"
          },
          {
            "ticket_id": 12786,
            "ticket_number": "3512774",
            "title": "GBN-112761 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:15",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:15"
          },
          {
            "ticket_id": 12787,
            "ticket_number": "3512775",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:23",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:23"
          },
          {
            "ticket_id": 12788,
            "ticket_number": "3512776",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:30",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:31"
          },
          {
            "ticket_id": 12789,
            "ticket_number": "3512777",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:39",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:39"
          },
          {
            "ticket_id": 12790,
            "ticket_number": "3512778",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:49",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:49"
          },
          {
            "ticket_id": 12791,
            "ticket_number": "3512779",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:50:54",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:50:54"
          },
          {
            "ticket_id": 12792,
            "ticket_number": "3512780",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:51:09",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:51:09"
          },
          {
            "ticket_id": 12793,
            "ticket_number": "3512781",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/03/2026 19:51:23",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:51:23"
          },
          {
            "ticket_id": 12803,
            "ticket_number": "3512791",
            "title": "Informação de reserva - SPT002601608965",
            "priority": "P2",
            "created_at": "16/03/2026 22:11:59",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 12.38,
            "sla_met": false,
            "sla_breach_hours": 8.38,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:35:24"
          },
          {
            "ticket_id": 12806,
            "ticket_number": "3512794",
            "title": "viajartours loc213123",
            "priority": "P2",
            "created_at": "16/03/2026 22:14:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 12.48,
            "sla_met": false,
            "sla_breach_hours": 8.48,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:43:31"
          },
          {
            "ticket_id": 12817,
            "ticket_number": "3512805",
            "title": "Informação importante sobre a tua reserva 6121533",
            "priority": "P2",
            "created_at": "17/03/2026 10:08:05",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:29:19"
          },
          {
            "ticket_id": 12818,
            "ticket_number": "3512806",
            "title": "Informação importante sobre a tua reserva 6121540",
            "priority": "P2",
            "created_at": "17/03/2026 10:08:07",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:29:46"
          },
          {
            "ticket_id": 12819,
            "ticket_number": "3512807",
            "title": "Informação importante sobre a tua reserva 6121537",
            "priority": "P2",
            "created_at": "17/03/2026 10:08:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:29:32"
          },
          {
            "ticket_id": 12820,
            "ticket_number": "3512808",
            "title": "Informação importante sobre a tua reserva 1778299",
            "priority": "P2",
            "created_at": "17/03/2026 10:08:11",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:29:53"
          },
          {
            "ticket_id": 12823,
            "ticket_number": "3512811",
            "title": "Contatos de Cliente em falta - n/File 432870",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:39:12"
          },
          {
            "ticket_id": 12832,
            "ticket_number": "3512820",
            "title": "Confirmação de reserva com localizador: 4124401",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:33",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:37:23"
          },
          {
            "ticket_id": 12835,
            "ticket_number": "3512823",
            "title": "Confirmação de reserva com localizador: 4124396",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:42",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:39:50"
          },
          {
            "ticket_id": 12836,
            "ticket_number": "3512824",
            "title": "Credenciais de acesso ao consolidador",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:09:45"
          },
          {
            "ticket_id": 12849,
            "ticket_number": "3512837",
            "title": "2ª VIA - Confirmação de Reserva n. 10047103 - UMA ",
            "priority": "P2",
            "created_at": "17/03/2026 11:36:53",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:08:37"
          },
          {
            "ticket_id": 12854,
            "ticket_number": "3512842",
            "title": "Confirmação de reserva 342724",
            "priority": "P2",
            "created_at": "17/03/2026 12:17:34",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 12:23:40"
          },
          {
            "ticket_id": 12857,
            "ticket_number": "3512845",
            "title": "Documentação Disponível - Reserva 338488",
            "priority": "P2",
            "created_at": "17/03/2026 12:35:45",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 12:39:44"
          },
          {
            "ticket_id": 12956,
            "ticket_number": "3512944",
            "title": "Reserva 24101541 - Soltrópico",
            "priority": "P2",
            "created_at": "18/03/2026 10:11:33",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:11:34"
          },
          {
            "ticket_id": 12962,
            "ticket_number": "3512950",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:05",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:43:39"
          },
          {
            "ticket_id": 12963,
            "ticket_number": "3512951",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:06",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:47:02"
          },
          {
            "ticket_id": 12964,
            "ticket_number": "3512952",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:41:32"
          },
          {
            "ticket_id": 12965,
            "ticket_number": "3512953",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:10",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:25:27"
          },
          {
            "ticket_id": 12966,
            "ticket_number": "3512954",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:42:32"
          },
          {
            "ticket_id": 12968,
            "ticket_number": "3512956",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:35",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:45:35"
          },
          {
            "ticket_id": 12970,
            "ticket_number": "3512958",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:39",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 10:45:39"
          },
          {
            "ticket_id": 12973,
            "ticket_number": "3512961",
            "title": "Informação de reserva - SPT002601609345",
            "priority": "P2",
            "created_at": "18/03/2026 10:53:15",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:42:21"
          },
          {
            "ticket_id": 12974,
            "ticket_number": "3512962",
            "title": "Informação de reserva - SPT002601609345",
            "priority": "P2",
            "created_at": "18/03/2026 10:53:26",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:41:11"
          },
          {
            "ticket_id": 12981,
            "ticket_number": "3512969",
            "title": "Informação de reserva - SPT002601609316",
            "priority": "P2",
            "created_at": "18/03/2026 11:49:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:23:19"
          },
          {
            "ticket_id": 12984,
            "ticket_number": "3512972",
            "title": "Informação de reserva - SPT002601609345",
            "priority": "P2",
            "created_at": "18/03/2026 12:33:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 12:55:18"
          },
          {
            "ticket_id": 12992,
            "ticket_number": "3512980",
            "title": "Informação de reserva - SPT002601609713",
            "priority": "P2",
            "created_at": "18/03/2026 13:04:52",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:14:25"
          },
          {
            "ticket_id": 13086,
            "ticket_number": "3513074",
            "title": "Eticket - 70796907 - EU  20/03/2026  Barcelona, Es",
            "priority": "P2",
            "created_at": "19/03/2026 10:04:29",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 10:35:20"
          },
          {
            "ticket_id": 13087,
            "ticket_number": "3513075",
            "title": "Confirmação de reserva. Localizador: 2TOJVMWB0E",
            "priority": "P2",
            "created_at": "19/03/2026 10:06:52",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 6.37,
            "sla_met": false,
            "sla_breach_hours": 2.37,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:29:00"
          },
          {
            "ticket_id": 13090,
            "ticket_number": "3513078",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "19/03/2026 10:51:26",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 10:51:27"
          },
          {
            "ticket_id": 13094,
            "ticket_number": "3513082",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604586794",
            "priority": "P2",
            "created_at": "19/03/2026 11:26:29",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:04:15"
          },
          {
            "ticket_id": 13097,
            "ticket_number": "3513085",
            "title": "RE: Pagamento 6142129",
            "priority": "P2",
            "created_at": "19/03/2026 11:28:02",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:43:06"
          },
          {
            "ticket_id": 13098,
            "ticket_number": "3513086",
            "title": "RE: Pagamento 6142012",
            "priority": "P2",
            "created_at": "19/03/2026 11:28:04",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:43:15"
          },
          {
            "ticket_id": 13099,
            "ticket_number": "3513087",
            "title": "RE: Pagamento 6142572",
            "priority": "P2",
            "created_at": "19/03/2026 11:28:06",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:43:22"
          },
          {
            "ticket_id": 13101,
            "ticket_number": "3513089",
            "title": "Envio de Fatura 213587",
            "priority": "P2",
            "created_at": "19/03/2026 11:52:31",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:59:44"
          },
          {
            "ticket_id": 13123,
            "ticket_number": "3513111",
            "title": "Pedido de formação do Consolidador",
            "priority": "P2",
            "created_at": "19/03/2026 14:48:01",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 14:48:01"
          },
          {
            "ticket_id": 13188,
            "ticket_number": "3513176",
            "title": "Contribuinte na fatura",
            "priority": "P2",
            "created_at": "20/03/2026 10:03:27",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:03:27"
          },
          {
            "ticket_id": 13209,
            "ticket_number": "3513197",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P1",
            "created_at": "20/03/2026 10:35:51",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 10:40:49"
          },
          {
            "ticket_id": 13215,
            "ticket_number": "3513203",
            "title": "Escapadelas idílicas para dar as boas-vindas à pri",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:51",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:41:58"
          },
          {
            "ticket_id": 13216,
            "ticket_number": "3513204",
            "title": "Reserva em WL 213934",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:53",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:29:42"
          },
          {
            "ticket_id": 13218,
            "ticket_number": "3513206",
            "title": "[Suporte] TRP-2026-03601 / TRL-2026-05484 - Vouche",
            "priority": "P2",
            "created_at": "20/03/2026 11:36:30",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 11:36:30"
          },
          {
            "ticket_id": 13219,
            "ticket_number": "3513207",
            "title": "[Suporte] TRP-2026-03601 / TRL-2026-05484 - Vouche",
            "priority": "P2",
            "created_at": "20/03/2026 11:37:04",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 11:37:04"
          },
          {
            "ticket_id": 13222,
            "ticket_number": "3513210",
            "title": "Cancelamento de reserva * File 435446",
            "priority": "P2",
            "created_at": "20/03/2026 12:23:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 12:29:49"
          },
          {
            "ticket_id": 13223,
            "ticket_number": "3513211",
            "title": "RE: [Cockpit] Viagem TRP-2026-03684 - AGA • Albina",
            "priority": "P2",
            "created_at": "20/03/2026 12:23:22",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 12:23:23"
          },
          {
            "ticket_id": 13226,
            "ticket_number": "3513214",
            "title": "[Suporte] TRP-2026-04415 - Hotel WL",
            "priority": "P2",
            "created_at": "20/03/2026 13:04:26",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 13:04:26"
          },
          {
            "ticket_id": 13227,
            "ticket_number": "3513215",
            "title": "Urgente Confirmação de reserva 342989### TIME LIMI",
            "priority": "P1",
            "created_at": "20/03/2026 13:22:54",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.3,
            "sla_met": false,
            "sla_breach_hours": 0.05,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 13:41:21"
          },
          {
            "ticket_id": 13228,
            "ticket_number": "3513216",
            "title": "PEDIDO DE CANCELAMENTO DA RESERVA NEWBLUE COM O LO",
            "priority": "P1",
            "created_at": "20/03/2026 13:22:56",
            "close_date": "2026-03-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 13:22:56"
          },
          {
            "ticket_id": 13232,
            "ticket_number": "3513220",
            "title": "Proforma CnTravel 17015545",
            "priority": "P2",
            "created_at": "20/03/2026 14:16:05",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 14:33:14"
          },
          {
            "ticket_id": 13238,
            "ticket_number": "3513226",
            "title": "Yanolja Go Global - Password Reset",
            "priority": "P2",
            "created_at": "20/03/2026 16:32:10",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 16:44:52"
          },
          {
            "ticket_id": 13241,
            "ticket_number": "3513229",
            "title": "[Cancelamento Viagem] TRP-2026-04418 - Gabriel Ant",
            "priority": "P2",
            "created_at": "20/03/2026 17:09:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 17:09:19"
          },
          {
            "ticket_id": 13242,
            "ticket_number": "3513230",
            "title": "Conhecer o Projeto",
            "priority": "P2",
            "created_at": "20/03/2026 17:28:49",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 17:57:43"
          },
          {
            "ticket_id": 13255,
            "ticket_number": "3513243",
            "title": "Pagamento da reserva – Ref PP242138, Sra. Ana Paul",
            "priority": "P2",
            "created_at": "20/03/2026 19:12:40",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 19:36:40"
          },
          {
            "ticket_id": 13257,
            "ticket_number": "3513245",
            "title": "w2m.travel: Confirmation of Payment received for t",
            "priority": "P2",
            "created_at": "20/03/2026 19:12:49",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 19:43:44"
          },
          {
            "ticket_id": 13286,
            "ticket_number": "3513274",
            "title": "[Cancelamento Serviço] TRP-2026-03611 / TRL-2026-0",
            "priority": "P2",
            "created_at": "20/03/2026 23:33:59",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:33:59"
          },
          {
            "ticket_id": 13287,
            "ticket_number": "3513275",
            "title": "[Cancelamento Viagem] TRP-2026-03784 - Rafael Pire",
            "priority": "P2",
            "created_at": "20/03/2026 23:34:59",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:34:59"
          },
          {
            "ticket_id": 13289,
            "ticket_number": "3513277",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "21/03/2026 09:58:16",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 12:27:53"
          },
          {
            "ticket_id": 13290,
            "ticket_number": "3513278",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "21/03/2026 09:58:18",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 12:27:59"
          },
          {
            "ticket_id": 13292,
            "ticket_number": "3513280",
            "title": "Pedido de apoio | TRP-2026-03648",
            "priority": "P2",
            "created_at": "21/03/2026 09:58:22",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 09:58:22"
          },
          {
            "ticket_id": 13293,
            "ticket_number": "3513281",
            "title": "GBN-113980 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/03/2026 09:58:32",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 09:58:32"
          },
          {
            "ticket_id": 13294,
            "ticket_number": "3513282",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "21/03/2026 09:58:40",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 13:16:22"
          },
          {
            "ticket_id": 13298,
            "ticket_number": "3513286",
            "title": "[Cancelamento Serviço] TRP-2026-02613 / TRL-2026-0",
            "priority": "P2",
            "created_at": "21/03/2026 11:04:19",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 11:04:19"
          },
          {
            "ticket_id": 13299,
            "ticket_number": "3513287",
            "title": "NB 6120599",
            "priority": "P2",
            "created_at": "21/03/2026 11:38:23",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 12:57:46"
          },
          {
            "ticket_id": 13300,
            "ticket_number": "3513288",
            "title": "Pagamento -  (Recibo-2147840583)",
            "priority": "P2",
            "created_at": "21/03/2026 12:14:25",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 13:14:21"
          },
          {
            "ticket_id": 13301,
            "ticket_number": "3513289",
            "title": "Informação de reserva - SPT002601611246",
            "priority": "P2",
            "created_at": "21/03/2026 12:14:31",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 12:49:54"
          },
          {
            "ticket_id": 13307,
            "ticket_number": "3513295",
            "title": "Incident Notification",
            "priority": "P2",
            "created_at": "21/03/2026 12:20:30",
            "close_date": "2026-03-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 12:31:37"
          },
          {
            "ticket_id": 13310,
            "ticket_number": "3513298",
            "title": "Erro Solférias 428139",
            "priority": "P2",
            "created_at": "21/03/2026 17:15:00",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/03/2026 17:15:00"
          },
          {
            "ticket_id": 13379,
            "ticket_number": "3513367",
            "title": "Cancelamento de Contrato de Consultor de Viagens",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:03",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13388,
            "ticket_number": "3513376",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "23/03/2026 10:15:23",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:15:23"
          },
          {
            "ticket_id": 13402,
            "ticket_number": "3513390",
            "title": "loc soltrópico -339057",
            "priority": "P2",
            "created_at": "23/03/2026 13:54:58",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:57:36"
          },
          {
            "ticket_id": 13405,
            "ticket_number": "3513393",
            "title": "Viajar Tours 23MAR Disponibilidades Roadshow Praia",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:08",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:49:09"
          },
          {
            "ticket_id": 13412,
            "ticket_number": "3513400",
            "title": "Campanha Azamara Cruises – Crédito a Bordo (Abril ",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:35",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 16:11:21"
          },
          {
            "ticket_id": 13415,
            "ticket_number": "3513403",
            "title": "RESERVA WL 343047",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:40",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:54:56"
          },
          {
            "ticket_id": 13417,
            "ticket_number": "3513405",
            "title": "VOUCHER DA RESERVA 604571432",
            "priority": "P2",
            "created_at": "23/03/2026 13:55:51",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 16:17:11"
          },
          {
            "ticket_id": 13431,
            "ticket_number": "3513419",
            "title": "Informação de reserva - SPT002601611959",
            "priority": "P2",
            "created_at": "23/03/2026 15:33:14",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:58:47"
          },
          {
            "ticket_id": 13432,
            "ticket_number": "3513420",
            "title": "Informação de reserva - SPT002601611959",
            "priority": "P2",
            "created_at": "23/03/2026 15:33:20",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:58:38"
          },
          {
            "ticket_id": 13436,
            "ticket_number": "3513424",
            "title": "Envio de documento (Factura-232008588) Vale do Ave",
            "priority": "P2",
            "created_at": "23/03/2026 17:23:51",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:32:06"
          },
          {
            "ticket_id": 13445,
            "ticket_number": "3513433",
            "title": "Notificação de autorização File 415793/25",
            "priority": "P2",
            "created_at": "23/03/2026 19:41:07",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:23:58"
          },
          {
            "ticket_id": 13446,
            "ticket_number": "3513434",
            "title": "RE: Proposta de viagem – Ilha do Sal (1 a 5 de mai",
            "priority": "P2",
            "created_at": "23/03/2026 19:41:09",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:40:37"
          },
          {
            "ticket_id": 13447,
            "ticket_number": "3513435",
            "title": "Importante - Checkin Online Voos TAP - FILE 341959",
            "priority": "P2",
            "created_at": "23/03/2026 19:41:12",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:13:51"
          },
          {
            "ticket_id": 13450,
            "ticket_number": "3513438",
            "title": "Envio de Documentação Disney File 424171",
            "priority": "P2",
            "created_at": "23/03/2026 20:26:12",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:35:09"
          },
          {
            "ticket_id": 13473,
            "ticket_number": "3513461",
            "title": "Consolidador",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:54",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:50:54"
          },
          {
            "ticket_id": 13478,
            "ticket_number": "3513466",
            "title": "Fwd: Viagify informa sobre a sua reserva 126269940",
            "priority": "P2",
            "created_at": "24/03/2026 10:04:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:04:24"
          },
          {
            "ticket_id": 13479,
            "ticket_number": "3513467",
            "title": "Fwd: Viagify informa sobre a sua reserva 126270075",
            "priority": "P2",
            "created_at": "24/03/2026 10:04:27",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:04:28"
          },
          {
            "ticket_id": 13492,
            "ticket_number": "3513480",
            "title": "Reembolso Cuba",
            "priority": "P2",
            "created_at": "24/03/2026 10:26:28",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:26:28"
          },
          {
            "ticket_id": 13505,
            "ticket_number": "3513493",
            "title": "Re: [Cockpit] Viagem TRP-2026-04465 - Férias em ca",
            "priority": "P2",
            "created_at": "24/03/2026 12:45:19",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 12:45:19"
          },
          {
            "ticket_id": 13507,
            "ticket_number": "3513495",
            "title": "Importante - Checkin Online Voos TAP - FILE 339057",
            "priority": "P2",
            "created_at": "24/03/2026 12:45:23",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 12:58:12"
          },
          {
            "ticket_id": 13508,
            "ticket_number": "3513496",
            "title": "Cancelamento de reserva 343047",
            "priority": "P2",
            "created_at": "24/03/2026 13:07:50",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:18:16"
          },
          {
            "ticket_id": 13514,
            "ticket_number": "3513502",
            "title": "TRP-2026-03770 - Pedido de ajuda legal",
            "priority": "P2",
            "created_at": "24/03/2026 13:30:25",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 13:30:25"
          },
          {
            "ticket_id": 13524,
            "ticket_number": "3513512",
            "title": "Fwd: Viagify informa sobre a sua reserva 126290474",
            "priority": "P2",
            "created_at": "24/03/2026 16:30:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 16:30:25"
          },
          {
            "ticket_id": 13525,
            "ticket_number": "3513513",
            "title": "Envio de Fatura 213934",
            "priority": "P2",
            "created_at": "24/03/2026 16:30:26",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:44:53"
          },
          {
            "ticket_id": 13526,
            "ticket_number": "3513514",
            "title": "Confirmação de Reserva * File 432293*ALTERAÇÃO*",
            "priority": "P2",
            "created_at": "24/03/2026 16:30:35",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:46:41"
          },
          {
            "ticket_id": 13537,
            "ticket_number": "3513525",
            "title": "Envio de Documentação * File 429171",
            "priority": "P2",
            "created_at": "24/03/2026 17:25:11",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:38:00"
          },
          {
            "ticket_id": 13559,
            "ticket_number": "3513547",
            "title": "Vania",
            "priority": "P2",
            "created_at": "24/03/2026 19:32:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:32:40"
          },
          {
            "ticket_id": 13586,
            "ticket_number": "3513574",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "25/03/2026 10:42:36",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:39:57"
          },
          {
            "ticket_id": 13587,
            "ticket_number": "3513575",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "25/03/2026 10:42:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:34:18"
          },
          {
            "ticket_id": 13593,
            "ticket_number": "3513581",
            "title": "Páscoa Last Minute_ Lavanda Hotels",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:31",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:37:01"
          },
          {
            "ticket_id": 13594,
            "ticket_number": "3513582",
            "title": "RE: Pedido de Agência MarSenses Web",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:35",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:37:15"
          },
          {
            "ticket_id": 13595,
            "ticket_number": "3513583",
            "title": "RE: Pagamento 6139564",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:37",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:34:45"
          },
          {
            "ticket_id": 13622,
            "ticket_number": "3513610",
            "title": "[Request received] Auto Reply",
            "priority": "P2",
            "created_at": "25/03/2026 16:27:48",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 42.58,
            "sla_met": false,
            "sla_breach_hours": 38.58,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 11:03:12"
          },
          {
            "ticket_id": 13629,
            "ticket_number": "3513617",
            "title": "Confirmação reserva Bedsonline 207-15889346",
            "priority": "P2",
            "created_at": "25/03/2026 17:09:58",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:04:31"
          },
          {
            "ticket_id": 13630,
            "ticket_number": "3513618",
            "title": "Invoice/credit note reprint for booking number  33",
            "priority": "P2",
            "created_at": "25/03/2026 17:09:59",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:19:59"
          },
          {
            "ticket_id": 13637,
            "ticket_number": "3513625",
            "title": "Envio de Documentação Financeira",
            "priority": "P2",
            "created_at": "25/03/2026 17:55:05",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:12:19"
          },
          {
            "ticket_id": 13679,
            "ticket_number": "3513667",
            "title": "emissão de bilhetes",
            "priority": "P2",
            "created_at": "26/03/2026 10:04:01",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:04:01"
          },
          {
            "ticket_id": 13681,
            "ticket_number": "3513669",
            "title": "RESERVA NEWBLUE 6143614-  ESCALRECIMENTO SOBRE APE",
            "priority": "P2",
            "created_at": "26/03/2026 10:04:04",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:04:05"
          },
          {
            "ticket_id": 13688,
            "ticket_number": "3513676",
            "title": "MSC Cruises Document - 2600101002225207",
            "priority": "P2",
            "created_at": "26/03/2026 10:07:35",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 11:33:03"
          },
          {
            "ticket_id": 13690,
            "ticket_number": "3513678",
            "title": "Fwd: Viagify informa sobre a sua reserva 126346169",
            "priority": "P2",
            "created_at": "26/03/2026 10:37:06",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:37:07"
          },
          {
            "ticket_id": 13696,
            "ticket_number": "3513684",
            "title": "GBN-115058 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "26/03/2026 11:24:45",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 11:24:45"
          },
          {
            "ticket_id": 13697,
            "ticket_number": "3513685",
            "title": "Reserva cancelada – Ref PP762271-1, Sr. Jose Alber",
            "priority": "P2",
            "created_at": "26/03/2026 11:39:16",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 12:07:49"
          },
          {
            "ticket_id": 13704,
            "ticket_number": "3513692",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604597980",
            "priority": "P2",
            "created_at": "26/03/2026 13:22:31",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 14:14:44"
          },
          {
            "ticket_id": 13707,
            "ticket_number": "3513695",
            "title": "RE: Pedido de cotação grupo de 15 pessoas",
            "priority": "P2",
            "created_at": "26/03/2026 14:16:41",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 14:44:19"
          },
          {
            "ticket_id": 13708,
            "ticket_number": "3513696",
            "title": "Fwd: Viagify informa sobre a sua reserva 126361644",
            "priority": "P2",
            "created_at": "26/03/2026 14:25:46",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 14:25:46"
          },
          {
            "ticket_id": 13718,
            "ticket_number": "3513706",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "P2",
            "created_at": "26/03/2026 15:59:00",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 16:24:08"
          },
          {
            "ticket_id": 13732,
            "ticket_number": "3513720",
            "title": "[Pedido de Grupo] Sevilha - 2026-06-27 a 2026-06-2",
            "priority": "P3",
            "created_at": "26/03/2026 19:47:00",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/03/2026 19:47:00"
          },
          {
            "ticket_id": 13751,
            "ticket_number": "3513739",
            "title": "Levantamento Comissões",
            "priority": "P2",
            "created_at": "26/03/2026 23:45:11",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:45:11"
          },
          {
            "ticket_id": 13771,
            "ticket_number": "3513759",
            "title": "Pedido de compra de lugares reserva 433137 / 2026 ",
            "priority": "P2",
            "created_at": "27/03/2026 10:38:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:38:05"
          },
          {
            "ticket_id": 13773,
            "ticket_number": "3513761",
            "title": "RE: Loc 1778053 W2MCS:003960005244",
            "priority": "P2",
            "created_at": "27/03/2026 11:03:10",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 11:22:09"
          },
          {
            "ticket_id": 13777,
            "ticket_number": "3513765",
            "title": "GBN-115343 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/03/2026 12:07:54",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 12:07:54"
          },
          {
            "ticket_id": 13779,
            "ticket_number": "3513767",
            "title": "TRP-2026-04334 - Upgrade para pensão completa ou T",
            "priority": "P2",
            "created_at": "27/03/2026 12:26:20",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 12:26:20"
          },
          {
            "ticket_id": 13783,
            "ticket_number": "3513771",
            "title": "GBN-115376 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/03/2026 13:02:41",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 13:02:41"
          },
          {
            "ticket_id": 13784,
            "ticket_number": "3513772",
            "title": "Icárion - Nova comercial Carla Ferreira",
            "priority": "P2",
            "created_at": "27/03/2026 13:02:43",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 4.05,
            "sla_met": false,
            "sla_breach_hours": 0.05,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:06:13"
          },
          {
            "ticket_id": 13787,
            "ticket_number": "3513775",
            "title": "VOUCHER DA RESERVA 604571207",
            "priority": "P2",
            "created_at": "27/03/2026 13:42:52",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:26:39"
          },
          {
            "ticket_id": 13791,
            "ticket_number": "3513779",
            "title": "Pedido de Contacto Movel - 341959 // Partida: 2026",
            "priority": "P2",
            "created_at": "27/03/2026 14:07:19",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 14:11:58"
          },
          {
            "ticket_id": 13800,
            "ticket_number": "3513788",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "27/03/2026 15:27:08",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 19:23:57"
          },
          {
            "ticket_id": 13804,
            "ticket_number": "3513792",
            "title": "Pedido de Contacto Movel - 341959 // Partida: 2026",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:22",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 16:44:09"
          },
          {
            "ticket_id": 13805,
            "ticket_number": "3513793",
            "title": "Pedido de Contacto Movel - 341959 // Partida: 2026",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:23",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:23:46"
          },
          {
            "ticket_id": 13806,
            "ticket_number": "3513794",
            "title": "Pedido de Contacto Movel - 332333 // Partida: 2026",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:25",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 16:45:49"
          },
          {
            "ticket_id": 13808,
            "ticket_number": "3513796",
            "title": "Pedido de Contacto Movel - 341925 // Partida: 2026",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:29",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:22:07"
          },
          {
            "ticket_id": 13895,
            "ticket_number": "3513883",
            "title": "[Suporte] TRP-2026-03215 - Cancelamento de passage",
            "priority": "P2",
            "created_at": "29/03/2026 22:08:26",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/03/2026 22:08:26"
          },
          {
            "ticket_id": 13911,
            "ticket_number": "3513899",
            "title": "GBN-115418 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:18",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:03"
          },
          {
            "ticket_id": 13922,
            "ticket_number": "3513910",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:05",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:04"
          },
          {
            "ticket_id": 13923,
            "ticket_number": "3513911",
            "title": "Fwd: Viagify informa sobre a sua reserva 125671155",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:09",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:09"
          },
          {
            "ticket_id": 13928,
            "ticket_number": "3513916",
            "title": "Fwd: Viagify informa sobre a sua reserva 126452885",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:24",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:25"
          },
          {
            "ticket_id": 13931,
            "ticket_number": "3513919",
            "title": "Fwd: Viagify informa sobre a sua reserva 126434590",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:31",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:32"
          },
          {
            "ticket_id": 13933,
            "ticket_number": "3513921",
            "title": "Fwd: Viagify informa sobre a sua reserva 126418282",
            "priority": "P2",
            "created_at": "30/03/2026 09:51:37",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:51:37"
          },
          {
            "ticket_id": 13936,
            "ticket_number": "3513924",
            "title": "GBN-115685 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:14",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:52:14"
          },
          {
            "ticket_id": 13937,
            "ticket_number": "3513925",
            "title": "GBN-115689 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:18",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:52:18"
          },
          {
            "ticket_id": 13938,
            "ticket_number": "3513926",
            "title": "Número de informação da reserva: 6143935",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:21",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13939,
            "ticket_number": "3513927",
            "title": "GBN-115684 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:25",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:52:25"
          },
          {
            "ticket_id": 13956,
            "ticket_number": "3513944",
            "title": "GBN-115641 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/03/2026 09:54:00",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13958,
            "ticket_number": "3513946",
            "title": "GBN-115680 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 09:54:07",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:54:08"
          },
          {
            "ticket_id": 13986,
            "ticket_number": "3513974",
            "title": "Credenciais",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:21",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:15:21"
          },
          {
            "ticket_id": 13995,
            "ticket_number": "3513983",
            "title": "[Suporte] TRP-2026-03640 - Alteracao datas TRP-202",
            "priority": "P2",
            "created_at": "30/03/2026 14:18:45",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 14:18:45"
          },
          {
            "ticket_id": 14001,
            "ticket_number": "3513989",
            "title": "Voucher reserva 266-2909360",
            "priority": "P2",
            "created_at": "30/03/2026 16:00:30",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:00:30"
          },
          {
            "ticket_id": 14005,
            "ticket_number": "3513993",
            "title": "Pedido de informação Civitatis",
            "priority": "P2",
            "created_at": "30/03/2026 16:04:00",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:04:01"
          },
          {
            "ticket_id": 14006,
            "ticket_number": "3513994",
            "title": "GBN 108882 Upgrade _URGENTE",
            "priority": "P2",
            "created_at": "30/03/2026 16:09:21",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:09:22"
          },
          {
            "ticket_id": 14007,
            "ticket_number": "3513995",
            "title": "GBN-115835 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/03/2026 16:15:28",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:15:28"
          },
          {
            "ticket_id": 14020,
            "ticket_number": "3514008",
            "title": "Rescisão do contrato",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:33",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 19:40:33"
          },
          {
            "ticket_id": 14035,
            "ticket_number": "3514023",
            "title": "Comissões Soltrópico - erradas",
            "priority": "P2",
            "created_at": "30/03/2026 21:44:48",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:44:48"
          },
          {
            "ticket_id": 14044,
            "ticket_number": "3514032",
            "title": "Re:[## 36635 ##] GBN-113662 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "30/03/2026 22:01:18",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:01:18"
          },
          {
            "ticket_id": 14051,
            "ticket_number": "3514039",
            "title": "GBN-75942 - Urgente",
            "priority": "P2",
            "created_at": "30/03/2026 22:58:48",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:58:49"
          },
          {
            "ticket_id": 14052,
            "ticket_number": "3514040",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "30/03/2026 23:16:55",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 11.47,
            "sla_met": false,
            "sla_breach_hours": 7.47,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 10:45:06"
          },
          {
            "ticket_id": 14056,
            "ticket_number": "3514044",
            "title": "Criação de processo File 437298/26",
            "priority": "P3",
            "created_at": "31/03/2026 09:08:01",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/03/2026 10:41:35"
          },
          {
            "ticket_id": 14061,
            "ticket_number": "3514049",
            "title": "Eticket - 66829878 - MU  04/04/2026  Funchal, Port",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:15",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 10:36:52"
          },
          {
            "ticket_id": 14062,
            "ticket_number": "3514050",
            "title": "MSC Cruises Document - 2600101002363002",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:24",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 10:49:44"
          },
          {
            "ticket_id": 14067,
            "ticket_number": "3514055",
            "title": "RE: Pagamento 6143902",
            "priority": "P2",
            "created_at": "31/03/2026 10:10:45",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 10:37:14"
          },
          {
            "ticket_id": 14068,
            "ticket_number": "3514056",
            "title": "Informação importante sobre a tua reserva 6126635",
            "priority": "P2",
            "created_at": "31/03/2026 10:10:48",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 10:34:23"
          },
          {
            "ticket_id": 14072,
            "ticket_number": "3514060",
            "title": "GBN-115967 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "31/03/2026 11:09:32",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/03/2026 11:09:32"
          },
          {
            "ticket_id": 14085,
            "ticket_number": "3514073",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "31/03/2026 13:51:06",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 13:53:48"
          },
          {
            "ticket_id": 14132,
            "ticket_number": "3514120",
            "title": "Faturas Pendentes: FA 2147903838",
            "priority": "P2",
            "created_at": "31/03/2026 18:19:07",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 15.58,
            "sla_met": false,
            "sla_breach_hours": 11.58,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 09:54:33"
          },
          {
            "ticket_id": 14161,
            "ticket_number": "3514149",
            "title": "Fwd: Viagify informa sobre a sua reserva 126542718",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:45",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 09:11:46"
          },
          {
            "ticket_id": 14166,
            "ticket_number": "3514154",
            "title": "Confirmação de reserva 343576 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "01/04/2026 10:29:19",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 10:30:12"
          },
          {
            "ticket_id": 14170,
            "ticket_number": "3514158",
            "title": "Informação de reserva - SPT002601616095",
            "priority": "P2",
            "created_at": "01/04/2026 12:13:35",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 13:56:26"
          },
          {
            "ticket_id": 14171,
            "ticket_number": "3514159",
            "title": "Informação de reserva - SPT002601616095",
            "priority": "P2",
            "created_at": "01/04/2026 12:13:42",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 13:57:38"
          },
          {
            "ticket_id": 14184,
            "ticket_number": "3514172",
            "title": "Fwd: Viagify informa-te do teu orçamento 126559892",
            "priority": "P2",
            "created_at": "01/04/2026 14:28:25",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:28:26"
          },
          {
            "ticket_id": 14192,
            "ticket_number": "3514180",
            "title": "[Cancelamento Serviço] TRP-2026-04583 / TRL-2026-0",
            "priority": "P2",
            "created_at": "01/04/2026 15:55:35",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 15:55:35"
          },
          {
            "ticket_id": 14196,
            "ticket_number": "3514184",
            "title": "[Suporte] TRP-2026-03595 / TRL-2026-05477 - reembo",
            "priority": "P2",
            "created_at": "01/04/2026 16:38:28",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 16:38:28"
          },
          {
            "ticket_id": 14230,
            "ticket_number": "3514218",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "01/04/2026 22:52:27",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 11.25,
            "sla_met": false,
            "sla_breach_hours": 7.25,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:07:44"
          },
          {
            "ticket_id": 14231,
            "ticket_number": "3514219",
            "title": "Reserva confirmada: Ingresso da Disneyland® Paris ",
            "priority": "P2",
            "created_at": "01/04/2026 22:52:29",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 11.48,
            "sla_met": false,
            "sla_breach_hours": 7.48,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:22:04"
          },
          {
            "ticket_id": 14232,
            "ticket_number": "3514220",
            "title": "GBN-116414 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "01/04/2026 22:52:35",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:52:35"
          },
          {
            "ticket_id": 14233,
            "ticket_number": "3514221",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "01/04/2026 23:07:29",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 11.25,
            "sla_met": false,
            "sla_breach_hours": 7.25,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:22:32"
          },
          {
            "ticket_id": 14238,
            "ticket_number": "3514226",
            "title": "Fwd: Viagify informa sobre a sua reserva 126571513",
            "priority": "P2",
            "created_at": "02/04/2026 09:21:25",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 09:21:26"
          },
          {
            "ticket_id": 14239,
            "ticket_number": "3514227",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/04/2026 09:27:22",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 11:12:22"
          },
          {
            "ticket_id": 14241,
            "ticket_number": "3514229",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/04/2026 09:27:27",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:45:36"
          },
          {
            "ticket_id": 14243,
            "ticket_number": "3514231",
            "title": "Madeira | Verão 2026 no The Editory Garden Carmo F",
            "priority": "P2",
            "created_at": "02/04/2026 09:59:29",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:46:28"
          },
          {
            "ticket_id": 14245,
            "ticket_number": "3514233",
            "title": "Pedido de Contacto Movel - 341925 // Partida: 2026",
            "priority": "P2",
            "created_at": "02/04/2026 10:23:00",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 10:29:08"
          },
          {
            "ticket_id": 14247,
            "ticket_number": "3514235",
            "title": "pedido credenciais",
            "priority": "P2",
            "created_at": "02/04/2026 11:15:37",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 11:15:37"
          },
          {
            "ticket_id": 14252,
            "ticket_number": "3514240",
            "title": "Tipo de Documento de Faturação - Catarina Faco",
            "priority": "P2",
            "created_at": "02/04/2026 12:44:19",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 12:44:19"
          },
          {
            "ticket_id": 14253,
            "ticket_number": "3514241",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/04/2026 12:44:21",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 12:54:01"
          },
          {
            "ticket_id": 14254,
            "ticket_number": "3514242",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/04/2026 12:44:24",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 12:54:07"
          },
          {
            "ticket_id": 14255,
            "ticket_number": "3514243",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "02/04/2026 12:44:27",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 12:54:13"
          },
          {
            "ticket_id": 14271,
            "ticket_number": "3514259",
            "title": "Quick note",
            "priority": "P2",
            "created_at": "02/04/2026 16:07:34",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:14:40"
          },
          {
            "ticket_id": 14276,
            "ticket_number": "3514264",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 16:32:54",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:32:54"
          },
          {
            "ticket_id": 14277,
            "ticket_number": "3514265",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 16:33:03",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:33:03"
          },
          {
            "ticket_id": 14278,
            "ticket_number": "3514266",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/04/2026 16:33:10",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:33:10"
          },
          {
            "ticket_id": 14449,
            "ticket_number": "3514437",
            "title": "Cotação Crowne Plaza Caparica - de 28 de Maio a 1 ",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:37",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:37"
          },
          {
            "ticket_id": 14477,
            "ticket_number": "3514465",
            "title": "[Suporte] TRP-2026-04630 - Alteração número CC no ",
            "priority": "P2",
            "created_at": "06/04/2026 20:32:23",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 20:32:23"
          },
          {
            "ticket_id": 14478,
            "ticket_number": "3514466",
            "title": "Pedido de cotação direta - Herdade do Amarelo",
            "priority": "P2",
            "created_at": "06/04/2026 20:48:15",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 20:48:15"
          },
          {
            "ticket_id": 14492,
            "ticket_number": "3514480",
            "title": "Loc338488",
            "priority": "P2",
            "created_at": "06/04/2026 21:51:27",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 22:54:07"
          },
          {
            "ticket_id": 14586,
            "ticket_number": "3514574",
            "title": "MSC Voyagers Club",
            "priority": "P2",
            "created_at": "07/04/2026 18:57:35",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:57:36"
          },
          {
            "ticket_id": 14629,
            "ticket_number": "3514617",
            "title": "Fwd: Incidente de voo TTN-1243164235#98278460#T191",
            "priority": "P2",
            "created_at": "08/04/2026 10:40:06",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 10:40:07"
          },
          {
            "ticket_id": 14635,
            "ticket_number": "3514623",
            "title": "Re: [Cockpit] Viagem TRP-2026-04659 - Brasil Voo",
            "priority": "P2",
            "created_at": "08/04/2026 11:19:39",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:19:39"
          },
          {
            "ticket_id": 14644,
            "ticket_number": "3514632",
            "title": "Número de informação da reserva: 6144812",
            "priority": "P2",
            "created_at": "08/04/2026 13:32:58",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:51:39"
          },
          {
            "ticket_id": 14650,
            "ticket_number": "3514638",
            "title": "Pedido de fatura à Tap",
            "priority": "P2",
            "created_at": "08/04/2026 15:20:41",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 15:20:41"
          },
          {
            "ticket_id": 14651,
            "ticket_number": "3514639",
            "title": "Re: Reserva - Excursão 17 - Tesouros De Adamanay (",
            "priority": "P2",
            "created_at": "08/04/2026 15:22:37",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 17:48:55"
          },
          {
            "ticket_id": 14652,
            "ticket_number": "3514640",
            "title": "MVU: Cambio Vuelo: 4133660 FAMILIAP 001",
            "priority": "P2",
            "created_at": "08/04/2026 15:34:12",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:05:41"
          },
          {
            "ticket_id": 14653,
            "ticket_number": "3514641",
            "title": "MVU: Cambio Vuelo: 4133656 FAMILIAP 001",
            "priority": "P2",
            "created_at": "08/04/2026 15:34:14",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:52:49"
          },
          {
            "ticket_id": 14654,
            "ticket_number": "3514642",
            "title": "Pedido de Contacto Movel - 340001 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:01:46",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:55:31"
          },
          {
            "ticket_id": 14656,
            "ticket_number": "3514644",
            "title": "Fwd: Informações da reserva TTN-1240916209#9812371",
            "priority": "P2",
            "created_at": "08/04/2026 16:01:56",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:01:58"
          },
          {
            "ticket_id": 14658,
            "ticket_number": "3514646",
            "title": "Cancelamento de Reserva - SPT002601600269",
            "priority": "P1",
            "created_at": "08/04/2026 16:02:08",
            "close_date": "2026-04-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.8,
            "sla_met": false,
            "sla_breach_hours": 1.55,
            "sla_name": "SLA P1",
            "first_response_at": "08/04/2026 17:50:41"
          },
          {
            "ticket_id": 14659,
            "ticket_number": "3514647",
            "title": "Pedido de Contacto Movel - 341138 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:02:10",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:56:20"
          },
          {
            "ticket_id": 14661,
            "ticket_number": "3514649",
            "title": "Pedido de Contacto Movel - 335271 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:02:14",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 17:02:43"
          },
          {
            "ticket_id": 14663,
            "ticket_number": "3514651",
            "title": "Pedido de Contacto Movel - 334059 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:02:17",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:57:23"
          },
          {
            "ticket_id": 14665,
            "ticket_number": "3514653",
            "title": "Pedido de Contacto Movel - 334667 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:20:47",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:58:39"
          },
          {
            "ticket_id": 14666,
            "ticket_number": "3514654",
            "title": "Pedido de Contacto Movel - 334072 // Partida: 2026",
            "priority": "P2",
            "created_at": "08/04/2026 16:20:49",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 17:00:16"
          },
          {
            "ticket_id": 14669,
            "ticket_number": "3514657",
            "title": "[Cancelamento Serviço] TRP-2026-02869 / TRL-2026-0",
            "priority": "P2",
            "created_at": "08/04/2026 16:47:29",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:47:30"
          },
          {
            "ticket_id": 14672,
            "ticket_number": "3514660",
            "title": "Reserva em WL 212563",
            "priority": "P2",
            "created_at": "08/04/2026 17:14:33",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 17:29:51"
          },
          {
            "ticket_id": 14680,
            "ticket_number": "3514668",
            "title": "JOANA GONCALVES RD ABRIL",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:16",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 13.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:24:02"
          },
          {
            "ticket_id": 14702,
            "ticket_number": "3514690",
            "title": "[Suporte] TRP-2026-03251 / TRL-2026-05020 - Docume",
            "priority": "P2",
            "created_at": "09/04/2026 09:25:17",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 09:25:17"
          },
          {
            "ticket_id": 14714,
            "ticket_number": "3514702",
            "title": "Cancelamento Reserva",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:58",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:18:58"
          },
          {
            "ticket_id": 14717,
            "ticket_number": "3514705",
            "title": "Pedido refeição de voo",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:05",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:19:05"
          },
          {
            "ticket_id": 14719,
            "ticket_number": "3514707",
            "title": "Adição de passageiro a reserva com o localizador 6",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:08",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:19:08"
          },
          {
            "ticket_id": 14721,
            "ticket_number": "3514709",
            "title": "GBN-117437 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:16",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:19:16"
          },
          {
            "ticket_id": 14723,
            "ticket_number": "3514711",
            "title": "GBN-117521 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 13:03:49",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:03:49"
          },
          {
            "ticket_id": 14725,
            "ticket_number": "3514713",
            "title": "Confirmação de Reserva 212563",
            "priority": "P2",
            "created_at": "09/04/2026 13:03:53",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:43:32"
          },
          {
            "ticket_id": 14729,
            "ticket_number": "3514717",
            "title": "Confirmation of booking with locator37RU5CRN",
            "priority": "P2",
            "created_at": "09/04/2026 13:59:27",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:49:09"
          },
          {
            "ticket_id": 14731,
            "ticket_number": "3514719",
            "title": "Correção de dados – Localizador nº1784191 Newblue ",
            "priority": "P1",
            "created_at": "09/04/2026 13:59:31",
            "close_date": "2026-04-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/04/2026 13:59:31"
          },
          {
            "ticket_id": 14737,
            "ticket_number": "3514725",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "09/04/2026 15:22:18",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:41:21"
          },
          {
            "ticket_id": 14738,
            "ticket_number": "3514726",
            "title": "Confirmação de reserva com localizador: 4162304",
            "priority": "P2",
            "created_at": "09/04/2026 15:22:20",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:42:59"
          },
          {
            "ticket_id": 14744,
            "ticket_number": "3514732",
            "title": "MVU: Cambio Vuelo: 4133716 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:24:48",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:29:09"
          },
          {
            "ticket_id": 14746,
            "ticket_number": "3514734",
            "title": "Confirmação de reserva com localizador: 4162489",
            "priority": "P2",
            "created_at": "09/04/2026 16:25:13",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:38:07"
          },
          {
            "ticket_id": 14747,
            "ticket_number": "3514735",
            "title": "VJT: Suplemento Combustível Charter Nouvelair_Djer",
            "priority": "P2",
            "created_at": "09/04/2026 16:25:15",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 16:42:59"
          },
          {
            "ticket_id": 14749,
            "ticket_number": "3514737",
            "title": "MVU: Cambio Vuelo: 4133726 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:40:17",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 16:52:58"
          },
          {
            "ticket_id": 14751,
            "ticket_number": "3514739",
            "title": "MVU: Cambio Vuelo: 4133744 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:40:20",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:41:15"
          },
          {
            "ticket_id": 14756,
            "ticket_number": "3514744",
            "title": "MVU: Cambio Vuelo: 4133749 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:47:00",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 17:07:01"
          },
          {
            "ticket_id": 14757,
            "ticket_number": "3514745",
            "title": "Liberação de acessos",
            "priority": "P2",
            "created_at": "09/04/2026 17:47:30",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 17:47:31"
          },
          {
            "ticket_id": 14760,
            "ticket_number": "3514748",
            "title": "GBN-115676 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/04/2026 17:47:44",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:42:37"
          },
          {
            "ticket_id": 14762,
            "ticket_number": "3514750",
            "title": "MVU: Cambio Vuelo: 4133753 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 17:47:48",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:50:06"
          },
          {
            "ticket_id": 14765,
            "ticket_number": "3514753",
            "title": "Fwd: Viagify informa sobre a sua reserva 126799688",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:02",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:03"
          },
          {
            "ticket_id": 14767,
            "ticket_number": "3514755",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:19",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:19"
          },
          {
            "ticket_id": 14768,
            "ticket_number": "3514756",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:28",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:28"
          },
          {
            "ticket_id": 14769,
            "ticket_number": "3514757",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:36",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:36"
          },
          {
            "ticket_id": 14770,
            "ticket_number": "3514758",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:40",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:40"
          },
          {
            "ticket_id": 14771,
            "ticket_number": "3514759",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:48",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:48"
          },
          {
            "ticket_id": 14772,
            "ticket_number": "3514760",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:07:58",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:07:58"
          },
          {
            "ticket_id": 14773,
            "ticket_number": "3514761",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:08:07",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:08:07"
          },
          {
            "ticket_id": 14774,
            "ticket_number": "3514762",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:08:15",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:08:15"
          },
          {
            "ticket_id": 14775,
            "ticket_number": "3514763",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 18:08:27",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:08:27"
          },
          {
            "ticket_id": 14776,
            "ticket_number": "3514764",
            "title": "[Cancelamento Serviço] TRP-2026-04591 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/04/2026 18:40:58",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 18:40:58"
          },
          {
            "ticket_id": 14777,
            "ticket_number": "3514765",
            "title": "URGENTE - Emissão Incorreta pelo Operador - Vouche",
            "priority": "P2",
            "created_at": "09/04/2026 19:01:49",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 19:01:49"
          },
          {
            "ticket_id": 14781,
            "ticket_number": "3514769",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:23",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:24"
          },
          {
            "ticket_id": 14783,
            "ticket_number": "3514771",
            "title": "Fwd: Viagify informa sobre a sua reserva 126804921",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:28",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:29"
          },
          {
            "ticket_id": 14784,
            "ticket_number": "3514772",
            "title": "GBN-117686 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:33",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:33"
          },
          {
            "ticket_id": 14791,
            "ticket_number": "3514779",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "09/04/2026 20:23:55",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:23:56"
          },
          {
            "ticket_id": 14803,
            "ticket_number": "3514791",
            "title": "Urgente: Dúvida Flexible Autos - pendente para ava",
            "priority": "P2",
            "created_at": "09/04/2026 23:28:49",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:28:49"
          },
          {
            "ticket_id": 14804,
            "ticket_number": "3514792",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "09/04/2026 23:28:52",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:28:53"
          },
          {
            "ticket_id": 14805,
            "ticket_number": "3514793",
            "title": "Fwd: Viagify informa sobre a sua reserva 126806348",
            "priority": "P2",
            "created_at": "09/04/2026 23:28:55",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:28:55"
          },
          {
            "ticket_id": 14807,
            "ticket_number": "3514795",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:08",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:29:08"
          },
          {
            "ticket_id": 14809,
            "ticket_number": "3514797",
            "title": "Fwd: O seu comprovativo",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:14",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:29:14"
          },
          {
            "ticket_id": 14810,
            "ticket_number": "3514798",
            "title": "GBN-117699 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:20",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:29:20"
          },
          {
            "ticket_id": 14811,
            "ticket_number": "3514799",
            "title": "Número de informação da reserva: 6145004",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:50",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 11.95,
            "sla_met": false,
            "sla_breach_hours": 7.95,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:26:57"
          },
          {
            "ticket_id": 14812,
            "ticket_number": "3514800",
            "title": "Número de informação da reserva: 6145005",
            "priority": "P2",
            "created_at": "09/04/2026 23:29:53",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 14.63,
            "sla_met": false,
            "sla_breach_hours": 10.63,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 14:08:50"
          },
          {
            "ticket_id": 14814,
            "ticket_number": "3514802",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60453564",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:36",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:27:37"
          },
          {
            "ticket_id": 14835,
            "ticket_number": "3514823",
            "title": "SAL",
            "priority": "P2",
            "created_at": "10/04/2026 13:31:48",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:28:56"
          },
          {
            "ticket_id": 14838,
            "ticket_number": "3514826",
            "title": "GBN-112976 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/04/2026 13:59:22",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:23:14"
          },
          {
            "ticket_id": 14879,
            "ticket_number": "3514867",
            "title": "Fwd: Localizador 1233152273 - SmyTravel informa TT",
            "priority": "P1",
            "created_at": "10/04/2026 17:48:43",
            "close_date": "2026-04-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "10/04/2026 17:48:43"
          },
          {
            "ticket_id": 14916,
            "ticket_number": "3514904",
            "title": "GBN-117952 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/04/2026 11:57:41",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 4.43,
            "sla_met": false,
            "sla_breach_hours": 0.43,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:23:51"
          },
          {
            "ticket_id": 14943,
            "ticket_number": "3514931",
            "title": "TRP-2026-03385 | Esclarecimento de questões NewBlu",
            "priority": "P2",
            "created_at": "11/04/2026 16:59:57",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:59:57"
          },
          {
            "ticket_id": 14948,
            "ticket_number": "3514936",
            "title": "Pedido credenciais acesso Consolidador",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:01",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:28:01"
          },
          {
            "ticket_id": 14976,
            "ticket_number": "3514964",
            "title": "[Cancelamento Viagem] TRP-2026-03452 - Rui Pinto -",
            "priority": "P2",
            "created_at": "12/04/2026 20:49:47",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:49:47"
          },
          {
            "ticket_id": 14977,
            "ticket_number": "3514965",
            "title": "[Cancelamento Viagem] TRP-2026-03451 - Rui Pinto -",
            "priority": "P2",
            "created_at": "12/04/2026 20:50:13",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:50:14"
          },
          {
            "ticket_id": 14979,
            "ticket_number": "3514967",
            "title": "[Cancelamento Viagem] TRP-2026-03561 - Neuza Matos",
            "priority": "P2",
            "created_at": "12/04/2026 20:51:14",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:51:14"
          },
          {
            "ticket_id": 14980,
            "ticket_number": "3514968",
            "title": "[Cancelamento Viagem] TRP-2026-03131 - Cláudio Cun",
            "priority": "P2",
            "created_at": "12/04/2026 20:51:38",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:51:38"
          },
          {
            "ticket_id": 14997,
            "ticket_number": "3514985",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P3",
            "created_at": "13/04/2026 09:20:25",
            "close_date": "2026-04-13",
            "sla_target_hours": 24,
            "actual_time_hours": 5.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/04/2026 14:37:48"
          },
          {
            "ticket_id": 15017,
            "ticket_number": "3515005",
            "title": "LOC: 1268958296 - DADOS CLIENTES",
            "priority": "P2",
            "created_at": "13/04/2026 09:22:03",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 09:22:03"
          },
          {
            "ticket_id": 15024,
            "ticket_number": "3515012",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "13/04/2026 10:10:56",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 11:03:38"
          },
          {
            "ticket_id": 15026,
            "ticket_number": "3515014",
            "title": "TRP-2026-02915 - Pagamentos - Voucher",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:04",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:11:05"
          },
          {
            "ticket_id": 15028,
            "ticket_number": "3515016",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546362",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:14",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:10:43"
          },
          {
            "ticket_id": 15029,
            "ticket_number": "3515017",
            "title": "Convite atualizado: Reunião Geral suporte @ sex. 1",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:16",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:11:16"
          },
          {
            "ticket_id": 15040,
            "ticket_number": "3515028",
            "title": "GBN-118132 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/04/2026 11:22:12",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 11:22:12"
          },
          {
            "ticket_id": 15041,
            "ticket_number": "3515029",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "13/04/2026 11:22:41",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:21:33"
          },
          {
            "ticket_id": 15045,
            "ticket_number": "3515033",
            "title": "[Cancelamento Serviço] TRP-2026-03905 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/04/2026 11:55:57",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 11:55:57"
          },
          {
            "ticket_id": 15046,
            "ticket_number": "3515034",
            "title": "Reserva cancelada com localizador: 4056308",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:31",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:57:10"
          },
          {
            "ticket_id": 15052,
            "ticket_number": "3515040",
            "title": "RESERVA DE VÔO COM ANIMAIS",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:46",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:48:46"
          },
          {
            "ticket_id": 15053,
            "ticket_number": "3515041",
            "title": "Cancellation of the booking with locator HLBDB40W",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:48",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:49:55"
          },
          {
            "ticket_id": 15055,
            "ticket_number": "3515043",
            "title": "Fwd: Informações sobre a sua reserva TTN-122258090",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:54",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 13:48:54"
          },
          {
            "ticket_id": 15059,
            "ticket_number": "3515047",
            "title": "Fwd: Viagify informa sobre a sua reserva 126920234",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:15",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:00:15"
          },
          {
            "ticket_id": 15062,
            "ticket_number": "3515050",
            "title": "GBN-118198 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:26",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:36:48"
          },
          {
            "ticket_id": 15066,
            "ticket_number": "3515054",
            "title": "Informação de reserva - SPT002601620028",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:47",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:41:24"
          },
          {
            "ticket_id": 15067,
            "ticket_number": "3515055",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:50",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:39:33"
          },
          {
            "ticket_id": 15070,
            "ticket_number": "3515058",
            "title": "Fwd: Informações da reserva TTN-1268958296#9875876",
            "priority": "P2",
            "created_at": "13/04/2026 16:21:27",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:21:28"
          },
          {
            "ticket_id": 15072,
            "ticket_number": "3515060",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-11",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:00",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:26:22"
          },
          {
            "ticket_id": 15073,
            "ticket_number": "3515061",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:04",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:04"
          },
          {
            "ticket_id": 15074,
            "ticket_number": "3515062",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:11",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:11"
          },
          {
            "ticket_id": 15075,
            "ticket_number": "3515063",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:19",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:19"
          },
          {
            "ticket_id": 15076,
            "ticket_number": "3515064",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:23",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:23"
          },
          {
            "ticket_id": 15077,
            "ticket_number": "3515065",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:25",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:25"
          },
          {
            "ticket_id": 15078,
            "ticket_number": "3515066",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/04/2026 16:23:34",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:23:34"
          },
          {
            "ticket_id": 15083,
            "ticket_number": "3515071",
            "title": "Reclamação: Proc. 1048/2026/VQ/AS: Maria Helena Si",
            "priority": "P2",
            "created_at": "13/04/2026 17:54:21",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:12:53"
          },
          {
            "ticket_id": 15084,
            "ticket_number": "3515072",
            "title": "Importante - Checkin Online Voos TAP - FILE 338488",
            "priority": "P2",
            "created_at": "13/04/2026 17:54:23",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:11:13"
          },
          {
            "ticket_id": 15142,
            "ticket_number": "3515130",
            "title": "GBN-75942 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/04/2026 11:28:24",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:51:54"
          },
          {
            "ticket_id": 15252,
            "ticket_number": "3515240",
            "title": "Fwd: Viagify informa sobre a sua reserva 126988680",
            "priority": "P2",
            "created_at": "15/04/2026 10:22:23",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 10:22:24"
          },
          {
            "ticket_id": 15273,
            "ticket_number": "3515261",
            "title": "Confirmação de reserva – Ref PP641372, Sr. José Le",
            "priority": "P2",
            "created_at": "15/04/2026 13:36:23",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.3,
            "sla_met": false,
            "sla_breach_hours": 0.3,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:55:11"
          },
          {
            "ticket_id": 15279,
            "ticket_number": "3515267",
            "title": "Suspensão projecto",
            "priority": "P2",
            "created_at": "15/04/2026 15:42:34",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 15:42:34"
          },
          {
            "ticket_id": 15282,
            "ticket_number": "3515270",
            "title": "Confirmação de reserva com localizador: 4172926",
            "priority": "P2",
            "created_at": "15/04/2026 16:08:05",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:57:01"
          },
          {
            "ticket_id": 15286,
            "ticket_number": "3515274",
            "title": "Confirmação reserva Bedsonline 436-7268657",
            "priority": "P2",
            "created_at": "15/04/2026 16:23:40",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:54:43"
          },
          {
            "ticket_id": 15297,
            "ticket_number": "3515285",
            "title": "Fwd: Viagify informa sobre a sua reserva 127014694",
            "priority": "P2",
            "created_at": "15/04/2026 17:26:21",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:26:21"
          },
          {
            "ticket_id": 15302,
            "ticket_number": "3515290",
            "title": "[Cancelamento Viagem] TRP-2026-03032 - Eduardo Men",
            "priority": "P2",
            "created_at": "15/04/2026 18:19:31",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 18:19:31"
          },
          {
            "ticket_id": 15303,
            "ticket_number": "3515291",
            "title": "Fwd: Recebeu uma nova mensagem TTN-1265879373#9903",
            "priority": "P2",
            "created_at": "15/04/2026 18:59:36",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 18:59:37"
          },
          {
            "ticket_id": 15306,
            "ticket_number": "3515294",
            "title": "Informação e entrevista",
            "priority": "P2",
            "created_at": "15/04/2026 19:00:08",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 22:43:33"
          },
          {
            "ticket_id": 15308,
            "ticket_number": "3515296",
            "title": "GBN-118770 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/04/2026 19:29:09",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 19:29:09"
          },
          {
            "ticket_id": 15309,
            "ticket_number": "3515297",
            "title": "Soltropico - 344285",
            "priority": "P2",
            "created_at": "15/04/2026 19:29:10",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 19:29:10"
          },
          {
            "ticket_id": 15315,
            "ticket_number": "3515303",
            "title": "GBN-118770 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/04/2026 21:18:52",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 20:39:48"
          },
          {
            "ticket_id": 15316,
            "ticket_number": "3515304",
            "title": "GBN-118606 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/04/2026 22:08:58",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 22:14:34"
          },
          {
            "ticket_id": 15319,
            "ticket_number": "3515307",
            "title": "[Cancelamento Serviço] TRP-2026-04702 / TRL-2026-0",
            "priority": "P2",
            "created_at": "15/04/2026 22:50:30",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 22:50:31"
          },
          {
            "ticket_id": 15323,
            "ticket_number": "3515311",
            "title": "[Cancelamento Serviço] TRP-2026-03329 / TRL-2026-0",
            "priority": "P2",
            "created_at": "16/04/2026 08:38:31",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 08:38:31"
          },
          {
            "ticket_id": 15326,
            "ticket_number": "3515314",
            "title": "GBN-118797 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/04/2026 09:12:36",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:12:36"
          },
          {
            "ticket_id": 15327,
            "ticket_number": "3515315",
            "title": "GBN-118795 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/04/2026 09:12:40",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:12:40"
          },
          {
            "ticket_id": 15330,
            "ticket_number": "3515318",
            "title": "TRP-2026-03726 | Extensão do seguro de uma passage",
            "priority": "P2",
            "created_at": "16/04/2026 09:35:36",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:35:36"
          },
          {
            "ticket_id": 15331,
            "ticket_number": "3515319",
            "title": "Fwd: Viagify informa sobre a sua reserva 127029149",
            "priority": "P2",
            "created_at": "16/04/2026 09:46:04",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:46:05"
          },
          {
            "ticket_id": 15332,
            "ticket_number": "3515320",
            "title": "Fwd: Viagify informa sobre a sua reserva 127028021",
            "priority": "P2",
            "created_at": "16/04/2026 09:46:07",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:46:08"
          },
          {
            "ticket_id": 15333,
            "ticket_number": "3515321",
            "title": "Fwd: Viagify informa sobre a sua reserva 127029149",
            "priority": "P2",
            "created_at": "16/04/2026 09:46:10",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:46:11"
          },
          {
            "ticket_id": 15334,
            "ticket_number": "3515322",
            "title": "Fwd: Viagify informa sobre a sua reserva 127028021",
            "priority": "P2",
            "created_at": "16/04/2026 09:46:13",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 09:46:14"
          },
          {
            "ticket_id": 15336,
            "ticket_number": "3515324",
            "title": "Documentação Disponível - Reserva 334072",
            "priority": "P2",
            "created_at": "16/04/2026 10:03:05",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:31:01"
          },
          {
            "ticket_id": 15338,
            "ticket_number": "3515326",
            "title": "Documentação Disponível - Reserva 334667",
            "priority": "P2",
            "created_at": "16/04/2026 10:03:10",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:38:53"
          },
          {
            "ticket_id": 15339,
            "ticket_number": "3515327",
            "title": "GBN-113247 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/04/2026 10:04:08",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:52:33"
          },
          {
            "ticket_id": 15340,
            "ticket_number": "3515328",
            "title": "GBN-108609 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/04/2026 10:04:09",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:52:40"
          },
          {
            "ticket_id": 15343,
            "ticket_number": "3515331",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "16/04/2026 10:39:46",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:50:26"
          },
          {
            "ticket_id": 15344,
            "ticket_number": "3515332",
            "title": "Re:[## 38297 ##] GBN-115505 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "16/04/2026 11:52:54",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 21:06:52"
          },
          {
            "ticket_id": 15346,
            "ticket_number": "3515334",
            "title": "Fwd: Informações da reserva TTN-1133020231#9911954",
            "priority": "P2",
            "created_at": "16/04/2026 12:09:27",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:09:28"
          },
          {
            "ticket_id": 15349,
            "ticket_number": "3515337",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:00",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:00"
          },
          {
            "ticket_id": 15350,
            "ticket_number": "3515338",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:07",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:07"
          },
          {
            "ticket_id": 15351,
            "ticket_number": "3515339",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:11",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:11"
          },
          {
            "ticket_id": 15352,
            "ticket_number": "3515340",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:15",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:15"
          },
          {
            "ticket_id": 15353,
            "ticket_number": "3515341",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:24",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:24"
          },
          {
            "ticket_id": 15354,
            "ticket_number": "3515342",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 12:30:38",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 12:30:38"
          },
          {
            "ticket_id": 15355,
            "ticket_number": "3515343",
            "title": "Confirmação de reserva com localizador: 4174711",
            "priority": "P2",
            "created_at": "16/04/2026 12:58:07",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:21:45"
          },
          {
            "ticket_id": 15356,
            "ticket_number": "3515344",
            "title": "Solole. Booking 2TUEPWDH is close to entering expe",
            "priority": "P2",
            "created_at": "16/04/2026 14:11:39",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:24:20"
          },
          {
            "ticket_id": 15359,
            "ticket_number": "3515347",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/04/2026 14:12:20",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 14:12:20"
          },
          {
            "ticket_id": 15360,
            "ticket_number": "3515348",
            "title": "GBN-96959 - Reenviar informações sobre sua reserva",
            "priority": "P2",
            "created_at": "16/04/2026 14:12:37",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:22:42"
          },
          {
            "ticket_id": 15362,
            "ticket_number": "3515350",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "16/04/2026 14:26:49",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:20:58"
          },
          {
            "ticket_id": 15365,
            "ticket_number": "3515353",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "16/04/2026 15:14:34",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:19:30"
          },
          {
            "ticket_id": 15372,
            "ticket_number": "3515360",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604569266",
            "priority": "P2",
            "created_at": "16/04/2026 17:02:39",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 17:51:41"
          },
          {
            "ticket_id": 15390,
            "ticket_number": "3515378",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "16/04/2026 22:08:28",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 13.15,
            "sla_met": false,
            "sla_breach_hours": 9.15,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:18:13"
          },
          {
            "ticket_id": 15416,
            "ticket_number": "3515404",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604535689",
            "priority": "P2",
            "created_at": "17/04/2026 09:17:25",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:54:00"
          },
          {
            "ticket_id": 15425,
            "ticket_number": "3515413",
            "title": "Confirmação de reserva – Ref PP175182, Sr. MARCELO",
            "priority": "P2",
            "created_at": "17/04/2026 10:14:38",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:44:01"
          },
          {
            "ticket_id": 15426,
            "ticket_number": "3515414",
            "title": "***** MALDIVAS Back to Nature *****",
            "priority": "P2",
            "created_at": "17/04/2026 10:14:45",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:58:54"
          },
          {
            "ticket_id": 15430,
            "ticket_number": "3515418",
            "title": "Confirmação de Reserva * File 438792",
            "priority": "P1",
            "created_at": "17/04/2026 10:32:52",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.63,
            "sla_met": false,
            "sla_breach_hours": 0.38,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 11:11:43"
          },
          {
            "ticket_id": 15437,
            "ticket_number": "3515425",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60451717",
            "priority": "P2",
            "created_at": "17/04/2026 10:48:49",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:58:04"
          },
          {
            "ticket_id": 15442,
            "ticket_number": "3515430",
            "title": "VJT: Documentação de Viagem Djerba 213587",
            "priority": "P3",
            "created_at": "17/04/2026 11:16:30",
            "close_date": "2026-04-17",
            "sla_target_hours": 24,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/04/2026 12:16:56"
          },
          {
            "ticket_id": 15444,
            "ticket_number": "3515432",
            "title": "Envio de Fatura 213587",
            "priority": "P2",
            "created_at": "17/04/2026 11:16:34",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:19:51"
          },
          {
            "ticket_id": 15446,
            "ticket_number": "3515434",
            "title": "Orçamento Quadrantes Tanzânia 2027",
            "priority": "P2",
            "created_at": "17/04/2026 11:27:04",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:27:04"
          },
          {
            "ticket_id": 15448,
            "ticket_number": "3515436",
            "title": "Importante - Checkin Online Voos TAP - FILE 344285",
            "priority": "P2",
            "created_at": "17/04/2026 12:11:41",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 12:21:18"
          },
          {
            "ticket_id": 15449,
            "ticket_number": "3515437",
            "title": "Pedido acesso",
            "priority": "P2",
            "created_at": "17/04/2026 12:25:43",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 12:25:43"
          },
          {
            "ticket_id": 15456,
            "ticket_number": "3515444",
            "title": "Duvido Insure",
            "priority": "P2",
            "created_at": "17/04/2026 13:40:59",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 13:40:59"
          },
          {
            "ticket_id": 15460,
            "ticket_number": "3515448",
            "title": "COSTA CRUZEIROS — Tudo Incluído que se vende sozin",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:18",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 17:41:57"
          },
          {
            "ticket_id": 15461,
            "ticket_number": "3515449",
            "title": "RECUPERADO: Amadeus Central Reservation: Editora: ",
            "priority": "P2",
            "created_at": "17/04/2026 14:49:20",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:26:36"
          },
          {
            "ticket_id": 15475,
            "ticket_number": "3515463",
            "title": "urgente: GBN-113981",
            "priority": "P2",
            "created_at": "17/04/2026 15:41:22",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 15:41:22"
          },
          {
            "ticket_id": 15478,
            "ticket_number": "3515466",
            "title": "GBN-111483 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "17/04/2026 16:02:04",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 16:02:04"
          },
          {
            "ticket_id": 15479,
            "ticket_number": "3515467",
            "title": "Solole. Booking 2TUEPWDH is close to entering expe",
            "priority": "P2",
            "created_at": "17/04/2026 16:02:07",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:53:55"
          },
          {
            "ticket_id": 15481,
            "ticket_number": "3515469",
            "title": "Confirmação de reserva com localizador: 4177028",
            "priority": "P2",
            "created_at": "17/04/2026 16:02:13",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:30:20"
          },
          {
            "ticket_id": 15485,
            "ticket_number": "3515473",
            "title": "Confirmação reserva Bedsonline 213-2227017",
            "priority": "P2",
            "created_at": "17/04/2026 16:58:36",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:47:19"
          },
          {
            "ticket_id": 15487,
            "ticket_number": "3515475",
            "title": "[Suporte] TRP-2026-03666 / TRL-2026-05583 - Reserv",
            "priority": "P2",
            "created_at": "17/04/2026 17:23:55",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 17:23:55"
          },
          {
            "ticket_id": 15491,
            "ticket_number": "3515479",
            "title": "Confirmação de reserva com localizador: 4177630",
            "priority": "P2",
            "created_at": "17/04/2026 18:11:21",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 18:46:46"
          },
          {
            "ticket_id": 15508,
            "ticket_number": "3515496",
            "title": "Informação de reserva - SPT002601622816",
            "priority": "P2",
            "created_at": "17/04/2026 22:35:06",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 12.6,
            "sla_met": false,
            "sla_breach_hours": 8.6,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 11:11:39"
          },
          {
            "ticket_id": 15510,
            "ticket_number": "3515498",
            "title": "[Suporte] TRP-2026-03319 / TRL-2026-05108 - Juntar",
            "priority": "P2",
            "created_at": "17/04/2026 22:35:17",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 22:35:17"
          },
          {
            "ticket_id": 15513,
            "ticket_number": "3515501",
            "title": "Envio de Cert. Seguro * File 437298",
            "priority": "P2",
            "created_at": "18/04/2026 09:02:00",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 11:13:01"
          },
          {
            "ticket_id": 15514,
            "ticket_number": "3515502",
            "title": "[Suporte] TRP-2026-04791 - Duplicação de reserva",
            "priority": "P2",
            "created_at": "18/04/2026 09:58:40",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 09:58:40"
          },
          {
            "ticket_id": 15515,
            "ticket_number": "3515503",
            "title": "Debito duplicado de mensalidade",
            "priority": "P2",
            "created_at": "18/04/2026 10:25:08",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 10:25:09"
          },
          {
            "ticket_id": 15516,
            "ticket_number": "3515504",
            "title": "URGENTE URGENTE EMISSÃO Rsv Especial IB (NDC)  == ",
            "priority": "P1",
            "created_at": "18/04/2026 10:26:39",
            "close_date": "2026-04-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/04/2026 10:27:44"
          },
          {
            "ticket_id": 15521,
            "ticket_number": "3515509",
            "title": "Códigos de reserva - voos",
            "priority": "P3",
            "created_at": "18/04/2026 12:45:57",
            "close_date": "2026-05-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/04/2026 12:45:57"
          },
          {
            "ticket_id": 15526,
            "ticket_number": "3515514",
            "title": "Fwd: Informações da reserva TTN-1271078251#9932145",
            "priority": "P2",
            "created_at": "18/04/2026 12:52:38",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:52:38"
          },
          {
            "ticket_id": 15527,
            "ticket_number": "3515515",
            "title": "Mensalidade duplicada",
            "priority": "P2",
            "created_at": "18/04/2026 13:59:01",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 13:59:01"
          },
          {
            "ticket_id": 15528,
            "ticket_number": "3515516",
            "title": "Re:[## 38554 ##] GBN-115717 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "18/04/2026 13:59:03",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 15:14:37"
          },
          {
            "ticket_id": 15532,
            "ticket_number": "3515520",
            "title": "Acesso Odisseias",
            "priority": "P2",
            "created_at": "18/04/2026 15:18:09",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 15:18:09"
          },
          {
            "ticket_id": 15535,
            "ticket_number": "3515523",
            "title": "[Suporte] TRP-2026-02694 - pagamento",
            "priority": "P2",
            "created_at": "18/04/2026 15:26:51",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 15:26:52"
          },
          {
            "ticket_id": 15544,
            "ticket_number": "3515532",
            "title": "Fwd: Reserva pendente à espera de emissão",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:27",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:27"
          },
          {
            "ticket_id": 15549,
            "ticket_number": "3515537",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:37",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:46:50"
          },
          {
            "ticket_id": 15559,
            "ticket_number": "3515547",
            "title": "Fwd: resposta à consulta TTN-1271255847#99356191#T",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:02",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:07:02"
          },
          {
            "ticket_id": 15564,
            "ticket_number": "3515552",
            "title": "Solole. Booking ZNAF4VSC is close to entering expe",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:12",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:34:22"
          },
          {
            "ticket_id": 15571,
            "ticket_number": "3515559",
            "title": "Mensalidade duplicada",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:29",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:07:29"
          },
          {
            "ticket_id": 15581,
            "ticket_number": "3515569",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:05",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:32:07"
          },
          {
            "ticket_id": 15595,
            "ticket_number": "3515583",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/04/2026 09:22:29",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 583.47,
            "sla_met": false,
            "sla_breach_hours": 579.47,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:51:07"
          },
          {
            "ticket_id": 15596,
            "ticket_number": "3515584",
            "title": "Informação importante sobre a tua reserva 6145102",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:36",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:32:14"
          },
          {
            "ticket_id": 15598,
            "ticket_number": "3515586",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:42",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:00:42"
          },
          {
            "ticket_id": 15599,
            "ticket_number": "3515587",
            "title": "Informação importante sobre a tua reserva 6122906",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:45",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:11:34"
          },
          {
            "ticket_id": 15600,
            "ticket_number": "3515588",
            "title": "Informação importante sobre a tua reserva 6122921",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:47",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:58:53"
          },
          {
            "ticket_id": 15601,
            "ticket_number": "3515589",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:51",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:00:51"
          },
          {
            "ticket_id": 15602,
            "ticket_number": "3515590",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:58",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:00:58"
          },
          {
            "ticket_id": 15603,
            "ticket_number": "3515591",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 10:01:02",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:01:02"
          },
          {
            "ticket_id": 15604,
            "ticket_number": "3515592",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 10:01:07",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:01:07"
          },
          {
            "ticket_id": 15605,
            "ticket_number": "3515593",
            "title": "Informação importante sobre a tua reserva 6122902",
            "priority": "P2",
            "created_at": "20/04/2026 10:01:09",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:35:59"
          },
          {
            "ticket_id": 15609,
            "ticket_number": "3515597",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "20/04/2026 10:32:20",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:55:46"
          },
          {
            "ticket_id": 15611,
            "ticket_number": "3515599",
            "title": "Informação de reserva - SPT002601622816",
            "priority": "P2",
            "created_at": "20/04/2026 11:20:37",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:32:51"
          },
          {
            "ticket_id": 15613,
            "ticket_number": "3515601",
            "title": "Três formas de viver o Algarve, até 35% de descont",
            "priority": "P2",
            "created_at": "20/04/2026 11:20:41",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:31:27"
          },
          {
            "ticket_id": 15614,
            "ticket_number": "3515602",
            "title": "Re: Confirmação reserva - 344478",
            "priority": "P2",
            "created_at": "20/04/2026 11:20:43",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:20:09"
          },
          {
            "ticket_id": 15615,
            "ticket_number": "3515603",
            "title": "Joana Fernandes pagamento duplicado",
            "priority": "P2",
            "created_at": "20/04/2026 11:20:45",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:20:09"
          },
          {
            "ticket_id": 15617,
            "ticket_number": "3515605",
            "title": "Confirmação de reserva para For PT004157 70358738",
            "priority": "P2",
            "created_at": "20/04/2026 11:21:03",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:23:00"
          },
          {
            "ticket_id": 15619,
            "ticket_number": "3515607",
            "title": "Reserva confirmada: Ingresso do Palácio da Pena e ",
            "priority": "P2",
            "created_at": "20/04/2026 11:37:09",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:46:36"
          },
          {
            "ticket_id": 15620,
            "ticket_number": "3515608",
            "title": "Reserva confirmada: Ingresso do Palácio da Pena e ",
            "priority": "P2",
            "created_at": "20/04/2026 11:37:11",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:45:57"
          },
          {
            "ticket_id": 15621,
            "ticket_number": "3515609",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604618103",
            "priority": "P2",
            "created_at": "20/04/2026 11:44:08",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:46:26"
          },
          {
            "ticket_id": 15622,
            "ticket_number": "3515610",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604618110",
            "priority": "P2",
            "created_at": "20/04/2026 11:55:14",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:14:12"
          },
          {
            "ticket_id": 15626,
            "ticket_number": "3515614",
            "title": "Débito directo duplicado",
            "priority": "P2",
            "created_at": "20/04/2026 12:41:23",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:47:03"
          },
          {
            "ticket_id": 15652,
            "ticket_number": "3515640",
            "title": "GBN-119467 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "20/04/2026 15:00:57",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:00:57"
          },
          {
            "ticket_id": 15653,
            "ticket_number": "3515641",
            "title": "[Suporte] TRP-2026-03573 / TRL-2026-05441 - Declar",
            "priority": "P2",
            "created_at": "20/04/2026 15:06:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:06:20"
          },
          {
            "ticket_id": 15660,
            "ticket_number": "3515648",
            "title": "Subscrição",
            "priority": "P2",
            "created_at": "20/04/2026 15:17:01",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 20.82,
            "sla_met": false,
            "sla_breach_hours": 16.82,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:06:57"
          },
          {
            "ticket_id": 15663,
            "ticket_number": "3515651",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "20/04/2026 15:43:35",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:26:09"
          },
          {
            "ticket_id": 15667,
            "ticket_number": "3515655",
            "title": "Fwd: Viagify informa sobre a sua reserva 127177615",
            "priority": "P2",
            "created_at": "20/04/2026 16:05:05",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:05:06"
          },
          {
            "ticket_id": 15669,
            "ticket_number": "3515657",
            "title": "GBN Travel: Resend booking confirmation - GBN-9064",
            "priority": "P2",
            "created_at": "20/04/2026 16:05:36",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:05:36"
          },
          {
            "ticket_id": 15670,
            "ticket_number": "3515658",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 16:15:38",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:15:38"
          },
          {
            "ticket_id": 15671,
            "ticket_number": "3515659",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 16:15:41",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:15:41"
          },
          {
            "ticket_id": 15672,
            "ticket_number": "3515660",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 16:15:48",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:15:48"
          },
          {
            "ticket_id": 15673,
            "ticket_number": "3515661",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 16:15:51",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:15:51"
          },
          {
            "ticket_id": 15674,
            "ticket_number": "3515662",
            "title": "MVU: Cambio Vuelo: 4133903 FAMILIAP 001",
            "priority": "P2",
            "created_at": "20/04/2026 16:15:54",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:30:26"
          },
          {
            "ticket_id": 15676,
            "ticket_number": "3515664",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:23",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 18:35:32"
          },
          {
            "ticket_id": 15677,
            "ticket_number": "3515665",
            "title": "Pagamento da reserva – Ref PP924615, Sr. Joaquim D",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:24",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 18:00:55"
          },
          {
            "ticket_id": 15679,
            "ticket_number": "3515667",
            "title": "pedido de PNR reserva GBN-115697",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:28",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:24:28"
          },
          {
            "ticket_id": 15681,
            "ticket_number": "3515669",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:37",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 18:11:49"
          },
          {
            "ticket_id": 15684,
            "ticket_number": "3515672",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/04/2026 17:41:29",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:41:29"
          },
          {
            "ticket_id": 15705,
            "ticket_number": "3515693",
            "title": "FW: Já pode descarregar a sua fatura 01-03-2026 a ",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:06",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:14:52"
          },
          {
            "ticket_id": 15713,
            "ticket_number": "3515701",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:23",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:16:00"
          },
          {
            "ticket_id": 15728,
            "ticket_number": "3515716",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "21/04/2026 11:52:07",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 15:42:25"
          },
          {
            "ticket_id": 15742,
            "ticket_number": "3515730",
            "title": "RESERVA WL 344478",
            "priority": "P2",
            "created_at": "21/04/2026 12:43:16",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:43:50"
          },
          {
            "ticket_id": 15803,
            "ticket_number": "3515791",
            "title": "[Cancelamento Serviço] TRP-2026-04801 / TRL-2026-0",
            "priority": "P2",
            "created_at": "22/04/2026 00:02:03",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 9.8,
            "sla_met": false,
            "sla_breach_hours": 5.8,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:50:43"
          },
          {
            "ticket_id": 15812,
            "ticket_number": "3515800",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/04/2026 09:05:38",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 13:00:32"
          },
          {
            "ticket_id": 15816,
            "ticket_number": "3515804",
            "title": "Informação importante sobre a tua reserva 6127246",
            "priority": "P2",
            "created_at": "22/04/2026 09:52:47",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:53:20"
          },
          {
            "ticket_id": 15817,
            "ticket_number": "3515805",
            "title": "Cancelamento de reserva 344478",
            "priority": "P2",
            "created_at": "22/04/2026 10:24:55",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:41:16"
          },
          {
            "ticket_id": 15835,
            "ticket_number": "3515823",
            "title": "GBN-119941 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/04/2026 11:52:16",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:52:16"
          },
          {
            "ticket_id": 15840,
            "ticket_number": "3515828",
            "title": "Fwd: Informações sobre a sua reserva TTN-126834783",
            "priority": "P2",
            "created_at": "22/04/2026 14:14:08",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 18:59:38"
          },
          {
            "ticket_id": 15852,
            "ticket_number": "3515840",
            "title": "Importante - Checkin Online Voos TAP - FILE 340001",
            "priority": "P2",
            "created_at": "22/04/2026 15:43:27",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:54:45"
          },
          {
            "ticket_id": 15855,
            "ticket_number": "3515843",
            "title": "informação importante sobre a reserva 6127077",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:24",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:11:24"
          },
          {
            "ticket_id": 15856,
            "ticket_number": "3515844",
            "title": "informação importante sobre a reserva 6126895",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:12:19"
          },
          {
            "ticket_id": 15857,
            "ticket_number": "3515845",
            "title": "informação importante sobre a reserva 6143966",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:27",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:15:11"
          },
          {
            "ticket_id": 15858,
            "ticket_number": "3515846",
            "title": "informação importante sobre a reserva 6126890",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:29",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:16:45"
          },
          {
            "ticket_id": 15859,
            "ticket_number": "3515847",
            "title": "informação importante sobre a reserva 6121385",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:30",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:18:19"
          },
          {
            "ticket_id": 15860,
            "ticket_number": "3515848",
            "title": "informação importante sobre a reserva 6124862",
            "priority": "P2",
            "created_at": "22/04/2026 16:09:32",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:13:12"
          },
          {
            "ticket_id": 15862,
            "ticket_number": "3515850",
            "title": "Informação importante para reserva 6122131",
            "priority": "P2",
            "created_at": "22/04/2026 16:15:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:20:12"
          },
          {
            "ticket_id": 15867,
            "ticket_number": "3515855",
            "title": "Proforma CnTravel 93130248",
            "priority": "P2",
            "created_at": "22/04/2026 17:10:41",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 17:14:44"
          },
          {
            "ticket_id": 15868,
            "ticket_number": "3515856",
            "title": "Fwd: Viagify informa sobre a sua reserva 127269253",
            "priority": "P2",
            "created_at": "22/04/2026 17:10:42",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 17:10:43"
          },
          {
            "ticket_id": 15871,
            "ticket_number": "3515859",
            "title": "Fwd: Viagify informa sobre a sua reserva 127269253",
            "priority": "P2",
            "created_at": "22/04/2026 17:10:49",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 17:10:50"
          },
          {
            "ticket_id": 15874,
            "ticket_number": "3515862",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/04/2026 18:02:53",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:02:53"
          },
          {
            "ticket_id": 15875,
            "ticket_number": "3515863",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:02",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:03:02"
          },
          {
            "ticket_id": 15876,
            "ticket_number": "3515864",
            "title": "Pagamento -  (Recibo-2147846369)",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:05",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:09:47"
          },
          {
            "ticket_id": 15877,
            "ticket_number": "3515865",
            "title": "GBN-116792 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:09",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:03:09"
          },
          {
            "ticket_id": 15883,
            "ticket_number": "3515871",
            "title": "***** MALDIVAS // ECOBOO HOTEL *****",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:27",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:05:12"
          },
          {
            "ticket_id": 15946,
            "ticket_number": "3515934",
            "title": "Confimação da reserva - Neblue 6124315",
            "priority": "P2",
            "created_at": "23/04/2026 12:58:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:58:34"
          },
          {
            "ticket_id": 15961,
            "ticket_number": "3515949",
            "title": "Confirmação de reserva 336196 ####BILHETES EMITIDO",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:28",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:51:01"
          },
          {
            "ticket_id": 15973,
            "ticket_number": "3515961",
            "title": "Dúvida Viagem Zanzibar",
            "priority": "P2",
            "created_at": "23/04/2026 17:11:01",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 17:11:02"
          },
          {
            "ticket_id": 15981,
            "ticket_number": "3515969",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "23/04/2026 18:13:11",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:13:11"
          },
          {
            "ticket_id": 15982,
            "ticket_number": "3515970",
            "title": "GBN-116784 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "23/04/2026 18:13:14",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:13:14"
          },
          {
            "ticket_id": 15983,
            "ticket_number": "3515971",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "23/04/2026 18:13:18",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:13:18"
          },
          {
            "ticket_id": 15985,
            "ticket_number": "3515973",
            "title": "GBN-120331 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "23/04/2026 18:58:14",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:58:14"
          },
          {
            "ticket_id": 15986,
            "ticket_number": "3515974",
            "title": "GBN-92041 - Reenviar informações sobre sua reserva",
            "priority": "P2",
            "created_at": "23/04/2026 18:58:16",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:58:16"
          },
          {
            "ticket_id": 15988,
            "ticket_number": "3515976",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "23/04/2026 18:58:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:58:23"
          },
          {
            "ticket_id": 16007,
            "ticket_number": "3515995",
            "title": "Número de informação da reserva: 6146286",
            "priority": "P2",
            "created_at": "24/04/2026 09:09:37",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 10:16:16"
          },
          {
            "ticket_id": 16011,
            "ticket_number": "3515999",
            "title": "MSC Cruises Document - 2600101003018176",
            "priority": "P2",
            "created_at": "24/04/2026 09:09:48",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:50:37"
          },
          {
            "ticket_id": 16012,
            "ticket_number": "3516000",
            "title": "MSC Cruises Document - 2600101003018178",
            "priority": "P2",
            "created_at": "24/04/2026 09:09:50",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:52:35"
          },
          {
            "ticket_id": 16013,
            "ticket_number": "3516001",
            "title": "MSC Cruises Document - 2600101003018179",
            "priority": "P2",
            "created_at": "24/04/2026 09:09:51",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:52:15"
          },
          {
            "ticket_id": 16014,
            "ticket_number": "3516002",
            "title": "MSC Cruises Document - 2600101003018177",
            "priority": "P2",
            "created_at": "24/04/2026 09:09:53",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:51:03"
          },
          {
            "ticket_id": 16018,
            "ticket_number": "3516006",
            "title": "Confirmação de reserva – Ref PP116492, Sra. Joana ",
            "priority": "P2",
            "created_at": "24/04/2026 09:10:05",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:59:05"
          },
          {
            "ticket_id": 16021,
            "ticket_number": "3516009",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "24/04/2026 09:20:03",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:26:24"
          },
          {
            "ticket_id": 16025,
            "ticket_number": "3516013",
            "title": "Cancelamento de Reservas 436-7268657 Bedsonline",
            "priority": "P2",
            "created_at": "24/04/2026 09:41:34",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:15:29"
          },
          {
            "ticket_id": 16026,
            "ticket_number": "3516014",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604621556",
            "priority": "P2",
            "created_at": "24/04/2026 09:41:36",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:46:04"
          },
          {
            "ticket_id": 16028,
            "ticket_number": "3516016",
            "title": "[Cancelamento Viagem] TRP-2026-04756 - Eunice Raqu",
            "priority": "P2",
            "created_at": "24/04/2026 10:27:07",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 10:27:07"
          },
          {
            "ticket_id": 16032,
            "ticket_number": "3516020",
            "title": "Novos tours na Civitatis.com",
            "priority": "P2",
            "created_at": "24/04/2026 11:13:17",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:04:51"
          },
          {
            "ticket_id": 16035,
            "ticket_number": "3516023",
            "title": "Fwd: SOLFÉRIAS | NOVA CAMPANHA DISNEYLAND® PARIS *",
            "priority": "P2",
            "created_at": "24/04/2026 11:13:35",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 11:13:36"
          },
          {
            "ticket_id": 16042,
            "ticket_number": "3516030",
            "title": "RE: ERRO ao selecionar alojamento",
            "priority": "P2",
            "created_at": "24/04/2026 12:28:03",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:34:06"
          },
          {
            "ticket_id": 16056,
            "ticket_number": "3516044",
            "title": "Última chamada: Cruzeiros Fluviais com 7% de desco",
            "priority": "P2",
            "created_at": "24/04/2026 15:19:24",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:58:59"
          },
          {
            "ticket_id": 16060,
            "ticket_number": "3516048",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "24/04/2026 15:20:26",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:20:26"
          },
          {
            "ticket_id": 16067,
            "ticket_number": "3516055",
            "title": "Documentação Disponível - Reserva 336458",
            "priority": "P2",
            "created_at": "24/04/2026 17:35:17",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:58:32"
          },
          {
            "ticket_id": 16068,
            "ticket_number": "3516056",
            "title": "Documentação Disponível - Reserva 334421",
            "priority": "P2",
            "created_at": "24/04/2026 17:35:18",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:57:43"
          },
          {
            "ticket_id": 16073,
            "ticket_number": "3516061",
            "title": "Pedido e cotação (Magali)",
            "priority": "P1",
            "created_at": "24/04/2026 17:59:19",
            "close_date": "2026-05-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "24/04/2026 17:59:20"
          },
          {
            "ticket_id": 16152,
            "ticket_number": "3516140",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/04/2026 09:12:11",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:17:14"
          },
          {
            "ticket_id": 16153,
            "ticket_number": "3516141",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/04/2026 09:12:12",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:35:41"
          },
          {
            "ticket_id": 16182,
            "ticket_number": "3516170",
            "title": "Fwd: Informações da sua reserva TTN-1273678002#100",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:32",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:32"
          },
          {
            "ticket_id": 16183,
            "ticket_number": "3516171",
            "title": "Fwd: Informações da reserva",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:35",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:35"
          },
          {
            "ticket_id": 16184,
            "ticket_number": "3516172",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:37",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:06:55"
          },
          {
            "ticket_id": 16187,
            "ticket_number": "3516175",
            "title": "Pagamento da reserva – Ref PP457698, Sr. Jose Tiag",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:43",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:29:45"
          },
          {
            "ticket_id": 16189,
            "ticket_number": "3516177",
            "title": "Fwd: Informações da sua reserva TTN-1273679729#100",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:47",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:48"
          },
          {
            "ticket_id": 16197,
            "ticket_number": "3516185",
            "title": "GBN-120662 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 10:05:34",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:05:34"
          },
          {
            "ticket_id": 16203,
            "ticket_number": "3516191",
            "title": "GBN-120743 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 10:47:13",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:47:13"
          },
          {
            "ticket_id": 16204,
            "ticket_number": "3516192",
            "title": "GBN-120746 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "27/04/2026 10:47:18",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:47:18"
          },
          {
            "ticket_id": 16205,
            "ticket_number": "3516193",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 10:47:26",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:47:26"
          },
          {
            "ticket_id": 16206,
            "ticket_number": "3516194",
            "title": "Proforma CnTravel 93130248",
            "priority": "P2",
            "created_at": "27/04/2026 10:58:08",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:24:42"
          },
          {
            "ticket_id": 16209,
            "ticket_number": "3516197",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "27/04/2026 11:44:56",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:51:37"
          },
          {
            "ticket_id": 16220,
            "ticket_number": "3516208",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "27/04/2026 12:01:28",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:03:43"
          },
          {
            "ticket_id": 16222,
            "ticket_number": "3516210",
            "title": "Dúvida cliente",
            "priority": "P2",
            "created_at": "27/04/2026 12:35:34",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:35:34"
          },
          {
            "ticket_id": 16229,
            "ticket_number": "3516217",
            "title": "Envio de Nota de Crédito 28581/26",
            "priority": "P2",
            "created_at": "27/04/2026 13:04:13",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:07:54"
          },
          {
            "ticket_id": 16232,
            "ticket_number": "3516220",
            "title": "[Suporte] TRP-2026-04883 - Cancelamento e nova res",
            "priority": "P2",
            "created_at": "27/04/2026 13:51:27",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:51:27"
          },
          {
            "ticket_id": 16234,
            "ticket_number": "3516222",
            "title": "[Cancelamento Viagem] TRP-2026-04788 - Catarina Ba",
            "priority": "P2",
            "created_at": "27/04/2026 14:58:31",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:19:16"
          },
          {
            "ticket_id": 16235,
            "ticket_number": "3516223",
            "title": "Confirmação de reserva com localizador: 4191474",
            "priority": "P2",
            "created_at": "27/04/2026 15:06:53",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 15:13:00"
          },
          {
            "ticket_id": 16244,
            "ticket_number": "3516232",
            "title": "Pagamento da reserva – Ref PP971723, Sr. Claudio  ",
            "priority": "P2",
            "created_at": "27/04/2026 16:53:15",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:17:31"
          },
          {
            "ticket_id": 16245,
            "ticket_number": "3516233",
            "title": "Pagamento da reserva – Ref PP175182, Sr. MARCELO A",
            "priority": "P2",
            "created_at": "27/04/2026 16:53:17",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:37:34"
          },
          {
            "ticket_id": 16247,
            "ticket_number": "3516235",
            "title": "Cancelar subscrição",
            "priority": "P2",
            "created_at": "27/04/2026 17:07:21",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 21:04:49"
          },
          {
            "ticket_id": 16250,
            "ticket_number": "3516238",
            "title": "Informações sobre o operador do Pedido Nº 13654891",
            "priority": "P2",
            "created_at": "27/04/2026 17:27:23",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 17:36:37"
          },
          {
            "ticket_id": 16251,
            "ticket_number": "3516239",
            "title": "Importante - Checkin Online Voos TAP - FILE 334072",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:02",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:06:07"
          },
          {
            "ticket_id": 16252,
            "ticket_number": "3516240",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:05",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:05:06"
          },
          {
            "ticket_id": 16253,
            "ticket_number": "3516241",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:15",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:05:15"
          },
          {
            "ticket_id": 16255,
            "ticket_number": "3516243",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:20",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:32:36"
          },
          {
            "ticket_id": 16257,
            "ticket_number": "3516245",
            "title": "Importante - Checkin Online Voos TAP - FILE 334667",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:24",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:16:26"
          },
          {
            "ticket_id": 16258,
            "ticket_number": "3516246",
            "title": "Importante - Checkin Online Voos TAP - FILE 334059",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:26",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:10:56"
          },
          {
            "ticket_id": 16260,
            "ticket_number": "3516248",
            "title": "Confirmação de reserva para For PT004157",
            "priority": "P2",
            "created_at": "27/04/2026 18:05:30",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:19:01"
          },
          {
            "ticket_id": 16262,
            "ticket_number": "3516250",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:07:41",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:07:41"
          },
          {
            "ticket_id": 16263,
            "ticket_number": "3516251",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:07:46",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:07:46"
          },
          {
            "ticket_id": 16264,
            "ticket_number": "3516252",
            "title": "Confirmação de reserva para For PT004157 71741223",
            "priority": "P2",
            "created_at": "27/04/2026 18:07:49",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:31:12"
          },
          {
            "ticket_id": 16265,
            "ticket_number": "3516253",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:15",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:15"
          },
          {
            "ticket_id": 16266,
            "ticket_number": "3516254",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:19",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:19"
          },
          {
            "ticket_id": 16267,
            "ticket_number": "3516255",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:23",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:23"
          },
          {
            "ticket_id": 16268,
            "ticket_number": "3516256",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:31",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:31"
          },
          {
            "ticket_id": 16269,
            "ticket_number": "3516257",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:40",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:41"
          },
          {
            "ticket_id": 16270,
            "ticket_number": "3516258",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "27/04/2026 18:33:44",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:33:44"
          },
          {
            "ticket_id": 16308,
            "ticket_number": "3516296",
            "title": "MSC Cruises Document - 2600101003110011",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:23",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:12:25"
          },
          {
            "ticket_id": 16309,
            "ticket_number": "3516297",
            "title": "GBN-109961 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:27",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:05:53"
          },
          {
            "ticket_id": 16310,
            "ticket_number": "3516298",
            "title": "Informação de reserva - SPT002601626063",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:32",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:06:25"
          },
          {
            "ticket_id": 16315,
            "ticket_number": "3516303",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:43",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:00:42"
          },
          {
            "ticket_id": 16329,
            "ticket_number": "3516317",
            "title": "Fwd: Os seus cartões de embarque estão prontos!🎉",
            "priority": "P2",
            "created_at": "28/04/2026 11:39:05",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:39:06"
          },
          {
            "ticket_id": 16330,
            "ticket_number": "3516318",
            "title": "Fwd: Fizemos o upgrade do teu lugar no teu voo par",
            "priority": "P2",
            "created_at": "28/04/2026 11:39:08",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:39:08"
          },
          {
            "ticket_id": 16332,
            "ticket_number": "3516320",
            "title": "✨OPORTUNIDADE ÚNICA!⏳ Reserve HOJE, decida  AMANHÃ",
            "priority": "P2",
            "created_at": "28/04/2026 11:39:12",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:41:25"
          },
          {
            "ticket_id": 16333,
            "ticket_number": "3516321",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604623820",
            "priority": "P2",
            "created_at": "28/04/2026 11:39:14",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:07:14"
          },
          {
            "ticket_id": 16343,
            "ticket_number": "3516331",
            "title": "GBN-120965 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/04/2026 13:20:56",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:55:02"
          },
          {
            "ticket_id": 16344,
            "ticket_number": "3516332",
            "title": "GBN-120965 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/04/2026 13:20:58",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:45:57"
          },
          {
            "ticket_id": 16351,
            "ticket_number": "3516339",
            "title": "Re:[## 34336 ##] GBN-111558 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "28/04/2026 14:09:33",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 13:10:00"
          },
          {
            "ticket_id": 16352,
            "ticket_number": "3516340",
            "title": "Fwd: RECONFIRMACION RESERVA HOTEL//1274580990 TTN-",
            "priority": "P2",
            "created_at": "28/04/2026 14:09:34",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:09:34"
          },
          {
            "ticket_id": 16446,
            "ticket_number": "3516434",
            "title": "Documentação Disponível - Reserva 337743",
            "priority": "P2",
            "created_at": "29/04/2026 12:10:01",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 12:13:37"
          },
          {
            "ticket_id": 16448,
            "ticket_number": "3516436",
            "title": "GBN-120950 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "29/04/2026 12:26:34",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 12:26:34"
          },
          {
            "ticket_id": 16451,
            "ticket_number": "3516439",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "29/04/2026 13:00:40",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:51:06"
          },
          {
            "ticket_id": 16452,
            "ticket_number": "3516440",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "29/04/2026 13:00:43",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:24:52"
          },
          {
            "ticket_id": 16453,
            "ticket_number": "3516441",
            "title": "Nelson Soares",
            "priority": "P2",
            "created_at": "29/04/2026 13:00:44",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 117.57,
            "sla_met": false,
            "sla_breach_hours": 113.57,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:35:23"
          },
          {
            "ticket_id": 16454,
            "ticket_number": "3516442",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "29/04/2026 13:00:47",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:24:27"
          },
          {
            "ticket_id": 16455,
            "ticket_number": "3516443",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "29/04/2026 13:00:54",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:51:32"
          },
          {
            "ticket_id": 16457,
            "ticket_number": "3516445",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "29/04/2026 13:08:44",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:58:01"
          },
          {
            "ticket_id": 16458,
            "ticket_number": "3516446",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "P2",
            "created_at": "29/04/2026 13:22:43",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:47:45"
          },
          {
            "ticket_id": 16461,
            "ticket_number": "3516449",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "P2",
            "created_at": "29/04/2026 13:28:14",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:23:42"
          },
          {
            "ticket_id": 16464,
            "ticket_number": "3516452",
            "title": "Confirmação de reserva para For PT004157 70772724",
            "priority": "P2",
            "created_at": "29/04/2026 13:47:49",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:55:58"
          },
          {
            "ticket_id": 16465,
            "ticket_number": "3516453",
            "title": "GBN-121352 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/04/2026 13:47:51",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 13:47:51"
          },
          {
            "ticket_id": 16469,
            "ticket_number": "3516457",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:46",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:10:21"
          },
          {
            "ticket_id": 16471,
            "ticket_number": "3516459",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:50",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:11:23"
          },
          {
            "ticket_id": 16473,
            "ticket_number": "3516461",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:54",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:13:14"
          },
          {
            "ticket_id": 16474,
            "ticket_number": "3516462",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:56",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:13:49"
          },
          {
            "ticket_id": 16476,
            "ticket_number": "3516464",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:59",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:20:40"
          },
          {
            "ticket_id": 16477,
            "ticket_number": "3516465",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:01",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:14:41"
          },
          {
            "ticket_id": 16478,
            "ticket_number": "3516466",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:02",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:17:39"
          },
          {
            "ticket_id": 16479,
            "ticket_number": "3516467",
            "title": "Confirmação reserva Bedsonline 1216-2208984",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:03",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:24:00"
          },
          {
            "ticket_id": 16480,
            "ticket_number": "3516468",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:18:28"
          },
          {
            "ticket_id": 16481,
            "ticket_number": "3516469",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:07",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:21:47"
          },
          {
            "ticket_id": 16482,
            "ticket_number": "3516470",
            "title": "Informações importantes sobre taxas governamentais",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:08",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:15:22"
          },
          {
            "ticket_id": 16488,
            "ticket_number": "3516476",
            "title": "Fwd: Incidente de voo TTN-1267172189#100360569#T19",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:18",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:45:19"
          },
          {
            "ticket_id": 16489,
            "ticket_number": "3516477",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604625134",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:21",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:05:11"
          },
          {
            "ticket_id": 16492,
            "ticket_number": "3516480",
            "title": "GBN-121361 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:32",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:45:32"
          },
          {
            "ticket_id": 16500,
            "ticket_number": "3516488",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "29/04/2026 16:37:30",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:40:33"
          },
          {
            "ticket_id": 16505,
            "ticket_number": "3516493",
            "title": "GBN-121361 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/04/2026 16:37:38",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 16:42:15"
          },
          {
            "ticket_id": 16537,
            "ticket_number": "3516525",
            "title": "Envio de documentos de File 419153/25",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:11",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:40:18"
          },
          {
            "ticket_id": 16543,
            "ticket_number": "3516531",
            "title": "Eticket - 70772724 - AX  03/05/2026  Veneza, Itáli",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:25",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:36:43"
          },
          {
            "ticket_id": 16547,
            "ticket_number": "3516535",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:29",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:24:52"
          },
          {
            "ticket_id": 16548,
            "ticket_number": "3516536",
            "title": "Información de reserva número: 1788405",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:32",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:35:31"
          },
          {
            "ticket_id": 16550,
            "ticket_number": "3516538",
            "title": "Re: Número de informação da reserva: 6146808 W2MCS",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:37",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:27:39"
          },
          {
            "ticket_id": 16552,
            "ticket_number": "3516540",
            "title": "Comprovativo pagamento - Localizador 6129227",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:41",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:34:18"
          },
          {
            "ticket_id": 16555,
            "ticket_number": "3516543",
            "title": "Información de reserva número: 1788431",
            "priority": "P2",
            "created_at": "30/04/2026 10:43:09",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:41:02"
          },
          {
            "ticket_id": 16559,
            "ticket_number": "3516547",
            "title": "Documentação Disponível - Reserva 343338",
            "priority": "P2",
            "created_at": "30/04/2026 11:06:15",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:23:38"
          },
          {
            "ticket_id": 16560,
            "ticket_number": "3516548",
            "title": "GBN-121520 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "30/04/2026 11:06:21",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:06:21"
          },
          {
            "ticket_id": 16561,
            "ticket_number": "3516549",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604625134",
            "priority": "P2",
            "created_at": "30/04/2026 11:47:56",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:51:26"
          },
          {
            "ticket_id": 16562,
            "ticket_number": "3516550",
            "title": "VOUCHER DA RESERVA 604625134",
            "priority": "P2",
            "created_at": "30/04/2026 11:48:00",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:52:44"
          },
          {
            "ticket_id": 16573,
            "ticket_number": "3516561",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "30/04/2026 13:16:05",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 17:01:55"
          },
          {
            "ticket_id": 16581,
            "ticket_number": "3516569",
            "title": "Re:[## 34336 ##] GBN-111558 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "30/04/2026 13:58:34",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 14:14:41"
          },
          {
            "ticket_id": 16586,
            "ticket_number": "3516574",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "30/04/2026 14:19:03",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 14:23:59"
          },
          {
            "ticket_id": 16592,
            "ticket_number": "3516580",
            "title": "GBN-114599 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/04/2026 14:37:04",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:21:14"
          },
          {
            "ticket_id": 16596,
            "ticket_number": "3516584",
            "title": "RESERVA NOVA",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 15:20:47"
          },
          {
            "ticket_id": 16598,
            "ticket_number": "3516586",
            "title": "Reserva confirmada: Cruzeiro com degustação de vin",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:50",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:04:20"
          },
          {
            "ticket_id": 16599,
            "ticket_number": "3516587",
            "title": "Confirmação de reserva com localizador: 4197214",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:52",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 17:18:10"
          },
          {
            "ticket_id": 16600,
            "ticket_number": "3516588",
            "title": "Confirmação de reserva 343800 ####BILHETES EMITIDO",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:54",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 15:50:04"
          },
          {
            "ticket_id": 16601,
            "ticket_number": "3516589",
            "title": "Reserva confirmada: Cruzeiro com degustação de vin",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:57",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:21:55"
          },
          {
            "ticket_id": 16607,
            "ticket_number": "3516595",
            "title": "MSC Cruzeiros - SUGESTÃO DE CHECK IN ONLINE PARA P",
            "priority": "P2",
            "created_at": "30/04/2026 15:57:20",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:20:39"
          },
          {
            "ticket_id": 16608,
            "ticket_number": "3516596",
            "title": "MSC Cruzeiros - SUGESTÃO DE CHECK IN ONLINE PARA P",
            "priority": "P2",
            "created_at": "30/04/2026 15:57:24",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:18:54"
          },
          {
            "ticket_id": 16609,
            "ticket_number": "3516597",
            "title": "MSC Cruzeiros - SUGESTÃO DE CHECK IN ONLINE PARA P",
            "priority": "P2",
            "created_at": "30/04/2026 15:57:26",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:19:39"
          },
          {
            "ticket_id": 16610,
            "ticket_number": "3516598",
            "title": "MSC Cruzeiros - SUGESTÃO DE CHECK IN ONLINE PARA P",
            "priority": "P2",
            "created_at": "30/04/2026 15:57:28",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:17:47"
          },
          {
            "ticket_id": 16612,
            "ticket_number": "3516600",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "30/04/2026 16:28:28",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 16:31:10"
          },
          {
            "ticket_id": 16616,
            "ticket_number": "3516604",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 17:02:40",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 17:02:40"
          },
          {
            "ticket_id": 16617,
            "ticket_number": "3516605",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "30/04/2026 17:02:43",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 17:02:44"
          },
          {
            "ticket_id": 16650,
            "ticket_number": "3516638",
            "title": "Icárion - Maldivas  - 23/12/2026 - 6363515 - AS21M",
            "priority": "P2",
            "created_at": "30/04/2026 19:02:57",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 88.33,
            "sla_met": false,
            "sla_breach_hours": 84.33,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:23:48"
          },
          {
            "ticket_id": 16681,
            "ticket_number": "3516669",
            "title": "Pedido reserva - Barcadouro - 15/05/2026",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:35",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:55:35"
          },
          {
            "ticket_id": 16703,
            "ticket_number": "3516691",
            "title": "Criação de processo File 440291/26",
            "priority": "P1",
            "created_at": "02/05/2026 09:59:08",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.28,
            "sla_met": false,
            "sla_breach_hours": 54.03,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:16:18"
          },
          {
            "ticket_id": 16732,
            "ticket_number": "3516720",
            "title": "Referencia para pagamento | File:440264/2026",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:21",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 7.72,
            "sla_met": false,
            "sla_breach_hours": 3.72,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 17:45:17"
          },
          {
            "ticket_id": 16733,
            "ticket_number": "3516721",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:23",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 48.85,
            "sla_met": false,
            "sla_breach_hours": 44.85,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:53:19"
          },
          {
            "ticket_id": 16738,
            "ticket_number": "3516726",
            "title": "Rescisão de contrato de prestação de serviços",
            "priority": "P2",
            "created_at": "02/05/2026 10:01:45",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 48.63,
            "sla_met": false,
            "sla_breach_hours": 44.63,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:40:03"
          },
          {
            "ticket_id": 16759,
            "ticket_number": "3516747",
            "title": "Criação de processo File 440322/26",
            "priority": "P1",
            "created_at": "02/05/2026 15:17:16",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 48.98,
            "sla_met": false,
            "sla_breach_hours": 48.73,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:16:40"
          },
          {
            "ticket_id": 16777,
            "ticket_number": "3516765",
            "title": "[Suporte] TRP-2026-04972 / TRL-2026-07658 - CONFIR",
            "priority": "P2",
            "created_at": "03/05/2026 11:49:30",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/05/2026 11:49:31"
          },
          {
            "ticket_id": 16780,
            "ticket_number": "3516768",
            "title": "[Cancelamento Serviço] TRP-2026-03354 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/05/2026 20:57:22",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:52:58"
          },
          {
            "ticket_id": 16781,
            "ticket_number": "3516769",
            "title": "[Suporte] TRP-2026-04267 / TRL-2026-06461 - Vouche",
            "priority": "P2",
            "created_at": "04/05/2026 08:11:57",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 08:11:57"
          },
          {
            "ticket_id": 16782,
            "ticket_number": "3516770",
            "title": "Fwd: O78IGE | Está quase na hora do teu voo para V",
            "priority": "P2",
            "created_at": "04/05/2026 09:09:41",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:09:42"
          },
          {
            "ticket_id": 16783,
            "ticket_number": "3516771",
            "title": "Fwd: Transavia - Revenda o seu bilhete se já não p",
            "priority": "P2",
            "created_at": "04/05/2026 09:09:44",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:09:45"
          },
          {
            "ticket_id": 16784,
            "ticket_number": "3516772",
            "title": "Fwd: Important information about your travel plans",
            "priority": "P2",
            "created_at": "04/05/2026 09:09:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:09:47"
          },
          {
            "ticket_id": 16786,
            "ticket_number": "3516774",
            "title": "MSC Cruises Document - 2600101003236224",
            "priority": "P2",
            "created_at": "04/05/2026 09:09:54",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:39:30"
          },
          {
            "ticket_id": 16824,
            "ticket_number": "3516812",
            "title": "Pagamento por Link da Fatura n.º2147910544 - Recib",
            "priority": "P2",
            "created_at": "04/05/2026 09:13:49",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:21:48"
          },
          {
            "ticket_id": 16827,
            "ticket_number": "3516815",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "04/05/2026 09:13:55",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:10:42"
          },
          {
            "ticket_id": 16830,
            "ticket_number": "3516818",
            "title": "Fwd: Envio Fatura",
            "priority": "P2",
            "created_at": "04/05/2026 09:14:03",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:47:08"
          },
          {
            "ticket_id": 16833,
            "ticket_number": "3516821",
            "title": "MSC Cruises Document - 2600101003186804",
            "priority": "P2",
            "created_at": "04/05/2026 09:14:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:35:10"
          },
          {
            "ticket_id": 16842,
            "ticket_number": "3516830",
            "title": "Webinar Melair Cruzeiros | Corazul Cruceros |",
            "priority": "P2",
            "created_at": "04/05/2026 09:48:22",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:48:22"
          },
          {
            "ticket_id": 16849,
            "ticket_number": "3516837",
            "title": "GBN-121899 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:31",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:40:55"
          },
          {
            "ticket_id": 16850,
            "ticket_number": "3516838",
            "title": "GBN-121899 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:33",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:53:10"
          },
          {
            "ticket_id": 16851,
            "ticket_number": "3516839",
            "title": "Informação importante sobre a tua reserva 6141384",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:35",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:45:46"
          },
          {
            "ticket_id": 16852,
            "ticket_number": "3516840",
            "title": "Informação importante sobre a tua reserva 6129191",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:38",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:51:21"
          },
          {
            "ticket_id": 16853,
            "ticket_number": "3516841",
            "title": "Informação importante sobre a tua reserva 6125263",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:41",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:52:32"
          },
          {
            "ticket_id": 16854,
            "ticket_number": "3516842",
            "title": "Informação importante sobre a tua reserva 6142286",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:43",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:52:39"
          },
          {
            "ticket_id": 16855,
            "ticket_number": "3516843",
            "title": "Informação importante sobre a tua reserva 6129181",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:45",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:53:20"
          },
          {
            "ticket_id": 16856,
            "ticket_number": "3516844",
            "title": "Informação importante sobre a tua reserva 6129187",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:52:47"
          },
          {
            "ticket_id": 16857,
            "ticket_number": "3516845",
            "title": "Informação importante sobre a tua reserva 6129184",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:50",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:53:33"
          },
          {
            "ticket_id": 16858,
            "ticket_number": "3516846",
            "title": "Fwd: Completed: Contrato Consultor - Karen Quipusc",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:41",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:55:41"
          },
          {
            "ticket_id": 16859,
            "ticket_number": "3516847",
            "title": "GBN-121877 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:44",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:06:12"
          },
          {
            "ticket_id": 16860,
            "ticket_number": "3516848",
            "title": "GBN-121928 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:48",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:55:48"
          },
          {
            "ticket_id": 16861,
            "ticket_number": "3516849",
            "title": "GBN-121887 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:50",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:58:14"
          },
          {
            "ticket_id": 16862,
            "ticket_number": "3516850",
            "title": "GBN-121887 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:53",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:05:14"
          },
          {
            "ticket_id": 16863,
            "ticket_number": "3516851",
            "title": "GBN-121877 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 10:55:55",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:55:56"
          },
          {
            "ticket_id": 16864,
            "ticket_number": "3516852",
            "title": "GBN-121877 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 10:56:01",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 10:57:49"
          },
          {
            "ticket_id": 16866,
            "ticket_number": "3516854",
            "title": "Confirmação de reserva 335503 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "04/05/2026 11:09:11",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:15:13"
          },
          {
            "ticket_id": 16867,
            "ticket_number": "3516855",
            "title": "** 2AVIA ** FW: RESERVA LEPLAN LOCALIZADOR  604609",
            "priority": "P2",
            "created_at": "04/05/2026 11:27:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:16:48"
          },
          {
            "ticket_id": 16880,
            "ticket_number": "3516868",
            "title": "GBN-99632 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 12:29:31",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:41:08"
          },
          {
            "ticket_id": 16885,
            "ticket_number": "3516873",
            "title": "Envio itinerário e números bilhetes emitidos //// ",
            "priority": "P2",
            "created_at": "04/05/2026 13:18:44",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:25:08"
          },
          {
            "ticket_id": 16886,
            "ticket_number": "3516874",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "04/05/2026 13:18:46",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:28:22"
          },
          {
            "ticket_id": 16887,
            "ticket_number": "3516875",
            "title": "Informação de reserva - SPT002601628157",
            "priority": "P2",
            "created_at": "04/05/2026 13:18:50",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:25:58"
          },
          {
            "ticket_id": 16888,
            "ticket_number": "3516876",
            "title": "Informação de reserva - SPT002601628157",
            "priority": "P2",
            "created_at": "04/05/2026 13:18:54",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:27:44"
          },
          {
            "ticket_id": 16891,
            "ticket_number": "3516879",
            "title": "Mensagem sobre a reserva 38389950 - Civitatis",
            "priority": "P2",
            "created_at": "04/05/2026 14:41:30",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:44:05"
          },
          {
            "ticket_id": 16895,
            "ticket_number": "3516883",
            "title": "Reserva confirmada: Tour pelas praias de ilha Saon",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:04",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:16:45"
          },
          {
            "ticket_id": 16898,
            "ticket_number": "3516886",
            "title": "Informações da reserva TTN-1268252673#100735071#T1",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:11",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:21:48"
          },
          {
            "ticket_id": 16899,
            "ticket_number": "3516887",
            "title": "Confirmação de reserva com localizador: 4200627",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:13",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:33:35"
          },
          {
            "ticket_id": 16900,
            "ticket_number": "3516888",
            "title": "Reserva confirmada: Tour pelas praias de ilha Saon",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:16",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:39:59"
          },
          {
            "ticket_id": 16901,
            "ticket_number": "3516889",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "04/05/2026 15:14:08",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:23:02"
          },
          {
            "ticket_id": 16902,
            "ticket_number": "3516890",
            "title": "Confirmação de reserva com localizador: 4200650",
            "priority": "P2",
            "created_at": "04/05/2026 15:14:35",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:38:04"
          },
          {
            "ticket_id": 16903,
            "ticket_number": "3516891",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "04/05/2026 15:27:36",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:36:50"
          },
          {
            "ticket_id": 16904,
            "ticket_number": "3516892",
            "title": "Cessação de vínculo",
            "priority": "P2",
            "created_at": "04/05/2026 15:27:38",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:24:00"
          },
          {
            "ticket_id": 16906,
            "ticket_number": "3516894",
            "title": "Envio de documentos de File 438792/26",
            "priority": "P2",
            "created_at": "04/05/2026 15:40:39",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:03:18"
          },
          {
            "ticket_id": 16908,
            "ticket_number": "3516896",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "04/05/2026 15:41:10",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:03:18"
          },
          {
            "ticket_id": 16909,
            "ticket_number": "3516897",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "04/05/2026 15:41:13",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:03:21"
          },
          {
            "ticket_id": 16910,
            "ticket_number": "3516898",
            "title": "MVU: Cambio Vuelo: 4135101 FAMILIAP 001",
            "priority": "P2",
            "created_at": "04/05/2026 16:03:12",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:38:54"
          },
          {
            "ticket_id": 16911,
            "ticket_number": "3516899",
            "title": "Envio de documentação",
            "priority": "P2",
            "created_at": "04/05/2026 16:03:14",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:33:38"
          },
          {
            "ticket_id": 16912,
            "ticket_number": "3516900",
            "title": "Soltour apresenta‑lhe: Sol Milanos Pingüinos 🌞",
            "priority": "P2",
            "created_at": "04/05/2026 16:03:15",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:41:56"
          },
          {
            "ticket_id": 16913,
            "ticket_number": "3516901",
            "title": "Acrescentar passageiros",
            "priority": "P2",
            "created_at": "04/05/2026 16:03:24",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:03:24"
          },
          {
            "ticket_id": 16915,
            "ticket_number": "3516903",
            "title": "GBN-121470 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "04/05/2026 16:15:50",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:15:50"
          },
          {
            "ticket_id": 16918,
            "ticket_number": "3516906",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "04/05/2026 16:42:53",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:48:25"
          },
          {
            "ticket_id": 16922,
            "ticket_number": "3516910",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "04/05/2026 17:39:28",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:50:04"
          },
          {
            "ticket_id": 16923,
            "ticket_number": "3516911",
            "title": "GBN-121735 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "04/05/2026 17:49:03",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:15:26"
          },
          {
            "ticket_id": 16924,
            "ticket_number": "3516912",
            "title": "GBN-121735 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 17:49:05",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:00:16"
          },
          {
            "ticket_id": 16925,
            "ticket_number": "3516913",
            "title": "Informação de reserva - SPT002601627440",
            "priority": "P2",
            "created_at": "04/05/2026 17:49:09",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:00:39"
          },
          {
            "ticket_id": 16929,
            "ticket_number": "3516917",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/05/2026 18:19:43",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:19:43"
          },
          {
            "ticket_id": 16930,
            "ticket_number": "3516918",
            "title": "GBN Travel: Resend booking confirmation - GBN-8801",
            "priority": "P2",
            "created_at": "04/05/2026 18:19:52",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:19:52"
          },
          {
            "ticket_id": 16931,
            "ticket_number": "3516919",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "04/05/2026 18:19:56",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:19:56"
          },
          {
            "ticket_id": 16932,
            "ticket_number": "3516920",
            "title": "w2m.travel: Payment confirmation 'KCSPY3'",
            "priority": "P2",
            "created_at": "04/05/2026 18:28:38",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:31:36"
          },
          {
            "ticket_id": 16933,
            "ticket_number": "3516921",
            "title": "VJT: Documentação de Viagem Djerba 212775",
            "priority": "P2",
            "created_at": "04/05/2026 18:28:40",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:31:26"
          },
          {
            "ticket_id": 16964,
            "ticket_number": "3516952",
            "title": "alteração de seguro",
            "priority": "P2",
            "created_at": "04/05/2026 22:55:18",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:55:19"
          },
          {
            "ticket_id": 16965,
            "ticket_number": "3516953",
            "title": "Envio de Nota de Crédito 28676/26",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:08",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:11:55"
          },
          {
            "ticket_id": 16966,
            "ticket_number": "3516954",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:10",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:18:55"
          },
          {
            "ticket_id": 16967,
            "ticket_number": "3516955",
            "title": "GBN-118066 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:12",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:14:30"
          },
          {
            "ticket_id": 16968,
            "ticket_number": "3516956",
            "title": "GBN-120685 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:14",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:18:16"
          },
          {
            "ticket_id": 16969,
            "ticket_number": "3516957",
            "title": "Envio de Nota de Crédito 28659/26",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:16",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:55:46"
          },
          {
            "ticket_id": 16971,
            "ticket_number": "3516959",
            "title": "Civitatis - Re: Contacto - Perguntas frequentes da",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:20",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:14:10"
          },
          {
            "ticket_id": 16972,
            "ticket_number": "3516960",
            "title": "81087 -",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:21",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:19:59"
          },
          {
            "ticket_id": 16974,
            "ticket_number": "3516962",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:29",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:19:15"
          },
          {
            "ticket_id": 16975,
            "ticket_number": "3516963",
            "title": "Eticket - 70358738 - SX  05/05/2026  Pireu, Grécia",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:35",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:16:15"
          },
          {
            "ticket_id": 16977,
            "ticket_number": "3516965",
            "title": "Número de informação da reserva: 6147155",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:14:46"
          },
          {
            "ticket_id": 16979,
            "ticket_number": "3516967",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:44",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:13:11"
          },
          {
            "ticket_id": 16980,
            "ticket_number": "3516968",
            "title": "Reserva confirmada: Tour pela ilha do Sal - Civita",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:46",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:12:51"
          },
          {
            "ticket_id": 16981,
            "ticket_number": "3516969",
            "title": "Fwd: Your request ECPTCGQG01 has been changed",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:15",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:26:15"
          },
          {
            "ticket_id": 16982,
            "ticket_number": "3516970",
            "title": "Fwd: A sua reserva STIMRE: informações importantes",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:17",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:26:18"
          },
          {
            "ticket_id": 16985,
            "ticket_number": "3516973",
            "title": "Destinos imperdíveis com tarifas igualmente imperd",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:25",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:53:57"
          },
          {
            "ticket_id": 16987,
            "ticket_number": "3516975",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "05/05/2026 09:26:30",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:07:07"
          },
          {
            "ticket_id": 17013,
            "ticket_number": "3517001",
            "title": "GBN-122230 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/05/2026 13:15:46",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:15:46"
          },
          {
            "ticket_id": 17015,
            "ticket_number": "3517003",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/05/2026 13:29:20",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:29:20"
          },
          {
            "ticket_id": 17072,
            "ticket_number": "3517060",
            "title": "Fatura Ato Isolado 2026 - Luana Silvestre",
            "priority": "P2",
            "created_at": "05/05/2026 22:01:57",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:01:57"
          },
          {
            "ticket_id": 17081,
            "ticket_number": "3517069",
            "title": "RE: Pagamento 1788405",
            "priority": "P2",
            "created_at": "06/05/2026 09:09:34",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:15:10"
          },
          {
            "ticket_id": 17082,
            "ticket_number": "3517070",
            "title": "Rescisão contrato",
            "priority": "P2",
            "created_at": "06/05/2026 09:09:36",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 13:02:05"
          },
          {
            "ticket_id": 17084,
            "ticket_number": "3517072",
            "title": "Confirmacao 345204",
            "priority": "P2",
            "created_at": "06/05/2026 09:09:52",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:07:23"
          },
          {
            "ticket_id": 17086,
            "ticket_number": "3517074",
            "title": "GBN-122377 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "06/05/2026 09:10:06",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:05:45"
          },
          {
            "ticket_id": 17087,
            "ticket_number": "3517075",
            "title": "Confirmação reserva Bedsonline 59-5853128",
            "priority": "P2",
            "created_at": "06/05/2026 09:10:10",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:13:03"
          },
          {
            "ticket_id": 17089,
            "ticket_number": "3517077",
            "title": "A reserva A38096307 foi paga e confirmada",
            "priority": "P2",
            "created_at": "06/05/2026 09:10:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:24:42"
          },
          {
            "ticket_id": 17092,
            "ticket_number": "3517080",
            "title": "Cruzeiro - 1270694719",
            "priority": "P2",
            "created_at": "06/05/2026 09:39:42",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 09:39:42"
          },
          {
            "ticket_id": 17097,
            "ticket_number": "3517085",
            "title": "Informação importante sobre a tua reserva 6132327",
            "priority": "P2",
            "created_at": "06/05/2026 10:07:22",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:22:39"
          },
          {
            "ticket_id": 17098,
            "ticket_number": "3517086",
            "title": "Reserva confirmada: Excursão de barco a La Maddale",
            "priority": "P2",
            "created_at": "06/05/2026 10:07:25",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:22:26"
          },
          {
            "ticket_id": 17103,
            "ticket_number": "3517091",
            "title": "Envio de Documentação * File 425983",
            "priority": "P2",
            "created_at": "06/05/2026 10:50:31",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:22:55"
          },
          {
            "ticket_id": 17104,
            "ticket_number": "3517092",
            "title": "Cancelar a Subscrição Lúcia Matos",
            "priority": "P2",
            "created_at": "06/05/2026 10:51:21",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:42:15"
          },
          {
            "ticket_id": 17105,
            "ticket_number": "3517093",
            "title": "Confirmação de reserva para For PT004157 72130439",
            "priority": "P2",
            "created_at": "06/05/2026 10:51:22",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:23:43"
          },
          {
            "ticket_id": 17122,
            "ticket_number": "3517110",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "06/05/2026 11:56:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:06:46"
          },
          {
            "ticket_id": 17127,
            "ticket_number": "3517115",
            "title": "RE: 420075",
            "priority": "P2",
            "created_at": "06/05/2026 12:42:42",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:42:35"
          },
          {
            "ticket_id": 17128,
            "ticket_number": "3517116",
            "title": "Envio de documentação - FILE 424887",
            "priority": "P2",
            "created_at": "06/05/2026 12:42:50",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:53:17"
          },
          {
            "ticket_id": 17129,
            "ticket_number": "3517117",
            "title": "Informação de reserva - SPT002601627784",
            "priority": "P2",
            "created_at": "06/05/2026 13:12:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:23:39"
          },
          {
            "ticket_id": 17161,
            "ticket_number": "3517149",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/05/2026 16:52:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:52:59"
          },
          {
            "ticket_id": 17162,
            "ticket_number": "3517150",
            "title": "Orçamento 2274824 - Férias em Zanzibar - 28/07/202",
            "priority": "P2",
            "created_at": "06/05/2026 16:53:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:59:14"
          },
          {
            "ticket_id": 17163,
            "ticket_number": "3517151",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/05/2026 16:53:12",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:53:12"
          },
          {
            "ticket_id": 17165,
            "ticket_number": "3517153",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "06/05/2026 16:53:22",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:53:22"
          },
          {
            "ticket_id": 17167,
            "ticket_number": "3517155",
            "title": "[Cancelamento Serviço] TRP-2026-03192 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/05/2026 17:16:30",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 17:21:44"
          },
          {
            "ticket_id": 17172,
            "ticket_number": "3517160",
            "title": "Documentação da reserva TTN-1274366759#101032595#T",
            "priority": "P2",
            "created_at": "06/05/2026 17:53:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 18:04:01"
          },
          {
            "ticket_id": 17175,
            "ticket_number": "3517163",
            "title": "Pedido de esclarecimento NewBlue",
            "priority": "P2",
            "created_at": "06/05/2026 19:06:53",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 19:06:53"
          },
          {
            "ticket_id": 17207,
            "ticket_number": "3517195",
            "title": "GBN-122574 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:45",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 12.42,
            "sla_met": false,
            "sla_breach_hours": 8.42,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:28:10"
          },
          {
            "ticket_id": 17209,
            "ticket_number": "3517197",
            "title": "GBN-122574 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:48",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 12.67,
            "sla_met": false,
            "sla_breach_hours": 8.67,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:42:57"
          },
          {
            "ticket_id": 17210,
            "ticket_number": "3517198",
            "title": "Reserva confirmada: Excursão de 2 dias ao deserto ",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:51",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 12.43,
            "sla_met": false,
            "sla_breach_hours": 8.43,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:28:58"
          },
          {
            "ticket_id": 17213,
            "ticket_number": "3517201",
            "title": "Reserva confirmada: Excursão de 2 dias ao deserto ",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:58",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 12.73,
            "sla_met": false,
            "sla_breach_hours": 8.73,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:47:25"
          },
          {
            "ticket_id": 17217,
            "ticket_number": "3517205",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "06/05/2026 23:03:08",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 11.05,
            "sla_met": false,
            "sla_breach_hours": 7.05,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:06:32"
          },
          {
            "ticket_id": 17218,
            "ticket_number": "3517206",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "06/05/2026 23:03:11",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 11.05,
            "sla_met": false,
            "sla_breach_hours": 7.05,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:06:45"
          },
          {
            "ticket_id": 17220,
            "ticket_number": "3517208",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:04",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:53:44"
          },
          {
            "ticket_id": 17222,
            "ticket_number": "3517210",
            "title": "GBN-122629 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:10",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:08:10"
          },
          {
            "ticket_id": 17223,
            "ticket_number": "3517211",
            "title": "Localizador 1277605364 - SmyTravel informa TTN-127",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:14",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:39:33"
          },
          {
            "ticket_id": 17224,
            "ticket_number": "3517212",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604629729",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:17",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:53:09"
          },
          {
            "ticket_id": 17226,
            "ticket_number": "3517214",
            "title": "Confirmação de reserva com localizador: 4205692",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:22",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:44:34"
          },
          {
            "ticket_id": 17228,
            "ticket_number": "3517216",
            "title": "Criação de processo File 440740/26",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:32",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:31:28"
          },
          {
            "ticket_id": 17231,
            "ticket_number": "3517219",
            "title": "Reserva pendente à espera de emiss��o",
            "priority": "P2",
            "created_at": "07/05/2026 09:09:04",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:38:35"
          },
          {
            "ticket_id": 17235,
            "ticket_number": "3517223",
            "title": "Reserva pendente à espera de emiss��o",
            "priority": "P2",
            "created_at": "07/05/2026 09:09:12",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:31:50"
          },
          {
            "ticket_id": 17240,
            "ticket_number": "3517228",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "07/05/2026 09:54:24",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:34:15"
          },
          {
            "ticket_id": 17241,
            "ticket_number": "3517229",
            "title": "VOUCHER DA RESERVA 604546362",
            "priority": "P2",
            "created_at": "07/05/2026 09:54:34",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:11:52"
          },
          {
            "ticket_id": 17246,
            "ticket_number": "3517234",
            "title": "GBN-122642 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 10:00:50",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:00:50"
          },
          {
            "ticket_id": 17249,
            "ticket_number": "3517237",
            "title": "GBN-122660 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 10:56:34",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:56:34"
          },
          {
            "ticket_id": 17254,
            "ticket_number": "3517242",
            "title": "Confirmação de reserva para For PT004157 71972459",
            "priority": "P2",
            "created_at": "07/05/2026 10:57:01",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:38:23"
          },
          {
            "ticket_id": 17255,
            "ticket_number": "3517243",
            "title": "GBN-122652 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 10:57:06",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:57:06"
          },
          {
            "ticket_id": 17256,
            "ticket_number": "3517244",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "07/05/2026 10:57:09",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:12:46"
          },
          {
            "ticket_id": 17267,
            "ticket_number": "3517255",
            "title": "MVU: Cambio Vuelo: 4135207 FAMILIAP 001",
            "priority": "P2",
            "created_at": "07/05/2026 12:39:28",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 16:16:47"
          },
          {
            "ticket_id": 17268,
            "ticket_number": "3517256",
            "title": "MVU: Cambio Vuelo: 4135199 FAMILIAP 001",
            "priority": "P2",
            "created_at": "07/05/2026 12:39:29",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:00:39"
          },
          {
            "ticket_id": 17269,
            "ticket_number": "3517257",
            "title": "MVU: Cambio Vuelo: 4135196 FAMILIAP 001",
            "priority": "P2",
            "created_at": "07/05/2026 12:39:31",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:11:34"
          },
          {
            "ticket_id": 17270,
            "ticket_number": "3517258",
            "title": "MVU: Cambio Vuelo: 4135204 FAMILIAP 001",
            "priority": "P2",
            "created_at": "07/05/2026 12:39:33",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 12:58:12"
          },
          {
            "ticket_id": 17274,
            "ticket_number": "3517262",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/05/2026 13:43:14",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:43:14"
          },
          {
            "ticket_id": 17276,
            "ticket_number": "3517264",
            "title": "GBN-122727 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 13:43:19",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:43:19"
          },
          {
            "ticket_id": 17277,
            "ticket_number": "3517265",
            "title": "GBN-122725 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/05/2026 13:43:23",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:43:23"
          },
          {
            "ticket_id": 17279,
            "ticket_number": "3517267",
            "title": "TIAGO FERREIRA RD MAIO",
            "priority": "P2",
            "created_at": "07/05/2026 14:49:20",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 15:06:11"
          },
          {
            "ticket_id": 17281,
            "ticket_number": "3517269",
            "title": "GBN Travel: Resend booking confirmation - GBN-9278",
            "priority": "P2",
            "created_at": "07/05/2026 14:49:26",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:49:26"
          },
          {
            "ticket_id": 17282,
            "ticket_number": "3517270",
            "title": "GBN Travel: Resend booking confirmation - GBN-9077",
            "priority": "P2",
            "created_at": "07/05/2026 14:49:30",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:49:30"
          },
          {
            "ticket_id": 17283,
            "ticket_number": "3517271",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "07/05/2026 14:49:41",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:49:41"
          },
          {
            "ticket_id": 17284,
            "ticket_number": "3517272",
            "title": "MAGALI MORIN RD MAIO",
            "priority": "P2",
            "created_at": "07/05/2026 15:04:52",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 15:07:12"
          },
          {
            "ticket_id": 17290,
            "ticket_number": "3517278",
            "title": "Envio de Documentação * File 420075",
            "priority": "P2",
            "created_at": "07/05/2026 15:22:39",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 15:23:08"
          },
          {
            "ticket_id": 17337,
            "ticket_number": "3517325",
            "title": "Pedido de Contacto Movel - 336458 // Partida: 2026",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:23",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 46.73,
            "sla_met": false,
            "sla_breach_hours": 42.73,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 20:44:06"
          },
          {
            "ticket_id": 17349,
            "ticket_number": "3517337",
            "title": "Mensagem sobre a reserva 38829654 - Civitatis",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:43",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 108.58,
            "sla_met": false,
            "sla_breach_hours": 104.58,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:34:47"
          },
          {
            "ticket_id": 17380,
            "ticket_number": "3517368",
            "title": "RE: Cancelamento reserva - 432225--CXL",
            "priority": "P2",
            "created_at": "08/05/2026 11:24:16",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:21:55"
          },
          {
            "ticket_id": 17388,
            "ticket_number": "3517376",
            "title": "Devolução do valor que o cliente pagou a mais por ",
            "priority": "P1",
            "created_at": "08/05/2026 14:19:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "08/05/2026 14:19:06"
          },
          {
            "ticket_id": 17415,
            "ticket_number": "3517403",
            "title": "NOTIFICAÇÃO IMPORTANTE SOBRE A SUA RESERVA 6125315",
            "priority": "P1",
            "created_at": "08/05/2026 15:34:16",
            "close_date": "2026-05-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.35,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA P1",
            "first_response_at": "08/05/2026 16:56:01"
          },
          {
            "ticket_id": 17436,
            "ticket_number": "3517424",
            "title": "Localizador: 1260745457 SMY",
            "priority": "P2",
            "created_at": "08/05/2026 20:17:30",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 20:17:30"
          },
          {
            "ticket_id": 17447,
            "ticket_number": "3517435",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/05/2026 22:51:48",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 58.3,
            "sla_met": false,
            "sla_breach_hours": 54.3,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:31"
          },
          {
            "ticket_id": 17449,
            "ticket_number": "3517437",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "08/05/2026 22:51:52",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 58.3,
            "sla_met": false,
            "sla_breach_hours": 54.3,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:29"
          },
          {
            "ticket_id": 17467,
            "ticket_number": "3517455",
            "title": "IN SURE em INGLÊS?",
            "priority": "P2",
            "created_at": "09/05/2026 10:03:18",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 10:03:19"
          },
          {
            "ticket_id": 17489,
            "ticket_number": "3517477",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "09/05/2026 12:58:53",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 44.18,
            "sla_met": false,
            "sla_breach_hours": 40.18,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:08"
          },
          {
            "ticket_id": 17503,
            "ticket_number": "3517491",
            "title": "GBN-123242 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "09/05/2026 17:56:33",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 17:56:33"
          },
          {
            "ticket_id": 17505,
            "ticket_number": "3517493",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/05/2026 19:03:28",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 19:03:28"
          },
          {
            "ticket_id": 17510,
            "ticket_number": "3517498",
            "title": "[Suporte] TRP-2026-04044 / TRL-2026-06104 - Dados ",
            "priority": "P2",
            "created_at": "10/05/2026 19:44:59",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/05/2026 19:44:59"
          },
          {
            "ticket_id": 17511,
            "ticket_number": "3517499",
            "title": "GBN-104400 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:27",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:35:52"
          },
          {
            "ticket_id": 17512,
            "ticket_number": "3517500",
            "title": "GBN-100587 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:30",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:31:03"
          },
          {
            "ticket_id": 17515,
            "ticket_number": "3517503",
            "title": "Informação de reserva -     SPT002601630524",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:39",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:01:15"
          },
          {
            "ticket_id": 17516,
            "ticket_number": "3517504",
            "title": "GBN-123306 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:47",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:03:47"
          },
          {
            "ticket_id": 17517,
            "ticket_number": "3517505",
            "title": "GBN-123300 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:50",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:03:50"
          },
          {
            "ticket_id": 17519,
            "ticket_number": "3517507",
            "title": "Confirmação de reserva com localizador: 4210185",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:55",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:10:42"
          },
          {
            "ticket_id": 17522,
            "ticket_number": "3517510",
            "title": "Informação de reserva - SPT002601630519",
            "priority": "P2",
            "created_at": "11/05/2026 09:06:08",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:54:02"
          },
          {
            "ticket_id": 17523,
            "ticket_number": "3517511",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "11/05/2026 09:06:10",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:22:50"
          },
          {
            "ticket_id": 17524,
            "ticket_number": "3517512",
            "title": "Confirmação de reserva com localizador: 4209979",
            "priority": "P2",
            "created_at": "11/05/2026 09:06:12",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:21:53"
          },
          {
            "ticket_id": 17526,
            "ticket_number": "3517514",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "11/05/2026 09:06:16",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:22:47"
          },
          {
            "ticket_id": 17527,
            "ticket_number": "3517515",
            "title": "Mensagem sobre a reserva  - Civitatis",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:02",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:00:25"
          },
          {
            "ticket_id": 17529,
            "ticket_number": "3517517",
            "title": "Informações sobre o operador do Pedido Nº 46173306",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:06",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:35:08"
          },
          {
            "ticket_id": 17530,
            "ticket_number": "3517518",
            "title": "GBN-123275 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:17",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:17"
          },
          {
            "ticket_id": 17532,
            "ticket_number": "3517520",
            "title": "Fwd: Recibo 160468-2026/PTR da reserva X5N58N",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:22",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:23"
          },
          {
            "ticket_id": 17533,
            "ticket_number": "3517521",
            "title": "Informação importante sobre a tua reserva 6143223",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:25",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:38:36"
          },
          {
            "ticket_id": 17534,
            "ticket_number": "3517522",
            "title": "Informação importante sobre a tua reserva 6135846",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:26",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:11:32"
          },
          {
            "ticket_id": 17535,
            "ticket_number": "3517523",
            "title": "Informação importante sobre a tua reserva 6139564",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:33",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:36:09"
          },
          {
            "ticket_id": 17537,
            "ticket_number": "3517525",
            "title": "Informação importante sobre a tua reserva 6140824",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:37",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:36:21"
          },
          {
            "ticket_id": 17538,
            "ticket_number": "3517526",
            "title": "Mensagem sobre a reserva 38884999 - Civitatis",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:41",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:38:27"
          },
          {
            "ticket_id": 17539,
            "ticket_number": "3517527",
            "title": "Reserva confirmada: Excursão ao parque Xcaret - Ci",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:44",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:42:42"
          },
          {
            "ticket_id": 17540,
            "ticket_number": "3517528",
            "title": "MSC Cruises Document - 2600101003331922",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:46",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:42:15"
          },
          {
            "ticket_id": 17541,
            "ticket_number": "3517529",
            "title": "Claudia Costa - Voucher Mx - Mayo 2026",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:50",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:25:48"
          },
          {
            "ticket_id": 17542,
            "ticket_number": "3517530",
            "title": "ifthenpay:  Processamento do dia 09-05-2026 da con",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:52",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:21:32"
          },
          {
            "ticket_id": 17543,
            "ticket_number": "3517531",
            "title": "Reserva confirmada: Festa na discoteca Coco Bongo ",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:54",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:01:03"
          },
          {
            "ticket_id": 17544,
            "ticket_number": "3517532",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:56",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:26:44"
          },
          {
            "ticket_id": 17545,
            "ticket_number": "3517533",
            "title": "GBN-105472 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "11/05/2026 09:10:58",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:40:23"
          },
          {
            "ticket_id": 17546,
            "ticket_number": "3517534",
            "title": "Notification about request #24188744, client's nam",
            "priority": "P2",
            "created_at": "11/05/2026 09:11:34",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:21:01"
          },
          {
            "ticket_id": 17547,
            "ticket_number": "3517535",
            "title": "RE: Comprovativo de pagamento 6146924",
            "priority": "P2",
            "created_at": "11/05/2026 09:11:35",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:35:51"
          },
          {
            "ticket_id": 17549,
            "ticket_number": "3517537",
            "title": "Confirmação reserva Bedsonline 59-5858868",
            "priority": "P2",
            "created_at": "11/05/2026 09:11:39",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:20:00"
          },
          {
            "ticket_id": 17550,
            "ticket_number": "3517538",
            "title": "Notification about request #24188744, client's nam",
            "priority": "P2",
            "created_at": "11/05/2026 09:11:41",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:14:00"
          },
          {
            "ticket_id": 17551,
            "ticket_number": "3517539",
            "title": "Notification about request #24188744, client's nam",
            "priority": "P2",
            "created_at": "11/05/2026 09:11:42",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:45:34"
          },
          {
            "ticket_id": 17554,
            "ticket_number": "3517542",
            "title": "Notification about request #24188350, client's nam",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:06",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:46:09"
          },
          {
            "ticket_id": 17555,
            "ticket_number": "3517543",
            "title": "Notification about request #24188350, client's nam",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:07",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:50:37"
          },
          {
            "ticket_id": 17556,
            "ticket_number": "3517544",
            "title": "Reserva confirmada: Festa na discoteca Coco Bongo ",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:09",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:11:46"
          },
          {
            "ticket_id": 17557,
            "ticket_number": "3517545",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:11",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:41:23"
          },
          {
            "ticket_id": 17558,
            "ticket_number": "3517546",
            "title": "Reserva confirmada: Excursão ao parque Xcaret - Ci",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:13",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:40:07"
          },
          {
            "ticket_id": 17560,
            "ticket_number": "3517548",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604631505",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:16",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:45:26"
          },
          {
            "ticket_id": 17561,
            "ticket_number": "3517549",
            "title": "Reserva confirmada: Excursão à Isla Mujeres de cat",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:18",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:30:47"
          },
          {
            "ticket_id": 17564,
            "ticket_number": "3517552",
            "title": "Confirmação de autenticação na Teldar Travel para ",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:23",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:34:42"
          },
          {
            "ticket_id": 17569,
            "ticket_number": "3517557",
            "title": "w2m.travel: Confirmación reserva 'Q13SJV'",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:31",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:24:31"
          },
          {
            "ticket_id": 17570,
            "ticket_number": "3517558",
            "title": "GBN-123243 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:37",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:12:37"
          },
          {
            "ticket_id": 17572,
            "ticket_number": "3517560",
            "title": "GBN-123311 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:42",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:12:42"
          },
          {
            "ticket_id": 17579,
            "ticket_number": "3517567",
            "title": "Informações da reserva TTN-1239465923#101392942#T1",
            "priority": "P2",
            "created_at": "11/05/2026 09:40:47",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:50:09"
          },
          {
            "ticket_id": 17580,
            "ticket_number": "3517568",
            "title": "A sua reserva continua CONFIRMADA �� tentativa de ",
            "priority": "P2",
            "created_at": "11/05/2026 09:40:49",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:59:22"
          },
          {
            "ticket_id": 17581,
            "ticket_number": "3517569",
            "title": "URGENTE LOC 604630953 DATOS PASAPORTES",
            "priority": "P2",
            "created_at": "11/05/2026 10:03:42",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:05:24"
          },
          {
            "ticket_id": 17582,
            "ticket_number": "3517570",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "11/05/2026 10:03:44",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:20:29"
          },
          {
            "ticket_id": 17584,
            "ticket_number": "3517572",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "11/05/2026 10:03:51",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:06:21"
          },
          {
            "ticket_id": 17586,
            "ticket_number": "3517574",
            "title": "GBN-123306 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/05/2026 10:12:14",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:18:46"
          },
          {
            "ticket_id": 17587,
            "ticket_number": "3517575",
            "title": "GBN-123306 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "11/05/2026 10:12:16",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:18:18"
          },
          {
            "ticket_id": 17591,
            "ticket_number": "3517579",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "11/05/2026 10:51:55",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:53:44"
          },
          {
            "ticket_id": 17599,
            "ticket_number": "3517587",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604477059",
            "priority": "P2",
            "created_at": "11/05/2026 11:17:05",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:37:05"
          },
          {
            "ticket_id": 17600,
            "ticket_number": "3517588",
            "title": "Confirmação de reserva – Ref PP461952, Sr. Luis Fi",
            "priority": "P2",
            "created_at": "11/05/2026 11:28:29",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:37:44"
          },
          {
            "ticket_id": 17601,
            "ticket_number": "3517589",
            "title": "Recolha Tour completo pela Madeira em 2 dias",
            "priority": "P2",
            "created_at": "11/05/2026 11:28:30",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:52:11"
          },
          {
            "ticket_id": 17603,
            "ticket_number": "3517591",
            "title": "Confirmação de reserva 337304 ####BILHETES EMITIDO",
            "priority": "P2",
            "created_at": "11/05/2026 11:45:34",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:15:15"
          },
          {
            "ticket_id": 17604,
            "ticket_number": "3517592",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "11/05/2026 12:22:43",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:51:25"
          },
          {
            "ticket_id": 17605,
            "ticket_number": "3517593",
            "title": "Envio de Nota de Crédito 28779/26",
            "priority": "P2",
            "created_at": "11/05/2026 12:22:45",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:50:48"
          },
          {
            "ticket_id": 17608,
            "ticket_number": "3517596",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "11/05/2026 12:42:15",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:47:33"
          },
          {
            "ticket_id": 17609,
            "ticket_number": "3517597",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "11/05/2026 12:42:18",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:51:36"
          },
          {
            "ticket_id": 17610,
            "ticket_number": "3517598",
            "title": "Informação de reserva - SPT002601630524",
            "priority": "P2",
            "created_at": "11/05/2026 12:42:23",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 12:49:00"
          },
          {
            "ticket_id": 17614,
            "ticket_number": "3517602",
            "title": "Importante - Checkin Online Voos TAP - FILE 336458",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:28",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 18:03:18"
          },
          {
            "ticket_id": 17615,
            "ticket_number": "3517603",
            "title": "Pedido de cancelamento da minha subscrição",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:30",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:16:30"
          },
          {
            "ticket_id": 17616,
            "ticket_number": "3517604",
            "title": "Dúvida no nome da cliente para efetuar reserva GBN",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:32",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:16:32"
          },
          {
            "ticket_id": 17620,
            "ticket_number": "3517608",
            "title": "Dados passaporte NB 6141528",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:46",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:16:46"
          },
          {
            "ticket_id": 17625,
            "ticket_number": "3517613",
            "title": "Informação de reserva - SPT002601622315",
            "priority": "P2",
            "created_at": "11/05/2026 14:36:02",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:45:42"
          },
          {
            "ticket_id": 17626,
            "ticket_number": "3517614",
            "title": "Re:[## 40681 ##] GBN-108957 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "11/05/2026 14:38:26",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 16:44:55"
          },
          {
            "ticket_id": 17628,
            "ticket_number": "3517616",
            "title": "Informação de reserva - SPT002601630815",
            "priority": "P2",
            "created_at": "11/05/2026 15:02:07",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:19:52"
          },
          {
            "ticket_id": 17632,
            "ticket_number": "3517620",
            "title": "Importante - Checkin Online Voos TAP - FILE 340136",
            "priority": "P2",
            "created_at": "11/05/2026 15:52:43",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 16:43:38"
          },
          {
            "ticket_id": 17637,
            "ticket_number": "3517625",
            "title": "Envio de Fatura 212274",
            "priority": "P2",
            "created_at": "11/05/2026 16:37:24",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 16:56:33"
          },
          {
            "ticket_id": 17662,
            "ticket_number": "3517650",
            "title": "Re:[## 40721 ##] GBN-92737 - Um cliente enviou uma",
            "priority": "P1",
            "created_at": "11/05/2026 19:17:19",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 15.28,
            "sla_met": false,
            "sla_breach_hours": 15.03,
            "sla_name": "SLA P1",
            "first_response_at": "12/05/2026 10:35:03"
          },
          {
            "ticket_id": 17697,
            "ticket_number": "3517685",
            "title": "Saídas de 11/06/2026 para 16/07/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "12/05/2026 09:02:39",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:42:43"
          },
          {
            "ticket_id": 17698,
            "ticket_number": "3517686",
            "title": "Reserva cancelada com localizador: 4057645",
            "priority": "P2",
            "created_at": "12/05/2026 09:02:40",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:01:20"
          },
          {
            "ticket_id": 17701,
            "ticket_number": "3517689",
            "title": "Confirmação de reserva – Ref PP315021, Sr. Jorge M",
            "priority": "P2",
            "created_at": "12/05/2026 09:05:09",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 09:52:32"
          },
          {
            "ticket_id": 17702,
            "ticket_number": "3517690",
            "title": "GBN-123526 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "12/05/2026 09:05:12",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 09:05:12"
          },
          {
            "ticket_id": 17703,
            "ticket_number": "3517691",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "12/05/2026 09:05:15",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:59:49"
          },
          {
            "ticket_id": 17704,
            "ticket_number": "3517692",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "12/05/2026 09:05:17",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:43:51"
          },
          {
            "ticket_id": 17705,
            "ticket_number": "3517693",
            "title": "JESSICA PATRICIA SANTOS PINTO",
            "priority": "P2",
            "created_at": "12/05/2026 09:05:20",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 18:05:28"
          },
          {
            "ticket_id": 17708,
            "ticket_number": "3517696",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "12/05/2026 09:34:45",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 09:44:10"
          },
          {
            "ticket_id": 17713,
            "ticket_number": "3517701",
            "title": "reserva rent a car- adicionar condutor extra",
            "priority": "P2",
            "created_at": "12/05/2026 09:53:24",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 09:53:24"
          },
          {
            "ticket_id": 17715,
            "ticket_number": "3517703",
            "title": "Informação importante sobre a tua reserva 6131019",
            "priority": "P2",
            "created_at": "12/05/2026 09:53:30",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:30:24"
          },
          {
            "ticket_id": 17716,
            "ticket_number": "3517704",
            "title": "Informação importante sobre a tua reserva 6131022",
            "priority": "P2",
            "created_at": "12/05/2026 09:53:32",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:30:31"
          },
          {
            "ticket_id": 17717,
            "ticket_number": "3517705",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "12/05/2026 09:53:42",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 13:00:13"
          },
          {
            "ticket_id": 17718,
            "ticket_number": "3517706",
            "title": "Informação importante sobre a tua reserva 6131017",
            "priority": "P2",
            "created_at": "12/05/2026 09:53:45",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:22:54"
          },
          {
            "ticket_id": 17720,
            "ticket_number": "3517708",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "12/05/2026 09:54:05",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 13:00:41"
          },
          {
            "ticket_id": 17725,
            "ticket_number": "3517713",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497276",
            "priority": "P2",
            "created_at": "12/05/2026 10:44:00",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:35:26"
          },
          {
            "ticket_id": 17729,
            "ticket_number": "3517717",
            "title": "Informação de reserva - SPT002601630815",
            "priority": "P2",
            "created_at": "12/05/2026 12:22:51",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:30:03"
          },
          {
            "ticket_id": 17730,
            "ticket_number": "3517718",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "12/05/2026 12:22:54",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 12:29:11"
          },
          {
            "ticket_id": 17739,
            "ticket_number": "3517727",
            "title": "GBN-113502 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "12/05/2026 13:19:35",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:41:47"
          },
          {
            "ticket_id": 17743,
            "ticket_number": "3517731",
            "title": "Hantavírus em Espanha; brasileiros deixam Portugal",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:30",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:33:05"
          },
          {
            "ticket_id": 17745,
            "ticket_number": "3517733",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604622406",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:35",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:39:18"
          },
          {
            "ticket_id": 17746,
            "ticket_number": "3517734",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604607269",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:37",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:44:07"
          },
          {
            "ticket_id": 17747,
            "ticket_number": "3517735",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604532618",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:39",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 18:29:01"
          },
          {
            "ticket_id": 17751,
            "ticket_number": "3517739",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604608019",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:48",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:47:12"
          },
          {
            "ticket_id": 17752,
            "ticket_number": "3517740",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624241",
            "priority": "P2",
            "created_at": "12/05/2026 14:21:50",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:40:52"
          },
          {
            "ticket_id": 17753,
            "ticket_number": "3517741",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604625134",
            "priority": "P2",
            "created_at": "12/05/2026 14:22:04",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:37:56"
          },
          {
            "ticket_id": 17762,
            "ticket_number": "3517750",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/05/2026 14:58:59",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:58:59"
          },
          {
            "ticket_id": 17766,
            "ticket_number": "3517754",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604591547",
            "priority": "P2",
            "created_at": "12/05/2026 14:59:07",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:32:45"
          },
          {
            "ticket_id": 17769,
            "ticket_number": "3517757",
            "title": ":: ALBÂNIA - CIRCUITOS EXCLUSIVOS | VOOS ESPECIAIS",
            "priority": "P2",
            "created_at": "12/05/2026 15:16:16",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:18:24"
          },
          {
            "ticket_id": 17770,
            "ticket_number": "3517758",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "12/05/2026 15:16:20",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:24:48"
          },
          {
            "ticket_id": 17772,
            "ticket_number": "3517760",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604543771",
            "priority": "P2",
            "created_at": "12/05/2026 15:16:24",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:29:13"
          },
          {
            "ticket_id": 17774,
            "ticket_number": "3517762",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604610015",
            "priority": "P2",
            "created_at": "12/05/2026 15:35:16",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:37:37"
          },
          {
            "ticket_id": 17777,
            "ticket_number": "3517765",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604532653",
            "priority": "P2",
            "created_at": "12/05/2026 15:35:23",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:42:44"
          },
          {
            "ticket_id": 17789,
            "ticket_number": "3517777",
            "title": "Documentação Disponível - Reserva 333869",
            "priority": "P2",
            "created_at": "12/05/2026 16:20:58",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 18:12:38"
          },
          {
            "ticket_id": 17797,
            "ticket_number": "3517785",
            "title": "Fwd: Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:11",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:12"
          },
          {
            "ticket_id": 17804,
            "ticket_number": "3517792",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:44",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:44"
          },
          {
            "ticket_id": 17806,
            "ticket_number": "3517794",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "12/05/2026 16:44:54",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:44:54"
          },
          {
            "ticket_id": 17808,
            "ticket_number": "3517796",
            "title": "André Hernandez - Voucher Mx - Mayo 2026",
            "priority": "P2",
            "created_at": "12/05/2026 16:52:41",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 17:50:50"
          },
          {
            "ticket_id": 17812,
            "ticket_number": "3517800",
            "title": "Confirmação reserva Bedsonline 491-2083020",
            "priority": "P2",
            "created_at": "12/05/2026 17:22:48",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 17:48:39"
          },
          {
            "ticket_id": 17813,
            "ticket_number": "3517801",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "12/05/2026 17:22:51",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 20:14:42"
          },
          {
            "ticket_id": 17823,
            "ticket_number": "3517811",
            "title": "Confirmação de reserva com localizador: 4213680",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:15",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 39.83,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:04:22"
          },
          {
            "ticket_id": 17829,
            "ticket_number": "3517817",
            "title": "Re:[## 40664 ##] GBN-109091 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:35",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:10:35"
          },
          {
            "ticket_id": 17831,
            "ticket_number": "3517819",
            "title": "Documentação da reserva TTN-1240329535#101639884",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:39",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:21:46"
          },
          {
            "ticket_id": 17836,
            "ticket_number": "3517824",
            "title": "Número de informação da reserva: 6147748",
            "priority": "P2",
            "created_at": "12/05/2026 21:52:02",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 12.67,
            "sla_met": false,
            "sla_breach_hours": 8.67,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 10:32:44"
          },
          {
            "ticket_id": 17840,
            "ticket_number": "3517828",
            "title": "[Cancelamento Viagem] TRP-2026-04850 - Carla Susan",
            "priority": "P2",
            "created_at": "12/05/2026 21:59:27",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:36:57"
          },
          {
            "ticket_id": 17845,
            "ticket_number": "3517833",
            "title": "w2m.travel: Confirmación reserva 'ZG6M2H'",
            "priority": "P2",
            "created_at": "12/05/2026 22:34:38",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 43.83,
            "sla_met": false,
            "sla_breach_hours": 39.83,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 18:24:39"
          },
          {
            "ticket_id": 17846,
            "ticket_number": "3517834",
            "title": "GBN-123764 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "12/05/2026 22:34:41",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/05/2026 22:34:41"
          },
          {
            "ticket_id": 17852,
            "ticket_number": "3517840",
            "title": "GBN-123768 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/05/2026 09:24:54",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 09:24:54"
          },
          {
            "ticket_id": 17862,
            "ticket_number": "3517850",
            "title": "RE: com pagamento 6138962",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:20",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 10:18:17"
          },
          {
            "ticket_id": 17867,
            "ticket_number": "3517855",
            "title": "Re:[## 40892 ##] GBN-123291 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "13/05/2026 09:36:22",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 10:45:05"
          },
          {
            "ticket_id": 17885,
            "ticket_number": "3517873",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:17",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 11:34:26"
          },
          {
            "ticket_id": 17890,
            "ticket_number": "3517878",
            "title": "Troca de um nome no loc GBN-104486",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:25",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 11:18:26"
          },
          {
            "ticket_id": 17893,
            "ticket_number": "3517881",
            "title": "RE: comp pagamento 6122145",
            "priority": "P2",
            "created_at": "13/05/2026 11:18:32",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 11:44:02"
          },
          {
            "ticket_id": 17895,
            "ticket_number": "3517883",
            "title": "MUITO URGENTE",
            "priority": "P2",
            "created_at": "13/05/2026 11:40:13",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 11:40:14"
          },
          {
            "ticket_id": 17900,
            "ticket_number": "3517888",
            "title": "Documentação Disponível - Reserva 333035",
            "priority": "P2",
            "created_at": "13/05/2026 12:39:13",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 12:47:07"
          },
          {
            "ticket_id": 17901,
            "ticket_number": "3517889",
            "title": "GBN-123815 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "13/05/2026 12:39:17",
            "close_date": "2026-05-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/05/2026 12:39:17"
          },
          {
            "ticket_id": 17922,
            "ticket_number": "3517910",
            "title": "Hotel Madeira: elegância clássica no coração do Fu",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:36",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:20:37"
          },
          {
            "ticket_id": 17924,
            "ticket_number": "3517912",
            "title": "GBN-119452 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:55",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:04:47"
          },
          {
            "ticket_id": 17925,
            "ticket_number": "3517913",
            "title": "GBN-119452 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:57",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:06:57"
          },
          {
            "ticket_id": 17926,
            "ticket_number": "3517914",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:59",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 15:21:39"
          },
          {
            "ticket_id": 17928,
            "ticket_number": "3517916",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P3",
            "created_at": "13/05/2026 15:07:30",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 19.88,
            "sla_name": "SLA P3",
            "first_response_at": "15/05/2026 11:00:48"
          },
          {
            "ticket_id": 17929,
            "ticket_number": "3517917",
            "title": "Número de informação da reserva: 6147797",
            "priority": "P2",
            "created_at": "13/05/2026 15:07:33",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:25:14"
          },
          {
            "ticket_id": 17937,
            "ticket_number": "3517925",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 16:35:51",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:35:51"
          },
          {
            "ticket_id": 17940,
            "ticket_number": "3517928",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "13/05/2026 16:35:59",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:57:40"
          },
          {
            "ticket_id": 17943,
            "ticket_number": "3517931",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 16:54:19",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:54:19"
          },
          {
            "ticket_id": 17944,
            "ticket_number": "3517932",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 16:54:23",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:54:23"
          },
          {
            "ticket_id": 17945,
            "ticket_number": "3517933",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 16:55:23",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:55:23"
          },
          {
            "ticket_id": 17951,
            "ticket_number": "3517939",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 17:35:10",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:35:10"
          },
          {
            "ticket_id": 17952,
            "ticket_number": "3517940",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 17:35:18",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:35:18"
          },
          {
            "ticket_id": 17953,
            "ticket_number": "3517941",
            "title": "Cancelamento reserva - Newblue 6147749",
            "priority": "P2",
            "created_at": "13/05/2026 17:35:50",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:35:50"
          },
          {
            "ticket_id": 17955,
            "ticket_number": "3517943",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 17:43:30",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:43:30"
          },
          {
            "ticket_id": 17957,
            "ticket_number": "3517945",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "13/05/2026 17:43:40",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:43:40"
          },
          {
            "ticket_id": 17961,
            "ticket_number": "3517949",
            "title": "TEM ALTERAÇÕES POR VALIDAR",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:09",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 18:38:09"
          },
          {
            "ticket_id": 17968,
            "ticket_number": "3517956",
            "title": "Reserva Newblue ES",
            "priority": "P2",
            "created_at": "13/05/2026 20:10:47",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:10:47"
          },
          {
            "ticket_id": 17977,
            "ticket_number": "3517965",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "13/05/2026 21:41:51",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 21:41:53"
          },
          {
            "ticket_id": 17989,
            "ticket_number": "3517977",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "13/05/2026 22:36:33",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 11.62,
            "sla_met": false,
            "sla_breach_hours": 7.62,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:53"
          },
          {
            "ticket_id": 17991,
            "ticket_number": "3517979",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "13/05/2026 23:00:03",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 11.22,
            "sla_met": false,
            "sla_breach_hours": 7.22,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:43"
          },
          {
            "ticket_id": 17993,
            "ticket_number": "3517981",
            "title": "GBN-123978 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "13/05/2026 23:00:12",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 23:00:12"
          },
          {
            "ticket_id": 17996,
            "ticket_number": "3517984",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "14/05/2026 10:12:56",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:45:51"
          },
          {
            "ticket_id": 18000,
            "ticket_number": "3517988",
            "title": "Informação de reserva - SPT002601572369",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:06",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:33:05"
          },
          {
            "ticket_id": 18002,
            "ticket_number": "3517990",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604505959",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:09",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:41:07"
          },
          {
            "ticket_id": 18003,
            "ticket_number": "3517991",
            "title": "Informação de reserva - SPT002601572357",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:12",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:30:19"
          },
          {
            "ticket_id": 18004,
            "ticket_number": "3517992",
            "title": "Informação de reserva - SPT002601572371",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:16",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:31:42"
          },
          {
            "ticket_id": 18007,
            "ticket_number": "3517995",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:22",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:23"
          },
          {
            "ticket_id": 18009,
            "ticket_number": "3517997",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:28",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:29"
          },
          {
            "ticket_id": 18011,
            "ticket_number": "3517999",
            "title": "Fwd: TSJPMI | Estacionamento cheio, garante o teu ",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:37",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:37"
          },
          {
            "ticket_id": 18012,
            "ticket_number": "3518000",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:40",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:41"
          },
          {
            "ticket_id": 18013,
            "ticket_number": "3518001",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:45",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:54:54"
          },
          {
            "ticket_id": 18014,
            "ticket_number": "3518002",
            "title": "Fwd: Uma Familia em Viagem informa sobre a sua res",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:49",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:13:50"
          },
          {
            "ticket_id": 18015,
            "ticket_number": "3518003",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:56",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:54:33"
          },
          {
            "ticket_id": 18017,
            "ticket_number": "3518005",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604585334",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:00",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:48:44"
          },
          {
            "ticket_id": 18018,
            "ticket_number": "3518006",
            "title": "Fwd: [Cockpit] Pagamento Pendente - Viagem TRP-202",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:02",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:55:37"
          },
          {
            "ticket_id": 18019,
            "ticket_number": "3518007",
            "title": "NU5XWTCY",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:33",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:53:58"
          },
          {
            "ticket_id": 18021,
            "ticket_number": "3518009",
            "title": "REMINDER: Dados de Passaporte - nosso File 415457",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:46",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:25:00"
          },
          {
            "ticket_id": 18022,
            "ticket_number": "3518010",
            "title": "Saídas de 13/06/2026 para 18/07/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "14/05/2026 10:14:53",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:00:38"
          },
          {
            "ticket_id": 18024,
            "ticket_number": "3518012",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604563025",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:06",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:49:51"
          },
          {
            "ticket_id": 18026,
            "ticket_number": "3518014",
            "title": "Disponibilidade Soltropico - Hotel Royal Garden Pa",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:15",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:15:15"
          },
          {
            "ticket_id": 18027,
            "ticket_number": "3518015",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:37:13"
          },
          {
            "ticket_id": 18029,
            "ticket_number": "3518017",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:30",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:18:11"
          },
          {
            "ticket_id": 18031,
            "ticket_number": "3518019",
            "title": "Transfer 2875967 alterado",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:08",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:12:45"
          },
          {
            "ticket_id": 18032,
            "ticket_number": "3518020",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:17",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:59:21"
          },
          {
            "ticket_id": 18033,
            "ticket_number": "3518021",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604591308",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:34:23"
          },
          {
            "ticket_id": 18034,
            "ticket_number": "3518022",
            "title": "PEDIDO DADOS ACESSO ODISSEIAS",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:21",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:54:21"
          },
          {
            "ticket_id": 18037,
            "ticket_number": "3518025",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "14/05/2026 10:54:26",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:33:14"
          },
          {
            "ticket_id": 18038,
            "ticket_number": "3518026",
            "title": "Reservas GBN  123764 e 123765",
            "priority": "P2",
            "created_at": "14/05/2026 11:19:11",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 11:19:11"
          },
          {
            "ticket_id": 18039,
            "ticket_number": "3518027",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604591308",
            "priority": "P2",
            "created_at": "14/05/2026 11:19:13",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:31:58"
          },
          {
            "ticket_id": 18040,
            "ticket_number": "3518028",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 11:53:53",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 4.33,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:14:40"
          },
          {
            "ticket_id": 18041,
            "ticket_number": "3518029",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604542341",
            "priority": "P2",
            "created_at": "14/05/2026 11:53:54",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:28:11"
          },
          {
            "ticket_id": 18042,
            "ticket_number": "3518030",
            "title": "Confirmação de reserva com localizador: 4216647",
            "priority": "P2",
            "created_at": "14/05/2026 11:53:55",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 12:06:50"
          },
          {
            "ticket_id": 18043,
            "ticket_number": "3518031",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "14/05/2026 11:53:57",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 4.33,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:14:42"
          },
          {
            "ticket_id": 18047,
            "ticket_number": "3518035",
            "title": "604570381**** MUY URGENTE CNX DJE****",
            "priority": "P2",
            "created_at": "14/05/2026 12:44:04",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 16:35:01"
          },
          {
            "ticket_id": 18054,
            "ticket_number": "3518042",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604532653",
            "priority": "P2",
            "created_at": "14/05/2026 13:32:40",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 13:45:08"
          },
          {
            "ticket_id": 18056,
            "ticket_number": "3518044",
            "title": "[Suporte] TRP-2026-03136 - Urgente - pagamento Sol",
            "priority": "P2",
            "created_at": "14/05/2026 13:40:25",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 13:40:25"
          },
          {
            "ticket_id": 18060,
            "ticket_number": "3518048",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624205",
            "priority": "P2",
            "created_at": "14/05/2026 15:04:54",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:35:36"
          },
          {
            "ticket_id": 18062,
            "ticket_number": "3518050",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604606804",
            "priority": "P2",
            "created_at": "14/05/2026 15:04:59",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:38:51"
          },
          {
            "ticket_id": 18063,
            "ticket_number": "3518051",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604619770",
            "priority": "P2",
            "created_at": "14/05/2026 15:05:02",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:27:47"
          },
          {
            "ticket_id": 18064,
            "ticket_number": "3518052",
            "title": "Documentação Disponível - Reserva 335503",
            "priority": "P2",
            "created_at": "14/05/2026 15:05:05",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:12:04"
          },
          {
            "ticket_id": 18065,
            "ticket_number": "3518053",
            "title": "Documentação Disponível - Reserva   344365",
            "priority": "P2",
            "created_at": "14/05/2026 15:05:07",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:12:50"
          },
          {
            "ticket_id": 18066,
            "ticket_number": "3518054",
            "title": "Documentação Disponível - Reserva 333282",
            "priority": "P2",
            "created_at": "14/05/2026 15:05:08",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:13:09"
          },
          {
            "ticket_id": 18067,
            "ticket_number": "3518055",
            "title": "Documentação Disponível - Reserva 344365",
            "priority": "P2",
            "created_at": "14/05/2026 15:05:10",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:12:22"
          },
          {
            "ticket_id": 18068,
            "ticket_number": "3518056",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604634486",
            "priority": "P2",
            "created_at": "14/05/2026 15:38:57",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:47:50"
          },
          {
            "ticket_id": 18070,
            "ticket_number": "3518058",
            "title": "Re:[## 40886 ##] GBN-123423 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "14/05/2026 15:39:04",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:40:49"
          },
          {
            "ticket_id": 18071,
            "ticket_number": "3518059",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 16:14:33",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:14:33"
          },
          {
            "ticket_id": 18072,
            "ticket_number": "3518060",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 16:14:37",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:14:37"
          },
          {
            "ticket_id": 18074,
            "ticket_number": "3518062",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "14/05/2026 16:14:56",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:31:59"
          },
          {
            "ticket_id": 18075,
            "ticket_number": "3518063",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 16:15:01",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:15:01"
          },
          {
            "ticket_id": 18076,
            "ticket_number": "3518064",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 16:15:04",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 16:15:05"
          },
          {
            "ticket_id": 18079,
            "ticket_number": "3518067",
            "title": "Re: autorização 50/50",
            "priority": "P2",
            "created_at": "14/05/2026 17:01:40",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:01:40"
          },
          {
            "ticket_id": 18081,
            "ticket_number": "3518069",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:13",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:12:13"
          },
          {
            "ticket_id": 18082,
            "ticket_number": "3518070",
            "title": "GBN-107994 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:15",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:17:11"
          },
          {
            "ticket_id": 18085,
            "ticket_number": "3518073",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:21",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 18:42:21"
          },
          {
            "ticket_id": 18086,
            "ticket_number": "3518074",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "14/05/2026 17:12:24",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:12:24"
          },
          {
            "ticket_id": 18089,
            "ticket_number": "3518077",
            "title": "Fwd: Completed: Contrato Consultor - Karen Quipusc",
            "priority": "P2",
            "created_at": "14/05/2026 17:39:52",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 17:39:53"
          },
          {
            "ticket_id": 18091,
            "ticket_number": "3518079",
            "title": "Novidades WOW: música, memórias e vistas incríveis",
            "priority": "P2",
            "created_at": "14/05/2026 18:13:16",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 18:41:00"
          },
          {
            "ticket_id": 18093,
            "ticket_number": "3518081",
            "title": "Confirmacao 345577",
            "priority": "P2",
            "created_at": "14/05/2026 18:13:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 18:41:39"
          },
          {
            "ticket_id": 18094,
            "ticket_number": "3518082",
            "title": "Candidatura consultor",
            "priority": "P2",
            "created_at": "14/05/2026 18:54:03",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 22:40:11"
          },
          {
            "ticket_id": 18115,
            "ticket_number": "3518103",
            "title": "REMINDER: Dados de Passaporte - nosso File 415469",
            "priority": "P2",
            "created_at": "15/05/2026 09:07:50",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:01:05"
          },
          {
            "ticket_id": 18119,
            "ticket_number": "3518107",
            "title": "REMINDER: Dados de Passaporte - nosso File 415457",
            "priority": "P2",
            "created_at": "15/05/2026 09:07:58",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:01:05"
          },
          {
            "ticket_id": 18121,
            "ticket_number": "3518109",
            "title": "GBN-124168 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "15/05/2026 09:08:04",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 09:08:04"
          },
          {
            "ticket_id": 18122,
            "ticket_number": "3518110",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "15/05/2026 09:08:06",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 09:08:07"
          },
          {
            "ticket_id": 18123,
            "ticket_number": "3518111",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604585334",
            "priority": "P2",
            "created_at": "15/05/2026 09:54:27",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 13:41:09"
          },
          {
            "ticket_id": 18125,
            "ticket_number": "3518113",
            "title": "[Suporte] TRP-2026-02780 / TRL-2026-04285 - Fatura",
            "priority": "P2",
            "created_at": "15/05/2026 10:06:42",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 10:06:43"
          },
          {
            "ticket_id": 18126,
            "ticket_number": "3518114",
            "title": "[Suporte] TRP-2026-04512 - Fatura último pagamento",
            "priority": "P2",
            "created_at": "15/05/2026 10:10:02",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 10:10:03"
          },
          {
            "ticket_id": 18127,
            "ticket_number": "3518115",
            "title": "[Suporte] TRP-2026-03321 - Emissão urgente fatura ",
            "priority": "P2",
            "created_at": "15/05/2026 10:11:19",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 10:11:19"
          },
          {
            "ticket_id": 18128,
            "ticket_number": "3518116",
            "title": "[Suporte] TRP-2026-03353 - Fatura último pagamento",
            "priority": "P2",
            "created_at": "15/05/2026 10:12:14",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 10:12:15"
          },
          {
            "ticket_id": 18134,
            "ticket_number": "3518122",
            "title": "GBN-124192 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/05/2026 11:04:49",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 12:27:18"
          },
          {
            "ticket_id": 18135,
            "ticket_number": "3518123",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "15/05/2026 11:04:52",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:01:16"
          },
          {
            "ticket_id": 18137,
            "ticket_number": "3518125",
            "title": "Importante - Checkin Online Voos TAP - FILE 343338",
            "priority": "P2",
            "created_at": "15/05/2026 11:59:23",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:19:57"
          },
          {
            "ticket_id": 18139,
            "ticket_number": "3518127",
            "title": "Documentação da reserva TTN-1221721747#101561454",
            "priority": "P2",
            "created_at": "15/05/2026 11:59:32",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 12:06:12"
          },
          {
            "ticket_id": 18143,
            "ticket_number": "3518131",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60457038",
            "priority": "P2",
            "created_at": "15/05/2026 11:59:39",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.27,
            "sla_met": false,
            "sla_breach_hours": 0.27,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:16:12"
          },
          {
            "ticket_id": 18144,
            "ticket_number": "3518132",
            "title": "GBN-123971 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/05/2026 11:59:41",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 4.93,
            "sla_met": false,
            "sla_breach_hours": 0.93,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:55:54"
          },
          {
            "ticket_id": 18145,
            "ticket_number": "3518133",
            "title": "Documentação da reserva TTN-1260745457#101933914",
            "priority": "P2",
            "created_at": "15/05/2026 11:59:48",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 12:31:01"
          },
          {
            "ticket_id": 18148,
            "ticket_number": "3518136",
            "title": "Documentação Disponível - Reserva 343800",
            "priority": "P2",
            "created_at": "15/05/2026 12:40:29",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:05:40"
          },
          {
            "ticket_id": 18149,
            "ticket_number": "3518137",
            "title": "Documentação Disponível - Reserva 337933",
            "priority": "P2",
            "created_at": "15/05/2026 12:40:30",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:06:01"
          },
          {
            "ticket_id": 18151,
            "ticket_number": "3518139",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "P2",
            "created_at": "15/05/2026 13:07:38",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:18:01"
          },
          {
            "ticket_id": 18152,
            "ticket_number": "3518140",
            "title": "CÓDIGO DE VALIDAÇÃO",
            "priority": "P2",
            "created_at": "15/05/2026 13:07:40",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:06:24"
          },
          {
            "ticket_id": 18165,
            "ticket_number": "3518153",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 16:25:05",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:25:05"
          },
          {
            "ticket_id": 18167,
            "ticket_number": "3518155",
            "title": "Documentação da reserva TTN-1243122708#101972238",
            "priority": "P2",
            "created_at": "15/05/2026 16:25:16",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:52:53"
          },
          {
            "ticket_id": 18168,
            "ticket_number": "3518156",
            "title": "Confirmação reserva Bedsonline 221-5639625",
            "priority": "P2",
            "created_at": "15/05/2026 16:25:18",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:50:54"
          },
          {
            "ticket_id": 18169,
            "ticket_number": "3518157",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 16:25:31",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:25:32"
          },
          {
            "ticket_id": 18170,
            "ticket_number": "3518158",
            "title": "Documentação da reserva TTN-1245967955#101972083",
            "priority": "P2",
            "created_at": "15/05/2026 16:25:40",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:34:30"
          },
          {
            "ticket_id": 18171,
            "ticket_number": "3518159",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 16:35:04",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:35:04"
          },
          {
            "ticket_id": 18174,
            "ticket_number": "3518162",
            "title": "Documentação da reserva TTN-1227746821#101975945",
            "priority": "P2",
            "created_at": "15/05/2026 16:45:16",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:02:15"
          },
          {
            "ticket_id": 18176,
            "ticket_number": "3518164",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 16:45:30",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:45:30"
          },
          {
            "ticket_id": 18182,
            "ticket_number": "3518170",
            "title": "GBN Travel: Resend booking confirmation - GBN-9279",
            "priority": "P2",
            "created_at": "15/05/2026 17:49:55",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:49:55"
          },
          {
            "ticket_id": 18188,
            "ticket_number": "3518176",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:56",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:50:56"
          },
          {
            "ticket_id": 18196,
            "ticket_number": "3518184",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "15/05/2026 19:22:25",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 21:55:04"
          },
          {
            "ticket_id": 18213,
            "ticket_number": "3518201",
            "title": "GBN-124245 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/05/2026 22:42:35",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 13.15,
            "sla_met": false,
            "sla_breach_hours": 9.15,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 11:52:23"
          },
          {
            "ticket_id": 18214,
            "ticket_number": "3518202",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:12",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 08:50:12"
          },
          {
            "ticket_id": 18215,
            "ticket_number": "3518203",
            "title": "Fwd: Re: [Cockpit] Viagem TRP-2026-04148 - Senegal",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:16",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 08:50:16"
          },
          {
            "ticket_id": 18216,
            "ticket_number": "3518204",
            "title": "REMINDER: Dados de Passaporte - nosso File 415469",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:20",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 10:29:47"
          },
          {
            "ticket_id": 18218,
            "ticket_number": "3518206",
            "title": "ifthenpay:  Processamento do dia 15-05-2026 da con",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:27",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 09:33:25"
          },
          {
            "ticket_id": 18219,
            "ticket_number": "3518207",
            "title": "Fwd: RE: [Cockpit] Viagem TRP-2026-04032 - Senegal",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:34",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 08:50:35"
          },
          {
            "ticket_id": 18220,
            "ticket_number": "3518208",
            "title": "REMINDER: Dados de Passaporte - nosso File 415457",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:42",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 10:31:06"
          },
          {
            "ticket_id": 18221,
            "ticket_number": "3518209",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:49",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 10:28:14"
          },
          {
            "ticket_id": 18223,
            "ticket_number": "3518211",
            "title": "IFTHENPAY - Pagamento Efetuado: ID b2b0490863b2491",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:56",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 10:03:59"
          },
          {
            "ticket_id": 18224,
            "ticket_number": "3518212",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "16/05/2026 08:51:03",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 08:51:03"
          },
          {
            "ticket_id": 18225,
            "ticket_number": "3518213",
            "title": "GBN-124378 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/05/2026 08:51:09",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 08:51:09"
          },
          {
            "ticket_id": 18226,
            "ticket_number": "3518214",
            "title": "Fwd: Re: [Cockpit] Viagem TRP-2026-04062 - Senegal",
            "priority": "P2",
            "created_at": "16/05/2026 10:23:49",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 10:23:49"
          },
          {
            "ticket_id": 18230,
            "ticket_number": "3518218",
            "title": "Mensagem sobre a reserva 2962102 - Civitatis",
            "priority": "P2",
            "created_at": "16/05/2026 13:00:13",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 13:08:05"
          },
          {
            "ticket_id": 18231,
            "ticket_number": "3518219",
            "title": "Confirmation of booking with locator91PACLYJ",
            "priority": "P2",
            "created_at": "16/05/2026 13:00:15",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 13:06:59"
          },
          {
            "ticket_id": 18232,
            "ticket_number": "3518220",
            "title": "Mensagem sobre a reserva 2962101 - Civitatis",
            "priority": "P2",
            "created_at": "16/05/2026 13:00:17",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 13:06:38"
          },
          {
            "ticket_id": 18233,
            "ticket_number": "3518221",
            "title": "Confirmação de reserva – Ref PP551204, Sra. Ana Ri",
            "priority": "P2",
            "created_at": "16/05/2026 13:00:19",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 13:08:20"
          },
          {
            "ticket_id": 18234,
            "ticket_number": "3518222",
            "title": "Confirmation of booking with locator69MFPC7D",
            "priority": "P2",
            "created_at": "16/05/2026 15:00:51",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 15:13:44"
          },
          {
            "ticket_id": 18235,
            "ticket_number": "3518223",
            "title": "GBN-124418 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/05/2026 16:46:41",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 16:46:41"
          },
          {
            "ticket_id": 18236,
            "ticket_number": "3518224",
            "title": "GBN-124421 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/05/2026 16:58:42",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 16:58:42"
          },
          {
            "ticket_id": 18237,
            "ticket_number": "3518225",
            "title": "GBN-124405 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "16/05/2026 16:58:44",
            "close_date": "2026-05-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 16:58:44"
          },
          {
            "ticket_id": 18249,
            "ticket_number": "3518237",
            "title": "Claudia Costa - Voucher Mx - Mayo 2026",
            "priority": "P2",
            "created_at": "17/05/2026 21:42:56",
            "close_date": "2026-05-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/05/2026 21:44:00"
          },
          {
            "ticket_id": 18259,
            "ticket_number": "3518247",
            "title": "RE: comp pagamento 6132660",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:41",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:23:54"
          },
          {
            "ticket_id": 18261,
            "ticket_number": "3518249",
            "title": "Envio de documento / Document delivery",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:45",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:52:08"
          },
          {
            "ticket_id": 18263,
            "ticket_number": "3518251",
            "title": "Proforma CnTravel 99125470",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:58:21"
          },
          {
            "ticket_id": 18294,
            "ticket_number": "3518282",
            "title": "Proforma CnTravel 99124736",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:43",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:40:56"
          },
          {
            "ticket_id": 18299,
            "ticket_number": "3518287",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:30:46"
          },
          {
            "ticket_id": 18316,
            "ticket_number": "3518304",
            "title": "Pedido de faturas",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:58",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:22:59"
          },
          {
            "ticket_id": 18320,
            "ticket_number": "3518308",
            "title": "Modification of booking with locator2SC3IZKS",
            "priority": "P2",
            "created_at": "18/05/2026 09:23:11",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:41:28"
          },
          {
            "ticket_id": 18323,
            "ticket_number": "3518311",
            "title": "Documentação da reserva TTN-1264890191#102084894",
            "priority": "P2",
            "created_at": "18/05/2026 10:12:46",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:56:34"
          },
          {
            "ticket_id": 18324,
            "ticket_number": "3518312",
            "title": "Documentação da reserva TTN-1265405855#102087255",
            "priority": "P2",
            "created_at": "18/05/2026 10:12:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:57:06"
          },
          {
            "ticket_id": 18325,
            "ticket_number": "3518313",
            "title": "Documentação da reserva TTN-1279660251#102087297",
            "priority": "P2",
            "created_at": "18/05/2026 10:12:57",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:35:33"
          },
          {
            "ticket_id": 18327,
            "ticket_number": "3518315",
            "title": "Documentação da reserva TTN-1234166917#102086765",
            "priority": "P2",
            "created_at": "18/05/2026 10:13:06",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:38:14"
          },
          {
            "ticket_id": 18329,
            "ticket_number": "3518317",
            "title": "GBN-124449 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:28",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:15:28"
          },
          {
            "ticket_id": 18332,
            "ticket_number": "3518320",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:35",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:33:16"
          },
          {
            "ticket_id": 18334,
            "ticket_number": "3518322",
            "title": "GBN-124449 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/05/2026 10:16:19",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:29:47"
          },
          {
            "ticket_id": 18336,
            "ticket_number": "3518324",
            "title": "GBN-124449 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "18/05/2026 10:42:56",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:00:04"
          },
          {
            "ticket_id": 18343,
            "ticket_number": "3518331",
            "title": "Envio de documentação - FILE 432065",
            "priority": "P2",
            "created_at": "18/05/2026 11:16:40",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 6.17,
            "sla_met": false,
            "sla_breach_hours": 2.17,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:27:30"
          },
          {
            "ticket_id": 18345,
            "ticket_number": "3518333",
            "title": "Envio de Documentação * File 435009",
            "priority": "P2",
            "created_at": "18/05/2026 11:16:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:48:32"
          },
          {
            "ticket_id": 18346,
            "ticket_number": "3518334",
            "title": "Documentação da reserva TTN-1263616449#102103634",
            "priority": "P2",
            "created_at": "18/05/2026 11:16:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:56:54"
          },
          {
            "ticket_id": 18353,
            "ticket_number": "3518341",
            "title": "Fwd: Documentação da reserva TTN-1279660251#102083",
            "priority": "P2",
            "created_at": "18/05/2026 12:57:04",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 12:57:05"
          },
          {
            "ticket_id": 18354,
            "ticket_number": "3518342",
            "title": "Re:[## 41168 ##] GBN-124151 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "18/05/2026 12:57:17",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.33,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:17:17"
          },
          {
            "ticket_id": 18357,
            "ticket_number": "3518345",
            "title": "Vila Galé | Confirmação da Reserva Nº9271195",
            "priority": "P2",
            "created_at": "18/05/2026 12:57:25",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.45,
            "sla_met": false,
            "sla_breach_hours": 0.45,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:25:21"
          },
          {
            "ticket_id": 18358,
            "ticket_number": "3518346",
            "title": "Vila Galé | Confirmação da Reserva Nº9271195",
            "priority": "P2",
            "created_at": "18/05/2026 12:57:28",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.25,
            "sla_met": false,
            "sla_breach_hours": 0.25,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:12:48"
          },
          {
            "ticket_id": 18362,
            "ticket_number": "3518350",
            "title": "RESERVA LEPLAN LOCALIZADOR 604572924 - CONTACTO CL",
            "priority": "P2",
            "created_at": "18/05/2026 15:57:51",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:07:37"
          },
          {
            "ticket_id": 18364,
            "ticket_number": "3518352",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:00",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 15:58:00"
          },
          {
            "ticket_id": 18366,
            "ticket_number": "3518354",
            "title": "Envio de Documentação * File 437298",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:10",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:58:55"
          },
          {
            "ticket_id": 18367,
            "ticket_number": "3518355",
            "title": "Tailândia - Festival das Lanternas 2026 - Saída a ",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:12",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:51:12"
          },
          {
            "ticket_id": 18368,
            "ticket_number": "3518356",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624205",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:13",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:29:21"
          },
          {
            "ticket_id": 18371,
            "ticket_number": "3518359",
            "title": "Número de informação da reserva: 6148098",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:23",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:43:58"
          },
          {
            "ticket_id": 18374,
            "ticket_number": "3518362",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:42",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 15:58:42"
          },
          {
            "ticket_id": 18375,
            "ticket_number": "3518363",
            "title": "Número de informação da reserva: 6148097",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:45",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:46:13"
          },
          {
            "ticket_id": 18376,
            "ticket_number": "3518364",
            "title": "GBN-123169 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:38:51"
          },
          {
            "ticket_id": 18377,
            "ticket_number": "3518365",
            "title": "Assinatura Contrato Ana Ribeiro - Comunicação",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:49",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:51:01"
          },
          {
            "ticket_id": 18379,
            "ticket_number": "3518367",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:32:59",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:32:59"
          },
          {
            "ticket_id": 18381,
            "ticket_number": "3518369",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:05",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:33:05"
          },
          {
            "ticket_id": 18382,
            "ticket_number": "3518370",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:09",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:33:09"
          },
          {
            "ticket_id": 18383,
            "ticket_number": "3518371",
            "title": "URGENTE LOC 604585334 PASAPORTES",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:11",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:37:15"
          },
          {
            "ticket_id": 18384,
            "ticket_number": "3518372",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:21",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:33:21"
          },
          {
            "ticket_id": 18385,
            "ticket_number": "3518373",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:29",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:33:29"
          },
          {
            "ticket_id": 18386,
            "ticket_number": "3518374",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:57:43",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:57:43"
          },
          {
            "ticket_id": 18387,
            "ticket_number": "3518375",
            "title": "Confirmação reserva Bedsonline 102-20659454",
            "priority": "P2",
            "created_at": "18/05/2026 16:57:45",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:59:47"
          },
          {
            "ticket_id": 18388,
            "ticket_number": "3518376",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:57:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:57:49"
          },
          {
            "ticket_id": 18389,
            "ticket_number": "3518377",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "18/05/2026 16:57:52",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:02:45"
          },
          {
            "ticket_id": 18391,
            "ticket_number": "3518379",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "18/05/2026 16:57:57",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:57:57"
          },
          {
            "ticket_id": 18394,
            "ticket_number": "3518382",
            "title": "Alteração horário voo PXO-OPO HAT",
            "priority": "P2",
            "created_at": "18/05/2026 17:38:17",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 18:33:05"
          },
          {
            "ticket_id": 18395,
            "ticket_number": "3518383",
            "title": "Envio de documentação - FILE 415457",
            "priority": "P2",
            "created_at": "18/05/2026 17:38:23",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:47:44"
          },
          {
            "ticket_id": 18411,
            "ticket_number": "3518399",
            "title": "Credenciais Odisseias",
            "priority": "P2",
            "created_at": "18/05/2026 21:44:58",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 21:44:59"
          },
          {
            "ticket_id": 18417,
            "ticket_number": "3518405",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "18/05/2026 22:42:20",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 10.28,
            "sla_met": false,
            "sla_breach_hours": 6.28,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 08:59:44"
          },
          {
            "ticket_id": 18428,
            "ticket_number": "3518416",
            "title": "Confirmação de reserva – Ref PP216713, Sr. Tiago E",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:57",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:33:54"
          },
          {
            "ticket_id": 18431,
            "ticket_number": "3518419",
            "title": "Saídas de 18/06/2026 para 23/07/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "19/05/2026 09:21:44",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:36:43"
          },
          {
            "ticket_id": 18432,
            "ticket_number": "3518420",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "19/05/2026 09:21:47",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:39:22"
          },
          {
            "ticket_id": 18433,
            "ticket_number": "3518421",
            "title": "Fwd: Declined: RGPD - José Pestana",
            "priority": "P2",
            "created_at": "19/05/2026 09:21:48",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:21:48"
          },
          {
            "ticket_id": 18434,
            "ticket_number": "3518422",
            "title": "Envio de Nota de Crédito 28911/26",
            "priority": "P2",
            "created_at": "19/05/2026 09:21:52",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:23:19"
          },
          {
            "ticket_id": 18442,
            "ticket_number": "3518430",
            "title": "Informação de reserva - SPT002601624165",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:44",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 10:20:57"
          },
          {
            "ticket_id": 18445,
            "ticket_number": "3518433",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "19/05/2026 10:23:06",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 10:30:12"
          },
          {
            "ticket_id": 18446,
            "ticket_number": "3518434",
            "title": "Alteração horário voo PXO-OPO HAT",
            "priority": "P1",
            "created_at": "19/05/2026 10:47:39",
            "close_date": "2026-05-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.02,
            "sla_met": false,
            "sla_breach_hours": 0.77,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 11:49:14"
          },
          {
            "ticket_id": 18447,
            "ticket_number": "3518435",
            "title": "Alteração horário voo PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 10:47:40",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:12:45"
          },
          {
            "ticket_id": 18448,
            "ticket_number": "3518436",
            "title": "Documentação da reserva TTN-1258540578#102238783",
            "priority": "P2",
            "created_at": "19/05/2026 10:47:47",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:16:00"
          },
          {
            "ticket_id": 18449,
            "ticket_number": "3518437",
            "title": "Documentação da reserva TTN-1239597920#102237335",
            "priority": "P2",
            "created_at": "19/05/2026 10:47:54",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:19:30"
          },
          {
            "ticket_id": 18450,
            "ticket_number": "3518438",
            "title": "Documentação da reserva TTN-1258567511#102238269",
            "priority": "P2",
            "created_at": "19/05/2026 10:48:02",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:26:42"
          },
          {
            "ticket_id": 18451,
            "ticket_number": "3518439",
            "title": "Documentação da reserva TTN-1237741509#102237767",
            "priority": "P2",
            "created_at": "19/05/2026 10:48:11",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:28:47"
          },
          {
            "ticket_id": 18452,
            "ticket_number": "3518440",
            "title": "Documentação da reserva TTN-1258439429#102238080",
            "priority": "P2",
            "created_at": "19/05/2026 10:48:18",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 12:54:16"
          },
          {
            "ticket_id": 18453,
            "ticket_number": "3518441",
            "title": "Documentação da reserva TTN-1259122340#102238578",
            "priority": "P2",
            "created_at": "19/05/2026 10:48:25",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 12:18:36"
          },
          {
            "ticket_id": 18454,
            "ticket_number": "3518442",
            "title": "Documentação da reserva TTN-1238331650#102235324",
            "priority": "P2",
            "created_at": "19/05/2026 10:48:32",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:09:45"
          },
          {
            "ticket_id": 18455,
            "ticket_number": "3518443",
            "title": "Chi… - quê? O mosquito que está a chegar mais pert",
            "priority": "P2",
            "created_at": "19/05/2026 11:16:48",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 11:18:20"
          },
          {
            "ticket_id": 18456,
            "ticket_number": "3518444",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "19/05/2026 11:16:50",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:14:05"
          },
          {
            "ticket_id": 18459,
            "ticket_number": "3518447",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "19/05/2026 11:16:57",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 12:34:47"
          },
          {
            "ticket_id": 18467,
            "ticket_number": "3518455",
            "title": "Alteração horário voos OPO-PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 13:03:55",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:10:07"
          },
          {
            "ticket_id": 18468,
            "ticket_number": "3518456",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/05/2026 13:13:59",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:34:33"
          },
          {
            "ticket_id": 18469,
            "ticket_number": "3518457",
            "title": "Fwd: Greve Geral | 3 junho 2026",
            "priority": "P2",
            "created_at": "19/05/2026 13:14:02",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:14:02"
          },
          {
            "ticket_id": 18470,
            "ticket_number": "3518458",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/05/2026 13:14:28",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:22:57"
          },
          {
            "ticket_id": 18471,
            "ticket_number": "3518459",
            "title": "Fwd: L8MG7B | Efetua o check-in online para o teu ",
            "priority": "P2",
            "created_at": "19/05/2026 13:14:38",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:14:39"
          },
          {
            "ticket_id": 18472,
            "ticket_number": "3518460",
            "title": "Fwd: O seu cartão de embarque para o voo em 20 May",
            "priority": "P2",
            "created_at": "19/05/2026 13:14:42",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:14:42"
          },
          {
            "ticket_id": 18477,
            "ticket_number": "3518465",
            "title": "Reserva GBN-121903 sem acesso ao site da Ryanair",
            "priority": "P2",
            "created_at": "19/05/2026 13:51:46",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:51:46"
          },
          {
            "ticket_id": 18485,
            "ticket_number": "3518473",
            "title": "FW: Envio de Documentação - FILE 5006926 - SANDRA ",
            "priority": "P2",
            "created_at": "19/05/2026 14:31:14",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:18:28"
          },
          {
            "ticket_id": 18487,
            "ticket_number": "3518475",
            "title": "Alteração horário voos OPO-PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 14:55:13",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 15:45:11"
          },
          {
            "ticket_id": 18488,
            "ticket_number": "3518476",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/05/2026 14:55:15",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:52:08"
          },
          {
            "ticket_id": 18489,
            "ticket_number": "3518477",
            "title": "Alteração horário voos OPO-PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 14:55:17",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:09:12"
          },
          {
            "ticket_id": 18490,
            "ticket_number": "3518478",
            "title": "[Suporte] TRP-2026-02565 - Custo EasyPay ?",
            "priority": "P2",
            "created_at": "19/05/2026 15:25:24",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 15:25:24"
          },
          {
            "ticket_id": 18491,
            "ticket_number": "3518479",
            "title": "Incidente de voo TTN-1261990228#102288610#T2012531",
            "priority": "P2",
            "created_at": "19/05/2026 15:27:49",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:24:49"
          },
          {
            "ticket_id": 18492,
            "ticket_number": "3518480",
            "title": "PPT formação",
            "priority": "P2",
            "created_at": "19/05/2026 15:28:04",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 15:28:05"
          },
          {
            "ticket_id": 18494,
            "ticket_number": "3518482",
            "title": "Re:[## 41352 ##] GBN-121903 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "19/05/2026 15:28:10",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:24:49"
          },
          {
            "ticket_id": 18495,
            "ticket_number": "3518483",
            "title": "Alteração horário voos OPO-PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 15:28:12",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:11:41"
          },
          {
            "ticket_id": 18497,
            "ticket_number": "3518485",
            "title": "Confirmação de reserva 338534 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "19/05/2026 16:07:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:04:53"
          },
          {
            "ticket_id": 18500,
            "ticket_number": "3518488",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "19/05/2026 16:15:28",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 6.5,
            "sla_met": false,
            "sla_breach_hours": 2.5,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:09"
          },
          {
            "ticket_id": 18502,
            "ticket_number": "3518490",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "19/05/2026 16:30:26",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:54:12"
          },
          {
            "ticket_id": 18503,
            "ticket_number": "3518491",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 16:47:30",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:47:30"
          },
          {
            "ticket_id": 18508,
            "ticket_number": "3518496",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:09",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:09"
          },
          {
            "ticket_id": 18509,
            "ticket_number": "3518497",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:12",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:12"
          },
          {
            "ticket_id": 18512,
            "ticket_number": "3518500",
            "title": "Incidente de voo TTN-1236232280#102308261#T2012991",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:20",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 21:40:04"
          },
          {
            "ticket_id": 18513,
            "ticket_number": "3518501",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:27",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:27"
          },
          {
            "ticket_id": 18514,
            "ticket_number": "3518502",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:38",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:39"
          },
          {
            "ticket_id": 18516,
            "ticket_number": "3518504",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:51",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:51"
          },
          {
            "ticket_id": 18517,
            "ticket_number": "3518505",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:55",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:47:55"
          },
          {
            "ticket_id": 18535,
            "ticket_number": "3518523",
            "title": "Acesso ao operador \"Expedia TAAP\"",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:04",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:04"
          },
          {
            "ticket_id": 18539,
            "ticket_number": "3518527",
            "title": "Cancelamento subscrição",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:16",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:16"
          },
          {
            "ticket_id": 18541,
            "ticket_number": "3518529",
            "title": "Pedido de acessos Airalo",
            "priority": "P2",
            "created_at": "19/05/2026 22:46:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 22:46:22"
          },
          {
            "ticket_id": 18544,
            "ticket_number": "3518532",
            "title": "Sua ideia de viagem tem um preço melhor!",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:47",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 10:37:15"
          },
          {
            "ticket_id": 18546,
            "ticket_number": "3518534",
            "title": "Incidente de voo TTN-1236232280#102308261#T2012991",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:52",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 10:40:57"
          },
          {
            "ticket_id": 18547,
            "ticket_number": "3518535",
            "title": "Información de su solicitud de Grupos",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:55",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18548,
            "ticket_number": "3518536",
            "title": "REMINDER: Dados de Passaporte - nosso File 420075",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:57",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 11:19:41"
          },
          {
            "ticket_id": 18549,
            "ticket_number": "3518537",
            "title": "Transfer em Tóquio, dados do motorista",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:58",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:54:33"
          },
          {
            "ticket_id": 18556,
            "ticket_number": "3518544",
            "title": "Reserva confirmada: Tour gastronômico por Tsukiji ",
            "priority": "P2",
            "created_at": "20/05/2026 09:02:13",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 10:11:04"
          },
          {
            "ticket_id": 18558,
            "ticket_number": "3518546",
            "title": "Confirmação de reserva com localizador: 4225257",
            "priority": "P2",
            "created_at": "20/05/2026 09:02:48",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:59:54"
          },
          {
            "ticket_id": 18562,
            "ticket_number": "3518550",
            "title": "Confirmation of booking with locatorXMEG36S1",
            "priority": "P2",
            "created_at": "20/05/2026 09:03:11",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18564,
            "ticket_number": "3518552",
            "title": "Fwd: Declined: CVO - Confirmação de Viagem - TRP-2",
            "priority": "P2",
            "created_at": "20/05/2026 09:34:01",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:34:01"
          },
          {
            "ticket_id": 18568,
            "ticket_number": "3518556",
            "title": "RE: comp pagamento 6148097",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:11",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:55:18"
          },
          {
            "ticket_id": 18569,
            "ticket_number": "3518557",
            "title": "RE: comp pagamento 6122762",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:12",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:55:29"
          },
          {
            "ticket_id": 18570,
            "ticket_number": "3518558",
            "title": "RE: comp pagamento 6147441",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:14",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:55:40"
          },
          {
            "ticket_id": 18571,
            "ticket_number": "3518559",
            "title": "RE: comp pagamento 6148037",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:15",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:56:05"
          },
          {
            "ticket_id": 18572,
            "ticket_number": "3518560",
            "title": "RE: comp pagamento 6147436",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:17",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:55:51"
          },
          {
            "ticket_id": 18573,
            "ticket_number": "3518561",
            "title": "RE: comp pagamento 6131346",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:19",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:56:16"
          },
          {
            "ticket_id": 18574,
            "ticket_number": "3518562",
            "title": "RE: comp pagamernto 6120833",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:21",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:56:10"
          },
          {
            "ticket_id": 18575,
            "ticket_number": "3518563",
            "title": "RE: comp pagamento 6147443",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:23",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:56:34"
          },
          {
            "ticket_id": 18579,
            "ticket_number": "3518567",
            "title": "Confirmacao 345737",
            "priority": "P2",
            "created_at": "20/05/2026 10:00:43",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:13:22"
          },
          {
            "ticket_id": 18580,
            "ticket_number": "3518568",
            "title": "Alteração de Horário - File 345504",
            "priority": "P1",
            "created_at": "20/05/2026 10:00:44",
            "close_date": "2026-05-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.08,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA P1",
            "first_response_at": "20/05/2026 11:06:35"
          },
          {
            "ticket_id": 18583,
            "ticket_number": "3518571",
            "title": "(A/c Magali)- Reserva 604597980 Travelplan - corre",
            "priority": "P2",
            "created_at": "20/05/2026 10:42:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 11:59:36"
          },
          {
            "ticket_id": 18584,
            "ticket_number": "3518572",
            "title": "Envio de documentação - FILE 415469",
            "priority": "P2",
            "created_at": "20/05/2026 11:08:04",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:17:25"
          },
          {
            "ticket_id": 18589,
            "ticket_number": "3518577",
            "title": "Confirmação de reserva com localizador: 4225895",
            "priority": "P2",
            "created_at": "20/05/2026 11:57:38",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:54:16"
          },
          {
            "ticket_id": 18594,
            "ticket_number": "3518582",
            "title": "Número de informação da reserva: 6148237",
            "priority": "P2",
            "created_at": "20/05/2026 12:34:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 12:53:09"
          },
          {
            "ticket_id": 18595,
            "ticket_number": "3518583",
            "title": "Fwd: L8MG7B | Clica aqui para o receberes primeiro",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:02",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:02"
          },
          {
            "ticket_id": 18596,
            "ticket_number": "3518584",
            "title": "Fwd: Documentação da reserva TTN-1272813682#102360",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:10",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:11"
          },
          {
            "ticket_id": 18597,
            "ticket_number": "3518585",
            "title": "Fwd: Confirmação da sua reserva JLWENT - LIS-PMI 2",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:13",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:14"
          },
          {
            "ticket_id": 18598,
            "ticket_number": "3518586",
            "title": "Fwd: Confirmação da sua reserva TKWRGJ - LIS-PMI 2",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:16",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:17"
          },
          {
            "ticket_id": 18599,
            "ticket_number": "3518587",
            "title": "Fwd: Important information about your flight",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:19",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:20"
          },
          {
            "ticket_id": 18600,
            "ticket_number": "3518588",
            "title": "Fwd: Confirmação de reserva alterada: a sua viajem",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:22"
          },
          {
            "ticket_id": 18601,
            "ticket_number": "3518589",
            "title": "Fwd: Confirmação da sua reserva NG2M2F - LIS-PMI 0",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:25",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:25"
          },
          {
            "ticket_id": 18603,
            "ticket_number": "3518591",
            "title": "Fwd: Departure time change: Your flight EY100 to A",
            "priority": "P2",
            "created_at": "20/05/2026 13:24:30",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:24:31"
          },
          {
            "ticket_id": 18604,
            "ticket_number": "3518592",
            "title": "ANDREIA PATRICIA FERREIRA BATISTA RD MAIO",
            "priority": "P2",
            "created_at": "20/05/2026 13:37:09",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:38:08"
          },
          {
            "ticket_id": 18608,
            "ticket_number": "3518596",
            "title": "GBN-124464 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "20/05/2026 14:22:05",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:24:20"
          },
          {
            "ticket_id": 18610,
            "ticket_number": "3518598",
            "title": "Solole. Booking 2Q0ZC2OE is close to entering expe",
            "priority": "P2",
            "created_at": "20/05/2026 14:22:10",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:45:35"
          },
          {
            "ticket_id": 18611,
            "ticket_number": "3518599",
            "title": "GBN-124464 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "20/05/2026 14:29:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:16:24"
          },
          {
            "ticket_id": 18612,
            "ticket_number": "3518600",
            "title": "GBN-124464 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/05/2026 14:29:24",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:14:46"
          },
          {
            "ticket_id": 18614,
            "ticket_number": "3518602",
            "title": "Documentação Disponível - Reserva 334347",
            "priority": "P2",
            "created_at": "20/05/2026 14:59:56",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:34:43"
          },
          {
            "ticket_id": 18620,
            "ticket_number": "3518608",
            "title": "Confirmação de reserva para For PT004157 67390950",
            "priority": "P2",
            "created_at": "20/05/2026 15:30:42",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:44:58"
          },
          {
            "ticket_id": 18624,
            "ticket_number": "3518612",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 15:57:25",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:57:25"
          },
          {
            "ticket_id": 18625,
            "ticket_number": "3518613",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 15:57:34",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:57:34"
          },
          {
            "ticket_id": 18626,
            "ticket_number": "3518614",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 15:57:42",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:57:43"
          },
          {
            "ticket_id": 18627,
            "ticket_number": "3518615",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 16:04:22",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:04:22"
          },
          {
            "ticket_id": 18628,
            "ticket_number": "3518616",
            "title": "[Suporte] TRP-2026-05172 / TRL-2026-08016 - GBN al",
            "priority": "P2",
            "created_at": "20/05/2026 16:05:26",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:05:27"
          },
          {
            "ticket_id": 18629,
            "ticket_number": "3518617",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 16:41:31",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:41:31"
          },
          {
            "ticket_id": 18630,
            "ticket_number": "3518618",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "20/05/2026 16:41:38",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:41:38"
          },
          {
            "ticket_id": 18631,
            "ticket_number": "3518619",
            "title": "Confirmação de reserva para For PT004157 67529520",
            "priority": "P2",
            "created_at": "20/05/2026 16:41:58",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 16:52:35"
          },
          {
            "ticket_id": 18644,
            "ticket_number": "3518632",
            "title": "cancelamento subscrição",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:49",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:26:49"
          },
          {
            "ticket_id": 18652,
            "ticket_number": "3518640",
            "title": "Fwd: Atualização | Remoção da sobretaxa de combust",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:41",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:51:42"
          },
          {
            "ticket_id": 18655,
            "ticket_number": "3518643",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:50",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 18:42:55"
          },
          {
            "ticket_id": 18656,
            "ticket_number": "3518644",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:52",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 18:43:02"
          },
          {
            "ticket_id": 18687,
            "ticket_number": "3518675",
            "title": "[Suporte] TRP-2026-02780 / TRL-2026-04285 - Vouche",
            "priority": "P2",
            "created_at": "21/05/2026 01:57:14",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 01:57:14"
          },
          {
            "ticket_id": 18688,
            "ticket_number": "3518676",
            "title": "REMINDER: Dados de Passaporte - nosso File 431638",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:43",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 09:44:51"
          },
          {
            "ticket_id": 18689,
            "ticket_number": "3518677",
            "title": "Reserva pendente à espera de emiss��o",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:45",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 09:54:51"
          },
          {
            "ticket_id": 18691,
            "ticket_number": "3518679",
            "title": "Saídas de 20/06/2026 para 25/07/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:48",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:16:14"
          },
          {
            "ticket_id": 18692,
            "ticket_number": "3518680",
            "title": "REMINDER: Dados de Passaporte - nosso File 440322",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:50",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 09:23:26"
          },
          {
            "ticket_id": 18693,
            "ticket_number": "3518681",
            "title": "Eticket - 67390950 - AX  31/05/2026  Veneza, Itáli",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:55",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 09:56:16"
          },
          {
            "ticket_id": 18700,
            "ticket_number": "3518688",
            "title": "FRANCISCO GONCALVES RD MAIO",
            "priority": "P2",
            "created_at": "21/05/2026 09:27:52",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:24:17"
          },
          {
            "ticket_id": 18711,
            "ticket_number": "3518699",
            "title": "RE: comp pagamento 6147437",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:08",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:28:45"
          },
          {
            "ticket_id": 18718,
            "ticket_number": "3518706",
            "title": "Documentação da reserva TTN-1239597920#102489501",
            "priority": "P2",
            "created_at": "21/05/2026 10:30:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:47:20"
          },
          {
            "ticket_id": 18719,
            "ticket_number": "3518707",
            "title": "GBN-125090 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/05/2026 10:30:47",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:30:47"
          },
          {
            "ticket_id": 18728,
            "ticket_number": "3518716",
            "title": "Informações sobre a sua reserva TTN-1258567511#102",
            "priority": "P2",
            "created_at": "21/05/2026 13:11:54",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:38:13"
          },
          {
            "ticket_id": 18729,
            "ticket_number": "3518717",
            "title": "Informações sobre a sua reserva TTN-1258439429#102",
            "priority": "P2",
            "created_at": "21/05/2026 13:11:56",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:04:40"
          },
          {
            "ticket_id": 18735,
            "ticket_number": "3518723",
            "title": "Informações sobre a sua reserva TTN-1259122340#102",
            "priority": "P2",
            "created_at": "21/05/2026 13:12:34",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:04:40"
          },
          {
            "ticket_id": 18745,
            "ticket_number": "3518733",
            "title": "MVU: Cambio Vuelo: 4135844 FAMILIAP 001",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:28",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:19:44"
          },
          {
            "ticket_id": 18749,
            "ticket_number": "3518737",
            "title": "MVU: Cambio Vuelo: 4135832 FAMILIAP 001",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:36",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:24:32"
          },
          {
            "ticket_id": 18750,
            "ticket_number": "3518738",
            "title": "Informações sobre a sua reserva TTN-1258540578#102",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:37",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:33:40"
          },
          {
            "ticket_id": 18751,
            "ticket_number": "3518739",
            "title": "Informações da reserva TTN-1281949570#102530413#T2",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:34:56"
          },
          {
            "ticket_id": 18753,
            "ticket_number": "3518741",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 15:03:23",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:22:48"
          },
          {
            "ticket_id": 18755,
            "ticket_number": "3518743",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:37",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:18:37"
          },
          {
            "ticket_id": 18756,
            "ticket_number": "3518744",
            "title": "Documentação Disponível - Reserva 345688",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:50:57"
          },
          {
            "ticket_id": 18760,
            "ticket_number": "3518748",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:50",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:04:54"
          },
          {
            "ticket_id": 18762,
            "ticket_number": "3518750",
            "title": "GBN-125069 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "21/05/2026 16:18:53",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 385.72,
            "sla_met": false,
            "sla_breach_hours": 361.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:02:46"
          },
          {
            "ticket_id": 18763,
            "ticket_number": "3518751",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:55",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:26:06"
          },
          {
            "ticket_id": 18764,
            "ticket_number": "3518752",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "21/05/2026 16:18:57",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:07:28"
          },
          {
            "ticket_id": 18765,
            "ticket_number": "3518753",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:00",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:46:07"
          },
          {
            "ticket_id": 18767,
            "ticket_number": "3518755",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:05",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:16:31"
          },
          {
            "ticket_id": 18769,
            "ticket_number": "3518757",
            "title": "GBN-125152 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:13",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:19:13"
          },
          {
            "ticket_id": 18770,
            "ticket_number": "3518758",
            "title": "Confirmação de reserva 338138 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "21/05/2026 16:19:15",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:17:33"
          },
          {
            "ticket_id": 18776,
            "ticket_number": "3518764",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/05/2026 16:54:22",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:54:22"
          },
          {
            "ticket_id": 18777,
            "ticket_number": "3518765",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/05/2026 16:54:31",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:54:31"
          },
          {
            "ticket_id": 18779,
            "ticket_number": "3518767",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/05/2026 17:07:21",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:07:21"
          },
          {
            "ticket_id": 18780,
            "ticket_number": "3518768",
            "title": "Confirmação de reserva. Localizador: 6CQCCU17T3",
            "priority": "P2",
            "created_at": "21/05/2026 17:14:17",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:12:24"
          },
          {
            "ticket_id": 18781,
            "ticket_number": "3518769",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 6",
            "priority": "P2",
            "created_at": "21/05/2026 17:14:19",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:15:29"
          },
          {
            "ticket_id": 18782,
            "ticket_number": "3518770",
            "title": "Envio de documento (Factura de Adiantamento-232000",
            "priority": "P2",
            "created_at": "21/05/2026 17:14:25",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:14:00"
          },
          {
            "ticket_id": 18785,
            "ticket_number": "3518773",
            "title": "LOCALIZADOR: 604601162 - leplan - pedido de referê",
            "priority": "P2",
            "created_at": "21/05/2026 17:53:58",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 17:53:59"
          },
          {
            "ticket_id": 18787,
            "ticket_number": "3518775",
            "title": "Aumento Fuel LIS DJE - 13JUN26 * File 437147",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:02",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:55:42"
          },
          {
            "ticket_id": 18788,
            "ticket_number": "3518776",
            "title": "Re:[## 41483 ##] GBN-123532 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:04",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:52:37"
          },
          {
            "ticket_id": 18789,
            "ticket_number": "3518777",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:25:52"
          },
          {
            "ticket_id": 18791,
            "ticket_number": "3518779",
            "title": "Re:[## 41485 ##] GBN-124553 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:10",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:52:30"
          },
          {
            "ticket_id": 18792,
            "ticket_number": "3518780",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:12",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:09:39"
          },
          {
            "ticket_id": 18793,
            "ticket_number": "3518781",
            "title": "Envio de documento (Factura de Adiantamento-232000",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:14",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:15:52"
          },
          {
            "ticket_id": 18794,
            "ticket_number": "3518782",
            "title": "Confirmação de reserva para For PT004157 67529122",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:16",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:57:26"
          },
          {
            "ticket_id": 18795,
            "ticket_number": "3518783",
            "title": "Aumento Fuel LIS DJE - 13JUN26 * File 437112",
            "priority": "P2",
            "created_at": "21/05/2026 17:54:17",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:54:21"
          },
          {
            "ticket_id": 18804,
            "ticket_number": "3518792",
            "title": "Voucher Reserva UMAFAMÍLIAEMVIAGEM (Localizador: 8",
            "priority": "P2",
            "created_at": "21/05/2026 19:00:39",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:12:07"
          },
          {
            "ticket_id": 18806,
            "ticket_number": "3518794",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "21/05/2026 19:00:54",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 19:00:54"
          },
          {
            "ticket_id": 18809,
            "ticket_number": "3518797",
            "title": "Informação de reserva - SPT002601634591",
            "priority": "P3",
            "created_at": "21/05/2026 19:55:42",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 382.1,
            "sla_met": false,
            "sla_breach_hours": 358.1,
            "sla_name": "SLA P3",
            "first_response_at": "06/06/2026 18:02:31"
          },
          {
            "ticket_id": 18817,
            "ticket_number": "3518805",
            "title": "Pagamentos reservas new blue 6131022  6131019 e 61",
            "priority": "P2",
            "created_at": "21/05/2026 21:44:55",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:44:56"
          },
          {
            "ticket_id": 18865,
            "ticket_number": "3518853",
            "title": "[Cancelamento Viagem] TRP-2026-05197 - Carolina Ca",
            "priority": "P2",
            "created_at": "22/05/2026 11:05:12",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 11:05:13"
          },
          {
            "ticket_id": 18873,
            "ticket_number": "3518861",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 12:22:25",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:49:22"
          },
          {
            "ticket_id": 18874,
            "ticket_number": "3518862",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "22/05/2026 12:22:29",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:13:07"
          },
          {
            "ticket_id": 18885,
            "ticket_number": "3518873",
            "title": "Solole. Booking 2Q0ZC2OE is close to entering expe",
            "priority": "P2",
            "created_at": "22/05/2026 14:03:32",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:04:49"
          },
          {
            "ticket_id": 18887,
            "ticket_number": "3518875",
            "title": "Informação de reserva - SPT002601630519",
            "priority": "P2",
            "created_at": "22/05/2026 14:28:38",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:06:59"
          },
          {
            "ticket_id": 18888,
            "ticket_number": "3518876",
            "title": "GBN-125327 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/05/2026 14:28:40",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 14:28:40"
          },
          {
            "ticket_id": 18889,
            "ticket_number": "3518877",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:15:17",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:15:17"
          },
          {
            "ticket_id": 18890,
            "ticket_number": "3518878",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:15:26",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:15:26"
          },
          {
            "ticket_id": 18892,
            "ticket_number": "3518880",
            "title": "[Cancelamento Serviço] TRP-2026-04247 / TRL-2026-0",
            "priority": "P2",
            "created_at": "22/05/2026 15:30:40",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:30:40"
          },
          {
            "ticket_id": 18893,
            "ticket_number": "3518881",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:32:48",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:32:48"
          },
          {
            "ticket_id": 18895,
            "ticket_number": "3518883",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:32:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:32:57"
          },
          {
            "ticket_id": 18896,
            "ticket_number": "3518884",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:33:06",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:33:06"
          },
          {
            "ticket_id": 18897,
            "ticket_number": "3518885",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:33:14",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:33:14"
          },
          {
            "ticket_id": 18898,
            "ticket_number": "3518886",
            "title": "GBN-125343 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "22/05/2026 15:33:17",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:33:18"
          },
          {
            "ticket_id": 18901,
            "ticket_number": "3518889",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:42:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:42:57"
          },
          {
            "ticket_id": 18902,
            "ticket_number": "3518890",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:43:02",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:43:02"
          },
          {
            "ticket_id": 18904,
            "ticket_number": "3518892",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:56:55",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:56:55"
          },
          {
            "ticket_id": 18906,
            "ticket_number": "3518894",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 15:57:01",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:57:01"
          },
          {
            "ticket_id": 18908,
            "ticket_number": "3518896",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624205",
            "priority": "P2",
            "created_at": "22/05/2026 16:08:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:30:50"
          },
          {
            "ticket_id": 18910,
            "ticket_number": "3518898",
            "title": "In Sure Broker - Envio de certificados de seguro",
            "priority": "P2",
            "created_at": "22/05/2026 16:09:02",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:10:11"
          },
          {
            "ticket_id": 18912,
            "ticket_number": "3518900",
            "title": "[Suporte] TRP-2026-04346 - documentação final",
            "priority": "P2",
            "created_at": "22/05/2026 16:39:38",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:39:38"
          },
          {
            "ticket_id": 18913,
            "ticket_number": "3518901",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 16:57:41",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:57:41"
          },
          {
            "ticket_id": 18915,
            "ticket_number": "3518903",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "22/05/2026 16:57:52",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 16:57:52"
          },
          {
            "ticket_id": 18917,
            "ticket_number": "3518905",
            "title": "Confirmação de reserva com localizador: 4223112",
            "priority": "P2",
            "created_at": "22/05/2026 18:16:48",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 19:22:53"
          },
          {
            "ticket_id": 18921,
            "ticket_number": "3518909",
            "title": "Documentação da reserva TTN-1269448599#100445545",
            "priority": "P2",
            "created_at": "22/05/2026 18:17:06",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 19:37:24"
          },
          {
            "ticket_id": 18922,
            "ticket_number": "3518910",
            "title": "[Cancelamento Viagem] TRP-2026-04059 - Anabela Tei",
            "priority": "P2",
            "created_at": "22/05/2026 18:49:52",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 18:49:52"
          },
          {
            "ticket_id": 18923,
            "ticket_number": "3518911",
            "title": "Cancelar subscrição",
            "priority": "P2",
            "created_at": "22/05/2026 19:06:26",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 20:39:10"
          },
          {
            "ticket_id": 18925,
            "ticket_number": "3518913",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "22/05/2026 19:18:58",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 19:29:48"
          },
          {
            "ticket_id": 18926,
            "ticket_number": "3518914",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604639641",
            "priority": "P2",
            "created_at": "22/05/2026 19:18:59",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 19:30:20"
          },
          {
            "ticket_id": 18928,
            "ticket_number": "3518916",
            "title": "Confirmação de reserva com localizador: 4231242",
            "priority": "P2",
            "created_at": "22/05/2026 19:53:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 20:07:31"
          },
          {
            "ticket_id": 18931,
            "ticket_number": "3518919",
            "title": "FW: NOVA RESERVA - SITE SMART PARKING",
            "priority": "P2",
            "created_at": "22/05/2026 21:44:14",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 22:16:33"
          },
          {
            "ticket_id": 18933,
            "ticket_number": "3518921",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604639676",
            "priority": "P2",
            "created_at": "22/05/2026 21:48:45",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 22:16:39"
          },
          {
            "ticket_id": 18989,
            "ticket_number": "3518977",
            "title": "Mensagem sobre a reserva 38792397 - Civitatis",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:26",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:33"
          },
          {
            "ticket_id": 19063,
            "ticket_number": "3519051",
            "title": "Re:[## 41702 ##] GBN-116163 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "25/05/2026 12:31:16",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:21:59"
          },
          {
            "ticket_id": 19358,
            "ticket_number": "3519346",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:13",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:01:21"
          },
          {
            "ticket_id": 19360,
            "ticket_number": "3519348",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:18",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:01:21"
          },
          {
            "ticket_id": 19362,
            "ticket_number": "3519350",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "27/05/2026 10:14:22",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:01:21"
          },
          {
            "ticket_id": 19632,
            "ticket_number": "3519620",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604642907",
            "priority": "Reservas sem Formulário",
            "created_at": "29/05/2026 10:25:15",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/05/2026 14:20:22"
          },
          {
            "ticket_id": 19669,
            "ticket_number": "3519657",
            "title": "GBN-126376 - Reenviar informações sobre sua reserv",
            "priority": "Reservas sem Formulário",
            "created_at": "29/05/2026 12:17:39",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "29/05/2026 12:17:39"
          },
          {
            "ticket_id": 19681,
            "ticket_number": "3519669",
            "title": "Confirmação de reserva – Ref PP594874, Sr. Claudio",
            "priority": "Reservas sem Formulário",
            "created_at": "29/05/2026 13:31:23",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 196.55,
            "sla_met": false,
            "sla_breach_hours": 172.55,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:04:41"
          },
          {
            "ticket_id": 19692,
            "ticket_number": "3519680",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-12",
            "priority": "Reservas sem Formulário",
            "created_at": "29/05/2026 14:49:18",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 195.23,
            "sla_met": false,
            "sla_breach_hours": 171.23,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:04:14"
          },
          {
            "ticket_id": 19723,
            "ticket_number": "3519711",
            "title": "GBN-126405 - Um cliente enviou uma nova solicitaçã",
            "priority": "Reservas sem Formulário",
            "created_at": "29/05/2026 16:31:08",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 193.53,
            "sla_met": false,
            "sla_breach_hours": 169.53,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:03:58"
          },
          {
            "ticket_id": 20004,
            "ticket_number": "3519992",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:14",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 41.07,
            "sla_met": false,
            "sla_breach_hours": 37.07,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 12:09:07"
          },
          {
            "ticket_id": 20006,
            "ticket_number": "3519994",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:21",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 41.07,
            "sla_met": false,
            "sla_breach_hours": 37.07,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 12:08:52"
          },
          {
            "ticket_id": 20008,
            "ticket_number": "3519996",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:25",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 40.0,
            "sla_met": false,
            "sla_breach_hours": 36.0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 11:04:47"
          },
          {
            "ticket_id": 20016,
            "ticket_number": "3520004",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 40.02,
            "sla_met": false,
            "sla_breach_hours": 36.02,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 11:06:41"
          },
          {
            "ticket_id": 20018,
            "ticket_number": "3520006",
            "title": "Pagamentos",
            "priority": "P2",
            "created_at": "01/06/2026 19:04:46",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:04:46"
          },
          {
            "ticket_id": 20168,
            "ticket_number": "3520156",
            "title": "Confirmación del Loc 9140317",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:41",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 12.3,
            "sla_met": false,
            "sla_breach_hours": 8.3,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:10:46"
          },
          {
            "ticket_id": 20169,
            "ticket_number": "3520157",
            "title": "Confirmación del Loc 9140319",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 12.4,
            "sla_met": false,
            "sla_breach_hours": 8.4,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:17:38"
          },
          {
            "ticket_id": 20174,
            "ticket_number": "3520162",
            "title": "Confirmação de reserva para For PT004157 72580901",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:56",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 12.4,
            "sla_met": false,
            "sla_breach_hours": 8.4,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:17:23"
          },
          {
            "ticket_id": 20180,
            "ticket_number": "3520168",
            "title": "Documentação Disponível - Reserva 338629",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:09",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.33,
            "sla_met": false,
            "sla_breach_hours": 7.33,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:13:18"
          },
          {
            "ticket_id": 20183,
            "ticket_number": "3520171",
            "title": "Confirmação de reserva com localizador: 4247903",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:15",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.95,
            "sla_met": false,
            "sla_breach_hours": 7.95,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:50:38"
          },
          {
            "ticket_id": 20188,
            "ticket_number": "3520176",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "02/06/2026 22:13:16",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.8,
            "sla_met": false,
            "sla_breach_hours": 7.8,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:01:57"
          },
          {
            "ticket_id": 20189,
            "ticket_number": "3520177",
            "title": "GBN-127041 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "02/06/2026 22:13:22",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 22:13:22"
          },
          {
            "ticket_id": 20190,
            "ticket_number": "3520178",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "02/06/2026 22:13:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.42,
            "sla_met": false,
            "sla_breach_hours": 7.42,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:39:03"
          },
          {
            "ticket_id": 20192,
            "ticket_number": "3520180",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "02/06/2026 22:13:37",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 22:13:37"
          },
          {
            "ticket_id": 20194,
            "ticket_number": "3520182",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604645462",
            "priority": "P2",
            "created_at": "02/06/2026 22:52:52",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 10.93,
            "sla_met": false,
            "sla_breach_hours": 6.93,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:49:49"
          },
          {
            "ticket_id": 20195,
            "ticket_number": "3520183",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604645461",
            "priority": "P2",
            "created_at": "02/06/2026 22:52:54",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.32,
            "sla_met": false,
            "sla_breach_hours": 7.32,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:12:13"
          },
          {
            "ticket_id": 20196,
            "ticket_number": "3520184",
            "title": "Hotéis Vila Galé | NC 482026/459",
            "priority": "P2",
            "created_at": "02/06/2026 22:52:56",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 10.48,
            "sla_met": false,
            "sla_breach_hours": 6.48,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:22:30"
          },
          {
            "ticket_id": 20197,
            "ticket_number": "3520185",
            "title": "Hotéis Vila Galé | FT 482026/4628",
            "priority": "P2",
            "created_at": "02/06/2026 22:52:58",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.2,
            "sla_met": false,
            "sla_breach_hours": 7.2,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:05:52"
          },
          {
            "ticket_id": 20198,
            "ticket_number": "3520186",
            "title": "Hotéis Vila Galé | NC 482026/459",
            "priority": "P2",
            "created_at": "02/06/2026 22:53:00",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.4,
            "sla_met": false,
            "sla_breach_hours": 7.4,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:17:54"
          },
          {
            "ticket_id": 20200,
            "ticket_number": "3520188",
            "title": "[Suporte] TRP-2026-04724 / TRL-2026-07221 - Fatura",
            "priority": "P2",
            "created_at": "02/06/2026 23:03:35",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 23:03:36"
          },
          {
            "ticket_id": 20202,
            "ticket_number": "3520190",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604645465",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:35",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:54:26"
          },
          {
            "ticket_id": 20203,
            "ticket_number": "3520191",
            "title": "GBN-127048 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:39",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:07:39"
          },
          {
            "ticket_id": 20206,
            "ticket_number": "3520194",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "03/06/2026 09:07:45",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:46:26"
          },
          {
            "ticket_id": 20210,
            "ticket_number": "3520198",
            "title": "Confirmation of booking with locatorJB5BEI72",
            "priority": "P2",
            "created_at": "03/06/2026 09:09:01",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:23:13"
          },
          {
            "ticket_id": 20217,
            "ticket_number": "3520205",
            "title": "Fwd: TSJPMI | Importante: Alterações ao controlo d",
            "priority": "P2",
            "created_at": "03/06/2026 09:57:20",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:57:20"
          },
          {
            "ticket_id": 20218,
            "ticket_number": "3520206",
            "title": "Hotéis Vila Galé | NC 482026/459",
            "priority": "P2",
            "created_at": "03/06/2026 09:58:21",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:16:02"
          },
          {
            "ticket_id": 20221,
            "ticket_number": "3520209",
            "title": "Envio de documentos de File 435009/26",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:28",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:48:05"
          },
          {
            "ticket_id": 20226,
            "ticket_number": "3520214",
            "title": "Re: Localizador: 345645",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:40",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:32:45"
          },
          {
            "ticket_id": 20229,
            "ticket_number": "3520217",
            "title": "Confirmação de reserva para For PT004157 72588955",
            "priority": "P2",
            "created_at": "03/06/2026 10:47:07",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 10:48:26"
          },
          {
            "ticket_id": 20231,
            "ticket_number": "3520219",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "03/06/2026 11:05:44",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 12:07:25"
          },
          {
            "ticket_id": 20241,
            "ticket_number": "3520229",
            "title": "Confirmação de reserva para For PT004157 70685717",
            "priority": "P2",
            "created_at": "03/06/2026 11:34:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 11:54:03"
          },
          {
            "ticket_id": 20245,
            "ticket_number": "3520233",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604595633",
            "priority": "P2",
            "created_at": "03/06/2026 12:11:35",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 12:22:08"
          },
          {
            "ticket_id": 20248,
            "ticket_number": "3520236",
            "title": "PEDIDO VOUCHERS RESERVA Odisseias",
            "priority": "P2",
            "created_at": "03/06/2026 12:23:58",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 12:23:59"
          },
          {
            "ticket_id": 20251,
            "ticket_number": "3520239",
            "title": "Notificação de autorização File 437731/26",
            "priority": "P2",
            "created_at": "03/06/2026 12:56:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 16:42:30"
          },
          {
            "ticket_id": 20252,
            "ticket_number": "3520240",
            "title": "Confirmation of booking with locatorKZ9Z50P4",
            "priority": "Reservas sem Formulário",
            "created_at": "03/06/2026 13:05:05",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 76.97,
            "sla_met": false,
            "sla_breach_hours": 52.97,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:03:36"
          },
          {
            "ticket_id": 20257,
            "ticket_number": "3520245",
            "title": "Fw: File 7004461 // MR CARLOS SILVA X 2",
            "priority": "P2",
            "created_at": "03/06/2026 13:53:17",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 13:53:17"
          },
          {
            "ticket_id": 20274,
            "ticket_number": "3520262",
            "title": "RE: Reserva 6120559 W2MCS:014950003908",
            "priority": "P2",
            "created_at": "03/06/2026 15:42:09",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:40:12"
          },
          {
            "ticket_id": 20278,
            "ticket_number": "3520266",
            "title": "CTM-12725 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "03/06/2026 16:15:14",
            "close_date": "2026-06-06",
            "sla_target_hours": 24,
            "actual_time_hours": 73.8,
            "sla_met": false,
            "sla_breach_hours": 49.8,
            "sla_name": "SLA Padrão",
            "first_response_at": "06/06/2026 18:03:19"
          },
          {
            "ticket_id": 20279,
            "ticket_number": "3520267",
            "title": "Check-in On-line TAP * File 432293",
            "priority": "P2",
            "created_at": "03/06/2026 16:15:17",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:13:15"
          },
          {
            "ticket_id": 20280,
            "ticket_number": "3520268",
            "title": "Novo operador acesso",
            "priority": "P2",
            "created_at": "03/06/2026 16:23:46",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 16:23:47"
          },
          {
            "ticket_id": 20283,
            "ticket_number": "3520271",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 16:45:22",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 16:45:22"
          },
          {
            "ticket_id": 20286,
            "ticket_number": "3520274",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "03/06/2026 17:05:58",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:05:58"
          },
          {
            "ticket_id": 20329,
            "ticket_number": "3520317",
            "title": "CTM-12730 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "03/06/2026 22:44:20",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 36.7,
            "sla_met": false,
            "sla_breach_hours": 32.7,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:26:23"
          },
          {
            "ticket_id": 20330,
            "ticket_number": "3520318",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "03/06/2026 22:44:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 37.78,
            "sla_met": false,
            "sla_breach_hours": 33.78,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:31:56"
          },
          {
            "ticket_id": 20339,
            "ticket_number": "3520327",
            "title": "Confirmação de reserva para For PT004157 72588955",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:33:23"
          },
          {
            "ticket_id": 20342,
            "ticket_number": "3520330",
            "title": "CTM-12731 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:21",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:46:19"
          },
          {
            "ticket_id": 20343,
            "ticket_number": "3520331",
            "title": "CTM-12729 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:02:25",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:46:37"
          },
          {
            "ticket_id": 20347,
            "ticket_number": "3520335",
            "title": "Confirmação reserva Bedsonline 491-2083020",
            "priority": "P2",
            "created_at": "05/06/2026 09:03:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:23:05"
          },
          {
            "ticket_id": 20348,
            "ticket_number": "3520336",
            "title": "CTM-12734 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:03:51",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:27:36"
          },
          {
            "ticket_id": 20351,
            "ticket_number": "3520339",
            "title": "CTM-12733 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:00",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:28:09"
          },
          {
            "ticket_id": 20352,
            "ticket_number": "3520340",
            "title": "CTM-12736 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:03",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:19:10"
          },
          {
            "ticket_id": 20354,
            "ticket_number": "3520342",
            "title": "CTM-12732 - Su confirmación de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:11",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:19:24"
          },
          {
            "ticket_id": 20356,
            "ticket_number": "3520344",
            "title": "Información importante / Important Information",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:15",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:34"
          },
          {
            "ticket_id": 20363,
            "ticket_number": "3520351",
            "title": "REMINDER: Dados de Passaporte - nosso File 442770",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:34",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:48:04"
          },
          {
            "ticket_id": 20370,
            "ticket_number": "3520358",
            "title": "GBN-115418 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:18",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:18:57"
          },
          {
            "ticket_id": 20373,
            "ticket_number": "3520361",
            "title": "CTM-12747 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:25",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:22:11"
          },
          {
            "ticket_id": 20375,
            "ticket_number": "3520363",
            "title": "GBN-105364 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:41:09"
          },
          {
            "ticket_id": 20377,
            "ticket_number": "3520365",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:37",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:35"
          },
          {
            "ticket_id": 20378,
            "ticket_number": "3520366",
            "title": "CTM-12743 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:42",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:45:40"
          },
          {
            "ticket_id": 20380,
            "ticket_number": "3520368",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:52",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:05:52"
          },
          {
            "ticket_id": 20381,
            "ticket_number": "3520369",
            "title": "GBN-127281 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:58",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:05:59"
          },
          {
            "ticket_id": 20382,
            "ticket_number": "3520370",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:35"
          },
          {
            "ticket_id": 20384,
            "ticket_number": "3520372",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:20",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:23:18"
          },
          {
            "ticket_id": 20385,
            "ticket_number": "3520373",
            "title": "GBN-127275 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:24",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:06:24"
          },
          {
            "ticket_id": 20389,
            "ticket_number": "3520377",
            "title": "Confirmação de reserva com localizador: 4251777",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:33",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:21:24"
          },
          {
            "ticket_id": 20392,
            "ticket_number": "3520380",
            "title": "CONGRESSO",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:39",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 09:06:39"
          },
          {
            "ticket_id": 20393,
            "ticket_number": "3520381",
            "title": "Confirmação Reserva * File 425056 - Sunrise Montem",
            "priority": "P2",
            "created_at": "05/06/2026 09:06:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:02:12"
          },
          {
            "ticket_id": 20398,
            "ticket_number": "3520386",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "05/06/2026 09:58:38",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:57:23"
          },
          {
            "ticket_id": 20400,
            "ticket_number": "3520388",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:02",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:22:58"
          },
          {
            "ticket_id": 20402,
            "ticket_number": "3520390",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:06",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:24:21"
          },
          {
            "ticket_id": 20403,
            "ticket_number": "3520391",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:07",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:24:12"
          },
          {
            "ticket_id": 20404,
            "ticket_number": "3520392",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:10",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:24:05"
          },
          {
            "ticket_id": 20405,
            "ticket_number": "3520393",
            "title": "Document from Costa Crociere",
            "priority": "P2",
            "created_at": "05/06/2026 10:00:12",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:23:24"
          },
          {
            "ticket_id": 20410,
            "ticket_number": "3520398",
            "title": "Documentação Disponível - Reserva 339933",
            "priority": "P2",
            "created_at": "05/06/2026 10:50:39",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:53:21"
          },
          {
            "ticket_id": 20411,
            "ticket_number": "3520399",
            "title": "Nova Confirmação de reserva 338541",
            "priority": "P2",
            "created_at": "05/06/2026 10:50:41",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:04:09"
          },
          {
            "ticket_id": 20412,
            "ticket_number": "3520400",
            "title": "Documentação reserva Newblue nr: 6148850",
            "priority": "P2",
            "created_at": "05/06/2026 10:50:42",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 10:50:43"
          },
          {
            "ticket_id": 20415,
            "ticket_number": "3520403",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "05/06/2026 11:27:31",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 12:20:32"
          },
          {
            "ticket_id": 20417,
            "ticket_number": "3520405",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604647112",
            "priority": "P2",
            "created_at": "05/06/2026 11:27:39",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:54:32"
          },
          {
            "ticket_id": 20420,
            "ticket_number": "3520408",
            "title": "Confirmação de reserva 346279",
            "priority": "P2",
            "created_at": "05/06/2026 11:39:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:53:37"
          },
          {
            "ticket_id": 20421,
            "ticket_number": "3520409",
            "title": "Confirmação de reserva para For PT004157 70869531",
            "priority": "P2",
            "created_at": "05/06/2026 11:39:24",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:50:40"
          },
          {
            "ticket_id": 20423,
            "ticket_number": "3520411",
            "title": "GBN-127118 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 11:53:01",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:53:01"
          },
          {
            "ticket_id": 20428,
            "ticket_number": "3520416",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604638533",
            "priority": "P2",
            "created_at": "05/06/2026 12:49:10",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:01:21"
          },
          {
            "ticket_id": 20430,
            "ticket_number": "3520418",
            "title": "UMA FAMILIA EM VIAGEM || RNAVT 11763 : Informações",
            "priority": "P2",
            "created_at": "05/06/2026 13:18:55",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:10:30"
          },
          {
            "ticket_id": 20432,
            "ticket_number": "3520420",
            "title": "CTM-12751 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 13:19:00",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:43:36"
          },
          {
            "ticket_id": 20439,
            "ticket_number": "3520427",
            "title": "Documentação Disponível - Reserva 344723",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:15",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:58:30"
          },
          {
            "ticket_id": 20440,
            "ticket_number": "3520428",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:19",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:40:19"
          },
          {
            "ticket_id": 20441,
            "ticket_number": "3520429",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:40:30"
          },
          {
            "ticket_id": 20444,
            "ticket_number": "3520432",
            "title": "Documentação Disponível - Reserva 345084",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:40",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:51:19"
          },
          {
            "ticket_id": 20445,
            "ticket_number": "3520433",
            "title": "Envio de Fatura 216960",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:42",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:07:53"
          },
          {
            "ticket_id": 20447,
            "ticket_number": "3520435",
            "title": "Documentação Disponível - Reserva 337345",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:49:13"
          },
          {
            "ticket_id": 20448,
            "ticket_number": "3520436",
            "title": "Documentação Disponível - Reserva 334047",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:50",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:50:34"
          },
          {
            "ticket_id": 20449,
            "ticket_number": "3520437",
            "title": "Documentação Disponível - Reserva 340408",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:52",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:49:29"
          },
          {
            "ticket_id": 20450,
            "ticket_number": "3520438",
            "title": "Documentação Disponível - Reserva 334066",
            "priority": "P2",
            "created_at": "05/06/2026 15:40:54",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:49:43"
          },
          {
            "ticket_id": 20452,
            "ticket_number": "3520440",
            "title": "Documentação Disponível - Reserva 340259",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:00",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:52:52"
          },
          {
            "ticket_id": 20453,
            "ticket_number": "3520441",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:03",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:41:03"
          },
          {
            "ticket_id": 20454,
            "ticket_number": "3520442",
            "title": "Documentação Disponível - Reserva 340262",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:05",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:52:38"
          },
          {
            "ticket_id": 20457,
            "ticket_number": "3520445",
            "title": "Soltour: Cancelamento de reserva: SPT002601622816",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:31:44"
          },
          {
            "ticket_id": 20458,
            "ticket_number": "3520446",
            "title": "CTM-12752 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:21",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:57:36"
          },
          {
            "ticket_id": 20459,
            "ticket_number": "3520447",
            "title": "Informação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:26",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 25.47,
            "sla_met": false,
            "sla_breach_hours": 21.47,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 17:09:55"
          },
          {
            "ticket_id": 20462,
            "ticket_number": "3520450",
            "title": "Soltour: Cancelamento de reserva: SPT002601640841",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:31",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:31:14"
          },
          {
            "ticket_id": 20464,
            "ticket_number": "3520452",
            "title": "Notificação de autorização File 432995/26",
            "priority": "P2",
            "created_at": "05/06/2026 15:41:43",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 15:55:19"
          },
          {
            "ticket_id": 20465,
            "ticket_number": "3520453",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:21",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:18:21"
          },
          {
            "ticket_id": 20466,
            "ticket_number": "3520454",
            "title": "CTM-12756 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:24",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:26:12"
          },
          {
            "ticket_id": 20470,
            "ticket_number": "3520458",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:13:44"
          },
          {
            "ticket_id": 20471,
            "ticket_number": "3520459",
            "title": "Confirmação reserva Bedsonline 296-3280961",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:33",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:39:39"
          },
          {
            "ticket_id": 20474,
            "ticket_number": "3520462",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:41",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:18:41"
          },
          {
            "ticket_id": 20475,
            "ticket_number": "3520463",
            "title": "Voucher da reserva",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:44",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:29:18"
          },
          {
            "ticket_id": 20478,
            "ticket_number": "3520466",
            "title": "CHECKIN",
            "priority": "P2",
            "created_at": "05/06/2026 16:46:02",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 16:46:02"
          },
          {
            "ticket_id": 20479,
            "ticket_number": "3520467",
            "title": "Envio de documentação File 432995/26",
            "priority": "P2",
            "created_at": "05/06/2026 16:46:13",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:59:23"
          },
          {
            "ticket_id": 20495,
            "ticket_number": "3520483",
            "title": "GBN-116749 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:16",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:38:54"
          },
          {
            "ticket_id": 20496,
            "ticket_number": "3520484",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:18",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:39:03"
          },
          {
            "ticket_id": 20498,
            "ticket_number": "3520486",
            "title": "Importante - Checkin Online Voos TAP - FILE 345688",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:52:41"
          },
          {
            "ticket_id": 20504,
            "ticket_number": "3520492",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "05/06/2026 17:28:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:53:18"
          },
          {
            "ticket_id": 20514,
            "ticket_number": "3520502",
            "title": "CTM-12757 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "05/06/2026 18:00:57",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 67.28,
            "sla_met": false,
            "sla_breach_hours": 63.28,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 13:18:29"
          },
          {
            "ticket_id": 20517,
            "ticket_number": "3520505",
            "title": "Envio de documentação File 437731/26",
            "priority": "P2",
            "created_at": "05/06/2026 18:33:13",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:34:46"
          },
          {
            "ticket_id": 20522,
            "ticket_number": "3520510",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:02:59",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 20.63,
            "sla_met": false,
            "sla_breach_hours": 16.63,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 17:41:43"
          },
          {
            "ticket_id": 20523,
            "ticket_number": "3520511",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:01",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 15.33,
            "sla_met": false,
            "sla_breach_hours": 11.33,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 12:23:23"
          },
          {
            "ticket_id": 20525,
            "ticket_number": "3520513",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:04",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 15.33,
            "sla_met": false,
            "sla_breach_hours": 11.33,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 12:23:18"
          },
          {
            "ticket_id": 20530,
            "ticket_number": "3520518",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "05/06/2026 21:03:25",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 22:09:26"
          },
          {
            "ticket_id": 20541,
            "ticket_number": "3520529",
            "title": "Pedido de acesso",
            "priority": "P2",
            "created_at": "06/06/2026 10:36:13",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 10:36:13"
          },
          {
            "ticket_id": 20546,
            "ticket_number": "3520534",
            "title": "Confirmacao 346370",
            "priority": "P2",
            "created_at": "06/06/2026 10:36:25",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 11:08:27"
          },
          {
            "ticket_id": 20547,
            "ticket_number": "3520535",
            "title": "Voucher da reserva",
            "priority": "P2",
            "created_at": "06/06/2026 10:36:28",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 12:26:27"
          },
          {
            "ticket_id": 20557,
            "ticket_number": "3520545",
            "title": "GBN-127513 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/06/2026 12:33:49",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 12:33:49"
          },
          {
            "ticket_id": 20562,
            "ticket_number": "3520550",
            "title": "Cotur Portugal: 2 serviços falharam na reserva CTM",
            "priority": "P2",
            "created_at": "06/06/2026 13:49:30",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 16:13:51"
          },
          {
            "ticket_id": 20565,
            "ticket_number": "3520553",
            "title": "Pedido de validação dos documentos- 604642257",
            "priority": "P2",
            "created_at": "06/06/2026 13:49:52",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 13:49:53"
          },
          {
            "ticket_id": 20569,
            "ticket_number": "3520557",
            "title": "Solole. A reserva 69MFPC7D está próxima de registr",
            "priority": "P2",
            "created_at": "06/06/2026 15:04:39",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 15:07:11"
          },
          {
            "ticket_id": 20577,
            "ticket_number": "3520565",
            "title": "CTM-12761 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/06/2026 17:06:18",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 17:10:34"
          },
          {
            "ticket_id": 20578,
            "ticket_number": "3520566",
            "title": "bilhetes 437731",
            "priority": "P2",
            "created_at": "06/06/2026 17:36:47",
            "close_date": "2026-06-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/06/2026 17:38:30"
          },
          {
            "ticket_id": 20641,
            "ticket_number": "3520629",
            "title": "CTM-12756 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "08/06/2026 09:11:49",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 13:00:57"
          },
          {
            "ticket_id": 20647,
            "ticket_number": "3520635",
            "title": "CTM-12756 - Um cliente enviou uma nova solicitação",
            "priority": "P2",
            "created_at": "08/06/2026 09:12:01",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 13:00:57"
          },
          {
            "ticket_id": 20649,
            "ticket_number": "3520637",
            "title": "Bonos de Reserva. Agencia UMA FAMILIA EM VIAGEM . ",
            "priority": "P2",
            "created_at": "08/06/2026 09:37:43",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 13:15:35"
          },
          {
            "ticket_id": 20650,
            "ticket_number": "3520638",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "08/06/2026 09:37:45",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:08:49"
          },
          {
            "ticket_id": 20652,
            "ticket_number": "3520640",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "08/06/2026 09:37:48",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 10:52:00"
          }
        ]
      },
      "Cátia Leal": {
        "total_tickets": 2386,
        "sla_met": 1550,
        "sla_missed": 836,
        "sla_compliance_rate": 64.96,
        "tickets": [
          {
            "ticket_id": 128,
            "ticket_number": "35127",
            "title": "Pedido de cancelamento GBN",
            "priority": "P2",
            "created_at": "01/10/2025 20:56:21",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 20:56:22"
          },
          {
            "ticket_id": 129,
            "ticket_number": "35128",
            "title": "Egotravel devolução -   331041",
            "priority": "P2",
            "created_at": "01/10/2025 21:04:34",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 13.17,
            "sla_met": false,
            "sla_breach_hours": 9.17,
            "sla_name": "SLA P2",
            "first_response_at": "02/10/2025 10:15:30"
          },
          {
            "ticket_id": 244,
            "ticket_number": "35243",
            "title": "loc 6119184 - NB",
            "priority": "P2",
            "created_at": "06/10/2025 12:19:09",
            "close_date": "2025-10-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 12:32:36"
          },
          {
            "ticket_id": 318,
            "ticket_number": "35317",
            "title": "Seguro viagem cancelada GBN-67758",
            "priority": "P3",
            "created_at": "07/10/2025 17:20:48",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 17:20:49"
          },
          {
            "ticket_id": 338,
            "ticket_number": "35337",
            "title": "URGENTE - Pedido de informação sobre alteração na ",
            "priority": "P3",
            "created_at": "07/10/2025 22:45:22",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/10/2025 22:45:22"
          },
          {
            "ticket_id": 416,
            "ticket_number": "35415",
            "title": "Informações importantes : 412548/2025 - SOLFERIAS.",
            "priority": "P2",
            "created_at": "08/10/2025 17:15:22",
            "close_date": "2025-10-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 17:15:22"
          },
          {
            "ticket_id": 438,
            "ticket_number": "35437",
            "title": "Nova Viagem #251000072 - Bucket List",
            "priority": "P2",
            "created_at": "09/10/2025 09:43:49",
            "close_date": "2025-10-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/10/2025 23:01:44"
          },
          {
            "ticket_id": 589,
            "ticket_number": "35588",
            "title": "Reserva cancelada com localizador: 3934466",
            "priority": "P3",
            "created_at": "13/10/2025 12:38:00",
            "close_date": "2025-10-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/10/2025 12:38:00"
          },
          {
            "ticket_id": 629,
            "ticket_number": "35628",
            "title": "Atividade cancelada: Ingresso do Balneário Széchen",
            "priority": "P2",
            "created_at": "13/10/2025 20:28:06",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 38.53,
            "sla_met": false,
            "sla_breach_hours": 34.53,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 11:01:04"
          },
          {
            "ticket_id": 630,
            "ticket_number": "35629",
            "title": "reserva  A34603688 civitatis",
            "priority": "P2",
            "created_at": "13/10/2025 20:29:44",
            "close_date": "2025-10-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 20:29:44"
          },
          {
            "ticket_id": 661,
            "ticket_number": "35660",
            "title": "Reembolso Reserva",
            "priority": "P2",
            "created_at": "14/10/2025 11:34:04",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 11:34:04"
          },
          {
            "ticket_id": 732,
            "ticket_number": "35731",
            "title": "Cancellation of the booking with   8B17T3PV",
            "priority": "P3",
            "created_at": "15/10/2025 10:13:40",
            "close_date": "2025-10-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/10/2025 11:10:40"
          },
          {
            "ticket_id": 736,
            "ticket_number": "35735",
            "title": "LOC: 1210276553",
            "priority": "P2",
            "created_at": "15/10/2025 11:15:37",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/10/2025 11:15:37"
          },
          {
            "ticket_id": 932,
            "ticket_number": "35931",
            "title": "Comissão 1205967579",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:39",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:39"
          },
          {
            "ticket_id": 981,
            "ticket_number": "35980",
            "title": "Re: Comissões",
            "priority": "P2",
            "created_at": "20/10/2025 20:48:32",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 20:48:32"
          },
          {
            "ticket_id": 982,
            "ticket_number": "35981",
            "title": "Re: Confirmação de Comissoes",
            "priority": "P2",
            "created_at": "20/10/2025 20:48:33",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 20:48:33"
          },
          {
            "ticket_id": 1003,
            "ticket_number": "351002",
            "title": "NIB Devolução caução Hotel",
            "priority": "P2",
            "created_at": "21/10/2025 10:23:36",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/10/2025 10:23:36"
          },
          {
            "ticket_id": 1088,
            "ticket_number": "351086",
            "title": "RE: Comissões",
            "priority": "P2",
            "created_at": "22/10/2025 13:21:07",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 13:21:07"
          },
          {
            "ticket_id": 1107,
            "ticket_number": "351105",
            "title": "ROSA PARDAL RD OUTUBRO 2DA VIA",
            "priority": "P2",
            "created_at": "22/10/2025 17:43:21",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 17:48:24"
          },
          {
            "ticket_id": 1131,
            "ticket_number": "351129",
            "title": "Fwd: Re: Pedido de devolução da diferença de trans",
            "priority": "P2",
            "created_at": "23/10/2025 09:28:48",
            "close_date": "2025-10-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/10/2025 09:28:48"
          },
          {
            "ticket_id": 1152,
            "ticket_number": "351150",
            "title": "Re: Voo Nouvelair - Porto Djerba - 30MAY | Reserva",
            "priority": "P3",
            "created_at": "23/10/2025 14:09:36",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/10/2025 15:45:12"
          },
          {
            "ticket_id": 1189,
            "ticket_number": "351186",
            "title": "GBN-83745 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "24/10/2025 09:03:29",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 5.15,
            "sla_met": false,
            "sla_breach_hours": 1.15,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 14:12:59"
          },
          {
            "ticket_id": 1199,
            "ticket_number": "351196",
            "title": "Comissões Mês de Outubro",
            "priority": "P2",
            "created_at": "24/10/2025 09:29:20",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 09:29:20"
          },
          {
            "ticket_id": 1203,
            "ticket_number": "351200",
            "title": "Re: Comissões",
            "priority": "P2",
            "created_at": "24/10/2025 10:41:05",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:41:05"
          },
          {
            "ticket_id": 1209,
            "ticket_number": "351206",
            "title": "RE: RECIBOS VERDES",
            "priority": "P2",
            "created_at": "24/10/2025 10:57:45",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:57:46"
          },
          {
            "ticket_id": 1212,
            "ticket_number": "351209",
            "title": "RECIBOS VERDES",
            "priority": "P2",
            "created_at": "24/10/2025 10:59:59",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 10:59:59"
          },
          {
            "ticket_id": 1240,
            "ticket_number": "351237",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "24/10/2025 15:37:41",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 15:37:41"
          },
          {
            "ticket_id": 1242,
            "ticket_number": "351239",
            "title": "Re: Comissão - valores por confirmar",
            "priority": "P2",
            "created_at": "24/10/2025 15:37:45",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 15:37:45"
          },
          {
            "ticket_id": 1264,
            "ticket_number": "351261",
            "title": "GBN-83745 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "25/10/2025 08:47:44",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 51.97,
            "sla_met": false,
            "sla_breach_hours": 47.97,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:46:23"
          },
          {
            "ticket_id": 1270,
            "ticket_number": "351267",
            "title": "A/C Cátia Leal - envio de recibo comissão 12059675",
            "priority": "P2",
            "created_at": "25/10/2025 10:48:07",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/10/2025 10:48:07"
          },
          {
            "ticket_id": 1280,
            "ticket_number": "351277",
            "title": "| Levantamento comissões outubro - Mariana Alves |",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:02",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:02"
          },
          {
            "ticket_id": 1281,
            "ticket_number": "351278",
            "title": "Recibo Emitido - Levantamento Comissões",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:04",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:05"
          },
          {
            "ticket_id": 1285,
            "ticket_number": "351282",
            "title": "Dados para faturação: Viagem #251000103 - O mundo ",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:15",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:15"
          },
          {
            "ticket_id": 1286,
            "ticket_number": "351283",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "26/10/2025 10:15:17",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 10:15:18"
          },
          {
            "ticket_id": 1290,
            "ticket_number": "351287",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "26/10/2025 12:21:31",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 12:21:31"
          },
          {
            "ticket_id": 1297,
            "ticket_number": "351294",
            "title": "Reembolso",
            "priority": "P2",
            "created_at": "27/10/2025 10:06:44",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:45:43"
          },
          {
            "ticket_id": 1302,
            "ticket_number": "351299",
            "title": "CONTROLO RESERVAS... - 240.00€ - 30/07/2025 240.00",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:03",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:47:23"
          },
          {
            "ticket_id": 1304,
            "ticket_number": "351301",
            "title": "CONTROLO RESERVAS... - 1645 - 15/09/2025 1000 - 26",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:05",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:47:44"
          },
          {
            "ticket_id": 1308,
            "ticket_number": "351305",
            "title": "Reserva estacionamento-Porto-29 outubro",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:14",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:07:14"
          },
          {
            "ticket_id": 1311,
            "ticket_number": "351308",
            "title": "GBN-62019 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:52",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 28.22,
            "sla_met": false,
            "sla_breach_hours": 24.22,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 14:21:16"
          },
          {
            "ticket_id": 1312,
            "ticket_number": "351309",
            "title": "GBN-83782 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "27/10/2025 10:07:54",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 5.42,
            "sla_met": false,
            "sla_breach_hours": 1.42,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 15:33:46"
          },
          {
            "ticket_id": 1314,
            "ticket_number": "351311",
            "title": "GBN-67921 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "27/10/2025 10:46:49",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/10/2025 12:03:16"
          },
          {
            "ticket_id": 1317,
            "ticket_number": "351314",
            "title": "Fwd: Re: Fwd: Reserva Barcadouro Porto/Régua/Porto",
            "priority": "P2",
            "created_at": "27/10/2025 10:54:59",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:54:59"
          },
          {
            "ticket_id": 1318,
            "ticket_number": "351315",
            "title": "Pedido de Sinalização De Reserva 332333",
            "priority": "P1",
            "created_at": "27/10/2025 11:20:08",
            "close_date": "2025-10-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/10/2025 11:33:35"
          },
          {
            "ticket_id": 1326,
            "ticket_number": "351323",
            "title": "Confirmação e Fatura de Reserva",
            "priority": "P2",
            "created_at": "27/10/2025 12:33:27",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 14:55:06"
          },
          {
            "ticket_id": 1329,
            "ticket_number": "351326",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P2",
            "created_at": "27/10/2025 12:33:32",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 12:33:33"
          },
          {
            "ticket_id": 1341,
            "ticket_number": "351338",
            "title": "RE: Pagamento 1756159",
            "priority": "P2",
            "created_at": "27/10/2025 16:15:28",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 22.12,
            "sla_met": false,
            "sla_breach_hours": 18.12,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 14:23:02"
          },
          {
            "ticket_id": 1343,
            "ticket_number": "351340",
            "title": "Confirmação de Reserva * File 414136 ***alteração ",
            "priority": "P2",
            "created_at": "27/10/2025 17:03:56",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 17:06:38"
          },
          {
            "ticket_id": 1344,
            "ticket_number": "351341",
            "title": "A/C CÁTIA LEAL - RECIBOS: VALORES COMISSÕES ATÉ 27",
            "priority": "P2",
            "created_at": "27/10/2025 17:17:53",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 17:17:53"
          },
          {
            "ticket_id": 1345,
            "ticket_number": "351342",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "27/10/2025 17:23:44",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 23.15,
            "sla_met": false,
            "sla_breach_hours": 19.15,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 16:33:10"
          },
          {
            "ticket_id": 1359,
            "ticket_number": "351356",
            "title": "Re:[## 23700 ##] GBN-87157 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:03",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/10/2025 12:21:29"
          },
          {
            "ticket_id": 1366,
            "ticket_number": "351363",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "27/10/2025 19:14:33",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:35:05"
          },
          {
            "ticket_id": 1394,
            "ticket_number": "351391",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:42",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 30.67,
            "sla_met": false,
            "sla_breach_hours": 26.67,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 16:44:44"
          },
          {
            "ticket_id": 1413,
            "ticket_number": "351410",
            "title": "Re: Comissões A/C Cátia Leal",
            "priority": "P2",
            "created_at": "28/10/2025 12:25:36",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 12:25:36"
          },
          {
            "ticket_id": 1424,
            "ticket_number": "351421",
            "title": "Fwd: File 24800025 | Solução Perfeita",
            "priority": "P2",
            "created_at": "28/10/2025 14:00:27",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 14:00:27"
          },
          {
            "ticket_id": 1436,
            "ticket_number": "351433",
            "title": "Fatura Pro Forma Localizador 408831",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:13",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:04:14"
          },
          {
            "ticket_id": 1438,
            "ticket_number": "351435",
            "title": "Fatura Pro Forma Localizador 409435",
            "priority": "P2",
            "created_at": "28/10/2025 17:04:18",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:04:18"
          },
          {
            "ticket_id": 1442,
            "ticket_number": "351439",
            "title": "Confirmação de Comissões",
            "priority": "P2",
            "created_at": "28/10/2025 17:26:33",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:26:34"
          },
          {
            "ticket_id": 1443,
            "ticket_number": "351440",
            "title": "Emissão de Recibos Verdes e Pagamento de Comissões",
            "priority": "P2",
            "created_at": "28/10/2025 17:40:59",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 17:40:59"
          },
          {
            "ticket_id": 1445,
            "ticket_number": "351442",
            "title": "Aviso de pagamento",
            "priority": "P1",
            "created_at": "28/10/2025 18:29:10",
            "close_date": "2025-10-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 63.7,
            "sla_met": false,
            "sla_breach_hours": 63.45,
            "sla_name": "SLA P1",
            "first_response_at": "31/10/2025 10:11:40"
          },
          {
            "ticket_id": 1446,
            "ticket_number": "351443",
            "title": "Emissão de Recibos Verdes e Pagamento de Comissões",
            "priority": "P2",
            "created_at": "28/10/2025 18:29:16",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 18:29:17"
          },
          {
            "ticket_id": 1447,
            "ticket_number": "351444",
            "title": "Re: Validação Valores para Recibo Verde",
            "priority": "P2",
            "created_at": "28/10/2025 21:26:55",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 21:26:55"
          },
          {
            "ticket_id": 1473,
            "ticket_number": "351470",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P1",
            "created_at": "29/10/2025 10:25:16",
            "close_date": "2025-10-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.47,
            "sla_met": false,
            "sla_breach_hours": 1.22,
            "sla_name": "SLA P1",
            "first_response_at": "29/10/2025 11:53:47"
          },
          {
            "ticket_id": 1487,
            "ticket_number": "351484",
            "title": "***URGENTE PAGO***LOC.604483835 (LEPLAN)----Uma Fa",
            "priority": "P1",
            "created_at": "29/10/2025 13:02:00",
            "close_date": "2025-10-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 30.1,
            "sla_met": false,
            "sla_breach_hours": 29.85,
            "sla_name": "SLA P1",
            "first_response_at": "30/10/2025 19:08:22"
          },
          {
            "ticket_id": 1493,
            "ticket_number": "351490",
            "title": "K000018205 - Extrato da conta",
            "priority": "P2",
            "created_at": "29/10/2025 13:02:48",
            "close_date": "2025-10-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 17:01:36"
          },
          {
            "ticket_id": 1495,
            "ticket_number": "351492",
            "title": "Re:[## 17460 ##] GBN-75892 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "29/10/2025 15:20:25",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 45.57,
            "sla_met": false,
            "sla_breach_hours": 41.57,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 12:54:41"
          },
          {
            "ticket_id": 1499,
            "ticket_number": "351496",
            "title": "ANDRE CRISTOVAO RD OUTUBRO",
            "priority": "P1",
            "created_at": "29/10/2025 15:38:53",
            "close_date": "2025-11-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "29/10/2025 15:43:17"
          },
          {
            "ticket_id": 1507,
            "ticket_number": "351504",
            "title": "Localizador SMY 1210584648 - A/C Cátia Leal",
            "priority": "P2",
            "created_at": "29/10/2025 17:06:45",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 17:06:45"
          },
          {
            "ticket_id": 1509,
            "ticket_number": "351506",
            "title": "FW: Nova Viagem #251000299 - Benice Travel",
            "priority": "P2",
            "created_at": "29/10/2025 17:36:13",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 17:36:13"
          },
          {
            "ticket_id": 1518,
            "ticket_number": "351515",
            "title": "Recibo Verde",
            "priority": "P2",
            "created_at": "29/10/2025 19:36:34",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 19:36:34"
          },
          {
            "ticket_id": 1522,
            "ticket_number": "351519",
            "title": "Recibo Verde Localizador 6116622| Localizador 1200",
            "priority": "P2",
            "created_at": "29/10/2025 19:49:55",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/10/2025 19:49:55"
          },
          {
            "ticket_id": 1533,
            "ticket_number": "351530",
            "title": "GBN-84892 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "30/10/2025 10:09:41",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 26.83,
            "sla_met": false,
            "sla_breach_hours": 22.83,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:00:28"
          },
          {
            "ticket_id": 1534,
            "ticket_number": "351531",
            "title": "Re: Recibo reserva 78971 GBN",
            "priority": "P2",
            "created_at": "30/10/2025 10:38:29",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 10:38:29"
          },
          {
            "ticket_id": 1540,
            "ticket_number": "351537",
            "title": "Referencia para pagamento | File:414491/2025",
            "priority": "P1",
            "created_at": "30/10/2025 11:28:57",
            "close_date": "2025-10-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.58,
            "sla_met": false,
            "sla_breach_hours": 7.33,
            "sla_name": "SLA P1",
            "first_response_at": "30/10/2025 19:04:19"
          },
          {
            "ticket_id": 1541,
            "ticket_number": "351538",
            "title": "Reminder * Reserva File 414491 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "30/10/2025 11:28:58",
            "close_date": "2025-10-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.55,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA P1",
            "first_response_at": "30/10/2025 19:02:52"
          },
          {
            "ticket_id": 1546,
            "ticket_number": "351543",
            "title": "Alteração de valor net - smy -1214485471",
            "priority": "P2",
            "created_at": "30/10/2025 12:03:28",
            "close_date": "2025-10-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/10/2025 13:30:15"
          },
          {
            "ticket_id": 1560,
            "ticket_number": "351557",
            "title": "Re:[## 23965 ##] GBN-77918 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "30/10/2025 13:32:24",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 2.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 15:57:07"
          },
          {
            "ticket_id": 1562,
            "ticket_number": "351559",
            "title": "Fatura e Confirmação de Reserva - Gocar - Armanda",
            "priority": "P2",
            "created_at": "30/10/2025 13:46:48",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 13:46:49"
          },
          {
            "ticket_id": 1568,
            "ticket_number": "351565",
            "title": "COMISSÕES OPTI 2422200002",
            "priority": "P2",
            "created_at": "30/10/2025 16:13:13",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:13:14"
          },
          {
            "ticket_id": 1569,
            "ticket_number": "351566",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "30/10/2025 16:13:15",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:13:15"
          },
          {
            "ticket_id": 1572,
            "ticket_number": "351569",
            "title": "Fwd: Nova Viagem #251000317 - Go Travel",
            "priority": "P2",
            "created_at": "30/10/2025 16:15:32",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 16:15:32"
          },
          {
            "ticket_id": 1582,
            "ticket_number": "351579",
            "title": "pedido de fatura de reservas",
            "priority": "P2",
            "created_at": "30/10/2025 17:41:08",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 17:41:08"
          },
          {
            "ticket_id": 1584,
            "ticket_number": "351581",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "30/10/2025 18:08:31",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 18:09:17"
          },
          {
            "ticket_id": 1585,
            "ticket_number": "351582",
            "title": "RECIBO VERDE DANIELA CRUZ",
            "priority": "P2",
            "created_at": "30/10/2025 18:27:16",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/10/2025 18:27:16"
          },
          {
            "ticket_id": 1598,
            "ticket_number": "351595",
            "title": "GBN-84892 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "31/10/2025 10:11:21",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 79.5,
            "sla_met": false,
            "sla_breach_hours": 75.5,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 17:41:57"
          },
          {
            "ticket_id": 1599,
            "ticket_number": "351596",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60446",
            "priority": "P2",
            "created_at": "31/10/2025 10:11:23",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 79.5,
            "sla_met": false,
            "sla_breach_hours": 75.5,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 17:42:19"
          },
          {
            "ticket_id": 1604,
            "ticket_number": "351601",
            "title": "[6156118] Pagamento 414549",
            "priority": "P2",
            "created_at": "31/10/2025 10:36:45",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:04:13"
          },
          {
            "ticket_id": 1608,
            "ticket_number": "351605",
            "title": "A/C Cátia - Localizadores a confirmar",
            "priority": "P2",
            "created_at": "31/10/2025 11:59:28",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 11:59:28"
          },
          {
            "ticket_id": 1609,
            "ticket_number": "351606",
            "title": "A/C Cátia - Validação de comissões Setembro",
            "priority": "P2",
            "created_at": "31/10/2025 11:59:30",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 11:59:30"
          },
          {
            "ticket_id": 1614,
            "ticket_number": "351611",
            "title": "fatura pendente",
            "priority": "P1",
            "created_at": "31/10/2025 12:27:32",
            "close_date": "2025-10-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.68,
            "sla_met": false,
            "sla_breach_hours": 0.43,
            "sla_name": "SLA P1",
            "first_response_at": "31/10/2025 13:09:04"
          },
          {
            "ticket_id": 1624,
            "ticket_number": "351621",
            "title": "Comisão",
            "priority": "P2",
            "created_at": "31/10/2025 13:46:24",
            "close_date": "2025-10-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 13:46:24"
          },
          {
            "ticket_id": 1634,
            "ticket_number": "351631",
            "title": "Fatura/recibo GBN-74839",
            "priority": "P2",
            "created_at": "31/10/2025 16:55:52",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 96.02,
            "sla_met": false,
            "sla_breach_hours": 92.02,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 16:57:51"
          },
          {
            "ticket_id": 1641,
            "ticket_number": "351638",
            "title": "autorização para emissão de bilhetes",
            "priority": "P2",
            "created_at": "31/10/2025 18:16:21",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 18:16:21"
          },
          {
            "ticket_id": 1653,
            "ticket_number": "351650",
            "title": "comissoes optis: 2422200007/ 2422200008/ 242220000",
            "priority": "P2",
            "created_at": "31/10/2025 21:18:40",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 21:18:40"
          },
          {
            "ticket_id": 1654,
            "ticket_number": "351651",
            "title": "Comissões OPTI - 2422200006",
            "priority": "P2",
            "created_at": "31/10/2025 21:32:39",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 21:32:39"
          },
          {
            "ticket_id": 1655,
            "ticket_number": "351652",
            "title": "recibo opti 2422200002",
            "priority": "P2",
            "created_at": "31/10/2025 21:44:26",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 21:44:27"
          },
          {
            "ticket_id": 1656,
            "ticket_number": "351653",
            "title": "recibo opti 2422200001",
            "priority": "P2",
            "created_at": "31/10/2025 21:44:29",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 21:44:29"
          },
          {
            "ticket_id": 1657,
            "ticket_number": "351654",
            "title": "Referencia para pagamento | File:404563/2025",
            "priority": "P2",
            "created_at": "31/10/2025 22:09:11",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 69.13,
            "sla_met": false,
            "sla_breach_hours": 65.13,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:17:28"
          },
          {
            "ticket_id": 1658,
            "ticket_number": "351655",
            "title": "Referencia para pagamento | File:402834/2025",
            "priority": "P2",
            "created_at": "31/10/2025 22:09:12",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 69.15,
            "sla_met": false,
            "sla_breach_hours": 65.15,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:18:35"
          },
          {
            "ticket_id": 1659,
            "ticket_number": "351656",
            "title": "GBN-88260 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "01/11/2025 10:02:46",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 55.73,
            "sla_met": false,
            "sla_breach_hours": 51.73,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 17:46:54"
          },
          {
            "ticket_id": 1663,
            "ticket_number": "351660",
            "title": "Comissões 2025",
            "priority": "P2",
            "created_at": "01/11/2025 15:06:32",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/11/2025 15:06:32"
          },
          {
            "ticket_id": 1664,
            "ticket_number": "351661",
            "title": "Comisssões",
            "priority": "P2",
            "created_at": "01/11/2025 15:06:34",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/11/2025 15:06:34"
          },
          {
            "ticket_id": 1666,
            "ticket_number": "351663",
            "title": "EMAIL PARA CÁTIA - Re: [## 21412 ##] GBN-78112 - S",
            "priority": "P2",
            "created_at": "01/11/2025 18:29:42",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 71.25,
            "sla_met": false,
            "sla_breach_hours": 67.25,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 17:45:39"
          },
          {
            "ticket_id": 1669,
            "ticket_number": "351666",
            "title": "GBN-88260 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/11/2025 10:24:02",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 31.38,
            "sla_met": false,
            "sla_breach_hours": 27.38,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 17:47:59"
          },
          {
            "ticket_id": 1670,
            "ticket_number": "351667",
            "title": "GBN-77919 - Your booking is still pending payment",
            "priority": "P2",
            "created_at": "02/11/2025 10:24:04",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 32.3,
            "sla_met": false,
            "sla_breach_hours": 28.3,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:42:08"
          },
          {
            "ticket_id": 1671,
            "ticket_number": "351668",
            "title": "Referencia para pagamento | File:414811/2025",
            "priority": "P2",
            "created_at": "02/11/2025 10:24:06",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 32.32,
            "sla_met": false,
            "sla_breach_hours": 28.32,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:43:10"
          },
          {
            "ticket_id": 1672,
            "ticket_number": "351669",
            "title": "Referencia para pagamento | File:414810/2025",
            "priority": "P2",
            "created_at": "02/11/2025 10:24:09",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 27.7,
            "sla_met": false,
            "sla_breach_hours": 23.7,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 14:07:07"
          },
          {
            "ticket_id": 1673,
            "ticket_number": "351670",
            "title": "Referencia para pagamento | File:407385/2025",
            "priority": "P2",
            "created_at": "02/11/2025 10:24:10",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 32.95,
            "sla_met": false,
            "sla_breach_hours": 28.95,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:21:10"
          },
          {
            "ticket_id": 1688,
            "ticket_number": "351685",
            "title": "GBN-77919 - Your booking is still pending payment",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:31",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 8.2,
            "sla_met": false,
            "sla_breach_hours": 4.2,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:47:08"
          },
          {
            "ticket_id": 1691,
            "ticket_number": "351688",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:37",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 10:34:53"
          },
          {
            "ticket_id": 1695,
            "ticket_number": "351692",
            "title": "Referencia para pagamento | File:396561/2025",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:50",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 8.25,
            "sla_met": false,
            "sla_breach_hours": 4.25,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:49:59"
          },
          {
            "ticket_id": 1697,
            "ticket_number": "351694",
            "title": "Comprovativo Transação  - SMY 1210584648",
            "priority": "P2",
            "created_at": "03/11/2025 10:34:55",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 56.88,
            "sla_met": false,
            "sla_breach_hours": 52.88,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 19:28:34"
          },
          {
            "ticket_id": 1714,
            "ticket_number": "351711",
            "title": "Reserva Aérea DXP72C",
            "priority": "P1",
            "created_at": "03/11/2025 11:27:00",
            "close_date": "2025-11-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/11/2025 11:26:46"
          },
          {
            "ticket_id": 1717,
            "ticket_number": "351714",
            "title": "Pagamento Final de Reserva - 333002",
            "priority": "P1",
            "created_at": "03/11/2025 11:46:51",
            "close_date": "2025-11-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 28.07,
            "sla_met": false,
            "sla_breach_hours": 27.82,
            "sla_name": "SLA P1",
            "first_response_at": "04/11/2025 15:51:33"
          },
          {
            "ticket_id": 1723,
            "ticket_number": "351720",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "03/11/2025 12:27:37",
            "close_date": "2025-11-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.1,
            "sla_met": false,
            "sla_breach_hours": 0.85,
            "sla_name": "SLA P1",
            "first_response_at": "03/11/2025 13:34:28"
          },
          {
            "ticket_id": 1724,
            "ticket_number": "351721",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "03/11/2025 12:27:38",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 13:35:22"
          },
          {
            "ticket_id": 1740,
            "ticket_number": "351737",
            "title": "Re: Emissão de fatura - GBN-84160 - Sandra Leite",
            "priority": "P2",
            "created_at": "03/11/2025 14:09:10",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 14:09:10"
          },
          {
            "ticket_id": 1741,
            "ticket_number": "351738",
            "title": "Pagamento comissão",
            "priority": "P2",
            "created_at": "03/11/2025 15:11:35",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 15:11:35"
          },
          {
            "ticket_id": 1742,
            "ticket_number": "351739",
            "title": "Faturas Pendentes: FA 2147872452",
            "priority": "P1",
            "created_at": "03/11/2025 15:11:36",
            "close_date": "2025-11-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.73,
            "sla_met": false,
            "sla_breach_hours": 3.48,
            "sla_name": "SLA P1",
            "first_response_at": "03/11/2025 18:55:38"
          },
          {
            "ticket_id": 1743,
            "ticket_number": "351740",
            "title": "Faturas Pendentes: FA 2147872454",
            "priority": "P1",
            "created_at": "03/11/2025 15:11:38",
            "close_date": "2025-11-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.73,
            "sla_met": false,
            "sla_breach_hours": 3.48,
            "sla_name": "SLA P1",
            "first_response_at": "03/11/2025 18:55:54"
          },
          {
            "ticket_id": 1744,
            "ticket_number": "351741",
            "title": "GBN-76721 - Faturas a/c da Cátia",
            "priority": "P2",
            "created_at": "03/11/2025 15:11:39",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 15:11:39"
          },
          {
            "ticket_id": 1746,
            "ticket_number": "351743",
            "title": "faturação",
            "priority": "P2",
            "created_at": "03/11/2025 15:28:14",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 15:28:14"
          },
          {
            "ticket_id": 1753,
            "ticket_number": "351750",
            "title": "Re: Autorização para pagamento a 1 mês",
            "priority": "P2",
            "created_at": "03/11/2025 16:58:59",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 16:59:00"
          },
          {
            "ticket_id": 1761,
            "ticket_number": "351758",
            "title": "Pedido de cessação de contrato",
            "priority": "P2",
            "created_at": "03/11/2025 18:33:16",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 18:33:16"
          },
          {
            "ticket_id": 1766,
            "ticket_number": "351763",
            "title": "Relação de comissões para emissão de recibo",
            "priority": "P2",
            "created_at": "03/11/2025 19:17:37",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:17:37"
          },
          {
            "ticket_id": 1770,
            "ticket_number": "351767",
            "title": "FATURAS - ATUALIZAÇÃO",
            "priority": "P2",
            "created_at": "03/11/2025 19:41:10",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:41:10"
          },
          {
            "ticket_id": 1773,
            "ticket_number": "351770",
            "title": "Dúvidas contabilidade - A/C Cátia Leal",
            "priority": "P2",
            "created_at": "03/11/2025 19:52:39",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:52:40"
          },
          {
            "ticket_id": 1774,
            "ticket_number": "351771",
            "title": "OPTI 2414000017",
            "priority": "P2",
            "created_at": "03/11/2025 19:52:41",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:52:42"
          },
          {
            "ticket_id": 1775,
            "ticket_number": "351772",
            "title": "Re: Emissão de voucher",
            "priority": "P3",
            "created_at": "03/11/2025 19:54:53",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/11/2025 19:54:53"
          },
          {
            "ticket_id": 1777,
            "ticket_number": "351774",
            "title": "Dados para faturação viagem Egito",
            "priority": "P2",
            "created_at": "03/11/2025 20:08:02",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 20:08:02"
          },
          {
            "ticket_id": 1786,
            "ticket_number": "351783",
            "title": "A/C Cátia - Faturas",
            "priority": "P2",
            "created_at": "03/11/2025 23:29:28",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 23:29:28"
          },
          {
            "ticket_id": 1788,
            "ticket_number": "351785",
            "title": "Processo de envio de recibos para pagamento de com",
            "priority": "P2",
            "created_at": "03/11/2025 23:42:56",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 23:42:57"
          },
          {
            "ticket_id": 1790,
            "ticket_number": "351787",
            "title": "Re: Dados Faturação",
            "priority": "P2",
            "created_at": "03/11/2025 23:49:23",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 23:49:23"
          },
          {
            "ticket_id": 1791,
            "ticket_number": "351788",
            "title": "GBN-87500 - Fatura",
            "priority": "P2",
            "created_at": "03/11/2025 23:56:20",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 23:56:20"
          },
          {
            "ticket_id": 1792,
            "ticket_number": "351789",
            "title": "Re:[## 23410 ##] GBN-84940 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "04/11/2025 00:39:53",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 00:40:40"
          },
          {
            "ticket_id": 1794,
            "ticket_number": "351791",
            "title": "FW: Nova Viagem #250800140 - Benice Travel",
            "priority": "P2",
            "created_at": "04/11/2025 10:03:32",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 10:03:32"
          },
          {
            "ticket_id": 1795,
            "ticket_number": "351792",
            "title": "Re: Nova Viagem #250800079 - Benice Travel",
            "priority": "P2",
            "created_at": "04/11/2025 10:03:34",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 10:03:35"
          },
          {
            "ticket_id": 1796,
            "ticket_number": "351793",
            "title": "FW: Nova Viagem #251000154 - Benice Travel",
            "priority": "P2",
            "created_at": "04/11/2025 10:03:36",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 10:03:36"
          },
          {
            "ticket_id": 1797,
            "ticket_number": "351794",
            "title": "FW: Nova Viagem #251000208 - Benice Travel",
            "priority": "P2",
            "created_at": "04/11/2025 10:03:38",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 10:03:39"
          },
          {
            "ticket_id": 1801,
            "ticket_number": "351798",
            "title": "GBN-87761 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "04/11/2025 10:10:11",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 5.73,
            "sla_met": false,
            "sla_breach_hours": 1.73,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 15:55:11"
          },
          {
            "ticket_id": 1805,
            "ticket_number": "351802",
            "title": "Liquidazione crediti rif. SR CAS-8983454-J7G9Q2",
            "priority": "P2",
            "created_at": "04/11/2025 11:03:07",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/11/2025 11:22:45"
          },
          {
            "ticket_id": 1808,
            "ticket_number": "351805",
            "title": "Re:[## 24220 ##] GBN-85525 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "04/11/2025 11:35:20",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 12:09:19"
          },
          {
            "ticket_id": 1819,
            "ticket_number": "351816",
            "title": "Cancelamento de reserva * File 414810",
            "priority": "P3",
            "created_at": "04/11/2025 13:46:48",
            "close_date": "2025-11-04",
            "sla_target_hours": 24,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 15:27:19"
          },
          {
            "ticket_id": 1852,
            "ticket_number": "351849",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60446",
            "priority": "P2",
            "created_at": "05/11/2025 10:04:57",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 9.1,
            "sla_met": false,
            "sla_breach_hours": 5.1,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 19:11:29"
          },
          {
            "ticket_id": 1853,
            "ticket_number": "351850",
            "title": "GBN-87408 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "05/11/2025 10:04:59",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 9.12,
            "sla_met": false,
            "sla_breach_hours": 5.12,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 19:12:25"
          },
          {
            "ticket_id": 1858,
            "ticket_number": "351855",
            "title": "Rcibo optis 6-7-8-9",
            "priority": "P2",
            "created_at": "05/11/2025 10:05:07",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 10:05:07"
          },
          {
            "ticket_id": 1859,
            "ticket_number": "351856",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3494614",
            "priority": "P3",
            "created_at": "05/11/2025 10:42:25",
            "close_date": "2025-11-05",
            "sla_target_hours": 24,
            "actual_time_hours": 8.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/11/2025 19:12:44"
          },
          {
            "ticket_id": 1865,
            "ticket_number": "351862",
            "title": "Recibo Verde - 13",
            "priority": "P2",
            "created_at": "05/11/2025 12:11:56",
            "close_date": "2025-11-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 12:11:56"
          },
          {
            "ticket_id": 1892,
            "ticket_number": "351889",
            "title": "Comprovativo de IBAN para devolução - Autoconsumo ",
            "priority": "P2",
            "created_at": "05/11/2025 20:47:21",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 20:47:21"
          },
          {
            "ticket_id": 1894,
            "ticket_number": "351891",
            "title": "Referencia para pagamento | File:415117/2025",
            "priority": "P2",
            "created_at": "05/11/2025 22:14:17",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 12.68,
            "sla_met": false,
            "sla_breach_hours": 8.68,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:56:01"
          },
          {
            "ticket_id": 1896,
            "ticket_number": "351893",
            "title": "Nova Viagem #251100035 - Rota dos Sonhos",
            "priority": "P2",
            "created_at": "05/11/2025 22:14:20",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 22:14:20"
          },
          {
            "ticket_id": 1901,
            "ticket_number": "351898",
            "title": "DADOS DE FATURAÇÃO DE RESERVAS MSC CRUZEIROS",
            "priority": "P2",
            "created_at": "05/11/2025 23:15:57",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 23:15:57"
          },
          {
            "ticket_id": 1903,
            "ticket_number": "351900",
            "title": "Re: Recibos Verdes",
            "priority": "P2",
            "created_at": "05/11/2025 23:16:01",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 279.37,
            "sla_met": false,
            "sla_breach_hours": 275.37,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 14:38:20"
          },
          {
            "ticket_id": 1904,
            "ticket_number": "351901",
            "title": "Recibo",
            "priority": "P2",
            "created_at": "05/11/2025 23:16:35",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/11/2025 23:16:35"
          },
          {
            "ticket_id": 1907,
            "ticket_number": "351904",
            "title": "GBN-75892 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "06/11/2025 10:09:24",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 101.7,
            "sla_met": false,
            "sla_breach_hours": 97.7,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 15:51:38"
          },
          {
            "ticket_id": 1908,
            "ticket_number": "351905",
            "title": "GBN-87408 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "06/11/2025 10:09:25",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 6.73,
            "sla_met": false,
            "sla_breach_hours": 2.73,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 16:53:34"
          },
          {
            "ticket_id": 1910,
            "ticket_number": "351907",
            "title": "Reminder * Reserva File 415117 * Deadline Hoje 16H",
            "priority": "P1",
            "created_at": "06/11/2025 10:20:08",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.32,
            "sla_met": false,
            "sla_breach_hours": 0.07,
            "sla_name": "SLA P1",
            "first_response_at": "06/11/2025 10:39:27"
          },
          {
            "ticket_id": 1912,
            "ticket_number": "351909",
            "title": "Mapa de Comissões – Viagens Realizadas",
            "priority": "P2",
            "created_at": "06/11/2025 10:20:11",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:20:11"
          },
          {
            "ticket_id": 1914,
            "ticket_number": "351911",
            "title": "IBAN Ana Margarida Costa - A/C Cátia Leal",
            "priority": "P2",
            "created_at": "06/11/2025 10:20:14",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 10:20:14"
          },
          {
            "ticket_id": 1940,
            "ticket_number": "351937",
            "title": "RE: Pedido de fatura",
            "priority": "P2",
            "created_at": "06/11/2025 13:37:36",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 16:55:04"
          },
          {
            "ticket_id": 1941,
            "ticket_number": "351938",
            "title": "Solole. Booking G0Y20UGS is close to entering expe",
            "priority": "P2",
            "created_at": "06/11/2025 14:04:11",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 16:55:57"
          },
          {
            "ticket_id": 1942,
            "ticket_number": "351939",
            "title": "Re: Pedido de Cotação – Tours Experience OC – Ilha",
            "priority": "P2",
            "created_at": "06/11/2025 14:04:46",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 16:56:58"
          },
          {
            "ticket_id": 1945,
            "ticket_number": "351942",
            "title": "Pedido de cessação de contrato",
            "priority": "P2",
            "created_at": "06/11/2025 15:42:03",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 15:42:03"
          },
          {
            "ticket_id": 1957,
            "ticket_number": "351953",
            "title": "Referencia para pagamento | File:415146/2025",
            "priority": "P2",
            "created_at": "06/11/2025 18:18:57",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:48:27"
          },
          {
            "ticket_id": 1958,
            "ticket_number": "351954",
            "title": "Referencia para pagamento | File:415145/2025",
            "priority": "P2",
            "created_at": "06/11/2025 18:18:58",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:48:53"
          },
          {
            "ticket_id": 1959,
            "ticket_number": "351955",
            "title": "******Reminder * Reserva File 415145 * Deadline Ho",
            "priority": "P2",
            "created_at": "06/11/2025 18:19:00",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:51:58"
          },
          {
            "ticket_id": 1961,
            "ticket_number": "351957",
            "title": "****Reminder * Reserva File 415146 * Deadline Hoje",
            "priority": "P2",
            "created_at": "06/11/2025 18:19:03",
            "close_date": "2025-11-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 18:52:52"
          },
          {
            "ticket_id": 1964,
            "ticket_number": "351960",
            "title": "Comprovativo IBAN",
            "priority": "P2",
            "created_at": "06/11/2025 19:29:43",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 19:29:43"
          },
          {
            "ticket_id": 1967,
            "ticket_number": "351963",
            "title": "Re:[## 24239 ##] GBN-88570 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "06/11/2025 20:47:43",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 23:49:22"
          },
          {
            "ticket_id": 1970,
            "ticket_number": "351966",
            "title": "GBN-75892 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "07/11/2025 10:02:57",
            "close_date": "2025-11-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.9,
            "sla_met": false,
            "sla_breach_hours": 7.65,
            "sla_name": "SLA P1",
            "first_response_at": "07/11/2025 17:57:36"
          },
          {
            "ticket_id": 1975,
            "ticket_number": "351971",
            "title": "Confirmação de reserva 333282 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "07/11/2025 10:48:26",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 7.17,
            "sla_met": false,
            "sla_breach_hours": 3.17,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 17:59:23"
          },
          {
            "ticket_id": 1977,
            "ticket_number": "351973",
            "title": "comissões",
            "priority": "P2",
            "created_at": "07/11/2025 10:49:01",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 10:49:01"
          },
          {
            "ticket_id": 1988,
            "ticket_number": "351984",
            "title": "Re: Pagamento 333282",
            "priority": "P1",
            "created_at": "07/11/2025 11:07:51",
            "close_date": "2025-11-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 80.42,
            "sla_met": false,
            "sla_breach_hours": 80.17,
            "sla_name": "SLA P1",
            "first_response_at": "10/11/2025 19:33:50"
          },
          {
            "ticket_id": 1994,
            "ticket_number": "351990",
            "title": "Solole. Booking G0Y20UGS is close to entering expe",
            "priority": "P1",
            "created_at": "07/11/2025 14:00:54",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 94.77,
            "sla_met": false,
            "sla_breach_hours": 94.52,
            "sla_name": "SLA P1",
            "first_response_at": "11/11/2025 12:47:24"
          },
          {
            "ticket_id": 1997,
            "ticket_number": "351993",
            "title": "Re: Comissões A/C Cátia Leal",
            "priority": "P2",
            "created_at": "07/11/2025 15:03:13",
            "close_date": "2025-11-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 15:03:14"
          },
          {
            "ticket_id": 2017,
            "ticket_number": "352013",
            "title": "Comissões Marisa Duarte",
            "priority": "P2",
            "created_at": "07/11/2025 18:54:56",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 18:54:56"
          },
          {
            "ticket_id": 2028,
            "ticket_number": "352024",
            "title": "Opti 241600021",
            "priority": "P2",
            "created_at": "07/11/2025 20:35:00",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/11/2025 20:35:00"
          },
          {
            "ticket_id": 2030,
            "ticket_number": "352026",
            "title": "Referencia para pagamento | File:409747/2025",
            "priority": "P2",
            "created_at": "07/11/2025 22:16:04",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 134.52,
            "sla_met": false,
            "sla_breach_hours": 130.52,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 12:48:00"
          },
          {
            "ticket_id": 2031,
            "ticket_number": "352027",
            "title": "Referencia para pagamento | File:415384/2025",
            "priority": "P2",
            "created_at": "07/11/2025 22:16:37",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 66.18,
            "sla_met": false,
            "sla_breach_hours": 62.18,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:28:28"
          },
          {
            "ticket_id": 2036,
            "ticket_number": "352032",
            "title": "Novo Reforço de Pagamento - Viagem # 408831/25 ",
            "priority": "P2",
            "created_at": "08/11/2025 11:51:55",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 11:51:55"
          },
          {
            "ticket_id": 2038,
            "ticket_number": "352034",
            "title": "Nova Viagem #251100059 - Bruno Monteiro",
            "priority": "P2",
            "created_at": "08/11/2025 11:51:58",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/11/2025 11:51:58"
          },
          {
            "ticket_id": 2043,
            "ticket_number": "352039",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P2",
            "created_at": "08/11/2025 12:51:09",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 76.18,
            "sla_met": false,
            "sla_breach_hours": 72.18,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 17:02:48"
          },
          {
            "ticket_id": 2044,
            "ticket_number": "352040",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60446",
            "priority": "P2",
            "created_at": "08/11/2025 12:51:11",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 103.68,
            "sla_met": false,
            "sla_breach_hours": 99.68,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:32:26"
          },
          {
            "ticket_id": 2045,
            "ticket_number": "352041",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60446",
            "priority": "P2",
            "created_at": "08/11/2025 12:51:12",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 51.73,
            "sla_met": false,
            "sla_breach_hours": 47.73,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:36:05"
          },
          {
            "ticket_id": 2051,
            "ticket_number": "352047",
            "title": "Referencia para pagamento | File:408831/2025",
            "priority": "P2",
            "created_at": "09/11/2025 11:48:53",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 28.22,
            "sla_met": false,
            "sla_breach_hours": 24.22,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:02:49"
          },
          {
            "ticket_id": 2054,
            "ticket_number": "352050",
            "title": "Referencia para pagamento | File:409435/2025",
            "priority": "P2",
            "created_at": "09/11/2025 11:49:02",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 28.23,
            "sla_met": false,
            "sla_breach_hours": 24.23,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:03:21"
          },
          {
            "ticket_id": 2061,
            "ticket_number": "352057",
            "title": "Pedido de Documentação - 396561/2025",
            "priority": "P2",
            "created_at": "09/11/2025 16:00:07",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 48.92,
            "sla_met": false,
            "sla_breach_hours": 44.92,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 16:55:17"
          },
          {
            "ticket_id": 2080,
            "ticket_number": "352076",
            "title": "GBN-86440 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:05",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 5.88,
            "sla_met": false,
            "sla_breach_hours": 1.88,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:05:02"
          },
          {
            "ticket_id": 2082,
            "ticket_number": "352078",
            "title": "GBN-78675 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:11",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 5.9,
            "sla_met": false,
            "sla_breach_hours": 1.9,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:05:34"
          },
          {
            "ticket_id": 2085,
            "ticket_number": "352081",
            "title": "Re: Pedido de cotação",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:33",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/11/2025 18:05:19"
          },
          {
            "ticket_id": 2086,
            "ticket_number": "352082",
            "title": "Referencia para pagamento | File:415420/2025",
            "priority": "P1",
            "created_at": "10/11/2025 10:11:34",
            "close_date": "2025-11-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.35,
            "sla_met": false,
            "sla_breach_hours": 6.1,
            "sla_name": "SLA P1",
            "first_response_at": "10/11/2025 16:33:03"
          },
          {
            "ticket_id": 2109,
            "ticket_number": "352105",
            "title": "Confirmação de Reserva * File 415384 * EMISSAO VOO",
            "priority": "P2",
            "created_at": "10/11/2025 11:38:40",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 11:48:25"
          },
          {
            "ticket_id": 2113,
            "ticket_number": "352109",
            "title": "RE: GBN-78131",
            "priority": "P2",
            "created_at": "10/11/2025 12:16:06",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 13:17:46"
          },
          {
            "ticket_id": 2114,
            "ticket_number": "352110",
            "title": "Cancelamento de reserva",
            "priority": "P2",
            "created_at": "10/11/2025 12:22:03",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 12:22:04"
          },
          {
            "ticket_id": 2120,
            "ticket_number": "352116",
            "title": "In Sure Broker alerta-o para documentos a pagament",
            "priority": "P2",
            "created_at": "10/11/2025 13:17:01",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 16:09:36"
          },
          {
            "ticket_id": 2121,
            "ticket_number": "352117",
            "title": "Reserva cancelada – Ref PP152546, Sr. Nuno João  B",
            "priority": "P2",
            "created_at": "10/11/2025 13:36:27",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 6.18,
            "sla_met": false,
            "sla_breach_hours": 2.18,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 19:47:49"
          },
          {
            "ticket_id": 2123,
            "ticket_number": "352119",
            "title": "Flexible Autos - Automatic response",
            "priority": "P3",
            "created_at": "10/11/2025 13:42:29",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/11/2025 12:29:08"
          },
          {
            "ticket_id": 2124,
            "ticket_number": "352120",
            "title": "GBN Travel: Information about your booking - GBN-8",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 13:57:42",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 2.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:45:40"
          },
          {
            "ticket_id": 2130,
            "ticket_number": "352126",
            "title": "ARSP-29315: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "10/11/2025 15:09:08",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 53.38,
            "sla_met": false,
            "sla_breach_hours": 49.38,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:33:01"
          },
          {
            "ticket_id": 2135,
            "ticket_number": "352131",
            "title": "GBN-89363 - Seu pedido foi recebido",
            "priority": "Reservas sem Formulário",
            "created_at": "10/11/2025 16:36:14",
            "close_date": "2025-11-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/11/2025 16:36:14"
          },
          {
            "ticket_id": 2151,
            "ticket_number": "352147",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "10/11/2025 19:16:22",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 19:16:23"
          },
          {
            "ticket_id": 2158,
            "ticket_number": "352154",
            "title": "OPTI 2414000019",
            "priority": "P2",
            "created_at": "10/11/2025 21:05:52",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 21:05:52"
          },
          {
            "ticket_id": 2165,
            "ticket_number": "352161",
            "title": "Dúvida sobre reserva EasyJet na Opti",
            "priority": "P2",
            "created_at": "10/11/2025 22:24:43",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 22:24:43"
          },
          {
            "ticket_id": 2168,
            "ticket_number": "352164",
            "title": "Reminder * Reserva File 415469 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "11/11/2025 10:10:06",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.37,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P1",
            "first_response_at": "11/11/2025 10:32:58"
          },
          {
            "ticket_id": 2169,
            "ticket_number": "352165",
            "title": "Referencia para pagamento | File:415469/2025",
            "priority": "P1",
            "created_at": "11/11/2025 10:10:07",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.47,
            "sla_met": false,
            "sla_breach_hours": 0.22,
            "sla_name": "SLA P1",
            "first_response_at": "11/11/2025 10:39:06"
          },
          {
            "ticket_id": 2171,
            "ticket_number": "352167",
            "title": "Reminder * Reserva File 415457 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "11/11/2025 10:10:10",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.63,
            "sla_met": false,
            "sla_breach_hours": 2.38,
            "sla_name": "SLA P1",
            "first_response_at": "11/11/2025 12:49:08"
          },
          {
            "ticket_id": 2172,
            "ticket_number": "352168",
            "title": "Referencia para pagamento | File:415457/2025",
            "priority": "P1",
            "created_at": "11/11/2025 10:10:12",
            "close_date": "2025-11-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.68,
            "sla_met": false,
            "sla_breach_hours": 2.43,
            "sla_name": "SLA P1",
            "first_response_at": "11/11/2025 12:51:45"
          },
          {
            "ticket_id": 2174,
            "ticket_number": "352170",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P2",
            "created_at": "11/11/2025 10:10:16",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 6.87,
            "sla_met": false,
            "sla_breach_hours": 2.87,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 17:02:37"
          },
          {
            "ticket_id": 2177,
            "ticket_number": "352173",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "11/11/2025 10:17:57",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 12:52:06"
          },
          {
            "ticket_id": 2196,
            "ticket_number": "352192",
            "title": "emissão e pagamento de comissões",
            "priority": "P2",
            "created_at": "11/11/2025 14:05:40",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 14:05:41"
          },
          {
            "ticket_id": 2212,
            "ticket_number": "352208",
            "title": "Re: Pedido de faturas",
            "priority": "P2",
            "created_at": "11/11/2025 17:01:44",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 506.5,
            "sla_met": false,
            "sla_breach_hours": 502.5,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 19:32:12"
          },
          {
            "ticket_id": 2234,
            "ticket_number": "352230",
            "title": "Referencia para pagamento | File:415693/2025",
            "priority": "P2",
            "created_at": "11/11/2025 22:22:53",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 21.03,
            "sla_met": false,
            "sla_breach_hours": 17.03,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 19:25:16"
          },
          {
            "ticket_id": 2235,
            "ticket_number": "352231",
            "title": "Recibo Verde - 14",
            "priority": "P3",
            "created_at": "11/11/2025 22:22:55",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/11/2025 22:22:55"
          },
          {
            "ticket_id": 2249,
            "ticket_number": "352245",
            "title": "viagem 251100078",
            "priority": "P3",
            "created_at": "12/11/2025 10:10:01",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 10:10:01"
          },
          {
            "ticket_id": 2250,
            "ticket_number": "352246",
            "title": "GBN-88330 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/11/2025 10:12:43",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 26.6,
            "sla_met": false,
            "sla_breach_hours": 2.6,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 12:48:49"
          },
          {
            "ticket_id": 2251,
            "ticket_number": "352247",
            "title": "GBN-76203 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/11/2025 10:12:45",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 10.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 20:33:42"
          },
          {
            "ticket_id": 2260,
            "ticket_number": "352256",
            "title": "RE: Correiacor - faturas",
            "priority": "P3",
            "created_at": "12/11/2025 10:40:03",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 11:05:13"
          },
          {
            "ticket_id": 2265,
            "ticket_number": "352261",
            "title": "PAGO URGENTE CANCELACION",
            "priority": "P3",
            "created_at": "12/11/2025 11:47:08",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 13:20:04"
          },
          {
            "ticket_id": 2268,
            "ticket_number": "352264",
            "title": "Referencia para pagamento | File:409747/2025",
            "priority": "P1",
            "created_at": "12/11/2025 12:23:00",
            "close_date": "2025-11-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.5,
            "sla_met": false,
            "sla_breach_hours": 24.25,
            "sla_name": "SLA P1",
            "first_response_at": "13/11/2025 12:53:09"
          },
          {
            "ticket_id": 2282,
            "ticket_number": "352278",
            "title": "Número de informação da reserva: 6120559",
            "priority": "P3",
            "created_at": "12/11/2025 12:55:33",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 35.75,
            "sla_met": false,
            "sla_breach_hours": 11.75,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 00:41:29"
          },
          {
            "ticket_id": 2286,
            "ticket_number": "352282",
            "title": "RV: TEMPLATE 6114915 W2M:013690002860",
            "priority": "P2",
            "created_at": "12/11/2025 13:10:11",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 24.37,
            "sla_met": false,
            "sla_breach_hours": 20.37,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 13:32:47"
          },
          {
            "ticket_id": 2287,
            "ticket_number": "352283",
            "title": "File 415457/25 * Excursão Confirmada 28/05",
            "priority": "P3",
            "created_at": "12/11/2025 13:39:45",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 17:47:58"
          },
          {
            "ticket_id": 2292,
            "ticket_number": "352288",
            "title": "Fecho de Contas 2025 – Regularização de Pagamentos",
            "priority": "P2",
            "created_at": "12/11/2025 15:05:38",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 5.55,
            "sla_met": false,
            "sla_breach_hours": 1.55,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:39:12"
          },
          {
            "ticket_id": 2302,
            "ticket_number": "352298",
            "title": "1217857373 - Reserva voo Ibéria",
            "priority": "P3",
            "created_at": "12/11/2025 16:33:59",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 21.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:34:19"
          },
          {
            "ticket_id": 2305,
            "ticket_number": "352300",
            "title": "Re:[## 23567 ##] GBN-86600 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/11/2025 16:59:45",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:02:36"
          },
          {
            "ticket_id": 2312,
            "ticket_number": "352307",
            "title": "Devolução de pagamento - Eduardo Mendes",
            "priority": "P2",
            "created_at": "12/11/2025 18:17:58",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 18:17:58"
          },
          {
            "ticket_id": 2313,
            "ticket_number": "352308",
            "title": "Referencia para pagamento | File:415693/2025",
            "priority": "P2",
            "created_at": "12/11/2025 18:18:00",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:39:40"
          },
          {
            "ticket_id": 2314,
            "ticket_number": "352309",
            "title": "Referencia para pagamento | File:415693/2025",
            "priority": "P2",
            "created_at": "12/11/2025 18:18:01",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 20:39:53"
          },
          {
            "ticket_id": 2317,
            "ticket_number": "352312",
            "title": "Confirmação de comissões",
            "priority": "P2",
            "created_at": "12/11/2025 18:40:22",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 18:40:22"
          },
          {
            "ticket_id": 2320,
            "ticket_number": "352315",
            "title": "GBN - 81225 solicitação de valores para emissão de",
            "priority": "P3",
            "created_at": "12/11/2025 20:44:17",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 20:44:17"
          },
          {
            "ticket_id": 2322,
            "ticket_number": "352317",
            "title": "vereficação de comissões",
            "priority": "P3",
            "created_at": "12/11/2025 21:14:36",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 21:14:36"
          },
          {
            "ticket_id": 2326,
            "ticket_number": "352321",
            "title": "Referencia para pagamento | File:415694/2025",
            "priority": "P2",
            "created_at": "12/11/2025 22:20:16",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 43.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:14:04"
          },
          {
            "ticket_id": 2327,
            "ticket_number": "352322",
            "title": "Referencia para pagamento | File:415790/2025",
            "priority": "P1",
            "created_at": "12/11/2025 22:20:18",
            "close_date": "2025-11-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.2,
            "sla_met": false,
            "sla_breach_hours": 0.95,
            "sla_name": "SLA P1",
            "first_response_at": "12/11/2025 23:33:10"
          },
          {
            "ticket_id": 2328,
            "ticket_number": "352323",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "12/11/2025 22:20:19",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 22:20:19"
          },
          {
            "ticket_id": 2330,
            "ticket_number": "352325",
            "title": "Referencia para pagamento | File:415573/2025",
            "priority": "P2",
            "created_at": "12/11/2025 22:20:22",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 14.7,
            "sla_met": false,
            "sla_breach_hours": 10.7,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 13:03:12"
          },
          {
            "ticket_id": 2335,
            "ticket_number": "352330",
            "title": "Comissões a faturar",
            "priority": "P3",
            "created_at": "12/11/2025 23:35:17",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 23:35:17"
          },
          {
            "ticket_id": 2338,
            "ticket_number": "352333",
            "title": "Re: Valor da comissão - GBN-65520",
            "priority": "P3",
            "created_at": "13/11/2025 10:14:03",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:14:04"
          },
          {
            "ticket_id": 2341,
            "ticket_number": "352336",
            "title": "confirmacação de localizadores para pagamento de c",
            "priority": "P3",
            "created_at": "13/11/2025 10:14:08",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:14:09"
          },
          {
            "ticket_id": 2344,
            "ticket_number": "352339",
            "title": "GBN-88330 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "13/11/2025 10:14:15",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:03:47"
          },
          {
            "ticket_id": 2345,
            "ticket_number": "352340",
            "title": "GBN-76203 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "13/11/2025 10:14:17",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:04:17"
          },
          {
            "ticket_id": 2348,
            "ticket_number": "352343",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 10:46:03",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:46:03"
          },
          {
            "ticket_id": 2350,
            "ticket_number": "352345",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 10:46:09",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 10:46:09"
          },
          {
            "ticket_id": 2353,
            "ticket_number": "352348",
            "title": "Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 11:06:48",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:07:04"
          },
          {
            "ticket_id": 2355,
            "ticket_number": "352350",
            "title": "Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 11:06:56",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:06:56"
          },
          {
            "ticket_id": 2356,
            "ticket_number": "352351",
            "title": "Re: emissão de recibo verde",
            "priority": "P3",
            "created_at": "13/11/2025 11:06:58",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:06:58"
          },
          {
            "ticket_id": 2357,
            "ticket_number": "352352",
            "title": "Re: Dúvidas sobre comissões",
            "priority": "P3",
            "created_at": "13/11/2025 11:07:00",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:07:00"
          },
          {
            "ticket_id": 2358,
            "ticket_number": "352353",
            "title": "Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 11:07:02",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:07:02"
          },
          {
            "ticket_id": 2359,
            "ticket_number": "352354",
            "title": "Ato único",
            "priority": "P3",
            "created_at": "13/11/2025 11:07:37",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:07:37"
          },
          {
            "ticket_id": 2360,
            "ticket_number": "352355",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 11:57:46",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:57:46"
          },
          {
            "ticket_id": 2361,
            "ticket_number": "352356",
            "title": "Re: Criação de balcão [#342268]",
            "priority": "P2",
            "created_at": "13/11/2025 11:57:47",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 12:03:47"
          },
          {
            "ticket_id": 2362,
            "ticket_number": "352357",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 11:57:49",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:57:49"
          },
          {
            "ticket_id": 2366,
            "ticket_number": "352361",
            "title": "comissões",
            "priority": "P3",
            "created_at": "13/11/2025 11:57:57",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 11:57:58"
          },
          {
            "ticket_id": 2368,
            "ticket_number": "352363",
            "title": "Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "13/11/2025 12:17:42",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 9.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 21:37:19"
          },
          {
            "ticket_id": 2369,
            "ticket_number": "352364",
            "title": "Información de reserva número:",
            "priority": "P3",
            "created_at": "13/11/2025 12:17:44",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 12:24:44"
          },
          {
            "ticket_id": 2370,
            "ticket_number": "352365",
            "title": "alteração valores opti",
            "priority": "P3",
            "created_at": "13/11/2025 12:17:48",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 12:17:49"
          },
          {
            "ticket_id": 2376,
            "ticket_number": "352371",
            "title": "Ato isolado para tratar das comissões",
            "priority": "P3",
            "created_at": "13/11/2025 13:32:48",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 13:32:48"
          },
          {
            "ticket_id": 2380,
            "ticket_number": "352375",
            "title": "Confirmação de valores de recibo verde",
            "priority": "P3",
            "created_at": "13/11/2025 14:09:41",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 14:09:41"
          },
          {
            "ticket_id": 2382,
            "ticket_number": "352377",
            "title": "Solole. Booking LJ3H1LIP is close to entering expe",
            "priority": "P3",
            "created_at": "13/11/2025 14:10:51",
            "close_date": "2025-11-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 18:50:16"
          },
          {
            "ticket_id": 2385,
            "ticket_number": "352380",
            "title": "Envio de Fatura-Recibo Nº1 – Comissões de Vendas d",
            "priority": "P3",
            "created_at": "13/11/2025 15:08:07",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 15:08:07"
          },
          {
            "ticket_id": 2386,
            "ticket_number": "352381",
            "title": "Acessos opti",
            "priority": "P3",
            "created_at": "13/11/2025 15:08:09",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 15:08:09"
          },
          {
            "ticket_id": 2391,
            "ticket_number": "352386",
            "title": "Comissões - ato isolado",
            "priority": "P2",
            "created_at": "13/11/2025 16:22:14",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 16:22:14"
          },
          {
            "ticket_id": 2392,
            "ticket_number": "352387",
            "title": "Confirmação de comissões",
            "priority": "P3",
            "created_at": "13/11/2025 16:22:16",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 16:22:16"
          },
          {
            "ticket_id": 2393,
            "ticket_number": "352388",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "13/11/2025 16:22:19",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 16:22:19"
          },
          {
            "ticket_id": 2394,
            "ticket_number": "352389",
            "title": "Comissão",
            "priority": "P3",
            "created_at": "13/11/2025 16:22:21",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 16:22:21"
          },
          {
            "ticket_id": 2397,
            "ticket_number": "352392",
            "title": "Devolução de pagamento - Filipa Lopes",
            "priority": "P2",
            "created_at": "13/11/2025 16:24:16",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 16:24:16"
          },
          {
            "ticket_id": 2398,
            "ticket_number": "352393",
            "title": "Opti - Localizador GBN-85066",
            "priority": "P2",
            "created_at": "13/11/2025 16:24:50",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 16:24:50"
          },
          {
            "ticket_id": 2400,
            "ticket_number": "352395",
            "title": "Fwd: Reserva Vila Galé Sintra (localizador 3962331",
            "priority": "P3",
            "created_at": "13/11/2025 16:34:27",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/11/2025 17:35:41"
          },
          {
            "ticket_id": 2420,
            "ticket_number": "352415",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "13/11/2025 18:43:29",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 18:45:16"
          },
          {
            "ticket_id": 2442,
            "ticket_number": "352437",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "13/11/2025 20:42:57",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 20:42:57"
          },
          {
            "ticket_id": 2448,
            "ticket_number": "352443",
            "title": "URGENTE  - Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "13/11/2025 22:25:35",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 19.77,
            "sla_met": false,
            "sla_breach_hours": 15.77,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:12:15"
          },
          {
            "ticket_id": 2449,
            "ticket_number": "352444",
            "title": "Rute Valado - Recibos para pagamento",
            "priority": "P2",
            "created_at": "13/11/2025 23:01:49",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 23:01:49"
          },
          {
            "ticket_id": 2450,
            "ticket_number": "352445",
            "title": "Susana Cota - Recibos para pagamento",
            "priority": "P2",
            "created_at": "13/11/2025 23:05:35",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 23:05:35"
          },
          {
            "ticket_id": 2451,
            "ticket_number": "352446",
            "title": "Faturas Pendentes: FA 2147875074; FA 2147875092",
            "priority": "P2",
            "created_at": "13/11/2025 23:14:11",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 20.75,
            "sla_met": false,
            "sla_breach_hours": 16.75,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 19:59:14"
          },
          {
            "ticket_id": 2453,
            "ticket_number": "352448",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60447",
            "priority": "P2",
            "created_at": "14/11/2025 10:04:23",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 104.22,
            "sla_met": false,
            "sla_breach_hours": 100.22,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 18:17:49"
          },
          {
            "ticket_id": 2455,
            "ticket_number": "352450",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60446",
            "priority": "P2",
            "created_at": "14/11/2025 10:04:27",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 8.35,
            "sla_met": false,
            "sla_breach_hours": 4.35,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:26:07"
          },
          {
            "ticket_id": 2456,
            "ticket_number": "352451",
            "title": "Re: Pgamento 2162351 (#2638868)",
            "priority": "P3",
            "created_at": "14/11/2025 10:04:29",
            "close_date": "2025-11-14",
            "sla_target_hours": 24,
            "actual_time_hours": 8.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 18:26:21"
          },
          {
            "ticket_id": 2457,
            "ticket_number": "352452",
            "title": "[Solicitação Recebida / Request Received]",
            "priority": "P3",
            "created_at": "14/11/2025 10:04:31",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 244.57,
            "sla_met": false,
            "sla_breach_hours": 220.57,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:38:52"
          },
          {
            "ticket_id": 2459,
            "ticket_number": "352454",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "14/11/2025 10:06:42",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 10:06:42"
          },
          {
            "ticket_id": 2474,
            "ticket_number": "352469",
            "title": "Comissões A/C Cátia Leal",
            "priority": "P3",
            "created_at": "14/11/2025 11:52:23",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:52:23"
          },
          {
            "ticket_id": 2476,
            "ticket_number": "352471",
            "title": "A/C CÁTIA LEAL - RECIBOS: VALORES COMISSÕES ATÉ DE",
            "priority": "P3",
            "created_at": "14/11/2025 12:10:32",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 12:10:32"
          },
          {
            "ticket_id": 2481,
            "ticket_number": "352476",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "14/11/2025 14:01:34",
            "close_date": "2025-11-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.85,
            "sla_met": false,
            "sla_breach_hours": 1.6,
            "sla_name": "SLA P1",
            "first_response_at": "14/11/2025 15:53:28"
          },
          {
            "ticket_id": 2487,
            "ticket_number": "352482",
            "title": "Recibos",
            "priority": "P2",
            "created_at": "14/11/2025 15:32:14",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 15:32:14"
          },
          {
            "ticket_id": 2490,
            "ticket_number": "352485",
            "title": "Faturas Pendentes: FA 2147875230",
            "priority": "P2",
            "created_at": "14/11/2025 16:22:53",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:27:32"
          },
          {
            "ticket_id": 2492,
            "ticket_number": "352487",
            "title": "Comissões / Ato isolado.",
            "priority": "P2",
            "created_at": "14/11/2025 16:48:31",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 16:48:31"
          },
          {
            "ticket_id": 2493,
            "ticket_number": "352488",
            "title": "Ao cuidado de Cátia Leal_RV",
            "priority": "P2",
            "created_at": "14/11/2025 16:48:33",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 16:48:33"
          },
          {
            "ticket_id": 2496,
            "ticket_number": "352491",
            "title": "RV_ Cátia Leal",
            "priority": "P2",
            "created_at": "14/11/2025 17:31:58",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 17:31:58"
          },
          {
            "ticket_id": 2502,
            "ticket_number": "352497",
            "title": "Fwd: Envio de Documentação",
            "priority": "P1",
            "created_at": "14/11/2025 17:59:35",
            "close_date": "2025-11-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/11/2025 17:59:35"
          },
          {
            "ticket_id": 2506,
            "ticket_number": "352501",
            "title": "RE: Fatura comissões - FR5",
            "priority": "P2",
            "created_at": "14/11/2025 18:27:37",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 18:27:38"
          },
          {
            "ticket_id": 2513,
            "ticket_number": "352508",
            "title": "Valores a receber",
            "priority": "P2",
            "created_at": "14/11/2025 21:06:19",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/11/2025 21:06:19"
          },
          {
            "ticket_id": 2523,
            "ticket_number": "352518",
            "title": "Faturas Pendentes: FA 2147875315",
            "priority": "P2",
            "created_at": "15/11/2025 00:23:30",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 67.68,
            "sla_met": false,
            "sla_breach_hours": 63.68,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 20:05:23"
          },
          {
            "ticket_id": 2527,
            "ticket_number": "352522",
            "title": "Urgente - pagamento sololé",
            "priority": "P2",
            "created_at": "15/11/2025 10:37:45",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 10:37:45"
          },
          {
            "ticket_id": 2528,
            "ticket_number": "352523",
            "title": "Att. Cátia Leal _ RV",
            "priority": "P2",
            "created_at": "15/11/2025 10:37:48",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 10:37:48"
          },
          {
            "ticket_id": 2534,
            "ticket_number": "352529",
            "title": "Solole. Booking KAX9U53U is close to entering expe",
            "priority": "P2",
            "created_at": "15/11/2025 15:47:01",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 50.95,
            "sla_met": false,
            "sla_breach_hours": 46.95,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:44:47"
          },
          {
            "ticket_id": 2536,
            "ticket_number": "352531",
            "title": "ON VOYAGE - PAGAMENTO COMISSÃO REF.396561 / 2025",
            "priority": "P2",
            "created_at": "15/11/2025 15:47:06",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 15:47:07"
          },
          {
            "ticket_id": 2540,
            "ticket_number": "352535",
            "title": "Solole. Booking LJ3H1LIP is close to entering expe",
            "priority": "P2",
            "created_at": "15/11/2025 15:47:14",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 50.95,
            "sla_met": false,
            "sla_breach_hours": 46.95,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:45:11"
          },
          {
            "ticket_id": 2546,
            "ticket_number": "352541",
            "title": "Amanhã será realizada a cobrança da reserva A34860",
            "priority": "P2",
            "created_at": "16/11/2025 10:54:51",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 76.93,
            "sla_met": false,
            "sla_breach_hours": 72.93,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 15:51:51"
          },
          {
            "ticket_id": 2547,
            "ticket_number": "352542",
            "title": "Referencia para pagamento | File:416013/2025",
            "priority": "P2",
            "created_at": "16/11/2025 10:54:53",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 32.1,
            "sla_met": false,
            "sla_breach_hours": 28.1,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 19:01:21"
          },
          {
            "ticket_id": 2548,
            "ticket_number": "352543",
            "title": "Referencia para pagamento | File:400707/2025",
            "priority": "P2",
            "created_at": "16/11/2025 10:54:54",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 32.22,
            "sla_met": false,
            "sla_breach_hours": 28.22,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 19:08:23"
          },
          {
            "ticket_id": 2550,
            "ticket_number": "352545",
            "title": "Recibos Verdes - Ao cuidado Catia Leal",
            "priority": "P2",
            "created_at": "16/11/2025 10:55:00",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 105.75,
            "sla_met": false,
            "sla_breach_hours": 101.75,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 20:40:30"
          },
          {
            "ticket_id": 2552,
            "ticket_number": "352547",
            "title": "Recibo Verde - 14",
            "priority": "P2",
            "created_at": "16/11/2025 10:55:42",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 10:55:42"
          },
          {
            "ticket_id": 2557,
            "ticket_number": "352552",
            "title": "Solole. Booking KAX9U53U is close to entering expe",
            "priority": "P2",
            "created_at": "16/11/2025 14:04:03",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 28.75,
            "sla_met": false,
            "sla_breach_hours": 24.75,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:49:18"
          },
          {
            "ticket_id": 2559,
            "ticket_number": "352554",
            "title": "Pedido de comissões ",
            "priority": "P2",
            "created_at": "16/11/2025 15:22:18",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 15:22:18"
          },
          {
            "ticket_id": 2560,
            "ticket_number": "352555",
            "title": "comissão",
            "priority": "P2",
            "created_at": "16/11/2025 16:04:11",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 16:04:12"
          },
          {
            "ticket_id": 2572,
            "ticket_number": "352567",
            "title": "Fatura opti 249900024",
            "priority": "P2",
            "created_at": "17/11/2025 10:18:41",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 10:18:41"
          },
          {
            "ticket_id": 2575,
            "ticket_number": "352570",
            "title": "Houve um problema com o pagamento da reserva A3486",
            "priority": "P2",
            "created_at": "17/11/2025 10:18:45",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 53.53,
            "sla_met": false,
            "sla_breach_hours": 49.53,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 15:51:23"
          },
          {
            "ticket_id": 2592,
            "ticket_number": "352587",
            "title": "Re: Comissões",
            "priority": "P2",
            "created_at": "17/11/2025 12:07:36",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:07:36"
          },
          {
            "ticket_id": 2593,
            "ticket_number": "352588",
            "title": "PAGO URGENTE CANCELACION",
            "priority": "P2",
            "created_at": "17/11/2025 12:07:38",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 6.72,
            "sla_met": false,
            "sla_breach_hours": 2.72,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:51:00"
          },
          {
            "ticket_id": 2595,
            "ticket_number": "352590",
            "title": "Pagamento Att/Cátia",
            "priority": "P2",
            "created_at": "17/11/2025 12:28:27",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:28:27"
          },
          {
            "ticket_id": 2598,
            "ticket_number": "352593",
            "title": "Pagamento Att/Cátia",
            "priority": "P2",
            "created_at": "17/11/2025 12:39:49",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:39:49"
          },
          {
            "ticket_id": 2600,
            "ticket_number": "352595",
            "title": "Pagamento Att/Cátia",
            "priority": "P2",
            "created_at": "17/11/2025 12:56:08",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:56:08"
          },
          {
            "ticket_id": 2602,
            "ticket_number": "352597",
            "title": "Comissoes",
            "priority": "P2",
            "created_at": "17/11/2025 13:10:05",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 13:10:05"
          },
          {
            "ticket_id": 2607,
            "ticket_number": "352602",
            "title": "Solole. Booking KAX9U53U is close to entering expe",
            "priority": "P2",
            "created_at": "17/11/2025 14:02:42",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 4.8,
            "sla_met": false,
            "sla_breach_hours": 0.8,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:51:14"
          },
          {
            "ticket_id": 2608,
            "ticket_number": "352603",
            "title": "Verificação de comissões",
            "priority": "P3",
            "created_at": "17/11/2025 14:46:21",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 14:46:21"
          },
          {
            "ticket_id": 2626,
            "ticket_number": "352621",
            "title": "GBN-90406 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/11/2025 18:07:49",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 24.1,
            "sla_met": false,
            "sla_breach_hours": 20.1,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 18:14:12"
          },
          {
            "ticket_id": 2635,
            "ticket_number": "352630",
            "title": "Re: Nova Viagem #251100144 - Mónica Linhares",
            "priority": "P2",
            "created_at": "17/11/2025 19:13:46",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 19:13:46"
          },
          {
            "ticket_id": 2662,
            "ticket_number": "352657",
            "title": "GBN-90406 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/11/2025 00:21:34",
            "close_date": "2025-11-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 00:25:39"
          },
          {
            "ticket_id": 2664,
            "ticket_number": "352659",
            "title": "Emissão de faturas - opti 247500029",
            "priority": "P2",
            "created_at": "18/11/2025 10:22:29",
            "close_date": "2025-11-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/11/2025 10:22:29"
          },
          {
            "ticket_id": 2665,
            "ticket_number": "352660",
            "title": "Confirmação de valores - Comissões",
            "priority": "P3",
            "created_at": "18/11/2025 10:22:30",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:22:30"
          },
          {
            "ticket_id": 2669,
            "ticket_number": "352664",
            "title": "Re: Nova Viagem #251100158 - O mundo à tua espera",
            "priority": "P3",
            "created_at": "18/11/2025 10:25:53",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:25:53"
          },
          {
            "ticket_id": 2671,
            "ticket_number": "352666",
            "title": "Levantamento de comissões A/C Cátia",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:07",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:08"
          },
          {
            "ticket_id": 2672,
            "ticket_number": "352667",
            "title": "Confirmação comissões A/C Cátia",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:09",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:09"
          },
          {
            "ticket_id": 2673,
            "ticket_number": "352668",
            "title": "Comissões Juliana Costa - Ferias a Porta",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:11",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:11"
          },
          {
            "ticket_id": 2674,
            "ticket_number": "352669",
            "title": "Pedio de comissões",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:12",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:12"
          },
          {
            "ticket_id": 2675,
            "ticket_number": "352670",
            "title": "Recibo verde",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:14",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:28:14"
          },
          {
            "ticket_id": 2676,
            "ticket_number": "352671",
            "title": "GBN-90406   - Sua reserva está pendente de pagamen",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:48",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 7.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 18:10:37"
          },
          {
            "ticket_id": 2677,
            "ticket_number": "352672",
            "title": "GBN-89700 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:50",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 7.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 18:05:39"
          },
          {
            "ticket_id": 2679,
            "ticket_number": "352674",
            "title": "Respuesta automática: Pagamento 604492196",
            "priority": "P3",
            "created_at": "18/11/2025 10:28:55",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 7.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 18:04:35"
          },
          {
            "ticket_id": 2682,
            "ticket_number": "352677",
            "title": "Confirmacao 333752",
            "priority": "P1",
            "created_at": "18/11/2025 10:28:59",
            "close_date": "2025-11-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.73,
            "sla_met": false,
            "sla_breach_hours": 1.48,
            "sla_name": "SLA P1",
            "first_response_at": "18/11/2025 12:13:06"
          },
          {
            "ticket_id": 2694,
            "ticket_number": "352689",
            "title": "Confirmar comissão",
            "priority": "P3",
            "created_at": "18/11/2025 12:55:53",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 12:55:53"
          },
          {
            "ticket_id": 2709,
            "ticket_number": "352704",
            "title": "RV_ Catia_ 2501002572",
            "priority": "P3",
            "created_at": "18/11/2025 16:26:22",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 16:26:22"
          },
          {
            "ticket_id": 2710,
            "ticket_number": "352705",
            "title": "cancelar viagem - loc 604489162",
            "priority": "P3",
            "created_at": "18/11/2025 16:26:24",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 16:26:24"
          },
          {
            "ticket_id": 2715,
            "ticket_number": "352710",
            "title": "Cancelamento de reserva 332230",
            "priority": "P3",
            "created_at": "18/11/2025 17:44:42",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 18:08:46"
          },
          {
            "ticket_id": 2721,
            "ticket_number": "352716",
            "title": "Att. Catia_ RV _  spt002501519183",
            "priority": "P3",
            "created_at": "18/11/2025 19:16:06",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 19:16:06"
          },
          {
            "ticket_id": 2753,
            "ticket_number": "352748",
            "title": "GBN-89265 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "19/11/2025 10:02:16",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 9.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 19:52:00"
          },
          {
            "ticket_id": 2754,
            "ticket_number": "352749",
            "title": "GBN-88499 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "19/11/2025 10:02:18",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 16:19:09"
          },
          {
            "ticket_id": 2755,
            "ticket_number": "352750",
            "title": "GBN-89700 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "19/11/2025 10:02:21",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 9.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 19:51:50"
          },
          {
            "ticket_id": 2756,
            "ticket_number": "352751",
            "title": "GBN-84978 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "19/11/2025 10:02:24",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 6.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 16:21:08"
          },
          {
            "ticket_id": 2758,
            "ticket_number": "352753",
            "title": "Referencia para pagamento | File:415790/2025",
            "priority": "P3",
            "created_at": "19/11/2025 10:05:16",
            "close_date": "2025-11-19",
            "sla_target_hours": 24,
            "actual_time_hours": 9.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 19:55:45"
          },
          {
            "ticket_id": 2763,
            "ticket_number": "352758",
            "title": "Houve um problema com o pagamento da reserva A3486",
            "priority": "P1",
            "created_at": "19/11/2025 10:07:07",
            "close_date": "2025-11-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.57,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA P1",
            "first_response_at": "19/11/2025 10:41:33"
          },
          {
            "ticket_id": 2765,
            "ticket_number": "352760",
            "title": "Orçamento grupo 16 pessoas",
            "priority": "P2",
            "created_at": "19/11/2025 10:07:45",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 10:07:45"
          },
          {
            "ticket_id": 2795,
            "ticket_number": "352790",
            "title": "Reserva cancelada com localizador: 3962331",
            "priority": "P3",
            "created_at": "19/11/2025 13:26:40",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 33.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 23:21:26"
          },
          {
            "ticket_id": 2803,
            "ticket_number": "352798",
            "title": "Aviso de pagamento",
            "priority": "P2",
            "created_at": "19/11/2025 15:35:39",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 19:24:23"
          },
          {
            "ticket_id": 2809,
            "ticket_number": "352804",
            "title": "URGENTE Confirmação de reserva 333869### TIME LIMI",
            "priority": "P1",
            "created_at": "19/11/2025 15:58:06",
            "close_date": "2025-11-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.32,
            "sla_met": false,
            "sla_breach_hours": 0.07,
            "sla_name": "SLA P1",
            "first_response_at": "19/11/2025 16:17:52"
          },
          {
            "ticket_id": 2834,
            "ticket_number": "352829",
            "title": "Morada de faturação",
            "priority": "P2",
            "created_at": "19/11/2025 23:38:28",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 23:38:29"
          },
          {
            "ticket_id": 2846,
            "ticket_number": "352841",
            "title": "GBN-85475 - Your booking is still pending payment",
            "priority": "P3",
            "created_at": "20/11/2025 10:21:59",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 34.95,
            "sla_met": false,
            "sla_breach_hours": 10.95,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 21:19:41"
          },
          {
            "ticket_id": 2863,
            "ticket_number": "352858",
            "title": "RE: Pagamento 1760552",
            "priority": "P3",
            "created_at": "20/11/2025 11:41:40",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 98.97,
            "sla_met": false,
            "sla_breach_hours": 74.97,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:40:29"
          },
          {
            "ticket_id": 2864,
            "ticket_number": "352859",
            "title": "RE: Pagamento 1760548",
            "priority": "P3",
            "created_at": "20/11/2025 11:41:41",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 98.97,
            "sla_met": false,
            "sla_breach_hours": 74.97,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:40:17"
          },
          {
            "ticket_id": 2866,
            "ticket_number": "352861",
            "title": "COMISSÕES",
            "priority": "P3",
            "created_at": "20/11/2025 11:58:20",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 11:58:20"
          },
          {
            "ticket_id": 2872,
            "ticket_number": "352867",
            "title": "Aviso de transferência",
            "priority": "P3",
            "created_at": "20/11/2025 12:39:07",
            "close_date": "2025-11-20",
            "sla_target_hours": 24,
            "actual_time_hours": 1.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 14:19:43"
          },
          {
            "ticket_id": 2873,
            "ticket_number": "352868",
            "title": "GBN-81225 - Solicitação de pagamento de comissão (",
            "priority": "P3",
            "created_at": "20/11/2025 13:24:50",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 13:24:50"
          },
          {
            "ticket_id": 2875,
            "ticket_number": "352870",
            "title": "Faturas em nome da Influente Proeza",
            "priority": "P3",
            "created_at": "20/11/2025 13:24:55",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 13:24:55"
          },
          {
            "ticket_id": 2883,
            "ticket_number": "352878",
            "title": "RE: Pagamento 6121113",
            "priority": "P3",
            "created_at": "20/11/2025 15:40:05",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 95.0,
            "sla_met": false,
            "sla_breach_hours": 71.0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:40:44"
          },
          {
            "ticket_id": 2884,
            "ticket_number": "352879",
            "title": "RE: Pagamento 6120833",
            "priority": "P3",
            "created_at": "20/11/2025 15:40:07",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 95.0,
            "sla_met": false,
            "sla_breach_hours": 71.0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:40:55"
          },
          {
            "ticket_id": 2890,
            "ticket_number": "352885",
            "title": "RE: Comissão 1115650285",
            "priority": "P3",
            "created_at": "20/11/2025 16:38:52",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 16:38:52"
          },
          {
            "ticket_id": 2896,
            "ticket_number": "352891",
            "title": "Confirmacao 333975",
            "priority": "P1",
            "created_at": "20/11/2025 17:44:33",
            "close_date": "2025-11-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.12,
            "sla_met": false,
            "sla_breach_hours": 0.87,
            "sla_name": "SLA P1",
            "first_response_at": "20/11/2025 18:51:46"
          },
          {
            "ticket_id": 2897,
            "ticket_number": "352892",
            "title": "Confirmação de reserva 333871",
            "priority": "P1",
            "created_at": "20/11/2025 17:52:31",
            "close_date": "2025-11-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.88,
            "sla_met": false,
            "sla_breach_hours": 0.63,
            "sla_name": "SLA P1",
            "first_response_at": "20/11/2025 18:45:43"
          },
          {
            "ticket_id": 2904,
            "ticket_number": "352899",
            "title": "DADOS FATURAÇÃO OPTI 2414900010",
            "priority": "P2",
            "created_at": "20/11/2025 19:29:46",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 19:29:46"
          },
          {
            "ticket_id": 2910,
            "ticket_number": "352905",
            "title": "pagamento comissões Liliana Pinto",
            "priority": "P3",
            "created_at": "20/11/2025 20:50:05",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 20:50:06"
          },
          {
            "ticket_id": 2912,
            "ticket_number": "352907",
            "title": "Confirmação de comissões",
            "priority": "P2",
            "created_at": "20/11/2025 22:49:40",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 22:49:41"
          },
          {
            "ticket_id": 2923,
            "ticket_number": "352918",
            "title": "RE: Pagamento 6121143",
            "priority": "P3",
            "created_at": "21/11/2025 10:05:31",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 76.58,
            "sla_met": false,
            "sla_breach_hours": 52.58,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:41:04"
          },
          {
            "ticket_id": 2924,
            "ticket_number": "352919",
            "title": "GBN-85475 - Your booking is still pending payment",
            "priority": "P2",
            "created_at": "21/11/2025 10:05:34",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 14:02:08"
          },
          {
            "ticket_id": 2925,
            "ticket_number": "352920",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "21/11/2025 10:05:37",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 10:05:37"
          },
          {
            "ticket_id": 2927,
            "ticket_number": "352922",
            "title": "Notificación comisiones servicios fuera de factura",
            "priority": "P2",
            "created_at": "21/11/2025 10:07:19",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 14:02:08"
          },
          {
            "ticket_id": 2928,
            "ticket_number": "352923",
            "title": "LEVANTAMENTO DE COMISSOES",
            "priority": "P3",
            "created_at": "21/11/2025 10:39:30",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 10:39:30"
          },
          {
            "ticket_id": 2929,
            "ticket_number": "352924",
            "title": "Pedido Comissões 2025- Raquel Pinho ",
            "priority": "P3",
            "created_at": "21/11/2025 11:06:53",
            "close_date": "2025-11-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 11:06:53"
          },
          {
            "ticket_id": 2930,
            "ticket_number": "352925",
            "title": "Confirmacao 334059",
            "priority": "P2",
            "created_at": "21/11/2025 11:25:46",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 9.82,
            "sla_met": false,
            "sla_breach_hours": 5.82,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 21:15:15"
          },
          {
            "ticket_id": 2931,
            "ticket_number": "352926",
            "title": "Confirmacao 334072",
            "priority": "P2",
            "created_at": "21/11/2025 11:25:48",
            "close_date": "2025-11-21",
            "sla_target_hours": 4,
            "actual_time_hours": 9.82,
            "sla_met": false,
            "sla_breach_hours": 5.82,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 21:15:39"
          },
          {
            "ticket_id": 2936,
            "ticket_number": "352931",
            "title": "Confirmacao 334043",
            "priority": "P1",
            "created_at": "21/11/2025 11:25:59",
            "close_date": "2025-11-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.93,
            "sla_met": false,
            "sla_breach_hours": 3.68,
            "sla_name": "SLA P1",
            "first_response_at": "21/11/2025 15:22:14"
          },
          {
            "ticket_id": 2937,
            "ticket_number": "352932",
            "title": "Confirmacao 334047",
            "priority": "Reservas sem Formulário",
            "created_at": "21/11/2025 11:26:02",
            "close_date": "2025-11-21",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "21/11/2025 15:22:14"
          },
          {
            "ticket_id": 2946,
            "ticket_number": "352941",
            "title": "Pedido de Comissões",
            "priority": "P2",
            "created_at": "21/11/2025 14:20:41",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 14:20:42"
          },
          {
            "ticket_id": 2950,
            "ticket_number": "352945",
            "title": "alexandra.leitao@umafamiliaemviagem.com",
            "priority": "P3",
            "created_at": "21/11/2025 14:20:53",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 14:20:53"
          },
          {
            "ticket_id": 2968,
            "ticket_number": "352963",
            "title": "Fwd: Nova Viagem #251100217 - Cristina Meira",
            "priority": "P2",
            "created_at": "21/11/2025 17:52:17",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 17:52:18"
          },
          {
            "ticket_id": 2988,
            "ticket_number": "352983",
            "title": "envio comissões para conferência",
            "priority": "P2",
            "created_at": "21/11/2025 19:22:14",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 19:22:14"
          },
          {
            "ticket_id": 2991,
            "ticket_number": "352986",
            "title": "Dúvidas Ato Isolado - Luana Silvestre",
            "priority": "P2",
            "created_at": "21/11/2025 20:42:10",
            "close_date": "2025-11-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 20:42:10"
          },
          {
            "ticket_id": 3002,
            "ticket_number": "352997",
            "title": "Referencia para pagamento | File:415420/2025",
            "priority": "P3",
            "created_at": "21/11/2025 22:35:48",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 91.63,
            "sla_met": false,
            "sla_breach_hours": 67.63,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 18:14:41"
          },
          {
            "ticket_id": 3003,
            "ticket_number": "352998",
            "title": "Referencia para pagamento | File:416895/2025",
            "priority": "P3",
            "created_at": "21/11/2025 22:35:50",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 64.43,
            "sla_met": false,
            "sla_breach_hours": 40.43,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 15:02:36"
          },
          {
            "ticket_id": 3004,
            "ticket_number": "352999",
            "title": "DADOS DE FATURAÇÃO DE RESERVAS GBN 90811 E CIVITAT",
            "priority": "P3",
            "created_at": "21/11/2025 22:35:51",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/11/2025 22:35:52"
          },
          {
            "ticket_id": 3010,
            "ticket_number": "353005",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "22/11/2025 11:13:57",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 11:13:58"
          },
          {
            "ticket_id": 3022,
            "ticket_number": "353017",
            "title": "Fatura/Recibo em falta - 331545 Soltropico",
            "priority": "P2",
            "created_at": "22/11/2025 18:04:16",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 18:04:16"
          },
          {
            "ticket_id": 3023,
            "ticket_number": "353018",
            "title": "Levantamento Comissoes",
            "priority": "P2",
            "created_at": "22/11/2025 19:23:29",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 19:23:29"
          },
          {
            "ticket_id": 3025,
            "ticket_number": "353020",
            "title": "Criação fatura reserva opti 2414900010",
            "priority": "P2",
            "created_at": "22/11/2025 20:02:53",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 20:02:53"
          },
          {
            "ticket_id": 3038,
            "ticket_number": "353033",
            "title": "fatura cliente localizador GBN 91292",
            "priority": "P3",
            "created_at": "23/11/2025 12:58:35",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 12:58:35"
          },
          {
            "ticket_id": 3051,
            "ticket_number": "353044",
            "title": "confirmação de comissões a levantar",
            "priority": "P3",
            "created_at": "23/11/2025 19:55:21",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 19:55:21"
          },
          {
            "ticket_id": 3052,
            "ticket_number": "353045",
            "title": "Faturas reserva GBN-74839",
            "priority": "P3",
            "created_at": "23/11/2025 20:37:20",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 17.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 14:31:09"
          },
          {
            "ticket_id": 3053,
            "ticket_number": "353046",
            "title": "Comissões",
            "priority": "P3",
            "created_at": "23/11/2025 20:37:21",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 15.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 12:33:25"
          },
          {
            "ticket_id": 3056,
            "ticket_number": "353049",
            "title": "Fatura em falta - Opti 247500027",
            "priority": "P3",
            "created_at": "23/11/2025 21:47:44",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 21:47:45"
          },
          {
            "ticket_id": 3060,
            "ticket_number": "353053",
            "title": "fatura para cliente reserva GBN-91357",
            "priority": "P3",
            "created_at": "23/11/2025 23:50:00",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 23:50:00"
          },
          {
            "ticket_id": 3064,
            "ticket_number": "353057",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "24/11/2025 10:07:38",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 14:00:36"
          },
          {
            "ticket_id": 3066,
            "ticket_number": "353059",
            "title": "GBN-86805 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "24/11/2025 10:07:45",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 14:00:36"
          },
          {
            "ticket_id": 3072,
            "ticket_number": "353065",
            "title": "Reminder * Reserva File 416895 * Deadline Hoje 13h",
            "priority": "P1",
            "created_at": "24/11/2025 10:39:15",
            "close_date": "2025-11-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.4,
            "sla_met": false,
            "sla_breach_hours": 4.15,
            "sla_name": "SLA P1",
            "first_response_at": "24/11/2025 15:03:51"
          },
          {
            "ticket_id": 3075,
            "ticket_number": "353068",
            "title": "Re: Documentos [#342704]",
            "priority": "P2",
            "created_at": "24/11/2025 10:48:32",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 14:40:42"
          },
          {
            "ticket_id": 3085,
            "ticket_number": "353078",
            "title": "Re:[## 25593 ##] GBN-85723 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "24/11/2025 12:00:06",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 20:25:25"
          },
          {
            "ticket_id": 3090,
            "ticket_number": "353083",
            "title": "Confirmação de valores para emissão de recibo",
            "priority": "P2",
            "created_at": "24/11/2025 12:35:36",
            "close_date": "2025-11-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 12:35:36"
          },
          {
            "ticket_id": 3098,
            "ticket_number": "353091",
            "title": "Envio NC*File 387305-Sinistro CIE São Vicente CV",
            "priority": "P2",
            "created_at": "24/11/2025 14:00:57",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 17:06:08"
          },
          {
            "ticket_id": 3099,
            "ticket_number": "353092",
            "title": "Pedido de Sinalização De Reserva 334252",
            "priority": "P1",
            "created_at": "24/11/2025 14:13:57",
            "close_date": "2025-11-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "24/11/2025 14:27:15"
          },
          {
            "ticket_id": 3121,
            "ticket_number": "353114",
            "title": "Documentos [#342704]",
            "priority": "P2",
            "created_at": "24/11/2025 18:01:39",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 19.9,
            "sla_met": false,
            "sla_breach_hours": 15.9,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 13:56:01"
          },
          {
            "ticket_id": 3130,
            "ticket_number": "353123",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "24/11/2025 21:44:48",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 21:44:48"
          },
          {
            "ticket_id": 3132,
            "ticket_number": "353125",
            "title": "Levantamento de comissões_nov 2025",
            "priority": "P2",
            "created_at": "24/11/2025 22:22:58",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/11/2025 22:22:59"
          },
          {
            "ticket_id": 3146,
            "ticket_number": "353139",
            "title": "GBN-91233 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "25/11/2025 11:07:26",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 12:52:19"
          },
          {
            "ticket_id": 3148,
            "ticket_number": "353141",
            "title": "Re: a/c Cátia Leal - RV",
            "priority": "P3",
            "created_at": "25/11/2025 11:07:30",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 7.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 18:49:39"
          },
          {
            "ticket_id": 3150,
            "ticket_number": "353143",
            "title": "a/c Cátia Leal - RV",
            "priority": "P3",
            "created_at": "25/11/2025 11:07:34",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 28.42,
            "sla_met": false,
            "sla_breach_hours": 4.42,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 15:32:54"
          },
          {
            "ticket_id": 3151,
            "ticket_number": "353144",
            "title": "Pedido de RESERVA Grupo - NewBlue Bayahibe",
            "priority": "P2",
            "created_at": "25/11/2025 11:07:36",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 11:07:36"
          },
          {
            "ticket_id": 3154,
            "ticket_number": "353147",
            "title": "RE: Pagamento 6120897",
            "priority": "P3",
            "created_at": "25/11/2025 12:23:59",
            "close_date": "2025-11-25",
            "sla_target_hours": 24,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:56:56"
          },
          {
            "ticket_id": 3166,
            "ticket_number": "353159",
            "title": "opti242100160 - A/C Cátia Leal",
            "priority": "P3",
            "created_at": "25/11/2025 13:09:37",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 26.2,
            "sla_met": false,
            "sla_breach_hours": 2.2,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 15:21:48"
          },
          {
            "ticket_id": 3174,
            "ticket_number": "353167",
            "title": "Emissao de Recibo",
            "priority": "P3",
            "created_at": "25/11/2025 13:41:12",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 13:41:12"
          },
          {
            "ticket_id": 3178,
            "ticket_number": "353171",
            "title": "Envio documentos - (Factura-231004994)  n. 1004557",
            "priority": "P1",
            "created_at": "25/11/2025 13:41:57",
            "close_date": "2025-11-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.92,
            "sla_met": false,
            "sla_breach_hours": 4.67,
            "sla_name": "SLA P1",
            "first_response_at": "25/11/2025 18:37:05"
          },
          {
            "ticket_id": 3187,
            "ticket_number": "353180",
            "title": "Pagamento comissões - ato único",
            "priority": "P3",
            "created_at": "25/11/2025 15:41:30",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 15:41:31"
          },
          {
            "ticket_id": 3193,
            "ticket_number": "353186",
            "title": "Re: SPT002501538118",
            "priority": "P3",
            "created_at": "25/11/2025 16:19:16",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 16:19:17"
          },
          {
            "ticket_id": 3199,
            "ticket_number": "353192",
            "title": "Pagamento",
            "priority": "P2",
            "created_at": "25/11/2025 17:31:06",
            "close_date": "2025-11-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 17:39:29"
          },
          {
            "ticket_id": 3219,
            "ticket_number": "353212",
            "title": "Referencia para pagamento | File:417998/2025",
            "priority": "P2",
            "created_at": "25/11/2025 22:44:19",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 13.03,
            "sla_met": false,
            "sla_breach_hours": 9.03,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 11:46:31"
          },
          {
            "ticket_id": 3222,
            "ticket_number": "353215",
            "title": "Fecho de contas - comissões",
            "priority": "P2",
            "created_at": "25/11/2025 22:44:24",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 22:44:24"
          },
          {
            "ticket_id": 3223,
            "ticket_number": "353216",
            "title": "Ato isolado - Renata Ferreira",
            "priority": "P2",
            "created_at": "25/11/2025 22:44:26",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/11/2025 22:44:26"
          },
          {
            "ticket_id": 3229,
            "ticket_number": "353222",
            "title": "GBN-91782 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "26/11/2025 00:05:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 00:05:10"
          },
          {
            "ticket_id": 3243,
            "ticket_number": "353236",
            "title": "GBN-91784 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "26/11/2025 10:24:54",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 14:24:26"
          },
          {
            "ticket_id": 3244,
            "ticket_number": "353237",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P3",
            "created_at": "26/11/2025 10:24:56",
            "close_date": "2025-11-26",
            "sla_target_hours": 24,
            "actual_time_hours": 4.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 15:09:57"
          },
          {
            "ticket_id": 3246,
            "ticket_number": "353239",
            "title": "GBN-85066 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "26/11/2025 10:25:00",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 14:24:26"
          },
          {
            "ticket_id": 3247,
            "ticket_number": "353240",
            "title": "GBN-91782 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "26/11/2025 10:25:02",
            "close_date": "2025-11-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 27.43,
            "sla_met": false,
            "sla_breach_hours": 27.18,
            "sla_name": "SLA P1",
            "first_response_at": "27/11/2025 13:51:38"
          },
          {
            "ticket_id": 3251,
            "ticket_number": "353244",
            "title": "Envio de Fatura - File 416895/25",
            "priority": "P3",
            "created_at": "26/11/2025 10:34:46",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 27.57,
            "sla_met": false,
            "sla_breach_hours": 3.57,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 14:08:55"
          },
          {
            "ticket_id": 3254,
            "ticket_number": "353247",
            "title": "Referencia para pagamento | File:418054/2025",
            "priority": "P2",
            "created_at": "26/11/2025 11:04:17",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 11:47:20"
          },
          {
            "ticket_id": 3255,
            "ticket_number": "353248",
            "title": "Reminder * Reserva File 418054 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "26/11/2025 11:04:18",
            "close_date": "2025-11-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.25,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA P1",
            "first_response_at": "26/11/2025 13:19:40"
          },
          {
            "ticket_id": 3256,
            "ticket_number": "353249",
            "title": "A/C Cátia Leal",
            "priority": "P2",
            "created_at": "26/11/2025 11:04:19",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 28.15,
            "sla_met": false,
            "sla_breach_hours": 24.15,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 15:13:42"
          },
          {
            "ticket_id": 3258,
            "ticket_number": "353251",
            "title": "Plano de Pagamento Vencido * Urgente, File 387503",
            "priority": "P1",
            "created_at": "26/11/2025 11:04:56",
            "close_date": "2025-11-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.28,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P1",
            "first_response_at": "26/11/2025 11:22:07"
          },
          {
            "ticket_id": 3260,
            "ticket_number": "353253",
            "title": "Plano de Pagamento Vencido * Urgente, File 405451",
            "priority": "P1",
            "created_at": "26/11/2025 11:07:10",
            "close_date": "2025-11-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/11/2025 11:21:57"
          },
          {
            "ticket_id": 3265,
            "ticket_number": "353258",
            "title": "FATURA OPTI Nº 2414900013",
            "priority": "P2",
            "created_at": "26/11/2025 12:20:18",
            "close_date": "2025-11-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 12:20:18"
          },
          {
            "ticket_id": 3267,
            "ticket_number": "353260",
            "title": "confirmar valores comissão",
            "priority": "P2",
            "created_at": "26/11/2025 12:37:33",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:24:39"
          },
          {
            "ticket_id": 3268,
            "ticket_number": "353261",
            "title": "Recibo de comissão",
            "priority": "P2",
            "created_at": "26/11/2025 12:37:34",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 12:37:35"
          },
          {
            "ticket_id": 3281,
            "ticket_number": "353274",
            "title": "Dificuldade no backoffice e levantamento de comiss",
            "priority": "P2",
            "created_at": "26/11/2025 14:41:28",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 14:41:28"
          },
          {
            "ticket_id": 3285,
            "ticket_number": "353278",
            "title": "A/c Cátia Leal - Comissões  [para verificar para e",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:11",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:18:11"
          },
          {
            "ticket_id": 3286,
            "ticket_number": "353279",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "26/11/2025 16:18:12",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 16:18:13"
          },
          {
            "ticket_id": 3294,
            "ticket_number": "353287",
            "title": "Cancelamento de Reserva 208653",
            "priority": "P3",
            "created_at": "26/11/2025 16:30:26",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 17:58:54"
          },
          {
            "ticket_id": 3301,
            "ticket_number": "353294",
            "title": "NIF para fatura Smytravel  LOC1219922927",
            "priority": "P2",
            "created_at": "26/11/2025 18:09:35",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 18:09:36"
          },
          {
            "ticket_id": 3313,
            "ticket_number": "353306",
            "title": "RE: Opti 2416700003",
            "priority": "P2",
            "created_at": "26/11/2025 19:05:54",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:00:15"
          },
          {
            "ticket_id": 3320,
            "ticket_number": "353313",
            "title": "Re: Re: Documentos para reembolso viagem Açores",
            "priority": "P2",
            "created_at": "26/11/2025 19:31:54",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:20:16"
          },
          {
            "ticket_id": 3323,
            "ticket_number": "353316",
            "title": "Ato isolado  - Paula de Sousa",
            "priority": "P2",
            "created_at": "26/11/2025 21:07:03",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 21:07:03"
          },
          {
            "ticket_id": 3327,
            "ticket_number": "353320",
            "title": "Faturação - GBN-90437",
            "priority": "P2",
            "created_at": "26/11/2025 23:44:49",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:44:50"
          },
          {
            "ticket_id": 3330,
            "ticket_number": "353323",
            "title": "Comprovativos de pagamento -NewBlue - 6122601",
            "priority": "P2",
            "created_at": "26/11/2025 23:44:55",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:44:56"
          },
          {
            "ticket_id": 3331,
            "ticket_number": "353324",
            "title": "Comprovativo de pagamento - GBN-91284 - Sergio Alv",
            "priority": "P2",
            "created_at": "26/11/2025 23:44:57",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:44:58"
          },
          {
            "ticket_id": 3332,
            "ticket_number": "353325",
            "title": "Referencia para pagamento | File:412540/2025",
            "priority": "P2",
            "created_at": "26/11/2025 23:44:59",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 13:40:57"
          },
          {
            "ticket_id": 3334,
            "ticket_number": "353327",
            "title": "GBN-91511 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "26/11/2025 23:45:02",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 11.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 10:54:46"
          },
          {
            "ticket_id": 3336,
            "ticket_number": "353329",
            "title": "Referencia para pagamento | File:418537/2025",
            "priority": "P2",
            "created_at": "26/11/2025 23:45:06",
            "close_date": "2025-11-30",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 13:40:58"
          },
          {
            "ticket_id": 3339,
            "ticket_number": "353332",
            "title": "Devolução cliente",
            "priority": "P2",
            "created_at": "26/11/2025 23:47:50",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/11/2025 23:47:51"
          },
          {
            "ticket_id": 3343,
            "ticket_number": "353336",
            "title": "Emissão de recibo e comissões",
            "priority": "P3",
            "created_at": "27/11/2025 10:54:27",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 10:54:27"
          },
          {
            "ticket_id": 3351,
            "ticket_number": "353344",
            "title": "GBN-91907 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "27/11/2025 10:54:49",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 13:52:37"
          },
          {
            "ticket_id": 3353,
            "ticket_number": "353346",
            "title": "RE: Pagamento 6122706",
            "priority": "P3",
            "created_at": "27/11/2025 10:54:55",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 3.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 14:10:14"
          },
          {
            "ticket_id": 3354,
            "ticket_number": "353347",
            "title": "Confirmação de Reserva PAR * File 418537",
            "priority": "P1",
            "created_at": "27/11/2025 10:55:07",
            "close_date": "2025-11-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.92,
            "sla_met": false,
            "sla_breach_hours": 0.67,
            "sla_name": "SLA P1",
            "first_response_at": "27/11/2025 11:50:11"
          },
          {
            "ticket_id": 3355,
            "ticket_number": "353348",
            "title": "GBN-85066 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "27/11/2025 10:55:09",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 13:53:24"
          },
          {
            "ticket_id": 3356,
            "ticket_number": "353349",
            "title": "Emissão de Faturas ",
            "priority": "P3",
            "created_at": "27/11/2025 10:55:12",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 10:55:12"
          },
          {
            "ticket_id": 3362,
            "ticket_number": "353355",
            "title": "Booking payment confirmation by POS",
            "priority": "P3",
            "created_at": "27/11/2025 10:57:34",
            "close_date": "2025-11-27",
            "sla_target_hours": 24,
            "actual_time_hours": 3.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 14:10:31"
          },
          {
            "ticket_id": 3369,
            "ticket_number": "353362",
            "title": "Confirmação e Sinalização de Reserva 208883",
            "priority": "P2",
            "created_at": "27/11/2025 13:48:37",
            "close_date": "2025-11-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 17:41:29"
          },
          {
            "ticket_id": 3384,
            "ticket_number": "353377",
            "title": "Dados de acesso e pedido de pagamento das comissoe",
            "priority": "P3",
            "created_at": "27/11/2025 16:52:03",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 16:52:03"
          },
          {
            "ticket_id": 3387,
            "ticket_number": "353380",
            "title": "Levantamento comissões",
            "priority": "P3",
            "created_at": "27/11/2025 16:52:09",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 16:52:09"
          },
          {
            "ticket_id": 3388,
            "ticket_number": "353381",
            "title": "Confirmação de Reserva * File 418656*( Time Limit)",
            "priority": "P2",
            "created_at": "27/11/2025 16:52:21",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 20:41:53"
          },
          {
            "ticket_id": 3410,
            "ticket_number": "353403",
            "title": "IBAN Renata Ferreira",
            "priority": "P2",
            "created_at": "27/11/2025 22:18:32",
            "close_date": "2025-11-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/11/2025 22:18:32"
          },
          {
            "ticket_id": 3412,
            "ticket_number": "353405",
            "title": "Referencia para pagamento | File:418656/2025",
            "priority": "P1",
            "created_at": "27/11/2025 22:19:13",
            "close_date": "2025-11-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.9,
            "sla_met": false,
            "sla_breach_hours": 1.65,
            "sla_name": "SLA P1",
            "first_response_at": "28/11/2025 00:13:44"
          },
          {
            "ticket_id": 3420,
            "ticket_number": "353413",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P2",
            "created_at": "28/11/2025 10:03:06",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 14:02:49"
          },
          {
            "ticket_id": 3425,
            "ticket_number": "353418",
            "title": "Fatura - Comissoes",
            "priority": "P3",
            "created_at": "28/11/2025 10:03:16",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 10:03:17"
          },
          {
            "ticket_id": 3443,
            "ticket_number": "353436",
            "title": "RE: Pagamento 6122131",
            "priority": "P3",
            "created_at": "28/11/2025 11:22:13",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 13:06:39"
          },
          {
            "ticket_id": 3444,
            "ticket_number": "353437",
            "title": "RE: Pagamento 6120899",
            "priority": "P3",
            "created_at": "28/11/2025 11:22:15",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 13:06:52"
          },
          {
            "ticket_id": 3452,
            "ticket_number": "353445",
            "title": "comissões",
            "priority": "P3",
            "created_at": "28/11/2025 12:16:51",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 12:16:52"
          },
          {
            "ticket_id": 3457,
            "ticket_number": "353450",
            "title": "Re: Nova Viagem #251100291 - Benice Travel",
            "priority": "P3",
            "created_at": "28/11/2025 13:29:02",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 13:29:02"
          },
          {
            "ticket_id": 3467,
            "ticket_number": "353460",
            "title": "EMISSÃO Voos TP  ===SPT0025015483370  --- Mrs Patr",
            "priority": "P1",
            "created_at": "28/11/2025 13:29:53",
            "close_date": "2025-11-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.87,
            "sla_met": false,
            "sla_breach_hours": 0.62,
            "sla_name": "SLA P1",
            "first_response_at": "28/11/2025 14:22:41"
          },
          {
            "ticket_id": 3470,
            "ticket_number": "353463",
            "title": "Pagamento comissões Liliana PInto",
            "priority": "P3",
            "created_at": "28/11/2025 16:13:54",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 16:13:54"
          },
          {
            "ticket_id": 3475,
            "ticket_number": "353468",
            "title": "Criação de processo File 419153/25",
            "priority": "Reservas sem Formulário",
            "created_at": "28/11/2025 16:14:15",
            "close_date": "2025-11-30",
            "sla_target_hours": 24,
            "actual_time_hours": 44.72,
            "sla_met": false,
            "sla_breach_hours": 20.72,
            "sla_name": "SLA Padrão",
            "first_response_at": "30/11/2025 12:57:19"
          },
          {
            "ticket_id": 3484,
            "ticket_number": "353477",
            "title": "Fatura Ato Isolado - Luana Silvestre",
            "priority": "P2",
            "created_at": "28/11/2025 17:02:10",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 17:02:11"
          },
          {
            "ticket_id": 3485,
            "ticket_number": "353478",
            "title": "A/C CÁTIA LEAL - RECIBO: CONFIRMAR VALOR COMISSÃO ",
            "priority": "P2",
            "created_at": "28/11/2025 17:34:03",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 17:34:04"
          },
          {
            "ticket_id": 3487,
            "ticket_number": "353480",
            "title": "Fwd: Viagify informa sobre a sua reserva 122365348",
            "priority": "P3",
            "created_at": "28/11/2025 17:56:11",
            "close_date": "2025-11-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 17:56:12"
          },
          {
            "ticket_id": 3490,
            "ticket_number": "353483",
            "title": "recibo verde comissoes - informo que alterou o iba",
            "priority": "P2",
            "created_at": "28/11/2025 19:14:08",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 19:14:09"
          },
          {
            "ticket_id": 3494,
            "ticket_number": "353487",
            "title": "Envio de Comprovativo de conta",
            "priority": "P3",
            "created_at": "28/11/2025 19:14:48",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/11/2025 19:14:48"
          },
          {
            "ticket_id": 3507,
            "ticket_number": "353500",
            "title": "Cliente - Sérgio Duarte Da Silva Leal",
            "priority": "P2",
            "created_at": "28/11/2025 22:28:56",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 22:28:57"
          },
          {
            "ticket_id": 3532,
            "ticket_number": "353525",
            "title": "Pedido de Comissões",
            "priority": "P3",
            "created_at": "29/11/2025 16:34:41",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 16:34:41"
          },
          {
            "ticket_id": 3538,
            "ticket_number": "353531",
            "title": "Re: Comunicado comissões Smy - Voos e cruzeiros",
            "priority": "P3",
            "created_at": "29/11/2025 16:58:56",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/11/2025 16:58:56"
          },
          {
            "ticket_id": 3551,
            "ticket_number": "353544",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P1",
            "created_at": "30/11/2025 10:44:47",
            "close_date": "2025-11-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.93,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P1",
            "first_response_at": "30/11/2025 12:40:48"
          },
          {
            "ticket_id": 3552,
            "ticket_number": "353545",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P1",
            "created_at": "30/11/2025 10:44:49",
            "close_date": "2025-11-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.2,
            "sla_met": false,
            "sla_breach_hours": 1.95,
            "sla_name": "SLA P1",
            "first_response_at": "30/11/2025 12:57:42"
          },
          {
            "ticket_id": 3553,
            "ticket_number": "353546",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P1",
            "created_at": "30/11/2025 10:44:50",
            "close_date": "2025-12-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.92,
            "sla_met": false,
            "sla_breach_hours": 54.67,
            "sla_name": "SLA P1",
            "first_response_at": "02/12/2025 17:39:53"
          },
          {
            "ticket_id": 3574,
            "ticket_number": "353567",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3510779",
            "priority": "P2",
            "created_at": "30/11/2025 21:56:32",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 45.63,
            "sla_met": false,
            "sla_breach_hours": 41.63,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 19:35:27"
          },
          {
            "ticket_id": 3576,
            "ticket_number": "353569",
            "title": "Cancelamento - GBN-91004",
            "priority": "P3",
            "created_at": "30/11/2025 23:09:38",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/11/2025 23:09:39"
          },
          {
            "ticket_id": 3588,
            "ticket_number": "353581",
            "title": "900164028 // Prepaid reservations -3 days before c",
            "priority": "P3",
            "created_at": "01/12/2025 10:35:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 31.07,
            "sla_met": false,
            "sla_breach_hours": 7.07,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:39:15"
          },
          {
            "ticket_id": 3591,
            "ticket_number": "353584",
            "title": "In Sure Broker - Alerta de disponibilidade dos dad",
            "priority": "P3",
            "created_at": "01/12/2025 10:35:42",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 31.03,
            "sla_met": false,
            "sla_breach_hours": 7.03,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 17:38:23"
          },
          {
            "ticket_id": 3602,
            "ticket_number": "353595",
            "title": "GBN-85874 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/12/2025 12:32:52",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 12:27:49"
          },
          {
            "ticket_id": 3608,
            "ticket_number": "353601",
            "title": "Solole. Booking RSO3OXSG is close to entering expe",
            "priority": "P2",
            "created_at": "01/12/2025 14:10:31",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 27.45,
            "sla_met": false,
            "sla_breach_hours": 23.45,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:37:38"
          },
          {
            "ticket_id": 3612,
            "ticket_number": "353605",
            "title": "Comissão e viagem grupo",
            "priority": "P2",
            "created_at": "01/12/2025 16:44:27",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 16:44:28"
          },
          {
            "ticket_id": 3615,
            "ticket_number": "353608",
            "title": "A35047648 - IMPORTANTE - Civitatis - Ingresso dos ",
            "priority": "P2",
            "created_at": "01/12/2025 17:04:54",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 17:04:54"
          },
          {
            "ticket_id": 3639,
            "ticket_number": "353632",
            "title": "RE: Pagamento 6124097",
            "priority": "P3",
            "created_at": "02/12/2025 10:23:19",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 9.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:35:39"
          },
          {
            "ticket_id": 3647,
            "ticket_number": "353640",
            "title": "900164028 // Prepaid reservations -2 days before c",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:42",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:22:17"
          },
          {
            "ticket_id": 3648,
            "ticket_number": "353641",
            "title": "Faturação - Vitor Hugo Pereira da Costa - 24157000",
            "priority": "P2",
            "created_at": "02/12/2025 10:23:44",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:23:44"
          },
          {
            "ticket_id": 3652,
            "ticket_number": "353645",
            "title": "Número de informação da reserva: 6124521",
            "priority": "P3",
            "created_at": "02/12/2025 10:23:56",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 10:23:37"
          },
          {
            "ticket_id": 3653,
            "ticket_number": "353646",
            "title": "CONFIRMAÇÃO DE RESERVA",
            "priority": "P2",
            "created_at": "02/12/2025 10:24:03",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 10:24:14"
          },
          {
            "ticket_id": 3660,
            "ticket_number": "353653",
            "title": "Re:[## 26213 ##] GBN-85874 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "02/12/2025 11:11:29",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 12:35:16"
          },
          {
            "ticket_id": 3661,
            "ticket_number": "353654",
            "title": "Re:[## 26196 ##] GBN-91004 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/12/2025 11:11:31",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 13:27:42"
          },
          {
            "ticket_id": 3662,
            "ticket_number": "353655",
            "title": "Re: Pagamento 334997",
            "priority": "P1",
            "created_at": "02/12/2025 11:12:04",
            "close_date": "2025-12-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.63,
            "sla_met": false,
            "sla_breach_hours": 8.38,
            "sla_name": "SLA P1",
            "first_response_at": "02/12/2025 19:50:31"
          },
          {
            "ticket_id": 3665,
            "ticket_number": "353658",
            "title": "Cancelamento da Reserva W2M - 4CN446",
            "priority": "P2",
            "created_at": "02/12/2025 11:25:58",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 11:25:58"
          },
          {
            "ticket_id": 3667,
            "ticket_number": "353660",
            "title": "Re:[## 26162 ##] GBN-83789 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "02/12/2025 12:00:37",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 13:25:12"
          },
          {
            "ticket_id": 3669,
            "ticket_number": "353662",
            "title": "Re: Envio documentos",
            "priority": "P3",
            "created_at": "02/12/2025 12:01:24",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 12:01:24"
          },
          {
            "ticket_id": 3673,
            "ticket_number": "353666",
            "title": "Pagamento Final de Reserva - 332064",
            "priority": "P2",
            "created_at": "02/12/2025 13:02:28",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 4.53,
            "sla_met": false,
            "sla_breach_hours": 0.53,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:35:02"
          },
          {
            "ticket_id": 3674,
            "ticket_number": "353667",
            "title": "Pedido de Sinalização De Reserva 334863",
            "priority": "P2",
            "created_at": "02/12/2025 13:02:30",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 4.5,
            "sla_met": false,
            "sla_breach_hours": 0.5,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:33:00"
          },
          {
            "ticket_id": 3675,
            "ticket_number": "353668",
            "title": "Pedido de Sinalização De Reserva 334142",
            "priority": "P2",
            "created_at": "02/12/2025 13:02:31",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 76.55,
            "sla_met": false,
            "sla_breach_hours": 72.55,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 17:36:11"
          },
          {
            "ticket_id": 3676,
            "ticket_number": "353669",
            "title": "Pedido de Sinalização De Reserva 335024",
            "priority": "P2",
            "created_at": "02/12/2025 13:02:33",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 48.12,
            "sla_met": false,
            "sla_breach_hours": 44.12,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 13:09:42"
          },
          {
            "ticket_id": 3677,
            "ticket_number": "353670",
            "title": "Comissão",
            "priority": "P2",
            "created_at": "02/12/2025 13:02:35",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 13:02:35"
          },
          {
            "ticket_id": 3683,
            "ticket_number": "353675",
            "title": "RECIBO VERDE - OPTI 24800034",
            "priority": "P3",
            "created_at": "02/12/2025 13:50:13",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 13:50:13"
          },
          {
            "ticket_id": 3685,
            "ticket_number": "353677",
            "title": "CCP-74404 Fwd: Soltour.es - Localizador SPT0025015",
            "priority": "P3",
            "created_at": "02/12/2025 13:50:17",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 5.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 19:03:11"
          },
          {
            "ticket_id": 3691,
            "ticket_number": "353683",
            "title": "Solole. Booking RSO3OXSG is close to entering expe",
            "priority": "P2",
            "created_at": "02/12/2025 14:27:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 17:28:26"
          },
          {
            "ticket_id": 3699,
            "ticket_number": "353691",
            "title": "Comissão 12/2025",
            "priority": "P3",
            "created_at": "02/12/2025 16:09:46",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 16:09:46"
          },
          {
            "ticket_id": 3707,
            "ticket_number": "353699",
            "title": "w2m.travel: Cancelamento da Reserva com Ref. Nr.: ",
            "priority": "P3",
            "created_at": "02/12/2025 17:51:10",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 18:55:06"
          },
          {
            "ticket_id": 3727,
            "ticket_number": "353719",
            "title": "Confirmacao 335271",
            "priority": "P2",
            "created_at": "02/12/2025 21:27:48",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 11:23:54"
          },
          {
            "ticket_id": 3729,
            "ticket_number": "353721",
            "title": "A/C Cátia - Validação de comissões Novembro",
            "priority": "P2",
            "created_at": "02/12/2025 23:24:10",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 23:24:10"
          },
          {
            "ticket_id": 3730,
            "ticket_number": "353722",
            "title": "Emissão de fatura relativa a comissões",
            "priority": "P2",
            "created_at": "02/12/2025 23:24:11",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 23:24:11"
          },
          {
            "ticket_id": 3734,
            "ticket_number": "353726",
            "title": "Criação de processo File 420370/25",
            "priority": "P1",
            "created_at": "02/12/2025 23:45:21",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 10.53,
            "sla_met": false,
            "sla_breach_hours": 10.28,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 10:17:41"
          },
          {
            "ticket_id": 3738,
            "ticket_number": "353730",
            "title": "Referencia para pagamento | File:410790/2025",
            "priority": "P3",
            "created_at": "03/12/2025 10:05:09",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 176.83,
            "sla_met": false,
            "sla_breach_hours": 152.83,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 18:55:44"
          },
          {
            "ticket_id": 3739,
            "ticket_number": "353731",
            "title": "Referencia para pagamento | File:420365/2025",
            "priority": "P2",
            "created_at": "03/12/2025 10:05:10",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 14:04:05"
          },
          {
            "ticket_id": 3740,
            "ticket_number": "353732",
            "title": "Referencia para pagamento | File:410791/2025",
            "priority": "P3",
            "created_at": "03/12/2025 10:05:12",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 153.7,
            "sla_met": false,
            "sla_breach_hours": 129.7,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 19:47:37"
          },
          {
            "ticket_id": 3742,
            "ticket_number": "353734",
            "title": "Referencia para pagamento | File:420370/2025",
            "priority": "P1",
            "created_at": "03/12/2025 10:05:16",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.17,
            "sla_met": false,
            "sla_breach_hours": 0.92,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 11:15:55"
          },
          {
            "ticket_id": 3744,
            "ticket_number": "353736",
            "title": "Referencia para pagamento | File:420319/2025",
            "priority": "P2",
            "created_at": "03/12/2025 10:05:23",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 14:04:05"
          },
          {
            "ticket_id": 3748,
            "ticket_number": "353740",
            "title": "900164028 // Prepaid reservations -1 days before c",
            "priority": "P1",
            "created_at": "03/12/2025 10:05:36",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.05,
            "sla_met": false,
            "sla_breach_hours": 6.8,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 17:09:21"
          },
          {
            "ticket_id": 3751,
            "ticket_number": "353743",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3512141",
            "priority": "P3",
            "created_at": "03/12/2025 10:46:31",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 29.17,
            "sla_met": false,
            "sla_breach_hours": 5.17,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 15:57:06"
          },
          {
            "ticket_id": 3752,
            "ticket_number": "353744",
            "title": "Referencia para pagamento | File:419153/2025",
            "priority": "P1",
            "created_at": "03/12/2025 10:46:33",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.43,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 11:13:12"
          },
          {
            "ticket_id": 3753,
            "ticket_number": "353745",
            "title": "Reminder * Reserva File 419153 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "03/12/2025 10:46:34",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.43,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 11:13:25"
          },
          {
            "ticket_id": 3755,
            "ticket_number": "353747",
            "title": "Anulação de processo File 420370/25",
            "priority": "P1",
            "created_at": "03/12/2025 10:57:52",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.27,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 11:14:33"
          },
          {
            "ticket_id": 3756,
            "ticket_number": "353748",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P3",
            "created_at": "03/12/2025 11:01:05",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 11:07:58"
          },
          {
            "ticket_id": 3765,
            "ticket_number": "353757",
            "title": "comissao",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:45",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:19:46"
          },
          {
            "ticket_id": 3768,
            "ticket_number": "353760",
            "title": "COMISSÕES A RECEBER",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:52",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 13:19:52"
          },
          {
            "ticket_id": 3779,
            "ticket_number": "353771",
            "title": "Solole. Booking RSO3OXSG is close to entering expe",
            "priority": "P1",
            "created_at": "03/12/2025 14:23:31",
            "close_date": "2025-12-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.83,
            "sla_met": false,
            "sla_breach_hours": 2.58,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 17:13:42"
          },
          {
            "ticket_id": 3783,
            "ticket_number": "353775",
            "title": "Pedido de cancelamento de reserva Travelplan LOC 6",
            "priority": "P2",
            "created_at": "03/12/2025 14:23:43",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 14:23:43"
          },
          {
            "ticket_id": 3786,
            "ticket_number": "353778",
            "title": "Mudança de data | tour10",
            "priority": "P2",
            "created_at": "03/12/2025 15:06:32",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 15:06:32"
          },
          {
            "ticket_id": 3788,
            "ticket_number": "353780",
            "title": "Comissão",
            "priority": "P2",
            "created_at": "03/12/2025 15:06:39",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 15:06:40"
          },
          {
            "ticket_id": 3792,
            "ticket_number": "353784",
            "title": "Confirmação e Sinalização de Reserva 209286",
            "priority": "P1",
            "created_at": "03/12/2025 16:00:58",
            "close_date": "2025-12-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.45,
            "sla_met": false,
            "sla_breach_hours": 1.2,
            "sla_name": "SLA P1",
            "first_response_at": "03/12/2025 17:28:01"
          },
          {
            "ticket_id": 3793,
            "ticket_number": "353785",
            "title": "FW: EXCURSAO ALTERNATIVA - MSC opera - 25 maio 202",
            "priority": "P3",
            "created_at": "03/12/2025 16:11:45",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 12:02:51"
          },
          {
            "ticket_id": 3794,
            "ticket_number": "353786",
            "title": "Fwd: Nova Viagem #251200041 - Go Travel",
            "priority": "P2",
            "created_at": "03/12/2025 16:20:51",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:20:52"
          },
          {
            "ticket_id": 3795,
            "ticket_number": "353787",
            "title": "comissao",
            "priority": "P2",
            "created_at": "03/12/2025 16:27:16",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 16:27:16"
          },
          {
            "ticket_id": 3807,
            "ticket_number": "353799",
            "title": "FW: Excursoes Shore2Shore Portugal :: MSC OPERA 25",
            "priority": "P3",
            "created_at": "03/12/2025 17:42:17",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 189.9,
            "sla_met": false,
            "sla_breach_hours": 165.9,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 15:36:30"
          },
          {
            "ticket_id": 3819,
            "ticket_number": "353811",
            "title": "Comissões - dúvidas p/ emissão de ato único - A/C ",
            "priority": "P3",
            "created_at": "03/12/2025 19:57:02",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 19:57:02"
          },
          {
            "ticket_id": 3821,
            "ticket_number": "353813",
            "title": "Comissões - dúvidas p/ emissão de ato único - A/C ",
            "priority": "P3",
            "created_at": "03/12/2025 19:57:06",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 19:57:06"
          },
          {
            "ticket_id": 3823,
            "ticket_number": "353815",
            "title": "Recibos Verdes (Pagamento de Comissões)",
            "priority": "P3",
            "created_at": "03/12/2025 19:57:09",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 19:57:10"
          },
          {
            "ticket_id": 3832,
            "ticket_number": "353824",
            "title": "Confirmação de comissões",
            "priority": "P3",
            "created_at": "03/12/2025 21:04:23",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 21:04:23"
          },
          {
            "ticket_id": 3839,
            "ticket_number": "353831",
            "title": "Pedido de Comissões",
            "priority": "P2",
            "created_at": "03/12/2025 21:24:03",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 21:24:04"
          },
          {
            "ticket_id": 3840,
            "ticket_number": "353832",
            "title": "Referencia para pagamento | File:420474/2025",
            "priority": "P2",
            "created_at": "03/12/2025 22:25:09",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 12:21:06"
          },
          {
            "ticket_id": 3841,
            "ticket_number": "353833",
            "title": "Referencia para pagamento | File:420075/2025",
            "priority": "P2",
            "created_at": "03/12/2025 22:25:11",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 12:21:06"
          },
          {
            "ticket_id": 3843,
            "ticket_number": "353835",
            "title": "Dados de faturação para a viagem #251200030 - O mu",
            "priority": "P2",
            "created_at": "03/12/2025 23:28:04",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 23:28:04"
          },
          {
            "ticket_id": 3844,
            "ticket_number": "353836",
            "title": "Ao cuidado da Cátia -  Recibo para pagamento",
            "priority": "P2",
            "created_at": "03/12/2025 23:28:06",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 23:28:07"
          },
          {
            "ticket_id": 3850,
            "ticket_number": "353842",
            "title": "Emissão de recibo 2025",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:22",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:23"
          },
          {
            "ticket_id": 3862,
            "ticket_number": "353854",
            "title": "Recordatorio prepago reserva vencida : 1765140",
            "priority": "P1",
            "created_at": "04/12/2025 11:18:46",
            "close_date": "2025-12-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.15,
            "sla_met": false,
            "sla_breach_hours": 3.9,
            "sla_name": "SLA P1",
            "first_response_at": "04/12/2025 15:27:46"
          },
          {
            "ticket_id": 3870,
            "ticket_number": "353862",
            "title": "RE: Pagamento 1765140",
            "priority": "P3",
            "created_at": "04/12/2025 12:23:56",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 16:00:14"
          },
          {
            "ticket_id": 3873,
            "ticket_number": "353865",
            "title": "RE: Pagamento 1763586",
            "priority": "P3",
            "created_at": "04/12/2025 12:58:08",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 3.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 16:00:25"
          },
          {
            "ticket_id": 3878,
            "ticket_number": "353870",
            "title": "RE: Pagamento 96000437",
            "priority": "P3",
            "created_at": "04/12/2025 13:52:10",
            "close_date": "2025-12-04",
            "sla_target_hours": 24,
            "actual_time_hours": 2.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 16:00:37"
          },
          {
            "ticket_id": 3879,
            "ticket_number": "353871",
            "title": "Fatura-Recibo Comissões Inês Sobral",
            "priority": "P3",
            "created_at": "04/12/2025 13:56:58",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 13:56:58"
          },
          {
            "ticket_id": 3886,
            "ticket_number": "353878",
            "title": "Fatura de comissões - FR6",
            "priority": "P2",
            "created_at": "04/12/2025 16:04:27",
            "close_date": "2025-12-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 16:04:28"
          },
          {
            "ticket_id": 3893,
            "ticket_number": "353885",
            "title": "Booking payment confirmation by POS",
            "priority": "P3",
            "created_at": "04/12/2025 18:17:40",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 160.57,
            "sla_met": false,
            "sla_breach_hours": 136.57,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:52:31"
          },
          {
            "ticket_id": 3896,
            "ticket_number": "353888",
            "title": "Confirmação de reserva 335371",
            "priority": "P1",
            "created_at": "04/12/2025 18:34:11",
            "close_date": "2025-12-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.37,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P1",
            "first_response_at": "04/12/2025 18:56:53"
          },
          {
            "ticket_id": 3902,
            "ticket_number": "353894",
            "title": "Pedido de uma fatura",
            "priority": "P3",
            "created_at": "04/12/2025 19:39:32",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 19:39:32"
          },
          {
            "ticket_id": 3912,
            "ticket_number": "353904",
            "title": "Fatura Comissões",
            "priority": "P2",
            "created_at": "04/12/2025 21:50:33",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 21:50:33"
          },
          {
            "ticket_id": 3917,
            "ticket_number": "353909",
            "title": "RE: Pagamento 6124187",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:22",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 144.72,
            "sla_met": false,
            "sla_breach_hours": 120.72,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:52:24"
          },
          {
            "ticket_id": 3918,
            "ticket_number": "353910",
            "title": "RE: Pagamento 6122762",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:26",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 128.07,
            "sla_met": false,
            "sla_breach_hours": 104.07,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 18:13:37"
          },
          {
            "ticket_id": 3919,
            "ticket_number": "353911",
            "title": "RE: Pagamento 6124154",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:27",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 144.7,
            "sla_met": false,
            "sla_breach_hours": 120.7,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:52:16"
          },
          {
            "ticket_id": 3921,
            "ticket_number": "353913",
            "title": "Levantamento de comissões A/C Cátia",
            "priority": "P3",
            "created_at": "05/12/2025 10:09:31",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:09:32"
          },
          {
            "ticket_id": 3929,
            "ticket_number": "353921",
            "title": "Recibo verde mês de novembro",
            "priority": "P3",
            "created_at": "05/12/2025 10:34:38",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 10:34:38"
          },
          {
            "ticket_id": 3946,
            "ticket_number": "353938",
            "title": "Re: Faturas de adiantamento [#343221]",
            "priority": "P2",
            "created_at": "05/12/2025 13:19:10",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 141.53,
            "sla_met": false,
            "sla_breach_hours": 137.53,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 10:52:04"
          },
          {
            "ticket_id": 3951,
            "ticket_number": "353943",
            "title": "Fatura Deixa-te Levar Tours",
            "priority": "P2",
            "created_at": "05/12/2025 13:19:58",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 13:19:58"
          },
          {
            "ticket_id": 3961,
            "ticket_number": "353953",
            "title": "Booking payment confirmation by POS",
            "priority": "P3",
            "created_at": "05/12/2025 16:52:10",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 137.98,
            "sla_met": false,
            "sla_breach_hours": 113.98,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:51:38"
          },
          {
            "ticket_id": 3962,
            "ticket_number": "353954",
            "title": "emissão de faturas das optis 2422200011/2422200012",
            "priority": "P3",
            "created_at": "05/12/2025 16:52:44",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 16:52:44"
          },
          {
            "ticket_id": 3967,
            "ticket_number": "353959",
            "title": "URGENTE URGENTE Confirmação de reserva 335435### T",
            "priority": "P1",
            "created_at": "05/12/2025 17:52:44",
            "close_date": "2025-12-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/12/2025 18:03:45"
          },
          {
            "ticket_id": 3972,
            "ticket_number": "353964",
            "title": "Verificação de comissões para envio de recibo verd",
            "priority": "P2",
            "created_at": "05/12/2025 18:32:43",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 18:32:43"
          },
          {
            "ticket_id": 3980,
            "ticket_number": "353972",
            "title": "Levantamento de comissões A/C Cátia",
            "priority": "P3",
            "created_at": "05/12/2025 19:40:47",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 19:40:47"
          },
          {
            "ticket_id": 3983,
            "ticket_number": "353975",
            "title": "pedido reserva GBN-93725",
            "priority": "P2",
            "created_at": "05/12/2025 20:58:29",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/12/2025 20:58:30"
          },
          {
            "ticket_id": 3985,
            "ticket_number": "353977",
            "title": "Referencia para pagamento | File:410791/2025",
            "priority": "P2",
            "created_at": "05/12/2025 22:08:51",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 93.67,
            "sla_met": false,
            "sla_breach_hours": 89.67,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 19:48:57"
          },
          {
            "ticket_id": 4016,
            "ticket_number": "354008",
            "title": "Pagamento de reservas",
            "priority": "P2",
            "created_at": "07/12/2025 10:14:16",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/12/2025 10:14:17"
          },
          {
            "ticket_id": 4017,
            "ticket_number": "354009",
            "title": "Pagamento recibo Liliana Pinto",
            "priority": "P2",
            "created_at": "07/12/2025 10:14:20",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/12/2025 10:14:20"
          },
          {
            "ticket_id": 4025,
            "ticket_number": "354017",
            "title": "Solole. Booking NVMSBL4L is close to entering expe",
            "priority": "P2",
            "created_at": "07/12/2025 14:03:19",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 51.05,
            "sla_met": false,
            "sla_breach_hours": 47.05,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:06:31"
          },
          {
            "ticket_id": 4026,
            "ticket_number": "354018",
            "title": "Levantamento Comissões Dezembro - Mariana Alves",
            "priority": "P2",
            "created_at": "07/12/2025 15:34:35",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/12/2025 15:34:35"
          },
          {
            "ticket_id": 4029,
            "ticket_number": "354021",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60442",
            "priority": "P2",
            "created_at": "08/12/2025 10:10:03",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 30.95,
            "sla_met": false,
            "sla_breach_hours": 26.95,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:07:34"
          },
          {
            "ticket_id": 4032,
            "ticket_number": "354024",
            "title": "GBN-86362 - Your booking is still pending payment",
            "priority": "P2",
            "created_at": "08/12/2025 10:10:10",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 30.95,
            "sla_met": false,
            "sla_breach_hours": 26.95,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:08:09"
          },
          {
            "ticket_id": 4036,
            "ticket_number": "354028",
            "title": "Solole. Booking NVMSBL4L is close to entering expe",
            "priority": "P2",
            "created_at": "08/12/2025 14:03:03",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 27.08,
            "sla_met": false,
            "sla_breach_hours": 23.08,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:08:24"
          },
          {
            "ticket_id": 4042,
            "ticket_number": "354034",
            "title": "fatura-Comissáo UFEV",
            "priority": "P2",
            "created_at": "08/12/2025 17:14:17",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/12/2025 17:14:18"
          },
          {
            "ticket_id": 4043,
            "ticket_number": "354035",
            "title": "Fatura 1 pagamento",
            "priority": "P2",
            "created_at": "08/12/2025 17:14:21",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/12/2025 17:14:21"
          },
          {
            "ticket_id": 4045,
            "ticket_number": "354037",
            "title": "Referencia para pagamento | File:415146/2025",
            "priority": "P3",
            "created_at": "09/12/2025 10:25:53",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 10:44:49"
          },
          {
            "ticket_id": 4046,
            "ticket_number": "354038",
            "title": "Referencia para pagamento | File:415117/2025",
            "priority": "P3",
            "created_at": "09/12/2025 10:25:55",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 10:54:33"
          },
          {
            "ticket_id": 4049,
            "ticket_number": "354041",
            "title": "Referencia para pagamento | File:415145/2025",
            "priority": "P3",
            "created_at": "09/12/2025 10:25:59",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 9.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 19:43:47"
          },
          {
            "ticket_id": 4050,
            "ticket_number": "354042",
            "title": "Criação de processo File 421030/25",
            "priority": "P1",
            "created_at": "09/12/2025 10:26:05",
            "close_date": "2025-12-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.75,
            "sla_met": false,
            "sla_breach_hours": 6.5,
            "sla_name": "SLA P1",
            "first_response_at": "09/12/2025 17:11:37"
          },
          {
            "ticket_id": 4052,
            "ticket_number": "354044",
            "title": "Pedido de Comissões",
            "priority": "P2",
            "created_at": "09/12/2025 10:26:39",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 10:26:40"
          },
          {
            "ticket_id": 4053,
            "ticket_number": "354045",
            "title": "Re: Nova Viagem #251200081 - Joana Aires",
            "priority": "P3",
            "created_at": "09/12/2025 10:26:41",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 10:26:42"
          },
          {
            "ticket_id": 4056,
            "ticket_number": "354048",
            "title": "GBN-86362 - Your booking is still pending payment",
            "priority": "P3",
            "created_at": "09/12/2025 10:35:25",
            "close_date": "2025-12-09",
            "sla_target_hours": 24,
            "actual_time_hours": 6.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 17:12:02"
          },
          {
            "ticket_id": 4057,
            "ticket_number": "354049",
            "title": "Faturaçao - OPTI 2416400005",
            "priority": "P3",
            "created_at": "09/12/2025 10:35:59",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 10:35:59"
          },
          {
            "ticket_id": 4074,
            "ticket_number": "354066",
            "title": "Pedido de Sinalização De Reserva 335294",
            "priority": "P2",
            "created_at": "09/12/2025 12:06:08",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 16:00:56"
          },
          {
            "ticket_id": 4077,
            "ticket_number": "354069",
            "title": "Envio documentos - (Recibo de Adiantamento-2310011",
            "priority": "P2",
            "created_at": "09/12/2025 13:08:43",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:01:07"
          },
          {
            "ticket_id": 4079,
            "ticket_number": "354071",
            "title": "OPTIGEST | Ticket #343330 | Ticket Criado / Ticket",
            "priority": "P2",
            "created_at": "09/12/2025 13:10:56",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:01:07"
          },
          {
            "ticket_id": 4080,
            "ticket_number": "354072",
            "title": "Fwd: Novo Reforço de Pagamento - Viagem #604450302",
            "priority": "P2",
            "created_at": "09/12/2025 13:11:29",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 13:11:30"
          },
          {
            "ticket_id": 4084,
            "ticket_number": "354076",
            "title": "FW: Fatura de comissões - FR6 e FR7",
            "priority": "P2",
            "created_at": "09/12/2025 13:41:27",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 13:41:28"
          },
          {
            "ticket_id": 4085,
            "ticket_number": "354077",
            "title": "Solole. Booking NVMSBL4L is close to entering expe",
            "priority": "P2",
            "created_at": "09/12/2025 14:02:48",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:02:35"
          },
          {
            "ticket_id": 4086,
            "ticket_number": "354078",
            "title": "Solole. Booking QNYP52TM is close to entering expe",
            "priority": "P2",
            "created_at": "09/12/2025 14:02:50",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 17:02:13"
          },
          {
            "ticket_id": 4097,
            "ticket_number": "354089",
            "title": "Re: Notas de crédito [#343330]",
            "priority": "P2",
            "created_at": "09/12/2025 16:33:13",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 20:21:32"
          },
          {
            "ticket_id": 4103,
            "ticket_number": "354095",
            "title": "Pagamento Comissões",
            "priority": "P3",
            "created_at": "09/12/2025 18:48:16",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 18:48:16"
          },
          {
            "ticket_id": 4114,
            "ticket_number": "354106",
            "title": "Referencia para pagamento | File:420983/2025",
            "priority": "P3",
            "created_at": "09/12/2025 22:12:07",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 22:14:12"
          },
          {
            "ticket_id": 4115,
            "ticket_number": "354107",
            "title": "Referencia para pagamento | File:421030/2025",
            "priority": "P1",
            "created_at": "09/12/2025 22:12:08",
            "close_date": "2025-12-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/12/2025 22:17:08"
          },
          {
            "ticket_id": 4118,
            "ticket_number": "354110",
            "title": "Recibo Comissoes",
            "priority": "P3",
            "created_at": "09/12/2025 22:26:25",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 22:26:25"
          },
          {
            "ticket_id": 4122,
            "ticket_number": "354114",
            "title": "Comissão | Maria Fontes",
            "priority": "P3",
            "created_at": "09/12/2025 22:37:55",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/12/2025 22:37:55"
          },
          {
            "ticket_id": 4123,
            "ticket_number": "354115",
            "title": "Re: Pedido de Envio RGPD",
            "priority": "P2",
            "created_at": "09/12/2025 23:23:29",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 23:23:29"
          },
          {
            "ticket_id": 4124,
            "ticket_number": "354116",
            "title": "Ato isolado 2025",
            "priority": "P2",
            "created_at": "09/12/2025 23:32:48",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 23:32:49"
          },
          {
            "ticket_id": 4127,
            "ticket_number": "354119",
            "title": "Fatura-recibo- pagamento de comissões",
            "priority": "P2",
            "created_at": "10/12/2025 10:01:48",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 10:01:49"
          },
          {
            "ticket_id": 4137,
            "ticket_number": "354129",
            "title": "Referencia para pagamento | File:420983/2025",
            "priority": "P1",
            "created_at": "10/12/2025 10:51:57",
            "close_date": "2025-12-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.68,
            "sla_met": false,
            "sla_breach_hours": 0.43,
            "sla_name": "SLA P1",
            "first_response_at": "10/12/2025 11:33:28"
          },
          {
            "ticket_id": 4142,
            "ticket_number": "354134",
            "title": "RE: Pagamento 6124339",
            "priority": "P3",
            "created_at": "10/12/2025 11:20:28",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 23.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 10:50:40"
          },
          {
            "ticket_id": 4146,
            "ticket_number": "354138",
            "title": "Novo Reforço de Pagamento - Viagem #PNR DXP72C / Y",
            "priority": "P2",
            "created_at": "10/12/2025 11:20:39",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 11:20:39"
          },
          {
            "ticket_id": 4147,
            "ticket_number": "354139",
            "title": "RE: Novo Reforço de Pagamento - Viagem #PNR DXP72C",
            "priority": "P3",
            "created_at": "10/12/2025 12:07:04",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 12:07:05"
          },
          {
            "ticket_id": 4165,
            "ticket_number": "354157",
            "title": "Solole. Booking QNYP52TM is close to entering expe",
            "priority": "P3",
            "created_at": "10/12/2025 14:48:19",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 18:35:46"
          },
          {
            "ticket_id": 4176,
            "ticket_number": "354168",
            "title": "Comissões",
            "priority": "P3",
            "created_at": "10/12/2025 17:28:43",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 17:28:44"
          },
          {
            "ticket_id": 4185,
            "ticket_number": "354177",
            "title": "Valor comissão GBN  65520 pendentes",
            "priority": "P3",
            "created_at": "10/12/2025 18:01:25",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 18:01:25"
          },
          {
            "ticket_id": 4203,
            "ticket_number": "354195",
            "title": "Valor das comissões",
            "priority": "P2",
            "created_at": "10/12/2025 21:06:42",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 21:06:42"
          },
          {
            "ticket_id": 4208,
            "ticket_number": "354200",
            "title": "calculo comissoes",
            "priority": "P2",
            "created_at": "10/12/2025 23:37:18",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 23:37:18"
          },
          {
            "ticket_id": 4211,
            "ticket_number": "354203",
            "title": "IBAN",
            "priority": "P2",
            "created_at": "11/12/2025 00:08:15",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 00:08:15"
          },
          {
            "ticket_id": 4223,
            "ticket_number": "354215",
            "title": "Ato Isolado",
            "priority": "P3",
            "created_at": "11/12/2025 11:47:44",
            "close_date": "2025-12-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 11:47:44"
          },
          {
            "ticket_id": 4225,
            "ticket_number": "354217",
            "title": "Comprovativo Transação  - reserva 2445, alteracao",
            "priority": "P3",
            "created_at": "11/12/2025 12:39:52",
            "close_date": "2025-12-11",
            "sla_target_hours": 24,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 15:35:41"
          },
          {
            "ticket_id": 4234,
            "ticket_number": "354226",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "11/12/2025 17:37:23",
            "close_date": "2025-12-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.52,
            "sla_met": false,
            "sla_breach_hours": 0.27,
            "sla_name": "SLA P1",
            "first_response_at": "11/12/2025 18:09:07"
          },
          {
            "ticket_id": 4241,
            "ticket_number": "354233",
            "title": "GBN-75128 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "11/12/2025 18:33:25",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 17.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 12:12:48"
          },
          {
            "ticket_id": 4248,
            "ticket_number": "354240",
            "title": "Recibo Verde e Comprovativo de NIB",
            "priority": "P2",
            "created_at": "11/12/2025 19:54:44",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 19:54:44"
          },
          {
            "ticket_id": 4251,
            "ticket_number": "354243",
            "title": "Localizadores :: Recibo 2025",
            "priority": "P2",
            "created_at": "11/12/2025 21:21:23",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 21:21:24"
          },
          {
            "ticket_id": 4255,
            "ticket_number": "354247",
            "title": "GBN-75128 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "12/12/2025 00:03:11",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 12.15,
            "sla_met": false,
            "sla_breach_hours": 8.15,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 12:12:31"
          },
          {
            "ticket_id": 4257,
            "ticket_number": "354249",
            "title": "Recibos levantamento comissões já confirmadas",
            "priority": "P3",
            "created_at": "12/12/2025 10:06:28",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:06:29"
          },
          {
            "ticket_id": 4259,
            "ticket_number": "354251",
            "title": "Levantamento de comissões Opti 247500028",
            "priority": "P3",
            "created_at": "12/12/2025 10:06:33",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:06:33"
          },
          {
            "ticket_id": 4260,
            "ticket_number": "354252",
            "title": "Pagamento Comissões - ATT Cátia Leal",
            "priority": "P3",
            "created_at": "12/12/2025 10:06:36",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:06:36"
          },
          {
            "ticket_id": 4266,
            "ticket_number": "354258",
            "title": "Atividade cancelada: Excursão a Pisa, San Gimignan",
            "priority": "P3",
            "created_at": "12/12/2025 10:28:33",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:42:30"
          },
          {
            "ticket_id": 4274,
            "ticket_number": "354266",
            "title": "Faturas",
            "priority": "P3",
            "created_at": "12/12/2025 11:28:22",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 11:28:22"
          },
          {
            "ticket_id": 4275,
            "ticket_number": "354267",
            "title": "RECIBO VERDE DANIELA CRUZ",
            "priority": "P3",
            "created_at": "12/12/2025 11:28:24",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 11:28:25"
          },
          {
            "ticket_id": 4281,
            "ticket_number": "354273",
            "title": "Re:[## 27130 ##] GBN-85535 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/12/2025 12:19:02",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 13:22:18"
          },
          {
            "ticket_id": 4295,
            "ticket_number": "354287",
            "title": "Pagamento comissão Localizador 1218666447",
            "priority": "P3",
            "created_at": "12/12/2025 14:11:21",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 14:11:21"
          },
          {
            "ticket_id": 4296,
            "ticket_number": "354288",
            "title": "Pagamento comissão",
            "priority": "P3",
            "created_at": "12/12/2025 14:11:23",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 14:11:23"
          },
          {
            "ticket_id": 4298,
            "ticket_number": "354290",
            "title": "Pagamento comissão Localizador 1128861115",
            "priority": "P3",
            "created_at": "12/12/2025 14:11:27",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 14:11:27"
          },
          {
            "ticket_id": 4306,
            "ticket_number": "354298",
            "title": "Recibo Localizadores 604456534 e GBN 80113 80114",
            "priority": "P3",
            "created_at": "12/12/2025 16:10:23",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 16:10:24"
          },
          {
            "ticket_id": 4310,
            "ticket_number": "354302",
            "title": "Pagamento comissão Localizador 1116716966",
            "priority": "P3",
            "created_at": "12/12/2025 17:26:56",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 17:26:56"
          },
          {
            "ticket_id": 4311,
            "ticket_number": "354303",
            "title": "Fatura pendente",
            "priority": "P1",
            "created_at": "12/12/2025 17:26:58",
            "close_date": "2025-12-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 65.72,
            "sla_met": false,
            "sla_breach_hours": 65.47,
            "sla_name": "SLA P1",
            "first_response_at": "15/12/2025 11:10:14"
          },
          {
            "ticket_id": 4313,
            "ticket_number": "354305",
            "title": "Comissões- Localizadores",
            "priority": "P3",
            "created_at": "12/12/2025 17:50:26",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 17:50:26"
          },
          {
            "ticket_id": 4329,
            "ticket_number": "354321",
            "title": "Preenchimento do recibo verde",
            "priority": "P2",
            "created_at": "12/12/2025 19:50:15",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 19:50:15"
          },
          {
            "ticket_id": 4333,
            "ticket_number": "354325",
            "title": "Faturar valor pago referente as optis 2410000009, ",
            "priority": "P2",
            "created_at": "12/12/2025 23:47:30",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 23:47:30"
          },
          {
            "ticket_id": 4337,
            "ticket_number": "354329",
            "title": "Comissões ",
            "priority": "P2",
            "created_at": "13/12/2025 11:14:08",
            "close_date": "2025-12-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 11:14:09"
          },
          {
            "ticket_id": 4339,
            "ticket_number": "354331",
            "title": "GBN-87503 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "13/12/2025 11:14:17",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 47.9,
            "sla_met": false,
            "sla_breach_hours": 43.9,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 11:09:09"
          },
          {
            "ticket_id": 4358,
            "ticket_number": "354350",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P3",
            "created_at": "14/12/2025 10:01:28",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 25.1,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 11:08:22"
          },
          {
            "ticket_id": 4363,
            "ticket_number": "354355",
            "title": "Comprovativo de IBAN",
            "priority": "P3",
            "created_at": "14/12/2025 10:01:47",
            "close_date": "2025-12-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/12/2025 10:01:47"
          },
          {
            "ticket_id": 4388,
            "ticket_number": "354380",
            "title": "GBN-93850 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:22",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 11:04:07"
          },
          {
            "ticket_id": 4389,
            "ticket_number": "354381",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:25",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 11:03:03"
          },
          {
            "ticket_id": 1883,
            "ticket_number": "351880",
            "title": "Re:[## 24012 ##] GBN-84526 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "05/11/2025 17:19:39",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/10/2025 23:52:21"
          },
          {
            "ticket_id": 2606,
            "ticket_number": "352601",
            "title": "Re: Urgente: Emissão de Recibos Verdes 2025",
            "priority": "P2",
            "created_at": "17/11/2025 14:02:08",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 14:02:09"
          },
          {
            "ticket_id": 3207,
            "ticket_number": "353200",
            "title": "Civitatis - Re: Reclamación (A34622562) - Excursão",
            "priority": "P3",
            "created_at": "25/11/2025 18:22:42",
            "close_date": "2025-11-28",
            "sla_target_hours": 24,
            "actual_time_hours": 16.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 10:39:36"
          },
          {
            "ticket_id": 3307,
            "ticket_number": "353300",
            "title": "Criação de processo File 418537/25",
            "priority": "P3",
            "created_at": "26/11/2025 18:10:40",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 18.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 12:13:58"
          },
          {
            "ticket_id": 3502,
            "ticket_number": "353495",
            "title": "Fatura - Ato Isolado - Comissões 2025",
            "priority": "P2",
            "created_at": "28/11/2025 21:05:57",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/11/2025 21:05:57"
          },
          {
            "ticket_id": 3599,
            "ticket_number": "353592",
            "title": "Reclamação LePlan 604469673",
            "priority": "P2",
            "created_at": "01/12/2025 12:26:22",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 12:26:22"
          },
          {
            "ticket_id": 3643,
            "ticket_number": "353636",
            "title": "Fwd: A sua reserva continua CONFIRMADA — tentativa",
            "priority": "P3",
            "created_at": "02/12/2025 10:23:31",
            "close_date": "2025-12-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 10:23:22"
          },
          {
            "ticket_id": 3710,
            "ticket_number": "353702",
            "title": "COMISSÕES OPTI 2422200003/OPTI -2422200004/OPTI -2",
            "priority": "P3",
            "created_at": "02/12/2025 18:01:23",
            "close_date": "2025-12-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 18:01:23"
          },
          {
            "ticket_id": 3885,
            "ticket_number": "353877",
            "title": "Recibos verdes",
            "priority": "P2",
            "created_at": "04/12/2025 16:04:24",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/12/2025 16:04:24"
          },
          {
            "ticket_id": 3916,
            "ticket_number": "353908",
            "title": "Recibo Verde",
            "priority": "P3",
            "created_at": "05/12/2025 10:08:47",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 195.05,
            "sla_met": false,
            "sla_breach_hours": 171.05,
            "sla_name": "SLA P3",
            "first_response_at": "13/12/2025 13:12:10"
          },
          {
            "ticket_id": 4044,
            "ticket_number": "354036",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P2",
            "created_at": "09/12/2025 10:25:52",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 14:20:46"
          },
          {
            "ticket_id": 4126,
            "ticket_number": "354118",
            "title": "Levantamento de comissões",
            "priority": "P2",
            "created_at": "10/12/2025 10:01:46",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 10:01:46"
          },
          {
            "ticket_id": 4158,
            "ticket_number": "354150",
            "title": "Acto isolado de comissões",
            "priority": "P3",
            "created_at": "10/12/2025 13:18:51",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 13:18:52"
          },
          {
            "ticket_id": 4171,
            "ticket_number": "354163",
            "title": "Re:[## 26959 ##] GBN-65878 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "10/12/2025 16:18:01",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 12:38:04"
          },
          {
            "ticket_id": 4207,
            "ticket_number": "354199",
            "title": "Confirmação valor comissões",
            "priority": "P2",
            "created_at": "10/12/2025 23:00:44",
            "close_date": "2025-12-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 23:00:44"
          },
          {
            "ticket_id": 4209,
            "ticket_number": "354201",
            "title": "Faturas comissões",
            "priority": "P2",
            "created_at": "10/12/2025 23:37:20",
            "close_date": "2025-12-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 23:37:21"
          },
          {
            "ticket_id": 4219,
            "ticket_number": "354211",
            "title": "ato isolado das comissões referentes a 2025",
            "priority": "P3",
            "created_at": "11/12/2025 11:24:50",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 11:24:51"
          },
          {
            "ticket_id": 4243,
            "ticket_number": "354235",
            "title": "Processamento de comissões",
            "priority": "P3",
            "created_at": "11/12/2025 18:33:30",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/12/2025 18:33:31"
          },
          {
            "ticket_id": 4254,
            "ticket_number": "354246",
            "title": "Confirmação de valor para emissão de recibo",
            "priority": "P2",
            "created_at": "11/12/2025 23:09:51",
            "close_date": "2025-12-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/12/2025 23:09:52"
          },
          {
            "ticket_id": 4258,
            "ticket_number": "354250",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P3",
            "created_at": "12/12/2025 10:06:31",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 250.23,
            "sla_met": false,
            "sla_breach_hours": 226.23,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 20:20:39"
          },
          {
            "ticket_id": 4318,
            "ticket_number": "354310",
            "title": "Booking payment confirmation by POS",
            "priority": "P3",
            "created_at": "12/12/2025 18:34:54",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 66.55,
            "sla_met": false,
            "sla_breach_hours": 42.55,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 13:08:19"
          },
          {
            "ticket_id": 4322,
            "ticket_number": "354314",
            "title": "Ato isolado",
            "priority": "P3",
            "created_at": "12/12/2025 18:35:28",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 18:35:30"
          },
          {
            "ticket_id": 4325,
            "ticket_number": "354317",
            "title": "Recibo comissões",
            "priority": "P3",
            "created_at": "12/12/2025 18:43:23",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 18:43:24"
          },
          {
            "ticket_id": 4330,
            "ticket_number": "354322",
            "title": "RESERVA URGENTE 14 - 15 Diciembre",
            "priority": "P3",
            "created_at": "12/12/2025 19:58:55",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 15.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/12/2025 11:14:07"
          },
          {
            "ticket_id": 4334,
            "ticket_number": "354326",
            "title": "Pagamento comissões Rita Santos",
            "priority": "P2",
            "created_at": "12/12/2025 23:53:23",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/12/2025 23:53:23"
          },
          {
            "ticket_id": 4342,
            "ticket_number": "354334",
            "title": "RECIBO VERDE PARA LEVANTAMENTO DE COMISSÕES / COMP",
            "priority": "P2",
            "created_at": "13/12/2025 11:14:23",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/12/2025 11:14:24"
          },
          {
            "ticket_id": 4357,
            "ticket_number": "354349",
            "title": "Referencia para pagamento | File:421441/2025",
            "priority": "P2",
            "created_at": "14/12/2025 10:01:26",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 32.43,
            "sla_met": false,
            "sla_breach_hours": 28.43,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:27:55"
          },
          {
            "ticket_id": 4364,
            "ticket_number": "354356",
            "title": "Fwd: Comprovativo Transação - viagem pedro bandeir",
            "priority": "P3",
            "created_at": "14/12/2025 10:01:50",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 27.1,
            "sla_met": false,
            "sla_breach_hours": 3.1,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 13:08:39"
          },
          {
            "ticket_id": 4365,
            "ticket_number": "354357",
            "title": "GBN-87503 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "14/12/2025 10:01:54",
            "close_date": "2025-12-16",
            "sla_target_hours": 4,
            "actual_time_hours": 54.92,
            "sla_met": false,
            "sla_breach_hours": 50.92,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 16:56:58"
          },
          {
            "ticket_id": 4366,
            "ticket_number": "354358",
            "title": "Armanda Martins Unipessoal, Lda. enviou-lhe um doc",
            "priority": "P2",
            "created_at": "14/12/2025 10:01:56",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 79.68,
            "sla_met": false,
            "sla_breach_hours": 75.68,
            "sla_name": "SLA P2",
            "first_response_at": "17/12/2025 17:43:03"
          },
          {
            "ticket_id": 4377,
            "ticket_number": "354369",
            "title": "Recebi verde",
            "priority": "P2",
            "created_at": "14/12/2025 18:15:28",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/12/2025 18:15:29"
          },
          {
            "ticket_id": 4390,
            "ticket_number": "354382",
            "title": "Envio de fatura-recibo das comissões",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:27",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:11:27"
          },
          {
            "ticket_id": 4391,
            "ticket_number": "354383",
            "title": "Validação valores a pagamento 2025",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:29",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:11:29"
          },
          {
            "ticket_id": 4395,
            "ticket_number": "354387",
            "title": "Envio de fatura",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:41",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:11:41"
          },
          {
            "ticket_id": 4396,
            "ticket_number": "354388",
            "title": "Comissões",
            "priority": "P3",
            "created_at": "15/12/2025 10:11:44",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 10:11:44"
          },
          {
            "ticket_id": 4409,
            "ticket_number": "354401",
            "title": "Re: Novo Reforço de Pagamento - Viagem #PNR DXP72C",
            "priority": "P2",
            "created_at": "15/12/2025 11:55:34",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 11:55:35"
          },
          {
            "ticket_id": 4415,
            "ticket_number": "354407",
            "title": "Recibos verdes",
            "priority": "P2",
            "created_at": "15/12/2025 12:40:55",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 12:40:56"
          },
          {
            "ticket_id": 4425,
            "ticket_number": "354417",
            "title": "NIF para fatura Solférias LOC 250900130",
            "priority": "P2",
            "created_at": "15/12/2025 13:50:20",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:50:20"
          },
          {
            "ticket_id": 4426,
            "ticket_number": "354418",
            "title": "As suas comissões já estão disponíveis na wallet",
            "priority": "P2",
            "created_at": "15/12/2025 13:50:54",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 17:41:44"
          },
          {
            "ticket_id": 4427,
            "ticket_number": "354419",
            "title": "Re: Fwd: [## 14752 ##] GBN-61170 - Seu pedido foi ",
            "priority": "P2",
            "created_at": "15/12/2025 13:50:56",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:50:56"
          },
          {
            "ticket_id": 4429,
            "ticket_number": "354421",
            "title": "COMISSÕES OPTI 2422200013",
            "priority": "P2",
            "created_at": "15/12/2025 13:51:02",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:51:02"
          },
          {
            "ticket_id": 4430,
            "ticket_number": "354422",
            "title": "Envio de Documentação Cuba * File 412540",
            "priority": "P3",
            "created_at": "15/12/2025 13:51:09",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 13:55:02"
          },
          {
            "ticket_id": 4431,
            "ticket_number": "354423",
            "title": "comissoes optis: 2422200014/ 2422200011/ 242220001",
            "priority": "P2",
            "created_at": "15/12/2025 13:51:43",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:51:43"
          },
          {
            "ticket_id": 4433,
            "ticket_number": "354425",
            "title": "NIF para Fatura Solférias LOC 250900128",
            "priority": "P2",
            "created_at": "15/12/2025 13:52:18",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 13:52:18"
          },
          {
            "ticket_id": 4436,
            "ticket_number": "354428",
            "title": "Confirmaçao de Formularios ",
            "priority": "P3",
            "created_at": "15/12/2025 15:13:59",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/12/2025 15:14:00"
          },
          {
            "ticket_id": 4439,
            "ticket_number": "354431",
            "title": "Comissões viagens - fatura",
            "priority": "P3",
            "created_at": "15/12/2025 15:43:55",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 70.65,
            "sla_met": false,
            "sla_breach_hours": 46.65,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 14:23:16"
          },
          {
            "ticket_id": 4459,
            "ticket_number": "354451",
            "title": "Re: Nova Viagem #251200152 - Patrícia Trabulo Viag",
            "priority": "P2",
            "created_at": "15/12/2025 19:08:35",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 19:08:36"
          },
          {
            "ticket_id": 4461,
            "ticket_number": "354453",
            "title": "Comissão",
            "priority": "P2",
            "created_at": "15/12/2025 19:37:50",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 19:37:51"
          },
          {
            "ticket_id": 4462,
            "ticket_number": "354454",
            "title": "Comissão",
            "priority": "P2",
            "created_at": "15/12/2025 19:37:53",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 19:37:53"
          },
          {
            "ticket_id": 4466,
            "ticket_number": "354458",
            "title": "Erro emissão de fatura - OPTI 2412000026",
            "priority": "P2",
            "created_at": "15/12/2025 21:41:34",
            "close_date": "2025-12-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 21:41:34"
          },
          {
            "ticket_id": 4467,
            "ticket_number": "354459",
            "title": "Comissões - Localizadores para emissão de recibo v",
            "priority": "P2",
            "created_at": "15/12/2025 21:58:07",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 21:58:08"
          },
          {
            "ticket_id": 4475,
            "ticket_number": "354467",
            "title": "Fatura comissão OPTI nº 2412000025",
            "priority": "P2",
            "created_at": "15/12/2025 22:39:37",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 22:39:38"
          },
          {
            "ticket_id": 4483,
            "ticket_number": "354475",
            "title": "Recibo 2025",
            "priority": "P2",
            "created_at": "16/12/2025 10:17:08",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 10:17:09"
          },
          {
            "ticket_id": 4484,
            "ticket_number": "354476",
            "title": "Mapa de Comissões – Viagem por realizar em Dez/25",
            "priority": "P2",
            "created_at": "16/12/2025 10:17:11",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 10:17:11"
          },
          {
            "ticket_id": 4492,
            "ticket_number": "354484",
            "title": "Information about your recent invoices, UMA FAMILI",
            "priority": "P2",
            "created_at": "16/12/2025 11:29:35",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 12:16:24"
          },
          {
            "ticket_id": 4501,
            "ticket_number": "354493",
            "title": "Pedido de Reembolso - Cláudio Cunha",
            "priority": "P3",
            "created_at": "16/12/2025 15:41:51",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 15:41:51"
          },
          {
            "ticket_id": 4506,
            "ticket_number": "354498",
            "title": "Fwd: FW: Pedido de faturas",
            "priority": "P3",
            "created_at": "16/12/2025 17:13:57",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/12/2025 17:13:58"
          },
          {
            "ticket_id": 4517,
            "ticket_number": "354509",
            "title": "Envio de Recibo de comissionista para pagamentos d",
            "priority": "P2",
            "created_at": "16/12/2025 23:22:50",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 23:22:51"
          },
          {
            "ticket_id": 4518,
            "ticket_number": "354510",
            "title": "A/C Cátia - Validação de comissões Dezembro",
            "priority": "P2",
            "created_at": "16/12/2025 23:57:38",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/12/2025 23:57:39"
          },
          {
            "ticket_id": 4521,
            "ticket_number": "354513",
            "title": "🔴Pagamento liquidação Natal",
            "priority": "P3",
            "created_at": "17/12/2025 10:07:40",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 11:16:49"
          },
          {
            "ticket_id": 4523,
            "ticket_number": "354515",
            "title": "GBN-83747 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "17/12/2025 10:07:43",
            "close_date": "2025-12-17",
            "sla_target_hours": 24,
            "actual_time_hours": 8.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 18:15:09"
          },
          {
            "ticket_id": 4524,
            "ticket_number": "354516",
            "title": "Comissões",
            "priority": "P3",
            "created_at": "17/12/2025 10:07:45",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 10:07:46"
          },
          {
            "ticket_id": 4525,
            "ticket_number": "354517",
            "title": "Confirmação comissões A/C Cátia",
            "priority": "P3",
            "created_at": "17/12/2025 10:07:47",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 10:07:48"
          },
          {
            "ticket_id": 4528,
            "ticket_number": "354520",
            "title": "RECIBO VERDE DANIELA CRUZ -9",
            "priority": "P3",
            "created_at": "17/12/2025 10:25:28",
            "close_date": "2025-12-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 10:25:28"
          },
          {
            "ticket_id": 4529,
            "ticket_number": "354521",
            "title": "Automatic reply: [OUTSIDE EMAIL] Re: Pagamento 351",
            "priority": "P3",
            "created_at": "17/12/2025 11:05:30",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 24.03,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 11:08:01"
          },
          {
            "ticket_id": 4530,
            "ticket_number": "354522",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3518704",
            "priority": "P3",
            "created_at": "17/12/2025 11:05:32",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 24.03,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 11:07:44"
          },
          {
            "ticket_id": 4534,
            "ticket_number": "354526",
            "title": "Ato Isolado - Localizadores",
            "priority": "P3",
            "created_at": "17/12/2025 11:53:28",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 11:53:28"
          },
          {
            "ticket_id": 4542,
            "ticket_number": "354534",
            "title": "Dados para pagamento de comissões A/C Cátia Leal",
            "priority": "P3",
            "created_at": "17/12/2025 13:11:40",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:11:41"
          },
          {
            "ticket_id": 4546,
            "ticket_number": "354538",
            "title": "Emissão de Recibos Verdes 2025",
            "priority": "P3",
            "created_at": "17/12/2025 13:53:59",
            "close_date": "2025-12-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/12/2025 13:54:00"
          },
          {
            "ticket_id": 4565,
            "ticket_number": "354557",
            "title": "emissao de fatura Rui Maia",
            "priority": "P2",
            "created_at": "17/12/2025 21:04:00",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 14.45,
            "sla_met": false,
            "sla_breach_hours": 10.45,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 11:31:53"
          },
          {
            "ticket_id": 4569,
            "ticket_number": "354561",
            "title": "Recibo verde de comissão ",
            "priority": "P3",
            "created_at": "18/12/2025 10:06:02",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/12/2025 10:06:03"
          },
          {
            "ticket_id": 4574,
            "ticket_number": "354566",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P3",
            "created_at": "18/12/2025 10:52:10",
            "close_date": "2025-12-19",
            "sla_target_hours": 24,
            "actual_time_hours": 31.73,
            "sla_met": false,
            "sla_breach_hours": 7.73,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 18:36:26"
          },
          {
            "ticket_id": 4577,
            "ticket_number": "354569",
            "title": "Soltropico 335785",
            "priority": "P2",
            "created_at": "18/12/2025 11:41:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 11:41:39"
          },
          {
            "ticket_id": 4587,
            "ticket_number": "354579",
            "title": "IBAN",
            "priority": "P2",
            "created_at": "18/12/2025 15:03:49",
            "close_date": "2025-12-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 15:03:49"
          },
          {
            "ticket_id": 4605,
            "ticket_number": "354597",
            "title": "Rute Valado - Recibo para pagamento",
            "priority": "P2",
            "created_at": "18/12/2025 23:40:33",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/12/2025 23:40:34"
          },
          {
            "ticket_id": 4610,
            "ticket_number": "354602",
            "title": "Recibo Verde",
            "priority": "P3",
            "created_at": "19/12/2025 10:10:02",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 10:10:02"
          },
          {
            "ticket_id": 4622,
            "ticket_number": "354614",
            "title": "Dúvida no preenchimento do ato isolado",
            "priority": "P3",
            "created_at": "19/12/2025 11:19:15",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 11:19:16"
          },
          {
            "ticket_id": 4626,
            "ticket_number": "354618",
            "title": "Recibos verdes",
            "priority": "P3",
            "created_at": "19/12/2025 12:05:48",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 12:05:49"
          },
          {
            "ticket_id": 4630,
            "ticket_number": "354622",
            "title": "A/C Cátia Leal - RV",
            "priority": "P3",
            "created_at": "19/12/2025 13:21:39",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 95.6,
            "sla_met": false,
            "sla_breach_hours": 71.6,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 12:57:45"
          },
          {
            "ticket_id": 4643,
            "ticket_number": "354635",
            "title": "Solole. Booking HNDB5JNJ is close to entering expe",
            "priority": "P2",
            "created_at": "19/12/2025 16:10:07",
            "close_date": "2025-12-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/12/2025 18:31:23"
          },
          {
            "ticket_id": 4651,
            "ticket_number": "354643",
            "title": "Automatic reply: [OUTSIDE EMAIL] Fwd: Pagamento 35",
            "priority": "P3",
            "created_at": "19/12/2025 18:39:03",
            "close_date": "2026-01-05",
            "sla_target_hours": 24,
            "actual_time_hours": 406.65,
            "sla_met": false,
            "sla_breach_hours": 382.65,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 17:18:08"
          },
          {
            "ticket_id": 4655,
            "ticket_number": "354647",
            "title": "GBN-91876 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "20/12/2025 11:58:31",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 77.8,
            "sla_met": false,
            "sla_breach_hours": 73.8,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 17:47:10"
          },
          {
            "ticket_id": 4658,
            "ticket_number": "354650",
            "title": "A/C Cátia Leal - Fatura de ato isolado",
            "priority": "P2",
            "created_at": "20/12/2025 12:58:14",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/12/2025 12:58:15"
          },
          {
            "ticket_id": 4663,
            "ticket_number": "354655",
            "title": "recibo Ana Ameixa",
            "priority": "P2",
            "created_at": "20/12/2025 15:15:56",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/12/2025 15:15:56"
          },
          {
            "ticket_id": 4672,
            "ticket_number": "354664",
            "title": "GBN-88570 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "21/12/2025 10:40:39",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 31.55,
            "sla_met": false,
            "sla_breach_hours": 27.55,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:14:15"
          },
          {
            "ticket_id": 4673,
            "ticket_number": "354665",
            "title": "fatura-recibo das comissões",
            "priority": "P2",
            "created_at": "21/12/2025 10:40:41",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/12/2025 10:40:41"
          },
          {
            "ticket_id": 4674,
            "ticket_number": "354666",
            "title": "GBN-91876 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "21/12/2025 10:40:43",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 31.48,
            "sla_met": false,
            "sla_breach_hours": 27.48,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:10:02"
          },
          {
            "ticket_id": 4676,
            "ticket_number": "354668",
            "title": "GBN-94695 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "21/12/2025 10:40:47",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 31.97,
            "sla_met": false,
            "sla_breach_hours": 27.97,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:39:27"
          },
          {
            "ticket_id": 4679,
            "ticket_number": "354671",
            "title": "Recapitulativa de billetes | Solicitud 926114 - Fa",
            "priority": "P2",
            "created_at": "21/12/2025 10:45:11",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 366.53,
            "sla_met": false,
            "sla_breach_hours": 362.53,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 17:17:52"
          },
          {
            "ticket_id": 4682,
            "ticket_number": "354674",
            "title": "Solole. Booking OJEV6T13 is close to entering expe",
            "priority": "P1",
            "created_at": "21/12/2025 16:35:48",
            "close_date": "2025-12-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 25.65,
            "sla_met": false,
            "sla_breach_hours": 25.4,
            "sla_name": "SLA P1",
            "first_response_at": "22/12/2025 18:15:14"
          },
          {
            "ticket_id": 4684,
            "ticket_number": "354676",
            "title": "Solole. Booking HNDB5JNJ is close to entering expe",
            "priority": "P1",
            "created_at": "21/12/2025 16:35:52",
            "close_date": "2025-12-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 25.65,
            "sla_met": false,
            "sla_breach_hours": 25.4,
            "sla_name": "SLA P1",
            "first_response_at": "22/12/2025 18:15:45"
          },
          {
            "ticket_id": 4687,
            "ticket_number": "354679",
            "title": "Levantamento de comissões A/C Cátia",
            "priority": "P2",
            "created_at": "21/12/2025 16:57:04",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/12/2025 16:57:05"
          },
          {
            "ticket_id": 4688,
            "ticket_number": "354680",
            "title": "GBN-94424 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "22/12/2025 10:08:33",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 14:04:58"
          },
          {
            "ticket_id": 4689,
            "ticket_number": "354681",
            "title": "GBN-94695 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "22/12/2025 10:08:35",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 14:04:58"
          },
          {
            "ticket_id": 4690,
            "ticket_number": "354682",
            "title": "GBN-88570 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "22/12/2025 10:08:37",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 14:04:58"
          },
          {
            "ticket_id": 4691,
            "ticket_number": "354683",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60447",
            "priority": "P2",
            "created_at": "22/12/2025 10:08:39",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 14:04:58"
          },
          {
            "ticket_id": 4699,
            "ticket_number": "354691",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P1",
            "created_at": "22/12/2025 10:11:27",
            "close_date": "2025-12-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.9,
            "sla_met": false,
            "sla_breach_hours": 7.65,
            "sla_name": "SLA P1",
            "first_response_at": "22/12/2025 18:05:49"
          },
          {
            "ticket_id": 4700,
            "ticket_number": "354692",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "22/12/2025 10:11:28",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 14:04:58"
          },
          {
            "ticket_id": 4720,
            "ticket_number": "354712",
            "title": "cambio de pasajeros 1751036 W2MCS:016560003155",
            "priority": "P1",
            "created_at": "22/12/2025 13:28:50",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "19/12/2025 14:03:38"
          },
          {
            "ticket_id": 4721,
            "ticket_number": "354713",
            "title": "Solole. Booking OJEV6T13 is close to entering expe",
            "priority": "P3",
            "created_at": "22/12/2025 14:07:48",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 14:11:58"
          },
          {
            "ticket_id": 4729,
            "ticket_number": "354721",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "22/12/2025 17:30:52",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:26:25"
          },
          {
            "ticket_id": 4734,
            "ticket_number": "354726",
            "title": "Pagamento Final de Reserva - 335601",
            "priority": "P1",
            "created_at": "22/12/2025 18:14:53",
            "close_date": "2025-12-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "22/12/2025 18:19:14"
          },
          {
            "ticket_id": 4736,
            "ticket_number": "354728",
            "title": "Pagamento comissões",
            "priority": "P2",
            "created_at": "22/12/2025 18:34:48",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:34:48"
          },
          {
            "ticket_id": 4740,
            "ticket_number": "354732",
            "title": "Pagamento comissões",
            "priority": "P2",
            "created_at": "22/12/2025 18:43:58",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 18:43:59"
          },
          {
            "ticket_id": 4743,
            "ticket_number": "354735",
            "title": "A/C Cátia Leal - comisões",
            "priority": "P2",
            "created_at": "22/12/2025 19:28:32",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 19:28:32"
          },
          {
            "ticket_id": 4753,
            "ticket_number": "354745",
            "title": "Envio de ato isolado",
            "priority": "P2",
            "created_at": "22/12/2025 21:09:27",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 21:09:27"
          },
          {
            "ticket_id": 4755,
            "ticket_number": "354747",
            "title": "Faturas Pendentes: FA 2147882385",
            "priority": "P2",
            "created_at": "22/12/2025 21:10:05",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 11:01:27"
          },
          {
            "ticket_id": 4759,
            "ticket_number": "354751",
            "title": "Re: Levantamento de comissões",
            "priority": "P2",
            "created_at": "22/12/2025 22:13:48",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 22:13:48"
          },
          {
            "ticket_id": 4762,
            "ticket_number": "354754",
            "title": "Valores a receber",
            "priority": "P2",
            "created_at": "22/12/2025 23:40:57",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/12/2025 23:40:58"
          },
          {
            "ticket_id": 4768,
            "ticket_number": "354760",
            "title": "Document from Costa Crociere",
            "priority": "P3",
            "created_at": "23/12/2025 10:42:06",
            "close_date": "2025-12-23",
            "sla_target_hours": 24,
            "actual_time_hours": 8.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 19:23:18"
          },
          {
            "ticket_id": 4780,
            "ticket_number": "354772",
            "title": "Comissões Dezembro Marisa Duarte",
            "priority": "P3",
            "created_at": "23/12/2025 14:36:05",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/12/2025 14:36:06"
          },
          {
            "ticket_id": 4796,
            "ticket_number": "354788",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "23/12/2025 18:04:39",
            "close_date": "2025-12-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/12/2025 19:22:18"
          },
          {
            "ticket_id": 4808,
            "ticket_number": "354800",
            "title": "Levantamento de comissões",
            "priority": "P3",
            "created_at": "24/12/2025 10:23:22",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/12/2025 10:23:23"
          },
          {
            "ticket_id": 4811,
            "ticket_number": "354803",
            "title": "Pagamento comissões 2025",
            "priority": "P3",
            "created_at": "24/12/2025 10:53:20",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/12/2025 10:53:21"
          },
          {
            "ticket_id": 4833,
            "ticket_number": "354825",
            "title": "Mapa de Comissões – Viagem por realizar em Dez/25 ",
            "priority": "P3",
            "created_at": "26/12/2025 11:11:24",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 11:11:25"
          },
          {
            "ticket_id": 4839,
            "ticket_number": "354831",
            "title": "Comissões _Recibos _NIB",
            "priority": "P3",
            "created_at": "26/12/2025 12:30:22",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 12:30:23"
          },
          {
            "ticket_id": 4840,
            "ticket_number": "354832",
            "title": "GBN-96131 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "26/12/2025 12:54:02",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 77.73,
            "sla_met": false,
            "sla_breach_hours": 53.73,
            "sla_name": "SLA P3",
            "first_response_at": "29/12/2025 18:38:44"
          },
          {
            "ticket_id": 4847,
            "ticket_number": "354839",
            "title": "ATT/ CATIA  LEAL - OPTI 2433800002 - DUVIDA SOBRE ",
            "priority": "P3",
            "created_at": "26/12/2025 13:29:34",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 13:29:34"
          },
          {
            "ticket_id": 4850,
            "ticket_number": "354842",
            "title": "DEVOLUÇÃO VALOR TOTAL SMYTRAVEL LOCALIZADOR Nº 119",
            "priority": "P3",
            "created_at": "26/12/2025 14:15:30",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 14:15:30"
          },
          {
            "ticket_id": 4853,
            "ticket_number": "354845",
            "title": "Comissões",
            "priority": "P3",
            "created_at": "26/12/2025 15:35:53",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 15:35:53"
          },
          {
            "ticket_id": 4859,
            "ticket_number": "354851",
            "title": "Confirmação de comissões- Ana Simões",
            "priority": "P3",
            "created_at": "26/12/2025 16:29:50",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 16:29:50"
          },
          {
            "ticket_id": 4863,
            "ticket_number": "354855",
            "title": "Comissoes",
            "priority": "P2",
            "created_at": "26/12/2025 17:30:45",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 17:30:46"
          },
          {
            "ticket_id": 4866,
            "ticket_number": "354858",
            "title": "GBN-96131 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "26/12/2025 18:00:58",
            "close_date": "2025-12-29",
            "sla_target_hours": 24,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 19:20:50"
          },
          {
            "ticket_id": 4868,
            "ticket_number": "354860",
            "title": "Valores a receber GBN-91562",
            "priority": "P2",
            "created_at": "26/12/2025 19:32:20",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 19:32:21"
          },
          {
            "ticket_id": 4872,
            "ticket_number": "354864",
            "title": "Localizadores com documentos por assinar",
            "priority": "P2",
            "created_at": "26/12/2025 21:57:04",
            "close_date": "2025-12-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 21:57:05"
          },
          {
            "ticket_id": 4874,
            "ticket_number": "354866",
            "title": "2º Ato isolado",
            "priority": "P2",
            "created_at": "26/12/2025 23:31:52",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/12/2025 23:31:53"
          },
          {
            "ticket_id": 4875,
            "ticket_number": "354867",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60447",
            "priority": "P2",
            "created_at": "27/12/2025 09:54:02",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 241.33,
            "sla_met": false,
            "sla_breach_hours": 237.33,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:14:41"
          },
          {
            "ticket_id": 4877,
            "ticket_number": "354869",
            "title": "Dados para Comisssões",
            "priority": "P2",
            "created_at": "27/12/2025 13:03:36",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/12/2025 13:03:36"
          },
          {
            "ticket_id": 4889,
            "ticket_number": "354881",
            "title": "Recapitulativa de billetes | Solicitud 933169 - Fa",
            "priority": "P2",
            "created_at": "28/12/2025 12:07:37",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 197.15,
            "sla_met": false,
            "sla_breach_hours": 193.15,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 17:16:41"
          },
          {
            "ticket_id": 4891,
            "ticket_number": "354883",
            "title": "GBN-86545 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "28/12/2025 12:07:41",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 30.48,
            "sla_met": false,
            "sla_breach_hours": 26.48,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 18:36:58"
          },
          {
            "ticket_id": 4902,
            "ticket_number": "354894",
            "title": "Proposta Hotel Dubai",
            "priority": "P2",
            "created_at": "28/12/2025 16:31:37",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 14:17:29"
          },
          {
            "ticket_id": 4904,
            "ticket_number": "354896",
            "title": "Recibo 2025 Tiago Martins",
            "priority": "P2",
            "created_at": "28/12/2025 18:25:13",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/12/2025 18:25:14"
          },
          {
            "ticket_id": 4914,
            "ticket_number": "354906",
            "title": "RE: Pagamento 1760548",
            "priority": "P3",
            "created_at": "29/12/2025 10:12:17",
            "close_date": "2025-12-31",
            "sla_target_hours": 24,
            "actual_time_hours": 52.33,
            "sla_met": false,
            "sla_breach_hours": 28.33,
            "sla_name": "SLA P3",
            "first_response_at": "31/12/2025 14:33:15"
          },
          {
            "ticket_id": 4916,
            "ticket_number": "354908",
            "title": "GBN-86545 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "29/12/2025 10:12:23",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 32.5,
            "sla_met": false,
            "sla_breach_hours": 8.5,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 18:43:15"
          },
          {
            "ticket_id": 4923,
            "ticket_number": "354915",
            "title": "OPTI - 243300042",
            "priority": "P2",
            "created_at": "29/12/2025 11:29:40",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 11:29:41"
          },
          {
            "ticket_id": 4924,
            "ticket_number": "354916",
            "title": "OPTI 243300053 - FATURAR",
            "priority": "P2",
            "created_at": "29/12/2025 12:04:04",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 12:04:05"
          },
          {
            "ticket_id": 4926,
            "ticket_number": "354918",
            "title": "***URGENTE PAGO***LOC.604456534(TRAVELPLAN CARIBE ",
            "priority": "P2",
            "created_at": "29/12/2025 12:04:09",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 16:02:41"
          },
          {
            "ticket_id": 4938,
            "ticket_number": "354930",
            "title": "Comissões - processamento",
            "priority": "P2",
            "created_at": "29/12/2025 14:59:52",
            "close_date": "2025-12-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 14:59:52"
          },
          {
            "ticket_id": 4953,
            "ticket_number": "354945",
            "title": "Recibo Comissoes",
            "priority": "P2",
            "created_at": "29/12/2025 19:57:41",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 19:57:41"
          },
          {
            "ticket_id": 4965,
            "ticket_number": "354957",
            "title": "GBN-91364 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "30/12/2025 10:10:36",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 14:04:07"
          },
          {
            "ticket_id": 4969,
            "ticket_number": "354961",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P3",
            "created_at": "30/12/2025 10:10:44",
            "close_date": "2025-12-30",
            "sla_target_hours": 24,
            "actual_time_hours": 8.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 18:40:46"
          },
          {
            "ticket_id": 4972,
            "ticket_number": "354964",
            "title": "Devolução valor insure",
            "priority": "P2",
            "created_at": "30/12/2025 12:46:23",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 12:46:24"
          },
          {
            "ticket_id": 4974,
            "ticket_number": "354966",
            "title": "Recibo referente a comissões de 2025",
            "priority": "P2",
            "created_at": "30/12/2025 15:00:58",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 15:00:58"
          },
          {
            "ticket_id": 4976,
            "ticket_number": "354968",
            "title": "Re: Encerramento do pagamento das comissões de 202",
            "priority": "P2",
            "created_at": "30/12/2025 15:01:33",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 15:01:33"
          },
          {
            "ticket_id": 4979,
            "ticket_number": "354971",
            "title": "Recibos Verdes em Falta 2025",
            "priority": "P2",
            "created_at": "30/12/2025 15:42:01",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 15:42:01"
          },
          {
            "ticket_id": 4985,
            "ticket_number": "354977",
            "title": "Fatura Comissões (Habater) Solférias LOC 410790-20",
            "priority": "P2",
            "created_at": "30/12/2025 17:58:11",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 17:58:12"
          },
          {
            "ticket_id": 4986,
            "ticket_number": "354978",
            "title": "Recibo Comissões a habater Solférias LOC 410791-20",
            "priority": "P2",
            "created_at": "30/12/2025 17:59:48",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 17:59:48"
          },
          {
            "ticket_id": 4990,
            "ticket_number": "354982",
            "title": "Pagamento de comissões Ana Simões",
            "priority": "P2",
            "created_at": "30/12/2025 18:55:36",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 18:55:36"
          },
          {
            "ticket_id": 4991,
            "ticket_number": "354983",
            "title": "recibo comissões",
            "priority": "P2",
            "created_at": "30/12/2025 19:07:40",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 19:07:40"
          },
          {
            "ticket_id": 4992,
            "ticket_number": "354984",
            "title": "RGPDs e CVOs",
            "priority": "P2",
            "created_at": "30/12/2025 19:39:13",
            "close_date": "2025-12-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 19:39:13"
          },
          {
            "ticket_id": 4999,
            "ticket_number": "354991",
            "title": "Processo Nrº 422534 - Reserva SAL",
            "priority": "P2",
            "created_at": "30/12/2025 22:03:51",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 22:03:51"
          },
          {
            "ticket_id": 5001,
            "ticket_number": "354993",
            "title": "Referencia para pagamento | File:422534/2025",
            "priority": "P2",
            "created_at": "30/12/2025 22:13:19",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 22:15:34"
          },
          {
            "ticket_id": 5002,
            "ticket_number": "354994",
            "title": "recibo verde",
            "priority": "P2",
            "created_at": "30/12/2025 22:27:28",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 22:27:28"
          },
          {
            "ticket_id": 5006,
            "ticket_number": "354998",
            "title": "recibo comissões",
            "priority": "P2",
            "created_at": "30/12/2025 23:30:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 23:30:50"
          },
          {
            "ticket_id": 5008,
            "ticket_number": "355000",
            "title": "Recibo Verde",
            "priority": "P2",
            "created_at": "30/12/2025 23:52:16",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/12/2025 23:52:16"
          },
          {
            "ticket_id": 5010,
            "ticket_number": "355002",
            "title": "localizadores comissões",
            "priority": "P2",
            "created_at": "31/12/2025 00:04:53",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/12/2025 00:04:53"
          },
          {
            "ticket_id": 5074,
            "ticket_number": "355066",
            "title": "Fatura",
            "priority": "P2",
            "created_at": "02/01/2026 19:43:46",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 23:43:08"
          },
          {
            "ticket_id": 5087,
            "ticket_number": "355079",
            "title": "Reforço de pagamento  OPTI 247500027",
            "priority": "P2",
            "created_at": "03/01/2026 13:42:03",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/01/2026 13:42:04"
          },
          {
            "ticket_id": 5090,
            "ticket_number": "355082",
            "title": "FW: Novo Reforço de Pagamento - Viagem #251000154",
            "priority": "P2",
            "created_at": "03/01/2026 13:42:12",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/01/2026 13:42:13"
          },
          {
            "ticket_id": 5091,
            "ticket_number": "355083",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "03/01/2026 13:44:22",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 69.5,
            "sla_met": false,
            "sla_breach_hours": 65.5,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:14:24"
          },
          {
            "ticket_id": 5095,
            "ticket_number": "355087",
            "title": "Solole. Booking WSF1AUF9 is close to entering expe",
            "priority": "P1",
            "created_at": "03/01/2026 14:02:22",
            "close_date": "2026-01-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 44.82,
            "sla_met": false,
            "sla_breach_hours": 44.57,
            "sla_name": "SLA P1",
            "first_response_at": "05/01/2026 10:51:59"
          },
          {
            "ticket_id": 5108,
            "ticket_number": "355100",
            "title": "Pedido de Comissões",
            "priority": "P2",
            "created_at": "03/01/2026 17:25:35",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/01/2026 17:25:35"
          },
          {
            "ticket_id": 5118,
            "ticket_number": "355110",
            "title": "Referencia para pagamento | File:422534/2025",
            "priority": "P2",
            "created_at": "04/01/2026 09:56:15",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 97.92,
            "sla_met": false,
            "sla_breach_hours": 93.92,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 11:51:45"
          },
          {
            "ticket_id": 5119,
            "ticket_number": "355111",
            "title": "Reserva newblue não efetuada mas paga (6125468)",
            "priority": "P2",
            "created_at": "04/01/2026 10:21:56",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/01/2026 10:22:17"
          },
          {
            "ticket_id": 5133,
            "ticket_number": "355125",
            "title": "Reforço pagamento GBN 89009",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:34",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 09:57:35"
          },
          {
            "ticket_id": 5135,
            "ticket_number": "355127",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:39",
            "close_date": "2026-01-06",
            "sla_target_hours": 4,
            "actual_time_hours": 25.27,
            "sla_met": false,
            "sla_breach_hours": 21.27,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 11:14:09"
          },
          {
            "ticket_id": 5137,
            "ticket_number": "355129",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60447",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:44",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 48.47,
            "sla_met": false,
            "sla_breach_hours": 44.47,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 10:26:28"
          },
          {
            "ticket_id": 5146,
            "ticket_number": "355138",
            "title": "FHHBZR - CONSOLIDADOR - ATUA",
            "priority": "P2",
            "created_at": "05/01/2026 10:34:45",
            "close_date": "2026-01-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/01/2026 12:25:02"
          },
          {
            "ticket_id": 5161,
            "ticket_number": "355153",
            "title": "Confirmação de recepção: EXPEDIENTE 604466293 + LO",
            "priority": "P3",
            "created_at": "05/01/2026 13:03:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/12/2025 16:24:20"
          },
          {
            "ticket_id": 5171,
            "ticket_number": "355163",
            "title": "Pedido de esclarecimento pagamento de comissões",
            "priority": "P3",
            "created_at": "05/01/2026 15:51:07",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:51:07"
          },
          {
            "ticket_id": 5196,
            "ticket_number": "355188",
            "title": "GBN-95589 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "06/01/2026 10:12:32",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 32.07,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 18:16:41"
          },
          {
            "ticket_id": 5198,
            "ticket_number": "355190",
            "title": "GBN-87175 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "06/01/2026 10:12:36",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 32.05,
            "sla_met": false,
            "sla_breach_hours": 8.05,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 18:15:55"
          },
          {
            "ticket_id": 5211,
            "ticket_number": "355203",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3523909",
            "priority": "P3",
            "created_at": "06/01/2026 11:46:59",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 15:41:54"
          },
          {
            "ticket_id": 5218,
            "ticket_number": "355210",
            "title": "OPTI 2414000030 - faturação",
            "priority": "P3",
            "created_at": "06/01/2026 12:52:38",
            "close_date": "2026-01-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/01/2026 12:52:39"
          },
          {
            "ticket_id": 5258,
            "ticket_number": "355250",
            "title": "Re:[## 28461 ##] GBN-92775 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "06/01/2026 20:03:47",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 17.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 13:51:25"
          },
          {
            "ticket_id": 5265,
            "ticket_number": "355257",
            "title": "6124862 New Blue",
            "priority": "P2",
            "created_at": "06/01/2026 22:35:30",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 22:35:30"
          },
          {
            "ticket_id": 5271,
            "ticket_number": "355263",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P1",
            "created_at": "07/01/2026 10:07:19",
            "close_date": "2026-01-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.93,
            "sla_met": false,
            "sla_breach_hours": 3.68,
            "sla_name": "SLA P1",
            "first_response_at": "07/01/2026 14:03:29"
          },
          {
            "ticket_id": 5272,
            "ticket_number": "355264",
            "title": "GBN-87175 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "07/01/2026 10:07:21",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 14:03:29"
          },
          {
            "ticket_id": 5281,
            "ticket_number": "355273",
            "title": "GBN-86359 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "07/01/2026 13:06:13",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 17:03:46"
          },
          {
            "ticket_id": 5282,
            "ticket_number": "355274",
            "title": "Reserva pendente de confirmaçao - GBN-96830",
            "priority": "P3",
            "created_at": "07/01/2026 13:06:14",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 13:06:15"
          },
          {
            "ticket_id": 5285,
            "ticket_number": "355277",
            "title": "GBN-65878 - nota de credito gbn + devolver a clien",
            "priority": "P2",
            "created_at": "07/01/2026 13:13:07",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/12/2025 17:08:59"
          },
          {
            "ticket_id": 5290,
            "ticket_number": "355282",
            "title": "pagamento comissões Liliana Pinto",
            "priority": "P3",
            "created_at": "07/01/2026 13:59:25",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/01/2026 13:59:25"
          },
          {
            "ticket_id": 5292,
            "ticket_number": "355284",
            "title": "Recordatorio prepago reserva: 1760552",
            "priority": "P3",
            "created_at": "07/01/2026 14:00:00",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 21.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 11:51:25"
          },
          {
            "ticket_id": 5319,
            "ticket_number": "355311",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "07/01/2026 19:27:38",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 23:24:29"
          },
          {
            "ticket_id": 5327,
            "ticket_number": "355319",
            "title": "Cacelamento reserva",
            "priority": "P2",
            "created_at": "07/01/2026 22:29:47",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/01/2026 22:29:48"
          },
          {
            "ticket_id": 5346,
            "ticket_number": "355338",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P2",
            "created_at": "08/01/2026 10:07:31",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 14:00:19"
          },
          {
            "ticket_id": 5377,
            "ticket_number": "355369",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P2",
            "created_at": "08/01/2026 11:21:32",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 15:20:21"
          },
          {
            "ticket_id": 5378,
            "ticket_number": "355370",
            "title": "Re: Nova Viagem #251200182 - Benice Travel",
            "priority": "P2",
            "created_at": "08/01/2026 11:21:37",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 11:21:37"
          },
          {
            "ticket_id": 5383,
            "ticket_number": "355375",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P2",
            "created_at": "08/01/2026 11:21:48",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 15:20:21"
          },
          {
            "ticket_id": 5384,
            "ticket_number": "355376",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P2",
            "created_at": "08/01/2026 11:21:50",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 15:20:21"
          },
          {
            "ticket_id": 5397,
            "ticket_number": "355389",
            "title": "Re: Novo Reforço de Pagamento - Viagem #251100291",
            "priority": "P2",
            "created_at": "08/01/2026 12:59:40",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 12:59:41"
          },
          {
            "ticket_id": 5403,
            "ticket_number": "355395",
            "title": "Confirmação de reserva 336196### TIME LIMIT EMISSÃ",
            "priority": "P3",
            "created_at": "08/01/2026 16:25:18",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/01/2026 18:46:28"
          },
          {
            "ticket_id": 5404,
            "ticket_number": "355396",
            "title": "Fatura Deixa-te Levar Tours",
            "priority": "P2",
            "created_at": "08/01/2026 18:31:26",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 18:31:26"
          },
          {
            "ticket_id": 5435,
            "ticket_number": "355427",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "09/01/2026 10:09:23",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 14:01:38"
          },
          {
            "ticket_id": 5443,
            "ticket_number": "355435",
            "title": "Fatura / Recibo OPTI 2422300010",
            "priority": "P2",
            "created_at": "09/01/2026 11:55:48",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 11:55:48"
          },
          {
            "ticket_id": 5455,
            "ticket_number": "355447",
            "title": "Re: Nova Viagem #260100050 - Filipa Romão",
            "priority": "P2",
            "created_at": "09/01/2026 13:49:08",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 13:49:08"
          },
          {
            "ticket_id": 5460,
            "ticket_number": "355452",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "09/01/2026 16:08:35",
            "close_date": "2026-01-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/01/2026 16:21:44"
          },
          {
            "ticket_id": 5463,
            "ticket_number": "355455",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "09/01/2026 16:24:29",
            "close_date": "2026-01-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.92,
            "sla_met": false,
            "sla_breach_hours": 4.67,
            "sla_name": "SLA P1",
            "first_response_at": "09/01/2026 21:20:29"
          },
          {
            "ticket_id": 5472,
            "ticket_number": "355464",
            "title": "Fatura Deixa-te levar tours",
            "priority": "P2",
            "created_at": "09/01/2026 18:28:49",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 18:28:49"
          },
          {
            "ticket_id": 5475,
            "ticket_number": "355467",
            "title": "Envio (Factura-2147885325) (Nota de Crédito-214755",
            "priority": "P2",
            "created_at": "09/01/2026 18:59:47",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/01/2026 21:18:36"
          },
          {
            "ticket_id": 5494,
            "ticket_number": "355486",
            "title": "Cancelamento - veturis",
            "priority": "P3",
            "created_at": "09/01/2026 23:39:21",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 23:39:21"
          },
          {
            "ticket_id": 5499,
            "ticket_number": "355491",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "10/01/2026 11:09:35",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 54.98,
            "sla_met": false,
            "sla_breach_hours": 50.98,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:09:20"
          },
          {
            "ticket_id": 5500,
            "ticket_number": "355492",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "10/01/2026 11:09:37",
            "close_date": "2026-01-12",
            "sla_target_hours": 4,
            "actual_time_hours": 54.98,
            "sla_met": false,
            "sla_breach_hours": 50.98,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 18:08:59"
          },
          {
            "ticket_id": 5539,
            "ticket_number": "355531",
            "title": "GBN-91238 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/01/2026 10:07:57",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:24"
          },
          {
            "ticket_id": 5544,
            "ticket_number": "355536",
            "title": "GBN-93840 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/01/2026 10:08:08",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:24"
          },
          {
            "ticket_id": 5546,
            "ticket_number": "355538",
            "title": "GBN-91308 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/01/2026 10:08:11",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:24"
          },
          {
            "ticket_id": 5560,
            "ticket_number": "355552",
            "title": "GBN-94705 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "12/01/2026 10:12:02",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:25"
          },
          {
            "ticket_id": 5569,
            "ticket_number": "355561",
            "title": "Faturas opti 2414000017",
            "priority": "P3",
            "created_at": "12/01/2026 10:14:04",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:14:04"
          },
          {
            "ticket_id": 5572,
            "ticket_number": "355564",
            "title": "GBN-91308 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/01/2026 10:16:15",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5580,
            "ticket_number": "355572",
            "title": "Referencia para pagamento | File:412548/2025",
            "priority": "P3",
            "created_at": "12/01/2026 10:16:40",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:26"
          },
          {
            "ticket_id": 5585,
            "ticket_number": "355577",
            "title": "Criação de processo File 423503/26",
            "priority": "P1",
            "created_at": "12/01/2026 10:17:27",
            "close_date": "2026-01-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.62,
            "sla_met": false,
            "sla_breach_hours": 9.37,
            "sla_name": "SLA P1",
            "first_response_at": "12/01/2026 19:54:48"
          },
          {
            "ticket_id": 5596,
            "ticket_number": "355588",
            "title": "Referencia para pagamento | File:423503/2026",
            "priority": "P1",
            "created_at": "12/01/2026 10:22:15",
            "close_date": "2026-01-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.47,
            "sla_met": false,
            "sla_breach_hours": 8.22,
            "sla_name": "SLA P1",
            "first_response_at": "12/01/2026 18:50:40"
          },
          {
            "ticket_id": 5602,
            "ticket_number": "355594",
            "title": "File 422534/25 - Pagamento em Falta",
            "priority": "P2",
            "created_at": "12/01/2026 12:41:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 13:54:27"
          },
          {
            "ticket_id": 5607,
            "ticket_number": "355599",
            "title": "***MUY URGENTE PAGO HOY***LOC.604519309 (LEPLAN)--",
            "priority": "P1",
            "created_at": "12/01/2026 12:42:54",
            "close_date": "2026-01-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.62,
            "sla_met": false,
            "sla_breach_hours": 0.37,
            "sla_name": "SLA P1",
            "first_response_at": "12/01/2026 13:20:09"
          },
          {
            "ticket_id": 5612,
            "ticket_number": "355604",
            "title": "RE: Pagamento 6125669",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:31",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 46.18,
            "sla_met": false,
            "sla_breach_hours": 22.18,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:14:03"
          },
          {
            "ticket_id": 5614,
            "ticket_number": "355606",
            "title": "RE: Pagamento 6125577",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:35",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 46.18,
            "sla_met": false,
            "sla_breach_hours": 22.18,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:13:54"
          },
          {
            "ticket_id": 5615,
            "ticket_number": "355607",
            "title": "RE: Pagamento 1757952",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:37",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 46.18,
            "sla_met": false,
            "sla_breach_hours": 22.18,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:13:40"
          },
          {
            "ticket_id": 5618,
            "ticket_number": "355610",
            "title": "***URGENTE PAGO HOY***LOC.604517161(LEPLAN)---Uma ",
            "priority": "P1",
            "created_at": "12/01/2026 13:02:44",
            "close_date": "2026-01-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/01/2026 13:13:12"
          },
          {
            "ticket_id": 5622,
            "ticket_number": "355614",
            "title": "Solole. Booking 8GCF64MO is close to entering expe",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:04",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 24.92,
            "sla_met": false,
            "sla_breach_hours": 0.92,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:35:52"
          },
          {
            "ticket_id": 5623,
            "ticket_number": "355615",
            "title": "Re:[## 28837 ##] GBN-94705 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:06",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 18:44:54"
          },
          {
            "ticket_id": 5628,
            "ticket_number": "355620",
            "title": "Pedido de cancelamento de reserva- GBN - 97747",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:19",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 15:40:20"
          },
          {
            "ticket_id": 5638,
            "ticket_number": "355630",
            "title": "Lembrete: Sinalização Reserva 208883",
            "priority": "P3",
            "created_at": "12/01/2026 16:43:02",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 26.35,
            "sla_met": false,
            "sla_breach_hours": 2.35,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 19:04:27"
          },
          {
            "ticket_id": 5658,
            "ticket_number": "355650",
            "title": "Re:[## 28946 ##] GBN-97747 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/01/2026 18:58:05",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 19:19:32"
          },
          {
            "ticket_id": 5664,
            "ticket_number": "355656",
            "title": "A/C CÁTIA INTERLINE",
            "priority": "P2",
            "created_at": "12/01/2026 21:10:00",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/01/2026 21:10:02"
          },
          {
            "ticket_id": 5685,
            "ticket_number": "355677",
            "title": "Envio Recibo Verde - GBN - 94773",
            "priority": "P2",
            "created_at": "13/01/2026 00:13:34",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:13:35"
          },
          {
            "ticket_id": 5686,
            "ticket_number": "355678",
            "title": "Envio Recibo Verde - GBN - 90444",
            "priority": "P2",
            "created_at": "13/01/2026 00:13:37",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:13:37"
          },
          {
            "ticket_id": 5687,
            "ticket_number": "355679",
            "title": "Envio Recibo Verde - Tour10 - 4005672",
            "priority": "P2",
            "created_at": "13/01/2026 00:13:40",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:13:40"
          },
          {
            "ticket_id": 5688,
            "ticket_number": "355680",
            "title": "Envio Recibo Verde - GBN - 90444",
            "priority": "P2",
            "created_at": "13/01/2026 00:13:42",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:13:43"
          },
          {
            "ticket_id": 5694,
            "ticket_number": "355686",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3527594",
            "priority": "P3",
            "created_at": "13/01/2026 10:03:42",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 25.02,
            "sla_met": false,
            "sla_breach_hours": 1.02,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:04:55"
          },
          {
            "ticket_id": 5698,
            "ticket_number": "355690",
            "title": "GBN-96569 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "13/01/2026 10:06:28",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 14:01:12"
          },
          {
            "ticket_id": 5699,
            "ticket_number": "355691",
            "title": "GBN-93840 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "13/01/2026 10:06:30",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 14:01:12"
          },
          {
            "ticket_id": 5712,
            "ticket_number": "355704",
            "title": "Comprovativo Transação ",
            "priority": "P3",
            "created_at": "13/01/2026 10:07:01",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 6.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 16:43:59"
          },
          {
            "ticket_id": 5740,
            "ticket_number": "355732",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P3",
            "created_at": "13/01/2026 12:56:01",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 15:48:50"
          },
          {
            "ticket_id": 5761,
            "ticket_number": "355753",
            "title": "Solole. Booking 8GCF64MO is close to entering expe",
            "priority": "P1",
            "created_at": "13/01/2026 14:56:46",
            "close_date": "2026-01-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.0,
            "sla_met": false,
            "sla_breach_hours": 0.75,
            "sla_name": "SLA P1",
            "first_response_at": "13/01/2026 15:57:13"
          },
          {
            "ticket_id": 5789,
            "ticket_number": "355781",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "13/01/2026 17:26:07",
            "close_date": "2026-01-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.62,
            "sla_met": false,
            "sla_breach_hours": 1.37,
            "sla_name": "SLA P1",
            "first_response_at": "13/01/2026 19:03:35"
          },
          {
            "ticket_id": 5803,
            "ticket_number": "355795",
            "title": "Confirmação de comissões",
            "priority": "P2",
            "created_at": "13/01/2026 19:37:47",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 19:37:47"
          },
          {
            "ticket_id": 5824,
            "ticket_number": "355816",
            "title": "Devoluçao 60€ - José",
            "priority": "P2",
            "created_at": "13/01/2026 22:26:05",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 22:26:05"
          },
          {
            "ticket_id": 5826,
            "ticket_number": "355818",
            "title": "Referencia para pagamento | File:422592/2026",
            "priority": "P2",
            "created_at": "13/01/2026 22:26:09",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:11:38"
          },
          {
            "ticket_id": 5836,
            "ticket_number": "355828",
            "title": "Fwd: Nova Viagem #260100140 - Marta Oliveira",
            "priority": "P2",
            "created_at": "13/01/2026 23:05:15",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 23:05:17"
          },
          {
            "ticket_id": 5853,
            "ticket_number": "355845",
            "title": "RE: Pagamento 6126040",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:02",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:03:02"
          },
          {
            "ticket_id": 5854,
            "ticket_number": "355846",
            "title": "GBN-96569 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "14/01/2026 10:08:04",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 11:26:32"
          },
          {
            "ticket_id": 5855,
            "ticket_number": "355847",
            "title": "GBN-98535 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:06",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 32.68,
            "sla_met": false,
            "sla_breach_hours": 8.68,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 18:49:39"
          },
          {
            "ticket_id": 5856,
            "ticket_number": "355848",
            "title": "GBN-95451 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:09",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:22:09"
          },
          {
            "ticket_id": 5860,
            "ticket_number": "355852",
            "title": "RE: Pagamento 6126022",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:20",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:33:31"
          },
          {
            "ticket_id": 5885,
            "ticket_number": "355877",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "14/01/2026 13:42:54",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.5,
            "sla_met": false,
            "sla_breach_hours": 4.25,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 18:13:19"
          },
          {
            "ticket_id": 5895,
            "ticket_number": "355887",
            "title": "Pedido de Comissões",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:30",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 13:43:30"
          },
          {
            "ticket_id": 5907,
            "ticket_number": "355899",
            "title": "Solole. Booking 8GCF64MO is close to entering expe",
            "priority": "P3",
            "created_at": "14/01/2026 15:05:01",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 18:15:40"
          },
          {
            "ticket_id": 5921,
            "ticket_number": "355913",
            "title": "RE: Devolução 6125468",
            "priority": "P3",
            "created_at": "14/01/2026 16:17:54",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 165.15,
            "sla_met": false,
            "sla_breach_hours": 141.15,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:27:21"
          },
          {
            "ticket_id": 5923,
            "ticket_number": "355915",
            "title": "Faturas Pendentes: FA 2147886486",
            "priority": "P1",
            "created_at": "14/01/2026 16:18:00",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.95,
            "sla_met": false,
            "sla_breach_hours": 1.7,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 18:15:10"
          },
          {
            "ticket_id": 5924,
            "ticket_number": "355916",
            "title": "Referencia para pagamento | File:423949/2026",
            "priority": "P1",
            "created_at": "14/01/2026 16:18:01",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.93,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 18:14:42"
          },
          {
            "ticket_id": 5925,
            "ticket_number": "355917",
            "title": "Reminder * Reserva File 423949 * Deadline Hoje 17H",
            "priority": "P1",
            "created_at": "14/01/2026 16:18:04",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.93,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P1",
            "first_response_at": "14/01/2026 18:14:21"
          },
          {
            "ticket_id": 5946,
            "ticket_number": "355938",
            "title": "Lembrete: Sinalização Reserva 209286",
            "priority": "P2",
            "created_at": "14/01/2026 19:58:39",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:44:46"
          },
          {
            "ticket_id": 5948,
            "ticket_number": "355940",
            "title": "Recibo Verde - 01 - 2026",
            "priority": "P2",
            "created_at": "14/01/2026 20:20:45",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 20:20:46"
          },
          {
            "ticket_id": 5962,
            "ticket_number": "355954",
            "title": "Criação de processo File 424156/26",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:06",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:26:58"
          },
          {
            "ticket_id": 5963,
            "ticket_number": "355955",
            "title": "Pagamento recibo Liliana Pinto",
            "priority": "P2",
            "created_at": "14/01/2026 22:51:09",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 22:51:09"
          },
          {
            "ticket_id": 5972,
            "ticket_number": "355964",
            "title": "BackOffice | Nova Viagem #260100162 - B Vibes (Loc",
            "priority": "P2",
            "created_at": "14/01/2026 23:09:28",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/01/2026 23:09:28"
          },
          {
            "ticket_id": 5986,
            "ticket_number": "355978",
            "title": "GBN-96972 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:29",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:00:41"
          },
          {
            "ticket_id": 5987,
            "ticket_number": "355979",
            "title": "GBN-88822 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:32",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:00:41"
          },
          {
            "ticket_id": 5988,
            "ticket_number": "355980",
            "title": "GBN-94474 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:34",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:00:41"
          },
          {
            "ticket_id": 5990,
            "ticket_number": "355982",
            "title": "GBN-98535 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/01/2026 10:13:38",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:00:41"
          },
          {
            "ticket_id": 6002,
            "ticket_number": "355994",
            "title": "Amanhã será realizada a cobrança da reserva A36059",
            "priority": "P2",
            "created_at": "15/01/2026 10:16:25",
            "close_date": "2026-01-15",
            "sla_target_hours": 4,
            "actual_time_hours": 8.32,
            "sla_met": false,
            "sla_breach_hours": 4.32,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:36:25"
          },
          {
            "ticket_id": 6007,
            "ticket_number": "355999",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "15/01/2026 10:32:56",
            "close_date": "2026-01-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.2,
            "sla_met": false,
            "sla_breach_hours": 8.95,
            "sla_name": "SLA P1",
            "first_response_at": "15/01/2026 19:45:45"
          },
          {
            "ticket_id": 6045,
            "ticket_number": "356037",
            "title": "Re: Nova Viagem #260100162 - B Vibes",
            "priority": "P2",
            "created_at": "15/01/2026 13:33:33",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 13:33:33"
          },
          {
            "ticket_id": 6094,
            "ticket_number": "356086",
            "title": "Seguros Insure - alteração",
            "priority": "P2",
            "created_at": "15/01/2026 20:04:31",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 20:04:32"
          },
          {
            "ticket_id": 6125,
            "ticket_number": "356117",
            "title": "332627 Soltrópico - cancelamento",
            "priority": "P3",
            "created_at": "16/01/2026 10:13:08",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:13:08"
          },
          {
            "ticket_id": 6135,
            "ticket_number": "356127",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P3",
            "created_at": "16/01/2026 10:13:47",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 273.92,
            "sla_met": false,
            "sla_breach_hours": 249.92,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 20:09:15"
          },
          {
            "ticket_id": 6136,
            "ticket_number": "356128",
            "title": "GBN-88822 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "16/01/2026 10:13:51",
            "close_date": "2026-01-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 17:35:42"
          },
          {
            "ticket_id": 6137,
            "ticket_number": "356129",
            "title": "GBN-92539 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "16/01/2026 10:13:55",
            "close_date": "2026-01-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.8,
            "sla_met": false,
            "sla_breach_hours": 3.55,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 14:02:48"
          },
          {
            "ticket_id": 6140,
            "ticket_number": "356132",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 273.88,
            "sla_met": false,
            "sla_breach_hours": 249.88,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 20:08:03"
          },
          {
            "ticket_id": 6142,
            "ticket_number": "356134",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:13",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 273.87,
            "sla_met": false,
            "sla_breach_hours": 249.87,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 20:06:38"
          },
          {
            "ticket_id": 6155,
            "ticket_number": "356147",
            "title": "Referencia para pagamento | File:424156/2026",
            "priority": "P3",
            "created_at": "16/01/2026 10:29:25",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 14:22:49"
          },
          {
            "ticket_id": 6158,
            "ticket_number": "356150",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "16/01/2026 10:53:44",
            "close_date": "2026-01-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.97,
            "sla_met": false,
            "sla_breach_hours": 6.72,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 17:52:01"
          },
          {
            "ticket_id": 6160,
            "ticket_number": "356152",
            "title": "Confirmação e Sinalização de Reserva 210302",
            "priority": "P1",
            "created_at": "16/01/2026 11:23:15",
            "close_date": "2026-01-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 102.18,
            "sla_met": false,
            "sla_breach_hours": 101.93,
            "sla_name": "SLA P1",
            "first_response_at": "20/01/2026 17:35:11"
          },
          {
            "ticket_id": 6172,
            "ticket_number": "356164",
            "title": "RE: Pagamento 1763586",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:41",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 119.57,
            "sla_met": false,
            "sla_breach_hours": 95.57,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 12:13:47"
          },
          {
            "ticket_id": 6173,
            "ticket_number": "356165",
            "title": "RE: Pagamento 1768993",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:43",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 119.55,
            "sla_met": false,
            "sla_breach_hours": 95.55,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 12:13:37"
          },
          {
            "ticket_id": 6174,
            "ticket_number": "356166",
            "title": "RE: Pagamento 6126614",
            "priority": "P3",
            "created_at": "16/01/2026 12:39:46",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 119.55,
            "sla_met": false,
            "sla_breach_hours": 95.55,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 12:13:25"
          },
          {
            "ticket_id": 6182,
            "ticket_number": "356174",
            "title": "Faturas Pendentes: FA 2147887107",
            "priority": "P3",
            "created_at": "16/01/2026 13:02:48",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 16:57:13"
          },
          {
            "ticket_id": 6207,
            "ticket_number": "356199",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "16/01/2026 16:21:41",
            "close_date": "2026-01-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.48,
            "sla_met": false,
            "sla_breach_hours": 1.23,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 17:51:32"
          },
          {
            "ticket_id": 6208,
            "ticket_number": "356200",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "16/01/2026 16:21:43",
            "close_date": "2026-01-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.48,
            "sla_met": false,
            "sla_breach_hours": 1.23,
            "sla_name": "SLA P1",
            "first_response_at": "16/01/2026 17:51:05"
          },
          {
            "ticket_id": 6231,
            "ticket_number": "356223",
            "title": "Re: Criação de balcões [#345217]",
            "priority": "P2",
            "created_at": "16/01/2026 20:19:54",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 92.47,
            "sla_met": false,
            "sla_breach_hours": 88.47,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 16:47:57"
          },
          {
            "ticket_id": 6241,
            "ticket_number": "356233",
            "title": "Referencia para pagamento | File:424453/2026",
            "priority": "P2",
            "created_at": "16/01/2026 22:47:04",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 23:28:19"
          },
          {
            "ticket_id": 6261,
            "ticket_number": "356253",
            "title": "GBN-97397 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/01/2026 10:08:11",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/01/2026 10:14:43"
          },
          {
            "ticket_id": 6263,
            "ticket_number": "356255",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P2",
            "created_at": "17/01/2026 10:08:19",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 79.4,
            "sla_met": false,
            "sla_breach_hours": 75.4,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:33:18"
          },
          {
            "ticket_id": 6305,
            "ticket_number": "356297",
            "title": "GBN-97397 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/01/2026 09:52:32",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 55.65,
            "sla_met": false,
            "sla_breach_hours": 51.65,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:32:11"
          },
          {
            "ticket_id": 6306,
            "ticket_number": "356298",
            "title": "Amanhã será realizada a cobrança da reserva A35307",
            "priority": "P1",
            "created_at": "18/01/2026 09:52:33",
            "close_date": "2026-01-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 55.65,
            "sla_met": false,
            "sla_breach_hours": 55.4,
            "sla_name": "SLA P1",
            "first_response_at": "20/01/2026 17:31:50"
          },
          {
            "ticket_id": 6309,
            "ticket_number": "356301",
            "title": "Recapitulativa de billetes | Solicitud 945264 - Fa",
            "priority": "P2",
            "created_at": "18/01/2026 09:52:43",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 415.07,
            "sla_met": false,
            "sla_breach_hours": 411.07,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 16:57:04"
          },
          {
            "ticket_id": 6315,
            "ticket_number": "356307",
            "title": "Referencia para pagamento | File:424637/2026",
            "priority": "P3",
            "created_at": "18/01/2026 09:52:58",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 55.63,
            "sla_met": false,
            "sla_breach_hours": 31.63,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:31:39"
          },
          {
            "ticket_id": 6320,
            "ticket_number": "356312",
            "title": "Devolução de sinal - opti nº 2412000028",
            "priority": "P3",
            "created_at": "18/01/2026 09:53:06",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/01/2026 09:53:07"
          },
          {
            "ticket_id": 6321,
            "ticket_number": "356313",
            "title": "Referencia para pagamento | File:424615/2026",
            "priority": "P2",
            "created_at": "18/01/2026 09:53:08",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 55.63,
            "sla_met": false,
            "sla_breach_hours": 51.63,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:31:18"
          },
          {
            "ticket_id": 6343,
            "ticket_number": "356335",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:10",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:10"
          },
          {
            "ticket_id": 6352,
            "ticket_number": "356344",
            "title": "GBN-94614 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/01/2026 14:07:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 48.92,
            "sla_met": false,
            "sla_breach_hours": 44.92,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:02:59"
          },
          {
            "ticket_id": 6382,
            "ticket_number": "356374",
            "title": "Cartão Agente de Viagens - Interlines Riviera Maya",
            "priority": "P3",
            "created_at": "19/01/2026 10:09:47",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:09:47"
          },
          {
            "ticket_id": 6383,
            "ticket_number": "356375",
            "title": "Houve um problema com o pagamento da reserva A3530",
            "priority": "P2",
            "created_at": "19/01/2026 10:09:49",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:57"
          },
          {
            "ticket_id": 6394,
            "ticket_number": "356386",
            "title": "Referencia para pagamento | File:424766/2026",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:23",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:57"
          },
          {
            "ticket_id": 6407,
            "ticket_number": "356399",
            "title": "Reembolso por cancelamento",
            "priority": "P3",
            "created_at": "19/01/2026 10:11:23",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:11:23"
          },
          {
            "ticket_id": 6425,
            "ticket_number": "356417",
            "title": "Criação de balcões [#345217]",
            "priority": "P3",
            "created_at": "19/01/2026 11:12:02",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 21:03:54"
          },
          {
            "ticket_id": 6429,
            "ticket_number": "356421",
            "title": "Pedido de Sinalização De Reserva 336983",
            "priority": "P2",
            "created_at": "19/01/2026 11:41:38",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6432,
            "ticket_number": "356424",
            "title": "Pedido de Sinalização De Reserva 337005",
            "priority": "P2",
            "created_at": "19/01/2026 11:41:43",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6433,
            "ticket_number": "356425",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "19/01/2026 11:41:46",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6435,
            "ticket_number": "356427",
            "title": "Pagamento Final de Reserva - 332766",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:43",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6436,
            "ticket_number": "356428",
            "title": "Pedido de Sinalização De Reserva 336983",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:44",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6437,
            "ticket_number": "356429",
            "title": "Pagamento Final de Reserva - 332768",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:45",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6438,
            "ticket_number": "356430",
            "title": "Pagamento Final de Reserva - 332769",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:47",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6439,
            "ticket_number": "356431",
            "title": "Pagamento Final de Reserva - 332773",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:48",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6440,
            "ticket_number": "356432",
            "title": "Pedido de Sinalização De Reserva 337005",
            "priority": "P2",
            "created_at": "19/01/2026 11:50:50",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:41:09"
          },
          {
            "ticket_id": 6444,
            "ticket_number": "356436",
            "title": "Confirmação e Sinalização de Reserva 210360",
            "priority": "P2",
            "created_at": "19/01/2026 12:32:59",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 16:21:16"
          },
          {
            "ticket_id": 6482,
            "ticket_number": "356474",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "19/01/2026 19:16:31",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 19:16:31"
          },
          {
            "ticket_id": 6488,
            "ticket_number": "356480",
            "title": "Levantamento de Comissões",
            "priority": "P2",
            "created_at": "19/01/2026 19:49:53",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 19:49:54"
          },
          {
            "ticket_id": 6505,
            "ticket_number": "356497",
            "title": "Referencia para pagamento | File:424887/2026",
            "priority": "P2",
            "created_at": "19/01/2026 22:13:39",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:02:38"
          },
          {
            "ticket_id": 6506,
            "ticket_number": "356498",
            "title": "Referencia para pagamento | File:425012/2026",
            "priority": "P2",
            "created_at": "19/01/2026 22:23:39",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:22:41"
          },
          {
            "ticket_id": 6507,
            "ticket_number": "356499",
            "title": "Referencia para pagamento | File:425020/2026",
            "priority": "P2",
            "created_at": "19/01/2026 22:23:40",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 12:22:41"
          },
          {
            "ticket_id": 6523,
            "ticket_number": "356515",
            "title": "Alterações em optis",
            "priority": "P2",
            "created_at": "20/01/2026 10:09:39",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 10:09:40"
          },
          {
            "ticket_id": 6558,
            "ticket_number": "356550",
            "title": "Reminder * Reserva File 424887 * Deadline Hoje 15h",
            "priority": "P1",
            "created_at": "20/01/2026 10:47:04",
            "close_date": "2026-01-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.28,
            "sla_met": false,
            "sla_breach_hours": 6.03,
            "sla_name": "SLA P1",
            "first_response_at": "20/01/2026 17:04:43"
          },
          {
            "ticket_id": 6577,
            "ticket_number": "356569",
            "title": "Confirmação de reserva 337317 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "20/01/2026 11:36:49",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 15:23:01"
          },
          {
            "ticket_id": 6586,
            "ticket_number": "356578",
            "title": "Confirmação e Sinalização de Reserva 210452",
            "priority": "P2",
            "created_at": "20/01/2026 13:25:20",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:23:18"
          },
          {
            "ticket_id": 6590,
            "ticket_number": "356582",
            "title": "Referencia para pagamento | File:424887/2026",
            "priority": "P2",
            "created_at": "20/01/2026 14:29:33",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:08:28"
          },
          {
            "ticket_id": 6591,
            "ticket_number": "356583",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "20/01/2026 14:29:36",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:22:00"
          },
          {
            "ticket_id": 6596,
            "ticket_number": "356588",
            "title": "Cancelamento reserva - SOLTRÓPICO - 336983",
            "priority": "P2",
            "created_at": "20/01/2026 14:41:27",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 14:41:28"
          },
          {
            "ticket_id": 6603,
            "ticket_number": "356595",
            "title": "Faturas Pendentes: FA 2147887996",
            "priority": "P2",
            "created_at": "20/01/2026 15:05:24",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 2.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:05:50"
          },
          {
            "ticket_id": 6616,
            "ticket_number": "356608",
            "title": "Reminder * Reserva File 424887 * Deadline Hoje 15h",
            "priority": "P2",
            "created_at": "20/01/2026 15:57:29",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 16:55:57"
          },
          {
            "ticket_id": 6644,
            "ticket_number": "356636",
            "title": "Cancelamento de reserva 336983",
            "priority": "P2",
            "created_at": "20/01/2026 17:38:10",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:08:36"
          },
          {
            "ticket_id": 6653,
            "ticket_number": "356645",
            "title": "Confirmação e Sinalização de Reserva 210490",
            "priority": "P2",
            "created_at": "20/01/2026 19:11:24",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 23:04:05"
          },
          {
            "ticket_id": 6654,
            "ticket_number": "356646",
            "title": "FATURA FINAL - OPTI 24800032",
            "priority": "P2",
            "created_at": "20/01/2026 19:59:15",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:59:15"
          },
          {
            "ticket_id": 6655,
            "ticket_number": "356647",
            "title": "Re: Reserva: 4017881",
            "priority": "P2",
            "created_at": "20/01/2026 19:59:17",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:59:17"
          },
          {
            "ticket_id": 6667,
            "ticket_number": "356659",
            "title": "ATT CATIA - PEDIDO PAGAMENTO COMISSÕES ",
            "priority": "P2",
            "created_at": "20/01/2026 21:10:51",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 21:10:51"
          },
          {
            "ticket_id": 6669,
            "ticket_number": "356661",
            "title": "Referencia para pagamento | File:425056/2026",
            "priority": "P2",
            "created_at": "20/01/2026 22:06:22",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 13.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 12:04:50"
          },
          {
            "ticket_id": 6672,
            "ticket_number": "356664",
            "title": "Referencia para pagamento | File:425068/2026",
            "priority": "P2",
            "created_at": "20/01/2026 22:12:51",
            "close_date": "2026-01-21",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 12:04:50"
          },
          {
            "ticket_id": 6688,
            "ticket_number": "356680",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3530023",
            "priority": "P3",
            "created_at": "21/01/2026 13:45:57",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 15:03:56"
          },
          {
            "ticket_id": 6690,
            "ticket_number": "356682",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3494614",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:01",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:54:34"
          },
          {
            "ticket_id": 6695,
            "ticket_number": "356687",
            "title": "Payment Reminder – Important Document from Costa C",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:15",
            "close_date": "2026-01-21",
            "sla_target_hours": 24,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 15:11:25"
          },
          {
            "ticket_id": 6697,
            "ticket_number": "356689",
            "title": "Cancelamento",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:21",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:22"
          },
          {
            "ticket_id": 6703,
            "ticket_number": "356695",
            "title": "Confirmação de reserva – Ref PP189225, Sr. Joao Ri",
            "priority": "P1",
            "created_at": "21/01/2026 13:46:38",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/01/2026 14:00:05"
          },
          {
            "ticket_id": 6777,
            "ticket_number": "356769",
            "title": "Re: Comprovativo de pagamento",
            "priority": "P2",
            "created_at": "21/01/2026 18:05:05",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:05:05"
          },
          {
            "ticket_id": 6778,
            "ticket_number": "356770",
            "title": "Fwd: Nova Viagem #260100291 - Viagens by Rita",
            "priority": "P2",
            "created_at": "21/01/2026 18:11:34",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 18:11:35"
          },
          {
            "ticket_id": 6800,
            "ticket_number": "356792",
            "title": "Referencia para pagamento | File:425456/2026",
            "priority": "P2",
            "created_at": "21/01/2026 22:37:06",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 13.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 12:22:30"
          },
          {
            "ticket_id": 6801,
            "ticket_number": "356793",
            "title": "Referencia para pagamento | File:425327/2026",
            "priority": "P2",
            "created_at": "21/01/2026 22:37:08",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 13.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 12:22:30"
          },
          {
            "ticket_id": 6827,
            "ticket_number": "356819",
            "title": "***MUY URGENTE PAGO HOY***LOC.604491711 (LEPLAN)--",
            "priority": "P1",
            "created_at": "22/01/2026 10:15:38",
            "close_date": "2026-01-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.97,
            "sla_met": false,
            "sla_breach_hours": 3.72,
            "sla_name": "SLA P1",
            "first_response_at": "22/01/2026 14:14:08"
          },
          {
            "ticket_id": 6828,
            "ticket_number": "356820",
            "title": "Referencia para pagamento | File:425077/2026",
            "priority": "P1",
            "created_at": "22/01/2026 10:15:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.28,
            "sla_met": false,
            "sla_breach_hours": 3.03,
            "sla_name": "SLA P1",
            "first_response_at": "22/01/2026 13:33:33"
          },
          {
            "ticket_id": 6833,
            "ticket_number": "356825",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P2",
            "created_at": "22/01/2026 10:16:00",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 14:02:51"
          },
          {
            "ticket_id": 6837,
            "ticket_number": "356829",
            "title": "RE: Pagamento 6127246",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:11",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 128.22,
            "sla_met": false,
            "sla_breach_hours": 104.22,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:29:28"
          },
          {
            "ticket_id": 6851,
            "ticket_number": "356843",
            "title": "ARSP-30363: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/01/2026 12:14:57",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 16:03:01"
          },
          {
            "ticket_id": 6852,
            "ticket_number": "356844",
            "title": "ARSP-30362: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/01/2026 12:14:59",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 16:03:01"
          },
          {
            "ticket_id": 6865,
            "ticket_number": "356857",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP189225, Sr/a ",
            "priority": "P1",
            "created_at": "22/01/2026 12:26:57",
            "close_date": "2026-01-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.88,
            "sla_met": false,
            "sla_breach_hours": 5.63,
            "sla_name": "SLA P1",
            "first_response_at": "22/01/2026 18:20:35"
          },
          {
            "ticket_id": 6867,
            "ticket_number": "356859",
            "title": "RE: Pagamento 1770371",
            "priority": "P3",
            "created_at": "22/01/2026 12:51:54",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 33.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 22:41:20"
          },
          {
            "ticket_id": 6869,
            "ticket_number": "356861",
            "title": "Pagamento da reserva – Ref PP294815, Sr. Luis Migu",
            "priority": "P3",
            "created_at": "22/01/2026 12:52:34",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 33.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 22:41:20"
          },
          {
            "ticket_id": 6877,
            "ticket_number": "356869",
            "title": "Confirmação de Valores de Comissão para Emissão de",
            "priority": "P2",
            "created_at": "22/01/2026 14:04:50",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 14:04:50"
          },
          {
            "ticket_id": 6909,
            "ticket_number": "356901",
            "title": "Referencia para pagamento | File:425629/2026",
            "priority": "P1",
            "created_at": "22/01/2026 18:41:56",
            "close_date": "2026-01-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "22/01/2026 18:41:56"
          },
          {
            "ticket_id": 6927,
            "ticket_number": "356919",
            "title": "Re: Nova Viagem #260100312 - O mundo à tua espera",
            "priority": "P2",
            "created_at": "22/01/2026 20:47:10",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 20:47:10"
          },
          {
            "ticket_id": 6934,
            "ticket_number": "356926",
            "title": "Comprovativo pagamento hotel",
            "priority": "P2",
            "created_at": "22/01/2026 21:32:23",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/01/2026 23:51:14"
          },
          {
            "ticket_id": 6943,
            "ticket_number": "356935",
            "title": "Referencia para pagamento | File:425894/2026",
            "priority": "P2",
            "created_at": "23/01/2026 00:07:42",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 00:08:51"
          },
          {
            "ticket_id": 6958,
            "ticket_number": "356950",
            "title": "GBN-97821 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "23/01/2026 10:06:01",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.2,
            "sla_met": false,
            "sla_breach_hours": 7.95,
            "sla_name": "SLA P1",
            "first_response_at": "23/01/2026 18:19:00"
          },
          {
            "ticket_id": 6963,
            "ticket_number": "356955",
            "title": "Criação de processo File 425983/26",
            "priority": "P1",
            "created_at": "23/01/2026 10:06:18",
            "close_date": "2026-01-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.05,
            "sla_met": false,
            "sla_breach_hours": 0.8,
            "sla_name": "SLA P1",
            "first_response_at": "23/01/2026 11:10:17"
          },
          {
            "ticket_id": 6964,
            "ticket_number": "356956",
            "title": "RE: Pagamento 6126963",
            "priority": "P3",
            "created_at": "23/01/2026 10:33:50",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 103.9,
            "sla_met": false,
            "sla_breach_hours": 79.9,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:28:48"
          },
          {
            "ticket_id": 6983,
            "ticket_number": "356975",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "23/01/2026 12:35:53",
            "close_date": "2026-01-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 78.33,
            "sla_met": false,
            "sla_breach_hours": 78.08,
            "sla_name": "SLA P1",
            "first_response_at": "26/01/2026 18:56:53"
          },
          {
            "ticket_id": 6987,
            "ticket_number": "356979",
            "title": "Emissão de fatura",
            "priority": "P3",
            "created_at": "23/01/2026 13:35:09",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 13:35:10"
          },
          {
            "ticket_id": 6993,
            "ticket_number": "356985",
            "title": "Pedido de Comissões",
            "priority": "P3",
            "created_at": "23/01/2026 14:56:07",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:56:07"
          },
          {
            "ticket_id": 6995,
            "ticket_number": "356987",
            "title": "Faturas Pendentes: FA 2147888825",
            "priority": "P2",
            "created_at": "23/01/2026 15:13:46",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 18:22:44"
          },
          {
            "ticket_id": 7007,
            "ticket_number": "356999",
            "title": "Questão sobre faturas",
            "priority": "P3",
            "created_at": "23/01/2026 17:11:32",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 17:11:32"
          },
          {
            "ticket_id": 7040,
            "ticket_number": "357032",
            "title": "Cancelamento de viagem e alteração na OPTI",
            "priority": "P2",
            "created_at": "23/01/2026 21:17:50",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 21:17:50"
          },
          {
            "ticket_id": 7047,
            "ticket_number": "357039",
            "title": "Referencia para pagamento | File:426271/2026",
            "priority": "Reservas sem Formulário",
            "created_at": "23/01/2026 22:29:29",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "23/01/2026 23:33:15"
          },
          {
            "ticket_id": 7049,
            "ticket_number": "357041",
            "title": "Pagamento de luares reserva Smy Loc 1220685395",
            "priority": "P2",
            "created_at": "23/01/2026 22:38:33",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 22:38:33"
          },
          {
            "ticket_id": 7065,
            "ticket_number": "357057",
            "title": "Atividade cancelada: Calçada do Gigante, Titanic E",
            "priority": "P2",
            "created_at": "24/01/2026 09:59:21",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 79.93,
            "sla_met": false,
            "sla_breach_hours": 75.93,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 17:56:17"
          },
          {
            "ticket_id": 7159,
            "ticket_number": "357151",
            "title": "Referencia para pagamento | File:426654/2026",
            "priority": "P2",
            "created_at": "26/01/2026 10:17:34",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 28.35,
            "sla_met": false,
            "sla_breach_hours": 24.35,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:39:07"
          },
          {
            "ticket_id": 7163,
            "ticket_number": "357155",
            "title": "Levantamento Comissões - Rosa dos Ventos",
            "priority": "P2",
            "created_at": "26/01/2026 10:19:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:19:18"
          },
          {
            "ticket_id": 7167,
            "ticket_number": "357159",
            "title": "ATT Cátia Leal",
            "priority": "P2",
            "created_at": "26/01/2026 10:19:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 10:20:00"
          },
          {
            "ticket_id": 7171,
            "ticket_number": "357163",
            "title": "GBN-86731 - Your booking is still pending payment",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:39",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 28.28,
            "sla_met": false,
            "sla_breach_hours": 24.28,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:38:27"
          },
          {
            "ticket_id": 7172,
            "ticket_number": "357164",
            "title": "GBN-100203 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "26/01/2026 10:20:40",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 8.52,
            "sla_met": false,
            "sla_breach_hours": 4.52,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:52:09"
          },
          {
            "ticket_id": 7180,
            "ticket_number": "357172",
            "title": "RE: Pagamento 6128555",
            "priority": "P3",
            "created_at": "26/01/2026 10:21:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 32.1,
            "sla_met": false,
            "sla_breach_hours": 8.1,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:28:22"
          },
          {
            "ticket_id": 7182,
            "ticket_number": "357174",
            "title": "RE: Pagamento 6127240",
            "priority": "P3",
            "created_at": "26/01/2026 10:21:32",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 32.1,
            "sla_met": false,
            "sla_breach_hours": 8.1,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:28:14"
          },
          {
            "ticket_id": 7195,
            "ticket_number": "357187",
            "title": "MSC Cruzeiros | Atualização de Dados Bancários",
            "priority": "P3",
            "created_at": "26/01/2026 11:32:56",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 30.83,
            "sla_met": false,
            "sla_breach_hours": 6.83,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:23:22"
          },
          {
            "ticket_id": 7197,
            "ticket_number": "357189",
            "title": "ARSP-30389: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "26/01/2026 11:33:01",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 7.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 18:50:50"
          },
          {
            "ticket_id": 7203,
            "ticket_number": "357195",
            "title": "Pedido de Sinalização De Reserva 337907",
            "priority": "P1",
            "created_at": "26/01/2026 11:53:09",
            "close_date": "2026-01-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.93,
            "sla_met": false,
            "sla_breach_hours": 6.68,
            "sla_name": "SLA P1",
            "first_response_at": "26/01/2026 18:50:06"
          },
          {
            "ticket_id": 7212,
            "ticket_number": "357204",
            "title": "Pedido de Sinalização De Reserva 337907",
            "priority": "P2",
            "created_at": "26/01/2026 12:25:24",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:22:29"
          },
          {
            "ticket_id": 7213,
            "ticket_number": "357205",
            "title": "Pedido de Sinalização De Reserva 337907",
            "priority": "P1",
            "created_at": "26/01/2026 12:25:27",
            "close_date": "2026-01-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.17,
            "sla_met": false,
            "sla_breach_hours": 5.92,
            "sla_name": "SLA P1",
            "first_response_at": "26/01/2026 18:35:52"
          },
          {
            "ticket_id": 7225,
            "ticket_number": "357217",
            "title": "Confirmação de reserva 337790 ## TIME LIMIT PARA E",
            "priority": "P2",
            "created_at": "26/01/2026 13:49:31",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 17:42:40"
          },
          {
            "ticket_id": 7233,
            "ticket_number": "357225",
            "title": "Solole. Booking I0LT4T9B is close to entering expe",
            "priority": "P2",
            "created_at": "26/01/2026 14:42:05",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 18:33:18"
          },
          {
            "ticket_id": 7241,
            "ticket_number": "357233",
            "title": "Gastos de cancelación reserva 1751036",
            "priority": "P1",
            "created_at": "26/01/2026 15:10:13",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 99.03,
            "sla_met": false,
            "sla_breach_hours": 98.78,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 18:12:38"
          },
          {
            "ticket_id": 7242,
            "ticket_number": "357234",
            "title": "Fatura de Comissões - OPTI 24100786",
            "priority": "P3",
            "created_at": "26/01/2026 16:19:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 16:19:05"
          },
          {
            "ticket_id": 7284,
            "ticket_number": "357276",
            "title": "Referencia para pagamento | File:425327/2026",
            "priority": "P2",
            "created_at": "26/01/2026 22:11:54",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 22:37:47"
          },
          {
            "ticket_id": 7307,
            "ticket_number": "357299",
            "title": "GBN-86731 - Your booking is still pending payment",
            "priority": "P1",
            "created_at": "27/01/2026 10:10:18",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.73,
            "sla_met": false,
            "sla_breach_hours": 8.48,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 18:54:43"
          },
          {
            "ticket_id": 7309,
            "ticket_number": "357301",
            "title": "GBN-100203 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "27/01/2026 10:10:22",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.38,
            "sla_met": false,
            "sla_breach_hours": 4.13,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 14:33:24"
          },
          {
            "ticket_id": 7311,
            "ticket_number": "357303",
            "title": "GBN-86947 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "27/01/2026 10:10:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:04:11"
          },
          {
            "ticket_id": 7324,
            "ticket_number": "357316",
            "title": "RE: Pagamento 6128608",
            "priority": "P3",
            "created_at": "27/01/2026 10:14:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:17:46"
          },
          {
            "ticket_id": 7325,
            "ticket_number": "357317",
            "title": "RE: Pagamento 6128736",
            "priority": "P3",
            "created_at": "27/01/2026 10:14:19",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:17:30"
          },
          {
            "ticket_id": 7326,
            "ticket_number": "357318",
            "title": "RE: Pagamento 6127888",
            "priority": "P3",
            "created_at": "27/01/2026 10:14:21",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:17:14"
          },
          {
            "ticket_id": 7327,
            "ticket_number": "357319",
            "title": "RE: Pagamento 6127890",
            "priority": "P3",
            "created_at": "27/01/2026 10:14:24",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:17:02"
          },
          {
            "ticket_id": 7328,
            "ticket_number": "357320",
            "title": "RE: Pagamento 6128553",
            "priority": "P3",
            "created_at": "27/01/2026 10:14:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:16:48"
          },
          {
            "ticket_id": 7329,
            "ticket_number": "357321",
            "title": "Re: Pedido de orçamento Grupo",
            "priority": "P3",
            "created_at": "27/01/2026 10:37:10",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 6.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 17:35:07"
          },
          {
            "ticket_id": 7330,
            "ticket_number": "357322",
            "title": "RE: Pagamento 6128988",
            "priority": "P3",
            "created_at": "27/01/2026 10:37:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 7.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:16:19"
          },
          {
            "ticket_id": 7331,
            "ticket_number": "357323",
            "title": "RE: Pagamento 6128814",
            "priority": "P2",
            "created_at": "27/01/2026 10:37:15",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:24:14"
          },
          {
            "ticket_id": 7332,
            "ticket_number": "357324",
            "title": "RE: Pagamento 6128558",
            "priority": "P3",
            "created_at": "27/01/2026 10:37:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 7.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:15:14"
          },
          {
            "ticket_id": 7333,
            "ticket_number": "357325",
            "title": "RE: Pagamento 6129257",
            "priority": "P3",
            "created_at": "27/01/2026 10:37:19",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 7.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:14:39"
          },
          {
            "ticket_id": 7341,
            "ticket_number": "357333",
            "title": "Pedido de reembolso",
            "priority": "P2",
            "created_at": "27/01/2026 12:22:13",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 12:22:13"
          },
          {
            "ticket_id": 7351,
            "ticket_number": "357343",
            "title": "Gastos de cancelación reserva 1751036",
            "priority": "P2",
            "created_at": "27/01/2026 14:17:43",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 14:29:23"
          },
          {
            "ticket_id": 7352,
            "ticket_number": "357344",
            "title": "canecamentos gbn",
            "priority": "P3",
            "created_at": "27/01/2026 14:41:24",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 14:41:25"
          },
          {
            "ticket_id": 7359,
            "ticket_number": "357351",
            "title": "cancelamento veturis",
            "priority": "P3",
            "created_at": "27/01/2026 14:50:34",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 14:50:34"
          },
          {
            "ticket_id": 7365,
            "ticket_number": "357357",
            "title": "CANCELAMENTO  59329R w2m",
            "priority": "P3",
            "created_at": "27/01/2026 15:39:05",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 15:39:05"
          },
          {
            "ticket_id": 7366,
            "ticket_number": "357358",
            "title": "Viagem interlines",
            "priority": "P3",
            "created_at": "27/01/2026 16:01:14",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 16:01:14"
          },
          {
            "ticket_id": 7373,
            "ticket_number": "357365",
            "title": "Recibo verde-Daniela Cruz",
            "priority": "P3",
            "created_at": "27/01/2026 16:30:10",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 16:30:10"
          },
          {
            "ticket_id": 7388,
            "ticket_number": "357380",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "27/01/2026 17:08:17",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.9,
            "sla_met": false,
            "sla_breach_hours": 2.65,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 20:03:12"
          },
          {
            "ticket_id": 7389,
            "ticket_number": "357381",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "27/01/2026 17:08:19",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.9,
            "sla_met": false,
            "sla_breach_hours": 2.65,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 20:02:27"
          },
          {
            "ticket_id": 7391,
            "ticket_number": "357383",
            "title": "Referencia para pagamento | File:426525/2026",
            "priority": "P1",
            "created_at": "27/01/2026 17:35:00",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.4,
            "sla_met": false,
            "sla_breach_hours": 2.15,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 19:59:48"
          },
          {
            "ticket_id": 7396,
            "ticket_number": "357388",
            "title": "Confirmação de Reserva * File 426525 - EMISSÃO HOJ",
            "priority": "P1",
            "created_at": "27/01/2026 17:35:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.3,
            "sla_met": false,
            "sla_breach_hours": 1.05,
            "sla_name": "SLA P1",
            "first_response_at": "27/01/2026 18:53:32"
          },
          {
            "ticket_id": 7409,
            "ticket_number": "357401",
            "title": "Referencia para pagamento | File:426525/2026",
            "priority": "P2",
            "created_at": "27/01/2026 18:24:52",
            "close_date": "2026-01-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 20:01:23"
          },
          {
            "ticket_id": 7412,
            "ticket_number": "357404",
            "title": "Cancelar Reserva",
            "priority": "P3",
            "created_at": "27/01/2026 18:25:03",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:25:03"
          },
          {
            "ticket_id": 7425,
            "ticket_number": "357417",
            "title": "Confirmacao 338272",
            "priority": "P1",
            "created_at": "27/01/2026 19:14:56",
            "close_date": "2026-02-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 137.57,
            "sla_met": false,
            "sla_breach_hours": 137.32,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 12:49:06"
          },
          {
            "ticket_id": 7434,
            "ticket_number": "357426",
            "title": "Faturação final OPTI 2428800002 indicador LePlan 6",
            "priority": "P2",
            "created_at": "27/01/2026 19:54:17",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 19:54:18"
          },
          {
            "ticket_id": 7460,
            "ticket_number": "357452",
            "title": "Referencia para pagamento | File:416895/2025",
            "priority": "P2",
            "created_at": "27/01/2026 22:13:12",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 22:14:57"
          },
          {
            "ticket_id": 7473,
            "ticket_number": "357465",
            "title": "Confirmacao 338301",
            "priority": "P1",
            "created_at": "28/01/2026 10:26:39",
            "close_date": "2026-01-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.9,
            "sla_met": false,
            "sla_breach_hours": 3.65,
            "sla_name": "SLA P1",
            "first_response_at": "28/01/2026 14:21:16"
          },
          {
            "ticket_id": 7488,
            "ticket_number": "357480",
            "title": "A/C - Cátia Leal -  Retificação de documentos",
            "priority": "P3",
            "created_at": "28/01/2026 10:29:28",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:29:29"
          },
          {
            "ticket_id": 7493,
            "ticket_number": "357485",
            "title": "recibos verdes",
            "priority": "P3",
            "created_at": "28/01/2026 10:30:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 20:23:44"
          },
          {
            "ticket_id": 7497,
            "ticket_number": "357489",
            "title": "Cancelamento de reserva 337002",
            "priority": "P3",
            "created_at": "28/01/2026 11:40:18",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 6.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 17:57:51"
          },
          {
            "ticket_id": 7515,
            "ticket_number": "357507",
            "title": "Solole. Booking I0LT4T9B is close to entering expe",
            "priority": "P1",
            "created_at": "28/01/2026 15:45:52",
            "close_date": "2026-01-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.53,
            "sla_met": false,
            "sla_breach_hours": 2.28,
            "sla_name": "SLA P1",
            "first_response_at": "28/01/2026 18:18:23"
          },
          {
            "ticket_id": 7541,
            "ticket_number": "357533",
            "title": "GBN-101935 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/01/2026 17:16:53",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 19:02:05"
          },
          {
            "ticket_id": 7546,
            "ticket_number": "357538",
            "title": "Pagamento de Comissões",
            "priority": "P2",
            "created_at": "28/01/2026 18:06:19",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 18:06:20"
          },
          {
            "ticket_id": 7561,
            "ticket_number": "357553",
            "title": "Re:[## 30420 ##] GBN-97247 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "28/01/2026 19:20:55",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 24.12,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 19:28:39"
          },
          {
            "ticket_id": 7574,
            "ticket_number": "357566",
            "title": "Referencia para pagamento | File:427403/2026",
            "priority": "P1",
            "created_at": "29/01/2026 10:24:35",
            "close_date": "2026-01-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.4,
            "sla_met": false,
            "sla_breach_hours": 6.15,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 16:48:56"
          },
          {
            "ticket_id": 7575,
            "ticket_number": "357567",
            "title": "Recibo Comissoes",
            "priority": "P3",
            "created_at": "29/01/2026 10:24:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:24:39"
          },
          {
            "ticket_id": 7581,
            "ticket_number": "357573",
            "title": "RE: Pagamento 6127527",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:00",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7582,
            "ticket_number": "357574",
            "title": "RE: Pagamento 6129227",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:02",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7583,
            "ticket_number": "357575",
            "title": "RE: Pagamento 6128601",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:05",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7584,
            "ticket_number": "357576",
            "title": "RE: Pagamento 6129746",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:07",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7585,
            "ticket_number": "357577",
            "title": "RE: Pagamento 604532920",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:09",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7588,
            "ticket_number": "357580",
            "title": "RE: Pagamento 6127520",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:16",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:38"
          },
          {
            "ticket_id": 7617,
            "ticket_number": "357609",
            "title": "RE: Pagamento 6129118",
            "priority": "P3",
            "created_at": "29/01/2026 11:19:28",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 148.83,
            "sla_met": false,
            "sla_breach_hours": 124.83,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:09:48"
          },
          {
            "ticket_id": 7618,
            "ticket_number": "357610",
            "title": "RE: Pagamento 6129064",
            "priority": "P3",
            "created_at": "29/01/2026 11:19:30",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 148.83,
            "sla_met": false,
            "sla_breach_hours": 124.83,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:09:40"
          },
          {
            "ticket_id": 7621,
            "ticket_number": "357613",
            "title": "ARSP-30389: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "29/01/2026 11:19:41",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 32.48,
            "sla_met": false,
            "sla_breach_hours": 32.23,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:49:13"
          },
          {
            "ticket_id": 7623,
            "ticket_number": "357615",
            "title": "COSTA CRUZEIROS — Atualização urgente dos dados ba",
            "priority": "P2",
            "created_at": "29/01/2026 11:19:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 128.05,
            "sla_met": false,
            "sla_breach_hours": 124.05,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 19:23:27"
          },
          {
            "ticket_id": 7627,
            "ticket_number": "357619",
            "title": "Reminder * Reserva File 427403 * Deadline Hoje 13H",
            "priority": "P1",
            "created_at": "29/01/2026 11:19:57",
            "close_date": "2026-01-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.47,
            "sla_met": false,
            "sla_breach_hours": 5.22,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 16:48:41"
          },
          {
            "ticket_id": 7638,
            "ticket_number": "357630",
            "title": "Referencia para pagamento | File:427403/2026",
            "priority": "P1",
            "created_at": "29/01/2026 12:56:44",
            "close_date": "2026-01-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 13:02:57"
          },
          {
            "ticket_id": 7657,
            "ticket_number": "357649",
            "title": "Criação de processo File 427582/26",
            "priority": "P1",
            "created_at": "29/01/2026 15:54:52",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.8,
            "sla_met": false,
            "sla_breach_hours": 3.55,
            "sla_name": "SLA P1",
            "first_response_at": "29/01/2026 19:43:32"
          },
          {
            "ticket_id": 7687,
            "ticket_number": "357679",
            "title": "GBN-85400 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "30/01/2026 10:08:14",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.67,
            "sla_met": false,
            "sla_breach_hours": 9.42,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:48:54"
          },
          {
            "ticket_id": 7689,
            "ticket_number": "357681",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP122216, Sr/a ",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:18",
            "close_date": "2026-01-30",
            "sla_target_hours": 24,
            "actual_time_hours": 9.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 19:48:28"
          },
          {
            "ticket_id": 7690,
            "ticket_number": "357682",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:21",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 176.57,
            "sla_met": false,
            "sla_breach_hours": 152.57,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:42:51"
          },
          {
            "ticket_id": 7697,
            "ticket_number": "357689",
            "title": "KIT BTL | Pagamento Débora",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:39",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:40"
          },
          {
            "ticket_id": 7712,
            "ticket_number": "357704",
            "title": "RECIBO VERDE - OPTI 24800032",
            "priority": "P3",
            "created_at": "30/01/2026 10:10:05",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:10:05"
          },
          {
            "ticket_id": 7714,
            "ticket_number": "357706",
            "title": "Referencia para pagamento | File:427582/2026",
            "priority": "P1",
            "created_at": "30/01/2026 10:10:10",
            "close_date": "2026-02-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.45,
            "sla_met": false,
            "sla_breach_hours": 1.2,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 11:38:08"
          },
          {
            "ticket_id": 7733,
            "ticket_number": "357725",
            "title": "ARSP-30389: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "30/01/2026 10:12:35",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.87,
            "sla_met": false,
            "sla_breach_hours": 3.62,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 14:04:43"
          },
          {
            "ticket_id": 7743,
            "ticket_number": "357735",
            "title": "RE: Pedido de contrataçao direta",
            "priority": "P2",
            "created_at": "30/01/2026 11:32:31",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 15:24:50"
          },
          {
            "ticket_id": 7760,
            "ticket_number": "357752",
            "title": "ARSP-30389: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "30/01/2026 13:16:22",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.48,
            "sla_met": false,
            "sla_breach_hours": 6.23,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:45:59"
          },
          {
            "ticket_id": 7769,
            "ticket_number": "357761",
            "title": "Emissão de fatura",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:16:55"
          },
          {
            "ticket_id": 7776,
            "ticket_number": "357768",
            "title": "ARSP-30389: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "30/01/2026 13:17:25",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.47,
            "sla_met": false,
            "sla_breach_hours": 6.22,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:45:27"
          },
          {
            "ticket_id": 7813,
            "ticket_number": "357805",
            "title": "Confirmacao 338629",
            "priority": "P1",
            "created_at": "30/01/2026 16:53:59",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.03,
            "sla_met": false,
            "sla_breach_hours": 0.78,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 17:56:20"
          },
          {
            "ticket_id": 7818,
            "ticket_number": "357810",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "30/01/2026 16:59:51",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.67,
            "sla_met": false,
            "sla_breach_hours": 2.42,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:40:34"
          },
          {
            "ticket_id": 7819,
            "ticket_number": "357811",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "30/01/2026 16:59:56",
            "close_date": "2026-01-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.65,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P1",
            "first_response_at": "30/01/2026 19:39:40"
          },
          {
            "ticket_id": 7848,
            "ticket_number": "357840",
            "title": "Cancelamento de Reserva 210951",
            "priority": "P3",
            "created_at": "30/01/2026 19:28:54",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 19:31:44"
          },
          {
            "ticket_id": 7854,
            "ticket_number": "357846",
            "title": "Cliente transferiu dinheiro por engano",
            "priority": "P2",
            "created_at": "30/01/2026 19:37:07",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:37:07"
          },
          {
            "ticket_id": 7857,
            "ticket_number": "357849",
            "title": "Soltour.es - Localizador SPT002601580881: pago efe",
            "priority": "P2",
            "created_at": "30/01/2026 20:11:03",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 20:59:26"
          },
          {
            "ticket_id": 7868,
            "ticket_number": "357860",
            "title": "Re:[## 30702 ##] GBN-102513 - Seu pedido foi receb",
            "priority": "P3",
            "created_at": "30/01/2026 23:10:52",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 63.88,
            "sla_met": false,
            "sla_breach_hours": 39.88,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 15:04:00"
          },
          {
            "ticket_id": 7897,
            "ticket_number": "357889",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "31/01/2026 10:46:12",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 77.47,
            "sla_met": false,
            "sla_breach_hours": 73.47,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 16:15:01"
          },
          {
            "ticket_id": 7898,
            "ticket_number": "357890",
            "title": "GBN-91007 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "31/01/2026 10:46:14",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 51.25,
            "sla_met": false,
            "sla_breach_hours": 27.25,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:01:57"
          },
          {
            "ticket_id": 7909,
            "ticket_number": "357901",
            "title": "Soltour.es - Localizador SPT002601581157: pago efe",
            "priority": "P2",
            "created_at": "31/01/2026 13:03:42",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 13:10:16"
          },
          {
            "ticket_id": 7915,
            "ticket_number": "357907",
            "title": "Comissão",
            "priority": "P3",
            "created_at": "31/01/2026 14:23:37",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 14:23:38"
          },
          {
            "ticket_id": 7931,
            "ticket_number": "357923",
            "title": "RE: Pagamento 6129184",
            "priority": "P3",
            "created_at": "02/02/2026 10:07:50",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.02,
            "sla_met": false,
            "sla_breach_hours": 30.02,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:09:21"
          },
          {
            "ticket_id": 7932,
            "ticket_number": "357924",
            "title": "RE: Pagamento 6129187",
            "priority": "P3",
            "created_at": "02/02/2026 10:07:52",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.02,
            "sla_met": false,
            "sla_breach_hours": 30.02,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:09:13"
          },
          {
            "ticket_id": 7933,
            "ticket_number": "357925",
            "title": "RE: Pagamento 6128947",
            "priority": "P3",
            "created_at": "02/02/2026 10:07:54",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.02,
            "sla_met": false,
            "sla_breach_hours": 30.02,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:09:03"
          },
          {
            "ticket_id": 7934,
            "ticket_number": "357926",
            "title": "RE: Pagamento 6130379",
            "priority": "P3",
            "created_at": "02/02/2026 10:07:57",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.0,
            "sla_met": false,
            "sla_breach_hours": 30.0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:08:52"
          },
          {
            "ticket_id": 7935,
            "ticket_number": "357927",
            "title": "RE: Pagamento 6129191",
            "priority": "P3",
            "created_at": "02/02/2026 10:07:59",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.0,
            "sla_met": false,
            "sla_breach_hours": 30.0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:08:38"
          },
          {
            "ticket_id": 7936,
            "ticket_number": "357928",
            "title": "RE: Pagamento 6130386",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:01",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.0,
            "sla_met": false,
            "sla_breach_hours": 30.0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:08:19"
          },
          {
            "ticket_id": 7938,
            "ticket_number": "357930",
            "title": "RE: Pagamento 6128960",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:07",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 54.0,
            "sla_met": false,
            "sla_breach_hours": 30.0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:08:09"
          },
          {
            "ticket_id": 7939,
            "ticket_number": "357931",
            "title": "Automatic reply: [OUTSIDE EMAIL] Pagamento 3459621",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:10",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:07:36"
          },
          {
            "ticket_id": 7940,
            "ticket_number": "357932",
            "title": "RE: Pagamento 6129181",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:12",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 53.98,
            "sla_met": false,
            "sla_breach_hours": 29.98,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:07:24"
          },
          {
            "ticket_id": 7955,
            "ticket_number": "357947",
            "title": "GBN-95521 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "02/02/2026 10:09:00",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:02:09"
          },
          {
            "ticket_id": 7956,
            "ticket_number": "357948",
            "title": "Referencia para pagamento | File:427856/2026",
            "priority": "P1",
            "created_at": "02/02/2026 10:09:36",
            "close_date": "2026-02-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.27,
            "sla_met": false,
            "sla_breach_hours": 54.02,
            "sla_name": "SLA P1",
            "first_response_at": "04/02/2026 16:26:06"
          },
          {
            "ticket_id": 7973,
            "ticket_number": "357965",
            "title": "GBN-91007 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "02/02/2026 10:16:27",
            "close_date": "2026-02-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.47,
            "sla_met": false,
            "sla_breach_hours": 0.22,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 10:44:54"
          },
          {
            "ticket_id": 7979,
            "ticket_number": "357971",
            "title": "GBN-95521 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "02/02/2026 10:16:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 30.48,
            "sla_met": false,
            "sla_breach_hours": 6.48,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 16:46:14"
          },
          {
            "ticket_id": 7987,
            "ticket_number": "357979",
            "title": "Criação de processo File 428177/26",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:29",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 13:54:04"
          },
          {
            "ticket_id": 8001,
            "ticket_number": "357993",
            "title": "Criação de processo File 428193/26",
            "priority": "P1",
            "created_at": "02/02/2026 10:18:56",
            "close_date": "2026-02-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.08,
            "sla_met": false,
            "sla_breach_hours": 0.83,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 11:24:13"
          },
          {
            "ticket_id": 8010,
            "ticket_number": "358002",
            "title": "Referencia para pagamento | File:428139/2026",
            "priority": "P1",
            "created_at": "02/02/2026 10:22:04",
            "close_date": "2026-02-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.63,
            "sla_met": false,
            "sla_breach_hours": 2.38,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 13:00:27"
          },
          {
            "ticket_id": 8016,
            "ticket_number": "358008",
            "title": "Referencia para pagamento | File:428177/2026",
            "priority": "P2",
            "created_at": "02/02/2026 10:22:23",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 29.73,
            "sla_met": false,
            "sla_breach_hours": 25.73,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 16:07:05"
          },
          {
            "ticket_id": 8039,
            "ticket_number": "358031",
            "title": "ARSP-30485: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "02/02/2026 10:48:06",
            "close_date": "2026-02-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 10:48:32"
          },
          {
            "ticket_id": 8054,
            "ticket_number": "358046",
            "title": "Recordatorio prepago reserva: 1757952",
            "priority": "P3",
            "created_at": "02/02/2026 12:49:03",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 5.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 18:40:22"
          },
          {
            "ticket_id": 8071,
            "ticket_number": "358063",
            "title": "FW: A/C - Cátia Leal -  Retificação de documentos",
            "priority": "P3",
            "created_at": "02/02/2026 13:39:17",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 13:39:17"
          },
          {
            "ticket_id": 8076,
            "ticket_number": "358068",
            "title": "ARSP-30489: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "02/02/2026 14:04:56",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 4.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 18:33:45"
          },
          {
            "ticket_id": 8078,
            "ticket_number": "358070",
            "title": "ARSP-30485: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "02/02/2026 14:05:05",
            "close_date": "2026-02-02",
            "sla_target_hours": 24,
            "actual_time_hours": 4.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 18:31:36"
          },
          {
            "ticket_id": 8082,
            "ticket_number": "358074",
            "title": "SOLICITAMOS DOCUMENTAÇÃO LOCALIZADOR SOLFÉRIAS: 41",
            "priority": "P1",
            "created_at": "02/02/2026 14:45:49",
            "close_date": "2026-02-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 14:45:49"
          },
          {
            "ticket_id": 8094,
            "ticket_number": "358086",
            "title": "1170852169 smy",
            "priority": "P1",
            "created_at": "02/02/2026 16:40:04",
            "close_date": "2026-03-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.35,
            "sla_met": false,
            "sla_breach_hours": 3.1,
            "sla_name": "SLA P1",
            "first_response_at": "02/02/2026 20:01:40"
          },
          {
            "ticket_id": 8110,
            "ticket_number": "358102",
            "title": "correção valor opti 2414900020",
            "priority": "P2",
            "created_at": "02/02/2026 18:12:51",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 18:12:51"
          },
          {
            "ticket_id": 8111,
            "ticket_number": "358103",
            "title": "Referencia para pagamento | File:415693/2025",
            "priority": "P2",
            "created_at": "02/02/2026 18:20:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 21.73,
            "sla_met": false,
            "sla_breach_hours": 17.73,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 16:04:49"
          },
          {
            "ticket_id": 8181,
            "ticket_number": "358173",
            "title": "Valor das comissões",
            "priority": "P2",
            "created_at": "03/02/2026 12:40:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 12:40:07"
          },
          {
            "ticket_id": 8193,
            "ticket_number": "358185",
            "title": "Fwd: Informações da sua reserva",
            "priority": "P3",
            "created_at": "03/02/2026 14:17:03",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 14:17:03"
          },
          {
            "ticket_id": 8197,
            "ticket_number": "358189",
            "title": "a/C catia leal- opti242100184",
            "priority": "P3",
            "created_at": "03/02/2026 15:06:03",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 1178.45,
            "sla_met": false,
            "sla_breach_hours": 1154.45,
            "sla_name": "SLA P3",
            "first_response_at": "24/03/2026 17:33:12"
          },
          {
            "ticket_id": 8203,
            "ticket_number": "358195",
            "title": "Confirmação de comissões",
            "priority": "P3",
            "created_at": "03/02/2026 15:15:25",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 15:15:26"
          },
          {
            "ticket_id": 8207,
            "ticket_number": "358199",
            "title": "Pedido de cancelamento reserva",
            "priority": "P3",
            "created_at": "03/02/2026 15:53:05",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 15:53:05"
          },
          {
            "ticket_id": 8208,
            "ticket_number": "358200",
            "title": "Re:[## 30852 ##] GBN-102989 - Seu pedido foi receb",
            "priority": "P3",
            "created_at": "03/02/2026 15:53:08",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 16:58:10"
          },
          {
            "ticket_id": 8212,
            "ticket_number": "358204",
            "title": "Re: Alteração de valores [#346190]",
            "priority": "P2",
            "created_at": "03/02/2026 17:18:01",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 22.58,
            "sla_met": false,
            "sla_breach_hours": 18.58,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 15:53:35"
          },
          {
            "ticket_id": 8215,
            "ticket_number": "358207",
            "title": "Reserva cancelada com localizador: 4047290",
            "priority": "P3",
            "created_at": "03/02/2026 17:18:09",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 5.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 22:25:16"
          },
          {
            "ticket_id": 8216,
            "ticket_number": "358208",
            "title": "OPTIGEST | Ticket #346190 | Ticket Criado / Ticket",
            "priority": "P3",
            "created_at": "03/02/2026 17:18:45",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 22.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 16:06:27"
          },
          {
            "ticket_id": 8243,
            "ticket_number": "358235",
            "title": "RE: Icárion - Praslin & Mahé - Feira Noivos - 2026",
            "priority": "P1",
            "created_at": "03/02/2026 21:44:29",
            "close_date": "2026-02-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/02/2026 21:44:30"
          },
          {
            "ticket_id": 8244,
            "ticket_number": "358236",
            "title": "Referencia para pagamento | File:426271/2026",
            "priority": "P3",
            "created_at": "03/02/2026 22:08:47",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 20.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 18:16:56"
          },
          {
            "ticket_id": 8269,
            "ticket_number": "358261",
            "title": "GBN-102629 - Sua reserva está pendente de pagament",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:32",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 34.0,
            "sla_met": false,
            "sla_breach_hours": 10.0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 20:21:32"
          },
          {
            "ticket_id": 8273,
            "ticket_number": "358265",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P3",
            "created_at": "04/02/2026 10:21:41",
            "close_date": "2026-02-04",
            "sla_target_hours": 24,
            "actual_time_hours": 5.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 15:55:38"
          },
          {
            "ticket_id": 8280,
            "ticket_number": "358272",
            "title": "Comissão - Nova Viagem #260100116 - OPTI 24940000",
            "priority": "P2",
            "created_at": "04/02/2026 11:41:02",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 11:41:03"
          },
          {
            "ticket_id": 8284,
            "ticket_number": "358276",
            "title": "Re: 336983",
            "priority": "P2",
            "created_at": "04/02/2026 12:20:24",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1549.75,
            "sla_met": false,
            "sla_breach_hours": 1545.75,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 02:06:07"
          },
          {
            "ticket_id": 8303,
            "ticket_number": "358295",
            "title": "Alteração de valores [#346190]",
            "priority": "P2",
            "created_at": "04/02/2026 16:13:57",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 987.2,
            "sla_met": false,
            "sla_breach_hours": 983.2,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 19:26:34"
          },
          {
            "ticket_id": 8309,
            "ticket_number": "358301",
            "title": "CORREÇÃO URGENTE FATURA OPTI Nº 2414900020",
            "priority": "P1",
            "created_at": "04/02/2026 17:05:42",
            "close_date": "2026-02-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/02/2026 17:05:43"
          },
          {
            "ticket_id": 8314,
            "ticket_number": "358306",
            "title": "FW: A/C - Cátia Leal -  Retificação de documentos ",
            "priority": "P2",
            "created_at": "04/02/2026 17:24:53",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:24:53"
          },
          {
            "ticket_id": 8322,
            "ticket_number": "358314",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "04/02/2026 17:55:22",
            "close_date": "2026-02-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/02/2026 18:04:13"
          },
          {
            "ticket_id": 8323,
            "ticket_number": "358315",
            "title": "FW: Icárion - Praslin & Mahé - Feira Noivos - 2026",
            "priority": "P1",
            "created_at": "04/02/2026 18:15:23",
            "close_date": "2026-02-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/02/2026 18:15:23"
          },
          {
            "ticket_id": 8335,
            "ticket_number": "358327",
            "title": "Recibo Verde - 01 - 2026",
            "priority": "P2",
            "created_at": "04/02/2026 20:25:54",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 20:25:55"
          },
          {
            "ticket_id": 8345,
            "ticket_number": "358337",
            "title": "Cancelamento da reserva GBN 103544",
            "priority": "P2",
            "created_at": "04/02/2026 21:31:35",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 21:31:36"
          },
          {
            "ticket_id": 8352,
            "ticket_number": "358344",
            "title": "Comissões Mês de fevereiro",
            "priority": "P2",
            "created_at": "04/02/2026 23:33:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 23:33:46"
          },
          {
            "ticket_id": 8368,
            "ticket_number": "358360",
            "title": "SmartParking - Envio de documento",
            "priority": "P1",
            "created_at": "05/02/2026 10:02:31",
            "close_date": "2026-02-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.0,
            "sla_met": false,
            "sla_breach_hours": 0.75,
            "sla_name": "SLA P1",
            "first_response_at": "05/02/2026 11:03:12"
          },
          {
            "ticket_id": 8369,
            "ticket_number": "358361",
            "title": "GBN-99921 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 104.88,
            "sla_met": false,
            "sla_breach_hours": 80.88,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:56:07"
          },
          {
            "ticket_id": 8370,
            "ticket_number": "358362",
            "title": "GBN-102629 - Sua reserva está pendente de pagament",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:37",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 7.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 17:49:39"
          },
          {
            "ticket_id": 8372,
            "ticket_number": "358364",
            "title": "GBN-102151 - Sua reserva está pendente de pagament",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:41",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 7.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 17:51:00"
          },
          {
            "ticket_id": 8418,
            "ticket_number": "358410",
            "title": "Cotação Hotel porto santo",
            "priority": "P2",
            "created_at": "05/02/2026 14:13:36",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 14:13:36"
          },
          {
            "ticket_id": 8435,
            "ticket_number": "358427",
            "title": "Pedido de pagamento Soltropico",
            "priority": "P1",
            "created_at": "05/02/2026 15:39:50",
            "close_date": "2026-02-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/02/2026 15:39:50"
          },
          {
            "ticket_id": 8452,
            "ticket_number": "358444",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "05/02/2026 18:07:23",
            "close_date": "2026-02-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/02/2026 18:21:10"
          },
          {
            "ticket_id": 8457,
            "ticket_number": "358449",
            "title": "Fwd: URGENTE - retirada de saldo em plataforma",
            "priority": "P3",
            "created_at": "05/02/2026 18:56:23",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 173.83,
            "sla_met": false,
            "sla_breach_hours": 149.83,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 00:46:32"
          },
          {
            "ticket_id": 8492,
            "ticket_number": "358484",
            "title": "GBN-102151 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "06/02/2026 10:08:55",
            "close_date": "2026-02-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.48,
            "sla_met": false,
            "sla_breach_hours": 8.23,
            "sla_name": "SLA P1",
            "first_response_at": "06/02/2026 18:38:12"
          },
          {
            "ticket_id": 8497,
            "ticket_number": "358489",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P3",
            "created_at": "06/02/2026 10:09:14",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 80.77,
            "sla_met": false,
            "sla_breach_hours": 56.77,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:55:26"
          },
          {
            "ticket_id": 8506,
            "ticket_number": "358498",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "06/02/2026 11:46:53",
            "close_date": "2026-02-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.32,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P1",
            "first_response_at": "06/02/2026 20:06:34"
          },
          {
            "ticket_id": 8507,
            "ticket_number": "358499",
            "title": "Comprovativo de pagamento Soltropico - urgente",
            "priority": "P1",
            "created_at": "06/02/2026 11:46:59",
            "close_date": "2026-02-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/02/2026 11:47:00"
          },
          {
            "ticket_id": 8527,
            "ticket_number": "358519",
            "title": "Faturas Pendentes: FA 2147892196",
            "priority": "P2",
            "created_at": "06/02/2026 14:03:05",
            "close_date": "2026-02-06",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 18:15:19"
          },
          {
            "ticket_id": 8540,
            "ticket_number": "358532",
            "title": "Notificação Transferência Nacional Santander",
            "priority": "P3",
            "created_at": "06/02/2026 16:22:16",
            "close_date": "2026-03-24",
            "sla_target_hours": 24,
            "actual_time_hours": 1105.25,
            "sla_met": false,
            "sla_breach_hours": 1081.25,
            "sla_name": "SLA P3",
            "first_response_at": "24/03/2026 17:37:18"
          },
          {
            "ticket_id": 8582,
            "ticket_number": "358574",
            "title": "Confirmacao 339139",
            "priority": "P2",
            "created_at": "06/02/2026 22:11:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 22:52:53"
          },
          {
            "ticket_id": 8604,
            "ticket_number": "358596",
            "title": "GBN-95291 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "07/02/2026 10:03:30",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 56.53,
            "sla_met": false,
            "sla_breach_hours": 52.53,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 18:35:39"
          },
          {
            "ticket_id": 8633,
            "ticket_number": "358625",
            "title": "FW: SignRequest sent: RGPD 24100697.docx",
            "priority": "P3",
            "created_at": "07/02/2026 15:47:04",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 15:47:05"
          },
          {
            "ticket_id": 8648,
            "ticket_number": "358640",
            "title": "Código promocional - RateHawk",
            "priority": "P3",
            "created_at": "09/02/2026 10:21:35",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8652,
            "ticket_number": "358644",
            "title": "GBN-102186 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "09/02/2026 10:21:46",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.43,
            "sla_met": false,
            "sla_breach_hours": 8.18,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:47:53"
          },
          {
            "ticket_id": 8653,
            "ticket_number": "358645",
            "title": "GBN-94696 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "09/02/2026 10:21:48",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:52:55"
          },
          {
            "ticket_id": 8654,
            "ticket_number": "358646",
            "title": "GBN-102183 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "09/02/2026 10:21:51",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.33,
            "sla_met": false,
            "sla_breach_hours": 8.08,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:42:17"
          },
          {
            "ticket_id": 8655,
            "ticket_number": "358647",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P3",
            "created_at": "09/02/2026 10:21:53",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 32.48,
            "sla_met": false,
            "sla_breach_hours": 8.48,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:51:41"
          },
          {
            "ticket_id": 8656,
            "ticket_number": "358648",
            "title": "GBN-94729 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "09/02/2026 10:21:56",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 8.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:48:41"
          },
          {
            "ticket_id": 8657,
            "ticket_number": "358649",
            "title": "RE: Pagamento 6131284",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:11",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8658,
            "ticket_number": "358650",
            "title": "RE: Pagamento 6131228",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:13",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8659,
            "ticket_number": "358651",
            "title": "RE: Pagamento 6131281",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:16",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8661,
            "ticket_number": "358653",
            "title": "RE: Pagamento 6131286",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:23",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8662,
            "ticket_number": "358654",
            "title": "RE: Pagamento 6131287",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:26",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 33.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:20:30"
          },
          {
            "ticket_id": 8667,
            "ticket_number": "358659",
            "title": "Pagamento efetuado a mais - Reserva 2450800006",
            "priority": "P2",
            "created_at": "09/02/2026 10:36:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:36:42"
          },
          {
            "ticket_id": 8696,
            "ticket_number": "358688",
            "title": "GBN-102186 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "09/02/2026 10:46:22",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.02,
            "sla_met": false,
            "sla_breach_hours": 7.77,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:47:34"
          },
          {
            "ticket_id": 8701,
            "ticket_number": "358693",
            "title": "GBN-94696 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:41",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 32.07,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:51:18"
          },
          {
            "ticket_id": 8702,
            "ticket_number": "358694",
            "title": "GBN-102183 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "09/02/2026 10:46:44",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.92,
            "sla_met": false,
            "sla_breach_hours": 7.67,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:41:58"
          },
          {
            "ticket_id": 8703,
            "ticket_number": "358695",
            "title": "2. Aviso - Reservas a ser pré-pagas nos próximos 6",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:46",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 32.05,
            "sla_met": false,
            "sla_breach_hours": 8.05,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:50:23"
          },
          {
            "ticket_id": 8704,
            "ticket_number": "358696",
            "title": "GBN-94729 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 32.03,
            "sla_met": false,
            "sla_breach_hours": 8.03,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:49:31"
          },
          {
            "ticket_id": 8707,
            "ticket_number": "358699",
            "title": "GBN-95291 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "09/02/2026 10:46:57",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 32.02,
            "sla_met": false,
            "sla_breach_hours": 31.77,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 18:48:54"
          },
          {
            "ticket_id": 8714,
            "ticket_number": "358706",
            "title": "Reserva cancelada com localizador: 4067102",
            "priority": "P2",
            "created_at": "09/02/2026 10:47:19",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 14:41:54"
          },
          {
            "ticket_id": 8726,
            "ticket_number": "358718",
            "title": "SOLFÉRIAS 424766",
            "priority": "P2",
            "created_at": "09/02/2026 10:48:26",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 10:48:27"
          },
          {
            "ticket_id": 8730,
            "ticket_number": "358722",
            "title": "novobanco | Documento",
            "priority": "P3",
            "created_at": "09/02/2026 10:48:42",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:40:33"
          },
          {
            "ticket_id": 8735,
            "ticket_number": "358727",
            "title": "Nova Viagem #250700285 - Euforia Glam",
            "priority": "P2",
            "created_at": "09/02/2026 11:17:43",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 11:17:43"
          },
          {
            "ticket_id": 8737,
            "ticket_number": "358729",
            "title": "Nova Confirmação de reserva 339026### TIME LIMIT E",
            "priority": "P2",
            "created_at": "09/02/2026 11:17:48",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 22.7,
            "sla_met": false,
            "sla_breach_hours": 18.7,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:00:10"
          },
          {
            "ticket_id": 8747,
            "ticket_number": "358739",
            "title": "Pedido de Sinalização De Reserva 339026",
            "priority": "P1",
            "created_at": "09/02/2026 13:30:55",
            "close_date": "2026-02-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 263.73,
            "sla_met": false,
            "sla_breach_hours": 263.48,
            "sla_name": "SLA P1",
            "first_response_at": "20/02/2026 13:15:36"
          },
          {
            "ticket_id": 8748,
            "ticket_number": "358740",
            "title": "Pedido de Sinalização De Reserva 338541",
            "priority": "P1",
            "created_at": "09/02/2026 13:30:58",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 29.27,
            "sla_met": false,
            "sla_breach_hours": 29.02,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 18:47:11"
          },
          {
            "ticket_id": 8749,
            "ticket_number": "358741",
            "title": "Pedido de Sinalização De Reserva 339139",
            "priority": "P1",
            "created_at": "09/02/2026 13:31:01",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.9,
            "sla_met": false,
            "sla_breach_hours": 4.65,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 18:25:54"
          },
          {
            "ticket_id": 8751,
            "ticket_number": "358743",
            "title": "ARSP-30535: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "09/02/2026 13:31:05",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 4.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:25:12"
          },
          {
            "ticket_id": 8753,
            "ticket_number": "358745",
            "title": "ARSP-30541: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "09/02/2026 13:31:09",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 4.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 18:24:40"
          },
          {
            "ticket_id": 8758,
            "ticket_number": "358750",
            "title": "Confirmação de comissões",
            "priority": "P2",
            "created_at": "09/02/2026 14:36:02",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 14:36:02"
          },
          {
            "ticket_id": 8765,
            "ticket_number": "358757",
            "title": "Confirmação de Reserva * File 428883 *TL 09/02/202",
            "priority": "P1",
            "created_at": "09/02/2026 16:29:57",
            "close_date": "2026-02-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.5,
            "sla_met": false,
            "sla_breach_hours": 2.25,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 19:00:10"
          },
          {
            "ticket_id": 8767,
            "ticket_number": "358759",
            "title": "FW: Novo Reforço de Pagamento - Viagem #427904",
            "priority": "P3",
            "created_at": "09/02/2026 16:30:03",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:30:04"
          },
          {
            "ticket_id": 8779,
            "ticket_number": "358771",
            "title": "Pagamento reserva CNTravel autoconsumo #260200161",
            "priority": "P2",
            "created_at": "09/02/2026 17:16:04",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 17:16:05"
          },
          {
            "ticket_id": 8792,
            "ticket_number": "358784",
            "title": "Reserva Gbn 94656 Florença Anabela Carvalho - para",
            "priority": "P1",
            "created_at": "09/02/2026 19:11:55",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 19:22:34"
          },
          {
            "ticket_id": 8798,
            "ticket_number": "358790",
            "title": "errata Reserva Gbn 94656 Florença Anabela Carvalho",
            "priority": "P2",
            "created_at": "09/02/2026 20:10:52",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 25.1,
            "sla_met": false,
            "sla_breach_hours": 21.1,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 21:17:30"
          },
          {
            "ticket_id": 8806,
            "ticket_number": "358798",
            "title": "fatura com nome errado",
            "priority": "P2",
            "created_at": "09/02/2026 21:28:53",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 21:28:54"
          },
          {
            "ticket_id": 8821,
            "ticket_number": "358813",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "10/02/2026 10:10:15",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 14:04:27"
          },
          {
            "ticket_id": 8823,
            "ticket_number": "358815",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P3",
            "created_at": "10/02/2026 10:10:27",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 8.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:43:26"
          },
          {
            "ticket_id": 8825,
            "ticket_number": "358817",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "10/02/2026 10:10:33",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 14:04:27"
          },
          {
            "ticket_id": 8839,
            "ticket_number": "358831",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "10/02/2026 10:13:12",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 14:04:27"
          },
          {
            "ticket_id": 8841,
            "ticket_number": "358833",
            "title": "Re: Pagamento 339026",
            "priority": "P1",
            "created_at": "10/02/2026 10:43:23",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.27,
            "sla_met": false,
            "sla_breach_hours": 0.02,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 10:59:27"
          },
          {
            "ticket_id": 8843,
            "ticket_number": "358835",
            "title": "URGENTE URGENTE: EMISSÃO OPO MAD SDQ MAD OPO ---- ",
            "priority": "P1",
            "created_at": "10/02/2026 10:52:14",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 10:55:35"
          },
          {
            "ticket_id": 8845,
            "ticket_number": "358837",
            "title": "Cancelamento de reserva 338855",
            "priority": "P2",
            "created_at": "10/02/2026 10:52:18",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 10:57:05"
          },
          {
            "ticket_id": 8851,
            "ticket_number": "358843",
            "title": "ARSP-30558: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "10/02/2026 11:56:26",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 15:44:36"
          },
          {
            "ticket_id": 8853,
            "ticket_number": "358845",
            "title": "ARSP-30561: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "10/02/2026 11:56:37",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 15:44:36"
          },
          {
            "ticket_id": 8857,
            "ticket_number": "358849",
            "title": "Re:[## 31670 ##] GBN-103272 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "10/02/2026 12:07:43",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 13:41:37"
          },
          {
            "ticket_id": 8859,
            "ticket_number": "358851",
            "title": "NIB | IBAN",
            "priority": "P2",
            "created_at": "10/02/2026 12:55:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 12:55:07"
          },
          {
            "ticket_id": 8868,
            "ticket_number": "358860",
            "title": "In Sure Broker alerta-o para documentos a pagament",
            "priority": "P2",
            "created_at": "10/02/2026 15:16:48",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 18:38:03"
          },
          {
            "ticket_id": 8869,
            "ticket_number": "358861",
            "title": "RE: Reserva GBN-91958",
            "priority": "P2",
            "created_at": "10/02/2026 15:22:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 19:13:20"
          },
          {
            "ticket_id": 8888,
            "ticket_number": "358880",
            "title": "GBN-104968 - Sua confirmação de reserva",
            "priority": "P3",
            "created_at": "10/02/2026 17:17:42",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 19.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 12:32:06"
          },
          {
            "ticket_id": 8895,
            "ticket_number": "358887",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "10/02/2026 18:13:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.75,
            "sla_met": false,
            "sla_breach_hours": 1.5,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 19:59:01"
          },
          {
            "ticket_id": 8903,
            "ticket_number": "358895",
            "title": "URGENTE  - Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "10/02/2026 18:35:04",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.62,
            "sla_met": false,
            "sla_breach_hours": 1.37,
            "sla_name": "SLA P1",
            "first_response_at": "10/02/2026 20:12:41"
          },
          {
            "ticket_id": 8924,
            "ticket_number": "358916",
            "title": "Reembolso",
            "priority": "P2",
            "created_at": "10/02/2026 19:59:37",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 18:37:02"
          },
          {
            "ticket_id": 8929,
            "ticket_number": "358921",
            "title": "Re: Nova Viagem #260100275 - Marisa Duarte MD Trav",
            "priority": "P2",
            "created_at": "10/02/2026 21:00:11",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 21:00:11"
          },
          {
            "ticket_id": 8944,
            "ticket_number": "358936",
            "title": "recibo verde",
            "priority": "P2",
            "created_at": "10/02/2026 23:43:55",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 23:43:55"
          },
          {
            "ticket_id": 8952,
            "ticket_number": "358944",
            "title": "Referencia para pagamento | File:415384/2025",
            "priority": "P3",
            "created_at": "11/02/2026 10:14:52",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 11:25:41"
          },
          {
            "ticket_id": 8956,
            "ticket_number": "358948",
            "title": "Re: Pagamento 339026",
            "priority": "P3",
            "created_at": "11/02/2026 10:51:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 10:57:36"
          },
          {
            "ticket_id": 8960,
            "ticket_number": "358952",
            "title": "RE: Pagamento 6132310",
            "priority": "P3",
            "created_at": "11/02/2026 10:51:22",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 20:44:12"
          },
          {
            "ticket_id": 8963,
            "ticket_number": "358955",
            "title": "RE: Pagamento 6132327",
            "priority": "P3",
            "created_at": "11/02/2026 10:51:31",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 20:44:12"
          },
          {
            "ticket_id": 8973,
            "ticket_number": "358965",
            "title": "RESERVA ANABELA CARVALHO GBN 94696",
            "priority": "P3",
            "created_at": "11/02/2026 12:13:18",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 33.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 22:04:20"
          },
          {
            "ticket_id": 8977,
            "ticket_number": "358969",
            "title": "CONTA CORRENTE - docs em aberto",
            "priority": "P3",
            "created_at": "11/02/2026 12:32:09",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 22:24:23"
          },
          {
            "ticket_id": 8988,
            "ticket_number": "358980",
            "title": "Re: Novo Reforço de Pagamento - Viagem #2414000017",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:03",
            "close_date": "2026-04-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:40:03"
          },
          {
            "ticket_id": 8992,
            "ticket_number": "358984",
            "title": "Alteração Optis",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:20",
            "close_date": "2026-04-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:40:21"
          },
          {
            "ticket_id": 8993,
            "ticket_number": "358985",
            "title": "Re: Novo Reforço de Pagamento - Viagem #2414000017",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:24",
            "close_date": "2026-04-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:40:25"
          },
          {
            "ticket_id": 8994,
            "ticket_number": "358986",
            "title": "Confirmação de reserva para For PT004157 70075958",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:27",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 21.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 11:27:38"
          },
          {
            "ticket_id": 9004,
            "ticket_number": "358996",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497469",
            "priority": "P3",
            "created_at": "11/02/2026 15:31:54",
            "close_date": "2026-02-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 15:55:52"
          },
          {
            "ticket_id": 9014,
            "ticket_number": "359006",
            "title": "Referencia para pagamento | File:429171/2026",
            "priority": "P1",
            "created_at": "11/02/2026 17:58:03",
            "close_date": "2026-02-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.25,
            "sla_met": false,
            "sla_breach_hours": 1.0,
            "sla_name": "SLA P1",
            "first_response_at": "11/02/2026 19:13:23"
          },
          {
            "ticket_id": 9016,
            "ticket_number": "359008",
            "title": "RV: Dados de pagamento",
            "priority": "P1",
            "created_at": "11/02/2026 17:58:09",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 547.72,
            "sla_met": false,
            "sla_breach_hours": 547.47,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 13:41:53"
          },
          {
            "ticket_id": 9019,
            "ticket_number": "359011",
            "title": "RE: Pedido de reserva",
            "priority": "P3",
            "created_at": "11/02/2026 18:12:50",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 18:20:35"
          },
          {
            "ticket_id": 9043,
            "ticket_number": "359035",
            "title": "alteração opti 247700016",
            "priority": "P2",
            "created_at": "11/02/2026 20:26:38",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 20:26:39"
          },
          {
            "ticket_id": 9074,
            "ticket_number": "359066",
            "title": "GBN-96239 - Sua reserva está pendente de pagamento",
            "priority": "P3",
            "created_at": "12/02/2026 10:08:18",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 32.35,
            "sla_met": false,
            "sla_breach_hours": 8.35,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:30:05"
          },
          {
            "ticket_id": 9089,
            "ticket_number": "359081",
            "title": "a/c catia leal",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:41",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 985.15,
            "sla_met": false,
            "sla_breach_hours": 961.15,
            "sla_name": "SLA P3",
            "first_response_at": "25/03/2026 11:20:47"
          },
          {
            "ticket_id": 9095,
            "ticket_number": "359087",
            "title": "a/c Catia Leal - 242100209",
            "priority": "P3",
            "created_at": "12/02/2026 10:11:57",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 985.15,
            "sla_met": false,
            "sla_breach_hours": 961.15,
            "sla_name": "SLA P3",
            "first_response_at": "25/03/2026 11:21:31"
          },
          {
            "ticket_id": 9108,
            "ticket_number": "359100",
            "title": "URG: ACRESCIMO DE UMA PESSOA A UMA RESERVA",
            "priority": "P2",
            "created_at": "12/02/2026 12:06:21",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 12:06:21"
          },
          {
            "ticket_id": 9109,
            "ticket_number": "359101",
            "title": "Valor de comissões",
            "priority": "P3",
            "created_at": "12/02/2026 12:06:23",
            "close_date": "2026-02-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 12:06:23"
          },
          {
            "ticket_id": 9112,
            "ticket_number": "359104",
            "title": "Reminder * Reserva File 429171 * Deadline Hoje 15H",
            "priority": "P3",
            "created_at": "12/02/2026 12:06:29",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 13:14:44"
          },
          {
            "ticket_id": 9114,
            "ticket_number": "359106",
            "title": "Referencia para pagamento | File:428927/2026",
            "priority": "P3",
            "created_at": "12/02/2026 13:17:46",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 29.18,
            "sla_met": false,
            "sla_breach_hours": 5.18,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:29:41"
          },
          {
            "ticket_id": 9119,
            "ticket_number": "359111",
            "title": "Referencia para pagamento | File:425077/2026",
            "priority": "P3",
            "created_at": "12/02/2026 13:18:07",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 29.73,
            "sla_met": false,
            "sla_breach_hours": 5.73,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:02:45"
          },
          {
            "ticket_id": 9125,
            "ticket_number": "359117",
            "title": "Cancelamento de reserva 338543",
            "priority": "P3",
            "created_at": "12/02/2026 13:42:40",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 5.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 18:49:18"
          },
          {
            "ticket_id": 9149,
            "ticket_number": "359141",
            "title": "A/C CÁTIA LEAL - PEDIDO FATURA/RECIBO ÚNICO OPTI: ",
            "priority": "P3",
            "created_at": "12/02/2026 18:20:10",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 18:20:12"
          },
          {
            "ticket_id": 9165,
            "ticket_number": "359157",
            "title": "Referencia para pagamento | File:429861/2026",
            "priority": "P2",
            "created_at": "12/02/2026 22:13:03",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 00:07:44"
          },
          {
            "ticket_id": 9166,
            "ticket_number": "359158",
            "title": "Referencia para pagamento | File:429857/2026",
            "priority": "P2",
            "created_at": "12/02/2026 22:13:05",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 00:07:11"
          },
          {
            "ticket_id": 9173,
            "ticket_number": "359165",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:09",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 128.75,
            "sla_met": false,
            "sla_breach_hours": 104.75,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 18:52:42"
          },
          {
            "ticket_id": 9174,
            "ticket_number": "359166",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:11",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 8.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:22:13"
          },
          {
            "ticket_id": 9179,
            "ticket_number": "359171",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:22",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 8.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 18:21:29"
          },
          {
            "ticket_id": 9180,
            "ticket_number": "359172",
            "title": "GBN-96239 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "13/02/2026 10:07:24",
            "close_date": "2026-02-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.17,
            "sla_met": false,
            "sla_breach_hours": 7.92,
            "sla_name": "SLA P1",
            "first_response_at": "13/02/2026 18:18:18"
          },
          {
            "ticket_id": 9184,
            "ticket_number": "359176",
            "title": "Fatura sem numero de contribuinte",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:33",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:33"
          },
          {
            "ticket_id": 9206,
            "ticket_number": "359198",
            "title": "Referencia para pagamento | File:416525/2025",
            "priority": "P1",
            "created_at": "13/02/2026 12:10:25",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 671.9,
            "sla_met": false,
            "sla_breach_hours": 671.65,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 12:05:10"
          },
          {
            "ticket_id": 9226,
            "ticket_number": "359218",
            "title": "cancelamento das reservas Civitatis T2827312 e T28",
            "priority": "P3",
            "created_at": "13/02/2026 14:40:55",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:40:56"
          },
          {
            "ticket_id": 9247,
            "ticket_number": "359239",
            "title": "Faturas de Pagamento - Viagem #Gbn- 94696",
            "priority": "P3",
            "created_at": "13/02/2026 16:20:52",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:20:53"
          },
          {
            "ticket_id": 9258,
            "ticket_number": "359250",
            "title": "novobanco | Documento",
            "priority": "P3",
            "created_at": "13/02/2026 17:28:45",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 72.87,
            "sla_met": false,
            "sla_breach_hours": 48.87,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 18:21:29"
          },
          {
            "ticket_id": 9263,
            "ticket_number": "359255",
            "title": "Re: Nova Viagem #260200244 - Rita Ribeiro",
            "priority": "P3",
            "created_at": "13/02/2026 17:45:45",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 17:45:45"
          },
          {
            "ticket_id": 9276,
            "ticket_number": "359268",
            "title": "Pedir informações para o operador e os documentos ",
            "priority": "P3",
            "created_at": "13/02/2026 19:20:32",
            "close_date": "2026-03-25",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:20:33"
          },
          {
            "ticket_id": 9294,
            "ticket_number": "359286",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "13/02/2026 20:23:32",
            "close_date": "2026-02-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/02/2026 20:31:17"
          },
          {
            "ticket_id": 9301,
            "ticket_number": "359293",
            "title": "Referencia para pagamento | File:429916/2026",
            "priority": "P2",
            "created_at": "13/02/2026 22:10:48",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 69.68,
            "sla_met": false,
            "sla_breach_hours": 65.68,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 19:51:58"
          },
          {
            "ticket_id": 9303,
            "ticket_number": "359295",
            "title": "Re: Nova Viagem #260200251 - Benice Travel",
            "priority": "P2",
            "created_at": "13/02/2026 22:44:57",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 22:44:58"
          },
          {
            "ticket_id": 9309,
            "ticket_number": "359301",
            "title": "RE: Pedido de reserva - 17 a 18 de Fev",
            "priority": "P2",
            "created_at": "14/02/2026 09:52:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 09:56:08"
          },
          {
            "ticket_id": 9348,
            "ticket_number": "359340",
            "title": "RE: Pagamento 8968623",
            "priority": "P2",
            "created_at": "16/02/2026 10:06:49",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:40:30"
          },
          {
            "ticket_id": 9367,
            "ticket_number": "359359",
            "title": "Pedido cancelamento resrva GBN 102944",
            "priority": "P2",
            "created_at": "16/02/2026 10:10:29",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:10:29"
          },
          {
            "ticket_id": 9391,
            "ticket_number": "359383",
            "title": "Pedido de Sinalização De Reserva 339183",
            "priority": "P1",
            "created_at": "16/02/2026 11:32:05",
            "close_date": "2026-02-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "16/02/2026 11:40:25"
          },
          {
            "ticket_id": 9392,
            "ticket_number": "359384",
            "title": "Cancelación de la reserva con localizador: 4063357",
            "priority": "P2",
            "created_at": "16/02/2026 11:32:06",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:09:46"
          },
          {
            "ticket_id": 9396,
            "ticket_number": "359388",
            "title": "***URGENTE PAGO HOY***RESERVAS 16/FEBRERO (LEPLAN)",
            "priority": "P1",
            "created_at": "16/02/2026 12:21:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 78.45,
            "sla_met": false,
            "sla_breach_hours": 78.2,
            "sla_name": "SLA P1",
            "first_response_at": "19/02/2026 18:49:00"
          },
          {
            "ticket_id": 9403,
            "ticket_number": "359395",
            "title": "Recordatorio prepago reserva: 1764234",
            "priority": "P2",
            "created_at": "16/02/2026 13:17:13",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 29.25,
            "sla_met": false,
            "sla_breach_hours": 25.25,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:32:34"
          },
          {
            "ticket_id": 9409,
            "ticket_number": "359401",
            "title": "Confirmação e Sinalização de Reserva 211730",
            "priority": "P1",
            "created_at": "16/02/2026 14:00:22",
            "close_date": "2026-02-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 52.67,
            "sla_met": false,
            "sla_breach_hours": 52.42,
            "sla_name": "SLA P1",
            "first_response_at": "18/02/2026 18:41:15"
          },
          {
            "ticket_id": 9411,
            "ticket_number": "359403",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60449762",
            "priority": "P2",
            "created_at": "16/02/2026 14:36:57",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 14:43:18"
          },
          {
            "ticket_id": 9413,
            "ticket_number": "359405",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60453906",
            "priority": "P2",
            "created_at": "16/02/2026 14:37:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 14:39:15"
          },
          {
            "ticket_id": 9417,
            "ticket_number": "359409",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60453904",
            "priority": "P2",
            "created_at": "16/02/2026 16:00:41",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 11:02:13"
          },
          {
            "ticket_id": 9418,
            "ticket_number": "359410",
            "title": "ALTERAÇÃO RESERVA TRAVELPLAN - NORTRAVEL",
            "priority": "P2",
            "created_at": "16/02/2026 16:00:43",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 16:00:43"
          },
          {
            "ticket_id": 9430,
            "ticket_number": "359422",
            "title": "REF DATOS RESERVA Reserva CNTravel 99123917",
            "priority": "P2",
            "created_at": "16/02/2026 17:04:10",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:10:32"
          },
          {
            "ticket_id": 9433,
            "ticket_number": "359425",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497621",
            "priority": "P2",
            "created_at": "16/02/2026 17:04:23",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 21:01:57"
          },
          {
            "ticket_id": 9440,
            "ticket_number": "359432",
            "title": "URGENTE! NOTIFICAÇÃO DE RESERVA 6128736",
            "priority": "P1",
            "created_at": "16/02/2026 18:31:15",
            "close_date": "2026-02-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.83,
            "sla_met": false,
            "sla_breach_hours": 3.58,
            "sla_name": "SLA P1",
            "first_response_at": "16/02/2026 22:22:03"
          },
          {
            "ticket_id": 9467,
            "ticket_number": "359459",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60452255",
            "priority": "P1",
            "created_at": "16/02/2026 19:19:58",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.27,
            "sla_met": false,
            "sla_breach_hours": 1.02,
            "sla_name": "SLA P1",
            "first_response_at": "16/02/2026 20:36:38"
          },
          {
            "ticket_id": 9468,
            "ticket_number": "359460",
            "title": "Recibo 02 - 2026",
            "priority": "P2",
            "created_at": "16/02/2026 19:31:31",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 19:31:31"
          },
          {
            "ticket_id": 9474,
            "ticket_number": "359466",
            "title": "Devolução de dinheiro",
            "priority": "P2",
            "created_at": "16/02/2026 20:37:21",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 20:37:21"
          },
          {
            "ticket_id": 9487,
            "ticket_number": "359479",
            "title": "Referencia para pagamento | File:430513/2026",
            "priority": "P2",
            "created_at": "16/02/2026 22:18:47",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 44.35,
            "sla_met": false,
            "sla_breach_hours": 40.35,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:40:12"
          },
          {
            "ticket_id": 9488,
            "ticket_number": "359480",
            "title": "Referencia para pagamento | File:430511/2026",
            "priority": "P2",
            "created_at": "16/02/2026 22:18:49",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 44.35,
            "sla_met": false,
            "sla_breach_hours": 40.35,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:39:59"
          },
          {
            "ticket_id": 9503,
            "ticket_number": "359495",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P2",
            "created_at": "17/02/2026 10:07:42",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 390.82,
            "sla_met": false,
            "sla_breach_hours": 386.82,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:57:25"
          },
          {
            "ticket_id": 9504,
            "ticket_number": "359496",
            "title": "GBN-90211 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/02/2026 10:07:44",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 8.32,
            "sla_met": false,
            "sla_breach_hours": 4.32,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:27:40"
          },
          {
            "ticket_id": 9507,
            "ticket_number": "359499",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "17/02/2026 10:07:52",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 32.5,
            "sla_met": false,
            "sla_breach_hours": 28.5,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:38:27"
          },
          {
            "ticket_id": 9515,
            "ticket_number": "359507",
            "title": "Recordatorio prepago reserva: 1764234",
            "priority": "P2",
            "created_at": "17/02/2026 11:35:23",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 31.02,
            "sla_met": false,
            "sla_breach_hours": 27.02,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:36:46"
          },
          {
            "ticket_id": 9516,
            "ticket_number": "359508",
            "title": "Urgente!!",
            "priority": "P1",
            "created_at": "17/02/2026 11:56:51",
            "close_date": "2026-02-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.42,
            "sla_met": false,
            "sla_breach_hours": 6.17,
            "sla_name": "SLA P1",
            "first_response_at": "17/02/2026 18:22:21"
          },
          {
            "ticket_id": 9523,
            "ticket_number": "359515",
            "title": "RE: Pagamento 1775938",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:30",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1237.85,
            "sla_met": false,
            "sla_breach_hours": 1233.85,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 02:20:19"
          },
          {
            "ticket_id": 9524,
            "ticket_number": "359516",
            "title": "RE: Pagamento 1770371",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:32",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1237.85,
            "sla_met": false,
            "sla_breach_hours": 1233.85,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 02:20:28"
          },
          {
            "ticket_id": 9537,
            "ticket_number": "359529",
            "title": "[Opentours] Enlaces para pagar los localizadores",
            "priority": "P2",
            "created_at": "17/02/2026 13:07:16",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 5.23,
            "sla_met": false,
            "sla_breach_hours": 1.23,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:22:12"
          },
          {
            "ticket_id": 9563,
            "ticket_number": "359555",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "17/02/2026 17:13:17",
            "close_date": "2026-02-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.08,
            "sla_met": false,
            "sla_breach_hours": 2.83,
            "sla_name": "SLA P1",
            "first_response_at": "17/02/2026 20:18:32"
          },
          {
            "ticket_id": 9585,
            "ticket_number": "359577",
            "title": "Comissões JAN/FEV Marisa Duarte",
            "priority": "P2",
            "created_at": "17/02/2026 22:55:07",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:55:08"
          },
          {
            "ticket_id": 9615,
            "ticket_number": "359607",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:00:30"
          },
          {
            "ticket_id": 9616,
            "ticket_number": "359608",
            "title": "GBN-104833 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:00:30"
          },
          {
            "ticket_id": 9618,
            "ticket_number": "359610",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:44",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:00:30"
          },
          {
            "ticket_id": 9650,
            "ticket_number": "359642",
            "title": "Fatura / Recibo FRH 1/18518 (Original)",
            "priority": "P2",
            "created_at": "18/02/2026 14:17:13",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:18:05"
          },
          {
            "ticket_id": 9654,
            "ticket_number": "359646",
            "title": "ARSP-30561: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "18/02/2026 17:29:56",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 18:32:03"
          },
          {
            "ticket_id": 9657,
            "ticket_number": "359649",
            "title": "Fwd: RECLAMACAO Localizador: 1160888817 /",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:04",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:30:05"
          },
          {
            "ticket_id": 9658,
            "ticket_number": "359650",
            "title": "pedido de comissoes",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:07",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:30:07"
          },
          {
            "ticket_id": 9680,
            "ticket_number": "359672",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "18/02/2026 18:23:54",
            "close_date": "2026-02-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/02/2026 18:25:20"
          },
          {
            "ticket_id": 9684,
            "ticket_number": "359676",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "18/02/2026 18:43:31",
            "close_date": "2026-02-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.63,
            "sla_met": false,
            "sla_breach_hours": 1.38,
            "sla_name": "SLA P1",
            "first_response_at": "18/02/2026 20:22:04"
          },
          {
            "ticket_id": 9710,
            "ticket_number": "359702",
            "title": "factura /recibo do cliente com o localizador 61292",
            "priority": "P2",
            "created_at": "18/02/2026 21:31:35",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 21:31:36"
          },
          {
            "ticket_id": 9737,
            "ticket_number": "359729",
            "title": "***ÚLTIMO AVISO***URGENTE PAGO HOY***RESERVAS 01/0",
            "priority": "P1",
            "created_at": "19/02/2026 10:58:55",
            "close_date": "2026-02-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.75,
            "sla_met": false,
            "sla_breach_hours": 0.5,
            "sla_name": "SLA P1",
            "first_response_at": "19/02/2026 11:44:51"
          },
          {
            "ticket_id": 9751,
            "ticket_number": "359743",
            "title": "Nova Confirmação de reserva 334142",
            "priority": "P2",
            "created_at": "19/02/2026 12:47:01",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 12:52:38"
          },
          {
            "ticket_id": 9753,
            "ticket_number": "359745",
            "title": "Comissao Gbn 86615",
            "priority": "P2",
            "created_at": "19/02/2026 13:04:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 13:04:22"
          },
          {
            "ticket_id": 9757,
            "ticket_number": "359749",
            "title": "Interline Ilha do Sal",
            "priority": "P2",
            "created_at": "19/02/2026 13:04:32",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 13:04:32"
          },
          {
            "ticket_id": 9787,
            "ticket_number": "359779",
            "title": "Confirmação e Sinalização de Reserva 211964",
            "priority": "P2",
            "created_at": "19/02/2026 17:01:07",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 25.65,
            "sla_met": false,
            "sla_breach_hours": 21.65,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 18:40:29"
          },
          {
            "ticket_id": 9795,
            "ticket_number": "359787",
            "title": "Skydive Seven Algarve - contratação direta",
            "priority": "P2",
            "created_at": "19/02/2026 19:26:42",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 19:26:42"
          },
          {
            "ticket_id": 9840,
            "ticket_number": "359832",
            "title": "Pedido esclarecimento - Soltropico",
            "priority": "P2",
            "created_at": "20/02/2026 10:19:41",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:19:42"
          },
          {
            "ticket_id": 9852,
            "ticket_number": "359844",
            "title": "Opti 249900031",
            "priority": "P2",
            "created_at": "20/02/2026 10:41:39",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:41:40"
          },
          {
            "ticket_id": 9882,
            "ticket_number": "359870",
            "title": "RE: Recibo Comissões - Urgente",
            "priority": "P2",
            "created_at": "20/02/2026 12:55:00",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:55:01"
          },
          {
            "ticket_id": 9883,
            "ticket_number": "359871",
            "title": "Recibo Comissões - Urgente",
            "priority": "P2",
            "created_at": "20/02/2026 12:55:02",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 12:55:02"
          },
          {
            "ticket_id": 9900,
            "ticket_number": "359888",
            "title": "Fwd: Informações sobre o seu caso / Reclamacao TTN",
            "priority": "P2",
            "created_at": "20/02/2026 15:02:57",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 15:02:53"
          },
          {
            "ticket_id": 9901,
            "ticket_number": "359889",
            "title": "Comissao Gbn 86615",
            "priority": "P2",
            "created_at": "20/02/2026 15:03:00",
            "close_date": "2026-02-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 15:03:01"
          },
          {
            "ticket_id": 9936,
            "ticket_number": "359924",
            "title": "Aviso de pagamento Wamos.",
            "priority": "P2",
            "created_at": "20/02/2026 19:20:26",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1098.13,
            "sla_met": false,
            "sla_breach_hours": 1094.13,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:29:25"
          },
          {
            "ticket_id": 9950,
            "ticket_number": "359938",
            "title": "Comissões em falta cockpit",
            "priority": "P2",
            "created_at": "20/02/2026 19:51:14",
            "close_date": "2026-02-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:51:14"
          },
          {
            "ticket_id": 9951,
            "ticket_number": "359939",
            "title": "Cancelamento Reserva - 4072719 Tour10 - OPTI - 241",
            "priority": "P2",
            "created_at": "20/02/2026 19:51:16",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 19:51:17"
          },
          {
            "ticket_id": 9954,
            "ticket_number": "359942",
            "title": "Alteração viagens TRP-2026-03555 e TRP-2026-03558",
            "priority": "P3",
            "created_at": "20/02/2026 20:39:40",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 20:39:41"
          },
          {
            "ticket_id": 9975,
            "ticket_number": "359963",
            "title": "Referencia para pagamento | File:430884/2026",
            "priority": "P2",
            "created_at": "20/02/2026 22:12:15",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 22:47:48"
          },
          {
            "ticket_id": 9976,
            "ticket_number": "359964",
            "title": "Referencia para pagamento | File:430984/2026",
            "priority": "P2",
            "created_at": "20/02/2026 22:45:47",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 23:07:43"
          },
          {
            "ticket_id": 9980,
            "ticket_number": "359968",
            "title": "Confirmacao 340056",
            "priority": "P2",
            "created_at": "20/02/2026 23:49:27",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 65.33,
            "sla_met": false,
            "sla_breach_hours": 61.33,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 17:10:21"
          },
          {
            "ticket_id": 9992,
            "ticket_number": "359980",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60454546",
            "priority": "P2",
            "created_at": "21/02/2026 10:07:25",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 18:53:01"
          },
          {
            "ticket_id": 10004,
            "ticket_number": "359992",
            "title": "novobanco | Documento",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:43",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 582.57,
            "sla_met": false,
            "sla_breach_hours": 578.57,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 19:22:59"
          },
          {
            "ticket_id": 10007,
            "ticket_number": "359995",
            "title": "ifthenpay:  Processamento do dia 20-02-2026 da con",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:50",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:44:11"
          },
          {
            "ticket_id": 10008,
            "ticket_number": "359996",
            "title": "ifthenpay:  Processamento do dia 20-02-2026 da con",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:52",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:44:23"
          },
          {
            "ticket_id": 10041,
            "ticket_number": "3510029",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:10",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:01:20"
          },
          {
            "ticket_id": 10042,
            "ticket_number": "3510030",
            "title": "GBN-85834 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:12",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:01:20"
          },
          {
            "ticket_id": 10048,
            "ticket_number": "3510036",
            "title": "GBN-107378 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:26",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:01:20"
          },
          {
            "ticket_id": 10069,
            "ticket_number": "3510057",
            "title": "Referencia para pagamento | File:431081/2026",
            "priority": "P1",
            "created_at": "23/02/2026 10:31:49",
            "close_date": "2026-02-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.97,
            "sla_met": false,
            "sla_breach_hours": 6.72,
            "sla_name": "SLA P1",
            "first_response_at": "23/02/2026 17:30:31"
          },
          {
            "ticket_id": 10070,
            "ticket_number": "3510058",
            "title": "Referencia para pagamento | File:431151/2026",
            "priority": "P1",
            "created_at": "23/02/2026 10:31:50",
            "close_date": "2026-02-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.95,
            "sla_met": false,
            "sla_breach_hours": 6.7,
            "sla_name": "SLA P1",
            "first_response_at": "23/02/2026 17:29:22"
          },
          {
            "ticket_id": 10071,
            "ticket_number": "3510059",
            "title": "Referencia para pagamento | File:431079/2026",
            "priority": "P1",
            "created_at": "23/02/2026 10:31:52",
            "close_date": "2026-02-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.93,
            "sla_met": false,
            "sla_breach_hours": 6.68,
            "sla_name": "SLA P1",
            "first_response_at": "23/02/2026 17:28:04"
          },
          {
            "ticket_id": 10073,
            "ticket_number": "3510061",
            "title": "Notificação comissões de serviços fora de fatura",
            "priority": "P2",
            "created_at": "23/02/2026 10:34:02",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:21:22"
          },
          {
            "ticket_id": 10079,
            "ticket_number": "3510067",
            "title": "Pedido de Sinalização De Reserva 339794",
            "priority": "P2",
            "created_at": "23/02/2026 11:25:18",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10080,
            "ticket_number": "3510068",
            "title": "Pedido de Sinalização De Reserva 339901",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:25",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10081,
            "ticket_number": "3510069",
            "title": "Pedido de Sinalização De Reserva 340001",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:27",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10082,
            "ticket_number": "3510070",
            "title": "Pedido de Sinalização De Reserva 340056",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:28",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10083,
            "ticket_number": "3510071",
            "title": "Pedido de Sinalização De Reserva 339933",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:30",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10084,
            "ticket_number": "3510072",
            "title": "Pedido de Sinalização De Reserva 339902",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:31",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:21:28"
          },
          {
            "ticket_id": 10085,
            "ticket_number": "3510073",
            "title": "Re: Fatura e (cvo-rgpd cockpit)",
            "priority": "P3",
            "created_at": "23/02/2026 11:27:33",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 268.33,
            "sla_met": false,
            "sla_breach_hours": 244.33,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 15:48:01"
          },
          {
            "ticket_id": 10096,
            "ticket_number": "3510084",
            "title": "Pedido de Sinalização De Reserva 339794",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:24",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10097,
            "ticket_number": "3510085",
            "title": "Pedido de Sinalização De Reserva 339933",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:26",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10098,
            "ticket_number": "3510086",
            "title": "Pedido de Sinalização De Reserva 340056",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:27",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10099,
            "ticket_number": "3510087",
            "title": "Pedido de Sinalização De Reserva 340001",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:29",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10100,
            "ticket_number": "3510088",
            "title": "Pedido de Sinalização De Reserva 339901",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:30",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10101,
            "ticket_number": "3510089",
            "title": "Pedido de Sinalização De Reserva 339902",
            "priority": "P2",
            "created_at": "23/02/2026 11:50:32",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:41:30"
          },
          {
            "ticket_id": 10105,
            "ticket_number": "3510093",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "23/02/2026 12:56:09",
            "close_date": "2026-02-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 20.9,
            "sla_met": false,
            "sla_breach_hours": 20.65,
            "sla_name": "SLA P1",
            "first_response_at": "24/02/2026 09:50:56"
          },
          {
            "ticket_id": 10197,
            "ticket_number": "3510185",
            "title": "Informacoes easypay",
            "priority": "P2",
            "created_at": "24/02/2026 10:07:45",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:07"
          },
          {
            "ticket_id": 10199,
            "ticket_number": "3510187",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "24/02/2026 10:07:51",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:07"
          },
          {
            "ticket_id": 10200,
            "ticket_number": "3510188",
            "title": "ifthenpay:  Processamento do dia 23-02-2026 da con",
            "priority": "P2",
            "created_at": "24/02/2026 10:07:53",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:07"
          },
          {
            "ticket_id": 10202,
            "ticket_number": "3510190",
            "title": "GBN-107378 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "24/02/2026 10:07:58",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:08"
          },
          {
            "ticket_id": 10204,
            "ticket_number": "3510192",
            "title": "GBN-106075 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:05",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:08"
          },
          {
            "ticket_id": 10205,
            "ticket_number": "3510193",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:09",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:08"
          },
          {
            "ticket_id": 10206,
            "ticket_number": "3510194",
            "title": "GBN-85834 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:12",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 14:03:08"
          },
          {
            "ticket_id": 10221,
            "ticket_number": "3510209",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "24/02/2026 11:06:58",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:03:12"
          },
          {
            "ticket_id": 10251,
            "ticket_number": "3510239",
            "title": "Faturas Pendentes: FA 2147895757",
            "priority": "P2",
            "created_at": "24/02/2026 13:20:52",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 5.45,
            "sla_met": false,
            "sla_breach_hours": 1.45,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 18:48:45"
          },
          {
            "ticket_id": 10285,
            "ticket_number": "3510273",
            "title": "IFTHENPAY - Pagamento Efetuado: ID DEP-78587316 En",
            "priority": "P2",
            "created_at": "24/02/2026 18:48:57",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:43:57"
          },
          {
            "ticket_id": 10306,
            "ticket_number": "3510294",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "24/02/2026 22:27:28",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:54:11"
          },
          {
            "ticket_id": 10307,
            "ticket_number": "3510295",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "24/02/2026 22:27:31",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 22:52:58"
          },
          {
            "ticket_id": 10322,
            "ticket_number": "3510310",
            "title": "Cancelamento Viagem Cockpit",
            "priority": "P2",
            "created_at": "25/02/2026 00:07:17",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 00:07:18"
          },
          {
            "ticket_id": 10333,
            "ticket_number": "3510321",
            "title": "GBN-105314 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:35",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 120.02,
            "sla_met": false,
            "sla_breach_hours": 116.02,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:17:52"
          },
          {
            "ticket_id": 10335,
            "ticket_number": "3510323",
            "title": "ifthenpay:  Processamento do dia 24-02-2026 da con",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:42",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 489.08,
            "sla_met": false,
            "sla_breach_hours": 485.08,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 19:22:08"
          },
          {
            "ticket_id": 10339,
            "ticket_number": "3510327",
            "title": "GBN-106075 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 120.0,
            "sla_met": false,
            "sla_breach_hours": 116.0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:17:37"
          },
          {
            "ticket_id": 10340,
            "ticket_number": "3510328",
            "title": "Fatura da Viagem nº TRP-2026-03768",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:57",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:16:57"
          },
          {
            "ticket_id": 10345,
            "ticket_number": "3510333",
            "title": "Pedido de cancelamento de viagem + reserva de viag",
            "priority": "P2",
            "created_at": "25/02/2026 10:45:58",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:45:59"
          },
          {
            "ticket_id": 10352,
            "ticket_number": "3510340",
            "title": "FW: Falta de pagamento!",
            "priority": "P1",
            "created_at": "25/02/2026 10:57:50",
            "close_date": "2026-02-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/02/2026 10:57:51"
          },
          {
            "ticket_id": 10353,
            "ticket_number": "3510341",
            "title": "RE: Pagamento 6136070",
            "priority": "P2",
            "created_at": "25/02/2026 10:57:53",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 132.72,
            "sla_met": false,
            "sla_breach_hours": 128.72,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:41:04"
          },
          {
            "ticket_id": 10357,
            "ticket_number": "3510345",
            "title": "Confirmação e Sinalização de Reserva 212274",
            "priority": "P2",
            "created_at": "25/02/2026 11:04:23",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 15:00:08"
          },
          {
            "ticket_id": 10358,
            "ticket_number": "3510346",
            "title": "Envio de Documentação",
            "priority": "P2",
            "created_at": "25/02/2026 11:04:25",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 15:00:08"
          },
          {
            "ticket_id": 10375,
            "ticket_number": "3510363",
            "title": "Confirmação e Sinalização de Reserva 212289",
            "priority": "P2",
            "created_at": "25/02/2026 12:43:09",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:40:16"
          },
          {
            "ticket_id": 10431,
            "ticket_number": "3510419",
            "title": "Fatura Recibo Fev 2026 - Comissões ",
            "priority": "P2",
            "created_at": "25/02/2026 19:50:55",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 19:50:56"
          },
          {
            "ticket_id": 10444,
            "ticket_number": "3510432",
            "title": "Pedido de esclarecimentos cancelamento + remarcaçã",
            "priority": "P2",
            "created_at": "25/02/2026 21:39:12",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:39:12"
          },
          {
            "ticket_id": 10448,
            "ticket_number": "3510436",
            "title": "Referencia para pagamento | File:431638/2026",
            "priority": "P2",
            "created_at": "25/02/2026 22:24:39",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:21:46"
          },
          {
            "ticket_id": 10452,
            "ticket_number": "3510440",
            "title": "Referencia para pagamento | File:431913/2026",
            "priority": "P2",
            "created_at": "25/02/2026 22:26:24",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 13.92,
            "sla_met": false,
            "sla_breach_hours": 9.92,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:21:46"
          },
          {
            "ticket_id": 10476,
            "ticket_number": "3510464",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "26/02/2026 10:36:16",
            "close_date": "2026-02-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.63,
            "sla_met": false,
            "sla_breach_hours": 7.38,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 18:14:26"
          },
          {
            "ticket_id": 10477,
            "ticket_number": "3510465",
            "title": "Reminder * Reserva File 431638 * Deadline Hoje 17h",
            "priority": "P1",
            "created_at": "26/02/2026 10:54:42",
            "close_date": "2026-02-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.65,
            "sla_met": false,
            "sla_breach_hours": 6.4,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 17:34:31"
          },
          {
            "ticket_id": 10510,
            "ticket_number": "3510498",
            "title": "***URGENTE PAGO HOY***LOC.604514888 (LEPLAN)----Um",
            "priority": "P1",
            "created_at": "26/02/2026 13:18:46",
            "close_date": "2026-02-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.95,
            "sla_met": false,
            "sla_breach_hours": 4.7,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 18:15:49"
          },
          {
            "ticket_id": 10534,
            "ticket_number": "3510522",
            "title": "Envio (Factura-2147896313)",
            "priority": "P1",
            "created_at": "26/02/2026 17:06:20",
            "close_date": "2026-02-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.18,
            "sla_met": false,
            "sla_breach_hours": 0.93,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 18:17:20"
          },
          {
            "ticket_id": 10543,
            "ticket_number": "3510531",
            "title": "CANCELAMENTO",
            "priority": "P2",
            "created_at": "26/02/2026 18:31:37",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:31:37"
          },
          {
            "ticket_id": 10558,
            "ticket_number": "3510546",
            "title": "Referencia para pagamento | File:423949/2026",
            "priority": "P2",
            "created_at": "26/02/2026 22:18:21",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 84.32,
            "sla_met": false,
            "sla_breach_hours": 80.32,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:37:56"
          },
          {
            "ticket_id": 10562,
            "ticket_number": "3510550",
            "title": "Referencia para pagamento | File:432065/2026",
            "priority": "P2",
            "created_at": "26/02/2026 22:30:07",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 12:23:23"
          },
          {
            "ticket_id": 10586,
            "ticket_number": "3510574",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P1",
            "created_at": "27/02/2026 10:04:12",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 86.22,
            "sla_met": false,
            "sla_breach_hours": 85.97,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 00:17:53"
          },
          {
            "ticket_id": 10587,
            "ticket_number": "3510575",
            "title": "GBN-96083 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "27/02/2026 10:04:15",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 86.22,
            "sla_met": false,
            "sla_breach_hours": 85.97,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 00:18:13"
          },
          {
            "ticket_id": 10589,
            "ticket_number": "3510577",
            "title": "Recordativo de pagamento de outros serviços agênci",
            "priority": "P2",
            "created_at": "27/02/2026 10:04:18",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 14:03:36"
          },
          {
            "ticket_id": 10609,
            "ticket_number": "3510597",
            "title": "ARSP-30821: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "27/02/2026 10:30:19",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 72.03,
            "sla_met": false,
            "sla_breach_hours": 71.78,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 10:33:12"
          },
          {
            "ticket_id": 10611,
            "ticket_number": "3510599",
            "title": "Cancelamento de reserva 340788",
            "priority": "P2",
            "created_at": "27/02/2026 12:24:07",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 13:18:01"
          },
          {
            "ticket_id": 10613,
            "ticket_number": "3510601",
            "title": "Cancelamento de reserva 340340",
            "priority": "P2",
            "created_at": "27/02/2026 12:24:16",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 12:27:08"
          },
          {
            "ticket_id": 10626,
            "ticket_number": "3510614",
            "title": "ARSP-30837: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/02/2026 12:55:33",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:43:51"
          },
          {
            "ticket_id": 10627,
            "ticket_number": "3510615",
            "title": "ARSP-30833: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/02/2026 12:55:35",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:43:51"
          },
          {
            "ticket_id": 10634,
            "ticket_number": "3510622",
            "title": "Referencia para pagamento | File:432065/2026",
            "priority": "P1",
            "created_at": "27/02/2026 13:43:53",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 81.88,
            "sla_met": false,
            "sla_breach_hours": 81.63,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 23:37:53"
          },
          {
            "ticket_id": 10638,
            "ticket_number": "3510626",
            "title": "Referencia para pagamento | File:432255/2026",
            "priority": "P1",
            "created_at": "27/02/2026 15:02:23",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/02/2026 15:03:41"
          },
          {
            "ticket_id": 10646,
            "ticket_number": "3510634",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "27/02/2026 15:41:56",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/02/2026 15:43:44"
          },
          {
            "ticket_id": 10647,
            "ticket_number": "3510635",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "27/02/2026 15:41:58",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/02/2026 15:43:44"
          },
          {
            "ticket_id": 10648,
            "ticket_number": "3510636",
            "title": "Envio de Documentação",
            "priority": "P1",
            "created_at": "27/02/2026 15:42:01",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/02/2026 15:43:44"
          },
          {
            "ticket_id": 10649,
            "ticket_number": "3510637",
            "title": "***URGENTE PAGO HOY***LOC.604505099 (LEPLAN)---Uma",
            "priority": "P1",
            "created_at": "27/02/2026 15:45:24",
            "close_date": "2026-02-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.92,
            "sla_met": false,
            "sla_breach_hours": 2.67,
            "sla_name": "SLA P1",
            "first_response_at": "27/02/2026 18:41:14"
          },
          {
            "ticket_id": 10660,
            "ticket_number": "3510648",
            "title": "Confirmação e Sinalização de Reserva 212563",
            "priority": "P2",
            "created_at": "27/02/2026 16:30:39",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 20:24:12"
          },
          {
            "ticket_id": 10665,
            "ticket_number": "3510653",
            "title": "URGENTE - erro no processo de reserva na CNTravel",
            "priority": "P2",
            "created_at": "27/02/2026 16:32:11",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:32:11"
          },
          {
            "ticket_id": 10669,
            "ticket_number": "3510657",
            "title": "Referencia para pagamento | File:432225/2026",
            "priority": "P1",
            "created_at": "27/02/2026 16:56:38",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 79.27,
            "sla_met": false,
            "sla_breach_hours": 79.02,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 00:13:17"
          },
          {
            "ticket_id": 10675,
            "ticket_number": "3510663",
            "title": "Recordativo de pagamento de outros serviços agênci",
            "priority": "P2",
            "created_at": "27/02/2026 18:17:44",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 22:04:18"
          },
          {
            "ticket_id": 10713,
            "ticket_number": "3510701",
            "title": "Referencia para pagamento | File:432293/2026",
            "priority": "P2",
            "created_at": "27/02/2026 22:29:19",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 60.68,
            "sla_met": false,
            "sla_breach_hours": 56.68,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:10:47"
          },
          {
            "ticket_id": 10714,
            "ticket_number": "3510702",
            "title": "Referencia para pagamento | File:432192/2026",
            "priority": "P1",
            "created_at": "27/02/2026 22:29:21",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 59.62,
            "sla_met": false,
            "sla_breach_hours": 59.37,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 10:07:08"
          },
          {
            "ticket_id": 10715,
            "ticket_number": "3510703",
            "title": "Referencia para pagamento | File:432232/2026",
            "priority": "P2",
            "created_at": "27/02/2026 22:29:23",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 59.98,
            "sla_met": false,
            "sla_breach_hours": 55.98,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:29:05"
          },
          {
            "ticket_id": 10721,
            "ticket_number": "3510709",
            "title": "Referencia para pagamento | File:432444/2026",
            "priority": "P2",
            "created_at": "27/02/2026 22:50:53",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 68.27,
            "sla_met": false,
            "sla_breach_hours": 64.27,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 19:07:48"
          },
          {
            "ticket_id": 10733,
            "ticket_number": "3510721",
            "title": "GBN-100480 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:20",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 47.92,
            "sla_met": false,
            "sla_breach_hours": 43.92,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:58:32"
          },
          {
            "ticket_id": 10734,
            "ticket_number": "3510722",
            "title": "GBN-94485 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:21",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 47.92,
            "sla_met": false,
            "sla_breach_hours": 43.92,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:58:22"
          },
          {
            "ticket_id": 10737,
            "ticket_number": "3510725",
            "title": "MSC Cruises Document - 2600101001523263",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:28",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 126.73,
            "sla_met": false,
            "sla_breach_hours": 122.73,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:47:29"
          },
          {
            "ticket_id": 10744,
            "ticket_number": "3510732",
            "title": "ARSP-30833: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:40",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 47.87,
            "sla_met": false,
            "sla_breach_hours": 43.87,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 09:55:46"
          },
          {
            "ticket_id": 10745,
            "ticket_number": "3510733",
            "title": "Recordativo de pagamento de outros serviços agênci",
            "priority": "P2",
            "created_at": "28/02/2026 10:03:42",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 48.73,
            "sla_met": false,
            "sla_breach_hours": 44.73,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:48:39"
          },
          {
            "ticket_id": 10754,
            "ticket_number": "3510742",
            "title": "Confirmacao 341109",
            "priority": "P1",
            "created_at": "28/02/2026 10:17:47",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.43,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P1",
            "first_response_at": "28/02/2026 10:44:40"
          },
          {
            "ticket_id": 10786,
            "ticket_number": "3510774",
            "title": "Envio",
            "priority": "P1",
            "created_at": "28/02/2026 16:03:34",
            "close_date": "2026-02-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.72,
            "sla_met": false,
            "sla_breach_hours": 3.47,
            "sla_name": "SLA P1",
            "first_response_at": "28/02/2026 19:47:02"
          },
          {
            "ticket_id": 10787,
            "ticket_number": "3510775",
            "title": "Cancelamento das reservas na Cockpit",
            "priority": "P2",
            "created_at": "28/02/2026 16:51:23",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 16:51:23"
          },
          {
            "ticket_id": 10789,
            "ticket_number": "3510777",
            "title": "Confirmação de reserva 341178 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "28/02/2026 16:51:27",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 50.18,
            "sla_met": false,
            "sla_breach_hours": 46.18,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 19:02:46"
          },
          {
            "ticket_id": 10802,
            "ticket_number": "3510790",
            "title": "Envio",
            "priority": "P1",
            "created_at": "28/02/2026 18:43:04",
            "close_date": "2026-02-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.05,
            "sla_met": false,
            "sla_breach_hours": 0.8,
            "sla_name": "SLA P1",
            "first_response_at": "28/02/2026 19:46:09"
          },
          {
            "ticket_id": 10803,
            "ticket_number": "3510791",
            "title": "Envio",
            "priority": "P1",
            "created_at": "28/02/2026 18:43:05",
            "close_date": "2026-02-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.03,
            "sla_met": false,
            "sla_breach_hours": 0.78,
            "sla_name": "SLA P1",
            "first_response_at": "28/02/2026 19:45:22"
          },
          {
            "ticket_id": 10809,
            "ticket_number": "3510797",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "28/02/2026 19:09:39",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 19:09:40"
          },
          {
            "ticket_id": 10826,
            "ticket_number": "3510814",
            "title": "Pagamento -  (Recibo-2147836461)",
            "priority": "P2",
            "created_at": "28/02/2026 21:25:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 50.23,
            "sla_met": false,
            "sla_breach_hours": 46.23,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:40:32"
          },
          {
            "ticket_id": 10832,
            "ticket_number": "3510820",
            "title": "Pagamento -  (Recibo-2147836460)",
            "priority": "P2",
            "created_at": "28/02/2026 21:26:13",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 50.2,
            "sla_met": false,
            "sla_breach_hours": 46.2,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:38:57"
          },
          {
            "ticket_id": 10833,
            "ticket_number": "3510821",
            "title": "Pagamento -  (Recibo-2147836459)",
            "priority": "P2",
            "created_at": "28/02/2026 21:26:15",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 50.17,
            "sla_met": false,
            "sla_breach_hours": 46.17,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:36:32"
          },
          {
            "ticket_id": 10838,
            "ticket_number": "3510826",
            "title": "Referencia para pagamento | File:432847/2026",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:06",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 67.9,
            "sla_met": false,
            "sla_breach_hours": 63.9,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:24:43"
          },
          {
            "ticket_id": 10839,
            "ticket_number": "3510827",
            "title": "Referencia para pagamento | File:432870/2026",
            "priority": "P1",
            "created_at": "28/02/2026 22:30:07",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 67.82,
            "sla_met": false,
            "sla_breach_hours": 67.57,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 18:19:40"
          },
          {
            "ticket_id": 10840,
            "ticket_number": "3510828",
            "title": "Referencia para pagamento | File:432892/2026",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:09",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 67.8,
            "sla_met": false,
            "sla_breach_hours": 63.8,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:18:21"
          },
          {
            "ticket_id": 10841,
            "ticket_number": "3510829",
            "title": "Referencia para pagamento | File:432585/2026",
            "priority": "P1",
            "created_at": "28/02/2026 22:30:11",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 49.63,
            "sla_met": false,
            "sla_breach_hours": 49.38,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 00:08:40"
          },
          {
            "ticket_id": 10842,
            "ticket_number": "3510830",
            "title": "Referencia para pagamento | File:432747/2026",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:12",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 67.75,
            "sla_met": false,
            "sla_breach_hours": 63.75,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:15:56"
          },
          {
            "ticket_id": 10844,
            "ticket_number": "3510832",
            "title": "Referencia para pagamento | File:432602/2026",
            "priority": "P1",
            "created_at": "28/02/2026 22:30:16",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 114.18,
            "sla_met": false,
            "sla_breach_hours": 113.93,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 16:41:24"
          },
          {
            "ticket_id": 10846,
            "ticket_number": "3510834",
            "title": "Referencia para pagamento | File:415793/2025",
            "priority": "P2",
            "created_at": "28/02/2026 22:30:21",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 44.5,
            "sla_met": false,
            "sla_breach_hours": 40.5,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 19:01:01"
          },
          {
            "ticket_id": 10869,
            "ticket_number": "3510857",
            "title": "GBN-94483 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "01/03/2026 11:47:11",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 22.08,
            "sla_met": false,
            "sla_breach_hours": 21.83,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 09:52:16"
          },
          {
            "ticket_id": 10870,
            "ticket_number": "3510858",
            "title": "GBN-100480 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "01/03/2026 11:47:13",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 22.02,
            "sla_met": false,
            "sla_breach_hours": 21.77,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 09:48:36"
          },
          {
            "ticket_id": 10871,
            "ticket_number": "3510859",
            "title": "GBN-94485 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "01/03/2026 11:47:14",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 22.02,
            "sla_met": false,
            "sla_breach_hours": 21.77,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 09:48:22"
          },
          {
            "ticket_id": 10873,
            "ticket_number": "3510861",
            "title": "1ª Notificação: Reclamação pagamento Reserva 80228",
            "priority": "P2",
            "created_at": "01/03/2026 11:47:18",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 54.23,
            "sla_met": false,
            "sla_breach_hours": 50.23,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:02:00"
          },
          {
            "ticket_id": 10879,
            "ticket_number": "3510867",
            "title": "Pagamento efetuado por validar - Até 2/3/2026",
            "priority": "P1",
            "created_at": "01/03/2026 11:47:30",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/03/2026 11:47:30"
          },
          {
            "ticket_id": 10943,
            "ticket_number": "3510931",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP669823, Sr/a ",
            "priority": "P3",
            "created_at": "02/03/2026 09:56:36",
            "close_date": "2026-03-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 10:42:14"
          },
          {
            "ticket_id": 10945,
            "ticket_number": "3510933",
            "title": "GBN-94483 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "02/03/2026 09:56:39",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 10:26:08"
          },
          {
            "ticket_id": 10983,
            "ticket_number": "3510971",
            "title": "Referencia para pagamento | File:433137/2026",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:40",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 12.07,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:03:14"
          },
          {
            "ticket_id": 10984,
            "ticket_number": "3510972",
            "title": "Referencia para pagamento | File:432995/2026",
            "priority": "P2",
            "created_at": "02/03/2026 09:58:41",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 8.93,
            "sla_met": false,
            "sla_breach_hours": 4.93,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:54:55"
          },
          {
            "ticket_id": 11005,
            "ticket_number": "3510993",
            "title": "Pedido de Sinalização De Reserva 340259",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:18",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.4,
            "sla_met": false,
            "sla_breach_hours": 7.15,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:51:34"
          },
          {
            "ticket_id": 11006,
            "ticket_number": "3510994",
            "title": "Pedido de Sinalização De Reserva 340888",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:20",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.38,
            "sla_met": false,
            "sla_breach_hours": 7.13,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:51:07"
          },
          {
            "ticket_id": 11007,
            "ticket_number": "3510995",
            "title": "Pedido de Sinalização De Reserva 340876",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:21",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.38,
            "sla_met": false,
            "sla_breach_hours": 7.13,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:50:45"
          },
          {
            "ticket_id": 11008,
            "ticket_number": "3510996",
            "title": "Pedido de Sinalização De Reserva 340262",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:23",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.38,
            "sla_met": false,
            "sla_breach_hours": 7.13,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:50:25"
          },
          {
            "ticket_id": 11009,
            "ticket_number": "3510997",
            "title": "Pedido de Sinalização De Reserva 340779",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:25",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:49:21"
          },
          {
            "ticket_id": 11010,
            "ticket_number": "3510998",
            "title": "Pedido de Sinalização De Reserva 341073",
            "priority": "P1",
            "created_at": "02/03/2026 11:27:26",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.35,
            "sla_met": false,
            "sla_breach_hours": 7.1,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:49:09"
          },
          {
            "ticket_id": 11011,
            "ticket_number": "3510999",
            "title": "Pedido de Sinalização De Reserva 341105",
            "priority": "P2",
            "created_at": "02/03/2026 11:27:28",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:22:29"
          },
          {
            "ticket_id": 11012,
            "ticket_number": "3511000",
            "title": "Pedido de Sinalização De Reserva 340887",
            "priority": "P2",
            "created_at": "02/03/2026 11:27:29",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:22:29"
          },
          {
            "ticket_id": 11018,
            "ticket_number": "3511006",
            "title": "Pedido de Sinalização De Reserva 340262",
            "priority": "P2",
            "created_at": "02/03/2026 12:00:47",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 29.92,
            "sla_met": false,
            "sla_breach_hours": 25.92,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:56:10"
          },
          {
            "ticket_id": 11020,
            "ticket_number": "3511008",
            "title": "Pedido de Sinalização De Reserva 340887",
            "priority": "P1",
            "created_at": "02/03/2026 12:00:51",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 30.15,
            "sla_met": false,
            "sla_breach_hours": 29.9,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 18:10:50"
          },
          {
            "ticket_id": 11021,
            "ticket_number": "3511009",
            "title": "Pedido de Sinalização De Reserva 341073",
            "priority": "P1",
            "created_at": "02/03/2026 12:00:52",
            "close_date": "2026-03-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.75,
            "sla_met": false,
            "sla_breach_hours": 6.5,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 18:46:19"
          },
          {
            "ticket_id": 11022,
            "ticket_number": "3511010",
            "title": "Pedido de Sinalização De Reserva 341105",
            "priority": "P2",
            "created_at": "02/03/2026 12:00:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 6.72,
            "sla_met": false,
            "sla_breach_hours": 2.72,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:44:43"
          },
          {
            "ticket_id": 11023,
            "ticket_number": "3511011",
            "title": "Pedido de Sinalização De Reserva 340779",
            "priority": "P2",
            "created_at": "02/03/2026 12:00:56",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 6.7,
            "sla_met": false,
            "sla_breach_hours": 2.7,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:43:05"
          },
          {
            "ticket_id": 11024,
            "ticket_number": "3511012",
            "title": "Pedido de Sinalização De Reserva 340876",
            "priority": "P2",
            "created_at": "02/03/2026 12:00:58",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 6.67,
            "sla_met": false,
            "sla_breach_hours": 2.67,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:41:01"
          },
          {
            "ticket_id": 11025,
            "ticket_number": "3511013",
            "title": "Pagamento Final de Reserva - 339057",
            "priority": "P2",
            "created_at": "02/03/2026 12:01:00",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 6.62,
            "sla_met": false,
            "sla_breach_hours": 2.62,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:38:59"
          },
          {
            "ticket_id": 11026,
            "ticket_number": "3511014",
            "title": "Pedido de Sinalização De Reserva 340888",
            "priority": "P2",
            "created_at": "02/03/2026 12:01:01",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 6.53,
            "sla_met": false,
            "sla_breach_hours": 2.53,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:33:56"
          },
          {
            "ticket_id": 11027,
            "ticket_number": "3511015",
            "title": "Pedido de Sinalização De Reserva 340259",
            "priority": "P2",
            "created_at": "02/03/2026 12:01:03",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 29.82,
            "sla_met": false,
            "sla_breach_hours": 25.82,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:50:51"
          },
          {
            "ticket_id": 11038,
            "ticket_number": "3511026",
            "title": "[Cancelamento Viagem] TRP-2026-04004 - Ana Maria  ",
            "priority": "P2",
            "created_at": "02/03/2026 12:52:08",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:52:08"
          },
          {
            "ticket_id": 11060,
            "ticket_number": "3511048",
            "title": "Confirmação e Sinalização de Reserva 212741",
            "priority": "P2",
            "created_at": "02/03/2026 16:10:54",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 2.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:25:41"
          },
          {
            "ticket_id": 11065,
            "ticket_number": "3511053",
            "title": "Atualização Cockpit",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:02",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:15:02"
          },
          {
            "ticket_id": 11066,
            "ticket_number": "3511054",
            "title": "Re:[## 33380 ##] GBN-102812 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:04",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:03:09"
          },
          {
            "ticket_id": 11081,
            "ticket_number": "3511069",
            "title": "Confirmação e Sinalização de Reserva 212653",
            "priority": "P2",
            "created_at": "02/03/2026 18:52:18",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:43:24"
          },
          {
            "ticket_id": 11091,
            "ticket_number": "3511079",
            "title": "Re: Localizador: 340685",
            "priority": "P2",
            "created_at": "02/03/2026 19:07:50",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 23:03:26"
          },
          {
            "ticket_id": 11109,
            "ticket_number": "3511097",
            "title": "Referencia para pagamento | File:433296/2026",
            "priority": "P2",
            "created_at": "02/03/2026 22:23:17",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:25:17"
          },
          {
            "ticket_id": 11112,
            "ticket_number": "3511100",
            "title": "[Cancelamento Serviço] TRP-2026-03917 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/03/2026 22:54:54",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:54:54"
          },
          {
            "ticket_id": 11121,
            "ticket_number": "3511109",
            "title": "[Cancelamento Serviço] TRP-2026-02739 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/03/2026 00:04:25",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 14.13,
            "sla_met": false,
            "sla_breach_hours": 10.13,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:13:16"
          },
          {
            "ticket_id": 11122,
            "ticket_number": "3511110",
            "title": "[Cancelamento Serviço] TRP-2026-02739 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/03/2026 00:05:10",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 14.18,
            "sla_met": false,
            "sla_breach_hours": 10.18,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:16:15"
          },
          {
            "ticket_id": 11123,
            "ticket_number": "3511111",
            "title": "[Cancelamento Viagem] TRP-2026-04035 - JOAO RICARD",
            "priority": "P2",
            "created_at": "03/03/2026 00:11:40",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 00:11:40"
          },
          {
            "ticket_id": 11125,
            "ticket_number": "3511113",
            "title": "Envio de Nif",
            "priority": "P2",
            "created_at": "03/03/2026 00:11:50",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 00:11:50"
          },
          {
            "ticket_id": 11134,
            "ticket_number": "3511122",
            "title": "[Suporte] TRP-2026-03651 - Adição de noites",
            "priority": "P3",
            "created_at": "03/03/2026 00:15:08",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/03/2026 00:15:08"
          },
          {
            "ticket_id": 11135,
            "ticket_number": "3511123",
            "title": "Referencia para pagamento | File:432870/2026",
            "priority": "P1",
            "created_at": "03/03/2026 10:01:13",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.53,
            "sla_met": false,
            "sla_breach_hours": 7.28,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 17:33:30"
          },
          {
            "ticket_id": 11140,
            "ticket_number": "3511128",
            "title": "Cancelamento viagem Cuba",
            "priority": "P2",
            "created_at": "03/03/2026 10:01:23",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 10:01:23"
          },
          {
            "ticket_id": 11151,
            "ticket_number": "3511139",
            "title": "Re: Localizador: 340594",
            "priority": "P2",
            "created_at": "03/03/2026 11:11:54",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 12:21:28"
          },
          {
            "ticket_id": 11185,
            "ticket_number": "3511173",
            "title": "[Suporte] TRP-2026-03441 - Corrigir os valores da ",
            "priority": "P2",
            "created_at": "03/03/2026 13:40:33",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:40:33"
          },
          {
            "ticket_id": 11190,
            "ticket_number": "3511178",
            "title": "[Suporte] TRP-2026-03441 - Cancelar reserva GBN-10",
            "priority": "P2",
            "created_at": "03/03/2026 13:42:19",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:42:19"
          },
          {
            "ticket_id": 11197,
            "ticket_number": "3511185",
            "title": "[Suporte] TRP-2026-03558 - Alterar valores - acres",
            "priority": "P2",
            "created_at": "03/03/2026 14:09:56",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:09:56"
          },
          {
            "ticket_id": 11199,
            "ticket_number": "3511187",
            "title": "Comissões vencidas e que não estão corretas no Coc",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:02",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:00:02"
          },
          {
            "ticket_id": 11202,
            "ticket_number": "3511190",
            "title": "Recibo TRP-2026-02884",
            "priority": "P2",
            "created_at": "03/03/2026 15:00:07",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:00:08"
          },
          {
            "ticket_id": 11206,
            "ticket_number": "3511194",
            "title": "[Cancelamento Serviço] TRP-2026-03217 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/03/2026 15:05:05",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:05:05"
          },
          {
            "ticket_id": 11207,
            "ticket_number": "3511195",
            "title": "[Cancelamento Serviço] TRP-2026-03025 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/03/2026 15:47:40",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 15:47:40"
          },
          {
            "ticket_id": 11240,
            "ticket_number": "3511228",
            "title": "Comissões Cockpit",
            "priority": "P1",
            "created_at": "03/03/2026 17:42:31",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/03/2026 17:42:31"
          },
          {
            "ticket_id": 11241,
            "ticket_number": "3511229",
            "title": "Confirmação e Sinalização de Reserva 212775",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:33",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 21:40:42"
          },
          {
            "ticket_id": 11267,
            "ticket_number": "3511255",
            "title": "Confirmação e Sinalização de Reserva 212936",
            "priority": "P2",
            "created_at": "03/03/2026 19:49:07",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 23:40:53"
          },
          {
            "ticket_id": 11283,
            "ticket_number": "3511271",
            "title": "Referencia para pagamento | File:432870/2026",
            "priority": "P2",
            "created_at": "03/03/2026 22:20:15",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:27:14"
          },
          {
            "ticket_id": 11295,
            "ticket_number": "3511283",
            "title": "GBN-108058 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:41",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 30.28,
            "sla_met": false,
            "sla_breach_hours": 26.28,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:34:57"
          },
          {
            "ticket_id": 11299,
            "ticket_number": "3511287",
            "title": "GBN-108016 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/03/2026 10:17:50",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.28,
            "sla_met": false,
            "sla_breach_hours": 3.03,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 13:35:38"
          },
          {
            "ticket_id": 11300,
            "ticket_number": "3511288",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:53",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:37:25"
          },
          {
            "ticket_id": 11302,
            "ticket_number": "3511290",
            "title": "GBN-102972 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/03/2026 10:17:57",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.28,
            "sla_met": false,
            "sla_breach_hours": 3.03,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 13:35:21"
          },
          {
            "ticket_id": 11303,
            "ticket_number": "3511291",
            "title": "GBN-103474 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:59",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 30.27,
            "sla_met": false,
            "sla_breach_hours": 26.27,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:34:44"
          },
          {
            "ticket_id": 11314,
            "ticket_number": "3511302",
            "title": "GBN-109723 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/03/2026 10:18:34",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.27,
            "sla_met": false,
            "sla_breach_hours": 3.02,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 13:35:01"
          },
          {
            "ticket_id": 11315,
            "ticket_number": "3511303",
            "title": "03/03/2026 TRF.IMED.   DE UMA FAMILIA VIAGEM LDA-R",
            "priority": "P2",
            "created_at": "04/03/2026 11:01:42",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:04:19"
          },
          {
            "ticket_id": 11329,
            "ticket_number": "3511317",
            "title": "***MUY URGENTE PAGO HOY***LOC.604505099 (LEPLAN)--",
            "priority": "P1",
            "created_at": "04/03/2026 11:33:51",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 11:41:48"
          },
          {
            "ticket_id": 11331,
            "ticket_number": "3511319",
            "title": "[Cancelamento Serviço] TRP-2026-03821 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/03/2026 11:53:08",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:53:09"
          },
          {
            "ticket_id": 11347,
            "ticket_number": "3511335",
            "title": "Envio",
            "priority": "P2",
            "created_at": "04/03/2026 12:04:54",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:58:35"
          },
          {
            "ticket_id": 11351,
            "ticket_number": "3511339",
            "title": "Reminder * Reserva File 433137 * Deadline Hoje 15H",
            "priority": "P1",
            "created_at": "04/03/2026 12:35:34",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.35,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 13:57:31"
          },
          {
            "ticket_id": 11355,
            "ticket_number": "3511343",
            "title": "Referencia para pagamento | File:433137/2026",
            "priority": "P1",
            "created_at": "04/03/2026 12:35:41",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.92,
            "sla_met": false,
            "sla_breach_hours": 0.67,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 13:31:23"
          },
          {
            "ticket_id": 11360,
            "ticket_number": "3511348",
            "title": "Recordatorio prepago reserva: 1773401",
            "priority": "P2",
            "created_at": "04/03/2026 12:36:01",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:22:28"
          },
          {
            "ticket_id": 11361,
            "ticket_number": "3511349",
            "title": "Recordatorio prepago reserva: 1774543",
            "priority": "P2",
            "created_at": "04/03/2026 12:36:03",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:56:33"
          },
          {
            "ticket_id": 11364,
            "ticket_number": "3511352",
            "title": "[Cancelamento Serviço] TRP-2026-03866 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/03/2026 12:55:23",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:55:23"
          },
          {
            "ticket_id": 11365,
            "ticket_number": "3511353",
            "title": "ARSP-30936: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/03/2026 12:56:36",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 16:42:30"
          },
          {
            "ticket_id": 11373,
            "ticket_number": "3511361",
            "title": "Pedido de faturas",
            "priority": "P2",
            "created_at": "04/03/2026 13:41:47",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:41:47"
          },
          {
            "ticket_id": 11374,
            "ticket_number": "3511362",
            "title": "pagamento",
            "priority": "P3",
            "created_at": "04/03/2026 13:41:49",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 13:41:49"
          },
          {
            "ticket_id": 11388,
            "ticket_number": "3511376",
            "title": "Devolução de transferências",
            "priority": "P1",
            "created_at": "04/03/2026 14:42:25",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 14:42:25"
          },
          {
            "ticket_id": 11408,
            "ticket_number": "3511396",
            "title": "Lembrete de reserva pré-paga : 6139879",
            "priority": "P1",
            "created_at": "04/03/2026 16:08:03",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 16:22:28"
          },
          {
            "ticket_id": 11425,
            "ticket_number": "3511413",
            "title": "Envio",
            "priority": "P1",
            "created_at": "04/03/2026 17:25:46",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.83,
            "sla_met": false,
            "sla_breach_hours": 0.58,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 18:16:45"
          },
          {
            "ticket_id": 11428,
            "ticket_number": "3511416",
            "title": "Envio",
            "priority": "P1",
            "created_at": "04/03/2026 17:25:59",
            "close_date": "2026-03-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.83,
            "sla_met": false,
            "sla_breach_hours": 0.58,
            "sla_name": "SLA P1",
            "first_response_at": "04/03/2026 18:16:06"
          },
          {
            "ticket_id": 11429,
            "ticket_number": "3511417",
            "title": "Faturas fevereiro 2026",
            "priority": "P2",
            "created_at": "04/03/2026 17:39:22",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 17:39:22"
          },
          {
            "ticket_id": 11440,
            "ticket_number": "3511428",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "04/03/2026 19:03:08",
            "close_date": "2026-03-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.77,
            "sla_met": false,
            "sla_breach_hours": 24.52,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 19:49:19"
          },
          {
            "ticket_id": 11445,
            "ticket_number": "3511433",
            "title": "81087 - Bookings due to arrive in the next 7 days",
            "priority": "P2",
            "created_at": "04/03/2026 19:33:20",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:36:37"
          },
          {
            "ticket_id": 11449,
            "ticket_number": "3511437",
            "title": "Comprovativo de IBAN",
            "priority": "P2",
            "created_at": "04/03/2026 21:39:39",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 21:39:39"
          },
          {
            "ticket_id": 11465,
            "ticket_number": "3511453",
            "title": "[Cancelamento Viagem] TRP-2026-04021 - JOAQUIM BAS",
            "priority": "P2",
            "created_at": "05/03/2026 00:32:47",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 00:32:48"
          },
          {
            "ticket_id": 11466,
            "ticket_number": "3511454",
            "title": "[Cancelamento Serviço] TRP-2026-03354 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/03/2026 01:58:02",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 60.2,
            "sla_met": false,
            "sla_breach_hours": 56.2,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 14:10:53"
          },
          {
            "ticket_id": 11477,
            "ticket_number": "3511465",
            "title": "Solole",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:21",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:47:14"
          },
          {
            "ticket_id": 11487,
            "ticket_number": "3511475",
            "title": "GBN-83273 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:56",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11488,
            "ticket_number": "3511476",
            "title": "GBN-108447 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "05/03/2026 10:07:58",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11489,
            "ticket_number": "3511477",
            "title": "GBN-108058 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "05/03/2026 10:08:01",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.87,
            "sla_met": false,
            "sla_breach_hours": 3.62,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11490,
            "ticket_number": "3511478",
            "title": "GBN-109804 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "05/03/2026 10:08:03",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:15"
          },
          {
            "ticket_id": 11517,
            "ticket_number": "3511505",
            "title": "RE: Reserva 6120559 W2MCS:014950003136",
            "priority": "P2",
            "created_at": "05/03/2026 12:43:57",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:40:38"
          },
          {
            "ticket_id": 11522,
            "ticket_number": "3511510",
            "title": "RE: Pagamento 604505099",
            "priority": "P2",
            "created_at": "05/03/2026 14:27:07",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:20:51"
          },
          {
            "ticket_id": 11525,
            "ticket_number": "3511513",
            "title": "Confirmação e Sinalização de Reserva 212003",
            "priority": "P1",
            "created_at": "05/03/2026 14:27:28",
            "close_date": "2026-03-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 14:40:22"
          },
          {
            "ticket_id": 11547,
            "ticket_number": "3511535",
            "title": "Faturação TRP-2026-04099_LOC GBN-110252",
            "priority": "P2",
            "created_at": "05/03/2026 16:52:02",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:52:02"
          },
          {
            "ticket_id": 11549,
            "ticket_number": "3511537",
            "title": "[Cancelamento Viagem] TRP-2026-02587 - Sonia Maria",
            "priority": "P2",
            "created_at": "05/03/2026 18:10:04",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:10:04"
          },
          {
            "ticket_id": 11566,
            "ticket_number": "3511554",
            "title": "URGENTE Confirmação de reserva 341851 ### TIME LIM",
            "priority": "P1",
            "created_at": "05/03/2026 18:53:25",
            "close_date": "2026-03-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.57,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 19:27:42"
          },
          {
            "ticket_id": 11588,
            "ticket_number": "3511576",
            "title": "Referencia para pagamento | File:433867/2026",
            "priority": "P2",
            "created_at": "05/03/2026 23:13:26",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:15:25"
          },
          {
            "ticket_id": 11594,
            "ticket_number": "3511582",
            "title": "Referencia para pagamento | File:413248/2025",
            "priority": "P2",
            "created_at": "05/03/2026 23:13:40",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:16:35"
          },
          {
            "ticket_id": 11598,
            "ticket_number": "3511586",
            "title": "Cancelamento de passageiro - Solferias 415793",
            "priority": "P2",
            "created_at": "05/03/2026 23:50:03",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:50:04"
          },
          {
            "ticket_id": 11602,
            "ticket_number": "3511590",
            "title": "[Cancelamento Serviço] TRP-2026-04102 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 01:12:31",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 01:12:31"
          },
          {
            "ticket_id": 11608,
            "ticket_number": "3511596",
            "title": "pedido de fatura",
            "priority": "P2",
            "created_at": "06/03/2026 10:09:02",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:09:03"
          },
          {
            "ticket_id": 11610,
            "ticket_number": "3511598",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "06/03/2026 10:09:06",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 14:02:54"
          },
          {
            "ticket_id": 11611,
            "ticket_number": "3511599",
            "title": "GBN-105557 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "06/03/2026 10:09:08",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 78.38,
            "sla_met": false,
            "sla_breach_hours": 78.13,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 16:32:30"
          },
          {
            "ticket_id": 11613,
            "ticket_number": "3511601",
            "title": "Información de reservas que entran en gastos próxi",
            "priority": "P1",
            "created_at": "06/03/2026 10:09:12",
            "close_date": "2026-03-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.45,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 10:36:54"
          },
          {
            "ticket_id": 11621,
            "ticket_number": "3511609",
            "title": "Re: Comissões erradas cokpit",
            "priority": "P2",
            "created_at": "06/03/2026 10:38:27",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:38:29"
          },
          {
            "ticket_id": 11639,
            "ticket_number": "3511627",
            "title": "Re: [Cockpit] Viagem TRP-2026-04001 - MAIORCA",
            "priority": "P2",
            "created_at": "06/03/2026 13:05:23",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:05:23"
          },
          {
            "ticket_id": 11648,
            "ticket_number": "3511636",
            "title": "ARSP-30913: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "06/03/2026 13:22:56",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 145.63,
            "sla_met": false,
            "sla_breach_hours": 141.63,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:00:57"
          },
          {
            "ticket_id": 11670,
            "ticket_number": "3511658",
            "title": "FW: [Cockpit] Viagem TRP-2026-04093 - ANA CORREIA ",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:36",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:47:36"
          },
          {
            "ticket_id": 11686,
            "ticket_number": "3511674",
            "title": "FW: ERROR-Icárion - Tailândia Incrível - 2026-06-1",
            "priority": "P1",
            "created_at": "06/03/2026 17:25:06",
            "close_date": "2026-03-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.52,
            "sla_met": false,
            "sla_breach_hours": 1.27,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 18:56:31"
          },
          {
            "ticket_id": 11689,
            "ticket_number": "3511677",
            "title": "Confirmação de reserva -Tailândia Incrível- 700429",
            "priority": "P1",
            "created_at": "06/03/2026 18:14:15",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.37,
            "sla_met": false,
            "sla_breach_hours": 0.12,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 18:36:20"
          },
          {
            "ticket_id": 11724,
            "ticket_number": "3511712",
            "title": "[Suporte] TRP-2026-02332 - Alteração de valor PVP ",
            "priority": "P2",
            "created_at": "06/03/2026 20:08:56",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:08:56"
          },
          {
            "ticket_id": 11729,
            "ticket_number": "3511717",
            "title": "Confirmacao 341993",
            "priority": "P1",
            "created_at": "06/03/2026 20:51:26",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.52,
            "sla_met": false,
            "sla_breach_hours": 0.27,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 21:23:25"
          },
          {
            "ticket_id": 11731,
            "ticket_number": "3511719",
            "title": "[Cancelamento Viagem] TRP-2026-03082 - LUIS MIGUEL",
            "priority": "P2",
            "created_at": "06/03/2026 21:19:03",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:19:04"
          },
          {
            "ticket_id": 11738,
            "ticket_number": "3511726",
            "title": "Confirmacao 341995",
            "priority": "P1",
            "created_at": "06/03/2026 21:34:35",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.35,
            "sla_met": false,
            "sla_breach_hours": 0.1,
            "sla_name": "SLA P1",
            "first_response_at": "06/03/2026 21:56:16"
          },
          {
            "ticket_id": 11743,
            "ticket_number": "3511731",
            "title": "Referencia para pagamento | File:434053/2026",
            "priority": "P2",
            "created_at": "06/03/2026 22:13:36",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:18:33"
          },
          {
            "ticket_id": 11769,
            "ticket_number": "3511757",
            "title": "RV: [Tour10] Asunto: Transferência de valores",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:43",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 10:07:43"
          },
          {
            "ticket_id": 11786,
            "ticket_number": "3511774",
            "title": "Faturas/Recibos",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:17",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:20:17"
          },
          {
            "ticket_id": 11792,
            "ticket_number": "3511780",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "07/03/2026 13:23:45",
            "close_date": "2026-03-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.03,
            "sla_met": false,
            "sla_breach_hours": 1.78,
            "sla_name": "SLA P1",
            "first_response_at": "07/03/2026 15:25:59"
          },
          {
            "ticket_id": 11793,
            "ticket_number": "3511781",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "07/03/2026 13:23:47",
            "close_date": "2026-03-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.02,
            "sla_met": false,
            "sla_breach_hours": 1.77,
            "sla_name": "SLA P1",
            "first_response_at": "07/03/2026 15:25:24"
          },
          {
            "ticket_id": 11794,
            "ticket_number": "3511782",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "07/03/2026 13:23:49",
            "close_date": "2026-03-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.02,
            "sla_met": false,
            "sla_breach_hours": 1.77,
            "sla_name": "SLA P1",
            "first_response_at": "07/03/2026 15:24:51"
          },
          {
            "ticket_id": 11814,
            "ticket_number": "3511802",
            "title": "Booking payment confirmation by POS",
            "priority": "P2",
            "created_at": "07/03/2026 18:40:51",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 143.72,
            "sla_met": false,
            "sla_breach_hours": 139.72,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 18:24:51"
          },
          {
            "ticket_id": 11827,
            "ticket_number": "3511815",
            "title": "[Cancelamento Serviço] TRP-2026-03881 / TRL-2026-0",
            "priority": "P3",
            "created_at": "08/03/2026 23:37:24",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/03/2026 23:37:24"
          },
          {
            "ticket_id": 11828,
            "ticket_number": "3511816",
            "title": "[Cancelamento Serviço] TRP-2026-03881 / TRL-2026-0",
            "priority": "P2",
            "created_at": "08/03/2026 23:37:48",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 23:37:48"
          },
          {
            "ticket_id": 11831,
            "ticket_number": "3511819",
            "title": "Faturas em falta",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:17",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:04:17"
          },
          {
            "ticket_id": 11832,
            "ticket_number": "3511820",
            "title": "GBN-96591 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:19",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.45,
            "sla_met": false,
            "sla_breach_hours": 2.45,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:32:02"
          },
          {
            "ticket_id": 11835,
            "ticket_number": "3511823",
            "title": "GBN-94107 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:25",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11837,
            "ticket_number": "3511825",
            "title": "GBN-98330 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:30",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11838,
            "ticket_number": "3511826",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:31",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.9,
            "sla_met": false,
            "sla_breach_hours": 2.9,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:59:12"
          },
          {
            "ticket_id": 11840,
            "ticket_number": "3511828",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:36",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11842,
            "ticket_number": "3511830",
            "title": "[Reserva a pagar] Reserva [Terrace Vila Ii By An I",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:40",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 6.87,
            "sla_met": false,
            "sla_breach_hours": 2.87,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 16:56:45"
          },
          {
            "ticket_id": 11843,
            "ticket_number": "3511831",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "09/03/2026 10:04:42",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:43"
          },
          {
            "ticket_id": 11857,
            "ticket_number": "3511845",
            "title": "Referencia para pagamento | File:433137/2026",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:18",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11882,
            "ticket_number": "3511870",
            "title": "GBN-98330 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:30",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11885,
            "ticket_number": "3511873",
            "title": "GBN-96591 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:38",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11887,
            "ticket_number": "3511875",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60457",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:43",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 247.87,
            "sla_met": false,
            "sla_breach_hours": 243.87,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:00:24"
          },
          {
            "ticket_id": 11889,
            "ticket_number": "3511877",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:47",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:42"
          },
          {
            "ticket_id": 11905,
            "ticket_number": "3511893",
            "title": "Re: [Cockpit] Viagem TRP-2026-03912 - BAYAHIBE",
            "priority": "P3",
            "created_at": "09/03/2026 10:44:38",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 10:44:38"
          },
          {
            "ticket_id": 11907,
            "ticket_number": "3511895",
            "title": "Solicitud depósito 17015545",
            "priority": "P1",
            "created_at": "09/03/2026 10:55:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.38,
            "sla_met": false,
            "sla_breach_hours": 3.13,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:18:55"
          },
          {
            "ticket_id": 11909,
            "ticket_number": "3511897",
            "title": "[Suporte] TRP-2026-03635 - Transferência de pagame",
            "priority": "P2",
            "created_at": "09/03/2026 11:24:39",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 11:24:39"
          },
          {
            "ticket_id": 11911,
            "ticket_number": "3511899",
            "title": "Pedido de Sinalização De Reserva 341374",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:16",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.8,
            "sla_met": false,
            "sla_breach_hours": 2.55,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:45:27"
          },
          {
            "ticket_id": 11912,
            "ticket_number": "3511900",
            "title": "Pedido de Sinalização De Reserva 341870",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:18",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.68,
            "sla_met": false,
            "sla_breach_hours": 2.43,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:38:37"
          },
          {
            "ticket_id": 11914,
            "ticket_number": "3511902",
            "title": "Pedido de Sinalização De Reserva 341154",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:22",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.62,
            "sla_met": false,
            "sla_breach_hours": 2.37,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:35:03"
          },
          {
            "ticket_id": 11915,
            "ticket_number": "3511903",
            "title": "Pedido de Sinalização De Reserva 341498",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:23",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.32,
            "sla_met": false,
            "sla_breach_hours": 3.07,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:16:55"
          },
          {
            "ticket_id": 11916,
            "ticket_number": "3511904",
            "title": "Pedido de Sinalização De Reserva 341139",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:25",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 32.63,
            "sla_met": false,
            "sla_breach_hours": 32.38,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 20:35:33"
          },
          {
            "ticket_id": 11918,
            "ticket_number": "3511906",
            "title": "Pedido de Sinalização De Reserva 341995",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:28",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.28,
            "sla_met": false,
            "sla_breach_hours": 3.03,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:14:57"
          },
          {
            "ticket_id": 11919,
            "ticket_number": "3511907",
            "title": "Pedido de Sinalização De Reserva 342009",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:30",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.23,
            "sla_met": false,
            "sla_breach_hours": 2.98,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:12:28"
          },
          {
            "ticket_id": 11920,
            "ticket_number": "3511908",
            "title": "Pedido de Sinalização De Reserva 341311",
            "priority": "P1",
            "created_at": "09/03/2026 11:57:32",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.23,
            "sla_met": false,
            "sla_breach_hours": 2.98,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:12:05"
          },
          {
            "ticket_id": 11924,
            "ticket_number": "3511912",
            "title": "Pedido de Sinalização De Reserva 342009",
            "priority": "P1",
            "created_at": "09/03/2026 12:14:49",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.92,
            "sla_met": false,
            "sla_breach_hours": 2.67,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:10:15"
          },
          {
            "ticket_id": 11925,
            "ticket_number": "3511913",
            "title": "Pagamento Final de Reserva - 341959",
            "priority": "P1",
            "created_at": "09/03/2026 12:14:50",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.85,
            "sla_met": false,
            "sla_breach_hours": 2.6,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:06:39"
          },
          {
            "ticket_id": 11926,
            "ticket_number": "3511914",
            "title": "Pagamento Final de Reserva - 341925",
            "priority": "P1",
            "created_at": "09/03/2026 12:14:52",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.82,
            "sla_met": false,
            "sla_breach_hours": 2.57,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 15:04:50"
          },
          {
            "ticket_id": 11927,
            "ticket_number": "3511915",
            "title": "Pagamento Final de Reserva - 341217",
            "priority": "P1",
            "created_at": "09/03/2026 12:14:54",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.7,
            "sla_met": false,
            "sla_breach_hours": 2.45,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:57:05"
          },
          {
            "ticket_id": 11928,
            "ticket_number": "3511916",
            "title": "Pedido de Sinalização De Reserva 341993",
            "priority": "P1",
            "created_at": "09/03/2026 12:14:56",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.68,
            "sla_met": false,
            "sla_breach_hours": 2.43,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:56:09"
          },
          {
            "ticket_id": 11935,
            "ticket_number": "3511923",
            "title": "Pedido de Sinalização De Reserva 341154",
            "priority": "P1",
            "created_at": "09/03/2026 12:15:09",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.6,
            "sla_met": false,
            "sla_breach_hours": 2.35,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:51:29"
          },
          {
            "ticket_id": 11936,
            "ticket_number": "3511924",
            "title": "Pedido de Sinalização De Reserva 341139",
            "priority": "P1",
            "created_at": "09/03/2026 12:15:10",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.6,
            "sla_met": false,
            "sla_breach_hours": 2.35,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 14:51:11"
          },
          {
            "ticket_id": 11956,
            "ticket_number": "3511944",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "09/03/2026 14:27:09",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.15,
            "sla_met": false,
            "sla_breach_hours": 1.9,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 16:36:28"
          },
          {
            "ticket_id": 11981,
            "ticket_number": "3511969",
            "title": "[Suporte] TRP-2026-04172 - Valor de comissão errad",
            "priority": "P2",
            "created_at": "09/03/2026 18:40:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 18:40:44"
          },
          {
            "ticket_id": 11982,
            "ticket_number": "3511970",
            "title": "Referencia para pagamento | File:434428/2026",
            "priority": "P1",
            "created_at": "09/03/2026 19:02:06",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 19:04:32"
          },
          {
            "ticket_id": 11997,
            "ticket_number": "3511985",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "09/03/2026 20:26:00",
            "close_date": "2026-03-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/03/2026 20:26:54"
          },
          {
            "ticket_id": 12012,
            "ticket_number": "3512000",
            "title": "[Suporte] TRP-2026-03821 - atualização de viagem",
            "priority": "P2",
            "created_at": "09/03/2026 23:03:25",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:52:28"
          },
          {
            "ticket_id": 12018,
            "ticket_number": "3512006",
            "title": "[Cancelamento Serviço] TRP-2026-03140 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/03/2026 23:58:59",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 23:59:00"
          },
          {
            "ticket_id": 12026,
            "ticket_number": "3512014",
            "title": "Información de reservas que entran en gastos próxi",
            "priority": "P2",
            "created_at": "10/03/2026 10:08:07",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 14:01:38"
          },
          {
            "ticket_id": 12027,
            "ticket_number": "3512015",
            "title": "Re: [Cockpit] Viagem TRP-2026-04096 - Formentera L",
            "priority": "P2",
            "created_at": "10/03/2026 10:08:09",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:08:09"
          },
          {
            "ticket_id": 12029,
            "ticket_number": "3512017",
            "title": "GBN-94107 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "10/03/2026 10:08:14",
            "close_date": "2026-03-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.88,
            "sla_met": false,
            "sla_breach_hours": 3.63,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 14:01:38"
          },
          {
            "ticket_id": 12030,
            "ticket_number": "3512018",
            "title": "Re: Novo Reforço de Pagamento - Viagem # 241400001",
            "priority": "P2",
            "created_at": "10/03/2026 10:11:49",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:11:49"
          },
          {
            "ticket_id": 12034,
            "ticket_number": "3512022",
            "title": "Faturas Pendentes: FA 2147898801",
            "priority": "P1",
            "created_at": "10/03/2026 10:18:17",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.55,
            "sla_met": false,
            "sla_breach_hours": 3.3,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 13:51:22"
          },
          {
            "ticket_id": 12035,
            "ticket_number": "3512023",
            "title": "Faturas Pendentes: FA 2147898927",
            "priority": "P1",
            "created_at": "10/03/2026 10:18:49",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.52,
            "sla_met": false,
            "sla_breach_hours": 3.27,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 13:49:56"
          },
          {
            "ticket_id": 12043,
            "ticket_number": "3512031",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P1",
            "created_at": "10/03/2026 10:24:21",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.95,
            "sla_met": false,
            "sla_breach_hours": 3.7,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 14:21:46"
          },
          {
            "ticket_id": 12044,
            "ticket_number": "3512032",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "10/03/2026 10:36:21",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.38,
            "sla_met": false,
            "sla_breach_hours": 3.13,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 14:00:16"
          },
          {
            "ticket_id": 12052,
            "ticket_number": "3512040",
            "title": "Confirmação de reserva 341328####### TIME LIMIT PA",
            "priority": "P1",
            "created_at": "10/03/2026 12:10:42",
            "close_date": "2026-04-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.85,
            "sla_met": false,
            "sla_breach_hours": 3.6,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 16:02:03"
          },
          {
            "ticket_id": 12056,
            "ticket_number": "3512044",
            "title": "Proforma CnTravel 17015545",
            "priority": "P1",
            "created_at": "10/03/2026 12:32:09",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.82,
            "sla_met": false,
            "sla_breach_hours": 3.57,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 16:22:05"
          },
          {
            "ticket_id": 12086,
            "ticket_number": "3512074",
            "title": "Comissões Opti 241600021",
            "priority": "P3",
            "created_at": "10/03/2026 16:16:32",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/03/2026 16:16:33"
          },
          {
            "ticket_id": 12094,
            "ticket_number": "3512082",
            "title": "Faturas Pendentes: FA 2147898986",
            "priority": "P1",
            "created_at": "10/03/2026 17:16:56",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.58,
            "sla_met": false,
            "sla_breach_hours": 2.33,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 19:52:42"
          },
          {
            "ticket_id": 12098,
            "ticket_number": "3512086",
            "title": "GBN-111260 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "10/03/2026 18:01:55",
            "close_date": "2026-03-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.8,
            "sla_met": false,
            "sla_breach_hours": 16.55,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 10:50:29"
          },
          {
            "ticket_id": 12101,
            "ticket_number": "3512089",
            "title": "Pedido de Emissão Faturas",
            "priority": "P2",
            "created_at": "10/03/2026 18:51:04",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 18:51:04"
          },
          {
            "ticket_id": 12102,
            "ticket_number": "3512090",
            "title": "In Sure Broker alerta-o para documentos a pagament",
            "priority": "P1",
            "created_at": "10/03/2026 18:51:07",
            "close_date": "2026-03-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "10/03/2026 19:02:35"
          },
          {
            "ticket_id": 12103,
            "ticket_number": "3512091",
            "title": "Pedido de cancelamento sem custos – Reserva 416525",
            "priority": "P1",
            "created_at": "10/03/2026 18:57:37",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "10/11/2025 10:57:11"
          },
          {
            "ticket_id": 12104,
            "ticket_number": "3512092",
            "title": "{Ref_CORREO_MARSOL_ESP20001536783} RV: RESERVA / F",
            "priority": "P2",
            "created_at": "10/03/2026 19:09:09",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:03:15"
          },
          {
            "ticket_id": 12107,
            "ticket_number": "3512095",
            "title": "[Cancelamento Viagem] TRP-2026-03899 - Daniela Oli",
            "priority": "P2",
            "created_at": "10/03/2026 21:19:55",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 11:57:17"
          },
          {
            "ticket_id": 12108,
            "ticket_number": "3512096",
            "title": "Faturas",
            "priority": "P2",
            "created_at": "10/03/2026 21:36:31",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 21:36:31"
          },
          {
            "ticket_id": 12132,
            "ticket_number": "3512120",
            "title": "Re: [Cockpit] Viagem TRP-2026-04169 - Carabela Ana",
            "priority": "P2",
            "created_at": "10/03/2026 23:08:31",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:08:31"
          },
          {
            "ticket_id": 12143,
            "ticket_number": "3512131",
            "title": "GBN-96779 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "11/03/2026 10:01:52",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 10:50:15"
          },
          {
            "ticket_id": 12147,
            "ticket_number": "3512135",
            "title": "Referencia para pagamento | File:434645/2026",
            "priority": "P1",
            "created_at": "11/03/2026 10:02:13",
            "close_date": "2026-03-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.62,
            "sla_met": false,
            "sla_breach_hours": 1.37,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 11:40:05"
          },
          {
            "ticket_id": 12148,
            "ticket_number": "3512136",
            "title": "Referencia para pagamento | File:429171/2026",
            "priority": "P2",
            "created_at": "11/03/2026 10:02:15",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 29.27,
            "sla_met": false,
            "sla_breach_hours": 25.27,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:19:12"
          },
          {
            "ticket_id": 12159,
            "ticket_number": "3512147",
            "title": "ARSP-31018: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/03/2026 10:48:28",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 14:40:00"
          },
          {
            "ticket_id": 12161,
            "ticket_number": "3512149",
            "title": "ARSP-31024: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/03/2026 10:48:32",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 14:40:00"
          },
          {
            "ticket_id": 12162,
            "ticket_number": "3512150",
            "title": "Re: [Cockpit] Viagem TRP-2026-04144 - Ilha da Made",
            "priority": "P3",
            "created_at": "11/03/2026 10:48:34",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/03/2026 10:48:34"
          },
          {
            "ticket_id": 12166,
            "ticket_number": "3512154",
            "title": "Information about your recent invoices, UMA FAMILI",
            "priority": "P2",
            "created_at": "11/03/2026 11:35:42",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 12:45:20"
          },
          {
            "ticket_id": 12236,
            "ticket_number": "3512224",
            "title": "Confirmação e Sinalização de Reserva 213426",
            "priority": "P1",
            "created_at": "11/03/2026 17:45:04",
            "close_date": "2026-03-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 21.52,
            "sla_met": false,
            "sla_breach_hours": 21.27,
            "sla_name": "SLA P1",
            "first_response_at": "12/03/2026 15:16:16"
          },
          {
            "ticket_id": 12245,
            "ticket_number": "3512233",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "11/03/2026 18:08:15",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 22:01:31"
          },
          {
            "ticket_id": 12248,
            "ticket_number": "3512236",
            "title": "FW: Icárion - Maldivas - Divisão de Estadia (Quart",
            "priority": "P2",
            "created_at": "11/03/2026 18:17:43",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 20.95,
            "sla_met": false,
            "sla_breach_hours": 16.95,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:14:58"
          },
          {
            "ticket_id": 12253,
            "ticket_number": "3512241",
            "title": "ARSP-31024: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/03/2026 18:19:26",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 20.88,
            "sla_met": false,
            "sla_breach_hours": 16.88,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:13:19"
          },
          {
            "ticket_id": 12267,
            "ticket_number": "3512255",
            "title": "ARSP-30936: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/03/2026 18:53:18",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 22:41:33"
          },
          {
            "ticket_id": 12273,
            "ticket_number": "3512261",
            "title": "Confirmação e Sinalização de Reserva 213430",
            "priority": "P1",
            "created_at": "11/03/2026 19:46:44",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.8,
            "sla_met": false,
            "sla_breach_hours": 3.55,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 23:35:20"
          },
          {
            "ticket_id": 12293,
            "ticket_number": "3512281",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P3",
            "created_at": "11/03/2026 21:49:36",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/03/2026 21:49:37"
          },
          {
            "ticket_id": 12300,
            "ticket_number": "3512288",
            "title": "Referencia para pagamento | File:434925/2026",
            "priority": "P2",
            "created_at": "11/03/2026 22:57:42",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:04:04"
          },
          {
            "ticket_id": 12304,
            "ticket_number": "3512292",
            "title": "Referencia para pagamento | File:434808/2026",
            "priority": "P2",
            "created_at": "11/03/2026 22:57:51",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:02:32"
          },
          {
            "ticket_id": 12323,
            "ticket_number": "3512311",
            "title": "GBN-96779 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:15",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.57,
            "sla_met": false,
            "sla_breach_hours": 0.57,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:30:51"
          },
          {
            "ticket_id": 12325,
            "ticket_number": "3512313",
            "title": "MSC Cruises Document - 2600101001882077",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:18",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.58,
            "sla_met": false,
            "sla_breach_hours": 0.58,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:31:31"
          },
          {
            "ticket_id": 12326,
            "ticket_number": "3512314",
            "title": "GBN-99759 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:20",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.57,
            "sla_met": false,
            "sla_breach_hours": 0.57,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:30:37"
          },
          {
            "ticket_id": 12328,
            "ticket_number": "3512316",
            "title": "Correção de valores – reserva Opti 2413500031",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:25",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 314.37,
            "sla_met": false,
            "sla_breach_hours": 310.37,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:19:07"
          },
          {
            "ticket_id": 12329,
            "ticket_number": "3512317",
            "title": "GBN-95844 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "12/03/2026 09:56:26",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.57,
            "sla_met": false,
            "sla_breach_hours": 0.57,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:30:30"
          },
          {
            "ticket_id": 12356,
            "ticket_number": "3512344",
            "title": "[Cancelamento Serviço] TRP-2026-04126 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/03/2026 13:06:46",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 13:06:47"
          },
          {
            "ticket_id": 12388,
            "ticket_number": "3512376",
            "title": "Confirmação de Reserva * FILE 435009/26",
            "priority": "P1",
            "created_at": "12/03/2026 17:41:58",
            "close_date": "2026-03-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.2,
            "sla_met": false,
            "sla_breach_hours": 0.95,
            "sla_name": "SLA P1",
            "first_response_at": "12/03/2026 18:54:25"
          },
          {
            "ticket_id": 12434,
            "ticket_number": "3512422",
            "title": "Referencia para pagamento | File:435009/2026",
            "priority": "P1",
            "created_at": "12/03/2026 22:29:17",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12435,
            "ticket_number": "3512423",
            "title": "Referencia para pagamento | File:434986/2026",
            "priority": "P1",
            "created_at": "12/03/2026 22:29:19",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12436,
            "ticket_number": "3512424",
            "title": "Referencia para pagamento | File:434988/2026",
            "priority": "P1",
            "created_at": "12/03/2026 22:29:20",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "12/03/2026 22:44:10"
          },
          {
            "ticket_id": 12445,
            "ticket_number": "3512433",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "12/03/2026 23:20:23",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 23:20:23"
          },
          {
            "ticket_id": 12447,
            "ticket_number": "3512435",
            "title": "GBN-67038 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "13/03/2026 10:05:29",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:40:21"
          },
          {
            "ticket_id": 12450,
            "ticket_number": "3512438",
            "title": "GBN-99759 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "13/03/2026 10:05:43",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.57,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 10:40:07"
          },
          {
            "ticket_id": 12451,
            "ticket_number": "3512439",
            "title": "GBN-95844 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "13/03/2026 10:05:45",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.52,
            "sla_met": false,
            "sla_breach_hours": 1.27,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 11:36:56"
          },
          {
            "ticket_id": 12454,
            "ticket_number": "3512442",
            "title": "Interline",
            "priority": "P2",
            "created_at": "13/03/2026 10:05:53",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 14:00:34"
          },
          {
            "ticket_id": 12455,
            "ticket_number": "3512443",
            "title": "Amanhã será realizada a cobrança da reserva A37551",
            "priority": "P2",
            "created_at": "13/03/2026 10:05:54",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:39:42"
          },
          {
            "ticket_id": 12461,
            "ticket_number": "3512449",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "13/03/2026 10:06:15",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:06:16"
          },
          {
            "ticket_id": 12474,
            "ticket_number": "3512462",
            "title": "Reminder * Reserva File 435009 * Deadline Hoje 13H",
            "priority": "P1",
            "created_at": "13/03/2026 11:12:43",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.8,
            "sla_met": false,
            "sla_breach_hours": 0.55,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 12:00:48"
          },
          {
            "ticket_id": 12478,
            "ticket_number": "3512466",
            "title": "Referencia para pagamento | File:435113/2026",
            "priority": "P1",
            "created_at": "13/03/2026 11:35:15",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 11:40:14"
          },
          {
            "ticket_id": 12479,
            "ticket_number": "3512467",
            "title": "Confirmação e Sinalização de Reserva 213524",
            "priority": "P1",
            "created_at": "13/03/2026 11:41:51",
            "close_date": "2026-03-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.27,
            "sla_met": false,
            "sla_breach_hours": 7.02,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 18:58:38"
          },
          {
            "ticket_id": 12510,
            "ticket_number": "3512498",
            "title": "Fatura Viagem TRP-2026-04260",
            "priority": "P2",
            "created_at": "13/03/2026 16:34:05",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:34:05"
          },
          {
            "ticket_id": 12514,
            "ticket_number": "3512502",
            "title": "Alteração iban comissões",
            "priority": "P2",
            "created_at": "13/03/2026 16:53:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 16:53:47"
          },
          {
            "ticket_id": 12538,
            "ticket_number": "3512526",
            "title": "Leplan - 604590473 e 604590476",
            "priority": "P1",
            "created_at": "13/03/2026 19:30:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/03/2026 19:30:25"
          },
          {
            "ticket_id": 12560,
            "ticket_number": "3512548",
            "title": "Referencia para pagamento | File:435117/2026",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:15",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 89.95,
            "sla_met": false,
            "sla_breach_hours": 85.95,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 17:23:44"
          },
          {
            "ticket_id": 12563,
            "ticket_number": "3512551",
            "title": "Referencia para pagamento | File:416525/2025",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:27",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 448.77,
            "sla_met": false,
            "sla_breach_hours": 444.77,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 16:12:34"
          },
          {
            "ticket_id": 12564,
            "ticket_number": "3512552",
            "title": "Referencia para pagamento | File:424615/2026",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:30",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 90.9,
            "sla_met": false,
            "sla_breach_hours": 86.9,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:21:17"
          },
          {
            "ticket_id": 12573,
            "ticket_number": "3512561",
            "title": "GBN-106969 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "14/03/2026 10:20:29",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.22,
            "sla_met": false,
            "sla_breach_hours": 53.97,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:34:21"
          },
          {
            "ticket_id": 12574,
            "ticket_number": "3512562",
            "title": "GBN-88141 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "14/03/2026 10:20:31",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.22,
            "sla_met": false,
            "sla_breach_hours": 53.97,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:34:12"
          },
          {
            "ticket_id": 12575,
            "ticket_number": "3512563",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60457",
            "priority": "P2",
            "created_at": "14/03/2026 10:20:33",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 293.98,
            "sla_met": false,
            "sla_breach_hours": 289.98,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 16:20:07"
          },
          {
            "ticket_id": 12576,
            "ticket_number": "3512564",
            "title": "GBN-106968 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "14/03/2026 10:20:35",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.2,
            "sla_met": false,
            "sla_breach_hours": 53.95,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:32:39"
          },
          {
            "ticket_id": 12577,
            "ticket_number": "3512565",
            "title": "GBN-106965 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "14/03/2026 10:20:37",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.17,
            "sla_met": false,
            "sla_breach_hours": 53.92,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:30:54"
          },
          {
            "ticket_id": 12578,
            "ticket_number": "3512566",
            "title": "GBN-100046 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "14/03/2026 10:20:39",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.17,
            "sla_met": false,
            "sla_breach_hours": 53.92,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:30:45"
          },
          {
            "ticket_id": 12580,
            "ticket_number": "3512568",
            "title": "Status dos pagamentos atuais ⏳",
            "priority": "P1",
            "created_at": "14/03/2026 10:21:30",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.38,
            "sla_met": false,
            "sla_breach_hours": 54.13,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:45:02"
          },
          {
            "ticket_id": 12623,
            "ticket_number": "3512611",
            "title": "Status dos pagamentos atuais ⏳",
            "priority": "P1",
            "created_at": "16/03/2026 10:06:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.98,
            "sla_met": false,
            "sla_breach_hours": 2.73,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 13:05:41"
          },
          {
            "ticket_id": 12628,
            "ticket_number": "3512616",
            "title": "GBN-107523 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:35",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12630,
            "ticket_number": "3512618",
            "title": "GBN-108072 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:39",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12631,
            "ticket_number": "3512619",
            "title": "GBN-106301 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:41",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12633,
            "ticket_number": "3512621",
            "title": "GBN-106942 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:47",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12634,
            "ticket_number": "3512622",
            "title": "GBN-87429 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:49",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12637,
            "ticket_number": "3512625",
            "title": "GBN-87424 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:57",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12638,
            "ticket_number": "3512626",
            "title": "GBN-87427 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "16/03/2026 10:06:59",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.33,
            "sla_met": false,
            "sla_breach_hours": 6.08,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:27:42"
          },
          {
            "ticket_id": 12643,
            "ticket_number": "3512631",
            "title": "Referencia para pagamento | File:435446/2026",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:11",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12644,
            "ticket_number": "3512632",
            "title": "Referencia para pagamento | File:424171/2026",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:13",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:04:35"
          },
          {
            "ticket_id": 12675,
            "ticket_number": "3512663",
            "title": "GBN-107523 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:27",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.3,
            "sla_met": false,
            "sla_breach_hours": 6.05,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:27:33"
          },
          {
            "ticket_id": 12681,
            "ticket_number": "3512669",
            "title": "GBN-106969 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:46",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.28,
            "sla_met": false,
            "sla_breach_hours": 6.03,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:27:25"
          },
          {
            "ticket_id": 12682,
            "ticket_number": "3512670",
            "title": "GBN-88141 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:48",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.28,
            "sla_met": false,
            "sla_breach_hours": 6.03,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:26:57"
          },
          {
            "ticket_id": 12683,
            "ticket_number": "3512671",
            "title": "GBN-106968 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:50",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.27,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:26:47"
          },
          {
            "ticket_id": 12684,
            "ticket_number": "3512672",
            "title": "GBN-106965 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:52",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.27,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:26:31"
          },
          {
            "ticket_id": 12685,
            "ticket_number": "3512673",
            "title": "GBN-106301 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:09:54",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.27,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:26:21"
          },
          {
            "ticket_id": 12690,
            "ticket_number": "3512678",
            "title": "GBN-100046 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "16/03/2026 10:10:08",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.27,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:26:09"
          },
          {
            "ticket_id": 12703,
            "ticket_number": "3512691",
            "title": "Status dos pagamentos atuais ⏳",
            "priority": "P1",
            "created_at": "16/03/2026 10:11:11",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.55,
            "sla_met": false,
            "sla_breach_hours": 6.3,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:44:48"
          },
          {
            "ticket_id": 12710,
            "ticket_number": "3512698",
            "title": "Confirmação e Sinalização de Reserva 213641",
            "priority": "P1",
            "created_at": "16/03/2026 13:05:44",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.68,
            "sla_met": false,
            "sla_breach_hours": 4.43,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 17:47:38"
          },
          {
            "ticket_id": 12713,
            "ticket_number": "3512701",
            "title": "Pedido de Sinalização De Reserva 342043",
            "priority": "P1",
            "created_at": "16/03/2026 13:05:58",
            "close_date": "2026-03-16",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.58,
            "sla_met": false,
            "sla_breach_hours": 3.33,
            "sla_name": "SLA P1",
            "first_response_at": "16/03/2026 16:41:18"
          },
          {
            "ticket_id": 12720,
            "ticket_number": "3512708",
            "title": "Recordatorio prepago reserva: 1778299",
            "priority": "P2",
            "created_at": "16/03/2026 13:07:01",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 16:39:08"
          },
          {
            "ticket_id": 12721,
            "ticket_number": "3512709",
            "title": "Lembrete de reserva pré-paga : 6121533",
            "priority": "P2",
            "created_at": "16/03/2026 13:15:54",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 16:38:14"
          },
          {
            "ticket_id": 12722,
            "ticket_number": "3512710",
            "title": "Lembrete de reserva pré-paga : 6121540",
            "priority": "P3",
            "created_at": "16/03/2026 13:15:58",
            "close_date": "2026-03-16",
            "sla_target_hours": 24,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/03/2026 16:37:31"
          },
          {
            "ticket_id": 12723,
            "ticket_number": "3512711",
            "title": "Lembrete de reserva pré-paga : 6130704",
            "priority": "P2",
            "created_at": "16/03/2026 13:16:00",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 16:36:47"
          },
          {
            "ticket_id": 12724,
            "ticket_number": "3512712",
            "title": "Lembrete de reserva pré-paga : 6121537",
            "priority": "P2",
            "created_at": "16/03/2026 13:16:03",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 16:35:44"
          },
          {
            "ticket_id": 12727,
            "ticket_number": "3512715",
            "title": "Resumo de Faturas de Comissão Uma Família em Viage",
            "priority": "P2",
            "created_at": "16/03/2026 13:34:05",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:20:13"
          },
          {
            "ticket_id": 12805,
            "ticket_number": "3512793",
            "title": "Referencia para pagamento | File:433259/2026",
            "priority": "P2",
            "created_at": "16/03/2026 22:12:04",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 13.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 12:02:11"
          },
          {
            "ticket_id": 12810,
            "ticket_number": "3512798",
            "title": "Referencia para pagamento | File:435715/2026",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:07",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 13:42:35"
          },
          {
            "ticket_id": 12813,
            "ticket_number": "3512801",
            "title": "Reserva GBN - 105200",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:27",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:43:27"
          },
          {
            "ticket_id": 12821,
            "ticket_number": "3512809",
            "title": "GBN-108072 - Sua reserva está pendente de pagament",
            "priority": "P3",
            "created_at": "17/03/2026 10:09:05",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 6.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/03/2026 17:02:41"
          },
          {
            "ticket_id": 12822,
            "ticket_number": "3512810",
            "title": "GBN-111701 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:07",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12824,
            "ticket_number": "3512812",
            "title": "GBN-87429 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:11",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12825,
            "ticket_number": "3512813",
            "title": "GBN-111725 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:14",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12826,
            "ticket_number": "3512814",
            "title": "GBN-87424 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:17",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12827,
            "ticket_number": "3512815",
            "title": "GBN-106942 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:19",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12829,
            "ticket_number": "3512817",
            "title": "GBN-87427 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:25",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12830,
            "ticket_number": "3512818",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60459",
            "priority": "P3",
            "created_at": "17/03/2026 10:09:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 32.07,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P3",
            "first_response_at": "18/03/2026 18:14:23"
          },
          {
            "ticket_id": 12831,
            "ticket_number": "3512819",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60459",
            "priority": "P3",
            "created_at": "17/03/2026 10:09:31",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 32.07,
            "sla_met": false,
            "sla_breach_hours": 8.07,
            "sla_name": "SLA P3",
            "first_response_at": "18/03/2026 18:13:41"
          },
          {
            "ticket_id": 12833,
            "ticket_number": "3512821",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:35",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12845,
            "ticket_number": "3512833",
            "title": "ARSP-31105: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "17/03/2026 10:50:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 6.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/03/2026 17:13:46"
          },
          {
            "ticket_id": 12846,
            "ticket_number": "3512834",
            "title": "ARSP-31114: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "17/03/2026 10:50:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 6.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/03/2026 17:13:02"
          },
          {
            "ticket_id": 12847,
            "ticket_number": "3512835",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "17/03/2026 10:55:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 23.32,
            "sla_met": false,
            "sla_breach_hours": 23.07,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 10:14:47"
          },
          {
            "ticket_id": 12861,
            "ticket_number": "3512849",
            "title": "Confirmação e Sinalização de Reserva 213123",
            "priority": "P2",
            "created_at": "17/03/2026 12:58:24",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 5.33,
            "sla_met": false,
            "sla_breach_hours": 1.33,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:18:33"
          },
          {
            "ticket_id": 12870,
            "ticket_number": "3512858",
            "title": "Recordatorio prepago reserva: 1780930",
            "priority": "P2",
            "created_at": "17/03/2026 14:50:41",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:33:09"
          },
          {
            "ticket_id": 12871,
            "ticket_number": "3512859",
            "title": "Recordatorio prepago reserva: 1778053",
            "priority": "P2",
            "created_at": "17/03/2026 14:50:44",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:26:14"
          },
          {
            "ticket_id": 12884,
            "ticket_number": "3512872",
            "title": "Confirmação e Sinalização de Reserva 213624",
            "priority": "P2",
            "created_at": "17/03/2026 16:14:07",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:29:09"
          },
          {
            "ticket_id": 12887,
            "ticket_number": "3512875",
            "title": "Alteração valores da reserva Vera Lazaro",
            "priority": "P3",
            "created_at": "17/03/2026 16:17:46",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/03/2026 16:17:46"
          },
          {
            "ticket_id": 12888,
            "ticket_number": "3512876",
            "title": "Alteração de valores da reserva",
            "priority": "P3",
            "created_at": "17/03/2026 16:17:48",
            "close_date": "2026-03-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/03/2026 16:17:49"
          },
          {
            "ticket_id": 12890,
            "ticket_number": "3512878",
            "title": "Confirmação e Sinalização de Reserva 213621",
            "priority": "P2",
            "created_at": "17/03/2026 16:45:49",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:22:52"
          },
          {
            "ticket_id": 12930,
            "ticket_number": "3512918",
            "title": "A/C CÁTIA LEAL - DÚVIDA ANULAÇÃO FATURA/RECIBO OPT",
            "priority": "P2",
            "created_at": "17/03/2026 23:35:06",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 23:35:06"
          },
          {
            "ticket_id": 12937,
            "ticket_number": "3512925",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P3",
            "created_at": "18/03/2026 10:09:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 24,
            "actual_time_hours": 8.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/03/2026 18:12:18"
          },
          {
            "ticket_id": 12961,
            "ticket_number": "3512949",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "18/03/2026 10:12:25",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 10.23,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 20:26:45"
          },
          {
            "ticket_id": 12969,
            "ticket_number": "3512957",
            "title": "Referencia para pagamento | File:435797/2026",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:36",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 14:40:43"
          },
          {
            "ticket_id": 12971,
            "ticket_number": "3512959",
            "title": "Referencia para pagamento | File:435737/2026",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:41",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 14:40:43"
          },
          {
            "ticket_id": 12987,
            "ticket_number": "3512975",
            "title": "Faturas Pendentes: FA 2147900863",
            "priority": "P1",
            "created_at": "18/03/2026 13:04:38",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.02,
            "sla_met": false,
            "sla_breach_hours": 4.77,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 18:06:38"
          },
          {
            "ticket_id": 13001,
            "ticket_number": "3512989",
            "title": "Solole. Booking 0HMNEQIK is close to entering expe",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:21",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:01:14"
          },
          {
            "ticket_id": 13016,
            "ticket_number": "3513004",
            "title": "Confirmação e Sinalização de Reserva 213587",
            "priority": "P1",
            "created_at": "18/03/2026 17:04:50",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.25,
            "sla_met": false,
            "sla_breach_hours": 2.0,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 19:20:13"
          },
          {
            "ticket_id": 13020,
            "ticket_number": "3513008",
            "title": "Confirmação e Sinalização de Reserva 213860",
            "priority": "P1",
            "created_at": "18/03/2026 17:56:58",
            "close_date": "2026-03-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.35,
            "sla_met": false,
            "sla_breach_hours": 1.1,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 19:18:50"
          },
          {
            "ticket_id": 13028,
            "ticket_number": "3513016",
            "title": "Localizador GBN- 109961",
            "priority": "P2",
            "created_at": "18/03/2026 19:04:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:04:00"
          },
          {
            "ticket_id": 13042,
            "ticket_number": "3513030",
            "title": "loc7.caixabank.es_GPeticiones;WebLogicS...gw2PXP7O",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:33",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 23:01:45"
          },
          {
            "ticket_id": 13085,
            "ticket_number": "3513073",
            "title": "GBN-108448 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "19/03/2026 10:04:23",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 7.68,
            "sla_met": false,
            "sla_breach_hours": 3.68,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 17:46:22"
          },
          {
            "ticket_id": 13089,
            "ticket_number": "3513077",
            "title": "Envio de recibo – fatura FT ATSIRE01FT/1",
            "priority": "P1",
            "created_at": "19/03/2026 10:06:55",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 38.6,
            "sla_met": false,
            "sla_breach_hours": 38.35,
            "sla_name": "SLA P1",
            "first_response_at": "21/03/2026 00:43:51"
          },
          {
            "ticket_id": 13121,
            "ticket_number": "3513109",
            "title": "TRP-2026-04102 - Catia Leal",
            "priority": "P1",
            "created_at": "19/03/2026 14:25:58",
            "close_date": "2026-03-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.65,
            "sla_met": false,
            "sla_breach_hours": 4.4,
            "sla_name": "SLA P1",
            "first_response_at": "19/03/2026 19:05:28"
          },
          {
            "ticket_id": 13134,
            "ticket_number": "3513122",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "19/03/2026 16:06:15",
            "close_date": "2026-03-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.97,
            "sla_met": false,
            "sla_breach_hours": 2.72,
            "sla_name": "SLA P1",
            "first_response_at": "19/03/2026 19:04:52"
          },
          {
            "ticket_id": 13135,
            "ticket_number": "3513123",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "19/03/2026 16:06:17",
            "close_date": "2026-03-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.95,
            "sla_met": false,
            "sla_breach_hours": 2.7,
            "sla_name": "SLA P1",
            "first_response_at": "19/03/2026 19:04:09"
          },
          {
            "ticket_id": 13158,
            "ticket_number": "3513146",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "19/03/2026 17:43:10",
            "close_date": "2026-03-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.33,
            "sla_met": false,
            "sla_breach_hours": 1.08,
            "sla_name": "SLA P1",
            "first_response_at": "19/03/2026 19:03:19"
          },
          {
            "ticket_id": 13186,
            "ticket_number": "3513174",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP242138, Sr/a ",
            "priority": "P2",
            "created_at": "19/03/2026 23:12:02",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 18.27,
            "sla_met": false,
            "sla_breach_hours": 14.27,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 17:28:58"
          },
          {
            "ticket_id": 13189,
            "ticket_number": "3513177",
            "title": "GBN-106244 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "20/03/2026 10:03:29",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.4,
            "sla_met": false,
            "sla_breach_hours": 7.15,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 17:28:01"
          },
          {
            "ticket_id": 13190,
            "ticket_number": "3513178",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P1",
            "created_at": "20/03/2026 10:03:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.4,
            "sla_met": false,
            "sla_breach_hours": 7.15,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 17:27:45"
          },
          {
            "ticket_id": 13196,
            "ticket_number": "3513184",
            "title": "900164028 // Prepaid reservations -4 days before c",
            "priority": "P1",
            "created_at": "20/03/2026 10:05:26",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.33,
            "sla_met": false,
            "sla_breach_hours": 7.08,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 17:25:49"
          },
          {
            "ticket_id": 13197,
            "ticket_number": "3513185",
            "title": "1ª Notificação: Reclamação pagamento Reserva 80249",
            "priority": "P2",
            "created_at": "20/03/2026 10:06:56",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 14:00:09"
          },
          {
            "ticket_id": 13210,
            "ticket_number": "3513198",
            "title": "Cancelación  reserva de paquetes con localizador: ",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:39",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:20:21"
          },
          {
            "ticket_id": 13211,
            "ticket_number": "3513199",
            "title": "Cancelación  reserva de paquetes con localizador: ",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:41",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:20:21"
          },
          {
            "ticket_id": 13212,
            "ticket_number": "3513200",
            "title": "Cancelación  reserva de paquetes con localizador: ",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:43",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:20:21"
          },
          {
            "ticket_id": 13213,
            "ticket_number": "3513201",
            "title": "Cancelación  reserva de paquetes con localizador: ",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:45",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:20:21"
          },
          {
            "ticket_id": 13214,
            "ticket_number": "3513202",
            "title": "Cancelación  reserva de paquetes con localizador: ",
            "priority": "P2",
            "created_at": "20/03/2026 11:28:47",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:20:21"
          },
          {
            "ticket_id": 13220,
            "ticket_number": "3513208",
            "title": "TRAVELPLAN RESERVA  604497276 CUSTO P/CLX",
            "priority": "P2",
            "created_at": "20/03/2026 12:23:14",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:29:46"
          },
          {
            "ticket_id": 13234,
            "ticket_number": "3513222",
            "title": "Fatura da viagem TRP-2026-03019",
            "priority": "P2",
            "created_at": "20/03/2026 14:16:15",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 14:16:15"
          },
          {
            "ticket_id": 13247,
            "ticket_number": "3513235",
            "title": "Recordativo de pagamento de outros serviços agênci",
            "priority": "P1",
            "created_at": "20/03/2026 18:22:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.48,
            "sla_met": false,
            "sla_breach_hours": 0.23,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 18:51:02"
          },
          {
            "ticket_id": 13253,
            "ticket_number": "3513241",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "20/03/2026 19:04:09",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.33,
            "sla_met": false,
            "sla_breach_hours": 0.08,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 19:24:20"
          },
          {
            "ticket_id": 13258,
            "ticket_number": "3513246",
            "title": "[Suporte] TRP-2026-04275 / TRL-2026-06470 - Retifi",
            "priority": "P2",
            "created_at": "20/03/2026 19:19:08",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 19:19:08"
          },
          {
            "ticket_id": 13288,
            "ticket_number": "3513276",
            "title": "Devolução de sinal",
            "priority": "P1",
            "created_at": "20/03/2026 23:38:45",
            "close_date": "2026-04-09",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/03/2026 23:38:45"
          },
          {
            "ticket_id": 13302,
            "ticket_number": "3513290",
            "title": "Referencia para pagamento | File:435734/2026",
            "priority": "P2",
            "created_at": "21/03/2026 12:14:33",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 53.23,
            "sla_met": false,
            "sla_breach_hours": 49.23,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:28:38"
          },
          {
            "ticket_id": 13304,
            "ticket_number": "3513292",
            "title": "Referencia para pagamento | File:436315/2026",
            "priority": "P1",
            "created_at": "21/03/2026 12:14:41",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 53.18,
            "sla_met": false,
            "sla_breach_hours": 52.93,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 17:25:42"
          },
          {
            "ticket_id": 13305,
            "ticket_number": "3513293",
            "title": "Faturas Pendentes: FA 2147901635",
            "priority": "P1",
            "created_at": "21/03/2026 12:14:42",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 52.25,
            "sla_met": false,
            "sla_breach_hours": 52.0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 16:30:07"
          },
          {
            "ticket_id": 13306,
            "ticket_number": "3513294",
            "title": "Recordativo de pagamento de outros serviços agênci",
            "priority": "P2",
            "created_at": "21/03/2026 12:14:45",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 52.23,
            "sla_met": false,
            "sla_breach_hours": 48.23,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 16:28:55"
          },
          {
            "ticket_id": 13326,
            "ticket_number": "3513314",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "23/03/2026 10:10:51",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13331,
            "ticket_number": "3513319",
            "title": "Gestão de Contas Correntes (Pagamentos Finais)",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:01",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13334,
            "ticket_number": "3513322",
            "title": "Gestão de Contas Correntes (Pagamentos Finais)",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:07",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13336,
            "ticket_number": "3513324",
            "title": "GBN-99517 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "23/03/2026 10:11:11",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.22,
            "sla_met": false,
            "sla_breach_hours": 5.97,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 16:25:02"
          },
          {
            "ticket_id": 13347,
            "ticket_number": "3513335",
            "title": "Referencia para pagamento | File:434053/2026",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:39",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13356,
            "ticket_number": "3513344",
            "title": "Re:[## 32370 ##] GBN-102802 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:14",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:32"
          },
          {
            "ticket_id": 13364,
            "ticket_number": "3513352",
            "title": "TRP-2026-03157 - faturas",
            "priority": "P2",
            "created_at": "23/03/2026 10:12:47",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:12:47"
          },
          {
            "ticket_id": 13365,
            "ticket_number": "3513353",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "23/03/2026 10:13:22",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13380,
            "ticket_number": "3513368",
            "title": "Referencia para pagamento | File:436375/2026",
            "priority": "P1",
            "created_at": "23/03/2026 10:14:04",
            "close_date": "2026-03-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 32.7,
            "sla_met": false,
            "sla_breach_hours": 32.45,
            "sla_name": "SLA P1",
            "first_response_at": "24/03/2026 18:56:14"
          },
          {
            "ticket_id": 13382,
            "ticket_number": "3513370",
            "title": "Referencia para pagamento | File:434428/2026",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:08",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13390,
            "ticket_number": "3513378",
            "title": "[Suporte] TRP-2026-04338 / TRL-2026-06557 - Altera",
            "priority": "P2",
            "created_at": "23/03/2026 11:00:20",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:00:20"
          },
          {
            "ticket_id": 13410,
            "ticket_number": "3513398",
            "title": "Pagamento Final de Reserva - 338488",
            "priority": "P1",
            "created_at": "23/03/2026 13:55:30",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13411,
            "ticket_number": "3513399",
            "title": "Pagamento Final de Reserva - 332333",
            "priority": "P1",
            "created_at": "23/03/2026 13:55:32",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13414,
            "ticket_number": "3513402",
            "title": "Pedido de Sinalização De Reserva 342760",
            "priority": "P1",
            "created_at": "23/03/2026 13:55:39",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 14:04:33"
          },
          {
            "ticket_id": 13421,
            "ticket_number": "3513409",
            "title": "Confirmação n. 221949",
            "priority": "P2",
            "created_at": "23/03/2026 13:56:07",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:44:53"
          },
          {
            "ticket_id": 13424,
            "ticket_number": "3513412",
            "title": "***PAGO RESERVA 802496917*** GREGAL (WELCOMEBEDS)",
            "priority": "P2",
            "created_at": "23/03/2026 13:56:28",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:44:53"
          },
          {
            "ticket_id": 13451,
            "ticket_number": "3513439",
            "title": "[Suporte] TRP-2026-04192 / TRL-2026-06339 - Factur",
            "priority": "P2",
            "created_at": "23/03/2026 20:46:54",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 20:46:54"
          },
          {
            "ticket_id": 13460,
            "ticket_number": "3513448",
            "title": "[Suporte] TRP-2026-02641 - Pedido de devolução",
            "priority": "P2",
            "created_at": "23/03/2026 22:28:38",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 22:28:38"
          },
          {
            "ticket_id": 13465,
            "ticket_number": "3513453",
            "title": "[Suporte] TRP-2026-04466 - auto consumo + 2 adulto",
            "priority": "P2",
            "created_at": "23/03/2026 23:24:12",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:24:12"
          },
          {
            "ticket_id": 13487,
            "ticket_number": "3513475",
            "title": "Actividad %s cancelada: Safári por Higüey e planta",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:42",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:06:42"
          },
          {
            "ticket_id": 13518,
            "ticket_number": "3513506",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "24/03/2026 14:09:58",
            "close_date": "2026-03-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "24/03/2026 14:21:35"
          },
          {
            "ticket_id": 13529,
            "ticket_number": "3513517",
            "title": "Recibo de Comissões - HENRIQUE RIOS",
            "priority": "P2",
            "created_at": "24/03/2026 16:49:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 16:49:24"
          },
          {
            "ticket_id": 13540,
            "ticket_number": "3513528",
            "title": "Re: [Cockpit] Viagem TRP-2026-03894 - Circuito Aço",
            "priority": "P2",
            "created_at": "24/03/2026 17:42:05",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 17:42:05"
          },
          {
            "ticket_id": 13541,
            "ticket_number": "3513529",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "24/03/2026 17:44:37",
            "close_date": "2026-03-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "24/03/2026 17:45:17"
          },
          {
            "ticket_id": 13544,
            "ticket_number": "3513532",
            "title": "GBN-114599 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "24/03/2026 18:02:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 18:21:26"
          },
          {
            "ticket_id": 13561,
            "ticket_number": "3513549",
            "title": "CONFIRMACION: Telma Graca / HOTEL OHTELS MAZAGON",
            "priority": "P2",
            "created_at": "24/03/2026 21:16:54",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 156.02,
            "sla_met": false,
            "sla_breach_hours": 152.02,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 09:18:33"
          },
          {
            "ticket_id": 13562,
            "ticket_number": "3513550",
            "title": "Referencia para pagamento | File:424637/2026",
            "priority": "P2",
            "created_at": "24/03/2026 22:20:26",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 19.95,
            "sla_met": false,
            "sla_breach_hours": 15.95,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:17:52"
          },
          {
            "ticket_id": 13563,
            "ticket_number": "3513551",
            "title": "Referencia para pagamento | File:424766/2026",
            "priority": "P2",
            "created_at": "24/03/2026 22:20:28",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 139.28,
            "sla_met": false,
            "sla_breach_hours": 135.28,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:37:29"
          },
          {
            "ticket_id": 13564,
            "ticket_number": "3513552",
            "title": "Referencia para pagamento | File:419933/2025",
            "priority": "P2",
            "created_at": "24/03/2026 22:20:29",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 139.43,
            "sla_met": false,
            "sla_breach_hours": 135.43,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:47:16"
          },
          {
            "ticket_id": 13566,
            "ticket_number": "3513554",
            "title": "Referencia para pagamento | File:425056/2026",
            "priority": "P2",
            "created_at": "24/03/2026 22:29:30",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 13.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 12:23:30"
          },
          {
            "ticket_id": 13567,
            "ticket_number": "3513555",
            "title": "Referencia para pagamento | File:426654/2026",
            "priority": "P2",
            "created_at": "24/03/2026 23:07:33",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 13.93,
            "sla_met": false,
            "sla_breach_hours": 9.93,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:03:38"
          },
          {
            "ticket_id": 13570,
            "ticket_number": "3513558",
            "title": "Referencia para pagamento | File:    428177    /20",
            "priority": "P2",
            "created_at": "24/03/2026 23:49:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:43:45"
          },
          {
            "ticket_id": 13571,
            "ticket_number": "3513559",
            "title": "[Suporte] TRP-2026-04346 - fatura e recibo valor s",
            "priority": "P2",
            "created_at": "25/03/2026 00:18:52",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 00:18:52"
          },
          {
            "ticket_id": 13574,
            "ticket_number": "3513562",
            "title": "Informações sobre reservas que em breve estarão su",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:30",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 14:03:47"
          },
          {
            "ticket_id": 13580,
            "ticket_number": "3513568",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P1",
            "created_at": "25/03/2026 10:07:43",
            "close_date": "2026-03-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.97,
            "sla_met": false,
            "sla_breach_hours": 6.72,
            "sla_name": "SLA P1",
            "first_response_at": "25/03/2026 17:05:57"
          },
          {
            "ticket_id": 13588,
            "ticket_number": "3513576",
            "title": "Fwd: Envio Fatura",
            "priority": "P1",
            "created_at": "25/03/2026 10:53:38",
            "close_date": "2026-03-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.98,
            "sla_met": false,
            "sla_breach_hours": 7.73,
            "sla_name": "SLA P1",
            "first_response_at": "25/03/2026 18:52:47"
          },
          {
            "ticket_id": 13592,
            "ticket_number": "3513580",
            "title": "PAGO URGENTE CANCELACION",
            "priority": "P2",
            "created_at": "25/03/2026 12:01:28",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 5.98,
            "sla_met": false,
            "sla_breach_hours": 1.98,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:00:54"
          },
          {
            "ticket_id": 13608,
            "ticket_number": "3513596",
            "title": "Solole. Booking X3X77HWL is close to entering expe",
            "priority": "P1",
            "created_at": "25/03/2026 14:20:49",
            "close_date": "2026-03-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.65,
            "sla_met": false,
            "sla_breach_hours": 2.4,
            "sla_name": "SLA P1",
            "first_response_at": "25/03/2026 17:00:43"
          },
          {
            "ticket_id": 13620,
            "ticket_number": "3513608",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP762271-1, Sr/",
            "priority": "P2",
            "created_at": "25/03/2026 16:27:45",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:24:43"
          },
          {
            "ticket_id": 13628,
            "ticket_number": "3513616",
            "title": "Informação importante portos gregos, reserva 33126",
            "priority": "P2",
            "created_at": "25/03/2026 17:09:56",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 21:04:46"
          },
          {
            "ticket_id": 13633,
            "ticket_number": "3513621",
            "title": "[Suporte] TRP-2026-04274 / TRL-2026-06469 - Altera",
            "priority": "P2",
            "created_at": "25/03/2026 17:29:18",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 17:29:19"
          },
          {
            "ticket_id": 13638,
            "ticket_number": "3513626",
            "title": "Re: [Cockpit] Viagem TRP-2026-04031 - Aventura Fam",
            "priority": "P2",
            "created_at": "25/03/2026 17:55:07",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 17:55:07"
          },
          {
            "ticket_id": 13646,
            "ticket_number": "3513634",
            "title": "Faturas em falta",
            "priority": "P2",
            "created_at": "25/03/2026 18:50:48",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:50:49"
          },
          {
            "ticket_id": 13649,
            "ticket_number": "3513637",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "25/03/2026 18:58:50",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 22:44:57"
          },
          {
            "ticket_id": 13650,
            "ticket_number": "3513638",
            "title": "[Suporte] TRP-2026-04410 / TRL-2026-06675 - Adicio",
            "priority": "P2",
            "created_at": "25/03/2026 19:31:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 19:31:46"
          },
          {
            "ticket_id": 13659,
            "ticket_number": "3513647",
            "title": "Correção fatura",
            "priority": "P1",
            "created_at": "25/03/2026 21:06:39",
            "close_date": "2026-03-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/03/2026 21:06:39"
          },
          {
            "ticket_id": 13687,
            "ticket_number": "3513675",
            "title": "***URGENTE PAGO HOY***LOC.604571207 (LEPLAN)----Um",
            "priority": "P1",
            "created_at": "26/03/2026 10:07:34",
            "close_date": "2026-03-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.1,
            "sla_met": false,
            "sla_breach_hours": 0.85,
            "sla_name": "SLA P1",
            "first_response_at": "26/03/2026 11:13:45"
          },
          {
            "ticket_id": 13689,
            "ticket_number": "3513677",
            "title": "Amanhã será realizada a cobrança da reserva T28538",
            "priority": "P2",
            "created_at": "26/03/2026 10:07:37",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 14:01:12"
          },
          {
            "ticket_id": 13710,
            "ticket_number": "3513698",
            "title": "Soltropico - Alteração na reserva 334043",
            "priority": "P2",
            "created_at": "26/03/2026 14:51:15",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 14:51:16"
          },
          {
            "ticket_id": 13736,
            "ticket_number": "3513724",
            "title": "Correção valor pvp na reserva TRP 2026-02987",
            "priority": "P2",
            "created_at": "26/03/2026 20:39:19",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 20:39:19"
          },
          {
            "ticket_id": 13762,
            "ticket_number": "3513750",
            "title": "Re: [Cockpit] Viagem TRP-2026-04050 - Viagem a Pal",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:01",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:07:01"
          },
          {
            "ticket_id": 13763,
            "ticket_number": "3513751",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:02",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:07:03"
          },
          {
            "ticket_id": 13781,
            "ticket_number": "3513769",
            "title": "PAGO NO RECIBIDO. La reserva con localizador 41432",
            "priority": "P1",
            "created_at": "27/03/2026 12:26:24",
            "close_date": "2026-03-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/03/2026 12:28:29"
          },
          {
            "ticket_id": 13796,
            "ticket_number": "3513784",
            "title": "PAGO NO RECIBIDO. La reserva con localizador 41436",
            "priority": "P1",
            "created_at": "27/03/2026 15:17:34",
            "close_date": "2026-03-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/03/2026 15:18:11"
          },
          {
            "ticket_id": 13814,
            "ticket_number": "3513802",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "27/03/2026 17:44:08",
            "close_date": "2026-03-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.37,
            "sla_met": false,
            "sla_breach_hours": 1.12,
            "sla_name": "SLA P1",
            "first_response_at": "27/03/2026 19:06:57"
          },
          {
            "ticket_id": 13859,
            "ticket_number": "3513847",
            "title": "[Suporte] TRP-2026-04512 - Fatura",
            "priority": "P2",
            "created_at": "28/03/2026 11:43:25",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:43:25"
          },
          {
            "ticket_id": 13867,
            "ticket_number": "3513855",
            "title": "RE: [Cockpit] Viagem TRP-2026-04008 - Viagem Marce",
            "priority": "P2",
            "created_at": "28/03/2026 12:25:09",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 12:25:10"
          },
          {
            "ticket_id": 13873,
            "ticket_number": "3513861",
            "title": "[Suporte] TRP-2026-03941 - Alteração valores",
            "priority": "P2",
            "created_at": "28/03/2026 13:10:28",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 13:10:29"
          },
          {
            "ticket_id": 13875,
            "ticket_number": "3513863",
            "title": "IFTHENPAY - Pagamento Efetuado: ID 1648dd1c6d454c2",
            "priority": "P2",
            "created_at": "28/03/2026 14:29:23",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 43.47,
            "sla_met": false,
            "sla_breach_hours": 39.47,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:57:26"
          },
          {
            "ticket_id": 13889,
            "ticket_number": "3513877",
            "title": "[Suporte] TRP-2026-04542 / TRL-2026-06885 - troca ",
            "priority": "P2",
            "created_at": "28/03/2026 18:48:45",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 18:48:45"
          },
          {
            "ticket_id": 13900,
            "ticket_number": "3513888",
            "title": "***MUY URGENTE PAGO HOY***LOC.604603898 (LEPLAN)--",
            "priority": "P1",
            "created_at": "30/03/2026 09:48:11",
            "close_date": "2026-03-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.23,
            "sla_met": false,
            "sla_breach_hours": 0.98,
            "sla_name": "SLA P1",
            "first_response_at": "30/03/2026 11:02:42"
          },
          {
            "ticket_id": 13952,
            "ticket_number": "3513940",
            "title": "Referencia para pagamento | File:437112/2026",
            "priority": "P1",
            "created_at": "30/03/2026 09:53:14",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 31.32,
            "sla_met": false,
            "sla_breach_hours": 31.07,
            "sla_name": "SLA P1",
            "first_response_at": "31/03/2026 17:12:53"
          },
          {
            "ticket_id": 13954,
            "ticket_number": "3513942",
            "title": "Referencia para pagamento | File:437147/2026",
            "priority": "P1",
            "created_at": "30/03/2026 09:53:49",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 31.3,
            "sla_met": false,
            "sla_breach_hours": 31.05,
            "sla_name": "SLA P1",
            "first_response_at": "31/03/2026 17:11:49"
          },
          {
            "ticket_id": 13966,
            "ticket_number": "3513954",
            "title": "ARSP-31332: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "30/03/2026 10:41:05",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 7.02,
            "sla_met": false,
            "sla_breach_hours": 3.02,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:42:20"
          },
          {
            "ticket_id": 13967,
            "ticket_number": "3513955",
            "title": "ARSP-31339: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "30/03/2026 10:41:07",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 7.0,
            "sla_met": false,
            "sla_breach_hours": 3.0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:41:21"
          },
          {
            "ticket_id": 13982,
            "ticket_number": "3513970",
            "title": "***URGENTE PAGO*** LOC.604571214(TRAVELPLAN CARIBE",
            "priority": "P1",
            "created_at": "30/03/2026 13:09:20",
            "close_date": "2026-03-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.55,
            "sla_met": false,
            "sla_breach_hours": 3.3,
            "sla_name": "SLA P1",
            "first_response_at": "30/03/2026 16:43:01"
          },
          {
            "ticket_id": 13997,
            "ticket_number": "3513985",
            "title": "[Suporte] TRP-2026-03690 - Alteração Valor PVP",
            "priority": "P2",
            "created_at": "30/03/2026 15:06:37",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:06:38"
          },
          {
            "ticket_id": 14011,
            "ticket_number": "3513999",
            "title": "[Suporte] TRP-2026-04529 - Atualizar valores Smy e",
            "priority": "P2",
            "created_at": "30/03/2026 17:15:17",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:15:17"
          },
          {
            "ticket_id": 14026,
            "ticket_number": "3514014",
            "title": "Referencia para pagamento | File:437201/2026",
            "priority": "P2",
            "created_at": "30/03/2026 21:14:08",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 13.83,
            "sla_met": false,
            "sla_breach_hours": 9.83,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:04:46"
          },
          {
            "ticket_id": 14027,
            "ticket_number": "3514015",
            "title": "Referencia para pagamento | File:437179/2026",
            "priority": "P1",
            "created_at": "30/03/2026 21:14:10",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 19.92,
            "sla_met": false,
            "sla_breach_hours": 19.67,
            "sla_name": "SLA P1",
            "first_response_at": "31/03/2026 17:09:46"
          },
          {
            "ticket_id": 14038,
            "ticket_number": "3514026",
            "title": "URGENTE - NOCA RESERVA SOLFÉRIAS - VAI ENTRAR EM G",
            "priority": "P2",
            "created_at": "30/03/2026 21:44:56",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:44:56"
          },
          {
            "ticket_id": 14047,
            "ticket_number": "3514035",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "30/03/2026 22:43:54",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:43:55"
          },
          {
            "ticket_id": 14054,
            "ticket_number": "3514042",
            "title": "Amanhã será realizada a cobrança da reserva T28538",
            "priority": "P2",
            "created_at": "31/03/2026 09:07:51",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 13:00:05"
          },
          {
            "ticket_id": 14055,
            "ticket_number": "3514043",
            "title": "GBN-92777 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "31/03/2026 09:07:54",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:59:06"
          },
          {
            "ticket_id": 14057,
            "ticket_number": "3514045",
            "title": "GBN-102802 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:03",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:58:57"
          },
          {
            "ticket_id": 14058,
            "ticket_number": "3514046",
            "title": "GBN-102512 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:05",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:58:50"
          },
          {
            "ticket_id": 14059,
            "ticket_number": "3514047",
            "title": "GBN-96975 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:07",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 2.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:58:41"
          },
          {
            "ticket_id": 14063,
            "ticket_number": "3514051",
            "title": "ARSP-31354: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "31/03/2026 09:08:26",
            "close_date": "2026-04-08",
            "sla_target_hours": 24,
            "actual_time_hours": 199.63,
            "sla_met": false,
            "sla_breach_hours": 175.63,
            "sla_name": "SLA P3",
            "first_response_at": "08/04/2026 16:47:06"
          },
          {
            "ticket_id": 14066,
            "ticket_number": "3514054",
            "title": "Lembrete de reserva pré-paga : 6143902",
            "priority": "P3",
            "created_at": "31/03/2026 10:10:43",
            "close_date": "2026-04-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "01/04/2026 20:03:17"
          },
          {
            "ticket_id": 14070,
            "ticket_number": "3514058",
            "title": "Lembrete de reserva pré-paga : 6126963",
            "priority": "P3",
            "created_at": "31/03/2026 10:10:56",
            "close_date": "2026-04-01",
            "sla_target_hours": 24,
            "actual_time_hours": 30.02,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P3",
            "first_response_at": "01/04/2026 16:12:17"
          },
          {
            "ticket_id": 14071,
            "ticket_number": "3514059",
            "title": "Lembrete de reserva pré-paga : 6143741",
            "priority": "P3",
            "created_at": "31/03/2026 10:10:58",
            "close_date": "2026-04-06",
            "sla_target_hours": 24,
            "actual_time_hours": 33.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P3",
            "first_response_at": "01/04/2026 20:03:17"
          },
          {
            "ticket_id": 14075,
            "ticket_number": "3514063",
            "title": "Novo Reforço de Pagamento - Viagem #2414000017",
            "priority": "P2",
            "created_at": "31/03/2026 11:09:39",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:09:39"
          },
          {
            "ticket_id": 14076,
            "ticket_number": "3514064",
            "title": "Novo Reforço de Pagamento - Viagem # 2414000017",
            "priority": "P2",
            "created_at": "31/03/2026 11:09:41",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:09:42"
          },
          {
            "ticket_id": 14105,
            "ticket_number": "3514093",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "31/03/2026 15:30:26",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "31/03/2026 15:40:32"
          },
          {
            "ticket_id": 14112,
            "ticket_number": "3514100",
            "title": "Solicitud de pago salida 11/04",
            "priority": "P1",
            "created_at": "31/03/2026 15:47:52",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.97,
            "sla_met": false,
            "sla_breach_hours": 1.72,
            "sla_name": "SLA P1",
            "first_response_at": "31/03/2026 17:46:33"
          },
          {
            "ticket_id": 14133,
            "ticket_number": "3514121",
            "title": "recibo",
            "priority": "P2",
            "created_at": "31/03/2026 18:19:09",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 548.67,
            "sla_met": false,
            "sla_breach_hours": 544.67,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 14:59:42"
          },
          {
            "ticket_id": 14151,
            "ticket_number": "3514139",
            "title": "Referencia para pagamento | File:437290/2026",
            "priority": "P1",
            "created_at": "31/03/2026 21:24:06",
            "close_date": "2026-04-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 18.78,
            "sla_met": false,
            "sla_breach_hours": 18.53,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 16:12:00"
          },
          {
            "ticket_id": 14152,
            "ticket_number": "3514140",
            "title": "Referencia para pagamento | File:437355/2026",
            "priority": "P2",
            "created_at": "31/03/2026 21:24:08",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 13.97,
            "sla_met": false,
            "sla_breach_hours": 9.97,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 11:22:17"
          },
          {
            "ticket_id": 14153,
            "ticket_number": "3514141",
            "title": "Re: [Cockpit] Viagem TRP-2026-01789 - BJS • Joana ",
            "priority": "P2",
            "created_at": "31/03/2026 22:19:16",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 22:19:16"
          },
          {
            "ticket_id": 14155,
            "ticket_number": "3514143",
            "title": "Comissões Optigest sem visibilidade no Cockpit | T",
            "priority": "P2",
            "created_at": "31/03/2026 22:52:51",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 22:52:51"
          },
          {
            "ticket_id": 14158,
            "ticket_number": "3514146",
            "title": "A reserva T2853867 foi paga e confirmada",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:38",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 09:49:38"
          },
          {
            "ticket_id": 14160,
            "ticket_number": "3514148",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:43",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 2.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 11:34:35"
          },
          {
            "ticket_id": 14163,
            "ticket_number": "3514151",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60459",
            "priority": "P2",
            "created_at": "01/04/2026 09:11:50",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 13:02:28"
          },
          {
            "ticket_id": 14169,
            "ticket_number": "3514157",
            "title": "[Suporte] TRP-2026-03441 - Faturação",
            "priority": "P2",
            "created_at": "01/04/2026 11:08:44",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 11:08:44"
          },
          {
            "ticket_id": 14180,
            "ticket_number": "3514168",
            "title": "Faturas Pendentes: FA 2147903970",
            "priority": "P2",
            "created_at": "01/04/2026 12:50:37",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:25:09"
          },
          {
            "ticket_id": 14182,
            "ticket_number": "3514170",
            "title": "Fwd: Envio Fatura",
            "priority": "P1",
            "created_at": "01/04/2026 14:27:50",
            "close_date": "2026-04-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.02,
            "sla_met": false,
            "sla_breach_hours": 3.77,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 18:29:15"
          },
          {
            "ticket_id": 14189,
            "ticket_number": "3514177",
            "title": "RE: [Cockpit] Viagem TRP-2026-04500 - VERÃO BRUNA",
            "priority": "P2",
            "created_at": "01/04/2026 15:10:27",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 15:10:27"
          },
          {
            "ticket_id": 14194,
            "ticket_number": "3514182",
            "title": "Faturas Pendentes: FA 2147904014",
            "priority": "P1",
            "created_at": "01/04/2026 16:04:38",
            "close_date": "2026-04-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.38,
            "sla_met": false,
            "sla_breach_hours": 2.13,
            "sla_name": "SLA P1",
            "first_response_at": "01/04/2026 18:28:20"
          },
          {
            "ticket_id": 14201,
            "ticket_number": "3514189",
            "title": "Re: [Cockpit] Viagem TRP-2026-04335 - Viagem a Eur",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:35",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 19:08:35"
          },
          {
            "ticket_id": 14204,
            "ticket_number": "3514192",
            "title": "Dados Reembolso cliente GBN-94286",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:43",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 19:08:44"
          },
          {
            "ticket_id": 14205,
            "ticket_number": "3514193",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:46",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 118.7,
            "sla_met": false,
            "sla_breach_hours": 114.7,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 17:51:19"
          },
          {
            "ticket_id": 14206,
            "ticket_number": "3514194",
            "title": "Confirmação de reserva 343716 ### TIME LIMIT EMISS",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:52",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 14.1,
            "sla_met": false,
            "sla_breach_hours": 10.1,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 09:15:36"
          },
          {
            "ticket_id": 14236,
            "ticket_number": "3514224",
            "title": "[Suporte] TRP-2026-02383 / TRL-2026-03657 - atuali",
            "priority": "P2",
            "created_at": "02/04/2026 01:22:00",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 01:22:00"
          },
          {
            "ticket_id": 14264,
            "ticket_number": "3514252",
            "title": "Alteração de valores Cockpit",
            "priority": "P2",
            "created_at": "02/04/2026 14:29:33",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 14:29:34"
          },
          {
            "ticket_id": 14285,
            "ticket_number": "3514273",
            "title": "disponibilidade rimaintours - Excursão 01 – Isla S",
            "priority": "P2",
            "created_at": "02/04/2026 17:03:15",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 17:03:16"
          },
          {
            "ticket_id": 14291,
            "ticket_number": "3514279",
            "title": "[Suporte] TRP-2026-04504 - ALTERACAO DOS VALORES N",
            "priority": "P2",
            "created_at": "02/04/2026 18:40:08",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:40:08"
          },
          {
            "ticket_id": 14295,
            "ticket_number": "3514283",
            "title": "Re: [Cockpit] Viagem TRP-2026-04570 - Rita&Álvaro ",
            "priority": "P2",
            "created_at": "02/04/2026 18:40:44",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:40:44"
          },
          {
            "ticket_id": 14311,
            "ticket_number": "3514299",
            "title": "[Suporte] TRP-2026-03821 / TRL-2026-06152 - correç",
            "priority": "P2",
            "created_at": "03/04/2026 01:07:46",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/04/2026 01:07:46"
          },
          {
            "ticket_id": 14312,
            "ticket_number": "3514300",
            "title": "[Suporte] TRP-2026-03821 / TRL-2026-05803 - correç",
            "priority": "P2",
            "created_at": "03/04/2026 01:09:34",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/04/2026 01:09:34"
          },
          {
            "ticket_id": 14317,
            "ticket_number": "3514305",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:31",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 53.73,
            "sla_met": false,
            "sla_breach_hours": 49.73,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:50:18"
          },
          {
            "ticket_id": 14318,
            "ticket_number": "3514306",
            "title": "GBN-109514 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:32",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 53.67,
            "sla_met": false,
            "sla_breach_hours": 49.67,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:46:25"
          },
          {
            "ticket_id": 14319,
            "ticket_number": "3514307",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:34",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 53.72,
            "sla_met": false,
            "sla_breach_hours": 49.72,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:48:46"
          },
          {
            "ticket_id": 14324,
            "ticket_number": "3514312",
            "title": "GBN-112344 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/04/2026 10:05:43",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 53.67,
            "sla_met": false,
            "sla_breach_hours": 53.42,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 15:46:10"
          },
          {
            "ticket_id": 14329,
            "ticket_number": "3514317",
            "title": "Referencia para pagamento | File:437298/2026",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:52",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 78.87,
            "sla_met": false,
            "sla_breach_hours": 74.87,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 16:58:06"
          },
          {
            "ticket_id": 14332,
            "ticket_number": "3514320",
            "title": "Referencia para pagamento | File:437711/2026",
            "priority": "P1",
            "created_at": "04/04/2026 10:05:57",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.0,
            "sla_met": false,
            "sla_breach_hours": 53.75,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 16:06:32"
          },
          {
            "ticket_id": 14343,
            "ticket_number": "3514331",
            "title": "GBN-112344 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/04/2026 10:06:33",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 53.63,
            "sla_met": false,
            "sla_breach_hours": 53.38,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 15:44:39"
          },
          {
            "ticket_id": 14361,
            "ticket_number": "3514349",
            "title": "GBN-116824 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:24",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14362,
            "ticket_number": "3514350",
            "title": "GBN-107660 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:25",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14363,
            "ticket_number": "3514351",
            "title": "Amanhã será realizada a cobrança da reserva A38065",
            "priority": "P1",
            "created_at": "06/04/2026 09:09:28",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.57,
            "sla_met": false,
            "sla_breach_hours": 6.32,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 15:44:10"
          },
          {
            "ticket_id": 14364,
            "ticket_number": "3514352",
            "title": "GBN-109710 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:29",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14366,
            "ticket_number": "3514354",
            "title": "GBN-103815 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:43",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14373,
            "ticket_number": "3514361",
            "title": "Referencia para pagamento | File:419153/2025",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:57",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:03:30"
          },
          {
            "ticket_id": 14375,
            "ticket_number": "3514363",
            "title": "GBN-116824 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:02",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:02"
          },
          {
            "ticket_id": 14382,
            "ticket_number": "3514370",
            "title": "Cokpit Viagens irregularidades",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:24",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 09:10:24"
          },
          {
            "ticket_id": 14384,
            "ticket_number": "3514372",
            "title": "Referencia para pagamento | File:437731/2026",
            "priority": "P1",
            "created_at": "06/04/2026 09:10:29",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.57,
            "sla_met": false,
            "sla_breach_hours": 7.32,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 16:44:36"
          },
          {
            "ticket_id": 14395,
            "ticket_number": "3514383",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "06/04/2026 10:12:03",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.63,
            "sla_met": false,
            "sla_breach_hours": 7.38,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 17:50:13"
          },
          {
            "ticket_id": 14396,
            "ticket_number": "3514384",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "06/04/2026 10:12:05",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.62,
            "sla_met": false,
            "sla_breach_hours": 7.37,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 17:49:07"
          },
          {
            "ticket_id": 14417,
            "ticket_number": "3514405",
            "title": "Confirmação e Sinalização de Reserva 214527",
            "priority": "P1",
            "created_at": "06/04/2026 12:41:19",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.98,
            "sla_met": false,
            "sla_breach_hours": 3.73,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 16:40:49"
          },
          {
            "ticket_id": 14423,
            "ticket_number": "3514411",
            "title": "Alteração cockpit TRP-2026-02579",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:40",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:41:41"
          },
          {
            "ticket_id": 14433,
            "ticket_number": "3514421",
            "title": "[Suporte] TRP-2026-02579 - Faturação",
            "priority": "P2",
            "created_at": "06/04/2026 14:31:23",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 14:31:23"
          },
          {
            "ticket_id": 14442,
            "ticket_number": "3514430",
            "title": "URGENTE  - Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "06/04/2026 15:56:18",
            "close_date": "2026-04-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.75,
            "sla_met": false,
            "sla_breach_hours": 2.5,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 18:41:48"
          },
          {
            "ticket_id": 14485,
            "ticket_number": "3514473",
            "title": "Referencia para pagamento | File:420474/2025",
            "priority": "P2",
            "created_at": "06/04/2026 21:12:24",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 13.78,
            "sla_met": false,
            "sla_breach_hours": 9.78,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:00:02"
          },
          {
            "ticket_id": 14498,
            "ticket_number": "3514486",
            "title": "Pedido Cotação Holiday Inn Beja - de 10 a 12 de Ju",
            "priority": "P1",
            "created_at": "06/04/2026 22:58:00",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "06/04/2026 22:58:00"
          },
          {
            "ticket_id": 14528,
            "ticket_number": "3514516",
            "title": "Lembrete de reserva pré-paga : 6141482",
            "priority": "P2",
            "created_at": "07/04/2026 11:39:20",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 29.07,
            "sla_met": false,
            "sla_breach_hours": 25.07,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:43:55"
          },
          {
            "ticket_id": 14529,
            "ticket_number": "3514517",
            "title": "GBN-109710 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "07/04/2026 11:52:48",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14530,
            "ticket_number": "3514518",
            "title": "GBN-103815 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "07/04/2026 11:52:50",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14531,
            "ticket_number": "3514519",
            "title": "GBN-109427 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "07/04/2026 11:52:52",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14532,
            "ticket_number": "3514520",
            "title": "GBN-116824 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "07/04/2026 11:52:55",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14533,
            "ticket_number": "3514521",
            "title": "GBN-106401 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "07/04/2026 11:52:57",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14550,
            "ticket_number": "3514538",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "07/04/2026 15:10:55",
            "close_date": "2026-04-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/04/2026 15:12:45"
          },
          {
            "ticket_id": 14554,
            "ticket_number": "3514542",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "07/04/2026 15:28:57",
            "close_date": "2026-04-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/04/2026 15:40:35"
          },
          {
            "ticket_id": 14561,
            "ticket_number": "3514549",
            "title": "TRP-2026-04140",
            "priority": "P2",
            "created_at": "07/04/2026 18:17:21",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 52.37,
            "sla_met": false,
            "sla_breach_hours": 48.37,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 22:39:56"
          },
          {
            "ticket_id": 14599,
            "ticket_number": "3514587",
            "title": "Referencia para pagamento | File:437290/2026",
            "priority": "P2",
            "created_at": "07/04/2026 21:36:52",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 13.75,
            "sla_met": false,
            "sla_breach_hours": 9.75,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:21:56"
          },
          {
            "ticket_id": 14610,
            "ticket_number": "3514598",
            "title": "GBN-104777 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:24",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:02:11"
          },
          {
            "ticket_id": 14611,
            "ticket_number": "3514599",
            "title": "GBN-109427 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:26",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:02:11"
          },
          {
            "ticket_id": 14616,
            "ticket_number": "3514604",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P1",
            "created_at": "08/04/2026 09:07:40",
            "close_date": "2026-04-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.53,
            "sla_met": false,
            "sla_breach_hours": 7.28,
            "sla_name": "SLA P1",
            "first_response_at": "08/04/2026 16:40:39"
          },
          {
            "ticket_id": 14620,
            "ticket_number": "3514608",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:49",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:02:11"
          },
          {
            "ticket_id": 14621,
            "ticket_number": "3514609",
            "title": "GBN-106401 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:51",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:02:11"
          },
          {
            "ticket_id": 14622,
            "ticket_number": "3514610",
            "title": "GBN-104729 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:53",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:02:11"
          },
          {
            "ticket_id": 14634,
            "ticket_number": "3514622",
            "title": "Proforma invoices IN 18/04 SOL FAMILY FUN",
            "priority": "P2",
            "created_at": "08/04/2026 11:19:37",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 5.73,
            "sla_met": false,
            "sla_breach_hours": 1.73,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 17:04:25"
          },
          {
            "ticket_id": 14642,
            "ticket_number": "3514630",
            "title": "[Suporte] TRP-2026-02480 / TRL-2026-03809 - Pedido",
            "priority": "P2",
            "created_at": "08/04/2026 13:05:02",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:05:02"
          },
          {
            "ticket_id": 14647,
            "ticket_number": "3514635",
            "title": "Re: [Cockpit] Viagem TRP-2026-03879 - Viagem a Nur",
            "priority": "P2",
            "created_at": "08/04/2026 13:33:03",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 13:33:04"
          },
          {
            "ticket_id": 14660,
            "ticket_number": "3514648",
            "title": "Erro nos valores  TRP-2026-04216",
            "priority": "P2",
            "created_at": "08/04/2026 16:02:12",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:02:12"
          },
          {
            "ticket_id": 14667,
            "ticket_number": "3514655",
            "title": "Pagamento Comissões",
            "priority": "P2",
            "created_at": "08/04/2026 16:20:50",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:20:50"
          },
          {
            "ticket_id": 14708,
            "ticket_number": "3514696",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:20",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 11:49:13"
          },
          {
            "ticket_id": 14710,
            "ticket_number": "3514698",
            "title": "GBN-117429 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:25",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:04:53"
          },
          {
            "ticket_id": 14711,
            "ticket_number": "3514699",
            "title": "GBN-104729 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:27",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:04:53"
          },
          {
            "ticket_id": 14735,
            "ticket_number": "3514723",
            "title": "Fwd: [Cockpit] ❌ Pedido de Comissão Rejeitado - PA",
            "priority": "P2",
            "created_at": "09/04/2026 15:22:09",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:22:09"
          },
          {
            "ticket_id": 14742,
            "ticket_number": "3514730",
            "title": "Pedido Contratação Direta",
            "priority": "P2",
            "created_at": "09/04/2026 15:36:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:36:40"
          },
          {
            "ticket_id": 14797,
            "ticket_number": "3514785",
            "title": "Referencia para pagamento | File:411467/2025",
            "priority": "P2",
            "created_at": "09/04/2026 21:07:31",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 13.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:01:29"
          },
          {
            "ticket_id": 14816,
            "ticket_number": "3514804",
            "title": "Reserva TRP-2026-03118 & TRP-2026-03421 | erro de ",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:41",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 09:22:41"
          },
          {
            "ticket_id": 14817,
            "ticket_number": "3514805",
            "title": "GBN-117429 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "10/04/2026 09:22:43",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:21:48"
          },
          {
            "ticket_id": 14849,
            "ticket_number": "3514837",
            "title": "[Tour10] Asunto: Reserva 4145655",
            "priority": "P1",
            "created_at": "10/04/2026 15:48:41",
            "close_date": "2026-04-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.47,
            "sla_met": false,
            "sla_breach_hours": 1.22,
            "sla_name": "SLA P1",
            "first_response_at": "10/04/2026 17:17:00"
          },
          {
            "ticket_id": 14852,
            "ticket_number": "3514840",
            "title": "fatura proforma TRP-2026-04482,",
            "priority": "P2",
            "created_at": "10/04/2026 15:48:50",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:48:50"
          },
          {
            "ticket_id": 14882,
            "ticket_number": "3514870",
            "title": "[Suporte] TRP-2026-02579 / TRL-2026-07157 - Retira",
            "priority": "P2",
            "created_at": "10/04/2026 18:24:18",
            "close_date": "2026-04-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 18:24:18"
          },
          {
            "ticket_id": 14912,
            "ticket_number": "3514900",
            "title": "[Suporte] TRP-2026-03941 - Alteração valores",
            "priority": "P2",
            "created_at": "11/04/2026 10:54:43",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 10:54:43"
          },
          {
            "ticket_id": 14926,
            "ticket_number": "3514914",
            "title": "Re: [Cockpit] Viagem TRP-2026-04066 - Sul de Espan",
            "priority": "P2",
            "created_at": "11/04/2026 13:18:17",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 13:18:17"
          },
          {
            "ticket_id": 14932,
            "ticket_number": "3514920",
            "title": "Re: [Cockpit] Viagem TRP-2026-04319 - Aventura Fam",
            "priority": "P2",
            "created_at": "11/04/2026 15:52:01",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 15:52:02"
          },
          {
            "ticket_id": 14933,
            "ticket_number": "3514921",
            "title": "Re: [Cockpit] Viagem TRP-2026-04062 - Aventura Fam",
            "priority": "P2",
            "created_at": "11/04/2026 15:52:03",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 15:52:04"
          },
          {
            "ticket_id": 14934,
            "ticket_number": "3514922",
            "title": "Re: [Cockpit] Viagem TRP-2026-04320 - Aventura Fam",
            "priority": "P2",
            "created_at": "11/04/2026 15:52:05",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 15:52:05"
          },
          {
            "ticket_id": 14935,
            "ticket_number": "3514923",
            "title": "[Suporte] TRP-2026-03473 / TRL-2026-05306 - Fatura",
            "priority": "P2",
            "created_at": "11/04/2026 16:03:06",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:03:07"
          },
          {
            "ticket_id": 14936,
            "ticket_number": "3514924",
            "title": "[Suporte] TRP-2026-02351 - Faturação",
            "priority": "P2",
            "created_at": "11/04/2026 16:04:04",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:04:04"
          },
          {
            "ticket_id": 14983,
            "ticket_number": "3514971",
            "title": "Re: [Cockpit] Viagem TRP-2026-03788 - Isabel e rog",
            "priority": "P2",
            "created_at": "13/04/2026 09:19:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 541.08,
            "sla_met": false,
            "sla_breach_hours": 537.08,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:25:19"
          },
          {
            "ticket_id": 15022,
            "ticket_number": "3515010",
            "title": "ARSP-31567: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "13/04/2026 10:10:52",
            "close_date": "2026-04-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/04/2026 14:36:37"
          },
          {
            "ticket_id": 15023,
            "ticket_number": "3515011",
            "title": "TRP-2026-02915 - Pagamentos comprovativos",
            "priority": "P2",
            "created_at": "13/04/2026 10:10:53",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:10:54"
          },
          {
            "ticket_id": 15033,
            "ticket_number": "3515021",
            "title": "Confirmação e Sinalização de Reserva 214773",
            "priority": "P2",
            "created_at": "13/04/2026 10:39:58",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 7.63,
            "sla_met": false,
            "sla_breach_hours": 3.63,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:18:05"
          },
          {
            "ticket_id": 15039,
            "ticket_number": "3515027",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "13/04/2026 10:46:28",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 8.22,
            "sla_met": false,
            "sla_breach_hours": 4.22,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:59:57"
          },
          {
            "ticket_id": 15047,
            "ticket_number": "3515035",
            "title": "Faturas Pendentes: FA 2147906408",
            "priority": "P2",
            "created_at": "13/04/2026 13:48:32",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 14:32:32"
          },
          {
            "ticket_id": 15056,
            "ticket_number": "3515044",
            "title": "Pagamento 6129242/Excursiones",
            "priority": "P1",
            "created_at": "13/04/2026 13:49:02",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "13/04/2026 14:01:23"
          },
          {
            "ticket_id": 15065,
            "ticket_number": "3515053",
            "title": "Levantamento de comissões",
            "priority": "P2",
            "created_at": "13/04/2026 15:00:37",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 15:00:37"
          },
          {
            "ticket_id": 15069,
            "ticket_number": "3515057",
            "title": "Re: [Cockpit] Viagem TRP-2026-03385 - CUN • Miguel",
            "priority": "P2",
            "created_at": "13/04/2026 16:21:23",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:21:24"
          },
          {
            "ticket_id": 15079,
            "ticket_number": "3515067",
            "title": "RASAMAR - FATURA EM FALTA",
            "priority": "P2",
            "created_at": "13/04/2026 16:46:32",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 20:42:14"
          },
          {
            "ticket_id": 15081,
            "ticket_number": "3515069",
            "title": "RE: [Cockpit] Viagem TRP-2026-02757 - DJE • David ",
            "priority": "P2",
            "created_at": "13/04/2026 17:54:12",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 17:54:12"
          },
          {
            "ticket_id": 15097,
            "ticket_number": "3515085",
            "title": "[Suporte] TRP-2026-04606 - falta faturar atividade",
            "priority": "P2",
            "created_at": "13/04/2026 21:52:57",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 21:52:57"
          },
          {
            "ticket_id": 15102,
            "ticket_number": "3515090",
            "title": "Referencia para pagamento | File:438226/2026",
            "priority": "P1",
            "created_at": "13/04/2026 22:21:28",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 20.22,
            "sla_met": false,
            "sla_breach_hours": 19.97,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 18:35:23"
          },
          {
            "ticket_id": 15111,
            "ticket_number": "3515099",
            "title": "[Suporte] TRP-2026-03632 / TRL-2026-05533 - Atuali",
            "priority": "P2",
            "created_at": "14/04/2026 00:25:10",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 00:25:10"
          },
          {
            "ticket_id": 15119,
            "ticket_number": "3515107",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:08",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:03:36"
          },
          {
            "ticket_id": 15120,
            "ticket_number": "3515108",
            "title": "Erro valores - GBN-106964 (TRP-2026-04351)",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:10",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:10"
          },
          {
            "ticket_id": 15121,
            "ticket_number": "3515109",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:12",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:03:36"
          },
          {
            "ticket_id": 15122,
            "ticket_number": "3515110",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:15",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:03:36"
          },
          {
            "ticket_id": 15133,
            "ticket_number": "3515121",
            "title": "Comissão paga da reserva TRP-2026-02948",
            "priority": "P1",
            "created_at": "14/04/2026 09:09:46",
            "close_date": "2026-05-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 09:09:46"
          },
          {
            "ticket_id": 15162,
            "ticket_number": "3515150",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "14/04/2026 15:18:06",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 15:28:44"
          },
          {
            "ticket_id": 15163,
            "ticket_number": "3515151",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "14/04/2026 15:18:08",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 15:28:56"
          },
          {
            "ticket_id": 15174,
            "ticket_number": "3515162",
            "title": "Re: [Cockpit] Viagem TRP-2026-04400 - MAGALI AMIGO",
            "priority": "P2",
            "created_at": "14/04/2026 16:31:20",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:31:20"
          },
          {
            "ticket_id": 15212,
            "ticket_number": "3515200",
            "title": "[Suporte] TRP-2026-03928 / TRL-2026-05960 - Adicio",
            "priority": "P2",
            "created_at": "14/04/2026 20:48:15",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:48:15"
          },
          {
            "ticket_id": 15213,
            "ticket_number": "3515201",
            "title": "[Suporte] TRP-2026-03116 / TRL-2026-04797 - Adicio",
            "priority": "P2",
            "created_at": "14/04/2026 20:53:25",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 20:53:26"
          },
          {
            "ticket_id": 15217,
            "ticket_number": "3515205",
            "title": "Referencia para pagamento | File:424887/2026",
            "priority": "P1",
            "created_at": "14/04/2026 21:18:28",
            "close_date": "2026-04-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.72,
            "sla_met": false,
            "sla_breach_hours": 0.47,
            "sla_name": "SLA P1",
            "first_response_at": "14/04/2026 22:02:25"
          },
          {
            "ticket_id": 15220,
            "ticket_number": "3515208",
            "title": "[Suporte] TRP-2026-02351 - Faturação URGENTE",
            "priority": "P2",
            "created_at": "14/04/2026 21:39:18",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:39:18"
          },
          {
            "ticket_id": 15238,
            "ticket_number": "3515226",
            "title": "GBN-96618 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "15/04/2026 10:08:25",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 14:00:43"
          },
          {
            "ticket_id": 15239,
            "ticket_number": "3515227",
            "title": "GBN-109015 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "15/04/2026 10:08:28",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 14:00:43"
          },
          {
            "ticket_id": 15243,
            "ticket_number": "3515231",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60459",
            "priority": "P1",
            "created_at": "15/04/2026 10:08:35",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.08,
            "sla_met": false,
            "sla_breach_hours": 6.83,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 17:14:34"
          },
          {
            "ticket_id": 15255,
            "ticket_number": "3515243",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "15/04/2026 10:24:22",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 10:27:39"
          },
          {
            "ticket_id": 15269,
            "ticket_number": "3515257",
            "title": "ARSP-31644: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "15/04/2026 12:16:36",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 171.62,
            "sla_met": false,
            "sla_breach_hours": 167.62,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:53:46"
          },
          {
            "ticket_id": 15277,
            "ticket_number": "3515265",
            "title": "Solole. Booking 2TUEPWDH is close to entering expe",
            "priority": "P2",
            "created_at": "15/04/2026 14:47:30",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 15:30:02"
          },
          {
            "ticket_id": 15285,
            "ticket_number": "3515273",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "15/04/2026 16:15:09",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "15/04/2026 16:20:53"
          },
          {
            "ticket_id": 15291,
            "ticket_number": "3515279",
            "title": "Re: [Cockpit] Viagem TRP-2026-02821 - ORY • Milton",
            "priority": "P2",
            "created_at": "15/04/2026 16:55:18",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 16:55:18"
          },
          {
            "ticket_id": 15293,
            "ticket_number": "3515281",
            "title": "Re: [Cockpit] Plano de Pagamento Ajustado - Viagem",
            "priority": "P2",
            "created_at": "15/04/2026 17:03:20",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:03:20"
          },
          {
            "ticket_id": 15310,
            "ticket_number": "3515298",
            "title": "Re: [Cockpit] Viagem TRP-2026-04754 - DolceCampoRe",
            "priority": "P2",
            "created_at": "15/04/2026 19:29:12",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 19:29:12"
          },
          {
            "ticket_id": 15312,
            "ticket_number": "3515300",
            "title": "Reserva GBN-118026",
            "priority": "P2",
            "created_at": "15/04/2026 21:06:51",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 21:06:51"
          },
          {
            "ticket_id": 15317,
            "ticket_number": "3515305",
            "title": "Re: [Cockpit] Viagem TRP-2026-04627 - seguro agadi",
            "priority": "P2",
            "created_at": "15/04/2026 22:08:59",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 22:09:00"
          },
          {
            "ticket_id": 15328,
            "ticket_number": "3515316",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P2",
            "created_at": "16/04/2026 09:12:59",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 13:02:30"
          },
          {
            "ticket_id": 15341,
            "ticket_number": "3515329",
            "title": "GBN-96618 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "16/04/2026 10:04:11",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 10:52:24"
          },
          {
            "ticket_id": 15342,
            "ticket_number": "3515330",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "16/04/2026 10:27:10",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 14:22:39"
          },
          {
            "ticket_id": 15348,
            "ticket_number": "3515336",
            "title": "Pedido de Pagamento Final de Reserva 213587",
            "priority": "P3",
            "created_at": "16/04/2026 12:09:32",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 4.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/04/2026 16:11:30"
          },
          {
            "ticket_id": 15371,
            "ticket_number": "3515359",
            "title": "Re: [Cockpit] Viagem TRP-2026-03116 - CUN • Maria ",
            "priority": "P2",
            "created_at": "16/04/2026 16:51:08",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 16:51:08"
          },
          {
            "ticket_id": 15373,
            "ticket_number": "3515361",
            "title": "URGENTE  - Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "16/04/2026 17:25:20",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 88.15,
            "sla_met": false,
            "sla_breach_hours": 87.9,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 09:34:25"
          },
          {
            "ticket_id": 15388,
            "ticket_number": "3515376",
            "title": "RE: [Cockpit] Viagem TRP-2026-02902 - LIS • Tania ",
            "priority": "P2",
            "created_at": "16/04/2026 22:07:57",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 22:07:58"
          },
          {
            "ticket_id": 15395,
            "ticket_number": "3515383",
            "title": "333035 - Emissão",
            "priority": "P1",
            "created_at": "17/04/2026 00:59:18",
            "close_date": "2026-05-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 00:59:18"
          },
          {
            "ticket_id": 15413,
            "ticket_number": "3515401",
            "title": "GBN-108609 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "17/04/2026 09:15:26",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.27,
            "sla_met": false,
            "sla_breach_hours": 6.02,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 15:32:21"
          },
          {
            "ticket_id": 15414,
            "ticket_number": "3515402",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P1",
            "created_at": "17/04/2026 09:15:27",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.23,
            "sla_met": false,
            "sla_breach_hours": 5.98,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 15:29:39"
          },
          {
            "ticket_id": 15415,
            "ticket_number": "3515403",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "17/04/2026 09:15:30",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 271.02,
            "sla_met": false,
            "sla_breach_hours": 267.02,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 16:17:24"
          },
          {
            "ticket_id": 15439,
            "ticket_number": "3515427",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "17/04/2026 10:59:28",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:59:28"
          },
          {
            "ticket_id": 15454,
            "ticket_number": "3515442",
            "title": "Re: [Cockpit] Viagem TRP-2026-03449 - ZNZ • Ana Ca",
            "priority": "P2",
            "created_at": "17/04/2026 13:24:54",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 13:24:54"
          },
          {
            "ticket_id": 15459,
            "ticket_number": "3515447",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:07",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:50:19"
          },
          {
            "ticket_id": 15473,
            "ticket_number": "3515461",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "17/04/2026 15:06:38",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 15:07:36"
          },
          {
            "ticket_id": 15474,
            "ticket_number": "3515462",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "17/04/2026 15:06:40",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 15:07:57"
          },
          {
            "ticket_id": 15480,
            "ticket_number": "3515468",
            "title": "RE: [Cockpit] Viagem TRP-2026-03383 - TUN • SERGIO",
            "priority": "P2",
            "created_at": "17/04/2026 16:02:10",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 16:02:11"
          },
          {
            "ticket_id": 15500,
            "ticket_number": "3515488",
            "title": "Referencia para pagamento | File:438860/2026",
            "priority": "P1",
            "created_at": "17/04/2026 22:12:54",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 22:21:02"
          },
          {
            "ticket_id": 15542,
            "ticket_number": "3515530",
            "title": "GBN-118329 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:23",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:57:16"
          },
          {
            "ticket_id": 15543,
            "ticket_number": "3515531",
            "title": "GBN-105065 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:25",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:56:57"
          },
          {
            "ticket_id": 15545,
            "ticket_number": "3515533",
            "title": "GBN-91053 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:30",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:56:46"
          },
          {
            "ticket_id": 15548,
            "ticket_number": "3515536",
            "title": "GBN-105369 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:35",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:56:27"
          },
          {
            "ticket_id": 15550,
            "ticket_number": "3515538",
            "title": "Fatura mês de Abril",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:39"
          },
          {
            "ticket_id": 15573,
            "ticket_number": "3515561",
            "title": "Re: [Cockpit] Viagem TRP-2026-04286 - Liliana Fran",
            "priority": "P2",
            "created_at": "20/04/2026 09:07:32",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:07:33"
          },
          {
            "ticket_id": 15577,
            "ticket_number": "3515565",
            "title": "GBN-119314 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "20/04/2026 09:07:58",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.8,
            "sla_met": false,
            "sla_breach_hours": 3.55,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 12:56:13"
          },
          {
            "ticket_id": 15579,
            "ticket_number": "3515567",
            "title": "GBN-118329 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:01",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:55:48"
          },
          {
            "ticket_id": 15580,
            "ticket_number": "3515568",
            "title": "GBN-105065 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:03",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:04:45"
          },
          {
            "ticket_id": 15583,
            "ticket_number": "3515571",
            "title": "GBN-105369 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:09",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 12:49:04"
          },
          {
            "ticket_id": 15591,
            "ticket_number": "3515579",
            "title": "Referencia para pagamento | File:438952/2026",
            "priority": "P1",
            "created_at": "20/04/2026 09:08:22",
            "close_date": "2026-04-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.07,
            "sla_met": false,
            "sla_breach_hours": 6.82,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 16:12:44"
          },
          {
            "ticket_id": 15597,
            "ticket_number": "3515585",
            "title": "Recibo de Comissões - HENRIQUE RIOS (20/04/2026)",
            "priority": "P2",
            "created_at": "20/04/2026 10:00:38",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:00:38"
          },
          {
            "ticket_id": 15623,
            "ticket_number": "3515611",
            "title": "TRP-2026-04802 - Debitar valor da viagem das comis",
            "priority": "P2",
            "created_at": "20/04/2026 11:55:18",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 11:55:18"
          },
          {
            "ticket_id": 15641,
            "ticket_number": "3515629",
            "title": "Re: [Cockpit] Viagem TRP-2026-04786 - HOTEL GDD AM",
            "priority": "P2",
            "created_at": "20/04/2026 13:15:35",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 13:15:35"
          },
          {
            "ticket_id": 15646,
            "ticket_number": "3515634",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P1",
            "created_at": "20/04/2026 14:22:15",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.97,
            "sla_met": false,
            "sla_breach_hours": 3.72,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 18:20:40"
          },
          {
            "ticket_id": 15647,
            "ticket_number": "3515635",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P1",
            "created_at": "20/04/2026 14:22:16",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.97,
            "sla_met": false,
            "sla_breach_hours": 3.72,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 18:20:40"
          },
          {
            "ticket_id": 15649,
            "ticket_number": "3515637",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P1",
            "created_at": "20/04/2026 14:39:14",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.98,
            "sla_met": false,
            "sla_breach_hours": 3.73,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 18:38:30"
          },
          {
            "ticket_id": 15657,
            "ticket_number": "3515645",
            "title": "Confirmação e Sinalização de Reserva 215052",
            "priority": "P2",
            "created_at": "20/04/2026 15:16:55",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:16:55"
          },
          {
            "ticket_id": 15664,
            "ticket_number": "3515652",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P1",
            "created_at": "20/04/2026 15:43:37",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.93,
            "sla_met": false,
            "sla_breach_hours": 2.68,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 18:39:53"
          },
          {
            "ticket_id": 15682,
            "ticket_number": "3515670",
            "title": "Re: [Cockpit] Viagem TRP-2026-04799 - Viagem a Áfr",
            "priority": "P2",
            "created_at": "20/04/2026 17:24:39",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 17:24:39"
          },
          {
            "ticket_id": 15702,
            "ticket_number": "3515690",
            "title": "GBN-113981 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "21/04/2026 09:02:59",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:02:07"
          },
          {
            "ticket_id": 15703,
            "ticket_number": "3515691",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:01",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:02:07"
          },
          {
            "ticket_id": 15706,
            "ticket_number": "3515694",
            "title": "Comissões_Cokpit",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:08",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:03:08"
          },
          {
            "ticket_id": 15707,
            "ticket_number": "3515695",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60461",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:11",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:02:07"
          },
          {
            "ticket_id": 15709,
            "ticket_number": "3515697",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60461",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:15",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:02:07"
          },
          {
            "ticket_id": 15712,
            "ticket_number": "3515700",
            "title": "Re: [Cockpit] Viagem TRP-2026-03788 - Isabel e rog",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:21",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:02:07"
          },
          {
            "ticket_id": 15736,
            "ticket_number": "3515724",
            "title": "Re: [Cockpit] Viagem TRP-2026-04805 - Algarve",
            "priority": "P2",
            "created_at": "21/04/2026 12:21:51",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:21:51"
          },
          {
            "ticket_id": 15738,
            "ticket_number": "3515726",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "21/04/2026 12:21:59",
            "close_date": "2026-04-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/04/2026 12:22:55"
          },
          {
            "ticket_id": 15739,
            "ticket_number": "3515727",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "21/04/2026 12:22:01",
            "close_date": "2026-04-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/04/2026 12:23:23"
          },
          {
            "ticket_id": 15745,
            "ticket_number": "3515733",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP175182, Sr/a ",
            "priority": "P2",
            "created_at": "21/04/2026 12:54:50",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 16:42:32"
          },
          {
            "ticket_id": 15776,
            "ticket_number": "3515764",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem   TRP-20",
            "priority": "P2",
            "created_at": "21/04/2026 18:34:41",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 18:34:41"
          },
          {
            "ticket_id": 15785,
            "ticket_number": "3515773",
            "title": "TRP-2026-02663 - Pedido E,issao Fatura",
            "priority": "P2",
            "created_at": "21/04/2026 20:35:58",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 20:35:58"
          },
          {
            "ticket_id": 15788,
            "ticket_number": "3515776",
            "title": "Referencia para pagamento | File:438952/2026",
            "priority": "P2",
            "created_at": "21/04/2026 21:17:28",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 18.48,
            "sla_met": false,
            "sla_breach_hours": 14.48,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:47:25"
          },
          {
            "ticket_id": 15791,
            "ticket_number": "3515779",
            "title": "[Suporte] TRP-2026-03478 / TRL-2026-05312 - Fatura",
            "priority": "P1",
            "created_at": "21/04/2026 22:55:05",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/04/2026 22:55:05"
          },
          {
            "ticket_id": 15795,
            "ticket_number": "3515783",
            "title": "Re: [Cockpit] Viagem TRP-2026-04773 - Cidade Real",
            "priority": "P2",
            "created_at": "21/04/2026 22:57:47",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 22:57:47"
          },
          {
            "ticket_id": 15805,
            "ticket_number": "3515793",
            "title": "GBN-113981 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:10",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 13:00:32"
          },
          {
            "ticket_id": 15808,
            "ticket_number": "3515796",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:17",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 13:00:32"
          },
          {
            "ticket_id": 15824,
            "ticket_number": "3515812",
            "title": "ARSP-31955: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:33",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 4.73,
            "sla_met": false,
            "sla_breach_hours": 0.73,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:42:14"
          },
          {
            "ticket_id": 15825,
            "ticket_number": "3515813",
            "title": "ARSP-31967: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:35",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 4.73,
            "sla_met": false,
            "sla_breach_hours": 0.73,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:42:01"
          },
          {
            "ticket_id": 15827,
            "ticket_number": "3515815",
            "title": "ARSP-31952: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:45",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 4.72,
            "sla_met": false,
            "sla_breach_hours": 0.72,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:41:19"
          },
          {
            "ticket_id": 15828,
            "ticket_number": "3515816",
            "title": "ARSP-31964: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:47",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 4.7,
            "sla_met": false,
            "sla_breach_hours": 0.7,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:40:40"
          },
          {
            "ticket_id": 15832,
            "ticket_number": "3515820",
            "title": "Envio documentos - (Factura-231005511)  n. 1004577",
            "priority": "P1",
            "created_at": "22/04/2026 11:22:08",
            "close_date": "2026-04-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.52,
            "sla_met": false,
            "sla_breach_hours": 6.27,
            "sla_name": "SLA P1",
            "first_response_at": "22/04/2026 17:54:01"
          },
          {
            "ticket_id": 15842,
            "ticket_number": "3515830",
            "title": "[Suporte] TRP-2026-02821 - Faturas",
            "priority": "P2",
            "created_at": "22/04/2026 14:16:50",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 14:16:50"
          },
          {
            "ticket_id": 15864,
            "ticket_number": "3515852",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "22/04/2026 16:34:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:34:39"
          },
          {
            "ticket_id": 15869,
            "ticket_number": "3515857",
            "title": "Pedido de Pagamento",
            "priority": "P2",
            "created_at": "22/04/2026 17:10:45",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 17:10:46"
          },
          {
            "ticket_id": 15872,
            "ticket_number": "3515860",
            "title": "Proforma 93130248",
            "priority": "P1",
            "created_at": "22/04/2026 17:10:52",
            "close_date": "2026-04-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "22/04/2026 17:20:57"
          },
          {
            "ticket_id": 15886,
            "ticket_number": "3515874",
            "title": "PAGAMENTO ATRASADO",
            "priority": "P2",
            "created_at": "22/04/2026 19:03:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 19:03:35"
          },
          {
            "ticket_id": 15905,
            "ticket_number": "3515893",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP457698, Sr/a ",
            "priority": "P2",
            "created_at": "22/04/2026 22:42:51",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:42:20"
          },
          {
            "ticket_id": 15936,
            "ticket_number": "3515924",
            "title": "[Suporte] TRP-2026-02401 - Faturas",
            "priority": "P2",
            "created_at": "23/04/2026 11:27:53",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 11:27:53"
          },
          {
            "ticket_id": 15966,
            "ticket_number": "3515954",
            "title": "Pedido de faturas",
            "priority": "P2",
            "created_at": "23/04/2026 16:15:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:15:40"
          },
          {
            "ticket_id": 15972,
            "ticket_number": "3515960",
            "title": "Re: [Cockpit] Viagem TRP-2026-04221 - México Amiga",
            "priority": "P2",
            "created_at": "23/04/2026 16:53:01",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 16:53:01"
          },
          {
            "ticket_id": 15976,
            "ticket_number": "3515964",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "23/04/2026 17:11:07",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 21:03:02"
          },
          {
            "ticket_id": 16023,
            "ticket_number": "3516011",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P2",
            "created_at": "24/04/2026 09:20:06",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:15:44"
          },
          {
            "ticket_id": 16039,
            "ticket_number": "3516027",
            "title": "RE: [Cockpit] Viagem TRP-2026-04836 - Tenerife - T",
            "priority": "P2",
            "created_at": "24/04/2026 12:03:53",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:03:53"
          },
          {
            "ticket_id": 16040,
            "ticket_number": "3516028",
            "title": "Iban da agência Uma Familia em Viagem",
            "priority": "P2",
            "created_at": "24/04/2026 12:27:58",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:27:59"
          },
          {
            "ticket_id": 16044,
            "ticket_number": "3516032",
            "title": "[Suporte] TRP-2026-02884 - Comissão - Viagem Total",
            "priority": "P2",
            "created_at": "24/04/2026 13:21:43",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 13:21:44"
          },
          {
            "ticket_id": 16047,
            "ticket_number": "3516035",
            "title": "Facturas",
            "priority": "P1",
            "created_at": "24/04/2026 13:26:11",
            "close_date": "2026-04-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "24/04/2026 13:26:12"
          },
          {
            "ticket_id": 16064,
            "ticket_number": "3516052",
            "title": "[Suporte] TRP-2026-04379 - Validação de pagamento",
            "priority": "P2",
            "created_at": "24/04/2026 17:03:58",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 17:03:58"
          },
          {
            "ticket_id": 16098,
            "ticket_number": "3516086",
            "title": "Referencia para pagamento | File:435009/2026",
            "priority": "P2",
            "created_at": "24/04/2026 21:06:14",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:03:37"
          },
          {
            "ticket_id": 16099,
            "ticket_number": "3516087",
            "title": "Referencia para pagamento | File:432065/2026",
            "priority": "P2",
            "created_at": "24/04/2026 21:06:15",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 67.43,
            "sla_met": false,
            "sla_breach_hours": 63.43,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 16:33:02"
          },
          {
            "ticket_id": 16101,
            "ticket_number": "3516089",
            "title": "Referencia para pagamento | File:439725/2026",
            "priority": "P2",
            "created_at": "24/04/2026 21:40:46",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 66.83,
            "sla_met": false,
            "sla_breach_hours": 62.83,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 16:31:37"
          },
          {
            "ticket_id": 16113,
            "ticket_number": "3516101",
            "title": "[Suporte] TRP-2026-04144 - Validação",
            "priority": "P2",
            "created_at": "26/04/2026 21:14:29",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/04/2026 21:14:29"
          },
          {
            "ticket_id": 16119,
            "ticket_number": "3516107",
            "title": "Sinalização do Grupo DGAV1554_26_GRUPO MARLENEFERN",
            "priority": "P1",
            "created_at": "27/04/2026 09:08:48",
            "close_date": "2026-04-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.67,
            "sla_met": false,
            "sla_breach_hours": 1.42,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 10:49:18"
          },
          {
            "ticket_id": 16120,
            "ticket_number": "3516108",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P2",
            "created_at": "27/04/2026 09:08:51",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:03:50"
          },
          {
            "ticket_id": 16124,
            "ticket_number": "3516112",
            "title": "GBN-104486 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:06",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:03:50"
          },
          {
            "ticket_id": 16127,
            "ticket_number": "3516115",
            "title": "Referencia para pagamento | File:432444/2026",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:12",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:03:50"
          },
          {
            "ticket_id": 16141,
            "ticket_number": "3516129",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP457698, Sr/a ",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:13",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:03:50"
          },
          {
            "ticket_id": 16148,
            "ticket_number": "3516136",
            "title": "Referencia para pagamento | File:439734/2026",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:31",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:34:02"
          },
          {
            "ticket_id": 16158,
            "ticket_number": "3516146",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP175182, Sr/a ",
            "priority": "P1",
            "created_at": "27/04/2026 09:13:23",
            "close_date": "2026-04-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.72,
            "sla_met": false,
            "sla_breach_hours": 8.47,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 17:56:28"
          },
          {
            "ticket_id": 16169,
            "ticket_number": "3516157",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:57",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:03:50"
          },
          {
            "ticket_id": 16190,
            "ticket_number": "3516178",
            "title": "ARSP-32161: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:50",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16191,
            "ticket_number": "3516179",
            "title": "ARSP-32171: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:52",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16192,
            "ticket_number": "3516180",
            "title": "ARSP-32153: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:54",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16193,
            "ticket_number": "3516181",
            "title": "ARSP-29676: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:55",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16194,
            "ticket_number": "3516182",
            "title": "ARSP-32164: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:57",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16195,
            "ticket_number": "3516183",
            "title": "ARSP-32159: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:59",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16196,
            "ticket_number": "3516184",
            "title": "ARSP-32166: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/04/2026 10:05:00",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16198,
            "ticket_number": "3516186",
            "title": "Recibo comissões Zulmira Fontes",
            "priority": "P2",
            "created_at": "27/04/2026 10:05:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:05:37"
          },
          {
            "ticket_id": 16200,
            "ticket_number": "3516188",
            "title": "Referencia para pagamento | File:437298/2026",
            "priority": "P2",
            "created_at": "27/04/2026 10:08:32",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:03:58"
          },
          {
            "ticket_id": 16202,
            "ticket_number": "3516190",
            "title": "***URGENTE PAGO***LOC.604513226 (LEPLAN)-----Uma F",
            "priority": "P1",
            "created_at": "27/04/2026 10:47:07",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 29.47,
            "sla_met": false,
            "sla_breach_hours": 29.22,
            "sla_name": "SLA P1",
            "first_response_at": "28/04/2026 16:15:41"
          },
          {
            "ticket_id": 16207,
            "ticket_number": "3516195",
            "title": "[Suporte] TRP-2026-04267 - Validar viagem com a al",
            "priority": "P2",
            "created_at": "27/04/2026 11:11:29",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 11:11:30"
          },
          {
            "ticket_id": 16217,
            "ticket_number": "3516205",
            "title": "Envio Fatura",
            "priority": "P2",
            "created_at": "27/04/2026 11:45:56",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 6.15,
            "sla_met": false,
            "sla_breach_hours": 2.15,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 17:55:31"
          },
          {
            "ticket_id": 16221,
            "ticket_number": "3516209",
            "title": "Re: [Cockpit] Viagem TRP-2026-02938 - ORY • Joana ",
            "priority": "P2",
            "created_at": "27/04/2026 12:17:59",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:17:59"
          },
          {
            "ticket_id": 16223,
            "ticket_number": "3516211",
            "title": "[Suporte] TRP-2026-03826 - Verificaçao Pagamento",
            "priority": "P2",
            "created_at": "27/04/2026 12:55:11",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 12:55:11"
          },
          {
            "ticket_id": 16231,
            "ticket_number": "3516219",
            "title": "Atividade %s cancelada: Passeio de barco pirata po",
            "priority": "P2",
            "created_at": "27/04/2026 13:17:10",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 13:00:10"
          },
          {
            "ticket_id": 16277,
            "ticket_number": "3516265",
            "title": "Referencia para pagamento | File:415469/2025",
            "priority": "P2",
            "created_at": "27/04/2026 21:09:24",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:00:47"
          },
          {
            "ticket_id": 16278,
            "ticket_number": "3516266",
            "title": "Referencia para pagamento | File:415457/2025",
            "priority": "P2",
            "created_at": "27/04/2026 21:09:26",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:00:47"
          },
          {
            "ticket_id": 16290,
            "ticket_number": "3516278",
            "title": "[Cancelamento Viagem] TRP-2026-04625 - Rui Lourenç",
            "priority": "P2",
            "created_at": "27/04/2026 22:27:07",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 22:27:07"
          },
          {
            "ticket_id": 16314,
            "ticket_number": "3516302",
            "title": "Viagem TRP-2026-04023",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:40",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:40"
          },
          {
            "ticket_id": 16320,
            "ticket_number": "3516308",
            "title": "ARSP-32385: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:25",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:01:17"
          },
          {
            "ticket_id": 16321,
            "ticket_number": "3516309",
            "title": "ARSP-32371: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:29",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:01:17"
          },
          {
            "ticket_id": 16324,
            "ticket_number": "3516312",
            "title": "RE: Pagamento 604569266",
            "priority": "P1",
            "created_at": "28/04/2026 10:05:38",
            "close_date": "2026-04-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.08,
            "sla_met": false,
            "sla_breach_hours": 5.83,
            "sla_name": "SLA P1",
            "first_response_at": "28/04/2026 16:11:08"
          },
          {
            "ticket_id": 16325,
            "ticket_number": "3516313",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:41",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:01:17"
          },
          {
            "ticket_id": 16331,
            "ticket_number": "3516319",
            "title": "Re: [Cockpit] Viagem TRP-2026-04897 - Viagem de fa",
            "priority": "P2",
            "created_at": "28/04/2026 11:39:10",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 11:39:10"
          },
          {
            "ticket_id": 16375,
            "ticket_number": "3516363",
            "title": "Pedido de Pagamento Final de Reserva 212775",
            "priority": "P2",
            "created_at": "28/04/2026 17:43:14",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 21:42:22"
          },
          {
            "ticket_id": 16376,
            "ticket_number": "3516364",
            "title": "FW: Emissão dos bilhetes aéreos - Senegal",
            "priority": "P2",
            "created_at": "28/04/2026 17:43:15",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:06:17"
          },
          {
            "ticket_id": 16392,
            "ticket_number": "3516380",
            "title": "Referencia para pagamento | File:440001/2026",
            "priority": "P2",
            "created_at": "28/04/2026 21:40:11",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 19.33,
            "sla_met": false,
            "sla_breach_hours": 15.33,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 17:00:45"
          },
          {
            "ticket_id": 16412,
            "ticket_number": "3516400",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:52",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 127.03,
            "sla_met": false,
            "sla_breach_hours": 123.03,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:17:41"
          },
          {
            "ticket_id": 16414,
            "ticket_number": "3516402",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P1",
            "created_at": "29/04/2026 09:14:55",
            "close_date": "2026-04-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.83,
            "sla_met": false,
            "sla_breach_hours": 24.58,
            "sla_name": "SLA P1",
            "first_response_at": "30/04/2026 10:05:24"
          },
          {
            "ticket_id": 16423,
            "ticket_number": "3516411",
            "title": "ARSP-32512: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "29/04/2026 09:51:29",
            "close_date": "2026-04-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.8,
            "sla_met": false,
            "sla_breach_hours": 4.55,
            "sla_name": "SLA P1",
            "first_response_at": "29/04/2026 14:39:39"
          },
          {
            "ticket_id": 16424,
            "ticket_number": "3516412",
            "title": "ARSP-32506: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "29/04/2026 09:51:31",
            "close_date": "2026-04-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.77,
            "sla_met": false,
            "sla_breach_hours": 4.52,
            "sla_name": "SLA P1",
            "first_response_at": "29/04/2026 14:38:07"
          },
          {
            "ticket_id": 16467,
            "ticket_number": "3516455",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "29/04/2026 15:44:43",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:44:43"
          },
          {
            "ticket_id": 16516,
            "ticket_number": "3516504",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "29/04/2026 18:46:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 117.45,
            "sla_met": false,
            "sla_breach_hours": 117.2,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:14:34"
          },
          {
            "ticket_id": 16538,
            "ticket_number": "3516526",
            "title": "Fwd: [Cockpit] ✅ Pedido de Comissão Aprovado - PAY",
            "priority": "P2",
            "created_at": "30/04/2026 09:14:12",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 09:14:12"
          },
          {
            "ticket_id": 16551,
            "ticket_number": "3516539",
            "title": "RE: Reserva 6146808 W2MCS:014950003633",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:38",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:34:01"
          },
          {
            "ticket_id": 16558,
            "ticket_number": "3516546",
            "title": "pro forma",
            "priority": "P2",
            "created_at": "30/04/2026 11:06:13",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:06:14"
          },
          {
            "ticket_id": 16570,
            "ticket_number": "3516558",
            "title": "Re: [Cockpit] Viagem TRP-2026-04023 - ILHA DO SAL ",
            "priority": "P2",
            "created_at": "30/04/2026 13:15:55",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:15:56"
          },
          {
            "ticket_id": 16575,
            "ticket_number": "3516563",
            "title": "Recibo de Comissões - HENRIQUE RIOS (30/04/2026)",
            "priority": "P2",
            "created_at": "30/04/2026 13:16:11",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 13:16:11"
          },
          {
            "ticket_id": 16579,
            "ticket_number": "3516567",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "30/04/2026 13:16:49",
            "close_date": "2026-04-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "30/04/2026 13:24:24"
          },
          {
            "ticket_id": 16666,
            "ticket_number": "3516654",
            "title": "Referencia para pagamento | File:435113/2026",
            "priority": "P2",
            "created_at": "30/04/2026 21:12:20",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 116.0,
            "sla_met": false,
            "sla_breach_hours": 112.0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 17:12:39"
          },
          {
            "ticket_id": 16680,
            "ticket_number": "3516668",
            "title": "Validação de Pagamento + Faturação",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:33",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:55:33"
          },
          {
            "ticket_id": 16693,
            "ticket_number": "3516681",
            "title": "GBN-117938 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "02/05/2026 09:56:49",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.2,
            "sla_met": false,
            "sla_breach_hours": 53.95,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:09:11"
          },
          {
            "ticket_id": 16694,
            "ticket_number": "3516682",
            "title": "GBN-94881 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "02/05/2026 09:56:51",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.2,
            "sla_met": false,
            "sla_breach_hours": 53.95,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:08:58"
          },
          {
            "ticket_id": 16719,
            "ticket_number": "3516707",
            "title": "GBN-102212 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "02/05/2026 10:00:38",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.12,
            "sla_met": false,
            "sla_breach_hours": 53.87,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:08:25"
          },
          {
            "ticket_id": 16721,
            "ticket_number": "3516709",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P2",
            "created_at": "02/05/2026 10:00:46",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 54.1,
            "sla_met": false,
            "sla_breach_hours": 50.1,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 16:07:28"
          },
          {
            "ticket_id": 16722,
            "ticket_number": "3516710",
            "title": "GBN-94881 - Sua reserva está pendente de pagamento",
            "priority": "P1",
            "created_at": "02/05/2026 10:00:48",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.1,
            "sla_met": false,
            "sla_breach_hours": 53.85,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:06:56"
          },
          {
            "ticket_id": 16725,
            "ticket_number": "3516713",
            "title": "GBN-117938 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "02/05/2026 10:00:54",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 54.07,
            "sla_met": false,
            "sla_breach_hours": 53.82,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:05:27"
          },
          {
            "ticket_id": 16736,
            "ticket_number": "3516724",
            "title": "Referencia para pagamento | File:440291/2026",
            "priority": "P1",
            "created_at": "02/05/2026 10:01:32",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 56.1,
            "sla_met": false,
            "sla_breach_hours": 55.85,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 18:07:52"
          },
          {
            "ticket_id": 16790,
            "ticket_number": "3516778",
            "title": "RESERVA TRP-2026-04427",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:12",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:10:13"
          },
          {
            "ticket_id": 16794,
            "ticket_number": "3516782",
            "title": "Referencia para pagamento | File:420075/2025",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:32",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:01:59"
          },
          {
            "ticket_id": 16812,
            "ticket_number": "3516800",
            "title": "GBN-102212 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "04/05/2026 09:11:52",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.8,
            "sla_met": false,
            "sla_breach_hours": 6.55,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 16:00:44"
          },
          {
            "ticket_id": 16813,
            "ticket_number": "3516801",
            "title": "GBN-120455 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "04/05/2026 09:11:54",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:01:59"
          },
          {
            "ticket_id": 16823,
            "ticket_number": "3516811",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P1",
            "created_at": "04/05/2026 09:13:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.72,
            "sla_met": false,
            "sla_breach_hours": 6.47,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 15:57:26"
          },
          {
            "ticket_id": 16825,
            "ticket_number": "3516813",
            "title": "Referencia para pagamento | File:440322/2026",
            "priority": "P1",
            "created_at": "04/05/2026 09:13:51",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.87,
            "sla_met": false,
            "sla_breach_hours": 8.62,
            "sla_name": "SLA P1",
            "first_response_at": "04/05/2026 18:06:50"
          },
          {
            "ticket_id": 16834,
            "ticket_number": "3516822",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P2",
            "created_at": "04/05/2026 09:14:48",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:01:59"
          },
          {
            "ticket_id": 16840,
            "ticket_number": "3516828",
            "title": "Recordativo de pagamento agência Uma Família em Vi",
            "priority": "P1",
            "created_at": "04/05/2026 09:31:51",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 23.47,
            "sla_met": false,
            "sla_breach_hours": 23.22,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 09:00:39"
          },
          {
            "ticket_id": 16846,
            "ticket_number": "3516834",
            "title": "ARSP-32617: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:03",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 14:22:11"
          },
          {
            "ticket_id": 16847,
            "ticket_number": "3516835",
            "title": "ARSP-29943: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:05",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 14:22:11"
          },
          {
            "ticket_id": 16848,
            "ticket_number": "3516836",
            "title": "ARSP-32626: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/05/2026 10:30:07",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 14:22:11"
          },
          {
            "ticket_id": 16889,
            "ticket_number": "3516877",
            "title": "[Suporte] TRP-2026-03105 - Fatura e Recibo",
            "priority": "P2",
            "created_at": "04/05/2026 13:32:37",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:32:37"
          },
          {
            "ticket_id": 16890,
            "ticket_number": "3516878",
            "title": "Re: [Cockpit] Viagem TRP-2026-04947 - Vitória Ferr",
            "priority": "P2",
            "created_at": "04/05/2026 14:00:17",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 14:00:17"
          },
          {
            "ticket_id": 16896,
            "ticket_number": "3516884",
            "title": "ARSP-32780: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:07",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:43:26"
          },
          {
            "ticket_id": 16897,
            "ticket_number": "3516885",
            "title": "ARSP-32784: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "04/05/2026 15:12:09",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 15:39:29"
          },
          {
            "ticket_id": 16917,
            "ticket_number": "3516905",
            "title": "Fatura BAMBUTI",
            "priority": "P2",
            "created_at": "04/05/2026 16:34:21",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 20:23:02"
          },
          {
            "ticket_id": 16928,
            "ticket_number": "3516916",
            "title": "RE: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "04/05/2026 18:19:38",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:19:38"
          },
          {
            "ticket_id": 16938,
            "ticket_number": "3516926",
            "title": "FW: Important: Your TAP Air Portugal flight refere",
            "priority": "P1",
            "created_at": "04/05/2026 20:30:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 22:46:08"
          },
          {
            "ticket_id": 16943,
            "ticket_number": "3516931",
            "title": "Referencia para pagamento | File:431638/2026",
            "priority": "P2",
            "created_at": "04/05/2026 21:21:33",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 181.32,
            "sla_met": false,
            "sla_breach_hours": 177.32,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:40:49"
          },
          {
            "ticket_id": 16949,
            "ticket_number": "3516937",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "04/05/2026 22:00:12",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:00:12"
          },
          {
            "ticket_id": 16970,
            "ticket_number": "3516958",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60448",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:18",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:04:34"
          },
          {
            "ticket_id": 16973,
            "ticket_number": "3516961",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60457",
            "priority": "P2",
            "created_at": "05/05/2026 09:05:23",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:04:34"
          },
          {
            "ticket_id": 16990,
            "ticket_number": "3516978",
            "title": "Amanhã será realizada a cobrança da reserva A38096",
            "priority": "P2",
            "created_at": "05/05/2026 10:26:57",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 14:24:49"
          },
          {
            "ticket_id": 16993,
            "ticket_number": "3516981",
            "title": "Lembrete de reserva pré-paga : 6142286",
            "priority": "P2",
            "created_at": "05/05/2026 10:56:06",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 11:04:03"
          },
          {
            "ticket_id": 17008,
            "ticket_number": "3516996",
            "title": "Cockpit com valores por validar",
            "priority": "P2",
            "created_at": "05/05/2026 12:53:01",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 12:53:01"
          },
          {
            "ticket_id": 17014,
            "ticket_number": "3517002",
            "title": "Fatura viagem TRP-2026-03105",
            "priority": "P2",
            "created_at": "05/05/2026 13:29:17",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:29:17"
          },
          {
            "ticket_id": 17018,
            "ticket_number": "3517006",
            "title": "fatura urgente TRP-2026-04665",
            "priority": "P2",
            "created_at": "05/05/2026 13:29:28",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:29:29"
          },
          {
            "ticket_id": 17019,
            "ticket_number": "3517007",
            "title": "emissão de faturas",
            "priority": "P2",
            "created_at": "05/05/2026 13:29:30",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:29:30"
          },
          {
            "ticket_id": 17041,
            "ticket_number": "3517029",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "05/05/2026 16:38:50",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.22,
            "sla_met": false,
            "sla_breach_hours": 1.97,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 18:52:06"
          },
          {
            "ticket_id": 17093,
            "ticket_number": "3517081",
            "title": "ARSP-32984: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "06/05/2026 10:07:14",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:02:11"
          },
          {
            "ticket_id": 17095,
            "ticket_number": "3517083",
            "title": "ARSP-32967: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "06/05/2026 10:07:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:02:11"
          },
          {
            "ticket_id": 17096,
            "ticket_number": "3517084",
            "title": "ARSP-32965: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "06/05/2026 10:07:21",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:02:11"
          },
          {
            "ticket_id": 17118,
            "ticket_number": "3517106",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "06/05/2026 11:31:41",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.38,
            "sla_met": false,
            "sla_breach_hours": 0.13,
            "sla_name": "SLA P1",
            "first_response_at": "06/05/2026 11:55:26"
          },
          {
            "ticket_id": 17177,
            "ticket_number": "3517165",
            "title": "Alterar descrição faturas 241000999 e 241000998 - ",
            "priority": "P2",
            "created_at": "06/05/2026 19:06:57",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 38.8,
            "sla_met": false,
            "sla_breach_hours": 34.8,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:55:49"
          },
          {
            "ticket_id": 17193,
            "ticket_number": "3517181",
            "title": "Referencia para pagamento | File:440688/2026",
            "priority": "P2",
            "created_at": "06/05/2026 21:43:21",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 35.62,
            "sla_met": false,
            "sla_breach_hours": 31.62,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:20:29"
          },
          {
            "ticket_id": 17205,
            "ticket_number": "3517193",
            "title": "[Suporte] TRP-2026-04410 - Faturação",
            "priority": "P2",
            "created_at": "06/05/2026 22:50:56",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 22:50:56"
          },
          {
            "ticket_id": 17208,
            "ticket_number": "3517196",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP148217, Sr/a ",
            "priority": "P2",
            "created_at": "06/05/2026 23:02:46",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 184.22,
            "sla_met": false,
            "sla_breach_hours": 180.22,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 15:16:10"
          },
          {
            "ticket_id": 17221,
            "ticket_number": "3517209",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60452",
            "priority": "P2",
            "created_at": "07/05/2026 09:08:06",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:04:46"
          },
          {
            "ticket_id": 17258,
            "ticket_number": "3517246",
            "title": "localizador - 6129227",
            "priority": "P2",
            "created_at": "07/05/2026 10:57:14",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:57:14"
          },
          {
            "ticket_id": 17285,
            "ticket_number": "3517273",
            "title": "ARSP-33023: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "07/05/2026 15:04:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 24,
            "actual_time_hours": 262.25,
            "sla_met": false,
            "sla_breach_hours": 238.25,
            "sla_name": "SLA P3",
            "first_response_at": "18/05/2026 13:20:15"
          },
          {
            "ticket_id": 17286,
            "ticket_number": "3517274",
            "title": "ARSP-32626: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "07/05/2026 15:04:58",
            "close_date": "2026-05-07",
            "sla_target_hours": 24,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/05/2026 17:41:08"
          },
          {
            "ticket_id": 17287,
            "ticket_number": "3517275",
            "title": "ARSP-32617: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P3",
            "created_at": "07/05/2026 15:05:00",
            "close_date": "2026-05-10",
            "sla_target_hours": 24,
            "actual_time_hours": 2.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/05/2026 18:03:21"
          },
          {
            "ticket_id": 17298,
            "ticket_number": "3517286",
            "title": "Antecipação emissão bilhetes Porto Santo GF 344772",
            "priority": "P2",
            "created_at": "07/05/2026 17:07:12",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 17:52:01"
          },
          {
            "ticket_id": 17304,
            "ticket_number": "3517292",
            "title": "Pedido de Pagamento Final de Reserva 212274",
            "priority": "P2",
            "created_at": "07/05/2026 17:07:24",
            "close_date": "2026-05-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 21:00:35"
          },
          {
            "ticket_id": 17307,
            "ticket_number": "3517295",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "07/05/2026 17:41:25",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 21:40:37"
          },
          {
            "ticket_id": 17310,
            "ticket_number": "3517298",
            "title": "Antecipação emissão bilhetes Porto Santo GF 341147",
            "priority": "P1",
            "created_at": "07/05/2026 17:41:32",
            "close_date": "2026-05-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/05/2026 17:53:33"
          },
          {
            "ticket_id": 17311,
            "ticket_number": "3517299",
            "title": "Antecipação emissão bilhetes Porto Santo GF 342268",
            "priority": "P2",
            "created_at": "07/05/2026 17:52:53",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 17:53:57"
          },
          {
            "ticket_id": 17335,
            "ticket_number": "3517323",
            "title": "Referencia para pagamento | File:440740/2026",
            "priority": "P1",
            "created_at": "07/05/2026 21:59:19",
            "close_date": "2026-05-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 67.13,
            "sla_met": false,
            "sla_breach_hours": 66.88,
            "sla_name": "SLA P1",
            "first_response_at": "10/05/2026 17:07:54"
          },
          {
            "ticket_id": 17339,
            "ticket_number": "3517327",
            "title": "Antecipação emissão bilhetes Ilha do Sal G HS 3389",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:25",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 13.35,
            "sla_met": false,
            "sla_breach_hours": 9.35,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 11:20:46"
          },
          {
            "ticket_id": 17341,
            "ticket_number": "3517329",
            "title": "Antecipação emissão bilhetes Ilha do Sal G HS 3419",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:31",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 21:59:31"
          },
          {
            "ticket_id": 17344,
            "ticket_number": "3517332",
            "title": "Antecipação emissão bilhetes Ilha do Sal GF 339901",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:35",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 16.85,
            "sla_met": false,
            "sla_breach_hours": 12.85,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 14:50:56"
          },
          {
            "ticket_id": 17348,
            "ticket_number": "3517336",
            "title": "Antecipação emissão bilhetes Senegal GF 341619",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:41",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 17.42,
            "sla_met": false,
            "sla_breach_hours": 13.42,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:25:12"
          },
          {
            "ticket_id": 17352,
            "ticket_number": "3517340",
            "title": "Antecipação emissão bilhetes Ilha da Boavista GF 3",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 17.5,
            "sla_met": false,
            "sla_breach_hours": 13.5,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:30:36"
          },
          {
            "ticket_id": 17359,
            "ticket_number": "3517347",
            "title": "Antecipação emissão bilhetes Ilha do Sal GF 344422",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:59",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 17.68,
            "sla_met": false,
            "sla_breach_hours": 13.68,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:41:08"
          },
          {
            "ticket_id": 17365,
            "ticket_number": "3517353",
            "title": "Antecipação emissão bilhetes Porto Santo GF 341139",
            "priority": "P2",
            "created_at": "07/05/2026 22:00:09",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 22:00:12"
          },
          {
            "ticket_id": 17366,
            "ticket_number": "3517354",
            "title": "Antecipação emissão bilhetes Ilha do Sal G LS 3379",
            "priority": "P2",
            "created_at": "07/05/2026 22:00:10",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 22:00:10"
          },
          {
            "ticket_id": 17371,
            "ticket_number": "3517359",
            "title": "Fatura TRP-2026-04786",
            "priority": "P2",
            "created_at": "08/05/2026 09:03:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 09:03:06"
          },
          {
            "ticket_id": 17430,
            "ticket_number": "3517418",
            "title": "[Suporte] TRP-2026-04410 - Faturação",
            "priority": "P2",
            "created_at": "08/05/2026 18:30:38",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 18:30:38"
          },
          {
            "ticket_id": 17454,
            "ticket_number": "3517442",
            "title": "GBN-105472 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "09/05/2026 09:03:13",
            "close_date": "2026-05-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 55.85,
            "sla_met": false,
            "sla_breach_hours": 55.6,
            "sla_name": "SLA P1",
            "first_response_at": "11/05/2026 16:55:00"
          },
          {
            "ticket_id": 17456,
            "ticket_number": "3517444",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P1",
            "created_at": "09/05/2026 09:03:17",
            "close_date": "2026-05-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 32.17,
            "sla_met": false,
            "sla_breach_hours": 31.92,
            "sla_name": "SLA P1",
            "first_response_at": "10/05/2026 17:13:58"
          },
          {
            "ticket_id": 17461,
            "ticket_number": "3517449",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60463",
            "priority": "P1",
            "created_at": "09/05/2026 09:03:26",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 73.6,
            "sla_met": false,
            "sla_breach_hours": 73.35,
            "sla_name": "SLA P1",
            "first_response_at": "12/05/2026 10:39:39"
          },
          {
            "ticket_id": 17513,
            "ticket_number": "3517501",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP148217, Sr/a ",
            "priority": "P1",
            "created_at": "11/05/2026 09:03:31",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 59.57,
            "sla_met": false,
            "sla_breach_hours": 59.32,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 20:37:42"
          },
          {
            "ticket_id": 17518,
            "ticket_number": "3517506",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "11/05/2026 09:03:52",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:02:46"
          },
          {
            "ticket_id": 17559,
            "ticket_number": "3517547",
            "title": "Referencia para pagamento | File:440943/2026",
            "priority": "P1",
            "created_at": "11/05/2026 09:12:14",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 25.4,
            "sla_met": false,
            "sla_breach_hours": 25.15,
            "sla_name": "SLA P1",
            "first_response_at": "12/05/2026 10:36:58"
          },
          {
            "ticket_id": 17563,
            "ticket_number": "3517551",
            "title": "Referencia para pagamento | File:435734/2026",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:22",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:02:46"
          },
          {
            "ticket_id": 17565,
            "ticket_number": "3517553",
            "title": "Referencia para pagamento | File:440949/2026",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:25",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:02:46"
          },
          {
            "ticket_id": 17566,
            "ticket_number": "3517554",
            "title": "Referencia para pagamento | File:440950/2026",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:26",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:02:46"
          },
          {
            "ticket_id": 17574,
            "ticket_number": "3517562",
            "title": "ARSP-33145: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/05/2026 09:40:37",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 28.62,
            "sla_met": false,
            "sla_breach_hours": 24.62,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:18:09"
          },
          {
            "ticket_id": 17575,
            "ticket_number": "3517563",
            "title": "ARSP-31967: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/05/2026 09:40:39",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 102.33,
            "sla_met": false,
            "sla_breach_hours": 98.33,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 16:00:58"
          },
          {
            "ticket_id": 17577,
            "ticket_number": "3517565",
            "title": "***MUY URGENTE PAGO HOY***LOC.604630953(TRAVELPLAN",
            "priority": "P1",
            "created_at": "11/05/2026 09:40:43",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 8.48,
            "sla_met": false,
            "sla_breach_hours": 8.23,
            "sla_name": "SLA P1",
            "first_response_at": "11/05/2026 18:09:50"
          },
          {
            "ticket_id": 17583,
            "ticket_number": "3517571",
            "title": "ARSP-31952: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/05/2026 10:03:47",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:02:50"
          },
          {
            "ticket_id": 17585,
            "ticket_number": "3517573",
            "title": "ARSP-31967: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "11/05/2026 10:04:11",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:02:50"
          },
          {
            "ticket_id": 17588,
            "ticket_number": "3517576",
            "title": "Lembrete de reserva pré-paga : 6143223",
            "priority": "P2",
            "created_at": "11/05/2026 10:51:50",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:42:54"
          },
          {
            "ticket_id": 17589,
            "ticket_number": "3517577",
            "title": "Lembrete de reserva pré-paga : 6135846",
            "priority": "P2",
            "created_at": "11/05/2026 10:51:52",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:42:54"
          },
          {
            "ticket_id": 17590,
            "ticket_number": "3517578",
            "title": "Lembrete de reserva pré-paga : 6144884",
            "priority": "P3",
            "created_at": "11/05/2026 10:51:53",
            "close_date": "2026-05-13",
            "sla_target_hours": 24,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/05/2026 14:42:54"
          },
          {
            "ticket_id": 17631,
            "ticket_number": "3517619",
            "title": "Lembrete de reserva pré-paga : 6145946",
            "priority": "P2",
            "created_at": "11/05/2026 15:48:11",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:43:30"
          },
          {
            "ticket_id": 17635,
            "ticket_number": "3517623",
            "title": "Confirmação de reserva 345373",
            "priority": "P1",
            "created_at": "11/05/2026 16:37:20",
            "close_date": "2026-05-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/05/2026 16:46:47"
          },
          {
            "ticket_id": 17671,
            "ticket_number": "3517659",
            "title": "In Sure Broker alerta-o para documentos a pagament",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:42",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 18.83,
            "sla_met": false,
            "sla_breach_hours": 14.83,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:08:36"
          },
          {
            "ticket_id": 17673,
            "ticket_number": "3517661",
            "title": "Aviso de pagamento",
            "priority": "P2",
            "created_at": "11/05/2026 19:17:47",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 18.83,
            "sla_met": false,
            "sla_breach_hours": 14.83,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:08:45"
          },
          {
            "ticket_id": 17689,
            "ticket_number": "3517677",
            "title": "Referencia para pagamento | File:414136/2025",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:46",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 21.4,
            "sla_met": false,
            "sla_breach_hours": 17.4,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 19:07:19"
          },
          {
            "ticket_id": 17690,
            "ticket_number": "3517678",
            "title": "Referencia para pagamento | File:441046/2026",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:47",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 21.38,
            "sla_met": false,
            "sla_breach_hours": 17.38,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 19:06:22"
          },
          {
            "ticket_id": 17699,
            "ticket_number": "3517687",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P2",
            "created_at": "12/05/2026 09:02:42",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 5.03,
            "sla_met": false,
            "sla_breach_hours": 1.03,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:04:56"
          },
          {
            "ticket_id": 17700,
            "ticket_number": "3517688",
            "title": "2. Aviso - Reservas a ser pré-pagas nos próximos 6",
            "priority": "P2",
            "created_at": "12/05/2026 09:02:43",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 5.02,
            "sla_met": false,
            "sla_breach_hours": 1.02,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 14:03:48"
          },
          {
            "ticket_id": 17737,
            "ticket_number": "3517725",
            "title": "GBN-115022 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "12/05/2026 13:19:30",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 31.28,
            "sla_met": false,
            "sla_breach_hours": 27.28,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:36:36"
          },
          {
            "ticket_id": 17738,
            "ticket_number": "3517726",
            "title": "GBN-104400 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "12/05/2026 13:19:33",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:39:25"
          },
          {
            "ticket_id": 17786,
            "ticket_number": "3517774",
            "title": "Fwd: Envio de Fatura - 1.1.7986 | Solução Perfeita",
            "priority": "P2",
            "created_at": "12/05/2026 16:04:34",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:04:34"
          },
          {
            "ticket_id": 17844,
            "ticket_number": "3517832",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP148217, Sr/a ",
            "priority": "P1",
            "created_at": "12/05/2026 22:25:01",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 21.4,
            "sla_met": false,
            "sla_breach_hours": 21.15,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 19:49:36"
          },
          {
            "ticket_id": 17853,
            "ticket_number": "3517841",
            "title": "ARSP-33023: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 09:24:57",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 10:33:55"
          },
          {
            "ticket_id": 17856,
            "ticket_number": "3517844",
            "title": "ARSP-32512: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 09:25:05",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:22:08"
          },
          {
            "ticket_id": 17868,
            "ticket_number": "3517856",
            "title": "ARSP-33392: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 09:36:53",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 13:22:09"
          },
          {
            "ticket_id": 17869,
            "ticket_number": "3517857",
            "title": "ARSP-33408: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:23",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.22,
            "sla_met": false,
            "sla_breach_hours": 215.22,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:15:05"
          },
          {
            "ticket_id": 17870,
            "ticket_number": "3517858",
            "title": "ARSP-33397: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:25",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.22,
            "sla_met": false,
            "sla_breach_hours": 215.22,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:14:32"
          },
          {
            "ticket_id": 17871,
            "ticket_number": "3517859",
            "title": "ARSP-33403: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:27",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.2,
            "sla_met": false,
            "sla_breach_hours": 215.2,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:13:52"
          },
          {
            "ticket_id": 17872,
            "ticket_number": "3517860",
            "title": "ARSP-29676: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:28",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 343.72,
            "sla_met": false,
            "sla_breach_hours": 339.72,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:44:54"
          },
          {
            "ticket_id": 17873,
            "ticket_number": "3517861",
            "title": "ARSP-33404: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:31",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.03,
            "sla_met": false,
            "sla_breach_hours": 215.03,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:03:46"
          },
          {
            "ticket_id": 17874,
            "ticket_number": "3517862",
            "title": "ARSP-32512: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:33",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.02,
            "sla_met": false,
            "sla_breach_hours": 215.02,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:02:34"
          },
          {
            "ticket_id": 17875,
            "ticket_number": "3517863",
            "title": "ARSP-33023: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:34",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 219.0,
            "sla_met": false,
            "sla_breach_hours": 215.0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:02:03"
          },
          {
            "ticket_id": 17876,
            "ticket_number": "3517864",
            "title": "ARSP-32171: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 10:01:36",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 218.98,
            "sla_met": false,
            "sla_breach_hours": 214.98,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:00:49"
          },
          {
            "ticket_id": 17910,
            "ticket_number": "3517898",
            "title": "ARSP-32984: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 13:15:42",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:02:34"
          },
          {
            "ticket_id": 17917,
            "ticket_number": "3517905",
            "title": "ARSP-29943: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 282.9,
            "sla_met": false,
            "sla_breach_hours": 278.9,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:01:07"
          },
          {
            "ticket_id": 17918,
            "ticket_number": "3517906",
            "title": "ARSP-32506: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:26",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.68,
            "sla_met": false,
            "sla_breach_hours": 1.68,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:47:45"
          },
          {
            "ticket_id": 17919,
            "ticket_number": "3517907",
            "title": "ARSP-33441: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "13/05/2026 15:06:28",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.65,
            "sla_met": false,
            "sla_breach_hours": 5.4,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 20:46:06"
          },
          {
            "ticket_id": 17920,
            "ticket_number": "3517908",
            "title": "ARSP-32164: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:31",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.62,
            "sla_met": false,
            "sla_breach_hours": 1.62,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:44:25"
          },
          {
            "ticket_id": 17921,
            "ticket_number": "3517909",
            "title": "ARSP-32153: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:33",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.62,
            "sla_met": false,
            "sla_breach_hours": 1.62,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:43:49"
          },
          {
            "ticket_id": 17923,
            "ticket_number": "3517911",
            "title": "ARSP-32984: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "13/05/2026 15:06:39",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 5.58,
            "sla_met": false,
            "sla_breach_hours": 1.58,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:42:17"
          },
          {
            "ticket_id": 17933,
            "ticket_number": "3517921",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "13/05/2026 15:45:02",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 3.87,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 19:52:07"
          },
          {
            "ticket_id": 17934,
            "ticket_number": "3517922",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "13/05/2026 15:45:03",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.15,
            "sla_met": false,
            "sla_breach_hours": 3.9,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 19:54:50"
          },
          {
            "ticket_id": 17935,
            "ticket_number": "3517923",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "13/05/2026 15:45:05",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.23,
            "sla_met": false,
            "sla_breach_hours": 3.98,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 19:59:55"
          },
          {
            "ticket_id": 17936,
            "ticket_number": "3517924",
            "title": "Envio Fatura",
            "priority": "P1",
            "created_at": "13/05/2026 15:45:06",
            "close_date": "2026-05-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.25,
            "sla_met": false,
            "sla_breach_hours": 4.0,
            "sla_name": "SLA P1",
            "first_response_at": "13/05/2026 20:00:19"
          },
          {
            "ticket_id": 17965,
            "ticket_number": "3517953",
            "title": "Re: Faturação de viagem - TRP-2026-04314",
            "priority": "P2",
            "created_at": "13/05/2026 18:38:19",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 18:38:19"
          },
          {
            "ticket_id": 17997,
            "ticket_number": "3517985",
            "title": "ARSP-33408: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "14/05/2026 10:12:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 17999,
            "ticket_number": "3517987",
            "title": "ARSP-33392: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:01",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18001,
            "ticket_number": "3517989",
            "title": "ARSP-33403: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:07",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18006,
            "ticket_number": "3517994",
            "title": "ARSP-33397: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:19",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18016,
            "ticket_number": "3518004",
            "title": "Lembrete de reserva pré-paga : 6145946",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:59",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18025,
            "ticket_number": "3518013",
            "title": "2. Aviso - Reservas a ser pré-pagas nos próximos 6",
            "priority": "P2",
            "created_at": "14/05/2026 10:15:11",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18055,
            "ticket_number": "3518043",
            "title": "[Suporte] TRP-2026-03136 - Fatura em falta",
            "priority": "P2",
            "created_at": "14/05/2026 13:37:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 13:37:55"
          },
          {
            "ticket_id": 18131,
            "ticket_number": "3518119",
            "title": "Lembrete de reserva pré-paga : 6145946",
            "priority": "P2",
            "created_at": "15/05/2026 11:04:36",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:01:16"
          },
          {
            "ticket_id": 18140,
            "ticket_number": "3518128",
            "title": "Pedido de Pagamento Final de Reserva 213950",
            "priority": "P1",
            "created_at": "15/05/2026 11:59:34",
            "close_date": "2026-05-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 73.28,
            "sla_met": false,
            "sla_breach_hours": 73.03,
            "sla_name": "SLA P1",
            "first_response_at": "18/05/2026 13:17:07"
          },
          {
            "ticket_id": 18146,
            "ticket_number": "3518134",
            "title": "Información de reservas que entran en gastos próxi",
            "priority": "P2",
            "created_at": "15/05/2026 12:00:24",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 15:54:15"
          },
          {
            "ticket_id": 18157,
            "ticket_number": "3518145",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "15/05/2026 16:08:59",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 2.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 18:58:30"
          },
          {
            "ticket_id": 18178,
            "ticket_number": "3518166",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "15/05/2026 17:28:14",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 18:59:50"
          },
          {
            "ticket_id": 18179,
            "ticket_number": "3518167",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "15/05/2026 17:28:16",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 19:03:47"
          },
          {
            "ticket_id": 18197,
            "ticket_number": "3518185",
            "title": "Faturas Pendentes: FA 2147913382",
            "priority": "P1",
            "created_at": "15/05/2026 19:22:27",
            "close_date": "2026-05-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.58,
            "sla_met": false,
            "sla_breach_hours": 0.33,
            "sla_name": "SLA P1",
            "first_response_at": "15/05/2026 19:58:11"
          },
          {
            "ticket_id": 18217,
            "ticket_number": "3518205",
            "title": "Fwd: RE: [Cockpit] Viagem TRP-2026-04031 - Senegal",
            "priority": "P2",
            "created_at": "16/05/2026 08:50:22",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 15:17:16"
          },
          {
            "ticket_id": 18242,
            "ticket_number": "3518230",
            "title": "[Suporte] TRP-2026-03478 - Faturação em falta 01/0",
            "priority": "P2",
            "created_at": "16/05/2026 18:54:00",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 18:54:00"
          },
          {
            "ticket_id": 18243,
            "ticket_number": "3518231",
            "title": "[Suporte] TRP-2026-03473 / TRL-2026-05306 - Fatura",
            "priority": "P2",
            "created_at": "16/05/2026 18:54:22",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 18:54:23"
          },
          {
            "ticket_id": 18244,
            "ticket_number": "3518232",
            "title": "[Suporte] TRP-2026-04044 / TRL-2026-06104 - Fatura",
            "priority": "P2",
            "created_at": "16/05/2026 23:24:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 23:24:51"
          },
          {
            "ticket_id": 18245,
            "ticket_number": "3518233",
            "title": "[Suporte] TRP-2026-03323 / TRL-2026-05113 - Fatura",
            "priority": "P2",
            "created_at": "16/05/2026 23:35:58",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 23:35:58"
          },
          {
            "ticket_id": 18252,
            "ticket_number": "3518240",
            "title": "GBN-119016 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:27",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:31:47"
          },
          {
            "ticket_id": 18255,
            "ticket_number": "3518243",
            "title": "GBN-90051 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:32",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:32:14"
          },
          {
            "ticket_id": 18257,
            "ticket_number": "3518245",
            "title": "GBN-114986 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:36",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:31:55"
          },
          {
            "ticket_id": 18258,
            "ticket_number": "3518246",
            "title": "GBN-116838 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:38",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:32:24"
          },
          {
            "ticket_id": 18260,
            "ticket_number": "3518248",
            "title": "GBN-108215 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:42",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.2,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:32:03"
          },
          {
            "ticket_id": 18262,
            "ticket_number": "3518250",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60451",
            "priority": "P1",
            "created_at": "18/05/2026 09:19:46",
            "close_date": "2026-05-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.45,
            "sla_met": false,
            "sla_breach_hours": 24.2,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 09:47:33"
          },
          {
            "ticket_id": 18266,
            "ticket_number": "3518254",
            "title": "Referencia para pagamento | File:414491/2025",
            "priority": "P2",
            "created_at": "18/05/2026 09:19:57",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 24.45,
            "sla_met": false,
            "sla_breach_hours": 20.45,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:47:43"
          },
          {
            "ticket_id": 18282,
            "ticket_number": "3518270",
            "title": "GBN-116838 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.27,
            "sla_met": false,
            "sla_breach_hours": 0.27,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:37:03"
          },
          {
            "ticket_id": 18285,
            "ticket_number": "3518273",
            "title": "GBN-119016 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:08",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.27,
            "sla_met": false,
            "sla_breach_hours": 0.27,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:37:12"
          },
          {
            "ticket_id": 18288,
            "ticket_number": "3518276",
            "title": "GBN-108610 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "18/05/2026 09:21:13",
            "close_date": "2026-05-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.28,
            "sla_met": false,
            "sla_breach_hours": 4.03,
            "sla_name": "SLA P1",
            "first_response_at": "18/05/2026 13:38:25"
          },
          {
            "ticket_id": 18298,
            "ticket_number": "3518286",
            "title": "1. Aviso - Reservas a ser pré-pagas nos próximos 9",
            "priority": "P2",
            "created_at": "18/05/2026 09:21:53",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:21:17"
          },
          {
            "ticket_id": 18328,
            "ticket_number": "3518316",
            "title": "Lembrete de reserva pré-paga : 6145946",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:20",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 23.53,
            "sla_met": false,
            "sla_breach_hours": 19.53,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:48:01"
          },
          {
            "ticket_id": 18330,
            "ticket_number": "3518318",
            "title": "ARSP-33645: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:31",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:44:43"
          },
          {
            "ticket_id": 18333,
            "ticket_number": "3518321",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "18/05/2026 10:15:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 13:16:49"
          },
          {
            "ticket_id": 18350,
            "ticket_number": "3518338",
            "title": "Faturas TRP-2026-  0363",
            "priority": "P2",
            "created_at": "18/05/2026 11:50:12",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:50:13"
          },
          {
            "ticket_id": 18351,
            "ticket_number": "3518339",
            "title": "Faturas TRP-2026-05081",
            "priority": "P2",
            "created_at": "18/05/2026 11:51:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:51:40"
          },
          {
            "ticket_id": 18363,
            "ticket_number": "3518351",
            "title": "Faturação de Pagamento - TRP-2026-03229",
            "priority": "P2",
            "created_at": "18/05/2026 15:57:53",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 18:34:43"
          },
          {
            "ticket_id": 18365,
            "ticket_number": "3518353",
            "title": "Uma Família em Viagem 604546339 Conforme 06/06/202",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:03",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 17.95,
            "sla_met": false,
            "sla_breach_hours": 13.95,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:55:58"
          },
          {
            "ticket_id": 18412,
            "ticket_number": "3518400",
            "title": "Referencia para pagamento | File:440322/2026",
            "priority": "P2",
            "created_at": "18/05/2026 21:45:00",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 24.0,
            "sla_met": false,
            "sla_breach_hours": 20.0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 21:46:00"
          },
          {
            "ticket_id": 18424,
            "ticket_number": "3518412",
            "title": "GBN-115681 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:42",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:59:19"
          },
          {
            "ticket_id": 18425,
            "ticket_number": "3518413",
            "title": "GBN-110433 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:48",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:59:29"
          },
          {
            "ticket_id": 18426,
            "ticket_number": "3518414",
            "title": "GBN-108215 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:53",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 09:59:39"
          },
          {
            "ticket_id": 18427,
            "ticket_number": "3518415",
            "title": "Confirmação de reserva – Ref PP461802, Sr. António",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:55",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 10:02:36"
          },
          {
            "ticket_id": 18429,
            "ticket_number": "3518417",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:59",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 10:03:23"
          },
          {
            "ticket_id": 18430,
            "ticket_number": "3518418",
            "title": "2. Aviso - Reservas a ser pré-pagas nos próximos 6",
            "priority": "P2",
            "created_at": "19/05/2026 09:00:01",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 10:04:20"
          },
          {
            "ticket_id": 18436,
            "ticket_number": "3518424",
            "title": "Lembrete de reserva pré-paga : 6137918",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:30",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18437,
            "ticket_number": "3518425",
            "title": "Lembrete de reserva pré-paga : 6123918",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:32",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18438,
            "ticket_number": "3518426",
            "title": "Lembrete de reserva pré-paga : 6131017",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:34",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18439,
            "ticket_number": "3518427",
            "title": "Lembrete de reserva pré-paga : 6131019",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:36",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18440,
            "ticket_number": "3518428",
            "title": "Lembrete de reserva pré-paga : 6131022",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:38",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18441,
            "ticket_number": "3518429",
            "title": "Lembrete de reserva pré-paga : 6131346",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18443,
            "ticket_number": "3518431",
            "title": "Lembrete de reserva pré-paga : 6137228",
            "priority": "P2",
            "created_at": "19/05/2026 10:13:46",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:04:08"
          },
          {
            "ticket_id": 18444,
            "ticket_number": "3518432",
            "title": "RE: Comp pagamento 604591378",
            "priority": "P1",
            "created_at": "19/05/2026 10:13:58",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 6.32,
            "sla_met": false,
            "sla_breach_hours": 6.07,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 16:33:40"
          },
          {
            "ticket_id": 18510,
            "ticket_number": "3518498",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "19/05/2026 17:47:15",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 21:40:04"
          },
          {
            "ticket_id": 18545,
            "ticket_number": "3518533",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP140796, Sr/a ",
            "priority": "P2",
            "created_at": "20/05/2026 09:01:49",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18550,
            "ticket_number": "3518538",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60461",
            "priority": "P2",
            "created_at": "20/05/2026 09:02:00",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18555,
            "ticket_number": "3518543",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P2",
            "created_at": "20/05/2026 09:02:10",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:01:34"
          },
          {
            "ticket_id": 18565,
            "ticket_number": "3518553",
            "title": "Uma Família em Viagem 604553839 Conforme 08/06/202",
            "priority": "P2",
            "created_at": "20/05/2026 09:45:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:41:49"
          },
          {
            "ticket_id": 18567,
            "ticket_number": "3518555",
            "title": "[Opentours] Enlaces para pagar los localizadores",
            "priority": "P2",
            "created_at": "20/05/2026 09:45:45",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:41:49"
          },
          {
            "ticket_id": 18576,
            "ticket_number": "3518564",
            "title": "ARSP-33889: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:42",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:41:49"
          },
          {
            "ticket_id": 18578,
            "ticket_number": "3518566",
            "title": "ARSP-33917: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "20/05/2026 09:53:45",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 13:41:49"
          },
          {
            "ticket_id": 18582,
            "ticket_number": "3518570",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "20/05/2026 10:30:50",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 14:21:56"
          },
          {
            "ticket_id": 18617,
            "ticket_number": "3518605",
            "title": "Confirmacao 345763",
            "priority": "P1",
            "created_at": "20/05/2026 15:08:40",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/05/2026 15:09:36"
          },
          {
            "ticket_id": 18647,
            "ticket_number": "3518635",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:23:00"
          },
          {
            "ticket_id": 18648,
            "ticket_number": "3518636",
            "title": "Confirmação e Sinalização de Reserva 216014",
            "priority": "P2",
            "created_at": "20/05/2026 17:35:38",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 21:23:00"
          },
          {
            "ticket_id": 18690,
            "ticket_number": "3518678",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60454",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:46",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:44:24"
          },
          {
            "ticket_id": 18694,
            "ticket_number": "3518682",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P2",
            "created_at": "21/05/2026 09:02:57",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:51:00"
          },
          {
            "ticket_id": 18696,
            "ticket_number": "3518684",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P2",
            "created_at": "21/05/2026 09:03:00",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:46:06"
          },
          {
            "ticket_id": 18702,
            "ticket_number": "3518690",
            "title": "Confirmação n. 222810",
            "priority": "P2",
            "created_at": "21/05/2026 09:46:26",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:44:18"
          },
          {
            "ticket_id": 18703,
            "ticket_number": "3518691",
            "title": "Confirmação n. 222809",
            "priority": "P2",
            "created_at": "21/05/2026 09:46:28",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:44:18"
          },
          {
            "ticket_id": 18706,
            "ticket_number": "3518694",
            "title": "Lembrete de reserva pré-paga : 6137228",
            "priority": "P2",
            "created_at": "21/05/2026 10:17:59",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:50:34"
          },
          {
            "ticket_id": 18707,
            "ticket_number": "3518695",
            "title": "Lembrete de reserva pré-paga : 6123918",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:01",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:50:10"
          },
          {
            "ticket_id": 18710,
            "ticket_number": "3518698",
            "title": "Lembrete de reserva pré-paga : 6131019",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:49:17"
          },
          {
            "ticket_id": 18712,
            "ticket_number": "3518700",
            "title": "Lembrete de reserva pré-paga : 6131017",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:10",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:48:44"
          },
          {
            "ticket_id": 18713,
            "ticket_number": "3518701",
            "title": "Lembrete de reserva pré-paga : 6131022",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:12",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:48:55"
          },
          {
            "ticket_id": 18715,
            "ticket_number": "3518703",
            "title": "Lembrete de reserva pré-paga : 6137918",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:15",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:46:50"
          },
          {
            "ticket_id": 18716,
            "ticket_number": "3518704",
            "title": "***MUY URGENTE PAGO HOY***LOC.604546362 (LEPLAN)--",
            "priority": "P1",
            "created_at": "21/05/2026 10:30:30",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.13,
            "sla_met": false,
            "sla_breach_hours": 1.88,
            "sla_name": "SLA P1",
            "first_response_at": "21/05/2026 12:39:17"
          },
          {
            "ticket_id": 18720,
            "ticket_number": "3518708",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "21/05/2026 10:48:32",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 14:44:27"
          },
          {
            "ticket_id": 18722,
            "ticket_number": "3518710",
            "title": "Confirmação e Sinalização de Reserva 216429",
            "priority": "P2",
            "created_at": "21/05/2026 11:38:14",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 15:24:28"
          },
          {
            "ticket_id": 18746,
            "ticket_number": "3518734",
            "title": "Solole. Booking 2Q0ZC2OE is close to entering expe",
            "priority": "P1",
            "created_at": "21/05/2026 14:32:30",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/05/2026 14:44:27"
          },
          {
            "ticket_id": 18783,
            "ticket_number": "3518771",
            "title": "Pagamento da reserva – Ref PP461802, Sr. António M",
            "priority": "P2",
            "created_at": "21/05/2026 17:53:54",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:40:10"
          },
          {
            "ticket_id": 18799,
            "ticket_number": "3518787",
            "title": "Pagamento da reserva – Ref PP216713, Sr. Tiago Ema",
            "priority": "P2",
            "created_at": "21/05/2026 18:17:01",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 17.67,
            "sla_met": false,
            "sla_breach_hours": 13.67,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 11:57:55"
          },
          {
            "ticket_id": 18813,
            "ticket_number": "3518801",
            "title": "Referencia para pagamento | File:441946/2026",
            "priority": "P1",
            "created_at": "21/05/2026 21:19:49",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 85.17,
            "sla_met": false,
            "sla_breach_hours": 84.92,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 10:30:04"
          },
          {
            "ticket_id": 18814,
            "ticket_number": "3518802",
            "title": "Referencia para pagamento | File:427582/2026",
            "priority": "P1",
            "created_at": "21/05/2026 21:19:51",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 83.75,
            "sla_met": false,
            "sla_breach_hours": 83.5,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 09:05:50"
          },
          {
            "ticket_id": 18827,
            "ticket_number": "3518815",
            "title": "Reserva Nº 26804929",
            "priority": "P1",
            "created_at": "21/05/2026 21:54:35",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 13.9,
            "sla_met": false,
            "sla_breach_hours": 13.65,
            "sla_name": "SLA P1",
            "first_response_at": "22/05/2026 11:49:21"
          },
          {
            "ticket_id": 18836,
            "ticket_number": "3518824",
            "title": "GBN-110714 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "22/05/2026 09:07:39",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.8,
            "sla_met": false,
            "sla_breach_hours": 2.55,
            "sla_name": "SLA P1",
            "first_response_at": "22/05/2026 11:55:57"
          },
          {
            "ticket_id": 18838,
            "ticket_number": "3518826",
            "title": "GBN-121787 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "22/05/2026 09:07:44",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.75,
            "sla_met": false,
            "sla_breach_hours": 2.5,
            "sla_name": "SLA P1",
            "first_response_at": "22/05/2026 11:53:08"
          },
          {
            "ticket_id": 18849,
            "ticket_number": "3518837",
            "title": "ARSP-32171: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "22/05/2026 09:55:45",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 71.2,
            "sla_met": false,
            "sla_breach_hours": 70.95,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 09:08:37"
          },
          {
            "ticket_id": 18850,
            "ticket_number": "3518838",
            "title": "ARSP-34002: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "22/05/2026 09:55:46",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 71.23,
            "sla_met": false,
            "sla_breach_hours": 70.98,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 09:10:21"
          },
          {
            "ticket_id": 18867,
            "ticket_number": "3518855",
            "title": "***URGENTE PAGO HOY***LOC.604546362 (LEPLAN)----Um",
            "priority": "P1",
            "created_at": "22/05/2026 11:16:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.57,
            "sla_met": false,
            "sla_breach_hours": 3.32,
            "sla_name": "SLA P1",
            "first_response_at": "22/05/2026 14:50:35"
          },
          {
            "ticket_id": 18869,
            "ticket_number": "3518857",
            "title": "Confirmação e Sinalização de Reserva 216460",
            "priority": "P1",
            "created_at": "22/05/2026 11:16:42",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 94.23,
            "sla_met": false,
            "sla_breach_hours": 93.98,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 09:31:14"
          },
          {
            "ticket_id": 18932,
            "ticket_number": "3518920",
            "title": "NOVA RESERVA - SITE SMART PARKING",
            "priority": "P2",
            "created_at": "22/05/2026 21:48:43",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 90.55,
            "sla_met": false,
            "sla_breach_hours": 86.55,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:21:46"
          },
          {
            "ticket_id": 18944,
            "ticket_number": "3518932",
            "title": "Amanhã será realizada a cobrança da reserva A38385",
            "priority": "P1",
            "created_at": "23/05/2026 09:06:58",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 56.7,
            "sla_met": false,
            "sla_breach_hours": 56.45,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 17:49:45"
          },
          {
            "ticket_id": 18960,
            "ticket_number": "3518948",
            "title": "Solole. Booking M1YI16WY is close to entering expe",
            "priority": "P1",
            "created_at": "23/05/2026 15:12:10",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 43.3,
            "sla_met": false,
            "sla_breach_hours": 43.05,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 10:30:33"
          },
          {
            "ticket_id": 18979,
            "ticket_number": "3518967",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:00",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:32"
          },
          {
            "ticket_id": 18980,
            "ticket_number": "3518968",
            "title": "GBN-123311 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:02",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:32"
          },
          {
            "ticket_id": 18984,
            "ticket_number": "3518972",
            "title": "GBN-119865 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:11",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:32"
          },
          {
            "ticket_id": 18985,
            "ticket_number": "3518973",
            "title": "GBN-112845 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:13",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:32"
          },
          {
            "ticket_id": 18986,
            "ticket_number": "3518974",
            "title": "GBN-117249 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:15",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:32"
          },
          {
            "ticket_id": 18987,
            "ticket_number": "3518975",
            "title": "GBN-120717 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:18",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:33"
          },
          {
            "ticket_id": 18990,
            "ticket_number": "3518978",
            "title": "GBN-112057 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:29",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:33"
          },
          {
            "ticket_id": 18994,
            "ticket_number": "3518982",
            "title": "Proforma CnTravel 99124816",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:39",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:33"
          },
          {
            "ticket_id": 19017,
            "ticket_number": "3519005",
            "title": "GBN-112845 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:07",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:34"
          },
          {
            "ticket_id": 19018,
            "ticket_number": "3519006",
            "title": "GBN-119865 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:09",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:34"
          },
          {
            "ticket_id": 19020,
            "ticket_number": "3519008",
            "title": "GBN-112057 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:13",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:34"
          },
          {
            "ticket_id": 19021,
            "ticket_number": "3519009",
            "title": "GBN-123311 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:15",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:34"
          },
          {
            "ticket_id": 19030,
            "ticket_number": "3519018",
            "title": "Referencia para pagamento | File:432293/2026",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:51",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 13:01:34"
          },
          {
            "ticket_id": 19035,
            "ticket_number": "3519023",
            "title": "Solole. Booking M1YI16WY is close to entering expe",
            "priority": "P1",
            "created_at": "25/05/2026 10:06:46",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 10:21:14"
          },
          {
            "ticket_id": 19055,
            "ticket_number": "3519043",
            "title": "Uma Família em Viagem 604553839 Conforme 08/06/202",
            "priority": "P2",
            "created_at": "25/05/2026 11:26:02",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:21:56"
          },
          {
            "ticket_id": 19060,
            "ticket_number": "3519048",
            "title": "Confirmação de reserva – Ref PP911821, Sr. Luis Pe",
            "priority": "P3",
            "created_at": "25/05/2026 12:21:17",
            "close_date": "2026-05-25",
            "sla_target_hours": 24,
            "actual_time_hours": 5.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/05/2026 17:39:55"
          },
          {
            "ticket_id": 19062,
            "ticket_number": "3519050",
            "title": "FW: Fatura - TRP-2026-05199",
            "priority": "P1",
            "created_at": "25/05/2026 12:23:47",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 12:23:48"
          },
          {
            "ticket_id": 19075,
            "ticket_number": "3519063",
            "title": "Solole. Booking M1YI16WY is close to entering expe",
            "priority": "P1",
            "created_at": "25/05/2026 14:44:36",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.75,
            "sla_met": false,
            "sla_breach_hours": 2.5,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 17:30:18"
          },
          {
            "ticket_id": 19153,
            "ticket_number": "3519141",
            "title": "Referencia para pagamento | File:437731/2026",
            "priority": "P2",
            "created_at": "25/05/2026 22:55:26",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:43:46"
          },
          {
            "ticket_id": 19156,
            "ticket_number": "3519144",
            "title": "Referencia para pagamento | File:442209/2026",
            "priority": "P2",
            "created_at": "25/05/2026 22:55:37",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.8,
            "sla_met": false,
            "sla_breach_hours": 9.8,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:43:46"
          },
          {
            "ticket_id": 19161,
            "ticket_number": "3519149",
            "title": "GBN-122514 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:00",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 7.63,
            "sla_met": false,
            "sla_breach_hours": 3.63,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:38:57"
          },
          {
            "ticket_id": 19162,
            "ticket_number": "3519150",
            "title": "***PAGO RESERVAS*** GREGAL",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:02",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 7.63,
            "sla_met": false,
            "sla_breach_hours": 3.63,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:38:40"
          },
          {
            "ticket_id": 19163,
            "ticket_number": "3519151",
            "title": "RESERVA PENDENTE DE PAGAMENTO Ref. PP196221, Sr/a ",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:05",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 7.48,
            "sla_met": false,
            "sla_breach_hours": 3.48,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:29:59"
          },
          {
            "ticket_id": 19164,
            "ticket_number": "3519152",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:09",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 32.58,
            "sla_met": false,
            "sla_breach_hours": 28.58,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:36:08"
          },
          {
            "ticket_id": 19167,
            "ticket_number": "3519155",
            "title": "GBN-120717 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:16",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 7.4,
            "sla_met": false,
            "sla_breach_hours": 3.4,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:24:19"
          },
          {
            "ticket_id": 19171,
            "ticket_number": "3519159",
            "title": "GBN-117249 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:25",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 7.38,
            "sla_met": false,
            "sla_breach_hours": 3.38,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:24:05"
          },
          {
            "ticket_id": 19187,
            "ticket_number": "3519175",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60447",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:39",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:03:56"
          },
          {
            "ticket_id": 19196,
            "ticket_number": "3519184",
            "title": "Envio Fatura -",
            "priority": "P1",
            "created_at": "26/05/2026 11:32:08",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/05/2026 11:32:17"
          },
          {
            "ticket_id": 19329,
            "ticket_number": "3519317",
            "title": "Referencia para pagamento | File:424637/2026",
            "priority": "P2",
            "created_at": "26/05/2026 21:08:35",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.87,
            "sla_met": false,
            "sla_breach_hours": 9.87,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:00:53"
          },
          {
            "ticket_id": 19334,
            "ticket_number": "3519322",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:31",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:01:11"
          },
          {
            "ticket_id": 19337,
            "ticket_number": "3519325",
            "title": "Lembrete de reserva pré-paga : 6146924",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:36",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:01:11"
          },
          {
            "ticket_id": 19338,
            "ticket_number": "3519326",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:38",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:01:11"
          },
          {
            "ticket_id": 19339,
            "ticket_number": "3519327",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60450",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:43",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:01:11"
          },
          {
            "ticket_id": 19341,
            "ticket_number": "3519329",
            "title": "GBN-108887 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:47",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 13:01:11"
          },
          {
            "ticket_id": 19373,
            "ticket_number": "3519361",
            "title": "Envio Fatura -",
            "priority": "P1",
            "created_at": "27/05/2026 11:22:34",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 7.52,
            "sla_met": false,
            "sla_breach_hours": 7.27,
            "sla_name": "SLA P1",
            "first_response_at": "27/05/2026 18:53:48"
          },
          {
            "ticket_id": 19383,
            "ticket_number": "3519371",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:46",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 16:01:37"
          },
          {
            "ticket_id": 19406,
            "ticket_number": "3519394",
            "title": "ARSP-34396: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/05/2026 14:28:07",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 14:41:28"
          },
          {
            "ticket_id": 19408,
            "ticket_number": "3519396",
            "title": "ARSP-34407: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "27/05/2026 14:28:09",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:22:25"
          },
          {
            "ticket_id": 19466,
            "ticket_number": "3519454",
            "title": "Referencia para pagamento | File:442342/2026",
            "priority": "P2",
            "created_at": "27/05/2026 21:31:14",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.85,
            "sla_met": false,
            "sla_breach_hours": 9.85,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:23:08"
          },
          {
            "ticket_id": 19473,
            "ticket_number": "3519461",
            "title": "Flexible Autos - Reserva com pagamento pendente Re",
            "priority": "P1",
            "created_at": "28/05/2026 09:08:19",
            "close_date": "2026-05-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.45,
            "sla_met": false,
            "sla_breach_hours": 5.2,
            "sla_name": "SLA P1",
            "first_response_at": "28/05/2026 14:35:21"
          },
          {
            "ticket_id": 19474,
            "ticket_number": "3519462",
            "title": "GBN-108887 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:21",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:03:25"
          },
          {
            "ticket_id": 19475,
            "ticket_number": "3519463",
            "title": "GBN-108888 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:24",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:03:25"
          },
          {
            "ticket_id": 19482,
            "ticket_number": "3519470",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60464",
            "priority": "P2",
            "created_at": "28/05/2026 09:08:38",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:03:25"
          },
          {
            "ticket_id": 19573,
            "ticket_number": "3519561",
            "title": "Envio Fatura -",
            "priority": "P1",
            "created_at": "28/05/2026 14:42:30",
            "close_date": "2026-05-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "28/05/2026 14:43:29"
          },
          {
            "ticket_id": 19589,
            "ticket_number": "3519577",
            "title": "Pagamento da reserva – Ref PP219523, Sr. Pedro  Ca",
            "priority": "P2",
            "created_at": "28/05/2026 16:17:18",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:13"
          },
          {
            "ticket_id": 19611,
            "ticket_number": "3519599",
            "title": "Referencia para pagamento | File:442483/2026",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:28",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 11:40:03"
          },
          {
            "ticket_id": 19630,
            "ticket_number": "3519618",
            "title": "GBN-108888 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "29/05/2026 10:25:06",
            "close_date": "2026-05-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.47,
            "sla_met": false,
            "sla_breach_hours": 4.22,
            "sla_name": "SLA P1",
            "first_response_at": "29/05/2026 14:53:53"
          },
          {
            "ticket_id": 19633,
            "ticket_number": "3519621",
            "title": "GBN-123169 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:17",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:20:23"
          },
          {
            "ticket_id": 19674,
            "ticket_number": "3519662",
            "title": "URGENTE  - Pedido de pagamento - PT004157",
            "priority": "P1",
            "created_at": "29/05/2026 13:04:22",
            "close_date": "2026-05-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.77,
            "sla_met": false,
            "sla_breach_hours": 1.52,
            "sla_name": "SLA P1",
            "first_response_at": "29/05/2026 14:50:34"
          },
          {
            "ticket_id": 19776,
            "ticket_number": "3519764",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60459",
            "priority": "P2",
            "created_at": "30/05/2026 09:02:22",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 53.83,
            "sla_met": false,
            "sla_breach_hours": 49.83,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 14:53:22"
          },
          {
            "ticket_id": 19817,
            "ticket_number": "3519805",
            "title": "Solole. Booking 94Q95W81 is close to entering expe",
            "priority": "P1",
            "created_at": "30/05/2026 14:08:53",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 48.5,
            "sla_met": false,
            "sla_breach_hours": 48.25,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 14:39:53"
          },
          {
            "ticket_id": 19853,
            "ticket_number": "3519841",
            "title": "GBN-91275 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "01/06/2026 09:04:57",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19855,
            "ticket_number": "3519843",
            "title": "GBN-108909 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:00",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19859,
            "ticket_number": "3519847",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60464",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:09",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19861,
            "ticket_number": "3519849",
            "title": "Solole. Booking 94Q95W81 is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 09:05:13",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.38,
            "sla_met": false,
            "sla_breach_hours": 9.13,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 18:28:26"
          },
          {
            "ticket_id": 19865,
            "ticket_number": "3519853",
            "title": "Referencia para pagamento | File:430984/2026",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19866,
            "ticket_number": "3519854",
            "title": "Referencia para pagamento | File:437147/2026",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:31",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19867,
            "ticket_number": "3519855",
            "title": "Referencia para pagamento | File:431913/2026",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:32",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19870,
            "ticket_number": "3519858",
            "title": "Referencia para pagamento | File:437112/2026",
            "priority": "P2",
            "created_at": "01/06/2026 09:05:53",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:12"
          },
          {
            "ticket_id": 19878,
            "ticket_number": "3519866",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "01/06/2026 09:06:36",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:13"
          },
          {
            "ticket_id": 19886,
            "ticket_number": "3519874",
            "title": "GBN-126406 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:08",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:14"
          },
          {
            "ticket_id": 19887,
            "ticket_number": "3519875",
            "title": "GBN-120662 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:10",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:14"
          },
          {
            "ticket_id": 19888,
            "ticket_number": "3519876",
            "title": "GBN-108909 - Sua reserva está pendente de pagament",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:13",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:15"
          },
          {
            "ticket_id": 19890,
            "ticket_number": "3519878",
            "title": "GBN-91275 - Sua reserva está pendente de pagamento",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:22",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 13:01:15"
          },
          {
            "ticket_id": 19894,
            "ticket_number": "3519882",
            "title": "Solole. Booking 1PVN0DCK is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 09:07:44",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.5,
            "sla_met": false,
            "sla_breach_hours": 5.25,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 14:37:44"
          },
          {
            "ticket_id": 19895,
            "ticket_number": "3519883",
            "title": "Solole. Booking ZKC8POSG is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 09:07:45",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.48,
            "sla_met": false,
            "sla_breach_hours": 5.23,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 14:37:22"
          },
          {
            "ticket_id": 19896,
            "ticket_number": "3519884",
            "title": "Solole. Booking 8X2JGFJ6 is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 09:07:51",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 9.35,
            "sla_met": false,
            "sla_breach_hours": 9.1,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 18:29:06"
          },
          {
            "ticket_id": 19943,
            "ticket_number": "3519931",
            "title": "Solole. Booking 1PVN0DCK is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 15:30:54",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.2,
            "sla_met": false,
            "sla_breach_hours": 23.95,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 15:43:22"
          },
          {
            "ticket_id": 19944,
            "ticket_number": "3519932",
            "title": "Solole. Booking HKCGBYQ9 is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 15:30:56",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.18,
            "sla_met": false,
            "sla_breach_hours": 23.93,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 15:42:55"
          },
          {
            "ticket_id": 19945,
            "ticket_number": "3519933",
            "title": "Solole. Booking 8X2JGFJ6 is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 15:30:57",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.95,
            "sla_met": false,
            "sla_breach_hours": 2.7,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 18:28:52"
          },
          {
            "ticket_id": 19946,
            "ticket_number": "3519934",
            "title": "Solole. Booking ZKC8POSG is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 15:31:00",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 24.18,
            "sla_met": false,
            "sla_breach_hours": 23.93,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 15:42:30"
          },
          {
            "ticket_id": 19947,
            "ticket_number": "3519935",
            "title": "Solole. Booking E307X71Y is close to entering expe",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:02",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:35"
          },
          {
            "ticket_id": 19955,
            "ticket_number": "3519943",
            "title": "Solole. Booking 94Q95W81 is close to entering expe",
            "priority": "P1",
            "created_at": "01/06/2026 15:31:22",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.93,
            "sla_met": false,
            "sla_breach_hours": 2.68,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 18:27:53"
          },
          {
            "ticket_id": 19985,
            "ticket_number": "3519973",
            "title": "Referencia para pagamento | File:442679/2026",
            "priority": "P1",
            "created_at": "01/06/2026 16:39:16",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.8,
            "sla_met": false,
            "sla_breach_hours": 1.55,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 18:28:13"
          },
          {
            "ticket_id": 20044,
            "ticket_number": "3520032",
            "title": "Referencia para pagamento | File:442770/2026",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:08",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:04:07"
          },
          {
            "ticket_id": 20045,
            "ticket_number": "3520033",
            "title": "Referencia para pagamento | File:432995/2026",
            "priority": "P2",
            "created_at": "02/06/2026 09:08:09",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:04:07"
          },
          {
            "ticket_id": 20060,
            "ticket_number": "3520048",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "02/06/2026 09:58:17",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 13:44:20"
          },
          {
            "ticket_id": 20067,
            "ticket_number": "3520055",
            "title": "ARSP-29943: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P1",
            "created_at": "02/06/2026 10:29:52",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 10:43:46"
          },
          {
            "ticket_id": 20074,
            "ticket_number": "3520062",
            "title": "***MUY URGENTE PAGO HOY***LOC.604643749 (LEPLAN)--",
            "priority": "P1",
            "created_at": "02/06/2026 11:08:03",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.3,
            "sla_met": false,
            "sla_breach_hours": 4.05,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 15:26:51"
          },
          {
            "ticket_id": 20077,
            "ticket_number": "3520065",
            "title": "Lembrete de reserva pré-paga : 6139558",
            "priority": "P2",
            "created_at": "02/06/2026 11:24:34",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 15:24:24"
          },
          {
            "ticket_id": 20079,
            "ticket_number": "3520067",
            "title": "Lembrete de reserva pré-paga : 6148850",
            "priority": "P2",
            "created_at": "02/06/2026 11:34:38",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 15:23:16"
          },
          {
            "ticket_id": 20111,
            "ticket_number": "3520099",
            "title": "Solole. Booking 8X2JGFJ6 is close to entering expe",
            "priority": "P1",
            "created_at": "02/06/2026 14:01:13",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.13,
            "sla_met": false,
            "sla_breach_hours": 3.88,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 18:09:58"
          },
          {
            "ticket_id": 20112,
            "ticket_number": "3520100",
            "title": "Solole. Booking ZKC8POSG is close to entering expe",
            "priority": "P1",
            "created_at": "02/06/2026 14:01:16",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.13,
            "sla_met": false,
            "sla_breach_hours": 3.88,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 18:09:37"
          },
          {
            "ticket_id": 20113,
            "ticket_number": "3520101",
            "title": "Solole. Booking E307X71Y is close to entering expe",
            "priority": "P1",
            "created_at": "02/06/2026 14:01:19",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 3.87,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 18:09:16"
          },
          {
            "ticket_id": 20114,
            "ticket_number": "3520102",
            "title": "Solole. Booking 1PVN0DCK is close to entering expe",
            "priority": "P1",
            "created_at": "02/06/2026 14:01:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.12,
            "sla_met": false,
            "sla_breach_hours": 3.87,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 18:08:53"
          },
          {
            "ticket_id": 20115,
            "ticket_number": "3520103",
            "title": "Solole. Booking HKCGBYQ9 is close to entering expe",
            "priority": "P1",
            "created_at": "02/06/2026 14:03:43",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 4.07,
            "sla_met": false,
            "sla_breach_hours": 3.82,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 18:08:29"
          },
          {
            "ticket_id": 20120,
            "ticket_number": "3520108",
            "title": "Fwd: Fatura e Confirmação de Reserva",
            "priority": "P1",
            "created_at": "02/06/2026 15:41:57",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 18.33,
            "sla_met": false,
            "sla_breach_hours": 18.08,
            "sla_name": "SLA P1",
            "first_response_at": "03/06/2026 10:02:31"
          },
          {
            "ticket_id": 20161,
            "ticket_number": "3520149",
            "title": "IBAN",
            "priority": "P1",
            "created_at": "02/06/2026 21:52:20",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/06/2026 21:52:20"
          },
          {
            "ticket_id": 20167,
            "ticket_number": "3520155",
            "title": "Referencia para pagamento | File:424766/2026",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:39",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 13.82,
            "sla_met": false,
            "sla_breach_hours": 9.82,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 11:41:45"
          },
          {
            "ticket_id": 20208,
            "ticket_number": "3520196",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60463",
            "priority": "P2",
            "created_at": "03/06/2026 09:08:02",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 13:01:56"
          },
          {
            "ticket_id": 20209,
            "ticket_number": "3520197",
            "title": "2ª Notificação: Reclamação pagamento Reserva 60460",
            "priority": "P2",
            "created_at": "03/06/2026 09:08:04",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 13:01:56"
          },
          {
            "ticket_id": 20216,
            "ticket_number": "3520204",
            "title": "***PAGO RESERVA 604632825*** GREGAL",
            "priority": "P2",
            "created_at": "03/06/2026 09:57:18",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 6.08,
            "sla_met": false,
            "sla_breach_hours": 2.08,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 16:03:15"
          },
          {
            "ticket_id": 20219,
            "ticket_number": "3520207",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P1",
            "created_at": "03/06/2026 10:01:52",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/06/2026 10:02:51"
          },
          {
            "ticket_id": 20227,
            "ticket_number": "3520215",
            "title": "ARSP-34977: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "03/06/2026 10:18:59",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 5.58,
            "sla_met": false,
            "sla_breach_hours": 1.58,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:54:16"
          },
          {
            "ticket_id": 20236,
            "ticket_number": "3520224",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "03/06/2026 11:22:21",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:22:19"
          },
          {
            "ticket_id": 20238,
            "ticket_number": "3520226",
            "title": "ARSP-34126: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "03/06/2026 11:32:16",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:22:19"
          },
          {
            "ticket_id": 20240,
            "ticket_number": "3520228",
            "title": "ARSP-29676: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "03/06/2026 11:34:13",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:22:19"
          },
          {
            "ticket_id": 20242,
            "ticket_number": "3520230",
            "title": "ARSP-29943: Cliente FAMILIAP - Suc: 001 - ID Reser",
            "priority": "P2",
            "created_at": "03/06/2026 11:34:33",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:22:19"
          },
          {
            "ticket_id": 20249,
            "ticket_number": "3520237",
            "title": "Bedsonline, S.L.U. - Electronic Invoice Delivery",
            "priority": "P2",
            "created_at": "03/06/2026 12:27:58",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 15:41:23"
          },
          {
            "ticket_id": 20272,
            "ticket_number": "3520260",
            "title": "Pedido de Pagamento Final de Reserva 212653",
            "priority": "P2",
            "created_at": "03/06/2026 14:55:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 18:42:46"
          },
          {
            "ticket_id": 20277,
            "ticket_number": "3520265",
            "title": "Pedido de pagamento - PT004157",
            "priority": "P2",
            "created_at": "03/06/2026 16:15:12",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 20:03:02"
          },
          {
            "ticket_id": 20319,
            "ticket_number": "3520307",
            "title": "Referencia para pagamento | File:438860/2026",
            "priority": "P2",
            "created_at": "03/06/2026 21:31:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 37.8,
            "sla_met": false,
            "sla_breach_hours": 33.8,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 11:20:16"
          },
          {
            "ticket_id": 20320,
            "ticket_number": "3520308",
            "title": "Referencia para pagamento | File:442894/2026",
            "priority": "P1",
            "created_at": "03/06/2026 21:31:34",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 42.98,
            "sla_met": false,
            "sla_breach_hours": 42.73,
            "sla_name": "SLA P1",
            "first_response_at": "05/06/2026 16:31:29"
          },
          {
            "ticket_id": 20364,
            "ticket_number": "3520352",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60453",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:36",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:35"
          },
          {
            "ticket_id": 20372,
            "ticket_number": "3520360",
            "title": "Lembrete de pagamentos PENDENTES para reservas que",
            "priority": "P2",
            "created_at": "05/06/2026 09:05:22",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:35"
          },
          {
            "ticket_id": 20374,
            "ticket_number": "3520362",
            "title": "1ª Notificação: Reclamação pagamento Reserva 60449",
            "priority": "P1",
            "created_at": "05/06/2026 09:05:27",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 5.37,
            "sla_met": false,
            "sla_breach_hours": 5.12,
            "sla_name": "SLA P1",
            "first_response_at": "05/06/2026 14:28:10"
          },
          {
            "ticket_id": 20406,
            "ticket_number": "3520394",
            "title": "***PAGO RESERVAS*** GREGAL",
            "priority": "P1",
            "created_at": "05/06/2026 10:00:14",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 71.08,
            "sla_met": false,
            "sla_breach_hours": 70.83,
            "sla_name": "SLA P1",
            "first_response_at": "08/06/2026 09:05:21"
          },
          {
            "ticket_id": 20408,
            "ticket_number": "3520396",
            "title": "***URGENTE PAGO HOY***LOC.604609011 (LEPLAN)----Um",
            "priority": "P1",
            "created_at": "05/06/2026 10:26:36",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.33,
            "sla_met": false,
            "sla_breach_hours": 2.08,
            "sla_name": "SLA P1",
            "first_response_at": "05/06/2026 12:46:59"
          },
          {
            "ticket_id": 20468,
            "ticket_number": "3520456",
            "title": "Confirmação e Sinalização de Reserva 217070",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:28",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 2.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 18:25:27"
          },
          {
            "ticket_id": 20487,
            "ticket_number": "3520475",
            "title": "Envio Fatura -",
            "priority": "P1",
            "created_at": "05/06/2026 17:05:34",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.22,
            "sla_met": false,
            "sla_breach_hours": 0.97,
            "sla_name": "SLA P1",
            "first_response_at": "05/06/2026 18:19:18"
          },
          {
            "ticket_id": 20488,
            "ticket_number": "3520476",
            "title": "Envio Fatura -",
            "priority": "P1",
            "created_at": "05/06/2026 17:05:35",
            "close_date": "2026-06-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.28,
            "sla_met": false,
            "sla_breach_hours": 0.03,
            "sla_name": "SLA P1",
            "first_response_at": "05/06/2026 17:23:22"
          },
          {
            "ticket_id": 20508,
            "ticket_number": "3520496",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "05/06/2026 17:46:45",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:50:01"
          },
          {
            "ticket_id": 20510,
            "ticket_number": "3520498",
            "title": "Envio Fatura -",
            "priority": "P2",
            "created_at": "05/06/2026 17:46:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 17:49:48"
          },
          {
            "ticket_id": 20614,
            "ticket_number": "3520602",
            "title": "Solole. Booking 69MFPC7D is close to entering expe",
            "priority": "P1",
            "created_at": "08/06/2026 09:06:53",
            "close_date": "2026-06-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.43,
            "sla_met": false,
            "sla_breach_hours": 0.18,
            "sla_name": "SLA P1",
            "first_response_at": "08/06/2026 09:33:18"
          },
          {
            "ticket_id": 20622,
            "ticket_number": "3520610",
            "title": "GBN-102498 - Sua reserva está pendente de pagament",
            "priority": "P1",
            "created_at": "08/06/2026 09:07:15",
            "close_date": "2026-06-08",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.45,
            "sla_met": false,
            "sla_breach_hours": 0.2,
            "sla_name": "SLA P1",
            "first_response_at": "08/06/2026 09:35:08"
          }
        ]
      },
      "Carolina Ferreirinha": {
        "total_tickets": 879,
        "sla_met": 836,
        "sla_missed": 43,
        "sla_compliance_rate": 95.11,
        "tickets": [
          {
            "ticket_id": 146,
            "ticket_number": "35145",
            "title": "Fwd: [## 21402 ##] GBN-60285 - Seu pedido foi rece",
            "priority": "P2",
            "created_at": "02/10/2025 11:58:32",
            "close_date": "2025-11-14",
            "sla_target_hours": 4,
            "actual_time_hours": 967.83,
            "sla_met": false,
            "sla_breach_hours": 963.83,
            "sla_name": "SLA P2",
            "first_response_at": "11/11/2025 19:48:39"
          },
          {
            "ticket_id": 1638,
            "ticket_number": "351635",
            "title": "Fwd: Feiras dos Noivos + Almoço de Planeamento",
            "priority": "P2",
            "created_at": "31/10/2025 18:16:15",
            "close_date": "2025-11-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/10/2025 18:16:15"
          },
          {
            "ticket_id": 1935,
            "ticket_number": "351932",
            "title": "Pedido operador LePlan",
            "priority": "P2",
            "created_at": "06/11/2025 12:50:28",
            "close_date": "2025-11-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/11/2025 12:50:28"
          },
          {
            "ticket_id": 1954,
            "ticket_number": "351950",
            "title": "ENGANO Re: Cotação voos tap Lisboa/Recife/Lisboa",
            "priority": "P3",
            "created_at": "06/11/2025 18:10:45",
            "close_date": "2025-11-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 18:10:46"
          },
          {
            "ticket_id": 2329,
            "ticket_number": "352324",
            "title": "Ao cuidado da Carolina / Sandra",
            "priority": "P3",
            "created_at": "12/11/2025 22:20:21",
            "close_date": "2025-11-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 22:20:21"
          },
          {
            "ticket_id": 2582,
            "ticket_number": "352577",
            "title": "contrato prestação de serviços",
            "priority": "P2",
            "created_at": "17/11/2025 10:42:18",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:40:21"
          },
          {
            "ticket_id": 2766,
            "ticket_number": "352761",
            "title": "Pedido de Esclarecimento",
            "priority": "P2",
            "created_at": "19/11/2025 10:07:46",
            "close_date": "2025-11-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 14:03:41"
          },
          {
            "ticket_id": 3185,
            "ticket_number": "353178",
            "title": "Esclarecimento",
            "priority": "P3",
            "created_at": "25/11/2025 15:28:28",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 15:28:29"
          },
          {
            "ticket_id": 3342,
            "ticket_number": "353335",
            "title": "Grupo Solférias - 70 pessoas - átua",
            "priority": "P3",
            "created_at": "27/11/2025 10:42:05",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/11/2025 11:45:03"
          },
          {
            "ticket_id": 3766,
            "ticket_number": "353758",
            "title": "Re: RESERVA 335024",
            "priority": "P2",
            "created_at": "03/12/2025 13:19:48",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 5.63,
            "sla_met": false,
            "sla_breach_hours": 1.63,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 18:58:43"
          },
          {
            "ticket_id": 3776,
            "ticket_number": "353768",
            "title": "RESERVA 335024",
            "priority": "P2",
            "created_at": "03/12/2025 13:22:52",
            "close_date": "2025-12-03",
            "sla_target_hours": 4,
            "actual_time_hours": 5.6,
            "sla_met": false,
            "sla_breach_hours": 1.6,
            "sla_name": "SLA P2",
            "first_response_at": "03/12/2025 18:58:55"
          },
          {
            "ticket_id": 3915,
            "ticket_number": "353907",
            "title": "Pedido de informação",
            "priority": "P3",
            "created_at": "05/12/2025 00:01:32",
            "close_date": "2025-12-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 00:01:32"
          },
          {
            "ticket_id": 2323,
            "ticket_number": "352318",
            "title": "Mês de agosto e setembro prestação serviços",
            "priority": "P2",
            "created_at": "12/11/2025 21:14:52",
            "close_date": "2026-01-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 21:14:53"
          },
          {
            "ticket_id": 2670,
            "ticket_number": "352665",
            "title": "T-shirt UFEV",
            "priority": "P3",
            "created_at": "18/11/2025 10:26:27",
            "close_date": "2026-01-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/11/2025 10:26:27"
          },
          {
            "ticket_id": 2892,
            "ticket_number": "352887",
            "title": "RE: FW: Proposta Evento 4 a 6 de Abril",
            "priority": "P2",
            "created_at": "20/11/2025 17:06:16",
            "close_date": "2026-01-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 21:01:19"
          },
          {
            "ticket_id": 3035,
            "ticket_number": "353030",
            "title": "GBN-91308 - Sua confirmação de reserva",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/11/2025 22:21:49",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 25.93,
            "sla_met": false,
            "sla_breach_hours": 1.93,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:18:06"
          },
          {
            "ticket_id": 3162,
            "ticket_number": "353155",
            "title": "PEDIDO DE INFORMAÇÃO",
            "priority": "P3",
            "created_at": "25/11/2025 12:40:58",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 33.98,
            "sla_met": false,
            "sla_breach_hours": 9.98,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 22:40:13"
          },
          {
            "ticket_id": 3196,
            "ticket_number": "353189",
            "title": "Proposta de parceria + Tabela de preços 2025/2026 ",
            "priority": "P3",
            "created_at": "25/11/2025 16:58:12",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 17:10:54"
          },
          {
            "ticket_id": 3937,
            "ticket_number": "353929",
            "title": "ATT - Conf. de Reserva*File 420474 *TL 05/12 15h c",
            "priority": "P3",
            "created_at": "05/12/2025 12:15:25",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/12/2025 13:32:35"
          },
          {
            "ticket_id": 4022,
            "ticket_number": "354014",
            "title": "BTL e FLY - Cindy & André",
            "priority": "P3",
            "created_at": "07/12/2025 10:35:13",
            "close_date": "2026-01-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/12/2025 10:35:13"
          },
          {
            "ticket_id": 4629,
            "ticket_number": "354621",
            "title": "Re: FELIZ NATAL!!!!!!!",
            "priority": "P3",
            "created_at": "19/12/2025 12:39:44",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 12:39:45"
          },
          {
            "ticket_id": 4647,
            "ticket_number": "354639",
            "title": "Re: FELIZ NATAL!!!!!!!",
            "priority": "P3",
            "created_at": "19/12/2025 17:12:25",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/12/2025 17:12:27"
          },
          {
            "ticket_id": 4719,
            "ticket_number": "354711",
            "title": "Sugestão de melhoria :)",
            "priority": "P3",
            "created_at": "22/12/2025 12:54:47",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/12/2025 12:54:48"
          },
          {
            "ticket_id": 4934,
            "ticket_number": "354926",
            "title": "Re:[## 27094 ##] GBN-82923 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "29/12/2025 13:40:22",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 10:58:01"
          },
          {
            "ticket_id": 4940,
            "ticket_number": "354932",
            "title": "Travelplan - Preços especiais NET para Grupos VOO ",
            "priority": "P2",
            "created_at": "29/12/2025 16:26:27",
            "close_date": "2026-01-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/12/2025 16:26:27"
          },
          {
            "ticket_id": 5132,
            "ticket_number": "355124",
            "title": "Dúvidas _patamares _AC/ Carolina",
            "priority": "P2",
            "created_at": "05/01/2026 09:57:32",
            "close_date": "2026-01-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/01/2026 09:57:32"
          },
          {
            "ticket_id": 5172,
            "ticket_number": "355164",
            "title": "Cruzeiro Douro - Voucher",
            "priority": "P3",
            "created_at": "05/01/2026 15:51:09",
            "close_date": "2026-01-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/01/2026 15:51:09"
          },
          {
            "ticket_id": 5261,
            "ticket_number": "355253",
            "title": "Consulta de viajante - 412548/2025 SOLFERIAS",
            "priority": "P2",
            "created_at": "06/01/2026 20:37:55",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/01/2026 20:37:56"
          },
          {
            "ticket_id": 5347,
            "ticket_number": "355339",
            "title": "REMINDER: Dados de Passaporte - nosso File 422534",
            "priority": "P3",
            "created_at": "08/01/2026 10:07:33",
            "close_date": "2026-01-08",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/12/2025 21:07:09"
          },
          {
            "ticket_id": 5351,
            "ticket_number": "355343",
            "title": "Webinar LePlan - Disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:49",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:49"
          },
          {
            "ticket_id": 5352,
            "ticket_number": "355344",
            "title": "WEbinar da le plan, Disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:50",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:24:46"
          },
          {
            "ticket_id": 5353,
            "ticket_number": "355345",
            "title": "Webinar da LePlan -  Disney amanhã, dia 8 de janei",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:51",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:51"
          },
          {
            "ticket_id": 5354,
            "ticket_number": "355346",
            "title": "Pedido assistir Webnar Le Plan 8 Janeiro",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:53",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:53"
          },
          {
            "ticket_id": 5355,
            "ticket_number": "355347",
            "title": "Webinar da LePlan -  Disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:55",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:55"
          },
          {
            "ticket_id": 5356,
            "ticket_number": "355348",
            "title": "Webinar Le Plan - Disney - 08 de Janeiro 10h",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:57",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:57"
          },
          {
            "ticket_id": 5357,
            "ticket_number": "355349",
            "title": "Webinar Leplan",
            "priority": "P2",
            "created_at": "08/01/2026 10:22:59",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:22:59"
          },
          {
            "ticket_id": 5358,
            "ticket_number": "355350",
            "title": "Webinar Le Plan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:01",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:01"
          },
          {
            "ticket_id": 5359,
            "ticket_number": "355351",
            "title": "Inscrição formação LEplan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:03",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:03"
          },
          {
            "ticket_id": 5360,
            "ticket_number": "355352",
            "title": "Re: Tui inscrição webinar",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:05",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:24:47"
          },
          {
            "ticket_id": 5361,
            "ticket_number": "355353",
            "title": "Webinar LePlan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:07",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:24:47"
          },
          {
            "ticket_id": 5362,
            "ticket_number": "355354",
            "title": "Webinar Le Plan - Disney 8/01 - 10h00",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:09",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:09"
          },
          {
            "ticket_id": 5363,
            "ticket_number": "355355",
            "title": "Webinar leplan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:12",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:13"
          },
          {
            "ticket_id": 5364,
            "ticket_number": "355356",
            "title": "Inscrição Webinar LePlan 08 de Janeiro",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:14",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:15"
          },
          {
            "ticket_id": 5365,
            "ticket_number": "355357",
            "title": "Webinar leplan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:17",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:24:47"
          },
          {
            "ticket_id": 5366,
            "ticket_number": "355358",
            "title": "webinar leplan disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:18",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:19"
          },
          {
            "ticket_id": 5367,
            "ticket_number": "355359",
            "title": "Webinar da LePlan -  Disney amanhã, dia 8 de janei",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:20",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:20"
          },
          {
            "ticket_id": 5368,
            "ticket_number": "355360",
            "title": "Webinar le plan. Disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:21",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:22"
          },
          {
            "ticket_id": 5369,
            "ticket_number": "355361",
            "title": "Webinar Le Plan - Disney",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:24",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:24"
          },
          {
            "ticket_id": 5370,
            "ticket_number": "355362",
            "title": "Webinar Disney - Le Plan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:26",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:26"
          },
          {
            "ticket_id": 5371,
            "ticket_number": "355363",
            "title": "Webinar Disney LePlan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:28",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:28"
          },
          {
            "ticket_id": 5372,
            "ticket_number": "355364",
            "title": "webinar da  LE Plan",
            "priority": "P2",
            "created_at": "08/01/2026 10:23:30",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:23:30"
          },
          {
            "ticket_id": 5373,
            "ticket_number": "355365",
            "title": "Link para webinar Le Plan",
            "priority": "P2",
            "created_at": "08/01/2026 10:24:04",
            "close_date": "2026-01-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 10:25:05"
          },
          {
            "ticket_id": 5424,
            "ticket_number": "355416",
            "title": "Documentos Optis",
            "priority": "P2",
            "created_at": "08/01/2026 21:30:57",
            "close_date": "2026-01-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/01/2026 21:30:58"
          },
          {
            "ticket_id": 5482,
            "ticket_number": "355474",
            "title": "pedido RGPD e CVO",
            "priority": "P3",
            "created_at": "09/01/2026 20:54:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 20:54:51"
          },
          {
            "ticket_id": 5486,
            "ticket_number": "355478",
            "title": "pedido RGPD e CVO",
            "priority": "P3",
            "created_at": "09/01/2026 21:17:15",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 21:17:16"
          },
          {
            "ticket_id": 5492,
            "ticket_number": "355484",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "09/01/2026 23:23:34",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 23:23:35"
          },
          {
            "ticket_id": 5493,
            "ticket_number": "355485",
            "title": "Envio RGPD & CVO",
            "priority": "P3",
            "created_at": "09/01/2026 23:38:47",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/01/2026 23:38:48"
          },
          {
            "ticket_id": 5513,
            "ticket_number": "355505",
            "title": "RGPD e CVO Localizador 35275941",
            "priority": "P3",
            "created_at": "10/01/2026 13:57:07",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 13:57:07"
          },
          {
            "ticket_id": 5515,
            "ticket_number": "355507",
            "title": "RGPD - Luís Miguel Rocha Ramos - 247600077",
            "priority": "P3",
            "created_at": "10/01/2026 14:13:53",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 14:13:53"
          },
          {
            "ticket_id": 5516,
            "ticket_number": "355508",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "10/01/2026 15:27:32",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 15:27:32"
          },
          {
            "ticket_id": 5517,
            "ticket_number": "355509",
            "title": "Fwd: RGPD",
            "priority": "P3",
            "created_at": "10/01/2026 15:27:37",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 15:27:38"
          },
          {
            "ticket_id": 5521,
            "ticket_number": "355513",
            "title": "Fwd: Documentos em falta",
            "priority": "P3",
            "created_at": "10/01/2026 15:47:10",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 15:47:10"
          },
          {
            "ticket_id": 5524,
            "ticket_number": "355516",
            "title": "RGPD OPTI 2416400018- Rogério Fábio Lopes Félix Ol",
            "priority": "P3",
            "created_at": "10/01/2026 15:47:21",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 15:47:22"
          },
          {
            "ticket_id": 5528,
            "ticket_number": "355520",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "10/01/2026 17:27:45",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 17:27:45"
          },
          {
            "ticket_id": 5536,
            "ticket_number": "355528",
            "title": "PEDIDO RGPD E CVO",
            "priority": "P3",
            "created_at": "10/01/2026 18:45:54",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/01/2026 18:45:54"
          },
          {
            "ticket_id": 5555,
            "ticket_number": "355547",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P3",
            "created_at": "12/01/2026 10:08:38",
            "close_date": "2026-01-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 14:04:25"
          },
          {
            "ticket_id": 5590,
            "ticket_number": "355582",
            "title": "Fwd: OPTI242100182",
            "priority": "P3",
            "created_at": "12/01/2026 10:21:29",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 84.48,
            "sla_met": false,
            "sla_breach_hours": 60.48,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 22:50:44"
          },
          {
            "ticket_id": 5593,
            "ticket_number": "355585",
            "title": "Fwd: Documentação da reserva TTN-1233475025#898016",
            "priority": "P3",
            "created_at": "12/01/2026 10:21:39",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 84.48,
            "sla_met": false,
            "sla_breach_hours": 60.48,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 22:50:44"
          },
          {
            "ticket_id": 5597,
            "ticket_number": "355589",
            "title": "FW: SignRequest email bounced: rgpd 422534.docx",
            "priority": "P3",
            "created_at": "12/01/2026 10:22:17",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/01/2026 21:58:35"
          },
          {
            "ticket_id": 5598,
            "ticket_number": "355590",
            "title": "pedido RGPD e CVO",
            "priority": "P3",
            "created_at": "12/01/2026 10:22:21",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:22:22"
          },
          {
            "ticket_id": 5599,
            "ticket_number": "355591",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "12/01/2026 10:47:38",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 10:47:38"
          },
          {
            "ticket_id": 5613,
            "ticket_number": "355605",
            "title": "Re: Nova Viagem #260100108 - Ana Rita Lima",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:33",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:02:33"
          },
          {
            "ticket_id": 5617,
            "ticket_number": "355609",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "12/01/2026 13:02:42",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 13:02:42"
          },
          {
            "ticket_id": 5625,
            "ticket_number": "355617",
            "title": "Pedido de RGPD -",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:11",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 15:40:12"
          },
          {
            "ticket_id": 5627,
            "ticket_number": "355619",
            "title": "RGPD - Vila Galé 8899864",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:17",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 15:40:18"
          },
          {
            "ticket_id": 5632,
            "ticket_number": "355624",
            "title": "Convite | BOOST 2026 > Seizing the future | 16 Jan",
            "priority": "P3",
            "created_at": "12/01/2026 15:40:29",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 44.98,
            "sla_met": false,
            "sla_breach_hours": 20.98,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 12:40:21"
          },
          {
            "ticket_id": 5634,
            "ticket_number": "355626",
            "title": "CVO e RGPD GBN 97650",
            "priority": "P3",
            "created_at": "12/01/2026 16:42:20",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 16:42:21"
          },
          {
            "ticket_id": 5635,
            "ticket_number": "355627",
            "title": "RGPD localizador SMY 1233637098",
            "priority": "P3",
            "created_at": "12/01/2026 16:42:22",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 16:42:23"
          },
          {
            "ticket_id": 5636,
            "ticket_number": "355628",
            "title": "CVO e RGPD GBN 97649",
            "priority": "P3",
            "created_at": "12/01/2026 16:42:25",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 16:42:26"
          },
          {
            "ticket_id": 5637,
            "ticket_number": "355629",
            "title": "CVO e RGPD GBN 97648",
            "priority": "P3",
            "created_at": "12/01/2026 16:42:28",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 16:42:29"
          },
          {
            "ticket_id": 5640,
            "ticket_number": "355632",
            "title": "Re:[## 27962 ##] GBN-68378 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/01/2026 16:43:05",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/12/2025 13:41:46"
          },
          {
            "ticket_id": 5642,
            "ticket_number": "355634",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "P3",
            "created_at": "12/01/2026 17:49:19",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 43.9,
            "sla_met": false,
            "sla_breach_hours": 19.9,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 13:43:35"
          },
          {
            "ticket_id": 5663,
            "ticket_number": "355655",
            "title": "Pedido de envio para cliente",
            "priority": "P3",
            "created_at": "12/01/2026 21:09:57",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 21:09:58"
          },
          {
            "ticket_id": 5666,
            "ticket_number": "355658",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "12/01/2026 21:10:09",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 21:10:09"
          },
          {
            "ticket_id": 5679,
            "ticket_number": "355671",
            "title": "Pedro Rocha -  Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "12/01/2026 22:39:46",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 22:39:46"
          },
          {
            "ticket_id": 5680,
            "ticket_number": "355672",
            "title": "RGPD - José Manuel Teles da Ressurreição - 2415700",
            "priority": "P3",
            "created_at": "12/01/2026 22:57:02",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/01/2026 22:57:02"
          },
          {
            "ticket_id": 5684,
            "ticket_number": "355676",
            "title": "Pedido de RGPD e CVO",
            "priority": "P2",
            "created_at": "13/01/2026 00:13:00",
            "close_date": "2026-01-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/01/2026 00:13:00"
          },
          {
            "ticket_id": 5701,
            "ticket_number": "355693",
            "title": "Pedido RGPD localizador 1233344540 SMY TRAVEL GBN-",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:36"
          },
          {
            "ticket_id": 5703,
            "ticket_number": "355695",
            "title": "Vera Marques -  Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:40"
          },
          {
            "ticket_id": 5704,
            "ticket_number": "355696",
            "title": "Pedido RGPD SMY 1234129672",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:42",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:42"
          },
          {
            "ticket_id": 5706,
            "ticket_number": "355698",
            "title": "luis gaspar rgpd e cvo   SMY 1170980123",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:46",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:46"
          },
          {
            "ticket_id": 5709,
            "ticket_number": "355701",
            "title": "RGPD - Patrícia Alexandra Martins Cota - 247600078",
            "priority": "P3",
            "created_at": "13/01/2026 10:06:54",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:06:54"
          },
          {
            "ticket_id": 5713,
            "ticket_number": "355705",
            "title": "RGPD - Andreia Carina Rodrigues Rocha - 247600079",
            "priority": "P3",
            "created_at": "13/01/2026 10:07:03",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:07:04"
          },
          {
            "ticket_id": 5719,
            "ticket_number": "355711",
            "title": "URGENTE - Re: Emissão de CVO e RGPD - SMY Travel 1",
            "priority": "P3",
            "created_at": "13/01/2026 10:37:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 10:37:36"
          },
          {
            "ticket_id": 5724,
            "ticket_number": "355716",
            "title": "RE: ID 604456534",
            "priority": "P3",
            "created_at": "13/01/2026 11:08:35",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 15:51:01"
          },
          {
            "ticket_id": 5725,
            "ticket_number": "355717",
            "title": "ID 604456534",
            "priority": "P3",
            "created_at": "13/01/2026 11:08:39",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 4.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 15:50:39"
          },
          {
            "ticket_id": 5749,
            "ticket_number": "355741",
            "title": "RGPD e CVO 35291692",
            "priority": "P3",
            "created_at": "13/01/2026 13:33:46",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 13:33:46"
          },
          {
            "ticket_id": 5753,
            "ticket_number": "355745",
            "title": "Daniela Queiros - Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "13/01/2026 14:56:15",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 14:56:15"
          },
          {
            "ticket_id": 5778,
            "ticket_number": "355770",
            "title": "Fwd: Pedido de RGPD",
            "priority": "P3",
            "created_at": "13/01/2026 17:05:48",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:05:49"
          },
          {
            "ticket_id": 5779,
            "ticket_number": "355771",
            "title": "SOLICITO RGPD E CVO - ANTONIO LUIS DA SILVA VIANA ",
            "priority": "P3",
            "created_at": "13/01/2026 17:05:51",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:05:52"
          },
          {
            "ticket_id": 5784,
            "ticket_number": "355776",
            "title": "RGPD e CVO Localizador 35294194",
            "priority": "P3",
            "created_at": "13/01/2026 17:06:12",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 17:06:13"
          },
          {
            "ticket_id": 5807,
            "ticket_number": "355799",
            "title": "Fwd: Nova reserva: 248000031 | envio de CVO + RGPD",
            "priority": "P3",
            "created_at": "13/01/2026 20:06:17",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 20:06:18"
          },
          {
            "ticket_id": 5808,
            "ticket_number": "355800",
            "title": "Fwd: Nova reserva: 248000030 | envio de CVO + RGPD",
            "priority": "P3",
            "created_at": "13/01/2026 20:06:20",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 20:06:20"
          },
          {
            "ticket_id": 5823,
            "ticket_number": "355815",
            "title": "RGPD - Soltrópico - 336636",
            "priority": "P3",
            "created_at": "13/01/2026 22:26:03",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 22:26:03"
          },
          {
            "ticket_id": 5825,
            "ticket_number": "355817",
            "title": "RGPD - Soltrópico - 336634",
            "priority": "P3",
            "created_at": "13/01/2026 22:26:07",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 22:26:07"
          },
          {
            "ticket_id": 5827,
            "ticket_number": "355819",
            "title": "Carolina Pereira Henriques - GBN-98535",
            "priority": "P3",
            "created_at": "13/01/2026 22:26:11",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 22:26:11"
          },
          {
            "ticket_id": 5832,
            "ticket_number": "355824",
            "title": "Nova reserva GBN + Le Plan | GBN-98602 + 604521877",
            "priority": "P3",
            "created_at": "13/01/2026 22:54:32",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 22:54:33"
          },
          {
            "ticket_id": 5833,
            "ticket_number": "355825",
            "title": "Opti 249100041_Marlene Fernandes",
            "priority": "P3",
            "created_at": "13/01/2026 23:05:04",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 23:05:04"
          },
          {
            "ticket_id": 5848,
            "ticket_number": "355840",
            "title": "RGPD - Ana Paula Gonçalves Cota - 247600080",
            "priority": "P3",
            "created_at": "13/01/2026 23:56:07",
            "close_date": "2026-01-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/01/2026 23:56:07"
          },
          {
            "ticket_id": 5865,
            "ticket_number": "355857",
            "title": "SOLICITO RGPD E CVO - MARIANA RAMALHO PALMA - OPTI",
            "priority": "P3",
            "created_at": "14/01/2026 10:08:33",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 10:08:34"
          },
          {
            "ticket_id": 5868,
            "ticket_number": "355860",
            "title": "rgpd e cvo",
            "priority": "P3",
            "created_at": "14/01/2026 10:57:49",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 2.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 13:17:37"
          },
          {
            "ticket_id": 5874,
            "ticket_number": "355866",
            "title": "RGPD - Rate Hawk 21363927",
            "priority": "P3",
            "created_at": "14/01/2026 11:21:10",
            "close_date": "2026-01-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 11:21:10"
          },
          {
            "ticket_id": 5896,
            "ticket_number": "355888",
            "title": "RGPD e CVO Localizador 35300237",
            "priority": "P3",
            "created_at": "14/01/2026 13:43:36",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 13:43:37"
          },
          {
            "ticket_id": 5908,
            "ticket_number": "355900",
            "title": "Envio de RGPD - Opti: 241600022 - Solferias 423949",
            "priority": "P3",
            "created_at": "14/01/2026 15:05:03",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 15:05:04"
          },
          {
            "ticket_id": 5911,
            "ticket_number": "355903",
            "title": "RGPD - Soltrópico - 336678",
            "priority": "P3",
            "created_at": "14/01/2026 15:21:26",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 15:21:26"
          },
          {
            "ticket_id": 5912,
            "ticket_number": "355904",
            "title": "GBN Travel: Informações sobre sua reserva - GBN-98",
            "priority": "P3",
            "created_at": "14/01/2026 15:21:32",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 26.33,
            "sla_met": false,
            "sla_breach_hours": 2.33,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 17:42:22"
          },
          {
            "ticket_id": 5913,
            "ticket_number": "355905",
            "title": "Envio do voucher e RGPD - OPTI 24940000 - Nova Via",
            "priority": "P3",
            "created_at": "14/01/2026 15:21:40",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 15:21:42"
          },
          {
            "ticket_id": 5916,
            "ticket_number": "355908",
            "title": "RGPD localizador LEPLAN 604522509",
            "priority": "P3",
            "created_at": "14/01/2026 15:30:47",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 15:30:47"
          },
          {
            "ticket_id": 5919,
            "ticket_number": "355911",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "14/01/2026 16:17:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 16:17:50"
          },
          {
            "ticket_id": 5922,
            "ticket_number": "355914",
            "title": "Re: Fwd: Importante - RGPD",
            "priority": "P3",
            "created_at": "14/01/2026 16:17:57",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 16:17:57"
          },
          {
            "ticket_id": 5926,
            "ticket_number": "355918",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "14/01/2026 16:18:06",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 16:18:06"
          },
          {
            "ticket_id": 5928,
            "ticket_number": "355920",
            "title": "CCTGTI-31105 Pedido para colocar nome completo -60",
            "priority": "P3",
            "created_at": "14/01/2026 16:18:47",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 21.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 14:03:42"
          },
          {
            "ticket_id": 5933,
            "ticket_number": "355925",
            "title": "Pedido RGPD E CVO SMYTRAVEL 1235013010",
            "priority": "P3",
            "created_at": "14/01/2026 17:29:35",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 17:29:36"
          },
          {
            "ticket_id": 5944,
            "ticket_number": "355936",
            "title": "Pedido RGPD e CVO GBN-98882",
            "priority": "P3",
            "created_at": "14/01/2026 19:55:23",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 19:55:23"
          },
          {
            "ticket_id": 5951,
            "ticket_number": "355943",
            "title": "GBN-98902 - João Madureira - Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "14/01/2026 20:57:33",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 20:57:33"
          },
          {
            "ticket_id": 5952,
            "ticket_number": "355944",
            "title": "CVO + RGPD 2460800002",
            "priority": "P3",
            "created_at": "14/01/2026 20:57:35",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 20:57:36"
          },
          {
            "ticket_id": 5956,
            "ticket_number": "355948",
            "title": "Pedido RGPD  GBN- 98913",
            "priority": "P3",
            "created_at": "14/01/2026 22:50:40",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 22:50:41"
          },
          {
            "ticket_id": 5958,
            "ticket_number": "355950",
            "title": "Pedido RGPD E CVO - GBN- 98753",
            "priority": "P3",
            "created_at": "14/01/2026 22:50:50",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 22:50:50"
          },
          {
            "ticket_id": 5959,
            "ticket_number": "355951",
            "title": "enviar RGPD Eduardo leite - GBN-98922",
            "priority": "P3",
            "created_at": "14/01/2026 22:50:52",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 22:50:53"
          },
          {
            "ticket_id": 5964,
            "ticket_number": "355956",
            "title": "Pedido CVO e RGPD",
            "priority": "P3",
            "created_at": "14/01/2026 22:51:11",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 22:51:12"
          },
          {
            "ticket_id": 5971,
            "ticket_number": "355963",
            "title": "604523178 TRAVELPLAN",
            "priority": "P3",
            "created_at": "14/01/2026 23:04:44",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 23:04:45"
          },
          {
            "ticket_id": 5973,
            "ticket_number": "355965",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "14/01/2026 23:09:29",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 23:09:30"
          },
          {
            "ticket_id": 5975,
            "ticket_number": "355967",
            "title": "Solicitação de envio de RGPD e CVO | Localizador 6",
            "priority": "P3",
            "created_at": "14/01/2026 23:13:46",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 23:13:46"
          },
          {
            "ticket_id": 5980,
            "ticket_number": "355972",
            "title": "1235214221 - Nuno Ferreira - Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "14/01/2026 23:50:03",
            "close_date": "2026-01-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 23:50:04"
          },
          {
            "ticket_id": 5992,
            "ticket_number": "355984",
            "title": "Pedido de envio de RGPD e CVO - João Dias- Solféri",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:41",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 10:13:42"
          },
          {
            "ticket_id": 5993,
            "ticket_number": "355985",
            "title": "Pedido de envio de RGPD e CVO - João Dias- GBN-989",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:44",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 10:13:44"
          },
          {
            "ticket_id": 5996,
            "ticket_number": "355988",
            "title": "Pedido de RGP GBN- 98936",
            "priority": "P3",
            "created_at": "15/01/2026 10:13:55",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 10:13:55"
          },
          {
            "ticket_id": 5998,
            "ticket_number": "355990",
            "title": "loc6126635 - opti242100186",
            "priority": "P3",
            "created_at": "15/01/2026 10:14:07",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 30.65,
            "sla_met": false,
            "sla_breach_hours": 6.65,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 16:54:04"
          },
          {
            "ticket_id": 6000,
            "ticket_number": "355992",
            "title": "Pedido Envio RGPD + CVO",
            "priority": "P3",
            "created_at": "15/01/2026 10:14:15",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 10:14:15"
          },
          {
            "ticket_id": 6017,
            "ticket_number": "356009",
            "title": "pedido RGPD",
            "priority": "P2",
            "created_at": "15/01/2026 10:59:50",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 10:59:50"
          },
          {
            "ticket_id": 6020,
            "ticket_number": "356012",
            "title": "RGPD #251100338",
            "priority": "P3",
            "created_at": "15/01/2026 11:02:37",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 11:02:38"
          },
          {
            "ticket_id": 6052,
            "ticket_number": "356044",
            "title": "Envio de RGPD e CVO",
            "priority": "P2",
            "created_at": "15/01/2026 14:46:56",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 14:46:57"
          },
          {
            "ticket_id": 6061,
            "ticket_number": "356053",
            "title": "RGPD - Vila Galé 8909809",
            "priority": "P2",
            "created_at": "15/01/2026 16:23:16",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 16:23:17"
          },
          {
            "ticket_id": 6063,
            "ticket_number": "356055",
            "title": "Pedido de RGPD e CVO",
            "priority": "P2",
            "created_at": "15/01/2026 16:23:21",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 16:23:22"
          },
          {
            "ticket_id": 6069,
            "ticket_number": "356061",
            "title": "CVO - localizador SPT002601568300",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:01",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:18:02"
          },
          {
            "ticket_id": 6074,
            "ticket_number": "356066",
            "title": "RGPD + CVO - localizador SPT002601568995",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:26",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:18:26"
          },
          {
            "ticket_id": 6075,
            "ticket_number": "356067",
            "title": "CVO - localizador SPT002601568223",
            "priority": "P2",
            "created_at": "15/01/2026 17:18:34",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 17:18:35"
          },
          {
            "ticket_id": 6078,
            "ticket_number": "356070",
            "title": "CVO e RGPD GBN 99069 Opti 2418700026",
            "priority": "P3",
            "created_at": "15/01/2026 18:04:23",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 18:04:23"
          },
          {
            "ticket_id": 6082,
            "ticket_number": "356074",
            "title": "CVO e RGPD Opti 2418700027",
            "priority": "P2",
            "created_at": "15/01/2026 18:23:05",
            "close_date": "2026-01-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/01/2026 18:23:05"
          },
          {
            "ticket_id": 6093,
            "ticket_number": "356085",
            "title": "Fwd: Nova Viagem #260100179 - Ana Rita Lima",
            "priority": "P3",
            "created_at": "15/01/2026 19:51:51",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 19:51:52"
          },
          {
            "ticket_id": 6098,
            "ticket_number": "356090",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "15/01/2026 21:44:56",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 21:44:56"
          },
          {
            "ticket_id": 6100,
            "ticket_number": "356092",
            "title": "pedido envio RGPD smytravel 1234693735",
            "priority": "P3",
            "created_at": "15/01/2026 22:28:03",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 22:28:03"
          },
          {
            "ticket_id": 6105,
            "ticket_number": "356097",
            "title": "Envio documentos cliente",
            "priority": "P3",
            "created_at": "15/01/2026 22:50:58",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 22:50:59"
          },
          {
            "ticket_id": 6106,
            "ticket_number": "356098",
            "title": "Nova reserva GBN - 248000033 - envio de doc",
            "priority": "P3",
            "created_at": "15/01/2026 23:04:34",
            "close_date": "2026-01-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 23:04:35"
          },
          {
            "ticket_id": 6120,
            "ticket_number": "356112",
            "title": "RE: SOLICITO RGPD E CVO - NAIR TAVEIRA - OPTI: 241",
            "priority": "P3",
            "created_at": "15/01/2026 23:54:19",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 23:54:19"
          },
          {
            "ticket_id": 6123,
            "ticket_number": "356115",
            "title": "Fwd: Nova Viagem #260100184 - Ana Rita Lima",
            "priority": "P3",
            "created_at": "15/01/2026 23:58:38",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/01/2026 23:58:38"
          },
          {
            "ticket_id": 6138,
            "ticket_number": "356130",
            "title": "MTU3NEIwMEI1MkM1OjkwMUMxNzhB - Francisco Madaleno ",
            "priority": "P3",
            "created_at": "16/01/2026 10:13:59",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:14:00"
          },
          {
            "ticket_id": 6139,
            "ticket_number": "356131",
            "title": "2MDC59 - Francisco Madaleno - Pedido de RGPD E CVO",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:02",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:14:03"
          },
          {
            "ticket_id": 6141,
            "ticket_number": "356133",
            "title": "FW: Beatriz Valéria - CVO + RGPD",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:10",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:14:11"
          },
          {
            "ticket_id": 6143,
            "ticket_number": "356135",
            "title": "Pedido RGPD  GBN- 99223",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:15",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 10:14:15"
          },
          {
            "ticket_id": 6144,
            "ticket_number": "356136",
            "title": "IMPORTANTE // Convite: Saleslink SHOWCASE, terça-f",
            "priority": "P3",
            "created_at": "16/01/2026 10:14:17",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 14:02:48"
          },
          {
            "ticket_id": 6183,
            "ticket_number": "356175",
            "title": "RGPD localizador LEPLAN 604524385",
            "priority": "P3",
            "created_at": "16/01/2026 13:02:53",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 13:02:55"
          },
          {
            "ticket_id": 6184,
            "ticket_number": "356176",
            "title": "Rgpd e cvo",
            "priority": "P3",
            "created_at": "16/01/2026 13:02:58",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 13:02:59"
          },
          {
            "ticket_id": 6214,
            "ticket_number": "356206",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "16/01/2026 17:08:50",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 17:08:51"
          },
          {
            "ticket_id": 6221,
            "ticket_number": "356213",
            "title": "Pedido de envio de docs - Nova Viagem #260100196 -",
            "priority": "P3",
            "created_at": "16/01/2026 19:29:34",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 19:29:34"
          },
          {
            "ticket_id": 6233,
            "ticket_number": "356225",
            "title": "RGPD e CVO SMY1236075654",
            "priority": "P3",
            "created_at": "16/01/2026 20:20:05",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 20:20:05"
          },
          {
            "ticket_id": 6238,
            "ticket_number": "356230",
            "title": "Envio RGPD+CVO-GBN-99443",
            "priority": "P3",
            "created_at": "16/01/2026 20:28:41",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 20:28:42"
          },
          {
            "ticket_id": 6242,
            "ticket_number": "356234",
            "title": "CVO + RGPD",
            "priority": "P3",
            "created_at": "16/01/2026 22:47:05",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 22:47:06"
          },
          {
            "ticket_id": 6250,
            "ticket_number": "356242",
            "title": "Re: NOVIDADES BTL!!",
            "priority": "P2",
            "created_at": "16/01/2026 23:38:22",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 23:38:22"
          },
          {
            "ticket_id": 6251,
            "ticket_number": "356243",
            "title": "pedido de RGPD - Maria Isabel Melícias - Soltrópic",
            "priority": "P3",
            "created_at": "16/01/2026 23:38:25",
            "close_date": "2026-01-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/01/2026 23:38:26"
          },
          {
            "ticket_id": 6259,
            "ticket_number": "356251",
            "title": "RGPD - LePlan - 604497323",
            "priority": "P3",
            "created_at": "17/01/2026 10:08:06",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 10:08:06"
          },
          {
            "ticket_id": 6270,
            "ticket_number": "356262",
            "title": "RGPD - Soltrópico - 336983",
            "priority": "P3",
            "created_at": "17/01/2026 10:08:42",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 10:08:42"
          },
          {
            "ticket_id": 6271,
            "ticket_number": "356263",
            "title": "SMY 1236218726 - Jorge Freitas - Pedido de RGPD E ",
            "priority": "P3",
            "created_at": "17/01/2026 10:08:48",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 10:08:48"
          },
          {
            "ticket_id": 6280,
            "ticket_number": "356272",
            "title": "Solicitação de envio de RGPD e CVO | Localizador 4",
            "priority": "P3",
            "created_at": "17/01/2026 12:26:37",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 12:26:38"
          },
          {
            "ticket_id": 6291,
            "ticket_number": "356283",
            "title": "Pedido de envio de RGPD e CVO - CIDALIA DIAS CARVA",
            "priority": "P3",
            "created_at": "17/01/2026 16:33:06",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 16:33:07"
          },
          {
            "ticket_id": 6299,
            "ticket_number": "356291",
            "title": "RE: Pedido RGPD localizador 1233344540 SMY TRAVEL ",
            "priority": "P3",
            "created_at": "17/01/2026 17:27:27",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 17:27:27"
          },
          {
            "ticket_id": 6300,
            "ticket_number": "356292",
            "title": "RE:  Pedido RGPD localizador 1233489310 SMY TRAVEL",
            "priority": "P3",
            "created_at": "17/01/2026 17:27:29",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/01/2026 17:27:29"
          },
          {
            "ticket_id": 6341,
            "ticket_number": "356333",
            "title": "Susana Gonçalves - CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:06",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:07"
          },
          {
            "ticket_id": 6342,
            "ticket_number": "356334",
            "title": "SignRequest email bounced: CVO 2417700005.pdf",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:08",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 35.73,
            "sla_met": false,
            "sla_breach_hours": 31.73,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 00:07:31"
          },
          {
            "ticket_id": 6344,
            "ticket_number": "356336",
            "title": "SMY - 123657600 - Pedro Barbosa  -  Pedido de RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:12",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:12"
          },
          {
            "ticket_id": 6345,
            "ticket_number": "356337",
            "title": "RGPD - GBN-99494",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:14",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:15"
          },
          {
            "ticket_id": 6346,
            "ticket_number": "356338",
            "title": "RGPD - OPTI 2416400019 -  Carolina Ferreira",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:16",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:16"
          },
          {
            "ticket_id": 6347,
            "ticket_number": "356339",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:19",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:19"
          },
          {
            "ticket_id": 6348,
            "ticket_number": "356340",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:22",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:22"
          },
          {
            "ticket_id": 6349,
            "ticket_number": "356341",
            "title": "Loc 164-10520866 (bedsonline) + Opti 2413000002",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:24",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:24"
          },
          {
            "ticket_id": 6350,
            "ticket_number": "356342",
            "title": "Opti 249100040_Marlene Fernandes",
            "priority": "P2",
            "created_at": "18/01/2026 12:23:27",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 12:23:28"
          },
          {
            "ticket_id": 6351,
            "ticket_number": "356343",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 13:31:21",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 13:31:21"
          },
          {
            "ticket_id": 6353,
            "ticket_number": "356345",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 14:07:03",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 14:07:04"
          },
          {
            "ticket_id": 6370,
            "ticket_number": "356362",
            "title": "Envio CVO + RGPD",
            "priority": "P2",
            "created_at": "18/01/2026 18:52:04",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 18:52:04"
          },
          {
            "ticket_id": 6371,
            "ticket_number": "356363",
            "title": "Pedido envio RGPD + CVO - OpenTours - 9100678",
            "priority": "P2",
            "created_at": "18/01/2026 18:57:20",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 18:57:21"
          },
          {
            "ticket_id": 6372,
            "ticket_number": "356364",
            "title": "Pedido envio RGPD + CVO - TOUR10 - 4036558",
            "priority": "P2",
            "created_at": "18/01/2026 18:57:23",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/01/2026 18:57:24"
          },
          {
            "ticket_id": 6393,
            "ticket_number": "356385",
            "title": "Envio de RGPD - reserva n# 1236854333",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:20",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:21"
          },
          {
            "ticket_id": 6395,
            "ticket_number": "356387",
            "title": "RGPD+CVO - Nortravel 604525966",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:25",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:26"
          },
          {
            "ticket_id": 6396,
            "ticket_number": "356388",
            "title": "RGPD - Márcia José Manita - 247600082",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:27",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:28"
          },
          {
            "ticket_id": 6397,
            "ticket_number": "356389",
            "title": "RGPD - Carlos Aníbal Pereira e Pereira - 247600081",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:29",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:29"
          },
          {
            "ticket_id": 6398,
            "ticket_number": "356390",
            "title": "Pedido envio RGPD + CVO - Leplan - 604525945",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:32",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:32"
          },
          {
            "ticket_id": 6402,
            "ticket_number": "356394",
            "title": "RGPD - Mafalda Sofia dos Santos Silva - 2415700059",
            "priority": "P2",
            "created_at": "19/01/2026 10:10:41",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:10:41"
          },
          {
            "ticket_id": 6403,
            "ticket_number": "356395",
            "title": "nova reserva GBN-99632 |  248000034 - envio de doc",
            "priority": "P3",
            "created_at": "19/01/2026 10:10:43",
            "close_date": "2026-01-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 10:10:43"
          },
          {
            "ticket_id": 6406,
            "ticket_number": "356398",
            "title": "Solferias - 424766 - RGPD",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:20",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:11:21"
          },
          {
            "ticket_id": 6416,
            "ticket_number": "356408",
            "title": "ENVIO DE CVO Reserva Localizador Viajartours-21036",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:45",
            "close_date": "2026-01-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:11:45"
          },
          {
            "ticket_id": 6417,
            "ticket_number": "356409",
            "title": "Pedido de RGPD",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:47",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:11:47"
          },
          {
            "ticket_id": 6418,
            "ticket_number": "356410",
            "title": "Pedido de RGPD",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:49",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 10:11:50"
          },
          {
            "ticket_id": 6431,
            "ticket_number": "356423",
            "title": "RGPD+CVO",
            "priority": "P2",
            "created_at": "19/01/2026 11:41:41",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 11:41:42"
          },
          {
            "ticket_id": 6448,
            "ticket_number": "356440",
            "title": "OpenTours - 9100828 - Miguel Pinto - Pedido de RGP",
            "priority": "P2",
            "created_at": "19/01/2026 14:00:32",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:33"
          },
          {
            "ticket_id": 6462,
            "ticket_number": "356454",
            "title": "GBN99745 CVO e RGPD",
            "priority": "P2",
            "created_at": "19/01/2026 15:30:48",
            "close_date": "2026-01-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 15:30:49"
          },
          {
            "ticket_id": 6480,
            "ticket_number": "356472",
            "title": "Pedido RGPD E CVO GBN - 99798",
            "priority": "P3",
            "created_at": "19/01/2026 18:19:33",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 18:19:33"
          },
          {
            "ticket_id": 6496,
            "ticket_number": "356488",
            "title": "Nova reserva Soltrópico |  337291 - envio de docum",
            "priority": "P3",
            "created_at": "19/01/2026 21:19:02",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 21:19:03"
          },
          {
            "ticket_id": 6504,
            "ticket_number": "356496",
            "title": "Utilização voucher 500€ TravelPlan",
            "priority": "P3",
            "created_at": "19/01/2026 22:13:37",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 22:13:38"
          },
          {
            "ticket_id": 6512,
            "ticket_number": "356504",
            "title": "Pedido Rgpd e cvo",
            "priority": "P3",
            "created_at": "19/01/2026 23:05:15",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/01/2026 23:05:16"
          },
          {
            "ticket_id": 6525,
            "ticket_number": "356517",
            "title": "Envio CVO + RGPD",
            "priority": "P3",
            "created_at": "20/01/2026 10:09:44",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:09:45"
          },
          {
            "ticket_id": 6528,
            "ticket_number": "356520",
            "title": "José Gomes - CVO + RGPD",
            "priority": "P3",
            "created_at": "20/01/2026 10:10:59",
            "close_date": "2026-01-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:11:00"
          },
          {
            "ticket_id": 6530,
            "ticket_number": "356522",
            "title": "TravelPlan - 604527341",
            "priority": "P3",
            "created_at": "20/01/2026 10:12:11",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:12:12"
          },
          {
            "ticket_id": 6533,
            "ticket_number": "356525",
            "title": "Enviar RGPD João Lima - GBN 99921",
            "priority": "P3",
            "created_at": "20/01/2026 10:12:22",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:12:22"
          },
          {
            "ticket_id": 6535,
            "ticket_number": "356527",
            "title": "SOLICITO ENVIO RGPD E CVO- AGOSTINHO BARBOSA NUNES",
            "priority": "P3",
            "created_at": "20/01/2026 10:12:27",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:12:27"
          },
          {
            "ticket_id": 6550,
            "ticket_number": "356542",
            "title": "RGPD - GBN - 99937",
            "priority": "P3",
            "created_at": "20/01/2026 10:14:13",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 10:14:14"
          },
          {
            "ticket_id": 6602,
            "ticket_number": "356594",
            "title": "opti242100189-loc337317",
            "priority": "P2",
            "created_at": "20/01/2026 15:05:22",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:03:31"
          },
          {
            "ticket_id": 6607,
            "ticket_number": "356599",
            "title": "opti242100188 - gbn99476",
            "priority": "P2",
            "created_at": "20/01/2026 15:57:03",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:43:37"
          },
          {
            "ticket_id": 6630,
            "ticket_number": "356622",
            "title": "Diana Madureira - Reserva SMY 1237741509 -  Pedido",
            "priority": "P3",
            "created_at": "20/01/2026 17:03:38",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:03:39"
          },
          {
            "ticket_id": 6633,
            "ticket_number": "356625",
            "title": "Fwd: SignRequest sent: cvo GBN-88822.pdf",
            "priority": "P3",
            "created_at": "20/01/2026 17:03:49",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:03:49"
          },
          {
            "ticket_id": 6634,
            "ticket_number": "356626",
            "title": "PEDIDO DE ENVIO RGPD E CVO - RICARDO REIS SMY 1237",
            "priority": "P3",
            "created_at": "20/01/2026 17:03:51",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 17:03:51"
          },
          {
            "ticket_id": 6638,
            "ticket_number": "356630",
            "title": "TIAGO CLAUDINO - 337345 - RGPD e CVO",
            "priority": "P2",
            "created_at": "20/01/2026 17:37:51",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:37:52"
          },
          {
            "ticket_id": 6645,
            "ticket_number": "356637",
            "title": "RGPD _ GBN 98016",
            "priority": "P2",
            "created_at": "20/01/2026 17:45:06",
            "close_date": "2026-01-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 17:45:06"
          },
          {
            "ticket_id": 6652,
            "ticket_number": "356644",
            "title": "RGPD _ GBN  99759",
            "priority": "P3",
            "created_at": "20/01/2026 19:11:19",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 19:11:20"
          },
          {
            "ticket_id": 6657,
            "ticket_number": "356649",
            "title": "RGPD E CVO - OPTI 24800032",
            "priority": "P3",
            "created_at": "20/01/2026 19:59:26",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 19:59:27"
          },
          {
            "ticket_id": 6677,
            "ticket_number": "356669",
            "title": "Envio RGPD e CVO - Sergio Alves- GBN-99777",
            "priority": "P3",
            "created_at": "20/01/2026 22:54:11",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 22:54:12"
          },
          {
            "ticket_id": 6680,
            "ticket_number": "356672",
            "title": "Correção de documentação",
            "priority": "P3",
            "created_at": "20/01/2026 23:31:57",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 23:31:58"
          },
          {
            "ticket_id": 6685,
            "ticket_number": "356677",
            "title": "SOLICITO ENVIO RGPD E CVO- GONÇALO MARTINS ALMEIDA",
            "priority": "P3",
            "created_at": "20/01/2026 23:56:14",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/01/2026 23:56:14"
          },
          {
            "ticket_id": 6686,
            "ticket_number": "356678",
            "title": "RGPD Localizador nr: 100217 GBN",
            "priority": "P3",
            "created_at": "21/01/2026 00:04:06",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 00:04:06"
          },
          {
            "ticket_id": 6691,
            "ticket_number": "356683",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:04",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:05"
          },
          {
            "ticket_id": 6692,
            "ticket_number": "356684",
            "title": "RGPD - Sergio Duarte Da Silva Leal - OPTI - 241460",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:08",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:09"
          },
          {
            "ticket_id": 6696,
            "ticket_number": "356688",
            "title": "ENVIO DE CVO Reserva Localizador Viajartours-21049",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:18",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:18"
          },
          {
            "ticket_id": 6707,
            "ticket_number": "356699",
            "title": "Anónio Azevedo  - Reserva NEWBLUE.ES - 1770387 - P",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:51",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:52"
          },
          {
            "ticket_id": 6708,
            "ticket_number": "356700",
            "title": "RGPD - Sergio Duarte Da Silva Leal - OPTI - 241460",
            "priority": "P3",
            "created_at": "21/01/2026 13:46:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:46:54"
          },
          {
            "ticket_id": 6718,
            "ticket_number": "356710",
            "title": "pedido de cvo e rgpd",
            "priority": "P3",
            "created_at": "21/01/2026 13:48:58",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 13:48:58"
          },
          {
            "ticket_id": 6739,
            "ticket_number": "356731",
            "title": "SOLICITO CVO - ANTONIO LUIS DA SILVA VIANA - OPTI:",
            "priority": "P3",
            "created_at": "21/01/2026 14:57:49",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 14:57:49"
          },
          {
            "ticket_id": 6747,
            "ticket_number": "356739",
            "title": "RE: SOLICITO RGPD E CVO - BELMIRA ELISABETE SOARES",
            "priority": "P2",
            "created_at": "21/01/2026 15:22:04",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 15:22:05"
          },
          {
            "ticket_id": 6755,
            "ticket_number": "356747",
            "title": "RGPD -  NewBlue - 6128032",
            "priority": "P2",
            "created_at": "21/01/2026 16:42:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 16:42:55"
          },
          {
            "ticket_id": 6756,
            "ticket_number": "356748",
            "title": "SOLICITO RGPD E CVO - JOANA CATARINA DE PADUA SIMO",
            "priority": "P3",
            "created_at": "21/01/2026 16:43:00",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 16:43:01"
          },
          {
            "ticket_id": 6758,
            "ticket_number": "356750",
            "title": "pedido RGPD e CVO NEWBLUE 1770371",
            "priority": "P2",
            "created_at": "21/01/2026 16:43:09",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/01/2026 16:43:09"
          },
          {
            "ticket_id": 6793,
            "ticket_number": "356785",
            "title": "CVO RGPD GBN100046",
            "priority": "P3",
            "created_at": "21/01/2026 20:01:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 20:01:04"
          },
          {
            "ticket_id": 6797,
            "ticket_number": "356789",
            "title": "Envio CVO Rita Ribeiro | Opti 247500031 | Localiza",
            "priority": "P3",
            "created_at": "21/01/2026 21:58:16",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 21:58:16"
          },
          {
            "ticket_id": 6807,
            "ticket_number": "356799",
            "title": "Fwd: Documentación Reserva: 6128337 - OPTI24210019",
            "priority": "Reservas sem Formulário",
            "created_at": "21/01/2026 22:57:52",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 24.32,
            "sla_met": false,
            "sla_breach_hours": 0.32,
            "sla_name": "SLA Padrão",
            "first_response_at": "22/01/2026 23:17:16"
          },
          {
            "ticket_id": 6810,
            "ticket_number": "356802",
            "title": "opti242100195 - loc425629",
            "priority": "P3",
            "created_at": "21/01/2026 23:10:42",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 24.13,
            "sla_met": false,
            "sla_breach_hours": 0.13,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 23:18:56"
          },
          {
            "ticket_id": 6813,
            "ticket_number": "356805",
            "title": "Diana Faria - CVO + RGPD",
            "priority": "P3",
            "created_at": "21/01/2026 23:54:55",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 23:54:55"
          },
          {
            "ticket_id": 6814,
            "ticket_number": "356806",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "21/01/2026 23:54:57",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 23:54:57"
          },
          {
            "ticket_id": 6817,
            "ticket_number": "356809",
            "title": "Diana Faria - CVO + RGPD",
            "priority": "P3",
            "created_at": "21/01/2026 23:55:06",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/01/2026 23:55:06"
          },
          {
            "ticket_id": 6845,
            "ticket_number": "356837",
            "title": "Envio CVO + RGPD",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:36",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:16:37"
          },
          {
            "ticket_id": 6847,
            "ticket_number": "356839",
            "title": "Enviar RGPD Sofia Nogueira - GBN-100531",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:16:41"
          },
          {
            "ticket_id": 6849,
            "ticket_number": "356841",
            "title": "enviar RGPD Eduardo leite - civitatis",
            "priority": "P3",
            "created_at": "22/01/2026 10:16:46",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 10:16:46"
          },
          {
            "ticket_id": 6860,
            "ticket_number": "356852",
            "title": "RGPD PAULA CRISTINA MOREIRA GOMES LEITÃO - Localiz",
            "priority": "P3",
            "created_at": "22/01/2026 12:26:42",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 12:26:42"
          },
          {
            "ticket_id": 6861,
            "ticket_number": "356853",
            "title": "RGPD e CVO GBN-100521",
            "priority": "P3",
            "created_at": "22/01/2026 12:26:44",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 12:26:44"
          },
          {
            "ticket_id": 6862,
            "ticket_number": "356854",
            "title": "RGPD e CVO GBN-100521",
            "priority": "P3",
            "created_at": "22/01/2026 12:26:47",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 12:26:48"
          },
          {
            "ticket_id": 6866,
            "ticket_number": "356858",
            "title": "RGPD - Ariana Passos Gomes - 2415700060",
            "priority": "P3",
            "created_at": "22/01/2026 12:27:01",
            "close_date": "2026-01-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 12:27:03"
          },
          {
            "ticket_id": 6878,
            "ticket_number": "356870",
            "title": "RGPD e CVO GBN 100517",
            "priority": "P3",
            "created_at": "22/01/2026 14:20:35",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 14:20:36"
          },
          {
            "ticket_id": 6886,
            "ticket_number": "356878",
            "title": "Miguel Pinto - Reserva SERVANTRIP 3E4C8AA2 - Pedid",
            "priority": "P3",
            "created_at": "22/01/2026 15:19:30",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 15:19:30"
          },
          {
            "ticket_id": 6888,
            "ticket_number": "356880",
            "title": "Envio RGPD + CVO  GBN-100577",
            "priority": "P3",
            "created_at": "22/01/2026 16:20:53",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 16:20:53"
          },
          {
            "ticket_id": 6924,
            "ticket_number": "356916",
            "title": "Solicitação RGPD Solférias 425894 / 2026",
            "priority": "P3",
            "created_at": "22/01/2026 19:49:23",
            "close_date": "2026-01-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 19:49:24"
          },
          {
            "ticket_id": 6937,
            "ticket_number": "356929",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "22/01/2026 22:18:01",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 22:18:02"
          },
          {
            "ticket_id": 6938,
            "ticket_number": "356930",
            "title": "CIVITATIS - A36592209 - RGPD",
            "priority": "P3",
            "created_at": "22/01/2026 22:18:05",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "22/01/2026 22:18:06"
          },
          {
            "ticket_id": 6957,
            "ticket_number": "356949",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "23/01/2026 10:05:58",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:05:59"
          },
          {
            "ticket_id": 6960,
            "ticket_number": "356952",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "23/01/2026 10:06:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:06:05"
          },
          {
            "ticket_id": 6961,
            "ticket_number": "356953",
            "title": "Envio RGPD e CVO - Tiago Silva - GBN-100480",
            "priority": "P3",
            "created_at": "23/01/2026 10:06:08",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:06:08"
          },
          {
            "ticket_id": 6962,
            "ticket_number": "356954",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "23/01/2026 10:06:11",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 10:06:12"
          },
          {
            "ticket_id": 6994,
            "ticket_number": "356986",
            "title": "Chalong Chalet Resort  - GBN-86193",
            "priority": "P3",
            "created_at": "23/01/2026 14:56:09",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 14:56:09"
          },
          {
            "ticket_id": 7001,
            "ticket_number": "356993",
            "title": "CVO SPT002501553935",
            "priority": "P3",
            "created_at": "23/01/2026 15:41:20",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 15:41:20"
          },
          {
            "ticket_id": 7005,
            "ticket_number": "356997",
            "title": "Pedido de envio de RGPD e CVO - EMANUEL FERREIRA A",
            "priority": "P3",
            "created_at": "23/01/2026 16:04:01",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 16:04:02"
          },
          {
            "ticket_id": 7018,
            "ticket_number": "357010",
            "title": "Rgpd cvo_337322",
            "priority": "P3",
            "created_at": "23/01/2026 17:42:02",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 17:42:02"
          },
          {
            "ticket_id": 7026,
            "ticket_number": "357018",
            "title": "CVO + RGPD",
            "priority": "P3",
            "created_at": "23/01/2026 18:57:16",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 18:57:17"
          },
          {
            "ticket_id": 7044,
            "ticket_number": "357036",
            "title": "Laura Devesa - Reserva GBN 101091 - Pedido de RGPD",
            "priority": "P3",
            "created_at": "23/01/2026 22:13:04",
            "close_date": "2026-01-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 22:13:04"
          },
          {
            "ticket_id": 7046,
            "ticket_number": "357038",
            "title": "Pedido de informação",
            "priority": "P3",
            "created_at": "23/01/2026 22:29:27",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 22:29:28"
          },
          {
            "ticket_id": 7053,
            "ticket_number": "357045",
            "title": "RGPD e CVO",
            "priority": "P3",
            "created_at": "23/01/2026 23:20:01",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 23:20:01"
          },
          {
            "ticket_id": 7059,
            "ticket_number": "357051",
            "title": "RGPD e CVO SOLTOUR SPT002601575704",
            "priority": "P3",
            "created_at": "24/01/2026 00:01:48",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 00:01:49"
          },
          {
            "ticket_id": 7061,
            "ticket_number": "357053",
            "title": "RGPD - Beatriz Pereira de Oliveira Nascimento - 24",
            "priority": "P3",
            "created_at": "24/01/2026 00:01:57",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 00:01:57"
          },
          {
            "ticket_id": 7063,
            "ticket_number": "357055",
            "title": "RGPD - Pedro Miguel da Ressurreição Silva Ramos - ",
            "priority": "P3",
            "created_at": "24/01/2026 00:02:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 00:02:05"
          },
          {
            "ticket_id": 7070,
            "ticket_number": "357062",
            "title": "Opti242100193 _loc 425327",
            "priority": "P3",
            "created_at": "24/01/2026 09:59:35",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 63.23,
            "sla_met": false,
            "sla_breach_hours": 39.23,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 01:14:11"
          },
          {
            "ticket_id": 7071,
            "ticket_number": "357063",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "24/01/2026 09:59:37",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 09:59:37"
          },
          {
            "ticket_id": 7072,
            "ticket_number": "357064",
            "title": "RGPD E CVO",
            "priority": "P3",
            "created_at": "24/01/2026 10:29:54",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 10:29:54"
          },
          {
            "ticket_id": 7078,
            "ticket_number": "357070",
            "title": "RGPD -  Soltrópico - 337790",
            "priority": "P3",
            "created_at": "24/01/2026 13:12:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 13:12:26"
          },
          {
            "ticket_id": 7079,
            "ticket_number": "357071",
            "title": "RGPD - GBN - 101161",
            "priority": "P3",
            "created_at": "24/01/2026 13:12:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 13:12:28"
          },
          {
            "ticket_id": 7081,
            "ticket_number": "357073",
            "title": "David Fernandes - Reserva SMY 1239597920 - Pedido ",
            "priority": "P3",
            "created_at": "24/01/2026 14:52:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 14:52:12"
          },
          {
            "ticket_id": 7082,
            "ticket_number": "357074",
            "title": "Ana Baldaia - Reserva NEWBLUE 6129064 - Pedido de ",
            "priority": "P3",
            "created_at": "24/01/2026 14:52:19",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 14:52:19"
          },
          {
            "ticket_id": 7094,
            "ticket_number": "357086",
            "title": "SOLICITO RGPD E CVO - ISABEL MARIA PAREDES SALDANH",
            "priority": "P3",
            "created_at": "24/01/2026 18:57:26",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 18:57:27"
          },
          {
            "ticket_id": 7095,
            "ticket_number": "357087",
            "title": "Eduardo Silva - CVO + RGPD",
            "priority": "P3",
            "created_at": "24/01/2026 18:57:28",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/01/2026 18:57:29"
          },
          {
            "ticket_id": 7102,
            "ticket_number": "357094",
            "title": "Pedido RGPD  793408654 e 512554201] da TOMAZ DOURO",
            "priority": "P3",
            "created_at": "26/01/2026 10:06:23",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:06:23"
          },
          {
            "ticket_id": 7106,
            "ticket_number": "357098",
            "title": "Envio RGPD - UFEV- OPTI 2414000033",
            "priority": "P3",
            "created_at": "26/01/2026 10:07:09",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:07:09"
          },
          {
            "ticket_id": 7115,
            "ticket_number": "357107",
            "title": "RGPD para assinar",
            "priority": "P3",
            "created_at": "26/01/2026 10:08:44",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:08:45"
          },
          {
            "ticket_id": 7118,
            "ticket_number": "357110",
            "title": "RGPD_Maria Margarida Testos",
            "priority": "P3",
            "created_at": "26/01/2026 10:08:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:09:00"
          },
          {
            "ticket_id": 7119,
            "ticket_number": "357111",
            "title": "Envio RGPD",
            "priority": "P3",
            "created_at": "26/01/2026 10:09:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:09:06"
          },
          {
            "ticket_id": 7121,
            "ticket_number": "357113",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "26/01/2026 10:11:18",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:11:18"
          },
          {
            "ticket_id": 7140,
            "ticket_number": "357132",
            "title": "Re: Envio RGPD e CVO 248900038",
            "priority": "P3",
            "created_at": "26/01/2026 10:14:02",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 36.27,
            "sla_met": false,
            "sla_breach_hours": 12.27,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:30:11"
          },
          {
            "ticket_id": 7142,
            "ticket_number": "357134",
            "title": "RGPD - Solférias - 425456",
            "priority": "P3",
            "created_at": "26/01/2026 10:14:07",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:14:07"
          },
          {
            "ticket_id": 7151,
            "ticket_number": "357143",
            "title": "RGPD #260100075",
            "priority": "P3",
            "created_at": "26/01/2026 10:16:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:16:41"
          },
          {
            "ticket_id": 7152,
            "ticket_number": "357144",
            "title": "Envio RGPD - UFEV - OPTI 2414000034",
            "priority": "P3",
            "created_at": "26/01/2026 10:16:44",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:16:45"
          },
          {
            "ticket_id": 7165,
            "ticket_number": "357157",
            "title": "Envio RGPD + CVO",
            "priority": "P3",
            "created_at": "26/01/2026 10:19:22",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:19:22"
          },
          {
            "ticket_id": 7187,
            "ticket_number": "357179",
            "title": "Envio RGPD - UFEV - opti 2414000019",
            "priority": "P3",
            "created_at": "26/01/2026 10:26:59",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:26:59"
          },
          {
            "ticket_id": 7188,
            "ticket_number": "357180",
            "title": "Envio RGPD - UFEV - OPTI 2414000024",
            "priority": "P3",
            "created_at": "26/01/2026 10:27:05",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:27:06"
          },
          {
            "ticket_id": 7189,
            "ticket_number": "357181",
            "title": "Envio RGPD - UFEV, OPTI 2414000018",
            "priority": "P3",
            "created_at": "26/01/2026 10:27:12",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 10:27:12"
          },
          {
            "ticket_id": 7190,
            "ticket_number": "357182",
            "title": "Pedido de envio de RGPD e CVO - Cristina Patrícia ",
            "priority": "P3",
            "created_at": "26/01/2026 11:32:46",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 11:32:46"
          },
          {
            "ticket_id": 7194,
            "ticket_number": "357186",
            "title": "Pedido de envio de RGPD e CVO -Inês Cristiana Ferr",
            "priority": "P3",
            "created_at": "26/01/2026 11:32:54",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 11:32:55"
          },
          {
            "ticket_id": 7215,
            "ticket_number": "357207",
            "title": "Convite Evento Turismo da Suíça – Lisboa | 23 de f",
            "priority": "P2",
            "created_at": "26/01/2026 12:25:32",
            "close_date": "2026-01-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 16:22:29"
          },
          {
            "ticket_id": 7236,
            "ticket_number": "357228",
            "title": "RGPD_Manuel Gomes",
            "priority": "P3",
            "created_at": "26/01/2026 14:42:14",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 14:42:14"
          },
          {
            "ticket_id": 7240,
            "ticket_number": "357232",
            "title": "RE: PRESENÇA STAND W2M BTL 2026",
            "priority": "P2",
            "created_at": "26/01/2026 15:10:10",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 19:02:49"
          },
          {
            "ticket_id": 7255,
            "ticket_number": "357247",
            "title": "1240329535 XAVIER NEVES - opti242100192",
            "priority": "P3",
            "created_at": "26/01/2026 16:45:56",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 29.37,
            "sla_met": false,
            "sla_breach_hours": 5.37,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:08:24"
          },
          {
            "ticket_id": 7257,
            "ticket_number": "357249",
            "title": "opti 242100191",
            "priority": "P3",
            "created_at": "26/01/2026 17:08:13",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 29.03,
            "sla_met": false,
            "sla_breach_hours": 5.03,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:10:31"
          },
          {
            "ticket_id": 7262,
            "ticket_number": "357254",
            "title": "reserva 1239792144 - CVO E RGPD",
            "priority": "P3",
            "created_at": "26/01/2026 17:24:57",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 17:24:57"
          },
          {
            "ticket_id": 7278,
            "ticket_number": "357270",
            "title": "Pedido de envio de RGPG + CVO",
            "priority": "P3",
            "created_at": "26/01/2026 19:28:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 19:28:39"
          },
          {
            "ticket_id": 7293,
            "ticket_number": "357285",
            "title": "RGPD - Soltrópico - 338126",
            "priority": "P3",
            "created_at": "26/01/2026 23:27:04",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 23:27:05"
          },
          {
            "ticket_id": 7299,
            "ticket_number": "357291",
            "title": "ENVIO RGPD + CVO - OPTI Nº 2414900018",
            "priority": "P3",
            "created_at": "26/01/2026 23:35:55",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 23:35:56"
          },
          {
            "ticket_id": 7302,
            "ticket_number": "357294",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "26/01/2026 23:46:39",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/01/2026 23:46:40"
          },
          {
            "ticket_id": 7304,
            "ticket_number": "357296",
            "title": "ENVIO RGPD + CVO OPTI Nº 2414900019",
            "priority": "P3",
            "created_at": "27/01/2026 00:04:41",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 00:04:41"
          },
          {
            "ticket_id": 7313,
            "ticket_number": "357305",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "27/01/2026 10:10:30",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 10:10:30"
          },
          {
            "ticket_id": 7314,
            "ticket_number": "357306",
            "title": "RGPD OPTI 2416400024- José Filipe Santos Fonseca G",
            "priority": "P3",
            "created_at": "27/01/2026 10:10:34",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 10:10:34"
          },
          {
            "ticket_id": 7315,
            "ticket_number": "357307",
            "title": "Envio RGPD",
            "priority": "P3",
            "created_at": "27/01/2026 10:10:38",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 10:10:38"
          },
          {
            "ticket_id": 7318,
            "ticket_number": "357310",
            "title": "RGPD - Soltrópico - 338138",
            "priority": "P3",
            "created_at": "27/01/2026 10:10:48",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 10:10:49"
          },
          {
            "ticket_id": 7355,
            "ticket_number": "357347",
            "title": "Documentação para assinar",
            "priority": "P3",
            "created_at": "27/01/2026 14:41:30",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 14:41:30"
          },
          {
            "ticket_id": 7360,
            "ticket_number": "357352",
            "title": "RGPD_Marcia Matos",
            "priority": "P3",
            "created_at": "27/01/2026 15:08:20",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 15:08:20"
          },
          {
            "ticket_id": 7363,
            "ticket_number": "357355",
            "title": "Pagamento Kits BTL",
            "priority": "P2",
            "created_at": "27/01/2026 15:39:00",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/01/2026 15:39:01"
          },
          {
            "ticket_id": 7372,
            "ticket_number": "357364",
            "title": "Comprovativo Pagamento KIT + T-Shirt BLT",
            "priority": "P3",
            "created_at": "27/01/2026 16:28:00",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 16:28:00"
          },
          {
            "ticket_id": 7374,
            "ticket_number": "357366",
            "title": "Enviar RGPD",
            "priority": "P3",
            "created_at": "27/01/2026 16:33:56",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 16:33:56"
          },
          {
            "ticket_id": 7383,
            "ticket_number": "357375",
            "title": "opti242100196 - nb6129707",
            "priority": "P3",
            "created_at": "27/01/2026 17:01:11",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 30.82,
            "sla_met": false,
            "sla_breach_hours": 6.82,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 23:51:00"
          },
          {
            "ticket_id": 7384,
            "ticket_number": "357376",
            "title": "Fwd: GBN-101462 - Sua confirmação de reserva - OPT",
            "priority": "P3",
            "created_at": "27/01/2026 17:01:18",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 30.88,
            "sla_met": false,
            "sla_breach_hours": 6.88,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 23:54:46"
          },
          {
            "ticket_id": 7385,
            "ticket_number": "357377",
            "title": "GBN-101634 - Sua confirmação de reserva- OPTI24210",
            "priority": "P3",
            "created_at": "27/01/2026 17:02:04",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 254.65,
            "sla_met": false,
            "sla_breach_hours": 230.65,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 07:41:18"
          },
          {
            "ticket_id": 7387,
            "ticket_number": "357379",
            "title": "Re: RGPD cliente assinar",
            "priority": "P3",
            "created_at": "27/01/2026 17:08:14",
            "close_date": "2026-01-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 17:08:14"
          },
          {
            "ticket_id": 7414,
            "ticket_number": "357406",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "27/01/2026 18:44:49",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:44:50"
          },
          {
            "ticket_id": 7419,
            "ticket_number": "357411",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "27/01/2026 18:58:58",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 18:58:58"
          },
          {
            "ticket_id": 7421,
            "ticket_number": "357413",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "27/01/2026 19:14:42",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 19:14:42"
          },
          {
            "ticket_id": 7431,
            "ticket_number": "357423",
            "title": "RE: Uma Familia Em Viagem - Uma Familia Em Viagem ",
            "priority": "P3",
            "created_at": "27/01/2026 19:53:05",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 21.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 17:05:41"
          },
          {
            "ticket_id": 7433,
            "ticket_number": "357425",
            "title": "RE: Envio RGPD e CVO 2416400024",
            "priority": "P3",
            "created_at": "27/01/2026 19:53:11",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 21.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 17:10:24"
          },
          {
            "ticket_id": 7440,
            "ticket_number": "357432",
            "title": "pedido envio RGPD, cvo e outros",
            "priority": "P3",
            "created_at": "27/01/2026 20:13:32",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 20:13:33"
          },
          {
            "ticket_id": 7446,
            "ticket_number": "357438",
            "title": "doc assinar",
            "priority": "P3",
            "created_at": "27/01/2026 21:19:41",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 21:19:41"
          },
          {
            "ticket_id": 7447,
            "ticket_number": "357439",
            "title": "Documentação para assinar",
            "priority": "P3",
            "created_at": "27/01/2026 21:19:43",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 21:19:43"
          },
          {
            "ticket_id": 7448,
            "ticket_number": "357440",
            "title": "pedido envio documentos RGPD e Contrato e seguro",
            "priority": "P3",
            "created_at": "27/01/2026 21:38:52",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 21:38:53"
          },
          {
            "ticket_id": 7449,
            "ticket_number": "357441",
            "title": "Fwd: Documentación Reserva: 6127890 + 6127888 - op",
            "priority": "P3",
            "created_at": "27/01/2026 21:39:13",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 26.38,
            "sla_met": false,
            "sla_breach_hours": 2.38,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 00:02:25"
          },
          {
            "ticket_id": 7450,
            "ticket_number": "357442",
            "title": "pedido RGPD e CVO Opti 242600006",
            "priority": "P3",
            "created_at": "27/01/2026 21:39:15",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 20.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:03:07"
          },
          {
            "ticket_id": 7451,
            "ticket_number": "357443",
            "title": "Solicitação RGPD",
            "priority": "P3",
            "created_at": "27/01/2026 21:41:57",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 21:41:57"
          },
          {
            "ticket_id": 7453,
            "ticket_number": "357445",
            "title": "pedido envio rgpd e cvo Newlue - 6129184 Seguro In",
            "priority": "P3",
            "created_at": "27/01/2026 21:46:30",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 21:46:30"
          },
          {
            "ticket_id": 7454,
            "ticket_number": "357446",
            "title": "envio rgpd e cvo Newlue - 6129187 Seguro Insure Si",
            "priority": "P3",
            "created_at": "27/01/2026 22:02:32",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:02:33"
          },
          {
            "ticket_id": 7456,
            "ticket_number": "357448",
            "title": "envio rgpd e cvo e seguro basico viagem Newlue - 6",
            "priority": "P3",
            "created_at": "27/01/2026 22:02:52",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:02:53"
          },
          {
            "ticket_id": 7461,
            "ticket_number": "357453",
            "title": "GBN-101909",
            "priority": "P3",
            "created_at": "27/01/2026 22:32:32",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 22:32:32"
          },
          {
            "ticket_id": 7465,
            "ticket_number": "357457",
            "title": "Pedido de envio de RGPD - Sara Alexandra Serra Ras",
            "priority": "P3",
            "created_at": "27/01/2026 23:20:24",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/01/2026 23:20:25"
          },
          {
            "ticket_id": 7466,
            "ticket_number": "357458",
            "title": "loc338299-opti 242100200",
            "priority": "P3",
            "created_at": "27/01/2026 23:32:46",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 24.17,
            "sla_met": false,
            "sla_breach_hours": 0.17,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 23:42:53"
          },
          {
            "ticket_id": 7469,
            "ticket_number": "357461",
            "title": "RGPD - Miguel Ângelo da Cunha Silva - 247600084",
            "priority": "P3",
            "created_at": "28/01/2026 00:01:01",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 00:01:01"
          },
          {
            "ticket_id": 7470,
            "ticket_number": "357462",
            "title": "RGPD | reserva GBN-101926 | OPTI - 248500065",
            "priority": "P3",
            "created_at": "28/01/2026 00:01:04",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 00:01:04"
          },
          {
            "ticket_id": 7474,
            "ticket_number": "357466",
            "title": "RGPD - Joana Isabel Pequeno de Oliveira - 24760008",
            "priority": "P3",
            "created_at": "28/01/2026 10:26:42",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:26:42"
          },
          {
            "ticket_id": 7477,
            "ticket_number": "357469",
            "title": "RGPD - Ricardo Jorge Ribeiro Vieira - 2415700062",
            "priority": "P3",
            "created_at": "28/01/2026 10:28:06",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:28:06"
          },
          {
            "ticket_id": 7478,
            "ticket_number": "357470",
            "title": "Confirmação de CVO/RGPD",
            "priority": "P3",
            "created_at": "28/01/2026 10:28:09",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:28:09"
          },
          {
            "ticket_id": 7479,
            "ticket_number": "357471",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "28/01/2026 10:28:13",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:28:14"
          },
          {
            "ticket_id": 7480,
            "ticket_number": "357472",
            "title": "RGPD - Cátia Sofia Nunes Gomes - 2415700063",
            "priority": "P3",
            "created_at": "28/01/2026 10:28:17",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:28:17"
          },
          {
            "ticket_id": 7481,
            "ticket_number": "357473",
            "title": "338301- Soltropico",
            "priority": "P3",
            "created_at": "28/01/2026 10:28:21",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:28:21"
          },
          {
            "ticket_id": 7489,
            "ticket_number": "357481",
            "title": "FW: [ ### EXTERNO ### ] Envio RGPD e CVO 241470008",
            "priority": "P3",
            "created_at": "28/01/2026 10:29:53",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 8.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:39:11"
          },
          {
            "ticket_id": 7494,
            "ticket_number": "357486",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "28/01/2026 10:31:15",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 10:31:15"
          },
          {
            "ticket_id": 7501,
            "ticket_number": "357493",
            "title": "RGPD - GBN - 101852",
            "priority": "P3",
            "created_at": "28/01/2026 12:26:34",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 12:26:35"
          },
          {
            "ticket_id": 7502,
            "ticket_number": "357494",
            "title": "RGPD+CVO - GBN 101683",
            "priority": "P3",
            "created_at": "28/01/2026 12:26:42",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 12:26:42"
          },
          {
            "ticket_id": 7505,
            "ticket_number": "357497",
            "title": "RGPD - GBN - 101842",
            "priority": "P3",
            "created_at": "28/01/2026 12:27:20",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 12:27:20"
          },
          {
            "ticket_id": 7508,
            "ticket_number": "357500",
            "title": "Ana Cunha - Reserva SMY 1241323553 - Pedido de RGP",
            "priority": "P3",
            "created_at": "28/01/2026 15:45:32",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:45:32"
          },
          {
            "ticket_id": 7510,
            "ticket_number": "357502",
            "title": "Re: Envio RGPD e CVO 248900038",
            "priority": "P3",
            "created_at": "28/01/2026 15:45:36",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:53:26"
          },
          {
            "ticket_id": 7514,
            "ticket_number": "357506",
            "title": "Pedido Rgpd e cvo- 337907",
            "priority": "P3",
            "created_at": "28/01/2026 15:45:50",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:45:50"
          },
          {
            "ticket_id": 7518,
            "ticket_number": "357510",
            "title": "RGPD_Sara Nobre",
            "priority": "P3",
            "created_at": "28/01/2026 15:46:00",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:46:00"
          },
          {
            "ticket_id": 7525,
            "ticket_number": "357517",
            "title": "Book&Go | Questionário de Utilização e Melhoria",
            "priority": "P2",
            "created_at": "28/01/2026 15:46:18",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 19:41:51"
          },
          {
            "ticket_id": 7526,
            "ticket_number": "357518",
            "title": "rgpd LUIS GASPAR",
            "priority": "P3",
            "created_at": "28/01/2026 15:46:21",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:46:21"
          },
          {
            "ticket_id": 7527,
            "ticket_number": "357519",
            "title": "CVO + RGPD",
            "priority": "P3",
            "created_at": "28/01/2026 15:46:24",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:46:24"
          },
          {
            "ticket_id": 7528,
            "ticket_number": "357520",
            "title": "CVO + RGPD",
            "priority": "P3",
            "created_at": "28/01/2026 15:46:26",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 15:46:26"
          },
          {
            "ticket_id": 7530,
            "ticket_number": "357522",
            "title": "Convite BTL",
            "priority": "P2",
            "created_at": "28/01/2026 15:47:02",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 15:47:02"
          },
          {
            "ticket_id": 7531,
            "ticket_number": "357523",
            "title": "Convite BTL",
            "priority": "P2",
            "created_at": "28/01/2026 15:47:04",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 15:47:04"
          },
          {
            "ticket_id": 7536,
            "ticket_number": "357528",
            "title": "Comprovativo Transferência para Kit Consultor + t-",
            "priority": "P2",
            "created_at": "28/01/2026 16:34:51",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 16:34:52"
          },
          {
            "ticket_id": 7537,
            "ticket_number": "357529",
            "title": "RGPD - Sara Campos de Almeida - 2415700064",
            "priority": "P3",
            "created_at": "28/01/2026 16:34:53",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 16:34:54"
          },
          {
            "ticket_id": 7542,
            "ticket_number": "357534",
            "title": "Opti 249100042_Marta Duarte",
            "priority": "P2",
            "created_at": "28/01/2026 17:16:57",
            "close_date": "2026-01-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/01/2026 17:16:57"
          },
          {
            "ticket_id": 7547,
            "ticket_number": "357539",
            "title": "RGPD - Leandro Miguel Monteiro Correia - 241570006",
            "priority": "P3",
            "created_at": "28/01/2026 18:06:22",
            "close_date": "2026-01-28",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "28/01/2026 18:06:22"
          },
          {
            "ticket_id": 7572,
            "ticket_number": "357564",
            "title": "Envio RGPD _ GBN-101276",
            "priority": "P3",
            "created_at": "29/01/2026 10:23:25",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:23:26"
          },
          {
            "ticket_id": 7579,
            "ticket_number": "357571",
            "title": "RGPD GBN-101215",
            "priority": "P3",
            "created_at": "29/01/2026 10:24:48",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:24:48"
          },
          {
            "ticket_id": 7587,
            "ticket_number": "357579",
            "title": "Re: Envio RGPD e CVO 2413800026",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:14",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:20:36"
          },
          {
            "ticket_id": 7593,
            "ticket_number": "357585",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:31",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:31"
          },
          {
            "ticket_id": 7595,
            "ticket_number": "357587",
            "title": "RGPD+CVO - GBN 102156",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:37",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:38"
          },
          {
            "ticket_id": 7596,
            "ticket_number": "357588",
            "title": "SMY - 1241586163 - RGPD e CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:43",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:44"
          },
          {
            "ticket_id": 7597,
            "ticket_number": "357589",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:46",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:47"
          },
          {
            "ticket_id": 7599,
            "ticket_number": "357591",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:53",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:54"
          },
          {
            "ticket_id": 7600,
            "ticket_number": "357592",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:27:56",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:27:56"
          },
          {
            "ticket_id": 7601,
            "ticket_number": "357593",
            "title": "SOLICITO RGPD E CVO - JOANA CRISTINA SOUSA CARNEIR",
            "priority": "P3",
            "created_at": "29/01/2026 10:28:00",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:28:00"
          },
          {
            "ticket_id": 7603,
            "ticket_number": "357595",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "29/01/2026 10:28:05",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:28:05"
          },
          {
            "ticket_id": 7607,
            "ticket_number": "357599",
            "title": "RGPD SMY 1236689700",
            "priority": "P3",
            "created_at": "29/01/2026 10:28:17",
            "close_date": "2026-01-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 10:28:18"
          },
          {
            "ticket_id": 7614,
            "ticket_number": "357606",
            "title": "Nova reserva - loc: 338415 & opti: 248000036 | env",
            "priority": "P2",
            "created_at": "29/01/2026 10:31:43",
            "close_date": "2026-01-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 10:31:43"
          },
          {
            "ticket_id": 7619,
            "ticket_number": "357611",
            "title": "Convite | Formação Lusanova | 5 de fevereiro | Lis",
            "priority": "P2",
            "created_at": "29/01/2026 11:19:34",
            "close_date": "2026-01-30",
            "sla_target_hours": 4,
            "actual_time_hours": 36.13,
            "sla_met": false,
            "sla_breach_hours": 32.13,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:28:18"
          },
          {
            "ticket_id": 7640,
            "ticket_number": "357632",
            "title": "GBN-102255 - OPTI242100201",
            "priority": "P2",
            "created_at": "29/01/2026 14:08:55",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 18:03:22"
          },
          {
            "ticket_id": 7641,
            "ticket_number": "357633",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "29/01/2026 15:14:23",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 15:14:23"
          },
          {
            "ticket_id": 7643,
            "ticket_number": "357635",
            "title": "Comprovativo Kit e Convite BTL",
            "priority": "P2",
            "created_at": "29/01/2026 15:14:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 15:14:31"
          },
          {
            "ticket_id": 7649,
            "ticket_number": "357641",
            "title": "TOUR10 3732446 - Solicitação de valores para emiss",
            "priority": "P3",
            "created_at": "29/01/2026 15:14:59",
            "close_date": "2026-04-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 15:14:59"
          },
          {
            "ticket_id": 7653,
            "ticket_number": "357645",
            "title": "Nova reserva New Blue |  6130386 & 248000037",
            "priority": "P3",
            "created_at": "29/01/2026 15:54:37",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "29/01/2026 15:54:38"
          },
          {
            "ticket_id": 7658,
            "ticket_number": "357650",
            "title": "BTL",
            "priority": "P2",
            "created_at": "29/01/2026 16:31:21",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:31:21"
          },
          {
            "ticket_id": 7663,
            "ticket_number": "357655",
            "title": "Comprovativo T-shirt adicional BTL",
            "priority": "P2",
            "created_at": "29/01/2026 16:31:36",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:31:36"
          },
          {
            "ticket_id": 7686,
            "ticket_number": "357678",
            "title": "RGPD localizador 4054602 TOUR10",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:11",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:11"
          },
          {
            "ticket_id": 7692,
            "ticket_number": "357684",
            "title": "RE: Envio RGPD e CVO 24100887",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:26",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 24.35,
            "sla_met": false,
            "sla_breach_hours": 0.35,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 10:29:34"
          },
          {
            "ticket_id": 7693,
            "ticket_number": "357685",
            "title": "Contracto + RGPD - João Vieira - Porto Santo",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:29",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:29"
          },
          {
            "ticket_id": 7695,
            "ticket_number": "357687",
            "title": "Nova reserva GBN-102509 &",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:34",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:34"
          },
          {
            "ticket_id": 7698,
            "ticket_number": "357690",
            "title": "RGPD - Andreia Filipa Santos Mendes - 247600086",
            "priority": "P3",
            "created_at": "30/01/2026 10:08:42",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:08:43"
          },
          {
            "ticket_id": 7704,
            "ticket_number": "357696",
            "title": "RGPD - GBN - 102450",
            "priority": "P3",
            "created_at": "30/01/2026 10:09:00",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:09:00"
          },
          {
            "ticket_id": 7706,
            "ticket_number": "357698",
            "title": "RGPD - GBN - 102498",
            "priority": "P3",
            "created_at": "30/01/2026 10:09:06",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:09:06"
          },
          {
            "ticket_id": 7710,
            "ticket_number": "357702",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "30/01/2026 10:10:01",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:10:01"
          },
          {
            "ticket_id": 7717,
            "ticket_number": "357709",
            "title": "Pedido Envio RGPD + CVO - ViajarTours - 210951",
            "priority": "P3",
            "created_at": "30/01/2026 10:10:50",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:10:52"
          },
          {
            "ticket_id": 7718,
            "ticket_number": "357710",
            "title": "RGPD para Cliente assinar",
            "priority": "P3",
            "created_at": "30/01/2026 10:10:55",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:10:55"
          },
          {
            "ticket_id": 7723,
            "ticket_number": "357715",
            "title": "[agencias1] CONVITE: Participe do nosso webinar di",
            "priority": "P2",
            "created_at": "30/01/2026 10:11:59",
            "close_date": "2026-02-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 14:04:42"
          },
          {
            "ticket_id": 7741,
            "ticket_number": "357733",
            "title": "Envio RGPD - UFEV- OPTI 2414000033",
            "priority": "P3",
            "created_at": "30/01/2026 10:23:42",
            "close_date": "2026-01-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 10:23:42"
          },
          {
            "ticket_id": 7752,
            "ticket_number": "357744",
            "title": "Ticket Recebido - 244480 Acesso a uma sandbox de t",
            "priority": "P2",
            "created_at": "30/01/2026 13:15:49",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 95.93,
            "sla_met": false,
            "sla_breach_hours": 91.93,
            "sla_name": "SLA P2",
            "first_response_at": "03/02/2026 13:12:36"
          },
          {
            "ticket_id": 7764,
            "ticket_number": "357756",
            "title": "Envio RGPD e CVO | João Oliveira OPTI 245700027",
            "priority": "P2",
            "created_at": "30/01/2026 13:16:43",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:16:43"
          },
          {
            "ticket_id": 7771,
            "ticket_number": "357763",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "30/01/2026 13:17:05",
            "close_date": "2026-02-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 16:44:25"
          },
          {
            "ticket_id": 7774,
            "ticket_number": "357766",
            "title": "BTL - pagamento Kits",
            "priority": "P2",
            "created_at": "30/01/2026 13:17:21",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:17:22"
          },
          {
            "ticket_id": 7781,
            "ticket_number": "357773",
            "title": "Solicitação envio RGPD | Consolidador | PNR FSFJQQ",
            "priority": "P2",
            "created_at": "30/01/2026 13:38:08",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 13:38:09"
          },
          {
            "ticket_id": 7802,
            "ticket_number": "357794",
            "title": "Pedido de RGPD",
            "priority": "P2",
            "created_at": "30/01/2026 16:12:42",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 16:12:43"
          },
          {
            "ticket_id": 7804,
            "ticket_number": "357796",
            "title": "Solicitação envio RGPD | GBN-102597",
            "priority": "P2",
            "created_at": "30/01/2026 16:12:52",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 16:12:52"
          },
          {
            "ticket_id": 7807,
            "ticket_number": "357799",
            "title": "rgpd e contrato em falta Newblue 612918",
            "priority": "P2",
            "created_at": "30/01/2026 16:13:05",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 16:13:05"
          },
          {
            "ticket_id": 7826,
            "ticket_number": "357818",
            "title": "Pagamento BTL",
            "priority": "P2",
            "created_at": "30/01/2026 18:55:50",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:55:50"
          },
          {
            "ticket_id": 7827,
            "ticket_number": "357819",
            "title": "Pedido RGPD reserva Wizz Air localizador STIMRE",
            "priority": "P2",
            "created_at": "30/01/2026 18:55:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:55:52"
          },
          {
            "ticket_id": 7830,
            "ticket_number": "357822",
            "title": "Pedido de envio RGPD",
            "priority": "P2",
            "created_at": "30/01/2026 18:56:05",
            "close_date": "2026-01-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:56:05"
          },
          {
            "ticket_id": 7831,
            "ticket_number": "357823",
            "title": "Comprovativo pagamento kit BTL",
            "priority": "P2",
            "created_at": "30/01/2026 18:56:39",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:56:40"
          },
          {
            "ticket_id": 7834,
            "ticket_number": "357826",
            "title": "Comprovativo BTL - Sílvia Milheiro",
            "priority": "P2",
            "created_at": "30/01/2026 18:56:55",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 18:56:55"
          },
          {
            "ticket_id": 7844,
            "ticket_number": "357836",
            "title": "RGPD + CVO_Id.Reserva SPT002601580753",
            "priority": "P3",
            "created_at": "30/01/2026 19:28:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 19:28:45"
          },
          {
            "ticket_id": 7846,
            "ticket_number": "357838",
            "title": "RGPD + CVO_Id.Reserva SPT002601580753",
            "priority": "P3",
            "created_at": "30/01/2026 19:28:48",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 19:28:49"
          },
          {
            "ticket_id": 7847,
            "ticket_number": "357839",
            "title": "Pedido Envio RGPD + CVO - Soltropico - 338629",
            "priority": "P3",
            "created_at": "30/01/2026 19:28:51",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 19:28:51"
          },
          {
            "ticket_id": 7852,
            "ticket_number": "357844",
            "title": "Pedido de envio de RGPG + CVO",
            "priority": "P2",
            "created_at": "30/01/2026 19:37:00",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 19:37:00"
          },
          {
            "ticket_id": 7859,
            "ticket_number": "357851",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "30/01/2026 20:19:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:19:03"
          },
          {
            "ticket_id": 7862,
            "ticket_number": "357854",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "30/01/2026 20:59:47",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/01/2026 20:59:48"
          },
          {
            "ticket_id": 7867,
            "ticket_number": "357859",
            "title": "Pedro Coelho BTL e kit",
            "priority": "P2",
            "created_at": "30/01/2026 23:10:49",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:10:50"
          },
          {
            "ticket_id": 7869,
            "ticket_number": "357861",
            "title": "enviar RGPD Anabela - newblue 6130007",
            "priority": "P2",
            "created_at": "30/01/2026 23:10:55",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:10:56"
          },
          {
            "ticket_id": 7872,
            "ticket_number": "357864",
            "title": "Pedido de RGPD - Localizador 6130704 New Blue",
            "priority": "P2",
            "created_at": "30/01/2026 23:11:03",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:11:03"
          },
          {
            "ticket_id": 7873,
            "ticket_number": "357865",
            "title": "Pedido RGPD e CVO",
            "priority": "P2",
            "created_at": "30/01/2026 23:11:05",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:11:05"
          },
          {
            "ticket_id": 7874,
            "ticket_number": "357866",
            "title": "Envio RGPD e CVO",
            "priority": "P2",
            "created_at": "30/01/2026 23:11:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:11:07"
          },
          {
            "ticket_id": 7875,
            "ticket_number": "357867",
            "title": "RGPD",
            "priority": "P2",
            "created_at": "30/01/2026 23:11:09",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:11:09"
          },
          {
            "ticket_id": 7879,
            "ticket_number": "357871",
            "title": "BTL pagamento",
            "priority": "P2",
            "created_at": "30/01/2026 23:11:24",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:11:25"
          },
          {
            "ticket_id": 7884,
            "ticket_number": "357876",
            "title": "Pedido Envio RGPD + CVO - Tour10 - 4056308",
            "priority": "P2",
            "created_at": "30/01/2026 23:23:13",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/01/2026 23:23:13"
          },
          {
            "ticket_id": 7885,
            "ticket_number": "357877",
            "title": "Fwd: Envio RGPD-CVO - GBN-102574 - Servantrip 3E62",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:30",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:31"
          },
          {
            "ticket_id": 7886,
            "ticket_number": "357878",
            "title": "Envio de RGPD e CVO",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:32",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:33"
          },
          {
            "ticket_id": 7888,
            "ticket_number": "357880",
            "title": "Envio RGPD-CVO - GBN-102574 - Servantrip 3E62E383",
            "priority": "P2",
            "created_at": "31/01/2026 00:09:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:09:37"
          },
          {
            "ticket_id": 7895,
            "ticket_number": "357887",
            "title": "Envio de RGPD e CVO",
            "priority": "P2",
            "created_at": "31/01/2026 00:10:24",
            "close_date": "2026-02-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 00:10:24"
          },
          {
            "ticket_id": 7908,
            "ticket_number": "357900",
            "title": "Pagamento BTL",
            "priority": "P2",
            "created_at": "31/01/2026 13:03:40",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/01/2026 13:03:40"
          },
          {
            "ticket_id": 7912,
            "ticket_number": "357904",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "31/01/2026 14:19:18",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 14:19:19"
          },
          {
            "ticket_id": 7913,
            "ticket_number": "357905",
            "title": "Enviar RGPD Joana  - solferias Localizador: 427856",
            "priority": "P3",
            "created_at": "31/01/2026 14:19:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 14:19:21"
          },
          {
            "ticket_id": 7924,
            "ticket_number": "357916",
            "title": "6131115 - NEWBLUE",
            "priority": "P3",
            "created_at": "31/01/2026 16:38:25",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 16:38:25"
          },
          {
            "ticket_id": 7926,
            "ticket_number": "357918",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "31/01/2026 16:42:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 16:42:45"
          },
          {
            "ticket_id": 7927,
            "ticket_number": "357919",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "31/01/2026 17:35:23",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 17:35:23"
          },
          {
            "ticket_id": 7928,
            "ticket_number": "357920",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "31/01/2026 17:35:26",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 17:35:26"
          },
          {
            "ticket_id": 7929,
            "ticket_number": "357921",
            "title": "Solicitação de de envio de RGDP e CVO",
            "priority": "P3",
            "created_at": "31/01/2026 17:35:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/01/2026 17:35:28"
          },
          {
            "ticket_id": 7952,
            "ticket_number": "357944",
            "title": "Helder Silva - Reserva SMY 1243185860 - Pedido de ",
            "priority": "P3",
            "created_at": "02/02/2026 10:08:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:08:52"
          },
          {
            "ticket_id": 7964,
            "ticket_number": "357956",
            "title": "Envio RGPD - UFEV - OPTI 2414000036",
            "priority": "P3",
            "created_at": "02/02/2026 10:14:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:14:39"
          },
          {
            "ticket_id": 7970,
            "ticket_number": "357962",
            "title": "RGPD LOCALIZADOR 6130276",
            "priority": "P3",
            "created_at": "02/02/2026 10:15:11",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:15:11"
          },
          {
            "ticket_id": 7971,
            "ticket_number": "357963",
            "title": "Re: Envio RGPD e CVO 2510000001",
            "priority": "P3",
            "created_at": "02/02/2026 10:15:13",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 15.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 02:09:06"
          },
          {
            "ticket_id": 7981,
            "ticket_number": "357973",
            "title": "RGPD - Soltrópico - 338772",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:00",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:00"
          },
          {
            "ticket_id": 7984,
            "ticket_number": "357976",
            "title": "Pedro Cardoso - Reserva GBN 102812 - Pedido de RGP",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:17",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:18"
          },
          {
            "ticket_id": 7985,
            "ticket_number": "357977",
            "title": "Opti 249100043_Vera Ferreira",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:20"
          },
          {
            "ticket_id": 7986,
            "ticket_number": "357978",
            "title": "Pedro Cardoso - Reserva SMY 1242485780 - Pedido de",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:22",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:22"
          },
          {
            "ticket_id": 7993,
            "ticket_number": "357985",
            "title": "RGPD e CVO   GBN-102930",
            "priority": "P3",
            "created_at": "02/02/2026 10:17:53",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:17:54"
          },
          {
            "ticket_id": 7998,
            "ticket_number": "357990",
            "title": "RGPD_Sérgio Bragança ",
            "priority": "P3",
            "created_at": "02/02/2026 10:18:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:18:37"
          },
          {
            "ticket_id": 8005,
            "ticket_number": "357997",
            "title": "Pedido de Envio de RGPD",
            "priority": "P3",
            "created_at": "02/02/2026 10:19:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:19:08"
          },
          {
            "ticket_id": 8006,
            "ticket_number": "357998",
            "title": "CVO + RGPD Localizador GBN-102950 - consumo própri",
            "priority": "P3",
            "created_at": "02/02/2026 10:19:11",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:19:11"
          },
          {
            "ticket_id": 8007,
            "ticket_number": "357999",
            "title": "1242936066 - Smy Travel",
            "priority": "P3",
            "created_at": "02/02/2026 10:19:52",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:19:52"
          },
          {
            "ticket_id": 8018,
            "ticket_number": "358010",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:28",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:29"
          },
          {
            "ticket_id": 8021,
            "ticket_number": "358013",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:37",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:38"
          },
          {
            "ticket_id": 8023,
            "ticket_number": "358015",
            "title": "GBN - 102972 - RGPD",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:45"
          },
          {
            "ticket_id": 8027,
            "ticket_number": "358019",
            "title": "RGPD - TravelPlan - 604540064",
            "priority": "P3",
            "created_at": "02/02/2026 10:22:58",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:22:59"
          },
          {
            "ticket_id": 8033,
            "ticket_number": "358025",
            "title": "Antonio Tavares - Reserva SMY 1243163838 - Pedido ",
            "priority": "P3",
            "created_at": "02/02/2026 10:23:50",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:23:51"
          },
          {
            "ticket_id": 8034,
            "ticket_number": "358026",
            "title": "RGPD - Raquel Afonso de Bastos - 2415700066",
            "priority": "P3",
            "created_at": "02/02/2026 10:23:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:23:54"
          },
          {
            "ticket_id": 8044,
            "ticket_number": "358036",
            "title": "Pedido Envio RGPD + CVO - Soltropico - 338629",
            "priority": "P3",
            "created_at": "02/02/2026 10:48:29",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 10:48:30"
          },
          {
            "ticket_id": 8050,
            "ticket_number": "358042",
            "title": "Envio de RGPD",
            "priority": "P3",
            "created_at": "02/02/2026 12:48:51",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:48:51"
          },
          {
            "ticket_id": 8052,
            "ticket_number": "358044",
            "title": "Pedido de envio de RGPD e CVO - Cátia Alexandra Go",
            "priority": "P3",
            "created_at": "02/02/2026 12:48:55",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:48:56"
          },
          {
            "ticket_id": 8056,
            "ticket_number": "358048",
            "title": "Pagamento BTL",
            "priority": "P3",
            "created_at": "02/02/2026 12:49:08",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:49:09"
          },
          {
            "ticket_id": 8058,
            "ticket_number": "358050",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "02/02/2026 12:49:13",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:49:13"
          },
          {
            "ticket_id": 8066,
            "ticket_number": "358058",
            "title": "Comprovativo Turno BTL",
            "priority": "P3",
            "created_at": "02/02/2026 12:49:58",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 12:49:59"
          },
          {
            "ticket_id": 8070,
            "ticket_number": "358062",
            "title": "CVO e RGPD OPTI 2418700030",
            "priority": "P3",
            "created_at": "02/02/2026 13:17:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 13:17:46"
          },
          {
            "ticket_id": 8080,
            "ticket_number": "358072",
            "title": "ENVIO RGPD + CVO OPTI Nº 2414900020",
            "priority": "P3",
            "created_at": "02/02/2026 14:45:44",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:45:44"
          },
          {
            "ticket_id": 8081,
            "ticket_number": "358073",
            "title": "Pedido RGPD e CVO",
            "priority": "P3",
            "created_at": "02/02/2026 14:45:46",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 14:45:47"
          },
          {
            "ticket_id": 8088,
            "ticket_number": "358080",
            "title": "António Tavares - Reserva SERVANTRIP 5AFA5313 - Pe",
            "priority": "P3",
            "created_at": "02/02/2026 16:38:01",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 16:38:02"
          },
          {
            "ticket_id": 8089,
            "ticket_number": "358081",
            "title": "Nova reserva - envio  de doc VG64743395 (Insure Si",
            "priority": "P3",
            "created_at": "02/02/2026 16:39:09",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 16:39:10"
          },
          {
            "ticket_id": 8090,
            "ticket_number": "358082",
            "title": "GBN-102937 - Paula Susana Viana Bessa",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 16:39:12",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 16:39:12"
          },
          {
            "ticket_id": 8097,
            "ticket_number": "358089",
            "title": "RGPD - TravelPlan - 604540064",
            "priority": "P3",
            "created_at": "02/02/2026 17:12:27",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 17:12:27"
          },
          {
            "ticket_id": 8098,
            "ticket_number": "358090",
            "title": "RGPD - EasyJet - KC1CD7T",
            "priority": "P3",
            "created_at": "02/02/2026 17:12:32",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 17:12:32"
          },
          {
            "ticket_id": 8099,
            "ticket_number": "358091",
            "title": "CVO e RGPD",
            "priority": "P3",
            "created_at": "02/02/2026 17:12:35",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 17:12:35"
          },
          {
            "ticket_id": 8100,
            "ticket_number": "358092",
            "title": "rgpd",
            "priority": "P3",
            "created_at": "02/02/2026 17:12:36",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 17:12:37"
          },
          {
            "ticket_id": 8113,
            "ticket_number": "358105",
            "title": "Envio rgpd",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 18:25:07",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 18:25:07"
          },
          {
            "ticket_id": 8123,
            "ticket_number": "358115",
            "title": "CVO e RGPD da Reserva da Solférias Loc 425983/2026",
            "priority": "P3",
            "created_at": "02/02/2026 20:36:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 20:36:15"
          },
          {
            "ticket_id": 8124,
            "ticket_number": "358116",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "02/02/2026 20:36:18",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 20:36:19"
          },
          {
            "ticket_id": 8127,
            "ticket_number": "358119",
            "title": "BTL - dia 26/2 - Para Carolina",
            "priority": "P2",
            "created_at": "02/02/2026 21:35:18",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 21:35:18"
          },
          {
            "ticket_id": 8130,
            "ticket_number": "358122",
            "title": "Solicitação RGPD SMY 1243552211",
            "priority": "Reservas sem Formulário",
            "created_at": "02/02/2026 22:45:38",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "02/02/2026 22:45:38"
          },
          {
            "ticket_id": 8135,
            "ticket_number": "358127",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "02/02/2026 23:50:56",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:50:56"
          },
          {
            "ticket_id": 8136,
            "ticket_number": "358128",
            "title": "Envio RGPD + CVO",
            "priority": "P3",
            "created_at": "02/02/2026 23:50:59",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:51:00"
          },
          {
            "ticket_id": 8138,
            "ticket_number": "358130",
            "title": "RGPD - OPTI 2416400022 - Inês Ribeiro de Carvalho ",
            "priority": "P3",
            "created_at": "02/02/2026 23:51:09",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:51:10"
          },
          {
            "ticket_id": 8139,
            "ticket_number": "358131",
            "title": "Envio CVO + RGPD",
            "priority": "P3",
            "created_at": "02/02/2026 23:51:15",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:51:15"
          },
          {
            "ticket_id": 8140,
            "ticket_number": "358132",
            "title": "Envio CVO + RGP",
            "priority": "P3",
            "created_at": "02/02/2026 23:51:19",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:51:20"
          },
          {
            "ticket_id": 8141,
            "ticket_number": "358133",
            "title": "RGPD - OPTI 2416400021 e 2416400010 - Carolina Fer",
            "priority": "P3",
            "created_at": "02/02/2026 23:51:22",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/02/2026 23:51:22"
          },
          {
            "ticket_id": 8143,
            "ticket_number": "358135",
            "title": "Dupla na BTL no Turno 2",
            "priority": "P2",
            "created_at": "02/02/2026 23:54:04",
            "close_date": "2026-02-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 23:54:05"
          },
          {
            "ticket_id": 8147,
            "ticket_number": "358139",
            "title": "GBN-103272",
            "priority": "P3",
            "created_at": "03/02/2026 10:00:57",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:00:58"
          },
          {
            "ticket_id": 8156,
            "ticket_number": "358148",
            "title": "Pedido RGPD localizador 1243551905 SMY TRAVEL e PP",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:04",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:05"
          },
          {
            "ticket_id": 8158,
            "ticket_number": "358150",
            "title": "RGPD e CVO para LE PLAN 604541477",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:16",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:17"
          },
          {
            "ticket_id": 8159,
            "ticket_number": "358151",
            "title": "Envio RGPD",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:20",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:22"
          },
          {
            "ticket_id": 8161,
            "ticket_number": "358153",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:27",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:28"
          },
          {
            "ticket_id": 8163,
            "ticket_number": "358155",
            "title": "Sara Pinto - Reserva SMY 1243678061 - Pedido de RG",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:34",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:34"
          },
          {
            "ticket_id": 8164,
            "ticket_number": "358156",
            "title": "Sergio  Pinto - Reserva FLEXIBLE AUTO PP188133 - P",
            "priority": "P3",
            "created_at": "03/02/2026 10:03:36",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:03:36"
          },
          {
            "ticket_id": 8165,
            "ticket_number": "358157",
            "title": "Bilhete BTL",
            "priority": "P3",
            "created_at": "03/02/2026 10:13:49",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:13:50"
          },
          {
            "ticket_id": 8167,
            "ticket_number": "358159",
            "title": "BTL",
            "priority": "P3",
            "created_at": "03/02/2026 10:13:54",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 10:13:55"
          },
          {
            "ticket_id": 8186,
            "ticket_number": "358178",
            "title": "BTL",
            "priority": "P3",
            "created_at": "03/02/2026 13:11:25",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 13:11:25"
          },
          {
            "ticket_id": 8196,
            "ticket_number": "358188",
            "title": "Comprovativo de pagamento - turnos BTL",
            "priority": "P3",
            "created_at": "03/02/2026 15:06:01",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 15:06:01"
          },
          {
            "ticket_id": 8206,
            "ticket_number": "358198",
            "title": "BTL 2026 LISBON | BOOK A MEETING",
            "priority": "P3",
            "created_at": "03/02/2026 15:39:53",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 141.2,
            "sla_met": false,
            "sla_breach_hours": 117.2,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 12:52:34"
          },
          {
            "ticket_id": 8219,
            "ticket_number": "358211",
            "title": "Solicitação RGPD",
            "priority": "P3",
            "created_at": "03/02/2026 18:18:23",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 18:18:23"
          },
          {
            "ticket_id": 8222,
            "ticket_number": "358214",
            "title": "Alteração urgente",
            "priority": "P3",
            "created_at": "03/02/2026 18:47:30",
            "close_date": "2026-02-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 18:47:30"
          },
          {
            "ticket_id": 8228,
            "ticket_number": "358220",
            "title": "Rgpd e Cvo- Reserva travelplan 604542341",
            "priority": "P3",
            "created_at": "03/02/2026 19:28:47",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 19:28:47"
          },
          {
            "ticket_id": 8235,
            "ticket_number": "358227",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "03/02/2026 20:48:00",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 20:48:01"
          },
          {
            "ticket_id": 8239,
            "ticket_number": "358231",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "03/02/2026 21:17:52",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 21:17:53"
          },
          {
            "ticket_id": 8242,
            "ticket_number": "358234",
            "title": "Pedido de envio de RGPD - Tânia Marisa Oliveira Si",
            "priority": "P3",
            "created_at": "03/02/2026 21:44:26",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 21:44:26"
          },
          {
            "ticket_id": 8248,
            "ticket_number": "358240",
            "title": "Transferencia Turnos BTL e Kit consultor",
            "priority": "P3",
            "created_at": "03/02/2026 23:37:19",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 23:37:19"
          },
          {
            "ticket_id": 8250,
            "ticket_number": "358242",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "03/02/2026 23:37:23",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/02/2026 23:37:24"
          },
          {
            "ticket_id": 8256,
            "ticket_number": "358248",
            "title": "RGPD - Paulo Sérgio Martins Rodrigues - 247600088",
            "priority": "P3",
            "created_at": "04/02/2026 00:02:37",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 00:02:38"
          },
          {
            "ticket_id": 8257,
            "ticket_number": "358249",
            "title": "Envio de RGPD - João do  Ó | GBN 103544 | OPTI 247",
            "priority": "P3",
            "created_at": "04/02/2026 00:02:40",
            "close_date": "2026-02-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 00:02:40"
          },
          {
            "ticket_id": 8259,
            "ticket_number": "358251",
            "title": "Pedido de envio de RGPG + CVO localizador Newblue ",
            "priority": "P3",
            "created_at": "04/02/2026 10:20:35",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:20:36"
          },
          {
            "ticket_id": 8260,
            "ticket_number": "358252",
            "title": "Pagamento BTL",
            "priority": "P3",
            "created_at": "04/02/2026 10:20:37",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:20:38"
          },
          {
            "ticket_id": 8261,
            "ticket_number": "358253",
            "title": "RGPD - Alexandra Cristina Nunes Sacadura - 2476000",
            "priority": "P3",
            "created_at": "04/02/2026 10:20:40",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 10:20:40"
          },
          {
            "ticket_id": 8274,
            "ticket_number": "358266",
            "title": "BTL dia 26",
            "priority": "P2",
            "created_at": "04/02/2026 10:30:42",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 10:30:42"
          },
          {
            "ticket_id": 8286,
            "ticket_number": "358278",
            "title": "BTL Bilhete Profissional",
            "priority": "P2",
            "created_at": "04/02/2026 12:47:32",
            "close_date": "2026-02-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 12:47:32"
          },
          {
            "ticket_id": 8288,
            "ticket_number": "358280",
            "title": "Comprovativo BTL 26 Fev 2026",
            "priority": "P2",
            "created_at": "04/02/2026 13:12:35",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 13:12:35"
          },
          {
            "ticket_id": 8291,
            "ticket_number": "358283",
            "title": "Comprovativo Transação ",
            "priority": "P2",
            "created_at": "04/02/2026 13:51:41",
            "close_date": "2026-02-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 17:44:11"
          },
          {
            "ticket_id": 8295,
            "ticket_number": "358287",
            "title": "RGPD - GBN - 103474",
            "priority": "P3",
            "created_at": "04/02/2026 15:00:34",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 15:00:34"
          },
          {
            "ticket_id": 8318,
            "ticket_number": "358310",
            "title": "Envio RGPD e CVO - Pedro Neves - GBN-102938",
            "priority": "P3",
            "created_at": "04/02/2026 17:35:39",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 17:35:40"
          },
          {
            "ticket_id": 8329,
            "ticket_number": "358321",
            "title": "Nova reserva Autoflexible - PP583324 | envio de do",
            "priority": "P3",
            "created_at": "04/02/2026 19:26:23",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 19:26:24"
          },
          {
            "ticket_id": 8332,
            "ticket_number": "358324",
            "title": "Re: Novo Reforço de Pagamento - Viagem #SPT0026015",
            "priority": "P3",
            "created_at": "04/02/2026 20:03:00",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 20:03:01"
          },
          {
            "ticket_id": 8341,
            "ticket_number": "358333",
            "title": "Nova reserva GBN-103806 | Envio de doc",
            "priority": "P3",
            "created_at": "04/02/2026 20:56:17",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 20:56:18"
          },
          {
            "ticket_id": 8349,
            "ticket_number": "358341",
            "title": "Pedido RGPD localizador 1243906987SMY TRAVEL",
            "priority": "P3",
            "created_at": "04/02/2026 22:54:08",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 22:54:08"
          },
          {
            "ticket_id": 8356,
            "ticket_number": "358348",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:42:22",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:42:23"
          },
          {
            "ticket_id": 8357,
            "ticket_number": "358349",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:44:34",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:44:34"
          },
          {
            "ticket_id": 8358,
            "ticket_number": "358350",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:44:36",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:44:36"
          },
          {
            "ticket_id": 8359,
            "ticket_number": "358351",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:46:13",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:46:13"
          },
          {
            "ticket_id": 8360,
            "ticket_number": "358352",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:47:51",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:47:51"
          },
          {
            "ticket_id": 8361,
            "ticket_number": "358353",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "04/02/2026 23:52:10",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/02/2026 23:52:10"
          },
          {
            "ticket_id": 8366,
            "ticket_number": "358358",
            "title": "Re: RGPD+CVO - GBN 103831",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:27",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:02:28"
          },
          {
            "ticket_id": 8373,
            "ticket_number": "358365",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "05/02/2026 10:02:45",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:02:45"
          },
          {
            "ticket_id": 8379,
            "ticket_number": "358371",
            "title": "RGPD+CVO - GBN 103831",
            "priority": "P3",
            "created_at": "05/02/2026 10:03:03",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 10:03:04"
          },
          {
            "ticket_id": 8400,
            "ticket_number": "358392",
            "title": "Pedido Envio RGPD + CVO - Tour10 - 4063357",
            "priority": "P3",
            "created_at": "05/02/2026 11:46:48",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 11:46:49"
          },
          {
            "ticket_id": 8403,
            "ticket_number": "358395",
            "title": "Comprovativo Transferência Turno BTL",
            "priority": "P3",
            "created_at": "05/02/2026 13:07:54",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 13:07:55"
          },
          {
            "ticket_id": 8404,
            "ticket_number": "358396",
            "title": "Stand BTL | Pagamento Débora",
            "priority": "P3",
            "created_at": "05/02/2026 13:07:57",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 13:07:58"
          },
          {
            "ticket_id": 8412,
            "ticket_number": "358404",
            "title": "opti242100184",
            "priority": "P3",
            "created_at": "05/02/2026 13:09:25",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 17:01:01"
          },
          {
            "ticket_id": 8417,
            "ticket_number": "358409",
            "title": "Envio RGPD - UFEV - OPTI 2414000037",
            "priority": "P3",
            "created_at": "05/02/2026 14:13:34",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 14:13:34"
          },
          {
            "ticket_id": 8421,
            "ticket_number": "358413",
            "title": "RGPD_Rute Pereira",
            "priority": "P3",
            "created_at": "05/02/2026 14:40:58",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 14:40:58"
          },
          {
            "ticket_id": 8427,
            "ticket_number": "358419",
            "title": "Btl",
            "priority": "P2",
            "created_at": "05/02/2026 15:11:05",
            "close_date": "2026-02-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 15:11:06"
          },
          {
            "ticket_id": 8428,
            "ticket_number": "358420",
            "title": "RGPD_Ana Rita Silva",
            "priority": "P3",
            "created_at": "05/02/2026 15:11:09",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 15:11:09"
          },
          {
            "ticket_id": 8462,
            "ticket_number": "358454",
            "title": "Comprovativo de transferencia BTL",
            "priority": "P3",
            "created_at": "05/02/2026 19:05:34",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 19:05:36"
          },
          {
            "ticket_id": 8468,
            "ticket_number": "358460",
            "title": "Pagamento Turno BTL",
            "priority": "P3",
            "created_at": "05/02/2026 20:05:32",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 20:05:32"
          },
          {
            "ticket_id": 8474,
            "ticket_number": "358466",
            "title": "Comprovativo pagamento sessões BTL",
            "priority": "P3",
            "created_at": "05/02/2026 21:19:01",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 21:19:02"
          },
          {
            "ticket_id": 8476,
            "ticket_number": "358468",
            "title": "Pedido de RGPD e CVO",
            "priority": "P3",
            "created_at": "05/02/2026 22:09:28",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 22:09:28"
          },
          {
            "ticket_id": 8481,
            "ticket_number": "358473",
            "title": "Catarina Rosa - SPT002601583979 – RGPD e CVO",
            "priority": "P3",
            "created_at": "05/02/2026 23:53:37",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "05/02/2026 23:53:38"
          },
          {
            "ticket_id": 8498,
            "ticket_number": "358490",
            "title": "opti242100203 - loc 4063949",
            "priority": "P3",
            "created_at": "06/02/2026 10:09:16",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 23.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 09:45:53"
          },
          {
            "ticket_id": 8518,
            "ticket_number": "358510",
            "title": "FLY stand + a páginas de AUTOCOLANTES",
            "priority": "P2",
            "created_at": "06/02/2026 12:37:35",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 12:37:35"
          },
          {
            "ticket_id": 8520,
            "ticket_number": "358512",
            "title": "BTL 2026",
            "priority": "P3",
            "created_at": "06/02/2026 13:21:25",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 13:21:25"
          },
          {
            "ticket_id": 8522,
            "ticket_number": "358514",
            "title": "Envio rgpd e cvo",
            "priority": "P3",
            "created_at": "06/02/2026 13:22:36",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 13:22:36"
          },
          {
            "ticket_id": 8524,
            "ticket_number": "358516",
            "title": "Signed: RGPD 2550000010.docx",
            "priority": "P3",
            "created_at": "06/02/2026 13:22:43",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 20.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 09:50:45"
          },
          {
            "ticket_id": 8529,
            "ticket_number": "358521",
            "title": "RGPD - Solférias - 428883",
            "priority": "P3",
            "created_at": "06/02/2026 14:03:12",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 14:03:13"
          },
          {
            "ticket_id": 8551,
            "ticket_number": "358543",
            "title": "Pagamento BTL",
            "priority": "P3",
            "created_at": "06/02/2026 18:23:19",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:23:20"
          },
          {
            "ticket_id": 8552,
            "ticket_number": "358544",
            "title": "Comprovativo de pagamento BTL",
            "priority": "P3",
            "created_at": "06/02/2026 18:23:22",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:23:22"
          },
          {
            "ticket_id": 8556,
            "ticket_number": "358548",
            "title": "Pagamento BLT - Marta Tavares",
            "priority": "P3",
            "created_at": "06/02/2026 18:23:34",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:23:34"
          },
          {
            "ticket_id": 8558,
            "ticket_number": "358550",
            "title": "Restaurante Almeirim",
            "priority": "P3",
            "created_at": "06/02/2026 19:14:39",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 18:03:34"
          },
          {
            "ticket_id": 8567,
            "ticket_number": "358559",
            "title": "Pagamento de autocolantes",
            "priority": "P2",
            "created_at": "06/02/2026 19:56:27",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/02/2026 19:56:29"
          },
          {
            "ticket_id": 8580,
            "ticket_number": "358572",
            "title": "Comprovativo BTL",
            "priority": "P3",
            "created_at": "06/02/2026 21:40:11",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 21:40:11"
          },
          {
            "ticket_id": 8584,
            "ticket_number": "358576",
            "title": "Solicitação envio RGPD | Loc 9106927",
            "priority": "P3",
            "created_at": "06/02/2026 22:44:31",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 22:44:31"
          },
          {
            "ticket_id": 8585,
            "ticket_number": "358577",
            "title": "Rogerio Manuel Vieira de Almeida - Reserva SOLTROP",
            "priority": "P3",
            "created_at": "06/02/2026 22:44:33",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 22:44:33"
          },
          {
            "ticket_id": 8587,
            "ticket_number": "358579",
            "title": "Comprovativo pagamento BTL + Kit - Ana Simões",
            "priority": "P3",
            "created_at": "06/02/2026 23:00:37",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 23:00:37"
          },
          {
            "ticket_id": 8597,
            "ticket_number": "358589",
            "title": "Envio RGPD + CVO",
            "priority": "P3",
            "created_at": "06/02/2026 23:16:08",
            "close_date": "2026-02-07",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 23:16:09"
          },
          {
            "ticket_id": 8600,
            "ticket_number": "358592",
            "title": "Pagamento BTL",
            "priority": "P3",
            "created_at": "06/02/2026 23:42:24",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/02/2026 23:42:24"
          },
          {
            "ticket_id": 8605,
            "ticket_number": "358597",
            "title": "opti242100206 - GBN-104355",
            "priority": "P3",
            "created_at": "07/02/2026 10:03:37",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:02:00"
          },
          {
            "ticket_id": 8606,
            "ticket_number": "358598",
            "title": "Comprovativo pagamento inscrição btle e fly e 2 ts",
            "priority": "P3",
            "created_at": "07/02/2026 10:03:39",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 10:03:39"
          },
          {
            "ticket_id": 8609,
            "ticket_number": "358601",
            "title": "opti242100203 - loc4063949",
            "priority": "P3",
            "created_at": "07/02/2026 10:03:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 53.97,
            "sla_met": false,
            "sla_breach_hours": 29.97,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 16:02:00"
          },
          {
            "ticket_id": 8616,
            "ticket_number": "358608",
            "title": "Pedido de RGPD",
            "priority": "P1",
            "created_at": "07/02/2026 10:50:26",
            "close_date": "2026-02-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/02/2026 10:50:27"
          },
          {
            "ticket_id": 8617,
            "ticket_number": "358609",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "07/02/2026 10:50:30",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 10:50:31"
          },
          {
            "ticket_id": 8623,
            "ticket_number": "358615",
            "title": "Pedido de Envio RGPD",
            "priority": "P3",
            "created_at": "07/02/2026 14:08:33",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 14:08:33"
          },
          {
            "ticket_id": 8624,
            "ticket_number": "358616",
            "title": "FW: Pedido de envio RGPD",
            "priority": "P3",
            "created_at": "07/02/2026 14:08:35",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 14:08:36"
          },
          {
            "ticket_id": 8626,
            "ticket_number": "358618",
            "title": "Pedido de envio RGPD",
            "priority": "P3",
            "created_at": "07/02/2026 14:08:41",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 14:08:42"
          },
          {
            "ticket_id": 8630,
            "ticket_number": "358622",
            "title": "Envio RGPD e CVO | Tânia Gaboleiro OPTI 245700036",
            "priority": "P3",
            "created_at": "07/02/2026 15:46:58",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 15:46:58"
          },
          {
            "ticket_id": 8631,
            "ticket_number": "358623",
            "title": "Urgente - Viagem amanhã",
            "priority": "P1",
            "created_at": "07/02/2026 15:47:00",
            "close_date": "2026-02-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "07/02/2026 15:47:01"
          },
          {
            "ticket_id": 8632,
            "ticket_number": "358624",
            "title": "KIT BTL ao cuidado da Carolina",
            "priority": "P3",
            "created_at": "07/02/2026 15:47:02",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 15:47:03"
          },
          {
            "ticket_id": 8634,
            "ticket_number": "358626",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "07/02/2026 15:47:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 15:47:07"
          },
          {
            "ticket_id": 8635,
            "ticket_number": "358627",
            "title": "envio doc assinar",
            "priority": "P3",
            "created_at": "07/02/2026 16:50:24",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/02/2026 16:50:25"
          },
          {
            "ticket_id": 8664,
            "ticket_number": "358656",
            "title": "CVO e RGPD da Reserva da New Blue Loc 6132310",
            "priority": "P3",
            "created_at": "09/02/2026 10:35:31",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:35:31"
          },
          {
            "ticket_id": 8668,
            "ticket_number": "358660",
            "title": "Pedido RGPD localizador 604546339 da Nortravel",
            "priority": "P3",
            "created_at": "09/02/2026 10:36:44",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:36:44"
          },
          {
            "ticket_id": 8669,
            "ticket_number": "358661",
            "title": "Pedido RGPD localizador 604543771 da Travelplan",
            "priority": "P3",
            "created_at": "09/02/2026 10:36:47",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:36:48"
          },
          {
            "ticket_id": 8670,
            "ticket_number": "358662",
            "title": "Nova reserva seguros VG64743395 | envio de documen",
            "priority": "P3",
            "created_at": "09/02/2026 10:36:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:36:52"
          },
          {
            "ticket_id": 8671,
            "ticket_number": "358663",
            "title": "RGPD Localizador nr:SPT002601584842",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:02",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:03"
          },
          {
            "ticket_id": 8672,
            "ticket_number": "358664",
            "title": "Nova reserva GBN-102509 | assinatura de docs",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:05",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:05"
          },
          {
            "ticket_id": 8673,
            "ticket_number": "358665",
            "title": "Envio RGPD Felisbela Ferreira Tour10 4067147",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:07",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:08"
          },
          {
            "ticket_id": 8674,
            "ticket_number": "358666",
            "title": "RGPD LOCALIZADOR  604540121, 604540123, 4060902",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:10",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:10"
          },
          {
            "ticket_id": 8675,
            "ticket_number": "358667",
            "title": "SOLICITO RGPD E CVO - BARBARA ANDREIA GUIMARAES DO",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:13",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:13"
          },
          {
            "ticket_id": 8676,
            "ticket_number": "358668",
            "title": "Envio RGPD ANDREIA BATISTA NEWBLUE 6132327",
            "priority": "P3",
            "created_at": "09/02/2026 10:37:16",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:37:16"
          },
          {
            "ticket_id": 8684,
            "ticket_number": "358676",
            "title": "BTL | Agendamento de reunião",
            "priority": "P3",
            "created_at": "09/02/2026 10:39:53",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 221.88,
            "sla_met": false,
            "sla_breach_hours": 197.88,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 16:33:41"
          },
          {
            "ticket_id": 8685,
            "ticket_number": "358677",
            "title": "BTL 60 autocolantes",
            "priority": "P3",
            "created_at": "09/02/2026 10:44:07",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:44:07"
          },
          {
            "ticket_id": 8694,
            "ticket_number": "358686",
            "title": "Dia profissional BTL + autocolantes",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:16",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:46:17"
          },
          {
            "ticket_id": 8698,
            "ticket_number": "358690",
            "title": "Parabéns! Você aumentou seu equilíbrio.",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:28",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 23.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 10:29:07"
          },
          {
            "ticket_id": 8699,
            "ticket_number": "358691",
            "title": "Envio rgpd e cvo",
            "priority": "P1",
            "created_at": "09/02/2026 10:46:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "09/02/2026 10:46:32"
          },
          {
            "ticket_id": 8700,
            "ticket_number": "358692",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:37",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:46:38"
          },
          {
            "ticket_id": 8708,
            "ticket_number": "358700",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "09/02/2026 10:46:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:47:00"
          },
          {
            "ticket_id": 8712,
            "ticket_number": "358704",
            "title": "RGPD E CVO GBN-104514",
            "priority": "P3",
            "created_at": "09/02/2026 10:47:11",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 33.88,
            "sla_met": false,
            "sla_breach_hours": 9.88,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:40:32"
          },
          {
            "ticket_id": 8724,
            "ticket_number": "358716",
            "title": "doc cliente assinar",
            "priority": "P3",
            "created_at": "09/02/2026 10:48:20",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:48:21"
          },
          {
            "ticket_id": 8727,
            "ticket_number": "358719",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "09/02/2026 10:48:29",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:48:29"
          },
          {
            "ticket_id": 8742,
            "ticket_number": "358734",
            "title": "Documentação Disponível - Reserva 336748",
            "priority": "P3",
            "created_at": "09/02/2026 12:02:29",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 7.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 19:25:32"
          },
          {
            "ticket_id": 8745,
            "ticket_number": "358737",
            "title": "BTL",
            "priority": "P3",
            "created_at": "09/02/2026 13:30:49",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 13:30:50"
          },
          {
            "ticket_id": 8746,
            "ticket_number": "358738",
            "title": "CVO e Rgpd opti 2418700031",
            "priority": "P3",
            "created_at": "09/02/2026 13:30:52",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 13:30:53"
          },
          {
            "ticket_id": 8754,
            "ticket_number": "358746",
            "title": "Fw: BTL 26/2",
            "priority": "P3",
            "created_at": "09/02/2026 13:37:37",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 13:37:38"
          },
          {
            "ticket_id": 8760,
            "ticket_number": "358752",
            "title": "comprovativo pagamento - dia 26 de fevereiro BTL",
            "priority": "P3",
            "created_at": "09/02/2026 15:43:05",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 15:43:06"
          },
          {
            "ticket_id": 8764,
            "ticket_number": "358756",
            "title": "Pedido de vouchers",
            "priority": "P3",
            "created_at": "09/02/2026 15:43:56",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 15:43:56"
          },
          {
            "ticket_id": 8766,
            "ticket_number": "358758",
            "title": "BTL 2026 - Douro Acima",
            "priority": "P3",
            "created_at": "09/02/2026 16:29:59",
            "close_date": "2026-02-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 17:11:47"
          },
          {
            "ticket_id": 8780,
            "ticket_number": "358772",
            "title": "Acesso ao operador Sonhando – reserva em curso",
            "priority": "P3",
            "created_at": "09/02/2026 17:16:06",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 17:16:07"
          },
          {
            "ticket_id": 8799,
            "ticket_number": "358791",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "09/02/2026 20:10:55",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 20:10:55"
          },
          {
            "ticket_id": 8801,
            "ticket_number": "358793",
            "title": "SOLICITO RGPD E CVO - DEBORA SOFIA SILVA SOUSA - O",
            "priority": "P3",
            "created_at": "09/02/2026 20:11:00",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 20:11:01"
          },
          {
            "ticket_id": 8804,
            "ticket_number": "358796",
            "title": "Nova reserva - Civitatis - A36937616 | doc para as",
            "priority": "P3",
            "created_at": "09/02/2026 21:28:48",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 21:28:48"
          },
          {
            "ticket_id": 8805,
            "ticket_number": "358797",
            "title": "Envio de RGPD e ACORDO GERAL PARA A PRESTAÇÃO DE S",
            "priority": "P3",
            "created_at": "09/02/2026 21:28:50",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 21:28:50"
          },
          {
            "ticket_id": 8808,
            "ticket_number": "358800",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "09/02/2026 21:28:59",
            "close_date": "2026-02-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 21:28:59"
          },
          {
            "ticket_id": 8809,
            "ticket_number": "358801",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "09/02/2026 21:29:02",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 21:29:02"
          },
          {
            "ticket_id": 8819,
            "ticket_number": "358811",
            "title": "Contracto + RGPD | Rafael Branco",
            "priority": "P3",
            "created_at": "09/02/2026 23:50:41",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 23:50:41"
          },
          {
            "ticket_id": 8829,
            "ticket_number": "358821",
            "title": "GBN-104804 - opti242100209",
            "priority": "P3",
            "created_at": "10/02/2026 10:10:57",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 10:10:57"
          },
          {
            "ticket_id": 8862,
            "ticket_number": "358854",
            "title": "bilhete btl",
            "priority": "P2",
            "created_at": "10/02/2026 12:55:15",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/02/2026 12:55:16"
          },
          {
            "ticket_id": 8876,
            "ticket_number": "358868",
            "title": "Banco BPI: Comprovativo de transferência para IBAN",
            "priority": "P3",
            "created_at": "10/02/2026 15:58:02",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 15:58:03"
          },
          {
            "ticket_id": 8881,
            "ticket_number": "358873",
            "title": "Reunião BTL - Uma Família em Viagem",
            "priority": "P3",
            "created_at": "10/02/2026 16:56:59",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 43.77,
            "sla_met": false,
            "sla_breach_hours": 19.77,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 12:43:24"
          },
          {
            "ticket_id": 8892,
            "ticket_number": "358884",
            "title": "Pagamento Fly",
            "priority": "P3",
            "created_at": "10/02/2026 18:13:41",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 18:13:41"
          },
          {
            "ticket_id": 8906,
            "ticket_number": "358898",
            "title": "Re: Envio RGPD e CVO 2417300042",
            "priority": "P3",
            "created_at": "10/02/2026 18:51:46",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 19.85,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 14:43:32"
          },
          {
            "ticket_id": 8925,
            "ticket_number": "358917",
            "title": "RGPD - Leandro Miguel Monteiro Correia - 241570006",
            "priority": "P3",
            "created_at": "10/02/2026 20:38:46",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:38:46"
          },
          {
            "ticket_id": 8926,
            "ticket_number": "358918",
            "title": "RGPD - Cátia Alexandra Oliveira Pinheiro  - 247600",
            "priority": "P3",
            "created_at": "10/02/2026 20:38:48",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:38:49"
          },
          {
            "ticket_id": 8928,
            "ticket_number": "358920",
            "title": "RGPD - Andreia Filipa Santos Mendes  - 247600091",
            "priority": "P3",
            "created_at": "10/02/2026 20:52:34",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 20:52:35"
          },
          {
            "ticket_id": 8932,
            "ticket_number": "358924",
            "title": "António Santos - CVO + RGPD",
            "priority": "P3",
            "created_at": "10/02/2026 21:53:04",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 21:53:04"
          },
          {
            "ticket_id": 8933,
            "ticket_number": "358925",
            "title": "GBN-104903",
            "priority": "P3",
            "created_at": "10/02/2026 22:08:07",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 22:08:07"
          },
          {
            "ticket_id": 8941,
            "ticket_number": "358933",
            "title": "GBN-105054",
            "priority": "P3",
            "created_at": "10/02/2026 23:07:35",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/02/2026 23:07:35"
          },
          {
            "ticket_id": 8948,
            "ticket_number": "358940",
            "title": "Envio de RGPD e CVO",
            "priority": "P1",
            "created_at": "11/02/2026 10:13:06",
            "close_date": "2026-02-18",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/02/2026 10:13:06"
          },
          {
            "ticket_id": 8949,
            "ticket_number": "358941",
            "title": "Envio RGPD e CVO - Sofia Rosa - GBN-104969",
            "priority": "P3",
            "created_at": "11/02/2026 10:13:08",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 10:13:08"
          },
          {
            "ticket_id": 8971,
            "ticket_number": "358963",
            "title": "Comprovativo stands BTL + autocolantes",
            "priority": "P3",
            "created_at": "11/02/2026 12:13:11",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 12:13:11"
          },
          {
            "ticket_id": 8979,
            "ticket_number": "358971",
            "title": "CVO + RGPD",
            "priority": "P3",
            "created_at": "11/02/2026 12:32:17",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 12:32:17"
          },
          {
            "ticket_id": 8980,
            "ticket_number": "358972",
            "title": "RE: BTL E FLY - GRAVAÇÃO DA SESSÃO",
            "priority": "P3",
            "created_at": "11/02/2026 12:32:19",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 12:32:19"
          },
          {
            "ticket_id": 8982,
            "ticket_number": "358974",
            "title": "PEDIDO DE ENVIO RGPD E CVO - RICARDO REIS SOLFERIA",
            "priority": "P3",
            "created_at": "11/02/2026 13:39:46",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:39:47"
          },
          {
            "ticket_id": 8983,
            "ticket_number": "358975",
            "title": "PEDIDO DE ENVIO RGPD E CVO - JOSÉ DUARTE GBN 10462",
            "priority": "P3",
            "created_at": "11/02/2026 13:39:49",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:39:49"
          },
          {
            "ticket_id": 8984,
            "ticket_number": "358976",
            "title": "PEDIDO DE ENVIO RGPD E CVO - RITA CARVALHEIRO GBN ",
            "priority": "P3",
            "created_at": "11/02/2026 13:39:52",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:39:52"
          },
          {
            "ticket_id": 8995,
            "ticket_number": "358987",
            "title": "Envio RGPD - UFEV - OPTI 2414000038",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:31",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:40:31"
          },
          {
            "ticket_id": 8996,
            "ticket_number": "358988",
            "title": "Envio RGPD - UFEV - OPTI 2414000039",
            "priority": "P3",
            "created_at": "11/02/2026 13:40:34",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:40:34"
          },
          {
            "ticket_id": 8997,
            "ticket_number": "358989",
            "title": "RGPD - GBN - 105149",
            "priority": "P3",
            "created_at": "11/02/2026 13:58:25",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 13:58:25"
          },
          {
            "ticket_id": 9011,
            "ticket_number": "359003",
            "title": "RGPD GBN-104841",
            "priority": "P3",
            "created_at": "11/02/2026 17:15:33",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 17:15:34"
          },
          {
            "ticket_id": 9030,
            "ticket_number": "359022",
            "title": "Envio Rgpd e Cvo",
            "priority": "P3",
            "created_at": "11/02/2026 18:53:40",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 18:53:40"
          },
          {
            "ticket_id": 9041,
            "ticket_number": "359033",
            "title": "Nova reserva Soltour & Insure |  SPT002601585681 &",
            "priority": "P3",
            "created_at": "11/02/2026 20:19:08",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 20:19:09"
          },
          {
            "ticket_id": 9044,
            "ticket_number": "359036",
            "title": "Diego Perez - GBN-105067- RGP e CVO",
            "priority": "P3",
            "created_at": "11/02/2026 20:31:27",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 20:31:27"
          },
          {
            "ticket_id": 9048,
            "ticket_number": "359040",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "11/02/2026 21:04:56",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 21:04:56"
          },
          {
            "ticket_id": 9055,
            "ticket_number": "359047",
            "title": "Pedido de Envio de RGPD",
            "priority": "P3",
            "created_at": "11/02/2026 21:47:04",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 21:47:04"
          },
          {
            "ticket_id": 9060,
            "ticket_number": "359052",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P3",
            "created_at": "11/02/2026 23:17:36",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 23:17:36"
          },
          {
            "ticket_id": 9063,
            "ticket_number": "359055",
            "title": "RGPD - GBN 101298",
            "priority": "P3",
            "created_at": "11/02/2026 23:23:11",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 23:23:12"
          },
          {
            "ticket_id": 9069,
            "ticket_number": "359061",
            "title": "Solicitação envio RGPD | Loc 6587/2026",
            "priority": "P3",
            "created_at": "11/02/2026 23:49:09",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/02/2026 23:49:09"
          },
          {
            "ticket_id": 9078,
            "ticket_number": "359070",
            "title": "Bilhetes profissionais BTL",
            "priority": "P3",
            "created_at": "12/02/2026 10:10:02",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 10:10:02"
          },
          {
            "ticket_id": 9081,
            "ticket_number": "359073",
            "title": "RGPD - Débora Rodrigues Pinto - 2415700068",
            "priority": "P3",
            "created_at": "12/02/2026 10:10:13",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 10:10:13"
          },
          {
            "ticket_id": 9097,
            "ticket_number": "359089",
            "title": "Re: Pedido de cotação - reserva 336748",
            "priority": "P3",
            "created_at": "12/02/2026 10:20:04",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 506.78,
            "sla_met": false,
            "sla_breach_hours": 482.78,
            "sla_name": "SLA P3",
            "first_response_at": "05/03/2026 13:07:05"
          },
          {
            "ticket_id": 9103,
            "ticket_number": "359095",
            "title": "Fwd: Pedido RGPD  793408654 e 512554201] da TOMAZ ",
            "priority": "P3",
            "created_at": "12/02/2026 11:00:11",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 11:00:11"
          },
          {
            "ticket_id": 9115,
            "ticket_number": "359107",
            "title": "Envio de RGPD para cliente",
            "priority": "P3",
            "created_at": "12/02/2026 13:17:49",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 13:17:50"
          },
          {
            "ticket_id": 9122,
            "ticket_number": "359114",
            "title": "Envio Rgpd e Cvo- travelplan  604546188",
            "priority": "P3",
            "created_at": "12/02/2026 13:18:15",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 13:18:15"
          },
          {
            "ticket_id": 9133,
            "ticket_number": "359125",
            "title": "envio rgpd e cvo",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:06",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 18:05:06"
          },
          {
            "ticket_id": 9134,
            "ticket_number": "359126",
            "title": "envio cvo e rgpd Localizador KC3J2K4 e Outros",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:08",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 18:05:08"
          },
          {
            "ticket_id": 9163,
            "ticket_number": "359155",
            "title": "CVO e RGPD Carla Lucio loc. 429861",
            "priority": "P3",
            "created_at": "12/02/2026 21:56:53",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 21:56:53"
          },
          {
            "ticket_id": 9164,
            "ticket_number": "359156",
            "title": "CVO e RGPD Luísa Bento loc. 429857",
            "priority": "P3",
            "created_at": "12/02/2026 22:01:13",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 22:01:14"
          },
          {
            "ticket_id": 9167,
            "ticket_number": "359159",
            "title": "Envio de RGPD",
            "priority": "P3",
            "created_at": "12/02/2026 23:07:07",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 23:07:07"
          },
          {
            "ticket_id": 9170,
            "ticket_number": "359162",
            "title": "RGPD - Diogo André Lopes Machado - OPTI - 24146000",
            "priority": "P3",
            "created_at": "12/02/2026 23:42:12",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/02/2026 23:42:13"
          },
          {
            "ticket_id": 9172,
            "ticket_number": "359164",
            "title": "RGPD - Beatriz Sousa Lopes - OPTI - 2414600028-Loc",
            "priority": "P3",
            "created_at": "13/02/2026 00:06:36",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 00:06:37"
          },
          {
            "ticket_id": 9176,
            "ticket_number": "359168",
            "title": "RGPD - Emanuel Rodrigues Pinto - 2415700070",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:15",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:15"
          },
          {
            "ticket_id": 9177,
            "ticket_number": "359169",
            "title": "RGPD - Andrea Carla da Silva Lage - 2415700073",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:17",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:17"
          },
          {
            "ticket_id": 9178,
            "ticket_number": "359170",
            "title": "RGPD - Glória da Conceição Rodrigues Pinto- 241570",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:19",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:20"
          },
          {
            "ticket_id": 9186,
            "ticket_number": "359178",
            "title": "CVO e RGDP",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:38",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:38"
          },
          {
            "ticket_id": 9187,
            "ticket_number": "359179",
            "title": "RGPD - Antonio Jose Guedes da Costa - OPTI - 24146",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:41",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:41"
          },
          {
            "ticket_id": 9188,
            "ticket_number": "359180",
            "title": "RGPD - Débora Rodrigues Pinto - 2415700068",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:43",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:43"
          },
          {
            "ticket_id": 9189,
            "ticket_number": "359181",
            "title": "RGPD - Hugo Fernando Da Silva Teles Teixeira - OPT",
            "priority": "P3",
            "created_at": "13/02/2026 10:07:46",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:07:46"
          },
          {
            "ticket_id": 9191,
            "ticket_number": "359183",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "13/02/2026 10:16:19",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 10:16:20"
          },
          {
            "ticket_id": 9196,
            "ticket_number": "359188",
            "title": "Comprovativo",
            "priority": "P3",
            "created_at": "13/02/2026 11:31:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 72.82,
            "sla_met": false,
            "sla_breach_hours": 48.82,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 12:20:35"
          },
          {
            "ticket_id": 9198,
            "ticket_number": "359190",
            "title": "RGPD - Eugenio Alberto Mendes Machado - OPTI - 241",
            "priority": "P3",
            "created_at": "13/02/2026 11:31:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:31:32"
          },
          {
            "ticket_id": 9199,
            "ticket_number": "359191",
            "title": "RGPD - Eugenio Alberto Mendes Machado - OPTI - 241",
            "priority": "P3",
            "created_at": "13/02/2026 11:31:35",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:31:36"
          },
          {
            "ticket_id": 9200,
            "ticket_number": "359192",
            "title": "RGPD - Leonel Fernando Ribeiro Alves - 2415700071",
            "priority": "P3",
            "created_at": "13/02/2026 11:42:48",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:42:48"
          },
          {
            "ticket_id": 9203,
            "ticket_number": "359195",
            "title": "RGPD - Sónia Alexandra Pereira Valente - 241570007",
            "priority": "P3",
            "created_at": "13/02/2026 11:42:58",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 11:42:59"
          },
          {
            "ticket_id": 9204,
            "ticket_number": "359196",
            "title": "RGPD - Tânia Sofia Cosme Fernandes  - 2415700074",
            "priority": "P3",
            "created_at": "13/02/2026 12:09:44",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 12:09:44"
          },
          {
            "ticket_id": 9214,
            "ticket_number": "359206",
            "title": "CVO e RGPD Janaina Prates loc. 429916",
            "priority": "P3",
            "created_at": "13/02/2026 13:59:19",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:59:20"
          },
          {
            "ticket_id": 9215,
            "ticket_number": "359207",
            "title": "Fwd: Nova Viagem #260200220 - Bruno Pereira",
            "priority": "P3",
            "created_at": "13/02/2026 13:59:53",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 13:59:54"
          },
          {
            "ticket_id": 9219,
            "ticket_number": "359211",
            "title": "Re: Nova Viagem #260200220 - Bruno Pereira",
            "priority": "P2",
            "created_at": "13/02/2026 14:35:18",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 14:35:19"
          },
          {
            "ticket_id": 9225,
            "ticket_number": "359217",
            "title": "RGPD - Hugo Miguel Reis de Oliveira - 2415700075",
            "priority": "P3",
            "created_at": "13/02/2026 14:40:53",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 14:40:53"
          },
          {
            "ticket_id": 9231,
            "ticket_number": "359223",
            "title": "RGPD - Ricardo Jorge Ribeiro Vieira - 2415700076",
            "priority": "P3",
            "created_at": "13/02/2026 15:45:03",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 15:45:04"
          },
          {
            "ticket_id": 9232,
            "ticket_number": "359224",
            "title": "doc assinar cliente",
            "priority": "P3",
            "created_at": "13/02/2026 15:45:38",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 15:45:38"
          },
          {
            "ticket_id": 9233,
            "ticket_number": "359225",
            "title": "assinatura doc",
            "priority": "P3",
            "created_at": "13/02/2026 15:45:40",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 15:45:40"
          },
          {
            "ticket_id": 9234,
            "ticket_number": "359226",
            "title": "doc cliente assinar",
            "priority": "P3",
            "created_at": "13/02/2026 15:45:42",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 15:45:42"
          },
          {
            "ticket_id": 9235,
            "ticket_number": "359227",
            "title": "FW: Nova Viagem #260200230 - Benice Travel",
            "priority": "P3",
            "created_at": "13/02/2026 16:00:14",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:00:14"
          },
          {
            "ticket_id": 9248,
            "ticket_number": "359240",
            "title": "Teste",
            "priority": "P3",
            "created_at": "13/02/2026 16:20:54",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:20:55"
          },
          {
            "ticket_id": 9251,
            "ticket_number": "359243",
            "title": "RGPD e CVO Tour10 9906/2026",
            "priority": "P3",
            "created_at": "13/02/2026 16:53:39",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:53:39"
          },
          {
            "ticket_id": 9254,
            "ticket_number": "359246",
            "title": "Bilhetes 26-02-2026",
            "priority": "P3",
            "created_at": "13/02/2026 16:53:46",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 16:53:46"
          },
          {
            "ticket_id": 9257,
            "ticket_number": "359249",
            "title": "Pagamento BTL 60 autocolantes",
            "priority": "P3",
            "created_at": "13/02/2026 17:28:43",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 17:28:43"
          },
          {
            "ticket_id": 9261,
            "ticket_number": "359253",
            "title": "-",
            "priority": "P3",
            "created_at": "13/02/2026 17:45:41",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 17:45:41"
          },
          {
            "ticket_id": 9265,
            "ticket_number": "359257",
            "title": "GBN-105789 - opti242100211",
            "priority": "P3",
            "created_at": "13/02/2026 17:45:54",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 16.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/02/2026 10:19:20"
          },
          {
            "ticket_id": 9272,
            "ticket_number": "359264",
            "title": "RGPD - Carla Cristina Medeiros Lima - 2415700078",
            "priority": "P3",
            "created_at": "13/02/2026 19:20:03",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:20:04"
          },
          {
            "ticket_id": 9282,
            "ticket_number": "359274",
            "title": "RGPD - Vanderlea da Silva Ribeiro - 2415700077",
            "priority": "P3",
            "created_at": "13/02/2026 19:21:14",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:21:15"
          },
          {
            "ticket_id": 9283,
            "ticket_number": "359275",
            "title": "Comprovativo pagamento BTL dia 26",
            "priority": "P3",
            "created_at": "13/02/2026 19:21:17",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:21:17"
          },
          {
            "ticket_id": 9285,
            "ticket_number": "359277",
            "title": "BTL-26/02/2026",
            "priority": "P3",
            "created_at": "13/02/2026 19:21:24",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 19:21:24"
          },
          {
            "ticket_id": 9286,
            "ticket_number": "359278",
            "title": "RE: 4F46_UMA FAMILIA EM VIAGEM_BTL 2026",
            "priority": "P2",
            "created_at": "13/02/2026 19:26:14",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 23:22:49"
          },
          {
            "ticket_id": 9298,
            "ticket_number": "359290",
            "title": "RGPD - Cátia Sofia Nunes Gomes - 2415700079",
            "priority": "P3",
            "created_at": "13/02/2026 21:21:44",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 21:21:44"
          },
          {
            "ticket_id": 9304,
            "ticket_number": "359296",
            "title": "RGPD + CVO",
            "priority": "P3",
            "created_at": "13/02/2026 23:13:21",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 23:13:21"
          },
          {
            "ticket_id": 9305,
            "ticket_number": "359297",
            "title": "BTL",
            "priority": "P3",
            "created_at": "13/02/2026 23:26:29",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/02/2026 23:26:30"
          },
          {
            "ticket_id": 9313,
            "ticket_number": "359305",
            "title": "Signed: CVO 2415700077.pdf",
            "priority": "P2",
            "created_at": "14/02/2026 13:18:43",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:57:45"
          },
          {
            "ticket_id": 9315,
            "ticket_number": "359307",
            "title": "Signed: RGPD 2415700077.pdf",
            "priority": "P2",
            "created_at": "14/02/2026 13:18:47",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:59:31"
          },
          {
            "ticket_id": 9316,
            "ticket_number": "359308",
            "title": "Signed: RGPD 2415700074.pdf",
            "priority": "P2",
            "created_at": "14/02/2026 13:33:55",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:58:12"
          },
          {
            "ticket_id": 9317,
            "ticket_number": "359309",
            "title": "Signed: CVO 2415700074.pdf",
            "priority": "P2",
            "created_at": "14/02/2026 13:33:56",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:56:42"
          },
          {
            "ticket_id": 9319,
            "ticket_number": "359311",
            "title": "Signer signed: CVO 2415700074.pdf",
            "priority": "P2",
            "created_at": "14/02/2026 13:34:00",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:55:04"
          },
          {
            "ticket_id": 9335,
            "ticket_number": "359327",
            "title": "Envio RGPD",
            "priority": "P3",
            "created_at": "14/02/2026 15:40:20",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/02/2026 15:40:20"
          },
          {
            "ticket_id": 9338,
            "ticket_number": "359330",
            "title": "Envio RGPD + CVO (urgente) - A/C Carolina",
            "priority": "P2",
            "created_at": "14/02/2026 17:13:56",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 17:13:57"
          },
          {
            "ticket_id": 9346,
            "ticket_number": "359338",
            "title": "Envio RGPD + CVO",
            "priority": "P3",
            "created_at": "16/02/2026 10:06:41",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:06:41"
          },
          {
            "ticket_id": 9352,
            "ticket_number": "359344",
            "title": "Fatura",
            "priority": "P3",
            "created_at": "16/02/2026 10:09:41",
            "close_date": "2026-03-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:09:41"
          },
          {
            "ticket_id": 9360,
            "ticket_number": "359352",
            "title": "Pedido de Envio RGPD",
            "priority": "P3",
            "created_at": "16/02/2026 10:10:09",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:10:10"
          },
          {
            "ticket_id": 9362,
            "ticket_number": "359354",
            "title": "Pedido de Envio RGPD",
            "priority": "P3",
            "created_at": "16/02/2026 10:10:15",
            "close_date": "2026-02-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:10:15"
          },
          {
            "ticket_id": 9366,
            "ticket_number": "359358",
            "title": "CVO e RGPD",
            "priority": "P3",
            "created_at": "16/02/2026 10:10:25",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:10:26"
          },
          {
            "ticket_id": 9372,
            "ticket_number": "359364",
            "title": "enviar RGPD Cliente Joana Meira -GBN-106059",
            "priority": "P3",
            "created_at": "16/02/2026 10:10:47",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 10:10:48"
          },
          {
            "ticket_id": 9401,
            "ticket_number": "359393",
            "title": "enviar RGPD Cliente Joana Meira -w2M 376BPM",
            "priority": "P3",
            "created_at": "16/02/2026 13:02:27",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 13:02:27"
          },
          {
            "ticket_id": 9432,
            "ticket_number": "359424",
            "title": "Bilhetes BTL 26/02/2026",
            "priority": "P3",
            "created_at": "16/02/2026 17:04:19",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 17:04:20"
          },
          {
            "ticket_id": 9463,
            "ticket_number": "359455",
            "title": "Comprovativo BTL dia 26",
            "priority": "P2",
            "created_at": "16/02/2026 18:43:28",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:42:07"
          },
          {
            "ticket_id": 9475,
            "ticket_number": "359467",
            "title": "Envio RGPD e CVO",
            "priority": "P3",
            "created_at": "16/02/2026 20:42:04",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 20:42:04"
          },
          {
            "ticket_id": 9483,
            "ticket_number": "359475",
            "title": "Pedido de RGPD",
            "priority": "P3",
            "created_at": "16/02/2026 21:56:44",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 21:56:44"
          },
          {
            "ticket_id": 9489,
            "ticket_number": "359481",
            "title": "RGPD e CVO A37079806 civitatis",
            "priority": "P3",
            "created_at": "16/02/2026 22:27:41",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 22:27:41"
          },
          {
            "ticket_id": 9496,
            "ticket_number": "359488",
            "title": "cvo e rgpd GBN106323",
            "priority": "P3",
            "created_at": "16/02/2026 23:20:34",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 23:20:34"
          },
          {
            "ticket_id": 9498,
            "ticket_number": "359490",
            "title": "Pedido de correção no backoffice",
            "priority": "P3",
            "created_at": "16/02/2026 23:34:41",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 23:34:42"
          },
          {
            "ticket_id": 9499,
            "ticket_number": "359491",
            "title": "RGPD - Filipa Morgado dos Santos Pedroso Botas - 2",
            "priority": "P3",
            "created_at": "16/02/2026 23:37:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 23:37:21"
          },
          {
            "ticket_id": 9501,
            "ticket_number": "359493",
            "title": "RGPD - Fernando Miguel Pinho Serra Coelho - 247600",
            "priority": "P3",
            "created_at": "16/02/2026 23:59:20",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/02/2026 23:59:20"
          },
          {
            "ticket_id": 9510,
            "ticket_number": "359502",
            "title": "RGPD - Sónia Alexandra Pereira Valente - 241570008",
            "priority": "P2",
            "created_at": "17/02/2026 10:08:00",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 10:08:00"
          },
          {
            "ticket_id": 9547,
            "ticket_number": "359539",
            "title": "CVO e RGDP",
            "priority": "P3",
            "created_at": "17/02/2026 16:31:08",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/02/2026 16:31:09"
          },
          {
            "ticket_id": 9553,
            "ticket_number": "359545",
            "title": "reserva GBN-105557",
            "priority": "P2",
            "created_at": "17/02/2026 16:35:13",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 16:35:14"
          },
          {
            "ticket_id": 9581,
            "ticket_number": "359573",
            "title": "Fwd: Documentação da reserva TTN-1249798120#933765",
            "priority": "P2",
            "created_at": "17/02/2026 18:55:53",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 28.27,
            "sla_met": false,
            "sla_breach_hours": 24.27,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 23:12:40"
          },
          {
            "ticket_id": 9594,
            "ticket_number": "359586",
            "title": "RGPD - Patricia Alexandra Martins Cota - 247600094",
            "priority": "P2",
            "created_at": "17/02/2026 22:55:36",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:55:37"
          },
          {
            "ticket_id": 9596,
            "ticket_number": "359588",
            "title": "PEDIDO DE ENVIO RGPD E CVO - RITA BRITO CONSOLIDAD",
            "priority": "P2",
            "created_at": "17/02/2026 22:55:43",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:55:44"
          },
          {
            "ticket_id": 9605,
            "ticket_number": "359597",
            "title": "RGPD+CVO",
            "priority": "P2",
            "created_at": "17/02/2026 22:56:14",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 22:56:15"
          },
          {
            "ticket_id": 9609,
            "ticket_number": "359601",
            "title": "Pedido envio RGPD + CVO - Tour10 - 4081078",
            "priority": "P2",
            "created_at": "18/02/2026 00:00:12",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 00:00:13"
          },
          {
            "ticket_id": 9625,
            "ticket_number": "359617",
            "title": "Re: Envio RGPD e CVO 2415000006",
            "priority": "P2",
            "created_at": "18/02/2026 11:58:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 11.33,
            "sla_met": false,
            "sla_breach_hours": 7.33,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 23:19:49"
          },
          {
            "ticket_id": 9634,
            "ticket_number": "359626",
            "title": "Envio RGPD",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:26",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:08:26"
          },
          {
            "ticket_id": 9648,
            "ticket_number": "359640",
            "title": "Pedido de envio RRGPD e CVO | opti 247500035 | GBN",
            "priority": "P2",
            "created_at": "18/02/2026 14:09:48",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:09:48"
          },
          {
            "ticket_id": 9661,
            "ticket_number": "359653",
            "title": "Comprovativo pagamento autocolantes",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:16",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 21:22:23"
          },
          {
            "ticket_id": 9674,
            "ticket_number": "359666",
            "title": "Envio de RGPD e CVO",
            "priority": "P3",
            "created_at": "18/02/2026 18:07:16",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 18:07:17"
          },
          {
            "ticket_id": 9683,
            "ticket_number": "359675",
            "title": "Comprovativo KIT BTL",
            "priority": "P3",
            "created_at": "18/02/2026 18:43:29",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 18:43:29"
          },
          {
            "ticket_id": 9711,
            "ticket_number": "359703",
            "title": "RGPD + CVO assinados localizador 6130877",
            "priority": "P3",
            "created_at": "18/02/2026 21:31:38",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 21:31:40"
          },
          {
            "ticket_id": 9713,
            "ticket_number": "359705",
            "title": "RGPD",
            "priority": "P3",
            "created_at": "18/02/2026 21:57:23",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 21:57:24"
          },
          {
            "ticket_id": 9718,
            "ticket_number": "359710",
            "title": "Pedido RGPD e CVO",
            "priority": "P3",
            "created_at": "18/02/2026 23:50:22",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "18/02/2026 23:50:22"
          },
          {
            "ticket_id": 9732,
            "ticket_number": "359724",
            "title": "RGPD_Sara Nobre",
            "priority": "P3",
            "created_at": "19/02/2026 10:07:45",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 10:07:45"
          },
          {
            "ticket_id": 9744,
            "ticket_number": "359736",
            "title": "Comprovativo dia Profissional BTL - 26 Fev 2026",
            "priority": "P3",
            "created_at": "19/02/2026 11:32:19",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 11:32:19"
          },
          {
            "ticket_id": 9759,
            "ticket_number": "359751",
            "title": "Comprovativo Pagamento Fly e 2 Páginas Autocolante",
            "priority": "P3",
            "created_at": "19/02/2026 13:26:31",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 13:26:31"
          },
          {
            "ticket_id": 9793,
            "ticket_number": "359785",
            "title": "SOLICITO RGPD - NUNO FILIPE DA SILVA MARQUES - OPT",
            "priority": "P3",
            "created_at": "19/02/2026 19:00:53",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 19:00:54"
          },
          {
            "ticket_id": 9814,
            "ticket_number": "359806",
            "title": "GBN-106943",
            "priority": "P3",
            "created_at": "19/02/2026 22:44:27",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/02/2026 22:44:28"
          },
          {
            "ticket_id": 9817,
            "ticket_number": "359809",
            "title": "Envio de fatura",
            "priority": "P2",
            "created_at": "20/02/2026 00:03:20",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 00:03:21"
          },
          {
            "ticket_id": 9821,
            "ticket_number": "359813",
            "title": "GBN-106957",
            "priority": "P3",
            "created_at": "20/02/2026 00:03:35",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 00:03:35"
          },
          {
            "ticket_id": 9827,
            "ticket_number": "359819",
            "title": "Dúvidas e Pedidos de retificação Cockpit ",
            "priority": "P2",
            "created_at": "20/02/2026 10:19:01",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:19:01"
          },
          {
            "ticket_id": 9848,
            "ticket_number": "359840",
            "title": "GBN-106963",
            "priority": "P3",
            "created_at": "20/02/2026 10:20:50",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 10:20:51"
          },
          {
            "ticket_id": 9850,
            "ticket_number": "359842",
            "title": "Fwd: Envio do documento - Soltropico",
            "priority": "P2",
            "created_at": "20/02/2026 10:37:54",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:37:54"
          },
          {
            "ticket_id": 9851,
            "ticket_number": "359843",
            "title": "Fwd: Documentación Reserva: 6124315",
            "priority": "P3",
            "created_at": "20/02/2026 10:37:57",
            "close_date": "2026-02-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 10:37:58"
          },
          {
            "ticket_id": 9903,
            "ticket_number": "359891",
            "title": "Voucher Oferta",
            "priority": "P3",
            "created_at": "20/02/2026 15:04:09",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 15:04:09"
          },
          {
            "ticket_id": 9905,
            "ticket_number": "359893",
            "title": "Erros detectados Cockpit",
            "priority": "P2",
            "created_at": "20/02/2026 16:06:39",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:06:39"
          },
          {
            "ticket_id": 9939,
            "ticket_number": "359927",
            "title": "Fly - Comprovativo pagamento",
            "priority": "P3",
            "created_at": "20/02/2026 19:20:36",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 19:20:38"
          },
          {
            "ticket_id": 9956,
            "ticket_number": "359944",
            "title": "Retificação de dados Cockpit",
            "priority": "P3",
            "created_at": "20/02/2026 20:40:46",
            "close_date": "2026-02-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 20:40:47"
          },
          {
            "ticket_id": 9978,
            "ticket_number": "359966",
            "title": "Cockipt reserva GBN-96257",
            "priority": "P3",
            "created_at": "20/02/2026 23:06:09",
            "close_date": "2026-02-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 23:06:09"
          },
          {
            "ticket_id": 9990,
            "ticket_number": "359978",
            "title": "valor comissão e viagem incorreta",
            "priority": "P2",
            "created_at": "21/02/2026 10:07:21",
            "close_date": "2026-02-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 10:07:21"
          },
          {
            "ticket_id": 10010,
            "ticket_number": "359998",
            "title": "Comissões a receber",
            "priority": "P2",
            "created_at": "21/02/2026 13:09:47",
            "close_date": "2026-02-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:09:47"
          },
          {
            "ticket_id": 10033,
            "ticket_number": "3510021",
            "title": "Viagem já marcada nb6122921",
            "priority": "P2",
            "created_at": "21/02/2026 16:49:54",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 16:49:52"
          },
          {
            "ticket_id": 10035,
            "ticket_number": "3510023",
            "title": "Recibo Verde - Comissões - Fevereiro 26",
            "priority": "P2",
            "created_at": "21/02/2026 17:43:39",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 17:43:40"
          },
          {
            "ticket_id": 10043,
            "ticket_number": "3510031",
            "title": "Re: Dificuldades no Cockpit",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:15"
          },
          {
            "ticket_id": 10046,
            "ticket_number": "3510034",
            "title": "Cockpit Reservas",
            "priority": "P2",
            "created_at": "23/02/2026 10:14:22",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:14:23"
          },
          {
            "ticket_id": 10053,
            "ticket_number": "3510041",
            "title": "Correção de valores - OPTI nº 2412000028",
            "priority": "P3",
            "created_at": "23/02/2026 10:14:38",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/02/2026 10:14:38"
          },
          {
            "ticket_id": 10072,
            "ticket_number": "3510060",
            "title": "Criação de operador no Cockpit",
            "priority": "P2",
            "created_at": "23/02/2026 10:32:25",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:32:26"
          },
          {
            "ticket_id": 10074,
            "ticket_number": "3510062",
            "title": "Validação Manual CVO e RGPD",
            "priority": "P2",
            "created_at": "23/02/2026 10:34:03",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 10:34:03"
          },
          {
            "ticket_id": 10086,
            "ticket_number": "3510074",
            "title": "Fatura e (cvo-rgpd cockpit)",
            "priority": "P2",
            "created_at": "23/02/2026 11:27:34",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:27:35"
          },
          {
            "ticket_id": 10093,
            "ticket_number": "3510081",
            "title": "Cockpit",
            "priority": "P2",
            "created_at": "23/02/2026 11:40:21",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 11:40:22"
          },
          {
            "ticket_id": 10106,
            "ticket_number": "3510094",
            "title": "Cockpit | Falta de informação",
            "priority": "P2",
            "created_at": "23/02/2026 12:57:47",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 12:57:47"
          },
          {
            "ticket_id": 10114,
            "ticket_number": "3510102",
            "title": "KIT BTL + AUTOCOLANTES",
            "priority": "P2",
            "created_at": "23/02/2026 13:38:48",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 13:38:49"
          },
          {
            "ticket_id": 10124,
            "ticket_number": "3510112",
            "title": "Emissão de Voucher Oferta",
            "priority": "P2",
            "created_at": "23/02/2026 14:28:51",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 14:28:51"
          },
          {
            "ticket_id": 10131,
            "ticket_number": "3510119",
            "title": "Cockpit | Valores",
            "priority": "P2",
            "created_at": "23/02/2026 15:09:30",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 15:09:31"
          },
          {
            "ticket_id": 10145,
            "ticket_number": "3510133",
            "title": "BTL dia 26",
            "priority": "P2",
            "created_at": "23/02/2026 16:24:07",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 16:24:08"
          },
          {
            "ticket_id": 10166,
            "ticket_number": "3510154",
            "title": "BTL _ Bilhete 26",
            "priority": "P3",
            "created_at": "23/02/2026 19:08:30",
            "close_date": "2026-03-05",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/02/2026 19:08:31"
          },
          {
            "ticket_id": 10168,
            "ticket_number": "3510156",
            "title": "comissoes, não aparecem p/levantamento no cockpit",
            "priority": "P2",
            "created_at": "23/02/2026 19:08:37",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 19:08:38"
          },
          {
            "ticket_id": 10188,
            "ticket_number": "3510176",
            "title": "Preenchimento dos formulários - Nova Viagem",
            "priority": "P2",
            "created_at": "23/02/2026 23:04:22",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 23:04:22"
          },
          {
            "ticket_id": 10192,
            "ticket_number": "3510180",
            "title": "Fwd: Nova Viagem #260200262 - Liliana Pinho/ Viage",
            "priority": "P2",
            "created_at": "23/02/2026 23:22:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 23:22:14"
          },
          {
            "ticket_id": 10212,
            "ticket_number": "3510200",
            "title": "Erro Plataforma pedido pagamento",
            "priority": "P2",
            "created_at": "24/02/2026 10:08:24",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:08:24"
          },
          {
            "ticket_id": 10214,
            "ticket_number": "3510202",
            "title": "RGPD + CVO",
            "priority": "P2",
            "created_at": "24/02/2026 10:29:10",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:29:10"
          },
          {
            "ticket_id": 10225,
            "ticket_number": "3510213",
            "title": "Pagamento BTL 26/02/2026",
            "priority": "P2",
            "created_at": "24/02/2026 11:09:43",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:03:12"
          },
          {
            "ticket_id": 10227,
            "ticket_number": "3510215",
            "title": "seguro",
            "priority": "P2",
            "created_at": "24/02/2026 11:09:49",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:09:49"
          },
          {
            "ticket_id": 10265,
            "ticket_number": "3510253",
            "title": "Comissoes no cockpit",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:09",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:10"
          },
          {
            "ticket_id": 10277,
            "ticket_number": "3510265",
            "title": "Divergencia entre o valor pago e o valor registado",
            "priority": "P2",
            "created_at": "24/02/2026 17:24:41",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 17:24:41"
          },
          {
            "ticket_id": 10347,
            "ticket_number": "3510335",
            "title": "Correções Cockpit",
            "priority": "P2",
            "created_at": "25/02/2026 10:51:21",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:51:21"
          },
          {
            "ticket_id": 10389,
            "ticket_number": "3510377",
            "title": "Dúvidas/Erros Cockpit",
            "priority": "P2",
            "created_at": "25/02/2026 14:21:20",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 14:21:21"
          },
          {
            "ticket_id": 10408,
            "ticket_number": "3510396",
            "title": "Pedido de credenciais Zammad",
            "priority": "P2",
            "created_at": "25/02/2026 16:22:06",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 16:22:07"
          },
          {
            "ticket_id": 10416,
            "ticket_number": "3510404",
            "title": "[Cancelamento Serviço] TRP-2026-00104 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/02/2026 17:55:04",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:55:04"
          },
          {
            "ticket_id": 10422,
            "ticket_number": "3510410",
            "title": "[Cancelamento Viagem] TRP-2026-03668 - Carolina Fe",
            "priority": "P2",
            "created_at": "25/02/2026 18:01:59",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:02:00"
          },
          {
            "ticket_id": 10423,
            "ticket_number": "3510411",
            "title": "[Cancelamento Serviço] TRP-2026-03668 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/02/2026 18:02:04",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:02:04"
          },
          {
            "ticket_id": 10436,
            "ticket_number": "3510424",
            "title": "Pagamento BTL",
            "priority": "P3",
            "created_at": "25/02/2026 20:42:33",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/02/2026 20:42:33"
          },
          {
            "ticket_id": 10437,
            "ticket_number": "3510425",
            "title": "Cockpit - por favor apagar reserva TRP-2026-03849",
            "priority": "P2",
            "created_at": "25/02/2026 21:10:21",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:10:21"
          },
          {
            "ticket_id": 10462,
            "ticket_number": "3510450",
            "title": "Pagamento fly e kit",
            "priority": "P3",
            "created_at": "25/02/2026 23:57:38",
            "close_date": "2026-03-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/02/2026 23:57:38"
          },
          {
            "ticket_id": 10467,
            "ticket_number": "3510455",
            "title": "Comprovativo bilhete BTL",
            "priority": "P2",
            "created_at": "26/02/2026 10:03:53",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:03:53"
          },
          {
            "ticket_id": 10547,
            "ticket_number": "3510535",
            "title": "Plataforma Nova - Pontos a validar",
            "priority": "P2",
            "created_at": "26/02/2026 18:53:25",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 18:53:25"
          },
          {
            "ticket_id": 10629,
            "ticket_number": "3510617",
            "title": "RE: reserva Cuba 6122325",
            "priority": "P2",
            "created_at": "27/02/2026 13:35:38",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:39:08"
          },
          {
            "ticket_id": 10726,
            "ticket_number": "3510714",
            "title": "Reclamação",
            "priority": "P2",
            "created_at": "27/02/2026 23:00:27",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 23:00:27"
          },
          {
            "ticket_id": 10807,
            "ticket_number": "3510795",
            "title": "RGPD e CVO",
            "priority": "P2",
            "created_at": "28/02/2026 18:54:38",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:54:39"
          },
          {
            "ticket_id": 10808,
            "ticket_number": "3510796",
            "title": "TRP-2026-03927",
            "priority": "P2",
            "created_at": "28/02/2026 18:54:40",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 18:54:41"
          },
          {
            "ticket_id": 10928,
            "ticket_number": "3510916",
            "title": "erro cockpit TRP-2026-03227 e 03134",
            "priority": "P2",
            "created_at": "01/03/2026 19:42:31",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/03/2026 19:42:31"
          },
          {
            "ticket_id": 11114,
            "ticket_number": "3511102",
            "title": "validar assinaturas rgpd pf",
            "priority": "P2",
            "created_at": "02/03/2026 22:57:26",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 22:57:26"
          },
          {
            "ticket_id": 11120,
            "ticket_number": "3511108",
            "title": "[Cancelamento Serviço] TRP-2026-04030 / TRL-2026-0",
            "priority": "P3",
            "created_at": "02/03/2026 23:29:25",
            "close_date": "2026-03-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/03/2026 23:29:25"
          },
          {
            "ticket_id": 11168,
            "ticket_number": "3511156",
            "title": "dados acesso Zammad",
            "priority": "P2",
            "created_at": "03/03/2026 12:34:17",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:34:17"
          },
          {
            "ticket_id": 11195,
            "ticket_number": "3511183",
            "title": "[Suporte] TRP-2026-03555 - Atualizar valores com m",
            "priority": "P2",
            "created_at": "03/03/2026 14:04:12",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 14:04:12"
          },
          {
            "ticket_id": 11293,
            "ticket_number": "3511281",
            "title": "Cockpit  Reservas Cayo Santa Maria Canceladas",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:37",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 10:17:37"
          },
          {
            "ticket_id": 11318,
            "ticket_number": "3511306",
            "title": "[Cancelamento Serviço] TRP-2026-03867 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/03/2026 11:15:16",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 11:15:16"
          },
          {
            "ticket_id": 11387,
            "ticket_number": "3511375",
            "title": "Correção de valores na Opti n.º 2417300044",
            "priority": "P2",
            "created_at": "04/03/2026 14:42:22",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 14:42:23"
          },
          {
            "ticket_id": 11453,
            "ticket_number": "3511441",
            "title": "TRP-2026-04074",
            "priority": "P2",
            "created_at": "04/03/2026 22:06:12",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 22:06:12"
          },
          {
            "ticket_id": 11454,
            "ticket_number": "3511442",
            "title": "CVO errado",
            "priority": "P2",
            "created_at": "04/03/2026 22:08:41",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 22:08:41"
          },
          {
            "ticket_id": 11462,
            "ticket_number": "3511450",
            "title": "RGPD e CVO",
            "priority": "P2",
            "created_at": "04/03/2026 23:06:53",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 23:06:53"
          },
          {
            "ticket_id": 11475,
            "ticket_number": "3511463",
            "title": "Uma Familia Em Viagem - Uma Familia Em Viagem Supo",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:17",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11512,
            "ticket_number": "3511500",
            "title": "Comprovativo Fly",
            "priority": "P2",
            "created_at": "05/03/2026 12:43:44",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 12:43:45"
          },
          {
            "ticket_id": 11551,
            "ticket_number": "3511539",
            "title": "Opti 241600020",
            "priority": "P2",
            "created_at": "05/03/2026 18:51:50",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 18:51:50"
          },
          {
            "ticket_id": 11581,
            "ticket_number": "3511569",
            "title": "Fatura Pagamento Viagem Malta - Loc:TRP-2026-03856",
            "priority": "P2",
            "created_at": "05/03/2026 21:17:15",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 21:17:15"
          },
          {
            "ticket_id": 11596,
            "ticket_number": "3511584",
            "title": "Pedido fatura viagem Rom Loc: TRP-2026-04061",
            "priority": "P2",
            "created_at": "05/03/2026 23:13:58",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:13:59"
          },
          {
            "ticket_id": 11609,
            "ticket_number": "3511597",
            "title": "pedido de fatura",
            "priority": "P2",
            "created_at": "06/03/2026 10:09:04",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:09:05"
          },
          {
            "ticket_id": 11638,
            "ticket_number": "3511626",
            "title": "dados de acesso tickets",
            "priority": "P3",
            "created_at": "06/03/2026 13:05:21",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 13:05:21"
          },
          {
            "ticket_id": 11646,
            "ticket_number": "3511634",
            "title": "Email no telemóvel",
            "priority": "P2",
            "created_at": "06/03/2026 13:18:55",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:18:55"
          },
          {
            "ticket_id": 11663,
            "ticket_number": "3511651",
            "title": "reserva ativa no cockpit com o localizador 6124525",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:17",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:47:18"
          },
          {
            "ticket_id": 11716,
            "ticket_number": "3511704",
            "title": "Pedido de fatura TRP-2026-03931",
            "priority": "P2",
            "created_at": "06/03/2026 19:46:17",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:46:18"
          },
          {
            "ticket_id": 11717,
            "ticket_number": "3511705",
            "title": "Correções no Cockpit - Rita Ribeiro",
            "priority": "P2",
            "created_at": "06/03/2026 19:46:22",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:46:22"
          },
          {
            "ticket_id": 11726,
            "ticket_number": "3511714",
            "title": "dados errados no cockpit",
            "priority": "P2",
            "created_at": "06/03/2026 20:29:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:29:55"
          },
          {
            "ticket_id": 11798,
            "ticket_number": "3511786",
            "title": "[Suporte] TRP-2026-03991 / TRL-2026-06035 - Fatura",
            "priority": "P2",
            "created_at": "07/03/2026 14:50:38",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 14:50:38"
          },
          {
            "ticket_id": 11799,
            "ticket_number": "3511787",
            "title": "[Suporte] TRP-2026-03832 - Fatura 1º Pagamento",
            "priority": "P2",
            "created_at": "07/03/2026 14:54:25",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 14:54:25"
          },
          {
            "ticket_id": 11808,
            "ticket_number": "3511796",
            "title": "Inscrição Fly 2026",
            "priority": "P2",
            "created_at": "07/03/2026 17:12:08",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 17:12:09"
          },
          {
            "ticket_id": 11810,
            "ticket_number": "3511798",
            "title": "Inscrição na Fly Porto 2026",
            "priority": "P2",
            "created_at": "07/03/2026 18:09:47",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 18:09:47"
          },
          {
            "ticket_id": 11880,
            "ticket_number": "3511868",
            "title": "Comissões",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:26",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:07:26"
          },
          {
            "ticket_id": 11891,
            "ticket_number": "3511879",
            "title": "Cockpit | Viagem não aparece",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:52",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:07:52"
          },
          {
            "ticket_id": 11947,
            "ticket_number": "3511935",
            "title": "Validação de pagamentos",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:22",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:54:22"
          },
          {
            "ticket_id": 11948,
            "ticket_number": "3511936",
            "title": "Comprovativo de pagamento Kit UFEV",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:24",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:54:24"
          },
          {
            "ticket_id": 11950,
            "ticket_number": "3511938",
            "title": "Comprovativo pagamento turno FLY - sábado",
            "priority": "P2",
            "created_at": "09/03/2026 13:54:28",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 13:54:29"
          },
          {
            "ticket_id": 11954,
            "ticket_number": "3511942",
            "title": "Orçamento Malta",
            "priority": "P2",
            "created_at": "09/03/2026 14:03:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:05"
          },
          {
            "ticket_id": 12032,
            "ticket_number": "3512020",
            "title": "Comprovativo de RGPD e CVO da Viagem nº TRP-2026-0",
            "priority": "P2",
            "created_at": "10/03/2026 10:12:19",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:12:20"
          },
          {
            "ticket_id": 12134,
            "ticket_number": "3512122",
            "title": "Faturas | Cobrança Acesso à Plataforma",
            "priority": "P1",
            "created_at": "10/03/2026 23:45:26",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 13.98,
            "sla_met": false,
            "sla_breach_hours": 13.73,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 13:44:48"
          },
          {
            "ticket_id": 12135,
            "ticket_number": "3512123",
            "title": "RGPD + CVO TRP-2026-03900",
            "priority": "P3",
            "created_at": "10/03/2026 23:45:28",
            "close_date": "2026-03-30",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/03/2026 23:45:28"
          },
          {
            "ticket_id": 12164,
            "ticket_number": "3512152",
            "title": "[Suporte] TRP-2026-02491 - Alteração de datas da v",
            "priority": "P2",
            "created_at": "11/03/2026 11:08:12",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 11:08:12"
          },
          {
            "ticket_id": 12298,
            "ticket_number": "3512286",
            "title": "Acessos Zammad - Farah Remtula",
            "priority": "P2",
            "created_at": "11/03/2026 22:48:08",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 2.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 00:51:08"
          },
          {
            "ticket_id": 12659,
            "ticket_number": "3512647",
            "title": "Re: [Cockpit] Viagem TRP-2026-03214 - HAV • Ana Re",
            "priority": "P3",
            "created_at": "16/03/2026 10:08:11",
            "close_date": "2026-04-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/03/2026 10:08:13"
          },
          {
            "ticket_id": 12735,
            "ticket_number": "3512723",
            "title": "Comprovativo pagamento kit fly",
            "priority": "P2",
            "created_at": "16/03/2026 14:07:12",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:07:12"
          },
          {
            "ticket_id": 12874,
            "ticket_number": "3512862",
            "title": "CVO e RGPD",
            "priority": "P2",
            "created_at": "17/03/2026 14:50:58",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:50:58"
          },
          {
            "ticket_id": 12914,
            "ticket_number": "3512902",
            "title": "Contacto da agência para apoio em viagem – urgente",
            "priority": "P2",
            "created_at": "17/03/2026 18:29:15",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:59:18"
          },
          {
            "ticket_id": 12989,
            "ticket_number": "3512977",
            "title": "Vendas e Comissões - COCKPIT",
            "priority": "P2",
            "created_at": "18/03/2026 13:04:41",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:04:42"
          },
          {
            "ticket_id": 12990,
            "ticket_number": "3512978",
            "title": "Pedido de faturas em atraso",
            "priority": "P2",
            "created_at": "18/03/2026 13:04:43",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:04:43"
          },
          {
            "ticket_id": 12991,
            "ticket_number": "3512979",
            "title": "TRP-2026-03536 - COCKPIT",
            "priority": "P2",
            "created_at": "18/03/2026 13:04:44",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:04:45"
          },
          {
            "ticket_id": 13053,
            "ticket_number": "3513041",
            "title": "Incumprimento contratual e regularização urgente",
            "priority": "P1",
            "created_at": "18/03/2026 19:58:30",
            "close_date": "2026-03-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 161.47,
            "sla_met": false,
            "sla_breach_hours": 161.22,
            "sla_name": "SLA P1",
            "first_response_at": "25/03/2026 13:26:51"
          },
          {
            "ticket_id": 13069,
            "ticket_number": "3513057",
            "title": "Ajuda Cockpit",
            "priority": "P1",
            "created_at": "18/03/2026 22:56:27",
            "close_date": "2026-03-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/03/2026 22:56:28"
          },
          {
            "ticket_id": 13195,
            "ticket_number": "3513183",
            "title": "Acesso suporte ufev",
            "priority": "P2",
            "created_at": "20/03/2026 10:03:40",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:03:41"
          },
          {
            "ticket_id": 13345,
            "ticket_number": "3513333",
            "title": "TRP-2026-03109 - fatura e recibo",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:34",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:11:34"
          },
          {
            "ticket_id": 13427,
            "ticket_number": "3513415",
            "title": "pagamento",
            "priority": "P1",
            "created_at": "23/03/2026 15:04:42",
            "close_date": "2026-03-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 15:04:43"
          },
          {
            "ticket_id": 13471,
            "ticket_number": "3513459",
            "title": "TRP-2026-02351",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:49",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:50:49"
          },
          {
            "ticket_id": 13602,
            "ticket_number": "3513590",
            "title": "[Suporte] TRP-2026-03504 / TRL-2026-05340 - Fatura",
            "priority": "P2",
            "created_at": "25/03/2026 13:06:52",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:06:52"
          },
          {
            "ticket_id": 13644,
            "ticket_number": "3513632",
            "title": "[Suporte] TRP-2026-02795 / TRL-2026-04308 - CVO e ",
            "priority": "P3",
            "created_at": "25/03/2026 18:22:22",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/03/2026 18:22:22"
          },
          {
            "ticket_id": 13746,
            "ticket_number": "3513734",
            "title": "TRP-2026-02351 - AC Carolina Ferreirinha",
            "priority": "P1",
            "created_at": "26/03/2026 22:37:32",
            "close_date": "2026-03-31",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/03/2026 22:37:33"
          },
          {
            "ticket_id": 13792,
            "ticket_number": "3513780",
            "title": "Alertas no cokpit",
            "priority": "P3",
            "created_at": "27/03/2026 14:07:51",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/03/2026 14:07:51"
          },
          {
            "ticket_id": 13886,
            "ticket_number": "3513874",
            "title": "[Suporte] TRP-2026-02893 / TRL-2026-04467 - CVO ex",
            "priority": "P2",
            "created_at": "28/03/2026 17:44:50",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:44:50"
          },
          {
            "ticket_id": 13912,
            "ticket_number": "3513900",
            "title": "Reserva TRP-2026-04550 com titular errado",
            "priority": "P2",
            "created_at": "30/03/2026 09:50:20",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:50:21"
          },
          {
            "ticket_id": 14002,
            "ticket_number": "3513990",
            "title": "Incongurênia CVO vs Cockpit",
            "priority": "P3",
            "created_at": "30/03/2026 16:00:33",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/03/2026 16:00:33"
          },
          {
            "ticket_id": 14053,
            "ticket_number": "3514041",
            "title": "Pedido de acesso tickets",
            "priority": "P3",
            "created_at": "31/03/2026 09:07:50",
            "close_date": "2026-03-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/03/2026 09:07:50"
          },
          {
            "ticket_id": 14089,
            "ticket_number": "3514077",
            "title": "AC Carolina",
            "priority": "P2",
            "created_at": "31/03/2026 14:53:00",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 14:53:00"
          },
          {
            "ticket_id": 14173,
            "ticket_number": "3514161",
            "title": "Sugestão Cookpit",
            "priority": "P3",
            "created_at": "01/04/2026 12:13:47",
            "close_date": "2026-04-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/04/2026 12:13:47"
          },
          {
            "ticket_id": 14288,
            "ticket_number": "3514276",
            "title": "Para vossa informação interna",
            "priority": "P2",
            "created_at": "02/04/2026 18:12:00",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:12:01"
          },
          {
            "ticket_id": 14321,
            "ticket_number": "3514309",
            "title": "A/c Carolina",
            "priority": "P1",
            "created_at": "04/04/2026 10:05:37",
            "close_date": "2026-04-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 84.62,
            "sla_met": false,
            "sla_breach_hours": 84.37,
            "sla_name": "SLA P1",
            "first_response_at": "07/04/2026 22:42:42"
          },
          {
            "ticket_id": 14448,
            "ticket_number": "3514436",
            "title": "Djerba",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:35",
            "close_date": "2026-04-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:35"
          },
          {
            "ticket_id": 14464,
            "ticket_number": "3514452",
            "title": "Incorreção no volume de vendas no dashboard do Coc",
            "priority": "P2",
            "created_at": "06/04/2026 18:41:36",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:41:36"
          },
          {
            "ticket_id": 14636,
            "ticket_number": "3514624",
            "title": "Recibos Mensalidade UFEV",
            "priority": "P2",
            "created_at": "08/04/2026 11:19:41",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:19:41"
          },
          {
            "ticket_id": 14733,
            "ticket_number": "3514721",
            "title": "Acesso Zammad",
            "priority": "P2",
            "created_at": "09/04/2026 15:22:05",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:22:05"
          },
          {
            "ticket_id": 14865,
            "ticket_number": "3514853",
            "title": "DGAV1554_26_Uma Familia Em Viagem_MARLENEFERNANDES",
            "priority": "P2",
            "created_at": "10/04/2026 16:41:26",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 402.15,
            "sla_met": false,
            "sla_breach_hours": 398.15,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:51:12"
          },
          {
            "ticket_id": 14970,
            "ticket_number": "3514958",
            "title": "[Suporte] TRP-2026-03691 / TRL-2026-05611 - RGPD a",
            "priority": "P3",
            "created_at": "11/04/2026 21:25:58",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "11/04/2026 21:25:58"
          },
          {
            "ticket_id": 15087,
            "ticket_number": "3515075",
            "title": "VCH-TP3WQSF2 - Engano",
            "priority": "P2",
            "created_at": "13/04/2026 18:44:55",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:44:55"
          },
          {
            "ticket_id": 15182,
            "ticket_number": "3515170",
            "title": "[Suporte] TRP-2026-04295 - Erro no CVO",
            "priority": "P3",
            "created_at": "14/04/2026 17:06:12",
            "close_date": "2026-04-29",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/04/2026 17:06:12"
          },
          {
            "ticket_id": 15190,
            "ticket_number": "3515178",
            "title": "Sugestão Cockpit",
            "priority": "P2",
            "created_at": "14/04/2026 17:57:05",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:57:06"
          },
          {
            "ticket_id": 15219,
            "ticket_number": "3515207",
            "title": "[Suporte] TRP-2026-03473 / TRL-2026-05306 - Fatura",
            "priority": "P2",
            "created_at": "14/04/2026 21:38:41",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 21:38:41"
          },
          {
            "ticket_id": 15298,
            "ticket_number": "3515286",
            "title": "Re: Recibo (ABK14833)",
            "priority": "P3",
            "created_at": "15/04/2026 17:58:52",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/04/2026 17:59:20"
          },
          {
            "ticket_id": 15299,
            "ticket_number": "3515287",
            "title": "Re: Recibo (ABK14833)",
            "priority": "P3",
            "created_at": "15/04/2026 17:58:53",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/04/2026 18:00:07"
          },
          {
            "ticket_id": 15300,
            "ticket_number": "3515288",
            "title": "Re: Recibo (ABK14844)",
            "priority": "P3",
            "created_at": "15/04/2026 17:58:55",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/04/2026 17:59:33"
          },
          {
            "ticket_id": 15301,
            "ticket_number": "3515289",
            "title": "Re: Recibo (ABK14844)",
            "priority": "P3",
            "created_at": "15/04/2026 17:58:56",
            "close_date": "2026-04-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "15/04/2026 17:59:53"
          },
          {
            "ticket_id": 15704,
            "ticket_number": "3515692",
            "title": "Re: Comissões_Cokpit",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:03",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:03:03"
          },
          {
            "ticket_id": 15819,
            "ticket_number": "3515807",
            "title": "Débito de valores",
            "priority": "P1",
            "created_at": "22/04/2026 10:34:59",
            "close_date": "2026-04-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "22/04/2026 10:35:01"
          },
          {
            "ticket_id": 15989,
            "ticket_number": "3515977",
            "title": "Retificação de comissões no cockpit",
            "priority": "P2",
            "created_at": "23/04/2026 18:58:26",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 18:58:26"
          },
          {
            "ticket_id": 16199,
            "ticket_number": "3516187",
            "title": "Re: Sign Request: Adenda e Anexos Contrato - Telma",
            "priority": "P1",
            "created_at": "27/04/2026 10:05:40",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "27/04/2026 10:05:40"
          },
          {
            "ticket_id": 16296,
            "ticket_number": "3516284",
            "title": "Fishtales > pedido das faturas",
            "priority": "P2",
            "created_at": "27/04/2026 22:46:22",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 13.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:41:08"
          },
          {
            "ticket_id": 16569,
            "ticket_number": "3516557",
            "title": "Re: Sign Request: Adenda e Anexos Contrato - Rita ",
            "priority": "P3",
            "created_at": "30/04/2026 13:15:53",
            "close_date": "2026-05-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "30/04/2026 13:15:54"
          },
          {
            "ticket_id": 16633,
            "ticket_number": "3516621",
            "title": "Reiteração de posição – Adenda contratual",
            "priority": "P2",
            "created_at": "30/04/2026 18:56:57",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 18:56:57"
          },
          {
            "ticket_id": 16665,
            "ticket_number": "3516653",
            "title": "Pedido de esclarecimentos e propostas de ajustamen",
            "priority": "P2",
            "created_at": "30/04/2026 21:12:18",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:12:19"
          },
          {
            "ticket_id": 16841,
            "ticket_number": "3516829",
            "title": "adenda",
            "priority": "P2",
            "created_at": "04/05/2026 09:48:20",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:48:20"
          },
          {
            "ticket_id": 17257,
            "ticket_number": "3517245",
            "title": "Faturas subscrição mensal",
            "priority": "P2",
            "created_at": "07/05/2026 10:57:12",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 10:57:12"
          },
          {
            "ticket_id": 17723,
            "ticket_number": "3517711",
            "title": "Ao cuidado da Carolina",
            "priority": "P2",
            "created_at": "12/05/2026 10:36:35",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 10:36:35"
          },
          {
            "ticket_id": 18030,
            "ticket_number": "3518018",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624241",
            "priority": "P2",
            "created_at": "14/05/2026 10:17:58",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 10:51:20"
          },
          {
            "ticket_id": 18408,
            "ticket_number": "3518396",
            "title": "Pedido ediçao Nome TRP 2026-04980",
            "priority": "P2",
            "created_at": "18/05/2026 20:46:32",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 20:46:32"
          },
          {
            "ticket_id": 18525,
            "ticket_number": "3518513",
            "title": "TRP-2026-02676 - valor em falta.",
            "priority": "P2",
            "created_at": "19/05/2026 19:38:07",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 19:38:07"
          }
        ]
      },
      "Rafaela Lapa": {
        "total_tickets": 65,
        "sla_met": 61,
        "sla_missed": 4,
        "sla_compliance_rate": 93.85,
        "tickets": [
          {
            "ticket_id": 191,
            "ticket_number": "35190",
            "title": "GBN-62019 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "03/10/2025 16:04:17",
            "close_date": "2025-10-12",
            "sla_target_hours": 24,
            "actual_time_hours": 1.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/10/2025 17:12:17"
          },
          {
            "ticket_id": 227,
            "ticket_number": "35226",
            "title": "Esclarecimento sobre seguros para atividades extra",
            "priority": "P2",
            "created_at": "06/10/2025 10:10:25",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 10:10:25"
          },
          {
            "ticket_id": 232,
            "ticket_number": "35231",
            "title": "[Ávoris] Re: EXPEDIENTE 604273864 + LOCALIZADOR RE",
            "priority": "P2",
            "created_at": "06/10/2025 10:28:06",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 11:26:45"
          },
          {
            "ticket_id": 235,
            "ticket_number": "35234",
            "title": "GBN-81955 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/10/2025 10:35:35",
            "close_date": "2025-10-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/10/2025 11:24:24"
          },
          {
            "ticket_id": 539,
            "ticket_number": "35538",
            "title": "DPXP44 – Reserva com emissão hoje",
            "priority": "P1",
            "created_at": "13/10/2025 09:06:09",
            "close_date": "2025-10-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "30/09/2025 11:18:02"
          },
          {
            "ticket_id": 577,
            "ticket_number": "35576",
            "title": "Aéreo - Confirmação de Emissão (RIBEIRO/LUIS)",
            "priority": "P2",
            "created_at": "13/10/2025 11:06:01",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 10:49:16"
          },
          {
            "ticket_id": 612,
            "ticket_number": "35611",
            "title": "Re:[## 22730 ##] GBN-79019 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "13/10/2025 17:53:03",
            "close_date": "2025-10-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/10/2025 19:45:26"
          },
          {
            "ticket_id": 904,
            "ticket_number": "35903",
            "title": "Re:[## 23198 ##] GBN-79019 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "19/10/2025 10:50:45",
            "close_date": "2025-10-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/10/2025 10:21:31"
          },
          {
            "ticket_id": 922,
            "ticket_number": "35921",
            "title": "Pedido esclarecimento Solferias",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:18",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:18"
          },
          {
            "ticket_id": 923,
            "ticket_number": "35922",
            "title": "Assintos Pendentes",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:19",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:20"
          },
          {
            "ticket_id": 930,
            "ticket_number": "35929",
            "title": "Pedido relativo à reserva 604477059",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:36",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 09:21:36"
          },
          {
            "ticket_id": 931,
            "ticket_number": "35930",
            "title": "Cancelamento de reserva",
            "priority": "P2",
            "created_at": "20/10/2025 09:21:37",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/10/2025 17:58:50"
          },
          {
            "ticket_id": 964,
            "ticket_number": "35963",
            "title": "SMY 1167089501",
            "priority": "P2",
            "created_at": "20/10/2025 17:09:08",
            "close_date": "2025-10-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/10/2025 17:09:08"
          },
          {
            "ticket_id": 1075,
            "ticket_number": "351073",
            "title": "Re:[## 23445 ##] GBN-84757 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "22/10/2025 10:39:58",
            "close_date": "2025-10-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/10/2025 10:55:25"
          },
          {
            "ticket_id": 1208,
            "ticket_number": "351205",
            "title": "Confirmação de reserva para For PT004157 66890519",
            "priority": "P2",
            "created_at": "24/10/2025 10:57:45",
            "close_date": "2025-10-24",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/10/2025 13:08:28"
          },
          {
            "ticket_id": 1292,
            "ticket_number": "351289",
            "title": "REMINDER: Dados de Passaporte - nosso File 406908",
            "priority": "P2",
            "created_at": "27/10/2025 10:06:21",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:26:30"
          },
          {
            "ticket_id": 1316,
            "ticket_number": "351313",
            "title": "Urgente - Problema alojamento",
            "priority": "P2",
            "created_at": "27/10/2025 10:54:57",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 10:54:57"
          },
          {
            "ticket_id": 1365,
            "ticket_number": "351362",
            "title": "Re: Pedido de autorização",
            "priority": "P2",
            "created_at": "27/10/2025 19:01:11",
            "close_date": "2025-10-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/10/2025 19:01:11"
          },
          {
            "ticket_id": 1392,
            "ticket_number": "351389",
            "title": "Eticket - 66890519 - EU  14/11/2025  Barcelona, Es",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:33",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:19:12"
          },
          {
            "ticket_id": 1393,
            "ticket_number": "351390",
            "title": "Eticket - 66890519 - EU  14/11/2025  Barcelona, Es",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:38",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:18:15"
          },
          {
            "ticket_id": 1396,
            "ticket_number": "351393",
            "title": "Eticket - 66890519 - EU  14/11/2025  Barcelona, Es",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:48",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:17:17"
          },
          {
            "ticket_id": 1397,
            "ticket_number": "351394",
            "title": "REMINDER: Dados de Passaporte - nosso File 406908",
            "priority": "P2",
            "created_at": "28/10/2025 10:04:51",
            "close_date": "2025-10-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/10/2025 10:14:42"
          },
          {
            "ticket_id": 1406,
            "ticket_number": "351403",
            "title": "\"GBN-87699 - Your request has been received\"",
            "priority": "P1",
            "created_at": "28/10/2025 11:38:21",
            "close_date": "2025-10-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "28/10/2025 11:40:41"
          },
          {
            "ticket_id": 1668,
            "ticket_number": "351665",
            "title": "Esclarecimento taxas ocupação/turisticas - urgente",
            "priority": "P3",
            "created_at": "02/11/2025 10:23:57",
            "close_date": "2025-11-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/11/2025 10:23:58"
          },
          {
            "ticket_id": 1677,
            "ticket_number": "351674",
            "title": "Fwd: Informações da reserva TTN-1205660590#8450018",
            "priority": "P2",
            "created_at": "02/11/2025 10:47:39",
            "close_date": "2025-11-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/11/2025 10:47:40"
          },
          {
            "ticket_id": 2048,
            "ticket_number": "352044",
            "title": "Re:[## 24568 ##] GBN-85713 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "08/11/2025 16:46:17",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 41.65,
            "sla_met": false,
            "sla_breach_hours": 37.65,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:26:14"
          },
          {
            "ticket_id": 2079,
            "ticket_number": "352075",
            "title": "GBN-89294 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/11/2025 10:11:03",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 10:27:57"
          },
          {
            "ticket_id": 2107,
            "ticket_number": "352103",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604485932",
            "priority": "P2",
            "created_at": "10/11/2025 11:38:32",
            "close_date": "2025-11-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/11/2025 11:58:29"
          },
          {
            "ticket_id": 2198,
            "ticket_number": "352194",
            "title": "Re:[## 24666 ##] GBN-73323 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "11/11/2025 15:57:18",
            "close_date": "2025-11-13",
            "sla_target_hours": 4,
            "actual_time_hours": 42.8,
            "sla_met": false,
            "sla_breach_hours": 38.8,
            "sla_name": "SLA P2",
            "first_response_at": "13/11/2025 10:46:13"
          },
          {
            "ticket_id": 2269,
            "ticket_number": "352265",
            "title": "Confirmação de Reserva * File 409747",
            "priority": "P2",
            "created_at": "12/11/2025 12:23:06",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 15:47:32"
          },
          {
            "ticket_id": 2270,
            "ticket_number": "352266",
            "title": "RE: SOLFERIAS 409747",
            "priority": "P2",
            "created_at": "12/11/2025 12:23:43",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 15:47:51"
          },
          {
            "ticket_id": 2280,
            "ticket_number": "352276",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604469673",
            "priority": "P3",
            "created_at": "12/11/2025 12:45:42",
            "close_date": "2025-11-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/11/2025 16:22:45"
          },
          {
            "ticket_id": 2298,
            "ticket_number": "352294",
            "title": "Re:[## 20467 ##] GBN-80770 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/11/2025 16:13:33",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:14:28"
          },
          {
            "ticket_id": 2299,
            "ticket_number": "352295",
            "title": "GBN-89481 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/11/2025 16:32:18",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 16:56:40"
          },
          {
            "ticket_id": 2300,
            "ticket_number": "352296",
            "title": "Re:[## 21059 ##] Fwd: Pedido de esclarecimento - G",
            "priority": "P2",
            "created_at": "12/11/2025 16:32:19",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 16:42:30"
          },
          {
            "ticket_id": 2310,
            "ticket_number": "352305",
            "title": "Confirmação de reserva para For PT004157 67529346",
            "priority": "P2",
            "created_at": "12/11/2025 17:27:35",
            "close_date": "2025-11-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/11/2025 17:29:29"
          },
          {
            "ticket_id": 2533,
            "ticket_number": "352528",
            "title": "Att. Catia _ RV _ 38154 - 38155",
            "priority": "P2",
            "created_at": "15/11/2025 13:22:48",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 13:22:48"
          },
          {
            "ticket_id": 2542,
            "ticket_number": "352537",
            "title": "GBN-82375 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/11/2025 16:55:19",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/11/2025 16:55:21"
          },
          {
            "ticket_id": 2545,
            "ticket_number": "352540",
            "title": "Att. Cátia _ RV _ 604366314",
            "priority": "P3",
            "created_at": "16/11/2025 10:54:49",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/11/2025 10:54:50"
          },
          {
            "ticket_id": 2563,
            "ticket_number": "352558",
            "title": "GBN-85625 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/11/2025 18:28:09",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 163.05,
            "sla_met": false,
            "sla_breach_hours": 159.05,
            "sla_name": "SLA P2",
            "first_response_at": "23/11/2025 13:32:08"
          },
          {
            "ticket_id": 2576,
            "ticket_number": "352571",
            "title": "REMINDER: Dados de Passaporte - nosso File 402834",
            "priority": "P2",
            "created_at": "17/11/2025 10:19:18",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 12:02:23"
          },
          {
            "ticket_id": 2577,
            "ticket_number": "352572",
            "title": "Contatos de Cliente em falta - n/File 402834",
            "priority": "P3",
            "created_at": "17/11/2025 10:19:20",
            "close_date": "2025-11-17",
            "sla_target_hours": 24,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "17/11/2025 11:20:30"
          },
          {
            "ticket_id": 2625,
            "ticket_number": "352620",
            "title": "Re:[## 25156 ##] GBN-84160 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "17/11/2025 17:49:28",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 17:49:28"
          },
          {
            "ticket_id": 2627,
            "ticket_number": "352622",
            "title": "\"GBN-77161 - Your request has been received\"",
            "priority": "P2",
            "created_at": "17/11/2025 18:22:45",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/11/2025 11:15:53"
          },
          {
            "ticket_id": 2628,
            "ticket_number": "352623",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "17/11/2025 18:29:41",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:33:06"
          },
          {
            "ticket_id": 2629,
            "ticket_number": "352624",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "17/11/2025 18:29:43",
            "close_date": "2025-11-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 18:32:18"
          },
          {
            "ticket_id": 2636,
            "ticket_number": "352631",
            "title": "\"GBN-77161 - Your request has been received\"",
            "priority": "P2",
            "created_at": "17/11/2025 19:13:48",
            "close_date": "2025-11-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/11/2025 19:19:04"
          },
          {
            "ticket_id": 2901,
            "ticket_number": "352896",
            "title": "GBN-86600 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "20/11/2025 18:33:01",
            "close_date": "2025-11-24",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "24/10/2025 12:58:36"
          },
          {
            "ticket_id": 3579,
            "ticket_number": "353572",
            "title": "GBN-92653 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/12/2025 00:03:22",
            "close_date": "2025-12-01",
            "sla_target_hours": 4,
            "actual_time_hours": 11.6,
            "sla_met": false,
            "sla_breach_hours": 7.6,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 11:39:50"
          },
          {
            "ticket_id": 3593,
            "ticket_number": "353586",
            "title": "1208029207 SMY - Pedido cliente",
            "priority": "P2",
            "created_at": "01/12/2025 11:32:07",
            "close_date": "2025-12-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/12/2025 11:32:08"
          },
          {
            "ticket_id": 3596,
            "ticket_number": "353589",
            "title": "RE: Pedido de cotação",
            "priority": "P3",
            "created_at": "01/12/2025 11:59:57",
            "close_date": "2025-12-01",
            "sla_target_hours": 24,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/12/2025 13:17:04"
          },
          {
            "ticket_id": 3681,
            "ticket_number": "353673",
            "title": "Re:[## 24041 ##] GBN-86003 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "02/12/2025 13:50:08",
            "close_date": "2025-12-02",
            "sla_target_hours": 24,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "02/12/2025 16:56:28"
          },
          {
            "ticket_id": 3708,
            "ticket_number": "353700",
            "title": "Envio de Documentação * File 409747",
            "priority": "P3",
            "created_at": "02/12/2025 17:51:13",
            "close_date": "2025-12-03",
            "sla_target_hours": 24,
            "actual_time_hours": 21.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 15:16:33"
          },
          {
            "ticket_id": 3754,
            "ticket_number": "353746",
            "title": "Re:[## 16075 ##] GBN-73323 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/12/2025 10:56:47",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/12/2025 14:56:47"
          },
          {
            "ticket_id": 3791,
            "ticket_number": "353783",
            "title": "GBN-65878 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "03/12/2025 15:37:14",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/12/2025 15:38:37"
          },
          {
            "ticket_id": 4028,
            "ticket_number": "354020",
            "title": "Confirmação de Reserva File 420983/25",
            "priority": "P3",
            "created_at": "07/12/2025 19:36:15",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "07/12/2025 19:41:39"
          },
          {
            "ticket_id": 4030,
            "ticket_number": "354022",
            "title": "Alteração data de nascimento passageiro",
            "priority": "P2",
            "created_at": "08/12/2025 10:10:05",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/12/2025 10:10:05"
          },
          {
            "ticket_id": 4033,
            "ticket_number": "354025",
            "title": "LOCALIZADOR 409435 E 408831",
            "priority": "P2",
            "created_at": "08/12/2025 10:10:13",
            "close_date": "2025-12-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/12/2025 10:10:13"
          },
          {
            "ticket_id": 4034,
            "ticket_number": "354026",
            "title": "Mensagem sobre a reserva 35417431 - Civitatis",
            "priority": "P2",
            "created_at": "08/12/2025 10:14:01",
            "close_date": "2025-12-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/12/2025 10:24:42"
          },
          {
            "ticket_id": 4081,
            "ticket_number": "354073",
            "title": "Re:[## 26816 ##] GBN-65878 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "09/12/2025 13:33:07",
            "close_date": "2025-12-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 11:31:21"
          },
          {
            "ticket_id": 4087,
            "ticket_number": "354079",
            "title": "GBN-65878 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/12/2025 14:14:08",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/12/2025 18:01:14"
          },
          {
            "ticket_id": 4138,
            "ticket_number": "354130",
            "title": "Reminder * Reserva File 420983 * Deadline Hoje 13H",
            "priority": "P2",
            "created_at": "10/12/2025 10:51:59",
            "close_date": "2025-12-10",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/12/2025 12:17:57"
          },
          {
            "ticket_id": 4315,
            "ticket_number": "354307",
            "title": "Re:[## 27156 ##] GBN-65878 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/12/2025 18:11:19",
            "close_date": "2025-12-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/12/2025 17:56:44"
          },
          {
            "ticket_id": 4382,
            "ticket_number": "354374",
            "title": "Contatos de Cliente em falta - n/File 418537",
            "priority": "P2",
            "created_at": "15/12/2025 10:08:53",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:27:11"
          },
          {
            "ticket_id": 4394,
            "ticket_number": "354386",
            "title": "Susana Patricia Costa Gomes - Leplan 604511198",
            "priority": "P2",
            "created_at": "15/12/2025 10:11:39",
            "close_date": "2025-12-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 10:11:39"
          }
        ]
      },
      "Débora Pinto": {
        "total_tickets": 805,
        "sla_met": 777,
        "sla_missed": 28,
        "sla_compliance_rate": 96.52,
        "tickets": [
          {
            "ticket_id": 689,
            "ticket_number": "35688",
            "title": "Cotação Grupo Açores",
            "priority": "P2",
            "created_at": "14/10/2025 16:55:12",
            "close_date": "2025-12-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/10/2025 16:55:13"
          },
          {
            "ticket_id": 1763,
            "ticket_number": "351760",
            "title": "Re:[## 19312 ##] GBN-61778 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "03/11/2025 18:49:54",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/11/2025 19:52:40"
          },
          {
            "ticket_id": 1843,
            "ticket_number": "351840",
            "title": "grupo de angariação",
            "priority": "P3",
            "created_at": "04/11/2025 21:32:09",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/11/2025 21:32:09"
          },
          {
            "ticket_id": 1909,
            "ticket_number": "351906",
            "title": "RE: Nueva solicitud de Grupos---860874---FLORENCIA",
            "priority": "P3",
            "created_at": "06/11/2025 10:20:07",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/11/2025 13:17:45"
          },
          {
            "ticket_id": 2229,
            "ticket_number": "352225",
            "title": "Confirmação de reserva com localizador: 3970579",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "11/11/2025 19:56:44",
            "close_date": "2026-02-19",
            "sla_target_hours": 24,
            "actual_time_hours": 52.68,
            "sla_met": false,
            "sla_breach_hours": 28.68,
            "sla_name": "SLA Padrão",
            "first_response_at": "14/11/2025 00:37:45"
          },
          {
            "ticket_id": 2276,
            "ticket_number": "352272",
            "title": "Re:[## 20353 ##] GBN-75222 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "12/11/2025 12:44:58",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/10/2025 17:07:54"
          },
          {
            "ticket_id": 2464,
            "ticket_number": "352459",
            "title": "Fwd: Localizador: 1125356410 Referência: UFEV TTN-",
            "priority": "P3",
            "created_at": "14/11/2025 11:03:34",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/11/2025 11:03:35"
          },
          {
            "ticket_id": 2794,
            "ticket_number": "352789",
            "title": "Re: [Ticket#2025111785002311] Solicitud de Presupu",
            "priority": "P3",
            "created_at": "19/11/2025 13:26:39",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/11/2025 16:46:01"
          },
          {
            "ticket_id": 3155,
            "ticket_number": "353148",
            "title": "Pedido de cotação| Estudiantes  - cntravel -Ref* P",
            "priority": "P3",
            "created_at": "25/11/2025 12:25:05",
            "close_date": "2026-03-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/11/2025 21:30:03"
          },
          {
            "ticket_id": 3190,
            "ticket_number": "353183",
            "title": "NB localizadores 6119682 + 6120803 + 6120795",
            "priority": "P3",
            "created_at": "25/11/2025 16:17:27",
            "close_date": "2025-12-15",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/11/2025 16:17:27"
          },
          {
            "ticket_id": 3321,
            "ticket_number": "353314",
            "title": "Re:[## 20353 ##] GBN-75222 - Seu pedido foi recebi",
            "priority": "P3",
            "created_at": "26/11/2025 19:31:59",
            "close_date": "2026-02-18",
            "sla_target_hours": 24,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/11/2025 23:20:16"
          },
          {
            "ticket_id": 3848,
            "ticket_number": "353840",
            "title": "Cotação de grupo | Soltrópico -   5521GRP e   5522",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:18",
            "close_date": "2026-02-14",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:18"
          },
          {
            "ticket_id": 3849,
            "ticket_number": "353841",
            "title": "Pedido de cotação de grupo | Soltrópico",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:20",
            "close_date": "2026-02-03",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:21"
          },
          {
            "ticket_id": 3851,
            "ticket_number": "353843",
            "title": "Pedido de cotação de grupo | Viajatours",
            "priority": "P3",
            "created_at": "04/12/2025 10:04:25",
            "close_date": "2026-02-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/12/2025 10:04:25"
          },
          {
            "ticket_id": 4237,
            "ticket_number": "354229",
            "title": "GBN-94387 - Sua confirmação de reserva",
            "priority": "Reservas sem Formulário",
            "created_at": "11/12/2025 17:37:38",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 22.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "12/12/2025 16:33:47"
          },
          {
            "ticket_id": 4444,
            "ticket_number": "354436",
            "title": "Re:[## 23112 ##] GBN-86359 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "15/12/2025 17:02:50",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/12/2025 17:03:27"
          },
          {
            "ticket_id": 5033,
            "ticket_number": "355025",
            "title": "Questões p/ GBN",
            "priority": "P2",
            "created_at": "02/01/2026 10:38:30",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/01/2026 10:38:30"
          },
          {
            "ticket_id": 5647,
            "ticket_number": "355639",
            "title": "Confirmação de recepção: EXPEDIENTE 604420884 + LO",
            "priority": "P1",
            "created_at": "12/01/2026 17:49:31",
            "close_date": "2026-01-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 18.17,
            "sla_met": false,
            "sla_breach_hours": 17.92,
            "sla_name": "SLA P1",
            "first_response_at": "13/01/2026 12:00:31"
          },
          {
            "ticket_id": 6982,
            "ticket_number": "356974",
            "title": "604531280 reserva RQ",
            "priority": "P3",
            "created_at": "23/01/2026 12:26:48",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/01/2026 12:26:48"
          },
          {
            "ticket_id": 7287,
            "ticket_number": "357279",
            "title": "Reservas",
            "priority": "P1",
            "created_at": "26/01/2026 22:37:01",
            "close_date": "2026-02-13",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/01/2026 22:37:01"
          },
          {
            "ticket_id": 7632,
            "ticket_number": "357624",
            "title": "Fwd: Incidente de voo TTN-1235214221#91498705#T172",
            "priority": "P2",
            "created_at": "29/01/2026 12:42:58",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 12:42:58"
          },
          {
            "ticket_id": 7660,
            "ticket_number": "357652",
            "title": "Pedido cotação grupo VIAJAR TOURS - Djerba",
            "priority": "P2",
            "created_at": "29/01/2026 16:31:28",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:31:29"
          },
          {
            "ticket_id": 7662,
            "ticket_number": "357654",
            "title": "Pedido cotação grupo NORTRAVEL - Sal e Boavista",
            "priority": "P2",
            "created_at": "29/01/2026 16:31:33",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/01/2026 16:31:34"
          },
          {
            "ticket_id": 8117,
            "ticket_number": "358109",
            "title": "Pedido orçamento Ilha do Sal",
            "priority": "P2",
            "created_at": "02/02/2026 20:10:07",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 20:10:08"
          },
          {
            "ticket_id": 8333,
            "ticket_number": "358325",
            "title": "Fwd: PNR information: X2ULKF",
            "priority": "P2",
            "created_at": "04/02/2026 20:03:04",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/02/2026 20:03:04"
          },
          {
            "ticket_id": 8750,
            "ticket_number": "358742",
            "title": "Cotacao e disponibilidade",
            "priority": "P2",
            "created_at": "09/02/2026 13:31:03",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 13:31:03"
          },
          {
            "ticket_id": 8768,
            "ticket_number": "358760",
            "title": "Confirmação de Reserva * File 429171",
            "priority": "P3",
            "created_at": "09/02/2026 16:30:11",
            "close_date": "2026-02-12",
            "sla_target_hours": 24,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 20:22:52"
          },
          {
            "ticket_id": 8814,
            "ticket_number": "358806",
            "title": "GBN-103272 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/02/2026 22:21:04",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1582.8,
            "sla_met": false,
            "sla_breach_hours": 1578.8,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 21:09:59"
          },
          {
            "ticket_id": 8966,
            "ticket_number": "358958",
            "title": "Ajuda Orçamento - Brasil",
            "priority": "P2",
            "created_at": "11/02/2026 11:36:56",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 11:36:56"
          },
          {
            "ticket_id": 8981,
            "ticket_number": "358973",
            "title": "GRUP-21041 Cotización GRUP-20935 - Ana Salgueirinh",
            "priority": "P2",
            "created_at": "11/02/2026 12:32:22",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 14:01:37"
          },
          {
            "ticket_id": 9032,
            "ticket_number": "359024",
            "title": "Re:[## 30537 ##] GBN-101259 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "11/02/2026 18:53:46",
            "close_date": "2026-02-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 22:42:46"
          },
          {
            "ticket_id": 9096,
            "ticket_number": "359088",
            "title": "Número de informação da reserva: 6132833",
            "priority": "P3",
            "created_at": "12/02/2026 10:12:00",
            "close_date": "2026-02-13",
            "sla_target_hours": 24,
            "actual_time_hours": 868.07,
            "sla_met": false,
            "sla_breach_hours": 844.07,
            "sla_name": "SLA P3",
            "first_response_at": "20/03/2026 14:16:42"
          },
          {
            "ticket_id": 9129,
            "ticket_number": "359121",
            "title": "RAFAELA LAPA - GRUPO - TAILÂNDIA DEZEMBRO",
            "priority": "P2",
            "created_at": "12/02/2026 14:48:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 13:18:28"
          },
          {
            "ticket_id": 9136,
            "ticket_number": "359128",
            "title": "Re:[## 30231 ##] GBN-99759 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "12/02/2026 18:05:13",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/01/2026 15:10:07"
          },
          {
            "ticket_id": 9169,
            "ticket_number": "359161",
            "title": "confirmação reserva GBN",
            "priority": "P2",
            "created_at": "12/02/2026 23:39:54",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/02/2026 23:39:54"
          },
          {
            "ticket_id": 9193,
            "ticket_number": "359185",
            "title": "Orçamento Costa Norte Egito",
            "priority": "P2",
            "created_at": "13/02/2026 10:45:31",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 10:45:31"
          },
          {
            "ticket_id": 9208,
            "ticket_number": "359200",
            "title": "ALTERAÇÃO DE HORÁRIO DE VOO - FILE 425894",
            "priority": "P2",
            "created_at": "13/02/2026 13:31:51",
            "close_date": "2026-02-13",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:04:41"
          },
          {
            "ticket_id": 9237,
            "ticket_number": "359229",
            "title": "FW: Pedido de orçamento 17-18 fev.",
            "priority": "P2",
            "created_at": "13/02/2026 16:00:26",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 16:00:27"
          },
          {
            "ticket_id": 9242,
            "ticket_number": "359234",
            "title": "Alteração de nome - Reserva NB 6132837",
            "priority": "P2",
            "created_at": "13/02/2026 16:19:33",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 16:19:34"
          },
          {
            "ticket_id": 9243,
            "ticket_number": "359235",
            "title": "Alteração de nome - Reserva NB 6133103",
            "priority": "P2",
            "created_at": "13/02/2026 16:19:36",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 16:19:36"
          },
          {
            "ticket_id": 9255,
            "ticket_number": "359247",
            "title": "Cancelamento Cayo Santa Maria  - Travelplan 604497",
            "priority": "P2",
            "created_at": "13/02/2026 17:02:12",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 17:02:12"
          },
          {
            "ticket_id": 9308,
            "ticket_number": "359300",
            "title": "Smy 1199230549",
            "priority": "P2",
            "created_at": "14/02/2026 09:52:26",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 09:52:27"
          },
          {
            "ticket_id": 9310,
            "ticket_number": "359302",
            "title": "Atividade cancelada: Excursão ao Parque Guanayara ",
            "priority": "P2",
            "created_at": "14/02/2026 10:15:04",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 10:52:17"
          },
          {
            "ticket_id": 9333,
            "ticket_number": "359325",
            "title": "Aqui tem o seu voucher para Ingresso da Disneyland",
            "priority": "P2",
            "created_at": "14/02/2026 15:01:21",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 15:17:00"
          },
          {
            "ticket_id": 9336,
            "ticket_number": "359328",
            "title": "Mudança reserva - NewBlue  6132838",
            "priority": "P2",
            "created_at": "14/02/2026 16:13:12",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 16:13:12"
          },
          {
            "ticket_id": 9342,
            "ticket_number": "359334",
            "title": "Mensagem sobre a reserva 36960178 - Civitatis",
            "priority": "P2",
            "created_at": "14/02/2026 18:34:22",
            "close_date": "2026-02-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 18:48:36"
          },
          {
            "ticket_id": 9344,
            "ticket_number": "359336",
            "title": "Pedido NB - Reserva 6132836",
            "priority": "P2",
            "created_at": "14/02/2026 19:12:35",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 19:12:35"
          },
          {
            "ticket_id": 9345,
            "ticket_number": "359337",
            "title": "Hotel Disney e entradas",
            "priority": "P2",
            "created_at": "16/02/2026 10:06:37",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:06:38"
          },
          {
            "ticket_id": 9356,
            "ticket_number": "359348",
            "title": "Viagem Soltropico localizador 339631",
            "priority": "P2",
            "created_at": "16/02/2026 10:09:53",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/01/2026 13:27:33"
          },
          {
            "ticket_id": 9368,
            "ticket_number": "359360",
            "title": "Pedido cancelamento reserva GBN 95439",
            "priority": "P2",
            "created_at": "16/02/2026 10:10:34",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 10:10:35"
          },
          {
            "ticket_id": 9397,
            "ticket_number": "359389",
            "title": "RESERVA WL ARQUIVO- 339631",
            "priority": "P2",
            "created_at": "16/02/2026 12:39:49",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 12:42:36"
          },
          {
            "ticket_id": 9400,
            "ticket_number": "359392",
            "title": "CANCELAMENTO VIAGEM LOCALIZADOR: 604497621",
            "priority": "P2",
            "created_at": "16/02/2026 13:02:25",
            "close_date": "2026-02-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 13:02:25"
          },
          {
            "ticket_id": 9427,
            "ticket_number": "359419",
            "title": "GBN-102944 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/02/2026 17:00:22",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 121.43,
            "sla_met": false,
            "sla_breach_hours": 117.43,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 18:26:43"
          },
          {
            "ticket_id": 9428,
            "ticket_number": "359420",
            "title": "GBN-95439 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/02/2026 17:00:24",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 121.45,
            "sla_met": false,
            "sla_breach_hours": 117.45,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 18:28:01"
          },
          {
            "ticket_id": 9429,
            "ticket_number": "359421",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "16/02/2026 17:02:01",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 17:19:17"
          },
          {
            "ticket_id": 9459,
            "ticket_number": "359451",
            "title": "URGENTE! NOTIFICAÇÃO DE RESERVA 6124097",
            "priority": "P2",
            "created_at": "16/02/2026 18:31:50",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/02/2026 22:22:06"
          },
          {
            "ticket_id": 9505,
            "ticket_number": "359497",
            "title": "Número de informação da reserva: 6135400",
            "priority": "P2",
            "created_at": "17/02/2026 10:07:47",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 11:22:09"
          },
          {
            "ticket_id": 9509,
            "ticket_number": "359501",
            "title": "Confirmación de reserva 99123969",
            "priority": "P2",
            "created_at": "17/02/2026 10:07:57",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 11:03:11"
          },
          {
            "ticket_id": 9514,
            "ticket_number": "359506",
            "title": "Pedido de cotação - grupo",
            "priority": "P2",
            "created_at": "17/02/2026 11:25:56",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 11:25:57"
          },
          {
            "ticket_id": 9528,
            "ticket_number": "359520",
            "title": "Campanha NB - Urgente",
            "priority": "P2",
            "created_at": "17/02/2026 12:28:42",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 12:28:42"
          },
          {
            "ticket_id": 9543,
            "ticket_number": "359535",
            "title": "Fwd: Incidencia de Hotel // 1235013010 TTN-1235013",
            "priority": "P2",
            "created_at": "17/02/2026 13:36:15",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 13:36:16"
          },
          {
            "ticket_id": 9544,
            "ticket_number": "359536",
            "title": "Pedido de acréscimo de telefone e email de cliente",
            "priority": "P2",
            "created_at": "17/02/2026 14:28:17",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 14:28:17"
          },
          {
            "ticket_id": 9570,
            "ticket_number": "359562",
            "title": "GBN-101631 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/02/2026 17:42:16",
            "close_date": "2026-02-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:45:21"
          },
          {
            "ticket_id": 9579,
            "ticket_number": "359571",
            "title": "reembolso do sinal pago localizador Soltrópico",
            "priority": "P2",
            "created_at": "17/02/2026 18:27:05",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/02/2026 18:27:05"
          },
          {
            "ticket_id": 9617,
            "ticket_number": "359609",
            "title": "DQ2S9K – Alteração de Horário – Aceite",
            "priority": "P2",
            "created_at": "18/02/2026 10:14:42",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:57:32"
          },
          {
            "ticket_id": 9621,
            "ticket_number": "359613",
            "title": "Fwd: Incidência hotel - 1235013010",
            "priority": "P2",
            "created_at": "18/02/2026 11:45:36",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:45:38"
          },
          {
            "ticket_id": 9622,
            "ticket_number": "359614",
            "title": "Fwd: Acompanhamento do procedimento TTN-1235013010",
            "priority": "P2",
            "created_at": "18/02/2026 11:45:40",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 11:45:41"
          },
          {
            "ticket_id": 9626,
            "ticket_number": "359618",
            "title": "Cancelamento de reserva 339631",
            "priority": "P2",
            "created_at": "18/02/2026 11:59:32",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 13:52:02"
          },
          {
            "ticket_id": 9629,
            "ticket_number": "359621",
            "title": "INFORMAÇÃO IMPORTANTE SOBRE A SUA RESERVA 6129257",
            "priority": "P1",
            "created_at": "18/02/2026 14:06:39",
            "close_date": "2026-02-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/02/2026 16:23:18"
          },
          {
            "ticket_id": 9637,
            "ticket_number": "359629",
            "title": "CIVITATIS TOURS SL [Ref.: A36991360]",
            "priority": "P2",
            "created_at": "18/02/2026 14:08:42",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 14:08:42"
          },
          {
            "ticket_id": 9647,
            "ticket_number": "359639",
            "title": "GBN-102802 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/02/2026 14:09:44",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 15:22:29"
          },
          {
            "ticket_id": 9656,
            "ticket_number": "359648",
            "title": "Re:[## 32151 ##] GBN-105208 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:01",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 21:30:25"
          },
          {
            "ticket_id": 9659,
            "ticket_number": "359651",
            "title": "Fwd: Reclamação – Falha no Serviço de Transfer – C",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:10",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:30:12"
          },
          {
            "ticket_id": 9662,
            "ticket_number": "359654",
            "title": "Reserva New Blue",
            "priority": "P2",
            "created_at": "18/02/2026 17:30:20",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 17:04:18"
          },
          {
            "ticket_id": 9692,
            "ticket_number": "359684",
            "title": "Proposta Solférias  19247/2026",
            "priority": "P2",
            "created_at": "18/02/2026 18:47:45",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 2.95,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 21:45:29"
          },
          {
            "ticket_id": 9715,
            "ticket_number": "359707",
            "title": "contacto",
            "priority": "P2",
            "created_at": "18/02/2026 22:41:53",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/02/2026 22:41:53"
          },
          {
            "ticket_id": 9722,
            "ticket_number": "359714",
            "title": "pedido de orçamento",
            "priority": "P2",
            "created_at": "19/02/2026 10:06:50",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 10:06:50"
          },
          {
            "ticket_id": 9775,
            "ticket_number": "359767",
            "title": "14 noites SHARM EL SHEIKH W2MCS:014960003211",
            "priority": "P2",
            "created_at": "19/02/2026 16:11:05",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 20:04:46"
          },
          {
            "ticket_id": 9778,
            "ticket_number": "359770",
            "title": "Fwd: Incidente de voo TTN-1235214221#91498705#T172",
            "priority": "P2",
            "created_at": "19/02/2026 16:18:36",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:18:30"
          },
          {
            "ticket_id": 9782,
            "ticket_number": "359774",
            "title": "Fwd: Informações da sua reserva TTN-1235214221#936",
            "priority": "P2",
            "created_at": "19/02/2026 16:51:22",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:51:23"
          },
          {
            "ticket_id": 9783,
            "ticket_number": "359775",
            "title": "Fwd: Incidente de voo TTN-1235214221#93597724#T178",
            "priority": "P2",
            "created_at": "19/02/2026 16:51:26",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:51:27"
          },
          {
            "ticket_id": 9784,
            "ticket_number": "359776",
            "title": "Soltour: Cancelamento de reserva: SPT002601590663",
            "priority": "P2",
            "created_at": "19/02/2026 16:51:29",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 12:40:01"
          },
          {
            "ticket_id": 9785,
            "ticket_number": "359777",
            "title": "Fwd: Informações da reserva TTN-1160888817#7857627",
            "priority": "P2",
            "created_at": "19/02/2026 16:51:31",
            "close_date": "2026-02-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:51:32"
          },
          {
            "ticket_id": 9810,
            "ticket_number": "359802",
            "title": "Nomes de 2 passageiros incompletos no Localizador ",
            "priority": "P2",
            "created_at": "19/02/2026 22:14:22",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 22:14:22"
          },
          {
            "ticket_id": 9855,
            "ticket_number": "359847",
            "title": "Questão Reserva Marsol 802403683",
            "priority": "P2",
            "created_at": "20/02/2026 10:54:16",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:54:16"
          },
          {
            "ticket_id": 9884,
            "ticket_number": "359872",
            "title": "Cancelamento de reserva 339899",
            "priority": "P2",
            "created_at": "20/02/2026 13:11:25",
            "close_date": "2026-02-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 17:03:32"
          },
          {
            "ticket_id": 9915,
            "ticket_number": "359903",
            "title": "Pedido de devolução",
            "priority": "P2",
            "created_at": "20/02/2026 16:53:17",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 16:53:18"
          },
          {
            "ticket_id": 9926,
            "ticket_number": "359914",
            "title": "Re:[## 32177 ##] GBN-98313 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "20/02/2026 18:04:44",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 13:18:45"
          },
          {
            "ticket_id": 9989,
            "ticket_number": "359977",
            "title": "YIJB53 – Pedido de Inserção de APIS",
            "priority": "P2",
            "created_at": "21/02/2026 10:07:19",
            "close_date": "2026-02-24",
            "sla_target_hours": 4,
            "actual_time_hours": 72.07,
            "sla_met": false,
            "sla_breach_hours": 68.07,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 10:11:40"
          },
          {
            "ticket_id": 9991,
            "ticket_number": "359979",
            "title": "6122920- New Blue",
            "priority": "P2",
            "created_at": "21/02/2026 10:07:23",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 10:07:23"
          },
          {
            "ticket_id": 9994,
            "ticket_number": "359982",
            "title": "Reserva LOC: 6136070",
            "priority": "P2",
            "created_at": "21/02/2026 10:07:30",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 10:07:30"
          },
          {
            "ticket_id": 9995,
            "ticket_number": "359983",
            "title": "Reserva confirmada: Chip eSIM Civitatis Marrocos -",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:19",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:39:24"
          },
          {
            "ticket_id": 9996,
            "ticket_number": "359984",
            "title": "Reserva de transfer em Marraquexe (Aeroporto Marra",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:21",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:40:19"
          },
          {
            "ticket_id": 9997,
            "ticket_number": "359985",
            "title": "Reserva de transfer em Marraquexe (Marrakech Medin",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:23",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:42:58"
          },
          {
            "ticket_id": 9998,
            "ticket_number": "359986",
            "title": "Reserva de transfer em Marrakech (Marrakech Medina",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:25",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:40:44"
          },
          {
            "ticket_id": 9999,
            "ticket_number": "359987",
            "title": "Reserva de transfer em Marrakech (Aeroporto Marrak",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:28",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:42:44"
          },
          {
            "ticket_id": 10000,
            "ticket_number": "359988",
            "title": "Reserva confirmada: Chip eSIM Civitatis Marrocos -",
            "priority": "P2",
            "created_at": "21/02/2026 12:46:31",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:40:58"
          },
          {
            "ticket_id": 10001,
            "ticket_number": "359989",
            "title": "GBN-94286 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/02/2026 12:47:05",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:51:25"
          },
          {
            "ticket_id": 10002,
            "ticket_number": "359990",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 802440366",
            "priority": "P2",
            "created_at": "21/02/2026 12:47:06",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:43:25"
          },
          {
            "ticket_id": 10005,
            "ticket_number": "359993",
            "title": "Número de informação da reserva: 6136070",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:46",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:51:46"
          },
          {
            "ticket_id": 10006,
            "ticket_number": "359994",
            "title": "Acessos Iberostar Pro",
            "priority": "P2",
            "created_at": "21/02/2026 12:48:48",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 12:48:49"
          },
          {
            "ticket_id": 10016,
            "ticket_number": "3510004",
            "title": "Reserva confirmada: Passeio de helicóptero pelas C",
            "priority": "P2",
            "created_at": "21/02/2026 13:52:47",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:14:24"
          },
          {
            "ticket_id": 10018,
            "ticket_number": "3510006",
            "title": "Reserva confirmada: Free tour pelo centro históric",
            "priority": "P2",
            "created_at": "21/02/2026 13:52:53",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:27:33"
          },
          {
            "ticket_id": 10019,
            "ticket_number": "3510007",
            "title": "Reserva confirmada: Free tour pelo centro históric",
            "priority": "P2",
            "created_at": "21/02/2026 13:52:55",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:27:14"
          },
          {
            "ticket_id": 10020,
            "ticket_number": "3510008",
            "title": "GBN-107304 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/02/2026 13:52:58",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 13:52:58"
          },
          {
            "ticket_id": 10021,
            "ticket_number": "3510009",
            "title": "Reserva confirmada: Cataratas do Iguaçu, lados arg",
            "priority": "P2",
            "created_at": "21/02/2026 13:53:00",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:13:36"
          },
          {
            "ticket_id": 10022,
            "ticket_number": "3510010",
            "title": "Reserva confirmada: Passeio de catamarã com jantar",
            "priority": "P2",
            "created_at": "21/02/2026 13:53:03",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:11:14"
          },
          {
            "ticket_id": 10023,
            "ticket_number": "3510011",
            "title": "Reserva confirmada: Passeio de helicóptero pelas C",
            "priority": "P2",
            "created_at": "21/02/2026 13:53:06",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:12:00"
          },
          {
            "ticket_id": 10025,
            "ticket_number": "3510013",
            "title": "Reserva confirmada: Cataratas do Iguaçu, lados arg",
            "priority": "P2",
            "created_at": "21/02/2026 13:53:10",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:09:20"
          },
          {
            "ticket_id": 10026,
            "ticket_number": "3510014",
            "title": "Reserva confirmada: Passeio de catamarã com jantar",
            "priority": "P2",
            "created_at": "21/02/2026 13:53:12",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 14:11:32"
          },
          {
            "ticket_id": 10027,
            "ticket_number": "3510015",
            "title": "Fwd: 1240916209 TTN-1240916209#92540329#T17524622¬",
            "priority": "P2",
            "created_at": "21/02/2026 16:04:40",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 16:04:41"
          },
          {
            "ticket_id": 10028,
            "ticket_number": "3510016",
            "title": "GBN-107324 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "21/02/2026 16:04:49",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 16:04:49"
          },
          {
            "ticket_id": 10029,
            "ticket_number": "3510017",
            "title": "Fwd: Informações sobre a sua reserva TTN-123137701",
            "priority": "P2",
            "created_at": "21/02/2026 16:07:27",
            "close_date": "2026-02-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/02/2026 16:07:28"
          },
          {
            "ticket_id": 10230,
            "ticket_number": "3510218",
            "title": "Reserva Soltour",
            "priority": "P2",
            "created_at": "24/02/2026 11:11:37",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 11:11:37"
          },
          {
            "ticket_id": 10263,
            "ticket_number": "3510251",
            "title": "Documentos viagem - Ilha do Sal",
            "priority": "P2",
            "created_at": "24/02/2026 15:51:52",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:51:53"
          },
          {
            "ticket_id": 10264,
            "ticket_number": "3510252",
            "title": "Excursões Bayahibe - Travelplan",
            "priority": "P2",
            "created_at": "24/02/2026 15:51:55",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:51:55"
          },
          {
            "ticket_id": 10272,
            "ticket_number": "3510260",
            "title": "Combinado Fortaleza & Jericoacoara - Operador Exót",
            "priority": "P2",
            "created_at": "24/02/2026 15:55:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 15:55:32"
          },
          {
            "ticket_id": 10287,
            "ticket_number": "3510275",
            "title": "Pedido de Informação",
            "priority": "P2",
            "created_at": "24/02/2026 18:56:56",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 18:56:56"
          },
          {
            "ticket_id": 10328,
            "ticket_number": "3510316",
            "title": "Informação importante sobre a tua reserva 1773401",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:12",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 6.9,
            "sla_met": false,
            "sla_breach_hours": 2.9,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 17:10:57"
          },
          {
            "ticket_id": 10331,
            "ticket_number": "3510319",
            "title": "Fwd: Informações da reserva TTN-1252868896#9409538",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:25",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:16:26"
          },
          {
            "ticket_id": 10334,
            "ticket_number": "3510322",
            "title": "Fwd: Localizador 1252868896 - SmyTravel informa TT",
            "priority": "P2",
            "created_at": "25/02/2026 10:16:39",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 10:16:40"
          },
          {
            "ticket_id": 10346,
            "ticket_number": "3510334",
            "title": "Cancelamento de reserva 339181",
            "priority": "P2",
            "created_at": "25/02/2026 10:46:00",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 11:15:53"
          },
          {
            "ticket_id": 10349,
            "ticket_number": "3510337",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "25/02/2026 10:57:41",
            "close_date": "2026-02-25",
            "sla_target_hours": 4,
            "actual_time_hours": 7.23,
            "sla_met": false,
            "sla_breach_hours": 3.23,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 18:12:25"
          },
          {
            "ticket_id": 10430,
            "ticket_number": "3510418",
            "title": "Solicitação Cancelamento - Reserva TRAVELPLAN 6045",
            "priority": "P1",
            "created_at": "25/02/2026 19:48:16",
            "close_date": "2026-03-24",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/02/2026 19:48:16"
          },
          {
            "ticket_id": 10474,
            "ticket_number": "3510462",
            "title": "Pedido de esclarecimento – sobre orçamento GBN pre",
            "priority": "P2",
            "created_at": "26/02/2026 10:04:21",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 10:04:21"
          },
          {
            "ticket_id": 10486,
            "ticket_number": "3510474",
            "title": "Atualização de Reserva * File 426271",
            "priority": "P2",
            "created_at": "26/02/2026 11:46:59",
            "close_date": "2026-02-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/02/2026 13:39:50"
          },
          {
            "ticket_id": 10491,
            "ticket_number": "3510479",
            "title": "Fwd: Incidente de voo TTN-1235822750#94208578#T180",
            "priority": "P1",
            "created_at": "26/02/2026 12:17:17",
            "close_date": "2026-02-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 12:17:17"
          },
          {
            "ticket_id": 10524,
            "ticket_number": "3510512",
            "title": "PEDIDO ALTERCAO DE UMA LETRA RESERVA DA SOLFERIAS ",
            "priority": "P2",
            "created_at": "26/02/2026 16:18:08",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 16:18:08"
          },
          {
            "ticket_id": 10533,
            "ticket_number": "3510521",
            "title": "caneclamento reserva",
            "priority": "P2",
            "created_at": "26/02/2026 16:45:05",
            "close_date": "2026-02-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 16:45:05"
          },
          {
            "ticket_id": 10551,
            "ticket_number": "3510539",
            "title": "GBN-99221 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/02/2026 19:33:56",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 12:15:27"
          },
          {
            "ticket_id": 10574,
            "ticket_number": "3510562",
            "title": "Fwd: Incidente de voo TTN-1235822750#94312250#T180",
            "priority": "P2",
            "created_at": "26/02/2026 23:49:31",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 23:49:31"
          },
          {
            "ticket_id": 10657,
            "ticket_number": "3510645",
            "title": "Pedido de Correção de Apelido de Viagem para amanh",
            "priority": "P2",
            "created_at": "27/02/2026 15:51:28",
            "close_date": "2026-02-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 15:51:28"
          },
          {
            "ticket_id": 10663,
            "ticket_number": "3510651",
            "title": "Reservation confirmed at JAM LISBON. Confirmation ",
            "priority": "P1",
            "created_at": "27/02/2026 16:30:46",
            "close_date": "2026-02-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "26/02/2026 16:24:52"
          },
          {
            "ticket_id": 10664,
            "ticket_number": "3510652",
            "title": "Erro ao finalizar reserva",
            "priority": "P2",
            "created_at": "27/02/2026 16:30:49",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 16:30:50"
          },
          {
            "ticket_id": 10860,
            "ticket_number": "3510848",
            "title": "Comunicação a Solférias",
            "priority": "P2",
            "created_at": "28/02/2026 23:25:09",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 23:25:09"
          },
          {
            "ticket_id": 11003,
            "ticket_number": "3510991",
            "title": "Correção do nome no voucher do localizador nº 4099",
            "priority": "P2",
            "created_at": "02/03/2026 11:15:12",
            "close_date": "2026-03-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 11:15:13"
          },
          {
            "ticket_id": 11053,
            "ticket_number": "3511041",
            "title": "Reporte de situação de valores",
            "priority": "P2",
            "created_at": "02/03/2026 15:34:18",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:34:18"
          },
          {
            "ticket_id": 11057,
            "ticket_number": "3511045",
            "title": "[Pedido de Grupo] Senegal, Mexico, Ilhas espanhola",
            "priority": "P2",
            "created_at": "02/03/2026 15:45:40",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 15:45:41"
          },
          {
            "ticket_id": 11064,
            "ticket_number": "3511052",
            "title": "Pedido de orçamento para Creta  saida de Lisboa di",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:00",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:15:00"
          },
          {
            "ticket_id": 11068,
            "ticket_number": "3511056",
            "title": "Esclarecimento - Insure",
            "priority": "P2",
            "created_at": "02/03/2026 17:15:10",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 17:15:10"
          },
          {
            "ticket_id": 11083,
            "ticket_number": "3511071",
            "title": "Confirmação de Reserva File 432870/26**TL 03/03 11",
            "priority": "P1",
            "created_at": "02/03/2026 18:52:30",
            "close_date": "2026-03-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.83,
            "sla_met": false,
            "sla_breach_hours": 3.58,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 22:43:24"
          },
          {
            "ticket_id": 11092,
            "ticket_number": "3511080",
            "title": "Re:[## 33578 ##] GBN-94286 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "02/03/2026 19:14:24",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 19:15:46"
          },
          {
            "ticket_id": 11129,
            "ticket_number": "3511117",
            "title": "Circuito rio douro",
            "priority": "P2",
            "created_at": "03/03/2026 00:12:06",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 00:12:06"
          },
          {
            "ticket_id": 11155,
            "ticket_number": "3511143",
            "title": "Cotação cruzeiro - urgência pf",
            "priority": "P2",
            "created_at": "03/03/2026 11:12:08",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 11:12:08"
          },
          {
            "ticket_id": 11165,
            "ticket_number": "3511153",
            "title": "msc Número da Reserva : 67570291",
            "priority": "P2",
            "created_at": "03/03/2026 12:34:09",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:24:53"
          },
          {
            "ticket_id": 11167,
            "ticket_number": "3511155",
            "title": "Correçao de data de incio de seguro classico",
            "priority": "P2",
            "created_at": "03/03/2026 12:34:15",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 12:34:15"
          },
          {
            "ticket_id": 11169,
            "ticket_number": "3511157",
            "title": "leplan loc604571207",
            "priority": "P2",
            "created_at": "03/03/2026 12:34:19",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 16:24:53"
          },
          {
            "ticket_id": 11194,
            "ticket_number": "3511182",
            "title": "cancelamento da viagem 2026-03825",
            "priority": "P2",
            "created_at": "03/03/2026 13:56:54",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 13:56:54"
          },
          {
            "ticket_id": 11225,
            "ticket_number": "3511213",
            "title": "GBN-107971 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 16:53:09",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:21:20"
          },
          {
            "ticket_id": 11239,
            "ticket_number": "3511227",
            "title": "Fwd: easyJet booking reference: KC6NH2C",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:27",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:42:28"
          },
          {
            "ticket_id": 11242,
            "ticket_number": "3511230",
            "title": "Resposta automática da MSC Cruzeiros  [SR Number: ",
            "priority": "P2",
            "created_at": "03/03/2026 17:42:36",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 21:40:42"
          },
          {
            "ticket_id": 11245,
            "ticket_number": "3511233",
            "title": "[Cancelamento Serviço] TRP-2026-04003 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/03/2026 17:45:15",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 17:45:15"
          },
          {
            "ticket_id": 11247,
            "ticket_number": "3511235",
            "title": "[Pedido de Grupo] Egipto - Hurgarda e Costa Norte ",
            "priority": "P2",
            "created_at": "03/03/2026 18:03:47",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 18:03:47"
          },
          {
            "ticket_id": 11250,
            "ticket_number": "3511238",
            "title": "GBN-107971 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/03/2026 18:26:43",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 19:28:20"
          },
          {
            "ticket_id": 11251,
            "ticket_number": "3511239",
            "title": "Re:[## 33745 ##] GBN-107971 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "03/03/2026 18:26:45",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 19:22:00"
          },
          {
            "ticket_id": 11290,
            "ticket_number": "3511278",
            "title": "RV: Confirmacion de la reserva Transavia: G9P4PF",
            "priority": "P2",
            "created_at": "04/03/2026 10:17:30",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 8.75,
            "sla_met": false,
            "sla_breach_hours": 4.75,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:03:19"
          },
          {
            "ticket_id": 11367,
            "ticket_number": "3511355",
            "title": "Dados para abertura de processo",
            "priority": "P2",
            "created_at": "04/03/2026 12:56:40",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:56:40"
          },
          {
            "ticket_id": 11368,
            "ticket_number": "3511356",
            "title": "RE: Duvida orçamento Solférias Tailandia Bangkok +",
            "priority": "P2",
            "created_at": "04/03/2026 12:56:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 12:56:42"
          },
          {
            "ticket_id": 11412,
            "ticket_number": "3511400",
            "title": "GR260725BCNBCN - BKG 70693147 - CONFIRMAÇÃO DE RES",
            "priority": "P2",
            "created_at": "04/03/2026 16:31:42",
            "close_date": "2026-03-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 19:49:46"
          },
          {
            "ticket_id": 11444,
            "ticket_number": "3511432",
            "title": "Re:[## 33455 ##] GBN-108320 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "04/03/2026 19:15:44",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 18:52:32"
          },
          {
            "ticket_id": 11467,
            "ticket_number": "3511455",
            "title": "[Pedido de Grupo] maceio ritz lagoa da anta hotel ",
            "priority": "P2",
            "created_at": "05/03/2026 02:25:49",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 02:25:49"
          },
          {
            "ticket_id": 11479,
            "ticket_number": "3511467",
            "title": "Re:[## 33838 ##] GBN-109783 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "05/03/2026 10:06:26",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:00:14"
          },
          {
            "ticket_id": 11500,
            "ticket_number": "3511488",
            "title": "Re: FECHO DE VIAGEM - MUITO URGENTE",
            "priority": "P2",
            "created_at": "05/03/2026 11:46:02",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 11:46:02"
          },
          {
            "ticket_id": 11506,
            "ticket_number": "3511494",
            "title": "Alteração de horários Ilha do Sal TAP 335271 Porto",
            "priority": "P2",
            "created_at": "05/03/2026 11:46:16",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 15:40:30"
          },
          {
            "ticket_id": 11508,
            "ticket_number": "3511496",
            "title": "Alteração de horários Ilha do Sal TAP 339057 Lisbo",
            "priority": "P2",
            "created_at": "05/03/2026 12:25:08",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:20:35"
          },
          {
            "ticket_id": 11509,
            "ticket_number": "3511497",
            "title": "Alteração de horários Ilha do Sal TAP 340136 Lisbo",
            "priority": "P2",
            "created_at": "05/03/2026 12:25:09",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:20:35"
          },
          {
            "ticket_id": 11521,
            "ticket_number": "3511509",
            "title": "Pedido cancelamento de transfer",
            "priority": "P2",
            "created_at": "05/03/2026 14:27:05",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 14:27:05"
          },
          {
            "ticket_id": 11528,
            "ticket_number": "3511516",
            "title": "Re:[## 33453 ##] GBN-101842 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "05/03/2026 15:08:43",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 15:08:43"
          },
          {
            "ticket_id": 11530,
            "ticket_number": "3511518",
            "title": "RESERVA WL FILE 341328",
            "priority": "P2",
            "created_at": "05/03/2026 15:09:17",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 17:35:56"
          },
          {
            "ticket_id": 11540,
            "ticket_number": "3511528",
            "title": "TRP-2026-03040 | Escala Dubai | Soltrópico | Viage",
            "priority": "P2",
            "created_at": "05/03/2026 16:03:05",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:03:05"
          },
          {
            "ticket_id": 11541,
            "ticket_number": "3511529",
            "title": "Pedido ajuda Hotel Ivy Cyrene NB",
            "priority": "P2",
            "created_at": "05/03/2026 16:15:52",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 16:15:52"
          },
          {
            "ticket_id": 11568,
            "ticket_number": "3511556",
            "title": "Alteração de horários Lisboa/Tunes/Lisboa",
            "priority": "P2",
            "created_at": "05/03/2026 18:59:57",
            "close_date": "2026-03-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:04:40"
          },
          {
            "ticket_id": 11573,
            "ticket_number": "3511561",
            "title": "Código Lepaln 604576576",
            "priority": "P2",
            "created_at": "05/03/2026 19:23:32",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:23:32"
          },
          {
            "ticket_id": 11577,
            "ticket_number": "3511565",
            "title": "Cotação de grupo",
            "priority": "P2",
            "created_at": "05/03/2026 19:42:39",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 19:42:39"
          },
          {
            "ticket_id": 11579,
            "ticket_number": "3511567",
            "title": "GBN-84048 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/03/2026 20:08:11",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 20:05:41"
          },
          {
            "ticket_id": 11583,
            "ticket_number": "3511571",
            "title": "Pedido de documentação loc: 6121533 - 6121537 - 61",
            "priority": "P2",
            "created_at": "05/03/2026 21:17:24",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 21:17:25"
          },
          {
            "ticket_id": 11589,
            "ticket_number": "3511577",
            "title": "Re: Pedido alteração datas de viagem Loc: TRP-2026",
            "priority": "P1",
            "created_at": "05/03/2026 23:13:28",
            "close_date": "2026-04-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/03/2026 23:13:28"
          },
          {
            "ticket_id": 11631,
            "ticket_number": "3511619",
            "title": "Entradas Disney - Le Plan",
            "priority": "P2",
            "created_at": "06/03/2026 12:20:16",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 12:20:16"
          },
          {
            "ticket_id": 11633,
            "ticket_number": "3511621",
            "title": "Flexible Auto Madeira - pedido cadeirinha bebé rea",
            "priority": "P2",
            "created_at": "06/03/2026 12:34:16",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 12:34:17"
          },
          {
            "ticket_id": 11635,
            "ticket_number": "3511623",
            "title": "Re: [Cockpit] Viagem TRP-2026-03870 - ILHA DO SAL ",
            "priority": "P2",
            "created_at": "06/03/2026 12:42:51",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 12:42:51"
          },
          {
            "ticket_id": 11643,
            "ticket_number": "3511631",
            "title": "GBN-81725 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/03/2026 13:14:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 20:34:36"
          },
          {
            "ticket_id": 11647,
            "ticket_number": "3511635",
            "title": "Opção MSC 70757417 valida até hoje",
            "priority": "P2",
            "created_at": "06/03/2026 13:22:27",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:22:28"
          },
          {
            "ticket_id": 11660,
            "ticket_number": "3511648",
            "title": "[Suporte] TRP-2026-04075 - Pedido de cotação de la",
            "priority": "P2",
            "created_at": "06/03/2026 14:32:48",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 14:32:48"
          },
          {
            "ticket_id": 11661,
            "ticket_number": "3511649",
            "title": "FW: AIR EUROPA // LOC : 9YP56G",
            "priority": "P2",
            "created_at": "06/03/2026 15:09:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 15:09:15"
          },
          {
            "ticket_id": 11664,
            "ticket_number": "3511652",
            "title": "reserva",
            "priority": "P2",
            "created_at": "06/03/2026 15:47:20",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 21:53:51"
          },
          {
            "ticket_id": 11672,
            "ticket_number": "3511660",
            "title": "GBN-110564 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/03/2026 16:39:03",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:24:07"
          },
          {
            "ticket_id": 11687,
            "ticket_number": "3511675",
            "title": "[Pedido de Grupo] Monte Saint-Michel - 2026-10-02 ",
            "priority": "P2",
            "created_at": "06/03/2026 18:03:40",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:03:40"
          },
          {
            "ticket_id": 11688,
            "ticket_number": "3511676",
            "title": "[Pedido de Grupo] Marrakesh - Riad Konouz (2 noite",
            "priority": "P3",
            "created_at": "06/03/2026 18:09:46",
            "close_date": "2026-03-16",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 18:09:46"
          },
          {
            "ticket_id": 11690,
            "ticket_number": "3511678",
            "title": "MUITO URGENTE Confirmação de reserva 341921### TIM",
            "priority": "P2",
            "created_at": "06/03/2026 18:36:14",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:43:46"
          },
          {
            "ticket_id": 11691,
            "ticket_number": "3511679",
            "title": "Transfer - Reserva Soltropico 337345",
            "priority": "P2",
            "created_at": "06/03/2026 18:36:15",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:24:21"
          },
          {
            "ticket_id": 11693,
            "ticket_number": "3511681",
            "title": "Fw: AIR EUROPA // LOC : 9YP56G",
            "priority": "P2",
            "created_at": "06/03/2026 18:36:23",
            "close_date": "2026-03-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 18:36:24"
          },
          {
            "ticket_id": 11712,
            "ticket_number": "3511700",
            "title": "GBN-110570 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "06/03/2026 19:03:08",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 986.27,
            "sla_met": false,
            "sla_breach_hours": 982.27,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 21:19:31"
          },
          {
            "ticket_id": 11713,
            "ticket_number": "3511701",
            "title": "[Cancelamento Serviço] TRP-2026-02349 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/03/2026 19:19:28",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:19:29"
          },
          {
            "ticket_id": 11715,
            "ticket_number": "3511703",
            "title": "FW: Your booking is confirmed - CX53RN - 425327",
            "priority": "P2",
            "created_at": "06/03/2026 19:46:14",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:11:51"
          },
          {
            "ticket_id": 11723,
            "ticket_number": "3511711",
            "title": "[Cancelamento Viagem] TRP-2026-04039 - Alberto Lop",
            "priority": "P2",
            "created_at": "06/03/2026 19:47:50",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:47:50"
          },
          {
            "ticket_id": 11750,
            "ticket_number": "3511738",
            "title": "[Suporte] TRP-2026-04109 / TRL-2026-06254 - Reserv",
            "priority": "P2",
            "created_at": "06/03/2026 23:19:02",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 23:19:03"
          },
          {
            "ticket_id": 11759,
            "ticket_number": "3511747",
            "title": "[Suporte] TRP-2026-04135 / TRL-2026-06261 - Questi",
            "priority": "P2",
            "created_at": "07/03/2026 01:13:00",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 01:13:00"
          },
          {
            "ticket_id": 11764,
            "ticket_number": "3511752",
            "title": "pedido portimao",
            "priority": "P2",
            "created_at": "07/03/2026 10:07:22",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 10:07:23"
          },
          {
            "ticket_id": 11770,
            "ticket_number": "3511758",
            "title": "GBN-99777 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/03/2026 10:13:46",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 10:09:10"
          },
          {
            "ticket_id": 11774,
            "ticket_number": "3511762",
            "title": "Cancelação da reserva com localizador 2CQUYV9R8N",
            "priority": "P2",
            "created_at": "07/03/2026 11:08:21",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 10:44:23"
          },
          {
            "ticket_id": 11775,
            "ticket_number": "3511763",
            "title": "Confirmacao 342009",
            "priority": "P2",
            "created_at": "07/03/2026 11:08:23",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:10:25"
          },
          {
            "ticket_id": 11779,
            "ticket_number": "3511767",
            "title": "Soltour - criança grátis - solicitação de esclarec",
            "priority": "P2",
            "created_at": "07/03/2026 12:03:59",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:03:59"
          },
          {
            "ticket_id": 11781,
            "ticket_number": "3511769",
            "title": "[Pedido de Grupo] Maiorca - Iberostar - 2026-07-28",
            "priority": "P2",
            "created_at": "07/03/2026 12:14:58",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:14:58"
          },
          {
            "ticket_id": 11782,
            "ticket_number": "3511770",
            "title": "[Suporte] TRP-2026-02585 - Icarion - 7003721 - lua",
            "priority": "P2",
            "created_at": "07/03/2026 12:19:24",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 12:19:24"
          },
          {
            "ticket_id": 11785,
            "ticket_number": "3511773",
            "title": "Aéreo - Confirmação de Emissão (DOS SANTOS E SILVA",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:15",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:47:37"
          },
          {
            "ticket_id": 11787,
            "ticket_number": "3511775",
            "title": "New Blue - dados passageiros loc 1773401  e 177454",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:20",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:20:20"
          },
          {
            "ticket_id": 11788,
            "ticket_number": "3511776",
            "title": "Aéreo - Confirmação de Emissão (TEIXEIRA CLARO\\RUI",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:22",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:20:22"
          },
          {
            "ticket_id": 11789,
            "ticket_number": "3511777",
            "title": "Aéreo - Confirmação de Emissão (DOS SANTOS E SILVA",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:24",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:44:52"
          },
          {
            "ticket_id": 11790,
            "ticket_number": "3511778",
            "title": "Aéreo - Confirmação de Emissão (TEIXEIRA CLARO\\RUI",
            "priority": "P2",
            "created_at": "07/03/2026 13:20:26",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:44:22"
          },
          {
            "ticket_id": 11795,
            "ticket_number": "3511783",
            "title": "Y9ITTF – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "07/03/2026 13:42:17",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 13:49:08"
          },
          {
            "ticket_id": 11802,
            "ticket_number": "3511790",
            "title": "Pedido alteração datas de viagem Loc: TRP-2026-040",
            "priority": "P2",
            "created_at": "07/03/2026 14:57:30",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 23:13:30"
          },
          {
            "ticket_id": 11804,
            "ticket_number": "3511792",
            "title": "GBN-110780 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/03/2026 15:13:56",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 15:10:58"
          },
          {
            "ticket_id": 11812,
            "ticket_number": "3511800",
            "title": "Re:[## 32571 ##] GBN-97397 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "07/03/2026 18:16:47",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 18:19:09"
          },
          {
            "ticket_id": 11816,
            "ticket_number": "3511804",
            "title": "Flexible Auto - localizador PP187213",
            "priority": "P2",
            "created_at": "07/03/2026 18:49:21",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 18:49:21"
          },
          {
            "ticket_id": 11819,
            "ticket_number": "3511807",
            "title": "[Pedido de Grupo] Bayahibe / Dreams Dominicus OU C",
            "priority": "P2",
            "created_at": "07/03/2026 19:25:45",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 19:25:46"
          },
          {
            "ticket_id": 11820,
            "ticket_number": "3511808",
            "title": "GBN-110798 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "07/03/2026 21:16:42",
            "close_date": "2026-03-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/03/2026 21:18:16"
          },
          {
            "ticket_id": 11822,
            "ticket_number": "3511810",
            "title": "Envio de documentos de File 416895/25",
            "priority": "P2",
            "created_at": "08/03/2026 01:13:10",
            "close_date": "2026-03-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 01:14:03"
          },
          {
            "ticket_id": 11825,
            "ticket_number": "3511813",
            "title": "Envio de documentos de File 434319/26",
            "priority": "P2",
            "created_at": "08/03/2026 20:25:31",
            "close_date": "2026-03-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/03/2026 20:25:52"
          },
          {
            "ticket_id": 11892,
            "ticket_number": "3511880",
            "title": "RE: GBN-109039 - Um cliente enviou uma nova solici",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:54",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 22:54:22"
          },
          {
            "ticket_id": 11896,
            "ticket_number": "3511884",
            "title": "Re:[## 33345 ##] GBN-108835 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "09/03/2026 10:08:26",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/02/2026 23:04:24"
          },
          {
            "ticket_id": 11979,
            "ticket_number": "3511967",
            "title": "LePlan - 604576576",
            "priority": "P2",
            "created_at": "09/03/2026 17:08:20",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 17:08:20"
          },
          {
            "ticket_id": 12016,
            "ticket_number": "3512004",
            "title": "[Cancelamento Viagem] TRP-2026-03025 - Inês Ribeir",
            "priority": "P2",
            "created_at": "09/03/2026 23:47:26",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 23:47:26"
          },
          {
            "ticket_id": 12017,
            "ticket_number": "3512005",
            "title": "[Cancelamento Serviço] TRP-2026-03177 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/03/2026 23:58:20",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 23:58:20"
          },
          {
            "ticket_id": 12039,
            "ticket_number": "3512027",
            "title": "Cotización Berlim - cntravel -Ref* 31009236 -Uma F",
            "priority": "P2",
            "created_at": "10/03/2026 10:23:50",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 13:20:48"
          },
          {
            "ticket_id": 12040,
            "ticket_number": "3512028",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "10/03/2026 10:23:52",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:23:52"
          },
          {
            "ticket_id": 12046,
            "ticket_number": "3512034",
            "title": "GBN-111177 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/03/2026 11:31:03",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 00:09:15"
          },
          {
            "ticket_id": 12054,
            "ticket_number": "3512042",
            "title": "Nova Confirmação de reserva 341311### TIME LIMIT E",
            "priority": "P2",
            "created_at": "10/03/2026 12:12:09",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 16:02:03"
          },
          {
            "ticket_id": 12066,
            "ticket_number": "3512054",
            "title": "Acesso BUSWAY",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:18",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:49:18"
          },
          {
            "ticket_id": 12067,
            "ticket_number": "3512055",
            "title": "GBN-94485 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:20",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 13:05:21"
          },
          {
            "ticket_id": 12068,
            "ticket_number": "3512056",
            "title": "Acesso SMY",
            "priority": "P2",
            "created_at": "10/03/2026 15:49:22",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:49:22"
          },
          {
            "ticket_id": 12082,
            "ticket_number": "3512070",
            "title": "TRP-2026-04023 - ILHA DO SAL RUI",
            "priority": "P2",
            "created_at": "10/03/2026 15:50:17",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 15:50:17"
          },
          {
            "ticket_id": 12087,
            "ticket_number": "3512075",
            "title": "Cancelamento de reserva Travelplan",
            "priority": "P2",
            "created_at": "10/03/2026 16:30:04",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 16:30:05"
          },
          {
            "ticket_id": 12105,
            "ticket_number": "3512093",
            "title": "Acessos Consolidador",
            "priority": "P2",
            "created_at": "10/03/2026 20:48:25",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 20:48:25"
          },
          {
            "ticket_id": 12106,
            "ticket_number": "3512094",
            "title": "[Cancelamento Viagem] TRP-2026-04158 - Daniela Oli",
            "priority": "P2",
            "created_at": "10/03/2026 21:14:46",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 21:14:47"
          },
          {
            "ticket_id": 12211,
            "ticket_number": "3512199",
            "title": "RESERVA PP891908",
            "priority": "P2",
            "created_at": "11/03/2026 15:18:29",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 15:18:29"
          },
          {
            "ticket_id": 12213,
            "ticket_number": "3512201",
            "title": "Orçamento 2265780 - Namíbia Completa e Cataratas V",
            "priority": "P2",
            "created_at": "11/03/2026 15:41:30",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/02/2026 16:55:40"
          },
          {
            "ticket_id": 12235,
            "ticket_number": "3512223",
            "title": "#55289549 +351968185696",
            "priority": "P2",
            "created_at": "11/03/2026 17:32:02",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 17:49:03"
          },
          {
            "ticket_id": 12263,
            "ticket_number": "3512251",
            "title": "Reserva n.º 433867 Soltropico - Porto Santo",
            "priority": "P2",
            "created_at": "11/03/2026 18:53:03",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 18:53:04"
          },
          {
            "ticket_id": 12272,
            "ticket_number": "3512260",
            "title": "Confirmação de reserva para For PT004157 70693147",
            "priority": "P2",
            "created_at": "11/03/2026 19:46:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:26:17"
          },
          {
            "ticket_id": 12280,
            "ticket_number": "3512268",
            "title": "TRP-2026-04146 - TRAVELPLAN - 604578663",
            "priority": "P2",
            "created_at": "11/03/2026 21:48:46",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:48:46"
          },
          {
            "ticket_id": 12308,
            "ticket_number": "3512296",
            "title": "Forfait Andorra",
            "priority": "P2",
            "created_at": "11/03/2026 22:58:47",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 22:58:48"
          },
          {
            "ticket_id": 12332,
            "ticket_number": "3512320",
            "title": "[Cancelamento Serviço] TRP-2026-04156 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/03/2026 10:51:46",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 10:51:46"
          },
          {
            "ticket_id": 12335,
            "ticket_number": "3512323",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60450755",
            "priority": "P2",
            "created_at": "12/03/2026 11:29:39",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 22:35:37"
          },
          {
            "ticket_id": 12345,
            "ticket_number": "3512333",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604563025",
            "priority": "P2",
            "created_at": "12/03/2026 11:30:14",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 12:32:21"
          },
          {
            "ticket_id": 12346,
            "ticket_number": "3512334",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "12/03/2026 11:30:15",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 12:33:21"
          },
          {
            "ticket_id": 12351,
            "ticket_number": "3512339",
            "title": "[Cancelamento Serviço] TRP-2026-04129 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/03/2026 12:57:47",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:54:59"
          },
          {
            "ticket_id": 12368,
            "ticket_number": "3512356",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "12/03/2026 14:58:21",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:58:21"
          },
          {
            "ticket_id": 12389,
            "ticket_number": "3512377",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "12/03/2026 17:42:00",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/02/2026 12:50:43"
          },
          {
            "ticket_id": 12390,
            "ticket_number": "3512378",
            "title": "TRP-2026-03860 - pagamento",
            "priority": "P2",
            "created_at": "12/03/2026 17:42:03",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 17:42:04"
          },
          {
            "ticket_id": 12404,
            "ticket_number": "3512392",
            "title": "Fwd: Incidente de voo TTN-1236854333#95877519#T184",
            "priority": "P2",
            "created_at": "12/03/2026 18:55:45",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/02/2026 21:26:13"
          },
          {
            "ticket_id": 12409,
            "ticket_number": "3512397",
            "title": "Fwd: Informações da reserva TTN-1258780978#9591258",
            "priority": "P2",
            "created_at": "12/03/2026 19:21:23",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:58:32"
          },
          {
            "ticket_id": 12422,
            "ticket_number": "3512410",
            "title": "Viagem para 8 pessoas Bayahibe - Newblue",
            "priority": "P2",
            "created_at": "12/03/2026 20:20:07",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 20:20:07"
          },
          {
            "ticket_id": 12472,
            "ticket_number": "3512460",
            "title": "Dúvida bicicleta - Costa 34596213",
            "priority": "P2",
            "created_at": "13/03/2026 10:38:35",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 10:38:35"
          },
          {
            "ticket_id": 12482,
            "ticket_number": "3512470",
            "title": "Comissão planesqui",
            "priority": "P2",
            "created_at": "13/03/2026 12:48:08",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 12:48:08"
          },
          {
            "ticket_id": 12524,
            "ticket_number": "3512512",
            "title": "portimão solicitação urgente",
            "priority": "P2",
            "created_at": "13/03/2026 17:29:54",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 17:29:54"
          },
          {
            "ticket_id": 12531,
            "ticket_number": "3512519",
            "title": "Re: [Cockpit] Viagem TRP-2026-04250 - RIVIERA MAIA",
            "priority": "P2",
            "created_at": "13/03/2026 18:17:33",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 18:17:34"
          },
          {
            "ticket_id": 12533,
            "ticket_number": "3512521",
            "title": "Acessos Servantrip",
            "priority": "P2",
            "created_at": "13/03/2026 19:22:24",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 19:22:24"
          },
          {
            "ticket_id": 12553,
            "ticket_number": "3512541",
            "title": "[Suporte] TRP-2026-04281 - Devolução cliente",
            "priority": "P2",
            "created_at": "13/03/2026 22:12:52",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 22:12:52"
          },
          {
            "ticket_id": 12557,
            "ticket_number": "3512545",
            "title": "Fwd: Informações da reserva TTN-1258520683#9603448",
            "priority": "P2",
            "created_at": "13/03/2026 23:26:05",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:26:05"
          },
          {
            "ticket_id": 12565,
            "ticket_number": "3512553",
            "title": "Pedido de cotação",
            "priority": "P3",
            "created_at": "13/03/2026 23:46:03",
            "close_date": "2026-03-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/03/2026 23:46:03"
          },
          {
            "ticket_id": 12579,
            "ticket_number": "3512567",
            "title": "Re: [Cockpit] Viagem TRP-2026-03065 - BCN • Daniel",
            "priority": "P2",
            "created_at": "14/03/2026 10:20:58",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 10:20:58"
          },
          {
            "ticket_id": 12585,
            "ticket_number": "3512573",
            "title": "nb loc 6126635",
            "priority": "P2",
            "created_at": "14/03/2026 11:58:39",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 12:30:36"
          },
          {
            "ticket_id": 12586,
            "ticket_number": "3512574",
            "title": "nb loc 6141116",
            "priority": "P2",
            "created_at": "14/03/2026 11:58:40",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 12:35:29"
          },
          {
            "ticket_id": 12587,
            "ticket_number": "3512575",
            "title": "resrva soltour bayahibe familia 5 pessoas",
            "priority": "P2",
            "created_at": "14/03/2026 11:58:42",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 11:58:42"
          },
          {
            "ticket_id": 12588,
            "ticket_number": "3512576",
            "title": "[Cancelamento Viagem] TRP-2026-03140 - Luís Miguel",
            "priority": "P2",
            "created_at": "14/03/2026 12:27:22",
            "close_date": "2026-03-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 12:27:22"
          },
          {
            "ticket_id": 12592,
            "ticket_number": "3512580",
            "title": "GBN-111792 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "14/03/2026 13:20:43",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 21:42:38"
          },
          {
            "ticket_id": 12594,
            "ticket_number": "3512582",
            "title": "Cancelamento de hotel da reserva GBN-112233",
            "priority": "P2",
            "created_at": "14/03/2026 13:21:21",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 13:21:22"
          },
          {
            "ticket_id": 12598,
            "ticket_number": "3512586",
            "title": "Horário de embarque Costa cruzeiro",
            "priority": "P2",
            "created_at": "14/03/2026 15:02:59",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 15:02:59"
          },
          {
            "ticket_id": 12599,
            "ticket_number": "3512587",
            "title": "Fwd: Informações da reserva TTN-1258520683#9603448",
            "priority": "P1",
            "created_at": "14/03/2026 15:03:28",
            "close_date": "2026-03-14",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/03/2026 13:51:41"
          },
          {
            "ticket_id": 12600,
            "ticket_number": "3512588",
            "title": "Reserva TUI",
            "priority": "P1",
            "created_at": "14/03/2026 15:55:31",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "02/03/2026 11:18:54"
          },
          {
            "ticket_id": 12606,
            "ticket_number": "3512594",
            "title": "Acesso auto europe",
            "priority": "P2",
            "created_at": "14/03/2026 16:35:07",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 15:02:57"
          },
          {
            "ticket_id": 12611,
            "ticket_number": "3512599",
            "title": "Reservas soltropico",
            "priority": "P2",
            "created_at": "14/03/2026 16:50:06",
            "close_date": "2026-03-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 16:50:07"
          },
          {
            "ticket_id": 12828,
            "ticket_number": "3512816",
            "title": "A reserva A37202099 foi paga e confirmada",
            "priority": "P2",
            "created_at": "17/03/2026 10:09:22",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:02:37"
          },
          {
            "ticket_id": 12843,
            "ticket_number": "3512831",
            "title": "[Suporte] TRP-2026-04346 - Confirmação",
            "priority": "P2",
            "created_at": "17/03/2026 10:27:19",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 10:27:20"
          },
          {
            "ticket_id": 12893,
            "ticket_number": "3512881",
            "title": "Fwd: GBN-100392 - reembolso",
            "priority": "P2",
            "created_at": "17/03/2026 17:23:28",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:10:08"
          },
          {
            "ticket_id": 12895,
            "ticket_number": "3512883",
            "title": "Re:[## 33645 ##] GBN-100392 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "17/03/2026 18:03:06",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:04:53"
          },
          {
            "ticket_id": 12908,
            "ticket_number": "3512896",
            "title": "Recibo verde Marta Oliveira",
            "priority": "P2",
            "created_at": "17/03/2026 18:04:43",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 18:04:44"
          },
          {
            "ticket_id": 12920,
            "ticket_number": "3512908",
            "title": "NB ES - voucher 1775938",
            "priority": "P2",
            "created_at": "17/03/2026 20:13:22",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 20:13:22"
          },
          {
            "ticket_id": 12921,
            "ticket_number": "3512909",
            "title": "Pedido de orçamento Barca Douro 2 dias",
            "priority": "P1",
            "created_at": "17/03/2026 20:40:55",
            "close_date": "2026-03-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/03/2026 20:40:56"
          },
          {
            "ticket_id": 12931,
            "ticket_number": "3512919",
            "title": "Reserva PP191495 Flexible",
            "priority": "P2",
            "created_at": "18/03/2026 00:08:34",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 00:08:34"
          },
          {
            "ticket_id": 12932,
            "ticket_number": "3512920",
            "title": "Sololé ST4YDR0N e EY0BG2QP",
            "priority": "P2",
            "created_at": "18/03/2026 00:19:04",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 00:19:04"
          },
          {
            "ticket_id": 12967,
            "ticket_number": "3512955",
            "title": "Contatos de Cliente em falta - n/File 432870",
            "priority": "P2",
            "created_at": "18/03/2026 10:45:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 13:02:53"
          },
          {
            "ticket_id": 13002,
            "ticket_number": "3512990",
            "title": "420319 / 2025 - Viagem Dubai",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:26",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 15:02:26"
          },
          {
            "ticket_id": 13027,
            "ticket_number": "3513015",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "18/03/2026 19:03:57",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:03:58"
          },
          {
            "ticket_id": 13038,
            "ticket_number": "3513026",
            "title": "Oferta de hóspede para reserva: 5928345 - PINTO - ",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:23",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 23:01:45"
          },
          {
            "ticket_id": 13051,
            "ticket_number": "3513039",
            "title": "Pedido de inscrição Webinar TUI",
            "priority": "P2",
            "created_at": "18/03/2026 19:26:20",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:26:20"
          },
          {
            "ticket_id": 13052,
            "ticket_number": "3513040",
            "title": "[Cancelamento Serviço] TRP-2026-04321 / TRL-2026-0",
            "priority": "P2",
            "created_at": "18/03/2026 19:43:12",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 19:43:13"
          },
          {
            "ticket_id": 13061,
            "ticket_number": "3513049",
            "title": "Reserva cancelada – Ref PP191495, Sr. CARLOS ALBER",
            "priority": "P2",
            "created_at": "18/03/2026 21:44:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 21:42:22"
          },
          {
            "ticket_id": 13062,
            "ticket_number": "3513050",
            "title": "Reserva cancelada com localizador: 4127443",
            "priority": "P2",
            "created_at": "18/03/2026 22:07:46",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 23:23:52"
          },
          {
            "ticket_id": 13067,
            "ticket_number": "3513055",
            "title": "[Suporte] TRP-2026-04366 - pagamento em atraso, ma",
            "priority": "P2",
            "created_at": "18/03/2026 22:23:23",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 22:23:23"
          },
          {
            "ticket_id": 13083,
            "ticket_number": "3513071",
            "title": "Fwd: Webinar TUI Cruzeiros Fluviais 🎥 É JÁ AMANHÃ!",
            "priority": "P2",
            "created_at": "18/03/2026 23:57:31",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 23:57:32"
          },
          {
            "ticket_id": 13084,
            "ticket_number": "3513072",
            "title": "Pacote Viajartour Formentera (dúvidas) + aluguer d",
            "priority": "P2",
            "created_at": "19/03/2026 10:04:21",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 10:04:21"
          },
          {
            "ticket_id": 13091,
            "ticket_number": "3513079",
            "title": "Fwd: Incidente de transfer TTN-1236854333#96506866",
            "priority": "P2",
            "created_at": "19/03/2026 10:51:29",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 10:51:30"
          },
          {
            "ticket_id": 13102,
            "ticket_number": "3513090",
            "title": "Pedido de esclarecimento à MCS Cruzeiros",
            "priority": "P2",
            "created_at": "19/03/2026 11:52:32",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 11:52:33"
          },
          {
            "ticket_id": 13161,
            "ticket_number": "3513149",
            "title": "Pedido de cancelamento de reserva",
            "priority": "P2",
            "created_at": "19/03/2026 18:02:46",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:02:47"
          },
          {
            "ticket_id": 13166,
            "ticket_number": "3513154",
            "title": "GBN-99478 - Reenviar informações sobre sua reserva",
            "priority": "P2",
            "created_at": "19/03/2026 18:58:08",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 15:48:50"
          },
          {
            "ticket_id": 13167,
            "ticket_number": "3513155",
            "title": "Re:[## 35417 ##] GBN-111700 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "19/03/2026 18:58:12",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 09:56:31"
          },
          {
            "ticket_id": 13191,
            "ticket_number": "3513179",
            "title": "Viajartours | Formentera | Cancelar reservas WL (e",
            "priority": "P2",
            "created_at": "20/03/2026 10:03:32",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:03:33"
          },
          {
            "ticket_id": 13198,
            "ticket_number": "3513186",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:30",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:39:21"
          },
          {
            "ticket_id": 13199,
            "ticket_number": "3513187",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:32",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:40:10"
          },
          {
            "ticket_id": 13200,
            "ticket_number": "3513188",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:34",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:41:26"
          },
          {
            "ticket_id": 13201,
            "ticket_number": "3513189",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:36",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:42:01"
          },
          {
            "ticket_id": 13202,
            "ticket_number": "3513190",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:38",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:42:56"
          },
          {
            "ticket_id": 13203,
            "ticket_number": "3513191",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:40",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:44:27"
          },
          {
            "ticket_id": 13204,
            "ticket_number": "3513192",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:42",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:49:53"
          },
          {
            "ticket_id": 13205,
            "ticket_number": "3513193",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:44",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:53:33"
          },
          {
            "ticket_id": 13206,
            "ticket_number": "3513194",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:46",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:55:02"
          },
          {
            "ticket_id": 13207,
            "ticket_number": "3513195",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:48",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:54:08"
          },
          {
            "ticket_id": 13208,
            "ticket_number": "3513196",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "20/03/2026 10:35:49",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 10:55:46"
          },
          {
            "ticket_id": 13233,
            "ticket_number": "3513221",
            "title": "VOUCHER DA RESERVA 604525587",
            "priority": "P2",
            "created_at": "20/03/2026 14:16:13",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 15:37:00"
          },
          {
            "ticket_id": 13262,
            "ticket_number": "3513250",
            "title": "Re:[## 32307 ##] GBN-106244 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "20/03/2026 19:27:51",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 19:34:02"
          },
          {
            "ticket_id": 13423,
            "ticket_number": "3513411",
            "title": "dados de passaporte? * File 433259",
            "priority": "P2",
            "created_at": "23/03/2026 13:56:20",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:44:53"
          },
          {
            "ticket_id": 13469,
            "ticket_number": "3513457",
            "title": "Urgente",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:46",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:50:46"
          },
          {
            "ticket_id": 13472,
            "ticket_number": "3513460",
            "title": "Reserva 802496917",
            "priority": "P2",
            "created_at": "23/03/2026 23:50:52",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 23:50:52"
          },
          {
            "ticket_id": 13476,
            "ticket_number": "3513464",
            "title": "[Cancelamento Viagem] TRP-2026-02957 - Liliana Ale",
            "priority": "P2",
            "created_at": "24/03/2026 00:54:53",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 00:54:53"
          },
          {
            "ticket_id": 13482,
            "ticket_number": "3513470",
            "title": "TRP-2026-03858:  Pedido de Cadeiras auto",
            "priority": "P2",
            "created_at": "24/03/2026 10:06:29",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 10:06:30"
          },
          {
            "ticket_id": 13491,
            "ticket_number": "3513479",
            "title": "Alteração de horário - TAP - Djerba - Lisboa | Res",
            "priority": "P2",
            "created_at": "24/03/2026 10:13:55",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 11:18:39"
          },
          {
            "ticket_id": 13502,
            "ticket_number": "3513490",
            "title": "GBN-105065 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "24/03/2026 12:16:11",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 11:44:17"
          },
          {
            "ticket_id": 13510,
            "ticket_number": "3513498",
            "title": "URGENTE: Pedido de orçamento de grupo para Abril",
            "priority": "P2",
            "created_at": "24/03/2026 13:15:49",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 13:15:49"
          },
          {
            "ticket_id": 13511,
            "ticket_number": "3513499",
            "title": "Envio de documentação - FILE 413248",
            "priority": "P2",
            "created_at": "24/03/2026 13:15:58",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 14:19:41"
          },
          {
            "ticket_id": 13513,
            "ticket_number": "3513501",
            "title": "Reserva Tour10",
            "priority": "P2",
            "created_at": "24/03/2026 13:29:55",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 13:29:55"
          },
          {
            "ticket_id": 13520,
            "ticket_number": "3513508",
            "title": "Envio de documentação File 415793/25",
            "priority": "P2",
            "created_at": "24/03/2026 14:22:23",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/02/2026 12:49:24"
          },
          {
            "ticket_id": 13575,
            "ticket_number": "3513563",
            "title": "cotação ceiba hotel bissau",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:31",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 10:07:32"
          },
          {
            "ticket_id": 13581,
            "ticket_number": "3513569",
            "title": "Participação de Sinistro - Dados em Falta",
            "priority": "P2",
            "created_at": "25/03/2026 10:07:46",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:52:25"
          },
          {
            "ticket_id": 13585,
            "ticket_number": "3513573",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "25/03/2026 10:36:43",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 11:10:38"
          },
          {
            "ticket_id": 13603,
            "ticket_number": "3513591",
            "title": "SOLFÉRIAS FILE  427582",
            "priority": "P2",
            "created_at": "25/03/2026 13:23:37",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:23:38"
          },
          {
            "ticket_id": 13606,
            "ticket_number": "3513594",
            "title": "Acesso IberostarPro",
            "priority": "P2",
            "created_at": "25/03/2026 13:50:45",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 13:50:45"
          },
          {
            "ticket_id": 13616,
            "ticket_number": "3513604",
            "title": "GBN-114865 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/03/2026 16:15:09",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 16:57:18"
          },
          {
            "ticket_id": 13643,
            "ticket_number": "3513631",
            "title": "Pagamento da reserva – Ref PP205146, Sr. RICARDO J",
            "priority": "P2",
            "created_at": "25/03/2026 18:20:37",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 18:43:30"
          },
          {
            "ticket_id": 13666,
            "ticket_number": "3513654",
            "title": "Rent a car La Mola Rent - Formentera | Pedido cota",
            "priority": "P2",
            "created_at": "25/03/2026 22:32:21",
            "close_date": "2026-04-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 22:32:22"
          },
          {
            "ticket_id": 13677,
            "ticket_number": "3513665",
            "title": "[Cancelamento Serviço] TRP-2026-03255 / TRL-2026-0",
            "priority": "P1",
            "created_at": "26/03/2026 00:25:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/03/2026 10:38:01"
          },
          {
            "ticket_id": 13678,
            "ticket_number": "3513666",
            "title": "[Suporte] TRP-2026-03094 / TRL-2026-04768 - Pagame",
            "priority": "P2",
            "created_at": "26/03/2026 00:27:40",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 00:27:40"
          },
          {
            "ticket_id": 13685,
            "ticket_number": "3513673",
            "title": "EMISSÃO",
            "priority": "P2",
            "created_at": "26/03/2026 10:04:14",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 10:04:14"
          },
          {
            "ticket_id": 13699,
            "ticket_number": "3513687",
            "title": "Convite: Apresentaçao de projeto UMA FAMILIA EM VI",
            "priority": "P2",
            "created_at": "26/03/2026 12:05:48",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 12:05:48"
          },
          {
            "ticket_id": 13700,
            "ticket_number": "3513688",
            "title": "Alteração de valores Solferias",
            "priority": "P2",
            "created_at": "26/03/2026 12:05:50",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:52:00"
          },
          {
            "ticket_id": 13703,
            "ticket_number": "3513691",
            "title": "[Pedido de Grupo] Ibiza - 2026-07-24 a 2026-07-31 ",
            "priority": "P2",
            "created_at": "26/03/2026 12:58:35",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 12:58:35"
          },
          {
            "ticket_id": 13706,
            "ticket_number": "3513694",
            "title": "GBN-115023 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/03/2026 13:42:07",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 13:35:09"
          },
          {
            "ticket_id": 13711,
            "ticket_number": "3513699",
            "title": "GBN-101836 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/03/2026 15:14:22",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/02/2026 00:07:20"
          },
          {
            "ticket_id": 13712,
            "ticket_number": "3513700",
            "title": "Fwd: Incidente de voo TTN-1223653484#97299167#T188",
            "priority": "P2",
            "created_at": "26/03/2026 15:52:58",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:52:59"
          },
          {
            "ticket_id": 13713,
            "ticket_number": "3513701",
            "title": "credenciais ncl cruzeiros",
            "priority": "P2",
            "created_at": "26/03/2026 15:53:01",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:53:01"
          },
          {
            "ticket_id": 13714,
            "ticket_number": "3513702",
            "title": "Fwd: ***INFORMAÇÕES IMPORTANTES SOBRE SEU VOO URRW",
            "priority": "P2",
            "created_at": "26/03/2026 15:53:03",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:53:04"
          },
          {
            "ticket_id": 13715,
            "ticket_number": "3513703",
            "title": "Fwd: Incidente de voo TTN-1223654178#97299159#T188",
            "priority": "P2",
            "created_at": "26/03/2026 15:53:06",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 15:53:07"
          },
          {
            "ticket_id": 13727,
            "ticket_number": "3513715",
            "title": "Fwd: Informações sobre a sua reserva TTN-125743831",
            "priority": "P2",
            "created_at": "26/03/2026 19:15:07",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:15:07"
          },
          {
            "ticket_id": 13731,
            "ticket_number": "3513719",
            "title": "GBN-106061 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/03/2026 19:46:41",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:40:04"
          },
          {
            "ticket_id": 13733,
            "ticket_number": "3513721",
            "title": "GBN-106058 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/03/2026 19:48:41",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 19:39:36"
          },
          {
            "ticket_id": 13738,
            "ticket_number": "3513726",
            "title": "Cancelamento reserva",
            "priority": "P2",
            "created_at": "26/03/2026 20:57:21",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 20:57:21"
          },
          {
            "ticket_id": 13756,
            "ticket_number": "3513744",
            "title": "Cancelamento Reserva PP242138",
            "priority": "P2",
            "created_at": "26/03/2026 23:46:17",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:46:17"
          },
          {
            "ticket_id": 13758,
            "ticket_number": "3513746",
            "title": "Lisboa/Alamein/Lisboa - Supressão de Voo",
            "priority": "P3",
            "created_at": "26/03/2026 23:46:22",
            "close_date": "2026-03-27",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/03/2026 23:46:22"
          },
          {
            "ticket_id": 13767,
            "ticket_number": "3513755",
            "title": "Pagamento de comissões",
            "priority": "P2",
            "created_at": "27/03/2026 10:07:12",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:07:12"
          },
          {
            "ticket_id": 13778,
            "ticket_number": "3513766",
            "title": "Pedido de cotação | Monte da Bemposta",
            "priority": "P2",
            "created_at": "27/03/2026 12:12:51",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 12:12:52"
          },
          {
            "ticket_id": 13786,
            "ticket_number": "3513774",
            "title": "A/C Debora - alteração de reserva GBN-111558 A/C D",
            "priority": "P2",
            "created_at": "27/03/2026 13:42:43",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 13:42:44"
          },
          {
            "ticket_id": 13801,
            "ticket_number": "3513789",
            "title": "Viagem para breve NADIA CREMILDE SOARES DE BRITO -",
            "priority": "P2",
            "created_at": "27/03/2026 16:12:52",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:04:45"
          },
          {
            "ticket_id": 13807,
            "ticket_number": "3513795",
            "title": "Valor por pessoa - Quarto Duplo - NB 6137918",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:26",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 16:23:27"
          },
          {
            "ticket_id": 13844,
            "ticket_number": "3513832",
            "title": "[Cancelamento Serviço] TRP-2026-03122 / TRL-2026-0",
            "priority": "P2",
            "created_at": "27/03/2026 22:59:23",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 22:59:24"
          },
          {
            "ticket_id": 13847,
            "ticket_number": "3513835",
            "title": "opti",
            "priority": "P2",
            "created_at": "27/03/2026 23:07:34",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:07:35"
          },
          {
            "ticket_id": 13858,
            "ticket_number": "3513846",
            "title": "[Cancelamento Serviço] TRP-2026-03941 / TRL-2026-0",
            "priority": "P2",
            "created_at": "28/03/2026 11:41:46",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 11:41:46"
          },
          {
            "ticket_id": 13869,
            "ticket_number": "3513857",
            "title": "[Cancelamento Serviço] TRP-2026-03941 / TRL-2026-0",
            "priority": "P2",
            "created_at": "28/03/2026 13:00:18",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 13:00:18"
          },
          {
            "ticket_id": 13876,
            "ticket_number": "3513864",
            "title": "LOC: 6121533 NB",
            "priority": "P2",
            "created_at": "28/03/2026 14:29:24",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 14:29:24"
          },
          {
            "ticket_id": 13877,
            "ticket_number": "3513865",
            "title": "Solole. Booking 9Y8BS7EK is close to entering expe",
            "priority": "P2",
            "created_at": "28/03/2026 14:29:26",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:07:11"
          },
          {
            "ticket_id": 13878,
            "ticket_number": "3513866",
            "title": "[Cancelamento Viagem] TRP-2026-04392 - TIAGO COUTI",
            "priority": "P2",
            "created_at": "28/03/2026 15:21:04",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 15:21:04"
          },
          {
            "ticket_id": 13879,
            "ticket_number": "3513867",
            "title": "[Cancelamento Viagem] TRP-2026-03801 - CARLA SOFIA",
            "priority": "P2",
            "created_at": "28/03/2026 15:23:20",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 15:23:20"
          },
          {
            "ticket_id": 13880,
            "ticket_number": "3513868",
            "title": "[Cancelamento Viagem] TRP-2026-02926 - Ana Maria F",
            "priority": "P2",
            "created_at": "28/03/2026 15:27:26",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/02/2026 17:14:30"
          },
          {
            "ticket_id": 13885,
            "ticket_number": "3513873",
            "title": "Envio de documentação - FILE 433137",
            "priority": "P2",
            "created_at": "28/03/2026 17:13:44",
            "close_date": "2026-03-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:17:45"
          },
          {
            "ticket_id": 13888,
            "ticket_number": "3513876",
            "title": "Pedido de possibilidade de acrescentar um adulto à",
            "priority": "P2",
            "created_at": "28/03/2026 17:47:12",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 17:47:12"
          },
          {
            "ticket_id": 13891,
            "ticket_number": "3513879",
            "title": "Pedido transfer especial Ilha de Santiago",
            "priority": "P1",
            "created_at": "28/03/2026 19:05:25",
            "close_date": "2026-04-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "28/03/2026 19:05:25"
          },
          {
            "ticket_id": 13892,
            "ticket_number": "3513880",
            "title": "reserva Tour10",
            "priority": "P2",
            "created_at": "28/03/2026 19:05:27",
            "close_date": "2026-03-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/03/2026 19:11:29"
          },
          {
            "ticket_id": 13940,
            "ticket_number": "3513928",
            "title": "Participação de Sinistro",
            "priority": "P2",
            "created_at": "30/03/2026 09:52:29",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:42:05"
          },
          {
            "ticket_id": 13961,
            "ticket_number": "3513949",
            "title": "Soltrópico - 334667 - alteração de nomes",
            "priority": "P2",
            "created_at": "30/03/2026 09:54:19",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 09:54:19"
          },
          {
            "ticket_id": 13969,
            "ticket_number": "3513957",
            "title": "Cancelamento de reserva * File 437116",
            "priority": "P2",
            "created_at": "30/03/2026 11:12:03",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:02:18"
          },
          {
            "ticket_id": 13980,
            "ticket_number": "3513968",
            "title": "Alteração de nome - Civitatis",
            "priority": "P2",
            "created_at": "30/03/2026 13:09:14",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:09:15"
          },
          {
            "ticket_id": 13984,
            "ticket_number": "3513972",
            "title": "Nova Confirmação de reserva 334043",
            "priority": "P2",
            "created_at": "30/03/2026 13:09:30",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:37"
          },
          {
            "ticket_id": 13987,
            "ticket_number": "3513975",
            "title": "Pergunta Civitatis",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:23",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:15:23"
          },
          {
            "ticket_id": 13992,
            "ticket_number": "3513980",
            "title": "RESERVA FINALIZADA numero 1198620745 E respetiva c",
            "priority": "P2",
            "created_at": "30/03/2026 13:57:30",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:57:30"
          },
          {
            "ticket_id": 13996,
            "ticket_number": "3513984",
            "title": "LOCALIZADOR 604497855",
            "priority": "P2",
            "created_at": "30/03/2026 15:00:39",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:00:39"
          },
          {
            "ticket_id": 14010,
            "ticket_number": "3513998",
            "title": "[Suporte] TRP-2026-04072 - Acerto de Valores entre",
            "priority": "P2",
            "created_at": "30/03/2026 16:31:40",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 16:31:40"
          },
          {
            "ticket_id": 14023,
            "ticket_number": "3514011",
            "title": "Reclamação GBN 97265",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:45",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 18:03:43"
          },
          {
            "ticket_id": 14039,
            "ticket_number": "3514027",
            "title": "Dúvidas - Reservas Celebrity Beyond",
            "priority": "P2",
            "created_at": "30/03/2026 21:44:59",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:45:00"
          },
          {
            "ticket_id": 14041,
            "ticket_number": "3514029",
            "title": "Pack hotel c/spa e massagens",
            "priority": "P2",
            "created_at": "30/03/2026 21:45:04",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:45:04"
          },
          {
            "ticket_id": 14043,
            "ticket_number": "3514031",
            "title": "GBN - 106969 - Reembolso viagem - Atestado doença",
            "priority": "P2",
            "created_at": "30/03/2026 22:00:47",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:00:47"
          },
          {
            "ticket_id": 14045,
            "ticket_number": "3514033",
            "title": "[Cancelamento Viagem] TRP-2026-03153 - Filipa Alex",
            "priority": "P2",
            "created_at": "30/03/2026 22:23:51",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:23:51"
          },
          {
            "ticket_id": 14048,
            "ticket_number": "3514036",
            "title": "Adição de passageiro - Localizador 612341",
            "priority": "P2",
            "created_at": "30/03/2026 22:43:56",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:43:57"
          },
          {
            "ticket_id": 14060,
            "ticket_number": "3514048",
            "title": "Informar a companhia aérea",
            "priority": "P2",
            "created_at": "31/03/2026 09:08:09",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 09:08:09"
          },
          {
            "ticket_id": 14092,
            "ticket_number": "3514080",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:46",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 15:36:45"
          },
          {
            "ticket_id": 14093,
            "ticket_number": "3514081",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:48",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 15:39:47"
          },
          {
            "ticket_id": 14094,
            "ticket_number": "3514082",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:49",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 15:40:23"
          },
          {
            "ticket_id": 14095,
            "ticket_number": "3514083",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:50",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 15:41:25"
          },
          {
            "ticket_id": 14097,
            "ticket_number": "3514085",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:53",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:04:30"
          },
          {
            "ticket_id": 14098,
            "ticket_number": "3514086",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:55",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:07:56"
          },
          {
            "ticket_id": 14099,
            "ticket_number": "3514087",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:56",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:07:03"
          },
          {
            "ticket_id": 14101,
            "ticket_number": "3514089",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:57:59",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:10:20"
          },
          {
            "ticket_id": 14102,
            "ticket_number": "3514090",
            "title": "Emissão Antecipada - Lugares Garantidos TAP",
            "priority": "P2",
            "created_at": "31/03/2026 14:58:01",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:10:52"
          },
          {
            "ticket_id": 14121,
            "ticket_number": "3514109",
            "title": "Pagamento comissão",
            "priority": "P2",
            "created_at": "31/03/2026 16:29:10",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:29:10"
          },
          {
            "ticket_id": 14125,
            "ticket_number": "3514113",
            "title": "Cancelamento de Reserva - SPT002601583979",
            "priority": "P2",
            "created_at": "31/03/2026 16:29:27",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 17:47:44"
          },
          {
            "ticket_id": 14127,
            "ticket_number": "3514115",
            "title": "GBN-89481 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/03/2026 16:36:44",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:21:05"
          },
          {
            "ticket_id": 14129,
            "ticket_number": "3514117",
            "title": "URGENTE - Alteração horário transfer",
            "priority": "P2",
            "created_at": "31/03/2026 16:59:49",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:59:50"
          },
          {
            "ticket_id": 14136,
            "ticket_number": "3514124",
            "title": "[Cancelamento Serviço] TRP-2026-04426 / TRL-2026-0",
            "priority": "P2",
            "created_at": "31/03/2026 18:52:12",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:00:26"
          },
          {
            "ticket_id": 14164,
            "ticket_number": "3514152",
            "title": "[Suporte] TRP-2026-04366 - cartao residencia",
            "priority": "P2",
            "created_at": "01/04/2026 10:02:54",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 10:02:54"
          },
          {
            "ticket_id": 14165,
            "ticket_number": "3514153",
            "title": "pedido de credenciais Vila Galé",
            "priority": "P2",
            "created_at": "01/04/2026 10:29:17",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 10:29:17"
          },
          {
            "ticket_id": 14181,
            "ticket_number": "3514169",
            "title": "Fwd: Informações sobre a sua reserva TTN-126345257",
            "priority": "P2",
            "created_at": "01/04/2026 13:22:12",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 13:22:12"
          },
          {
            "ticket_id": 14191,
            "ticket_number": "3514179",
            "title": "Re:[## 33418 ##] GBN-108848 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "01/04/2026 15:35:35",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/02/2026 10:04:11"
          },
          {
            "ticket_id": 14195,
            "ticket_number": "3514183",
            "title": "GBN-113247 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "01/04/2026 16:20:11",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 14:28:51"
          },
          {
            "ticket_id": 14211,
            "ticket_number": "3514199",
            "title": "Alteração de dia de Operação - OPO/DSS/OPO - Impor",
            "priority": "P2",
            "created_at": "01/04/2026 19:09:11",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:44:46"
          },
          {
            "ticket_id": 14219,
            "ticket_number": "3514207",
            "title": "Fwd: Re: Emisão antecipada de voos TRP-2026-03296",
            "priority": "P2",
            "created_at": "01/04/2026 21:14:28",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:01:54"
          },
          {
            "ticket_id": 14235,
            "ticket_number": "3514223",
            "title": "[Suporte] TRP-2026-02383 - Pedido informações Roya",
            "priority": "P2",
            "created_at": "02/04/2026 01:20:40",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 01:20:40"
          },
          {
            "ticket_id": 14240,
            "ticket_number": "3514228",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/04/2026 09:27:25",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 11:13:21"
          },
          {
            "ticket_id": 14258,
            "ticket_number": "3514246",
            "title": "DADOS CLIENTES SMY LOC: 1222585367",
            "priority": "P2",
            "created_at": "02/04/2026 14:07:03",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 14:07:03"
          },
          {
            "ticket_id": 14259,
            "ticket_number": "3514247",
            "title": "YGOZWA – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "02/04/2026 14:07:05",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:02:41"
          },
          {
            "ticket_id": 14261,
            "ticket_number": "3514249",
            "title": "Y9ITTF – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "02/04/2026 14:07:31",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 1.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:03:53"
          },
          {
            "ticket_id": 14266,
            "ticket_number": "3514254",
            "title": "GBN-94746 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/04/2026 15:02:53",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:35:33"
          },
          {
            "ticket_id": 14267,
            "ticket_number": "3514255",
            "title": "Cancelamento de reserva * File 437610",
            "priority": "P2",
            "created_at": "02/04/2026 16:00:31",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 14:26:04"
          },
          {
            "ticket_id": 14270,
            "ticket_number": "3514258",
            "title": "Atividades Roma Civitatis",
            "priority": "P2",
            "created_at": "02/04/2026 16:07:32",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:07:33"
          },
          {
            "ticket_id": 14279,
            "ticket_number": "3514267",
            "title": "[Suporte] TRP-2026-03450 - Nome do passageiro tem ",
            "priority": "P2",
            "created_at": "02/04/2026 16:37:25",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:37:25"
          },
          {
            "ticket_id": 14292,
            "ticket_number": "3514280",
            "title": "GBN-116518 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "02/04/2026 18:40:36",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 16:23:07"
          },
          {
            "ticket_id": 14302,
            "ticket_number": "3514290",
            "title": "Mensagem sobre a reserva 38094624 - Civitatis",
            "priority": "P2",
            "created_at": "02/04/2026 19:25:17",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 42.07,
            "sla_met": false,
            "sla_breach_hours": 38.07,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 13:29:20"
          },
          {
            "ticket_id": 14314,
            "ticket_number": "3514302",
            "title": "[Cancelamento Viagem] TRP-2026-04609 - Marisa Duar",
            "priority": "P2",
            "created_at": "03/04/2026 18:16:54",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 12:42:18"
          },
          {
            "ticket_id": 14315,
            "ticket_number": "3514303",
            "title": "[Cancelamento Serviço] TRP-2026-02352 / TRL-2026-0",
            "priority": "P1",
            "created_at": "03/04/2026 21:47:10",
            "close_date": "2026-04-07",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/04/2026 21:47:10"
          },
          {
            "ticket_id": 14316,
            "ticket_number": "3514304",
            "title": "[Cancelamento Serviço] TRP-2026-02707 / TRL-2026-0",
            "priority": "P2",
            "created_at": "03/04/2026 23:31:07",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/04/2026 23:31:07"
          },
          {
            "ticket_id": 14330,
            "ticket_number": "3514318",
            "title": "Y9ITTF – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:54",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 12:57:10"
          },
          {
            "ticket_id": 14331,
            "ticket_number": "3514319",
            "title": "YGOZWA – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "04/04/2026 10:05:56",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 10:05:56"
          },
          {
            "ticket_id": 14333,
            "ticket_number": "3514321",
            "title": "BILHETES - 433137",
            "priority": "P2",
            "created_at": "04/04/2026 10:06:00",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 2.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 13:05:01"
          },
          {
            "ticket_id": 14345,
            "ticket_number": "3514333",
            "title": "GBN-116029 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/04/2026 10:16:34",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 101.8,
            "sla_met": false,
            "sla_breach_hours": 97.8,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:05:27"
          },
          {
            "ticket_id": 14346,
            "ticket_number": "3514334",
            "title": "INSERÇÃO DE DADOS PASSAPORTE NEWBLUE PARA EMISSÃO ",
            "priority": "P2",
            "created_at": "04/04/2026 13:05:54",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 13:05:54"
          },
          {
            "ticket_id": 14350,
            "ticket_number": "3514338",
            "title": "[Suporte] TRP-2026-04581 / TRL-2026-06958 - Dados ",
            "priority": "P2",
            "created_at": "04/04/2026 15:40:44",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 15:40:44"
          },
          {
            "ticket_id": 14351,
            "ticket_number": "3514339",
            "title": "Re: [Cockpit] A Tua Semana",
            "priority": "P2",
            "created_at": "04/04/2026 15:53:06",
            "close_date": "2026-04-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 15:53:06"
          },
          {
            "ticket_id": 14376,
            "ticket_number": "3514364",
            "title": "Recolha Parasailing em Sharm el-Sheikh",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:04",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:04:53"
          },
          {
            "ticket_id": 14377,
            "ticket_number": "3514365",
            "title": "Mensagem sobre a reserva 38094626 - Civitatis",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:06",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:22:59"
          },
          {
            "ticket_id": 14379,
            "ticket_number": "3514367",
            "title": "O seu próximo transfer em Sharm el-Sheij - Civitat",
            "priority": "P2",
            "created_at": "06/04/2026 09:10:12",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 11:31:59"
          },
          {
            "ticket_id": 14399,
            "ticket_number": "3514387",
            "title": "Informação importante sobre a tua reserva 6141482",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:13",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:52:32"
          },
          {
            "ticket_id": 14408,
            "ticket_number": "3514396",
            "title": "Informação importante sobre a tua reserva 6143156",
            "priority": "P2",
            "created_at": "06/04/2026 10:12:59",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:48:57"
          },
          {
            "ticket_id": 14409,
            "ticket_number": "3514397",
            "title": "[Suporte] TRP-2026-04075 / TRL-2026-06159 - Pedido",
            "priority": "P2",
            "created_at": "06/04/2026 11:03:03",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 11:03:03"
          },
          {
            "ticket_id": 14410,
            "ticket_number": "3514398",
            "title": "[Suporte] TRP-2026-04018 / TRL-2026-06068 - Pedido",
            "priority": "P2",
            "created_at": "06/04/2026 11:04:42",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 11:04:42"
          },
          {
            "ticket_id": 14415,
            "ticket_number": "3514403",
            "title": "Importante - Checkin Online Voos TAP - FILE 332333",
            "priority": "P2",
            "created_at": "06/04/2026 12:41:14",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:51:26"
          },
          {
            "ticket_id": 14425,
            "ticket_number": "3514413",
            "title": "[Suporte] TRP-2026-04162 - Cancelar viagem",
            "priority": "P2",
            "created_at": "06/04/2026 13:02:51",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 13:02:51"
          },
          {
            "ticket_id": 14435,
            "ticket_number": "3514423",
            "title": "[Cancelamento Viagem] TRP-2026-03595 - Marta Crist",
            "priority": "P2",
            "created_at": "06/04/2026 15:23:50",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:23:51"
          },
          {
            "ticket_id": 14459,
            "ticket_number": "3514447",
            "title": "Pedido de levantamento de comissões – Atualização ",
            "priority": "P2",
            "created_at": "06/04/2026 16:28:45",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 16:28:45"
          },
          {
            "ticket_id": 14503,
            "ticket_number": "3514491",
            "title": "Pedido urgente de verificação – alteração de voo e",
            "priority": "P2",
            "created_at": "07/04/2026 09:08:22",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 09:08:22"
          },
          {
            "ticket_id": 14512,
            "ticket_number": "3514500",
            "title": "Cancelamento de reserva 340779",
            "priority": "P2",
            "created_at": "07/04/2026 10:08:01",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 13:49:58"
          },
          {
            "ticket_id": 14515,
            "ticket_number": "3514503",
            "title": "GBN-98037 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:17",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 226.03,
            "sla_met": false,
            "sla_breach_hours": 222.03,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 21:40:50"
          },
          {
            "ticket_id": 14517,
            "ticket_number": "3514505",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:21",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:40:52"
          },
          {
            "ticket_id": 14519,
            "ticket_number": "3514507",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:26",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:41:58"
          },
          {
            "ticket_id": 14520,
            "ticket_number": "3514508",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:28",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:44:19"
          },
          {
            "ticket_id": 14521,
            "ticket_number": "3514509",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:30",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 13:30:48"
          },
          {
            "ticket_id": 14522,
            "ticket_number": "3514510",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:32",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:45:27"
          },
          {
            "ticket_id": 14527,
            "ticket_number": "3514515",
            "title": "Reserva leplan 604546362 - adicionar serviço",
            "priority": "P2",
            "created_at": "07/04/2026 11:39:18",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:39:18"
          },
          {
            "ticket_id": 14534,
            "ticket_number": "3514522",
            "title": "Orçamento para mais uma pessoa na reserva",
            "priority": "P2",
            "created_at": "07/04/2026 11:55:16",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 11:55:16"
          },
          {
            "ticket_id": 14536,
            "ticket_number": "3514524",
            "title": "[Suporte] TRP-2026-04320 / TRL-2026-06534 - Upgrad",
            "priority": "P2",
            "created_at": "07/04/2026 12:13:14",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:13:14"
          },
          {
            "ticket_id": 14539,
            "ticket_number": "3514527",
            "title": "Açores 3 ilhas",
            "priority": "P2",
            "created_at": "07/04/2026 12:15:54",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 12:15:55"
          },
          {
            "ticket_id": 14606,
            "ticket_number": "3514594",
            "title": "Reserva MSC 70358738",
            "priority": "P2",
            "created_at": "07/04/2026 22:35:54",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 22:35:55"
          },
          {
            "ticket_id": 14668,
            "ticket_number": "3514656",
            "title": "[Pedido de Grupo] Promenade City Hotel Budapeste -",
            "priority": "P3",
            "created_at": "08/04/2026 16:41:36",
            "close_date": "2026-04-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/04/2026 16:41:36"
          },
          {
            "ticket_id": 14671,
            "ticket_number": "3514659",
            "title": "GBN-104777 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "08/04/2026 16:50:27",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 17:28:54"
          },
          {
            "ticket_id": 14679,
            "ticket_number": "3514667",
            "title": "Reserva cancelada com localizador: 4161024",
            "priority": "P2",
            "created_at": "08/04/2026 20:09:28",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 19:59:27"
          },
          {
            "ticket_id": 14690,
            "ticket_number": "3514678",
            "title": "Reserva Atividade %s alterada: Passeio de barco co",
            "priority": "P2",
            "created_at": "08/04/2026 21:31:40",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:32:51"
          },
          {
            "ticket_id": 14691,
            "ticket_number": "3514679",
            "title": "[Suporte] TRP-2026-04670 / TRL-2026-07115 - Dados ",
            "priority": "P2",
            "created_at": "08/04/2026 22:21:07",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:21:07"
          },
          {
            "ticket_id": 14704,
            "ticket_number": "3514692",
            "title": "GBN-116504 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/04/2026 11:18:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:44:46"
          },
          {
            "ticket_id": 14716,
            "ticket_number": "3514704",
            "title": "GBN-117413 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "09/04/2026 11:19:03",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:04:53"
          },
          {
            "ticket_id": 14750,
            "ticket_number": "3514738",
            "title": "MVU: Cambio Vuelo: 4133740 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:40:19",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 23.18,
            "sla_met": false,
            "sla_breach_hours": 19.18,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:51:23"
          },
          {
            "ticket_id": 14752,
            "ticket_number": "3514740",
            "title": "MVU: Cambio Vuelo: 4133752 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:46:48",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:40:38"
          },
          {
            "ticket_id": 14753,
            "ticket_number": "3514741",
            "title": "MVU: Cambio Vuelo: 4133745 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:46:49",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:40:38"
          },
          {
            "ticket_id": 14755,
            "ticket_number": "3514743",
            "title": "MVU: Cambio Vuelo: 4133748 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 16:46:58",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:40:38"
          },
          {
            "ticket_id": 14761,
            "ticket_number": "3514749",
            "title": "MVU: Cambio Vuelo: 4133757 FAMILIAP 001",
            "priority": "P2",
            "created_at": "09/04/2026 17:47:46",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 21:40:41"
          },
          {
            "ticket_id": 14793,
            "ticket_number": "3514781",
            "title": "PEDIDO DE CREDENCIAIS \" ODISSEIAS\"",
            "priority": "P2",
            "created_at": "09/04/2026 20:24:02",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 20:24:02"
          },
          {
            "ticket_id": 14802,
            "ticket_number": "3514790",
            "title": "Problema com nome de cliente",
            "priority": "P2",
            "created_at": "09/04/2026 23:28:47",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 23:28:47"
          },
          {
            "ticket_id": 14827,
            "ticket_number": "3514815",
            "title": "A/C DEBORA",
            "priority": "P2",
            "created_at": "10/04/2026 12:26:09",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 12:26:10"
          },
          {
            "ticket_id": 14830,
            "ticket_number": "3514818",
            "title": "Fwd: Incidente de voo TTN-1252218555#98394796#T191",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:17",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/02/2026 14:33:09"
          },
          {
            "ticket_id": 14834,
            "ticket_number": "3514822",
            "title": "* File 411467 *** voos UN QR - partida 07Maio/alte",
            "priority": "P2",
            "created_at": "10/04/2026 13:31:47",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 2.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:47:26"
          },
          {
            "ticket_id": 14840,
            "ticket_number": "3514828",
            "title": "Sololé 2Q0ZC2OE | Correção dos nomes dos convidado",
            "priority": "P1",
            "created_at": "10/04/2026 14:18:56",
            "close_date": "2026-04-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "10/04/2026 14:18:56"
          },
          {
            "ticket_id": 14848,
            "ticket_number": "3514836",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "10/04/2026 15:48:39",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:48:39"
          },
          {
            "ticket_id": 14855,
            "ticket_number": "3514843",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "10/04/2026 15:55:49",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:57:30"
          },
          {
            "ticket_id": 14857,
            "ticket_number": "3514845",
            "title": "Preços concorrencia",
            "priority": "P2",
            "created_at": "10/04/2026 15:55:53",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 15:55:54"
          },
          {
            "ticket_id": 14874,
            "ticket_number": "3514862",
            "title": "Jupiter Albufeira Hotel",
            "priority": "P2",
            "created_at": "10/04/2026 16:56:55",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 16:50:25"
          },
          {
            "ticket_id": 14907,
            "ticket_number": "3514895",
            "title": "URGENTE BILHETES REGRESSO DIA 11 ABRIL",
            "priority": "P2",
            "created_at": "11/04/2026 09:06:43",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 09:06:43"
          },
          {
            "ticket_id": 14908,
            "ticket_number": "3514896",
            "title": "Reserva excursões Rimain Tours",
            "priority": "P1",
            "created_at": "11/04/2026 09:06:44",
            "close_date": "2026-04-15",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/04/2026 09:06:45"
          },
          {
            "ticket_id": 14910,
            "ticket_number": "3514898",
            "title": "Reserva Aérea Y4IHZC",
            "priority": "P1",
            "created_at": "11/04/2026 09:06:48",
            "close_date": "2026-04-11",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.52,
            "sla_met": false,
            "sla_breach_hours": 2.27,
            "sla_name": "SLA P1",
            "first_response_at": "11/04/2026 11:38:18"
          },
          {
            "ticket_id": 14917,
            "ticket_number": "3514905",
            "title": "Fwd: Informações sobre a sua reserva TTN-126834783",
            "priority": "P2",
            "created_at": "11/04/2026 11:57:43",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 16:55:33"
          },
          {
            "ticket_id": 14937,
            "ticket_number": "3514925",
            "title": "GKCFTB – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "11/04/2026 16:08:23",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:08:27"
          },
          {
            "ticket_id": 14945,
            "ticket_number": "3514933",
            "title": "YJ9KBX – Novo prazo de emissão",
            "priority": "P2",
            "created_at": "11/04/2026 17:00:07",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 17:00:07"
          },
          {
            "ticket_id": 14953,
            "ticket_number": "3514941",
            "title": "GBN-110187 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/04/2026 17:28:11",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 12:29:20"
          },
          {
            "ticket_id": 14973,
            "ticket_number": "3514961",
            "title": "[Pedido de Grupo] Açores: Ilha de São Miguel / Qui",
            "priority": "P3",
            "created_at": "12/04/2026 11:59:25",
            "close_date": "2026-04-20",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/04/2026 11:59:25"
          },
          {
            "ticket_id": 15080,
            "ticket_number": "3515068",
            "title": "[Pedido de Grupo] Oasis Belorizonte Ilha do sal - ",
            "priority": "P3",
            "created_at": "13/04/2026 16:56:56",
            "close_date": "2026-05-04",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "13/04/2026 16:56:56"
          },
          {
            "ticket_id": 15082,
            "ticket_number": "3515070",
            "title": "Alteração de horários Ilha de São Vicente TAP 3425",
            "priority": "P2",
            "created_at": "13/04/2026 17:54:14",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 10:30:22"
          },
          {
            "ticket_id": 15138,
            "ticket_number": "3515126",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "14/04/2026 10:30:49",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 11:02:47"
          },
          {
            "ticket_id": 15173,
            "ticket_number": "3515161",
            "title": "ALTERAÇÃO DE Hoteis - FILE 419153",
            "priority": "P2",
            "created_at": "14/04/2026 16:31:18",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 1.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:34:44"
          },
          {
            "ticket_id": 15245,
            "ticket_number": "3515233",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "15/04/2026 10:09:14",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 10:09:14"
          },
          {
            "ticket_id": 15247,
            "ticket_number": "3515235",
            "title": "Re:[## 38116 ##] GBN-116627 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "15/04/2026 10:20:19",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:03:38"
          },
          {
            "ticket_id": 15248,
            "ticket_number": "3515236",
            "title": "GBN-118069 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "15/04/2026 10:20:21",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 11:09:08"
          },
          {
            "ticket_id": 15254,
            "ticket_number": "3515242",
            "title": "Confirmação reserva Bedsonline 59-5827974",
            "priority": "P2",
            "created_at": "15/04/2026 10:24:19",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 10:24:19"
          },
          {
            "ticket_id": 15257,
            "ticket_number": "3515245",
            "title": "Referencia para pagamento | File:433137/2026",
            "priority": "P2",
            "created_at": "15/04/2026 11:02:56",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 22:41:58"
          },
          {
            "ticket_id": 15261,
            "ticket_number": "3515249",
            "title": "Re: URGENTE Confirmação de reserva 344276 ### TIME",
            "priority": "P2",
            "created_at": "15/04/2026 12:04:39",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:08:43"
          },
          {
            "ticket_id": 15276,
            "ticket_number": "3515264",
            "title": "PEDIDO DE ALTERAÇÃO DO ENDEREÇO DE E-MAIL NAS RESE",
            "priority": "P2",
            "created_at": "15/04/2026 14:47:28",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 14:47:28"
          },
          {
            "ticket_id": 15280,
            "ticket_number": "3515268",
            "title": "Reserva cancelada com localizador: 4109981",
            "priority": "P2",
            "created_at": "15/04/2026 15:42:36",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 16:11:16"
          },
          {
            "ticket_id": 15295,
            "ticket_number": "3515283",
            "title": "Cotação para contratação direta - Hotel em Monthey",
            "priority": "P2",
            "created_at": "15/04/2026 17:14:54",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 17:14:54"
          },
          {
            "ticket_id": 15305,
            "ticket_number": "3515293",
            "title": "Reserva cancelada – Ref PP902181, Sr. Jose Leandro",
            "priority": "P2",
            "created_at": "15/04/2026 19:00:06",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/04/2026 12:38:40"
          },
          {
            "ticket_id": 15347,
            "ticket_number": "3515335",
            "title": "XYAC2P – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "16/04/2026 12:09:30",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 26.18,
            "sla_met": false,
            "sla_breach_hours": 25.93,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:21:18"
          },
          {
            "ticket_id": 15357,
            "ticket_number": "3515345",
            "title": "Pedido de orçamento newblue para Bayahibe",
            "priority": "P2",
            "created_at": "16/04/2026 14:11:48",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 14:11:48"
          },
          {
            "ticket_id": 15364,
            "ticket_number": "3515352",
            "title": "Nova Confirmação de reserva 342052**bilhetes emiti",
            "priority": "P2",
            "created_at": "16/04/2026 15:14:26",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 18:33:24"
          },
          {
            "ticket_id": 15367,
            "ticket_number": "3515355",
            "title": "Pedido de Contacto Movel - 334043 // Partida: 2026",
            "priority": "P2",
            "created_at": "16/04/2026 15:14:45",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 15:15:42"
          },
          {
            "ticket_id": 15370,
            "ticket_number": "3515358",
            "title": "[Suporte] TRP-2026-02877 - pedido de PNR",
            "priority": "P2",
            "created_at": "16/04/2026 16:28:00",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 16:28:00"
          },
          {
            "ticket_id": 15375,
            "ticket_number": "3515363",
            "title": "Request for availability and quotation",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:03",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 20:13:34"
          },
          {
            "ticket_id": 15381,
            "ticket_number": "3515369",
            "title": "GBN-106391 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/04/2026 19:45:55",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 20:20:55"
          },
          {
            "ticket_id": 15383,
            "ticket_number": "3515371",
            "title": "Re:[## 32685 ##] GBN-104385 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "16/04/2026 20:14:37",
            "close_date": "2026-04-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 10:20:08"
          },
          {
            "ticket_id": 15392,
            "ticket_number": "3515380",
            "title": "[Cancelamento Viagem] TRP-2026-02693 - Cátia Sofia",
            "priority": "P2",
            "created_at": "16/04/2026 23:01:18",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 23:01:18"
          },
          {
            "ticket_id": 15393,
            "ticket_number": "3515381",
            "title": "[Cancelamento Viagem] TRP-2026-02794 - Jéssica dos",
            "priority": "P2",
            "created_at": "16/04/2026 23:01:52",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 23:01:52"
          },
          {
            "ticket_id": 15394,
            "ticket_number": "3515382",
            "title": "[Cancelamento Viagem] TRP-2026-03655 - Sónia Alexa",
            "priority": "P2",
            "created_at": "16/04/2026 23:02:46",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 23:02:46"
          },
          {
            "ticket_id": 15396,
            "ticket_number": "3515384",
            "title": "418054 - Emissão",
            "priority": "P2",
            "created_at": "17/04/2026 01:20:50",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 01:20:50"
          },
          {
            "ticket_id": 15397,
            "ticket_number": "3515385",
            "title": "420319 - Emissão",
            "priority": "P2",
            "created_at": "17/04/2026 01:20:52",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 01:20:52"
          },
          {
            "ticket_id": 15401,
            "ticket_number": "3515389",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:26",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:27"
          },
          {
            "ticket_id": 15409,
            "ticket_number": "3515397",
            "title": "Pedido de Orçamento - Hotel Oasis Salinas Sea Cabo",
            "priority": "P2",
            "created_at": "17/04/2026 09:14:50",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 09:14:50"
          },
          {
            "ticket_id": 15412,
            "ticket_number": "3515400",
            "title": "Reserva Aérea Y8E9XS",
            "priority": "P1",
            "created_at": "17/04/2026 09:14:57",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 09:14:54"
          },
          {
            "ticket_id": 15419,
            "ticket_number": "3515407",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "17/04/2026 09:46:29",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:15:55"
          },
          {
            "ticket_id": 15420,
            "ticket_number": "3515408",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "17/04/2026 09:46:31",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:21:25"
          },
          {
            "ticket_id": 15421,
            "ticket_number": "3515409",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "17/04/2026 09:46:34",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:22:50"
          },
          {
            "ticket_id": 15422,
            "ticket_number": "3515410",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "17/04/2026 09:46:36",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:23:47"
          },
          {
            "ticket_id": 15431,
            "ticket_number": "3515419",
            "title": "Pedido de cancelamento transferes GBN",
            "priority": "P2",
            "created_at": "17/04/2026 10:32:54",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:32:54"
          },
          {
            "ticket_id": 15432,
            "ticket_number": "3515420",
            "title": "Pedido Urgente de valores - Contratação Direta",
            "priority": "P2",
            "created_at": "17/04/2026 10:33:47",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 10:33:48"
          },
          {
            "ticket_id": 15441,
            "ticket_number": "3515429",
            "title": "Re:[## 33136 ##] GBN-108091 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "17/04/2026 11:06:30",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 11:41:43"
          },
          {
            "ticket_id": 15452,
            "ticket_number": "3515440",
            "title": "YIHCW6 – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "17/04/2026 13:03:52",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.75,
            "sla_met": false,
            "sla_breach_hours": 1.5,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:49:12"
          },
          {
            "ticket_id": 15462,
            "ticket_number": "3515450",
            "title": "Aéreo - Confirmação de Emissão (SILVA\\RAFHAELLA) -",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:23",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:53:18"
          },
          {
            "ticket_id": 15463,
            "ticket_number": "3515451",
            "title": "Aéreo - Confirmação de Emissão (DINIZ\\EDLA) - YIHC",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:25",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:53:34"
          },
          {
            "ticket_id": 15465,
            "ticket_number": "3515453",
            "title": "Aéreo - Confirmação de Emissão (SOUZA\\JANE) - Y8E9",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:29",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:53:05"
          },
          {
            "ticket_id": 15468,
            "ticket_number": "3515456",
            "title": "Aéreo - Confirmação de Emissão (GONCALVES SILVA\\IV",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:35",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:51:31"
          },
          {
            "ticket_id": 15469,
            "ticket_number": "3515457",
            "title": "Aéreo - Confirmação de Emissão (VIEIRA PINTO\\ANTON",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:37",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:51:40"
          },
          {
            "ticket_id": 15470,
            "ticket_number": "3515458",
            "title": "Aéreo - Confirmação de Emissão (SANTOS SILVA\\ANA P",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:40",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:52:33"
          },
          {
            "ticket_id": 15471,
            "ticket_number": "3515459",
            "title": "Aéreo - Confirmação de Emissão (SOUSA SANTOS\\PATRI",
            "priority": "P1",
            "created_at": "17/04/2026 14:49:43",
            "close_date": "2026-04-17",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/04/2026 14:52:22"
          },
          {
            "ticket_id": 15627,
            "ticket_number": "3515615",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P2",
            "created_at": "20/04/2026 12:55:57",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:48:52"
          },
          {
            "ticket_id": 15636,
            "ticket_number": "3515624",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P2",
            "created_at": "20/04/2026 13:06:00",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:16:32"
          },
          {
            "ticket_id": 15637,
            "ticket_number": "3515625",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P1",
            "created_at": "20/04/2026 13:06:02",
            "close_date": "2026-05-25",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.08,
            "sla_met": false,
            "sla_breach_hours": 2.83,
            "sla_name": "SLA P1",
            "first_response_at": "20/04/2026 16:11:33"
          },
          {
            "ticket_id": 15654,
            "ticket_number": "3515642",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P2",
            "created_at": "20/04/2026 15:10:56",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:07:43"
          },
          {
            "ticket_id": 15658,
            "ticket_number": "3515646",
            "title": "Antecipação emissão bilhetes regulares",
            "priority": "P2",
            "created_at": "20/04/2026 15:16:57",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 16:08:22"
          },
          {
            "ticket_id": 15701,
            "ticket_number": "3515689",
            "title": "Antecipação emissão bilhetes regulares   343800",
            "priority": "P2",
            "created_at": "21/04/2026 09:02:57",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:58:54"
          },
          {
            "ticket_id": 15727,
            "ticket_number": "3515715",
            "title": "Confirmação de reserva * File 438860",
            "priority": "P2",
            "created_at": "21/04/2026 11:51:43",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:45:34"
          },
          {
            "ticket_id": 15740,
            "ticket_number": "3515728",
            "title": "[Suporte] TRP-2026-04697 - Morada Cliente",
            "priority": "P2",
            "created_at": "21/04/2026 12:25:32",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 12:25:32"
          },
          {
            "ticket_id": 15746,
            "ticket_number": "3515734",
            "title": "Alteração de seguro In Sure Broker",
            "priority": "P2",
            "created_at": "21/04/2026 13:10:51",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:10:51"
          },
          {
            "ticket_id": 15747,
            "ticket_number": "3515735",
            "title": "Fwd: 1261147331 TTN-1261147331#99073499#T19314678¬",
            "priority": "P2",
            "created_at": "21/04/2026 13:10:53",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:10:53"
          },
          {
            "ticket_id": 15750,
            "ticket_number": "3515738",
            "title": "Informações importantes sobre a reserva 6129317",
            "priority": "P2",
            "created_at": "21/04/2026 13:53:59",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 15:04:42"
          },
          {
            "ticket_id": 15752,
            "ticket_number": "3515740",
            "title": "Valor comissão NB - Menorca",
            "priority": "P2",
            "created_at": "21/04/2026 14:46:36",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 14:46:36"
          },
          {
            "ticket_id": 15758,
            "ticket_number": "3515746",
            "title": "TOP URG# BKK 71741223 - detalhes dos passageiros",
            "priority": "P2",
            "created_at": "21/04/2026 16:06:30",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 16:19:18"
          },
          {
            "ticket_id": 15761,
            "ticket_number": "3515749",
            "title": "FACTURA-RECIBO PARA PAGAMENTO",
            "priority": "P2",
            "created_at": "21/04/2026 16:10:45",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 16:10:46"
          },
          {
            "ticket_id": 15762,
            "ticket_number": "3515750",
            "title": "GBN-110433 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/04/2026 16:11:50",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:32:13"
          },
          {
            "ticket_id": 15765,
            "ticket_number": "3515753",
            "title": "Solférias: File 434645/26 - Hotel Allegro Isora",
            "priority": "P2",
            "created_at": "21/04/2026 17:00:35",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 17:15:33"
          },
          {
            "ticket_id": 15775,
            "ticket_number": "3515763",
            "title": "GBN-108582 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "21/04/2026 18:11:08",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 18:15:30"
          },
          {
            "ticket_id": 15798,
            "ticket_number": "3515786",
            "title": "GBN-114517 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "21/04/2026 22:57:55",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 13:45:59"
          },
          {
            "ticket_id": 15847,
            "ticket_number": "3515835",
            "title": "[Cancelamento Serviço] TRP-2026-04821 / TRL-2026-0",
            "priority": "P2",
            "created_at": "22/04/2026 15:11:11",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:11:12"
          },
          {
            "ticket_id": 15861,
            "ticket_number": "3515849",
            "title": "Devolução valor reserva cliente Rui Gomes",
            "priority": "P2",
            "created_at": "22/04/2026 16:15:54",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 16:15:55"
          },
          {
            "ticket_id": 15870,
            "ticket_number": "3515858",
            "title": "GBN-119781 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/04/2026 17:10:47",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 43.93,
            "sla_met": false,
            "sla_breach_hours": 39.93,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 13:07:46"
          },
          {
            "ticket_id": 15873,
            "ticket_number": "3515861",
            "title": "GBN-116792 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "22/04/2026 18:00:19",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:36:10"
          },
          {
            "ticket_id": 15916,
            "ticket_number": "3515904",
            "title": "Fwd: Ref.: L1020740670 - GBN-102255",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:27",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:38:30"
          },
          {
            "ticket_id": 15938,
            "ticket_number": "3515926",
            "title": "Envio dados passaporte RESERVA Soltropico n. 34427",
            "priority": "P2",
            "created_at": "23/04/2026 11:59:42",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 11:59:42"
          },
          {
            "ticket_id": 15944,
            "ticket_number": "3515932",
            "title": "BedsOnline",
            "priority": "P2",
            "created_at": "23/04/2026 12:39:59",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:39:59"
          },
          {
            "ticket_id": 15957,
            "ticket_number": "3515945",
            "title": "Bedsonline",
            "priority": "P2",
            "created_at": "23/04/2026 15:23:54",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 15:23:55"
          },
          {
            "ticket_id": 15984,
            "ticket_number": "3515972",
            "title": "GBN-112456 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "23/04/2026 18:13:21",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 12:55:57"
          },
          {
            "ticket_id": 16006,
            "ticket_number": "3515994",
            "title": "[Suporte] TRP-2026-02506 / TRL-2026-03856 - Check ",
            "priority": "P2",
            "created_at": "24/04/2026 08:49:49",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 08:49:49"
          },
          {
            "ticket_id": 16024,
            "ticket_number": "3516012",
            "title": "[Cancelamento Viagem] TRP-2026-04842 - Nuno Filipe",
            "priority": "P2",
            "created_at": "24/04/2026 09:35:04",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 09:35:04"
          },
          {
            "ticket_id": 16033,
            "ticket_number": "3516021",
            "title": "Fwd: FORMAÇÃO CERTIFICADA | WHATSAPP | 23 DE ABRIL",
            "priority": "P2",
            "created_at": "24/04/2026 11:13:21",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 11:13:21"
          },
          {
            "ticket_id": 16036,
            "ticket_number": "3516024",
            "title": "* File 435734 * alteração de horário voo CDG MRU C",
            "priority": "P2",
            "created_at": "24/04/2026 11:43:22",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 12:06:43"
          },
          {
            "ticket_id": 16043,
            "ticket_number": "3516031",
            "title": "Mensagem sobre a reserva 38565511 - Civitatis",
            "priority": "P2",
            "created_at": "24/04/2026 12:28:08",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 16:20:23"
          },
          {
            "ticket_id": 16052,
            "ticket_number": "3516040",
            "title": "Envento presencial Vila Baleira",
            "priority": "P2",
            "created_at": "24/04/2026 14:49:50",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 14:49:51"
          },
          {
            "ticket_id": 16054,
            "ticket_number": "3516042",
            "title": "Fwd: Y8DDVH | Extras para a tua viagem para Marrak",
            "priority": "P2",
            "created_at": "24/04/2026 15:19:18",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:19:18"
          },
          {
            "ticket_id": 16058,
            "ticket_number": "3516046",
            "title": "Fwd: DS6MNI | Atualização importante para todos os",
            "priority": "P2",
            "created_at": "24/04/2026 15:19:36",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:19:37"
          },
          {
            "ticket_id": 16061,
            "ticket_number": "3516049",
            "title": "AVISO CANCELAMENTO DE RESERVA LOCALIZADOR 60462076",
            "priority": "P2",
            "created_at": "24/04/2026 15:36:54",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 15:48:28"
          },
          {
            "ticket_id": 16122,
            "ticket_number": "3516110",
            "title": "reserva soltropico nr: 344772 questões",
            "priority": "P2",
            "created_at": "27/04/2026 09:09:00",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:09:00"
          },
          {
            "ticket_id": 16186,
            "ticket_number": "3516174",
            "title": "Viagem Soltropico",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:41",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:41"
          },
          {
            "ticket_id": 16201,
            "ticket_number": "3516189",
            "title": "Credenciais de acesso a Veturis e Servantrip",
            "priority": "P2",
            "created_at": "27/04/2026 10:09:33",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:09:33"
          },
          {
            "ticket_id": 16312,
            "ticket_number": "3516300",
            "title": "Acesso servantrip",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:37",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 09:16:37"
          },
          {
            "ticket_id": 16316,
            "ticket_number": "3516304",
            "title": "[Cancelamento Serviço] TRP-2026-03934 / TRL-2026-0",
            "priority": "P2",
            "created_at": "28/04/2026 09:23:06",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 16:44:14"
          },
          {
            "ticket_id": 16319,
            "ticket_number": "3516307",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "28/04/2026 10:05:22",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 2.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:15:37"
          },
          {
            "ticket_id": 16334,
            "ticket_number": "3516322",
            "title": "EMISSÃO Rsv Especial IB (NDC)  == SPT002601626063 ",
            "priority": "P2",
            "created_at": "28/04/2026 11:40:07",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 4.13,
            "sla_met": false,
            "sla_breach_hours": 0.13,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 15:48:18"
          },
          {
            "ticket_id": 16340,
            "ticket_number": "3516328",
            "title": "Acréscimo de uma pessoa à reserva",
            "priority": "P2",
            "created_at": "28/04/2026 12:28:17",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 12:28:18"
          },
          {
            "ticket_id": 16356,
            "ticket_number": "3516344",
            "title": "Cancelamento de reserva * File 430511",
            "priority": "P2",
            "created_at": "28/04/2026 14:09:43",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/04/2026 12:48:11"
          },
          {
            "ticket_id": 16370,
            "ticket_number": "3516358",
            "title": "Pedido de acesso à Odisseias",
            "priority": "P2",
            "created_at": "28/04/2026 17:04:41",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:04:41"
          },
          {
            "ticket_id": 16373,
            "ticket_number": "3516361",
            "title": "MVU: Cambio Vuelo: 4134662 FAMILIAP 001",
            "priority": "P2",
            "created_at": "28/04/2026 17:29:51",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:51:27"
          },
          {
            "ticket_id": 16397,
            "ticket_number": "3516385",
            "title": "LOC: 6126895 - NB - alteração passageiro",
            "priority": "P2",
            "created_at": "28/04/2026 21:59:47",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 21:59:47"
          },
          {
            "ticket_id": 16398,
            "ticket_number": "3516386",
            "title": "[Suporte] TRP-2026-04387 / TRL-2026-06652 - Altera",
            "priority": "P2",
            "created_at": "28/04/2026 22:22:12",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 12:37:11"
          },
          {
            "ticket_id": 16401,
            "ticket_number": "3516389",
            "title": "[Cancelamento Serviço] TRP-2026-03696 / TRL-2026-0",
            "priority": "P2",
            "created_at": "28/04/2026 22:24:58",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 22:24:59"
          },
          {
            "ticket_id": 16408,
            "ticket_number": "3516396",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604619807",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:45",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:39:14"
          },
          {
            "ticket_id": 16409,
            "ticket_number": "3516397",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604595633",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:46",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:41:46"
          },
          {
            "ticket_id": 16410,
            "ticket_number": "3516398",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604621213",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:48",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:42:29"
          },
          {
            "ticket_id": 16411,
            "ticket_number": "3516399",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604563025",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:50",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:48:56"
          },
          {
            "ticket_id": 16413,
            "ticket_number": "3516401",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604563025",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:54",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:43:20"
          },
          {
            "ticket_id": 16415,
            "ticket_number": "3516403",
            "title": "Pedido de esclarecimento – condições de pagamento ",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:57",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:14:57"
          },
          {
            "ticket_id": 16416,
            "ticket_number": "3516404",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:59",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:00:45"
          },
          {
            "ticket_id": 16417,
            "ticket_number": "3516405",
            "title": "Incidência resolvida - domingo 26/04",
            "priority": "P2",
            "created_at": "29/04/2026 09:17:17",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:17:17"
          },
          {
            "ticket_id": 16418,
            "ticket_number": "3516406",
            "title": "[Cancelamento Viagem] TRP-2026-02070 - Rui Gomes -",
            "priority": "P2",
            "created_at": "29/04/2026 09:29:40",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:29:40"
          },
          {
            "ticket_id": 16419,
            "ticket_number": "3516407",
            "title": "Nova Confirmação de reserva 333905 ### BILHETES EM",
            "priority": "P2",
            "created_at": "29/04/2026 09:35:19",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 15:53:02"
          },
          {
            "ticket_id": 16420,
            "ticket_number": "3516408",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "29/04/2026 09:35:20",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:49:57"
          },
          {
            "ticket_id": 16422,
            "ticket_number": "3516410",
            "title": "Para relembrar!!!! RE: EMISSÃO Rsv Especial IB (ND",
            "priority": "P2",
            "created_at": "29/04/2026 09:51:27",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 09:57:17"
          },
          {
            "ticket_id": 16429,
            "ticket_number": "3516417",
            "title": "Fwd: Informações da reserva TTN-1273528510#1003338",
            "priority": "P2",
            "created_at": "29/04/2026 10:00:58",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:00:58"
          },
          {
            "ticket_id": 16431,
            "ticket_number": "3516419",
            "title": "Fwd: Your Hand Luggage Allowance, Booking: VQ66GH",
            "priority": "P2",
            "created_at": "29/04/2026 10:36:40",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 10:36:40"
          },
          {
            "ticket_id": 16442,
            "ticket_number": "3516430",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "29/04/2026 11:39:51",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:51:28"
          },
          {
            "ticket_id": 16443,
            "ticket_number": "3516431",
            "title": "In Sure Broker - Pedido de alteração de pessoa seg",
            "priority": "P2",
            "created_at": "29/04/2026 11:39:54",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 11:52:06"
          },
          {
            "ticket_id": 16490,
            "ticket_number": "3516478",
            "title": "Alteração nome",
            "priority": "P2",
            "created_at": "29/04/2026 15:45:23",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:45:23"
          },
          {
            "ticket_id": 16512,
            "ticket_number": "3516500",
            "title": "GBN-102450 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:23",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:44:51"
          },
          {
            "ticket_id": 16513,
            "ticket_number": "3516501",
            "title": "GBN-102450 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:26",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:19:10"
          },
          {
            "ticket_id": 16528,
            "ticket_number": "3516516",
            "title": "TRP-2026-04686 pedido de cancelamento",
            "priority": "P1",
            "created_at": "29/04/2026 22:40:45",
            "close_date": "2026-05-04",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "29/04/2026 15:48:21"
          },
          {
            "ticket_id": 16557,
            "ticket_number": "3516545",
            "title": "[Suporte] TRP-2026-04872 - Pedido de compra 12GO",
            "priority": "P2",
            "created_at": "30/04/2026 11:03:22",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 11:03:22"
          },
          {
            "ticket_id": 16606,
            "ticket_number": "3516594",
            "title": "Reclamação BMQJWYY4",
            "priority": "P2",
            "created_at": "30/04/2026 15:54:51",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 15:55:22"
          },
          {
            "ticket_id": 16674,
            "ticket_number": "3516662",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "01/05/2026 00:50:06",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/05/2026 00:49:28"
          },
          {
            "ticket_id": 16788,
            "ticket_number": "3516776",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "04/05/2026 09:10:08",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 13:01:59"
          },
          {
            "ticket_id": 16878,
            "ticket_number": "3516866",
            "title": "STP002601627440 SOLTOUR",
            "priority": "P2",
            "created_at": "04/05/2026 12:13:29",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:13:29"
          },
          {
            "ticket_id": 16882,
            "ticket_number": "3516870",
            "title": "[Cancelamento Viagem] TRP-2026-03765 - Adriana Sou",
            "priority": "P2",
            "created_at": "04/05/2026 12:34:24",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 10:23:19"
          },
          {
            "ticket_id": 16916,
            "ticket_number": "3516904",
            "title": "Importante - Checkin Online Voos TAP - FILE 334043",
            "priority": "P2",
            "created_at": "04/05/2026 16:15:52",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 17:00:50"
          },
          {
            "ticket_id": 16991,
            "ticket_number": "3516979",
            "title": "Re:[## 39060 ##] GBN-119781 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "05/05/2026 10:45:08",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 11:41:42"
          },
          {
            "ticket_id": 16997,
            "ticket_number": "3516985",
            "title": "GBN-107986 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "05/05/2026 11:26:46",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 11:26:46"
          },
          {
            "ticket_id": 17023,
            "ticket_number": "3517011",
            "title": "[Suporte] TRP-2026-04993 / TRL-2026-07696 - Altera",
            "priority": "P2",
            "created_at": "05/05/2026 14:26:31",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 14:25:40"
          },
          {
            "ticket_id": 17077,
            "ticket_number": "3517065",
            "title": "Cancellation of the booking with locator 9NHWPIHY",
            "priority": "P2",
            "created_at": "05/05/2026 22:24:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:24:16"
          },
          {
            "ticket_id": 17079,
            "ticket_number": "3517067",
            "title": "Cancellation of the booking with locator 9JMO8OU1",
            "priority": "P2",
            "created_at": "05/05/2026 22:27:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:27:18"
          },
          {
            "ticket_id": 17100,
            "ticket_number": "3517088",
            "title": "[Cancelamento Serviço] TRP-2026-04966 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/05/2026 10:41:08",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:41:08"
          },
          {
            "ticket_id": 17106,
            "ticket_number": "3517094",
            "title": "Mensagem sobre a reserva 36566235 - Civitatis",
            "priority": "P2",
            "created_at": "06/05/2026 10:51:24",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:30:50"
          },
          {
            "ticket_id": 17109,
            "ticket_number": "3517097",
            "title": "Mensagem sobre a reserva 36566236 - Civitatis",
            "priority": "P2",
            "created_at": "06/05/2026 10:51:31",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:32:46"
          },
          {
            "ticket_id": 17120,
            "ticket_number": "3517108",
            "title": "Alteração de horário de voo - OPOSIDOPO",
            "priority": "P2",
            "created_at": "06/05/2026 11:55:59",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:15:00"
          },
          {
            "ticket_id": 17124,
            "ticket_number": "3517112",
            "title": "Envio de documentação",
            "priority": "P2",
            "created_at": "06/05/2026 12:03:59",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:19:41"
          },
          {
            "ticket_id": 17125,
            "ticket_number": "3517113",
            "title": "Re:[## 40345 ##] GBN-122364 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "06/05/2026 12:25:39",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 10:51:27"
          },
          {
            "ticket_id": 17137,
            "ticket_number": "3517125",
            "title": "GBN-101025 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "06/05/2026 14:46:12",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 15:33:03"
          },
          {
            "ticket_id": 17139,
            "ticket_number": "3517127",
            "title": "GBN-119022 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "06/05/2026 14:46:16",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 14:46:16"
          },
          {
            "ticket_id": 17185,
            "ticket_number": "3517173",
            "title": "[Suporte] TRP-2026-02714 / TRL-2026-04172 - Aletar",
            "priority": "P2",
            "created_at": "06/05/2026 21:08:16",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 21:08:17"
          },
          {
            "ticket_id": 17219,
            "ticket_number": "3517207",
            "title": "[Suporte] TRP-2026-04694 - Revisão CVO e RGPD",
            "priority": "P2",
            "created_at": "06/05/2026 23:09:11",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 23:09:12"
          },
          {
            "ticket_id": 17232,
            "ticket_number": "3517220",
            "title": "Transfer 2992970 cancelado",
            "priority": "P2",
            "created_at": "07/05/2026 09:09:06",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 12:41:52"
          },
          {
            "ticket_id": 17234,
            "ticket_number": "3517222",
            "title": "Transfer 2992971 cancelado",
            "priority": "P2",
            "created_at": "07/05/2026 09:09:10",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:09:10"
          },
          {
            "ticket_id": 17261,
            "ticket_number": "3517249",
            "title": "URGENTE TTN-1267172189#100360569#T19641568¬1177793",
            "priority": "P2",
            "created_at": "07/05/2026 11:30:39",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:36:35"
          },
          {
            "ticket_id": 17263,
            "ticket_number": "3517251",
            "title": "Informações da reserva TTN-1256680749#100807963#T1",
            "priority": "P2",
            "created_at": "07/05/2026 11:30:46",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 3.12,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:37:52"
          },
          {
            "ticket_id": 17265,
            "ticket_number": "3517253",
            "title": "GBN-112440 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "07/05/2026 11:59:20",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 12:38:00"
          },
          {
            "ticket_id": 17289,
            "ticket_number": "3517277",
            "title": "Informações da reserva TTN-1258387533#101021048#T1",
            "priority": "P2",
            "created_at": "07/05/2026 15:22:30",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 16:34:45"
          },
          {
            "ticket_id": 17296,
            "ticket_number": "3517284",
            "title": "Incidente de voo TTN-1267172189#100360569#T1964156",
            "priority": "P2",
            "created_at": "07/05/2026 16:01:36",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 16:44:28"
          },
          {
            "ticket_id": 17300,
            "ticket_number": "3517288",
            "title": "Re:[## 40448 ##] GBN-112440 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "07/05/2026 17:07:17",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 14:44:55"
          },
          {
            "ticket_id": 17301,
            "ticket_number": "3517289",
            "title": "Re:[## 40444 ##] GBN-121759 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "07/05/2026 17:07:19",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:54:39"
          },
          {
            "ticket_id": 17324,
            "ticket_number": "3517312",
            "title": "TRP-2026-03795 - Viagem Vietnam Laos e Camboja",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:30",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 19:32:30"
          },
          {
            "ticket_id": 17343,
            "ticket_number": "3517331",
            "title": "Antecipação emissão bilhetes São Tomé G LS 342724",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:34",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 18.73,
            "sla_met": false,
            "sla_breach_hours": 14.73,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 16:43:38"
          },
          {
            "ticket_id": 17416,
            "ticket_number": "3517404",
            "title": "AJUSTE DO HORÁRIO DE VERAO 6127188",
            "priority": "P2",
            "created_at": "08/05/2026 15:34:19",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 16:57:02"
          },
          {
            "ticket_id": 17417,
            "ticket_number": "3517405",
            "title": "Re:[## 40299 ##] GBN-119016 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "08/05/2026 16:26:24",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:49:58"
          },
          {
            "ticket_id": 17418,
            "ticket_number": "3517406",
            "title": "NOTIFICAÇÃO IMPORTANTE SOBRE A SUA RESERVA 6123918",
            "priority": "P2",
            "created_at": "08/05/2026 16:26:26",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 17:27:55"
          },
          {
            "ticket_id": 17445,
            "ticket_number": "3517433",
            "title": "[Cancelamento Serviço] TRP-2026-05050 / TRL-2026-0",
            "priority": "P2",
            "created_at": "08/05/2026 21:33:51",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 21:33:52"
          },
          {
            "ticket_id": 17466,
            "ticket_number": "3517454",
            "title": "Civitatis - Re: Civitatis Cerimônia do chá em Tóqu",
            "priority": "P2",
            "created_at": "09/05/2026 09:04:17",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:26:06"
          },
          {
            "ticket_id": 17487,
            "ticket_number": "3517475",
            "title": "Informações da reserva TTN-1249892858#101331765#T1",
            "priority": "P2",
            "created_at": "09/05/2026 12:36:17",
            "close_date": "2026-05-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 12:50:50"
          },
          {
            "ticket_id": 17824,
            "ticket_number": "3517812",
            "title": "GBN-123532 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "12/05/2026 20:14:17",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 21:08:19"
          },
          {
            "ticket_id": 17947,
            "ticket_number": "3517935",
            "title": "[Cancelamento Viagem] TRP-2026-02717 - LILIANA CUN",
            "priority": "P2",
            "created_at": "13/05/2026 17:18:11",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:18:11"
          },
          {
            "ticket_id": 18069,
            "ticket_number": "3518057",
            "title": "Informação de reserva - SPT002601580753",
            "priority": "P2",
            "created_at": "14/05/2026 15:39:02",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 19:24:49"
          },
          {
            "ticket_id": 18229,
            "ticket_number": "3518217",
            "title": "GBN-124387 - Sua confirmação de reserva",
            "priority": "P1",
            "created_at": "16/05/2026 11:27:06",
            "close_date": "2026-05-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "16/05/2026 11:40:12"
          },
          {
            "ticket_id": 18238,
            "ticket_number": "3518226",
            "title": "[Cancelamento Serviço] TRP-2026-05079 / TRL-2026-0",
            "priority": "P2",
            "created_at": "16/05/2026 17:42:42",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 17:42:43"
          },
          {
            "ticket_id": 18248,
            "ticket_number": "3518236",
            "title": "[Suporte] TRP-2026-03263 - Documentação de Viagem",
            "priority": "P2",
            "created_at": "17/05/2026 20:26:51",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/05/2026 20:26:51"
          },
          {
            "ticket_id": 18275,
            "ticket_number": "3518263",
            "title": "Atualização dados reserva Newblue 6131017",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:27",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:27"
          },
          {
            "ticket_id": 18279,
            "ticket_number": "3518267",
            "title": "Pedido de esclarecimento sobre transfer e opções d",
            "priority": "P2",
            "created_at": "18/05/2026 09:20:38",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:20:38"
          },
          {
            "ticket_id": 18280,
            "ticket_number": "3518268",
            "title": "Informação de reserva - SPT002601632901",
            "priority": "P1",
            "created_at": "18/05/2026 09:20:41",
            "close_date": "2026-05-21",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "18/05/2026 09:20:44"
          },
          {
            "ticket_id": 18339,
            "ticket_number": "3518327",
            "title": "Re:[## 39855 ##] GBN-121361 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "18/05/2026 10:43:02",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:45:12"
          },
          {
            "ticket_id": 18349,
            "ticket_number": "3518337",
            "title": "Incidente de voo TTN-1243185860#102047752#T2006762",
            "priority": "P2",
            "created_at": "18/05/2026 11:28:10",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 15:21:36"
          },
          {
            "ticket_id": 18359,
            "ticket_number": "3518347",
            "title": "Documentação da reserva TTN-1252218555#102141185",
            "priority": "P2",
            "created_at": "18/05/2026 14:19:34",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 14:25:47"
          },
          {
            "ticket_id": 18380,
            "ticket_number": "3518368",
            "title": "GBN-124375 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "18/05/2026 16:33:02",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 16:54:06"
          },
          {
            "ticket_id": 18419,
            "ticket_number": "3518407",
            "title": "Pedido de voucher",
            "priority": "P2",
            "created_at": "18/05/2026 22:42:26",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 22:42:26"
          },
          {
            "ticket_id": 18423,
            "ticket_number": "3518411",
            "title": "Informações da reserva TTN-1239792144#101976060#T2",
            "priority": "P2",
            "created_at": "19/05/2026 08:59:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 20:46:37"
          },
          {
            "ticket_id": 18462,
            "ticket_number": "3518450",
            "title": "Taxa de Cartão de Crédito - TRP-2026-05081",
            "priority": "P2",
            "created_at": "19/05/2026 12:09:01",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 12:09:01"
          },
          {
            "ticket_id": 18465,
            "ticket_number": "3518453",
            "title": "Alteração horário voos OPO-PXO-OPO HAT",
            "priority": "P2",
            "created_at": "19/05/2026 12:55:21",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:16:18"
          },
          {
            "ticket_id": 18473,
            "ticket_number": "3518461",
            "title": "[Cancelamento Serviço] TRP-2026-05172 / TRL-2026-0",
            "priority": "P2",
            "created_at": "19/05/2026 13:50:09",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:50:09"
          },
          {
            "ticket_id": 18478,
            "ticket_number": "3518466",
            "title": "[Suporte] TRP-2026-03941 - Ajuda com alteração dos",
            "priority": "P2",
            "created_at": "19/05/2026 13:53:47",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 13:53:48"
          },
          {
            "ticket_id": 18481,
            "ticket_number": "3518469",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604632825",
            "priority": "P2",
            "created_at": "19/05/2026 14:30:36",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:42:52"
          },
          {
            "ticket_id": 18483,
            "ticket_number": "3518471",
            "title": "GBN-124484 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "19/05/2026 14:30:44",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 14:30:44"
          },
          {
            "ticket_id": 18501,
            "ticket_number": "3518489",
            "title": "Reembolso 50€ - TRP-2026-04775",
            "priority": "P2",
            "created_at": "19/05/2026 16:30:25",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 16:30:25"
          },
          {
            "ticket_id": 18534,
            "ticket_number": "3518522",
            "title": "[Cancelamento Serviço] TRP-2026-03220 / TRL-2026-0",
            "priority": "P1",
            "created_at": "19/05/2026 20:30:34",
            "close_date": "2026-05-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 20:30:35"
          },
          {
            "ticket_id": 18563,
            "ticket_number": "3518551",
            "title": "[Suporte] TRP-2026-02470 / TRL-2026-03793 - Esclar",
            "priority": "P2",
            "created_at": "20/05/2026 09:20:38",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 09:20:38"
          },
          {
            "ticket_id": 18581,
            "ticket_number": "3518569",
            "title": "[Suporte] TRP-2026-02480 - NIB para devolução valo",
            "priority": "P2",
            "created_at": "20/05/2026 10:12:33",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 10:12:33"
          },
          {
            "ticket_id": 18586,
            "ticket_number": "3518574",
            "title": "Grp. 884491 || Lisboa || 10/07 a 12/07",
            "priority": "P2",
            "created_at": "20/05/2026 11:37:04",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:22:09"
          },
          {
            "ticket_id": 18638,
            "ticket_number": "3518626",
            "title": "GBN-124875 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:36",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:51:39"
          },
          {
            "ticket_id": 18643,
            "ticket_number": "3518631",
            "title": "Reserva Djerba",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:47",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:26:47"
          },
          {
            "ticket_id": 18650,
            "ticket_number": "3518638",
            "title": "[Cancelamento Serviço] TRP-2026-05194 / TRL-2026-0",
            "priority": "P2",
            "created_at": "20/05/2026 17:42:17",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:42:18"
          },
          {
            "ticket_id": 18653,
            "ticket_number": "3518641",
            "title": "Duvida orçamento NEWBLUE ES",
            "priority": "P2",
            "created_at": "20/05/2026 17:51:45",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 17:51:45"
          },
          {
            "ticket_id": 18666,
            "ticket_number": "3518654",
            "title": "GBN 105492",
            "priority": "P2",
            "created_at": "20/05/2026 19:16:33",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 19:16:34"
          },
          {
            "ticket_id": 18671,
            "ticket_number": "3518659",
            "title": "NOVA RESERVA TRAVELPLAN",
            "priority": "P2",
            "created_at": "20/05/2026 20:15:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:15:06"
          },
          {
            "ticket_id": 18704,
            "ticket_number": "3518692",
            "title": "Confirmação de reserva 333993 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "21/05/2026 09:58:58",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 3.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:39:18"
          },
          {
            "ticket_id": 18705,
            "ticket_number": "3518693",
            "title": "URGENTE - SOLFÉRIAS",
            "priority": "P2",
            "created_at": "21/05/2026 10:02:57",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:02:57"
          },
          {
            "ticket_id": 18714,
            "ticket_number": "3518702",
            "title": "Localizador 4223112 - TOUR10",
            "priority": "P2",
            "created_at": "21/05/2026 10:18:13",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 10:18:13"
          },
          {
            "ticket_id": 18726,
            "ticket_number": "3518714",
            "title": "Confirmação de reserva 344677 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "21/05/2026 13:11:48",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 13:22:09"
          },
          {
            "ticket_id": 18733,
            "ticket_number": "3518721",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604546362",
            "priority": "P2",
            "created_at": "21/05/2026 13:12:06",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 16:55:30"
          },
          {
            "ticket_id": 18741,
            "ticket_number": "3518729",
            "title": "Informações da reserva TTN-1282436603#102534164#T2",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:18",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 20:35:20"
          },
          {
            "ticket_id": 18748,
            "ticket_number": "3518736",
            "title": "MVU: Cambio Vuelo: 4135830 FAMILIAP 001",
            "priority": "P2",
            "created_at": "21/05/2026 14:32:34",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 18:24:49"
          },
          {
            "ticket_id": 18815,
            "ticket_number": "3518803",
            "title": "Referência: UFEV TTN-1234448066#102584769#T2019792",
            "priority": "P2",
            "created_at": "21/05/2026 21:19:52",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:49:27"
          },
          {
            "ticket_id": 18820,
            "ticket_number": "3518808",
            "title": "Adicionar criança de 9 anos - Soltour SPT002601622",
            "priority": "P2",
            "created_at": "21/05/2026 21:45:03",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:45:03"
          },
          {
            "ticket_id": 18823,
            "ticket_number": "3518811",
            "title": "Emissão Visto",
            "priority": "P2",
            "created_at": "21/05/2026 21:54:27",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 21:54:27"
          },
          {
            "ticket_id": 18828,
            "ticket_number": "3518816",
            "title": "RIMAIN TOURS | Reserva Excursão | Marta Oliveira",
            "priority": "P1",
            "created_at": "21/05/2026 22:24:29",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/05/2026 22:24:30"
          },
          {
            "ticket_id": 18834,
            "ticket_number": "3518822",
            "title": "[Cancelamento Viagem] TRP-2026-04855 - Hugo Miguel",
            "priority": "P2",
            "created_at": "21/05/2026 23:22:46",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 23:22:46"
          },
          {
            "ticket_id": 18835,
            "ticket_number": "3518823",
            "title": "REMINDER: Dados de Passaporte - nosso File 431638",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:37",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:37:54"
          },
          {
            "ticket_id": 18839,
            "ticket_number": "3518827",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:46",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:10:26"
          },
          {
            "ticket_id": 18840,
            "ticket_number": "3518828",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:47",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:38:33"
          },
          {
            "ticket_id": 18841,
            "ticket_number": "3518829",
            "title": "REMINDER: Dados de Passaporte - nosso File 440322",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:49",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:09:49"
          },
          {
            "ticket_id": 18843,
            "ticket_number": "3518831",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:53",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:39:20"
          },
          {
            "ticket_id": 18845,
            "ticket_number": "3518833",
            "title": "Incidente de voo TTN-1234448066#102586353#T2019828",
            "priority": "P2",
            "created_at": "22/05/2026 09:07:58",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 3.88,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:01:23"
          },
          {
            "ticket_id": 18846,
            "ticket_number": "3518834",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "22/05/2026 09:08:00",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:40:14"
          },
          {
            "ticket_id": 18853,
            "ticket_number": "3518841",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/05/2026 09:55:51",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:07:36"
          },
          {
            "ticket_id": 18855,
            "ticket_number": "3518843",
            "title": "Re:[## 41497 ##] GBN-123765 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "22/05/2026 09:55:57",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/05/2026 15:57:22"
          },
          {
            "ticket_id": 18860,
            "ticket_number": "3518848",
            "title": "INFORMAMOS SOBRE A RESERVA LOCALIZADOR 604638571",
            "priority": "P2",
            "created_at": "22/05/2026 10:33:59",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:48:25"
          },
          {
            "ticket_id": 18868,
            "ticket_number": "3518856",
            "title": "Incidente de voo TTN-1223362854#102383431#T2014852",
            "priority": "P2",
            "created_at": "22/05/2026 11:16:38",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 21:39:23"
          },
          {
            "ticket_id": 18875,
            "ticket_number": "3518863",
            "title": "Confirmação de reserva 333882 ###BILHETES EMITIDOS",
            "priority": "P2",
            "created_at": "22/05/2026 12:27:15",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 21:59:56"
          },
          {
            "ticket_id": 18881,
            "ticket_number": "3518869",
            "title": "VJT: Suplemento Combustível Charter 212653",
            "priority": "P2",
            "created_at": "22/05/2026 12:55:58",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:44:57"
          },
          {
            "ticket_id": 18882,
            "ticket_number": "3518870",
            "title": "Documentação da reserva TTN-1258780978#102421709",
            "priority": "P2",
            "created_at": "22/05/2026 13:03:22",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:48:36"
          },
          {
            "ticket_id": 18884,
            "ticket_number": "3518872",
            "title": "Documentação da reserva TTN-1258520683#102650705",
            "priority": "P2",
            "created_at": "22/05/2026 13:29:59",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 13:49:08"
          },
          {
            "ticket_id": 18891,
            "ticket_number": "3518879",
            "title": "[Cancelamento Serviço] TRP-2026-04247 / TRL-2026-0",
            "priority": "P2",
            "created_at": "22/05/2026 15:23:02",
            "close_date": "2026-05-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:23:03"
          },
          {
            "ticket_id": 18907,
            "ticket_number": "3518895",
            "title": "Re: PARABÉNS MÓNICA!!! FOSTE A GRANDE VENCEDORA DO",
            "priority": "P2",
            "created_at": "22/05/2026 15:57:04",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 15:57:05"
          },
          {
            "ticket_id": 18919,
            "ticket_number": "3518907",
            "title": "Información de reserva número:",
            "priority": "P2",
            "created_at": "22/05/2026 18:16:53",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 23:13:33"
          },
          {
            "ticket_id": 18937,
            "ticket_number": "3518925",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:38",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 8.83,
            "sla_met": false,
            "sla_breach_hours": 4.83,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:57:16"
          },
          {
            "ticket_id": 18939,
            "ticket_number": "3518927",
            "title": "REMINDER: Dados de Passaporte - nosso File 431638",
            "priority": "P2",
            "created_at": "23/05/2026 09:06:43",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:39:21"
          },
          {
            "ticket_id": 18947,
            "ticket_number": "3518935",
            "title": "Informações sobre o seu orçamento TTN-1283245222#1",
            "priority": "P2",
            "created_at": "23/05/2026 09:49:42",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 13:26:13"
          },
          {
            "ticket_id": 18948,
            "ticket_number": "3518936",
            "title": "1234129672 TTN-1234129672#102699833#T20226167¬1211",
            "priority": "P2",
            "created_at": "23/05/2026 09:49:44",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 11:35:14"
          },
          {
            "ticket_id": 18950,
            "ticket_number": "3518938",
            "title": "[Cancelamento Serviço] TRP-2026-05184 / TRL-2026-0",
            "priority": "P2",
            "created_at": "23/05/2026 12:57:42",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 12:57:42"
          },
          {
            "ticket_id": 18963,
            "ticket_number": "3518951",
            "title": "Documentação da reserva TTN-1241119548#91340346",
            "priority": "P2",
            "created_at": "23/05/2026 15:12:23",
            "close_date": "2026-05-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 15:14:44"
          },
          {
            "ticket_id": 18969,
            "ticket_number": "3518957",
            "title": "Reserva Soltropico para Zanzibar",
            "priority": "P2",
            "created_at": "23/05/2026 17:34:57",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 17:34:57"
          },
          {
            "ticket_id": 19039,
            "ticket_number": "3519027",
            "title": "Recibo verde",
            "priority": "P2",
            "created_at": "25/05/2026 10:34:53",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:34:53"
          },
          {
            "ticket_id": 19056,
            "ticket_number": "3519044",
            "title": "[Cancelamento Serviço] TRP-2026-05249 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/05/2026 11:43:10",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 11:43:10"
          },
          {
            "ticket_id": 19057,
            "ticket_number": "3519045",
            "title": "RE: Bilhetes Magic Shuttle 604490259",
            "priority": "P2",
            "created_at": "25/05/2026 12:20:45",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 4.77,
            "sla_met": false,
            "sla_breach_hours": 0.77,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:07:31"
          },
          {
            "ticket_id": 19061,
            "ticket_number": "3519049",
            "title": "processo 442135 / 2026 - Solfeiras - URGENTE",
            "priority": "P1",
            "created_at": "25/05/2026 12:21:18",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 12:21:18"
          },
          {
            "ticket_id": 19069,
            "ticket_number": "3519057",
            "title": "RESERVA LEPLAN LOCALIZADOR 604591064 - CONTACTO CL",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:16",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.55,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:18:12"
          },
          {
            "ticket_id": 19072,
            "ticket_number": "3519060",
            "title": "Pedido de esclarecimento",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:26",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 14:44:26"
          },
          {
            "ticket_id": 19073,
            "ticket_number": "3519061",
            "title": "Alteração de horário Maldivas - Divisão de Estadia",
            "priority": "P2",
            "created_at": "25/05/2026 14:44:30",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 3.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:51:29"
          },
          {
            "ticket_id": 19094,
            "ticket_number": "3519082",
            "title": "[Suporte] TRP-2026-05212 - Pedido Operador",
            "priority": "P2",
            "created_at": "25/05/2026 15:08:49",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:08:49"
          },
          {
            "ticket_id": 19096,
            "ticket_number": "3519084",
            "title": "[Suporte] TRP-2026-04828 - Passaporte",
            "priority": "P2",
            "created_at": "25/05/2026 15:24:16",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 15:24:17"
          },
          {
            "ticket_id": 19106,
            "ticket_number": "3519094",
            "title": "A38516502 - IMPORTANTE - Civitatis -  Ingresso da ",
            "priority": "P2",
            "created_at": "25/05/2026 16:01:51",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:21:01"
          },
          {
            "ticket_id": 19107,
            "ticket_number": "3519095",
            "title": "Reserva Atividade %s alterada: Ingresso da Torre E",
            "priority": "P2",
            "created_at": "25/05/2026 16:01:53",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:18:29"
          },
          {
            "ticket_id": 19110,
            "ticket_number": "3519098",
            "title": "Reserva Atividade %s alterada: Ingresso da Torre E",
            "priority": "P2",
            "created_at": "25/05/2026 16:02:01",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:19:50"
          },
          {
            "ticket_id": 19111,
            "ticket_number": "3519099",
            "title": "A37598623 - IMPORTANTE - Civitatis -  Ingresso da ",
            "priority": "P2",
            "created_at": "25/05/2026 16:02:03",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 1.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:20:30"
          },
          {
            "ticket_id": 19113,
            "ticket_number": "3519101",
            "title": "Confirmação de reserva 345890 ###### BILHETES EMIT",
            "priority": "P2",
            "created_at": "25/05/2026 16:02:07",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 16:02:35"
          },
          {
            "ticket_id": 19115,
            "ticket_number": "3519103",
            "title": "[Suporte] TRP-2026-05203 / TRL-2026-08056 - CANCEL",
            "priority": "P2",
            "created_at": "25/05/2026 16:09:59",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:09:59"
          },
          {
            "ticket_id": 19116,
            "ticket_number": "3519104",
            "title": "[Cancelamento Serviço] TRP-2026-05203 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/05/2026 16:36:29",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 16:36:29"
          },
          {
            "ticket_id": 19118,
            "ticket_number": "3519106",
            "title": "Importante - Checkin Online Voos TAP - FILE 333975",
            "priority": "P2",
            "created_at": "25/05/2026 16:49:34",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 17:10:27"
          },
          {
            "ticket_id": 19129,
            "ticket_number": "3519117",
            "title": "Aumento Fuel OPO DBB OPO - 22JUN * File 421441",
            "priority": "P2",
            "created_at": "25/05/2026 18:09:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:55:35"
          },
          {
            "ticket_id": 19174,
            "ticket_number": "3519162",
            "title": "PEDIDO DE INFORMAÇÃO",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:00:33"
          },
          {
            "ticket_id": 19183,
            "ticket_number": "3519171",
            "title": "Reserva Zanzibar Soltropico",
            "priority": "P2",
            "created_at": "26/05/2026 10:07:26",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:07:27"
          },
          {
            "ticket_id": 19197,
            "ticket_number": "3519185",
            "title": "Bilhetes Magic Shuttle 604490259",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:10",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:48:34"
          },
          {
            "ticket_id": 19206,
            "ticket_number": "3519194",
            "title": "Urgente - Passageiros",
            "priority": "P2",
            "created_at": "26/05/2026 11:32:35",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.15,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:42:31"
          },
          {
            "ticket_id": 19209,
            "ticket_number": "3519197",
            "title": "Saídas de 25/06/2026 para 30/07/2026 - DADOS OBRIG",
            "priority": "P2",
            "created_at": "26/05/2026 11:33:12",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:15:05"
          },
          {
            "ticket_id": 19210,
            "ticket_number": "3519198",
            "title": "Contatos de Cliente em falta - n/File 414136",
            "priority": "P2",
            "created_at": "26/05/2026 11:33:31",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:44:15"
          },
          {
            "ticket_id": 19211,
            "ticket_number": "3519199",
            "title": "Importante - Checkin Online Voos TAP - FILE 344365",
            "priority": "P2",
            "created_at": "26/05/2026 11:33:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 11:52:44"
          },
          {
            "ticket_id": 19215,
            "ticket_number": "3519203",
            "title": "Fwd: easyJet número de referência da reserva: KCHK",
            "priority": "P2",
            "created_at": "26/05/2026 11:55:23",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.2,
            "sla_met": false,
            "sla_breach_hours": 2.2,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:08:00"
          },
          {
            "ticket_id": 19216,
            "ticket_number": "3519204",
            "title": "Fwd: easyJet número de referência da reserva: KCHK",
            "priority": "P2",
            "created_at": "26/05/2026 11:55:26",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 6.2,
            "sla_met": false,
            "sla_breach_hours": 2.2,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:08:12"
          },
          {
            "ticket_id": 19219,
            "ticket_number": "3519207",
            "title": "Pedido de logins Tour10 e Asalgarve",
            "priority": "P2",
            "created_at": "26/05/2026 12:01:42",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:01:42"
          },
          {
            "ticket_id": 19222,
            "ticket_number": "3519210",
            "title": "RESERVA NOVA DE VÔO COM O LOC. ZTEP3U",
            "priority": "P2",
            "created_at": "26/05/2026 12:32:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:32:41"
          },
          {
            "ticket_id": 19223,
            "ticket_number": "3519211",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "26/05/2026 12:32:43",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:56:59"
          },
          {
            "ticket_id": 19224,
            "ticket_number": "3519212",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "26/05/2026 12:32:45",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.4,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 12:57:27"
          },
          {
            "ticket_id": 19247,
            "ticket_number": "3519235",
            "title": "MARTA OLIVEIRA RD MAIO",
            "priority": "P2",
            "created_at": "26/05/2026 14:30:33",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:05:18"
          },
          {
            "ticket_id": 19258,
            "ticket_number": "3519246",
            "title": "MUITO URGENTE Alteração de Horário - File 336122",
            "priority": "P2",
            "created_at": "26/05/2026 14:31:05",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:59:58"
          },
          {
            "ticket_id": 19259,
            "ticket_number": "3519247",
            "title": "Documentação da reserva TTN-1258661886#102978533#T",
            "priority": "P2",
            "created_at": "26/05/2026 14:31:12",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 2.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:16:23"
          },
          {
            "ticket_id": 19260,
            "ticket_number": "3519248",
            "title": "Documentação da reserva TTN-1253313250#102979226#T",
            "priority": "P2",
            "created_at": "26/05/2026 14:31:14",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:47:54"
          },
          {
            "ticket_id": 19270,
            "ticket_number": "3519258",
            "title": "reserva SMY: 1284512001",
            "priority": "P2",
            "created_at": "26/05/2026 15:31:51",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 15:31:51"
          },
          {
            "ticket_id": 19281,
            "ticket_number": "3519269",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "26/05/2026 15:56:56",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:44:08"
          },
          {
            "ticket_id": 19284,
            "ticket_number": "3519272",
            "title": "Confirmação de Reserva * File 442209 - EMISSÃO 29/",
            "priority": "P2",
            "created_at": "26/05/2026 16:11:35",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 16:36:37"
          },
          {
            "ticket_id": 19289,
            "ticket_number": "3519277",
            "title": "Check in online",
            "priority": "P2",
            "created_at": "26/05/2026 17:32:13",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:32:13"
          },
          {
            "ticket_id": 19299,
            "ticket_number": "3519287",
            "title": "CANCELAMENTO TOUR 10 LOC 4207571",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:49",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:19:49"
          },
          {
            "ticket_id": 19301,
            "ticket_number": "3519289",
            "title": "CANCELAMENTO VIAGEM - TOUR10 LOC 4138397",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:55",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:19:55"
          },
          {
            "ticket_id": 19305,
            "ticket_number": "3519293",
            "title": "GBN-124375 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "26/05/2026 18:23:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:42:31"
          },
          {
            "ticket_id": 19307,
            "ticket_number": "3519295",
            "title": "Passaportes Clientes Viajartours loc 216014",
            "priority": "P2",
            "created_at": "26/05/2026 18:27:13",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:27:13"
          },
          {
            "ticket_id": 19314,
            "ticket_number": "3519302",
            "title": "RESERVA DE VÔO COM ANIMAIS LOC. ZTEP3U OPERADOR - ",
            "priority": "P2",
            "created_at": "26/05/2026 20:02:29",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/05/2026 16:54:15"
          },
          {
            "ticket_id": 19414,
            "ticket_number": "3519402",
            "title": "Informações da reserva TTN-1267609701#103062471#T2",
            "priority": "P2",
            "created_at": "27/05/2026 14:57:18",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:23:25"
          },
          {
            "ticket_id": 19415,
            "ticket_number": "3519403",
            "title": "Acompanhamento do procedimento TTN-1267609701#1031",
            "priority": "P2",
            "created_at": "27/05/2026 14:57:22",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:08:39"
          },
          {
            "ticket_id": 19424,
            "ticket_number": "3519412",
            "title": "CANCELAMENTO DE RESERVA",
            "priority": "P2",
            "created_at": "27/05/2026 15:21:13",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 15:21:14"
          },
          {
            "ticket_id": 19429,
            "ticket_number": "3519417",
            "title": "XQY84H – Vendor Locator da companhia",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:34",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 18:14:51"
          },
          {
            "ticket_id": 19450,
            "ticket_number": "3519438",
            "title": "Adicionar Animais XTIZVH",
            "priority": "P2",
            "created_at": "27/05/2026 17:14:03",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 17:14:38"
          },
          {
            "ticket_id": 19498,
            "ticket_number": "3519486",
            "title": "Pedido de Contacto Movel - 332542 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:33",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:56:42"
          },
          {
            "ticket_id": 19510,
            "ticket_number": "3519498",
            "title": "NOTIFICACION RESERVA 6147443",
            "priority": "P2",
            "created_at": "28/05/2026 11:21:51",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:52:24"
          },
          {
            "ticket_id": 19512,
            "ticket_number": "3519500",
            "title": "NOTIFICACION RESERVA 6147436",
            "priority": "P2",
            "created_at": "28/05/2026 11:21:54",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.53,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:54:02"
          },
          {
            "ticket_id": 19513,
            "ticket_number": "3519501",
            "title": "NOTIFICACION RESERVA 6147441",
            "priority": "P2",
            "created_at": "28/05/2026 11:21:57",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.5,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:52:54"
          },
          {
            "ticket_id": 19514,
            "ticket_number": "3519502",
            "title": "NOTIFICACION RESERVA 6142145",
            "priority": "P2",
            "created_at": "28/05/2026 11:21:59",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:57:23"
          },
          {
            "ticket_id": 19519,
            "ticket_number": "3519507",
            "title": "NOTIFICACION RESERVA 6148483",
            "priority": "P2",
            "created_at": "28/05/2026 11:25:51",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:57:49"
          },
          {
            "ticket_id": 19520,
            "ticket_number": "3519508",
            "title": "NOTIFICACION RESERVA 6148484",
            "priority": "P2",
            "created_at": "28/05/2026 11:25:53",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.57,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:00:04"
          },
          {
            "ticket_id": 19521,
            "ticket_number": "3519509",
            "title": "NOTIFICACION RESERVA 6148481",
            "priority": "P2",
            "created_at": "28/05/2026 11:25:55",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:53:24"
          },
          {
            "ticket_id": 19522,
            "ticket_number": "3519510",
            "title": "Re:[## 41564 ##] GBN-124275 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "28/05/2026 11:25:58",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 21:42:07"
          },
          {
            "ticket_id": 19523,
            "ticket_number": "3519511",
            "title": "NOTIFICACION RESERVA 6146302",
            "priority": "P2",
            "created_at": "28/05/2026 11:26:01",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:54:36"
          },
          {
            "ticket_id": 19524,
            "ticket_number": "3519512",
            "title": "NOTIFICACION RESERVA 6142205",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:22",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:59:05"
          },
          {
            "ticket_id": 19525,
            "ticket_number": "3519513",
            "title": "NOTIFICACION RESERVA 6137228",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:24",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.32,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:58:30"
          },
          {
            "ticket_id": 19526,
            "ticket_number": "3519514",
            "title": "NOTIFICACION RESERVA 6131346",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:25",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:56:49"
          },
          {
            "ticket_id": 19527,
            "ticket_number": "3519515",
            "title": "NOTIFICACION RESERVA 6137918",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:27",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:55:05"
          },
          {
            "ticket_id": 19528,
            "ticket_number": "3519516",
            "title": "NOTIFICACION RESERVA 6132816",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:28",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:55:34"
          },
          {
            "ticket_id": 19529,
            "ticket_number": "3519517",
            "title": "NOTIFICACION RESERVA 6131347",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:30",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:56:08"
          },
          {
            "ticket_id": 19530,
            "ticket_number": "3519518",
            "title": "NOTIFICACION RESERVA 6142207",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:32",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 11:59:36"
          },
          {
            "ticket_id": 19531,
            "ticket_number": "3519519",
            "title": "NOTIFICACION RESERVA 6142210",
            "priority": "P2",
            "created_at": "28/05/2026 11:39:33",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 12:00:31"
          },
          {
            "ticket_id": 19564,
            "ticket_number": "3519552",
            "title": "Pedido de Contacto Movel - 341073 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 13:02:19",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 13:08:40"
          },
          {
            "ticket_id": 19568,
            "ticket_number": "3519556",
            "title": "Aéreo - Confirmação de Emissão (FONSECA\\LUCIANA DU",
            "priority": "P2",
            "created_at": "28/05/2026 14:35:31",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 14:35:29"
          },
          {
            "ticket_id": 19577,
            "ticket_number": "3519565",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:45",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:15:46"
          },
          {
            "ticket_id": 19579,
            "ticket_number": "3519567",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "28/05/2026 16:15:49",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:15:49"
          },
          {
            "ticket_id": 19592,
            "ticket_number": "3519580",
            "title": "Pedido de confirmacão dos detalhes do alojamento",
            "priority": "P2",
            "created_at": "28/05/2026 16:17:25",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:17:26"
          },
          {
            "ticket_id": 19594,
            "ticket_number": "3519582",
            "title": "GBN-111482 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/05/2026 16:17:29",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:13"
          },
          {
            "ticket_id": 19595,
            "ticket_number": "3519583",
            "title": "[Suporte] TRP-2026-04247 / TRL-2026-06433 - Greve ",
            "priority": "P2",
            "created_at": "28/05/2026 16:20:08",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 16:20:08"
          },
          {
            "ticket_id": 19634,
            "ticket_number": "3519622",
            "title": "URGENTE - RESERVA FEITA HOJE",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:21",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 10:25:21"
          },
          {
            "ticket_id": 19637,
            "ticket_number": "3519625",
            "title": "Fw: 11043479 RICARDO REIS",
            "priority": "P2",
            "created_at": "29/05/2026 10:25:33",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/03/2026 22:41:26"
          },
          {
            "ticket_id": 19658,
            "ticket_number": "3519646",
            "title": "REMINDER: Dados de Passaporte - nosso File 424637",
            "priority": "P2",
            "created_at": "29/05/2026 11:41:19",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:31:16"
          },
          {
            "ticket_id": 19663,
            "ticket_number": "3519651",
            "title": "Acessos",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:08",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:09"
          },
          {
            "ticket_id": 19670,
            "ticket_number": "3519658",
            "title": "REEMBOLSO DE VALOR",
            "priority": "P2",
            "created_at": "29/05/2026 12:17:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 12:17:42"
          },
          {
            "ticket_id": 19682,
            "ticket_number": "3519670",
            "title": "[Cancelamento Serviço] TRP-2026-05297 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 13:51:10",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 13:51:10"
          },
          {
            "ticket_id": 19685,
            "ticket_number": "3519673",
            "title": "Pagamento pendente",
            "priority": "P2",
            "created_at": "29/05/2026 14:09:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:09:58"
          },
          {
            "ticket_id": 19687,
            "ticket_number": "3519675",
            "title": "CANCELAMENTO DE RESERVA",
            "priority": "P2",
            "created_at": "29/05/2026 14:10:02",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 14:10:02"
          },
          {
            "ticket_id": 19742,
            "ticket_number": "3519730",
            "title": "GBN-111580 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/05/2026 18:10:59",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 18:56:45"
          },
          {
            "ticket_id": 19743,
            "ticket_number": "3519731",
            "title": "GBN-126233 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "29/05/2026 18:11:01",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 18:58:03"
          },
          {
            "ticket_id": 19851,
            "ticket_number": "3519839",
            "title": "[Suporte] TRP-2026-03181 / TRL-2026-04895 - Pagame",
            "priority": "P2",
            "created_at": "31/05/2026 23:47:06",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/05/2026 23:47:06"
          },
          {
            "ticket_id": 19991,
            "ticket_number": "3519979",
            "title": "Urgente - Cookpit TRP-2026-04922 - Salu",
            "priority": "P2",
            "created_at": "01/06/2026 17:22:06",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:22:06"
          },
          {
            "ticket_id": 20052,
            "ticket_number": "3520040",
            "title": "TRP-2026-05320",
            "priority": "P2",
            "created_at": "02/06/2026 09:09:05",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 09:09:05"
          },
          {
            "ticket_id": 20065,
            "ticket_number": "3520053",
            "title": "Solicitação de upgrade de quarto - Reserva Solféri",
            "priority": "P2",
            "created_at": "02/06/2026 10:11:51",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 10:11:52"
          },
          {
            "ticket_id": 20088,
            "ticket_number": "3520076",
            "title": "Notificação do aumento do preço dos Combustíveis -",
            "priority": "P2",
            "created_at": "02/06/2026 12:07:53",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.33,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:27:57"
          },
          {
            "ticket_id": 20089,
            "ticket_number": "3520077",
            "title": "Taxa aeroportuária – Reservas 604485940 e 60448593",
            "priority": "P2",
            "created_at": "02/06/2026 12:47:20",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 24.72,
            "sla_met": false,
            "sla_breach_hours": 20.72,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 13:31:13"
          },
          {
            "ticket_id": 20098,
            "ticket_number": "3520086",
            "title": "Assunto: Comunicação Importante: Bilhete de Identi",
            "priority": "P2",
            "created_at": "02/06/2026 12:49:42",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:44:45"
          },
          {
            "ticket_id": 20108,
            "ticket_number": "3520096",
            "title": "Reserva NB 6138555 - jantar de aniversário",
            "priority": "P2",
            "created_at": "02/06/2026 12:50:25",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 12:50:26"
          },
          {
            "ticket_id": 20119,
            "ticket_number": "3520107",
            "title": "Fwd: ***INFORMAÇÕES IMPORTANTES SOBRE SEU VOO O7KT",
            "priority": "P2",
            "created_at": "02/06/2026 15:40:02",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 15:40:03"
          },
          {
            "ticket_id": 20122,
            "ticket_number": "3520110",
            "title": "Informação importante sobre a tua reserva 6130007",
            "priority": "P2",
            "created_at": "02/06/2026 16:29:36",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 16:52:32"
          },
          {
            "ticket_id": 20144,
            "ticket_number": "3520132",
            "title": "Re:[## 42434 ##] GBN-111700 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "02/06/2026 17:38:53",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:38:53"
          },
          {
            "ticket_id": 20170,
            "ticket_number": "3520158",
            "title": "Informações da reserva TTN-1240982218#103624646#T2",
            "priority": "P2",
            "created_at": "02/06/2026 21:52:45",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 11:02:51"
          },
          {
            "ticket_id": 20182,
            "ticket_number": "3520170",
            "title": "Alteração de data de nascimento",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:13",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 21:53:14"
          },
          {
            "ticket_id": 20193,
            "ticket_number": "3520181",
            "title": "Pedido de contacto e informações sobre alojamento ",
            "priority": "P2",
            "created_at": "02/06/2026 22:28:51",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 22:28:51"
          },
          {
            "ticket_id": 20215,
            "ticket_number": "3520203",
            "title": "GBN-125720 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "03/06/2026 09:56:51",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 1.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 11:38:17"
          },
          {
            "ticket_id": 20258,
            "ticket_number": "3520246",
            "title": "Informação importante: Partida 05 de Junho - Alter",
            "priority": "P2",
            "created_at": "03/06/2026 13:53:22",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 14:23:13"
          },
          {
            "ticket_id": 20259,
            "ticket_number": "3520247",
            "title": "CORREÇÃO NOME PASSAGEIRO - LOCALIZADOR NEWBLUE: 61",
            "priority": "P2",
            "created_at": "03/06/2026 14:34:27",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 14:34:27"
          },
          {
            "ticket_id": 20288,
            "ticket_number": "3520276",
            "title": "GBN-122993 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "03/06/2026 17:39:55",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:39:58"
          },
          {
            "ticket_id": 20292,
            "ticket_number": "3520280",
            "title": "Re:[## 42612 ##] GBN-122993 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "03/06/2026 17:49:03",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 17:52:46"
          },
          {
            "ticket_id": 20651,
            "ticket_number": "3520639",
            "title": "Confirmaciones a Agencia. Agencia UMA FAMILIA EM V",
            "priority": "P2",
            "created_at": "08/06/2026 09:37:46",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 09:40:14"
          }
        ]
      },
      "Marta Oliveira": {
        "total_tickets": 11,
        "sla_met": 8,
        "sla_missed": 3,
        "sla_compliance_rate": 72.73,
        "tickets": [
          {
            "ticket_id": 868,
            "ticket_number": "35867",
            "title": "Fwd: Informações da reserva TTN#83556823#T15004666",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "17/10/2025 14:24:49",
            "close_date": "2025-12-31",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "10/10/2025 14:02:33"
          },
          {
            "ticket_id": 2747,
            "ticket_number": "352742",
            "title": "Pedido de Orçamento Grupo Soltropico - Sal",
            "priority": "P2",
            "created_at": "19/11/2025 00:04:01",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/11/2025 00:04:01"
          },
          {
            "ticket_id": 2814,
            "ticket_number": "352809",
            "title": "GBN-90771 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "19/11/2025 18:10:40",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 0.27,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/11/2025 18:27:16"
          },
          {
            "ticket_id": 2907,
            "ticket_number": "352902",
            "title": "Reserva WL 333952",
            "priority": "P2",
            "created_at": "20/11/2025 19:29:53",
            "close_date": "2025-12-31",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/11/2025 21:17:51"
          },
          {
            "ticket_id": 2995,
            "ticket_number": "352990",
            "title": "Confirmacao 334252",
            "priority": "P2",
            "created_at": "21/11/2025 21:36:06",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 1.63,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/11/2025 23:14:31"
          },
          {
            "ticket_id": 3000,
            "ticket_number": "352995",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604497323",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "21/11/2025 22:08:53",
            "close_date": "2026-01-09",
            "sla_target_hours": 24,
            "actual_time_hours": 49.95,
            "sla_met": false,
            "sla_breach_hours": 25.95,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:06:25"
          },
          {
            "ticket_id": 3006,
            "ticket_number": "353001",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P2",
            "created_at": "22/11/2025 00:02:19",
            "close_date": "2025-12-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/11/2025 00:14:11"
          },
          {
            "ticket_id": 3026,
            "ticket_number": "353021",
            "title": "GBN-91302 - Your booking confirmation",
            "priority": "Reservas sem pedido RGPD e CVO",
            "created_at": "22/11/2025 20:02:57",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 28.18,
            "sla_met": false,
            "sla_breach_hours": 4.18,
            "sla_name": "SLA Padrão",
            "first_response_at": "24/11/2025 00:14:54"
          },
          {
            "ticket_id": 3032,
            "ticket_number": "353027",
            "title": "Número de informação da reserva: 6122238",
            "priority": "P3",
            "created_at": "22/11/2025 21:10:14",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 27.08,
            "sla_met": false,
            "sla_breach_hours": 3.08,
            "sla_name": "SLA P3",
            "first_response_at": "24/11/2025 00:15:40"
          },
          {
            "ticket_id": 3049,
            "ticket_number": "353042",
            "title": "GBN Travel: Information about your booking - GBN-9",
            "priority": "P3",
            "created_at": "23/11/2025 19:01:38",
            "close_date": "2025-12-22",
            "sla_target_hours": 24,
            "actual_time_hours": 4.17,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "23/11/2025 23:12:35"
          },
          {
            "ticket_id": 4604,
            "ticket_number": "354596",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR   604513226",
            "priority": "Reservas sem Formulário",
            "created_at": "18/12/2025 22:39:15",
            "close_date": "2025-12-26",
            "sla_target_hours": 24,
            "actual_time_hours": 1.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA Padrão",
            "first_response_at": "19/12/2025 00:11:06"
          }
        ]
      },
      "Margarida Janeiro": {
        "total_tickets": 504,
        "sla_met": 469,
        "sla_missed": 35,
        "sla_compliance_rate": 93.06,
        "tickets": [
          {
            "ticket_id": 4411,
            "ticket_number": "354403",
            "title": "Petición CnTravel 15002556",
            "priority": "P2",
            "created_at": "15/12/2025 12:07:35",
            "close_date": "2026-02-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/12/2025 13:03:21"
          },
          {
            "ticket_id": 5942,
            "ticket_number": "355934",
            "title": "Pedido orçamento Lua de Mel - Mexico e Bayahibe",
            "priority": "P3",
            "created_at": "14/01/2026 19:10:16",
            "close_date": "2026-03-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "14/01/2026 19:10:16"
          },
          {
            "ticket_id": 6146,
            "ticket_number": "356138",
            "title": "Grupo Marrakech",
            "priority": "P2",
            "created_at": "16/01/2026 10:14:54",
            "close_date": "2026-01-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/01/2026 10:13:39"
          },
          {
            "ticket_id": 6409,
            "ticket_number": "356401",
            "title": "GBN-99626 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "19/01/2026 10:11:28",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/01/2026 14:00:59"
          },
          {
            "ticket_id": 6651,
            "ticket_number": "356643",
            "title": "Pedido de orçamentos de grupo",
            "priority": "P2",
            "created_at": "20/01/2026 19:11:17",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/01/2026 19:11:17"
          },
          {
            "ticket_id": 8451,
            "ticket_number": "358443",
            "title": "Fwd: Viagify informa-te do teu orçamento 124491991",
            "priority": "P2",
            "created_at": "05/02/2026 17:55:47",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/02/2026 17:55:48"
          },
          {
            "ticket_id": 8718,
            "ticket_number": "358710",
            "title": "Pedido de ajuda new blue",
            "priority": "P3",
            "created_at": "09/02/2026 10:47:31",
            "close_date": "2026-03-12",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/02/2026 10:47:31"
          },
          {
            "ticket_id": 9271,
            "ticket_number": "359263",
            "title": "GBN-87150 - Tempestade Kristin",
            "priority": "P2",
            "created_at": "13/02/2026 19:20:01",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/02/2026 19:20:01"
          },
          {
            "ticket_id": 9877,
            "ticket_number": "359865",
            "title": "[Pedido de Grupo] Djerba - 2026-08-29 a 2026-09-05",
            "priority": "P2",
            "created_at": "20/02/2026 12:18:36",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 11.62,
            "sla_met": false,
            "sla_breach_hours": 7.62,
            "sla_name": "SLA P2",
            "first_response_at": "20/02/2026 23:56:30"
          },
          {
            "ticket_id": 9929,
            "ticket_number": "359917",
            "title": "Cancelamento GBN-89702",
            "priority": "P3",
            "created_at": "20/02/2026 18:12:18",
            "close_date": "2026-03-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "20/02/2026 18:12:18"
          },
          {
            "ticket_id": 10535,
            "ticket_number": "3510523",
            "title": "[Pedido de Grupo] Barcelona - Toulouse - Lourdes -",
            "priority": "P3",
            "created_at": "26/02/2026 17:24:19",
            "close_date": "2026-04-22",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "26/02/2026 17:24:20"
          },
          {
            "ticket_id": 11262,
            "ticket_number": "3511250",
            "title": "Orçamento grupo direto hotel",
            "priority": "P3",
            "created_at": "03/03/2026 19:48:56",
            "close_date": "2026-03-10",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "03/03/2026 19:48:57"
          },
          {
            "ticket_id": 11265,
            "ticket_number": "3511253",
            "title": "Alteração de dia de Operação - OPO/DSS/OPO - Impor",
            "priority": "P2",
            "created_at": "03/03/2026 19:49:03",
            "close_date": "2026-03-03",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/03/2026 22:18:20"
          },
          {
            "ticket_id": 11442,
            "ticket_number": "3511430",
            "title": "[Pedido de Grupo] Ilha do Sal -  Melia Dunas Beach",
            "priority": "P3",
            "created_at": "04/03/2026 19:14:51",
            "close_date": "2026-03-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "04/03/2026 19:14:51"
          },
          {
            "ticket_id": 11450,
            "ticket_number": "3511438",
            "title": "Alteração na reserva Newblue 1778654",
            "priority": "P2",
            "created_at": "04/03/2026 21:39:42",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/03/2026 21:39:42"
          },
          {
            "ticket_id": 11538,
            "ticket_number": "3511526",
            "title": "Proposta Solférias 19552/2026 FILE 425077 valores ",
            "priority": "P2",
            "created_at": "05/03/2026 16:02:59",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/03/2026 21:43:12"
          },
          {
            "ticket_id": 11703,
            "ticket_number": "3511691",
            "title": "NEWBLUE: 6125558 - COMPLETAR E CORRIGIR INFORMAÇÃO",
            "priority": "P2",
            "created_at": "06/03/2026 19:02:19",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 19:02:20"
          },
          {
            "ticket_id": 11718,
            "ticket_number": "3511706",
            "title": "Pedido orçamento Viagem de Grupo Cabo Verde Ilha d",
            "priority": "P3",
            "created_at": "06/03/2026 19:46:23",
            "close_date": "2026-03-11",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "06/03/2026 19:46:23"
          },
          {
            "ticket_id": 11728,
            "ticket_number": "3511716",
            "title": "Reserva GBN-75942",
            "priority": "P2",
            "created_at": "06/03/2026 20:51:24",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 20:51:25"
          },
          {
            "ticket_id": 11735,
            "ticket_number": "3511723",
            "title": "[Suporte] TRP-2026-03634 / TRL-2026-05535 - Pedir ",
            "priority": "P2",
            "created_at": "06/03/2026 21:30:33",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/03/2026 21:30:33"
          },
          {
            "ticket_id": 11841,
            "ticket_number": "3511829",
            "title": "Orçamento Tempo _questao para o operador",
            "priority": "P3",
            "created_at": "09/03/2026 10:04:38",
            "close_date": "2026-03-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 10:04:38"
          },
          {
            "ticket_id": 11858,
            "ticket_number": "3511846",
            "title": "Orçamento Newblue - Hotel Sol Milanos Pinguinos 21",
            "priority": "P2",
            "created_at": "09/03/2026 10:05:20",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 10:05:21"
          },
          {
            "ticket_id": 11884,
            "ticket_number": "3511872",
            "title": "Datos de Pasajeros de la Reserva en el expediente ",
            "priority": "P2",
            "created_at": "09/03/2026 10:07:35",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 14:03:44"
          },
          {
            "ticket_id": 11937,
            "ticket_number": "3511925",
            "title": "[Pedido de Grupo] Madeira- Dom Pedro Garajau - 202",
            "priority": "P3",
            "created_at": "09/03/2026 12:18:03",
            "close_date": "2026-04-18",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 12:18:03"
          },
          {
            "ticket_id": 11967,
            "ticket_number": "3511955",
            "title": "URGENTE – Confirmação política de idade | SBH Moni",
            "priority": "P2",
            "created_at": "09/03/2026 15:37:21",
            "close_date": "2026-03-09",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/03/2026 15:37:21"
          },
          {
            "ticket_id": 11971,
            "ticket_number": "3511959",
            "title": "Orçamento Benidorm",
            "priority": "P3",
            "created_at": "09/03/2026 15:51:05",
            "close_date": "2026-03-09",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 15:51:05"
          },
          {
            "ticket_id": 11992,
            "ticket_number": "3511980",
            "title": "[Pedido de Grupo] Riviera Maya / Republica Dominic",
            "priority": "P3",
            "created_at": "09/03/2026 19:56:50",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 19:56:50"
          },
          {
            "ticket_id": 11993,
            "ticket_number": "3511981",
            "title": "Enviar email à Solférias - Adição quarto - Process",
            "priority": "P3",
            "created_at": "09/03/2026 20:22:55",
            "close_date": "2026-03-19",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "09/03/2026 20:22:55"
          },
          {
            "ticket_id": 12036,
            "ticket_number": "3512024",
            "title": "pedido de ajuda junto da travelplan orçamento baya",
            "priority": "P2",
            "created_at": "10/03/2026 10:21:20",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 10:21:21"
          },
          {
            "ticket_id": 12078,
            "ticket_number": "3512066",
            "title": "Soltour: Cancelamento de reserva: SPT002601603925",
            "priority": "P2",
            "created_at": "10/03/2026 15:50:04",
            "close_date": "2026-03-10",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 19:42:40"
          },
          {
            "ticket_id": 12092,
            "ticket_number": "3512080",
            "title": "Fwd: Informações sobre o seu caso TTN-1222039695#9",
            "priority": "P2",
            "created_at": "10/03/2026 17:16:50",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 16:30:08"
          },
          {
            "ticket_id": 12126,
            "ticket_number": "3512114",
            "title": "Confirmação dos servicos da reserva GBN-111122",
            "priority": "P2",
            "created_at": "10/03/2026 22:48:24",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 22:48:25"
          },
          {
            "ticket_id": 12133,
            "ticket_number": "3512121",
            "title": "[Suporte] TRP-2026-04109 / TRL-2026-06254 - Comfir",
            "priority": "P2",
            "created_at": "10/03/2026 23:33:57",
            "close_date": "2026-04-17",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:33:58"
          },
          {
            "ticket_id": 12136,
            "ticket_number": "3512124",
            "title": "RGPD + CVO",
            "priority": "P2",
            "created_at": "10/03/2026 23:45:29",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:45:29"
          },
          {
            "ticket_id": 12137,
            "ticket_number": "3512125",
            "title": "RGPD + CVO",
            "priority": "P2",
            "created_at": "10/03/2026 23:45:31",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:45:31"
          },
          {
            "ticket_id": 12229,
            "ticket_number": "3512217",
            "title": "Grp. 870658 || Régua Douro || 01/05 a 02/05",
            "priority": "P2",
            "created_at": "11/03/2026 16:49:17",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 17:16:41"
          },
          {
            "ticket_id": 12230,
            "ticket_number": "3512218",
            "title": "codigo disney 604541477",
            "priority": "P2",
            "created_at": "11/03/2026 16:55:48",
            "close_date": "2026-03-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 16:55:48"
          },
          {
            "ticket_id": 12277,
            "ticket_number": "3512265",
            "title": "dados dos passageiros GBN-81725",
            "priority": "P2",
            "created_at": "11/03/2026 21:48:39",
            "close_date": "2026-03-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 21:48:39"
          },
          {
            "ticket_id": 12310,
            "ticket_number": "3512298",
            "title": "orçamento para Safari Quénia e Zanzibar",
            "priority": "P2",
            "created_at": "11/03/2026 23:12:46",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:12:46"
          },
          {
            "ticket_id": 12317,
            "ticket_number": "3512305",
            "title": "[Cancelamento Serviço] TRP-2026-03634 / TRL-2026-0",
            "priority": "P2",
            "created_at": "11/03/2026 23:41:14",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/03/2026 23:41:15"
          },
          {
            "ticket_id": 12339,
            "ticket_number": "3512327",
            "title": "Confirmação com o Operador",
            "priority": "P2",
            "created_at": "12/03/2026 11:29:55",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 11:29:55"
          },
          {
            "ticket_id": 12348,
            "ticket_number": "3512336",
            "title": "[Pedido de Grupo] RÉGUA - 2026-07-10 a 2026-07-11 ",
            "priority": "P3",
            "created_at": "12/03/2026 11:36:05",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/03/2026 11:36:05"
          },
          {
            "ticket_id": 12362,
            "ticket_number": "3512350",
            "title": "TRP-2026-03951",
            "priority": "P2",
            "created_at": "12/03/2026 13:58:39",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 13:58:40"
          },
          {
            "ticket_id": 12365,
            "ticket_number": "3512353",
            "title": "[Cockpit] Viagem TRP-2026-04169 - Carabela Ana Car",
            "priority": "P2",
            "created_at": "12/03/2026 14:04:40",
            "close_date": "2026-03-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 14:04:41"
          },
          {
            "ticket_id": 12375,
            "ticket_number": "3512363",
            "title": "Flexibleauto - Dúvida",
            "priority": "P2",
            "created_at": "12/03/2026 15:33:32",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/03/2026 15:33:33"
          },
          {
            "ticket_id": 12443,
            "ticket_number": "3512431",
            "title": "Pedido de cotação direta",
            "priority": "P2",
            "created_at": "12/03/2026 23:11:51",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 16.1,
            "sla_met": false,
            "sla_breach_hours": 12.1,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 15:18:06"
          },
          {
            "ticket_id": 12491,
            "ticket_number": "3512479",
            "title": "Orçamento +1 noite Hotel - Operador Tour10",
            "priority": "P2",
            "created_at": "13/03/2026 15:07:23",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 15:07:23"
          },
          {
            "ticket_id": 12506,
            "ticket_number": "3512494",
            "title": "AGENCIA UMA FAMILIA EM VIAGEM, LDA APROBADA - LIVV",
            "priority": "P2",
            "created_at": "13/03/2026 16:25:05",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/03/2026 23:45:35"
          },
          {
            "ticket_id": 12525,
            "ticket_number": "3512513",
            "title": "Información de su solicitud de Grupos",
            "priority": "P3",
            "created_at": "13/03/2026 17:45:57",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "12/03/2026 16:05:05"
          },
          {
            "ticket_id": 12554,
            "ticket_number": "3512542",
            "title": "[Suporte] TRP-2026-02921 - Rent a Car Go Car",
            "priority": "P2",
            "created_at": "13/03/2026 23:06:40",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/03/2026 23:06:41"
          },
          {
            "ticket_id": 12572,
            "ticket_number": "3512560",
            "title": "Ajuda com reserva Leplan 604591064",
            "priority": "P2",
            "created_at": "14/03/2026 10:16:57",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/03/2026 10:16:57"
          },
          {
            "ticket_id": 12627,
            "ticket_number": "3512615",
            "title": "Contatos de Cliente em falta - n/File 432870",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:33",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.38,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 12:29:41"
          },
          {
            "ticket_id": 12629,
            "ticket_number": "3512617",
            "title": "REMINDER: Dados de Passaporte - nosso File 423949",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:37",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 12:44:22"
          },
          {
            "ticket_id": 12635,
            "ticket_number": "3512623",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "16/03/2026 10:06:51",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 3.18,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 13:17:56"
          },
          {
            "ticket_id": 12639,
            "ticket_number": "3512627",
            "title": "pedido de confirmação de hotel em wl catalonia bay",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:02",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:02"
          },
          {
            "ticket_id": 12645,
            "ticket_number": "3512633",
            "title": "Soltour | Esclarecimento de seguro adicional para ",
            "priority": "P2",
            "created_at": "16/03/2026 10:07:14",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 10:07:15"
          },
          {
            "ticket_id": 12732,
            "ticket_number": "3512720",
            "title": "Pedido de cotalão moun10 urlaubswohnen URGENTE",
            "priority": "P2",
            "created_at": "16/03/2026 14:06:50",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 14:06:52"
          },
          {
            "ticket_id": 12759,
            "ticket_number": "3512747",
            "title": "[Pedido de Grupo] Menorca - 2026-07-24 a 2026-07-3",
            "priority": "P3",
            "created_at": "16/03/2026 16:28:33",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "16/03/2026 16:28:34"
          },
          {
            "ticket_id": 12772,
            "ticket_number": "3512760",
            "title": "[Pedido de Grupo] Barcelo Isla Canela - 2026-04-30",
            "priority": "P2",
            "created_at": "16/03/2026 17:53:22",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 17:53:23"
          },
          {
            "ticket_id": 12785,
            "ticket_number": "3512773",
            "title": "[Suporte] TRP-2026-03313 / TRL-2026-05098 - reeemc",
            "priority": "P2",
            "created_at": "16/03/2026 19:49:32",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 19:49:33"
          },
          {
            "ticket_id": 12807,
            "ticket_number": "3512795",
            "title": "GBN-112715 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:01",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:55:59"
          },
          {
            "ticket_id": 12808,
            "ticket_number": "3512796",
            "title": "GBN-112613 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:03",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:56:06"
          },
          {
            "ticket_id": 12809,
            "ticket_number": "3512797",
            "title": "GBN-112292 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "16/03/2026 23:43:05",
            "close_date": "2026-03-16",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/03/2026 23:56:12"
          },
          {
            "ticket_id": 12856,
            "ticket_number": "3512844",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "P2",
            "created_at": "17/03/2026 12:35:43",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 15:27:51"
          },
          {
            "ticket_id": 12859,
            "ticket_number": "3512847",
            "title": "Reserva confirmada: Transfer entre o aeroporto de ",
            "priority": "P2",
            "created_at": "17/03/2026 12:35:55",
            "close_date": "2026-03-17",
            "sla_target_hours": 4,
            "actual_time_hours": 2.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 15:28:14"
          },
          {
            "ticket_id": 12862,
            "ticket_number": "3512850",
            "title": "Pedido de inclusão em reserva",
            "priority": "P2",
            "created_at": "17/03/2026 13:04:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 13:04:24"
          },
          {
            "ticket_id": 12869,
            "ticket_number": "3512857",
            "title": "Reserva da Soltrópico 342760 em WL",
            "priority": "P2",
            "created_at": "17/03/2026 14:50:38",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 14:50:39"
          },
          {
            "ticket_id": 12880,
            "ticket_number": "3512868",
            "title": "GBN-67038 - Esclarecimento",
            "priority": "P2",
            "created_at": "17/03/2026 16:13:54",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 16:13:54"
          },
          {
            "ticket_id": 12910,
            "ticket_number": "3512898",
            "title": "File 435734/26*reserva erro",
            "priority": "P1",
            "created_at": "17/03/2026 18:28:48",
            "close_date": "2026-04-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "17/03/2026 18:43:23"
          },
          {
            "ticket_id": 12916,
            "ticket_number": "3512904",
            "title": "GBN-109961 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "17/03/2026 19:15:06",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 22:56:53"
          },
          {
            "ticket_id": 12924,
            "ticket_number": "3512912",
            "title": "Pedido cotação | Hotel Morabeza, Ilha do Sal | 2 A",
            "priority": "P2",
            "created_at": "17/03/2026 22:04:41",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 22:04:41"
          },
          {
            "ticket_id": 12927,
            "ticket_number": "3512915",
            "title": "Confirmação NewBlue Oasis Belorizonte",
            "priority": "P2",
            "created_at": "17/03/2026 23:34:56",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 23:34:56"
          },
          {
            "ticket_id": 12929,
            "ticket_number": "3512917",
            "title": "viagem com localizador SPT002601597683",
            "priority": "P2",
            "created_at": "17/03/2026 23:35:03",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 23:35:04"
          },
          {
            "ticket_id": 12996,
            "ticket_number": "3512984",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:04",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:43:44"
          },
          {
            "ticket_id": 12998,
            "ticket_number": "3512986",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:12",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:44:24"
          },
          {
            "ticket_id": 12999,
            "ticket_number": "3512987",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:14",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:45:03"
          },
          {
            "ticket_id": 13000,
            "ticket_number": "3512988",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:18",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:45:12"
          },
          {
            "ticket_id": 13003,
            "ticket_number": "3512991",
            "title": "Confirmação de reserva para For PT004157 70796907",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:28",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:45:18"
          },
          {
            "ticket_id": 13006,
            "ticket_number": "3512994",
            "title": "LOC 4126460 AVISO SOBRE ALTERAÇÃO DO LOCALIZADOR, ",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:43",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:42:09"
          },
          {
            "ticket_id": 13008,
            "ticket_number": "3512996",
            "title": "Confirmation of booking with locator0HMNEQIK",
            "priority": "P2",
            "created_at": "18/03/2026 15:02:48",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.7,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 18:45:36"
          },
          {
            "ticket_id": 13013,
            "ticket_number": "3513001",
            "title": "GBN-113247 - Sua confirmação de reserva",
            "priority": "P2",
            "created_at": "18/03/2026 15:54:45",
            "close_date": "2026-03-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/03/2026 15:54:45"
          },
          {
            "ticket_id": 13041,
            "ticket_number": "3513029",
            "title": "Re:[## 35101 ##] GBN-98330 - Um cliente enviou uma",
            "priority": "P2",
            "created_at": "18/03/2026 19:06:31",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/03/2026 13:27:22"
          },
          {
            "ticket_id": 13137,
            "ticket_number": "3513125",
            "title": "MSC - reserva de excursões",
            "priority": "P2",
            "created_at": "19/03/2026 16:24:51",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 16:24:52"
          },
          {
            "ticket_id": 13146,
            "ticket_number": "3513134",
            "title": "Rsv. cruzeiro - Confirmação Procº 1050306/2026",
            "priority": "P2",
            "created_at": "19/03/2026 17:07:47",
            "close_date": "2026-03-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:23:23"
          },
          {
            "ticket_id": 13160,
            "ticket_number": "3513148",
            "title": "Processo 419153 / 2025 SOLFERIAS - DADOS CLIENTE",
            "priority": "P2",
            "created_at": "19/03/2026 18:02:44",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 18:02:44"
          },
          {
            "ticket_id": 13170,
            "ticket_number": "3513158",
            "title": "Pedido cotação grupo direta",
            "priority": "P3",
            "created_at": "19/03/2026 19:09:04",
            "close_date": "2026-04-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "19/03/2026 19:09:04"
          },
          {
            "ticket_id": 13173,
            "ticket_number": "3513161",
            "title": "Reserva 604596751 - Travelplan - Susana Passos",
            "priority": "P2",
            "created_at": "19/03/2026 19:09:24",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 19:09:24"
          },
          {
            "ticket_id": 13174,
            "ticket_number": "3513162",
            "title": "[Cancelamento Viagem] TRP-2026-04402 - Anthony da ",
            "priority": "P2",
            "created_at": "19/03/2026 19:43:00",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/03/2026 19:43:00"
          },
          {
            "ticket_id": 13252,
            "ticket_number": "3513240",
            "title": "CORREÇÃO NOME PASSAGEIRO - RESERVA NEWBLUE ES: 178",
            "priority": "P2",
            "created_at": "20/03/2026 18:40:01",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 18:40:01"
          },
          {
            "ticket_id": 13267,
            "ticket_number": "3513255",
            "title": "Alteração numa reserva SPT002601611072",
            "priority": "P2",
            "created_at": "20/03/2026 20:21:00",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 20:21:00"
          },
          {
            "ticket_id": 13273,
            "ticket_number": "3513261",
            "title": "Confirmação de Reserva * File 435734",
            "priority": "P2",
            "created_at": "20/03/2026 21:08:02",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:10:54"
          },
          {
            "ticket_id": 13274,
            "ticket_number": "3513262",
            "title": "[Cancelamento Serviço] TRP-2026-04423 / TRL-2026-0",
            "priority": "P2",
            "created_at": "20/03/2026 21:15:39",
            "close_date": "2026-03-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 21:15:39"
          },
          {
            "ticket_id": 13283,
            "ticket_number": "3513271",
            "title": "Información sobre el check-in: 12YMS3JE4L",
            "priority": "P2",
            "created_at": "20/03/2026 22:57:37",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.13,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/03/2026 23:06:07"
          },
          {
            "ticket_id": 13308,
            "ticket_number": "3513296",
            "title": "GBN-92529 - Seu pedido foi recebido",
            "priority": "P3",
            "created_at": "21/03/2026 12:31:30",
            "close_date": "2026-06-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "21/03/2026 09:58:20"
          },
          {
            "ticket_id": 13313,
            "ticket_number": "3513301",
            "title": "[Cancelamento Serviço] TRP-2026-03162 / TRL-2026-0",
            "priority": "P2",
            "created_at": "22/03/2026 12:25:53",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/03/2026 12:25:53"
          },
          {
            "ticket_id": 13315,
            "ticket_number": "3513303",
            "title": "[Cancelamento Viagem] TRP-2026-03464 - SANDRA PERE",
            "priority": "P2",
            "created_at": "22/03/2026 21:31:52",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/03/2026 21:31:52"
          },
          {
            "ticket_id": 13316,
            "ticket_number": "3513304",
            "title": "[Cancelamento Viagem] TRP-2026-04448 - Tania Sofia",
            "priority": "P2",
            "created_at": "22/03/2026 22:37:14",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/03/2026 22:37:14"
          },
          {
            "ticket_id": 13340,
            "ticket_number": "3513328",
            "title": "Alteração da data de validade do passaporte",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:20",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:11:20"
          },
          {
            "ticket_id": 13346,
            "ticket_number": "3513334",
            "title": "GBN-114122 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/03/2026 10:11:37",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:25:42"
          },
          {
            "ticket_id": 13378,
            "ticket_number": "3513366",
            "title": "pedido de contratação direta",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:01",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:14:02"
          },
          {
            "ticket_id": 13381,
            "ticket_number": "3513369",
            "title": "GBN-114083 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:06",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:13:45"
          },
          {
            "ticket_id": 13385,
            "ticket_number": "3513373",
            "title": "Solférias- 424171 - João Dias",
            "priority": "P2",
            "created_at": "23/03/2026 10:14:15",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:14:15"
          },
          {
            "ticket_id": 13391,
            "ticket_number": "3513379",
            "title": "[Suporte] TRP-2026-02884 / TRL-2026-04450 - Comiss",
            "priority": "P2",
            "created_at": "23/03/2026 11:02:09",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:02:09"
          },
          {
            "ticket_id": 13397,
            "ticket_number": "3513385",
            "title": "[Cancelamento Viagem] TRP-2026-04354 - Fernando  M",
            "priority": "P2",
            "created_at": "23/03/2026 13:27:40",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:27:40"
          },
          {
            "ticket_id": 13433,
            "ticket_number": "3513421",
            "title": "GBN-106401 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/03/2026 15:33:22",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 15:04:48"
          },
          {
            "ticket_id": 13440,
            "ticket_number": "3513428",
            "title": "Pedido de Contratação direta",
            "priority": "P2",
            "created_at": "23/03/2026 17:54:30",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 17:54:31"
          },
          {
            "ticket_id": 13442,
            "ticket_number": "3513430",
            "title": "[Cancelamento Serviço] TRP-2026-03648 / TRL-2026-0",
            "priority": "P2",
            "created_at": "23/03/2026 18:00:28",
            "close_date": "2026-03-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 18:00:28"
          },
          {
            "ticket_id": 13443,
            "ticket_number": "3513431",
            "title": "Re:[## 35690 ##] GBN-113956 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "23/03/2026 18:40:12",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 10:12:22"
          },
          {
            "ticket_id": 13449,
            "ticket_number": "3513437",
            "title": "GBN-103474 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "23/03/2026 20:21:34",
            "close_date": "2026-03-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 21:18:20"
          },
          {
            "ticket_id": 13454,
            "ticket_number": "3513442",
            "title": "Re:[## 35771 ##] GBN-103474 - Um cliente enviou um",
            "priority": "P1",
            "created_at": "23/03/2026 20:58:10",
            "close_date": "2026-04-23",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 21:04:40"
          },
          {
            "ticket_id": 13552,
            "ticket_number": "3513540",
            "title": "[Cancelamento Viagem] TRP-2026-04422 - Edbela Mont",
            "priority": "P2",
            "created_at": "24/03/2026 19:00:47",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 11:51:38"
          },
          {
            "ticket_id": 13558,
            "ticket_number": "3513546",
            "title": "[Suporte] TRP-2026-03289 / TRL-2026-05072 - Bilhet",
            "priority": "P2",
            "created_at": "24/03/2026 19:30:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 19:30:34"
          },
          {
            "ticket_id": 13560,
            "ticket_number": "3513548",
            "title": "[Cancelamento Serviço] TRP-2026-03606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "24/03/2026 20:48:08",
            "close_date": "2026-03-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 20:48:08"
          },
          {
            "ticket_id": 13565,
            "ticket_number": "3513553",
            "title": "Reserva pessoal Travelplan",
            "priority": "P2",
            "created_at": "24/03/2026 22:29:29",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 22:29:29"
          },
          {
            "ticket_id": 13568,
            "ticket_number": "3513556",
            "title": "[Suporte] TRP-2026-03316 / TRL-2026-05101 - Pedido",
            "priority": "P2",
            "created_at": "24/03/2026 23:21:14",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/03/2026 23:21:15"
          },
          {
            "ticket_id": 13605,
            "ticket_number": "3513593",
            "title": "[Pedido de Grupo] Hotel S. Bento da Porta Aberta, ",
            "priority": "P3",
            "created_at": "25/03/2026 13:40:00",
            "close_date": "2026-04-01",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "25/03/2026 13:40:00"
          },
          {
            "ticket_id": 13611,
            "ticket_number": "3513599",
            "title": "[Suporte] TRP-2026-03941 - Alteração valores e Loc",
            "priority": "P2",
            "created_at": "25/03/2026 14:45:55",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 14:45:55"
          },
          {
            "ticket_id": 13634,
            "ticket_number": "3513622",
            "title": "GBN-114903 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "25/03/2026 17:45:59",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:15:44"
          },
          {
            "ticket_id": 13635,
            "ticket_number": "3513623",
            "title": "Rimain Tours | Pedido cotação Tours",
            "priority": "P2",
            "created_at": "25/03/2026 17:46:01",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 17:46:01"
          },
          {
            "ticket_id": 13653,
            "ticket_number": "3513641",
            "title": "[Suporte] TRP-2026-04062 - Upgrade de um dos quart",
            "priority": "P2",
            "created_at": "25/03/2026 19:51:23",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 19:51:23"
          },
          {
            "ticket_id": 13655,
            "ticket_number": "3513643",
            "title": "Pedido de cotação | Apartamento com 3 ou 4 quartos",
            "priority": "P2",
            "created_at": "25/03/2026 20:38:03",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:38:03"
          },
          {
            "ticket_id": 13657,
            "ticket_number": "3513645",
            "title": "Activity %s canceled: Free tour pelo centro histór",
            "priority": "P2",
            "created_at": "25/03/2026 20:38:06",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:38:06"
          },
          {
            "ticket_id": 13658,
            "ticket_number": "3513646",
            "title": "Informar operador  6 reservas que passageiros viaj",
            "priority": "P2",
            "created_at": "25/03/2026 20:38:08",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 20:38:09"
          },
          {
            "ticket_id": 13660,
            "ticket_number": "3513648",
            "title": "[Suporte] TRP-2026-04346 - Correção dados CVO",
            "priority": "P2",
            "created_at": "25/03/2026 21:11:02",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 21:11:03"
          },
          {
            "ticket_id": 13665,
            "ticket_number": "3513653",
            "title": "[Suporte] TRP-2026-03953 / TRL-2026-05987 - Altera",
            "priority": "P2",
            "created_at": "25/03/2026 22:30:00",
            "close_date": "2026-03-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/03/2026 22:30:00"
          },
          {
            "ticket_id": 13686,
            "ticket_number": "3513674",
            "title": "RE: Pedido de Cotação Direta",
            "priority": "P2",
            "created_at": "26/03/2026 10:04:34",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.62,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 12:42:20"
          },
          {
            "ticket_id": 13719,
            "ticket_number": "3513707",
            "title": "GBN Travel: Reenvio de confirmação de reserva - GB",
            "priority": "P2",
            "created_at": "26/03/2026 16:18:37",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/03/2026 13:55:14"
          },
          {
            "ticket_id": 13726,
            "ticket_number": "3513714",
            "title": "Soltropico 340915",
            "priority": "P2",
            "created_at": "26/03/2026 18:47:31",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 18:47:31"
          },
          {
            "ticket_id": 13748,
            "ticket_number": "3513736",
            "title": "[Cancelamento Viagem] TRP-2026-03976 - Pedro Jose ",
            "priority": "P2",
            "created_at": "26/03/2026 22:48:55",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 22:48:55"
          },
          {
            "ticket_id": 13750,
            "ticket_number": "3513738",
            "title": "Pedido de Orçamento de Grupo",
            "priority": "P2",
            "created_at": "26/03/2026 23:15:37",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/03/2026 23:15:38"
          },
          {
            "ticket_id": 13760,
            "ticket_number": "3513748",
            "title": "Pedido de reserva a hotel - Fwd: Longroiva Hotel R",
            "priority": "P2",
            "created_at": "27/03/2026 00:05:13",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 00:05:14"
          },
          {
            "ticket_id": 13798,
            "ticket_number": "3513786",
            "title": "Acessos planski",
            "priority": "P2",
            "created_at": "27/03/2026 15:18:08",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 15:18:09"
          },
          {
            "ticket_id": 13802,
            "ticket_number": "3513790",
            "title": "Re:[## 32148 ##] GBN-87150 - Seu pedido foi recebi",
            "priority": "P2",
            "created_at": "27/03/2026 16:23:18",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.65,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 19:02:26"
          },
          {
            "ticket_id": 13809,
            "ticket_number": "3513797",
            "title": "[Suporte] TRP-2026-04516 - Erro ortografico nome d",
            "priority": "P2",
            "created_at": "27/03/2026 16:37:41",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 16:37:42"
          },
          {
            "ticket_id": 13816,
            "ticket_number": "3513804",
            "title": "[Cancelamento Viagem] TRP-2026-03753 - Pedro  Amar",
            "priority": "P2",
            "created_at": "27/03/2026 17:55:36",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 17:55:36"
          },
          {
            "ticket_id": 13820,
            "ticket_number": "3513808",
            "title": "Re:[## 32777 ##] GBN-107408 - Seu pedido foi receb",
            "priority": "P2",
            "created_at": "27/03/2026 18:16:44",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 2.73,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:01:05"
          },
          {
            "ticket_id": 13825,
            "ticket_number": "3513813",
            "title": "[Suporte] TRP-2026-04474 - Pagamento",
            "priority": "P2",
            "created_at": "27/03/2026 19:11:46",
            "close_date": "2026-03-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 19:11:47"
          },
          {
            "ticket_id": 13827,
            "ticket_number": "3513815",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "27/03/2026 20:02:00",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:48:41"
          },
          {
            "ticket_id": 13829,
            "ticket_number": "3513817",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "27/03/2026 20:02:05",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:49:26"
          },
          {
            "ticket_id": 13830,
            "ticket_number": "3513818",
            "title": "Uma Familia em Viagem informa-te do teu orçamento ",
            "priority": "P2",
            "created_at": "27/03/2026 20:02:09",
            "close_date": "2026-03-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 21:50:05"
          },
          {
            "ticket_id": 13843,
            "ticket_number": "3513831",
            "title": "GBN-115564 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "27/03/2026 22:43:39",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 517.93,
            "sla_met": false,
            "sla_breach_hours": 513.93,
            "sla_name": "SLA P2",
            "first_response_at": "18/04/2026 12:40:35"
          },
          {
            "ticket_id": 13848,
            "ticket_number": "3513836",
            "title": "GBN-114903 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "27/03/2026 23:17:59",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 23:19:26"
          },
          {
            "ticket_id": 13964,
            "ticket_number": "3513952",
            "title": "Re:[## 35101 ##] GBN-98330 - Um cliente enviou uma",
            "priority": "P2",
            "created_at": "30/03/2026 10:41:00",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 27.4,
            "sla_met": false,
            "sla_breach_hours": 23.4,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 14:05:57"
          },
          {
            "ticket_id": 13978,
            "ticket_number": "3513966",
            "title": "Reserva TRP-2026-04534 - hotel Veneza",
            "priority": "P2",
            "created_at": "30/03/2026 13:09:10",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:09:10"
          },
          {
            "ticket_id": 13989,
            "ticket_number": "3513977",
            "title": "acesso ASA Algarve",
            "priority": "P2",
            "created_at": "30/03/2026 13:15:27",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 13:15:27"
          },
          {
            "ticket_id": 13999,
            "ticket_number": "3513987",
            "title": "[Suporte] TRP-2026-04332 - Dados passageiros",
            "priority": "P2",
            "created_at": "30/03/2026 15:20:06",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 15:20:06"
          },
          {
            "ticket_id": 14019,
            "ticket_number": "3514007",
            "title": "Pedido de cancelamento de viagem",
            "priority": "P2",
            "created_at": "30/03/2026 19:40:31",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 19:40:31"
          },
          {
            "ticket_id": 14029,
            "ticket_number": "3514017",
            "title": "[Cancelamento Serviço] TRP-2026-02869 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/03/2026 21:15:46",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:15:46"
          },
          {
            "ticket_id": 14030,
            "ticket_number": "3514018",
            "title": "[Cancelamento Serviço] TRP-2026-02869 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/03/2026 21:16:20",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:16:20"
          },
          {
            "ticket_id": 14031,
            "ticket_number": "3514019",
            "title": "[Cancelamento Serviço] TRP-2026-02869 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/03/2026 21:16:48",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:16:49"
          },
          {
            "ticket_id": 14032,
            "ticket_number": "3514020",
            "title": "[Cancelamento Serviço] TRP-2026-02869 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/03/2026 21:17:23",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:17:24"
          },
          {
            "ticket_id": 14034,
            "ticket_number": "3514022",
            "title": "Re: URGENTE - NOCA RESERVA SOLFÉRIAS - VAI ENTRAR ",
            "priority": "P2",
            "created_at": "30/03/2026 21:44:46",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 21:44:46"
          },
          {
            "ticket_id": 14046,
            "ticket_number": "3514034",
            "title": "Pedido de Cotação: Alteração de Nomes / Redução de",
            "priority": "P2",
            "created_at": "30/03/2026 22:43:52",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 22:43:52"
          },
          {
            "ticket_id": 14080,
            "ticket_number": "3514068",
            "title": "[Suporte] TRP-2026-04529 / TRL-2026-06857 - Altera",
            "priority": "P2",
            "created_at": "31/03/2026 11:42:50",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 11:42:50"
          },
          {
            "ticket_id": 14108,
            "ticket_number": "3514096",
            "title": "[Pedido de Grupo] Navio MSC SINFONIA - MEDITERRÂNE",
            "priority": "P3",
            "created_at": "31/03/2026 15:40:20",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "31/03/2026 15:40:20"
          },
          {
            "ticket_id": 14114,
            "ticket_number": "3514102",
            "title": "GBN-115299 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "31/03/2026 16:15:02",
            "close_date": "2026-03-31",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 13:03:02"
          },
          {
            "ticket_id": 14122,
            "ticket_number": "3514110",
            "title": "Envio de Documentação Disney File 419933",
            "priority": "P2",
            "created_at": "31/03/2026 16:29:13",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 20:21:29"
          },
          {
            "ticket_id": 14128,
            "ticket_number": "3514116",
            "title": "Orçamento Djerba",
            "priority": "P2",
            "created_at": "31/03/2026 16:59:47",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "31/03/2026 16:59:48"
          },
          {
            "ticket_id": 14154,
            "ticket_number": "3514142",
            "title": "Confirmação de reserva – Ref PP180187, Sr. Celso F",
            "priority": "P2",
            "created_at": "31/03/2026 22:48:50",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 43.85,
            "sla_met": false,
            "sla_breach_hours": 39.85,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:40:35"
          },
          {
            "ticket_id": 14178,
            "ticket_number": "3514166",
            "title": "Re:[## 36550 ##] GBN-112218 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "01/04/2026 12:50:05",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/03/2026 17:02:37"
          },
          {
            "ticket_id": 14188,
            "ticket_number": "3514176",
            "title": "[Suporte] TRP-2026-04581 / TRL-2026-06958 - Retifi",
            "priority": "P2",
            "created_at": "01/04/2026 15:10:10",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 15:10:10"
          },
          {
            "ticket_id": 14199,
            "ticket_number": "3514187",
            "title": "Alteração de dia de Operação - OPO/DSS/OPO - Impor",
            "priority": "P2",
            "created_at": "01/04/2026 17:04:49",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 21:03:25"
          },
          {
            "ticket_id": 14200,
            "ticket_number": "3514188",
            "title": "Alteração de dia de Operação - OPO/DSS/OPO - Impor",
            "priority": "P2",
            "created_at": "01/04/2026 19:08:33",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 3.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 22:39:35"
          },
          {
            "ticket_id": 14210,
            "ticket_number": "3514198",
            "title": "Fwd: Foto de Isabel Chou e José Chou",
            "priority": "P2",
            "created_at": "01/04/2026 19:09:09",
            "close_date": "2026-04-01",
            "sla_target_hours": 4,
            "actual_time_hours": 1.37,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/04/2026 20:31:27"
          },
          {
            "ticket_id": 14216,
            "ticket_number": "3514204",
            "title": "[Pedido de Grupo] Ibiza - 2026-08-29 a 2026-09-05 ",
            "priority": "P3",
            "created_at": "01/04/2026 20:23:02",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "01/04/2026 20:23:02"
          },
          {
            "ticket_id": 14287,
            "ticket_number": "3514275",
            "title": "TRP-2026-03754",
            "priority": "P2",
            "created_at": "02/04/2026 18:11:35",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 18:11:36"
          },
          {
            "ticket_id": 14303,
            "ticket_number": "3514291",
            "title": "[Cancelamento Serviço] TRP-2026-03876 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/04/2026 19:38:21",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 19:38:21"
          },
          {
            "ticket_id": 14310,
            "ticket_number": "3514298",
            "title": "[Cancelamento Viagem] TRP-2026-04590 - Cristina Pe",
            "priority": "P2",
            "created_at": "02/04/2026 23:07:04",
            "close_date": "2026-04-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/04/2026 23:07:04"
          },
          {
            "ticket_id": 14359,
            "ticket_number": "3514347",
            "title": "Anulação de processo File 437711/26",
            "priority": "P2",
            "created_at": "06/04/2026 09:09:20",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/04/2026 23:43:09"
          },
          {
            "ticket_id": 14424,
            "ticket_number": "3514412",
            "title": "[Suporte] TRP-2026-02792 - Alteraçao de horarios d",
            "priority": "P2",
            "created_at": "06/04/2026 12:42:55",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 12:42:55"
          },
          {
            "ticket_id": 14436,
            "ticket_number": "3514424",
            "title": "[Cancelamento Serviço] TRP-2026-04564 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 15:41:49",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:41:49"
          },
          {
            "ticket_id": 14446,
            "ticket_number": "3514434",
            "title": "Acessos - Consolidador e Douro Acima",
            "priority": "P2",
            "created_at": "06/04/2026 15:56:28",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 15:56:28"
          },
          {
            "ticket_id": 14471,
            "ticket_number": "3514459",
            "title": "Fwd: Incidente de voo TTN-1261990228#98135549#T190",
            "priority": "P2",
            "created_at": "06/04/2026 18:42:05",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:42:05"
          },
          {
            "ticket_id": 14474,
            "ticket_number": "3514462",
            "title": "Cancelamento Saidia-Lisboa",
            "priority": "P2",
            "created_at": "06/04/2026 18:42:35",
            "close_date": "2026-04-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 18:42:35"
          },
          {
            "ticket_id": 14483,
            "ticket_number": "3514471",
            "title": "pedido orçamento Viajar Tours",
            "priority": "P2",
            "created_at": "06/04/2026 21:00:18",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:00:18"
          },
          {
            "ticket_id": 14487,
            "ticket_number": "3514475",
            "title": "[Cancelamento Serviço] TRP-2026-04606 / TRL-2026-0",
            "priority": "P2",
            "created_at": "06/04/2026 21:20:28",
            "close_date": "2026-04-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:20:28"
          },
          {
            "ticket_id": 14493,
            "ticket_number": "3514481",
            "title": "Reserva Jaydeth GBN 104514",
            "priority": "P2",
            "created_at": "06/04/2026 21:51:29",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 21:51:29"
          },
          {
            "ticket_id": 14510,
            "ticket_number": "3514498",
            "title": "Reserva Soltrópico Loc: 334047 - dúvida",
            "priority": "P2",
            "created_at": "07/04/2026 10:07:28",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 10:07:28"
          },
          {
            "ticket_id": 14523,
            "ticket_number": "3514511",
            "title": "GBN-86600 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/04/2026 11:38:34",
            "close_date": "2026-04-18",
            "sla_target_hours": 4,
            "actual_time_hours": 25.18,
            "sla_met": false,
            "sla_breach_hours": 21.18,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 12:50:33"
          },
          {
            "ticket_id": 14583,
            "ticket_number": "3514571",
            "title": "GBN-115936 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/04/2026 18:57:26",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 1.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/04/2026 20:12:01"
          },
          {
            "ticket_id": 14617,
            "ticket_number": "3514605",
            "title": "Civitatis - Excursão Cozumel",
            "priority": "P2",
            "created_at": "08/04/2026 09:07:43",
            "close_date": "2026-04-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 09:07:43"
          },
          {
            "ticket_id": 14648,
            "ticket_number": "3514636",
            "title": "Fwd: 1244634600 TTN-1244634600#98072443#T19066011¬",
            "priority": "P2",
            "created_at": "08/04/2026 14:00:59",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/04/2026 10:12:01"
          },
          {
            "ticket_id": 14700,
            "ticket_number": "3514688",
            "title": "[Pedido de Grupo] Funchal - 2026-09-18 a 2026-09-2",
            "priority": "P3",
            "created_at": "08/04/2026 23:26:58",
            "close_date": "2026-04-23",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/04/2026 23:26:58"
          },
          {
            "ticket_id": 14728,
            "ticket_number": "3514716",
            "title": "Viagem comboio Roma",
            "priority": "P2",
            "created_at": "09/04/2026 13:57:58",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 13:57:59"
          },
          {
            "ticket_id": 14734,
            "ticket_number": "3514722",
            "title": "Fwd: Consulta sobre o seu pedido TTN-1259316145#98",
            "priority": "P2",
            "created_at": "09/04/2026 15:22:07",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/03/2026 10:41:08"
          },
          {
            "ticket_id": 14743,
            "ticket_number": "3514731",
            "title": "PAGAMENTO NÃO RECEBIDO. A reserva com localizador ",
            "priority": "P2",
            "created_at": "09/04/2026 15:56:09",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 15:58:40"
          },
          {
            "ticket_id": 14778,
            "ticket_number": "3514766",
            "title": "[Cancelamento Viagem] TRP-2026-04334 - Adriana  Ba",
            "priority": "P2",
            "created_at": "09/04/2026 19:05:44",
            "close_date": "2026-04-10",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 19:05:44"
          },
          {
            "ticket_id": 14794,
            "ticket_number": "3514782",
            "title": "Re:[## 37284 ##] GBN-86600 - Um cliente enviou uma",
            "priority": "P2",
            "created_at": "09/04/2026 20:24:04",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.95,
            "sla_met": false,
            "sla_breach_hours": 9.95,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 10:21:23"
          },
          {
            "ticket_id": 14799,
            "ticket_number": "3514787",
            "title": "[Suporte] TRP-2026-04184 / TRL-2026-06329 - Solici",
            "priority": "P2",
            "created_at": "09/04/2026 21:42:39",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 21:42:39"
          },
          {
            "ticket_id": 14801,
            "ticket_number": "3514789",
            "title": "[Suporte] TRP-2026-03982 / TRL-2026-06024 - autori",
            "priority": "P2",
            "created_at": "09/04/2026 22:53:40",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/04/2026 22:53:40"
          },
          {
            "ticket_id": 14829,
            "ticket_number": "3514817",
            "title": "Re: Local exato do embarque Barcadouro",
            "priority": "P2",
            "created_at": "10/04/2026 13:15:15",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 13:15:15"
          },
          {
            "ticket_id": 14839,
            "ticket_number": "3514827",
            "title": "Transfer 11/04",
            "priority": "P2",
            "created_at": "10/04/2026 14:05:21",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 14:05:21"
          },
          {
            "ticket_id": 14875,
            "ticket_number": "3514863",
            "title": "[Cancelamento Serviço] TRP-2026-04687 / TRL-2026-0",
            "priority": "P2",
            "created_at": "10/04/2026 17:19:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 17:19:04"
          },
          {
            "ticket_id": 14883,
            "ticket_number": "3514871",
            "title": "[Pedido de Grupo] Riviera Maya, Allegro Playacar, ",
            "priority": "P3",
            "created_at": "10/04/2026 18:36:14",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/04/2026 18:36:14"
          },
          {
            "ticket_id": 14888,
            "ticket_number": "3514876",
            "title": "Documentação Disponível - Reserva 341653",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:38",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 2.67,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 22:25:58"
          },
          {
            "ticket_id": 14891,
            "ticket_number": "3514879",
            "title": "Re: Confirmação de Reserva",
            "priority": "P2",
            "created_at": "10/04/2026 19:45:47",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 19:45:47"
          },
          {
            "ticket_id": 14897,
            "ticket_number": "3514885",
            "title": "[Pedido de Grupo] Salou - 2026-09-01 a 2026-09-08 ",
            "priority": "P3",
            "created_at": "10/04/2026 20:09:16",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "10/04/2026 20:09:16"
          },
          {
            "ticket_id": 14898,
            "ticket_number": "3514886",
            "title": "[Suporte] TRP-2026-04607 - faturação",
            "priority": "P2",
            "created_at": "10/04/2026 20:14:07",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 20:14:07"
          },
          {
            "ticket_id": 14900,
            "ticket_number": "3514888",
            "title": "Re: [Cockpit] Viagem TRP-2026-04527 - RITA RIBEIRO",
            "priority": "P2",
            "created_at": "10/04/2026 21:25:13",
            "close_date": "2026-04-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 21:25:14"
          },
          {
            "ticket_id": 14905,
            "ticket_number": "3514893",
            "title": "Esclarecimento passaporte viagem Maceio Viajartour",
            "priority": "P2",
            "created_at": "10/04/2026 22:14:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 22:14:55"
          },
          {
            "ticket_id": 14922,
            "ticket_number": "3514910",
            "title": "Esclarecimento passaporte viagem Soltropico",
            "priority": "P1",
            "created_at": "11/04/2026 12:48:15",
            "close_date": "2026-05-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/04/2026 12:48:16"
          },
          {
            "ticket_id": 14940,
            "ticket_number": "3514928",
            "title": "[Cancelamento Serviço] TRP-2026-04682 / TRL-2026-0",
            "priority": "P2",
            "created_at": "11/04/2026 16:42:39",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/04/2026 11:02:54"
          },
          {
            "ticket_id": 14971,
            "ticket_number": "3514959",
            "title": "[Cancelamento Serviço] TRP-2026-04570 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/04/2026 11:19:06",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 11:19:07"
          },
          {
            "ticket_id": 14972,
            "ticket_number": "3514960",
            "title": "[Cancelamento Serviço] TRP-2026-04570 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/04/2026 11:20:02",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 11:20:02"
          },
          {
            "ticket_id": 14974,
            "ticket_number": "3514962",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/04/2026 17:59:55",
            "close_date": "2026-04-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 17:59:55"
          },
          {
            "ticket_id": 14978,
            "ticket_number": "3514966",
            "title": "[Cancelamento Viagem] TRP-2026-03708 - Rui Pinto -",
            "priority": "P2",
            "created_at": "12/04/2026 20:50:49",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/04/2026 20:50:49"
          },
          {
            "ticket_id": 14981,
            "ticket_number": "3514969",
            "title": "[Suporte] TRP-2026-02877 - Reserva Newblue - reser",
            "priority": "P2",
            "created_at": "13/04/2026 00:25:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 00:25:05"
          },
          {
            "ticket_id": 15027,
            "ticket_number": "3515015",
            "title": "Proposta Solférias  20001/2026",
            "priority": "P2",
            "created_at": "13/04/2026 10:11:12",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/04/2026 11:15:37"
          },
          {
            "ticket_id": 15086,
            "ticket_number": "3515074",
            "title": "Pedido de reserva na Soltropico - Maceio - viagem ",
            "priority": "P2",
            "created_at": "13/04/2026 18:44:53",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 18:44:53"
          },
          {
            "ticket_id": 15093,
            "ticket_number": "3515081",
            "title": "[Suporte] TRP-2026-02544 - Duvida",
            "priority": "P2",
            "created_at": "13/04/2026 20:14:05",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 20:14:06"
          },
          {
            "ticket_id": 15096,
            "ticket_number": "3515084",
            "title": "[Suporte] TRP-2026-03240 - Pagamento por Validar",
            "priority": "P2",
            "created_at": "13/04/2026 21:17:08",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 21:17:08"
          },
          {
            "ticket_id": 15109,
            "ticket_number": "3515097",
            "title": "Estado de reserva localizador 213587",
            "priority": "P2",
            "created_at": "13/04/2026 22:34:51",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 22:34:51"
          },
          {
            "ticket_id": 15110,
            "ticket_number": "3515098",
            "title": "[Cancelamento Serviço] TRP-2026-04716 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/04/2026 23:30:31",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 23:30:32"
          },
          {
            "ticket_id": 15112,
            "ticket_number": "3515100",
            "title": "[Cancelamento Serviço] TRP-2026-02577 / TRL-2026-0",
            "priority": "P2",
            "created_at": "14/04/2026 01:21:24",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 01:21:24"
          },
          {
            "ticket_id": 15117,
            "ticket_number": "3515105",
            "title": "acessos consolidador aereo",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:04",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 12:54:43"
          },
          {
            "ticket_id": 15127,
            "ticket_number": "3515115",
            "title": "TRP-2026-04730",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:27",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:28"
          },
          {
            "ticket_id": 15134,
            "ticket_number": "3515122",
            "title": "Pedido de Seguro LOC 604546339",
            "priority": "P2",
            "created_at": "14/04/2026 09:09:54",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 09:09:54"
          },
          {
            "ticket_id": 15136,
            "ticket_number": "3515124",
            "title": "[Cancelamento Viagem] TRP-2026-04105 - PAULA MORAI",
            "priority": "P2",
            "created_at": "14/04/2026 10:19:06",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:19:06"
          },
          {
            "ticket_id": 15137,
            "ticket_number": "3515125",
            "title": "Envio de documentação - FILE 434053",
            "priority": "P2",
            "created_at": "14/04/2026 10:30:46",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.43,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 10:57:02"
          },
          {
            "ticket_id": 15144,
            "ticket_number": "3515132",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604500738",
            "priority": "P2",
            "created_at": "14/04/2026 12:07:02",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:03:58"
          },
          {
            "ticket_id": 15146,
            "ticket_number": "3515134",
            "title": "[Cancelamento Viagem] TRP-2026-03461 - IDELMA RIBE",
            "priority": "P2",
            "created_at": "14/04/2026 13:04:00",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 13:04:00"
          },
          {
            "ticket_id": 15161,
            "ticket_number": "3515149",
            "title": "Re: Solicitação de Acesso ao Consolidador",
            "priority": "P2",
            "created_at": "14/04/2026 15:03:46",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 15:03:46"
          },
          {
            "ticket_id": 15167,
            "ticket_number": "3515155",
            "title": "[Suporte] TRP-2026-04379 / TRL-2026-06618 - Valida",
            "priority": "P2",
            "created_at": "14/04/2026 16:03:15",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:03:15"
          },
          {
            "ticket_id": 15168,
            "ticket_number": "3515156",
            "title": "Documentação Disponível - Reserva 341132",
            "priority": "P2",
            "created_at": "14/04/2026 16:06:45",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:50:21"
          },
          {
            "ticket_id": 15170,
            "ticket_number": "3515158",
            "title": "Documentação Disponível - Reserva 341510",
            "priority": "P2",
            "created_at": "14/04/2026 16:19:48",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.52,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 16:51:30"
          },
          {
            "ticket_id": 15186,
            "ticket_number": "3515174",
            "title": "Regresso antecipado",
            "priority": "P2",
            "created_at": "14/04/2026 17:36:56",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 17:36:56"
          },
          {
            "ticket_id": 15225,
            "ticket_number": "3515213",
            "title": "Dúvida Solférias",
            "priority": "P2",
            "created_at": "14/04/2026 22:27:09",
            "close_date": "2026-04-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 22:27:09"
          },
          {
            "ticket_id": 15228,
            "ticket_number": "3515216",
            "title": "[Cancelamento Viagem] TRP-2026-04460 - Lisete Sora",
            "priority": "P2",
            "created_at": "14/04/2026 22:44:19",
            "close_date": "2026-04-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/04/2026 22:44:19"
          },
          {
            "ticket_id": 15358,
            "ticket_number": "3515346",
            "title": "Informação sobre reserva Le Plan",
            "priority": "P2",
            "created_at": "16/04/2026 14:11:59",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/04/2026 14:11:59"
          },
          {
            "ticket_id": 15497,
            "ticket_number": "3515485",
            "title": "[Suporte] TRP-2026-04767 - Valores",
            "priority": "P2",
            "created_at": "17/04/2026 21:21:19",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "17/04/2026 21:21:19"
          },
          {
            "ticket_id": 15540,
            "ticket_number": "3515528",
            "title": "[Cancelamento Viagem] TRP-2026-03674 - Liliana Pin",
            "priority": "P2",
            "created_at": "19/04/2026 20:27:54",
            "close_date": "2026-04-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/04/2026 20:27:55"
          },
          {
            "ticket_id": 15551,
            "ticket_number": "3515539",
            "title": "Check-in/ check-out hotel Djerba",
            "priority": "P2",
            "created_at": "20/04/2026 09:06:41",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:06:42"
          },
          {
            "ticket_id": 15588,
            "ticket_number": "3515576",
            "title": "Alteração",
            "priority": "P2",
            "created_at": "20/04/2026 09:08:17",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 09:08:18"
          },
          {
            "ticket_id": 15668,
            "ticket_number": "3515656",
            "title": "Confirmação de Reserva File 438792/26",
            "priority": "P2",
            "created_at": "20/04/2026 16:05:18",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:35:00"
          },
          {
            "ticket_id": 15688,
            "ticket_number": "3515676",
            "title": "Luís Guedes - Voucher Mx - Septiembre 2026",
            "priority": "P2",
            "created_at": "20/04/2026 18:35:17",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 19:25:06"
          },
          {
            "ticket_id": 15698,
            "ticket_number": "3515686",
            "title": "[Suporte] TRP-2026-04625 - Confirmação pendente",
            "priority": "P2",
            "created_at": "20/04/2026 22:48:44",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "20/04/2026 22:48:44"
          },
          {
            "ticket_id": 15711,
            "ticket_number": "3515699",
            "title": "Nb 6145944",
            "priority": "P2",
            "created_at": "21/04/2026 09:03:20",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:20:51"
          },
          {
            "ticket_id": 15715,
            "ticket_number": "3515703",
            "title": "Viagem Catarina Dinis - LOC: 214773 Viajartours",
            "priority": "P2",
            "created_at": "21/04/2026 09:26:41",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 09:26:42"
          },
          {
            "ticket_id": 15723,
            "ticket_number": "3515711",
            "title": "[Pedido de Grupo] Valência - hotéis: hotel benetus",
            "priority": "P2",
            "created_at": "21/04/2026 11:16:45",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 11:16:45"
          },
          {
            "ticket_id": 15779,
            "ticket_number": "3515767",
            "title": "Documentos assinados em falta",
            "priority": "P2",
            "created_at": "21/04/2026 19:36:22",
            "close_date": "2026-04-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 19:36:22"
          },
          {
            "ticket_id": 15793,
            "ticket_number": "3515781",
            "title": "Alteração titular | Veturis",
            "priority": "P1",
            "created_at": "21/04/2026 22:57:43",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "21/04/2026 22:57:43"
          },
          {
            "ticket_id": 15797,
            "ticket_number": "3515785",
            "title": "GBN-119606 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "21/04/2026 22:57:52",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 20:33:25"
          },
          {
            "ticket_id": 15802,
            "ticket_number": "3515790",
            "title": "[Suporte] TRP-2026-03162 - Pagamento a mais",
            "priority": "P2",
            "created_at": "21/04/2026 22:59:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "21/04/2026 22:59:37"
          },
          {
            "ticket_id": 15806,
            "ticket_number": "3515794",
            "title": "questão cliente: SPT002601624165 Soltour",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:12",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:01:13"
          },
          {
            "ticket_id": 15809,
            "ticket_number": "3515797",
            "title": "Dados de Clientes - Soltour: SPT002601624165",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:19",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:01:19"
          },
          {
            "ticket_id": 15810,
            "ticket_number": "3515798",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "22/04/2026 09:01:21",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.47,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 10:29:39"
          },
          {
            "ticket_id": 15814,
            "ticket_number": "3515802",
            "title": "Pedido de esclarecimento GBN-94763",
            "priority": "P2",
            "created_at": "22/04/2026 09:24:12",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 09:24:12"
          },
          {
            "ticket_id": 15826,
            "ticket_number": "3515814",
            "title": "VOUCHER DA RESERVA 604522509",
            "priority": "P2",
            "created_at": "22/04/2026 10:57:43",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 11:22:57"
          },
          {
            "ticket_id": 15836,
            "ticket_number": "3515824",
            "title": "Pedidos - Le Plan 604518491",
            "priority": "P2",
            "created_at": "22/04/2026 12:21:52",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 12:21:53"
          },
          {
            "ticket_id": 15837,
            "ticket_number": "3515825",
            "title": "RESERVA LEPLAN LOCALIZADOR  604609011 - CONTACTO C",
            "priority": "P2",
            "created_at": "22/04/2026 12:21:54",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 12:24:05"
          },
          {
            "ticket_id": 15838,
            "ticket_number": "3515826",
            "title": "Documentação Disponível - Reserva 342550",
            "priority": "P2",
            "created_at": "22/04/2026 12:57:00",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 12:58:22"
          },
          {
            "ticket_id": 15853,
            "ticket_number": "3515841",
            "title": "Importante - Checkin Online Voos TAP - FILE 341138",
            "priority": "P2",
            "created_at": "22/04/2026 15:47:19",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:53:33"
          },
          {
            "ticket_id": 15854,
            "ticket_number": "3515842",
            "title": "Importante - Checkin Online Voos TAP - FILE 341132",
            "priority": "P2",
            "created_at": "22/04/2026 15:47:20",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 15:52:25"
          },
          {
            "ticket_id": 15882,
            "ticket_number": "3515870",
            "title": "GRUP-22209 Cotización GRUP-22181 - Grupo Sal - Mar",
            "priority": "P2",
            "created_at": "22/04/2026 18:03:19",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:08:19"
          },
          {
            "ticket_id": 15884,
            "ticket_number": "3515872",
            "title": "[Suporte] TRP-2026-02070 - Devolução valor reserva",
            "priority": "P2",
            "created_at": "22/04/2026 18:43:03",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 18:43:03"
          },
          {
            "ticket_id": 15887,
            "ticket_number": "3515875",
            "title": "Fatura - TRP-2026-02944",
            "priority": "P2",
            "created_at": "22/04/2026 19:03:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 19:03:38"
          },
          {
            "ticket_id": 15888,
            "ticket_number": "3515876",
            "title": "[Suporte] TRP-2026-02579 - Pedido de correção do V",
            "priority": "P2",
            "created_at": "22/04/2026 19:45:34",
            "close_date": "2026-04-22",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 19:45:35"
          },
          {
            "ticket_id": 15893,
            "ticket_number": "3515881",
            "title": "Taxas de cancelamento - LOC: 6126890 6126895 61270",
            "priority": "P2",
            "created_at": "22/04/2026 22:19:52",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 22:19:52"
          },
          {
            "ticket_id": 15910,
            "ticket_number": "3515898",
            "title": "[Cancelamento Viagem] TRP-2026-02669 - Eduarda Isa",
            "priority": "P2",
            "created_at": "22/04/2026 23:06:17",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/04/2026 23:06:17"
          },
          {
            "ticket_id": 15913,
            "ticket_number": "3515901",
            "title": "PEDIDO DE INFORMAÇÃO PARA CONFIRMAÇÃO E-SIM - File",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:18",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.3,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:27:11"
          },
          {
            "ticket_id": 15914,
            "ticket_number": "3515902",
            "title": "REMINDER: Dados de Passaporte - nosso File 438792",
            "priority": "P2",
            "created_at": "23/04/2026 09:08:19",
            "close_date": "2026-04-23",
            "sla_target_hours": 4,
            "actual_time_hours": 0.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 09:29:45"
          },
          {
            "ticket_id": 15937,
            "ticket_number": "3515925",
            "title": "processo 419153 / 2025- SOLFERIAS URGENTE",
            "priority": "P2",
            "created_at": "23/04/2026 11:59:15",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 11:59:16"
          },
          {
            "ticket_id": 15948,
            "ticket_number": "3515936",
            "title": "[Suporte] TRP-2026-02754 / TRL-2026-04238 - proces",
            "priority": "P2",
            "created_at": "23/04/2026 13:58:27",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 13:58:27"
          },
          {
            "ticket_id": 15971,
            "ticket_number": "3515959",
            "title": "File 427856/26 - VOOS UN - TURKISH AIRLINES * URGE",
            "priority": "P1",
            "created_at": "23/04/2026 16:45:28",
            "close_date": "2026-05-06",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/04/2026 16:48:13"
          },
          {
            "ticket_id": 15994,
            "ticket_number": "3515982",
            "title": "Pedido de esclarecimento – condições de cancelamen",
            "priority": "P2",
            "created_at": "23/04/2026 19:40:27",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 19:40:28"
          },
          {
            "ticket_id": 16093,
            "ticket_number": "3516081",
            "title": "Reembolso ao cliente - transferência indevida",
            "priority": "P2",
            "created_at": "24/04/2026 21:01:44",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:01:44"
          },
          {
            "ticket_id": 16100,
            "ticket_number": "3516088",
            "title": "[Suporte] TRP-2026-04873 - faltou contacto telefón",
            "priority": "P2",
            "created_at": "24/04/2026 21:28:51",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:28:51"
          },
          {
            "ticket_id": 16102,
            "ticket_number": "3516090",
            "title": "[Suporte] TRP-2026-04856 - Viagem de substituição",
            "priority": "P2",
            "created_at": "24/04/2026 21:55:31",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 21:55:31"
          },
          {
            "ticket_id": 16105,
            "ticket_number": "3516093",
            "title": "Re:[## 39377 ##] GBN-120575 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "24/04/2026 23:06:55",
            "close_date": "2026-04-24",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 23:09:32"
          },
          {
            "ticket_id": 16108,
            "ticket_number": "3516096",
            "title": "[Suporte] TRP-2026-03874 / TRL-2026-05893 - Erro s",
            "priority": "P2",
            "created_at": "25/04/2026 15:39:46",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/04/2026 15:39:46"
          },
          {
            "ticket_id": 16110,
            "ticket_number": "3516098",
            "title": "[Cancelamento Serviço] TRP-2026-04878 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/04/2026 18:35:37",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/04/2026 18:35:38"
          },
          {
            "ticket_id": 16111,
            "ticket_number": "3516099",
            "title": "[Cancelamento Serviço] TRP-2026-04878 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/04/2026 18:35:46",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/04/2026 18:35:46"
          },
          {
            "ticket_id": 16112,
            "ticket_number": "3516100",
            "title": "[Cancelamento Serviço] TRP-2026-04878 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/04/2026 18:50:06",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/04/2026 18:50:06"
          },
          {
            "ticket_id": 16114,
            "ticket_number": "3516102",
            "title": "[Suporte] TRP-2026-04883 / TRL-2026-07506 - Possib",
            "priority": "P2",
            "created_at": "26/04/2026 21:43:51",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/04/2026 21:43:51"
          },
          {
            "ticket_id": 16118,
            "ticket_number": "3516106",
            "title": "Contatos de Cliente em falta - n/File 425983",
            "priority": "P2",
            "created_at": "27/04/2026 09:08:46",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:14:05"
          },
          {
            "ticket_id": 16145,
            "ticket_number": "3516133",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "27/04/2026 09:11:24",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:16:12"
          },
          {
            "ticket_id": 16157,
            "ticket_number": "3516145",
            "title": "Fwd: Os seus cartões de embarque estão prontos!🎉",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:21",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:22"
          },
          {
            "ticket_id": 16162,
            "ticket_number": "3516150",
            "title": "Dúvidas: cancelamento de voos + cancelamento de re",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:38",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 09:13:39"
          },
          {
            "ticket_id": 16168,
            "ticket_number": "3516156",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "27/04/2026 09:13:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 1.07,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:18:27"
          },
          {
            "ticket_id": 16185,
            "ticket_number": "3516173",
            "title": "Fwd: Informações da reserva TTN-1273678002#1000718",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:39",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:39"
          },
          {
            "ticket_id": 16188,
            "ticket_number": "3516176",
            "title": "Fwd: Informações da reserva TTN-1273679729#1000712",
            "priority": "P2",
            "created_at": "27/04/2026 10:04:45",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 10:04:45"
          },
          {
            "ticket_id": 16233,
            "ticket_number": "3516221",
            "title": "Pedido de informação a Tour 10",
            "priority": "P2",
            "created_at": "27/04/2026 14:39:50",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 14:39:50"
          },
          {
            "ticket_id": 16237,
            "ticket_number": "3516225",
            "title": "Reserva LePlan - 604623197 | Dúvidas urgentes",
            "priority": "P2",
            "created_at": "27/04/2026 15:33:28",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 15:33:28"
          },
          {
            "ticket_id": 16238,
            "ticket_number": "3516226",
            "title": "[Suporte] TRP-2026-04896 - Esclarecimento clientes",
            "priority": "P2",
            "created_at": "27/04/2026 15:45:10",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 15:45:10"
          },
          {
            "ticket_id": 16248,
            "ticket_number": "3516236",
            "title": "[Cancelamento Viagem] TRP-2026-04883 - RICARDO FIL",
            "priority": "P2",
            "created_at": "27/04/2026 17:16:59",
            "close_date": "2026-04-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 17:16:59"
          },
          {
            "ticket_id": 16272,
            "ticket_number": "3516260",
            "title": "Berço no quarto",
            "priority": "P2",
            "created_at": "27/04/2026 19:10:43",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 19:10:43"
          },
          {
            "ticket_id": 16284,
            "ticket_number": "3516272",
            "title": "[Pedido de Grupo] ILHA DO SAL - 2026-10-19 a 2026-",
            "priority": "P3",
            "created_at": "27/04/2026 21:44:59",
            "close_date": "2026-05-06",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "27/04/2026 21:44:59"
          },
          {
            "ticket_id": 16299,
            "ticket_number": "3516287",
            "title": "Pedido Autorização Compra Direta",
            "priority": "P2",
            "created_at": "27/04/2026 23:01:13",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/04/2026 23:01:14"
          },
          {
            "ticket_id": 16306,
            "ticket_number": "3516294",
            "title": "Fwd: Incidente de voo TTN-1252218555#100201764#T19",
            "priority": "P2",
            "created_at": "28/04/2026 09:16:18",
            "close_date": "2026-06-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/04/2026 19:02:13"
          },
          {
            "ticket_id": 16347,
            "ticket_number": "3516335",
            "title": "GBN-108595 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "28/04/2026 13:21:25",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 13:21:27"
          },
          {
            "ticket_id": 16349,
            "ticket_number": "3516337",
            "title": "GBN-108594 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/04/2026 13:21:28",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:08:00"
          },
          {
            "ticket_id": 16350,
            "ticket_number": "3516338",
            "title": "GBN-108595 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "28/04/2026 13:21:31",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:08:15"
          },
          {
            "ticket_id": 16354,
            "ticket_number": "3516342",
            "title": "Re: [Cockpit] Viagem TRP-2026-04860 - RIVIERA MAYA",
            "priority": "P2",
            "created_at": "28/04/2026 14:09:40",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 14:09:40"
          },
          {
            "ticket_id": 16360,
            "ticket_number": "3516348",
            "title": "Fwd: Incidente de voo TTN-1252218555#100201764#T19",
            "priority": "P2",
            "created_at": "28/04/2026 15:34:49",
            "close_date": "2026-04-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 15:34:50"
          },
          {
            "ticket_id": 16381,
            "ticket_number": "3516369",
            "title": "Re:[## 39673 ##] GBN-108595 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "28/04/2026 19:01:55",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 1.9,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 20:56:20"
          },
          {
            "ticket_id": 16406,
            "ticket_number": "3516394",
            "title": "Fwd: Incidente de voo TTN-1261990228#100310730#T19",
            "priority": "P2",
            "created_at": "29/04/2026 09:14:21",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 15:34:46"
          },
          {
            "ticket_id": 16425,
            "ticket_number": "3516413",
            "title": "Envio de Documentação * File 438792",
            "priority": "P2",
            "created_at": "29/04/2026 09:51:40",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 75.23,
            "sla_met": false,
            "sla_breach_hours": 71.23,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 13:06:37"
          },
          {
            "ticket_id": 16433,
            "ticket_number": "3516421",
            "title": "GBN-75942 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "29/04/2026 10:36:47",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 14:23:48"
          },
          {
            "ticket_id": 16434,
            "ticket_number": "3516422",
            "title": "GBN-75942 - Um cliente enviou uma nova solicitação",
            "priority": "P2",
            "created_at": "29/04/2026 10:36:50",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 14:23:48"
          },
          {
            "ticket_id": 16437,
            "ticket_number": "3516425",
            "title": "GBN-119715 - Reenviar informações sobre sua reserv",
            "priority": "P2",
            "created_at": "29/04/2026 11:03:11",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 17:31:00"
          },
          {
            "ticket_id": 16445,
            "ticket_number": "3516433",
            "title": "Fwd: Incidente de voo TTN-1227780270#99963237#T195",
            "priority": "P2",
            "created_at": "29/04/2026 12:09:58",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "24/04/2026 18:48:57"
          },
          {
            "ticket_id": 16456,
            "ticket_number": "3516444",
            "title": "Acessos Veturis",
            "priority": "P2",
            "created_at": "29/04/2026 13:03:40",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 13:03:40"
          },
          {
            "ticket_id": 16460,
            "ticket_number": "3516448",
            "title": "Acesso a veturis",
            "priority": "P2",
            "created_at": "29/04/2026 13:22:46",
            "close_date": "2026-04-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 13:22:47"
          },
          {
            "ticket_id": 16466,
            "ticket_number": "3516454",
            "title": "[Cancelamento Viagem] TRP-2026-04611 - RICARDO REI",
            "priority": "P2",
            "created_at": "29/04/2026 15:04:00",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:04:00"
          },
          {
            "ticket_id": 16494,
            "ticket_number": "3516482",
            "title": "[Suporte] TRP-2026-03082 - Cancelamento",
            "priority": "P2",
            "created_at": "29/04/2026 15:51:18",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 15:51:19"
          },
          {
            "ticket_id": 16510,
            "ticket_number": "3516498",
            "title": "Pedido de Informações URGENTE",
            "priority": "P2",
            "created_at": "29/04/2026 18:46:17",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 18:46:18"
          },
          {
            "ticket_id": 16518,
            "ticket_number": "3516506",
            "title": "Pedido orçamento",
            "priority": "P2",
            "created_at": "29/04/2026 19:49:51",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 19:49:51"
          },
          {
            "ticket_id": 16519,
            "ticket_number": "3516507",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "29/04/2026 21:23:58",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 21:23:58"
          },
          {
            "ticket_id": 16527,
            "ticket_number": "3516515",
            "title": "[Suporte] TRP-2026-03207 / TRL-2026-04944 - Docume",
            "priority": "P2",
            "created_at": "29/04/2026 22:29:39",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/04/2026 22:29:39"
          },
          {
            "ticket_id": 16546,
            "ticket_number": "3516534",
            "title": "Fwd: Dúvida sobre reserva Disney - le plan",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:26",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 10:00:26"
          },
          {
            "ticket_id": 16549,
            "ticket_number": "3516537",
            "title": "TRP-2026-04718 | Pagamento por validar",
            "priority": "P2",
            "created_at": "30/04/2026 10:00:34",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 10:00:34"
          },
          {
            "ticket_id": 16564,
            "ticket_number": "3516552",
            "title": "[Cancelamento Serviço] TRP-2026-04925 / TRL-2026-0",
            "priority": "P2",
            "created_at": "30/04/2026 12:20:19",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 12:20:19"
          },
          {
            "ticket_id": 16565,
            "ticket_number": "3516553",
            "title": "[Cancelamento Viagem] TRP-2026-03344 - Tiago Palma",
            "priority": "P2",
            "created_at": "30/04/2026 12:33:17",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 12:33:18"
          },
          {
            "ticket_id": 16597,
            "ticket_number": "3516585",
            "title": "[Cancelamento Viagem] TRP-2026-03082 - LUIS MIGUEL",
            "priority": "P2",
            "created_at": "30/04/2026 15:20:49",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 15:20:49"
          },
          {
            "ticket_id": 16619,
            "ticket_number": "3516607",
            "title": "Contacto - Perguntas frequentes da atividade (A376",
            "priority": "P2",
            "created_at": "30/04/2026 17:53:39",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:42:28"
          },
          {
            "ticket_id": 16620,
            "ticket_number": "3516608",
            "title": "Alteração de Horário - File 342637",
            "priority": "P2",
            "created_at": "30/04/2026 18:10:42",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.28,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 20:28:38"
          },
          {
            "ticket_id": 16632,
            "ticket_number": "3516620",
            "title": "GBN-114599 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "30/04/2026 18:56:56",
            "close_date": "2026-04-30",
            "sla_target_hours": 4,
            "actual_time_hours": 2.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:32:12"
          },
          {
            "ticket_id": 16663,
            "ticket_number": "3516651",
            "title": "RESERVA / FATURA PROFORMA LOCALIZADOR 604626563",
            "priority": "P2",
            "created_at": "30/04/2026 21:12:14",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 818.07,
            "sla_met": false,
            "sla_breach_hours": 814.07,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 23:16:36"
          },
          {
            "ticket_id": 16667,
            "ticket_number": "3516655",
            "title": "Documentação de viagem assinada",
            "priority": "P2",
            "created_at": "30/04/2026 21:12:27",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 43.87,
            "sla_met": false,
            "sla_breach_hours": 39.87,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 17:04:32"
          },
          {
            "ticket_id": 16670,
            "ticket_number": "3516658",
            "title": "Credenciais de acesso ao operador Royal Caribbean",
            "priority": "P2",
            "created_at": "30/04/2026 21:34:49",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 21:34:49"
          },
          {
            "ticket_id": 16675,
            "ticket_number": "3516663",
            "title": "[Suporte] TRP-2026-04949 / TRL-2026-07626 - Altera",
            "priority": "P1",
            "created_at": "01/05/2026 19:03:30",
            "close_date": "2026-05-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/05/2026 19:03:30"
          },
          {
            "ticket_id": 16683,
            "ticket_number": "3516671",
            "title": "GBN-118330 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/05/2026 09:55:41",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:55:47"
          },
          {
            "ticket_id": 16687,
            "ticket_number": "3516675",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "02/05/2026 09:56:35",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 11:26:05"
          },
          {
            "ticket_id": 16692,
            "ticket_number": "3516680",
            "title": "Informações",
            "priority": "P2",
            "created_at": "02/05/2026 09:56:47",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:56:47"
          },
          {
            "ticket_id": 16695,
            "ticket_number": "3516683",
            "title": "Alteração reserva newblue LOC 6146921",
            "priority": "P2",
            "created_at": "02/05/2026 09:58:35",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 09:58:35"
          },
          {
            "ticket_id": 16706,
            "ticket_number": "3516694",
            "title": "Informações sobre o seu voo 1267172189 TTN-1267172",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:14",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 49.55,
            "sla_met": false,
            "sla_breach_hours": 45.55,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 11:32:57"
          },
          {
            "ticket_id": 16707,
            "ticket_number": "3516695",
            "title": "MARQUES FARIA/LUIS MIGUEL MR 17MAY2026 OPO IBZ",
            "priority": "P2",
            "created_at": "02/05/2026 09:59:15",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 7.55,
            "sla_met": false,
            "sla_breach_hours": 3.55,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 17:32:55"
          },
          {
            "ticket_id": 16718,
            "ticket_number": "3516706",
            "title": "GBN-121772 - Um cliente enviou uma nova solicitaçã",
            "priority": "P2",
            "created_at": "02/05/2026 10:00:36",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 10:00:50"
          },
          {
            "ticket_id": 16720,
            "ticket_number": "3516708",
            "title": "Eticket - 66593177 - AM  23/05/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "02/05/2026 10:00:44",
            "close_date": "2026-05-02",
            "sla_target_hours": 4,
            "actual_time_hours": 5.35,
            "sla_met": false,
            "sla_breach_hours": 1.35,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 15:22:34"
          },
          {
            "ticket_id": 16744,
            "ticket_number": "3516732",
            "title": "[Cancelamento Serviço] TRP-2026-04627 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/05/2026 11:35:16",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 11:35:16"
          },
          {
            "ticket_id": 16765,
            "ticket_number": "3516753",
            "title": "Fwd: [Cockpit] A Tua Semana",
            "priority": "P2",
            "created_at": "02/05/2026 16:57:02",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 16:57:02"
          },
          {
            "ticket_id": 16769,
            "ticket_number": "3516757",
            "title": "[Cancelamento Serviço] TRP-2026-02858 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/05/2026 18:26:46",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:26:47"
          },
          {
            "ticket_id": 16770,
            "ticket_number": "3516758",
            "title": "[Cancelamento Serviço] TRP-2026-02865 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/05/2026 18:28:06",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 18:28:06"
          },
          {
            "ticket_id": 16771,
            "ticket_number": "3516759",
            "title": "[Cancelamento Serviço] TRP-2026-04839 / TRL-2026-0",
            "priority": "P2",
            "created_at": "02/05/2026 20:37:17",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/04/2026 16:08:18"
          },
          {
            "ticket_id": 16772,
            "ticket_number": "3516760",
            "title": "[Cancelamento Viagem] TRP-2026-03748 - Paulo Ricar",
            "priority": "P2",
            "created_at": "02/05/2026 22:02:06",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 22:02:06"
          },
          {
            "ticket_id": 16774,
            "ticket_number": "3516762",
            "title": "[Suporte] TRP-2026-04827 / TRL-2026-07419 - Pedido",
            "priority": "P1",
            "created_at": "03/05/2026 10:10:48",
            "close_date": "2026-05-19",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/05/2026 10:10:48"
          },
          {
            "ticket_id": 16776,
            "ticket_number": "3516764",
            "title": "[Suporte] TRP-2026-04827 / TRL-2026-07419 - Esclar",
            "priority": "P2",
            "created_at": "03/05/2026 10:18:09",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/05/2026 10:18:09"
          },
          {
            "ticket_id": 16779,
            "ticket_number": "3516767",
            "title": "[Cancelamento Viagem] TRP-2026-04179 - Abilio Paul",
            "priority": "P2",
            "created_at": "03/05/2026 17:56:15",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "03/05/2026 17:56:15"
          },
          {
            "ticket_id": 16836,
            "ticket_number": "3516824",
            "title": "Eticket - 70358738 - SX  05/05/2026  Pireu, Grécia",
            "priority": "P2",
            "created_at": "04/05/2026 09:20:20",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 09:24:19"
          },
          {
            "ticket_id": 16872,
            "ticket_number": "3516860",
            "title": "GBN-102255",
            "priority": "P1",
            "created_at": "04/05/2026 11:42:31",
            "close_date": "2026-05-05",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "23/03/2026 17:54:32"
          },
          {
            "ticket_id": 16879,
            "ticket_number": "3516867",
            "title": "Reembolso cliente",
            "priority": "P2",
            "created_at": "04/05/2026 12:21:34",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 12:21:35"
          },
          {
            "ticket_id": 16914,
            "ticket_number": "3516902",
            "title": "Re:[## 40136 ##] GBN-119557 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "04/05/2026 16:03:27",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "02/05/2026 12:41:34"
          },
          {
            "ticket_id": 16927,
            "ticket_number": "3516915",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "04/05/2026 18:16:59",
            "close_date": "2026-05-04",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 18:17:00"
          },
          {
            "ticket_id": 16934,
            "ticket_number": "3516922",
            "title": "urgente",
            "priority": "P2",
            "created_at": "04/05/2026 20:21:55",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 20:21:56"
          },
          {
            "ticket_id": 16936,
            "ticket_number": "3516924",
            "title": "GBN-101025 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 20:29:55",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 20:29:56"
          },
          {
            "ticket_id": 16941,
            "ticket_number": "3516929",
            "title": "GBN-121830 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "04/05/2026 20:49:28",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 13.9,
            "sla_met": false,
            "sla_breach_hours": 9.9,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 10:44:01"
          },
          {
            "ticket_id": 16953,
            "ticket_number": "3516941",
            "title": "[Cancelamento Viagem] TRP-2026-04749 - Maria da Co",
            "priority": "P2",
            "created_at": "04/05/2026 22:15:39",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:15:39"
          },
          {
            "ticket_id": 16954,
            "ticket_number": "3516942",
            "title": "[Suporte] TRP-2026-02470 / TRL-2026-03793 - Dados ",
            "priority": "P2",
            "created_at": "04/05/2026 22:16:30",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "04/05/2026 22:16:30"
          },
          {
            "ticket_id": 16988,
            "ticket_number": "3516976",
            "title": "[Suporte] TRP-2026-04910 / TRL-2026-07562 - Altera",
            "priority": "P2",
            "created_at": "05/05/2026 09:27:58",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 09:27:59"
          },
          {
            "ticket_id": 17009,
            "ticket_number": "3516997",
            "title": "Viagem a 10 de Maio ainda a aguardar autorização d",
            "priority": "P1",
            "created_at": "05/05/2026 12:53:02",
            "close_date": "2026-05-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "05/05/2026 12:53:02"
          },
          {
            "ticket_id": 17021,
            "ticket_number": "3517009",
            "title": "[Cancelamento Serviço] TRP-2026-02506 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/05/2026 13:58:50",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 13:58:50"
          },
          {
            "ticket_id": 17038,
            "ticket_number": "3517026",
            "title": "FATURAS DE RESERVAS",
            "priority": "P2",
            "created_at": "05/05/2026 15:58:09",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 15:58:09"
          },
          {
            "ticket_id": 17039,
            "ticket_number": "3517027",
            "title": "pedido de informações / orçamento - Andreia Rodrig",
            "priority": "P2",
            "created_at": "05/05/2026 15:58:10",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 41.87,
            "sla_met": false,
            "sla_breach_hours": 37.87,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 09:50:16"
          },
          {
            "ticket_id": 17040,
            "ticket_number": "3517028",
            "title": "Bilhete para a sua viagem",
            "priority": "P2",
            "created_at": "05/05/2026 16:38:47",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:43:51"
          },
          {
            "ticket_id": 17043,
            "ticket_number": "3517031",
            "title": "Pedido de correção de nome – Apólice nº VG64743395",
            "priority": "P2",
            "created_at": "05/05/2026 16:38:56",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:38:56"
          },
          {
            "ticket_id": 17048,
            "ticket_number": "3517036",
            "title": "Tickets abertos que não sei o que é necessário",
            "priority": "P2",
            "created_at": "05/05/2026 16:49:56",
            "close_date": "2026-05-05",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 16:49:57"
          },
          {
            "ticket_id": 17063,
            "ticket_number": "3517051",
            "title": "[Suporte] TRP-2026-04011 - faturação do 2º e ultim",
            "priority": "P2",
            "created_at": "05/05/2026 21:21:52",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 21:21:53"
          },
          {
            "ticket_id": 17065,
            "ticket_number": "3517053",
            "title": "[Cancelamento Serviço] TRP-2026-04701 / TRL-2026-0",
            "priority": "P2",
            "created_at": "05/05/2026 21:45:27",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 21:45:27"
          },
          {
            "ticket_id": 17069,
            "ticket_number": "3517057",
            "title": "loc340136 - soltropico",
            "priority": "P2",
            "created_at": "05/05/2026 22:01:45",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.48,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:31:17"
          },
          {
            "ticket_id": 17073,
            "ticket_number": "3517061",
            "title": "[Suporte] TRP-2026-03341 - Reembolso de pagamento",
            "priority": "P2",
            "created_at": "05/05/2026 22:09:02",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/05/2026 22:09:02"
          },
          {
            "ticket_id": 17101,
            "ticket_number": "3517089",
            "title": "Re:[## 40228 ##] GBN-106687 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "06/05/2026 10:50:20",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 1.42,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 12:15:51"
          },
          {
            "ticket_id": 17119,
            "ticket_number": "3517107",
            "title": "[Suporte] TRP-2026-04267 / TRL-2026-06461 - Código",
            "priority": "P2",
            "created_at": "06/05/2026 11:37:14",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 11:37:14"
          },
          {
            "ticket_id": 17131,
            "ticket_number": "3517119",
            "title": "Re:[## 36731 ##] GBN-115299 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "06/05/2026 13:44:20",
            "close_date": "2026-05-06",
            "sla_target_hours": 4,
            "actual_time_hours": 3.97,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 17:42:43"
          },
          {
            "ticket_id": 17182,
            "ticket_number": "3517170",
            "title": "[Suporte] TRP-2026-03793 / TRL-2026-05760 - Esclar",
            "priority": "P2",
            "created_at": "06/05/2026 20:39:08",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 20:39:08"
          },
          {
            "ticket_id": 17236,
            "ticket_number": "3517224",
            "title": "Mensagem sobre a reserva 2992970 - Civitatis",
            "priority": "P2",
            "created_at": "07/05/2026 09:09:14",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 3.92,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 13:04:46"
          },
          {
            "ticket_id": 17242,
            "ticket_number": "3517230",
            "title": "GBN-109961 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "07/05/2026 09:54:36",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 11:46:21"
          },
          {
            "ticket_id": 17313,
            "ticket_number": "3517301",
            "title": "Acessos Veturis",
            "priority": "P2",
            "created_at": "07/05/2026 19:18:32",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 19:18:33"
          },
          {
            "ticket_id": 17318,
            "ticket_number": "3517306",
            "title": "Re:[## 38038 ##] GBN-116409 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:14",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/04/2026 19:27:44"
          },
          {
            "ticket_id": 17320,
            "ticket_number": "3517308",
            "title": "Acessos Bedsonline",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:18",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 19:32:19"
          },
          {
            "ticket_id": 17328,
            "ticket_number": "3517316",
            "title": "Re:[## 35520 ##] GBN-104564 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:41",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/02/2026 21:28:56"
          },
          {
            "ticket_id": 17330,
            "ticket_number": "3517318",
            "title": "Re:[## 40490 ##] GBN-119781 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:46",
            "close_date": "2026-05-07",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 15:36:04"
          },
          {
            "ticket_id": 17331,
            "ticket_number": "3517319",
            "title": "Aumento Fuel LIS DJE - 01JUN26 * File 440322",
            "priority": "P2",
            "created_at": "07/05/2026 19:32:47",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 2.68,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 22:14:22"
          },
          {
            "ticket_id": 17332,
            "ticket_number": "3517320",
            "title": "[Suporte] TRP-2026-04042 / TRL-2026-06102 - Falta ",
            "priority": "P2",
            "created_at": "07/05/2026 20:10:12",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "07/05/2026 20:10:12"
          },
          {
            "ticket_id": 17336,
            "ticket_number": "3517324",
            "title": "Pedido de Contacto Movel - 338629 // Partida: 2026",
            "priority": "P2",
            "created_at": "07/05/2026 21:59:21",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 12.13,
            "sla_met": false,
            "sla_breach_hours": 8.13,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 10:07:40"
          },
          {
            "ticket_id": 17382,
            "ticket_number": "3517370",
            "title": "Aceso Iberostar",
            "priority": "P2",
            "created_at": "08/05/2026 11:24:25",
            "close_date": "2026-05-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/05/2026 11:24:25"
          },
          {
            "ticket_id": 17429,
            "ticket_number": "3517417",
            "title": "[Pedido de Grupo] B&b Hotel Lisboa Montijo - 2026-",
            "priority": "P3",
            "created_at": "08/05/2026 17:43:59",
            "close_date": "2026-05-13",
            "sla_target_hours": 24,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P3",
            "first_response_at": "08/05/2026 17:43:59"
          },
          {
            "ticket_id": 17506,
            "ticket_number": "3517494",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/05/2026 19:04:22",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 19:04:22"
          },
          {
            "ticket_id": 17507,
            "ticket_number": "3517495",
            "title": "[Cancelamento Serviço] TRP-2026-04957 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/05/2026 19:26:03",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 19:26:04"
          },
          {
            "ticket_id": 17508,
            "ticket_number": "3517496",
            "title": "[Cancelamento Serviço] TRP-2026-04886 / TRL-2026-0",
            "priority": "P2",
            "created_at": "09/05/2026 20:26:36",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "09/05/2026 20:26:36"
          },
          {
            "ticket_id": 17509,
            "ticket_number": "3517497",
            "title": "[Suporte] TRP-2026-02524 - Suporte — Viagem TRP-20",
            "priority": "P2",
            "created_at": "10/05/2026 14:29:26",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "10/05/2026 14:29:26"
          },
          {
            "ticket_id": 17553,
            "ticket_number": "3517541",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:04",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 23:00:31"
          },
          {
            "ticket_id": 17562,
            "ticket_number": "3517550",
            "title": "Confirmação reserva Bedsonline 54-3350092",
            "priority": "P2",
            "created_at": "11/05/2026 09:12:20",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 1.1,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 10:19:17"
          },
          {
            "ticket_id": 17573,
            "ticket_number": "3517561",
            "title": "[Cancelamento Serviço] TRP-2026-04671 / TRL-2026-0",
            "priority": "P1",
            "created_at": "11/05/2026 09:19:18",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "11/05/2026 09:19:18"
          },
          {
            "ticket_id": 17597,
            "ticket_number": "3517585",
            "title": "GBN-75942 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "11/05/2026 10:57:25",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.82,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 11:46:28"
          },
          {
            "ticket_id": 17612,
            "ticket_number": "3517600",
            "title": "[Suporte] TRP-2026-04232 - Alteração Valor venda",
            "priority": "P2",
            "created_at": "11/05/2026 13:58:38",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 13:58:38"
          },
          {
            "ticket_id": 17617,
            "ticket_number": "3517605",
            "title": "Re:[## 40634 ##] GBN-92436 - Um cliente enviou uma",
            "priority": "P2",
            "created_at": "11/05/2026 14:16:35",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 14:16:35"
          },
          {
            "ticket_id": 17634,
            "ticket_number": "3517622",
            "title": "[Suporte] TRP-2026-05079 / TRL-2026-07841 - Reserv",
            "priority": "P2",
            "created_at": "11/05/2026 16:28:53",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 16:28:53"
          },
          {
            "ticket_id": 17636,
            "ticket_number": "3517624",
            "title": "VJT: Documentação de Viagem Djerba 212274",
            "priority": "P2",
            "created_at": "11/05/2026 16:37:22",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.77,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 20:23:33"
          },
          {
            "ticket_id": 17648,
            "ticket_number": "3517636",
            "title": "[Cancelamento Viagem] TRP-2026-05077 - daniel  pim",
            "priority": "P2",
            "created_at": "11/05/2026 17:15:12",
            "close_date": "2026-05-11",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:03:38"
          },
          {
            "ticket_id": 17651,
            "ticket_number": "3517639",
            "title": "[Suporte] TRP-2026-04629 / TRL-2026-07848 - Pedido",
            "priority": "P2",
            "created_at": "11/05/2026 17:42:18",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 17:42:18"
          },
          {
            "ticket_id": 17686,
            "ticket_number": "3517674",
            "title": "Servantrip credenciais",
            "priority": "P2",
            "created_at": "11/05/2026 21:42:39",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 21:42:40"
          },
          {
            "ticket_id": 17694,
            "ticket_number": "3517682",
            "title": "[Suporte] TRP-2026-03330 - pedido de documentação",
            "priority": "P2",
            "created_at": "11/05/2026 22:43:12",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 22:43:12"
          },
          {
            "ticket_id": 17728,
            "ticket_number": "3517716",
            "title": "Confirmação de reserva 345457 ### TIME LIMIT PARA ",
            "priority": "P1",
            "created_at": "12/05/2026 12:22:47",
            "close_date": "2026-05-22",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.85,
            "sla_met": false,
            "sla_breach_hours": 1.6,
            "sla_name": "SLA P1",
            "first_response_at": "12/05/2026 14:14:39"
          },
          {
            "ticket_id": 17731,
            "ticket_number": "3517719",
            "title": "URGENTE URGENTE Confirmação de reserva 345456 ### ",
            "priority": "P1",
            "created_at": "12/05/2026 12:22:56",
            "close_date": "2026-05-12",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.3,
            "sla_met": false,
            "sla_breach_hours": 1.05,
            "sla_name": "SLA P1",
            "first_response_at": "12/05/2026 13:41:19"
          },
          {
            "ticket_id": 17734,
            "ticket_number": "3517722",
            "title": "Envio de Cert. Seguro * File 431638",
            "priority": "P2",
            "created_at": "12/05/2026 12:55:01",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 09:06:00"
          },
          {
            "ticket_id": 17759,
            "ticket_number": "3517747",
            "title": "GBN-89481 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "12/05/2026 14:58:51",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 4.45,
            "sla_met": false,
            "sla_breach_hours": 0.45,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 19:25:56"
          },
          {
            "ticket_id": 17773,
            "ticket_number": "3517761",
            "title": "XFWYRCK5  UFEV",
            "priority": "P2",
            "created_at": "12/05/2026 15:16:26",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 30.63,
            "sla_met": false,
            "sla_breach_hours": 26.63,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 21:54:36"
          },
          {
            "ticket_id": 17778,
            "ticket_number": "3517766",
            "title": "[Suporte] TRP-2026-05091 - Dados viagem",
            "priority": "P2",
            "created_at": "12/05/2026 15:48:49",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 15:48:50"
          },
          {
            "ticket_id": 17788,
            "ticket_number": "3517776",
            "title": "[Cancelamento Serviço] TRP-2026-04629 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/05/2026 16:19:46",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:19:46"
          },
          {
            "ticket_id": 17793,
            "ticket_number": "3517781",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/05/2026 16:35:03",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:35:03"
          },
          {
            "ticket_id": 17794,
            "ticket_number": "3517782",
            "title": "[Cancelamento Serviço] TRP-2026-04527 / TRL-2026-0",
            "priority": "P2",
            "created_at": "12/05/2026 16:35:53",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:35:54"
          },
          {
            "ticket_id": 17795,
            "ticket_number": "3517783",
            "title": "[Suporte] TRP-2026-03302 / TRL-2026-05086 - PNR",
            "priority": "P2",
            "created_at": "12/05/2026 16:43:12",
            "close_date": "2026-05-21",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 16:43:12"
          },
          {
            "ticket_id": 17821,
            "ticket_number": "3517809",
            "title": "[Suporte] TRP-2026-02744 - Lua de Mel",
            "priority": "P2",
            "created_at": "12/05/2026 18:55:53",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 18:55:53"
          },
          {
            "ticket_id": 17835,
            "ticket_number": "3517823",
            "title": "Cancelamento",
            "priority": "P2",
            "created_at": "12/05/2026 21:51:59",
            "close_date": "2026-05-12",
            "sla_target_hours": 4,
            "actual_time_hours": 0.98,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 22:51:46"
          },
          {
            "ticket_id": 17850,
            "ticket_number": "3517838",
            "title": "[Cancelamento Viagem] TRP-2026-03477 - Luciana Sil",
            "priority": "P2",
            "created_at": "12/05/2026 23:21:05",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "12/05/2026 23:21:05"
          },
          {
            "ticket_id": 17896,
            "ticket_number": "3517884",
            "title": "Re:[## 40840 ##] GBN-89481 - Um cliente enviou uma",
            "priority": "P2",
            "created_at": "13/05/2026 12:00:58",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "06/05/2026 17:39:15"
          },
          {
            "ticket_id": 17897,
            "ticket_number": "3517885",
            "title": "Documentação smy",
            "priority": "P2",
            "created_at": "13/05/2026 12:01:00",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 12:01:01"
          },
          {
            "ticket_id": 17915,
            "ticket_number": "3517903",
            "title": "[Cancelamento Serviço] TRP-2026-05093 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/05/2026 14:03:54",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 14:03:54"
          },
          {
            "ticket_id": 17916,
            "ticket_number": "3517904",
            "title": "[Cancelamento Serviço] TRP-2026-05093 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/05/2026 14:43:17",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 14:43:17"
          },
          {
            "ticket_id": 17941,
            "ticket_number": "3517929",
            "title": "Re:[## 40775 ##] GBN-101127 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "13/05/2026 16:36:01",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "11/05/2026 19:17:25"
          },
          {
            "ticket_id": 17950,
            "ticket_number": "3517938",
            "title": "Nortravel 604485940 + 604485939",
            "priority": "P2",
            "created_at": "13/05/2026 17:35:00",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 17:35:00"
          },
          {
            "ticket_id": 17956,
            "ticket_number": "3517944",
            "title": "Cancelamento de Reservas 54-3350092 Bedsonline",
            "priority": "P2",
            "created_at": "13/05/2026 17:43:32",
            "close_date": "2026-05-13",
            "sla_target_hours": 4,
            "actual_time_hours": 1.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 18:48:41"
          },
          {
            "ticket_id": 17971,
            "ticket_number": "3517959",
            "title": "Reserva ViajarTours 213950 _ Formentera _ Joana Gi",
            "priority": "P2",
            "created_at": "13/05/2026 20:10:55",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 20:10:55"
          },
          {
            "ticket_id": 17976,
            "ticket_number": "3517964",
            "title": "[Cancelamento Serviço] TRP-2026-02600 / TRL-2026-0",
            "priority": "P2",
            "created_at": "13/05/2026 21:22:19",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "13/05/2026 21:22:20"
          },
          {
            "ticket_id": 18008,
            "ticket_number": "3517996",
            "title": "Informação de reserva - SPT002601628868",
            "priority": "P2",
            "created_at": "14/05/2026 10:13:26",
            "close_date": "2026-05-14",
            "sla_target_hours": 4,
            "actual_time_hours": 3.83,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 14:04:10"
          },
          {
            "ticket_id": 18057,
            "ticket_number": "3518045",
            "title": "| Urgente: pedido de orçamento Barceló Punta Umbri",
            "priority": "P1",
            "created_at": "14/05/2026 14:08:14",
            "close_date": "2026-05-27",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "14/05/2026 14:08:14"
          },
          {
            "ticket_id": 18103,
            "ticket_number": "3518091",
            "title": "RE: [Cockpit] Viagem TRP-2026-04792 - Viagem a Sam",
            "priority": "P2",
            "created_at": "14/05/2026 21:36:57",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "14/05/2026 21:36:57"
          },
          {
            "ticket_id": 18124,
            "ticket_number": "3518112",
            "title": "Cancelamento GBN",
            "priority": "P2",
            "created_at": "15/05/2026 09:54:29",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 09:54:29"
          },
          {
            "ticket_id": 18186,
            "ticket_number": "3518174",
            "title": "pedido de cotação",
            "priority": "P2",
            "created_at": "15/05/2026 17:50:38",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 17:50:39"
          },
          {
            "ticket_id": 18201,
            "ticket_number": "3518189",
            "title": "Informações da reserva TTN-1280716384#101995634#T2",
            "priority": "P2",
            "created_at": "15/05/2026 19:44:44",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 64.07,
            "sla_met": false,
            "sla_breach_hours": 60.07,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 11:48:54"
          },
          {
            "ticket_id": 18206,
            "ticket_number": "3518194",
            "title": "NU5XWTCY",
            "priority": "P2",
            "created_at": "15/05/2026 21:55:05",
            "close_date": "2026-05-15",
            "sla_target_hours": 4,
            "actual_time_hours": 0.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "15/05/2026 22:31:30"
          },
          {
            "ticket_id": 18240,
            "ticket_number": "3518228",
            "title": "[Cancelamento Serviço] TRP-2026-03510 / TRL-2026-0",
            "priority": "P2",
            "created_at": "16/05/2026 17:57:48",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 17:57:48"
          },
          {
            "ticket_id": 18241,
            "ticket_number": "3518229",
            "title": "[Cancelamento Serviço] TRP-2026-03510 / TRL-2026-0",
            "priority": "P2",
            "created_at": "16/05/2026 17:58:25",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "16/05/2026 17:58:25"
          },
          {
            "ticket_id": 18314,
            "ticket_number": "3518302",
            "title": "Localizadores 6119682 + 6120803 + 6120795",
            "priority": "P2",
            "created_at": "18/05/2026 09:22:51",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 09:22:52"
          },
          {
            "ticket_id": 18338,
            "ticket_number": "3518326",
            "title": "Pedido de documentos Flexible auto",
            "priority": "P2",
            "created_at": "18/05/2026 10:42:59",
            "close_date": "2026-05-20",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 10:42:59"
          },
          {
            "ticket_id": 18373,
            "ticket_number": "3518361",
            "title": "Re:[## 40894 ##] GBN-123532 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "18/05/2026 15:58:35",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 4.77,
            "sla_met": false,
            "sla_breach_hours": 0.77,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 20:44:53"
          },
          {
            "ticket_id": 18392,
            "ticket_number": "3518380",
            "title": "Re:[## 41182 ##] GBN-123169 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "18/05/2026 17:18:14",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 0.2,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 17:30:55"
          },
          {
            "ticket_id": 18402,
            "ticket_number": "3518390",
            "title": "Envio de documentação - FILE 435113",
            "priority": "P2",
            "created_at": "18/05/2026 18:31:01",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 21:52:55"
          },
          {
            "ticket_id": 18403,
            "ticket_number": "3518391",
            "title": "Aumento Fuel OPO HRG OPO - 15JUN * File 432995",
            "priority": "P2",
            "created_at": "18/05/2026 18:31:03",
            "close_date": "2026-05-18",
            "sla_target_hours": 4,
            "actual_time_hours": 3.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 21:58:49"
          },
          {
            "ticket_id": 18505,
            "ticket_number": "3518493",
            "title": "Aumento Fuel OPO/DSS/OPO - 13JUN26 * File 431913",
            "priority": "P2",
            "created_at": "19/05/2026 17:46:37",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 2.35,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:08:05"
          },
          {
            "ticket_id": 18507,
            "ticket_number": "3518495",
            "title": "Fwd: Documentação da reserva TTN-1227780270#102308",
            "priority": "P2",
            "created_at": "19/05/2026 17:46:47",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 17:46:48"
          },
          {
            "ticket_id": 18521,
            "ticket_number": "3518509",
            "title": "Eticket - 67390950 - AX  31/05/2026  Veneza, Itáli",
            "priority": "P2",
            "created_at": "19/05/2026 18:44:40",
            "close_date": "2026-05-19",
            "sla_target_hours": 4,
            "actual_time_hours": 1.45,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "19/05/2026 20:12:09"
          },
          {
            "ticket_id": 18523,
            "ticket_number": "3518511",
            "title": "[Cancelamento Viagem] TRP-2026-05166 - Ana Santo -",
            "priority": "P1",
            "created_at": "19/05/2026 19:01:58",
            "close_date": "2026-05-20",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "19/05/2026 19:01:58"
          },
          {
            "ticket_id": 18645,
            "ticket_number": "3518633",
            "title": "Solicitud de cuna en la habitación - Reserva 61469",
            "priority": "P2",
            "created_at": "20/05/2026 17:26:51",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "18/05/2026 18:31:06"
          },
          {
            "ticket_id": 18679,
            "ticket_number": "3518667",
            "title": "[Suporte] TRP-2026-02663 / TRL-2026-04088 - Greve ",
            "priority": "P1",
            "created_at": "20/05/2026 21:47:21",
            "close_date": "2026-05-28",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "20/05/2026 21:47:21"
          },
          {
            "ticket_id": 18851,
            "ticket_number": "3518839",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/05/2026 09:55:48",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 09:56:54"
          },
          {
            "ticket_id": 18852,
            "ticket_number": "3518840",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/05/2026 09:55:50",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.02,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 09:57:15"
          },
          {
            "ticket_id": 18854,
            "ticket_number": "3518842",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "22/05/2026 09:55:53",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.22,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:08:57"
          },
          {
            "ticket_id": 18982,
            "ticket_number": "3518970",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604599575",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:06",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.23,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:17:46"
          },
          {
            "ticket_id": 18988,
            "ticket_number": "3518976",
            "title": "Eticket - 71972459 - AM  06/06/2026  Miami, Estado",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:24",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:19:16"
          },
          {
            "ticket_id": 18995,
            "ticket_number": "3518983",
            "title": "Dados passageiro incorretos - 604532653 Travelplan",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:41",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:03:41"
          },
          {
            "ticket_id": 18996,
            "ticket_number": "3518984",
            "title": "Pedido de informação sobre documentação do seguro ",
            "priority": "P2",
            "created_at": "25/05/2026 09:03:43",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:03:44"
          },
          {
            "ticket_id": 19026,
            "ticket_number": "3519014",
            "title": "Dúvida cliente urgente",
            "priority": "P2",
            "created_at": "25/05/2026 09:05:37",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 09:05:38"
          },
          {
            "ticket_id": 19034,
            "ticket_number": "3519022",
            "title": "Re: Email Cliente - SPT002601634591",
            "priority": "P2",
            "created_at": "25/05/2026 09:51:16",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "22/05/2026 10:11:19"
          },
          {
            "ticket_id": 19040,
            "ticket_number": "3519028",
            "title": "[Cancelamento Serviço] TRP-2026-05088 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/05/2026 10:43:01",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:43:01"
          },
          {
            "ticket_id": 19041,
            "ticket_number": "3519029",
            "title": "[Cancelamento Serviço] TRP-2026-05088 / TRL-2026-0",
            "priority": "P2",
            "created_at": "25/05/2026 10:43:11",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:43:12"
          },
          {
            "ticket_id": 19065,
            "ticket_number": "3519053",
            "title": "[Suporte] TRP-2026-02804 - Pedido operador",
            "priority": "P2",
            "created_at": "25/05/2026 14:36:53",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 14:36:54"
          },
          {
            "ticket_id": 19100,
            "ticket_number": "3519088",
            "title": "NOVA Confirmação de reserva 342804",
            "priority": "P2",
            "created_at": "25/05/2026 15:38:56",
            "close_date": "2026-05-25",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 10:57:33"
          },
          {
            "ticket_id": 19130,
            "ticket_number": "3519118",
            "title": "SMY 1225273071 - pedido de esclarecimento (reserva",
            "priority": "P2",
            "created_at": "25/05/2026 18:09:46",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "25/05/2026 18:09:46"
          },
          {
            "ticket_id": 19141,
            "ticket_number": "3519129",
            "title": "[Cancelamento Serviço] TRP-2026-04629 / TRL-2026-0",
            "priority": "P1",
            "created_at": "25/05/2026 19:46:44",
            "close_date": "2026-05-26",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "25/05/2026 19:46:44"
          },
          {
            "ticket_id": 19160,
            "ticket_number": "3519148",
            "title": "Pedido de Dados de Passageiros - TSA Taxa Seguranç",
            "priority": "P2",
            "created_at": "26/05/2026 08:59:58",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.58,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:35:28"
          },
          {
            "ticket_id": 19180,
            "ticket_number": "3519168",
            "title": "Lua de Mel - reserva NB 6139532",
            "priority": "P2",
            "created_at": "26/05/2026 09:00:53",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 09:00:53"
          },
          {
            "ticket_id": 19188,
            "ticket_number": "3519176",
            "title": "Re:[## 41710 ##] GBN-109055 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "26/05/2026 10:22:49",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "23/05/2026 13:31:02"
          },
          {
            "ticket_id": 19192,
            "ticket_number": "3519180",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "26/05/2026 10:23:22",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.08,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 10:28:42"
          },
          {
            "ticket_id": 19235,
            "ticket_number": "3519223",
            "title": "LOCALIZADOR 1267609701 SMYTRAVEL",
            "priority": "P2",
            "created_at": "26/05/2026 14:29:49",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 14:29:50"
          },
          {
            "ticket_id": 19292,
            "ticket_number": "3519280",
            "title": "[Cancelamento Viagem] TRP-2026-03448 - Catarina Co",
            "priority": "P2",
            "created_at": "26/05/2026 17:34:08",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 17:34:08"
          },
          {
            "ticket_id": 19296,
            "ticket_number": "3519284",
            "title": "Documentação Viagem Nortravel loc 604546339",
            "priority": "P2",
            "created_at": "26/05/2026 18:19:42",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 18:19:42"
          },
          {
            "ticket_id": 19324,
            "ticket_number": "3519312",
            "title": "w2m.travel: Confirmação da Reserva com Ref. Nr.: '",
            "priority": "P2",
            "created_at": "26/05/2026 20:38:00",
            "close_date": "2026-05-26",
            "sla_target_hours": 4,
            "actual_time_hours": 0.03,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:40:01"
          },
          {
            "ticket_id": 19328,
            "ticket_number": "3519316",
            "title": "[Suporte] TRP-2026-04466 - PASSAPORTE",
            "priority": "P2",
            "created_at": "26/05/2026 20:40:46",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "26/05/2026 20:40:46"
          },
          {
            "ticket_id": 19342,
            "ticket_number": "3519330",
            "title": "Last reminder! Missing data for issuing voucher",
            "priority": "P2",
            "created_at": "27/05/2026 09:11:50",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 1.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 11:03:39"
          },
          {
            "ticket_id": 19346,
            "ticket_number": "3519334",
            "title": "Uma Familia em Viagem informa sobre a sua reserva ",
            "priority": "P2",
            "created_at": "27/05/2026 09:12:02",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 152.58,
            "sla_met": false,
            "sla_breach_hours": 148.58,
            "sla_name": "SLA P2",
            "first_response_at": "02/06/2026 17:47:28"
          },
          {
            "ticket_id": 19381,
            "ticket_number": "3519369",
            "title": "Re: [Cockpit] Viagem TRP-2026-05254 - Londres Fami",
            "priority": "P2",
            "created_at": "27/05/2026 12:13:39",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 12:13:39"
          },
          {
            "ticket_id": 19431,
            "ticket_number": "3519419",
            "title": "Mensagem sobre a reserva 37339057 - Civitatis",
            "priority": "P2",
            "created_at": "27/05/2026 16:48:52",
            "close_date": "2026-05-27",
            "sla_target_hours": 4,
            "actual_time_hours": 2.72,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "27/05/2026 19:32:44"
          },
          {
            "ticket_id": 19461,
            "ticket_number": "3519449",
            "title": "Informação de reserva",
            "priority": "P1",
            "created_at": "27/05/2026 19:45:02",
            "close_date": "2026-05-29",
            "sla_target_hours": 0.25,
            "actual_time_hours": 50.15,
            "sla_met": false,
            "sla_breach_hours": 49.9,
            "sla_name": "SLA P1",
            "first_response_at": "29/05/2026 21:54:38"
          },
          {
            "ticket_id": 19467,
            "ticket_number": "3519455",
            "title": "Documentação de reserva 345820",
            "priority": "P2",
            "created_at": "27/05/2026 21:42:46",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 42.02,
            "sla_met": false,
            "sla_breach_hours": 38.02,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:44:05"
          },
          {
            "ticket_id": 19495,
            "ticket_number": "3519483",
            "title": "Pedido de Contacto Movel - 339139 // Partida: 2026",
            "priority": "P2",
            "created_at": "28/05/2026 09:46:29",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 09:49:35"
          },
          {
            "ticket_id": 19582,
            "ticket_number": "3519570",
            "title": "Pedido de Email do Cliente p/ Confirmação - Fil 42",
            "priority": "P2",
            "created_at": "28/05/2026 16:16:02",
            "close_date": "2026-05-28",
            "sla_target_hours": 4,
            "actual_time_hours": 3.8,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:12"
          },
          {
            "ticket_id": 19586,
            "ticket_number": "3519574",
            "title": "Alteração de horário LIS/HRG 24/06 * File 440943",
            "priority": "P2",
            "created_at": "28/05/2026 16:16:55",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 3.78,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 20:04:13"
          },
          {
            "ticket_id": 19614,
            "ticket_number": "3519602",
            "title": "TRP-2026-05296",
            "priority": "P2",
            "created_at": "28/05/2026 21:40:36",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "28/05/2026 21:40:36"
          },
          {
            "ticket_id": 19706,
            "ticket_number": "3519694",
            "title": "Re: [Cockpit] Pagamento Pendente - Viagem TRP-2026",
            "priority": "P2",
            "created_at": "29/05/2026 15:44:21",
            "close_date": "2026-05-30",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 15:44:21"
          },
          {
            "ticket_id": 19718,
            "ticket_number": "3519706",
            "title": "[Cancelamento Serviço] TRP-2026-05193 / TRL-2026-0",
            "priority": "P2",
            "created_at": "29/05/2026 16:20:54",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 16:20:54"
          },
          {
            "ticket_id": 19733,
            "ticket_number": "3519721",
            "title": "Fwd: Itinerário de Viagem Ryanair",
            "priority": "P2",
            "created_at": "29/05/2026 17:45:57",
            "close_date": "2026-05-29",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 17:45:57"
          },
          {
            "ticket_id": 19735,
            "ticket_number": "3519723",
            "title": "Re:[## 42029 ##] GBN-121787 - Um cliente enviou um",
            "priority": "P1",
            "created_at": "29/05/2026 17:46:01",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 2.97,
            "sla_met": false,
            "sla_breach_hours": 2.72,
            "sla_name": "SLA P1",
            "first_response_at": "29/05/2026 20:44:18"
          },
          {
            "ticket_id": 19751,
            "ticket_number": "3519739",
            "title": "Reserva Aérea YXQ85H",
            "priority": "P1",
            "created_at": "29/05/2026 20:46:22",
            "close_date": "2026-05-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 16.27,
            "sla_met": false,
            "sla_breach_hours": 16.02,
            "sla_name": "SLA P1",
            "first_response_at": "30/05/2026 13:03:15"
          },
          {
            "ticket_id": 19752,
            "ticket_number": "3519740",
            "title": "YXQ85H – Novo prazo de emissão",
            "priority": "P1",
            "created_at": "29/05/2026 20:46:24",
            "close_date": "2026-05-30",
            "sla_target_hours": 0.25,
            "actual_time_hours": 13.97,
            "sla_met": false,
            "sla_breach_hours": 13.72,
            "sla_name": "SLA P1",
            "first_response_at": "30/05/2026 10:44:36"
          },
          {
            "ticket_id": 19808,
            "ticket_number": "3519796",
            "title": "Viagem Djerba 604638533",
            "priority": "P2",
            "created_at": "30/05/2026 11:32:43",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 11:32:43"
          },
          {
            "ticket_id": 19819,
            "ticket_number": "3519807",
            "title": "[Suporte] TRP-2026-04042 / TRL-2026-06102 - ATUALI",
            "priority": "P2",
            "created_at": "30/05/2026 16:01:55",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/05/2026 16:01:55"
          },
          {
            "ticket_id": 19829,
            "ticket_number": "3519817",
            "title": "GBN-120715 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "30/05/2026 16:44:37",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 42.85,
            "sla_met": false,
            "sla_breach_hours": 38.85,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:36:16"
          },
          {
            "ticket_id": 19891,
            "ticket_number": "3519879",
            "title": "Alteração de email de cliente",
            "priority": "P2",
            "created_at": "01/06/2026 09:07:24",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 09:07:25"
          },
          {
            "ticket_id": 19903,
            "ticket_number": "3519891",
            "title": "Madeira - taxa turística a partir de 01/06/2026",
            "priority": "P2",
            "created_at": "01/06/2026 10:08:53",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.87,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 14:01:23"
          },
          {
            "ticket_id": 19910,
            "ticket_number": "3519898",
            "title": "Re:[## 42296 ##] GBN-120715 - Um cliente enviou um",
            "priority": "P2",
            "created_at": "01/06/2026 11:35:26",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.05,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:38:43"
          },
          {
            "ticket_id": 19912,
            "ticket_number": "3519900",
            "title": "[Tour10] Asunto: 4195466 - No Show | a/c Sara",
            "priority": "P1",
            "created_at": "01/06/2026 11:45:00",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.93,
            "sla_met": false,
            "sla_breach_hours": 3.68,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 15:41:48"
          },
          {
            "ticket_id": 19916,
            "ticket_number": "3519904",
            "title": "TRP-2026-03201_Duvida Visto | 08/06/2026",
            "priority": "P2",
            "created_at": "01/06/2026 11:45:09",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:45:09"
          },
          {
            "ticket_id": 19928,
            "ticket_number": "3519916",
            "title": "Incidente de voo TTN-1223362854#102788199#T2025707",
            "priority": "P1",
            "created_at": "01/06/2026 11:46:19",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 3.92,
            "sla_met": false,
            "sla_breach_hours": 3.67,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 15:41:49"
          },
          {
            "ticket_id": 19929,
            "ticket_number": "3519917",
            "title": "Viagem Djerba 604638533",
            "priority": "P2",
            "created_at": "01/06/2026 11:46:21",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 11:46:22"
          },
          {
            "ticket_id": 19937,
            "ticket_number": "3519925",
            "title": "4195466 - No Show | a/c Sara",
            "priority": "P1",
            "created_at": "01/06/2026 15:28:48",
            "close_date": "2026-06-01",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 09:27:06"
          },
          {
            "ticket_id": 19956,
            "ticket_number": "3519944",
            "title": "XSJ545 + 658NQJ: Alterações de reserva W2MCS:01612",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:24",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 3.85,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 19:22:36"
          },
          {
            "ticket_id": 19961,
            "ticket_number": "3519949",
            "title": "INFORMAÇÃO IMPORTANTE NO LOCALIZADOR 604624205",
            "priority": "P2",
            "created_at": "01/06/2026 15:31:55",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 1.6,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 17:08:44"
          },
          {
            "ticket_id": 19976,
            "ticket_number": "3519964",
            "title": "[Cancelamento Serviço] TRP-2026-03102 / TRL-2026-0",
            "priority": "P2",
            "created_at": "01/06/2026 15:52:55",
            "close_date": "2026-06-01",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 15:52:55"
          },
          {
            "ticket_id": 19982,
            "ticket_number": "3519970",
            "title": "Documentação reservas Soltour",
            "priority": "P2",
            "created_at": "01/06/2026 16:05:11",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 16:05:12"
          },
          {
            "ticket_id": 19984,
            "ticket_number": "3519972",
            "title": "NewBlue - 6119682",
            "priority": "P2",
            "created_at": "01/06/2026 16:10:03",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 16:10:03"
          },
          {
            "ticket_id": 19996,
            "ticket_number": "3519984",
            "title": "Alteração de reserva",
            "priority": "P2",
            "created_at": "01/06/2026 17:43:05",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.75,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 18:28:20"
          },
          {
            "ticket_id": 19997,
            "ticket_number": "3519985",
            "title": "[Suporte] TRP-2026-04907 - pedido de documentação",
            "priority": "P2",
            "created_at": "01/06/2026 18:11:47",
            "close_date": "2026-06-02",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "01/06/2026 18:11:48"
          },
          {
            "ticket_id": 20027,
            "ticket_number": "3520015",
            "title": "URGENTE - X9R7Y7S9",
            "priority": "P1",
            "created_at": "01/06/2026 19:54:25",
            "close_date": "2026-06-02",
            "sla_target_hours": 0.25,
            "actual_time_hours": 1.63,
            "sla_met": false,
            "sla_breach_hours": 1.38,
            "sla_name": "SLA P1",
            "first_response_at": "01/06/2026 21:33:07"
          },
          {
            "ticket_id": 20176,
            "ticket_number": "3520164",
            "title": "Copia de documento firmado conteniendo - 2026-06-0",
            "priority": "P2",
            "created_at": "02/06/2026 21:53:00",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 11.3,
            "sla_met": false,
            "sla_breach_hours": 7.3,
            "sla_name": "SLA P2",
            "first_response_at": "03/06/2026 09:11:40"
          },
          {
            "ticket_id": 20233,
            "ticket_number": "3520221",
            "title": "DGI GBN-119767",
            "priority": "P2",
            "created_at": "03/06/2026 11:06:16",
            "close_date": "2026-06-03",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "30/04/2026 14:44:12"
          },
          {
            "ticket_id": 20316,
            "ticket_number": "3520304",
            "title": "[Cancelamento Serviço] TRP-2026-05031 / TRL-2026-0",
            "priority": "P1",
            "created_at": "03/06/2026 19:58:59",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/06/2026 19:58:59"
          },
          {
            "ticket_id": 20317,
            "ticket_number": "3520305",
            "title": "[Cancelamento Serviço] TRP-2026-05033 / TRL-2026-0",
            "priority": "P1",
            "created_at": "03/06/2026 20:10:15",
            "close_date": "2026-06-03",
            "sla_target_hours": 0.25,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P1",
            "first_response_at": "03/06/2026 20:10:15"
          },
          {
            "ticket_id": 20331,
            "ticket_number": "3520319",
            "title": "CTM-12728 - Seu pedido foi recebido",
            "priority": "P2",
            "created_at": "03/06/2026 23:00:48",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 45.17,
            "sla_met": false,
            "sla_breach_hours": 41.17,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 20:10:53"
          },
          {
            "ticket_id": 20362,
            "ticket_number": "3520350",
            "title": "Support case for Uma Familia em Viagem, Lda",
            "priority": "P2",
            "created_at": "05/06/2026 09:04:32",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 3.93,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 13:00:34"
          },
          {
            "ticket_id": 20469,
            "ticket_number": "3520457",
            "title": "LUXURY COLLECTION: A sua reserva de luxo com a Bed",
            "priority": "P2",
            "created_at": "05/06/2026 16:18:29",
            "close_date": "2026-06-05",
            "sla_target_hours": 4,
            "actual_time_hours": 5.58,
            "sla_met": false,
            "sla_breach_hours": 1.58,
            "sla_name": "SLA P2",
            "first_response_at": "05/06/2026 21:53:54"
          },
          {
            "ticket_id": 20476,
            "ticket_number": "3520464",
            "title": "Cancelamento de reserva 345991",
            "priority": "P2",
            "created_at": "05/06/2026 16:45:57",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "29/05/2026 22:00:19"
          },
          {
            "ticket_id": 20662,
            "ticket_number": "3520650",
            "title": "[Suporte] TRP-2026-02675 / TRL-2026-04116 - Docume",
            "priority": "P2",
            "created_at": "08/06/2026 11:07:47",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.0,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:07:47"
          },
          {
            "ticket_id": 20667,
            "ticket_number": "3520655",
            "title": "**** URGENTE *** RE: *** EMISSÃO VOO HOJE ***  FIL",
            "priority": "P2",
            "created_at": "08/06/2026 11:30:55",
            "close_date": "2026-06-08",
            "sla_target_hours": 4,
            "actual_time_hours": 0.25,
            "sla_met": true,
            "sla_breach_hours": 0,
            "sla_name": "SLA P2",
            "first_response_at": "08/06/2026 11:46:39"
          }
        ]
      }
    },
    "summary": {
      "total_tickets_analyzed": 17013,
      "total_sla_met": 13598,
      "total_sla_missed": 3415,
      "overall_compliance_rate": 79.93
    }
  },
  "_meta": {
    "generated_at": "2026-06-08T13:20:17.648731+00:00",
    "cached_closed_tickets": 3158,
    "new_closed_tickets": 13855,
    "open_tickets": 1361,
    "incremental": true
  }
};
